(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6HTJH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $4e21fe3f44f10ac2$export$6503ec6e8aabbaf; }, function (v) { return $4e21fe3f44f10ac2$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $4e21fe3f44f10ac2$export$f7ad0328861e2f03; }, function (v) { return $4e21fe3f44f10ac2$export$f7ad0328861e2f03 = v; });
var $4e21fe3f44f10ac2$export$6503ec6e8aabbaf;
var $4e21fe3f44f10ac2$export$f7ad0328861e2f03;
"use strict";
var $4e21fe3f44f10ac2$var$mapping = new Map();
function $4e21fe3f44f10ac2$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$4e21fe3f44f10ac2$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $4e21fe3f44f10ac2$var$resolve(id) {
    var resolved = $4e21fe3f44f10ac2$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$4e21fe3f44f10ac2$export$6503ec6e8aabbaf = $4e21fe3f44f10ac2$var$register;
$4e21fe3f44f10ac2$export$f7ad0328861e2f03 = $4e21fe3f44f10ac2$var$resolve;

});

parcelRegister("jN93C", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $e6899e88d213bbbc$export$bdfd709ae4826697; }, function (v) { return $e6899e88d213bbbc$export$bdfd709ae4826697 = v; });
var $e6899e88d213bbbc$export$bdfd709ae4826697;
var $e6899e88d213bbbc$export$c9e73fbda7da57b6;
var $e6899e88d213bbbc$export$5a759dc7a1cfb72a;
"use strict";
var $e6899e88d213bbbc$var$bundleURL = {};
function $e6899e88d213bbbc$var$getBundleURLCached(id) {
    var value = $e6899e88d213bbbc$var$bundleURL[id];
    if (!value) {
        value = $e6899e88d213bbbc$var$getBundleURL();
        $e6899e88d213bbbc$var$bundleURL[id] = value;
    }
    return value;
}
function $e6899e88d213bbbc$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $e6899e88d213bbbc$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $e6899e88d213bbbc$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $e6899e88d213bbbc$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$e6899e88d213bbbc$export$bdfd709ae4826697 = $e6899e88d213bbbc$var$getBundleURLCached;
$e6899e88d213bbbc$export$c9e73fbda7da57b6 = $e6899e88d213bbbc$var$getBaseURL;
$e6899e88d213bbbc$export$5a759dc7a1cfb72a = $e6899e88d213bbbc$var$getOrigin;

});

parcelRegister("bb3TF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cL59g"));

});
parcelRegister("cL59g", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $949dde2c22391d9a$export$ffb0004e005737fa; }, function (v) { return $949dde2c22391d9a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $949dde2c22391d9a$export$34b9dba7ce09269b; }, function (v) { return $949dde2c22391d9a$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $949dde2c22391d9a$export$25062201e9e25d76; }, function (v) { return $949dde2c22391d9a$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $949dde2c22391d9a$export$ffb0004e005737fa;
var $949dde2c22391d9a$export$34b9dba7ce09269b;
var $949dde2c22391d9a$export$25062201e9e25d76;
'use strict';
parcelRequire("kw0QJ");

var $6fFrj = parcelRequire("6fFrj");
var $949dde2c22391d9a$var$g = 60103;
$949dde2c22391d9a$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $949dde2c22391d9a$var$h = Symbol.for;
    $949dde2c22391d9a$var$g = $949dde2c22391d9a$var$h("react.element");
    $949dde2c22391d9a$export$ffb0004e005737fa = $949dde2c22391d9a$var$h("react.fragment");
}
var $949dde2c22391d9a$var$m = $6fFrj.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $949dde2c22391d9a$var$n = Object.prototype.hasOwnProperty, $949dde2c22391d9a$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $949dde2c22391d9a$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$949dde2c22391d9a$var$n.call(a, b) && !$949dde2c22391d9a$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $949dde2c22391d9a$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $949dde2c22391d9a$var$m.current
    };
}
$949dde2c22391d9a$export$34b9dba7ce09269b = $949dde2c22391d9a$var$q;
$949dde2c22391d9a$export$25062201e9e25d76 = $949dde2c22391d9a$var$q;

});
parcelRegister("kw0QJ", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $eef774823f176417$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $eef774823f176417$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $eef774823f176417$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $eef774823f176417$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $eef774823f176417$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $eef774823f176417$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $eef774823f176417$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($eef774823f176417$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($eef774823f176417$var$getOwnPropertySymbols) {
            symbols = $eef774823f176417$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($eef774823f176417$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("6fFrj", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gbr4O"));

});
parcelRegister("gbr4O", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $bc82ad483894b8e4$export$ffb0004e005737fa; }, function (v) { return $bc82ad483894b8e4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bc82ad483894b8e4$export$5f8d39834fd61797; }, function (v) { return $bc82ad483894b8e4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $bc82ad483894b8e4$export$e2c29f18771995cb; }, function (v) { return $bc82ad483894b8e4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $bc82ad483894b8e4$export$74bf444e3cd11ea5; }, function (v) { return $bc82ad483894b8e4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $bc82ad483894b8e4$export$dca3b0875bd9a954; }, function (v) { return $bc82ad483894b8e4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $bc82ad483894b8e4$export$16fa2f45be04daa8; }, function (v) { return $bc82ad483894b8e4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $bc82ad483894b8e4$export$221d75b3f55bb0bd; }, function (v) { return $bc82ad483894b8e4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bc82ad483894b8e4$export$ae55be85d98224ed; }, function (v) { return $bc82ad483894b8e4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $bc82ad483894b8e4$export$e530037191fcd5d7; }, function (v) { return $bc82ad483894b8e4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $bc82ad483894b8e4$export$fd42f52fd3ae1109; }, function (v) { return $bc82ad483894b8e4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $bc82ad483894b8e4$export$c8a8987d4410bf2d; }, function (v) { return $bc82ad483894b8e4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $bc82ad483894b8e4$export$d38cd72104c1f0e9; }, function (v) { return $bc82ad483894b8e4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $bc82ad483894b8e4$export$7d1e3a5e95ceca43; }, function (v) { return $bc82ad483894b8e4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $bc82ad483894b8e4$export$257a8862b851cb5b; }, function (v) { return $bc82ad483894b8e4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $bc82ad483894b8e4$export$a8257692ac88316c; }, function (v) { return $bc82ad483894b8e4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $bc82ad483894b8e4$export$488013bae63b21da; }, function (v) { return $bc82ad483894b8e4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $bc82ad483894b8e4$export$7c73462e0d25e514; }, function (v) { return $bc82ad483894b8e4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $bc82ad483894b8e4$export$35808ee640e87ca7; }, function (v) { return $bc82ad483894b8e4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $bc82ad483894b8e4$export$fae74005e78b1a27; }, function (v) { return $bc82ad483894b8e4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $bc82ad483894b8e4$export$dc8fbce3eb94dc1e; }, function (v) { return $bc82ad483894b8e4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $bc82ad483894b8e4$export$6d9c69b0de29b591; }, function (v) { return $bc82ad483894b8e4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $bc82ad483894b8e4$export$d5a552a76deda3c2; }, function (v) { return $bc82ad483894b8e4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $bc82ad483894b8e4$export$e5c5a5f917a5871c; }, function (v) { return $bc82ad483894b8e4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $bc82ad483894b8e4$export$1538c33de8887b59; }, function (v) { return $bc82ad483894b8e4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $bc82ad483894b8e4$export$13e3392192263954; }, function (v) { return $bc82ad483894b8e4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $bc82ad483894b8e4$export$b8f5890fc79d6aca; }, function (v) { return $bc82ad483894b8e4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $bc82ad483894b8e4$export$60241385465d0a34; }, function (v) { return $bc82ad483894b8e4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $bc82ad483894b8e4$export$83d89fbfd8236492; }, function (v) { return $bc82ad483894b8e4$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bc82ad483894b8e4$export$ffb0004e005737fa;
var $bc82ad483894b8e4$export$5f8d39834fd61797;
var $bc82ad483894b8e4$export$e2c29f18771995cb;
var $bc82ad483894b8e4$export$74bf444e3cd11ea5;
var $bc82ad483894b8e4$export$dca3b0875bd9a954;
var $bc82ad483894b8e4$export$16fa2f45be04daa8;
var $bc82ad483894b8e4$export$221d75b3f55bb0bd;
var $bc82ad483894b8e4$export$ae55be85d98224ed;
var $bc82ad483894b8e4$export$e530037191fcd5d7;
var $bc82ad483894b8e4$export$fd42f52fd3ae1109;
var $bc82ad483894b8e4$export$c8a8987d4410bf2d;
var $bc82ad483894b8e4$export$d38cd72104c1f0e9;
var $bc82ad483894b8e4$export$7d1e3a5e95ceca43;
var $bc82ad483894b8e4$export$257a8862b851cb5b;
var $bc82ad483894b8e4$export$a8257692ac88316c;
var $bc82ad483894b8e4$export$488013bae63b21da;
var $bc82ad483894b8e4$export$7c73462e0d25e514;
var $bc82ad483894b8e4$export$35808ee640e87ca7;
var $bc82ad483894b8e4$export$fae74005e78b1a27;
var $bc82ad483894b8e4$export$dc8fbce3eb94dc1e;
var $bc82ad483894b8e4$export$6d9c69b0de29b591;
var $bc82ad483894b8e4$export$d5a552a76deda3c2;
var $bc82ad483894b8e4$export$e5c5a5f917a5871c;
var $bc82ad483894b8e4$export$1538c33de8887b59;
var $bc82ad483894b8e4$export$13e3392192263954;
var $bc82ad483894b8e4$export$b8f5890fc79d6aca;
var $bc82ad483894b8e4$export$60241385465d0a34;
var $bc82ad483894b8e4$export$83d89fbfd8236492;
'use strict';

var $kw0QJ = parcelRequire("kw0QJ");
var $bc82ad483894b8e4$var$n = 60103, $bc82ad483894b8e4$var$p = 60106;
$bc82ad483894b8e4$export$ffb0004e005737fa = 60107;
$bc82ad483894b8e4$export$5f8d39834fd61797 = 60108;
$bc82ad483894b8e4$export$e2c29f18771995cb = 60114;
var $bc82ad483894b8e4$var$q = 60109, $bc82ad483894b8e4$var$r = 60110, $bc82ad483894b8e4$var$t = 60112;
$bc82ad483894b8e4$export$74bf444e3cd11ea5 = 60113;
var $bc82ad483894b8e4$var$u = 60115, $bc82ad483894b8e4$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $bc82ad483894b8e4$var$w = Symbol.for;
    $bc82ad483894b8e4$var$n = $bc82ad483894b8e4$var$w("react.element");
    $bc82ad483894b8e4$var$p = $bc82ad483894b8e4$var$w("react.portal");
    $bc82ad483894b8e4$export$ffb0004e005737fa = $bc82ad483894b8e4$var$w("react.fragment");
    $bc82ad483894b8e4$export$5f8d39834fd61797 = $bc82ad483894b8e4$var$w("react.strict_mode");
    $bc82ad483894b8e4$export$e2c29f18771995cb = $bc82ad483894b8e4$var$w("react.profiler");
    $bc82ad483894b8e4$var$q = $bc82ad483894b8e4$var$w("react.provider");
    $bc82ad483894b8e4$var$r = $bc82ad483894b8e4$var$w("react.context");
    $bc82ad483894b8e4$var$t = $bc82ad483894b8e4$var$w("react.forward_ref");
    $bc82ad483894b8e4$export$74bf444e3cd11ea5 = $bc82ad483894b8e4$var$w("react.suspense");
    $bc82ad483894b8e4$var$u = $bc82ad483894b8e4$var$w("react.memo");
    $bc82ad483894b8e4$var$v = $bc82ad483894b8e4$var$w("react.lazy");
}
var $bc82ad483894b8e4$var$x = "function" === typeof Symbol && Symbol.iterator;
function $bc82ad483894b8e4$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $bc82ad483894b8e4$var$x && a[$bc82ad483894b8e4$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $bc82ad483894b8e4$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $bc82ad483894b8e4$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $bc82ad483894b8e4$var$B = {};
function $bc82ad483894b8e4$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $bc82ad483894b8e4$var$B;
    this.updater = c || $bc82ad483894b8e4$var$A;
}
$bc82ad483894b8e4$var$C.prototype.isReactComponent = {};
$bc82ad483894b8e4$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($bc82ad483894b8e4$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$bc82ad483894b8e4$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $bc82ad483894b8e4$var$D() {}
$bc82ad483894b8e4$var$D.prototype = $bc82ad483894b8e4$var$C.prototype;
function $bc82ad483894b8e4$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $bc82ad483894b8e4$var$B;
    this.updater = c || $bc82ad483894b8e4$var$A;
}
var $bc82ad483894b8e4$var$F = $bc82ad483894b8e4$var$E.prototype = new $bc82ad483894b8e4$var$D;
$bc82ad483894b8e4$var$F.constructor = $bc82ad483894b8e4$var$E;
$kw0QJ($bc82ad483894b8e4$var$F, $bc82ad483894b8e4$var$C.prototype);
$bc82ad483894b8e4$var$F.isPureReactComponent = !0;
var $bc82ad483894b8e4$var$G = {
    current: null
}, $bc82ad483894b8e4$var$H = Object.prototype.hasOwnProperty, $bc82ad483894b8e4$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bc82ad483894b8e4$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$bc82ad483894b8e4$var$H.call(b, e) && !$bc82ad483894b8e4$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $bc82ad483894b8e4$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $bc82ad483894b8e4$var$G.current
    };
}
function $bc82ad483894b8e4$var$K(a, b) {
    return {
        $$typeof: $bc82ad483894b8e4$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $bc82ad483894b8e4$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bc82ad483894b8e4$var$n;
}
function $bc82ad483894b8e4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $bc82ad483894b8e4$var$M = /\/+/g;
function $bc82ad483894b8e4$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $bc82ad483894b8e4$var$escape("" + a.key) : b.toString(36);
}
function $bc82ad483894b8e4$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $bc82ad483894b8e4$var$n:
                case $bc82ad483894b8e4$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $bc82ad483894b8e4$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($bc82ad483894b8e4$var$M, "$&/") + "/"), $bc82ad483894b8e4$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($bc82ad483894b8e4$var$L(d) && (d = $bc82ad483894b8e4$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($bc82ad483894b8e4$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $bc82ad483894b8e4$var$N(k, g);
        h += $bc82ad483894b8e4$var$O(k, b, c, f, d);
    }
    else if (f = $bc82ad483894b8e4$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $bc82ad483894b8e4$var$N(k, g++), h += $bc82ad483894b8e4$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($bc82ad483894b8e4$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $bc82ad483894b8e4$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $bc82ad483894b8e4$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $bc82ad483894b8e4$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $bc82ad483894b8e4$var$R = {
    current: null
};
function $bc82ad483894b8e4$var$S() {
    var a = $bc82ad483894b8e4$var$R.current;
    if (null === a) throw Error($bc82ad483894b8e4$var$z(321));
    return a;
}
var $bc82ad483894b8e4$var$T = {
    ReactCurrentDispatcher: $bc82ad483894b8e4$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $bc82ad483894b8e4$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $kw0QJ
};
$bc82ad483894b8e4$export$dca3b0875bd9a954 = {
    map: $bc82ad483894b8e4$var$P,
    forEach: function(a, b, c) {
        $bc82ad483894b8e4$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $bc82ad483894b8e4$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $bc82ad483894b8e4$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$bc82ad483894b8e4$var$L(a)) throw Error($bc82ad483894b8e4$var$z(143));
        return a;
    }
};
$bc82ad483894b8e4$export$16fa2f45be04daa8 = $bc82ad483894b8e4$var$C;
$bc82ad483894b8e4$export$221d75b3f55bb0bd = $bc82ad483894b8e4$var$E;
$bc82ad483894b8e4$export$ae55be85d98224ed = $bc82ad483894b8e4$var$T;
$bc82ad483894b8e4$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($bc82ad483894b8e4$var$z(267, a));
    var e = $kw0QJ({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $bc82ad483894b8e4$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$bc82ad483894b8e4$var$H.call(b, f) && !$bc82ad483894b8e4$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $bc82ad483894b8e4$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$bc82ad483894b8e4$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $bc82ad483894b8e4$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $bc82ad483894b8e4$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$bc82ad483894b8e4$export$c8a8987d4410bf2d = $bc82ad483894b8e4$var$J;
$bc82ad483894b8e4$export$d38cd72104c1f0e9 = function(a) {
    var b = $bc82ad483894b8e4$var$J.bind(null, a);
    b.type = a;
    return b;
};
$bc82ad483894b8e4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$bc82ad483894b8e4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $bc82ad483894b8e4$var$t,
        render: a
    };
};
$bc82ad483894b8e4$export$a8257692ac88316c = $bc82ad483894b8e4$var$L;
$bc82ad483894b8e4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $bc82ad483894b8e4$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $bc82ad483894b8e4$var$Q
    };
};
$bc82ad483894b8e4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $bc82ad483894b8e4$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$bc82ad483894b8e4$export$35808ee640e87ca7 = function(a, b) {
    return $bc82ad483894b8e4$var$S().useCallback(a, b);
};
$bc82ad483894b8e4$export$fae74005e78b1a27 = function(a, b) {
    return $bc82ad483894b8e4$var$S().useContext(a, b);
};
$bc82ad483894b8e4$export$dc8fbce3eb94dc1e = function() {};
$bc82ad483894b8e4$export$6d9c69b0de29b591 = function(a, b) {
    return $bc82ad483894b8e4$var$S().useEffect(a, b);
};
$bc82ad483894b8e4$export$d5a552a76deda3c2 = function(a, b, c) {
    return $bc82ad483894b8e4$var$S().useImperativeHandle(a, b, c);
};
$bc82ad483894b8e4$export$e5c5a5f917a5871c = function(a, b) {
    return $bc82ad483894b8e4$var$S().useLayoutEffect(a, b);
};
$bc82ad483894b8e4$export$1538c33de8887b59 = function(a, b) {
    return $bc82ad483894b8e4$var$S().useMemo(a, b);
};
$bc82ad483894b8e4$export$13e3392192263954 = function(a, b, c) {
    return $bc82ad483894b8e4$var$S().useReducer(a, b, c);
};
$bc82ad483894b8e4$export$b8f5890fc79d6aca = function(a) {
    return $bc82ad483894b8e4$var$S().useRef(a);
};
$bc82ad483894b8e4$export$60241385465d0a34 = function(a) {
    return $bc82ad483894b8e4$var$S().useState(a);
};
$bc82ad483894b8e4$export$83d89fbfd8236492 = "17.0.2";

});




parcelRegister("8CZEB", function(module, exports) {
'use strict';
function $6481b2845dce8a35$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6481b2845dce8a35$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6481b2845dce8a35$var$checkDCE();

module.exports = (parcelRequire("8PP1S"));

});
parcelRegister("8PP1S", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $6fFrj = parcelRequire("6fFrj");

var $kw0QJ = parcelRequire("kw0QJ");

var $cNLGy = parcelRequire("cNLGy");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$6fFrj) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $6fFrj.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $kw0QJ({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $6fFrj.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $kw0QJ({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $kw0QJ({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $kw0QJ({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $cNLGy.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $cNLGy.unstable_scheduleCallback($cNLGy.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $cNLGy.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $cNLGy.unstable_UserBlockingPriority, ed = $cNLGy.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $kw0QJ(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $kw0QJ({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $kw0QJ({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $kw0QJ({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $kw0QJ({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $kw0QJ({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $kw0QJ({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $kw0QJ({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $kw0QJ({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $kw0QJ({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $kw0QJ({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $kw0QJ({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $kw0QJ({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $kw0QJ({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $cNLGy.unstable_runWithPriority, Of = $cNLGy.unstable_scheduleCallback, Pf = $cNLGy.unstable_cancelCallback, Qf = $cNLGy.unstable_shouldYield, Rf = $cNLGy.unstable_requestPaint, Sf = $cNLGy.unstable_now, Tf = $cNLGy.unstable_getCurrentPriorityLevel, Uf = $cNLGy.unstable_ImmediatePriority, Vf = $cNLGy.unstable_UserBlockingPriority, Wf = $cNLGy.unstable_NormalPriority, Xf = $cNLGy.unstable_LowPriority, Yf = $cNLGy.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $kw0QJ({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $kw0QJ({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $6fFrj.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $kw0QJ({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $kw0QJ({}, e, {
                    value: void 0
                });
                d = $kw0QJ({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $kw0QJ({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("cNLGy", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4dVZI"));

});
parcelRegister("4dVZI", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $31355ccda61e66b2$export$c4744153514ff05d; }, function (v) { return $31355ccda61e66b2$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $31355ccda61e66b2$export$b5836b71941fa3ed; }, function (v) { return $31355ccda61e66b2$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $31355ccda61e66b2$export$d66a1c1c77bd778b; }, function (v) { return $31355ccda61e66b2$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $31355ccda61e66b2$export$3e506c1ccc9cc1a7; }, function (v) { return $31355ccda61e66b2$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $31355ccda61e66b2$export$e26fe2ed2fa76875; }, function (v) { return $31355ccda61e66b2$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $31355ccda61e66b2$export$502329bbf4b505b1; }, function (v) { return $31355ccda61e66b2$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $31355ccda61e66b2$export$6e3807111c4874c4; }, function (v) { return $31355ccda61e66b2$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $31355ccda61e66b2$export$c27134553091fb3a; }, function (v) { return $31355ccda61e66b2$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $31355ccda61e66b2$export$33ee1acdc04fd2a2; }, function (v) { return $31355ccda61e66b2$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $31355ccda61e66b2$export$b00a404bbd5edef2; }, function (v) { return $31355ccda61e66b2$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $31355ccda61e66b2$export$8352ce38b91d0c62; }, function (v) { return $31355ccda61e66b2$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $31355ccda61e66b2$export$d3dfb8e4810cb555; }, function (v) { return $31355ccda61e66b2$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $31355ccda61e66b2$export$839f9183b0465a69; }, function (v) { return $31355ccda61e66b2$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $31355ccda61e66b2$export$72fdf0e06517287b; }, function (v) { return $31355ccda61e66b2$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $31355ccda61e66b2$export$4b844e58a3e414b4; }, function (v) { return $31355ccda61e66b2$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $31355ccda61e66b2$export$816d2913ae6b83b1; }, function (v) { return $31355ccda61e66b2$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $31355ccda61e66b2$export$61bcfe829111a1d0; }, function (v) { return $31355ccda61e66b2$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $31355ccda61e66b2$export$7ee8c9beb337bc3f; }, function (v) { return $31355ccda61e66b2$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $31355ccda61e66b2$export$cf845f2c119da08a; }, function (v) { return $31355ccda61e66b2$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $31355ccda61e66b2$export$c4744153514ff05d;
var $31355ccda61e66b2$export$b5836b71941fa3ed;
var $31355ccda61e66b2$export$d66a1c1c77bd778b;
var $31355ccda61e66b2$export$3e506c1ccc9cc1a7;
var $31355ccda61e66b2$export$e26fe2ed2fa76875;
var $31355ccda61e66b2$export$502329bbf4b505b1;
var $31355ccda61e66b2$export$6e3807111c4874c4;
var $31355ccda61e66b2$export$c27134553091fb3a;
var $31355ccda61e66b2$export$33ee1acdc04fd2a2;
var $31355ccda61e66b2$export$b00a404bbd5edef2;
var $31355ccda61e66b2$export$8352ce38b91d0c62;
var $31355ccda61e66b2$export$d3dfb8e4810cb555;
var $31355ccda61e66b2$export$839f9183b0465a69;
var $31355ccda61e66b2$export$72fdf0e06517287b;
var $31355ccda61e66b2$export$4b844e58a3e414b4;
var $31355ccda61e66b2$export$816d2913ae6b83b1;
var $31355ccda61e66b2$export$61bcfe829111a1d0;
var $31355ccda61e66b2$export$7ee8c9beb337bc3f;
var $31355ccda61e66b2$export$cf845f2c119da08a;
'use strict';
var $31355ccda61e66b2$var$f, $31355ccda61e66b2$var$g, $31355ccda61e66b2$var$h, $31355ccda61e66b2$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $31355ccda61e66b2$var$l = performance;
    $31355ccda61e66b2$export$c4744153514ff05d = function() {
        return $31355ccda61e66b2$var$l.now();
    };
} else {
    var $31355ccda61e66b2$var$p = Date, $31355ccda61e66b2$var$q = $31355ccda61e66b2$var$p.now();
    $31355ccda61e66b2$export$c4744153514ff05d = function() {
        return $31355ccda61e66b2$var$p.now() - $31355ccda61e66b2$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $31355ccda61e66b2$var$t = null, $31355ccda61e66b2$var$u = null, $31355ccda61e66b2$var$w = function() {
        if (null !== $31355ccda61e66b2$var$t) try {
            var a = $31355ccda61e66b2$export$c4744153514ff05d();
            $31355ccda61e66b2$var$t(!0, a);
            $31355ccda61e66b2$var$t = null;
        } catch (b) {
            throw setTimeout($31355ccda61e66b2$var$w, 0), b;
        }
    };
    $31355ccda61e66b2$var$f = function(a) {
        null !== $31355ccda61e66b2$var$t ? setTimeout($31355ccda61e66b2$var$f, 0, a) : ($31355ccda61e66b2$var$t = a, setTimeout($31355ccda61e66b2$var$w, 0));
    };
    $31355ccda61e66b2$var$g = function(a, b) {
        $31355ccda61e66b2$var$u = setTimeout(a, b);
    };
    $31355ccda61e66b2$var$h = function() {
        clearTimeout($31355ccda61e66b2$var$u);
    };
    $31355ccda61e66b2$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $31355ccda61e66b2$var$k = $31355ccda61e66b2$export$d66a1c1c77bd778b = function() {};
} else {
    var $31355ccda61e66b2$var$x = window.setTimeout, $31355ccda61e66b2$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $31355ccda61e66b2$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $31355ccda61e66b2$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $31355ccda61e66b2$var$A = !1, $31355ccda61e66b2$var$B = null, $31355ccda61e66b2$var$C = -1, $31355ccda61e66b2$var$D = 5, $31355ccda61e66b2$var$E = 0;
    $31355ccda61e66b2$export$b5836b71941fa3ed = function() {
        return $31355ccda61e66b2$export$c4744153514ff05d() >= $31355ccda61e66b2$var$E;
    };
    $31355ccda61e66b2$var$k = function() {};
    $31355ccda61e66b2$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $31355ccda61e66b2$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $31355ccda61e66b2$var$F = new MessageChannel, $31355ccda61e66b2$var$G = $31355ccda61e66b2$var$F.port2;
    $31355ccda61e66b2$var$F.port1.onmessage = function() {
        if (null !== $31355ccda61e66b2$var$B) {
            var a = $31355ccda61e66b2$export$c4744153514ff05d();
            $31355ccda61e66b2$var$E = a + $31355ccda61e66b2$var$D;
            try {
                $31355ccda61e66b2$var$B(!0, a) ? $31355ccda61e66b2$var$G.postMessage(null) : ($31355ccda61e66b2$var$A = !1, $31355ccda61e66b2$var$B = null);
            } catch (b) {
                throw $31355ccda61e66b2$var$G.postMessage(null), b;
            }
        } else $31355ccda61e66b2$var$A = !1;
    };
    $31355ccda61e66b2$var$f = function(a) {
        $31355ccda61e66b2$var$B = a;
        $31355ccda61e66b2$var$A || ($31355ccda61e66b2$var$A = !0, $31355ccda61e66b2$var$G.postMessage(null));
    };
    $31355ccda61e66b2$var$g = function(a, b) {
        $31355ccda61e66b2$var$C = $31355ccda61e66b2$var$x(function() {
            a($31355ccda61e66b2$export$c4744153514ff05d());
        }, b);
    };
    $31355ccda61e66b2$var$h = function() {
        $31355ccda61e66b2$var$y($31355ccda61e66b2$var$C);
        $31355ccda61e66b2$var$C = -1;
    };
}
function $31355ccda61e66b2$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $31355ccda61e66b2$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $31355ccda61e66b2$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $31355ccda61e66b2$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $31355ccda61e66b2$var$I(n, c)) void 0 !== r && 0 > $31355ccda61e66b2$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $31355ccda61e66b2$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $31355ccda61e66b2$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $31355ccda61e66b2$var$L = [], $31355ccda61e66b2$var$M = [], $31355ccda61e66b2$var$N = 1, $31355ccda61e66b2$var$O = null, $31355ccda61e66b2$var$P = 3, $31355ccda61e66b2$var$Q = !1, $31355ccda61e66b2$var$R = !1, $31355ccda61e66b2$var$S = !1;
function $31355ccda61e66b2$var$T(a) {
    for(var b = $31355ccda61e66b2$var$J($31355ccda61e66b2$var$M); null !== b;){
        if (null === b.callback) $31355ccda61e66b2$var$K($31355ccda61e66b2$var$M);
        else if (b.startTime <= a) $31355ccda61e66b2$var$K($31355ccda61e66b2$var$M), b.sortIndex = b.expirationTime, $31355ccda61e66b2$var$H($31355ccda61e66b2$var$L, b);
        else break;
        b = $31355ccda61e66b2$var$J($31355ccda61e66b2$var$M);
    }
}
function $31355ccda61e66b2$var$U(a) {
    $31355ccda61e66b2$var$S = !1;
    $31355ccda61e66b2$var$T(a);
    if (!$31355ccda61e66b2$var$R) {
        if (null !== $31355ccda61e66b2$var$J($31355ccda61e66b2$var$L)) $31355ccda61e66b2$var$R = !0, $31355ccda61e66b2$var$f($31355ccda61e66b2$var$V);
        else {
            var b = $31355ccda61e66b2$var$J($31355ccda61e66b2$var$M);
            null !== b && $31355ccda61e66b2$var$g($31355ccda61e66b2$var$U, b.startTime - a);
        }
    }
}
function $31355ccda61e66b2$var$V(a, b) {
    $31355ccda61e66b2$var$R = !1;
    $31355ccda61e66b2$var$S && ($31355ccda61e66b2$var$S = !1, $31355ccda61e66b2$var$h());
    $31355ccda61e66b2$var$Q = !0;
    var c = $31355ccda61e66b2$var$P;
    try {
        $31355ccda61e66b2$var$T(b);
        for($31355ccda61e66b2$var$O = $31355ccda61e66b2$var$J($31355ccda61e66b2$var$L); null !== $31355ccda61e66b2$var$O && (!($31355ccda61e66b2$var$O.expirationTime > b) || a && !$31355ccda61e66b2$export$b5836b71941fa3ed());){
            var d = $31355ccda61e66b2$var$O.callback;
            if ("function" === typeof d) {
                $31355ccda61e66b2$var$O.callback = null;
                $31355ccda61e66b2$var$P = $31355ccda61e66b2$var$O.priorityLevel;
                var e = d($31355ccda61e66b2$var$O.expirationTime <= b);
                b = $31355ccda61e66b2$export$c4744153514ff05d();
                "function" === typeof e ? $31355ccda61e66b2$var$O.callback = e : $31355ccda61e66b2$var$O === $31355ccda61e66b2$var$J($31355ccda61e66b2$var$L) && $31355ccda61e66b2$var$K($31355ccda61e66b2$var$L);
                $31355ccda61e66b2$var$T(b);
            } else $31355ccda61e66b2$var$K($31355ccda61e66b2$var$L);
            $31355ccda61e66b2$var$O = $31355ccda61e66b2$var$J($31355ccda61e66b2$var$L);
        }
        if (null !== $31355ccda61e66b2$var$O) var m = !0;
        else {
            var n = $31355ccda61e66b2$var$J($31355ccda61e66b2$var$M);
            null !== n && $31355ccda61e66b2$var$g($31355ccda61e66b2$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $31355ccda61e66b2$var$O = null, $31355ccda61e66b2$var$P = c, $31355ccda61e66b2$var$Q = !1;
    }
}
var $31355ccda61e66b2$var$W = $31355ccda61e66b2$var$k;
$31355ccda61e66b2$export$3e506c1ccc9cc1a7 = 5;
$31355ccda61e66b2$export$e26fe2ed2fa76875 = 1;
$31355ccda61e66b2$export$502329bbf4b505b1 = 4;
$31355ccda61e66b2$export$6e3807111c4874c4 = 3;
$31355ccda61e66b2$export$c27134553091fb3a = null;
$31355ccda61e66b2$export$33ee1acdc04fd2a2 = 2;
$31355ccda61e66b2$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$31355ccda61e66b2$export$8352ce38b91d0c62 = function() {
    $31355ccda61e66b2$var$R || $31355ccda61e66b2$var$Q || ($31355ccda61e66b2$var$R = !0, $31355ccda61e66b2$var$f($31355ccda61e66b2$var$V));
};
$31355ccda61e66b2$export$d3dfb8e4810cb555 = function() {
    return $31355ccda61e66b2$var$P;
};
$31355ccda61e66b2$export$839f9183b0465a69 = function() {
    return $31355ccda61e66b2$var$J($31355ccda61e66b2$var$L);
};
$31355ccda61e66b2$export$72fdf0e06517287b = function(a) {
    switch($31355ccda61e66b2$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $31355ccda61e66b2$var$P;
    }
    var c = $31355ccda61e66b2$var$P;
    $31355ccda61e66b2$var$P = b;
    try {
        return a();
    } finally{
        $31355ccda61e66b2$var$P = c;
    }
};
$31355ccda61e66b2$export$4b844e58a3e414b4 = function() {};
$31355ccda61e66b2$export$816d2913ae6b83b1 = $31355ccda61e66b2$var$W;
$31355ccda61e66b2$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $31355ccda61e66b2$var$P;
    $31355ccda61e66b2$var$P = a;
    try {
        return b();
    } finally{
        $31355ccda61e66b2$var$P = c;
    }
};
$31355ccda61e66b2$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $31355ccda61e66b2$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $31355ccda61e66b2$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $31355ccda61e66b2$var$H($31355ccda61e66b2$var$M, a), null === $31355ccda61e66b2$var$J($31355ccda61e66b2$var$L) && a === $31355ccda61e66b2$var$J($31355ccda61e66b2$var$M) && ($31355ccda61e66b2$var$S ? $31355ccda61e66b2$var$h() : $31355ccda61e66b2$var$S = !0, $31355ccda61e66b2$var$g($31355ccda61e66b2$var$U, c - d))) : (a.sortIndex = e, $31355ccda61e66b2$var$H($31355ccda61e66b2$var$L, a), $31355ccda61e66b2$var$R || $31355ccda61e66b2$var$Q || ($31355ccda61e66b2$var$R = !0, $31355ccda61e66b2$var$f($31355ccda61e66b2$var$V)));
    return a;
};
$31355ccda61e66b2$export$cf845f2c119da08a = function(a) {
    var b = $31355ccda61e66b2$var$P;
    return function() {
        var c = $31355ccda61e66b2$var$P;
        $31355ccda61e66b2$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $31355ccda61e66b2$var$P = c;
        }
    };
};

});




parcelRegister("8LKEK", function(module, exports) {
// shim for using process in browser
var $6626e77e777e465e$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $6626e77e777e465e$var$cachedSetTimeout;
var $6626e77e777e465e$var$cachedClearTimeout;
function $6626e77e777e465e$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $6626e77e777e465e$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $6626e77e777e465e$var$cachedSetTimeout = setTimeout;
        else $6626e77e777e465e$var$cachedSetTimeout = $6626e77e777e465e$var$defaultSetTimout;
    } catch (e) {
        $6626e77e777e465e$var$cachedSetTimeout = $6626e77e777e465e$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $6626e77e777e465e$var$cachedClearTimeout = clearTimeout;
        else $6626e77e777e465e$var$cachedClearTimeout = $6626e77e777e465e$var$defaultClearTimeout;
    } catch (e) {
        $6626e77e777e465e$var$cachedClearTimeout = $6626e77e777e465e$var$defaultClearTimeout;
    }
})();
function $6626e77e777e465e$var$runTimeout(fun) {
    if ($6626e77e777e465e$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($6626e77e777e465e$var$cachedSetTimeout === $6626e77e777e465e$var$defaultSetTimout || !$6626e77e777e465e$var$cachedSetTimeout) && setTimeout) {
        $6626e77e777e465e$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $6626e77e777e465e$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $6626e77e777e465e$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $6626e77e777e465e$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $6626e77e777e465e$var$runClearTimeout(marker) {
    if ($6626e77e777e465e$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($6626e77e777e465e$var$cachedClearTimeout === $6626e77e777e465e$var$defaultClearTimeout || !$6626e77e777e465e$var$cachedClearTimeout) && clearTimeout) {
        $6626e77e777e465e$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $6626e77e777e465e$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $6626e77e777e465e$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $6626e77e777e465e$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $6626e77e777e465e$var$queue = [];
var $6626e77e777e465e$var$draining = false;
var $6626e77e777e465e$var$currentQueue;
var $6626e77e777e465e$var$queueIndex = -1;
function $6626e77e777e465e$var$cleanUpNextTick() {
    if (!$6626e77e777e465e$var$draining || !$6626e77e777e465e$var$currentQueue) return;
    $6626e77e777e465e$var$draining = false;
    if ($6626e77e777e465e$var$currentQueue.length) $6626e77e777e465e$var$queue = $6626e77e777e465e$var$currentQueue.concat($6626e77e777e465e$var$queue);
    else $6626e77e777e465e$var$queueIndex = -1;
    if ($6626e77e777e465e$var$queue.length) $6626e77e777e465e$var$drainQueue();
}
function $6626e77e777e465e$var$drainQueue() {
    if ($6626e77e777e465e$var$draining) return;
    var timeout = $6626e77e777e465e$var$runTimeout($6626e77e777e465e$var$cleanUpNextTick);
    $6626e77e777e465e$var$draining = true;
    var len = $6626e77e777e465e$var$queue.length;
    while(len){
        $6626e77e777e465e$var$currentQueue = $6626e77e777e465e$var$queue;
        $6626e77e777e465e$var$queue = [];
        while(++$6626e77e777e465e$var$queueIndex < len)if ($6626e77e777e465e$var$currentQueue) $6626e77e777e465e$var$currentQueue[$6626e77e777e465e$var$queueIndex].run();
        $6626e77e777e465e$var$queueIndex = -1;
        len = $6626e77e777e465e$var$queue.length;
    }
    $6626e77e777e465e$var$currentQueue = null;
    $6626e77e777e465e$var$draining = false;
    $6626e77e777e465e$var$runClearTimeout(timeout);
}
$6626e77e777e465e$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $6626e77e777e465e$var$queue.push(new $6626e77e777e465e$var$Item(fun, args));
    if ($6626e77e777e465e$var$queue.length === 1 && !$6626e77e777e465e$var$draining) $6626e77e777e465e$var$runTimeout($6626e77e777e465e$var$drainQueue);
};
// v8 likes predictible objects
function $6626e77e777e465e$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$6626e77e777e465e$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$6626e77e777e465e$var$process.title = 'browser';
$6626e77e777e465e$var$process.browser = true;
$6626e77e777e465e$var$process.env = {};
$6626e77e777e465e$var$process.argv = [];
$6626e77e777e465e$var$process.version = ''; // empty string to avoid regexp issues
$6626e77e777e465e$var$process.versions = {};
function $6626e77e777e465e$var$noop() {}
$6626e77e777e465e$var$process.on = $6626e77e777e465e$var$noop;
$6626e77e777e465e$var$process.addListener = $6626e77e777e465e$var$noop;
$6626e77e777e465e$var$process.once = $6626e77e777e465e$var$noop;
$6626e77e777e465e$var$process.off = $6626e77e777e465e$var$noop;
$6626e77e777e465e$var$process.removeListener = $6626e77e777e465e$var$noop;
$6626e77e777e465e$var$process.removeAllListeners = $6626e77e777e465e$var$noop;
$6626e77e777e465e$var$process.emit = $6626e77e777e465e$var$noop;
$6626e77e777e465e$var$process.prependListener = $6626e77e777e465e$var$noop;
$6626e77e777e465e$var$process.prependOnceListener = $6626e77e777e465e$var$noop;
$6626e77e777e465e$var$process.listeners = function(name) {
    return [];
};
$6626e77e777e465e$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$6626e77e777e465e$var$process.cwd = function() {
    return '/';
};
$6626e77e777e465e$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$6626e77e777e465e$var$process.umask = function() {
    return 0;
};

});

parcelRegister("l3kzc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7QaCu = parcelRequire("7QaCu");
function $f539d4e778e34a31$var$emptyFunction() {}
function $f539d4e778e34a31$var$emptyFunctionWithReset() {}
$f539d4e778e34a31$var$emptyFunctionWithReset.resetWarningCache = $f539d4e778e34a31$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7QaCu) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f539d4e778e34a31$var$emptyFunctionWithReset,
        resetWarningCache: $f539d4e778e34a31$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7QaCu", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5b55a0992a19df29$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5b55a0992a19df29$var$ReactPropTypesSecret;

});


parcelRegister("g8WFZ", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $bc0ae8905982b0e9$export$2b8d127b894957b9; }, function (v) { return $bc0ae8905982b0e9$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $bc0ae8905982b0e9$export$cea3a54a6425200c; }, function (v) { return $bc0ae8905982b0e9$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $bc0ae8905982b0e9$export$a7c73072b1a182ae; }, function (v) { return $bc0ae8905982b0e9$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $bc0ae8905982b0e9$export$9f27bc3417b4524d; }, function (v) { return $bc0ae8905982b0e9$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $bc0ae8905982b0e9$export$db77ccec0bb4ccac; }, function (v) { return $bc0ae8905982b0e9$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $bc0ae8905982b0e9$export$8392c0c9d3dcbd35; }, function (v) { return $bc0ae8905982b0e9$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bc0ae8905982b0e9$export$ffb0004e005737fa; }, function (v) { return $bc0ae8905982b0e9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $bc0ae8905982b0e9$export$b624eff549462981; }, function (v) { return $bc0ae8905982b0e9$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $bc0ae8905982b0e9$export$7897aa7841a5380c; }, function (v) { return $bc0ae8905982b0e9$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $bc0ae8905982b0e9$export$602eac185826482c; }, function (v) { return $bc0ae8905982b0e9$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $bc0ae8905982b0e9$export$e2c29f18771995cb; }, function (v) { return $bc0ae8905982b0e9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bc0ae8905982b0e9$export$5f8d39834fd61797; }, function (v) { return $bc0ae8905982b0e9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bc0ae8905982b0e9$export$74bf444e3cd11ea5; }, function (v) { return $bc0ae8905982b0e9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $bc0ae8905982b0e9$export$92387174baf9b227; }, function (v) { return $bc0ae8905982b0e9$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $bc0ae8905982b0e9$export$ec112efeb987d9c6; }, function (v) { return $bc0ae8905982b0e9$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $bc0ae8905982b0e9$export$b706b080d889d2c9; }, function (v) { return $bc0ae8905982b0e9$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $bc0ae8905982b0e9$export$5be5a87408f70ddc; }, function (v) { return $bc0ae8905982b0e9$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $bc0ae8905982b0e9$export$45a5e7f76e0caa8d; }, function (v) { return $bc0ae8905982b0e9$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $bc0ae8905982b0e9$export$455c2e768291efa6; }, function (v) { return $bc0ae8905982b0e9$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $bc0ae8905982b0e9$export$9522e17588c12572; }, function (v) { return $bc0ae8905982b0e9$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $bc0ae8905982b0e9$export$2110ac352bb060b9; }, function (v) { return $bc0ae8905982b0e9$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $bc0ae8905982b0e9$export$56885ab8b9c456ab; }, function (v) { return $bc0ae8905982b0e9$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $bc0ae8905982b0e9$export$d927fcb6adf8f9de; }, function (v) { return $bc0ae8905982b0e9$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $bc0ae8905982b0e9$export$b82d16f27459e05a; }, function (v) { return $bc0ae8905982b0e9$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $bc0ae8905982b0e9$export$522c17b4f5e123e8; }, function (v) { return $bc0ae8905982b0e9$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $bc0ae8905982b0e9$export$1aabd8a0274ecfd6; }, function (v) { return $bc0ae8905982b0e9$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $bc0ae8905982b0e9$export$9b621391a187a31a; }, function (v) { return $bc0ae8905982b0e9$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $bc0ae8905982b0e9$export$f5bbd400c2f4426f; }, function (v) { return $bc0ae8905982b0e9$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bc0ae8905982b0e9$export$2b8d127b894957b9;
var $bc0ae8905982b0e9$export$cea3a54a6425200c;
var $bc0ae8905982b0e9$export$a7c73072b1a182ae;
var $bc0ae8905982b0e9$export$9f27bc3417b4524d;
var $bc0ae8905982b0e9$export$db77ccec0bb4ccac;
var $bc0ae8905982b0e9$export$8392c0c9d3dcbd35;
var $bc0ae8905982b0e9$export$ffb0004e005737fa;
var $bc0ae8905982b0e9$export$b624eff549462981;
var $bc0ae8905982b0e9$export$7897aa7841a5380c;
var $bc0ae8905982b0e9$export$602eac185826482c;
var $bc0ae8905982b0e9$export$e2c29f18771995cb;
var $bc0ae8905982b0e9$export$5f8d39834fd61797;
var $bc0ae8905982b0e9$export$74bf444e3cd11ea5;
var $bc0ae8905982b0e9$export$92387174baf9b227;
var $bc0ae8905982b0e9$export$ec112efeb987d9c6;
var $bc0ae8905982b0e9$export$b706b080d889d2c9;
var $bc0ae8905982b0e9$export$5be5a87408f70ddc;
var $bc0ae8905982b0e9$export$45a5e7f76e0caa8d;
var $bc0ae8905982b0e9$export$455c2e768291efa6;
var $bc0ae8905982b0e9$export$9522e17588c12572;
var $bc0ae8905982b0e9$export$2110ac352bb060b9;
var $bc0ae8905982b0e9$export$56885ab8b9c456ab;
var $bc0ae8905982b0e9$export$d927fcb6adf8f9de;
var $bc0ae8905982b0e9$export$b82d16f27459e05a;
var $bc0ae8905982b0e9$export$522c17b4f5e123e8;
var $bc0ae8905982b0e9$export$1aabd8a0274ecfd6;
var $bc0ae8905982b0e9$export$9b621391a187a31a;
var $bc0ae8905982b0e9$export$f5bbd400c2f4426f;
'use strict';
var $bc0ae8905982b0e9$var$b = "function" === typeof Symbol && Symbol.for, $bc0ae8905982b0e9$var$c = $bc0ae8905982b0e9$var$b ? Symbol.for("react.element") : 60103, $bc0ae8905982b0e9$var$d = $bc0ae8905982b0e9$var$b ? Symbol.for("react.portal") : 60106, $bc0ae8905982b0e9$var$e = $bc0ae8905982b0e9$var$b ? Symbol.for("react.fragment") : 60107, $bc0ae8905982b0e9$var$f = $bc0ae8905982b0e9$var$b ? Symbol.for("react.strict_mode") : 60108, $bc0ae8905982b0e9$var$g = $bc0ae8905982b0e9$var$b ? Symbol.for("react.profiler") : 60114, $bc0ae8905982b0e9$var$h = $bc0ae8905982b0e9$var$b ? Symbol.for("react.provider") : 60109, $bc0ae8905982b0e9$var$k = $bc0ae8905982b0e9$var$b ? Symbol.for("react.context") : 60110, $bc0ae8905982b0e9$var$l = $bc0ae8905982b0e9$var$b ? Symbol.for("react.async_mode") : 60111, $bc0ae8905982b0e9$var$m = $bc0ae8905982b0e9$var$b ? Symbol.for("react.concurrent_mode") : 60111, $bc0ae8905982b0e9$var$n = $bc0ae8905982b0e9$var$b ? Symbol.for("react.forward_ref") : 60112, $bc0ae8905982b0e9$var$p = $bc0ae8905982b0e9$var$b ? Symbol.for("react.suspense") : 60113, $bc0ae8905982b0e9$var$q = $bc0ae8905982b0e9$var$b ? Symbol.for("react.suspense_list") : 60120, $bc0ae8905982b0e9$var$r = $bc0ae8905982b0e9$var$b ? Symbol.for("react.memo") : 60115, $bc0ae8905982b0e9$var$t = $bc0ae8905982b0e9$var$b ? Symbol.for("react.lazy") : 60116, $bc0ae8905982b0e9$var$v = $bc0ae8905982b0e9$var$b ? Symbol.for("react.block") : 60121, $bc0ae8905982b0e9$var$w = $bc0ae8905982b0e9$var$b ? Symbol.for("react.fundamental") : 60117, $bc0ae8905982b0e9$var$x = $bc0ae8905982b0e9$var$b ? Symbol.for("react.responder") : 60118, $bc0ae8905982b0e9$var$y = $bc0ae8905982b0e9$var$b ? Symbol.for("react.scope") : 60119;
function $bc0ae8905982b0e9$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $bc0ae8905982b0e9$var$c:
                switch(a = a.type, a){
                    case $bc0ae8905982b0e9$var$l:
                    case $bc0ae8905982b0e9$var$m:
                    case $bc0ae8905982b0e9$var$e:
                    case $bc0ae8905982b0e9$var$g:
                    case $bc0ae8905982b0e9$var$f:
                    case $bc0ae8905982b0e9$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $bc0ae8905982b0e9$var$k:
                            case $bc0ae8905982b0e9$var$n:
                            case $bc0ae8905982b0e9$var$t:
                            case $bc0ae8905982b0e9$var$r:
                            case $bc0ae8905982b0e9$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $bc0ae8905982b0e9$var$d:
                return u;
        }
    }
}
function $bc0ae8905982b0e9$var$A(a) {
    return $bc0ae8905982b0e9$var$z(a) === $bc0ae8905982b0e9$var$m;
}
$bc0ae8905982b0e9$export$2b8d127b894957b9 = $bc0ae8905982b0e9$var$l;
$bc0ae8905982b0e9$export$cea3a54a6425200c = $bc0ae8905982b0e9$var$m;
$bc0ae8905982b0e9$export$a7c73072b1a182ae = $bc0ae8905982b0e9$var$k;
$bc0ae8905982b0e9$export$9f27bc3417b4524d = $bc0ae8905982b0e9$var$h;
$bc0ae8905982b0e9$export$db77ccec0bb4ccac = $bc0ae8905982b0e9$var$c;
$bc0ae8905982b0e9$export$8392c0c9d3dcbd35 = $bc0ae8905982b0e9$var$n;
$bc0ae8905982b0e9$export$ffb0004e005737fa = $bc0ae8905982b0e9$var$e;
$bc0ae8905982b0e9$export$b624eff549462981 = $bc0ae8905982b0e9$var$t;
$bc0ae8905982b0e9$export$7897aa7841a5380c = $bc0ae8905982b0e9$var$r;
$bc0ae8905982b0e9$export$602eac185826482c = $bc0ae8905982b0e9$var$d;
$bc0ae8905982b0e9$export$e2c29f18771995cb = $bc0ae8905982b0e9$var$g;
$bc0ae8905982b0e9$export$5f8d39834fd61797 = $bc0ae8905982b0e9$var$f;
$bc0ae8905982b0e9$export$74bf444e3cd11ea5 = $bc0ae8905982b0e9$var$p;
$bc0ae8905982b0e9$export$92387174baf9b227 = function(a) {
    return $bc0ae8905982b0e9$var$A(a) || $bc0ae8905982b0e9$var$z(a) === $bc0ae8905982b0e9$var$l;
};
$bc0ae8905982b0e9$export$ec112efeb987d9c6 = $bc0ae8905982b0e9$var$A;
$bc0ae8905982b0e9$export$b706b080d889d2c9 = function(a) {
    return $bc0ae8905982b0e9$var$z(a) === $bc0ae8905982b0e9$var$k;
};
$bc0ae8905982b0e9$export$5be5a87408f70ddc = function(a) {
    return $bc0ae8905982b0e9$var$z(a) === $bc0ae8905982b0e9$var$h;
};
$bc0ae8905982b0e9$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bc0ae8905982b0e9$var$c;
};
$bc0ae8905982b0e9$export$455c2e768291efa6 = function(a) {
    return $bc0ae8905982b0e9$var$z(a) === $bc0ae8905982b0e9$var$n;
};
$bc0ae8905982b0e9$export$9522e17588c12572 = function(a) {
    return $bc0ae8905982b0e9$var$z(a) === $bc0ae8905982b0e9$var$e;
};
$bc0ae8905982b0e9$export$2110ac352bb060b9 = function(a) {
    return $bc0ae8905982b0e9$var$z(a) === $bc0ae8905982b0e9$var$t;
};
$bc0ae8905982b0e9$export$56885ab8b9c456ab = function(a) {
    return $bc0ae8905982b0e9$var$z(a) === $bc0ae8905982b0e9$var$r;
};
$bc0ae8905982b0e9$export$d927fcb6adf8f9de = function(a) {
    return $bc0ae8905982b0e9$var$z(a) === $bc0ae8905982b0e9$var$d;
};
$bc0ae8905982b0e9$export$b82d16f27459e05a = function(a) {
    return $bc0ae8905982b0e9$var$z(a) === $bc0ae8905982b0e9$var$g;
};
$bc0ae8905982b0e9$export$522c17b4f5e123e8 = function(a) {
    return $bc0ae8905982b0e9$var$z(a) === $bc0ae8905982b0e9$var$f;
};
$bc0ae8905982b0e9$export$1aabd8a0274ecfd6 = function(a) {
    return $bc0ae8905982b0e9$var$z(a) === $bc0ae8905982b0e9$var$p;
};
$bc0ae8905982b0e9$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $bc0ae8905982b0e9$var$e || a === $bc0ae8905982b0e9$var$m || a === $bc0ae8905982b0e9$var$g || a === $bc0ae8905982b0e9$var$f || a === $bc0ae8905982b0e9$var$p || a === $bc0ae8905982b0e9$var$q || "object" === typeof a && null !== a && (a.$$typeof === $bc0ae8905982b0e9$var$t || a.$$typeof === $bc0ae8905982b0e9$var$r || a.$$typeof === $bc0ae8905982b0e9$var$h || a.$$typeof === $bc0ae8905982b0e9$var$k || a.$$typeof === $bc0ae8905982b0e9$var$n || a.$$typeof === $bc0ae8905982b0e9$var$w || a.$$typeof === $bc0ae8905982b0e9$var$x || a.$$typeof === $bc0ae8905982b0e9$var$y || a.$$typeof === $bc0ae8905982b0e9$var$v);
};
$bc0ae8905982b0e9$export$f5bbd400c2f4426f = $bc0ae8905982b0e9$var$z;

});

parcelRegister("icW8m", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $d416712c7616e3dd$export$a7c73072b1a182ae; }, function (v) { return $d416712c7616e3dd$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $d416712c7616e3dd$export$9f27bc3417b4524d; }, function (v) { return $d416712c7616e3dd$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $d416712c7616e3dd$export$db77ccec0bb4ccac; }, function (v) { return $d416712c7616e3dd$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $d416712c7616e3dd$export$8392c0c9d3dcbd35; }, function (v) { return $d416712c7616e3dd$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d416712c7616e3dd$export$ffb0004e005737fa; }, function (v) { return $d416712c7616e3dd$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $d416712c7616e3dd$export$b624eff549462981; }, function (v) { return $d416712c7616e3dd$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $d416712c7616e3dd$export$7897aa7841a5380c; }, function (v) { return $d416712c7616e3dd$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $d416712c7616e3dd$export$602eac185826482c; }, function (v) { return $d416712c7616e3dd$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $d416712c7616e3dd$export$e2c29f18771995cb; }, function (v) { return $d416712c7616e3dd$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d416712c7616e3dd$export$5f8d39834fd61797; }, function (v) { return $d416712c7616e3dd$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d416712c7616e3dd$export$74bf444e3cd11ea5; }, function (v) { return $d416712c7616e3dd$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $d416712c7616e3dd$export$92387174baf9b227; }, function (v) { return $d416712c7616e3dd$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $d416712c7616e3dd$export$ec112efeb987d9c6; }, function (v) { return $d416712c7616e3dd$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $d416712c7616e3dd$export$b706b080d889d2c9; }, function (v) { return $d416712c7616e3dd$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $d416712c7616e3dd$export$5be5a87408f70ddc; }, function (v) { return $d416712c7616e3dd$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $d416712c7616e3dd$export$45a5e7f76e0caa8d; }, function (v) { return $d416712c7616e3dd$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $d416712c7616e3dd$export$455c2e768291efa6; }, function (v) { return $d416712c7616e3dd$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $d416712c7616e3dd$export$9522e17588c12572; }, function (v) { return $d416712c7616e3dd$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $d416712c7616e3dd$export$2110ac352bb060b9; }, function (v) { return $d416712c7616e3dd$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $d416712c7616e3dd$export$56885ab8b9c456ab; }, function (v) { return $d416712c7616e3dd$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $d416712c7616e3dd$export$d927fcb6adf8f9de; }, function (v) { return $d416712c7616e3dd$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $d416712c7616e3dd$export$b82d16f27459e05a; }, function (v) { return $d416712c7616e3dd$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $d416712c7616e3dd$export$522c17b4f5e123e8; }, function (v) { return $d416712c7616e3dd$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $d416712c7616e3dd$export$1aabd8a0274ecfd6; }, function (v) { return $d416712c7616e3dd$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $d416712c7616e3dd$export$9b621391a187a31a; }, function (v) { return $d416712c7616e3dd$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $d416712c7616e3dd$export$f5bbd400c2f4426f; }, function (v) { return $d416712c7616e3dd$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d416712c7616e3dd$export$a7c73072b1a182ae;
var $d416712c7616e3dd$export$9f27bc3417b4524d;
var $d416712c7616e3dd$export$db77ccec0bb4ccac;
var $d416712c7616e3dd$export$8392c0c9d3dcbd35;
var $d416712c7616e3dd$export$ffb0004e005737fa;
var $d416712c7616e3dd$export$b624eff549462981;
var $d416712c7616e3dd$export$7897aa7841a5380c;
var $d416712c7616e3dd$export$602eac185826482c;
var $d416712c7616e3dd$export$e2c29f18771995cb;
var $d416712c7616e3dd$export$5f8d39834fd61797;
var $d416712c7616e3dd$export$74bf444e3cd11ea5;
var $d416712c7616e3dd$export$92387174baf9b227;
var $d416712c7616e3dd$export$ec112efeb987d9c6;
var $d416712c7616e3dd$export$b706b080d889d2c9;
var $d416712c7616e3dd$export$5be5a87408f70ddc;
var $d416712c7616e3dd$export$45a5e7f76e0caa8d;
var $d416712c7616e3dd$export$455c2e768291efa6;
var $d416712c7616e3dd$export$9522e17588c12572;
var $d416712c7616e3dd$export$2110ac352bb060b9;
var $d416712c7616e3dd$export$56885ab8b9c456ab;
var $d416712c7616e3dd$export$d927fcb6adf8f9de;
var $d416712c7616e3dd$export$b82d16f27459e05a;
var $d416712c7616e3dd$export$522c17b4f5e123e8;
var $d416712c7616e3dd$export$1aabd8a0274ecfd6;
var $d416712c7616e3dd$export$9b621391a187a31a;
var $d416712c7616e3dd$export$f5bbd400c2f4426f;
'use strict';
var $d416712c7616e3dd$var$b = 60103, $d416712c7616e3dd$var$c = 60106, $d416712c7616e3dd$var$d = 60107, $d416712c7616e3dd$var$e = 60108, $d416712c7616e3dd$var$f = 60114, $d416712c7616e3dd$var$g = 60109, $d416712c7616e3dd$var$h = 60110, $d416712c7616e3dd$var$k = 60112, $d416712c7616e3dd$var$l = 60113, $d416712c7616e3dd$var$m = 60120, $d416712c7616e3dd$var$n = 60115, $d416712c7616e3dd$var$p = 60116, $d416712c7616e3dd$var$q = 60121, $d416712c7616e3dd$var$r = 60122, $d416712c7616e3dd$var$u = 60117, $d416712c7616e3dd$var$v = 60129, $d416712c7616e3dd$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $d416712c7616e3dd$var$x = Symbol.for;
    $d416712c7616e3dd$var$b = $d416712c7616e3dd$var$x("react.element");
    $d416712c7616e3dd$var$c = $d416712c7616e3dd$var$x("react.portal");
    $d416712c7616e3dd$var$d = $d416712c7616e3dd$var$x("react.fragment");
    $d416712c7616e3dd$var$e = $d416712c7616e3dd$var$x("react.strict_mode");
    $d416712c7616e3dd$var$f = $d416712c7616e3dd$var$x("react.profiler");
    $d416712c7616e3dd$var$g = $d416712c7616e3dd$var$x("react.provider");
    $d416712c7616e3dd$var$h = $d416712c7616e3dd$var$x("react.context");
    $d416712c7616e3dd$var$k = $d416712c7616e3dd$var$x("react.forward_ref");
    $d416712c7616e3dd$var$l = $d416712c7616e3dd$var$x("react.suspense");
    $d416712c7616e3dd$var$m = $d416712c7616e3dd$var$x("react.suspense_list");
    $d416712c7616e3dd$var$n = $d416712c7616e3dd$var$x("react.memo");
    $d416712c7616e3dd$var$p = $d416712c7616e3dd$var$x("react.lazy");
    $d416712c7616e3dd$var$q = $d416712c7616e3dd$var$x("react.block");
    $d416712c7616e3dd$var$r = $d416712c7616e3dd$var$x("react.server.block");
    $d416712c7616e3dd$var$u = $d416712c7616e3dd$var$x("react.fundamental");
    $d416712c7616e3dd$var$v = $d416712c7616e3dd$var$x("react.debug_trace_mode");
    $d416712c7616e3dd$var$w = $d416712c7616e3dd$var$x("react.legacy_hidden");
}
function $d416712c7616e3dd$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $d416712c7616e3dd$var$b:
                switch(a = a.type, a){
                    case $d416712c7616e3dd$var$d:
                    case $d416712c7616e3dd$var$f:
                    case $d416712c7616e3dd$var$e:
                    case $d416712c7616e3dd$var$l:
                    case $d416712c7616e3dd$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $d416712c7616e3dd$var$h:
                            case $d416712c7616e3dd$var$k:
                            case $d416712c7616e3dd$var$p:
                            case $d416712c7616e3dd$var$n:
                            case $d416712c7616e3dd$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $d416712c7616e3dd$var$c:
                return t;
        }
    }
}
var $d416712c7616e3dd$var$z = $d416712c7616e3dd$var$g, $d416712c7616e3dd$var$A = $d416712c7616e3dd$var$b, $d416712c7616e3dd$var$B = $d416712c7616e3dd$var$k, $d416712c7616e3dd$var$C = $d416712c7616e3dd$var$d, $d416712c7616e3dd$var$D = $d416712c7616e3dd$var$p, $d416712c7616e3dd$var$E = $d416712c7616e3dd$var$n, $d416712c7616e3dd$var$F = $d416712c7616e3dd$var$c, $d416712c7616e3dd$var$G = $d416712c7616e3dd$var$f, $d416712c7616e3dd$var$H = $d416712c7616e3dd$var$e, $d416712c7616e3dd$var$I = $d416712c7616e3dd$var$l;
$d416712c7616e3dd$export$a7c73072b1a182ae = $d416712c7616e3dd$var$h;
$d416712c7616e3dd$export$9f27bc3417b4524d = $d416712c7616e3dd$var$z;
$d416712c7616e3dd$export$db77ccec0bb4ccac = $d416712c7616e3dd$var$A;
$d416712c7616e3dd$export$8392c0c9d3dcbd35 = $d416712c7616e3dd$var$B;
$d416712c7616e3dd$export$ffb0004e005737fa = $d416712c7616e3dd$var$C;
$d416712c7616e3dd$export$b624eff549462981 = $d416712c7616e3dd$var$D;
$d416712c7616e3dd$export$7897aa7841a5380c = $d416712c7616e3dd$var$E;
$d416712c7616e3dd$export$602eac185826482c = $d416712c7616e3dd$var$F;
$d416712c7616e3dd$export$e2c29f18771995cb = $d416712c7616e3dd$var$G;
$d416712c7616e3dd$export$5f8d39834fd61797 = $d416712c7616e3dd$var$H;
$d416712c7616e3dd$export$74bf444e3cd11ea5 = $d416712c7616e3dd$var$I;
$d416712c7616e3dd$export$92387174baf9b227 = function() {
    return !1;
};
$d416712c7616e3dd$export$ec112efeb987d9c6 = function() {
    return !1;
};
$d416712c7616e3dd$export$b706b080d889d2c9 = function(a) {
    return $d416712c7616e3dd$var$y(a) === $d416712c7616e3dd$var$h;
};
$d416712c7616e3dd$export$5be5a87408f70ddc = function(a) {
    return $d416712c7616e3dd$var$y(a) === $d416712c7616e3dd$var$g;
};
$d416712c7616e3dd$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d416712c7616e3dd$var$b;
};
$d416712c7616e3dd$export$455c2e768291efa6 = function(a) {
    return $d416712c7616e3dd$var$y(a) === $d416712c7616e3dd$var$k;
};
$d416712c7616e3dd$export$9522e17588c12572 = function(a) {
    return $d416712c7616e3dd$var$y(a) === $d416712c7616e3dd$var$d;
};
$d416712c7616e3dd$export$2110ac352bb060b9 = function(a) {
    return $d416712c7616e3dd$var$y(a) === $d416712c7616e3dd$var$p;
};
$d416712c7616e3dd$export$56885ab8b9c456ab = function(a) {
    return $d416712c7616e3dd$var$y(a) === $d416712c7616e3dd$var$n;
};
$d416712c7616e3dd$export$d927fcb6adf8f9de = function(a) {
    return $d416712c7616e3dd$var$y(a) === $d416712c7616e3dd$var$c;
};
$d416712c7616e3dd$export$b82d16f27459e05a = function(a) {
    return $d416712c7616e3dd$var$y(a) === $d416712c7616e3dd$var$f;
};
$d416712c7616e3dd$export$522c17b4f5e123e8 = function(a) {
    return $d416712c7616e3dd$var$y(a) === $d416712c7616e3dd$var$e;
};
$d416712c7616e3dd$export$1aabd8a0274ecfd6 = function(a) {
    return $d416712c7616e3dd$var$y(a) === $d416712c7616e3dd$var$l;
};
$d416712c7616e3dd$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $d416712c7616e3dd$var$d || a === $d416712c7616e3dd$var$f || a === $d416712c7616e3dd$var$v || a === $d416712c7616e3dd$var$e || a === $d416712c7616e3dd$var$l || a === $d416712c7616e3dd$var$m || a === $d416712c7616e3dd$var$w || "object" === typeof a && null !== a && (a.$$typeof === $d416712c7616e3dd$var$p || a.$$typeof === $d416712c7616e3dd$var$n || a.$$typeof === $d416712c7616e3dd$var$g || a.$$typeof === $d416712c7616e3dd$var$h || a.$$typeof === $d416712c7616e3dd$var$k || a.$$typeof === $d416712c7616e3dd$var$u || a.$$typeof === $d416712c7616e3dd$var$q || a[0] === $d416712c7616e3dd$var$r) ? !0 : !1;
};
$d416712c7616e3dd$export$f5bbd400c2f4426f = $d416712c7616e3dd$var$y;

});

parcelRegister("6CbLG", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return dateTimestampInSeconds; });
$parcel$export(module.exports, "timestampInSeconds", function () { return timestampInSeconds; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return browserPerformanceTimeOrigin; });

var $iZbO1 = parcelRequire("iZbO1");

var $9avcL = parcelRequire("9avcL");
// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0, $9avcL.getGlobalObject)();
/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */ /**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ const dateTimestampSource = {
    nowSeconds: ()=>Date.now() / 1000
};
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    const { performance } = WINDOW;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    const timeOrigin = Date.now() - performance.now();
    return {
        now: ()=>performance.now(),
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        const perfHooks = (0, $iZbO1.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ const platformPerformance = (0, $iZbO1.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
const timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: ()=>(platformPerformance.timeOrigin + platformPerformance.now()) / 1000
};
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */ const usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const browserPerformanceTimeOrigin = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance } = WINDOW;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
})();

});
parcelRegister("iZbO1", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });
$parcel$export(module.exports, "dynamicRequire", function () { return dynamicRequire; });

var $102SM = parcelRequire("102SM");

var $8LKEK = parcelRequire("8LKEK");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $102SM.isBrowserBundle)() && Object.prototype.toString.call(typeof $8LKEK !== 'undefined' ? $8LKEK : 0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, 'process');
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("102SM", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $0ba806ebb7470804$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $0ba806ebb7470804$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $0ba806ebb7470804$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $0ba806ebb7470804$export$8ad33f488b1ab046() {
    // @ts-ignore "npm" is injected by rollup during build process
    return "npm";
}

});


parcelRegister("9avcL", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $6acd40dd224f58f7$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $6acd40dd224f58f7$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $6acd40dd224f58f7$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $6acd40dd224f58f7$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $6acd40dd224f58f7$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $6acd40dd224f58f7$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $6acd40dd224f58f7$var$isGlobalObj(window) || typeof self == 'object' && $6acd40dd224f58f7$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $6acd40dd224f58f7$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $6acd40dd224f58f7$export$256479dc0cea61c4() {
    return $6acd40dd224f58f7$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $6acd40dd224f58f7$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $6acd40dd224f58f7$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("fEoMa", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return D; });
$parcel$export(module.exports, "enableES5", function () { return N; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $b64dcf6b4cc848d0$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? (n.delete(r), n.add(t)) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) ? n : (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0), n);
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function O(n) {
    g(n), n.p.forEach(S), n.p = null;
}
function g(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.O = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.g || b("ES5").S(e, r, o), o ? (i[Q].P && (O(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), O(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o;
        i(3 === e.i ? new Set(o) : o, function(r, i) {
            return A(n, e, o, r, i, t);
        }), x(n, o, !1), t && n.u && b("Patches").R(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s) {
    if (r(c)) {
        var v = M(e, c, s && i && 3 !== i.i && !u(i.D, a) ? s.concat(a) : void 0);
        if (f(o, a, v), !r(v)) return;
        e.m = !1;
    }
    if (t(c) && !y(c)) {
        if (!e.h.F && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), n.h.F && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function R(n, r, t) {
    var e = s(r) ? b("MapSet").N(r, t) : v(r) ? b("MapSet").T(r, t) : n.g ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            D: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function D(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = F(r, c), u.I = !1;
        } else e = F(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function F(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function N() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.O && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                D: {},
                l: r,
                t: n,
                k: i,
                o: null,
                O: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.D, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = "" + i[s];
                    0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        R: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.D, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.D, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.D = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = R(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.O && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                D: void 0,
                t: n,
                k: this,
                C: !1,
                O: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.D.set(n, !0), t.o.set(n, r), t.D.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.D.set(n, !1) : r.D.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.D = new Map, i(n.t, function(r) {
                n.D.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = R(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                O: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        N: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    N(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = R(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.D[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && "number" != typeof t && (void 0 !== t || r in n.o) || (n.o[r] = t, n.D[r] = !0, !0);
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.D[r] = !1, E(n), k(n)) : delete n.D[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.g = B, this.F = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = R(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? O(c) : g(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw O(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.F && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = D(e));
        var i = w(this), o = R(this, e, void 0);
        return o[Q].C = !0, g(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.F = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.g = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $b64dcf6b4cc848d0$export$2e2bcd8739ae039 = fn;

});

parcelRegister("49ujK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $305f8522f4fcc350$export$1e511d4a378977f5; }, function (v) { return $305f8522f4fcc350$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $305f8522f4fcc350$export$2e2bcd8739ae039; }, function (v) { return $305f8522f4fcc350$export$2e2bcd8739ae039 = v; });
var $305f8522f4fcc350$export$1e511d4a378977f5;
var $305f8522f4fcc350$export$2e2bcd8739ae039;
"use strict";
$305f8522f4fcc350$export$1e511d4a378977f5 = true;
$305f8522f4fcc350$export$2e2bcd8739ae039 = $305f8522f4fcc350$var$createWebStorage;

var $305f8522f4fcc350$var$_getStorage = $305f8522f4fcc350$var$_interopRequireDefault((parcelRequire("dHzP2")));
function $305f8522f4fcc350$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $305f8522f4fcc350$var$createWebStorage(type) {
    var storage = (0, $305f8522f4fcc350$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRegister("dHzP2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $9f9b14150b6dbd0c$export$1e511d4a378977f5; }, function (v) { return $9f9b14150b6dbd0c$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $9f9b14150b6dbd0c$export$2e2bcd8739ae039; }, function (v) { return $9f9b14150b6dbd0c$export$2e2bcd8739ae039 = v; });
var $9f9b14150b6dbd0c$export$1e511d4a378977f5;
var $9f9b14150b6dbd0c$export$2e2bcd8739ae039;
"use strict";
$9f9b14150b6dbd0c$export$1e511d4a378977f5 = true;
$9f9b14150b6dbd0c$export$2e2bcd8739ae039 = $9f9b14150b6dbd0c$var$getStorage;
function $9f9b14150b6dbd0c$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9f9b14150b6dbd0c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9f9b14150b6dbd0c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9f9b14150b6dbd0c$var$_typeof(obj);
}
function $9f9b14150b6dbd0c$var$noop() {}
var $9f9b14150b6dbd0c$var$noopStorage = {
    getItem: $9f9b14150b6dbd0c$var$noop,
    setItem: $9f9b14150b6dbd0c$var$noop,
    removeItem: $9f9b14150b6dbd0c$var$noop
};
function $9f9b14150b6dbd0c$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $9f9b14150b6dbd0c$var$_typeof(self)) !== 'object' || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, 'test');
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $9f9b14150b6dbd0c$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($9f9b14150b6dbd0c$var$hasStorage(storageType)) return self[storageType];
    else return $9f9b14150b6dbd0c$var$noopStorage;
}

});


parcelRegister("i5UNc", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("9wyTk", function(module, exports) {
/* global window */ 
var $6goTd = parcelRequire("6goTd");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $6goTd.default)(root);
var $6ef22aef01f48800$export$2e2bcd8739ae039 = result;

});
parcelRegister("6goTd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48f78b3aab3ce3fa$export$2e2bcd8739ae039; });
function $48f78b3aab3ce3fa$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === 'function') // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for('https://github.com/benlesh/symbol-observable');
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol('https://github.com/benlesh/symbol-observable');
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("fActo", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("h13av", function(module, exports) {

var $dxEkO = parcelRequire("dxEkO");

var $inUVE = parcelRequire("inUVE");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $c634fcd60682ef25$var$camelCase = $inUVE(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $dxEkO(word) : word);
});
module.exports = $c634fcd60682ef25$var$camelCase;

});
parcelRegister("dxEkO", function(module, exports) {

var $9hRhZ = parcelRequire("9hRhZ");

var $eGIdK = parcelRequire("eGIdK");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $9dbda5146943e12f$var$capitalize(string) {
    return $eGIdK($9hRhZ(string).toLowerCase());
}
module.exports = $9dbda5146943e12f$var$capitalize;

});
parcelRegister("9hRhZ", function(module, exports) {

var $3rofy = parcelRequire("3rofy");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $6c2f09b0d553217b$var$toString(value) {
    return value == null ? '' : $3rofy(value);
}
module.exports = $6c2f09b0d553217b$var$toString;

});
parcelRegister("3rofy", function(module, exports) {

var $az0v2 = parcelRequire("az0v2");

var $isWDR = parcelRequire("isWDR");

var $3SBIi = parcelRequire("3SBIi");

var $87L1g = parcelRequire("87L1g");
/** Used as references for various `Number` constants. */ var $2816b4375e331840$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $2816b4375e331840$var$symbolProto = $az0v2 ? $az0v2.prototype : undefined, $2816b4375e331840$var$symbolToString = $2816b4375e331840$var$symbolProto ? $2816b4375e331840$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $2816b4375e331840$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($3SBIi(value)) // Recursively convert values (susceptible to call stack limits).
    return $isWDR(value, $2816b4375e331840$var$baseToString) + '';
    if ($87L1g(value)) return $2816b4375e331840$var$symbolToString ? $2816b4375e331840$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$2816b4375e331840$var$INFINITY ? '-0' : result;
}
module.exports = $2816b4375e331840$var$baseToString;

});
parcelRegister("az0v2", function(module, exports) {

var $kqNAI = parcelRequire("kqNAI");
/** Built-in value references. */ var $7b0d8f811b934fe4$var$Symbol = $kqNAI.Symbol;
module.exports = $7b0d8f811b934fe4$var$Symbol;

});
parcelRegister("kqNAI", function(module, exports) {

var $2lvAs = parcelRequire("2lvAs");
/** Detect free variable `self`. */ var $edfcb4212feb6e68$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $edfcb4212feb6e68$var$root = $2lvAs || $edfcb4212feb6e68$var$freeSelf || Function('return this')();
module.exports = $edfcb4212feb6e68$var$root;

});
parcelRegister("2lvAs", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $1b560b6ff1ca742d$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $1b560b6ff1ca742d$var$freeGlobal;

});



parcelRegister("isWDR", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d71854902fcda119$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $d71854902fcda119$var$arrayMap;

});

parcelRegister("3SBIi", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $2d33ab5c825c2f3f$var$isArray = Array.isArray;
module.exports = $2d33ab5c825c2f3f$var$isArray;

});

parcelRegister("87L1g", function(module, exports) {

var $euXSx = parcelRequire("euXSx");

var $dPKCC = parcelRequire("dPKCC");
/** `Object#toString` result references. */ var $5ea3733d7326614f$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5ea3733d7326614f$var$isSymbol(value) {
    return typeof value == 'symbol' || $dPKCC(value) && $euXSx(value) == $5ea3733d7326614f$var$symbolTag;
}
module.exports = $5ea3733d7326614f$var$isSymbol;

});
parcelRegister("euXSx", function(module, exports) {

var $az0v2 = parcelRequire("az0v2");

var $jHTYo = parcelRequire("jHTYo");

var $1gp7l = parcelRequire("1gp7l");
/** `Object#toString` result references. */ var $a8e250b3fe0a5227$var$nullTag = '[object Null]', $a8e250b3fe0a5227$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a8e250b3fe0a5227$var$symToStringTag = $az0v2 ? $az0v2.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a8e250b3fe0a5227$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a8e250b3fe0a5227$var$undefinedTag : $a8e250b3fe0a5227$var$nullTag;
    return $a8e250b3fe0a5227$var$symToStringTag && $a8e250b3fe0a5227$var$symToStringTag in Object(value) ? $jHTYo(value) : $1gp7l(value);
}
module.exports = $a8e250b3fe0a5227$var$baseGetTag;

});
parcelRegister("jHTYo", function(module, exports) {

var $az0v2 = parcelRequire("az0v2");
/** Used for built-in method references. */ var $e58d739045b74368$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e58d739045b74368$var$hasOwnProperty = $e58d739045b74368$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e58d739045b74368$var$nativeObjectToString = $e58d739045b74368$var$objectProto.toString;
/** Built-in value references. */ var $e58d739045b74368$var$symToStringTag = $az0v2 ? $az0v2.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $e58d739045b74368$var$getRawTag(value) {
    var isOwn = $e58d739045b74368$var$hasOwnProperty.call(value, $e58d739045b74368$var$symToStringTag), tag = value[$e58d739045b74368$var$symToStringTag];
    try {
        value[$e58d739045b74368$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $e58d739045b74368$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$e58d739045b74368$var$symToStringTag] = tag;
        else delete value[$e58d739045b74368$var$symToStringTag];
    }
    return result;
}
module.exports = $e58d739045b74368$var$getRawTag;

});

parcelRegister("1gp7l", function(module, exports) {
/** Used for built-in method references. */ var $0ebac4df149aa95c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0ebac4df149aa95c$var$nativeObjectToString = $0ebac4df149aa95c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $0ebac4df149aa95c$var$objectToString(value) {
    return $0ebac4df149aa95c$var$nativeObjectToString.call(value);
}
module.exports = $0ebac4df149aa95c$var$objectToString;

});


parcelRegister("dPKCC", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $a12433eb24168020$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $a12433eb24168020$var$isObjectLike;

});




parcelRegister("eGIdK", function(module, exports) {

var $1bpkR = parcelRequire("1bpkR");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $ab174a4486b12f08$var$upperFirst = $1bpkR('toUpperCase');
module.exports = $ab174a4486b12f08$var$upperFirst;

});
parcelRegister("1bpkR", function(module, exports) {

var $8mst1 = parcelRequire("8mst1");

var $2212c = parcelRequire("2212c");

var $l1tWD = parcelRequire("l1tWD");

var $9hRhZ = parcelRequire("9hRhZ");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $0dca78a05be6d9f5$var$createCaseFirst(methodName) {
    return function(string) {
        string = $9hRhZ(string);
        var strSymbols = $2212c(string) ? $l1tWD(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $8mst1(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $0dca78a05be6d9f5$var$createCaseFirst;

});
parcelRegister("8mst1", function(module, exports) {

var $hgj8Y = parcelRequire("hgj8Y");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $616675ca7640214f$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $hgj8Y(array, start, end);
}
module.exports = $616675ca7640214f$var$castSlice;

});
parcelRegister("hgj8Y", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $c912c7d451340eaa$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $c912c7d451340eaa$var$baseSlice;

});


parcelRegister("2212c", function(module, exports) {
/** Used to compose unicode character classes. */ var $17ac92196e4af692$var$rsAstralRange = '\\ud800-\\udfff', $17ac92196e4af692$var$rsComboMarksRange = '\\u0300-\\u036f', $17ac92196e4af692$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $17ac92196e4af692$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $17ac92196e4af692$var$rsComboRange = $17ac92196e4af692$var$rsComboMarksRange + $17ac92196e4af692$var$reComboHalfMarksRange + $17ac92196e4af692$var$rsComboSymbolsRange, $17ac92196e4af692$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $17ac92196e4af692$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $17ac92196e4af692$var$reHasUnicode = RegExp('[' + $17ac92196e4af692$var$rsZWJ + $17ac92196e4af692$var$rsAstralRange + $17ac92196e4af692$var$rsComboRange + $17ac92196e4af692$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $17ac92196e4af692$var$hasUnicode(string) {
    return $17ac92196e4af692$var$reHasUnicode.test(string);
}
module.exports = $17ac92196e4af692$var$hasUnicode;

});

parcelRegister("l1tWD", function(module, exports) {

var $eaaL6 = parcelRequire("eaaL6");

var $2212c = parcelRequire("2212c");

var $fGhko = parcelRequire("fGhko");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $f4e0eb63fe903c00$var$stringToArray(string) {
    return $2212c(string) ? $fGhko(string) : $eaaL6(string);
}
module.exports = $f4e0eb63fe903c00$var$stringToArray;

});
parcelRegister("eaaL6", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $a4fa585514bdd967$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $a4fa585514bdd967$var$asciiToArray;

});

parcelRegister("fGhko", function(module, exports) {
/** Used to compose unicode character classes. */ var $b6a8383e0dc46956$var$rsAstralRange = '\\ud800-\\udfff', $b6a8383e0dc46956$var$rsComboMarksRange = '\\u0300-\\u036f', $b6a8383e0dc46956$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $b6a8383e0dc46956$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $b6a8383e0dc46956$var$rsComboRange = $b6a8383e0dc46956$var$rsComboMarksRange + $b6a8383e0dc46956$var$reComboHalfMarksRange + $b6a8383e0dc46956$var$rsComboSymbolsRange, $b6a8383e0dc46956$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $b6a8383e0dc46956$var$rsAstral = '[' + $b6a8383e0dc46956$var$rsAstralRange + ']', $b6a8383e0dc46956$var$rsCombo = '[' + $b6a8383e0dc46956$var$rsComboRange + ']', $b6a8383e0dc46956$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $b6a8383e0dc46956$var$rsModifier = '(?:' + $b6a8383e0dc46956$var$rsCombo + '|' + $b6a8383e0dc46956$var$rsFitz + ')', $b6a8383e0dc46956$var$rsNonAstral = '[^' + $b6a8383e0dc46956$var$rsAstralRange + ']', $b6a8383e0dc46956$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $b6a8383e0dc46956$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $b6a8383e0dc46956$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $b6a8383e0dc46956$var$reOptMod = $b6a8383e0dc46956$var$rsModifier + '?', $b6a8383e0dc46956$var$rsOptVar = '[' + $b6a8383e0dc46956$var$rsVarRange + ']?', $b6a8383e0dc46956$var$rsOptJoin = '(?:' + $b6a8383e0dc46956$var$rsZWJ + '(?:' + [
    $b6a8383e0dc46956$var$rsNonAstral,
    $b6a8383e0dc46956$var$rsRegional,
    $b6a8383e0dc46956$var$rsSurrPair
].join('|') + ')' + $b6a8383e0dc46956$var$rsOptVar + $b6a8383e0dc46956$var$reOptMod + ')*', $b6a8383e0dc46956$var$rsSeq = $b6a8383e0dc46956$var$rsOptVar + $b6a8383e0dc46956$var$reOptMod + $b6a8383e0dc46956$var$rsOptJoin, $b6a8383e0dc46956$var$rsSymbol = '(?:' + [
    $b6a8383e0dc46956$var$rsNonAstral + $b6a8383e0dc46956$var$rsCombo + '?',
    $b6a8383e0dc46956$var$rsCombo,
    $b6a8383e0dc46956$var$rsRegional,
    $b6a8383e0dc46956$var$rsSurrPair,
    $b6a8383e0dc46956$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $b6a8383e0dc46956$var$reUnicode = RegExp($b6a8383e0dc46956$var$rsFitz + '(?=' + $b6a8383e0dc46956$var$rsFitz + ')|' + $b6a8383e0dc46956$var$rsSymbol + $b6a8383e0dc46956$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $b6a8383e0dc46956$var$unicodeToArray(string) {
    return string.match($b6a8383e0dc46956$var$reUnicode) || [];
}
module.exports = $b6a8383e0dc46956$var$unicodeToArray;

});





parcelRegister("inUVE", function(module, exports) {

var $4Q4q9 = parcelRequire("4Q4q9");

var $8OB6y = parcelRequire("8OB6y");

var $lTD65 = parcelRequire("lTD65");
/** Used to compose unicode capture groups. */ var $d62688e13912d40e$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $d62688e13912d40e$var$reApos = RegExp($d62688e13912d40e$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $d62688e13912d40e$var$createCompounder(callback) {
    return function(string) {
        return $4Q4q9($lTD65($8OB6y(string).replace($d62688e13912d40e$var$reApos, '')), callback, '');
    };
}
module.exports = $d62688e13912d40e$var$createCompounder;

});
parcelRegister("4Q4q9", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $385f72a2187ffb42$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $385f72a2187ffb42$var$arrayReduce;

});

parcelRegister("8OB6y", function(module, exports) {

var $dV9in = parcelRequire("dV9in");

var $9hRhZ = parcelRequire("9hRhZ");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $66afc67c7e90edde$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $66afc67c7e90edde$var$rsComboMarksRange = '\\u0300-\\u036f', $66afc67c7e90edde$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $66afc67c7e90edde$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $66afc67c7e90edde$var$rsComboRange = $66afc67c7e90edde$var$rsComboMarksRange + $66afc67c7e90edde$var$reComboHalfMarksRange + $66afc67c7e90edde$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $66afc67c7e90edde$var$rsCombo = '[' + $66afc67c7e90edde$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $66afc67c7e90edde$var$reComboMark = RegExp($66afc67c7e90edde$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $66afc67c7e90edde$var$deburr(string) {
    string = $9hRhZ(string);
    return string && string.replace($66afc67c7e90edde$var$reLatin, $dV9in).replace($66afc67c7e90edde$var$reComboMark, '');
}
module.exports = $66afc67c7e90edde$var$deburr;

});
parcelRegister("dV9in", function(module, exports) {

var $5WSyd = parcelRequire("5WSyd");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $a227cf181bd1b111$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $a227cf181bd1b111$var$deburrLetter = $5WSyd($a227cf181bd1b111$var$deburredLetters);
module.exports = $a227cf181bd1b111$var$deburrLetter;

});
parcelRegister("5WSyd", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $454caf30fd4142b5$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $454caf30fd4142b5$var$basePropertyOf;

});



parcelRegister("lTD65", function(module, exports) {

var $c1J2i = parcelRequire("c1J2i");

var $8Pg8I = parcelRequire("8Pg8I");

var $9hRhZ = parcelRequire("9hRhZ");

var $9EkA8 = parcelRequire("9EkA8");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $ff0d0fed666e9562$var$words(string, pattern, guard) {
    string = $9hRhZ(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $8Pg8I(string) ? $9EkA8(string) : $c1J2i(string);
    return string.match(pattern) || [];
}
module.exports = $ff0d0fed666e9562$var$words;

});
parcelRegister("c1J2i", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $8c18833aec66c56e$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $8c18833aec66c56e$var$asciiWords(string) {
    return string.match($8c18833aec66c56e$var$reAsciiWord) || [];
}
module.exports = $8c18833aec66c56e$var$asciiWords;

});

parcelRegister("8Pg8I", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $66cf9b258fdad8ed$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $66cf9b258fdad8ed$var$hasUnicodeWord(string) {
    return $66cf9b258fdad8ed$var$reHasUnicodeWord.test(string);
}
module.exports = $66cf9b258fdad8ed$var$hasUnicodeWord;

});

parcelRegister("9EkA8", function(module, exports) {
/** Used to compose unicode character classes. */ var $7067d096e971c1ed$var$rsAstralRange = '\\ud800-\\udfff', $7067d096e971c1ed$var$rsComboMarksRange = '\\u0300-\\u036f', $7067d096e971c1ed$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $7067d096e971c1ed$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $7067d096e971c1ed$var$rsComboRange = $7067d096e971c1ed$var$rsComboMarksRange + $7067d096e971c1ed$var$reComboHalfMarksRange + $7067d096e971c1ed$var$rsComboSymbolsRange, $7067d096e971c1ed$var$rsDingbatRange = '\\u2700-\\u27bf', $7067d096e971c1ed$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $7067d096e971c1ed$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $7067d096e971c1ed$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $7067d096e971c1ed$var$rsPunctuationRange = '\\u2000-\\u206f', $7067d096e971c1ed$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $7067d096e971c1ed$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $7067d096e971c1ed$var$rsVarRange = '\\ufe0e\\ufe0f', $7067d096e971c1ed$var$rsBreakRange = $7067d096e971c1ed$var$rsMathOpRange + $7067d096e971c1ed$var$rsNonCharRange + $7067d096e971c1ed$var$rsPunctuationRange + $7067d096e971c1ed$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $7067d096e971c1ed$var$rsApos = "['\u2019]", $7067d096e971c1ed$var$rsBreak = '[' + $7067d096e971c1ed$var$rsBreakRange + ']', $7067d096e971c1ed$var$rsCombo = '[' + $7067d096e971c1ed$var$rsComboRange + ']', $7067d096e971c1ed$var$rsDigits = '\\d+', $7067d096e971c1ed$var$rsDingbat = '[' + $7067d096e971c1ed$var$rsDingbatRange + ']', $7067d096e971c1ed$var$rsLower = '[' + $7067d096e971c1ed$var$rsLowerRange + ']', $7067d096e971c1ed$var$rsMisc = '[^' + $7067d096e971c1ed$var$rsAstralRange + $7067d096e971c1ed$var$rsBreakRange + $7067d096e971c1ed$var$rsDigits + $7067d096e971c1ed$var$rsDingbatRange + $7067d096e971c1ed$var$rsLowerRange + $7067d096e971c1ed$var$rsUpperRange + ']', $7067d096e971c1ed$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $7067d096e971c1ed$var$rsModifier = '(?:' + $7067d096e971c1ed$var$rsCombo + '|' + $7067d096e971c1ed$var$rsFitz + ')', $7067d096e971c1ed$var$rsNonAstral = '[^' + $7067d096e971c1ed$var$rsAstralRange + ']', $7067d096e971c1ed$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $7067d096e971c1ed$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $7067d096e971c1ed$var$rsUpper = '[' + $7067d096e971c1ed$var$rsUpperRange + ']', $7067d096e971c1ed$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $7067d096e971c1ed$var$rsMiscLower = '(?:' + $7067d096e971c1ed$var$rsLower + '|' + $7067d096e971c1ed$var$rsMisc + ')', $7067d096e971c1ed$var$rsMiscUpper = '(?:' + $7067d096e971c1ed$var$rsUpper + '|' + $7067d096e971c1ed$var$rsMisc + ')', $7067d096e971c1ed$var$rsOptContrLower = '(?:' + $7067d096e971c1ed$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $7067d096e971c1ed$var$rsOptContrUpper = '(?:' + $7067d096e971c1ed$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $7067d096e971c1ed$var$reOptMod = $7067d096e971c1ed$var$rsModifier + '?', $7067d096e971c1ed$var$rsOptVar = '[' + $7067d096e971c1ed$var$rsVarRange + ']?', $7067d096e971c1ed$var$rsOptJoin = '(?:' + $7067d096e971c1ed$var$rsZWJ + '(?:' + [
    $7067d096e971c1ed$var$rsNonAstral,
    $7067d096e971c1ed$var$rsRegional,
    $7067d096e971c1ed$var$rsSurrPair
].join('|') + ')' + $7067d096e971c1ed$var$rsOptVar + $7067d096e971c1ed$var$reOptMod + ')*', $7067d096e971c1ed$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $7067d096e971c1ed$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $7067d096e971c1ed$var$rsSeq = $7067d096e971c1ed$var$rsOptVar + $7067d096e971c1ed$var$reOptMod + $7067d096e971c1ed$var$rsOptJoin, $7067d096e971c1ed$var$rsEmoji = '(?:' + [
    $7067d096e971c1ed$var$rsDingbat,
    $7067d096e971c1ed$var$rsRegional,
    $7067d096e971c1ed$var$rsSurrPair
].join('|') + ')' + $7067d096e971c1ed$var$rsSeq;
/** Used to match complex or compound words. */ var $7067d096e971c1ed$var$reUnicodeWord = RegExp([
    $7067d096e971c1ed$var$rsUpper + '?' + $7067d096e971c1ed$var$rsLower + '+' + $7067d096e971c1ed$var$rsOptContrLower + '(?=' + [
        $7067d096e971c1ed$var$rsBreak,
        $7067d096e971c1ed$var$rsUpper,
        '$'
    ].join('|') + ')',
    $7067d096e971c1ed$var$rsMiscUpper + '+' + $7067d096e971c1ed$var$rsOptContrUpper + '(?=' + [
        $7067d096e971c1ed$var$rsBreak,
        $7067d096e971c1ed$var$rsUpper + $7067d096e971c1ed$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $7067d096e971c1ed$var$rsUpper + '?' + $7067d096e971c1ed$var$rsMiscLower + '+' + $7067d096e971c1ed$var$rsOptContrLower,
    $7067d096e971c1ed$var$rsUpper + '+' + $7067d096e971c1ed$var$rsOptContrUpper,
    $7067d096e971c1ed$var$rsOrdUpper,
    $7067d096e971c1ed$var$rsOrdLower,
    $7067d096e971c1ed$var$rsDigits,
    $7067d096e971c1ed$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $7067d096e971c1ed$var$unicodeWords(string) {
    return string.match($7067d096e971c1ed$var$reUnicodeWord) || [];
}
module.exports = $7067d096e971c1ed$var$unicodeWords;

});




parcelRegister("5EVeC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41ed15d145114bc4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "CSSMotionList", function () { return (parcelRequire("2ZBO2")).default; });

var $eXuaz = parcelRequire("eXuaz");

var $2ZBO2 = parcelRequire("2ZBO2");

var $1fjI4 = parcelRequire("1fjI4");
var $41ed15d145114bc4$export$2e2bcd8739ae039 = (0, $eXuaz.default);

});
parcelRegister("eXuaz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae3dfa6d33f0bcc7$export$2e2bcd8739ae039; });

var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $5KhTJ = parcelRequire("5KhTJ");

var $fActo = parcelRequire("fActo");

var $k5B64 = parcelRequire("k5B64");

var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");

var $1fjI4 = parcelRequire("1fjI4");

var $h1Wjo = parcelRequire("h1Wjo");

var $d1vbo = parcelRequire("d1vbo");

var $ioLV1 = parcelRequire("ioLV1");

var $geUhA = parcelRequire("geUhA");

var $bQo5x = parcelRequire("bQo5x");
function $ae3dfa6d33f0bcc7$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $5KhTJ.default)(config) === 'object') transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $6fFrj.useContext((0, $1fjI4.Context)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $6fFrj.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $6fFrj.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $k5B64.default)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $d1vbo.default)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $jP8CL.default)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $6fFrj.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $6fFrj.useCallback(function(node) {
            nodeRef.current = node;
            (0, $3BOWT.fillRef)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $kNxFX.default)((0, $kNxFX.default)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $geUhA.STATUS_NONE)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $kNxFX.default)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $kNxFX.default)((0, $kNxFX.default)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $kNxFX.default)((0, $kNxFX.default)({}, mergedProps), {}, {
                style: {
                    display: 'none'
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            // In motion
            var statusSuffix;
            if (statusStep === (0, $geUhA.STEP_PREPARE)) statusSuffix = 'prepare';
            else if ((0, $ioLV1.isActive)(statusStep)) statusSuffix = 'active';
            else if (statusStep === (0, $geUhA.STEP_START)) statusSuffix = 'start';
            var motionCls = (0, $bQo5x.getTransitionName)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $kNxFX.default)((0, $kNxFX.default)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $bQo5x.getTransitionName)(motionName, status), (0, $43449.default)((0, $43449.default)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $6fFrj.isValidElement(motionChildren) && (0, $3BOWT.supportRef)(motionChildren)) {
            var originNodeRef = (0, $3BOWT.getNodeRef)(motionChildren);
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $6fFrj.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $6fFrj.createElement((0, $h1Wjo.default), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $ae3dfa6d33f0bcc7$export$2e2bcd8739ae039 = $ae3dfa6d33f0bcc7$export$e265d52a86a9f199((0, $bQo5x.supportTransition));

});
parcelRegister("43449", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f2a98a60bf46129$export$2e2bcd8739ae039; });

var $406uy = parcelRequire("406uy");
function $2f2a98a60bf46129$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $406uy.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("406uy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e9c32aac72d2025$export$2e2bcd8739ae039; });

var $5KhTJ = parcelRequire("5KhTJ");

var $ahKkh = parcelRequire("ahKkh");
function $2e9c32aac72d2025$export$2e2bcd8739ae039(t) {
    var i = (0, $ahKkh.default)(t, "string");
    return "symbol" == (0, $5KhTJ.default)(i) ? i : i + "";
}

});
parcelRegister("5KhTJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42ef21c8fb1f6d14$export$2e2bcd8739ae039; });
function $42ef21c8fb1f6d14$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $42ef21c8fb1f6d14$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $42ef21c8fb1f6d14$export$2e2bcd8739ae039(o);
}

});

parcelRegister("ahKkh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77cf6d54c5edc70c$export$2e2bcd8739ae039; });

var $5KhTJ = parcelRequire("5KhTJ");
function $77cf6d54c5edc70c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $5KhTJ.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $5KhTJ.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("kNxFX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f242818b0388cedb$export$2e2bcd8739ae039; });

var $43449 = parcelRequire("43449");
function $f242818b0388cedb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f242818b0388cedb$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f242818b0388cedb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $43449.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f242818b0388cedb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("jP8CL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6e978542196f4e2$export$2e2bcd8739ae039; });

var $hDq8V = parcelRequire("hDq8V");

var $cCYbo = parcelRequire("cCYbo");

var $9qJjI = parcelRequire("9qJjI");

var $dbCep = parcelRequire("dbCep");
function $e6e978542196f4e2$export$2e2bcd8739ae039(r, e) {
    return (0, $hDq8V.default)(r) || (0, $cCYbo.default)(r, e) || (0, $9qJjI.default)(r, e) || (0, $dbCep.default)();
}

});
parcelRegister("hDq8V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd6a5ba2d4043cb9$export$2e2bcd8739ae039; });
function $cd6a5ba2d4043cb9$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("cCYbo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9317b7b30f173586$export$2e2bcd8739ae039; });
function $9317b7b30f173586$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("9qJjI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dd9b1c0b6b7e209$export$2e2bcd8739ae039; });

var $2wEk5 = parcelRequire("2wEk5");
function $6dd9b1c0b6b7e209$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $2wEk5.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $2wEk5.default)(r, a) : void 0;
    }
}

});
parcelRegister("2wEk5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d6dd93c982a30af$export$2e2bcd8739ae039; });
function $1d6dd93c982a30af$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("dbCep", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9999f565872c5048$export$2e2bcd8739ae039; });
function $9999f565872c5048$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("k5B64", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea010cf50f56f8f6$export$2e2bcd8739ae039; });

var $5KhTJ = parcelRequire("5KhTJ");

var $6fFrj = parcelRequire("6fFrj");

var $8CZEB = parcelRequire("8CZEB");
function $ea010cf50f56f8f6$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $ea010cf50f56f8f6$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $5KhTJ.default)(node) === 'object' && $ea010cf50f56f8f6$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($ea010cf50f56f8f6$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $ea010cf50f56f8f6$export$2e2bcd8739ae039(node) {
    var domNode = $ea010cf50f56f8f6$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($8CZEB))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($8CZEB))), node);
    }
    return null;
}

});

parcelRegister("3BOWT", function(module, exports) {

$parcel$export(module.exports, "fillRef", function () { return $2a0c593396b233cd$export$f17fd18fa51dcb5b; });
$parcel$export(module.exports, "composeRef", function () { return $2a0c593396b233cd$export$ab452c34e8e05029; });
$parcel$export(module.exports, "useComposeRef", function () { return $2a0c593396b233cd$export$1d1c999670a1285d; });
$parcel$export(module.exports, "supportRef", function () { return $2a0c593396b233cd$export$c1cec34af06bcf7; });
$parcel$export(module.exports, "getNodeRef", function () { return $2a0c593396b233cd$export$7465e5c0bf44f19a; });

var $5KhTJ = parcelRequire("5KhTJ");

var $6fFrj = parcelRequire("6fFrj");

var $dSEHW = parcelRequire("dSEHW");

var $a5lfY = parcelRequire("a5lfY");

var $eywMK = parcelRequire("eywMK");
var $2a0c593396b233cd$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $5KhTJ.default)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $2a0c593396b233cd$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $2a0c593396b233cd$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $2a0c593396b233cd$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $a5lfY.default)(function() {
        return $2a0c593396b233cd$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $2a0c593396b233cd$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($2a0c593396b233cd$var$isReactElement(nodeOrComponent) && nodeOrComponent.props.propertyIsEnumerable('ref')) return true;
    var type = (0, $dSEHW.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $dSEHW.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $dSEHW.ForwardRef)) return false;
    return true;
};
function $2a0c593396b233cd$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $6fFrj.isValidElement)(node) && !(0, $eywMK.default)(node);
}
var $2a0c593396b233cd$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $2a0c593396b233cd$var$isReactElement(node) && $2a0c593396b233cd$export$c1cec34af06bcf7(node);
};
var $2a0c593396b233cd$export$7465e5c0bf44f19a = function getNodeRef(node) {
    if (node && $2a0c593396b233cd$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};

});
parcelRegister("dSEHW", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lvRYf"));

});
parcelRegister("lvRYf", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $fa965bb25f5b0621$export$a7c73072b1a182ae; }, function (v) { return $fa965bb25f5b0621$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $fa965bb25f5b0621$export$9f27bc3417b4524d; }, function (v) { return $fa965bb25f5b0621$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $fa965bb25f5b0621$export$db77ccec0bb4ccac; }, function (v) { return $fa965bb25f5b0621$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $fa965bb25f5b0621$export$8392c0c9d3dcbd35; }, function (v) { return $fa965bb25f5b0621$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $fa965bb25f5b0621$export$ffb0004e005737fa; }, function (v) { return $fa965bb25f5b0621$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $fa965bb25f5b0621$export$b624eff549462981; }, function (v) { return $fa965bb25f5b0621$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $fa965bb25f5b0621$export$7897aa7841a5380c; }, function (v) { return $fa965bb25f5b0621$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $fa965bb25f5b0621$export$602eac185826482c; }, function (v) { return $fa965bb25f5b0621$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $fa965bb25f5b0621$export$e2c29f18771995cb; }, function (v) { return $fa965bb25f5b0621$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $fa965bb25f5b0621$export$5f8d39834fd61797; }, function (v) { return $fa965bb25f5b0621$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $fa965bb25f5b0621$export$74bf444e3cd11ea5; }, function (v) { return $fa965bb25f5b0621$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $fa965bb25f5b0621$export$998bcd577473dd93; }, function (v) { return $fa965bb25f5b0621$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $fa965bb25f5b0621$export$92387174baf9b227; }, function (v) { return $fa965bb25f5b0621$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $fa965bb25f5b0621$export$ec112efeb987d9c6; }, function (v) { return $fa965bb25f5b0621$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $fa965bb25f5b0621$export$b706b080d889d2c9; }, function (v) { return $fa965bb25f5b0621$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $fa965bb25f5b0621$export$5be5a87408f70ddc; }, function (v) { return $fa965bb25f5b0621$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $fa965bb25f5b0621$export$45a5e7f76e0caa8d; }, function (v) { return $fa965bb25f5b0621$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $fa965bb25f5b0621$export$455c2e768291efa6; }, function (v) { return $fa965bb25f5b0621$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $fa965bb25f5b0621$export$9522e17588c12572; }, function (v) { return $fa965bb25f5b0621$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $fa965bb25f5b0621$export$2110ac352bb060b9; }, function (v) { return $fa965bb25f5b0621$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $fa965bb25f5b0621$export$56885ab8b9c456ab; }, function (v) { return $fa965bb25f5b0621$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $fa965bb25f5b0621$export$d927fcb6adf8f9de; }, function (v) { return $fa965bb25f5b0621$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $fa965bb25f5b0621$export$b82d16f27459e05a; }, function (v) { return $fa965bb25f5b0621$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $fa965bb25f5b0621$export$522c17b4f5e123e8; }, function (v) { return $fa965bb25f5b0621$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $fa965bb25f5b0621$export$1aabd8a0274ecfd6; }, function (v) { return $fa965bb25f5b0621$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $fa965bb25f5b0621$export$3d6c20d97e46b957; }, function (v) { return $fa965bb25f5b0621$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $fa965bb25f5b0621$export$9b621391a187a31a; }, function (v) { return $fa965bb25f5b0621$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $fa965bb25f5b0621$export$f5bbd400c2f4426f; }, function (v) { return $fa965bb25f5b0621$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fa965bb25f5b0621$export$a7c73072b1a182ae;
var $fa965bb25f5b0621$export$9f27bc3417b4524d;
var $fa965bb25f5b0621$export$db77ccec0bb4ccac;
var $fa965bb25f5b0621$export$8392c0c9d3dcbd35;
var $fa965bb25f5b0621$export$ffb0004e005737fa;
var $fa965bb25f5b0621$export$b624eff549462981;
var $fa965bb25f5b0621$export$7897aa7841a5380c;
var $fa965bb25f5b0621$export$602eac185826482c;
var $fa965bb25f5b0621$export$e2c29f18771995cb;
var $fa965bb25f5b0621$export$5f8d39834fd61797;
var $fa965bb25f5b0621$export$74bf444e3cd11ea5;
var $fa965bb25f5b0621$export$998bcd577473dd93;
var $fa965bb25f5b0621$export$92387174baf9b227;
var $fa965bb25f5b0621$export$ec112efeb987d9c6;
var $fa965bb25f5b0621$export$b706b080d889d2c9;
var $fa965bb25f5b0621$export$5be5a87408f70ddc;
var $fa965bb25f5b0621$export$45a5e7f76e0caa8d;
var $fa965bb25f5b0621$export$455c2e768291efa6;
var $fa965bb25f5b0621$export$9522e17588c12572;
var $fa965bb25f5b0621$export$2110ac352bb060b9;
var $fa965bb25f5b0621$export$56885ab8b9c456ab;
var $fa965bb25f5b0621$export$d927fcb6adf8f9de;
var $fa965bb25f5b0621$export$b82d16f27459e05a;
var $fa965bb25f5b0621$export$522c17b4f5e123e8;
var $fa965bb25f5b0621$export$1aabd8a0274ecfd6;
var $fa965bb25f5b0621$export$3d6c20d97e46b957;
var $fa965bb25f5b0621$export$9b621391a187a31a;
var $fa965bb25f5b0621$export$f5bbd400c2f4426f;
'use strict';
var $fa965bb25f5b0621$var$b = Symbol.for("react.element"), $fa965bb25f5b0621$var$c = Symbol.for("react.portal"), $fa965bb25f5b0621$var$d = Symbol.for("react.fragment"), $fa965bb25f5b0621$var$e = Symbol.for("react.strict_mode"), $fa965bb25f5b0621$var$f = Symbol.for("react.profiler"), $fa965bb25f5b0621$var$g = Symbol.for("react.provider"), $fa965bb25f5b0621$var$h = Symbol.for("react.context"), $fa965bb25f5b0621$var$k = Symbol.for("react.server_context"), $fa965bb25f5b0621$var$l = Symbol.for("react.forward_ref"), $fa965bb25f5b0621$var$m = Symbol.for("react.suspense"), $fa965bb25f5b0621$var$n = Symbol.for("react.suspense_list"), $fa965bb25f5b0621$var$p = Symbol.for("react.memo"), $fa965bb25f5b0621$var$q = Symbol.for("react.lazy"), $fa965bb25f5b0621$var$t = Symbol.for("react.offscreen"), $fa965bb25f5b0621$var$u;
$fa965bb25f5b0621$var$u = Symbol.for("react.module.reference");
function $fa965bb25f5b0621$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $fa965bb25f5b0621$var$b:
                switch(a = a.type, a){
                    case $fa965bb25f5b0621$var$d:
                    case $fa965bb25f5b0621$var$f:
                    case $fa965bb25f5b0621$var$e:
                    case $fa965bb25f5b0621$var$m:
                    case $fa965bb25f5b0621$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $fa965bb25f5b0621$var$k:
                            case $fa965bb25f5b0621$var$h:
                            case $fa965bb25f5b0621$var$l:
                            case $fa965bb25f5b0621$var$q:
                            case $fa965bb25f5b0621$var$p:
                            case $fa965bb25f5b0621$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $fa965bb25f5b0621$var$c:
                return r;
        }
    }
}
$fa965bb25f5b0621$export$a7c73072b1a182ae = $fa965bb25f5b0621$var$h;
$fa965bb25f5b0621$export$9f27bc3417b4524d = $fa965bb25f5b0621$var$g;
$fa965bb25f5b0621$export$db77ccec0bb4ccac = $fa965bb25f5b0621$var$b;
$fa965bb25f5b0621$export$8392c0c9d3dcbd35 = $fa965bb25f5b0621$var$l;
$fa965bb25f5b0621$export$ffb0004e005737fa = $fa965bb25f5b0621$var$d;
$fa965bb25f5b0621$export$b624eff549462981 = $fa965bb25f5b0621$var$q;
$fa965bb25f5b0621$export$7897aa7841a5380c = $fa965bb25f5b0621$var$p;
$fa965bb25f5b0621$export$602eac185826482c = $fa965bb25f5b0621$var$c;
$fa965bb25f5b0621$export$e2c29f18771995cb = $fa965bb25f5b0621$var$f;
$fa965bb25f5b0621$export$5f8d39834fd61797 = $fa965bb25f5b0621$var$e;
$fa965bb25f5b0621$export$74bf444e3cd11ea5 = $fa965bb25f5b0621$var$m;
$fa965bb25f5b0621$export$998bcd577473dd93 = $fa965bb25f5b0621$var$n;
$fa965bb25f5b0621$export$92387174baf9b227 = function() {
    return !1;
};
$fa965bb25f5b0621$export$ec112efeb987d9c6 = function() {
    return !1;
};
$fa965bb25f5b0621$export$b706b080d889d2c9 = function(a) {
    return $fa965bb25f5b0621$var$v(a) === $fa965bb25f5b0621$var$h;
};
$fa965bb25f5b0621$export$5be5a87408f70ddc = function(a) {
    return $fa965bb25f5b0621$var$v(a) === $fa965bb25f5b0621$var$g;
};
$fa965bb25f5b0621$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $fa965bb25f5b0621$var$b;
};
$fa965bb25f5b0621$export$455c2e768291efa6 = function(a) {
    return $fa965bb25f5b0621$var$v(a) === $fa965bb25f5b0621$var$l;
};
$fa965bb25f5b0621$export$9522e17588c12572 = function(a) {
    return $fa965bb25f5b0621$var$v(a) === $fa965bb25f5b0621$var$d;
};
$fa965bb25f5b0621$export$2110ac352bb060b9 = function(a) {
    return $fa965bb25f5b0621$var$v(a) === $fa965bb25f5b0621$var$q;
};
$fa965bb25f5b0621$export$56885ab8b9c456ab = function(a) {
    return $fa965bb25f5b0621$var$v(a) === $fa965bb25f5b0621$var$p;
};
$fa965bb25f5b0621$export$d927fcb6adf8f9de = function(a) {
    return $fa965bb25f5b0621$var$v(a) === $fa965bb25f5b0621$var$c;
};
$fa965bb25f5b0621$export$b82d16f27459e05a = function(a) {
    return $fa965bb25f5b0621$var$v(a) === $fa965bb25f5b0621$var$f;
};
$fa965bb25f5b0621$export$522c17b4f5e123e8 = function(a) {
    return $fa965bb25f5b0621$var$v(a) === $fa965bb25f5b0621$var$e;
};
$fa965bb25f5b0621$export$1aabd8a0274ecfd6 = function(a) {
    return $fa965bb25f5b0621$var$v(a) === $fa965bb25f5b0621$var$m;
};
$fa965bb25f5b0621$export$3d6c20d97e46b957 = function(a) {
    return $fa965bb25f5b0621$var$v(a) === $fa965bb25f5b0621$var$n;
};
$fa965bb25f5b0621$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $fa965bb25f5b0621$var$d || a === $fa965bb25f5b0621$var$f || a === $fa965bb25f5b0621$var$e || a === $fa965bb25f5b0621$var$m || a === $fa965bb25f5b0621$var$n || a === $fa965bb25f5b0621$var$t || "object" === typeof a && null !== a && (a.$$typeof === $fa965bb25f5b0621$var$q || a.$$typeof === $fa965bb25f5b0621$var$p || a.$$typeof === $fa965bb25f5b0621$var$g || a.$$typeof === $fa965bb25f5b0621$var$h || a.$$typeof === $fa965bb25f5b0621$var$l || a.$$typeof === $fa965bb25f5b0621$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$fa965bb25f5b0621$export$f5bbd400c2f4426f = $fa965bb25f5b0621$var$v;

});


parcelRegister("a5lfY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $757adc21ef499166$export$2e2bcd8739ae039; });

var $6fFrj = parcelRequire("6fFrj");
function $757adc21ef499166$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $6fFrj.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}

});

parcelRegister("eywMK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a98dac1e98e63b72$export$2e2bcd8739ae039; });

var $5KhTJ = parcelRequire("5KhTJ");
var $a98dac1e98e63b72$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var $a98dac1e98e63b72$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var $a98dac1e98e63b72$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $a98dac1e98e63b72$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && (0, $5KhTJ.default)(object) === 'object' && // React Element type
    (object.$$typeof === $a98dac1e98e63b72$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $a98dac1e98e63b72$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $a98dac1e98e63b72$var$REACT_FRAGMENT_TYPE);
}

});


parcelRegister("1fjI4", function(module, exports) {

$parcel$export(module.exports, "Context", function () { return $0e867b1d3591e8b9$export$841858b892ce1f4c; });

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");
var $0e867b1d3591e8b9$var$_excluded = [
    "children"
];
var $0e867b1d3591e8b9$export$841858b892ce1f4c = /*#__PURE__*/ $6fFrj.createContext({});
function $0e867b1d3591e8b9$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $04RxA.default)(_ref, $0e867b1d3591e8b9$var$_excluded);
    return /*#__PURE__*/ $6fFrj.createElement($0e867b1d3591e8b9$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}

});
parcelRegister("04RxA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00e9e7e59527c6f9$export$2e2bcd8739ae039; });

var $1FHru = parcelRequire("1FHru");
function $00e9e7e59527c6f9$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $1FHru.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("1FHru", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $137b51843269d7d1$export$2e2bcd8739ae039; });
function $137b51843269d7d1$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});



parcelRegister("h1Wjo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c65fc32683052a47$export$2e2bcd8739ae039; });

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $6fFrj = parcelRequire("6fFrj");
var $c65fc32683052a47$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(DomWrapper, _React$Component);
    var _super = (0, $lSufv.default)(DomWrapper);
    function DomWrapper() {
        (0, $kjNeN.default)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $5KQxu.default)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($6fFrj.Component);
var $c65fc32683052a47$export$2e2bcd8739ae039 = $c65fc32683052a47$var$DomWrapper;

});
parcelRegister("kjNeN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecabc6917563e6c4$export$2e2bcd8739ae039; });
function $ecabc6917563e6c4$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("5KQxu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $430a00ce3dfab491$export$2e2bcd8739ae039; });

var $406uy = parcelRequire("406uy");
function $430a00ce3dfab491$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $406uy.default)(o.key), o);
    }
}
function $430a00ce3dfab491$export$2e2bcd8739ae039(e, r, t) {
    return r && $430a00ce3dfab491$var$_defineProperties(e.prototype, r), t && $430a00ce3dfab491$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("bxC2Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86704a22456e38ef$export$2e2bcd8739ae039; });

var $diyuB = parcelRequire("diyuB");
function $86704a22456e38ef$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $diyuB.default)(t, e);
}

});
parcelRegister("diyuB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ae7b64bb8316f0e$export$2e2bcd8739ae039; });
function $9ae7b64bb8316f0e$export$2e2bcd8739ae039(t, e) {
    return $9ae7b64bb8316f0e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $9ae7b64bb8316f0e$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("lSufv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fed61af69bc0ba36$export$2e2bcd8739ae039; });

var $744q1 = parcelRequire("744q1");

var $jbuPt = parcelRequire("jbuPt");

var $82HU4 = parcelRequire("82HU4");
function $fed61af69bc0ba36$export$2e2bcd8739ae039(t) {
    var r = (0, $jbuPt.default)();
    return function() {
        var e, o = (0, $744q1.default)(t);
        if (r) {
            var s = (0, $744q1.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $82HU4.default)(this, e);
    };
}

});
parcelRegister("744q1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $524c559329113d9e$export$2e2bcd8739ae039; });
function $524c559329113d9e$export$2e2bcd8739ae039(t) {
    return $524c559329113d9e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $524c559329113d9e$export$2e2bcd8739ae039(t);
}

});

parcelRegister("jbuPt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df76f56dc001b64c$export$2e2bcd8739ae039; });
function $df76f56dc001b64c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($df76f56dc001b64c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("82HU4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0182d90bffec5fa2$export$2e2bcd8739ae039; });

var $5KhTJ = parcelRequire("5KhTJ");

var $3mZgl = parcelRequire("3mZgl");
function $0182d90bffec5fa2$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5KhTJ.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $3mZgl.default)(t);
}

});
parcelRegister("3mZgl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2742f2a1f44e51b7$export$2e2bcd8739ae039; });
function $2742f2a1f44e51b7$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});




parcelRegister("d1vbo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97b38ea0cacb9d19$export$2e2bcd8739ae039; });

var $kNxFX = parcelRequire("kNxFX");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");
parcelRequire("iVfr3");
var $2c6ch = parcelRequire("2c6ch");

var $lqiy0 = parcelRequire("lqiy0");

var $fovZY = parcelRequire("fovZY");

var $6fFrj = parcelRequire("6fFrj");

var $geUhA = parcelRequire("geUhA");

var $3tabp = parcelRequire("3tabp");

var $cZcMb = parcelRequire("cZcMb");

var $ioLV1 = parcelRequire("ioLV1");
function $97b38ea0cacb9d19$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $lqiy0.default)(), _useState2 = (0, $jP8CL.default)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useSyncState = (0, $fovZY.default)((0, $geUhA.STATUS_NONE)), _useSyncState2 = (0, $jP8CL.default)(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
    var _useState3 = (0, $lqiy0.default)(null), _useState4 = (0, $jP8CL.default)(_useState3, 2), style = _useState4[0], setStyle = _useState4[1];
    var currentStatus = getStatus();
    var mountedRef = (0, $6fFrj.useRef)(false);
    var deadlineRef = (0, $6fFrj.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $6fFrj.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $geUhA.STATUS_NONE));
        setStyle(null, true);
    }
    var onInternalMotionEnd = (0, $2c6ch.default)(function(event) {
        var status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $geUhA.STATUS_NONE)) return;
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $geUhA.STATUS_APPEAR) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $geUhA.STATUS_ENTER) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $geUhA.STATUS_LEAVE) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    var _useDomMotionEvents = (0, $3tabp.default)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $jP8CL.default)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        switch(targetStatus){
            case 0, $geUhA.STATUS_APPEAR:
                return (0, $43449.default)((0, $43449.default)((0, $43449.default)({}, (0, $geUhA.STEP_PREPARE), onAppearPrepare), (0, $geUhA.STEP_START), onAppearStart), (0, $geUhA.STEP_ACTIVE), onAppearActive);
            case 0, $geUhA.STATUS_ENTER:
                return (0, $43449.default)((0, $43449.default)((0, $43449.default)({}, (0, $geUhA.STEP_PREPARE), onEnterPrepare), (0, $geUhA.STEP_START), onEnterStart), (0, $geUhA.STEP_ACTIVE), onEnterActive);
            case 0, $geUhA.STATUS_LEAVE:
                return (0, $43449.default)((0, $43449.default)((0, $43449.default)({}, (0, $geUhA.STEP_PREPARE), onLeavePrepare), (0, $geUhA.STEP_START), onLeaveStart), (0, $geUhA.STEP_ACTIVE), onLeaveActive);
            default:
                return {};
        }
    };
    var eventHandlers = $6fFrj.useMemo(function() {
        return getEventHandlers(currentStatus);
    }, [
        currentStatus
    ]);
    var _useStepQueue = (0, $ioLV1.default)(currentStatus, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $geUhA.STEP_PREPARE)) {
            var onPrepare = eventHandlers[0, $geUhA.STEP_PREPARE];
            if (!onPrepare) return 0, $ioLV1.SkipStep;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $geUhA.STEP_ACTIVE) && currentStatus !== (0, $geUhA.STATUS_NONE)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $geUhA.STEP_PREPARED)) updateMotionEndStatus();
        return 0, $ioLV1.DoStep;
    }), _useStepQueue2 = (0, $jP8CL.default)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $ioLV1.isActive)(step);
    activeRef.current = active;
    // ============================ Status ============================
    var visibleRef = (0, $6fFrj.useRef)(null);
    // Update with new status
    (0, $cZcMb.default)(function() {
        // When use Suspense, the `visible` will repeat trigger,
        // But not real change of the `visible`, we need to skip it.
        // https://github.com/ant-design/ant-design/issues/44379
        if (mountedRef.current && visibleRef.current === visible) return;
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $geUhA.STATUS_APPEAR);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $geUhA.STATUS_ENTER);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $geUhA.STATUS_LEAVE);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $geUhA.STEP_PREPARE])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $geUhA.STATUS_NONE));
        visibleRef.current = visible;
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $6fFrj.useEffect)(function() {
        if (// Cancel appear
        currentStatus === (0, $geUhA.STATUS_APPEAR) && !motionAppear || // Cancel enter
        currentStatus === (0, $geUhA.STATUS_ENTER) && !motionEnter || // Cancel leave
        currentStatus === (0, $geUhA.STATUS_LEAVE) && !motionLeave) setStatus((0, $geUhA.STATUS_NONE));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $6fFrj.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $6fFrj.useRef(false);
    (0, $6fFrj.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $geUhA.STATUS_NONE)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $geUhA.STEP_PREPARE] && step === (0, $geUhA.STEP_START)) mergedStyle = (0, $kNxFX.default)({
        transition: 'none'
    }, mergedStyle);
    return [
        currentStatus,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}

});
parcelRegister("iVfr3", function(module, exports) {

$parcel$export(module.exports, "useEvent", function () { return (parcelRequire("2c6ch")).default; });

var $2c6ch = parcelRequire("2c6ch");

var $gfhff = parcelRequire("gfhff");

var $3BOWT = parcelRequire("3BOWT");

var $ij6y6 = parcelRequire("ij6y6");

var $i5KV1 = parcelRequire("i5KV1");

var $3mXQ2 = parcelRequire("3mXQ2");

});
parcelRegister("2c6ch", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1991825b687d819a$export$2e2bcd8739ae039; });

var $6fFrj = parcelRequire("6fFrj");
function $1991825b687d819a$export$2e2bcd8739ae039(callback) {
    var fnRef = $6fFrj.useRef();
    fnRef.current = callback;
    var memoFn = $6fFrj.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}

});

parcelRegister("gfhff", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd3b6c8d36ab1177$export$2e2bcd8739ae039; });

var $jP8CL = parcelRequire("jP8CL");

var $2c6ch = parcelRequire("2c6ch");

var $dNZA9 = parcelRequire("dNZA9");

var $lqiy0 = parcelRequire("lqiy0");
/** We only think `undefined` is empty */ function $bd3b6c8d36ab1177$var$hasValue(value) {
    return value !== undefined;
}
function $bd3b6c8d36ab1177$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $lqiy0.default)(function() {
        if ($bd3b6c8d36ab1177$var$hasValue(value)) return value;
        else if ($bd3b6c8d36ab1177$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $jP8CL.default)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $2c6ch.default)(onChange);
    var _useState3 = (0, $lqiy0.default)([
        mergedValue
    ]), _useState4 = (0, $jP8CL.default)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $dNZA9.useLayoutUpdateEffect)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $dNZA9.useLayoutUpdateEffect)(function() {
        if (!$bd3b6c8d36ab1177$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $2c6ch.default)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}

});
parcelRegister("dNZA9", function(module, exports) {

$parcel$export(module.exports, "useLayoutUpdateEffect", function () { return $a0cf9ee74f7f91f0$export$9283e56bae2f7b0f; });
$parcel$export(module.exports, "default", function () { return $a0cf9ee74f7f91f0$export$2e2bcd8739ae039; });

var $6fFrj = parcelRequire("6fFrj");

var $aSXdS = parcelRequire("aSXdS");
/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $a0cf9ee74f7f91f0$var$useInternalLayoutEffect = (0, $aSXdS.default)() ? $6fFrj.useLayoutEffect : $6fFrj.useEffect;
var $a0cf9ee74f7f91f0$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $6fFrj.useRef(true);
    $a0cf9ee74f7f91f0$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $a0cf9ee74f7f91f0$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $a0cf9ee74f7f91f0$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $a0cf9ee74f7f91f0$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $a0cf9ee74f7f91f0$export$2e2bcd8739ae039 = $a0cf9ee74f7f91f0$var$useLayoutEffect;

});
parcelRegister("aSXdS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ecce2f3b6b13ea4$export$2e2bcd8739ae039; });
function $7ecce2f3b6b13ea4$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

});


parcelRegister("lqiy0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f98a69ce1071a2c3$export$2e2bcd8739ae039; });

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
function $f98a69ce1071a2c3$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $6fFrj.useRef(false);
    var _React$useState = $6fFrj.useState(defaultValue), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $6fFrj.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}

});


parcelRegister("ij6y6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d53f14d8c84300cc$export$2e2bcd8739ae039; });
function $d53f14d8c84300cc$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}

});

parcelRegister("i5KV1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2bd16b21b598f87$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "merge", function () { return $d2bd16b21b598f87$export$4950aa0f605343fb; });

var $5KhTJ = parcelRequire("5KhTJ");

var $kNxFX = parcelRequire("kNxFX");

var $37xND = parcelRequire("37xND");

var $hFMPf = parcelRequire("hFMPf");

var $ij6y6 = parcelRequire("ij6y6");
function $d2bd16b21b598f87$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $hFMPf.default)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $37xND.default)(entity);
    else clone = (0, $kNxFX.default)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $d2bd16b21b598f87$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $d2bd16b21b598f87$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $ij6y6.default)(entity, paths.slice(0, -1))) return entity;
    return $d2bd16b21b598f87$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $d2bd16b21b598f87$var$isObject(obj) {
    return (0, $5KhTJ.default)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $d2bd16b21b598f87$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $d2bd16b21b598f87$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $d2bd16b21b598f87$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $d2bd16b21b598f87$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $ij6y6.default)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $d2bd16b21b598f87$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $ij6y6.default)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $d2bd16b21b598f87$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $5KhTJ.default)(originValue) !== 'object') // Init container if not exist
                    clone = $d2bd16b21b598f87$export$2e2bcd8739ae039(clone, path, $d2bd16b21b598f87$var$createEmpty(value));
                    $d2bd16b21b598f87$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $37xND.default)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $d2bd16b21b598f87$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}

});
parcelRegister("37xND", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $245c3e6bd62cdb50$export$2e2bcd8739ae039; });

var $lFwIb = parcelRequire("lFwIb");

var $8o834 = parcelRequire("8o834");

var $9qJjI = parcelRequire("9qJjI");

var $3dO0G = parcelRequire("3dO0G");
function $245c3e6bd62cdb50$export$2e2bcd8739ae039(r) {
    return (0, $lFwIb.default)(r) || (0, $8o834.default)(r) || (0, $9qJjI.default)(r) || (0, $3dO0G.default)();
}

});
parcelRegister("lFwIb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc66cd2476c61efb$export$2e2bcd8739ae039; });

var $2wEk5 = parcelRequire("2wEk5");
function $fc66cd2476c61efb$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $2wEk5.default)(r);
}

});

parcelRegister("8o834", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61b6cee0bec55d07$export$2e2bcd8739ae039; });
function $61b6cee0bec55d07$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("3dO0G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $258960f631f9ad95$export$2e2bcd8739ae039; });
function $258960f631f9ad95$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("hFMPf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cddc23bc7f3ae05e$export$2e2bcd8739ae039; });

var $hDq8V = parcelRequire("hDq8V");

var $8o834 = parcelRequire("8o834");

var $9qJjI = parcelRequire("9qJjI");

var $dbCep = parcelRequire("dbCep");
function $cddc23bc7f3ae05e$export$2e2bcd8739ae039(r) {
    return (0, $hDq8V.default)(r) || (0, $8o834.default)(r) || (0, $9qJjI.default)(r) || (0, $dbCep.default)();
}

});


parcelRegister("3mXQ2", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $2741d7cd15d6af6c$export$491112666e282270; });
$parcel$export(module.exports, "noteOnce", function () { return $2741d7cd15d6af6c$export$89ff31684837bbbf; });
$parcel$export(module.exports, "default", function () { return $2741d7cd15d6af6c$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $2741d7cd15d6af6c$var$warned = {};
var $2741d7cd15d6af6c$var$preWarningFns = [];
var $2741d7cd15d6af6c$export$61616f168f0e5a05 = function preMessage(fn) {
    $2741d7cd15d6af6c$var$preWarningFns.push(fn);
};
function $2741d7cd15d6af6c$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $2741d7cd15d6af6c$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $2741d7cd15d6af6c$export$60eef1277fe463e4() {
    $2741d7cd15d6af6c$var$warned = {};
}
function $2741d7cd15d6af6c$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$2741d7cd15d6af6c$var$warned[message]) {
        method(false, message);
        $2741d7cd15d6af6c$var$warned[message] = true;
    }
}
function $2741d7cd15d6af6c$export$82934adf09101657(valid, message) {
    $2741d7cd15d6af6c$export$848feb93d8f32b9b($2741d7cd15d6af6c$export$491112666e282270, valid, message);
}
function $2741d7cd15d6af6c$export$89ff31684837bbbf(valid, message) {
    $2741d7cd15d6af6c$export$848feb93d8f32b9b($2741d7cd15d6af6c$export$a92e4c44d367d0af, valid, message);
}
$2741d7cd15d6af6c$export$82934adf09101657.preMessage = $2741d7cd15d6af6c$export$61616f168f0e5a05;
$2741d7cd15d6af6c$export$82934adf09101657.resetWarned = $2741d7cd15d6af6c$export$60eef1277fe463e4;
$2741d7cd15d6af6c$export$82934adf09101657.noteOnce = $2741d7cd15d6af6c$export$89ff31684837bbbf;
var $2741d7cd15d6af6c$export$2e2bcd8739ae039 = $2741d7cd15d6af6c$export$82934adf09101657;

});


parcelRegister("fovZY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b351eb28a7e9431c$export$2e2bcd8739ae039; });

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $2c6ch = parcelRequire("2c6ch");
function $b351eb28a7e9431c$export$2e2bcd8739ae039(defaultValue) {
    var _React$useReducer = $6fFrj.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $jP8CL.default)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    var currentValueRef = $6fFrj.useRef(defaultValue);
    var getValue = (0, $2c6ch.default)(function() {
        return currentValueRef.current;
    });
    var setValue = (0, $2c6ch.default)(function(updater) {
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}

});

parcelRegister("geUhA", function(module, exports) {

$parcel$export(module.exports, "STATUS_NONE", function () { return $bd299cb570535ce8$export$de71442bbf2143da; });
$parcel$export(module.exports, "STATUS_APPEAR", function () { return $bd299cb570535ce8$export$4fc3521687bcacd2; });
$parcel$export(module.exports, "STATUS_ENTER", function () { return $bd299cb570535ce8$export$5d6af549241fe2e8; });
$parcel$export(module.exports, "STATUS_LEAVE", function () { return $bd299cb570535ce8$export$59b1c493d29f68e4; });
$parcel$export(module.exports, "STEP_NONE", function () { return $bd299cb570535ce8$export$40b34dd77d5522bf; });
$parcel$export(module.exports, "STEP_PREPARE", function () { return $bd299cb570535ce8$export$1b792916a5fac4fc; });
$parcel$export(module.exports, "STEP_START", function () { return $bd299cb570535ce8$export$9563153dd25a3ce8; });
$parcel$export(module.exports, "STEP_ACTIVE", function () { return $bd299cb570535ce8$export$e205886172277ec6; });
$parcel$export(module.exports, "STEP_ACTIVATED", function () { return $bd299cb570535ce8$export$3a846c3d2fac10b8; });
$parcel$export(module.exports, "STEP_PREPARED", function () { return $bd299cb570535ce8$export$98351fa4e6b4f204; });
var $bd299cb570535ce8$export$de71442bbf2143da = 'none';
var $bd299cb570535ce8$export$4fc3521687bcacd2 = 'appear';
var $bd299cb570535ce8$export$5d6af549241fe2e8 = 'enter';
var $bd299cb570535ce8$export$59b1c493d29f68e4 = 'leave';
var $bd299cb570535ce8$export$40b34dd77d5522bf = 'none';
var $bd299cb570535ce8$export$1b792916a5fac4fc = 'prepare';
var $bd299cb570535ce8$export$9563153dd25a3ce8 = 'start';
var $bd299cb570535ce8$export$e205886172277ec6 = 'active';
var $bd299cb570535ce8$export$3a846c3d2fac10b8 = 'end';
var $bd299cb570535ce8$export$98351fa4e6b4f204 = 'prepared';

});

parcelRegister("3tabp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $286bfaaca6935c8b$export$2e2bcd8739ae039; });

var $6fFrj = parcelRequire("6fFrj");

var $bQo5x = parcelRequire("bQo5x");
var $286bfaaca6935c8b$export$2e2bcd8739ae039 = function(onInternalMotionEnd) {
    var cacheElementRef = (0, $6fFrj.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $bQo5x.transitionEndName), onInternalMotionEnd);
            element.removeEventListener((0, $bQo5x.animationEndName), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $bQo5x.transitionEndName), onInternalMotionEnd);
            element.addEventListener((0, $bQo5x.animationEndName), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $6fFrj.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};

});
parcelRegister("bQo5x", function(module, exports) {

$parcel$export(module.exports, "supportTransition", function () { return $89f73c75bb88ed3b$export$d28133ed3ad06c8b; });
$parcel$export(module.exports, "animationEndName", function () { return $89f73c75bb88ed3b$export$760cc9769c51b738; });
$parcel$export(module.exports, "transitionEndName", function () { return $89f73c75bb88ed3b$export$44baea64b8602e3c; });
$parcel$export(module.exports, "getTransitionName", function () { return $89f73c75bb88ed3b$export$27c72201b1d09951; });

var $5KhTJ = parcelRequire("5KhTJ");

var $aSXdS = parcelRequire("aSXdS");
// ================= Transition =================
// Event wrapper. Copy from react source code
function $89f73c75bb88ed3b$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $89f73c75bb88ed3b$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $89f73c75bb88ed3b$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $89f73c75bb88ed3b$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $89f73c75bb88ed3b$var$vendorPrefixes = $89f73c75bb88ed3b$export$6e8b350b1a8958a0((0, $aSXdS.default)(), typeof window !== 'undefined' ? window : {});
var $89f73c75bb88ed3b$var$style = {};
if ((0, $aSXdS.default)()) {
    var $89f73c75bb88ed3b$var$_document$createEleme = document.createElement('div');
    $89f73c75bb88ed3b$var$style = $89f73c75bb88ed3b$var$_document$createEleme.style;
}
var $89f73c75bb88ed3b$var$prefixedEventNames = {};
function $89f73c75bb88ed3b$export$a032e4f39350c1d8(eventName) {
    if ($89f73c75bb88ed3b$var$prefixedEventNames[eventName]) return $89f73c75bb88ed3b$var$prefixedEventNames[eventName];
    var prefixMap = $89f73c75bb88ed3b$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $89f73c75bb88ed3b$var$style) {
                $89f73c75bb88ed3b$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $89f73c75bb88ed3b$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
var $89f73c75bb88ed3b$var$internalAnimationEndName = $89f73c75bb88ed3b$export$a032e4f39350c1d8('animationend');
var $89f73c75bb88ed3b$var$internalTransitionEndName = $89f73c75bb88ed3b$export$a032e4f39350c1d8('transitionend');
var $89f73c75bb88ed3b$export$d28133ed3ad06c8b = !!($89f73c75bb88ed3b$var$internalAnimationEndName && $89f73c75bb88ed3b$var$internalTransitionEndName);
var $89f73c75bb88ed3b$export$760cc9769c51b738 = $89f73c75bb88ed3b$var$internalAnimationEndName || 'animationend';
var $89f73c75bb88ed3b$export$44baea64b8602e3c = $89f73c75bb88ed3b$var$internalTransitionEndName || 'transitionend';
function $89f73c75bb88ed3b$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $5KhTJ.default)(transitionName) === 'object') {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}

});


parcelRegister("cZcMb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9745179cbfbedf9e$export$2e2bcd8739ae039; });

var $aSXdS = parcelRequire("aSXdS");

var $6fFrj = parcelRequire("6fFrj");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $9745179cbfbedf9e$var$useIsomorphicLayoutEffect = (0, $aSXdS.default)() ? (0, $6fFrj.useLayoutEffect) : (0, $6fFrj.useEffect);
var $9745179cbfbedf9e$export$2e2bcd8739ae039 = $9745179cbfbedf9e$var$useIsomorphicLayoutEffect;

});

parcelRegister("ioLV1", function(module, exports) {

$parcel$export(module.exports, "SkipStep", function () { return $d64fa38575f3827d$export$c2029bf6cfdbc28a; });
$parcel$export(module.exports, "DoStep", function () { return $d64fa38575f3827d$export$dbee1e282e8c4830; });
$parcel$export(module.exports, "isActive", function () { return $d64fa38575f3827d$export$39e04e72f972b885; });
$parcel$export(module.exports, "default", function () { return $d64fa38575f3827d$export$2e2bcd8739ae039; });

var $jP8CL = parcelRequire("jP8CL");

var $lqiy0 = parcelRequire("lqiy0");

var $6fFrj = parcelRequire("6fFrj");

var $geUhA = parcelRequire("geUhA");

var $cZcMb = parcelRequire("cZcMb");

var $id8Dr = parcelRequire("id8Dr");
var $d64fa38575f3827d$var$FULL_STEP_QUEUE = [
    (0, $geUhA.STEP_PREPARE),
    (0, $geUhA.STEP_START),
    (0, $geUhA.STEP_ACTIVE),
    (0, $geUhA.STEP_ACTIVATED)
];
var $d64fa38575f3827d$var$SIMPLE_STEP_QUEUE = [
    (0, $geUhA.STEP_PREPARE),
    (0, $geUhA.STEP_PREPARED)
];
var $d64fa38575f3827d$export$c2029bf6cfdbc28a = false;
var $d64fa38575f3827d$export$dbee1e282e8c4830 = true;
function $d64fa38575f3827d$export$39e04e72f972b885(step) {
    return step === (0, $geUhA.STEP_ACTIVE) || step === (0, $geUhA.STEP_ACTIVATED);
}
var $d64fa38575f3827d$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $lqiy0.default)((0, $geUhA.STEP_NONE)), _useState2 = (0, $jP8CL.default)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $id8Dr.default)(), _useNextFrame2 = (0, $jP8CL.default)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $geUhA.STEP_PREPARE), true);
    }
    var STEP_QUEUE = prepareOnly ? $d64fa38575f3827d$var$SIMPLE_STEP_QUEUE : $d64fa38575f3827d$var$FULL_STEP_QUEUE;
    (0, $cZcMb.default)(function() {
        if (step !== (0, $geUhA.STEP_NONE) && step !== (0, $geUhA.STEP_ACTIVATED)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $d64fa38575f3827d$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $6fFrj.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};

});
parcelRegister("id8Dr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d42023a4a46b00fa$export$2e2bcd8739ae039; });

var $hqic8 = parcelRequire("hqic8");

var $6fFrj = parcelRequire("6fFrj");
var $d42023a4a46b00fa$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $6fFrj.useRef(null);
    function cancelNextFrame() {
        (0, $hqic8.default).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $hqic8.default)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $6fFrj.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};

});
parcelRegister("hqic8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caf2fa77194868ee$export$2e2bcd8739ae039; });
var $caf2fa77194868ee$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $caf2fa77194868ee$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $caf2fa77194868ee$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $caf2fa77194868ee$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $caf2fa77194868ee$var$rafUUID = 0;
var $caf2fa77194868ee$var$rafIds = new Map();
function $caf2fa77194868ee$var$cleanup(id) {
    $caf2fa77194868ee$var$rafIds.delete(id);
}
var $caf2fa77194868ee$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $caf2fa77194868ee$var$rafUUID += 1;
    var id = $caf2fa77194868ee$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $caf2fa77194868ee$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $caf2fa77194868ee$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $caf2fa77194868ee$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$caf2fa77194868ee$var$wrapperRaf.cancel = function(id) {
    var realId = $caf2fa77194868ee$var$rafIds.get(id);
    $caf2fa77194868ee$var$cleanup(id);
    return $caf2fa77194868ee$var$caf(realId);
};
var $caf2fa77194868ee$export$2e2bcd8739ae039 = $caf2fa77194868ee$var$wrapperRaf;

});





parcelRegister("2ZBO2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22de9ac776023d08$export$2e2bcd8739ae039; });

var $fIrcP = parcelRequire("fIrcP");

var $04RxA = parcelRequire("04RxA");

var $kNxFX = parcelRequire("kNxFX");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $3mZgl = parcelRequire("3mZgl");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");

var $eXuaz = parcelRequire("eXuaz");

var $i6dVE = parcelRequire("i6dVE");

var $bQo5x = parcelRequire("bQo5x");
var $22de9ac776023d08$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $22de9ac776023d08$var$_excluded2 = [
    "status"
];
var $22de9ac776023d08$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $22de9ac776023d08$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $eXuaz.default);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $bxC2Y.default)(CSSMotionList, _React$Component);
        var _super = (0, $lSufv.default)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $kjNeN.default)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $43449.default)((0, $3mZgl.default)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $43449.default)((0, $3mZgl.default)(_this), "removeKey", function(removeKey) {
                _this.setState(function(prevState) {
                    var nextKeyEntities = prevState.keyEntities.map(function(entity) {
                        if (entity.key !== removeKey) return entity;
                        return (0, $kNxFX.default)((0, $kNxFX.default)({}, entity), {}, {
                            status: (0, $i6dVE.STATUS_REMOVED)
                        });
                    });
                    return {
                        keyEntities: nextKeyEntities
                    };
                }, function() {
                    var keyEntities = _this.state.keyEntities;
                    var restKeysCount = keyEntities.filter(function(_ref) {
                        var status = _ref.status;
                        return status !== (0, $i6dVE.STATUS_REMOVED);
                    }).length;
                    if (restKeysCount === 0 && _this.props.onAllRemoved) _this.props.onAllRemoved();
                });
            });
            return _this;
        }
        (0, $5KQxu.default)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $04RxA.default)(_this$props, $22de9ac776023d08$var$_excluded);
                    var Component = component || $6fFrj.Fragment;
                    var motionProps = {};
                    $22de9ac776023d08$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $6fFrj.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $04RxA.default)(_ref2, $22de9ac776023d08$var$_excluded2);
                        var visible = status === (0, $i6dVE.STATUS_ADD) || status === (0, $i6dVE.STATUS_KEEP);
                        return /*#__PURE__*/ $6fFrj.createElement(CSSMotion, (0, $fIrcP.default)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) _this2.removeKey(eventProps.key);
                            }
                        }), function(props, ref) {
                            return children((0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $i6dVE.parseKeys)(keys);
                    var mixedKeyEntities = (0, $i6dVE.diffKeys)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $i6dVE.STATUS_REMOVED) && entity.status === (0, $i6dVE.STATUS_REMOVE)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($6fFrj.Component);
    (0, $43449.default)(CSSMotionList, "defaultProps", {
        component: 'div'
    });
    return CSSMotionList;
}
var $22de9ac776023d08$export$2e2bcd8739ae039 = $22de9ac776023d08$export$fcfc62c1d33d5e2e((0, $bQo5x.supportTransition));

});
parcelRegister("fIrcP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b71011944c3f66fb$export$2e2bcd8739ae039; });
function $b71011944c3f66fb$export$2e2bcd8739ae039() {
    return $b71011944c3f66fb$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b71011944c3f66fb$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("i6dVE", function(module, exports) {

$parcel$export(module.exports, "STATUS_ADD", function () { return $d2d397810fe1674d$export$3904baa009bc026e; });
$parcel$export(module.exports, "STATUS_KEEP", function () { return $d2d397810fe1674d$export$851162f0adad2cbc; });
$parcel$export(module.exports, "STATUS_REMOVE", function () { return $d2d397810fe1674d$export$c8b3fb08b68cfc85; });
$parcel$export(module.exports, "STATUS_REMOVED", function () { return $d2d397810fe1674d$export$2ac1bd1808d2e43a; });
$parcel$export(module.exports, "parseKeys", function () { return $d2d397810fe1674d$export$84bd7bd42ccc0f72; });
$parcel$export(module.exports, "diffKeys", function () { return $d2d397810fe1674d$export$14527669107aa301; });

var $kNxFX = parcelRequire("kNxFX");

var $5KhTJ = parcelRequire("5KhTJ");
var $d2d397810fe1674d$export$3904baa009bc026e = 'add';
var $d2d397810fe1674d$export$851162f0adad2cbc = 'keep';
var $d2d397810fe1674d$export$c8b3fb08b68cfc85 = 'remove';
var $d2d397810fe1674d$export$2ac1bd1808d2e43a = 'removed';
function $d2d397810fe1674d$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $5KhTJ.default)(key) === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $kNxFX.default)((0, $kNxFX.default)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $d2d397810fe1674d$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($d2d397810fe1674d$export$c47fd798e598c85c);
}
function $d2d397810fe1674d$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $d2d397810fe1674d$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $d2d397810fe1674d$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $kNxFX.default)((0, $kNxFX.default)({}, obj), {}, {
                            status: $d2d397810fe1674d$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $kNxFX.default)((0, $kNxFX.default)({}, currentKeyObj), {}, {
                    status: $d2d397810fe1674d$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $kNxFX.default)((0, $kNxFX.default)({}, keyObj), {}, {
            status: $d2d397810fe1674d$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $kNxFX.default)((0, $kNxFX.default)({}, obj), {}, {
            status: $d2d397810fe1674d$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $d2d397810fe1674d$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $d2d397810fe1674d$export$851162f0adad2cbc;
        });
    });
    return list;
}

});



parcelRegister("8ctwF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f8658ec8ab6d2bd$export$2e2bcd8739ae039; });

var $4SruF = parcelRequire("4SruF");
var $5f8658ec8ab6d2bd$export$2e2bcd8739ae039 = (0, $4SruF.default);

});
parcelRegister("4SruF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38d18835b78c5990$export$2e2bcd8739ae039; });

var $04RxA = parcelRequire("04RxA");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $6fFrj = parcelRequire("6fFrj");

var $Z1x3o = parcelRequire("Z1x3o");

var $fActo = parcelRequire("fActo");
parcelRequire("5EVeC");
var $2ZBO2 = parcelRequire("2ZBO2");

var $2SCwd = parcelRequire("2SCwd");

var $3jFiw = parcelRequire("3jFiw");
var $38d18835b78c5990$var$_excluded = [
    "getContainer"
];
var $38d18835b78c5990$var$seed = 0;
var $38d18835b78c5990$var$now = Date.now();
function $38d18835b78c5990$var$getUuid() {
    var id = $38d18835b78c5990$var$seed;
    $38d18835b78c5990$var$seed += 1;
    return "rcNotification_".concat($38d18835b78c5990$var$now, "_").concat(id);
}
var $38d18835b78c5990$var$Notification = /*#__PURE__*/ function(_Component) {
    (0, $bxC2Y.default)(Notification, _Component);
    var _super = (0, $lSufv.default)(Notification);
    function Notification() {
        var _this;
        (0, $kjNeN.default)(this, Notification);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            notices: []
        };
        _this.hookRefs = new Map();
        _this.add = function(originNotice, holderCallback) {
            var _originNotice$key;
            var key = (_originNotice$key = originNotice.key) !== null && _originNotice$key !== void 0 ? _originNotice$key : $38d18835b78c5990$var$getUuid();
            var notice = (0, $kNxFX.default)((0, $kNxFX.default)({}, originNotice), {}, {
                key: key
            });
            var maxCount = _this.props.maxCount;
            _this.setState(function(previousState) {
                var notices = previousState.notices;
                var noticeIndex = notices.map(function(v) {
                    return v.notice.key;
                }).indexOf(key);
                var updatedNotices = notices.concat();
                if (noticeIndex !== -1) updatedNotices.splice(noticeIndex, 1, {
                    notice: notice,
                    holderCallback: holderCallback
                });
                else {
                    if (maxCount && notices.length >= maxCount) {
                        // XXX, use key of first item to update new added (let React to move exsiting
                        // instead of remove and mount). Same key was used before for both a) external
                        // manual control and b) internal react 'key' prop , which is not that good.
                        // eslint-disable-next-line no-param-reassign
                        // zombieJ: Not know why use `updateKey`. This makes Notice infinite loop in jest.
                        // Change to `updateMark` for compare instead.
                        // https://github.com/react-component/notification/commit/32299e6be396f94040bfa82517eea940db947ece
                        notice.key = updatedNotices[0].notice.key;
                        notice.updateMark = $38d18835b78c5990$var$getUuid();
                        // zombieJ: That's why. User may close by key directly.
                        // We need record this but not re-render to avoid upper issue
                        // https://github.com/react-component/notification/issues/129
                        notice.userPassKey = key;
                        updatedNotices.shift();
                    }
                    updatedNotices.push({
                        notice: notice,
                        holderCallback: holderCallback
                    });
                }
                return {
                    notices: updatedNotices
                };
            });
        };
        _this.remove = function(removeKey) {
            _this.setState(function(_ref) {
                var notices = _ref.notices;
                return {
                    notices: notices.filter(function(_ref2) {
                        var _ref2$notice = _ref2.notice, key = _ref2$notice.key, userPassKey = _ref2$notice.userPassKey;
                        var mergedKey = userPassKey !== null && userPassKey !== void 0 ? userPassKey : key;
                        return mergedKey !== removeKey;
                    })
                };
            });
        };
        _this.noticePropsMap = {};
        return _this;
    }
    (0, $5KQxu.default)(Notification, [
        {
            key: "getTransitionName",
            value: function getTransitionName() {
                var _this$props = this.props, prefixCls = _this$props.prefixCls, animation = _this$props.animation;
                var transitionName = this.props.transitionName;
                if (!transitionName && animation) transitionName = "".concat(prefixCls, "-").concat(animation);
                return transitionName;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var notices = this.state.notices;
                var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, className = _this$props2.className, closeIcon = _this$props2.closeIcon, style = _this$props2.style;
                var noticeKeys = [];
                notices.forEach(function(_ref3, index) {
                    var notice = _ref3.notice, holderCallback = _ref3.holderCallback;
                    var updateMark = index === notices.length - 1 ? notice.updateMark : undefined;
                    var key = notice.key, userPassKey = notice.userPassKey;
                    var noticeProps = (0, $kNxFX.default)((0, $kNxFX.default)((0, $kNxFX.default)({
                        prefixCls: prefixCls,
                        closeIcon: closeIcon
                    }, notice), notice.props), {}, {
                        key: key,
                        noticeKey: userPassKey || key,
                        updateMark: updateMark,
                        onClose: function onClose(noticeKey) {
                            var _notice$onClose;
                            _this2.remove(noticeKey);
                            (_notice$onClose = notice.onClose) === null || _notice$onClose === void 0 || _notice$onClose.call(notice);
                        },
                        onClick: notice.onClick,
                        children: notice.content
                    });
                    // Give to motion
                    noticeKeys.push(key);
                    _this2.noticePropsMap[key] = {
                        props: noticeProps,
                        holderCallback: holderCallback
                    };
                });
                return /*#__PURE__*/ $6fFrj.createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className),
                    style: style
                }, /*#__PURE__*/ $6fFrj.createElement((0, $2ZBO2.default), {
                    keys: noticeKeys,
                    motionName: this.getTransitionName(),
                    onVisibleChanged: function onVisibleChanged(changedVisible, _ref4) {
                        var key = _ref4.key;
                        if (!changedVisible) delete _this2.noticePropsMap[key];
                    }
                }, function(_ref5) {
                    var key = _ref5.key, motionClassName = _ref5.className, motionStyle = _ref5.style, visible = _ref5.visible;
                    var _this2$noticePropsMap = _this2.noticePropsMap[key], noticeProps = _this2$noticePropsMap.props, holderCallback = _this2$noticePropsMap.holderCallback;
                    if (holderCallback) return /*#__PURE__*/ $6fFrj.createElement("div", {
                        key: key,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(motionClassName, "".concat(prefixCls, "-hook-holder")),
                        style: (0, $kNxFX.default)({}, motionStyle),
                        ref: function ref(div) {
                            if (typeof key === 'undefined') return;
                            if (div) {
                                _this2.hookRefs.set(key, div);
                                holderCallback(div, noticeProps);
                            } else _this2.hookRefs.delete(key);
                        }
                    });
                    return /*#__PURE__*/ $6fFrj.createElement((0, $2SCwd.default), (0, $fIrcP.default)({}, noticeProps, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(motionClassName, noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.className),
                        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, motionStyle), noticeProps === null || noticeProps === void 0 ? void 0 : noticeProps.style),
                        visible: visible
                    }));
                }));
            }
        }
    ]);
    return Notification;
}((0, $6fFrj.Component));
$38d18835b78c5990$var$Notification.newInstance = void 0;
$38d18835b78c5990$var$Notification.defaultProps = {
    prefixCls: 'rc-notification',
    animation: 'fade',
    style: {
        top: 65,
        left: '50%'
    }
};
$38d18835b78c5990$var$Notification.newInstance = function newNotificationInstance(properties, callback) {
    var _ref6 = properties || {}, getContainer = _ref6.getContainer, props = (0, $04RxA.default)(_ref6, $38d18835b78c5990$var$_excluded);
    var div = document.createElement('div');
    if (getContainer) {
        var root = getContainer();
        root.appendChild(div);
    } else document.body.appendChild(div);
    var called = false;
    function ref(notification) {
        if (called) return;
        called = true;
        callback({
            notice: function notice(noticeProps) {
                notification.add(noticeProps);
            },
            removeNotice: function removeNotice(key) {
                notification.remove(key);
            },
            component: notification,
            destroy: function destroy() {
                (0, $Z1x3o.unmount)(div);
                if (div.parentNode) div.parentNode.removeChild(div);
            },
            // Hooks
            useNotification: function useNotification() {
                return (0, $3jFiw.default)(notification);
            }
        });
    }
    (0, $Z1x3o.render)(/*#__PURE__*/ $6fFrj.createElement($38d18835b78c5990$var$Notification, (0, $fIrcP.default)({}, props, {
        ref: ref
    })), div);
};
var $38d18835b78c5990$export$2e2bcd8739ae039 = $38d18835b78c5990$var$Notification;

});
parcelRegister("Z1x3o", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $0b76e2de1ced64dd$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "unmount", function () { return $0b76e2de1ced64dd$export$121e2d597d222bad; });

var $1WWLf = parcelRequire("1WWLf");

var $47DhB = parcelRequire("47DhB");

var $5KhTJ = parcelRequire("5KhTJ");

var $kNxFX = parcelRequire("kNxFX");

var $8CZEB = parcelRequire("8CZEB");
// Let compiler not to search module usage
var $0b76e2de1ced64dd$var$fullClone = (0, $kNxFX.default)({}, $8CZEB);
var $0b76e2de1ced64dd$var$version = $0b76e2de1ced64dd$var$fullClone.version, $0b76e2de1ced64dd$var$reactRender = $0b76e2de1ced64dd$var$fullClone.render, $0b76e2de1ced64dd$var$unmountComponentAtNode = $0b76e2de1ced64dd$var$fullClone.unmountComponentAtNode;
var $0b76e2de1ced64dd$var$createRoot;
try {
    var $0b76e2de1ced64dd$var$mainVersion = Number(($0b76e2de1ced64dd$var$version || '').split('.')[0]);
    if ($0b76e2de1ced64dd$var$mainVersion >= 18) $0b76e2de1ced64dd$var$createRoot = $0b76e2de1ced64dd$var$fullClone.createRoot;
} catch (e) {
// Do nothing;
}
function $0b76e2de1ced64dd$var$toggleWarning(skip) {
    var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $0b76e2de1ced64dd$var$fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0, $5KhTJ.default)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === 'object') __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
}
var $0b76e2de1ced64dd$var$MARK = '__rc_react_root__';
// ========================== Render ==========================
function $0b76e2de1ced64dd$var$modernRender(node, container) {
    $0b76e2de1ced64dd$var$toggleWarning(true);
    var root = container[$0b76e2de1ced64dd$var$MARK] || $0b76e2de1ced64dd$var$createRoot(container);
    $0b76e2de1ced64dd$var$toggleWarning(false);
    root.render(node);
    container[$0b76e2de1ced64dd$var$MARK] = root;
}
function $0b76e2de1ced64dd$var$legacyRender(node, container) {
    $0b76e2de1ced64dd$var$reactRender === null || $0b76e2de1ced64dd$var$reactRender === void 0 || $0b76e2de1ced64dd$var$reactRender(node, container);
}
function $0b76e2de1ced64dd$export$892c6608f54d7438(node, container) {}
function $0b76e2de1ced64dd$export$b3890eb0ae9dca99(node, container) {
    if ($0b76e2de1ced64dd$var$createRoot) {
        $0b76e2de1ced64dd$var$modernRender(node, container);
        return;
    }
    $0b76e2de1ced64dd$var$legacyRender(node, container);
}
// ========================= Unmount ==========================
function $0b76e2de1ced64dd$var$modernUnmount(_x) {
    return $0b76e2de1ced64dd$var$_modernUnmount.apply(this, arguments);
}
function $0b76e2de1ced64dd$var$_modernUnmount() {
    $0b76e2de1ced64dd$var$_modernUnmount = (0, $47DhB.default)(/*#__PURE__*/ (0, $1WWLf.default)().mark(function _callee(container) {
        return (0, $1WWLf.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", Promise.resolve().then(function() {
                        var _container$MARK;
                        (_container$MARK = container[$0b76e2de1ced64dd$var$MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
                        delete container[$0b76e2de1ced64dd$var$MARK];
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $0b76e2de1ced64dd$var$_modernUnmount.apply(this, arguments);
}
function $0b76e2de1ced64dd$var$legacyUnmount(container) {
    $0b76e2de1ced64dd$var$unmountComponentAtNode(container);
}
function $0b76e2de1ced64dd$export$fd39fe14445b207a(container) {}
function $0b76e2de1ced64dd$export$121e2d597d222bad(_x2) {
    return $0b76e2de1ced64dd$var$_unmount.apply(this, arguments);
}
function $0b76e2de1ced64dd$var$_unmount() {
    $0b76e2de1ced64dd$var$_unmount = (0, $47DhB.default)(/*#__PURE__*/ (0, $1WWLf.default)().mark(function _callee2(container) {
        return (0, $1WWLf.default)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (!($0b76e2de1ced64dd$var$createRoot !== undefined)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", $0b76e2de1ced64dd$var$modernUnmount(container));
                case 2:
                    $0b76e2de1ced64dd$var$legacyUnmount(container);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $0b76e2de1ced64dd$var$_unmount.apply(this, arguments);
}

});
parcelRegister("1WWLf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16b8c9f7baa2e968$export$2e2bcd8739ae039; });

var $5KhTJ = parcelRequire("5KhTJ");
function $16b8c9f7baa2e968$export$2e2bcd8739ae039() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $16b8c9f7baa2e968$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == (0, $5KhTJ.default)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError((0, $5KhTJ.default)(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}

});

parcelRegister("47DhB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $300649a74f796c84$export$2e2bcd8739ae039; });
function $300649a74f796c84$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $300649a74f796c84$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $300649a74f796c84$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $300649a74f796c84$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});


parcelRegister("2SCwd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $218e80eba00e1cee$export$2e2bcd8739ae039; });

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $6fFrj = parcelRequire("6fFrj");

var $8CZEB = parcelRequire("8CZEB");

var $fActo = parcelRequire("fActo");
var $218e80eba00e1cee$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, $bxC2Y.default)(Notice, _Component);
    var _super = (0, $lSufv.default)(Notice);
    function Notice() {
        var _this;
        (0, $kjNeN.default)(this, Notice);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.closeTimer = null;
        _this.close = function(e) {
            if (e) e.stopPropagation();
            _this.clearCloseTimer();
            var _this$props = _this.props, onClose = _this$props.onClose, noticeKey = _this$props.noticeKey;
            if (onClose) onClose(noticeKey);
        };
        _this.startCloseTimer = function() {
            if (_this.props.duration) _this.closeTimer = window.setTimeout(function() {
                _this.close();
            }, _this.props.duration * 1000);
        };
        _this.clearCloseTimer = function() {
            if (_this.closeTimer) {
                clearTimeout(_this.closeTimer);
                _this.closeTimer = null;
            }
        };
        return _this;
    }
    (0, $5KQxu.default)(Notice, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startCloseTimer();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props.duration !== prevProps.duration || this.props.updateMark !== prevProps.updateMark || // Visible again need reset timer
                this.props.visible !== prevProps.visible && this.props.visible) this.restartCloseTimer();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.clearCloseTimer();
            }
        },
        {
            key: "restartCloseTimer",
            value: function restartCloseTimer() {
                this.clearCloseTimer();
                this.startCloseTimer();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, className = _this$props2.className, closable = _this$props2.closable, closeIcon = _this$props2.closeIcon, style = _this$props2.style, onClick = _this$props2.onClick, children = _this$props2.children, holder = _this$props2.holder;
                var componentClass = "".concat(prefixCls, "-notice");
                var dataOrAriaAttributeProps = Object.keys(this.props).reduce(function(acc, key) {
                    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') acc[key] = _this2.props[key];
                    return acc;
                }, {});
                var node = /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(componentClass, className, (0, $43449.default)({}, "".concat(componentClass, "-closable"), closable)),
                    style: style,
                    onMouseEnter: this.clearCloseTimer,
                    onMouseLeave: this.startCloseTimer,
                    onClick: onClick
                }, dataOrAriaAttributeProps), /*#__PURE__*/ $6fFrj.createElement("div", {
                    className: "".concat(componentClass, "-content")
                }, children), closable ? /*#__PURE__*/ $6fFrj.createElement("a", {
                    tabIndex: 0,
                    onClick: this.close,
                    className: "".concat(componentClass, "-close")
                }, closeIcon || /*#__PURE__*/ $6fFrj.createElement("span", {
                    className: "".concat(componentClass, "-close-x")
                })) : null);
                if (holder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8CZEB))).createPortal(node, holder);
                return node;
            }
        }
    ]);
    return Notice;
}((0, $6fFrj.Component));
$218e80eba00e1cee$export$2e2bcd8739ae039.defaultProps = {
    onClose: function onClose() {},
    duration: 1.5
};

});

parcelRegister("3jFiw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26a32e5721c7662c$export$2e2bcd8739ae039; });

var $37xND = parcelRequire("37xND");

var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $2SCwd = parcelRequire("2SCwd");
function $26a32e5721c7662c$export$2e2bcd8739ae039(notificationInstance) {
    var createdRef = $6fFrj.useRef({});
    var _React$useState = $6fFrj.useState([]), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), elements = _React$useState2[0], setElements = _React$useState2[1];
    function notify(noticeProps) {
        var firstMount = true;
        notificationInstance.add(noticeProps, function(div, props) {
            var key = props.key;
            if (div && (!createdRef.current[key] || firstMount)) {
                var noticeEle = /*#__PURE__*/ $6fFrj.createElement((0, $2SCwd.default), (0, $fIrcP.default)({}, props, {
                    holder: div
                }));
                createdRef.current[key] = noticeEle;
                setElements(function(originElements) {
                    var index = originElements.findIndex(function(ele) {
                        return ele.key === props.key;
                    });
                    if (index === -1) return [].concat((0, $37xND.default)(originElements), [
                        noticeEle
                    ]);
                    var cloneList = (0, $37xND.default)(originElements);
                    cloneList[index] = noticeEle;
                    return cloneList;
                });
            }
            firstMount = false;
        });
    }
    return [
        notify,
        /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, elements)
    ];
}

});



parcelRegister("7OMVO", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("fDpdg", function(module, exports) {

var $kqNAI = parcelRequire("kqNAI");

var $iTKuM = parcelRequire("iTKuM");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $kqNAI.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $iTKuM;
module.exports = isBuffer;

});
parcelRegister("iTKuM", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $dc216e1517d94740$var$stubFalse() {
    return false;
}
module.exports = $dc216e1517d94740$var$stubFalse;

});


parcelRegister("7UBHT", function(module, exports) {

var $2lvAs = parcelRequire("2lvAs");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $2lvAs.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("6wBJ8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $9rwUk = parcelRequire("9rwUk");
function $4c02ff07e1d77ddf$var$emptyFunction() {}
function $4c02ff07e1d77ddf$var$emptyFunctionWithReset() {}
$4c02ff07e1d77ddf$var$emptyFunctionWithReset.resetWarningCache = $4c02ff07e1d77ddf$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $9rwUk) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4c02ff07e1d77ddf$var$emptyFunctionWithReset,
        resetWarningCache: $4c02ff07e1d77ddf$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("9rwUk", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $6e0029673e922b90$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $6e0029673e922b90$var$ReactPropTypesSecret;

});


parcelRegister("a1BUX", function(module, exports) {

var $8qdJN = parcelRequire("8qdJN");

var $63yjW = parcelRequire("63yjW");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $8qdJN.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $63yjW;
module.exports = isBuffer;

});
parcelRegister("8qdJN", function(module, exports) {

var $aT1pq = parcelRequire("aT1pq");
/** Detect free variable `self`. */ var $621b6878a23d95d7$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $621b6878a23d95d7$var$root = $aT1pq || $621b6878a23d95d7$var$freeSelf || Function('return this')();
module.exports = $621b6878a23d95d7$var$root;

});
parcelRegister("aT1pq", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $7ed022420a9ab542$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $7ed022420a9ab542$var$freeGlobal;

});


parcelRegister("63yjW", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $468da53ccf30ca0b$var$stubFalse() {
    return false;
}
module.exports = $468da53ccf30ca0b$var$stubFalse;

});


parcelRegister("Etj01", function(module, exports) {

var $aT1pq = parcelRequire("aT1pq");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $aT1pq.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("ipnkk", function(module, exports) {

$parcel$export(module.exports, "FormikProvider", function () { return FormikProvider; });
$parcel$export(module.exports, "useFormik", function () { return useFormik; });
$parcel$export(module.exports, "Formik", function () { return Formik; });

var $6fFrj = parcelRequire("6fFrj");

var $4FS9d = parcelRequire("4FS9d");

var $ldfW9 = parcelRequire("ldfW9");

var $h8EF0 = parcelRequire("h8EF0");

var $jY8Ms = parcelRequire("jY8Ms");

var $7IUCQ = parcelRequire("7IUCQ");

var $7Ypvc = parcelRequire("7Ypvc");

var $7nfXW = parcelRequire("7nfXW");

var $82zmU = parcelRequire("82zmU");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $6fFrj.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $7IUCQ.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $jY8Ms.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $7IUCQ.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $jY8Ms.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
var FormikContext = /*#__PURE__*/ (0, $6fFrj.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $6fFrj.useContext)(FormikContext);
    !!!formik && (0, $7Ypvc.default)(false);
    return formik;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($4FS9d)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $6fFrj.useRef)(props.initialValues);
    var initialErrors = (0, $6fFrj.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $6fFrj.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $6fFrj.useRef)(props.initialStatus);
    var isMounted = (0, $6fFrj.useRef)(false);
    var fieldRegistry = (0, $6fFrj.useRef)({});
    (0, $6fFrj.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useReducer = (0, $6fFrj.useReducer)(formikReducer, {
        values: props.initialValues,
        errors: props.initialErrors || emptyErrors,
        touched: props.initialTouched || emptyTouched,
        status: props.initialStatus,
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    }), state = _React$useReducer[0], dispatch = _React$useReducer[1];
    var runValidateHandler = (0, $6fFrj.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $6fFrj.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $6fFrj.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $6fFrj.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $6fFrj.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $ldfW9.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $6fFrj.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($4FS9d)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $6fFrj.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched
    ]);
    (0, $6fFrj.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($4FS9d)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
            }
            if (validateOnMount) validateFormWithHighPriority(initialValues.current);
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $6fFrj.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($4FS9d)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $6fFrj.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($4FS9d)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $6fFrj.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($4FS9d)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: error[name]
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $6fFrj.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $6fFrj.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $6fFrj.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $6fFrj.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $6fFrj.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $6fFrj.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $6fFrj.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $6fFrj.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $6fFrj.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $6fFrj.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $6fFrj.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $6fFrj.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $6fFrj.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($4FS9d)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $6fFrj.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $6fFrj.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $6fFrj.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $6fFrj.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $6fFrj.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    if (context === void 0) context = {};
    var validateData = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](validateData, {
        abortEarly: false,
        context: context
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $h8EF0.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $h8EF0.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $ldfW9.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $ldfW9.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $6fFrj.useLayoutEffect) : (0, $6fFrj.useEffect);
function useEventCallback(fn) {
    var ref = (0, $6fFrj.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $6fFrj.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $6fFrj.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $7Ypvc.default)(false);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        getFieldHelpers(fieldName)
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $6fFrj.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $6fFrj.createElement)(component, _extends({
                ref: innerRef
            }, field, rest), children);
        } // We don't pass `meta` for backwards compat
        return (0, $6fFrj.createElement)(component, _extends({
            field: field,
            form: formik
        }, props), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $6fFrj.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest), children);
    }
    return (0, $6fFrj.createElement)(asElement, _extends({}, field, props), children);
}
var Form = /*#__PURE__*/ (0, $6fFrj.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $6fFrj.createElement)("form", Object.assign({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                _this = _React$Component.apply(this, arguments) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                /**
         * Just avoiding a render callback for perf here
         */ _this.renderFormComponent = function(formikProps) {
                    return (0, $6fFrj.createElement)(Component$1, Object.assign({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $6fFrj.createElement)(Formik, Object.assign({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $6fFrj.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($7nfXW)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $6fFrj.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $7Ypvc.default)(false);
            return (0, $6fFrj.createElement)(Comp, Object.assign({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($7nfXW)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = typeof alterErrors === 'function' ? alterErrors : fn;
                var updateTouched = typeof alterTouched === 'function' ? alterTouched : fn; // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $82zmU.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                if (length < 0) length = arr.length;
                return arr;
            }, function(array) {
                var arr = array ? [
                    null
                ].concat(array) : [
                    null
                ];
                if (length < 0) length = arr.length;
                return arr;
            }, function(array) {
                var arr = array ? [
                    null
                ].concat(array) : [
                    null
                ];
                if (length < 0) length = arr.length;
                return arr;
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        }; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($4FS9d)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
            return copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array;
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $6fFrj.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $6fFrj.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $6fFrj.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $6fFrj.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $6fFrj.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $7Ypvc.default)(false);
        !!(component && render) && (0, $7Ypvc.default)(false);
        !!(is && children && isFunction(children)) && (0, $7Ypvc.default)(false);
        !!(component && children && isFunction(children)) && (0, $7Ypvc.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $7Ypvc.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $6fFrj.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $6fFrj.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $6fFrj.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $6fFrj.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $6fFrj.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("4FS9d", function(module, exports) {
'use strict';
var $3674fe5722c4ea3d$var$isArray = Array.isArray;
var $3674fe5722c4ea3d$var$keyList = Object.keys;
var $3674fe5722c4ea3d$var$hasProp = Object.prototype.hasOwnProperty;
var $3674fe5722c4ea3d$var$hasElementType = typeof Element !== 'undefined';
function $3674fe5722c4ea3d$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $3674fe5722c4ea3d$var$isArray(a), arrB = $3674fe5722c4ea3d$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$3674fe5722c4ea3d$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $3674fe5722c4ea3d$var$keyList(a);
        length = keys.length;
        if (length !== $3674fe5722c4ea3d$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$3674fe5722c4ea3d$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($3674fe5722c4ea3d$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$3674fe5722c4ea3d$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $3674fe5722c4ea3d$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("ldfW9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7172c9e597ad1b3$export$2e2bcd8739ae039; });
var $f7172c9e597ad1b3$var$isMergeableObject = function isMergeableObject(value) {
    return $f7172c9e597ad1b3$var$isNonNullObject(value) && !$f7172c9e597ad1b3$var$isSpecial(value);
};
function $f7172c9e597ad1b3$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $f7172c9e597ad1b3$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $f7172c9e597ad1b3$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $f7172c9e597ad1b3$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $f7172c9e597ad1b3$var$REACT_ELEMENT_TYPE = $f7172c9e597ad1b3$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $f7172c9e597ad1b3$var$isReactElement(value) {
    return value.$$typeof === $f7172c9e597ad1b3$var$REACT_ELEMENT_TYPE;
}
function $f7172c9e597ad1b3$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $f7172c9e597ad1b3$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $f7172c9e597ad1b3$var$deepmerge($f7172c9e597ad1b3$var$emptyTarget(value), value, options) : value;
}
function $f7172c9e597ad1b3$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $f7172c9e597ad1b3$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $f7172c9e597ad1b3$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $f7172c9e597ad1b3$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $f7172c9e597ad1b3$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $f7172c9e597ad1b3$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $f7172c9e597ad1b3$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $f7172c9e597ad1b3$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $f7172c9e597ad1b3$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $f7172c9e597ad1b3$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $f7172c9e597ad1b3$var$mergeObject(target, source, options);
}
$f7172c9e597ad1b3$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $f7172c9e597ad1b3$var$deepmerge(prev, next, options);
    }, {});
};
var $f7172c9e597ad1b3$var$deepmerge_1 = $f7172c9e597ad1b3$var$deepmerge;
var $f7172c9e597ad1b3$export$2e2bcd8739ae039 = $f7172c9e597ad1b3$var$deepmerge_1;

});

parcelRegister("h8EF0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7a2b9587882db8e$export$2e2bcd8739ae039; });

var $93yXN = parcelRequire("93yXN");

var $daOsy = parcelRequire("daOsy");

var $1g8Rw = parcelRequire("1g8Rw");
/** `Object#toString` result references. */ var $c7a2b9587882db8e$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $c7a2b9587882db8e$var$funcProto = Function.prototype, $c7a2b9587882db8e$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $c7a2b9587882db8e$var$funcToString = $c7a2b9587882db8e$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c7a2b9587882db8e$var$hasOwnProperty = $c7a2b9587882db8e$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $c7a2b9587882db8e$var$objectCtorString = $c7a2b9587882db8e$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $c7a2b9587882db8e$var$isPlainObject(value) {
    if (!(0, $1g8Rw.default)(value) || (0, $93yXN.default)(value) != $c7a2b9587882db8e$var$objectTag) return false;
    var proto = (0, $daOsy.default)(value);
    if (proto === null) return true;
    var Ctor = $c7a2b9587882db8e$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $c7a2b9587882db8e$var$funcToString.call(Ctor) == $c7a2b9587882db8e$var$objectCtorString;
}
var $c7a2b9587882db8e$export$2e2bcd8739ae039 = $c7a2b9587882db8e$var$isPlainObject;

});
parcelRegister("93yXN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $697f83e08c49f881$export$2e2bcd8739ae039; });

var $2u0qg = parcelRequire("2u0qg");

var $jj3Fy = parcelRequire("jj3Fy");

var $2gjn4 = parcelRequire("2gjn4");
/** `Object#toString` result references. */ var $697f83e08c49f881$var$nullTag = '[object Null]', $697f83e08c49f881$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $697f83e08c49f881$var$symToStringTag = (0, $2u0qg.default) ? (0, $2u0qg.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $697f83e08c49f881$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $697f83e08c49f881$var$undefinedTag : $697f83e08c49f881$var$nullTag;
    return $697f83e08c49f881$var$symToStringTag && $697f83e08c49f881$var$symToStringTag in Object(value) ? (0, $jj3Fy.default)(value) : (0, $2gjn4.default)(value);
}
var $697f83e08c49f881$export$2e2bcd8739ae039 = $697f83e08c49f881$var$baseGetTag;

});
parcelRegister("2u0qg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ceeb604227bc5da$export$2e2bcd8739ae039; });

var $8CDLW = parcelRequire("8CDLW");
/** Built-in value references. */ var $1ceeb604227bc5da$var$Symbol = (0, $8CDLW.default).Symbol;
var $1ceeb604227bc5da$export$2e2bcd8739ae039 = $1ceeb604227bc5da$var$Symbol;

});
parcelRegister("8CDLW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6470b94a565bf685$export$2e2bcd8739ae039; });

var $3qFrv = parcelRequire("3qFrv");
/** Detect free variable `self`. */ var $6470b94a565bf685$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $6470b94a565bf685$var$root = (0, $3qFrv.default) || $6470b94a565bf685$var$freeSelf || Function('return this')();
var $6470b94a565bf685$export$2e2bcd8739ae039 = $6470b94a565bf685$var$root;

});
parcelRegister("3qFrv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27f3f279dd2666cd$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $27f3f279dd2666cd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $27f3f279dd2666cd$export$2e2bcd8739ae039 = $27f3f279dd2666cd$var$freeGlobal;

});



parcelRegister("jj3Fy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0e2a352a13f720f$export$2e2bcd8739ae039; });

var $2u0qg = parcelRequire("2u0qg");
/** Used for built-in method references. */ var $e0e2a352a13f720f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e0e2a352a13f720f$var$hasOwnProperty = $e0e2a352a13f720f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e0e2a352a13f720f$var$nativeObjectToString = $e0e2a352a13f720f$var$objectProto.toString;
/** Built-in value references. */ var $e0e2a352a13f720f$var$symToStringTag = (0, $2u0qg.default) ? (0, $2u0qg.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $e0e2a352a13f720f$var$getRawTag(value) {
    var isOwn = $e0e2a352a13f720f$var$hasOwnProperty.call(value, $e0e2a352a13f720f$var$symToStringTag), tag = value[$e0e2a352a13f720f$var$symToStringTag];
    try {
        value[$e0e2a352a13f720f$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $e0e2a352a13f720f$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$e0e2a352a13f720f$var$symToStringTag] = tag;
        else delete value[$e0e2a352a13f720f$var$symToStringTag];
    }
    return result;
}
var $e0e2a352a13f720f$export$2e2bcd8739ae039 = $e0e2a352a13f720f$var$getRawTag;

});

parcelRegister("2gjn4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a5c1a1b43ca199e$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $1a5c1a1b43ca199e$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1a5c1a1b43ca199e$var$nativeObjectToString = $1a5c1a1b43ca199e$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $1a5c1a1b43ca199e$var$objectToString(value) {
    return $1a5c1a1b43ca199e$var$nativeObjectToString.call(value);
}
var $1a5c1a1b43ca199e$export$2e2bcd8739ae039 = $1a5c1a1b43ca199e$var$objectToString;

});


parcelRegister("daOsy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $997359bf8de5d68e$export$2e2bcd8739ae039; });

var $hSyP8 = parcelRequire("hSyP8");
/** Built-in value references. */ var $997359bf8de5d68e$var$getPrototype = (0, $hSyP8.default)(Object.getPrototypeOf, Object);
var $997359bf8de5d68e$export$2e2bcd8739ae039 = $997359bf8de5d68e$var$getPrototype;

});
parcelRegister("hSyP8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0427e126f5f952f$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $d0427e126f5f952f$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $d0427e126f5f952f$export$2e2bcd8739ae039 = $d0427e126f5f952f$var$overArg;

});


parcelRegister("1g8Rw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0eae28e79018c44d$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $0eae28e79018c44d$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $0eae28e79018c44d$export$2e2bcd8739ae039 = $0eae28e79018c44d$var$isObjectLike;

});


parcelRegister("jY8Ms", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e89a6e91132d21fa$export$2e2bcd8739ae039; });

var $3m59F = parcelRequire("3m59F");
/** Used to compose bitmasks for cloning. */ var $e89a6e91132d21fa$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $e89a6e91132d21fa$var$clone(value) {
    return (0, $3m59F.default)(value, $e89a6e91132d21fa$var$CLONE_SYMBOLS_FLAG);
}
var $e89a6e91132d21fa$export$2e2bcd8739ae039 = $e89a6e91132d21fa$var$clone;

});
parcelRegister("3m59F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27176cdaddc4d3e0$export$2e2bcd8739ae039; });

var $1quOP = parcelRequire("1quOP");

var $75VIz = parcelRequire("75VIz");

var $1zllh = parcelRequire("1zllh");

var $hBcJt = parcelRequire("hBcJt");

var $akXBN = parcelRequire("akXBN");

var $7Ohy1 = parcelRequire("7Ohy1");

var $7542D = parcelRequire("7542D");

var $fbMCH = parcelRequire("fbMCH");

var $kylCV = parcelRequire("kylCV");

var $1T43p = parcelRequire("1T43p");

var $kNHgh = parcelRequire("kNHgh");

var $bly3Q = parcelRequire("bly3Q");

var $hvhLZ = parcelRequire("hvhLZ");

var $9O4gO = parcelRequire("9O4gO");

var $4STpn = parcelRequire("4STpn");

var $kT11y = parcelRequire("kT11y");

var $bGao0 = parcelRequire("bGao0");

var $307ff = parcelRequire("307ff");

var $cRjGZ = parcelRequire("cRjGZ");

var $3NA4N = parcelRequire("3NA4N");

var $aZPAT = parcelRequire("aZPAT");

var $e1dAa = parcelRequire("e1dAa");
/** Used to compose bitmasks for cloning. */ var $27176cdaddc4d3e0$var$CLONE_DEEP_FLAG = 1, $27176cdaddc4d3e0$var$CLONE_FLAT_FLAG = 2, $27176cdaddc4d3e0$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $27176cdaddc4d3e0$var$argsTag = '[object Arguments]', $27176cdaddc4d3e0$var$arrayTag = '[object Array]', $27176cdaddc4d3e0$var$boolTag = '[object Boolean]', $27176cdaddc4d3e0$var$dateTag = '[object Date]', $27176cdaddc4d3e0$var$errorTag = '[object Error]', $27176cdaddc4d3e0$var$funcTag = '[object Function]', $27176cdaddc4d3e0$var$genTag = '[object GeneratorFunction]', $27176cdaddc4d3e0$var$mapTag = '[object Map]', $27176cdaddc4d3e0$var$numberTag = '[object Number]', $27176cdaddc4d3e0$var$objectTag = '[object Object]', $27176cdaddc4d3e0$var$regexpTag = '[object RegExp]', $27176cdaddc4d3e0$var$setTag = '[object Set]', $27176cdaddc4d3e0$var$stringTag = '[object String]', $27176cdaddc4d3e0$var$symbolTag = '[object Symbol]', $27176cdaddc4d3e0$var$weakMapTag = '[object WeakMap]';
var $27176cdaddc4d3e0$var$arrayBufferTag = '[object ArrayBuffer]', $27176cdaddc4d3e0$var$dataViewTag = '[object DataView]', $27176cdaddc4d3e0$var$float32Tag = '[object Float32Array]', $27176cdaddc4d3e0$var$float64Tag = '[object Float64Array]', $27176cdaddc4d3e0$var$int8Tag = '[object Int8Array]', $27176cdaddc4d3e0$var$int16Tag = '[object Int16Array]', $27176cdaddc4d3e0$var$int32Tag = '[object Int32Array]', $27176cdaddc4d3e0$var$uint8Tag = '[object Uint8Array]', $27176cdaddc4d3e0$var$uint8ClampedTag = '[object Uint8ClampedArray]', $27176cdaddc4d3e0$var$uint16Tag = '[object Uint16Array]', $27176cdaddc4d3e0$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $27176cdaddc4d3e0$var$cloneableTags = {};
$27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$argsTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$arrayTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$arrayBufferTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$dataViewTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$boolTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$dateTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$float32Tag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$float64Tag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$int8Tag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$int16Tag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$int32Tag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$mapTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$numberTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$objectTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$regexpTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$setTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$stringTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$symbolTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$uint8Tag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$uint8ClampedTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$uint16Tag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$uint32Tag] = true;
$27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$errorTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$funcTag] = $27176cdaddc4d3e0$var$cloneableTags[$27176cdaddc4d3e0$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $27176cdaddc4d3e0$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $27176cdaddc4d3e0$var$CLONE_DEEP_FLAG, isFlat = bitmask & $27176cdaddc4d3e0$var$CLONE_FLAT_FLAG, isFull = bitmask & $27176cdaddc4d3e0$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $cRjGZ.default)(value)) return value;
    var isArr = (0, $kT11y.default)(value);
    if (isArr) {
        result = (0, $hvhLZ.default)(value);
        if (!isDeep) return (0, $7542D.default)(value, result);
    } else {
        var tag = (0, $bly3Q.default)(value), isFunc = tag == $27176cdaddc4d3e0$var$funcTag || tag == $27176cdaddc4d3e0$var$genTag;
        if ((0, $bGao0.default)(value)) return (0, $7Ohy1.default)(value, isDeep);
        if (tag == $27176cdaddc4d3e0$var$objectTag || tag == $27176cdaddc4d3e0$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $4STpn.default)(value);
            if (!isDeep) return isFlat ? (0, $kylCV.default)(value, (0, $akXBN.default)(result, value)) : (0, $fbMCH.default)(value, (0, $hBcJt.default)(result, value));
        } else {
            if (!$27176cdaddc4d3e0$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $9O4gO.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $1quOP.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $3NA4N.default)(value)) value.forEach(function(subValue) {
        result.add($27176cdaddc4d3e0$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $307ff.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $27176cdaddc4d3e0$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $kNHgh.default) : (0, $1T43p.default) : isFlat ? (0, $e1dAa.default) : (0, $aZPAT.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $75VIz.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $1zllh.default)(result, key, $27176cdaddc4d3e0$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $27176cdaddc4d3e0$export$2e2bcd8739ae039 = $27176cdaddc4d3e0$var$baseClone;

});
parcelRegister("1quOP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10a0201c793d8e91$export$2e2bcd8739ae039; });

var $M83Pl = parcelRequire("M83Pl");

var $eNxUP = parcelRequire("eNxUP");

var $bdJsr = parcelRequire("bdJsr");

var $jxdQK = parcelRequire("jxdQK");

var $e75fJ = parcelRequire("e75fJ");

var $2psI5 = parcelRequire("2psI5");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $10a0201c793d8e91$var$Stack(entries) {
    var data = this.__data__ = new (0, $M83Pl.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$10a0201c793d8e91$var$Stack.prototype.clear = (0, $eNxUP.default);
$10a0201c793d8e91$var$Stack.prototype['delete'] = (0, $bdJsr.default);
$10a0201c793d8e91$var$Stack.prototype.get = (0, $jxdQK.default);
$10a0201c793d8e91$var$Stack.prototype.has = (0, $e75fJ.default);
$10a0201c793d8e91$var$Stack.prototype.set = (0, $2psI5.default);
var $10a0201c793d8e91$export$2e2bcd8739ae039 = $10a0201c793d8e91$var$Stack;

});
parcelRegister("M83Pl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $090abc8097305fd3$export$2e2bcd8739ae039; });

var $aZN5V = parcelRequire("aZN5V");

var $iC6bR = parcelRequire("iC6bR");

var $jq124 = parcelRequire("jq124");

var $3ae68 = parcelRequire("3ae68");

var $95rKM = parcelRequire("95rKM");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $090abc8097305fd3$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$090abc8097305fd3$var$ListCache.prototype.clear = (0, $aZN5V.default);
$090abc8097305fd3$var$ListCache.prototype['delete'] = (0, $iC6bR.default);
$090abc8097305fd3$var$ListCache.prototype.get = (0, $jq124.default);
$090abc8097305fd3$var$ListCache.prototype.has = (0, $3ae68.default);
$090abc8097305fd3$var$ListCache.prototype.set = (0, $95rKM.default);
var $090abc8097305fd3$export$2e2bcd8739ae039 = $090abc8097305fd3$var$ListCache;

});
parcelRegister("aZN5V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8015af0714305831$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $8015af0714305831$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $8015af0714305831$export$2e2bcd8739ae039 = $8015af0714305831$var$listCacheClear;

});

parcelRegister("iC6bR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8d093dd6d350579$export$2e2bcd8739ae039; });

var $3PwVO = parcelRequire("3PwVO");
/** Used for built-in method references. */ var $d8d093dd6d350579$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d8d093dd6d350579$var$splice = $d8d093dd6d350579$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d8d093dd6d350579$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $3PwVO.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d8d093dd6d350579$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $d8d093dd6d350579$export$2e2bcd8739ae039 = $d8d093dd6d350579$var$listCacheDelete;

});
parcelRegister("3PwVO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c9fae028e385f38$export$2e2bcd8739ae039; });

var $gWKGw = parcelRequire("gWKGw");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2c9fae028e385f38$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $gWKGw.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $2c9fae028e385f38$export$2e2bcd8739ae039 = $2c9fae028e385f38$var$assocIndexOf;

});
parcelRegister("gWKGw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c56646c049d97a8d$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $c56646c049d97a8d$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $c56646c049d97a8d$export$2e2bcd8739ae039 = $c56646c049d97a8d$var$eq;

});



parcelRegister("jq124", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2313f0c00291e40$export$2e2bcd8739ae039; });

var $3PwVO = parcelRequire("3PwVO");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e2313f0c00291e40$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $3PwVO.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $e2313f0c00291e40$export$2e2bcd8739ae039 = $e2313f0c00291e40$var$listCacheGet;

});

parcelRegister("3ae68", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24dd3dd36e0d4d5c$export$2e2bcd8739ae039; });

var $3PwVO = parcelRequire("3PwVO");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $24dd3dd36e0d4d5c$var$listCacheHas(key) {
    return (0, $3PwVO.default)(this.__data__, key) > -1;
}
var $24dd3dd36e0d4d5c$export$2e2bcd8739ae039 = $24dd3dd36e0d4d5c$var$listCacheHas;

});

parcelRegister("95rKM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69da1bf7409e6916$export$2e2bcd8739ae039; });

var $3PwVO = parcelRequire("3PwVO");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $69da1bf7409e6916$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $3PwVO.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $69da1bf7409e6916$export$2e2bcd8739ae039 = $69da1bf7409e6916$var$listCacheSet;

});


parcelRegister("eNxUP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac5ff33b44c3d082$export$2e2bcd8739ae039; });

var $M83Pl = parcelRequire("M83Pl");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $ac5ff33b44c3d082$var$stackClear() {
    this.__data__ = new (0, $M83Pl.default);
    this.size = 0;
}
var $ac5ff33b44c3d082$export$2e2bcd8739ae039 = $ac5ff33b44c3d082$var$stackClear;

});

parcelRegister("bdJsr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82b42b924c9210a5$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $82b42b924c9210a5$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $82b42b924c9210a5$export$2e2bcd8739ae039 = $82b42b924c9210a5$var$stackDelete;

});

parcelRegister("jxdQK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e38bd7ab421d9e41$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e38bd7ab421d9e41$var$stackGet(key) {
    return this.__data__.get(key);
}
var $e38bd7ab421d9e41$export$2e2bcd8739ae039 = $e38bd7ab421d9e41$var$stackGet;

});

parcelRegister("e75fJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a465cb3d70c29d83$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a465cb3d70c29d83$var$stackHas(key) {
    return this.__data__.has(key);
}
var $a465cb3d70c29d83$export$2e2bcd8739ae039 = $a465cb3d70c29d83$var$stackHas;

});

parcelRegister("2psI5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c142fcf35ec0844$export$2e2bcd8739ae039; });

var $M83Pl = parcelRequire("M83Pl");

var $43Vob = parcelRequire("43Vob");

var $6CBG7 = parcelRequire("6CBG7");
/** Used as the size to enable large array optimizations. */ var $1c142fcf35ec0844$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $1c142fcf35ec0844$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $M83Pl.default)) {
        var pairs = data.__data__;
        if (!(0, $43Vob.default) || pairs.length < $1c142fcf35ec0844$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $6CBG7.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $1c142fcf35ec0844$export$2e2bcd8739ae039 = $1c142fcf35ec0844$var$stackSet;

});
parcelRegister("43Vob", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f53f57e0254e10e$export$2e2bcd8739ae039; });

var $8Fqap = parcelRequire("8Fqap");

var $8CDLW = parcelRequire("8CDLW");
/* Built-in method references that are verified to be native. */ var $2f53f57e0254e10e$var$Map = (0, $8Fqap.default)((0, $8CDLW.default), 'Map');
var $2f53f57e0254e10e$export$2e2bcd8739ae039 = $2f53f57e0254e10e$var$Map;

});
parcelRegister("8Fqap", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64f67344652e08fc$export$2e2bcd8739ae039; });

var $kMqkL = parcelRequire("kMqkL");

var $h6SDu = parcelRequire("h6SDu");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $64f67344652e08fc$var$getNative(object, key) {
    var value = (0, $h6SDu.default)(object, key);
    return (0, $kMqkL.default)(value) ? value : undefined;
}
var $64f67344652e08fc$export$2e2bcd8739ae039 = $64f67344652e08fc$var$getNative;

});
parcelRegister("kMqkL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f20cb7afe2568ac6$export$2e2bcd8739ae039; });

var $2u3CM = parcelRequire("2u3CM");

var $3AnX7 = parcelRequire("3AnX7");

var $cRjGZ = parcelRequire("cRjGZ");

var $dCE7s = parcelRequire("dCE7s");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $f20cb7afe2568ac6$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $f20cb7afe2568ac6$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $f20cb7afe2568ac6$var$funcProto = Function.prototype, $f20cb7afe2568ac6$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $f20cb7afe2568ac6$var$funcToString = $f20cb7afe2568ac6$var$funcProto.toString;
/** Used to check objects for own properties. */ var $f20cb7afe2568ac6$var$hasOwnProperty = $f20cb7afe2568ac6$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $f20cb7afe2568ac6$var$reIsNative = RegExp('^' + $f20cb7afe2568ac6$var$funcToString.call($f20cb7afe2568ac6$var$hasOwnProperty).replace($f20cb7afe2568ac6$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $f20cb7afe2568ac6$var$baseIsNative(value) {
    if (!(0, $cRjGZ.default)(value) || (0, $3AnX7.default)(value)) return false;
    var pattern = (0, $2u3CM.default)(value) ? $f20cb7afe2568ac6$var$reIsNative : $f20cb7afe2568ac6$var$reIsHostCtor;
    return pattern.test((0, $dCE7s.default)(value));
}
var $f20cb7afe2568ac6$export$2e2bcd8739ae039 = $f20cb7afe2568ac6$var$baseIsNative;

});
parcelRegister("2u3CM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cf131e241aade1c$export$2e2bcd8739ae039; });

var $93yXN = parcelRequire("93yXN");

var $cRjGZ = parcelRequire("cRjGZ");
/** `Object#toString` result references. */ var $1cf131e241aade1c$var$asyncTag = '[object AsyncFunction]', $1cf131e241aade1c$var$funcTag = '[object Function]', $1cf131e241aade1c$var$genTag = '[object GeneratorFunction]', $1cf131e241aade1c$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $1cf131e241aade1c$var$isFunction(value) {
    if (!(0, $cRjGZ.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $93yXN.default)(value);
    return tag == $1cf131e241aade1c$var$funcTag || tag == $1cf131e241aade1c$var$genTag || tag == $1cf131e241aade1c$var$asyncTag || tag == $1cf131e241aade1c$var$proxyTag;
}
var $1cf131e241aade1c$export$2e2bcd8739ae039 = $1cf131e241aade1c$var$isFunction;

});
parcelRegister("cRjGZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95c9b5c468ae9573$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $95c9b5c468ae9573$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $95c9b5c468ae9573$export$2e2bcd8739ae039 = $95c9b5c468ae9573$var$isObject;

});


parcelRegister("3AnX7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29c7505cad9d2714$export$2e2bcd8739ae039; });

var $WSPD9 = parcelRequire("WSPD9");
/** Used to detect methods masquerading as native. */ var $29c7505cad9d2714$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $WSPD9.default) && (0, $WSPD9.default).keys && (0, $WSPD9.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $29c7505cad9d2714$var$isMasked(func) {
    return !!$29c7505cad9d2714$var$maskSrcKey && $29c7505cad9d2714$var$maskSrcKey in func;
}
var $29c7505cad9d2714$export$2e2bcd8739ae039 = $29c7505cad9d2714$var$isMasked;

});
parcelRegister("WSPD9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b0ff3566203ac9e$export$2e2bcd8739ae039; });

var $8CDLW = parcelRequire("8CDLW");
/** Used to detect overreaching core-js shims. */ var $0b0ff3566203ac9e$var$coreJsData = (0, $8CDLW.default)['__core-js_shared__'];
var $0b0ff3566203ac9e$export$2e2bcd8739ae039 = $0b0ff3566203ac9e$var$coreJsData;

});


parcelRegister("dCE7s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9eadf1d0d1736e08$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $9eadf1d0d1736e08$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9eadf1d0d1736e08$var$funcToString = $9eadf1d0d1736e08$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9eadf1d0d1736e08$var$toSource(func) {
    if (func != null) {
        try {
            return $9eadf1d0d1736e08$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $9eadf1d0d1736e08$export$2e2bcd8739ae039 = $9eadf1d0d1736e08$var$toSource;

});


parcelRegister("h6SDu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c74d60c3ab71f2c5$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $c74d60c3ab71f2c5$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $c74d60c3ab71f2c5$export$2e2bcd8739ae039 = $c74d60c3ab71f2c5$var$getValue;

});



parcelRegister("6CBG7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d2384d7936b270a$export$2e2bcd8739ae039; });

var $9zEp5 = parcelRequire("9zEp5");

var $cxXeY = parcelRequire("cxXeY");

var $jFXeW = parcelRequire("jFXeW");

var $lNL5a = parcelRequire("lNL5a");

var $3XRQa = parcelRequire("3XRQa");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4d2384d7936b270a$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4d2384d7936b270a$var$MapCache.prototype.clear = (0, $9zEp5.default);
$4d2384d7936b270a$var$MapCache.prototype['delete'] = (0, $cxXeY.default);
$4d2384d7936b270a$var$MapCache.prototype.get = (0, $jFXeW.default);
$4d2384d7936b270a$var$MapCache.prototype.has = (0, $lNL5a.default);
$4d2384d7936b270a$var$MapCache.prototype.set = (0, $3XRQa.default);
var $4d2384d7936b270a$export$2e2bcd8739ae039 = $4d2384d7936b270a$var$MapCache;

});
parcelRegister("9zEp5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f86b944b888105b$export$2e2bcd8739ae039; });

var $9kXk6 = parcelRequire("9kXk6");

var $M83Pl = parcelRequire("M83Pl");

var $43Vob = parcelRequire("43Vob");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $6f86b944b888105b$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $9kXk6.default),
        'map': new ((0, $43Vob.default) || (0, $M83Pl.default)),
        'string': new (0, $9kXk6.default)
    };
}
var $6f86b944b888105b$export$2e2bcd8739ae039 = $6f86b944b888105b$var$mapCacheClear;

});
parcelRegister("9kXk6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cc3ffa67baf12ff$export$2e2bcd8739ae039; });

var $ftJhx = parcelRequire("ftJhx");

var $fEvR8 = parcelRequire("fEvR8");

var $45I2r = parcelRequire("45I2r");

var $1c9sr = parcelRequire("1c9sr");

var $jFKpx = parcelRequire("jFKpx");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6cc3ffa67baf12ff$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$6cc3ffa67baf12ff$var$Hash.prototype.clear = (0, $ftJhx.default);
$6cc3ffa67baf12ff$var$Hash.prototype['delete'] = (0, $fEvR8.default);
$6cc3ffa67baf12ff$var$Hash.prototype.get = (0, $45I2r.default);
$6cc3ffa67baf12ff$var$Hash.prototype.has = (0, $1c9sr.default);
$6cc3ffa67baf12ff$var$Hash.prototype.set = (0, $jFKpx.default);
var $6cc3ffa67baf12ff$export$2e2bcd8739ae039 = $6cc3ffa67baf12ff$var$Hash;

});
parcelRegister("ftJhx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b44cb08182877846$export$2e2bcd8739ae039; });

var $bMM8d = parcelRequire("bMM8d");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $b44cb08182877846$var$hashClear() {
    this.__data__ = (0, $bMM8d.default) ? (0, $bMM8d.default)(null) : {};
    this.size = 0;
}
var $b44cb08182877846$export$2e2bcd8739ae039 = $b44cb08182877846$var$hashClear;

});
parcelRegister("bMM8d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $894983574111fc89$export$2e2bcd8739ae039; });

var $8Fqap = parcelRequire("8Fqap");
/* Built-in method references that are verified to be native. */ var $894983574111fc89$var$nativeCreate = (0, $8Fqap.default)(Object, 'create');
var $894983574111fc89$export$2e2bcd8739ae039 = $894983574111fc89$var$nativeCreate;

});


parcelRegister("fEvR8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6534d611780eceb$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b6534d611780eceb$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $b6534d611780eceb$export$2e2bcd8739ae039 = $b6534d611780eceb$var$hashDelete;

});

parcelRegister("45I2r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fa9ca2481006ea8$export$2e2bcd8739ae039; });

var $bMM8d = parcelRequire("bMM8d");
/** Used to stand-in for `undefined` hash values. */ var $2fa9ca2481006ea8$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $2fa9ca2481006ea8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2fa9ca2481006ea8$var$hasOwnProperty = $2fa9ca2481006ea8$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2fa9ca2481006ea8$var$hashGet(key) {
    var data = this.__data__;
    if (0, $bMM8d.default) {
        var result = data[key];
        return result === $2fa9ca2481006ea8$var$HASH_UNDEFINED ? undefined : result;
    }
    return $2fa9ca2481006ea8$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $2fa9ca2481006ea8$export$2e2bcd8739ae039 = $2fa9ca2481006ea8$var$hashGet;

});

parcelRegister("1c9sr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0dee3f8aeb4872ba$export$2e2bcd8739ae039; });

var $bMM8d = parcelRequire("bMM8d");
/** Used for built-in method references. */ var $0dee3f8aeb4872ba$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0dee3f8aeb4872ba$var$hasOwnProperty = $0dee3f8aeb4872ba$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0dee3f8aeb4872ba$var$hashHas(key) {
    var data = this.__data__;
    return (0, $bMM8d.default) ? data[key] !== undefined : $0dee3f8aeb4872ba$var$hasOwnProperty.call(data, key);
}
var $0dee3f8aeb4872ba$export$2e2bcd8739ae039 = $0dee3f8aeb4872ba$var$hashHas;

});

parcelRegister("jFKpx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e525d8e99b1c6b8f$export$2e2bcd8739ae039; });

var $bMM8d = parcelRequire("bMM8d");
/** Used to stand-in for `undefined` hash values. */ var $e525d8e99b1c6b8f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $e525d8e99b1c6b8f$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $bMM8d.default) && value === undefined ? $e525d8e99b1c6b8f$var$HASH_UNDEFINED : value;
    return this;
}
var $e525d8e99b1c6b8f$export$2e2bcd8739ae039 = $e525d8e99b1c6b8f$var$hashSet;

});



parcelRegister("cxXeY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9226850eca37a2f1$export$2e2bcd8739ae039; });

var $bMiES = parcelRequire("bMiES");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9226850eca37a2f1$var$mapCacheDelete(key) {
    var result = (0, $bMiES.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $9226850eca37a2f1$export$2e2bcd8739ae039 = $9226850eca37a2f1$var$mapCacheDelete;

});
parcelRegister("bMiES", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8932a693aa5af8ce$export$2e2bcd8739ae039; });

var $lJwWG = parcelRequire("lJwWG");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $8932a693aa5af8ce$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $lJwWG.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $8932a693aa5af8ce$export$2e2bcd8739ae039 = $8932a693aa5af8ce$var$getMapData;

});
parcelRegister("lJwWG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd275b41dddafba0$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $fd275b41dddafba0$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $fd275b41dddafba0$export$2e2bcd8739ae039 = $fd275b41dddafba0$var$isKeyable;

});



parcelRegister("jFXeW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e52fcc790972ba0c$export$2e2bcd8739ae039; });

var $bMiES = parcelRequire("bMiES");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e52fcc790972ba0c$var$mapCacheGet(key) {
    return (0, $bMiES.default)(this, key).get(key);
}
var $e52fcc790972ba0c$export$2e2bcd8739ae039 = $e52fcc790972ba0c$var$mapCacheGet;

});

parcelRegister("lNL5a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdf2b2225e6a6e19$export$2e2bcd8739ae039; });

var $bMiES = parcelRequire("bMiES");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fdf2b2225e6a6e19$var$mapCacheHas(key) {
    return (0, $bMiES.default)(this, key).has(key);
}
var $fdf2b2225e6a6e19$export$2e2bcd8739ae039 = $fdf2b2225e6a6e19$var$mapCacheHas;

});

parcelRegister("3XRQa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e30a562d7ebf051$export$2e2bcd8739ae039; });

var $bMiES = parcelRequire("bMiES");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $2e30a562d7ebf051$var$mapCacheSet(key, value) {
    var data = (0, $bMiES.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $2e30a562d7ebf051$export$2e2bcd8739ae039 = $2e30a562d7ebf051$var$mapCacheSet;

});




parcelRegister("75VIz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52a5c5948068a235$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $52a5c5948068a235$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $52a5c5948068a235$export$2e2bcd8739ae039 = $52a5c5948068a235$var$arrayEach;

});

parcelRegister("1zllh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12499d783b4484d5$export$2e2bcd8739ae039; });

var $cuezR = parcelRequire("cuezR");

var $gWKGw = parcelRequire("gWKGw");
/** Used for built-in method references. */ var $12499d783b4484d5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $12499d783b4484d5$var$hasOwnProperty = $12499d783b4484d5$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $12499d783b4484d5$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($12499d783b4484d5$var$hasOwnProperty.call(object, key) && (0, $gWKGw.default)(objValue, value)) || value === undefined && !(key in object)) (0, $cuezR.default)(object, key, value);
}
var $12499d783b4484d5$export$2e2bcd8739ae039 = $12499d783b4484d5$var$assignValue;

});
parcelRegister("cuezR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91739827a0e24d43$export$2e2bcd8739ae039; });

var $67l52 = parcelRequire("67l52");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $91739827a0e24d43$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $67l52.default)) (0, $67l52.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $91739827a0e24d43$export$2e2bcd8739ae039 = $91739827a0e24d43$var$baseAssignValue;

});
parcelRegister("67l52", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4743bfa45b77573a$export$2e2bcd8739ae039; });

var $8Fqap = parcelRequire("8Fqap");
var $4743bfa45b77573a$var$defineProperty = function() {
    try {
        var func = (0, $8Fqap.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $4743bfa45b77573a$export$2e2bcd8739ae039 = $4743bfa45b77573a$var$defineProperty;

});



parcelRegister("hBcJt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccffc4bfc14c893e$export$2e2bcd8739ae039; });

var $lb2CG = parcelRequire("lb2CG");

var $aZPAT = parcelRequire("aZPAT");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $ccffc4bfc14c893e$var$baseAssign(object, source) {
    return object && (0, $lb2CG.default)(source, (0, $aZPAT.default)(source), object);
}
var $ccffc4bfc14c893e$export$2e2bcd8739ae039 = $ccffc4bfc14c893e$var$baseAssign;

});
parcelRegister("lb2CG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6aca8ee95a7603f$export$2e2bcd8739ae039; });

var $1zllh = parcelRequire("1zllh");

var $cuezR = parcelRequire("cuezR");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $f6aca8ee95a7603f$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $cuezR.default)(object, key, newValue);
        else (0, $1zllh.default)(object, key, newValue);
    }
    return object;
}
var $f6aca8ee95a7603f$export$2e2bcd8739ae039 = $f6aca8ee95a7603f$var$copyObject;

});

parcelRegister("aZPAT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80179f643b430174$export$2e2bcd8739ae039; });

var $gl5yP = parcelRequire("gl5yP");

var $6RtEm = parcelRequire("6RtEm");

var $97lta = parcelRequire("97lta");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $80179f643b430174$var$keys(object) {
    return (0, $97lta.default)(object) ? (0, $gl5yP.default)(object) : (0, $6RtEm.default)(object);
}
var $80179f643b430174$export$2e2bcd8739ae039 = $80179f643b430174$var$keys;

});
parcelRegister("gl5yP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be52ebbc6b1b600a$export$2e2bcd8739ae039; });

var $3K3Ah = parcelRequire("3K3Ah");

var $3YFGP = parcelRequire("3YFGP");

var $kT11y = parcelRequire("kT11y");

var $bGao0 = parcelRequire("bGao0");

var $3JT4K = parcelRequire("3JT4K");

var $lFgL3 = parcelRequire("lFgL3");
/** Used for built-in method references. */ var $be52ebbc6b1b600a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $be52ebbc6b1b600a$var$hasOwnProperty = $be52ebbc6b1b600a$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $be52ebbc6b1b600a$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $kT11y.default)(value), isArg = !isArr && (0, $3YFGP.default)(value), isBuff = !isArr && !isArg && (0, $bGao0.default)(value), isType = !isArr && !isArg && !isBuff && (0, $lFgL3.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $3K3Ah.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $be52ebbc6b1b600a$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $3JT4K.default)(key, length)))) result.push(key);
    return result;
}
var $be52ebbc6b1b600a$export$2e2bcd8739ae039 = $be52ebbc6b1b600a$var$arrayLikeKeys;

});
parcelRegister("3K3Ah", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b9872ba22c2671e$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $2b9872ba22c2671e$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $2b9872ba22c2671e$export$2e2bcd8739ae039 = $2b9872ba22c2671e$var$baseTimes;

});

parcelRegister("3YFGP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e57506ee16e380c$export$2e2bcd8739ae039; });

var $iOqCp = parcelRequire("iOqCp");

var $1g8Rw = parcelRequire("1g8Rw");
/** Used for built-in method references. */ var $2e57506ee16e380c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2e57506ee16e380c$var$hasOwnProperty = $2e57506ee16e380c$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $2e57506ee16e380c$var$propertyIsEnumerable = $2e57506ee16e380c$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $2e57506ee16e380c$var$isArguments = (0, $iOqCp.default)(function() {
    return arguments;
}()) ? (0, $iOqCp.default) : function(value) {
    return (0, $1g8Rw.default)(value) && $2e57506ee16e380c$var$hasOwnProperty.call(value, 'callee') && !$2e57506ee16e380c$var$propertyIsEnumerable.call(value, 'callee');
};
var $2e57506ee16e380c$export$2e2bcd8739ae039 = $2e57506ee16e380c$var$isArguments;

});
parcelRegister("iOqCp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db218b61364bab5e$export$2e2bcd8739ae039; });

var $93yXN = parcelRequire("93yXN");

var $1g8Rw = parcelRequire("1g8Rw");
/** `Object#toString` result references. */ var $db218b61364bab5e$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $db218b61364bab5e$var$baseIsArguments(value) {
    return (0, $1g8Rw.default)(value) && (0, $93yXN.default)(value) == $db218b61364bab5e$var$argsTag;
}
var $db218b61364bab5e$export$2e2bcd8739ae039 = $db218b61364bab5e$var$baseIsArguments;

});


parcelRegister("kT11y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f349bd0d5e224129$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $f349bd0d5e224129$var$isArray = Array.isArray;
var $f349bd0d5e224129$export$2e2bcd8739ae039 = $f349bd0d5e224129$var$isArray;

});

parcelRegister("bGao0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $880bac72cde66500$export$2e2bcd8739ae039; });

var $8CDLW = parcelRequire("8CDLW");

var $h41yH = parcelRequire("h41yH");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $8CDLW.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $h41yH.default);
var $880bac72cde66500$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("h41yH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6c404eeefbdd6c6$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $c6c404eeefbdd6c6$var$stubFalse() {
    return false;
}
var $c6c404eeefbdd6c6$export$2e2bcd8739ae039 = $c6c404eeefbdd6c6$var$stubFalse;

});


parcelRegister("3JT4K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b904bee9ce51069$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $2b904bee9ce51069$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $2b904bee9ce51069$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $2b904bee9ce51069$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $2b904bee9ce51069$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $2b904bee9ce51069$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $2b904bee9ce51069$export$2e2bcd8739ae039 = $2b904bee9ce51069$var$isIndex;

});

parcelRegister("lFgL3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc5a6d19e6179c12$export$2e2bcd8739ae039; });

var $gbT02 = parcelRequire("gbT02");

var $1UOdp = parcelRequire("1UOdp");

var $eBBfU = parcelRequire("eBBfU");
/* Node.js helper references. */ var $fc5a6d19e6179c12$var$nodeIsTypedArray = (0, $eBBfU.default) && (0, $eBBfU.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $fc5a6d19e6179c12$var$isTypedArray = $fc5a6d19e6179c12$var$nodeIsTypedArray ? (0, $1UOdp.default)($fc5a6d19e6179c12$var$nodeIsTypedArray) : (0, $gbT02.default);
var $fc5a6d19e6179c12$export$2e2bcd8739ae039 = $fc5a6d19e6179c12$var$isTypedArray;

});
parcelRegister("gbT02", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc9856386214b53f$export$2e2bcd8739ae039; });

var $93yXN = parcelRequire("93yXN");

var $j4U5V = parcelRequire("j4U5V");

var $1g8Rw = parcelRequire("1g8Rw");
/** `Object#toString` result references. */ var $bc9856386214b53f$var$argsTag = '[object Arguments]', $bc9856386214b53f$var$arrayTag = '[object Array]', $bc9856386214b53f$var$boolTag = '[object Boolean]', $bc9856386214b53f$var$dateTag = '[object Date]', $bc9856386214b53f$var$errorTag = '[object Error]', $bc9856386214b53f$var$funcTag = '[object Function]', $bc9856386214b53f$var$mapTag = '[object Map]', $bc9856386214b53f$var$numberTag = '[object Number]', $bc9856386214b53f$var$objectTag = '[object Object]', $bc9856386214b53f$var$regexpTag = '[object RegExp]', $bc9856386214b53f$var$setTag = '[object Set]', $bc9856386214b53f$var$stringTag = '[object String]', $bc9856386214b53f$var$weakMapTag = '[object WeakMap]';
var $bc9856386214b53f$var$arrayBufferTag = '[object ArrayBuffer]', $bc9856386214b53f$var$dataViewTag = '[object DataView]', $bc9856386214b53f$var$float32Tag = '[object Float32Array]', $bc9856386214b53f$var$float64Tag = '[object Float64Array]', $bc9856386214b53f$var$int8Tag = '[object Int8Array]', $bc9856386214b53f$var$int16Tag = '[object Int16Array]', $bc9856386214b53f$var$int32Tag = '[object Int32Array]', $bc9856386214b53f$var$uint8Tag = '[object Uint8Array]', $bc9856386214b53f$var$uint8ClampedTag = '[object Uint8ClampedArray]', $bc9856386214b53f$var$uint16Tag = '[object Uint16Array]', $bc9856386214b53f$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $bc9856386214b53f$var$typedArrayTags = {};
$bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$float32Tag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$float64Tag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$int8Tag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$int16Tag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$int32Tag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$uint8Tag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$uint8ClampedTag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$uint16Tag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$uint32Tag] = true;
$bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$argsTag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$arrayTag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$arrayBufferTag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$boolTag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$dataViewTag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$dateTag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$errorTag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$funcTag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$mapTag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$numberTag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$objectTag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$regexpTag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$setTag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$stringTag] = $bc9856386214b53f$var$typedArrayTags[$bc9856386214b53f$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $bc9856386214b53f$var$baseIsTypedArray(value) {
    return (0, $1g8Rw.default)(value) && (0, $j4U5V.default)(value.length) && !!$bc9856386214b53f$var$typedArrayTags[(0, $93yXN.default)(value)];
}
var $bc9856386214b53f$export$2e2bcd8739ae039 = $bc9856386214b53f$var$baseIsTypedArray;

});
parcelRegister("j4U5V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de39e73faf30272f$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $de39e73faf30272f$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $de39e73faf30272f$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $de39e73faf30272f$var$MAX_SAFE_INTEGER;
}
var $de39e73faf30272f$export$2e2bcd8739ae039 = $de39e73faf30272f$var$isLength;

});


parcelRegister("1UOdp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1651f91ad40718b8$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $1651f91ad40718b8$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $1651f91ad40718b8$export$2e2bcd8739ae039 = $1651f91ad40718b8$var$baseUnary;

});

parcelRegister("eBBfU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa216b953a933810$export$2e2bcd8739ae039; });

var $3qFrv = parcelRequire("3qFrv");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $3qFrv.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $aa216b953a933810$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("6RtEm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4feeb12d0bd8de55$export$2e2bcd8739ae039; });

var $w2k6y = parcelRequire("w2k6y");

var $irr9W = parcelRequire("irr9W");
/** Used for built-in method references. */ var $4feeb12d0bd8de55$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4feeb12d0bd8de55$var$hasOwnProperty = $4feeb12d0bd8de55$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $4feeb12d0bd8de55$var$baseKeys(object) {
    if (!(0, $w2k6y.default)(object)) return (0, $irr9W.default)(object);
    var result = [];
    for(var key in Object(object))if ($4feeb12d0bd8de55$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $4feeb12d0bd8de55$export$2e2bcd8739ae039 = $4feeb12d0bd8de55$var$baseKeys;

});
parcelRegister("w2k6y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0604caa0715c230d$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $0604caa0715c230d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $0604caa0715c230d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $0604caa0715c230d$var$objectProto;
    return value === proto;
}
var $0604caa0715c230d$export$2e2bcd8739ae039 = $0604caa0715c230d$var$isPrototype;

});

parcelRegister("irr9W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6cfd0e24c83f410$export$2e2bcd8739ae039; });

var $hSyP8 = parcelRequire("hSyP8");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d6cfd0e24c83f410$var$nativeKeys = (0, $hSyP8.default)(Object.keys, Object);
var $d6cfd0e24c83f410$export$2e2bcd8739ae039 = $d6cfd0e24c83f410$var$nativeKeys;

});


parcelRegister("97lta", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a356be00f9fd292$export$2e2bcd8739ae039; });

var $2u3CM = parcelRequire("2u3CM");

var $j4U5V = parcelRequire("j4U5V");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $6a356be00f9fd292$var$isArrayLike(value) {
    return value != null && (0, $j4U5V.default)(value.length) && !(0, $2u3CM.default)(value);
}
var $6a356be00f9fd292$export$2e2bcd8739ae039 = $6a356be00f9fd292$var$isArrayLike;

});



parcelRegister("akXBN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $786a02a54d268237$export$2e2bcd8739ae039; });

var $lb2CG = parcelRequire("lb2CG");

var $e1dAa = parcelRequire("e1dAa");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $786a02a54d268237$var$baseAssignIn(object, source) {
    return object && (0, $lb2CG.default)(source, (0, $e1dAa.default)(source), object);
}
var $786a02a54d268237$export$2e2bcd8739ae039 = $786a02a54d268237$var$baseAssignIn;

});
parcelRegister("e1dAa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a34bb1d90513c24e$export$2e2bcd8739ae039; });

var $gl5yP = parcelRequire("gl5yP");

var $imVQM = parcelRequire("imVQM");

var $97lta = parcelRequire("97lta");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $a34bb1d90513c24e$var$keysIn(object) {
    return (0, $97lta.default)(object) ? (0, $gl5yP.default)(object, true) : (0, $imVQM.default)(object);
}
var $a34bb1d90513c24e$export$2e2bcd8739ae039 = $a34bb1d90513c24e$var$keysIn;

});
parcelRegister("imVQM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5f727e95ea6281e$export$2e2bcd8739ae039; });

var $cRjGZ = parcelRequire("cRjGZ");

var $w2k6y = parcelRequire("w2k6y");

var $aQCKf = parcelRequire("aQCKf");
/** Used for built-in method references. */ var $d5f727e95ea6281e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d5f727e95ea6281e$var$hasOwnProperty = $d5f727e95ea6281e$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $d5f727e95ea6281e$var$baseKeysIn(object) {
    if (!(0, $cRjGZ.default)(object)) return (0, $aQCKf.default)(object);
    var isProto = (0, $w2k6y.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$d5f727e95ea6281e$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $d5f727e95ea6281e$export$2e2bcd8739ae039 = $d5f727e95ea6281e$var$baseKeysIn;

});
parcelRegister("aQCKf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e5cd0a3f5c97ab0$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $7e5cd0a3f5c97ab0$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $7e5cd0a3f5c97ab0$export$2e2bcd8739ae039 = $7e5cd0a3f5c97ab0$var$nativeKeysIn;

});




parcelRegister("7Ohy1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5afad086a47bb45b$export$2e2bcd8739ae039; });

var $8CDLW = parcelRequire("8CDLW");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $8CDLW.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $5afad086a47bb45b$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("7542D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01549533fddb9749$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $01549533fddb9749$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $01549533fddb9749$export$2e2bcd8739ae039 = $01549533fddb9749$var$copyArray;

});

parcelRegister("fbMCH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0ed99a88d84b369$export$2e2bcd8739ae039; });

var $lb2CG = parcelRequire("lb2CG");

var $5Pvyb = parcelRequire("5Pvyb");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $b0ed99a88d84b369$var$copySymbols(source, object) {
    return (0, $lb2CG.default)(source, (0, $5Pvyb.default)(source), object);
}
var $b0ed99a88d84b369$export$2e2bcd8739ae039 = $b0ed99a88d84b369$var$copySymbols;

});
parcelRegister("5Pvyb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43ea3063e1d23b89$export$2e2bcd8739ae039; });

var $cwL2H = parcelRequire("cwL2H");

var $kyUmR = parcelRequire("kyUmR");
/** Used for built-in method references. */ var $43ea3063e1d23b89$var$objectProto = Object.prototype;
/** Built-in value references. */ var $43ea3063e1d23b89$var$propertyIsEnumerable = $43ea3063e1d23b89$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $43ea3063e1d23b89$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $43ea3063e1d23b89$var$getSymbols = !$43ea3063e1d23b89$var$nativeGetSymbols ? (0, $kyUmR.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $cwL2H.default)($43ea3063e1d23b89$var$nativeGetSymbols(object), function(symbol) {
        return $43ea3063e1d23b89$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $43ea3063e1d23b89$export$2e2bcd8739ae039 = $43ea3063e1d23b89$var$getSymbols;

});
parcelRegister("cwL2H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91ecf6e2c87fe30d$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $91ecf6e2c87fe30d$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $91ecf6e2c87fe30d$export$2e2bcd8739ae039 = $91ecf6e2c87fe30d$var$arrayFilter;

});

parcelRegister("kyUmR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef82b5124f44eb55$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $ef82b5124f44eb55$var$stubArray() {
    return [];
}
var $ef82b5124f44eb55$export$2e2bcd8739ae039 = $ef82b5124f44eb55$var$stubArray;

});



parcelRegister("kylCV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef67c23dfd12fe02$export$2e2bcd8739ae039; });

var $lb2CG = parcelRequire("lb2CG");

var $c3NGB = parcelRequire("c3NGB");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $ef67c23dfd12fe02$var$copySymbolsIn(source, object) {
    return (0, $lb2CG.default)(source, (0, $c3NGB.default)(source), object);
}
var $ef67c23dfd12fe02$export$2e2bcd8739ae039 = $ef67c23dfd12fe02$var$copySymbolsIn;

});
parcelRegister("c3NGB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c7c4e8019bacd66$export$2e2bcd8739ae039; });

var $82uFZ = parcelRequire("82uFZ");

var $daOsy = parcelRequire("daOsy");

var $5Pvyb = parcelRequire("5Pvyb");

var $kyUmR = parcelRequire("kyUmR");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8c7c4e8019bacd66$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $8c7c4e8019bacd66$var$getSymbolsIn = !$8c7c4e8019bacd66$var$nativeGetSymbols ? (0, $kyUmR.default) : function(object) {
    var result = [];
    while(object){
        (0, $82uFZ.default)(result, (0, $5Pvyb.default)(object));
        object = (0, $daOsy.default)(object);
    }
    return result;
};
var $8c7c4e8019bacd66$export$2e2bcd8739ae039 = $8c7c4e8019bacd66$var$getSymbolsIn;

});
parcelRegister("82uFZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5da64e4f6f0f8aa1$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $5da64e4f6f0f8aa1$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $5da64e4f6f0f8aa1$export$2e2bcd8739ae039 = $5da64e4f6f0f8aa1$var$arrayPush;

});



parcelRegister("1T43p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15fe1288acd58853$export$2e2bcd8739ae039; });

var $5P5i3 = parcelRequire("5P5i3");

var $5Pvyb = parcelRequire("5Pvyb");

var $aZPAT = parcelRequire("aZPAT");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $15fe1288acd58853$var$getAllKeys(object) {
    return (0, $5P5i3.default)(object, (0, $aZPAT.default), (0, $5Pvyb.default));
}
var $15fe1288acd58853$export$2e2bcd8739ae039 = $15fe1288acd58853$var$getAllKeys;

});
parcelRegister("5P5i3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43d5d1b159e70f28$export$2e2bcd8739ae039; });

var $82uFZ = parcelRequire("82uFZ");

var $kT11y = parcelRequire("kT11y");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $43d5d1b159e70f28$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $kT11y.default)(object) ? result : (0, $82uFZ.default)(result, symbolsFunc(object));
}
var $43d5d1b159e70f28$export$2e2bcd8739ae039 = $43d5d1b159e70f28$var$baseGetAllKeys;

});


parcelRegister("kNHgh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f249f11eefbf6152$export$2e2bcd8739ae039; });

var $5P5i3 = parcelRequire("5P5i3");

var $c3NGB = parcelRequire("c3NGB");

var $e1dAa = parcelRequire("e1dAa");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $f249f11eefbf6152$var$getAllKeysIn(object) {
    return (0, $5P5i3.default)(object, (0, $e1dAa.default), (0, $c3NGB.default));
}
var $f249f11eefbf6152$export$2e2bcd8739ae039 = $f249f11eefbf6152$var$getAllKeysIn;

});

parcelRegister("bly3Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $842c13b0d8a593b4$export$2e2bcd8739ae039; });

var $hVmCK = parcelRequire("hVmCK");

var $43Vob = parcelRequire("43Vob");

var $iiqhn = parcelRequire("iiqhn");

var $4tsGM = parcelRequire("4tsGM");

var $7tPi9 = parcelRequire("7tPi9");

var $93yXN = parcelRequire("93yXN");

var $dCE7s = parcelRequire("dCE7s");
/** `Object#toString` result references. */ var $842c13b0d8a593b4$var$mapTag = '[object Map]', $842c13b0d8a593b4$var$objectTag = '[object Object]', $842c13b0d8a593b4$var$promiseTag = '[object Promise]', $842c13b0d8a593b4$var$setTag = '[object Set]', $842c13b0d8a593b4$var$weakMapTag = '[object WeakMap]';
var $842c13b0d8a593b4$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $842c13b0d8a593b4$var$dataViewCtorString = (0, $dCE7s.default)((0, $hVmCK.default)), $842c13b0d8a593b4$var$mapCtorString = (0, $dCE7s.default)((0, $43Vob.default)), $842c13b0d8a593b4$var$promiseCtorString = (0, $dCE7s.default)((0, $iiqhn.default)), $842c13b0d8a593b4$var$setCtorString = (0, $dCE7s.default)((0, $4tsGM.default)), $842c13b0d8a593b4$var$weakMapCtorString = (0, $dCE7s.default)((0, $7tPi9.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $842c13b0d8a593b4$var$getTag = (0, $93yXN.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $hVmCK.default) && $842c13b0d8a593b4$var$getTag(new (0, $hVmCK.default)(new ArrayBuffer(1))) != $842c13b0d8a593b4$var$dataViewTag || (0, $43Vob.default) && $842c13b0d8a593b4$var$getTag(new (0, $43Vob.default)) != $842c13b0d8a593b4$var$mapTag || (0, $iiqhn.default) && $842c13b0d8a593b4$var$getTag((0, $iiqhn.default).resolve()) != $842c13b0d8a593b4$var$promiseTag || (0, $4tsGM.default) && $842c13b0d8a593b4$var$getTag(new (0, $4tsGM.default)) != $842c13b0d8a593b4$var$setTag || (0, $7tPi9.default) && $842c13b0d8a593b4$var$getTag(new (0, $7tPi9.default)) != $842c13b0d8a593b4$var$weakMapTag) $842c13b0d8a593b4$var$getTag = function(value) {
    var result = (0, $93yXN.default)(value), Ctor = result == $842c13b0d8a593b4$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $dCE7s.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $842c13b0d8a593b4$var$dataViewCtorString:
            return $842c13b0d8a593b4$var$dataViewTag;
        case $842c13b0d8a593b4$var$mapCtorString:
            return $842c13b0d8a593b4$var$mapTag;
        case $842c13b0d8a593b4$var$promiseCtorString:
            return $842c13b0d8a593b4$var$promiseTag;
        case $842c13b0d8a593b4$var$setCtorString:
            return $842c13b0d8a593b4$var$setTag;
        case $842c13b0d8a593b4$var$weakMapCtorString:
            return $842c13b0d8a593b4$var$weakMapTag;
    }
    return result;
};
var $842c13b0d8a593b4$export$2e2bcd8739ae039 = $842c13b0d8a593b4$var$getTag;

});
parcelRegister("hVmCK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0c94f32522f2f35$export$2e2bcd8739ae039; });

var $8Fqap = parcelRequire("8Fqap");

var $8CDLW = parcelRequire("8CDLW");
/* Built-in method references that are verified to be native. */ var $d0c94f32522f2f35$var$DataView = (0, $8Fqap.default)((0, $8CDLW.default), 'DataView');
var $d0c94f32522f2f35$export$2e2bcd8739ae039 = $d0c94f32522f2f35$var$DataView;

});

parcelRegister("iiqhn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d51e4aed8652d221$export$2e2bcd8739ae039; });

var $8Fqap = parcelRequire("8Fqap");

var $8CDLW = parcelRequire("8CDLW");
/* Built-in method references that are verified to be native. */ var $d51e4aed8652d221$var$Promise = (0, $8Fqap.default)((0, $8CDLW.default), 'Promise');
var $d51e4aed8652d221$export$2e2bcd8739ae039 = $d51e4aed8652d221$var$Promise;

});

parcelRegister("4tsGM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34201fe38d4384bf$export$2e2bcd8739ae039; });

var $8Fqap = parcelRequire("8Fqap");

var $8CDLW = parcelRequire("8CDLW");
/* Built-in method references that are verified to be native. */ var $34201fe38d4384bf$var$Set = (0, $8Fqap.default)((0, $8CDLW.default), 'Set');
var $34201fe38d4384bf$export$2e2bcd8739ae039 = $34201fe38d4384bf$var$Set;

});

parcelRegister("7tPi9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57230754f57081aa$export$2e2bcd8739ae039; });

var $8Fqap = parcelRequire("8Fqap");

var $8CDLW = parcelRequire("8CDLW");
/* Built-in method references that are verified to be native. */ var $57230754f57081aa$var$WeakMap = (0, $8Fqap.default)((0, $8CDLW.default), 'WeakMap');
var $57230754f57081aa$export$2e2bcd8739ae039 = $57230754f57081aa$var$WeakMap;

});


parcelRegister("hvhLZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbe31e4a94981da5$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $cbe31e4a94981da5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cbe31e4a94981da5$var$hasOwnProperty = $cbe31e4a94981da5$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $cbe31e4a94981da5$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $cbe31e4a94981da5$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $cbe31e4a94981da5$export$2e2bcd8739ae039 = $cbe31e4a94981da5$var$initCloneArray;

});

parcelRegister("9O4gO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $723c188519b2b3cd$export$2e2bcd8739ae039; });

var $j53YS = parcelRequire("j53YS");

var $a6hPX = parcelRequire("a6hPX");

var $dNWj0 = parcelRequire("dNWj0");

var $c3LWA = parcelRequire("c3LWA");

var $com4m = parcelRequire("com4m");
/** `Object#toString` result references. */ var $723c188519b2b3cd$var$boolTag = '[object Boolean]', $723c188519b2b3cd$var$dateTag = '[object Date]', $723c188519b2b3cd$var$mapTag = '[object Map]', $723c188519b2b3cd$var$numberTag = '[object Number]', $723c188519b2b3cd$var$regexpTag = '[object RegExp]', $723c188519b2b3cd$var$setTag = '[object Set]', $723c188519b2b3cd$var$stringTag = '[object String]', $723c188519b2b3cd$var$symbolTag = '[object Symbol]';
var $723c188519b2b3cd$var$arrayBufferTag = '[object ArrayBuffer]', $723c188519b2b3cd$var$dataViewTag = '[object DataView]', $723c188519b2b3cd$var$float32Tag = '[object Float32Array]', $723c188519b2b3cd$var$float64Tag = '[object Float64Array]', $723c188519b2b3cd$var$int8Tag = '[object Int8Array]', $723c188519b2b3cd$var$int16Tag = '[object Int16Array]', $723c188519b2b3cd$var$int32Tag = '[object Int32Array]', $723c188519b2b3cd$var$uint8Tag = '[object Uint8Array]', $723c188519b2b3cd$var$uint8ClampedTag = '[object Uint8ClampedArray]', $723c188519b2b3cd$var$uint16Tag = '[object Uint16Array]', $723c188519b2b3cd$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $723c188519b2b3cd$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $723c188519b2b3cd$var$arrayBufferTag:
            return (0, $j53YS.default)(object);
        case $723c188519b2b3cd$var$boolTag:
        case $723c188519b2b3cd$var$dateTag:
            return new Ctor(+object);
        case $723c188519b2b3cd$var$dataViewTag:
            return (0, $a6hPX.default)(object, isDeep);
        case $723c188519b2b3cd$var$float32Tag:
        case $723c188519b2b3cd$var$float64Tag:
        case $723c188519b2b3cd$var$int8Tag:
        case $723c188519b2b3cd$var$int16Tag:
        case $723c188519b2b3cd$var$int32Tag:
        case $723c188519b2b3cd$var$uint8Tag:
        case $723c188519b2b3cd$var$uint8ClampedTag:
        case $723c188519b2b3cd$var$uint16Tag:
        case $723c188519b2b3cd$var$uint32Tag:
            return (0, $com4m.default)(object, isDeep);
        case $723c188519b2b3cd$var$mapTag:
            return new Ctor;
        case $723c188519b2b3cd$var$numberTag:
        case $723c188519b2b3cd$var$stringTag:
            return new Ctor(object);
        case $723c188519b2b3cd$var$regexpTag:
            return (0, $dNWj0.default)(object);
        case $723c188519b2b3cd$var$setTag:
            return new Ctor;
        case $723c188519b2b3cd$var$symbolTag:
            return (0, $c3LWA.default)(object);
    }
}
var $723c188519b2b3cd$export$2e2bcd8739ae039 = $723c188519b2b3cd$var$initCloneByTag;

});
parcelRegister("j53YS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de4192734720063a$export$2e2bcd8739ae039; });

var $1LCnu = parcelRequire("1LCnu");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $de4192734720063a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $1LCnu.default)(result).set(new (0, $1LCnu.default)(arrayBuffer));
    return result;
}
var $de4192734720063a$export$2e2bcd8739ae039 = $de4192734720063a$var$cloneArrayBuffer;

});
parcelRegister("1LCnu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1497f347ba1b834f$export$2e2bcd8739ae039; });

var $8CDLW = parcelRequire("8CDLW");
/** Built-in value references. */ var $1497f347ba1b834f$var$Uint8Array = (0, $8CDLW.default).Uint8Array;
var $1497f347ba1b834f$export$2e2bcd8739ae039 = $1497f347ba1b834f$var$Uint8Array;

});


parcelRegister("a6hPX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75a84cf4ff4b651b$export$2e2bcd8739ae039; });

var $j53YS = parcelRequire("j53YS");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $75a84cf4ff4b651b$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $j53YS.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $75a84cf4ff4b651b$export$2e2bcd8739ae039 = $75a84cf4ff4b651b$var$cloneDataView;

});

parcelRegister("dNWj0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0cd143b4c0da0f0$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $a0cd143b4c0da0f0$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $a0cd143b4c0da0f0$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $a0cd143b4c0da0f0$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $a0cd143b4c0da0f0$export$2e2bcd8739ae039 = $a0cd143b4c0da0f0$var$cloneRegExp;

});

parcelRegister("c3LWA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c7af47e8f55345a$export$2e2bcd8739ae039; });

var $2u0qg = parcelRequire("2u0qg");
/** Used to convert symbols to primitives and strings. */ var $8c7af47e8f55345a$var$symbolProto = (0, $2u0qg.default) ? (0, $2u0qg.default).prototype : undefined, $8c7af47e8f55345a$var$symbolValueOf = $8c7af47e8f55345a$var$symbolProto ? $8c7af47e8f55345a$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $8c7af47e8f55345a$var$cloneSymbol(symbol) {
    return $8c7af47e8f55345a$var$symbolValueOf ? Object($8c7af47e8f55345a$var$symbolValueOf.call(symbol)) : {};
}
var $8c7af47e8f55345a$export$2e2bcd8739ae039 = $8c7af47e8f55345a$var$cloneSymbol;

});

parcelRegister("com4m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9058d874d0b40a35$export$2e2bcd8739ae039; });

var $j53YS = parcelRequire("j53YS");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $9058d874d0b40a35$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $j53YS.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $9058d874d0b40a35$export$2e2bcd8739ae039 = $9058d874d0b40a35$var$cloneTypedArray;

});


parcelRegister("4STpn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38e72f7e06e0f14f$export$2e2bcd8739ae039; });

var $5SKhw = parcelRequire("5SKhw");

var $daOsy = parcelRequire("daOsy");

var $w2k6y = parcelRequire("w2k6y");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $38e72f7e06e0f14f$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $w2k6y.default)(object) ? (0, $5SKhw.default)((0, $daOsy.default)(object)) : {};
}
var $38e72f7e06e0f14f$export$2e2bcd8739ae039 = $38e72f7e06e0f14f$var$initCloneObject;

});
parcelRegister("5SKhw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4485e5748d1c7711$export$2e2bcd8739ae039; });

var $cRjGZ = parcelRequire("cRjGZ");
/** Built-in value references. */ var $4485e5748d1c7711$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $4485e5748d1c7711$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $cRjGZ.default)(proto)) return {};
        if ($4485e5748d1c7711$var$objectCreate) return $4485e5748d1c7711$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $4485e5748d1c7711$export$2e2bcd8739ae039 = $4485e5748d1c7711$var$baseCreate;

});


parcelRegister("307ff", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22f6fde587b8cb0d$export$2e2bcd8739ae039; });

var $1PuHa = parcelRequire("1PuHa");

var $1UOdp = parcelRequire("1UOdp");

var $eBBfU = parcelRequire("eBBfU");
/* Node.js helper references. */ var $22f6fde587b8cb0d$var$nodeIsMap = (0, $eBBfU.default) && (0, $eBBfU.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $22f6fde587b8cb0d$var$isMap = $22f6fde587b8cb0d$var$nodeIsMap ? (0, $1UOdp.default)($22f6fde587b8cb0d$var$nodeIsMap) : (0, $1PuHa.default);
var $22f6fde587b8cb0d$export$2e2bcd8739ae039 = $22f6fde587b8cb0d$var$isMap;

});
parcelRegister("1PuHa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15525d4822cf201b$export$2e2bcd8739ae039; });

var $bly3Q = parcelRequire("bly3Q");

var $1g8Rw = parcelRequire("1g8Rw");
/** `Object#toString` result references. */ var $15525d4822cf201b$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $15525d4822cf201b$var$baseIsMap(value) {
    return (0, $1g8Rw.default)(value) && (0, $bly3Q.default)(value) == $15525d4822cf201b$var$mapTag;
}
var $15525d4822cf201b$export$2e2bcd8739ae039 = $15525d4822cf201b$var$baseIsMap;

});


parcelRegister("3NA4N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c41eeb69493b490$export$2e2bcd8739ae039; });

var $hrq1o = parcelRequire("hrq1o");

var $1UOdp = parcelRequire("1UOdp");

var $eBBfU = parcelRequire("eBBfU");
/* Node.js helper references. */ var $2c41eeb69493b490$var$nodeIsSet = (0, $eBBfU.default) && (0, $eBBfU.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $2c41eeb69493b490$var$isSet = $2c41eeb69493b490$var$nodeIsSet ? (0, $1UOdp.default)($2c41eeb69493b490$var$nodeIsSet) : (0, $hrq1o.default);
var $2c41eeb69493b490$export$2e2bcd8739ae039 = $2c41eeb69493b490$var$isSet;

});
parcelRegister("hrq1o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb2924979d18576b$export$2e2bcd8739ae039; });

var $bly3Q = parcelRequire("bly3Q");

var $1g8Rw = parcelRequire("1g8Rw");
/** `Object#toString` result references. */ var $cb2924979d18576b$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $cb2924979d18576b$var$baseIsSet(value) {
    return (0, $1g8Rw.default)(value) && (0, $bly3Q.default)(value) == $cb2924979d18576b$var$setTag;
}
var $cb2924979d18576b$export$2e2bcd8739ae039 = $cb2924979d18576b$var$baseIsSet;

});




parcelRegister("7IUCQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59f891198dd478cb$export$2e2bcd8739ae039; });

var $8w4ic = parcelRequire("8w4ic");

var $7542D = parcelRequire("7542D");

var $kT11y = parcelRequire("kT11y");

var $cHJLm = parcelRequire("cHJLm");

var $ksRJm = parcelRequire("ksRJm");

var $cdqUH = parcelRequire("cdqUH");

var $8T2Sb = parcelRequire("8T2Sb");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $59f891198dd478cb$var$toPath(value) {
    if ((0, $kT11y.default)(value)) return (0, $8w4ic.default)(value, (0, $cdqUH.default));
    return (0, $cHJLm.default)(value) ? [
        value
    ] : (0, $7542D.default)((0, $ksRJm.default)((0, $8T2Sb.default)(value)));
}
var $59f891198dd478cb$export$2e2bcd8739ae039 = $59f891198dd478cb$var$toPath;

});
parcelRegister("8w4ic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6334a44aacb2fbc7$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $6334a44aacb2fbc7$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $6334a44aacb2fbc7$export$2e2bcd8739ae039 = $6334a44aacb2fbc7$var$arrayMap;

});

parcelRegister("cHJLm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93fcffbad31d8b9f$export$2e2bcd8739ae039; });

var $93yXN = parcelRequire("93yXN");

var $1g8Rw = parcelRequire("1g8Rw");
/** `Object#toString` result references. */ var $93fcffbad31d8b9f$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $93fcffbad31d8b9f$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $1g8Rw.default)(value) && (0, $93yXN.default)(value) == $93fcffbad31d8b9f$var$symbolTag;
}
var $93fcffbad31d8b9f$export$2e2bcd8739ae039 = $93fcffbad31d8b9f$var$isSymbol;

});

parcelRegister("ksRJm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee6019f964771dea$export$2e2bcd8739ae039; });

var $eu367 = parcelRequire("eu367");
/** Used to match property names within property paths. */ var $ee6019f964771dea$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $ee6019f964771dea$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $ee6019f964771dea$var$stringToPath = (0, $eu367.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($ee6019f964771dea$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($ee6019f964771dea$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $ee6019f964771dea$export$2e2bcd8739ae039 = $ee6019f964771dea$var$stringToPath;

});
parcelRegister("eu367", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8b6452ba061e3ba$export$2e2bcd8739ae039; });

var $cX9mG = parcelRequire("cX9mG");
/** Used as the maximum memoize cache size. */ var $a8b6452ba061e3ba$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $a8b6452ba061e3ba$var$memoizeCapped(func) {
    var result = (0, $cX9mG.default)(func, function(key) {
        if (cache.size === $a8b6452ba061e3ba$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $a8b6452ba061e3ba$export$2e2bcd8739ae039 = $a8b6452ba061e3ba$var$memoizeCapped;

});
parcelRegister("cX9mG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96e2425ff37d93b0$export$2e2bcd8739ae039; });

var $6CBG7 = parcelRequire("6CBG7");
/** Error message constants. */ var $96e2425ff37d93b0$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $96e2425ff37d93b0$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($96e2425ff37d93b0$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($96e2425ff37d93b0$var$memoize.Cache || (0, $6CBG7.default));
    return memoized;
}
// Expose `MapCache`.
$96e2425ff37d93b0$var$memoize.Cache = (0, $6CBG7.default);
var $96e2425ff37d93b0$export$2e2bcd8739ae039 = $96e2425ff37d93b0$var$memoize;

});



parcelRegister("cdqUH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e4b93667e31211a$export$2e2bcd8739ae039; });

var $cHJLm = parcelRequire("cHJLm");
/** Used as references for various `Number` constants. */ var $8e4b93667e31211a$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $8e4b93667e31211a$var$toKey(value) {
    if (typeof value == 'string' || (0, $cHJLm.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$8e4b93667e31211a$var$INFINITY ? '-0' : result;
}
var $8e4b93667e31211a$export$2e2bcd8739ae039 = $8e4b93667e31211a$var$toKey;

});

parcelRegister("8T2Sb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6785b04a938036ea$export$2e2bcd8739ae039; });

var $cazWJ = parcelRequire("cazWJ");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $6785b04a938036ea$var$toString(value) {
    return value == null ? '' : (0, $cazWJ.default)(value);
}
var $6785b04a938036ea$export$2e2bcd8739ae039 = $6785b04a938036ea$var$toString;

});
parcelRegister("cazWJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dc24d5e9cb7c3da$export$2e2bcd8739ae039; });

var $2u0qg = parcelRequire("2u0qg");

var $8w4ic = parcelRequire("8w4ic");

var $kT11y = parcelRequire("kT11y");

var $cHJLm = parcelRequire("cHJLm");
/** Used as references for various `Number` constants. */ var $8dc24d5e9cb7c3da$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $8dc24d5e9cb7c3da$var$symbolProto = (0, $2u0qg.default) ? (0, $2u0qg.default).prototype : undefined, $8dc24d5e9cb7c3da$var$symbolToString = $8dc24d5e9cb7c3da$var$symbolProto ? $8dc24d5e9cb7c3da$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $8dc24d5e9cb7c3da$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $kT11y.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $8w4ic.default)(value, $8dc24d5e9cb7c3da$var$baseToString) + '';
    if ((0, $cHJLm.default)(value)) return $8dc24d5e9cb7c3da$var$symbolToString ? $8dc24d5e9cb7c3da$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$8dc24d5e9cb7c3da$var$INFINITY ? '-0' : result;
}
var $8dc24d5e9cb7c3da$export$2e2bcd8739ae039 = $8dc24d5e9cb7c3da$var$baseToString;

});



parcelRegister("7Ypvc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ce1eb3ba6e37590$export$2e2bcd8739ae039; });
var $5ce1eb3ba6e37590$var$isProduction = true;
function $5ce1eb3ba6e37590$var$warning(condition, message) {
    if (!$5ce1eb3ba6e37590$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $5ce1eb3ba6e37590$export$2e2bcd8739ae039 = $5ce1eb3ba6e37590$var$warning;

});

parcelRegister("7nfXW", function(module, exports) {
'use strict';

var $gpbya = parcelRequire("gpbya");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $55e710d91f76b0ee$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $55e710d91f76b0ee$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $55e710d91f76b0ee$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $55e710d91f76b0ee$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $55e710d91f76b0ee$var$TYPE_STATICS = {};
$55e710d91f76b0ee$var$TYPE_STATICS[$gpbya.ForwardRef] = $55e710d91f76b0ee$var$FORWARD_REF_STATICS;
$55e710d91f76b0ee$var$TYPE_STATICS[$gpbya.Memo] = $55e710d91f76b0ee$var$MEMO_STATICS;
function $55e710d91f76b0ee$var$getStatics(component) {
    // React v16.11 and below
    if ($gpbya.isMemo(component)) return $55e710d91f76b0ee$var$MEMO_STATICS;
     // React v16.12 and above
    return $55e710d91f76b0ee$var$TYPE_STATICS[component['$$typeof']] || $55e710d91f76b0ee$var$REACT_STATICS;
}
var $55e710d91f76b0ee$var$defineProperty = Object.defineProperty;
var $55e710d91f76b0ee$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $55e710d91f76b0ee$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $55e710d91f76b0ee$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $55e710d91f76b0ee$var$getPrototypeOf = Object.getPrototypeOf;
var $55e710d91f76b0ee$var$objectPrototype = Object.prototype;
function $55e710d91f76b0ee$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($55e710d91f76b0ee$var$objectPrototype) {
            var inheritedComponent = $55e710d91f76b0ee$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $55e710d91f76b0ee$var$objectPrototype) $55e710d91f76b0ee$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $55e710d91f76b0ee$var$getOwnPropertyNames(sourceComponent);
        if ($55e710d91f76b0ee$var$getOwnPropertySymbols) keys = keys.concat($55e710d91f76b0ee$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $55e710d91f76b0ee$var$getStatics(targetComponent);
        var sourceStatics = $55e710d91f76b0ee$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$55e710d91f76b0ee$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $55e710d91f76b0ee$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $55e710d91f76b0ee$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $55e710d91f76b0ee$var$hoistNonReactStatics;

});
parcelRegister("gpbya", function(module, exports) {
'use strict';

module.exports = (parcelRequire("g8WFZ"));

});


parcelRegister("82zmU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5da9f21ac3572c6e$export$2e2bcd8739ae039; });

var $3m59F = parcelRequire("3m59F");
/** Used to compose bitmasks for cloning. */ var $5da9f21ac3572c6e$var$CLONE_DEEP_FLAG = 1, $5da9f21ac3572c6e$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $5da9f21ac3572c6e$var$cloneDeep(value) {
    return (0, $3m59F.default)(value, $5da9f21ac3572c6e$var$CLONE_DEEP_FLAG | $5da9f21ac3572c6e$var$CLONE_SYMBOLS_FLAG);
}
var $5da9f21ac3572c6e$export$2e2bcd8739ae039 = $5da9f21ac3572c6e$var$cloneDeep;

});


parcelRegister("6Sgv0", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias('month', 'M');
    // PRIORITY
    addUnitPriority('month', 8);
    // PARSING
    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // ALIASES
    addUnitAlias('year', 'y');
    // PRIORITIES
    addUnitPriority('year', 1);
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // ALIASES
    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');
    // PRIORITIES
    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);
    // PARSING
    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // ALIASES
    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');
    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // ALIASES
    addUnitAlias('hour', 'h');
    // PRIORITY
    addUnitPriority('hour', 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');
    // PRIORITY
    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // ALIASES
    addUnitAlias('quarter', 'Q');
    // PRIORITY
    addUnitPriority('quarter', 7);
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // ALIASES
    addUnitAlias('date', 'D');
    // PRIORITY
    addUnitPriority('date', 9);
    // PARSING
    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // ALIASES
    addUnitAlias('dayOfYear', 'DDD');
    // PRIORITY
    addUnitPriority('dayOfYear', 4);
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // ALIASES
    addUnitAlias('minute', 'm');
    // PRIORITY
    addUnitPriority('minute', 14);
    // PARSING
    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // ALIASES
    addUnitAlias('second', 's');
    // PRIORITY
    addUnitPriority('second', 15);
    // PARSING
    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias('millisecond', 'ms');
    // PRIORITY
    addUnitPriority('millisecond', 16);
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y');
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.29.4';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("6bVDu", function(module, exports) {
'use strict';

var $eVaWG = parcelRequire("eVaWG");

var $2HzQs = parcelRequire("2HzQs");

var $96hFS = parcelRequire("96hFS");

var $3Au1K = parcelRequire("3Au1K");

var $6kc6n = parcelRequire("6kc6n");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $48207a76b4205fac$var$createInstance(defaultConfig) {
    var context = new $96hFS(defaultConfig);
    var instance = $2HzQs($96hFS.prototype.request, context);
    // Copy axios.prototype to instance
    $eVaWG.extend(instance, $96hFS.prototype, context);
    // Copy context to instance
    $eVaWG.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $48207a76b4205fac$var$createInstance($3Au1K(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $48207a76b4205fac$var$axios = $48207a76b4205fac$var$createInstance($6kc6n);
// Expose Axios class to allow class inheritance
$48207a76b4205fac$var$axios.Axios = $96hFS;

// Expose Cancel & CancelToken
$48207a76b4205fac$var$axios.Cancel = (parcelRequire("5Op8V"));

$48207a76b4205fac$var$axios.CancelToken = (parcelRequire("fsHQo"));

$48207a76b4205fac$var$axios.isCancel = (parcelRequire("7H6AU"));

$48207a76b4205fac$var$axios.VERSION = (parcelRequire("hjDLm")).version;
// Expose all/spread
$48207a76b4205fac$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$48207a76b4205fac$var$axios.spread = (parcelRequire("5SFCI"));

// Expose isAxiosError
$48207a76b4205fac$var$axios.isAxiosError = (parcelRequire("802Ul"));
module.exports = $48207a76b4205fac$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $48207a76b4205fac$var$axios;

});
parcelRegister("eVaWG", function(module, exports) {
'use strict';

var $2HzQs = parcelRequire("2HzQs");
// utils is a library of generic helper functions non-specific to axios
var $adcee11e836ff328$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $adcee11e836ff328$var$isArray(val) {
    return $adcee11e836ff328$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $adcee11e836ff328$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $adcee11e836ff328$var$isBuffer(val) {
    return val !== null && !$adcee11e836ff328$var$isUndefined(val) && val.constructor !== null && !$adcee11e836ff328$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $adcee11e836ff328$var$isArrayBuffer(val) {
    return $adcee11e836ff328$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $adcee11e836ff328$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $adcee11e836ff328$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $adcee11e836ff328$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $adcee11e836ff328$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $adcee11e836ff328$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $adcee11e836ff328$var$isPlainObject(val) {
    if ($adcee11e836ff328$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $adcee11e836ff328$var$isDate(val) {
    return $adcee11e836ff328$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $adcee11e836ff328$var$isFile(val) {
    return $adcee11e836ff328$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $adcee11e836ff328$var$isBlob(val) {
    return $adcee11e836ff328$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $adcee11e836ff328$var$isFunction(val) {
    return $adcee11e836ff328$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $adcee11e836ff328$var$isStream(val) {
    return $adcee11e836ff328$var$isObject(val) && $adcee11e836ff328$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $adcee11e836ff328$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $adcee11e836ff328$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $adcee11e836ff328$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $adcee11e836ff328$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($adcee11e836ff328$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $adcee11e836ff328$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($adcee11e836ff328$var$isPlainObject(result[key]) && $adcee11e836ff328$var$isPlainObject(val)) result[key] = $adcee11e836ff328$var$merge(result[key], val);
        else if ($adcee11e836ff328$var$isPlainObject(val)) result[key] = $adcee11e836ff328$var$merge({}, val);
        else if ($adcee11e836ff328$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$adcee11e836ff328$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $adcee11e836ff328$var$extend(a, b, thisArg) {
    $adcee11e836ff328$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $2HzQs(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $adcee11e836ff328$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $adcee11e836ff328$var$isArray,
    isArrayBuffer: $adcee11e836ff328$var$isArrayBuffer,
    isBuffer: $adcee11e836ff328$var$isBuffer,
    isFormData: $adcee11e836ff328$var$isFormData,
    isArrayBufferView: $adcee11e836ff328$var$isArrayBufferView,
    isString: $adcee11e836ff328$var$isString,
    isNumber: $adcee11e836ff328$var$isNumber,
    isObject: $adcee11e836ff328$var$isObject,
    isPlainObject: $adcee11e836ff328$var$isPlainObject,
    isUndefined: $adcee11e836ff328$var$isUndefined,
    isDate: $adcee11e836ff328$var$isDate,
    isFile: $adcee11e836ff328$var$isFile,
    isBlob: $adcee11e836ff328$var$isBlob,
    isFunction: $adcee11e836ff328$var$isFunction,
    isStream: $adcee11e836ff328$var$isStream,
    isURLSearchParams: $adcee11e836ff328$var$isURLSearchParams,
    isStandardBrowserEnv: $adcee11e836ff328$var$isStandardBrowserEnv,
    forEach: $adcee11e836ff328$var$forEach,
    merge: $adcee11e836ff328$var$merge,
    extend: $adcee11e836ff328$var$extend,
    trim: $adcee11e836ff328$var$trim,
    stripBOM: $adcee11e836ff328$var$stripBOM
};

});
parcelRegister("2HzQs", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("96hFS", function(module, exports) {
'use strict';

var $eVaWG = parcelRequire("eVaWG");

var $4wx4T = parcelRequire("4wx4T");

var $8QjMg = parcelRequire("8QjMg");

var $cgawg = parcelRequire("cgawg");

var $3Au1K = parcelRequire("3Au1K");

var $7rkc7 = parcelRequire("7rkc7");
var $6a02626474aab4e5$var$validators = $7rkc7.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $6a02626474aab4e5$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $8QjMg(),
        response: new $8QjMg()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $6a02626474aab4e5$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $3Au1K(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $7rkc7.assertOptions(transitional, {
        silentJSONParsing: $6a02626474aab4e5$var$validators.transitional($6a02626474aab4e5$var$validators.boolean),
        forcedJSONParsing: $6a02626474aab4e5$var$validators.transitional($6a02626474aab4e5$var$validators.boolean),
        clarifyTimeoutError: $6a02626474aab4e5$var$validators.transitional($6a02626474aab4e5$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $cgawg,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $cgawg(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$6a02626474aab4e5$var$Axios.prototype.getUri = function getUri(config) {
    config = $3Au1K(this.defaults, config);
    return $4wx4T(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$eVaWG.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $6a02626474aab4e5$var$Axios.prototype[method] = function(url, config) {
        return this.request($3Au1K(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$eVaWG.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $6a02626474aab4e5$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($3Au1K(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $6a02626474aab4e5$var$Axios;

});
parcelRegister("4wx4T", function(module, exports) {
'use strict';

var $eVaWG = parcelRequire("eVaWG");
function $34b3cf2887595020$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($eVaWG.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $eVaWG.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($eVaWG.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $eVaWG.forEach(val, function parseValue(v) {
                if ($eVaWG.isDate(v)) v = v.toISOString();
                else if ($eVaWG.isObject(v)) v = JSON.stringify(v);
                parts.push($34b3cf2887595020$var$encode(key) + '=' + $34b3cf2887595020$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("8QjMg", function(module, exports) {
'use strict';

var $eVaWG = parcelRequire("eVaWG");
function $6702857006cc048e$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $6702857006cc048e$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $6702857006cc048e$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $6702857006cc048e$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $eVaWG.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $6702857006cc048e$var$InterceptorManager;

});

parcelRegister("cgawg", function(module, exports) {
'use strict';

var $eVaWG = parcelRequire("eVaWG");

var $7HZb0 = parcelRequire("7HZb0");

var $7H6AU = parcelRequire("7H6AU");

var $6kc6n = parcelRequire("6kc6n");

var $5Op8V = parcelRequire("5Op8V");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $8ecf239a928fa419$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $5Op8V('canceled');
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $8ecf239a928fa419$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7HZb0.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $eVaWG.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $eVaWG.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $6kc6n.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $8ecf239a928fa419$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7HZb0.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7H6AU(reason)) {
            $8ecf239a928fa419$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7HZb0.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("7HZb0", function(module, exports) {
'use strict';

var $eVaWG = parcelRequire("eVaWG");

var $6kc6n = parcelRequire("6kc6n");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $6kc6n;
    /*eslint no-param-reassign:0*/ $eVaWG.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("6kc6n", function(module, exports) {

var $8LKEK = parcelRequire("8LKEK");
'use strict';

var $eVaWG = parcelRequire("eVaWG");

var $4fS1w = parcelRequire("4fS1w");

var $1nnA5 = parcelRequire("1nnA5");
var $49adff817bf192fe$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $49adff817bf192fe$var$setContentTypeIfUnset(headers, value) {
    if (!$eVaWG.isUndefined(headers) && $eVaWG.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}


function $49adff817bf192fe$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("fz5k2"));
    else if (typeof $8LKEK !== 'undefined' && Object.prototype.toString.call($8LKEK) === '[object process]') // For node use HTTP adapter
    adapter = (parcelRequire("fz5k2"));
    return adapter;
}
function $49adff817bf192fe$var$stringifySafely(rawValue, parser, encoder) {
    if ($eVaWG.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $eVaWG.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $49adff817bf192fe$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $49adff817bf192fe$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $4fS1w(headers, 'Accept');
            $4fS1w(headers, 'Content-Type');
            if ($eVaWG.isFormData(data) || $eVaWG.isArrayBuffer(data) || $eVaWG.isBuffer(data) || $eVaWG.isStream(data) || $eVaWG.isFile(data) || $eVaWG.isBlob(data)) return data;
            if ($eVaWG.isArrayBufferView(data)) return data.buffer;
            if ($eVaWG.isURLSearchParams(data)) {
                $49adff817bf192fe$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($eVaWG.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
                $49adff817bf192fe$var$setContentTypeIfUnset(headers, 'application/json');
                return $49adff817bf192fe$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $49adff817bf192fe$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $eVaWG.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $1nnA5(e, this, 'E_JSON_PARSE');
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*'
        }
    }
};
$eVaWG.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $49adff817bf192fe$var$defaults.headers[method] = {};
});
$eVaWG.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $49adff817bf192fe$var$defaults.headers[method] = $eVaWG.merge($49adff817bf192fe$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $49adff817bf192fe$var$defaults;

});
parcelRegister("4fS1w", function(module, exports) {
'use strict';

var $eVaWG = parcelRequire("eVaWG");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $eVaWG.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("1nnA5", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("fz5k2", function(module, exports) {
'use strict';

var $eVaWG = parcelRequire("eVaWG");

var $3Qkqz = parcelRequire("3Qkqz");

var $6u3S0 = parcelRequire("6u3S0");

var $4wx4T = parcelRequire("4wx4T");

var $BSJUJ = parcelRequire("BSJUJ");

var $1SkDn = parcelRequire("1SkDn");

var $2KsUM = parcelRequire("2KsUM");

var $6lOMY = parcelRequire("6lOMY");

var $6kc6n = parcelRequire("6kc6n");

var $5Op8V = parcelRequire("5Op8V");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        if ($eVaWG.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $BSJUJ(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $4wx4T(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $1SkDn(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $3Qkqz(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($6lOMY('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($6lOMY('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || $6kc6n.transitional;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($6lOMY(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($eVaWG.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $2KsUM(fullPath)) && config.xsrfCookieName ? $6u3S0.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $eVaWG.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$eVaWG.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $5Op8V('canceled') : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("3Qkqz", function(module, exports) {
'use strict';

var $6lOMY = parcelRequire("6lOMY");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($6lOMY('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("6lOMY", function(module, exports) {
'use strict';

var $1nnA5 = parcelRequire("1nnA5");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $1nnA5(error, config, code, request, response);
};

});


parcelRegister("6u3S0", function(module, exports) {
'use strict';

var $eVaWG = parcelRequire("eVaWG");
module.exports = $eVaWG.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($eVaWG.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($eVaWG.isString(path)) cookie.push('path=' + path);
            if ($eVaWG.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("BSJUJ", function(module, exports) {
'use strict';

var $exvUG = parcelRequire("exvUG");

var $8KTEo = parcelRequire("8KTEo");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$exvUG(requestedURL)) return $8KTEo(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("exvUG", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("8KTEo", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("1SkDn", function(module, exports) {
'use strict';

var $eVaWG = parcelRequire("eVaWG");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $15dad71a8d2b3b25$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $eVaWG.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $eVaWG.trim(line.substr(0, i)).toLowerCase();
        val = $eVaWG.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $15dad71a8d2b3b25$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("2KsUM", function(module, exports) {
'use strict';

var $eVaWG = parcelRequire("eVaWG");
module.exports = $eVaWG.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $eVaWG.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("5Op8V", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $43b520259656c67c$var$Cancel(message) {
    this.message = message;
}
$43b520259656c67c$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$43b520259656c67c$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $43b520259656c67c$var$Cancel;

});




parcelRegister("7H6AU", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("3Au1K", function(module, exports) {
'use strict';

var $eVaWG = parcelRequire("eVaWG");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($eVaWG.isPlainObject(target) && $eVaWG.isPlainObject(source)) return $eVaWG.merge(target, source);
        else if ($eVaWG.isPlainObject(source)) return $eVaWG.merge({}, source);
        else if ($eVaWG.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$eVaWG.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$eVaWG.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$eVaWG.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$eVaWG.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$eVaWG.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
    };
    $eVaWG.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $eVaWG.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("7rkc7", function(module, exports) {
'use strict';

var $hjDLm = parcelRequire("hjDLm");
var $56aab838ad721a74$require$VERSION = $hjDLm.version;
var $56aab838ad721a74$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $56aab838ad721a74$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $56aab838ad721a74$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $56aab838ad721a74$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + $56aab838ad721a74$require$VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
        if (version && !$56aab838ad721a74$var$deprecatedWarnings[opt]) {
            $56aab838ad721a74$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $56aab838ad721a74$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new TypeError('options must be an object');
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError('option ' + opt + ' must be ' + result);
            continue;
        }
        if (allowUnknown !== true) throw Error('Unknown option ' + opt);
    }
}
module.exports = {
    assertOptions: $56aab838ad721a74$var$assertOptions,
    validators: $56aab838ad721a74$var$validators
};

});
parcelRegister("hjDLm", function(module, exports) {
module.exports = {
    "version": "0.24.0"
};

});



parcelRegister("fsHQo", function(module, exports) {
'use strict';

var $5Op8V = parcelRequire("5Op8V");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $b41b7b10b499eb45$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $5Op8V(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $b41b7b10b499eb45$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $b41b7b10b499eb45$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $b41b7b10b499eb45$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $b41b7b10b499eb45$var$CancelToken.source = function source() {
    var cancel;
    var token = new $b41b7b10b499eb45$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $b41b7b10b499eb45$var$CancelToken;

});

parcelRegister("5SFCI", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("802Ul", function(module, exports) {
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === 'object' && payload.isAxiosError === true;
};

});


parcelRegister("gfXgg", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});

var $6fFrj = parcelRequire("6fFrj");
function $bd5c04215658ed5f$var$i() {
    return $bd5c04215658ed5f$var$i = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var s = arguments[i];
            for(var n in s)Object.prototype.hasOwnProperty.call(s, n) && (t[n] = s[n]);
        }
        return t;
    }, $bd5c04215658ed5f$var$i.apply(this, arguments);
}
var $bd5c04215658ed5f$var$s = $6fFrj.createElement("svg", {
    viewBox: "-2 -5 14 20",
    height: "100%",
    width: "100%",
    style: {
        position: "absolute",
        top: 0
    }
}, $6fFrj.createElement("path", {
    d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
    fill: "#fff",
    fillRule: "evenodd"
})), $bd5c04215658ed5f$var$n = $6fFrj.createElement("svg", {
    height: "100%",
    width: "100%",
    viewBox: "-2 -5 17 21",
    style: {
        position: "absolute",
        top: 0
    }
}, $6fFrj.createElement("path", {
    d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
    fill: "#fff",
    fillRule: "evenodd"
}));
function $bd5c04215658ed5f$var$o(t) {
    if (7 === t.length) return t;
    for(var i = "#", s = 1; s < 4; s += 1)i += t[s] + t[s];
    return i;
}
function $bd5c04215658ed5f$var$h(t, i, s, n, h) {
    return function(t, i, s, n, o) {
        var h = (t - s) / (i - s);
        if (0 === h) return n;
        if (1 === h) return o;
        for(var e = "#", a = 1; a < 6; a += 2){
            var r = parseInt(n.substr(a, 2), 16), l = parseInt(o.substr(a, 2), 16), u = Math.round((1 - h) * r + h * l).toString(16);
            1 === u.length && (u = "0" + u), e += u;
        }
        return e;
    }(t, i, s, $bd5c04215658ed5f$var$o(n), $bd5c04215658ed5f$var$o(h));
}
var $bd5c04215658ed5f$var$e = function(s) {
    function n(t) {
        s.call(this, t);
        var i = t.height, n = t.width, o = t.checked;
        this.t = t.handleDiameter || i - 2, this.i = Math.max(n - i, n - (i + this.t) / 2), this.o = Math.max(0, (i - this.t) / 2), this.state = {
            h: o ? this.i : this.o
        }, this.l = 0, this.u = 0, this.p = this.p.bind(this), this.v = this.v.bind(this), this.k = this.k.bind(this), this.M = this.M.bind(this), this.m = this.m.bind(this), this.T = this.T.bind(this), this.$ = this.$.bind(this), this.C = this.C.bind(this), this.O = this.O.bind(this), this.D = this.D.bind(this), this.S = this.S.bind(this), this.W = this.W.bind(this);
    }
    return s && (n.__proto__ = s), (n.prototype = Object.create(s && s.prototype)).constructor = n, n.prototype.componentDidMount = function() {
        this.I = !0;
    }, n.prototype.componentDidUpdate = function(t) {
        t.checked !== this.props.checked && this.setState({
            h: this.props.checked ? this.i : this.o
        });
    }, n.prototype.componentWillUnmount = function() {
        this.I = !1;
    }, n.prototype.H = function(t) {
        this.j.focus(), this.setState({
            R: t,
            B: !0,
            L: Date.now()
        });
    }, n.prototype.N = function(t) {
        var i = this.state, s = i.R, n = i.h, o = (this.props.checked ? this.i : this.o) + t - s;
        i.U || t === s || this.setState({
            U: !0
        });
        var h = Math.min(this.i, Math.max(this.o, o));
        h !== n && this.setState({
            h: h
        });
    }, n.prototype.A = function(t) {
        var i = this.state, s = i.h, n = i.U, o = i.L, h = this.props.checked, e = (this.i + this.o) / 2;
        this.setState({
            h: this.props.checked ? this.i : this.o
        });
        var a = Date.now() - o;
        (!n || a < 250 || h && s <= e || !h && s >= e) && this.X(t), this.I && this.setState({
            U: !1,
            B: !1
        }), this.l = Date.now();
    }, n.prototype.p = function(t) {
        t.preventDefault(), "number" == typeof t.button && 0 !== t.button || (this.H(t.clientX), window.addEventListener("mousemove", this.v), window.addEventListener("mouseup", this.k));
    }, n.prototype.v = function(t) {
        t.preventDefault(), this.N(t.clientX);
    }, n.prototype.k = function(t) {
        this.A(t), window.removeEventListener("mousemove", this.v), window.removeEventListener("mouseup", this.k);
    }, n.prototype.M = function(t) {
        this._ = null, this.H(t.touches[0].clientX);
    }, n.prototype.m = function(t) {
        this.N(t.touches[0].clientX);
    }, n.prototype.T = function(t) {
        t.preventDefault(), this.A(t);
    }, n.prototype.C = function(t) {
        Date.now() - this.l > 50 && (this.X(t), Date.now() - this.u > 50 && this.I && this.setState({
            B: !1
        }));
    }, n.prototype.O = function() {
        this.u = Date.now();
    }, n.prototype.D = function() {
        this.setState({
            B: !0
        });
    }, n.prototype.S = function() {
        this.setState({
            B: !1
        });
    }, n.prototype.W = function(t) {
        this.j = t;
    }, n.prototype.$ = function(t) {
        t.preventDefault(), this.j.focus(), this.X(t), this.I && this.setState({
            B: !1
        });
    }, n.prototype.X = function(t) {
        var i = this.props;
        (0, i.onChange)(!i.checked, t, i.id);
    }, n.prototype.render = function() {
        var s = this.props, n = s.checked, o = s.disabled, e = s.className, a = s.offColor, r = s.onColor, l = s.offHandleColor, u = s.onHandleColor, c = s.checkedIcon, d = s.uncheckedIcon, f = s.checkedHandleIcon, p = s.uncheckedHandleIcon, b = s.boxShadow, v = s.activeBoxShadow, g = s.height, y = s.width, w = s.borderRadius, k = function(t, i) {
            var s = {};
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && -1 === i.indexOf(n) && (s[n] = t[n]);
            return s;
        }(s, [
            "checked",
            "disabled",
            "className",
            "offColor",
            "onColor",
            "offHandleColor",
            "onHandleColor",
            "checkedIcon",
            "uncheckedIcon",
            "checkedHandleIcon",
            "uncheckedHandleIcon",
            "boxShadow",
            "activeBoxShadow",
            "height",
            "width",
            "borderRadius",
            "handleDiameter"
        ]), M = this.state, m = M.h, T = M.U, x = M.B, $ = {
            position: "relative",
            display: "inline-block",
            textAlign: "left",
            opacity: o ? .5 : 1,
            direction: "ltr",
            borderRadius: g / 2,
            WebkitTransition: "opacity 0.25s",
            MozTransition: "opacity 0.25s",
            transition: "opacity 0.25s",
            touchAction: "none",
            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
            userSelect: "none"
        }, C = {
            height: g,
            width: y,
            margin: Math.max(0, (this.t - g) / 2),
            position: "relative",
            background: $bd5c04215658ed5f$var$h(m, this.i, this.o, a, r),
            borderRadius: "number" == typeof w ? w : g / 2,
            cursor: o ? "default" : "pointer",
            WebkitTransition: T ? null : "background 0.25s",
            MozTransition: T ? null : "background 0.25s",
            transition: T ? null : "background 0.25s"
        }, O = {
            height: g,
            width: Math.min(1.5 * g, y - (this.t + g) / 2 + 1),
            position: "relative",
            opacity: (m - this.o) / (this.i - this.o),
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        }, D = {
            height: g,
            width: Math.min(1.5 * g, y - (this.t + g) / 2 + 1),
            position: "absolute",
            opacity: 1 - (m - this.o) / (this.i - this.o),
            right: 0,
            top: 0,
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        }, S = {
            height: this.t,
            width: this.t,
            background: $bd5c04215658ed5f$var$h(m, this.i, this.o, l, u),
            display: "inline-block",
            cursor: o ? "default" : "pointer",
            borderRadius: "number" == typeof w ? w - 1 : "50%",
            position: "absolute",
            transform: "translateX(" + m + "px)",
            top: Math.max(0, (g - this.t) / 2),
            outline: 0,
            boxShadow: x ? v : b,
            border: 0,
            WebkitTransition: T ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
            MozTransition: T ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
            transition: T ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s"
        }, W = {
            height: this.t,
            width: this.t,
            opacity: Math.max(2 * (1 - (m - this.o) / (this.i - this.o) - .5), 0),
            position: "absolute",
            left: 0,
            top: 0,
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        }, z = {
            height: this.t,
            width: this.t,
            opacity: Math.max(2 * ((m - this.o) / (this.i - this.o) - .5), 0),
            position: "absolute",
            left: 0,
            top: 0,
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        };
        return $6fFrj.createElement("div", {
            className: e,
            style: $
        }, $6fFrj.createElement("div", {
            className: "react-switch-bg",
            style: C,
            onClick: o ? null : this.$,
            onMouseDown: function(t) {
                return t.preventDefault();
            }
        }, c && $6fFrj.createElement("div", {
            style: O
        }, c), d && $6fFrj.createElement("div", {
            style: D
        }, d)), $6fFrj.createElement("div", {
            className: "react-switch-handle",
            style: S,
            onClick: function(t) {
                return t.preventDefault();
            },
            onMouseDown: o ? null : this.p,
            onTouchStart: o ? null : this.M,
            onTouchMove: o ? null : this.m,
            onTouchEnd: o ? null : this.T,
            onTouchCancel: o ? null : this.S
        }, p && $6fFrj.createElement("div", {
            style: W
        }, p), f && $6fFrj.createElement("div", {
            style: z
        }, f)), $6fFrj.createElement("input", $bd5c04215658ed5f$var$i({}, {
            type: "checkbox",
            role: "switch",
            "aria-checked": n,
            checked: n,
            disabled: o,
            style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: 1,
                margin: -1,
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: 1
            }
        }, k, {
            ref: this.W,
            onFocus: this.D,
            onBlur: this.S,
            onKeyUp: this.O,
            onChange: this.C
        })));
    }, n;
}($6fFrj.Component);
$bd5c04215658ed5f$var$e.defaultProps = {
    disabled: !1,
    offColor: "#888",
    onColor: "#080",
    offHandleColor: "#fff",
    onHandleColor: "#fff",
    uncheckedIcon: $bd5c04215658ed5f$var$s,
    checkedIcon: $bd5c04215658ed5f$var$n,
    boxShadow: null,
    activeBoxShadow: "0 0 2px 3px #3bf",
    height: 28,
    width: 56
}, module.exports.default = $bd5c04215658ed5f$var$e;

});

parcelRegister("ddkAr", function(module, exports) {
"use strict";

var $99ec75634284ddd3$var$protobuf = module.exports = (parcelRequire("6rwtH"));
$99ec75634284ddd3$var$protobuf.build = "full";

// Parser
$99ec75634284ddd3$var$protobuf.tokenize = (parcelRequire("1gmIw"));

$99ec75634284ddd3$var$protobuf.parse = (parcelRequire("2HtwA"));

$99ec75634284ddd3$var$protobuf.common = (parcelRequire("iKJSX"));
// Configure parser
$99ec75634284ddd3$var$protobuf.Root._configure($99ec75634284ddd3$var$protobuf.Type, $99ec75634284ddd3$var$protobuf.parse, $99ec75634284ddd3$var$protobuf.common);

});
parcelRegister("6rwtH", function(module, exports) {
"use strict";

var $4b0e7522f7a2e12f$var$protobuf = module.exports = (parcelRequire("d1SVP"));
$4b0e7522f7a2e12f$var$protobuf.build = "light";
/**
 * A node-style callback as used by {@link load} and {@link Root#load}.
 * @typedef LoadCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Root} [root] Root, if there hasn't been an error
 * @returns {undefined}
 */ /**
 * Loads one or multiple .proto or preprocessed .json files into a common root namespace and calls the callback.
 * @param {string|string[]} filename One or multiple files to load
 * @param {Root} root Root namespace, defaults to create a new one if omitted.
 * @param {LoadCallback} callback Callback function
 * @returns {undefined}
 * @see {@link Root#load}
 */ function $4b0e7522f7a2e12f$var$load(filename, root, callback) {
    if (typeof root === "function") {
        callback = root;
        root = new $4b0e7522f7a2e12f$var$protobuf.Root();
    } else if (!root) root = new $4b0e7522f7a2e12f$var$protobuf.Root();
    return root.load(filename, callback);
}
/**
 * Loads one or multiple .proto or preprocessed .json files into a common root namespace and calls the callback.
 * @name load
 * @function
 * @param {string|string[]} filename One or multiple files to load
 * @param {LoadCallback} callback Callback function
 * @returns {undefined}
 * @see {@link Root#load}
 * @variation 2
 */ // function load(filename:string, callback:LoadCallback):undefined
/**
 * Loads one or multiple .proto or preprocessed .json files into a common root namespace and returns a promise.
 * @name load
 * @function
 * @param {string|string[]} filename One or multiple files to load
 * @param {Root} [root] Root namespace, defaults to create a new one if omitted.
 * @returns {Promise<Root>} Promise
 * @see {@link Root#load}
 * @variation 3
 */ // function load(filename:string, [root:Root]):Promise<Root>
$4b0e7522f7a2e12f$var$protobuf.load = $4b0e7522f7a2e12f$var$load;
/**
 * Synchronously loads one or multiple .proto or preprocessed .json files into a common root namespace (node only).
 * @param {string|string[]} filename One or multiple files to load
 * @param {Root} [root] Root namespace, defaults to create a new one if omitted.
 * @returns {Root} Root namespace
 * @throws {Error} If synchronous fetching is not supported (i.e. in browsers) or if a file's syntax is invalid
 * @see {@link Root#loadSync}
 */ function $4b0e7522f7a2e12f$var$loadSync(filename, root) {
    if (!root) root = new $4b0e7522f7a2e12f$var$protobuf.Root();
    return root.loadSync(filename);
}
$4b0e7522f7a2e12f$var$protobuf.loadSync = $4b0e7522f7a2e12f$var$loadSync;

// Serialization
$4b0e7522f7a2e12f$var$protobuf.encoder = (parcelRequire("iM0tk"));

$4b0e7522f7a2e12f$var$protobuf.decoder = (parcelRequire("03zCF"));

$4b0e7522f7a2e12f$var$protobuf.verifier = (parcelRequire("8KWb1"));

$4b0e7522f7a2e12f$var$protobuf.converter = (parcelRequire("elQct"));

// Reflection
$4b0e7522f7a2e12f$var$protobuf.ReflectionObject = (parcelRequire("jAZD5"));

$4b0e7522f7a2e12f$var$protobuf.Namespace = (parcelRequire("1nsZk"));

$4b0e7522f7a2e12f$var$protobuf.Root = (parcelRequire("fTkGs"));

$4b0e7522f7a2e12f$var$protobuf.Enum = (parcelRequire("l9EYs"));

$4b0e7522f7a2e12f$var$protobuf.Type = (parcelRequire("8zc9K"));

$4b0e7522f7a2e12f$var$protobuf.Field = (parcelRequire("IbYAq"));

$4b0e7522f7a2e12f$var$protobuf.OneOf = (parcelRequire("iMxDc"));

$4b0e7522f7a2e12f$var$protobuf.MapField = (parcelRequire("hI2Xk"));

$4b0e7522f7a2e12f$var$protobuf.Service = (parcelRequire("5Iewc"));

$4b0e7522f7a2e12f$var$protobuf.Method = (parcelRequire("kgBOI"));

// Runtime
$4b0e7522f7a2e12f$var$protobuf.Message = (parcelRequire("9npbz"));

$4b0e7522f7a2e12f$var$protobuf.wrappers = (parcelRequire("d5RQG"));

// Utility
$4b0e7522f7a2e12f$var$protobuf.types = (parcelRequire("hyVJi"));

$4b0e7522f7a2e12f$var$protobuf.util = (parcelRequire("1C5z4"));
// Set up possibly cyclic reflection dependencies
$4b0e7522f7a2e12f$var$protobuf.ReflectionObject._configure($4b0e7522f7a2e12f$var$protobuf.Root);
$4b0e7522f7a2e12f$var$protobuf.Namespace._configure($4b0e7522f7a2e12f$var$protobuf.Type, $4b0e7522f7a2e12f$var$protobuf.Service, $4b0e7522f7a2e12f$var$protobuf.Enum);
$4b0e7522f7a2e12f$var$protobuf.Root._configure($4b0e7522f7a2e12f$var$protobuf.Type);
$4b0e7522f7a2e12f$var$protobuf.Field._configure($4b0e7522f7a2e12f$var$protobuf.Type);

});
parcelRegister("d1SVP", function(module, exports) {
"use strict";
var $97c5faa5ebb19960$var$protobuf = module.exports;
/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */ $97c5faa5ebb19960$var$protobuf.build = "minimal";

// Serialization
$97c5faa5ebb19960$var$protobuf.Writer = (parcelRequire("i4Gf0"));

$97c5faa5ebb19960$var$protobuf.BufferWriter = (parcelRequire("4Ius5"));

$97c5faa5ebb19960$var$protobuf.Reader = (parcelRequire("akfl2"));

$97c5faa5ebb19960$var$protobuf.BufferReader = (parcelRequire("2tdju"));

// Utility
$97c5faa5ebb19960$var$protobuf.util = (parcelRequire("9920C"));

$97c5faa5ebb19960$var$protobuf.rpc = (parcelRequire("jh3HG"));

$97c5faa5ebb19960$var$protobuf.roots = (parcelRequire("ikHzD"));
$97c5faa5ebb19960$var$protobuf.configure = $97c5faa5ebb19960$var$configure;
/* istanbul ignore next */ /**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */ function $97c5faa5ebb19960$var$configure() {
    $97c5faa5ebb19960$var$protobuf.util._configure();
    $97c5faa5ebb19960$var$protobuf.Writer._configure($97c5faa5ebb19960$var$protobuf.BufferWriter);
    $97c5faa5ebb19960$var$protobuf.Reader._configure($97c5faa5ebb19960$var$protobuf.BufferReader);
}
// Set up buffer utility according to the environment
$97c5faa5ebb19960$var$configure();

});
parcelRegister("i4Gf0", function(module, exports) {
"use strict";
module.exports = $d2895de0fcff1add$var$Writer;

var $9920C = parcelRequire("9920C");
var $d2895de0fcff1add$var$BufferWriter; // cyclic
var $d2895de0fcff1add$var$LongBits = $9920C.LongBits, $d2895de0fcff1add$var$base64 = $9920C.base64, $d2895de0fcff1add$var$utf8 = $9920C.utf8;
/**
 * Constructs a new writer operation instance.
 * @classdesc Scheduled writer operation.
 * @constructor
 * @param {function(*, Uint8Array, number)} fn Function to call
 * @param {number} len Value byte length
 * @param {*} val Value to write
 * @ignore
 */ function $d2895de0fcff1add$var$Op(fn, len, val) {
    /**
     * Function to call.
     * @type {function(Uint8Array, number, *)}
     */ this.fn = fn;
    /**
     * Value byte length.
     * @type {number}
     */ this.len = len;
    /**
     * Next operation.
     * @type {Writer.Op|undefined}
     */ this.next = undefined;
    /**
     * Value to write.
     * @type {*}
     */ this.val = val; // type varies
}
/* istanbul ignore next */ function $d2895de0fcff1add$var$noop() {} // eslint-disable-line no-empty-function
/**
 * Constructs a new writer state instance.
 * @classdesc Copied writer state.
 * @memberof Writer
 * @constructor
 * @param {Writer} writer Writer to copy state from
 * @ignore
 */ function $d2895de0fcff1add$var$State(writer) {
    /**
     * Current head.
     * @type {Writer.Op}
     */ this.head = writer.head;
    /**
     * Current tail.
     * @type {Writer.Op}
     */ this.tail = writer.tail;
    /**
     * Current buffer length.
     * @type {number}
     */ this.len = writer.len;
    /**
     * Next state.
     * @type {State|null}
     */ this.next = writer.states;
}
/**
 * Constructs a new writer instance.
 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 */ function $d2895de0fcff1add$var$Writer() {
    /**
     * Current length.
     * @type {number}
     */ this.len = 0;
    /**
     * Operations head.
     * @type {Object}
     */ this.head = new $d2895de0fcff1add$var$Op($d2895de0fcff1add$var$noop, 0, 0);
    /**
     * Operations tail
     * @type {Object}
     */ this.tail = this.head;
    /**
     * Linked forked states.
     * @type {Object|null}
     */ this.states = null;
// When a value is written, the writer calculates its byte length and puts it into a linked
// list of operations to perform when finish() is called. This both allows us to allocate
// buffers of the exact required size and reduces the amount of work we have to do compared
// to first calculating over objects and then encoding over objects. In our case, the encoding
// part is just a linked list walk calling operations with already prepared values.
}
var $d2895de0fcff1add$var$create = function create() {
    return $9920C.Buffer ? function create_buffer_setup() {
        return ($d2895de0fcff1add$var$Writer.create = function create_buffer() {
            return new $d2895de0fcff1add$var$BufferWriter();
        })();
    } : function create_array() {
        return new $d2895de0fcff1add$var$Writer();
    };
};
/**
 * Creates a new writer.
 * @function
 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
 */ $d2895de0fcff1add$var$Writer.create = $d2895de0fcff1add$var$create();
/**
 * Allocates a buffer of the specified size.
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ $d2895de0fcff1add$var$Writer.alloc = function alloc(size) {
    return new $9920C.Array(size);
};
// Use Uint8Array buffer pool in the browser, just like node does with buffers
/* istanbul ignore else */ if ($9920C.Array !== Array) $d2895de0fcff1add$var$Writer.alloc = $9920C.pool($d2895de0fcff1add$var$Writer.alloc, $9920C.Array.prototype.subarray);
/**
 * Pushes a new operation to the queue.
 * @param {function(Uint8Array, number, *)} fn Function to call
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @returns {Writer} `this`
 * @private
 */ $d2895de0fcff1add$var$Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new $d2895de0fcff1add$var$Op(fn, len, val);
    this.len += len;
    return this;
};
function $d2895de0fcff1add$var$writeByte(val, buf, pos) {
    buf[pos] = val & 255;
}
function $d2895de0fcff1add$var$writeVarint32(val, buf, pos) {
    while(val > 127){
        buf[pos++] = val & 127 | 128;
        val >>>= 7;
    }
    buf[pos] = val;
}
/**
 * Constructs a new varint writer operation instance.
 * @classdesc Scheduled varint writer operation.
 * @extends Op
 * @constructor
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @ignore
 */ function $d2895de0fcff1add$var$VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
}
$d2895de0fcff1add$var$VarintOp.prototype = Object.create($d2895de0fcff1add$var$Op.prototype);
$d2895de0fcff1add$var$VarintOp.prototype.fn = $d2895de0fcff1add$var$writeVarint32;
/**
 * Writes an unsigned 32 bit value as a varint.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $d2895de0fcff1add$var$Writer.prototype.uint32 = function write_uint32(value) {
    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
    // uint32 is by far the most frequently used operation and benefits significantly from this.
    this.len += (this.tail = this.tail.next = new $d2895de0fcff1add$var$VarintOp((value = value >>> 0) < 128 ? 1 : value < 16384 ? 2 : value < 2097152 ? 3 : value < 268435456 ? 4 : 5, value)).len;
    return this;
};
/**
 * Writes a signed 32 bit value as a varint.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $d2895de0fcff1add$var$Writer.prototype.int32 = function write_int32(value) {
    return value < 0 ? this._push($d2895de0fcff1add$var$writeVarint64, 10, $d2895de0fcff1add$var$LongBits.fromNumber(value)) // 10 bytes per spec
     : this.uint32(value);
};
/**
 * Writes a 32 bit value as a varint, zig-zag encoded.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $d2895de0fcff1add$var$Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
};
function $d2895de0fcff1add$var$writeVarint64(val, buf, pos) {
    while(val.hi){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
        val.hi >>>= 7;
    }
    while(val.lo > 127){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = val.lo >>> 7;
    }
    buf[pos++] = val.lo;
}
/**
 * Writes an unsigned 64 bit value as a varint.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $d2895de0fcff1add$var$Writer.prototype.uint64 = function write_uint64(value) {
    var bits = $d2895de0fcff1add$var$LongBits.from(value);
    return this._push($d2895de0fcff1add$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a signed 64 bit value as a varint.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $d2895de0fcff1add$var$Writer.prototype.int64 = $d2895de0fcff1add$var$Writer.prototype.uint64;
/**
 * Writes a signed 64 bit value as a varint, zig-zag encoded.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $d2895de0fcff1add$var$Writer.prototype.sint64 = function write_sint64(value) {
    var bits = $d2895de0fcff1add$var$LongBits.from(value).zzEncode();
    return this._push($d2895de0fcff1add$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a boolish value as a varint.
 * @param {boolean} value Value to write
 * @returns {Writer} `this`
 */ $d2895de0fcff1add$var$Writer.prototype.bool = function write_bool(value) {
    return this._push($d2895de0fcff1add$var$writeByte, 1, value ? 1 : 0);
};
function $d2895de0fcff1add$var$writeFixed32(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
/**
 * Writes an unsigned 32 bit value as fixed 32 bits.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $d2895de0fcff1add$var$Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push($d2895de0fcff1add$var$writeFixed32, 4, value >>> 0);
};
/**
 * Writes a signed 32 bit value as fixed 32 bits.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $d2895de0fcff1add$var$Writer.prototype.sfixed32 = $d2895de0fcff1add$var$Writer.prototype.fixed32;
/**
 * Writes an unsigned 64 bit value as fixed 64 bits.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $d2895de0fcff1add$var$Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = $d2895de0fcff1add$var$LongBits.from(value);
    return this._push($d2895de0fcff1add$var$writeFixed32, 4, bits.lo)._push($d2895de0fcff1add$var$writeFixed32, 4, bits.hi);
};
/**
 * Writes a signed 64 bit value as fixed 64 bits.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $d2895de0fcff1add$var$Writer.prototype.sfixed64 = $d2895de0fcff1add$var$Writer.prototype.fixed64;
/**
 * Writes a float (32 bit).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $d2895de0fcff1add$var$Writer.prototype.float = function write_float(value) {
    return this._push($9920C.float.writeFloatLE, 4, value);
};
/**
 * Writes a double (64 bit float).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $d2895de0fcff1add$var$Writer.prototype.double = function write_double(value) {
    return this._push($9920C.float.writeDoubleLE, 8, value);
};
var $d2895de0fcff1add$var$writeBytes = $9920C.Array.prototype.set ? function writeBytes_set(val, buf, pos) {
    buf.set(val, pos); // also works for plain array values
} : function writeBytes_for(val, buf, pos) {
    for(var i = 0; i < val.length; ++i)buf[pos + i] = val[i];
};
/**
 * Writes a sequence of bytes.
 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
 * @returns {Writer} `this`
 */ $d2895de0fcff1add$var$Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len) return this._push($d2895de0fcff1add$var$writeByte, 1, 0);
    if ($9920C.isString(value)) {
        var buf = $d2895de0fcff1add$var$Writer.alloc(len = $d2895de0fcff1add$var$base64.length(value));
        $d2895de0fcff1add$var$base64.decode(value, buf, 0);
        value = buf;
    }
    return this.uint32(len)._push($d2895de0fcff1add$var$writeBytes, len, value);
};
/**
 * Writes a string.
 * @param {string} value Value to write
 * @returns {Writer} `this`
 */ $d2895de0fcff1add$var$Writer.prototype.string = function write_string(value) {
    var len = $d2895de0fcff1add$var$utf8.length(value);
    return len ? this.uint32(len)._push($d2895de0fcff1add$var$utf8.write, len, value) : this._push($d2895de0fcff1add$var$writeByte, 1, 0);
};
/**
 * Forks this writer's state by pushing it to a stack.
 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
 * @returns {Writer} `this`
 */ $d2895de0fcff1add$var$Writer.prototype.fork = function fork() {
    this.states = new $d2895de0fcff1add$var$State(this);
    this.head = this.tail = new $d2895de0fcff1add$var$Op($d2895de0fcff1add$var$noop, 0, 0);
    this.len = 0;
    return this;
};
/**
 * Resets this instance to the last state.
 * @returns {Writer} `this`
 */ $d2895de0fcff1add$var$Writer.prototype.reset = function reset() {
    if (this.states) {
        this.head = this.states.head;
        this.tail = this.states.tail;
        this.len = this.states.len;
        this.states = this.states.next;
    } else {
        this.head = this.tail = new $d2895de0fcff1add$var$Op($d2895de0fcff1add$var$noop, 0, 0);
        this.len = 0;
    }
    return this;
};
/**
 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
 * @returns {Writer} `this`
 */ $d2895de0fcff1add$var$Writer.prototype.ldelim = function ldelim() {
    var head = this.head, tail = this.tail, len = this.len;
    this.reset().uint32(len);
    if (len) {
        this.tail.next = head.next; // skip noop
        this.tail = tail;
        this.len += len;
    }
    return this;
};
/**
 * Finishes the write operation.
 * @returns {Uint8Array} Finished buffer
 */ $d2895de0fcff1add$var$Writer.prototype.finish = function finish() {
    var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
    while(head){
        head.fn(head.val, buf, pos);
        pos += head.len;
        head = head.next;
    }
    // this.head = this.tail = null;
    return buf;
};
$d2895de0fcff1add$var$Writer._configure = function(BufferWriter_) {
    $d2895de0fcff1add$var$BufferWriter = BufferWriter_;
    $d2895de0fcff1add$var$Writer.create = $d2895de0fcff1add$var$create();
    $d2895de0fcff1add$var$BufferWriter._configure();
};

});
parcelRegister("9920C", function(module, exports) {
"use strict";
var $6a8683448923ac90$var$util = module.exports;

// used to return a Promise where callback is omitted
$6a8683448923ac90$var$util.asPromise = (parcelRequire("jtjMu"));

// converts to / from base64 encoded strings
$6a8683448923ac90$var$util.base64 = (parcelRequire("hyp9t"));

// base class of rpc.Service
$6a8683448923ac90$var$util.EventEmitter = (parcelRequire("i8W33"));

// float handling accross browsers
$6a8683448923ac90$var$util.float = (parcelRequire("7BOYC"));

// requires modules optionally and hides the call from bundlers
$6a8683448923ac90$var$util.inquire = (parcelRequire("P7eYm"));

// converts to / from utf8 encoded strings
$6a8683448923ac90$var$util.utf8 = (parcelRequire("rm2dM"));

// provides a node-like buffer pool in the browser
$6a8683448923ac90$var$util.pool = (parcelRequire("5lR62"));

// utility to work with the low and high bits of a 64 bit value
$6a8683448923ac90$var$util.LongBits = (parcelRequire("5jc9v"));
/**
 * Whether running within node or not.
 * @memberof util
 * @type {boolean}
 */ $6a8683448923ac90$var$util.isNode = Boolean(typeof $parcel$global !== "undefined" && $parcel$global && $parcel$global.process && $parcel$global.process.versions && $parcel$global.process.versions.node);
/**
 * Global object reference.
 * @memberof util
 * @type {Object}
 */ $6a8683448923ac90$var$util.global = $6a8683448923ac90$var$util.isNode && $parcel$global || typeof window !== "undefined" && window || typeof self !== "undefined" && self || module.exports; // eslint-disable-line no-invalid-this
/**
 * An immuable empty array.
 * @memberof util
 * @type {Array.<*>}
 * @const
 */ $6a8683448923ac90$var$util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes
/**
 * An immutable empty object.
 * @type {Object}
 * @const
 */ $6a8683448923ac90$var$util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes
/**
 * Tests if the specified value is an integer.
 * @function
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is an integer
 */ $6a8683448923ac90$var$util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
/**
 * Tests if the specified value is a string.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a string
 */ $6a8683448923ac90$var$util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
};
/**
 * Tests if the specified value is a non-null object.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a non-null object
 */ $6a8683448923ac90$var$util.isObject = function isObject(value) {
    return value && typeof value === "object";
};
/**
 * Checks if a property on a message is considered to be present.
 * This is an alias of {@link util.isSet}.
 * @function
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $6a8683448923ac90$var$util.isset = /**
 * Checks if a property on a message is considered to be present.
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $6a8683448923ac90$var$util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && obj.hasOwnProperty(prop)) return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
};
/**
 * Any compatible Buffer instance.
 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
 * @interface Buffer
 * @extends Uint8Array
 */ /**
 * Node's Buffer class if available.
 * @type {Constructor<Buffer>}
 */ $6a8683448923ac90$var$util.Buffer = function() {
    try {
        var Buffer = $6a8683448923ac90$var$util.inquire("buffer").Buffer;
        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
// Internal alias of or polyfull for Buffer.from.
$6a8683448923ac90$var$util._Buffer_from = null;
// Internal alias of or polyfill for Buffer.allocUnsafe.
$6a8683448923ac90$var$util._Buffer_allocUnsafe = null;
/**
 * Creates a new buffer of whatever type supported by the environment.
 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
 * @returns {Uint8Array|Buffer} Buffer
 */ $6a8683448923ac90$var$util.newBuffer = function newBuffer(sizeOrArray) {
    /* istanbul ignore next */ return typeof sizeOrArray === "number" ? $6a8683448923ac90$var$util.Buffer ? $6a8683448923ac90$var$util._Buffer_allocUnsafe(sizeOrArray) : new $6a8683448923ac90$var$util.Array(sizeOrArray) : $6a8683448923ac90$var$util.Buffer ? $6a8683448923ac90$var$util._Buffer_from(sizeOrArray) : typeof Uint8Array === "undefined" ? sizeOrArray : new Uint8Array(sizeOrArray);
};
/**
 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
 * @type {Constructor<Uint8Array>}
 */ $6a8683448923ac90$var$util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */  : Array;
/**
 * Any compatible Long instance.
 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
 * @interface Long
 * @property {number} low Low bits
 * @property {number} high High bits
 * @property {boolean} unsigned Whether unsigned or not
 */ /**
 * Long.js's Long class if available.
 * @type {Constructor<Long>}
 */ $6a8683448923ac90$var$util.Long = /* istanbul ignore next */ $6a8683448923ac90$var$util.global.dcodeIO && /* istanbul ignore next */ $6a8683448923ac90$var$util.global.dcodeIO.Long || /* istanbul ignore next */ $6a8683448923ac90$var$util.global.Long || $6a8683448923ac90$var$util.inquire("long");
/**
 * Regular expression used to verify 2 bit (`bool`) map keys.
 * @type {RegExp}
 * @const
 */ $6a8683448923ac90$var$util.key2Re = /^true|false|0|1$/;
/**
 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $6a8683448923ac90$var$util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
/**
 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $6a8683448923ac90$var$util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
/**
 * Converts a number or long to an 8 characters long hash string.
 * @param {Long|number} value Value to convert
 * @returns {string} Hash
 */ $6a8683448923ac90$var$util.longToHash = function longToHash(value) {
    return value ? $6a8683448923ac90$var$util.LongBits.from(value).toHash() : $6a8683448923ac90$var$util.LongBits.zeroHash;
};
/**
 * Converts an 8 characters long hash string to a long or number.
 * @param {string} hash Hash
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long|number} Original value
 */ $6a8683448923ac90$var$util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = $6a8683448923ac90$var$util.LongBits.fromHash(hash);
    if ($6a8683448923ac90$var$util.Long) return $6a8683448923ac90$var$util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
};
/**
 * Merges the properties of the source object into the destination object.
 * @memberof util
 * @param {Object.<string,*>} dst Destination object
 * @param {Object.<string,*>} src Source object
 * @param {boolean} [ifNotSet=false] Merges only if the key is not already set
 * @returns {Object.<string,*>} Destination object
 */ function $6a8683448923ac90$var$merge(dst, src, ifNotSet) {
    for(var keys = Object.keys(src), i = 0; i < keys.length; ++i)if (dst[keys[i]] === undefined || !ifNotSet) dst[keys[i]] = src[keys[i]];
    return dst;
}
$6a8683448923ac90$var$util.merge = $6a8683448923ac90$var$merge;
/**
 * Converts the first character of a string to lower case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $6a8683448923ac90$var$util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};
/**
 * Creates a custom error constructor.
 * @memberof util
 * @param {string} name Error name
 * @returns {Constructor<Error>} Custom error constructor
 */ function $6a8683448923ac90$var$newError(name) {
    function CustomError(message, properties) {
        if (!(this instanceof CustomError)) return new CustomError(message, properties);
        // Error.call(this, message);
        // ^ just returns a new error instance because the ctor can be called as a function
        Object.defineProperty(this, "message", {
            get: function() {
                return message;
            }
        });
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, CustomError);
        else Object.defineProperty(this, "stack", {
            value: new Error().stack || ""
        });
        if (properties) $6a8683448923ac90$var$merge(this, properties);
    }
    CustomError.prototype = Object.create(Error.prototype, {
        constructor: {
            value: CustomError,
            writable: true,
            enumerable: false,
            configurable: true
        },
        name: {
            get: function get() {
                return name;
            },
            set: undefined,
            enumerable: false,
            // configurable: false would accurately preserve the behavior of
            // the original, but I'm guessing that was not intentional.
            // For an actual error subclass, this property would
            // be configurable.
            configurable: true
        },
        toString: {
            value: function value() {
                return this.name + ": " + this.message;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    return CustomError;
}
$6a8683448923ac90$var$util.newError = $6a8683448923ac90$var$newError;
/**
 * Constructs a new protocol error.
 * @classdesc Error subclass indicating a protocol specifc error.
 * @memberof util
 * @extends Error
 * @template T extends Message<T>
 * @constructor
 * @param {string} message Error message
 * @param {Object.<string,*>} [properties] Additional properties
 * @example
 * try {
 *     MyMessage.decode(someBuffer); // throws if required fields are missing
 * } catch (e) {
 *     if (e instanceof ProtocolError && e.instance)
 *         console.log("decoded so far: " + JSON.stringify(e.instance));
 * }
 */ $6a8683448923ac90$var$util.ProtocolError = $6a8683448923ac90$var$newError("ProtocolError");
/**
 * So far decoded message instance.
 * @name util.ProtocolError#instance
 * @type {Message<T>}
 */ /**
 * A OneOf getter as returned by {@link util.oneOfGetter}.
 * @typedef OneOfGetter
 * @type {function}
 * @returns {string|undefined} Set field name, if any
 */ /**
 * Builds a getter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfGetter} Unbound getter
 */ $6a8683448923ac90$var$util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for(var i = 0; i < fieldNames.length; ++i)fieldMap[fieldNames[i]] = 1;
    /**
     * @returns {string|undefined} Set field name, if any
     * @this Object
     * @ignore
     */ return function() {
        for(var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null) return keys[i];
    };
};
/**
 * A OneOf setter as returned by {@link util.oneOfSetter}.
 * @typedef OneOfSetter
 * @type {function}
 * @param {string|undefined} value Field name
 * @returns {undefined}
 */ /**
 * Builds a setter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfSetter} Unbound setter
 */ $6a8683448923ac90$var$util.oneOfSetter = function setOneOf(fieldNames) {
    /**
     * @param {string} name Field name
     * @returns {undefined}
     * @this Object
     * @ignore
     */ return function(name) {
        for(var i = 0; i < fieldNames.length; ++i)if (fieldNames[i] !== name) delete this[fieldNames[i]];
    };
};
/**
 * Default conversion options used for {@link Message#toJSON} implementations.
 *
 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
 *
 * - Longs become strings
 * - Enums become string keys
 * - Bytes become base64 encoded strings
 * - (Sub-)Messages become plain objects
 * - Maps become plain objects with all string keys
 * - Repeated fields become arrays
 * - NaN and Infinity for float and double fields become strings
 *
 * @type {IConversionOptions}
 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
 */ $6a8683448923ac90$var$util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
};
// Sets up buffer utility according to the environment (called in index-minimal)
$6a8683448923ac90$var$util._configure = function() {
    var Buffer = $6a8683448923ac90$var$util.Buffer;
    /* istanbul ignore if */ if (!Buffer) {
        $6a8683448923ac90$var$util._Buffer_from = $6a8683448923ac90$var$util._Buffer_allocUnsafe = null;
        return;
    }
    // because node 4.x buffers are incompatible & immutable
    // see: https://github.com/dcodeIO/protobuf.js/pull/665
    $6a8683448923ac90$var$util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from || /* istanbul ignore next */ function Buffer_from(value, encoding) {
        return new Buffer(value, encoding);
    };
    $6a8683448923ac90$var$util._Buffer_allocUnsafe = Buffer.allocUnsafe || /* istanbul ignore next */ function Buffer_allocUnsafe(size) {
        return new Buffer(size);
    };
};

});
parcelRegister("jtjMu", function(module, exports) {
"use strict";
module.exports = $e2d011df7dad05f1$var$asPromise;
/**
 * Callback as used by {@link util.asPromise}.
 * @typedef asPromiseCallback
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {...*} params Additional arguments
 * @returns {undefined}
 */ /**
 * Returns a promise from a node-style callback function.
 * @memberof util
 * @param {asPromiseCallback} fn Function to call
 * @param {*} ctx Function context
 * @param {...*} params Function arguments
 * @returns {Promise<*>} Promisified function
 */ function $e2d011df7dad05f1$var$asPromise(fn, ctx /*, varargs */ ) {
    var params = new Array(arguments.length - 1), offset = 0, index = 2, pending = true;
    while(index < arguments.length)params[offset++] = arguments[index++];
    return new Promise(function executor(resolve, reject) {
        params[offset] = function callback(err /*, varargs */ ) {
            if (pending) {
                pending = false;
                if (err) reject(err);
                else {
                    var params = new Array(arguments.length - 1), offset = 0;
                    while(offset < params.length)params[offset++] = arguments[offset];
                    resolve.apply(null, params);
                }
            }
        };
        try {
            fn.apply(ctx || null, params);
        } catch (err) {
            if (pending) {
                pending = false;
                reject(err);
            }
        }
    });
}

});

parcelRegister("hyp9t", function(module, exports) {
"use strict";
/**
 * A minimal base64 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $cc791f41076f52d5$var$base64 = module.exports;
/**
 * Calculates the byte length of a base64 encoded string.
 * @param {string} string Base64 encoded string
 * @returns {number} Byte length
 */ $cc791f41076f52d5$var$base64.length = function length(string) {
    var p = string.length;
    if (!p) return 0;
    var n = 0;
    while(--p % 4 > 1 && string.charAt(p) === "=")++n;
    return Math.ceil(string.length * 3) / 4 - n;
};
// Base64 encoding table
var $cc791f41076f52d5$var$b64 = new Array(64);
// Base64 decoding table
var $cc791f41076f52d5$var$s64 = new Array(123);
// 65..90, 97..122, 48..57, 43, 47
for(var $cc791f41076f52d5$var$i = 0; $cc791f41076f52d5$var$i < 64;)$cc791f41076f52d5$var$s64[$cc791f41076f52d5$var$b64[$cc791f41076f52d5$var$i] = $cc791f41076f52d5$var$i < 26 ? $cc791f41076f52d5$var$i + 65 : $cc791f41076f52d5$var$i < 52 ? $cc791f41076f52d5$var$i + 71 : $cc791f41076f52d5$var$i < 62 ? $cc791f41076f52d5$var$i - 4 : $cc791f41076f52d5$var$i - 59 | 43] = $cc791f41076f52d5$var$i++;
/**
 * Encodes a buffer to a base64 encoded string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} Base64 encoded string
 */ $cc791f41076f52d5$var$base64.encode = function encode(buffer, start, end) {
    var parts = null, chunk = [];
    var i = 0, j = 0, t; // temporary
    while(start < end){
        var b = buffer[start++];
        switch(j){
            case 0:
                chunk[i++] = $cc791f41076f52d5$var$b64[b >> 2];
                t = (b & 3) << 4;
                j = 1;
                break;
            case 1:
                chunk[i++] = $cc791f41076f52d5$var$b64[t | b >> 4];
                t = (b & 15) << 2;
                j = 2;
                break;
            case 2:
                chunk[i++] = $cc791f41076f52d5$var$b64[t | b >> 6];
                chunk[i++] = $cc791f41076f52d5$var$b64[b & 63];
                j = 0;
                break;
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (j) {
        chunk[i++] = $cc791f41076f52d5$var$b64[t];
        chunk[i++] = 61;
        if (j === 1) chunk[i++] = 61;
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
var $cc791f41076f52d5$var$invalidEncoding = "invalid encoding";
/**
 * Decodes a base64 encoded string to a buffer.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Number of bytes written
 * @throws {Error} If encoding is invalid
 */ $cc791f41076f52d5$var$base64.decode = function decode(string, buffer, offset) {
    var start = offset;
    var j = 0, t; // temporary
    for(var i = 0; i < string.length;){
        var c = string.charCodeAt(i++);
        if (c === 61 && j > 1) break;
        if ((c = $cc791f41076f52d5$var$s64[c]) === undefined) throw Error($cc791f41076f52d5$var$invalidEncoding);
        switch(j){
            case 0:
                t = c;
                j = 1;
                break;
            case 1:
                buffer[offset++] = t << 2 | (c & 48) >> 4;
                t = c;
                j = 2;
                break;
            case 2:
                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
                t = c;
                j = 3;
                break;
            case 3:
                buffer[offset++] = (t & 3) << 6 | c;
                j = 0;
                break;
        }
    }
    if (j === 1) throw Error($cc791f41076f52d5$var$invalidEncoding);
    return offset - start;
};
/**
 * Tests if the specified string appears to be base64 encoded.
 * @param {string} string String to test
 * @returns {boolean} `true` if probably base64 encoded, otherwise false
 */ $cc791f41076f52d5$var$base64.test = function test(string) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
};

});

parcelRegister("i8W33", function(module, exports) {
"use strict";
module.exports = $d356008c0cff95a4$var$EventEmitter;
/**
 * Constructs a new event emitter instance.
 * @classdesc A minimal event emitter.
 * @memberof util
 * @constructor
 */ function $d356008c0cff95a4$var$EventEmitter() {
    /**
     * Registered listeners.
     * @type {Object.<string,*>}
     * @private
     */ this._listeners = {};
}
/**
 * Registers an event listener.
 * @param {string} evt Event name
 * @param {function} fn Listener
 * @param {*} [ctx] Listener context
 * @returns {util.EventEmitter} `this`
 */ $d356008c0cff95a4$var$EventEmitter.prototype.on = function on(evt, fn, ctx) {
    (this._listeners[evt] || (this._listeners[evt] = [])).push({
        fn: fn,
        ctx: ctx || this
    });
    return this;
};
/**
 * Removes an event listener or any matching listeners if arguments are omitted.
 * @param {string} [evt] Event name. Removes all listeners if omitted.
 * @param {function} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
 * @returns {util.EventEmitter} `this`
 */ $d356008c0cff95a4$var$EventEmitter.prototype.off = function off(evt, fn) {
    if (evt === undefined) this._listeners = {};
    else if (fn === undefined) this._listeners[evt] = [];
    else {
        var listeners = this._listeners[evt];
        for(var i = 0; i < listeners.length;)if (listeners[i].fn === fn) listeners.splice(i, 1);
        else ++i;
    }
    return this;
};
/**
 * Emits an event by calling its listeners with the specified arguments.
 * @param {string} evt Event name
 * @param {...*} args Arguments
 * @returns {util.EventEmitter} `this`
 */ $d356008c0cff95a4$var$EventEmitter.prototype.emit = function emit(evt) {
    var listeners = this._listeners[evt];
    if (listeners) {
        var args = [], i = 1;
        for(; i < arguments.length;)args.push(arguments[i++]);
        for(i = 0; i < listeners.length;)listeners[i].fn.apply(listeners[i++].ctx, args);
    }
    return this;
};

});

parcelRegister("7BOYC", function(module, exports) {
"use strict";
module.exports = $58a38803c73f3427$var$factory($58a38803c73f3427$var$factory);
/**
 * Reads / writes floats / doubles from / to buffers.
 * @name util.float
 * @namespace
 */ /**
 * Writes a 32 bit float to a buffer using little endian byte order.
 * @name util.float.writeFloatLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 32 bit float to a buffer using big endian byte order.
 * @name util.float.writeFloatBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 32 bit float from a buffer using little endian byte order.
 * @name util.float.readFloatLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 32 bit float from a buffer using big endian byte order.
 * @name util.float.readFloatBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Writes a 64 bit double to a buffer using little endian byte order.
 * @name util.float.writeDoubleLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 64 bit double to a buffer using big endian byte order.
 * @name util.float.writeDoubleBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 64 bit double from a buffer using little endian byte order.
 * @name util.float.readDoubleLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 64 bit double from a buffer using big endian byte order.
 * @name util.float.readDoubleBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ // Factory function for the purpose of node-based testing in modified global environments
function $58a38803c73f3427$var$factory(exports) {
    // float: typed array
    if (typeof Float32Array !== "undefined") (function() {
        var f32 = new Float32Array([
            -0
        ]), f8b = new Uint8Array(f32.buffer), le = f8b[3] === 128;
        function writeFloat_f32_cpy(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
        }
        function writeFloat_f32_rev(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[3];
            buf[pos + 1] = f8b[2];
            buf[pos + 2] = f8b[1];
            buf[pos + 3] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
        /* istanbul ignore next */ exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
        function readFloat_f32_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            return f32[0];
        }
        function readFloat_f32_rev(buf, pos) {
            f8b[3] = buf[pos];
            f8b[2] = buf[pos + 1];
            f8b[1] = buf[pos + 2];
            f8b[0] = buf[pos + 3];
            return f32[0];
        }
        /* istanbul ignore next */ exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
        /* istanbul ignore next */ exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
    // float: ieee754
    })();
    else (function() {
        function writeFloat_ieee754(writeUint, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
            else if (isNaN(val)) writeUint(2143289344, buf, pos);
            else if (val > 3.4028234663852886e+38) writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
            else if (val < 1.1754943508222875e-38) writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
            else {
                var exponent = Math.floor(Math.log(val) / Math.LN2), mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
            }
        }
        exports.writeFloatLE = writeFloat_ieee754.bind(null, $58a38803c73f3427$var$writeUintLE);
        exports.writeFloatBE = writeFloat_ieee754.bind(null, $58a38803c73f3427$var$writeUintBE);
        function readFloat_ieee754(readUint, buf, pos) {
            var uint = readUint(buf, pos), sign = (uint >> 31) * 2 + 1, exponent = uint >>> 23 & 255, mantissa = uint & 8388607;
            return exponent === 255 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 1.401298464324817e-45 * mantissa : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
        }
        exports.readFloatLE = readFloat_ieee754.bind(null, $58a38803c73f3427$var$readUintLE);
        exports.readFloatBE = readFloat_ieee754.bind(null, $58a38803c73f3427$var$readUintBE);
    })();
    // double: typed array
    if (typeof Float64Array !== "undefined") (function() {
        var f64 = new Float64Array([
            -0
        ]), f8b = new Uint8Array(f64.buffer), le = f8b[7] === 128;
        function writeDouble_f64_cpy(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
            buf[pos + 4] = f8b[4];
            buf[pos + 5] = f8b[5];
            buf[pos + 6] = f8b[6];
            buf[pos + 7] = f8b[7];
        }
        function writeDouble_f64_rev(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[7];
            buf[pos + 1] = f8b[6];
            buf[pos + 2] = f8b[5];
            buf[pos + 3] = f8b[4];
            buf[pos + 4] = f8b[3];
            buf[pos + 5] = f8b[2];
            buf[pos + 6] = f8b[1];
            buf[pos + 7] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
        /* istanbul ignore next */ exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
        function readDouble_f64_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            f8b[4] = buf[pos + 4];
            f8b[5] = buf[pos + 5];
            f8b[6] = buf[pos + 6];
            f8b[7] = buf[pos + 7];
            return f64[0];
        }
        function readDouble_f64_rev(buf, pos) {
            f8b[7] = buf[pos];
            f8b[6] = buf[pos + 1];
            f8b[5] = buf[pos + 2];
            f8b[4] = buf[pos + 3];
            f8b[3] = buf[pos + 4];
            f8b[2] = buf[pos + 5];
            f8b[1] = buf[pos + 6];
            f8b[0] = buf[pos + 7];
            return f64[0];
        }
        /* istanbul ignore next */ exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
        /* istanbul ignore next */ exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
    // double: ieee754
    })();
    else (function() {
        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) {
                writeUint(0, buf, pos + off0);
                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
            } else if (isNaN(val)) {
                writeUint(0, buf, pos + off0);
                writeUint(2146959360, buf, pos + off1);
            } else if (val > 1.7976931348623157e+308) {
                writeUint(0, buf, pos + off0);
                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
            } else {
                var mantissa;
                if (val < 2.2250738585072014e-308) {
                    mantissa = val / 5e-324;
                    writeUint(mantissa >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
                } else {
                    var exponent = Math.floor(Math.log(val) / Math.LN2);
                    if (exponent === 1024) exponent = 1023;
                    mantissa = val * Math.pow(2, -exponent);
                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
                }
            }
        }
        exports.writeDoubleLE = writeDouble_ieee754.bind(null, $58a38803c73f3427$var$writeUintLE, 0, 4);
        exports.writeDoubleBE = writeDouble_ieee754.bind(null, $58a38803c73f3427$var$writeUintBE, 4, 0);
        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
            var lo = readUint(buf, pos + off0), hi = readUint(buf, pos + off1);
            var sign = (hi >> 31) * 2 + 1, exponent = hi >>> 20 & 2047, mantissa = 4294967296 * (hi & 1048575) + lo;
            return exponent === 2047 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 5e-324 * mantissa : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
        }
        exports.readDoubleLE = readDouble_ieee754.bind(null, $58a38803c73f3427$var$readUintLE, 0, 4);
        exports.readDoubleBE = readDouble_ieee754.bind(null, $58a38803c73f3427$var$readUintBE, 4, 0);
    })();
    return exports;
}
// uint helpers
function $58a38803c73f3427$var$writeUintLE(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
function $58a38803c73f3427$var$writeUintBE(val, buf, pos) {
    buf[pos] = val >>> 24;
    buf[pos + 1] = val >>> 16 & 255;
    buf[pos + 2] = val >>> 8 & 255;
    buf[pos + 3] = val & 255;
}
function $58a38803c73f3427$var$readUintLE(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16 | buf[pos + 3] << 24) >>> 0;
}
function $58a38803c73f3427$var$readUintBE(buf, pos) {
    return (buf[pos] << 24 | buf[pos + 1] << 16 | buf[pos + 2] << 8 | buf[pos + 3]) >>> 0;
}

});

parcelRegister("P7eYm", function(module, exports) {
"use strict";
module.exports = inquire;
/**
 * Requires a module only if available.
 * @memberof util
 * @param {string} moduleName Module to require
 * @returns {?Object} Required module if available and not empty, otherwise `null`
 */ function inquire(moduleName) {
    try {
        var mod = eval("quire".replace(/^/, "re"))(moduleName); // eslint-disable-line no-eval
        if (mod && (mod.length || Object.keys(mod).length)) return mod;
    } catch (e) {} // eslint-disable-line no-empty
    return null;
}

});

parcelRegister("rm2dM", function(module, exports) {
"use strict";
/**
 * A minimal UTF8 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $05239d637b100fac$var$utf8 = module.exports;
/**
 * Calculates the UTF8 byte length of a string.
 * @param {string} string String
 * @returns {number} Byte length
 */ $05239d637b100fac$var$utf8.length = function utf8_length(string) {
    var len = 0, c = 0;
    for(var i = 0; i < string.length; ++i){
        c = string.charCodeAt(i);
        if (c < 128) len += 1;
        else if (c < 2048) len += 2;
        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
            ++i;
            len += 4;
        } else len += 3;
    }
    return len;
};
/**
 * Reads UTF8 bytes as a string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} String read
 */ $05239d637b100fac$var$utf8.read = function utf8_read(buffer, start, end) {
    var len = end - start;
    if (len < 1) return "";
    var parts = null, chunk = [], i = 0, t; // temporary
    while(start < end){
        t = buffer[start++];
        if (t < 128) chunk[i++] = t;
        else if (t > 191 && t < 224) chunk[i++] = (t & 31) << 6 | buffer[start++] & 63;
        else if (t > 239 && t < 365) {
            t = ((t & 7) << 18 | (buffer[start++] & 63) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63) - 0x10000;
            chunk[i++] = 0xD800 + (t >> 10);
            chunk[i++] = 0xDC00 + (t & 1023);
        } else chunk[i++] = (t & 15) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63;
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
/**
 * Writes a string as UTF8 bytes.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Bytes written
 */ $05239d637b100fac$var$utf8.write = function utf8_write(string, buffer, offset) {
    var start = offset, c1, c2; // character 2
    for(var i = 0; i < string.length; ++i){
        c1 = string.charCodeAt(i);
        if (c1 < 128) buffer[offset++] = c1;
        else if (c1 < 2048) {
            buffer[offset++] = c1 >> 6 | 192;
            buffer[offset++] = c1 & 63 | 128;
        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
            ++i;
            buffer[offset++] = c1 >> 18 | 240;
            buffer[offset++] = c1 >> 12 & 63 | 128;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        } else {
            buffer[offset++] = c1 >> 12 | 224;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        }
    }
    return offset - start;
};

});

parcelRegister("5lR62", function(module, exports) {
"use strict";
module.exports = $3e5819c762a7b860$var$pool;
/**
 * An allocator as used by {@link util.pool}.
 * @typedef PoolAllocator
 * @type {function}
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ /**
 * A slicer as used by {@link util.pool}.
 * @typedef PoolSlicer
 * @type {function}
 * @param {number} start Start offset
 * @param {number} end End offset
 * @returns {Uint8Array} Buffer slice
 * @this {Uint8Array}
 */ /**
 * A general purpose buffer pool.
 * @memberof util
 * @function
 * @param {PoolAllocator} alloc Allocator
 * @param {PoolSlicer} slice Slicer
 * @param {number} [size=8192] Slab size
 * @returns {PoolAllocator} Pooled allocator
 */ function $3e5819c762a7b860$var$pool(alloc, slice, size) {
    var SIZE = size || 8192;
    var MAX = SIZE >>> 1;
    var slab = null;
    var offset = SIZE;
    return function pool_alloc(size) {
        if (size < 1 || size > MAX) return alloc(size);
        if (offset + size > SIZE) {
            slab = alloc(SIZE);
            offset = 0;
        }
        var buf = slice.call(slab, offset, offset += size);
        if (offset & 7) offset = (offset | 7) + 1;
        return buf;
    };
}

});

parcelRegister("5jc9v", function(module, exports) {
"use strict";
module.exports = $3dd82750ac9256cd$var$LongBits;

var $9920C = parcelRequire("9920C");
/**
 * Constructs new long bits.
 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
 * @memberof util
 * @constructor
 * @param {number} lo Low 32 bits, unsigned
 * @param {number} hi High 32 bits, unsigned
 */ function $3dd82750ac9256cd$var$LongBits(lo, hi) {
    // note that the casts below are theoretically unnecessary as of today, but older statically
    // generated converter code might still call the ctor with signed 32bits. kept for compat.
    /**
     * Low bits.
     * @type {number}
     */ this.lo = lo >>> 0;
    /**
     * High bits.
     * @type {number}
     */ this.hi = hi >>> 0;
}
/**
 * Zero bits.
 * @memberof util.LongBits
 * @type {util.LongBits}
 */ var $3dd82750ac9256cd$var$zero = $3dd82750ac9256cd$var$LongBits.zero = new $3dd82750ac9256cd$var$LongBits(0, 0);
$3dd82750ac9256cd$var$zero.toNumber = function() {
    return 0;
};
$3dd82750ac9256cd$var$zero.zzEncode = $3dd82750ac9256cd$var$zero.zzDecode = function() {
    return this;
};
$3dd82750ac9256cd$var$zero.length = function() {
    return 1;
};
/**
 * Zero hash.
 * @memberof util.LongBits
 * @type {string}
 */ var $3dd82750ac9256cd$var$zeroHash = $3dd82750ac9256cd$var$LongBits.zeroHash = "\0\0\0\0\0\0\0\0";
/**
 * Constructs new long bits from the specified number.
 * @param {number} value Value
 * @returns {util.LongBits} Instance
 */ $3dd82750ac9256cd$var$LongBits.fromNumber = function fromNumber(value) {
    if (value === 0) return $3dd82750ac9256cd$var$zero;
    var sign = value < 0;
    if (sign) value = -value;
    var lo = value >>> 0, hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
        hi = ~hi >>> 0;
        lo = ~lo >>> 0;
        if (++lo > 4294967295) {
            lo = 0;
            if (++hi > 4294967295) hi = 0;
        }
    }
    return new $3dd82750ac9256cd$var$LongBits(lo, hi);
};
/**
 * Constructs new long bits from a number, long or string.
 * @param {Long|number|string} value Value
 * @returns {util.LongBits} Instance
 */ $3dd82750ac9256cd$var$LongBits.from = function from(value) {
    if (typeof value === "number") return $3dd82750ac9256cd$var$LongBits.fromNumber(value);
    if ($9920C.isString(value)) {
        /* istanbul ignore else */ if ($9920C.Long) value = $9920C.Long.fromString(value);
        else return $3dd82750ac9256cd$var$LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new $3dd82750ac9256cd$var$LongBits(value.low >>> 0, value.high >>> 0) : $3dd82750ac9256cd$var$zero;
};
/**
 * Converts this long bits to a possibly unsafe JavaScript number.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {number} Possibly unsafe number
 */ $3dd82750ac9256cd$var$LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
        var lo = ~this.lo + 1 >>> 0, hi = ~this.hi >>> 0;
        if (!lo) hi = hi + 1 >>> 0;
        return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
};
/**
 * Converts this long bits to a long.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long} Long
 */ $3dd82750ac9256cd$var$LongBits.prototype.toLong = function toLong(unsigned) {
    return $9920C.Long ? new $9920C.Long(this.lo | 0, this.hi | 0, Boolean(unsigned)) : {
        low: this.lo | 0,
        high: this.hi | 0,
        unsigned: Boolean(unsigned)
    };
};
var $3dd82750ac9256cd$var$charCodeAt = String.prototype.charCodeAt;
/**
 * Constructs new long bits from the specified 8 characters long hash.
 * @param {string} hash Hash
 * @returns {util.LongBits} Bits
 */ $3dd82750ac9256cd$var$LongBits.fromHash = function fromHash(hash) {
    if (hash === $3dd82750ac9256cd$var$zeroHash) return $3dd82750ac9256cd$var$zero;
    return new $3dd82750ac9256cd$var$LongBits(($3dd82750ac9256cd$var$charCodeAt.call(hash, 0) | $3dd82750ac9256cd$var$charCodeAt.call(hash, 1) << 8 | $3dd82750ac9256cd$var$charCodeAt.call(hash, 2) << 16 | $3dd82750ac9256cd$var$charCodeAt.call(hash, 3) << 24) >>> 0, ($3dd82750ac9256cd$var$charCodeAt.call(hash, 4) | $3dd82750ac9256cd$var$charCodeAt.call(hash, 5) << 8 | $3dd82750ac9256cd$var$charCodeAt.call(hash, 6) << 16 | $3dd82750ac9256cd$var$charCodeAt.call(hash, 7) << 24) >>> 0);
};
/**
 * Converts this long bits to a 8 characters long hash.
 * @returns {string} Hash
 */ $3dd82750ac9256cd$var$LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
};
/**
 * Zig-zag encodes this long bits.
 * @returns {util.LongBits} `this`
 */ $3dd82750ac9256cd$var$LongBits.prototype.zzEncode = function zzEncode() {
    var mask = this.hi >> 31;
    this.hi = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo = (this.lo << 1 ^ mask) >>> 0;
    return this;
};
/**
 * Zig-zag decodes this long bits.
 * @returns {util.LongBits} `this`
 */ $3dd82750ac9256cd$var$LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi = (this.hi >>> 1 ^ mask) >>> 0;
    return this;
};
/**
 * Calculates the length of this longbits when encoded as a varint.
 * @returns {number} Length
 */ $3dd82750ac9256cd$var$LongBits.prototype.length = function length() {
    var part0 = this.lo, part1 = (this.lo >>> 28 | this.hi << 4) >>> 0, part2 = this.hi >>> 24;
    return part2 === 0 ? part1 === 0 ? part0 < 16384 ? part0 < 128 ? 1 : 2 : part0 < 2097152 ? 3 : 4 : part1 < 16384 ? part1 < 128 ? 5 : 6 : part1 < 2097152 ? 7 : 8 : part2 < 128 ? 9 : 10;
};

});



parcelRegister("4Ius5", function(module, exports) {
"use strict";
module.exports = $36f2e4a2eaf69f36$var$BufferWriter;

var $i4Gf0 = parcelRequire("i4Gf0");
($36f2e4a2eaf69f36$var$BufferWriter.prototype = Object.create($i4Gf0.prototype)).constructor = $36f2e4a2eaf69f36$var$BufferWriter;

var $9920C = parcelRequire("9920C");
/**
 * Constructs a new buffer writer instance.
 * @classdesc Wire format writer using node buffers.
 * @extends Writer
 * @constructor
 */ function $36f2e4a2eaf69f36$var$BufferWriter() {
    $i4Gf0.call(this);
}
$36f2e4a2eaf69f36$var$BufferWriter._configure = function() {
    /**
     * Allocates a buffer of the specified size.
     * @function
     * @param {number} size Buffer size
     * @returns {Buffer} Buffer
     */ $36f2e4a2eaf69f36$var$BufferWriter.alloc = $9920C._Buffer_allocUnsafe;
    $36f2e4a2eaf69f36$var$BufferWriter.writeBytesBuffer = $9920C.Buffer && $9920C.Buffer.prototype instanceof Uint8Array && $9920C.Buffer.prototype.set.name === "set" ? function writeBytesBuffer_set(val, buf, pos) {
        buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
    // also works for plain array values
    } : function writeBytesBuffer_copy(val, buf, pos) {
        if (val.copy) val.copy(buf, pos, 0, val.length);
        else for(var i = 0; i < val.length;)buf[pos++] = val[i++];
    };
};
/**
 * @override
 */ $36f2e4a2eaf69f36$var$BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if ($9920C.isString(value)) value = $9920C._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len) this._push($36f2e4a2eaf69f36$var$BufferWriter.writeBytesBuffer, len, value);
    return this;
};
function $36f2e4a2eaf69f36$var$writeStringBuffer(val, buf, pos) {
    if (val.length < 40) $9920C.utf8.write(val, buf, pos);
    else if (buf.utf8Write) buf.utf8Write(val, pos);
    else buf.write(val, pos);
}
/**
 * @override
 */ $36f2e4a2eaf69f36$var$BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = $9920C.Buffer.byteLength(value);
    this.uint32(len);
    if (len) this._push($36f2e4a2eaf69f36$var$writeStringBuffer, len, value);
    return this;
};
/**
 * Finishes the write operation.
 * @name BufferWriter#finish
 * @function
 * @returns {Buffer} Finished buffer
 */ $36f2e4a2eaf69f36$var$BufferWriter._configure();

});

parcelRegister("akfl2", function(module, exports) {
"use strict";
module.exports = $7847ab809aa9b3f0$var$Reader;

var $9920C = parcelRequire("9920C");
var $7847ab809aa9b3f0$var$BufferReader; // cyclic
var $7847ab809aa9b3f0$var$LongBits = $9920C.LongBits, $7847ab809aa9b3f0$var$utf8 = $9920C.utf8;
/* istanbul ignore next */ function $7847ab809aa9b3f0$var$indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
}
/**
 * Constructs a new reader instance using the specified buffer.
 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 * @param {Uint8Array} buffer Buffer to read from
 */ function $7847ab809aa9b3f0$var$Reader(buffer) {
    /**
     * Read buffer.
     * @type {Uint8Array}
     */ this.buf = buffer;
    /**
     * Read buffer position.
     * @type {number}
     */ this.pos = 0;
    /**
     * Read buffer length.
     * @type {number}
     */ this.len = buffer.length;
}
var $7847ab809aa9b3f0$var$create_array = typeof Uint8Array !== "undefined" ? function create_typed_array(buffer) {
    if (buffer instanceof Uint8Array || Array.isArray(buffer)) return new $7847ab809aa9b3f0$var$Reader(buffer);
    throw Error("illegal buffer");
} : function create_array(buffer) {
    if (Array.isArray(buffer)) return new $7847ab809aa9b3f0$var$Reader(buffer);
    throw Error("illegal buffer");
};
var $7847ab809aa9b3f0$var$create = function create() {
    return $9920C.Buffer ? function create_buffer_setup(buffer) {
        return ($7847ab809aa9b3f0$var$Reader.create = function create_buffer(buffer) {
            return $9920C.Buffer.isBuffer(buffer) ? new $7847ab809aa9b3f0$var$BufferReader(buffer) : $7847ab809aa9b3f0$var$create_array(buffer);
        })(buffer);
    } : $7847ab809aa9b3f0$var$create_array;
};
/**
 * Creates a new reader using the specified buffer.
 * @function
 * @param {Uint8Array|Buffer} buffer Buffer to read from
 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
 * @throws {Error} If `buffer` is not a valid buffer
 */ $7847ab809aa9b3f0$var$Reader.create = $7847ab809aa9b3f0$var$create();
$7847ab809aa9b3f0$var$Reader.prototype._slice = $9920C.Array.prototype.subarray || /* istanbul ignore next */ $9920C.Array.prototype.slice;
/**
 * Reads a varint as an unsigned 32 bit value.
 * @function
 * @returns {number} Value read
 */ $7847ab809aa9b3f0$var$Reader.prototype.uint32 = function read_uint32_setup() {
    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
    return function read_uint32() {
        value = (this.buf[this.pos] & 127) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 7) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 15) << 28) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        /* istanbul ignore if */ if ((this.pos += 5) > this.len) {
            this.pos = this.len;
            throw $7847ab809aa9b3f0$var$indexOutOfRange(this, 10);
        }
        return value;
    };
}();
/**
 * Reads a varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $7847ab809aa9b3f0$var$Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
};
/**
 * Reads a zig-zag encoded varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $7847ab809aa9b3f0$var$Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
};
/* eslint-disable no-invalid-this */ function $7847ab809aa9b3f0$var$readLongVarint() {
    // tends to deopt with local vars for octet etc.
    var bits = new $7847ab809aa9b3f0$var$LongBits(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
        for(; i < 4; ++i){
            // 1st..4th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 5th
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >> 4) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
        i = 0;
    } else {
        for(; i < 3; ++i){
            /* istanbul ignore if */ if (this.pos >= this.len) throw $7847ab809aa9b3f0$var$indexOutOfRange(this);
            // 1st..3th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 4th
        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
        return bits;
    }
    if (this.len - this.pos > 4) for(; i < 5; ++i){
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    else for(; i < 5; ++i){
        /* istanbul ignore if */ if (this.pos >= this.len) throw $7847ab809aa9b3f0$var$indexOutOfRange(this);
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    /* istanbul ignore next */ throw Error("invalid varint encoding");
}
/* eslint-enable no-invalid-this */ /**
 * Reads a varint as a signed 64 bit value.
 * @name Reader#int64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as an unsigned 64 bit value.
 * @name Reader#uint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a zig-zag encoded varint as a signed 64 bit value.
 * @name Reader#sint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as a boolean.
 * @returns {boolean} Value read
 */ $7847ab809aa9b3f0$var$Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
};
function $7847ab809aa9b3f0$var$readFixed32_end(buf, end) {
    return (buf[end - 4] | buf[end - 3] << 8 | buf[end - 2] << 16 | buf[end - 1] << 24) >>> 0;
}
/**
 * Reads fixed 32 bits as an unsigned 32 bit integer.
 * @returns {number} Value read
 */ $7847ab809aa9b3f0$var$Reader.prototype.fixed32 = function read_fixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $7847ab809aa9b3f0$var$indexOutOfRange(this, 4);
    return $7847ab809aa9b3f0$var$readFixed32_end(this.buf, this.pos += 4);
};
/**
 * Reads fixed 32 bits as a signed 32 bit integer.
 * @returns {number} Value read
 */ $7847ab809aa9b3f0$var$Reader.prototype.sfixed32 = function read_sfixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $7847ab809aa9b3f0$var$indexOutOfRange(this, 4);
    return $7847ab809aa9b3f0$var$readFixed32_end(this.buf, this.pos += 4) | 0;
};
/* eslint-disable no-invalid-this */ function $7847ab809aa9b3f0$var$readFixed64() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $7847ab809aa9b3f0$var$indexOutOfRange(this, 8);
    return new $7847ab809aa9b3f0$var$LongBits($7847ab809aa9b3f0$var$readFixed32_end(this.buf, this.pos += 4), $7847ab809aa9b3f0$var$readFixed32_end(this.buf, this.pos += 4));
}
/* eslint-enable no-invalid-this */ /**
 * Reads fixed 64 bits.
 * @name Reader#fixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads zig-zag encoded fixed 64 bits.
 * @name Reader#sfixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a float (32 bit) as a number.
 * @function
 * @returns {number} Value read
 */ $7847ab809aa9b3f0$var$Reader.prototype.float = function read_float() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $7847ab809aa9b3f0$var$indexOutOfRange(this, 4);
    var value = $9920C.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
};
/**
 * Reads a double (64 bit float) as a number.
 * @function
 * @returns {number} Value read
 */ $7847ab809aa9b3f0$var$Reader.prototype.double = function read_double() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $7847ab809aa9b3f0$var$indexOutOfRange(this, 4);
    var value = $9920C.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @returns {Uint8Array} Value read
 */ $7847ab809aa9b3f0$var$Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(), start = this.pos, end = this.pos + length;
    /* istanbul ignore if */ if (end > this.len) throw $7847ab809aa9b3f0$var$indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf)) return this.buf.slice(start, end);
    if (start === end) {
        var nativeBuffer = $9920C.Buffer;
        return nativeBuffer ? nativeBuffer.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, start, end);
};
/**
 * Reads a string preceeded by its byte length as a varint.
 * @returns {string} Value read
 */ $7847ab809aa9b3f0$var$Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return $7847ab809aa9b3f0$var$utf8.read(bytes, 0, bytes.length);
};
/**
 * Skips the specified number of bytes if specified, otherwise skips a varint.
 * @param {number} [length] Length if known, otherwise a varint is assumed
 * @returns {Reader} `this`
 */ $7847ab809aa9b3f0$var$Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
        /* istanbul ignore if */ if (this.pos + length > this.len) throw $7847ab809aa9b3f0$var$indexOutOfRange(this, length);
        this.pos += length;
    } else do {
        /* istanbul ignore if */ if (this.pos >= this.len) throw $7847ab809aa9b3f0$var$indexOutOfRange(this);
    }while (this.buf[this.pos++] & 128);
    return this;
};
/**
 * Skips the next element of the specified wire type.
 * @param {number} wireType Wire type received
 * @returns {Reader} `this`
 */ $7847ab809aa9b3f0$var$Reader.prototype.skipType = function(wireType) {
    switch(wireType){
        case 0:
            this.skip();
            break;
        case 1:
            this.skip(8);
            break;
        case 2:
            this.skip(this.uint32());
            break;
        case 3:
            while((wireType = this.uint32() & 7) !== 4)this.skipType(wireType);
            break;
        case 5:
            this.skip(4);
            break;
        /* istanbul ignore next */ default:
            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
};
$7847ab809aa9b3f0$var$Reader._configure = function(BufferReader_) {
    $7847ab809aa9b3f0$var$BufferReader = BufferReader_;
    $7847ab809aa9b3f0$var$Reader.create = $7847ab809aa9b3f0$var$create();
    $7847ab809aa9b3f0$var$BufferReader._configure();
    var fn = $9920C.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
    $9920C.merge($7847ab809aa9b3f0$var$Reader.prototype, {
        int64: function read_int64() {
            return $7847ab809aa9b3f0$var$readLongVarint.call(this)[fn](false);
        },
        uint64: function read_uint64() {
            return $7847ab809aa9b3f0$var$readLongVarint.call(this)[fn](true);
        },
        sint64: function read_sint64() {
            return $7847ab809aa9b3f0$var$readLongVarint.call(this).zzDecode()[fn](false);
        },
        fixed64: function read_fixed64() {
            return $7847ab809aa9b3f0$var$readFixed64.call(this)[fn](true);
        },
        sfixed64: function read_sfixed64() {
            return $7847ab809aa9b3f0$var$readFixed64.call(this)[fn](false);
        }
    });
};

});

parcelRegister("2tdju", function(module, exports) {
"use strict";
module.exports = $1cc89dfb8f2d322e$var$BufferReader;

var $akfl2 = parcelRequire("akfl2");
($1cc89dfb8f2d322e$var$BufferReader.prototype = Object.create($akfl2.prototype)).constructor = $1cc89dfb8f2d322e$var$BufferReader;

var $9920C = parcelRequire("9920C");
/**
 * Constructs a new buffer reader instance.
 * @classdesc Wire format reader using node buffers.
 * @extends Reader
 * @constructor
 * @param {Buffer} buffer Buffer to read from
 */ function $1cc89dfb8f2d322e$var$BufferReader(buffer) {
    $akfl2.call(this, buffer);
/**
     * Read buffer.
     * @name BufferReader#buf
     * @type {Buffer}
     */ }
$1cc89dfb8f2d322e$var$BufferReader._configure = function() {
    /* istanbul ignore else */ if ($9920C.Buffer) $1cc89dfb8f2d322e$var$BufferReader.prototype._slice = $9920C.Buffer.prototype.slice;
};
/**
 * @override
 */ $1cc89dfb8f2d322e$var$BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32(); // modifies pos
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @name BufferReader#bytes
 * @function
 * @returns {Buffer} Value read
 */ $1cc89dfb8f2d322e$var$BufferReader._configure();

});

parcelRegister("jh3HG", function(module, exports) {
"use strict";
/**
 * Streaming RPC helpers.
 * @namespace
 */ var $e0827a4f001f202b$var$rpc = module.exports;

/**
 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
 * @typedef RPCImpl
 * @type {function}
 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
 * @param {Uint8Array} requestData Request data
 * @param {RPCImplCallback} callback Callback function
 * @returns {undefined}
 * @example
 * function rpcImpl(method, requestData, callback) {
 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
 *         throw Error("no such method");
 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
 *         callback(err, responseData);
 *     });
 * }
 */ /**
 * Node-style callback as used by {@link RPCImpl}.
 * @typedef RPCImplCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
 * @returns {undefined}
 */ $e0827a4f001f202b$var$rpc.Service = (parcelRequire("hDd3z"));

});
parcelRegister("hDd3z", function(module, exports) {
"use strict";
module.exports = $cd6034f738e1e612$var$Service;

var $9920C = parcelRequire("9920C");
// Extends EventEmitter
($cd6034f738e1e612$var$Service.prototype = Object.create($9920C.EventEmitter.prototype)).constructor = $cd6034f738e1e612$var$Service;
/**
 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
 *
 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
 * @typedef rpc.ServiceMethodCallback
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {TRes} [response] Response message
 * @returns {undefined}
 */ /**
 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
 * @typedef rpc.ServiceMethod
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
 */ /**
 * Constructs a new RPC service instance.
 * @classdesc An RPC service as returned by {@link Service#create}.
 * @exports rpc.Service
 * @extends util.EventEmitter
 * @constructor
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 */ function $cd6034f738e1e612$var$Service(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function") throw TypeError("rpcImpl must be a function");
    $9920C.EventEmitter.call(this);
    /**
     * RPC implementation. Becomes `null` once the service is ended.
     * @type {RPCImpl|null}
     */ this.rpcImpl = rpcImpl;
    /**
     * Whether requests are length-delimited.
     * @type {boolean}
     */ this.requestDelimited = Boolean(requestDelimited);
    /**
     * Whether responses are length-delimited.
     * @type {boolean}
     */ this.responseDelimited = Boolean(responseDelimited);
}
/**
 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
 * @param {Constructor<TReq>} requestCtor Request constructor
 * @param {Constructor<TRes>} responseCtor Response constructor
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
 * @returns {undefined}
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 */ $cd6034f738e1e612$var$Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request) throw TypeError("request must be specified");
    var self = this;
    if (!callback) return $9920C.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
    if (!self.rpcImpl) {
        setTimeout(function() {
            callback(Error("already ended"));
        }, 0);
        return undefined;
    }
    try {
        return self.rpcImpl(method, requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(), function rpcCallback(err, response) {
            if (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            if (response === null) {
                self.end(/* endedByRPC */ true);
                return undefined;
            }
            if (!(response instanceof responseCtor)) try {
                response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
            } catch (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            self.emit("data", response, method);
            return callback(null, response);
        });
    } catch (err) {
        self.emit("error", err, method);
        setTimeout(function() {
            callback(err);
        }, 0);
        return undefined;
    }
};
/**
 * Ends this service and emits the `end` event.
 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
 * @returns {rpc.Service} `this`
 */ $cd6034f738e1e612$var$Service.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
        if (!endedByRPC) this.rpcImpl(null, null, null);
        this.rpcImpl = null;
        this.emit("end").off();
    }
    return this;
};

});


parcelRegister("ikHzD", function(module, exports) {
"use strict";
module.exports = {}; /**
 * Named roots.
 * This is where pbjs stores generated structures (the option `-r, --root` specifies a name).
 * Can also be used manually to make roots available across modules.
 * @name roots
 * @type {Object.<string,Root>}
 * @example
 * // pbjs -r myroot -o compiled.js ...
 *
 * // in another module:
 * require("./compiled.js");
 *
 * // in any subsequent module:
 * var root = protobuf.roots["myroot"];
 */ 

});


parcelRegister("iM0tk", function(module, exports) {
"use strict";
module.exports = $daad136e95e4b2f2$var$encoder;

var $l9EYs = parcelRequire("l9EYs");

var $hyVJi = parcelRequire("hyVJi");

var $1C5z4 = parcelRequire("1C5z4");
/**
 * Generates a partial message type encoder.
 * @param {Codegen} gen Codegen instance
 * @param {Field} field Reflected field
 * @param {number} fieldIndex Field index
 * @param {string} ref Variable reference
 * @returns {Codegen} Codegen instance
 * @ignore
 */ function $daad136e95e4b2f2$var$genTypePartial(gen, field, fieldIndex, ref) {
    return field.resolvedType.group ? gen("types[%i].encode(%s,w.uint32(%i)).uint32(%i)", fieldIndex, ref, (field.id << 3 | 3) >>> 0, (field.id << 3 | 4) >>> 0) : gen("types[%i].encode(%s,w.uint32(%i).fork()).ldelim()", fieldIndex, ref, (field.id << 3 | 2) >>> 0);
}
/**
 * Generates an encoder specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ function $daad136e95e4b2f2$var$encoder(mtype) {
    /* eslint-disable no-unexpected-multiline, block-scoped-var, no-redeclare */ var gen = $1C5z4.codegen([
        "m",
        "w"
    ], mtype.name + "$encode")("if(!w)")("w=Writer.create()");
    var i, ref;
    // "when a message is serialized its known fields should be written sequentially by field number"
    var fields = /* initializes */ mtype.fieldsArray.slice().sort($1C5z4.compareFieldsById);
    for(var i = 0; i < fields.length; ++i){
        var field = fields[i].resolve(), index = mtype._fieldsArray.indexOf(field), type = field.resolvedType instanceof $l9EYs ? "int32" : field.type, wireType = $hyVJi.basic[type];
        ref = "m" + $1C5z4.safeProp(field.name);
        // Map fields
        if (field.map) {
            gen("if(%s!=null&&Object.hasOwnProperty.call(m,%j)){", ref, field.name) // !== undefined && !== null
            ("for(var ks=Object.keys(%s),i=0;i<ks.length;++i){", ref)("w.uint32(%i).fork().uint32(%i).%s(ks[i])", (field.id << 3 | 2) >>> 0, 8 | $hyVJi.mapKey[field.keyType], field.keyType);
            if (wireType === undefined) gen("types[%i].encode(%s[ks[i]],w.uint32(18).fork()).ldelim().ldelim()", index, ref); // can't be groups
            else gen(".uint32(%i).%s(%s[ks[i]]).ldelim()", 16 | wireType, type, ref);
            gen("}")("}");
        // Repeated fields
        } else if (field.repeated) {
            gen("if(%s!=null&&%s.length){", ref, ref); // !== undefined && !== null
            // Packed repeated
            if (field.packed && $hyVJi.packed[type] !== undefined) gen("w.uint32(%i).fork()", (field.id << 3 | 2) >>> 0)("for(var i=0;i<%s.length;++i)", ref)("w.%s(%s[i])", type, ref)("w.ldelim()");
            else {
                gen("for(var i=0;i<%s.length;++i)", ref);
                if (wireType === undefined) $daad136e95e4b2f2$var$genTypePartial(gen, field, index, ref + "[i]");
                else gen("w.uint32(%i).%s(%s[i])", (field.id << 3 | wireType) >>> 0, type, ref);
            }
            gen("}");
        // Non-repeated
        } else {
            if (field.optional) gen("if(%s!=null&&Object.hasOwnProperty.call(m,%j))", ref, field.name); // !== undefined && !== null
            if (wireType === undefined) $daad136e95e4b2f2$var$genTypePartial(gen, field, index, ref);
            else gen("w.uint32(%i).%s(%s)", (field.id << 3 | wireType) >>> 0, type, ref);
        }
    }
    return gen("return w");
/* eslint-enable no-unexpected-multiline, block-scoped-var, no-redeclare */ }

});
parcelRegister("l9EYs", function(module, exports) {
"use strict";
module.exports = $f66a38d694a52151$var$Enum;

var $jAZD5 = parcelRequire("jAZD5");
(($f66a38d694a52151$var$Enum.prototype = Object.create($jAZD5.prototype)).constructor = $f66a38d694a52151$var$Enum).className = "Enum";

var $1nsZk = parcelRequire("1nsZk");

var $1C5z4 = parcelRequire("1C5z4");
/**
 * Constructs a new enum instance.
 * @classdesc Reflected enum.
 * @extends ReflectionObject
 * @constructor
 * @param {string} name Unique name within its namespace
 * @param {Object.<string,number>} [values] Enum values as an object, by name
 * @param {Object.<string,*>} [options] Declared options
 * @param {string} [comment] The comment for this enum
 * @param {Object.<string,string>} [comments] The value comments for this enum
 * @param {Object.<string,Object<string,*>>|undefined} [valuesOptions] The value options for this enum
 */ function $f66a38d694a52151$var$Enum(name, values, options, comment, comments, valuesOptions) {
    $jAZD5.call(this, name, options);
    if (values && typeof values !== "object") throw TypeError("values must be an object");
    /**
     * Enum values by id.
     * @type {Object.<number,string>}
     */ this.valuesById = {};
    /**
     * Enum values by name.
     * @type {Object.<string,number>}
     */ this.values = Object.create(this.valuesById); // toJSON, marker
    /**
     * Enum comment text.
     * @type {string|null}
     */ this.comment = comment;
    /**
     * Value comment texts, if any.
     * @type {Object.<string,string>}
     */ this.comments = comments || {};
    /**
     * Values options, if any
     * @type {Object<string, Object<string, *>>|undefined}
     */ this.valuesOptions = valuesOptions;
    /**
     * Reserved ranges, if any.
     * @type {Array.<number[]|string>}
     */ this.reserved = undefined; // toJSON
    // Note that values inherit valuesById on their prototype which makes them a TypeScript-
    // compatible enum. This is used by pbts to write actual enum definitions that work for
    // static and reflection code alike instead of emitting generic object definitions.
    if (values) {
        for(var keys = Object.keys(values), i = 0; i < keys.length; ++i)if (typeof values[keys[i]] === "number") this.valuesById[this.values[keys[i]] = values[keys[i]]] = keys[i];
    }
}
/**
 * Enum descriptor.
 * @interface IEnum
 * @property {Object.<string,number>} values Enum values
 * @property {Object.<string,*>} [options] Enum options
 */ /**
 * Constructs an enum from an enum descriptor.
 * @param {string} name Enum name
 * @param {IEnum} json Enum descriptor
 * @returns {Enum} Created enum
 * @throws {TypeError} If arguments are invalid
 */ $f66a38d694a52151$var$Enum.fromJSON = function fromJSON(name, json) {
    var enm = new $f66a38d694a52151$var$Enum(name, json.values, json.options, json.comment, json.comments);
    enm.reserved = json.reserved;
    return enm;
};
/**
 * Converts this enum to an enum descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IEnum} Enum descriptor
 */ $f66a38d694a52151$var$Enum.prototype.toJSON = function toJSON(toJSONOptions) {
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $1C5z4.toObject([
        "options",
        this.options,
        "valuesOptions",
        this.valuesOptions,
        "values",
        this.values,
        "reserved",
        this.reserved && this.reserved.length ? this.reserved : undefined,
        "comment",
        keepComments ? this.comment : undefined,
        "comments",
        keepComments ? this.comments : undefined
    ]);
};
/**
 * Adds a value to this enum.
 * @param {string} name Value name
 * @param {number} id Value id
 * @param {string} [comment] Comment, if any
 * @param {Object.<string, *>|undefined} [options] Options, if any
 * @returns {Enum} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If there is already a value with this name or id
 */ $f66a38d694a52151$var$Enum.prototype.add = function add(name, id, comment, options) {
    // utilized by the parser but not by .fromJSON
    if (!$1C5z4.isString(name)) throw TypeError("name must be a string");
    if (!$1C5z4.isInteger(id)) throw TypeError("id must be an integer");
    if (this.values[name] !== undefined) throw Error("duplicate name '" + name + "' in " + this);
    if (this.isReservedId(id)) throw Error("id " + id + " is reserved in " + this);
    if (this.isReservedName(name)) throw Error("name '" + name + "' is reserved in " + this);
    if (this.valuesById[id] !== undefined) {
        if (!(this.options && this.options.allow_alias)) throw Error("duplicate id " + id + " in " + this);
        this.values[name] = id;
    } else this.valuesById[this.values[name] = id] = name;
    if (options) {
        if (this.valuesOptions === undefined) this.valuesOptions = {};
        this.valuesOptions[name] = options || null;
    }
    this.comments[name] = comment || null;
    return this;
};
/**
 * Removes a value from this enum
 * @param {string} name Value name
 * @returns {Enum} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If `name` is not a name of this enum
 */ $f66a38d694a52151$var$Enum.prototype.remove = function remove(name) {
    if (!$1C5z4.isString(name)) throw TypeError("name must be a string");
    var val = this.values[name];
    if (val == null) throw Error("name '" + name + "' does not exist in " + this);
    delete this.valuesById[val];
    delete this.values[name];
    delete this.comments[name];
    if (this.valuesOptions) delete this.valuesOptions[name];
    return this;
};
/**
 * Tests if the specified id is reserved.
 * @param {number} id Id to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $f66a38d694a52151$var$Enum.prototype.isReservedId = function isReservedId(id) {
    return $1nsZk.isReservedId(this.reserved, id);
};
/**
 * Tests if the specified name is reserved.
 * @param {string} name Name to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $f66a38d694a52151$var$Enum.prototype.isReservedName = function isReservedName(name) {
    return $1nsZk.isReservedName(this.reserved, name);
};

});
parcelRegister("jAZD5", function(module, exports) {
"use strict";
module.exports = $e4412f759d385834$var$ReflectionObject;
$e4412f759d385834$var$ReflectionObject.className = "ReflectionObject";

var $1C5z4 = parcelRequire("1C5z4");
var $e4412f759d385834$var$Root; // cyclic
/**
 * Constructs a new reflection object instance.
 * @classdesc Base class of all reflection objects.
 * @constructor
 * @param {string} name Object name
 * @param {Object.<string,*>} [options] Declared options
 * @abstract
 */ function $e4412f759d385834$var$ReflectionObject(name, options) {
    if (!$1C5z4.isString(name)) throw TypeError("name must be a string");
    if (options && !$1C5z4.isObject(options)) throw TypeError("options must be an object");
    /**
     * Options.
     * @type {Object.<string,*>|undefined}
     */ this.options = options; // toJSON
    /**
     * Parsed Options.
     * @type {Array.<Object.<string,*>>|undefined}
     */ this.parsedOptions = null;
    /**
     * Unique name within its namespace.
     * @type {string}
     */ this.name = name;
    /**
     * Parent namespace.
     * @type {Namespace|null}
     */ this.parent = null;
    /**
     * Whether already resolved or not.
     * @type {boolean}
     */ this.resolved = false;
    /**
     * Comment text, if any.
     * @type {string|null}
     */ this.comment = null;
    /**
     * Defining file name.
     * @type {string|null}
     */ this.filename = null;
}
Object.defineProperties($e4412f759d385834$var$ReflectionObject.prototype, {
    /**
     * Reference to the root namespace.
     * @name ReflectionObject#root
     * @type {Root}
     * @readonly
     */ root: {
        get: function() {
            var ptr = this;
            while(ptr.parent !== null)ptr = ptr.parent;
            return ptr;
        }
    },
    /**
     * Full name including leading dot.
     * @name ReflectionObject#fullName
     * @type {string}
     * @readonly
     */ fullName: {
        get: function() {
            var path = [
                this.name
            ], ptr = this.parent;
            while(ptr){
                path.unshift(ptr.name);
                ptr = ptr.parent;
            }
            return path.join(".");
        }
    }
});
/**
 * Converts this reflection object to its descriptor representation.
 * @returns {Object.<string,*>} Descriptor
 * @abstract
 */ $e4412f759d385834$var$ReflectionObject.prototype.toJSON = /* istanbul ignore next */ function toJSON() {
    throw Error(); // not implemented, shouldn't happen
};
/**
 * Called when this object is added to a parent.
 * @param {ReflectionObject} parent Parent added to
 * @returns {undefined}
 */ $e4412f759d385834$var$ReflectionObject.prototype.onAdd = function onAdd(parent) {
    if (this.parent && this.parent !== parent) this.parent.remove(this);
    this.parent = parent;
    this.resolved = false;
    var root = parent.root;
    if (root instanceof $e4412f759d385834$var$Root) root._handleAdd(this);
};
/**
 * Called when this object is removed from a parent.
 * @param {ReflectionObject} parent Parent removed from
 * @returns {undefined}
 */ $e4412f759d385834$var$ReflectionObject.prototype.onRemove = function onRemove(parent) {
    var root = parent.root;
    if (root instanceof $e4412f759d385834$var$Root) root._handleRemove(this);
    this.parent = null;
    this.resolved = false;
};
/**
 * Resolves this objects type references.
 * @returns {ReflectionObject} `this`
 */ $e4412f759d385834$var$ReflectionObject.prototype.resolve = function resolve() {
    if (this.resolved) return this;
    if (this.root instanceof $e4412f759d385834$var$Root) this.resolved = true; // only if part of a root
    return this;
};
/**
 * Gets an option value.
 * @param {string} name Option name
 * @returns {*} Option value or `undefined` if not set
 */ $e4412f759d385834$var$ReflectionObject.prototype.getOption = function getOption(name) {
    if (this.options) return this.options[name];
    return undefined;
};
/**
 * Sets an option.
 * @param {string} name Option name
 * @param {*} value Option value
 * @param {boolean} [ifNotSet] Sets the option only if it isn't currently set
 * @returns {ReflectionObject} `this`
 */ $e4412f759d385834$var$ReflectionObject.prototype.setOption = function setOption(name, value, ifNotSet) {
    if (!ifNotSet || !this.options || this.options[name] === undefined) (this.options || (this.options = {}))[name] = value;
    return this;
};
/**
 * Sets a parsed option.
 * @param {string} name parsed Option name
 * @param {*} value Option value
 * @param {string} propName dot '.' delimited full path of property within the option to set. if undefined\empty, will add a new option with that value
 * @returns {ReflectionObject} `this`
 */ $e4412f759d385834$var$ReflectionObject.prototype.setParsedOption = function setParsedOption(name, value, propName) {
    if (!this.parsedOptions) this.parsedOptions = [];
    var parsedOptions = this.parsedOptions;
    if (propName) {
        // If setting a sub property of an option then try to merge it
        // with an existing option
        var opt = parsedOptions.find(function(opt) {
            return Object.prototype.hasOwnProperty.call(opt, name);
        });
        if (opt) {
            // If we found an existing option - just merge the property value
            var newValue = opt[name];
            $1C5z4.setProperty(newValue, propName, value);
        } else {
            // otherwise, create a new option, set it's property and add it to the list
            opt = {};
            opt[name] = $1C5z4.setProperty({}, propName, value);
            parsedOptions.push(opt);
        }
    } else {
        // Always create a new option when setting the value of the option itself
        var newOpt = {};
        newOpt[name] = value;
        parsedOptions.push(newOpt);
    }
    return this;
};
/**
 * Sets multiple options.
 * @param {Object.<string,*>} options Options to set
 * @param {boolean} [ifNotSet] Sets an option only if it isn't currently set
 * @returns {ReflectionObject} `this`
 */ $e4412f759d385834$var$ReflectionObject.prototype.setOptions = function setOptions(options, ifNotSet) {
    if (options) for(var keys = Object.keys(options), i = 0; i < keys.length; ++i)this.setOption(keys[i], options[keys[i]], ifNotSet);
    return this;
};
/**
 * Converts this instance to its string representation.
 * @returns {string} Class name[, space, full name]
 */ $e4412f759d385834$var$ReflectionObject.prototype.toString = function toString() {
    var className = this.constructor.className, fullName = this.fullName;
    if (fullName.length) return className + " " + fullName;
    return className;
};
// Sets up cyclic dependencies (called in index-light)
$e4412f759d385834$var$ReflectionObject._configure = function(Root_) {
    $e4412f759d385834$var$Root = Root_;
};

});
parcelRegister("1C5z4", function(module, exports) {
"use strict";

/**
 * Various utility functions.
 * @namespace
 */ var $12cda80d8b46764f$var$util = module.exports = (parcelRequire("9920C"));

var $ikHzD = parcelRequire("ikHzD");
var $12cda80d8b46764f$var$Type, $12cda80d8b46764f$var$Enum;

$12cda80d8b46764f$var$util.codegen = (parcelRequire("8yAJp"));

$12cda80d8b46764f$var$util.fetch = (parcelRequire("dpV8U"));

$12cda80d8b46764f$var$util.path = (parcelRequire("fbvrb"));
/**
 * Node's fs module if available.
 * @type {Object.<string,*>}
 */ $12cda80d8b46764f$var$util.fs = $12cda80d8b46764f$var$util.inquire("fs");
/**
 * Converts an object's values to an array.
 * @param {Object.<string,*>} object Object to convert
 * @returns {Array.<*>} Converted array
 */ $12cda80d8b46764f$var$util.toArray = function toArray(object) {
    if (object) {
        var keys = Object.keys(object), array = new Array(keys.length), index = 0;
        while(index < keys.length)array[index] = object[keys[index++]];
        return array;
    }
    return [];
};
/**
 * Converts an array of keys immediately followed by their respective value to an object, omitting undefined values.
 * @param {Array.<*>} array Array to convert
 * @returns {Object.<string,*>} Converted object
 */ $12cda80d8b46764f$var$util.toObject = function toObject(array) {
    var object = {}, index = 0;
    while(index < array.length){
        var key = array[index++], val = array[index++];
        if (val !== undefined) object[key] = val;
    }
    return object;
};
var $12cda80d8b46764f$var$safePropBackslashRe = /\\/g, $12cda80d8b46764f$var$safePropQuoteRe = /"/g;
/**
 * Tests whether the specified name is a reserved word in JS.
 * @param {string} name Name to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $12cda80d8b46764f$var$util.isReserved = function isReserved(name) {
    return /^(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$/.test(name);
};
/**
 * Returns a safe property accessor for the specified property name.
 * @param {string} prop Property name
 * @returns {string} Safe accessor
 */ $12cda80d8b46764f$var$util.safeProp = function safeProp(prop) {
    if (!/^[$\w_]+$/.test(prop) || $12cda80d8b46764f$var$util.isReserved(prop)) return "[\"" + prop.replace($12cda80d8b46764f$var$safePropBackslashRe, "\\\\").replace($12cda80d8b46764f$var$safePropQuoteRe, "\\\"") + "\"]";
    return "." + prop;
};
/**
 * Converts the first character of a string to upper case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $12cda80d8b46764f$var$util.ucFirst = function ucFirst(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
};
var $12cda80d8b46764f$var$camelCaseRe = /_([a-z])/g;
/**
 * Converts a string to camel case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $12cda80d8b46764f$var$util.camelCase = function camelCase(str) {
    return str.substring(0, 1) + str.substring(1).replace($12cda80d8b46764f$var$camelCaseRe, function($0, $1) {
        return $1.toUpperCase();
    });
};
/**
 * Compares reflected fields by id.
 * @param {Field} a First field
 * @param {Field} b Second field
 * @returns {number} Comparison value
 */ $12cda80d8b46764f$var$util.compareFieldsById = function compareFieldsById(a, b) {
    return a.id - b.id;
};

/**
 * Decorator helper for types (TypeScript).
 * @param {Constructor<T>} ctor Constructor function
 * @param {string} [typeName] Type name, defaults to the constructor's name
 * @returns {Type} Reflected type
 * @template T extends Message<T>
 * @property {Root} root Decorators root
 */ $12cda80d8b46764f$var$util.decorateType = function decorateType(ctor, typeName) {
    /* istanbul ignore if */ if (ctor.$type) {
        if (typeName && ctor.$type.name !== typeName) {
            $12cda80d8b46764f$var$util.decorateRoot.remove(ctor.$type);
            ctor.$type.name = typeName;
            $12cda80d8b46764f$var$util.decorateRoot.add(ctor.$type);
        }
        return ctor.$type;
    }
    /* istanbul ignore next */ if (!$12cda80d8b46764f$var$Type) $12cda80d8b46764f$var$Type = (parcelRequire("8zc9K"));
    var type = new $12cda80d8b46764f$var$Type(typeName || ctor.name);
    $12cda80d8b46764f$var$util.decorateRoot.add(type);
    type.ctor = ctor; // sets up .encode, .decode etc.
    Object.defineProperty(ctor, "$type", {
        value: type,
        enumerable: false
    });
    Object.defineProperty(ctor.prototype, "$type", {
        value: type,
        enumerable: false
    });
    return type;
};
var $12cda80d8b46764f$var$decorateEnumIndex = 0;

/**
 * Decorator helper for enums (TypeScript).
 * @param {Object} object Enum object
 * @returns {Enum} Reflected enum
 */ $12cda80d8b46764f$var$util.decorateEnum = function decorateEnum(object) {
    /* istanbul ignore if */ if (object.$type) return object.$type;
    /* istanbul ignore next */ if (!$12cda80d8b46764f$var$Enum) $12cda80d8b46764f$var$Enum = (parcelRequire("l9EYs"));
    var enm = new $12cda80d8b46764f$var$Enum("Enum" + $12cda80d8b46764f$var$decorateEnumIndex++, object);
    $12cda80d8b46764f$var$util.decorateRoot.add(enm);
    Object.defineProperty(object, "$type", {
        value: enm,
        enumerable: false
    });
    return enm;
};
/**
 * Sets the value of a property by property path. If a value already exists, it is turned to an array
 * @param {Object.<string,*>} dst Destination object
 * @param {string} path dot '.' delimited path of the property to set
 * @param {Object} value the value to set
 * @returns {Object.<string,*>} Destination object
 */ $12cda80d8b46764f$var$util.setProperty = function setProperty(dst, path, value) {
    function setProp(dst, path, value) {
        var part = path.shift();
        if (part === "__proto__" || part === "prototype") return dst;
        if (path.length > 0) dst[part] = setProp(dst[part] || {}, path, value);
        else {
            var prevValue = dst[part];
            if (prevValue) value = [].concat(prevValue).concat(value);
            dst[part] = value;
        }
        return dst;
    }
    if (typeof dst !== "object") throw TypeError("dst must be an object");
    if (!path) throw TypeError("path must be specified");
    path = path.split(".");
    return setProp(dst, path, value);
};

/**
 * Decorator root (TypeScript).
 * @name util.decorateRoot
 * @type {Root}
 * @readonly
 */ Object.defineProperty($12cda80d8b46764f$var$util, "decorateRoot", {
    get: function() {
        return $ikHzD.decorated || ($ikHzD["decorated"] = new (parcelRequire("fTkGs"))());
    }
});

});
parcelRegister("8yAJp", function(module, exports) {
"use strict";
module.exports = $63adfdd290e43ba3$var$codegen;
/**
 * Begins generating a function.
 * @memberof util
 * @param {string[]} functionParams Function parameter names
 * @param {string} [functionName] Function name if not anonymous
 * @returns {Codegen} Appender that appends code to the function's body
 */ function $63adfdd290e43ba3$var$codegen(functionParams, functionName) {
    /* istanbul ignore if */ if (typeof functionParams === "string") {
        functionName = functionParams;
        functionParams = undefined;
    }
    var body = [];
    /**
     * Appends code to the function's body or finishes generation.
     * @typedef Codegen
     * @type {function}
     * @param {string|Object.<string,*>} [formatStringOrScope] Format string or, to finish the function, an object of additional scope variables, if any
     * @param {...*} [formatParams] Format parameters
     * @returns {Codegen|Function} Itself or the generated function if finished
     * @throws {Error} If format parameter counts do not match
     */ function Codegen(formatStringOrScope) {
        // note that explicit array handling below makes this ~50% faster
        // finish the function
        if (typeof formatStringOrScope !== "string") {
            var source = toString();
            if ($63adfdd290e43ba3$var$codegen.verbose) console.log("codegen: " + source); // eslint-disable-line no-console
            source = "return " + source;
            if (formatStringOrScope) {
                var scopeKeys = Object.keys(formatStringOrScope), scopeParams = new Array(scopeKeys.length + 1), scopeValues = new Array(scopeKeys.length), scopeOffset = 0;
                while(scopeOffset < scopeKeys.length){
                    scopeParams[scopeOffset] = scopeKeys[scopeOffset];
                    scopeValues[scopeOffset] = formatStringOrScope[scopeKeys[scopeOffset++]];
                }
                scopeParams[scopeOffset] = source;
                return Function.apply(null, scopeParams).apply(null, scopeValues); // eslint-disable-line no-new-func
            }
            return Function(source)(); // eslint-disable-line no-new-func
        }
        // otherwise append to body
        var formatParams = new Array(arguments.length - 1), formatOffset = 0;
        while(formatOffset < formatParams.length)formatParams[formatOffset] = arguments[++formatOffset];
        formatOffset = 0;
        formatStringOrScope = formatStringOrScope.replace(/%([%dfijs])/g, function replace($0, $1) {
            var value = formatParams[formatOffset++];
            switch($1){
                case "d":
                case "f":
                    return String(Number(value));
                case "i":
                    return String(Math.floor(value));
                case "j":
                    return JSON.stringify(value);
                case "s":
                    return String(value);
            }
            return "%";
        });
        if (formatOffset !== formatParams.length) throw Error("parameter count mismatch");
        body.push(formatStringOrScope);
        return Codegen;
    }
    function toString(functionNameOverride) {
        return "function " + (functionNameOverride || functionName || "") + "(" + (functionParams && functionParams.join(",") || "") + "){\n  " + body.join("\n  ") + "\n}";
    }
    Codegen.toString = toString;
    return Codegen;
}
/**
 * Begins generating a function.
 * @memberof util
 * @function codegen
 * @param {string} [functionName] Function name if not anonymous
 * @returns {Codegen} Appender that appends code to the function's body
 * @variation 2
 */ /**
 * When set to `true`, codegen will log generated code to console. Useful for debugging.
 * @name util.codegen.verbose
 * @type {boolean}
 */ $63adfdd290e43ba3$var$codegen.verbose = false;

});

parcelRegister("dpV8U", function(module, exports) {
"use strict";
module.exports = $9c49ef7f86334db5$var$fetch;

var $jtjMu = parcelRequire("jtjMu");

var $P7eYm = parcelRequire("P7eYm");
var $9c49ef7f86334db5$var$fs = $P7eYm("fs");
/**
 * Node-style callback as used by {@link util.fetch}.
 * @typedef FetchCallback
 * @type {function}
 * @param {?Error} error Error, if any, otherwise `null`
 * @param {string} [contents] File contents, if there hasn't been an error
 * @returns {undefined}
 */ /**
 * Options as used by {@link util.fetch}.
 * @typedef FetchOptions
 * @type {Object}
 * @property {boolean} [binary=false] Whether expecting a binary response
 * @property {boolean} [xhr=false] If `true`, forces the use of XMLHttpRequest
 */ /**
 * Fetches the contents of a file.
 * @memberof util
 * @param {string} filename File path or url
 * @param {FetchOptions} options Fetch options
 * @param {FetchCallback} callback Callback function
 * @returns {undefined}
 */ function $9c49ef7f86334db5$var$fetch(filename, options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = {};
    } else if (!options) options = {};
    if (!callback) return $jtjMu($9c49ef7f86334db5$var$fetch, this, filename, options); // eslint-disable-line no-invalid-this
    // if a node-like filesystem is present, try it first but fall back to XHR if nothing is found.
    if (!options.xhr && $9c49ef7f86334db5$var$fs && $9c49ef7f86334db5$var$fs.readFile) return $9c49ef7f86334db5$var$fs.readFile(filename, function fetchReadFileCallback(err, contents) {
        return err && typeof XMLHttpRequest !== "undefined" ? $9c49ef7f86334db5$var$fetch.xhr(filename, options, callback) : err ? callback(err) : callback(null, options.binary ? contents : contents.toString("utf8"));
    });
    // use the XHR version otherwise.
    return $9c49ef7f86334db5$var$fetch.xhr(filename, options, callback);
}
/**
 * Fetches the contents of a file.
 * @name util.fetch
 * @function
 * @param {string} path File path or url
 * @param {FetchCallback} callback Callback function
 * @returns {undefined}
 * @variation 2
 */ /**
 * Fetches the contents of a file.
 * @name util.fetch
 * @function
 * @param {string} path File path or url
 * @param {FetchOptions} [options] Fetch options
 * @returns {Promise<string|Uint8Array>} Promise
 * @variation 3
 */ /**/ $9c49ef7f86334db5$var$fetch.xhr = function fetch_xhr(filename, options, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function fetchOnReadyStateChange() {
        if (xhr.readyState !== 4) return undefined;
        // local cors security errors return status 0 / empty string, too. afaik this cannot be
        // reliably distinguished from an actually empty file for security reasons. feel free
        // to send a pull request if you are aware of a solution.
        if (xhr.status !== 0 && xhr.status !== 200) return callback(Error("status " + xhr.status));
        // if binary data is expected, make sure that some sort of array is returned, even if
        // ArrayBuffers are not supported. the binary string fallback, however, is unsafe.
        if (options.binary) {
            var buffer = xhr.response;
            if (!buffer) {
                buffer = [];
                for(var i = 0; i < xhr.responseText.length; ++i)buffer.push(xhr.responseText.charCodeAt(i) & 255);
            }
            return callback(null, typeof Uint8Array !== "undefined" ? new Uint8Array(buffer) : buffer);
        }
        return callback(null, xhr.responseText);
    };
    if (options.binary) {
        // ref: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/Sending_and_Receiving_Binary_Data#Receiving_binary_data_in_older_browsers
        if ("overrideMimeType" in xhr) xhr.overrideMimeType("text/plain; charset=x-user-defined");
        xhr.responseType = "arraybuffer";
    }
    xhr.open("GET", filename);
    xhr.send();
};

});

parcelRegister("fbvrb", function(module, exports) {
"use strict";
/**
 * A minimal path module to resolve Unix, Windows and URL paths alike.
 * @memberof util
 * @namespace
 */ var $b0e044e486f2aa78$var$path = module.exports;
var $b0e044e486f2aa78$var$isAbsolute = /**
 * Tests if the specified path is absolute.
 * @param {string} path Path to test
 * @returns {boolean} `true` if path is absolute
 */ $b0e044e486f2aa78$var$path.isAbsolute = function isAbsolute(path) {
    return /^(?:\/|\w+:)/.test(path);
};
var $b0e044e486f2aa78$var$normalize = /**
 * Normalizes the specified path.
 * @param {string} path Path to normalize
 * @returns {string} Normalized path
 */ $b0e044e486f2aa78$var$path.normalize = function normalize(path) {
    path = path.replace(/\\/g, "/").replace(/\/{2,}/g, "/");
    var parts = path.split("/"), absolute = $b0e044e486f2aa78$var$isAbsolute(path), prefix = "";
    if (absolute) prefix = parts.shift() + "/";
    for(var i = 0; i < parts.length;){
        if (parts[i] === "..") {
            if (i > 0 && parts[i - 1] !== "..") parts.splice(--i, 2);
            else if (absolute) parts.splice(i, 1);
            else ++i;
        } else if (parts[i] === ".") parts.splice(i, 1);
        else ++i;
    }
    return prefix + parts.join("/");
};
/**
 * Resolves the specified include path against the specified origin path.
 * @param {string} originPath Path to the origin file
 * @param {string} includePath Include path relative to origin path
 * @param {boolean} [alreadyNormalized=false] `true` if both paths are already known to be normalized
 * @returns {string} Path to the include file
 */ $b0e044e486f2aa78$var$path.resolve = function resolve(originPath, includePath, alreadyNormalized) {
    if (!alreadyNormalized) includePath = $b0e044e486f2aa78$var$normalize(includePath);
    if ($b0e044e486f2aa78$var$isAbsolute(includePath)) return includePath;
    if (!alreadyNormalized) originPath = $b0e044e486f2aa78$var$normalize(originPath);
    return (originPath = originPath.replace(/(?:\/|^)[^/]+$/, "")).length ? $b0e044e486f2aa78$var$normalize(originPath + "/" + includePath) : includePath;
};

});

parcelRegister("8zc9K", function(module, exports) {
"use strict";
module.exports = $63cb05970b1d2ecd$var$Type;

var $1nsZk = parcelRequire("1nsZk");
(($63cb05970b1d2ecd$var$Type.prototype = Object.create($1nsZk.prototype)).constructor = $63cb05970b1d2ecd$var$Type).className = "Type";

var $l9EYs = parcelRequire("l9EYs");

var $iMxDc = parcelRequire("iMxDc");

var $IbYAq = parcelRequire("IbYAq");

var $hI2Xk = parcelRequire("hI2Xk");

var $5Iewc = parcelRequire("5Iewc");

var $9npbz = parcelRequire("9npbz");

var $akfl2 = parcelRequire("akfl2");

var $i4Gf0 = parcelRequire("i4Gf0");

var $1C5z4 = parcelRequire("1C5z4");

var $iM0tk = parcelRequire("iM0tk");

var $03zCF = parcelRequire("03zCF");

var $8KWb1 = parcelRequire("8KWb1");

var $elQct = parcelRequire("elQct");

var $d5RQG = parcelRequire("d5RQG");
/**
 * Constructs a new reflected message type instance.
 * @classdesc Reflected message type.
 * @extends NamespaceBase
 * @constructor
 * @param {string} name Message name
 * @param {Object.<string,*>} [options] Declared options
 */ function $63cb05970b1d2ecd$var$Type(name, options) {
    $1nsZk.call(this, name, options);
    /**
     * Message fields.
     * @type {Object.<string,Field>}
     */ this.fields = {}; // toJSON, marker
    /**
     * Oneofs declared within this namespace, if any.
     * @type {Object.<string,OneOf>}
     */ this.oneofs = undefined; // toJSON
    /**
     * Extension ranges, if any.
     * @type {number[][]}
     */ this.extensions = undefined; // toJSON
    /**
     * Reserved ranges, if any.
     * @type {Array.<number[]|string>}
     */ this.reserved = undefined; // toJSON
    /*?
     * Whether this type is a legacy group.
     * @type {boolean|undefined}
     */ this.group = undefined; // toJSON
    /**
     * Cached fields by id.
     * @type {Object.<number,Field>|null}
     * @private
     */ this._fieldsById = null;
    /**
     * Cached fields as an array.
     * @type {Field[]|null}
     * @private
     */ this._fieldsArray = null;
    /**
     * Cached oneofs as an array.
     * @type {OneOf[]|null}
     * @private
     */ this._oneofsArray = null;
    /**
     * Cached constructor.
     * @type {Constructor<{}>}
     * @private
     */ this._ctor = null;
}
Object.defineProperties($63cb05970b1d2ecd$var$Type.prototype, {
    /**
     * Message fields by id.
     * @name Type#fieldsById
     * @type {Object.<number,Field>}
     * @readonly
     */ fieldsById: {
        get: function() {
            /* istanbul ignore if */ if (this._fieldsById) return this._fieldsById;
            this._fieldsById = {};
            for(var names = Object.keys(this.fields), i = 0; i < names.length; ++i){
                var field = this.fields[names[i]], id = field.id;
                /* istanbul ignore if */ if (this._fieldsById[id]) throw Error("duplicate id " + id + " in " + this);
                this._fieldsById[id] = field;
            }
            return this._fieldsById;
        }
    },
    /**
     * Fields of this message as an array for iteration.
     * @name Type#fieldsArray
     * @type {Field[]}
     * @readonly
     */ fieldsArray: {
        get: function() {
            return this._fieldsArray || (this._fieldsArray = $1C5z4.toArray(this.fields));
        }
    },
    /**
     * Oneofs of this message as an array for iteration.
     * @name Type#oneofsArray
     * @type {OneOf[]}
     * @readonly
     */ oneofsArray: {
        get: function() {
            return this._oneofsArray || (this._oneofsArray = $1C5z4.toArray(this.oneofs));
        }
    },
    /**
     * The registered constructor, if any registered, otherwise a generic constructor.
     * Assigning a function replaces the internal constructor. If the function does not extend {@link Message} yet, its prototype will be setup accordingly and static methods will be populated. If it already extends {@link Message}, it will just replace the internal constructor.
     * @name Type#ctor
     * @type {Constructor<{}>}
     */ ctor: {
        get: function() {
            return this._ctor || (this.ctor = $63cb05970b1d2ecd$var$Type.generateConstructor(this)());
        },
        set: function(ctor) {
            // Ensure proper prototype
            var prototype = ctor.prototype;
            if (!(prototype instanceof $9npbz)) {
                (ctor.prototype = new $9npbz()).constructor = ctor;
                $1C5z4.merge(ctor.prototype, prototype);
            }
            // Classes and messages reference their reflected type
            ctor.$type = ctor.prototype.$type = this;
            // Mix in static methods
            $1C5z4.merge(ctor, $9npbz, true);
            this._ctor = ctor;
            // Messages have non-enumerable default values on their prototype
            var i = 0;
            for(; i < /* initializes */ this.fieldsArray.length; ++i)this._fieldsArray[i].resolve(); // ensures a proper value
            // Messages have non-enumerable getters and setters for each virtual oneof field
            var ctorProperties = {};
            for(i = 0; i < /* initializes */ this.oneofsArray.length; ++i)ctorProperties[this._oneofsArray[i].resolve().name] = {
                get: $1C5z4.oneOfGetter(this._oneofsArray[i].oneof),
                set: $1C5z4.oneOfSetter(this._oneofsArray[i].oneof)
            };
            if (i) Object.defineProperties(ctor.prototype, ctorProperties);
        }
    }
});
/**
 * Generates a constructor function for the specified type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ $63cb05970b1d2ecd$var$Type.generateConstructor = function generateConstructor(mtype) {
    /* eslint-disable no-unexpected-multiline */ var gen = $1C5z4.codegen([
        "p"
    ], mtype.name);
    // explicitly initialize mutable object/array fields so that these aren't just inherited from the prototype
    for(var i = 0, field; i < mtype.fieldsArray.length; ++i)if ((field = mtype._fieldsArray[i]).map) gen("this%s={}", $1C5z4.safeProp(field.name));
    else if (field.repeated) gen("this%s=[]", $1C5z4.safeProp(field.name));
    return gen("if(p)for(var ks=Object.keys(p),i=0;i<ks.length;++i)if(p[ks[i]]!=null)") // omit undefined or null
    ("this[ks[i]]=p[ks[i]]");
/* eslint-enable no-unexpected-multiline */ };
function $63cb05970b1d2ecd$var$clearCache(type) {
    type._fieldsById = type._fieldsArray = type._oneofsArray = null;
    delete type.encode;
    delete type.decode;
    delete type.verify;
    return type;
}
/**
 * Message type descriptor.
 * @interface IType
 * @extends INamespace
 * @property {Object.<string,IOneOf>} [oneofs] Oneof descriptors
 * @property {Object.<string,IField>} fields Field descriptors
 * @property {number[][]} [extensions] Extension ranges
 * @property {Array.<number[]|string>} [reserved] Reserved ranges
 * @property {boolean} [group=false] Whether a legacy group or not
 */ /**
 * Creates a message type from a message type descriptor.
 * @param {string} name Message name
 * @param {IType} json Message type descriptor
 * @returns {Type} Created message type
 */ $63cb05970b1d2ecd$var$Type.fromJSON = function fromJSON(name, json) {
    var type = new $63cb05970b1d2ecd$var$Type(name, json.options);
    type.extensions = json.extensions;
    type.reserved = json.reserved;
    var names = Object.keys(json.fields), i = 0;
    for(; i < names.length; ++i)type.add((typeof json.fields[names[i]].keyType !== "undefined" ? $hI2Xk.fromJSON : $IbYAq.fromJSON)(names[i], json.fields[names[i]]));
    if (json.oneofs) for(names = Object.keys(json.oneofs), i = 0; i < names.length; ++i)type.add($iMxDc.fromJSON(names[i], json.oneofs[names[i]]));
    if (json.nested) for(names = Object.keys(json.nested), i = 0; i < names.length; ++i){
        var nested = json.nested[names[i]];
        type.add((nested.id !== undefined ? $IbYAq.fromJSON : nested.fields !== undefined ? $63cb05970b1d2ecd$var$Type.fromJSON : nested.values !== undefined ? $l9EYs.fromJSON : nested.methods !== undefined ? $5Iewc.fromJSON : $1nsZk.fromJSON)(names[i], nested));
    }
    if (json.extensions && json.extensions.length) type.extensions = json.extensions;
    if (json.reserved && json.reserved.length) type.reserved = json.reserved;
    if (json.group) type.group = true;
    if (json.comment) type.comment = json.comment;
    return type;
};
/**
 * Converts this message type to a message type descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IType} Message type descriptor
 */ $63cb05970b1d2ecd$var$Type.prototype.toJSON = function toJSON(toJSONOptions) {
    var inherited = $1nsZk.prototype.toJSON.call(this, toJSONOptions);
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $1C5z4.toObject([
        "options",
        inherited && inherited.options || undefined,
        "oneofs",
        $1nsZk.arrayToJSON(this.oneofsArray, toJSONOptions),
        "fields",
        $1nsZk.arrayToJSON(this.fieldsArray.filter(function(obj) {
            return !obj.declaringField;
        }), toJSONOptions) || {},
        "extensions",
        this.extensions && this.extensions.length ? this.extensions : undefined,
        "reserved",
        this.reserved && this.reserved.length ? this.reserved : undefined,
        "group",
        this.group || undefined,
        "nested",
        inherited && inherited.nested || undefined,
        "comment",
        keepComments ? this.comment : undefined
    ]);
};
/**
 * @override
 */ $63cb05970b1d2ecd$var$Type.prototype.resolveAll = function resolveAll() {
    var fields = this.fieldsArray, i = 0;
    while(i < fields.length)fields[i++].resolve();
    var oneofs = this.oneofsArray;
    i = 0;
    while(i < oneofs.length)oneofs[i++].resolve();
    return $1nsZk.prototype.resolveAll.call(this);
};
/**
 * @override
 */ $63cb05970b1d2ecd$var$Type.prototype.get = function get(name) {
    return this.fields[name] || this.oneofs && this.oneofs[name] || this.nested && this.nested[name] || null;
};
/**
 * Adds a nested object to this type.
 * @param {ReflectionObject} object Nested object to add
 * @returns {Type} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If there is already a nested object with this name or, if a field, when there is already a field with this id
 */ $63cb05970b1d2ecd$var$Type.prototype.add = function add(object) {
    if (this.get(object.name)) throw Error("duplicate name '" + object.name + "' in " + this);
    if (object instanceof $IbYAq && object.extend === undefined) {
        // NOTE: Extension fields aren't actual fields on the declaring type, but nested objects.
        // The root object takes care of adding distinct sister-fields to the respective extended
        // type instead.
        // avoids calling the getter if not absolutely necessary because it's called quite frequently
        if (this._fieldsById ? /* istanbul ignore next */ this._fieldsById[object.id] : this.fieldsById[object.id]) throw Error("duplicate id " + object.id + " in " + this);
        if (this.isReservedId(object.id)) throw Error("id " + object.id + " is reserved in " + this);
        if (this.isReservedName(object.name)) throw Error("name '" + object.name + "' is reserved in " + this);
        if (object.parent) object.parent.remove(object);
        this.fields[object.name] = object;
        object.message = this;
        object.onAdd(this);
        return $63cb05970b1d2ecd$var$clearCache(this);
    }
    if (object instanceof $iMxDc) {
        if (!this.oneofs) this.oneofs = {};
        this.oneofs[object.name] = object;
        object.onAdd(this);
        return $63cb05970b1d2ecd$var$clearCache(this);
    }
    return $1nsZk.prototype.add.call(this, object);
};
/**
 * Removes a nested object from this type.
 * @param {ReflectionObject} object Nested object to remove
 * @returns {Type} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If `object` is not a member of this type
 */ $63cb05970b1d2ecd$var$Type.prototype.remove = function remove(object) {
    if (object instanceof $IbYAq && object.extend === undefined) {
        // See Type#add for the reason why extension fields are excluded here.
        /* istanbul ignore if */ if (!this.fields || this.fields[object.name] !== object) throw Error(object + " is not a member of " + this);
        delete this.fields[object.name];
        object.parent = null;
        object.onRemove(this);
        return $63cb05970b1d2ecd$var$clearCache(this);
    }
    if (object instanceof $iMxDc) {
        /* istanbul ignore if */ if (!this.oneofs || this.oneofs[object.name] !== object) throw Error(object + " is not a member of " + this);
        delete this.oneofs[object.name];
        object.parent = null;
        object.onRemove(this);
        return $63cb05970b1d2ecd$var$clearCache(this);
    }
    return $1nsZk.prototype.remove.call(this, object);
};
/**
 * Tests if the specified id is reserved.
 * @param {number} id Id to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $63cb05970b1d2ecd$var$Type.prototype.isReservedId = function isReservedId(id) {
    return $1nsZk.isReservedId(this.reserved, id);
};
/**
 * Tests if the specified name is reserved.
 * @param {string} name Name to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $63cb05970b1d2ecd$var$Type.prototype.isReservedName = function isReservedName(name) {
    return $1nsZk.isReservedName(this.reserved, name);
};
/**
 * Creates a new message of this type using the specified properties.
 * @param {Object.<string,*>} [properties] Properties to set
 * @returns {Message<{}>} Message instance
 */ $63cb05970b1d2ecd$var$Type.prototype.create = function create(properties) {
    return new this.ctor(properties);
};
/**
 * Sets up {@link Type#encode|encode}, {@link Type#decode|decode} and {@link Type#verify|verify}.
 * @returns {Type} `this`
 */ $63cb05970b1d2ecd$var$Type.prototype.setup = function setup() {
    // Sets up everything at once so that the prototype chain does not have to be re-evaluated
    // multiple times (V8, soft-deopt prototype-check).
    var fullName = this.fullName, types = [];
    for(var i = 0; i < /* initializes */ this.fieldsArray.length; ++i)types.push(this._fieldsArray[i].resolve().resolvedType);
    // Replace setup methods with type-specific generated functions
    this.encode = $iM0tk(this)({
        Writer: $i4Gf0,
        types: types,
        util: $1C5z4
    });
    this.decode = $03zCF(this)({
        Reader: $akfl2,
        types: types,
        util: $1C5z4
    });
    this.verify = $8KWb1(this)({
        types: types,
        util: $1C5z4
    });
    this.fromObject = $elQct.fromObject(this)({
        types: types,
        util: $1C5z4
    });
    this.toObject = $elQct.toObject(this)({
        types: types,
        util: $1C5z4
    });
    // Inject custom wrappers for common types
    var wrapper = $d5RQG[fullName];
    if (wrapper) {
        var originalThis = Object.create(this);
        // if (wrapper.fromObject) {
        originalThis.fromObject = this.fromObject;
        this.fromObject = wrapper.fromObject.bind(originalThis);
        // }
        // if (wrapper.toObject) {
        originalThis.toObject = this.toObject;
        this.toObject = wrapper.toObject.bind(originalThis);
    // }
    }
    return this;
};
/**
 * Encodes a message of this type. Does not implicitly {@link Type#verify|verify} messages.
 * @param {Message<{}>|Object.<string,*>} message Message instance or plain object
 * @param {Writer} [writer] Writer to encode to
 * @returns {Writer} writer
 */ $63cb05970b1d2ecd$var$Type.prototype.encode = function encode_setup(message, writer) {
    return this.setup().encode(message, writer); // overrides this method
};
/**
 * Encodes a message of this type preceeded by its byte length as a varint. Does not implicitly {@link Type#verify|verify} messages.
 * @param {Message<{}>|Object.<string,*>} message Message instance or plain object
 * @param {Writer} [writer] Writer to encode to
 * @returns {Writer} writer
 */ $63cb05970b1d2ecd$var$Type.prototype.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
};
/**
 * Decodes a message of this type.
 * @param {Reader|Uint8Array} reader Reader or buffer to decode from
 * @param {number} [length] Length of the message, if known beforehand
 * @returns {Message<{}>} Decoded message
 * @throws {Error} If the payload is not a reader or valid buffer
 * @throws {util.ProtocolError<{}>} If required fields are missing
 */ $63cb05970b1d2ecd$var$Type.prototype.decode = function decode_setup(reader, length) {
    return this.setup().decode(reader, length); // overrides this method
};
/**
 * Decodes a message of this type preceeded by its byte length as a varint.
 * @param {Reader|Uint8Array} reader Reader or buffer to decode from
 * @returns {Message<{}>} Decoded message
 * @throws {Error} If the payload is not a reader or valid buffer
 * @throws {util.ProtocolError} If required fields are missing
 */ $63cb05970b1d2ecd$var$Type.prototype.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $akfl2)) reader = $akfl2.create(reader);
    return this.decode(reader, reader.uint32());
};
/**
 * Verifies that field values are valid and that required fields are present.
 * @param {Object.<string,*>} message Plain object to verify
 * @returns {null|string} `null` if valid, otherwise the reason why it is not
 */ $63cb05970b1d2ecd$var$Type.prototype.verify = function verify_setup(message) {
    return this.setup().verify(message); // overrides this method
};
/**
 * Creates a new message of this type from a plain object. Also converts values to their respective internal types.
 * @param {Object.<string,*>} object Plain object to convert
 * @returns {Message<{}>} Message instance
 */ $63cb05970b1d2ecd$var$Type.prototype.fromObject = function fromObject(object) {
    return this.setup().fromObject(object);
};
/**
 * Conversion options as used by {@link Type#toObject} and {@link Message.toObject}.
 * @interface IConversionOptions
 * @property {Function} [longs] Long conversion type.
 * Valid values are `String` and `Number` (the global types).
 * Defaults to copy the present value, which is a possibly unsafe number without and a {@link Long} with a long library.
 * @property {Function} [enums] Enum value conversion type.
 * Only valid value is `String` (the global type).
 * Defaults to copy the present value, which is the numeric id.
 * @property {Function} [bytes] Bytes value conversion type.
 * Valid values are `Array` and (a base64 encoded) `String` (the global types).
 * Defaults to copy the present value, which usually is a Buffer under node and an Uint8Array in the browser.
 * @property {boolean} [defaults=false] Also sets default values on the resulting object
 * @property {boolean} [arrays=false] Sets empty arrays for missing repeated fields even if `defaults=false`
 * @property {boolean} [objects=false] Sets empty objects for missing map fields even if `defaults=false`
 * @property {boolean} [oneofs=false] Includes virtual oneof properties set to the present field's name, if any
 * @property {boolean} [json=false] Performs additional JSON compatibility conversions, i.e. NaN and Infinity to strings
 */ /**
 * Creates a plain object from a message of this type. Also converts values to other types if specified.
 * @param {Message<{}>} message Message instance
 * @param {IConversionOptions} [options] Conversion options
 * @returns {Object.<string,*>} Plain object
 */ $63cb05970b1d2ecd$var$Type.prototype.toObject = function toObject(message, options) {
    return this.setup().toObject(message, options);
};
/**
 * Decorator function as returned by {@link Type.d} (TypeScript).
 * @typedef TypeDecorator
 * @type {function}
 * @param {Constructor<T>} target Target constructor
 * @returns {undefined}
 * @template T extends Message<T>
 */ /**
 * Type decorator (TypeScript).
 * @param {string} [typeName] Type name, defaults to the constructor's name
 * @returns {TypeDecorator<T>} Decorator function
 * @template T extends Message<T>
 */ $63cb05970b1d2ecd$var$Type.d = function decorateType(typeName) {
    return function typeDecorator(target) {
        $1C5z4.decorateType(target, typeName);
    };
};

});
parcelRegister("1nsZk", function(module, exports) {
"use strict";
module.exports = $100e6ce17ae29a1a$var$Namespace;

var $jAZD5 = parcelRequire("jAZD5");
(($100e6ce17ae29a1a$var$Namespace.prototype = Object.create($jAZD5.prototype)).constructor = $100e6ce17ae29a1a$var$Namespace).className = "Namespace";

var $IbYAq = parcelRequire("IbYAq");

var $1C5z4 = parcelRequire("1C5z4");

var $iMxDc = parcelRequire("iMxDc");
var $100e6ce17ae29a1a$var$Type, $100e6ce17ae29a1a$var$Service, $100e6ce17ae29a1a$var$Enum;
/**
 * Constructs a new namespace instance.
 * @name Namespace
 * @classdesc Reflected namespace.
 * @extends NamespaceBase
 * @constructor
 * @param {string} name Namespace name
 * @param {Object.<string,*>} [options] Declared options
 */ /**
 * Constructs a namespace from JSON.
 * @memberof Namespace
 * @function
 * @param {string} name Namespace name
 * @param {Object.<string,*>} json JSON object
 * @returns {Namespace} Created namespace
 * @throws {TypeError} If arguments are invalid
 */ $100e6ce17ae29a1a$var$Namespace.fromJSON = function fromJSON(name, json) {
    return new $100e6ce17ae29a1a$var$Namespace(name, json.options).addJSON(json.nested);
};
/**
 * Converts an array of reflection objects to JSON.
 * @memberof Namespace
 * @param {ReflectionObject[]} array Object array
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {Object.<string,*>|undefined} JSON object or `undefined` when array is empty
 */ function $100e6ce17ae29a1a$var$arrayToJSON(array, toJSONOptions) {
    if (!(array && array.length)) return undefined;
    var obj = {};
    for(var i = 0; i < array.length; ++i)obj[array[i].name] = array[i].toJSON(toJSONOptions);
    return obj;
}
$100e6ce17ae29a1a$var$Namespace.arrayToJSON = $100e6ce17ae29a1a$var$arrayToJSON;
/**
 * Tests if the specified id is reserved.
 * @param {Array.<number[]|string>|undefined} reserved Array of reserved ranges and names
 * @param {number} id Id to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $100e6ce17ae29a1a$var$Namespace.isReservedId = function isReservedId(reserved, id) {
    if (reserved) {
        for(var i = 0; i < reserved.length; ++i)if (typeof reserved[i] !== "string" && reserved[i][0] <= id && reserved[i][1] > id) return true;
    }
    return false;
};
/**
 * Tests if the specified name is reserved.
 * @param {Array.<number[]|string>|undefined} reserved Array of reserved ranges and names
 * @param {string} name Name to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $100e6ce17ae29a1a$var$Namespace.isReservedName = function isReservedName(reserved, name) {
    if (reserved) {
        for(var i = 0; i < reserved.length; ++i)if (reserved[i] === name) return true;
    }
    return false;
};
/**
 * Not an actual constructor. Use {@link Namespace} instead.
 * @classdesc Base class of all reflection objects containing nested objects. This is not an actual class but here for the sake of having consistent type definitions.
 * @exports NamespaceBase
 * @extends ReflectionObject
 * @abstract
 * @constructor
 * @param {string} name Namespace name
 * @param {Object.<string,*>} [options] Declared options
 * @see {@link Namespace}
 */ function $100e6ce17ae29a1a$var$Namespace(name, options) {
    $jAZD5.call(this, name, options);
    /**
     * Nested objects by name.
     * @type {Object.<string,ReflectionObject>|undefined}
     */ this.nested = undefined; // toJSON
    /**
     * Cached nested objects as an array.
     * @type {ReflectionObject[]|null}
     * @private
     */ this._nestedArray = null;
}
function $100e6ce17ae29a1a$var$clearCache(namespace) {
    namespace._nestedArray = null;
    return namespace;
}
/**
 * Nested objects of this namespace as an array for iteration.
 * @name NamespaceBase#nestedArray
 * @type {ReflectionObject[]}
 * @readonly
 */ Object.defineProperty($100e6ce17ae29a1a$var$Namespace.prototype, "nestedArray", {
    get: function() {
        return this._nestedArray || (this._nestedArray = $1C5z4.toArray(this.nested));
    }
});
/**
 * Namespace descriptor.
 * @interface INamespace
 * @property {Object.<string,*>} [options] Namespace options
 * @property {Object.<string,AnyNestedObject>} [nested] Nested object descriptors
 */ /**
 * Any extension field descriptor.
 * @typedef AnyExtensionField
 * @type {IExtensionField|IExtensionMapField}
 */ /**
 * Any nested object descriptor.
 * @typedef AnyNestedObject
 * @type {IEnum|IType|IService|AnyExtensionField|INamespace|IOneOf}
 */ /**
 * Converts this namespace to a namespace descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {INamespace} Namespace descriptor
 */ $100e6ce17ae29a1a$var$Namespace.prototype.toJSON = function toJSON(toJSONOptions) {
    return $1C5z4.toObject([
        "options",
        this.options,
        "nested",
        $100e6ce17ae29a1a$var$arrayToJSON(this.nestedArray, toJSONOptions)
    ]);
};
/**
 * Adds nested objects to this namespace from nested object descriptors.
 * @param {Object.<string,AnyNestedObject>} nestedJson Any nested object descriptors
 * @returns {Namespace} `this`
 */ $100e6ce17ae29a1a$var$Namespace.prototype.addJSON = function addJSON(nestedJson) {
    var ns = this;
    /* istanbul ignore else */ if (nestedJson) for(var names = Object.keys(nestedJson), i = 0, nested; i < names.length; ++i){
        nested = nestedJson[names[i]];
        ns.add((nested.fields !== undefined ? $100e6ce17ae29a1a$var$Type.fromJSON : nested.values !== undefined ? $100e6ce17ae29a1a$var$Enum.fromJSON : nested.methods !== undefined ? $100e6ce17ae29a1a$var$Service.fromJSON : nested.id !== undefined ? $IbYAq.fromJSON : $100e6ce17ae29a1a$var$Namespace.fromJSON)(names[i], nested));
    }
    return this;
};
/**
 * Gets the nested object of the specified name.
 * @param {string} name Nested object name
 * @returns {ReflectionObject|null} The reflection object or `null` if it doesn't exist
 */ $100e6ce17ae29a1a$var$Namespace.prototype.get = function get(name) {
    return this.nested && this.nested[name] || null;
};
/**
 * Gets the values of the nested {@link Enum|enum} of the specified name.
 * This methods differs from {@link Namespace#get|get} in that it returns an enum's values directly and throws instead of returning `null`.
 * @param {string} name Nested enum name
 * @returns {Object.<string,number>} Enum values
 * @throws {Error} If there is no such enum
 */ $100e6ce17ae29a1a$var$Namespace.prototype.getEnum = function getEnum(name) {
    if (this.nested && this.nested[name] instanceof $100e6ce17ae29a1a$var$Enum) return this.nested[name].values;
    throw Error("no such enum: " + name);
};
/**
 * Adds a nested object to this namespace.
 * @param {ReflectionObject} object Nested object to add
 * @returns {Namespace} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If there is already a nested object with this name
 */ $100e6ce17ae29a1a$var$Namespace.prototype.add = function add(object) {
    if (!(object instanceof $IbYAq && object.extend !== undefined || object instanceof $100e6ce17ae29a1a$var$Type || object instanceof $iMxDc || object instanceof $100e6ce17ae29a1a$var$Enum || object instanceof $100e6ce17ae29a1a$var$Service || object instanceof $100e6ce17ae29a1a$var$Namespace)) throw TypeError("object must be a valid nested object");
    if (!this.nested) this.nested = {};
    else {
        var prev = this.get(object.name);
        if (prev) {
            if (prev instanceof $100e6ce17ae29a1a$var$Namespace && object instanceof $100e6ce17ae29a1a$var$Namespace && !(prev instanceof $100e6ce17ae29a1a$var$Type || prev instanceof $100e6ce17ae29a1a$var$Service)) {
                // replace plain namespace but keep existing nested elements and options
                var nested = prev.nestedArray;
                for(var i = 0; i < nested.length; ++i)object.add(nested[i]);
                this.remove(prev);
                if (!this.nested) this.nested = {};
                object.setOptions(prev.options, true);
            } else throw Error("duplicate name '" + object.name + "' in " + this);
        }
    }
    this.nested[object.name] = object;
    object.onAdd(this);
    return $100e6ce17ae29a1a$var$clearCache(this);
};
/**
 * Removes a nested object from this namespace.
 * @param {ReflectionObject} object Nested object to remove
 * @returns {Namespace} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If `object` is not a member of this namespace
 */ $100e6ce17ae29a1a$var$Namespace.prototype.remove = function remove(object) {
    if (!(object instanceof $jAZD5)) throw TypeError("object must be a ReflectionObject");
    if (object.parent !== this) throw Error(object + " is not a member of " + this);
    delete this.nested[object.name];
    if (!Object.keys(this.nested).length) this.nested = undefined;
    object.onRemove(this);
    return $100e6ce17ae29a1a$var$clearCache(this);
};
/**
 * Defines additial namespaces within this one if not yet existing.
 * @param {string|string[]} path Path to create
 * @param {*} [json] Nested types to create from JSON
 * @returns {Namespace} Pointer to the last namespace created or `this` if path is empty
 */ $100e6ce17ae29a1a$var$Namespace.prototype.define = function define(path, json) {
    if ($1C5z4.isString(path)) path = path.split(".");
    else if (!Array.isArray(path)) throw TypeError("illegal path");
    if (path && path.length && path[0] === "") throw Error("path must be relative");
    var ptr = this;
    while(path.length > 0){
        var part = path.shift();
        if (ptr.nested && ptr.nested[part]) {
            ptr = ptr.nested[part];
            if (!(ptr instanceof $100e6ce17ae29a1a$var$Namespace)) throw Error("path conflicts with non-namespace objects");
        } else ptr.add(ptr = new $100e6ce17ae29a1a$var$Namespace(part));
    }
    if (json) ptr.addJSON(json);
    return ptr;
};
/**
 * Resolves this namespace's and all its nested objects' type references. Useful to validate a reflection tree, but comes at a cost.
 * @returns {Namespace} `this`
 */ $100e6ce17ae29a1a$var$Namespace.prototype.resolveAll = function resolveAll() {
    var nested = this.nestedArray, i = 0;
    while(i < nested.length)if (nested[i] instanceof $100e6ce17ae29a1a$var$Namespace) nested[i++].resolveAll();
    else nested[i++].resolve();
    return this.resolve();
};
/**
 * Recursively looks up the reflection object matching the specified path in the scope of this namespace.
 * @param {string|string[]} path Path to look up
 * @param {*|Array.<*>} filterTypes Filter types, any combination of the constructors of `protobuf.Type`, `protobuf.Enum`, `protobuf.Service` etc.
 * @param {boolean} [parentAlreadyChecked=false] If known, whether the parent has already been checked
 * @returns {ReflectionObject|null} Looked up object or `null` if none could be found
 */ $100e6ce17ae29a1a$var$Namespace.prototype.lookup = function lookup(path, filterTypes, parentAlreadyChecked) {
    /* istanbul ignore next */ if (typeof filterTypes === "boolean") {
        parentAlreadyChecked = filterTypes;
        filterTypes = undefined;
    } else if (filterTypes && !Array.isArray(filterTypes)) filterTypes = [
        filterTypes
    ];
    if ($1C5z4.isString(path) && path.length) {
        if (path === ".") return this.root;
        path = path.split(".");
    } else if (!path.length) return this;
    // Start at root if path is absolute
    if (path[0] === "") return this.root.lookup(path.slice(1), filterTypes);
    // Test if the first part matches any nested object, and if so, traverse if path contains more
    var found = this.get(path[0]);
    if (found) {
        if (path.length === 1) {
            if (!filterTypes || filterTypes.indexOf(found.constructor) > -1) return found;
        } else if (found instanceof $100e6ce17ae29a1a$var$Namespace && (found = found.lookup(path.slice(1), filterTypes, true))) return found;
    // Otherwise try each nested namespace
    } else for(var i = 0; i < this.nestedArray.length; ++i)if (this._nestedArray[i] instanceof $100e6ce17ae29a1a$var$Namespace && (found = this._nestedArray[i].lookup(path, filterTypes, true))) return found;
    // If there hasn't been a match, try again at the parent
    if (this.parent === null || parentAlreadyChecked) return null;
    return this.parent.lookup(path, filterTypes);
};
/**
 * Looks up the reflection object at the specified path, relative to this namespace.
 * @name NamespaceBase#lookup
 * @function
 * @param {string|string[]} path Path to look up
 * @param {boolean} [parentAlreadyChecked=false] Whether the parent has already been checked
 * @returns {ReflectionObject|null} Looked up object or `null` if none could be found
 * @variation 2
 */ // lookup(path: string, [parentAlreadyChecked: boolean])
/**
 * Looks up the {@link Type|type} at the specified path, relative to this namespace.
 * Besides its signature, this methods differs from {@link Namespace#lookup|lookup} in that it throws instead of returning `null`.
 * @param {string|string[]} path Path to look up
 * @returns {Type} Looked up type
 * @throws {Error} If `path` does not point to a type
 */ $100e6ce17ae29a1a$var$Namespace.prototype.lookupType = function lookupType(path) {
    var found = this.lookup(path, [
        $100e6ce17ae29a1a$var$Type
    ]);
    if (!found) throw Error("no such type: " + path);
    return found;
};
/**
 * Looks up the values of the {@link Enum|enum} at the specified path, relative to this namespace.
 * Besides its signature, this methods differs from {@link Namespace#lookup|lookup} in that it throws instead of returning `null`.
 * @param {string|string[]} path Path to look up
 * @returns {Enum} Looked up enum
 * @throws {Error} If `path` does not point to an enum
 */ $100e6ce17ae29a1a$var$Namespace.prototype.lookupEnum = function lookupEnum(path) {
    var found = this.lookup(path, [
        $100e6ce17ae29a1a$var$Enum
    ]);
    if (!found) throw Error("no such Enum '" + path + "' in " + this);
    return found;
};
/**
 * Looks up the {@link Type|type} or {@link Enum|enum} at the specified path, relative to this namespace.
 * Besides its signature, this methods differs from {@link Namespace#lookup|lookup} in that it throws instead of returning `null`.
 * @param {string|string[]} path Path to look up
 * @returns {Type} Looked up type or enum
 * @throws {Error} If `path` does not point to a type or enum
 */ $100e6ce17ae29a1a$var$Namespace.prototype.lookupTypeOrEnum = function lookupTypeOrEnum(path) {
    var found = this.lookup(path, [
        $100e6ce17ae29a1a$var$Type,
        $100e6ce17ae29a1a$var$Enum
    ]);
    if (!found) throw Error("no such Type or Enum '" + path + "' in " + this);
    return found;
};
/**
 * Looks up the {@link Service|service} at the specified path, relative to this namespace.
 * Besides its signature, this methods differs from {@link Namespace#lookup|lookup} in that it throws instead of returning `null`.
 * @param {string|string[]} path Path to look up
 * @returns {Service} Looked up service
 * @throws {Error} If `path` does not point to a service
 */ $100e6ce17ae29a1a$var$Namespace.prototype.lookupService = function lookupService(path) {
    var found = this.lookup(path, [
        $100e6ce17ae29a1a$var$Service
    ]);
    if (!found) throw Error("no such Service '" + path + "' in " + this);
    return found;
};
// Sets up cyclic dependencies (called in index-light)
$100e6ce17ae29a1a$var$Namespace._configure = function(Type_, Service_, Enum_) {
    $100e6ce17ae29a1a$var$Type = Type_;
    $100e6ce17ae29a1a$var$Service = Service_;
    $100e6ce17ae29a1a$var$Enum = Enum_;
};

});
parcelRegister("IbYAq", function(module, exports) {
"use strict";
module.exports = $084d6666693dc56a$var$Field;

var $jAZD5 = parcelRequire("jAZD5");
(($084d6666693dc56a$var$Field.prototype = Object.create($jAZD5.prototype)).constructor = $084d6666693dc56a$var$Field).className = "Field";

var $l9EYs = parcelRequire("l9EYs");

var $hyVJi = parcelRequire("hyVJi");

var $1C5z4 = parcelRequire("1C5z4");
var $084d6666693dc56a$var$Type; // cyclic
var $084d6666693dc56a$var$ruleRe = /^required|optional|repeated$/;
/**
 * Constructs a new message field instance. Note that {@link MapField|map fields} have their own class.
 * @name Field
 * @classdesc Reflected message field.
 * @extends FieldBase
 * @constructor
 * @param {string} name Unique name within its namespace
 * @param {number} id Unique id within its namespace
 * @param {string} type Value type
 * @param {string|Object.<string,*>} [rule="optional"] Field rule
 * @param {string|Object.<string,*>} [extend] Extended type if different from parent
 * @param {Object.<string,*>} [options] Declared options
 */ /**
 * Constructs a field from a field descriptor.
 * @param {string} name Field name
 * @param {IField} json Field descriptor
 * @returns {Field} Created field
 * @throws {TypeError} If arguments are invalid
 */ $084d6666693dc56a$var$Field.fromJSON = function fromJSON(name, json) {
    return new $084d6666693dc56a$var$Field(name, json.id, json.type, json.rule, json.extend, json.options, json.comment);
};
/**
 * Not an actual constructor. Use {@link Field} instead.
 * @classdesc Base class of all reflected message fields. This is not an actual class but here for the sake of having consistent type definitions.
 * @exports FieldBase
 * @extends ReflectionObject
 * @constructor
 * @param {string} name Unique name within its namespace
 * @param {number} id Unique id within its namespace
 * @param {string} type Value type
 * @param {string|Object.<string,*>} [rule="optional"] Field rule
 * @param {string|Object.<string,*>} [extend] Extended type if different from parent
 * @param {Object.<string,*>} [options] Declared options
 * @param {string} [comment] Comment associated with this field
 */ function $084d6666693dc56a$var$Field(name, id, type, rule, extend, options, comment) {
    if ($1C5z4.isObject(rule)) {
        comment = extend;
        options = rule;
        rule = extend = undefined;
    } else if ($1C5z4.isObject(extend)) {
        comment = options;
        options = extend;
        extend = undefined;
    }
    $jAZD5.call(this, name, options);
    if (!$1C5z4.isInteger(id) || id < 0) throw TypeError("id must be a non-negative integer");
    if (!$1C5z4.isString(type)) throw TypeError("type must be a string");
    if (rule !== undefined && !$084d6666693dc56a$var$ruleRe.test(rule = rule.toString().toLowerCase())) throw TypeError("rule must be a string rule");
    if (extend !== undefined && !$1C5z4.isString(extend)) throw TypeError("extend must be a string");
    /**
     * Field rule, if any.
     * @type {string|undefined}
     */ if (rule === "proto3_optional") rule = "optional";
    this.rule = rule && rule !== "optional" ? rule : undefined; // toJSON
    /**
     * Field type.
     * @type {string}
     */ this.type = type; // toJSON
    /**
     * Unique field id.
     * @type {number}
     */ this.id = id; // toJSON, marker
    /**
     * Extended type if different from parent.
     * @type {string|undefined}
     */ this.extend = extend || undefined; // toJSON
    /**
     * Whether this field is required.
     * @type {boolean}
     */ this.required = rule === "required";
    /**
     * Whether this field is optional.
     * @type {boolean}
     */ this.optional = !this.required;
    /**
     * Whether this field is repeated.
     * @type {boolean}
     */ this.repeated = rule === "repeated";
    /**
     * Whether this field is a map or not.
     * @type {boolean}
     */ this.map = false;
    /**
     * Message this field belongs to.
     * @type {Type|null}
     */ this.message = null;
    /**
     * OneOf this field belongs to, if any,
     * @type {OneOf|null}
     */ this.partOf = null;
    /**
     * The field type's default value.
     * @type {*}
     */ this.typeDefault = null;
    /**
     * The field's default value on prototypes.
     * @type {*}
     */ this.defaultValue = null;
    /**
     * Whether this field's value should be treated as a long.
     * @type {boolean}
     */ this.long = $1C5z4.Long ? $hyVJi.long[type] !== undefined : /* istanbul ignore next */ false;
    /**
     * Whether this field's value is a buffer.
     * @type {boolean}
     */ this.bytes = type === "bytes";
    /**
     * Resolved type if not a basic type.
     * @type {Type|Enum|null}
     */ this.resolvedType = null;
    /**
     * Sister-field within the extended type if a declaring extension field.
     * @type {Field|null}
     */ this.extensionField = null;
    /**
     * Sister-field within the declaring namespace if an extended field.
     * @type {Field|null}
     */ this.declaringField = null;
    /**
     * Internally remembers whether this field is packed.
     * @type {boolean|null}
     * @private
     */ this._packed = null;
    /**
     * Comment for this field.
     * @type {string|null}
     */ this.comment = comment;
}
/**
 * Determines whether this field is packed. Only relevant when repeated and working with proto2.
 * @name Field#packed
 * @type {boolean}
 * @readonly
 */ Object.defineProperty($084d6666693dc56a$var$Field.prototype, "packed", {
    get: function() {
        // defaults to packed=true if not explicity set to false
        if (this._packed === null) this._packed = this.getOption("packed") !== false;
        return this._packed;
    }
});
/**
 * @override
 */ $084d6666693dc56a$var$Field.prototype.setOption = function setOption(name, value, ifNotSet) {
    if (name === "packed") this._packed = null;
    return $jAZD5.prototype.setOption.call(this, name, value, ifNotSet);
};
/**
 * Field descriptor.
 * @interface IField
 * @property {string} [rule="optional"] Field rule
 * @property {string} type Field type
 * @property {number} id Field id
 * @property {Object.<string,*>} [options] Field options
 */ /**
 * Extension field descriptor.
 * @interface IExtensionField
 * @extends IField
 * @property {string} extend Extended type
 */ /**
 * Converts this field to a field descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IField} Field descriptor
 */ $084d6666693dc56a$var$Field.prototype.toJSON = function toJSON(toJSONOptions) {
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $1C5z4.toObject([
        "rule",
        this.rule !== "optional" && this.rule || undefined,
        "type",
        this.type,
        "id",
        this.id,
        "extend",
        this.extend,
        "options",
        this.options,
        "comment",
        keepComments ? this.comment : undefined
    ]);
};
/**
 * Resolves this field's type references.
 * @returns {Field} `this`
 * @throws {Error} If any reference cannot be resolved
 */ $084d6666693dc56a$var$Field.prototype.resolve = function resolve() {
    if (this.resolved) return this;
    if ((this.typeDefault = $hyVJi.defaults[this.type]) === undefined) {
        this.resolvedType = (this.declaringField ? this.declaringField.parent : this.parent).lookupTypeOrEnum(this.type);
        if (this.resolvedType instanceof $084d6666693dc56a$var$Type) this.typeDefault = null;
        else this.typeDefault = this.resolvedType.values[Object.keys(this.resolvedType.values)[0]]; // first defined
    } else if (this.options && this.options.proto3_optional) // proto3 scalar value marked optional; should default to null
    this.typeDefault = null;
    // use explicitly set default value if present
    if (this.options && this.options["default"] != null) {
        this.typeDefault = this.options["default"];
        if (this.resolvedType instanceof $l9EYs && typeof this.typeDefault === "string") this.typeDefault = this.resolvedType.values[this.typeDefault];
    }
    // remove unnecessary options
    if (this.options) {
        if (this.options.packed === true || this.options.packed !== undefined && this.resolvedType && !(this.resolvedType instanceof $l9EYs)) delete this.options.packed;
        if (!Object.keys(this.options).length) this.options = undefined;
    }
    // convert to internal data type if necesssary
    if (this.long) {
        this.typeDefault = $1C5z4.Long.fromNumber(this.typeDefault, this.type.charAt(0) === "u");
        /* istanbul ignore else */ if (Object.freeze) Object.freeze(this.typeDefault); // long instances are meant to be immutable anyway (i.e. use small int cache that even requires it)
    } else if (this.bytes && typeof this.typeDefault === "string") {
        var buf;
        if ($1C5z4.base64.test(this.typeDefault)) $1C5z4.base64.decode(this.typeDefault, buf = $1C5z4.newBuffer($1C5z4.base64.length(this.typeDefault)), 0);
        else $1C5z4.utf8.write(this.typeDefault, buf = $1C5z4.newBuffer($1C5z4.utf8.length(this.typeDefault)), 0);
        this.typeDefault = buf;
    }
    // take special care of maps and repeated fields
    if (this.map) this.defaultValue = $1C5z4.emptyObject;
    else if (this.repeated) this.defaultValue = $1C5z4.emptyArray;
    else this.defaultValue = this.typeDefault;
    // ensure proper value on prototype
    if (this.parent instanceof $084d6666693dc56a$var$Type) this.parent.ctor.prototype[this.name] = this.defaultValue;
    return $jAZD5.prototype.resolve.call(this);
};
/**
 * Decorator function as returned by {@link Field.d} and {@link MapField.d} (TypeScript).
 * @typedef FieldDecorator
 * @type {function}
 * @param {Object} prototype Target prototype
 * @param {string} fieldName Field name
 * @returns {undefined}
 */ /**
 * Field decorator (TypeScript).
 * @name Field.d
 * @function
 * @param {number} fieldId Field id
 * @param {"double"|"float"|"int32"|"uint32"|"sint32"|"fixed32"|"sfixed32"|"int64"|"uint64"|"sint64"|"fixed64"|"sfixed64"|"string"|"bool"|"bytes"|Object} fieldType Field type
 * @param {"optional"|"required"|"repeated"} [fieldRule="optional"] Field rule
 * @param {T} [defaultValue] Default value
 * @returns {FieldDecorator} Decorator function
 * @template T extends number | number[] | Long | Long[] | string | string[] | boolean | boolean[] | Uint8Array | Uint8Array[] | Buffer | Buffer[]
 */ $084d6666693dc56a$var$Field.d = function decorateField(fieldId, fieldType, fieldRule, defaultValue) {
    // submessage: decorate the submessage and use its name as the type
    if (typeof fieldType === "function") fieldType = $1C5z4.decorateType(fieldType).name;
    else if (fieldType && typeof fieldType === "object") fieldType = $1C5z4.decorateEnum(fieldType).name;
    return function fieldDecorator(prototype, fieldName) {
        $1C5z4.decorateType(prototype.constructor).add(new $084d6666693dc56a$var$Field(fieldName, fieldId, fieldType, fieldRule, {
            "default": defaultValue
        }));
    };
};
/**
 * Field decorator (TypeScript).
 * @name Field.d
 * @function
 * @param {number} fieldId Field id
 * @param {Constructor<T>|string} fieldType Field type
 * @param {"optional"|"required"|"repeated"} [fieldRule="optional"] Field rule
 * @returns {FieldDecorator} Decorator function
 * @template T extends Message<T>
 * @variation 2
 */ // like Field.d but without a default value
// Sets up cyclic dependencies (called in index-light)
$084d6666693dc56a$var$Field._configure = function configure(Type_) {
    $084d6666693dc56a$var$Type = Type_;
};

});
parcelRegister("hyVJi", function(module, exports) {
"use strict";
/**
 * Common type constants.
 * @namespace
 */ var $cc92648a257b2fd2$var$types = module.exports;

var $1C5z4 = parcelRequire("1C5z4");
var $cc92648a257b2fd2$var$s = [
    "double",
    "float",
    "int32",
    "uint32",
    "sint32",
    "fixed32",
    "sfixed32",
    "int64",
    "uint64",
    "sint64",
    "fixed64",
    "sfixed64",
    "bool",
    "string",
    "bytes" // 14
];
function $cc92648a257b2fd2$var$bake(values, offset) {
    var i = 0, o = {};
    offset |= 0;
    while(i < values.length)o[$cc92648a257b2fd2$var$s[i + offset]] = values[i++];
    return o;
}
/**
 * Basic type wire types.
 * @type {Object.<string,number>}
 * @const
 * @property {number} double=1 Fixed64 wire type
 * @property {number} float=5 Fixed32 wire type
 * @property {number} int32=0 Varint wire type
 * @property {number} uint32=0 Varint wire type
 * @property {number} sint32=0 Varint wire type
 * @property {number} fixed32=5 Fixed32 wire type
 * @property {number} sfixed32=5 Fixed32 wire type
 * @property {number} int64=0 Varint wire type
 * @property {number} uint64=0 Varint wire type
 * @property {number} sint64=0 Varint wire type
 * @property {number} fixed64=1 Fixed64 wire type
 * @property {number} sfixed64=1 Fixed64 wire type
 * @property {number} bool=0 Varint wire type
 * @property {number} string=2 Ldelim wire type
 * @property {number} bytes=2 Ldelim wire type
 */ $cc92648a257b2fd2$var$types.basic = $cc92648a257b2fd2$var$bake([
    /* double   */ 1,
    /* float    */ 5,
    /* int32    */ 0,
    /* uint32   */ 0,
    /* sint32   */ 0,
    /* fixed32  */ 5,
    /* sfixed32 */ 5,
    /* int64    */ 0,
    /* uint64   */ 0,
    /* sint64   */ 0,
    /* fixed64  */ 1,
    /* sfixed64 */ 1,
    /* bool     */ 0,
    /* string   */ 2,
    /* bytes    */ 2
]);
/**
 * Basic type defaults.
 * @type {Object.<string,*>}
 * @const
 * @property {number} double=0 Double default
 * @property {number} float=0 Float default
 * @property {number} int32=0 Int32 default
 * @property {number} uint32=0 Uint32 default
 * @property {number} sint32=0 Sint32 default
 * @property {number} fixed32=0 Fixed32 default
 * @property {number} sfixed32=0 Sfixed32 default
 * @property {number} int64=0 Int64 default
 * @property {number} uint64=0 Uint64 default
 * @property {number} sint64=0 Sint32 default
 * @property {number} fixed64=0 Fixed64 default
 * @property {number} sfixed64=0 Sfixed64 default
 * @property {boolean} bool=false Bool default
 * @property {string} string="" String default
 * @property {Array.<number>} bytes=Array(0) Bytes default
 * @property {null} message=null Message default
 */ $cc92648a257b2fd2$var$types.defaults = $cc92648a257b2fd2$var$bake([
    /* double   */ 0,
    /* float    */ 0,
    /* int32    */ 0,
    /* uint32   */ 0,
    /* sint32   */ 0,
    /* fixed32  */ 0,
    /* sfixed32 */ 0,
    /* int64    */ 0,
    /* uint64   */ 0,
    /* sint64   */ 0,
    /* fixed64  */ 0,
    /* sfixed64 */ 0,
    /* bool     */ false,
    /* string   */ "",
    /* bytes    */ $1C5z4.emptyArray,
    /* message  */ null
]);
/**
 * Basic long type wire types.
 * @type {Object.<string,number>}
 * @const
 * @property {number} int64=0 Varint wire type
 * @property {number} uint64=0 Varint wire type
 * @property {number} sint64=0 Varint wire type
 * @property {number} fixed64=1 Fixed64 wire type
 * @property {number} sfixed64=1 Fixed64 wire type
 */ $cc92648a257b2fd2$var$types.long = $cc92648a257b2fd2$var$bake([
    /* int64    */ 0,
    /* uint64   */ 0,
    /* sint64   */ 0,
    /* fixed64  */ 1,
    /* sfixed64 */ 1
], 7);
/**
 * Allowed types for map keys with their associated wire type.
 * @type {Object.<string,number>}
 * @const
 * @property {number} int32=0 Varint wire type
 * @property {number} uint32=0 Varint wire type
 * @property {number} sint32=0 Varint wire type
 * @property {number} fixed32=5 Fixed32 wire type
 * @property {number} sfixed32=5 Fixed32 wire type
 * @property {number} int64=0 Varint wire type
 * @property {number} uint64=0 Varint wire type
 * @property {number} sint64=0 Varint wire type
 * @property {number} fixed64=1 Fixed64 wire type
 * @property {number} sfixed64=1 Fixed64 wire type
 * @property {number} bool=0 Varint wire type
 * @property {number} string=2 Ldelim wire type
 */ $cc92648a257b2fd2$var$types.mapKey = $cc92648a257b2fd2$var$bake([
    /* int32    */ 0,
    /* uint32   */ 0,
    /* sint32   */ 0,
    /* fixed32  */ 5,
    /* sfixed32 */ 5,
    /* int64    */ 0,
    /* uint64   */ 0,
    /* sint64   */ 0,
    /* fixed64  */ 1,
    /* sfixed64 */ 1,
    /* bool     */ 0,
    /* string   */ 2
], 2);
/**
 * Allowed types for packed repeated fields with their associated wire type.
 * @type {Object.<string,number>}
 * @const
 * @property {number} double=1 Fixed64 wire type
 * @property {number} float=5 Fixed32 wire type
 * @property {number} int32=0 Varint wire type
 * @property {number} uint32=0 Varint wire type
 * @property {number} sint32=0 Varint wire type
 * @property {number} fixed32=5 Fixed32 wire type
 * @property {number} sfixed32=5 Fixed32 wire type
 * @property {number} int64=0 Varint wire type
 * @property {number} uint64=0 Varint wire type
 * @property {number} sint64=0 Varint wire type
 * @property {number} fixed64=1 Fixed64 wire type
 * @property {number} sfixed64=1 Fixed64 wire type
 * @property {number} bool=0 Varint wire type
 */ $cc92648a257b2fd2$var$types.packed = $cc92648a257b2fd2$var$bake([
    /* double   */ 1,
    /* float    */ 5,
    /* int32    */ 0,
    /* uint32   */ 0,
    /* sint32   */ 0,
    /* fixed32  */ 5,
    /* sfixed32 */ 5,
    /* int64    */ 0,
    /* uint64   */ 0,
    /* sint64   */ 0,
    /* fixed64  */ 1,
    /* sfixed64 */ 1,
    /* bool     */ 0
]);

});


parcelRegister("iMxDc", function(module, exports) {
"use strict";
module.exports = $dac6cc2bcf44bc6e$var$OneOf;

var $jAZD5 = parcelRequire("jAZD5");
(($dac6cc2bcf44bc6e$var$OneOf.prototype = Object.create($jAZD5.prototype)).constructor = $dac6cc2bcf44bc6e$var$OneOf).className = "OneOf";

var $IbYAq = parcelRequire("IbYAq");

var $1C5z4 = parcelRequire("1C5z4");
/**
 * Constructs a new oneof instance.
 * @classdesc Reflected oneof.
 * @extends ReflectionObject
 * @constructor
 * @param {string} name Oneof name
 * @param {string[]|Object.<string,*>} [fieldNames] Field names
 * @param {Object.<string,*>} [options] Declared options
 * @param {string} [comment] Comment associated with this field
 */ function $dac6cc2bcf44bc6e$var$OneOf(name, fieldNames, options, comment) {
    if (!Array.isArray(fieldNames)) {
        options = fieldNames;
        fieldNames = undefined;
    }
    $jAZD5.call(this, name, options);
    /* istanbul ignore if */ if (!(fieldNames === undefined || Array.isArray(fieldNames))) throw TypeError("fieldNames must be an Array");
    /**
     * Field names that belong to this oneof.
     * @type {string[]}
     */ this.oneof = fieldNames || []; // toJSON, marker
    /**
     * Fields that belong to this oneof as an array for iteration.
     * @type {Field[]}
     * @readonly
     */ this.fieldsArray = []; // declared readonly for conformance, possibly not yet added to parent
    /**
     * Comment for this field.
     * @type {string|null}
     */ this.comment = comment;
}
/**
 * Oneof descriptor.
 * @interface IOneOf
 * @property {Array.<string>} oneof Oneof field names
 * @property {Object.<string,*>} [options] Oneof options
 */ /**
 * Constructs a oneof from a oneof descriptor.
 * @param {string} name Oneof name
 * @param {IOneOf} json Oneof descriptor
 * @returns {OneOf} Created oneof
 * @throws {TypeError} If arguments are invalid
 */ $dac6cc2bcf44bc6e$var$OneOf.fromJSON = function fromJSON(name, json) {
    return new $dac6cc2bcf44bc6e$var$OneOf(name, json.oneof, json.options, json.comment);
};
/**
 * Converts this oneof to a oneof descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IOneOf} Oneof descriptor
 */ $dac6cc2bcf44bc6e$var$OneOf.prototype.toJSON = function toJSON(toJSONOptions) {
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $1C5z4.toObject([
        "options",
        this.options,
        "oneof",
        this.oneof,
        "comment",
        keepComments ? this.comment : undefined
    ]);
};
/**
 * Adds the fields of the specified oneof to the parent if not already done so.
 * @param {OneOf} oneof The oneof
 * @returns {undefined}
 * @inner
 * @ignore
 */ function $dac6cc2bcf44bc6e$var$addFieldsToParent(oneof) {
    if (oneof.parent) {
        for(var i = 0; i < oneof.fieldsArray.length; ++i)if (!oneof.fieldsArray[i].parent) oneof.parent.add(oneof.fieldsArray[i]);
    }
}
/**
 * Adds a field to this oneof and removes it from its current parent, if any.
 * @param {Field} field Field to add
 * @returns {OneOf} `this`
 */ $dac6cc2bcf44bc6e$var$OneOf.prototype.add = function add(field) {
    /* istanbul ignore if */ if (!(field instanceof $IbYAq)) throw TypeError("field must be a Field");
    if (field.parent && field.parent !== this.parent) field.parent.remove(field);
    this.oneof.push(field.name);
    this.fieldsArray.push(field);
    field.partOf = this; // field.parent remains null
    $dac6cc2bcf44bc6e$var$addFieldsToParent(this);
    return this;
};
/**
 * Removes a field from this oneof and puts it back to the oneof's parent.
 * @param {Field} field Field to remove
 * @returns {OneOf} `this`
 */ $dac6cc2bcf44bc6e$var$OneOf.prototype.remove = function remove(field) {
    /* istanbul ignore if */ if (!(field instanceof $IbYAq)) throw TypeError("field must be a Field");
    var index = this.fieldsArray.indexOf(field);
    /* istanbul ignore if */ if (index < 0) throw Error(field + " is not a member of " + this);
    this.fieldsArray.splice(index, 1);
    index = this.oneof.indexOf(field.name);
    /* istanbul ignore else */ if (index > -1) this.oneof.splice(index, 1);
    field.partOf = null;
    return this;
};
/**
 * @override
 */ $dac6cc2bcf44bc6e$var$OneOf.prototype.onAdd = function onAdd(parent) {
    $jAZD5.prototype.onAdd.call(this, parent);
    var self = this;
    // Collect present fields
    for(var i = 0; i < this.oneof.length; ++i){
        var field = parent.get(this.oneof[i]);
        if (field && !field.partOf) {
            field.partOf = self;
            self.fieldsArray.push(field);
        }
    }
    // Add not yet present fields
    $dac6cc2bcf44bc6e$var$addFieldsToParent(this);
};
/**
 * @override
 */ $dac6cc2bcf44bc6e$var$OneOf.prototype.onRemove = function onRemove(parent) {
    for(var i = 0, field; i < this.fieldsArray.length; ++i)if ((field = this.fieldsArray[i]).parent) field.parent.remove(field);
    $jAZD5.prototype.onRemove.call(this, parent);
};
/**
 * Decorator function as returned by {@link OneOf.d} (TypeScript).
 * @typedef OneOfDecorator
 * @type {function}
 * @param {Object} prototype Target prototype
 * @param {string} oneofName OneOf name
 * @returns {undefined}
 */ /**
 * OneOf decorator (TypeScript).
 * @function
 * @param {...string} fieldNames Field names
 * @returns {OneOfDecorator} Decorator function
 * @template T extends string
 */ $dac6cc2bcf44bc6e$var$OneOf.d = function decorateOneOf() {
    var fieldNames = new Array(arguments.length), index = 0;
    while(index < arguments.length)fieldNames[index] = arguments[index++];
    return function oneOfDecorator(prototype, oneofName) {
        $1C5z4.decorateType(prototype.constructor).add(new $dac6cc2bcf44bc6e$var$OneOf(oneofName, fieldNames));
        Object.defineProperty(prototype, oneofName, {
            get: $1C5z4.oneOfGetter(fieldNames),
            set: $1C5z4.oneOfSetter(fieldNames)
        });
    };
};

});


parcelRegister("hI2Xk", function(module, exports) {
"use strict";
module.exports = $ce48d6b25a9ab464$var$MapField;

var $IbYAq = parcelRequire("IbYAq");
(($ce48d6b25a9ab464$var$MapField.prototype = Object.create($IbYAq.prototype)).constructor = $ce48d6b25a9ab464$var$MapField).className = "MapField";

var $hyVJi = parcelRequire("hyVJi");

var $1C5z4 = parcelRequire("1C5z4");
/**
 * Constructs a new map field instance.
 * @classdesc Reflected map field.
 * @extends FieldBase
 * @constructor
 * @param {string} name Unique name within its namespace
 * @param {number} id Unique id within its namespace
 * @param {string} keyType Key type
 * @param {string} type Value type
 * @param {Object.<string,*>} [options] Declared options
 * @param {string} [comment] Comment associated with this field
 */ function $ce48d6b25a9ab464$var$MapField(name, id, keyType, type, options, comment) {
    $IbYAq.call(this, name, id, type, undefined, undefined, options, comment);
    /* istanbul ignore if */ if (!$1C5z4.isString(keyType)) throw TypeError("keyType must be a string");
    /**
     * Key type.
     * @type {string}
     */ this.keyType = keyType; // toJSON, marker
    /**
     * Resolved key type if not a basic type.
     * @type {ReflectionObject|null}
     */ this.resolvedKeyType = null;
    // Overrides Field#map
    this.map = true;
}
/**
 * Map field descriptor.
 * @interface IMapField
 * @extends {IField}
 * @property {string} keyType Key type
 */ /**
 * Extension map field descriptor.
 * @interface IExtensionMapField
 * @extends IMapField
 * @property {string} extend Extended type
 */ /**
 * Constructs a map field from a map field descriptor.
 * @param {string} name Field name
 * @param {IMapField} json Map field descriptor
 * @returns {MapField} Created map field
 * @throws {TypeError} If arguments are invalid
 */ $ce48d6b25a9ab464$var$MapField.fromJSON = function fromJSON(name, json) {
    return new $ce48d6b25a9ab464$var$MapField(name, json.id, json.keyType, json.type, json.options, json.comment);
};
/**
 * Converts this map field to a map field descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IMapField} Map field descriptor
 */ $ce48d6b25a9ab464$var$MapField.prototype.toJSON = function toJSON(toJSONOptions) {
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $1C5z4.toObject([
        "keyType",
        this.keyType,
        "type",
        this.type,
        "id",
        this.id,
        "extend",
        this.extend,
        "options",
        this.options,
        "comment",
        keepComments ? this.comment : undefined
    ]);
};
/**
 * @override
 */ $ce48d6b25a9ab464$var$MapField.prototype.resolve = function resolve() {
    if (this.resolved) return this;
    // Besides a value type, map fields have a key type that may be "any scalar type except for floating point types and bytes"
    if ($hyVJi.mapKey[this.keyType] === undefined) throw Error("invalid key type: " + this.keyType);
    return $IbYAq.prototype.resolve.call(this);
};
/**
 * Map field decorator (TypeScript).
 * @name MapField.d
 * @function
 * @param {number} fieldId Field id
 * @param {"int32"|"uint32"|"sint32"|"fixed32"|"sfixed32"|"int64"|"uint64"|"sint64"|"fixed64"|"sfixed64"|"bool"|"string"} fieldKeyType Field key type
 * @param {"double"|"float"|"int32"|"uint32"|"sint32"|"fixed32"|"sfixed32"|"int64"|"uint64"|"sint64"|"fixed64"|"sfixed64"|"bool"|"string"|"bytes"|Object|Constructor<{}>} fieldValueType Field value type
 * @returns {FieldDecorator} Decorator function
 * @template T extends { [key: string]: number | Long | string | boolean | Uint8Array | Buffer | number[] | Message<{}> }
 */ $ce48d6b25a9ab464$var$MapField.d = function decorateMapField(fieldId, fieldKeyType, fieldValueType) {
    // submessage value: decorate the submessage and use its name as the type
    if (typeof fieldValueType === "function") fieldValueType = $1C5z4.decorateType(fieldValueType).name;
    else if (fieldValueType && typeof fieldValueType === "object") fieldValueType = $1C5z4.decorateEnum(fieldValueType).name;
    return function mapFieldDecorator(prototype, fieldName) {
        $1C5z4.decorateType(prototype.constructor).add(new $ce48d6b25a9ab464$var$MapField(fieldName, fieldId, fieldKeyType, fieldValueType));
    };
};

});

parcelRegister("5Iewc", function(module, exports) {
"use strict";
module.exports = $428c52d6882c9217$var$Service;

var $1nsZk = parcelRequire("1nsZk");
(($428c52d6882c9217$var$Service.prototype = Object.create($1nsZk.prototype)).constructor = $428c52d6882c9217$var$Service).className = "Service";

var $kgBOI = parcelRequire("kgBOI");

var $1C5z4 = parcelRequire("1C5z4");

var $jh3HG = parcelRequire("jh3HG");
/**
 * Constructs a new service instance.
 * @classdesc Reflected service.
 * @extends NamespaceBase
 * @constructor
 * @param {string} name Service name
 * @param {Object.<string,*>} [options] Service options
 * @throws {TypeError} If arguments are invalid
 */ function $428c52d6882c9217$var$Service(name, options) {
    $1nsZk.call(this, name, options);
    /**
     * Service methods.
     * @type {Object.<string,Method>}
     */ this.methods = {}; // toJSON, marker
    /**
     * Cached methods as an array.
     * @type {Method[]|null}
     * @private
     */ this._methodsArray = null;
}
/**
 * Service descriptor.
 * @interface IService
 * @extends INamespace
 * @property {Object.<string,IMethod>} methods Method descriptors
 */ /**
 * Constructs a service from a service descriptor.
 * @param {string} name Service name
 * @param {IService} json Service descriptor
 * @returns {Service} Created service
 * @throws {TypeError} If arguments are invalid
 */ $428c52d6882c9217$var$Service.fromJSON = function fromJSON(name, json) {
    var service = new $428c52d6882c9217$var$Service(name, json.options);
    /* istanbul ignore else */ if (json.methods) for(var names = Object.keys(json.methods), i = 0; i < names.length; ++i)service.add($kgBOI.fromJSON(names[i], json.methods[names[i]]));
    if (json.nested) service.addJSON(json.nested);
    service.comment = json.comment;
    return service;
};
/**
 * Converts this service to a service descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IService} Service descriptor
 */ $428c52d6882c9217$var$Service.prototype.toJSON = function toJSON(toJSONOptions) {
    var inherited = $1nsZk.prototype.toJSON.call(this, toJSONOptions);
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $1C5z4.toObject([
        "options",
        inherited && inherited.options || undefined,
        "methods",
        $1nsZk.arrayToJSON(this.methodsArray, toJSONOptions) || /* istanbul ignore next */ {},
        "nested",
        inherited && inherited.nested || undefined,
        "comment",
        keepComments ? this.comment : undefined
    ]);
};
/**
 * Methods of this service as an array for iteration.
 * @name Service#methodsArray
 * @type {Method[]}
 * @readonly
 */ Object.defineProperty($428c52d6882c9217$var$Service.prototype, "methodsArray", {
    get: function() {
        return this._methodsArray || (this._methodsArray = $1C5z4.toArray(this.methods));
    }
});
function $428c52d6882c9217$var$clearCache(service) {
    service._methodsArray = null;
    return service;
}
/**
 * @override
 */ $428c52d6882c9217$var$Service.prototype.get = function get(name) {
    return this.methods[name] || $1nsZk.prototype.get.call(this, name);
};
/**
 * @override
 */ $428c52d6882c9217$var$Service.prototype.resolveAll = function resolveAll() {
    var methods = this.methodsArray;
    for(var i = 0; i < methods.length; ++i)methods[i].resolve();
    return $1nsZk.prototype.resolve.call(this);
};
/**
 * @override
 */ $428c52d6882c9217$var$Service.prototype.add = function add(object) {
    /* istanbul ignore if */ if (this.get(object.name)) throw Error("duplicate name '" + object.name + "' in " + this);
    if (object instanceof $kgBOI) {
        this.methods[object.name] = object;
        object.parent = this;
        return $428c52d6882c9217$var$clearCache(this);
    }
    return $1nsZk.prototype.add.call(this, object);
};
/**
 * @override
 */ $428c52d6882c9217$var$Service.prototype.remove = function remove(object) {
    if (object instanceof $kgBOI) {
        /* istanbul ignore if */ if (this.methods[object.name] !== object) throw Error(object + " is not a member of " + this);
        delete this.methods[object.name];
        object.parent = null;
        return $428c52d6882c9217$var$clearCache(this);
    }
    return $1nsZk.prototype.remove.call(this, object);
};
/**
 * Creates a runtime service using the specified rpc implementation.
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 * @returns {rpc.Service} RPC service. Useful where requests and/or responses are streamed.
 */ $428c52d6882c9217$var$Service.prototype.create = function create(rpcImpl, requestDelimited, responseDelimited) {
    var rpcService = new $jh3HG.Service(rpcImpl, requestDelimited, responseDelimited);
    for(var i = 0, method; i < /* initializes */ this.methodsArray.length; ++i){
        var methodName = $1C5z4.lcFirst((method = this._methodsArray[i]).resolve().name).replace(/[^$\w_]/g, "");
        rpcService[methodName] = $1C5z4.codegen([
            "r",
            "c"
        ], $1C5z4.isReserved(methodName) ? methodName + "_" : methodName)("return this.rpcCall(m,q,s,r,c)")({
            m: method,
            q: method.resolvedRequestType.ctor,
            s: method.resolvedResponseType.ctor
        });
    }
    return rpcService;
};

});
parcelRegister("kgBOI", function(module, exports) {
"use strict";
module.exports = $ec12a2f51555de4a$var$Method;

var $jAZD5 = parcelRequire("jAZD5");
(($ec12a2f51555de4a$var$Method.prototype = Object.create($jAZD5.prototype)).constructor = $ec12a2f51555de4a$var$Method).className = "Method";

var $1C5z4 = parcelRequire("1C5z4");
/**
 * Constructs a new service method instance.
 * @classdesc Reflected service method.
 * @extends ReflectionObject
 * @constructor
 * @param {string} name Method name
 * @param {string|undefined} type Method type, usually `"rpc"`
 * @param {string} requestType Request message type
 * @param {string} responseType Response message type
 * @param {boolean|Object.<string,*>} [requestStream] Whether the request is streamed
 * @param {boolean|Object.<string,*>} [responseStream] Whether the response is streamed
 * @param {Object.<string,*>} [options] Declared options
 * @param {string} [comment] The comment for this method
 * @param {Object.<string,*>} [parsedOptions] Declared options, properly parsed into an object
 */ function $ec12a2f51555de4a$var$Method(name, type, requestType, responseType, requestStream, responseStream, options, comment, parsedOptions) {
    /* istanbul ignore next */ if ($1C5z4.isObject(requestStream)) {
        options = requestStream;
        requestStream = responseStream = undefined;
    } else if ($1C5z4.isObject(responseStream)) {
        options = responseStream;
        responseStream = undefined;
    }
    /* istanbul ignore if */ if (!(type === undefined || $1C5z4.isString(type))) throw TypeError("type must be a string");
    /* istanbul ignore if */ if (!$1C5z4.isString(requestType)) throw TypeError("requestType must be a string");
    /* istanbul ignore if */ if (!$1C5z4.isString(responseType)) throw TypeError("responseType must be a string");
    $jAZD5.call(this, name, options);
    /**
     * Method type.
     * @type {string}
     */ this.type = type || "rpc"; // toJSON
    /**
     * Request type.
     * @type {string}
     */ this.requestType = requestType; // toJSON, marker
    /**
     * Whether requests are streamed or not.
     * @type {boolean|undefined}
     */ this.requestStream = requestStream ? true : undefined; // toJSON
    /**
     * Response type.
     * @type {string}
     */ this.responseType = responseType; // toJSON
    /**
     * Whether responses are streamed or not.
     * @type {boolean|undefined}
     */ this.responseStream = responseStream ? true : undefined; // toJSON
    /**
     * Resolved request type.
     * @type {Type|null}
     */ this.resolvedRequestType = null;
    /**
     * Resolved response type.
     * @type {Type|null}
     */ this.resolvedResponseType = null;
    /**
     * Comment for this method
     * @type {string|null}
     */ this.comment = comment;
    /**
     * Options properly parsed into an object
     */ this.parsedOptions = parsedOptions;
}
/**
 * Method descriptor.
 * @interface IMethod
 * @property {string} [type="rpc"] Method type
 * @property {string} requestType Request type
 * @property {string} responseType Response type
 * @property {boolean} [requestStream=false] Whether requests are streamed
 * @property {boolean} [responseStream=false] Whether responses are streamed
 * @property {Object.<string,*>} [options] Method options
 * @property {string} comment Method comments
 * @property {Object.<string,*>} [parsedOptions] Method options properly parsed into an object
 */ /**
 * Constructs a method from a method descriptor.
 * @param {string} name Method name
 * @param {IMethod} json Method descriptor
 * @returns {Method} Created method
 * @throws {TypeError} If arguments are invalid
 */ $ec12a2f51555de4a$var$Method.fromJSON = function fromJSON(name, json) {
    return new $ec12a2f51555de4a$var$Method(name, json.type, json.requestType, json.responseType, json.requestStream, json.responseStream, json.options, json.comment, json.parsedOptions);
};
/**
 * Converts this method to a method descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IMethod} Method descriptor
 */ $ec12a2f51555de4a$var$Method.prototype.toJSON = function toJSON(toJSONOptions) {
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $1C5z4.toObject([
        "type",
        this.type !== "rpc" && /* istanbul ignore next */ this.type || undefined,
        "requestType",
        this.requestType,
        "requestStream",
        this.requestStream,
        "responseType",
        this.responseType,
        "responseStream",
        this.responseStream,
        "options",
        this.options,
        "comment",
        keepComments ? this.comment : undefined,
        "parsedOptions",
        this.parsedOptions
    ]);
};
/**
 * @override
 */ $ec12a2f51555de4a$var$Method.prototype.resolve = function resolve() {
    /* istanbul ignore if */ if (this.resolved) return this;
    this.resolvedRequestType = this.parent.lookupType(this.requestType);
    this.resolvedResponseType = this.parent.lookupType(this.responseType);
    return $jAZD5.prototype.resolve.call(this);
};

});


parcelRegister("9npbz", function(module, exports) {
"use strict";
module.exports = $6d39cc6021b9ab53$var$Message;

var $9920C = parcelRequire("9920C");
/**
 * Constructs a new message instance.
 * @classdesc Abstract runtime message.
 * @constructor
 * @param {Properties<T>} [properties] Properties to set
 * @template T extends object = object
 */ function $6d39cc6021b9ab53$var$Message(properties) {
    // not used internally
    if (properties) for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)this[keys[i]] = properties[keys[i]];
}
/**
 * Reference to the reflected type.
 * @name Message.$type
 * @type {Type}
 * @readonly
 */ /**
 * Reference to the reflected type.
 * @name Message#$type
 * @type {Type}
 * @readonly
 */ /*eslint-disable valid-jsdoc*/ /**
 * Creates a new message of this type using the specified properties.
 * @param {Object.<string,*>} [properties] Properties to set
 * @returns {Message<T>} Message instance
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $6d39cc6021b9ab53$var$Message.create = function create(properties) {
    return this.$type.create(properties);
};
/**
 * Encodes a message of this type.
 * @param {T|Object.<string,*>} message Message to encode
 * @param {Writer} [writer] Writer to use
 * @returns {Writer} Writer
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $6d39cc6021b9ab53$var$Message.encode = function encode(message, writer) {
    return this.$type.encode(message, writer);
};
/**
 * Encodes a message of this type preceeded by its length as a varint.
 * @param {T|Object.<string,*>} message Message to encode
 * @param {Writer} [writer] Writer to use
 * @returns {Writer} Writer
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $6d39cc6021b9ab53$var$Message.encodeDelimited = function encodeDelimited(message, writer) {
    return this.$type.encodeDelimited(message, writer);
};
/**
 * Decodes a message of this type.
 * @name Message.decode
 * @function
 * @param {Reader|Uint8Array} reader Reader or buffer to decode
 * @returns {T} Decoded message
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $6d39cc6021b9ab53$var$Message.decode = function decode(reader) {
    return this.$type.decode(reader);
};
/**
 * Decodes a message of this type preceeded by its length as a varint.
 * @name Message.decodeDelimited
 * @function
 * @param {Reader|Uint8Array} reader Reader or buffer to decode
 * @returns {T} Decoded message
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $6d39cc6021b9ab53$var$Message.decodeDelimited = function decodeDelimited(reader) {
    return this.$type.decodeDelimited(reader);
};
/**
 * Verifies a message of this type.
 * @name Message.verify
 * @function
 * @param {Object.<string,*>} message Plain object to verify
 * @returns {string|null} `null` if valid, otherwise the reason why it is not
 */ $6d39cc6021b9ab53$var$Message.verify = function verify(message) {
    return this.$type.verify(message);
};
/**
 * Creates a new message of this type from a plain object. Also converts values to their respective internal types.
 * @param {Object.<string,*>} object Plain object
 * @returns {T} Message instance
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $6d39cc6021b9ab53$var$Message.fromObject = function fromObject(object) {
    return this.$type.fromObject(object);
};
/**
 * Creates a plain object from a message of this type. Also converts values to other types if specified.
 * @param {T} message Message instance
 * @param {IConversionOptions} [options] Conversion options
 * @returns {Object.<string,*>} Plain object
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $6d39cc6021b9ab53$var$Message.toObject = function toObject(message, options) {
    return this.$type.toObject(message, options);
};
/**
 * Converts this message to JSON.
 * @returns {Object.<string,*>} JSON object
 */ $6d39cc6021b9ab53$var$Message.prototype.toJSON = function toJSON() {
    return this.$type.toObject(this, $9920C.toJSONOptions);
}; /*eslint-enable valid-jsdoc*/ 

});

parcelRegister("03zCF", function(module, exports) {
"use strict";
module.exports = $00abe9de259ff019$var$decoder;

var $l9EYs = parcelRequire("l9EYs");

var $hyVJi = parcelRequire("hyVJi");

var $1C5z4 = parcelRequire("1C5z4");
function $00abe9de259ff019$var$missing(field) {
    return "missing required '" + field.name + "'";
}
/**
 * Generates a decoder specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ function $00abe9de259ff019$var$decoder(mtype) {
    /* eslint-disable no-unexpected-multiline */ var gen = $1C5z4.codegen([
        "r",
        "l"
    ], mtype.name + "$decode")("if(!(r instanceof Reader))")("r=Reader.create(r)")("var c=l===undefined?r.len:r.pos+l,m=new this.ctor" + (mtype.fieldsArray.filter(function(field) {
        return field.map;
    }).length ? ",k,value" : ""))("while(r.pos<c){")("var t=r.uint32()");
    if (mtype.group) gen("if((t&7)===4)")("break");
    gen("switch(t>>>3){");
    var i = 0;
    for(; i < /* initializes */ mtype.fieldsArray.length; ++i){
        var field = mtype._fieldsArray[i].resolve(), type = field.resolvedType instanceof $l9EYs ? "int32" : field.type, ref = "m" + $1C5z4.safeProp(field.name);
        gen("case %i: {", field.id);
        // Map fields
        if (field.map) {
            gen("if(%s===util.emptyObject)", ref)("%s={}", ref)("var c2 = r.uint32()+r.pos");
            if ($hyVJi.defaults[field.keyType] !== undefined) gen("k=%j", $hyVJi.defaults[field.keyType]);
            else gen("k=null");
            if ($hyVJi.defaults[type] !== undefined) gen("value=%j", $hyVJi.defaults[type]);
            else gen("value=null");
            gen("while(r.pos<c2){")("var tag2=r.uint32()")("switch(tag2>>>3){")("case 1: k=r.%s(); break", field.keyType)("case 2:");
            if ($hyVJi.basic[type] === undefined) gen("value=types[%i].decode(r,r.uint32())", i); // can't be groups
            else gen("value=r.%s()", type);
            gen("break")("default:")("r.skipType(tag2&7)")("break")("}")("}");
            if ($hyVJi.long[field.keyType] !== undefined) gen("%s[typeof k===\"object\"?util.longToHash(k):k]=value", ref);
            else gen("%s[k]=value", ref);
        // Repeated fields
        } else if (field.repeated) {
            gen("if(!(%s&&%s.length))", ref, ref)("%s=[]", ref);
            // Packable (always check for forward and backward compatiblity)
            if ($hyVJi.packed[type] !== undefined) gen("if((t&7)===2){")("var c2=r.uint32()+r.pos")("while(r.pos<c2)")("%s.push(r.%s())", ref, type)("}else");
            // Non-packed
            if ($hyVJi.basic[type] === undefined) gen(field.resolvedType.group ? "%s.push(types[%i].decode(r))" : "%s.push(types[%i].decode(r,r.uint32()))", ref, i);
            else gen("%s.push(r.%s())", ref, type);
        // Non-repeated
        } else if ($hyVJi.basic[type] === undefined) gen(field.resolvedType.group ? "%s=types[%i].decode(r)" : "%s=types[%i].decode(r,r.uint32())", ref, i);
        else gen("%s=r.%s()", ref, type);
        gen("break")("}");
    // Unknown fields
    }
    gen("default:")("r.skipType(t&7)")("break")("}")("}");
    // Field presence
    for(i = 0; i < mtype._fieldsArray.length; ++i){
        var rfield = mtype._fieldsArray[i];
        if (rfield.required) gen("if(!m.hasOwnProperty(%j))", rfield.name)("throw util.ProtocolError(%j,{instance:m})", $00abe9de259ff019$var$missing(rfield));
    }
    return gen("return m");
/* eslint-enable no-unexpected-multiline */ }

});

parcelRegister("8KWb1", function(module, exports) {
"use strict";
module.exports = $65ffbf4e3531df48$var$verifier;

var $l9EYs = parcelRequire("l9EYs");

var $1C5z4 = parcelRequire("1C5z4");
function $65ffbf4e3531df48$var$invalid(field, expected) {
    return field.name + ": " + expected + (field.repeated && expected !== "array" ? "[]" : field.map && expected !== "object" ? "{k:" + field.keyType + "}" : "") + " expected";
}
/**
 * Generates a partial value verifier.
 * @param {Codegen} gen Codegen instance
 * @param {Field} field Reflected field
 * @param {number} fieldIndex Field index
 * @param {string} ref Variable reference
 * @returns {Codegen} Codegen instance
 * @ignore
 */ function $65ffbf4e3531df48$var$genVerifyValue(gen, field, fieldIndex, ref) {
    /* eslint-disable no-unexpected-multiline */ if (field.resolvedType) {
        if (field.resolvedType instanceof $l9EYs) {
            gen("switch(%s){", ref)("default:")("return%j", $65ffbf4e3531df48$var$invalid(field, "enum value"));
            for(var keys = Object.keys(field.resolvedType.values), j = 0; j < keys.length; ++j)gen("case %i:", field.resolvedType.values[keys[j]]);
            gen("break")("}");
        } else gen("{")("var e=types[%i].verify(%s);", fieldIndex, ref)("if(e)")("return%j+e", field.name + ".")("}");
    } else switch(field.type){
        case "int32":
        case "uint32":
        case "sint32":
        case "fixed32":
        case "sfixed32":
            gen("if(!util.isInteger(%s))", ref)("return%j", $65ffbf4e3531df48$var$invalid(field, "integer"));
            break;
        case "int64":
        case "uint64":
        case "sint64":
        case "fixed64":
        case "sfixed64":
            gen("if(!util.isInteger(%s)&&!(%s&&util.isInteger(%s.low)&&util.isInteger(%s.high)))", ref, ref, ref, ref)("return%j", $65ffbf4e3531df48$var$invalid(field, "integer|Long"));
            break;
        case "float":
        case "double":
            gen("if(typeof %s!==\"number\")", ref)("return%j", $65ffbf4e3531df48$var$invalid(field, "number"));
            break;
        case "bool":
            gen("if(typeof %s!==\"boolean\")", ref)("return%j", $65ffbf4e3531df48$var$invalid(field, "boolean"));
            break;
        case "string":
            gen("if(!util.isString(%s))", ref)("return%j", $65ffbf4e3531df48$var$invalid(field, "string"));
            break;
        case "bytes":
            gen("if(!(%s&&typeof %s.length===\"number\"||util.isString(%s)))", ref, ref, ref)("return%j", $65ffbf4e3531df48$var$invalid(field, "buffer"));
            break;
    }
    return gen;
/* eslint-enable no-unexpected-multiline */ }
/**
 * Generates a partial key verifier.
 * @param {Codegen} gen Codegen instance
 * @param {Field} field Reflected field
 * @param {string} ref Variable reference
 * @returns {Codegen} Codegen instance
 * @ignore
 */ function $65ffbf4e3531df48$var$genVerifyKey(gen, field, ref) {
    /* eslint-disable no-unexpected-multiline */ switch(field.keyType){
        case "int32":
        case "uint32":
        case "sint32":
        case "fixed32":
        case "sfixed32":
            gen("if(!util.key32Re.test(%s))", ref)("return%j", $65ffbf4e3531df48$var$invalid(field, "integer key"));
            break;
        case "int64":
        case "uint64":
        case "sint64":
        case "fixed64":
        case "sfixed64":
            gen("if(!util.key64Re.test(%s))", ref) // see comment above: x is ok, d is not
            ("return%j", $65ffbf4e3531df48$var$invalid(field, "integer|Long key"));
            break;
        case "bool":
            gen("if(!util.key2Re.test(%s))", ref)("return%j", $65ffbf4e3531df48$var$invalid(field, "boolean key"));
            break;
    }
    return gen;
/* eslint-enable no-unexpected-multiline */ }
/**
 * Generates a verifier specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ function $65ffbf4e3531df48$var$verifier(mtype) {
    /* eslint-disable no-unexpected-multiline */ var gen = $1C5z4.codegen([
        "m"
    ], mtype.name + "$verify")("if(typeof m!==\"object\"||m===null)")("return%j", "object expected");
    var oneofs = mtype.oneofsArray, seenFirstField = {};
    if (oneofs.length) gen("var p={}");
    for(var i = 0; i < /* initializes */ mtype.fieldsArray.length; ++i){
        var field = mtype._fieldsArray[i].resolve(), ref = "m" + $1C5z4.safeProp(field.name);
        if (field.optional) gen("if(%s!=null&&m.hasOwnProperty(%j)){", ref, field.name); // !== undefined && !== null
        // map fields
        if (field.map) {
            gen("if(!util.isObject(%s))", ref)("return%j", $65ffbf4e3531df48$var$invalid(field, "object"))("var k=Object.keys(%s)", ref)("for(var i=0;i<k.length;++i){");
            $65ffbf4e3531df48$var$genVerifyKey(gen, field, "k[i]");
            $65ffbf4e3531df48$var$genVerifyValue(gen, field, i, ref + "[k[i]]")("}");
        // repeated fields
        } else if (field.repeated) {
            gen("if(!Array.isArray(%s))", ref)("return%j", $65ffbf4e3531df48$var$invalid(field, "array"))("for(var i=0;i<%s.length;++i){", ref);
            $65ffbf4e3531df48$var$genVerifyValue(gen, field, i, ref + "[i]")("}");
        // required or present fields
        } else {
            if (field.partOf) {
                var oneofProp = $1C5z4.safeProp(field.partOf.name);
                if (seenFirstField[field.partOf.name] === 1) gen("if(p%s===1)", oneofProp)("return%j", field.partOf.name + ": multiple values");
                seenFirstField[field.partOf.name] = 1;
                gen("p%s=1", oneofProp);
            }
            $65ffbf4e3531df48$var$genVerifyValue(gen, field, i, ref);
        }
        if (field.optional) gen("}");
    }
    return gen("return null");
/* eslint-enable no-unexpected-multiline */ }

});

parcelRegister("elQct", function(module, exports) {
"use strict";
/**
 * Runtime message from/to plain object converters.
 * @namespace
 */ var $a72b84bbd179b2f7$var$converter = module.exports;

var $l9EYs = parcelRequire("l9EYs");

var $1C5z4 = parcelRequire("1C5z4");
/**
 * Generates a partial value fromObject conveter.
 * @param {Codegen} gen Codegen instance
 * @param {Field} field Reflected field
 * @param {number} fieldIndex Field index
 * @param {string} prop Property reference
 * @returns {Codegen} Codegen instance
 * @ignore
 */ function $a72b84bbd179b2f7$var$genValuePartial_fromObject(gen, field, fieldIndex, prop) {
    var defaultAlreadyEmitted = false;
    /* eslint-disable no-unexpected-multiline, block-scoped-var, no-redeclare */ if (field.resolvedType) {
        if (field.resolvedType instanceof $l9EYs) {
            gen("switch(d%s){", prop);
            for(var values = field.resolvedType.values, keys = Object.keys(values), i = 0; i < keys.length; ++i){
                // enum unknown values passthrough
                if (values[keys[i]] === field.typeDefault && !defaultAlreadyEmitted) {
                    gen("default:")("if(typeof(d%s)===\"number\"){m%s=d%s;break}", prop, prop, prop);
                    if (!field.repeated) gen // fallback to default value only for
                    ("break"); // for non-repeated fields, just ignore
                    defaultAlreadyEmitted = true;
                }
                gen("case%j:", keys[i])("case %i:", values[keys[i]])("m%s=%j", prop, values[keys[i]])("break");
            }
            gen("}");
        } else gen("if(typeof d%s!==\"object\")", prop)("throw TypeError(%j)", field.fullName + ": object expected")("m%s=types[%i].fromObject(d%s)", prop, fieldIndex, prop);
    } else {
        var isUnsigned = false;
        switch(field.type){
            case "double":
            case "float":
                gen("m%s=Number(d%s)", prop, prop); // also catches "NaN", "Infinity"
                break;
            case "uint32":
            case "fixed32":
                gen("m%s=d%s>>>0", prop, prop);
                break;
            case "int32":
            case "sint32":
            case "sfixed32":
                gen("m%s=d%s|0", prop, prop);
                break;
            case "uint64":
                isUnsigned = true;
            // eslint-disable-next-line no-fallthrough
            case "int64":
            case "sint64":
            case "fixed64":
            case "sfixed64":
                gen("if(util.Long)")("(m%s=util.Long.fromValue(d%s)).unsigned=%j", prop, prop, isUnsigned)("else if(typeof d%s===\"string\")", prop)("m%s=parseInt(d%s,10)", prop, prop)("else if(typeof d%s===\"number\")", prop)("m%s=d%s", prop, prop)("else if(typeof d%s===\"object\")", prop)("m%s=new util.LongBits(d%s.low>>>0,d%s.high>>>0).toNumber(%s)", prop, prop, prop, isUnsigned ? "true" : "");
                break;
            case "bytes":
                gen("if(typeof d%s===\"string\")", prop)("util.base64.decode(d%s,m%s=util.newBuffer(util.base64.length(d%s)),0)", prop, prop, prop)("else if(d%s.length >= 0)", prop)("m%s=d%s", prop, prop);
                break;
            case "string":
                gen("m%s=String(d%s)", prop, prop);
                break;
            case "bool":
                gen("m%s=Boolean(d%s)", prop, prop);
                break;
        }
    }
    return gen;
/* eslint-enable no-unexpected-multiline, block-scoped-var, no-redeclare */ }
/**
 * Generates a plain object to runtime message converter specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ $a72b84bbd179b2f7$var$converter.fromObject = function fromObject(mtype) {
    /* eslint-disable no-unexpected-multiline, block-scoped-var, no-redeclare */ var fields = mtype.fieldsArray;
    var gen = $1C5z4.codegen([
        "d"
    ], mtype.name + "$fromObject")("if(d instanceof this.ctor)")("return d");
    if (!fields.length) return gen("return new this.ctor");
    gen("var m=new this.ctor");
    for(var i = 0; i < fields.length; ++i){
        var field = fields[i].resolve(), prop = $1C5z4.safeProp(field.name);
        // Map fields
        if (field.map) {
            gen("if(d%s){", prop)("if(typeof d%s!==\"object\")", prop)("throw TypeError(%j)", field.fullName + ": object expected")("m%s={}", prop)("for(var ks=Object.keys(d%s),i=0;i<ks.length;++i){", prop);
            $a72b84bbd179b2f7$var$genValuePartial_fromObject(gen, field, /* not sorted */ i, prop + "[ks[i]]")("}")("}");
        // Repeated fields
        } else if (field.repeated) {
            gen("if(d%s){", prop)("if(!Array.isArray(d%s))", prop)("throw TypeError(%j)", field.fullName + ": array expected")("m%s=[]", prop)("for(var i=0;i<d%s.length;++i){", prop);
            $a72b84bbd179b2f7$var$genValuePartial_fromObject(gen, field, /* not sorted */ i, prop + "[i]")("}")("}");
        // Non-repeated fields
        } else {
            if (!(field.resolvedType instanceof $l9EYs)) gen // no need to test for null/undefined if an enum (uses switch)
            ("if(d%s!=null){", prop); // !== undefined && !== null
            $a72b84bbd179b2f7$var$genValuePartial_fromObject(gen, field, /* not sorted */ i, prop);
            if (!(field.resolvedType instanceof $l9EYs)) gen("}");
        }
    }
    return gen("return m");
/* eslint-enable no-unexpected-multiline, block-scoped-var, no-redeclare */ };
/**
 * Generates a partial value toObject converter.
 * @param {Codegen} gen Codegen instance
 * @param {Field} field Reflected field
 * @param {number} fieldIndex Field index
 * @param {string} prop Property reference
 * @returns {Codegen} Codegen instance
 * @ignore
 */ function $a72b84bbd179b2f7$var$genValuePartial_toObject(gen, field, fieldIndex, prop) {
    /* eslint-disable no-unexpected-multiline, block-scoped-var, no-redeclare */ if (field.resolvedType) {
        if (field.resolvedType instanceof $l9EYs) gen("d%s=o.enums===String?(types[%i].values[m%s]===undefined?m%s:types[%i].values[m%s]):m%s", prop, fieldIndex, prop, prop, fieldIndex, prop, prop);
        else gen("d%s=types[%i].toObject(m%s,o)", prop, fieldIndex, prop);
    } else {
        var isUnsigned = false;
        switch(field.type){
            case "double":
            case "float":
                gen("d%s=o.json&&!isFinite(m%s)?String(m%s):m%s", prop, prop, prop, prop);
                break;
            case "uint64":
                isUnsigned = true;
            // eslint-disable-next-line no-fallthrough
            case "int64":
            case "sint64":
            case "fixed64":
            case "sfixed64":
                gen("if(typeof m%s===\"number\")", prop)("d%s=o.longs===String?String(m%s):m%s", prop, prop, prop)("else") // Long-like
                ("d%s=o.longs===String?util.Long.prototype.toString.call(m%s):o.longs===Number?new util.LongBits(m%s.low>>>0,m%s.high>>>0).toNumber(%s):m%s", prop, prop, prop, prop, isUnsigned ? "true" : "", prop);
                break;
            case "bytes":
                gen("d%s=o.bytes===String?util.base64.encode(m%s,0,m%s.length):o.bytes===Array?Array.prototype.slice.call(m%s):m%s", prop, prop, prop, prop, prop);
                break;
            default:
                gen("d%s=m%s", prop, prop);
                break;
        }
    }
    return gen;
/* eslint-enable no-unexpected-multiline, block-scoped-var, no-redeclare */ }
/**
 * Generates a runtime message to plain object converter specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ $a72b84bbd179b2f7$var$converter.toObject = function toObject(mtype) {
    /* eslint-disable no-unexpected-multiline, block-scoped-var, no-redeclare */ var fields = mtype.fieldsArray.slice().sort($1C5z4.compareFieldsById);
    if (!fields.length) return $1C5z4.codegen()("return {}");
    var gen = $1C5z4.codegen([
        "m",
        "o"
    ], mtype.name + "$toObject")("if(!o)")("o={}")("var d={}");
    var repeatedFields = [], mapFields = [], normalFields = [], i = 0;
    for(; i < fields.length; ++i)if (!fields[i].partOf) (fields[i].resolve().repeated ? repeatedFields : fields[i].map ? mapFields : normalFields).push(fields[i]);
    if (repeatedFields.length) {
        gen("if(o.arrays||o.defaults){");
        for(i = 0; i < repeatedFields.length; ++i)gen("d%s=[]", $1C5z4.safeProp(repeatedFields[i].name));
        gen("}");
    }
    if (mapFields.length) {
        gen("if(o.objects||o.defaults){");
        for(i = 0; i < mapFields.length; ++i)gen("d%s={}", $1C5z4.safeProp(mapFields[i].name));
        gen("}");
    }
    if (normalFields.length) {
        gen("if(o.defaults){");
        for(i = 0; i < normalFields.length; ++i){
            var field = normalFields[i], prop = $1C5z4.safeProp(field.name);
            if (field.resolvedType instanceof $l9EYs) gen("d%s=o.enums===String?%j:%j", prop, field.resolvedType.valuesById[field.typeDefault], field.typeDefault);
            else if (field.long) gen("if(util.Long){")("var n=new util.Long(%i,%i,%j)", field.typeDefault.low, field.typeDefault.high, field.typeDefault.unsigned)("d%s=o.longs===String?n.toString():o.longs===Number?n.toNumber():n", prop)("}else")("d%s=o.longs===String?%j:%i", prop, field.typeDefault.toString(), field.typeDefault.toNumber());
            else if (field.bytes) {
                var arrayDefault = "[" + Array.prototype.slice.call(field.typeDefault).join(",") + "]";
                gen("if(o.bytes===String)d%s=%j", prop, String.fromCharCode.apply(String, field.typeDefault))("else{")("d%s=%s", prop, arrayDefault)("if(o.bytes!==Array)d%s=util.newBuffer(d%s)", prop, prop)("}");
            } else gen("d%s=%j", prop, field.typeDefault); // also messages (=null)
        }
        gen("}");
    }
    var hasKs2 = false;
    for(i = 0; i < fields.length; ++i){
        var field = fields[i], index = mtype._fieldsArray.indexOf(field), prop = $1C5z4.safeProp(field.name);
        if (field.map) {
            if (!hasKs2) {
                hasKs2 = true;
                gen("var ks2");
            }
            gen("if(m%s&&(ks2=Object.keys(m%s)).length){", prop, prop)("d%s={}", prop)("for(var j=0;j<ks2.length;++j){");
            $a72b84bbd179b2f7$var$genValuePartial_toObject(gen, field, /* sorted */ index, prop + "[ks2[j]]")("}");
        } else if (field.repeated) {
            gen("if(m%s&&m%s.length){", prop, prop)("d%s=[]", prop)("for(var j=0;j<m%s.length;++j){", prop);
            $a72b84bbd179b2f7$var$genValuePartial_toObject(gen, field, /* sorted */ index, prop + "[j]")("}");
        } else {
            gen("if(m%s!=null&&m.hasOwnProperty(%j)){", prop, field.name); // !== undefined && !== null
            $a72b84bbd179b2f7$var$genValuePartial_toObject(gen, field, /* sorted */ index, prop);
            if (field.partOf) gen("if(o.oneofs)")("d%s=%j", $1C5z4.safeProp(field.partOf.name), field.name);
        }
        gen("}");
    }
    return gen("return d");
/* eslint-enable no-unexpected-multiline, block-scoped-var, no-redeclare */ };

});

parcelRegister("d5RQG", function(module, exports) {
"use strict";
/**
 * Wrappers for common types.
 * @type {Object.<string,IWrapper>}
 * @const
 */ var $98858338f9c384ed$var$wrappers = module.exports;

var $9npbz = parcelRequire("9npbz");
/**
 * From object converter part of an {@link IWrapper}.
 * @typedef WrapperFromObjectConverter
 * @type {function}
 * @param {Object.<string,*>} object Plain object
 * @returns {Message<{}>} Message instance
 * @this Type
 */ /**
 * To object converter part of an {@link IWrapper}.
 * @typedef WrapperToObjectConverter
 * @type {function}
 * @param {Message<{}>} message Message instance
 * @param {IConversionOptions} [options] Conversion options
 * @returns {Object.<string,*>} Plain object
 * @this Type
 */ /**
 * Common type wrapper part of {@link wrappers}.
 * @interface IWrapper
 * @property {WrapperFromObjectConverter} [fromObject] From object converter
 * @property {WrapperToObjectConverter} [toObject] To object converter
 */ // Custom wrapper for Any
$98858338f9c384ed$var$wrappers[".google.protobuf.Any"] = {
    fromObject: function(object) {
        // unwrap value type if mapped
        if (object && object["@type"]) {
            // Only use fully qualified type name after the last '/'
            var name = object["@type"].substring(object["@type"].lastIndexOf("/") + 1);
            var type = this.lookup(name);
            /* istanbul ignore else */ if (type) {
                // type_url does not accept leading "."
                var type_url = object["@type"].charAt(0) === "." ? object["@type"].slice(1) : object["@type"];
                // type_url prefix is optional, but path seperator is required
                if (type_url.indexOf("/") === -1) type_url = "/" + type_url;
                return this.create({
                    type_url: type_url,
                    value: type.encode(type.fromObject(object)).finish()
                });
            }
        }
        return this.fromObject(object);
    },
    toObject: function(message, options) {
        // Default prefix
        var googleApi = "type.googleapis.com/";
        var prefix = "";
        var name = "";
        // decode value if requested and unmapped
        if (options && options.json && message.type_url && message.value) {
            // Only use fully qualified type name after the last '/'
            name = message.type_url.substring(message.type_url.lastIndexOf("/") + 1);
            // Separate the prefix used
            prefix = message.type_url.substring(0, message.type_url.lastIndexOf("/") + 1);
            var type = this.lookup(name);
            /* istanbul ignore else */ if (type) message = type.decode(message.value);
        }
        // wrap value if unmapped
        if (!(message instanceof this.ctor) && message instanceof $9npbz) {
            var object = message.$type.toObject(message, options);
            var messageName = message.$type.fullName[0] === "." ? message.$type.fullName.slice(1) : message.$type.fullName;
            // Default to type.googleapis.com prefix if no prefix is used
            if (prefix === "") prefix = googleApi;
            name = prefix + messageName;
            object["@type"] = name;
            return object;
        }
        return this.toObject(message, options);
    }
};

});


parcelRegister("fTkGs", function(module, exports) {
"use strict";
module.exports = $b91c097155c4fdb9$var$Root;

var $1nsZk = parcelRequire("1nsZk");
(($b91c097155c4fdb9$var$Root.prototype = Object.create($1nsZk.prototype)).constructor = $b91c097155c4fdb9$var$Root).className = "Root";

var $IbYAq = parcelRequire("IbYAq");

var $l9EYs = parcelRequire("l9EYs");

var $iMxDc = parcelRequire("iMxDc");

var $1C5z4 = parcelRequire("1C5z4");
var $b91c097155c4fdb9$var$Type, $b91c097155c4fdb9$var$parse, $b91c097155c4fdb9$var$common; // "
/**
 * Constructs a new root namespace instance.
 * @classdesc Root namespace wrapping all types, enums, services, sub-namespaces etc. that belong together.
 * @extends NamespaceBase
 * @constructor
 * @param {Object.<string,*>} [options] Top level options
 */ function $b91c097155c4fdb9$var$Root(options) {
    $1nsZk.call(this, "", options);
    /**
     * Deferred extension fields.
     * @type {Field[]}
     */ this.deferred = [];
    /**
     * Resolved file names of loaded files.
     * @type {string[]}
     */ this.files = [];
}
/**
 * Loads a namespace descriptor into a root namespace.
 * @param {INamespace} json Nameespace descriptor
 * @param {Root} [root] Root namespace, defaults to create a new one if omitted
 * @returns {Root} Root namespace
 */ $b91c097155c4fdb9$var$Root.fromJSON = function fromJSON(json, root) {
    if (!root) root = new $b91c097155c4fdb9$var$Root();
    if (json.options) root.setOptions(json.options);
    return root.addJSON(json.nested);
};
/**
 * Resolves the path of an imported file, relative to the importing origin.
 * This method exists so you can override it with your own logic in case your imports are scattered over multiple directories.
 * @function
 * @param {string} origin The file name of the importing file
 * @param {string} target The file name being imported
 * @returns {string|null} Resolved path to `target` or `null` to skip the file
 */ $b91c097155c4fdb9$var$Root.prototype.resolvePath = $1C5z4.path.resolve;
/**
 * Fetch content from file path or url
 * This method exists so you can override it with your own logic.
 * @function
 * @param {string} path File path or url
 * @param {FetchCallback} callback Callback function
 * @returns {undefined}
 */ $b91c097155c4fdb9$var$Root.prototype.fetch = $1C5z4.fetch;
// A symbol-like function to safely signal synchronous loading
/* istanbul ignore next */ function $b91c097155c4fdb9$var$SYNC() {} // eslint-disable-line no-empty-function
/**
 * Loads one or multiple .proto or preprocessed .json files into this root namespace and calls the callback.
 * @param {string|string[]} filename Names of one or multiple files to load
 * @param {IParseOptions} options Parse options
 * @param {LoadCallback} callback Callback function
 * @returns {undefined}
 */ $b91c097155c4fdb9$var$Root.prototype.load = function load(filename, options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = undefined;
    }
    var self = this;
    if (!callback) return $1C5z4.asPromise(load, self, filename, options);
    var sync = callback === $b91c097155c4fdb9$var$SYNC; // undocumented
    // Finishes loading by calling the callback (exactly once)
    function finish(err, root) {
        /* istanbul ignore if */ if (!callback) return;
        if (sync) throw err;
        var cb = callback;
        callback = null;
        cb(err, root);
    }
    // Bundled definition existence checking
    function getBundledFileName(filename) {
        var idx = filename.lastIndexOf("google/protobuf/");
        if (idx > -1) {
            var altname = filename.substring(idx);
            if (altname in $b91c097155c4fdb9$var$common) return altname;
        }
        return null;
    }
    // Processes a single file
    function process(filename, source) {
        try {
            if ($1C5z4.isString(source) && source.charAt(0) === "{") source = JSON.parse(source);
            if (!$1C5z4.isString(source)) self.setOptions(source.options).addJSON(source.nested);
            else {
                $b91c097155c4fdb9$var$parse.filename = filename;
                var parsed = $b91c097155c4fdb9$var$parse(source, self, options), resolved, i = 0;
                if (parsed.imports) {
                    for(; i < parsed.imports.length; ++i)if (resolved = getBundledFileName(parsed.imports[i]) || self.resolvePath(filename, parsed.imports[i])) fetch(resolved);
                }
                if (parsed.weakImports) {
                    for(i = 0; i < parsed.weakImports.length; ++i)if (resolved = getBundledFileName(parsed.weakImports[i]) || self.resolvePath(filename, parsed.weakImports[i])) fetch(resolved, true);
                }
            }
        } catch (err) {
            finish(err);
        }
        if (!sync && !queued) finish(null, self); // only once anyway
    }
    // Fetches a single file
    function fetch(filename, weak) {
        filename = getBundledFileName(filename) || filename;
        // Skip if already loaded / attempted
        if (self.files.indexOf(filename) > -1) return;
        self.files.push(filename);
        // Shortcut bundled definitions
        if (filename in $b91c097155c4fdb9$var$common) {
            if (sync) process(filename, $b91c097155c4fdb9$var$common[filename]);
            else {
                ++queued;
                setTimeout(function() {
                    --queued;
                    process(filename, $b91c097155c4fdb9$var$common[filename]);
                });
            }
            return;
        }
        // Otherwise fetch from disk or network
        if (sync) {
            var source;
            try {
                source = $1C5z4.fs.readFileSync(filename).toString("utf8");
            } catch (err) {
                if (!weak) finish(err);
                return;
            }
            process(filename, source);
        } else {
            ++queued;
            self.fetch(filename, function(err, source) {
                --queued;
                /* istanbul ignore if */ if (!callback) return; // terminated meanwhile
                if (err) {
                    /* istanbul ignore else */ if (!weak) finish(err);
                    else if (!queued) finish(null, self);
                    return;
                }
                process(filename, source);
            });
        }
    }
    var queued = 0;
    // Assembling the root namespace doesn't require working type
    // references anymore, so we can load everything in parallel
    if ($1C5z4.isString(filename)) filename = [
        filename
    ];
    for(var i = 0, resolved; i < filename.length; ++i)if (resolved = self.resolvePath("", filename[i])) fetch(resolved);
    if (sync) return self;
    if (!queued) finish(null, self);
    return undefined;
};
// function load(filename:string, options:IParseOptions, callback:LoadCallback):undefined
/**
 * Loads one or multiple .proto or preprocessed .json files into this root namespace and calls the callback.
 * @function Root#load
 * @param {string|string[]} filename Names of one or multiple files to load
 * @param {LoadCallback} callback Callback function
 * @returns {undefined}
 * @variation 2
 */ // function load(filename:string, callback:LoadCallback):undefined
/**
 * Loads one or multiple .proto or preprocessed .json files into this root namespace and returns a promise.
 * @function Root#load
 * @param {string|string[]} filename Names of one or multiple files to load
 * @param {IParseOptions} [options] Parse options. Defaults to {@link parse.defaults} when omitted.
 * @returns {Promise<Root>} Promise
 * @variation 3
 */ // function load(filename:string, [options:IParseOptions]):Promise<Root>
/**
 * Synchronously loads one or multiple .proto or preprocessed .json files into this root namespace (node only).
 * @function Root#loadSync
 * @param {string|string[]} filename Names of one or multiple files to load
 * @param {IParseOptions} [options] Parse options. Defaults to {@link parse.defaults} when omitted.
 * @returns {Root} Root namespace
 * @throws {Error} If synchronous fetching is not supported (i.e. in browsers) or if a file's syntax is invalid
 */ $b91c097155c4fdb9$var$Root.prototype.loadSync = function loadSync(filename, options) {
    if (!$1C5z4.isNode) throw Error("not supported");
    return this.load(filename, options, $b91c097155c4fdb9$var$SYNC);
};
/**
 * @override
 */ $b91c097155c4fdb9$var$Root.prototype.resolveAll = function resolveAll() {
    if (this.deferred.length) throw Error("unresolvable extensions: " + this.deferred.map(function(field) {
        return "'extend " + field.extend + "' in " + field.parent.fullName;
    }).join(", "));
    return $1nsZk.prototype.resolveAll.call(this);
};
// only uppercased (and thus conflict-free) children are exposed, see below
var $b91c097155c4fdb9$var$exposeRe = /^[A-Z]/;
/**
 * Handles a deferred declaring extension field by creating a sister field to represent it within its extended type.
 * @param {Root} root Root instance
 * @param {Field} field Declaring extension field witin the declaring type
 * @returns {boolean} `true` if successfully added to the extended type, `false` otherwise
 * @inner
 * @ignore
 */ function $b91c097155c4fdb9$var$tryHandleExtension(root, field) {
    var extendedType = field.parent.lookup(field.extend);
    if (extendedType) {
        var sisterField = new $IbYAq(field.fullName, field.id, field.type, field.rule, undefined, field.options);
        //do not allow to extend same field twice to prevent the error
        if (extendedType.get(sisterField.name)) return true;
        sisterField.declaringField = field;
        field.extensionField = sisterField;
        extendedType.add(sisterField);
        return true;
    }
    return false;
}
/**
 * Called when any object is added to this root or its sub-namespaces.
 * @param {ReflectionObject} object Object added
 * @returns {undefined}
 * @private
 */ $b91c097155c4fdb9$var$Root.prototype._handleAdd = function _handleAdd(object) {
    if (object instanceof $IbYAq) {
        if (/* an extension field (implies not part of a oneof) */ object.extend !== undefined && /* not already handled */ !object.extensionField) {
            if (!$b91c097155c4fdb9$var$tryHandleExtension(this, object)) this.deferred.push(object);
        }
    } else if (object instanceof $l9EYs) {
        if ($b91c097155c4fdb9$var$exposeRe.test(object.name)) object.parent[object.name] = object.values; // expose enum values as property of its parent
    } else if (!(object instanceof $iMxDc)) /* everything else is a namespace */ {
        if (object instanceof $b91c097155c4fdb9$var$Type) for(var i = 0; i < this.deferred.length;)if ($b91c097155c4fdb9$var$tryHandleExtension(this, this.deferred[i])) this.deferred.splice(i, 1);
        else ++i;
        for(var j = 0; j < /* initializes */ object.nestedArray.length; ++j)this._handleAdd(object._nestedArray[j]);
        if ($b91c097155c4fdb9$var$exposeRe.test(object.name)) object.parent[object.name] = object; // expose namespace as property of its parent
    }
// The above also adds uppercased (and thus conflict-free) nested types, services and enums as
// properties of namespaces just like static code does. This allows using a .d.ts generated for
// a static module with reflection-based solutions where the condition is met.
};
/**
 * Called when any object is removed from this root or its sub-namespaces.
 * @param {ReflectionObject} object Object removed
 * @returns {undefined}
 * @private
 */ $b91c097155c4fdb9$var$Root.prototype._handleRemove = function _handleRemove(object) {
    if (object instanceof $IbYAq) {
        if (/* an extension field */ object.extend !== undefined) {
            if (/* already handled */ object.extensionField) {
                object.extensionField.parent.remove(object.extensionField);
                object.extensionField = null;
            } else {
                var index = this.deferred.indexOf(object);
                /* istanbul ignore else */ if (index > -1) this.deferred.splice(index, 1);
            }
        }
    } else if (object instanceof $l9EYs) {
        if ($b91c097155c4fdb9$var$exposeRe.test(object.name)) delete object.parent[object.name]; // unexpose enum values
    } else if (object instanceof $1nsZk) {
        for(var i = 0; i < /* initializes */ object.nestedArray.length; ++i)this._handleRemove(object._nestedArray[i]);
        if ($b91c097155c4fdb9$var$exposeRe.test(object.name)) delete object.parent[object.name]; // unexpose namespaces
    }
};
// Sets up cyclic dependencies (called in index-light)
$b91c097155c4fdb9$var$Root._configure = function(Type_, parse_, common_) {
    $b91c097155c4fdb9$var$Type = Type_;
    $b91c097155c4fdb9$var$parse = parse_;
    $b91c097155c4fdb9$var$common = common_;
};

});






parcelRegister("1gmIw", function(module, exports) {
"use strict";
module.exports = $0eb8e83718493c46$var$tokenize;
var $0eb8e83718493c46$var$delimRe = /[\s{}=;:[\],'"()<>]/g, $0eb8e83718493c46$var$stringDoubleRe = /(?:"([^"\\]*(?:\\.[^"\\]*)*)")/g, $0eb8e83718493c46$var$stringSingleRe = /(?:'([^'\\]*(?:\\.[^'\\]*)*)')/g;
var $0eb8e83718493c46$var$setCommentRe = /^ *[*/]+ */, $0eb8e83718493c46$var$setCommentAltRe = /^\s*\*?\/*/, $0eb8e83718493c46$var$setCommentSplitRe = /\n/g, $0eb8e83718493c46$var$whitespaceRe = /\s/, $0eb8e83718493c46$var$unescapeRe = /\\(.?)/g;
var $0eb8e83718493c46$var$unescapeMap = {
    "0": "\0",
    "r": "\r",
    "n": "\n",
    "t": "\t"
};
/**
 * Unescapes a string.
 * @param {string} str String to unescape
 * @returns {string} Unescaped string
 * @property {Object.<string,string>} map Special characters map
 * @memberof tokenize
 */ function $0eb8e83718493c46$var$unescape(str) {
    return str.replace($0eb8e83718493c46$var$unescapeRe, function($0, $1) {
        switch($1){
            case "\\":
            case "":
                return $1;
            default:
                return $0eb8e83718493c46$var$unescapeMap[$1] || "";
        }
    });
}
$0eb8e83718493c46$var$tokenize.unescape = $0eb8e83718493c46$var$unescape;
/**
 * Gets the next token and advances.
 * @typedef TokenizerHandleNext
 * @type {function}
 * @returns {string|null} Next token or `null` on eof
 */ /**
 * Peeks for the next token.
 * @typedef TokenizerHandlePeek
 * @type {function}
 * @returns {string|null} Next token or `null` on eof
 */ /**
 * Pushes a token back to the stack.
 * @typedef TokenizerHandlePush
 * @type {function}
 * @param {string} token Token
 * @returns {undefined}
 */ /**
 * Skips the next token.
 * @typedef TokenizerHandleSkip
 * @type {function}
 * @param {string} expected Expected token
 * @param {boolean} [optional=false] If optional
 * @returns {boolean} Whether the token matched
 * @throws {Error} If the token didn't match and is not optional
 */ /**
 * Gets the comment on the previous line or, alternatively, the line comment on the specified line.
 * @typedef TokenizerHandleCmnt
 * @type {function}
 * @param {number} [line] Line number
 * @returns {string|null} Comment text or `null` if none
 */ /**
 * Handle object returned from {@link tokenize}.
 * @interface ITokenizerHandle
 * @property {TokenizerHandleNext} next Gets the next token and advances (`null` on eof)
 * @property {TokenizerHandlePeek} peek Peeks for the next token (`null` on eof)
 * @property {TokenizerHandlePush} push Pushes a token back to the stack
 * @property {TokenizerHandleSkip} skip Skips a token, returns its presence and advances or, if non-optional and not present, throws
 * @property {TokenizerHandleCmnt} cmnt Gets the comment on the previous line or the line comment on the specified line, if any
 * @property {number} line Current line number
 */ /**
 * Tokenizes the given .proto source and returns an object with useful utility functions.
 * @param {string} source Source contents
 * @param {boolean} alternateCommentMode Whether we should activate alternate comment parsing mode.
 * @returns {ITokenizerHandle} Tokenizer handle
 */ function $0eb8e83718493c46$var$tokenize(source, alternateCommentMode) {
    /* eslint-disable callback-return */ source = source.toString();
    var offset = 0, length = source.length, line = 1, lastCommentLine = 0, comments = {};
    var stack = [];
    var stringDelim = null;
    /* istanbul ignore next */ /**
     * Creates an error for illegal syntax.
     * @param {string} subject Subject
     * @returns {Error} Error created
     * @inner
     */ function illegal(subject) {
        return Error("illegal " + subject + " (line " + line + ")");
    }
    /**
     * Reads a string till its end.
     * @returns {string} String read
     * @inner
     */ function readString() {
        var re = stringDelim === "'" ? $0eb8e83718493c46$var$stringSingleRe : $0eb8e83718493c46$var$stringDoubleRe;
        re.lastIndex = offset - 1;
        var match = re.exec(source);
        if (!match) throw illegal("string");
        offset = re.lastIndex;
        push(stringDelim);
        stringDelim = null;
        return $0eb8e83718493c46$var$unescape(match[1]);
    }
    /**
     * Gets the character at `pos` within the source.
     * @param {number} pos Position
     * @returns {string} Character
     * @inner
     */ function charAt(pos) {
        return source.charAt(pos);
    }
    /**
     * Sets the current comment text.
     * @param {number} start Start offset
     * @param {number} end End offset
     * @param {boolean} isLeading set if a leading comment
     * @returns {undefined}
     * @inner
     */ function setComment(start, end, isLeading) {
        var comment = {
            type: source.charAt(start++),
            lineEmpty: false,
            leading: isLeading
        };
        var lookback;
        if (alternateCommentMode) lookback = 2; // alternate comment parsing: "//" or "/*"
        else lookback = 3; // "///" or "/**"
        var commentOffset = start - lookback, c;
        do if (--commentOffset < 0 || (c = source.charAt(commentOffset)) === "\n") {
            comment.lineEmpty = true;
            break;
        }
        while (c === " " || c === "\t");
        var lines = source.substring(start, end).split($0eb8e83718493c46$var$setCommentSplitRe);
        for(var i = 0; i < lines.length; ++i)lines[i] = lines[i].replace(alternateCommentMode ? $0eb8e83718493c46$var$setCommentAltRe : $0eb8e83718493c46$var$setCommentRe, "").trim();
        comment.text = lines.join("\n").trim();
        comments[line] = comment;
        lastCommentLine = line;
    }
    function isDoubleSlashCommentLine(startOffset) {
        var endOffset = findEndOfLine(startOffset);
        // see if remaining line matches comment pattern
        var lineText = source.substring(startOffset, endOffset);
        var isComment = /^\s*\/\//.test(lineText);
        return isComment;
    }
    function findEndOfLine(cursor) {
        // find end of cursor's line
        var endOffset = cursor;
        while(endOffset < length && charAt(endOffset) !== "\n")endOffset++;
        return endOffset;
    }
    /**
     * Obtains the next token.
     * @returns {string|null} Next token or `null` on eof
     * @inner
     */ function next() {
        if (stack.length > 0) return stack.shift();
        if (stringDelim) return readString();
        var repeat, prev, curr, start, isDoc, isLeadingComment = offset === 0;
        do {
            if (offset === length) return null;
            repeat = false;
            while($0eb8e83718493c46$var$whitespaceRe.test(curr = charAt(offset))){
                if (curr === "\n") {
                    isLeadingComment = true;
                    ++line;
                }
                if (++offset === length) return null;
            }
            if (charAt(offset) === "/") {
                if (++offset === length) throw illegal("comment");
                if (charAt(offset) === "/") {
                    if (!alternateCommentMode) {
                        // check for triple-slash comment
                        isDoc = charAt(start = offset + 1) === "/";
                        while(charAt(++offset) !== "\n"){
                            if (offset === length) return null;
                        }
                        ++offset;
                        if (isDoc) {
                            setComment(start, offset - 1, isLeadingComment);
                            // Trailing comment cannot not be multi-line,
                            // so leading comment state should be reset to handle potential next comments
                            isLeadingComment = true;
                        }
                        ++line;
                        repeat = true;
                    } else {
                        // check for double-slash comments, consolidating consecutive lines
                        start = offset;
                        isDoc = false;
                        if (isDoubleSlashCommentLine(offset - 1)) {
                            isDoc = true;
                            do {
                                offset = findEndOfLine(offset);
                                if (offset === length) break;
                                offset++;
                                if (!isLeadingComment) break;
                            }while (isDoubleSlashCommentLine(offset));
                        } else offset = Math.min(length, findEndOfLine(offset) + 1);
                        if (isDoc) {
                            setComment(start, offset, isLeadingComment);
                            isLeadingComment = true;
                        }
                        line++;
                        repeat = true;
                    }
                } else if ((curr = charAt(offset)) === "*") {
                    // check for /** (regular comment mode) or /* (alternate comment mode)
                    start = offset + 1;
                    isDoc = alternateCommentMode || charAt(start) === "*";
                    do {
                        if (curr === "\n") ++line;
                        if (++offset === length) throw illegal("comment");
                        prev = curr;
                        curr = charAt(offset);
                    }while (prev !== "*" || curr !== "/");
                    ++offset;
                    if (isDoc) {
                        setComment(start, offset - 2, isLeadingComment);
                        isLeadingComment = true;
                    }
                    repeat = true;
                } else return "/";
            }
        }while (repeat);
        // offset !== length if we got here
        var end = offset;
        $0eb8e83718493c46$var$delimRe.lastIndex = 0;
        var delim = $0eb8e83718493c46$var$delimRe.test(charAt(end++));
        if (!delim) while(end < length && !$0eb8e83718493c46$var$delimRe.test(charAt(end)))++end;
        var token = source.substring(offset, offset = end);
        if (token === "\"" || token === "'") stringDelim = token;
        return token;
    }
    /**
     * Pushes a token back to the stack.
     * @param {string} token Token
     * @returns {undefined}
     * @inner
     */ function push(token) {
        stack.push(token);
    }
    /**
     * Peeks for the next token.
     * @returns {string|null} Token or `null` on eof
     * @inner
     */ function peek() {
        if (!stack.length) {
            var token = next();
            if (token === null) return null;
            push(token);
        }
        return stack[0];
    }
    /**
     * Skips a token.
     * @param {string} expected Expected token
     * @param {boolean} [optional=false] Whether the token is optional
     * @returns {boolean} `true` when skipped, `false` if not
     * @throws {Error} When a required token is not present
     * @inner
     */ function skip(expected, optional) {
        var actual = peek(), equals = actual === expected;
        if (equals) {
            next();
            return true;
        }
        if (!optional) throw illegal("token '" + actual + "', '" + expected + "' expected");
        return false;
    }
    /**
     * Gets a comment.
     * @param {number} [trailingLine] Line number if looking for a trailing comment
     * @returns {string|null} Comment text
     * @inner
     */ function cmnt(trailingLine) {
        var ret = null;
        var comment;
        if (trailingLine === undefined) {
            comment = comments[line - 1];
            delete comments[line - 1];
            if (comment && (alternateCommentMode || comment.type === "*" || comment.lineEmpty)) ret = comment.leading ? comment.text : null;
        } else {
            /* istanbul ignore else */ if (lastCommentLine < trailingLine) peek();
            comment = comments[trailingLine];
            delete comments[trailingLine];
            if (comment && !comment.lineEmpty && (alternateCommentMode || comment.type === "/")) ret = comment.leading ? null : comment.text;
        }
        return ret;
    }
    return Object.defineProperty({
        next: next,
        peek: peek,
        push: push,
        skip: skip,
        cmnt: cmnt
    }, "line", {
        get: function() {
            return line;
        }
    });
/* eslint-enable callback-return */ }

});

parcelRegister("2HtwA", function(module, exports) {
"use strict";
module.exports = $1f767fdede2ad6f4$var$parse;
$1f767fdede2ad6f4$var$parse.filename = null;
$1f767fdede2ad6f4$var$parse.defaults = {
    keepCase: false
};

var $1gmIw = parcelRequire("1gmIw");

var $fTkGs = parcelRequire("fTkGs");

var $8zc9K = parcelRequire("8zc9K");

var $IbYAq = parcelRequire("IbYAq");

var $hI2Xk = parcelRequire("hI2Xk");

var $iMxDc = parcelRequire("iMxDc");

var $l9EYs = parcelRequire("l9EYs");

var $5Iewc = parcelRequire("5Iewc");

var $kgBOI = parcelRequire("kgBOI");

var $hyVJi = parcelRequire("hyVJi");

var $1C5z4 = parcelRequire("1C5z4");
var $1f767fdede2ad6f4$var$base10Re = /^[1-9][0-9]*$/, $1f767fdede2ad6f4$var$base10NegRe = /^-?[1-9][0-9]*$/, $1f767fdede2ad6f4$var$base16Re = /^0[x][0-9a-fA-F]+$/, $1f767fdede2ad6f4$var$base16NegRe = /^-?0[x][0-9a-fA-F]+$/, $1f767fdede2ad6f4$var$base8Re = /^0[0-7]+$/, $1f767fdede2ad6f4$var$base8NegRe = /^-?0[0-7]+$/, $1f767fdede2ad6f4$var$numberRe = /^(?![eE])[0-9]*(?:\.[0-9]*)?(?:[eE][+-]?[0-9]+)?$/, $1f767fdede2ad6f4$var$nameRe = /^[a-zA-Z_][a-zA-Z_0-9]*$/, $1f767fdede2ad6f4$var$typeRefRe = /^(?:\.?[a-zA-Z_][a-zA-Z_0-9]*)(?:\.[a-zA-Z_][a-zA-Z_0-9]*)*$/, $1f767fdede2ad6f4$var$fqTypeRefRe = /^(?:\.[a-zA-Z_][a-zA-Z_0-9]*)+$/;
/**
 * Result object returned from {@link parse}.
 * @interface IParserResult
 * @property {string|undefined} package Package name, if declared
 * @property {string[]|undefined} imports Imports, if any
 * @property {string[]|undefined} weakImports Weak imports, if any
 * @property {string|undefined} syntax Syntax, if specified (either `"proto2"` or `"proto3"`)
 * @property {Root} root Populated root instance
 */ /**
 * Options modifying the behavior of {@link parse}.
 * @interface IParseOptions
 * @property {boolean} [keepCase=false] Keeps field casing instead of converting to camel case
 * @property {boolean} [alternateCommentMode=false] Recognize double-slash comments in addition to doc-block comments.
 * @property {boolean} [preferTrailingComment=false] Use trailing comment when both leading comment and trailing comment exist.
 */ /**
 * Options modifying the behavior of JSON serialization.
 * @interface IToJSONOptions
 * @property {boolean} [keepComments=false] Serializes comments.
 */ /**
 * Parses the given .proto source and returns an object with the parsed contents.
 * @param {string} source Source contents
 * @param {Root} root Root to populate
 * @param {IParseOptions} [options] Parse options. Defaults to {@link parse.defaults} when omitted.
 * @returns {IParserResult} Parser result
 * @property {string} filename=null Currently processing file name for error reporting, if known
 * @property {IParseOptions} defaults Default {@link IParseOptions}
 */ function $1f767fdede2ad6f4$var$parse(source, root, options) {
    /* eslint-disable callback-return */ if (!(root instanceof $fTkGs)) {
        options = root;
        root = new $fTkGs();
    }
    if (!options) options = $1f767fdede2ad6f4$var$parse.defaults;
    var preferTrailingComment = options.preferTrailingComment || false;
    var tn = $1gmIw(source, options.alternateCommentMode || false), next = tn.next, push = tn.push, peek = tn.peek, skip = tn.skip, cmnt = tn.cmnt;
    var head = true, pkg, imports, weakImports, syntax, isProto3 = false;
    var ptr = root;
    var applyCase = options.keepCase ? function(name) {
        return name;
    } : $1C5z4.camelCase;
    /* istanbul ignore next */ function illegal(token, name, insideTryCatch) {
        var filename = $1f767fdede2ad6f4$var$parse.filename;
        if (!insideTryCatch) $1f767fdede2ad6f4$var$parse.filename = null;
        return Error("illegal " + (name || "token") + " '" + token + "' (" + (filename ? filename + ", " : "") + "line " + tn.line + ")");
    }
    function readString() {
        var values = [], token;
        do {
            /* istanbul ignore if */ if ((token = next()) !== "\"" && token !== "'") throw illegal(token);
            values.push(next());
            skip(token);
            token = peek();
        }while (token === "\"" || token === "'");
        return values.join("");
    }
    function readValue(acceptTypeRef) {
        var token = next();
        switch(token){
            case "'":
            case "\"":
                push(token);
                return readString();
            case "true":
            case "TRUE":
                return true;
            case "false":
            case "FALSE":
                return false;
        }
        try {
            return parseNumber(token, /* insideTryCatch */ true);
        } catch (e) {
            /* istanbul ignore else */ if (acceptTypeRef && $1f767fdede2ad6f4$var$typeRefRe.test(token)) return token;
            /* istanbul ignore next */ throw illegal(token, "value");
        }
    }
    function readRanges(target, acceptStrings) {
        var token, start;
        do if (acceptStrings && ((token = peek()) === "\"" || token === "'")) target.push(readString());
        else target.push([
            start = parseId(next()),
            skip("to", true) ? parseId(next()) : start
        ]);
        while (skip(",", true));
        var dummy = {
            options: undefined
        };
        dummy.setOption = function(name, value) {
            if (this.options === undefined) this.options = {};
            this.options[name] = value;
        };
        ifBlock(dummy, function parseRange_block(token) {
            /* istanbul ignore else */ if (token === "option") {
                parseOption(dummy, token); // skip
                skip(";");
            } else throw illegal(token);
        }, function parseRange_line() {
            parseInlineOptions(dummy); // skip
        });
    }
    function parseNumber(token, insideTryCatch) {
        var sign = 1;
        if (token.charAt(0) === "-") {
            sign = -1;
            token = token.substring(1);
        }
        switch(token){
            case "inf":
            case "INF":
            case "Inf":
                return sign * Infinity;
            case "nan":
            case "NAN":
            case "Nan":
            case "NaN":
                return NaN;
            case "0":
                return 0;
        }
        if ($1f767fdede2ad6f4$var$base10Re.test(token)) return sign * parseInt(token, 10);
        if ($1f767fdede2ad6f4$var$base16Re.test(token)) return sign * parseInt(token, 16);
        if ($1f767fdede2ad6f4$var$base8Re.test(token)) return sign * parseInt(token, 8);
        /* istanbul ignore else */ if ($1f767fdede2ad6f4$var$numberRe.test(token)) return sign * parseFloat(token);
        /* istanbul ignore next */ throw illegal(token, "number", insideTryCatch);
    }
    function parseId(token, acceptNegative) {
        switch(token){
            case "max":
            case "MAX":
            case "Max":
                return 536870911;
            case "0":
                return 0;
        }
        /* istanbul ignore if */ if (!acceptNegative && token.charAt(0) === "-") throw illegal(token, "id");
        if ($1f767fdede2ad6f4$var$base10NegRe.test(token)) return parseInt(token, 10);
        if ($1f767fdede2ad6f4$var$base16NegRe.test(token)) return parseInt(token, 16);
        /* istanbul ignore else */ if ($1f767fdede2ad6f4$var$base8NegRe.test(token)) return parseInt(token, 8);
        /* istanbul ignore next */ throw illegal(token, "id");
    }
    function parsePackage() {
        /* istanbul ignore if */ if (pkg !== undefined) throw illegal("package");
        pkg = next();
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$typeRefRe.test(pkg)) throw illegal(pkg, "name");
        ptr = ptr.define(pkg);
        skip(";");
    }
    function parseImport() {
        var token = peek();
        var whichImports;
        switch(token){
            case "weak":
                whichImports = weakImports || (weakImports = []);
                next();
                break;
            case "public":
                next();
            // eslint-disable-next-line no-fallthrough
            default:
                whichImports = imports || (imports = []);
                break;
        }
        token = readString();
        skip(";");
        whichImports.push(token);
    }
    function parseSyntax() {
        skip("=");
        syntax = readString();
        isProto3 = syntax === "proto3";
        /* istanbul ignore if */ if (!isProto3 && syntax !== "proto2") throw illegal(syntax, "syntax");
        // Syntax is needed to understand the meaning of the optional field rule
        // Otherwise the meaning is ambiguous between proto2 and proto3
        root.setOption("syntax", syntax);
        skip(";");
    }
    function parseCommon(parent, token) {
        switch(token){
            case "option":
                parseOption(parent, token);
                skip(";");
                return true;
            case "message":
                parseType(parent, token);
                return true;
            case "enum":
                parseEnum(parent, token);
                return true;
            case "service":
                parseService(parent, token);
                return true;
            case "extend":
                parseExtension(parent, token);
                return true;
        }
        return false;
    }
    function ifBlock(obj, fnIf, fnElse) {
        var trailingLine = tn.line;
        if (obj) {
            if (typeof obj.comment !== "string") obj.comment = cmnt(); // try block-type comment
            obj.filename = $1f767fdede2ad6f4$var$parse.filename;
        }
        if (skip("{", true)) {
            var token;
            while((token = next()) !== "}")fnIf(token);
            skip(";", true);
        } else {
            if (fnElse) fnElse();
            skip(";");
            if (obj && (typeof obj.comment !== "string" || preferTrailingComment)) obj.comment = cmnt(trailingLine) || obj.comment; // try line-type comment
        }
    }
    function parseType(parent, token) {
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$nameRe.test(token = next())) throw illegal(token, "type name");
        var type = new $8zc9K(token);
        ifBlock(type, function parseType_block(token) {
            if (parseCommon(type, token)) return;
            switch(token){
                case "map":
                    parseMapField(type, token);
                    break;
                case "required":
                case "repeated":
                    parseField(type, token);
                    break;
                case "optional":
                    /* istanbul ignore if */ if (isProto3) parseField(type, "proto3_optional");
                    else parseField(type, "optional");
                    break;
                case "oneof":
                    parseOneOf(type, token);
                    break;
                case "extensions":
                    readRanges(type.extensions || (type.extensions = []));
                    break;
                case "reserved":
                    readRanges(type.reserved || (type.reserved = []), true);
                    break;
                default:
                    /* istanbul ignore if */ if (!isProto3 || !$1f767fdede2ad6f4$var$typeRefRe.test(token)) throw illegal(token);
                    push(token);
                    parseField(type, "optional");
                    break;
            }
        });
        parent.add(type);
    }
    function parseField(parent, rule, extend) {
        var type = next();
        if (type === "group") {
            parseGroup(parent, rule);
            return;
        }
        // Type names can consume multiple tokens, in multiple variants:
        //    package.subpackage   field       tokens: "package.subpackage" [TYPE NAME ENDS HERE] "field"
        //    package . subpackage field       tokens: "package" "." "subpackage" [TYPE NAME ENDS HERE] "field"
        //    package.  subpackage field       tokens: "package." "subpackage" [TYPE NAME ENDS HERE] "field"
        //    package  .subpackage field       tokens: "package" ".subpackage" [TYPE NAME ENDS HERE] "field"
        // Keep reading tokens until we get a type name with no period at the end,
        // and the next token does not start with a period.
        while(type.endsWith(".") || peek().startsWith("."))type += next();
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$typeRefRe.test(type)) throw illegal(type, "type");
        var name = next();
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$nameRe.test(name)) throw illegal(name, "name");
        name = applyCase(name);
        skip("=");
        var field = new $IbYAq(name, parseId(next()), type, rule, extend);
        ifBlock(field, function parseField_block(token) {
            /* istanbul ignore else */ if (token === "option") {
                parseOption(field, token);
                skip(";");
            } else throw illegal(token);
        }, function parseField_line() {
            parseInlineOptions(field);
        });
        if (rule === "proto3_optional") {
            // for proto3 optional fields, we create a single-member Oneof to mimic "optional" behavior
            var oneof = new $iMxDc("_" + name);
            field.setOption("proto3_optional", true);
            oneof.add(field);
            parent.add(oneof);
        } else parent.add(field);
        // JSON defaults to packed=true if not set so we have to set packed=false explicity when
        // parsing proto2 descriptors without the option, where applicable. This must be done for
        // all known packable types and anything that could be an enum (= is not a basic type).
        if (!isProto3 && field.repeated && ($hyVJi.packed[type] !== undefined || $hyVJi.basic[type] === undefined)) field.setOption("packed", false, /* ifNotSet */ true);
    }
    function parseGroup(parent, rule) {
        var name = next();
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$nameRe.test(name)) throw illegal(name, "name");
        var fieldName = $1C5z4.lcFirst(name);
        if (name === fieldName) name = $1C5z4.ucFirst(name);
        skip("=");
        var id = parseId(next());
        var type = new $8zc9K(name);
        type.group = true;
        var field = new $IbYAq(fieldName, id, name, rule);
        field.filename = $1f767fdede2ad6f4$var$parse.filename;
        ifBlock(type, function parseGroup_block(token) {
            switch(token){
                case "option":
                    parseOption(type, token);
                    skip(";");
                    break;
                case "required":
                case "repeated":
                    parseField(type, token);
                    break;
                case "optional":
                    /* istanbul ignore if */ if (isProto3) parseField(type, "proto3_optional");
                    else parseField(type, "optional");
                    break;
                case "message":
                    parseType(type, token);
                    break;
                case "enum":
                    parseEnum(type, token);
                    break;
                /* istanbul ignore next */ default:
                    throw illegal(token); // there are no groups with proto3 semantics
            }
        });
        parent.add(type).add(field);
    }
    function parseMapField(parent) {
        skip("<");
        var keyType = next();
        /* istanbul ignore if */ if ($hyVJi.mapKey[keyType] === undefined) throw illegal(keyType, "type");
        skip(",");
        var valueType = next();
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$typeRefRe.test(valueType)) throw illegal(valueType, "type");
        skip(">");
        var name = next();
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$nameRe.test(name)) throw illegal(name, "name");
        skip("=");
        var field = new $hI2Xk(applyCase(name), parseId(next()), keyType, valueType);
        ifBlock(field, function parseMapField_block(token) {
            /* istanbul ignore else */ if (token === "option") {
                parseOption(field, token);
                skip(";");
            } else throw illegal(token);
        }, function parseMapField_line() {
            parseInlineOptions(field);
        });
        parent.add(field);
    }
    function parseOneOf(parent, token) {
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$nameRe.test(token = next())) throw illegal(token, "name");
        var oneof = new $iMxDc(applyCase(token));
        ifBlock(oneof, function parseOneOf_block(token) {
            if (token === "option") {
                parseOption(oneof, token);
                skip(";");
            } else {
                push(token);
                parseField(oneof, "optional");
            }
        });
        parent.add(oneof);
    }
    function parseEnum(parent, token) {
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$nameRe.test(token = next())) throw illegal(token, "name");
        var enm = new $l9EYs(token);
        ifBlock(enm, function parseEnum_block(token) {
            switch(token){
                case "option":
                    parseOption(enm, token);
                    skip(";");
                    break;
                case "reserved":
                    readRanges(enm.reserved || (enm.reserved = []), true);
                    break;
                default:
                    parseEnumValue(enm, token);
            }
        });
        parent.add(enm);
    }
    function parseEnumValue(parent, token) {
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$nameRe.test(token)) throw illegal(token, "name");
        skip("=");
        var value = parseId(next(), true), dummy = {
            options: undefined
        };
        dummy.setOption = function(name, value) {
            if (this.options === undefined) this.options = {};
            this.options[name] = value;
        };
        ifBlock(dummy, function parseEnumValue_block(token) {
            /* istanbul ignore else */ if (token === "option") {
                parseOption(dummy, token); // skip
                skip(";");
            } else throw illegal(token);
        }, function parseEnumValue_line() {
            parseInlineOptions(dummy); // skip
        });
        parent.add(token, value, dummy.comment, dummy.options);
    }
    function parseOption(parent, token) {
        var isCustom = skip("(", true);
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$typeRefRe.test(token = next())) throw illegal(token, "name");
        var name = token;
        var option = name;
        var propName;
        if (isCustom) {
            skip(")");
            name = "(" + name + ")";
            option = name;
            token = peek();
            if ($1f767fdede2ad6f4$var$fqTypeRefRe.test(token)) {
                propName = token.slice(1); //remove '.' before property name
                name += token;
                next();
            }
        }
        skip("=");
        var optionValue = parseOptionValue(parent, name);
        setParsedOption(parent, option, optionValue, propName);
    }
    function parseOptionValue(parent, name) {
        // { a: "foo" b { c: "bar" } }
        if (skip("{", true)) {
            var objectResult = {};
            while(!skip("}", true)){
                /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$nameRe.test(token = next())) throw illegal(token, "name");
                if (token === null) throw illegal(token, "end of input");
                var value;
                var propName = token;
                skip(":", true);
                if (peek() === "{") value = parseOptionValue(parent, name + "." + token);
                else if (peek() === "[") {
                    // option (my_option) = {
                    //     repeated_value: [ "foo", "bar" ]
                    // };
                    value = [];
                    var lastValue;
                    if (skip("[", true)) {
                        do {
                            lastValue = readValue(true);
                            value.push(lastValue);
                        }while (skip(",", true));
                        skip("]");
                        if (typeof lastValue !== "undefined") setOption(parent, name + "." + token, lastValue);
                    }
                } else {
                    value = readValue(true);
                    setOption(parent, name + "." + token, value);
                }
                var prevValue = objectResult[propName];
                if (prevValue) value = [].concat(prevValue).concat(value);
                objectResult[propName] = value;
                // Semicolons and commas can be optional
                skip(",", true);
                skip(";", true);
            }
            return objectResult;
        }
        var simpleValue = readValue(true);
        setOption(parent, name, simpleValue);
        return simpleValue;
    // Does not enforce a delimiter to be universal
    }
    function setOption(parent, name, value) {
        if (parent.setOption) parent.setOption(name, value);
    }
    function setParsedOption(parent, name, value, propName) {
        if (parent.setParsedOption) parent.setParsedOption(name, value, propName);
    }
    function parseInlineOptions(parent) {
        if (skip("[", true)) {
            do parseOption(parent, "option");
            while (skip(",", true));
            skip("]");
        }
        return parent;
    }
    function parseService(parent, token) {
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$nameRe.test(token = next())) throw illegal(token, "service name");
        var service = new $5Iewc(token);
        ifBlock(service, function parseService_block(token) {
            if (parseCommon(service, token)) return;
            /* istanbul ignore else */ if (token === "rpc") parseMethod(service, token);
            else throw illegal(token);
        });
        parent.add(service);
    }
    function parseMethod(parent, token) {
        // Get the comment of the preceding line now (if one exists) in case the
        // method is defined across multiple lines.
        var commentText = cmnt();
        var type = token;
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$nameRe.test(token = next())) throw illegal(token, "name");
        var name = token, requestType, requestStream, responseType, responseStream;
        skip("(");
        if (skip("stream", true)) requestStream = true;
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$typeRefRe.test(token = next())) throw illegal(token);
        requestType = token;
        skip(")");
        skip("returns");
        skip("(");
        if (skip("stream", true)) responseStream = true;
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$typeRefRe.test(token = next())) throw illegal(token);
        responseType = token;
        skip(")");
        var method = new $kgBOI(name, type, requestType, responseType, requestStream, responseStream);
        method.comment = commentText;
        ifBlock(method, function parseMethod_block(token) {
            /* istanbul ignore else */ if (token === "option") {
                parseOption(method, token);
                skip(";");
            } else throw illegal(token);
        });
        parent.add(method);
    }
    function parseExtension(parent, token) {
        /* istanbul ignore if */ if (!$1f767fdede2ad6f4$var$typeRefRe.test(token = next())) throw illegal(token, "reference");
        var reference = token;
        ifBlock(null, function parseExtension_block(token) {
            switch(token){
                case "required":
                case "repeated":
                    parseField(parent, token, reference);
                    break;
                case "optional":
                    /* istanbul ignore if */ if (isProto3) parseField(parent, "proto3_optional", reference);
                    else parseField(parent, "optional", reference);
                    break;
                default:
                    /* istanbul ignore if */ if (!isProto3 || !$1f767fdede2ad6f4$var$typeRefRe.test(token)) throw illegal(token);
                    push(token);
                    parseField(parent, "optional", reference);
                    break;
            }
        });
    }
    var token;
    while((token = next()) !== null)switch(token){
        case "package":
            /* istanbul ignore if */ if (!head) throw illegal(token);
            parsePackage();
            break;
        case "import":
            /* istanbul ignore if */ if (!head) throw illegal(token);
            parseImport();
            break;
        case "syntax":
            /* istanbul ignore if */ if (!head) throw illegal(token);
            parseSyntax();
            break;
        case "option":
            parseOption(ptr, token);
            skip(";");
            break;
        default:
            /* istanbul ignore else */ if (parseCommon(ptr, token)) {
                head = false;
                continue;
            }
            /* istanbul ignore next */ throw illegal(token);
    }
    $1f767fdede2ad6f4$var$parse.filename = null;
    return {
        "package": pkg,
        "imports": imports,
        weakImports: weakImports,
        syntax: syntax,
        root: root
    };
} /**
 * Parses the given .proto source and returns an object with the parsed contents.
 * @name parse
 * @function
 * @param {string} source Source contents
 * @param {IParseOptions} [options] Parse options. Defaults to {@link parse.defaults} when omitted.
 * @returns {IParserResult} Parser result
 * @property {string} filename=null Currently processing file name for error reporting, if known
 * @property {IParseOptions} defaults Default {@link IParseOptions}
 * @variation 2
 */ 

});

parcelRegister("iKJSX", function(module, exports) {
"use strict";
module.exports = $da701dc720189400$var$common;
var $da701dc720189400$var$commonRe = /\/|\./;
/**
 * Provides common type definitions.
 * Can also be used to provide additional google types or your own custom types.
 * @param {string} name Short name as in `google/protobuf/[name].proto` or full file name
 * @param {Object.<string,*>} json JSON definition within `google.protobuf` if a short name, otherwise the file's root definition
 * @returns {undefined}
 * @property {INamespace} google/protobuf/any.proto Any
 * @property {INamespace} google/protobuf/duration.proto Duration
 * @property {INamespace} google/protobuf/empty.proto Empty
 * @property {INamespace} google/protobuf/field_mask.proto FieldMask
 * @property {INamespace} google/protobuf/struct.proto Struct, Value, NullValue and ListValue
 * @property {INamespace} google/protobuf/timestamp.proto Timestamp
 * @property {INamespace} google/protobuf/wrappers.proto Wrappers
 * @example
 * // manually provides descriptor.proto (assumes google/protobuf/ namespace and .proto extension)
 * protobuf.common("descriptor", descriptorJson);
 *
 * // manually provides a custom definition (uses my.foo namespace)
 * protobuf.common("my/foo/bar.proto", myFooBarJson);
 */ function $da701dc720189400$var$common(name, json) {
    if (!$da701dc720189400$var$commonRe.test(name)) {
        name = "google/protobuf/" + name + ".proto";
        json = {
            nested: {
                google: {
                    nested: {
                        protobuf: {
                            nested: json
                        }
                    }
                }
            }
        };
    }
    $da701dc720189400$var$common[name] = json;
}
// Not provided because of limited use (feel free to discuss or to provide yourself):
//
// google/protobuf/descriptor.proto
// google/protobuf/source_context.proto
// google/protobuf/type.proto
//
// Stripped and pre-parsed versions of these non-bundled files are instead available as part of
// the repository or package within the google/protobuf directory.
$da701dc720189400$var$common("any", {
    /**
     * Properties of a google.protobuf.Any message.
     * @interface IAny
     * @type {Object}
     * @property {string} [typeUrl]
     * @property {Uint8Array} [bytes]
     * @memberof common
     */ Any: {
        fields: {
            type_url: {
                type: "string",
                id: 1
            },
            value: {
                type: "bytes",
                id: 2
            }
        }
    }
});
var $da701dc720189400$var$timeType;
$da701dc720189400$var$common("duration", {
    /**
     * Properties of a google.protobuf.Duration message.
     * @interface IDuration
     * @type {Object}
     * @property {number|Long} [seconds]
     * @property {number} [nanos]
     * @memberof common
     */ Duration: $da701dc720189400$var$timeType = {
        fields: {
            seconds: {
                type: "int64",
                id: 1
            },
            nanos: {
                type: "int32",
                id: 2
            }
        }
    }
});
$da701dc720189400$var$common("timestamp", {
    /**
     * Properties of a google.protobuf.Timestamp message.
     * @interface ITimestamp
     * @type {Object}
     * @property {number|Long} [seconds]
     * @property {number} [nanos]
     * @memberof common
     */ Timestamp: $da701dc720189400$var$timeType
});
$da701dc720189400$var$common("empty", {
    /**
     * Properties of a google.protobuf.Empty message.
     * @interface IEmpty
     * @memberof common
     */ Empty: {
        fields: {}
    }
});
$da701dc720189400$var$common("struct", {
    /**
     * Properties of a google.protobuf.Struct message.
     * @interface IStruct
     * @type {Object}
     * @property {Object.<string,IValue>} [fields]
     * @memberof common
     */ Struct: {
        fields: {
            fields: {
                keyType: "string",
                type: "Value",
                id: 1
            }
        }
    },
    /**
     * Properties of a google.protobuf.Value message.
     * @interface IValue
     * @type {Object}
     * @property {string} [kind]
     * @property {0} [nullValue]
     * @property {number} [numberValue]
     * @property {string} [stringValue]
     * @property {boolean} [boolValue]
     * @property {IStruct} [structValue]
     * @property {IListValue} [listValue]
     * @memberof common
     */ Value: {
        oneofs: {
            kind: {
                oneof: [
                    "nullValue",
                    "numberValue",
                    "stringValue",
                    "boolValue",
                    "structValue",
                    "listValue"
                ]
            }
        },
        fields: {
            nullValue: {
                type: "NullValue",
                id: 1
            },
            numberValue: {
                type: "double",
                id: 2
            },
            stringValue: {
                type: "string",
                id: 3
            },
            boolValue: {
                type: "bool",
                id: 4
            },
            structValue: {
                type: "Struct",
                id: 5
            },
            listValue: {
                type: "ListValue",
                id: 6
            }
        }
    },
    NullValue: {
        values: {
            NULL_VALUE: 0
        }
    },
    /**
     * Properties of a google.protobuf.ListValue message.
     * @interface IListValue
     * @type {Object}
     * @property {Array.<IValue>} [values]
     * @memberof common
     */ ListValue: {
        fields: {
            values: {
                rule: "repeated",
                type: "Value",
                id: 1
            }
        }
    }
});
$da701dc720189400$var$common("wrappers", {
    /**
     * Properties of a google.protobuf.DoubleValue message.
     * @interface IDoubleValue
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */ DoubleValue: {
        fields: {
            value: {
                type: "double",
                id: 1
            }
        }
    },
    /**
     * Properties of a google.protobuf.FloatValue message.
     * @interface IFloatValue
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */ FloatValue: {
        fields: {
            value: {
                type: "float",
                id: 1
            }
        }
    },
    /**
     * Properties of a google.protobuf.Int64Value message.
     * @interface IInt64Value
     * @type {Object}
     * @property {number|Long} [value]
     * @memberof common
     */ Int64Value: {
        fields: {
            value: {
                type: "int64",
                id: 1
            }
        }
    },
    /**
     * Properties of a google.protobuf.UInt64Value message.
     * @interface IUInt64Value
     * @type {Object}
     * @property {number|Long} [value]
     * @memberof common
     */ UInt64Value: {
        fields: {
            value: {
                type: "uint64",
                id: 1
            }
        }
    },
    /**
     * Properties of a google.protobuf.Int32Value message.
     * @interface IInt32Value
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */ Int32Value: {
        fields: {
            value: {
                type: "int32",
                id: 1
            }
        }
    },
    /**
     * Properties of a google.protobuf.UInt32Value message.
     * @interface IUInt32Value
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */ UInt32Value: {
        fields: {
            value: {
                type: "uint32",
                id: 1
            }
        }
    },
    /**
     * Properties of a google.protobuf.BoolValue message.
     * @interface IBoolValue
     * @type {Object}
     * @property {boolean} [value]
     * @memberof common
     */ BoolValue: {
        fields: {
            value: {
                type: "bool",
                id: 1
            }
        }
    },
    /**
     * Properties of a google.protobuf.StringValue message.
     * @interface IStringValue
     * @type {Object}
     * @property {string} [value]
     * @memberof common
     */ StringValue: {
        fields: {
            value: {
                type: "string",
                id: 1
            }
        }
    },
    /**
     * Properties of a google.protobuf.BytesValue message.
     * @interface IBytesValue
     * @type {Object}
     * @property {Uint8Array} [value]
     * @memberof common
     */ BytesValue: {
        fields: {
            value: {
                type: "bytes",
                id: 1
            }
        }
    }
});
$da701dc720189400$var$common("field_mask", {
    /**
     * Properties of a google.protobuf.FieldMask message.
     * @interface IDoubleValue
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */ FieldMask: {
        fields: {
            paths: {
                rule: "repeated",
                type: "string",
                id: 1
            }
        }
    }
});
/**
 * Gets the root definition of the specified common proto file.
 *
 * Bundled definitions are:
 * - google/protobuf/any.proto
 * - google/protobuf/duration.proto
 * - google/protobuf/empty.proto
 * - google/protobuf/field_mask.proto
 * - google/protobuf/struct.proto
 * - google/protobuf/timestamp.proto
 * - google/protobuf/wrappers.proto
 *
 * @param {string} file Proto file name
 * @returns {INamespace|null} Root definition or `null` if not defined
 */ $da701dc720189400$var$common.get = function get(file) {
    return $da701dc720189400$var$common[file] || null;
};

});


parcelRegister("1hWVY", function(module, exports) {

//! moment-timezone.js
//! version : 0.5.39
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone
(function(root, factory) {
    "use strict";
    /*global define*/ if (0, module.exports) module.exports = factory((parcelRequire("6Sgv0"))); // Node
    else if (typeof define === 'function' && define.amd) define([
        'moment'
    ], factory); // AMD
    else factory(root.moment); // Browser
})(module.exports, function(moment) {
    "use strict";
    // Resolves es6 module loading issue
    if (moment.version === undefined && moment.default) moment = moment.default;
    // Do not load moment-timezone a second time.
    // if (moment.tz !== undefined) {
    // 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
    // 	return moment;
    // }
    var VERSION = "0.5.39", zones = {}, links = {}, countries = {}, names = {}, guesses = {}, cachedGuess;
    if (!moment || typeof moment.version !== 'string') logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
    var momentVersion = moment.version.split('.'), major = +momentVersion[0], minor = +momentVersion[1];
    // Moment.js version check
    if (major < 2 || major === 2 && minor < 6) logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
    /************************************
		Unpacking
	************************************/ function charCodeToInt(charCode) {
        if (charCode > 96) return charCode - 87;
        else if (charCode > 64) return charCode - 29;
        return charCode - 48;
    }
    function unpackBase60(string) {
        var i = 0, parts = string.split('.'), whole = parts[0], fractional = parts[1] || '', multiplier = 1, num, out = 0, sign = 1;
        // handle negative numbers
        if (string.charCodeAt(0) === 45) {
            i = 1;
            sign = -1;
        }
        // handle digits before the decimal
        for(i; i < whole.length; i++){
            num = charCodeToInt(whole.charCodeAt(i));
            out = 60 * out + num;
        }
        // handle digits after the decimal
        for(i = 0; i < fractional.length; i++){
            multiplier = multiplier / 60;
            num = charCodeToInt(fractional.charCodeAt(i));
            out += num * multiplier;
        }
        return out * sign;
    }
    function arrayToInt(array) {
        for(var i = 0; i < array.length; i++)array[i] = unpackBase60(array[i]);
    }
    function intToUntil(array, length) {
        for(var i = 0; i < length; i++)array[i] = Math.round((array[i - 1] || 0) + array[i] * 60000); // minutes to milliseconds
        array[length - 1] = Infinity;
    }
    function mapIndices(source, indices) {
        var out = [], i;
        for(i = 0; i < indices.length; i++)out[i] = source[indices[i]];
        return out;
    }
    function unpack(string) {
        var data = string.split('|'), offsets = data[2].split(' '), indices = data[3].split(''), untils = data[4].split(' ');
        arrayToInt(offsets);
        arrayToInt(indices);
        arrayToInt(untils);
        intToUntil(untils, indices.length);
        return {
            name: data[0],
            abbrs: mapIndices(data[1].split(' '), indices),
            offsets: mapIndices(offsets, indices),
            untils: untils,
            population: data[5] | 0
        };
    }
    /************************************
		Zone object
	************************************/ function Zone(packedString) {
        if (packedString) this._set(unpack(packedString));
    }
    Zone.prototype = {
        _set: function(unpacked) {
            this.name = unpacked.name;
            this.abbrs = unpacked.abbrs;
            this.untils = unpacked.untils;
            this.offsets = unpacked.offsets;
            this.population = unpacked.population;
        },
        _index: function(timestamp) {
            var target = +timestamp, untils = this.untils, i;
            for(i = 0; i < untils.length; i++){
                if (target < untils[i]) return i;
            }
        },
        countries: function() {
            var zone_name = this.name;
            return Object.keys(countries).filter(function(country_code) {
                return countries[country_code].zones.indexOf(zone_name) !== -1;
            });
        },
        parse: function(timestamp) {
            var target = +timestamp, offsets = this.offsets, untils = this.untils, max = untils.length - 1, offset, offsetNext, offsetPrev, i;
            for(i = 0; i < max; i++){
                offset = offsets[i];
                offsetNext = offsets[i + 1];
                offsetPrev = offsets[i ? i - 1 : i];
                if (offset < offsetNext && tz.moveAmbiguousForward) offset = offsetNext;
                else if (offset > offsetPrev && tz.moveInvalidForward) offset = offsetPrev;
                if (target < untils[i] - offset * 60000) return offsets[i];
            }
            return offsets[max];
        },
        abbr: function(mom) {
            return this.abbrs[this._index(mom)];
        },
        offset: function(mom) {
            logError("zone.offset has been deprecated in favor of zone.utcOffset");
            return this.offsets[this._index(mom)];
        },
        utcOffset: function(mom) {
            return this.offsets[this._index(mom)];
        }
    };
    /************************************
		Country object
	************************************/ function Country(country_name, zone_names) {
        this.name = country_name;
        this.zones = zone_names;
    }
    /************************************
		Current Timezone
	************************************/ function OffsetAt(at) {
        var timeString = at.toTimeString();
        var abbr = timeString.match(/\([a-z ]+\)/i);
        if (abbr && abbr[0]) {
            // 17:56:31 GMT-0600 (CST)
            // 17:56:31 GMT-0600 (Central Standard Time)
            abbr = abbr[0].match(/[A-Z]/g);
            abbr = abbr ? abbr.join('') : undefined;
        } else {
            // 17:56:31 CST
            // 17:56:31 GMT+0800 (台北標準時間)
            abbr = timeString.match(/[A-Z]{3,5}/g);
            abbr = abbr ? abbr[0] : undefined;
        }
        if (abbr === 'GMT') abbr = undefined;
        this.at = +at;
        this.abbr = abbr;
        this.offset = at.getTimezoneOffset();
    }
    function ZoneScore(zone) {
        this.zone = zone;
        this.offsetScore = 0;
        this.abbrScore = 0;
    }
    ZoneScore.prototype.scoreOffsetAt = function(offsetAt) {
        this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
        if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) this.abbrScore++;
    };
    function findChange(low, high) {
        var mid, diff;
        while(diff = ((high.at - low.at) / 12e4 | 0) * 6e4){
            mid = new OffsetAt(new Date(low.at + diff));
            if (mid.offset === low.offset) low = mid;
            else high = mid;
        }
        return low;
    }
    function userOffsets() {
        var startYear = new Date().getFullYear() - 2, last = new OffsetAt(new Date(startYear, 0, 1)), offsets = [
            last
        ], change, next, i;
        for(i = 1; i < 48; i++){
            next = new OffsetAt(new Date(startYear, i, 1));
            if (next.offset !== last.offset) {
                change = findChange(last, next);
                offsets.push(change);
                offsets.push(new OffsetAt(new Date(change.at + 6e4)));
            }
            last = next;
        }
        for(i = 0; i < 4; i++){
            offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
            offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
        }
        return offsets;
    }
    function sortZoneScores(a, b) {
        if (a.offsetScore !== b.offsetScore) return a.offsetScore - b.offsetScore;
        if (a.abbrScore !== b.abbrScore) return a.abbrScore - b.abbrScore;
        if (a.zone.population !== b.zone.population) return b.zone.population - a.zone.population;
        return b.zone.name.localeCompare(a.zone.name);
    }
    function addToGuesses(name, offsets) {
        var i, offset;
        arrayToInt(offsets);
        for(i = 0; i < offsets.length; i++){
            offset = offsets[i];
            guesses[offset] = guesses[offset] || {};
            guesses[offset][name] = true;
        }
    }
    function guessesForUserOffsets(offsets) {
        var offsetsLength = offsets.length, filteredGuesses = {}, out = [], i, j, guessesOffset;
        for(i = 0; i < offsetsLength; i++){
            guessesOffset = guesses[offsets[i].offset] || {};
            for(j in guessesOffset)if (guessesOffset.hasOwnProperty(j)) filteredGuesses[j] = true;
        }
        for(i in filteredGuesses)if (filteredGuesses.hasOwnProperty(i)) out.push(names[i]);
        return out;
    }
    function rebuildGuess() {
        // use Intl API when available and returning valid time zone
        try {
            var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (intlName && intlName.length > 3) {
                var name = names[normalizeName(intlName)];
                if (name) return name;
                logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
            }
        } catch (e) {
        // Intl unavailable, fall back to manual guessing.
        }
        var offsets = userOffsets(), offsetsLength = offsets.length, guesses = guessesForUserOffsets(offsets), zoneScores = [], zoneScore, i, j;
        for(i = 0; i < guesses.length; i++){
            zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
            for(j = 0; j < offsetsLength; j++)zoneScore.scoreOffsetAt(offsets[j]);
            zoneScores.push(zoneScore);
        }
        zoneScores.sort(sortZoneScores);
        return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
    }
    function guess(ignoreCache) {
        if (!cachedGuess || ignoreCache) cachedGuess = rebuildGuess();
        return cachedGuess;
    }
    /************************************
		Global Methods
	************************************/ function normalizeName(name) {
        return (name || '').toLowerCase().replace(/\//g, '_');
    }
    function addZone(packed) {
        var i, name, split, normalized;
        if (typeof packed === "string") packed = [
            packed
        ];
        for(i = 0; i < packed.length; i++){
            split = packed[i].split('|');
            name = split[0];
            normalized = normalizeName(name);
            zones[normalized] = packed[i];
            names[normalized] = name;
            addToGuesses(normalized, split[2].split(' '));
        }
    }
    function getZone(name, caller) {
        name = normalizeName(name);
        var zone = zones[name];
        var link;
        if (zone instanceof Zone) return zone;
        if (typeof zone === 'string') {
            zone = new Zone(zone);
            zones[name] = zone;
            return zone;
        }
        // Pass getZone to prevent recursion more than 1 level deep
        if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
            zone = zones[name] = new Zone();
            zone._set(link);
            zone.name = names[name];
            return zone;
        }
        return null;
    }
    function getNames() {
        var i, out = [];
        for(i in names)if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) out.push(names[i]);
        return out.sort();
    }
    function getCountryNames() {
        return Object.keys(countries);
    }
    function addLink(aliases) {
        var i, alias, normal0, normal1;
        if (typeof aliases === "string") aliases = [
            aliases
        ];
        for(i = 0; i < aliases.length; i++){
            alias = aliases[i].split('|');
            normal0 = normalizeName(alias[0]);
            normal1 = normalizeName(alias[1]);
            links[normal0] = normal1;
            names[normal0] = alias[0];
            links[normal1] = normal0;
            names[normal1] = alias[1];
        }
    }
    function addCountries(data) {
        var i, country_code, country_zones, split;
        if (!data || !data.length) return;
        for(i = 0; i < data.length; i++){
            split = data[i].split('|');
            country_code = split[0].toUpperCase();
            country_zones = split[1].split(' ');
            countries[country_code] = new Country(country_code, country_zones);
        }
    }
    function getCountry(name) {
        name = name.toUpperCase();
        return countries[name] || null;
    }
    function zonesForCountry(country, with_offset) {
        country = getCountry(country);
        if (!country) return null;
        var zones = country.zones.sort();
        if (with_offset) return zones.map(function(zone_name) {
            var zone = getZone(zone_name);
            return {
                name: zone_name,
                offset: zone.utcOffset(new Date())
            };
        });
        return zones;
    }
    function loadData(data) {
        addZone(data.zones);
        addLink(data.links);
        addCountries(data.countries);
        tz.dataVersion = data.version;
    }
    function zoneExists(name) {
        if (!zoneExists.didShowError) {
            zoneExists.didShowError = true;
            logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
        }
        return !!getZone(name);
    }
    function needsOffset(m) {
        var isUnixTimestamp = m._f === 'X' || m._f === 'x';
        return !!(m._a && m._tzm === undefined && !isUnixTimestamp);
    }
    function logError(message) {
        if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    }
    /************************************
		moment.tz namespace
	************************************/ function tz(input) {
        var args = Array.prototype.slice.call(arguments, 0, -1), name = arguments[arguments.length - 1], zone = getZone(name), out = moment.utc.apply(null, args);
        if (zone && !moment.isMoment(input) && needsOffset(out)) out.add(zone.parse(out), 'minutes');
        out.tz(name);
        return out;
    }
    tz.version = VERSION;
    tz.dataVersion = '';
    tz._zones = zones;
    tz._links = links;
    tz._names = names;
    tz._countries = countries;
    tz.add = addZone;
    tz.link = addLink;
    tz.load = loadData;
    tz.zone = getZone;
    tz.zoneExists = zoneExists; // deprecated in 0.1.0
    tz.guess = guess;
    tz.names = getNames;
    tz.Zone = Zone;
    tz.unpack = unpack;
    tz.unpackBase60 = unpackBase60;
    tz.needsOffset = needsOffset;
    tz.moveInvalidForward = true;
    tz.moveAmbiguousForward = false;
    tz.countries = getCountryNames;
    tz.zonesForCountry = zonesForCountry;
    /************************************
		Interface with Moment.js
	************************************/ var fn = moment.fn;
    moment.tz = tz;
    moment.defaultZone = null;
    moment.updateOffset = function(mom, keepTime) {
        var zone = moment.defaultZone, offset;
        if (mom._z === undefined) {
            if (zone && needsOffset(mom) && !mom._isUTC) {
                mom._d = moment.utc(mom._a)._d;
                mom.utc().add(zone.parse(mom), 'minutes');
            }
            mom._z = zone;
        }
        if (mom._z) {
            offset = mom._z.utcOffset(mom);
            if (Math.abs(offset) < 16) offset = offset / 60;
            if (mom.utcOffset !== undefined) {
                var z = mom._z;
                mom.utcOffset(-offset, keepTime);
                mom._z = z;
            } else mom.zone(offset, keepTime);
        }
    };
    fn.tz = function(name, keepTime) {
        if (name) {
            if (typeof name !== 'string') throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
            this._z = getZone(name);
            if (this._z) moment.updateOffset(this, keepTime);
            else logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
            return this;
        }
        if (this._z) return this._z.name;
    };
    function abbrWrap(old) {
        return function() {
            if (this._z) return this._z.abbr(this);
            return old.call(this);
        };
    }
    function resetZoneWrap(old) {
        return function() {
            this._z = null;
            return old.apply(this, arguments);
        };
    }
    function resetZoneWrap2(old) {
        return function() {
            if (arguments.length > 0) this._z = null;
            return old.apply(this, arguments);
        };
    }
    fn.zoneName = abbrWrap(fn.zoneName);
    fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
    fn.utc = resetZoneWrap(fn.utc);
    fn.local = resetZoneWrap(fn.local);
    fn.utcOffset = resetZoneWrap2(fn.utcOffset);
    moment.tz.setDefault = function(name) {
        if (major < 2 || major === 2 && minor < 9) logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
        moment.defaultZone = name ? getZone(name) : null;
        return moment;
    };
    // Cloning a moment should include the _z property.
    var momentProperties = moment.momentProperties;
    if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
        // moment 2.8.1+
        momentProperties.push('_z');
        momentProperties.push('_a');
    } else if (momentProperties) // moment 2.7.0
    momentProperties._z = null;
    // INJECT DATA
    return moment;
});

});

parcelRegister("5zyFs", function(module, exports) {
module.exports = JSON.parse("{\"version\":\"2022f\",\"zones\":[\"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5\",\"Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5\",\"Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5\",\"Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6\",\"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4\",\"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5\",\"Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6\",\"Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5\",\"Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3\",\"Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4\",\"Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5\",\"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|\",\"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5\",\"Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5\",\"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5\",\"Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|\",\"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5\",\"Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5\",\"Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4\",\"America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326\",\"America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4\",\"America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5\",\"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4\",\"America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|\",\"America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|\",\"America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|\",\"America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|\",\"America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|\",\"America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|\",\"America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|\",\"America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|\",\"America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|\",\"America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|\",\"America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|\",\"America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|\",\"America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5\",\"America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5\",\"America/Bahia_Banderas|LMT MST CST MDT PST CDT|71 70 60 60 80 50|0121312141313131313131313131313131313152525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3\",\"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5\",\"America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4\",\"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5\",\"America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3\",\"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2\",\"America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 2en0|90e5\",\"America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4\",\"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2\",\"America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4\",\"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4\",\"America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5\",\"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3\",\"America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5\",\"America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4\",\"America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5\",\"America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5\",\"America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4\",\"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8\",\"America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3\",\"America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2\",\"America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5\",\"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5\",\"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5\",\"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3\",\"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5\",\"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5\",\"America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2\",\"America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5\",\"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3\",\"America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3\",\"America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2\",\"America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2\",\"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5\",\"America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5\",\"America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4\",\"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4\",\"America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5\",\"America/Hermosillo|LMT MST CST MDT PST|7n.Q 70 60 60 80|0121312141313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4\",\"America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|01212134121212121212121212121512121212121212121212125212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|01212134121212121212121212121212156565212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2\",\"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2\",\"America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4\",\"America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3\",\"America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5\",\"America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6\",\"America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6\",\"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4\",\"America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5\",\"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5\",\"America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4\",\"America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4\",\"America/Mazatlan|LMT MST CST MDT PST|75.E 70 60 60 80|0121312141313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4\",\"America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2\",\"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5\",\"America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2\",\"America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6\",\"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2\",\"America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3\",\"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5\",\"America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5\",\"America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5\",\"America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6\",\"America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2\",\"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2\",\"America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|012121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0|\",\"America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0|23e3\",\"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2\",\"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4\",\"America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5\",\"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4\",\"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4\",\"America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|\",\"America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4\",\"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2\",\"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5\",\"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4\",\"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229\",\"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4\",\"America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5\",\"America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5\",\"America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6\",\"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452\",\"America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2\",\"America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4\",\"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3\",\"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5\",\"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656\",\"America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5\",\"America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3\",\"America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642\",\"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3\",\"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10\",\"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70\",\"Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4\",\"Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1\",\"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60\",\"Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5\",\"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40\",\"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130\",\"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5\",\"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40\",\"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5\",\"Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5\",\"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5\",\"Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5\",\"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3\",\"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4\",\"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4\",\"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4\",\"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|\",\"Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5\",\"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4\",\"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5\",\"Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6\",\"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|\",\"Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5\",\"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4\",\"Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4\",\"Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6\",\"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4\",\"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3\",\"Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6\",\"Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5\",\"Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6\",\"Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5\",\"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4\",\"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5\",\"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4\",\"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|\",\"Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5\",\"Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4\",\"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5\",\"Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5\",\"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3\",\"Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4\",\"Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6\",\"Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6\",\"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4\",\"Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4\",\"Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5\",\"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4\",\"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6\",\"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5\",\"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2\",\"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5\",\"Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so1u|71e5\",\"Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4\",\"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3\",\"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5\",\"Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6\",\"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4\",\"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4\",\"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5\",\"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5\",\"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4\",\"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4\",\"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5\",\"Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|\",\"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4\",\"Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5\",\"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4\",\"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4\",\"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6\",\"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2\",\"Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5\",\"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5\",\"Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5\",\"Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 XA0 Wou JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6\",\"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3\",\"Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6\",\"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5\",\"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5\",\"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2\",\"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4\",\"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4\",\"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5\",\"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5\",\"Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4\",\"Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3\",\"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4\",\"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4\",\"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3\",\"Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4\",\"Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30\",\"Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2\",\"Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5\",\"Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5\",\"Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5\",\"Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3\",\"Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4\",\"Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4\",\"Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368\",\"Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347\",\"Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10\",\"Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5\",\"Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5\",\"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|\",\"Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2\",\"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|\",\"Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"EST|EST|50|0||\",\"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"Etc/GMT-0|GMT|0|0||\",\"Etc/GMT-1|+01|-10|0||\",\"Etc/GMT-10|+10|-a0|0||\",\"Etc/GMT-11|+11|-b0|0||\",\"Etc/GMT-12|+12|-c0|0||\",\"Etc/GMT-13|+13|-d0|0||\",\"Etc/GMT-14|+14|-e0|0||\",\"Etc/GMT-2|+02|-20|0||\",\"Etc/GMT-3|+03|-30|0||\",\"Etc/GMT-4|+04|-40|0||\",\"Etc/GMT-5|+05|-50|0||\",\"Etc/GMT-6|+06|-60|0||\",\"Etc/GMT-7|+07|-70|0||\",\"Etc/GMT-8|+08|-80|0||\",\"Etc/GMT-9|+09|-90|0||\",\"Etc/GMT+1|-01|10|0||\",\"Etc/GMT+10|-10|a0|0||\",\"Etc/GMT+11|-11|b0|0||\",\"Etc/GMT+12|-12|c0|0||\",\"Etc/GMT+2|-02|20|0||\",\"Etc/GMT+3|-03|30|0||\",\"Etc/GMT+4|-04|40|0||\",\"Etc/GMT+5|-05|50|0||\",\"Etc/GMT+6|-06|60|0||\",\"Etc/GMT+7|-07|70|0||\",\"Etc/GMT+8|-08|80|0||\",\"Etc/GMT+9|-09|90|0||\",\"Etc/UTC|UTC|0|0||\",\"Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5\",\"Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3\",\"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5\",\"Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5\",\"Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6\",\"Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5\",\"Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5\",\"Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5\",\"Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4\",\"Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4\",\"Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3\",\"Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4\",\"Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5\",\"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4\",\"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5\",\"Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5\",\"Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4\",\"Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5\",\"Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6\",\"Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6\",\"Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4\",\"Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5\",\"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5\",\"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|\",\"Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4\",\"Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4\",\"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4\",\"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5\",\"Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5\",\"Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4\",\"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5\",\"Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5\",\"HST|HST|a0|0||\",\"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2\",\"Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4\",\"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4\",\"Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3\",\"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|\",\"MST|MST|70|0||\",\"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600\",\"Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3\",\"Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4\",\"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3\",\"Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1\",\"Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483\",\"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4\",\"Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3\",\"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3\",\"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125\",\"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4\",\"Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4\",\"Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4\",\"Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2\",\"Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2\",\"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2\",\"Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2\",\"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3\",\"Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2\",\"Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4\",\"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3\",\"Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3\",\"Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56\",\"Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3\",\"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4\",\"Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3\",\"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|\"],\"links\":[\"Africa/Abidjan|Africa/Accra\",\"Africa/Abidjan|Africa/Bamako\",\"Africa/Abidjan|Africa/Banjul\",\"Africa/Abidjan|Africa/Conakry\",\"Africa/Abidjan|Africa/Dakar\",\"Africa/Abidjan|Africa/Freetown\",\"Africa/Abidjan|Africa/Lome\",\"Africa/Abidjan|Africa/Nouakchott\",\"Africa/Abidjan|Africa/Ouagadougou\",\"Africa/Abidjan|Africa/Timbuktu\",\"Africa/Abidjan|Atlantic/Reykjavik\",\"Africa/Abidjan|Atlantic/St_Helena\",\"Africa/Abidjan|Iceland\",\"Africa/Cairo|Egypt\",\"Africa/Johannesburg|Africa/Maseru\",\"Africa/Johannesburg|Africa/Mbabane\",\"Africa/Lagos|Africa/Bangui\",\"Africa/Lagos|Africa/Brazzaville\",\"Africa/Lagos|Africa/Douala\",\"Africa/Lagos|Africa/Kinshasa\",\"Africa/Lagos|Africa/Libreville\",\"Africa/Lagos|Africa/Luanda\",\"Africa/Lagos|Africa/Malabo\",\"Africa/Lagos|Africa/Niamey\",\"Africa/Lagos|Africa/Porto-Novo\",\"Africa/Maputo|Africa/Blantyre\",\"Africa/Maputo|Africa/Bujumbura\",\"Africa/Maputo|Africa/Gaborone\",\"Africa/Maputo|Africa/Harare\",\"Africa/Maputo|Africa/Kigali\",\"Africa/Maputo|Africa/Lubumbashi\",\"Africa/Maputo|Africa/Lusaka\",\"Africa/Nairobi|Africa/Addis_Ababa\",\"Africa/Nairobi|Africa/Asmara\",\"Africa/Nairobi|Africa/Asmera\",\"Africa/Nairobi|Africa/Dar_es_Salaam\",\"Africa/Nairobi|Africa/Djibouti\",\"Africa/Nairobi|Africa/Kampala\",\"Africa/Nairobi|Africa/Mogadishu\",\"Africa/Nairobi|Indian/Antananarivo\",\"Africa/Nairobi|Indian/Comoro\",\"Africa/Nairobi|Indian/Mayotte\",\"Africa/Tripoli|Libya\",\"America/Adak|America/Atka\",\"America/Adak|US/Aleutian\",\"America/Anchorage|US/Alaska\",\"America/Argentina/Buenos_Aires|America/Buenos_Aires\",\"America/Argentina/Catamarca|America/Argentina/ComodRivadavia\",\"America/Argentina/Catamarca|America/Catamarca\",\"America/Argentina/Cordoba|America/Cordoba\",\"America/Argentina/Cordoba|America/Rosario\",\"America/Argentina/Jujuy|America/Jujuy\",\"America/Argentina/Mendoza|America/Mendoza\",\"America/Chicago|US/Central\",\"America/Denver|America/Shiprock\",\"America/Denver|Navajo\",\"America/Denver|US/Mountain\",\"America/Detroit|US/Michigan\",\"America/Edmonton|Canada/Mountain\",\"America/Fort_Wayne|America/Indiana/Indianapolis\",\"America/Fort_Wayne|America/Indianapolis\",\"America/Fort_Wayne|US/East-Indiana\",\"America/Godthab|America/Nuuk\",\"America/Halifax|Canada/Atlantic\",\"America/Havana|Cuba\",\"America/Indiana/Knox|America/Knox_IN\",\"America/Indiana/Knox|US/Indiana-Starke\",\"America/Jamaica|Jamaica\",\"America/Kentucky/Louisville|America/Louisville\",\"America/Los_Angeles|US/Pacific\",\"America/Manaus|Brazil/West\",\"America/Mazatlan|Mexico/BajaSur\",\"America/Mexico_City|Mexico/General\",\"America/New_York|US/Eastern\",\"America/Noronha|Brazil/DeNoronha\",\"America/Panama|America/Atikokan\",\"America/Panama|America/Cayman\",\"America/Panama|America/Coral_Harbour\",\"America/Phoenix|America/Creston\",\"America/Phoenix|US/Arizona\",\"America/Puerto_Rico|America/Anguilla\",\"America/Puerto_Rico|America/Antigua\",\"America/Puerto_Rico|America/Aruba\",\"America/Puerto_Rico|America/Blanc-Sablon\",\"America/Puerto_Rico|America/Curacao\",\"America/Puerto_Rico|America/Dominica\",\"America/Puerto_Rico|America/Grenada\",\"America/Puerto_Rico|America/Guadeloupe\",\"America/Puerto_Rico|America/Kralendijk\",\"America/Puerto_Rico|America/Lower_Princes\",\"America/Puerto_Rico|America/Marigot\",\"America/Puerto_Rico|America/Montserrat\",\"America/Puerto_Rico|America/Port_of_Spain\",\"America/Puerto_Rico|America/St_Barthelemy\",\"America/Puerto_Rico|America/St_Kitts\",\"America/Puerto_Rico|America/St_Lucia\",\"America/Puerto_Rico|America/St_Thomas\",\"America/Puerto_Rico|America/St_Vincent\",\"America/Puerto_Rico|America/Tortola\",\"America/Puerto_Rico|America/Virgin\",\"America/Regina|Canada/Saskatchewan\",\"America/Rio_Branco|America/Porto_Acre\",\"America/Rio_Branco|Brazil/Acre\",\"America/Santiago|Chile/Continental\",\"America/Sao_Paulo|Brazil/East\",\"America/St_Johns|Canada/Newfoundland\",\"America/Tijuana|America/Ensenada\",\"America/Tijuana|America/Santa_Isabel\",\"America/Tijuana|Mexico/BajaNorte\",\"America/Toronto|America/Montreal\",\"America/Toronto|America/Nassau\",\"America/Toronto|America/Nipigon\",\"America/Toronto|America/Thunder_Bay\",\"America/Toronto|Canada/Eastern\",\"America/Vancouver|Canada/Pacific\",\"America/Whitehorse|Canada/Yukon\",\"America/Winnipeg|America/Rainy_River\",\"America/Winnipeg|Canada/Central\",\"Asia/Ashgabat|Asia/Ashkhabad\",\"Asia/Bangkok|Asia/Phnom_Penh\",\"Asia/Bangkok|Asia/Vientiane\",\"Asia/Bangkok|Indian/Christmas\",\"Asia/Brunei|Asia/Kuching\",\"Asia/Dhaka|Asia/Dacca\",\"Asia/Dubai|Asia/Muscat\",\"Asia/Dubai|Indian/Mahe\",\"Asia/Dubai|Indian/Reunion\",\"Asia/Ho_Chi_Minh|Asia/Saigon\",\"Asia/Hong_Kong|Hongkong\",\"Asia/Jerusalem|Asia/Tel_Aviv\",\"Asia/Jerusalem|Israel\",\"Asia/Kathmandu|Asia/Katmandu\",\"Asia/Kolkata|Asia/Calcutta\",\"Asia/Kuala_Lumpur|Asia/Singapore\",\"Asia/Kuala_Lumpur|Singapore\",\"Asia/Macau|Asia/Macao\",\"Asia/Makassar|Asia/Ujung_Pandang\",\"Asia/Nicosia|Europe/Nicosia\",\"Asia/Qatar|Asia/Bahrain\",\"Asia/Rangoon|Asia/Yangon\",\"Asia/Rangoon|Indian/Cocos\",\"Asia/Riyadh|Antarctica/Syowa\",\"Asia/Riyadh|Asia/Aden\",\"Asia/Riyadh|Asia/Kuwait\",\"Asia/Seoul|ROK\",\"Asia/Shanghai|Asia/Chongqing\",\"Asia/Shanghai|Asia/Chungking\",\"Asia/Shanghai|Asia/Harbin\",\"Asia/Shanghai|PRC\",\"Asia/Taipei|ROC\",\"Asia/Tehran|Iran\",\"Asia/Thimphu|Asia/Thimbu\",\"Asia/Tokyo|Japan\",\"Asia/Ulaanbaatar|Asia/Ulan_Bator\",\"Asia/Urumqi|Antarctica/Vostok\",\"Asia/Urumqi|Asia/Kashgar\",\"Atlantic/Faroe|Atlantic/Faeroe\",\"Australia/Adelaide|Australia/South\",\"Australia/Brisbane|Australia/Queensland\",\"Australia/Broken_Hill|Australia/Yancowinna\",\"Australia/Darwin|Australia/North\",\"Australia/Hobart|Australia/Currie\",\"Australia/Hobart|Australia/Tasmania\",\"Australia/Lord_Howe|Australia/LHI\",\"Australia/Melbourne|Australia/Victoria\",\"Australia/Perth|Australia/West\",\"Australia/Sydney|Australia/ACT\",\"Australia/Sydney|Australia/Canberra\",\"Australia/Sydney|Australia/NSW\",\"Etc/GMT-0|Etc/GMT\",\"Etc/GMT-0|Etc/GMT+0\",\"Etc/GMT-0|Etc/GMT0\",\"Etc/GMT-0|Etc/Greenwich\",\"Etc/GMT-0|GMT\",\"Etc/GMT-0|GMT+0\",\"Etc/GMT-0|GMT-0\",\"Etc/GMT-0|GMT0\",\"Etc/GMT-0|Greenwich\",\"Etc/UTC|Etc/UCT\",\"Etc/UTC|Etc/Universal\",\"Etc/UTC|Etc/Zulu\",\"Etc/UTC|UCT\",\"Etc/UTC|UTC\",\"Etc/UTC|Universal\",\"Etc/UTC|Zulu\",\"Europe/Belgrade|Europe/Ljubljana\",\"Europe/Belgrade|Europe/Podgorica\",\"Europe/Belgrade|Europe/Sarajevo\",\"Europe/Belgrade|Europe/Skopje\",\"Europe/Belgrade|Europe/Zagreb\",\"Europe/Berlin|Arctic/Longyearbyen\",\"Europe/Berlin|Atlantic/Jan_Mayen\",\"Europe/Berlin|Europe/Copenhagen\",\"Europe/Berlin|Europe/Oslo\",\"Europe/Berlin|Europe/Stockholm\",\"Europe/Brussels|Europe/Amsterdam\",\"Europe/Brussels|Europe/Luxembourg\",\"Europe/Chisinau|Europe/Tiraspol\",\"Europe/Dublin|Eire\",\"Europe/Helsinki|Europe/Mariehamn\",\"Europe/Istanbul|Asia/Istanbul\",\"Europe/Istanbul|Turkey\",\"Europe/Kiev|Europe/Kyiv\",\"Europe/Kiev|Europe/Uzhgorod\",\"Europe/Kiev|Europe/Zaporozhye\",\"Europe/Lisbon|Portugal\",\"Europe/London|Europe/Belfast\",\"Europe/London|Europe/Guernsey\",\"Europe/London|Europe/Isle_of_Man\",\"Europe/London|Europe/Jersey\",\"Europe/London|GB\",\"Europe/London|GB-Eire\",\"Europe/Moscow|W-SU\",\"Europe/Paris|Europe/Monaco\",\"Europe/Prague|Europe/Bratislava\",\"Europe/Rome|Europe/San_Marino\",\"Europe/Rome|Europe/Vatican\",\"Europe/Warsaw|Poland\",\"Europe/Zurich|Europe/Busingen\",\"Europe/Zurich|Europe/Vaduz\",\"Indian/Maldives|Indian/Kerguelen\",\"Pacific/Auckland|Antarctica/McMurdo\",\"Pacific/Auckland|Antarctica/South_Pole\",\"Pacific/Auckland|NZ\",\"Pacific/Chatham|NZ-CHAT\",\"Pacific/Easter|Chile/EasterIsland\",\"Pacific/Enderbury|Pacific/Kanton\",\"Pacific/Guadalcanal|Pacific/Pohnpei\",\"Pacific/Guadalcanal|Pacific/Ponape\",\"Pacific/Guam|Pacific/Saipan\",\"Pacific/Honolulu|Pacific/Johnston\",\"Pacific/Honolulu|US/Hawaii\",\"Pacific/Kwajalein|Kwajalein\",\"Pacific/Pago_Pago|Pacific/Midway\",\"Pacific/Pago_Pago|Pacific/Samoa\",\"Pacific/Pago_Pago|US/Samoa\",\"Pacific/Port_Moresby|Antarctica/DumontDUrville\",\"Pacific/Port_Moresby|Pacific/Chuuk\",\"Pacific/Port_Moresby|Pacific/Truk\",\"Pacific/Port_Moresby|Pacific/Yap\",\"Pacific/Tarawa|Pacific/Funafuti\",\"Pacific/Tarawa|Pacific/Majuro\",\"Pacific/Tarawa|Pacific/Wake\",\"Pacific/Tarawa|Pacific/Wallis\"],\"countries\":[\"AD|Europe/Andorra\",\"AE|Asia/Dubai\",\"AF|Asia/Kabul\",\"AG|America/Puerto_Rico America/Antigua\",\"AI|America/Puerto_Rico America/Anguilla\",\"AL|Europe/Tirane\",\"AM|Asia/Yerevan\",\"AO|Africa/Lagos Africa/Luanda\",\"AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Asia/Urumqi Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa Antarctica/Vostok\",\"AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia\",\"AS|Pacific/Pago_Pago\",\"AT|Europe/Vienna\",\"AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla\",\"AW|America/Puerto_Rico America/Aruba\",\"AX|Europe/Helsinki Europe/Mariehamn\",\"AZ|Asia/Baku\",\"BA|Europe/Belgrade Europe/Sarajevo\",\"BB|America/Barbados\",\"BD|Asia/Dhaka\",\"BE|Europe/Brussels\",\"BF|Africa/Abidjan Africa/Ouagadougou\",\"BG|Europe/Sofia\",\"BH|Asia/Qatar Asia/Bahrain\",\"BI|Africa/Maputo Africa/Bujumbura\",\"BJ|Africa/Lagos Africa/Porto-Novo\",\"BL|America/Puerto_Rico America/St_Barthelemy\",\"BM|Atlantic/Bermuda\",\"BN|Asia/Kuching Asia/Brunei\",\"BO|America/La_Paz\",\"BQ|America/Puerto_Rico America/Kralendijk\",\"BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco\",\"BS|America/Toronto America/Nassau\",\"BT|Asia/Thimphu\",\"BW|Africa/Maputo Africa/Gaborone\",\"BY|Europe/Minsk\",\"BZ|America/Belize\",\"CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Pangnirtung America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston\",\"CC|Asia/Yangon Indian/Cocos\",\"CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi\",\"CF|Africa/Lagos Africa/Bangui\",\"CG|Africa/Lagos Africa/Brazzaville\",\"CH|Europe/Zurich\",\"CI|Africa/Abidjan\",\"CK|Pacific/Rarotonga\",\"CL|America/Santiago America/Punta_Arenas Pacific/Easter\",\"CM|Africa/Lagos Africa/Douala\",\"CN|Asia/Shanghai Asia/Urumqi\",\"CO|America/Bogota\",\"CR|America/Costa_Rica\",\"CU|America/Havana\",\"CV|Atlantic/Cape_Verde\",\"CW|America/Puerto_Rico America/Curacao\",\"CX|Asia/Bangkok Indian/Christmas\",\"CY|Asia/Nicosia Asia/Famagusta\",\"CZ|Europe/Prague\",\"DE|Europe/Zurich Europe/Berlin Europe/Busingen\",\"DJ|Africa/Nairobi Africa/Djibouti\",\"DK|Europe/Berlin Europe/Copenhagen\",\"DM|America/Puerto_Rico America/Dominica\",\"DO|America/Santo_Domingo\",\"DZ|Africa/Algiers\",\"EC|America/Guayaquil Pacific/Galapagos\",\"EE|Europe/Tallinn\",\"EG|Africa/Cairo\",\"EH|Africa/El_Aaiun\",\"ER|Africa/Nairobi Africa/Asmara\",\"ES|Europe/Madrid Africa/Ceuta Atlantic/Canary\",\"ET|Africa/Nairobi Africa/Addis_Ababa\",\"FI|Europe/Helsinki\",\"FJ|Pacific/Fiji\",\"FK|Atlantic/Stanley\",\"FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei\",\"FO|Atlantic/Faroe\",\"FR|Europe/Paris\",\"GA|Africa/Lagos Africa/Libreville\",\"GB|Europe/London\",\"GD|America/Puerto_Rico America/Grenada\",\"GE|Asia/Tbilisi\",\"GF|America/Cayenne\",\"GG|Europe/London Europe/Guernsey\",\"GH|Africa/Abidjan Africa/Accra\",\"GI|Europe/Gibraltar\",\"GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule\",\"GM|Africa/Abidjan Africa/Banjul\",\"GN|Africa/Abidjan Africa/Conakry\",\"GP|America/Puerto_Rico America/Guadeloupe\",\"GQ|Africa/Lagos Africa/Malabo\",\"GR|Europe/Athens\",\"GS|Atlantic/South_Georgia\",\"GT|America/Guatemala\",\"GU|Pacific/Guam\",\"GW|Africa/Bissau\",\"GY|America/Guyana\",\"HK|Asia/Hong_Kong\",\"HN|America/Tegucigalpa\",\"HR|Europe/Belgrade Europe/Zagreb\",\"HT|America/Port-au-Prince\",\"HU|Europe/Budapest\",\"ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura\",\"IE|Europe/Dublin\",\"IL|Asia/Jerusalem\",\"IM|Europe/London Europe/Isle_of_Man\",\"IN|Asia/Kolkata\",\"IO|Indian/Chagos\",\"IQ|Asia/Baghdad\",\"IR|Asia/Tehran\",\"IS|Africa/Abidjan Atlantic/Reykjavik\",\"IT|Europe/Rome\",\"JE|Europe/London Europe/Jersey\",\"JM|America/Jamaica\",\"JO|Asia/Amman\",\"JP|Asia/Tokyo\",\"KE|Africa/Nairobi\",\"KG|Asia/Bishkek\",\"KH|Asia/Bangkok Asia/Phnom_Penh\",\"KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati\",\"KM|Africa/Nairobi Indian/Comoro\",\"KN|America/Puerto_Rico America/St_Kitts\",\"KP|Asia/Pyongyang\",\"KR|Asia/Seoul\",\"KW|Asia/Riyadh Asia/Kuwait\",\"KY|America/Panama America/Cayman\",\"KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral\",\"LA|Asia/Bangkok Asia/Vientiane\",\"LB|Asia/Beirut\",\"LC|America/Puerto_Rico America/St_Lucia\",\"LI|Europe/Zurich Europe/Vaduz\",\"LK|Asia/Colombo\",\"LR|Africa/Monrovia\",\"LS|Africa/Johannesburg Africa/Maseru\",\"LT|Europe/Vilnius\",\"LU|Europe/Brussels Europe/Luxembourg\",\"LV|Europe/Riga\",\"LY|Africa/Tripoli\",\"MA|Africa/Casablanca\",\"MC|Europe/Paris Europe/Monaco\",\"MD|Europe/Chisinau\",\"ME|Europe/Belgrade Europe/Podgorica\",\"MF|America/Puerto_Rico America/Marigot\",\"MG|Africa/Nairobi Indian/Antananarivo\",\"MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro\",\"MK|Europe/Belgrade Europe/Skopje\",\"ML|Africa/Abidjan Africa/Bamako\",\"MM|Asia/Yangon\",\"MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan\",\"MO|Asia/Macau\",\"MP|Pacific/Guam Pacific/Saipan\",\"MQ|America/Martinique\",\"MR|Africa/Abidjan Africa/Nouakchott\",\"MS|America/Puerto_Rico America/Montserrat\",\"MT|Europe/Malta\",\"MU|Indian/Mauritius\",\"MV|Indian/Maldives\",\"MW|Africa/Maputo Africa/Blantyre\",\"MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas\",\"MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur\",\"MZ|Africa/Maputo\",\"NA|Africa/Windhoek\",\"NC|Pacific/Noumea\",\"NE|Africa/Lagos Africa/Niamey\",\"NF|Pacific/Norfolk\",\"NG|Africa/Lagos\",\"NI|America/Managua\",\"NL|Europe/Brussels Europe/Amsterdam\",\"NO|Europe/Berlin Europe/Oslo\",\"NP|Asia/Kathmandu\",\"NR|Pacific/Nauru\",\"NU|Pacific/Niue\",\"NZ|Pacific/Auckland Pacific/Chatham\",\"OM|Asia/Dubai Asia/Muscat\",\"PA|America/Panama\",\"PE|America/Lima\",\"PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier\",\"PG|Pacific/Port_Moresby Pacific/Bougainville\",\"PH|Asia/Manila\",\"PK|Asia/Karachi\",\"PL|Europe/Warsaw\",\"PM|America/Miquelon\",\"PN|Pacific/Pitcairn\",\"PR|America/Puerto_Rico\",\"PS|Asia/Gaza Asia/Hebron\",\"PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores\",\"PW|Pacific/Palau\",\"PY|America/Asuncion\",\"QA|Asia/Qatar\",\"RE|Asia/Dubai Indian/Reunion\",\"RO|Europe/Bucharest\",\"RS|Europe/Belgrade\",\"RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr\",\"RW|Africa/Maputo Africa/Kigali\",\"SA|Asia/Riyadh\",\"SB|Pacific/Guadalcanal\",\"SC|Asia/Dubai Indian/Mahe\",\"SD|Africa/Khartoum\",\"SE|Europe/Berlin Europe/Stockholm\",\"SG|Asia/Singapore\",\"SH|Africa/Abidjan Atlantic/St_Helena\",\"SI|Europe/Belgrade Europe/Ljubljana\",\"SJ|Europe/Berlin Arctic/Longyearbyen\",\"SK|Europe/Prague Europe/Bratislava\",\"SL|Africa/Abidjan Africa/Freetown\",\"SM|Europe/Rome Europe/San_Marino\",\"SN|Africa/Abidjan Africa/Dakar\",\"SO|Africa/Nairobi Africa/Mogadishu\",\"SR|America/Paramaribo\",\"SS|Africa/Juba\",\"ST|Africa/Sao_Tome\",\"SV|America/El_Salvador\",\"SX|America/Puerto_Rico America/Lower_Princes\",\"SY|Asia/Damascus\",\"SZ|Africa/Johannesburg Africa/Mbabane\",\"TC|America/Grand_Turk\",\"TD|Africa/Ndjamena\",\"TF|Asia/Dubai Indian/Maldives Indian/Kerguelen\",\"TG|Africa/Abidjan Africa/Lome\",\"TH|Asia/Bangkok\",\"TJ|Asia/Dushanbe\",\"TK|Pacific/Fakaofo\",\"TL|Asia/Dili\",\"TM|Asia/Ashgabat\",\"TN|Africa/Tunis\",\"TO|Pacific/Tongatapu\",\"TR|Europe/Istanbul\",\"TT|America/Puerto_Rico America/Port_of_Spain\",\"TV|Pacific/Tarawa Pacific/Funafuti\",\"TW|Asia/Taipei\",\"TZ|Africa/Nairobi Africa/Dar_es_Salaam\",\"UA|Europe/Simferopol Europe/Kyiv\",\"UG|Africa/Nairobi Africa/Kampala\",\"UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Honolulu Pacific/Midway Pacific/Wake\",\"US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu\",\"UY|America/Montevideo\",\"UZ|Asia/Samarkand Asia/Tashkent\",\"VA|Europe/Rome Europe/Vatican\",\"VC|America/Puerto_Rico America/St_Vincent\",\"VE|America/Caracas\",\"VG|America/Puerto_Rico America/Tortola\",\"VI|America/Puerto_Rico America/St_Thomas\",\"VN|Asia/Bangkok Asia/Ho_Chi_Minh\",\"VU|Pacific/Efate\",\"WF|Pacific/Tarawa Pacific/Wallis\",\"WS|Pacific/Apia\",\"YE|Asia/Riyadh Asia/Aden\",\"YT|Africa/Nairobi Indian/Mayotte\",\"ZA|Africa/Johannesburg\",\"ZM|Africa/Maputo Africa/Lusaka\",\"ZW|Africa/Maputo Africa/Harare\"]}");

});

parcelRegister("lDAPC", function(module, exports) {

var $8qdJN = parcelRequire("8qdJN");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $8qdJN.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("4kRfe", function(module, exports) {

$parcel$export(module.exports, "handleFocus", function () { return handleFocus; });

var $6fFrj = parcelRequire("6fFrj");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Focus, [
            {
                key: 'render',
                value: function render() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Component, _extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
};

});

parcelRegister("fWb4i", function(module, exports) {

var $32V8e = parcelRequire("32V8e");
function $b9a4dbb60c4b60d7$var$_defineProperty(obj, key, value) {
    key = $32V8e(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $b9a4dbb60c4b60d7$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("32V8e", function(module, exports) {

var $tywpZ = parcelRequire("tywpZ");
var $237de0312c349fc4$var$_typeof = $tywpZ.default;

var $fBCyJ = parcelRequire("fBCyJ");
function $237de0312c349fc4$var$toPropertyKey(t) {
    var i = $fBCyJ(t, "string");
    return "symbol" == $237de0312c349fc4$var$_typeof(i) ? i : i + "";
}
module.exports = $237de0312c349fc4$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("tywpZ", function(module, exports) {
function $058d7cdf8118a1b8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $058d7cdf8118a1b8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $058d7cdf8118a1b8$var$_typeof(o);
}
module.exports = $058d7cdf8118a1b8$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fBCyJ", function(module, exports) {

var $tywpZ = parcelRequire("tywpZ");
var $b5c838c8e920ea0f$var$_typeof = $tywpZ.default;
function $b5c838c8e920ea0f$var$toPrimitive(t, r) {
    if ("object" != $b5c838c8e920ea0f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b5c838c8e920ea0f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b5c838c8e920ea0f$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fk9rV", function(module, exports) {

module.exports = (parcelRequire("jN93C")).getBundleURL('a0IFD') + "taxaroo-logo.7a3ce4e2.png";

});

parcelRegister("10A66", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $0bc1cab5e3a8732d$export$a7c73072b1a182ae; }, function (v) { return $0bc1cab5e3a8732d$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $0bc1cab5e3a8732d$export$9f27bc3417b4524d; }, function (v) { return $0bc1cab5e3a8732d$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $0bc1cab5e3a8732d$export$db77ccec0bb4ccac; }, function (v) { return $0bc1cab5e3a8732d$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $0bc1cab5e3a8732d$export$8392c0c9d3dcbd35; }, function (v) { return $0bc1cab5e3a8732d$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0bc1cab5e3a8732d$export$ffb0004e005737fa; }, function (v) { return $0bc1cab5e3a8732d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $0bc1cab5e3a8732d$export$b624eff549462981; }, function (v) { return $0bc1cab5e3a8732d$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $0bc1cab5e3a8732d$export$7897aa7841a5380c; }, function (v) { return $0bc1cab5e3a8732d$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $0bc1cab5e3a8732d$export$602eac185826482c; }, function (v) { return $0bc1cab5e3a8732d$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $0bc1cab5e3a8732d$export$e2c29f18771995cb; }, function (v) { return $0bc1cab5e3a8732d$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0bc1cab5e3a8732d$export$5f8d39834fd61797; }, function (v) { return $0bc1cab5e3a8732d$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0bc1cab5e3a8732d$export$74bf444e3cd11ea5; }, function (v) { return $0bc1cab5e3a8732d$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $0bc1cab5e3a8732d$export$998bcd577473dd93; }, function (v) { return $0bc1cab5e3a8732d$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $0bc1cab5e3a8732d$export$92387174baf9b227; }, function (v) { return $0bc1cab5e3a8732d$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $0bc1cab5e3a8732d$export$ec112efeb987d9c6; }, function (v) { return $0bc1cab5e3a8732d$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $0bc1cab5e3a8732d$export$b706b080d889d2c9; }, function (v) { return $0bc1cab5e3a8732d$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $0bc1cab5e3a8732d$export$5be5a87408f70ddc; }, function (v) { return $0bc1cab5e3a8732d$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $0bc1cab5e3a8732d$export$45a5e7f76e0caa8d; }, function (v) { return $0bc1cab5e3a8732d$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $0bc1cab5e3a8732d$export$455c2e768291efa6; }, function (v) { return $0bc1cab5e3a8732d$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $0bc1cab5e3a8732d$export$9522e17588c12572; }, function (v) { return $0bc1cab5e3a8732d$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $0bc1cab5e3a8732d$export$2110ac352bb060b9; }, function (v) { return $0bc1cab5e3a8732d$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $0bc1cab5e3a8732d$export$56885ab8b9c456ab; }, function (v) { return $0bc1cab5e3a8732d$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $0bc1cab5e3a8732d$export$d927fcb6adf8f9de; }, function (v) { return $0bc1cab5e3a8732d$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $0bc1cab5e3a8732d$export$b82d16f27459e05a; }, function (v) { return $0bc1cab5e3a8732d$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $0bc1cab5e3a8732d$export$522c17b4f5e123e8; }, function (v) { return $0bc1cab5e3a8732d$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $0bc1cab5e3a8732d$export$1aabd8a0274ecfd6; }, function (v) { return $0bc1cab5e3a8732d$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $0bc1cab5e3a8732d$export$3d6c20d97e46b957; }, function (v) { return $0bc1cab5e3a8732d$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $0bc1cab5e3a8732d$export$9b621391a187a31a; }, function (v) { return $0bc1cab5e3a8732d$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $0bc1cab5e3a8732d$export$f5bbd400c2f4426f; }, function (v) { return $0bc1cab5e3a8732d$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0bc1cab5e3a8732d$export$a7c73072b1a182ae;
var $0bc1cab5e3a8732d$export$9f27bc3417b4524d;
var $0bc1cab5e3a8732d$export$db77ccec0bb4ccac;
var $0bc1cab5e3a8732d$export$8392c0c9d3dcbd35;
var $0bc1cab5e3a8732d$export$ffb0004e005737fa;
var $0bc1cab5e3a8732d$export$b624eff549462981;
var $0bc1cab5e3a8732d$export$7897aa7841a5380c;
var $0bc1cab5e3a8732d$export$602eac185826482c;
var $0bc1cab5e3a8732d$export$e2c29f18771995cb;
var $0bc1cab5e3a8732d$export$5f8d39834fd61797;
var $0bc1cab5e3a8732d$export$74bf444e3cd11ea5;
var $0bc1cab5e3a8732d$export$998bcd577473dd93;
var $0bc1cab5e3a8732d$export$92387174baf9b227;
var $0bc1cab5e3a8732d$export$ec112efeb987d9c6;
var $0bc1cab5e3a8732d$export$b706b080d889d2c9;
var $0bc1cab5e3a8732d$export$5be5a87408f70ddc;
var $0bc1cab5e3a8732d$export$45a5e7f76e0caa8d;
var $0bc1cab5e3a8732d$export$455c2e768291efa6;
var $0bc1cab5e3a8732d$export$9522e17588c12572;
var $0bc1cab5e3a8732d$export$2110ac352bb060b9;
var $0bc1cab5e3a8732d$export$56885ab8b9c456ab;
var $0bc1cab5e3a8732d$export$d927fcb6adf8f9de;
var $0bc1cab5e3a8732d$export$b82d16f27459e05a;
var $0bc1cab5e3a8732d$export$522c17b4f5e123e8;
var $0bc1cab5e3a8732d$export$1aabd8a0274ecfd6;
var $0bc1cab5e3a8732d$export$3d6c20d97e46b957;
var $0bc1cab5e3a8732d$export$9b621391a187a31a;
var $0bc1cab5e3a8732d$export$f5bbd400c2f4426f;
'use strict';
var $0bc1cab5e3a8732d$var$b = Symbol.for("react.element"), $0bc1cab5e3a8732d$var$c = Symbol.for("react.portal"), $0bc1cab5e3a8732d$var$d = Symbol.for("react.fragment"), $0bc1cab5e3a8732d$var$e = Symbol.for("react.strict_mode"), $0bc1cab5e3a8732d$var$f = Symbol.for("react.profiler"), $0bc1cab5e3a8732d$var$g = Symbol.for("react.provider"), $0bc1cab5e3a8732d$var$h = Symbol.for("react.context"), $0bc1cab5e3a8732d$var$k = Symbol.for("react.server_context"), $0bc1cab5e3a8732d$var$l = Symbol.for("react.forward_ref"), $0bc1cab5e3a8732d$var$m = Symbol.for("react.suspense"), $0bc1cab5e3a8732d$var$n = Symbol.for("react.suspense_list"), $0bc1cab5e3a8732d$var$p = Symbol.for("react.memo"), $0bc1cab5e3a8732d$var$q = Symbol.for("react.lazy"), $0bc1cab5e3a8732d$var$t = Symbol.for("react.offscreen"), $0bc1cab5e3a8732d$var$u;
$0bc1cab5e3a8732d$var$u = Symbol.for("react.module.reference");
function $0bc1cab5e3a8732d$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $0bc1cab5e3a8732d$var$b:
                switch(a = a.type, a){
                    case $0bc1cab5e3a8732d$var$d:
                    case $0bc1cab5e3a8732d$var$f:
                    case $0bc1cab5e3a8732d$var$e:
                    case $0bc1cab5e3a8732d$var$m:
                    case $0bc1cab5e3a8732d$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $0bc1cab5e3a8732d$var$k:
                            case $0bc1cab5e3a8732d$var$h:
                            case $0bc1cab5e3a8732d$var$l:
                            case $0bc1cab5e3a8732d$var$q:
                            case $0bc1cab5e3a8732d$var$p:
                            case $0bc1cab5e3a8732d$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $0bc1cab5e3a8732d$var$c:
                return r;
        }
    }
}
$0bc1cab5e3a8732d$export$a7c73072b1a182ae = $0bc1cab5e3a8732d$var$h;
$0bc1cab5e3a8732d$export$9f27bc3417b4524d = $0bc1cab5e3a8732d$var$g;
$0bc1cab5e3a8732d$export$db77ccec0bb4ccac = $0bc1cab5e3a8732d$var$b;
$0bc1cab5e3a8732d$export$8392c0c9d3dcbd35 = $0bc1cab5e3a8732d$var$l;
$0bc1cab5e3a8732d$export$ffb0004e005737fa = $0bc1cab5e3a8732d$var$d;
$0bc1cab5e3a8732d$export$b624eff549462981 = $0bc1cab5e3a8732d$var$q;
$0bc1cab5e3a8732d$export$7897aa7841a5380c = $0bc1cab5e3a8732d$var$p;
$0bc1cab5e3a8732d$export$602eac185826482c = $0bc1cab5e3a8732d$var$c;
$0bc1cab5e3a8732d$export$e2c29f18771995cb = $0bc1cab5e3a8732d$var$f;
$0bc1cab5e3a8732d$export$5f8d39834fd61797 = $0bc1cab5e3a8732d$var$e;
$0bc1cab5e3a8732d$export$74bf444e3cd11ea5 = $0bc1cab5e3a8732d$var$m;
$0bc1cab5e3a8732d$export$998bcd577473dd93 = $0bc1cab5e3a8732d$var$n;
$0bc1cab5e3a8732d$export$92387174baf9b227 = function() {
    return !1;
};
$0bc1cab5e3a8732d$export$ec112efeb987d9c6 = function() {
    return !1;
};
$0bc1cab5e3a8732d$export$b706b080d889d2c9 = function(a) {
    return $0bc1cab5e3a8732d$var$v(a) === $0bc1cab5e3a8732d$var$h;
};
$0bc1cab5e3a8732d$export$5be5a87408f70ddc = function(a) {
    return $0bc1cab5e3a8732d$var$v(a) === $0bc1cab5e3a8732d$var$g;
};
$0bc1cab5e3a8732d$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0bc1cab5e3a8732d$var$b;
};
$0bc1cab5e3a8732d$export$455c2e768291efa6 = function(a) {
    return $0bc1cab5e3a8732d$var$v(a) === $0bc1cab5e3a8732d$var$l;
};
$0bc1cab5e3a8732d$export$9522e17588c12572 = function(a) {
    return $0bc1cab5e3a8732d$var$v(a) === $0bc1cab5e3a8732d$var$d;
};
$0bc1cab5e3a8732d$export$2110ac352bb060b9 = function(a) {
    return $0bc1cab5e3a8732d$var$v(a) === $0bc1cab5e3a8732d$var$q;
};
$0bc1cab5e3a8732d$export$56885ab8b9c456ab = function(a) {
    return $0bc1cab5e3a8732d$var$v(a) === $0bc1cab5e3a8732d$var$p;
};
$0bc1cab5e3a8732d$export$d927fcb6adf8f9de = function(a) {
    return $0bc1cab5e3a8732d$var$v(a) === $0bc1cab5e3a8732d$var$c;
};
$0bc1cab5e3a8732d$export$b82d16f27459e05a = function(a) {
    return $0bc1cab5e3a8732d$var$v(a) === $0bc1cab5e3a8732d$var$f;
};
$0bc1cab5e3a8732d$export$522c17b4f5e123e8 = function(a) {
    return $0bc1cab5e3a8732d$var$v(a) === $0bc1cab5e3a8732d$var$e;
};
$0bc1cab5e3a8732d$export$1aabd8a0274ecfd6 = function(a) {
    return $0bc1cab5e3a8732d$var$v(a) === $0bc1cab5e3a8732d$var$m;
};
$0bc1cab5e3a8732d$export$3d6c20d97e46b957 = function(a) {
    return $0bc1cab5e3a8732d$var$v(a) === $0bc1cab5e3a8732d$var$n;
};
$0bc1cab5e3a8732d$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $0bc1cab5e3a8732d$var$d || a === $0bc1cab5e3a8732d$var$f || a === $0bc1cab5e3a8732d$var$e || a === $0bc1cab5e3a8732d$var$m || a === $0bc1cab5e3a8732d$var$n || a === $0bc1cab5e3a8732d$var$t || "object" === typeof a && null !== a && (a.$$typeof === $0bc1cab5e3a8732d$var$q || a.$$typeof === $0bc1cab5e3a8732d$var$p || a.$$typeof === $0bc1cab5e3a8732d$var$g || a.$$typeof === $0bc1cab5e3a8732d$var$h || a.$$typeof === $0bc1cab5e3a8732d$var$l || a.$$typeof === $0bc1cab5e3a8732d$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$0bc1cab5e3a8732d$export$f5bbd400c2f4426f = $0bc1cab5e3a8732d$var$v;

});

parcelRegister("ha77Z", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CSVLink = module.exports.CSVDownload = undefined;

var $hEkJW = parcelRequire("hEkJW");
var $c7e8e64a04662d0e$var$_Download2 = $c7e8e64a04662d0e$var$_interopRequireDefault($hEkJW);

var $aVImo = parcelRequire("aVImo");
var $c7e8e64a04662d0e$var$_Link2 = $c7e8e64a04662d0e$var$_interopRequireDefault($aVImo);
function $c7e8e64a04662d0e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c7e8e64a04662d0e$var$CSVDownload = module.exports.CSVDownload = $c7e8e64a04662d0e$var$_Download2.default;
var $c7e8e64a04662d0e$var$CSVLink = module.exports.CSVLink = $c7e8e64a04662d0e$var$_Link2.default;

});
parcelRegister("hEkJW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cd9642a1d0b435cb$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $6fFrj = parcelRequire("6fFrj");
var $cd9642a1d0b435cb$var$_react2 = $cd9642a1d0b435cb$var$_interopRequireDefault($6fFrj);

var $ipsCM = parcelRequire("ipsCM");

var $ioMlW = parcelRequire("ioMlW");
function $cd9642a1d0b435cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cd9642a1d0b435cb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cd9642a1d0b435cb$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $cd9642a1d0b435cb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $cd9642a1d0b435cb$var$defaultProps = {
    target: '_blank'
};
var $cd9642a1d0b435cb$var$CSVDownload = function(_React$Component) {
    $cd9642a1d0b435cb$var$_inherits(CSVDownload, _React$Component);
    function CSVDownload(props) {
        $cd9642a1d0b435cb$var$_classCallCheck(this, CSVDownload);
        var _this = $cd9642a1d0b435cb$var$_possibleConstructorReturn(this, (CSVDownload.__proto__ || Object.getPrototypeOf(CSVDownload)).call(this, props));
        _this.state = {};
        return _this;
    }
    $cd9642a1d0b435cb$var$_createClass(CSVDownload, [
        {
            key: 'buildURI',
            value: function buildURI() {
                return $ipsCM.buildURI.apply(undefined, arguments);
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props = this.props, data = _props.data, headers = _props.headers, separator = _props.separator, enclosingCharacter = _props.enclosingCharacter, uFEFF = _props.uFEFF, target = _props.target, specs = _props.specs, replace = _props.replace;
                this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator, enclosingCharacter), target, specs, replace);
            }
        },
        {
            key: 'getWindow',
            value: function getWindow() {
                return this.state.page;
            }
        },
        {
            key: 'render',
            value: function render() {
                return null;
            }
        }
    ]);
    return CSVDownload;
}($cd9642a1d0b435cb$var$_react2.default.Component);
$cd9642a1d0b435cb$var$CSVDownload.defaultProps = Object.assign($ioMlW.defaultProps, $cd9642a1d0b435cb$var$defaultProps);
$cd9642a1d0b435cb$var$CSVDownload.propTypes = $ioMlW.propTypes;
module.exports.default = $cd9642a1d0b435cb$var$CSVDownload;

});
parcelRegister("ipsCM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d670c40aea43f33f$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $d670c40aea43f33f$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $d670c40aea43f33f$var$isSafari = module.exports.isSafari = function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};
var $d670c40aea43f33f$var$isJsons = module.exports.isJsons = function isJsons(array) {
    return Array.isArray(array) && array.every(function(row) {
        return (typeof row === "undefined" ? "undefined" : $d670c40aea43f33f$var$_typeof(row)) === 'object' && !(row instanceof Array);
    });
};
var $d670c40aea43f33f$var$isArrays = module.exports.isArrays = function isArrays(array) {
    return Array.isArray(array) && array.every(function(row) {
        return Array.isArray(row);
    });
};
var $d670c40aea43f33f$var$jsonsHeaders = module.exports.jsonsHeaders = function jsonsHeaders(array) {
    return Array.from(array.map(function(json) {
        return Object.keys(json);
    }).reduce(function(a, b) {
        return new Set([].concat($d670c40aea43f33f$var$_toConsumableArray(a), $d670c40aea43f33f$var$_toConsumableArray(b)));
    }, []));
};
var $d670c40aea43f33f$var$jsons2arrays = module.exports.jsons2arrays = function jsons2arrays(jsons, headers) {
    headers = headers || $d670c40aea43f33f$var$jsonsHeaders(jsons);
    var headerLabels = headers;
    var headerKeys = headers;
    if ($d670c40aea43f33f$var$isJsons(headers)) {
        headerLabels = headers.map(function(header) {
            return header.label;
        });
        headerKeys = headers.map(function(header) {
            return header.key;
        });
    }
    var data = jsons.map(function(object) {
        return headerKeys.map(function(header) {
            return $d670c40aea43f33f$var$getHeaderValue(header, object);
        });
    });
    return [
        headerLabels
    ].concat($d670c40aea43f33f$var$_toConsumableArray(data));
};
var $d670c40aea43f33f$var$getHeaderValue = module.exports.getHeaderValue = function getHeaderValue(property, obj) {
    var foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function(o, p, i, arr) {
        var value = o[p];
        if (value === undefined || value === null) arr.splice(1);
        else return value;
    }, obj);
    return foundValue === undefined ? property in obj ? obj[property] : '' : foundValue;
};
var $d670c40aea43f33f$var$elementOrEmpty = module.exports.elementOrEmpty = function elementOrEmpty(element) {
    return typeof element === 'undefined' || element === null ? '' : element;
};
var $d670c40aea43f33f$var$joiner = module.exports.joiner = function joiner(data) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
    var enclosingCharacter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '"';
    return data.filter(function(e) {
        return e;
    }).map(function(row) {
        return row.map(function(element) {
            return $d670c40aea43f33f$var$elementOrEmpty(element);
        }).map(function(column) {
            return "" + enclosingCharacter + column + enclosingCharacter;
        }).join(separator);
    }).join("\n");
};
var $d670c40aea43f33f$var$arrays2csv = module.exports.arrays2csv = function arrays2csv(data, headers, separator, enclosingCharacter) {
    return $d670c40aea43f33f$var$joiner(headers ? [
        headers
    ].concat($d670c40aea43f33f$var$_toConsumableArray(data)) : data, separator, enclosingCharacter);
};
var $d670c40aea43f33f$var$jsons2csv = module.exports.jsons2csv = function jsons2csv(data, headers, separator, enclosingCharacter) {
    return $d670c40aea43f33f$var$joiner($d670c40aea43f33f$var$jsons2arrays(data, headers), separator, enclosingCharacter);
};
var $d670c40aea43f33f$var$string2csv = module.exports.string2csv = function string2csv(data, headers, separator, enclosingCharacter) {
    return headers ? headers.join(separator) + "\n" + data : data.replace(/"/g, '""');
};
var $d670c40aea43f33f$var$toCSV = module.exports.toCSV = function toCSV(data, headers, separator, enclosingCharacter) {
    if ($d670c40aea43f33f$var$isJsons(data)) return $d670c40aea43f33f$var$jsons2csv(data, headers, separator, enclosingCharacter);
    if ($d670c40aea43f33f$var$isArrays(data)) return $d670c40aea43f33f$var$arrays2csv(data, headers, separator, enclosingCharacter);
    if (typeof data === 'string') return $d670c40aea43f33f$var$string2csv(data, headers, separator);
    throw new TypeError("Data should be a \"String\", \"Array of arrays\" OR \"Array of objects\" ");
};
var $d670c40aea43f33f$var$buildURI = module.exports.buildURI = function buildURI(data, uFEFF, headers, separator, enclosingCharacter) {
    var csv = $d670c40aea43f33f$var$toCSV(data, headers, separator, enclosingCharacter);
    var type = $d670c40aea43f33f$var$isSafari() ? 'application/csv' : 'text/csv';
    var blob = new Blob([
        uFEFF ? "\uFEFF" : '',
        csv
    ], {
        type: type
    });
    var dataURI = "data:" + type + ";charset=utf-8," + (uFEFF ? "\uFEFF" : '') + csv;
    var URL = window.URL || window.webkitURL;
    return typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);
};

});

parcelRegister("ioMlW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropsNotForwarded = module.exports.defaultProps = module.exports.propTypes = undefined;

var $6fFrj = parcelRequire("6fFrj");
var $d64ff9c2e3cd3f66$var$_react2 = $d64ff9c2e3cd3f66$var$_interopRequireDefault($6fFrj);

var $cgjHV = parcelRequire("cgjHV");
function $d64ff9c2e3cd3f66$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d64ff9c2e3cd3f66$var$propTypes = module.exports.propTypes = {
    data: (0, $cgjHV.oneOfType)([
        $cgjHV.string,
        $cgjHV.array,
        $cgjHV.func
    ]).isRequired,
    headers: $cgjHV.array,
    target: $cgjHV.string,
    separator: $cgjHV.string,
    filename: $cgjHV.string,
    uFEFF: $cgjHV.bool,
    onClick: $cgjHV.func,
    asyncOnClick: $cgjHV.bool,
    enclosingCharacter: $cgjHV.string
};
var $d64ff9c2e3cd3f66$var$defaultProps = module.exports.defaultProps = {
    separator: ',',
    filename: 'generatedBy_react-csv.csv',
    uFEFF: true,
    asyncOnClick: false,
    enclosingCharacter: '"'
};
var $d64ff9c2e3cd3f66$var$PropsNotForwarded = module.exports.PropsNotForwarded = [
    'data',
    'headers'
];

});
parcelRegister("cgjHV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8ed6442ac09c3039$var$ReactIs, $8ed6442ac09c3039$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("l3kzc"))();

});



parcelRegister("aVImo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7f51a3494eda9874$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7f51a3494eda9874$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $6fFrj = parcelRequire("6fFrj");
var $7f51a3494eda9874$var$_react2 = $7f51a3494eda9874$var$_interopRequireDefault($6fFrj);

var $ipsCM = parcelRequire("ipsCM");

var $ioMlW = parcelRequire("ioMlW");
function $7f51a3494eda9874$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7f51a3494eda9874$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $7f51a3494eda9874$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7f51a3494eda9874$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7f51a3494eda9874$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $7f51a3494eda9874$var$CSVLink = function(_React$Component) {
    $7f51a3494eda9874$var$_inherits(CSVLink, _React$Component);
    function CSVLink(props) {
        $7f51a3494eda9874$var$_classCallCheck(this, CSVLink);
        var _this = $7f51a3494eda9874$var$_possibleConstructorReturn(this, (CSVLink.__proto__ || Object.getPrototypeOf(CSVLink)).call(this, props));
        _this.buildURI = _this.buildURI.bind(_this);
        return _this;
    }
    $7f51a3494eda9874$var$_createClass(CSVLink, [
        {
            key: 'buildURI',
            value: function buildURI() {
                return $ipsCM.buildURI.apply(undefined, arguments);
            }
        },
        {
            key: 'handleLegacy',
            value: function handleLegacy(event) {
                var isAsync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                if (window.navigator.msSaveOrOpenBlob) {
                    event.preventDefault();
                    var _props = this.props, data = _props.data, headers = _props.headers, separator = _props.separator, filename = _props.filename, enclosingCharacter = _props.enclosingCharacter, uFEFF = _props.uFEFF;
                    var csvData = isAsync && typeof data === 'function' ? data() : data;
                    var blob = new Blob([
                        uFEFF ? '\uFEFF' : '',
                        (0, $ipsCM.toCSV)(csvData, headers, separator, enclosingCharacter)
                    ]);
                    window.navigator.msSaveBlob(blob, filename);
                    return false;
                }
            }
        },
        {
            key: 'handleAsyncClick',
            value: function handleAsyncClick(event) {
                var _this2 = this;
                var done = function done(proceed) {
                    if (proceed === false) {
                        event.preventDefault();
                        return;
                    }
                    _this2.handleLegacy(event, true);
                };
                this.props.onClick(event, done);
            }
        },
        {
            key: 'handleSyncClick',
            value: function handleSyncClick(event) {
                var stopEvent = this.props.onClick(event) === false;
                if (stopEvent) {
                    event.preventDefault();
                    return;
                }
                this.handleLegacy(event);
            }
        },
        {
            key: 'handleClick',
            value: function handleClick() {
                var _this3 = this;
                return function(event) {
                    if (typeof _this3.props.onClick === 'function') return _this3.props.asyncOnClick ? _this3.handleAsyncClick(event) : _this3.handleSyncClick(event);
                    _this3.handleLegacy(event);
                };
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this4 = this;
                var _props2 = this.props, data = _props2.data, headers = _props2.headers, separator = _props2.separator, filename = _props2.filename, uFEFF = _props2.uFEFF, children = _props2.children, onClick = _props2.onClick, asyncOnClick = _props2.asyncOnClick, enclosingCharacter = _props2.enclosingCharacter, rest = $7f51a3494eda9874$var$_objectWithoutProperties(_props2, [
                    'data',
                    'headers',
                    'separator',
                    'filename',
                    'uFEFF',
                    'children',
                    'onClick',
                    'asyncOnClick',
                    'enclosingCharacter'
                ]);
                var isNodeEnvironment = typeof window === 'undefined';
                var href = isNodeEnvironment ? '' : this.buildURI(data, uFEFF, headers, separator, enclosingCharacter);
                return $7f51a3494eda9874$var$_react2.default.createElement('a', $7f51a3494eda9874$var$_extends({
                    download: filename
                }, rest, {
                    ref: function ref(link) {
                        return _this4.link = link;
                    },
                    target: '_self',
                    href: href,
                    onClick: this.handleClick()
                }), children);
            }
        }
    ]);
    return CSVLink;
}($7f51a3494eda9874$var$_react2.default.Component);
$7f51a3494eda9874$var$CSVLink.defaultProps = $ioMlW.defaultProps;
$7f51a3494eda9874$var$CSVLink.propTypes = $ioMlW.propTypes;
module.exports.default = $7f51a3494eda9874$var$CSVLink;

});


parcelRegister("gAYid", function(module, exports) {


module.exports = (parcelRequire("j5L7k"))((parcelRequire("6HTJH")).resolve("1QZfE")).then(()=>parcelRequire('cWHDN'));

});
parcelRegister("j5L7k", function(module, exports) {
"use strict";

var $17g6b = parcelRequire("17g6b");
module.exports = $17g6b(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("17g6b", function(module, exports) {
"use strict";
var $0d02eec551d2273a$var$cachedBundles = {};
var $0d02eec551d2273a$var$cachedPreloads = {};
var $0d02eec551d2273a$var$cachedPrefetches = {};
function $0d02eec551d2273a$var$getCache(type) {
    switch(type){
        case 'preload':
            return $0d02eec551d2273a$var$cachedPreloads;
        case 'prefetch':
            return $0d02eec551d2273a$var$cachedPrefetches;
        default:
            return $0d02eec551d2273a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $0d02eec551d2273a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("bNcHL", function(module, exports) {


module.exports = (parcelRequire("j5L7k"))((parcelRequire("6HTJH")).resolve("1MzEI")).then(()=>parcelRequire('b95V1'));

});

parcelRegister("izS64", function(module, exports) {


module.exports = (parcelRequire("j5L7k"))((parcelRequire("6HTJH")).resolve("dzTn4")).then(()=>parcelRequire('d3qCb'));

});

parcelRegister("f1EGP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.asap = $af06832436b73a67$var$asap;

var $jQnu6 = parcelRequire("jQnu6");

var $97DTJ = parcelRequire("97DTJ");
const $af06832436b73a67$var$asapQueue = new $jQnu6.AsapQueue();
const $af06832436b73a67$var$taskFactory = new $97DTJ.TaskFactory($af06832436b73a67$var$asapQueue.registerPendingError);
function $af06832436b73a67$var$asap(task) {
    $af06832436b73a67$var$asapQueue.enqueueTask($af06832436b73a67$var$taskFactory.create(task));
}

});
parcelRegister("jQnu6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bc94x = parcelRequire("bc94x");
class $e7251735c0b85bd3$var$AsapQueue {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q, requestFlush: requestFlush } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++)q[scan] = q[scan + this.index];
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = $bc94x.makeRequestCall(this.flush);
        this.requestErrorThrow = $bc94x.makeRequestCallFromTimer(()=>{
            // Throw first error
            if (this.pendingErrors.length) throw this.pendingErrors.shift();
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html
// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.
// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }
// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.
// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }
// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.
// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.
// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// // its existence.
// rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
module.exports.AsapQueue = $e7251735c0b85bd3$var$AsapQueue;

});
parcelRegister("bc94x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeRequestCallFromTimer = $8267da41428ea3b0$var$makeRequestCallFromTimer;
module.exports.makeRequestCallFromMutationObserver = $8267da41428ea3b0$var$makeRequestCallFromMutationObserver;
module.exports.makeRequestCall = void 0;
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const $8267da41428ea3b0$var$scope = typeof $parcel$global !== 'undefined' ? $parcel$global : self;
const $8267da41428ea3b0$var$BrowserMutationObserver = $8267da41428ea3b0$var$scope.MutationObserver || $8267da41428ea3b0$var$scope.WebKitMutationObserver;
function $8267da41428ea3b0$var$makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
function $8267da41428ea3b0$var$makeRequestCallFromMutationObserver(callback) {
    let toggle = 1;
    const observer = new $8267da41428ea3b0$var$BrowserMutationObserver(callback);
    const node = document.createTextNode('');
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const $8267da41428ea3b0$var$makeRequestCall = typeof $8267da41428ea3b0$var$BrowserMutationObserver === 'function' ? // They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
$8267da41428ea3b0$var$makeRequestCallFromMutationObserver : // 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
$8267da41428ea3b0$var$makeRequestCallFromTimer;
module.exports.makeRequestCall = $8267da41428ea3b0$var$makeRequestCall;

});


parcelRegister("97DTJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hv7PN = parcelRequire("hv7PN");
class $6a43b769b1f85373$var$TaskFactory {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new $hv7PN.RawTask(this.onError, (t)=>tasks[tasks.length] = t);
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}
module.exports.TaskFactory = $6a43b769b1f85373$var$TaskFactory;

});
parcelRegister("hv7PN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $cbdb68b1c6111901$var$RawTask {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}
module.exports.RawTask = $cbdb68b1c6111901$var$RawTask;

});



parcelRegister("4W5kO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cp7mo", function(module, exports) {


module.exports = (parcelRequire("j5L7k"))((parcelRequire("6HTJH")).resolve("fIVmS")).then(()=>parcelRequire('eN48r'));

});

parcelRegister("j5Jox", function(module, exports) {

var $8LKEK = parcelRequire("8LKEK");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function stringifiable(obj) {
    // Safely stringify Object.create(null)
    /* istanbul ignore next */ return typeof obj === 'object' && !('toString' in obj) ? Object.prototype.toString.call(obj).slice(8, -1) : obj;
}
var isProduction = typeof $8LKEK === 'object' && true;
function invariant(condition, message) {
    if (!condition) {
        /* istanbul ignore next */ if (isProduction) throw new Error('Invariant failed');
        throw new Error(message());
    }
}
exports.invariant = invariant;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;
var toString = Object.prototype.toString;
function type(obj) {
    return toString.call(obj).slice(8, -1);
}
var assign = Object.assign || /* istanbul ignore next */ function(target, source) {
    getAllKeys(source).forEach(function(key) {
        if (hasOwnProperty.call(source, key)) target[key] = source[key];
    });
    return target;
};
var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ? function(obj) {
    return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj));
} : function(obj) {
    return Object.keys(obj);
};
function copy(object) {
    return Array.isArray(object) ? assign(object.constructor(object.length), object) : type(object) === 'Map' ? new Map(object) : type(object) === 'Set' ? new Set(object) : object && typeof object === 'object' ? assign(Object.create(Object.getPrototypeOf(object)), object) : object;
}
var Context = /** @class */ function() {
    function Context() {
        this.commands = assign({}, defaultCommands);
        this.update = this.update.bind(this);
        // Deprecated: update.extend, update.isEquals and update.newContext
        this.update.extend = this.extend = this.extend.bind(this);
        this.update.isEquals = function(x, y) {
            return x === y;
        };
        this.update.newContext = function() {
            return new Context().update;
        };
    }
    Object.defineProperty(Context.prototype, "isEquals", {
        get: function() {
            return this.update.isEquals;
        },
        set: function(value) {
            this.update.isEquals = value;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.extend = function(directive, fn) {
        this.commands[directive] = fn;
    };
    Context.prototype.update = function(object, $spec) {
        var _this = this;
        var spec = typeof $spec === 'function' ? {
            $apply: $spec
        } : $spec;
        if (!(Array.isArray(object) && Array.isArray(spec))) invariant(!Array.isArray(spec), function() {
            return "update(): You provided an invalid spec to update(). The spec may not contain an array except as the value of $set, $push, $unshift, $splice or any custom command allowing an array value.";
        });
        invariant(typeof spec === 'object' && spec !== null, function() {
            return "update(): You provided an invalid spec to update(). The spec and every included key path must be plain objects containing one of the " + ("following commands: " + Object.keys(_this.commands).join(', ') + ".");
        });
        var nextObject = object;
        getAllKeys(spec).forEach(function(key) {
            if (hasOwnProperty.call(_this.commands, key)) {
                var objectWasNextObject = object === nextObject;
                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
                if (objectWasNextObject && _this.isEquals(nextObject, object)) nextObject = object;
            } else {
                var nextValueForKey = type(object) === 'Map' ? _this.update(object.get(key), spec[key]) : _this.update(object[key], spec[key]);
                var nextObjectValue = type(nextObject) === 'Map' ? nextObject.get(key) : nextObject[key];
                if (!_this.isEquals(nextValueForKey, nextObjectValue) || typeof nextValueForKey === 'undefined' && !hasOwnProperty.call(object, key)) {
                    if (nextObject === object) nextObject = copy(object);
                    if (type(nextObject) === 'Map') nextObject.set(key, nextValueForKey);
                    else nextObject[key] = nextValueForKey;
                }
            }
        });
        return nextObject;
    };
    return Context;
}();
exports.Context = Context;
var defaultCommands = {
    $push: function(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$push');
        return value.length ? nextObject.concat(value) : nextObject;
    },
    $unshift: function(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$unshift');
        return value.length ? value.concat(nextObject) : nextObject;
    },
    $splice: function(value, nextObject, spec, originalObject) {
        invariantSplices(nextObject, spec);
        value.forEach(function(args) {
            invariantSplice(args);
            if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
            splice.apply(nextObject, args);
        });
        return nextObject;
    },
    $set: function(value, _nextObject, spec) {
        invariantSet(spec);
        return value;
    },
    $toggle: function(targets, nextObject) {
        invariantSpecArray(targets, '$toggle');
        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
        targets.forEach(function(target) {
            nextObjectCopy[target] = !nextObject[target];
        });
        return nextObjectCopy;
    },
    $unset: function(value, nextObject, _spec, originalObject) {
        invariantSpecArray(value, '$unset');
        value.forEach(function(key) {
            if (Object.hasOwnProperty.call(nextObject, key)) {
                if (nextObject === originalObject) nextObject = copy(originalObject);
                delete nextObject[key];
            }
        });
        return nextObject;
    },
    $add: function(values, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$add');
        invariantSpecArray(values, '$add');
        if (type(nextObject) === 'Map') values.forEach(function(_a) {
            var key = _a[0], value = _a[1];
            if (nextObject === originalObject && nextObject.get(key) !== value) nextObject = copy(originalObject);
            nextObject.set(key, value);
        });
        else values.forEach(function(value) {
            if (nextObject === originalObject && !nextObject.has(value)) nextObject = copy(originalObject);
            nextObject.add(value);
        });
        return nextObject;
    },
    $remove: function(value, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$remove');
        invariantSpecArray(value, '$remove');
        value.forEach(function(key) {
            if (nextObject === originalObject && nextObject.has(key)) nextObject = copy(originalObject);
            nextObject.delete(key);
        });
        return nextObject;
    },
    $merge: function(value, nextObject, _spec, originalObject) {
        invariantMerge(nextObject, value);
        getAllKeys(value).forEach(function(key) {
            if (value[key] !== nextObject[key]) {
                if (nextObject === originalObject) nextObject = copy(originalObject);
                nextObject[key] = value[key];
            }
        });
        return nextObject;
    },
    $apply: function(value, original) {
        invariantApply(value);
        return value(original);
    }
};
var defaultContext = new Context();
exports.isEquals = defaultContext.update.isEquals;
exports.extend = defaultContext.extend;
exports.default = defaultContext.update;
// @ts-ignore
exports.default.default = module.exports = assign(exports.default, exports);
// invariants
function invariantPushAndUnshift(value, spec, command) {
    invariant(Array.isArray(value), function() {
        return "update(): expected target of " + stringifiable(command) + " to be an array; got " + stringifiable(value) + ".";
    });
    invariantSpecArray(spec[command], command);
}
function invariantSpecArray(spec, command) {
    invariant(Array.isArray(spec), function() {
        return "update(): expected spec of " + stringifiable(command) + " to be an array; got " + stringifiable(spec) + ". " + "Did you forget to wrap your parameter in an array?";
    });
}
function invariantSplices(value, spec) {
    invariant(Array.isArray(value), function() {
        return "Expected $splice target to be an array; got " + stringifiable(value);
    });
    invariantSplice(spec.$splice);
}
function invariantSplice(value) {
    invariant(Array.isArray(value), function() {
        return "update(): expected spec of $splice to be an array of arrays; got " + stringifiable(value) + ". " + "Did you forget to wrap your parameters in an array?";
    });
}
function invariantApply(fn) {
    invariant(typeof fn === 'function', function() {
        return "update(): expected spec of $apply to be a function; got " + stringifiable(fn) + ".";
    });
}
function invariantSet(spec) {
    invariant(Object.keys(spec).length === 1, function() {
        return "Cannot have more than one key in an object with $set";
    });
}
function invariantMerge(target, specValue) {
    invariant(specValue && typeof specValue === 'object', function() {
        return "update(): $merge expects a spec of type 'object'; got " + stringifiable(specValue);
    });
    invariant(target && typeof target === 'object', function() {
        return "update(): $merge expects a target of type 'object'; got " + stringifiable(target);
    });
}
function invariantMapOrSet(target, command) {
    var typeOfTarget = type(target);
    invariant(typeOfTarget === 'Map' || typeOfTarget === 'Set', function() {
        return "update(): " + stringifiable(command) + " expects a target of type Set or Map; got " + stringifiable(typeOfTarget);
    });
}

});

parcelRegister("4A1Hw", function(module, exports) {

$parcel$export(module.exports, "NonFullScreenPageMode", function () { return NonFullScreenPageMode; });
$parcel$export(module.exports, "ReadingDirection", function () { return ReadingDirection; });
$parcel$export(module.exports, "PrintScaling", function () { return PrintScaling; });
$parcel$export(module.exports, "Duplex", function () { return Duplex; });
$parcel$export(module.exports, "default", function () { return $355bd7ffaaf63172$export$2e2bcd8739ae039; });

var $6IKEk = parcelRequire("6IKEk");

var $HB3Cf = parcelRequire("HB3Cf");

var $2npvA = parcelRequire("2npvA");

var $dKRgb = parcelRequire("dKRgb");
parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
var asEnum = function(rawValue, enumType) {
    if (rawValue === undefined) return undefined;
    return enumType[rawValue];
};
var NonFullScreenPageMode;
(function(NonFullScreenPageMode) {
    /**
     * After exiting FullScreen mode, neither the document outline nor thumbnail
     * images should be visible.
     */ NonFullScreenPageMode["UseNone"] = "UseNone";
    /** After exiting FullScreen mode, the document outline should be visible. */ NonFullScreenPageMode["UseOutlines"] = "UseOutlines";
    /** After exiting FullScreen mode, thumbnail images should be visible. */ NonFullScreenPageMode["UseThumbs"] = "UseThumbs";
    /**
     * After exiting FullScreen mode, the optional content group panel should be
     * visible.
     */ NonFullScreenPageMode["UseOC"] = "UseOC";
})(NonFullScreenPageMode || (NonFullScreenPageMode = {}));
var ReadingDirection;
(function(ReadingDirection) {
    /** The predominant reading order is Left to Right. */ ReadingDirection["L2R"] = "L2R";
    /**
     * The predominant reading order is Right to left (including vertical writing
     * systems, such as Chinese, Japanese and Korean).
     */ ReadingDirection["R2L"] = "R2L";
})(ReadingDirection || (ReadingDirection = {}));
var PrintScaling;
(function(PrintScaling) {
    /** No page scaling. */ PrintScaling["None"] = "None";
    /* Use the PDF reader's default print scaling. */ PrintScaling["AppDefault"] = "AppDefault";
})(PrintScaling || (PrintScaling = {}));
var Duplex;
(function(Duplex) {
    /** The PDF reader should print single-sided. */ Duplex["Simplex"] = "Simplex";
    /**
     * The PDF reader should print double sided and flip on the short edge of the
     * sheet.
     */ Duplex["DuplexFlipShortEdge"] = "DuplexFlipShortEdge";
    /**
     * The PDF reader should print double sided and flip on the long edge of the
     * sheet.
     */ Duplex["DuplexFlipLongEdge"] = "DuplexFlipLongEdge";
})(Duplex || (Duplex = {}));
var ViewerPreferences = /** @class */ function() {
    /** @ignore */ function ViewerPreferences(dict) {
        this.dict = dict;
    }
    ViewerPreferences.prototype.lookupBool = function(key) {
        var returnObj = this.dict.lookup((0, $2npvA.default).of(key));
        if (returnObj instanceof (0, $HB3Cf.default)) return returnObj;
        return undefined;
    };
    ViewerPreferences.prototype.lookupName = function(key) {
        var returnObj = this.dict.lookup((0, $2npvA.default).of(key));
        if (returnObj instanceof (0, $2npvA.default)) return returnObj;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.HideToolbar = function() {
        return this.lookupBool('HideToolbar');
    };
    /** @ignore */ ViewerPreferences.prototype.HideMenubar = function() {
        return this.lookupBool('HideMenubar');
    };
    /** @ignore */ ViewerPreferences.prototype.HideWindowUI = function() {
        return this.lookupBool('HideWindowUI');
    };
    /** @ignore */ ViewerPreferences.prototype.FitWindow = function() {
        return this.lookupBool('FitWindow');
    };
    /** @ignore */ ViewerPreferences.prototype.CenterWindow = function() {
        return this.lookupBool('CenterWindow');
    };
    /** @ignore */ ViewerPreferences.prototype.DisplayDocTitle = function() {
        return this.lookupBool('DisplayDocTitle');
    };
    /** @ignore */ ViewerPreferences.prototype.NonFullScreenPageMode = function() {
        return this.lookupName('NonFullScreenPageMode');
    };
    /** @ignore */ ViewerPreferences.prototype.Direction = function() {
        return this.lookupName('Direction');
    };
    /** @ignore */ ViewerPreferences.prototype.PrintScaling = function() {
        return this.lookupName('PrintScaling');
    };
    /** @ignore */ ViewerPreferences.prototype.Duplex = function() {
        return this.lookupName('Duplex');
    };
    /** @ignore */ ViewerPreferences.prototype.PickTrayByPDFSize = function() {
        return this.lookupBool('PickTrayByPDFSize');
    };
    /** @ignore */ ViewerPreferences.prototype.PrintPageRange = function() {
        var PrintPageRange = this.dict.lookup((0, $2npvA.default).of('PrintPageRange'));
        if (PrintPageRange instanceof (0, $6IKEk.default)) return PrintPageRange;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.NumCopies = function() {
        var NumCopies = this.dict.lookup((0, $2npvA.default).of('NumCopies'));
        if (NumCopies instanceof (0, $dKRgb.default)) return NumCopies;
        return undefined;
    };
    /**
     * Returns `true` if PDF readers should hide the toolbar menus when displaying
     * this document.
     * @returns Whether or not toolbars should be hidden.
     */ ViewerPreferences.prototype.getHideToolbar = function() {
        var _a, _b;
        return (_b = (_a = this.HideToolbar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the menu bar when displaying this
     * document.
     * @returns Whether or not the menu bar should be hidden.
     */ ViewerPreferences.prototype.getHideMenubar = function() {
        var _a, _b;
        return (_b = (_a = this.HideMenubar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the user interface elements in
     * the document's window (such as scroll bars and navigation controls),
     * leaving only the document's contents displayed.
     * @returns Whether or not user interface elements should be hidden.
     */ ViewerPreferences.prototype.getHideWindowUI = function() {
        var _a, _b;
        return (_b = (_a = this.HideWindowUI()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should resize the document's window to fit
     * the size of the first displayed page.
     * @returns Whether or not the window should be resized to fit.
     */ ViewerPreferences.prototype.getFitWindow = function() {
        var _a, _b;
        return (_b = (_a = this.FitWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should position the document's window in the
     * center of the screen.
     * @returns Whether or not to center the document window.
     */ ViewerPreferences.prototype.getCenterWindow = function() {
        var _a, _b;
        return (_b = (_a = this.CenterWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if the window's title bar should display the document
     * `Title`, taken from the document metadata (see [[PDFDocument.getTitle]]).
     * Returns `false` if the title bar should instead display the filename of the
     * PDF file.
     * @returns Whether to display the document title.
     */ ViewerPreferences.prototype.getDisplayDocTitle = function() {
        var _a, _b;
        return (_b = (_a = this.DisplayDocTitle()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns the page mode, which tells the PDF reader how to display the
     * document after exiting full-screen mode.
     * @returns The page mode after exiting full-screen mode.
     */ ViewerPreferences.prototype.getNonFullScreenPageMode = function() {
        var _a, _b;
        var mode = (_a = this.NonFullScreenPageMode()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(mode, NonFullScreenPageMode)) !== null && _b !== void 0 ? _b : NonFullScreenPageMode.UseNone;
    };
    /**
     * Returns the predominant reading order for text.
     * @returns The text reading order.
     */ ViewerPreferences.prototype.getReadingDirection = function() {
        var _a, _b;
        var direction = (_a = this.Direction()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(direction, ReadingDirection)) !== null && _b !== void 0 ? _b : ReadingDirection.L2R;
    };
    /**
     * Returns the page scaling option that the PDF reader should select when the
     * print dialog is displayed.
     * @returns The page scaling option.
     */ ViewerPreferences.prototype.getPrintScaling = function() {
        var _a, _b;
        var scaling = (_a = this.PrintScaling()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(scaling, PrintScaling)) !== null && _b !== void 0 ? _b : PrintScaling.AppDefault;
    };
    /**
     * Returns the paper handling option that should be used when printing the
     * file from the print dialog.
     * @returns The paper handling option.
     */ ViewerPreferences.prototype.getDuplex = function() {
        var _a;
        var duplex = (_a = this.Duplex()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return asEnum(duplex, Duplex);
    };
    /**
     * Returns `true` if the PDF page size should be used to select the input
     * paper tray.
     * @returns Whether or not the PDF page size should be used to select the
     *          input paper tray.
     */ ViewerPreferences.prototype.getPickTrayByPDFSize = function() {
        var _a;
        return (_a = this.PickTrayByPDFSize()) === null || _a === void 0 ? void 0 : _a.asBoolean();
    };
    /**
     * Returns an array of page number ranges, which are the values used to
     * initialize the print dialog box when the file is printed. Each range
     * specifies the first (`start`) and last (`end`) pages in a sub-range of
     * pages to be printed. The first page of the PDF file is denoted by 0.
     * For example:
     * ```js
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * const includesPage3 = viewerPrefs
     *   .getPrintRanges()
     *   .some(pr => pr.start =< 2 && pr.end >= 2)
     * if (includesPage3) console.log('printRange includes page 3')
     * ```
     * @returns An array of objects, each with the properties `start` and `end`,
     *          denoting page indices. If not, specified an empty array is
     *          returned.
     */ ViewerPreferences.prototype.getPrintPageRange = function() {
        var rng = this.PrintPageRange();
        if (!rng) return [];
        var pageRanges = [];
        for(var i = 0; i < rng.size(); i += 2){
            // Despite the spec clearly stating that "The first page of the PDF file
            // shall be donoted by 1", several test PDFs (spec 1.7) created in
            // Acrobat XI 11.0 and also read with Reader DC 2020.013 indicate this is
            // actually a 0 based index.
            var start = rng.lookup(i, (0, $dKRgb.default)).asNumber();
            var end = rng.lookup(i + 1, (0, $dKRgb.default)).asNumber();
            pageRanges.push({
                start: start,
                end: end
            });
        }
        return pageRanges;
    };
    /**
     * Returns the number of copies to be printed when the print dialog is opened
     * for this document.
     * @returns The default number of copies to be printed.
     */ ViewerPreferences.prototype.getNumCopies = function() {
        var _a, _b;
        return (_b = (_a = this.NumCopies()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    /**
     * Choose whether the PDF reader's toolbars should be hidden while the
     * document is active.
     * @param hideToolbar `true` if the toolbar should be hidden.
     */ ViewerPreferences.prototype.setHideToolbar = function(hideToolbar) {
        var HideToolbar = this.dict.context.obj(hideToolbar);
        this.dict.set((0, $2npvA.default).of('HideToolbar'), HideToolbar);
    };
    /**
     * Choose whether the PDF reader's menu bar should be hidden while the
     * document is active.
     * @param hideMenubar `true` if the menu bar should be hidden.
     */ ViewerPreferences.prototype.setHideMenubar = function(hideMenubar) {
        var HideMenubar = this.dict.context.obj(hideMenubar);
        this.dict.set((0, $2npvA.default).of('HideMenubar'), HideMenubar);
    };
    /**
     * Choose whether the PDF reader should hide user interface elements in the
     * document's window (such as scroll bars and navigation controls), leaving
     * only the document's contents displayed.
     * @param hideWindowUI `true` if the user interface elements should be hidden.
     */ ViewerPreferences.prototype.setHideWindowUI = function(hideWindowUI) {
        var HideWindowUI = this.dict.context.obj(hideWindowUI);
        this.dict.set((0, $2npvA.default).of('HideWindowUI'), HideWindowUI);
    };
    /**
     * Choose whether the PDF reader should resize the document's window to fit
     * the size of the first displayed page.
     * @param fitWindow `true` if the window should be resized.
     */ ViewerPreferences.prototype.setFitWindow = function(fitWindow) {
        var FitWindow = this.dict.context.obj(fitWindow);
        this.dict.set((0, $2npvA.default).of('FitWindow'), FitWindow);
    };
    /**
     * Choose whether the PDF reader should position the document's window in the
     * center of the screen.
     * @param centerWindow `true` if the window should be centered.
     */ ViewerPreferences.prototype.setCenterWindow = function(centerWindow) {
        var CenterWindow = this.dict.context.obj(centerWindow);
        this.dict.set((0, $2npvA.default).of('CenterWindow'), CenterWindow);
    };
    /**
     * Choose whether the window's title bar should display the document `Title`
     * taken from the document metadata (see [[PDFDocument.setTitle]]). If
     * `false`, the title bar should instead display the PDF filename.
     * @param displayTitle `true` if the document title should be displayed.
     */ ViewerPreferences.prototype.setDisplayDocTitle = function(displayTitle) {
        var DisplayDocTitle = this.dict.context.obj(displayTitle);
        this.dict.set((0, $2npvA.default).of('DisplayDocTitle'), DisplayDocTitle);
    };
    /**
     * Choose how the PDF reader should display the document upon exiting
     * full-screen mode. This entry is meaningful only if the value of the
     * `PageMode` entry in the document's [[PDFCatalog]] is `FullScreen`.
     *
     * For example:
     * ```js
     * import { PDFDocument, NonFullScreenPageMode, PDFName } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     *
     * // Set the PageMode
     * pdfDoc.catalog.set(PDFName.of('PageMode'),PDFName.of('FullScreen'))
     *
     * // Set what happens when full-screen is closed
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setNonFullScreenPageMode(NonFullScreenPageMode.UseOutlines)
     * ```
     *
     * @param nonFullScreenPageMode How the document should be displayed upon
     *                              exiting full screen mode.
     */ ViewerPreferences.prototype.setNonFullScreenPageMode = function(nonFullScreenPageMode) {
        (0, $afaKe.assertIsOneOf)(nonFullScreenPageMode, 'nonFullScreenPageMode', NonFullScreenPageMode);
        var mode = (0, $2npvA.default).of(nonFullScreenPageMode);
        this.dict.set((0, $2npvA.default).of('NonFullScreenPageMode'), mode);
    };
    /**
     * Choose the predominant reading order for text.
     *
     * This entry has no direct effect on the document's contents or page
     * numbering, but may be used to determine the relative positioning of pages
     * when displayed side by side or printed n-up.
     *
     * For example:
     * ```js
     * import { PDFDocument, ReadingDirection } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setReadingDirection(ReadingDirection.R2L)
     * ```
     *
     * @param readingDirection The reading order for text.
     */ ViewerPreferences.prototype.setReadingDirection = function(readingDirection) {
        (0, $afaKe.assertIsOneOf)(readingDirection, 'readingDirection', ReadingDirection);
        var direction = (0, $2npvA.default).of(readingDirection);
        this.dict.set((0, $2npvA.default).of('Direction'), direction);
    };
    /**
     * Choose the page scaling option that should be selected when a print dialog
     * is displayed for this document.
     *
     * For example:
     * ```js
     * import { PDFDocument, PrintScaling } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setPrintScaling(PrintScaling.None)
     * ```
     *
     * @param printScaling The print scaling option.
     */ ViewerPreferences.prototype.setPrintScaling = function(printScaling) {
        (0, $afaKe.assertIsOneOf)(printScaling, 'printScaling', PrintScaling);
        var scaling = (0, $2npvA.default).of(printScaling);
        this.dict.set((0, $2npvA.default).of('PrintScaling'), scaling);
    };
    /**
     * Choose the paper handling option that should be selected by default in the
     * print dialog.
     *
     * For example:
     * ```js
     * import { PDFDocument, Duplex } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setDuplex(Duplex.DuplexFlipShortEdge)
     * ```
     *
     * @param duplex The double or single sided printing option.
     */ ViewerPreferences.prototype.setDuplex = function(duplex) {
        (0, $afaKe.assertIsOneOf)(duplex, 'duplex', Duplex);
        var dup = (0, $2npvA.default).of(duplex);
        this.dict.set((0, $2npvA.default).of('Duplex'), dup);
    };
    /**
     * Choose whether the PDF document's page size should be used to select the
     * input paper tray when printing. This setting influences only the preset
     * values used to populate the print dialog presented by a PDF reader.
     *
     * If PickTrayByPDFSize is true, the check box in the print dialog associated
     * with input paper tray should be checked. This setting has no effect on
     * operating systems that do not provide the ability to pick the input tray
     * by size.
     *
     * @param pickTrayByPDFSize `true` if the document's page size should be used
     *                          to select the input paper tray.
     */ ViewerPreferences.prototype.setPickTrayByPDFSize = function(pickTrayByPDFSize) {
        var PickTrayByPDFSize = this.dict.context.obj(pickTrayByPDFSize);
        this.dict.set((0, $2npvA.default).of('PickTrayByPDFSize'), PickTrayByPDFSize);
    };
    /**
     * Choose the page numbers used to initialize the print dialog box when the
     * file is printed. The first page of the PDF file is denoted by 0.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     *
     * // We can set the default print range to only the first page
     * viewerPrefs.setPrintPageRange({ start: 0, end: 0 })
     *
     * // Or we can supply noncontiguous ranges (e.g. pages 1, 3, and 5-7)
     * viewerPrefs.setPrintPageRange([
     *   { start: 0, end: 0 },
     *   { start: 2, end: 2 },
     *   { start: 4, end: 6 },
     * ])
     * ```
     *
     * @param printPageRange An object or array of objects, each with the
     *                       properties `start` and `end`, denoting a range of
     *                       page indices.
     */ ViewerPreferences.prototype.setPrintPageRange = function(printPageRange) {
        if (!Array.isArray(printPageRange)) printPageRange = [
            printPageRange
        ];
        var flatRange = [];
        for(var idx = 0, len = printPageRange.length; idx < len; idx++){
            flatRange.push(printPageRange[idx].start);
            flatRange.push(printPageRange[idx].end);
        }
        (0, $afaKe.assertEachIs)(flatRange, 'printPageRange', [
            'number'
        ]);
        var pageRanges = this.dict.context.obj(flatRange);
        this.dict.set((0, $2npvA.default).of('PrintPageRange'), pageRanges);
    };
    /**
     * Choose the default number of copies to be printed when the print dialog is
     * opened for this file.
     * @param numCopies The default number of copies.
     */ ViewerPreferences.prototype.setNumCopies = function(numCopies) {
        (0, $afaKe.assertRange)(numCopies, 'numCopies', 1, Number.MAX_VALUE);
        (0, $afaKe.assertInteger)(numCopies, 'numCopies');
        var NumCopies = this.dict.context.obj(numCopies);
        this.dict.set((0, $2npvA.default).of('NumCopies'), NumCopies);
    };
    /** @ignore */ ViewerPreferences.fromDict = function(dict) {
        return new ViewerPreferences(dict);
    };
    /** @ignore */ ViewerPreferences.create = function(context) {
        var dict = context.obj({});
        return new ViewerPreferences(dict);
    };
    return ViewerPreferences;
}();
var $355bd7ffaaf63172$export$2e2bcd8739ae039 = ViewerPreferences;

});
parcelRegister("6IKEk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e4b09c5a33d2444$export$2e2bcd8739ae039; });

var $47XJ3 = parcelRequire("47XJ3");

var $dKRgb = parcelRequire("dKRgb");

var $l0PqT = parcelRequire("l0PqT");

var $90Qf4 = parcelRequire("90Qf4");

var $6AcCU = parcelRequire("6AcCU");
var $4e4b09c5a33d2444$var$PDFArray = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFArray, _super);
    function PDFArray(context) {
        var _this = _super.call(this) || this;
        _this.array = [];
        _this.context = context;
        return _this;
    }
    PDFArray.prototype.size = function() {
        return this.array.length;
    };
    PDFArray.prototype.push = function(object) {
        this.array.push(object);
    };
    PDFArray.prototype.insert = function(index, object) {
        this.array.splice(index, 0, object);
    };
    PDFArray.prototype.indexOf = function(object) {
        var index = this.array.indexOf(object);
        return index === -1 ? undefined : index;
    };
    PDFArray.prototype.remove = function(index) {
        this.array.splice(index, 1);
    };
    PDFArray.prototype.set = function(idx, object) {
        this.array[idx] = object;
    };
    PDFArray.prototype.get = function(index) {
        return this.array[index];
    };
    PDFArray.prototype.lookupMaybe = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookupMaybe.apply(_a, (0, $47XJ3.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.lookup = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookup.apply(_a, (0, $47XJ3.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.asRectangle = function() {
        if (this.size() !== 4) throw new (0, $6AcCU.PDFArrayIsNotRectangleError)(this.size());
        var lowerLeftX = this.lookup(0, (0, $dKRgb.default)).asNumber();
        var lowerLeftY = this.lookup(1, (0, $dKRgb.default)).asNumber();
        var upperRightX = this.lookup(2, (0, $dKRgb.default)).asNumber();
        var upperRightY = this.lookup(3, (0, $dKRgb.default)).asNumber();
        var x = lowerLeftX;
        var y = lowerLeftY;
        var width = upperRightX - lowerLeftX;
        var height = upperRightY - lowerLeftY;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    };
    PDFArray.prototype.asArray = function() {
        return this.array.slice();
    };
    PDFArray.prototype.clone = function(context) {
        var clone = PDFArray.withContext(context || this.context);
        for(var idx = 0, len = this.size(); idx < len; idx++)clone.push(this.array[idx]);
        return clone;
    };
    PDFArray.prototype.toString = function() {
        var arrayString = '[ ';
        for(var idx = 0, len = this.size(); idx < len; idx++){
            arrayString += this.get(idx).toString();
            arrayString += ' ';
        }
        arrayString += ']';
        return arrayString;
    };
    PDFArray.prototype.sizeInBytes = function() {
        var size = 3;
        for(var idx = 0, len = this.size(); idx < len; idx++)size += this.get(idx).sizeInBytes() + 1;
        return size;
    };
    PDFArray.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $90Qf4.default).LeftSquareBracket;
        buffer[offset++] = (0, $90Qf4.default).Space;
        for(var idx = 0, len = this.size(); idx < len; idx++){
            offset += this.get(idx).copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $90Qf4.default).Space;
        }
        buffer[offset++] = (0, $90Qf4.default).RightSquareBracket;
        return offset - initialOffset;
    };
    PDFArray.prototype.scalePDFNumbers = function(x, y) {
        for(var idx = 0, len = this.size(); idx < len; idx++){
            var el = this.lookup(idx);
            if (el instanceof (0, $dKRgb.default)) {
                var factor = idx % 2 === 0 ? x : y;
                this.set(idx, (0, $dKRgb.default).of(el.asNumber() * factor));
            }
        }
    };
    PDFArray.withContext = function(context) {
        return new PDFArray(context);
    };
    return PDFArray;
}((0, $l0PqT.default));
var $4e4b09c5a33d2444$export$2e2bcd8739ae039 = $4e4b09c5a33d2444$var$PDFArray;

});
parcelRegister("47XJ3", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $301625269e9fd3a7$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $301625269e9fd3a7$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $301625269e9fd3a7$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $301625269e9fd3a7$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $301625269e9fd3a7$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__spreadArrays", function () { return $301625269e9fd3a7$export$6388937ca91ccae8; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $301625269e9fd3a7$var$extendStatics = function(d, b) {
    $301625269e9fd3a7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $301625269e9fd3a7$var$extendStatics(d, b);
};
function $301625269e9fd3a7$export$a8ba968b8961cb8a(d, b) {
    $301625269e9fd3a7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $301625269e9fd3a7$export$18ce0697a983be9b = function() {
    $301625269e9fd3a7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $301625269e9fd3a7$export$18ce0697a983be9b.apply(this, arguments);
};
function $301625269e9fd3a7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $301625269e9fd3a7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $301625269e9fd3a7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $301625269e9fd3a7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $301625269e9fd3a7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $301625269e9fd3a7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $301625269e9fd3a7$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $301625269e9fd3a7$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $301625269e9fd3a7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $301625269e9fd3a7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $301625269e9fd3a7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($301625269e9fd3a7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $301625269e9fd3a7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $301625269e9fd3a7$export$10c90e4f7922046c(v) {
    return this instanceof $301625269e9fd3a7$export$10c90e4f7922046c ? (this.v = v, this) : new $301625269e9fd3a7$export$10c90e4f7922046c(v);
}
function $301625269e9fd3a7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $301625269e9fd3a7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $301625269e9fd3a7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $301625269e9fd3a7$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $301625269e9fd3a7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $301625269e9fd3a7$export$19a8beecd37a4c45 === "function" ? $301625269e9fd3a7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $301625269e9fd3a7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $301625269e9fd3a7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $301625269e9fd3a7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $301625269e9fd3a7$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $301625269e9fd3a7$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("dKRgb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a038e297a81b1316$export$2e2bcd8739ae039; });

var $47XJ3 = parcelRequire("47XJ3");
parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
var $bv0iE = parcelRequire("bv0iE");

var $l0PqT = parcelRequire("l0PqT");
var $a038e297a81b1316$var$PDFNumber = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFNumber, _super);
    function PDFNumber(value) {
        var _this = _super.call(this) || this;
        _this.numberValue = value;
        _this.stringValue = (0, $bv0iE.numberToString)(value);
        return _this;
    }
    PDFNumber.prototype.asNumber = function() {
        return this.numberValue;
    };
    /** @deprecated in favor of [[PDFNumber.asNumber]] */ PDFNumber.prototype.value = function() {
        return this.numberValue;
    };
    PDFNumber.prototype.clone = function() {
        return PDFNumber.of(this.numberValue);
    };
    PDFNumber.prototype.toString = function() {
        return this.stringValue;
    };
    PDFNumber.prototype.sizeInBytes = function() {
        return this.stringValue.length;
    };
    PDFNumber.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $8ZzAZ.copyStringIntoBuffer)(this.stringValue, buffer, offset);
        return this.stringValue.length;
    };
    PDFNumber.of = function(value) {
        return new PDFNumber(value);
    };
    return PDFNumber;
}((0, $l0PqT.default));
var $a038e297a81b1316$export$2e2bcd8739ae039 = $a038e297a81b1316$var$PDFNumber;

});
parcelRegister("5w6hV", function(module, exports) {
$parcel$export(module.exports, "arrayAsString", function () { return (parcelRequire("4LYfy")).arrayAsString; });
$parcel$export(module.exports, "byAscendingId", function () { return (parcelRequire("4LYfy")).byAscendingId; });
$parcel$export(module.exports, "canBeConvertedToUint8Array", function () { return (parcelRequire("4LYfy")).canBeConvertedToUint8Array; });
$parcel$export(module.exports, "last", function () { return (parcelRequire("4LYfy")).last; });
$parcel$export(module.exports, "mergeIntoTypedArray", function () { return (parcelRequire("4LYfy")).mergeIntoTypedArray; });
$parcel$export(module.exports, "mergeUint8Arrays", function () { return (parcelRequire("4LYfy")).mergeUint8Arrays; });
$parcel$export(module.exports, "pluckIndices", function () { return (parcelRequire("4LYfy")).pluckIndices; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("4LYfy")).range; });
$parcel$export(module.exports, "reverseArray", function () { return (parcelRequire("4LYfy")).reverseArray; });
$parcel$export(module.exports, "sortedUniq", function () { return (parcelRequire("4LYfy")).sortedUniq; });
$parcel$export(module.exports, "sum", function () { return (parcelRequire("4LYfy")).sum; });
$parcel$export(module.exports, "toUint8Array", function () { return (parcelRequire("4LYfy")).toUint8Array; });
$parcel$export(module.exports, "typedArrayFor", function () { return (parcelRequire("4LYfy")).typedArrayFor; });
$parcel$export(module.exports, "waitForTick", function () { return (parcelRequire("9J7bS")).waitForTick; });
$parcel$export(module.exports, "breakTextIntoLines", function () { return (parcelRequire("8ZzAZ")).breakTextIntoLines; });
$parcel$export(module.exports, "charAtIndex", function () { return (parcelRequire("8ZzAZ")).charAtIndex; });
$parcel$export(module.exports, "charFromCode", function () { return (parcelRequire("8ZzAZ")).charFromCode; });
$parcel$export(module.exports, "charFromHexCode", function () { return (parcelRequire("8ZzAZ")).charFromHexCode; });
$parcel$export(module.exports, "charSplit", function () { return (parcelRequire("8ZzAZ")).charSplit; });
$parcel$export(module.exports, "cleanText", function () { return (parcelRequire("8ZzAZ")).cleanText; });
$parcel$export(module.exports, "copyStringIntoBuffer", function () { return (parcelRequire("8ZzAZ")).copyStringIntoBuffer; });
$parcel$export(module.exports, "findLastMatch", function () { return (parcelRequire("8ZzAZ")).findLastMatch; });
$parcel$export(module.exports, "lineSplit", function () { return (parcelRequire("8ZzAZ")).lineSplit; });
$parcel$export(module.exports, "mergeLines", function () { return (parcelRequire("8ZzAZ")).mergeLines; });
$parcel$export(module.exports, "padStart", function () { return (parcelRequire("8ZzAZ")).padStart; });
$parcel$export(module.exports, "parseDate", function () { return (parcelRequire("8ZzAZ")).parseDate; });
$parcel$export(module.exports, "toCharCode", function () { return (parcelRequire("8ZzAZ")).toCharCode; });
$parcel$export(module.exports, "toCodePoint", function () { return (parcelRequire("8ZzAZ")).toCodePoint; });
$parcel$export(module.exports, "toHexString", function () { return (parcelRequire("8ZzAZ")).toHexString; });
$parcel$export(module.exports, "toHexStringOfMinLength", function () { return (parcelRequire("8ZzAZ")).toHexStringOfMinLength; });
$parcel$export(module.exports, "hasUtf16BOM", function () { return (parcelRequire("asRCt")).hasUtf16BOM; });
$parcel$export(module.exports, "utf16Decode", function () { return (parcelRequire("asRCt")).utf16Decode; });
$parcel$export(module.exports, "utf16Encode", function () { return (parcelRequire("asRCt")).utf16Encode; });
$parcel$export(module.exports, "bytesFor", function () { return (parcelRequire("bv0iE")).bytesFor; });
$parcel$export(module.exports, "numberToString", function () { return (parcelRequire("bv0iE")).numberToString; });
$parcel$export(module.exports, "sizeInBytes", function () { return (parcelRequire("bv0iE")).sizeInBytes; });
$parcel$export(module.exports, "error", function () { return (parcelRequire("ffMdc")).error; });
$parcel$export(module.exports, "encodeToBase64", function () { return (parcelRequire("aLhPo")).encodeToBase64; });
$parcel$export(module.exports, "isStandardFont", function () { return (parcelRequire("5dg82")).isStandardFont; });
$parcel$export(module.exports, "rectanglesAreEqual", function () { return (parcelRequire("5dg82")).rectanglesAreEqual; });
$parcel$export(module.exports, "assertEachIs", function () { return (parcelRequire("afaKe")).assertEachIs; });
$parcel$export(module.exports, "assertInteger", function () { return (parcelRequire("afaKe")).assertInteger; });
$parcel$export(module.exports, "assertIs", function () { return (parcelRequire("afaKe")).assertIs; });
$parcel$export(module.exports, "assertIsOneOf", function () { return (parcelRequire("afaKe")).assertIsOneOf; });
$parcel$export(module.exports, "assertIsOneOfOrUndefined", function () { return (parcelRequire("afaKe")).assertIsOneOfOrUndefined; });
$parcel$export(module.exports, "assertIsSubset", function () { return (parcelRequire("afaKe")).assertIsSubset; });
$parcel$export(module.exports, "assertMultiple", function () { return (parcelRequire("afaKe")).assertMultiple; });
$parcel$export(module.exports, "assertOrUndefined", function () { return (parcelRequire("afaKe")).assertOrUndefined; });
$parcel$export(module.exports, "assertPositive", function () { return (parcelRequire("afaKe")).assertPositive; });
$parcel$export(module.exports, "assertRange", function () { return (parcelRequire("afaKe")).assertRange; });
$parcel$export(module.exports, "assertRangeOrUndefined", function () { return (parcelRequire("afaKe")).assertRangeOrUndefined; });
$parcel$export(module.exports, "pdfDocEncodingDecode", function () { return (parcelRequire("8YZBr")).pdfDocEncodingDecode; });

$parcel$export(module.exports, "Cache", function () { return (parcelRequire("fdd94")).default; });
parcelRequire("4LYfy");
parcelRequire("9J7bS");
parcelRequire("8ZzAZ");
parcelRequire("asRCt");
parcelRequire("bv0iE");
parcelRequire("ffMdc");
parcelRequire("aLhPo");
parcelRequire("5dg82");
parcelRequire("afaKe");
parcelRequire("8YZBr");

var $fdd94 = parcelRequire("fdd94");

});
parcelRegister("4LYfy", function(module, exports) {

$parcel$export(module.exports, "last", function () { return $379a49974822c1aa$export$4c7897fafd92b108; });
$parcel$export(module.exports, "typedArrayFor", function () { return $379a49974822c1aa$export$98b44e66722b6f4d; });
$parcel$export(module.exports, "mergeIntoTypedArray", function () { return $379a49974822c1aa$export$8907b5381cbcd9a7; });
$parcel$export(module.exports, "mergeUint8Arrays", function () { return $379a49974822c1aa$export$99cee7ee2de7e6e4; });
$parcel$export(module.exports, "arrayAsString", function () { return $379a49974822c1aa$export$5f8f9664fe5c5f14; });
$parcel$export(module.exports, "byAscendingId", function () { return $379a49974822c1aa$export$55b6b1f56c6e1ba5; });
$parcel$export(module.exports, "sortedUniq", function () { return $379a49974822c1aa$export$720e3b5aefb27114; });
$parcel$export(module.exports, "reverseArray", function () { return $379a49974822c1aa$export$c9b97e771c4a8302; });
$parcel$export(module.exports, "sum", function () { return $379a49974822c1aa$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "range", function () { return $379a49974822c1aa$export$d02631cccf789723; });
$parcel$export(module.exports, "pluckIndices", function () { return $379a49974822c1aa$export$279d041ff3481d88; });
$parcel$export(module.exports, "canBeConvertedToUint8Array", function () { return $379a49974822c1aa$export$20e9c5ed92218c4b; });
$parcel$export(module.exports, "toUint8Array", function () { return $379a49974822c1aa$export$73470fd2221e6aef; });

var $aLhPo = parcelRequire("aLhPo");

var $8ZzAZ = parcelRequire("8ZzAZ");
var $379a49974822c1aa$export$4c7897fafd92b108 = function(array) {
    return array[array.length - 1];
};
var $379a49974822c1aa$export$98b44e66722b6f4d = function(value) {
    if (value instanceof Uint8Array) return value;
    var length = value.length;
    var typedArray = new Uint8Array(length);
    for(var idx = 0; idx < length; idx++)typedArray[idx] = value.charCodeAt(idx);
    return typedArray;
};
var $379a49974822c1aa$export$8907b5381cbcd9a7 = function() {
    var arrays = [];
    for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
    var arrayCount = arrays.length;
    var typedArrays = [];
    for(var idx = 0; idx < arrayCount; idx++){
        var element = arrays[idx];
        typedArrays[idx] = element instanceof Uint8Array ? element : $379a49974822c1aa$export$98b44e66722b6f4d(element);
    }
    var totalSize = 0;
    for(var idx = 0; idx < arrayCount; idx++)totalSize += arrays[idx].length;
    var merged = new Uint8Array(totalSize);
    var offset = 0;
    for(var arrIdx = 0; arrIdx < arrayCount; arrIdx++){
        var arr = typedArrays[arrIdx];
        for(var byteIdx = 0, arrLen = arr.length; byteIdx < arrLen; byteIdx++)merged[offset++] = arr[byteIdx];
    }
    return merged;
};
var $379a49974822c1aa$export$99cee7ee2de7e6e4 = function(arrays) {
    var totalSize = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++)totalSize += arrays[idx].length;
    var mergedBuffer = new Uint8Array(totalSize);
    var offset = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++){
        var array = arrays[idx];
        mergedBuffer.set(array, offset);
        offset += array.length;
    }
    return mergedBuffer;
};
var $379a49974822c1aa$export$5f8f9664fe5c5f14 = function(array) {
    var str = '';
    for(var idx = 0, len = array.length; idx < len; idx++)str += (0, $8ZzAZ.charFromCode)(array[idx]);
    return str;
};
var $379a49974822c1aa$export$55b6b1f56c6e1ba5 = function(a, b) {
    return a.id - b.id;
};
var $379a49974822c1aa$export$720e3b5aefb27114 = function(array, indexer) {
    var uniq = [];
    for(var idx = 0, len = array.length; idx < len; idx++){
        var curr = array[idx];
        var prev = array[idx - 1];
        if (idx === 0 || indexer(curr) !== indexer(prev)) uniq.push(curr);
    }
    return uniq;
};
var $379a49974822c1aa$export$c9b97e771c4a8302 = function(array) {
    var arrayLen = array.length;
    for(var idx = 0, len = Math.floor(arrayLen / 2); idx < len; idx++){
        var leftIdx = idx;
        var rightIdx = arrayLen - idx - 1;
        var temp = array[idx];
        array[leftIdx] = array[rightIdx];
        array[rightIdx] = temp;
    }
    return array;
};
var $379a49974822c1aa$export$8a63f25cc62965f1 = function(array) {
    var total = 0;
    for(var idx = 0, len = array.length; idx < len; idx++)total += array[idx];
    return total;
};
var $379a49974822c1aa$export$d02631cccf789723 = function(start, end) {
    var arr = new Array(end - start);
    for(var idx = 0, len = arr.length; idx < len; idx++)arr[idx] = start + idx;
    return arr;
};
var $379a49974822c1aa$export$279d041ff3481d88 = function(arr, indices) {
    var plucked = new Array(indices.length);
    for(var idx = 0, len = indices.length; idx < len; idx++)plucked[idx] = arr[indices[idx]];
    return plucked;
};
var $379a49974822c1aa$export$20e9c5ed92218c4b = function(input) {
    return input instanceof Uint8Array || input instanceof ArrayBuffer || typeof input === 'string';
};
var $379a49974822c1aa$export$73470fd2221e6aef = function(input) {
    if (typeof input === 'string') return (0, $aLhPo.decodeFromBase64DataUri)(input);
    else if (input instanceof ArrayBuffer) return new Uint8Array(input);
    else if (input instanceof Uint8Array) return input;
    else throw new TypeError('`input` must be one of `string | ArrayBuffer | Uint8Array`');
};

});
parcelRegister("aLhPo", function(module, exports) {

$parcel$export(module.exports, "encodeToBase64", function () { return $7d5c1f6aefd2b744$export$373f4c3083978ffd; });
$parcel$export(module.exports, "decodeFromBase64DataUri", function () { return $7d5c1f6aefd2b744$export$f6810f5086699d73; });
/*
 * The `chars`, `lookup`, `encode`, and `decode` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ var $7d5c1f6aefd2b744$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $7d5c1f6aefd2b744$var$lookup = new Uint8Array(256);
for(var $7d5c1f6aefd2b744$var$i = 0; $7d5c1f6aefd2b744$var$i < $7d5c1f6aefd2b744$var$chars.length; $7d5c1f6aefd2b744$var$i++)$7d5c1f6aefd2b744$var$lookup[$7d5c1f6aefd2b744$var$chars.charCodeAt($7d5c1f6aefd2b744$var$i)] = $7d5c1f6aefd2b744$var$i;
var $7d5c1f6aefd2b744$export$373f4c3083978ffd = function(bytes) {
    var base64 = '';
    var len = bytes.length;
    for(var i = 0; i < len; i += 3){
        base64 += $7d5c1f6aefd2b744$var$chars[bytes[i] >> 2];
        base64 += $7d5c1f6aefd2b744$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $7d5c1f6aefd2b744$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $7d5c1f6aefd2b744$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
var $7d5c1f6aefd2b744$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $7d5c1f6aefd2b744$var$lookup[base64.charCodeAt(i)];
        encoded2 = $7d5c1f6aefd2b744$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $7d5c1f6aefd2b744$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $7d5c1f6aefd2b744$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
// This regex is designed to be as flexible as possible. It will parse certain
// invalid data URIs.
var $7d5c1f6aefd2b744$var$DATA_URI_PREFIX_REGEX = /^(data)?:?([\w\/\+]+)?;?(charset=[\w-]+|base64)?.*,/i;
var $7d5c1f6aefd2b744$export$f6810f5086699d73 = function(dataUri) {
    var trimmedUri = dataUri.trim();
    var prefix = trimmedUri.substring(0, 100);
    var res = prefix.match($7d5c1f6aefd2b744$var$DATA_URI_PREFIX_REGEX);
    // Assume it's not a data URI - just a plain base64 string
    if (!res) return $7d5c1f6aefd2b744$export$83edfd8fcc66ec17(trimmedUri);
    // Remove the data URI prefix and parse the remainder as a base64 string
    var fullMatch = res[0];
    var data = trimmedUri.substring(fullMatch.length);
    return $7d5c1f6aefd2b744$export$83edfd8fcc66ec17(data);
};

});

parcelRegister("8ZzAZ", function(module, exports) {

$parcel$export(module.exports, "toCharCode", function () { return $68bfa1c699cb7dce$export$d90166409dd04e85; });
$parcel$export(module.exports, "toCodePoint", function () { return $68bfa1c699cb7dce$export$93bf578f015d73f0; });
$parcel$export(module.exports, "toHexStringOfMinLength", function () { return $68bfa1c699cb7dce$export$6ac97d2d1bf41f39; });
$parcel$export(module.exports, "padStart", function () { return $68bfa1c699cb7dce$export$36cf564d487b5178; });
$parcel$export(module.exports, "toHexString", function () { return $68bfa1c699cb7dce$export$f4915efbb94d4d01; });
$parcel$export(module.exports, "charFromCode", function () { return $68bfa1c699cb7dce$export$207031940e6950ad; });
$parcel$export(module.exports, "charFromHexCode", function () { return $68bfa1c699cb7dce$export$ceedd1b69dcde7a5; });
$parcel$export(module.exports, "copyStringIntoBuffer", function () { return $68bfa1c699cb7dce$export$c41a03555c37a984; });
$parcel$export(module.exports, "cleanText", function () { return $68bfa1c699cb7dce$export$6b5e57d20078142b; });
$parcel$export(module.exports, "lineSplit", function () { return $68bfa1c699cb7dce$export$4f60280859794d8c; });
$parcel$export(module.exports, "mergeLines", function () { return $68bfa1c699cb7dce$export$b5bf5e120f07cbe; });
$parcel$export(module.exports, "charAtIndex", function () { return $68bfa1c699cb7dce$export$1a93fc5af577aa5c; });
$parcel$export(module.exports, "charSplit", function () { return $68bfa1c699cb7dce$export$78f5a8ab9b5e7f1e; });
$parcel$export(module.exports, "breakTextIntoLines", function () { return $68bfa1c699cb7dce$export$38936f7739928807; });
$parcel$export(module.exports, "parseDate", function () { return $68bfa1c699cb7dce$export$6b862160d295c8e; });
$parcel$export(module.exports, "findLastMatch", function () { return $68bfa1c699cb7dce$export$dc1d7d42f51764e3; });
var $68bfa1c699cb7dce$export$d90166409dd04e85 = function(character) {
    return character.charCodeAt(0);
};
var $68bfa1c699cb7dce$export$93bf578f015d73f0 = function(character) {
    return character.codePointAt(0);
};
var $68bfa1c699cb7dce$export$6ac97d2d1bf41f39 = function(num, minLength) {
    return $68bfa1c699cb7dce$export$36cf564d487b5178(num.toString(16), minLength, '0').toUpperCase();
};
var $68bfa1c699cb7dce$export$f4915efbb94d4d01 = function(num) {
    return $68bfa1c699cb7dce$export$6ac97d2d1bf41f39(num, 2);
};
var $68bfa1c699cb7dce$export$207031940e6950ad = function(code) {
    return String.fromCharCode(code);
};
var $68bfa1c699cb7dce$export$ceedd1b69dcde7a5 = function(hex) {
    return $68bfa1c699cb7dce$export$207031940e6950ad(parseInt(hex, 16));
};
var $68bfa1c699cb7dce$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = '';
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};
var $68bfa1c699cb7dce$export$c41a03555c37a984 = function(str, buffer, offset) {
    var length = str.length;
    for(var idx = 0; idx < length; idx++)buffer[offset++] = str.charCodeAt(idx);
    return length;
};
var $68bfa1c699cb7dce$export$505d8f7c00d806ca = function(prefix, suffixLength) {
    if (suffixLength === void 0) suffixLength = 4;
    return prefix + "-" + Math.floor(Math.random() * Math.pow(10, suffixLength));
};
var $68bfa1c699cb7dce$export$7c57da42ce8e346f = function(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
var $68bfa1c699cb7dce$export$6b5e57d20078142b = function(text) {
    return text.replace(/\t|\u0085|\u2028|\u2029/g, '    ').replace(/[\b\v]/g, '');
};
var $68bfa1c699cb7dce$export$60bd2eb6e5a75df0 = [
    '\\n',
    '\\f',
    '\\r',
    '\\u000B'
];
var $68bfa1c699cb7dce$export$634cc0013ed0f624 = [
    '\n',
    '\f',
    '\r',
    '\u000B'
];
var $68bfa1c699cb7dce$export$3fc8feceeed3beb0 = function(text) {
    return /^[\n\f\r\u000B]$/.test(text);
};
var $68bfa1c699cb7dce$export$4f60280859794d8c = function(text) {
    return text.split(/[\n\f\r\u000B]/);
};
var $68bfa1c699cb7dce$export$b5bf5e120f07cbe = function(text) {
    return text.replace(/[\n\f\r\u000B]/g, ' ');
};
var $68bfa1c699cb7dce$export$1a93fc5af577aa5c = function(text, index) {
    // Get the first code unit and code unit value
    var cuFirst = text.charCodeAt(index);
    var cuSecond;
    var nextIndex = index + 1;
    var length = 1;
    if (// Check if it's the start of a surrogate pair.
    cuFirst >= 0xd800 && cuFirst <= 0xdbff && // high surrogate
    text.length > nextIndex // there is a next code unit
    ) {
        cuSecond = text.charCodeAt(nextIndex);
        if (cuSecond >= 0xdc00 && cuSecond <= 0xdfff) length = 2; // low surrogate
    }
    return [
        text.slice(index, index + length),
        length
    ];
};
var $68bfa1c699cb7dce$export$78f5a8ab9b5e7f1e = function(text) {
    var chars = [];
    for(var idx = 0, len = text.length; idx < len;){
        var _a = $68bfa1c699cb7dce$export$1a93fc5af577aa5c(text, idx), c = _a[0], cLen = _a[1];
        chars.push(c);
        idx += cLen;
    }
    return chars;
};
var $68bfa1c699cb7dce$var$buildWordBreakRegex = function(wordBreaks) {
    var newlineCharUnion = $68bfa1c699cb7dce$export$60bd2eb6e5a75df0.join('|');
    var escapedRules = [
        '$'
    ];
    for(var idx = 0, len = wordBreaks.length; idx < len; idx++){
        var wordBreak = wordBreaks[idx];
        if ($68bfa1c699cb7dce$export$3fc8feceeed3beb0(wordBreak)) throw new TypeError("`wordBreak` must not include " + newlineCharUnion);
        escapedRules.push(wordBreak === '' ? '.' : $68bfa1c699cb7dce$export$7c57da42ce8e346f(wordBreak));
    }
    var breakRules = escapedRules.join('|');
    return new RegExp("(" + newlineCharUnion + ")|((.*?)(" + breakRules + "))", 'gm');
};
var $68bfa1c699cb7dce$export$38936f7739928807 = function(text, wordBreaks, maxWidth, computeWidthOfText) {
    var regex = $68bfa1c699cb7dce$var$buildWordBreakRegex(wordBreaks);
    var words = $68bfa1c699cb7dce$export$6b5e57d20078142b(text).match(regex);
    var currLine = '';
    var currWidth = 0;
    var lines = [];
    var pushCurrLine = function() {
        if (currLine !== '') lines.push(currLine);
        currLine = '';
        currWidth = 0;
    };
    for(var idx = 0, len = words.length; idx < len; idx++){
        var word = words[idx];
        if ($68bfa1c699cb7dce$export$3fc8feceeed3beb0(word)) pushCurrLine();
        else {
            var width = computeWidthOfText(word);
            if (currWidth + width > maxWidth) pushCurrLine();
            currLine += word;
            currWidth += width;
        }
    }
    pushCurrLine();
    return lines;
};
// See section "7.9.4 Dates" of the PDF specification
var $68bfa1c699cb7dce$var$dateRegex = /^D:(\d\d\d\d)(\d\d)?(\d\d)?(\d\d)?(\d\d)?(\d\d)?([+\-Z])?(\d\d)?'?(\d\d)?'?$/;
var $68bfa1c699cb7dce$export$6b862160d295c8e = function(dateStr) {
    var match = dateStr.match($68bfa1c699cb7dce$var$dateRegex);
    if (!match) return undefined;
    var year = match[1], _a = match[2], month = _a === void 0 ? '01' : _a, _b = match[3], day = _b === void 0 ? '01' : _b, _c = match[4], hours = _c === void 0 ? '00' : _c, _d = match[5], mins = _d === void 0 ? '00' : _d, _e = match[6], secs = _e === void 0 ? '00' : _e, _f = match[7], offsetSign = _f === void 0 ? 'Z' : _f, _g = match[8], offsetHours = _g === void 0 ? '00' : _g, _h = match[9], offsetMins = _h === void 0 ? '00' : _h;
    // http://www.ecma-international.org/ecma-262/5.1/#sec-15.9.1.15
    var tzOffset = offsetSign === 'Z' ? 'Z' : "" + offsetSign + offsetHours + ":" + offsetMins;
    var date = new Date(year + "-" + month + "-" + day + "T" + hours + ":" + mins + ":" + secs + tzOffset);
    return date;
};
var $68bfa1c699cb7dce$export$dc1d7d42f51764e3 = function(value, regex) {
    var _a;
    var position = 0;
    var lastMatch;
    while(position < value.length){
        var match = value.substring(position).match(regex);
        if (!match) return {
            match: lastMatch,
            pos: position
        };
        lastMatch = match;
        position += ((_a = match.index) !== null && _a !== void 0 ? _a : 0) + match[0].length;
    }
    return {
        match: lastMatch,
        pos: position
    };
};

});


parcelRegister("9J7bS", function(module, exports) {

$parcel$export(module.exports, "waitForTick", function () { return $714de4e5aac906e2$export$3b7198a3beef1a5f; });
/**
 * Returns a Promise that resolves after at least one tick of the
 * Macro Task Queue occurs.
 */ var $714de4e5aac906e2$export$3b7198a3beef1a5f = function() {
    return new Promise(function(resolve) {
        setTimeout(function() {
            return resolve();
        }, 0);
    });
};

});

parcelRegister("asRCt", function(module, exports) {

$parcel$export(module.exports, "utf16Encode", function () { return $79e61c9ef666d39d$export$73704d2337848c8e; });
$parcel$export(module.exports, "highSurrogate", function () { return $79e61c9ef666d39d$export$8d3bd4086f36eaeb; });
$parcel$export(module.exports, "lowSurrogate", function () { return $79e61c9ef666d39d$export$382051c72943492d; });
$parcel$export(module.exports, "isWithinBMP", function () { return $79e61c9ef666d39d$export$919ae47c3852aa15; });
$parcel$export(module.exports, "hasSurrogates", function () { return $79e61c9ef666d39d$export$d5ab89e7561b44ab; });
$parcel$export(module.exports, "utf16Decode", function () { return $79e61c9ef666d39d$export$b89f54f9db637f79; });
$parcel$export(module.exports, "hasUtf16BOM", function () { return $79e61c9ef666d39d$export$41e7c15c75b1b24d; });

var $8ZzAZ = parcelRequire("8ZzAZ");
var $79e61c9ef666d39d$export$e1b32e613f230dc6 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xef, 0xbb, 0xbf);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // One byte encoding
        if (codePoint < 0x80) {
            var byte1 = codePoint & 0x7f;
            encoded.push(byte1);
            idx += 1;
        } else if (codePoint < 0x0800) {
            var byte1 = codePoint >> 6 & 0x1f | 0xc0;
            var byte2 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2);
            idx += 1;
        } else if (codePoint < 0x010000) {
            var byte1 = codePoint >> 12 & 0x0f | 0xe0;
            var byte2 = codePoint >> 6 & 0x3f | 0x80;
            var byte3 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3);
            idx += 1;
        } else if (codePoint < 0x110000) {
            var byte1 = codePoint >> 18 & 0x07 | 0xf0;
            var byte2 = codePoint >> 12 & 0x3f | 0x80;
            var byte3 = codePoint >> 6 & 0x3f | 0x80;
            var byte4 = codePoint >> 0 & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3, byte4);
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $8ZzAZ.toHexString)(codePoint));
    }
    return new Uint8Array(encoded);
};
var $79e61c9ef666d39d$export$73704d2337848c8e = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xfeff);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // Two byte encoding
        if (codePoint < 0x010000) {
            encoded.push(codePoint);
            idx += 1;
        } else if (codePoint < 0x110000) {
            encoded.push($79e61c9ef666d39d$export$8d3bd4086f36eaeb(codePoint), $79e61c9ef666d39d$export$382051c72943492d(codePoint));
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $8ZzAZ.toHexString)(codePoint));
    }
    return new Uint16Array(encoded);
};
var $79e61c9ef666d39d$export$919ae47c3852aa15 = function(codePoint) {
    return codePoint >= 0 && codePoint <= 0xffff;
};
var $79e61c9ef666d39d$export$d5ab89e7561b44ab = function(codePoint) {
    return codePoint >= 0x010000 && codePoint <= 0x10ffff;
};
var $79e61c9ef666d39d$export$8d3bd4086f36eaeb = function(codePoint) {
    return Math.floor((codePoint - 0x10000) / 0x400) + 0xd800;
};
var $79e61c9ef666d39d$export$382051c72943492d = function(codePoint) {
    return (codePoint - 0x10000) % 0x400 + 0xdc00;
};
var $79e61c9ef666d39d$var$ByteOrder;
(function(ByteOrder) {
    ByteOrder["BigEndian"] = "BigEndian";
    ByteOrder["LittleEndian"] = "LittleEndian";
})($79e61c9ef666d39d$var$ByteOrder || ($79e61c9ef666d39d$var$ByteOrder = {}));
var $79e61c9ef666d39d$var$REPLACEMENT = "\uFFFD".codePointAt(0);
var $79e61c9ef666d39d$export$b89f54f9db637f79 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    // Need at least 2 bytes of data in UTF-16 encodings
    if (input.length <= 1) return String.fromCodePoint($79e61c9ef666d39d$var$REPLACEMENT);
    var byteOrder = byteOrderMark ? $79e61c9ef666d39d$var$readBOM(input) : $79e61c9ef666d39d$var$ByteOrder.BigEndian;
    // Skip byte order mark if needed
    var idx = byteOrderMark ? 2 : 0;
    var codePoints = [];
    while(input.length - idx >= 2){
        var first = $79e61c9ef666d39d$var$decodeValues(input[idx++], input[idx++], byteOrder);
        if ($79e61c9ef666d39d$var$isHighSurrogate(first)) {
            if (input.length - idx < 2) // Need at least 2 bytes left for the low surrogate that is required
            codePoints.push($79e61c9ef666d39d$var$REPLACEMENT);
            else {
                var second = $79e61c9ef666d39d$var$decodeValues(input[idx++], input[idx++], byteOrder);
                if ($79e61c9ef666d39d$var$isLowSurrogate(second)) codePoints.push(first, second);
                else // Low surrogates should always follow high surrogates
                codePoints.push($79e61c9ef666d39d$var$REPLACEMENT);
            }
        } else if ($79e61c9ef666d39d$var$isLowSurrogate(first)) {
            // High surrogates should always come first since `decodeValues()`
            // accounts for the byte ordering
            idx += 2;
            codePoints.push($79e61c9ef666d39d$var$REPLACEMENT);
        } else codePoints.push(first);
    }
    // There shouldn't be extra byte(s) left over
    if (idx < input.length) codePoints.push($79e61c9ef666d39d$var$REPLACEMENT);
    return String.fromCodePoint.apply(String, codePoints);
};
/**
 * Returns `true` if the given `codePoint` is a high surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $79e61c9ef666d39d$var$isHighSurrogate = function(codePoint) {
    return codePoint >= 0xd800 && codePoint <= 0xdbff;
};
/**
 * Returns `true` if the given `codePoint` is a low surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $79e61c9ef666d39d$var$isLowSurrogate = function(codePoint) {
    return codePoint >= 0xdc00 && codePoint <= 0xdfff;
};
/**
 * Decodes the given utf-16 values first and second using the specified
 * byte order.
 * @param first The first byte of the encoding.
 * @param second The second byte of the encoding.
 * @param byteOrder The byte order of the encoding.
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Examples
 */ var $79e61c9ef666d39d$var$decodeValues = function(first, second, byteOrder) {
    // Append the binary representation of the preceding byte by shifting the
    // first one 8 to the left and than applying a bitwise or-operator to append
    // the second one.
    if (byteOrder === $79e61c9ef666d39d$var$ByteOrder.LittleEndian) return second << 8 | first;
    if (byteOrder === $79e61c9ef666d39d$var$ByteOrder.BigEndian) return first << 8 | second;
    throw new Error("Invalid byteOrder: " + byteOrder);
};
/**
 * Returns whether the given array contains a byte order mark for the
 * UTF-16BE or UTF-16LE encoding. If it has neither, BigEndian is assumed.
 *
 * Reference: https://en.wikipedia.org/wiki/Byte_order_mark#UTF-16
 *
 * @param bytes The byte array to be evaluated.
 */ // prettier-ignore
var $79e61c9ef666d39d$var$readBOM = function(bytes) {
    return $79e61c9ef666d39d$var$hasUtf16BigEndianBOM(bytes) ? $79e61c9ef666d39d$var$ByteOrder.BigEndian : $79e61c9ef666d39d$var$hasUtf16LittleEndianBOM(bytes) ? $79e61c9ef666d39d$var$ByteOrder.LittleEndian : $79e61c9ef666d39d$var$ByteOrder.BigEndian;
};
var $79e61c9ef666d39d$var$hasUtf16BigEndianBOM = function(bytes) {
    return bytes[0] === 0xfe && bytes[1] === 0xff;
};
var $79e61c9ef666d39d$var$hasUtf16LittleEndianBOM = function(bytes) {
    return bytes[0] === 0xff && bytes[1] === 0xfe;
};
var $79e61c9ef666d39d$export$41e7c15c75b1b24d = function(bytes) {
    return $79e61c9ef666d39d$var$hasUtf16BigEndianBOM(bytes) || $79e61c9ef666d39d$var$hasUtf16LittleEndianBOM(bytes);
};

});

parcelRegister("bv0iE", function(module, exports) {

$parcel$export(module.exports, "numberToString", function () { return $85f2d283fd8a4ea4$export$f67be9d9b0e25d7b; });
$parcel$export(module.exports, "sizeInBytes", function () { return $85f2d283fd8a4ea4$export$cc6acfd7a782614d; });
$parcel$export(module.exports, "bytesFor", function () { return $85f2d283fd8a4ea4$export$3c7962b7d5fa4e42; });
// tslint:disable radix
/**
 * Converts a number to its string representation in decimal. This function
 * differs from simply converting a number to a string with `.toString()`
 * because this function's output string will **not** contain exponential
 * notation.
 *
 * Credit: https://stackoverflow.com/a/46545519
 */ var $85f2d283fd8a4ea4$export$f67be9d9b0e25d7b = function(num) {
    var numStr = String(num);
    if (Math.abs(num) < 1.0) {
        var e = parseInt(num.toString().split('e-')[1]);
        if (e) {
            var negative = num < 0;
            if (negative) num *= -1;
            num *= Math.pow(10, e - 1);
            numStr = '0.' + new Array(e).join('0') + num.toString().substring(2);
            if (negative) numStr = '-' + numStr;
        }
    } else {
        var e = parseInt(num.toString().split('+')[1]);
        if (e > 20) {
            e -= 20;
            num /= Math.pow(10, e);
            numStr = num.toString() + new Array(e + 1).join('0');
        }
    }
    return numStr;
};
var $85f2d283fd8a4ea4$export$cc6acfd7a782614d = function(n) {
    return Math.ceil(n.toString(2).length / 8);
};
var $85f2d283fd8a4ea4$export$3c7962b7d5fa4e42 = function(n) {
    var bytes = new Uint8Array($85f2d283fd8a4ea4$export$cc6acfd7a782614d(n));
    for(var i = 1; i <= bytes.length; i++)bytes[i - 1] = n >> (bytes.length - i) * 8;
    return bytes;
};

});

parcelRegister("ffMdc", function(module, exports) {

$parcel$export(module.exports, "error", function () { return $b1ada7a15ca7ee5c$export$a3bc9b8ed74fc; });
var $b1ada7a15ca7ee5c$export$a3bc9b8ed74fc = function(msg) {
    throw new Error(msg);
};

});

parcelRegister("5dg82", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $3cbaad7ae6936ed3$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "isStandardFont", function () { return $3cbaad7ae6936ed3$export$f2950432a4491977; });
$parcel$export(module.exports, "rectanglesAreEqual", function () { return $3cbaad7ae6936ed3$export$93263d7e9f52c023; });
parcelRequire("kLYdZ");
var $9h1QL = parcelRequire("9h1QL");
var $3cbaad7ae6936ed3$export$68c286be0e7e55b7 = function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $3cbaad7ae6936ed3$export$59252e21bbb61725 = $3cbaad7ae6936ed3$export$68c286be0e7e55b7((0, $9h1QL.FontNames));
var $3cbaad7ae6936ed3$export$f2950432a4491977 = function(input) {
    return $3cbaad7ae6936ed3$export$59252e21bbb61725.includes(input);
};
var $3cbaad7ae6936ed3$export$93263d7e9f52c023 = function(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
};

});
parcelRegister("kLYdZ", function(module, exports) {
$parcel$export(module.exports, "Font", function () { return (parcelRequire("9h1QL")).Font; });
$parcel$export(module.exports, "FontNames", function () { return (parcelRequire("9h1QL")).FontNames; });
$parcel$export(module.exports, "Encodings", function () { return (parcelRequire("46WCp")).Encodings; });
parcelRequire("9h1QL");
parcelRequire("46WCp");

});
parcelRegister("9h1QL", function(module, exports) {

$parcel$export(module.exports, "FontNames", function () { return $6c0722f1753d9887$export$a1e7b970f5a14844; });
$parcel$export(module.exports, "Font", function () { return $6c0722f1753d9887$export$89abf52a030e56ee; });

var $hs3eC = parcelRequire("hs3eC");

var $dwFO6 = parcelRequire("dwFO6");

var $9aR4Y = parcelRequire("9aR4Y");

var $34Hk3 = parcelRequire("34Hk3");

var $7U8Ia = parcelRequire("7U8Ia");

var $jOiwc = parcelRequire("jOiwc");

var $hGw79 = parcelRequire("hGw79");

var $15ZGI = parcelRequire("15ZGI");

var $5gLRa = parcelRequire("5gLRa");

var $2koco = parcelRequire("2koco");

var $etDcc = parcelRequire("etDcc");

var $6HerL = parcelRequire("6HerL");

var $102Bh = parcelRequire("102Bh");

var $9nZUm = parcelRequire("9nZUm");

var $iGzmY = parcelRequire("iGzmY");
// prettier-ignore
var $6c0722f1753d9887$var$compressedJsonForFontName = {
    'Courier': (0, (/*@__PURE__*/$parcel$interopDefault($7U8Ia))),
    'Courier-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($dwFO6))),
    'Courier-Oblique': (0, (/*@__PURE__*/$parcel$interopDefault($34Hk3))),
    'Courier-BoldOblique': (0, (/*@__PURE__*/$parcel$interopDefault($9aR4Y))),
    'Helvetica': (0, (/*@__PURE__*/$parcel$interopDefault($5gLRa))),
    'Helvetica-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($jOiwc))),
    'Helvetica-Oblique': (0, (/*@__PURE__*/$parcel$interopDefault($15ZGI))),
    'Helvetica-BoldOblique': (0, (/*@__PURE__*/$parcel$interopDefault($hGw79))),
    'Times-Roman': (0, (/*@__PURE__*/$parcel$interopDefault($102Bh))),
    'Times-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($2koco))),
    'Times-Italic': (0, (/*@__PURE__*/$parcel$interopDefault($6HerL))),
    'Times-BoldItalic': (0, (/*@__PURE__*/$parcel$interopDefault($etDcc))),
    'Symbol': (0, (/*@__PURE__*/$parcel$interopDefault($9nZUm))),
    'ZapfDingbats': (0, (/*@__PURE__*/$parcel$interopDefault($iGzmY)))
};
var $6c0722f1753d9887$export$a1e7b970f5a14844;
(function(FontNames) {
    FontNames["Courier"] = "Courier";
    FontNames["CourierBold"] = "Courier-Bold";
    FontNames["CourierOblique"] = "Courier-Oblique";
    FontNames["CourierBoldOblique"] = "Courier-BoldOblique";
    FontNames["Helvetica"] = "Helvetica";
    FontNames["HelveticaBold"] = "Helvetica-Bold";
    FontNames["HelveticaOblique"] = "Helvetica-Oblique";
    FontNames["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    FontNames["TimesRoman"] = "Times-Roman";
    FontNames["TimesRomanBold"] = "Times-Bold";
    FontNames["TimesRomanItalic"] = "Times-Italic";
    FontNames["TimesRomanBoldItalic"] = "Times-BoldItalic";
    FontNames["Symbol"] = "Symbol";
    FontNames["ZapfDingbats"] = "ZapfDingbats";
})($6c0722f1753d9887$export$a1e7b970f5a14844 || ($6c0722f1753d9887$export$a1e7b970f5a14844 = {}));
var $6c0722f1753d9887$var$fontCache = {};
var $6c0722f1753d9887$export$89abf52a030e56ee = /** @class */ function() {
    function Font() {
        var _this = this;
        this.getWidthOfGlyph = function(glyphName) {
            return _this.CharWidths[glyphName];
        };
        this.getXAxisKerningForPair = function(leftGlyphName, rightGlyphName) {
            return (_this.KernPairXAmounts[leftGlyphName] || {})[rightGlyphName];
        };
    }
    Font.load = function(fontName) {
        var cachedFont = $6c0722f1753d9887$var$fontCache[fontName];
        if (cachedFont) return cachedFont;
        var json = (0, $hs3eC.decompressJson)($6c0722f1753d9887$var$compressedJsonForFontName[fontName]);
        var font = Object.assign(new Font(), JSON.parse(json));
        font.CharWidths = font.CharMetrics.reduce(function(acc, metric) {
            acc[metric.N] = metric.WX;
            return acc;
        }, {});
        font.KernPairXAmounts = font.KernPairs.reduce(function(acc, _a) {
            var name1 = _a[0], name2 = _a[1], width = _a[2];
            if (!acc[name1]) acc[name1] = {};
            acc[name1][name2] = width;
            return acc;
        }, {});
        $6c0722f1753d9887$var$fontCache[fontName] = font;
        return font;
    };
    return Font;
}();

});
parcelRegister("hs3eC", function(module, exports) {

$parcel$export(module.exports, "decompressJson", function () { return $cb478f93e37fa0a7$export$134b8d792d6efd14; });
$parcel$export(module.exports, "padStart", function () { return $cb478f93e37fa0a7$export$36cf564d487b5178; });
/*
 * The `chars`, `lookup`, and `decodeFromBase64` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ 
var $hjofF = parcelRequire("hjofF");
var $cb478f93e37fa0a7$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $cb478f93e37fa0a7$var$lookup = new Uint8Array(256);
for(var $cb478f93e37fa0a7$var$i = 0; $cb478f93e37fa0a7$var$i < $cb478f93e37fa0a7$var$chars.length; $cb478f93e37fa0a7$var$i++)$cb478f93e37fa0a7$var$lookup[$cb478f93e37fa0a7$var$chars.charCodeAt($cb478f93e37fa0a7$var$i)] = $cb478f93e37fa0a7$var$i;
var $cb478f93e37fa0a7$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $cb478f93e37fa0a7$var$lookup[base64.charCodeAt(i)];
        encoded2 = $cb478f93e37fa0a7$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $cb478f93e37fa0a7$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $cb478f93e37fa0a7$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
var $cb478f93e37fa0a7$var$arrayToString = function(array) {
    var str = '';
    for(var i = 0; i < array.length; i++)str += String.fromCharCode(array[i]);
    return str;
};
var $cb478f93e37fa0a7$export$134b8d792d6efd14 = function(compressedJson) {
    return $cb478f93e37fa0a7$var$arrayToString((0, (/*@__PURE__*/$parcel$interopDefault($hjofF))).inflate($cb478f93e37fa0a7$export$83edfd8fcc66ec17(compressedJson)));
};
var $cb478f93e37fa0a7$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = '';
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};

});
parcelRegister("hjofF", function(module, exports) {
// Top level file is just a mixin of submodules & constants
'use strict';

var $4EedN = parcelRequire("4EedN");
var $c9a705e658997743$require$assign = $4EedN.assign;

var $2vCpb = parcelRequire("2vCpb");

var $bnGIQ = parcelRequire("bnGIQ");

var $4CajD = parcelRequire("4CajD");
var $c9a705e658997743$var$pako = {};
$c9a705e658997743$require$assign($c9a705e658997743$var$pako, $2vCpb, $bnGIQ, $4CajD);
module.exports = $c9a705e658997743$var$pako;

});
parcelRegister("4EedN", function(module, exports) {
'use strict';
var $3625edf7823c3b1f$var$TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
function $3625edf7823c3b1f$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
module.exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(var p in source)if ($3625edf7823c3b1f$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
module.exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $3625edf7823c3b1f$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $3625edf7823c3b1f$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
module.exports.setTyped = function(on) {
    if (on) {
        module.exports.Buf8 = Uint8Array;
        module.exports.Buf16 = Uint16Array;
        module.exports.Buf32 = Int32Array;
        module.exports.assign(module.exports, $3625edf7823c3b1f$var$fnTyped);
    } else {
        module.exports.Buf8 = Array;
        module.exports.Buf16 = Array;
        module.exports.Buf32 = Array;
        module.exports.assign(module.exports, $3625edf7823c3b1f$var$fnUntyped);
    }
};
module.exports.setTyped($3625edf7823c3b1f$var$TYPED_OK);

});

parcelRegister("2vCpb", function(module, exports) {

$parcel$export(module.exports, "Deflate", function () { return $1d3c447d17e66cbc$export$ae157b6234afe138; }, function (v) { return $1d3c447d17e66cbc$export$ae157b6234afe138 = v; });
$parcel$export(module.exports, "deflate", function () { return $1d3c447d17e66cbc$export$2316623ecd1285ab; }, function (v) { return $1d3c447d17e66cbc$export$2316623ecd1285ab = v; });
$parcel$export(module.exports, "deflateRaw", function () { return $1d3c447d17e66cbc$export$e95d6a8f69fb340a; }, function (v) { return $1d3c447d17e66cbc$export$e95d6a8f69fb340a = v; });
$parcel$export(module.exports, "gzip", function () { return $1d3c447d17e66cbc$export$69f0ea7cf3a331a8; }, function (v) { return $1d3c447d17e66cbc$export$69f0ea7cf3a331a8 = v; });
var $1d3c447d17e66cbc$export$ae157b6234afe138;
var $1d3c447d17e66cbc$export$2316623ecd1285ab;
var $1d3c447d17e66cbc$export$e95d6a8f69fb340a;
var $1d3c447d17e66cbc$export$69f0ea7cf3a331a8;
'use strict';

var $7PAHm = parcelRequire("7PAHm");

var $4EedN = parcelRequire("4EedN");

var $fpcg6 = parcelRequire("fpcg6");

var $byxFx = parcelRequire("byxFx");

var $Wwmpf = parcelRequire("Wwmpf");
var $1d3c447d17e66cbc$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $1d3c447d17e66cbc$var$Z_NO_FLUSH = 0;
var $1d3c447d17e66cbc$var$Z_FINISH = 4;
var $1d3c447d17e66cbc$var$Z_OK = 0;
var $1d3c447d17e66cbc$var$Z_STREAM_END = 1;
var $1d3c447d17e66cbc$var$Z_SYNC_FLUSH = 2;
var $1d3c447d17e66cbc$var$Z_DEFAULT_COMPRESSION = -1;
var $1d3c447d17e66cbc$var$Z_DEFAULT_STRATEGY = 0;
var $1d3c447d17e66cbc$var$Z_DEFLATED = 8;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $1d3c447d17e66cbc$var$Deflate(options) {
    if (!(this instanceof $1d3c447d17e66cbc$var$Deflate)) return new $1d3c447d17e66cbc$var$Deflate(options);
    this.options = $4EedN.assign({
        level: $1d3c447d17e66cbc$var$Z_DEFAULT_COMPRESSION,
        method: $1d3c447d17e66cbc$var$Z_DEFLATED,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $1d3c447d17e66cbc$var$Z_DEFAULT_STRATEGY,
        to: ''
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $Wwmpf();
    this.strm.avail_out = 0;
    var status = $7PAHm.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $1d3c447d17e66cbc$var$Z_OK) throw new Error($byxFx[status]);
    if (opt.header) $7PAHm.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $fpcg6.string2buf(opt.dictionary);
        else if ($1d3c447d17e66cbc$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $7PAHm.deflateSetDictionary(this.strm, dict);
        if (status !== $1d3c447d17e66cbc$var$Z_OK) throw new Error($byxFx[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $1d3c447d17e66cbc$var$Deflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _mode;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $1d3c447d17e66cbc$var$Z_FINISH : $1d3c447d17e66cbc$var$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $fpcg6.string2buf(data);
    else if ($1d3c447d17e66cbc$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $4EedN.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $7PAHm.deflate(strm, _mode); /* no bad return value */ 
        if (status !== $1d3c447d17e66cbc$var$Z_STREAM_END && status !== $1d3c447d17e66cbc$var$Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === $1d3c447d17e66cbc$var$Z_FINISH || _mode === $1d3c447d17e66cbc$var$Z_SYNC_FLUSH)) {
            if (this.options.to === 'string') this.onData($fpcg6.buf2binstring($4EedN.shrinkBuf(strm.output, strm.next_out)));
            else this.onData($4EedN.shrinkBuf(strm.output, strm.next_out));
        }
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $1d3c447d17e66cbc$var$Z_STREAM_END);
    // Finalize on the last chunk.
    if (_mode === $1d3c447d17e66cbc$var$Z_FINISH) {
        status = $7PAHm.deflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $1d3c447d17e66cbc$var$Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $1d3c447d17e66cbc$var$Z_SYNC_FLUSH) {
        this.onEnd($1d3c447d17e66cbc$var$Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $1d3c447d17e66cbc$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $1d3c447d17e66cbc$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $1d3c447d17e66cbc$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $4EedN.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $1d3c447d17e66cbc$var$deflate(input, options) {
    var deflator = new $1d3c447d17e66cbc$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $byxFx[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $1d3c447d17e66cbc$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $1d3c447d17e66cbc$var$deflate(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $1d3c447d17e66cbc$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $1d3c447d17e66cbc$var$deflate(input, options);
}
$1d3c447d17e66cbc$export$ae157b6234afe138 = $1d3c447d17e66cbc$var$Deflate;
$1d3c447d17e66cbc$export$2316623ecd1285ab = $1d3c447d17e66cbc$var$deflate;
$1d3c447d17e66cbc$export$e95d6a8f69fb340a = $1d3c447d17e66cbc$var$deflateRaw;
$1d3c447d17e66cbc$export$69f0ea7cf3a331a8 = $1d3c447d17e66cbc$var$gzip;

});
parcelRegister("7PAHm", function(module, exports) {

$parcel$export(module.exports, "deflateInit2", function () { return $5b39c35753cc0db9$export$a65c7b2bde87cb70; }, function (v) { return $5b39c35753cc0db9$export$a65c7b2bde87cb70 = v; });
$parcel$export(module.exports, "deflateSetHeader", function () { return $5b39c35753cc0db9$export$1cd50f7b2515ba19; }, function (v) { return $5b39c35753cc0db9$export$1cd50f7b2515ba19 = v; });
$parcel$export(module.exports, "deflate", function () { return $5b39c35753cc0db9$export$2316623ecd1285ab; }, function (v) { return $5b39c35753cc0db9$export$2316623ecd1285ab = v; });
$parcel$export(module.exports, "deflateEnd", function () { return $5b39c35753cc0db9$export$599854fa319a815f; }, function (v) { return $5b39c35753cc0db9$export$599854fa319a815f = v; });
$parcel$export(module.exports, "deflateSetDictionary", function () { return $5b39c35753cc0db9$export$f55e0b3ab66b5d46; }, function (v) { return $5b39c35753cc0db9$export$f55e0b3ab66b5d46 = v; });
var $5b39c35753cc0db9$export$72b35d618fb8ad9b;
var $5b39c35753cc0db9$export$a65c7b2bde87cb70;
var $5b39c35753cc0db9$export$8f99f0e30bc7dd53;
var $5b39c35753cc0db9$export$e78fab288549509;
var $5b39c35753cc0db9$export$1cd50f7b2515ba19;
var $5b39c35753cc0db9$export$2316623ecd1285ab;
var $5b39c35753cc0db9$export$599854fa319a815f;
var $5b39c35753cc0db9$export$f55e0b3ab66b5d46;
var $5b39c35753cc0db9$export$12b6e1fcadea22f9;
'use strict';

var $4EedN = parcelRequire("4EedN");

var $dC7Tl = parcelRequire("dC7Tl");

var $4qNPd = parcelRequire("4qNPd");

var $5s1AD = parcelRequire("5s1AD");

var $byxFx = parcelRequire("byxFx");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $5b39c35753cc0db9$var$Z_NO_FLUSH = 0;
var $5b39c35753cc0db9$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $5b39c35753cc0db9$var$Z_FULL_FLUSH = 3;
var $5b39c35753cc0db9$var$Z_FINISH = 4;
var $5b39c35753cc0db9$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $5b39c35753cc0db9$var$Z_OK = 0;
var $5b39c35753cc0db9$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $5b39c35753cc0db9$var$Z_STREAM_ERROR = -2;
var $5b39c35753cc0db9$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $5b39c35753cc0db9$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $5b39c35753cc0db9$var$Z_DEFAULT_COMPRESSION = -1;
var $5b39c35753cc0db9$var$Z_FILTERED = 1;
var $5b39c35753cc0db9$var$Z_HUFFMAN_ONLY = 2;
var $5b39c35753cc0db9$var$Z_RLE = 3;
var $5b39c35753cc0db9$var$Z_FIXED = 4;
var $5b39c35753cc0db9$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $5b39c35753cc0db9$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $5b39c35753cc0db9$var$Z_DEFLATED = 8;
/*============================================================================*/ var $5b39c35753cc0db9$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $5b39c35753cc0db9$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $5b39c35753cc0db9$var$DEF_MEM_LEVEL = 8;
var $5b39c35753cc0db9$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $5b39c35753cc0db9$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $5b39c35753cc0db9$var$L_CODES = $5b39c35753cc0db9$var$LITERALS + 1 + $5b39c35753cc0db9$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $5b39c35753cc0db9$var$D_CODES = 30;
/* number of distance codes */ var $5b39c35753cc0db9$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $5b39c35753cc0db9$var$HEAP_SIZE = 2 * $5b39c35753cc0db9$var$L_CODES + 1;
/* maximum heap size */ var $5b39c35753cc0db9$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $5b39c35753cc0db9$var$MIN_MATCH = 3;
var $5b39c35753cc0db9$var$MAX_MATCH = 258;
var $5b39c35753cc0db9$var$MIN_LOOKAHEAD = $5b39c35753cc0db9$var$MAX_MATCH + $5b39c35753cc0db9$var$MIN_MATCH + 1;
var $5b39c35753cc0db9$var$PRESET_DICT = 0x20;
var $5b39c35753cc0db9$var$INIT_STATE = 42;
var $5b39c35753cc0db9$var$EXTRA_STATE = 69;
var $5b39c35753cc0db9$var$NAME_STATE = 73;
var $5b39c35753cc0db9$var$COMMENT_STATE = 91;
var $5b39c35753cc0db9$var$HCRC_STATE = 103;
var $5b39c35753cc0db9$var$BUSY_STATE = 113;
var $5b39c35753cc0db9$var$FINISH_STATE = 666;
var $5b39c35753cc0db9$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $5b39c35753cc0db9$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $5b39c35753cc0db9$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $5b39c35753cc0db9$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $5b39c35753cc0db9$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $5b39c35753cc0db9$var$err(strm, errorCode) {
    strm.msg = $byxFx[errorCode];
    return errorCode;
}
function $5b39c35753cc0db9$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $5b39c35753cc0db9$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $5b39c35753cc0db9$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $4EedN.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $5b39c35753cc0db9$var$flush_block_only(s, last) {
    $dC7Tl._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $5b39c35753cc0db9$var$flush_pending(s.strm);
}
function $5b39c35753cc0db9$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $5b39c35753cc0db9$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $5b39c35753cc0db9$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $4EedN.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $4qNPd(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $5s1AD(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $5b39c35753cc0db9$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $5b39c35753cc0db9$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $5b39c35753cc0db9$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $5b39c35753cc0db9$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $5b39c35753cc0db9$var$MAX_MATCH - (strend - scan);
        scan = strend - $5b39c35753cc0db9$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $5b39c35753cc0db9$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $5b39c35753cc0db9$var$MIN_LOOKAHEAD)) {
            $4EedN.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $5b39c35753cc0db9$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $5b39c35753cc0db9$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $5b39c35753cc0db9$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $5b39c35753cc0db9$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $5b39c35753cc0db9$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $5b39c35753cc0db9$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $5b39c35753cc0db9$var$fill_window(s);
            if (s.lookahead === 0 && flush === $5b39c35753cc0db9$var$Z_NO_FLUSH) return $5b39c35753cc0db9$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $5b39c35753cc0db9$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $5b39c35753cc0db9$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $5b39c35753cc0db9$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $5b39c35753cc0db9$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $5b39c35753cc0db9$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_FINISH_STARTED;
        /***/ return $5b39c35753cc0db9$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $5b39c35753cc0db9$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_NEED_MORE;
    /***/ }
    return $5b39c35753cc0db9$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $5b39c35753cc0db9$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $5b39c35753cc0db9$var$MIN_LOOKAHEAD) {
            $5b39c35753cc0db9$var$fill_window(s);
            if (s.lookahead < $5b39c35753cc0db9$var$MIN_LOOKAHEAD && flush === $5b39c35753cc0db9$var$Z_NO_FLUSH) return $5b39c35753cc0db9$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $5b39c35753cc0db9$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $5b39c35753cc0db9$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $5b39c35753cc0db9$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $5b39c35753cc0db9$var$longest_match(s, hash_head);
        if (s.match_length >= $5b39c35753cc0db9$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $dC7Tl._tr_tally(s, s.strstart - s.match_start, s.match_length - $5b39c35753cc0db9$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $5b39c35753cc0db9$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $5b39c35753cc0db9$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $dC7Tl._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $5b39c35753cc0db9$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $5b39c35753cc0db9$var$MIN_MATCH - 1 ? s.strstart : $5b39c35753cc0db9$var$MIN_MATCH - 1;
    if (flush === $5b39c35753cc0db9$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $5b39c35753cc0db9$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_FINISH_STARTED;
        /***/ return $5b39c35753cc0db9$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $5b39c35753cc0db9$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_NEED_MORE;
    /***/ }
    return $5b39c35753cc0db9$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $5b39c35753cc0db9$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $5b39c35753cc0db9$var$MIN_LOOKAHEAD) {
            $5b39c35753cc0db9$var$fill_window(s);
            if (s.lookahead < $5b39c35753cc0db9$var$MIN_LOOKAHEAD && flush === $5b39c35753cc0db9$var$Z_NO_FLUSH) return $5b39c35753cc0db9$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $5b39c35753cc0db9$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $5b39c35753cc0db9$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $5b39c35753cc0db9$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $5b39c35753cc0db9$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $5b39c35753cc0db9$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $5b39c35753cc0db9$var$Z_FILTERED || s.match_length === $5b39c35753cc0db9$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $5b39c35753cc0db9$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $5b39c35753cc0db9$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $5b39c35753cc0db9$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $dC7Tl._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $5b39c35753cc0db9$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $5b39c35753cc0db9$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $5b39c35753cc0db9$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $5b39c35753cc0db9$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $dC7Tl._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $5b39c35753cc0db9$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $dC7Tl._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $5b39c35753cc0db9$var$MIN_MATCH - 1 ? s.strstart : $5b39c35753cc0db9$var$MIN_MATCH - 1;
    if (flush === $5b39c35753cc0db9$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $5b39c35753cc0db9$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_FINISH_STARTED;
        /***/ return $5b39c35753cc0db9$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $5b39c35753cc0db9$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_NEED_MORE;
    /***/ }
    return $5b39c35753cc0db9$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $5b39c35753cc0db9$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $5b39c35753cc0db9$var$MAX_MATCH) {
            $5b39c35753cc0db9$var$fill_window(s);
            if (s.lookahead <= $5b39c35753cc0db9$var$MAX_MATCH && flush === $5b39c35753cc0db9$var$Z_NO_FLUSH) return $5b39c35753cc0db9$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $5b39c35753cc0db9$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $5b39c35753cc0db9$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $5b39c35753cc0db9$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $5b39c35753cc0db9$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $dC7Tl._tr_tally(s, 1, s.match_length - $5b39c35753cc0db9$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $dC7Tl._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $5b39c35753cc0db9$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $5b39c35753cc0db9$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $5b39c35753cc0db9$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_FINISH_STARTED;
        /***/ return $5b39c35753cc0db9$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $5b39c35753cc0db9$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_NEED_MORE;
    /***/ }
    return $5b39c35753cc0db9$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $5b39c35753cc0db9$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $5b39c35753cc0db9$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $5b39c35753cc0db9$var$Z_NO_FLUSH) return $5b39c35753cc0db9$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $dC7Tl._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $5b39c35753cc0db9$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $5b39c35753cc0db9$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $5b39c35753cc0db9$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_FINISH_STARTED;
        /***/ return $5b39c35753cc0db9$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $5b39c35753cc0db9$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $5b39c35753cc0db9$var$BS_NEED_MORE;
    /***/ }
    return $5b39c35753cc0db9$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $5b39c35753cc0db9$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $5b39c35753cc0db9$var$configuration_table;
$5b39c35753cc0db9$var$configuration_table = [
    /*      good lazy nice chain */ new $5b39c35753cc0db9$var$Config(0, 0, 0, 0, $5b39c35753cc0db9$var$deflate_stored),
    /* 0 store only */ new $5b39c35753cc0db9$var$Config(4, 4, 8, 4, $5b39c35753cc0db9$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $5b39c35753cc0db9$var$Config(4, 5, 16, 8, $5b39c35753cc0db9$var$deflate_fast),
    /* 2 */ new $5b39c35753cc0db9$var$Config(4, 6, 32, 32, $5b39c35753cc0db9$var$deflate_fast),
    /* 3 */ new $5b39c35753cc0db9$var$Config(4, 4, 16, 16, $5b39c35753cc0db9$var$deflate_slow),
    /* 4 lazy matches */ new $5b39c35753cc0db9$var$Config(8, 16, 32, 32, $5b39c35753cc0db9$var$deflate_slow),
    /* 5 */ new $5b39c35753cc0db9$var$Config(8, 16, 128, 128, $5b39c35753cc0db9$var$deflate_slow),
    /* 6 */ new $5b39c35753cc0db9$var$Config(8, 32, 128, 256, $5b39c35753cc0db9$var$deflate_slow),
    /* 7 */ new $5b39c35753cc0db9$var$Config(32, 128, 258, 1024, $5b39c35753cc0db9$var$deflate_slow),
    /* 8 */ new $5b39c35753cc0db9$var$Config(32, 258, 258, 4096, $5b39c35753cc0db9$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $5b39c35753cc0db9$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $5b39c35753cc0db9$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $5b39c35753cc0db9$var$configuration_table[s.level].max_lazy;
    s.good_match = $5b39c35753cc0db9$var$configuration_table[s.level].good_length;
    s.nice_match = $5b39c35753cc0db9$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $5b39c35753cc0db9$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $5b39c35753cc0db9$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $5b39c35753cc0db9$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $5b39c35753cc0db9$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $4EedN.Buf16($5b39c35753cc0db9$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $4EedN.Buf16((2 * $5b39c35753cc0db9$var$D_CODES + 1) * 2);
    this.bl_tree = new $4EedN.Buf16((2 * $5b39c35753cc0db9$var$BL_CODES + 1) * 2);
    $5b39c35753cc0db9$var$zero(this.dyn_ltree);
    $5b39c35753cc0db9$var$zero(this.dyn_dtree);
    $5b39c35753cc0db9$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $4EedN.Buf16($5b39c35753cc0db9$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $4EedN.Buf16(2 * $5b39c35753cc0db9$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $5b39c35753cc0db9$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $4EedN.Buf16(2 * $5b39c35753cc0db9$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $5b39c35753cc0db9$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $5b39c35753cc0db9$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $5b39c35753cc0db9$var$err(strm, $5b39c35753cc0db9$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $5b39c35753cc0db9$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $5b39c35753cc0db9$var$INIT_STATE : $5b39c35753cc0db9$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $5b39c35753cc0db9$var$Z_NO_FLUSH;
    $dC7Tl._tr_init(s);
    return $5b39c35753cc0db9$var$Z_OK;
}
function $5b39c35753cc0db9$var$deflateReset(strm) {
    var ret = $5b39c35753cc0db9$var$deflateResetKeep(strm);
    if (ret === $5b39c35753cc0db9$var$Z_OK) $5b39c35753cc0db9$var$lm_init(strm.state);
    return ret;
}
function $5b39c35753cc0db9$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $5b39c35753cc0db9$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $5b39c35753cc0db9$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $5b39c35753cc0db9$var$Z_OK;
}
function $5b39c35753cc0db9$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $5b39c35753cc0db9$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $5b39c35753cc0db9$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $5b39c35753cc0db9$var$MAX_MEM_LEVEL || method !== $5b39c35753cc0db9$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $5b39c35753cc0db9$var$Z_FIXED) return $5b39c35753cc0db9$var$err(strm, $5b39c35753cc0db9$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $5b39c35753cc0db9$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $5b39c35753cc0db9$var$MIN_MATCH - 1) / $5b39c35753cc0db9$var$MIN_MATCH);
    s.window = new $4EedN.Buf8(s.w_size * 2);
    s.head = new $4EedN.Buf16(s.hash_size);
    s.prev = new $4EedN.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $4EedN.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $5b39c35753cc0db9$var$deflateReset(strm);
}
function $5b39c35753cc0db9$var$deflateInit(strm, level) {
    return $5b39c35753cc0db9$var$deflateInit2(strm, level, $5b39c35753cc0db9$var$Z_DEFLATED, $5b39c35753cc0db9$var$MAX_WBITS, $5b39c35753cc0db9$var$DEF_MEM_LEVEL, $5b39c35753cc0db9$var$Z_DEFAULT_STRATEGY);
}
function $5b39c35753cc0db9$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $5b39c35753cc0db9$var$Z_BLOCK || flush < 0) return strm ? $5b39c35753cc0db9$var$err(strm, $5b39c35753cc0db9$var$Z_STREAM_ERROR) : $5b39c35753cc0db9$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $5b39c35753cc0db9$var$FINISH_STATE && flush !== $5b39c35753cc0db9$var$Z_FINISH) return $5b39c35753cc0db9$var$err(strm, strm.avail_out === 0 ? $5b39c35753cc0db9$var$Z_BUF_ERROR : $5b39c35753cc0db9$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $5b39c35753cc0db9$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $5b39c35753cc0db9$var$put_byte(s, 31);
            $5b39c35753cc0db9$var$put_byte(s, 139);
            $5b39c35753cc0db9$var$put_byte(s, 8);
            if (!s.gzhead) {
                $5b39c35753cc0db9$var$put_byte(s, 0);
                $5b39c35753cc0db9$var$put_byte(s, 0);
                $5b39c35753cc0db9$var$put_byte(s, 0);
                $5b39c35753cc0db9$var$put_byte(s, 0);
                $5b39c35753cc0db9$var$put_byte(s, 0);
                $5b39c35753cc0db9$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $5b39c35753cc0db9$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $5b39c35753cc0db9$var$put_byte(s, $5b39c35753cc0db9$var$OS_CODE);
                s.status = $5b39c35753cc0db9$var$BUSY_STATE;
            } else {
                $5b39c35753cc0db9$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $5b39c35753cc0db9$var$put_byte(s, s.gzhead.time & 0xff);
                $5b39c35753cc0db9$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $5b39c35753cc0db9$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $5b39c35753cc0db9$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $5b39c35753cc0db9$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $5b39c35753cc0db9$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $5b39c35753cc0db9$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $5b39c35753cc0db9$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $5b39c35753cc0db9$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $5s1AD(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $5b39c35753cc0db9$var$EXTRA_STATE;
            }
        } else {
            var header = $5b39c35753cc0db9$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $5b39c35753cc0db9$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $5b39c35753cc0db9$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $5b39c35753cc0db9$var$BUSY_STATE;
            $5b39c35753cc0db9$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $5b39c35753cc0db9$var$putShortMSB(s, strm.adler >>> 16);
                $5b39c35753cc0db9$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $5b39c35753cc0db9$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5s1AD(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $5b39c35753cc0db9$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $5b39c35753cc0db9$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5s1AD(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $5b39c35753cc0db9$var$NAME_STATE;
            }
        } else s.status = $5b39c35753cc0db9$var$NAME_STATE;
    }
    if (s.status === $5b39c35753cc0db9$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5s1AD(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $5b39c35753cc0db9$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $5b39c35753cc0db9$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5s1AD(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $5b39c35753cc0db9$var$COMMENT_STATE;
            }
        } else s.status = $5b39c35753cc0db9$var$COMMENT_STATE;
    }
    if (s.status === $5b39c35753cc0db9$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5s1AD(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $5b39c35753cc0db9$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $5b39c35753cc0db9$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5s1AD(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $5b39c35753cc0db9$var$HCRC_STATE;
        } else s.status = $5b39c35753cc0db9$var$HCRC_STATE;
    }
    if (s.status === $5b39c35753cc0db9$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $5b39c35753cc0db9$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $5b39c35753cc0db9$var$put_byte(s, strm.adler & 0xff);
                $5b39c35753cc0db9$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $5b39c35753cc0db9$var$BUSY_STATE;
            }
        } else s.status = $5b39c35753cc0db9$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $5b39c35753cc0db9$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $5b39c35753cc0db9$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $5b39c35753cc0db9$var$rank(flush) <= $5b39c35753cc0db9$var$rank(old_flush) && flush !== $5b39c35753cc0db9$var$Z_FINISH) return $5b39c35753cc0db9$var$err(strm, $5b39c35753cc0db9$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $5b39c35753cc0db9$var$FINISH_STATE && strm.avail_in !== 0) return $5b39c35753cc0db9$var$err(strm, $5b39c35753cc0db9$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $5b39c35753cc0db9$var$Z_NO_FLUSH && s.status !== $5b39c35753cc0db9$var$FINISH_STATE) {
        var bstate = s.strategy === $5b39c35753cc0db9$var$Z_HUFFMAN_ONLY ? $5b39c35753cc0db9$var$deflate_huff(s, flush) : s.strategy === $5b39c35753cc0db9$var$Z_RLE ? $5b39c35753cc0db9$var$deflate_rle(s, flush) : $5b39c35753cc0db9$var$configuration_table[s.level].func(s, flush);
        if (bstate === $5b39c35753cc0db9$var$BS_FINISH_STARTED || bstate === $5b39c35753cc0db9$var$BS_FINISH_DONE) s.status = $5b39c35753cc0db9$var$FINISH_STATE;
        if (bstate === $5b39c35753cc0db9$var$BS_NEED_MORE || bstate === $5b39c35753cc0db9$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $5b39c35753cc0db9$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $5b39c35753cc0db9$var$BS_BLOCK_DONE) {
            if (flush === $5b39c35753cc0db9$var$Z_PARTIAL_FLUSH) $dC7Tl._tr_align(s);
            else if (flush !== $5b39c35753cc0db9$var$Z_BLOCK) {
                $dC7Tl._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $5b39c35753cc0db9$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $5b39c35753cc0db9$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $5b39c35753cc0db9$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $5b39c35753cc0db9$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $5b39c35753cc0db9$var$Z_FINISH) return $5b39c35753cc0db9$var$Z_OK;
    if (s.wrap <= 0) return $5b39c35753cc0db9$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $5b39c35753cc0db9$var$put_byte(s, strm.adler & 0xff);
        $5b39c35753cc0db9$var$put_byte(s, strm.adler >> 8 & 0xff);
        $5b39c35753cc0db9$var$put_byte(s, strm.adler >> 16 & 0xff);
        $5b39c35753cc0db9$var$put_byte(s, strm.adler >> 24 & 0xff);
        $5b39c35753cc0db9$var$put_byte(s, strm.total_in & 0xff);
        $5b39c35753cc0db9$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $5b39c35753cc0db9$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $5b39c35753cc0db9$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $5b39c35753cc0db9$var$putShortMSB(s, strm.adler >>> 16);
        $5b39c35753cc0db9$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $5b39c35753cc0db9$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $5b39c35753cc0db9$var$Z_OK : $5b39c35753cc0db9$var$Z_STREAM_END;
}
function $5b39c35753cc0db9$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $5b39c35753cc0db9$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $5b39c35753cc0db9$var$INIT_STATE && status !== $5b39c35753cc0db9$var$EXTRA_STATE && status !== $5b39c35753cc0db9$var$NAME_STATE && status !== $5b39c35753cc0db9$var$COMMENT_STATE && status !== $5b39c35753cc0db9$var$HCRC_STATE && status !== $5b39c35753cc0db9$var$BUSY_STATE && status !== $5b39c35753cc0db9$var$FINISH_STATE) return $5b39c35753cc0db9$var$err(strm, $5b39c35753cc0db9$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $5b39c35753cc0db9$var$BUSY_STATE ? $5b39c35753cc0db9$var$err(strm, $5b39c35753cc0db9$var$Z_DATA_ERROR) : $5b39c35753cc0db9$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $5b39c35753cc0db9$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $5b39c35753cc0db9$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $5b39c35753cc0db9$var$INIT_STATE || s.lookahead) return $5b39c35753cc0db9$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $4qNPd(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $5b39c35753cc0db9$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $4EedN.Buf8(s.w_size);
        $4EedN.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $5b39c35753cc0db9$var$fill_window(s);
    while(s.lookahead >= $5b39c35753cc0db9$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($5b39c35753cc0db9$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $5b39c35753cc0db9$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $5b39c35753cc0db9$var$MIN_MATCH - 1;
        $5b39c35753cc0db9$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $5b39c35753cc0db9$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $5b39c35753cc0db9$var$Z_OK;
}
$5b39c35753cc0db9$export$72b35d618fb8ad9b = $5b39c35753cc0db9$var$deflateInit;
$5b39c35753cc0db9$export$a65c7b2bde87cb70 = $5b39c35753cc0db9$var$deflateInit2;
$5b39c35753cc0db9$export$8f99f0e30bc7dd53 = $5b39c35753cc0db9$var$deflateReset;
$5b39c35753cc0db9$export$e78fab288549509 = $5b39c35753cc0db9$var$deflateResetKeep;
$5b39c35753cc0db9$export$1cd50f7b2515ba19 = $5b39c35753cc0db9$var$deflateSetHeader;
$5b39c35753cc0db9$export$2316623ecd1285ab = $5b39c35753cc0db9$var$deflate;
$5b39c35753cc0db9$export$599854fa319a815f = $5b39c35753cc0db9$var$deflateEnd;
$5b39c35753cc0db9$export$f55e0b3ab66b5d46 = $5b39c35753cc0db9$var$deflateSetDictionary;
$5b39c35753cc0db9$export$12b6e1fcadea22f9 = 'pako deflate (from Nodeca project)'; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

});
parcelRegister("dC7Tl", function(module, exports) {

$parcel$export(module.exports, "_tr_init", function () { return $9e94f211a0a23071$export$4e4fc0157c3cd14d; }, function (v) { return $9e94f211a0a23071$export$4e4fc0157c3cd14d = v; });
$parcel$export(module.exports, "_tr_stored_block", function () { return $9e94f211a0a23071$export$8959e34c5e020172; }, function (v) { return $9e94f211a0a23071$export$8959e34c5e020172 = v; });
$parcel$export(module.exports, "_tr_flush_block", function () { return $9e94f211a0a23071$export$44f15b52eef0cf41; }, function (v) { return $9e94f211a0a23071$export$44f15b52eef0cf41 = v; });
$parcel$export(module.exports, "_tr_tally", function () { return $9e94f211a0a23071$export$b3cbce147289408f; }, function (v) { return $9e94f211a0a23071$export$b3cbce147289408f = v; });
$parcel$export(module.exports, "_tr_align", function () { return $9e94f211a0a23071$export$bfb360e02ee9b403; }, function (v) { return $9e94f211a0a23071$export$bfb360e02ee9b403 = v; });
var $9e94f211a0a23071$export$4e4fc0157c3cd14d;
var $9e94f211a0a23071$export$8959e34c5e020172;
var $9e94f211a0a23071$export$44f15b52eef0cf41;
var $9e94f211a0a23071$export$b3cbce147289408f;
var $9e94f211a0a23071$export$bfb360e02ee9b403;
'use strict';

var $4EedN = parcelRequire("4EedN");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $9e94f211a0a23071$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $9e94f211a0a23071$var$Z_BINARY = 0;
var $9e94f211a0a23071$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $9e94f211a0a23071$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $9e94f211a0a23071$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $9e94f211a0a23071$var$STORED_BLOCK = 0;
var $9e94f211a0a23071$var$STATIC_TREES = 1;
var $9e94f211a0a23071$var$DYN_TREES = 2;
/* The three kinds of block type */ var $9e94f211a0a23071$var$MIN_MATCH = 3;
var $9e94f211a0a23071$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $9e94f211a0a23071$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $9e94f211a0a23071$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $9e94f211a0a23071$var$L_CODES = $9e94f211a0a23071$var$LITERALS + 1 + $9e94f211a0a23071$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $9e94f211a0a23071$var$D_CODES = 30;
/* number of distance codes */ var $9e94f211a0a23071$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $9e94f211a0a23071$var$HEAP_SIZE = 2 * $9e94f211a0a23071$var$L_CODES + 1;
/* maximum heap size */ var $9e94f211a0a23071$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $9e94f211a0a23071$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $9e94f211a0a23071$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $9e94f211a0a23071$var$END_BLOCK = 256;
/* end of block literal code */ var $9e94f211a0a23071$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $9e94f211a0a23071$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $9e94f211a0a23071$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $9e94f211a0a23071$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $9e94f211a0a23071$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $9e94f211a0a23071$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $9e94f211a0a23071$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $9e94f211a0a23071$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $9e94f211a0a23071$var$static_ltree = new Array(($9e94f211a0a23071$var$L_CODES + 2) * 2);
$9e94f211a0a23071$var$zero($9e94f211a0a23071$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $9e94f211a0a23071$var$static_dtree = new Array($9e94f211a0a23071$var$D_CODES * 2);
$9e94f211a0a23071$var$zero($9e94f211a0a23071$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $9e94f211a0a23071$var$_dist_code = new Array($9e94f211a0a23071$var$DIST_CODE_LEN);
$9e94f211a0a23071$var$zero($9e94f211a0a23071$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $9e94f211a0a23071$var$_length_code = new Array($9e94f211a0a23071$var$MAX_MATCH - $9e94f211a0a23071$var$MIN_MATCH + 1);
$9e94f211a0a23071$var$zero($9e94f211a0a23071$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $9e94f211a0a23071$var$base_length = new Array($9e94f211a0a23071$var$LENGTH_CODES);
$9e94f211a0a23071$var$zero($9e94f211a0a23071$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $9e94f211a0a23071$var$base_dist = new Array($9e94f211a0a23071$var$D_CODES);
$9e94f211a0a23071$var$zero($9e94f211a0a23071$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $9e94f211a0a23071$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $9e94f211a0a23071$var$static_l_desc;
var $9e94f211a0a23071$var$static_d_desc;
var $9e94f211a0a23071$var$static_bl_desc;
function $9e94f211a0a23071$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $9e94f211a0a23071$var$d_code(dist) {
    return dist < 256 ? $9e94f211a0a23071$var$_dist_code[dist] : $9e94f211a0a23071$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $9e94f211a0a23071$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $9e94f211a0a23071$var$send_bits(s, value, length) {
    if (s.bi_valid > $9e94f211a0a23071$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $9e94f211a0a23071$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $9e94f211a0a23071$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $9e94f211a0a23071$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $9e94f211a0a23071$var$send_code(s, c, tree) {
    $9e94f211a0a23071$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $9e94f211a0a23071$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $9e94f211a0a23071$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $9e94f211a0a23071$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $9e94f211a0a23071$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $9e94f211a0a23071$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $9e94f211a0a23071$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $9e94f211a0a23071$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($9e94f211a0a23071$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $9e94f211a0a23071$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $9e94f211a0a23071$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $9e94f211a0a23071$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($9e94f211a0a23071$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $9e94f211a0a23071$var$LENGTH_CODES - 1; code++){
        $9e94f211a0a23071$var$base_length[code] = length;
        for(n = 0; n < 1 << $9e94f211a0a23071$var$extra_lbits[code]; n++)$9e94f211a0a23071$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $9e94f211a0a23071$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $9e94f211a0a23071$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $9e94f211a0a23071$var$extra_dbits[code]; n++)$9e94f211a0a23071$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $9e94f211a0a23071$var$D_CODES; code++){
        $9e94f211a0a23071$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $9e94f211a0a23071$var$extra_dbits[code] - 7; n++)$9e94f211a0a23071$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $9e94f211a0a23071$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $9e94f211a0a23071$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $9e94f211a0a23071$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $9e94f211a0a23071$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $9e94f211a0a23071$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $9e94f211a0a23071$var$gen_codes($9e94f211a0a23071$var$static_ltree, $9e94f211a0a23071$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $9e94f211a0a23071$var$D_CODES; n++){
        $9e94f211a0a23071$var$static_dtree[n * 2 + 1] = 5;
        $9e94f211a0a23071$var$static_dtree[n * 2] = $9e94f211a0a23071$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $9e94f211a0a23071$var$static_l_desc = new $9e94f211a0a23071$var$StaticTreeDesc($9e94f211a0a23071$var$static_ltree, $9e94f211a0a23071$var$extra_lbits, $9e94f211a0a23071$var$LITERALS + 1, $9e94f211a0a23071$var$L_CODES, $9e94f211a0a23071$var$MAX_BITS);
    $9e94f211a0a23071$var$static_d_desc = new $9e94f211a0a23071$var$StaticTreeDesc($9e94f211a0a23071$var$static_dtree, $9e94f211a0a23071$var$extra_dbits, 0, $9e94f211a0a23071$var$D_CODES, $9e94f211a0a23071$var$MAX_BITS);
    $9e94f211a0a23071$var$static_bl_desc = new $9e94f211a0a23071$var$StaticTreeDesc(new Array(0), $9e94f211a0a23071$var$extra_blbits, 0, $9e94f211a0a23071$var$BL_CODES, $9e94f211a0a23071$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $9e94f211a0a23071$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $9e94f211a0a23071$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $9e94f211a0a23071$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $9e94f211a0a23071$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$9e94f211a0a23071$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $9e94f211a0a23071$var$bi_windup(s) {
    if (s.bi_valid > 8) $9e94f211a0a23071$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $9e94f211a0a23071$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $9e94f211a0a23071$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $9e94f211a0a23071$var$put_short(s, len);
        $9e94f211a0a23071$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $4EedN.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $9e94f211a0a23071$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $9e94f211a0a23071$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $9e94f211a0a23071$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($9e94f211a0a23071$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $9e94f211a0a23071$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $9e94f211a0a23071$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $9e94f211a0a23071$var$_length_code[lc];
            $9e94f211a0a23071$var$send_code(s, code + $9e94f211a0a23071$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $9e94f211a0a23071$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $9e94f211a0a23071$var$base_length[code];
                $9e94f211a0a23071$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $9e94f211a0a23071$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $9e94f211a0a23071$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $9e94f211a0a23071$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $9e94f211a0a23071$var$base_dist[code];
                $9e94f211a0a23071$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $9e94f211a0a23071$var$send_code(s, $9e94f211a0a23071$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $9e94f211a0a23071$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $9e94f211a0a23071$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$9e94f211a0a23071$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $9e94f211a0a23071$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $9e94f211a0a23071$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $9e94f211a0a23071$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $9e94f211a0a23071$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $9e94f211a0a23071$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$9e94f211a0a23071$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$9e94f211a0a23071$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$9e94f211a0a23071$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $9e94f211a0a23071$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $9e94f211a0a23071$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $9e94f211a0a23071$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $9e94f211a0a23071$var$send_code(s, $9e94f211a0a23071$var$REP_3_6, s.bl_tree);
            $9e94f211a0a23071$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $9e94f211a0a23071$var$send_code(s, $9e94f211a0a23071$var$REPZ_3_10, s.bl_tree);
            $9e94f211a0a23071$var$send_bits(s, count - 3, 3);
        } else {
            $9e94f211a0a23071$var$send_code(s, $9e94f211a0a23071$var$REPZ_11_138, s.bl_tree);
            $9e94f211a0a23071$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $9e94f211a0a23071$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $9e94f211a0a23071$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $9e94f211a0a23071$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $9e94f211a0a23071$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $9e94f211a0a23071$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$9e94f211a0a23071$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $9e94f211a0a23071$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $9e94f211a0a23071$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $9e94f211a0a23071$var$send_bits(s, dcodes - 1, 5);
    $9e94f211a0a23071$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $9e94f211a0a23071$var$send_bits(s, s.bl_tree[$9e94f211a0a23071$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $9e94f211a0a23071$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $9e94f211a0a23071$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $9e94f211a0a23071$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $9e94f211a0a23071$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $9e94f211a0a23071$var$Z_TEXT;
    for(n = 32; n < $9e94f211a0a23071$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $9e94f211a0a23071$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $9e94f211a0a23071$var$Z_BINARY;
}
var $9e94f211a0a23071$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $9e94f211a0a23071$var$_tr_init(s) {
    if (!$9e94f211a0a23071$var$static_init_done) {
        $9e94f211a0a23071$var$tr_static_init();
        $9e94f211a0a23071$var$static_init_done = true;
    }
    s.l_desc = new $9e94f211a0a23071$var$TreeDesc(s.dyn_ltree, $9e94f211a0a23071$var$static_l_desc);
    s.d_desc = new $9e94f211a0a23071$var$TreeDesc(s.dyn_dtree, $9e94f211a0a23071$var$static_d_desc);
    s.bl_desc = new $9e94f211a0a23071$var$TreeDesc(s.bl_tree, $9e94f211a0a23071$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $9e94f211a0a23071$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $9e94f211a0a23071$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $9e94f211a0a23071$var$send_bits(s, ($9e94f211a0a23071$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $9e94f211a0a23071$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $9e94f211a0a23071$var$_tr_align(s) {
    $9e94f211a0a23071$var$send_bits(s, $9e94f211a0a23071$var$STATIC_TREES << 1, 3);
    $9e94f211a0a23071$var$send_code(s, $9e94f211a0a23071$var$END_BLOCK, $9e94f211a0a23071$var$static_ltree);
    $9e94f211a0a23071$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $9e94f211a0a23071$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $9e94f211a0a23071$var$Z_UNKNOWN) s.strm.data_type = $9e94f211a0a23071$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $9e94f211a0a23071$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $9e94f211a0a23071$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $9e94f211a0a23071$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $9e94f211a0a23071$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $9e94f211a0a23071$var$Z_FIXED || static_lenb === opt_lenb) {
        $9e94f211a0a23071$var$send_bits(s, ($9e94f211a0a23071$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $9e94f211a0a23071$var$compress_block(s, $9e94f211a0a23071$var$static_ltree, $9e94f211a0a23071$var$static_dtree);
    } else {
        $9e94f211a0a23071$var$send_bits(s, ($9e94f211a0a23071$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $9e94f211a0a23071$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $9e94f211a0a23071$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $9e94f211a0a23071$var$init_block(s);
    if (last) $9e94f211a0a23071$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $9e94f211a0a23071$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($9e94f211a0a23071$var$_length_code[lc] + $9e94f211a0a23071$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$9e94f211a0a23071$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$9e94f211a0a23071$export$4e4fc0157c3cd14d = $9e94f211a0a23071$var$_tr_init;
$9e94f211a0a23071$export$8959e34c5e020172 = $9e94f211a0a23071$var$_tr_stored_block;
$9e94f211a0a23071$export$44f15b52eef0cf41 = $9e94f211a0a23071$var$_tr_flush_block;
$9e94f211a0a23071$export$b3cbce147289408f = $9e94f211a0a23071$var$_tr_tally;
$9e94f211a0a23071$export$bfb360e02ee9b403 = $9e94f211a0a23071$var$_tr_align;

});

parcelRegister("4qNPd", function(module, exports) {
'use strict';
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $33a03d584e7e4501$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = $33a03d584e7e4501$var$adler32;

});

parcelRegister("5s1AD", function(module, exports) {
'use strict';
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $3f80ccfa16f76bf4$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $3f80ccfa16f76bf4$var$crcTable = $3f80ccfa16f76bf4$var$makeTable();
function $3f80ccfa16f76bf4$var$crc32(crc, buf, len, pos) {
    var t = $3f80ccfa16f76bf4$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = $3f80ccfa16f76bf4$var$crc32;

});

parcelRegister("byxFx", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};

});


parcelRegister("fpcg6", function(module, exports) {

$parcel$export(module.exports, "string2buf", function () { return $b372b32203c918a2$export$7a4c1b2f775b5a9f; }, function (v) { return $b372b32203c918a2$export$7a4c1b2f775b5a9f = v; });
$parcel$export(module.exports, "buf2binstring", function () { return $b372b32203c918a2$export$a751fe64af8a9a51; }, function (v) { return $b372b32203c918a2$export$a751fe64af8a9a51 = v; });
$parcel$export(module.exports, "binstring2buf", function () { return $b372b32203c918a2$export$1d1a7119601ff18c; }, function (v) { return $b372b32203c918a2$export$1d1a7119601ff18c = v; });
$parcel$export(module.exports, "buf2string", function () { return $b372b32203c918a2$export$49a50563f377746; }, function (v) { return $b372b32203c918a2$export$49a50563f377746 = v; });
$parcel$export(module.exports, "utf8border", function () { return $b372b32203c918a2$export$53dee3f58a714214; }, function (v) { return $b372b32203c918a2$export$53dee3f58a714214 = v; });
// String encode/decode helpers
// convert string to array (typed, when possible)
var $b372b32203c918a2$export$7a4c1b2f775b5a9f;
// Convert byte array to binary string
var $b372b32203c918a2$export$a751fe64af8a9a51;
// Convert binary string (typed, when possible)
var $b372b32203c918a2$export$1d1a7119601ff18c;
// convert array to string
var $b372b32203c918a2$export$49a50563f377746;
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $b372b32203c918a2$export$53dee3f58a714214;
'use strict';

var $4EedN = parcelRequire("4EedN");
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $b372b32203c918a2$var$STR_APPLY_OK = true;
var $b372b32203c918a2$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, [
        0
    ]);
} catch (__) {
    $b372b32203c918a2$var$STR_APPLY_OK = false;
}
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $b372b32203c918a2$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $b372b32203c918a2$var$_utf8len = new $4EedN.Buf8(256);
for(var $b372b32203c918a2$var$q = 0; $b372b32203c918a2$var$q < 256; $b372b32203c918a2$var$q++)$b372b32203c918a2$var$_utf8len[$b372b32203c918a2$var$q] = $b372b32203c918a2$var$q >= 252 ? 6 : $b372b32203c918a2$var$q >= 248 ? 5 : $b372b32203c918a2$var$q >= 240 ? 4 : $b372b32203c918a2$var$q >= 224 ? 3 : $b372b32203c918a2$var$q >= 192 ? 2 : 1;
$b372b32203c918a2$var$_utf8len[254] = $b372b32203c918a2$var$_utf8len[254] = 1; // Invalid sequence start
$b372b32203c918a2$export$7a4c1b2f775b5a9f = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new $4EedN.Buf8(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper (used in 2 places)
function $b372b32203c918a2$var$buf2binstring(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $b372b32203c918a2$var$STR_APPLY_UIA_OK || !buf.subarray && $b372b32203c918a2$var$STR_APPLY_OK) return String.fromCharCode.apply(null, $4EedN.shrinkBuf(buf, len));
    }
    var result = '';
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
}
$b372b32203c918a2$export$a751fe64af8a9a51 = function(buf) {
    return $b372b32203c918a2$var$buf2binstring(buf, buf.length);
};
$b372b32203c918a2$export$1d1a7119601ff18c = function(str) {
    var buf = new $4EedN.Buf8(str.length);
    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
    return buf;
};
$b372b32203c918a2$export$49a50563f377746 = function(buf, max) {
    var i, out, c, c_len;
    var len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $b372b32203c918a2$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $b372b32203c918a2$var$buf2binstring(utf16buf, out);
};
$b372b32203c918a2$export$53dee3f58a714214 = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $b372b32203c918a2$var$_utf8len[buf[pos]] > max ? pos : max;
};

});

parcelRegister("Wwmpf", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $0afe84fe5ba55e29$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = $0afe84fe5ba55e29$var$ZStream;

});


parcelRegister("bnGIQ", function(module, exports) {

$parcel$export(module.exports, "Inflate", function () { return $8492fb76fa35e661$export$d1de70a877d6e43c; }, function (v) { return $8492fb76fa35e661$export$d1de70a877d6e43c = v; });
$parcel$export(module.exports, "inflate", function () { return $8492fb76fa35e661$export$cae1ce83fe4a1782; }, function (v) { return $8492fb76fa35e661$export$cae1ce83fe4a1782 = v; });
$parcel$export(module.exports, "inflateRaw", function () { return $8492fb76fa35e661$export$d0f0aa2d05c905c5; }, function (v) { return $8492fb76fa35e661$export$d0f0aa2d05c905c5 = v; });
$parcel$export(module.exports, "ungzip", function () { return $8492fb76fa35e661$export$95adf9d270383091; }, function (v) { return $8492fb76fa35e661$export$95adf9d270383091 = v; });
/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $8492fb76fa35e661$export$d1de70a877d6e43c;
var $8492fb76fa35e661$export$cae1ce83fe4a1782;
var $8492fb76fa35e661$export$d0f0aa2d05c905c5;
var $8492fb76fa35e661$export$95adf9d270383091;
'use strict';

var $jqssV = parcelRequire("jqssV");

var $4EedN = parcelRequire("4EedN");

var $fpcg6 = parcelRequire("fpcg6");

var $4CajD = parcelRequire("4CajD");

var $byxFx = parcelRequire("byxFx");

var $Wwmpf = parcelRequire("Wwmpf");

var $4YdHs = parcelRequire("4YdHs");
var $8492fb76fa35e661$var$toString = Object.prototype.toString;
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $8492fb76fa35e661$var$Inflate(options) {
    if (!(this instanceof $8492fb76fa35e661$var$Inflate)) return new $8492fb76fa35e661$var$Inflate(options);
    this.options = $4EedN.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ''
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $Wwmpf();
    this.strm.avail_out = 0;
    var status = $jqssV.inflateInit2(this.strm, opt.windowBits);
    if (status !== $4CajD.Z_OK) throw new Error($byxFx[status]);
    this.header = new $4YdHs();
    $jqssV.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $fpcg6.string2buf(opt.dictionary);
        else if ($8492fb76fa35e661$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $jqssV.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $4CajD.Z_OK) throw new Error($byxFx[status]);
        }
    }
}
/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $8492fb76fa35e661$var$Inflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _mode;
    var next_out_utf8, tail, utf8str;
    // Flag to properly process Z_BUF_ERROR on testing inflate call
    // when we check that all output data was flushed.
    var allowBufError = false;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $4CajD.Z_FINISH : $4CajD.Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // Only binary strings can be decompressed on practice
    strm.input = $fpcg6.binstring2buf(data);
    else if ($8492fb76fa35e661$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $4EedN.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $jqssV.inflate(strm, $4CajD.Z_NO_FLUSH); /* no bad return value */ 
        if (status === $4CajD.Z_NEED_DICT && dictionary) status = $jqssV.inflateSetDictionary(this.strm, dictionary);
        if (status === $4CajD.Z_BUF_ERROR && allowBufError === true) {
            status = $4CajD.Z_OK;
            allowBufError = false;
        }
        if (status !== $4CajD.Z_STREAM_END && status !== $4CajD.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $4CajD.Z_STREAM_END || strm.avail_in === 0 && (_mode === $4CajD.Z_FINISH || _mode === $4CajD.Z_SYNC_FLUSH)) {
                if (this.options.to === 'string') {
                    next_out_utf8 = $fpcg6.utf8border(strm.output, strm.next_out);
                    tail = strm.next_out - next_out_utf8;
                    utf8str = $fpcg6.buf2string(strm.output, next_out_utf8);
                    // move tail
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) $4EedN.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                    this.onData(utf8str);
                } else this.onData($4EedN.shrinkBuf(strm.output, strm.next_out));
            }
        }
        // When no more input data, we should check that internal inflate buffers
        // are flushed. The only way to do it when avail_out = 0 - run one more
        // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
        // Here we set flag to process this error properly.
        //
        // NOTE. Deflate does not return error in this case and does not needs such
        // logic.
        if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $4CajD.Z_STREAM_END);
    if (status === $4CajD.Z_STREAM_END) _mode = $4CajD.Z_FINISH;
    // Finalize on the last chunk.
    if (_mode === $4CajD.Z_FINISH) {
        status = $jqssV.inflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $4CajD.Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $4CajD.Z_SYNC_FLUSH) {
        this.onEnd($4CajD.Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $8492fb76fa35e661$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $8492fb76fa35e661$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $4CajD.Z_OK) {
        if (this.options.to === 'string') // Glue & convert here, until we teach pako to send
        // utf8 aligned strings to onData
        this.result = this.chunks.join('');
        else this.result = $4EedN.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $8492fb76fa35e661$var$inflate(input, options) {
    var inflator = new $8492fb76fa35e661$var$Inflate(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $byxFx[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $8492fb76fa35e661$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $8492fb76fa35e661$var$inflate(input, options);
}
$8492fb76fa35e661$export$d1de70a877d6e43c = $8492fb76fa35e661$var$Inflate;
$8492fb76fa35e661$export$cae1ce83fe4a1782 = $8492fb76fa35e661$var$inflate;
$8492fb76fa35e661$export$d0f0aa2d05c905c5 = $8492fb76fa35e661$var$inflateRaw;
$8492fb76fa35e661$export$95adf9d270383091 = $8492fb76fa35e661$var$inflate;

});
parcelRegister("jqssV", function(module, exports) {

$parcel$export(module.exports, "inflateInit2", function () { return $e24686b5e0b8c28a$export$6792d92addc5c8a0; }, function (v) { return $e24686b5e0b8c28a$export$6792d92addc5c8a0 = v; });
$parcel$export(module.exports, "inflate", function () { return $e24686b5e0b8c28a$export$cae1ce83fe4a1782; }, function (v) { return $e24686b5e0b8c28a$export$cae1ce83fe4a1782 = v; });
$parcel$export(module.exports, "inflateEnd", function () { return $e24686b5e0b8c28a$export$224e1a443c3fba76; }, function (v) { return $e24686b5e0b8c28a$export$224e1a443c3fba76 = v; });
$parcel$export(module.exports, "inflateGetHeader", function () { return $e24686b5e0b8c28a$export$6d4647cb9e1c75fc; }, function (v) { return $e24686b5e0b8c28a$export$6d4647cb9e1c75fc = v; });
$parcel$export(module.exports, "inflateSetDictionary", function () { return $e24686b5e0b8c28a$export$60da749bed98ccf8; }, function (v) { return $e24686b5e0b8c28a$export$60da749bed98ccf8 = v; });
var $e24686b5e0b8c28a$export$42de45683a92ba94;
var $e24686b5e0b8c28a$export$7633ac2cd30f9650;
var $e24686b5e0b8c28a$export$6710ea52c4ec9d6a;
var $e24686b5e0b8c28a$export$9c140b25e26874f9;
var $e24686b5e0b8c28a$export$6792d92addc5c8a0;
var $e24686b5e0b8c28a$export$cae1ce83fe4a1782;
var $e24686b5e0b8c28a$export$224e1a443c3fba76;
var $e24686b5e0b8c28a$export$6d4647cb9e1c75fc;
var $e24686b5e0b8c28a$export$60da749bed98ccf8;
var $e24686b5e0b8c28a$export$220f6291ca35fd71;
'use strict';

var $4EedN = parcelRequire("4EedN");

var $4qNPd = parcelRequire("4qNPd");

var $5s1AD = parcelRequire("5s1AD");

var $9P4SH = parcelRequire("9P4SH");

var $3NUEH = parcelRequire("3NUEH");
var $e24686b5e0b8c28a$var$CODES = 0;
var $e24686b5e0b8c28a$var$LENS = 1;
var $e24686b5e0b8c28a$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $e24686b5e0b8c28a$var$Z_FINISH = 4;
var $e24686b5e0b8c28a$var$Z_BLOCK = 5;
var $e24686b5e0b8c28a$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $e24686b5e0b8c28a$var$Z_OK = 0;
var $e24686b5e0b8c28a$var$Z_STREAM_END = 1;
var $e24686b5e0b8c28a$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $e24686b5e0b8c28a$var$Z_STREAM_ERROR = -2;
var $e24686b5e0b8c28a$var$Z_DATA_ERROR = -3;
var $e24686b5e0b8c28a$var$Z_MEM_ERROR = -4;
var $e24686b5e0b8c28a$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $e24686b5e0b8c28a$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $e24686b5e0b8c28a$var$HEAD = 1; /* i: waiting for magic header */ 
var $e24686b5e0b8c28a$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $e24686b5e0b8c28a$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $e24686b5e0b8c28a$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $e24686b5e0b8c28a$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $e24686b5e0b8c28a$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $e24686b5e0b8c28a$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $e24686b5e0b8c28a$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $e24686b5e0b8c28a$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $e24686b5e0b8c28a$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $e24686b5e0b8c28a$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $e24686b5e0b8c28a$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $e24686b5e0b8c28a$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $e24686b5e0b8c28a$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $e24686b5e0b8c28a$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $e24686b5e0b8c28a$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $e24686b5e0b8c28a$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $e24686b5e0b8c28a$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $e24686b5e0b8c28a$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $e24686b5e0b8c28a$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $e24686b5e0b8c28a$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $e24686b5e0b8c28a$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $e24686b5e0b8c28a$var$DIST = 23; /* i: waiting for distance code */ 
var $e24686b5e0b8c28a$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $e24686b5e0b8c28a$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $e24686b5e0b8c28a$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $e24686b5e0b8c28a$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $e24686b5e0b8c28a$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $e24686b5e0b8c28a$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $e24686b5e0b8c28a$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $e24686b5e0b8c28a$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $e24686b5e0b8c28a$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $e24686b5e0b8c28a$var$ENOUGH_LENS = 852;
var $e24686b5e0b8c28a$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $e24686b5e0b8c28a$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $e24686b5e0b8c28a$var$DEF_WBITS = $e24686b5e0b8c28a$var$MAX_WBITS;
function $e24686b5e0b8c28a$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $e24686b5e0b8c28a$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $4EedN.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $4EedN.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $e24686b5e0b8c28a$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $e24686b5e0b8c28a$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $e24686b5e0b8c28a$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $4EedN.Buf32($e24686b5e0b8c28a$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $4EedN.Buf32($e24686b5e0b8c28a$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $e24686b5e0b8c28a$var$Z_OK;
}
function $e24686b5e0b8c28a$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $e24686b5e0b8c28a$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $e24686b5e0b8c28a$var$inflateResetKeep(strm);
}
function $e24686b5e0b8c28a$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $e24686b5e0b8c28a$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $e24686b5e0b8c28a$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $e24686b5e0b8c28a$var$inflateReset(strm);
}
function $e24686b5e0b8c28a$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $e24686b5e0b8c28a$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $e24686b5e0b8c28a$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $e24686b5e0b8c28a$var$inflateReset2(strm, windowBits);
    if (ret !== $e24686b5e0b8c28a$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $e24686b5e0b8c28a$var$inflateInit(strm) {
    return $e24686b5e0b8c28a$var$inflateInit2(strm, $e24686b5e0b8c28a$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $e24686b5e0b8c28a$var$virgin = true;
var $e24686b5e0b8c28a$var$lenfix, $e24686b5e0b8c28a$var$distfix; // We have no pointers in JS, so keep tables separate
function $e24686b5e0b8c28a$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($e24686b5e0b8c28a$var$virgin) {
        var sym;
        $e24686b5e0b8c28a$var$lenfix = new $4EedN.Buf32(512);
        $e24686b5e0b8c28a$var$distfix = new $4EedN.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $3NUEH($e24686b5e0b8c28a$var$LENS, state.lens, 0, 288, $e24686b5e0b8c28a$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $3NUEH($e24686b5e0b8c28a$var$DISTS, state.lens, 0, 32, $e24686b5e0b8c28a$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $e24686b5e0b8c28a$var$virgin = false;
    }
    state.lencode = $e24686b5e0b8c28a$var$lenfix;
    state.lenbits = 9;
    state.distcode = $e24686b5e0b8c28a$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $e24686b5e0b8c28a$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $4EedN.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $4EedN.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $4EedN.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $4EedN.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $e24686b5e0b8c28a$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $4EedN.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $e24686b5e0b8c28a$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $e24686b5e0b8c28a$var$TYPE) state.mode = $e24686b5e0b8c28a$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $e24686b5e0b8c28a$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $e24686b5e0b8c28a$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $e24686b5e0b8c28a$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5s1AD(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $e24686b5e0b8c28a$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $e24686b5e0b8c28a$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $e24686b5e0b8c28a$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $e24686b5e0b8c28a$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $e24686b5e0b8c28a$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $e24686b5e0b8c28a$var$DICTID : $e24686b5e0b8c28a$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $e24686b5e0b8c28a$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $e24686b5e0b8c28a$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $e24686b5e0b8c28a$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $e24686b5e0b8c28a$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5s1AD(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $e24686b5e0b8c28a$var$TIME;
        /* falls through */ case $e24686b5e0b8c28a$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $5s1AD(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $e24686b5e0b8c28a$var$OS;
        /* falls through */ case $e24686b5e0b8c28a$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5s1AD(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $e24686b5e0b8c28a$var$EXLEN;
        /* falls through */ case $e24686b5e0b8c28a$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $5s1AD(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $e24686b5e0b8c28a$var$EXTRA;
        /* falls through */ case $e24686b5e0b8c28a$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $4EedN.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $5s1AD(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $e24686b5e0b8c28a$var$NAME;
        /* falls through */ case $e24686b5e0b8c28a$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5s1AD(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $e24686b5e0b8c28a$var$COMMENT;
        /* falls through */ case $e24686b5e0b8c28a$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5s1AD(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $e24686b5e0b8c28a$var$HCRC;
        /* falls through */ case $e24686b5e0b8c28a$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $e24686b5e0b8c28a$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $e24686b5e0b8c28a$var$TYPE;
            break;
        case $e24686b5e0b8c28a$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $e24686b5e0b8c28a$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $e24686b5e0b8c28a$var$DICT;
        /* falls through */ case $e24686b5e0b8c28a$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $e24686b5e0b8c28a$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $e24686b5e0b8c28a$var$TYPE;
        /* falls through */ case $e24686b5e0b8c28a$var$TYPE:
            if (flush === $e24686b5e0b8c28a$var$Z_BLOCK || flush === $e24686b5e0b8c28a$var$Z_TREES) break inf_leave;
        /* falls through */ case $e24686b5e0b8c28a$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $e24686b5e0b8c28a$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $e24686b5e0b8c28a$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $e24686b5e0b8c28a$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $e24686b5e0b8c28a$var$LEN_; /* decode codes */ 
                    if (flush === $e24686b5e0b8c28a$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $e24686b5e0b8c28a$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $e24686b5e0b8c28a$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $e24686b5e0b8c28a$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $e24686b5e0b8c28a$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $e24686b5e0b8c28a$var$COPY_;
            if (flush === $e24686b5e0b8c28a$var$Z_TREES) break inf_leave;
        /* falls through */ case $e24686b5e0b8c28a$var$COPY_:
            state.mode = $e24686b5e0b8c28a$var$COPY;
        /* falls through */ case $e24686b5e0b8c28a$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $4EedN.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $e24686b5e0b8c28a$var$TYPE;
            break;
        case $e24686b5e0b8c28a$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $e24686b5e0b8c28a$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $e24686b5e0b8c28a$var$LENLENS;
        /* falls through */ case $e24686b5e0b8c28a$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $3NUEH($e24686b5e0b8c28a$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $e24686b5e0b8c28a$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $e24686b5e0b8c28a$var$CODELENS;
        /* falls through */ case $e24686b5e0b8c28a$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $e24686b5e0b8c28a$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $e24686b5e0b8c28a$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $e24686b5e0b8c28a$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $e24686b5e0b8c28a$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $3NUEH($e24686b5e0b8c28a$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $e24686b5e0b8c28a$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $3NUEH($e24686b5e0b8c28a$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $e24686b5e0b8c28a$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $e24686b5e0b8c28a$var$LEN_;
            if (flush === $e24686b5e0b8c28a$var$Z_TREES) break inf_leave;
        /* falls through */ case $e24686b5e0b8c28a$var$LEN_:
            state.mode = $e24686b5e0b8c28a$var$LEN;
        /* falls through */ case $e24686b5e0b8c28a$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $9P4SH(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $e24686b5e0b8c28a$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $e24686b5e0b8c28a$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $e24686b5e0b8c28a$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $e24686b5e0b8c28a$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $e24686b5e0b8c28a$var$LENEXT;
        /* falls through */ case $e24686b5e0b8c28a$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $e24686b5e0b8c28a$var$DIST;
        /* falls through */ case $e24686b5e0b8c28a$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $e24686b5e0b8c28a$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $e24686b5e0b8c28a$var$DISTEXT;
        /* falls through */ case $e24686b5e0b8c28a$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $e24686b5e0b8c28a$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $e24686b5e0b8c28a$var$MATCH;
        /* falls through */ case $e24686b5e0b8c28a$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $e24686b5e0b8c28a$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $e24686b5e0b8c28a$var$LEN;
            break;
        case $e24686b5e0b8c28a$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $e24686b5e0b8c28a$var$LEN;
            break;
        case $e24686b5e0b8c28a$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $5s1AD(state.check, output, _out, put - _out) : $4qNPd(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $e24686b5e0b8c28a$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $e24686b5e0b8c28a$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $e24686b5e0b8c28a$var$LENGTH;
        /* falls through */ case $e24686b5e0b8c28a$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $e24686b5e0b8c28a$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $e24686b5e0b8c28a$var$DONE;
        /* falls through */ case $e24686b5e0b8c28a$var$DONE:
            ret = $e24686b5e0b8c28a$var$Z_STREAM_END;
            break inf_leave;
        case $e24686b5e0b8c28a$var$BAD:
            ret = $e24686b5e0b8c28a$var$Z_DATA_ERROR;
            break inf_leave;
        case $e24686b5e0b8c28a$var$MEM:
            return $e24686b5e0b8c28a$var$Z_MEM_ERROR;
        case $e24686b5e0b8c28a$var$SYNC:
        /* falls through */ default:
            return $e24686b5e0b8c28a$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $e24686b5e0b8c28a$var$BAD && (state.mode < $e24686b5e0b8c28a$var$CHECK || flush !== $e24686b5e0b8c28a$var$Z_FINISH)) {
        if ($e24686b5e0b8c28a$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $e24686b5e0b8c28a$var$MEM;
            return $e24686b5e0b8c28a$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $5s1AD(state.check, output, _out, strm.next_out - _out) : $4qNPd(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $e24686b5e0b8c28a$var$TYPE ? 128 : 0) + (state.mode === $e24686b5e0b8c28a$var$LEN_ || state.mode === $e24686b5e0b8c28a$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $e24686b5e0b8c28a$var$Z_FINISH) && ret === $e24686b5e0b8c28a$var$Z_OK) ret = $e24686b5e0b8c28a$var$Z_BUF_ERROR;
    return ret;
}
function $e24686b5e0b8c28a$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $e24686b5e0b8c28a$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $e24686b5e0b8c28a$var$Z_OK;
}
function $e24686b5e0b8c28a$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $e24686b5e0b8c28a$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $e24686b5e0b8c28a$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $e24686b5e0b8c28a$var$Z_OK;
}
function $e24686b5e0b8c28a$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $e24686b5e0b8c28a$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $e24686b5e0b8c28a$var$DICT) return $e24686b5e0b8c28a$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $e24686b5e0b8c28a$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $4qNPd(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $e24686b5e0b8c28a$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $e24686b5e0b8c28a$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $e24686b5e0b8c28a$var$MEM;
        return $e24686b5e0b8c28a$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $e24686b5e0b8c28a$var$Z_OK;
}
$e24686b5e0b8c28a$export$42de45683a92ba94 = $e24686b5e0b8c28a$var$inflateReset;
$e24686b5e0b8c28a$export$7633ac2cd30f9650 = $e24686b5e0b8c28a$var$inflateReset2;
$e24686b5e0b8c28a$export$6710ea52c4ec9d6a = $e24686b5e0b8c28a$var$inflateResetKeep;
$e24686b5e0b8c28a$export$9c140b25e26874f9 = $e24686b5e0b8c28a$var$inflateInit;
$e24686b5e0b8c28a$export$6792d92addc5c8a0 = $e24686b5e0b8c28a$var$inflateInit2;
$e24686b5e0b8c28a$export$cae1ce83fe4a1782 = $e24686b5e0b8c28a$var$inflate;
$e24686b5e0b8c28a$export$224e1a443c3fba76 = $e24686b5e0b8c28a$var$inflateEnd;
$e24686b5e0b8c28a$export$6d4647cb9e1c75fc = $e24686b5e0b8c28a$var$inflateGetHeader;
$e24686b5e0b8c28a$export$60da749bed98ccf8 = $e24686b5e0b8c28a$var$inflateSetDictionary;
$e24686b5e0b8c28a$export$220f6291ca35fd71 = 'pako inflate (from Nodeca project)'; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

});
parcelRegister("9P4SH", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $726ca9cf6c721b53$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $726ca9cf6c721b53$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $726ca9cf6c721b53$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $726ca9cf6c721b53$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $726ca9cf6c721b53$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $726ca9cf6c721b53$var$TYPE;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $726ca9cf6c721b53$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

});

parcelRegister("3NUEH", function(module, exports) {
'use strict';

var $4EedN = parcelRequire("4EedN");
var $2c51e54d4d12a7c4$var$MAXBITS = 15;
var $2c51e54d4d12a7c4$var$ENOUGH_LENS = 852;
var $2c51e54d4d12a7c4$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $2c51e54d4d12a7c4$var$CODES = 0;
var $2c51e54d4d12a7c4$var$LENS = 1;
var $2c51e54d4d12a7c4$var$DISTS = 2;
var $2c51e54d4d12a7c4$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $2c51e54d4d12a7c4$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $2c51e54d4d12a7c4$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $2c51e54d4d12a7c4$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $4EedN.Buf16($2c51e54d4d12a7c4$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $4EedN.Buf16($2c51e54d4d12a7c4$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $2c51e54d4d12a7c4$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $2c51e54d4d12a7c4$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $2c51e54d4d12a7c4$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $2c51e54d4d12a7c4$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $2c51e54d4d12a7c4$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $2c51e54d4d12a7c4$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $2c51e54d4d12a7c4$var$LENS) {
        base = $2c51e54d4d12a7c4$var$lbase;
        base_index -= 257;
        extra = $2c51e54d4d12a7c4$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $2c51e54d4d12a7c4$var$dbase;
        extra = $2c51e54d4d12a7c4$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $2c51e54d4d12a7c4$var$LENS && used > $2c51e54d4d12a7c4$var$ENOUGH_LENS || type === $2c51e54d4d12a7c4$var$DISTS && used > $2c51e54d4d12a7c4$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $2c51e54d4d12a7c4$var$LENS && used > $2c51e54d4d12a7c4$var$ENOUGH_LENS || type === $2c51e54d4d12a7c4$var$DISTS && used > $2c51e54d4d12a7c4$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

});


parcelRegister("4CajD", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

});

parcelRegister("4YdHs", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $39e7648e5fdf86a9$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
module.exports = $39e7648e5fdf86a9$var$GZheader;

});




parcelRegister("dwFO6", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("9aR4Y", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("34Hk3", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("7U8Ia", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("jOiwc", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("hGw79", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("15ZGI", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("5gLRa", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("2koco", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("etDcc", function(module, exports) {
module.exports = JSON.parse("\"eJyFnV9TG0myxb8K0U/3RjC7NgZj5o0ZZnYGz5pZGyH3bsyDEA3oImhWfxCajf3ut1Xqyjx5Mkt+cbh/p9RdlZV1qrrVJf5T/dg+PjZPi+r76urvy/nortk7PPpwfLh39P7DyUm1X/3cPi0+jR6brsDl5LGZf/dDO735dTGaTsYbdTmdorq3UfdUHj1Opmss0MFhM7m731xwU7Y73pY+fbqbdqW+e3vUkfnPk9fm5vfJYnxffb+YLZv96sf70Ww0XjSzL83msz+9Lpqnm+bmc/s4euqr+cMP7Wv1/b++O3jzZv+7g7cf9k9O3u+fHLz9Y78adGVn08lT83s7nywm7dPmSl0xFS7vJ+OHp2Y+r74/6vhVM5unYtWbNwd/efPmTXeNT+1iMt605Mf2eT3bNGLvf8b/u/f25MPR/ubf4/Tvyebfkzfp33fp3+O905v2utn7sp4vmsf53q9P43b23M5Gi+bmL3t7p9Pp3ufN2eZ7n5t5M3vp6DaYk/neaG8xG900j6PZw157u/fb5KldrJ+b735puk+d/m1v9HTz13a2N+k+PF9ezyc3k9Fs0sz/0lX3p+4yN5Onuy/j+yZ1QKrFl0X3kdHsJqtdwR9Hz7/0ffL+/cl+9TUfHb4/2K9O5+NNpGed+OHdfnXWyHEX4+P96svi5pdhV/Yg/feq++/bg7fb/vp7s5hNxl1E//Wfavi1+v5gE9lPXU3mz6MukP/d3+J3XcwSbl7H09Gj8KOjoy3/97LtQnU9VeVNf6Kn5eP1pqfunrx2006no5nwD+/ebflzMxtvMj4Lx8cftsLosZPmXXi0ZvkzqQapy732PJo1T9PmtiTZj0n1RvPNGecPqhz3yvN0ORcqMRt3A3XkL3G/fr5vnnzxrimTVltykBs5n47m9742fzaz1tP2qfFwsQpKLu5nTVD2tl3OAjp5CcrOJ68BbF6aoG+bOKZPE6iwhGjcTtsnj+fN48RK0gPTjQ842vx7OZp6fDdrupEcNPPfy2aevEZT8KDve637+/fHW3bq0Q8e/ahpe9Cf7MyX+smjn/0H/+aHwC9+UP7qG3buT/9R0du3W/Sbtjuf6+++Ep88uvDn+t2X+oevxGewjvdb9MWf69Kfa+DPdeVrP/SlvvrT1x790yffdTeZPTQLYxsyRq87zY5T/hx5yrF4yngyGU9m4+Wj77XlxrXn3dQTDJHkb6Yy6lMeXQs6PDzsx1jgv75UcOVb/8E73433PkgTj/7Pn+vBl9IhLGn/6K8YmE5ge8/BqPdDaObR3Ndr4Sux9CF88Um48pV49R9c+0r8qejwg+aXTYSDg9zrMJna8ruycTGZ3hSn+pt2FcTZzM46EyzSQk2T421u/+1mYYg+K59ZR3PH7bSdTQI+bwpnGS9n3TQ+XvsuS8NmPklL18D+t6uWeFjdLSed8tgu4pXDRk4n/oZMoc+JczsJWLB+6lZy4XLgZnR3F01pW45LMVpwbPqumTU3/qPdWmh0Nxs9g6nlj153dxFN0EoN7/VoviPCu9XC+ks6wOrdXUGOzXQ6eZ5P5oHUtXVx3y7NWtFN+ya5tedmo5fABkfj5SJauiQvv502r16jkZXx42g8i5Y717MmuvBNuxiNzYhTadL1JAZAlBmOQ61sc9OFNFqjLp/uRrPl43S0DC7T3nXLzIfgdCNsB/TLo8nZk2xwp7rqOXjf53w7u7ntlnlmXagLFDvH6vrDcrnAhV7gncwJs5vHzueWU7yCnGmkTDzjZjPk5/Ng+poW1uZtoZ5tkPTd6OxuiLush16TlZzrUJ2Ybf7p5G+zRiemsEv1dLbvdG3kaiCTxc3kZXITdFJta6bL5WBoaLXth3SdF3xIJ0gagzJVpzsvGiTQVH9KvZ4ZKIp9GKTmNBr0M9RD0hP0Ab0HcBfRO4bOIeAWxN5iUkOPD4+z2D/0CC5FnqOrQpsH2so4Lp+iCujwKOWotVRd50dn0xup0tmsrUI4vVFqhphmAidH1MWrvfrhSR+waftn83QXXP6zvYTew0WN1OTYOUgCUYcXTyOylrUVga6mturdj4+c9tF9OwtadUFX1zAURsEXcok32WwLYRvQBTRidmozjzfmy7TGmQX1pRSUKJY42Wo2wcfldDF5nq6DelEDNcltd+RE6lZbi8loejO5vfV9tS5bwyd7HU3YXcny08402zHrlKVxoaOfSjZIHQqeEo/NX+lE+PCtWzDgEzi5AZq1D80T3gaJOc6au8ncLnx1iNLKS6djPy7kXmTZjWpzN6LBphWkDMyCobU8lmRcFlLqn2Tahyd55Zqec9mnYNLKnxb3vq4/Fg1wGvnWu7xsWxRMpinOjqVZ8LS0fNiRlYUA/1kaGqVKXZR6pDT1lDx3XrpyeRxf7FyW8IyZ1wXNdBE87lkYk1ZPXLU7HDFY6b3PJhe0xNZIQxWuM3UsUOj1PtWucI6P0Me7BJ51iQxVk2nE3cJ8OMj5OgonpI/hIkPuMGzH6T2MfKkTmWJ5ofFrITV/LY3x32j+y3HoonY/msKztzzIN7cm9Jxb+iJyefFlu2zSVPtGB9I6SILA87Pc31gzxQb13Rr16iic67+E613J4PgWRzKss4noG4+2MOX/WKjEkjL/UOz8ZjKOjPasMKHNdrbmk+0frW5huft5d17vXFqfFs55WjTp+HbgovDs8M9g4tSlSGG6LznFQ9iUN9mrzEpAz7ZzKNgq6PPdnVeatneb/n5qg0dVrTdTSR8v5QzqTlUYyXfhTYM8X4GZXGNeSN+ncB6H7w/dFKGeXxrjPy0330X+sV99bGZPv48ms803yP+qTjdfVVf7370/+mO/P9q6h0HbelrUmzrCv22O3sjR1lUMwoahcNEdHelRrgIgSA7DpasM3Y5/g4zzGKUPmWHbp0MGbQcOon9sjqT1l/YoxwyRab0KA3PWgW/9oND6Qdj6gW/9oNj6QdD6vPAzLNkJkqvu6ETaMOyOuqk4H9bd4bEe5SYBgqorhVcCOnyY8bI7eieFlvlsgEyAgMNVgOYAAaIAgSIBAiYBAtYHSMmLacPKHK3tkcRHEcZnS/tCOF4F0aAVTiNXOQ/frMAYFkQDWXg4mrMKQ1oQZbbwKL1F9DkuEiW68DjbReaUF4FGvXAa+pnD+M/oMkDkBMojO8jqwF+OjUH4rvAFFiFSIXwFsxC5FD5nGyJY78gYDCQjdJHMwEoEkZ8I96aSpchZsgb2Iog8RnhkNCJ6txGJLEd47Dsis/mIwA4kgrWhjF98q1cerQNE1iTc+1NvE+hPgsifhJM/KWd/ygr4kyDyJ+GhP2UV/EkQDTDh0QAT0Q8wkWiACY8HmMg8wEQgfxJO/pQ5+FNGlwEif1Ie+VNWB/5y7E/Cd4Uv8CeRCuEr+JPIpfA5fxLB+lPG4E8ZoT9lBv4kiPxJuPenLEX+lDXwJ0HkT8IjfxLR+5NI5E/CY38Smf1JBPYnEaw/ZfziW73yaB0g8ifh3p8wNGhSlpNTWZHsikT2LCODcVlO7mXF0MJMEfAxy2k0WjEakraEH5dWp8FpxXiE2jI8TK1KVmdF8jsjgukZflniZH8kRh5oigwK9WA3tOI34x/4otV3xb/gkLbMzvg7r7SqNUyjgWsajtZpBPBPy8lEreid1OiRnZoC4KmWk7FaMXJXW8JbrNXJZ60Ym60tw45rVbZdq1rvNdpLIU6rAl+XOPmxFb0pK0FLRkqGjBLZsZHYjEEEK0ZKRoxSaMNQAEwYKVkASpEBoO6HP6o0+FGKhz6W4IGPGtkuSmS6IIHlAr2MKdmtkSKzhQKD8OpstCh9I8qByaJajnLBYLHEjig7c0XNWisoYKxA0VYBg6kiJUtFyRsqqJGdggxmipSsFKXISFH3NooqmShKsYViCTZQ1Ng+UbPmCcpLGJNVSNcxJdNEyVtm33r0S0FklsLJKZWzTWYFPFIQGaTw0B2zCtYoiEas8Gi4iujHqkg0UIXHo1RkHqIikAsKJwvMHPwvo8sAkfMpj2wvqwN/OTY84bvCF1idSIXwFUxO5FL4nL2JYL0tYzC2jNDVMgNLE0R+JtybWZYiJ8sa2Jgg8jDhkYGJ6N1LJLIu4bFvicymJQI7lgjWrjJ+8a1eebQOEFmUcO9Pua5oUMrIoVQgiwKBPUokMCll5FIqhDYlMviUMhppKkRDTVU/1lSjwaZCPNpU5+GmCtmVCuRXIoBhCbuMGFkWCJFniTwIrsmupcLOWAa+pVoplgXnUr0YS+ddqljzEg7uJQztSyD4lzIyMBW8g4kWWZiI4GHKyMRUiFxMVW9jqpGPqRAbmersZKqwlalivUz4S9D+VcDWESM/U8EbWq4YGpoyMjQVyNBAYEMTCQxNGRmaCqGhiQyGpowGoQrRIFTVD0LVaBCqEA9C1XkQqkKGpgIZmghgaMIuI0aGBkJkaCIPgmuyoamwM5aBoalWimXB0FQvxtIZmirW0ISDoQlDQxMIhqaMDE0Fb2iiRYYmIhiaMjI0FSJDU9UbmmpkaCrEhqY6G5oqbGiqWEMT/hK0fxWwjaG9YyYxYQFbvdVm/W+UqANlQmaWMVmZYDayXgAby4RMLOPQwnoRDCwTGnIZRwMua364ZYUGW8bxUMsqD7TMybIyJsPqMdhVTy49IasSHBlVLw7cldikMt4RscCgshJHrGBOWS1EzBlT5taWegqm1BO0pB6BIWVCdpSxN6Neiayol8CIMiEbyjgyoax5C8oKGVDGsf1klc0nc7aezK3x9PTFtXXlyNoTWkFl7NdP/SBAvxFEhiOcHEc5W05WwHMEkekID10nq2A7gmgUCY+GkYh+HIlEA0l4PJJE5qEkArmPcLKfzMF/MroMEDmQ8siCsjrwl2MTEr4rfIENiVQIX8GIRC6Fz1mRCNaLMgYzygjdKDOwI0HkR8K9IWUpcqSsgSUJIk8SHpmSiN6VRCJbEh77kshsTCKwM4lgrSnjF9/qlUfrAJE9CXf+9ENHT7ujgyM5yp8FlL0EkAkpcLgC0BxIQBIkYBIfYH1ogOSBrWiQMlCOcgsAmeoCh+oCzdUFRF0OijQEmDQEWN+QLTkzcT/zcT/zcT8rxP0sjPuZj/tZEPezIO5nLu5nPu5nvRkcSXs2PnAoR7XRamuDZzTue9qbLkZGEIVHOMVIeBQoEX20RKKQCee4icDBE8FGUDCFMfMrHwYIaEa1L8WhFR7EN21itPHNiOObOcc38zC+WQzimyWOb+Yuvllw8c0CxTdjjm/Pr3wYML49qn0pF9/MXXx/7kPbT4Y/Y1iR5ZAiI4NSwTiUYrUoZeBECsGKFIoXKcphAzaSuT4d5aYAyi0BZBoCHNoBNDcDkLQCmDQCWN8GILkJira/cdk16uAkI2pjE3RQkxd/hhU6qIk7CHbdWh50XBN1XBN13EQyNh3lugMy1QQOtQSaKwNI6gJMqqKsldVaOrJru4RMTYC75V6iuSaAaMoFReoILN8GAMr5oKj/EVOTEDMzfmd2tCck9wKA7G1AEs6Ns557Uz33fnpesNLz0EXPvYGeB955HtjmuXPMc2+W5/2gP5T2jGyKneOgBxRk3TkNeqA2687NoAdGWXcOgx5IboEiGfRCrN74NsmIRxS3qQnbZIY7YN/UJmhqEzS1tUe+zm2hgm1YwdbXhAcYKEEdZYAB8rHXASZoaQosfUOWhYYsw4YsfUP4fgyUoCHLINhLk1cfq+2TkHd6ZO8sEwpuKhN395OJ2lvJhMK7yKTQDWRiOfyAcvgV6VD+iIkOKCc6Im8/HynRkUKiA7au9NEkOjBypY99osORr3NbqGAbVrD1NeFEByWooyQ6IGuTH/usPpC4S1YDsrVWjrVWKrVWxLVWRWutTCOrLPu9kLU98rVe+9qZqQ7HBQk0REiNRgsV8QOHCtAYIjUeTlSIRxbJNMhIpfFmVUgPEiijSaUByWqQ+lTEjwIu4EcslaAhQyqPEZJ5SFu5LQo7wxKOeSryrYazE5AamwIV2t12tgpSyTWsuiyNMPYSUiNboSLfGsNsNqTGvkOF2IJIZjci2RqTFddFYWdgvHP9Vm0f7b/9IEdyYwfIrORV2DwveHecj4bmqLZH4nyK0MuEmsfZ268OfusbrIXW/mxrfzbcc9/X2e25dzxqKW5Ip3MPPaoDRPWN9qOTFMUBt2FTcY5ItA27l2xKQHBIoBCxGgXKlrkqXXNYEuqiQM0j9VuNjILpB1T4UQ5seUD1BXq7w8AKopAqj4KZ1St/7qFHdYCo6sLLlY4ClbW1L87BEe6u8Kna3vdvlwXpyK6FEsp3zYCCNVHibiGUqF39JESrmcToO6bEzNdLidilzKc8pE4DRG0RTg0SHrVKRN80kah9wrmRInBLRbDNFUxtxi8bGFGb3ZcNzKM2R182sERt9l82sMBt5i8bGHObzQg/LQrcfqtyFKwaxsIWCSJiC3BcrOqiY2UXIytTpKxI8cpfnJ4GiGIknKIjPIqLiD4iIlEshHMUROD2i2BbLti2+aJv7qEe2Uc2F9hIQMFTnAtqGlD7FOfCNAgYPau5gGYAsc+hLvoZCo7s470LPy+poN8TXfSzkR59NSVro9HXRBdV9A3RBRrtISEKszNa5lHAI6NliULvjZYF7gQ2WsbUHbhWZUQdU1irknrl4zn06Kv/YO1LcbdFy9deMtu5oQMtp160InWlFaP+tCV8p1qdetaK3L1W5T62qu1oq1Fvux+eCDn1+64fnoiKXBV6ZVjgXwvnqQvlOSuKv7/Q67BpFRIDKaUFSpQUKEUpgbpPCFQpHVDiZECNUwE1mwioUBrQZviAUgqUN8P7Aldh5Ich/RqeoQ7LcrcX9oj3at4GCD0uiLpbOPW18KijRfS9LBJ1sXDuXxG4c0WwPSuYuhX3+DKiDi3s8SX1ysdz6NFX/8Hal+Lui7bE9pJ9xoVdyAr1JMvUoSxH/cplfPdyCepllrmzWec+Z912PauUASRflhXKBydHaUGFroo9NiwqX4tnq4uf4cxh2SeQ7JmD1FFGSaMCpYsKUaKo6lNENUoOFTgtVOGEUMWmgnJKArNz1jHq+NLOWZavgugOA/Y1+GwdlONODTeY9lp+ugO9KYg6Uzj1pfCoK0X0PSkSdaRw7kcRuBtFsL0omDoRn+Yxoi4sPM0j9crHc+jRV//B2pfizose8PUS3qQfEqK+czfpzKO+i27SWaK+8zfpLHDf8U06Y+o73LrAiPqusHWB1Csfz6FHX/0Ha1+K+y56038r/d5324cjOcqfBZQ7C5DpJ+BwBaC5dwBJxwCTPgHWdweQ3BOK9JWpdGRzLiGbbgkFmZa4S7JEbX4lRKmVGGVVYiahErG5tEH0nuQGNaaTGtulCdnX4rbIb2pJPOx488U0YLvDJSHavZIYbVzZsM2XzUfSLfINMyBbQeVYQaVSE0W8zUYVraMy2ZukSLYlCeKXEv9R4Y6GdGR3NCQU7GhI3O1oSNTuaEgo3NGQFNrRkBjtaEjM7Gj4XG1fDjnUIzsQEgqyPnGX9YnarE8ofNUrKTQeErPvrCVkk/9z76Hv9CinNSLjnCoMzHkGvr2DQnsHYXsHvr3cS6AE7R3Q+P8MvaRkY/Xb7+E+9y6vR7U9krxThPm1pfmRGfS+IAqJ8CguIvrgiEQREh6HSWSOlQiUIMIpS/AR5jtClC+FR5ikDvy5OX2E74pVkEgiFWJVSCmRS7FyySWCzTB8SksZMvSoDhBlXfRItpfy91yQeoIonMKjcIrowykShVN4HE6ROZwiUOoJp9TLHFJPEKWe8ij1sjrw5+bUE74rVkHqiVSIVSH1RC7FyqWeCDb1cC8VZcjQozpAlHrRXqosudcicyXi1yJjNQxw8bXIuAAHe+drkXEhF/j4tchY5YR17+C8CwVO3l3v4IRlBqVrunS26rdjHqW2LbAz5qU0t4V2x9ynvJUp8d3LSWGWDktCXRR4QBRfTtoW6Lo73dBtV7fpyK7CE8q3Q4CChXnibmGeqF2YJ0TL78T0FkFZ3tauxK7IL/vRrO25sDG4dOMWeBgQGaGAePWtiq6+leUBCEj26wlK2/UO5CjXGpBs11Nkt+spx+16SmW7niLdrqdMt+spy9v1lMh2PUHjdrrd1nWoZHtjqmXsJxrfSrkvRRS30tyXAoX7UigsSadIk05Z0Pj79fN9Y6u02cm3fX0sHdmXzRLS1ziEbe5vTyRL5f4WULD7MnG3+zJRu/syIcpLUGhfZmI5LwHZTZgbJPe32vqZadbMt1723CGyU4II8+Zx4jNnacos/SXoVyGUuxf8EpXXcBTxjgNV9N0cZUF/yu8+CFmZo7U98m3wLyPmaRVd2L3Wxpz8OH6tjUXvzO61Nubs0f61NhasW7vX2oiDb7vbAOaRg0e3ASyRl5duA1hmV3e3AczJ3zMHMxREHiic7F545IYieuMXidxfOE8BIrAVimAnA8E0I2ROg1uxmRsyDk7As4RwmiqU74hQMGmo5GcO0Wj6EM5ziAil6PFskjlMKYLIMoSzGWUBZhhBNM0Ij+YaEf2EIxLNOsLjqUdknn9EoElIOM1EmfN0lPnMR4MnJuE0OymPpqisBvNUlpa+NM9YwqNpS8TyfMATmPB4FhOZpzIRSilEk1rGK4/WASq0Opro3LvMeTaI32WOVZ76drzLHBcJpsH4XeZYdVNi4V3mWKbpMX6XOVRxqowfWMRqOG0WH1jEBXgK3fnAIi7kptP4gUWs8tRqVJxRrMCTiFV5srVqOKHYIsHEawvw9GtVNwlb2U0mVqYJ2Yo8LRuVHY1EO0XbnaNFYWek3aRN6jcjHU3gVCCYxm0Jnsyt6qZ0K+/uCze9GxUneSuwc1rVubXdqgrTpBV48rdquASwRYKFgC3AywGrFhYFtpBbGliZFwhW5WWCUd1iwaizUjzdwsGqvHwgNVxEmDLRUsIUWJY+6ZYVVg0XF7bIt2Zit9CwamG5YQu5RYeVdyczL0CMuCoJ66KwM2J+YTLoVyOHR3Ikz6MVyRshiuxzaeX4MFqpPIFWpE+UleljZGX52bESeYS/RWaXCiFqi9+lQjxqVbhLhSRqX7BLhQRuqdulQpja7Hd3RJxaX9jdEYlRHMq7OyKdIlLa3RGpHJt4d0ekUZR4o4OnFKFwo4OXouiUNjp4lSITb3TwGkcl2ujgFYqI2QVAiGLhdwEQj6IQ7gIgidof7AIggVvudgEQpjZHb8/HCkWg+PZ8LEfx2PX2fFyColN+ez7WOValt+djlSJnXxtnRtEKXhtnIYpQ/No4axSV6LVxVjgS/rVx5tR6+bsMpxGj1qtArVchar2qvvWqUetV4Narwq1XxbZeObW+/5H4U0+o5RlTuzOOWp013+asUIsz5vZmzq3N3LY1U9vSq76VH/TIvtV7ha0DFLzVe0WtAmrf6r0yrQFGb/VeQSuA2Ld6N2jzo/rbVxvTkf5oqyC7UFdBfyMrHdmN4gkFe8ETd9vAE7U7wBMKf+wqKbQtPDH7s1YJ2U3fG5Te/337Vg7lORAwCQIw+0QIBHwOBFie/gDTxzkA9ZVTgPmdU0DyOEeZvTfaEvOG8wbRZ5qgwfpLsMgKDcbnCsdA8YdgobT84qki/V1TZVEU5BHBsfTe5rnAkeTuxD70TIgeJW5Ya0/bBhFoS61t4+5tg+7lm3iUop6XG3ZkQS/zi9Mb5u+MN3Rpmr300VkGT3oTd493E7XPdBMKXwxPCj3iTSzojKV5mDvsPXTbhiF6KKA8HgHZn91VjsmpVJJQkSahMqkusL66QOT3dgWlp8zSHn20rMiml3LMLqWSXIo4t1TR1FImmaVIEkvQSOaBIRohIDt3DZ0NAndz1xBNEBDNXUNjgcDM3DVEA1SUR8ARkK3/ad+kZ15v5Ege9CmSB62AzAM/5W6Dx5CtDwrbDR5D43zA9DGpMDE+LaYPRIeVewo6rPyjz2FvfB/kFOJ7gGx3KsfuVCrdqYjyEhTtaGU5LwFJrwoSv9NORLvTzl7aI2t3w4LdDUO7G3q7GxbtbhjY3TCwu2Fod2t75Gu9drWrjUvW3iVr75J1wSXr0CVr75J14JJ14JK1c8nau2Tdu+SBtEdcElDwa5g1uSRQ+7uXdeCSoNAvXNbokoDsb1nWFX5RVlfu27G6cl+J1c4lgbsvv+rKfeNVV/5rrrry323VFX+hVVfuW6waXBIJfl9VV2aRWFd+kVhXfpFYO6M8Vu7WiDUbJZ7FrhHryq8R6ypYI9aV+xqprnCNWFdujVhXfo1YV2aNWFd+jVg7s0TBrxHryq8R68AvUeI1Yl35NWJd+TVi7T2zJs/U4CztkU/nZSF3l2HuLn3usmeCEmT1Msjqpc1qfEzfN889pmdOXhg/pmfRu6J7TM+c/dE/pmfBOqV7TE8cPNNtNmMeuWe02Ywl8tHSZjOW2VHdZjPm5K2Zj3xPs8sKJ6sVHuWsiD5xRaLsFc6JKgJnqwhxyrIbZ07jUrHx5YxxrAtjgxKBbVqFwKtF9IatUuDaIpJ1C2f/FsGZeFbYyTMHOxdEni6cjT0LbXA9Z/EihD4vamD2orHji1CwfdGd94vCE4AIPAtkgaeCzIP5IEvLABWGYDg9iFgeajxRCI9nC5FLI9HNGyLYkUjf5PUxib7JCySaRYrf5AW6n0uib/ICiWeU8Ju8QLPzSvRNnpdgdkFKEwxK0RyDup9mUKWZBqV4ssESPN+gRlMOSjTrgDQKs4TnHpRo+kEpGhao+5GBKg0OlHgAoMZjALXiMOA5CSSyB6OYmQkUtCDE7K6o8RRltGCWQt1PVEYN5irUabpCiWcs1NykBSLPWyDB1IWUZi+UeAIDrY0v76Yx1MKZDAsEkxnKPJ+hVpjSsIib1VDkiQ01nttA4+kNpGCGA3UZ0/JwD6c61HeOaZ7wUIrnPCyxY9S7mQ81M+qvO3Jd5a/srjF4h4L0D3RcYzgABX+K45qaD9T+0Y3roLmg0J/XuDbNA2b+kMZ4M+ikWZujB3sUfWE5lmWmRw8BCs8hW1M8eghQfI78183NWQQ+hDA809aStz/4f3M9zb/5v33B06hWakxaZKNGlFuACF+XAg7Jh1RtGHF+0QaQvEQBTF4tUHZb8R+825DuMtNmPk/PxgU2pgj84UtB9m9WCqbf/tmw2yq/Pn+bHVi01p+Z/Fa5/V2i28g+VRFjVKR/tTQj+gt0t9TV2+njoQ/HNjgPGA5A9hcKHtwkDNx9cf/A8QRsv89/MHMsMPod9wcT6Acf6IdCoB94PlNqw/9QDP+DnbSU2S558F1iRygGvfDOf6xSV+x65z8u4jtoxzv/cQnqttI7/7HMnenfvw/jxV286/37uIjv+ML797Eap0Pp/ftYpiQpvH+/VTeO9yLz8FP2YEDZgxGZM4KQf3lQUdsfbb/t3Rxt3gg/kCMN5OZobY9sZyTkwttilfurZASXyujVf3AdILqycH95Mx9BHQyHihj+WjjPusSpXlb0lYNJEaoGFCoG9DU8wzqmVCWUfIXyxAu1yQiqktGr/+A6QFQD4f7y9LYo1IIUqAwpr8WzrcsK1ZBlX1FZjUAVhUHlhL0Gn11HjKqigq9E/g1YqENGUIWMXv0H1wGi60d/5qmX0Ez6y2cEl8/o1X9wHSC6vHB3+byuKSxrrWy1hKbN7SLL2//3N4r4gepG2mbxePtH7yPNXDA45Sz+mGyRijR5DhJpdsnvS8zjeszt80yr5QuGWr7diFVTnajE82hcuKxugLI42gFmSmgKdtGV9f97IbII7hF/j0KYi/MvLBB2xcM9n6FIH+1js/37SseG2Bd5BMtfV7I42LcmGi79rGJ3qgmm3WfC6UUi4Wa/mVB5w9bgzW9zbd/azGToSO2J5K7F+MwvKS/QAdsLv/Sr7m26vOBSG5AdcC9uUQ3cvZn3wstnwPaFvRezUAamd5jCWnvk69wWKtiGFWx9TdzaVpWgjq19dfDFLF0FSX5vg9/NC5Xemacja/gJ2VfLEwoW9om7aSFRu4RPiJbkidF9fGLmN3wTsevxlUuoVYWPElaVe5SwMgkFKG5TE7YpeBaxMgmlKGgqP7JYmYRa+YRaFRJqFSbUyifUqphQqyChVj6hVj6hVj6hXk3wX33wX33wXwvBfw2D/xoH/9UH/zUI/msQ/LVLobVv2JqnKMJcPPgKxiv4oT/++/9jjgIE\"");

});

parcelRegister("6HerL", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("102Bh", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("9nZUm", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("iGzmY", function(module, exports) {
module.exports = JSON.parse("\"eJxtmNtu20YQhl+F4FULyMGeD7pz3AY1ChtG7NpFA18w1NomIlECSRcxgrx7SVk7+wOdG8H5OJydf2Z2d5gf9cV+t0v9VK/r+6vXsXlOlbHe28paq229qj/t++m62aXZ4J/m8PRb1z9/baZxefK63Z6eXN5dVMvTCh83u277xr/6kLrnl2XNq7TpXnczuZyabdee98/b2VzM/x4/dd/T5qab2pd6PQ2vaVVfvDRD005puE3Lu7eH1HbN9hTjx4/77/X6y5lcnUmjVzHIVVDicVX/1W/SsO36dLMfu6nb9/X6TAoBD+5euvZbn8axXtuZ36dhPJrVQqgPQoh5hev91LWLkIv94W1Ygq9+aX+tZAx2tfz64284/sblN/rqfLP/mqrbt3FKu7G67Nv9cNgPzZQ2H6rz7bb6vLgZq89pTMO/M/xfEqturJpqSM/d7GJIm2oamk3aNcO3av80O5xh3yyKmm1193ZIT02bqovTKjP+MAf++7zsZvZ3276kYyWWXB0z99S18/PbafPHQ71W4fjn/fxnFO+ZvkrT0LVzTr78qB/+nk38bHM9exgP8zr1z9U7jt6840YW5uSJKcZOCaBBnKgm5mU8MVNYyMwWFvO7Ukagkmgg6sDWQ5yFFqjzUrLEaQ3BEmiwNsMSaZS0vgWfOkPHWQowNeTUc0kumnxZvsgPxlGai6VTGUqAVCTQ6QkWnc77DKEiLktSUBJKqHIQZ86d8gCpHYoiEzMsb1ubYy8vW50DChB5ZhGqrijD0EqUIeiaEHIfCg5Kpuu0ApiToaGPSY0uaQsyr65L2oKi1yFt1PLaQ3lzfXTgXodGoJYzglndSLDMPg1sTPJpQJHJigw0QrGERqD9YhyTOgONQDUyuF1zaxuokc/BW2ztXCMrGZ9WMW1oQZHIXWNBkSCfRZEL5BMUiZw6CzVSFCfUSGZFNjIldoKDkonTKQiJIGzWmFd3BizJJ9SINoLDriOfUCOZS+zg+KGD1qGiLNMLxtJD1/ns00ON6EzyUCM6vbxhoBKaqbG3DFQCNiL1iHccBPV0DHhQH/JW8EW90dkyFKGywCJU0WkVSvSGeiSUODWFFD0HYdPQVoiRgfPMA+/nnRgiAyNYSjpWNQcNSMrtFCUH4ZIRpSCWocFCSuhCEY6hoUClc0WC52BJlCYYLQdhN+hygRRRlo5BKRRLS6oihSqh+ZzzRGG1Mo4Iz1LoP0qsxDGFzk0JE42ji0jCPejomJKCuwil4m5CiRMEUMVSzVLDUstSx1Juc0oVWMpqY295qVltmtWmWW2a1aZZbZrVplltmtWmWW2G1WZYbYbVZlhthtVmWG2G1WZYbYbVZlhtltVmWW2W1WZZbZbVZlltltVmWW2W1QYjQCh7E2aAQHeGhCFgPoNoy8KNb2wxBhmGKBxoUZXlLGsLI6AsftEDHV0wIURVbANLcTKlGGBIKPOAxCmhePCKUwFzAmpDFRQvjA9R06Hq8TONvshgKDCuRAZTXigUxjxNFfKRo3CLhnIJBMFRvMZpqpNBMlQJzGT5WFQMVQI/AikPMIhEU1aDjqJvQwmjSHB05cC9jbYwc5UtAHNLhDw41ha+lEqF4JaH3gmB61SYcqInxTDmQK8v08vjqv4zDf1N0w3Lf4A8/vwPpfK11w==\"");

});


parcelRegister("46WCp", function(module, exports) {

$parcel$export(module.exports, "Encodings", function () { return $2fe531630af48cc1$export$c85030bb86979d84; });
/* tslint:disable max-classes-per-file */ 
var $hs3eC = parcelRequire("hs3eC");

var $7Ur1A = parcelRequire("7Ur1A");
var $2fe531630af48cc1$var$decompressedEncodings = (0, $hs3eC.decompressJson)((0, (/*@__PURE__*/$parcel$interopDefault($7Ur1A))));
var $2fe531630af48cc1$var$allUnicodeMappings = JSON.parse($2fe531630af48cc1$var$decompressedEncodings);
var $2fe531630af48cc1$var$Encoding = /** @class */ function() {
    function Encoding(name, unicodeMappings) {
        var _this = this;
        this.canEncodeUnicodeCodePoint = function(codePoint) {
            return codePoint in _this.unicodeMappings;
        };
        this.encodeUnicodeCodePoint = function(codePoint) {
            var mapped = _this.unicodeMappings[codePoint];
            if (!mapped) {
                var str = String.fromCharCode(codePoint);
                var hexCode = "0x" + (0, $hs3eC.padStart)(codePoint.toString(16), 4, '0');
                var msg = _this.name + " cannot encode \"" + str + "\" (" + hexCode + ")";
                throw new Error(msg);
            }
            return {
                code: mapped[0],
                name: mapped[1]
            };
        };
        this.name = name;
        this.supportedCodePoints = Object.keys(unicodeMappings).map(Number).sort(function(a, b) {
            return a - b;
        });
        this.unicodeMappings = unicodeMappings;
    }
    return Encoding;
}();
var $2fe531630af48cc1$export$c85030bb86979d84 = {
    Symbol: new $2fe531630af48cc1$var$Encoding('Symbol', $2fe531630af48cc1$var$allUnicodeMappings.symbol),
    ZapfDingbats: new $2fe531630af48cc1$var$Encoding('ZapfDingbats', $2fe531630af48cc1$var$allUnicodeMappings.zapfdingbats),
    WinAnsi: new $2fe531630af48cc1$var$Encoding('WinAnsi', $2fe531630af48cc1$var$allUnicodeMappings.win1252)
};

});
parcelRegister("7Ur1A", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});




parcelRegister("afaKe", function(module, exports) {

$parcel$export(module.exports, "assertIsOneOf", function () { return $7753a3be8eb58104$export$8883a3014ee46cd1; });
$parcel$export(module.exports, "assertIsOneOfOrUndefined", function () { return $7753a3be8eb58104$export$846079600c50354e; });
$parcel$export(module.exports, "assertIsSubset", function () { return $7753a3be8eb58104$export$dce66947695c582f; });
$parcel$export(module.exports, "assertIs", function () { return $7753a3be8eb58104$export$6fee1f82edcf4a03; });
$parcel$export(module.exports, "assertOrUndefined", function () { return $7753a3be8eb58104$export$92143017cb173fb0; });
$parcel$export(module.exports, "assertEachIs", function () { return $7753a3be8eb58104$export$47fbce961905bcd0; });
$parcel$export(module.exports, "assertRange", function () { return $7753a3be8eb58104$export$6698b6d148bc9b0c; });
$parcel$export(module.exports, "assertRangeOrUndefined", function () { return $7753a3be8eb58104$export$bce4080186be486; });
$parcel$export(module.exports, "assertMultiple", function () { return $7753a3be8eb58104$export$c9f5acf8e31d1a2e; });
$parcel$export(module.exports, "assertInteger", function () { return $7753a3be8eb58104$export$a59e49f1e2708383; });
$parcel$export(module.exports, "assertPositive", function () { return $7753a3be8eb58104$export$2cad8b74f3cf13dd; });
/* tslint:disable:ban-types */ 
var $5dg82 = parcelRequire("5dg82");
var $7753a3be8eb58104$export$c7ce26e85cccb3a8 = function(val) {
    return "`" + val + "`";
};
var $7753a3be8eb58104$export$1909b7b8a28995a9 = function(val) {
    return "'" + val + "'";
};
// prettier-ignore
var $7753a3be8eb58104$var$formatValue = function(value) {
    var type = typeof value;
    if (type === 'string') return $7753a3be8eb58104$export$1909b7b8a28995a9(value);
    else if (type === 'undefined') return $7753a3be8eb58104$export$c7ce26e85cccb3a8(value);
    else return value;
};
var $7753a3be8eb58104$export$2ac73c5d250d45a9 = function(value, valueName, values) {
    var allowedValues = new Array(values.length);
    for(var idx = 0, len = values.length; idx < len; idx++){
        var v = values[idx];
        allowedValues[idx] = $7753a3be8eb58104$var$formatValue(v);
    }
    var joinedValues = allowedValues.join(' or ');
    // prettier-ignore
    return $7753a3be8eb58104$export$c7ce26e85cccb3a8(valueName) + " must be one of " + joinedValues + ", but was actually " + $7753a3be8eb58104$var$formatValue(value);
};
var $7753a3be8eb58104$export$8883a3014ee46cd1 = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $5dg82.values)(allowedValues);
    for(var idx = 0, len = allowedValues.length; idx < len; idx++){
        if (value === allowedValues[idx]) return;
    }
    throw new TypeError($7753a3be8eb58104$export$2ac73c5d250d45a9(value, valueName, allowedValues));
};
var $7753a3be8eb58104$export$846079600c50354e = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $5dg82.values)(allowedValues);
    $7753a3be8eb58104$export$8883a3014ee46cd1(value, valueName, allowedValues.concat(undefined));
};
var $7753a3be8eb58104$export$dce66947695c582f = function(values, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $5dg82.values)(allowedValues);
    for(var idx = 0, len = values.length; idx < len; idx++)$7753a3be8eb58104$export$8883a3014ee46cd1(values[idx], valueName, allowedValues);
};
var $7753a3be8eb58104$export$e2b5c5db9e2009fd = function(val) {
    if (val === null) return 'null';
    if (val === undefined) return 'undefined';
    if (typeof val === 'string') return 'string';
    if (isNaN(val)) return 'NaN';
    if (typeof val === 'number') return 'number';
    if (typeof val === 'boolean') return 'boolean';
    if (typeof val === 'symbol') return 'symbol';
    if (typeof val === 'bigint') return 'bigint';
    if (val.constructor && val.constructor.name) return val.constructor.name;
    if (val.name) return val.name;
    if (val.constructor) return String(val.constructor);
    return String(val);
};
var $7753a3be8eb58104$export$26b9f946b448f23e = function(value, type) {
    if (type === 'null') return value === null;
    if (type === 'undefined') return value === undefined;
    if (type === 'string') return typeof value === 'string';
    if (type === 'number') return typeof value === 'number' && !isNaN(value);
    if (type === 'boolean') return typeof value === 'boolean';
    if (type === 'symbol') return typeof value === 'symbol';
    if (type === 'bigint') return typeof value === 'bigint';
    if (type === Date) return value instanceof Date;
    if (type === Array) return value instanceof Array;
    if (type === Uint8Array) return value instanceof Uint8Array;
    if (type === ArrayBuffer) return value instanceof ArrayBuffer;
    if (type === Function) return value instanceof Function;
    return value instanceof type[0];
};
var $7753a3be8eb58104$export$6e3e1e6304e79984 = function(value, valueName, types) {
    var allowedTypes = new Array(types.length);
    for(var idx = 0, len = types.length; idx < len; idx++){
        var type = types[idx];
        if (type === 'null') allowedTypes[idx] = $7753a3be8eb58104$export$c7ce26e85cccb3a8('null');
        if (type === 'undefined') allowedTypes[idx] = $7753a3be8eb58104$export$c7ce26e85cccb3a8('undefined');
        if (type === 'string') allowedTypes[idx] = $7753a3be8eb58104$export$c7ce26e85cccb3a8('string');
        else if (type === 'number') allowedTypes[idx] = $7753a3be8eb58104$export$c7ce26e85cccb3a8('number');
        else if (type === 'boolean') allowedTypes[idx] = $7753a3be8eb58104$export$c7ce26e85cccb3a8('boolean');
        else if (type === 'symbol') allowedTypes[idx] = $7753a3be8eb58104$export$c7ce26e85cccb3a8('symbol');
        else if (type === 'bigint') allowedTypes[idx] = $7753a3be8eb58104$export$c7ce26e85cccb3a8('bigint');
        else if (type === Array) allowedTypes[idx] = $7753a3be8eb58104$export$c7ce26e85cccb3a8('Array');
        else if (type === Uint8Array) allowedTypes[idx] = $7753a3be8eb58104$export$c7ce26e85cccb3a8('Uint8Array');
        else if (type === ArrayBuffer) allowedTypes[idx] = $7753a3be8eb58104$export$c7ce26e85cccb3a8('ArrayBuffer');
        else allowedTypes[idx] = $7753a3be8eb58104$export$c7ce26e85cccb3a8(type[1]);
    }
    var joinedTypes = allowedTypes.join(' or ');
    // prettier-ignore
    return $7753a3be8eb58104$export$c7ce26e85cccb3a8(valueName) + " must be of type " + joinedTypes + ", but was actually of type " + $7753a3be8eb58104$export$c7ce26e85cccb3a8($7753a3be8eb58104$export$e2b5c5db9e2009fd(value));
};
var $7753a3be8eb58104$export$6fee1f82edcf4a03 = function(value, valueName, types) {
    for(var idx = 0, len = types.length; idx < len; idx++){
        if ($7753a3be8eb58104$export$26b9f946b448f23e(value, types[idx])) return;
    }
    throw new TypeError($7753a3be8eb58104$export$6e3e1e6304e79984(value, valueName, types));
};
var $7753a3be8eb58104$export$92143017cb173fb0 = function(value, valueName, types) {
    $7753a3be8eb58104$export$6fee1f82edcf4a03(value, valueName, types.concat('undefined'));
};
var $7753a3be8eb58104$export$47fbce961905bcd0 = function(values, valueName, types) {
    for(var idx = 0, len = values.length; idx < len; idx++)$7753a3be8eb58104$export$6fee1f82edcf4a03(values[idx], valueName, types);
};
var $7753a3be8eb58104$export$6698b6d148bc9b0c = function(value, valueName, min, max) {
    $7753a3be8eb58104$export$6fee1f82edcf4a03(value, valueName, [
        'number'
    ]);
    $7753a3be8eb58104$export$6fee1f82edcf4a03(min, 'min', [
        'number'
    ]);
    $7753a3be8eb58104$export$6fee1f82edcf4a03(max, 'max', [
        'number'
    ]);
    max = Math.max(min, max);
    if (value < min || value > max) // prettier-ignore
    throw new Error($7753a3be8eb58104$export$c7ce26e85cccb3a8(valueName) + " must be at least " + min + " and at most " + max + ", but was actually " + value);
};
var $7753a3be8eb58104$export$bce4080186be486 = function(value, valueName, min, max) {
    $7753a3be8eb58104$export$6fee1f82edcf4a03(value, valueName, [
        'number',
        'undefined'
    ]);
    if (typeof value === 'number') $7753a3be8eb58104$export$6698b6d148bc9b0c(value, valueName, min, max);
};
var $7753a3be8eb58104$export$c9f5acf8e31d1a2e = function(value, valueName, multiplier) {
    $7753a3be8eb58104$export$6fee1f82edcf4a03(value, valueName, [
        'number'
    ]);
    if (value % multiplier !== 0) // prettier-ignore
    throw new Error($7753a3be8eb58104$export$c7ce26e85cccb3a8(valueName) + " must be a multiple of " + multiplier + ", but was actually " + value);
};
var $7753a3be8eb58104$export$a59e49f1e2708383 = function(value, valueName) {
    if (!Number.isInteger(value)) throw new Error($7753a3be8eb58104$export$c7ce26e85cccb3a8(valueName) + " must be an integer, but was actually " + value);
};
var $7753a3be8eb58104$export$2cad8b74f3cf13dd = function(value, valueName) {
    if (![
        1,
        0
    ].includes(Math.sign(value))) // prettier-ignore
    throw new Error($7753a3be8eb58104$export$c7ce26e85cccb3a8(valueName) + " must be a positive number or 0, but was actually " + value);
};

});

parcelRegister("8YZBr", function(module, exports) {

$parcel$export(module.exports, "pdfDocEncodingDecode", function () { return $68a3b664353b6e30$export$ea426b9c784ba215; });

var $8ZzAZ = parcelRequire("8ZzAZ");
// Mapping from PDFDocEncoding to Unicode code point
var $68a3b664353b6e30$var$pdfDocEncodingToUnicode = new Uint16Array(256);
// Initialize the code points which are the same
for(var $68a3b664353b6e30$var$idx = 0; $68a3b664353b6e30$var$idx < 256; $68a3b664353b6e30$var$idx++)$68a3b664353b6e30$var$pdfDocEncodingToUnicode[$68a3b664353b6e30$var$idx] = $68a3b664353b6e30$var$idx;
// Set differences (see "Table D.2 – PDFDocEncoding Character Set" of the PDF spec)
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x16] = (0, $8ZzAZ.toCharCode)('\u0017'); // SYNCRONOUS IDLE
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x18] = (0, $8ZzAZ.toCharCode)('\u02D8'); // BREVE
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x19] = (0, $8ZzAZ.toCharCode)('\u02C7'); // CARON
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x1a] = (0, $8ZzAZ.toCharCode)('\u02C6'); // MODIFIER LETTER CIRCUMFLEX ACCENT
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x1b] = (0, $8ZzAZ.toCharCode)('\u02D9'); // DOT ABOVE
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x1c] = (0, $8ZzAZ.toCharCode)('\u02DD'); // DOUBLE ACUTE ACCENT
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x1d] = (0, $8ZzAZ.toCharCode)('\u02DB'); // OGONEK
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x1e] = (0, $8ZzAZ.toCharCode)('\u02DA'); // RING ABOVE
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x1f] = (0, $8ZzAZ.toCharCode)('\u02DC'); // SMALL TILDE
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x7f] = (0, $8ZzAZ.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x80] = (0, $8ZzAZ.toCharCode)('\u2022'); // BULLET
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x81] = (0, $8ZzAZ.toCharCode)('\u2020'); // DAGGER
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x82] = (0, $8ZzAZ.toCharCode)('\u2021'); // DOUBLE DAGGER
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x83] = (0, $8ZzAZ.toCharCode)('\u2026'); // HORIZONTAL ELLIPSIS
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x84] = (0, $8ZzAZ.toCharCode)('\u2014'); // EM DASH
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x85] = (0, $8ZzAZ.toCharCode)('\u2013'); // EN DASH
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x86] = (0, $8ZzAZ.toCharCode)('\u0192'); // LATIN SMALL LETTER SCRIPT F
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x87] = (0, $8ZzAZ.toCharCode)('\u2044'); // FRACTION SLASH (solidus)
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x88] = (0, $8ZzAZ.toCharCode)('\u2039'); // SINGLE LEFT-POINTING ANGLE QUOTATION MARK
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x89] = (0, $8ZzAZ.toCharCode)('\u203A'); // SINGLE RIGHT-POINTING ANGLE QUOTATION MARK
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x8a] = (0, $8ZzAZ.toCharCode)('\u2212'); // MINUS SIGN
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x8b] = (0, $8ZzAZ.toCharCode)('\u2030'); // PER MILLE SIGN
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x8c] = (0, $8ZzAZ.toCharCode)('\u201E'); // DOUBLE LOW-9 QUOTATION MARK (quotedblbase)
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x8d] = (0, $8ZzAZ.toCharCode)('\u201C'); // LEFT DOUBLE QUOTATION MARK (quotedblleft)
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x8e] = (0, $8ZzAZ.toCharCode)('\u201D'); // RIGHT DOUBLE QUOTATION MARK (quotedblright)
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x8f] = (0, $8ZzAZ.toCharCode)('\u2018'); // LEFT SINGLE QUOTATION MARK (quoteleft)
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x90] = (0, $8ZzAZ.toCharCode)('\u2019'); // RIGHT SINGLE QUOTATION MARK (quoteright)
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x91] = (0, $8ZzAZ.toCharCode)('\u201A'); // SINGLE LOW-9 QUOTATION MARK (quotesinglbase)
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x92] = (0, $8ZzAZ.toCharCode)('\u2122'); // TRADE MARK SIGN
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x93] = (0, $8ZzAZ.toCharCode)('\uFB01'); // LATIN SMALL LIGATURE FI
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x94] = (0, $8ZzAZ.toCharCode)('\uFB02'); // LATIN SMALL LIGATURE FL
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x95] = (0, $8ZzAZ.toCharCode)('\u0141'); // LATIN CAPITAL LETTER L WITH STROKE
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x96] = (0, $8ZzAZ.toCharCode)('\u0152'); // LATIN CAPITAL LIGATURE OE
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x97] = (0, $8ZzAZ.toCharCode)('\u0160'); // LATIN CAPITAL LETTER S WITH CARON
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x98] = (0, $8ZzAZ.toCharCode)('\u0178'); // LATIN CAPITAL LETTER Y WITH DIAERESIS
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x99] = (0, $8ZzAZ.toCharCode)('\u017D'); // LATIN CAPITAL LETTER Z WITH CARON
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x9a] = (0, $8ZzAZ.toCharCode)('\u0131'); // LATIN SMALL LETTER DOTLESS I
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x9b] = (0, $8ZzAZ.toCharCode)('\u0142'); // LATIN SMALL LETTER L WITH STROKE
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x9c] = (0, $8ZzAZ.toCharCode)('\u0153'); // LATIN SMALL LIGATURE OE
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x9d] = (0, $8ZzAZ.toCharCode)('\u0161'); // LATIN SMALL LETTER S WITH CARON
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x9e] = (0, $8ZzAZ.toCharCode)('\u017E'); // LATIN SMALL LETTER Z WITH CARON
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0x9f] = (0, $8ZzAZ.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0xa0] = (0, $8ZzAZ.toCharCode)('\u20AC'); // EURO SIGN
$68a3b664353b6e30$var$pdfDocEncodingToUnicode[0xad] = (0, $8ZzAZ.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
var $68a3b664353b6e30$export$ea426b9c784ba215 = function(bytes) {
    var codePoints = new Array(bytes.length);
    for(var idx = 0, len = bytes.length; idx < len; idx++)codePoints[idx] = $68a3b664353b6e30$var$pdfDocEncodingToUnicode[bytes[idx]];
    return String.fromCodePoint.apply(String, codePoints);
};

});

parcelRegister("fdd94", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1324449dfd86daf$export$2e2bcd8739ae039; });
var $b1324449dfd86daf$var$Cache = /** @class */ function() {
    function Cache(populate) {
        this.populate = populate;
        this.value = undefined;
    }
    Cache.prototype.getValue = function() {
        return this.value;
    };
    Cache.prototype.access = function() {
        if (!this.value) this.value = this.populate();
        return this.value;
    };
    Cache.prototype.invalidate = function() {
        this.value = undefined;
    };
    Cache.populatedBy = function(populate) {
        return new Cache(populate);
    };
    return Cache;
}();
var $b1324449dfd86daf$export$2e2bcd8739ae039 = $b1324449dfd86daf$var$Cache;

});


parcelRegister("l0PqT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4c17e8ca71677db$export$2e2bcd8739ae039; });

var $6AcCU = parcelRequire("6AcCU");
var $f4c17e8ca71677db$var$PDFObject = /** @class */ function() {
    function PDFObject() {}
    PDFObject.prototype.clone = function(_context) {
        throw new (0, $6AcCU.MethodNotImplementedError)(this.constructor.name, 'clone');
    };
    PDFObject.prototype.toString = function() {
        throw new (0, $6AcCU.MethodNotImplementedError)(this.constructor.name, 'toString');
    };
    PDFObject.prototype.sizeInBytes = function() {
        throw new (0, $6AcCU.MethodNotImplementedError)(this.constructor.name, 'sizeInBytes');
    };
    PDFObject.prototype.copyBytesInto = function(_buffer, _offset) {
        throw new (0, $6AcCU.MethodNotImplementedError)(this.constructor.name, 'copyBytesInto');
    };
    return PDFObject;
}();
var $f4c17e8ca71677db$export$2e2bcd8739ae039 = $f4c17e8ca71677db$var$PDFObject;

});
parcelRegister("6AcCU", function(module, exports) {

$parcel$export(module.exports, "MethodNotImplementedError", function () { return $4cafe63fa70445dc$export$b549a6777be1bc17; });
$parcel$export(module.exports, "PrivateConstructorError", function () { return $4cafe63fa70445dc$export$20e18464cd4b43a; });
$parcel$export(module.exports, "UnexpectedObjectTypeError", function () { return $4cafe63fa70445dc$export$ab03f98a62c22159; });
$parcel$export(module.exports, "UnsupportedEncodingError", function () { return $4cafe63fa70445dc$export$5de8fe8a6031fb92; });
$parcel$export(module.exports, "ReparseError", function () { return $4cafe63fa70445dc$export$df523155c7c35e23; });
$parcel$export(module.exports, "MissingPageContentsEmbeddingError", function () { return $4cafe63fa70445dc$export$48e9be38307e3c37; });
$parcel$export(module.exports, "UnrecognizedStreamTypeError", function () { return $4cafe63fa70445dc$export$f8343077e7fd3a86; });
$parcel$export(module.exports, "PageEmbeddingMismatchedContextError", function () { return $4cafe63fa70445dc$export$22c55e00f6509a2c; });
$parcel$export(module.exports, "PDFArrayIsNotRectangleError", function () { return $4cafe63fa70445dc$export$a76bae7761f3d760; });
$parcel$export(module.exports, "InvalidPDFDateStringError", function () { return $4cafe63fa70445dc$export$8638e3ad1edceac8; });
$parcel$export(module.exports, "InvalidTargetIndexError", function () { return $4cafe63fa70445dc$export$845c01ec1ddb8877; });
$parcel$export(module.exports, "CorruptPageTreeError", function () { return $4cafe63fa70445dc$export$1012d63cae1523f8; });
$parcel$export(module.exports, "IndexOutOfBoundsError", function () { return $4cafe63fa70445dc$export$19a77d83c7473130; });
$parcel$export(module.exports, "InvalidAcroFieldValueError", function () { return $4cafe63fa70445dc$export$d39c49ea9be644ec; });
$parcel$export(module.exports, "MultiSelectValueError", function () { return $4cafe63fa70445dc$export$6606fe23b6c4542c; });
$parcel$export(module.exports, "MissingDAEntryError", function () { return $4cafe63fa70445dc$export$dfa101de065b3cc2; });
$parcel$export(module.exports, "MissingTfOperatorError", function () { return $4cafe63fa70445dc$export$b5ee390f1267b133; });
$parcel$export(module.exports, "NumberParsingError", function () { return $4cafe63fa70445dc$export$81adf4c464255546; });
$parcel$export(module.exports, "NextByteAssertionError", function () { return $4cafe63fa70445dc$export$fda6cb3cf0fe0c76; });
$parcel$export(module.exports, "PDFObjectParsingError", function () { return $4cafe63fa70445dc$export$b8907968b8d7f502; });
$parcel$export(module.exports, "PDFInvalidObjectParsingError", function () { return $4cafe63fa70445dc$export$72474f06fb3a1c6b; });
$parcel$export(module.exports, "PDFStreamParsingError", function () { return $4cafe63fa70445dc$export$b1a91b84397f50d6; });
$parcel$export(module.exports, "UnbalancedParenthesisError", function () { return $4cafe63fa70445dc$export$92803ff0e03167f9; });
$parcel$export(module.exports, "StalledParserError", function () { return $4cafe63fa70445dc$export$b934c61834236c8; });
$parcel$export(module.exports, "MissingPDFHeaderError", function () { return $4cafe63fa70445dc$export$cf6bd1b11dd05d74; });
$parcel$export(module.exports, "MissingKeywordError", function () { return $4cafe63fa70445dc$export$bc024c15c94be864; });

var $47XJ3 = parcelRequire("47XJ3");
parcelRequire("5w6hV");
var $4LYfy = parcelRequire("4LYfy");
var $4cafe63fa70445dc$export$b549a6777be1bc17 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(MethodNotImplementedError, _super);
    function MethodNotImplementedError(className, methodName) {
        var _this = this;
        var msg = "Method " + className + "." + methodName + "() not implemented";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MethodNotImplementedError;
}(Error);
var $4cafe63fa70445dc$export$20e18464cd4b43a = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PrivateConstructorError, _super);
    function PrivateConstructorError(className) {
        var _this = this;
        var msg = "Cannot construct " + className + " - it has a private constructor";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PrivateConstructorError;
}(Error);
var $4cafe63fa70445dc$export$ab03f98a62c22159 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(UnexpectedObjectTypeError, _super);
    function UnexpectedObjectTypeError(expected, actual) {
        var _this = this;
        var name = function(t) {
            var _a, _b;
            return (_a = t === null || t === void 0 ? void 0 : t.name) !== null && _a !== void 0 ? _a : (_b = t === null || t === void 0 ? void 0 : t.constructor) === null || _b === void 0 ? void 0 : _b.name;
        };
        var expectedTypes = Array.isArray(expected) ? expected.map(name) : [
            name(expected)
        ];
        var msg = "Expected instance of " + expectedTypes.join(' or ') + ", " + ("but got instance of " + (actual ? name(actual) : actual));
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedObjectTypeError;
}(Error);
var $4cafe63fa70445dc$export$5de8fe8a6031fb92 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(UnsupportedEncodingError, _super);
    function UnsupportedEncodingError(encoding) {
        var _this = this;
        var msg = encoding + " stream encoding not supported";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnsupportedEncodingError;
}(Error);
var $4cafe63fa70445dc$export$df523155c7c35e23 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(ReparseError, _super);
    function ReparseError(className, methodName) {
        var _this = this;
        var msg = "Cannot call " + className + "." + methodName + "() more than once";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ReparseError;
}(Error);
var $4cafe63fa70445dc$export$3afc9350d4666214 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(MissingCatalogError, _super);
    function MissingCatalogError(ref) {
        var _this = this;
        var msg = "Missing catalog (ref=" + ref + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingCatalogError;
}(Error);
var $4cafe63fa70445dc$export$48e9be38307e3c37 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(MissingPageContentsEmbeddingError, _super);
    function MissingPageContentsEmbeddingError() {
        var _this = this;
        var msg = "Can't embed page with missing Contents";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingPageContentsEmbeddingError;
}(Error);
var $4cafe63fa70445dc$export$f8343077e7fd3a86 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(UnrecognizedStreamTypeError, _super);
    function UnrecognizedStreamTypeError(stream) {
        var _a, _b, _c;
        var _this = this;
        var streamType = (_c = (_b = (_a = stream === null || stream === void 0 ? void 0 : stream.contructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : stream === null || stream === void 0 ? void 0 : stream.name) !== null && _c !== void 0 ? _c : stream;
        var msg = "Unrecognized stream type: " + streamType;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnrecognizedStreamTypeError;
}(Error);
var $4cafe63fa70445dc$export$22c55e00f6509a2c = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PageEmbeddingMismatchedContextError, _super);
    function PageEmbeddingMismatchedContextError() {
        var _this = this;
        var msg = "Found mismatched contexts while embedding pages. All pages in the array passed to `PDFDocument.embedPages()` must be from the same document.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PageEmbeddingMismatchedContextError;
}(Error);
var $4cafe63fa70445dc$export$a76bae7761f3d760 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFArrayIsNotRectangleError, _super);
    function PDFArrayIsNotRectangleError(size) {
        var _this = this;
        var msg = "Attempted to convert PDFArray with " + size + " elements to rectangle, but must have exactly 4 elements.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFArrayIsNotRectangleError;
}(Error);
var $4cafe63fa70445dc$export$8638e3ad1edceac8 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(InvalidPDFDateStringError, _super);
    function InvalidPDFDateStringError(value) {
        var _this = this;
        var msg = "Attempted to convert \"" + value + "\" to a date, but it does not match the PDF date string format.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidPDFDateStringError;
}(Error);
var $4cafe63fa70445dc$export$845c01ec1ddb8877 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(InvalidTargetIndexError, _super);
    function InvalidTargetIndexError(targetIndex, Count) {
        var _this = this;
        var msg = "Invalid targetIndex specified: targetIndex=" + targetIndex + " must be less than Count=" + Count;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidTargetIndexError;
}(Error);
var $4cafe63fa70445dc$export$1012d63cae1523f8 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(CorruptPageTreeError, _super);
    function CorruptPageTreeError(targetIndex, operation) {
        var _this = this;
        var msg = "Failed to " + operation + " at targetIndex=" + targetIndex + " due to corrupt page tree: It is likely that one or more 'Count' entries are invalid";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CorruptPageTreeError;
}(Error);
var $4cafe63fa70445dc$export$19a77d83c7473130 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(IndexOutOfBoundsError, _super);
    function IndexOutOfBoundsError(index, min, max) {
        var _this = this;
        var msg = "index should be at least " + min + " and at most " + max + ", but was actually " + index;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return IndexOutOfBoundsError;
}(Error);
var $4cafe63fa70445dc$export$d39c49ea9be644ec = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(InvalidAcroFieldValueError, _super);
    function InvalidAcroFieldValueError() {
        var _this = this;
        var msg = "Attempted to set invalid field value";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidAcroFieldValueError;
}(Error);
var $4cafe63fa70445dc$export$6606fe23b6c4542c = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(MultiSelectValueError, _super);
    function MultiSelectValueError() {
        var _this = this;
        var msg = "Attempted to select multiple values for single-select field";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MultiSelectValueError;
}(Error);
var $4cafe63fa70445dc$export$dfa101de065b3cc2 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(MissingDAEntryError, _super);
    function MissingDAEntryError(fieldName) {
        var _this = this;
        var msg = "No /DA (default appearance) entry found for field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingDAEntryError;
}(Error);
var $4cafe63fa70445dc$export$b5ee390f1267b133 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(MissingTfOperatorError, _super);
    function MissingTfOperatorError(fieldName) {
        var _this = this;
        var msg = "No Tf operator found for DA of field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingTfOperatorError;
}(Error);
var $4cafe63fa70445dc$export$81adf4c464255546 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(NumberParsingError, _super);
    function NumberParsingError(pos, value) {
        var _this = this;
        var msg = "Failed to parse number " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): \"" + value + "\"");
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NumberParsingError;
}(Error);
var $4cafe63fa70445dc$export$fd202455a19cb700 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFParsingError, _super);
    function PDFParsingError(pos, details) {
        var _this = this;
        var msg = "Failed to parse PDF document " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): " + details);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFParsingError;
}(Error);
var $4cafe63fa70445dc$export$fda6cb3cf0fe0c76 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(NextByteAssertionError, _super);
    function NextByteAssertionError(pos, expectedByte, actualByte) {
        var _this = this;
        var msg = "Expected next byte to be " + expectedByte + " but it was actually " + actualByte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return NextByteAssertionError;
}($4cafe63fa70445dc$export$fd202455a19cb700);
var $4cafe63fa70445dc$export$b8907968b8d7f502 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFObjectParsingError, _super);
    function PDFObjectParsingError(pos, byte) {
        var _this = this;
        var msg = "Failed to parse PDF object starting with the following byte: " + byte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFObjectParsingError;
}($4cafe63fa70445dc$export$fd202455a19cb700);
var $4cafe63fa70445dc$export$72474f06fb3a1c6b = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFInvalidObjectParsingError, _super);
    function PDFInvalidObjectParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse invalid PDF object";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFInvalidObjectParsingError;
}($4cafe63fa70445dc$export$fd202455a19cb700);
var $4cafe63fa70445dc$export$b1a91b84397f50d6 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFStreamParsingError, _super);
    function PDFStreamParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF stream";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFStreamParsingError;
}($4cafe63fa70445dc$export$fd202455a19cb700);
var $4cafe63fa70445dc$export$92803ff0e03167f9 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(UnbalancedParenthesisError, _super);
    function UnbalancedParenthesisError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF literal string due to unbalanced parenthesis";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return UnbalancedParenthesisError;
}($4cafe63fa70445dc$export$fd202455a19cb700);
var $4cafe63fa70445dc$export$b934c61834236c8 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(StalledParserError, _super);
    function StalledParserError(pos) {
        var _this = this;
        var msg = "Parser stalled";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return StalledParserError;
}($4cafe63fa70445dc$export$fd202455a19cb700);
var $4cafe63fa70445dc$export$cf6bd1b11dd05d74 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(MissingPDFHeaderError, _super);
    function MissingPDFHeaderError(pos) {
        var _this = this;
        var msg = "No PDF header found";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingPDFHeaderError;
}($4cafe63fa70445dc$export$fd202455a19cb700);
var $4cafe63fa70445dc$export$bc024c15c94be864 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(MissingKeywordError, _super);
    function MissingKeywordError(pos, keyword) {
        var _this = this;
        var msg = "Did not find expected keyword '" + (0, $4LYfy.arrayAsString)(keyword) + "'";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingKeywordError;
}($4cafe63fa70445dc$export$fd202455a19cb700);

});



parcelRegister("90Qf4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68fca35a558012d0$export$2e2bcd8739ae039; });
var $68fca35a558012d0$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Null"] = 0] = "Null";
    CharCodes[CharCodes["Backspace"] = 8] = "Backspace";
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["Newline"] = 10] = "Newline";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationPoint"] = 33] = "ExclamationPoint";
    CharCodes[CharCodes["Hash"] = 35] = "Hash";
    CharCodes[CharCodes["Percent"] = 37] = "Percent";
    CharCodes[CharCodes["LeftParen"] = 40] = "LeftParen";
    CharCodes[CharCodes["RightParen"] = 41] = "RightParen";
    CharCodes[CharCodes["Plus"] = 43] = "Plus";
    CharCodes[CharCodes["Minus"] = 45] = "Minus";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Period"] = 46] = "Period";
    CharCodes[CharCodes["ForwardSlash"] = 47] = "ForwardSlash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["One"] = 49] = "One";
    CharCodes[CharCodes["Two"] = 50] = "Two";
    CharCodes[CharCodes["Three"] = 51] = "Three";
    CharCodes[CharCodes["Four"] = 52] = "Four";
    CharCodes[CharCodes["Five"] = 53] = "Five";
    CharCodes[CharCodes["Six"] = 54] = "Six";
    CharCodes[CharCodes["Seven"] = 55] = "Seven";
    CharCodes[CharCodes["Eight"] = 56] = "Eight";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["LessThan"] = 60] = "LessThan";
    CharCodes[CharCodes["GreaterThan"] = 62] = "GreaterThan";
    CharCodes[CharCodes["A"] = 65] = "A";
    CharCodes[CharCodes["D"] = 68] = "D";
    CharCodes[CharCodes["E"] = 69] = "E";
    CharCodes[CharCodes["F"] = 70] = "F";
    CharCodes[CharCodes["O"] = 79] = "O";
    CharCodes[CharCodes["P"] = 80] = "P";
    CharCodes[CharCodes["R"] = 82] = "R";
    CharCodes[CharCodes["LeftSquareBracket"] = 91] = "LeftSquareBracket";
    CharCodes[CharCodes["BackSlash"] = 92] = "BackSlash";
    CharCodes[CharCodes["RightSquareBracket"] = 93] = "RightSquareBracket";
    CharCodes[CharCodes["a"] = 97] = "a";
    CharCodes[CharCodes["b"] = 98] = "b";
    CharCodes[CharCodes["d"] = 100] = "d";
    CharCodes[CharCodes["e"] = 101] = "e";
    CharCodes[CharCodes["f"] = 102] = "f";
    CharCodes[CharCodes["i"] = 105] = "i";
    CharCodes[CharCodes["j"] = 106] = "j";
    CharCodes[CharCodes["l"] = 108] = "l";
    CharCodes[CharCodes["m"] = 109] = "m";
    CharCodes[CharCodes["n"] = 110] = "n";
    CharCodes[CharCodes["o"] = 111] = "o";
    CharCodes[CharCodes["r"] = 114] = "r";
    CharCodes[CharCodes["s"] = 115] = "s";
    CharCodes[CharCodes["t"] = 116] = "t";
    CharCodes[CharCodes["u"] = 117] = "u";
    CharCodes[CharCodes["x"] = 120] = "x";
    CharCodes[CharCodes["LeftCurly"] = 123] = "LeftCurly";
    CharCodes[CharCodes["RightCurly"] = 125] = "RightCurly";
    CharCodes[CharCodes["Tilde"] = 126] = "Tilde";
})($68fca35a558012d0$var$CharCodes || ($68fca35a558012d0$var$CharCodes = {}));
var $68fca35a558012d0$export$2e2bcd8739ae039 = $68fca35a558012d0$var$CharCodes;

});


parcelRegister("HB3Cf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0830c31435ca09b9$export$2e2bcd8739ae039; });

var $47XJ3 = parcelRequire("47XJ3");

var $6AcCU = parcelRequire("6AcCU");

var $l0PqT = parcelRequire("l0PqT");

var $90Qf4 = parcelRequire("90Qf4");
var $0830c31435ca09b9$var$ENFORCER = {};
var $0830c31435ca09b9$var$PDFBool = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFBool, _super);
    function PDFBool(enforcer, value) {
        var _this = this;
        if (enforcer !== $0830c31435ca09b9$var$ENFORCER) throw new (0, $6AcCU.PrivateConstructorError)('PDFBool');
        _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFBool.prototype.asBoolean = function() {
        return this.value;
    };
    PDFBool.prototype.clone = function() {
        return this;
    };
    PDFBool.prototype.toString = function() {
        return String(this.value);
    };
    PDFBool.prototype.sizeInBytes = function() {
        return this.value ? 4 : 5;
    };
    PDFBool.prototype.copyBytesInto = function(buffer, offset) {
        if (this.value) {
            buffer[offset++] = (0, $90Qf4.default).t;
            buffer[offset++] = (0, $90Qf4.default).r;
            buffer[offset++] = (0, $90Qf4.default).u;
            buffer[offset++] = (0, $90Qf4.default).e;
            return 4;
        } else {
            buffer[offset++] = (0, $90Qf4.default).f;
            buffer[offset++] = (0, $90Qf4.default).a;
            buffer[offset++] = (0, $90Qf4.default).l;
            buffer[offset++] = (0, $90Qf4.default).s;
            buffer[offset++] = (0, $90Qf4.default).e;
            return 5;
        }
    };
    PDFBool.True = new PDFBool($0830c31435ca09b9$var$ENFORCER, true);
    PDFBool.False = new PDFBool($0830c31435ca09b9$var$ENFORCER, false);
    return PDFBool;
}((0, $l0PqT.default));
var $0830c31435ca09b9$export$2e2bcd8739ae039 = $0830c31435ca09b9$var$PDFBool;

});

parcelRegister("2npvA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bb18431b667c80f$export$2e2bcd8739ae039; });

var $47XJ3 = parcelRequire("47XJ3");

var $6AcCU = parcelRequire("6AcCU");

var $l0PqT = parcelRequire("l0PqT");

var $90Qf4 = parcelRequire("90Qf4");

var $4MuQU = parcelRequire("4MuQU");
parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
var $1bb18431b667c80f$var$decodeName = function(name) {
    return name.replace(/#([\dABCDEF]{2})/g, function(_, hex) {
        return (0, $8ZzAZ.charFromHexCode)(hex);
    });
};
var $1bb18431b667c80f$var$isRegularChar = function(charCode) {
    return charCode >= (0, $90Qf4.default).ExclamationPoint && charCode <= (0, $90Qf4.default).Tilde && !(0, $4MuQU.IsIrregular)[charCode];
};
var $1bb18431b667c80f$var$ENFORCER = {};
var $1bb18431b667c80f$var$pool = new Map();
var $1bb18431b667c80f$var$PDFName = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFName, _super);
    function PDFName(enforcer, name) {
        var _this = this;
        if (enforcer !== $1bb18431b667c80f$var$ENFORCER) throw new (0, $6AcCU.PrivateConstructorError)('PDFName');
        _this = _super.call(this) || this;
        var encodedName = '/';
        for(var idx = 0, len = name.length; idx < len; idx++){
            var character = name[idx];
            var code = (0, $8ZzAZ.toCharCode)(character);
            encodedName += $1bb18431b667c80f$var$isRegularChar(code) ? character : "#" + (0, $8ZzAZ.toHexString)(code);
        }
        _this.encodedName = encodedName;
        return _this;
    }
    PDFName.prototype.asBytes = function() {
        var bytes = [];
        var hex = '';
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 1, len = this.encodedName.length; idx < len; idx++){
            var char = this.encodedName[idx];
            var byte = (0, $8ZzAZ.toCharCode)(char);
            var nextChar = this.encodedName[idx + 1];
            if (!escaped) {
                if (byte === (0, $90Qf4.default).Hash) escaped = true;
                else pushByte(byte);
            } else if (byte >= (0, $90Qf4.default).Zero && byte <= (0, $90Qf4.default).Nine || byte >= (0, $90Qf4.default).a && byte <= (0, $90Qf4.default).f || byte >= (0, $90Qf4.default).A && byte <= (0, $90Qf4.default).F) {
                hex += char;
                if (hex.length === 2 || !(nextChar >= '0' && nextChar <= '9' || nextChar >= 'a' && nextChar <= 'f' || nextChar >= 'A' && nextChar <= 'F')) {
                    pushByte(parseInt(hex, 16));
                    hex = '';
                }
            } else pushByte(byte);
        }
        return new Uint8Array(bytes);
    };
    // TODO: This should probably use `utf8Decode()`
    // TODO: Polyfill Array.from?
    PDFName.prototype.decodeText = function() {
        var bytes = this.asBytes();
        return String.fromCharCode.apply(String, Array.from(bytes));
    };
    PDFName.prototype.asString = function() {
        return this.encodedName;
    };
    /** @deprecated in favor of [[PDFName.asString]] */ PDFName.prototype.value = function() {
        return this.encodedName;
    };
    PDFName.prototype.clone = function() {
        return this;
    };
    PDFName.prototype.toString = function() {
        return this.encodedName;
    };
    PDFName.prototype.sizeInBytes = function() {
        return this.encodedName.length;
    };
    PDFName.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $8ZzAZ.copyStringIntoBuffer)(this.encodedName, buffer, offset);
        return this.encodedName.length;
    };
    PDFName.of = function(name) {
        var decodedValue = $1bb18431b667c80f$var$decodeName(name);
        var instance = $1bb18431b667c80f$var$pool.get(decodedValue);
        if (!instance) {
            instance = new PDFName($1bb18431b667c80f$var$ENFORCER, decodedValue);
            $1bb18431b667c80f$var$pool.set(decodedValue, instance);
        }
        return instance;
    };
    /* tslint:disable member-ordering */ PDFName.Length = PDFName.of('Length');
    PDFName.FlateDecode = PDFName.of('FlateDecode');
    PDFName.Resources = PDFName.of('Resources');
    PDFName.Font = PDFName.of('Font');
    PDFName.XObject = PDFName.of('XObject');
    PDFName.ExtGState = PDFName.of('ExtGState');
    PDFName.Contents = PDFName.of('Contents');
    PDFName.Type = PDFName.of('Type');
    PDFName.Parent = PDFName.of('Parent');
    PDFName.MediaBox = PDFName.of('MediaBox');
    PDFName.Page = PDFName.of('Page');
    PDFName.Annots = PDFName.of('Annots');
    PDFName.TrimBox = PDFName.of('TrimBox');
    PDFName.ArtBox = PDFName.of('ArtBox');
    PDFName.BleedBox = PDFName.of('BleedBox');
    PDFName.CropBox = PDFName.of('CropBox');
    PDFName.Rotate = PDFName.of('Rotate');
    PDFName.Title = PDFName.of('Title');
    PDFName.Author = PDFName.of('Author');
    PDFName.Subject = PDFName.of('Subject');
    PDFName.Creator = PDFName.of('Creator');
    PDFName.Keywords = PDFName.of('Keywords');
    PDFName.Producer = PDFName.of('Producer');
    PDFName.CreationDate = PDFName.of('CreationDate');
    PDFName.ModDate = PDFName.of('ModDate');
    return PDFName;
}((0, $l0PqT.default));
var $1bb18431b667c80f$export$2e2bcd8739ae039 = $1bb18431b667c80f$var$PDFName;

});
parcelRegister("4MuQU", function(module, exports) {

$parcel$export(module.exports, "IsIrregular", function () { return $37b393c651ae0b69$export$5a447e10c710a69b; });

var $90Qf4 = parcelRequire("90Qf4");

var $bomHe = parcelRequire("bomHe");

var $fKAUz = parcelRequire("fKAUz");
var $37b393c651ae0b69$export$5a447e10c710a69b = new Uint8Array(256);
for(var $37b393c651ae0b69$var$idx = 0, $37b393c651ae0b69$var$len = 256; $37b393c651ae0b69$var$idx < $37b393c651ae0b69$var$len; $37b393c651ae0b69$var$idx++)$37b393c651ae0b69$export$5a447e10c710a69b[$37b393c651ae0b69$var$idx] = (0, $fKAUz.IsWhitespace)[$37b393c651ae0b69$var$idx] || (0, $bomHe.IsDelimiter)[$37b393c651ae0b69$var$idx] ? 1 : 0;
$37b393c651ae0b69$export$5a447e10c710a69b[(0, $90Qf4.default).Hash] = 1;

});
parcelRegister("bomHe", function(module, exports) {

$parcel$export(module.exports, "IsDelimiter", function () { return $84b38a9aa0294b30$export$30620680eaa3becd; });

var $90Qf4 = parcelRequire("90Qf4");
var $84b38a9aa0294b30$export$30620680eaa3becd = new Uint8Array(256);
$84b38a9aa0294b30$export$30620680eaa3becd[(0, $90Qf4.default).LeftParen] = 1;
$84b38a9aa0294b30$export$30620680eaa3becd[(0, $90Qf4.default).RightParen] = 1;
$84b38a9aa0294b30$export$30620680eaa3becd[(0, $90Qf4.default).LessThan] = 1;
$84b38a9aa0294b30$export$30620680eaa3becd[(0, $90Qf4.default).GreaterThan] = 1;
$84b38a9aa0294b30$export$30620680eaa3becd[(0, $90Qf4.default).LeftSquareBracket] = 1;
$84b38a9aa0294b30$export$30620680eaa3becd[(0, $90Qf4.default).RightSquareBracket] = 1;
$84b38a9aa0294b30$export$30620680eaa3becd[(0, $90Qf4.default).LeftCurly] = 1;
$84b38a9aa0294b30$export$30620680eaa3becd[(0, $90Qf4.default).RightCurly] = 1;
$84b38a9aa0294b30$export$30620680eaa3becd[(0, $90Qf4.default).ForwardSlash] = 1;
$84b38a9aa0294b30$export$30620680eaa3becd[(0, $90Qf4.default).Percent] = 1;

});

parcelRegister("fKAUz", function(module, exports) {

$parcel$export(module.exports, "IsWhitespace", function () { return $b777c8c0b01694ff$export$38c4de915d0e2c37; });

var $90Qf4 = parcelRequire("90Qf4");
var $b777c8c0b01694ff$export$38c4de915d0e2c37 = new Uint8Array(256);
$b777c8c0b01694ff$export$38c4de915d0e2c37[(0, $90Qf4.default).Null] = 1;
$b777c8c0b01694ff$export$38c4de915d0e2c37[(0, $90Qf4.default).Tab] = 1;
$b777c8c0b01694ff$export$38c4de915d0e2c37[(0, $90Qf4.default).Newline] = 1;
$b777c8c0b01694ff$export$38c4de915d0e2c37[(0, $90Qf4.default).FormFeed] = 1;
$b777c8c0b01694ff$export$38c4de915d0e2c37[(0, $90Qf4.default).CarriageReturn] = 1;
$b777c8c0b01694ff$export$38c4de915d0e2c37[(0, $90Qf4.default).Space] = 1;

});




parcelRegister("9nh0j", function(module, exports) {
/*
 * JavaScript Load Image
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */ (function($) {
    'use strict';
    var urlAPI = $.URL || $.webkitURL;
    /**
   * Creates an object URL for a given File object.
   *
   * @param {Blob} blob Blob object
   * @returns {string|boolean} Returns object URL if API exists, else false.
   */ function createObjectURL(blob) {
        return urlAPI ? urlAPI.createObjectURL(blob) : false;
    }
    /**
   * Revokes a given object URL.
   *
   * @param {string} url Blob object URL
   * @returns {undefined|boolean} Returns undefined if API exists, else false.
   */ function revokeObjectURL(url) {
        return urlAPI ? urlAPI.revokeObjectURL(url) : false;
    }
    /**
   * Helper function to revoke an object URL
   *
   * @param {string} url Blob Object URL
   * @param {object} [options] Options object
   */ function revokeHelper(url, options) {
        if (url && url.slice(0, 5) === 'blob:' && !(options && options.noRevoke)) revokeObjectURL(url);
    }
    /**
   * Loads a given File object via FileReader interface.
   *
   * @param {Blob} file Blob object
   * @param {Function} onload Load event callback
   * @param {Function} [onerror] Error/Abort event callback
   * @param {string} [method=readAsDataURL] FileReader method
   * @returns {FileReader|boolean} Returns FileReader if API exists, else false.
   */ function readFile(file, onload, onerror, method) {
        if (!$.FileReader) return false;
        var reader = new FileReader();
        reader.onload = function() {
            onload.call(reader, this.result);
        };
        if (onerror) reader.onabort = reader.onerror = function() {
            onerror.call(reader, this.error);
        };
        var readerMethod = reader[method || 'readAsDataURL'];
        if (readerMethod) {
            readerMethod.call(reader, file);
            return reader;
        }
    }
    /**
   * Cross-frame instanceof check.
   *
   * @param {string} type Instance type
   * @param {object} obj Object instance
   * @returns {boolean} Returns true if the object is of the given instance.
   */ function isInstanceOf(type, obj) {
        // Cross-frame instanceof check
        return Object.prototype.toString.call(obj) === '[object ' + type + ']';
    }
    /**
   * @typedef { HTMLImageElement|HTMLCanvasElement } Result
   */ /**
   * Loads an image for a given File object.
   *
   * @param {Blob|string} file Blob object or image URL
   * @param {Function|object} [callback] Image load event callback or options
   * @param {object} [options] Options object
   * @returns {HTMLImageElement|FileReader|Promise<Result>} Object
   */ function loadImage(file, callback, options) {
        /**
     * Promise executor
     *
     * @param {Function} resolve Resolution function
     * @param {Function} reject Rejection function
     * @returns {HTMLImageElement|FileReader} Object
     */ function executor(resolve, reject) {
            var img = document.createElement('img');
            var url;
            /**
       * Callback for the fetchBlob call.
       *
       * @param {HTMLImageElement|HTMLCanvasElement} img Error object
       * @param {object} data Data object
       * @returns {undefined} Undefined
       */ function resolveWrapper(img, data) {
                if (resolve === reject) {
                    // Not using Promises
                    if (resolve) resolve(img, data);
                    return;
                } else if (img instanceof Error) {
                    reject(img);
                    return;
                }
                data = data || {} // eslint-disable-line no-param-reassign
                ;
                data.image = img;
                resolve(data);
            }
            /**
       * Callback for the fetchBlob call.
       *
       * @param {Blob} blob Blob object
       * @param {Error} err Error object
       */ function fetchBlobCallback(blob, err) {
                if (err && $.console) console.log(err) // eslint-disable-line no-console
                ;
                if (blob && isInstanceOf('Blob', blob)) {
                    file = blob // eslint-disable-line no-param-reassign
                    ;
                    url = createObjectURL(file);
                } else {
                    url = file;
                    if (options && options.crossOrigin) img.crossOrigin = options.crossOrigin;
                }
                img.src = url;
            }
            img.onerror = function(event) {
                revokeHelper(url, options);
                if (reject) reject.call(img, event);
            };
            img.onload = function() {
                revokeHelper(url, options);
                var data = {
                    originalWidth: img.naturalWidth || img.width,
                    originalHeight: img.naturalHeight || img.height
                };
                try {
                    loadImage.transform(img, options, resolveWrapper, file, data);
                } catch (error) {
                    if (reject) reject(error);
                }
            };
            if (typeof file === 'string') {
                if (loadImage.requiresMetaData(options)) loadImage.fetchBlob(file, fetchBlobCallback, options);
                else fetchBlobCallback();
                return img;
            } else if (isInstanceOf('Blob', file) || isInstanceOf('File', file)) {
                url = createObjectURL(file);
                if (url) {
                    img.src = url;
                    return img;
                }
                return readFile(file, function(url) {
                    img.src = url;
                }, reject);
            }
        }
        if ($.Promise && typeof callback !== 'function') {
            options = callback // eslint-disable-line no-param-reassign
            ;
            return new Promise(executor);
        }
        return executor(callback, callback);
    }
    // Determines if metadata should be loaded automatically.
    // Requires the load image meta extension to load metadata.
    loadImage.requiresMetaData = function(options) {
        return options && options.meta;
    };
    // If the callback given to this function returns a blob, it is used as image
    // source instead of the original url and overrides the file argument used in
    // the onload and onerror event callbacks:
    loadImage.fetchBlob = function(url, callback) {
        callback();
    };
    loadImage.transform = function(img, options, callback, file, data) {
        callback(img, data);
    };
    loadImage.global = $;
    loadImage.readFile = readFile;
    loadImage.isInstanceOf = isInstanceOf;
    loadImage.createObjectURL = createObjectURL;
    loadImage.revokeObjectURL = revokeObjectURL;
    if (typeof define === 'function' && define.amd) define(function() {
        return loadImage;
    });
    else if (0, module.exports) module.exports = loadImage;
    else $.loadImage = loadImage;
})(typeof window !== 'undefined' && window || module.exports);

});

parcelRegister("e9FyL", function(module, exports) {
/*
 * JavaScript Load Image Scaling
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */ 
(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) // Register as an anonymous AMD module:
    define([
        './load-image'
    ], factory);
    else if (0, module.exports) factory((parcelRequire("9nh0j")));
    else // Browser globals:
    factory(window.loadImage);
})(function(loadImage) {
    'use strict';
    var originalTransform = loadImage.transform;
    loadImage.createCanvas = function(width, height, offscreen) {
        if (offscreen && loadImage.global.OffscreenCanvas) return new OffscreenCanvas(width, height);
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    };
    loadImage.transform = function(img, options, callback, file, data) {
        originalTransform.call(loadImage, loadImage.scale(img, options, data), options, callback, file, data);
    };
    // Transform image coordinates, allows to override e.g.
    // the canvas orientation based on the orientation option,
    // gets canvas, options and data passed as arguments:
    loadImage.transformCoordinates = function() {};
    // Returns transformed options, allows to override e.g.
    // maxWidth, maxHeight and crop options based on the aspectRatio.
    // gets img, options, data passed as arguments:
    loadImage.getTransformedOptions = function(img, options) {
        var aspectRatio = options.aspectRatio;
        var newOptions;
        var i;
        var width;
        var height;
        if (!aspectRatio) return options;
        newOptions = {};
        for(i in options)if (Object.prototype.hasOwnProperty.call(options, i)) newOptions[i] = options[i];
        newOptions.crop = true;
        width = img.naturalWidth || img.width;
        height = img.naturalHeight || img.height;
        if (width / height > aspectRatio) {
            newOptions.maxWidth = height * aspectRatio;
            newOptions.maxHeight = height;
        } else {
            newOptions.maxWidth = width;
            newOptions.maxHeight = width / aspectRatio;
        }
        return newOptions;
    };
    // Canvas render method, allows to implement a different rendering algorithm:
    loadImage.drawImage = function(img, canvas, sourceX, sourceY, sourceWidth, sourceHeight, destWidth, destHeight, options) {
        var ctx = canvas.getContext('2d');
        if (options.imageSmoothingEnabled === false) {
            ctx.msImageSmoothingEnabled = false;
            ctx.imageSmoothingEnabled = false;
        } else if (options.imageSmoothingQuality) ctx.imageSmoothingQuality = options.imageSmoothingQuality;
        ctx.drawImage(img, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, destWidth, destHeight);
        return ctx;
    };
    // Determines if the target image should be a canvas element:
    loadImage.requiresCanvas = function(options) {
        return options.canvas || options.crop || !!options.aspectRatio;
    };
    // Scales and/or crops the given image (img or canvas HTML element)
    // using the given options:
    loadImage.scale = function(img, options, data) {
        // eslint-disable-next-line no-param-reassign
        options = options || {};
        // eslint-disable-next-line no-param-reassign
        data = data || {};
        var useCanvas = img.getContext || loadImage.requiresCanvas(options) && !!loadImage.global.HTMLCanvasElement;
        var width = img.naturalWidth || img.width;
        var height = img.naturalHeight || img.height;
        var destWidth = width;
        var destHeight = height;
        var maxWidth;
        var maxHeight;
        var minWidth;
        var minHeight;
        var sourceWidth;
        var sourceHeight;
        var sourceX;
        var sourceY;
        var pixelRatio;
        var downsamplingRatio;
        var tmp;
        var canvas;
        /**
     * Scales up image dimensions
     */ function scaleUp() {
            var scale = Math.max((minWidth || destWidth) / destWidth, (minHeight || destHeight) / destHeight);
            if (scale > 1) {
                destWidth *= scale;
                destHeight *= scale;
            }
        }
        /**
     * Scales down image dimensions
     */ function scaleDown() {
            var scale = Math.min((maxWidth || destWidth) / destWidth, (maxHeight || destHeight) / destHeight);
            if (scale < 1) {
                destWidth *= scale;
                destHeight *= scale;
            }
        }
        if (useCanvas) {
            // eslint-disable-next-line no-param-reassign
            options = loadImage.getTransformedOptions(img, options, data);
            sourceX = options.left || 0;
            sourceY = options.top || 0;
            if (options.sourceWidth) {
                sourceWidth = options.sourceWidth;
                if (options.right !== undefined && options.left === undefined) sourceX = width - sourceWidth - options.right;
            } else sourceWidth = width - sourceX - (options.right || 0);
            if (options.sourceHeight) {
                sourceHeight = options.sourceHeight;
                if (options.bottom !== undefined && options.top === undefined) sourceY = height - sourceHeight - options.bottom;
            } else sourceHeight = height - sourceY - (options.bottom || 0);
            destWidth = sourceWidth;
            destHeight = sourceHeight;
        }
        maxWidth = options.maxWidth;
        maxHeight = options.maxHeight;
        minWidth = options.minWidth;
        minHeight = options.minHeight;
        if (useCanvas && maxWidth && maxHeight && options.crop) {
            destWidth = maxWidth;
            destHeight = maxHeight;
            tmp = sourceWidth / sourceHeight - maxWidth / maxHeight;
            if (tmp < 0) {
                sourceHeight = maxHeight * sourceWidth / maxWidth;
                if (options.top === undefined && options.bottom === undefined) sourceY = (height - sourceHeight) / 2;
            } else if (tmp > 0) {
                sourceWidth = maxWidth * sourceHeight / maxHeight;
                if (options.left === undefined && options.right === undefined) sourceX = (width - sourceWidth) / 2;
            }
        } else {
            if (options.contain || options.cover) {
                minWidth = maxWidth = maxWidth || minWidth;
                minHeight = maxHeight = maxHeight || minHeight;
            }
            if (options.cover) {
                scaleDown();
                scaleUp();
            } else {
                scaleUp();
                scaleDown();
            }
        }
        if (useCanvas) {
            pixelRatio = options.pixelRatio;
            if (pixelRatio > 1 && // Check if the image has not yet had the device pixel ratio applied:
            !(img.style.width && Math.floor(parseFloat(img.style.width, 10)) === Math.floor(width / pixelRatio))) {
                destWidth *= pixelRatio;
                destHeight *= pixelRatio;
            }
            // Check if workaround for Chromium orientation crop bug is required:
            // https://bugs.chromium.org/p/chromium/issues/detail?id=1074354
            if (loadImage.orientationCropBug && !img.getContext && (sourceX || sourceY || sourceWidth !== width || sourceHeight !== height)) {
                // Write the complete source image to an intermediate canvas first:
                tmp = img;
                // eslint-disable-next-line no-param-reassign
                img = loadImage.createCanvas(width, height, true);
                loadImage.drawImage(tmp, img, 0, 0, width, height, width, height, options);
            }
            downsamplingRatio = options.downsamplingRatio;
            if (downsamplingRatio > 0 && downsamplingRatio < 1 && destWidth < sourceWidth && destHeight < sourceHeight) while(sourceWidth * downsamplingRatio > destWidth){
                canvas = loadImage.createCanvas(sourceWidth * downsamplingRatio, sourceHeight * downsamplingRatio, true);
                loadImage.drawImage(img, canvas, sourceX, sourceY, sourceWidth, sourceHeight, canvas.width, canvas.height, options);
                sourceX = 0;
                sourceY = 0;
                sourceWidth = canvas.width;
                sourceHeight = canvas.height;
                // eslint-disable-next-line no-param-reassign
                img = canvas;
            }
            canvas = loadImage.createCanvas(destWidth, destHeight);
            loadImage.transformCoordinates(canvas, options, data);
            if (pixelRatio > 1) canvas.style.width = canvas.width / pixelRatio + 'px';
            loadImage.drawImage(img, canvas, sourceX, sourceY, sourceWidth, sourceHeight, destWidth, destHeight, options).setTransform(1, 0, 0, 1, 0, 0) // reset to the identity matrix
            ;
            return canvas;
        }
        img.width = destWidth;
        img.height = destHeight;
        return img;
    };
});

});

parcelRegister("4p70X", function(module, exports) {
/*
 * JavaScript Load Image Meta
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Image metadata handling implementation
 * based on the help and contribution of
 * Achim Stöhr.
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */ 
(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) // Register as an anonymous AMD module:
    define([
        './load-image'
    ], factory);
    else if (0, module.exports) factory((parcelRequire("9nh0j")));
    else // Browser globals:
    factory(window.loadImage);
})(function(loadImage) {
    'use strict';
    var global = loadImage.global;
    var originalTransform = loadImage.transform;
    var blobSlice = global.Blob && (Blob.prototype.slice || Blob.prototype.webkitSlice || Blob.prototype.mozSlice);
    var bufferSlice = global.ArrayBuffer && ArrayBuffer.prototype.slice || function(begin, end) {
        // Polyfill for IE10, which does not support ArrayBuffer.slice
        // eslint-disable-next-line no-param-reassign
        end = end || this.byteLength - begin;
        var arr1 = new Uint8Array(this, begin, end);
        var arr2 = new Uint8Array(end);
        arr2.set(arr1);
        return arr2.buffer;
    };
    var metaDataParsers = {
        jpeg: {
            0xffe1: [],
            0xffed: [] // APP13 marker
        }
    };
    /**
   * Parses image metadata and calls the callback with an object argument
   * with the following property:
   * - imageHead: The complete image head as ArrayBuffer
   * The options argument accepts an object and supports the following
   * properties:
   * - maxMetaDataSize: Defines the maximum number of bytes to parse.
   * - disableImageHead: Disables creating the imageHead property.
   *
   * @param {Blob} file Blob object
   * @param {Function} [callback] Callback function
   * @param {object} [options] Parsing options
   * @param {object} [data] Result data object
   * @returns {Promise<object>|undefined} Returns Promise if no callback given.
   */ function parseMetaData(file, callback, options, data) {
        var that = this;
        /**
     * Promise executor
     *
     * @param {Function} resolve Resolution function
     * @param {Function} reject Rejection function
     * @returns {undefined} Undefined
     */ function executor(resolve, reject) {
            if (!(global.DataView && blobSlice && file && file.size >= 12 && file.type === 'image/jpeg')) // Nothing to parse
            return resolve(data);
            // 256 KiB should contain all EXIF/ICC/IPTC segments:
            var maxMetaDataSize = options.maxMetaDataSize || 262144;
            if (!loadImage.readFile(blobSlice.call(file, 0, maxMetaDataSize), function(buffer) {
                // Note on endianness:
                // Since the marker and length bytes in JPEG files are always
                // stored in big endian order, we can leave the endian parameter
                // of the DataView methods undefined, defaulting to big endian.
                var dataView = new DataView(buffer);
                // Check for the JPEG marker (0xffd8):
                if (dataView.getUint16(0) !== 0xffd8) return reject(new Error('Invalid JPEG file: Missing JPEG marker.'));
                var offset = 2;
                var maxOffset = dataView.byteLength - 4;
                var headLength = offset;
                var markerBytes;
                var markerLength;
                var parsers;
                var i;
                while(offset < maxOffset){
                    markerBytes = dataView.getUint16(offset);
                    // Search for APPn (0xffeN) and COM (0xfffe) markers,
                    // which contain application-specific metadata like
                    // Exif, ICC and IPTC data and text comments:
                    if (markerBytes >= 0xffe0 && markerBytes <= 0xffef || markerBytes === 0xfffe) {
                        // The marker bytes (2) are always followed by
                        // the length bytes (2), indicating the length of the
                        // marker segment, which includes the length bytes,
                        // but not the marker bytes, so we add 2:
                        markerLength = dataView.getUint16(offset + 2) + 2;
                        if (offset + markerLength > dataView.byteLength) {
                            // eslint-disable-next-line no-console
                            console.log('Invalid JPEG metadata: Invalid segment size.');
                            break;
                        }
                        parsers = metaDataParsers.jpeg[markerBytes];
                        if (parsers && !options.disableMetaDataParsers) for(i = 0; i < parsers.length; i += 1)parsers[i].call(that, dataView, offset, markerLength, data, options);
                        offset += markerLength;
                        headLength = offset;
                    } else break;
                }
                // Meta length must be longer than JPEG marker (2)
                // plus APPn marker (2), followed by length bytes (2):
                if (!options.disableImageHead && headLength > 6) data.imageHead = bufferSlice.call(buffer, 0, headLength);
                resolve(data);
            }, reject, 'readAsArrayBuffer')) // No support for the FileReader interface, nothing to parse
            resolve(data);
        }
        options = options || {} // eslint-disable-line no-param-reassign
        ;
        if (global.Promise && typeof callback !== 'function') {
            options = callback || {} // eslint-disable-line no-param-reassign
            ;
            data = options // eslint-disable-line no-param-reassign
            ;
            return new Promise(executor);
        }
        data = data || {} // eslint-disable-line no-param-reassign
        ;
        return executor(callback, callback);
    }
    /**
   * Replaces the head of a JPEG Blob
   *
   * @param {Blob} blob Blob object
   * @param {ArrayBuffer} oldHead Old JPEG head
   * @param {ArrayBuffer} newHead New JPEG head
   * @returns {Blob} Combined Blob
   */ function replaceJPEGHead(blob, oldHead, newHead) {
        if (!blob || !oldHead || !newHead) return null;
        return new Blob([
            newHead,
            blobSlice.call(blob, oldHead.byteLength)
        ], {
            type: 'image/jpeg'
        });
    }
    /**
   * Replaces the image head of a JPEG blob with the given one.
   * Returns a Promise or calls the callback with the new Blob.
   *
   * @param {Blob} blob Blob object
   * @param {ArrayBuffer} head New JPEG head
   * @param {Function} [callback] Callback function
   * @returns {Promise<Blob|null>|undefined} Combined Blob
   */ function replaceHead(blob, head, callback) {
        var options = {
            maxMetaDataSize: 1024,
            disableMetaDataParsers: true
        };
        if (!callback && global.Promise) return parseMetaData(blob, options).then(function(data) {
            return replaceJPEGHead(blob, data.imageHead, head);
        });
        parseMetaData(blob, function(data) {
            callback(replaceJPEGHead(blob, data.imageHead, head));
        }, options);
    }
    loadImage.transform = function(img, options, callback, file, data) {
        if (loadImage.requiresMetaData(options)) {
            data = data || {} // eslint-disable-line no-param-reassign
            ;
            parseMetaData(file, function(result) {
                if (result !== data) {
                    // eslint-disable-next-line no-console
                    if (global.console) console.log(result);
                    result = data // eslint-disable-line no-param-reassign
                    ;
                }
                originalTransform.call(loadImage, img, options, callback, file, result);
            }, options, data);
        } else originalTransform.apply(loadImage, arguments);
    };
    loadImage.blobSlice = blobSlice;
    loadImage.bufferSlice = bufferSlice;
    loadImage.replaceHead = replaceHead;
    loadImage.parseMetaData = parseMetaData;
    loadImage.metaDataParsers = metaDataParsers;
});

});

parcelRegister("khOMr", function(module, exports) {
/*
 * JavaScript Load Image Exif Parser
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */ /* global define, module, require, DataView */ 

(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) // Register as an anonymous AMD module:
    define([
        './load-image',
        './load-image-meta'
    ], factory);
    else if (0, module.exports) factory((parcelRequire("9nh0j")), (parcelRequire("4p70X")));
    else // Browser globals:
    factory(window.loadImage);
})(function(loadImage) {
    'use strict';
    /**
   * Exif tag map
   *
   * @name ExifMap
   * @class
   * @param {number|string} tagCode IFD tag code
   */ function ExifMap(tagCode) {
        if (tagCode) {
            Object.defineProperty(this, 'map', {
                value: this.ifds[tagCode].map
            });
            Object.defineProperty(this, 'tags', {
                value: this.tags && this.tags[tagCode] || {}
            });
        }
    }
    ExifMap.prototype.map = {
        Orientation: 0x0112,
        Thumbnail: 'ifd1',
        Blob: 0x0201,
        Exif: 0x8769,
        GPSInfo: 0x8825,
        Interoperability: 0xa005
    };
    ExifMap.prototype.ifds = {
        ifd1: {
            name: 'Thumbnail',
            map: ExifMap.prototype.map
        },
        0x8769: {
            name: 'Exif',
            map: {}
        },
        0x8825: {
            name: 'GPSInfo',
            map: {}
        },
        0xa005: {
            name: 'Interoperability',
            map: {}
        }
    };
    /**
   * Retrieves exif tag value
   *
   * @param {number|string} id Exif tag code or name
   * @returns {object} Exif tag value
   */ ExifMap.prototype.get = function(id) {
        return this[id] || this[this.map[id]];
    };
    /**
   * Returns the Exif Thumbnail data as Blob.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} offset Thumbnail data offset
   * @param {number} length Thumbnail data length
   * @returns {undefined|Blob} Returns the Thumbnail Blob or undefined
   */ function getExifThumbnail(dataView, offset, length) {
        if (!length) return;
        if (offset + length > dataView.byteLength) {
            console.log('Invalid Exif data: Invalid thumbnail data.');
            return;
        }
        return new Blob([
            loadImage.bufferSlice.call(dataView.buffer, offset, offset + length)
        ], {
            type: 'image/jpeg'
        });
    }
    var ExifTagTypes = {
        // byte, 8-bit unsigned int:
        1: {
            getValue: function(dataView, dataOffset) {
                return dataView.getUint8(dataOffset);
            },
            size: 1
        },
        // ascii, 8-bit byte:
        2: {
            getValue: function(dataView, dataOffset) {
                return String.fromCharCode(dataView.getUint8(dataOffset));
            },
            size: 1,
            ascii: true
        },
        // short, 16 bit int:
        3: {
            getValue: function(dataView, dataOffset, littleEndian) {
                return dataView.getUint16(dataOffset, littleEndian);
            },
            size: 2
        },
        // long, 32 bit int:
        4: {
            getValue: function(dataView, dataOffset, littleEndian) {
                return dataView.getUint32(dataOffset, littleEndian);
            },
            size: 4
        },
        // rational = two long values, first is numerator, second is denominator:
        5: {
            getValue: function(dataView, dataOffset, littleEndian) {
                return dataView.getUint32(dataOffset, littleEndian) / dataView.getUint32(dataOffset + 4, littleEndian);
            },
            size: 8
        },
        // slong, 32 bit signed int:
        9: {
            getValue: function(dataView, dataOffset, littleEndian) {
                return dataView.getInt32(dataOffset, littleEndian);
            },
            size: 4
        },
        // srational, two slongs, first is numerator, second is denominator:
        10: {
            getValue: function(dataView, dataOffset, littleEndian) {
                return dataView.getInt32(dataOffset, littleEndian) / dataView.getInt32(dataOffset + 4, littleEndian);
            },
            size: 8
        }
    };
    // undefined, 8-bit byte, value depending on field:
    ExifTagTypes[7] = ExifTagTypes[1];
    /**
   * Returns Exif tag value.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} tiffOffset TIFF offset
   * @param {number} offset Tag offset
   * @param {number} type Tag type
   * @param {number} length Tag length
   * @param {boolean} littleEndian Little endian encoding
   * @returns {object} Tag value
   */ function getExifValue(dataView, tiffOffset, offset, type, length, littleEndian) {
        var tagType = ExifTagTypes[type];
        var tagSize;
        var dataOffset;
        var values;
        var i;
        var str;
        var c;
        if (!tagType) {
            console.log('Invalid Exif data: Invalid tag type.');
            return;
        }
        tagSize = tagType.size * length;
        // Determine if the value is contained in the dataOffset bytes,
        // or if the value at the dataOffset is a pointer to the actual data:
        dataOffset = tagSize > 4 ? tiffOffset + dataView.getUint32(offset + 8, littleEndian) : offset + 8;
        if (dataOffset + tagSize > dataView.byteLength) {
            console.log('Invalid Exif data: Invalid data offset.');
            return;
        }
        if (length === 1) return tagType.getValue(dataView, dataOffset, littleEndian);
        values = [];
        for(i = 0; i < length; i += 1)values[i] = tagType.getValue(dataView, dataOffset + i * tagType.size, littleEndian);
        if (tagType.ascii) {
            str = '';
            // Concatenate the chars:
            for(i = 0; i < values.length; i += 1){
                c = values[i];
                // Ignore the terminating NULL byte(s):
                if (c === '\u0000') break;
                str += c;
            }
            return str;
        }
        return values;
    }
    /**
   * Determines if the given tag should be included.
   *
   * @param {object} includeTags Map of tags to include
   * @param {object} excludeTags Map of tags to exclude
   * @param {number|string} tagCode Tag code to check
   * @returns {boolean} True if the tag should be included
   */ function shouldIncludeTag(includeTags, excludeTags, tagCode) {
        return (!includeTags || includeTags[tagCode]) && (!excludeTags || excludeTags[tagCode] !== true);
    }
    /**
   * Parses Exif tags.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} tiffOffset TIFF offset
   * @param {number} dirOffset Directory offset
   * @param {boolean} littleEndian Little endian encoding
   * @param {ExifMap} tags Map to store parsed exif tags
   * @param {ExifMap} tagOffsets Map to store parsed exif tag offsets
   * @param {object} includeTags Map of tags to include
   * @param {object} excludeTags Map of tags to exclude
   * @returns {number} Next directory offset
   */ function parseExifTags(dataView, tiffOffset, dirOffset, littleEndian, tags, tagOffsets, includeTags, excludeTags) {
        var tagsNumber, dirEndOffset, i, tagOffset, tagNumber, tagValue;
        if (dirOffset + 6 > dataView.byteLength) {
            console.log('Invalid Exif data: Invalid directory offset.');
            return;
        }
        tagsNumber = dataView.getUint16(dirOffset, littleEndian);
        dirEndOffset = dirOffset + 2 + 12 * tagsNumber;
        if (dirEndOffset + 4 > dataView.byteLength) {
            console.log('Invalid Exif data: Invalid directory size.');
            return;
        }
        for(i = 0; i < tagsNumber; i += 1){
            tagOffset = dirOffset + 2 + 12 * i;
            tagNumber = dataView.getUint16(tagOffset, littleEndian);
            if (!shouldIncludeTag(includeTags, excludeTags, tagNumber)) continue;
            tagValue = getExifValue(dataView, tiffOffset, tagOffset, dataView.getUint16(tagOffset + 2, littleEndian), dataView.getUint32(tagOffset + 4, littleEndian), littleEndian);
            tags[tagNumber] = tagValue;
            if (tagOffsets) tagOffsets[tagNumber] = tagOffset;
        }
        // Return the offset to the next directory:
        return dataView.getUint32(dirEndOffset, littleEndian);
    }
    /**
   * Parses tags in a given IFD (Image File Directory).
   *
   * @param {object} data Data object to store exif tags and offsets
   * @param {number|string} tagCode IFD tag code
   * @param {DataView} dataView Data view interface
   * @param {number} tiffOffset TIFF offset
   * @param {boolean} littleEndian Little endian encoding
   * @param {object} includeTags Map of tags to include
   * @param {object} excludeTags Map of tags to exclude
   */ function parseExifIFD(data, tagCode, dataView, tiffOffset, littleEndian, includeTags, excludeTags) {
        var dirOffset = data.exif[tagCode];
        if (dirOffset) {
            data.exif[tagCode] = new ExifMap(tagCode);
            if (data.exifOffsets) data.exifOffsets[tagCode] = new ExifMap(tagCode);
            parseExifTags(dataView, tiffOffset, tiffOffset + dirOffset, littleEndian, data.exif[tagCode], data.exifOffsets && data.exifOffsets[tagCode], includeTags && includeTags[tagCode], excludeTags && excludeTags[tagCode]);
        }
    }
    loadImage.parseExifData = function(dataView, offset, length, data, options) {
        if (options.disableExif) return;
        var includeTags = options.includeExifTags;
        var excludeTags = options.excludeExifTags || {
            0x8769: {
                // ExifIFDPointer
                0x927c: true // MakerNote
            }
        };
        var tiffOffset = offset + 10;
        var littleEndian;
        var dirOffset;
        var thumbnailIFD;
        // Check for the ASCII code for "Exif" (0x45786966):
        if (dataView.getUint32(offset + 4) !== 0x45786966) // No Exif data, might be XMP data instead
        return;
        if (tiffOffset + 8 > dataView.byteLength) {
            console.log('Invalid Exif data: Invalid segment size.');
            return;
        }
        // Check for the two null bytes:
        if (dataView.getUint16(offset + 8) !== 0x0000) {
            console.log('Invalid Exif data: Missing byte alignment offset.');
            return;
        }
        // Check the byte alignment:
        switch(dataView.getUint16(tiffOffset)){
            case 0x4949:
                littleEndian = true;
                break;
            case 0x4d4d:
                littleEndian = false;
                break;
            default:
                console.log('Invalid Exif data: Invalid byte alignment marker.');
                return;
        }
        // Check for the TIFF tag marker (0x002A):
        if (dataView.getUint16(tiffOffset + 2, littleEndian) !== 0x002a) {
            console.log('Invalid Exif data: Missing TIFF marker.');
            return;
        }
        // Retrieve the directory offset bytes, usually 0x00000008 or 8 decimal:
        dirOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
        // Create the exif object to store the tags:
        data.exif = new ExifMap();
        if (!options.disableExifOffsets) {
            data.exifOffsets = new ExifMap();
            data.exifTiffOffset = tiffOffset;
            data.exifLittleEndian = littleEndian;
        }
        // Parse the tags of the main image directory (IFD0) and retrieve the
        // offset to the next directory (IFD1), usually the thumbnail directory:
        dirOffset = parseExifTags(dataView, tiffOffset, tiffOffset + dirOffset, littleEndian, data.exif, data.exifOffsets, includeTags, excludeTags);
        if (dirOffset && shouldIncludeTag(includeTags, excludeTags, 'ifd1')) {
            data.exif.ifd1 = dirOffset;
            if (data.exifOffsets) data.exifOffsets.ifd1 = tiffOffset + dirOffset;
        }
        Object.keys(data.exif.ifds).forEach(function(tagCode) {
            parseExifIFD(data, tagCode, dataView, tiffOffset, littleEndian, includeTags, excludeTags);
        });
        thumbnailIFD = data.exif.ifd1;
        // Check for JPEG Thumbnail offset and data length:
        if (thumbnailIFD && thumbnailIFD[0x0201]) thumbnailIFD[0x0201] = getExifThumbnail(dataView, tiffOffset + thumbnailIFD[0x0201], thumbnailIFD[0x0202] // Thumbnail data length
        );
    };
    // Registers the Exif parser for the APP1 JPEG metadata segment:
    loadImage.metaDataParsers.jpeg[0xffe1].push(loadImage.parseExifData);
    loadImage.exifWriters = {
        // Orientation writer:
        0x0112: function(buffer, data, value) {
            var orientationOffset = data.exifOffsets[0x0112];
            if (!orientationOffset) return buffer;
            var view = new DataView(buffer, orientationOffset + 8, 2);
            view.setUint16(0, value, data.exifLittleEndian);
            return buffer;
        }
    };
    loadImage.writeExifData = function(buffer, data, id, value) {
        return loadImage.exifWriters[data.exif.map[id]](buffer, data, value);
    };
    loadImage.ExifMap = ExifMap;
// Adds the following properties to the parseMetaData callback data:
// - exif: The parsed Exif tags
// - exifOffsets: The parsed Exif tag offsets
// - exifTiffOffset: TIFF header offset (used for offset pointers)
// - exifLittleEndian: little endian order if true, big endian if false
// Adds the following options to the parseMetaData method:
// - disableExif: Disables Exif parsing when true.
// - disableExifOffsets: Disables storing Exif tag offsets when true.
// - includeExifTags: A map of Exif tags to include for parsing.
// - excludeExifTags: A map of Exif tags to exclude from parsing.
});

});

parcelRegister("19Rix", function(module, exports) {
/*
 * JavaScript Load Image IPTC Parser
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * Copyright 2018, Dave Bevan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */ 

(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) // Register as an anonymous AMD module:
    define([
        './load-image',
        './load-image-meta'
    ], factory);
    else if (0, module.exports) factory((parcelRequire("9nh0j")), (parcelRequire("4p70X")));
    else // Browser globals:
    factory(window.loadImage);
})(function(loadImage) {
    'use strict';
    /**
   * IPTC tag map
   *
   * @name IptcMap
   * @class
   */ function IptcMap() {}
    IptcMap.prototype.map = {
        ObjectName: 5
    };
    IptcMap.prototype.types = {
        0: 'Uint16',
        200: 'Uint16',
        201: 'Uint16',
        202: 'binary' // ObjectPreviewData
    };
    /**
   * Retrieves IPTC tag value
   *
   * @param {number|string} id IPTC tag code or name
   * @returns {object} IPTC tag value
   */ IptcMap.prototype.get = function(id) {
        return this[id] || this[this.map[id]];
    };
    /**
   * Retrieves string for the given DataView and range
   *
   * @param {DataView} dataView Data view interface
   * @param {number} offset Offset start
   * @param {number} length Offset length
   * @returns {string} String value
   */ function getStringValue(dataView, offset, length) {
        var outstr = '';
        var end = offset + length;
        for(var n = offset; n < end; n += 1)outstr += String.fromCharCode(dataView.getUint8(n));
        return outstr;
    }
    /**
   * Retrieves tag value for the given DataView and range
   *
   * @param {number} tagCode tag code
   * @param {IptcMap} map IPTC tag map
   * @param {DataView} dataView Data view interface
   * @param {number} offset Range start
   * @param {number} length Range length
   * @returns {object} Tag value
   */ function getTagValue(tagCode, map, dataView, offset, length) {
        if (map.types[tagCode] === 'binary') return new Blob([
            dataView.buffer.slice(offset, offset + length)
        ]);
        if (map.types[tagCode] === 'Uint16') return dataView.getUint16(offset);
        return getStringValue(dataView, offset, length);
    }
    /**
   * Combines IPTC value with existing ones.
   *
   * @param {object} value Existing IPTC field value
   * @param {object} newValue New IPTC field value
   * @returns {object} Resulting IPTC field value
   */ function combineTagValues(value, newValue) {
        if (value === undefined) return newValue;
        if (value instanceof Array) {
            value.push(newValue);
            return value;
        }
        return [
            value,
            newValue
        ];
    }
    /**
   * Parses IPTC tags.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} segmentOffset Segment offset
   * @param {number} segmentLength Segment length
   * @param {object} data Data export object
   * @param {object} includeTags Map of tags to include
   * @param {object} excludeTags Map of tags to exclude
   */ function parseIptcTags(dataView, segmentOffset, segmentLength, data, includeTags, excludeTags) {
        var value, tagSize, tagCode;
        var segmentEnd = segmentOffset + segmentLength;
        var offset = segmentOffset;
        while(offset < segmentEnd){
            if (dataView.getUint8(offset) === 0x1c && // tag marker
            dataView.getUint8(offset + 1) === 0x02 // record number, only handles v2
            ) {
                tagCode = dataView.getUint8(offset + 2);
                if ((!includeTags || includeTags[tagCode]) && (!excludeTags || !excludeTags[tagCode])) {
                    tagSize = dataView.getInt16(offset + 3);
                    value = getTagValue(tagCode, data.iptc, dataView, offset + 5, tagSize);
                    data.iptc[tagCode] = combineTagValues(data.iptc[tagCode], value);
                    if (data.iptcOffsets) data.iptcOffsets[tagCode] = offset;
                }
            }
            offset += 1;
        }
    }
    /**
   * Tests if field segment starts at offset.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} offset Segment offset
   * @returns {boolean} True if '8BIM<EOT><EOT>' exists at offset
   */ function isSegmentStart(dataView, offset) {
        return dataView.getUint32(offset) === 0x3842494d && // Photoshop segment start
        dataView.getUint16(offset + 4) === 0x0404 // IPTC segment start
        ;
    }
    /**
   * Returns header length.
   *
   * @param {DataView} dataView Data view interface
   * @param {number} offset Segment offset
   * @returns {number} Header length
   */ function getHeaderLength(dataView, offset) {
        var length = dataView.getUint8(offset + 7);
        if (length % 2 !== 0) length += 1;
        // Check for pre photoshop 6 format
        if (length === 0) // Always 4
        length = 4;
        return length;
    }
    loadImage.parseIptcData = function(dataView, offset, length, data, options) {
        if (options.disableIptc) return;
        var markerLength = offset + length;
        while(offset + 8 < markerLength){
            if (isSegmentStart(dataView, offset)) {
                var headerLength = getHeaderLength(dataView, offset);
                var segmentOffset = offset + 8 + headerLength;
                if (segmentOffset > markerLength) {
                    // eslint-disable-next-line no-console
                    console.log('Invalid IPTC data: Invalid segment offset.');
                    break;
                }
                var segmentLength = dataView.getUint16(offset + 6 + headerLength);
                if (offset + segmentLength > markerLength) {
                    // eslint-disable-next-line no-console
                    console.log('Invalid IPTC data: Invalid segment size.');
                    break;
                }
                // Create the iptc object to store the tags:
                data.iptc = new IptcMap();
                if (!options.disableIptcOffsets) data.iptcOffsets = new IptcMap();
                parseIptcTags(dataView, segmentOffset, segmentLength, data, options.includeIptcTags, options.excludeIptcTags || {
                    202: true
                } // ObjectPreviewData
                );
                return;
            }
            // eslint-disable-next-line no-param-reassign
            offset += 1;
        }
    };
    // Registers this IPTC parser for the APP13 JPEG metadata segment:
    loadImage.metaDataParsers.jpeg[0xffed].push(loadImage.parseIptcData);
    loadImage.IptcMap = IptcMap;
// Adds the following properties to the parseMetaData callback data:
// - iptc: The iptc tags, parsed by the parseIptcData method
// Adds the following options to the parseMetaData method:
// - disableIptc: Disables IPTC parsing when true.
// - disableIptcOffsets: Disables storing IPTC tag offsets when true.
// - includeIptcTags: A map of IPTC tags to include for parsing.
// - excludeIptcTags: A map of IPTC tags to exclude from parsing.
});

});

parcelRegister("cLIgV", function(module, exports) {

$parcel$export(module.exports, "createInstance", function () { return createInstance; });
$parcel$export(module.exports, "init", function () { return init; });
$parcel$export(module.exports, "loadResources", function () { return loadResources; });
$parcel$export(module.exports, "reloadResources", function () { return reloadResources; });
$parcel$export(module.exports, "use", function () { return use; });
$parcel$export(module.exports, "changeLanguage", function () { return changeLanguage; });
$parcel$export(module.exports, "getFixedT", function () { return getFixedT; });
$parcel$export(module.exports, "t", function () { return t; });
$parcel$export(module.exports, "exists", function () { return exists; });
$parcel$export(module.exports, "setDefaultNamespace", function () { return setDefaultNamespace; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return hasLoadedNamespace; });
$parcel$export(module.exports, "loadNamespaces", function () { return loadNamespaces; });
$parcel$export(module.exports, "loadLanguages", function () { return loadLanguages; });
$parcel$export(module.exports, "default", function () { return $94bc374bfa14ebb7$export$2e2bcd8739ae039; });

var $6g7hW = parcelRequire("6g7hW");

var $9VR4w = parcelRequire("9VR4w");

var $8HiBB = parcelRequire("8HiBB");

var $4TaHZ = parcelRequire("4TaHZ");

var $2tFMC = parcelRequire("2tFMC");

var $hEAnx = parcelRequire("hEAnx");

var $d60oy = parcelRequire("d60oy");

var $5fApW = parcelRequire("5fApW");

var $fxpTi = parcelRequire("fxpTi");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, $5fApW.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var consoleLogger = {
    type: 'logger',
    log: function log(args) {
        this.output('log', args);
    },
    warn: function warn(args) {
        this.output('warn', args);
    },
    error: function error(args) {
        this.output('error', args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $9VR4w.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $8HiBB.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || 'i18next:';
                this.logger = concreteLogger || consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, 'log', '', true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, 'warn', '', true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, 'error', '');
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, _objectSpread(_objectSpread({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var baseLogger = new Logger();
var EventEmitter = function() {
    function EventEmitter() {
        (0, $9VR4w.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, $8HiBB.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(' ').forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers['*']) {
                    var _cloned = [].concat(this.observers['*']);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function makeString(object) {
    if (object == null) return '';
    return '' + object;
}
function copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === 'string';
    }
    var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function setPath(object, path, newValue) {
    var _getLastOfPath = getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
    var _getLastOfPath3 = getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
    var value = getPath(data, key);
    if (value !== undefined) return value;
    return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
function escape(data) {
    if (typeof data === 'string') return data.replace(/[&<>"'\/]/g, function(s) {
        return _entityMap[s];
    });
    return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    var possibleChars = chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === '?' ? '\\?' : c;
    }).join('|'), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$1(Object(source), true).forEach(function(key) {
            (0, $5fApW.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $d60oy.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $d60oy.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $hEAnx.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === 'string') return mix;
                if (p && typeof mix[p] === 'string') return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
var ResourceStore = function(_EventEmitter) {
    (0, $2tFMC.default)(ResourceStore, _EventEmitter);
    var _super = _createSuper(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        (0, $9VR4w.default)(this, ResourceStore);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $4TaHZ.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $8HiBB.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== 'string') path = path.concat(key);
                if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) path = lng.split('.');
                var result = getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
                return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = '.';
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                setPath(this.data, path, value);
                if (!options.silent) this.emit('added', lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = getPath(this.data, path) || {};
                if (deep) deepExtend(pack, resources, overwrite);
                else pack = _objectSpread$1(_objectSpread$1({}, pack), resources);
                setPath(this.data, path, pack);
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit('removed', lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === 'v1') return _objectSpread$1(_objectSpread$1({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}(EventEmitter);
var postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$2(Object(source), true).forEach(function(key) {
            (0, $5fApW.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $d60oy.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $d60oy.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $hEAnx.default)(this, result);
    };
}
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var checkedLoadedFor = {};
var Translator = function(_EventEmitter) {
    (0, $2tFMC.default)(Translator, _EventEmitter);
    var _super = _createSuper$1(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $9VR4w.default)(this, Translator);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $4TaHZ.default)(_this));
        copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, (0, $4TaHZ.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        _this.logger = baseLogger.create('translator');
        return _this;
    }
    (0, $8HiBB.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ':';
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $6g7hW.default)(options) !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return '';
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === 'cimode') {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) {
                            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
                            return resolved;
                        }
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) {
                        resolved.res = key;
                        return resolved;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    '[object Number]',
                    '[object Function]',
                    '[object RegExp]'
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === '[object Array]';
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit('missingKey', l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== 'v1') res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
                        interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === 'string' ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === 'string') keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = 'defaultValue';
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}(EventEmitter);
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $9VR4w.default)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = baseLogger.create('languageUtils');
    }
    (0, $8HiBB.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return null;
                var p = code.split('-');
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === 'x') return null;
                return this.formatLanguageCode(p.join('-'));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return code;
                var p = code.split('-');
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    var specialCases = [
                        'hans',
                        'hant',
                        'latn',
                        'cyrl',
                        'cans',
                        'mong',
                        'arab'
                    ];
                    var p = code.split('-');
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
                    }
                    return p.join('-');
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
                if (typeof fallbacks === 'string') fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
                    if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === 'string') addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var _rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var deprecatedJsonVersions = [
    'v1',
    'v2',
    'v3'
];
var suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function createRules() {
    var rules = {};
    sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: _rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $9VR4w.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = baseLogger.create('pluralResolver');
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
            this.options.compatibilityJSON = 'v3';
            this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
        }
        this.rules = createRules();
    }
    (0, $8HiBB.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? 'ordinal' : 'cardinal'
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return '';
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = 'plural';
                    else if (suffix === 1) suffix = '';
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === 'v1') {
                    if (suffix === 1) return '';
                    if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$3(Object(source), true).forEach(function(key) {
            (0, $5fApW.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $9VR4w.default)(this, Interpolator);
        this.logger = baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $8HiBB.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
                this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
                this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
                this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
                this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
                this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, 'g');
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, '$$$$');
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === 'function') {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === 'string' ? temp : '';
                            } else if (options && options.hasOwnProperty(matchedVar)) value = '';
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = '';
                            }
                        } else if (typeof value !== 'string' && !_this.useRawValueToEscape) value = makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = _objectSpread$3({}, options);
                clonedOptions.applyPostProcessor = false;
                delete clonedOptions.defaultValue;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== 'string') return value;
                    if (typeof value !== 'string') value = makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = '';
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$4(Object(source), true).forEach(function(key) {
            (0, $5fApW.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        var p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(';');
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(':'), _opt$split2 = (0, $fxpTi.default)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === 'false') formatOptions[key.trim()] = false;
                if (val === 'true') formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $9VR4w.default)(this, Formatter);
        this.logger = baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, options);
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
                    style: 'currency'
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.DateTimeFormat(lng, _objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val, options.range || 'day');
                };
            }),
            list: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.ListFormat(lng, _objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $8HiBB.default)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng, options) {
                var _this = this;
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$5(Object(source), true).forEach(function(key) {
            (0, $5fApW.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $d60oy.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $d60oy.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $hEAnx.default)(this, result);
    };
}
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var Connector = function(_EventEmitter) {
    (0, $2tFMC.default)(Connector, _EventEmitter);
    var _super = _createSuper$2(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $9VR4w.default)(this, Connector);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $4TaHZ.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = baseLogger.create('backendConnector');
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $8HiBB.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit('failedLoading', lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    pushPath(q.loaded, [
                        lng
                    ], ns);
                    removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(ns) {
                                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit('loaded', loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                return this.backend[fcName](lng, ns, function(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn('No backend was added via i18next.use. Will not load resources.');
                    return callback && callback();
                }
                if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, 'read', undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                    return;
                }
                if (key === undefined || key === null || key === '') return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
                    isUpdate: isUpdate
                }));
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}(EventEmitter);
function get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $6g7hW.default)(args[1]) === 'object') ret = args[1];
            if (typeof args[1] === 'string') ret.defaultValue = args[1];
            if (typeof args[2] === 'string') ret.tDescription = args[2];
            if ((0, $6g7hW.default)(args[2]) === 'object' || (0, $6g7hW.default)(args[3]) === 'object') {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function transformOptions(options) {
    if (typeof options.ns === 'string') options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === 'string') options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === 'string') options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
}
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$6(Object(source), true).forEach(function(key) {
            (0, $5fApW.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $d60oy.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $d60oy.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $hEAnx.default)(this, result);
    };
}
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function noop() {}
function bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
}
var I18n = function(_EventEmitter) {
    (0, $2tFMC.default)(I18n, _EventEmitter);
    var _super = _createSuper$3(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $9VR4w.default)(this, I18n);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $4TaHZ.default)(_this));
        _this.options = transformOptions(options);
        _this.services = {};
        _this.logger = baseLogger;
        _this.modules = {
            external: []
        };
        bindMemberFunctions((0, $4TaHZ.default)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $hEAnx.default)(_this, (0, $4TaHZ.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $8HiBB.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === 'string') options.defaultNS = options.ns;
                    else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = get();
                this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));
                if (this.options.compatibilityAPI !== 'v1') this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === 'function') return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== 'undefined') formatter = Formatter;
                    var lu = new LanguageUtil(this.options);
                    this.store = new ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on('*', function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new Translator(this.services, this.options);
                    this.translator.on('*', function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
                var storeApi = [
                    'getResource',
                    'hasResourceBundle',
                    'getResourceBundle',
                    'getDataByLanguage'
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    'addResource',
                    'addResources',
                    'addResourceBundle',
                    'removeResourceBundle'
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
                        _this2.emit('initialized', _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var usedCallback = callback;
                var usedLng = typeof language === 'string' ? language : this.language;
                if (typeof language === 'function') usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
                if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
                if (module.type === 'backend') this.modules.backend = module;
                if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === 'languageDetector') this.modules.languageDetector = module;
                if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
                if (module.type === 'postProcessor') postProcessor.addPostProcessor(module);
                if (module.type === 'formatter') this.modules.formatter = module;
                if (module.type === '3rdParty') this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    'cimode',
                    'dev'
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        'cimode',
                        'dev'
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = defer();
                this.emit('languageChanging', lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit('languageChanged', l);
                        _this4.logger.log('languageChanged', l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $6g7hW.default)(opts) !== 'object') {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = _objectSpread$6({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || '.';
                    var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === 'string') fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
                    return false;
                }
                var lng = this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === 'cimode') return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === 'string') ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = defer();
                if (typeof lngs === 'string') lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return 'rtl';
                var rtlLngs = [
                    'ar',
                    'shu',
                    'sqr',
                    'ssh',
                    'xaa',
                    'yhd',
                    'yud',
                    'aao',
                    'abh',
                    'abv',
                    'acm',
                    'acq',
                    'acw',
                    'acx',
                    'acy',
                    'adf',
                    'ads',
                    'aeb',
                    'aec',
                    'afb',
                    'ajp',
                    'apc',
                    'apd',
                    'arb',
                    'arq',
                    'ars',
                    'ary',
                    'arz',
                    'auz',
                    'avl',
                    'ayh',
                    'ayl',
                    'ayn',
                    'ayp',
                    'bbz',
                    'pga',
                    'he',
                    'iw',
                    'ps',
                    'pbt',
                    'pbu',
                    'pst',
                    'prp',
                    'prd',
                    'ug',
                    'ur',
                    'ydd',
                    'yds',
                    'yih',
                    'ji',
                    'yi',
                    'hbo',
                    'men',
                    'xmn',
                    'fa',
                    'jpr',
                    'peo',
                    'pes',
                    'prs',
                    'dv',
                    'sam',
                    'ckb'
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    'store',
                    'services',
                    'language'
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = _objectSpread$6({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new Translator(clone.services, clone.options);
                clone.translator.on('*', function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}(EventEmitter);
(0, $5fApW.default)(I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
var createInstance = instance.createInstance;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;
var $94bc374bfa14ebb7$export$2e2bcd8739ae039 = instance;

});
parcelRegister("6g7hW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48e9e402a576f477$export$2e2bcd8739ae039; });
function $48e9e402a576f477$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $48e9e402a576f477$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $48e9e402a576f477$export$2e2bcd8739ae039(o);
}

});

parcelRegister("9VR4w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73b29ae2d5450298$export$2e2bcd8739ae039; });
function $73b29ae2d5450298$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("8HiBB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6550c5886e053039$export$2e2bcd8739ae039; });

var $lqK15 = parcelRequire("lqK15");
function $6550c5886e053039$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $lqK15.default)(descriptor.key), descriptor);
    }
}
function $6550c5886e053039$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $6550c5886e053039$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6550c5886e053039$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});
parcelRegister("lqK15", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f99fb89fe0a27b15$export$2e2bcd8739ae039; });

var $6g7hW = parcelRequire("6g7hW");

var $eocwv = parcelRequire("eocwv");
function $f99fb89fe0a27b15$export$2e2bcd8739ae039(t) {
    var i = (0, $eocwv.default)(t, "string");
    return "symbol" == (0, $6g7hW.default)(i) ? i : i + "";
}

});
parcelRegister("eocwv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a79d0571922586aa$export$2e2bcd8739ae039; });

var $6g7hW = parcelRequire("6g7hW");
function $a79d0571922586aa$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $6g7hW.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $6g7hW.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("4TaHZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38f49af7ad6b6c27$export$2e2bcd8739ae039; });
function $38f49af7ad6b6c27$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("2tFMC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cdeb374564bb2bc$export$2e2bcd8739ae039; });

var $jEgcK = parcelRequire("jEgcK");
function $1cdeb374564bb2bc$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $jEgcK.default)(subClass, superClass);
}

});
parcelRegister("jEgcK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4de52a998646915$export$2e2bcd8739ae039; });
function $e4de52a998646915$export$2e2bcd8739ae039(o, p) {
    $e4de52a998646915$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e4de52a998646915$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("hEAnx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cda2641fc057498d$export$2e2bcd8739ae039; });

var $6g7hW = parcelRequire("6g7hW");

var $4TaHZ = parcelRequire("4TaHZ");
function $cda2641fc057498d$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $6g7hW.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $4TaHZ.default)(self);
}

});

parcelRegister("d60oy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $988c24550f286cce$export$2e2bcd8739ae039; });
function $988c24550f286cce$export$2e2bcd8739ae039(o) {
    $988c24550f286cce$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $988c24550f286cce$export$2e2bcd8739ae039(o);
}

});

parcelRegister("5fApW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d2a9a314df18bb4$export$2e2bcd8739ae039; });

var $lqK15 = parcelRequire("lqK15");
function $3d2a9a314df18bb4$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $lqK15.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("fxpTi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4fe0572b8402a39$export$2e2bcd8739ae039; });

var $aHC7s = parcelRequire("aHC7s");

var $3yua1 = parcelRequire("3yua1");

var $ltlk5 = parcelRequire("ltlk5");

var $ltWw4 = parcelRequire("ltWw4");
function $b4fe0572b8402a39$export$2e2bcd8739ae039(arr) {
    return (0, $aHC7s.default)(arr) || (0, $3yua1.default)(arr) || (0, $ltlk5.default)(arr) || (0, $ltWw4.default)();
}

});
parcelRegister("aHC7s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cab7d382d415256$export$2e2bcd8739ae039; });
function $7cab7d382d415256$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("3yua1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $296bf1557463ce90$export$2e2bcd8739ae039; });
function $296bf1557463ce90$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("ltlk5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa1cd8af69e53469$export$2e2bcd8739ae039; });

var $kmhzA = parcelRequire("kmhzA");
function $fa1cd8af69e53469$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $kmhzA.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $kmhzA.default)(o, minLen);
}

});
parcelRegister("kmhzA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed237e55f0a7d78e$export$2e2bcd8739ae039; });
function $ed237e55f0a7d78e$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("ltWw4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa39b284f087a6b0$export$2e2bcd8739ae039; });
function $fa39b284f087a6b0$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



var $a73c5e94313bcddb$exports = {};


(parcelRequire("6HTJH")).register((parcelRequire("jN93C")).getBundleURL('a0IFD'), JSON.parse("[\"a0IFD\",\"index.3aaedeb0.js\",\"By79o\",\"pay-wall-person.a1a60f18.png\",\"eufdg\",\"taxaroo-logo.7a3ce4e2.png\",\"3uu5w\",\"empty.e5bcf0dc.png\",\"1obon\",\"empty.a99e273d.png\",\"j7mT6\",\"empty.e5bcf0dc.png\",\"1QZfE\",\"html2canvas.b6e548af.js\",\"1MzEI\",\"purify.1ed18c3f.js\",\"dzTn4\",\"index.es.c753ab05.js\",\"fIVmS\",\"_empty.edb61c7e.js\",\"4utqd\",\"pdf.worker.min.6e91ecaa.js\",\"c2RQ8\",\"index.8a25f367.css\"]"));


var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

var $8CZEB = parcelRequire("8CZEB");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $7455305bac30ddd9$var$extendStatics = function(d, b) {
    $7455305bac30ddd9$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $7455305bac30ddd9$var$extendStatics(d, b);
};
function $7455305bac30ddd9$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $7455305bac30ddd9$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7455305bac30ddd9$export$18ce0697a983be9b = function() {
    $7455305bac30ddd9$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7455305bac30ddd9$export$18ce0697a983be9b.apply(this, arguments);
};
function $7455305bac30ddd9$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7455305bac30ddd9$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $7455305bac30ddd9$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $7455305bac30ddd9$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $7455305bac30ddd9$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7455305bac30ddd9$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $7455305bac30ddd9$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $7455305bac30ddd9$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $7455305bac30ddd9$export$45d3717a4c69092e(o, m, p);
}
function $7455305bac30ddd9$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $7455305bac30ddd9$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $7455305bac30ddd9$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7455305bac30ddd9$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $7455305bac30ddd9$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $7455305bac30ddd9$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $7455305bac30ddd9$export$10c90e4f7922046c(v) {
    return this instanceof $7455305bac30ddd9$export$10c90e4f7922046c ? (this.v = v, this) : new $7455305bac30ddd9$export$10c90e4f7922046c(v);
}
function $7455305bac30ddd9$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7455305bac30ddd9$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $7455305bac30ddd9$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7455305bac30ddd9$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $7455305bac30ddd9$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7455305bac30ddd9$export$19a8beecd37a4c45 === "function" ? $7455305bac30ddd9$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $7455305bac30ddd9$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $7455305bac30ddd9$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $7455305bac30ddd9$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7455305bac30ddd9$export$45d3717a4c69092e(result, mod, k);
    }
    $7455305bac30ddd9$var$__setModuleDefault(result, mod);
    return result;
}
function $7455305bac30ddd9$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $7455305bac30ddd9$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $7455305bac30ddd9$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $7455305bac30ddd9$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


var $03191bfc90720c4f$var$genericMessage = "Invariant Violation";
var $03191bfc90720c4f$var$_a = Object.setPrototypeOf, $03191bfc90720c4f$var$setPrototypeOf = $03191bfc90720c4f$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $03191bfc90720c4f$var$_a;
var $03191bfc90720c4f$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $7455305bac30ddd9$export$a8ba968b8961cb8a)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $03191bfc90720c4f$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $03191bfc90720c4f$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $03191bfc90720c4f$var$genericMessage;
        $03191bfc90720c4f$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $03191bfc90720c4f$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $03191bfc90720c4f$export$cea12affaee22fe8(message);
}
var $03191bfc90720c4f$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $03191bfc90720c4f$var$verbosityLevel = $03191bfc90720c4f$var$verbosityLevels.indexOf("log");
function $03191bfc90720c4f$var$wrapConsoleMethod(name) {
    return function() {
        if ($03191bfc90720c4f$var$verbosityLevels.indexOf(name) >= $03191bfc90720c4f$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $03191bfc90720c4f$var$wrapConsoleMethod("debug");
    invariant.log = $03191bfc90720c4f$var$wrapConsoleMethod("log");
    invariant.warn = $03191bfc90720c4f$var$wrapConsoleMethod("warn");
    invariant.error = $03191bfc90720c4f$var$wrapConsoleMethod("error");
})($03191bfc90720c4f$export$f5708dca728d7177 || ($03191bfc90720c4f$export$f5708dca728d7177 = {}));
function $03191bfc90720c4f$export$a80e09f2cd325fb8(level) {
    var old = $03191bfc90720c4f$var$verbosityLevels[$03191bfc90720c4f$var$verbosityLevel];
    $03191bfc90720c4f$var$verbosityLevel = Math.max(0, $03191bfc90720c4f$var$verbosityLevels.indexOf(level));
    return old;
}
var $03191bfc90720c4f$export$2e2bcd8739ae039 = $03191bfc90720c4f$export$f5708dca728d7177;


function $b39dc9e14d9f1bb4$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}


var $529d602cf6fa2ecd$export$2e2bcd8739ae039 = (0, $b39dc9e14d9f1bb4$export$f8b8b9ce72e9ccbf)(function() {
    return globalThis;
}) || (0, $b39dc9e14d9f1bb4$export$f8b8b9ce72e9ccbf)(function() {
    return window;
}) || (0, $b39dc9e14d9f1bb4$export$f8b8b9ce72e9ccbf)(function() {
    return self;
}) || (0, $b39dc9e14d9f1bb4$export$f8b8b9ce72e9ccbf)(function() {
    return $parcel$global;
}) || (0, $b39dc9e14d9f1bb4$export$f8b8b9ce72e9ccbf)(function() {
    return (0, $b39dc9e14d9f1bb4$export$f8b8b9ce72e9ccbf).constructor("return this")();
});



var $ef62416d46a9c623$var$__ = "__";
var $ef62416d46a9c623$var$GLOBAL_KEY = [
    $ef62416d46a9c623$var$__,
    $ef62416d46a9c623$var$__
].join("DEV");
function $ef62416d46a9c623$var$getDEV() {
    try {
        return Boolean(__DEV__);
    } catch (_a) {
        Object.defineProperty((0, $529d602cf6fa2ecd$export$2e2bcd8739ae039), $ef62416d46a9c623$var$GLOBAL_KEY, {
            value: (0, $b39dc9e14d9f1bb4$export$f8b8b9ce72e9ccbf)(function() {
                return "production";
            }) !== "production",
            enumerable: false,
            configurable: true,
            writable: true
        });
        return (0, $529d602cf6fa2ecd$export$2e2bcd8739ae039)[$ef62416d46a9c623$var$GLOBAL_KEY];
    }
}
var $ef62416d46a9c623$export$2e2bcd8739ae039 = $ef62416d46a9c623$var$getDEV();



var $8LKEK = parcelRequire("8LKEK");
function $ddbd9e45d8c9d229$var$maybe(thunk) {
    try {
        return thunk();
    } catch (_) {}
}
var $ddbd9e45d8c9d229$var$safeGlobal = $ddbd9e45d8c9d229$var$maybe(function() {
    return globalThis;
}) || $ddbd9e45d8c9d229$var$maybe(function() {
    return window;
}) || $ddbd9e45d8c9d229$var$maybe(function() {
    return self;
}) || $ddbd9e45d8c9d229$var$maybe(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
$ddbd9e45d8c9d229$var$maybe(function() {
    return $ddbd9e45d8c9d229$var$maybe.constructor("return this")();
});
var $ddbd9e45d8c9d229$var$needToRemove = false;
function $ddbd9e45d8c9d229$export$4b3e715f166fdd78() {
    if ($ddbd9e45d8c9d229$var$safeGlobal && !$ddbd9e45d8c9d229$var$maybe(function() {
        return "production";
    }) && !$ddbd9e45d8c9d229$var$maybe(function() {
        return $8LKEK;
    })) {
        Object.defineProperty($ddbd9e45d8c9d229$var$safeGlobal, "process", {
            value: {
                env: {
                    // This default needs to be "production" instead of "development", to
                    // avoid the problem https://github.com/graphql/graphql-js/pull/2894
                    // will eventually solve, once merged and released.
                    NODE_ENV: "production"
                }
            },
            // Let anyone else change global.process as they see fit, but hide it from
            // Object.keys(global) enumeration.
            configurable: true,
            enumerable: false,
            writable: true
        });
        $ddbd9e45d8c9d229$var$needToRemove = true;
    }
}
// Call install() at least once, when this module is imported.
$ddbd9e45d8c9d229$export$4b3e715f166fdd78();
function $ddbd9e45d8c9d229$export$cd7f480d6b8286c3() {
    if ($ddbd9e45d8c9d229$var$needToRemove) {
        delete $ddbd9e45d8c9d229$var$safeGlobal.process;
        $ddbd9e45d8c9d229$var$needToRemove = false;
    }
}


function $d9bdcc7feb0c4bb8$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $9fb51304070b81b7$var$MAX_ARRAY_LENGTH = 10;
const $9fb51304070b81b7$var$MAX_RECURSIVE_DEPTH = 2;
function $9fb51304070b81b7$export$9dec5d1b3b6a130d(value) {
    return $9fb51304070b81b7$var$formatValue(value, []);
}
function $9fb51304070b81b7$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $9fb51304070b81b7$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $9fb51304070b81b7$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($9fb51304070b81b7$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $9fb51304070b81b7$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $9fb51304070b81b7$var$formatArray(value, seenValues);
    return $9fb51304070b81b7$var$formatObject(value, seenValues);
}
function $9fb51304070b81b7$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $9fb51304070b81b7$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $9fb51304070b81b7$var$MAX_RECURSIVE_DEPTH) return '[' + $9fb51304070b81b7$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $9fb51304070b81b7$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $9fb51304070b81b7$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $9fb51304070b81b7$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($9fb51304070b81b7$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($9fb51304070b81b7$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $9fb51304070b81b7$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}



/* c8 ignore next 3 */ const $a56dcb1ed6fa1460$var$isProduction = globalThis.process && // eslint-disable-next-line no-undef
true;
const $a56dcb1ed6fa1460$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
$a56dcb1ed6fa1460$var$isProduction ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === 'object' && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $9fb51304070b81b7$export$9dec5d1b3b6a130d)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};


class $f0c15646e987ba10$export$1d2df86270c81ecb {
    constructor(body, name = 'GraphQL request', locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === 'string' || (0, $d9bdcc7feb0c4bb8$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $9fb51304070b81b7$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $d9bdcc7feb0c4bb8$export$b6cb5906f04696c8)(false, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $d9bdcc7feb0c4bb8$export$b6cb5906f04696c8)(false, 'column in locationOffset is 1-indexed and must be positive.');
    }
    get [Symbol.toStringTag]() {
        return 'Source';
    }
}
function $f0c15646e987ba10$export$75135ee9ed6e435b(source) {
    return (0, $a56dcb1ed6fa1460$export$ca03416d6c9e029e)(source, $f0c15646e987ba10$export$1d2df86270c81ecb);
}


function $b8960be26a412786$export$645629cf60cf5775() {
    return typeof (0, $f0c15646e987ba10$export$1d2df86270c81ecb) === "function" ? (0, $ddbd9e45d8c9d229$export$cd7f480d6b8286c3)() : (0, $ddbd9e45d8c9d229$export$cd7f480d6b8286c3)();
}




function $c827ead0a621fcc3$export$94b45febe34b7938() {
    __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)("boolean" === typeof (0, $ef62416d46a9c623$export$2e2bcd8739ae039), (0, $ef62416d46a9c623$export$2e2bcd8739ae039)) : (0, $03191bfc90720c4f$export$f5708dca728d7177)("boolean" === typeof (0, $ef62416d46a9c623$export$2e2bcd8739ae039), 38);
}
(0, $b8960be26a412786$export$645629cf60cf5775)();
$c827ead0a621fcc3$export$94b45febe34b7938();



var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");

var $b97fc55b2a1fddda$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && (0, $b39dc9e14d9f1bb4$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.product;
}) !== 'ReactNative';
var $b97fc55b2a1fddda$export$7293b8a0b474028d = typeof WeakSet === 'function';
var $b97fc55b2a1fddda$export$23ba675b4b838b92 = typeof Symbol === 'function' && typeof Symbol.for === 'function';
var $b97fc55b2a1fddda$export$c34f882e9f1c1637 = $b97fc55b2a1fddda$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $b97fc55b2a1fddda$export$71594e8a50f746f4 = typeof (0, $b39dc9e14d9f1bb4$export$f8b8b9ce72e9ccbf)(function() {
    return window.document.createElement;
}) === "function";
var $b97fc55b2a1fddda$var$usingJSDOM = (0, $b39dc9e14d9f1bb4$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $b97fc55b2a1fddda$export$4001f6cd4a62405b = $b97fc55b2a1fddda$export$71594e8a50f746f4 && !$b97fc55b2a1fddda$var$usingJSDOM;


var $0c60d4e5be34846c$var$contextKey = (0, $b97fc55b2a1fddda$export$23ba675b4b838b92) ? Symbol.for('__APOLLO_CONTEXT__') : '__APOLLO_CONTEXT__';
function $0c60d4e5be34846c$export$a47505d961ee3a1() {
    var context = $6fFrj.createContext[$0c60d4e5be34846c$var$contextKey];
    if (!context) {
        Object.defineProperty($6fFrj.createContext, $0c60d4e5be34846c$var$contextKey, {
            value: context = $6fFrj.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true
        });
        context.displayName = 'ApolloContext';
    }
    return context;
}


var $aada76e34d6cfbf9$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, $0c60d4e5be34846c$export$a47505d961ee3a1)();
    return $6fFrj.createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(context.client, 'ApolloProvider was not passed a client instance. Make sure you pass in your client via the "client" prop.') : (0, $03191bfc90720c4f$export$f5708dca728d7177)(context.client, 28);
        return $6fFrj.createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};



var $6fFrj = parcelRequire("6fFrj");
function $caa8046e980e645b$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $caa8046e980e645b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $caa8046e980e645b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $caa8046e980e645b$var$_typeof(obj);
}
function $caa8046e980e645b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $caa8046e980e645b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $caa8046e980e645b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $caa8046e980e645b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $caa8046e980e645b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $caa8046e980e645b$var$_possibleConstructorReturn(self, call) {
    if (call && ($caa8046e980e645b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $caa8046e980e645b$var$_assertThisInitialized(self);
}
function $caa8046e980e645b$var$_getPrototypeOf(o) {
    $caa8046e980e645b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $caa8046e980e645b$var$_getPrototypeOf(o);
}
function $caa8046e980e645b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $caa8046e980e645b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $caa8046e980e645b$var$_setPrototypeOf(subClass, superClass);
}
function $caa8046e980e645b$var$_setPrototypeOf(o, p) {
    $caa8046e980e645b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $caa8046e980e645b$var$_setPrototypeOf(o, p);
}
function $caa8046e980e645b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $caa8046e980e645b$export$311ca220e7478cda = /*#__PURE__*/ function(_PureComponent) {
    $caa8046e980e645b$var$_inherits(PersistGate, _PureComponent);
    function PersistGate() {
        var _getPrototypeOf2;
        var _this;
        $caa8046e980e645b$var$_classCallCheck(this, PersistGate);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $caa8046e980e645b$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $caa8046e980e645b$var$_getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $caa8046e980e645b$var$_defineProperty($caa8046e980e645b$var$_assertThisInitialized(_this), "state", {
            bootstrapped: false
        });
        $caa8046e980e645b$var$_defineProperty($caa8046e980e645b$var$_assertThisInitialized(_this), "_unsubscribe", void 0);
        $caa8046e980e645b$var$_defineProperty($caa8046e980e645b$var$_assertThisInitialized(_this), "handlePersistorState", function() {
            var persistor = _this.props.persistor;
            var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
            if (bootstrapped) {
                if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).finally(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                });
                else _this.setState({
                    bootstrapped: true
                });
                _this._unsubscribe && _this._unsubscribe();
            }
        });
        return _this;
    }
    $caa8046e980e645b$var$_createClass(PersistGate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                this.handlePersistorState();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._unsubscribe && this._unsubscribe();
            }
        },
        {
            key: "render",
            value: function render() {
                if (typeof this.props.children === 'function') return this.props.children(this.state.bootstrapped);
                return this.state.bootstrapped ? this.props.children : this.props.loading;
            }
        }
    ]);
    return PersistGate;
}((0, $6fFrj.PureComponent));
$caa8046e980e645b$var$_defineProperty($caa8046e980e645b$export$311ca220e7478cda, "defaultProps", {
    children: null,
    loading: null
});


var $97a27fb4e1c739e5$export$711117ad6ad27992 = 'persist:';
var $97a27fb4e1c739e5$export$2aaee4793dd13a52 = 'persist/FLUSH';
var $97a27fb4e1c739e5$export$1647ef958242c4e2 = 'persist/REHYDRATE';
var $97a27fb4e1c739e5$export$dd1033c27a16bbd3 = 'persist/PAUSE';
var $97a27fb4e1c739e5$export$913fe0e161ed92a2 = 'persist/PERSIST';
var $97a27fb4e1c739e5$export$5514fc3b4067675f = 'persist/PURGE';
var $97a27fb4e1c739e5$export$51e82cdd7353a0e1 = 'persist/REGISTER';
var $97a27fb4e1c739e5$export$363ebe89e6e7aeef = -1;


function $229789acf707b92b$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $229789acf707b92b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $229789acf707b92b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $229789acf707b92b$var$_typeof(obj);
}
function $229789acf707b92b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $229789acf707b92b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $229789acf707b92b$var$ownKeys(source, true).forEach(function(key) {
            $229789acf707b92b$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $229789acf707b92b$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $229789acf707b92b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $229789acf707b92b$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $229789acf707b92b$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $229789acf707b92b$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
         // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
}



function $595ff8351db385ce$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $97a27fb4e1c739e5$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === 'function') serialize = config.serialize;
    else serialize = $595ff8351db385ce$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error('redux-persist/createPersistoid: error serializing state', err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
    }
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $595ff8351db385ce$var$defaultSerialize(data) {
    return JSON.stringify(data);
}



function $215d99a2b1b9cac4$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $97a27fb4e1c739e5$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === 'function') deserialize = config.deserialize;
    else deserialize = $215d99a2b1b9cac4$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $215d99a2b1b9cac4$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}



function $57eb589fb69ddf2c$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $97a27fb4e1c739e5$export$711117ad6ad27992)).concat(config.key);
    return storage.removeItem(storageKey, $57eb589fb69ddf2c$var$warnIfRemoveError);
}
function $57eb589fb69ddf2c$var$warnIfRemoveError(err) {}


function $d57599ddbbf3a34e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d57599ddbbf3a34e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d57599ddbbf3a34e$var$ownKeys(source, true).forEach(function(key) {
            $d57599ddbbf3a34e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d57599ddbbf3a34e$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d57599ddbbf3a34e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d57599ddbbf3a34e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d57599ddbbf3a34e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d57599ddbbf3a34e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d57599ddbbf3a34e$var$DEFAULT_TIMEOUT = 5000;
function $d57599ddbbf3a34e$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $97a27fb4e1c739e5$export$363ebe89e6e7aeef);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $229789acf707b92b$export$2e2bcd8739ae039) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $215d99a2b1b9cac4$export$2e2bcd8739ae039);
    var timeout = config.timeout !== undefined ? config.timeout : $d57599ddbbf3a34e$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $d57599ddbbf3a34e$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $97a27fb4e1c739e5$export$913fe0e161ed92a2)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error("redux-persist: persist timed out for persist key \"".concat(config.key, "\"")));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $595ff8351db385ce$export$2e2bcd8739ae039)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $d57599ddbbf3a34e$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $d57599ddbbf3a34e$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $97a27fb4e1c739e5$export$5514fc3b4067675f)) {
            _purge = true;
            action.result((0, $57eb589fb69ddf2c$export$2e2bcd8739ae039)(config));
            return $d57599ddbbf3a34e$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $97a27fb4e1c739e5$export$2aaee4793dd13a52)) {
            action.result(_persistoid && _persistoid.flush());
            return $d57599ddbbf3a34e$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $97a27fb4e1c739e5$export$dd1033c27a16bbd3)) _paused = true;
        else if (action.type === (0, $97a27fb4e1c739e5$export$1647ef958242c4e2)) {
            // noop on restState if purging
            if (_purge) return $d57599ddbbf3a34e$var$_objectSpread({}, restState, {
                _persist: $d57599ddbbf3a34e$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $d57599ddbbf3a34e$var$_objectSpread({}, reconciledRest, {
                    _persist: $d57599ddbbf3a34e$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($d57599ddbbf3a34e$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}



var $5fApW = parcelRequire("5fApW");
function $cdb445c333a43100$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cdb445c333a43100$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cdb445c333a43100$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5fApW.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cdb445c333a43100$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $e0db014f981f40cf$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $e0db014f981f40cf$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $e0db014f981f40cf$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $e0db014f981f40cf$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $e0db014f981f40cf$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $e0db014f981f40cf$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $e0db014f981f40cf$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $e0db014f981f40cf$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $e0db014f981f40cf$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($e0db014f981f40cf$var$isDate(val)) return 'date';
    if ($e0db014f981f40cf$var$isError(val)) return 'error';
    var constructorName = $e0db014f981f40cf$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $e0db014f981f40cf$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $e0db014f981f40cf$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $e0db014f981f40cf$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $e0db014f981f40cf$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $e0db014f981f40cf$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(1));
        return enhancer($e0db014f981f40cf$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$e0db014f981f40cf$var$isPlainObject(action)) throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $e0db014f981f40cf$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$e0db014f981f40cf$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $e0db014f981f40cf$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$e0db014f981f40cf$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $e0db014f981f40cf$export$8928921ea2d3b126 = $e0db014f981f40cf$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $e0db014f981f40cf$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $e0db014f981f40cf$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $e0db014f981f40cf$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$e0db014f981f40cf$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $e0db014f981f40cf$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $e0db014f981f40cf$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $e0db014f981f40cf$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $e0db014f981f40cf$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $e0db014f981f40cf$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $e0db014f981f40cf$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $e0db014f981f40cf$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $e0db014f981f40cf$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $e0db014f981f40cf$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $e0db014f981f40cf$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $e0db014f981f40cf$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $e0db014f981f40cf$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $e0db014f981f40cf$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($e0db014f981f40cf$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $e0db014f981f40cf$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $cdb445c333a43100$export$2e2bcd8739ae039)((0, $cdb445c333a43100$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}



function $9ee58ef1a8aa8dcc$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9ee58ef1a8aa8dcc$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9ee58ef1a8aa8dcc$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9ee58ef1a8aa8dcc$var$_typeof(obj);
}
function $9ee58ef1a8aa8dcc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9ee58ef1a8aa8dcc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $9ee58ef1a8aa8dcc$var$ownKeys(source, true).forEach(function(key) {
            $9ee58ef1a8aa8dcc$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $9ee58ef1a8aa8dcc$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9ee58ef1a8aa8dcc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9ee58ef1a8aa8dcc$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $9ee58ef1a8aa8dcc$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $9ee58ef1a8aa8dcc$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($9ee58ef1a8aa8dcc$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $9ee58ef1a8aa8dcc$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
function $9ee58ef1a8aa8dcc$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $9ee58ef1a8aa8dcc$var$_typeof(o) === 'object';
}


function $f11259ec7aa2c5e9$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $9ee58ef1a8aa8dcc$export$2e2bcd8739ae039) : config.stateReconciler;
    return (0, $d57599ddbbf3a34e$export$2e2bcd8739ae039)(config, (0, $e0db014f981f40cf$export$66e4520cdb265d18)(reducers));
}




function $64c53298d3249927$var$_toConsumableArray(arr) {
    return $64c53298d3249927$var$_arrayWithoutHoles(arr) || $64c53298d3249927$var$_iterableToArray(arr) || $64c53298d3249927$var$_nonIterableSpread();
}
function $64c53298d3249927$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $64c53298d3249927$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $64c53298d3249927$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $64c53298d3249927$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $64c53298d3249927$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $64c53298d3249927$var$ownKeys(source, true).forEach(function(key) {
            $64c53298d3249927$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $64c53298d3249927$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $64c53298d3249927$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $64c53298d3249927$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $64c53298d3249927$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $64c53298d3249927$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $97a27fb4e1c739e5$export$51e82cdd7353a0e1:
            return $64c53298d3249927$var$_objectSpread({}, state, {
                registry: [].concat($64c53298d3249927$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $97a27fb4e1c739e5$export$1647ef958242c4e2:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $64c53298d3249927$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $64c53298d3249927$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $64c53298d3249927$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $e0db014f981f40cf$export$f51a9068ac82ea43)($64c53298d3249927$var$persistorReducer, $64c53298d3249927$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $97a27fb4e1c739e5$export$51e82cdd7353a0e1),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $97a27fb4e1c739e5$export$1647ef958242c4e2),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $64c53298d3249927$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $97a27fb4e1c739e5$export$5514fc3b4067675f),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $97a27fb4e1c739e5$export$2aaee4793dd13a52),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $97a27fb4e1c739e5$export$dd1033c27a16bbd3)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $97a27fb4e1c739e5$export$913fe0e161ed92a2),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}



function $121a6b905378fc6f$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $97a27fb4e1c739e5$export$363ebe89e6e7aeef);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}


function $52e8b16f3d39611a$export$2e2bcd8739ae039(inbound, outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}









var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");
var $72c4a7bbec456ff1$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createContext(null);
var $72c4a7bbec456ff1$export$2e2bcd8739ae039 = $72c4a7bbec456ff1$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $7315136231e1f8a1$var$defaultNoopBatch(callback) {
    callback();
}
var $7315136231e1f8a1$var$batch = $7315136231e1f8a1$var$defaultNoopBatch; // Allow injecting another batching function later
var $7315136231e1f8a1$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $7315136231e1f8a1$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $7315136231e1f8a1$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $7315136231e1f8a1$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $7aeaa274b9afc14d$var$createListenerCollection() {
    var batch = (0, $7315136231e1f8a1$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $7aeaa274b9afc14d$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $7aeaa274b9afc14d$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $7aeaa274b9afc14d$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $7aeaa274b9afc14d$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $7aeaa274b9afc14d$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $6fFrj = parcelRequire("6fFrj");
var $e158bcf3c188d0fe$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $6fFrj.useLayoutEffect) : (0, $6fFrj.useEffect);


function $211270d3ecf64ed8$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $6fFrj.useMemo)(function() {
        var subscription = (0, $7aeaa274b9afc14d$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $6fFrj.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $e158bcf3c188d0fe$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $72c4a7bbec456ff1$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $211270d3ecf64ed8$export$2e2bcd8739ae039 = $211270d3ecf64ed8$var$Provider;


function $876165ca1d22d290$export$2e2bcd8739ae039() {
    $876165ca1d22d290$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $876165ca1d22d290$export$2e2bcd8739ae039.apply(this, arguments);
}


function $368fc019dd8ff8b8$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $7nfXW = parcelRequire("7nfXW");

var $6fFrj = parcelRequire("6fFrj");
var $69d47a19e71da8c7$exports = {};
'use strict';

$69d47a19e71da8c7$exports = (parcelRequire("icW8m"));





var $31a477b53989c0c7$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $31a477b53989c0c7$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $31a477b53989c0c7$var$EMPTY_ARRAY = [];
var $31a477b53989c0c7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $31a477b53989c0c7$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $31a477b53989c0c7$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $31a477b53989c0c7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $e158bcf3c188d0fe$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $31a477b53989c0c7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $31a477b53989c0c7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $31a477b53989c0c7$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $31a477b53989c0c7$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $72c4a7bbec456ff1$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $368fc019dd8ff8b8$export$2e2bcd8739ae039)(_ref2, $31a477b53989c0c7$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $6fFrj.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $6fFrj.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $368fc019dd8ff8b8$export$2e2bcd8739ae039)(props, $31a477b53989c0c7$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $6fFrj.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $69d47a19e71da8c7$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $6fFrj.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $6fFrj.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $6fFrj.useMemo)(function() {
                if (!shouldHandleStateChanges) return $31a477b53989c0c7$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $7aeaa274b9afc14d$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $6fFrj.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $6fFrj.useReducer)($31a477b53989c0c7$var$storeStateUpdatesReducer, $31a477b53989c0c7$var$EMPTY_ARRAY, $31a477b53989c0c7$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $6fFrj.useRef)();
            var lastWrapperProps = (0, $6fFrj.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $6fFrj.useRef)();
            var renderIsScheduled = (0, $6fFrj.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $31a477b53989c0c7$var$useIsomorphicLayoutEffectWithArgs($31a477b53989c0c7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $31a477b53989c0c7$var$useIsomorphicLayoutEffectWithArgs($31a477b53989c0c7$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $6fFrj.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(WrappedComponent, (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $6fFrj.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Connect, (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7nfXW)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7nfXW)))(Connect, WrappedComponent);
    };
}






function $4615049bdd0da708$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $4615049bdd0da708$export$2e2bcd8739ae039(objA, objB) {
    if ($4615049bdd0da708$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$4615049bdd0da708$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $9be653d5e66fe650$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $edd1ea5c676844bd$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $6168268b83593d3c$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $e2b0303b9cca890a$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $edd1ea5c676844bd$export$2e2bcd8739ae039)(value)) (0, $6168268b83593d3c$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $f72dbc27e45bf9a9$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $f72dbc27e45bf9a9$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $f72dbc27e45bf9a9$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $f72dbc27e45bf9a9$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $f72dbc27e45bf9a9$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $a630c4a02d0115d1$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $f72dbc27e45bf9a9$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $a630c4a02d0115d1$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $f72dbc27e45bf9a9$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $a630c4a02d0115d1$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $f72dbc27e45bf9a9$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $9be653d5e66fe650$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $a630c4a02d0115d1$export$2e2bcd8739ae039 = [
    $a630c4a02d0115d1$export$a9f27b4b187c1166,
    $a630c4a02d0115d1$export$ba20d1a7aa0c4a90,
    $a630c4a02d0115d1$export$94a6e55709d4d961
];



function $664edc20fe04c84a$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $f72dbc27e45bf9a9$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $664edc20fe04c84a$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $f72dbc27e45bf9a9$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $664edc20fe04c84a$export$2e2bcd8739ae039 = [
    $664edc20fe04c84a$export$23fc470827b14aa,
    $664edc20fe04c84a$export$514bc8c1a53c1d66
];




function $d357773e653472b3$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $d357773e653472b3$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $d357773e653472b3$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $d357773e653472b3$export$5b105939c84b5234(mergeProps) : undefined;
}
function $d357773e653472b3$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $d357773e653472b3$export$691c327fc30bc857;
    } : undefined;
}
var $d357773e653472b3$export$2e2bcd8739ae039 = [
    $d357773e653472b3$export$d61b680184bc3f00,
    $d357773e653472b3$export$a13ba70ef50dda6d
];




function $5165492f8eefd2b3$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $6168268b83593d3c$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $5165492f8eefd2b3$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $5165492f8eefd2b3$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $5165492f8eefd2b3$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $5165492f8eefd2b3$var$verify(mergeProps, 'mergeProps', displayName);
}


var $c3bba500e209e060$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $c3bba500e209e060$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $c3bba500e209e060$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $c3bba500e209e060$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $368fc019dd8ff8b8$export$2e2bcd8739ae039)(_ref2, $c3bba500e209e060$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $c3bba500e209e060$export$d20c0c2ca6eb2b6f : $c3bba500e209e060$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $ecf532c7b88e8e09$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $ecf532c7b88e8e09$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $ecf532c7b88e8e09$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $ecf532c7b88e8e09$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $31a477b53989c0c7$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $664edc20fe04c84a$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $a630c4a02d0115d1$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $d357773e653472b3$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $c3bba500e209e060$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $ecf532c7b88e8e09$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $4615049bdd0da708$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $4615049bdd0da708$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $4615049bdd0da708$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $368fc019dd8ff8b8$export$2e2bcd8739ae039)(_ref3, $ecf532c7b88e8e09$var$_excluded);
        var initMapStateToProps = $ecf532c7b88e8e09$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $ecf532c7b88e8e09$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $ecf532c7b88e8e09$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $876165ca1d22d290$export$2e2bcd8739ae039)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $ecf532c7b88e8e09$export$2e2bcd8739ae039 = /*#__PURE__*/ $ecf532c7b88e8e09$export$9f9feb656dec1fc4();




var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");

function $e3a1290732694c0d$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $6fFrj.useContext)((0, $72c4a7bbec456ff1$export$cc80c08dc91f1c00));
    return contextValue;
}


function $6ce5a3efd45591b6$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $72c4a7bbec456ff1$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $72c4a7bbec456ff1$export$cc80c08dc91f1c00) ? (0, $e3a1290732694c0d$export$c1275ca9a6fd3ec5) : function() {
        return (0, $6fFrj.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $6ce5a3efd45591b6$export$6ccbb43953eebf8 = /*#__PURE__*/ $6ce5a3efd45591b6$export$671dba69185d0304();


function $1a030f7d00178424$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $72c4a7bbec456ff1$export$cc80c08dc91f1c00);
    var useStore = context === (0, $72c4a7bbec456ff1$export$cc80c08dc91f1c00) ? (0, $6ce5a3efd45591b6$export$6ccbb43953eebf8) : (0, $6ce5a3efd45591b6$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $1a030f7d00178424$export$8ad76b76a4c905f8 = /*#__PURE__*/ $1a030f7d00178424$export$bc9b55530897c558();



var $6fFrj = parcelRequire("6fFrj");




var $f9ccae383da3d032$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $f9ccae383da3d032$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $6fFrj.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $6fFrj.useMemo)(function() {
        return (0, $7aeaa274b9afc14d$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $6fFrj.useRef)();
    var latestSelector = (0, $6fFrj.useRef)();
    var latestStoreState = (0, $6fFrj.useRef)();
    var latestSelectedState = (0, $6fFrj.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $e158bcf3c188d0fe$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $e158bcf3c188d0fe$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $f9ccae383da3d032$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $72c4a7bbec456ff1$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $72c4a7bbec456ff1$export$cc80c08dc91f1c00) ? (0, $e3a1290732694c0d$export$c1275ca9a6fd3ec5) : function() {
        return (0, $6fFrj.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $f9ccae383da3d032$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $f9ccae383da3d032$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $6fFrj.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $f9ccae383da3d032$export$2105062e25df4afe = /*#__PURE__*/ $f9ccae383da3d032$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ 
var $8CZEB = parcelRequire("8CZEB");


var $8CZEB = parcelRequire("8CZEB");

// with standard React renderers (ReactDOM, React Native)
(0, $7315136231e1f8a1$export$4b9874722d0da7bc)((0, $8CZEB.unstable_batchedUpdates));


// eslint-disable-next-line @typescript-eslint/unbound-method
const $4fda53d1ed38be80$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4fda53d1ed38be80$export$e6127cc7fe7395c3(wat) {
    switch($4fda53d1ed38be80$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $4fda53d1ed38be80$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $4fda53d1ed38be80$var$isBuiltin(wat, className) {
    return $4fda53d1ed38be80$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4fda53d1ed38be80$export$9f9636d330b71954(wat) {
    return $4fda53d1ed38be80$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4fda53d1ed38be80$export$ef9e2056653f0c8e(wat) {
    return $4fda53d1ed38be80$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4fda53d1ed38be80$export$12e869b2a583f783(wat) {
    return $4fda53d1ed38be80$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4fda53d1ed38be80$export$844ec244b1367d54(wat) {
    return $4fda53d1ed38be80$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4fda53d1ed38be80$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4fda53d1ed38be80$export$53b83ca8eaab0383(wat) {
    return $4fda53d1ed38be80$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4fda53d1ed38be80$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $4fda53d1ed38be80$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4fda53d1ed38be80$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $4fda53d1ed38be80$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4fda53d1ed38be80$export$49841c62b9eff15(wat) {
    return $4fda53d1ed38be80$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $4fda53d1ed38be80$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4fda53d1ed38be80$export$bc2894c7158efbac(wat) {
    return $4fda53d1ed38be80$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4fda53d1ed38be80$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $4fda53d1ed38be80$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}


var $9avcL = parcelRequire("9avcL");
/** Prefix for logging strings */ const $1eb1a39bb029f9a9$var$PREFIX = 'Sentry Logger ';
const $1eb1a39bb029f9a9$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $1eb1a39bb029f9a9$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $9avcL.GLOBAL_OBJ))) return callback();
    const originalConsole = (0, $9avcL.GLOBAL_OBJ).console;
    const wrappedLevels = {};
    // Restore all wrapped console methods
    $1eb1a39bb029f9a9$export$2a2b1d2252a69ecb.forEach((level)=>{
        // TODO(v7): Remove this check as it's only needed for Node 6
        const originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in originalConsole && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach((level)=>{
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $1eb1a39bb029f9a9$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        }
    };
    if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) $1eb1a39bb029f9a9$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $1eb1a39bb029f9a9$export$cda52e2a8927a2ca(()=>{
                (0, $9avcL.GLOBAL_OBJ).console[name](`${$1eb1a39bb029f9a9$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $1eb1a39bb029f9a9$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let $1eb1a39bb029f9a9$export$af88d00dbe7f521;
if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) $1eb1a39bb029f9a9$export$af88d00dbe7f521 = (0, $9avcL.getGlobalSingleton)('logger', $1eb1a39bb029f9a9$var$makeLogger);
else $1eb1a39bb029f9a9$export$af88d00dbe7f521 = $1eb1a39bb029f9a9$var$makeLogger();



var $6CbLG = parcelRequire("6CbLG");
var $9avcL = parcelRequire("9avcL");

var $9avcL = parcelRequire("9avcL");
// eslint-disable-next-line deprecation/deprecation
const $0897e54e36555b02$var$WINDOW = (0, $9avcL.getGlobalObject)();
const $0897e54e36555b02$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $0897e54e36555b02$export$5647df6b7814ac86(elem, options = {}) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $0897e54e36555b02$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $0897e54e36555b02$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $0897e54e36555b02$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $4fda53d1ed38be80$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $0897e54e36555b02$export$1cfafeee2987818b() {
    try {
        return $0897e54e36555b02$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0897e54e36555b02$export$c660c1f3ab49225c(selector) {
    if ($0897e54e36555b02$var$WINDOW.document && $0897e54e36555b02$var$WINDOW.document.querySelector) return $0897e54e36555b02$var$WINDOW.document.querySelector(selector);
    return null;
}




/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $b6e2a386a4033810$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $b6e2a386a4033810$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b6e2a386a4033810$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $b6e2a386a4033810$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $4fda53d1ed38be80$export$844ec244b1367d54)(value)) return false;
    if ((0, $4fda53d1ed38be80$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $4fda53d1ed38be80$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $b6e2a386a4033810$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$b6e2a386a4033810$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $c7598308515e5ce6$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $c7598308515e5ce6$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $c7598308515e5ce6$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $c7598308515e5ce6$export$5c1499e2e5d010ae(wrapped, original) {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $c7598308515e5ce6$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $c7598308515e5ce6$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $c7598308515e5ce6$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $c7598308515e5ce6$export$62ff257738bf57f5(value) {
    if ((0, $4fda53d1ed38be80$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$c7598308515e5ce6$var$getOwnProperties(value)
    };
    else if ((0, $4fda53d1ed38be80$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $c7598308515e5ce6$var$serializeEventTarget(value.target),
            currentTarget: $c7598308515e5ce6$var$serializeEventTarget(value.currentTarget),
            ...$c7598308515e5ce6$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $4fda53d1ed38be80$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $c7598308515e5ce6$var$serializeEventTarget(target) {
    try {
        return (0, $4fda53d1ed38be80$export$45a5e7f76e0caa8d)(target) ? (0, $0897e54e36555b02$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $c7598308515e5ce6$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $c7598308515e5ce6$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($c7598308515e5ce6$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $b6e2a386a4033810$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $b6e2a386a4033810$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $c7598308515e5ce6$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $c7598308515e5ce6$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $c7598308515e5ce6$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ((0, $4fda53d1ed38be80$export$53b83ca8eaab0383)(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $c7598308515e5ce6$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($c7598308515e5ce6$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $c7598308515e5ce6$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $4fda53d1ed38be80$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




var $9avcL = parcelRequire("9avcL");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $65d42e3833054e5c$export$19f53698e68b2496() {
    const gbl = (0, $9avcL.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
    const getRandomByte = crypto && crypto.getRandomValues ? ()=>crypto.getRandomValues(new Uint8Array(1))[0] : ()=>Math.random() * 16;
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $65d42e3833054e5c$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $65d42e3833054e5c$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $65d42e3833054e5c$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $65d42e3833054e5c$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $65d42e3833054e5c$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $65d42e3833054e5c$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $65d42e3833054e5c$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $65d42e3833054e5c$export$d364f2020ab30578(input) {
    const match = input.match($65d42e3833054e5c$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $65d42e3833054e5c$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $b6e2a386a4033810$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $b6e2a386a4033810$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $b6e2a386a4033810$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $65d42e3833054e5c$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $c7598308515e5ce6$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $65d42e3833054e5c$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $1914256e120b4d38$export$849dbeeeda01ae98 = 'production';



var $6CbLG = parcelRequire("6CbLG");
var $9avcL = parcelRequire("9avcL");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $73f700349fff73af$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($73f700349fff73af$var$States || ($73f700349fff73af$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $73f700349fff73af$export$1fda8aa4d135f8aa(value) {
    return new $73f700349fff73af$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $73f700349fff73af$export$78e43115b553f358(reason) {
    return new $73f700349fff73af$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $73f700349fff73af$export$6f292d4960313241 {
    __init() {
        this._state = $73f700349fff73af$var$States.PENDING;
    }
    __init2() {
        this._handlers = [];
    }
    constructor(executor){
        $73f700349fff73af$export$6f292d4960313241.prototype.__init.call(this);
        $73f700349fff73af$export$6f292d4960313241.prototype.__init2.call(this);
        $73f700349fff73af$export$6f292d4960313241.prototype.__init3.call(this);
        $73f700349fff73af$export$6f292d4960313241.prototype.__init4.call(this);
        $73f700349fff73af$export$6f292d4960313241.prototype.__init5.call(this);
        $73f700349fff73af$export$6f292d4960313241.prototype.__init6.call(this);
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $73f700349fff73af$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $73f700349fff73af$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init3() {
        this._resolve = (value)=>{
            this._setResult($73f700349fff73af$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init4() {
        this._reject = (reason)=>{
            this._setResult($73f700349fff73af$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init5() {
        this._setResult = (state, value)=>{
            if (this._state !== $73f700349fff73af$var$States.PENDING) return;
            if ((0, $4fda53d1ed38be80$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init6() {
        this._executeHandlers = ()=>{
            if (this._state === $73f700349fff73af$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $73f700349fff73af$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $73f700349fff73af$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



var $6CbLG = parcelRequire("6CbLG");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $c32ce746d875b706$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $6CbLG.timestampInSeconds)();
    const session = {
        sid: (0, $65d42e3833054e5c$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$c32ce746d875b706$var$sessionToJSON(session)
    };
    if (context) $c32ce746d875b706$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $c32ce746d875b706$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $6CbLG.timestampInSeconds)();
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $65d42e3833054e5c$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $c32ce746d875b706$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $c32ce746d875b706$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $c32ce746d875b706$var$sessionToJSON(session) {
    return (0, $c7598308515e5ce6$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $287ad5dd047650ab$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $287ad5dd047650ab$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /** Transaction Name */ /** Span */ /** Session */ /** Request Mode Session Status */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
    }
    /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */ static clone(scope) {
        const newScope = new $287ad5dd047650ab$export$775b6bb06e53a214();
        if (scope) {
            newScope._breadcrumbs = [
                ...scope._breadcrumbs
            ];
            newScope._tags = {
                ...scope._tags
            };
            newScope._extra = {
                ...scope._extra
            };
            newScope._contexts = {
                ...scope._contexts
            };
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = [
                ...scope._eventProcessors
            ];
            newScope._requestSession = scope._requestSession;
            newScope._attachments = [
                ...scope._attachments
            ];
            newScope._sdkProcessingMetadata = {
                ...scope._sdkProcessingMetadata
            };
        }
        return newScope;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this._user = user || {};
        if (this._session) (0, $c32ce746d875b706$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSpan() {
        return this._span;
    }
    /**
   * @inheritDoc
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this.getSpan();
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            const updatedScope = captureContext(this);
            return updatedScope instanceof $287ad5dd047650ab$export$775b6bb06e53a214 ? updatedScope : this;
        }
        if (captureContext instanceof $287ad5dd047650ab$export$775b6bb06e53a214) {
            this._tags = {
                ...this._tags,
                ...captureContext._tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext._extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext._contexts
            };
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $4fda53d1ed38be80$export$53b83ca8eaab0383)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = {
                ...this._tags,
                ...captureContext.tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext.contexts
            };
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $287ad5dd047650ab$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $6CbLG.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        this._breadcrumbs = [
            ...this._breadcrumbs,
            mergedBreadcrumb
        ].slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ getAttachments() {
        return this._attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */ applyToEvent(event, hint = {}) {
        if (this._extra && Object.keys(this._extra).length) event.extra = {
            ...this._extra,
            ...event.extra
        };
        if (this._tags && Object.keys(this._tags).length) event.tags = {
            ...this._tags,
            ...event.tags
        };
        if (this._user && Object.keys(this._user).length) event.user = {
            ...this._user,
            ...event.user
        };
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = {
            ...this._contexts,
            ...event.contexts
        };
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = {
                trace: this._span.getTraceContext(),
                ...event.contexts
            };
            const transaction = this._span.transaction;
            if (transaction) {
                event.sdkProcessingMetadata = {
                    dynamicSamplingContext: transaction.getDynamicSamplingContext(),
                    ...event.sdkProcessingMetadata
                };
                const transactionName = transaction.name;
                if (transactionName) event.tags = {
                    transaction: transactionName,
                    ...event.tags
                };
            }
        }
        this._applyFingerprint(event);
        event.breadcrumbs = [
            ...event.breadcrumbs || [],
            ...this._breadcrumbs
        ];
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = {
            ...event.sdkProcessingMetadata,
            ...this._sdkProcessingMetadata
        };
        return this._notifyEventProcessors([
            ...$287ad5dd047650ab$var$getGlobalEventProcessors(),
            ...this._eventProcessors
        ], event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * This will be called after {@link applyToEvent} is finished.
   */ _notifyEventProcessors(processors, event, hint, index = 0) {
        return new (0, $73f700349fff73af$export$6f292d4960313241)((resolve, reject)=>{
            const processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                const result = processor({
                    ...event
                }, hint);
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && processor.id && result === null && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
                if ((0, $4fda53d1ed38be80$export$f5b060c2914b97c8)(result)) result.then((final)=>this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve)).then(null, reject);
                else this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */ _applyFingerprint(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? (0, $65d42e3833054e5c$export$3131421a7d01b4fb)(event.fingerprint) : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    }
}
/**
 * Returns the global event processors.
 */ function $287ad5dd047650ab$var$getGlobalEventProcessors() {
    return (0, $9avcL.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */ function $287ad5dd047650ab$export$8e4e25f54d456511(callback) {
    $287ad5dd047650ab$var$getGlobalEventProcessors().push(callback);
}



/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $4e8ba91971b7f1f7$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4e8ba91971b7f1f7$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ class $4e8ba91971b7f1f7$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */ constructor(client, scope = new (0, $287ad5dd047650ab$export$775b6bb06e53a214)(), _version = $4e8ba91971b7f1f7$export$24a86ef7798177e4){
        this._version = _version;
        this._stack = [
            {
                scope: scope
            }
        ];
        if (client) this.bindClient(client);
    }
    /**
   * @inheritDoc
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * @inheritDoc
   */ bindClient(client) {
        const top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    }
    /**
   * @inheritDoc
   */ pushScope() {
        // We want to clone the content of prev scope
        const scope = (0, $287ad5dd047650ab$export$775b6bb06e53a214).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   */ popScope() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   */ withScope(callback) {
        const scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this.getStackTop().client;
    }
    /** Returns the scope of the top stack. */ getScope() {
        return this.getStackTop().scope;
    }
    /** Returns the scope stack for domains or the process. */ getStack() {
        return this._stack;
    }
    /** Returns the topmost scope layer in the order domain > local > process. */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $65d42e3833054e5c$export$19f53698e68b2496)();
        const syntheticException = new Error('Sentry syntheticException');
        this._withClient((client, scope)=>{
            client.captureException(exception, {
                originalException: exception,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $65d42e3833054e5c$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        this._withClient((client, scope)=>{
            client.captureMessage(message, level, {
                originalException: message,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $65d42e3833054e5c$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        this._withClient((client, scope)=>{
            client.captureEvent(event, {
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, hint) {
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4e8ba91971b7f1f7$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $6CbLG.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $1eb1a39bb029f9a9$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this.getScope().setUser(user);
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this.getScope().setTags(tags);
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this.getScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.getScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this.getScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        this.getScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   */ configureScope(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        const oldHub = $4e8ba91971b7f1f7$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $4e8ba91971b7f1f7$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        const client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && !result) // eslint-disable-next-line no-console
        console.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        return result;
    }
    /**
   * @inheritDoc
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   */ endSession() {
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $c32ce746d875b706$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   */ startSession(context) {
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $1914256e120b4d38$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $9avcL.GLOBAL_OBJ).navigator || {};
        const session = (0, $c32ce746d875b706$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $c32ce746d875b706$export$531818e825e774db)(currentSession, {
            status: 'exited'
        });
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */ shouldSendDefaultPii() {
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */ _withClient(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(client, scope);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $4e8ba91971b7f1f7$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $4e8ba91971b7f1f7$export$19eade501500c6c1() {
    (0, $9avcL.GLOBAL_OBJ).__SENTRY__ = (0, $9avcL.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $9avcL.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */ function $4e8ba91971b7f1f7$export$4188a14ad302d1bc(hub) {
    const registry = $4e8ba91971b7f1f7$export$19eade501500c6c1();
    const oldHub = $4e8ba91971b7f1f7$export$bfa8a924a84a76b7(registry);
    $4e8ba91971b7f1f7$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */ function $4e8ba91971b7f1f7$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $4e8ba91971b7f1f7$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $4e8ba91971b7f1f7$var$getGlobalHub(registry);
}
function $4e8ba91971b7f1f7$var$getGlobalHub(registry = $4e8ba91971b7f1f7$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$4e8ba91971b7f1f7$var$hasHubOnCarrier(registry) || $4e8ba91971b7f1f7$export$bfa8a924a84a76b7(registry).isOlderThan($4e8ba91971b7f1f7$export$24a86ef7798177e4)) $4e8ba91971b7f1f7$export$849f05434e95d2f2(registry, new $4e8ba91971b7f1f7$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $4e8ba91971b7f1f7$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ function $4e8ba91971b7f1f7$export$236689a79f5aa020(carrier, parent = $4e8ba91971b7f1f7$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$4e8ba91971b7f1f7$var$hasHubOnCarrier(carrier) || $4e8ba91971b7f1f7$export$bfa8a924a84a76b7(carrier).isOlderThan($4e8ba91971b7f1f7$export$24a86ef7798177e4)) {
        const globalHubTopStack = parent.getStackTop();
        $4e8ba91971b7f1f7$export$849f05434e95d2f2(carrier, new $4e8ba91971b7f1f7$export$8c41bb232f1008b1(globalHubTopStack.client, (0, $287ad5dd047650ab$export$775b6bb06e53a214).clone(globalHubTopStack.scope)));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $4e8ba91971b7f1f7$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $4e8ba91971b7f1f7$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $4e8ba91971b7f1f7$export$70d775fb1f267027(callback, options = {}) {
    const registry = $4e8ba91971b7f1f7$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $4e8ba91971b7f1f7$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $4e8ba91971b7f1f7$export$bfa8a924a84a76b7(carrier) {
    return (0, $9avcL.getGlobalSingleton)('hub', ()=>new $4e8ba91971b7f1f7$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $4e8ba91971b7f1f7$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $9234c712ceb99fb8$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getClient();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}





/** Node Stack line parser */ // eslint-disable-next-line complexity
function $0bfe564ef069c5c6$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
            !filename.startsWith('/') && // It's not internal if it's an absolute windows path
            !filename.includes(':\\') && // It's not internal if the path is starting with a dot
            !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
            !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
            // in_app is all that's not an internal Node function or a module within node_modules
            // note that isNative appears to return true even for node core libraries
            // see https://github.com/getsentry/raven-node/issues/176
            const in_app = !isInternal && filename !== undefined && !filename.includes('node_modules/');
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: in_app
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $469cba5b454ec853$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $469cba5b454ec853$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $469cba5b454ec853$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $469cba5b454ec853$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($469cba5b454ec853$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $469cba5b454ec853$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $469cba5b454ec853$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $469cba5b454ec853$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $469cba5b454ec853$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $469cba5b454ec853$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = stack.slice(0, $469cba5b454ec853$var$STACKTRACE_FRAME_LIMIT);
    const lastFrameFunction = localStack[localStack.length - 1].function;
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (lastFrameFunction && /sentryWrapped/.test(lastFrameFunction)) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    const firstFrameFunction = localStack[localStack.length - 1].function;
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (firstFrameFunction && /captureMessage|captureException/.test(firstFrameFunction)) localStack.pop();
    return localStack.map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $469cba5b454ec853$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $469cba5b454ec853$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $469cba5b454ec853$var$defaultFunctionName;
        return fn.name || $469cba5b454ec853$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $469cba5b454ec853$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $469cba5b454ec853$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $0bfe564ef069c5c6$export$35059013cd4a06db)(getModule)
    ];
}




var $9avcL = parcelRequire("9avcL");
// eslint-disable-next-line deprecation/deprecation
const $1ce49bc5e7b0f93c$var$WINDOW = (0, $9avcL.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $1ce49bc5e7b0f93c$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $1ce49bc5e7b0f93c$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $1ce49bc5e7b0f93c$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $1ce49bc5e7b0f93c$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $1ce49bc5e7b0f93c$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $1ce49bc5e7b0f93c$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $1ce49bc5e7b0f93c$export$c82d238e23c40b21() {
    if (!$1ce49bc5e7b0f93c$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($1ce49bc5e7b0f93c$export$18cf36ed71d733e7($1ce49bc5e7b0f93c$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $1ce49bc5e7b0f93c$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $1ce49bc5e7b0f93c$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $1ce49bc5e7b0f93c$export$531055a6c684a70a() {
    return 'ReportingObserver' in $1ce49bc5e7b0f93c$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $1ce49bc5e7b0f93c$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$1ce49bc5e7b0f93c$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}



var $9avcL = parcelRequire("9avcL");

var $9avcL = parcelRequire("9avcL");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $031a7f4760c825e1$var$WINDOW = (0, $9avcL.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $031a7f4760c825e1$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chrome = $031a7f4760c825e1$var$WINDOW.chrome;
    const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $031a7f4760c825e1$var$WINDOW && !!$031a7f4760c825e1$var$WINDOW.history.pushState && !!$031a7f4760c825e1$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}


// eslint-disable-next-line deprecation/deprecation
const $d43610efe653d8f1$var$WINDOW = (0, $9avcL.getGlobalObject)();
const $d43610efe653d8f1$export$55b6bb1e45c6cf59 = '__sentry_xhr_v2__';
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ const $d43610efe653d8f1$var$handlers = {};
const $d43610efe653d8f1$var$instrumented = {};
/** Instruments given API */ function $d43610efe653d8f1$var$instrument(type) {
    if ($d43610efe653d8f1$var$instrumented[type]) return;
    $d43610efe653d8f1$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $d43610efe653d8f1$var$instrumentConsole();
            break;
        case 'dom':
            $d43610efe653d8f1$var$instrumentDOM();
            break;
        case 'xhr':
            $d43610efe653d8f1$var$instrumentXHR();
            break;
        case 'fetch':
            $d43610efe653d8f1$var$instrumentFetch();
            break;
        case 'history':
            $d43610efe653d8f1$var$instrumentHistory();
            break;
        case 'error':
            $d43610efe653d8f1$var$instrumentError();
            break;
        case 'unhandledrejection':
            $d43610efe653d8f1$var$instrumentUnhandledRejection();
            break;
        default:
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('unknown instrumentation type:', type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d43610efe653d8f1$export$285b9172a3741fb7(type, callback) {
    $d43610efe653d8f1$var$handlers[type] = $d43610efe653d8f1$var$handlers[type] || [];
    $d43610efe653d8f1$var$handlers[type].push(callback);
    $d43610efe653d8f1$var$instrument(type);
}
/** JSDoc */ function $d43610efe653d8f1$var$triggerHandlers(type, data) {
    if (!type || !$d43610efe653d8f1$var$handlers[type]) return;
    for (const handler of $d43610efe653d8f1$var$handlers[type] || [])try {
        handler(data);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $469cba5b454ec853$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
/** JSDoc */ function $d43610efe653d8f1$var$instrumentConsole() {
    if (!('console' in $d43610efe653d8f1$var$WINDOW)) return;
    (0, $1eb1a39bb029f9a9$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in $d43610efe653d8f1$var$WINDOW.console)) return;
        (0, $c7598308515e5ce6$export$9563e054e6f787fb)($d43610efe653d8f1$var$WINDOW.console, level, function(originalConsoleMethod) {
            return function(...args) {
                $d43610efe653d8f1$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($d43610efe653d8f1$var$WINDOW.console, args);
            };
        });
    });
}
/** JSDoc */ function $d43610efe653d8f1$var$instrumentFetch() {
    if (!(0, $1ce49bc5e7b0f93c$export$c82d238e23c40b21)()) return;
    (0, $c7598308515e5ce6$export$9563e054e6f787fb)($d43610efe653d8f1$var$WINDOW, 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $d43610efe653d8f1$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            $d43610efe653d8f1$var$triggerHandlers('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($d43610efe653d8f1$var$WINDOW, args).then((response)=>{
                $d43610efe653d8f1$var$triggerHandlers('fetch', {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                });
                return response;
            }, (error)=>{
                $d43610efe653d8f1$var$triggerHandlers('fetch', {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                });
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $d43610efe653d8f1$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $d43610efe653d8f1$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($d43610efe653d8f1$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request
 */ function $d43610efe653d8f1$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $d43610efe653d8f1$var$getUrlFromResource(url),
            method: $d43610efe653d8f1$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $d43610efe653d8f1$var$getUrlFromResource(arg),
        method: $d43610efe653d8f1$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
/** JSDoc */ function $d43610efe653d8f1$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $d43610efe653d8f1$var$WINDOW)) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $c7598308515e5ce6$export$9563e054e6f787fb)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const url = args[1];
            const xhrInfo = this[$d43610efe653d8f1$export$55b6bb1e45c6cf59] = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $4fda53d1ed38be80$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $4fda53d1ed38be80$export$844ec244b1367d54)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$d43610efe653d8f1$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    $d43610efe653d8f1$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: this
                    });
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $c7598308515e5ce6$export$9563e054e6f787fb)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $c7598308515e5ce6$export$9563e054e6f787fb)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$d43610efe653d8f1$export$55b6bb1e45c6cf59];
                    if (xhrInfo) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $c7598308515e5ce6$export$9563e054e6f787fb)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$d43610efe653d8f1$export$55b6bb1e45c6cf59];
            if (sentryXhrData && args[0] !== undefined) sentryXhrData.body = args[0];
            $d43610efe653d8f1$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
let $d43610efe653d8f1$var$lastHref;
/** JSDoc */ function $d43610efe653d8f1$var$instrumentHistory() {
    if (!(0, $031a7f4760c825e1$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $d43610efe653d8f1$var$WINDOW.onpopstate;
    $d43610efe653d8f1$var$WINDOW.onpopstate = function(...args) {
        const to = $d43610efe653d8f1$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $d43610efe653d8f1$var$lastHref;
        $d43610efe653d8f1$var$lastHref = to;
        $d43610efe653d8f1$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $d43610efe653d8f1$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $d43610efe653d8f1$var$lastHref = to;
                $d43610efe653d8f1$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $c7598308515e5ce6$export$9563e054e6f787fb)($d43610efe653d8f1$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $c7598308515e5ce6$export$9563e054e6f787fb)($d43610efe653d8f1$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}
const $d43610efe653d8f1$var$debounceDuration = 1000;
let $d43610efe653d8f1$var$debounceTimerID;
let $d43610efe653d8f1$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $d43610efe653d8f1$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $d43610efe653d8f1$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        const target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $d43610efe653d8f1$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $d43610efe653d8f1$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($d43610efe653d8f1$var$shouldSkipDOMEvent(event)) return;
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($d43610efe653d8f1$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $d43610efe653d8f1$var$lastCapturedEvent = event;
        } else if ($d43610efe653d8f1$var$shouldShortcircuitPreviousDebounce($d43610efe653d8f1$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $d43610efe653d8f1$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($d43610efe653d8f1$var$debounceTimerID);
        $d43610efe653d8f1$var$debounceTimerID = $d43610efe653d8f1$var$WINDOW.setTimeout(()=>{
            $d43610efe653d8f1$var$debounceTimerID = undefined;
        }, $d43610efe653d8f1$var$debounceDuration);
    };
}
/** JSDoc */ function $d43610efe653d8f1$var$instrumentDOM() {
    if (!('document' in $d43610efe653d8f1$var$WINDOW)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = $d43610efe653d8f1$var$triggerHandlers.bind(null, 'dom');
    const globalDOMEventHandler = $d43610efe653d8f1$var$makeDOMEventHandler(triggerDOMHandler, true);
    $d43610efe653d8f1$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $d43610efe653d8f1$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $d43610efe653d8f1$var$WINDOW[target] && $d43610efe653d8f1$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $c7598308515e5ce6$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $d43610efe653d8f1$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $c7598308515e5ce6$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
let $d43610efe653d8f1$var$_oldOnErrorHandler = null;
/** JSDoc */ function $d43610efe653d8f1$var$instrumentError() {
    $d43610efe653d8f1$var$_oldOnErrorHandler = $d43610efe653d8f1$var$WINDOW.onerror;
    $d43610efe653d8f1$var$WINDOW.onerror = function(msg, url, line, column, error) {
        $d43610efe653d8f1$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($d43610efe653d8f1$var$_oldOnErrorHandler && !$d43610efe653d8f1$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $d43610efe653d8f1$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $d43610efe653d8f1$var$WINDOW.onerror.__SENTRY_INSTRUMENTED__ = true;
}
let $d43610efe653d8f1$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $d43610efe653d8f1$var$instrumentUnhandledRejection() {
    $d43610efe653d8f1$var$_oldOnUnhandledRejectionHandler = $d43610efe653d8f1$var$WINDOW.onunhandledrejection;
    $d43610efe653d8f1$var$WINDOW.onunhandledrejection = function(e) {
        $d43610efe653d8f1$var$triggerHandlers('unhandledrejection', e);
        if ($d43610efe653d8f1$var$_oldOnUnhandledRejectionHandler && !$d43610efe653d8f1$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $d43610efe653d8f1$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $d43610efe653d8f1$var$WINDOW.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}




/** Grabs active transaction off scope, if any */ function $7a33888f93c04594$export$a7feb32fdd923295(maybeHub) {
    const hub = maybeHub || (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)();
    const scope = hub.getScope();
    return scope.getTransaction();
}


let $0665d99e1ffd7d8e$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $0665d99e1ffd7d8e$export$637857c1d87b640c() {
    if ($0665d99e1ffd7d8e$var$errorsInstrumented) return;
    $0665d99e1ffd7d8e$var$errorsInstrumented = true;
    (0, $d43610efe653d8f1$export$285b9172a3741fb7)('error', $0665d99e1ffd7d8e$var$errorCallback);
    (0, $d43610efe653d8f1$export$285b9172a3741fb7)('unhandledrejection', $0665d99e1ffd7d8e$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $0665d99e1ffd7d8e$var$errorCallback() {
    const activeTransaction = (0, $7a33888f93c04594$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = 'internal_error';
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$0665d99e1ffd7d8e$var$errorCallback.tag = 'sentry_tracingErrorCallback';



var $6CbLG = parcelRequire("6CbLG");

var $6CbLG = parcelRequire("6CbLG");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $1a8776f8808530e4$export$10c95c129cd0d4fe {
    __init() {
        this.spans = [];
    }
    constructor(maxlen = 1000){
        $1a8776f8808530e4$export$10c95c129cd0d4fe.prototype.__init.call(this);
        this._maxlen = maxlen;
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $1a8776f8808530e4$export$5f1714a13ed34c01 {
    /**
   * @inheritDoc
   */ __init2() {
        this.traceId = (0, $65d42e3833054e5c$export$19f53698e68b2496)();
    }
    /**
   * @inheritDoc
   */ __init3() {
        this.spanId = (0, $65d42e3833054e5c$export$19f53698e68b2496)().substring(16);
    }
    /**
   * @inheritDoc
   */ /**
   * Internal keeper of the status
   */ /**
   * @inheritDoc
   */ /**
   * Timestamp in seconds when the span was created.
   */ __init4() {
        this.startTimestamp = (0, $6CbLG.timestampInSeconds)();
    }
    /**
   * Timestamp in seconds when the span ended.
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ __init5() {
        this.tags = {};
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    __init6() {
        this.data = {};
    }
    /**
   * List of spans that were finalized
   */ /**
   * @inheritDoc
   */ /**
   * The instrumenter that created this span.
   */ __init7() {
        this.instrumenter = 'sentry';
    }
    /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext){
        $1a8776f8808530e4$export$5f1714a13ed34c01.prototype.__init2.call(this);
        $1a8776f8808530e4$export$5f1714a13ed34c01.prototype.__init3.call(this);
        $1a8776f8808530e4$export$5f1714a13ed34c01.prototype.__init4.call(this);
        $1a8776f8808530e4$export$5f1714a13ed34c01.prototype.__init5.call(this);
        $1a8776f8808530e4$export$5f1714a13ed34c01.prototype.__init6.call(this);
        $1a8776f8808530e4$export$5f1714a13ed34c01.prototype.__init7.call(this);
        if (!spanContext) return this;
        if (spanContext.traceId) this.traceId = spanContext.traceId;
        if (spanContext.spanId) this.spanId = spanContext.spanId;
        if (spanContext.parentSpanId) this.parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this.sampled = spanContext.sampled;
        if (spanContext.op) this.op = spanContext.op;
        if (spanContext.description) this.description = spanContext.description;
        if (spanContext.data) this.data = spanContext.data;
        if (spanContext.tags) this.tags = spanContext.tags;
        if (spanContext.status) this.status = spanContext.status;
        if (spanContext.startTimestamp) this.startTimestamp = spanContext.startTimestamp;
        if (spanContext.endTimestamp) this.endTimestamp = spanContext.endTimestamp;
        if (spanContext.instrumenter) this.instrumenter = spanContext.instrumenter;
    }
    /**
   * @inheritDoc
   */ startChild(spanContext) {
        const childSpan = new $1a8776f8808530e4$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this.spanId,
            sampled: this.sampled,
            traceId: this.traceId
        });
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) childSpan.spanRecorder.add(childSpan);
        childSpan.transaction = this.transaction;
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
            const opStr = spanContext && spanContext.op || '< unknown op >';
            const nameStr = childSpan.transaction.name || '< unknown name >';
            const idStr = childSpan.transaction.spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = {
                logMessage: logMessage
            };
            (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(logMessage);
        }
        return childSpan;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    setData(key, value) {
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this.status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ setHttpStatus(httpStatus) {
        this.setTag('http.status_code', String(httpStatus));
        const spanStatus = $1a8776f8808530e4$export$ac65c70d78fcdb55(httpStatus);
        if (spanStatus !== 'unknown_error') this.setStatus(spanStatus);
        return this;
    }
    /**
   * @inheritDoc
   */ isSuccess() {
        return this.status === 'ok';
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && // Don't call this for transactions
        this.transaction && this.transaction.spanId !== this.spanId) {
            const { logMessage: logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
            if (logMessage) (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(logMessage.replace('Starting', 'Finishing'));
        }
        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0, $6CbLG.timestampInSeconds)();
    }
    /**
   * @inheritDoc
   */ toTraceparent() {
        let sampledString = '';
        if (this.sampled !== undefined) sampledString = this.sampled ? '-1' : '-0';
        return `${this.traceId}-${this.spanId}${sampledString}`;
    }
    /**
   * @inheritDoc
   */ toContext() {
        return (0, $c7598308515e5ce6$export$d25f2688db1bb433)({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(spanContext) {
        this.data = spanContext.data || {};
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = spanContext.spanId || this.spanId;
        this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
        this.status = spanContext.status;
        this.tags = spanContext.tags || {};
        this.traceId = spanContext.traceId || this.traceId;
        return this;
    }
    /**
   * @inheritDoc
   */ getTraceContext() {
        return (0, $c7598308515e5ce6$export$d25f2688db1bb433)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ toJSON() {
        return (0, $c7598308515e5ce6$export$d25f2688db1bb433)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId
        });
    }
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $1a8776f8808530e4$export$ac65c70d78fcdb55(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}






/** JSDoc */ class $68cd3d992998e93b$export$febc5573c75cefb0 extends (0, $1a8776f8808530e4$export$5f1714a13ed34c01) {
    /**
   * The reference to the current hub.
   */ __init() {
        this._measurements = {};
    }
    __init2() {
        this._contexts = {};
    }
    __init3() {
        this._frozenDynamicSamplingContext = undefined;
    }
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(transactionContext, hub){
        super(transactionContext);
        $68cd3d992998e93b$export$febc5573c75cefb0.prototype.__init.call(this);
        $68cd3d992998e93b$export$febc5573c75cefb0.prototype.__init2.call(this);
        $68cd3d992998e93b$export$febc5573c75cefb0.prototype.__init3.call(this);
        this._hub = hub || (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)();
        this._name = transactionContext.name || '';
        this.metadata = {
            source: 'custom',
            ...transactionContext.metadata,
            spanMetadata: {}
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    /** Getter for `name` property */ get name() {
        return this._name;
    }
    /** Setter for `name` property, which also sets `source` as custom */ set name(newName) {
        this.setName(newName);
    }
    /**
   * JSDoc
   */ setName(name, source = 'custom') {
        this._name = name;
        this.metadata.source = source;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        if (!this.spanRecorder) this.spanRecorder = new (0, $1a8776f8808530e4$export$10c95c129cd0d4fe)(maxlen);
        this.spanRecorder.add(this);
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   */ setMeasurement(name, value, unit = '') {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * @inheritDoc
   */ setMetadata(newMetadata) {
        this.metadata = {
            ...this.metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) return undefined;
        if (!this.name) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this.name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        super.finish(endTimestamp);
        const client = this._hub.getClient();
        if (client && client.emit) client.emit('finishTransaction', this);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((s)=>s !== this && s.endTimestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) this.endTimestamp = finishedSpans.reduce((prev, current)=>{
            if (prev.endTimestamp && current.endTimestamp) return prev.endTimestamp > current.endTimestamp ? prev : current;
            return prev;
        }).endTimestamp;
        const metadata = this.metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: this.getTraceContext()
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: 'transaction',
            sdkProcessingMetadata: {
                ...metadata,
                dynamicSamplingContext: this.getDynamicSamplingContext()
            },
            ...metadata.source && {
                transaction_info: {
                    source: metadata.source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        const spanContext = super.toContext();
        return (0, $c7598308515e5ce6$export$d25f2688db1bb433)({
            ...spanContext,
            name: this.name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        super.updateWithContext(transactionContext);
        this.name = transactionContext.name || '';
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   */ getDynamicSamplingContext() {
        if (this._frozenDynamicSamplingContext) return this._frozenDynamicSamplingContext;
        const hub = this._hub || (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)();
        const client = hub && hub.getClient();
        if (!client) return {};
        const { environment: environment, release: release } = client.getOptions() || {};
        const { publicKey: public_key } = client.getDsn() || {};
        const maybeSampleRate = this.metadata.sampleRate;
        const sample_rate = maybeSampleRate !== undefined ? maybeSampleRate.toString() : undefined;
        const { segment: user_segment } = hub.getScope().getUser() || {};
        const source = this.metadata.source;
        // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
        const transaction = source && source !== 'url' ? this.name : undefined;
        const dsc = (0, $c7598308515e5ce6$export$d25f2688db1bb433)({
            environment: environment || (0, $1914256e120b4d38$export$849dbeeeda01ae98),
            release: release,
            transaction: transaction,
            user_segment: user_segment,
            public_key: public_key,
            trace_id: this.traceId,
            sample_rate: sample_rate
        });
        // Uncomment if we want to make DSC immutable
        // this._frozenDynamicSamplingContext = dsc;
        client.emit && client.emit('createDsc', dsc);
        return dsc;
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ setHub(hub) {
        this._hub = hub;
    }
}


const $a0f0882a44eb2af0$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $a0f0882a44eb2af0$var$FINISH_REASON_TAG = 'finishReason';
const $a0f0882a44eb2af0$var$IDLE_TRANSACTION_FINISH_REASONS = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden',
    'finalTimeout',
    'externalFinish',
    'cancelled'
];
/**
 * @inheritDoc
 */ class $a0f0882a44eb2af0$export$370d6113c18ba86c extends (0, $1a8776f8808530e4$export$10c95c129cd0d4fe) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = (endTimestamp)=>{
                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0, $6CbLG.timestampInSeconds)();
                this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) this._pushActivity(span.spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $a0f0882a44eb2af0$export$b279e6bd7040371f extends (0, $68cd3d992998e93b$export$febc5573c75cefb0) {
    // Activities store a list of active spans
    __init() {
        this.activities = {};
    }
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    __init2() {
        this._heartbeatCounter = 0;
    }
    // We should not use heartbeat if we finished a transaction
    __init3() {
        this._finished = false;
    }
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    __init4() {
        this._idleTimeoutCanceledPermanently = false;
    }
    __init5() {
        this._beforeFinishCallbacks = [];
    }
    /**
   * Timer that tracks Transaction idleTimeout
   */ __init6() {
        this._finishReason = $a0f0882a44eb2af0$var$IDLE_TRANSACTION_FINISH_REASONS[4];
    }
    constructor(transactionContext, _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $a0f0882a44eb2af0$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $a0f0882a44eb2af0$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $a0f0882a44eb2af0$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        $a0f0882a44eb2af0$export$b279e6bd7040371f.prototype.__init.call(this);
        $a0f0882a44eb2af0$export$b279e6bd7040371f.prototype.__init2.call(this);
        $a0f0882a44eb2af0$export$b279e6bd7040371f.prototype.__init3.call(this);
        $a0f0882a44eb2af0$export$b279e6bd7040371f.prototype.__init4.call(this);
        $a0f0882a44eb2af0$export$b279e6bd7040371f.prototype.__init5.call(this);
        $a0f0882a44eb2af0$export$b279e6bd7040371f.prototype.__init6.call(this);
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
            _idleHub.configureScope((scope)=>scope.setSpan(this));
        }
        this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus('deadline_exceeded');
                this._finishReason = $a0f0882a44eb2af0$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.finish();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ finish(endTimestamp = (0, $6CbLG.timestampInSeconds)()) {
        this._finished = true;
        this.activities = {};
        if (this.op === 'ui.action.click') this.setTag($a0f0882a44eb2af0$var$FINISH_REASON_TAG, this._finishReason);
        if (this.spanRecorder) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestamp);
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === this.spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus('cancelled');
                    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                const keepSpan = span.startTimestamp < endTimestamp;
                if (!keepSpan) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
                return keepSpan;
            });
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Tracing] flushing IdleTransaction');
        } else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Tracing] No active IdleTransaction');
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            const scope = this._idleHub.getScope();
            if (scope.getTransaction() === this) scope.setSpan(undefined);
        }
        return super.finish(endTimestamp);
    }
    /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            this.spanRecorder = new $a0f0882a44eb2af0$export$370d6113c18ba86c(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('Starting heartbeat');
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $a0f0882a44eb2af0$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $a0f0882a44eb2af0$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.finish(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Tracing] new activities count', Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $6CbLG.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                this._finishReason = $a0f0882a44eb2af0$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Tracing] Transaction finished because of no change for 3 heart beats');
            this.setStatus('deadline_exceeded');
            this._finishReason = $a0f0882a44eb2af0$var$IDLE_TRANSACTION_FINISH_REASONS[0];
            this.finish();
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}



/** Returns all trace headers that are currently on the top scope. */ function $2e9953b90790cb56$var$traceHeaders() {
    const scope = this.getScope();
    const span = scope.getSpan();
    return span ? {
        'sentry-trace': span.toTraceparent()
    } : {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */ function $2e9953b90790cb56$var$sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $9234c712ceb99fb8$export$5008da00b1b6dee6)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            sampleRate: Number(transaction.sampled)
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setMetadata({
            sampleRate: sampleRate
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$2e9953b90790cb56$var$isValidSampleRate(sampleRate)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $2e9953b90790cb56$var$isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $4fda53d1ed38be80$export$c9f5652083b8129d)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $2e9953b90790cb56$var$_startTransaction(transactionContext, customSamplingContext) {
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || 'sentry';
    const transactionInstrumenter = transactionContext.instrumenter || 'sentry';
    if (configInstrumenter !== transactionInstrumenter) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        transactionContext.sampled = false;
    }
    let transaction = new (0, $68cd3d992998e93b$export$febc5573c75cefb0)(transactionContext, this);
    transaction = $2e9953b90790cb56$var$sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $2e9953b90790cb56$export$479dbd817e392a4f(hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval) {
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    let transaction = new (0, $a0f0882a44eb2af0$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
    transaction = $2e9953b90790cb56$var$sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $2e9953b90790cb56$export$653d0ef2bad9cdf9() {
    const carrier = (0, $4e8ba91971b7f1f7$export$19eade501500c6c1)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $2e9953b90790cb56$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $2e9953b90790cb56$var$traceHeaders;
    (0, $0665d99e1ffd7d8e$export$637857c1d87b640c)();
}

const $9e3eb45ed09581ed$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $9e3eb45ed09581ed$export$8e9a29865c0a1226(traceparent) {
    const matches = traceparent.match($9e3eb45ed09581ed$export$394a210812ba3012);
    if (!traceparent || !matches) // empty string or no matches is invalid traceparent data
    return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}




const $dbbd445a9d5c903f$export$9ca9946bd449ac06 = 'baggage';
const $dbbd445a9d5c903f$export$6e69537d67fa20f = 'sentry-';
const $dbbd445a9d5c903f$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $dbbd445a9d5c903f$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $dbbd445a9d5c903f$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $4fda53d1ed38be80$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $dbbd445a9d5c903f$var$baggageHeaderToObject(curr);
        return {
            ...acc,
            ...currBaggageObject
        };
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $dbbd445a9d5c903f$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($dbbd445a9d5c903f$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($dbbd445a9d5c903f$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $dbbd445a9d5c903f$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$dbbd445a9d5c903f$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $dbbd445a9d5c903f$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $dbbd445a9d5c903f$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $dbbd445a9d5c903f$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $dbbd445a9d5c903f$export$bdd844ddb2def819) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}





var $9avcL = parcelRequire("9avcL");
const $b21c4da5808208f1$export$56d8a8a25bd48b81 = (0, $9avcL.GLOBAL_OBJ);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $5c87c907c6d8e7bd$export$6f18f55521af71a1() {
    if ((0, $b21c4da5808208f1$export$56d8a8a25bd48b81) && (0, $b21c4da5808208f1$export$56d8a8a25bd48b81).document) (0, $b21c4da5808208f1$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
        const activeTransaction = (0, $7a33888f93c04594$export$a7feb32fdd923295)();
        if ((0, $b21c4da5808208f1$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = 'cancelled';
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!activeTransaction.status) activeTransaction.setStatus(statusType);
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.finish();
        }
    });
    else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}




var $6CbLG = parcelRequire("6CbLG");

const $f88a22b7a5fbdeee$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $6a1928c3f0437028$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4972b93e6cb36081$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $b21c4da5808208f1$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $b21c4da5808208f1$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate'
    };
    for(const key in timing)if (key !== 'navigationStart' && key !== 'toJSON') navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $4972b93e6cb36081$export$6431553786c94949 = ()=>{
    if ((0, $b21c4da5808208f1$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $b21c4da5808208f1$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || $4972b93e6cb36081$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $b21c4da5808208f1$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $94917e9f8ad93fc9$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $4972b93e6cb36081$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8f4c032953b50845$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $4972b93e6cb36081$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $b21c4da5808208f1$export$56d8a8a25bd48b81).document.prerendering || (0, $94917e9f8ad93fc9$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else navigationType = navEntry.type.replace(/_/g, '-');
    }
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: [],
        id: (0, $6a1928c3f0437028$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $ba689975d97ebb2d$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b750b484cc694496$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $b21c4da5808208f1$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $55bb4bfd04dafe05$export$a7873055838e5ad8 = (onReport)=>{
    const metric = (0, $8f4c032953b50845$export$3c29b44508a0612b)('CLS', 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $ba689975d97ebb2d$export$d1203567a167490e)('layout-shift', handleEntries);
    if (po) {
        report = (0, $f88a22b7a5fbdeee$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $b750b484cc694496$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $1cb9ef6c683a956c$var$firstHiddenTime = -1;
const $1cb9ef6c683a956c$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    return (0, $b21c4da5808208f1$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && !(0, $b21c4da5808208f1$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $1cb9ef6c683a956c$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $b750b484cc694496$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $1cb9ef6c683a956c$var$firstHiddenTime = timeStamp;
    }, true);
};
const $1cb9ef6c683a956c$export$443f86b2c77012c4 = ()=>{
    if ($1cb9ef6c683a956c$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $1cb9ef6c683a956c$var$firstHiddenTime = $1cb9ef6c683a956c$var$initHiddenTime();
        $1cb9ef6c683a956c$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $1cb9ef6c683a956c$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $ba97151dc2c17ce7$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $1cb9ef6c683a956c$export$443f86b2c77012c4)();
    const metric = (0, $8f4c032953b50845$export$3c29b44508a0612b)('FID');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $ba689975d97ebb2d$export$d1203567a167490e)('first-input', handleEntries);
    report = (0, $f88a22b7a5fbdeee$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $b750b484cc694496$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6c67f4a1c1b2699a$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $6c67f4a1c1b2699a$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $1cb9ef6c683a956c$export$443f86b2c77012c4)();
    const metric = (0, $8f4c032953b50845$export$3c29b44508a0612b)('LCP');
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $94917e9f8ad93fc9$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $ba689975d97ebb2d$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
    if (po) {
        report = (0, $f88a22b7a5fbdeee$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$6c67f4a1c1b2699a$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $6c67f4a1c1b2699a$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach((type)=>{
            addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $b750b484cc694496$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};




/**
 * Checks if a given value is a valid measurement value.
 */ function $661ed359857470d6$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $661ed359857470d6$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    if (startTimestamp && transaction.startTimestamp > startTimestamp) transaction.startTimestamp = startTimestamp;
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}


/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $d8d8e0e37729e30e$var$msToSec(time) {
    return time / 1000;
}
function $d8d8e0e37729e30e$var$getBrowserPerformanceAPI() {
    return (0, $b21c4da5808208f1$export$56d8a8a25bd48b81) && (0, $b21c4da5808208f1$export$56d8a8a25bd48b81).addEventListener && (0, $b21c4da5808208f1$export$56d8a8a25bd48b81).performance;
}
let $d8d8e0e37729e30e$var$_performanceCursor = 0;
let $d8d8e0e37729e30e$var$_measurements = {};
let $d8d8e0e37729e30e$var$_lcpEntry;
let $d8d8e0e37729e30e$var$_clsEntry;
/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */ function $d8d8e0e37729e30e$export$7c69f0412d101b88() {
    const performance = $d8d8e0e37729e30e$var$getBrowserPerformanceAPI();
    if (performance && (0, $6CbLG.browserPerformanceTimeOrigin)) {
        if (performance.mark) (0, $b21c4da5808208f1$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        $d8d8e0e37729e30e$var$_trackFID();
        const clsCallback = $d8d8e0e37729e30e$var$_trackCLS();
        const lcpCallback = $d8d8e0e37729e30e$var$_trackLCP();
        return ()=>{
            if (clsCallback) clsCallback();
            if (lcpCallback) lcpCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $d8d8e0e37729e30e$export$f396d19077034ad2() {
    const entryHandler = (entries)=>{
        for (const entry of entries){
            const transaction = (0, $7a33888f93c04594$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $d8d8e0e37729e30e$var$msToSec((0, $6CbLG.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $d8d8e0e37729e30e$var$msToSec(entry.duration);
            transaction.startChild({
                description: 'Main UI thread blocked',
                op: 'ui.long-task',
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    };
    (0, $ba689975d97ebb2d$export$d1203567a167490e)('longtask', entryHandler);
}
/**
 * Start tracking interaction events.
 */ function $d8d8e0e37729e30e$export$e27543e0976315e4() {
    const entryHandler = (entries)=>{
        for (const entry of entries){
            const transaction = (0, $7a33888f93c04594$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === 'click') {
                const startTime = $d8d8e0e37729e30e$var$msToSec((0, $6CbLG.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $d8d8e0e37729e30e$var$msToSec(entry.duration);
                transaction.startChild({
                    description: (0, $0897e54e36555b02$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                });
            }
        }
    };
    (0, $ba689975d97ebb2d$export$d1203567a167490e)('event', entryHandler, {
        durationThreshold: 0
    });
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $d8d8e0e37729e30e$var$_trackCLS() {
    // See:
    // https://web.dev/evolving-cls/
    // https://web.dev/cls-web-tooling/
    return (0, $55bb4bfd04dafe05$export$a7873055838e5ad8)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Measurements] Adding CLS');
        $d8d8e0e37729e30e$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $d8d8e0e37729e30e$var$_clsEntry = entry;
    });
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $d8d8e0e37729e30e$var$_trackLCP() {
    return (0, $6c67f4a1c1b2699a$export$947b1626ab8d5632)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Measurements] Adding LCP');
        $d8d8e0e37729e30e$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $d8d8e0e37729e30e$var$_lcpEntry = entry;
    });
}
/** Starts tracking the First Input Delay on the current page. */ function $d8d8e0e37729e30e$var$_trackFID() {
    (0, $ba97151dc2c17ce7$export$39705a25c49af873)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        const timeOrigin = $d8d8e0e37729e30e$var$msToSec((0, $6CbLG.browserPerformanceTimeOrigin));
        const startTime = $d8d8e0e37729e30e$var$msToSec(entry.startTime);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Measurements] Adding FID');
        $d8d8e0e37729e30e$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $d8d8e0e37729e30e$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
/** Add performance related spans to a transaction */ function $d8d8e0e37729e30e$export$5f8fa6b3467a7443(transaction) {
    const performance = $d8d8e0e37729e30e$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $b21c4da5808208f1$export$56d8a8a25bd48b81).performance.getEntries || !(0, $6CbLG.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Tracing] Adding & adjusting spans using Performance API');
    const timeOrigin = $d8d8e0e37729e30e$var$msToSec((0, $6CbLG.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    let responseStartTimestamp;
    let requestStartTimestamp;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($d8d8e0e37729e30e$var$_performanceCursor).forEach((entry)=>{
        const startTime = $d8d8e0e37729e30e$var$msToSec(entry.startTime);
        const duration = $d8d8e0e37729e30e$var$msToSec(entry.duration);
        if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) return;
        switch(entry.entryType){
            case 'navigation':
                $d8d8e0e37729e30e$var$_addNavigationSpans(transaction, entry, timeOrigin);
                responseStartTimestamp = timeOrigin + $d8d8e0e37729e30e$var$msToSec(entry.responseStart);
                requestStartTimestamp = timeOrigin + $d8d8e0e37729e30e$var$msToSec(entry.requestStart);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $d8d8e0e37729e30e$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $1cb9ef6c683a956c$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Measurements] Adding FP');
                        $d8d8e0e37729e30e$var$_measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Measurements] Adding FCP');
                        $d8d8e0e37729e30e$var$_measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                {
                    const resourceName = entry.name.replace((0, $b21c4da5808208f1$export$56d8a8a25bd48b81).location.origin, '');
                    $d8d8e0e37729e30e$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                }
        }
    });
    $d8d8e0e37729e30e$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $d8d8e0e37729e30e$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (transaction.op === 'pageload') {
        // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
        // start of the response in milliseconds
        if (typeof responseStartTimestamp === 'number') {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Measurements] Adding TTFB');
            $d8d8e0e37729e30e$var$_measurements['ttfb'] = {
                value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
                unit: 'millisecond'
            };
            if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) // Capture the time spent making the request and receiving the first byte of the response.
            // This is the time between the start of the request and the start of the response in milliseconds.
            $d8d8e0e37729e30e$var$_measurements['ttfb.requestTime'] = {
                value: (responseStartTimestamp - requestStartTimestamp) * 1000,
                unit: 'millisecond'
            };
        }
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach((name)=>{
            if (!$d8d8e0e37729e30e$var$_measurements[name] || timeOrigin >= transaction.startTimestamp) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $d8d8e0e37729e30e$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $d8d8e0e37729e30e$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
            const delta = normalizedValue - oldValue;
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $d8d8e0e37729e30e$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $d8d8e0e37729e30e$var$_measurements['mark.fid'];
        if (fidMark && $d8d8e0e37729e30e$var$_measurements['fid']) {
            // create span for FID
            (0, $661ed359857470d6$export$8bd469e1f37aa721)(transaction, {
                description: 'first input delay',
                endTimestamp: fidMark.value + $d8d8e0e37729e30e$var$msToSec($d8d8e0e37729e30e$var$_measurements['fid'].value),
                op: 'ui.action',
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $d8d8e0e37729e30e$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in $d8d8e0e37729e30e$var$_measurements)) delete $d8d8e0e37729e30e$var$_measurements.cls;
        Object.keys($d8d8e0e37729e30e$var$_measurements).forEach((measurementName)=>{
            transaction.setMeasurement(measurementName, $d8d8e0e37729e30e$var$_measurements[measurementName].value, $d8d8e0e37729e30e$var$_measurements[measurementName].unit);
        });
        $d8d8e0e37729e30e$var$_tagMetricInfo(transaction);
    }
    $d8d8e0e37729e30e$var$_lcpEntry = undefined;
    $d8d8e0e37729e30e$var$_clsEntry = undefined;
    $d8d8e0e37729e30e$var$_measurements = {};
}
/** Create measure related spans */ function $d8d8e0e37729e30e$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $661ed359857470d6$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d8d8e0e37729e30e$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $d8d8e0e37729e30e$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $d8d8e0e37729e30e$var$_addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $d8d8e0e37729e30e$var$_addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $d8d8e0e37729e30e$var$_addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    $d8d8e0e37729e30e$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $d8d8e0e37729e30e$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $661ed359857470d6$export$8bd469e1f37aa721)(transaction, {
        op: 'browser',
        description: description || event,
        startTimestamp: timeOrigin + $d8d8e0e37729e30e$var$msToSec(start),
        endTimestamp: timeOrigin + $d8d8e0e37729e30e$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d8d8e0e37729e30e$var$_addRequest(transaction, entry, timeOrigin) {
    (0, $661ed359857470d6$export$8bd469e1f37aa721)(transaction, {
        op: 'browser',
        description: 'request',
        startTimestamp: timeOrigin + $d8d8e0e37729e30e$var$msToSec(entry.requestStart),
        endTimestamp: timeOrigin + $d8d8e0e37729e30e$var$msToSec(entry.responseEnd)
    });
    (0, $661ed359857470d6$export$8bd469e1f37aa721)(transaction, {
        op: 'browser',
        description: 'response',
        startTimestamp: timeOrigin + $d8d8e0e37729e30e$var$msToSec(entry.responseStart),
        endTimestamp: timeOrigin + $d8d8e0e37729e30e$var$msToSec(entry.responseEnd)
    });
}
/** Create resource-related spans */ function $d8d8e0e37729e30e$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    if ('transferSize' in entry) data['http.response_transfer_size'] = entry.transferSize;
    if ('encodedBodySize' in entry) data['http.response_content_length'] = entry.encodedBodySize;
    if ('decodedBodySize' in entry) data['http.decoded_response_content_length'] = entry.decodedBodySize;
    if ('renderBlockingStatus' in entry) data['resource.render_blocking_status'] = entry.renderBlockingStatus;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $661ed359857470d6$export$8bd469e1f37aa721)(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $d8d8e0e37729e30e$var$_trackNavigator(transaction) {
    const navigator = (0, $b21c4da5808208f1$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) transaction.setTag('effectiveConnectionType', connection.effectiveType);
        if (connection.type) transaction.setTag('connectionType', connection.type);
        if ((0, $661ed359857470d6$export$27169ccae1b439e3)(connection.rtt)) $d8d8e0e37729e30e$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $661ed359857470d6$export$27169ccae1b439e3)(navigator.deviceMemory)) transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $661ed359857470d6$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $d8d8e0e37729e30e$var$_tagMetricInfo(transaction) {
    if ($d8d8e0e37729e30e$var$_lcpEntry) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($d8d8e0e37729e30e$var$_lcpEntry.element) transaction.setTag('lcp.element', (0, $0897e54e36555b02$export$5647df6b7814ac86)($d8d8e0e37729e30e$var$_lcpEntry.element));
        if ($d8d8e0e37729e30e$var$_lcpEntry.id) transaction.setTag('lcp.id', $d8d8e0e37729e30e$var$_lcpEntry.id);
        if ($d8d8e0e37729e30e$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        transaction.setTag('lcp.url', $d8d8e0e37729e30e$var$_lcpEntry.url.trim().slice(0, 200));
        transaction.setTag('lcp.size', $d8d8e0e37729e30e$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($d8d8e0e37729e30e$var$_clsEntry && $d8d8e0e37729e30e$var$_clsEntry.sources) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Measurements] Adding CLS Data');
        $d8d8e0e37729e30e$var$_clsEntry.sources.forEach((source, index)=>transaction.setTag(`cls.source.${index + 1}`, (0, $0897e54e36555b02$export$5647df6b7814ac86)(source.node)));
    }
}




/* eslint-disable max-lines */ const $31eb7fed3fc327d6$export$15bd0305d05ad07b = [
    'localhost',
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $31eb7fed3fc327d6$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    // TODO (v8): Remove this property
    tracingOrigins: $31eb7fed3fc327d6$export$15bd0305d05ad07b,
    tracePropagationTargets: $31eb7fed3fc327d6$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $31eb7fed3fc327d6$export$864489cb3478db3e(_options) {
    // eslint-disable-next-line deprecation/deprecation
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: tracePropagationTargets, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest } = {
        traceFetch: $31eb7fed3fc327d6$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $31eb7fed3fc327d6$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$31eb7fed3fc327d6$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $d43610efe653d8f1$export$285b9172a3741fb7)('fetch', (handlerData)=>{
        $31eb7fed3fc327d6$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
    if (traceXHR) (0, $d43610efe653d8f1$export$285b9172a3741fb7)('xhr', (handlerData)=>{
        $31eb7fed3fc327d6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $31eb7fed3fc327d6$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $b6e2a386a4033810$export$a7a5ec66062ea5d)(url, tracePropagationTargets || $31eb7fed3fc327d6$export$15bd0305d05ad07b);
}
/**
 * Create and track fetch request spans
 */ function $31eb7fed3fc327d6$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    if (!(0, $9234c712ceb99fb8$export$5008da00b1b6dee6)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) return;
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                // TODO (kmclb) remove this once types PR goes through
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                span.setHttpStatus(handlerData.response.status);
                const contentLength = // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
                const contentLengthNum = parseInt(contentLength);
                if (contentLengthNum > 0) span.setData('http.response_content_length', contentLengthNum);
            } else if (handlerData.error) span.setStatus('internal_error');
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    const currentScope = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getScope();
    const currentSpan = currentScope && currentScope.getSpan();
    const activeTransaction = currentSpan && currentSpan.transaction;
    if (currentSpan && activeTransaction) {
        const { method: method, url: url } = handlerData.fetchData;
        const span = currentSpan.startChild({
            data: {
                url: url,
                type: 'fetch',
                'http.method': method
            },
            description: `${method} ${url}`,
            op: 'http.client'
        });
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        if (shouldAttachHeaders(handlerData.fetchData.url)) options.headers = $31eb7fed3fc327d6$export$6717acf674206871(request, activeTransaction.getDynamicSamplingContext(), span, options);
    }
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $31eb7fed3fc327d6$export$6717acf674206871(request, dynamicSamplingContext, span, options) {
    const sentryBaggageHeader = (0, $dbbd445a9d5c903f$export$56766feef403f365)(dynamicSamplingContext);
    const sentryTraceHeader = span.toTraceparent();
    const headers = typeof Request !== 'undefined' && (0, $4fda53d1ed38be80$export$49034edbe6b62415)(request, Request) ? request.headers : options.headers;
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, $4fda53d1ed38be80$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $dbbd445a9d5c903f$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $dbbd445a9d5c903f$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
/**
 * Create and track xhr request spans
 */ function $31eb7fed3fc327d6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $d43610efe653d8f1$export$55b6bb1e45c6cf59];
    if (!(0, $9234c712ceb99fb8$export$5008da00b1b6dee6)() || xhr && xhr.__sentry_own_request__ || !(xhr && sentryXhrData && shouldCreateSpan(sentryXhrData.url))) return;
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            span.setHttpStatus(sentryXhrData.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    const currentScope = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getScope();
    const currentSpan = currentScope && currentScope.getSpan();
    const activeTransaction = currentSpan && currentSpan.transaction;
    if (currentSpan && activeTransaction) {
        const span = currentSpan.startChild({
            data: {
                ...sentryXhrData.data,
                type: 'xhr',
                'http.method': sentryXhrData.method,
                url: sentryXhrData.url
            },
            description: `${sentryXhrData.method} ${sentryXhrData.url}`,
            op: 'http.client'
        });
        xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
        if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url)) try {
            xhr.setRequestHeader('sentry-trace', span.toTraceparent());
            const dynamicSamplingContext = activeTransaction.getDynamicSamplingContext();
            const sentryBaggageHeader = (0, $dbbd445a9d5c903f$export$56766feef403f365)(dynamicSamplingContext);
            if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
            // We can therefore simply set a baggage header without checking what was there before
            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
            xhr.setRequestHeader((0, $dbbd445a9d5c903f$export$9ca9946bd449ac06), sentryBaggageHeader);
        } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
        }
    }
}



var $6CbLG = parcelRequire("6CbLG");

/**
 * Default function implementing pageload and navigation transactions
 */ function $a2f21a97ff2c68b0$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $b21c4da5808208f1$export$56d8a8a25bd48b81) || !(0, $b21c4da5808208f1$export$56d8a8a25bd48b81).location) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    let startingUrl = (0, $b21c4da5808208f1$export$56d8a8a25bd48b81).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $b21c4da5808208f1$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $6CbLG.browserPerformanceTimeOrigin) ? (0, $6CbLG.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: 'pageload',
        metadata: {
            source: 'url'
        }
    });
    if (startTransactionOnLocationChange) (0, $d43610efe653d8f1$export$285b9172a3741fb7)('history', ({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.finish();
            }
            activeTransaction = customStartTransaction({
                name: (0, $b21c4da5808208f1$export$56d8a8a25bd48b81).location.pathname,
                op: 'navigation',
                metadata: {
                    source: 'url'
                }
            });
        }
    });
}



const $d45b5653f1edc3ff$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $d45b5653f1edc3ff$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $a0f0882a44eb2af0$export$809a2b7987fd5306),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $a2f21a97ff2c68b0$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    _experiments: {},
    ...(0, $31eb7fed3fc327d6$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */ class $d45b5653f1edc3ff$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ __init() {
        this.name = $d45b5653f1edc3ff$export$bbd2089f30bd3708;
    }
    constructor(_options){
        $d45b5653f1edc3ff$export$46d3bbd0375f5fa4.prototype.__init.call(this);
        (0, $2e9953b90790cb56$export$653d0ef2bad9cdf9)();
        this.options = {
            ...$d45b5653f1edc3ff$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $d8d8e0e37729e30e$export$7c69f0412d101b88)();
        if (this.options.enableLongTask) (0, $d8d8e0e37729e30e$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $d8d8e0e37729e30e$export$e27543e0976315e4)();
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: tracePropagationTargets, shouldCreateSpanForRequest: shouldCreateSpanForRequest, _experiments: _experiments } = this.options;
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $5c87c907c6d8e7bd$export$6f18f55521af71a1)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        (0, $31eb7fed3fc327d6$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === 'pageload';
        const sentryTraceMetaTagValue = isPageloadTransaction ? $d45b5653f1edc3ff$export$f147b32b03c9cf11('sentry-trace') : null;
        const baggageMetaTagValue = isPageloadTransaction ? $d45b5653f1edc3ff$export$f147b32b03c9cf11('baggage') : null;
        const traceParentData = sentryTraceMetaTagValue ? (0, $9e3eb45ed09581ed$export$8e9a29865c0a1226)(sentryTraceMetaTagValue) : undefined;
        const dynamicSamplingContext = baggageMetaTagValue ? (0, $dbbd445a9d5c903f$export$5b96ee2c8421f107)(baggageMetaTagValue) : undefined;
        const expandedContext = {
            ...context,
            ...traceParentData,
            metadata: {
                ...context.metadata,
                dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext
            },
            trimEnd: true
        };
        const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: 'custom'
        } : finalContext.metadata;
        this._latestRouteName = finalContext.name;
        this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;
        if (finalContext.sampled === false) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const hub = this._getCurrentHub();
        const { location: location } = (0, $b21c4da5808208f1$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $2e9953b90790cb56$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $d8d8e0e37729e30e$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = 'ui.action.click';
            const currentTransaction = (0, $7a33888f93c04594$export$a7feb32fdd923295)();
            if (currentTransaction && currentTransaction.op && [
                'navigation',
                'pageload'
            ].includes(currentTransaction.op)) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason('interactionInterrupted');
                inflightInteractionTransaction.finish();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRouteName) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $b21c4da5808208f1$export$56d8a8a25bd48b81);
            const context = {
                name: this._latestRouteName,
                op: op,
                trimEnd: true,
                metadata: {
                    source: this._latestRouteSource || 'url'
                }
            };
            inflightInteractionTransaction = (0, $2e9953b90790cb56$export$479dbd817e392a4f)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            'click'
        ].forEach((type)=>{
            addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
}
/** Returns the value of a meta tag */ function $d45b5653f1edc3ff$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $0897e54e36555b02$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : null;
}




const $86a52df17259f1ae$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $86a52df17259f1ae$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $86a52df17259f1ae$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $65d42e3833054e5c$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $86a52df17259f1ae$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $86a52df17259f1ae$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $86a52df17259f1ae$export$51abed9797baa598(integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $86a52df17259f1ae$export$e7390a03b70a6f2f(integration, integrationIndex);
    });
    return integrationIndex;
}
/** Setup a single integration.  */ function $86a52df17259f1ae$export$e7390a03b70a6f2f(integration, integrationIndex) {
    integrationIndex[integration.name] = integration;
    if ($86a52df17259f1ae$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        integration.setupOnce((0, $287ad5dd047650ab$export$8e4e25f54d456511), (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c));
        $86a52df17259f1ae$export$b14a8888f80a0b3e.push(integration.name);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
    }
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $86a52df17259f1ae$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}


/** Regular expression used to parse a Dsn. */ const $7fce9ba20a431eb8$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $7fce9ba20a431eb8$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $7fce9ba20a431eb8$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $7fce9ba20a431eb8$export$b892860177f70a30(str) {
    const match = $7fce9ba20a431eb8$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        // eslint-disable-next-line no-console
        console.error(`Invalid Sentry Dsn: ${str}`);
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $7fce9ba20a431eb8$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $7fce9ba20a431eb8$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $7fce9ba20a431eb8$var$validateDsn(dsn) {
    if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$7fce9ba20a431eb8$var$isValidProtocol(protocol)) {
        (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $7fce9ba20a431eb8$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $7fce9ba20a431eb8$export$b892860177f70a30(from) : $7fce9ba20a431eb8$var$dsnFromComponents(from);
    if (!components || !$7fce9ba20a431eb8$var$validateDsn(components)) return undefined;
    return components;
}


const $15e69d1b7a564e51$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $15e69d1b7a564e51$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $15e69d1b7a564e51$var$_getIngestEndpoint(dsn) {
    return `${$15e69d1b7a564e51$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $15e69d1b7a564e51$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $c7598308515e5ce6$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $15e69d1b7a564e51$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $15e69d1b7a564e51$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$15e69d1b7a564e51$var$_getIngestEndpoint(dsn)}?${$15e69d1b7a564e51$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $15e69d1b7a564e51$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $7fce9ba20a431eb8$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$15e69d1b7a564e51$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $7fce9ba20a431eb8$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}



/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $38804fa7098439d7$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    const hub = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)();
    const scope = hub.getScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    hub.bindClient(client);
}

var $1531605be0a97434$exports = {};

$parcel$export($1531605be0a97434$exports, "FunctionToString", function () { return $21a4e309182202e2$export$da4704525c20ae79; });
$parcel$export($1531605be0a97434$exports, "InboundFilters", function () { return $ae1a3a90cd241410$export$2ffbb5359dcc6be4; });

let $21a4e309182202e2$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ class $21a4e309182202e2$export$da4704525c20ae79 {
    constructor(){
        $21a4e309182202e2$export$da4704525c20ae79.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'FunctionToString';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $21a4e309182202e2$export$da4704525c20ae79.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $21a4e309182202e2$var$originalFunctionToString = Function.prototype.toString;
        // intrinsics (like Function.prototype) might be immutable in some environments
        // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Function.prototype.toString = function(...args) {
                const context = (0, $c7598308515e5ce6$export$e6cc1e135e2092e5)(this) || this;
                return $21a4e309182202e2$var$originalFunctionToString.apply(context, args);
            };
        } catch (e) {
        // ignore errors here, just don't patch this
        }
    }
}
$21a4e309182202e2$export$da4704525c20ae79.__initStatic();



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $ae1a3a90cd241410$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Options for the InboundFilters integration */ /** Inbound filters configurable by the user */ class $ae1a3a90cd241410$export$2ffbb5359dcc6be4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'InboundFilters';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $ae1a3a90cd241410$export$2ffbb5359dcc6be4.id;
    }
    constructor(_options = {}){
        this._options = _options;
        $ae1a3a90cd241410$export$2ffbb5359dcc6be4.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ setupOnce(addGlobalEventProcessor, getCurrentHub) {
        const eventProcess = (event)=>{
            const hub = getCurrentHub();
            if (hub) {
                const self = hub.getIntegration($ae1a3a90cd241410$export$2ffbb5359dcc6be4);
                if (self) {
                    const client = hub.getClient();
                    const clientOptions = client ? client.getOptions() : {};
                    const options = $ae1a3a90cd241410$export$6620a151868b99aa(self._options, clientOptions);
                    return $ae1a3a90cd241410$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        };
        eventProcess.id = this.name;
        addGlobalEventProcessor(eventProcess);
    }
}
$ae1a3a90cd241410$export$2ffbb5359dcc6be4.__initStatic();
/** JSDoc */ function $ae1a3a90cd241410$export$6620a151868b99aa(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...$ae1a3a90cd241410$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
/** JSDoc */ function $ae1a3a90cd241410$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $ae1a3a90cd241410$var$_isSentryError(event)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $65d42e3833054e5c$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($ae1a3a90cd241410$var$_isIgnoredError(event, options.ignoreErrors)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $65d42e3833054e5c$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($ae1a3a90cd241410$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $65d42e3833054e5c$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($ae1a3a90cd241410$var$_isDeniedUrl(event, options.denyUrls)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $65d42e3833054e5c$export$4157119e2b157127)(event)}.\nUrl: ${$ae1a3a90cd241410$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$ae1a3a90cd241410$var$_isAllowedUrl(event, options.allowUrls)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $65d42e3833054e5c$export$4157119e2b157127)(event)}.\nUrl: ${$ae1a3a90cd241410$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $ae1a3a90cd241410$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $ae1a3a90cd241410$var$_getPossibleEventMessages(event).some((message)=>(0, $b6e2a386a4033810$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $ae1a3a90cd241410$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $b6e2a386a4033810$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $ae1a3a90cd241410$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $ae1a3a90cd241410$var$_getEventFilterUrl(event);
    return !url ? false : (0, $b6e2a386a4033810$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $ae1a3a90cd241410$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $ae1a3a90cd241410$var$_getEventFilterUrl(event);
    return !url ? true : (0, $b6e2a386a4033810$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $ae1a3a90cd241410$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) {
        const { values: values } = event.exception;
        try {
            const { type: type = '', value: value = '' } = values && values[values.length - 1] || {};
            return [
                `${value}`,
                `${type}: ${value}`
            ];
        } catch (oO) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error(`Cannot extract message for event ${(0, $65d42e3833054e5c$export$4157119e2b157127)(event)}`);
            return [];
        }
    }
    return [];
}
function $ae1a3a90cd241410$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $ae1a3a90cd241410$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $ae1a3a90cd241410$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $ae1a3a90cd241410$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $65d42e3833054e5c$export$4157119e2b157127)(event)}`);
        return null;
    }
}







/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $b2cf5888f03fd731$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}




/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4cc0442f6ee1f737$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $4cc0442f6ee1f737$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $4cc0442f6ee1f737$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $4cc0442f6ee1f737$export$a3295358bff77e(object, depth);
    if ($4cc0442f6ee1f737$var$jsonSize(normalized) > maxSize) return $4cc0442f6ee1f737$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $4cc0442f6ee1f737$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $b2cf5888f03fd731$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $4fda53d1ed38be80$export$c9f5652083b8129d)(value)) return value;
    const stringified = $4cc0442f6ee1f737$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $4cc0442f6ee1f737$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $c7598308515e5ce6$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $4cc0442f6ee1f737$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $4cc0442f6ee1f737$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $4fda53d1ed38be80$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $469cba5b454ec853$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $4cc0442f6ee1f737$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $4cc0442f6ee1f737$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $4cc0442f6ee1f737$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4cc0442f6ee1f737$var$jsonSize(value) {
    return $4cc0442f6ee1f737$var$utf8Length(JSON.stringify(value));
}



/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $c4b30a4fb2276f64$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $c4b30a4fb2276f64$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $c4b30a4fb2276f64$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $c4b30a4fb2276f64$export$604a45d95a155e2b(envelope, types) {
    return $c4b30a4fb2276f64$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $c4b30a4fb2276f64$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $c4b30a4fb2276f64$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $c4b30a4fb2276f64$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $c4b30a4fb2276f64$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $4cc0442f6ee1f737$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $c4b30a4fb2276f64$var$concatBuffers(parts);
}
function $c4b30a4fb2276f64$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $c4b30a4fb2276f64$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $c4b30a4fb2276f64$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $c4b30a4fb2276f64$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $c7598308515e5ce6$export$d25f2688db1bb433)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $c4b30a4fb2276f64$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $c4b30a4fb2276f64$export$b11169581eeaf237(type) {
    return $c4b30a4fb2276f64$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from from the metadata or an events */ function $c4b30a4fb2276f64$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $c4b30a4fb2276f64$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && {
            dsn: (0, $7fce9ba20a431eb8$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $c7598308515e5ce6$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}

/** An error emitted by Sentry SDKs and related utilities. */ class $1e4a101170c0db5c$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $2f7564a245723836$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $2f7564a245723836$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $c4b30a4fb2276f64$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && {
            dsn: (0, $7fce9ba20a431eb8$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session
    ];
    return (0, $c4b30a4fb2276f64$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $2f7564a245723836$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $c4b30a4fb2276f64$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $2f7564a245723836$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $c4b30a4fb2276f64$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $c4b30a4fb2276f64$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}





var $6CbLG = parcelRequire("6CbLG");
var $9avcL = parcelRequire("9avcL");


/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $77b83a1be9fe3673$export$2d67fb380bd11267(options, event, hint, scope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $65d42e3833054e5c$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $6CbLG.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $77b83a1be9fe3673$var$applyClientOptions(prepared, options);
    $77b83a1be9fe3673$var$applyIntegrationsMetadata(prepared, integrations);
    // Only apply debug metadata to error events.
    if (event.type === undefined) $77b83a1be9fe3673$export$4c0b0d8ee0d018b5(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    let finalScope = scope;
    if (hint.captureContext) finalScope = (0, $287ad5dd047650ab$export$775b6bb06e53a214).clone(finalScope).update(hint.captureContext);
    // We prepare the result here with a resolved Event.
    let result = (0, $73f700349fff73af$export$1fda8aa4d135f8aa)(prepared);
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    //
    // We need to check for the existence of `finalScope.getAttachments`
    // because `getAttachments` can be undefined if users are using an older version
    // of `@sentry/core` that does not have the `getAttachments` method.
    // See: https://github.com/getsentry/sentry-javascript/issues/5229
    if (finalScope) {
        // Collect attachments from the hint and scope
        if (finalScope.getAttachments) {
            const attachments = [
                ...hint.attachments || [],
                ...finalScope.getAttachments()
            ];
            if (attachments.length) hint.attachments = attachments;
        }
        // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
    }
    return result.then((evt)=>{
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $77b83a1be9fe3673$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $77b83a1be9fe3673$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $1914256e120b4d38$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $b6e2a386a4033810$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $b6e2a386a4033810$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $b6e2a386a4033810$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $77b83a1be9fe3673$var$debugIdStackParserCache = new WeakMap();
/**
 * Applies debug metadata images to the event in order to apply source maps by looking up their debug ID.
 */ function $77b83a1be9fe3673$export$4c0b0d8ee0d018b5(event, stackParser) {
    const debugIdMap = (0, $9avcL.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $77b83a1be9fe3673$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $77b83a1be9fe3673$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    // Get a Set of filenames in the stack trace
    const errorFileNames = new Set();
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) errorFileNames.add(frame.filename);
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    errorFileNames.forEach((filename)=>{
        if (filenameDebugIdMap[filename]) images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $77b83a1be9fe3673$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $77b83a1be9fe3673$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $4cc0442f6ee1f737$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $4cc0442f6ee1f737$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $4cc0442f6ee1f737$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $4cc0442f6ee1f737$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $4cc0442f6ee1f737$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
        if (span.data) span.data = (0, $4cc0442f6ee1f737$export$a3295358bff77e)(span.data, depth, maxBreadth);
        return span;
    });
    return normalized;
}


const $a05dec76deaf0cd6$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $a05dec76deaf0cd6$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ __init() {
        this._integrations = {};
    }
    /** Indicates whether this client's integrations have been set up. */ __init2() {
        this._integrationsInitialized = false;
    }
    /** Number of calls being processed */ __init3() {
        this._numProcessing = 0;
    }
    /** Holds flushable  */ __init4() {
        this._outcomes = {};
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    __init5() {
        this._hooks = {};
    }
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        $a05dec76deaf0cd6$export$4f22f74eddb7716a.prototype.__init.call(this);
        $a05dec76deaf0cd6$export$4f22f74eddb7716a.prototype.__init2.call(this);
        $a05dec76deaf0cd6$export$4f22f74eddb7716a.prototype.__init3.call(this);
        $a05dec76deaf0cd6$export$4f22f74eddb7716a.prototype.__init4.call(this);
        $a05dec76deaf0cd6$export$4f22f74eddb7716a.prototype.__init5.call(this);
        this._options = options;
        if (options.dsn) this._dsn = (0, $7fce9ba20a431eb8$export$128827c3562ec0cb)(options.dsn);
        else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('No DSN provided, client will not do anything.');
        if (this._dsn) {
            const url = (0, $15e69d1b7a564e51$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $65d42e3833054e5c$export$6de4ffac6a2f1098)(exception)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log($a05dec76deaf0cd6$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const promisedEvent = (0, $4fda53d1ed38be80$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(String(message), level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $65d42e3833054e5c$export$6de4ffac6a2f1098)(hint.originalException)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log($a05dec76deaf0cd6$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!this._isEnabled()) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $c32ce746d875b706$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
            return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
        });
        else return (0, $73f700349fff73af$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            return result;
        });
    }
    /**
   * Sets up the integrations
   */ setupIntegrations() {
        if (this._isEnabled() && !this._integrationsInitialized) {
            this._integrations = (0, $86a52df17259f1ae$export$51abed9797baa598)(this._options.integrations);
            this._integrationsInitialized = true;
        }
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */ getIntegrationById(integrationId) {
        return this._integrations[integrationId];
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        (0, $86a52df17259f1ae$export$e7390a03b70a6f2f)(integration, this._integrations);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        if (this._dsn) {
            let env = (0, $2f7564a245723836$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
            for (const attachment of hint.attachments || [])env = (0, $c4b30a4fb2276f64$export$d650323442802f6f)(env, (0, $c4b30a4fb2276f64$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
            const promise = this._sendEnvelope(env);
            if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
        }
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        if (this._dsn) {
            const env = (0, $2f7564a245723836$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
            this._sendEnvelope(env);
        }
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-ignore We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) // @ts-ignore we cannot enforce the callback to match the hook
        this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $c32ce746d875b706$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $73f700349fff73af$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        return (0, $77b83a1be9fe3673$export$2d67fb380bd11267)(options, event, hint, scope);
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        if (!this._isEnabled()) return (0, $73f700349fff73af$export$78e43115b553f358)(new (0, $1e4a101170c0db5c$export$5949942ba2a7c0e2)('SDK not enabled, will not capture event.', 'log'));
        const isTransaction = $a05dec76deaf0cd6$var$isTransactionEvent(event);
        const isError = $a05dec76deaf0cd6$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $73f700349fff73af$export$78e43115b553f358)(new (0, $1e4a101170c0db5c$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, scope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $1e4a101170c0db5c$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $a05dec76deaf0cd6$var$processBeforeSend(options, prepared, hint);
            return $a05dec76deaf0cd6$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                throw new (0, $1e4a101170c0db5c$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $1e4a101170c0db5c$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $1e4a101170c0db5c$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        if (this._transport && this._dsn) {
            this.emit('beforeEnvelope', envelope);
            return this._transport.send(envelope).then(null, (reason)=>{
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error('Error while sending event:', reason);
            });
        } else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $a05dec76deaf0cd6$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $4fda53d1ed38be80$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $4fda53d1ed38be80$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $1e4a101170c0db5c$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $1e4a101170c0db5c$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $4fda53d1ed38be80$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $1e4a101170c0db5c$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $a05dec76deaf0cd6$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($a05dec76deaf0cd6$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($a05dec76deaf0cd6$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $a05dec76deaf0cd6$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $a05dec76deaf0cd6$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}

const $69b89edc7cd573a3$export$31499a9cd224b78c = '7.53.0';




var $6CbLG = parcelRequire("6CbLG");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $74cb99e8a4e4e934$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $6CbLG.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $c4b30a4fb2276f64$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $102SM = parcelRequire("102SM");


/**
 * This function creates an exception from a JavaScript Error
 */ function $598e5a2a43d22dd5$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $598e5a2a43d22dd5$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $598e5a2a43d22dd5$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $598e5a2a43d22dd5$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const hub = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)();
    const client = hub.getClient();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $4fda53d1ed38be80$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: `Non-Error ${isUnhandledRejection ? 'promise rejection' : 'exception'} captured with keys: ${(0, $c7598308515e5ce6$export$b0244d5063c0b61b)(exception)}`
                }
            ]
        },
        extra: {
            __serialized__: (0, $4cc0442f6ee1f737$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $598e5a2a43d22dd5$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $598e5a2a43d22dd5$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $598e5a2a43d22dd5$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $598e5a2a43d22dd5$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $598e5a2a43d22dd5$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $598e5a2a43d22dd5$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $598e5a2a43d22dd5$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($598e5a2a43d22dd5$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $598e5a2a43d22dd5$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $598e5a2a43d22dd5$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $598e5a2a43d22dd5$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $65d42e3833054e5c$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $73f700349fff73af$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $598e5a2a43d22dd5$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $598e5a2a43d22dd5$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $73f700349fff73af$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $598e5a2a43d22dd5$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $4fda53d1ed38be80$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $598e5a2a43d22dd5$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $4fda53d1ed38be80$export$ef9e2056653f0c8e)(exception) || (0, $4fda53d1ed38be80$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $598e5a2a43d22dd5$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $4fda53d1ed38be80$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $598e5a2a43d22dd5$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $65d42e3833054e5c$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $4fda53d1ed38be80$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $598e5a2a43d22dd5$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $4fda53d1ed38be80$export$53b83ca8eaab0383)(exception) || (0, $4fda53d1ed38be80$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $598e5a2a43d22dd5$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $65d42e3833054e5c$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $598e5a2a43d22dd5$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $65d42e3833054e5c$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $65d42e3833054e5c$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $598e5a2a43d22dd5$export$47d86ae4b3c9994(stackParser, input, syntheticException, attachStacktrace) {
    const event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        const frames = $598e5a2a43d22dd5$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: input,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    return event;
}




// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $7364f12ad7fd150c$export$f5282963edea4a68(exception, captureContext) {
    return (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().captureException(exception, {
        captureContext: captureContext
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */ function $7364f12ad7fd150c$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */ function $7364f12ad7fd150c$export$1462b974fdcf6ba2(event, hint) {
    return (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */ function $7364f12ad7fd150c$export$99d44f04437e9cb8(callback) {
    (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ function $7364f12ad7fd150c$export$efda9a273d7a036d(breadcrumb) {
    (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7364f12ad7fd150c$export$2f04de43fe27971a(name, context) {
    (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $7364f12ad7fd150c$export$bb4922da0dd51b92(extras) {
    (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $7364f12ad7fd150c$export$8e8e7789d42ed61d(key, extra) {
    (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $7364f12ad7fd150c$export$74a8fb34822092e6(tags) {
    (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $7364f12ad7fd150c$export$a37d07ee78eb4569(key, value) {
    (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $7364f12ad7fd150c$export$8b6bb3dd62a01be2(user) {
    (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */ function $7364f12ad7fd150c$export$ec58d9285c204497(callback) {
    (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().withScope(callback);
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */ function $7364f12ad7fd150c$export$e262da7ae6480481(context, customSamplingContext) {
    return (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $7364f12ad7fd150c$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const client = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getClient();
    if (!client) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig);
    return (0, $65d42e3833054e5c$export$19f53698e68b2496)();
}



var $9avcL = parcelRequire("9avcL");
const $f376c6a2c7a06d65$export$56d8a8a25bd48b81 = (0, $9avcL.GLOBAL_OBJ);
let $f376c6a2c7a06d65$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $f376c6a2c7a06d65$export$b79738ab10c590b2() {
    return $f376c6a2c7a06d65$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $f376c6a2c7a06d65$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $f376c6a2c7a06d65$var$ignoreOnError++;
    setTimeout(()=>{
        $f376c6a2c7a06d65$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $f376c6a2c7a06d65$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $c7598308515e5ce6$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$f376c6a2c7a06d65$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $f376c6a2c7a06d65$export$1265a142ff5ba165();
            (0, $7364f12ad7fd150c$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $65d42e3833054e5c$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $65d42e3833054e5c$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $7364f12ad7fd150c$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $c7598308515e5ce6$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $c7598308515e5ce6$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $eaf34807843366d4$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $eaf34807843366d4$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $eaf34807843366d4$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $eaf34807843366d4$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    .replace(':80', '').replace(':443', '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $aa6d6758bd278563$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $aa6d6758bd278563$export$e01cef29b4327697(level) {
    return $aa6d6758bd278563$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $aa6d6758bd278563$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $aa6d6758bd278563$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}



/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $0046a6cdf462bbd3$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $0046a6cdf462bbd3$export$6d0f6df16bece7bf = 'Breadcrumbs';
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ class $0046a6cdf462bbd3$export$2dc68d50d56fbbd {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = $0046a6cdf462bbd3$export$6d0f6df16bece7bf;
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $0046a6cdf462bbd3$export$2dc68d50d56fbbd.id;
    }
    /**
   * Options of the breadcrumbs integration.
   */ // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.
    /**
   * @inheritDoc
   */ constructor(options){
        $0046a6cdf462bbd3$export$2dc68d50d56fbbd.prototype.__init.call(this);
        this.options = {
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true,
            ...options
        };
    }
    /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */ setupOnce() {
        if (this.options.console) (0, $d43610efe653d8f1$export$285b9172a3741fb7)('console', $0046a6cdf462bbd3$var$_consoleBreadcrumb);
        if (this.options.dom) (0, $d43610efe653d8f1$export$285b9172a3741fb7)('dom', $0046a6cdf462bbd3$var$_domBreadcrumb(this.options.dom));
        if (this.options.xhr) (0, $d43610efe653d8f1$export$285b9172a3741fb7)('xhr', $0046a6cdf462bbd3$var$_xhrBreadcrumb);
        if (this.options.fetch) (0, $d43610efe653d8f1$export$285b9172a3741fb7)('fetch', $0046a6cdf462bbd3$var$_fetchBreadcrumb);
        if (this.options.history) (0, $d43610efe653d8f1$export$285b9172a3741fb7)('history', $0046a6cdf462bbd3$var$_historyBreadcrumb);
    }
    /**
   * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
   */ addSentryBreadcrumb(event) {
        if (this.options.sentry) (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $65d42e3833054e5c$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    }
}
$0046a6cdf462bbd3$export$2dc68d50d56fbbd.__initStatic();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $0046a6cdf462bbd3$var$_domBreadcrumb(dom) {
    function _innerDomBreadcrumb(handlerData) {
        let target;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $0046a6cdf462bbd3$var$MAX_ALLOWED_STRING_LENGTH) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$0046a6cdf462bbd3$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$0046a6cdf462bbd3$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $0046a6cdf462bbd3$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            target = $0046a6cdf462bbd3$var$_isEvent(event) ? (0, $0897e54e36555b02$export$5647df6b7814ac86)(event.target, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            }) : (0, $0897e54e36555b02$export$5647df6b7814ac86)(event, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: `ui.${handlerData.name}`,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ function $0046a6cdf462bbd3$var$_consoleBreadcrumb(handlerData) {
    // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
    // console warnings. This happens when a Vue template is rendered with
    // an undeclared variable, which we try to stringify, ultimately causing
    // Vue to issue another warning which repeats indefinitely.
    // see: https://github.com/getsentry/sentry-javascript/pull/6010
    // see: https://github.com/getsentry/sentry-javascript/issues/5916
    for(let i = 0; i < handlerData.args.length; i++)if (handlerData.args[i] === 'ref=Ref<') {
        handlerData.args[i + 1] = 'viewRef';
        break;
    }
    const breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $aa6d6758bd278563$export$d771ef054122c30a)(handlerData.level),
        message: (0, $b6e2a386a4033810$export$465e9d514283d4fd)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = `Assertion failed: ${(0, $b6e2a386a4033810$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $0046a6cdf462bbd3$var$_xhrBreadcrumb(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
    const sentryXhrData = handlerData.xhr[0, $d43610efe653d8f1$export$55b6bb1e45c6cf59];
    // We only capture complete, non-sentry requests
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
    const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
    const data = {
        method: method,
        url: url,
        status_code: status_code
    };
    const hint = {
        xhr: handlerData.xhr,
        input: body,
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp
    };
    (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().addBreadcrumb({
        category: 'xhr',
        data: data,
        type: 'http'
    }, hint);
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $0046a6cdf462bbd3$var$_fetchBreadcrumb(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
    // We only capture complete fetch requests
    if (!endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) {
        const data = handlerData.fetchData;
        const hint = {
            data: handlerData.error,
            input: handlerData.args,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: 'fetch',
            data: data,
            level: 'error',
            type: 'http'
        }, hint);
    } else {
        const data = {
            ...handlerData.fetchData,
            status_code: handlerData.response && handlerData.response.status
        };
        const hint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: 'fetch',
            data: data,
            type: 'http'
        }, hint);
    }
}
/**
 * Creates breadcrumbs from history API calls
 */ function $0046a6cdf462bbd3$var$_historyBreadcrumb(handlerData) {
    let from = handlerData.from;
    let to = handlerData.to;
    const parsedLoc = (0, $eaf34807843366d4$export$7a5253c0f62e0150)((0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).location.href);
    let parsedFrom = (0, $eaf34807843366d4$export$7a5253c0f62e0150)(from);
    const parsedTo = (0, $eaf34807843366d4$export$7a5253c0f62e0150)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}
function $0046a6cdf462bbd3$var$_isEvent(event) {
    return event && !!event.target;
}



/**
 * Creates an envelope from a user feedback.
 */ function $1486bc77c775660e$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $7fce9ba20a431eb8$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $1486bc77c775660e$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $c4b30a4fb2276f64$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $1486bc77c775660e$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $47e48a95232a43ea$export$1df9218a526d318d extends (0, $a05dec76deaf0cd6$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $102SM.getSDKSource)();
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: `${sdkSource}:@sentry/browser`,
                    version: (0, $69b89edc7cd573a3$export$31499a9cd224b78c)
                }
            ],
            version: (0, $69b89edc7cd573a3$export$31499a9cd224b78c)
        };
        super(options);
        if (options.sendClientReports && (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).document) (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $598e5a2a43d22dd5$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $598e5a2a43d22dd5$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint) {
        // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
        // activated its `sentry` option.
        // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
        // bundles, if it is not used by the SDK.
        // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
        // way for now.
        const breadcrumbIntegration = this.getIntegrationById((0, $0046a6cdf462bbd3$export$6d0f6df16bece7bf));
        // We check for definedness of `addSentryBreadcrumb` in case users provided their own integration with id
        // "Breadcrumbs" that does not have this function.
        if (breadcrumbIntegration && breadcrumbIntegration.addSentryBreadcrumb) breadcrumbIntegration.addSentryBreadcrumb(event);
        super.sendEvent(event, hint);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $1486bc77c775660e$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        if (!this._dsn) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const envelope = (0, $74cb99e8a4e4e934$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $7fce9ba20a431eb8$export$44d472fbb931a776)(this._dsn));
        this._sendEnvelope(envelope);
    }
}







/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Global handlers */ class $92475c01b5771461$export$204155decbc90e5a {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'GlobalHandlers';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $92475c01b5771461$export$204155decbc90e5a.id;
    }
    /** JSDoc */ /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */ __init2() {
        this._installFunc = {
            onerror: $92475c01b5771461$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $92475c01b5771461$var$_installGlobalOnUnhandledRejectionHandler
        };
    }
    /** JSDoc */ constructor(options){
        $92475c01b5771461$export$204155decbc90e5a.prototype.__init.call(this);
        $92475c01b5771461$export$204155decbc90e5a.prototype.__init2.call(this);
        this._options = {
            onerror: true,
            onunhandledrejection: true,
            ...options
        };
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        Error.stackTraceLimit = 50;
        const options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(const key in options){
            const installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $92475c01b5771461$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    }
}
$92475c01b5771461$export$204155decbc90e5a.__initStatic();
/** JSDoc */ function $92475c01b5771461$var$_installGlobalOnErrorHandler() {
    (0, $d43610efe653d8f1$export$285b9172a3741fb7)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data)=>{
        const [hub, stackParser, attachStacktrace] = $92475c01b5771461$var$getHubAndOptions();
        if (!hub.getIntegration($92475c01b5771461$export$204155decbc90e5a)) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        if ((0, $f376c6a2c7a06d65$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return;
        const event = error === undefined && (0, $4fda53d1ed38be80$export$844ec244b1367d54)(msg) ? $92475c01b5771461$var$_eventFromIncompleteOnError(msg, url, line, column) : $92475c01b5771461$var$_enhanceEventWithInitialFrame((0, $598e5a2a43d22dd5$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        $92475c01b5771461$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $92475c01b5771461$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $d43610efe653d8f1$export$285b9172a3741fb7)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e)=>{
        const [hub, stackParser, attachStacktrace] = $92475c01b5771461$var$getHubAndOptions();
        if (!hub.getIntegration($92475c01b5771461$export$204155decbc90e5a)) return;
        let error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $f376c6a2c7a06d65$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return true;
        const event = (0, $4fda53d1ed38be80$export$c3825b437cbdea5c)(error) ? $92475c01b5771461$var$_eventFromRejectionWithPrimitive(error) : (0, $598e5a2a43d22dd5$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        $92475c01b5771461$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $92475c01b5771461$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $92475c01b5771461$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $4fda53d1ed38be80$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $92475c01b5771461$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $92475c01b5771461$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $4fda53d1ed38be80$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $0897e54e36555b02$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $92475c01b5771461$var$globalHandlerLog(type) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $92475c01b5771461$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $65d42e3833054e5c$export$c69a9a0313b03bb1)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $92475c01b5771461$var$getHubAndOptions() {
    const hub = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)();
    const client = hub.getClient();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return [
        hub,
        options.stackParser,
        options.attachStacktrace
    ];
}




const $e7b79edf6d653394$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ class $e7b79edf6d653394$export$f1a018517668e6d3 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'TryCatch';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $e7b79edf6d653394$export$f1a018517668e6d3.id;
    }
    /** JSDoc */ /**
   * @inheritDoc
   */ constructor(options){
        $e7b79edf6d653394$export$f1a018517668e6d3.prototype.__init.call(this);
        this._options = {
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true,
            ...options
        };
    }
    /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */ setupOnce() {
        if (this._options.setTimeout) (0, $c7598308515e5ce6$export$9563e054e6f787fb)((0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81), 'setTimeout', $e7b79edf6d653394$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $c7598308515e5ce6$export$9563e054e6f787fb)((0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81), 'setInterval', $e7b79edf6d653394$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $c7598308515e5ce6$export$9563e054e6f787fb)((0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81), 'requestAnimationFrame', $e7b79edf6d653394$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81)) (0, $c7598308515e5ce6$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $e7b79edf6d653394$var$_wrapXHR);
        const eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $e7b79edf6d653394$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($e7b79edf6d653394$var$_wrapEventTarget);
        }
    }
}
$e7b79edf6d653394$export$f1a018517668e6d3.__initStatic();
/** JSDoc */ function $e7b79edf6d653394$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $f376c6a2c7a06d65$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $469cba5b454ec853$export$aad197c7121a6651)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e7b79edf6d653394$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $f376c6a2c7a06d65$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $469cba5b454ec853$export$aad197c7121a6651)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $e7b79edf6d653394$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $c7598308515e5ce6$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $469cba5b454ec853$export$aad197c7121a6651)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $c7598308515e5ce6$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $469cba5b454ec853$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $f376c6a2c7a06d65$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $e7b79edf6d653394$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $c7598308515e5ce6$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $f376c6a2c7a06d65$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $469cba5b454ec853$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $f376c6a2c7a06d65$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $469cba5b454ec853$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $c7598308515e5ce6$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}






const $83b669a06cbff663$var$DEFAULT_KEY = 'cause';
const $83b669a06cbff663$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ class $83b669a06cbff663$export$8d1e60aaf616fb4f {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'LinkedErrors';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $83b669a06cbff663$export$8d1e60aaf616fb4f.id;
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        $83b669a06cbff663$export$8d1e60aaf616fb4f.prototype.__init.call(this);
        this._key = options.key || $83b669a06cbff663$var$DEFAULT_KEY;
        this._limit = options.limit || $83b669a06cbff663$var$DEFAULT_LIMIT;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        const client = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getClient();
        if (!client) return;
        (0, $287ad5dd047650ab$export$8e4e25f54d456511)((event, hint)=>{
            const self = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getIntegration($83b669a06cbff663$export$8d1e60aaf616fb4f);
            return self ? $83b669a06cbff663$export$7bd713d0612d8839(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
        });
    }
}
$83b669a06cbff663$export$8d1e60aaf616fb4f.__initStatic();
/**
 * @inheritDoc
 */ function $83b669a06cbff663$export$7bd713d0612d8839(parser, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $4fda53d1ed38be80$export$49034edbe6b62415)(hint.originalException, Error)) return event;
    const linkedErrors = $83b669a06cbff663$export$e4e3ecf6f8f76c75(parser, limit, hint.originalException, key);
    event.exception.values = [
        ...linkedErrors,
        ...event.exception.values
    ];
    return event;
}
/**
 * JSDOC
 */ function $83b669a06cbff663$export$e4e3ecf6f8f76c75(parser, limit, error, key, stack = []) {
    if (!(0, $4fda53d1ed38be80$export$49034edbe6b62415)(error[key], Error) || stack.length + 1 >= limit) return stack;
    const exception = (0, $598e5a2a43d22dd5$export$a6c2d27607295951)(parser, error[key]);
    return $83b669a06cbff663$export$e4e3ecf6f8f76c75(parser, limit, error[key], key, [
        exception,
        ...stack
    ]);
}




/** HttpContext integration collects information about HTTP request headers */ class $9871cd36460cec0a$export$5d2ee9a544b09a94 {
    constructor(){
        $9871cd36460cec0a$export$5d2ee9a544b09a94.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'HttpContext';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $9871cd36460cec0a$export$5d2ee9a544b09a94.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        (0, $287ad5dd047650ab$export$8e4e25f54d456511)((event)=>{
            if ((0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getIntegration($9871cd36460cec0a$export$5d2ee9a544b09a94)) {
                // if none of the information we want exists, don't bother
                if (!(0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).navigator && !(0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).location && !(0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).document) return event;
                // grab as much info as exists and add it to the event
                const url = event.request && event.request.url || (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).location && (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).location.href;
                const { referrer: referrer } = (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).document || {};
                const { userAgent: userAgent } = (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).navigator || {};
                const headers = {
                    ...event.request && event.request.headers,
                    ...referrer && {
                        Referer: referrer
                    },
                    ...userAgent && {
                        'User-Agent': userAgent
                    }
                };
                const request = {
                    ...event.request,
                    ...url && {
                        url: url
                    },
                    headers: headers
                };
                return {
                    ...event,
                    request: request
                };
            }
            return event;
        });
    }
}
$9871cd36460cec0a$export$5d2ee9a544b09a94.__initStatic();



/** Deduplication filter */ class $56c35e90bd12f18f$export$688d98c249d31ad3 {
    constructor(){
        $56c35e90bd12f18f$export$688d98c249d31ad3.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Dedupe';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $56c35e90bd12f18f$export$688d98c249d31ad3.id;
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ setupOnce(addGlobalEventProcessor, getCurrentHub) {
        const eventProcessor = (currentEvent)=>{
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            const self = getCurrentHub().getIntegration($56c35e90bd12f18f$export$688d98c249d31ad3);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($56c35e90bd12f18f$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        };
        eventProcessor.id = this.name;
        addGlobalEventProcessor(eventProcessor);
    }
}
$56c35e90bd12f18f$export$688d98c249d31ad3.__initStatic();
/** JSDoc */ function $56c35e90bd12f18f$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($56c35e90bd12f18f$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($56c35e90bd12f18f$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $56c35e90bd12f18f$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$56c35e90bd12f18f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$56c35e90bd12f18f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $56c35e90bd12f18f$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $56c35e90bd12f18f$var$_getExceptionFromEvent(previousEvent);
    const currentException = $56c35e90bd12f18f$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$56c35e90bd12f18f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$56c35e90bd12f18f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $56c35e90bd12f18f$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $56c35e90bd12f18f$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $56c35e90bd12f18f$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $56c35e90bd12f18f$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $56c35e90bd12f18f$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $56c35e90bd12f18f$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}



// global reference to slice
const $3d91f8440bdc0dd2$var$UNKNOWN_FUNCTION = '?';
const $3d91f8440bdc0dd2$var$OPERA10_PRIORITY = 10;
const $3d91f8440bdc0dd2$var$OPERA11_PRIORITY = 20;
const $3d91f8440bdc0dd2$var$CHROME_PRIORITY = 30;
const $3d91f8440bdc0dd2$var$WINJS_PRIORITY = 40;
const $3d91f8440bdc0dd2$var$GECKO_PRIORITY = 50;
function $3d91f8440bdc0dd2$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $3d91f8440bdc0dd2$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $3d91f8440bdc0dd2$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $3d91f8440bdc0dd2$var$chrome = (line)=>{
    const parts = $3d91f8440bdc0dd2$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $3d91f8440bdc0dd2$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $3d91f8440bdc0dd2$var$extractSafariExtensionDetails(parts[1] || $3d91f8440bdc0dd2$var$UNKNOWN_FUNCTION, parts[2]);
        return $3d91f8440bdc0dd2$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $3d91f8440bdc0dd2$export$263a749fff749872 = [
    $3d91f8440bdc0dd2$var$CHROME_PRIORITY,
    $3d91f8440bdc0dd2$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $3d91f8440bdc0dd2$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $3d91f8440bdc0dd2$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $3d91f8440bdc0dd2$var$gecko = (line)=>{
    const parts = $3d91f8440bdc0dd2$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $3d91f8440bdc0dd2$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $3d91f8440bdc0dd2$var$UNKNOWN_FUNCTION;
        [func, filename] = $3d91f8440bdc0dd2$var$extractSafariExtensionDetails(func, filename);
        return $3d91f8440bdc0dd2$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $3d91f8440bdc0dd2$export$cdba47a5dd2804d = [
    $3d91f8440bdc0dd2$var$GECKO_PRIORITY,
    $3d91f8440bdc0dd2$var$gecko
];
const $3d91f8440bdc0dd2$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $3d91f8440bdc0dd2$var$winjs = (line)=>{
    const parts = $3d91f8440bdc0dd2$var$winjsRegex.exec(line);
    return parts ? $3d91f8440bdc0dd2$var$createFrame(parts[2], parts[1] || $3d91f8440bdc0dd2$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $3d91f8440bdc0dd2$export$179460296da408e8 = [
    $3d91f8440bdc0dd2$var$WINJS_PRIORITY,
    $3d91f8440bdc0dd2$var$winjs
];
const $3d91f8440bdc0dd2$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $3d91f8440bdc0dd2$var$opera10 = (line)=>{
    const parts = $3d91f8440bdc0dd2$var$opera10Regex.exec(line);
    return parts ? $3d91f8440bdc0dd2$var$createFrame(parts[2], parts[3] || $3d91f8440bdc0dd2$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $3d91f8440bdc0dd2$export$f892b52c880ffc7a = [
    $3d91f8440bdc0dd2$var$OPERA10_PRIORITY,
    $3d91f8440bdc0dd2$var$opera10
];
const $3d91f8440bdc0dd2$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $3d91f8440bdc0dd2$var$opera11 = (line)=>{
    const parts = $3d91f8440bdc0dd2$var$opera11Regex.exec(line);
    return parts ? $3d91f8440bdc0dd2$var$createFrame(parts[5], parts[3] || parts[4] || $3d91f8440bdc0dd2$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $3d91f8440bdc0dd2$export$af11af13f09fb0dc = [
    $3d91f8440bdc0dd2$var$OPERA11_PRIORITY,
    $3d91f8440bdc0dd2$var$opera11
];
const $3d91f8440bdc0dd2$export$7197c0fe6554c079 = [
    $3d91f8440bdc0dd2$export$263a749fff749872,
    $3d91f8440bdc0dd2$export$cdba47a5dd2804d,
    $3d91f8440bdc0dd2$export$179460296da408e8
];
const $3d91f8440bdc0dd2$export$2b2b997d81bf3907 = (0, $469cba5b454ec853$export$a5739666fb2d03d4)(...$3d91f8440bdc0dd2$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $3d91f8440bdc0dd2$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $3d91f8440bdc0dd2$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $9acd7c4282f15325$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $9acd7c4282f15325$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $9acd7c4282f15325$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $9acd7c4282f15325$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $9acd7c4282f15325$export$6c91fec22056810a(limits, category, now = Date.now()) {
    return $9acd7c4282f15325$export$b89fc7b2e4c799e7(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $9acd7c4282f15325$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories] = limit.split(':', 2);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';'))updatedRateLimits[category] = now + delay;
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $9acd7c4282f15325$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $91bce79f5f93f755$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $73f700349fff73af$export$78e43115b553f358)(new (0, $1e4a101170c0db5c$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $73f700349fff73af$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $73f700349fff73af$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


const $7856001ae23d5ab2$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $7856001ae23d5ab2$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $91bce79f5f93f755$export$85a4f67f852183e6)(options.bufferSize || $7856001ae23d5ab2$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $c4b30a4fb2276f64$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const envelopeItemDataCategory = (0, $c4b30a4fb2276f64$export$b11169581eeaf237)(type);
            if ((0, $9acd7c4282f15325$export$6c91fec22056810a)(rateLimits, envelopeItemDataCategory)) {
                const event = $7856001ae23d5ab2$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $73f700349fff73af$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $c4b30a4fb2276f64$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $c4b30a4fb2276f64$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $7856001ae23d5ab2$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $c4b30a4fb2276f64$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $c4b30a4fb2276f64$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $9acd7c4282f15325$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $1e4a101170c0db5c$export$5949942ba2a7c0e2)) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $73f700349fff73af$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $7856001ae23d5ab2$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}





let $2e8d5d4b3b873e14$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $2e8d5d4b3b873e14$export$8be2119ce08e3379() {
    if ($2e8d5d4b3b873e14$var$cachedFetchImpl) return $2e8d5d4b3b873e14$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $1ce49bc5e7b0f93c$export$18cf36ed71d733e7)((0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).fetch)) return $2e8d5d4b3b873e14$var$cachedFetchImpl = (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).fetch.bind((0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81));
    const document = (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $2e8d5d4b3b873e14$var$cachedFetchImpl = fetchImpl.bind((0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $2e8d5d4b3b873e14$export$d499686d2dd738c6() {
    $2e8d5d4b3b873e14$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $0484be08247304ae$export$b2311068c46d7cc8(options, nativeFetch = (0, $2e8d5d4b3b873e14$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $2e8d5d4b3b873e14$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $73f700349fff73af$export$78e43115b553f358)(e);
        }
    }
    return (0, $7856001ae23d5ab2$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $644e8b01ca49c81c$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $644e8b01ca49c81c$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $73f700349fff73af$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $644e8b01ca49c81c$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $7856001ae23d5ab2$export$d09f50d9ab7f7b69)(options, makeRequest);
}


const $3c7607181e767dbb$export$5ef831fccfce35e5 = [
    new (0, $1531605be0a97434$exports).InboundFilters(),
    new (0, $1531605be0a97434$exports).FunctionToString(),
    new (0, $e7b79edf6d653394$export$f1a018517668e6d3)(),
    new (0, $0046a6cdf462bbd3$export$2dc68d50d56fbbd)(),
    new (0, $92475c01b5771461$export$204155decbc90e5a)(),
    new (0, $83b669a06cbff663$export$8d1e60aaf616fb4f)(),
    new (0, $56c35e90bd12f18f$export$688d98c249d31ad3)(),
    new (0, $9871cd36460cec0a$export$5d2ee9a544b09a94)()
];
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $3c7607181e767dbb$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $3c7607181e767dbb$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $469cba5b454ec853$export$1d5cf88b347146d4)(options.stackParser || (0, $3d91f8440bdc0dd2$export$2b2b997d81bf3907)),
        integrations: (0, $86a52df17259f1ae$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $1ce49bc5e7b0f93c$export$edf3cb81fd7d2a3e)() ? (0, $0484be08247304ae$export$b2311068c46d7cc8) : (0, $644e8b01ca49c81c$export$5e1441cee30d5a39))
    };
    (0, $38804fa7098439d7$export$5333c3f1c58d9bc1)((0, $47e48a95232a43ea$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $3c7607181e767dbb$var$startSessionTracking();
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $3c7607181e767dbb$export$3a8fd680da42627b(options = {}, hub = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)()) {
    // doesn't work without a document (React Native)
    if (!(0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).document) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error('Global document not defined in showReportDialog call');
        return;
    }
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) options.eventId = hub.lastEventId();
    const script = (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.src = (0, $15e69d1b7a564e51$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const injectionPoint = (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).document.head || (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error('Not injecting report dialog. No injection point found in HTML');
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $3c7607181e767dbb$export$5d4e9fd7fac8e617() {
    return (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $3c7607181e767dbb$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $3c7607181e767dbb$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function $3c7607181e767dbb$export$4909b86c8034bf73(timeout) {
    const client = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getClient();
    if (client) return client.flush(timeout);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return (0, $73f700349fff73af$export$1fda8aa4d135f8aa)(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function $3c7607181e767dbb$export$8360e631d277ea4d(timeout) {
    const client = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getClient();
    if (client) return client.close(timeout);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $73f700349fff73af$export$1fda8aa4d135f8aa)(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3c7607181e767dbb$export$4997ffc0176396a6(fn) {
    return (0, $f376c6a2c7a06d65$export$4997ffc0176396a6)(fn)();
}
function $3c7607181e767dbb$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $3c7607181e767dbb$var$startSessionTracking() {
    if (typeof (0, $f376c6a2c7a06d65$export$56d8a8a25bd48b81).document === 'undefined') {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    const hub = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $3c7607181e767dbb$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $d43610efe653d8f1$export$285b9172a3741fb7)('history', ({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $3c7607181e767dbb$var$startSessionOnHub((0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)());
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $3c7607181e767dbb$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getClient();
    if (client) client.captureUserFeedback(feedback);
}


/**
 * Inits the React SDK
 */ function $efb8670e6decf1f1$export$2cd8252107eb640b(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
        name: 'sentry.javascript.react',
        packages: [
            {
                name: 'npm:@sentry/react',
                version: (0, $69b89edc7cd573a3$export$31499a9cd224b78c)
            }
        ],
        version: (0, $69b89edc7cd573a3$export$31499a9cd224b78c)
    };
    (0, $3c7607181e767dbb$export$2cd8252107eb640b)(options);
}



var $6CbLG = parcelRequire("6CbLG");
var $9avcL = parcelRequire("9avcL");
var $iZbO1 = parcelRequire("iZbO1");

var $8LKEK = parcelRequire("8LKEK");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $af5eb29b940bd654$var$WINDOW = (0, $9avcL.GLOBAL_OBJ);
const $af5eb29b940bd654$var$REPLAY_SESSION_KEY = 'sentryReplaySession';
const $af5eb29b940bd654$var$REPLAY_EVENT_NAME = 'replay_event';
const $af5eb29b940bd654$var$UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';
// The idle limit for a session after which recording is paused.
const $af5eb29b940bd654$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $af5eb29b940bd654$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
// The maximum length of a session
const $af5eb29b940bd654$var$MAX_SESSION_LIFE = 3600000; // 60 minutes in ms
/** Default flush delays */ const $af5eb29b940bd654$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $af5eb29b940bd654$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $af5eb29b940bd654$var$BUFFER_CHECKOUT_TIME = 60000;
const $af5eb29b940bd654$var$RETRY_BASE_INTERVAL = 5000;
const $af5eb29b940bd654$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $af5eb29b940bd654$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $af5eb29b940bd654$var$CONSOLE_ARG_MAX_SIZE = 5000;
var $af5eb29b940bd654$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($af5eb29b940bd654$var$NodeType$1 || ($af5eb29b940bd654$var$NodeType$1 = {}));
function $af5eb29b940bd654$var$isElement(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $af5eb29b940bd654$var$isShadowRoot(n) {
    const host = n === null || n === void 0 ? void 0 : n.host;
    return Boolean(host && host.shadowRoot && host.shadowRoot === n);
}
function $af5eb29b940bd654$var$isInputTypeMasked({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName.toLowerCase() === 'option') tagName = 'select';
    const actualType = typeof type === 'string' ? type.toLowerCase() : undefined;
    return maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType] || actualType === 'password' || tagName === 'input' && !type && maskInputOptions['text'];
}
function $af5eb29b940bd654$var$hasInputMaskOptions({ tagName: tagName, type: type, maskInputOptions: maskInputOptions, maskInputSelector: maskInputSelector }) {
    return maskInputSelector || $af5eb29b940bd654$var$isInputTypeMasked({
        maskInputOptions: maskInputOptions,
        tagName: tagName,
        type: type
    });
}
function $af5eb29b940bd654$var$maskInputValue({ input: input, maskInputSelector: maskInputSelector, unmaskInputSelector: unmaskInputSelector, maskInputOptions: maskInputOptions, tagName: tagName, type: type, value: value, maskInputFn: maskInputFn }) {
    let text = value || '';
    if (unmaskInputSelector && input.matches(unmaskInputSelector)) return text;
    if (input.hasAttribute('data-rr-is-password')) type = 'password';
    if ($af5eb29b940bd654$var$isInputTypeMasked({
        maskInputOptions: maskInputOptions,
        tagName: tagName,
        type: type
    }) || maskInputSelector && input.matches(maskInputSelector)) {
        if (maskInputFn) text = maskInputFn(text);
        else text = '*'.repeat(text.length);
    }
    return text;
}
const $af5eb29b940bd654$var$ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function $af5eb29b940bd654$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $af5eb29b940bd654$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$af5eb29b940bd654$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $af5eb29b940bd654$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute('data-rr-is-password') ? 'password' : type ? type.toLowerCase() : null;
}
function $af5eb29b940bd654$var$getInputValue(el, tagName, type) {
    typeof type === 'string' && type.toLowerCase();
    if (tagName === 'INPUT' && (type === 'radio' || type === 'checkbox')) return el.getAttribute('value') || '';
    return el.value;
}
let $af5eb29b940bd654$var$_id = 1;
const $af5eb29b940bd654$var$tagNameRegex = new RegExp('[^a-z0-9-_:]');
const $af5eb29b940bd654$var$IGNORED_NODE = -2;
function $af5eb29b940bd654$var$defaultMaskFn(str) {
    return str ? str.replace(/[\S]/g, '*') : '';
}
function $af5eb29b940bd654$var$genId() {
    return $af5eb29b940bd654$var$_id++;
}
function $af5eb29b940bd654$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return 'form';
    const processedTagName = element.tagName.toLowerCase().trim();
    if ($af5eb29b940bd654$var$tagNameRegex.test(processedTagName)) return 'div';
    return processedTagName;
}
function $af5eb29b940bd654$var$getCssRulesString(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? Array.from(rules).map($af5eb29b940bd654$var$getCssRuleString).join('') : null;
    } catch (error) {
        return null;
    }
}
function $af5eb29b940bd654$var$getCssRuleString(rule) {
    let cssStringified = rule.cssText;
    if ($af5eb29b940bd654$var$isCSSImportRule(rule)) try {
        cssStringified = $af5eb29b940bd654$var$getCssRulesString(rule.styleSheet) || cssStringified;
    } catch (_a) {}
    return $af5eb29b940bd654$var$validateStringifiedCssRule(cssStringified);
}
function $af5eb29b940bd654$var$validateStringifiedCssRule(cssStringified) {
    if (cssStringified.indexOf(':') > -1) {
        const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
        return cssStringified.replace(regex, '$1\\$2');
    }
    return cssStringified;
}
function $af5eb29b940bd654$var$isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function $af5eb29b940bd654$var$stringifyStyleSheet(sheet) {
    return sheet.cssRules ? Array.from(sheet.cssRules).map((rule)=>rule.cssText ? $af5eb29b940bd654$var$validateStringifiedCssRule(rule.cssText) : '').join('') : '';
}
function $af5eb29b940bd654$var$extractOrigin(url) {
    let origin = '';
    if (url.indexOf('//') > -1) origin = url.split('/').slice(0, 3).join('/');
    else origin = url.split('/')[0];
    origin = origin.split('?')[0];
    return origin;
}
let $af5eb29b940bd654$var$canvasService;
let $af5eb29b940bd654$var$canvasCtx;
const $af5eb29b940bd654$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $af5eb29b940bd654$var$RELATIVE_PATH = /^(?!www\.|(?:http|ftp)s?:\/\/|[A-Za-z]:\\|\/\/|#).*/;
const $af5eb29b940bd654$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $af5eb29b940bd654$var$absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace($af5eb29b940bd654$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || '';
        if (!filePath) return origin;
        if (!$af5eb29b940bd654$var$RELATIVE_PATH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($af5eb29b940bd654$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === '/') return `url(${maybeQuote}${$af5eb29b940bd654$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split('/');
        const parts = filePath.split('/');
        stack.pop();
        for (const part of parts){
            if (part === '.') continue;
            else if (part === '..') stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join('/')}${maybeQuote})`;
    });
}
const $af5eb29b940bd654$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $af5eb29b940bd654$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $af5eb29b940bd654$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        let match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    let output = [];
    while(true){
        collectCharacters($af5eb29b940bd654$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($af5eb29b940bd654$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = $af5eb29b940bd654$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = '';
            url = $af5eb29b940bd654$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                let c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === '(') inParens = true;
                } else if (c === ')') inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
function $af5eb29b940bd654$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') return attributeValue;
    const a = doc.createElement('a');
    a.href = attributeValue;
    return a.href;
}
function $af5eb29b940bd654$var$isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function $af5eb29b940bd654$var$getHref() {
    const a = document.createElement('a');
    a.href = '';
    return a.href;
}
function $af5eb29b940bd654$var$transformAttribute(doc, element, _tagName, _name, value, maskAllText, unmaskTextSelector, maskTextFn) {
    if (!value) return value;
    const name = _name.toLowerCase();
    const tagName = _tagName.toLowerCase();
    if (name === 'src' || name === 'href') return $af5eb29b940bd654$var$absoluteToDoc(doc, value);
    else if (name === 'xlink:href' && value[0] !== '#') return $af5eb29b940bd654$var$absoluteToDoc(doc, value);
    else if (name === 'background' && (tagName === 'table' || tagName === 'td' || tagName === 'th')) return $af5eb29b940bd654$var$absoluteToDoc(doc, value);
    else if (name === 'srcset') return $af5eb29b940bd654$var$getAbsoluteSrcsetString(doc, value);
    else if (name === 'style') return $af5eb29b940bd654$var$absoluteToStylesheet(value, $af5eb29b940bd654$var$getHref());
    else if (tagName === 'object' && name === 'data') return $af5eb29b940bd654$var$absoluteToDoc(doc, value);
    else if (maskAllText && $af5eb29b940bd654$var$_shouldMaskAttribute(element, name, tagName, unmaskTextSelector)) return maskTextFn ? maskTextFn(value) : $af5eb29b940bd654$var$defaultMaskFn(value);
    return value;
}
function $af5eb29b940bd654$var$_shouldMaskAttribute(element, attribute, tagName, unmaskTextSelector) {
    if (unmaskTextSelector && element.matches(unmaskTextSelector)) return false;
    return [
        'placeholder',
        'title',
        'aria-label'
    ].indexOf(attribute) > -1 || tagName === 'input' && attribute === 'value' && element.hasAttribute('type') && [
        'submit',
        'button'
    ].indexOf(element.getAttribute('type').toLowerCase()) > -1;
}
function $af5eb29b940bd654$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    if (unblockSelector && element.matches(unblockSelector)) return false;
    if (typeof blockClass === 'string') {
        if (element.classList.contains(blockClass)) return true;
    } else for(let eIndex = 0; eIndex < element.classList.length; eIndex++){
        const className = element.classList[eIndex];
        if (blockClass.test(className)) return true;
    }
    if (blockSelector) return element.matches(blockSelector);
    return false;
}
function $af5eb29b940bd654$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText) {
    if (!node) return false;
    if (node.nodeType !== node.ELEMENT_NODE) return $af5eb29b940bd654$var$needMaskingText(node.parentNode, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText);
    if (unmaskTextSelector) {
        if (node.matches(unmaskTextSelector) || node.closest(unmaskTextSelector)) return false;
    }
    if (maskAllText) return true;
    if (typeof maskTextClass === 'string') {
        if (node.classList.contains(maskTextClass)) return true;
    } else for(let eIndex = 0; eIndex < node.classList.length; eIndex++){
        const className = node.classList[eIndex];
        if (maskTextClass.test(className)) return true;
    }
    if (maskTextSelector) {
        if (node.matches(maskTextSelector)) return true;
    }
    return $af5eb29b940bd654$var$needMaskingText(node.parentNode, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText);
}
function $af5eb29b940bd654$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = 'about:blank';
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === '') {
        setTimeout(listener, 0);
        return;
    }
    iframeEl.addEventListener('load', listener);
}
function $af5eb29b940bd654$var$serializeNode(n, options) {
    var _a;
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskTextClass: maskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputSelector: maskInputSelector, unmaskInputSelector: unmaskInputSelector, maskAllText: maskAllText, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn } = options;
    let rootId;
    if (doc.__sn) {
        const docId = doc.__sn.id;
        rootId = docId === 1 ? undefined : docId;
    }
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') return {
                type: $af5eb29b940bd654$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode,
                rootId: rootId
            };
            else return {
                type: $af5eb29b940bd654$var$NodeType$1.Document,
                childNodes: [],
                rootId: rootId
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $af5eb29b940bd654$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            const needBlock = $af5eb29b940bd654$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
            const tagName = $af5eb29b940bd654$var$getValidTagName(n);
            let attributes = {};
            for (const { name: name, value: value } of Array.from(n.attributes))if (!$af5eb29b940bd654$var$skipAttribute(tagName, name)) attributes[name] = $af5eb29b940bd654$var$transformAttribute(doc, n, tagName, name, value, maskAllText, unmaskTextSelector, maskTextFn);
            if (tagName === 'link' && inlineStylesheet) {
                const stylesheet = Array.from(doc.styleSheets).find((s)=>{
                    return s.href === n.href;
                });
                let cssText = null;
                if (stylesheet) cssText = $af5eb29b940bd654$var$getCssRulesString(stylesheet);
                if (cssText) {
                    delete attributes.rel;
                    delete attributes.href;
                    attributes._cssText = $af5eb29b940bd654$var$absoluteToStylesheet(cssText, stylesheet.href);
                }
            }
            if (tagName === 'style' && n.sheet && !(n.innerText || n.textContent || '').trim().length) {
                const cssText = $af5eb29b940bd654$var$getCssRulesString(n.sheet);
                if (cssText) attributes._cssText = $af5eb29b940bd654$var$absoluteToStylesheet(cssText, $af5eb29b940bd654$var$getHref());
            }
            if (tagName === 'input' || tagName === 'textarea' || tagName === 'select' || tagName === 'option') {
                const el = n;
                const type = $af5eb29b940bd654$var$getInputType(el);
                const value = $af5eb29b940bd654$var$getInputValue(el, tagName.toUpperCase(), type);
                const checked = n.checked;
                if (type !== 'submit' && type !== 'button' && value) attributes.value = $af5eb29b940bd654$var$maskInputValue({
                    input: el,
                    type: type,
                    tagName: tagName,
                    value: value,
                    maskInputSelector: maskInputSelector,
                    unmaskInputSelector: unmaskInputSelector,
                    maskInputOptions: maskInputOptions,
                    maskInputFn: maskInputFn
                });
                if (checked) attributes.checked = checked;
            }
            if (tagName === 'option') {
                if (n.selected && !maskInputOptions['select']) attributes.selected = true;
                else delete attributes.selected;
            }
            if (tagName === 'canvas' && recordCanvas) {
                if (n.__context === '2d') {
                    if (!$af5eb29b940bd654$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                } else if (!('__context' in n)) {
                    const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    const blankCanvas = document.createElement('canvas');
                    blankCanvas.width = n.width;
                    blankCanvas.height = n.height;
                    const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
                }
            }
            if (tagName === 'img' && inlineImages) {
                if (!$af5eb29b940bd654$var$canvasService) {
                    $af5eb29b940bd654$var$canvasService = doc.createElement('canvas');
                    $af5eb29b940bd654$var$canvasCtx = $af5eb29b940bd654$var$canvasService.getContext('2d');
                }
                const image = n;
                const oldValue = image.crossOrigin;
                image.crossOrigin = 'anonymous';
                const recordInlineImage = ()=>{
                    try {
                        $af5eb29b940bd654$var$canvasService.width = image.naturalWidth;
                        $af5eb29b940bd654$var$canvasService.height = image.naturalHeight;
                        $af5eb29b940bd654$var$canvasCtx.drawImage(image, 0, 0);
                        attributes.rr_dataURL = $af5eb29b940bd654$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    } catch (err) {
                        console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
                    }
                    oldValue ? attributes.crossOrigin = oldValue : delete attributes.crossOrigin;
                };
                if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                else image.onload = recordInlineImage;
            }
            if (tagName === 'audio' || tagName === 'video') {
                attributes.rr_mediaState = n.paused ? 'paused' : 'played';
                attributes.rr_mediaCurrentTime = n.currentTime;
            }
            if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
            if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
            if (needBlock) {
                const { width: width, height: height } = n.getBoundingClientRect();
                attributes = {
                    class: attributes.class,
                    rr_width: `${width}px`,
                    rr_height: `${height}px`
                };
            }
            if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
                if (!n.contentDocument) attributes.rr_src = attributes.src;
                delete attributes.src;
            }
            return {
                type: $af5eb29b940bd654$var$NodeType$1.Element,
                tagName: tagName,
                attributes: attributes,
                childNodes: [],
                isSVG: $af5eb29b940bd654$var$isSVGElement(n) || undefined,
                needBlock: needBlock,
                rootId: rootId
            };
        case n.TEXT_NODE:
            const parentTagName = n.parentNode && n.parentNode.tagName;
            let textContent = n.textContent;
            const isStyle = parentTagName === 'STYLE' ? true : undefined;
            const isScript = parentTagName === 'SCRIPT' ? true : undefined;
            if (isStyle && textContent) {
                try {
                    if (n.nextSibling || n.previousSibling) ;
                    else if ((_a = n.parentNode.sheet) === null || _a === void 0 ? void 0 : _a.cssRules) textContent = $af5eb29b940bd654$var$stringifyStyleSheet(n.parentNode.sheet);
                } catch (err) {
                    console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
                }
                textContent = $af5eb29b940bd654$var$absoluteToStylesheet(textContent, $af5eb29b940bd654$var$getHref());
            }
            if (isScript) textContent = 'SCRIPT_PLACEHOLDER';
            if (parentTagName === 'TEXTAREA' && textContent) textContent = '';
            else if (parentTagName === 'OPTION' && textContent) {
                const option = n.parentNode;
                textContent = $af5eb29b940bd654$var$maskInputValue({
                    input: option,
                    type: null,
                    tagName: parentTagName,
                    value: textContent,
                    maskInputSelector: maskInputSelector,
                    unmaskInputSelector: unmaskInputSelector,
                    maskInputOptions: maskInputOptions,
                    maskInputFn: maskInputFn
                });
            } else if (!isStyle && !isScript && $af5eb29b940bd654$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText) && textContent) textContent = maskTextFn ? maskTextFn(textContent) : $af5eb29b940bd654$var$defaultMaskFn(textContent);
            return {
                type: $af5eb29b940bd654$var$NodeType$1.Text,
                textContent: textContent || '',
                isStyle: isStyle,
                rootId: rootId
            };
        case n.CDATA_SECTION_NODE:
            return {
                type: $af5eb29b940bd654$var$NodeType$1.CDATA,
                textContent: '',
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $af5eb29b940bd654$var$NodeType$1.Comment,
                textContent: n.textContent || '',
                rootId: rootId
            };
        default:
            return false;
    }
}
function $af5eb29b940bd654$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return '';
    else return maybeAttr.toLowerCase();
}
function $af5eb29b940bd654$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $af5eb29b940bd654$var$NodeType$1.Comment) return true;
    else if (sn.type === $af5eb29b940bd654$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === 'script' || sn.tagName === 'link' && (sn.attributes.rel === 'preload' || sn.attributes.rel === 'modulepreload') && sn.attributes.as === 'script' || sn.tagName === 'link' && sn.attributes.rel === 'prefetch' && typeof sn.attributes.href === 'string' && sn.attributes.href.endsWith('.js'))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon' || sn.tagName === 'meta' && ($af5eb29b940bd654$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'application-name' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.rel) === 'icon' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.rel) === 'shortcut icon'))) return true;
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords && $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($af5eb29b940bd654$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'pinterest')) return true;
            else if (slimDOMOptions.headMetaRobots && ($af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'robots' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'googlebot' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'bingbot')) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes['http-equiv'] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'author' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'generator' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'framework' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'publisher' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'progid' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'google-site-verification' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'yandex-verification' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'csrf-token' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'p:domain_verify' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'verify-v1' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'verification' || $af5eb29b940bd654$var$lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) return true;
        }
    }
    return false;
}
function $af5eb29b940bd654$var$serializeNodeWithId(n, options) {
    const { doc: doc, map: map, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskTextClass: maskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputSelector: maskInputSelector, unmaskInputSelector: unmaskInputSelector, maskAllText: maskAllText, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $af5eb29b940bd654$var$serializeNode(n, {
        doc: doc,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputSelector: maskInputSelector,
        unmaskInputSelector: unmaskInputSelector,
        maskAllText: maskAllText,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    let id;
    if ('__sn' in n) id = n.__sn.id;
    else if ($af5eb29b940bd654$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $af5eb29b940bd654$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length) id = $af5eb29b940bd654$var$IGNORED_NODE;
    else id = $af5eb29b940bd654$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    n.__sn = serializedNode;
    if (id === $af5eb29b940bd654$var$IGNORED_NODE) return null;
    map[id] = n;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $af5eb29b940bd654$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        if (n.shadowRoot) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $af5eb29b940bd654$var$NodeType$1.Document || serializedNode.type === $af5eb29b940bd654$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && _serializedNode.type === $af5eb29b940bd654$var$NodeType$1.Element && _serializedNode.tagName === 'head') preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            map: map,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            maskAllText: maskAllText,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $af5eb29b940bd654$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($af5eb29b940bd654$var$isElement(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $af5eb29b940bd654$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                serializedChildNode.isShadow = true;
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $af5eb29b940bd654$var$isShadowRoot(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $af5eb29b940bd654$var$NodeType$1.Element && serializedNode.tagName === 'iframe') $af5eb29b940bd654$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $af5eb29b940bd654$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                map: map,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputSelector: maskInputSelector,
                unmaskInputSelector: unmaskInputSelector,
                maskAllText: maskAllText,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    return serializedNode;
}
function $af5eb29b940bd654$var$snapshot(n, options) {
    const { blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskTextClass: maskTextClass = 'rr-mask', maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskInputSelector: maskInputSelector = null, unmaskInputSelector: unmaskInputSelector = null, maskAllText: maskAllText = false, maskAllInputs: maskAllInputs = false, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const idNodeMap = {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === 'all',
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return [
        $af5eb29b940bd654$var$serializeNodeWithId(n, {
            doc: n,
            map: idNodeMap,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: false,
            inlineStylesheet: inlineStylesheet,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            maskAllText: maskAllText,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        }),
        idNodeMap
    ];
}
function $af5eb29b940bd654$var$skipAttribute(tagName, attributeName, value) {
    return (tagName === 'video' || tagName === 'audio') && attributeName === 'autoplay';
}
var $af5eb29b940bd654$var$EventType$1;
(function(EventType) {
    EventType[EventType["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType[EventType["Load"] = 1] = "Load";
    EventType[EventType["FullSnapshot"] = 2] = "FullSnapshot";
    EventType[EventType["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType[EventType["Meta"] = 4] = "Meta";
    EventType[EventType["Custom"] = 5] = "Custom";
    EventType[EventType["Plugin"] = 6] = "Plugin";
})($af5eb29b940bd654$var$EventType$1 || ($af5eb29b940bd654$var$EventType$1 = {}));
var $af5eb29b940bd654$var$IncrementalSource;
(function(IncrementalSource) {
    IncrementalSource[IncrementalSource["Mutation"] = 0] = "Mutation";
    IncrementalSource[IncrementalSource["MouseMove"] = 1] = "MouseMove";
    IncrementalSource[IncrementalSource["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource[IncrementalSource["Scroll"] = 3] = "Scroll";
    IncrementalSource[IncrementalSource["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource[IncrementalSource["Input"] = 5] = "Input";
    IncrementalSource[IncrementalSource["TouchMove"] = 6] = "TouchMove";
    IncrementalSource[IncrementalSource["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource[IncrementalSource["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource[IncrementalSource["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource[IncrementalSource["Font"] = 10] = "Font";
    IncrementalSource[IncrementalSource["Log"] = 11] = "Log";
    IncrementalSource[IncrementalSource["Drag"] = 12] = "Drag";
    IncrementalSource[IncrementalSource["StyleDeclaration"] = 13] = "StyleDeclaration";
})($af5eb29b940bd654$var$IncrementalSource || ($af5eb29b940bd654$var$IncrementalSource = {}));
var $af5eb29b940bd654$var$MouseInteractions;
(function(MouseInteractions) {
    MouseInteractions[MouseInteractions["MouseUp"] = 0] = "MouseUp";
    MouseInteractions[MouseInteractions["MouseDown"] = 1] = "MouseDown";
    MouseInteractions[MouseInteractions["Click"] = 2] = "Click";
    MouseInteractions[MouseInteractions["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions[MouseInteractions["DblClick"] = 4] = "DblClick";
    MouseInteractions[MouseInteractions["Focus"] = 5] = "Focus";
    MouseInteractions[MouseInteractions["Blur"] = 6] = "Blur";
    MouseInteractions[MouseInteractions["TouchStart"] = 7] = "TouchStart";
    MouseInteractions[MouseInteractions["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions[MouseInteractions["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions[MouseInteractions["TouchCancel"] = 10] = "TouchCancel";
})($af5eb29b940bd654$var$MouseInteractions || ($af5eb29b940bd654$var$MouseInteractions = {}));
var $af5eb29b940bd654$var$CanvasContext;
(function(CanvasContext) {
    CanvasContext[CanvasContext["2D"] = 0] = "2D";
    CanvasContext[CanvasContext["WebGL"] = 1] = "WebGL";
    CanvasContext[CanvasContext["WebGL2"] = 2] = "WebGL2";
})($af5eb29b940bd654$var$CanvasContext || ($af5eb29b940bd654$var$CanvasContext = {}));
var $af5eb29b940bd654$var$MediaInteractions;
(function(MediaInteractions) {
    MediaInteractions[MediaInteractions["Play"] = 0] = "Play";
    MediaInteractions[MediaInteractions["Pause"] = 1] = "Pause";
    MediaInteractions[MediaInteractions["Seeked"] = 2] = "Seeked";
    MediaInteractions[MediaInteractions["VolumeChange"] = 3] = "VolumeChange";
})($af5eb29b940bd654$var$MediaInteractions || ($af5eb29b940bd654$var$MediaInteractions = {}));
var $af5eb29b940bd654$var$ReplayerEvents;
(function(ReplayerEvents) {
    ReplayerEvents["Start"] = "start";
    ReplayerEvents["Pause"] = "pause";
    ReplayerEvents["Resume"] = "resume";
    ReplayerEvents["Resize"] = "resize";
    ReplayerEvents["Finish"] = "finish";
    ReplayerEvents["FullsnapshotRebuilded"] = "fullsnapshot-rebuilded";
    ReplayerEvents["LoadStylesheetStart"] = "load-stylesheet-start";
    ReplayerEvents["LoadStylesheetEnd"] = "load-stylesheet-end";
    ReplayerEvents["SkipStart"] = "skip-start";
    ReplayerEvents["SkipEnd"] = "skip-end";
    ReplayerEvents["MouseInteraction"] = "mouse-interaction";
    ReplayerEvents["EventCast"] = "event-cast";
    ReplayerEvents["CustomEvent"] = "custom-event";
    ReplayerEvents["Flush"] = "flush";
    ReplayerEvents["StateChange"] = "state-change";
    ReplayerEvents["PlayBack"] = "play-back";
})($af5eb29b940bd654$var$ReplayerEvents || ($af5eb29b940bd654$var$ReplayerEvents = {}));
function $af5eb29b940bd654$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
function $af5eb29b940bd654$var$createMirror() {
    return {
        map: {},
        getId (n) {
            if (!n || !n.__sn) return -1;
            return n.__sn.id;
        },
        getNode (id) {
            return this.map[id] || null;
        },
        removeNodeFromMap (n) {
            const id = n.__sn && n.__sn.id;
            delete this.map[id];
            if (n.childNodes) n.childNodes.forEach((child)=>this.removeNodeFromMap(child));
        },
        has (id) {
            return this.map.hasOwnProperty(id);
        },
        reset () {
            this.map = {};
        }
    };
}
const $af5eb29b940bd654$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $af5eb29b940bd654$var$_mirror = {
    map: {},
    getId () {
        console.error($af5eb29b940bd654$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($af5eb29b940bd654$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($af5eb29b940bd654$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($af5eb29b940bd654$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($af5eb29b940bd654$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) $af5eb29b940bd654$var$_mirror = new Proxy($af5eb29b940bd654$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === 'map') console.error($af5eb29b940bd654$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $af5eb29b940bd654$var$throttle(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(arg) {
        let now = Date.now();
        if (!previous && options.leading === false) previous = now;
        let remaining = wait - (now - previous);
        let context = this;
        let args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $af5eb29b940bd654$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$af5eb29b940bd654$var$hookSetter(target, key, original || {}, true);
}
function $af5eb29b940bd654$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (_a) {
        return ()=>{};
    }
}
function $af5eb29b940bd654$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $af5eb29b940bd654$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $af5eb29b940bd654$var$isBlocked(node, blockClass, blockSelector, unblockSelector) {
    if (!node) return false;
    if (node.nodeType === node.ELEMENT_NODE) {
        let needBlock = false;
        const needUnblock = unblockSelector && node.matches(unblockSelector);
        if (typeof blockClass === 'string') {
            if (node.closest !== undefined) needBlock = !needUnblock && node.closest('.' + blockClass) !== null;
            else needBlock = !needUnblock && node.classList.contains(blockClass);
        } else !needUnblock && node.classList.forEach((className)=>{
            if (blockClass.test(className)) needBlock = true;
        });
        if (!needBlock && blockSelector) needBlock = node.matches(blockSelector);
        return !needUnblock && needBlock || $af5eb29b940bd654$var$isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
    }
    if (node.nodeType === node.TEXT_NODE) return $af5eb29b940bd654$var$isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
    return $af5eb29b940bd654$var$isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
}
function $af5eb29b940bd654$var$isIgnored(n) {
    if ('__sn' in n) return n.__sn.id === $af5eb29b940bd654$var$IGNORED_NODE;
    return false;
}
function $af5eb29b940bd654$var$isAncestorRemoved(target, mirror) {
    if ($af5eb29b940bd654$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $af5eb29b940bd654$var$isAncestorRemoved(target.parentNode, mirror);
}
function $af5eb29b940bd654$var$isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $af5eb29b940bd654$var$polyfill(win = window) {
    if ('NodeList' in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = function contains(node) {
        if (!(0 in arguments)) throw new TypeError('1 argument is required');
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $af5eb29b940bd654$var$isIframeINode(node) {
    if ('__sn' in node) return node.__sn.type === $af5eb29b940bd654$var$NodeType$1.Element && node.__sn.tagName === 'iframe';
    return false;
}
function $af5eb29b940bd654$var$hasShadowRoot(n) {
    return Boolean(n === null || n === void 0 ? void 0 : n.shadowRoot);
}
function $af5eb29b940bd654$var$isNodeInLinkedList(n) {
    return '__ln' in n;
}
class $af5eb29b940bd654$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
    }
    get(position) {
        if (position >= this.length) throw new Error('Position outside of list range');
        let current = this.head;
        for(let index = 0; index < position; index++)current = (current === null || current === void 0 ? void 0 : current.next) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $af5eb29b940bd654$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $af5eb29b940bd654$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $af5eb29b940bd654$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
function $af5eb29b940bd654$var$isINode(n) {
    return '__sn' in n;
}
class $af5eb29b940bd654$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addList = new $af5eb29b940bd654$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $af5eb29b940bd654$var$IGNORED_NODE;
                while(nextId === $af5eb29b940bd654$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                var _a, _b, _c, _d, _e;
                const shadowHost = n.getRootNode ? (_a = n.getRootNode()) === null || _a === void 0 ? void 0 : _a.host : null;
                let rootShadowHost = shadowHost;
                while((_c = (_b = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _b === void 0 ? void 0 : _b.call(rootShadowHost)) === null || _c === void 0 ? void 0 : _c.host)rootShadowHost = ((_e = (_d = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _d === void 0 ? void 0 : _d.call(rootShadowHost)) === null || _e === void 0 ? void 0 : _e.host) || null;
                const notInDoc = !this.doc.contains(n) && (!rootShadowHost || !this.doc.contains(rootShadowHost));
                if (!n.parentNode || notInDoc) return;
                const parentId = $af5eb29b940bd654$var$isShadowRoot(n.parentNode) ? this.mirror.getId(shadowHost) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                let sn = $af5eb29b940bd654$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    map: this.mirror.map,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    maskInputSelector: this.maskInputSelector,
                    unmaskInputSelector: this.unmaskInputSelector,
                    skipChild: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskAllText: this.maskAllText,
                    maskInputOptions: this.maskInputOptions,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($af5eb29b940bd654$var$isIframeINode(currentN)) this.iframeManager.addIframe(currentN);
                        if ($af5eb29b940bd654$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, document);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    }
                });
                if (sn) adds.push({
                    parentId: parentId,
                    nextId: nextId,
                    node: sn
                });
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($af5eb29b940bd654$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$af5eb29b940bd654$var$isAncestorInSet(this.droppedSet, n) && !$af5eb29b940bd654$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($af5eb29b940bd654$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) for(let index = addList.length - 1; index >= 0; index--){
                    const _node = addList.get(index);
                    if (_node) {
                        const parentId = this.mirror.getId(_node.value.parentNode);
                        const nextId = getNextId(_node.value);
                        if (parentId !== -1 && nextId !== -1) {
                            node = _node;
                            break;
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>({
                        id: this.mirror.getId(attribute.node),
                        attributes: attribute.attributes
                    })).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($af5eb29b940bd654$var$isIgnored(m.target)) return;
            switch(m.type){
                case 'characterData':
                    {
                        const value = m.target.textContent;
                        if (!$af5eb29b940bd654$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) && value !== m.oldValue) this.texts.push({
                            value: $af5eb29b940bd654$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value) : value.replace(/[\S]/g, '*') : value,
                            node: m.target
                        });
                        break;
                    }
                case 'attributes':
                    {
                        const target = m.target;
                        let value = target.getAttribute(m.attributeName);
                        if (m.attributeName === 'value') value = $af5eb29b940bd654$var$maskInputValue({
                            input: target,
                            maskInputSelector: this.maskInputSelector,
                            unmaskInputSelector: this.unmaskInputSelector,
                            maskInputOptions: this.maskInputOptions,
                            tagName: target.tagName,
                            type: target.getAttribute('type'),
                            value: value,
                            maskInputFn: this.maskInputFn
                        });
                        if ($af5eb29b940bd654$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) || value === m.oldValue) return;
                        let item = this.attributes.find((a)=>a.node === m.target);
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {}
                            };
                            this.attributes.push(item);
                        }
                        if (m.attributeName === 'type' && target.tagName === 'INPUT' && (m.oldValue || '').toLowerCase() === 'password') target.setAttribute('data-rr-is-password', 'true');
                        if (m.attributeName === 'style') {
                            const old = this.doc.createElement('span');
                            if (m.oldValue) old.setAttribute('style', m.oldValue);
                            if (item.attributes.style === undefined || item.attributes.style === null) item.attributes.style = {};
                            try {
                                const styleObj = item.attributes.style;
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === '') styleObj[pname] = newValue;
                                        else styleObj[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    }
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === '') styleObj[pname] = false;
                            } catch (error) {
                                console.warn('[rrweb] Error when parsing update to style attribute:', error);
                            }
                        } else {
                            const element = m.target;
                            item.attributes[m.attributeName] = $af5eb29b940bd654$var$transformAttribute(this.doc, element, element.tagName, m.attributeName, value, this.maskAllText, this.unmaskTextSelector, this.maskTextFn);
                        }
                        break;
                    }
                case 'childList':
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $af5eb29b940bd654$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($af5eb29b940bd654$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) || $af5eb29b940bd654$var$isIgnored(n)) return;
                        if (this.addedSet.has(n)) {
                            $af5eb29b940bd654$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($af5eb29b940bd654$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$af5eb29b940bd654$var$moveKey(nodeId, parentId)]) $af5eb29b940bd654$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $af5eb29b940bd654$var$isShadowRoot(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (target && $af5eb29b940bd654$var$isBlocked(target, this.blockClass, this.blockSelector, this.unblockSelector)) return;
            if ($af5eb29b940bd654$var$isINode(n)) {
                if ($af5eb29b940bd654$var$isIgnored(n)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && $af5eb29b940bd654$var$isINode(target)) targetId = target.__sn.id;
                if (targetId) this.movedMap[$af5eb29b940bd654$var$moveKey(n.__sn.id, targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$af5eb29b940bd654$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector)) n.childNodes.forEach((childN)=>this.genAdds(childN));
        };
    }
    init(options) {
        [
            'mutationCb',
            'blockClass',
            'blockSelector',
            'unblockSelector',
            'maskTextClass',
            'maskTextSelector',
            'unmaskTextSelector',
            'maskInputSelector',
            'unmaskInputSelector',
            'inlineStylesheet',
            'maskAllText',
            'maskInputOptions',
            'maskTextFn',
            'maskInputFn',
            'recordCanvas',
            'inlineImages',
            'slimDOMOptions',
            'doc',
            'mirror',
            'iframeManager',
            'shadowDomManager',
            'canvasManager'
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $af5eb29b940bd654$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$af5eb29b940bd654$var$deepDelete(addsSet, childN));
}
function $af5eb29b940bd654$var$isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $af5eb29b940bd654$var$isParentRemoved(removes, parentNode, mirror);
}
function $af5eb29b940bd654$var$isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $af5eb29b940bd654$var$isAncestorInSet(set, parentNode);
}
const $af5eb29b940bd654$var$callbackWrapper = (cb)=>{
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            try {
                error.__rrweb__ = true;
            } catch (_a) {}
            throw error;
        }
    };
    return rrwebWrapped;
};
const $af5eb29b940bd654$var$mutationBuffers = [];
function $af5eb29b940bd654$var$getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ('path' in event && event.path.length) return event.path[0];
    } catch (_a) {}
    return event && event.target;
}
function $af5eb29b940bd654$var$initMutationObserver(options, rootEl) {
    var _a, _b;
    const mutationBuffer = new $af5eb29b940bd654$var$MutationBuffer();
    $af5eb29b940bd654$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = (_b = (_a = window === null || window === void 0 ? void 0 : window.Zone) === null || _a === void 0 ? void 0 : _a.__symbol__) === null || _b === void 0 ? void 0 : _b.call(_a, 'MutationObserver');
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($af5eb29b940bd654$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $af5eb29b940bd654$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $af5eb29b940bd654$var$throttle((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        $af5eb29b940bd654$var$callbackWrapper(mousemoveCb)(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }, callbackThreshold);
    const updatePosition = $af5eb29b940bd654$var$throttle((evt)=>{
        const target = $af5eb29b940bd654$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $af5eb29b940bd654$var$isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = Date.now();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: Date.now() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? $af5eb29b940bd654$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $af5eb29b940bd654$var$IncrementalSource.MouseMove : $af5eb29b940bd654$var$IncrementalSource.TouchMove);
    }, threshold, {
        trailing: false
    });
    const handlers = [
        $af5eb29b940bd654$var$on('mousemove', $af5eb29b940bd654$var$callbackWrapper(updatePosition), doc),
        $af5eb29b940bd654$var$on('touchmove', $af5eb29b940bd654$var$callbackWrapper(updatePosition), doc),
        $af5eb29b940bd654$var$on('drag', $af5eb29b940bd654$var$callbackWrapper(updatePosition), doc)
    ];
    return $af5eb29b940bd654$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $af5eb29b940bd654$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $af5eb29b940bd654$var$getEventTarget(event);
            if ($af5eb29b940bd654$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
            const e = $af5eb29b940bd654$var$isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $af5eb29b940bd654$var$callbackWrapper(mouseInteractionCb)({
                type: $af5eb29b940bd654$var$MouseInteractions[eventKey],
                id: id,
                x: clientX,
                y: clientY
            });
        };
    };
    Object.keys($af5eb29b940bd654$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false).forEach((eventKey)=>{
        const eventName = eventKey.toLowerCase();
        const handler = $af5eb29b940bd654$var$callbackWrapper(getHandler(eventKey));
        handlers.push($af5eb29b940bd654$var$on(eventName, handler, doc));
    });
    return $af5eb29b940bd654$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $af5eb29b940bd654$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $af5eb29b940bd654$var$throttle((evt)=>{
        const target = $af5eb29b940bd654$var$getEventTarget(evt);
        if (!target || $af5eb29b940bd654$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
        const id = mirror.getId(target);
        if (target === doc) {
            const scrollEl = doc.scrollingElement || doc.documentElement;
            $af5eb29b940bd654$var$callbackWrapper(scrollCb)({
                id: id,
                x: scrollEl.scrollLeft,
                y: scrollEl.scrollTop
            });
        } else $af5eb29b940bd654$var$callbackWrapper(scrollCb)({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }, sampling.scroll || 100);
    return $af5eb29b940bd654$var$on('scroll', $af5eb29b940bd654$var$callbackWrapper(updatePosition), doc);
}
function $af5eb29b940bd654$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $af5eb29b940bd654$var$throttle(()=>{
        const height = $af5eb29b940bd654$var$getWindowHeight();
        const width = $af5eb29b940bd654$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            $af5eb29b940bd654$var$callbackWrapper(viewportResizeCb)({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }, 200);
    return $af5eb29b940bd654$var$on('resize', $af5eb29b940bd654$var$callbackWrapper(updateDimension), window);
}
function $af5eb29b940bd654$var$wrapEventWithUserTriggeredFlag(v, enable) {
    const value = Object.assign({}, v);
    if (!enable) delete value.userTriggered;
    return value;
}
const $af5eb29b940bd654$var$INPUT_TAGS = [
    'INPUT',
    'TEXTAREA',
    'SELECT'
];
const $af5eb29b940bd654$var$lastInputValueMap = new WeakMap();
function $af5eb29b940bd654$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputSelector: maskInputSelector, unmaskInputSelector: unmaskInputSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput }) {
    function eventHandler(event) {
        let target = $af5eb29b940bd654$var$getEventTarget(event);
        const tagName = target && target.tagName;
        const userTriggered = event.isTrusted;
        if (tagName === 'OPTION') target = target.parentElement;
        if (!target || !tagName || $af5eb29b940bd654$var$INPUT_TAGS.indexOf(tagName) < 0 || $af5eb29b940bd654$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
        const el = target;
        const type = $af5eb29b940bd654$var$getInputType(el);
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        let text = $af5eb29b940bd654$var$getInputValue(el, tagName, type);
        let isChecked = false;
        if (type === 'radio' || type === 'checkbox') isChecked = target.checked;
        if ($af5eb29b940bd654$var$hasInputMaskOptions({
            maskInputOptions: maskInputOptions,
            maskInputSelector: maskInputSelector,
            tagName: tagName,
            type: type
        })) text = $af5eb29b940bd654$var$maskInputValue({
            input: el,
            maskInputOptions: maskInputOptions,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            tagName: tagName,
            type: type,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, $af5eb29b940bd654$var$callbackWrapper($af5eb29b940bd654$var$wrapEventWithUserTriggeredFlag)({
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        }, userTriggeredOnInput));
        const name = target.name;
        if (type === 'radio' && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $af5eb29b940bd654$var$maskInputValue({
                    input: el,
                    maskInputOptions: maskInputOptions,
                    maskInputSelector: maskInputSelector,
                    unmaskInputSelector: unmaskInputSelector,
                    tagName: tagName,
                    type: type,
                    value: $af5eb29b940bd654$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, $af5eb29b940bd654$var$callbackWrapper($af5eb29b940bd654$var$wrapEventWithUserTriggeredFlag)({
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                }, userTriggeredOnInput));
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $af5eb29b940bd654$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $af5eb29b940bd654$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            inputCb(Object.assign(Object.assign({}, v), {
                id: id
            }));
        }
    }
    const events = sampling.input === 'last' ? [
        'change'
    ] : [
        'input',
        'change'
    ];
    const handlers = events.map((eventName)=>$af5eb29b940bd654$var$on(eventName, $af5eb29b940bd654$var$callbackWrapper(eventHandler), doc));
    const propertyDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    const hookProperties = [
        [
            HTMLInputElement.prototype,
            'value'
        ],
        [
            HTMLInputElement.prototype,
            'checked'
        ],
        [
            HTMLSelectElement.prototype,
            'value'
        ],
        [
            HTMLTextAreaElement.prototype,
            'value'
        ],
        [
            HTMLSelectElement.prototype,
            'selectedIndex'
        ],
        [
            HTMLOptionElement.prototype,
            'selected'
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$af5eb29b940bd654$var$hookSetter(p[0], p[1], {
            set () {
                $af5eb29b940bd654$var$callbackWrapper(eventHandler)({
                    target: this
                });
            }
        })));
    return $af5eb29b940bd654$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $af5eb29b940bd654$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($af5eb29b940bd654$var$hasNestedCSSRule('CSSGroupingRule') && childRule.parentRule instanceof CSSGroupingRule || $af5eb29b940bd654$var$hasNestedCSSRule('CSSMediaRule') && childRule.parentRule instanceof CSSMediaRule || $af5eb29b940bd654$var$hasNestedCSSRule('CSSSupportsRule') && childRule.parentRule instanceof CSSSupportsRule || $af5eb29b940bd654$var$hasNestedCSSRule('CSSConditionRule') && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $af5eb29b940bd654$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $af5eb29b940bd654$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const id = mirror.getId(thisArg.ownerNode);
            if (id !== -1) styleSheetRuleCb({
                id: id,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $af5eb29b940bd654$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const id = mirror.getId(thisArg.ownerNode);
            if (id !== -1) styleSheetRuleCb({
                id: id,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const supportedNestedCSSRuleTypes = {};
    if ($af5eb29b940bd654$var$canMonkeyPatchNestedCSSRule('CSSGroupingRule')) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($af5eb29b940bd654$var$canMonkeyPatchNestedCSSRule('CSSMediaRule')) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($af5eb29b940bd654$var$canMonkeyPatchNestedCSSRule('CSSConditionRule')) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($af5eb29b940bd654$var$canMonkeyPatchNestedCSSRule('CSSSupportsRule')) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $af5eb29b940bd654$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const id = mirror.getId(thisArg.parentStyleSheet.ownerNode);
                if (id !== -1) styleSheetRuleCb({
                    id: id,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$af5eb29b940bd654$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $af5eb29b940bd654$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const id = mirror.getId(thisArg.parentStyleSheet.ownerNode);
                if (id !== -1) styleSheetRuleCb({
                    id: id,
                    removes: [
                        {
                            index: [
                                ...$af5eb29b940bd654$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $af5eb29b940bd654$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $af5eb29b940bd654$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $af5eb29b940bd654$var$callbackWrapper((target, thisArg, argumentsList)=>{
            var _a, _b;
            const [property, value, priority] = argumentsList;
            const id = mirror.getId((_b = (_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
            if (id !== -1) styleDeclarationCb({
                id: id,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $af5eb29b940bd654$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $af5eb29b940bd654$var$callbackWrapper((target, thisArg, argumentsList)=>{
            var _a, _b;
            const [property] = argumentsList;
            const id = mirror.getId((_b = (_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
            if (id !== -1) styleDeclarationCb({
                id: id,
                remove: {
                    property: property
                },
                index: $af5eb29b940bd654$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $af5eb29b940bd654$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $af5eb29b940bd654$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling }) {
    const handler = (type)=>$af5eb29b940bd654$var$throttle($af5eb29b940bd654$var$callbackWrapper((event)=>{
            const target = $af5eb29b940bd654$var$getEventTarget(event);
            if (!target || $af5eb29b940bd654$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
            const { currentTime: currentTime, volume: volume, muted: muted } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted
            });
        }), sampling.media || 500);
    const handlers = [
        $af5eb29b940bd654$var$on('play', handler(0)),
        $af5eb29b940bd654$var$on('pause', handler(1)),
        $af5eb29b940bd654$var$on('seeked', handler(2)),
        $af5eb29b940bd654$var$on('volumechange', handler(3))
    ];
    return $af5eb29b940bd654$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $af5eb29b940bd654$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== 'string',
            descriptors: descriptors,
            fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $af5eb29b940bd654$var$patch(doc.fonts, 'add', function(original) {
        return function(fontFace) {
            setTimeout(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }, 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $af5eb29b940bd654$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $af5eb29b940bd654$var$mergeHooks(o, hooks) {
    const { mutationCb: mutationCb, mousemoveCb: mousemoveCb, mouseInteractionCb: mouseInteractionCb, scrollCb: scrollCb, viewportResizeCb: viewportResizeCb, inputCb: inputCb, mediaInteractionCb: mediaInteractionCb, styleSheetRuleCb: styleSheetRuleCb, styleDeclarationCb: styleDeclarationCb, canvasMutationCb: canvasMutationCb, fontCb: fontCb } = o;
    o.mutationCb = (...p)=>{
        if (hooks.mutation) hooks.mutation(...p);
        mutationCb(...p);
    };
    o.mousemoveCb = (...p)=>{
        if (hooks.mousemove) hooks.mousemove(...p);
        mousemoveCb(...p);
    };
    o.mouseInteractionCb = (...p)=>{
        if (hooks.mouseInteraction) hooks.mouseInteraction(...p);
        mouseInteractionCb(...p);
    };
    o.scrollCb = (...p)=>{
        if (hooks.scroll) hooks.scroll(...p);
        scrollCb(...p);
    };
    o.viewportResizeCb = (...p)=>{
        if (hooks.viewportResize) hooks.viewportResize(...p);
        viewportResizeCb(...p);
    };
    o.inputCb = (...p)=>{
        if (hooks.input) hooks.input(...p);
        inputCb(...p);
    };
    o.mediaInteractionCb = (...p)=>{
        if (hooks.mediaInteaction) hooks.mediaInteaction(...p);
        mediaInteractionCb(...p);
    };
    o.styleSheetRuleCb = (...p)=>{
        if (hooks.styleSheetRule) hooks.styleSheetRule(...p);
        styleSheetRuleCb(...p);
    };
    o.styleDeclarationCb = (...p)=>{
        if (hooks.styleDeclaration) hooks.styleDeclaration(...p);
        styleDeclarationCb(...p);
    };
    o.canvasMutationCb = (...p)=>{
        if (hooks.canvasMutation) hooks.canvasMutation(...p);
        canvasMutationCb(...p);
    };
    o.fontCb = (...p)=>{
        if (hooks.font) hooks.font(...p);
        fontCb(...p);
    };
}
function $af5eb29b940bd654$var$initObservers(o, hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    $af5eb29b940bd654$var$mergeHooks(o, hooks);
    const mutationObserver = $af5eb29b940bd654$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $af5eb29b940bd654$var$initMoveObserver(o);
    const mouseInteractionHandler = $af5eb29b940bd654$var$initMouseInteractionObserver(o);
    const scrollHandler = $af5eb29b940bd654$var$initScrollObserver(o);
    const viewportResizeHandler = $af5eb29b940bd654$var$initViewportResizeObserver(o);
    const inputHandler = $af5eb29b940bd654$var$initInputObserver(o);
    const mediaInteractionHandler = $af5eb29b940bd654$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $af5eb29b940bd654$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const styleDeclarationObserver = $af5eb29b940bd654$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $af5eb29b940bd654$var$initFontObserver(o) : ()=>{};
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $af5eb29b940bd654$var$callbackWrapper(()=>{
        $af5eb29b940bd654$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        try {
            styleSheetObserver();
            styleDeclarationObserver();
        } catch (e) {}
        fontObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $af5eb29b940bd654$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== 'undefined';
}
function $af5eb29b940bd654$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== 'undefined' && window[prop].prototype && 'insertRule' in window[prop].prototype && 'deleteRule' in window[prop].prototype);
}
class $af5eb29b940bd654$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.mutationCb = options.mutationCb;
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        var _a;
        this.mutationCb({
            adds: [
                {
                    parentId: iframeEl.__sn.id,
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        (_a = this.loadListener) === null || _a === void 0 || _a.call(this, iframeEl);
    }
}
class $af5eb29b940bd654$var$ShadowDomManager {
    constructor(options){
        this.restorePatches = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        const manager = this;
        this.restorePatches.push($af5eb29b940bd654$var$patch(HTMLElement.prototype, 'attachShadow', function(original) {
            return function() {
                const shadowRoot = original.apply(this, arguments);
                if (this.shadowRoot) manager.addShadowRoot(this.shadowRoot, this.ownerDocument);
                return shadowRoot;
            };
        }));
    }
    addShadowRoot(shadowRoot, doc) {
        $af5eb29b940bd654$var$initMutationObserver(Object.assign(Object.assign({}, this.bypassOptions), {
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }), shadowRoot);
        $af5eb29b940bd654$var$initScrollObserver(Object.assign(Object.assign({}, this.bypassOptions), {
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
    }
    observeAttachShadow(iframeElement) {
        if (iframeElement.contentWindow) {
            const manager = this;
            this.restorePatches.push($af5eb29b940bd654$var$patch(iframeElement.contentWindow.HTMLElement.prototype, 'attachShadow', function(original) {
                return function() {
                    const shadowRoot = original.apply(this, arguments);
                    if (this.shadowRoot) manager.addShadowRoot(this.shadowRoot, iframeElement.contentDocument);
                    return shadowRoot;
                };
            }));
        }
    }
    reset() {
        this.restorePatches.forEach((restorePatch)=>restorePatch());
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $af5eb29b940bd654$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $af5eb29b940bd654$var$initCanvas2DMutationObserver(cb, win, blockClass, unblockSelector, blockSelector, mirror) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D)try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== 'function') continue;
        const restoreHandler = $af5eb29b940bd654$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
            return function(...args) {
                if (!$af5eb29b940bd654$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector)) setTimeout(()=>{
                    const recordArgs = [
                        ...args
                    ];
                    if (prop === 'drawImage') {
                        if (recordArgs[0] && recordArgs[0] instanceof HTMLCanvasElement) {
                            const canvas = recordArgs[0];
                            const ctx = canvas.getContext('2d');
                            let imgd = ctx === null || ctx === void 0 ? void 0 : ctx.getImageData(0, 0, canvas.width, canvas.height);
                            let pix = imgd === null || imgd === void 0 ? void 0 : imgd.data;
                            recordArgs[0] = JSON.stringify(pix);
                        }
                    }
                    cb(this.canvas, {
                        type: $af5eb29b940bd654$var$CanvasContext['2D'],
                        property: prop,
                        args: recordArgs
                    });
                }, 0);
                return original.apply(this, args);
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        const hookHandler = $af5eb29b940bd654$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: $af5eb29b940bd654$var$CanvasContext['2D'],
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $af5eb29b940bd654$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector) {
    const handlers = [];
    try {
        const restoreHandler = $af5eb29b940bd654$var$patch(win.HTMLCanvasElement.prototype, 'getContext', function(original) {
            return function(contextType, ...args) {
                if (!$af5eb29b940bd654$var$isBlocked(this, blockClass, blockSelector, unblockSelector)) {
                    if (!('__context' in this)) this.__context = contextType;
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        console.error('failed to patch HTMLCanvasElement.prototype.getContext');
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
/*
 * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var $af5eb29b940bd654$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $af5eb29b940bd654$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(var $af5eb29b940bd654$var$i = 0; $af5eb29b940bd654$var$i < $af5eb29b940bd654$var$chars.length; $af5eb29b940bd654$var$i++)$af5eb29b940bd654$var$lookup[$af5eb29b940bd654$var$chars.charCodeAt($af5eb29b940bd654$var$i)] = $af5eb29b940bd654$var$i;
var $af5eb29b940bd654$var$encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $af5eb29b940bd654$var$chars[bytes[i] >> 2];
        base64 += $af5eb29b940bd654$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $af5eb29b940bd654$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $af5eb29b940bd654$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $af5eb29b940bd654$var$webGLVarMap = new Map();
function $af5eb29b940bd654$var$variableListFor(ctx, ctor) {
    let contextMap = $af5eb29b940bd654$var$webGLVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        $af5eb29b940bd654$var$webGLVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
const $af5eb29b940bd654$var$saveWebGLVar = (value, win, ctx)=>{
    if (!value || !($af5eb29b940bd654$var$isInstanceOfWebGLObject(value, win) || typeof value === 'object')) return;
    const name = value.constructor.name;
    const list = $af5eb29b940bd654$var$variableListFor(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function $af5eb29b940bd654$var$serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map((arg)=>$af5eb29b940bd654$var$serializeArg(arg, win, ctx));
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = $af5eb29b940bd654$var$encode(value);
        return {
            rr_type: name,
            base64: base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $af5eb29b940bd654$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src: src } = value;
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $af5eb29b940bd654$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($af5eb29b940bd654$var$isInstanceOfWebGLObject(value, win) || typeof value === 'object') {
        const name = value.constructor.name;
        const index = $af5eb29b940bd654$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index
        };
    }
    return value;
}
const $af5eb29b940bd654$var$serializeArgs = (args, win, ctx)=>{
    return [
        ...args
    ].map((arg)=>$af5eb29b940bd654$var$serializeArg(arg, win, ctx));
};
const $af5eb29b940bd654$var$isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        'WebGLActiveInfo',
        'WebGLBuffer',
        'WebGLFramebuffer',
        'WebGLProgram',
        'WebGLRenderbuffer',
        'WebGLShader',
        'WebGLShaderPrecisionFormat',
        'WebGLTexture',
        'WebGLUniformLocation',
        'WebGLVertexArrayObject',
        'WebGLVertexArrayObjectOES'
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === 'function');
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function $af5eb29b940bd654$var$patchGLPrototype(prototype, type, cb, blockClass, unblockSelector, blockSelector, mirror, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props)try {
        if (typeof prototype[prop] !== 'function') continue;
        const restoreHandler = $af5eb29b940bd654$var$patch(prototype, prop, function(original) {
            return function(...args) {
                const result = original.apply(this, args);
                $af5eb29b940bd654$var$saveWebGLVar(result, win, prototype);
                if (!$af5eb29b940bd654$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector)) {
                    const id = mirror.getId(this.canvas);
                    const recordArgs = $af5eb29b940bd654$var$serializeArgs([
                        ...args
                    ], win, prototype);
                    const mutation = {
                        type: type,
                        property: prop,
                        args: recordArgs
                    };
                    cb(this.canvas, mutation);
                }
                return result;
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        const hookHandler = $af5eb29b940bd654$var$hookSetter(prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: type,
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return handlers;
}
function $af5eb29b940bd654$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
    const handlers = [];
    handlers.push(...$af5eb29b940bd654$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $af5eb29b940bd654$var$CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    if (typeof win.WebGL2RenderingContext !== 'undefined') handlers.push(...$af5eb29b940bd654$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $af5eb29b940bd654$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
class $af5eb29b940bd654$var$CanvasManager {
    reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    constructor(options){
        this.pendingCanvasMutations = new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.frozen = false;
        this.locked = false;
        this.processMutation = function(target, mutation) {
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (options.recordCanvas === true) this.initCanvasMutationObserver(options.win, options.blockClass, options.blockSelector, options.unblockSelector);
    }
    initCanvasMutationObserver(win, blockClass, unblockSelector, blockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        const canvasContextReset = $af5eb29b940bd654$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector);
        const canvas2DReset = $af5eb29b940bd654$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        const canvasWebGL1and2Reset = $af5eb29b940bd654$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        this.resetObservers = ()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    }
    startPendingCanvasMutationFlusher() {
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const rest = $af5eb29b940bd654$var$__rest(value, [
                "type"
            ]);
            return rest;
        });
        const { type: type } = valuesWithType[0];
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
}
function $af5eb29b940bd654$var$wrapEvent(e) {
    return Object.assign(Object.assign({}, e), {
        timestamp: Date.now()
    });
}
let $af5eb29b940bd654$var$wrappedEmit;
let $af5eb29b940bd654$var$takeFullSnapshot;
const $af5eb29b940bd654$var$mirror = $af5eb29b940bd654$var$createMirror();
function $af5eb29b940bd654$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = 'rr-ignore', ignoreSelector: ignoreSelector = null, maskTextClass: maskTextClass = 'rr-mask', maskTextSelector: maskTextSelector = null, maskInputSelector: maskInputSelector = null, unmaskTextSelector: unmaskTextSelector = null, unmaskInputSelector: unmaskInputSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllText: maskAllText = false, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskInputFn: maskInputFn, maskTextFn: maskTextFn, hooks: hooks, packFn: packFn, sampling: sampling = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, onMutation: onMutation } = options;
    if (!emit) throw new Error('emit function is required');
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === 'all',
        headMetaDescKeywords: _slimDOMOptions === 'all'
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $af5eb29b940bd654$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn) e = packFn(e);
        return e;
    };
    $af5eb29b940bd654$var$wrappedEmit = (e, isCheckout)=>{
        var _a;
        if (((_a = $af5eb29b940bd654$var$mutationBuffers[0]) === null || _a === void 0 ? void 0 : _a.isFrozen()) && e.type !== $af5eb29b940bd654$var$EventType$1.FullSnapshot && !(e.type === $af5eb29b940bd654$var$EventType$1.IncrementalSnapshot && e.data.source === $af5eb29b940bd654$var$IncrementalSource.Mutation)) $af5eb29b940bd654$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        emit(eventProcessor(e), isCheckout);
        if (e.type === $af5eb29b940bd654$var$EventType$1.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $af5eb29b940bd654$var$EventType$1.IncrementalSnapshot) {
            if (e.data.source === $af5eb29b940bd654$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) $af5eb29b940bd654$var$takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
            type: $af5eb29b940bd654$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $af5eb29b940bd654$var$IncrementalSource.Mutation
            }, m)
        }));
    };
    const wrappedScrollEmit = (p)=>$af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
            type: $af5eb29b940bd654$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $af5eb29b940bd654$var$IncrementalSource.Scroll
            }, p)
        }));
    const wrappedCanvasMutationEmit = (p)=>$af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
            type: $af5eb29b940bd654$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $af5eb29b940bd654$var$IncrementalSource.CanvasMutation
            }, p)
        }));
    const iframeManager = new $af5eb29b940bd654$var$IframeManager({
        mutationCb: wrappedMutationEmit
    });
    const canvasManager = new $af5eb29b940bd654$var$CanvasManager({
        recordCanvas: recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        mirror: $af5eb29b940bd654$var$mirror
    });
    const shadowDomManager = new $af5eb29b940bd654$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllText: maskAllText,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            canvasManager: canvasManager
        },
        mirror: $af5eb29b940bd654$var$mirror
    });
    $af5eb29b940bd654$var$takeFullSnapshot = (isCheckout = false)=>{
        var _a, _b, _c, _d;
        $af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
            type: $af5eb29b940bd654$var$EventType$1.Meta,
            data: {
                href: window.location.href,
                width: $af5eb29b940bd654$var$getWindowWidth(),
                height: $af5eb29b940bd654$var$getWindowHeight()
            }
        }), isCheckout);
        $af5eb29b940bd654$var$mutationBuffers.forEach((buf)=>buf.lock());
        const [node, idNodeMap] = $af5eb29b940bd654$var$snapshot(document, {
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllText: maskAllText,
            maskAllInputs: maskInputOptions,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($af5eb29b940bd654$var$isIframeINode(n)) iframeManager.addIframe(n);
                if ($af5eb29b940bd654$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn('Failed to snapshot the document');
        $af5eb29b940bd654$var$mirror.map = idNodeMap;
        $af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
            type: $af5eb29b940bd654$var$EventType$1.FullSnapshot,
            data: {
                node: node,
                initialOffset: {
                    left: window.pageXOffset !== undefined ? window.pageXOffset : (document === null || document === void 0 ? void 0 : document.documentElement.scrollLeft) || ((_b = (_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.scrollLeft) || (document === null || document === void 0 ? void 0 : document.body.scrollLeft) || 0,
                    top: window.pageYOffset !== undefined ? window.pageYOffset : (document === null || document === void 0 ? void 0 : document.documentElement.scrollTop) || ((_d = (_c = document === null || document === void 0 ? void 0 : document.body) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.scrollTop) || (document === null || document === void 0 ? void 0 : document.body.scrollTop) || 0
                }
            }
        }));
        $af5eb29b940bd654$var$mutationBuffers.forEach((buf)=>buf.unlock());
    };
    try {
        const handlers = [];
        handlers.push($af5eb29b940bd654$var$on('DOMContentLoaded', ()=>{
            $af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
                type: $af5eb29b940bd654$var$EventType$1.DomContentLoaded,
                data: {}
            }));
        }));
        const observe = (doc)=>{
            var _a;
            return $af5eb29b940bd654$var$callbackWrapper($af5eb29b940bd654$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
                        type: $af5eb29b940bd654$var$EventType$1.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    })),
                mouseInteractionCb: (d)=>$af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
                        type: $af5eb29b940bd654$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $af5eb29b940bd654$var$IncrementalSource.MouseInteraction
                        }, d)
                    })),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
                        type: $af5eb29b940bd654$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $af5eb29b940bd654$var$IncrementalSource.ViewportResize
                        }, d)
                    })),
                inputCb: (v)=>$af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
                        type: $af5eb29b940bd654$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $af5eb29b940bd654$var$IncrementalSource.Input
                        }, v)
                    })),
                mediaInteractionCb: (p)=>$af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
                        type: $af5eb29b940bd654$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $af5eb29b940bd654$var$IncrementalSource.MediaInteraction
                        }, p)
                    })),
                styleSheetRuleCb: (r)=>$af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
                        type: $af5eb29b940bd654$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $af5eb29b940bd654$var$IncrementalSource.StyleSheetRule
                        }, r)
                    })),
                styleDeclarationCb: (r)=>$af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
                        type: $af5eb29b940bd654$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $af5eb29b940bd654$var$IncrementalSource.StyleDeclaration
                        }, r)
                    })),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
                        type: $af5eb29b940bd654$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $af5eb29b940bd654$var$IncrementalSource.Font
                        }, p)
                    })),
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputSelector: maskInputSelector,
                unmaskInputSelector: unmaskInputSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAllText: maskAllText,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                mirror: $af5eb29b940bd654$var$mirror,
                iframeManager: iframeManager,
                shadowDomManager: shadowDomManager,
                canvasManager: canvasManager,
                plugins: ((_a = plugins === null || plugins === void 0 ? void 0 : plugins.filter((p)=>p.observer)) === null || _a === void 0 ? void 0 : _a.map((p)=>({
                        observer: p.observer,
                        options: p.options,
                        callback: (payload)=>$af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
                                type: $af5eb29b940bd654$var$EventType$1.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            }))
                    }))) || []
            }, hooks);
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            $af5eb29b940bd654$var$takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === 'interactive' || document.readyState === 'complete') init();
        else handlers.push($af5eb29b940bd654$var$on('load', ()=>{
            $af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
                type: $af5eb29b940bd654$var$EventType$1.Load,
                data: {}
            }));
            init();
        }, window));
        return ()=>{
            handlers.forEach((h)=>h());
        };
    } catch (error) {
        console.warn(error);
    }
}
$af5eb29b940bd654$var$record.addCustomEvent = (tag, payload)=>{
    if (!$af5eb29b940bd654$var$wrappedEmit) throw new Error('please add custom event after start recording');
    $af5eb29b940bd654$var$wrappedEmit($af5eb29b940bd654$var$wrapEvent({
        type: $af5eb29b940bd654$var$EventType$1.Custom,
        data: {
            tag: tag,
            payload: payload
        }
    }));
};
$af5eb29b940bd654$var$record.freezePage = ()=>{
    $af5eb29b940bd654$var$mutationBuffers.forEach((buf)=>buf.freeze());
};
$af5eb29b940bd654$var$record.takeFullSnapshot = (isCheckout)=>{
    if (!$af5eb29b940bd654$var$takeFullSnapshot) throw new Error('please take full snapshot after start recording');
    $af5eb29b940bd654$var$takeFullSnapshot(isCheckout);
};
$af5eb29b940bd654$var$record.mirror = $af5eb29b940bd654$var$mirror;
/**
 * Create a breadcrumb for a replay.
 */ function $af5eb29b940bd654$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: 'default',
        ...breadcrumb
    };
}
var $af5eb29b940bd654$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($af5eb29b940bd654$var$NodeType || ($af5eb29b940bd654$var$NodeType = {}));
/* eslint-disable @typescript-eslint/naming-convention */ var $af5eb29b940bd654$var$EventType;
(function(EventType) {
    const DomContentLoaded = 0;
    EventType[EventType["DomContentLoaded"] = DomContentLoaded] = "DomContentLoaded";
    const Load = 1;
    EventType[EventType["Load"] = Load] = "Load";
    const FullSnapshot = 2;
    EventType[EventType["FullSnapshot"] = FullSnapshot] = "FullSnapshot";
    const IncrementalSnapshot = 3;
    EventType[EventType["IncrementalSnapshot"] = IncrementalSnapshot] = "IncrementalSnapshot";
    const Meta = 4;
    EventType[EventType["Meta"] = Meta] = "Meta";
    const Custom = 5;
    EventType[EventType["Custom"] = Custom] = "Custom";
    const Plugin = 6;
    EventType[EventType["Plugin"] = Plugin] = "Plugin";
})($af5eb29b940bd654$var$EventType || ($af5eb29b940bd654$var$EventType = {}));
/**
 * This is a partial copy of rrweb's eventWithTime type which only contains the properties
 * we specifcally need in the SDK.
 */ /**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $af5eb29b940bd654$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Add an event to the event buffer.
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ async function $af5eb29b940bd654$var$addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) // This implies that `_isEnabled` is false
    return null;
    if (replay.isPaused()) // Do not add to event buffer when recording is paused
    return null;
    const timestampInMs = $af5eb29b940bd654$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return null;
    try {
        if (isCheckout) replay.eventBuffer.clear();
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = typeof replayOptions.beforeAddRecordingEvent === 'function' && event.type === $af5eb29b940bd654$var$EventType.Custom ? replayOptions.beforeAddRecordingEvent(event) : event;
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error(error);
        await replay.stop('addEvent');
        const client = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getClient();
        if (client) client.recordDroppedEvent('internal_sdk_error', 'replay');
    }
}
/**
 * Add a breadcrumb event to replay.
 */ function $af5eb29b940bd654$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === 'sentry.transaction') return;
    if ([
        'ui.click',
        'ui.input'
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        $af5eb29b940bd654$var$addEvent(replay, {
            type: $af5eb29b940bd654$var$EventType$1.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: 'breadcrumb',
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $4cc0442f6ee1f737$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === 'console';
    });
}
/**
 * Detect a slow click on a button/a tag,
 * and potentially create a corresponding breadcrumb.
 */ function $af5eb29b940bd654$var$detectSlowClick(replay, config, clickBreadcrumb, node) {
    if ($af5eb29b940bd654$var$ignoreElement(node, config)) return;
    /*
    We consider a slow click a click on a button/a, which does not trigger one of:
     - DOM mutation
     - Scroll (within 100ms)
     Within the given threshold time.
     After time timeout time, we stop listening and mark it as a slow click anyhow.
  */ let cleanup = ()=>{
    // replaced further down
    };
    // After timeout time, def. consider this a slow click, and stop watching for mutations
    const timeout = setTimeout(()=>{
        $af5eb29b940bd654$var$handleSlowClick(replay, clickBreadcrumb, config.timeout, 'timeout');
        cleanup();
    }, config.timeout);
    const mutationHandler = ()=>{
        $af5eb29b940bd654$var$maybeHandleSlowClick(replay, clickBreadcrumb, config.threshold, config.timeout, 'mutation');
        cleanup();
    };
    const scrollHandler = ()=>{
        $af5eb29b940bd654$var$maybeHandleSlowClick(replay, clickBreadcrumb, config.scrollTimeout, config.timeout, 'scroll');
        cleanup();
    };
    const obs = new MutationObserver(mutationHandler);
    obs.observe($af5eb29b940bd654$var$WINDOW.document.documentElement, {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true
    });
    $af5eb29b940bd654$var$WINDOW.addEventListener('scroll', scrollHandler);
    // Stop listening to scroll timeouts early
    const scrollTimeout = setTimeout(()=>{
        $af5eb29b940bd654$var$WINDOW.removeEventListener('scroll', scrollHandler);
    }, config.scrollTimeout);
    cleanup = ()=>{
        clearTimeout(timeout);
        clearTimeout(scrollTimeout);
        obs.disconnect();
        $af5eb29b940bd654$var$WINDOW.removeEventListener('scroll', scrollHandler);
    };
}
function $af5eb29b940bd654$var$maybeHandleSlowClick(replay, clickBreadcrumb, threshold, timeout, endReason) {
    const now = Date.now();
    const timeAfterClickMs = now - clickBreadcrumb.timestamp * 1000;
    if (timeAfterClickMs > threshold) {
        $af5eb29b940bd654$var$handleSlowClick(replay, clickBreadcrumb, Math.min(timeAfterClickMs, timeout), endReason);
        return true;
    }
    return false;
}
function $af5eb29b940bd654$var$handleSlowClick(replay, clickBreadcrumb, timeAfterClickMs, endReason) {
    const breadcrumb = {
        message: clickBreadcrumb.message,
        timestamp: clickBreadcrumb.timestamp,
        category: 'ui.slowClickDetected',
        data: {
            ...clickBreadcrumb.data,
            url: $af5eb29b940bd654$var$WINDOW.location.href,
            timeAfterClickMs: // TODO FN: add parametrized route, when possible
            timeAfterClickMs,
            endReason: endReason
        }
    };
    $af5eb29b940bd654$var$addBreadcrumbEvent(replay, breadcrumb);
}
const $af5eb29b940bd654$var$SLOW_CLICK_IGNORE_TAGS = [
    'SELECT',
    'OPTION'
];
function $af5eb29b940bd654$var$ignoreElement(node, config) {
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === 'INPUT' && ![
        'submit',
        'button'
    ].includes(node.getAttribute('type') || '')) return true;
    if ($af5eb29b940bd654$var$SLOW_CLICK_IGNORE_TAGS.includes(node.tagName)) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === 'A' && (node.hasAttribute('download') || node.hasAttribute('target') && node.getAttribute('target') !== '_self')) return true;
    if (config.ignoreSelector && node.matches(config.ignoreSelector)) return true;
    return false;
}
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $af5eb29b940bd654$var$ATTRIBUTES_TO_RECORD = new Set([
    'id',
    'class',
    'aria-label',
    'role',
    'name',
    'alt',
    'title',
    'data-test-id',
    'data-testid'
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $af5eb29b940bd654$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($af5eb29b940bd654$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === 'data-testid' || key === 'data-test-id') normalizedKey = 'testId';
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $af5eb29b940bd654$var$handleDomListener = (replay)=>{
    const slowClickExperiment = replay.getOptions()._experiments.slowClicks;
    const slowClickConfig = slowClickExperiment ? {
        threshold: slowClickExperiment.threshold,
        timeout: slowClickExperiment.timeout,
        scrollTimeout: slowClickExperiment.scrollTimeout,
        ignoreSelector: slowClickExperiment.ignoreSelectors ? slowClickExperiment.ignoreSelectors.join(',') : ''
    } : undefined;
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $af5eb29b940bd654$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === 'click';
        const event = isClick && handlerData.event;
        // Ignore clicks if ctrl/alt/meta keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && slowClickConfig && event && !event.altKey && !event.metaKey && !event.ctrlKey) $af5eb29b940bd654$var$detectSlowClick(replay, slowClickConfig, result, $af5eb29b940bd654$var$getClickTargetNode(handlerData.event));
        $af5eb29b940bd654$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $af5eb29b940bd654$var$getBaseDomBreadcrumb(target, message) {
    // `__sn` property is the serialized node created by rrweb
    const serializedNode = target && $af5eb29b940bd654$var$isRrwebNode(target) && target.__sn.type === $af5eb29b940bd654$var$NodeType.Element ? target.__sn : null;
    return {
        message: message,
        data: serializedNode ? {
            nodeId: serializedNode.id,
            node: {
                id: serializedNode.id,
                tagName: serializedNode.tagName,
                textContent: target ? Array.from(target.childNodes).map((node)=>'__sn' in node && node.__sn.type === $af5eb29b940bd654$var$NodeType.Text && node.__sn.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join('') : '',
                attributes: $af5eb29b940bd654$var$getAttributesToRecord(serializedNode.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $af5eb29b940bd654$var$handleDom(handlerData) {
    const { target: target, message: message } = $af5eb29b940bd654$var$getDomTarget(handlerData);
    return $af5eb29b940bd654$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$af5eb29b940bd654$var$getBaseDomBreadcrumb(target, message)
    });
}
function $af5eb29b940bd654$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === 'click';
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $af5eb29b940bd654$var$getClickTargetNode(handlerData.event) : $af5eb29b940bd654$var$getTargetNode(handlerData.event);
        message = (0, $0897e54e36555b02$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || '<unknown>';
    } catch (e) {
        message = '<unknown>';
    }
    return {
        target: target,
        message: message
    };
}
function $af5eb29b940bd654$var$isRrwebNode(node) {
    return '__sn' in node;
}
function $af5eb29b940bd654$var$getTargetNode(event) {
    if ($af5eb29b940bd654$var$isEventWithTarget(event)) return event.target;
    return event;
}
const $af5eb29b940bd654$var$INTERACTIVE_SELECTOR = 'button,a';
// For clicks, we check if the target is inside of a button or link
// If so, we use this as the target instead
// This is useful because if you click on the image in <button><img></button>,
// The target will be the image, not the button, which we don't want here
function $af5eb29b940bd654$var$getClickTargetNode(event) {
    const target = $af5eb29b940bd654$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    const closestInteractive = target.closest($af5eb29b940bd654$var$INTERACTIVE_SELECTOR);
    return closestInteractive || target;
}
function $af5eb29b940bd654$var$isEventWithTarget(event) {
    return typeof event === 'object' && !!event && 'target' in event;
}
/** Handle keyboard events & create breadcrumbs. */ function $af5eb29b940bd654$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    replay.triggerUserActivity();
    const breadcrumb = $af5eb29b940bd654$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $af5eb29b940bd654$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $af5eb29b940bd654$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $af5eb29b940bd654$var$isInputElement(target)) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $0897e54e36555b02$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || '<unknown>';
    const baseBreadcrumb = $af5eb29b940bd654$var$getBaseDomBreadcrumb(target, message);
    return $af5eb29b940bd654$var$createBreadcrumb({
        category: 'ui.keyDown',
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $af5eb29b940bd654$var$isInputElement(target) {
    return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}
const $af5eb29b940bd654$var$NAVIGATION_ENTRY_KEYS = [
    'name',
    'type',
    'startTime',
    'transferSize',
    'duration'
];
function $af5eb29b940bd654$var$isNavigationEntryEqual(a) {
    return function(b) {
        return $af5eb29b940bd654$var$NAVIGATION_ENTRY_KEYS.every((key)=>a[key] === b[key]);
    };
}
/**
 * There are some difficulties diagnosing why there are duplicate navigation
 * entries. We've witnessed several intermittent results:
 * - duplicate entries have duration = 0
 * - duplicate entries are the same object reference
 * - none of the above
 *
 * Compare the values of several keys to determine if the entries are duplicates or not.
 */ // TODO (high-prio): Figure out wth is returned here
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function $af5eb29b940bd654$var$dedupePerformanceEntries(currentList, newList) {
    // Partition `currentList` into 3 different lists based on entryType
    const [existingNavigationEntries, existingLcpEntries, existingEntries] = currentList.reduce((acc, entry)=>{
        if (entry.entryType === 'navigation') acc[0].push(entry);
        else if (entry.entryType === 'largest-contentful-paint') acc[1].push(entry);
        else acc[2].push(entry);
        return acc;
    }, [
        [],
        [],
        []
    ]);
    const newEntries = [];
    const newNavigationEntries = [];
    let newLcpEntry = existingLcpEntries.length ? existingLcpEntries[existingLcpEntries.length - 1] // Take the last element as list is sorted
     : undefined;
    newList.forEach((entry)=>{
        if (entry.entryType === 'largest-contentful-paint') {
            // We want the latest LCP event only
            if (!newLcpEntry || newLcpEntry.startTime < entry.startTime) newLcpEntry = entry;
            return;
        }
        if (entry.entryType === 'navigation') {
            const navigationEntry = entry;
            // Check if the navigation entry is contained in currentList or newList
            if (// Ignore any navigation entries with duration 0, as they are likely duplicates
            entry.duration > 0 && // Ensure new entry does not already exist in existing entries
            !existingNavigationEntries.find($af5eb29b940bd654$var$isNavigationEntryEqual(navigationEntry)) && // Ensure new entry does not already exist in new list of navigation entries
            !newNavigationEntries.find($af5eb29b940bd654$var$isNavigationEntryEqual(navigationEntry))) newNavigationEntries.push(navigationEntry);
            // Otherwise this navigation entry is considered a duplicate and is thrown away
            return;
        }
        newEntries.push(entry);
    });
    // Re-combine and sort by startTime
    return [
        ...newLcpEntry ? [
            newLcpEntry
        ] : [],
        ...existingNavigationEntries,
        ...existingEntries,
        ...newEntries,
        ...newNavigationEntries
    ].sort((a, b)=>a.startTime - b.startTime);
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 */ function $af5eb29b940bd654$var$setupPerformanceObserver(replay) {
    const performanceObserverHandler = (list)=>{
        // For whatever reason the observer was returning duplicate navigation
        // entries (the other entry types were not duplicated).
        const newPerformanceEntries = $af5eb29b940bd654$var$dedupePerformanceEntries(replay.performanceEvents, list.getEntries());
        replay.performanceEvents = newPerformanceEntries;
    };
    const performanceObserver = new PerformanceObserver(performanceObserverHandler);
    [
        'element',
        'event',
        'first-input',
        'largest-contentful-paint',
        'layout-shift',
        'longtask',
        'navigation',
        'paint',
        'resource'
    ].forEach((type)=>{
        try {
            performanceObserver.observe({
                type: type,
                buffered: true
            });
        } catch (e) {
        // This can throw if an entry type is not supported in the browser.
        // Ignore these errors.
        }
    });
    return performanceObserver;
}
const $af5eb29b940bd654$var$r = `/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
function t(t){let e=t.length;for(;--e>=0;)t[e]=0}const e=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),a=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),i=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),n=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=new Array(576);t(s);const r=new Array(60);t(r);const o=new Array(512);t(o);const l=new Array(256);t(l);const h=new Array(29);t(h);const d=new Array(30);function _(t,e,a,i,n){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=i,this.max_length=n,this.has_stree=t&&t.length}let f,c,u;function w(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}t(d);const m=t=>t<256?o[t]:o[256+(t>>>7)],b=(t,e)=>{t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},g=(t,e,a)=>{t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,b(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},p=(t,e,a)=>{g(t,a[2*e],a[2*e+1])},k=(t,e)=>{let a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},v=(t,e,a)=>{const i=new Array(16);let n,s,r=0;for(n=1;n<=15;n++)r=r+a[n-1]<<1,i[n]=r;for(s=0;s<=e;s++){let e=t[2*s+1];0!==e&&(t[2*s]=k(i[e]++,e))}},y=t=>{let e;for(e=0;e<286;e++)t.dyn_ltree[2*e]=0;for(e=0;e<30;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.sym_next=t.matches=0},x=t=>{t.bi_valid>8?b(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},z=(t,e,a,i)=>{const n=2*e,s=2*a;return t[n]<t[s]||t[n]===t[s]&&i[e]<=i[a]},A=(t,e,a)=>{const i=t.heap[a];let n=a<<1;for(;n<=t.heap_len&&(n<t.heap_len&&z(e,t.heap[n+1],t.heap[n],t.depth)&&n++,!z(e,i,t.heap[n],t.depth));)t.heap[a]=t.heap[n],a=n,n<<=1;t.heap[a]=i},E=(t,i,n)=>{let s,r,o,_,f=0;if(0!==t.sym_next)do{s=255&t.pending_buf[t.sym_buf+f++],s+=(255&t.pending_buf[t.sym_buf+f++])<<8,r=t.pending_buf[t.sym_buf+f++],0===s?p(t,r,i):(o=l[r],p(t,o+256+1,i),_=e[o],0!==_&&(r-=h[o],g(t,r,_)),s--,o=m(s),p(t,o,n),_=a[o],0!==_&&(s-=d[o],g(t,s,_)))}while(f<t.sym_next);p(t,256,i)},R=(t,e)=>{const a=e.dyn_tree,i=e.stat_desc.static_tree,n=e.stat_desc.has_stree,s=e.stat_desc.elems;let r,o,l,h=-1;for(t.heap_len=0,t.heap_max=573,r=0;r<s;r++)0!==a[2*r]?(t.heap[++t.heap_len]=h=r,t.depth[r]=0):a[2*r+1]=0;for(;t.heap_len<2;)l=t.heap[++t.heap_len]=h<2?++h:0,a[2*l]=1,t.depth[l]=0,t.opt_len--,n&&(t.static_len-=i[2*l+1]);for(e.max_code=h,r=t.heap_len>>1;r>=1;r--)A(t,a,r);l=s;do{r=t.heap[1],t.heap[1]=t.heap[t.heap_len--],A(t,a,1),o=t.heap[1],t.heap[--t.heap_max]=r,t.heap[--t.heap_max]=o,a[2*l]=a[2*r]+a[2*o],t.depth[l]=(t.depth[r]>=t.depth[o]?t.depth[r]:t.depth[o])+1,a[2*r+1]=a[2*o+1]=l,t.heap[1]=l++,A(t,a,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],((t,e)=>{const a=e.dyn_tree,i=e.max_code,n=e.stat_desc.static_tree,s=e.stat_desc.has_stree,r=e.stat_desc.extra_bits,o=e.stat_desc.extra_base,l=e.stat_desc.max_length;let h,d,_,f,c,u,w=0;for(f=0;f<=15;f++)t.bl_count[f]=0;for(a[2*t.heap[t.heap_max]+1]=0,h=t.heap_max+1;h<573;h++)d=t.heap[h],f=a[2*a[2*d+1]+1]+1,f>l&&(f=l,w++),a[2*d+1]=f,d>i||(t.bl_count[f]++,c=0,d>=o&&(c=r[d-o]),u=a[2*d],t.opt_len+=u*(f+c),s&&(t.static_len+=u*(n[2*d+1]+c)));if(0!==w){do{for(f=l-1;0===t.bl_count[f];)f--;t.bl_count[f]--,t.bl_count[f+1]+=2,t.bl_count[l]--,w-=2}while(w>0);for(f=l;0!==f;f--)for(d=t.bl_count[f];0!==d;)_=t.heap[--h],_>i||(a[2*_+1]!==f&&(t.opt_len+=(f-a[2*_+1])*a[2*_],a[2*_+1]=f),d--)}})(t,e),v(a,h,t.bl_count)},Z=(t,e,a)=>{let i,n,s=-1,r=e[1],o=0,l=7,h=4;for(0===r&&(l=138,h=3),e[2*(a+1)+1]=65535,i=0;i<=a;i++)n=r,r=e[2*(i+1)+1],++o<l&&n===r||(o<h?t.bl_tree[2*n]+=o:0!==n?(n!==s&&t.bl_tree[2*n]++,t.bl_tree[32]++):o<=10?t.bl_tree[34]++:t.bl_tree[36]++,o=0,s=n,0===r?(l=138,h=3):n===r?(l=6,h=3):(l=7,h=4))},U=(t,e,a)=>{let i,n,s=-1,r=e[1],o=0,l=7,h=4;for(0===r&&(l=138,h=3),i=0;i<=a;i++)if(n=r,r=e[2*(i+1)+1],!(++o<l&&n===r)){if(o<h)do{p(t,n,t.bl_tree)}while(0!=--o);else 0!==n?(n!==s&&(p(t,n,t.bl_tree),o--),p(t,16,t.bl_tree),g(t,o-3,2)):o<=10?(p(t,17,t.bl_tree),g(t,o-3,3)):(p(t,18,t.bl_tree),g(t,o-11,7));o=0,s=n,0===r?(l=138,h=3):n===r?(l=6,h=3):(l=7,h=4)}};let S=!1;const D=(t,e,a,i)=>{g(t,0+(i?1:0),3),x(t),b(t,a),b(t,~a),a&&t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a};var T=(t,e,a,i)=>{let o,l,h=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=(t=>{let e,a=4093624447;for(e=0;e<=31;e++,a>>>=1)if(1&a&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<256;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0})(t)),R(t,t.l_desc),R(t,t.d_desc),h=(t=>{let e;for(Z(t,t.dyn_ltree,t.l_desc.max_code),Z(t,t.dyn_dtree,t.d_desc.max_code),R(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*n[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e})(t),o=t.opt_len+3+7>>>3,l=t.static_len+3+7>>>3,l<=o&&(o=l)):o=l=a+5,a+4<=o&&-1!==e?D(t,e,a,i):4===t.strategy||l===o?(g(t,2+(i?1:0),3),E(t,s,r)):(g(t,4+(i?1:0),3),((t,e,a,i)=>{let s;for(g(t,e-257,5),g(t,a-1,5),g(t,i-4,4),s=0;s<i;s++)g(t,t.bl_tree[2*n[s]+1],3);U(t,t.dyn_ltree,e-1),U(t,t.dyn_dtree,a-1)})(t,t.l_desc.max_code+1,t.d_desc.max_code+1,h+1),E(t,t.dyn_ltree,t.dyn_dtree)),y(t),i&&x(t)},O={_tr_init:t=>{S||((()=>{let t,n,w,m,b;const g=new Array(16);for(w=0,m=0;m<28;m++)for(h[m]=w,t=0;t<1<<e[m];t++)l[w++]=m;for(l[w-1]=m,b=0,m=0;m<16;m++)for(d[m]=b,t=0;t<1<<a[m];t++)o[b++]=m;for(b>>=7;m<30;m++)for(d[m]=b<<7,t=0;t<1<<a[m]-7;t++)o[256+b++]=m;for(n=0;n<=15;n++)g[n]=0;for(t=0;t<=143;)s[2*t+1]=8,t++,g[8]++;for(;t<=255;)s[2*t+1]=9,t++,g[9]++;for(;t<=279;)s[2*t+1]=7,t++,g[7]++;for(;t<=287;)s[2*t+1]=8,t++,g[8]++;for(v(s,287,g),t=0;t<30;t++)r[2*t+1]=5,r[2*t]=k(t,5);f=new _(s,e,257,286,15),c=new _(r,a,0,30,15),u=new _(new Array(0),i,0,19,7)})(),S=!0),t.l_desc=new w(t.dyn_ltree,f),t.d_desc=new w(t.dyn_dtree,c),t.bl_desc=new w(t.bl_tree,u),t.bi_buf=0,t.bi_valid=0,y(t)},_tr_stored_block:D,_tr_flush_block:T,_tr_tally:(t,e,a)=>(t.pending_buf[t.sym_buf+t.sym_next++]=e,t.pending_buf[t.sym_buf+t.sym_next++]=e>>8,t.pending_buf[t.sym_buf+t.sym_next++]=a,0===e?t.dyn_ltree[2*a]++:(t.matches++,e--,t.dyn_ltree[2*(l[a]+256+1)]++,t.dyn_dtree[2*m(e)]++),t.sym_next===t.sym_end),_tr_align:t=>{g(t,2,3),p(t,256,s),(t=>{16===t.bi_valid?(b(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)})(t)}};var F=(t,e,a,i)=>{let n=65535&t|0,s=t>>>16&65535|0,r=0;for(;0!==a;){r=a>2e3?2e3:a,a-=r;do{n=n+e[i++]|0,s=s+n|0}while(--r);n%=65521,s%=65521}return n|s<<16|0};const L=new Uint32Array((()=>{let t,e=[];for(var a=0;a<256;a++){t=a;for(var i=0;i<8;i++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e})());var N=(t,e,a,i)=>{const n=L,s=i+a;t^=-1;for(let a=i;a<s;a++)t=t>>>8^n[255&(t^e[a])];return-1^t},I={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},B={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8};const{_tr_init:C,_tr_stored_block:H,_tr_flush_block:M,_tr_tally:j,_tr_align:K}=O,{Z_NO_FLUSH:P,Z_PARTIAL_FLUSH:Y,Z_FULL_FLUSH:G,Z_FINISH:X,Z_BLOCK:W,Z_OK:q,Z_STREAM_END:J,Z_STREAM_ERROR:Q,Z_DATA_ERROR:V,Z_BUF_ERROR:$,Z_DEFAULT_COMPRESSION:tt,Z_FILTERED:et,Z_HUFFMAN_ONLY:at,Z_RLE:it,Z_FIXED:nt,Z_DEFAULT_STRATEGY:st,Z_UNKNOWN:rt,Z_DEFLATED:ot}=B,lt=(t,e)=>(t.msg=I[e],e),ht=t=>2*t-(t>4?9:0),dt=t=>{let e=t.length;for(;--e>=0;)t[e]=0},_t=t=>{let e,a,i,n=t.w_size;e=t.hash_size,i=e;do{a=t.head[--i],t.head[i]=a>=n?a-n:0}while(--e);e=n,i=e;do{a=t.prev[--i],t.prev[i]=a>=n?a-n:0}while(--e)};let ft=(t,e,a)=>(e<<t.hash_shift^a)&t.hash_mask;const ct=t=>{const e=t.state;let a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},ut=(t,e)=>{M(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,ct(t.strm)},wt=(t,e)=>{t.pending_buf[t.pending++]=e},mt=(t,e)=>{t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},bt=(t,e,a,i)=>{let n=t.avail_in;return n>i&&(n=i),0===n?0:(t.avail_in-=n,e.set(t.input.subarray(t.next_in,t.next_in+n),a),1===t.state.wrap?t.adler=F(t.adler,e,n,a):2===t.state.wrap&&(t.adler=N(t.adler,e,n,a)),t.next_in+=n,t.total_in+=n,n)},gt=(t,e)=>{let a,i,n=t.max_chain_length,s=t.strstart,r=t.prev_length,o=t.nice_match;const l=t.strstart>t.w_size-262?t.strstart-(t.w_size-262):0,h=t.window,d=t.w_mask,_=t.prev,f=t.strstart+258;let c=h[s+r-1],u=h[s+r];t.prev_length>=t.good_match&&(n>>=2),o>t.lookahead&&(o=t.lookahead);do{if(a=e,h[a+r]===u&&h[a+r-1]===c&&h[a]===h[s]&&h[++a]===h[s+1]){s+=2,a++;do{}while(h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&s<f);if(i=258-(f-s),s=f-258,i>r){if(t.match_start=e,r=i,i>=o)break;c=h[s+r-1],u=h[s+r]}}}while((e=_[e&d])>l&&0!=--n);return r<=t.lookahead?r:t.lookahead},pt=t=>{const e=t.w_size;let a,i,n;do{if(i=t.window_size-t.lookahead-t.strstart,t.strstart>=e+(e-262)&&(t.window.set(t.window.subarray(e,e+e-i),0),t.match_start-=e,t.strstart-=e,t.block_start-=e,t.insert>t.strstart&&(t.insert=t.strstart),_t(t),i+=e),0===t.strm.avail_in)break;if(a=bt(t.strm,t.window,t.strstart+t.lookahead,i),t.lookahead+=a,t.lookahead+t.insert>=3)for(n=t.strstart-t.insert,t.ins_h=t.window[n],t.ins_h=ft(t,t.ins_h,t.window[n+1]);t.insert&&(t.ins_h=ft(t,t.ins_h,t.window[n+3-1]),t.prev[n&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=n,n++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<262&&0!==t.strm.avail_in)},kt=(t,e)=>{let a,i,n,s=t.pending_buf_size-5>t.w_size?t.w_size:t.pending_buf_size-5,r=0,o=t.strm.avail_in;do{if(a=65535,n=t.bi_valid+42>>3,t.strm.avail_out<n)break;if(n=t.strm.avail_out-n,i=t.strstart-t.block_start,a>i+t.strm.avail_in&&(a=i+t.strm.avail_in),a>n&&(a=n),a<s&&(0===a&&e!==X||e===P||a!==i+t.strm.avail_in))break;r=e===X&&a===i+t.strm.avail_in?1:0,H(t,0,0,r),t.pending_buf[t.pending-4]=a,t.pending_buf[t.pending-3]=a>>8,t.pending_buf[t.pending-2]=~a,t.pending_buf[t.pending-1]=~a>>8,ct(t.strm),i&&(i>a&&(i=a),t.strm.output.set(t.window.subarray(t.block_start,t.block_start+i),t.strm.next_out),t.strm.next_out+=i,t.strm.avail_out-=i,t.strm.total_out+=i,t.block_start+=i,a-=i),a&&(bt(t.strm,t.strm.output,t.strm.next_out,a),t.strm.next_out+=a,t.strm.avail_out-=a,t.strm.total_out+=a)}while(0===r);return o-=t.strm.avail_in,o&&(o>=t.w_size?(t.matches=2,t.window.set(t.strm.input.subarray(t.strm.next_in-t.w_size,t.strm.next_in),0),t.strstart=t.w_size,t.insert=t.strstart):(t.window_size-t.strstart<=o&&(t.strstart-=t.w_size,t.window.set(t.window.subarray(t.w_size,t.w_size+t.strstart),0),t.matches<2&&t.matches++,t.insert>t.strstart&&(t.insert=t.strstart)),t.window.set(t.strm.input.subarray(t.strm.next_in-o,t.strm.next_in),t.strstart),t.strstart+=o,t.insert+=o>t.w_size-t.insert?t.w_size-t.insert:o),t.block_start=t.strstart),t.high_water<t.strstart&&(t.high_water=t.strstart),r?4:e!==P&&e!==X&&0===t.strm.avail_in&&t.strstart===t.block_start?2:(n=t.window_size-t.strstart,t.strm.avail_in>n&&t.block_start>=t.w_size&&(t.block_start-=t.w_size,t.strstart-=t.w_size,t.window.set(t.window.subarray(t.w_size,t.w_size+t.strstart),0),t.matches<2&&t.matches++,n+=t.w_size,t.insert>t.strstart&&(t.insert=t.strstart)),n>t.strm.avail_in&&(n=t.strm.avail_in),n&&(bt(t.strm,t.window,t.strstart,n),t.strstart+=n,t.insert+=n>t.w_size-t.insert?t.w_size-t.insert:n),t.high_water<t.strstart&&(t.high_water=t.strstart),n=t.bi_valid+42>>3,n=t.pending_buf_size-n>65535?65535:t.pending_buf_size-n,s=n>t.w_size?t.w_size:n,i=t.strstart-t.block_start,(i>=s||(i||e===X)&&e!==P&&0===t.strm.avail_in&&i<=n)&&(a=i>n?n:i,r=e===X&&0===t.strm.avail_in&&a===i?1:0,H(t,t.block_start,a,r),t.block_start+=a,ct(t.strm)),r?3:1)},vt=(t,e)=>{let a,i;for(;;){if(t.lookahead<262){if(pt(t),t.lookahead<262&&e===P)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-262&&(t.match_length=gt(t,a)),t.match_length>=3)if(i=j(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=ft(t,t.ins_h,t.window[t.strstart+1]);else i=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(i&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2},yt=(t,e)=>{let a,i,n;for(;;){if(t.lookahead<262){if(pt(t),t.lookahead<262&&e===P)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-262&&(t.match_length=gt(t,a),t.match_length<=5&&(t.strategy===et||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){n=t.strstart+t.lookahead-3,i=j(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=n&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,i&&(ut(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if(i=j(t,0,t.window[t.strstart-1]),i&&ut(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(i=j(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2};function xt(t,e,a,i,n){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=i,this.func=n}const zt=[new xt(0,0,0,0,kt),new xt(4,4,8,4,vt),new xt(4,5,16,8,vt),new xt(4,6,32,32,vt),new xt(4,4,16,16,yt),new xt(8,16,32,32,yt),new xt(8,16,128,128,yt),new xt(8,32,128,256,yt),new xt(32,128,258,1024,yt),new xt(32,258,258,4096,yt)];function At(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ot,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),dt(this.dyn_ltree),dt(this.dyn_dtree),dt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),dt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),dt(this.depth),this.sym_buf=0,this.lit_bufsize=0,this.sym_next=0,this.sym_end=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}const Et=t=>{if(!t)return 1;const e=t.state;return!e||e.strm!==t||42!==e.status&&57!==e.status&&69!==e.status&&73!==e.status&&91!==e.status&&103!==e.status&&113!==e.status&&666!==e.status?1:0},Rt=t=>{if(Et(t))return lt(t,Q);t.total_in=t.total_out=0,t.data_type=rt;const e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=2===e.wrap?57:e.wrap?42:113,t.adler=2===e.wrap?0:1,e.last_flush=-2,C(e),q},Zt=t=>{const e=Rt(t);var a;return e===q&&((a=t.state).window_size=2*a.w_size,dt(a.head),a.max_lazy_match=zt[a.level].max_lazy,a.good_match=zt[a.level].good_length,a.nice_match=zt[a.level].nice_length,a.max_chain_length=zt[a.level].max_chain,a.strstart=0,a.block_start=0,a.lookahead=0,a.insert=0,a.match_length=a.prev_length=2,a.match_available=0,a.ins_h=0),e},Ut=(t,e,a,i,n,s)=>{if(!t)return Q;let r=1;if(e===tt&&(e=6),i<0?(r=0,i=-i):i>15&&(r=2,i-=16),n<1||n>9||a!==ot||i<8||i>15||e<0||e>9||s<0||s>nt||8===i&&1!==r)return lt(t,Q);8===i&&(i=9);const o=new At;return t.state=o,o.strm=t,o.status=42,o.wrap=r,o.gzhead=null,o.w_bits=i,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=n+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+3-1)/3),o.window=new Uint8Array(2*o.w_size),o.head=new Uint16Array(o.hash_size),o.prev=new Uint16Array(o.w_size),o.lit_bufsize=1<<n+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new Uint8Array(o.pending_buf_size),o.sym_buf=o.lit_bufsize,o.sym_end=3*(o.lit_bufsize-1),o.level=e,o.strategy=s,o.method=a,Zt(t)};var St={deflateInit:(t,e)=>Ut(t,e,ot,15,8,st),deflateInit2:Ut,deflateReset:Zt,deflateResetKeep:Rt,deflateSetHeader:(t,e)=>Et(t)||2!==t.state.wrap?Q:(t.state.gzhead=e,q),deflate:(t,e)=>{if(Et(t)||e>W||e<0)return t?lt(t,Q):Q;const a=t.state;if(!t.output||0!==t.avail_in&&!t.input||666===a.status&&e!==X)return lt(t,0===t.avail_out?$:Q);const i=a.last_flush;if(a.last_flush=e,0!==a.pending){if(ct(t),0===t.avail_out)return a.last_flush=-1,q}else if(0===t.avail_in&&ht(e)<=ht(i)&&e!==X)return lt(t,$);if(666===a.status&&0!==t.avail_in)return lt(t,$);if(42===a.status&&0===a.wrap&&(a.status=113),42===a.status){let e=ot+(a.w_bits-8<<4)<<8,i=-1;if(i=a.strategy>=at||a.level<2?0:a.level<6?1:6===a.level?2:3,e|=i<<6,0!==a.strstart&&(e|=32),e+=31-e%31,mt(a,e),0!==a.strstart&&(mt(a,t.adler>>>16),mt(a,65535&t.adler)),t.adler=1,a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q}if(57===a.status)if(t.adler=0,wt(a,31),wt(a,139),wt(a,8),a.gzhead)wt(a,(a.gzhead.text?1:0)+(a.gzhead.hcrc?2:0)+(a.gzhead.extra?4:0)+(a.gzhead.name?8:0)+(a.gzhead.comment?16:0)),wt(a,255&a.gzhead.time),wt(a,a.gzhead.time>>8&255),wt(a,a.gzhead.time>>16&255),wt(a,a.gzhead.time>>24&255),wt(a,9===a.level?2:a.strategy>=at||a.level<2?4:0),wt(a,255&a.gzhead.os),a.gzhead.extra&&a.gzhead.extra.length&&(wt(a,255&a.gzhead.extra.length),wt(a,a.gzhead.extra.length>>8&255)),a.gzhead.hcrc&&(t.adler=N(t.adler,a.pending_buf,a.pending,0)),a.gzindex=0,a.status=69;else if(wt(a,0),wt(a,0),wt(a,0),wt(a,0),wt(a,0),wt(a,9===a.level?2:a.strategy>=at||a.level<2?4:0),wt(a,3),a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q;if(69===a.status){if(a.gzhead.extra){let e=a.pending,i=(65535&a.gzhead.extra.length)-a.gzindex;for(;a.pending+i>a.pending_buf_size;){let n=a.pending_buf_size-a.pending;if(a.pending_buf.set(a.gzhead.extra.subarray(a.gzindex,a.gzindex+n),a.pending),a.pending=a.pending_buf_size,a.gzhead.hcrc&&a.pending>e&&(t.adler=N(t.adler,a.pending_buf,a.pending-e,e)),a.gzindex+=n,ct(t),0!==a.pending)return a.last_flush=-1,q;e=0,i-=n}let n=new Uint8Array(a.gzhead.extra);a.pending_buf.set(n.subarray(a.gzindex,a.gzindex+i),a.pending),a.pending+=i,a.gzhead.hcrc&&a.pending>e&&(t.adler=N(t.adler,a.pending_buf,a.pending-e,e)),a.gzindex=0}a.status=73}if(73===a.status){if(a.gzhead.name){let e,i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),ct(t),0!==a.pending)return a.last_flush=-1,q;i=0}e=a.gzindex<a.gzhead.name.length?255&a.gzhead.name.charCodeAt(a.gzindex++):0,wt(a,e)}while(0!==e);a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),a.gzindex=0}a.status=91}if(91===a.status){if(a.gzhead.comment){let e,i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),ct(t),0!==a.pending)return a.last_flush=-1,q;i=0}e=a.gzindex<a.gzhead.comment.length?255&a.gzhead.comment.charCodeAt(a.gzindex++):0,wt(a,e)}while(0!==e);a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i))}a.status=103}if(103===a.status){if(a.gzhead.hcrc){if(a.pending+2>a.pending_buf_size&&(ct(t),0!==a.pending))return a.last_flush=-1,q;wt(a,255&t.adler),wt(a,t.adler>>8&255),t.adler=0}if(a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q}if(0!==t.avail_in||0!==a.lookahead||e!==P&&666!==a.status){let i=0===a.level?kt(a,e):a.strategy===at?((t,e)=>{let a;for(;;){if(0===t.lookahead&&(pt(t),0===t.lookahead)){if(e===P)return 1;break}if(t.match_length=0,a=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2})(a,e):a.strategy===it?((t,e)=>{let a,i,n,s;const r=t.window;for(;;){if(t.lookahead<=258){if(pt(t),t.lookahead<=258&&e===P)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=t.strstart-1,i=r[n],i===r[++n]&&i===r[++n]&&i===r[++n])){s=t.strstart+258;do{}while(i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&n<s);t.match_length=258-(s-n),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=j(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2})(a,e):zt[a.level].func(a,e);if(3!==i&&4!==i||(a.status=666),1===i||3===i)return 0===t.avail_out&&(a.last_flush=-1),q;if(2===i&&(e===Y?K(a):e!==W&&(H(a,0,0,!1),e===G&&(dt(a.head),0===a.lookahead&&(a.strstart=0,a.block_start=0,a.insert=0))),ct(t),0===t.avail_out))return a.last_flush=-1,q}return e!==X?q:a.wrap<=0?J:(2===a.wrap?(wt(a,255&t.adler),wt(a,t.adler>>8&255),wt(a,t.adler>>16&255),wt(a,t.adler>>24&255),wt(a,255&t.total_in),wt(a,t.total_in>>8&255),wt(a,t.total_in>>16&255),wt(a,t.total_in>>24&255)):(mt(a,t.adler>>>16),mt(a,65535&t.adler)),ct(t),a.wrap>0&&(a.wrap=-a.wrap),0!==a.pending?q:J)},deflateEnd:t=>{if(Et(t))return Q;const e=t.state.status;return t.state=null,113===e?lt(t,V):q},deflateSetDictionary:(t,e)=>{let a=e.length;if(Et(t))return Q;const i=t.state,n=i.wrap;if(2===n||1===n&&42!==i.status||i.lookahead)return Q;if(1===n&&(t.adler=F(t.adler,e,a,0)),i.wrap=0,a>=i.w_size){0===n&&(dt(i.head),i.strstart=0,i.block_start=0,i.insert=0);let t=new Uint8Array(i.w_size);t.set(e.subarray(a-i.w_size,a),0),e=t,a=i.w_size}const s=t.avail_in,r=t.next_in,o=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,pt(i);i.lookahead>=3;){let t=i.strstart,e=i.lookahead-2;do{i.ins_h=ft(i,i.ins_h,i.window[t+3-1]),i.prev[t&i.w_mask]=i.head[i.ins_h],i.head[i.ins_h]=t,t++}while(--e);i.strstart=t,i.lookahead=2,pt(i)}return i.strstart+=i.lookahead,i.block_start=i.strstart,i.insert=i.lookahead,i.lookahead=0,i.match_length=i.prev_length=2,i.match_available=0,t.next_in=r,t.input=o,t.avail_in=s,i.wrap=n,q},deflateInfo:"pako deflate (from Nodeca project)"};const Dt=(t,e)=>Object.prototype.hasOwnProperty.call(t,e);var Tt=function(t){const e=Array.prototype.slice.call(arguments,1);for(;e.length;){const a=e.shift();if(a){if("object"!=typeof a)throw new TypeError(a+"must be non-object");for(const e in a)Dt(a,e)&&(t[e]=a[e])}}return t},Ot=t=>{let e=0;for(let a=0,i=t.length;a<i;a++)e+=t[a].length;const a=new Uint8Array(e);for(let e=0,i=0,n=t.length;e<n;e++){let n=t[e];a.set(n,i),i+=n.length}return a};let Ft=!0;try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(t){Ft=!1}const Lt=new Uint8Array(256);for(let t=0;t<256;t++)Lt[t]=t>=252?6:t>=248?5:t>=240?4:t>=224?3:t>=192?2:1;Lt[254]=Lt[254]=1;var Nt=t=>{if("function"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);let e,a,i,n,s,r=t.length,o=0;for(n=0;n<r;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),o+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(o),s=0,n=0;s<o;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),a<128?e[s++]=a:a<2048?(e[s++]=192|a>>>6,e[s++]=128|63&a):a<65536?(e[s++]=224|a>>>12,e[s++]=128|a>>>6&63,e[s++]=128|63&a):(e[s++]=240|a>>>18,e[s++]=128|a>>>12&63,e[s++]=128|a>>>6&63,e[s++]=128|63&a);return e},It=(t,e)=>{const a=e||t.length;if("function"==typeof TextDecoder&&TextDecoder.prototype.decode)return(new TextDecoder).decode(t.subarray(0,e));let i,n;const s=new Array(2*a);for(n=0,i=0;i<a;){let e=t[i++];if(e<128){s[n++]=e;continue}let r=Lt[e];if(r>4)s[n++]=65533,i+=r-1;else{for(e&=2===r?31:3===r?15:7;r>1&&i<a;)e=e<<6|63&t[i++],r--;r>1?s[n++]=65533:e<65536?s[n++]=e:(e-=65536,s[n++]=55296|e>>10&1023,s[n++]=56320|1023&e)}}return((t,e)=>{if(e<65534&&t.subarray&&Ft)return String.fromCharCode.apply(null,t.length===e?t:t.subarray(0,e));let a="";for(let i=0;i<e;i++)a+=String.fromCharCode(t[i]);return a})(s,n)},Bt=(t,e)=>{(e=e||t.length)>t.length&&(e=t.length);let a=e-1;for(;a>=0&&128==(192&t[a]);)a--;return a<0||0===a?e:a+Lt[t[a]]>e?a:e};var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0};const Ht=Object.prototype.toString,{Z_NO_FLUSH:Mt,Z_SYNC_FLUSH:jt,Z_FULL_FLUSH:Kt,Z_FINISH:Pt,Z_OK:Yt,Z_STREAM_END:Gt,Z_DEFAULT_COMPRESSION:Xt,Z_DEFAULT_STRATEGY:Wt,Z_DEFLATED:qt}=B;function Jt(t){this.options=Tt({level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt},t||{});let e=this.options;e.raw&&e.windowBits>0?e.windowBits=-e.windowBits:e.gzip&&e.windowBits>0&&e.windowBits<16&&(e.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;let a=St.deflateInit2(this.strm,e.level,e.method,e.windowBits,e.memLevel,e.strategy);if(a!==Yt)throw new Error(I[a]);if(e.header&&St.deflateSetHeader(this.strm,e.header),e.dictionary){let t;if(t="string"==typeof e.dictionary?Nt(e.dictionary):"[object ArrayBuffer]"===Ht.call(e.dictionary)?new Uint8Array(e.dictionary):e.dictionary,a=St.deflateSetDictionary(this.strm,t),a!==Yt)throw new Error(I[a]);this._dict_set=!0}}function Qt(t,e){const a=new Jt(e);if(a.push(t,!0),a.err)throw a.msg||I[a.err];return a.result}Jt.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize;let n,s;if(this.ended)return!1;for(s=e===~~e?e:!0===e?Pt:Mt,"string"==typeof t?a.input=Nt(t):"[object ArrayBuffer]"===Ht.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;)if(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),(s===jt||s===Kt)&&a.avail_out<=6)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else{if(n=St.deflate(a,s),n===Gt)return a.next_out>0&&this.onData(a.output.subarray(0,a.next_out)),n=St.deflateEnd(this.strm),this.onEnd(n),this.ended=!0,n===Yt;if(0!==a.avail_out){if(s>0&&a.next_out>0)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else if(0===a.avail_in)break}else this.onData(a.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===Yt&&(this.result=Ot(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};var Vt={Deflate:Jt,deflate:Qt,deflateRaw:function(t,e){return(e=e||{}).raw=!0,Qt(t,e)},gzip:function(t,e){return(e=e||{}).gzip=!0,Qt(t,e)},constants:B};var $t=function(t,e){let a,i,n,s,r,o,l,h,d,_,f,c,u,w,m,b,g,p,k,v,y,x,z,A;const E=t.state;a=t.next_in,z=t.input,i=a+(t.avail_in-5),n=t.next_out,A=t.output,s=n-(e-t.avail_out),r=n+(t.avail_out-257),o=E.dmax,l=E.wsize,h=E.whave,d=E.wnext,_=E.window,f=E.hold,c=E.bits,u=E.lencode,w=E.distcode,m=(1<<E.lenbits)-1,b=(1<<E.distbits)-1;t:do{c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),g=u[f&m];e:for(;;){if(p=g>>>24,f>>>=p,c-=p,p=g>>>16&255,0===p)A[n++]=65535&g;else{if(!(16&p)){if(0==(64&p)){g=u[(65535&g)+(f&(1<<p)-1)];continue e}if(32&p){E.mode=16191;break t}t.msg="invalid literal/length code",E.mode=16209;break t}k=65535&g,p&=15,p&&(c<p&&(f+=z[a++]<<c,c+=8),k+=f&(1<<p)-1,f>>>=p,c-=p),c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),g=w[f&b];a:for(;;){if(p=g>>>24,f>>>=p,c-=p,p=g>>>16&255,!(16&p)){if(0==(64&p)){g=w[(65535&g)+(f&(1<<p)-1)];continue a}t.msg="invalid distance code",E.mode=16209;break t}if(v=65535&g,p&=15,c<p&&(f+=z[a++]<<c,c+=8,c<p&&(f+=z[a++]<<c,c+=8)),v+=f&(1<<p)-1,v>o){t.msg="invalid distance too far back",E.mode=16209;break t}if(f>>>=p,c-=p,p=n-s,v>p){if(p=v-p,p>h&&E.sane){t.msg="invalid distance too far back",E.mode=16209;break t}if(y=0,x=_,0===d){if(y+=l-p,p<k){k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}}else if(d<p){if(y+=l+d-p,p-=d,p<k){k-=p;do{A[n++]=_[y++]}while(--p);if(y=0,d<k){p=d,k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}}}else if(y+=d-p,p<k){k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}for(;k>2;)A[n++]=x[y++],A[n++]=x[y++],A[n++]=x[y++],k-=3;k&&(A[n++]=x[y++],k>1&&(A[n++]=x[y++]))}else{y=n-v;do{A[n++]=A[y++],A[n++]=A[y++],A[n++]=A[y++],k-=3}while(k>2);k&&(A[n++]=A[y++],k>1&&(A[n++]=A[y++]))}break}}break}}while(a<i&&n<r);k=c>>3,a-=k,c-=k<<3,f&=(1<<c)-1,t.next_in=a,t.next_out=n,t.avail_in=a<i?i-a+5:5-(a-i),t.avail_out=n<r?r-n+257:257-(n-r),E.hold=f,E.bits=c};const te=new Uint16Array([3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0]),ee=new Uint8Array([16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78]),ae=new Uint16Array([1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0]),ie=new Uint8Array([16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64]);var ne=(t,e,a,i,n,s,r,o)=>{const l=o.bits;let h,d,_,f,c,u,w=0,m=0,b=0,g=0,p=0,k=0,v=0,y=0,x=0,z=0,A=null;const E=new Uint16Array(16),R=new Uint16Array(16);let Z,U,S,D=null;for(w=0;w<=15;w++)E[w]=0;for(m=0;m<i;m++)E[e[a+m]]++;for(p=l,g=15;g>=1&&0===E[g];g--);if(p>g&&(p=g),0===g)return n[s++]=20971520,n[s++]=20971520,o.bits=1,0;for(b=1;b<g&&0===E[b];b++);for(p<b&&(p=b),y=1,w=1;w<=15;w++)if(y<<=1,y-=E[w],y<0)return-1;if(y>0&&(0===t||1!==g))return-1;for(R[1]=0,w=1;w<15;w++)R[w+1]=R[w]+E[w];for(m=0;m<i;m++)0!==e[a+m]&&(r[R[e[a+m]]++]=m);if(0===t?(A=D=r,u=20):1===t?(A=te,D=ee,u=257):(A=ae,D=ie,u=0),z=0,m=0,w=b,c=s,k=p,v=0,_=-1,x=1<<p,f=x-1,1===t&&x>852||2===t&&x>592)return 1;for(;;){Z=w-v,r[m]+1<u?(U=0,S=r[m]):r[m]>=u?(U=D[r[m]-u],S=A[r[m]-u]):(U=96,S=0),h=1<<w-v,d=1<<k,b=d;do{d-=h,n[c+(z>>v)+d]=Z<<24|U<<16|S|0}while(0!==d);for(h=1<<w-1;z&h;)h>>=1;if(0!==h?(z&=h-1,z+=h):z=0,m++,0==--E[w]){if(w===g)break;w=e[a+r[m]]}if(w>p&&(z&f)!==_){for(0===v&&(v=p),c+=b,k=w-v,y=1<<k;k+v<g&&(y-=E[k+v],!(y<=0));)k++,y<<=1;if(x+=1<<k,1===t&&x>852||2===t&&x>592)return 1;_=z&f,n[_]=p<<24|k<<16|c-s|0}}return 0!==z&&(n[c+z]=w-v<<24|64<<16|0),o.bits=p,0};const{Z_FINISH:se,Z_BLOCK:re,Z_TREES:oe,Z_OK:le,Z_STREAM_END:he,Z_NEED_DICT:de,Z_STREAM_ERROR:_e,Z_DATA_ERROR:fe,Z_MEM_ERROR:ce,Z_BUF_ERROR:ue,Z_DEFLATED:we}=B,me=16209,be=t=>(t>>>24&255)+(t>>>8&65280)+((65280&t)<<8)+((255&t)<<24);function ge(){this.strm=null,this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new Uint16Array(320),this.work=new Uint16Array(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}const pe=t=>{if(!t)return 1;const e=t.state;return!e||e.strm!==t||e.mode<16180||e.mode>16211?1:0},ke=t=>{if(pe(t))return _e;const e=t.state;return t.total_in=t.total_out=e.total=0,t.msg="",e.wrap&&(t.adler=1&e.wrap),e.mode=16180,e.last=0,e.havedict=0,e.flags=-1,e.dmax=32768,e.head=null,e.hold=0,e.bits=0,e.lencode=e.lendyn=new Int32Array(852),e.distcode=e.distdyn=new Int32Array(592),e.sane=1,e.back=-1,le},ve=t=>{if(pe(t))return _e;const e=t.state;return e.wsize=0,e.whave=0,e.wnext=0,ke(t)},ye=(t,e)=>{let a;if(pe(t))return _e;const i=t.state;return e<0?(a=0,e=-e):(a=5+(e>>4),e<48&&(e&=15)),e&&(e<8||e>15)?_e:(null!==i.window&&i.wbits!==e&&(i.window=null),i.wrap=a,i.wbits=e,ve(t))},xe=(t,e)=>{if(!t)return _e;const a=new ge;t.state=a,a.strm=t,a.window=null,a.mode=16180;const i=ye(t,e);return i!==le&&(t.state=null),i};let ze,Ae,Ee=!0;const Re=t=>{if(Ee){ze=new Int32Array(512),Ae=new Int32Array(32);let e=0;for(;e<144;)t.lens[e++]=8;for(;e<256;)t.lens[e++]=9;for(;e<280;)t.lens[e++]=7;for(;e<288;)t.lens[e++]=8;for(ne(1,t.lens,0,288,ze,0,t.work,{bits:9}),e=0;e<32;)t.lens[e++]=5;ne(2,t.lens,0,32,Ae,0,t.work,{bits:5}),Ee=!1}t.lencode=ze,t.lenbits=9,t.distcode=Ae,t.distbits=5},Ze=(t,e,a,i)=>{let n;const s=t.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new Uint8Array(s.wsize)),i>=s.wsize?(s.window.set(e.subarray(a-s.wsize,a),0),s.wnext=0,s.whave=s.wsize):(n=s.wsize-s.wnext,n>i&&(n=i),s.window.set(e.subarray(a-i,a-i+n),s.wnext),(i-=n)?(s.window.set(e.subarray(a-i,a),0),s.wnext=i,s.whave=s.wsize):(s.wnext+=n,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=n))),0};var Ue={inflateReset:ve,inflateReset2:ye,inflateResetKeep:ke,inflateInit:t=>xe(t,15),inflateInit2:xe,inflate:(t,e)=>{let a,i,n,s,r,o,l,h,d,_,f,c,u,w,m,b,g,p,k,v,y,x,z=0;const A=new Uint8Array(4);let E,R;const Z=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);if(pe(t)||!t.output||!t.input&&0!==t.avail_in)return _e;a=t.state,16191===a.mode&&(a.mode=16192),r=t.next_out,n=t.output,l=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,h=a.hold,d=a.bits,_=o,f=l,x=le;t:for(;;)switch(a.mode){case 16180:if(0===a.wrap){a.mode=16192;break}for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(2&a.wrap&&35615===h){0===a.wbits&&(a.wbits=15),a.check=0,A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0),h=0,d=0,a.mode=16181;break}if(a.head&&(a.head.done=!1),!(1&a.wrap)||(((255&h)<<8)+(h>>8))%31){t.msg="incorrect header check",a.mode=me;break}if((15&h)!==we){t.msg="unknown compression method",a.mode=me;break}if(h>>>=4,d-=4,y=8+(15&h),0===a.wbits&&(a.wbits=y),y>15||y>a.wbits){t.msg="invalid window size",a.mode=me;break}a.dmax=1<<a.wbits,a.flags=0,t.adler=a.check=1,a.mode=512&h?16189:16191,h=0,d=0;break;case 16181:for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(a.flags=h,(255&a.flags)!==we){t.msg="unknown compression method",a.mode=me;break}if(57344&a.flags){t.msg="unknown header flags set",a.mode=me;break}a.head&&(a.head.text=h>>8&1),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0,a.mode=16182;case 16182:for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.head&&(a.head.time=h),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,A[2]=h>>>16&255,A[3]=h>>>24&255,a.check=N(a.check,A,4,0)),h=0,d=0,a.mode=16183;case 16183:for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.head&&(a.head.xflags=255&h,a.head.os=h>>8),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0,a.mode=16184;case 16184:if(1024&a.flags){for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.length=h,a.head&&(a.head.extra_len=h),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0}else a.head&&(a.head.extra=null);a.mode=16185;case 16185:if(1024&a.flags&&(c=a.length,c>o&&(c=o),c&&(a.head&&(y=a.head.extra_len-a.length,a.head.extra||(a.head.extra=new Uint8Array(a.head.extra_len)),a.head.extra.set(i.subarray(s,s+c),y)),512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,a.length-=c),a.length))break t;a.length=0,a.mode=16186;case 16186:if(2048&a.flags){if(0===o)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.name+=String.fromCharCode(y))}while(y&&c<o);if(512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,y)break t}else a.head&&(a.head.name=null);a.length=0,a.mode=16187;case 16187:if(4096&a.flags){if(0===o)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.comment+=String.fromCharCode(y))}while(y&&c<o);if(512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,y)break t}else a.head&&(a.head.comment=null);a.mode=16188;case 16188:if(512&a.flags){for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(4&a.wrap&&h!==(65535&a.check)){t.msg="header crc mismatch",a.mode=me;break}h=0,d=0}a.head&&(a.head.hcrc=a.flags>>9&1,a.head.done=!0),t.adler=a.check=0,a.mode=16191;break;case 16189:for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}t.adler=a.check=be(h),h=0,d=0,a.mode=16190;case 16190:if(0===a.havedict)return t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,de;t.adler=a.check=1,a.mode=16191;case 16191:if(e===re||e===oe)break t;case 16192:if(a.last){h>>>=7&d,d-=7&d,a.mode=16206;break}for(;d<3;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}switch(a.last=1&h,h>>>=1,d-=1,3&h){case 0:a.mode=16193;break;case 1:if(Re(a),a.mode=16199,e===oe){h>>>=2,d-=2;break t}break;case 2:a.mode=16196;break;case 3:t.msg="invalid block type",a.mode=me}h>>>=2,d-=2;break;case 16193:for(h>>>=7&d,d-=7&d;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if((65535&h)!=(h>>>16^65535)){t.msg="invalid stored block lengths",a.mode=me;break}if(a.length=65535&h,h=0,d=0,a.mode=16194,e===oe)break t;case 16194:a.mode=16195;case 16195:if(c=a.length,c){if(c>o&&(c=o),c>l&&(c=l),0===c)break t;n.set(i.subarray(s,s+c),r),o-=c,s+=c,l-=c,r+=c,a.length-=c;break}a.mode=16191;break;case 16196:for(;d<14;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(a.nlen=257+(31&h),h>>>=5,d-=5,a.ndist=1+(31&h),h>>>=5,d-=5,a.ncode=4+(15&h),h>>>=4,d-=4,a.nlen>286||a.ndist>30){t.msg="too many length or distance symbols",a.mode=me;break}a.have=0,a.mode=16197;case 16197:for(;a.have<a.ncode;){for(;d<3;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.lens[Z[a.have++]]=7&h,h>>>=3,d-=3}for(;a.have<19;)a.lens[Z[a.have++]]=0;if(a.lencode=a.lendyn,a.lenbits=7,E={bits:a.lenbits},x=ne(0,a.lens,0,19,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid code lengths set",a.mode=me;break}a.have=0,a.mode=16198;case 16198:for(;a.have<a.nlen+a.ndist;){for(;z=a.lencode[h&(1<<a.lenbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(g<16)h>>>=m,d-=m,a.lens[a.have++]=g;else{if(16===g){for(R=m+2;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(h>>>=m,d-=m,0===a.have){t.msg="invalid bit length repeat",a.mode=me;break}y=a.lens[a.have-1],c=3+(3&h),h>>>=2,d-=2}else if(17===g){for(R=m+3;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=m,d-=m,y=0,c=3+(7&h),h>>>=3,d-=3}else{for(R=m+7;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=m,d-=m,y=0,c=11+(127&h),h>>>=7,d-=7}if(a.have+c>a.nlen+a.ndist){t.msg="invalid bit length repeat",a.mode=me;break}for(;c--;)a.lens[a.have++]=y}}if(a.mode===me)break;if(0===a.lens[256]){t.msg="invalid code -- missing end-of-block",a.mode=me;break}if(a.lenbits=9,E={bits:a.lenbits},x=ne(1,a.lens,0,a.nlen,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid literal/lengths set",a.mode=me;break}if(a.distbits=6,a.distcode=a.distdyn,E={bits:a.distbits},x=ne(2,a.lens,a.nlen,a.ndist,a.distcode,0,a.work,E),a.distbits=E.bits,x){t.msg="invalid distances set",a.mode=me;break}if(a.mode=16199,e===oe)break t;case 16199:a.mode=16200;case 16200:if(o>=6&&l>=258){t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,$t(t,f),r=t.next_out,n=t.output,l=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,h=a.hold,d=a.bits,16191===a.mode&&(a.back=-1);break}for(a.back=0;z=a.lencode[h&(1<<a.lenbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(b&&0==(240&b)){for(p=m,k=b,v=g;z=a.lencode[v+((h&(1<<p+k)-1)>>p)],m=z>>>24,b=z>>>16&255,g=65535&z,!(p+m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=p,d-=p,a.back+=p}if(h>>>=m,d-=m,a.back+=m,a.length=g,0===b){a.mode=16205;break}if(32&b){a.back=-1,a.mode=16191;break}if(64&b){t.msg="invalid literal/length code",a.mode=me;break}a.extra=15&b,a.mode=16201;case 16201:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.length+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra}a.was=a.length,a.mode=16202;case 16202:for(;z=a.distcode[h&(1<<a.distbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(0==(240&b)){for(p=m,k=b,v=g;z=a.distcode[v+((h&(1<<p+k)-1)>>p)],m=z>>>24,b=z>>>16&255,g=65535&z,!(p+m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=p,d-=p,a.back+=p}if(h>>>=m,d-=m,a.back+=m,64&b){t.msg="invalid distance code",a.mode=me;break}a.offset=g,a.extra=15&b,a.mode=16203;case 16203:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.offset+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra}if(a.offset>a.dmax){t.msg="invalid distance too far back",a.mode=me;break}a.mode=16204;case 16204:if(0===l)break t;if(c=f-l,a.offset>c){if(c=a.offset-c,c>a.whave&&a.sane){t.msg="invalid distance too far back",a.mode=me;break}c>a.wnext?(c-=a.wnext,u=a.wsize-c):u=a.wnext-c,c>a.length&&(c=a.length),w=a.window}else w=n,u=r-a.offset,c=a.length;c>l&&(c=l),l-=c,a.length-=c;do{n[r++]=w[u++]}while(--c);0===a.length&&(a.mode=16200);break;case 16205:if(0===l)break t;n[r++]=a.length,l--,a.mode=16200;break;case 16206:if(a.wrap){for(;d<32;){if(0===o)break t;o--,h|=i[s++]<<d,d+=8}if(f-=l,t.total_out+=f,a.total+=f,4&a.wrap&&f&&(t.adler=a.check=a.flags?N(a.check,n,f,r-f):F(a.check,n,f,r-f)),f=l,4&a.wrap&&(a.flags?h:be(h))!==a.check){t.msg="incorrect data check",a.mode=me;break}h=0,d=0}a.mode=16207;case 16207:if(a.wrap&&a.flags){for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(4&a.wrap&&h!==(4294967295&a.total)){t.msg="incorrect length check",a.mode=me;break}h=0,d=0}a.mode=16208;case 16208:x=he;break t;case me:x=fe;break t;case 16210:return ce;default:return _e}return t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,(a.wsize||f!==t.avail_out&&a.mode<me&&(a.mode<16206||e!==se))&&Ze(t,t.output,t.next_out,f-t.avail_out),_-=t.avail_in,f-=t.avail_out,t.total_in+=_,t.total_out+=f,a.total+=f,4&a.wrap&&f&&(t.adler=a.check=a.flags?N(a.check,n,f,t.next_out-f):F(a.check,n,f,t.next_out-f)),t.data_type=a.bits+(a.last?64:0)+(16191===a.mode?128:0)+(16199===a.mode||16194===a.mode?256:0),(0===_&&0===f||e===se)&&x===le&&(x=ue),x},inflateEnd:t=>{if(pe(t))return _e;let e=t.state;return e.window&&(e.window=null),t.state=null,le},inflateGetHeader:(t,e)=>{if(pe(t))return _e;const a=t.state;return 0==(2&a.wrap)?_e:(a.head=e,e.done=!1,le)},inflateSetDictionary:(t,e)=>{const a=e.length;let i,n,s;return pe(t)?_e:(i=t.state,0!==i.wrap&&16190!==i.mode?_e:16190===i.mode&&(n=1,n=F(n,e,a,0),n!==i.check)?fe:(s=Ze(t,e,a,a),s?(i.mode=16210,ce):(i.havedict=1,le)))},inflateInfo:"pako inflate (from Nodeca project)"};var Se=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1};const De=Object.prototype.toString,{Z_NO_FLUSH:Te,Z_FINISH:Oe,Z_OK:Fe,Z_STREAM_END:Le,Z_NEED_DICT:Ne,Z_STREAM_ERROR:Ie,Z_DATA_ERROR:Be,Z_MEM_ERROR:Ce}=B;function He(t){this.options=Tt({chunkSize:65536,windowBits:15,to:""},t||{});const e=this.options;e.raw&&e.windowBits>=0&&e.windowBits<16&&(e.windowBits=-e.windowBits,0===e.windowBits&&(e.windowBits=-15)),!(e.windowBits>=0&&e.windowBits<16)||t&&t.windowBits||(e.windowBits+=32),e.windowBits>15&&e.windowBits<48&&0==(15&e.windowBits)&&(e.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;let a=Ue.inflateInit2(this.strm,e.windowBits);if(a!==Fe)throw new Error(I[a]);if(this.header=new Se,Ue.inflateGetHeader(this.strm,this.header),e.dictionary&&("string"==typeof e.dictionary?e.dictionary=Nt(e.dictionary):"[object ArrayBuffer]"===De.call(e.dictionary)&&(e.dictionary=new Uint8Array(e.dictionary)),e.raw&&(a=Ue.inflateSetDictionary(this.strm,e.dictionary),a!==Fe)))throw new Error(I[a])}He.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize,n=this.options.dictionary;let s,r,o;if(this.ended)return!1;for(r=e===~~e?e:!0===e?Oe:Te,"[object ArrayBuffer]"===De.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;){for(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),s=Ue.inflate(a,r),s===Ne&&n&&(s=Ue.inflateSetDictionary(a,n),s===Fe?s=Ue.inflate(a,r):s===Be&&(s=Ne));a.avail_in>0&&s===Le&&a.state.wrap>0&&0!==t[a.next_in];)Ue.inflateReset(a),s=Ue.inflate(a,r);switch(s){case Ie:case Be:case Ne:case Ce:return this.onEnd(s),this.ended=!0,!1}if(o=a.avail_out,a.next_out&&(0===a.avail_out||s===Le))if("string"===this.options.to){let t=Bt(a.output,a.next_out),e=a.next_out-t,n=It(a.output,t);a.next_out=e,a.avail_out=i-e,e&&a.output.set(a.output.subarray(t,t+e),0),this.onData(n)}else this.onData(a.output.length===a.next_out?a.output:a.output.subarray(0,a.next_out));if(s!==Fe||0!==o){if(s===Le)return s=Ue.inflateEnd(this.strm),this.onEnd(s),this.ended=!0,!0;if(0===a.avail_in)break}}return!0},He.prototype.onData=function(t){this.chunks.push(t)},He.prototype.onEnd=function(t){t===Fe&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=Ot(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};const{Deflate:Me,deflate:je,deflateRaw:Ke,gzip:Pe}=Vt;var Ye=Me,Ge=je,Xe=B;const We=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const e=this._hasEvents?",":"";this.deflate.push(e+t,Xe.Z_SYNC_FLUSH),this._hasEvents=!0}finish(){if(this.deflate.push("]",Xe.Z_FINISH),this.deflate.err)throw this.deflate.err;const t=this.deflate.result;return this._init(),t}_init(){this._hasEvents=!1,this.deflate=new Ye,this.deflate.push("[",Xe.Z_NO_FLUSH)}},qe={clear:()=>{We.clear()},addEvent:t=>We.addEvent(t),finish:()=>We.finish(),compress:t=>function(t){return Ge(t)}(t)};addEventListener("message",(function(t){const e=t.data.method,a=t.data.id,i=t.data.arg;if(e in qe&&"function"==typeof qe[e])try{const t=qe[e](i);postMessage({id:a,method:e,success:!0,response:t})}catch(t){postMessage({id:a,method:e,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $af5eb29b940bd654$var$e() {
    const e = new Blob([
        $af5eb29b940bd654$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $af5eb29b940bd654$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ constructor(){
        this.events = [];
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return 'sync';
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.events = [];
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $af5eb29b940bd654$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $af5eb29b940bd654$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener('message', ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener('error', (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Replay] Destroying compression worker');
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener('message', listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error('[Replay]', response.response);
                    reject(new Error('Error in compression worker'));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener('message', listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $af5eb29b940bd654$var$EventBufferCompressionWorker {
    constructor(worker){
        this._worker = new $af5eb29b940bd654$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return 'worker';
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $af5eb29b940bd654$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        return this._sendEventToWorker(event);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage('clear');
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(event) {
        return this._worker.postMessage('addEvent', JSON.stringify(event));
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage('finish');
        this._earliestTimestamp = null;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $af5eb29b940bd654$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $af5eb29b940bd654$var$EventBufferArray();
        this._compression = new $af5eb29b940bd654$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Replay] Failed to load the compression worker, falling back to simple buffer');
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('[Replay] Failed to add events when switching buffers.', error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $af5eb29b940bd654$var$createEventBuffer({ useCompression: useCompression }) {
    // eslint-disable-next-line no-restricted-globals
    if (useCompression && window.Worker) try {
        const workerUrl = $af5eb29b940bd654$var$e();
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Replay] Using compression worker');
        const worker = new Worker(workerUrl);
        return new $af5eb29b940bd654$var$EventBufferProxy(worker);
    } catch (error) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Replay] Failed to create compression worker');
    // Fall back to use simple event buffer array
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Replay] Using simple buffer');
    return new $af5eb29b940bd654$var$EventBufferArray();
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $af5eb29b940bd654$var$clearSession(replay) {
    $af5eb29b940bd654$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $af5eb29b940bd654$var$deleteSession() {
    const hasSessionStorage = 'sessionStorage' in $af5eb29b940bd654$var$WINDOW;
    if (!hasSessionStorage) return;
    try {
        $af5eb29b940bd654$var$WINDOW.sessionStorage.removeItem($af5eb29b940bd654$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $af5eb29b940bd654$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $af5eb29b940bd654$var$isSessionExpired(session, timeouts, targetTime = +new Date()) {
    return(// First, check that maximum session length has not been exceeded
    $af5eb29b940bd654$var$isExpired(session.started, timeouts.maxSessionLife, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $af5eb29b940bd654$var$isExpired(session.lastActivity, timeouts.sessionIdleExpire, targetTime));
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $af5eb29b940bd654$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Save a session to session storage.
 */ function $af5eb29b940bd654$var$saveSession(session) {
    const hasSessionStorage = 'sessionStorage' in $af5eb29b940bd654$var$WINDOW;
    if (!hasSessionStorage) return;
    try {
        $af5eb29b940bd654$var$WINDOW.sessionStorage.setItem($af5eb29b940bd654$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get a session with defaults & applied sampling.
 */ function $af5eb29b940bd654$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $65d42e3833054e5c$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        shouldRefresh: true
    };
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $af5eb29b940bd654$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $af5eb29b940bd654$var$isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $af5eb29b940bd654$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }) {
    const sampled = $af5eb29b940bd654$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $af5eb29b940bd654$var$makeSession({
        sampled: sampled
    });
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log(`[Replay] Creating new session: ${session.id}`);
    if (stickySession) $af5eb29b940bd654$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $af5eb29b940bd654$var$fetchSession() {
    const hasSessionStorage = 'sessionStorage' in $af5eb29b940bd654$var$WINDOW;
    if (!hasSessionStorage) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $af5eb29b940bd654$var$WINDOW.sessionStorage.getItem($af5eb29b940bd654$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        return $af5eb29b940bd654$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Get or create a session
 */ function $af5eb29b940bd654$var$getSession({ timeouts: timeouts, currentSession: currentSession, stickySession: stickySession, sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering }) {
    // If session exists and is passed, use it instead of always hitting session storage
    const session = currentSession || stickySession && $af5eb29b940bd654$var$fetchSession();
    if (session) {
        // If there is a session, check if it is valid (e.g. "last activity" time
        // should be within the "session idle time", and "session started" time is
        // within "max session time").
        const isExpired = $af5eb29b940bd654$var$isSessionExpired(session, timeouts);
        if (!isExpired) return {
            type: 'saved',
            session: session
        };
        else if (!session.shouldRefresh) {
            // In this case, stop
            // This is the case if we have an error session that is completed (=triggered an error)
            const discardedSession = $af5eb29b940bd654$var$makeSession({
                sampled: false
            });
            return {
                type: 'new',
                session: discardedSession
            };
        } else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Replay] Session has expired');
    // Otherwise continue to create a new session
    }
    const newSession = $af5eb29b940bd654$var$createSession({
        stickySession: stickySession,
        sessionSampleRate: sessionSampleRate,
        allowBuffering: allowBuffering
    });
    return {
        type: 'new',
        session: newSession
    };
}
/** If the event is an error event */ function $af5eb29b940bd654$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $af5eb29b940bd654$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** If the event is an replay event */ function $af5eb29b940bd654$var$isReplayEvent(event) {
    return event.type === 'replay_event';
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $af5eb29b940bd654$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $af5eb29b940bd654$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!$af5eb29b940bd654$var$isErrorEvent(event) && !$af5eb29b940bd654$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        // Collect traceIds in _context regardless of `recordingMode`
        // In error mode, _context gets cleared on every checkout
        if ($af5eb29b940bd654$var$isTransactionEvent(event) && event.contexts && event.contexts.trace && event.contexts.trace.trace_id) {
            replay.getContext().traceIds.add(event.contexts.trace.trace_id);
            return;
        }
        // Everything below is just for error events
        if (!$af5eb29b940bd654$var$isErrorEvent(event)) return;
        // Add error to list of errorIds of replay. This is ok to do even if not
        // sampled because context will get reset at next checkout.
        // XXX: There is also a race condition where it's possible to capture an
        // error to Sentry before Replay SDK has loaded, but response returns after
        // it was loaded, and this gets called.
        if (event.event_id) replay.getContext().errorIds.add(event.event_id);
        // If error event is tagged with replay id it means it was sampled (when in buffer mode)
        // Need to be very careful that this does not cause an infinite loop
        if (replay.recordingMode === 'buffer' && event.tags && event.tags.replayId) setTimeout(()=>{
            // Capture current event buffer as new replay
            replay.sendBufferedReplayOrFlush();
        });
    };
}
function $af5eb29b940bd654$var$isBaseTransportSend() {
    const client = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getClient();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $af5eb29b940bd654$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-ignore this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    // Check if any exception originates from rrweb
    return event.exception.values.some((exception)=>{
        if (!exception.stacktrace || !exception.stacktrace.frames || !exception.stacktrace.frames.length) return false;
        return exception.stacktrace.frames.some((frame)=>frame.filename && frame.filename.includes('/rrweb/src/'));
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $af5eb29b940bd654$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== 'buffer') return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $af5eb29b940bd654$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $af5eb29b940bd654$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addGlobalEventProcessor(listener)`.
 */ function $af5eb29b940bd654$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $af5eb29b940bd654$var$handleAfterSendEvent(replay) : undefined;
    return (event, hint)=>{
        if ($af5eb29b940bd654$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors & transactions, nothing else
        if (!$af5eb29b940bd654$var$isErrorEvent(event) && !$af5eb29b940bd654$var$isTransactionEvent(event)) return event;
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($af5eb29b940bd654$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Replay] Ignoring error from rrweb internals', event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $af5eb29b940bd654$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && replay.getOptions()._experiments.traceInternals && $af5eb29b940bd654$var$isErrorEvent(event)) {
            const exc = $af5eb29b940bd654$var$getEventExceptionValues(event);
            $af5eb29b940bd654$var$addInternalBreadcrumb({
                message: `Tagging event (${event.event_id}) - ${event.message} - ${exc.type}: ${exc.value}`
            });
        }
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    };
}
function $af5eb29b940bd654$var$addInternalBreadcrumb(arg) {
    const { category: category, level: level, message: message, ...rest } = arg;
    (0, $7364f12ad7fd150c$export$efda9a273d7a036d)({
        category: category || 'console',
        level: level || 'debug',
        message: `[debug]: ${message}`,
        ...rest
    });
}
function $af5eb29b940bd654$var$getEventExceptionValues(event) {
    return {
        type: 'Unknown',
        value: 'n/a',
        ...event.exception && event.exception.values && event.exception.values[0]
    };
}
/**
 * Create a "span" for each performance entry. The parent transaction is `this.replayEvent`.
 */ function $af5eb29b940bd654$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>$af5eb29b940bd654$var$addEvent(replay, {
            type: $af5eb29b940bd654$var$EventType$1.Custom,
            timestamp: start,
            data: {
                tag: 'performanceSpan',
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        }));
}
function $af5eb29b940bd654$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: 'navigation.push',
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addInstrumentationHandler('history', listener)`.
 */ function $af5eb29b940bd654$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $af5eb29b940bd654$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $af5eb29b940bd654$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $af5eb29b940bd654$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && replay.getOptions()._experiments.traceInternals) return false;
    return $af5eb29b940bd654$var$_isSentryRequest(url);
}
/**
 * Checks wether a given URL belongs to the configured Sentry DSN.
 */ function $af5eb29b940bd654$var$_isSentryRequest(url) {
    const client = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getClient();
    const dsn = client && client.getDsn();
    return dsn ? url.includes(dsn.host) : false;
}
/** Add a performance entry breadcrumb */ function $af5eb29b940bd654$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($af5eb29b940bd654$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $af5eb29b940bd654$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $af5eb29b940bd654$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, fetchData: fetchData, response: response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url } = fetchData;
    return {
        type: 'resource.fetch',
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response && response.status
        }
    };
}
/**
 * Returns a listener to be added to `addInstrumentationHandler('fetch', listener)`.
 */ function $af5eb29b940bd654$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $af5eb29b940bd654$var$handleFetch(handlerData);
        $af5eb29b940bd654$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $af5eb29b940bd654$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, xhr: xhr } = handlerData;
    const sentryXhrData = xhr[0, $d43610efe653d8f1$export$55b6bb1e45c6cf59];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: 'resource.xhr',
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addInstrumentationHandler('xhr', listener)`.
 */ function $af5eb29b940bd654$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $af5eb29b940bd654$var$handleXhr(handlerData);
        $af5eb29b940bd654$var$addNetworkBreadcrumb(replay, result);
    };
}
const $af5eb29b940bd654$var$OBJ = 10;
const $af5eb29b940bd654$var$OBJ_KEY = 11;
const $af5eb29b940bd654$var$OBJ_KEY_STR = 12;
const $af5eb29b940bd654$var$OBJ_VAL = 13;
const $af5eb29b940bd654$var$OBJ_VAL_STR = 14;
const $af5eb29b940bd654$var$OBJ_VAL_COMPLETED = 15;
const $af5eb29b940bd654$var$ARR = 20;
const $af5eb29b940bd654$var$ARR_VAL = 21;
const $af5eb29b940bd654$var$ARR_VAL_STR = 22;
const $af5eb29b940bd654$var$ARR_VAL_COMPLETED = 23;
const $af5eb29b940bd654$var$ALLOWED_PRIMITIVES = [
    'true',
    'false',
    'null'
];
/**
 * Complete an incomplete JSON string.
 * This will ensure that the last element always has a `"~~"` to indicate it was truncated.
 * For example, `[1,2,` will be completed to `[1,2,"~~"]`
 * and `{"aa":"b` will be completed to `{"aa":"b~~"}`
 */ function $af5eb29b940bd654$var$completeJson(incompleteJson, stack) {
    if (!stack.length) return incompleteJson;
    let json = incompleteJson;
    // Most checks are only needed for the last step in the stack
    const lastPos = stack.length - 1;
    const lastStep = stack[lastPos];
    json = $af5eb29b940bd654$var$_fixLastStep(json, lastStep);
    // Complete remaining steps - just add closing brackets
    for(let i = lastPos; i >= 0; i--){
        const step = stack[i];
        switch(step){
            case $af5eb29b940bd654$var$OBJ:
                json = `${json}}`;
                break;
            case $af5eb29b940bd654$var$ARR:
                json = `${json}]`;
                break;
        }
    }
    return json;
}
function $af5eb29b940bd654$var$_fixLastStep(json, lastStep) {
    switch(lastStep){
        // Object cases
        case $af5eb29b940bd654$var$OBJ:
            return `${json}"~~":"~~"`;
        case $af5eb29b940bd654$var$OBJ_KEY:
            return `${json}:"~~"`;
        case $af5eb29b940bd654$var$OBJ_KEY_STR:
            return `${json}~~":"~~"`;
        case $af5eb29b940bd654$var$OBJ_VAL:
            return $af5eb29b940bd654$var$_maybeFixIncompleteObjValue(json);
        case $af5eb29b940bd654$var$OBJ_VAL_STR:
            return `${json}~~"`;
        case $af5eb29b940bd654$var$OBJ_VAL_COMPLETED:
            return `${json},"~~":"~~"`;
        // Array cases
        case $af5eb29b940bd654$var$ARR:
            return `${json}"~~"`;
        case $af5eb29b940bd654$var$ARR_VAL:
            return $af5eb29b940bd654$var$_maybeFixIncompleteArrValue(json);
        case $af5eb29b940bd654$var$ARR_VAL_STR:
            return `${json}~~"`;
        case $af5eb29b940bd654$var$ARR_VAL_COMPLETED:
            return `${json},"~~"`;
    }
    return json;
}
function $af5eb29b940bd654$var$_maybeFixIncompleteArrValue(json) {
    const pos = $af5eb29b940bd654$var$_findLastArrayDelimiter(json);
    if (pos > -1) {
        const part = json.slice(pos + 1);
        if ($af5eb29b940bd654$var$ALLOWED_PRIMITIVES.includes(part.trim())) return `${json},"~~"`;
        // Everything else is replaced with `"~~"`
        return `${json.slice(0, pos + 1)}"~~"`;
    }
    // fallback, this shouldn't happen, to be save
    return json;
}
function $af5eb29b940bd654$var$_findLastArrayDelimiter(json) {
    for(let i = json.length - 1; i >= 0; i--){
        const char = json[i];
        if (char === ',' || char === '[') return i;
    }
    return -1;
}
function $af5eb29b940bd654$var$_maybeFixIncompleteObjValue(json) {
    const startPos = json.lastIndexOf(':');
    const part = json.slice(startPos + 1);
    if ($af5eb29b940bd654$var$ALLOWED_PRIMITIVES.includes(part.trim())) return `${json},"~~":"~~"`;
    // Everything else is replaced with `"~~"`
    // This also means we do not have incomplete numbers, e.g `[1` is replaced with `["~~"]`
    return `${json.slice(0, startPos + 1)}"~~"`;
}
/**
 * Evaluate an (incomplete) JSON string.
 */ function $af5eb29b940bd654$var$evaluateJson(json) {
    const stack = [];
    for(let pos = 0; pos < json.length; pos++)$af5eb29b940bd654$var$_evaluateJsonPos(stack, json, pos);
    return stack;
}
function $af5eb29b940bd654$var$_evaluateJsonPos(stack, json, pos) {
    const curStep = stack[stack.length - 1];
    const char = json[pos];
    const whitespaceRegex = /\s/;
    if (whitespaceRegex.test(char)) return;
    if (char === '"' && !$af5eb29b940bd654$var$_isEscaped(json, pos)) {
        $af5eb29b940bd654$var$_handleQuote(stack, curStep);
        return;
    }
    switch(char){
        case '{':
            $af5eb29b940bd654$var$_handleObj(stack, curStep);
            break;
        case '[':
            $af5eb29b940bd654$var$_handleArr(stack, curStep);
            break;
        case ':':
            $af5eb29b940bd654$var$_handleColon(stack, curStep);
            break;
        case ',':
            $af5eb29b940bd654$var$_handleComma(stack, curStep);
            break;
        case '}':
            $af5eb29b940bd654$var$_handleObjClose(stack, curStep);
            break;
        case ']':
            $af5eb29b940bd654$var$_handleArrClose(stack, curStep);
            break;
    }
}
function $af5eb29b940bd654$var$_handleQuote(stack, curStep) {
    // End of obj value
    if (curStep === $af5eb29b940bd654$var$OBJ_VAL_STR) {
        stack.pop();
        stack.push($af5eb29b940bd654$var$OBJ_VAL_COMPLETED);
        return;
    }
    // End of arr value
    if (curStep === $af5eb29b940bd654$var$ARR_VAL_STR) {
        stack.pop();
        stack.push($af5eb29b940bd654$var$ARR_VAL_COMPLETED);
        return;
    }
    // Start of obj value
    if (curStep === $af5eb29b940bd654$var$OBJ_VAL) {
        stack.push($af5eb29b940bd654$var$OBJ_VAL_STR);
        return;
    }
    // Start of arr value
    if (curStep === $af5eb29b940bd654$var$ARR_VAL) {
        stack.push($af5eb29b940bd654$var$ARR_VAL_STR);
        return;
    }
    // Start of obj key
    if (curStep === $af5eb29b940bd654$var$OBJ) {
        stack.push($af5eb29b940bd654$var$OBJ_KEY_STR);
        return;
    }
    // End of obj key
    if (curStep === $af5eb29b940bd654$var$OBJ_KEY_STR) {
        stack.pop();
        stack.push($af5eb29b940bd654$var$OBJ_KEY);
        return;
    }
}
function $af5eb29b940bd654$var$_handleObj(stack, curStep) {
    // Initial object
    if (!curStep) {
        stack.push($af5eb29b940bd654$var$OBJ);
        return;
    }
    // New object as obj value
    if (curStep === $af5eb29b940bd654$var$OBJ_VAL) {
        stack.push($af5eb29b940bd654$var$OBJ);
        return;
    }
    // New object as array element
    if (curStep === $af5eb29b940bd654$var$ARR_VAL) stack.push($af5eb29b940bd654$var$OBJ);
    // New object as first array element
    if (curStep === $af5eb29b940bd654$var$ARR) {
        stack.push($af5eb29b940bd654$var$OBJ);
        return;
    }
}
function $af5eb29b940bd654$var$_handleArr(stack, curStep) {
    // Initial array
    if (!curStep) {
        stack.push($af5eb29b940bd654$var$ARR);
        stack.push($af5eb29b940bd654$var$ARR_VAL);
        return;
    }
    // New array as obj value
    if (curStep === $af5eb29b940bd654$var$OBJ_VAL) {
        stack.push($af5eb29b940bd654$var$ARR);
        stack.push($af5eb29b940bd654$var$ARR_VAL);
        return;
    }
    // New array as array element
    if (curStep === $af5eb29b940bd654$var$ARR_VAL) {
        stack.push($af5eb29b940bd654$var$ARR);
        stack.push($af5eb29b940bd654$var$ARR_VAL);
    }
    // New array as first array element
    if (curStep === $af5eb29b940bd654$var$ARR) {
        stack.push($af5eb29b940bd654$var$ARR);
        stack.push($af5eb29b940bd654$var$ARR_VAL);
        return;
    }
}
function $af5eb29b940bd654$var$_handleColon(stack, curStep) {
    if (curStep === $af5eb29b940bd654$var$OBJ_KEY) {
        stack.pop();
        stack.push($af5eb29b940bd654$var$OBJ_VAL);
    }
}
function $af5eb29b940bd654$var$_handleComma(stack, curStep) {
    // Comma after obj value
    if (curStep === $af5eb29b940bd654$var$OBJ_VAL) {
        stack.pop();
        return;
    }
    if (curStep === $af5eb29b940bd654$var$OBJ_VAL_COMPLETED) {
        // Pop OBJ_VAL_COMPLETED & OBJ_VAL
        stack.pop();
        stack.pop();
        return;
    }
    // Comma after arr value
    if (curStep === $af5eb29b940bd654$var$ARR_VAL) // do nothing - basically we'd pop ARR_VAL but add it right back
    return;
    if (curStep === $af5eb29b940bd654$var$ARR_VAL_COMPLETED) {
        // Pop ARR_VAL_COMPLETED
        stack.pop();
        // basically we'd pop ARR_VAL but add it right back
        return;
    }
}
function $af5eb29b940bd654$var$_handleObjClose(stack, curStep) {
    // Empty object {}
    if (curStep === $af5eb29b940bd654$var$OBJ) stack.pop();
    // Object with element
    if (curStep === $af5eb29b940bd654$var$OBJ_VAL) {
        // Pop OBJ_VAL, OBJ
        stack.pop();
        stack.pop();
    }
    // Obj with element
    if (curStep === $af5eb29b940bd654$var$OBJ_VAL_COMPLETED) {
        // Pop OBJ_VAL_COMPLETED, OBJ_VAL, OBJ
        stack.pop();
        stack.pop();
        stack.pop();
    }
    // if was obj value, complete it
    if (stack[stack.length - 1] === $af5eb29b940bd654$var$OBJ_VAL) stack.push($af5eb29b940bd654$var$OBJ_VAL_COMPLETED);
    // if was arr value, complete it
    if (stack[stack.length - 1] === $af5eb29b940bd654$var$ARR_VAL) stack.push($af5eb29b940bd654$var$ARR_VAL_COMPLETED);
}
function $af5eb29b940bd654$var$_handleArrClose(stack, curStep) {
    // Empty array []
    if (curStep === $af5eb29b940bd654$var$ARR) stack.pop();
    // Array with element
    if (curStep === $af5eb29b940bd654$var$ARR_VAL) {
        // Pop ARR_VAL, ARR
        stack.pop();
        stack.pop();
    }
    // Array with element
    if (curStep === $af5eb29b940bd654$var$ARR_VAL_COMPLETED) {
        // Pop ARR_VAL_COMPLETED, ARR_VAL, ARR
        stack.pop();
        stack.pop();
        stack.pop();
    }
    // if was obj value, complete it
    if (stack[stack.length - 1] === $af5eb29b940bd654$var$OBJ_VAL) stack.push($af5eb29b940bd654$var$OBJ_VAL_COMPLETED);
    // if was arr value, complete it
    if (stack[stack.length - 1] === $af5eb29b940bd654$var$ARR_VAL) stack.push($af5eb29b940bd654$var$ARR_VAL_COMPLETED);
}
function $af5eb29b940bd654$var$_isEscaped(str, pos) {
    const previousChar = str[pos - 1];
    return previousChar === '\\' && !$af5eb29b940bd654$var$_isEscaped(str, pos - 1);
}
/* eslint-disable max-lines */ /**
 * Takes an incomplete JSON string, and returns a hopefully valid JSON string.
 * Note that this _can_ fail, so you should check the return value is valid JSON.
 */ function $af5eb29b940bd654$var$fixJson(incompleteJson) {
    const stack = $af5eb29b940bd654$var$evaluateJson(incompleteJson);
    return $af5eb29b940bd654$var$completeJson(incompleteJson, stack);
}
/** Get the size of a body. */ function $af5eb29b940bd654$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === 'string') return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $af5eb29b940bd654$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $af5eb29b940bd654$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $af5eb29b940bd654$var$getBodyString(body) {
    if (typeof body === 'string') return body;
    if (body instanceof URLSearchParams) return body.toString();
    if (body instanceof FormData) return $af5eb29b940bd654$var$_serializeFormData(body);
    return undefined;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $af5eb29b940bd654$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $c7598308515e5ce6$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $af5eb29b940bd654$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                'URL_SKIPPED'
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $af5eb29b940bd654$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $af5eb29b940bd654$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $af5eb29b940bd654$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $af5eb29b940bd654$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-ignore passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $af5eb29b940bd654$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== 'string') return {
        body: body,
        warnings: []
    };
    const exceedsSizeLimit = body.length > $af5eb29b940bd654$var$NETWORK_BODY_MAX_SIZE;
    if ($af5eb29b940bd654$var$_strIsProbablyJson(body)) try {
        const json = exceedsSizeLimit ? $af5eb29b940bd654$var$fixJson(body.slice(0, $af5eb29b940bd654$var$NETWORK_BODY_MAX_SIZE)) : body;
        const normalizedBody = JSON.parse(json);
        return {
            body: normalizedBody,
            warnings: exceedsSizeLimit ? [
                'JSON_TRUNCATED'
            ] : []
        };
    } catch (e3) {
        return {
            body: exceedsSizeLimit ? `${body.slice(0, $af5eb29b940bd654$var$NETWORK_BODY_MAX_SIZE)}\u{2026}` : body,
            warnings: exceedsSizeLimit ? [
                'INVALID_JSON',
                'TEXT_TRUNCATED'
            ] : [
                'INVALID_JSON'
            ]
        };
    }
    return {
        body: exceedsSizeLimit ? `${body.slice(0, $af5eb29b940bd654$var$NETWORK_BODY_MAX_SIZE)}\u{2026}` : body,
        warnings: exceedsSizeLimit ? [
            'TEXT_TRUNCATED'
        ] : []
    };
}
function $af5eb29b940bd654$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === '[' && last === ']' || first === '{' && last === '}';
}
/** Match an URL against a list of strings/Regex. */ function $af5eb29b940bd654$var$urlMatches(url, urls) {
    const fullUrl = $af5eb29b940bd654$var$getFullUrl(url);
    return (0, $b6e2a386a4033810$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $af5eb29b940bd654$var$getFullUrl(url, baseURI = $af5eb29b940bd654$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith($af5eb29b940bd654$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith('/') && fullUrl.endsWith('/')) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $af5eb29b940bd654$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $af5eb29b940bd654$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $af5eb29b940bd654$var$makeNetworkReplayBreadcrumb('resource.fetch', data);
        $af5eb29b940bd654$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error('[Replay] Failed to capture fetch breadcrumb', error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $af5eb29b940bd654$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input, response: response } = hint;
    const body = $af5eb29b940bd654$var$_getFetchRequestArgBody(input);
    const reqSize = $af5eb29b940bd654$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $af5eb29b940bd654$var$parseContentLengthHeader(response.headers.get('content-length')) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $af5eb29b940bd654$var$_prepareFetchData(breadcrumb, hint, options) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $af5eb29b940bd654$var$urlMatches(url, options.networkDetailAllowUrls);
    const request = captureDetails ? $af5eb29b940bd654$var$_getRequestInfo(options, hint.input, requestBodySize) : $af5eb29b940bd654$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $af5eb29b940bd654$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $af5eb29b940bd654$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = $af5eb29b940bd654$var$getRequestHeaders(input, networkRequestHeaders);
    if (!networkCaptureBodies) return $af5eb29b940bd654$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $af5eb29b940bd654$var$_getFetchRequestArgBody(input);
    const bodyStr = $af5eb29b940bd654$var$getBodyString(requestBody);
    return $af5eb29b940bd654$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
}
async function $af5eb29b940bd654$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $af5eb29b940bd654$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = $af5eb29b940bd654$var$getAllHeaders(response.headers, networkResponseHeaders);
    if (!networkCaptureBodies && responseBodySize !== undefined) return $af5eb29b940bd654$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    // Only clone the response if we need to
    try {
        // We have to clone this, as the body can only be read once
        const res = response.clone();
        const bodyText = await $af5eb29b940bd654$var$_parseFetchBody(res);
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $af5eb29b940bd654$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $af5eb29b940bd654$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $af5eb29b940bd654$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $af5eb29b940bd654$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (e) {
        // fallback
        return $af5eb29b940bd654$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $af5eb29b940bd654$var$_parseFetchBody(response) {
    try {
        return await response.text();
    } catch (e2) {
        return undefined;
    }
}
function $af5eb29b940bd654$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== 'object') return undefined;
    return fetchArgs[1].body;
}
function $af5eb29b940bd654$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $af5eb29b940bd654$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') return $af5eb29b940bd654$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $af5eb29b940bd654$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $af5eb29b940bd654$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $af5eb29b940bd654$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $af5eb29b940bd654$var$getAllowedHeaders(headers, allowedHeaders);
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $af5eb29b940bd654$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $af5eb29b940bd654$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $af5eb29b940bd654$var$makeNetworkReplayBreadcrumb('resource.xhr', data);
        $af5eb29b940bd654$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error('[Replay] Failed to capture fetch breadcrumb', error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $af5eb29b940bd654$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr, input: input } = hint;
    const reqSize = $af5eb29b940bd654$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader('content-length') ? $af5eb29b940bd654$var$parseContentLengthHeader(xhr.getResponseHeader('content-length')) : $af5eb29b940bd654$var$getBodySize(xhr.response, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $af5eb29b940bd654$var$_prepareXhrData(breadcrumb, hint, options) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!$af5eb29b940bd654$var$urlMatches(url, options.networkDetailAllowUrls)) {
        const request = $af5eb29b940bd654$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $af5eb29b940bd654$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $d43610efe653d8f1$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $af5eb29b940bd654$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $af5eb29b940bd654$var$getAllowedHeaders($af5eb29b940bd654$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const request = $af5eb29b940bd654$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, options.networkCaptureBodies ? $af5eb29b940bd654$var$getBodyString(input) : undefined);
    const response = $af5eb29b940bd654$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, options.networkCaptureBodies ? hint.xhr.responseText : undefined);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $af5eb29b940bd654$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $af5eb29b940bd654$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getClient();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on('beforeAddBreadcrumb', (breadcrumb, hint)=>$af5eb29b940bd654$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $d43610efe653d8f1$export$285b9172a3741fb7)('fetch', $af5eb29b940bd654$var$handleFetchSpanListener(replay));
            (0, $d43610efe653d8f1$export$285b9172a3741fb7)('xhr', $af5eb29b940bd654$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $af5eb29b940bd654$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($af5eb29b940bd654$var$_isXhrBreadcrumb(breadcrumb) && $af5eb29b940bd654$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $af5eb29b940bd654$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            $af5eb29b940bd654$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($af5eb29b940bd654$var$_isFetchBreadcrumb(breadcrumb) && $af5eb29b940bd654$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $af5eb29b940bd654$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            $af5eb29b940bd654$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('Error when enriching network breadcrumb');
    }
}
function $af5eb29b940bd654$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'xhr';
}
function $af5eb29b940bd654$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'fetch';
}
function $af5eb29b940bd654$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $af5eb29b940bd654$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $af5eb29b940bd654$var$_LAST_BREADCRUMB = null;
const $af5eb29b940bd654$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $af5eb29b940bd654$var$handleScope(scope);
        if (!result) return;
        $af5eb29b940bd654$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $af5eb29b940bd654$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($af5eb29b940bd654$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $af5eb29b940bd654$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (newBreadcrumb.category && ([
        'fetch',
        'xhr',
        'sentry.event',
        'sentry.transaction'
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith('ui.'))) return null;
    if (newBreadcrumb.category === 'console') return $af5eb29b940bd654$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $af5eb29b940bd654$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $af5eb29b940bd654$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $af5eb29b940bd654$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === 'string') {
            if (arg.length > $af5eb29b940bd654$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $af5eb29b940bd654$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === 'object') try {
            const normalizedArg = (0, $4cc0442f6ee1f737$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $af5eb29b940bd654$var$CONSOLE_ARG_MAX_SIZE) {
                const fixedJson = $af5eb29b940bd654$var$fixJson(stringified.slice(0, $af5eb29b940bd654$var$CONSOLE_ARG_MAX_SIZE));
                const json = JSON.parse(fixedJson);
                // We only set this after JSON.parse() was successfull, so we know we didn't run into `catch`
                isTruncated = true;
                return json;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $af5eb29b940bd654$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        'CONSOLE_ARG_TRUNCATED'
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $af5eb29b940bd654$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getScope();
    const client = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getClient();
    if (scope) scope.addScopeListener($af5eb29b940bd654$var$handleScopeListener(replay));
    (0, $d43610efe653d8f1$export$285b9172a3741fb7)('dom', $af5eb29b940bd654$var$handleDomListener(replay));
    (0, $d43610efe653d8f1$export$285b9172a3741fb7)('history', $af5eb29b940bd654$var$handleHistorySpanListener(replay));
    $af5eb29b940bd654$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    (0, $287ad5dd047650ab$export$8e4e25f54d456511)($af5eb29b940bd654$var$handleGlobalEventListener(replay, !$af5eb29b940bd654$var$hasHooks(client)));
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($af5eb29b940bd654$var$hasHooks(client)) {
        client.on('afterSendEvent', $af5eb29b940bd654$var$handleAfterSendEvent(replay));
        client.on('createDsc', (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === 'session') dsc.replay_id = replayId;
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $af5eb29b940bd654$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $af5eb29b940bd654$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($af5eb29b940bd654$var$createPerformanceSpans(replay, [
            // @ts-ignore memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $af5eb29b940bd654$var$createMemoryEntry($af5eb29b940bd654$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $af5eb29b940bd654$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: 'memory',
        name: 'memory',
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
// Map entryType -> function to normalize data for event
// @ts-ignore TODO: entry type does not fit the create* functions entry type
const $af5eb29b940bd654$var$ENTRY_TYPES = {
    // @ts-ignore TODO: entry type does not fit the create* functions entry type
    resource: $af5eb29b940bd654$var$createResourceEntry,
    paint: $af5eb29b940bd654$var$createPaintEntry,
    // @ts-ignore TODO: entry type does not fit the create* functions entry type
    navigation: $af5eb29b940bd654$var$createNavigationEntry,
    // @ts-ignore TODO: entry type does not fit the create* functions entry type
    ['largest-contentful-paint']: $af5eb29b940bd654$var$createLargestContentfulPaint
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $af5eb29b940bd654$var$createPerformanceEntries(entries) {
    return entries.map($af5eb29b940bd654$var$createPerformanceEntry).filter(Boolean);
}
function $af5eb29b940bd654$var$createPerformanceEntry(entry) {
    if ($af5eb29b940bd654$var$ENTRY_TYPES[entry.entryType] === undefined) return null;
    return $af5eb29b940bd654$var$ENTRY_TYPES[entry.entryType](entry);
}
function $af5eb29b940bd654$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $6CbLG.browserPerformanceTimeOrigin) || $af5eb29b940bd654$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $af5eb29b940bd654$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $af5eb29b940bd654$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $af5eb29b940bd654$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $af5eb29b940bd654$var$getAbsoluteTime(startTime),
        end: $af5eb29b940bd654$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $af5eb29b940bd654$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        'fetch',
        'xmlhttprequest'
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $af5eb29b940bd654$var$getAbsoluteTime(startTime),
        end: $af5eb29b940bd654$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
function $af5eb29b940bd654$var$createLargestContentfulPaint(entry) {
    const { entryType: entryType, startTime: startTime, size: size } = entry;
    let startTimeOrNavigationActivation = 0;
    if ($af5eb29b940bd654$var$WINDOW.performance) {
        const navEntry = $af5eb29b940bd654$var$WINDOW.performance.getEntriesByType('navigation')[0];
        // See https://github.com/GoogleChrome/web-vitals/blob/9f11c4c6578fb4c5ee6fa4e32b9d1d756475f135/src/lib/getActivationStart.ts#L21
        startTimeOrNavigationActivation = navEntry && navEntry.activationStart || 0;
    }
    // value is in ms
    const value = Math.max(startTime - startTimeOrNavigationActivation, 0);
    // LCP doesn't have a "duration", it just happens at a single point in time.
    // But the UI expects both, so use end (in seconds) for both timestamps.
    const end = $af5eb29b940bd654$var$getAbsoluteTime(startTimeOrNavigationActivation) + value / 1000;
    return {
        type: entryType,
        name: entryType,
        start: end,
        end: end,
        data: {
            value: value,
            size: size,
            // Not sure why this errors, Node should be correct (Argument of type 'Node' is not assignable to parameter of type 'INode')
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            nodeId: $af5eb29b940bd654$var$record.mirror.getId(entry.element)
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $af5eb29b940bd654$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $af5eb29b940bd654$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).warn('[Replay] Received replay event after session expired.');
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === 'buffer' && isCheckout) replay.setInitialState();
            // We need to clear existing events on a checkout, otherwise they are
            // incremental event updates and should be appended
            $af5eb29b940bd654$var$addEvent(replay, event, isCheckout);
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $af5eb29b940bd654$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === 'buffer' && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $af5eb29b940bd654$var$saveSession(replay.session);
                }
            }
            const options = replay.getOptions();
            // TODO: We want this as an experiment so that we can test
            // internally and create metrics before making this the default
            if (options._experiments.delayFlushOnCheckout) {
                // If the full snapshot is due to an initial load, we will not have
                // a previous session ID. In this case, we want to buffer events
                // for a set amount of time before flushing. This can help avoid
                // capturing replays of users that immediately close the window.
                setTimeout(()=>replay.conditionalFlush(), options._experiments.delayFlushOnCheckout);
                // Cancel any previously debounced flushes to ensure there are no [near]
                // simultaneous flushes happening. The latter request should be
                // insignificant in this case, so wait for additional user interaction to
                // trigger a new flush.
                //
                // This can happen because there's no guarantee that a recording event
                // happens first. e.g. a mouse click can happen and trigger a debounced
                // flush before the checkout.
                replay.cancelFlush();
                return true;
            }
            // Flush immediately so that we do not miss the first segment, otherwise
            // it can prevent loading on the UI. This will cause an increase in short
            // replays (e.g. opening and closing a tab quickly), but these can be
            // filtered on the UI.
            if (replay.recordingMode === 'session') // We want to ensure the worker is ready, as otherwise we'd always send the first event uncompressed
            replay.flushImmediate();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $af5eb29b940bd654$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $af5eb29b940bd654$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: 'options',
            payload: {
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $af5eb29b940bd654$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return Promise.resolve(null);
    return $af5eb29b940bd654$var$addEvent(replay, $af5eb29b940bd654$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $af5eb29b940bd654$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $c4b30a4fb2276f64$export$f93f7f385160c44e)((0, $c4b30a4fb2276f64$export$92b6093782fe661b)(replayEvent, (0, $c4b30a4fb2276f64$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: 'replay_event'
            },
            replayEvent
        ],
        [
            {
                type: 'replay_recording',
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $af5eb29b940bd654$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === 'string') payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $af5eb29b940bd654$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === 'object' && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const preparedEvent = await (0, $77b83a1be9fe3673$export$2d67fb380bd11267)(client.getOptions(), event, {
        event_id: event_id,
        integrations: integrations
    }, scope);
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || 'javascript';
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || 'sentry.javascript.unknown',
        version: version || '0.0.0'
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $af5eb29b940bd654$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $af5eb29b940bd654$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const hub = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)();
    const client = hub.getClient();
    const scope = hub.getScope();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !scope || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $af5eb29b940bd654$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $af5eb29b940bd654$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent('event_processor', 'replay', baseEvent);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('An event processor returned `null`, will not send event.');
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ const envelope = $af5eb29b940bd654$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($af5eb29b940bd654$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-ignore This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) throw new $af5eb29b940bd654$var$TransportStatusCodeError(response.statusCode);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $af5eb29b940bd654$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $af5eb29b940bd654$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $af5eb29b940bd654$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $af5eb29b940bd654$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $af5eb29b940bd654$var$TransportStatusCodeError) throw err;
        // Capture error for every failed replay
        (0, $7364f12ad7fd150c$export$2f04de43fe27971a)('Replays', {
            _retryCount: retryConfig.count
        });
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && options._experiments && options._experiments.captureExceptions) (0, $7364f12ad7fd150c$export$f5282963edea4a68)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $af5eb29b940bd654$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$af5eb29b940bd654$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-ignore This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return await new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $af5eb29b940bd654$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $af5eb29b940bd654$var$ReplayContainer {
    __init() {
        this.eventBuffer = null;
    }
    /**
   * List of PerformanceEntry from PerformanceObserver
   */ __init2() {
        this.performanceEvents = [];
    }
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ __init3() {
        this.recordingMode = 'session';
    }
    /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ __init4() {
        this.timeouts = {
            sessionIdlePause: $af5eb29b940bd654$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $af5eb29b940bd654$var$SESSION_IDLE_EXPIRE_DURATION,
            maxSessionLife: $af5eb29b940bd654$var$MAX_SESSION_LIFE
        };
    }
    /**
   * Options to pass to `rrweb.record()`
   */ __init5() {
        this._performanceObserver = null;
    }
    __init6() {
        this._flushLock = null;
    }
    /**
   * Timestamp of the last user activity. This lives across sessions.
   */ __init7() {
        this._lastActivity = Date.now();
    }
    /**
   * Is the integration currently active?
   */ __init8() {
        this._isEnabled = false;
    }
    /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ __init9() {
        this._isPaused = false;
    }
    /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ __init10() {
        this._hasInitializedCoreListeners = false;
    }
    /**
   * Function to stop recording
   */ __init11() {
        this._stopRecording = null;
    }
    __init12() {
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ''
        };
    }
    constructor({ options: options, recordingOptions: recordingOptions }){
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init2.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init3.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init4.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init5.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init6.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init7.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init8.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init9.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init10.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init11.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init12.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init13.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init14.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init15.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init16.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init17.call(this);
        $af5eb29b940bd654$var$ReplayContainer.prototype.__init18.call(this);
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $af5eb29b940bd654$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling() {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        const isSessionSampled = this._loadAndCheckSession();
        if (!isSessionSampled) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error('Unable to initialize and create session'));
            return;
        }
        if (this.session.sampled && this.session.sampled !== 'session') // If not sampled as session-based, then recording mode will be `buffer`
        // Note that we don't explicitly check if `sampled === 'buffer'` because we
        // could have sessions from Session storage that are still `error` from
        // prior SDK version.
        this.recordingMode = 'buffer';
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === 'session') throw new Error('Replay recording is already in progress');
        if (this._isEnabled && this.recordingMode === 'buffer') throw new Error('Replay buffering is in progress, call `flush()` to save the replay');
        const previousSessionId = this.session && this.session.id;
        const { session: session } = $af5eb29b940bd654$var$getSession({
            timeouts: this.timeouts,
            stickySession: Boolean(this._options.stickySession),
            currentSession: this.session,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        session.previousSessionId = previousSessionId;
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error('Replay recording is already in progress');
        const previousSessionId = this.session && this.session.id;
        const { session: session } = $af5eb29b940bd654$var$getSession({
            timeouts: this.timeouts,
            stickySession: Boolean(this._options.stickySession),
            currentSession: this.session,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        session.previousSessionId = previousSessionId;
        this.session = session;
        this.recordingMode = 'buffer';
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            this._stopRecording = $af5eb29b940bd654$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === 'buffer' && {
                    checkoutEveryNms: $af5eb29b940bd654$var$BUFFER_CHECKOUT_TIME
                },
                emit: $af5eb29b940bd654$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop(reason) {
        if (!this._isEnabled) return;
        try {
            if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) {
                const msg = `[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ''}`;
                // When `traceInternals` is enabled, we want to log this to the console
                // Else, use the regular debug output
                // eslint-disable-next-line
                const log = this.getOptions()._experiments.traceInternals ? console.warn : (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log;
                log(msg);
            }
            // We can't move `_isEnabled` after awaiting a flush, otherwise we can
            // enter into an infinite loop when `stop()` is called while flushing.
            this._isEnabled = false;
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $af5eb29b940bd654$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        this._isPaused = true;
        this.stopRecording();
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._loadAndCheckSession()) return;
        this._isPaused = false;
        this.startRecording();
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === 'session') return this.flushImmediate();
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // Re-start recording, but in "session" recording mode
        // Reset all "capture on error" configuration before
        // starting a new recording
        this.recordingMode = 'session';
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this.session.shouldRefresh = false;
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === 'buffer') return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._loadAndCheckSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === 'buffer') return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        const oldSessionId = this.getSessionId();
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $af5eb29b940bd654$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === 'session') {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._loadAndCheckSession()) return;
        // Session was expired if session ids do not match
        const expired = oldSessionId !== this.getSessionId();
        if (!expired) return true;
        // Session is expired, trigger a full snapshot (which will create a new session)
        this._triggerFullSnapshot();
        return false;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$af5eb29b940bd654$var$WINDOW.location.pathname}${$af5eb29b940bd654$var$WINDOW.location.hash}${$af5eb29b940bd654$var$WINDOW.location.search}`;
        const url = `${$af5eb29b940bd654$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEvents = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $af5eb29b940bd654$var$createEventBuffer({
            useCompression: this._options.useCompression
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error('[Replay]', error);
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && this._options._experiments && this._options._experiments.captureExceptions) (0, $7364f12ad7fd150c$export$f5282963edea4a68)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   * Returns false if session is not recorded.
   */ _loadAndCheckSession() {
        const { type: type, session: session } = $af5eb29b940bd654$var$getSession({
            timeouts: this.timeouts,
            stickySession: Boolean(this._options.stickySession),
            currentSession: this.session,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: this._options.errorSampleRate > 0
        });
        // If session was newly created (i.e. was not loaded from storage), then
        // enable flag to create the root replay
        if (type === 'new') this.setInitialState();
        const currentSessionId = this.getSessionId();
        if (session.id !== currentSessionId) session.previousSessionId = currentSessionId;
        this.session = session;
        if (!this.session.sampled) {
            this.stop('session unsampled');
            return false;
        }
        return true;
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $af5eb29b940bd654$var$WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
            $af5eb29b940bd654$var$WINDOW.addEventListener('blur', this._handleWindowBlur);
            $af5eb29b940bd654$var$WINDOW.addEventListener('focus', this._handleWindowFocus);
            $af5eb29b940bd654$var$WINDOW.addEventListener('keydown', this._handleKeyboardEvent);
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $af5eb29b940bd654$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        // PerformanceObserver //
        if (!('PerformanceObserver' in $af5eb29b940bd654$var$WINDOW)) return;
        this._performanceObserver = $af5eb29b940bd654$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $af5eb29b940bd654$var$WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);
            $af5eb29b940bd654$var$WINDOW.removeEventListener('blur', this._handleWindowBlur);
            $af5eb29b940bd654$var$WINDOW.removeEventListener('focus', this._handleWindowFocus);
            $af5eb29b940bd654$var$WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);
            if (this._performanceObserver) {
                this._performanceObserver.disconnect();
                this._performanceObserver = null;
            }
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init13() {
        this._handleVisibilityChange = ()=>{
            if ($af5eb29b940bd654$var$WINDOW.document.visibilityState === 'visible') this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init14() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $af5eb29b940bd654$var$createBreadcrumb({
                category: 'ui.blur'
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init15() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $af5eb29b940bd654$var$createBreadcrumb({
                category: 'ui.focus'
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init16() {
        this._handleKeyboardEvent = (event)=>{
            $af5eb29b940bd654$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $af5eb29b940bd654$var$isSessionExpired(this.session, this.timeouts);
        if (breadcrumb && !expired) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Replay] Document has become active, but session has expired');
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Trigger rrweb to take a full snapshot which will cause this plugin to
   * create a new Replay event.
   */ _triggerFullSnapshot(checkout = true) {
        try {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).log('[Replay] Taking full rrweb snapshot');
            $af5eb29b940bd654$var$record.takeFullSnapshot(checkout);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            $af5eb29b940bd654$var$addEvent(this, {
                type: $af5eb29b940bd654$var$EventType$1.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: 'breadcrumb',
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEvents`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        // Copy and reset entries before processing
        const entries = [
            ...this.performanceEvents
        ];
        this.performanceEvents = [];
        return Promise.all($af5eb29b940bd654$var$createPerformanceSpans(this, $af5eb29b940bd654$var$createPerformanceEntries(entries)));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        if (!this.session || !this.eventBuffer) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error('[Replay] No session or eventBuffer found to flush.');
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $af5eb29b940bd654$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            // NOTE: Copy values from instance members, as it's possible they could
            // change before the flush finishes.
            const replayId = this.session.id;
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            await $af5eb29b940bd654$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: Date.now()
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            this.stop('sendReplay');
            const client = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getClient();
            if (client) client.recordDroppedEvent('send_error', 'replay');
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init17() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error('[Replay] Attempting to finish replay event after session expired.');
                return;
            }
            if (!this.session) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error('[Replay] No session found to flush.');
                return;
            }
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = null;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $1eb1a39bb029f9a9$export$af88d00dbe7f521).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $af5eb29b940bd654$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init18() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options._experiments.mutationLimit || 0;
            const mutationBreadcrumbLimit = this._options._experiments.mutationBreadcrumbLimit || 1000;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $af5eb29b940bd654$var$createBreadcrumb({
                    category: 'replay.mutations',
                    data: {
                        count: count
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            if (overMutationLimit) {
                // We want to skip doing an incremental snapshot if there are too many mutations
                // Instead, we do a full snapshot
                this._triggerFullSnapshot(false);
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $af5eb29b940bd654$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === 'string' ? deprecatedSelectorOption.split(',') : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== 'undefined') {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === 'string') allSelectors.push(`.${deprecatedClassOption}`);
        // eslint-disable-next-line no-console
        console.warn('[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.');
    }
    return allSelectors.join(',');
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $af5eb29b940bd654$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore, blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector, maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $af5eb29b940bd654$var$getOption(mask, [
        '.sentry-mask',
        '[data-sentry-mask]'
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $af5eb29b940bd654$var$getOption(unmask, [
        '.sentry-unmask',
        '[data-sentry-unmask]'
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        maskInputSelector: maskSelector,
        unmaskInputSelector: unmaskSelector,
        blockSelector: $af5eb29b940bd654$var$getOption(block, [
            '.sentry-block',
            '[data-sentry-block]',
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $af5eb29b940bd654$var$getOption(unblock, [
            '.sentry-unblock',
            '[data-sentry-unblock]'
        ]),
        ignoreSelector: $af5eb29b940bd654$var$getOption(ignore, [
            '.sentry-ignore',
            '[data-sentry-ignore]',
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Returns true if we are in the browser.
 */ function $af5eb29b940bd654$var$isBrowser() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!(0, $iZbO1.isNodeEnv)() || $af5eb29b940bd654$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $af5eb29b940bd654$var$isElectronNodeRenderer() {
    return typeof $8LKEK !== 'undefined' && $8LKEK.type === 'renderer';
}
const $af5eb29b940bd654$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $af5eb29b940bd654$var$DEFAULT_NETWORK_HEADERS = [
    'content-length',
    'content-type',
    'accept'
];
let $af5eb29b940bd654$var$_initialized = false;
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 */ class $af5eb29b940bd654$export$a35c789ed37ee0f7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Replay';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $af5eb29b940bd654$export$a35c789ed37ee0f7.id;
    }
    /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $af5eb29b940bd654$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $af5eb29b940bd654$var$DEFAULT_FLUSH_MAX_DELAY, stickySession: stickySession = true, useCompression: useCompression = true, _experiments: _experiments = {}, sessionSampleRate: sessionSampleRate, errorSampleRate: errorSampleRate, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, networkDetailAllowUrls: networkDetailAllowUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector, maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        $af5eb29b940bd654$export$a35c789ed37ee0f7.prototype.__init.call(this);
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            ...$af5eb29b940bd654$var$getPrivacyOptions({
                mask: mask,
                unmask: unmask,
                block: block,
                unblock: unblock,
                ignore: ignore,
                blockClass: blockClass,
                blockSelector: blockSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                ignoreClass: ignoreClass
            }),
            // Our defaults
            slimDOMOptions: 'all',
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $af5eb29b940bd654$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $af5eb29b940bd654$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === 'number') {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === 'number') {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $af5eb29b940bd654$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$af5eb29b940bd654$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && $af5eb29b940bd654$var$isBrowser()) throw new Error('Multiple Sentry Session Replay instances are not supported');
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $af5eb29b940bd654$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $af5eb29b940bd654$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!$af5eb29b940bd654$var$isBrowser()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop();
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $af5eb29b940bd654$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $af5eb29b940bd654$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
}
$af5eb29b940bd654$export$a35c789ed37ee0f7.__initStatic();
/** Parse Replay-related options from SDK options */ function $af5eb29b940bd654$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $4e8ba91971b7f1f7$export$a07cdf6544bbd7c)().getClient();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $c7598308515e5ce6$export$d25f2688db1bb433)(initialOptions)
    };
    if (!opt) {
        // eslint-disable-next-line no-console
        console.warn('SDK client is not available.');
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) // eslint-disable-next-line no-console
    console.warn('Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.');
    if (typeof opt.replaysSessionSampleRate === 'number') finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === 'number') finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $af5eb29b940bd654$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$af5eb29b940bd654$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

var $fEoMa = parcelRequire("fEoMa");

// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $3adf194465daea7d$var$NOT_FOUND = 'NOT_FOUND';
function $3adf194465daea7d$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $3adf194465daea7d$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $3adf194465daea7d$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $3adf194465daea7d$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $3adf194465daea7d$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $3adf194465daea7d$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $3adf194465daea7d$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $3adf194465daea7d$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $3adf194465daea7d$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $3adf194465daea7d$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $3adf194465daea7d$var$createSingletonCache(comparator) : $3adf194465daea7d$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $3adf194465daea7d$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $be809239f9e6bcd4$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $be809239f9e6bcd4$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $be809239f9e6bcd4$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $be809239f9e6bcd4$export$595d22ed68ca2841 = /* #__PURE__ */ $be809239f9e6bcd4$export$5943f4447f6ef248((0, $3adf194465daea7d$export$281bff7f05488aa2));
var $be809239f9e6bcd4$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $be809239f9e6bcd4$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $7ed13903966d0bcf$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $7ed13903966d0bcf$var$thunk = $7ed13903966d0bcf$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$7ed13903966d0bcf$var$thunk.withExtraArgument = $7ed13903966d0bcf$var$createThunkMiddleware;
var $7ed13903966d0bcf$export$2e2bcd8739ae039 = $7ed13903966d0bcf$var$thunk;



var $8LKEK = parcelRequire("8LKEK");
var $44e12de5a38cd004$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $44e12de5a38cd004$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $44e12de5a38cd004$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $44e12de5a38cd004$var$__defProp = Object.defineProperty;
var $44e12de5a38cd004$var$__defProps = Object.defineProperties;
var $44e12de5a38cd004$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $44e12de5a38cd004$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $44e12de5a38cd004$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $44e12de5a38cd004$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $44e12de5a38cd004$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $44e12de5a38cd004$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $44e12de5a38cd004$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($44e12de5a38cd004$var$__hasOwnProp.call(b, prop)) $44e12de5a38cd004$var$__defNormalProp(a, prop, b[prop]);
    if ($44e12de5a38cd004$var$__getOwnPropSymbols) for(var _i = 0, _c = $44e12de5a38cd004$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($44e12de5a38cd004$var$__propIsEnum.call(b, prop)) $44e12de5a38cd004$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $44e12de5a38cd004$var$__spreadProps = function(a, b) {
    return $44e12de5a38cd004$var$__defProps(a, $44e12de5a38cd004$var$__getOwnPropDescs(b));
};
var $44e12de5a38cd004$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $44e12de5a38cd004$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $be809239f9e6bcd4$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $44e12de5a38cd004$var$__spreadArray([
            (0, $fEoMa.isDraft)(value) ? (0, $fEoMa.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $44e12de5a38cd004$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $e0db014f981f40cf$export$f672e0b6f7222cd7;
    return (0, $e0db014f981f40cf$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $44e12de5a38cd004$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $44e12de5a38cd004$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
function $44e12de5a38cd004$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $44e12de5a38cd004$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $44e12de5a38cd004$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $44e12de5a38cd004$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $44e12de5a38cd004$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
function $44e12de5a38cd004$var$freezeDraftable(val) {
    return (0, $fEoMa.isDraftable)(val) ? (0, $fEoMa.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $44e12de5a38cd004$var$isProduction = true;
var $44e12de5a38cd004$var$prefix = "Invariant failed";
function $44e12de5a38cd004$var$invariant(condition, message) {
    if (condition) return;
    if ($44e12de5a38cd004$var$isProduction) throw new Error($44e12de5a38cd004$var$prefix);
    throw new Error($44e12de5a38cd004$var$prefix + ": " + (message || ""));
}
function $44e12de5a38cd004$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $44e12de5a38cd004$var$getSerialize(serializer, decycler), indent);
}
function $44e12de5a38cd004$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $44e12de5a38cd004$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $44e12de5a38cd004$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $44e12de5a38cd004$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $44e12de5a38cd004$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $44e12de5a38cd004$var$trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $44e12de5a38cd004$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $44e12de5a38cd004$var$detectMutations(isImmutable, ignorePaths, trackedProperty, obj, sameParentRef, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    for(var key in keysToDetect){
        var childPath = path ? path + "." + key : key;
        if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
        var result = $44e12de5a38cd004$var$detectMutations(isImmutable, ignorePaths, trackedProperty.children[key], obj[key], sameRef, childPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $44e12de5a38cd004$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $44e12de5a38cd004$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $44e12de5a38cd004$export$53b83ca8eaab0383(val);
}
function $44e12de5a38cd004$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $44e12de5a38cd004$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths && ignoredPaths.indexOf(nestedPath) >= 0) continue;
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $44e12de5a38cd004$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    return false;
}
function $44e12de5a38cd004$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $44e12de5a38cd004$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $44e12de5a38cd004$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $44e12de5a38cd004$export$36c1185aeee5b0a6(options);
    };
}
function $44e12de5a38cd004$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new $44e12de5a38cd004$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($44e12de5a38cd004$var$isBoolean(thunk)) middlewareArray.push((0, $7ed13903966d0bcf$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $7ed13903966d0bcf$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $44e12de5a38cd004$var$IS_PRODUCTION = true;
function $44e12de5a38cd004$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $44e12de5a38cd004$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($44e12de5a38cd004$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $e0db014f981f40cf$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$44e12de5a38cd004$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$44e12de5a38cd004$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $e0db014f981f40cf$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $e0db014f981f40cf$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $44e12de5a38cd004$var$composeWithDevTools($44e12de5a38cd004$var$__spreadValues({
        trace: !$44e12de5a38cd004$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var storeEnhancers = [
        middlewareEnhancer
    ];
    if (Array.isArray(enhancers)) storeEnhancers = $44e12de5a38cd004$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(storeEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $e0db014f981f40cf$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function $44e12de5a38cd004$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $44e12de5a38cd004$var$__spreadValues($44e12de5a38cd004$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $44e12de5a38cd004$var$isFSA(action) {
    return $44e12de5a38cd004$export$53b83ca8eaab0383(action) && typeof action.type === "string" && Object.keys(action).every($44e12de5a38cd004$var$isValidKey);
}
function $44e12de5a38cd004$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $44e12de5a38cd004$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/mapBuilders.ts
function $44e12de5a38cd004$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) throw new Error("addCase cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $44e12de5a38cd004$var$isStateFunction(x) {
    return typeof x === "function";
}
var $44e12de5a38cd004$var$hasWarnedAboutObjectNotation = false;
function $44e12de5a38cd004$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $44e12de5a38cd004$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($44e12de5a38cd004$var$isStateFunction(initialState)) getInitialState = function() {
        return $44e12de5a38cd004$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $44e12de5a38cd004$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $44e12de5a38cd004$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $fEoMa.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $fEoMa.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $fEoMa.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $44e12de5a38cd004$var$hasWarnedAboutObjectNotation2 = false;
function $44e12de5a38cd004$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $44e12de5a38cd004$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $8LKEK;
    var initialState = typeof options.initialState == "function" ? options.initialState : $44e12de5a38cd004$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $44e12de5a38cd004$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $44e12de5a38cd004$export$309c7a02b0b0bc62(type, prepareCallback) : $44e12de5a38cd004$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $44e12de5a38cd004$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $44e12de5a38cd004$var$__spreadValues($44e12de5a38cd004$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $44e12de5a38cd004$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $44e12de5a38cd004$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $44e12de5a38cd004$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($44e12de5a38cd004$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $44e12de5a38cd004$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $44e12de5a38cd004$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $44e12de5a38cd004$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $44e12de5a38cd004$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $44e12de5a38cd004$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $44e12de5a38cd004$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $44e12de5a38cd004$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $44e12de5a38cd004$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $44e12de5a38cd004$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $44e12de5a38cd004$var$createSingleArgumentStateOperator(mutator) {
    var operator = $44e12de5a38cd004$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $44e12de5a38cd004$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $44e12de5a38cd004$var$isFSA(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $fEoMa.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $fEoMa.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $44e12de5a38cd004$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $44e12de5a38cd004$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $44e12de5a38cd004$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $44e12de5a38cd004$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $44e12de5a38cd004$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $44e12de5a38cd004$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $44e12de5a38cd004$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $44e12de5a38cd004$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $44e12de5a38cd004$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $44e12de5a38cd004$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $44e12de5a38cd004$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $44e12de5a38cd004$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $44e12de5a38cd004$var$__spreadValues($44e12de5a38cd004$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $44e12de5a38cd004$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $44e12de5a38cd004$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $44e12de5a38cd004$var$createStateOperator(addOneMutably),
        addMany: $44e12de5a38cd004$var$createStateOperator(addManyMutably),
        setOne: $44e12de5a38cd004$var$createStateOperator(setOneMutably),
        setMany: $44e12de5a38cd004$var$createStateOperator(setManyMutably),
        setAll: $44e12de5a38cd004$var$createStateOperator(setAllMutably),
        updateOne: $44e12de5a38cd004$var$createStateOperator(updateOneMutably),
        updateMany: $44e12de5a38cd004$var$createStateOperator(updateManyMutably),
        upsertOne: $44e12de5a38cd004$var$createStateOperator(upsertOneMutably),
        upsertMany: $44e12de5a38cd004$var$createStateOperator(upsertManyMutably),
        removeOne: $44e12de5a38cd004$var$createStateOperator(removeOneMutably),
        removeMany: $44e12de5a38cd004$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $44e12de5a38cd004$var$createSortedStateAdapter(selectId, sort) {
    var _c = $44e12de5a38cd004$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $44e12de5a38cd004$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($44e12de5a38cd004$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $44e12de5a38cd004$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $44e12de5a38cd004$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $44e12de5a38cd004$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $44e12de5a38cd004$var$createStateOperator(addOneMutably),
        updateOne: $44e12de5a38cd004$var$createStateOperator(updateOneMutably),
        upsertOne: $44e12de5a38cd004$var$createStateOperator(upsertOneMutably),
        setOne: $44e12de5a38cd004$var$createStateOperator(setOneMutably),
        setMany: $44e12de5a38cd004$var$createStateOperator(setManyMutably),
        setAll: $44e12de5a38cd004$var$createStateOperator(setAllMutably),
        addMany: $44e12de5a38cd004$var$createStateOperator(addManyMutably),
        updateMany: $44e12de5a38cd004$var$createStateOperator(updateManyMutably),
        upsertMany: $44e12de5a38cd004$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $44e12de5a38cd004$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $44e12de5a38cd004$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $44e12de5a38cd004$var$createInitialStateFactory();
    var selectorsFactory = $44e12de5a38cd004$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $44e12de5a38cd004$var$createSortedStateAdapter(selectId, sortComparer) : $44e12de5a38cd004$var$createUnsortedStateAdapter(selectId);
    return $44e12de5a38cd004$var$__spreadValues($44e12de5a38cd004$var$__spreadValues($44e12de5a38cd004$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $44e12de5a38cd004$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $44e12de5a38cd004$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $44e12de5a38cd004$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $44e12de5a38cd004$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $44e12de5a38cd004$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $44e12de5a38cd004$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $44e12de5a38cd004$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $44e12de5a38cd004$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $44e12de5a38cd004$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $44e12de5a38cd004$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $44e12de5a38cd004$var$__spreadProps($44e12de5a38cd004$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $44e12de5a38cd004$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $44e12de5a38cd004$var$__spreadProps($44e12de5a38cd004$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $44e12de5a38cd004$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $44e12de5a38cd004$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $44e12de5a38cd004$var$__spreadProps($44e12de5a38cd004$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $44e12de5a38cd004$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $44e12de5a38cd004$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $44e12de5a38cd004$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$44e12de5a38cd004$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $44e12de5a38cd004$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $44e12de5a38cd004$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $44e12de5a38cd004$var$RejectWithValue) throw result;
                                                if (result instanceof $44e12de5a38cd004$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $44e12de5a38cd004$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($44e12de5a38cd004$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $44e12de5a38cd004$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $44e12de5a38cd004$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var $44e12de5a38cd004$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var $44e12de5a38cd004$var$matches = function(matcher, action) {
    if ($44e12de5a38cd004$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $44e12de5a38cd004$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $44e12de5a38cd004$var$matches(matcher, action);
        });
    };
}
function $44e12de5a38cd004$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $44e12de5a38cd004$var$matches(matcher, action);
        });
    };
}
function $44e12de5a38cd004$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $44e12de5a38cd004$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $44e12de5a38cd004$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $44e12de5a38cd004$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$44e12de5a38cd004$var$isAsyncThunkArray(asyncThunks)) return $44e12de5a38cd004$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $44e12de5a38cd004$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $44e12de5a38cd004$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $44e12de5a38cd004$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$44e12de5a38cd004$var$isAsyncThunkArray(asyncThunks)) return $44e12de5a38cd004$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $44e12de5a38cd004$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $44e12de5a38cd004$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $44e12de5a38cd004$export$9dd1fb32974da385($44e12de5a38cd004$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$44e12de5a38cd004$var$isAsyncThunkArray(asyncThunks)) return $44e12de5a38cd004$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $44e12de5a38cd004$export$9dd1fb32974da385($44e12de5a38cd004$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $44e12de5a38cd004$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $44e12de5a38cd004$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$44e12de5a38cd004$var$isAsyncThunkArray(asyncThunks)) return $44e12de5a38cd004$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $44e12de5a38cd004$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $44e12de5a38cd004$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $44e12de5a38cd004$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$44e12de5a38cd004$var$isAsyncThunkArray(asyncThunks)) return $44e12de5a38cd004$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $44e12de5a38cd004$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $44e12de5a38cd004$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $44e12de5a38cd004$var$noop = function() {};
var $44e12de5a38cd004$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $44e12de5a38cd004$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $44e12de5a38cd004$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
};
var $44e12de5a38cd004$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $44e12de5a38cd004$var$task = "task";
var $44e12de5a38cd004$var$listener = "listener";
var $44e12de5a38cd004$var$completed = "completed";
var $44e12de5a38cd004$var$cancelled = "cancelled";
var $44e12de5a38cd004$var$taskCancelled = "task-" + $44e12de5a38cd004$var$cancelled;
var $44e12de5a38cd004$var$taskCompleted = "task-" + $44e12de5a38cd004$var$completed;
var $44e12de5a38cd004$var$listenerCancelled = $44e12de5a38cd004$var$listener + "-" + $44e12de5a38cd004$var$cancelled;
var $44e12de5a38cd004$var$listenerCompleted = $44e12de5a38cd004$var$listener + "-" + $44e12de5a38cd004$var$completed;
var $44e12de5a38cd004$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $44e12de5a38cd004$var$task + " " + $44e12de5a38cd004$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $44e12de5a38cd004$var$validateActive = function(signal) {
    if (signal.aborted) throw new $44e12de5a38cd004$export$cb1bdac908fed7f(signal.reason);
};
var $44e12de5a38cd004$var$promisifyAbortSignal = function(signal) {
    return $44e12de5a38cd004$var$catchRejection(new Promise(function(_, reject) {
        var notifyRejection = function() {
            return reject(new $44e12de5a38cd004$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) notifyRejection();
        else $44e12de5a38cd004$var$addAbortSignalListener(signal, notifyRejection);
    }));
};
var $44e12de5a38cd004$var$runTask = function(task2, cleanUp) {
    return $44e12de5a38cd004$var$__async(void 0, null, function() {
        var value, error_1;
        return $44e12de5a38cd004$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $44e12de5a38cd004$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $44e12de5a38cd004$var$createPause = function(signal) {
    return function(promise2) {
        return $44e12de5a38cd004$var$catchRejection(Promise.race([
            $44e12de5a38cd004$var$promisifyAbortSignal(signal),
            promise2
        ]).then(function(output) {
            $44e12de5a38cd004$var$validateActive(signal);
            return output;
        }));
    };
};
var $44e12de5a38cd004$var$createDelay = function(signal) {
    var pause = $44e12de5a38cd004$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $44e12de5a38cd004$var$assign = Object.assign;
var $44e12de5a38cd004$var$INTERNAL_NIL_TOKEN = {};
var $44e12de5a38cd004$var$alm = "listenerMiddleware";
var $44e12de5a38cd004$var$createFork = function(parentAbortSignal) {
    var linkControllers = function(controller) {
        return $44e12de5a38cd004$var$addAbortSignalListener(parentAbortSignal, function() {
            return $44e12de5a38cd004$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor) {
        $44e12de5a38cd004$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $44e12de5a38cd004$var$runTask(function() {
            return $44e12de5a38cd004$var$__async(void 0, null, function() {
                var result2;
                return $44e12de5a38cd004$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $44e12de5a38cd004$var$validateActive(parentAbortSignal);
                            $44e12de5a38cd004$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $44e12de5a38cd004$var$createPause(childAbortController.signal),
                                    delay: $44e12de5a38cd004$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $44e12de5a38cd004$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $44e12de5a38cd004$var$abortControllerWithReason(childAbortController, $44e12de5a38cd004$var$taskCompleted);
        });
        return {
            result: $44e12de5a38cd004$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $44e12de5a38cd004$var$abortControllerWithReason(childAbortController, $44e12de5a38cd004$var$taskCancelled);
            }
        };
    };
};
var $44e12de5a38cd004$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $44e12de5a38cd004$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $44e12de5a38cd004$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $44e12de5a38cd004$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve) {
                            unsubscribe = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                        });
                        promises = [
                            $44e12de5a38cd004$var$promisifyAbortSignal(signal),
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.race(promises)
                        ];
                    case 2:
                        output = _c.sent();
                        $44e12de5a38cd004$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $44e12de5a38cd004$var$catchRejection(take(predicate, timeout));
    };
};
var $44e12de5a38cd004$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $44e12de5a38cd004$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $44e12de5a38cd004$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $44e12de5a38cd004$var$createListenerEntry = function(options) {
    var _c = $44e12de5a38cd004$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $44e12de5a38cd004$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $44e12de5a38cd004$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($44e12de5a38cd004$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $44e12de5a38cd004$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $44e12de5a38cd004$export$f03a6b845d3fb58b = $44e12de5a38cd004$export$309c7a02b0b0bc62($44e12de5a38cd004$var$alm + "/add");
var $44e12de5a38cd004$export$b1b8022855fb2b71 = $44e12de5a38cd004$export$309c7a02b0b0bc62($44e12de5a38cd004$var$alm + "/removeAll");
var $44e12de5a38cd004$export$b03e9483f936dccb = $44e12de5a38cd004$export$309c7a02b0b0bc62($44e12de5a38cd004$var$alm + "/remove");
var $44e12de5a38cd004$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $44e12de5a38cd004$var$__spreadArray([
        $44e12de5a38cd004$var$alm + "/error"
    ], args));
};
var $44e12de5a38cd004$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $44e12de5a38cd004$var$abortControllerWithReason(controller, $44e12de5a38cd004$var$listenerCancelled);
    });
};
function $44e12de5a38cd004$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $44e12de5a38cd004$var$defaultErrorHandler : _c;
    $44e12de5a38cd004$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $44e12de5a38cd004$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $44e12de5a38cd004$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $44e12de5a38cd004$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $44e12de5a38cd004$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $44e12de5a38cd004$var$__async(_this, null, function() {
            var internalTaskController, take, listenerError_1;
            return $44e12de5a38cd004$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $44e12de5a38cd004$var$createTakePattern(startListening, internalTaskController.signal);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $44e12de5a38cd004$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $44e12de5a38cd004$var$createDelay(internalTaskController.signal),
                                pause: $44e12de5a38cd004$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $44e12de5a38cd004$var$createFork(internalTaskController.signal),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $44e12de5a38cd004$var$abortControllerWithReason(controller, $44e12de5a38cd004$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $44e12de5a38cd004$export$cb1bdac908fed7f)) $44e12de5a38cd004$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        $44e12de5a38cd004$var$abortControllerWithReason(internalTaskController, $44e12de5a38cd004$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $44e12de5a38cd004$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if ($44e12de5a38cd004$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($44e12de5a38cd004$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($44e12de5a38cd004$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $44e12de5a38cd004$var$INTERNAL_NIL_TOKEN) throw new Error($44e12de5a38cd004$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $44e12de5a38cd004$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $44e12de5a38cd004$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $44e12de5a38cd004$export$8fb31c0f05df007b = "RTK_autoBatch";
var $44e12de5a38cd004$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$44e12de5a38cd004$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $44e12de5a38cd004$var$promise;
var $44e12de5a38cd004$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($44e12de5a38cd004$var$promise || ($44e12de5a38cd004$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $44e12de5a38cd004$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $44e12de5a38cd004$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $44e12de5a38cd004$var$createQueueWithTimer(10);
var $44e12de5a38cd004$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $44e12de5a38cd004$var$queueMicrotaskShim : options.type === "raf" ? $44e12de5a38cd004$var$rAF : options.type === "callback" ? options.queueNotification : $44e12de5a38cd004$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$44e12de5a38cd004$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $fEoMa.enableES5)();


var $42bae757363610b8$export$1e511d4a378977f5;
var $42bae757363610b8$export$2e2bcd8739ae039;
"use strict";
$42bae757363610b8$export$1e511d4a378977f5 = true;
$42bae757363610b8$export$2e2bcd8739ae039 = void 0;

var $42bae757363610b8$var$_createWebStorage = $42bae757363610b8$var$_interopRequireDefault((parcelRequire("49ujK")));
function $42bae757363610b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $42bae757363610b8$var$_default = (0, $42bae757363610b8$var$_createWebStorage.default)('local');
$42bae757363610b8$export$2e2bcd8739ae039 = $42bae757363610b8$var$_default;


var $719c64f71d9c516c$exports = {};
!function(e, t) {
    t($719c64f71d9c516c$exports);
}($719c64f71d9c516c$exports, function(e) {
    "use strict";
    function t(e, t) {
        e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        });
    }
    function r(e, t) {
        Object.defineProperty(this, "kind", {
            value: e,
            enumerable: !0
        }), t && t.length && Object.defineProperty(this, "path", {
            value: t,
            enumerable: !0
        });
    }
    function n(e, t, r) {
        n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "rhs", {
            value: r,
            enumerable: !0
        });
    }
    function o(e, t) {
        o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
            value: t,
            enumerable: !0
        });
    }
    function i(e, t) {
        i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        });
    }
    function a(e, t, r) {
        a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "item", {
            value: r,
            enumerable: !0
        });
    }
    function f(e, t, r) {
        var n = e.slice((r || t) + 1 || e.length);
        return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
    }
    function u(e) {
        var t = "undefined" == typeof e ? "undefined" : N(e);
        return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
    }
    function l(e, t, r, c, s, d, p) {
        s = s || [], p = p || [];
        var g = s.slice(0);
        if ("undefined" != typeof d) {
            if (c) {
                if ("function" == typeof c && c(g, d)) return;
                if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
                    if (c.prefilter && c.prefilter(g, d)) return;
                    if (c.normalize) {
                        var h = c.normalize(g, d, e, t);
                        h && (e = h[0], t = h[1]);
                    }
                }
            }
            g.push(d);
        }
        "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
        var y = "undefined" == typeof e ? "undefined" : N(e), v = "undefined" == typeof t ? "undefined" : N(t), b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d), m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
        if (!b && m) r(new o(g, t));
        else if (!m && b) r(new i(g, e));
        else if (u(e) !== u(t)) r(new n(g, e, t));
        else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));
        else if ("object" === y && null !== e && null !== t) {
            if (p.filter(function(t) {
                return t.lhs === e;
            }).length) e !== t && r(new n(g, e, t));
            else {
                if (p.push({
                    lhs: e,
                    rhs: t
                }), Array.isArray(e)) {
                    var w;
                    e.length;
                    for(w = 0; w < e.length; w++)w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
                    for(; w < t.length;)r(new a(g, w, new o(void 0, t[w++])));
                } else {
                    var x = Object.keys(e), S = Object.keys(t);
                    x.forEach(function(n, o) {
                        var i = S.indexOf(n);
                        i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
                    }), S.forEach(function(e) {
                        l(void 0, t[e], r, c, g, e, p);
                    });
                }
                p.length = p.length - 1;
            }
        } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
    }
    function c(e, t, r, n) {
        return n = n || [], l(e, t, function(e) {
            e && n.push(e);
        }, r), n.length ? n : void 0;
    }
    function s(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    s(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    delete o[r.path[n]];
                    break;
                case "E":
                case "N":
                    o[r.path[n]] = r.rhs;
            }
        } else switch(r.kind){
            case "A":
                s(e[t], r.index, r.item);
                break;
            case "D":
                e = f(e, t);
                break;
            case "E":
            case "N":
                e[t] = r.rhs;
        }
        return e;
    }
    function d(e, t, r) {
        if (e && t && r && r.kind) {
            for(var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;)"undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
            switch(r.kind){
                case "A":
                    s(r.path ? n[r.path[o]] : n, r.index, r.item);
                    break;
                case "D":
                    delete n[r.path[o]];
                    break;
                case "E":
                case "N":
                    n[r.path[o]] = r.rhs;
            }
        }
    }
    function p(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    p(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    o[r.path[n]] = r.lhs;
                    break;
                case "E":
                    o[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete o[r.path[n]];
            }
        } else switch(r.kind){
            case "A":
                p(e[t], r.index, r.item);
                break;
            case "D":
                e[t] = r.lhs;
                break;
            case "E":
                e[t] = r.lhs;
                break;
            case "N":
                e = f(e, t);
        }
        return e;
    }
    function g(e, t, r) {
        if (e && t && r && r.kind) {
            var n, o, i = e;
            for(o = r.path.length - 1, n = 0; n < o; n++)"undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
            switch(r.kind){
                case "A":
                    p(i[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    i[r.path[n]] = r.lhs;
                    break;
                case "E":
                    i[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete i[r.path[n]];
            }
        }
    }
    function h(e, t, r) {
        if (e && t) {
            var n = function(n) {
                r && !r(e, t, n) || d(e, t, n);
            };
            l(e, t, n);
        }
    }
    function y(e) {
        return "color: " + F[e].color + "; font-weight: bold";
    }
    function v(e) {
        var t = e.kind, r = e.path, n = e.lhs, o = e.rhs, i = e.index, a = e.item;
        switch(t){
            case "E":
                return [
                    r.join("."),
                    n,
                    "\u2192",
                    o
                ];
            case "N":
                return [
                    r.join("."),
                    o
                ];
            case "D":
                return [
                    r.join(".")
                ];
            case "A":
                return [
                    r.join(".") + "[" + i + "]",
                    a
                ];
            default:
                return [];
        }
    }
    function b(e, t, r, n) {
        var o = c(e, t);
        try {
            n ? r.groupCollapsed("diff") : r.group("diff");
        } catch (e) {
            r.log("diff");
        }
        o ? o.forEach(function(e) {
            var t = e.kind, n = v(e);
            r.log.apply(r, [
                "%c " + F[t].text,
                y(t)
            ].concat(P(n)));
        }) : r.log("\u2014\u2014 no diff \u2014\u2014");
        try {
            r.groupEnd();
        } catch (e) {
            r.log("\u2014\u2014 diff end \u2014\u2014 ");
        }
    }
    function m(e, t, r, n) {
        switch("undefined" == typeof e ? "undefined" : N(e)){
            case "object":
                return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];
            case "function":
                return e(t);
            default:
                return e;
        }
    }
    function w(e) {
        var t = e.timestamp, r = e.duration;
        return function(e, n, o) {
            var i = [
                "action"
            ];
            return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
        };
    }
    function x(e, t) {
        var r = t.logger, n = t.actionTransformer, o = t.titleFormatter, i = void 0 === o ? w(t) : o, a = t.collapsed, f = t.colors, u = t.level, l = t.diff, c = "undefined" == typeof t.titleFormatter;
        e.forEach(function(o, s) {
            var d = o.started, p = o.startedTime, g = o.action, h = o.prevState, y = o.error, v = o.took, w = o.nextState, x = e[s + 1];
            x && (w = x.prevState, v = x.started - d);
            var S = n(g), k = "function" == typeof a ? a(function() {
                return w;
            }, g, o) : a, j = D(p), E = f.title ? "color: " + f.title(S) + ";" : "", A = [
                "color: gray; font-weight: lighter;"
            ];
            A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
            var O = i(S, j, v);
            try {
                k ? f.title && c ? r.groupCollapsed.apply(r, [
                    "%c " + O
                ].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, [
                    "%c " + O
                ].concat(A)) : r.group(O);
            } catch (e) {
                r.log(O);
            }
            var N = m(u, S, [
                h
            ], "prevState"), P = m(u, S, [
                S
            ], "action"), C = m(u, S, [
                y,
                h
            ], "error"), F = m(u, S, [
                w
            ], "nextState");
            if (N) {
                if (f.prevState) {
                    var L = "color: " + f.prevState(h) + "; font-weight: bold";
                    r[N]("%c prev state", L, h);
                } else r[N]("prev state", h);
            }
            if (P) {
                if (f.action) {
                    var T = "color: " + f.action(S) + "; font-weight: bold";
                    r[P]("%c action    ", T, S);
                } else r[P]("action    ", S);
            }
            if (y && C) {
                if (f.error) {
                    var M = "color: " + f.error(y, h) + "; font-weight: bold;";
                    r[C]("%c error     ", M, y);
                } else r[C]("error     ", y);
            }
            if (F) {
                if (f.nextState) {
                    var _ = "color: " + f.nextState(w) + "; font-weight: bold";
                    r[F]("%c next state", _, w);
                } else r[F]("next state", w);
            }
            l && b(h, w, r, k);
            try {
                r.groupEnd();
            } catch (e) {
                r.log("\u2014\u2014 log end \u2014\u2014");
            }
        });
    }
    function S() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Object.assign({}, L, e), r = t.logger, n = t.stateTransformer, o = t.errorTransformer, i = t.predicate, a = t.logErrors, f = t.diffPredicate;
        if ("undefined" == typeof r) return function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        var u = [];
        return function(e) {
            var r = e.getState;
            return function(e) {
                return function(l) {
                    if ("function" == typeof i && !i(r, l)) return e(l);
                    var c = {};
                    u.push(c), c.started = O.now(), c.startedTime = new Date, c.prevState = n(r()), c.action = l;
                    var s = void 0;
                    if (a) try {
                        s = e(l);
                    } catch (e) {
                        c.error = o(e);
                    }
                    else s = e(l);
                    c.took = O.now() - c.started, c.nextState = n(r());
                    var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
                    if (x(u, Object.assign({}, t, {
                        diff: d
                    })), u.length = 0, c.error) throw c.error;
                    return s;
                };
            };
        };
    }
    var k, j, E = function(e, t) {
        return new Array(t + 1).join(e);
    }, A = function(e, t) {
        return E("0", t - e.toString().length) + e;
    }, D = function(e) {
        return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
    }, O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date, N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, P = function(e) {
        if (Array.isArray(e)) {
            for(var t = 0, r = Array(e.length); t < e.length; t++)r[t] = e[t];
            return r;
        }
        return Array.from(e);
    }, C = [];
    k = "object" === ("undefined" == typeof $parcel$global ? "undefined" : N($parcel$global)) && $parcel$global ? $parcel$global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function() {
        "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
    }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
        diff: {
            value: c,
            enumerable: !0
        },
        observableDiff: {
            value: l,
            enumerable: !0
        },
        applyDiff: {
            value: h,
            enumerable: !0
        },
        applyChange: {
            value: d,
            enumerable: !0
        },
        revertChange: {
            value: g,
            enumerable: !0
        },
        isConflict: {
            value: function() {
                return "undefined" != typeof j;
            },
            enumerable: !0
        },
        noConflict: {
            value: function() {
                return C && (C.forEach(function(e) {
                    e();
                }), C = null), c;
            },
            enumerable: !0
        }
    });
    var F = {
        E: {
            color: "#2196F3",
            text: "CHANGED:"
        },
        N: {
            color: "#4CAF50",
            text: "ADDED:"
        },
        D: {
            color: "#F44336",
            text: "DELETED:"
        },
        A: {
            color: "#2196F3",
            text: "ARRAY:"
        }
    }, L = {
        level: "log",
        logger: console,
        logErrors: !0,
        collapsed: void 0,
        predicate: void 0,
        duration: !1,
        timestamp: !0,
        stateTransformer: function(e) {
            return e;
        },
        actionTransformer: function(e) {
            return e;
        },
        errorTransformer: function(e) {
            return e;
        },
        colors: {
            title: function() {
                return "inherit";
            },
            prevState: function() {
                return "#9E9E9E";
            },
            action: function() {
                return "#03A9F4";
            },
            nextState: function() {
                return "#4CAF50";
            },
            error: function() {
                return "#F20404";
            }
        },
        diff: !1,
        diffPredicate: void 0,
        transformer: void 0
    }, T = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.dispatch, r = e.getState;
        return "function" == typeof t || "function" == typeof r ? S()({
            dispatch: t,
            getState: r
        }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
    };
    e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});





var $i5UNc = parcelRequire("i5UNc");
const $59a61dbb6cd2676b$var$INITIAL_STATE = {
    jobs: [],
    id: undefined,
    job: undefined,
    email: undefined,
    entityId: undefined,
    lastName: undefined,
    firstName: undefined,
    languageId: undefined,
    workNumber: undefined,
    phoneNumber: undefined,
    landlineNumber: undefined,
    userInformationId: undefined,
    birthday: undefined
};
const $59a61dbb6cd2676b$export$f578f9573782f150 = {
    id: undefined,
    createAt: undefined,
    updateAt: undefined,
    requestAt: undefined,
    completedAt: undefined,
    description: undefined,
    taxYearInterviewId: undefined
};
const $59a61dbb6cd2676b$var$clientSlice = (0, $44e12de5a38cd004$export$4d8d9bd83c24ae8b)({
    name: 'client',
    initialState: $59a61dbb6cd2676b$var$INITIAL_STATE,
    reducers: {
        resetClientData: (state)=>({
                ...state,
                ...$59a61dbb6cd2676b$var$INITIAL_STATE
            }),
        setClientData: (state, action)=>{
            const { workNumber: workNumber, phoneNumber: phoneNumber, landlineNumber: landlineNumber, ...restPayload } = action.payload;
            return {
                ...state,
                ...restPayload,
                ...workNumber ? {
                    workNumber: (0, $i5UNc.omit)(workNumber, '__typename')
                } : {},
                ...phoneNumber ? {
                    phoneNumber: (0, $i5UNc.omit)(phoneNumber, '__typename')
                } : {},
                ...landlineNumber ? {
                    landlineNumber: (0, $i5UNc.omit)(landlineNumber, '__typename')
                } : {}
            };
        },
        updateJobInList: (state, action)=>({
                ...state,
                jobs: [
                    ...state.jobs.map((job)=>{
                        if (job.id === action.payload.id) return {
                            ...job,
                            ...action.payload
                        };
                        return job;
                    })
                ]
            }),
        removeJobInlist: (state, action)=>({
                ...state,
                jobs: state.jobs.filter(({ id: id })=>{
                    if (id === action.payload.id) return false;
                    return true;
                })
            }),
        updateJobInListAndSelectedJob: (state, action)=>({
                ...state,
                job: state?.job?.id === action.payload.id ? {
                    ...state.job,
                    ...action.payload
                } : {
                    ...state.job
                },
                jobs: state.jobs.map((job)=>{
                    if (job.id === action.payload.id) return {
                        ...job,
                        ...action.payload
                    };
                    return job;
                })
            }),
        setTaskInJobList (state, action) {
            return {
                ...state,
                jobs: state.jobs.map((job)=>{
                    if (job.id === action.payload.jobId) return {
                        ...job,
                        Tasks: [
                            ...job.Tasks,
                            action.payload.task
                        ]
                    };
                    return job;
                })
            };
        }
    }
});
const { setClientData: $59a61dbb6cd2676b$export$b7c209536cc73fdf, updateJobInList: $59a61dbb6cd2676b$export$78920674715e6dcf, removeJobInlist: $59a61dbb6cd2676b$export$89e9dd6ce8ce4d6c, resetClientData: $59a61dbb6cd2676b$export$28052446e33b6b86, updateJobInListAndSelectedJob: $59a61dbb6cd2676b$export$bcdede59be5b38a5, setTaskInJobList: $59a61dbb6cd2676b$export$db56a3fa70d52194 } = $59a61dbb6cd2676b$var$clientSlice.actions;
const $59a61dbb6cd2676b$export$6ff67ccf1d823f06 = (state)=>state.client;
const $59a61dbb6cd2676b$export$3d7376a035007c14 = (state)=>state.client.jobs.filter(({ TaxYear: TaxYear })=>TaxYear.Entity.Users.id === state.client.id);
const $59a61dbb6cd2676b$export$60a97d652ae11c5a = (jobId)=>(state)=>state.client.jobs.filter(({ id: id })=>id === jobId)[0];
const $59a61dbb6cd2676b$export$89e68ced66ee156d = ({ session: session, client: client })=>session.languages.filter(({ id: id })=>id === client.languageId)[0];
const $59a61dbb6cd2676b$export$fa413959a37814a5 = ({ taxYearInterviewId: taxYearInterviewId, questionId: questionId })=>({ client: client })=>{
        const job = client.jobs.filter(({ id: id })=>id === taxYearInterviewId)[0];
        if (job) {
            const { Answers: Answers } = job;
            if (Answers?.length) return Answers.filter(({ id: id })=>id === questionId)[0] ?? $59a61dbb6cd2676b$export$f578f9573782f150;
        }
        return $59a61dbb6cd2676b$export$f578f9573782f150;
    };
const $59a61dbb6cd2676b$export$61caf638b7690b55 = (jobId, paymentId, inList)=>(store)=>inList ? store.client.jobs.filter(({ id: id })=>jobId === id)[0]?.Tasks?.filter(({ Payments: Payments })=>Payments[0]?.id === paymentId)[0] : store.client.job.Tasks?.filter(({ Payments: Payments })=>Payments[0]?.id === paymentId)[0];
var $59a61dbb6cd2676b$export$2e2bcd8739ae039 = $59a61dbb6cd2676b$var$clientSlice.reducer;


/* eslint-disable */ 
// Define the initial state using that type
const $e3b9937a336ce5aa$var$initialState = {
    email: undefined,
    accessToken: undefined,
    previousAccessToken: undefined,
    id: undefined,
    userId: undefined,
    firstName: undefined,
    lastName: undefined,
    birthday: undefined,
    ssn: undefined,
    profilePhoto: undefined,
    firmAccountId: undefined,
    userInformationId: undefined,
    languageId: undefined,
    userRole: undefined,
    progressStatuses: undefined,
    languages: undefined,
    firmName: undefined,
    firmAddress: undefined,
    firmPhoneNumber: undefined,
    firmCreatedAt: undefined,
    userCreatedAt: undefined
};
const $e3b9937a336ce5aa$export$ecdc87976bfd5f14 = (0, $44e12de5a38cd004$export$4d8d9bd83c24ae8b)({
    name: 'session',
    initialState: // `createSlice` will infer the state type from the `initialState` argument
    $e3b9937a336ce5aa$var$initialState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        setProfilePhoto: (state, action)=>{
            return {
                ...state,
                profilePhoto: action.payload
            };
        },
        setSession: (state, action)=>{
            return {
                ...state,
                email: action.payload.email,
                accessToken: action.payload.accessToken,
                id: action.payload.id,
                userId: action.payload.userId,
                userInformationId: action.payload.userInformationId,
                firstName: action.payload.firstName,
                lastName: action.payload.lastName,
                birthday: action.payload.birthday,
                ssn: action.payload.ssn,
                profilePhoto: action.payload.profilePhoto,
                firmAccountId: action.payload.firmAccountId,
                languageId: action.payload.languageId,
                userRole: action.payload.userRole,
                firmName: action.payload.firmName,
                progressStatuses: action.payload.progressStatuses,
                firmAddress: action.payload.firmAddress,
                firmPhoneNumber: action.payload.firmPhoneNumber,
                firmCreatedAt: action.payload.firmCreatedAt,
                userCreatedAt: action.payload.userCreatedAt
            };
        },
        addProgressStatus: (state, action)=>({
                ...state,
                progressStatuses: [
                    ...state.progressStatuses,
                    action.payload
                ]
            }),
        updateProgressStatus: (state, action)=>({
                ...state,
                progressStatuses: state.progressStatuses.map(({ id: id, ...statusData })=>{
                    if (id === action.payload.id) return action.payload;
                    return {
                        id: id,
                        ...statusData
                    };
                })
            }),
        removeProgressStatus: (state, action)=>({
                ...state,
                progressStatuses: state.progressStatuses.filter(({ id: id })=>{
                    if (action.payload.id === id) return false;
                    return true;
                })
            }),
        resetSession: ()=>{
            return $e3b9937a336ce5aa$var$initialState;
        },
        setPreviousAccessToken: (state, action)=>{
            return {
                ...state,
                previousAccessToken: action.payload.accessToken
            };
        },
        setAllLanguages: (state, action)=>({
                ...state,
                languages: action.payload.languages
            })
    }
});
const { setSession: $e3b9937a336ce5aa$export$b94982631f8f9752, setProfilePhoto: $e3b9937a336ce5aa$export$a47ec9a39832a0a7, resetSession: $e3b9937a336ce5aa$export$b5d16ddcd70241c7, addProgressStatus: $e3b9937a336ce5aa$export$a8eb14e18a4a0672, updateProgressStatus: $e3b9937a336ce5aa$export$dd58280d98c6df6a, removeProgressStatus: $e3b9937a336ce5aa$export$e4af0a63758a5a96, setPreviousAccessToken: $e3b9937a336ce5aa$export$940f9a34d01c641a, setAllLanguages: $e3b9937a336ce5aa$export$d25bc3c2e588da99 } = $e3b9937a336ce5aa$export$ecdc87976bfd5f14.actions;
const $e3b9937a336ce5aa$export$ca779d385d6ad982 = (state)=>state.session;
const $e3b9937a336ce5aa$export$20b36ebcfeb0a091 = ({ session: session })=>session.languages.filter(({ id: id })=>id === session.languageId)[0];
var $e3b9937a336ce5aa$export$2e2bcd8739ae039 = $e3b9937a336ce5aa$export$ecdc87976bfd5f14.reducer;



const $af02328711f8c5fd$var$INITIAL_STATE = {
    interviews: [],
    currentInterview: null
};
const $af02328711f8c5fd$var$interviewsSlice = (0, $44e12de5a38cd004$export$4d8d9bd83c24ae8b)({
    name: 'interviews',
    initialState: $af02328711f8c5fd$var$INITIAL_STATE,
    reducers: {
        resetInterviews: (state)=>({
                ...state,
                ...$af02328711f8c5fd$var$INITIAL_STATE
            }),
        setCurrentInterview: (state, action)=>({
                ...state,
                currentInterview: {
                    ...state.currentInterview,
                    ...action.payload
                }
            }),
        setInterviews: (state, action)=>({
                ...state,
                interviews: action.payload
            }),
        clearCurrentInterview: (state)=>({
                ...state,
                currentInterview: null
            })
    }
});
const $af02328711f8c5fd$export$c0faa43928530039 = (state)=>state.interviews.interviews;
const $af02328711f8c5fd$export$7708ce48455f25ad = (state)=>{
    const getTranslationsWithoutDeleteOperations = (translations)=>translations.filter(({ operation: operation })=>!operation || operation !== 'delete');
    const getOptionsWithoutDeleteOperations = (options)=>options.filter(({ operation: operation })=>!operation || operation !== 'delete').map((option)=>({
                ...option,
                Translations: getTranslationsWithoutDeleteOperations(option.Translations)
            }));
    const getQuestionsWithoutDeleteOperations = (questions)=>questions.filter(({ operation: operation })=>!operation || operation !== 'delete').map((question)=>({
                ...question,
                Options: getOptionsWithoutDeleteOperations(question.Options ?? []),
                Translations: getTranslationsWithoutDeleteOperations(question.Translations ?? [])
            }));
    const getSectionsWithoutDeleteOperations = (sections)=>sections.filter(({ operation: operation })=>!operation || operation !== 'delete').map((section)=>{
            const { Translations: SectionTranslations, SubSections: SubSections, Questions: SectionQuestions } = section;
            return {
                ...section,
                Questions: getQuestionsWithoutDeleteOperations(SectionQuestions),
                SubSections: getSectionsWithoutDeleteOperations(SubSections ?? []),
                Translations: getTranslationsWithoutDeleteOperations(SectionTranslations)
            };
        });
    return {
        ...state.interviews.currentInterview ?? {
            id: null,
            name: '',
            Sections: [],
            isLive: false,
            temporalId: null,
            isTemplate: false
        },
        Sections: getSectionsWithoutDeleteOperations(state.interviews.currentInterview?.Sections ?? []).sort(({ order: order }, { order: orderB })=>order - orderB) ?? []
    };
};
const $af02328711f8c5fd$export$a4d45c787b899913 = (state)=>({
        ...state.interviews.currentInterview ?? {
            id: null,
            name: '',
            Sections: [],
            isLive: false,
            temporalId: null,
            isTemplate: false
        }
    });
const { setInterviews: $af02328711f8c5fd$export$51529446d9f71f44, resetInterviews: $af02328711f8c5fd$export$95c2dcacae3679d3, setCurrentInterview: $af02328711f8c5fd$export$7cde7a299bfe1e43, clearCurrentInterview: $af02328711f8c5fd$export$752f0a70a89451c5 } = $af02328711f8c5fd$var$interviewsSlice.actions;
var $af02328711f8c5fd$export$2e2bcd8739ae039 = $af02328711f8c5fd$var$interviewsSlice.reducer;



const $66a7cecdd31d321f$var$CHAT_INITIAL_STATE = {
    channels: [],
    selectedChannel: undefined,
    messages: {}
};
const $66a7cecdd31d321f$var$chatSlice = (0, $44e12de5a38cd004$export$4d8d9bd83c24ae8b)({
    name: 'chat',
    initialState: $66a7cecdd31d321f$var$CHAT_INITIAL_STATE,
    reducers: {
        setSelectedChannel: (state, action)=>({
                ...state,
                selectedChannel: action.payload
            }),
        setChannels: (state, action)=>({
                ...state,
                channels: action.payload
            }),
        appendChannels: (state, action)=>({
                ...state,
                channels: [
                    ...state.channels,
                    ...action.payload
                ]
            }),
        addMessages: (state, action)=>{
            const newMessages = [
                ...state.messages[action.payload.channelId] ?? [],
                ...action.payload.messages
            ];
            const sortedMessages = newMessages?.slice().sort((a, b)=>{
                if (new Date(a.createAt) > new Date(b.createAt)) return 1;
                if (new Date(a.createAt) < new Date(b.createAt)) return -1;
                return 0;
            });
            return {
                ...state,
                messages: {
                    ...state.messages,
                    [action.payload.channelId]: sortedMessages
                }
            };
        },
        setChannelStatusInList: (state, action)=>({
                ...state,
                channels: state.channels.map((channel)=>{
                    if (channel.id === action.payload.id) return {
                        ...channel,
                        status: action.payload.status
                    };
                    return channel;
                })
            }),
        resetChat: ()=>({
                channels: [],
                selectedChannel: undefined,
                messages: {}
            })
    }
});
const { resetChat: $66a7cecdd31d321f$export$43119c4be593e906, setChannels: $66a7cecdd31d321f$export$a142660abc388412, setSelectedChannel: $66a7cecdd31d321f$export$705c7bcc3db528a6, setChannelStatusInList: $66a7cecdd31d321f$export$439d4e84adb1eff5, addMessages: $66a7cecdd31d321f$export$e8c6a0d7313851e, appendChannels: $66a7cecdd31d321f$export$49eea2bdf1db9fe4 } = $66a7cecdd31d321f$var$chatSlice.actions;
const $66a7cecdd31d321f$export$64113a45e478f19d = (state)=>state.chat.selectedChannel;
const $66a7cecdd31d321f$export$2656785094d54bbd = (state)=>state.chat.channels;
const $66a7cecdd31d321f$export$3230350281d85b62 = (state)=>state.chat.messages;
var $66a7cecdd31d321f$export$2e2bcd8739ae039 = $66a7cecdd31d321f$var$chatSlice.reducer;



var $6321cad55da6617a$export$6df15c054eb3c4d7;
(function(RegisterStep) {
    RegisterStep["DONE"] = "DONE";
    RegisterStep["VIDEO"] = "VIDEO";
    RegisterStep["SELECT_PLAN"] = "SELECT_PLAN";
    RegisterStep["PERSONAL_INFO"] = "PERSONAL_INFO";
    RegisterStep["BUSINESS_INFO"] = "BUSINESS_INFO";
    RegisterStep["PERSONAL_ADDRESS"] = "PERSONAL_ADDRESS";
    RegisterStep["BUSINESS_ADDRESS"] = "BUSINESS_ADDRESS";
})($6321cad55da6617a$export$6df15c054eb3c4d7 || ($6321cad55da6617a$export$6df15c054eb3c4d7 = {}));
const $6321cad55da6617a$export$9f19b25b8860c8f1 = {
    the_em: '',
    the_pass: '',
    the_last_name: '',
    the_first_name: '',
    the_confirm_pass: '',
    the_date_of_birth: '',
    the_operating_as: null
};
const $6321cad55da6617a$export$f93bcc1c3c9c48da = {
    the_id: '',
    the_tax_returns: null,
    the_business_name: '',
    the_business_phone: '',
    the_business_phone_id: ''
};
const $6321cad55da6617a$export$39f70ed8ebb03c08 = {
    the_id: '',
    the_city: '',
    the_line1: '',
    the_line2: '',
    the_state: '',
    the_zip_code: ''
};
const $6321cad55da6617a$export$bdf13c23d1fee66b = {
    the_id: '',
    the_city: '',
    the_line1: '',
    the_line2: '',
    the_state: '',
    the_zip_code: ''
};
const $6321cad55da6617a$export$fb8a2d36d2cf937c = {
    cvc: '',
    cardNumber: '',
    expireDate: ''
};
const $6321cad55da6617a$var$INITIAL_STATE = {
    selectedPlanId: null,
    paymentInfo: $6321cad55da6617a$export$fb8a2d36d2cf937c,
    personalInfo: $6321cad55da6617a$export$9f19b25b8860c8f1,
    businessInfo: $6321cad55da6617a$export$f93bcc1c3c9c48da,
    currentStep: $6321cad55da6617a$export$6df15c054eb3c4d7.PERSONAL_INFO,
    personalAddress: $6321cad55da6617a$export$39f70ed8ebb03c08,
    businessAddress: $6321cad55da6617a$export$bdf13c23d1fee66b
};
const $6321cad55da6617a$var$registerSlice = (0, $44e12de5a38cd004$export$4d8d9bd83c24ae8b)({
    initialState: {
        ...$6321cad55da6617a$var$INITIAL_STATE
    },
    name: 'register',
    reducers: {
        changeStep: (state, { payload: payload })=>({
                ...state,
                currentStep: payload
            }),
        setPersonalInfo: (state, { payload: payload })=>({
                ...state,
                personalInfo: {
                    ...state.personalInfo,
                    ...payload
                }
            }),
        setBusinessInfo: (state, { payload: payload })=>({
                ...state,
                businessInfo: {
                    ...state.businessInfo,
                    ...payload
                }
            }),
        setPersonalAddress: (state, { payload: payload })=>({
                ...state,
                personalAddress: {
                    ...state.personalAddress,
                    ...payload
                }
            }),
        setBusinessAddress: (state, { payload: payload })=>({
                ...state,
                businessAddress: {
                    ...state.businessAddress,
                    ...payload
                }
            }),
        setPaymentInfo: (state, { payload: payload })=>({
                ...state,
                paymentInfo: {
                    ...state.paymentInfo,
                    ...payload
                }
            }),
        selectPlanId: (state, { payload: payload })=>({
                ...state,
                selectedPlanId: payload
            }),
        resetRegisterState: (state)=>({
                ...$6321cad55da6617a$var$INITIAL_STATE
            })
    }
});
const $6321cad55da6617a$export$534a056efe5a6df1 = (state)=>state.register;
const { selectPlanId: $6321cad55da6617a$export$8752e44945104444, setPaymentInfo: $6321cad55da6617a$export$daba6e5feed163b5, setBusinessInfo: $6321cad55da6617a$export$90792fd0d1fe4d64, setPersonalInfo: $6321cad55da6617a$export$16ff3f9024376b12, setPersonalAddress: $6321cad55da6617a$export$6758be4729bd8a95, setBusinessAddress: $6321cad55da6617a$export$eac745c5d2b8d5ca, resetRegisterState: $6321cad55da6617a$export$c280c27017a6bb0f } = $6321cad55da6617a$var$registerSlice.actions;
var $6321cad55da6617a$export$2e2bcd8739ae039 = $6321cad55da6617a$var$registerSlice.reducer;


/* eslint-disable */ 
const $9f2fcb8c18c74f4f$var$initialState = {
    heygenStateOpen: undefined,
    isGreetingsDone: false
};
const $9f2fcb8c18c74f4f$export$d77b5804e20a6467 = (0, $44e12de5a38cd004$export$4d8d9bd83c24ae8b)({
    name: 'aiMessages',
    initialState: $9f2fcb8c18c74f4f$var$initialState,
    reducers: {
        setHeygenOpen: (state, action)=>{
            return {
                ...state,
                ...action.payload
            };
        },
        setGreetingsDone: (state, action)=>{
            return {
                ...state,
                ...action.payload
            };
        }
    }
});
const { setHeygenOpen: $9f2fcb8c18c74f4f$export$499f69d44b807de0, setGreetingsDone: $9f2fcb8c18c74f4f$export$1a5760e25fa92c7f } = $9f2fcb8c18c74f4f$export$d77b5804e20a6467.actions;
var $9f2fcb8c18c74f4f$export$2e2bcd8739ae039 = $9f2fcb8c18c74f4f$export$d77b5804e20a6467.reducer;


const $e4ec60025026f14e$var$persistConfig = {
    key: 'root',
    storage: $42bae757363610b8$export$2e2bcd8739ae039,
    blacklist: [
        'interviews',
        'chat',
        'register'
    ]
};
const $e4ec60025026f14e$var$reducers = (0, $e0db014f981f40cf$export$66e4520cdb265d18)({
    chat: (0, $66a7cecdd31d321f$export$2e2bcd8739ae039),
    client: (0, $59a61dbb6cd2676b$export$2e2bcd8739ae039),
    session: (0, $e3b9937a336ce5aa$export$2e2bcd8739ae039),
    register: (0, $6321cad55da6617a$export$2e2bcd8739ae039),
    interviews: (0, $af02328711f8c5fd$export$2e2bcd8739ae039),
    aiMessages: (0, $9f2fcb8c18c74f4f$export$2e2bcd8739ae039)
});
const $e4ec60025026f14e$var$persistedReducer = (0, $d57599ddbbf3a34e$export$2e2bcd8739ae039)($e4ec60025026f14e$var$persistConfig, $e4ec60025026f14e$var$reducers);
const $e4ec60025026f14e$var$store = (0, $44e12de5a38cd004$export$7d8a5b498da695ac)({
    reducer: $e4ec60025026f14e$var$persistedReducer,
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    (0, $97a27fb4e1c739e5$export$2aaee4793dd13a52),
                    (0, $97a27fb4e1c739e5$export$1647ef958242c4e2),
                    (0, $97a27fb4e1c739e5$export$dd1033c27a16bbd3),
                    (0, $97a27fb4e1c739e5$export$913fe0e161ed92a2),
                    (0, $97a27fb4e1c739e5$export$5514fc3b4067675f),
                    (0, $97a27fb4e1c739e5$export$51e82cdd7353a0e1)
                ]
            }
        }).concat((0, (/*@__PURE__*/$parcel$interopDefault($719c64f71d9c516c$exports)))),
    devTools: false
});
var $e4ec60025026f14e$export$2e2bcd8739ae039 = $e4ec60025026f14e$var$store;


const $6fe88dfd8b11724f$var$config = {
    // eslint-disable-next-line
    env: "production",
    // eslint-disable-next-line
    serverUrl: "https://3v3qd22r2u.us-east-1.awsapprunner.com",
    // eslint-disable-next-line
    clientUrl: "https://client.taxaroo.com",
    // eslint-disable-next-line
    CSRF: '',
    // eslint-disable-next-line
    pusherKey: "b95baacac8892846e00d" ?? '08efc9f3f00e6821d6ff',
    // eslint-disable-next-line
    stripeAPIKey: "pk_live_3zev05nEzxLIUAIlvnBeUow8",
    // eslint-disable-next-line
    stripePlanMonthly: undefined,
    // eslint-disable-next-line
    stripePlanAnnual: undefined,
    // eslint-disable-next-line
    stripePlanDownSell: undefined,
    // eslint-disable-next-line
    stripeBlackFridayPricingTableId: "prctbl_1OG1gAFCiM1aXhAm5uhdXQ57",
    // eslint-disable-next-line
    stripePaywallPricingTableId: "prctbl_1OubjWFCiM1aXhAmFHKmik8q",
    // eslint-disable-next-line
    stripeFreePlanPriceId: "price_1OubNrFCiM1aXhAmBW9lZCH8",
    // eslint-disable-next-line
    stripeLitePlanPriceId: "price_1OrXvoFCiM1aXhAm9BwltH7P",
    // eslint-disable-next-line
    stripeMonthlyPlanPriceId: "price_1QS6eqFCiM1aXhAmeuuT0dHh",
    // eslint-disable-next-line
    stripeYearlyPlanPriceId: "price_1OAG4VFCiM1aXhAmDCQjyAmo",
    // eslint-disable-next-line
    agentApiUrl: "wss://agent-api.taxaroo.com"
};
const $6fe88dfd8b11724f$export$b31a738785768718 = (csrf)=>{
    $6fe88dfd8b11724f$var$config.CSRF = csrf;
};
var $6fe88dfd8b11724f$export$2e2bcd8739ae039 = $6fe88dfd8b11724f$var$config;


const $dfc6a33c14790f87$var$getUserFromSession = ()=>{
    const user = (0, $e4ec60025026f14e$export$2e2bcd8739ae039).getState().session;
    return {
        id: user?.userId,
        email: user?.email,
        FirstName: user?.firstName,
        LastName: user?.lastName,
        FullName: user?.firstName ? `${user?.firstName} ${user?.lastName}` : undefined,
        Role: user?.userRole,
        FirmAccountId: user?.firmAccountId
    };
};
// identify, page, track, reset, on, off
const $dfc6a33c14790f87$var$callCustomerIoMethod = (methodName, params, trackEventName)=>{
    if ((0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).env === 'development') console.log({
        methodName: methodName,
        params: params,
        trackEventName: trackEventName
    });
    if ((0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).env !== 'production') return null;
    try {
        // eslint-disable-next-line
        const _cio = window['_cio'];
        if (_cio) {
            if (trackEventName) return _cio[methodName](trackEventName, {
                ...params,
                env: (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).env
            });
            return _cio[methodName]({
                ...params,
                env: (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).env
            });
        }
        console.warn('_cio is not defined');
    } catch (e) {
        console.log('_cio error', e);
    }
    return null;
};
var $dfc6a33c14790f87$export$8f144a86ebfa3544;
(function(CUSTOMER_IO_EVENTS) {
    CUSTOMER_IO_EVENTS["SING_IN"] = "Sign In";
    CUSTOMER_IO_EVENTS["SIGN_OUT"] = "Sign Out";
    CUSTOMER_IO_EVENTS["TAB_SELECT"] = "Tab Select";
    CUSTOMER_IO_EVENTS["JOB_DETAILS"] = "Job Details";
    CUSTOMER_IO_EVENTS["MODAL_SHOW"] = "Modal Show";
    CUSTOMER_IO_EVENTS["CLICK"] = "Click Action";
    CUSTOMER_IO_EVENTS["REGISTER"] = "Register";
    CUSTOMER_IO_EVENTS["HEYGEN_SESSION_ID"] = "Heygen Session Id";
})($dfc6a33c14790f87$export$8f144a86ebfa3544 || ($dfc6a33c14790f87$export$8f144a86ebfa3544 = {}));
const $dfc6a33c14790f87$export$10a8148065e6dad6 = (eventName, params)=>$dfc6a33c14790f87$var$callCustomerIoMethod('track', params, eventName);
const $dfc6a33c14790f87$export$212bca99edcd2b5f = ()=>{
    const identity = $dfc6a33c14790f87$var$getUserFromSession();
    $dfc6a33c14790f87$var$callCustomerIoMethod('identify', identity);
    $dfc6a33c14790f87$export$10a8148065e6dad6($dfc6a33c14790f87$export$8f144a86ebfa3544.SING_IN, identity);
};
const $dfc6a33c14790f87$export$1e0a7af4e6017e75 = ()=>{
    const identity = $dfc6a33c14790f87$var$getUserFromSession();
    $dfc6a33c14790f87$var$callCustomerIoMethod('identify', identity);
    $dfc6a33c14790f87$export$10a8148065e6dad6($dfc6a33c14790f87$export$8f144a86ebfa3544.SIGN_OUT, identity);
    $dfc6a33c14790f87$var$callCustomerIoMethod('reset', identity);
};
const $dfc6a33c14790f87$export$eae5917686cce945 = ()=>{
    const identity = $dfc6a33c14790f87$var$getUserFromSession();
    $dfc6a33c14790f87$var$callCustomerIoMethod('identify', identity);
};
const $dfc6a33c14790f87$export$92ab14d0aa42e41e = ()=>{
    $dfc6a33c14790f87$var$callCustomerIoMethod('page', {}, window.location.href);
};
const $dfc6a33c14790f87$export$687cd65f7d91f1da = (planType)=>{
    const identity = $dfc6a33c14790f87$var$getUserFromSession();
    $dfc6a33c14790f87$var$callCustomerIoMethod('identify', {
        ...identity,
        PlanType: planType
    });
};
const $dfc6a33c14790f87$export$3d6a71dac8f63b0b = (finishedOnboarding)=>{
    const identity = $dfc6a33c14790f87$var$getUserFromSession();
    $dfc6a33c14790f87$var$callCustomerIoMethod('identify', {
        ...identity,
        StripeFinishedOnboarding: finishedOnboarding
    });
};
const $dfc6a33c14790f87$export$15307ef7a3dbf74e = (name, status)=>{
    const identity = $dfc6a33c14790f87$var$getUserFromSession();
    $dfc6a33c14790f87$var$callCustomerIoMethod('identify', {
        ...identity,
        CustomDomainURL: name || null,
        CustomDomainStatus: status
    });
};
const $dfc6a33c14790f87$export$b3f6a57c0551730 = (id, email, firstName, lastName, role, firmAccountId)=>{
    const identity = {
        id: id,
        email: email,
        FirstName: firstName,
        LastName: lastName,
        FullName: firstName ? `${firstName} ${lastName}` : undefined,
        Role: role,
        FirmAccountId: firmAccountId,
        created_at: Math.round(new Date().getTime() / 1e3)
    };
    $dfc6a33c14790f87$var$callCustomerIoMethod('identify', identity);
    $dfc6a33c14790f87$export$10a8148065e6dad6($dfc6a33c14790f87$export$8f144a86ebfa3544.REGISTER, identity);
};



/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $c4dc83c92383a7f6$export$c10d0b04eaa80a43(value) {
    return typeof value == 'object' && value !== null;
}


function $1f9d76f75e6279ef$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}


const $7b72da85f54bbe71$var$LineRegExp = /\r\n|[\n\r]/g;
function $7b72da85f54bbe71$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($7b72da85f54bbe71$var$LineRegExp)){
        typeof match.index === 'number' || (0, $1f9d76f75e6279ef$export$f5708dca728d7177)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}



function $7725138d19df058f$export$96a9681e539deed(location) {
    return $7725138d19df058f$export$867940333fd9f869(location.source, (0, $7b72da85f54bbe71$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $7725138d19df058f$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = ''.padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $7725138d19df058f$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    '|',
                    subLine
                ]),
            [
                '|',
                '^'.padStart(subLineColumnNum)
            ],
            [
                '|',
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $7725138d19df058f$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            '|',
            '^'.padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $7725138d19df058f$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? ' ' + line : '')).join('\n');
}


function $0e333f7706dea6f8$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $0e333f7706dea6f8$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $0e333f7706dea6f8$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = 'GraphQLError';
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $0e333f7706dea6f8$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $0e333f7706dea6f8$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $7b72da85f54bbe71$export$e7fd20fad3cf4b5f)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $7b72da85f54bbe71$export$e7fd20fad3cf4b5f)(loc.source, loc.start));
        const originalExtensions = (0, $c4dc83c92383a7f6$export$c10d0b04eaa80a43)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, 'stack', {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $0e333f7706dea6f8$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return 'GraphQLError';
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += '\n\n' + (0, $7725138d19df058f$export$96a9681e539deed)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += '\n\n' + (0, $7725138d19df058f$export$867940333fd9f869)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $0e333f7706dea6f8$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $0e333f7706dea6f8$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $0e333f7706dea6f8$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}


function $00bd2bacf336a5f1$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $0e333f7706dea6f8$export$92d6ed0888e7cb7f)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $8c8cf88dd9d4f3e6$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $8c8cf88dd9d4f3e6$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $8c8cf88dd9d4f3e6$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
const $8c8cf88dd9d4f3e6$var$kindValues = new Set(Object.keys($8c8cf88dd9d4f3e6$export$4fcd777a40ccf407));
function $8c8cf88dd9d4f3e6$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $8c8cf88dd9d4f3e6$var$kindValues.has(maybeKind);
}
/** Name */ var $8c8cf88dd9d4f3e6$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($8c8cf88dd9d4f3e6$export$f58c50edb4aef9d4 || ($8c8cf88dd9d4f3e6$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed directive location values.
 */ var $e34da38169498656$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation['QUERY'] = 'QUERY';
    DirectiveLocation['MUTATION'] = 'MUTATION';
    DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
    DirectiveLocation['FIELD'] = 'FIELD';
    DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
    DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
    DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
    DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
    DirectiveLocation['SCHEMA'] = 'SCHEMA';
    DirectiveLocation['SCALAR'] = 'SCALAR';
    DirectiveLocation['OBJECT'] = 'OBJECT';
    DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
    DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
    DirectiveLocation['INTERFACE'] = 'INTERFACE';
    DirectiveLocation['UNION'] = 'UNION';
    DirectiveLocation['ENUM'] = 'ENUM';
    DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
    DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
    DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})($e34da38169498656$export$b45ffd2948484c41 || ($e34da38169498656$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 

/**
 * The set of allowed kind values for AST nodes.
 */ var $5050f41989ff6c78$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})($5050f41989ff6c78$export$a84bdc57c5122798 || ($5050f41989ff6c78$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $c4a6284118c1fa86$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $c4a6284118c1fa86$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $c4a6284118c1fa86$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $c4a6284118c1fa86$export$45a677ea7cb6d5c8(code) {
    return $c4a6284118c1fa86$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $c4a6284118c1fa86$export$d3f406ff46035894(code) {
    return $c4a6284118c1fa86$export$79c5d5217943d6a7(code) || $c4a6284118c1fa86$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $9035e60eb7281107$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $9035e60eb7281107$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $9035e60eb7281107$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $c4a6284118c1fa86$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $9035e60eb7281107$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $9035e60eb7281107$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $c4a6284118c1fa86$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $c4a6284118c1fa86$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}



/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $b6f979a07c6a61bc$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind['SOF'] = '<SOF>';
    TokenKind['EOF'] = '<EOF>';
    TokenKind['BANG'] = '!';
    TokenKind['DOLLAR'] = '$';
    TokenKind['AMP'] = '&';
    TokenKind['PAREN_L'] = '(';
    TokenKind['PAREN_R'] = ')';
    TokenKind['SPREAD'] = '...';
    TokenKind['COLON'] = ':';
    TokenKind['EQUALS'] = '=';
    TokenKind['AT'] = '@';
    TokenKind['BRACKET_L'] = '[';
    TokenKind['BRACKET_R'] = ']';
    TokenKind['BRACE_L'] = '{';
    TokenKind['PIPE'] = '|';
    TokenKind['BRACE_R'] = '}';
    TokenKind['NAME'] = 'Name';
    TokenKind['INT'] = 'Int';
    TokenKind['FLOAT'] = 'Float';
    TokenKind['STRING'] = 'String';
    TokenKind['BLOCK_STRING'] = 'BlockString';
    TokenKind['COMMENT'] = 'Comment';
})($b6f979a07c6a61bc$export$8b9d26ab11394711 || ($b6f979a07c6a61bc$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 

class $fd3c00a89e043c78$export$6168dc8908a6c652 {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $8c8cf88dd9d4f3e6$export$50792b0e93539fde)((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return 'Lexer';
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $fd3c00a89e043c78$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).COMMENT);
        }
        return token;
    }
}
function $fd3c00a89e043c78$export$59ac0f4da287406a(kind) {
    return kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BANG || kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).DOLLAR || kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).AMP || kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).PAREN_L || kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).PAREN_R || kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).SPREAD || kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).COLON || kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).EQUALS || kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).AT || kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACKET_L || kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACKET_R || kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_L || kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).PIPE || kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $fd3c00a89e043c78$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $fd3c00a89e043c78$var$isSupplementaryCodePoint(body, location) {
    return $fd3c00a89e043c78$var$isLeadingSurrogate(body.charCodeAt(location)) && $fd3c00a89e043c78$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $fd3c00a89e043c78$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $fd3c00a89e043c78$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $fd3c00a89e043c78$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */ function $fd3c00a89e043c78$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $8c8cf88dd9d4f3e6$export$50792b0e93539fde)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $fd3c00a89e043c78$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $fd3c00a89e043c78$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BANG, position, position + 1);
            case 0x0024:
                // $
                return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).AMP, position, position + 1);
            case 0x0028:
                // (
                return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x003d:
                // =
                return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).AT, position, position + 1);
            case 0x005b:
                // [
                return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $fd3c00a89e043c78$var$readBlockString(lexer, position);
                return $fd3c00a89e043c78$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $c4a6284118c1fa86$export$727d9dbc4fbb948f)(code) || code === 0x002d) return $fd3c00a89e043c78$var$readNumber(lexer, position, code);
         // Name
        if ((0, $c4a6284118c1fa86$export$45a677ea7cb6d5c8)(code)) return $fd3c00a89e043c78$var$readName(lexer, position);
        throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(lexer.source, position, code === 0x0027 ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?' : $fd3c00a89e043c78$var$isUnicodeScalarValue(code) || $fd3c00a89e043c78$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$fd3c00a89e043c78$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$fd3c00a89e043c78$var$printCodePointAt(lexer, position)}.`);
    }
    return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $fd3c00a89e043c78$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($fd3c00a89e043c78$var$isUnicodeScalarValue(code)) ++position;
        else if ($fd3c00a89e043c78$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $fd3c00a89e043c78$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $c4a6284118c1fa86$export$727d9dbc4fbb948f)(code)) throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$fd3c00a89e043c78$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $fd3c00a89e043c78$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $fd3c00a89e043c78$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $fd3c00a89e043c78$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $c4a6284118c1fa86$export$45a677ea7cb6d5c8)(code)) throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, expected digit but got: ${$fd3c00a89e043c78$var$printCodePointAt(lexer, position)}.`);
    return $fd3c00a89e043c78$var$createToken(lexer, isFloat ? (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).FLOAT : (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $fd3c00a89e043c78$var$readDigits(lexer, start, firstCode) {
    if (!(0, $c4a6284118c1fa86$export$727d9dbc4fbb948f)(firstCode)) throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(lexer.source, start, `Invalid number, expected digit but got: ${$fd3c00a89e043c78$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $c4a6284118c1fa86$export$727d9dbc4fbb948f)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $fd3c00a89e043c78$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = '';
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $fd3c00a89e043c78$var$readEscapedUnicodeVariableWidth(lexer, position) : $fd3c00a89e043c78$var$readEscapedUnicodeFixedWidth(lexer, position) : $fd3c00a89e043c78$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($fd3c00a89e043c78$var$isUnicodeScalarValue(code)) ++position;
        else if ($fd3c00a89e043c78$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$fd3c00a89e043c78$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.
function $fd3c00a89e043c78$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$fd3c00a89e043c78$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $fd3c00a89e043c78$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $fd3c00a89e043c78$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $fd3c00a89e043c78$var$read16BitHexCode(body, position + 2);
    if ($fd3c00a89e043c78$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($fd3c00a89e043c78$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $fd3c00a89e043c78$var$read16BitHexCode(body, position + 8);
            if ($fd3c00a89e043c78$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $fd3c00a89e043c78$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $fd3c00a89e043c78$var$readHexDigit(body.charCodeAt(position)) << 12 | $fd3c00a89e043c78$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $fd3c00a89e043c78$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $fd3c00a89e043c78$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $fd3c00a89e043c78$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $fd3c00a89e043c78$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '\u0022',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: '\u005c',
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: '\u002f',
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: '\u0008',
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: '\u000c',
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: '\u000a',
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: '\u000d',
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: '\u0009',
                size: 2
            };
    }
    throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $fd3c00a89e043c78$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = '';
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, (0, $9035e60eb7281107$export$d5ee19b441e8d2ae)(blockLines).join('\n'));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = '';
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($fd3c00a89e043c78$var$isUnicodeScalarValue(code)) ++position;
        else if ($fd3c00a89e043c78$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$fd3c00a89e043c78$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $fd3c00a89e043c78$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $c4a6284118c1fa86$export$d3f406ff46035894)(code)) ++position;
        else break;
    }
    return $fd3c00a89e043c78$var$createToken(lexer, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).NAME, start, position, body.slice(start, position));
}




function $80144b7d42788eda$export$98e6a39c04603d36(source, options) {
    const parser = new $80144b7d42788eda$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $80144b7d42788eda$export$5303528d1070ff6f(source, options) {
    const parser = new $80144b7d42788eda$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).EOF);
    return value;
}
function $80144b7d42788eda$export$e14c466bd0916f7a(source, options) {
    const parser = new $80144b7d42788eda$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).EOF);
    return value;
}
function $80144b7d42788eda$export$28b8f402ccc88182(source, options) {
    const parser = new $80144b7d42788eda$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).EOF);
    return type;
}
class $80144b7d42788eda$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const sourceObj = (0, $f0c15646e987ba10$export$75135ee9ed6e435b)(source) ? source : new (0, $f0c15646e987ba10$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $fd3c00a89e043c78$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).NAME);
        return this.node(token, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).NAME) {
            switch(keywordToken.value){
                case 'schema':
                    return this.parseSchemaDefinition();
                case 'scalar':
                    return this.parseScalarTypeDefinition();
                case 'type':
                    return this.parseObjectTypeDefinition();
                case 'interface':
                    return this.parseInterfaceTypeDefinition();
                case 'union':
                    return this.parseUnionTypeDefinition();
                case 'enum':
                    return this.parseEnumTypeDefinition();
                case 'input':
                    return this.parseInputObjectTypeDefinition();
                case 'directive':
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, 'Unexpected description, descriptions are supported only on type definitions.');
            switch(keywordToken.value){
                case 'query':
                case 'mutation':
                case 'subscription':
                    return this.parseOperationDefinition();
                case 'fragment':
                    return this.parseFragmentDefinition();
                case 'extend':
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_L)) return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: (0, $8c8cf88dd9d4f3e6$export$f58c50edb4aef9d4).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case 'query':
                return (0, $8c8cf88dd9d4f3e6$export$f58c50edb4aef9d4).QUERY;
            case 'mutation':
                return (0, $8c8cf88dd9d4f3e6$export$f58c50edb4aef9d4).MUTATION;
            case 'subscription':
                return (0, $8c8cf88dd9d4f3e6$export$f58c50edb4aef9d4).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).DOLLAR);
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).PAREN_L, item, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).NAME)) return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).INT,
                    value: token.value
                });
            case (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).FLOAT,
                    value: token.value
                });
            case (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).STRING:
            case (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).NAME:
                this.advanceLexer();
                switch(token.value){
                    case 'true':
                        return this.node(token, {
                            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).BOOLEAN,
                            value: true
                        });
                    case 'false':
                        return this.node(token, {
                            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).BOOLEAN,
                            value: false
                        });
                    case 'null':
                        return this.node(token, {
                            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).ENUM,
                            value: token.value
                        });
                }
            case (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).DOLLAR);
                    if (this._lexer.token.kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).LIST,
            values: this.any((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACKET_L, item, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_L, item, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).AT);
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACKET_R);
            type = this.node(start, {
                kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BANG)) return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).STRING) || this.peek((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_R);
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword('implements') ? this.delimitedMany((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === 'true' || this._lexer.token.value === 'false' || this._lexer.token.value === 'null') throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, `${$80144b7d42788eda$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $5050f41989ff6c78$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $b6f979a07c6a61bc$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $e34da38169498656$export$b45ffd2948484c41), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $8c8cf88dd9d4f3e6$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected ${$80144b7d42788eda$var$getTokenKindDesc(kind)}, found ${$80144b7d42788eda$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).NAME && token.value === value) this.advanceLexer();
        else throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected "${value}", found ${$80144b7d42788eda$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected ${$80144b7d42788eda$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (maxTokens !== undefined && token.kind !== (0, $b6f979a07c6a61bc$export$8b9d26ab11394711).EOF) {
            ++this._tokenCounter;
            if (this._tokenCounter > maxTokens) throw (0, $00bd2bacf336a5f1$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $80144b7d42788eda$var$getTokenDesc(token) {
    const value = token.value;
    return $80144b7d42788eda$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $80144b7d42788eda$var$getTokenKindDesc(kind) {
    return (0, $fd3c00a89e043c78$export$59ac0f4da287406a)(kind) ? `"${kind}"` : kind;
}


var $a6e2f431afb98ad4$var$docCache = new Map();
var $a6e2f431afb98ad4$var$fragmentSourceMap = new Map();
var $a6e2f431afb98ad4$var$printFragmentWarnings = true;
var $a6e2f431afb98ad4$var$experimentalFragmentVariables = false;
function $a6e2f431afb98ad4$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $a6e2f431afb98ad4$var$cacheKeyFromLoc(loc) {
    return $a6e2f431afb98ad4$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $a6e2f431afb98ad4$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $a6e2f431afb98ad4$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $a6e2f431afb98ad4$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($a6e2f431afb98ad4$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $a6e2f431afb98ad4$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, ast), {
        definitions: definitions
    });
}
function $a6e2f431afb98ad4$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $a6e2f431afb98ad4$var$parseDocument(source) {
    var cacheKey = $a6e2f431afb98ad4$var$normalize(source);
    if (!$a6e2f431afb98ad4$var$docCache.has(cacheKey)) {
        var parsed = (0, $80144b7d42788eda$export$98e6a39c04603d36)(source, {
            experimentalFragmentVariables: $a6e2f431afb98ad4$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $a6e2f431afb98ad4$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $a6e2f431afb98ad4$var$docCache.set(cacheKey, $a6e2f431afb98ad4$var$stripLoc($a6e2f431afb98ad4$var$processFragments(parsed)));
    }
    return $a6e2f431afb98ad4$var$docCache.get(cacheKey);
}
function $a6e2f431afb98ad4$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $a6e2f431afb98ad4$var$parseDocument(result);
}
function $a6e2f431afb98ad4$export$657554ef4dc7ac2d() {
    $a6e2f431afb98ad4$var$docCache.clear();
    $a6e2f431afb98ad4$var$fragmentSourceMap.clear();
}
function $a6e2f431afb98ad4$export$e4294e638636c6ab() {
    $a6e2f431afb98ad4$var$printFragmentWarnings = false;
}
function $a6e2f431afb98ad4$export$78cf889af350c840() {
    $a6e2f431afb98ad4$var$experimentalFragmentVariables = true;
}
function $a6e2f431afb98ad4$export$5290df9bbbd3cfa() {
    $a6e2f431afb98ad4$var$experimentalFragmentVariables = false;
}
var $a6e2f431afb98ad4$var$extras = {
    gql: $a6e2f431afb98ad4$export$72e4926bf8358653,
    resetCaches: $a6e2f431afb98ad4$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $a6e2f431afb98ad4$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $a6e2f431afb98ad4$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $a6e2f431afb98ad4$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $a6e2f431afb98ad4$var$extras.gql, gql_1.resetCaches = $a6e2f431afb98ad4$var$extras.resetCaches, gql_1.disableFragmentWarnings = $a6e2f431afb98ad4$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $a6e2f431afb98ad4$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $a6e2f431afb98ad4$var$extras.disableExperimentalFragmentVariables;
})($a6e2f431afb98ad4$export$72e4926bf8358653 || ($a6e2f431afb98ad4$export$72e4926bf8358653 = {}));
$a6e2f431afb98ad4$export$72e4926bf8358653["default"] = $a6e2f431afb98ad4$export$72e4926bf8358653;
var $a6e2f431afb98ad4$export$2e2bcd8739ae039 = $a6e2f431afb98ad4$export$72e4926bf8358653;



var $6fFrj = parcelRequire("6fFrj");

function $20c8e93b6072aee9$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}


function $68f062d2048ef6b4$export$235b7fc70b9fc359(defaults, options) {
    return (0, $20c8e93b6072aee9$export$8e16b83750b44988)(defaults, options, options.variables && {
        variables: (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, defaults && defaults.variables), options.variables)
    });
}





var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");

var $54ecaae8b5bfa383$var$didWarnUncachedGetSnapshot = false;
var $54ecaae8b5bfa383$var$uSESKey = "useSyncExternalStore";
var $54ecaae8b5bfa383$var$realHook = $6fFrj[$54ecaae8b5bfa383$var$uSESKey];
var $54ecaae8b5bfa383$export$306c0aa65ff9ec16 = $54ecaae8b5bfa383$var$realHook || function(subscribe, getSnapshot, getServerSnapshot) {
    var value = getSnapshot();
    if (__DEV__ && !$54ecaae8b5bfa383$var$didWarnUncachedGetSnapshot && value !== getSnapshot()) {
        $54ecaae8b5bfa383$var$didWarnUncachedGetSnapshot = true;
        __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).error('The result of getSnapshot should be cached to avoid an infinite loop');
    }
    var _a = $6fFrj.useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _a[0].inst, forceUpdate = _a[1];
    if (0, $b97fc55b2a1fddda$export$4001f6cd4a62405b) $6fFrj.useLayoutEffect(function() {
        Object.assign(inst, {
            value: value,
            getSnapshot: getSnapshot
        });
        if ($54ecaae8b5bfa383$var$checkIfSnapshotChanged(inst)) forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    else Object.assign(inst, {
        value: value,
        getSnapshot: getSnapshot
    });
    $6fFrj.useEffect(function() {
        if ($54ecaae8b5bfa383$var$checkIfSnapshotChanged(inst)) forceUpdate({
            inst: inst
        });
        return subscribe(function handleStoreChange() {
            if ($54ecaae8b5bfa383$var$checkIfSnapshotChanged(inst)) forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    return value;
};
function $54ecaae8b5bfa383$var$checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    } catch (_b) {
        return true;
    }
}


var $9675d5b886252616$var$_a = Object.prototype, $9675d5b886252616$var$toString = $9675d5b886252616$var$_a.toString, $9675d5b886252616$var$hasOwnProperty = $9675d5b886252616$var$_a.hasOwnProperty;
var $9675d5b886252616$var$fnToStr = Function.prototype.toString;
var $9675d5b886252616$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $9675d5b886252616$export$2e2bcd8739ae039(a, b) {
    try {
        return $9675d5b886252616$var$check(a, b);
    } finally{
        $9675d5b886252616$var$previousComparisons.clear();
    }
}
function $9675d5b886252616$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $9675d5b886252616$var$toString.call(a);
    var bTag = $9675d5b886252616$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($9675d5b886252616$var$previouslyCompared(a, b)) return true;
            var aKeys = $9675d5b886252616$var$definedKeys(a);
            var bKeys = $9675d5b886252616$var$definedKeys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$9675d5b886252616$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$9675d5b886252616$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "".concat(b);
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($9675d5b886252616$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$9675d5b886252616$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
        case '[object Uint16Array]':
        case '[object Uint8Array]':
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]':
            var len = a.byteLength;
            if (len === b.byteLength) {
                while(len-- && a[len] === b[len]);
            }
            return len === -1;
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]':
            var aCode = $9675d5b886252616$var$fnToStr.call(a);
            if (aCode !== $9675d5b886252616$var$fnToStr.call(b)) return false;
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !$9675d5b886252616$var$endsWith(aCode, $9675d5b886252616$var$nativeCodeSuffix);
    }
    // Otherwise the values are not equal.
    return false;
}
function $9675d5b886252616$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($9675d5b886252616$var$isDefinedKey, obj);
}
function $9675d5b886252616$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
var $9675d5b886252616$var$nativeCodeSuffix = "{ [native code] }";
function $9675d5b886252616$var$endsWith(full, suffix) {
    var fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $9675d5b886252616$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $9675d5b886252616$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $9675d5b886252616$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}






function $7401f4590b7a34ce$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $7401f4590b7a34ce$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7401f4590b7a34ce$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7401f4590b7a34ce$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7401f4590b7a34ce$var$_arrayLikeToArray(o, minLen);
}
function $7401f4590b7a34ce$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7401f4590b7a34ce$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7401f4590b7a34ce$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7401f4590b7a34ce$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7401f4590b7a34ce$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $7401f4590b7a34ce$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $7401f4590b7a34ce$var$hasSymbol = function(name) {
    return $7401f4590b7a34ce$var$hasSymbols() && Boolean(Symbol[name]);
};
var $7401f4590b7a34ce$var$getSymbol = function(name) {
    return $7401f4590b7a34ce$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($7401f4590b7a34ce$var$hasSymbols() && !$7401f4590b7a34ce$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $7401f4590b7a34ce$var$SymbolIterator = $7401f4590b7a34ce$var$getSymbol('iterator');
var $7401f4590b7a34ce$var$SymbolObservable = $7401f4590b7a34ce$var$getSymbol('observable');
var $7401f4590b7a34ce$var$SymbolSpecies = $7401f4590b7a34ce$var$getSymbol('species'); // === Abstract Operations ===
function $7401f4590b7a34ce$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $7401f4590b7a34ce$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$7401f4590b7a34ce$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $7401f4590b7a34ce$export$77cea355fa80b5f4;
}
function $7401f4590b7a34ce$var$isObservable(x) {
    return x instanceof $7401f4590b7a34ce$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $7401f4590b7a34ce$var$hostReportError(e) {
    if ($7401f4590b7a34ce$var$hostReportError.log) $7401f4590b7a34ce$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $7401f4590b7a34ce$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $7401f4590b7a34ce$var$hostReportError(e);
        }
    });
}
function $7401f4590b7a34ce$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $7401f4590b7a34ce$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $7401f4590b7a34ce$var$hostReportError(e);
    }
}
function $7401f4590b7a34ce$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $7401f4590b7a34ce$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $7401f4590b7a34ce$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $7401f4590b7a34ce$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $7401f4590b7a34ce$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $7401f4590b7a34ce$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $7401f4590b7a34ce$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $7401f4590b7a34ce$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $7401f4590b7a34ce$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $7401f4590b7a34ce$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $7401f4590b7a34ce$var$enqueue(function() {
            return $7401f4590b7a34ce$var$flushSubscription(subscription);
        });
        return;
    }
    $7401f4590b7a34ce$var$notifySubscription(subscription, type, value);
}
var $7401f4590b7a34ce$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $7401f4590b7a34ce$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== 'closed') {
            $7401f4590b7a34ce$var$closeSubscription(this);
            $7401f4590b7a34ce$var$cleanupSubscription(this);
        }
    };
    $7401f4590b7a34ce$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $7401f4590b7a34ce$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $7401f4590b7a34ce$var$onNotify(this._subscription, 'next', value);
    };
    _proto2.error = function error(value) {
        $7401f4590b7a34ce$var$onNotify(this._subscription, 'error', value);
    };
    _proto2.complete = function complete() {
        $7401f4590b7a34ce$var$onNotify(this._subscription, 'complete');
    };
    $7401f4590b7a34ce$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $7401f4590b7a34ce$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $7401f4590b7a34ce$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== 'function') {
                reject(new TypeError(fn + ' is not a function'));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $7401f4590b7a34ce$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $7401f4590b7a34ce$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $7401f4590b7a34ce$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $7401f4590b7a34ce$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $7401f4590b7a34ce$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$7401f4590b7a34ce$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === 'function' ? this : Observable;
        if (x == null) throw new TypeError(x + ' is not an object');
        var method = $7401f4590b7a34ce$var$getMethod(x, $7401f4590b7a34ce$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
            if ($7401f4590b7a34ce$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($7401f4590b7a34ce$var$hasSymbol('iterator')) {
            method = $7401f4590b7a34ce$var$getMethod(x, $7401f4590b7a34ce$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $7401f4590b7a34ce$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $7401f4590b7a34ce$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $7401f4590b7a34ce$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + ' is not observable');
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === 'function' ? this : Observable;
        return new C(function(observer) {
            $7401f4590b7a34ce$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $7401f4590b7a34ce$var$_createClass(Observable, null, [
        {
            key: $7401f4590b7a34ce$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($7401f4590b7a34ce$var$hasSymbols()) Object.defineProperty($7401f4590b7a34ce$export$77cea355fa80b5f4, Symbol('extensions'), {
    value: {
        symbol: $7401f4590b7a34ce$var$SymbolObservable,
        hostReportError: $7401f4590b7a34ce$var$hostReportError
    },
    configurable: true
});


parcelRequire("9wyTk");
var $22bf7fcb4ccfbc69$var$prototype = (0, $7401f4590b7a34ce$export$77cea355fa80b5f4).prototype;
var $22bf7fcb4ccfbc69$var$fakeObsSymbol = '@@observable';
if (!$22bf7fcb4ccfbc69$var$prototype[$22bf7fcb4ccfbc69$var$fakeObsSymbol]) $22bf7fcb4ccfbc69$var$prototype[$22bf7fcb4ccfbc69$var$fakeObsSymbol] = function() {
    return this;
};



function $93c211dba1940fd8$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, context), next(context));
        else context = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, context), next);
    };
    var getContext = function() {
        return (0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    return operation;
}



function $604f10e48f8d6e7b$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === 'object';
}




function $5e4d569a846b5f9e$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw __DEV__ ? new (0, $03191bfc90720c4f$export$cea12affaee22fe8)("Found a ".concat(definition.operation, " operation").concat(definition.name ? " named '".concat(definition.name.value, "'") : '', ". ") + 'No operations are allowed when using a fragment as a query. Only fragments are allowed.') : new (0, $03191bfc90720c4f$export$cea12affaee22fe8)(43);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(fragments.length === 1, "Found ".concat(fragments.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : (0, $03191bfc90720c4f$export$f5708dca728d7177)(fragments.length === 1, 44);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, document), {
        definitions: (0, $7455305bac30ddd9$export$1216008129fb82ed)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $5e4d569a846b5f9e$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $5e4d569a846b5f9e$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case 'InlineFragment':
            return selection;
        case 'FragmentSpread':
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(fragment, "No fragment named ".concat(fragmentName)) : (0, $03191bfc90720c4f$export$f5708dca728d7177)(fragment, 45);
            return fragment || null;
        default:
            return null;
    }
}


function $6fe96515315d55c4$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $6fe96515315d55c4$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === 'object' && typeof obj.__ref === 'string');
}
function $6fe96515315d55c4$export$540432d49fcec6c9(value) {
    return (0, $604f10e48f8d6e7b$export$417207af72fad9c9)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $6fe96515315d55c4$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $6fe96515315d55c4$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $6fe96515315d55c4$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $6fe96515315d55c4$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $6fe96515315d55c4$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $6fe96515315d55c4$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $6fe96515315d55c4$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $6fe96515315d55c4$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $6fe96515315d55c4$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $6fe96515315d55c4$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($6fe96515315d55c4$var$isIntValue(value) || $6fe96515315d55c4$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($6fe96515315d55c4$var$isBooleanValue(value) || $6fe96515315d55c4$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($6fe96515315d55c4$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $6fe96515315d55c4$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($6fe96515315d55c4$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($6fe96515315d55c4$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $6fe96515315d55c4$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($6fe96515315d55c4$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($6fe96515315d55c4$var$isNullValue(value)) argObj[name.value] = null;
    else throw __DEV__ ? new (0, $03191bfc90720c4f$export$cea12affaee22fe8)("The inline argument \"".concat(name.value, "\" of kind \"").concat(value.kind, "\"") + 'is not supported. Use variables instead of inline arguments to ' + 'overcome this limitation.') : new (0, $03191bfc90720c4f$export$cea12affaee22fe8)(54);
}
function $6fe96515315d55c4$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $6fe96515315d55c4$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $6fe96515315d55c4$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $6fe96515315d55c4$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $6fe96515315d55c4$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
var $6fe96515315d55c4$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives['connection']['key'], "(").concat($6fe96515315d55c4$var$stringify(filteredArgs_1), ")");
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = $6fe96515315d55c4$var$stringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($6fe96515315d55c4$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($6fe96515315d55c4$var$stringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $6fe96515315d55c4$var$stringify;
        $6fe96515315d55c4$var$stringify = s;
        return previous;
    }
});
var $6fe96515315d55c4$var$stringify = function defaultStringify(value) {
    return JSON.stringify(value, $6fe96515315d55c4$var$stringifyReplacer);
};
function $6fe96515315d55c4$var$stringifyReplacer(_key, value) {
    if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(value) && !Array.isArray(value)) value = Object.keys(value).sort().reduce(function(copy, key) {
        copy[key] = value[key];
        return copy;
    }, {});
    return value;
}
function $6fe96515315d55c4$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $6fe96515315d55c4$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $6fe96515315d55c4$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $6fe96515315d55c4$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    if (typeof result.__typename === 'string') return result.__typename;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($6fe96515315d55c4$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === '__typename') return result[$6fe96515315d55c4$export$7d1ad22471852218(selection)];
        } else {
            var typename = $6fe96515315d55c4$export$cf7bf7e4f289cc26(result, (0, $5e4d569a846b5f9e$export$f80bdb85f299186)(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === 'string') return typename;
        }
    }
}
function $6fe96515315d55c4$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $6fe96515315d55c4$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}


function $2424e121a4289e63$export$a7d0d8111d2386df(doc) {
    __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0, $03191bfc90720c4f$export$f5708dca728d7177)(doc && doc.kind === 'Document', 46);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw __DEV__ ? new (0, $03191bfc90720c4f$export$cea12affaee22fe8)("Schema type definitions not allowed in queries. Found: \"".concat(definition.kind, "\"")) : new (0, $03191bfc90720c4f$export$cea12affaee22fe8)(47);
        return definition;
    });
    __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(operations.length <= 1, "Ambiguous GraphQL document: contains ".concat(operations.length, " operations")) : (0, $03191bfc90720c4f$export$f5708dca728d7177)(operations.length <= 1, 48);
    return doc;
}
function $2424e121a4289e63$export$7a5b1fa979d2c158(doc) {
    $2424e121a4289e63$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $2424e121a4289e63$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $2424e121a4289e63$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $2424e121a4289e63$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $2424e121a4289e63$export$7a5b1fa979d2c158(doc);
    __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(queryDef && queryDef.operation === 'query', 'Must contain a query definition.') : (0, $03191bfc90720c4f$export$f5708dca728d7177)(queryDef && queryDef.operation === 'query', 49);
    return queryDef;
}
function $2424e121a4289e63$export$772111caef41b3f5(doc) {
    __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0, $03191bfc90720c4f$export$f5708dca728d7177)(doc.kind === 'Document', 50);
    __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(doc.definitions.length <= 1, 'Fragment must have exactly one definition.') : (0, $03191bfc90720c4f$export$f5708dca728d7177)(doc.definitions.length <= 1, 51);
    var fragmentDef = doc.definitions[0];
    __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.') : (0, $03191bfc90720c4f$export$f5708dca728d7177)(fragmentDef.kind === 'FragmentDefinition', 52);
    return fragmentDef;
}
function $2424e121a4289e63$export$f431198736b7f96d(queryDoc) {
    $2424e121a4289e63$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw __DEV__ ? new (0, $03191bfc90720c4f$export$cea12affaee22fe8)('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.') : new (0, $03191bfc90720c4f$export$cea12affaee22fe8)(53);
}
function $2424e121a4289e63$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $6fe96515315d55c4$export$a1dab82d368d6525)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}


function $782bb89084e3942d$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $2424e121a4289e63$export$41bca9dc6871dd4e)(transformedOperation.query) || undefined : '';
    return transformedOperation;
}


function $28ff5091c6ae6deb$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw __DEV__ ? new (0, $03191bfc90720c4f$export$cea12affaee22fe8)("illegal argument: ".concat(key)) : new (0, $03191bfc90720c4f$export$cea12affaee22fe8)(26);
    }
    return operation;
}


function $80285925cfe0f960$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $7401f4590b7a34ce$export$77cea355fa80b5f4).of();
}
function $80285925cfe0f960$var$toLink(handler) {
    return typeof handler === 'function' ? new $80285925cfe0f960$export$2fed3d61f740bc7f(handler) : handler;
}
function $80285925cfe0f960$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $80285925cfe0f960$var$LinkError = function(_super) {
    (0, $7455305bac30ddd9$export$a8ba968b8961cb8a)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
var $80285925cfe0f960$export$2fed3d61f740bc7f = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $7401f4590b7a34ce$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($80285925cfe0f960$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $80285925cfe0f960$var$toLink(left);
        var rightLink = $80285925cfe0f960$var$toLink(right || new ApolloLink($80285925cfe0f960$var$passthrough));
        if ($80285925cfe0f960$var$isTerminating(leftLink) && $80285925cfe0f960$var$isTerminating(rightLink)) return new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $7401f4590b7a34ce$export$77cea355fa80b5f4).of() : rightLink.request(operation) || (0, $7401f4590b7a34ce$export$77cea355fa80b5f4).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $7401f4590b7a34ce$export$77cea355fa80b5f4).of() : rightLink.request(operation, forward) || (0, $7401f4590b7a34ce$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $93c211dba1940fd8$export$f29bedd62f56fcb2)(operation.context, (0, $782bb89084e3942d$export$4f3f7df1b558c729)((0, $28ff5091c6ae6deb$export$a92a48117d546c9)(operation)))) || (0, $7401f4590b7a34ce$export$77cea355fa80b5f4).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $80285925cfe0f960$var$toLink(first);
        if ($80285925cfe0f960$var$isTerminating(firstLink)) {
            __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).warn(new $80285925cfe0f960$var$LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
            return firstLink;
        }
        var nextLink = $80285925cfe0f960$var$toLink(second);
        if ($80285925cfe0f960$var$isTerminating(nextLink)) return new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $7401f4590b7a34ce$export$77cea355fa80b5f4).of();
            }) || (0, $7401f4590b7a34ce$export$77cea355fa80b5f4).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $7401f4590b7a34ce$export$77cea355fa80b5f4).of();
            }) || (0, $7401f4590b7a34ce$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($80285925cfe0f960$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw __DEV__ ? new (0, $03191bfc90720c4f$export$cea12affaee22fe8)('request is not implemented') : new (0, $03191bfc90720c4f$export$cea12affaee22fe8)(21);
    };
    ApolloLink.prototype.onError = function(error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            return false;
        }
        throw error;
    };
    ApolloLink.prototype.setOnError = function(fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();


var $a1c093f3f4975a7d$export$51396ec711da548b = (0, $80285925cfe0f960$export$2fed3d61f740bc7f).execute;


var $a8d780b011b44c78$export$83d89fbfd8236492 = '3.7.1';










const $d071986d8a8d61be$export$a89c95c098ac2a58 = Object.freeze({});
function $d071986d8a8d61be$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $8c8cf88dd9d4f3e6$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $5050f41989ff6c78$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $d071986d8a8d61be$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $8c8cf88dd9d4f3e6$export$8ee0fc9ee280b4ee)(node) || (0, $d9bdcc7feb0c4bb8$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $9fb51304070b81b7$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $d071986d8a8d61be$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $8c8cf88dd9d4f3e6$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $d071986d8a8d61be$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $5050f41989ff6c78$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $d071986d8a8d61be$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $d071986d8a8d61be$export$a89c95c098ac2a58) skipping[i] = $d071986d8a8d61be$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $d071986d8a8d61be$export$a89c95c098ac2a58) skipping[i] = $d071986d8a8d61be$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $d071986d8a8d61be$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $d071986d8a8d61be$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $d071986d8a8d61be$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}





function $7ec532f319e0861b$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $7ec532f319e0861b$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables && variables[ifArgument.value.name.value];
            __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(evaledValue !== void 0, "Invalid variable referenced in @".concat(directive.name.value, " directive.")) : (0, $03191bfc90720c4f$export$f5708dca728d7177)(evaledValue !== void 0, 39);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $7ec532f319e0861b$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $d071986d8a8d61be$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $7ec532f319e0861b$export$528b5e7d8ba07fbf = function(names, root) {
    return $7ec532f319e0861b$export$2dafb573e282fe8d(names, root, false);
};
var $7ec532f319e0861b$export$ad1b63b26c1a9b76 = function(names, root) {
    return $7ec532f319e0861b$export$2dafb573e282fe8d(names, root, true);
};
function $7ec532f319e0861b$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $d071986d8a8d61be$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $d071986d8a8d61be$export$a89c95c098ac2a58;
        }
    });
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $7ec532f319e0861b$export$8d1e9e5bbfa5d09a(document) {
    return document && $7ec532f319e0861b$export$2dafb573e282fe8d([
        'client',
        'export'
    ], document, true);
}
function $7ec532f319e0861b$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $7ec532f319e0861b$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$7ec532f319e0861b$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @".concat(directiveName, " directive.")) : (0, $03191bfc90720c4f$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, 40);
        var ifArgument = directiveArguments[0];
        __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @".concat(directiveName, " directive.")) : (0, $03191bfc90720c4f$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === 'if', 41);
        var ifValue = ifArgument.value;
        __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), "Argument for the @".concat(directiveName, " directive must be a variable or a boolean value.")) : (0, $03191bfc90720c4f$export$f5708dca728d7177)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 42);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}



var $96c53074b6483eeb$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = __DEV__ ? new (0, $03191bfc90720c4f$export$cea12affaee22fe8)("Network request failed. ".concat(label, " is not serializable: ").concat(e.message)) : new (0, $03191bfc90720c4f$export$cea12affaee22fe8)(23);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};


var $eb4829d581536a6d$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};




function $6534dfc205cd8a10$export$18f63c735264ee11(value) {
    return !!value.body;
}
function $6534dfc205cd8a10$export$ac613ff475b69d05(value) {
    return !!value.getReader;
}
function $6534dfc205cd8a10$export$fe1556bffc7e68ee(value) {
    return !!((0, $b97fc55b2a1fddda$export$c34f882e9f1c1637) && value[Symbol.asyncIterator]);
}
function $6534dfc205cd8a10$export$70be23b513fb72ac(value) {
    return !!value.stream;
}
function $6534dfc205cd8a10$export$5bcd6e94ed871c88(value) {
    return !!value.arrayBuffer;
}
function $6534dfc205cd8a10$export$530196473208426f(value) {
    return !!value.pipe;
}


function $3596a2c217e32280$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}



function $321fe30ca522e962$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $b97fc55b2a1fddda$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}



function $e0c93ed63765db0a$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $b97fc55b2a1fddda$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}



function $05221a261a65fff2$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $b97fc55b2a1fddda$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


function $e0b6c1f0f1271b21$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ((0, $6534dfc205cd8a10$export$18f63c735264ee11)(response)) body = response.body;
    if ((0, $6534dfc205cd8a10$export$fe1556bffc7e68ee)(body)) return (0, $3596a2c217e32280$export$2e2bcd8739ae039)(body);
    if ((0, $6534dfc205cd8a10$export$ac613ff475b69d05)(body)) return (0, $05221a261a65fff2$export$2e2bcd8739ae039)(body.getReader());
    if ((0, $6534dfc205cd8a10$export$70be23b513fb72ac)(body)) return (0, $05221a261a65fff2$export$2e2bcd8739ae039)(body.stream().getReader());
    if ((0, $6534dfc205cd8a10$export$5bcd6e94ed871c88)(body)) return (0, $e0c93ed63765db0a$export$2e2bcd8739ae039)(body.arrayBuffer());
    if ((0, $6534dfc205cd8a10$export$530196473208426f)(body)) return (0, $321fe30ca522e962$export$2e2bcd8739ae039)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}


var $581af40d617c605f$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};


var $e8f2b937a467fbb8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e8f2b937a467fbb8$export$ccb60864026baf09(response, observer) {
    var _a, _b, _c;
    return (0, $7455305bac30ddd9$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _d, value, done, chunk, bi, message, i, headers, contentType_1, body, result;
        var _e;
        return (0, $7455305bac30ddd9$export$67ebef60e6f28a6)(this, function(_f) {
            switch(_f.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('content-type');
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $e0b6c1f0f1271b21$export$7e4ac9ed9577f145)(response);
                    running = true;
                    _f.label = 1;
                case 1:
                    if (!running) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        iterator.next()
                    ];
                case 2:
                    _d = _f.sent(), value = _d.value, done = _d.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary);
                    while(bi > -1){
                        message = void 0;
                        _e = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _e[0], buffer = _e[1];
                        if (message.trim()) {
                            i = message.indexOf("\r\n\r\n");
                            headers = $e8f2b937a467fbb8$export$eea2c1c5e1a37e50(message.slice(0, i));
                            contentType_1 = headers["content-type"];
                            if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                            body = message.slice(i);
                            try {
                                result = $e8f2b937a467fbb8$export$759bcb35b0d1bf81(response, body.replace("\r\n", ""));
                                if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result) (_b = observer.next) === null || _b === void 0 || _b.call(observer, result);
                            } catch (err) {
                                $e8f2b937a467fbb8$export$d3da1ecaf1206c58(err, observer);
                            }
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3,
                        1
                    ];
                case 3:
                    (_c = observer.complete) === null || _c === void 0 || _c.call(observer);
                    return [
                        2
                    ];
            }
        });
    });
}
function $e8f2b937a467fbb8$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $e8f2b937a467fbb8$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $581af40d617c605f$export$c33ef9219f27efd7)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $e8f2b937a467fbb8$export$d3da1ecaf1206c58(err, observer) {
    var _a, _b;
    if (err.name === "AbortError") return;
    if (err.result && err.result.errors && err.result.data) (_a = observer.next) === null || _a === void 0 || _a.call(observer, err.result);
    (_b = observer.error) === null || _b === void 0 || _b.call(observer, err);
}
function $e8f2b937a467fbb8$export$239a7c04069f210b(response, operation, observer) {
    $e8f2b937a467fbb8$export$d4051215bea0639f(operation)(response).then(function(result) {
        var _a, _b;
        (_a = observer.next) === null || _a === void 0 || _a.call(observer, result);
        (_b = observer.complete) === null || _b === void 0 || _b.call(observer);
    }).catch(function(err) {
        return $e8f2b937a467fbb8$export$d3da1ecaf1206c58(err, observer);
    });
}
function $e8f2b937a467fbb8$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $e8f2b937a467fbb8$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (response.status >= 300) (0, $581af40d617c605f$export$c33ef9219f27efd7)(response, result, "Response not successful: Received status code ".concat(response.status));
            if (!Array.isArray(result) && !$e8f2b937a467fbb8$var$hasOwnProperty.call(result, "data") && !$e8f2b937a467fbb8$var$hasOwnProperty.call(result, "errors")) (0, $581af40d617c605f$export$c33ef9219f27efd7)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}



var $3a080b165738c652$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') throw __DEV__ ? new (0, $03191bfc90720c4f$export$cea12affaee22fe8)("\n\"fetch\" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:\n\nimport fetch from 'cross-fetch';\nimport { ApolloClient, HttpLink } from '@apollo/client';\nconst client = new ApolloClient({\n  link: new HttpLink({ uri: '/graphql', fetch })\n});\n    ") : new (0, $03191bfc90720c4f$export$cea12affaee22fe8)(22);
};




/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $94213ef19dcadd26$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($94213ef19dcadd26$var$escapedRegExp, $94213ef19dcadd26$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $94213ef19dcadd26$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $94213ef19dcadd26$var$escapedReplacer(str) {
    return $94213ef19dcadd26$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $94213ef19dcadd26$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];



function $94dc95d460afe35c$export$c2d084dc44961371(ast) {
    return (0, $d071986d8a8d61be$export$bf638b60ea8b89b7)(ast, $94dc95d460afe35c$var$printDocASTReducer);
}
const $94dc95d460afe35c$var$MAX_LINE_LENGTH = 80;
const $94dc95d460afe35c$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$94dc95d460afe35c$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $94dc95d460afe35c$var$wrap('(', $94dc95d460afe35c$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $94dc95d460afe35c$var$join([
                node.operation,
                $94dc95d460afe35c$var$join([
                    node.name,
                    varDefs
                ]),
                $94dc95d460afe35c$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ': ' + type + $94dc95d460afe35c$var$wrap(' = ', defaultValue) + $94dc95d460afe35c$var$wrap(' ', $94dc95d460afe35c$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$94dc95d460afe35c$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $94dc95d460afe35c$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $94dc95d460afe35c$var$wrap('(', $94dc95d460afe35c$var$join(args, ', '), ')');
            if (argsLine.length > $94dc95d460afe35c$var$MAX_LINE_LENGTH) argsLine = prefix + $94dc95d460afe35c$var$wrap('(\n', $94dc95d460afe35c$var$indent($94dc95d460afe35c$var$join(args, '\n')), '\n)');
            return $94dc95d460afe35c$var$join([
                argsLine,
                $94dc95d460afe35c$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $94dc95d460afe35c$var$wrap(' ', $94dc95d460afe35c$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$94dc95d460afe35c$var$join([
                '...',
                $94dc95d460afe35c$var$wrap('on ', typeCondition),
                $94dc95d460afe35c$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$94dc95d460afe35c$var$wrap('(', $94dc95d460afe35c$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$94dc95d460afe35c$var$wrap('', $94dc95d460afe35c$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $9035e60eb7281107$export$adb6ca997eeb1f45)(value) : (0, $94213ef19dcadd26$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $94dc95d460afe35c$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $94dc95d460afe35c$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $94dc95d460afe35c$var$wrap('(', $94dc95d460afe35c$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$94dc95d460afe35c$var$wrap('', description, '\n') + $94dc95d460afe35c$var$join([
                'schema',
                $94dc95d460afe35c$var$join(directives, ' '),
                $94dc95d460afe35c$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$94dc95d460afe35c$var$wrap('', description, '\n') + $94dc95d460afe35c$var$join([
                'scalar',
                name,
                $94dc95d460afe35c$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$94dc95d460afe35c$var$wrap('', description, '\n') + $94dc95d460afe35c$var$join([
                'type',
                name,
                $94dc95d460afe35c$var$wrap('implements ', $94dc95d460afe35c$var$join(interfaces, ' & ')),
                $94dc95d460afe35c$var$join(directives, ' '),
                $94dc95d460afe35c$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$94dc95d460afe35c$var$wrap('', description, '\n') + name + ($94dc95d460afe35c$var$hasMultilineItems(args) ? $94dc95d460afe35c$var$wrap('(\n', $94dc95d460afe35c$var$indent($94dc95d460afe35c$var$join(args, '\n')), '\n)') : $94dc95d460afe35c$var$wrap('(', $94dc95d460afe35c$var$join(args, ', '), ')')) + ': ' + type + $94dc95d460afe35c$var$wrap(' ', $94dc95d460afe35c$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$94dc95d460afe35c$var$wrap('', description, '\n') + $94dc95d460afe35c$var$join([
                name + ': ' + type,
                $94dc95d460afe35c$var$wrap('= ', defaultValue),
                $94dc95d460afe35c$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$94dc95d460afe35c$var$wrap('', description, '\n') + $94dc95d460afe35c$var$join([
                'interface',
                name,
                $94dc95d460afe35c$var$wrap('implements ', $94dc95d460afe35c$var$join(interfaces, ' & ')),
                $94dc95d460afe35c$var$join(directives, ' '),
                $94dc95d460afe35c$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$94dc95d460afe35c$var$wrap('', description, '\n') + $94dc95d460afe35c$var$join([
                'union',
                name,
                $94dc95d460afe35c$var$join(directives, ' '),
                $94dc95d460afe35c$var$wrap('= ', $94dc95d460afe35c$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$94dc95d460afe35c$var$wrap('', description, '\n') + $94dc95d460afe35c$var$join([
                'enum',
                name,
                $94dc95d460afe35c$var$join(directives, ' '),
                $94dc95d460afe35c$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$94dc95d460afe35c$var$wrap('', description, '\n') + $94dc95d460afe35c$var$join([
                name,
                $94dc95d460afe35c$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$94dc95d460afe35c$var$wrap('', description, '\n') + $94dc95d460afe35c$var$join([
                'input',
                name,
                $94dc95d460afe35c$var$join(directives, ' '),
                $94dc95d460afe35c$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$94dc95d460afe35c$var$wrap('', description, '\n') + 'directive @' + name + ($94dc95d460afe35c$var$hasMultilineItems(args) ? $94dc95d460afe35c$var$wrap('(\n', $94dc95d460afe35c$var$indent($94dc95d460afe35c$var$join(args, '\n')), '\n)') : $94dc95d460afe35c$var$wrap('(', $94dc95d460afe35c$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $94dc95d460afe35c$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$94dc95d460afe35c$var$join([
                'extend schema',
                $94dc95d460afe35c$var$join(directives, ' '),
                $94dc95d460afe35c$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$94dc95d460afe35c$var$join([
                'extend scalar',
                name,
                $94dc95d460afe35c$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$94dc95d460afe35c$var$join([
                'extend type',
                name,
                $94dc95d460afe35c$var$wrap('implements ', $94dc95d460afe35c$var$join(interfaces, ' & ')),
                $94dc95d460afe35c$var$join(directives, ' '),
                $94dc95d460afe35c$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$94dc95d460afe35c$var$join([
                'extend interface',
                name,
                $94dc95d460afe35c$var$wrap('implements ', $94dc95d460afe35c$var$join(interfaces, ' & ')),
                $94dc95d460afe35c$var$join(directives, ' '),
                $94dc95d460afe35c$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$94dc95d460afe35c$var$join([
                'extend union',
                name,
                $94dc95d460afe35c$var$join(directives, ' '),
                $94dc95d460afe35c$var$wrap('= ', $94dc95d460afe35c$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$94dc95d460afe35c$var$join([
                'extend enum',
                name,
                $94dc95d460afe35c$var$join(directives, ' '),
                $94dc95d460afe35c$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$94dc95d460afe35c$var$join([
                'extend input',
                name,
                $94dc95d460afe35c$var$join(directives, ' '),
                $94dc95d460afe35c$var$block(fields)
            ], ' ')
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $94dc95d460afe35c$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $94dc95d460afe35c$var$block(array) {
    return $94dc95d460afe35c$var$wrap('{\n', $94dc95d460afe35c$var$indent($94dc95d460afe35c$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $94dc95d460afe35c$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $94dc95d460afe35c$var$indent(str) {
    return $94dc95d460afe35c$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $94dc95d460afe35c$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}


var $4c20345c72384df1$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $4c20345c72384df1$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $4c20345c72384df1$var$defaultOptions = {
    method: 'POST'
};
var $4c20345c72384df1$export$dd86f00dc866e75d = {
    http: $4c20345c72384df1$var$defaultHttpOptions,
    headers: $4c20345c72384df1$var$defaultHeaders,
    options: $4c20345c72384df1$var$defaultOptions
};
var $4c20345c72384df1$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $4c20345c72384df1$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $4c20345c72384df1$export$12d90ccf75844275.apply(void 0, (0, $7455305bac30ddd9$export$1216008129fb82ed)([
        operation,
        $4c20345c72384df1$export$e88934976ca4fd65
    ], configs, false));
}
function $4c20345c72384df1$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), config.options), {
            headers: (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, http), config.http);
    });
    options.headers = $4c20345c72384df1$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = printer(query, (0, $94dc95d460afe35c$export$c2d084dc44961371));
    return {
        options: options,
        body: body
    };
}
function $4c20345c72384df1$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}


var $a82af8acc73eb867$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};



function $fe2a21e63705b544$export$fb82bb094b6f76b5(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $96c53074b6483eeb$export$5f8e80ac52052e28)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $96c53074b6483eeb$export$5f8e80ac52052e28)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}



function $92363ecf8a5e8796$export$4fd972edbe7450d3(errorValue) {
    return new (0, $7401f4590b7a34ce$export$77cea355fa80b5f4)(function(observer) {
        observer.error(errorValue);
    });
}


var $b2a84aefebda3329$var$backupFetch = (0, $b39dc9e14d9f1bb4$export$f8b8b9ce72e9ccbf)(function() {
    return fetch;
});
var $b2a84aefebda3329$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $4c20345c72384df1$export$e88934976ca4fd65) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $7455305bac30ddd9$export$3c9a16f847548506)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (__DEV__) (0, $3a080b165738c652$export$8423f0cd3773115e)(preferredFetch || $b2a84aefebda3329$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $80285925cfe0f960$export$2fed3d61f740bc7f)(function(operation) {
        var chosenURI = (0, $eb4829d581536a6d$export$63ccc2571850f81a)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $4c20345c72384df1$export$12d90ccf75844275)(operation, print, (0, $4c20345c72384df1$export$dd86f00dc866e75d), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) {
            var unusedNames_1 = new Set(Object.keys(body.variables));
            (0, $d071986d8a8d61be$export$bf638b60ea8b89b7)(operation.query, {
                Variable: function(node, _key, parent) {
                    if (parent && parent.kind !== 'VariableDefinition') unusedNames_1.delete(node.name.value);
                }
            });
            if (unusedNames_1.size) {
                body.variables = (0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, body.variables);
                unusedNames_1.forEach(function(name) {
                    delete body.variables[name];
                });
            }
        }
        var controller;
        if (!options.signal) {
            var _c = (0, $a82af8acc73eb867$export$f5853cd1fc39aea6)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if ((0, $7ec532f319e0861b$export$2dafb573e282fe8d)([
            'defer'
        ], operation.query)) options.headers.accept = "multipart/mixed; deferSpec=20220824, application/json";
        if (options.method === 'GET') {
            var _d = (0, $fe2a21e63705b544$export$fb82bb094b6f76b5)(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $92363ecf8a5e8796$export$4fd972edbe7450d3)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $96c53074b6483eeb$export$5f8e80ac52052e28)(body, 'Payload');
        } catch (parseError) {
            return (0, $92363ecf8a5e8796$export$4fd972edbe7450d3)(parseError);
        }
        return new (0, $7401f4590b7a34ce$export$77cea355fa80b5f4)(function(observer) {
            var currentFetch = preferredFetch || (0, $b39dc9e14d9f1bb4$export$f8b8b9ce72e9ccbf)(function() {
                return fetch;
            }) || $b2a84aefebda3329$var$backupFetch;
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('content-type');
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $e8f2b937a467fbb8$export$ccb60864026baf09)(response, observer);
                else return (0, $e8f2b937a467fbb8$export$239a7c04069f210b)(response, operation, observer);
            }).catch(function(err) {
                return (0, $e8f2b937a467fbb8$export$d3da1ecaf1206c58)(err, observer);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};


var $afdafcce1fdcac38$export$f4bbf1aec241cc1 = function(_super) {
    (0, $7455305bac30ddd9$export$a8ba968b8961cb8a)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $b2a84aefebda3329$export$95180a16573d6675)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $80285925cfe0f960$export$2fed3d61f740bc7f));






function $9de5d00cf0289adf$export$879767c5cdf33cb3(value) {
    return !!value.incremental;
}




// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var $a8424dc7ce80e30f$var$defaultMakeData = function() {
    return Object.create(null);
};
// Useful for processing arguments objects as well as arrays.
var $a8424dc7ce80e30f$var$_a = Array.prototype, $a8424dc7ce80e30f$var$forEach = $a8424dc7ce80e30f$var$_a.forEach, $a8424dc7ce80e30f$var$slice = $a8424dc7ce80e30f$var$_a.slice;
var $a8424dc7ce80e30f$export$73571c50d0f2507e = /** @class */ function() {
    function Trie(weakness, makeData) {
        if (weakness === void 0) weakness = true;
        if (makeData === void 0) makeData = $a8424dc7ce80e30f$var$defaultMakeData;
        this.weakness = weakness;
        this.makeData = makeData;
    }
    Trie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    Trie.prototype.lookupArray = function(array) {
        var node = this;
        $a8424dc7ce80e30f$var$forEach.call(array, function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = this.makeData($a8424dc7ce80e30f$var$slice.call(array)));
    };
    Trie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $a8424dc7ce80e30f$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    };
    return Trie;
}();
function $a8424dc7ce80e30f$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}





var $104323fd517dfc25$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $104323fd517dfc25$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $104323fd517dfc25$export$160070228be94b08(sources);
}
function $104323fd517dfc25$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $104323fd517dfc25$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $104323fd517dfc25$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $104323fd517dfc25$export$509e11c221f576c0 = function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $104323fd517dfc25$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $604f10e48f8d6e7b$export$417207af72fad9c9);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(source) && (0, $604f10e48f8d6e7b$export$417207af72fad9c9)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($104323fd517dfc25$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $7455305bac30ddd9$export$1216008129fb82ed)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $7455305bac30ddd9$export$18ce0697a983be9b)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();


var $7cf1a004cfc57df5$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $7cf1a004cfc57df5$export$b931b78cbb3caf86(value) {
    return value === null || value === void 0;
}
var $7cf1a004cfc57df5$export$43bee75e5e14138e = Array.isArray;
function $7cf1a004cfc57df5$export$bd03c5a9c99d6bce(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !$7cf1a004cfc57df5$export$b931b78cbb3caf86(id) ? {
            id: id
        } : !$7cf1a004cfc57df5$export$b931b78cbb3caf86(_id) ? {
            _id: _id
        } : void 0;
        if ($7cf1a004cfc57df5$export$b931b78cbb3caf86(id) && !$7cf1a004cfc57df5$export$b931b78cbb3caf86(_id)) id = _id;
        if (!$7cf1a004cfc57df5$export$b931b78cbb3caf86(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var $7cf1a004cfc57df5$var$defaultConfig = {
    dataIdFromObject: $7cf1a004cfc57df5$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    canonizeResults: false
};
function $7cf1a004cfc57df5$export$fa542f9ee3f7f4e2(config) {
    return (0, $20c8e93b6072aee9$export$8e16b83750b44988)($7cf1a004cfc57df5$var$defaultConfig, config);
}
function $7cf1a004cfc57df5$export$3ac2a95fbd99c479(config) {
    var value = config.canonizeResults;
    return value === void 0 ? $7cf1a004cfc57df5$var$defaultConfig.canonizeResults : value;
}
function $7cf1a004cfc57df5$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $6fe96515315d55c4$export$fa99cac1c0883c47)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $7cf1a004cfc57df5$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $7cf1a004cfc57df5$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($7cf1a004cfc57df5$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $7cf1a004cfc57df5$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(result)) return $7cf1a004cfc57df5$export$43bee75e5e14138e(result) ? result.every(function(item) {
        return $7cf1a004cfc57df5$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $6fe96515315d55c4$export$fb56ad75dd311c12)(field) && (0, $7ec532f319e0861b$export$3dc388a5f013b4a5)(field, variables)) {
            var key = (0, $6fe96515315d55c4$export$7d1ad22471852218)(field);
            return $7cf1a004cfc57df5$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $7cf1a004cfc57df5$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        return true;
    });
    return false;
}
function $7cf1a004cfc57df5$export$4f39afca21bd938e(value) {
    return (0, $604f10e48f8d6e7b$export$417207af72fad9c9)(value) && !(0, $6fe96515315d55c4$export$fa99cac1c0883c47)(value) && !$7cf1a004cfc57df5$export$43bee75e5e14138e(value);
}
function $7cf1a004cfc57df5$export$b874a818f7a2fa6d() {
    return new (0, $104323fd517dfc25$export$509e11c221f576c0);
}
function $7cf1a004cfc57df5$export$3a33c00f0ae4a480(document, fragments) {
    var fragmentMap = (0, $5e4d569a846b5f9e$export$193789b4c8246dd4)((0, $2424e121a4289e63$export$5320a7ba9466a3df)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}


function $38af0b4df3538bbb$var$shallowCopy(value) {
    if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(value)) return (0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(value) ? value.slice(0) : (0, $7455305bac30ddd9$export$18ce0697a983be9b)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
var $38af0b4df3538bbb$export$c2e7fdd82233f4a4 = function() {
    function ObjectCanon() {
        this.known = new ((0, $b97fc55b2a1fddda$export$7293b8a0b474028d) ? WeakSet : Set)();
        this.pool = new (0, $a8424dc7ce80e30f$export$73571c50d0f2507e)((0, $b97fc55b2a1fddda$export$772fbc04a0ad4ce9));
        this.passes = new WeakMap();
        this.keysByJSON = new Map();
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, $604f10e48f8d6e7b$export$417207af72fad9c9)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(value)) {
            var copy = $38af0b4df3538bbb$var$shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        if (__DEV__) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        if (__DEV__) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();
var $38af0b4df3538bbb$export$88a0ad9b6f961b51 = Object.assign(function(value) {
    if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(value)) {
        if ($38af0b4df3538bbb$var$stringifyCanon === void 0) $38af0b4df3538bbb$var$resetCanonicalStringify();
        var canonical = $38af0b4df3538bbb$var$stringifyCanon.admit(value);
        var json = $38af0b4df3538bbb$var$stringifyCache.get(canonical);
        if (json === void 0) $38af0b4df3538bbb$var$stringifyCache.set(canonical, json = JSON.stringify(canonical));
        return json;
    }
    return JSON.stringify(value);
}, {
    reset: $38af0b4df3538bbb$var$resetCanonicalStringify
});
var $38af0b4df3538bbb$var$stringifyCanon;
var $38af0b4df3538bbb$var$stringifyCache;
function $38af0b4df3538bbb$var$resetCanonicalStringify() {
    $38af0b4df3538bbb$var$stringifyCanon = new $38af0b4df3538bbb$export$c2e7fdd82233f4a4;
    $38af0b4df3538bbb$var$stringifyCache = new ((0, $b97fc55b2a1fddda$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
}



function $5d1d4b46ff09d192$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, $7401f4590b7a34ce$export$77cea355fa80b5f4)(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeCallbackCount = 0;
        var completed = false;
        var promiseQueue = {
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, delegate) {
            if (examiner) return function(arg) {
                ++activeCallbackCount;
                var both = function() {
                    return examiner(arg);
                };
                promiseQueue = promiseQueue.then(both, both).then(function(result) {
                    --activeCallbackCount;
                    next && next.call(observer, result);
                    if (completed) handler.complete();
                }, function(error) {
                    --activeCallbackCount;
                    throw error;
                }).catch(function(caught) {
                    error && error.call(observer, caught);
                });
            };
            else return function(arg) {
                return delegate && delegate.call(observer, arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, next),
            error: makeCallback(catchFn, error),
            complete: function() {
                completed = true;
                if (!activeCallbackCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}

var $aa264210ed31b6df$var$toString = Object.prototype.toString;
function $aa264210ed31b6df$export$629a2bd3f5a49ecc(value) {
    return $aa264210ed31b6df$var$cloneDeepHelper(value);
}
function $aa264210ed31b6df$var$cloneDeepHelper(val, seen) {
    switch($aa264210ed31b6df$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map;
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $aa264210ed31b6df$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map;
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $aa264210ed31b6df$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}



function $c10b68054a477c15$export$9f6c99ae166dbeca(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}




function $43a1c61714a473d7$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, {
            value: (0, $7401f4590b7a34ce$export$77cea355fa80b5f4)
        });
    }
    if ((0, $b97fc55b2a1fddda$export$23ba675b4b838b92) && Symbol.species) set(Symbol.species);
    set("@@species");
    return subclass;
}


function $ea4a70d73b084114$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
var $ea4a70d73b084114$export$ae0cf2ec7a6fa78e = function(_super) {
    (0, $7455305bac30ddd9$export$a8ba968b8961cb8a)(Concast, _super);
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, $c10b68054a477c15$export$9f6c99ae166dbeca)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, $c10b68054a477c15$export$9f6c99ae166dbeca)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var sub = _this.sub;
                if (sub !== null) {
                    var value = _this.sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        (0, $c10b68054a477c15$export$9f6c99ae166dbeca)(_this.observers, "complete");
                    } else if ($ea4a70d73b084114$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    });
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        _this.promise.catch(function(_) {});
        if (typeof sources === "function") sources = [
            new (0, $7401f4590b7a34ce$export$77cea355fa80b5f4)(sources)
        ];
        if ($ea4a70d73b084114$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        this.sources = Array.from(sources);
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            this.nextResultListeners = new Set;
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, $7401f4590b7a34ce$export$77cea355fa80b5f4));
(0, $43a1c61714a473d7$export$33c8bd820eece9b2)($ea4a70d73b084114$export$ae0cf2ec7a6fa78e);

function $0d8d884137f1bba5$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length > 0 || false;
}

function $d974c0bd81b7c069$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}

var $fab8b8d7adece54d$var$prefixCounts = new Map();
function $fab8b8d7adece54d$export$d0c8ec0fe1b18b70(prefix) {
    var count = $fab8b8d7adece54d$var$prefixCounts.get(prefix) || 1;
    $fab8b8d7adece54d$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}





function $e24ea883f87bce19$export$21c5d5745f10f2e(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}




var $695d33c6ff5cdb34$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $695d33c6ff5cdb34$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $695d33c6ff5cdb34$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $695d33c6ff5cdb34$var$nullIfDocIsEmpty(doc) {
    return $695d33c6ff5cdb34$var$isEmpty((0, $2424e121a4289e63$export$7a5b1fa979d2c158)(doc) || (0, $2424e121a4289e63$export$772111caef41b3f5)(doc), (0, $5e4d569a846b5f9e$export$193789b4c8246dd4)((0, $2424e121a4289e63$export$5320a7ba9466a3df)(doc))) ? null : doc;
}
function $695d33c6ff5cdb34$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $695d33c6ff5cdb34$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $695d33c6ff5cdb34$var$nullIfDocIsEmpty((0, $d071986d8a8d61be$export$bf638b60ea8b89b7)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($695d33c6ff5cdb34$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $695d33c6ff5cdb34$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($695d33c6ff5cdb34$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && (0, $e24ea883f87bce19$export$21c5d5745f10f2e)(variablesToRemove, function(v) {
        return !!v.name && !variablesInUse[v.name];
    }).length) modifiedDoc = $695d33c6ff5cdb34$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && (0, $e24ea883f87bce19$export$21c5d5745f10f2e)(fragmentSpreadsToRemove, function(fs) {
        return !!fs.name && !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $695d33c6ff5cdb34$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
var $695d33c6ff5cdb34$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $d071986d8a8d61be$export$bf638b60ea8b89b7)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return (0, $6fe96515315d55c4$export$fb56ad75dd311c12)(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ((0, $6fe96515315d55c4$export$fb56ad75dd311c12)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, node), {
                    selections: (0, $7455305bac30ddd9$export$1216008129fb82ed)((0, $7455305bac30ddd9$export$1216008129fb82ed)([], selections, true), [
                        $695d33c6ff5cdb34$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $695d33c6ff5cdb34$var$TYPENAME_FIELD;
    }
});
var $695d33c6ff5cdb34$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === 'key';
            })) __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).warn("Removing an @connection directive even though it does not have a key. You may want to use the key parameter to specify a store key.");
        }
        return willRemove;
    }
};
function $695d33c6ff5cdb34$export$74985f3324559867(doc) {
    return $695d33c6ff5cdb34$export$e5ae0530da5fe96c([
        $695d33c6ff5cdb34$var$connectionRemoveConfig
    ], (0, $2424e121a4289e63$export$a7d0d8111d2386df)(doc));
}
function $695d33c6ff5cdb34$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $695d33c6ff5cdb34$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $695d33c6ff5cdb34$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $6fe96515315d55c4$export$fb56ad75dd311c12)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($695d33c6ff5cdb34$var$getDirectiveMatcher(directives)) || nestedCheck && $695d33c6ff5cdb34$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $695d33c6ff5cdb34$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $695d33c6ff5cdb34$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $695d33c6ff5cdb34$var$getArgumentMatcher(config);
    return $695d33c6ff5cdb34$var$nullIfDocIsEmpty((0, $d071986d8a8d61be$export$bf638b60ea8b89b7)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, node), {
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $695d33c6ff5cdb34$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $695d33c6ff5cdb34$var$nullIfDocIsEmpty((0, $d071986d8a8d61be$export$bf638b60ea8b89b7)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $695d33c6ff5cdb34$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (((0, $6fe96515315d55c4$export$fb56ad75dd311c12)(selection) || (0, $6fe96515315d55c4$export$22a1cdafaf27bcff)(selection)) && selection.selectionSet) $695d33c6ff5cdb34$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $695d33c6ff5cdb34$export$57c368c23873f32b(document) {
    var definition = (0, $2424e121a4289e63$export$f431198736b7f96d)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $d071986d8a8d61be$export$bf638b60ea8b89b7)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $695d33c6ff5cdb34$export$8eae69e876ee321e(document) {
    (0, $2424e121a4289e63$export$a7d0d8111d2386df)(document);
    var modifiedDoc = $695d33c6ff5cdb34$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $d071986d8a8d61be$export$bf638b60ea8b89b7)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return (0, $6fe96515315d55c4$export$fb56ad75dd311c12)(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}





function $94d00a3b1a6b6d00$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $94d00a3b1a6b6d00$var$generateErrorMessage = function(err) {
    var message = '';
    if ((0, $d974c0bd81b7c069$export$d307f5934e447d0e)(err.graphQLErrors) || (0, $d974c0bd81b7c069$export$d307f5934e447d0e)(err.clientErrors)) {
        var errors = (err.graphQLErrors || []).concat(err.clientErrors || []);
        errors.forEach(function(error) {
            var errorMessage = error ? error.message : 'Error message not found.';
            message += "".concat(errorMessage, "\n");
        });
    }
    if (err.networkError) message += "".concat(err.networkError.message, "\n");
    message = message.replace(/\n$/, '');
    return message;
};
var $94d00a3b1a6b6d00$export$26a337512320b8c6 = function(_super) {
    (0, $7455305bac30ddd9$export$a8ba968b8961cb8a)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $94d00a3b1a6b6d00$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);





var $d8e6204d6ef04bee$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($d8e6204d6ef04bee$export$bd096ddbd246c79c || ($d8e6204d6ef04bee$export$bd096ddbd246c79c = {}));
function $d8e6204d6ef04bee$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}



var $b303337872d7f597$var$assign = Object.assign, $b303337872d7f597$var$hasOwnProperty = Object.hasOwnProperty;
var $b303337872d7f597$export$6c1b56eac59c9584 = function(_super) {
    (0, $7455305bac30ddd9$export$a8ba968b8961cb8a)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function(observer) {
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $b303337872d7f597$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(last.result);
            if (first) _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, _f = options.initialFetchPolicy, initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
            initialFetchPolicy: initialFetchPolicy,
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, $2424e121a4289e63$export$7a5b1fa979d2c158)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        get: function() {
            return this.queryManager.transform(this.options.query).document;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).ready;
        var result = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, lastResult), {
            loading: (0, $d8e6204d6ef04bee$export$37509604341a3464)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (fetchPolicy === 'network-only' || fetchPolicy === 'no-cache' || fetchPolicy === 'standby' || this.queryManager.transform(this.options.query).hasForcedResolvers) ;
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, $9675d5b886252616$export$2e2bcd8739ae039)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                delete result.partial;
                if (diff.complete && result.networkStatus === (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).loading && (fetchPolicy === 'cache-first' || fetchPolicy === 'cache-only')) {
                    result.networkStatus = (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            if (__DEV__ && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) $b303337872d7f597$export$b7e1973aacac3ae7(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        return !this.last || !(0, $9675d5b886252616$export$2e2bcd8739ae039)(this.last.result, newResult) || variables && !(0, $9675d5b886252616$export$2e2bcd8739ae039)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, $9675d5b886252616$export$2e2bcd8739ae039)(last.variables, this.variables))) return last[key];
    };
    ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            pollInterval: 0
        };
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-and-network') reobserveOptions.fetchPolicy = fetchPolicy;
        else if (fetchPolicy === 'no-cache') reobserveOptions.fetchPolicy = 'no-cache';
        else reobserveOptions.fetchPolicy = 'network-only';
        if (__DEV__ && variables && $b303337872d7f597$var$hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, $2424e121a4289e63$export$d96b2213c1b9d3a9)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).warn("Called refetch(".concat(JSON.stringify(variables), ") for query ").concat(((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || JSON.stringify(queryDef), ", which does not declare a $variables variable.\nDid you mean to call refetch(variables) instead of refetch({ variables })?"));
        }
        if (variables && !(0, $9675d5b886252616$export$2e2bcd8739ae039)(this.options.variables, variables)) reobserveOptions.variables = this.options.variables = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, this.options), {
            query: this.query
        }), fetchMoreOptions), {
            variables: (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: "no-cache"
        });
        var qid = this.queryManager.generateQueryId();
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    updatedQuerySet.add(watch.query);
                }
            });
            return fetchMoreResult;
        }).finally(function() {
            if (!updatedQuerySet.has(_this.query)) $b303337872d7f597$export$419171d60552792a(_this);
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).error('Unhandled GraphQL subscription error', err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.setVariables = function(variables) {
        if ((0, $9675d5b886252616$export$2e2bcd8739ae039)(this.variables, variables)) return this.observers.size ? this.result() : Promise.resolve();
        this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).setVariables);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus) {
        this.queryManager.setObservableQuery(this);
        return this.queryManager.fetchQueryObservable(this.queryId, options, newNetworkStatus);
    };
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(pollInterval, 'Attempted to start a polling query without a polling interval.') : (0, $03191bfc90720c4f$export$f5708dca728d7177)(pollInterval, 12);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            if (_this.pollingInfo) {
                if (!(0, $d8e6204d6ef04bee$export$37509604341a3464)(_this.queryInfo.networkStatus)) _this.reobserve({
                    fetchPolicy: _this.options.initialFetchPolicy === 'no-cache' ? 'no-cache' : 'network-only'
                }, (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        if (variables === void 0) variables = this.variables;
        this.last = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, this.last), {
            result: this.queryManager.assumeImmutableResults ? newResult : (0, $aa264210ed31b6df$export$629a2bd3f5a49ecc)(newResult),
            variables: variables
        });
        if (!(0, $d974c0bd81b7c069$export$d307f5934e447d0e)(newResult.errors)) delete this.last.error;
        return this.last;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = newNetworkStatus === (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).refetch || newNetworkStatus === (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).fetchMore || newNetworkStatus === (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).poll;
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, $20c8e93b6072aee9$export$8e16b83750b44988)(this.options, newOptions || {});
        var options = useDisposableConcast ? mergedOptions : $b303337872d7f597$var$assign(this.options, mergedOptions);
        if (!useDisposableConcast) {
            this.updatePolling();
            if (newOptions && newOptions.variables && !(0, $9675d5b886252616$export$2e2bcd8739ae039)(newOptions.variables, oldVariables) && options.fetchPolicy !== "standby" && options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).setVariables;
            }
        }
        var variables = options.variables && (0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options.variables);
        var concast = this.fetch(options, newNetworkStatus);
        var observer = {
            next: function(result) {
                _this.reportResult(result, variables);
            },
            error: function(error) {
                _this.reportError(error, variables);
            }
        };
        if (!useDisposableConcast) {
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast.promise;
    };
    ObservableQuery.prototype.observe = function() {
        this.reportResult(this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var lastError = this.getLastError();
        if (lastError || this.isDifferentFromLastResult(result, variables)) {
            if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
            (0, $c10b68054a477c15$export$9f6c99ae166dbeca)(this.observers, 'next', result);
        }
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        var errorResult = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, this.getLastResult()), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, $c10b68054a477c15$export$9f6c99ae166dbeca)(this.observers, 'error', this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    return ObservableQuery;
}((0, $7401f4590b7a34ce$export$77cea355fa80b5f4));
(0, $43a1c61714a473d7$export$33c8bd820eece9b2)($b303337872d7f597$export$6c1b56eac59c9584);
function $b303337872d7f597$export$419171d60552792a(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return obsQuery.reobserve({
        fetchPolicy: "cache-first",
        nextFetchPolicy: function() {
            this.nextFetchPolicy = nextFetchPolicy;
            if (typeof nextFetchPolicy === "function") return nextFetchPolicy.apply(this, arguments);
            return fetchPolicy;
        }
    });
    return obsQuery.reobserve();
}
function $b303337872d7f597$var$defaultSubscriptionObserverErrorCallback(error) {
    __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).error('Unhandled error', error.message, error.stack);
}
function $b303337872d7f597$export$b7e1973aacac3ae7(missing) {
    if (__DEV__ && missing) __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).debug("Missing cache result fields: ".concat(JSON.stringify(missing)), missing);
}








// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $4b4babab5cea65c4$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $4b4babab5cea65c4$var$MISSING_VALUE = {};
var $4b4babab5cea65c4$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $4b4babab5cea65c4$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $4b4babab5cea65c4$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $4b4babab5cea65c4$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $4b4babab5cea65c4$var$MISSING_VALUE) break;
                if (context_1 !== $4b4babab5cea65c4$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $4b4babab5cea65c4$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($4b4babab5cea65c4$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $4b4babab5cea65c4$var$currentContext.slots[this.id] = $4b4babab5cea65c4$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $4b4babab5cea65c4$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $4b4babab5cea65c4$var$currentContext;
            $4b4babab5cea65c4$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $4b4babab5cea65c4$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $4b4babab5cea65c4$var$currentContext;
            return function() {
                var saved = $4b4babab5cea65c4$var$currentContext;
                try {
                    $4b4babab5cea65c4$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $4b4babab5cea65c4$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($4b4babab5cea65c4$var$currentContext) {
                var saved = $4b4babab5cea65c4$var$currentContext;
                try {
                    $4b4babab5cea65c4$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $4b4babab5cea65c4$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
function $4b4babab5cea65c4$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
var $4b4babab5cea65c4$var$globalKey = "@wry/context:Slot";
var $4b4babab5cea65c4$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$4b4babab5cea65c4$var$maybe(function() {
    return globalThis;
}) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$4b4babab5cea65c4$var$maybe(function() {
    return $parcel$global;
}) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
var $4b4babab5cea65c4$var$globalHost = $4b4babab5cea65c4$var$host;
var $4b4babab5cea65c4$export$8c6ed5c666ac1360 = $4b4babab5cea65c4$var$globalHost[$4b4babab5cea65c4$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$4b4babab5cea65c4$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($4b4babab5cea65c4$var$globalHost, $4b4babab5cea65c4$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($4b4babab5cea65c4$var$makeSlotClass());
var $4b4babab5cea65c4$export$2385a24977818dd0 = $4b4babab5cea65c4$export$8c6ed5c666ac1360.bind, $4b4babab5cea65c4$export$9fa6f2e300a97f8 = $4b4babab5cea65c4$export$8c6ed5c666ac1360.noContext;
function $4b4babab5cea65c4$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($4b4babab5cea65c4$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $4b4babab5cea65c4$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $4b4babab5cea65c4$export$2385a24977818dd0(gen.next);
        var boundThrow = $4b4babab5cea65c4$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($4b4babab5cea65c4$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $4b4babab5cea65c4$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $4b4babab5cea65c4$var$wrappedFibers = [];
function $4b4babab5cea65c4$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($4b4babab5cea65c4$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $4b4babab5cea65c4$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $4b4babab5cea65c4$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


function $bf80b665eb3927c6$var$defaultDispose() {}
var $bf80b665eb3927c6$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $bf80b665eb3927c6$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var node = this.getNode(key);
        return node && node.value;
    };
    Cache.prototype.getNode = function(key) {
        var node = this.map.get(key);
        if (node && node !== this.newest) {
            var older = node.older, newer = node.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    };
    Cache.prototype.set = function(key, value) {
        var node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $bf80b665eb3927c6$var$parentEntrySlot = new (0, $4b4babab5cea65c4$export$8c6ed5c666ac1360)();
var $bf80b665eb3927c6$var$_a;
var $bf80b665eb3927c6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var // This Array.from polyfill is restricted to working with Set<any> for now,
// but we can improve the polyfill and add other input types, as needed. Note
// that this fallback implementation will only be used if the host environment
// does not support a native Array.from function. In most modern JS runtimes,
// the toArray function exported here will be === Array.from.
$bf80b665eb3927c6$var$toArray = ($bf80b665eb3927c6$var$_a = Array.from, $bf80b665eb3927c6$var$_a === void 0 ? function(collection) {
    var array = [];
    collection.forEach(function(item) {
        return array.push(item);
    });
    return array;
} : $bf80b665eb3927c6$var$_a);
function $bf80b665eb3927c6$var$maybeUnsubscribe(entryOrDep) {
    var unsubscribe = entryOrDep.unsubscribe;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}
var $bf80b665eb3927c6$var$emptySetPool = [];
var $bf80b665eb3927c6$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $bf80b665eb3927c6$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $bf80b665eb3927c6$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $bf80b665eb3927c6$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $bf80b665eb3927c6$var$valueCopy(value) {
    return value.slice(0);
}
var $bf80b665eb3927c6$var$Entry = /** @class */ function() {
    function Entry(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    Entry.prototype.peek = function() {
        if (this.value.length === 1 && !$bf80b665eb3927c6$var$mightBeDirty(this)) {
            $bf80b665eb3927c6$var$rememberParent(this);
            return this.value[0];
        }
    };
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function(args) {
        $bf80b665eb3927c6$var$assert(!this.recomputing, "already recomputing");
        $bf80b665eb3927c6$var$rememberParent(this);
        return $bf80b665eb3927c6$var$mightBeDirty(this) ? $bf80b665eb3927c6$var$reallyRecompute(this, args) : $bf80b665eb3927c6$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $bf80b665eb3927c6$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $bf80b665eb3927c6$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $bf80b665eb3927c6$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $bf80b665eb3927c6$var$eachParent(this, function(parent, child) {
            parent.setDirty();
            $bf80b665eb3927c6$var$forgetChild(parent, _this);
        });
    };
    Entry.prototype.forget = function() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    };
    Entry.prototype.dependOn = function(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $bf80b665eb3927c6$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    };
    Entry.prototype.forgetDeps = function() {
        var _this = this;
        if (this.deps) {
            $bf80b665eb3927c6$var$toArray(this.deps).forEach(function(dep) {
                return dep.delete(_this);
            });
            this.deps.clear();
            $bf80b665eb3927c6$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    };
    Entry.count = 0;
    return Entry;
}();
function $bf80b665eb3927c6$var$rememberParent(child) {
    var parent = $bf80b665eb3927c6$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($bf80b665eb3927c6$var$mightBeDirty(child)) $bf80b665eb3927c6$var$reportDirtyChild(parent, child);
        else $bf80b665eb3927c6$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $bf80b665eb3927c6$var$reallyRecompute(entry, args) {
    $bf80b665eb3927c6$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $bf80b665eb3927c6$var$parentEntrySlot.withValue(entry, $bf80b665eb3927c6$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($bf80b665eb3927c6$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $bf80b665eb3927c6$var$setClean(entry);
    return $bf80b665eb3927c6$var$valueGet(entry.value);
}
function $bf80b665eb3927c6$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $bf80b665eb3927c6$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $bf80b665eb3927c6$var$setClean(entry) {
    entry.dirty = false;
    if ($bf80b665eb3927c6$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $bf80b665eb3927c6$var$reportClean(entry);
}
function $bf80b665eb3927c6$var$reportDirty(child) {
    $bf80b665eb3927c6$var$eachParent(child, $bf80b665eb3927c6$var$reportDirtyChild);
}
function $bf80b665eb3927c6$var$reportClean(child) {
    $bf80b665eb3927c6$var$eachParent(child, $bf80b665eb3927c6$var$reportCleanChild);
}
function $bf80b665eb3927c6$var$eachParent(child, callback) {
    var parentCount = child.parents.size;
    if (parentCount) {
        var parents = $bf80b665eb3927c6$var$toArray(child.parents);
        for(var i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $bf80b665eb3927c6$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $bf80b665eb3927c6$var$assert(parent.childValues.has(child));
    $bf80b665eb3927c6$var$assert($bf80b665eb3927c6$var$mightBeDirty(child));
    var parentWasClean = !$bf80b665eb3927c6$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $bf80b665eb3927c6$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $bf80b665eb3927c6$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $bf80b665eb3927c6$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $bf80b665eb3927c6$var$assert(parent.childValues.has(child));
    $bf80b665eb3927c6$var$assert(!$bf80b665eb3927c6$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $bf80b665eb3927c6$var$valueCopy(child.value));
    else if (!$bf80b665eb3927c6$var$valueIs(childValue, child.value)) parent.setDirty();
    $bf80b665eb3927c6$var$removeDirtyChild(parent, child);
    if ($bf80b665eb3927c6$var$mightBeDirty(parent)) return;
    $bf80b665eb3927c6$var$reportClean(parent);
}
function $bf80b665eb3927c6$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($bf80b665eb3927c6$var$emptySetPool.length < $bf80b665eb3927c6$var$POOL_TARGET_SIZE) $bf80b665eb3927c6$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $bf80b665eb3927c6$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach(function(_value, child) {
        $bf80b665eb3927c6$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $bf80b665eb3927c6$var$assert(parent.dirtyChildren === null);
}
function $bf80b665eb3927c6$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $bf80b665eb3927c6$var$removeDirtyChild(parent, child);
}
function $bf80b665eb3927c6$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        $bf80b665eb3927c6$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
var $bf80b665eb3927c6$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $bf80b665eb3927c6$export$c723b7eff9d8f870(options) {
    var depsByKey = new Map();
    var subscribe = options && options.subscribe;
    function depend(key) {
        var parent = $bf80b665eb3927c6$var$parentEntrySlot.getValue();
        if (parent) {
            var dep_1 = depsByKey.get(key);
            if (!dep_1) depsByKey.set(key, dep_1 = new Set);
            parent.dependOn(dep_1);
            if (typeof subscribe === "function") {
                $bf80b665eb3927c6$var$maybeUnsubscribe(dep_1);
                dep_1.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        var dep = depsByKey.get(key);
        if (dep) {
            var m_1 = entryMethodName && $bf80b665eb3927c6$var$hasOwnProperty.call($bf80b665eb3927c6$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use toArray(dep).forEach instead of dep.forEach, because
            // modifying a Set while iterating over it can cause elements in the Set
            // to be removed from the Set before they've been iterated over.
            $bf80b665eb3927c6$var$toArray(dep).forEach(function(entry) {
                return entry[m_1]();
            });
            depsByKey.delete(key);
            $bf80b665eb3927c6$var$maybeUnsubscribe(dep);
        }
    };
    return depend;
}
function $bf80b665eb3927c6$var$makeDefaultMakeCacheKeyFunction() {
    var keyTrie = new (0, $a8424dc7ce80e30f$export$73571c50d0f2507e)(typeof WeakMap === "function");
    return function() {
        return keyTrie.lookupArray(arguments);
    };
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $bf80b665eb3927c6$export$cd3144f8dd136006 = $bf80b665eb3927c6$var$makeDefaultMakeCacheKeyFunction();
var $bf80b665eb3927c6$var$caches = new Set();
function $bf80b665eb3927c6$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $bf80b665eb3927c6$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var keyArgs = options.keyArgs;
    var makeCacheKey = options.makeCacheKey || $bf80b665eb3927c6$var$makeDefaultMakeCacheKeyFunction();
    var optimistic = function() {
        var key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new $bf80b665eb3927c6$var$Entry(originalFunction));
            entry.subscribe = options.subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $bf80b665eb3927c6$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$bf80b665eb3927c6$var$parentEntrySlot.hasValue()) {
            $bf80b665eb3927c6$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $bf80b665eb3927c6$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: function() {
            return cache["map"].size;
        },
        configurable: false,
        enumerable: false
    });
    function dirtyKey(key) {
        var entry = cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        var entry = cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return cache.delete(key);
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}



var $f14668c1009c897e$export$ac9723609f5c76c2 = new (0, $4b4babab5cea65c4$export$8c6ed5c666ac1360)();
var $f14668c1009c897e$var$cacheInfoMap = new WeakMap();
function $f14668c1009c897e$var$getCacheInfo(cache) {
    var info = $f14668c1009c897e$var$cacheInfoMap.get(cache);
    if (!info) $f14668c1009c897e$var$cacheInfoMap.set(cache, info = {
        vars: new Set,
        dep: (0, $bf80b665eb3927c6$export$c723b7eff9d8f870)()
    });
    return info;
}
function $f14668c1009c897e$export$cbe12faed7725318(cache) {
    $f14668c1009c897e$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $f14668c1009c897e$export$f342bdd61b3e9412(cache) {
    $f14668c1009c897e$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $f14668c1009c897e$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    $f14668c1009c897e$var$getCacheInfo(cache).dep.dirty(rv);
                    $f14668c1009c897e$var$broadcast(cache);
                });
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            var cache = $f14668c1009c897e$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $f14668c1009c897e$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $f14668c1009c897e$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $f14668c1009c897e$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}


var $a6c73f6d48f5c7a8$export$19901bcd339c3ded = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $104323fd517dfc25$export$dd702b3c8240390c)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $104323fd517dfc25$export$dd702b3c8240390c)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $7455305bac30ddd9$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $7455305bac30ddd9$export$67ebef60e6f28a6)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $7ec532f319e0861b$export$2dafb573e282fe8d)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return (0, $695d33c6ff5cdb34$export$8eae69e876ee321e)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $7455305bac30ddd9$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $7455305bac30ddd9$export$67ebef60e6f28a6)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $d071986d8a8d61be$export$bf638b60ea8b89b7)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $d071986d8a8d61be$export$a89c95c098ac2a58;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $695d33c6ff5cdb34$export$57c368c23873f32b)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $7455305bac30ddd9$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $7455305bac30ddd9$export$67ebef60e6f28a6)(this, function(_b) {
                mainDefinition = (0, $2424e121a4289e63$export$f431198736b7f96d)(document);
                fragments = (0, $2424e121a4289e63$export$5320a7ba9466a3df)(document);
                fragmentMap = (0, $5e4d569a846b5f9e$export$193789b4c8246dd4)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $7455305bac30ddd9$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $7455305bac30ddd9$export$67ebef60e6f28a6)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $7455305bac30ddd9$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $7455305bac30ddd9$export$67ebef60e6f28a6)(this, function(_a) {
                            if (!(0, $7ec532f319e0861b$export$3dc388a5f013b4a5)(selection, variables)) return [
                                2
                            ];
                            if ((0, $6fe96515315d55c4$export$fb56ad75dd311c12)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $6fe96515315d55c4$export$7d1ad22471852218)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $6fe96515315d55c4$export$22a1cdafaf27bcff)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(fragment, "No fragment named ".concat(selection.name.value)) : (0, $03191bfc90720c4f$export$f5708dca728d7177)(fragment, 11);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $104323fd517dfc25$export$160070228be94b08)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $7455305bac30ddd9$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $7455305bac30ddd9$export$67ebef60e6f28a6)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $6fe96515315d55c4$export$7d1ad22471852218)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve((0, $f14668c1009c897e$export$ac9723609f5c76c2).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $6fe96515315d55c4$export$3f5a60fb6a781b4f)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();







var $aacd2e48362b59f9$var$destructiveMethodCounts = new ((0, $b97fc55b2a1fddda$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
function $aacd2e48362b59f9$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") cache[methodName] = function() {
        $aacd2e48362b59f9$var$destructiveMethodCounts.set(cache, ($aacd2e48362b59f9$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        return original.apply(this, arguments);
    };
}
function $aacd2e48362b59f9$var$cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
var $aacd2e48362b59f9$export$79a6120a39c90b6a = function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.subscriptions = new Set();
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        if (!$aacd2e48362b59f9$var$destructiveMethodCounts.has(cache)) {
            $aacd2e48362b59f9$var$destructiveMethodCounts.set(cache, 0);
            $aacd2e48362b59f9$var$wrapDestructiveCacheMethod(cache, "evict");
            $aacd2e48362b59f9$var$wrapDestructiveCacheMethod(cache, "modify");
            $aacd2e48362b59f9$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).loading;
        if (this.variables && this.networkStatus !== (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).loading && !(0, $9675d5b886252616$export$2e2bcd8739ae039)(this.variables, query.variables)) networkStatus = (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).setVariables;
        if (!(0, $9675d5b886252616$export$2e2bcd8739ae039)(query.variables, this.variables)) this.lastDiff = void 0;
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.reset = function() {
        $aacd2e48362b59f9$var$cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.getDiff = function(variables) {
        if (variables === void 0) variables = this.variables;
        var options = this.getDiffOptions(variables);
        if (this.lastDiff && (0, $9675d5b886252616$export$2e2bcd8739ae039)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables = variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        this.updateLastDiff(diff);
        if (!this.dirty && !(0, $9675d5b886252616$export$2e2bcd8739ae039)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
                return _this.notify();
            }, 0);
        }
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        var _this = this;
        if (oq === this.observableQuery) return;
        if (this.oqListener) this.listeners.delete(this.oqListener);
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function() {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) oq["observe"]();
                else (0, $b303337872d7f597$export$419171d60552792a)(oq);
            });
        } else delete this.oqListener;
    };
    QueryInfo.prototype.notify = function() {
        var _this = this;
        $aacd2e48362b59f9$var$cancelNotifyTimeout(this);
        if (this.shouldNotify()) this.listeners.forEach(function(listener) {
            return listener(_this);
        });
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function() {
        if (!this.dirty || !this.listeners.size) return false;
        if ((0, $d8e6204d6ef04bee$export$37509604341a3464)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") return false;
        }
        return true;
    };
    QueryInfo.prototype.stop = function() {
        if (!this.stopped) {
            this.stopped = true;
            this.reset();
            this.cancel();
            this.cancel = QueryInfo.prototype.cancel;
            this.subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function() {};
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, $9675d5b886252616$export$2e2bcd8739ae039)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && lastWrite.dmCount === $aacd2e48362b59f9$var$destructiveMethodCounts.get(this.cache) && (0, $9675d5b886252616$export$2e2bcd8739ae039)(variables, lastWrite.variables) && (0, $9675d5b886252616$export$2e2bcd8739ae039)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        var graphQLErrors = (0, $d974c0bd81b7c069$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
        this.reset();
        if ('incremental' in result && (0, $d974c0bd81b7c069$export$d307f5934e447d0e)(result.incremental)) {
            var mergedData_1 = this.getDiff().result;
            var merger_1 = new (0, $104323fd517dfc25$export$509e11c221f576c0)();
            result.incremental.forEach(function(_a) {
                var data = _a.data, path = _a.path, errors = _a.errors;
                for(var i = path.length - 1; i >= 0; --i){
                    var key = path[i];
                    var isNumericKey = !isNaN(+key);
                    var parent_1 = isNumericKey ? [] : {};
                    parent_1[key] = data;
                    data = parent_1;
                }
                if (errors) graphQLErrors.push.apply(graphQLErrors, errors);
                mergedData_1 = merger_1.merge(mergedData_1, data);
            });
            result.data = mergedData_1;
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === 'no-cache') this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0) {
            if ($aacd2e48362b59f9$export$5f47a9fb9a521654(result, options.errorPolicy)) this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $aacd2e48362b59f9$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = cache.diff(diffOptions);
                if (!_this.stopped) _this.updateWatch(options.variables);
                _this.updateLastDiff(diff, diffOptions);
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        this.networkStatus = (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $aacd2e48362b59f9$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $0d8d884137f1bba5$export$b4df399e879e53ab)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}


var $1a37c73b1531990c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $1a37c73b1531990c$export$b986383a50b53ea4 = function() {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.clientAwareness = {};
        this.queries = new Map();
        this.fetchCancelFns = new Map();
        this.transformCache = new ((0, $b97fc55b2a1fddda$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        this.inFlightLinkObservables = new Map();
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new (0, $a6c73f6d48f5c7a8$export$19901bcd339c3ded)({
            cache: cache
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
        if (this.onBroadcast = onBroadcast) this.mutationStore = Object.create(null);
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches(__DEV__ ? new (0, $03191bfc90720c4f$export$cea12affaee22fe8)('QueryManager stopped while query was in flight') : new (0, $03191bfc90720c4f$export$cea12affaee22fe8)(13));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return (0, $7455305bac30ddd9$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var mutationId, _h, document, hasClientExports, mutationStoreValue, self;
            return (0, $7455305bac30ddd9$export$67ebef60e6f28a6)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(mutation, 'mutation option is required. You must specify your GraphQL document in the mutation option.') : (0, $03191bfc90720c4f$export$f5708dca728d7177)(mutation, 14);
                        __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(fetchPolicy === 'network-only' || fetchPolicy === 'no-cache', "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : (0, $03191bfc90720c4f$export$f5708dca728d7177)(fetchPolicy === 'network-only' || fetchPolicy === 'no-cache', 15);
                        mutationId = this.generateMutationId();
                        _h = this.transform(mutation), document = _h.document, hasClientExports = _h.hasClientExports;
                        mutation = this.cache.transformForLink(document);
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _j.sent();
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        if (optimisticResponse) this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                return (0, $5d1d4b46ff09d192$export$707ee4c4c95d39e3)(self.getObservableFromLink(mutation, (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false), function(result) {
                                    if ((0, $0d8d884137f1bba5$export$b4df399e879e53ab)(result) && errorPolicy === 'none') throw new (0, $94d00a3b1a6b6d00$export$26a337512320b8c6)({
                                        graphQLErrors: result.errors
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === 'ignore' && (0, $0d8d884137f1bba5$export$b4df399e879e53ab)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: optimisticResponse ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        resolve(storeResult);
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (optimisticResponse) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, $94d00a3b1a6b6d00$export$26a337512320b8c6) ? err : new (0, $94d00a3b1a6b6d00$export$26a337512320b8c6)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, $aacd2e48362b59f9$export$5f47a9fb9a521654)(result, mutation.errorPolicy)) {
            cacheWrites.push({
                result: result.data,
                dataId: 'ROOT_MUTATION',
                query: mutation.document,
                variables: mutation.variables
            });
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$1a37c73b1531990c$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, $2424e121a4289e63$export$41bca9dc6871dd4e)(document) || void 0,
                        queryVariables: variables
                    });
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || mutation.refetchQueries || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    var update = mutation.update;
                    if (update) {
                        if (!skipCache) {
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                query: _this.transform(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete && !(0, $9de5d00cf0289adf$export$879767c5cdf33cb3)(result)) result = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, result), {
                                data: diff.result
                            });
                        }
                        update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    if (!skipCache && !mutation.keepRootFields) cache.modify({
                        id: 'ROOT_MUTATION',
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                optimistic: false,
                removeOptimistic: mutation.removeOptimistic,
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables) : optimisticResponse;
        return this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).error(error);
            }
        }, mutation.mutationId);
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchQueryObservable(queryId, options, networkStatus).promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var transformed = this.cache.transformDocument(document);
            var noConnection = (0, $695d33c6ff5cdb34$export$74985f3324559867)(transformed);
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = noConnection && this.localState.serverQuery(noConnection);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $7ec532f319e0861b$export$8d1e9e5bbfa5d09a)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $2424e121a4289e63$export$84c19026e616569e)((0, $2424e121a4289e63$export$7a5b1fa979d2c158)(transformed)),
                asQuery: (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, transformed), {
                    definitions: transformed.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        options = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
            variables: this.getVariables(options.query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $aacd2e48362b59f9$export$79a6120a39c90b6a)(this);
        var observable = new (0, $b303337872d7f597$export$6c1b56eac59c9584)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        this.queries.set(observable.queryId, queryInfo);
        queryInfo.init({
            document: observable.query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(options.query, "query option is required. You must specify your GraphQL document in the query option.") : (0, $03191bfc90720c4f$export$f5708dca728d7177)(options.query, 16);
        __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(options.query.kind === 'Document', 'You must wrap the query string in a "gql" tag.') : (0, $03191bfc90720c4f$export$f5708dca728d7177)(options.query.kind === 'Document', 17);
        __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(!options.returnPartialData, 'returnPartialData option only supported on watchQuery.') : (0, $03191bfc90720c4f$export$f5708dca728d7177)(!options.returnPartialData, 18);
        __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(!options.pollInterval, 'pollInterval option only supported on watchQuery.') : (0, $03191bfc90720c4f$export$f5708dca728d7177)(!options.pollInterval, 19);
        return this.fetchQuery(queryId, options).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        this.cancelPendingFetches(__DEV__ ? new (0, $03191bfc90720c4f$export$cea12affaee22fe8)('Store reset while query was in flight (not completed in link chain)') : new (0, $03191bfc90720c4f$export$cea12affaee22fe8)(20));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) queryInfo.networkStatus = (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") queryNamesAndDocs.set(desc, false);
            else if ((0, $6fe96515315d55c4$export$540432d49fcec6c9)(desc)) queryNamesAndDocs.set(_this.transform(desc).document, false);
            else if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndDocs.has(queryName) || document && queryNamesAndDocs.has(document)) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndDocs.set(queryName, true);
                    if (document) queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            var queryId = (0, $fab8b8d7adece54d$export$d0c8ec0fe1b18b70)("legacyOneTimeQuery");
            var queryInfo = _this.getQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, $b303337872d7f597$export$6c1b56eac59c9584)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, $03191bfc90720c4f$export$f5708dca728d7177)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (__DEV__ && queryNamesAndDocs.size) queryNamesAndDocs.forEach(function(included, nameOrDoc) {
            if (!included) __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).warn("Unknown query ".concat(typeof nameOrDoc === "string" ? "named " : "").concat(JSON.stringify(nameOrDoc, null, 2), " requested in refetchQueries options.include array"));
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function(observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, errorPolicy = _a.errorPolicy, variables = _a.variables, _b = _a.context, context = _b === void 0 ? {} : _b;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables).map(function(result) {
                if (fetchPolicy !== 'no-cache') {
                    if ((0, $aacd2e48362b59f9$export$5f47a9fb9a521654)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: 'ROOT_SUBSCRIPTION',
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                if ((0, $0d8d884137f1bba5$export$b4df399e879e53ab)(result)) throw new (0, $94d00a3b1a6b6d00$export$26a337512320b8c6)({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, $7401f4590b7a34ce$export$77cea355fa80b5f4)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            return info.notify();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _b = this, inFlightLinkObservables_1 = _b.inFlightLinkObservables, link = _b.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $2424e121a4289e63$export$41bca9dc6871dd4e)(serverQuery) || void 0,
                context: this.prepareContext((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = (0, $38af0b4df3538bbb$export$88a0ad9b6f961b51)(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new (0, $ea4a70d73b084114$export$ae0cf2ec7a6fa78e)([
                        (0, $a1c093f3f4975a7d$export$51396ec711da548b)(link, operation)
                    ]);
                    byVariables_1.set(varJson_1, observable = concast);
                    concast.beforeNext(function() {
                        if (byVariables_1.delete(varJson_1) && byVariables_1.size < 1) inFlightLinkObservables_1.delete(serverQuery);
                    });
                }
            } else observable = new (0, $ea4a70d73b084114$export$ae0cf2ec7a6fa78e)([
                (0, $a1c093f3f4975a7d$export$51396ec711da548b)(link, operation)
            ]);
        } else {
            observable = new (0, $ea4a70d73b084114$export$ae0cf2ec7a6fa78e)([
                (0, $7401f4590b7a34ce$export$77cea355fa80b5f4).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = (0, $5d1d4b46ff09d192$export$707ee4c4c95d39e3)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        options = (0, $aa264210ed31b6df$export$629a2bd3f5a49ecc)(options);
        var linkDocument = this.cache.transformForLink(this.transform(queryInfo.document).document);
        return (0, $5d1d4b46ff09d192$export$707ee4c4c95d39e3)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, $d974c0bd81b7c069$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
            if ('incremental' in result && (0, $d974c0bd81b7c069$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
                if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
            });
            var hasErrors = (0, $d974c0bd81b7c069$export$d307f5934e447d0e)(graphQLErrors);
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") throw queryInfo.markError(new (0, $94d00a3b1a6b6d00$export$26a337512320b8c6)({
                    graphQLErrors: graphQLErrors
                }));
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).ready
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, $94d00a3b1a6b6d00$export$17f5e6bd290bb15d)(networkError) ? networkError : new (0, $94d00a3b1a6b6d00$export$26a337512320b8c6)({
                networkError: networkError
            });
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchQueryObservable = function(queryId, options, networkStatus) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).loading;
        var query = this.transform(options.query).document;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            normalized.variables = variables;
            var concastSources = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (normalized.fetchPolicy !== "standby" && concastSources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return concastSources;
        };
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryId);
        };
        this.fetchCancelFns.set(queryId, function(reason) {
            cleanupCancelFn();
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast = new (0, $ea4a70d73b084114$export$ae0cf2ec7a6fa78e)(this.transform(normalized.query).hasClientExports ? this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables) : fromVariables(normalized.variables));
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return concast;
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, $fab8b8d7adece54d$export$d0c8ec0fe1b18b70)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: _this.getQuery(queryId).getDiff()
            });
        });
        var results = new Map;
        if (updateCache) this.cache.batch({
            update: updateCache,
            optimistic: optimistic && removeOptimistic || false,
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, $aacd2e48362b59f9$export$79a6120a39c90b6a) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) result = oq.refetch();
                        if (result !== false) results.set(oq, result);
                        return result;
                    }
                    if (onQueryUpdated !== null) includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            if (onQueryUpdated) {
                if (!diff) {
                    var info = oq["queryInfo"];
                    info.reset();
                    diff = info.getDiff();
                }
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: this.transform(query).document,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff(variables);
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).loading;
            var data = diff.result;
            if (__DEV__ && !returnPartialData && !(0, $9675d5b886252616$export$2e2bcd8739ae039)(data, {})) (0, $b303337872d7f597$export$b7e1973aacac3ae7)(diff.missing);
            var fromData = function(data) {
                return (0, $7401f4590b7a34ce$export$77cea355fa80b5f4).of((0, $7455305bac30ddd9$export$18ce0697a983be9b)({
                    data: data,
                    loading: (0, $d8e6204d6ef04bee$export$37509604341a3464)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.transform(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 : networkStatus === (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).refetch && refetchWritePolicy !== "merge" ? 1 : 2;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $d8e6204d6ef04bee$export$37509604341a3464)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return [
                    resultsFromCache(diff, queryInfo.markReady())
                ];
                if (returnPartialData || shouldNotify) return [
                    resultsFromCache(diff),
                    resultsFromLink()
                ];
                return [
                    resultsFromLink()
                ];
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return [
                    resultsFromCache(diff),
                    resultsFromLink()
                ];
                return [
                    resultsFromLink()
                ];
            case "cache-only":
                return [
                    resultsFromCache(readCache(), queryInfo.markReady())
                ];
            case "network-only":
                if (shouldNotify) return [
                    resultsFromCache(readCache()),
                    resultsFromLink()
                ];
                return [
                    resultsFromLink()
                ];
            case "no-cache":
                if (shouldNotify) return [
                    resultsFromCache(queryInfo.getDiff()),
                    resultsFromLink()
                ];
                return [
                    resultsFromLink()
                ];
            case "standby":
                return [];
        }
    };
    QueryManager.prototype.getQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $aacd2e48362b59f9$export$79a6120a39c90b6a)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();




var $5215b865ef3c30a6$var$hasSuggestedDevtools = false;
var $5215b865ef3c30a6$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, _c = options.connectToDevTools, connectToDevTools = _c === void 0 ? typeof window === 'object' && !window.__APOLLO_CLIENT__ && __DEV__ : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? false : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) link = uri ? new (0, $afdafcce1fdcac38$export$f4bbf1aec241cc1)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $80285925cfe0f960$export$2fed3d61f740bc7f).empty();
        if (!cache) throw __DEV__ ? new (0, $03191bfc90720c4f$export$cea12affaee22fe8)("To initialize Apollo Client, you must specify a 'cache' property in the options object. \nFor more information, please visit: https://go.apollo.dev/c/docs") : new (0, $03191bfc90720c4f$export$cea12affaee22fe8)(9);
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        if (connectToDevTools && typeof window === 'object') window.__APOLLO_CLIENT__ = this;
        if (!$5215b865ef3c30a6$var$hasSuggestedDevtools && __DEV__) {
            $5215b865ef3c30a6$var$hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                var nav = window.navigator;
                var ua = nav && nav.userAgent;
                var url = void 0;
                if (typeof ua === "string") {
                    if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                    else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                }
                if (url) __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).log("Download the Apollo DevTools for a better development experience: " + url);
            }
        }
        this.version = (0, $a8d780b011b44c78$export$83d89fbfd8236492);
        this.localState = new (0, $a6c73f6d48f5c7a8$export$19901bcd339c3ded)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $1a37c73b1531990c$export$b986383a50b53ea4)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $68f062d2048ef6b4$export$235b7fc70b9fc359)(this.defaultOptions.watchQuery, options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $68f062d2048ef6b4$export$235b7fc70b9fc359)(this.defaultOptions.query, options);
        __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(options.fetchPolicy !== 'cache-and-network', "The cache-and-network fetchPolicy does not work with client.query, because client.query can only return a single result. Please use client.watchQuery to receive multiple results from the cache and the network, or consider using a different fetchPolicy, such as cache-first or network-only.") : (0, $03191bfc90720c4f$export$f5708dca728d7177)(options.fetchPolicy !== 'cache-and-network', 10);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $68f062d2048ef6b4$export$235b7fc70b9fc359)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.writeFragment = function(options) {
        this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $a1c093f3f4975a7d$export$51396ec711da548b)(this.link, payload);
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        result.queries = queries;
        result.results = results;
        result.catch(function(error) {
            __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(error));
        });
        return result;
    };
    ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}();





var $316cfcdad6602aa8$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($316cfcdad6602aa8$export$d1d99cf900472499 || ($316cfcdad6602aa8$export$d1d99cf900472499 = {}));
var $316cfcdad6602aa8$var$cache = new Map();
function $316cfcdad6602aa8$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $316cfcdad6602aa8$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $316cfcdad6602aa8$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $316cfcdad6602aa8$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $316cfcdad6602aa8$export$8f49e4af10703ce3(document) {
    var cached = $316cfcdad6602aa8$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(!!document && !!document.kind, "Argument of ".concat(document, " passed to parser was not a valid GraphQL ") + "DocumentNode. You may need to use 'graphql-tag' or another method " + "to convert your operation into a document") : (0, $03191bfc90720c4f$export$f5708dca728d7177)(!!document && !!document.kind, 32);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for(var _i = 0, _a = document.definitions; _i < _a.length; _i++){
        var x = _a[_i];
        if (x.kind === 'FragmentDefinition') {
            fragments.push(x);
            continue;
        }
        if (x.kind === 'OperationDefinition') switch(x.operation){
            case 'query':
                queries.push(x);
                break;
            case 'mutation':
                mutations.push(x);
                break;
            case 'subscription':
                subscriptions.push(x);
                break;
        }
    }
    __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(!fragments.length || queries.length || mutations.length || subscriptions.length, "Passing only a fragment to 'graphql' is not yet supported. You must include a query, subscription or mutation as well") : (0, $03191bfc90720c4f$export$f5708dca728d7177)(!fragments.length || queries.length || mutations.length || subscriptions.length, 33);
    __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " + "".concat(document, " had ").concat(queries.length, " queries, ").concat(subscriptions.length, " ") + "subscriptions and ".concat(mutations.length, " mutations. ") + "You can use 'compose' to join multiple operation types to a component") : (0, $03191bfc90720c4f$export$f5708dca728d7177)(queries.length + mutations.length + subscriptions.length <= 1, 34);
    type = queries.length ? $316cfcdad6602aa8$export$d1d99cf900472499.Query : $316cfcdad6602aa8$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $316cfcdad6602aa8$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(definitions.length === 1, "react-apollo only supports one definition per HOC. ".concat(document, " had ") + "".concat(definitions.length, " definitions. ") + "You can use 'compose' to join multiple operation types to a component") : (0, $03191bfc90720c4f$export$f5708dca728d7177)(definitions.length === 1, 35);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $316cfcdad6602aa8$var$cache.set(document, payload);
    return payload;
}
function $316cfcdad6602aa8$export$6dfb8732f737404c(document, type) {
    var operation = $316cfcdad6602aa8$export$8f49e4af10703ce3(document);
    var requiredOperationName = $316cfcdad6602aa8$export$5db520940cf00715(type);
    var usedOperationName = $316cfcdad6602aa8$export$5db520940cf00715(operation.type);
    __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(operation.type === type, "Running a ".concat(requiredOperationName, " requires a graphql ") + "".concat(requiredOperationName, ", but a ").concat(usedOperationName, " was used instead.")) : (0, $03191bfc90720c4f$export$f5708dca728d7177)(operation.type === type, 36);
}




var $6fFrj = parcelRequire("6fFrj");

function $35f6182eda3ba50d$export$eb9a56e7a29e494(override) {
    var context = (0, $6fFrj.useContext)((0, $0c60d4e5be34846c$export$a47505d961ee3a1)());
    var client = override || context.client;
    __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(!!client, 'Could not find "client" in the context or passed in as an option. Wrap the root component in an <ApolloProvider>, or pass an ApolloClient instance in via options.') : (0, $03191bfc90720c4f$export$f5708dca728d7177)(!!client, 31);
    return client;
}




function $62d5a3f8d8ea93ca$var$deepFreeze(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(obj) && $62d5a3f8d8ea93ca$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $62d5a3f8d8ea93ca$var$shallowFreeze(obj) {
    if (__DEV__ && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function $62d5a3f8d8ea93ca$export$7f9c177735b71f18(obj) {
    if (__DEV__) $62d5a3f8d8ea93ca$var$deepFreeze(obj);
    return obj;
}


var $cec66d7339eadd2d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $cec66d7339eadd2d$export$dd0a697e1782aedd(query, options) {
    if (options === void 0) options = Object.create(null);
    return $cec66d7339eadd2d$export$6342ea8c555e49e5((0, $35f6182eda3ba50d$export$eb9a56e7a29e494)(options.client), query).useQuery(options);
}
function $cec66d7339eadd2d$export$6342ea8c555e49e5(client, query) {
    var stateRef = (0, $6fFrj.useRef)();
    if (!stateRef.current || client !== stateRef.current.client || query !== stateRef.current.query) stateRef.current = new $cec66d7339eadd2d$var$InternalState(client, query, stateRef.current);
    var state = stateRef.current;
    var _a = (0, $6fFrj.useState)(0), _tick = _a[0], setTick = _a[1];
    state.forceUpdate = function() {
        setTick(function(tick) {
            return tick + 1;
        });
    };
    return state;
}
var $cec66d7339eadd2d$var$InternalState = function() {
    function InternalState(client, query, previous) {
        this.client = client;
        this.query = query;
        this.asyncResolveFns = new Set();
        this.optionsToIgnoreOnce = new ((0, $b97fc55b2a1fddda$export$7293b8a0b474028d) ? WeakSet : Set)();
        this.ssrDisabledResult = (0, $62d5a3f8d8ea93ca$export$7f9c177735b71f18)({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).loading
        });
        this.skipStandbyResult = (0, $62d5a3f8d8ea93ca$export$7f9c177735b71f18)({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).ready
        });
        this.toQueryResultCache = new ((0, $b97fc55b2a1fddda$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        (0, $316cfcdad6602aa8$export$6dfb8732f737404c)(query, (0, $316cfcdad6602aa8$export$d1d99cf900472499).Query);
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) this.previousData = previousData;
    }
    InternalState.prototype.forceUpdate = function() {
        __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).warn("Calling default no-op implementation of InternalState#forceUpdate");
    };
    InternalState.prototype.asyncUpdate = function() {
        var _this = this;
        return new Promise(function(resolve) {
            _this.asyncResolveFns.add(resolve);
            _this.optionsToIgnoreOnce.add(_this.watchQueryOptions);
            _this.forceUpdate();
        });
    };
    InternalState.prototype.useQuery = function(options) {
        var _this = this;
        this.renderPromises = (0, $6fFrj.useContext)((0, $0c60d4e5be34846c$export$a47505d961ee3a1)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = (0, $54ecaae8b5bfa383$export$306c0aa65ff9ec16)((0, $6fFrj.useCallback)(function() {
            if (_this.renderPromises) return function() {};
            var onNext = function() {
                var previousResult = _this.result;
                var result = obsQuery.getCurrentResult();
                if (previousResult && previousResult.loading === result.loading && previousResult.networkStatus === result.networkStatus && (0, $9675d5b886252616$export$2e2bcd8739ae039)(previousResult.data, result.data)) return;
                _this.setResult(result);
            };
            var onError = function(error) {
                var last = obsQuery["last"];
                subscription.unsubscribe();
                try {
                    obsQuery.resetLastResults();
                    subscription = obsQuery.subscribe(onNext, onError);
                } finally{
                    obsQuery["last"] = last;
                }
                if (!$cec66d7339eadd2d$var$hasOwnProperty.call(error, 'graphQLErrors')) throw error;
                var previousResult = _this.result;
                if (!previousResult || previousResult && previousResult.loading || !(0, $9675d5b886252616$export$2e2bcd8739ae039)(error, previousResult.error)) _this.setResult({
                    data: previousResult && previousResult.data,
                    error: error,
                    loading: false,
                    networkStatus: (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).error
                });
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            return function() {
                return subscription.unsubscribe();
            };
        }, [
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches
        ]), function() {
            return _this.getCurrentResult();
        }, function() {
            return _this.getCurrentResult();
        });
        this.unsafeHandlePartialRefetch(result);
        var queryResult = this.toQueryResult(result);
        if (!queryResult.loading && this.asyncResolveFns.size) {
            this.asyncResolveFns.forEach(function(resolve) {
                return resolve(queryResult);
            });
            this.asyncResolveFns.clear();
        }
        return queryResult;
    };
    InternalState.prototype.useOptions = function(options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (this.optionsToIgnoreOnce.has(currentWatchQueryOptions) || !(0, $9675d5b886252616$export$2e2bcd8739ae039)(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                this.optionsToIgnoreOnce.delete(currentWatchQueryOptions);
                this.observable.reobserve(this.getObsQueryOptions());
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        this.onCompleted = options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) && this.queryHookOptions.ssr === false && !this.queryHookOptions.skip) this.result = this.ssrDisabledResult;
        else if (this.queryHookOptions.skip || this.watchQueryOptions.fetchPolicy === 'standby') this.result = this.skipStandbyResult;
        else if (this.result === this.ssrDisabledResult || this.result === this.skipStandbyResult) this.result = void 0;
    };
    InternalState.prototype.getObsQueryOptions = function() {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults) toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) toMerge.push(this.queryHookOptions.defaultOptions);
        toMerge.push((0, $20c8e93b6072aee9$export$8e16b83750b44988)(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce((0, $68f062d2048ef6b4$export$235b7fc70b9fc359));
    };
    InternalState.prototype.createWatchQueryOptions = function(_a) {
        var _b;
        if (_a === void 0) _a = {};
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, otherOptions = (0, $7455305bac30ddd9$export$3c9a16f847548506)(_a, [
            "skip",
            "ssr",
            "onCompleted",
            "onError",
            "defaultOptions"
        ]);
        var watchQueryOptions = Object.assign(otherOptions, {
            query: this.query
        });
        if (this.renderPromises && (watchQueryOptions.fetchPolicy === 'network-only' || watchQueryOptions.fetchPolicy === 'cache-and-network')) watchQueryOptions.fetchPolicy = 'cache-first';
        if (!watchQueryOptions.variables) watchQueryOptions.variables = {};
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: 'standby'
            });
        } else if (!watchQueryOptions.fetchPolicy) watchQueryOptions.fetchPolicy = ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) || this.getDefaultFetchPolicy();
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function() {
        var _a, _b;
        return ((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "cache-first";
    };
    InternalState.prototype.onCompleted = function(data) {};
    InternalState.prototype.onError = function(error) {};
    InternalState.prototype.useObservableQuery = function() {
        var obsQuery = this.observable = this.renderPromises && this.renderPromises.getSSRObservable(this.watchQueryOptions) || this.observable || this.client.watchQuery(this.getObsQueryOptions());
        this.obsQueryFields = (0, $6fFrj.useMemo)(function() {
            return {
                refetch: obsQuery.refetch.bind(obsQuery),
                reobserve: obsQuery.reobserve.bind(obsQuery),
                fetchMore: obsQuery.fetchMore.bind(obsQuery),
                updateQuery: obsQuery.updateQuery.bind(obsQuery),
                startPolling: obsQuery.startPolling.bind(obsQuery),
                stopPolling: obsQuery.stopPolling.bind(obsQuery),
                subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery)
            };
        }, [
            obsQuery
        ]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false || this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) this.renderPromises.addObservableQueryPromise(obsQuery);
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function(nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) this.previousData = previousResult.data;
        this.result = nextResult;
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function(result) {
        var _this = this;
        if (!result.loading) Promise.resolve().then(function() {
            if (result.error) _this.onError(result.error);
            else if (result.data) _this.onCompleted(result.data);
        }).catch(function(error) {
            __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).warn(error);
        });
    };
    InternalState.prototype.getCurrentResult = function() {
        if (!this.result) this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult());
        return this.result;
    };
    InternalState.prototype.toQueryResult = function(result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult) return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0, $7455305bac30ddd9$export$3c9a16f847548506)(result, [
            "data",
            "partial"
        ]);
        this.toQueryResultCache.set(result, queryResult = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({
            data: data
        }, resultWithoutPartial), this.obsQueryFields), {
            client: this.client,
            observable: this.observable,
            variables: this.observable.variables,
            called: !this.queryHookOptions.skip,
            previousData: this.previousData
        }));
        if (!queryResult.error && (0, $d974c0bd81b7c069$export$d307f5934e447d0e)(result.errors)) queryResult.error = new (0, $94d00a3b1a6b6d00$export$26a337512320b8c6)({
            graphQLErrors: result.errors
        });
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function(result) {
        if (result.partial && this.queryHookOptions.partialRefetch && !result.loading && (!result.data || Object.keys(result.data).length === 0) && this.observable.options.fetchPolicy !== 'cache-only') {
            Object.assign(result, {
                loading: true,
                networkStatus: (0, $d8e6204d6ef04bee$export$bd096ddbd246c79c).refetch
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}();



var $b479e4ced1af6421$var$EAGER_METHODS = [
    'refetch',
    'reobserve',
    'fetchMore',
    'updateQuery',
    'startPolling',
    'subscribeToMore'
];
function $b479e4ced1af6421$export$fd83eea6ecd2d8fa(query, options) {
    var internalState = (0, $cec66d7339eadd2d$export$6342ea8c555e49e5)((0, $35f6182eda3ba50d$export$eb9a56e7a29e494)(options && options.client), query);
    var execOptionsRef = (0, $6fFrj.useRef)();
    var merged = execOptionsRef.current ? (0, $68f062d2048ef6b4$export$235b7fc70b9fc359)(options, execOptionsRef.current) : options;
    var useQueryResult = internalState.useQuery((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, merged), {
        skip: !execOptionsRef.current
    }));
    var initialFetchPolicy = useQueryResult.observable.options.initialFetchPolicy || internalState.getDefaultFetchPolicy();
    var result = Object.assign(useQueryResult, {
        called: !!execOptionsRef.current
    });
    var eagerMethods = (0, $6fFrj.useMemo)(function() {
        var eagerMethods = {};
        var _loop_1 = function(key) {
            var method = result[key];
            eagerMethods[key] = function() {
                if (!execOptionsRef.current) {
                    execOptionsRef.current = Object.create(null);
                    internalState.forceUpdate();
                }
                return method.apply(this, arguments);
            };
        };
        for(var _i = 0, EAGER_METHODS_1 = $b479e4ced1af6421$var$EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++){
            var key = EAGER_METHODS_1[_i];
            _loop_1(key);
        }
        return eagerMethods;
    }, []);
    Object.assign(result, eagerMethods);
    var execute = (0, $6fFrj.useCallback)(function(executeOptions) {
        execOptionsRef.current = executeOptions ? (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, executeOptions), {
            fetchPolicy: executeOptions.fetchPolicy || initialFetchPolicy
        }) : {
            fetchPolicy: initialFetchPolicy
        };
        var promise = internalState.asyncUpdate().then(function(queryResult) {
            return Object.assign(queryResult, eagerMethods);
        });
        promise.catch(function() {});
        return promise;
    }, []);
    return [
        execute,
        result
    ];
}


const $fa3f5c8f35890bd3$var$defaultOptions = {};
const $fa3f5c8f35890bd3$export$320b6e73dbce3484 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetStripeCustomer($getStripeCustomerInput: GetStripeCustomerInput!) {
  getStripeCustomer(getStripeCustomerInput: $getStripeCustomerInput) {
    id
    default_source
    invoice_settings {
      default_payment_method
    }
  }
}
    `;
function $fa3f5c8f35890bd3$export$eeb3a77a20e59876(baseOptions) {
    const options = {
        ...$fa3f5c8f35890bd3$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($fa3f5c8f35890bd3$export$320b6e73dbce3484, options);
}
function $fa3f5c8f35890bd3$export$af32abb3b1bb6a47(baseOptions) {
    const options = {
        ...$fa3f5c8f35890bd3$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($fa3f5c8f35890bd3$export$320b6e73dbce3484, options);
}
const $fa3f5c8f35890bd3$export$59f6df54d261a4eb = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetCancellationPrice {
  GetCancellationPrice {
    id
    product {
      id
      name
    }
    billing_scheme
    tiers {
      flat_amount
      flat_amount_decimal
      unit_amount
      unit_amount_decimal
      up_to
    }
    tiers_mode
    unit_amount
    unit_amount_decimal
    nickname
  }
}
    `;
function $fa3f5c8f35890bd3$export$51bb9b73b250814d(baseOptions) {
    const options = {
        ...$fa3f5c8f35890bd3$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($fa3f5c8f35890bd3$export$59f6df54d261a4eb, options);
}
function $fa3f5c8f35890bd3$export$ac1788677f55dd55(baseOptions) {
    const options = {
        ...$fa3f5c8f35890bd3$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($fa3f5c8f35890bd3$export$59f6df54d261a4eb, options);
}
const $fa3f5c8f35890bd3$export$fd2c7e237e635e25 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetPlanAccessLevel {
  getPlanAccessLevel {
    planType
  }
}
    `;
function $fa3f5c8f35890bd3$export$793fe9e22153f877(baseOptions) {
    const options = {
        ...$fa3f5c8f35890bd3$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($fa3f5c8f35890bd3$export$fd2c7e237e635e25, options);
}
function $fa3f5c8f35890bd3$export$f228cc639da2598e(baseOptions) {
    const options = {
        ...$fa3f5c8f35890bd3$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($fa3f5c8f35890bd3$export$fd2c7e237e635e25, options);
}
const $fa3f5c8f35890bd3$export$39ac829ab91f0716 = {
    Query: {
        GetStripeCustomer: 'GetStripeCustomer',
        GetCancellationPrice: 'GetCancellationPrice',
        GetPlanAccessLevel: 'GetPlanAccessLevel'
    }
};



const $58073eff19365823$export$f51d452c10d5b956 = ()=>(0, $1a030f7d00178424$export$8ad76b76a4c905f8)();
const $58073eff19365823$export$a7347740d65f620b = (0, $f9ccae383da3d032$export$2105062e25df4afe);



var $a8c21a2ece310828$export$617d79dae526d2cf;
(function(Features) {
    Features["signatures"] = "signatures";
    Features["approvals"] = "approvals";
    Features["followUps"] = "followUps";
    Features["aiMessaging"] = "aiMessaging";
    Features["mappedDrive"] = "mappedDrive";
    Features["entityInterviews"] = "entityInterviews";
    Features["reviews"] = "reviews";
    Features["appointments"] = "appointments";
    Features["aiResearch"] = "aiResearch";
    Features["export"] = "export";
    Features["videoCalls"] = "videoCalls";
    Features["birthdayEmails"] = "birthdayEmails";
    Features["pixels"] = "pixels";
    Features["teamMembers"] = "teamMembers";
})($a8c21a2ece310828$export$617d79dae526d2cf || ($a8c21a2ece310828$export$617d79dae526d2cf = {}));
const $a8c21a2ece310828$export$73f20a159a96bef5 = [
    $a8c21a2ece310828$export$617d79dae526d2cf.appointments,
    $a8c21a2ece310828$export$617d79dae526d2cf.pixels,
    $a8c21a2ece310828$export$617d79dae526d2cf.birthdayEmails
];
const $a8c21a2ece310828$var$ModalContext = /*#__PURE__*/ (0, $6fFrj.createContext)({
    isModalVisible: false,
    showModal: (newFeature, closable)=>null,
    hideModal: ()=>null,
    accessObject: {},
    feature: null,
    closable: true
});
const $a8c21a2ece310828$export$178405afcd8c5eb = ({ children: children })=>{
    const { accessToken: accessToken } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$ca779d385d6ad982));
    const [isModalVisible, setIsModalVisible] = (0, $6fFrj.useState)(false);
    const [feature, setFeature] = (0, $6fFrj.useState)(null);
    const [closable, setClosable] = (0, $6fFrj.useState)(true);
    const [accessObject, setAccessObject] = (0, $6fFrj.useState)(null);
    const { data: planAccessData, loading: loadingPlanType } = (0, $fa3f5c8f35890bd3$export$793fe9e22153f877)({
        skip: !accessToken
    });
    const currentPlanAccess = planAccessData?.getPlanAccessLevel?.planType;
    const getAccess = (theFeature)=>{
        if (currentPlanAccess === 'FREE') return false;
        if (currentPlanAccess === 'LITE') return $a8c21a2ece310828$export$73f20a159a96bef5.includes(theFeature);
        return true; // must be on pro plan
    };
    (0, $6fFrj.useEffect)(()=>{
        if (!loadingPlanType && currentPlanAccess) {
            const accessResults = {};
            // eslint-disable-next-line no-restricted-syntax
            for (const f of Object.values($a8c21a2ece310828$export$617d79dae526d2cf))accessResults[f] = getAccess(f);
            console.log('accessResults', accessResults);
            setAccessObject(accessResults);
            (0, $dfc6a33c14790f87$export$687cd65f7d91f1da)(currentPlanAccess);
        }
    }, [
        currentPlanAccess,
        feature,
        loadingPlanType
    ]);
    const showModal = (newFeature = null, isClosable = true)=>{
        setFeature(newFeature);
        setClosable(isClosable);
        setIsModalVisible(true);
    };
    const hideModal = ()=>{
        setIsModalVisible(false);
        setFeature(null); // Reset feature when closing the modal
    };
    // Memoize the context value
    const contextValue = (0, $6fFrj.useMemo)(()=>({
            isModalVisible: isModalVisible,
            feature: feature,
            closable: closable,
            showModal: showModal,
            hideModal: hideModal,
            accessObject: accessObject
        }), [
        isModalVisible,
        feature,
        closable,
        currentPlanAccess,
        accessObject
    ]);
    console.log('accessObject', accessObject);
    return (0, $bb3TF.jsx)($a8c21a2ece310828$var$ModalContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $a8c21a2ece310828$export$c8ea4d078f89ced5 = ()=>(0, $6fFrj.useContext)($a8c21a2ece310828$var$ModalContext);




var $bb3TF = parcelRequire("bb3TF");
/**
 * React Router DOM v6.4.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6fFrj = parcelRequire("6fFrj");
/**
 * @remix-run/router v1.0.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $814c115a3a0a6b4a$var$_extends() {
    $814c115a3a0a6b4a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $814c115a3a0a6b4a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $814c115a3a0a6b4a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($814c115a3a0a6b4a$export$e19cd5f9376f8cee || ($814c115a3a0a6b4a$export$e19cd5f9376f8cee = {}));
const $814c115a3a0a6b4a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $814c115a3a0a6b4a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $814c115a3a0a6b4a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $814c115a3a0a6b4a$var$warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref (to) {
            return typeof to === "string" ? to : $814c115a3a0a6b4a$export$fe53371bee54353d(to);
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $814c115a3a0a6b4a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation
            });
        },
        replace (to, state) {
            action = $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation
            });
        },
        go (delta) {
            action = $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Pop;
            index = clampIndex(index + delta);
            if (listener) listener({
                action: action,
                location: getCurrentLocation()
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $814c115a3a0a6b4a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $814c115a3a0a6b4a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $814c115a3a0a6b4a$export$fe53371bee54353d(to);
    }
    return $814c115a3a0a6b4a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $814c115a3a0a6b4a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $814c115a3a0a6b4a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $814c115a3a0a6b4a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $814c115a3a0a6b4a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $814c115a3a0a6b4a$var$warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $814c115a3a0a6b4a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region UTILS
////////////////////////////////////////////////////////////////////////////////
function $814c115a3a0a6b4a$var$warning$1(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $814c115a3a0a6b4a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $814c115a3a0a6b4a$var$getHistoryState(location) {
    return {
        usr: location.state,
        key: location.key
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $814c115a3a0a6b4a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $814c115a3a0a6b4a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $814c115a3a0a6b4a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $814c115a3a0a6b4a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $814c115a3a0a6b4a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $814c115a3a0a6b4a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $814c115a3a0a6b4a$var$createURL(location) {
    // window.location.origin is "null" (the literal string value) in Firefox
    // under certain conditions, notably when serving from a local HTML file
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
    let base = typeof window !== "undefined" && typeof window.location !== "undefined" && window.location.origin !== "null" ? window.location.origin : "unknown://unknown";
    let href = typeof location === "string" ? location : $814c115a3a0a6b4a$export$fe53371bee54353d(location);
    return new URL(href, base);
}
function $814c115a3a0a6b4a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function handlePop() {
        action = $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Pop;
        if (listener) listener({
            action: action,
            location: history.location
        });
    }
    function push(to, state) {
        action = $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Push;
        let location = $814c115a3a0a6b4a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        let historyState = $814c115a3a0a6b4a$var$getHistoryState(location);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location
        });
    }
    function replace(to, state) {
        action = $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Replace;
        let location = $814c115a3a0a6b4a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        let historyState = $814c115a3a0a6b4a$var$getHistoryState(location);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location
        });
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($814c115a3a0a6b4a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($814c115a3a0a6b4a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = $814c115a3a0a6b4a$var$createURL(typeof to === "string" ? to : $814c115a3a0a6b4a$export$fe53371bee54353d(to));
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $814c115a3a0a6b4a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($814c115a3a0a6b4a$var$ResultType || ($814c115a3a0a6b4a$var$ResultType = {}));
function $814c115a3a0a6b4a$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $814c115a3a0a6b4a$export$4a6d22b32134ea5d(routes, parentPath, allIds) {
    if (parentPath === void 0) parentPath = [];
    if (allIds === void 0) allIds = new Set();
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $814c115a3a0a6b4a$export$f5708dca728d7177(route.index !== true || !route.children, "Cannot specify children on an index route");
        $814c115a3a0a6b4a$export$f5708dca728d7177(!allIds.has(id), "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        allIds.add(id);
        if ($814c115a3a0a6b4a$var$isIndexRoute(route)) {
            let indexRoute = $814c115a3a0a6b4a$var$_extends({}, route, {
                id: id
            });
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $814c115a3a0a6b4a$var$_extends({}, route, {
                id: id,
                children: route.children ? $814c115a3a0a6b4a$export$4a6d22b32134ea5d(route.children, treePath, allIds) : undefined
            });
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/match-routes
 */ function $814c115a3a0a6b4a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $814c115a3a0a6b4a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $814c115a3a0a6b4a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $814c115a3a0a6b4a$var$flattenRoutes(routes);
    $814c115a3a0a6b4a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $814c115a3a0a6b4a$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $814c115a3a0a6b4a$var$safelyDecodeURI(pathname));
    return matches;
}
function $814c115a3a0a6b4a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    routes.forEach((route, index)=>{
        let meta = {
            relativePath: route.path || "",
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $814c115a3a0a6b4a$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $814c115a3a0a6b4a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $814c115a3a0a6b4a$export$f5708dca728d7177(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $814c115a3a0a6b4a$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $814c115a3a0a6b4a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $814c115a3a0a6b4a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $814c115a3a0a6b4a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $814c115a3a0a6b4a$var$paramRe = /^:\w+$/;
const $814c115a3a0a6b4a$var$dynamicSegmentValue = 3;
const $814c115a3a0a6b4a$var$indexRouteValue = 2;
const $814c115a3a0a6b4a$var$emptySegmentValue = 1;
const $814c115a3a0a6b4a$var$staticSegmentValue = 10;
const $814c115a3a0a6b4a$var$splatPenalty = -2;
const $814c115a3a0a6b4a$var$isSplat = (s)=>s === "*";
function $814c115a3a0a6b4a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($814c115a3a0a6b4a$var$isSplat)) initialScore += $814c115a3a0a6b4a$var$splatPenalty;
    if (index) initialScore += $814c115a3a0a6b4a$var$indexRouteValue;
    return segments.filter((s)=>!$814c115a3a0a6b4a$var$isSplat(s)).reduce((score, segment)=>score + ($814c115a3a0a6b4a$var$paramRe.test(segment) ? $814c115a3a0a6b4a$var$dynamicSegmentValue : segment === "" ? $814c115a3a0a6b4a$var$emptySegmentValue : $814c115a3a0a6b4a$var$staticSegmentValue), initialScore);
}
function $814c115a3a0a6b4a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $814c115a3a0a6b4a$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $814c115a3a0a6b4a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $814c115a3a0a6b4a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $814c115a3a0a6b4a$export$a5c6d149b50c1d86($814c115a3a0a6b4a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $814c115a3a0a6b4a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/generate-path
 */ function $814c115a3a0a6b4a$export$82476f982757e71e(path, params) {
    if (params === void 0) params = {};
    return path.replace(/:(\w+)/g, (_, key)=>{
        $814c115a3a0a6b4a$export$f5708dca728d7177(params[key] != null, "Missing \":" + key + "\" param");
        return params[key];
    }).replace(/(\/?)\*/, (_, prefix, __, str)=>{
        const star = "*";
        if (params[star] == null) // If no splat was provided, trim the trailing slash _unless_ it's
        // the entire path
        return str === "/*" ? "/" : "";
         // Apply the splat
        return "" + prefix + params[star];
    });
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/match-path
 */ function $814c115a3a0a6b4a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $814c115a3a0a6b4a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $814c115a3a0a6b4a$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $814c115a3a0a6b4a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $814c115a3a0a6b4a$export$491112666e282270(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $814c115a3a0a6b4a$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $814c115a3a0a6b4a$export$491112666e282270(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $814c115a3a0a6b4a$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $814c115a3a0a6b4a$export$491112666e282270(false, "The value for the URL param \"" + paramName + "\" will not be decoded because" + (" the string \"" + value + "\" is a malformed URL segment. This is probably") + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $814c115a3a0a6b4a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
function $814c115a3a0a6b4a$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
/**
 * @private
 */ function $814c115a3a0a6b4a$export$491112666e282270(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/resolve-path
 */ function $814c115a3a0a6b4a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $814c115a3a0a6b4a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $814c115a3a0a6b4a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $814c115a3a0a6b4a$var$normalizeSearch(search),
        hash: $814c115a3a0a6b4a$var$normalizeHash(hash)
    };
}
function $814c115a3a0a6b4a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $814c115a3a0a6b4a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $814c115a3a0a6b4a$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $814c115a3a0a6b4a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $814c115a3a0a6b4a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $814c115a3a0a6b4a$var$_extends({}, toArg);
        $814c115a3a0a6b4a$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $814c115a3a0a6b4a$var$getInvalidPathError("?", "pathname", "search", to));
        $814c115a3a0a6b4a$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $814c115a3a0a6b4a$var$getInvalidPathError("#", "pathname", "hash", to));
        $814c115a3a0a6b4a$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $814c115a3a0a6b4a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $814c115a3a0a6b4a$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $814c115a3a0a6b4a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $814c115a3a0a6b4a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $814c115a3a0a6b4a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $814c115a3a0a6b4a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $814c115a3a0a6b4a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $814c115a3a0a6b4a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $814c115a3a0a6b4a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $814c115a3a0a6b4a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $814c115a3a0a6b4a$export$42a99a7a4bc0e76a extends Error {
}
class $814c115a3a0a6b4a$var$DeferredData {
    constructor(data){
        this.pendingKeys = new Set();
        this.subscriber = undefined;
        $814c115a3a0a6b4a$export$f5708dca728d7177(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $814c115a3a0a6b4a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.pendingKeys.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $814c115a3a0a6b4a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeys.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        const subscriber = this.subscriber;
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            subscriber && subscriber(false);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        subscriber && subscriber(false);
        return data;
    }
    subscribe(fn) {
        this.subscriber = fn;
    }
    cancel() {
        this.controller.abort();
        this.pendingKeys.forEach((v, k)=>this.pendingKeys.delete(k));
        let subscriber = this.subscriber;
        subscriber && subscriber(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeys.size === 0;
    }
    get unwrappedData() {
        $814c115a3a0a6b4a$export$f5708dca728d7177(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $814c115a3a0a6b4a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
}
function $814c115a3a0a6b4a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $814c115a3a0a6b4a$var$unwrapTrackedPromise(value) {
    if (!$814c115a3a0a6b4a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
function $814c115a3a0a6b4a$export$260e5c0943f31606(data) {
    return new $814c115a3a0a6b4a$var$DeferredData(data);
}
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $814c115a3a0a6b4a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $814c115a3a0a6b4a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $814c115a3a0a6b4a$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response throw from an action/loader
 */ function $814c115a3a0a6b4a$export$972111febbeef05b(e) {
    return e instanceof $814c115a3a0a6b4a$export$acf1a680051f5031;
}
const $814c115a3a0a6b4a$var$validActionMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $814c115a3a0a6b4a$var$validActionMethods = new Set($814c115a3a0a6b4a$var$validActionMethodsArr);
const $814c115a3a0a6b4a$var$validRequestMethodsArr = [
    "get",
    ...$814c115a3a0a6b4a$var$validActionMethodsArr
];
const $814c115a3a0a6b4a$var$validRequestMethods = new Set($814c115a3a0a6b4a$var$validRequestMethodsArr);
const $814c115a3a0a6b4a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $814c115a3a0a6b4a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $814c115a3a0a6b4a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $814c115a3a0a6b4a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $814c115a3a0a6b4a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $814c115a3a0a6b4a$var$isServer = !$814c115a3a0a6b4a$var$isBrowser; //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $814c115a3a0a6b4a$export$baddd0131ee8c05b(init) {
    $814c115a3a0a6b4a$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let dataRoutes = $814c115a3a0a6b4a$export$4a6d22b32134ea5d(init.routes); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    let initialScrollRestored = false;
    let initialMatches = $814c115a3a0a6b4a$export$2708184779ceb39d(dataRoutes, init.history.location, init.basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $814c115a3a0a6b4a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $814c115a3a0a6b4a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = !initialMatches.some((m)=>m.route.loader) || init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $814c115a3a0a6b4a$export$ed3e14b2f9e105d0,
        restoreScrollPosition: null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidate()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations from their actions
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location } = _ref;
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        if (!state.initialized) startNavigation($814c115a3a0a6b4a$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $814c115a3a0a6b4a$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _state$navigation$for;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a submission
        // - We're past the submitting state and into the loading state
        // - The location we've finished loading is different from the submission
        //   location, indicating we redirected from the action (avoids false
        //   positives for loading/submissionRedirect when actionData returned
        //   on a prior submission)
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && state.navigation.state === "loading" && ((_state$navigation$for = state.navigation.formAction) == null ? void 0 : _state$navigation$for.split("?")[0]) === location.pathname; // Always preserve any existing loaderData from re-used routes
        let newLoaderData = newState.loaderData ? {
            loaderData: $814c115a3a0a6b4a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [])
        } : {};
        updateState($814c115a3a0a6b4a$var$_extends({}, isActionReload ? {} : {
            actionData: null
        }, newState, newLoaderData, {
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $814c115a3a0a6b4a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            // Don't restore on submission navigations
            restoreScrollPosition: state.navigation.formData ? false : getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: pendingPreventScrollReset
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let { path: path, submission: submission, error: error } = $814c115a3a0a6b4a$var$normalizeNavigateOptions(to, opts);
        let location = $814c115a3a0a6b4a$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        location = $814c115a3a0a6b4a$var$_extends({}, location, init.history.encodeLocation(location));
        let historyAction = (opts && opts.replace) === true || submission != null ? $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Replace : $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Push;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        return await startNavigation(historyAction, location, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $814c115a3a0a6b4a$export$2708184779ceb39d(dataRoutes, location, init.basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $814c115a3a0a6b4a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $814c115a3a0a6b4a$var$getShortCircuitMatches(dataRoutes); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change
        if ($814c115a3a0a6b4a$var$isHashChangeOnly(state.location, location)) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $814c115a3a0a6b4a$var$createRequest(location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$814c115a3a0a6b4a$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $814c115a3a0a6b4a$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation;
        } // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: matches,
            loaderData: loaderData,
            errors: errors
        });
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = $814c115a3a0a6b4a$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = $814c115a3a0a6b4a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action) result = {
            type: $814c115a3a0a6b4a$var$ResultType.error,
            error: $814c115a3a0a6b4a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $814c115a3a0a6b4a$var$callLoaderOrAction("action", request, actionMatch, matches, router.basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($814c115a3a0a6b4a$var$isRedirectResult(result)) {
            await startRedirectNavigation(state, result, opts && opts.replace === true);
            return {
                shortCircuited: true
            };
        }
        if ($814c115a3a0a6b4a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $814c115a3a0a6b4a$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($814c115a3a0a6b4a$var$isDeferredResult(result)) throw new Error("defer() is not supported in actions");
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = {
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            };
            loadingNavigation = navigation;
        }
        let [matchesToLoad, revalidatingFetchers] = $814c115a3a0a6b4a$var$getMatchesToLoad(state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            completeNavigation(location, {
                matches: matches,
                loaderData: $814c115a3a0a6b4a$var$mergeLoaderData(state.loaderData, {}, matches),
                // Commit pending error if we're short circuiting
                errors: pendingError || null,
                actionData: pendingActionData || null
            });
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((_ref2)=>{
                let [key] = _ref2;
                let fetcher = state.fetchers.get(key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined
                };
                state.fetchers.set(key, revalidatingFetcher);
            });
            updateState($814c115a3a0a6b4a$var$_extends({
                navigation: loadingNavigation,
                actionData: pendingActionData || state.actionData || null
            }, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((_ref3)=>{
            let [key] = _ref3;
            return fetchControllers.set(key, pendingNavigationController);
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        revalidatingFetchers.forEach((_ref4)=>{
            let [key] = _ref4;
            return fetchControllers.delete(key);
        }); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $814c115a3a0a6b4a$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, replace);
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $814c115a3a0a6b4a$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        return $814c115a3a0a6b4a$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $814c115a3a0a6b4a$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($814c115a3a0a6b4a$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let matches = $814c115a3a0a6b4a$export$2708184779ceb39d(dataRoutes, href, init.basename);
        if (!matches) {
            setFetcherError(key, routeId, $814c115a3a0a6b4a$var$getInternalRouterError(404, {
                pathname: href
            }));
            return;
        }
        let { path: path, submission: submission } = $814c115a3a0a6b4a$var$normalizeNavigateOptions(href, opts, true);
        let match = $814c115a3a0a6b4a$var$getTargetMatch(matches, path);
        if (submission) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, [
            path,
            match,
            matches
        ]);
        handleFetcherLoader(key, routeId, path, match, matches);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action) {
            let error = $814c115a3a0a6b4a$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $814c115a3a0a6b4a$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $814c115a3a0a6b4a$var$createRequest(path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $814c115a3a0a6b4a$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, router.basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($814c115a3a0a6b4a$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $814c115a3a0a6b4a$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult);
        } // Process any non-redirect errors thrown
        if ($814c115a3a0a6b4a$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($814c115a3a0a6b4a$var$isDeferredResult(actionResult)) $814c115a3a0a6b4a$export$f5708dca728d7177(false, "defer() is not supported in actions");
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $814c115a3a0a6b4a$var$createRequest(nextLocation, abortController.signal);
        let matches = state.navigation.state !== "idle" ? $814c115a3a0a6b4a$export$2708184779ceb39d(dataRoutes, state.navigation.location, init.basename) : state.matches;
        $814c115a3a0a6b4a$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $814c115a3a0a6b4a$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $814c115a3a0a6b4a$var$getMatchesToLoad(state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, {
            [match.route.id]: actionResult.data
        }, undefined, fetchLoadMatches); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((_ref5)=>{
            let [staleKey] = _ref5;
            return staleKey !== key;
        }).forEach((_ref6)=>{
            let [staleKey] = _ref6;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            fetchControllers.set(staleKey, abortController);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((_ref7)=>{
            let [staleKey] = _ref7;
            return fetchControllers.delete(staleKey);
        });
        let redirect = $814c115a3a0a6b4a$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
         // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $814c115a3a0a6b4a$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $814c115a3a0a6b4a$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($814c115a3a0a6b4a$var$_extends({
                errors: errors,
                loaderData: $814c115a3a0a6b4a$var$mergeLoaderData(state.loaderData, loaderData, matches)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            data: existingFetcher && existingFetcher.data
        };
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $814c115a3a0a6b4a$var$createRequest(path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $814c115a3a0a6b4a$var$callLoaderOrAction("loader", fetchRequest, match, matches, router.basename); // Deferred isn't supported or fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($814c115a3a0a6b4a$var$isDeferredResult(result)) result = await $814c115a3a0a6b4a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by ou our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($814c115a3a0a6b4a$var$isRedirectResult(result)) {
            await startRedirectNavigation(state, result);
            return;
        } // Process any non-redirect errors thrown
        if ($814c115a3a0a6b4a$var$isErrorResult(result)) {
            let boundaryMatch = $814c115a3a0a6b4a$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $814c115a3a0a6b4a$export$f5708dca728d7177(!$814c115a3a0a6b4a$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, replace) {
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $814c115a3a0a6b4a$var$createLocation(state.location, redirect.location);
        $814c115a3a0a6b4a$export$f5708dca728d7177(redirectLocation, "Expected a location on the redirect navigation");
        if (redirect.external && typeof window !== "undefined" && typeof window.location !== "undefined") {
            if (replace) window.location.replace(redirect.location);
            else window.location.assign(redirect.location);
            return;
        } // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Replace : $814c115a3a0a6b4a$export$e19cd5f9376f8cee.Push;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, formData: formData } = state.navigation; // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($814c115a3a0a6b4a$var$redirectPreserveMethodStatusCodes.has(redirect.status) && formMethod && $814c115a3a0a6b4a$var$isSubmissionMethod(formMethod) && formEncType && formData) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: {
                formMethod: formMethod,
                formAction: redirect.location,
                formEncType: formEncType,
                formData: formData
            }
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: formMethod || undefined,
                formAction: formAction || undefined,
                formEncType: formEncType || undefined,
                formData: formData || undefined
            }
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$814c115a3a0a6b4a$var$callLoaderOrAction("loader", request, match, matches, router.basename)),
            ...fetchersToLoad.map((_ref8)=>{
                let [, href, match, fetchMatches] = _ref8;
                return $814c115a3a0a6b4a$var$callLoaderOrAction("loader", $814c115a3a0a6b4a$var$createRequest(href, request.signal), match, fetchMatches, router.basename);
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $814c115a3a0a6b4a$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, request.signal, false, state.loaderData),
            $814c115a3a0a6b4a$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((_ref9)=>{
                let [, , match] = _ref9;
                return match;
            }), fetcherResults, request.signal, true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $814c115a3a0a6b4a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $814c115a3a0a6b4a$export$f5708dca728d7177(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $814c115a3a0a6b4a$export$f5708dca728d7177(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
            }
        }
        markFetchersDone(doneKeys);
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $814c115a3a0a6b4a$export$f5708dca728d7177(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $814c115a3a0a6b4a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$814c115a3a0a6b4a$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$814c115a3a0a6b4a$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    router = {
        get basename () {
            return init.basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
function $814c115a3a0a6b4a$export$4791cb6e2df78547(routes, opts) {
    $814c115a3a0a6b4a$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to unstable_createStaticHandler");
    let dataRoutes = $814c115a3a0a6b4a$export$4a6d22b32134ea5d(routes);
    let basename = (opts ? opts.basename : null) || "/";
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request) {
        let url = new URL(request.url);
        let method = request.method.toLowerCase();
        let location = $814c115a3a0a6b4a$var$createLocation("", $814c115a3a0a6b4a$export$fe53371bee54353d(url), null, "default");
        let matches = $814c115a3a0a6b4a$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$814c115a3a0a6b4a$var$isValidMethod(method) && method !== "head") {
            let error = $814c115a3a0a6b4a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $814c115a3a0a6b4a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        } else if (!matches) {
            let error = $814c115a3a0a6b4a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $814c115a3a0a6b4a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let result = await queryImpl(request, location, matches);
        if (result instanceof Response) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $814c115a3a0a6b4a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, routeId) {
        let url = new URL(request.url);
        let method = request.method.toLowerCase();
        let location = $814c115a3a0a6b4a$var$createLocation("", $814c115a3a0a6b4a$export$fe53371bee54353d(url), null, "default");
        let matches = $814c115a3a0a6b4a$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$814c115a3a0a6b4a$var$isValidMethod(method) && method !== "head") throw $814c115a3a0a6b4a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $814c115a3a0a6b4a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $814c115a3a0a6b4a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $814c115a3a0a6b4a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $814c115a3a0a6b4a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, match);
        if (result instanceof Response) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
         // Pick off the right state value to return
        let routeData = [
            result.actionData,
            result.loaderData
        ].find((v)=>v);
        return Object.values(routeData || {})[0];
    }
    async function queryImpl(request, location, matches, routeMatch) {
        $814c115a3a0a6b4a$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($814c115a3a0a6b4a$var$isSubmissionMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $814c115a3a0a6b4a$var$getTargetMatch(matches, location), routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, routeMatch);
            return result instanceof Response ? result : $814c115a3a0a6b4a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($814c115a3a0a6b4a$var$isQueryRouteResponse(e)) {
                if (e.type === $814c115a3a0a6b4a$var$ResultType.error && !$814c115a3a0a6b4a$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            } // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($814c115a3a0a6b4a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, isRouteRequest) {
        let result;
        if (!actionMatch.route.action) {
            let error = $814c115a3a0a6b4a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: $814c115a3a0a6b4a$var$createURL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $814c115a3a0a6b4a$var$ResultType.error,
                error: error
            };
        } else {
            result = await $814c115a3a0a6b4a$var$callLoaderOrAction("action", request, actionMatch, matches, basename, true, isRouteRequest);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($814c115a3a0a6b4a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($814c115a3a0a6b4a$var$isDeferredResult(result)) throw new Error("defer() is not supported in actions");
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($814c115a3a0a6b4a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if ($814c115a3a0a6b4a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $814c115a3a0a6b4a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, undefined, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return $814c115a3a0a6b4a$var$_extends({}, context, {
                statusCode: $814c115a3a0a6b4a$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $814c115a3a0a6b4a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(request, matches);
        return $814c115a3a0a6b4a$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $814c115a3a0a6b4a$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader)) throw $814c115a3a0a6b4a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: $814c115a3a0a6b4a$var$createURL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $814c115a3a0a6b4a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader); // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$814c115a3a0a6b4a$var$callLoaderOrAction("loader", request, match, matches, basename, true, isRouteRequest))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        } // Can't do anything with these without the Remix side of things, so just
        // cancel them for now
        results.forEach((result)=>{
            if ($814c115a3a0a6b4a$var$isDeferredResult(result)) result.deferredData.cancel();
        }); // Process and commit output from loaders
        let context = $814c115a3a0a6b4a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError);
        return $814c115a3a0a6b4a$var$_extends({}, context, {
            matches: matches
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $814c115a3a0a6b4a$export$fec11da027c70692(routes, context, error) {
    let newContext = $814c115a3a0a6b4a$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $814c115a3a0a6b4a$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $814c115a3a0a6b4a$var$normalizeNavigateOptions(to, opts, isFetcher) {
    if (isFetcher === void 0) isFetcher = false;
    let path = typeof to === "string" ? to : $814c115a3a0a6b4a$export$fe53371bee54353d(to); // Return location verbatim on non-submission navigations
    if (!opts || !$814c115a3a0a6b4a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$814c115a3a0a6b4a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $814c115a3a0a6b4a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    if (opts.formMethod && $814c115a3a0a6b4a$var$isSubmissionMethod(opts.formMethod)) return {
        path: path,
        submission: {
            formMethod: opts.formMethod,
            formAction: $814c115a3a0a6b4a$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        }
    };
     // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $814c115a3a0a6b4a$export$8ccf933b0513f8d0(path);
    try {
        let searchParams = $814c115a3a0a6b4a$var$convertFormDataToSearchParams(opts.formData); // Since fetcher GET submissions only run a single loader (as opposed to
        // navigation GET submissions which run all loaders), we need to preserve
        // any incoming ?index params
        if (isFetcher && parsedPath.search && $814c115a3a0a6b4a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
        parsedPath.search = "?" + searchParams;
    } catch (e) {
        return {
            path: path,
            error: $814c115a3a0a6b4a$var$getInternalRouterError(400)
        };
    }
    return {
        path: $814c115a3a0a6b4a$export$fe53371bee54353d(parsedPath)
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $814c115a3a0a6b4a$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $814c115a3a0a6b4a$var$getMatchesToLoad(state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : null; // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $814c115a3a0a6b4a$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>match.route.loader != null && ($814c115a3a0a6b4a$var$isNewLoader(state.loaderData, state.matches[index], match) || // If this route had a pending deferred cancelled it must be revalidated
        cancelledDeferredRoutes.some((id)=>id === match.route.id) || $814c115a3a0a6b4a$var$shouldRevalidateLoader(state.location, state.matches[index], submission, location, match, isRevalidationRequired, actionResult))); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches && fetchLoadMatches.forEach((_ref10, key)=>{
        let [href, match, fetchMatches] = _ref10;
        // This fetcher was cancelled from a prior action submission - force reload
        if (cancelledFetcherLoads.includes(key)) revalidatingFetchers.push([
            key,
            href,
            match,
            fetchMatches
        ]);
        else if (isRevalidationRequired) {
            let shouldRevalidate = $814c115a3a0a6b4a$var$shouldRevalidateLoader(href, match, submission, href, match, isRevalidationRequired, actionResult);
            if (shouldRevalidate) revalidatingFetchers.push([
                key,
                href,
                match,
                fetchMatches
            ]);
        }
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $814c115a3a0a6b4a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $814c115a3a0a6b4a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $814c115a3a0a6b4a$var$shouldRevalidateLoader(currentLocation, currentMatch, submission, location, match, isRevalidationRequired, actionResult) {
    let currentUrl = $814c115a3a0a6b4a$var$createURL(currentLocation);
    let currentParams = currentMatch.params;
    let nextUrl = $814c115a3a0a6b4a$var$createURL(location);
    let nextParams = match.params; // This is the default implementation as to when we revalidate.  If the route
    // provides it's own implementation, then we give them full control but
    // provide this value so they can leverage it if needed after they check
    // their own specific use cases
    // Note that fetchers always provide the same current/next locations so the
    // URL-based checks here don't apply to fetcher shouldRevalidate calls
    let defaultShouldRevalidate = $814c115a3a0a6b4a$var$isNewRouteInstance(currentMatch, match) || // Clicked the same link, resubmitted a GET form
    currentUrl.toString() === nextUrl.toString() || // Search params affect all loaders
    currentUrl.search !== nextUrl.search || // Forced revalidation due to submission, useRevalidate, or X-Remix-Revalidate
    isRevalidationRequired;
    if (match.route.shouldRevalidate) {
        let routeChoice = match.route.shouldRevalidate($814c115a3a0a6b4a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentParams,
            nextUrl: nextUrl,
            nextParams: nextParams
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate
        }));
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return defaultShouldRevalidate;
}
async function $814c115a3a0a6b4a$var$callLoaderOrAction(type, request, match, matches, basename, isStaticRequest, isRouteRequest) {
    if (basename === void 0) basename = "/";
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result; // Setup a promise we can race against so that abort signals short circuit
    let reject;
    let abortPromise = new Promise((_, r)=>reject = r);
    let onReject = ()=>reject();
    request.signal.addEventListener("abort", onReject);
    try {
        let handler = match.route[type];
        $814c115a3a0a6b4a$export$f5708dca728d7177(handler, "Could not find the " + type + " to run on the \"" + match.route.id + "\" route");
        result = await Promise.race([
            handler({
                request: request,
                params: match.params
            }),
            abortPromise
        ]);
        $814c115a3a0a6b4a$export$f5708dca728d7177(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $814c115a3a0a6b4a$var$ResultType.error;
        result = e;
    } finally{
        request.signal.removeEventListener("abort", onReject);
    }
    if (result instanceof Response) {
        let status = result.status; // Process redirects
        if ($814c115a3a0a6b4a$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $814c115a3a0a6b4a$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header"); // Check if this an external redirect that goes to a new origin
            let external = $814c115a3a0a6b4a$var$createURL(location).origin !== $814c115a3a0a6b4a$var$createURL("/").origin; // Support relative routing in internal redirects
            if (!external) {
                let activeMatches = matches.slice(0, matches.indexOf(match) + 1);
                let routePathnames = $814c115a3a0a6b4a$export$90ba53ce1c7fdff2(activeMatches).map((match)=>match.pathnameBase);
                let requestPath = $814c115a3a0a6b4a$var$createURL(request.url).pathname;
                let resolvedLocation = $814c115a3a0a6b4a$export$cae722b0cc860f13(location, routePathnames, requestPath);
                $814c115a3a0a6b4a$export$f5708dca728d7177($814c115a3a0a6b4a$export$fe53371bee54353d(resolvedLocation), "Unable to resolve redirect location: " + location); // Prepend the basename to the redirect location if we have one
                if (basename) {
                    let path = resolvedLocation.pathname;
                    resolvedLocation.pathname = path === "/" ? basename : $814c115a3a0a6b4a$export$86d9a7913e44197e([
                        basename,
                        path
                    ]);
                }
                location = $814c115a3a0a6b4a$export$fe53371bee54353d(resolvedLocation);
            } // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $814c115a3a0a6b4a$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                external: external
            };
        } // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $814c115a3a0a6b4a$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type");
        if (contentType && contentType.startsWith("application/json")) data = await result.json();
        else data = await result.text();
        if (resultType === $814c115a3a0a6b4a$var$ResultType.error) return {
            type: resultType,
            error: new $814c115a3a0a6b4a$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $814c115a3a0a6b4a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $814c115a3a0a6b4a$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if (result instanceof $814c115a3a0a6b4a$var$DeferredData) return {
        type: $814c115a3a0a6b4a$var$ResultType.deferred,
        deferredData: result
    };
    return {
        type: $814c115a3a0a6b4a$var$ResultType.data,
        data: result
    };
}
function $814c115a3a0a6b4a$var$createRequest(location, signal, submission) {
    let url = $814c115a3a0a6b4a$var$createURL($814c115a3a0a6b4a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission) {
        let { formMethod: formMethod, formEncType: formEncType, formData: formData } = submission;
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $814c115a3a0a6b4a$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $814c115a3a0a6b4a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries()){
        $814c115a3a0a6b4a$export$f5708dca728d7177(typeof value === "string", 'File inputs are not supported with encType "application/x-www-form-urlencoded", please use "multipart/form-data" instead.');
        searchParams.append(key, value);
    }
    return searchParams;
}
function $814c115a3a0a6b4a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $814c115a3a0a6b4a$export$f5708dca728d7177(!$814c115a3a0a6b4a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($814c115a3a0a6b4a$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $814c115a3a0a6b4a$var$findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = Object.assign(errors || {}, {
                [boundaryMatch.route.id]: error
            }); // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $814c115a3a0a6b4a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($814c115a3a0a6b4a$var$isDeferredResult(result)) {
            activeDeferreds && activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data; // TODO: Add statusCode/headers once we wire up streaming in Remix
        } else {
            loaderData[id] = result.data; // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here
    if (pendingError) errors = pendingError;
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $814c115a3a0a6b4a$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $814c115a3a0a6b4a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let [key, , match] = revalidatingFetchers[index];
        $814c115a3a0a6b4a$export$f5708dca728d7177(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if ($814c115a3a0a6b4a$var$isErrorResult(result)) {
            let boundaryMatch = $814c115a3a0a6b4a$var$findNearestBoundary(state.matches, match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $814c115a3a0a6b4a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($814c115a3a0a6b4a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        throw new Error("Unhandled fetcher revalidation redirect");
        else if ($814c115a3a0a6b4a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        throw new Error("Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $814c115a3a0a6b4a$var$mergeLoaderData(loaderData, newLoaderData, matches) {
    let mergedLoaderData = $814c115a3a0a6b4a$var$_extends({}, newLoaderData);
    matches.forEach((match)=>{
        let id = match.route.id;
        if (newLoaderData[id] === undefined && loaderData[id] !== undefined) mergedLoaderData[id] = loaderData[id];
    });
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $814c115a3a0a6b4a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $814c115a3a0a6b4a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $814c115a3a0a6b4a$var$getInternalRouterError(status, _temp) {
    let { pathname: pathname, routeId: routeId, method: method, message: message } = _temp === void 0 ? {} : _temp;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else errorMessage = "Cannot submit binary form data using GET";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $814c115a3a0a6b4a$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $814c115a3a0a6b4a$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($814c115a3a0a6b4a$var$isRedirectResult(result)) return result;
    }
}
function $814c115a3a0a6b4a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $814c115a3a0a6b4a$export$8ccf933b0513f8d0(path) : path;
    return $814c115a3a0a6b4a$export$fe53371bee54353d($814c115a3a0a6b4a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $814c115a3a0a6b4a$var$isHashChangeOnly(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash !== b.hash;
}
function $814c115a3a0a6b4a$var$isDeferredResult(result) {
    return result.type === $814c115a3a0a6b4a$var$ResultType.deferred;
}
function $814c115a3a0a6b4a$var$isErrorResult(result) {
    return result.type === $814c115a3a0a6b4a$var$ResultType.error;
}
function $814c115a3a0a6b4a$var$isRedirectResult(result) {
    return (result && result.type) === $814c115a3a0a6b4a$var$ResultType.redirect;
}
function $814c115a3a0a6b4a$var$isRedirectResponse(result) {
    if (!(result instanceof Response)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $814c115a3a0a6b4a$var$isQueryRouteResponse(obj) {
    return obj && obj.response instanceof Response && (obj.type === $814c115a3a0a6b4a$var$ResultType.data || $814c115a3a0a6b4a$var$ResultType.error);
}
function $814c115a3a0a6b4a$var$isValidMethod(method) {
    return $814c115a3a0a6b4a$var$validRequestMethods.has(method);
}
function $814c115a3a0a6b4a$var$isSubmissionMethod(method) {
    return $814c115a3a0a6b4a$var$validActionMethods.has(method);
}
async function $814c115a3a0a6b4a$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signal, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$814c115a3a0a6b4a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($814c115a3a0a6b4a$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $814c115a3a0a6b4a$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
            if (result) results[index] = result || results[index];
        });
    }
}
async function $814c115a3a0a6b4a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $814c115a3a0a6b4a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $814c115a3a0a6b4a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $814c115a3a0a6b4a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $814c115a3a0a6b4a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $814c115a3a0a6b4a$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $814c115a3a0a6b4a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $814c115a3a0a6b4a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $814c115a3a0a6b4a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $814c115a3a0a6b4a$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

/**
 * React Router v6.4.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $6fFrj = parcelRequire("6fFrj");
function $990f835fb2356f36$var$_extends() {
    $990f835fb2356f36$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $990f835fb2356f36$var$_extends.apply(this, arguments);
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function $990f835fb2356f36$var$isPolyfill(x, y) {
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
    ;
}
const $990f835fb2356f36$var$is = typeof Object.is === "function" ? Object.is : $990f835fb2356f36$var$isPolyfill; // Intentionally not using named imports because Rollup uses dynamic
// dispatch for CommonJS interop named imports.
const { useState: $990f835fb2356f36$var$useState, useEffect: $990f835fb2356f36$var$useEffect, useLayoutEffect: $990f835fb2356f36$var$useLayoutEffect, useDebugValue: $990f835fb2356f36$var$useDebugValue } = $6fFrj;
let $990f835fb2356f36$var$didWarnOld18Alpha = false;
let $990f835fb2356f36$var$didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.
function $990f835fb2356f36$var$useSyncExternalStore$2(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    const value = getSnapshot();
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    const [{ inst: inst }, forceUpdate] = $990f835fb2356f36$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }); // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    $990f835fb2356f36$var$useLayoutEffect(()=>{
        inst.value = value;
        inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($990f835fb2356f36$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $990f835fb2356f36$var$useEffect(()=>{
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($990f835fb2356f36$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        const handleStoreChange = ()=>{
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($990f835fb2356f36$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    $990f835fb2356f36$var$useDebugValue(value);
    return value;
}
function $990f835fb2356f36$var$checkIfSnapshotChanged(inst) {
    const latestGetSnapshot = inst.getSnapshot;
    const prevValue = inst.value;
    try {
        const nextValue = latestGetSnapshot();
        return !$990f835fb2356f36$var$is(prevValue, nextValue);
    } catch (error) {
        return true;
    }
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */ function $990f835fb2356f36$var$useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
    // Note: The shim does not use getServerSnapshot, because pre-18 versions of
    // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    return getSnapshot();
}
/**
 * Inlined into the react-router repo since use-sync-external-store does not
 * provide a UMD-compatible package, so we need this to be able to distribute
 * UMD react-router bundles
 */ const $990f835fb2356f36$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $990f835fb2356f36$var$isServerEnvironment = !$990f835fb2356f36$var$canUseDOM;
const $990f835fb2356f36$var$shim = $990f835fb2356f36$var$isServerEnvironment ? $990f835fb2356f36$var$useSyncExternalStore$1 : $990f835fb2356f36$var$useSyncExternalStore$2;
const $990f835fb2356f36$var$useSyncExternalStore = "useSyncExternalStore" in $6fFrj ? ((module)=>module.useSyncExternalStore)($6fFrj) : $990f835fb2356f36$var$shim;
// Contexts for data routers
const $990f835fb2356f36$export$30522a91b9deeaa0 = /*#__PURE__*/ $6fFrj.createContext(null);
const $990f835fb2356f36$export$3add0d5dce533e2e = /*#__PURE__*/ $6fFrj.createContext(null);
const $990f835fb2356f36$export$145dfa71566a64dc = /*#__PURE__*/ $6fFrj.createContext(null);
const $990f835fb2356f36$var$AwaitContext = /*#__PURE__*/ $6fFrj.createContext(null);
const $990f835fb2356f36$export$26749e8557646306 = /*#__PURE__*/ $6fFrj.createContext(null);
const $990f835fb2356f36$export$c7914228fb69b0f5 = /*#__PURE__*/ $6fFrj.createContext(null);
const $990f835fb2356f36$export$9072aa6dd1f93057 = /*#__PURE__*/ $6fFrj.createContext({
    outlet: null,
    matches: []
});
const $990f835fb2356f36$var$RouteErrorContext = /*#__PURE__*/ $6fFrj.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-href
 */ function $990f835fb2356f36$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$990f835fb2356f36$export$9c954a9d03d32f4a() && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    let { basename: basename, navigator: navigator } = $6fFrj.useContext($990f835fb2356f36$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $990f835fb2356f36$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $814c115a3a0a6b4a$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-in-router-context
 */ function $990f835fb2356f36$export$9c954a9d03d32f4a() {
    return $6fFrj.useContext($990f835fb2356f36$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-location
 */ function $990f835fb2356f36$export$45d76561a5302f2b() {
    !$990f835fb2356f36$export$9c954a9d03d32f4a() && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    return $6fFrj.useContext($990f835fb2356f36$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-navigation-type
 */ function $990f835fb2356f36$export$1b3f31771c5d07c() {
    return $6fFrj.useContext($990f835fb2356f36$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-match
 */ function $990f835fb2356f36$export$6c330e8992e8a295(pattern) {
    !$990f835fb2356f36$export$9c954a9d03d32f4a() && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    let { pathname: pathname } = $990f835fb2356f36$export$45d76561a5302f2b();
    return $6fFrj.useMemo(()=>(0, $814c115a3a0a6b4a$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-navigate
 */ function $990f835fb2356f36$export$9770f232ac06a008() {
    !$990f835fb2356f36$export$9c954a9d03d32f4a() && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    let { basename: basename, navigator: navigator } = $6fFrj.useContext($990f835fb2356f36$export$26749e8557646306);
    let { matches: matches } = $6fFrj.useContext($990f835fb2356f36$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $990f835fb2356f36$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $814c115a3a0a6b4a$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $6fFrj.useRef(false);
    $6fFrj.useEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6fFrj.useCallback(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $814c115a3a0a6b4a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history.  If this is a root navigation, then we
        // navigate to the raw basename which allows the basename to have full
        // control over the presence of a trailing slash on root links
        if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $814c115a3a0a6b4a$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $990f835fb2356f36$var$OutletContext = /*#__PURE__*/ $6fFrj.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/docs/en/v6/hooks/use-outlet-context
 */ function $990f835fb2356f36$export$4138103a3ae699cc() {
    return $6fFrj.useContext($990f835fb2356f36$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-outlet
 */ function $990f835fb2356f36$export$a3be3530d8e40d0b(context) {
    let outlet = $6fFrj.useContext($990f835fb2356f36$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-params
 */ function $990f835fb2356f36$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $6fFrj.useContext($990f835fb2356f36$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-resolved-path
 */ function $990f835fb2356f36$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $6fFrj.useContext($990f835fb2356f36$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $990f835fb2356f36$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $814c115a3a0a6b4a$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $6fFrj.useMemo(()=>(0, $814c115a3a0a6b4a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/docs/en/v6/hooks/use-routes
 */ function $990f835fb2356f36$export$5d3fca4a98652595(routes, locationArg) {
    !$990f835fb2356f36$export$9c954a9d03d32f4a() && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    let { navigator: navigator } = $6fFrj.useContext($990f835fb2356f36$export$26749e8557646306);
    let dataRouterStateContext = $6fFrj.useContext($990f835fb2356f36$export$145dfa71566a64dc);
    let { matches: parentMatches } = $6fFrj.useContext($990f835fb2356f36$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $990f835fb2356f36$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $814c115a3a0a6b4a$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $814c115a3a0a6b4a$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $990f835fb2356f36$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $814c115a3a0a6b4a$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $814c115a3a0a6b4a$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterStateContext || undefined); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $990f835fb2356f36$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $814c115a3a0a6b4a$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $990f835fb2356f36$var$DefaultErrorElement() {
    let error = $990f835fb2356f36$export$ed527bf60f6e05f2();
    let message = (0, $814c115a3a0a6b4a$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, /*#__PURE__*/ $6fFrj.createElement("h2", null, "Unhandled Thrown Error!"), /*#__PURE__*/ $6fFrj.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $6fFrj.createElement("pre", {
        style: preStyles
    }, stack) : null, /*#__PURE__*/ $6fFrj.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ $6fFrj.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own\xA0", /*#__PURE__*/ $6fFrj.createElement("code", {
        style: codeStyles
    }, "errorElement"), " props on\xA0", /*#__PURE__*/ $6fFrj.createElement("code", {
        style: codeStyles
    }, "<Route>")));
}
class $990f835fb2356f36$var$RenderErrorBoundary extends $6fFrj.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location) return {
            error: props.error,
            location: props.location
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        }) : this.props.children;
    }
}
function $990f835fb2356f36$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataStaticRouterContext = $6fFrj.useContext($990f835fb2356f36$export$30522a91b9deeaa0); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataStaticRouterContext && match.route.errorElement) dataStaticRouterContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $990f835fb2356f36$var$_renderMatches(matches, parentMatches, dataRouterState) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) {
        if (dataRouterState != null && dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = dataRouterState == null ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = dataRouterState ? match.route.errorElement || /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$var$DefaultErrorElement, null) : null;
        let getChildren = ()=>/*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: parentMatches.concat(renderedMatches.slice(0, index + 1))
                }
            }, error ? errorElement : match.route.element !== undefined ? match.route.element : outlet); // Only wrap in an error boundary within data router usages when we have an
        // errorElement on this route.  Otherwise let it bubble up to an ancestor
        // errorElement
        return dataRouterState && (match.route.errorElement || index === 0) ? /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            component: errorElement,
            error: error,
            children: getChildren()
        }) : getChildren();
    }, null);
}
var $990f835fb2356f36$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseRevalidator"] = "useRevalidator";
})($990f835fb2356f36$var$DataRouterHook || ($990f835fb2356f36$var$DataRouterHook = {}));
var $990f835fb2356f36$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
})($990f835fb2356f36$var$DataRouterStateHook || ($990f835fb2356f36$var$DataRouterStateHook = {}));
function $990f835fb2356f36$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.";
}
function $990f835fb2356f36$var$useDataRouterContext(hookName) {
    let ctx = $6fFrj.useContext($990f835fb2356f36$export$3add0d5dce533e2e);
    !ctx && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    return ctx;
}
function $990f835fb2356f36$var$useDataRouterState(hookName) {
    let state = $6fFrj.useContext($990f835fb2356f36$export$145dfa71566a64dc);
    !state && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    return state;
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $990f835fb2356f36$export$d0fd4b7106de2769() {
    let state = $990f835fb2356f36$var$useDataRouterState($990f835fb2356f36$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $990f835fb2356f36$export$600dc272ed516c15() {
    let dataRouterContext = $990f835fb2356f36$var$useDataRouterContext($990f835fb2356f36$var$DataRouterHook.UseRevalidator);
    let state = $990f835fb2356f36$var$useDataRouterState($990f835fb2356f36$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $990f835fb2356f36$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $990f835fb2356f36$var$useDataRouterState($990f835fb2356f36$var$DataRouterStateHook.UseMatches);
    return $6fFrj.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $990f835fb2356f36$export$1448a5050d252c4d() {
    let state = $990f835fb2356f36$var$useDataRouterState($990f835fb2356f36$var$DataRouterStateHook.UseLoaderData);
    let route = $6fFrj.useContext($990f835fb2356f36$export$9072aa6dd1f93057);
    !route && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    return state.loaderData[thisRoute.route.id];
}
/**
 * Returns the loaderData for the given routeId
 */ function $990f835fb2356f36$export$fd5d37484eab868d(routeId) {
    let state = $990f835fb2356f36$var$useDataRouterState($990f835fb2356f36$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $990f835fb2356f36$export$fdc00f3f26066d5e() {
    let state = $990f835fb2356f36$var$useDataRouterState($990f835fb2356f36$var$DataRouterStateHook.UseActionData);
    let route = $6fFrj.useContext($990f835fb2356f36$export$9072aa6dd1f93057);
    !route && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * errorElement to display a proper error message.
 */ function $990f835fb2356f36$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $6fFrj.useContext($990f835fb2356f36$var$RouteErrorContext);
    let state = $990f835fb2356f36$var$useDataRouterState($990f835fb2356f36$var$DataRouterStateHook.UseRouteError);
    let route = $6fFrj.useContext($990f835fb2356f36$export$9072aa6dd1f93057);
    let thisRoute = route.matches[route.matches.length - 1]; // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    !route && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    !thisRoute.route.id && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false); // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[thisRoute.route.id];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $990f835fb2356f36$export$78a72ddb39bdd145() {
    let value = $6fFrj.useContext($990f835fb2356f36$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $990f835fb2356f36$export$17f53340677d5831() {
    let value = $6fFrj.useContext($990f835fb2356f36$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
const $990f835fb2356f36$var$alreadyWarned = {};
function $990f835fb2356f36$var$warningOnce(key, cond, message) {
    if (!cond && !$990f835fb2356f36$var$alreadyWarned[key]) $990f835fb2356f36$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $990f835fb2356f36$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router } = _ref;
    // Sync router state to our component state to force re-renders
    let state = $990f835fb2356f36$var$useSyncExternalStore(router.subscribe, ()=>router.state, // but we pass our serialized hydration data into the router so state here
    // is already synced with what the server saw
    ()=>router.state);
    let navigator = $6fFrj.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    return /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$export$3add0d5dce533e2e.Provider, {
        value: {
            router: router,
            navigator: navigator,
            static: false,
            basename: // Do we need this?
            basename
        }
    }, /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$export$3565eb3d00ca5a74, null) : fallbackElement)));
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/docs/en/v6/routers/memory-router
 */ function $990f835fb2356f36$export$ae46f04cfaffe093(_ref2) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref2;
    let historyRef = $6fFrj.useRef();
    if (historyRef.current == null) historyRef.current = (0, $814c115a3a0a6b4a$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $6fFrj.useState({
        action: history.action,
        location: history.location
    });
    $6fFrj.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/docs/en/v6/components/navigate
 */ function $990f835fb2356f36$export$444b3ab0cb9aec40(_ref3) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref3;
    !$990f835fb2356f36$export$9c954a9d03d32f4a() && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    let dataRouterState = $6fFrj.useContext($990f835fb2356f36$export$145dfa71566a64dc);
    let navigate = $990f835fb2356f36$export$9770f232ac06a008();
    $6fFrj.useEffect(()=>{
        // Avoid kicking off multiple navigations if we're in the middle of a
        // data-router navigation, since components get re-rendered when we enter
        // a submitting/loading state
        if (dataRouterState && dataRouterState.navigation.state !== "idle") return;
        navigate(to, {
            replace: replace,
            state: state,
            relative: relative
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/docs/en/v6/components/outlet
 */ function $990f835fb2356f36$export$910ae8079b2c2852(props) {
    return $990f835fb2356f36$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/docs/en/v6/components/route
 */ function $990f835fb2356f36$export$e7b0ac011bb776c6(_props) {
    (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/docs/en/v6/routers/router
 */ function $990f835fb2356f36$export$55185c17a0fcbe46(_ref4) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $814c115a3a0a6b4a$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref4;
    !!$990f835fb2356f36$export$9c954a9d03d32f4a() && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $6fFrj.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $814c115a3a0a6b4a$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let location = $6fFrj.useMemo(()=>{
        let trailingPathname = (0, $814c115a3a0a6b4a$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            pathname: trailingPathname,
            search: search,
            hash: hash,
            state: state,
            key: key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    if (location == null) return null;
    return /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: {
            location: location,
            navigationType: navigationType
        }
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/components/routes
 */ function $990f835fb2356f36$export$3565eb3d00ca5a74(_ref5) {
    let { children: children, location: location } = _ref5;
    let dataRouterContext = $6fFrj.useContext($990f835fb2356f36$export$3add0d5dce533e2e); // When in a DataRouterContext _without_ children, we use the router routes
    // directly.  If we have children, then we're in a descendant tree and we
    // need to use child routes.
    let routes = dataRouterContext && !children ? dataRouterContext.router.routes : $990f835fb2356f36$export$16da398f5434bdec(children);
    return $990f835fb2356f36$export$5d3fca4a98652595(routes, location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $990f835fb2356f36$export$6ddabde395c8c576(_ref6) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref6;
    return /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$var$ResolveAwait, null, children));
}
var $990f835fb2356f36$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($990f835fb2356f36$var$AwaitRenderStatus || ($990f835fb2356f36$var$AwaitRenderStatus = {}));
const $990f835fb2356f36$var$neverSettledPromise = new Promise(()=>{});
class $990f835fb2356f36$var$AwaitErrorBoundary extends $6fFrj.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $990f835fb2356f36$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $990f835fb2356f36$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $990f835fb2356f36$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $990f835fb2356f36$var$AwaitRenderStatus.error : promise._data !== undefined ? $990f835fb2356f36$var$AwaitRenderStatus.success : $990f835fb2356f36$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $990f835fb2356f36$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $990f835fb2356f36$var$AwaitRenderStatus.error && promise._error instanceof (0, $814c115a3a0a6b4a$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $990f835fb2356f36$var$neverSettledPromise;
        if (status === $990f835fb2356f36$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $990f835fb2356f36$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $990f835fb2356f36$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $6fFrj.createElement($990f835fb2356f36$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $990f835fb2356f36$var$ResolveAwait(_ref7) {
    let { children: children } = _ref7;
    let data = $990f835fb2356f36$export$78a72ddb39bdd145();
    if (typeof children === "function") return children(data);
    return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, children);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/docs/en/v6/utils/create-routes-from-children
 */ function $990f835fb2356f36$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $6fFrj.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $6fFrj.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        if (element.type === $6fFrj.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $990f835fb2356f36$export$16da398f5434bdec(element.props.children, parentPath));
            return;
        }
        !(element.type === $990f835fb2356f36$export$e7b0ac011bb776c6) && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
        !(!element.props.index || !element.props.children) && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
        let treePath = [
            ...parentPath,
            index
        ];
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            hasErrorBoundary: element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle
        };
        if (element.props.children) route.children = $990f835fb2356f36$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $990f835fb2356f36$export$daf73786167a7f72(matches) {
    return $990f835fb2356f36$var$_renderMatches(matches);
}
/**
 * @private
 * Walk the route tree and add hasErrorBoundary if it's not provided, so that
 * users providing manual route arrays can just specify errorElement
 */ function $990f835fb2356f36$export$c7b301c52f838c5f(routes) {
    return routes.map((route)=>{
        let routeClone = $990f835fb2356f36$var$_extends({}, route);
        if (routeClone.hasErrorBoundary == null) routeClone.hasErrorBoundary = routeClone.errorElement != null;
        if (routeClone.children) routeClone.children = $990f835fb2356f36$export$c7b301c52f838c5f(routeClone.children);
        return routeClone;
    });
}
function $990f835fb2356f36$export$f30f7e456d254e83(routes, opts) {
    return (0, $814c115a3a0a6b4a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $814c115a3a0a6b4a$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: $990f835fb2356f36$export$c7b301c52f838c5f(routes)
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////



function $a6e470ffbc8d2470$var$_extends() {
    $a6e470ffbc8d2470$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a6e470ffbc8d2470$var$_extends.apply(this, arguments);
}
function $a6e470ffbc8d2470$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a6e470ffbc8d2470$var$defaultMethod = "get";
const $a6e470ffbc8d2470$var$defaultEncType = "application/x-www-form-urlencoded";
function $a6e470ffbc8d2470$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a6e470ffbc8d2470$var$isButtonElement(object) {
    return $a6e470ffbc8d2470$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a6e470ffbc8d2470$var$isFormElement(object) {
    return $a6e470ffbc8d2470$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a6e470ffbc8d2470$var$isInputElement(object) {
    return $a6e470ffbc8d2470$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a6e470ffbc8d2470$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a6e470ffbc8d2470$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a6e470ffbc8d2470$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a6e470ffbc8d2470$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a6e470ffbc8d2470$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a6e470ffbc8d2470$export$a2e4e2dcc7b1f22f(locationSearch);
    for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
        searchParams.append(key, value);
    });
    return searchParams;
}
function $a6e470ffbc8d2470$var$getFormSubmissionInfo(target, defaultAction, options) {
    let method;
    let action;
    let encType;
    let formData;
    if ($a6e470ffbc8d2470$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        method = options.method || target.getAttribute("method") || $a6e470ffbc8d2470$var$defaultMethod;
        action = options.action || target.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("enctype") || $a6e470ffbc8d2470$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($a6e470ffbc8d2470$var$isButtonElement(target) || $a6e470ffbc8d2470$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
         // <button>/<input type="submit"> may override attributes of <form>
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $a6e470ffbc8d2470$var$defaultMethod;
        action = options.action || target.getAttribute("formaction") || form.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $a6e470ffbc8d2470$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($a6e470ffbc8d2470$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $a6e470ffbc8d2470$var$defaultMethod;
        action = options.action || defaultAction;
        encType = options.encType || $a6e470ffbc8d2470$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    let { protocol: protocol, host: host } = window.location;
    let url = new URL(action, protocol + "//" + host);
    return {
        url: url,
        method: method,
        encType: encType,
        formData: formData
    };
}
const $a6e470ffbc8d2470$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $a6e470ffbc8d2470$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $a6e470ffbc8d2470$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative"
];
//#region Routers
////////////////////////////////////////////////////////////////////////////////
function $a6e470ffbc8d2470$export$1f3f55432a00e06d(routes, opts) {
    return (0, $814c115a3a0a6b4a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $814c115a3a0a6b4a$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a6e470ffbc8d2470$var$parseHydrationData(),
        routes: (0, $990f835fb2356f36$export$c7b301c52f838c5f)(routes)
    }).initialize();
}
function $a6e470ffbc8d2470$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $814c115a3a0a6b4a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $814c115a3a0a6b4a$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a6e470ffbc8d2470$var$parseHydrationData(),
        routes: (0, $990f835fb2356f36$export$c7b301c52f838c5f)(routes)
    }).initialize();
}
function $a6e470ffbc8d2470$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a6e470ffbc8d2470$var$_extends({}, state, {
        errors: $a6e470ffbc8d2470$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a6e470ffbc8d2470$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries)// Hey you!  If you change this, please change the corresponding logic in
    // serializeErrors in react-router-dom/server.tsx :)
    if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $814c115a3a0a6b4a$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
    else serialized[key] = val;
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a6e470ffbc8d2470$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window1 } = _ref;
    let historyRef = $6fFrj.useRef();
    if (historyRef.current == null) historyRef.current = (0, $814c115a3a0a6b4a$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $6fFrj.useState({
        action: history.action,
        location: history.location
    });
    $6fFrj.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $990f835fb2356f36$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a6e470ffbc8d2470$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window1 } = _ref2;
    let historyRef = $6fFrj.useRef();
    if (historyRef.current == null) historyRef.current = (0, $814c115a3a0a6b4a$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $6fFrj.useState({
        action: history.action,
        location: history.location
    });
    $6fFrj.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $990f835fb2356f36$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a6e470ffbc8d2470$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = $6fFrj.useState({
        action: history.action,
        location: history.location
    });
    $6fFrj.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $990f835fb2356f36$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * The public API for rendering a history-aware <a>.
 */ const $a6e470ffbc8d2470$export$a6c7ac8248d6e38a = /*#__PURE__*/ $6fFrj.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $a6e470ffbc8d2470$var$_objectWithoutPropertiesLoose(_ref4, $a6e470ffbc8d2470$var$_excluded);
    let href = (0, $990f835fb2356f36$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $a6e470ffbc8d2470$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $6fFrj.createElement("a", $a6e470ffbc8d2470$var$_extends({}, rest, {
        href: href,
        onClick: reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $a6e470ffbc8d2470$export$b0d92dbee9b5b60d = /*#__PURE__*/ $6fFrj.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $a6e470ffbc8d2470$var$_objectWithoutPropertiesLoose(_ref5, $a6e470ffbc8d2470$var$_excluded2);
    let path = (0, $990f835fb2356f36$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $990f835fb2356f36$export$45d76561a5302f2b)();
    let routerState = $6fFrj.useContext((0, $990f835fb2356f36$export$145dfa71566a64dc));
    let { navigator: navigator } = $6fFrj.useContext((0, $990f835fb2356f36$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $6fFrj.createElement($a6e470ffbc8d2470$export$a6c7ac8248d6e38a, $a6e470ffbc8d2470$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a6e470ffbc8d2470$export$a7fed597f4b8afd8 = /*#__PURE__*/ $6fFrj.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $6fFrj.createElement($a6e470ffbc8d2470$var$FormImpl, $a6e470ffbc8d2470$var$_extends({}, props, {
        ref: ref
    }));
});
const $a6e470ffbc8d2470$var$FormImpl = /*#__PURE__*/ $6fFrj.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $a6e470ffbc8d2470$var$defaultMethod, action: action, onSubmit: onSubmit, fetcherKey: fetcherKey, routeId: routeId, relative: relative } = _ref6, props = $a6e470ffbc8d2470$var$_objectWithoutPropertiesLoose(_ref6, $a6e470ffbc8d2470$var$_excluded3);
    let submit = $a6e470ffbc8d2470$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $a6e470ffbc8d2470$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        submit(submitter || event.currentTarget, {
            method: method,
            replace: replace,
            relative: relative
        });
    };
    return /*#__PURE__*/ $6fFrj.createElement("form", $a6e470ffbc8d2470$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a6e470ffbc8d2470$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $a6e470ffbc8d2470$var$useScrollRestoration({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a6e470ffbc8d2470$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($a6e470ffbc8d2470$var$DataRouterHook || ($a6e470ffbc8d2470$var$DataRouterHook = {}));
var $a6e470ffbc8d2470$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a6e470ffbc8d2470$var$DataRouterStateHook || ($a6e470ffbc8d2470$var$DataRouterStateHook = {}));
function $a6e470ffbc8d2470$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.";
}
function $a6e470ffbc8d2470$var$useDataRouterContext(hookName) {
    let ctx = $6fFrj.useContext((0, $990f835fb2356f36$export$3add0d5dce533e2e));
    !ctx && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    return ctx;
}
function $a6e470ffbc8d2470$var$useDataRouterState(hookName) {
    let state = $6fFrj.useContext((0, $990f835fb2356f36$export$145dfa71566a64dc));
    !state && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a6e470ffbc8d2470$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    let location = (0, $990f835fb2356f36$export$45d76561a5302f2b)();
    let path = (0, $990f835fb2356f36$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $6fFrj.useCallback((event)=>{
        if ($a6e470ffbc8d2470$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $814c115a3a0a6b4a$export$fe53371bee54353d)(location) === (0, $814c115a3a0a6b4a$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a6e470ffbc8d2470$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $6fFrj.useRef($a6e470ffbc8d2470$export$a2e4e2dcc7b1f22f(defaultInit));
    let location = (0, $990f835fb2356f36$export$45d76561a5302f2b)();
    let searchParams = $6fFrj.useMemo(()=>$a6e470ffbc8d2470$var$getSearchParamsForLocation(location.search, defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    let setSearchParams = $6fFrj.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a6e470ffbc8d2470$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a6e470ffbc8d2470$export$47c85c6e3a081d3() {
    return $a6e470ffbc8d2470$var$useSubmitImpl();
}
function $a6e470ffbc8d2470$var$useSubmitImpl(fetcherKey, routeId) {
    let { router: router } = $a6e470ffbc8d2470$var$useDataRouterContext($a6e470ffbc8d2470$var$DataRouterHook.UseSubmitImpl);
    let defaultAction = $a6e470ffbc8d2470$export$89a6bd6db0d97c56();
    return $6fFrj.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { method: method, encType: encType, formData: formData, url: url } = $a6e470ffbc8d2470$var$getFormSubmissionInfo(target, defaultAction, options);
        let href = url.pathname + url.search;
        let opts = {
            replace: options.replace,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(routeId != null) && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
            router.fetch(fetcherKey, routeId, href, opts);
        } else router.navigate(href, opts);
    }, [
        defaultAction,
        router,
        fetcherKey,
        routeId
    ]);
}
function $a6e470ffbc8d2470$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $6fFrj.useContext((0, $990f835fb2356f36$export$26749e8557646306));
    let routeContext = $6fFrj.useContext((0, $990f835fb2356f36$export$9072aa6dd1f93057));
    !routeContext && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    let [match] = routeContext.matches.slice(-1);
    let resolvedAction = action != null ? action : "."; // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a6e470ffbc8d2470$var$_extends({}, (0, $990f835fb2356f36$export$e75d2a2d1b3c245b)(resolvedAction, {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $990f835fb2356f36$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $814c115a3a0a6b4a$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $814c115a3a0a6b4a$export$fe53371bee54353d)(path);
}
function $a6e470ffbc8d2470$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $6fFrj.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $6fFrj.createElement($a6e470ffbc8d2470$var$FormImpl, $a6e470ffbc8d2470$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $a6e470ffbc8d2470$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a6e470ffbc8d2470$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $a6e470ffbc8d2470$var$useDataRouterContext($a6e470ffbc8d2470$var$DataRouterHook.UseFetcher);
    let route = $6fFrj.useContext((0, $990f835fb2356f36$export$9072aa6dd1f93057));
    !route && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
    let [fetcherKey] = $6fFrj.useState(()=>String(++$a6e470ffbc8d2470$var$fetcherId));
    let [Form] = $6fFrj.useState(()=>{
        !routeId && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
        return $a6e470ffbc8d2470$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $6fFrj.useState(()=>(href)=>{
            !router && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
            !routeId && (0, $814c115a3a0a6b4a$export$f5708dca728d7177)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $a6e470ffbc8d2470$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $6fFrj.useMemo(()=>$a6e470ffbc8d2470$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $6fFrj.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No fetcher available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a6e470ffbc8d2470$export$fa996778a3a31087() {
    let state = $a6e470ffbc8d2470$var$useDataRouterState($a6e470ffbc8d2470$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $a6e470ffbc8d2470$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a6e470ffbc8d2470$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a6e470ffbc8d2470$var$useScrollRestoration(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a6e470ffbc8d2470$var$useDataRouterContext($a6e470ffbc8d2470$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a6e470ffbc8d2470$var$useDataRouterState($a6e470ffbc8d2470$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $990f835fb2356f36$export$45d76561a5302f2b)();
    let matches = (0, $990f835fb2356f36$export$2378eb7f5ff86053)();
    let navigation = (0, $990f835fb2356f36$export$d0fd4b7106de2769)(); // Trigger manual scroll restoration while we're active
    $6fFrj.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on unload
    $a6e470ffbc8d2470$var$useBeforeUnload($6fFrj.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a6e470ffbc8d2470$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $a6e470ffbc8d2470$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a6e470ffbc8d2470$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    $6fFrj.useLayoutEffect(()=>{
        try {
            let sessionPositions = sessionStorage.getItem(storageKey || $a6e470ffbc8d2470$var$SCROLL_RESTORATION_STORAGE_KEY);
            if (sessionPositions) $a6e470ffbc8d2470$var$savedScrollPositions = JSON.parse(sessionPositions);
        } catch (e) {}
    }, [
        storageKey
    ]); // Enable scroll restoration in the router
    $6fFrj.useLayoutEffect(()=>{
        let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a6e470ffbc8d2470$var$savedScrollPositions, ()=>window.scrollY, getKey);
        return ()=>disableScrollRestoration && disableScrollRestoration();
    }, [
        router,
        getKey
    ]); // Restore scrolling when state.restoreScrollPosition changes
    $6fFrj.useLayoutEffect(()=>{
        // Explicit false means don't do anything (used for submissions)
        if (restoreScrollPosition === false) return;
         // been here before, scroll to it
        if (typeof restoreScrollPosition === "number") {
            window.scrollTo(0, restoreScrollPosition);
            return;
        } // try to scroll to the hash
        if (location.hash) {
            let el = document.getElementById(location.hash.slice(1));
            if (el) {
                el.scrollIntoView();
                return;
            }
        } // Opt out of scroll reset if this link requested it
        if (preventScrollReset === true) return;
         // otherwise go to the top on new locations
        window.scrollTo(0, 0);
    }, [
        location,
        restoreScrollPosition,
        preventScrollReset
    ]);
}
function $a6e470ffbc8d2470$var$useBeforeUnload(callback) {
    $6fFrj.useEffect(()=>{
        window.addEventListener("beforeunload", callback);
        return ()=>{
            window.removeEventListener("beforeunload", callback);
        };
    }, [
        callback
    ]);
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Utils
////////////////////////////////////////////////////////////////////////////////
function $a6e470ffbc8d2470$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
} //#endregion



var $6fFrj = parcelRequire("6fFrj");

const $1b6cd4304c8b74ff$export$d8d3dbd8639f022f = (0, $6fFrj.createContext)(null);
const $1b6cd4304c8b74ff$export$e16a8f6f26d15fff = function({ children: children, client: client }) {
    const Context = $1b6cd4304c8b74ff$export$d8d3dbd8639f022f;
    return $6fFrj.createElement(Context.Provider, {
        value: client
    }, children);
};
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $1b6cd4304c8b74ff$var$__assign = function() {
    $1b6cd4304c8b74ff$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1b6cd4304c8b74ff$var$__assign.apply(this, arguments);
};
function $1b6cd4304c8b74ff$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1b6cd4304c8b74ff$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1b6cd4304c8b74ff$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $1b6cd4304c8b74ff$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
var $1b6cd4304c8b74ff$var$LogLevels = {
    DEBUG: {
        name: "DEBUG",
        severity: 10
    },
    INFO: {
        name: "INFO",
        severity: 100
    },
    WARN: {
        name: "WARN",
        severity: 1000
    },
    ERROR: {
        name: "ERROR",
        severity: 10000
    },
    NONE: {
        name: "NONE",
        severity: 10000
    }
};
var $1b6cd4304c8b74ff$var$rootLogger = null;
/**
 * Create logger or return cached instance
 */ function $1b6cd4304c8b74ff$var$getLogger() {
    if ($1b6cd4304c8b74ff$var$rootLogger) return $1b6cd4304c8b74ff$var$rootLogger;
    else return $1b6cd4304c8b74ff$var$rootLogger = $1b6cd4304c8b74ff$var$createLogger();
}
function $1b6cd4304c8b74ff$var$setRootLogLevel(logLevelName) {
    var logLevel = $1b6cd4304c8b74ff$var$LogLevels[logLevelName.toLocaleUpperCase()];
    if (!logLevel) {
        console.warn("Can't find log level with name " + logLevelName.toLocaleUpperCase() + ", defaulting to INFO");
        logLevel = $1b6cd4304c8b74ff$var$LogLevels.INFO;
    }
    $1b6cd4304c8b74ff$var$rootLogger = $1b6cd4304c8b74ff$var$createLogger(logLevel);
    return $1b6cd4304c8b74ff$var$rootLogger;
}
function $1b6cd4304c8b74ff$var$setDebugVar(name, val) {
    if (!$1b6cd4304c8b74ff$var$isWindowAvailable()) return;
    var win = window;
    if (!win.__usermavenDebug) win.__usermavenDebug = {};
    win.__usermavenDebug[name] = val;
}
/**
 * Creates a loggger with given log-level
 * @param logLevel
 */ function $1b6cd4304c8b74ff$var$createLogger(logLevel) {
    var globalLogLevel = $1b6cd4304c8b74ff$var$isWindowAvailable() && window['__eventNLogLevel'];
    var minLogLevel = $1b6cd4304c8b74ff$var$LogLevels.WARN;
    if (globalLogLevel) {
        var level = $1b6cd4304c8b74ff$var$LogLevels[globalLogLevel.toUpperCase()];
        if (level && level > 0) minLogLevel = level;
    } else if (logLevel) minLogLevel = logLevel;
    var logger = {
        minLogLevel: minLogLevel
    };
    Object.values($1b6cd4304c8b74ff$var$LogLevels).forEach(function(_a) {
        var name = _a.name, severity = _a.severity;
        logger[name.toLowerCase()] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (severity >= minLogLevel.severity && args.length > 0) {
                var message = args[0];
                var msgArgs = args.splice(1);
                var msgFormatted = "[J-" + name + "] " + message;
                if (name === 'DEBUG' || name === 'INFO') console.log.apply(console, $1b6cd4304c8b74ff$var$__spreadArray([
                    msgFormatted
                ], msgArgs, false));
                else if (name === 'WARN') console.warn.apply(console, $1b6cd4304c8b74ff$var$__spreadArray([
                    msgFormatted
                ], msgArgs, false));
                else console.error.apply(console, $1b6cd4304c8b74ff$var$__spreadArray([
                    msgFormatted
                ], msgArgs, false));
            }
        };
    });
    $1b6cd4304c8b74ff$var$setDebugVar("logger", logger);
    return logger;
}
/**
 * Checks if global variable 'window' is available. If it's available,
 * code runs in browser environment
 */ function $1b6cd4304c8b74ff$var$isWindowAvailable(warnMsg) {
    //here we check not only of window object is globally available, but also if it's not a fake one
    //react-native do have a window object, but it's not a real one: https://stackoverflow.com/questions/49911424/what-does-the-variable-window-represent-in-react-native
    const windowAvailable = !!globalThis.window && !!globalThis.window.document && !!globalThis.window.location;
    if (!windowAvailable && warnMsg) $1b6cd4304c8b74ff$var$getLogger().warn(warnMsg);
    return windowAvailable;
}
/**
 * @param msg
 * @return {Window}
 */ function $1b6cd4304c8b74ff$var$requireWindow(msg) {
    if (!$1b6cd4304c8b74ff$var$isWindowAvailable()) throw new Error(msg || "window' is not available. Seems like this code runs outside browser environment. It shouldn't happen");
    return window;
}
// Note: updated this method to test on staging (Ref:: https://github.com/PostHog/posthog-js/blob/master/src/storage.ts#L42)
// Commented out some jitsu cookies setters that are not bring used in posthog-js
function $1b6cd4304c8b74ff$var$serializeCookie(name, val, opt) {
    if (opt === void 0) opt = {};
    try {
        var maxAge = opt.maxAge, domain = opt.domain, path = opt.path, expires = opt.expires, httpOnly = opt.httpOnly, secure = opt.secure, sameSite = opt.sameSite;
        var new_cookie_val = name + "=" + encodeURIComponent(val);
        if (domain) new_cookie_val += "; domain=" + domain;
        if (path) new_cookie_val += "; path=" + path;
        else new_cookie_val += "; path=/";
        if (expires) new_cookie_val += "; expires=" + expires.toUTCString();
        if (maxAge) new_cookie_val += "; max-age=" + maxAge;
        if (httpOnly) new_cookie_val += "; httponly";
        if (secure) new_cookie_val += "; secure";
        if (sameSite) {
            var sameSiteAttr = typeof sameSite === "string" ? sameSite.toLowerCase() : sameSite;
            switch(sameSiteAttr){
                case true:
                    new_cookie_val += "; SameSite=Strict";
                    break;
                case "lax":
                    new_cookie_val += "; SameSite=Lax";
                    break;
                case "strict":
                    new_cookie_val += "; SameSite=Strict";
                    break;
                case "none":
                    new_cookie_val += "; SameSite=None";
                    break;
            }
        } else if (secure) /**
             * SameSite=None - means that the browser sends the cookie with both cross-site and same-site requests.
             * The Secure attribute must also be set when setting this value, like so SameSite=None; Secure.
             * If Secure is missing an error will be logged.
             *
             * https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie#samesitesamesite-value
             */ new_cookie_val += "; SameSite=None";
        return new_cookie_val;
    } catch (e) {
        $1b6cd4304c8b74ff$var$getLogger().error("serializeCookie", e);
        return '';
    }
}
// Courtesy: https://stackoverflow.com/a/23945027
function $1b6cd4304c8b74ff$var$extractHostname(url) {
    var hostname;
    //find & remove protocol (http, ftp, etc.) and get hostname
    if (url.indexOf("//") > -1) hostname = url.split('/')[2];
    else hostname = url.split('/')[0];
    //find & remove port number
    hostname = hostname.split(':')[0];
    //find & remove "?"
    hostname = hostname.split('?')[0];
    return hostname;
}
// Warning: you can use this function to extract the "root" domain, but it will not be as accurate as using the psl package. 
// https://www.npmjs.com/package/psl
var $1b6cd4304c8b74ff$var$extractRootDomain = function(url) {
    var domain = $1b6cd4304c8b74ff$var$extractHostname(url), splitArr = domain.split('.'), arrLen = splitArr.length;
    // extracting the root domain here
    // if there is a subdomain
    if (arrLen > 2) {
        if (splitArr[arrLen - 1].length == 2) {
            // likely a ccTLD
            domain = splitArr[arrLen - 2] + '.' + splitArr[arrLen - 1];
            // if the second level domain is also two letters (like co.uk), include the next part up
            if (splitArr[arrLen - 2].length == 2) domain = splitArr[arrLen - 3] + '.' + domain;
        } else // likely a gTLD
        domain = splitArr[arrLen - 2] + '.' + splitArr[arrLen - 1];
    }
    return domain;
};
var $1b6cd4304c8b74ff$var$extractTopLevelDomain = function(url) {
    var DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
    var matches = url.match(DOMAIN_MATCH_REGEX), domain = matches ? matches[0] : '';
    return domain;
};
var $1b6cd4304c8b74ff$var$extractRoot = function(url) {
    var domainParts = url.split(".");
    var domainLength = domainParts.length;
    // Check if it's an IP address
    if (domainLength === 4 && domainParts.every(function(part) {
        return !isNaN(part);
    })) return url;
    var rootDomain = $1b6cd4304c8b74ff$var$extractTopLevelDomain(url);
    if (!rootDomain) rootDomain = $1b6cd4304c8b74ff$var$extractRootDomain(url);
    return rootDomain;
};
var $1b6cd4304c8b74ff$var$getCookieDomain = function() {
    if ($1b6cd4304c8b74ff$var$isWindowAvailable()) // const domain = window.location.hostname.replace("www.", "")
    //
    // // Check if subdomain is set, if yes, we remove the subdomain from the cookie domain and return the root domain with a leading dot
    // // This is to ensure that cookies are set correctly for cross domain tracking
    // const subdomain = domain.split('.')[0]
    // if (subdomain) {
    //   return '.' + extractRootDomain(domain)
    // }
    return $1b6cd4304c8b74ff$var$extractRoot(window.location.hostname);
    return undefined;
};
var $1b6cd4304c8b74ff$var$cookieParsingCache;
function $1b6cd4304c8b74ff$var$parseCookieString(cookieStr) {
    if (!cookieStr) return {};
    var res = {};
    var cookies = cookieStr.split(";");
    for(var i = 0; i < cookies.length; i++){
        var cookie = cookies[i];
        var idx = cookie.indexOf("=");
        if (idx > 0) res[cookie.substr(i > 0 ? 1 : 0, i > 0 ? idx - 1 : idx)] = cookie.substr(idx + 1);
    }
    return res;
}
function $1b6cd4304c8b74ff$var$copyAttributes(source, target) {
    return Array.from(source.attributes).forEach(function(attribute) {
        target.setAttribute(attribute.nodeName, attribute.nodeValue);
    });
}
function $1b6cd4304c8b74ff$var$insertAndExecute(element, html) {
    element.innerHTML = html;
    var scripts = element.getElementsByTagName("script");
    var index;
    for(index = scripts.length - 1; index >= 0; index--){
        var script = scripts[index];
        var tag = document.createElement("script");
        $1b6cd4304c8b74ff$var$copyAttributes(script, tag);
        if (script.innerHTML) tag.innerHTML = script.innerHTML;
        tag.setAttribute("data-usermaven-tag-id", element.id);
        document.getElementsByTagName("head")[0].appendChild(tag);
        scripts[index].parentNode.removeChild(scripts[index]);
    }
}
var $1b6cd4304c8b74ff$var$getCookies = function(useCache) {
    if (useCache === void 0) useCache = false;
    if (useCache && $1b6cd4304c8b74ff$var$cookieParsingCache) return $1b6cd4304c8b74ff$var$cookieParsingCache;
    var res = $1b6cd4304c8b74ff$var$parseCookieString(document.cookie);
    $1b6cd4304c8b74ff$var$cookieParsingCache = res;
    return res;
};
// Methods partially borrowed from quirksmode.org/js/cookies.html
var $1b6cd4304c8b74ff$var$getCookie = function(name) {
    if (!name) return null;
    try {
        var nameEQ = name + '=';
        var ca = $1b6cd4304c8b74ff$var$requireWindow().document.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
    } catch (err) {
        $1b6cd4304c8b74ff$var$getLogger().error("getCookies", err);
    }
    return null;
};
var $1b6cd4304c8b74ff$var$setCookie = function(name, value, opts) {
    if (opts === void 0) opts = {};
    $1b6cd4304c8b74ff$var$requireWindow().document.cookie = $1b6cd4304c8b74ff$var$serializeCookie(name, value, opts);
};
var $1b6cd4304c8b74ff$var$deleteCookie = function(name, path) {
    if (path === void 0) path = "/";
    document.cookie = name + "= ; SameSite=Strict; expires = Thu, 01 Jan 1970 00:00:00 GMT" + (path ? "; path = " + path : "");
};
var $1b6cd4304c8b74ff$var$generateId = function() {
    return Math.random().toString(36).substring(2, 12);
};
var $1b6cd4304c8b74ff$var$getUmExclusionState = function() {
    var state = "false";
    if (typeof window !== 'undefined' && window.localStorage) state = localStorage.getItem("um_exclusion");
    return state === undefined || state === null || state === "false" ? false : true;
};
var $1b6cd4304c8b74ff$var$generateRandom = function() {
    return Math.random().toString(36).substring(2, 7);
};
var $1b6cd4304c8b74ff$var$parseQuery = function(qs) {
    if (!qs) return {};
    var queryString = qs.length > 0 && qs.charAt(0) === "?" ? qs.substring(1) : qs;
    var query = {};
    var pairs = (queryString[0] === "?" ? queryString.substr(1) : queryString).split("&");
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i].split("=");
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
    }
    return query;
};
var $1b6cd4304c8b74ff$var$UTM_TYPES = {
    utm_source: "source",
    utm_medium: "medium",
    utm_campaign: "campaign",
    utm_term: "term",
    utm_content: "content"
};
var $1b6cd4304c8b74ff$var$CLICK_IDS = {
    gclid: true,
    fbclid: true,
    dclid: true
};
var $1b6cd4304c8b74ff$var$getDataFromParams = function(params) {
    var result = {
        utm: {},
        click_id: {}
    };
    for(var name in params){
        if (!params.hasOwnProperty(name)) continue;
        var val = params[name];
        var utm = $1b6cd4304c8b74ff$var$UTM_TYPES[name];
        if (utm) result.utm[utm] = val;
        else if ($1b6cd4304c8b74ff$var$CLICK_IDS[name]) result.click_id[name] = val;
    }
    return result;
};
//2020-08-24T13:42:16.439Z -> 2020-08-24T13:42:16.439123Z
var $1b6cd4304c8b74ff$var$reformatDate = function(strDate) {
    var end = strDate.split(".")[1];
    if (!end) return strDate;
    if (end.length >= 7) return strDate;
    return strDate.slice(0, -1) + "0".repeat(7 - end.length) + "Z";
};
function $1b6cd4304c8b74ff$var$endsWith(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
}
var $1b6cd4304c8b74ff$var$getHostWithProtocol = function(host) {
    while($1b6cd4304c8b74ff$var$endsWith(host, "/"))host = host.substr(0, host.length - 1);
    if (host.indexOf("https://") === 0 || host.indexOf("http://") === 0) return host;
    else return "https://" + host;
};
var $1b6cd4304c8b74ff$var$MemoryQueue = /** @class */ function() {
    function MemoryQueue() {
        this.queue = [];
    }
    MemoryQueue.prototype.flush = function() {
        var queue = this.queue;
        this.queue = [];
        return queue;
    };
    MemoryQueue.prototype.push = function() {
        var _a;
        var values = [];
        for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
        (_a = this.queue).push.apply(_a, values);
    };
    return MemoryQueue;
}();
var $1b6cd4304c8b74ff$var$LocalStorageQueue = /** @class */ function() {
    function LocalStorageQueue(key) {
        this.key = key;
    }
    LocalStorageQueue.prototype.flush = function() {
        var queue = this.get();
        if (queue.length) this.set([]);
        return queue;
    };
    LocalStorageQueue.prototype.push = function() {
        var values = [];
        for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
        var queue = this.get();
        queue.push.apply(queue, values);
        this.set(queue);
    };
    LocalStorageQueue.prototype.set = function(queue) {
        localStorage.setItem(this.key, JSON.stringify(queue));
    };
    LocalStorageQueue.prototype.get = function() {
        var data = localStorage.getItem(this.key);
        if (data !== null && data !== "") return JSON.parse(data);
        return [];
    };
    return LocalStorageQueue;
}();
var $1b6cd4304c8b74ff$var$ObjProto = Object.prototype;
var $1b6cd4304c8b74ff$var$toString = $1b6cd4304c8b74ff$var$ObjProto.toString;
var $1b6cd4304c8b74ff$var$hasOwnProperty = $1b6cd4304c8b74ff$var$ObjProto.hasOwnProperty;
var $1b6cd4304c8b74ff$var$ArrayProto = Array.prototype;
var $1b6cd4304c8b74ff$var$nativeForEach = $1b6cd4304c8b74ff$var$ArrayProto.forEach, $1b6cd4304c8b74ff$var$nativeIsArray = Array.isArray, $1b6cd4304c8b74ff$var$breaker = {};
var $1b6cd4304c8b74ff$var$_isArray = $1b6cd4304c8b74ff$var$nativeIsArray || function(obj) {
    return $1b6cd4304c8b74ff$var$toString.call(obj) === '[object Array]';
};
function $1b6cd4304c8b74ff$var$_eachArray(obj, iterator, thisArg) {
    if (Array.isArray(obj)) {
        if ($1b6cd4304c8b74ff$var$nativeForEach && obj.forEach === $1b6cd4304c8b74ff$var$nativeForEach) obj.forEach(iterator, thisArg);
        else if ('length' in obj && obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
            if (i in obj && iterator.call(thisArg, obj[i], i) === $1b6cd4304c8b74ff$var$breaker) return;
        }
    }
}
// Embed part of the Underscore Library
var $1b6cd4304c8b74ff$var$_trim = function(str) {
    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
var $1b6cd4304c8b74ff$var$_bind_instance_methods = function(obj) {
    for(var func in obj)if (typeof obj[func] === 'function') obj[func] = obj[func].bind(obj);
};
/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} thisArg
 */ function $1b6cd4304c8b74ff$var$_each(obj, iterator, thisArg) {
    if (obj === null || obj === undefined) return;
    if ($1b6cd4304c8b74ff$var$nativeForEach && Array.isArray(obj) && obj.forEach === $1b6cd4304c8b74ff$var$nativeForEach) obj.forEach(iterator, thisArg);
    else if ('length' in obj && obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
        if (i in obj && iterator.call(thisArg, obj[i], i) === $1b6cd4304c8b74ff$var$breaker) return;
    }
    else {
        for(var key in obj)if ($1b6cd4304c8b74ff$var$hasOwnProperty.call(obj, key)) {
            if (iterator.call(thisArg, obj[key], key) === $1b6cd4304c8b74ff$var$breaker) return;
        }
    }
}
var $1b6cd4304c8b74ff$var$_extend = function(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $1b6cd4304c8b74ff$var$_eachArray(args, function(source) {
        for(var prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
    });
    return obj;
};
function $1b6cd4304c8b74ff$var$_includes(str, needle) {
    return str.indexOf(needle) !== -1;
}
// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// let bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
var $1b6cd4304c8b74ff$var$_isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};
var $1b6cd4304c8b74ff$var$_isUndefined = function(obj) {
    return obj === void 0;
};
var $1b6cd4304c8b74ff$var$_register_event = function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from PostHog
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440
    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */ var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            $1b6cd4304c8b74ff$var$getLogger().error('No valid element provided to register_event');
            return;
        }
        if (element.addEventListener && !oldSchool) element.addEventListener(type, handler, !!useCapture);
        else {
            var ontype = 'on' + type;
            var old_handler = element[ontype] // can be undefined
            ;
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };
    function makeHandler(element, new_handler, old_handlers) {
        return function(event) {
            event = event || fixEvent(window.event);
            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) return undefined;
            var ret = true;
            var old_result;
            if ($1b6cd4304c8b74ff$var$_isFunction(old_handlers)) old_result = old_handlers(event);
            var new_result = new_handler.call(element, event);
            if (false === old_result || false === new_result) ret = false;
            return ret;
        };
    }
    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return register_event;
}();
var $1b6cd4304c8b74ff$var$_safewrap = function(f) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return f.apply(this, args);
        } catch (e) {
            $1b6cd4304c8b74ff$var$getLogger().error('Implementation error. Please turn on debug and contact support@usermaven.com.', e);
        // if (Config.DEBUG) {
        //     getLogger.critical(e)
        // }
        }
    };
};
var $1b6cd4304c8b74ff$var$_safewrap_instance_methods = function(obj) {
    for(var func in obj)if (typeof obj[func] === 'function') obj[func] = $1b6cd4304c8b74ff$var$_safewrap(obj[func]);
};
var $1b6cd4304c8b74ff$var$COPY_IN_PROGRESS_ATTRIBUTE = typeof Symbol !== 'undefined' ? Symbol('__deepCircularCopyInProgress__') : '__deepCircularCopyInProgress__';
/**
 * Deep copies an object.
 * It handles cycles by replacing all references to them with `undefined`
 * Also supports customizing native values
 *
 * @param value
 * @param customizer
 * @param [key] if provided this is the object key associated with the value to be copied. It allows the customizer function to have context when it runs
 * @returns {{}|undefined|*}
 */ function $1b6cd4304c8b74ff$var$deepCircularCopy(value, customizer, key) {
    if (value !== Object(value)) return customizer ? customizer(value, key) : value; // primitive value
    if (value[$1b6cd4304c8b74ff$var$COPY_IN_PROGRESS_ATTRIBUTE]) return undefined;
    value[$1b6cd4304c8b74ff$var$COPY_IN_PROGRESS_ATTRIBUTE] = true;
    var result;
    if ($1b6cd4304c8b74ff$var$_isArray(value)) {
        result = [];
        $1b6cd4304c8b74ff$var$_eachArray(value, function(it) {
            result.push($1b6cd4304c8b74ff$var$deepCircularCopy(it, customizer));
        });
    } else {
        result = {};
        $1b6cd4304c8b74ff$var$_each(value, function(val, key) {
            if (key !== $1b6cd4304c8b74ff$var$COPY_IN_PROGRESS_ATTRIBUTE) result[key] = $1b6cd4304c8b74ff$var$deepCircularCopy(val, customizer, key);
        });
    }
    delete value[$1b6cd4304c8b74ff$var$COPY_IN_PROGRESS_ATTRIBUTE];
    return result;
}
var $1b6cd4304c8b74ff$var$LONG_STRINGS_ALLOW_LIST = [
    '$performance_raw'
];
function $1b6cd4304c8b74ff$var$_copyAndTruncateStrings(object, maxStringLength) {
    return $1b6cd4304c8b74ff$var$deepCircularCopy(object, function(value, key) {
        if (key && $1b6cd4304c8b74ff$var$LONG_STRINGS_ALLOW_LIST.indexOf(key) > -1) return value;
        if (typeof value === 'string' && maxStringLength !== null) return value.slice(0, maxStringLength);
        return value;
    });
}
// Function to find the closest link element
function $1b6cd4304c8b74ff$var$_findClosestLink(element) {
    while(element && element.tagName){
        if (element.tagName.toLowerCase() == 'a') return element;
        element = element.parentNode;
    }
    return null;
}
function $1b6cd4304c8b74ff$var$_cleanObject(obj) {
    for(var propName in obj)if (obj[propName] === '' || obj[propName] === null || obj[propName] === undefined || typeof obj[propName] === 'object' && Object.keys(obj[propName]).length === 0) delete obj[propName];
    return obj;
}
/*
 * Get the className of an element, accounting for edge cases where element.className is an object
 * @param {Element} el - element to get the className of
 * @returns {string} the element's class
 */ function $1b6cd4304c8b74ff$var$getClassName(el) {
    switch(typeof el.className){
        case 'string':
            return el.className;
        // TODO: when is this ever used?
        case 'object':
            return ('baseVal' in el.className ? el.className.baseVal : null) || el.getAttribute('class') || '';
        default:
            // future proof
            return '';
    }
}
/*
 * Get the direct text content of an element, protecting against sensitive data collection.
 * Concats textContent of each of the element's text node children; this avoids potential
 * collection of sensitive data that could happen if we used element.textContent and the
 * element had sensitive child elements, since element.textContent includes child content.
 * Scrubs values that look like they could be sensitive (i.e. cc or ssn number).
 * @param {Element} el - element to get the text of
 * @returns {string} the element's direct text content
 */ function $1b6cd4304c8b74ff$var$getSafeText(el) {
    var elText = '';
    if ($1b6cd4304c8b74ff$var$shouldCaptureElement(el) && !$1b6cd4304c8b74ff$var$isSensitiveElement(el) && el.childNodes && el.childNodes.length) $1b6cd4304c8b74ff$var$_each(el.childNodes, function(child) {
        if ($1b6cd4304c8b74ff$var$isTextNode(child) && child.textContent) elText += $1b6cd4304c8b74ff$var$_trim(child.textContent)// scrub potentially sensitive values
        .split(/(\s+)/).filter($1b6cd4304c8b74ff$var$shouldCaptureValue).join('')// normalize whitespace
        .replace(/[\r\n]/g, ' ').replace(/[ ]+/g, ' ')// truncate
        .substring(0, 255);
    });
    return $1b6cd4304c8b74ff$var$_trim(elText);
}
/*
 * Check whether an element has nodeType Node.ELEMENT_NODE
 * @param {Element} el - element to check
 * @returns {boolean} whether el is of the correct nodeType
 */ function $1b6cd4304c8b74ff$var$isElementNode(el) {
    return !!el && el.nodeType === 1; // Node.ELEMENT_NODE - use integer constant for browser portability
}
/*
 * Check whether an element is of a given tag type.
 * Due to potential reference discrepancies (such as the webcomponents.js polyfill),
 * we want to match tagNames instead of specific references because something like
 * element === document.body won't always work because element might not be a native
 * element.
 * @param {Element} el - element to check
 * @param {string} tag - tag name (e.g., "div")
 * @returns {boolean} whether el is of the given tag type
 */ function $1b6cd4304c8b74ff$var$isTag(el, tag) {
    return !!el && !!el.tagName && el.tagName.toLowerCase() === tag.toLowerCase();
}
/*
 * Check whether an element has nodeType Node.TEXT_NODE
 * @param {Element} el - element to check
 * @returns {boolean} whether el is of the correct nodeType
 */ function $1b6cd4304c8b74ff$var$isTextNode(el) {
    return !!el && el.nodeType === 3; // Node.TEXT_NODE - use integer constant for browser portability
}
/*
 * Check whether an element has nodeType Node.DOCUMENT_FRAGMENT_NODE
 * @param {Element} el - element to check
 * @returns {boolean} whether el is of the correct nodeType
 */ function $1b6cd4304c8b74ff$var$isDocumentFragment(el) {
    return !!el && el.nodeType === 11; // Node.DOCUMENT_FRAGMENT_NODE - use integer constant for browser portability
}
var $1b6cd4304c8b74ff$var$usefulElements = [
    'a',
    'button',
    'form',
    'input',
    'select',
    'textarea',
    'label'
];
/*
 * Check whether a DOM event should be "captured" or if it may contain sentitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Event} event - event to check
 * @returns {boolean} whether the event should be captured
 */ function $1b6cd4304c8b74ff$var$shouldCaptureDomEvent(el, event) {
    if (!el || $1b6cd4304c8b74ff$var$isTag(el, 'html') || !$1b6cd4304c8b74ff$var$isElementNode(el)) return false;
    // allow users to programmatically prevent capturing of elements by adding class 'um-no-capture'
    if (el.classList && el.classList.contains('um-no-capture')) return false;
    var parentIsUsefulElement = false;
    var targetElementList = [
        el
    ]; // TODO: remove this var, it's never queried
    var parentNode = true;
    var curEl = el;
    while(curEl.parentNode && !$1b6cd4304c8b74ff$var$isTag(curEl, 'body')){
        // If element is a shadow root, we skip it
        if ($1b6cd4304c8b74ff$var$isDocumentFragment(curEl.parentNode)) {
            targetElementList.push(curEl.parentNode.host);
            curEl = curEl.parentNode.host;
            continue;
        }
        parentNode = curEl.parentNode || false;
        if (!parentNode) break;
        if ($1b6cd4304c8b74ff$var$usefulElements.indexOf(parentNode.tagName.toLowerCase()) > -1) parentIsUsefulElement = true;
        else {
            var compStyles_1 = window.getComputedStyle(parentNode);
            if (compStyles_1 && compStyles_1.getPropertyValue('cursor') === 'pointer') parentIsUsefulElement = true;
        }
        targetElementList.push(parentNode);
        curEl = parentNode;
    }
    var compStyles = window.getComputedStyle(el);
    if (compStyles && compStyles.getPropertyValue('cursor') === 'pointer' && event.type === 'click') return true;
    var tag = el.tagName.toLowerCase();
    switch(tag){
        case 'html':
            return false;
        case 'form':
            return event.type === 'submit';
        case 'input':
            return event.type === 'change' || event.type === 'click';
        case 'select':
        case 'textarea':
            return event.type === 'change' || event.type === 'click';
        default:
            if (parentIsUsefulElement) return event.type === 'click';
            return event.type === 'click' && ($1b6cd4304c8b74ff$var$usefulElements.indexOf(tag) > -1 || el.getAttribute('contenteditable') === 'true');
    }
}
/*
 * Check whether a DOM element should be "captured" or if it may contain sentitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @returns {boolean} whether the element should be captured
 */ function $1b6cd4304c8b74ff$var$shouldCaptureElement(el) {
    for(var curEl = el; curEl.parentNode && !$1b6cd4304c8b74ff$var$isTag(curEl, 'body'); curEl = curEl.parentNode){
        var classes = $1b6cd4304c8b74ff$var$getClassName(curEl).split(' ');
        if ($1b6cd4304c8b74ff$var$_includes(classes, 'ph-sensitive') || $1b6cd4304c8b74ff$var$_includes(classes, 'ph-no-capture')) return false;
    }
    if ($1b6cd4304c8b74ff$var$_includes($1b6cd4304c8b74ff$var$getClassName(el).split(' '), 'ph-include')) return true;
    // don't include hidden or password fields
    var type = el.type || '';
    if (typeof type === 'string') // it's possible for el.type to be a DOM element if el is a form with a child input[name="type"]
    switch(type.toLowerCase()){
        case 'hidden':
            return false;
        case 'password':
            return false;
    }
    // filter out data from fields that look like sensitive fields
    var name = el.name || el.id || '';
    // See https://github.com/posthog/posthog-js/issues/165
    // Under specific circumstances a bug caused .replace to be called on a DOM element
    // instead of a string, removing the element from the page. Ensure this issue is mitigated.
    if (typeof name === 'string') {
        // it's possible for el.name or el.id to be a DOM element if el is a form with a child input[name="name"]
        var sensitiveNameRegex = /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i;
        if (sensitiveNameRegex.test(name.replace(/[^a-zA-Z0-9]/g, ''))) return false;
    }
    return true;
}
/*
 * Check whether a DOM element is 'sensitive' and we should only capture limited data
 * @param {Element} el - element to check
 * @returns {boolean} whether the element should be captured
 */ function $1b6cd4304c8b74ff$var$isSensitiveElement(el) {
    // don't send data from inputs or similar elements since there will always be
    // a risk of clientside javascript placing sensitive data in attributes
    var allowedInputTypes = [
        'button',
        'checkbox',
        'submit',
        'reset'
    ];
    if ($1b6cd4304c8b74ff$var$isTag(el, 'input') && !allowedInputTypes.includes(el.type) || $1b6cd4304c8b74ff$var$isTag(el, 'select') || $1b6cd4304c8b74ff$var$isTag(el, 'textarea') || el.getAttribute('contenteditable') === 'true') return true;
    return false;
}
/*
 * Check whether a string value should be "captured" or if it may contain sentitive data
 * using a variety of heuristics.
 * @param {string} value - string value to check
 * @returns {boolean} whether the element should be captured
 */ function $1b6cd4304c8b74ff$var$shouldCaptureValue(value) {
    if (value === null || $1b6cd4304c8b74ff$var$_isUndefined(value)) return false;
    if (typeof value === 'string') {
        value = $1b6cd4304c8b74ff$var$_trim(value);
        // check to see if input value looks like a credit card number
        // see: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9781449327453/ch04s20.html
        var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        if (ccRegex.test((value || '').replace(/[- ]/g, ''))) return false;
        // check to see if input value looks like a social security number
        var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
        if (ssnRegex.test(value)) return false;
    }
    return true;
}
/*
 * Check whether an attribute name is an Angular style attr (either _ngcontent or _nghost)
 * These update on each build and lead to noise in the element chain
 * More details on the attributes here: https://angular.io/guide/view-encapsulation
 * @param {string} attributeName - string value to check
 * @returns {boolean} whether the element is an angular tag
 */ function $1b6cd4304c8b74ff$var$isAngularStyleAttr(attributeName) {
    if (typeof attributeName === 'string') return attributeName.substring(0, 10) === '_ngcontent' || attributeName.substring(0, 7) === '_nghost';
    return false;
}
// Naive rage click implementation: If mouse has not moved than RAGE_CLICK_THRESHOLD_PX
// over RAGE_CLICK_CLICK_COUNT clicks with max RAGE_CLICK_TIMEOUT_MS between clicks, it's
// counted as a rage click
var $1b6cd4304c8b74ff$var$RAGE_CLICK_THRESHOLD_PX = 30;
var $1b6cd4304c8b74ff$var$RAGE_CLICK_TIMEOUT_MS = 1000;
var $1b6cd4304c8b74ff$var$RAGE_CLICK_CLICK_COUNT = 3;
var $1b6cd4304c8b74ff$var$RageClick = /** @class */ function() {
    function RageClick(instance, enabled) {
        if (enabled === void 0) enabled = false;
        this.clicks = [];
        this.instance = instance;
        this.enabled = enabled;
    }
    RageClick.prototype.click = function(x, y, timestamp) {
        if (!this.enabled) return;
        var lastClick = this.clicks[this.clicks.length - 1];
        if (lastClick && Math.abs(x - lastClick.x) + Math.abs(y - lastClick.y) < $1b6cd4304c8b74ff$var$RAGE_CLICK_THRESHOLD_PX && timestamp - lastClick.timestamp < $1b6cd4304c8b74ff$var$RAGE_CLICK_TIMEOUT_MS) {
            this.clicks.push({
                x: x,
                y: y,
                timestamp: timestamp
            });
            if (this.clicks.length === $1b6cd4304c8b74ff$var$RAGE_CLICK_CLICK_COUNT) this.instance.capture('$rageclick');
        } else this.clicks = [
            {
                x: x,
                y: y,
                timestamp: timestamp
            }
        ];
    };
    return RageClick;
}();
/**
 * Scroll extension to add scroll get scroll depth in percentage
 */ var $1b6cd4304c8b74ff$var$ScrollDepth = /** @class */ function() {
    function ScrollDepth(instance) {
        this.instance = instance;
        this.lastScrollDepth = 0;
        this.canSend = true;
        this.documentElement = document.documentElement;
    }
    /**
     * Track scroll depth
     * @description this function will be called on every scroll event to track scroll depth
     */ ScrollDepth.prototype.track = function() {
        var scrollDepth = this.getScrollDepth();
        // If scroll depth is greater than last scroll depth, then update last scroll depth
        // We are doing this to only get the maximum scroll depth
        if (scrollDepth > this.lastScrollDepth) {
            this.lastScrollDepth = scrollDepth;
            this.canSend = true;
        }
    };
    /**
     * Send scroll depth event
     * @description this function will be when we want to send scroll depth event e.g. on page visibility change
     */ ScrollDepth.prototype.send = function(eventType) {
        if (eventType === void 0) eventType = "$scroll";
        if (!this.canSend) return;
        // Creating payload
        var props = {
            percent: this.lastScrollDepth,
            window_height: this.getWindowHeight(),
            document_height: this.getDocumentHeight(),
            scroll_distance: this.getScrollDistance()
        };
        // Sending event
        this.instance.capture(eventType, props);
        // Setting canSend to false, for avoiding sending multiple events
        this.canSend = false;
    };
    /**
     * Core method to get scroll depth
     */ ScrollDepth.prototype.getScrollDepth = function() {
        try {
            // Get the height of the window and the document body
            var winHeight = this.getWindowHeight();
            var docHeight = this.getDocumentHeight();
            // Get the current scroll position and the length of the track
            var scrollTop = this.getScrollDistance();
            var trackLength = docHeight - winHeight;
            // Calculate the scroll depth as a percentage
            return Math.min(100, Math.floor(scrollTop / trackLength * 100));
        } catch (e) {
            return 0;
        }
    };
    /**
     * Core method to get window height
     */ ScrollDepth.prototype.getWindowHeight = function() {
        try {
            return window.innerHeight || this.documentElement.clientHeight || document.body.clientHeight || 0;
        } catch (e) {
            return 0;
        }
    };
    /**
     * Core method to get document height
     */ ScrollDepth.prototype.getDocumentHeight = function() {
        try {
            return Math.max(document.body.scrollHeight || 0, this.documentElement.scrollHeight || 0, document.body.offsetHeight || 0, this.documentElement.offsetHeight || 0, document.body.clientHeight || 0, this.documentElement.clientHeight || 0);
        } catch (e) {
            return 0;
        }
    };
    /**
     * Core method to get scroll distance
     */ ScrollDepth.prototype.getScrollDistance = function() {
        try {
            return window.scrollY || window.pageYOffset || document.body.scrollTop || this.documentElement.scrollTop || 0;
        } catch (e) {
            return 0;
        }
    };
    return ScrollDepth;
}();
var $1b6cd4304c8b74ff$var$autocapture = {
    _initializedTokens: [],
    _previousElementSibling: function(el) {
        if (el.previousElementSibling) return el.previousElementSibling;
        else {
            var _el = el;
            do _el = _el.previousSibling; // resolves to ChildNode->Node, which is Element's parent class
            while (_el && !$1b6cd4304c8b74ff$var$isElementNode(_el));
            return _el;
        }
    },
    _getPropertiesFromElement: function(elem, maskInputs, maskText) {
        var tag_name = elem.tagName.toLowerCase();
        var props = {
            tag_name: tag_name
        };
        if ($1b6cd4304c8b74ff$var$usefulElements.indexOf(tag_name) > -1 && !maskText) props['$el_text'] = $1b6cd4304c8b74ff$var$getSafeText(elem);
        var classes = $1b6cd4304c8b74ff$var$getClassName(elem);
        if (classes.length > 0) props['classes'] = classes.split(' ').filter(function(c) {
            return c !== '';
        });
        $1b6cd4304c8b74ff$var$_each(elem.attributes, function(attr) {
            // Only capture attributes we know are safe
            if ($1b6cd4304c8b74ff$var$isSensitiveElement(elem) && [
                'name',
                'id',
                'class'
            ].indexOf(attr.name) === -1) return;
            if (!maskInputs && $1b6cd4304c8b74ff$var$shouldCaptureValue(attr.value) && !$1b6cd4304c8b74ff$var$isAngularStyleAttr(attr.name)) props['attr__' + attr.name] = attr.value;
        });
        var nthChild = 1;
        var nthOfType = 1;
        var currentElem = elem;
        while(currentElem = this._previousElementSibling(currentElem)){
            // eslint-disable-line no-cond-assign
            nthChild++;
            if (currentElem.tagName === elem.tagName) nthOfType++;
        }
        props['nth_child'] = nthChild;
        props['nth_of_type'] = nthOfType;
        return props;
    },
    _getDefaultProperties: function(eventType) {
        return {
            $event_type: eventType,
            $ce_version: 1
        };
    },
    _extractCustomPropertyValue: function(customProperty) {
        var propValues = [];
        $1b6cd4304c8b74ff$var$_each(document.querySelectorAll(customProperty['css_selector']), function(matchedElem) {
            var value;
            if ([
                'input',
                'select'
            ].indexOf(matchedElem.tagName.toLowerCase()) > -1) value = matchedElem['value'];
            else if (matchedElem['textContent']) value = matchedElem['textContent'];
            if ($1b6cd4304c8b74ff$var$shouldCaptureValue(value)) propValues.push(value);
        });
        return propValues.join(', ');
    },
    // TODO: delete custom_properties after changeless typescript refactor
    _getCustomProperties: function(targetElementList) {
        var _this = this;
        var props = {}; // will be deleted
        $1b6cd4304c8b74ff$var$_each(this._customProperties, function(customProperty) {
            $1b6cd4304c8b74ff$var$_each(customProperty['event_selectors'], function(eventSelector) {
                var eventElements = document.querySelectorAll(eventSelector);
                $1b6cd4304c8b74ff$var$_each(eventElements, function(eventElement) {
                    if ($1b6cd4304c8b74ff$var$_includes(targetElementList, eventElement) && $1b6cd4304c8b74ff$var$shouldCaptureElement(eventElement)) props[customProperty['name']] = _this._extractCustomPropertyValue(customProperty);
                });
            });
        });
        return props;
    },
    _getEventTarget: function(e) {
        var _a;
        // https://developer.mozilla.org/en-US/docs/Web/API/Event/target#Compatibility_notes
        if (typeof e.target === 'undefined') return e.srcElement || null;
        else {
            if ((_a = e.target) === null || _a === void 0 ? void 0 : _a.shadowRoot) return e.composedPath()[0] || null;
            return e.target || null;
        }
    },
    _captureEvent: function(e, instance, opts) {
        var _this = this;
        var _a;
        /*** Don't mess with this code without running IE8 tests on it ***/ var target = this._getEventTarget(e);
        if ($1b6cd4304c8b74ff$var$isTextNode(target)) // defeat Safari bug (see: http://www.quirksmode.org/js/events_properties.html)
        target = target.parentNode || null;
        // If type is 'scroll', track the scroll depth
        if (e.type === 'scroll') {
            this.scrollDepth.track();
            return true;
        }
        // If type is visibilitychange and the page is about to be hidden, send a scroll depth event
        if (e.type === 'visibilitychange' && document.visibilityState === 'hidden' || e.type === 'popstate') {
            this.scrollDepth.send();
            return true;
        }
        if (e.type === 'click' && e instanceof MouseEvent) (_a = this.rageclicks) === null || _a === void 0 || _a.click(e.clientX, e.clientY, new Date().getTime());
        if (target && $1b6cd4304c8b74ff$var$shouldCaptureDomEvent(target, e)) {
            var targetElementList = [
                target
            ];
            var curEl = target;
            while(curEl.parentNode && !$1b6cd4304c8b74ff$var$isTag(curEl, 'body')){
                if ($1b6cd4304c8b74ff$var$isDocumentFragment(curEl.parentNode)) {
                    targetElementList.push(curEl.parentNode.host);
                    curEl = curEl.parentNode.host;
                    continue;
                }
                targetElementList.push(curEl.parentNode);
                curEl = curEl.parentNode;
            }
            var elementsJson_1 = [];
            var href_1, explicitNoCapture_1 = false;
            $1b6cd4304c8b74ff$var$_each(targetElementList, function(el) {
                var shouldCaptureEl = $1b6cd4304c8b74ff$var$shouldCaptureElement(el);
                // if the element or a parent element is an anchor tag
                // include the href as a property
                if (el.tagName.toLowerCase() === 'a') {
                    href_1 = el.getAttribute('href');
                    href_1 = shouldCaptureEl && $1b6cd4304c8b74ff$var$shouldCaptureValue(href_1) && href_1;
                }
                // allow users to programmatically prevent capturing of elements by adding class 'ph-no-capture'
                var classes = $1b6cd4304c8b74ff$var$getClassName(el).split(' ');
                if ($1b6cd4304c8b74ff$var$_includes(classes, 'ph-no-capture')) explicitNoCapture_1 = true;
                elementsJson_1.push(_this._getPropertiesFromElement(el, opts === null || opts === void 0 ? void 0 : opts.mask_all_element_attributes, opts === null || opts === void 0 ? void 0 : opts.mask_all_text));
            });
            if (!(opts === null || opts === void 0 ? void 0 : opts.mask_all_text)) elementsJson_1[0]['$el_text'] = $1b6cd4304c8b74ff$var$getSafeText(target);
            if (href_1) elementsJson_1[0]['attr__href'] = href_1;
            if (explicitNoCapture_1) return false;
            var props = $1b6cd4304c8b74ff$var$_extend(this._getDefaultProperties(e.type), {
                $elements: elementsJson_1
            }, this._getCustomProperties(targetElementList));
            instance.capture('$autocapture', props);
            return true;
        }
    },
    // only reason is to stub for unit tests
    // since you can't override window.location props
    _navigate: function(href) {
        window.location.href = href;
    },
    _addDomEventHandlers: function(instance, opts) {
        var _this = this;
        var handler = function(e) {
            e = e || window.event;
            _this._captureEvent(e, instance, opts);
        };
        $1b6cd4304c8b74ff$var$_register_event(document, 'submit', handler, false, true);
        $1b6cd4304c8b74ff$var$_register_event(document, 'change', handler, false, true);
        $1b6cd4304c8b74ff$var$_register_event(document, 'click', handler, false, true);
        $1b6cd4304c8b74ff$var$_register_event(document, 'visibilitychange', handler, false, true);
        $1b6cd4304c8b74ff$var$_register_event(document, 'scroll', handler, false, true);
        $1b6cd4304c8b74ff$var$_register_event(window, 'popstate', handler, false, true);
    },
    _customProperties: [],
    rageclicks: null,
    scrollDepth: null,
    opts: {},
    init: function(instance, opts) {
        var _this = this;
        this.rageclicks = new $1b6cd4304c8b74ff$var$RageClick(instance);
        this.scrollDepth = new $1b6cd4304c8b74ff$var$ScrollDepth(instance);
        this.opts = opts;
        if (!(document && document.body)) {
            console.debug('document not ready yet, trying again in 500 milliseconds...');
            setTimeout(function() {
                _this.readyAutocapture(instance, opts);
            }, 500);
            return;
        }
        this.readyAutocapture(instance, opts);
    },
    readyAutocapture: function(instance, opts) {
        this._addDomEventHandlers(instance, opts);
    },
    // this is a mechanism to ramp up CE with no server-side interaction.
    // when CE is active, every page load results in a decide request. we
    // need to gently ramp this up so we don't overload decide. this decides
    // deterministically if CE is enabled for this project by modding the char
    // value of the project token.
    enabledForProject: function(token, numBuckets, numEnabledBuckets) {
        if (!token) return true;
        numBuckets = !$1b6cd4304c8b74ff$var$_isUndefined(numBuckets) ? numBuckets : 10;
        numEnabledBuckets = !$1b6cd4304c8b74ff$var$_isUndefined(numEnabledBuckets) ? numEnabledBuckets : 10;
        var charCodeSum = 0;
        for(var i = 0; i < token.length; i++)charCodeSum += token.charCodeAt(i);
        return charCodeSum % numBuckets < numEnabledBuckets;
    },
    isBrowserSupported: function() {
        return $1b6cd4304c8b74ff$var$_isFunction(document.querySelectorAll);
    }
};
$1b6cd4304c8b74ff$var$_bind_instance_methods($1b6cd4304c8b74ff$var$autocapture);
$1b6cd4304c8b74ff$var$_safewrap_instance_methods($1b6cd4304c8b74ff$var$autocapture);
var $1b6cd4304c8b74ff$var$FormTracking = /** @class */ function() {
    function FormTracking(instance, trackingType) {
        if (trackingType === void 0) trackingType = 'all';
        this.instance = instance;
        this.trackingType = trackingType;
        // Wait for the DOM to be ready
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.track.bind(this));
        else this.track();
    }
    /**
     * Track form submit
     * @description this function will be called on every form submit event to track form submit
     */ FormTracking.prototype.track = function() {
        var _this = this;
        this.formElements = document.querySelectorAll('form');
        if (this.trackingType === 'tagged') this.formElements = document.querySelectorAll('form[data-um-form]');
        this.formElements.forEach(function(form) {
            form.addEventListener('submit', function(event) {
                var form = event.target;
                var props = _this._getFormDetails(form);
                _this.instance.capture('$form', $1b6cd4304c8b74ff$var$_cleanObject(props));
            });
        });
    };
    FormTracking.getInstance = function(instance, trackingType) {
        if (trackingType === void 0) trackingType = 'all';
        if (!FormTracking.instance) FormTracking.instance = new FormTracking(instance, trackingType);
        return FormTracking.instance;
    };
    FormTracking.prototype._getFormDetails = function(form) {
        var _this = this;
        var formDetails = {
            form_id: form.id,
            form_name: form.name || '',
            form_action: form.action,
            form_method: form.method
        };
        var formFields = form.querySelectorAll('input, select, textarea');
        // ignore form fields with class um-no-capture
        var filteredFormFields = Array.from(formFields).filter(function(field) {
            return !field.classList.contains('um-no-capture');
        });
        filteredFormFields.forEach(function(field, index) {
            var fieldProps = _this._getFieldProps(field, index);
            Object.assign(formDetails, fieldProps);
        });
        return formDetails;
    };
    FormTracking.prototype._getFieldProps = function(field, index) {
        var _a;
        var fieldDataAttributes = Object.keys(field.dataset).length ? JSON.stringify(field.dataset) : undefined;
        var safeValue = this.getSafeText(field);
        return _a = {}, _a["field_" + (index + 1) + "_tag"] = field.tagName.toLowerCase(), _a["field_" + (index + 1) + "_type"] = field instanceof HTMLInputElement ? field.type : undefined, _a["field_" + (index + 1) + "_data_attributes"] = fieldDataAttributes, _a["field_" + (index + 1) + "_id"] = field.id, _a["field_" + (index + 1) + "_value"] = safeValue, _a["field_" + (index + 1) + "_class"] = field.className, _a["field_" + (index + 1) + "_name"] = field.name, _a;
    };
    FormTracking.prototype.getSafeText = function(element) {
        var safeText = '';
        if ('value' in element && element.type !== "password") safeText = element.value;
        else if (element.hasChildNodes()) {
            var textNodes = Array.from(element.childNodes).filter(function(node) {
                return node.nodeType === Node.TEXT_NODE;
            });
            safeText = textNodes.map(function(node) {
                return node.textContent;
            }).join('');
        } else safeText = element.textContent || '';
        return this._scrubPotentiallySensitiveValues(safeText);
    };
    FormTracking.prototype._scrubPotentiallySensitiveValues = function(text) {
        if (!this._shouldCaptureValue(text)) return '<redacted>';
        return text;
    };
    FormTracking.prototype._shouldCaptureValue = function(value) {
        if (this._isNullish(value)) return false;
        if (this._isString(value)) {
            value = this._trim(value);
            // check to see if input value looks like a credit card number
            // see: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9781449327453/ch04s20.html
            var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
            if (ccRegex.test((value || '').replace(/[- ]/g, ''))) return false;
            // check to see if input value looks like a social security number
            var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
            if (ssnRegex.test(value)) return false;
        }
        return true;
    };
    FormTracking.prototype._isNullish = function(value) {
        return value === null || value === undefined;
    };
    FormTracking.prototype._isString = function(value) {
        return typeof value === 'string' || value instanceof String;
    };
    FormTracking.prototype._trim = function(value) {
        return value.trim().replace(/^\s+|\s+$/g, '');
    };
    return FormTracking;
}();
var $1b6cd4304c8b74ff$var$VERSION_INFO = {
    env: 'production',
    date: '2024-05-21T10:41:05.452Z',
    version: '1.4.0'
};
var $1b6cd4304c8b74ff$var$USERMAVEN_VERSION = $1b6cd4304c8b74ff$var$VERSION_INFO.version + "/" + $1b6cd4304c8b74ff$var$VERSION_INFO.env + "@" + $1b6cd4304c8b74ff$var$VERSION_INFO.date;
var $1b6cd4304c8b74ff$var$MAX_AGE_TEN_YEARS = 316224000;
var $1b6cd4304c8b74ff$var$beaconTransport = function(url, json) {
    $1b6cd4304c8b74ff$var$getLogger().debug("Sending beacon", json);
    var blob = new Blob([
        json
    ], {
        type: "text/plain"
    });
    navigator.sendBeacon(url, blob);
    return Promise.resolve();
};
function $1b6cd4304c8b74ff$var$tryFormat(string) {
    if (typeof string === "string") try {
        return JSON.stringify(JSON.parse(string), null, 2);
    } catch (e) {
        return string;
    }
}
var $1b6cd4304c8b74ff$var$echoTransport = function(url, json) {
    console.debug("Jitsu client tried to send payload to " + url, $1b6cd4304c8b74ff$var$tryFormat(json));
    return Promise.resolve();
};
// This is a hack to expire all cookies with non-root path left behind by invalid tracking.
// TODO remove soon
function $1b6cd4304c8b74ff$var$expireNonRootCookies(name, path) {
    if (path === void 0) path = undefined;
    path = path !== null && path !== void 0 ? path : window.location.pathname;
    if (path == "" || path == "/") return;
    $1b6cd4304c8b74ff$var$deleteCookie(name, path);
    $1b6cd4304c8b74ff$var$expireNonRootCookies(name, path.slice(0, path.lastIndexOf("/")));
}
var $1b6cd4304c8b74ff$var$CookiePersistence = /** @class */ function() {
    function CookiePersistence(cookieDomain, cookieName) {
        this.cookieDomain = cookieDomain;
        this.cookieName = cookieName;
    }
    CookiePersistence.prototype.save = function(props) {
        $1b6cd4304c8b74ff$var$setCookie(this.cookieName, JSON.stringify(props), {
            domain: this.cookieDomain,
            secure: document.location.protocol !== "http:",
            maxAge: $1b6cd4304c8b74ff$var$MAX_AGE_TEN_YEARS
        });
    };
    CookiePersistence.prototype.restore = function() {
        $1b6cd4304c8b74ff$var$expireNonRootCookies(this.cookieName);
        var str = $1b6cd4304c8b74ff$var$getCookie(this.cookieName);
        if (str) try {
            var parsed = JSON.parse(decodeURIComponent(str));
            if (typeof parsed !== "object") {
                $1b6cd4304c8b74ff$var$getLogger().warn("Can't restore value of " + this.cookieName + "@" + this.cookieDomain + ", expected to be object, but found " + (typeof parsed !== "object") + ": " + parsed + ". Ignoring");
                return undefined;
            }
            return parsed;
        } catch (e) {
            $1b6cd4304c8b74ff$var$getLogger().error("Failed to decode JSON from " + str, e);
            return undefined;
        }
        return undefined;
    };
    CookiePersistence.prototype.delete = function() {
        $1b6cd4304c8b74ff$var$deleteCookie(this.cookieName);
    };
    return CookiePersistence;
}();
var $1b6cd4304c8b74ff$var$NoPersistence = /** @class */ function() {
    function NoPersistence() {}
    NoPersistence.prototype.save = function(props) {};
    NoPersistence.prototype.restore = function() {
        return undefined;
    };
    NoPersistence.prototype.delete = function() {};
    return NoPersistence;
}();
var $1b6cd4304c8b74ff$var$defaultCompatMode = false;
function $1b6cd4304c8b74ff$var$usermavenClient(opts) {
    var client = new $1b6cd4304c8b74ff$var$UsermavenClientImpl();
    client.init(opts);
    return client;
}
var $1b6cd4304c8b74ff$var$browserEnv = {
    getSourceIp: function() {
        return undefined;
    },
    describeClient: function() {
        return {
            referer: document.referrer,
            url: window.location.href,
            page_title: document.title,
            doc_path: document.location.pathname,
            doc_host: document.location.hostname,
            doc_search: window.location.search,
            screen_resolution: screen.width + "x" + screen.height,
            vp_size: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) + "x" + Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
            user_agent: navigator.userAgent,
            user_language: navigator.language,
            doc_encoding: document.characterSet
        };
    },
    getAnonymousId: function(_a) {
        var name = _a.name, domain = _a.domain, _b = _a.crossDomainLinking, crossDomainLinking = _b === void 0 ? true : _b;
        $1b6cd4304c8b74ff$var$expireNonRootCookies(name);
        // Check if cross domain linking is enabled
        if (crossDomainLinking) {
            // Try to extract the '_um' parameter from query string and hash fragment (https://example.com#_um=1~abcde5~)
            var urlParams = new URLSearchParams(window.location.search);
            var queryId = urlParams.get('_um');
            var urlHash = window.location.hash.substring(1);
            var hashedValues = urlHash.split("~");
            var fragmentId = hashedValues.length > 1 ? hashedValues[1] : undefined;
            // If the '_um' parameter is set in both the query string and hash fragment,
            // prioritize the one in query string
            var crossDomainAnonymousId = queryId || fragmentId;
            // If coming from another domain, use the ID from URL parameter
            if (crossDomainAnonymousId) {
                $1b6cd4304c8b74ff$var$getLogger().debug("Existing user id from other domain", crossDomainAnonymousId);
                // Check if the ID needs to be set as cookie
                var currentCookie = $1b6cd4304c8b74ff$var$getCookie(name);
                if (!currentCookie || currentCookie !== crossDomainAnonymousId) $1b6cd4304c8b74ff$var$setCookie(name, crossDomainAnonymousId, {
                    domain: domain,
                    secure: document.location.protocol !== "http:",
                    maxAge: $1b6cd4304c8b74ff$var$MAX_AGE_TEN_YEARS
                });
                return crossDomainAnonymousId;
            }
        }
        var idCookie = $1b6cd4304c8b74ff$var$getCookie(name);
        if (idCookie) {
            $1b6cd4304c8b74ff$var$getLogger().debug("Existing user id", idCookie);
            return idCookie;
        }
        var newId = $1b6cd4304c8b74ff$var$generateId();
        $1b6cd4304c8b74ff$var$getLogger().debug("New user id", newId);
        $1b6cd4304c8b74ff$var$setCookie(name, newId, {
            domain: domain,
            secure: document.location.protocol !== "http:",
            maxAge: $1b6cd4304c8b74ff$var$MAX_AGE_TEN_YEARS
        });
        return newId;
    }
};
function $1b6cd4304c8b74ff$var$ensurePrefix(prefix, str) {
    if (!str) return str;
    return (str === null || str === void 0 ? void 0 : str.length) > 0 && str.indexOf(prefix) !== 0 ? prefix + str : str;
}
function $1b6cd4304c8b74ff$var$cutPostfix(postfixes, str) {
    for(var _i = 0, _a = typeof postfixes === "string" ? [
        postfixes
    ] : postfixes; _i < _a.length; _i++){
        var postfix = _a[_i];
        while(str && str.length > 0 && str.charAt(str.length - 1) === postfix)str = str.substring(0, str.length - 1);
    }
    return str;
}
function $1b6cd4304c8b74ff$var$httpApi(req, res, opts) {
    if (opts === void 0) opts = {};
    var header = function(req, name) {
        var vals = req.headers[name.toLowerCase()];
        if (!vals) return undefined;
        if (typeof vals === "string") return vals;
        else if (vals.length > 0) return vals.join(",");
    };
    return {
        getAnonymousId: function(_a) {
            var name = _a.name, domain = _a.domain;
            if (opts === null || opts === void 0 ? void 0 : opts.disableCookies) return "";
            var cookie = $1b6cd4304c8b74ff$var$parseCookieString(req.headers["cookie"])[name];
            if (!cookie) {
                var cookieOpts = {
                    maxAge: 316224000,
                    httpOnly: false
                };
                if (domain) cookieOpts.domain = domain;
                var newId = $1b6cd4304c8b74ff$var$generateId();
                res.setHeader("Set-Cookie", $1b6cd4304c8b74ff$var$serializeCookie(name, newId, cookieOpts));
                return newId;
            } else return cookie;
        },
        getSourceIp: function() {
            var ip = header(req, "x-forwarded-for") || header(req, "x-real-ip") || req.socket.remoteAddress;
            return ip && ip.split(",")[0].trim();
        },
        describeClient: function() {
            var url = req.url ? new URL(req.url, req.url.startsWith("http") ? undefined : "http://localhost") : {};
            var requestHost = header(req, "x-forwarded-host") || header(req, "host") || url.hostname;
            var proto = $1b6cd4304c8b74ff$var$cutPostfix([
                ":",
                "/"
            ], header(req, "x-forwarded-proto") || url.protocol);
            var query = $1b6cd4304c8b74ff$var$ensurePrefix("?", url.search);
            var path = $1b6cd4304c8b74ff$var$ensurePrefix("/", url.pathname);
            return {
                doc_encoding: "",
                doc_host: requestHost,
                doc_path: req.url,
                doc_search: query,
                page_title: "",
                referer: header(req, "referrer"),
                screen_resolution: "",
                url: proto + "://" + requestHost + (path || "") + (query || ""),
                user_agent: req.headers["user-agent"],
                user_language: req.headers["accept-language"] && req.headers["accept-language"].split(",")[0],
                vp_size: ""
            };
        }
    };
}
var $1b6cd4304c8b74ff$var$emptyEnv = {
    getSourceIp: function() {
        return undefined;
    },
    describeClient: function() {
        return {};
    },
    getAnonymousId: function() {
        return "";
    }
};
/**
 * Dictionary of supported environments
 */ var $1b6cd4304c8b74ff$var$envs = {
    httpApi: $1b6cd4304c8b74ff$var$httpApi,
    nextjsApi: $1b6cd4304c8b74ff$var$httpApi,
    // fetchApi: fetchApi,
    // nextjsMiddleware: fetchApi,
    browser: function() {
        return $1b6cd4304c8b74ff$var$browserEnv;
    },
    express: $1b6cd4304c8b74ff$var$httpApi,
    empty: function() {
        return $1b6cd4304c8b74ff$var$emptyEnv;
    }
};
var $1b6cd4304c8b74ff$var$xmlHttpTransport = function(url, jsonPayload, additionalHeaders, handler) {
    if (handler === void 0) handler = function(code, body) {};
    var req = new window.XMLHttpRequest();
    return new Promise(function(resolve, reject) {
        req.onerror = function(e) {
            $1b6cd4304c8b74ff$var$getLogger().error("Failed to send payload to " + url + ": " + ((e === null || e === void 0 ? void 0 : e.message) || "unknown error"), jsonPayload, e);
            handler(-1, {});
            reject(new Error("Failed to send JSON. See console logs"));
        };
        req.onload = function() {
            if (req.status !== 200) {
                handler(req.status, {});
                $1b6cd4304c8b74ff$var$getLogger().warn("Failed to send data to " + url + " (#" + req.status + " - " + req.statusText + ")", jsonPayload);
                reject(new Error("Failed to send JSON. Error code: " + req.status + ". See logs for details"));
            } else handler(req.status, req.responseText);
            resolve();
        };
        req.open("POST", url);
        req.setRequestHeader("Content-Type", "application/json");
        Object.entries(additionalHeaders || {}).forEach(function(_a) {
            var key = _a[0], val = _a[1];
            return req.setRequestHeader(key, val);
        });
        req.send(jsonPayload);
        $1b6cd4304c8b74ff$var$getLogger().debug("sending json", jsonPayload);
    });
};
var $1b6cd4304c8b74ff$var$fetchTransport = function(fetch) {
    return function(url, jsonPayload, additionalHeaders, handler) {
        if (handler === void 0) handler = function(code, body) {};
        return $1b6cd4304c8b74ff$var$__awaiter(void 0, void 0, void 0, function() {
            var res, e_1, resJson, text, contentType, e_2;
            var _a, _b;
            return $1b6cd4304c8b74ff$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            fetch(url, {
                                method: "POST",
                                headers: $1b6cd4304c8b74ff$var$__assign({
                                    Accept: "application/json",
                                    "Content-Type": "application/json"
                                }, additionalHeaders || {}),
                                body: jsonPayload
                            })
                        ];
                    case 1:
                        res = _c.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_1 = _c.sent();
                        $1b6cd4304c8b74ff$var$getLogger().error("Failed to send data to " + url + ": " + ((e_1 === null || e_1 === void 0 ? void 0 : e_1.message) || "unknown error"), jsonPayload, e_1);
                        handler(-1, {});
                        return [
                            2 /*return*/ 
                        ];
                    case 3:
                        if (res.status !== 200) {
                            $1b6cd4304c8b74ff$var$getLogger().warn("Failed to send data to " + url + " (#" + res.status + " - " + res.statusText + ")", jsonPayload);
                            handler(res.status, {});
                            return [
                                2 /*return*/ 
                            ];
                        }
                        resJson = {};
                        text = "";
                        contentType = (_b = (_a = res.headers) === null || _a === void 0 ? void 0 : _a.get('Content-Type')) !== null && _b !== void 0 ? _b : "";
                        _c.label = 4;
                    case 4:
                        _c.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            res.text()
                        ];
                    case 5:
                        text = _c.sent();
                        resJson = JSON.parse(text);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_2 = _c.sent();
                        $1b6cd4304c8b74ff$var$getLogger().error("Failed to parse " + url + " response. Content-type: " + contentType + " text: " + text, e_2);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        try {
                            handler(res.status, resJson);
                        } catch (e) {
                            $1b6cd4304c8b74ff$var$getLogger().error("Failed to handle " + url + " response. Content-type: " + contentType + " text: " + text, e);
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
};
var $1b6cd4304c8b74ff$var$UsermavenClientImpl = /** @class */ function() {
    function UsermavenClientImpl() {
        this.userProperties = {};
        this.groupProperties = {};
        this.permanentProperties = {
            globalProps: {},
            propsPerEvent: {}
        };
        this.cookieDomain = "";
        this.trackingHost = "";
        this.idCookieName = "";
        this.randomizeUrl = false;
        this.namespace = "usermaven";
        this.crossDomainLinking = true;
        this.formTracking = false;
        this.domains = [];
        this.apiKey = "";
        this.initialized = false;
        this._3pCookies = {};
        this.cookiePolicy = "keep";
        this.ipPolicy = "keep";
        this.beaconApi = false;
        this.transport = $1b6cd4304c8b74ff$var$xmlHttpTransport;
        this.customHeaders = function() {
            return {};
        };
        this.queue = new $1b6cd4304c8b74ff$var$MemoryQueue();
        this.maxSendAttempts = 4;
        this.retryTimeout = [
            500,
            1e12
        ];
        this.flushing = false;
        this.attempt = 1;
        this.propertyBlacklist = [];
        // public persistence?: UserMavenPersistence;
        // public sessionManager?: SessionIdManager;
        this.__autocapture_enabled = false;
        this.__auto_pageview_enabled = false;
        // private anonymousId: string = '';
        // Fallback tracking host
        this.trackingHostFallback = "https://events.usermaven.com";
    }
    // Used for session + autocapture
    UsermavenClientImpl.prototype.get_config = function(prop_name) {
        return this.config ? this.config[prop_name] : null;
    };
    UsermavenClientImpl.prototype.id = function(props, doNotSendEvent) {
        this.userProperties = $1b6cd4304c8b74ff$var$__assign($1b6cd4304c8b74ff$var$__assign({}, this.userProperties), props);
        $1b6cd4304c8b74ff$var$getLogger().debug("Usermaven user identified", props);
        if (this.userIdPersistence) this.userIdPersistence.save(props);
        else $1b6cd4304c8b74ff$var$getLogger().warn("Id() is called before initialization");
        if (!doNotSendEvent) return this.track("user_identify", {});
        else return Promise.resolve();
    };
    UsermavenClientImpl.prototype.group = function(props, doNotSendEvent) {
        this.groupProperties = $1b6cd4304c8b74ff$var$__assign($1b6cd4304c8b74ff$var$__assign({}, this.groupProperties), props);
        $1b6cd4304c8b74ff$var$getLogger().debug("Usermaven group identified", props);
        if (this.userIdPersistence) // Update the 'company' property in the user persistence
        this.userIdPersistence.save({
            company: props
        });
        else $1b6cd4304c8b74ff$var$getLogger().warn("Group() is called before initialization");
        if (!doNotSendEvent) return this.track("group", {});
        else return Promise.resolve();
    };
    UsermavenClientImpl.prototype.reset = function(resetAnonId) {
        if (this.userIdPersistence) this.userIdPersistence.delete();
        if (this.propsPersistance) this.propsPersistance.delete();
        if (resetAnonId) {
            var idCookie = $1b6cd4304c8b74ff$var$getCookie(this.idCookieName);
            if (idCookie) {
                $1b6cd4304c8b74ff$var$getLogger().debug("Removing id cookie", idCookie);
                $1b6cd4304c8b74ff$var$setCookie(this.idCookieName, "", {
                    domain: this.cookieDomain,
                    expires: new Date(0)
                });
            }
        }
        return Promise.resolve();
    };
    UsermavenClientImpl.prototype.rawTrack = function(payload) {
        return this.sendJson(payload);
    };
    UsermavenClientImpl.prototype.makeEvent = function(event_type, src, payload) {
        var _a;
        var env = payload.env, payloadData = $1b6cd4304c8b74ff$var$__rest(payload, [
            "env"
        ]);
        if (!env) env = $1b6cd4304c8b74ff$var$isWindowAvailable() ? $1b6cd4304c8b74ff$var$envs.browser() : $1b6cd4304c8b74ff$var$envs.empty();
        this.restoreId();
        var context = this.getCtx(env);
        var persistentProps = $1b6cd4304c8b74ff$var$__assign($1b6cd4304c8b74ff$var$__assign({}, this.permanentProperties.globalProps), (_a = this.permanentProperties.propsPerEvent[event_type]) !== null && _a !== void 0 ? _a : {});
        var base = $1b6cd4304c8b74ff$var$__assign({
            api_key: this.apiKey,
            src: src,
            event_type: event_type
        }, payloadData);
        var sourceIp = env.getSourceIp();
        if (sourceIp) base["source_ip"] = sourceIp;
        return this.compatMode ? $1b6cd4304c8b74ff$var$__assign($1b6cd4304c8b74ff$var$__assign($1b6cd4304c8b74ff$var$__assign({}, persistentProps), {
            eventn_ctx: context
        }), base) : $1b6cd4304c8b74ff$var$__assign($1b6cd4304c8b74ff$var$__assign($1b6cd4304c8b74ff$var$__assign({}, persistentProps), context), base);
    };
    UsermavenClientImpl.prototype._send3p = function(sourceType, object, type) {
        var eventType = "3rdparty";
        if (type && type !== "") eventType = type;
        var e = this.makeEvent(eventType, sourceType, {
            src_payload: object
        });
        return this.sendJson(e);
    };
    UsermavenClientImpl.prototype.sendJson = function(json) {
        return $1b6cd4304c8b74ff$var$__awaiter(this, void 0, Promise, function() {
            var umExclusionState;
            return $1b6cd4304c8b74ff$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        umExclusionState = $1b6cd4304c8b74ff$var$getUmExclusionState();
                        if (!!umExclusionState) return [
                            3 /*break*/ ,
                            3
                        ];
                        if (!(this.maxSendAttempts > 1)) return [
                            3 /*break*/ ,
                            1
                        ];
                        this.queue.push([
                            json,
                            0
                        ]);
                        this.scheduleFlush(0);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.doSendJson(json)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    UsermavenClientImpl.prototype.doSendJson = function(json) {
        var _this = this;
        var cookiePolicy = this.cookiePolicy !== "keep" ? "&cookie_policy=" + this.cookiePolicy : "";
        var ipPolicy = this.ipPolicy !== "keep" ? "&ip_policy=" + this.ipPolicy : "";
        var urlPrefix = $1b6cd4304c8b74ff$var$isWindowAvailable() ? "/api/v1/event" : "/api/v1/s2s/event";
        var url = "" + this.trackingHost + urlPrefix + "?token=" + this.apiKey + cookiePolicy + ipPolicy;
        if (this.randomizeUrl) url = this.trackingHost + "/api." + $1b6cd4304c8b74ff$var$generateRandom() + "?p_" + $1b6cd4304c8b74ff$var$generateRandom() + "=" + this.apiKey + cookiePolicy + ipPolicy;
        var jsonString = JSON.stringify(json);
        $1b6cd4304c8b74ff$var$getLogger().debug("Sending payload to " + url, json.length);
        return this.transport(url, jsonString, this.customHeaders(), function(code, body) {
            return _this.postHandle(code, body);
        });
    };
    UsermavenClientImpl.prototype.scheduleFlush = function(timeout) {
        var _this = this;
        if (this.flushing) return;
        this.flushing = true;
        if (typeof timeout === "undefined") {
            var random = Math.random() + 1;
            var factor = Math.pow(2, this.attempt++);
            timeout = Math.min(this.retryTimeout[0] * random * factor, this.retryTimeout[1]);
        }
        $1b6cd4304c8b74ff$var$getLogger().debug("Scheduling event queue flush in " + timeout + " ms.");
        setTimeout(function() {
            return _this.flush();
        }, timeout);
    };
    UsermavenClientImpl.prototype.flush = function() {
        return $1b6cd4304c8b74ff$var$__awaiter(this, void 0, Promise, function() {
            var queue;
            var _a;
            var _this = this;
            return $1b6cd4304c8b74ff$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if ($1b6cd4304c8b74ff$var$isWindowAvailable() && !window.navigator.onLine) {
                            this.flushing = false;
                            this.scheduleFlush();
                        }
                        queue = this.queue.flush();
                        this.flushing = false;
                        if (queue.length === 0) return [
                            2 /*return*/ 
                        ];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.doSendJson(queue.map(function(el) {
                                return el[0];
                            }))
                        ];
                    case 2:
                        _b.sent();
                        this.attempt = 1;
                        $1b6cd4304c8b74ff$var$getLogger().debug("Successfully flushed " + queue.length + " events from queue");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        _b.sent();
                        // In case of failing custom domain (trackingHost), we will replace it with default domain (trackingHostFallback)
                        if (this.trackingHost !== this.trackingHostFallback) {
                            $1b6cd4304c8b74ff$var$getLogger().debug("Using fallback tracking host " + this.trackingHostFallback + " instead of " + this.trackingHost + " on " + $1b6cd4304c8b74ff$var$VERSION_INFO.env);
                            this.trackingHost = this.trackingHostFallback;
                        }
                        queue = queue.map(function(el) {
                            return [
                                el[0],
                                el[1] + 1
                            ];
                        }).filter(function(el) {
                            if (el[1] >= _this.maxSendAttempts) {
                                $1b6cd4304c8b74ff$var$getLogger().error("Dropping queued event after " + el[1] + " attempts since max send attempts " + _this.maxSendAttempts + " reached. See logs for details");
                                return false;
                            }
                            return true;
                        });
                        if (queue.length > 0) {
                            (_a = this.queue).push.apply(_a, queue);
                            this.scheduleFlush();
                        } else this.attempt = 1;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    UsermavenClientImpl.prototype.postHandle = function(status, response) {
        if (this.cookiePolicy === "strict" || this.cookiePolicy === "comply") {
            if (status === 200) {
                var data = response;
                if (typeof response === "string") data = JSON.parse(response);
                if (!data["delete_cookie"]) return;
            }
            this.userIdPersistence.delete();
            this.propsPersistance.delete();
            $1b6cd4304c8b74ff$var$deleteCookie(this.idCookieName);
        }
        if (status === 200) {
            var data = response;
            if (typeof response === "string" && response.length > 0) {
                data = JSON.parse(response);
                var extras = data["jitsu_sdk_extras"];
                if (extras && extras.length > 0) {
                    var isWindow = $1b6cd4304c8b74ff$var$isWindowAvailable();
                    if (!isWindow) $1b6cd4304c8b74ff$var$getLogger().error("Tags destination supported only in browser environment");
                    else for(var _i = 0, extras_1 = extras; _i < extras_1.length; _i++){
                        var _a = extras_1[_i], type = _a.type, id = _a.id, value = _a.value;
                        if (type === "tag") {
                            var tag = document.createElement("div");
                            tag.id = id;
                            $1b6cd4304c8b74ff$var$insertAndExecute(tag, value);
                            if (tag.childElementCount > 0) document.body.appendChild(tag);
                        }
                    }
                }
            }
        }
    };
    UsermavenClientImpl.prototype.getCtx = function(env) {
        var now = new Date();
        var props = env.describeClient() || {};
        var user = $1b6cd4304c8b74ff$var$__assign({}, this.userProperties);
        var company = user['company'] || {};
        delete user['company'];
        var payload = $1b6cd4304c8b74ff$var$__assign($1b6cd4304c8b74ff$var$__assign({
            event_id: "",
            user: $1b6cd4304c8b74ff$var$__assign({
                anonymous_id: this.cookiePolicy !== "strict" ? env.getAnonymousId({
                    name: this.idCookieName,
                    domain: this.cookieDomain,
                    crossDomainLinking: this.crossDomainLinking
                }) : ""
            }, user),
            ids: this._getIds(),
            utc_time: $1b6cd4304c8b74ff$var$reformatDate(now.toISOString()),
            local_tz_offset: now.getTimezoneOffset()
        }, props), $1b6cd4304c8b74ff$var$getDataFromParams($1b6cd4304c8b74ff$var$parseQuery(props.doc_search)));
        // id and name attributes will be checked on backend
        if (Object.keys(company).length) payload['company'] = company;
        return payload;
    };
    UsermavenClientImpl.prototype._getIds = function() {
        if (!$1b6cd4304c8b74ff$var$isWindowAvailable()) return {};
        var cookies = $1b6cd4304c8b74ff$var$getCookies(false);
        var res = {};
        for(var _i = 0, _a = Object.entries(cookies); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (this._3pCookies[key]) res[key.charAt(0) == "_" ? key.substr(1) : key] = value;
        }
        return res;
    };
    UsermavenClientImpl.prototype.pathMatches = function(wildcardPath, docUrl) {
        var actualPath = new URL(docUrl).pathname;
        return actualPath.match(new RegExp('^' + wildcardPath.trim().replace(/\*\*/g, '.*').replace(/([^\.])\*/g, '$1[^\\s\/]*') + '\/?$'));
    };
    UsermavenClientImpl.prototype.track = function(type, payload) {
        var _this = this;
        var data = payload || {};
        $1b6cd4304c8b74ff$var$getLogger().debug("track event of type", type, data);
        var env = $1b6cd4304c8b74ff$var$isWindowAvailable() ? $1b6cd4304c8b74ff$var$envs.browser() : $1b6cd4304c8b74ff$var$envs.empty();
        var context = this.getCtx(env);
        // Check if the page is not excluded.
        if (this.config && this.config.exclude && this.config.exclude.length > 1 && (context === null || context === void 0 ? void 0 : context.url)) {
            var excludeList = this.config.exclude.split(',');
            // check if the current page is in the exclude list
            if (excludeList.some(function(excludePage) {
                return _this.pathMatches(excludePage.trim(), context === null || context === void 0 ? void 0 : context.url);
            })) {
                $1b6cd4304c8b74ff$var$getLogger().debug("Page is excluded from tracking");
                return;
            }
        }
        var p = payload || {};
        // All custom events and scroll event will have event_attributes
        if (type !== "$autocapture" && type !== "user_identify" && type !== "pageview" && type !== "$pageleave") p = {
            event_attributes: payload
        };
        var e = this.makeEvent(type, this.compatMode ? "eventn" : "usermaven", p);
        return this.sendJson(e);
    };
    UsermavenClientImpl.prototype.init = function(options) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        if ($1b6cd4304c8b74ff$var$isWindowAvailable() && !options.force_use_fetch) {
            if (options.fetch) $1b6cd4304c8b74ff$var$getLogger().warn("Custom fetch implementation is provided to Usermaven. However, it will be ignored since Usermaven runs in browser");
            this.transport = this.beaconApi ? $1b6cd4304c8b74ff$var$beaconTransport : $1b6cd4304c8b74ff$var$xmlHttpTransport;
        } else {
            if (!options.fetch && !globalThis.fetch) throw new Error("Usermaven runs in Node environment. However, neither UsermavenOptions.fetch is provided, nor global fetch function is defined. \nPlease, provide custom fetch implementation. You can get it via node-fetch package");
            this.transport = $1b6cd4304c8b74ff$var$fetchTransport(options.fetch || globalThis.fetch);
        }
        if (options.custom_headers && typeof options.custom_headers === "function") this.customHeaders = options.custom_headers;
        else if (options.custom_headers) this.customHeaders = function() {
            return options.custom_headers;
        };
        if (options.tracking_host === "echo") {
            $1b6cd4304c8b74ff$var$getLogger().warn('jitsuClient is configured with "echo" transport. Outgoing requests will be written to console');
            this.transport = $1b6cd4304c8b74ff$var$echoTransport;
        }
        if (options.ip_policy) this.ipPolicy = options.ip_policy;
        if (options.cookie_policy) this.cookiePolicy = options.cookie_policy;
        if (options.privacy_policy === "strict") {
            this.ipPolicy = "strict";
            this.cookiePolicy = "strict";
        }
        if (options.use_beacon_api && navigator.sendBeacon) this.beaconApi = true;
        //can't handle delete cookie response when beacon api
        if (this.cookiePolicy === "comply" && this.beaconApi) this.cookiePolicy = "strict";
        if (options.log_level) $1b6cd4304c8b74ff$var$setRootLogLevel(options.log_level);
        this.initialOptions = options;
        $1b6cd4304c8b74ff$var$getLogger().debug("Initializing Usemaven Tracker tracker", options, $1b6cd4304c8b74ff$var$USERMAVEN_VERSION);
        if (!options.key) {
            $1b6cd4304c8b74ff$var$getLogger().error("Can't initialize Usemaven, key property is not set");
            return;
        }
        this.compatMode = options.compat_mode === undefined ? $1b6cd4304c8b74ff$var$defaultCompatMode : !!options.compat_mode;
        this.cookieDomain = options.cookie_domain || $1b6cd4304c8b74ff$var$getCookieDomain();
        this.namespace = options.namespace || "usermaven";
        this.crossDomainLinking = (_a = options.cross_domain_linking) !== null && _a !== void 0 ? _a : true;
        this.formTracking = (_b = options.form_tracking) !== null && _b !== void 0 ? _b : false;
        this.domains = options.domains ? options.domains.split(',').map(function(domain) {
            return domain.trim();
        }) : [];
        this.trackingHost = $1b6cd4304c8b74ff$var$getHostWithProtocol(options["tracking_host"] || "t.usermaven.com");
        this.randomizeUrl = options.randomize_url || false;
        this.apiKey = options.key;
        this.__auto_pageview_enabled = options.auto_pageview || false;
        this.idCookieName = options.cookie_name || "__eventn_id_" + options.key;
        if (this.cookiePolicy === "strict") this.propsPersistance = new $1b6cd4304c8b74ff$var$NoPersistence();
        else this.propsPersistance = $1b6cd4304c8b74ff$var$isWindowAvailable() ? new $1b6cd4304c8b74ff$var$CookiePersistence(this.cookieDomain, this.idCookieName + "_props") : new $1b6cd4304c8b74ff$var$NoPersistence();
        if (this.cookiePolicy === "strict") this.userIdPersistence = new $1b6cd4304c8b74ff$var$NoPersistence();
        else this.userIdPersistence = $1b6cd4304c8b74ff$var$isWindowAvailable() ? new $1b6cd4304c8b74ff$var$CookiePersistence(this.cookieDomain, this.idCookieName + "_usr") : new $1b6cd4304c8b74ff$var$NoPersistence();
        if (this.propsPersistance) {
            var restored = this.propsPersistance.restore();
            if (restored) {
                this.permanentProperties = restored;
                this.permanentProperties.globalProps = (_c = restored.globalProps) !== null && _c !== void 0 ? _c : {};
                this.permanentProperties.propsPerEvent = (_d = restored.propsPerEvent) !== null && _d !== void 0 ? _d : {};
            }
            $1b6cd4304c8b74ff$var$getLogger().debug("Restored persistent properties", this.permanentProperties);
        }
        this.propertyBlacklist = options.property_blacklist && options.property_blacklist.length > 0 ? options.property_blacklist : [];
        // // Added these configuration for session management + autocapture
        var defaultConfig = {
            autocapture: false,
            properties_string_max_length: null,
            property_blacklist: [],
            sanitize_properties: null,
            auto_pageview: false
        };
        this.config = $1b6cd4304c8b74ff$var$_extend({}, defaultConfig, options || {}, this.config || {}, {
            token: this.apiKey
        });
        $1b6cd4304c8b74ff$var$getLogger().debug('Default Configuration', this.config);
        // this.manageSession(this.config);
        this.manageAutoCapture(this.config);
        this.manageFormTracking(this.config);
        this.manageCrossDomainLinking({
            cross_domain_linking: this.crossDomainLinking,
            domains: this.domains,
            cookiePolicy: this.cookiePolicy
        });
        if (options.capture_3rd_party_cookies === false) this._3pCookies = {};
        else (options.capture_3rd_party_cookies || [
            "_ga",
            "_fbp",
            "_ym_uid",
            "ajs_user_id",
            "ajs_anonymous_id"
        ]).forEach(function(name) {
            return _this._3pCookies[name] = true;
        });
        if (options.ga_hook) $1b6cd4304c8b74ff$var$getLogger().warn("GA event interceptor isn't supported anymore");
        if (options.segment_hook) $1b6cd4304c8b74ff$var$interceptSegmentCalls(this);
        if ($1b6cd4304c8b74ff$var$isWindowAvailable()) {
            if (!options.disable_event_persistence) {
                this.queue = new $1b6cd4304c8b74ff$var$LocalStorageQueue(this.namespace + "-event-queue");
                this.scheduleFlush(0);
            }
            window.addEventListener("beforeunload", function() {
                return _this.flush();
            });
        }
        if (this.__auto_pageview_enabled) $1b6cd4304c8b74ff$var$enableAutoPageviews(this);
        this.retryTimeout = [
            (_e = options.min_send_timeout) !== null && _e !== void 0 ? _e : this.retryTimeout[0],
            (_f = options.max_send_timeout) !== null && _f !== void 0 ? _f : this.retryTimeout[1]
        ];
        if (!!options.max_send_attempts) this.maxSendAttempts = options.max_send_attempts;
        this.initialized = true;
    };
    UsermavenClientImpl.prototype.interceptAnalytics = function(analytics) {
        var _this = this;
        var interceptor = function(chain) {
            var _a;
            try {
                var payload = $1b6cd4304c8b74ff$var$__assign({}, chain.payload);
                $1b6cd4304c8b74ff$var$getLogger().debug("Intercepted segment payload", payload.obj);
                var integration = chain.integrations["Segment.io"];
                if (integration && integration.analytics) {
                    var analyticsOriginal = integration.analytics;
                    if (typeof analyticsOriginal.user === "function" && analyticsOriginal.user() && typeof analyticsOriginal.user().id === "function") payload.obj.userId = analyticsOriginal.user().id();
                }
                if ((_a = payload === null || payload === void 0 ? void 0 : payload.obj) === null || _a === void 0 ? void 0 : _a.timestamp) payload.obj.sentAt = payload.obj.timestamp;
                var type = chain.payload.type();
                if (type === "track") type = chain.payload.event();
                _this._send3p("ajs", payload, type);
            } catch (e) {
                $1b6cd4304c8b74ff$var$getLogger().warn("Failed to send an event", e);
            }
            chain.next(chain.payload);
        };
        if (typeof analytics.addSourceMiddleware === "function") {
            //analytics is fully initialized
            $1b6cd4304c8b74ff$var$getLogger().debug("Analytics.js is initialized, calling addSourceMiddleware");
            analytics.addSourceMiddleware(interceptor);
        } else {
            $1b6cd4304c8b74ff$var$getLogger().debug("Analytics.js is not initialized, pushing addSourceMiddleware to callstack");
            analytics.push([
                "addSourceMiddleware",
                interceptor
            ]);
        }
        analytics["__en_intercepted"] = true;
    };
    UsermavenClientImpl.prototype.restoreId = function() {
        if (this.userIdPersistence) {
            var props = this.userIdPersistence.restore();
            if (props) this.userProperties = $1b6cd4304c8b74ff$var$__assign($1b6cd4304c8b74ff$var$__assign({}, props), this.userProperties);
        }
    };
    UsermavenClientImpl.prototype.set = function(properties, opts) {
        var _a;
        var eventType = opts === null || opts === void 0 ? void 0 : opts.eventType;
        var persist = (opts === null || opts === void 0 ? void 0 : opts.persist) === undefined || (opts === null || opts === void 0 ? void 0 : opts.persist);
        if (eventType !== undefined) {
            var current = (_a = this.permanentProperties.propsPerEvent[eventType]) !== null && _a !== void 0 ? _a : {};
            this.permanentProperties.propsPerEvent[eventType] = $1b6cd4304c8b74ff$var$__assign($1b6cd4304c8b74ff$var$__assign({}, current), properties);
        } else this.permanentProperties.globalProps = $1b6cd4304c8b74ff$var$__assign($1b6cd4304c8b74ff$var$__assign({}, this.permanentProperties.globalProps), properties);
        if (this.propsPersistance && persist) this.propsPersistance.save(this.permanentProperties);
    };
    UsermavenClientImpl.prototype.unset = function(propertyName, opts) {
        $1b6cd4304c8b74ff$var$requireWindow();
        var eventType = opts === null || opts === void 0 ? void 0 : opts.eventType;
        var persist = (opts === null || opts === void 0 ? void 0 : opts.persist) === undefined || (opts === null || opts === void 0 ? void 0 : opts.persist);
        if (!eventType) delete this.permanentProperties.globalProps[propertyName];
        else if (this.permanentProperties.propsPerEvent[eventType]) delete this.permanentProperties.propsPerEvent[eventType][propertyName];
        if (this.propsPersistance && persist) this.propsPersistance.save(this.permanentProperties);
    };
    UsermavenClientImpl.prototype.manageCrossDomainLinking = function(options) {
        if (!$1b6cd4304c8b74ff$var$isWindowAvailable() || !options.cross_domain_linking || options.domains.length === 0 || options.cookiePolicy === "strict") return false;
        var cookieName = this.idCookieName;
        var domains = options.domains || [];
        // Listen for all clicks on the page
        document.addEventListener('click', function(event) {
            // Find the closest link
            var target = $1b6cd4304c8b74ff$var$_findClosestLink(event.target);
            if (target) {
                // Check if the link is pointing to a different domain
                var href = (target === null || target === void 0 ? void 0 : target.hasAttribute('href')) ? target === null || target === void 0 ? void 0 : target.getAttribute('href') : '';
                if (href && href.startsWith('http')) {
                    var url = new URL(href);
                    var cookie = $1b6cd4304c8b74ff$var$getCookie(cookieName);
                    // Skip the link if it's pointing to the current domain
                    if (url.hostname === window.location.hostname) return;
                    if (domains.includes(url.hostname) && cookie) {
                        // Add the '_um' parameter to the URL
                        url.searchParams.append('_um', cookie);
                        target.setAttribute('href', url.toString());
                    }
                }
            }
        }, false);
    };
    /**
     * Manage auto-capturing
     * @param options
     */ UsermavenClientImpl.prototype.manageAutoCapture = function(options) {
        $1b6cd4304c8b74ff$var$getLogger().debug("Auto Capture Status: ", this.config['autocapture']);
        this.__autocapture_enabled = this.config['autocapture'] && $1b6cd4304c8b74ff$var$isWindowAvailable();
        if (!this.__autocapture_enabled) return;
        var num_buckets = 100;
        var num_enabled_buckets = 100;
        if (!$1b6cd4304c8b74ff$var$autocapture.enabledForProject(this.apiKey, num_buckets, num_enabled_buckets)) {
            this.config['autocapture'] = false;
            this.__autocapture_enabled = false;
            $1b6cd4304c8b74ff$var$getLogger().debug('Not in active bucket: disabling Automatic Event Collection.');
        } else if (!$1b6cd4304c8b74ff$var$autocapture.isBrowserSupported()) {
            this.config['autocapture'] = false;
            this.__autocapture_enabled = false;
            $1b6cd4304c8b74ff$var$getLogger().debug('Disabling Automatic Event Collection because this browser is not supported');
        } else {
            $1b6cd4304c8b74ff$var$getLogger().debug('Autocapture enabled...');
            $1b6cd4304c8b74ff$var$autocapture.init(this, options);
        }
    };
    /**
     * Manage form tracking
     */ UsermavenClientImpl.prototype.manageFormTracking = function(options) {
        if (!$1b6cd4304c8b74ff$var$isWindowAvailable() || !this.formTracking || this.formTracking === "none") return;
        $1b6cd4304c8b74ff$var$getLogger().debug('Form tracking enabled...');
        // all and true are the same
        var trackingType = this.formTracking === true ? 'all' : this.formTracking;
        $1b6cd4304c8b74ff$var$FormTracking.getInstance(this, trackingType).track();
    };
    /**
     * Capture an event. This is the most important and
     * frequently used usermaven function.
     *
     * ### Usage:
     *     usermaven.capture('Registered', {'Gender': 'Male', 'Age': 21}, {});
     *
     * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
     * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
     * @param {Object} [options] Optional configuration for this capture request.
     * @param {String} [options.transport] Transport method for network request ('XHR' or 'sendBeacon').
     */ UsermavenClientImpl.prototype.capture = function(event_name, properties) {
        var _a, _b;
        if (properties === void 0) properties = {};
        if (!this.initialized) {
            console.error('Trying to capture event before initialization');
            return;
        }
        if ($1b6cd4304c8b74ff$var$_isUndefined(event_name) || typeof event_name !== 'string') {
            console.error('No event name provided to usermaven.capture');
            return;
        }
        // if (_.isBlockedUA(userAgent)) {
        //   return
        // }
        var data = {
            event: event_name + (properties['$event_type'] ? '_' + properties['$event_type'] : ''),
            properties: this._calculate_event_properties(event_name, properties)
        };
        data = $1b6cd4304c8b74ff$var$_copyAndTruncateStrings(data, this.get_config('properties_string_max_length'));
        // send event if there is a tagname available
        if ((_b = (_a = data.properties) === null || _a === void 0 ? void 0 : _a.autocapture_attributes) === null || _b === void 0 ? void 0 : _b.tag_name) this.track("$autocapture", data.properties);
        // send event if the event is $scroll
        if (event_name === '$scroll') this.track(event_name, data.properties);
        // send event if the event is $form
        if (event_name === '$form') this.track(event_name, data.properties);
    };
    UsermavenClientImpl.prototype._calculate_event_properties = function(event_name, event_properties) {
        var _a, _b;
        // set defaults
        var properties = event_properties || {};
        if (event_name === '$snapshot' || event_name === '$scroll' || event_name === '$form') return properties;
        if ($1b6cd4304c8b74ff$var$_isArray(this.propertyBlacklist)) $1b6cd4304c8b74ff$var$_each(this.propertyBlacklist, function(blacklisted_prop) {
            delete properties[blacklisted_prop];
        });
        else console.error('Invalid value for property_blacklist config: ' + this.propertyBlacklist);
        // assign first element from $elements only
        var attributes = {};
        var elements = properties['$elements'] || [];
        if (elements.length) attributes = elements[0];
        properties['autocapture_attributes'] = attributes;
        properties['autocapture_attributes']["el_text"] = (_a = properties['autocapture_attributes']["$el_text"]) !== null && _a !== void 0 ? _a : "";
        properties['autocapture_attributes']["event_type"] = (_b = properties["$event_type"]) !== null && _b !== void 0 ? _b : "";
        [
            '$ce_version',
            "$event_type",
            "$initial_referrer",
            "$initial_referring_domain",
            "$referrer",
            "$referring_domain",
            "$elements"
        ].forEach(function(key) {
            delete properties[key];
        });
        // TODO: later remove this from the autotrack code.
        delete properties['autocapture_attributes']["$el_text"];
        delete properties['autocapture_attributes']["nth_child"];
        delete properties['autocapture_attributes']["nth_of_type"];
        return properties;
    };
    return UsermavenClientImpl;
}();
function $1b6cd4304c8b74ff$var$enableAutoPageviews(t) {
    var page = function() {
        return t.track("pageview");
    };
    // Attach pushState and popState listeners
    var originalPushState = history.pushState;
    if (originalPushState) {
        // eslint-disable-next-line functional/immutable-data
        history.pushState = function(data, title, url) {
            originalPushState.apply(this, [
                data,
                title,
                url
            ]);
            page();
        };
        addEventListener('popstate', page);
    }
    addEventListener('hashchange', page);
}
function $1b6cd4304c8b74ff$var$interceptSegmentCalls(t) {
    var win = window;
    if (!win.analytics) win.analytics = [];
    t.interceptAnalytics(win.analytics);
}
function $1b6cd4304c8b74ff$export$5d730b7aed1a3eb0(params) {
    return $1b6cd4304c8b74ff$var$usermavenClient(params);
}
function $1b6cd4304c8b74ff$export$346b73153e5ac4d0() {
    const client = (0, $6fFrj.useContext)($1b6cd4304c8b74ff$export$d8d3dbd8639f022f);
    if (!client) throw new Error("Before calling useUsermaven() hook, please wrap your component into <JitsuProvider />. Read more in http://jitsu.com/docs/sending-data/js-sdk/react");
    const id = (0, $6fFrj.useCallback)((userData, doNotSendEvent)=>client === null || client === void 0 ? void 0 : client.id(userData, doNotSendEvent), [
        client
    ]);
    const trackPageView = (0, $6fFrj.useCallback)(()=>client === null || client === void 0 ? void 0 : client.track('pageview'), [
        client
    ]);
    const track = (0, $6fFrj.useCallback)((typeName, payload)=>client === null || client === void 0 ? void 0 : client.track(typeName, payload), [
        client
    ]);
    const rawTrack = (0, $6fFrj.useCallback)((payload)=>client === null || client === void 0 ? void 0 : client.rawTrack(payload), [
        client
    ]);
    const interceptAnalytics = (0, $6fFrj.useCallback)((analytics)=>client === null || client === void 0 ? void 0 : client.interceptAnalytics(analytics), [
        client
    ]);
    const set = (0, $6fFrj.useCallback)((properties, opts)=>client === null || client === void 0 ? void 0 : client.set(properties, opts), [
        client
    ]);
    const unset = (0, $6fFrj.useCallback)((propertyName, opts)=>client === null || client === void 0 ? void 0 : client.unset(propertyName, opts), [
        client
    ]);
    return Object.assign(Object.assign({}, client), {
        id: id,
        track: track,
        trackPageView: trackPageView,
        rawTrack: rawTrack,
        interceptAnalytics: interceptAnalytics,
        set: set,
        unset: unset
    });
}
function $1b6cd4304c8b74ff$export$ce099541bf79f159(opts = {}) {
    let location = (0, $990f835fb2356f36$export$45d76561a5302f2b)();
    const usermaven = $1b6cd4304c8b74ff$export$346b73153e5ac4d0();
    (0, $6fFrj.useEffect)(()=>{
        if (opts.before) opts.before(usermaven);
        usermaven.track((opts === null || opts === void 0 ? void 0 : opts.typeName) || 'pageview', opts.payload);
    }, [
        location,
        usermaven.track,
        opts.payload,
        opts.before
    ]);
    return usermaven;
}



var $bb3TF = parcelRequire("bb3TF");


var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $eb65b0cccdfec234$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
var $eb65b0cccdfec234$export$2e2bcd8739ae039 = $eb65b0cccdfec234$var$CheckCircleFilled;



var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $43449 = parcelRequire("43449");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");
var $47a5c11e3aa73f6c$var$IconContext = /*#__PURE__*/ (0, $6fFrj.createContext)({});
var $47a5c11e3aa73f6c$export$2e2bcd8739ae039 = $47a5c11e3aa73f6c$var$IconContext;



var $04RxA = parcelRequire("04RxA");

var $kNxFX = parcelRequire("kNxFX");

var $kNxFX = parcelRequire("kNxFX");

var $5KhTJ = parcelRequire("5KhTJ");
/* eslint-disable @typescript-eslint/no-redundant-type-constituents */ /**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */ function $81e65def826cae1e$export$b0e60b43d1d059f0(n, max) {
    if ($81e65def826cae1e$export$7bf7d6849640691b(n)) n = '100%';
    var isPercent = $81e65def826cae1e$export$d86432a85610ea90(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (isPercent) n = parseInt(String(n * max), 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    if (max === 360) // If n is a hue given in degrees,
    // wrap around out-of-range values into [0, 360] range
    // then convert into [0, 1].
    n = (n < 0 ? n % max + max : n % max) / parseFloat(String(max));
    else // If n not a hue given in degrees
    // Convert into [0, 1] range if it isn't already.
    n = n % max / parseFloat(String(max));
    return n;
}
function $81e65def826cae1e$export$5c5ee632c52bc4a2(val) {
    return Math.min(1, Math.max(0, val));
}
function $81e65def826cae1e$export$7bf7d6849640691b(n) {
    return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
}
function $81e65def826cae1e$export$d86432a85610ea90(n) {
    return typeof n === 'string' && n.indexOf('%') !== -1;
}
function $81e65def826cae1e$export$3ae665204365318d(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
function $81e65def826cae1e$export$8ba0754c08bd5ca8(n) {
    if (n <= 1) return "".concat(Number(n) * 100, "%");
    return n;
}
function $81e65def826cae1e$export$9decc9dc70e2c76f(c) {
    return c.length === 1 ? '0' + c : String(c);
}


function $a7b58901a65f86df$export$1a0d7f039f803cb(r, g, b) {
    return {
        r: (0, $81e65def826cae1e$export$b0e60b43d1d059f0)(r, 255) * 255,
        g: (0, $81e65def826cae1e$export$b0e60b43d1d059f0)(g, 255) * 255,
        b: (0, $81e65def826cae1e$export$b0e60b43d1d059f0)(b, 255) * 255
    };
}
function $a7b58901a65f86df$export$c85ca4f4753af384(r, g, b) {
    r = (0, $81e65def826cae1e$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $81e65def826cae1e$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $81e65def826cae1e$export$b0e60b43d1d059f0)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var s = 0;
    var l = (max + min) / 2;
    if (max === min) {
        s = 0;
        h = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
function $a7b58901a65f86df$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * (6 * t);
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $a7b58901a65f86df$export$29fb7152bd3f781a(h, s, l) {
    var r;
    var g;
    var b;
    h = (0, $81e65def826cae1e$export$b0e60b43d1d059f0)(h, 360);
    s = (0, $81e65def826cae1e$export$b0e60b43d1d059f0)(s, 100);
    l = (0, $81e65def826cae1e$export$b0e60b43d1d059f0)(l, 100);
    if (s === 0) {
        // achromatic
        g = l;
        b = l;
        r = l;
    } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = $a7b58901a65f86df$var$hue2rgb(p, q, h + 1 / 3);
        g = $a7b58901a65f86df$var$hue2rgb(p, q, h);
        b = $a7b58901a65f86df$var$hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $a7b58901a65f86df$export$f76e85ca00a47f5c(r, g, b) {
    r = (0, $81e65def826cae1e$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $81e65def826cae1e$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $81e65def826cae1e$export$b0e60b43d1d059f0)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    if (max === min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
function $a7b58901a65f86df$export$210753cfeec758a5(h, s, v) {
    h = (0, $81e65def826cae1e$export$b0e60b43d1d059f0)(h, 360) * 6;
    s = (0, $81e65def826cae1e$export$b0e60b43d1d059f0)(s, 100);
    v = (0, $81e65def826cae1e$export$b0e60b43d1d059f0)(v, 100);
    var i = Math.floor(h);
    var f = h - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i % 6;
    var r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod];
    var g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod];
    var b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $a7b58901a65f86df$export$34d09c4a771c46ef(r, g, b, allow3Char) {
    var hex = [
        (0, $81e65def826cae1e$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $81e65def826cae1e$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $81e65def826cae1e$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join('');
}
function $a7b58901a65f86df$export$ffee5509a14af63d(r, g, b, a, allow4Char) {
    var hex = [
        (0, $81e65def826cae1e$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $81e65def826cae1e$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $81e65def826cae1e$export$9decc9dc70e2c76f)(Math.round(b).toString(16)),
        (0, $81e65def826cae1e$export$9decc9dc70e2c76f)($a7b58901a65f86df$export$51dcdea396f3aff6(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1)) && hex[3].startsWith(hex[3].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join('');
}
function $a7b58901a65f86df$export$ce6645f7d73030f4(r, g, b, a) {
    var hex = [
        (0, $81e65def826cae1e$export$9decc9dc70e2c76f)($a7b58901a65f86df$export$51dcdea396f3aff6(a)),
        (0, $81e65def826cae1e$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $81e65def826cae1e$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $81e65def826cae1e$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    return hex.join('');
}
function $a7b58901a65f86df$export$51dcdea396f3aff6(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
function $a7b58901a65f86df$export$616da979ad1c2414(h) {
    return $a7b58901a65f86df$export$262b3ba788b4d07c(h) / 255;
}
function $a7b58901a65f86df$export$262b3ba788b4d07c(val) {
    return parseInt(val, 16);
}
function $a7b58901a65f86df$export$4076ec82b665900d(color) {
    return {
        r: color >> 16,
        g: (color & 0xff00) >> 8,
        b: color & 0xff
    };
}


// https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json
/**
 * @hidden
 */ var $b7f1e600d42473b1$export$e4b2ac9215619f8d = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    goldenrod: '#daa520',
    gold: '#ffd700',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavenderblush: '#fff0f5',
    lavender: '#e6e6fa',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
};



function $321d015feb50c14a$export$87de337d8199f22c(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color === 'string') color = $321d015feb50c14a$export$56237d872eed15a0(color);
    if (typeof color === 'object') {
        if ($321d015feb50c14a$export$80d4d71a83d4526d(color.r) && $321d015feb50c14a$export$80d4d71a83d4526d(color.g) && $321d015feb50c14a$export$80d4d71a83d4526d(color.b)) {
            rgb = (0, $a7b58901a65f86df$export$1a0d7f039f803cb)(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === '%' ? 'prgb' : 'rgb';
        } else if ($321d015feb50c14a$export$80d4d71a83d4526d(color.h) && $321d015feb50c14a$export$80d4d71a83d4526d(color.s) && $321d015feb50c14a$export$80d4d71a83d4526d(color.v)) {
            s = (0, $81e65def826cae1e$export$8ba0754c08bd5ca8)(color.s);
            v = (0, $81e65def826cae1e$export$8ba0754c08bd5ca8)(color.v);
            rgb = (0, $a7b58901a65f86df$export$210753cfeec758a5)(color.h, s, v);
            ok = true;
            format = 'hsv';
        } else if ($321d015feb50c14a$export$80d4d71a83d4526d(color.h) && $321d015feb50c14a$export$80d4d71a83d4526d(color.s) && $321d015feb50c14a$export$80d4d71a83d4526d(color.l)) {
            s = (0, $81e65def826cae1e$export$8ba0754c08bd5ca8)(color.s);
            l = (0, $81e65def826cae1e$export$8ba0754c08bd5ca8)(color.l);
            rgb = (0, $a7b58901a65f86df$export$29fb7152bd3f781a)(color.h, s, l);
            ok = true;
            format = 'hsl';
        }
        if (Object.prototype.hasOwnProperty.call(color, 'a')) a = color.a;
    }
    a = (0, $81e65def826cae1e$export$3ae665204365318d)(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// <http://www.w3.org/TR/css3-values/#integers>
var $321d015feb50c14a$var$CSS_INTEGER = '[-\\+]?\\d+%?';
// <http://www.w3.org/TR/css3-values/#number-value>
var $321d015feb50c14a$var$CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?';
// Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
var $321d015feb50c14a$var$CSS_UNIT = "(?:".concat($321d015feb50c14a$var$CSS_NUMBER, ")|(?:").concat($321d015feb50c14a$var$CSS_INTEGER, ")");
// Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren
var $321d015feb50c14a$var$PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat($321d015feb50c14a$var$CSS_UNIT, ")[,|\\s]+(").concat($321d015feb50c14a$var$CSS_UNIT, ")[,|\\s]+(").concat($321d015feb50c14a$var$CSS_UNIT, ")\\s*\\)?");
var $321d015feb50c14a$var$PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat($321d015feb50c14a$var$CSS_UNIT, ")[,|\\s]+(").concat($321d015feb50c14a$var$CSS_UNIT, ")[,|\\s]+(").concat($321d015feb50c14a$var$CSS_UNIT, ")[,|\\s]+(").concat($321d015feb50c14a$var$CSS_UNIT, ")\\s*\\)?");
var $321d015feb50c14a$var$matchers = {
    CSS_UNIT: new RegExp($321d015feb50c14a$var$CSS_UNIT),
    rgb: new RegExp('rgb' + $321d015feb50c14a$var$PERMISSIVE_MATCH3),
    rgba: new RegExp('rgba' + $321d015feb50c14a$var$PERMISSIVE_MATCH4),
    hsl: new RegExp('hsl' + $321d015feb50c14a$var$PERMISSIVE_MATCH3),
    hsla: new RegExp('hsla' + $321d015feb50c14a$var$PERMISSIVE_MATCH4),
    hsv: new RegExp('hsv' + $321d015feb50c14a$var$PERMISSIVE_MATCH3),
    hsva: new RegExp('hsva' + $321d015feb50c14a$var$PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function $321d015feb50c14a$export$56237d872eed15a0(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) return false;
    var named = false;
    if ((0, $b7f1e600d42473b1$export$e4b2ac9215619f8d)[color]) {
        color = (0, $b7f1e600d42473b1$export$e4b2ac9215619f8d)[color];
        named = true;
    } else if (color === 'transparent') return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: 'name'
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match = $321d015feb50c14a$var$matchers.rgb.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    match = $321d015feb50c14a$var$matchers.rgba.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    match = $321d015feb50c14a$var$matchers.hsl.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    match = $321d015feb50c14a$var$matchers.hsla.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    match = $321d015feb50c14a$var$matchers.hsv.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    match = $321d015feb50c14a$var$matchers.hsva.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    match = $321d015feb50c14a$var$matchers.hex8.exec(color);
    if (match) return {
        r: (0, $a7b58901a65f86df$export$262b3ba788b4d07c)(match[1]),
        g: (0, $a7b58901a65f86df$export$262b3ba788b4d07c)(match[2]),
        b: (0, $a7b58901a65f86df$export$262b3ba788b4d07c)(match[3]),
        a: (0, $a7b58901a65f86df$export$616da979ad1c2414)(match[4]),
        format: named ? 'name' : 'hex8'
    };
    match = $321d015feb50c14a$var$matchers.hex6.exec(color);
    if (match) return {
        r: (0, $a7b58901a65f86df$export$262b3ba788b4d07c)(match[1]),
        g: (0, $a7b58901a65f86df$export$262b3ba788b4d07c)(match[2]),
        b: (0, $a7b58901a65f86df$export$262b3ba788b4d07c)(match[3]),
        format: named ? 'name' : 'hex'
    };
    match = $321d015feb50c14a$var$matchers.hex4.exec(color);
    if (match) return {
        r: (0, $a7b58901a65f86df$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $a7b58901a65f86df$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $a7b58901a65f86df$export$262b3ba788b4d07c)(match[3] + match[3]),
        a: (0, $a7b58901a65f86df$export$616da979ad1c2414)(match[4] + match[4]),
        format: named ? 'name' : 'hex8'
    };
    match = $321d015feb50c14a$var$matchers.hex3.exec(color);
    if (match) return {
        r: (0, $a7b58901a65f86df$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $a7b58901a65f86df$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $a7b58901a65f86df$export$262b3ba788b4d07c)(match[3] + match[3]),
        format: named ? 'name' : 'hex'
    };
    return false;
}
function $321d015feb50c14a$export$80d4d71a83d4526d(color) {
    return Boolean($321d015feb50c14a$var$matchers.CSS_UNIT.exec(String(color)));
}


var $f98afff48ee41fa5$var$hueStep = 2; // 色相阶梯
var $f98afff48ee41fa5$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
var $f98afff48ee41fa5$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
var $f98afff48ee41fa5$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
var $f98afff48ee41fa5$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
var $f98afff48ee41fa5$var$lightColorCount = 5; // 浅色数量，主色上
var $f98afff48ee41fa5$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
var $f98afff48ee41fa5$var$darkColorMap = [
    {
        index: 7,
        opacity: 0.15
    },
    {
        index: 6,
        opacity: 0.25
    },
    {
        index: 5,
        opacity: 0.3
    },
    {
        index: 5,
        opacity: 0.45
    },
    {
        index: 5,
        opacity: 0.65
    },
    {
        index: 5,
        opacity: 0.85
    },
    {
        index: 4,
        opacity: 0.9
    },
    {
        index: 3,
        opacity: 0.95
    },
    {
        index: 2,
        opacity: 0.97
    },
    {
        index: 1,
        opacity: 0.98
    }
]; // Wrapper function ported from TinyColor.prototype.toHsv
// Keep it here because of `hsv.h * 360`
function $f98afff48ee41fa5$var$toHsv(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var hsv = (0, $a7b58901a65f86df$export$f76e85ca00a47f5c)(r, g, b);
    return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v
    };
} // Wrapper function ported from TinyColor.prototype.toHexString
// Keep it here because of the prefix `#`
function $f98afff48ee41fa5$var$toHex(_ref2) {
    var r = _ref2.r, g = _ref2.g, b = _ref2.b;
    return "#".concat((0, $a7b58901a65f86df$export$34d09c4a771c46ef)(r, g, b, false));
} // Wrapper function ported from TinyColor.prototype.mix, not treeshakable.
// Amount in range [0, 1]
// Assume color1 & color2 has no alpha, since the following src code did so.
function $f98afff48ee41fa5$var$mix(rgb1, rgb2, amount) {
    var p = amount / 100;
    var rgb = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b
    };
    return rgb;
}
function $f98afff48ee41fa5$var$getHue(hsv, i, light) {
    var hue; // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $f98afff48ee41fa5$var$hueStep * i : Math.round(hsv.h) + $f98afff48ee41fa5$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $f98afff48ee41fa5$var$hueStep * i : Math.round(hsv.h) - $f98afff48ee41fa5$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $f98afff48ee41fa5$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    var saturation;
    if (light) saturation = hsv.s - $f98afff48ee41fa5$var$saturationStep * i;
    else if (i === $f98afff48ee41fa5$var$darkColorCount) saturation = hsv.s + $f98afff48ee41fa5$var$saturationStep;
    else saturation = hsv.s + $f98afff48ee41fa5$var$saturationStep2 * i;
     // 边界值修正
    if (saturation > 1) saturation = 1;
     // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $f98afff48ee41fa5$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Number(saturation.toFixed(2));
}
function $f98afff48ee41fa5$var$getValue(hsv, i, light) {
    var value;
    if (light) value = hsv.v + $f98afff48ee41fa5$var$brightnessStep1 * i;
    else value = hsv.v - $f98afff48ee41fa5$var$brightnessStep2 * i;
    if (value > 1) value = 1;
    return Number(value.toFixed(2));
}
function $f98afff48ee41fa5$export$80d376111cc09ad7(color) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var patterns = [];
    var pColor = (0, $321d015feb50c14a$export$87de337d8199f22c)(color);
    for(var i = $f98afff48ee41fa5$var$lightColorCount; i > 0; i -= 1){
        var hsv = $f98afff48ee41fa5$var$toHsv(pColor);
        var colorString = $f98afff48ee41fa5$var$toHex((0, $321d015feb50c14a$export$87de337d8199f22c)({
            h: $f98afff48ee41fa5$var$getHue(hsv, i, true),
            s: $f98afff48ee41fa5$var$getSaturation(hsv, i, true),
            v: $f98afff48ee41fa5$var$getValue(hsv, i, true)
        }));
        patterns.push(colorString);
    }
    patterns.push($f98afff48ee41fa5$var$toHex(pColor));
    for(var _i = 1; _i <= $f98afff48ee41fa5$var$darkColorCount; _i += 1){
        var _hsv = $f98afff48ee41fa5$var$toHsv(pColor);
        var _colorString = $f98afff48ee41fa5$var$toHex((0, $321d015feb50c14a$export$87de337d8199f22c)({
            h: $f98afff48ee41fa5$var$getHue(_hsv, _i),
            s: $f98afff48ee41fa5$var$getSaturation(_hsv, _i),
            v: $f98afff48ee41fa5$var$getValue(_hsv, _i)
        }));
        patterns.push(_colorString);
    } // dark theme patterns
    if (opts.theme === 'dark') return $f98afff48ee41fa5$var$darkColorMap.map(function(_ref3) {
        var index = _ref3.index, opacity = _ref3.opacity;
        var darkColorString = $f98afff48ee41fa5$var$toHex($f98afff48ee41fa5$var$mix((0, $321d015feb50c14a$export$87de337d8199f22c)(opts.backgroundColor || '#141414'), (0, $321d015feb50c14a$export$87de337d8199f22c)(patterns[index]), opacity * 100));
        return darkColorString;
    });
    return patterns;
}
var $f98afff48ee41fa5$export$3968a3afc810b5f5 = {
    red: '#F5222D',
    volcano: '#FA541C',
    orange: '#FA8C16',
    gold: '#FAAD14',
    yellow: '#FADB14',
    lime: '#A0D911',
    green: '#52C41A',
    cyan: '#13C2C2',
    blue: '#1890FF',
    geekblue: '#2F54EB',
    purple: '#722ED1',
    magenta: '#EB2F96',
    grey: '#666666'
};
var $f98afff48ee41fa5$export$36ad6df0f83f284d = {};
var $f98afff48ee41fa5$export$24617255e4daf647 = {};
Object.keys($f98afff48ee41fa5$export$3968a3afc810b5f5).forEach(function(key) {
    $f98afff48ee41fa5$export$36ad6df0f83f284d[key] = $f98afff48ee41fa5$export$80d376111cc09ad7($f98afff48ee41fa5$export$3968a3afc810b5f5[key]);
    $f98afff48ee41fa5$export$36ad6df0f83f284d[key].primary = $f98afff48ee41fa5$export$36ad6df0f83f284d[key][5]; // dark presetPalettes
    $f98afff48ee41fa5$export$24617255e4daf647[key] = $f98afff48ee41fa5$export$80d376111cc09ad7($f98afff48ee41fa5$export$3968a3afc810b5f5[key], {
        theme: 'dark',
        backgroundColor: '#141414'
    });
    $f98afff48ee41fa5$export$24617255e4daf647[key].primary = $f98afff48ee41fa5$export$24617255e4daf647[key][5];
});
var $f98afff48ee41fa5$export$a90204d1394caf30 = $f98afff48ee41fa5$export$36ad6df0f83f284d.red;
var $f98afff48ee41fa5$export$e63a1643b2f79b16 = $f98afff48ee41fa5$export$36ad6df0f83f284d.volcano;
var $f98afff48ee41fa5$export$c24201f7fe3571d8 = $f98afff48ee41fa5$export$36ad6df0f83f284d.gold;
var $f98afff48ee41fa5$export$ad766f34ace1cafd = $f98afff48ee41fa5$export$36ad6df0f83f284d.orange;
var $f98afff48ee41fa5$export$594c5a8758200c32 = $f98afff48ee41fa5$export$36ad6df0f83f284d.yellow;
var $f98afff48ee41fa5$export$221d31baf2636aad = $f98afff48ee41fa5$export$36ad6df0f83f284d.lime;
var $f98afff48ee41fa5$export$955a2ebd2fb142ae = $f98afff48ee41fa5$export$36ad6df0f83f284d.green;
var $f98afff48ee41fa5$export$7474046f446842ee = $f98afff48ee41fa5$export$36ad6df0f83f284d.cyan;
var $f98afff48ee41fa5$export$2aa0182783e7e9de = $f98afff48ee41fa5$export$36ad6df0f83f284d.blue;
var $f98afff48ee41fa5$export$4138d3aeddcbf415 = $f98afff48ee41fa5$export$36ad6df0f83f284d.geekblue;
var $f98afff48ee41fa5$export$e13cce2a2d16a9d4 = $f98afff48ee41fa5$export$36ad6df0f83f284d.purple;
var $f98afff48ee41fa5$export$2a9ca2e383622e18 = $f98afff48ee41fa5$export$36ad6df0f83f284d.magenta;
var $f98afff48ee41fa5$export$e4c89085febbc618 = $f98afff48ee41fa5$export$36ad6df0f83f284d.grey;



var $6fFrj = parcelRequire("6fFrj");

var $3mXQ2 = parcelRequire("3mXQ2");

var $kNxFX = parcelRequire("kNxFX");

var $aSXdS = parcelRequire("aSXdS");
function $b5cc600be516f1fa$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}


var $be1cee03a7a68105$var$APPEND_ORDER = 'data-rc-order';
var $be1cee03a7a68105$var$APPEND_PRIORITY = 'data-rc-priority';
var $be1cee03a7a68105$var$MARK_KEY = "rc-util-key";
var $be1cee03a7a68105$var$containerCache = new Map();
function $be1cee03a7a68105$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith('data-') ? mark : "data-".concat(mark);
    return $be1cee03a7a68105$var$MARK_KEY;
}
function $be1cee03a7a68105$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector('head');
    return head || document.body;
}
function $be1cee03a7a68105$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function $be1cee03a7a68105$var$findStyles(container) {
    return Array.from(($be1cee03a7a68105$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === 'STYLE';
    });
}
function $be1cee03a7a68105$export$1ab5838465dbd10a(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $aSXdS.default)()) return null;
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = $be1cee03a7a68105$var$getOrder(prepend);
    var isPrependQueue = mergedOrder === 'prependQueue';
    var styleNode = document.createElement('style');
    styleNode.setAttribute($be1cee03a7a68105$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($be1cee03a7a68105$var$APPEND_PRIORITY, "".concat(priority));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $be1cee03a7a68105$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            var existStyle = (option.styles || $be1cee03a7a68105$var$findStyles(container)).filter(function(node) {
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($be1cee03a7a68105$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                var nodePriority = Number(node.getAttribute($be1cee03a7a68105$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $be1cee03a7a68105$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $be1cee03a7a68105$var$getContainer(option);
    return (option.styles || $be1cee03a7a68105$var$findStyles(container)).find(function(node) {
        return node.getAttribute($be1cee03a7a68105$var$getMark(option)) === key;
    });
}
function $be1cee03a7a68105$export$2232e336aecaa80a(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $be1cee03a7a68105$var$findExistNode(key, option);
    if (existNode) {
        var container = $be1cee03a7a68105$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $be1cee03a7a68105$var$syncRealContainer(container, option) {
    var cachedRealContainer = $be1cee03a7a68105$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $b5cc600be516f1fa$export$2e2bcd8739ae039)(document, cachedRealContainer)) {
        var placeholderStyle = $be1cee03a7a68105$export$1ab5838465dbd10a('', option);
        var parentNode = placeholderStyle.parentNode;
        $be1cee03a7a68105$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $be1cee03a7a68105$export$f80df667f2f5a272() {
    $be1cee03a7a68105$var$containerCache.clear();
}
function $be1cee03a7a68105$export$4d99a2890bb989f0(css, key) {
    var originOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $be1cee03a7a68105$var$getContainer(originOption);
    var styles = $be1cee03a7a68105$var$findStyles(container);
    var option = (0, $kNxFX.default)((0, $kNxFX.default)({}, originOption), {}, {
        styles: styles
    });
    // Sync real parent
    $be1cee03a7a68105$var$syncRealContainer(container, option);
    var existNode = $be1cee03a7a68105$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $be1cee03a7a68105$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($be1cee03a7a68105$var$getMark(option), key);
    return newNode;
}




var $h13av = parcelRequire("h13av");
function $214a2ea59d241733$export$491112666e282270(valid, message) {
    (0, $3mXQ2.default)(valid, "[@ant-design/icons] ".concat(message));
}
function $214a2ea59d241733$export$ab652842c37578f4(target) {
    return (0, $5KhTJ.default)(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && ((0, $5KhTJ.default)(target.icon) === 'object' || typeof target.icon === 'function');
}
function $214a2ea59d241733$export$9f5073e7201cc21c() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(attrs).reduce(function(acc, key) {
        var val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[(0, (/*@__PURE__*/$parcel$interopDefault($h13av)))(key)] = val;
        }
        return acc;
    }, {});
}
function $214a2ea59d241733$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(node.tag, (0, $kNxFX.default)({
        key: key
    }, $214a2ea59d241733$export$9f5073e7201cc21c(node.attrs)), (node.children || []).map(function(child, index) {
        return $214a2ea59d241733$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(node.tag, (0, $kNxFX.default)((0, $kNxFX.default)({
        key: key
    }, $214a2ea59d241733$export$9f5073e7201cc21c(node.attrs)), rootProps), (node.children || []).map(function(child, index) {
        return $214a2ea59d241733$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
}
function $214a2ea59d241733$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $f98afff48ee41fa5$export$80d376111cc09ad7)(primaryColor)[0];
}
function $214a2ea59d241733$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
var $214a2ea59d241733$export$960a899a9cccb2d5 = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
var $214a2ea59d241733$export$2c99b98b77550cb4 = "\n.anticon {\n  display: inline-flex;\n  alignItems: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var $214a2ea59d241733$export$938b1f86b61613d0 = function useInsertStyles() {
    var styleStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $214a2ea59d241733$export$2c99b98b77550cb4;
    var _useContext = (0, $6fFrj.useContext)((0, $47a5c11e3aa73f6c$export$2e2bcd8739ae039)), csp = _useContext.csp;
    (0, $6fFrj.useEffect)(function() {
        (0, $be1cee03a7a68105$export$4d99a2890bb989f0)(styleStr, '@ant-design-icons', {
            prepend: true,
            csp: csp
        });
    }, []);
};


var $60b55d756c5e145a$var$_excluded = [
    "icon",
    "className",
    "onClick",
    "style",
    "primaryColor",
    "secondaryColor"
];
var $60b55d756c5e145a$var$twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6',
    calculated: false
};
function $60b55d756c5e145a$var$setTwoToneColors(_ref) {
    var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
    $60b55d756c5e145a$var$twoToneColorPalette.primaryColor = primaryColor;
    $60b55d756c5e145a$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $214a2ea59d241733$export$b71c93f469694483)(primaryColor);
    $60b55d756c5e145a$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $60b55d756c5e145a$var$getTwoToneColors() {
    return (0, $kNxFX.default)({}, $60b55d756c5e145a$var$twoToneColorPalette);
}
var $60b55d756c5e145a$var$IconBase = function IconBase(props) {
    var icon = props.icon, className = props.className, onClick = props.onClick, style = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, $04RxA.default)(props, $60b55d756c5e145a$var$_excluded);
    var colors = $60b55d756c5e145a$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $214a2ea59d241733$export$b71c93f469694483)(primaryColor)
    };
    (0, $214a2ea59d241733$export$938b1f86b61613d0)();
    (0, $214a2ea59d241733$export$491112666e282270)((0, $214a2ea59d241733$export$ab652842c37578f4)(icon), "icon should be icon definiton, but got ".concat(icon));
    if (!(0, $214a2ea59d241733$export$ab652842c37578f4)(icon)) return null;
    var target = icon;
    if (target && typeof target.icon === 'function') target = (0, $kNxFX.default)((0, $kNxFX.default)({}, target), {}, {
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
    return (0, $214a2ea59d241733$export$80d376111cc09ad7)(target.icon, "svg-".concat(target.name), (0, $kNxFX.default)({
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true'
    }, restProps));
};
$60b55d756c5e145a$var$IconBase.displayName = 'IconReact';
$60b55d756c5e145a$var$IconBase.getTwoToneColors = $60b55d756c5e145a$var$getTwoToneColors;
$60b55d756c5e145a$var$IconBase.setTwoToneColors = $60b55d756c5e145a$var$setTwoToneColors;
var $60b55d756c5e145a$export$2e2bcd8739ae039 = $60b55d756c5e145a$var$IconBase;



var $jP8CL = parcelRequire("jP8CL");


function $6c8624e7a27633b3$export$8a145f34580ff02b(twoToneColor) {
    var _normalizeTwoToneColo = (0, $214a2ea59d241733$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $jP8CL.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return (0, $60b55d756c5e145a$export$2e2bcd8739ae039).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $6c8624e7a27633b3$export$abc7c554784cb4a7() {
    var colors = (0, $60b55d756c5e145a$export$2e2bcd8739ae039).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}



var $dc0e0091f50fc261$var$_excluded = [
    "className",
    "icon",
    "spin",
    "rotate",
    "tabIndex",
    "onClick",
    "twoToneColor"
];
// Initial setting
// should move it to antd main repo?
(0, $6c8624e7a27633b3$export$8a145f34580ff02b)('#1890ff');
var $dc0e0091f50fc261$var$Icon = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, $04RxA.default)(props, $dc0e0091f50fc261$var$_excluded);
    var _React$useContext = $6fFrj.useContext((0, $47a5c11e3aa73f6c$export$2e2bcd8739ae039)), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(rootClassName, prefixCls, (0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    var svgStyle = rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
    } : undefined;
    var _normalizeTwoToneColo = (0, $214a2ea59d241733$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $jP8CL.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return /*#__PURE__*/ $6fFrj.createElement("span", (0, $kNxFX.default)((0, $kNxFX.default)({
        role: "img",
        "aria-label": icon.name
    }, restProps), {}, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $6fFrj.createElement((0, $60b55d756c5e145a$export$2e2bcd8739ae039), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$dc0e0091f50fc261$var$Icon.displayName = 'AntdIcon';
$dc0e0091f50fc261$var$Icon.getTwoToneColor = (0, $6c8624e7a27633b3$export$abc7c554784cb4a7);
$dc0e0091f50fc261$var$Icon.setTwoToneColor = (0, $6c8624e7a27633b3$export$8a145f34580ff02b);
var $dc0e0091f50fc261$export$2e2bcd8739ae039 = $dc0e0091f50fc261$var$Icon;


var $a539793a765f8968$var$CheckCircleFilled = function CheckCircleFilled(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $eb65b0cccdfec234$export$2e2bcd8739ae039)
    }));
};
var $a539793a765f8968$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($a539793a765f8968$var$CheckCircleFilled);
var $a539793a765f8968$export$2e2bcd8739ae039 = $a539793a765f8968$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $0c7499f70782b24d$var$CheckCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "outlined"
};
var $0c7499f70782b24d$export$2e2bcd8739ae039 = $0c7499f70782b24d$var$CheckCircleOutlined;



var $996a31538a9d5bb4$var$CheckCircleOutlined = function CheckCircleOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $0c7499f70782b24d$export$2e2bcd8739ae039)
    }));
};
var $996a31538a9d5bb4$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($996a31538a9d5bb4$var$CheckCircleOutlined);
var $996a31538a9d5bb4$export$2e2bcd8739ae039 = $996a31538a9d5bb4$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $a4fa40757ca9896a$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
var $a4fa40757ca9896a$export$2e2bcd8739ae039 = $a4fa40757ca9896a$var$CloseCircleFilled;



var $9429a61ddf5bc264$var$CloseCircleFilled = function CloseCircleFilled(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $a4fa40757ca9896a$export$2e2bcd8739ae039)
    }));
};
var $9429a61ddf5bc264$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($9429a61ddf5bc264$var$CloseCircleFilled);
var $9429a61ddf5bc264$export$2e2bcd8739ae039 = $9429a61ddf5bc264$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $fe3bbf009eae49c2$var$CloseCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm128.01 198.83c.03 0 .05.01.09.06l45.02 45.01a.2.2 0 01.05.09.12.12 0 010 .07c0 .02-.01.04-.05.08L557.25 512l127.87 127.86a.27.27 0 01.05.06v.02a.12.12 0 010 .07c0 .03-.01.05-.05.09l-45.02 45.02a.2.2 0 01-.09.05.12.12 0 01-.07 0c-.02 0-.04-.01-.08-.05L512 557.25 384.14 685.12c-.04.04-.06.05-.08.05a.12.12 0 01-.07 0c-.03 0-.05-.01-.09-.05l-45.02-45.02a.2.2 0 01-.05-.09.12.12 0 010-.07c0-.02.01-.04.06-.08L466.75 512 338.88 384.14a.27.27 0 01-.05-.06l-.01-.02a.12.12 0 010-.07c0-.03.01-.05.05-.09l45.02-45.02a.2.2 0 01.09-.05.12.12 0 01.07 0c.02 0 .04.01.08.06L512 466.75l127.86-127.86c.04-.05.06-.06.08-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "outlined"
};
var $fe3bbf009eae49c2$export$2e2bcd8739ae039 = $fe3bbf009eae49c2$var$CloseCircleOutlined;



var $83dc1c57eab38fbc$var$CloseCircleOutlined = function CloseCircleOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $fe3bbf009eae49c2$export$2e2bcd8739ae039)
    }));
};
var $83dc1c57eab38fbc$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($83dc1c57eab38fbc$var$CloseCircleOutlined);
var $83dc1c57eab38fbc$export$2e2bcd8739ae039 = $83dc1c57eab38fbc$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $00f004987c9cb52d$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
var $00f004987c9cb52d$export$2e2bcd8739ae039 = $00f004987c9cb52d$var$CloseOutlined;



var $4cb3f1f073816266$var$CloseOutlined = function CloseOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $00f004987c9cb52d$export$2e2bcd8739ae039)
    }));
};
var $4cb3f1f073816266$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($4cb3f1f073816266$var$CloseOutlined);
var $4cb3f1f073816266$export$2e2bcd8739ae039 = $4cb3f1f073816266$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $262f5e9825acb6ab$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
var $262f5e9825acb6ab$export$2e2bcd8739ae039 = $262f5e9825acb6ab$var$ExclamationCircleFilled;



var $4b49a895caf27162$var$ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $262f5e9825acb6ab$export$2e2bcd8739ae039)
    }));
};
var $4b49a895caf27162$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($4b49a895caf27162$var$ExclamationCircleFilled);
var $4b49a895caf27162$export$2e2bcd8739ae039 = $4b49a895caf27162$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $3221a06934a4a7f9$var$ExclamationCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "outlined"
};
var $3221a06934a4a7f9$export$2e2bcd8739ae039 = $3221a06934a4a7f9$var$ExclamationCircleOutlined;



var $5a26a3af64ff8e01$var$ExclamationCircleOutlined = function ExclamationCircleOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $3221a06934a4a7f9$export$2e2bcd8739ae039)
    }));
};
var $5a26a3af64ff8e01$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($5a26a3af64ff8e01$var$ExclamationCircleOutlined);
var $5a26a3af64ff8e01$export$2e2bcd8739ae039 = $5a26a3af64ff8e01$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $0f990fb0a5c51b12$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
var $0f990fb0a5c51b12$export$2e2bcd8739ae039 = $0f990fb0a5c51b12$var$InfoCircleFilled;



var $07ece45f4cb05aa5$var$InfoCircleFilled = function InfoCircleFilled(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $0f990fb0a5c51b12$export$2e2bcd8739ae039)
    }));
};
var $07ece45f4cb05aa5$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($07ece45f4cb05aa5$var$InfoCircleFilled);
var $07ece45f4cb05aa5$export$2e2bcd8739ae039 = $07ece45f4cb05aa5$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $06ae3dfd39649729$var$InfoCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "outlined"
};
var $06ae3dfd39649729$export$2e2bcd8739ae039 = $06ae3dfd39649729$var$InfoCircleOutlined;



var $60bea5c3f0793107$var$InfoCircleOutlined = function InfoCircleOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $06ae3dfd39649729$export$2e2bcd8739ae039)
    }));
};
var $60bea5c3f0793107$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($60bea5c3f0793107$var$InfoCircleOutlined);
var $60bea5c3f0793107$export$2e2bcd8739ae039 = $60bea5c3f0793107$var$RefIcon;



var $fActo = parcelRequire("fActo");

var $5EVeC = parcelRequire("5EVeC");

var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");


var $a5lfY = parcelRequire("a5lfY");

var $6fFrj = parcelRequire("6fFrj");

var $i5KV1 = parcelRequire("i5KV1");

var $6fFrj = parcelRequire("6fFrj");
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-field-form`
$5022a8205bf86c7a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $6fFrj.createContext)(undefined);



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");


var $fIrcP = parcelRequire("fIrcP");
/* eslint-disable no-template-curly-in-string */ var $d2585e4c74ed0f46$export$2e2bcd8739ae039 = {
    // Options.jsx
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: 'Page',
    // Pagination.jsx
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
    page_size: 'Page Size'
};



var $fIrcP = parcelRequire("fIrcP");
var $337ed71125200ebb$var$locale = {
    locale: 'en_US',
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'OK',
    clear: 'Clear',
    month: 'Month',
    year: 'Year',
    timeSelect: 'select time',
    dateSelect: 'select date',
    weekSelect: 'Choose a week',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    yearFormat: 'YYYY',
    dateFormat: 'M/D/YYYY',
    dayFormat: 'D',
    dateTimeFormat: 'M/D/YYYY HH:mm:ss',
    monthBeforeYear: true,
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century'
};
var $337ed71125200ebb$export$2e2bcd8739ae039 = $337ed71125200ebb$var$locale;


var $ba3568116bafb03a$var$locale = {
    placeholder: 'Select time',
    rangePlaceholder: [
        'Start time',
        'End time'
    ]
};
var $ba3568116bafb03a$export$2e2bcd8739ae039 = $ba3568116bafb03a$var$locale;


// Merge into a locale object
var $e0bfb08c543235f2$var$locale = {
    lang: (0, $fIrcP.default)({
        placeholder: 'Select date',
        yearPlaceholder: 'Select year',
        quarterPlaceholder: 'Select quarter',
        monthPlaceholder: 'Select month',
        weekPlaceholder: 'Select week',
        rangePlaceholder: [
            'Start date',
            'End date'
        ],
        rangeYearPlaceholder: [
            'Start year',
            'End year'
        ],
        rangeQuarterPlaceholder: [
            'Start quarter',
            'End quarter'
        ],
        rangeMonthPlaceholder: [
            'Start month',
            'End month'
        ],
        rangeWeekPlaceholder: [
            'Start week',
            'End week'
        ]
    }, (0, $337ed71125200ebb$export$2e2bcd8739ae039)),
    timePickerLocale: (0, $fIrcP.default)({}, (0, $ba3568116bafb03a$export$2e2bcd8739ae039))
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$e0bfb08c543235f2$export$2e2bcd8739ae039 = $e0bfb08c543235f2$var$locale;


var $11633cb42635b1ff$export$2e2bcd8739ae039 = (0, $e0bfb08c543235f2$export$2e2bcd8739ae039);




var $da4c09bd655d3c55$var$typeTemplate = '${label} is not a valid ${type}';
var $da4c09bd655d3c55$var$localeValues = {
    locale: 'en',
    Pagination: (0, $d2585e4c74ed0f46$export$2e2bcd8739ae039),
    DatePicker: (0, $e0bfb08c543235f2$export$2e2bcd8739ae039),
    TimePicker: (0, $ba3568116bafb03a$export$2e2bcd8739ae039),
    Calendar: (0, $11633cb42635b1ff$export$2e2bcd8739ae039),
    global: {
        placeholder: 'Please select'
    },
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        filterEmptyText: 'No filters',
        filterCheckall: 'Select all items',
        filterSearchPlaceholder: 'Search in filters',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page',
        selectNone: 'Clear all data',
        selectionAll: 'Select all data',
        sortTitle: 'Sort',
        expand: 'Expand row',
        collapse: 'Collapse row',
        triggerDesc: 'Click to sort descending',
        triggerAsc: 'Click to sort ascending',
        cancelSort: 'Click to cancel sorting'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items',
        remove: 'Remove',
        selectCurrent: 'Select current page',
        removeCurrent: 'Remove current page',
        selectAll: 'Select all data',
        removeAll: 'Remove all data',
        selectInvert: 'Invert current page'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file',
        downloadFile: 'Download file'
    },
    Empty: {
        description: 'No data'
    },
    Icon: {
        icon: 'icon'
    },
    Text: {
        edit: 'Edit',
        copy: 'Copy',
        copied: 'Copied',
        expand: 'Expand'
    },
    PageHeader: {
        back: 'Back'
    },
    Form: {
        optional: '(optional)',
        defaultValidateMessages: {
            "default": 'Field validation error for ${label}',
            required: 'Please enter ${label}',
            "enum": '${label} must be one of [${enum}]',
            whitespace: '${label} cannot be a blank character',
            date: {
                format: '${label} date format is invalid',
                parse: '${label} cannot be converted to a date',
                invalid: '${label} is an invalid date'
            },
            types: {
                string: $da4c09bd655d3c55$var$typeTemplate,
                method: $da4c09bd655d3c55$var$typeTemplate,
                array: $da4c09bd655d3c55$var$typeTemplate,
                object: $da4c09bd655d3c55$var$typeTemplate,
                number: $da4c09bd655d3c55$var$typeTemplate,
                date: $da4c09bd655d3c55$var$typeTemplate,
                "boolean": $da4c09bd655d3c55$var$typeTemplate,
                integer: $da4c09bd655d3c55$var$typeTemplate,
                "float": $da4c09bd655d3c55$var$typeTemplate,
                regexp: $da4c09bd655d3c55$var$typeTemplate,
                email: $da4c09bd655d3c55$var$typeTemplate,
                url: $da4c09bd655d3c55$var$typeTemplate,
                hex: $da4c09bd655d3c55$var$typeTemplate
            },
            string: {
                len: '${label} must be ${len} characters',
                min: '${label} must be at least ${min} characters',
                max: '${label} must be up to ${max} characters',
                range: '${label} must be between ${min}-${max} characters'
            },
            number: {
                len: '${label} must be equal to ${len}',
                min: '${label} must be minimum ${min}',
                max: '${label} must be maximum ${max}',
                range: '${label} must be between ${min}-${max}'
            },
            array: {
                len: 'Must be ${len} ${label}',
                min: 'At least ${min} ${label}',
                max: 'At most ${max} ${label}',
                range: 'The amount of ${label} must be between ${min}-${max}'
            },
            pattern: {
                mismatch: '${label} does not match the pattern ${pattern}'
            }
        }
    },
    Image: {
        preview: 'Preview'
    }
};
var $da4c09bd655d3c55$export$2e2bcd8739ae039 = $da4c09bd655d3c55$var$localeValues;


var $882906c8305330eb$var$runtimeLocale = (0, $fIrcP.default)({}, (0, $da4c09bd655d3c55$export$2e2bcd8739ae039).Modal);
function $882906c8305330eb$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) $882906c8305330eb$var$runtimeLocale = (0, $fIrcP.default)((0, $fIrcP.default)({}, $882906c8305330eb$var$runtimeLocale), newLocale);
    else $882906c8305330eb$var$runtimeLocale = (0, $fIrcP.default)({}, (0, $da4c09bd655d3c55$export$2e2bcd8739ae039).Modal);
}
function $882906c8305330eb$export$1b6004afda18cd51() {
    return $882906c8305330eb$var$runtimeLocale;
}



var $6fFrj = parcelRequire("6fFrj");
var $e704f7727fa599c3$var$LocaleContext = /*#__PURE__*/ (0, $6fFrj.createContext)(undefined);
var $e704f7727fa599c3$export$2e2bcd8739ae039 = $e704f7727fa599c3$var$LocaleContext;


var $249043b809ee0f76$export$b2f162cd5c15ea3e = 'internalMark';
var $249043b809ee0f76$var$LocaleProvider = function LocaleProvider(props) {
    var _props$locale = props.locale, locale = _props$locale === void 0 ? {} : _props$locale, children = props.children, _ANT_MARK__ = props._ANT_MARK__;
    $6fFrj.useEffect(function() {
        (0, $882906c8305330eb$export$9485ecb9d81a550c)(locale && locale.Modal);
        return function() {
            (0, $882906c8305330eb$export$9485ecb9d81a550c)();
        };
    }, [
        locale
    ]);
    var getMemoizedContextValue = $6fFrj.useMemo(function() {
        return (0, $fIrcP.default)((0, $fIrcP.default)({}, locale), {
            exist: true
        });
    }, [
        locale
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $e704f7727fa599c3$export$2e2bcd8739ae039).Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $249043b809ee0f76$export$2e2bcd8739ae039 = $249043b809ee0f76$var$LocaleProvider;



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");


var $14c42a3b346bdbb2$export$2e2bcd8739ae039 = (0, $da4c09bd655d3c55$export$2e2bcd8739ae039);


var $d37c6ecde78f75e8$var$LocaleReceiver = function LocaleReceiver(props) {
    var _props$componentName = props.componentName, componentName = _props$componentName === void 0 ? 'global' : _props$componentName, defaultLocale = props.defaultLocale, children = props.children;
    var antLocale = $6fFrj.useContext((0, $e704f7727fa599c3$export$2e2bcd8739ae039));
    var getLocale = $6fFrj.useMemo(function() {
        var _a;
        var locale = defaultLocale || (0, $14c42a3b346bdbb2$export$2e2bcd8739ae039)[componentName];
        var localeFromContext = (_a = antLocale === null || antLocale === void 0 ? void 0 : antLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return (0, $fIrcP.default)((0, $fIrcP.default)({}, locale instanceof Function ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        antLocale
    ]);
    var getLocaleCode = $6fFrj.useMemo(function() {
        var localeCode = antLocale && antLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if (antLocale && antLocale.exist && !localeCode) return (0, $14c42a3b346bdbb2$export$2e2bcd8739ae039).locale;
        return localeCode;
    }, [
        antLocale
    ]);
    return children(getLocale, getLocaleCode, antLocale);
};
var $d37c6ecde78f75e8$export$2e2bcd8739ae039 = $d37c6ecde78f75e8$var$LocaleReceiver;
var $d37c6ecde78f75e8$export$52f95bab0279a481 = function useLocaleReceiver(componentName, defaultLocale) {
    var antLocale = $6fFrj.useContext((0, $e704f7727fa599c3$export$2e2bcd8739ae039));
    var getLocale = $6fFrj.useMemo(function() {
        var _a;
        var locale = defaultLocale || (0, $14c42a3b346bdbb2$export$2e2bcd8739ae039)[componentName];
        var localeFromContext = (_a = antLocale === null || antLocale === void 0 ? void 0 : antLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return (0, $fIrcP.default)((0, $fIrcP.default)({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        antLocale
    ]);
    return [
        getLocale
    ];
};




var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");





var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $239fda6d4547d145$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
var $239fda6d4547d145$export$2e2bcd8739ae039 = $239fda6d4547d145$var$LoadingOutlined;



var $3240b41b65b5dac9$var$LoadingOutlined = function LoadingOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $239fda6d4547d145$export$2e2bcd8739ae039)
    }));
};
var $3240b41b65b5dac9$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($3240b41b65b5dac9$var$LoadingOutlined);
var $3240b41b65b5dac9$export$2e2bcd8739ae039 = $3240b41b65b5dac9$var$RefIcon;



var $fActo = parcelRequire("fActo");

var $8ctwF = parcelRequire("8ctwF");

var $6fFrj = parcelRequire("6fFrj");


var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $3jFiw = parcelRequire("3jFiw");

var $6fFrj = parcelRequire("6fFrj");


function $68f4c8dbe1a88a9d$export$2e2bcd8739ae039(getRcNotificationInstance, getRCNoticeProps) {
    var useMessage = function useMessage() {
        // We can only get content by render
        var getPrefixCls;
        var getPopupContainer;
        // We create a proxy to handle delay created instance
        var innerInstance = null;
        var proxy = {
            add: function add(noticeProps, holderCallback) {
                innerInstance === null || innerInstance === void 0 || innerInstance.component.add(noticeProps, holderCallback);
            }
        };
        var _useRCNotification = (0, $3jFiw.default)(proxy), _useRCNotification2 = (0, $jP8CL.default)(_useRCNotification, 2), hookNotify = _useRCNotification2[0], holder = _useRCNotification2[1];
        function notify(args) {
            var customizePrefixCls = args.prefixCls;
            var mergedPrefixCls = getPrefixCls('message', customizePrefixCls);
            var rootPrefixCls = getPrefixCls();
            var target = args.key || (0, $55c6005cab9be059$export$ab227b2024307500)();
            var closePromise = new Promise(function(resolve) {
                var callback = function callback() {
                    if (typeof args.onClose === 'function') args.onClose();
                    return resolve(true);
                };
                getRcNotificationInstance((0, $fIrcP.default)((0, $fIrcP.default)({}, args), {
                    prefixCls: mergedPrefixCls,
                    rootPrefixCls: rootPrefixCls,
                    getPopupContainer: getPopupContainer
                }), function(_ref) {
                    var prefixCls = _ref.prefixCls, instance = _ref.instance;
                    innerInstance = instance;
                    hookNotify(getRCNoticeProps((0, $fIrcP.default)((0, $fIrcP.default)({}, args), {
                        key: target,
                        onClose: callback
                    }), prefixCls));
                });
            });
            var result = function result() {
                if (innerInstance) innerInstance.removeNotice(target);
            };
            result.then = function(filled, rejected) {
                return closePromise.then(filled, rejected);
            };
            result.promise = closePromise;
            return result;
        }
        // Fill functions
        var hookApiRef = $6fFrj.useRef({});
        hookApiRef.current.open = notify;
        (0, $55c6005cab9be059$export$37928ca2918d853b).forEach(function(type) {
            return (0, $55c6005cab9be059$export$63b017493c112c94)(hookApiRef.current, type);
        });
        return [
            hookApiRef.current,
            /*#__PURE__*/ $6fFrj.createElement((0, $1bdb4c3de815e386$export$cd5442f2b8da7663), {
                key: "holder"
            }, function(context) {
                getPrefixCls = context.getPrefixCls;
                getPopupContainer = context.getPopupContainer;
                return holder;
            })
        ];
    };
    return useMessage;
}


var $55c6005cab9be059$var$messageInstance;
var $55c6005cab9be059$var$defaultDuration = 3;
var $55c6005cab9be059$var$defaultTop;
var $55c6005cab9be059$var$key = 1;
var $55c6005cab9be059$var$localPrefixCls = '';
var $55c6005cab9be059$var$transitionName = 'move-up';
var $55c6005cab9be059$var$hasTransitionName = false;
var $55c6005cab9be059$var$getContainer;
var $55c6005cab9be059$var$maxCount;
var $55c6005cab9be059$var$rtl = false;
function $55c6005cab9be059$export$ab227b2024307500() {
    return $55c6005cab9be059$var$key++;
}
function $55c6005cab9be059$var$setMessageConfig(options) {
    if (options.top !== undefined) {
        $55c6005cab9be059$var$defaultTop = options.top;
        $55c6005cab9be059$var$messageInstance = null; // delete messageInstance for new defaultTop
    }
    if (options.duration !== undefined) $55c6005cab9be059$var$defaultDuration = options.duration;
    if (options.prefixCls !== undefined) $55c6005cab9be059$var$localPrefixCls = options.prefixCls;
    if (options.getContainer !== undefined) {
        $55c6005cab9be059$var$getContainer = options.getContainer;
        $55c6005cab9be059$var$messageInstance = null; // delete messageInstance for new getContainer
    }
    if (options.transitionName !== undefined) {
        $55c6005cab9be059$var$transitionName = options.transitionName;
        $55c6005cab9be059$var$messageInstance = null; // delete messageInstance for new transitionName
        $55c6005cab9be059$var$hasTransitionName = true;
    }
    if (options.maxCount !== undefined) {
        $55c6005cab9be059$var$maxCount = options.maxCount;
        $55c6005cab9be059$var$messageInstance = null;
    }
    if (options.rtl !== undefined) $55c6005cab9be059$var$rtl = options.rtl;
}
function $55c6005cab9be059$var$getRCNotificationInstance(args, callback) {
    var customizePrefixCls = args.prefixCls, getContextPopupContainer = args.getPopupContainer;
    var _globalConfig = (0, $f681578438e08b9b$export$f9cd1e43211d8a4a)(), getPrefixCls = _globalConfig.getPrefixCls, getRootPrefixCls = _globalConfig.getRootPrefixCls, getIconPrefixCls = _globalConfig.getIconPrefixCls;
    var prefixCls = getPrefixCls('message', customizePrefixCls || $55c6005cab9be059$var$localPrefixCls);
    var rootPrefixCls = getRootPrefixCls(args.rootPrefixCls, prefixCls);
    var iconPrefixCls = getIconPrefixCls();
    if ($55c6005cab9be059$var$messageInstance) {
        callback({
            prefixCls: prefixCls,
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls,
            instance: $55c6005cab9be059$var$messageInstance
        });
        return;
    }
    var instanceConfig = {
        prefixCls: prefixCls,
        transitionName: $55c6005cab9be059$var$hasTransitionName ? $55c6005cab9be059$var$transitionName : "".concat(rootPrefixCls, "-").concat($55c6005cab9be059$var$transitionName),
        style: {
            top: $55c6005cab9be059$var$defaultTop
        },
        getContainer: $55c6005cab9be059$var$getContainer || getContextPopupContainer,
        maxCount: $55c6005cab9be059$var$maxCount
    };
    (0, $8ctwF.default).newInstance(instanceConfig, function(instance) {
        if ($55c6005cab9be059$var$messageInstance) {
            callback({
                prefixCls: prefixCls,
                rootPrefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                instance: $55c6005cab9be059$var$messageInstance
            });
            return;
        }
        $55c6005cab9be059$var$messageInstance = instance;
        callback({
            prefixCls: prefixCls,
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls,
            instance: instance
        });
    });
}
var $55c6005cab9be059$var$typeToIcon = {
    info: (0, $07ece45f4cb05aa5$export$2e2bcd8739ae039),
    success: (0, $a539793a765f8968$export$2e2bcd8739ae039),
    error: (0, $9429a61ddf5bc264$export$2e2bcd8739ae039),
    warning: (0, $4b49a895caf27162$export$2e2bcd8739ae039),
    loading: (0, $3240b41b65b5dac9$export$2e2bcd8739ae039)
};
var $55c6005cab9be059$export$37928ca2918d853b = Object.keys($55c6005cab9be059$var$typeToIcon);
function $55c6005cab9be059$var$getRCNoticeProps(args, prefixCls, iconPrefixCls) {
    var duration = args.duration !== undefined ? args.duration : $55c6005cab9be059$var$defaultDuration;
    var IconComponent = $55c6005cab9be059$var$typeToIcon[args.type];
    var messageClass = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-custom-content"), (0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-").concat(args.type), args.type), "".concat(prefixCls, "-rtl"), $55c6005cab9be059$var$rtl === true));
    return {
        key: args.key,
        duration: duration,
        style: args.style || {},
        className: args.className,
        content: /*#__PURE__*/ $6fFrj.createElement((0, $f681578438e08b9b$export$2e2bcd8739ae039), {
            iconPrefixCls: iconPrefixCls
        }, /*#__PURE__*/ $6fFrj.createElement("div", {
            className: messageClass
        }, args.icon || IconComponent && /*#__PURE__*/ $6fFrj.createElement(IconComponent, null), /*#__PURE__*/ $6fFrj.createElement("span", null, args.content))),
        onClose: args.onClose,
        onClick: args.onClick
    };
}
function $55c6005cab9be059$var$notice(args) {
    var target = args.key || $55c6005cab9be059$export$ab227b2024307500();
    var closePromise = new Promise(function(resolve) {
        var callback = function callback() {
            if (typeof args.onClose === 'function') args.onClose();
            return resolve(true);
        };
        $55c6005cab9be059$var$getRCNotificationInstance(args, function(_ref) {
            var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, instance = _ref.instance;
            instance.notice($55c6005cab9be059$var$getRCNoticeProps((0, $fIrcP.default)((0, $fIrcP.default)({}, args), {
                key: target,
                onClose: callback
            }), prefixCls, iconPrefixCls));
        });
    });
    var result = function result() {
        var _a;
        if ($55c6005cab9be059$var$messageInstance) {
            $55c6005cab9be059$var$messageInstance.removeNotice(target);
            (_a = args.onClose) === null || _a === void 0 || _a.call(args);
        }
    };
    result.then = function(filled, rejected) {
        return closePromise.then(filled, rejected);
    };
    result.promise = closePromise;
    return result;
}
function $55c6005cab9be059$var$isArgsProps(content) {
    return Object.prototype.toString.call(content) === '[object Object]' && !!content.content;
}
var $55c6005cab9be059$var$api = {
    open: $55c6005cab9be059$var$notice,
    config: $55c6005cab9be059$var$setMessageConfig,
    destroy: function destroy(messageKey) {
        if ($55c6005cab9be059$var$messageInstance) {
            if (messageKey) {
                var _messageInstance = $55c6005cab9be059$var$messageInstance, removeNotice = _messageInstance.removeNotice;
                removeNotice(messageKey);
            } else {
                var _messageInstance2 = $55c6005cab9be059$var$messageInstance, destroy = _messageInstance2.destroy;
                destroy();
                $55c6005cab9be059$var$messageInstance = null;
            }
        }
    }
};
function $55c6005cab9be059$export$63b017493c112c94(originalApi, type) {
    originalApi[type] = function(content, duration, onClose) {
        if ($55c6005cab9be059$var$isArgsProps(content)) return originalApi.open((0, $fIrcP.default)((0, $fIrcP.default)({}, content), {
            type: type
        }));
        if (typeof duration === 'function') {
            onClose = duration;
            duration = undefined;
        }
        return originalApi.open({
            content: content,
            duration: duration,
            type: type,
            onClose: onClose
        });
    };
}
$55c6005cab9be059$export$37928ca2918d853b.forEach(function(type) {
    return $55c6005cab9be059$export$63b017493c112c94($55c6005cab9be059$var$api, type);
});
$55c6005cab9be059$var$api.warn = $55c6005cab9be059$var$api.warning;
$55c6005cab9be059$var$api.useMessage = (0, $68f4c8dbe1a88a9d$export$2e2bcd8739ae039)($55c6005cab9be059$var$getRCNotificationInstance, $55c6005cab9be059$var$getRCNoticeProps);
var $55c6005cab9be059$export$8bedcca5bbd73999 = function getInstance() {
    return null;
};
var $55c6005cab9be059$export$2e2bcd8739ae039 = $55c6005cab9be059$var$api;



var $1WWLf = parcelRequire("1WWLf");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");






var $fActo = parcelRequire("fActo");

var $8ctwF = parcelRequire("8ctwF");

var $6fFrj = parcelRequire("6fFrj");


var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $3jFiw = parcelRequire("3jFiw");

var $6fFrj = parcelRequire("6fFrj");

function $38185d73a2ab689d$export$2e2bcd8739ae039(getNotificationInstance, getRCNoticeProps) {
    var useNotification = function useNotification() {
        // We can only get content by render
        var getPrefixCls;
        // We create a proxy to handle delay created instance
        var innerInstance = null;
        var proxy = {
            add: function add(noticeProps, holderCallback) {
                innerInstance === null || innerInstance === void 0 || innerInstance.component.add(noticeProps, holderCallback);
            }
        };
        var _useRCNotification = (0, $3jFiw.default)(proxy), _useRCNotification2 = (0, $jP8CL.default)(_useRCNotification, 2), hookNotify = _useRCNotification2[0], holder = _useRCNotification2[1];
        function notify(args) {
            var customizePrefixCls = args.prefixCls;
            var mergedPrefixCls = getPrefixCls('notification', customizePrefixCls);
            getNotificationInstance((0, $fIrcP.default)((0, $fIrcP.default)({}, args), {
                prefixCls: mergedPrefixCls
            }), function(_ref) {
                var prefixCls = _ref.prefixCls, instance = _ref.instance;
                innerInstance = instance;
                hookNotify(getRCNoticeProps(args, prefixCls));
            });
        }
        // Fill functions
        var hookApiRef = $6fFrj.useRef({});
        hookApiRef.current.open = notify;
        [
            'success',
            'info',
            'warning',
            'error'
        ].forEach(function(type) {
            hookApiRef.current[type] = function(args) {
                return hookApiRef.current.open((0, $fIrcP.default)((0, $fIrcP.default)({}, args), {
                    type: type
                }));
            };
        });
        return [
            hookApiRef.current,
            /*#__PURE__*/ $6fFrj.createElement((0, $1bdb4c3de815e386$export$cd5442f2b8da7663), {
                key: "holder"
            }, function(context) {
                getPrefixCls = context.getPrefixCls;
                return holder;
            })
        ];
    };
    return useNotification;
}


var $fb8edf64a7aededa$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fb8edf64a7aededa$var$notificationInstance = {};
var $fb8edf64a7aededa$var$defaultDuration = 4.5;
var $fb8edf64a7aededa$var$defaultTop = 24;
var $fb8edf64a7aededa$var$defaultBottom = 24;
var $fb8edf64a7aededa$var$defaultPrefixCls = '';
var $fb8edf64a7aededa$var$defaultPlacement = 'topRight';
var $fb8edf64a7aededa$var$defaultGetContainer;
var $fb8edf64a7aededa$var$defaultCloseIcon;
var $fb8edf64a7aededa$var$rtl = false;
var $fb8edf64a7aededa$var$maxCount;
function $fb8edf64a7aededa$var$setNotificationConfig(options) {
    var duration = options.duration, placement = options.placement, bottom = options.bottom, top = options.top, getContainer = options.getContainer, closeIcon = options.closeIcon, prefixCls = options.prefixCls;
    if (prefixCls !== undefined) $fb8edf64a7aededa$var$defaultPrefixCls = prefixCls;
    if (duration !== undefined) $fb8edf64a7aededa$var$defaultDuration = duration;
    if (placement !== undefined) $fb8edf64a7aededa$var$defaultPlacement = placement;
    else if (options.rtl) $fb8edf64a7aededa$var$defaultPlacement = 'topLeft';
    if (bottom !== undefined) $fb8edf64a7aededa$var$defaultBottom = bottom;
    if (top !== undefined) $fb8edf64a7aededa$var$defaultTop = top;
    if (getContainer !== undefined) $fb8edf64a7aededa$var$defaultGetContainer = getContainer;
    if (closeIcon !== undefined) $fb8edf64a7aededa$var$defaultCloseIcon = closeIcon;
    if (options.rtl !== undefined) $fb8edf64a7aededa$var$rtl = options.rtl;
    if (options.maxCount !== undefined) $fb8edf64a7aededa$var$maxCount = options.maxCount;
}
function $fb8edf64a7aededa$var$getPlacementStyle(placement) {
    var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $fb8edf64a7aededa$var$defaultTop;
    var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $fb8edf64a7aededa$var$defaultBottom;
    var style;
    switch(placement){
        case 'top':
            style = {
                left: '50%',
                transform: 'translateX(-50%)',
                right: 'auto',
                top: top,
                bottom: 'auto'
            };
            break;
        case 'topLeft':
            style = {
                left: 0,
                top: top,
                bottom: 'auto'
            };
            break;
        case 'topRight':
            style = {
                right: 0,
                top: top,
                bottom: 'auto'
            };
            break;
        case 'bottom':
            style = {
                left: '50%',
                transform: 'translateX(-50%)',
                right: 'auto',
                top: 'auto',
                bottom: bottom
            };
            break;
        case 'bottomLeft':
            style = {
                left: 0,
                top: 'auto',
                bottom: bottom
            };
            break;
        default:
            style = {
                right: 0,
                top: 'auto',
                bottom: bottom
            };
            break;
    }
    return style;
}
function $fb8edf64a7aededa$var$getNotificationInstance(args, callback) {
    var _args$placement = args.placement, placement = _args$placement === void 0 ? $fb8edf64a7aededa$var$defaultPlacement : _args$placement, top = args.top, bottom = args.bottom, _args$getContainer = args.getContainer, getContainer = _args$getContainer === void 0 ? $fb8edf64a7aededa$var$defaultGetContainer : _args$getContainer, customizePrefixCls = args.prefixCls;
    var _globalConfig = (0, $f681578438e08b9b$export$f9cd1e43211d8a4a)(), getPrefixCls = _globalConfig.getPrefixCls, getIconPrefixCls = _globalConfig.getIconPrefixCls;
    var prefixCls = getPrefixCls('notification', customizePrefixCls || $fb8edf64a7aededa$var$defaultPrefixCls);
    var iconPrefixCls = getIconPrefixCls();
    var cacheKey = "".concat(prefixCls, "-").concat(placement);
    var cacheInstance = $fb8edf64a7aededa$var$notificationInstance[cacheKey];
    if (cacheInstance) {
        Promise.resolve(cacheInstance).then(function(instance) {
            callback({
                prefixCls: "".concat(prefixCls, "-notice"),
                iconPrefixCls: iconPrefixCls,
                instance: instance
            });
        });
        return;
    }
    var notificationClass = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-").concat(placement), (0, $43449.default)({}, "".concat(prefixCls, "-rtl"), $fb8edf64a7aededa$var$rtl === true));
    $fb8edf64a7aededa$var$notificationInstance[cacheKey] = new Promise(function(resolve) {
        (0, $8ctwF.default).newInstance({
            prefixCls: prefixCls,
            className: notificationClass,
            style: $fb8edf64a7aededa$var$getPlacementStyle(placement, top, bottom),
            getContainer: getContainer,
            maxCount: $fb8edf64a7aededa$var$maxCount
        }, function(notification) {
            resolve(notification);
            callback({
                prefixCls: "".concat(prefixCls, "-notice"),
                iconPrefixCls: iconPrefixCls,
                instance: notification
            });
        });
    });
}
var $fb8edf64a7aededa$var$typeToIcon = {
    success: (0, $996a31538a9d5bb4$export$2e2bcd8739ae039),
    info: (0, $60bea5c3f0793107$export$2e2bcd8739ae039),
    error: (0, $83dc1c57eab38fbc$export$2e2bcd8739ae039),
    warning: (0, $5a26a3af64ff8e01$export$2e2bcd8739ae039)
};
function $fb8edf64a7aededa$var$getRCNoticeProps(args, prefixCls, iconPrefixCls) {
    var durationArg = args.duration, icon = args.icon, type = args.type, description = args.description, message = args.message, btn = args.btn, onClose = args.onClose, onClick = args.onClick, key = args.key, style = args.style, className = args.className, _args$closeIcon = args.closeIcon, closeIcon = _args$closeIcon === void 0 ? $fb8edf64a7aededa$var$defaultCloseIcon : _args$closeIcon, props = args.props;
    var duration = durationArg === undefined ? $fb8edf64a7aededa$var$defaultDuration : durationArg;
    var iconNode = null;
    if (icon) iconNode = /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-icon")
    }, args.icon);
    else if (type) iconNode = /*#__PURE__*/ $6fFrj.createElement($fb8edf64a7aededa$var$typeToIcon[type] || null, {
        className: "".concat(prefixCls, "-icon ").concat(prefixCls, "-icon-").concat(type)
    });
    var closeIconToRender = typeof closeIcon === 'undefined' ? /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-close-x")
    }, /*#__PURE__*/ $6fFrj.createElement((0, $4cb3f1f073816266$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-close-icon")
    })) : closeIcon;
    var autoMarginTag = !description && iconNode ? /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-message-single-line-auto-margin")
    }) : null;
    return {
        content: /*#__PURE__*/ $6fFrj.createElement((0, $f681578438e08b9b$export$2e2bcd8739ae039), {
            iconPrefixCls: iconPrefixCls
        }, /*#__PURE__*/ $6fFrj.createElement("div", {
            className: iconNode ? "".concat(prefixCls, "-with-icon") : '',
            role: "alert"
        }, iconNode, /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-message")
        }, autoMarginTag, message), /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-description")
        }, description), btn ? /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-btn")
        }, btn) : null)),
        duration: duration,
        closable: true,
        closeIcon: closeIconToRender,
        onClose: onClose,
        onClick: onClick,
        key: key,
        style: style || {},
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(className, (0, $43449.default)({}, "".concat(prefixCls, "-").concat(type), !!type)),
        props: props
    };
}
function $fb8edf64a7aededa$var$notice(args) {
    $fb8edf64a7aededa$var$getNotificationInstance(args, function(_ref) {
        var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, instance = _ref.instance;
        instance.notice($fb8edf64a7aededa$var$getRCNoticeProps(args, prefixCls, iconPrefixCls));
    });
}
var $fb8edf64a7aededa$var$api = {
    open: $fb8edf64a7aededa$var$notice,
    close: function close(key) {
        Object.keys($fb8edf64a7aededa$var$notificationInstance).forEach(function(cacheKey) {
            return Promise.resolve($fb8edf64a7aededa$var$notificationInstance[cacheKey]).then(function(instance) {
                instance.removeNotice(key);
            });
        });
    },
    config: $fb8edf64a7aededa$var$setNotificationConfig,
    destroy: function destroy() {
        Object.keys($fb8edf64a7aededa$var$notificationInstance).forEach(function(cacheKey) {
            Promise.resolve($fb8edf64a7aededa$var$notificationInstance[cacheKey]).then(function(instance) {
                instance.destroy();
            });
            delete $fb8edf64a7aededa$var$notificationInstance[cacheKey]; // lgtm[js/missing-await]
        });
    }
};
[
    'success',
    'info',
    'warning',
    'error'
].forEach(function(type) {
    $fb8edf64a7aededa$var$api[type] = function(args) {
        return $fb8edf64a7aededa$var$api.open((0, $fIrcP.default)((0, $fIrcP.default)({}, args), {
            type: type
        }));
    };
});
$fb8edf64a7aededa$var$api.warn = $fb8edf64a7aededa$var$api.warning;
$fb8edf64a7aededa$var$api.useNotification = (0, $38185d73a2ab689d$export$2e2bcd8739ae039)($fb8edf64a7aededa$var$getNotificationInstance, $fb8edf64a7aededa$var$getRCNoticeProps);
var $fb8edf64a7aededa$export$8bedcca5bbd73999 = function getInstance(cacheKey) {
    return $fb8edf64a7aededa$var$__awaiter(void 0, void 0, void 0, /*#__PURE__*/ (0, $1WWLf.default)().mark(function _callee() {
        return (0, $1WWLf.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", null);
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
};
var $fb8edf64a7aededa$export$2e2bcd8739ae039 = $fb8edf64a7aededa$var$api;



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");
var $1bdb4c3de815e386$var$defaultGetPrefixCls = function defaultGetPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? "ant-".concat(suffixCls) : 'ant';
};
var $1bdb4c3de815e386$export$a92f85ab3e9ad68b = /*#__PURE__*/ $6fFrj.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $1bdb4c3de815e386$var$defaultGetPrefixCls
});
var $1bdb4c3de815e386$export$cd5442f2b8da7663 = $1bdb4c3de815e386$export$a92f85ab3e9ad68b.Consumer;
function $1bdb4c3de815e386$export$ac719629fc076fcb(config) {
    return function withConfigConsumerFunc(Component) {
        // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
        var SFC = function SFC(props) {
            return /*#__PURE__*/ $6fFrj.createElement($1bdb4c3de815e386$export$cd5442f2b8da7663, null, function(configProps) {
                var basicPrefixCls = config.prefixCls;
                var getPrefixCls = configProps.getPrefixCls;
                var customizePrefixCls = props.prefixCls;
                var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
                return /*#__PURE__*/ $6fFrj.createElement(Component, (0, $fIrcP.default)({}, configProps, props, {
                    prefixCls: prefixCls
                }));
            });
        };
        var cons = Component.constructor;
        var name = cons && cons.displayName || Component.name || 'Component';
        return SFC;
    };
}


/* eslint-disable import/prefer-default-export, prefer-destructuring */ 




var $9613825d06e6c531$export$d850312fc213f33e = /** @class */ function() {
    function TinyColor(color, opts) {
        if (color === void 0) color = '';
        if (opts === void 0) opts = {};
        var _a;
        // If input is already a tinycolor, return itself
        if (color instanceof TinyColor) // eslint-disable-next-line no-constructor-return
        return color;
        if (typeof color === 'number') color = (0, $a7b58901a65f86df$export$4076ec82b665900d)(color);
        this.originalInput = color;
        var rgb = (0, $321d015feb50c14a$export$87de337d8199f22c)(color);
        this.originalInput = color;
        this.r = rgb.r;
        this.g = rgb.g;
        this.b = rgb.b;
        this.a = rgb.a;
        this.roundA = Math.round(100 * this.a) / 100;
        this.format = (_a = opts.format) !== null && _a !== void 0 ? _a : rgb.format;
        this.gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this.r < 1) this.r = Math.round(this.r);
        if (this.g < 1) this.g = Math.round(this.g);
        if (this.b < 1) this.b = Math.round(this.b);
        this.isValid = rgb.ok;
    }
    TinyColor.prototype.isDark = function() {
        return this.getBrightness() < 128;
    };
    TinyColor.prototype.isLight = function() {
        return !this.isDark();
    };
    /**
     * Returns the perceived brightness of the color, from 0-255.
     */ TinyColor.prototype.getBrightness = function() {
        // http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    };
    /**
     * Returns the perceived luminance of a color, from 0-1.
     */ TinyColor.prototype.getLuminance = function() {
        // http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var R;
        var G;
        var B;
        var RsRGB = rgb.r / 255;
        var GsRGB = rgb.g / 255;
        var BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    };
    /**
     * Returns the alpha value of a color, from 0-1.
     */ TinyColor.prototype.getAlpha = function() {
        return this.a;
    };
    /**
     * Sets the alpha value on the current color.
     *
     * @param alpha - The new alpha value. The accepted range is 0-1.
     */ TinyColor.prototype.setAlpha = function(alpha) {
        this.a = (0, $81e65def826cae1e$export$3ae665204365318d)(alpha);
        this.roundA = Math.round(100 * this.a) / 100;
        return this;
    };
    /**
     * Returns whether the color is monochrome.
     */ TinyColor.prototype.isMonochrome = function() {
        var s = this.toHsl().s;
        return s === 0;
    };
    /**
     * Returns the object as a HSVA object.
     */ TinyColor.prototype.toHsv = function() {
        var hsv = (0, $a7b58901a65f86df$export$f76e85ca00a47f5c)(this.r, this.g, this.b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this.a
        };
    };
    /**
     * Returns the hsva values interpolated into a string with the following format:
     * "hsva(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHsvString = function() {
        var hsv = (0, $a7b58901a65f86df$export$f76e85ca00a47f5c)(this.r, this.g, this.b);
        var h = Math.round(hsv.h * 360);
        var s = Math.round(hsv.s * 100);
        var v = Math.round(hsv.v * 100);
        return this.a === 1 ? "hsv(".concat(h, ", ").concat(s, "%, ").concat(v, "%)") : "hsva(".concat(h, ", ").concat(s, "%, ").concat(v, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a HSLA object.
     */ TinyColor.prototype.toHsl = function() {
        var hsl = (0, $a7b58901a65f86df$export$c85ca4f4753af384)(this.r, this.g, this.b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this.a
        };
    };
    /**
     * Returns the hsla values interpolated into a string with the following format:
     * "hsla(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHslString = function() {
        var hsl = (0, $a7b58901a65f86df$export$c85ca4f4753af384)(this.r, this.g, this.b);
        var h = Math.round(hsl.h * 360);
        var s = Math.round(hsl.s * 100);
        var l = Math.round(hsl.l * 100);
        return this.a === 1 ? "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)") : "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the hex value of the color.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHex = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return (0, $a7b58901a65f86df$export$34d09c4a771c46ef)(this.r, this.g, this.b, allow3Char);
    };
    /**
     * Returns the hex value of the color -with a # prefixed.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHexString = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return '#' + this.toHex(allow3Char);
    };
    /**
     * Returns the hex 8 value of the color.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8 = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return (0, $a7b58901a65f86df$export$ffee5509a14af63d)(this.r, this.g, this.b, this.a, allow4Char);
    };
    /**
     * Returns the hex 8 value of the color -with a # prefixed.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8String = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return '#' + this.toHex8(allow4Char);
    };
    /**
     * Returns the shorter hex value of the color depends on its alpha -with a # prefixed.
     * @param allowShortChar will shorten hex value to 3 or 4 char if possible
     */ TinyColor.prototype.toHexShortString = function(allowShortChar) {
        if (allowShortChar === void 0) allowShortChar = false;
        return this.a === 1 ? this.toHexString(allowShortChar) : this.toHex8String(allowShortChar);
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toRgb = function() {
        return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA values interpolated into a string with the following format:
     * "RGBA(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toRgbString = function() {
        var r = Math.round(this.r);
        var g = Math.round(this.g);
        var b = Math.round(this.b);
        return this.a === 1 ? "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")") : "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toPercentageRgb = function() {
        var fmt = function(x) {
            return "".concat(Math.round((0, $81e65def826cae1e$export$b0e60b43d1d059f0)(x, 255) * 100), "%");
        };
        return {
            r: fmt(this.r),
            g: fmt(this.g),
            b: fmt(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA relative values interpolated into a string
     */ TinyColor.prototype.toPercentageRgbString = function() {
        var rnd = function(x) {
            return Math.round((0, $81e65def826cae1e$export$b0e60b43d1d059f0)(x, 255) * 100);
        };
        return this.a === 1 ? "rgb(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%)") : "rgba(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%, ").concat(this.roundA, ")");
    };
    /**
     * The 'real' name of the color -if there is one.
     */ TinyColor.prototype.toName = function() {
        if (this.a === 0) return 'transparent';
        if (this.a < 1) return false;
        var hex = '#' + (0, $a7b58901a65f86df$export$34d09c4a771c46ef)(this.r, this.g, this.b, false);
        for(var _i = 0, _a = Object.entries((0, $b7f1e600d42473b1$export$e4b2ac9215619f8d)); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (hex === value) return key;
        }
        return false;
    };
    TinyColor.prototype.toString = function(format) {
        var formatSet = Boolean(format);
        format = format !== null && format !== void 0 ? format : this.format;
        var formattedString = false;
        var hasAlpha = this.a < 1 && this.a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format.startsWith('hex') || format === 'name');
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === 'name' && this.a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === 'rgb') formattedString = this.toRgbString();
        if (format === 'prgb') formattedString = this.toPercentageRgbString();
        if (format === 'hex' || format === 'hex6') formattedString = this.toHexString();
        if (format === 'hex3') formattedString = this.toHexString(true);
        if (format === 'hex4') formattedString = this.toHex8String(true);
        if (format === 'hex8') formattedString = this.toHex8String();
        if (format === 'name') formattedString = this.toName();
        if (format === 'hsl') formattedString = this.toHslString();
        if (format === 'hsv') formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    };
    TinyColor.prototype.toNumber = function() {
        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    };
    TinyColor.prototype.clone = function() {
        return new TinyColor(this.toString());
    };
    /**
     * Lighten the color a given amount. Providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.lighten = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l += amount / 100;
        hsl.l = (0, $81e65def826cae1e$export$5c5ee632c52bc4a2)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Brighten the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.brighten = function(amount) {
        if (amount === void 0) amount = 10;
        var rgb = this.toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return new TinyColor(rgb);
    };
    /**
     * Darken the color a given amount, from 0 to 100.
     * Providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.darken = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l -= amount / 100;
        hsl.l = (0, $81e65def826cae1e$export$5c5ee632c52bc4a2)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Mix the color with pure white, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.tint = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix('white', amount);
    };
    /**
     * Mix the color with pure black, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.shade = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix('black', amount);
    };
    /**
     * Desaturate the color a given amount, from 0 to 100.
     * Providing 100 will is the same as calling greyscale
     * @param amount - valid between 1-100
     */ TinyColor.prototype.desaturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s -= amount / 100;
        hsl.s = (0, $81e65def826cae1e$export$5c5ee632c52bc4a2)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Saturate the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.saturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s += amount / 100;
        hsl.s = (0, $81e65def826cae1e$export$5c5ee632c52bc4a2)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Completely desaturates a color into greyscale.
     * Same as calling `desaturate(100)`
     */ TinyColor.prototype.greyscale = function() {
        return this.desaturate(100);
    };
    /**
     * Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
     * Values outside of this range will be wrapped into this range.
     */ TinyColor.prototype.spin = function(amount) {
        var hsl = this.toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return new TinyColor(hsl);
    };
    /**
     * Mix the current color a given amount with another color, from 0 to 100.
     * 0 means no mixing (return current color).
     */ TinyColor.prototype.mix = function(color, amount) {
        if (amount === void 0) amount = 50;
        var rgb1 = this.toRgb();
        var rgb2 = new TinyColor(color).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return new TinyColor(rgba);
    };
    TinyColor.prototype.analogous = function(results, slices) {
        if (results === void 0) results = 6;
        if (slices === void 0) slices = 30;
        var hsl = this.toHsl();
        var part = 360 / slices;
        var ret = [
            this
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(new TinyColor(hsl));
        }
        return ret;
    };
    /**
     * taken from https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js
     */ TinyColor.prototype.complement = function() {
        var hsl = this.toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return new TinyColor(hsl);
    };
    TinyColor.prototype.monochromatic = function(results) {
        if (results === void 0) results = 6;
        var hsv = this.toHsv();
        var h = hsv.h;
        var s = hsv.s;
        var v = hsv.v;
        var res = [];
        var modification = 1 / results;
        while(results--){
            res.push(new TinyColor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return res;
    };
    TinyColor.prototype.splitcomplement = function() {
        var hsl = this.toHsl();
        var h = hsl.h;
        return [
            this,
            new TinyColor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            new TinyColor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    };
    /**
     * Compute how the color would appear on a background
     */ TinyColor.prototype.onBackground = function(background) {
        var fg = this.toRgb();
        var bg = new TinyColor(background).toRgb();
        var alpha = fg.a + bg.a * (1 - fg.a);
        return new TinyColor({
            r: (fg.r * fg.a + bg.r * bg.a * (1 - fg.a)) / alpha,
            g: (fg.g * fg.a + bg.g * bg.a * (1 - fg.a)) / alpha,
            b: (fg.b * fg.a + bg.b * bg.a * (1 - fg.a)) / alpha,
            a: alpha
        });
    };
    /**
     * Alias for `polyad(3)`
     */ TinyColor.prototype.triad = function() {
        return this.polyad(3);
    };
    /**
     * Alias for `polyad(4)`
     */ TinyColor.prototype.tetrad = function() {
        return this.polyad(4);
    };
    /**
     * Get polyad colors, like (for 1, 2, 3, 4, 5, 6, 7, 8, etc...)
     * monad, dyad, triad, tetrad, pentad, hexad, heptad, octad, etc...
     */ TinyColor.prototype.polyad = function(n) {
        var hsl = this.toHsl();
        var h = hsl.h;
        var result = [
            this
        ];
        var increment = 360 / n;
        for(var i = 1; i < n; i++)result.push(new TinyColor({
            h: (h + i * increment) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    };
    /**
     * compare color vs current color
     */ TinyColor.prototype.equals = function(color) {
        return this.toRgbString() === new TinyColor(color).toRgbString();
    };
    return TinyColor;
}();
function $9613825d06e6c531$export$6325b328a5266d34(color, opts) {
    if (color === void 0) color = '';
    if (opts === void 0) opts = {};
    return new $9613825d06e6c531$export$d850312fc213f33e(color, opts);
}



var $aSXdS = parcelRequire("aSXdS");


var $9b95e2e32a1fe45a$var$dynamicStyleMark = "-ant-".concat(Date.now(), "-").concat(Math.random());
function $9b95e2e32a1fe45a$export$3d2f074408bd1b82(globalPrefixCls, theme) {
    var variables = {};
    var formatColor = function formatColor(color, updater) {
        var clone = color.clone();
        clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
        return clone.toRgbString();
    };
    var fillColor = function fillColor(colorVal, type) {
        var baseColor = new (0, $9613825d06e6c531$export$d850312fc213f33e)(colorVal);
        var colorPalettes = (0, $f98afff48ee41fa5$export$80d376111cc09ad7)(baseColor.toRgbString());
        variables["".concat(type, "-color")] = formatColor(baseColor);
        variables["".concat(type, "-color-disabled")] = colorPalettes[1];
        variables["".concat(type, "-color-hover")] = colorPalettes[4];
        variables["".concat(type, "-color-active")] = colorPalettes[6];
        variables["".concat(type, "-color-outline")] = baseColor.clone().setAlpha(0.2).toRgbString();
        variables["".concat(type, "-color-deprecated-bg")] = colorPalettes[0];
        variables["".concat(type, "-color-deprecated-border")] = colorPalettes[2];
    };
    // ================ Primary Color ================
    if (theme.primaryColor) {
        fillColor(theme.primaryColor, 'primary');
        var primaryColor = new (0, $9613825d06e6c531$export$d850312fc213f33e)(theme.primaryColor);
        var primaryColors = (0, $f98afff48ee41fa5$export$80d376111cc09ad7)(primaryColor.toRgbString());
        // Legacy - We should use semantic naming standard
        primaryColors.forEach(function(color, index) {
            variables["primary-".concat(index + 1)] = color;
        });
        // Deprecated
        variables['primary-color-deprecated-l-35'] = formatColor(primaryColor, function(c) {
            return c.lighten(35);
        });
        variables['primary-color-deprecated-l-20'] = formatColor(primaryColor, function(c) {
            return c.lighten(20);
        });
        variables['primary-color-deprecated-t-20'] = formatColor(primaryColor, function(c) {
            return c.tint(20);
        });
        variables['primary-color-deprecated-t-50'] = formatColor(primaryColor, function(c) {
            return c.tint(50);
        });
        variables['primary-color-deprecated-f-12'] = formatColor(primaryColor, function(c) {
            return c.setAlpha(c.getAlpha() * 0.12);
        });
        var primaryActiveColor = new (0, $9613825d06e6c531$export$d850312fc213f33e)(primaryColors[0]);
        variables['primary-color-active-deprecated-f-30'] = formatColor(primaryActiveColor, function(c) {
            return c.setAlpha(c.getAlpha() * 0.3);
        });
        variables['primary-color-active-deprecated-d-02'] = formatColor(primaryActiveColor, function(c) {
            return c.darken(2);
        });
    }
    // ================ Success Color ================
    if (theme.successColor) fillColor(theme.successColor, 'success');
    // ================ Warning Color ================
    if (theme.warningColor) fillColor(theme.warningColor, 'warning');
    // ================= Error Color =================
    if (theme.errorColor) fillColor(theme.errorColor, 'error');
    // ================= Info Color ==================
    if (theme.infoColor) fillColor(theme.infoColor, 'info');
    // Convert to css variables
    var cssList = Object.keys(variables).map(function(key) {
        return "--".concat(globalPrefixCls, "-").concat(key, ": ").concat(variables[key], ";");
    });
    return "\n  :root {\n    ".concat(cssList.join('\n'), "\n  }\n  ").trim();
}
function $9b95e2e32a1fe45a$export$f9c59eed5de5ff80(globalPrefixCls, theme) {
    var style = $9b95e2e32a1fe45a$export$3d2f074408bd1b82(globalPrefixCls, theme);
    if ((0, $aSXdS.default)()) (0, $be1cee03a7a68105$export$4d99a2890bb989f0)(style, "".concat($9b95e2e32a1fe45a$var$dynamicStyleMark, "-dynamic-theme"));
}



var $6fFrj = parcelRequire("6fFrj");
var $3880af76d17f94a3$var$DisabledContext = /*#__PURE__*/ $6fFrj.createContext(false);
var $3880af76d17f94a3$export$6adb5f3b918b11bb = function DisabledContextProvider(_ref) {
    var children = _ref.children, disabled = _ref.disabled;
    var originDisabled = $6fFrj.useContext($3880af76d17f94a3$var$DisabledContext);
    return /*#__PURE__*/ $6fFrj.createElement($3880af76d17f94a3$var$DisabledContext.Provider, {
        value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
    }, children);
};
var $3880af76d17f94a3$export$2e2bcd8739ae039 = $3880af76d17f94a3$var$DisabledContext;



var $6fFrj = parcelRequire("6fFrj");
var $aefad26b74860b7e$var$SizeContext = /*#__PURE__*/ $6fFrj.createContext(undefined);
var $aefad26b74860b7e$export$dbc92d89fabc8ebe = function SizeContextProvider(_ref) {
    var children = _ref.children, size = _ref.size;
    return /*#__PURE__*/ $6fFrj.createElement($aefad26b74860b7e$var$SizeContext.Consumer, null, function(originSize) {
        return /*#__PURE__*/ $6fFrj.createElement($aefad26b74860b7e$var$SizeContext.Provider, {
            value: size || originSize
        }, children);
    });
};
var $aefad26b74860b7e$export$2e2bcd8739ae039 = $aefad26b74860b7e$var$SizeContext;


var $f681578438e08b9b$export$e7f14a745e5c386a = [
    'getTargetContainer',
    'getPopupContainer',
    'rootPrefixCls',
    'getPrefixCls',
    'renderEmpty',
    'csp',
    'autoInsertSpaceInButton',
    'locale',
    'pageHeader'
];
// These props is used by `useContext` directly in sub component
var $f681578438e08b9b$var$PASSED_PROPS = [
    'getTargetContainer',
    'getPopupContainer',
    'renderEmpty',
    'pageHeader',
    'input',
    'pagination',
    'form'
];
var $f681578438e08b9b$export$e4ec87ea71f29b41 = 'ant';
var $f681578438e08b9b$export$eaca8ee5ed21b4e9 = 'anticon';
var $f681578438e08b9b$var$globalPrefixCls;
var $f681578438e08b9b$var$globalIconPrefixCls;
function $f681578438e08b9b$var$getGlobalPrefixCls() {
    return $f681578438e08b9b$var$globalPrefixCls || $f681578438e08b9b$export$e4ec87ea71f29b41;
}
function $f681578438e08b9b$var$getGlobalIconPrefixCls() {
    return $f681578438e08b9b$var$globalIconPrefixCls || $f681578438e08b9b$export$eaca8ee5ed21b4e9;
}
var $f681578438e08b9b$var$setGlobalConfig = function setGlobalConfig(_ref) {
    var prefixCls = _ref.prefixCls, iconPrefixCls = _ref.iconPrefixCls, theme = _ref.theme;
    if (prefixCls !== undefined) $f681578438e08b9b$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $f681578438e08b9b$var$globalIconPrefixCls = iconPrefixCls;
    if (theme) (0, $9b95e2e32a1fe45a$export$f9c59eed5de5ff80)($f681578438e08b9b$var$getGlobalPrefixCls(), theme);
};
var $f681578438e08b9b$export$f9cd1e43211d8a4a = function globalConfig() {
    return {
        getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? "".concat($f681578438e08b9b$var$getGlobalPrefixCls(), "-").concat(suffixCls) : $f681578438e08b9b$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $f681578438e08b9b$var$getGlobalIconPrefixCls,
        getRootPrefixCls: function getRootPrefixCls(rootPrefixCls, customizePrefixCls) {
            // Customize rootPrefixCls is first priority
            if (rootPrefixCls) return rootPrefixCls;
            // If Global prefixCls provided, use this
            if ($f681578438e08b9b$var$globalPrefixCls) return $f681578438e08b9b$var$globalPrefixCls;
            // [Legacy] If customize prefixCls provided, we cut it to get the prefixCls
            if (customizePrefixCls && customizePrefixCls.includes('-')) return customizePrefixCls.replace(/^(.*)-[^-]*$/, '$1');
            // Fallback to default prefixCls
            return $f681578438e08b9b$var$getGlobalPrefixCls();
        }
    };
};
var $f681578438e08b9b$var$ProviderChildren = function ProviderChildren(props) {
    var children = props.children, csp = props.csp, autoInsertSpaceInButton = props.autoInsertSpaceInButton, form = props.form, locale = props.locale, componentSize = props.componentSize, direction = props.direction, space = props.space, virtual = props.virtual, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, legacyLocale = props.legacyLocale, parentContext = props.parentContext, iconPrefixCls = props.iconPrefixCls, componentDisabled = props.componentDisabled;
    var getPrefixCls = $6fFrj.useCallback(function(suffixCls, customizePrefixCls) {
        var prefixCls = props.prefixCls;
        if (customizePrefixCls) return customizePrefixCls;
        var mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
        return suffixCls ? "".concat(mergedPrefixCls, "-").concat(suffixCls) : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    var config = (0, $fIrcP.default)((0, $fIrcP.default)({}, parentContext), {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        virtual: virtual,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        getPrefixCls: getPrefixCls
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $f681578438e08b9b$var$PASSED_PROPS.forEach(function(propName) {
        var propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    // https://github.com/ant-design/ant-design/issues/27617
    var memoedConfig = (0, $a5lfY.default)(function() {
        return config;
    }, config, function(prevConfig, currentConfig) {
        var prevKeys = Object.keys(prevConfig);
        var currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some(function(key) {
            return prevConfig[key] !== currentConfig[key];
        });
    });
    var memoIconContextValue = $6fFrj.useMemo(function() {
        return {
            prefixCls: iconPrefixCls,
            csp: csp
        };
    }, [
        iconPrefixCls,
        csp
    ]);
    var childNode = children;
    var validateMessages = $6fFrj.useMemo(function() {
        var _a, _b, _c, _d;
        return (0, $i5KV1.merge)(((_a = (0, $da4c09bd655d3c55$export$2e2bcd8739ae039).Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
    }, [
        memoedConfig,
        form === null || form === void 0 ? void 0 : form.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $6fFrj.createElement((0, $5022a8205bf86c7a$export$2e2bcd8739ae039).Provider, {
        value: validateMessages
    }, children);
    if (locale) childNode = /*#__PURE__*/ $6fFrj.createElement((0, $249043b809ee0f76$export$2e2bcd8739ae039), {
        locale: locale,
        _ANT_MARK__: (0, $249043b809ee0f76$export$b2f162cd5c15ea3e)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $6fFrj.createElement((0, $47a5c11e3aa73f6c$export$2e2bcd8739ae039).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $6fFrj.createElement((0, $aefad26b74860b7e$export$dbc92d89fabc8ebe), {
        size: componentSize
    }, childNode);
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $6fFrj.createElement((0, $3880af76d17f94a3$export$6adb5f3b918b11bb), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $6fFrj.createElement((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b).Provider, {
        value: memoedConfig
    }, childNode);
};
var $f681578438e08b9b$var$ConfigProvider = function ConfigProvider(props) {
    $6fFrj.useEffect(function() {
        if (props.direction) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).config({
                rtl: props.direction === 'rtl'
            });
            (0, $fb8edf64a7aededa$export$2e2bcd8739ae039).config({
                rtl: props.direction === 'rtl'
            });
        }
    }, [
        props.direction
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $d37c6ecde78f75e8$export$2e2bcd8739ae039), null, function(_, __, legacyLocale) {
        return /*#__PURE__*/ $6fFrj.createElement((0, $1bdb4c3de815e386$export$cd5442f2b8da7663), null, function(context) {
            return /*#__PURE__*/ $6fFrj.createElement($f681578438e08b9b$var$ProviderChildren, (0, $fIrcP.default)({
                parentContext: context,
                legacyLocale: legacyLocale
            }, props));
        });
    });
};
/** @private internal Usage. do not use in your production */ $f681578438e08b9b$var$ConfigProvider.ConfigContext = (0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b);
$f681578438e08b9b$var$ConfigProvider.SizeContext = (0, $aefad26b74860b7e$export$2e2bcd8739ae039);
$f681578438e08b9b$var$ConfigProvider.config = $f681578438e08b9b$var$setGlobalConfig;
var $f681578438e08b9b$export$2e2bcd8739ae039 = $f681578438e08b9b$var$ConfigProvider;


function $2341cdaa45fe261f$export$2e2bcd8739ae039(props) {
    return Object.keys(props).reduce(function(prev, key) {
        if ((key.startsWith('data-') || key.startsWith('aria-') || key === 'role') && !key.startsWith('data-__')) prev[key] = props[key];
        return prev;
    }, {});
}



var $6fFrj = parcelRequire("6fFrj");
var $79365009d9b77ac6$export$a8257692ac88316c = $6fFrj.isValidElement;
function $79365009d9b77ac6$export$9522e17588c12572(child) {
    return child && $79365009d9b77ac6$export$a8257692ac88316c(child) && child.type === $6fFrj.Fragment;
}
function $79365009d9b77ac6$export$2dfe578f95754f6a(element, replacement, props) {
    if (!$79365009d9b77ac6$export$a8257692ac88316c(element)) return replacement;
    return /*#__PURE__*/ $6fFrj.cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
}
function $79365009d9b77ac6$export$e530037191fcd5d7(element, props) {
    return $79365009d9b77ac6$export$2dfe578f95754f6a(element, element, props);
}



var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $82HU4 = parcelRequire("82HU4");

var $jbuPt = parcelRequire("jbuPt");

var $744q1 = parcelRequire("744q1");

var $bxC2Y = parcelRequire("bxC2Y");

var $6fFrj = parcelRequire("6fFrj");

function $724bd0dbb7a68c6c$var$_callSuper(t, o, e) {
    return o = (0, $744q1.default)(o), (0, $82HU4.default)(t, (0, $jbuPt.default)() ? Reflect.construct(o, e || [], (0, $744q1.default)(t).constructor) : o.apply(t, e));
}
var $724bd0dbb7a68c6c$var$ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        (0, $kjNeN.default)(this, ErrorBoundary);
        _this = $724bd0dbb7a68c6c$var$_callSuper(this, ErrorBoundary, arguments);
        _this.state = {
            error: undefined,
            info: {
                componentStack: ''
            }
        };
        return _this;
    }
    (0, $5KQxu.default)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, info) {
                this.setState({
                    error: error,
                    info: info
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, message = _this$props.message, description = _this$props.description, children = _this$props.children;
                var _this$state = this.state, error = _this$state.error, info = _this$state.info;
                var componentStack = info && info.componentStack ? info.componentStack : null;
                var errorMessage = typeof message === 'undefined' ? (error || '').toString() : message;
                var errorDescription = typeof description === 'undefined' ? componentStack : description;
                if (error) return /*#__PURE__*/ $6fFrj.createElement((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                    type: "error",
                    message: errorMessage,
                    description: /*#__PURE__*/ $6fFrj.createElement("pre", null, errorDescription)
                });
                return children;
            }
        }
    ]);
    return ErrorBoundary;
}($6fFrj.Component);
var $724bd0dbb7a68c6c$export$2e2bcd8739ae039 = $724bd0dbb7a68c6c$var$ErrorBoundary;


var $a2607640c59659c0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a2607640c59659c0$var$iconMapFilled = {
    success: (0, $a539793a765f8968$export$2e2bcd8739ae039),
    info: (0, $07ece45f4cb05aa5$export$2e2bcd8739ae039),
    error: (0, $9429a61ddf5bc264$export$2e2bcd8739ae039),
    warning: (0, $4b49a895caf27162$export$2e2bcd8739ae039)
};
var $a2607640c59659c0$var$iconMapOutlined = {
    success: (0, $996a31538a9d5bb4$export$2e2bcd8739ae039),
    info: (0, $60bea5c3f0793107$export$2e2bcd8739ae039),
    error: (0, $83dc1c57eab38fbc$export$2e2bcd8739ae039),
    warning: (0, $5a26a3af64ff8e01$export$2e2bcd8739ae039)
};
var $a2607640c59659c0$var$IconNode = function IconNode(props) {
    var description = props.description, icon = props.icon, prefixCls = props.prefixCls, type = props.type;
    var iconType = (description ? $a2607640c59659c0$var$iconMapOutlined : $a2607640c59659c0$var$iconMapFilled)[type] || null;
    if (icon) return (0, $79365009d9b77ac6$export$2dfe578f95754f6a)(icon, /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-icon")
    }, icon), function() {
        return {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-icon"), (0, $43449.default)({}, icon.props.className, icon.props.className))
        };
    });
    return /*#__PURE__*/ $6fFrj.createElement(iconType, {
        className: "".concat(prefixCls, "-icon")
    });
};
var $a2607640c59659c0$var$CloseIcon = function CloseIcon(props) {
    var isClosable = props.isClosable, closeText = props.closeText, prefixCls = props.prefixCls, closeIcon = props.closeIcon, handleClose = props.handleClose;
    return isClosable ? /*#__PURE__*/ $6fFrj.createElement("button", {
        type: "button",
        onClick: handleClose,
        className: "".concat(prefixCls, "-close-icon"),
        tabIndex: 0
    }, closeText ? /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-close-text")
    }, closeText) : closeIcon) : null;
};
var $a2607640c59659c0$var$Alert = function Alert(_a) {
    var description = _a.description, customizePrefixCls = _a.prefixCls, message = _a.message, banner = _a.banner, _a$className = _a.className, className = _a$className === void 0 ? '' : _a$className, style = _a.style, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onClick = _a.onClick, afterClose = _a.afterClose, showIcon = _a.showIcon, closable = _a.closable, closeText = _a.closeText, _a$closeIcon = _a.closeIcon, closeIcon = _a$closeIcon === void 0 ? /*#__PURE__*/ $6fFrj.createElement((0, $4cb3f1f073816266$export$2e2bcd8739ae039), null) : _a$closeIcon, action = _a.action, props = $a2607640c59659c0$var$__rest(_a, [
        "description",
        "prefixCls",
        "message",
        "banner",
        "className",
        "style",
        "onMouseEnter",
        "onMouseLeave",
        "onClick",
        "afterClose",
        "showIcon",
        "closable",
        "closeText",
        "closeIcon",
        "action"
    ]);
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), closed = _React$useState2[0], setClosed = _React$useState2[1];
    var ref = $6fFrj.useRef();
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var prefixCls = getPrefixCls('alert', customizePrefixCls);
    var handleClose = function handleClose(e) {
        var _a;
        setClosed(true);
        (_a = props.onClose) === null || _a === void 0 || _a.call(props, e);
    };
    var getType = function getType() {
        var type = props.type;
        if (type !== undefined) return type;
        // banner 模式默认为警告
        return banner ? 'warning' : 'info';
    };
    // closeable when closeText is assigned
    var isClosable = closeText ? true : closable;
    var type = getType();
    // banner 模式默认有 Icon
    var isShowIcon = banner && showIcon === undefined ? true : showIcon;
    var alertCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-").concat(type), (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-with-description"), !!description), "".concat(prefixCls, "-no-icon"), !isShowIcon), "".concat(prefixCls, "-banner"), !!banner), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    var dataOrAriaProps = (0, $2341cdaa45fe261f$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), {
        visible: !closed,
        motionName: "".concat(prefixCls, "-motion"),
        motionAppear: false,
        motionEnter: false,
        onLeaveStart: function onLeaveStart(node) {
            return {
                maxHeight: node.offsetHeight
            };
        },
        onLeaveEnd: afterClose
    }, function(_ref) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
            ref: ref,
            "data-show": !closed,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(alertCls, motionClassName),
            style: (0, $fIrcP.default)((0, $fIrcP.default)({}, style), motionStyle),
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            role: "alert"
        }, dataOrAriaProps), isShowIcon ? /*#__PURE__*/ $6fFrj.createElement($a2607640c59659c0$var$IconNode, {
            description: description,
            icon: props.icon,
            prefixCls: prefixCls,
            type: type
        }) : null, /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-content")
        }, message ? /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-message")
        }, message) : null, description ? /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-description")
        }, description) : null), action ? /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-action")
        }, action) : null, /*#__PURE__*/ $6fFrj.createElement($a2607640c59659c0$var$CloseIcon, {
            isClosable: !!isClosable,
            closeText: closeText,
            prefixCls: prefixCls,
            closeIcon: closeIcon,
            handleClose: handleClose
        }));
    });
};
$a2607640c59659c0$var$Alert.ErrorBoundary = (0, $724bd0dbb7a68c6c$export$2e2bcd8739ae039);
var $a2607640c59659c0$export$2e2bcd8739ae039 = $a2607640c59659c0$var$Alert;


var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $5KhTJ = parcelRequire("5KhTJ");

var $jP8CL = parcelRequire("jP8CL");

var $fActo = parcelRequire("fActo");

var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

var $eywMK = parcelRequire("eywMK");

var $6fFrj = parcelRequire("6fFrj");
function $a41a9a7924b187f8$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($a41a9a7924b187f8$export$2e2bcd8739ae039(child));
        else if ((0, $eywMK.default)(child) && child.props) ret = ret.concat($a41a9a7924b187f8$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}


parcelRequire("3mXQ2");

var $kNxFX = parcelRequire("kNxFX");

var $5KhTJ = parcelRequire("5KhTJ");

var $k5B64 = parcelRequire("k5B64");

var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");
var $3672906e2a91631d$export$db36075d98ba73d3 = /*#__PURE__*/ $6fFrj.createContext(null);
function $3672906e2a91631d$export$fb8073518f34e6ec(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = $6fFrj.useRef(0);
    var resizeInfosRef = $6fFrj.useRef([]);
    var onCollectionResize = $6fFrj.useContext($3672906e2a91631d$export$db36075d98ba73d3);
    var onResize = $6fFrj.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $6fFrj.createElement($3672906e2a91631d$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}


/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $b6545e955638aae9$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $b6545e955638aae9$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $b6545e955638aae9$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $b6545e955638aae9$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($b6545e955638aae9$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $b6545e955638aae9$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $b6545e955638aae9$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $b6545e955638aae9$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $b6545e955638aae9$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $b6545e955638aae9$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $b6545e955638aae9$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $b6545e955638aae9$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $b6545e955638aae9$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $b6545e955638aae9$var$throttle(this.refresh.bind(this), $b6545e955638aae9$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$b6545e955638aae9$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($b6545e955638aae9$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$b6545e955638aae9$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $b6545e955638aae9$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $b6545e955638aae9$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $b6545e955638aae9$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $b6545e955638aae9$var$global$1;
};
// Placeholder of an empty content rectangle.
var $b6545e955638aae9$var$emptyRect = $b6545e955638aae9$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $b6545e955638aae9$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $b6545e955638aae9$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $b6545e955638aae9$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $b6545e955638aae9$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $b6545e955638aae9$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $b6545e955638aae9$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $b6545e955638aae9$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $b6545e955638aae9$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $b6545e955638aae9$var$emptyRect;
    var styles = $b6545e955638aae9$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $b6545e955638aae9$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $b6545e955638aae9$var$toFloat(styles.width), height = $b6545e955638aae9$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $b6545e955638aae9$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $b6545e955638aae9$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$b6545e955638aae9$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $b6545e955638aae9$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $b6545e955638aae9$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $b6545e955638aae9$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $b6545e955638aae9$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $b6545e955638aae9$var$isDocumentElement(target) {
    return target === $b6545e955638aae9$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $b6545e955638aae9$var$getContentRect(target) {
    if (!$b6545e955638aae9$var$isBrowser) return $b6545e955638aae9$var$emptyRect;
    if ($b6545e955638aae9$var$isSVGGraphicsElement(target)) return $b6545e955638aae9$var$getSVGContentRect(target);
    return $b6545e955638aae9$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $b6545e955638aae9$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $b6545e955638aae9$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $b6545e955638aae9$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $b6545e955638aae9$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $b6545e955638aae9$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $b6545e955638aae9$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $b6545e955638aae9$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $b6545e955638aae9$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $b6545e955638aae9$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $b6545e955638aae9$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $b6545e955638aae9$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $b6545e955638aae9$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $b6545e955638aae9$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $b6545e955638aae9$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $b6545e955638aae9$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $b6545e955638aae9$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $b6545e955638aae9$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $b6545e955638aae9$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $b6545e955638aae9$var$ResizeObserverController.getInstance();
        var observer = new $b6545e955638aae9$var$ResizeObserverSPI(callback, controller, this);
        $b6545e955638aae9$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $b6545e955638aae9$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $b6545e955638aae9$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $b6545e955638aae9$var$index = function() {
    // Export existing implementation if available.
    if (typeof $b6545e955638aae9$var$global$1.ResizeObserver !== 'undefined') return $b6545e955638aae9$var$global$1.ResizeObserver;
    return $b6545e955638aae9$var$ResizeObserver;
}();
var $b6545e955638aae9$export$2e2bcd8739ae039 = $b6545e955638aae9$var$index;


// =============================== Const ===============================
var $b3cc95eef215c593$var$elementListeners = new Map();
function $b3cc95eef215c593$var$onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = $b3cc95eef215c593$var$elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var $b3cc95eef215c593$var$resizeObserver = new (0, $b6545e955638aae9$export$2e2bcd8739ae039)($b3cc95eef215c593$var$onResize);
var $b3cc95eef215c593$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
var $b3cc95eef215c593$export$524f0fd3b47831a = null; // eslint-disable-line
function $b3cc95eef215c593$export$d1203567a167490e(element, callback) {
    if (!$b3cc95eef215c593$var$elementListeners.has(element)) {
        $b3cc95eef215c593$var$elementListeners.set(element, new Set());
        $b3cc95eef215c593$var$resizeObserver.observe(element);
    }
    $b3cc95eef215c593$var$elementListeners.get(element).add(callback);
}
function $b3cc95eef215c593$export$23a2283368c55ea2(element, callback) {
    if ($b3cc95eef215c593$var$elementListeners.has(element)) {
        $b3cc95eef215c593$var$elementListeners.get(element).delete(callback);
        if (!$b3cc95eef215c593$var$elementListeners.get(element).size) {
            $b3cc95eef215c593$var$resizeObserver.unobserve(element);
            $b3cc95eef215c593$var$elementListeners.delete(element);
        }
    }
}



var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $6fFrj = parcelRequire("6fFrj");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var $e0481796ab0c373f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(DomWrapper, _React$Component);
    var _super = (0, $lSufv.default)(DomWrapper);
    function DomWrapper() {
        (0, $kjNeN.default)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $5KQxu.default)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($6fFrj.Component);


function $25fa20692b6366ff$var$SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = $6fFrj.useRef(null);
    var wrapperRef = $6fFrj.useRef(null);
    var onCollectionResize = $6fFrj.useContext((0, $3672906e2a91631d$export$db36075d98ba73d3));
    // =========================== Children ===========================
    var isRenderProps = typeof children === 'function';
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = $6fFrj.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ $6fFrj.isValidElement(mergedChildren) && (0, $3BOWT.supportRef)(mergedChildren);
    var originRef = canRef ? (0, $3BOWT.getNodeRef)(mergedChildren) : null;
    var mergedRef = (0, $3BOWT.useComposeRef)(originRef, elementRef);
    var getDom = function getDom() {
        var _elementRef$current;
        return (0, $k5B64.default)(elementRef.current) || // Support `nativeElement` format
        (elementRef.current && (0, $5KhTJ.default)(elementRef.current) === 'object' ? (0, $k5B64.default)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0, $k5B64.default)(wrapperRef.current);
    };
    $6fFrj.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = $6fFrj.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = $6fFrj.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, $kNxFX.default)((0, $kNxFX.default)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $6fFrj.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, $b3cc95eef215c593$export$d1203567a167490e)(currentElement, onInternalResize);
        return function() {
            return (0, $b3cc95eef215c593$export$23a2283368c55ea2)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $6fFrj.createElement((0, $e0481796ab0c373f$export$2e2bcd8739ae039), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ $6fFrj.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var $25fa20692b6366ff$var$RefSingleObserver = /*#__PURE__*/ $6fFrj.forwardRef($25fa20692b6366ff$var$SingleObserver);
var $25fa20692b6366ff$export$2e2bcd8739ae039 = $25fa20692b6366ff$var$RefSingleObserver;




var $8e6bb008621f90f5$var$INTERNAL_PREFIX_KEY = 'rc-observer-key';
function $8e6bb008621f90f5$var$ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === 'function' ? [
        children
    ] : (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(children);
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat($8e6bb008621f90f5$var$INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ $6fFrj.createElement((0, $25fa20692b6366ff$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var $8e6bb008621f90f5$var$RefResizeObserver = /*#__PURE__*/ $6fFrj.forwardRef($8e6bb008621f90f5$var$ResizeObserver);
$8e6bb008621f90f5$var$RefResizeObserver.Collection = (0, $3672906e2a91631d$export$fb8073518f34e6ec);
var $8e6bb008621f90f5$export$2e2bcd8739ae039 = $8e6bb008621f90f5$var$RefResizeObserver;



var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
function $930b14fa9874af4b$export$2e2bcd8739ae039() {
    var _React$useReducer = $6fFrj.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $jP8CL.default)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    return forceUpdate;
}



var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");
var $ba9d944a99636e67$export$74c1bf8296b1541f = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
var $ba9d944a99636e67$export$7d16f0c74495c67 = {
    xs: '(max-width: 575px)',
    sm: '(min-width: 576px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 992px)',
    xl: '(min-width: 1200px)',
    xxl: '(min-width: 1600px)'
};
var $ba9d944a99636e67$var$subscribers = new Map();
var $ba9d944a99636e67$var$subUid = -1;
var $ba9d944a99636e67$var$screens = {};
var $ba9d944a99636e67$var$responsiveObserve = {
    matchHandlers: {},
    dispatch: function dispatch(pointMap) {
        $ba9d944a99636e67$var$screens = pointMap;
        $ba9d944a99636e67$var$subscribers.forEach(function(func) {
            return func($ba9d944a99636e67$var$screens);
        });
        return $ba9d944a99636e67$var$subscribers.size >= 1;
    },
    subscribe: function subscribe(func) {
        if (!$ba9d944a99636e67$var$subscribers.size) this.register();
        $ba9d944a99636e67$var$subUid += 1;
        $ba9d944a99636e67$var$subscribers.set($ba9d944a99636e67$var$subUid, func);
        func($ba9d944a99636e67$var$screens);
        return $ba9d944a99636e67$var$subUid;
    },
    unsubscribe: function unsubscribe(token) {
        $ba9d944a99636e67$var$subscribers["delete"](token);
        if (!$ba9d944a99636e67$var$subscribers.size) this.unregister();
    },
    unregister: function unregister() {
        var _this = this;
        Object.keys($ba9d944a99636e67$export$7d16f0c74495c67).forEach(function(screen) {
            var matchMediaQuery = $ba9d944a99636e67$export$7d16f0c74495c67[screen];
            var handler = _this.matchHandlers[matchMediaQuery];
            handler === null || handler === void 0 || handler.mql.removeListener(handler === null || handler === void 0 ? void 0 : handler.listener);
        });
        $ba9d944a99636e67$var$subscribers.clear();
    },
    register: function register() {
        var _this2 = this;
        Object.keys($ba9d944a99636e67$export$7d16f0c74495c67).forEach(function(screen) {
            var matchMediaQuery = $ba9d944a99636e67$export$7d16f0c74495c67[screen];
            var listener = function listener(_ref) {
                var matches = _ref.matches;
                _this2.dispatch((0, $fIrcP.default)((0, $fIrcP.default)({}, $ba9d944a99636e67$var$screens), (0, $43449.default)({}, screen, matches)));
            };
            var mql = window.matchMedia(matchMediaQuery);
            mql.addListener(listener);
            _this2.matchHandlers[matchMediaQuery] = {
                mql: mql,
                listener: listener
            };
            listener(mql);
        });
    }
};
var $ba9d944a99636e67$export$2e2bcd8739ae039 = $ba9d944a99636e67$var$responsiveObserve;


function $60fdd98823a1708b$var$useBreakpoint() {
    var refreshOnChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var screensRef = (0, $6fFrj.useRef)({});
    var forceUpdate = (0, $930b14fa9874af4b$export$2e2bcd8739ae039)();
    (0, $6fFrj.useEffect)(function() {
        var token = (0, $ba9d944a99636e67$export$2e2bcd8739ae039).subscribe(function(supportScreens) {
            screensRef.current = supportScreens;
            if (refreshOnChange) forceUpdate();
        });
        return function() {
            return (0, $ba9d944a99636e67$export$2e2bcd8739ae039).unsubscribe(token);
        };
    }, []);
    return screensRef.current;
}
var $60fdd98823a1708b$export$2e2bcd8739ae039 = $60fdd98823a1708b$var$useBreakpoint;





var $6fFrj = parcelRequire("6fFrj");
var $8be80b6dadc13335$var$SizeContext = /*#__PURE__*/ $6fFrj.createContext('default');
var $8be80b6dadc13335$export$dbc92d89fabc8ebe = function SizeContextProvider(_ref) {
    var children = _ref.children, size = _ref.size;
    return /*#__PURE__*/ $6fFrj.createElement($8be80b6dadc13335$var$SizeContext.Consumer, null, function(originSize) {
        return /*#__PURE__*/ $6fFrj.createElement($8be80b6dadc13335$var$SizeContext.Provider, {
            value: size || originSize
        }, children);
    });
};
var $8be80b6dadc13335$export$2e2bcd8739ae039 = $8be80b6dadc13335$var$SizeContext;


var $422f183daa56b489$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $422f183daa56b489$var$InternalAvatar = function InternalAvatar(props, ref) {
    var groupSize = $6fFrj.useContext((0, $8be80b6dadc13335$export$2e2bcd8739ae039));
    var _React$useState = $6fFrj.useState(1), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), scale = _React$useState2[0], setScale = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState(false), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), mounted = _React$useState4[0], setMounted = _React$useState4[1];
    var _React$useState5 = $6fFrj.useState(true), _React$useState6 = (0, $jP8CL.default)(_React$useState5, 2), isImgExist = _React$useState6[0], setIsImgExist = _React$useState6[1];
    var avatarNodeRef = $6fFrj.useRef(null);
    var avatarChildrenRef = $6fFrj.useRef(null);
    var avatarNodeMergeRef = (0, $3BOWT.composeRef)(ref, avatarNodeRef);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var setScaleParam = function setScaleParam() {
        if (!avatarChildrenRef.current || !avatarNodeRef.current) return;
        var childrenWidth = avatarChildrenRef.current.offsetWidth; // offsetWidth avoid affecting be transform scale
        var nodeWidth = avatarNodeRef.current.offsetWidth;
        // denominator is 0 is no meaning
        if (childrenWidth !== 0 && nodeWidth !== 0) {
            var _props$gap = props.gap, gap = _props$gap === void 0 ? 4 : _props$gap;
            if (gap * 2 < nodeWidth) setScale(nodeWidth - gap * 2 < childrenWidth ? (nodeWidth - gap * 2) / childrenWidth : 1);
        }
    };
    $6fFrj.useEffect(function() {
        setMounted(true);
    }, []);
    $6fFrj.useEffect(function() {
        setIsImgExist(true);
        setScale(1);
    }, [
        props.src
    ]);
    $6fFrj.useEffect(function() {
        setScaleParam();
    }, [
        props.gap
    ]);
    var handleImgLoadError = function handleImgLoadError() {
        var onError = props.onError;
        var errorFlag = onError ? onError() : undefined;
        if (errorFlag !== false) setIsImgExist(false);
    };
    var customizePrefixCls = props.prefixCls, _props$shape = props.shape, shape = _props$shape === void 0 ? 'circle' : _props$shape, _props$size = props.size, customSize = _props$size === void 0 ? 'default' : _props$size, src = props.src, srcSet = props.srcSet, icon = props.icon, className = props.className, alt = props.alt, draggable = props.draggable, children = props.children, crossOrigin = props.crossOrigin, others = $422f183daa56b489$var$__rest(props, [
        "prefixCls",
        "shape",
        "size",
        "src",
        "srcSet",
        "icon",
        "className",
        "alt",
        "draggable",
        "children",
        "crossOrigin"
    ]);
    var size = customSize === 'default' ? groupSize : customSize;
    var needResponsive = Object.keys((0, $5KhTJ.default)(size) === 'object' ? size || {} : {}).some(function(key) {
        return [
            'xs',
            'sm',
            'md',
            'lg',
            'xl',
            'xxl'
        ].includes(key);
    });
    var screens = (0, $60fdd98823a1708b$export$2e2bcd8739ae039)(needResponsive);
    var responsiveSizeStyle = $6fFrj.useMemo(function() {
        if ((0, $5KhTJ.default)(size) !== 'object') return {};
        var currentBreakpoint = (0, $ba9d944a99636e67$export$74c1bf8296b1541f).find(function(screen) {
            return screens[screen];
        });
        var currentSize = size[currentBreakpoint];
        return currentSize ? {
            width: currentSize,
            height: currentSize,
            lineHeight: "".concat(currentSize, "px"),
            fontSize: icon ? currentSize / 2 : 18
        } : {};
    }, [
        screens,
        size
    ]);
    var prefixCls = getPrefixCls('avatar', customizePrefixCls);
    var sizeCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-lg"), size === 'large'), "".concat(prefixCls, "-sm"), size === 'small'));
    var hasImageElement = /*#__PURE__*/ $6fFrj.isValidElement(src);
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, sizeCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-").concat(shape), !!shape), "".concat(prefixCls, "-image"), hasImageElement || src && isImgExist), "".concat(prefixCls, "-icon"), !!icon), className);
    var sizeStyle = typeof size === 'number' ? {
        width: size,
        height: size,
        lineHeight: "".concat(size, "px"),
        fontSize: icon ? size / 2 : 18
    } : {};
    var childrenToRender;
    if (typeof src === 'string' && isImgExist) childrenToRender = /*#__PURE__*/ $6fFrj.createElement("img", {
        src: src,
        draggable: draggable,
        srcSet: srcSet,
        onError: handleImgLoadError,
        alt: alt,
        crossOrigin: crossOrigin
    });
    else if (hasImageElement) childrenToRender = src;
    else if (icon) childrenToRender = icon;
    else if (mounted || scale !== 1) {
        var transformString = "scale(".concat(scale, ") translateX(-50%)");
        var childrenStyle = {
            msTransform: transformString,
            WebkitTransform: transformString,
            transform: transformString
        };
        var sizeChildrenStyle = typeof size === 'number' ? {
            lineHeight: "".concat(size, "px")
        } : {};
        childrenToRender = /*#__PURE__*/ $6fFrj.createElement((0, $8e6bb008621f90f5$export$2e2bcd8739ae039), {
            onResize: setScaleParam
        }, /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-string"),
            ref: avatarChildrenRef,
            style: (0, $fIrcP.default)((0, $fIrcP.default)({}, sizeChildrenStyle), childrenStyle)
        }, children));
    } else childrenToRender = /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-string"),
        style: {
            opacity: 0
        },
        ref: avatarChildrenRef
    }, children);
    // The event is triggered twice from bubbling up the DOM tree.
    // see https://codesandbox.io/s/kind-snow-9lidz
    delete others.onError;
    delete others.gap;
    return /*#__PURE__*/ $6fFrj.createElement("span", (0, $fIrcP.default)({}, others, {
        style: (0, $fIrcP.default)((0, $fIrcP.default)((0, $fIrcP.default)({}, sizeStyle), responsiveSizeStyle), others.style),
        className: classString,
        ref: avatarNodeMergeRef
    }), childrenToRender);
};
var $422f183daa56b489$var$Avatar = /*#__PURE__*/ $6fFrj.forwardRef($422f183daa56b489$var$InternalAvatar);
var $422f183daa56b489$export$2e2bcd8739ae039 = $422f183daa56b489$var$Avatar;



var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");


var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");
var $fc871912853a3dce$export$15e5fca53711d340 = function getRenderPropValue(propValue) {
    if (!propValue) return null;
    if (typeof propValue === 'function') return propValue();
    return propValue;
};


// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
var $cacd97b96801cebe$export$65e3907585753458 = function tuple() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return args;
};
var $cacd97b96801cebe$export$1ada10640a0e4dad = function tupleNum() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    return args;
};


// ================== Collapse Motion ==================
var $779588b2444df86c$var$getCollapsedHeight = function getCollapsedHeight() {
    return {
        height: 0,
        opacity: 0
    };
};
var $779588b2444df86c$var$getRealHeight = function getRealHeight(node) {
    var scrollHeight = node.scrollHeight;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
var $779588b2444df86c$var$getCurrentHeight = function getCurrentHeight(node) {
    return {
        height: node ? node.offsetHeight : 0
    };
};
var $779588b2444df86c$var$skipOpacityTransition = function skipOpacityTransition(_, event) {
    return (event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === 'height';
};
var $779588b2444df86c$var$collapseMotion = {
    motionName: 'ant-motion-collapse',
    onAppearStart: $779588b2444df86c$var$getCollapsedHeight,
    onEnterStart: $779588b2444df86c$var$getCollapsedHeight,
    onAppearActive: $779588b2444df86c$var$getRealHeight,
    onEnterActive: $779588b2444df86c$var$getRealHeight,
    onLeaveStart: $779588b2444df86c$var$getCurrentHeight,
    onLeaveActive: $779588b2444df86c$var$getCollapsedHeight,
    onAppearEnd: $779588b2444df86c$var$skipOpacityTransition,
    onEnterEnd: $779588b2444df86c$var$skipOpacityTransition,
    onLeaveEnd: $779588b2444df86c$var$skipOpacityTransition,
    motionDeadline: 500
};
var $779588b2444df86c$var$SelectPlacements = (0, $cacd97b96801cebe$export$65e3907585753458)('bottomLeft', 'bottomRight', 'topLeft', 'topRight');
var $779588b2444df86c$export$b2382d4a41c58fef = function getTransitionDirection(placement) {
    if (placement !== undefined && (placement === 'topLeft' || placement === 'topRight')) return "slide-down";
    return "slide-up";
};
var $779588b2444df86c$export$27c72201b1d09951 = function getTransitionName(rootPrefixCls, motion, transitionName) {
    if (transitionName !== undefined) return transitionName;
    return "".concat(rootPrefixCls, "-").concat(motion);
};
var $779588b2444df86c$export$2e2bcd8739ae039 = $779588b2444df86c$var$collapseMotion;




var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $fIrcP = parcelRequire("fIrcP");

var $fActo = parcelRequire("fActo");

var $fIrcP = parcelRequire("fIrcP");

var $5KhTJ = parcelRequire("5KhTJ");

var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $kNxFX = parcelRequire("kNxFX");

var $fIrcP = parcelRequire("fIrcP");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $3mZgl = parcelRequire("3mZgl");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");

var $8CZEB = parcelRequire("8CZEB");

var $hqic8 = parcelRequire("hqic8");


var $k5B64 = parcelRequire("k5B64");

var $3BOWT = parcelRequire("3BOWT");

var $8CZEB = parcelRequire("8CZEB");
function $5184338d6a99a234$export$2e2bcd8739ae039(target, eventType, cb, option) {
    /* eslint camelcase: 2 */ var callback = (0, (/*@__PURE__*/$parcel$interopDefault($8CZEB))).unstable_batchedUpdates ? function run(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($8CZEB))).unstable_batchedUpdates(cb, e);
    } : cb;
    if (target !== null && target !== void 0 && target.addEventListener) target.addEventListener(eventType, callback, option);
    return {
        remove: function remove() {
            if (target !== null && target !== void 0 && target.removeEventListener) target.removeEventListener(eventType, callback, option);
        }
    };
}



var $6fFrj = parcelRequire("6fFrj");

var $8CZEB = parcelRequire("8CZEB");

var $aSXdS = parcelRequire("aSXdS");
var $a87dbe925d56f62d$var$Portal = /*#__PURE__*/ (0, $6fFrj.forwardRef)(function(props, ref) {
    var didUpdate = props.didUpdate, getContainer = props.getContainer, children = props.children;
    var parentRef = (0, $6fFrj.useRef)();
    var containerRef = (0, $6fFrj.useRef)();
    // Ref return nothing, only for wrapper check exist
    (0, $6fFrj.useImperativeHandle)(ref, function() {
        return {};
    });
    // Create container in client side with sync to avoid useEffect not get ref
    var initRef = (0, $6fFrj.useRef)(false);
    if (!initRef.current && (0, $aSXdS.default)()) {
        containerRef.current = getContainer();
        parentRef.current = containerRef.current.parentNode;
        initRef.current = true;
    }
    // [Legacy] Used by `rc-trigger`
    (0, $6fFrj.useEffect)(function() {
        didUpdate === null || didUpdate === void 0 || didUpdate(props);
    });
    (0, $6fFrj.useEffect)(function() {
        // Restore container to original place
        // React 18 StrictMode will unmount first and mount back for effect test:
        // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
        if (containerRef.current.parentNode === null && parentRef.current !== null) parentRef.current.appendChild(containerRef.current);
        return function() {
            var _containerRef$current;
            // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
            // Since some component use `Portal` directly, we have to keep the logic here.
            (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current = _containerRef$current.parentNode) === null || _containerRef$current === void 0 || _containerRef$current.removeChild(containerRef.current);
        };
    }, []);
    return containerRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8CZEB))).createPortal(children, containerRef.current) : null;
});
var $a87dbe925d56f62d$export$2e2bcd8739ae039 = $a87dbe925d56f62d$var$Portal;



var $fActo = parcelRequire("fActo");

var $kNxFX = parcelRequire("kNxFX");
function $4d04d717f294539c$var$isPointsEq(a1, a2, isAlignPoint) {
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $4d04d717f294539c$export$44605b74f7c5d944(builtinPlacements, placementStr, align) {
    var baseAlign = builtinPlacements[placementStr] || {};
    return (0, $kNxFX.default)((0, $kNxFX.default)({}, baseAlign), align);
}
function $4d04d717f294539c$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var placement = placements[i];
        if ($4d04d717f294539c$var$isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return '';
}



var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");
var $fee6da8402dc892a$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};



var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $5EVeC = parcelRequire("5EVeC");
function $c01032bdb736b76a$export$7b8936ddc277a29a(_ref) {
    var prefixCls = _ref.prefixCls, motion = _ref.motion, animation = _ref.animation, transitionName = _ref.transitionName;
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}


function $00bef2784a16c0d4$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, mask = props.mask, maskMotion = props.maskMotion, maskAnimation = props.maskAnimation, maskTransitionName = props.maskTransitionName;
    if (!mask) return null;
    var motion = {};
    if (maskMotion || maskTransitionName || maskAnimation) motion = (0, $kNxFX.default)({
        motionAppear: true
    }, (0, $c01032bdb736b76a$export$7b8936ddc277a29a)({
        motion: maskMotion,
        prefixCls: prefixCls,
        transitionName: maskTransitionName,
        animation: maskAnimation
    }));
    return /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), (0, $fIrcP.default)({}, motion, {
        visible: visible,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $6fFrj.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-mask"), className)
        });
    });
}



var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
// export this package's api

var $jP8CL = parcelRequire("jP8CL");

var $5KhTJ = parcelRequire("5KhTJ");
function $d3ef512d6139f433$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d3ef512d6139f433$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d3ef512d6139f433$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d3ef512d6139f433$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d3ef512d6139f433$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d3ef512d6139f433$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d3ef512d6139f433$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d3ef512d6139f433$var$_typeof(obj);
}
function $d3ef512d6139f433$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d3ef512d6139f433$var$vendorPrefix;
var $d3ef512d6139f433$var$jsCssMap = {
    Webkit: '-webkit-',
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-'
};
function $d3ef512d6139f433$var$getVendorPrefix() {
    if ($d3ef512d6139f433$var$vendorPrefix !== undefined) return $d3ef512d6139f433$var$vendorPrefix;
    $d3ef512d6139f433$var$vendorPrefix = '';
    var style = document.createElement('p').style;
    var testProp = 'Transform';
    for(var key in $d3ef512d6139f433$var$jsCssMap)if (key + testProp in style) $d3ef512d6139f433$var$vendorPrefix = key;
    return $d3ef512d6139f433$var$vendorPrefix;
}
function $d3ef512d6139f433$var$getTransitionName() {
    return $d3ef512d6139f433$var$getVendorPrefix() ? "".concat($d3ef512d6139f433$var$getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}
function $d3ef512d6139f433$var$getTransformName() {
    return $d3ef512d6139f433$var$getVendorPrefix() ? "".concat($d3ef512d6139f433$var$getVendorPrefix(), "Transform") : 'transform';
}
function $d3ef512d6139f433$var$setTransitionProperty(node, value) {
    var name = $d3ef512d6139f433$var$getTransitionName();
    if (name) {
        node.style[name] = value;
        if (name !== 'transitionProperty') node.style.transitionProperty = value;
    }
}
function $d3ef512d6139f433$var$setTransform(node, value) {
    var name = $d3ef512d6139f433$var$getTransformName();
    if (name) {
        node.style[name] = value;
        if (name !== 'transform') node.style.transform = value;
    }
}
function $d3ef512d6139f433$var$getTransitionProperty(node) {
    return node.style.transitionProperty || node.style[$d3ef512d6139f433$var$getTransitionName()];
}
function $d3ef512d6139f433$var$getTransformXY(node) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue($d3ef512d6139f433$var$getTransformName());
    if (transform && transform !== 'none') {
        var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
        return {
            x: parseFloat(matrix[12] || matrix[4], 0),
            y: parseFloat(matrix[13] || matrix[5], 0)
        };
    }
    return {
        x: 0,
        y: 0
    };
}
var $d3ef512d6139f433$var$matrix2d = /matrix\((.*)\)/;
var $d3ef512d6139f433$var$matrix3d = /matrix3d\((.*)\)/;
function $d3ef512d6139f433$var$setTransformXY(node, xy) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue($d3ef512d6139f433$var$getTransformName());
    if (transform && transform !== 'none') {
        var arr;
        var match2d = transform.match($d3ef512d6139f433$var$matrix2d);
        if (match2d) {
            match2d = match2d[1];
            arr = match2d.split(',').map(function(item) {
                return parseFloat(item, 10);
            });
            arr[4] = xy.x;
            arr[5] = xy.y;
            $d3ef512d6139f433$var$setTransform(node, "matrix(".concat(arr.join(','), ")"));
        } else {
            var match3d = transform.match($d3ef512d6139f433$var$matrix3d)[1];
            arr = match3d.split(',').map(function(item) {
                return parseFloat(item, 10);
            });
            arr[12] = xy.x;
            arr[13] = xy.y;
            $d3ef512d6139f433$var$setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
        }
    } else $d3ef512d6139f433$var$setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
}
var $d3ef512d6139f433$var$RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var $d3ef512d6139f433$var$getComputedStyleX;
// https://stackoverflow.com/a/3485654/3040605
function $d3ef512d6139f433$var$forceRelayout(elem) {
    var originalStyle = elem.style.display;
    elem.style.display = 'none';
    elem.offsetHeight; // eslint-disable-line
    elem.style.display = originalStyle;
}
function $d3ef512d6139f433$var$css(el, name, v) {
    var value = v;
    if ($d3ef512d6139f433$var$_typeof(name) === 'object') {
        for(var i in name)if (name.hasOwnProperty(i)) $d3ef512d6139f433$var$css(el, i, name[i]);
        return undefined;
    }
    if (typeof value !== 'undefined') {
        if (typeof value === 'number') value = "".concat(value, "px");
        el.style[name] = value;
        return undefined;
    }
    return $d3ef512d6139f433$var$getComputedStyleX(el, name);
}
function $d3ef512d6139f433$var$getClientPosition(elem) {
    var box;
    var x;
    var y;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement;
    // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
    box = elem.getBoundingClientRect();
    // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
    // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
    // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
    x = Math.floor(box.left);
    y = Math.floor(box.top);
    // In IE, most of the time, 2 extra pixels are added to the top and left
    // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
    // IE6 standards mode, this border can be overridden by setting the
    // document element's border to zero -- thus, we cannot rely on the
    // offset always being 2 pixels.
    // In quirks mode, the offset can be determined by querying the body's
    // clientLeft/clientTop, but in standards mode, it is found by querying
    // the document element's clientLeft/clientTop.  Since we already called
    // getClientBoundingRect we have already forced a reflow, so it is not
    // too expensive just to query them all.
    // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
    // 窗口边框标准是设 documentElement ,quirks 时设置 body
    // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
    // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
    // 标准 ie 下 docElem.clientTop 就是 border-top
    // ie7 html 即窗口边框改变不了。永远为 2
    // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
        left: x,
        top: y
    };
}
function $d3ef512d6139f433$var$getScroll(w, top) {
    var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
    var method = "scroll".concat(top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        // ie6,7,8 standard mode
        ret = d.documentElement[method];
        if (typeof ret !== 'number') // quirks mode
        ret = d.body[method];
    }
    return ret;
}
function $d3ef512d6139f433$var$getScrollLeft(w) {
    return $d3ef512d6139f433$var$getScroll(w);
}
function $d3ef512d6139f433$var$getScrollTop(w) {
    return $d3ef512d6139f433$var$getScroll(w, true);
}
function $d3ef512d6139f433$var$getOffset(el) {
    var pos = $d3ef512d6139f433$var$getClientPosition(el);
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $d3ef512d6139f433$var$getScrollLeft(w);
    pos.top += $d3ef512d6139f433$var$getScrollTop(w);
    return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */ function $d3ef512d6139f433$var$isWindow(obj) {
    // must use == for ie8
    /* eslint eqeqeq:0 */ return obj !== null && obj !== undefined && obj == obj.window;
}
function $d3ef512d6139f433$var$getDocument(node) {
    if ($d3ef512d6139f433$var$isWindow(node)) return node.document;
    if (node.nodeType === 9) return node;
    return node.ownerDocument;
}
function $d3ef512d6139f433$var$_getComputedStyle(elem, name, cs) {
    var computedStyle = cs;
    var val = '';
    var d = $d3ef512d6139f433$var$getDocument(elem);
    computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
    // https://github.com/kissyteam/kissy/issues/61
    if (computedStyle) val = computedStyle.getPropertyValue(name) || computedStyle[name];
    return val;
}
var $d3ef512d6139f433$var$_RE_NUM_NO_PX = new RegExp("^(".concat($d3ef512d6139f433$var$RE_NUM, ")(?!px)[a-z%]+$"), 'i');
var $d3ef512d6139f433$var$RE_POS = /^(top|right|bottom|left)$/;
var $d3ef512d6139f433$var$CURRENT_STYLE = 'currentStyle';
var $d3ef512d6139f433$var$RUNTIME_STYLE = 'runtimeStyle';
var $d3ef512d6139f433$var$LEFT = 'left';
var $d3ef512d6139f433$var$PX = 'px';
function $d3ef512d6139f433$var$_getComputedStyleIE(elem, name) {
    // currentStyle maybe null
    // http://msdn.microsoft.com/en-us/library/ms535231.aspx
    var ret = elem[$d3ef512d6139f433$var$CURRENT_STYLE] && elem[$d3ef512d6139f433$var$CURRENT_STYLE][name];
    // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
    // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
    // 在 ie 下不对，需要直接用 offset 方式
    // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels
    // exclude left right for relativity
    if ($d3ef512d6139f433$var$_RE_NUM_NO_PX.test(ret) && !$d3ef512d6139f433$var$RE_POS.test(name)) {
        // Remember the original values
        var style = elem.style;
        var left = style[$d3ef512d6139f433$var$LEFT];
        var rsLeft = elem[$d3ef512d6139f433$var$RUNTIME_STYLE][$d3ef512d6139f433$var$LEFT];
        // prevent flashing of content
        elem[$d3ef512d6139f433$var$RUNTIME_STYLE][$d3ef512d6139f433$var$LEFT] = elem[$d3ef512d6139f433$var$CURRENT_STYLE][$d3ef512d6139f433$var$LEFT];
        // Put in the new values to get a computed value out
        style[$d3ef512d6139f433$var$LEFT] = name === 'fontSize' ? '1em' : ret || 0;
        ret = style.pixelLeft + $d3ef512d6139f433$var$PX;
        // Revert the changed values
        style[$d3ef512d6139f433$var$LEFT] = left;
        elem[$d3ef512d6139f433$var$RUNTIME_STYLE][$d3ef512d6139f433$var$LEFT] = rsLeft;
    }
    return ret === '' ? 'auto' : ret;
}
if (typeof window !== 'undefined') $d3ef512d6139f433$var$getComputedStyleX = window.getComputedStyle ? $d3ef512d6139f433$var$_getComputedStyle : $d3ef512d6139f433$var$_getComputedStyleIE;
function $d3ef512d6139f433$var$getOffsetDirection(dir, option) {
    if (dir === 'left') return option.useCssRight ? 'right' : dir;
    return option.useCssBottom ? 'bottom' : dir;
}
function $d3ef512d6139f433$var$oppositeOffsetDirection(dir) {
    if (dir === 'left') return 'right';
    else if (dir === 'right') return 'left';
    else if (dir === 'top') return 'bottom';
    else if (dir === 'bottom') return 'top';
}
// 设置 elem 相对 elem.ownerDocument 的坐标
function $d3ef512d6139f433$var$setLeftTop(elem, offset, option) {
    // set position first, in-case top/left are set even on static elem
    if ($d3ef512d6139f433$var$css(elem, 'position') === 'static') elem.style.position = 'relative';
    var presetH = -999;
    var presetV = -999;
    var horizontalProperty = $d3ef512d6139f433$var$getOffsetDirection('left', option);
    var verticalProperty = $d3ef512d6139f433$var$getOffsetDirection('top', option);
    var oppositeHorizontalProperty = $d3ef512d6139f433$var$oppositeOffsetDirection(horizontalProperty);
    var oppositeVerticalProperty = $d3ef512d6139f433$var$oppositeOffsetDirection(verticalProperty);
    if (horizontalProperty !== 'left') presetH = 999;
    if (verticalProperty !== 'top') presetV = 999;
    var originalTransition = '';
    var originalOffset = $d3ef512d6139f433$var$getOffset(elem);
    if ('left' in offset || 'top' in offset) {
        originalTransition = $d3ef512d6139f433$var$getTransitionProperty(elem) || '';
        $d3ef512d6139f433$var$setTransitionProperty(elem, 'none');
    }
    if ('left' in offset) {
        elem.style[oppositeHorizontalProperty] = '';
        elem.style[horizontalProperty] = "".concat(presetH, "px");
    }
    if ('top' in offset) {
        elem.style[oppositeVerticalProperty] = '';
        elem.style[verticalProperty] = "".concat(presetV, "px");
    }
    // force relayout
    $d3ef512d6139f433$var$forceRelayout(elem);
    var old = $d3ef512d6139f433$var$getOffset(elem);
    var originalStyle = {};
    for(var key in offset)if (offset.hasOwnProperty(key)) {
        var dir = $d3ef512d6139f433$var$getOffsetDirection(key, option);
        var preset = key === 'left' ? presetH : presetV;
        var off = originalOffset[key] - old[key];
        if (dir === key) originalStyle[dir] = preset + off;
        else originalStyle[dir] = preset - off;
    }
    $d3ef512d6139f433$var$css(elem, originalStyle);
    // force relayout
    $d3ef512d6139f433$var$forceRelayout(elem);
    if ('left' in offset || 'top' in offset) $d3ef512d6139f433$var$setTransitionProperty(elem, originalTransition);
    var ret = {};
    for(var _key in offset)if (offset.hasOwnProperty(_key)) {
        var _dir = $d3ef512d6139f433$var$getOffsetDirection(_key, option);
        var _off = offset[_key] - originalOffset[_key];
        if (_key === _dir) ret[_dir] = originalStyle[_dir] + _off;
        else ret[_dir] = originalStyle[_dir] - _off;
    }
    $d3ef512d6139f433$var$css(elem, ret);
}
function $d3ef512d6139f433$var$setTransform$1(elem, offset) {
    var originalOffset = $d3ef512d6139f433$var$getOffset(elem);
    var originalXY = $d3ef512d6139f433$var$getTransformXY(elem);
    var resultXY = {
        x: originalXY.x,
        y: originalXY.y
    };
    if ('left' in offset) resultXY.x = originalXY.x + offset.left - originalOffset.left;
    if ('top' in offset) resultXY.y = originalXY.y + offset.top - originalOffset.top;
    $d3ef512d6139f433$var$setTransformXY(elem, resultXY);
}
function $d3ef512d6139f433$var$setOffset(elem, offset, option) {
    if (option.ignoreShake) {
        var oriOffset = $d3ef512d6139f433$var$getOffset(elem);
        var oLeft = oriOffset.left.toFixed(0);
        var oTop = oriOffset.top.toFixed(0);
        var tLeft = offset.left.toFixed(0);
        var tTop = offset.top.toFixed(0);
        if (oLeft === tLeft && oTop === tTop) return;
    }
    if (option.useCssRight || option.useCssBottom) $d3ef512d6139f433$var$setLeftTop(elem, offset, option);
    else if (option.useCssTransform && $d3ef512d6139f433$var$getTransformName() in document.body.style) $d3ef512d6139f433$var$setTransform$1(elem, offset);
    else $d3ef512d6139f433$var$setLeftTop(elem, offset, option);
}
function $d3ef512d6139f433$var$each(arr, fn) {
    for(var i = 0; i < arr.length; i++)fn(arr[i]);
}
function $d3ef512d6139f433$var$isBorderBoxFn(elem) {
    return $d3ef512d6139f433$var$getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var $d3ef512d6139f433$var$BOX_MODELS = [
    'margin',
    'border',
    'padding'
];
var $d3ef512d6139f433$var$CONTENT_INDEX = -1;
var $d3ef512d6139f433$var$PADDING_INDEX = 2;
var $d3ef512d6139f433$var$BORDER_INDEX = 1;
var $d3ef512d6139f433$var$MARGIN_INDEX = 0;
function $d3ef512d6139f433$var$swap(elem, options, callback) {
    var old = {};
    var style = elem.style;
    var name;
    // Remember the old values, and insert the new ones
    for(name in options)if (options.hasOwnProperty(name)) {
        old[name] = style[name];
        style[name] = options[name];
    }
    callback.call(elem);
    // Revert the old values
    for(name in options)if (options.hasOwnProperty(name)) style[name] = old[name];
}
function $d3ef512d6139f433$var$getPBMWidth(elem, props, which) {
    var value = 0;
    var prop;
    var j;
    var i;
    for(j = 0; j < props.length; j++){
        prop = props[j];
        if (prop) for(i = 0; i < which.length; i++){
            var cssProp = void 0;
            if (prop === 'border') cssProp = "".concat(prop).concat(which[i], "Width");
            else cssProp = prop + which[i];
            value += parseFloat($d3ef512d6139f433$var$getComputedStyleX(elem, cssProp)) || 0;
        }
    }
    return value;
}
var $d3ef512d6139f433$var$domUtils = {
    getParent: function getParent(element) {
        var parent = element;
        do if (parent.nodeType === 11 && parent.host) parent = parent.host;
        else parent = parent.parentNode;
        while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
        return parent;
    }
};
$d3ef512d6139f433$var$each([
    'Width',
    'Height'
], function(name) {
    $d3ef512d6139f433$var$domUtils["doc".concat(name)] = function(refWin) {
        var d = refWin.document;
        return Math.max(// firefox chrome documentElement.scrollHeight< body.scrollHeight
        // ie standard mode : documentElement.scrollHeight> body.scrollHeight
        d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
        d.body["scroll".concat(name)], $d3ef512d6139f433$var$domUtils["viewport".concat(name)](d));
    };
    $d3ef512d6139f433$var$domUtils["viewport".concat(name)] = function(win) {
        // pc browser includes scrollbar in window.innerWidth
        var prop = "client".concat(name);
        var doc = win.document;
        var body = doc.body;
        var documentElement = doc.documentElement;
        var documentElementProp = documentElement[prop];
        // 标准模式取 documentElement
        // backcompat 取 body
        return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
    };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */ function $d3ef512d6139f433$var$getWH(elem, name, ex) {
    var extra = ex;
    if ($d3ef512d6139f433$var$isWindow(elem)) return name === 'width' ? $d3ef512d6139f433$var$domUtils.viewportWidth(elem) : $d3ef512d6139f433$var$domUtils.viewportHeight(elem);
    else if (elem.nodeType === 9) return name === 'width' ? $d3ef512d6139f433$var$domUtils.docWidth(elem) : $d3ef512d6139f433$var$domUtils.docHeight(elem);
    var which = name === 'width' ? [
        'Left',
        'Right'
    ] : [
        'Top',
        'Bottom'
    ];
    var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
    var isBorderBox = $d3ef512d6139f433$var$isBorderBoxFn(elem);
    var cssBoxValue = 0;
    if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
        borderBoxValue = undefined;
        // Fall back to computed then un computed css if necessary
        cssBoxValue = $d3ef512d6139f433$var$getComputedStyleX(elem, name);
        if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) cssBoxValue = elem.style[name] || 0;
        // Normalize '', auto, and prepare for extra
        cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
    }
    if (extra === undefined) extra = isBorderBox ? $d3ef512d6139f433$var$BORDER_INDEX : $d3ef512d6139f433$var$CONTENT_INDEX;
    var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
    var val = borderBoxValue || cssBoxValue;
    if (extra === $d3ef512d6139f433$var$CONTENT_INDEX) {
        if (borderBoxValueOrIsBorderBox) return val - $d3ef512d6139f433$var$getPBMWidth(elem, [
            'border',
            'padding'
        ], which);
        return cssBoxValue;
    } else if (borderBoxValueOrIsBorderBox) {
        if (extra === $d3ef512d6139f433$var$BORDER_INDEX) return val;
        return val + (extra === $d3ef512d6139f433$var$PADDING_INDEX ? -$d3ef512d6139f433$var$getPBMWidth(elem, [
            'border'
        ], which) : $d3ef512d6139f433$var$getPBMWidth(elem, [
            'margin'
        ], which));
    }
    return cssBoxValue + $d3ef512d6139f433$var$getPBMWidth(elem, $d3ef512d6139f433$var$BOX_MODELS.slice(extra), which);
}
var $d3ef512d6139f433$var$cssShow = {
    position: 'absolute',
    visibility: 'hidden',
    display: 'block'
};
// fix #119 : https://github.com/kissyteam/kissy/issues/119
function $d3ef512d6139f433$var$getWHIgnoreDisplay() {
    for(var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++)args[_key2] = arguments[_key2];
    var val;
    var elem = args[0];
    // in case elem is window
    // elem.offsetWidth === undefined
    if (elem.offsetWidth !== 0) val = $d3ef512d6139f433$var$getWH.apply(undefined, args);
    else $d3ef512d6139f433$var$swap(elem, $d3ef512d6139f433$var$cssShow, function() {
        val = $d3ef512d6139f433$var$getWH.apply(undefined, args);
    });
    return val;
}
$d3ef512d6139f433$var$each([
    'width',
    'height'
], function(name) {
    var first = name.charAt(0).toUpperCase() + name.slice(1);
    $d3ef512d6139f433$var$domUtils["outer".concat(first)] = function(el, includeMargin) {
        return el && $d3ef512d6139f433$var$getWHIgnoreDisplay(el, name, includeMargin ? $d3ef512d6139f433$var$MARGIN_INDEX : $d3ef512d6139f433$var$BORDER_INDEX);
    };
    var which = name === 'width' ? [
        'Left',
        'Right'
    ] : [
        'Top',
        'Bottom'
    ];
    $d3ef512d6139f433$var$domUtils[name] = function(elem, v) {
        var val = v;
        if (val !== undefined) {
            if (elem) {
                var isBorderBox = $d3ef512d6139f433$var$isBorderBoxFn(elem);
                if (isBorderBox) val += $d3ef512d6139f433$var$getPBMWidth(elem, [
                    'padding',
                    'border'
                ], which);
                return $d3ef512d6139f433$var$css(elem, name, val);
            }
            return undefined;
        }
        return elem && $d3ef512d6139f433$var$getWHIgnoreDisplay(elem, name, $d3ef512d6139f433$var$CONTENT_INDEX);
    };
});
function $d3ef512d6139f433$var$mix(to, from) {
    for(var i in from)if (from.hasOwnProperty(i)) to[i] = from[i];
    return to;
}
var $d3ef512d6139f433$var$utils = {
    getWindow: function getWindow(node) {
        if (node && node.document && node.setTimeout) return node;
        var doc = node.ownerDocument || node;
        return doc.defaultView || doc.parentWindow;
    },
    getDocument: $d3ef512d6139f433$var$getDocument,
    offset: function offset(el, value, option) {
        if (typeof value !== 'undefined') $d3ef512d6139f433$var$setOffset(el, value, option || {});
        else return $d3ef512d6139f433$var$getOffset(el);
    },
    isWindow: $d3ef512d6139f433$var$isWindow,
    each: $d3ef512d6139f433$var$each,
    css: $d3ef512d6139f433$var$css,
    clone: function clone(obj) {
        var i;
        var ret = {};
        for(i in obj)if (obj.hasOwnProperty(i)) ret[i] = obj[i];
        var overflow = obj.overflow;
        if (overflow) {
            for(i in obj)if (obj.hasOwnProperty(i)) ret.overflow[i] = obj.overflow[i];
        }
        return ret;
    },
    mix: $d3ef512d6139f433$var$mix,
    getWindowScrollLeft: function getWindowScrollLeft(w) {
        return $d3ef512d6139f433$var$getScrollLeft(w);
    },
    getWindowScrollTop: function getWindowScrollTop(w) {
        return $d3ef512d6139f433$var$getScrollTop(w);
    },
    merge: function merge() {
        var ret = {};
        for(var i = 0; i < arguments.length; i++)$d3ef512d6139f433$var$utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
        return ret;
    },
    viewportWidth: 0,
    viewportHeight: 0
};
$d3ef512d6139f433$var$mix($d3ef512d6139f433$var$utils, $d3ef512d6139f433$var$domUtils);
/**
 * 得到会导致元素显示不全的祖先元素
 */ var $d3ef512d6139f433$var$getParent = $d3ef512d6139f433$var$utils.getParent;
function $d3ef512d6139f433$var$getOffsetParent(element) {
    if ($d3ef512d6139f433$var$utils.isWindow(element) || element.nodeType === 9) return null;
    // ie 这个也不是完全可行
    /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */ // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
    //  In other browsers it only includes elements with position absolute, relative or
    // fixed, not elements with overflow set to auto or scroll.
    //        if (UA.ie && ieMode < 8) {
    //            return element.offsetParent;
    //        }
    // 统一的 offsetParent 方法
    var doc = $d3ef512d6139f433$var$utils.getDocument(element);
    var body = doc.body;
    var parent;
    var positionStyle = $d3ef512d6139f433$var$utils.css(element, 'position');
    var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
    if (!skipStatic) return element.nodeName.toLowerCase() === 'html' ? null : $d3ef512d6139f433$var$getParent(element);
    for(parent = $d3ef512d6139f433$var$getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = $d3ef512d6139f433$var$getParent(parent)){
        positionStyle = $d3ef512d6139f433$var$utils.css(parent, 'position');
        if (positionStyle !== 'static') return parent;
    }
    return null;
}
var $d3ef512d6139f433$var$getParent$1 = $d3ef512d6139f433$var$utils.getParent;
function $d3ef512d6139f433$var$isAncestorFixed(element) {
    if ($d3ef512d6139f433$var$utils.isWindow(element) || element.nodeType === 9) return false;
    var doc = $d3ef512d6139f433$var$utils.getDocument(element);
    var body = doc.body;
    var parent = null;
    for(parent = $d3ef512d6139f433$var$getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
    parent && parent !== body && parent !== doc; parent = $d3ef512d6139f433$var$getParent$1(parent)){
        var positionStyle = $d3ef512d6139f433$var$utils.css(parent, 'position');
        if (positionStyle === 'fixed') return true;
    }
    return false;
}
/**
 * 获得元素的显示部分的区域
 */ function $d3ef512d6139f433$var$getVisibleRectForElement(element, alwaysByViewport) {
    var visibleRect = {
        left: 0,
        right: Infinity,
        top: 0,
        bottom: Infinity
    };
    var el = $d3ef512d6139f433$var$getOffsetParent(element);
    var doc = $d3ef512d6139f433$var$utils.getDocument(element);
    var win = doc.defaultView || doc.parentWindow;
    var body = doc.body;
    var documentElement = doc.documentElement;
    // Determine the size of the visible rect by climbing the dom accounting for
    // all scrollable containers.
    while(el){
        // clientWidth is zero for inline block elements in ie.
        if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
        // viewport. In some browsers, el.offsetParent may be
        // document.documentElement, so check for that too.
        el !== body && el !== documentElement && $d3ef512d6139f433$var$utils.css(el, 'overflow') !== 'visible') {
            var pos = $d3ef512d6139f433$var$utils.offset(el);
            // add border
            pos.left += el.clientLeft;
            pos.top += el.clientTop;
            visibleRect.top = Math.max(visibleRect.top, pos.top);
            visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
            pos.left + el.clientWidth);
            visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
            visibleRect.left = Math.max(visibleRect.left, pos.left);
        } else if (el === body || el === documentElement) break;
        el = $d3ef512d6139f433$var$getOffsetParent(el);
    }
    // Set element position to fixed
    // make sure absolute element itself don't affect it's visible area
    // https://github.com/ant-design/ant-design/issues/7601
    var originalPosition = null;
    if (!$d3ef512d6139f433$var$utils.isWindow(element) && element.nodeType !== 9) {
        originalPosition = element.style.position;
        var position = $d3ef512d6139f433$var$utils.css(element, 'position');
        if (position === 'absolute') element.style.position = 'fixed';
    }
    var scrollX = $d3ef512d6139f433$var$utils.getWindowScrollLeft(win);
    var scrollY = $d3ef512d6139f433$var$utils.getWindowScrollTop(win);
    var viewportWidth = $d3ef512d6139f433$var$utils.viewportWidth(win);
    var viewportHeight = $d3ef512d6139f433$var$utils.viewportHeight(win);
    var documentWidth = documentElement.scrollWidth;
    var documentHeight = documentElement.scrollHeight;
    // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
    // We should cut this ourself.
    var bodyStyle = window.getComputedStyle(body);
    if (bodyStyle.overflowX === 'hidden') documentWidth = win.innerWidth;
    if (bodyStyle.overflowY === 'hidden') documentHeight = win.innerHeight;
    // Reset element position after calculate the visible area
    if (element.style) element.style.position = originalPosition;
    if (alwaysByViewport || $d3ef512d6139f433$var$isAncestorFixed(element)) {
        // Clip by viewport's size.
        visibleRect.left = Math.max(visibleRect.left, scrollX);
        visibleRect.top = Math.max(visibleRect.top, scrollY);
        visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
        visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
    } else {
        // Clip by document's size.
        var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
        visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
        var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
        visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
    }
    return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function $d3ef512d6139f433$var$adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
    var pos = $d3ef512d6139f433$var$utils.clone(elFuturePos);
    var size = {
        width: elRegion.width,
        height: elRegion.height
    };
    if (overflow.adjustX && pos.left < visibleRect.left) pos.left = visibleRect.left;
    // Left edge inside and right edge outside viewport, try to resize it.
    if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) size.width -= pos.left + size.width - visibleRect.right;
    // Right edge outside viewport, try to move it.
    if (overflow.adjustX && pos.left + size.width > visibleRect.right) // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
    // Top edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top < visibleRect.top) pos.top = visibleRect.top;
    // Top edge inside and bottom edge outside viewport, try to resize it.
    if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) size.height -= pos.top + size.height - visibleRect.bottom;
    // Bottom edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
    return $d3ef512d6139f433$var$utils.mix(pos, size);
}
function $d3ef512d6139f433$var$getRegion(node) {
    var offset;
    var w;
    var h;
    if (!$d3ef512d6139f433$var$utils.isWindow(node) && node.nodeType !== 9) {
        offset = $d3ef512d6139f433$var$utils.offset(node);
        w = $d3ef512d6139f433$var$utils.outerWidth(node);
        h = $d3ef512d6139f433$var$utils.outerHeight(node);
    } else {
        var win = $d3ef512d6139f433$var$utils.getWindow(node);
        offset = {
            left: $d3ef512d6139f433$var$utils.getWindowScrollLeft(win),
            top: $d3ef512d6139f433$var$utils.getWindowScrollTop(win)
        };
        w = $d3ef512d6139f433$var$utils.viewportWidth(win);
        h = $d3ef512d6139f433$var$utils.viewportHeight(win);
    }
    offset.width = w;
    offset.height = h;
    return offset;
}
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */ function $d3ef512d6139f433$var$getAlignOffset(region, align) {
    var V = align.charAt(0);
    var H = align.charAt(1);
    var w = region.width;
    var h = region.height;
    var x = region.left;
    var y = region.top;
    if (V === 'c') y += h / 2;
    else if (V === 'b') y += h;
    if (H === 'c') x += w / 2;
    else if (H === 'r') x += w;
    return {
        left: x,
        top: y
    };
}
function $d3ef512d6139f433$var$getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
    var p1 = $d3ef512d6139f433$var$getAlignOffset(refNodeRegion, points[1]);
    var p2 = $d3ef512d6139f433$var$getAlignOffset(elRegion, points[0]);
    var diff = [
        p2.left - p1.left,
        p2.top - p1.top
    ];
    return {
        left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
        top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
    };
}
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */ // http://yiminghe.iteye.com/blog/1124720
function $d3ef512d6139f433$var$isFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function $d3ef512d6139f433$var$isFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function $d3ef512d6139f433$var$isCompleteFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function $d3ef512d6139f433$var$isCompleteFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function $d3ef512d6139f433$var$flip(points, reg, map) {
    var ret = [];
    $d3ef512d6139f433$var$utils.each(points, function(p) {
        ret.push(p.replace(reg, function(m) {
            return map[m];
        }));
    });
    return ret;
}
function $d3ef512d6139f433$var$flipOffset(offset, index) {
    offset[index] = -offset[index];
    return offset;
}
function $d3ef512d6139f433$var$convertOffset(str, offsetLen) {
    var n;
    if (/%$/.test(str)) n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
    else n = parseInt(str, 10);
    return n || 0;
}
function $d3ef512d6139f433$var$normalizeOffset(offset, el) {
    offset[0] = $d3ef512d6139f433$var$convertOffset(offset[0], el.width);
    offset[1] = $d3ef512d6139f433$var$convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */ function $d3ef512d6139f433$var$doAlign(el, tgtRegion, align, isTgtRegionVisible) {
    var points = align.points;
    var offset = align.offset || [
        0,
        0
    ];
    var targetOffset = align.targetOffset || [
        0,
        0
    ];
    var overflow = align.overflow;
    var source = align.source || el;
    offset = [].concat(offset);
    targetOffset = [].concat(targetOffset);
    overflow = overflow || {};
    var newOverflowCfg = {};
    var fail = 0;
    var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
    // 当前节点可以被放置的显示区域
    var visibleRect = $d3ef512d6139f433$var$getVisibleRectForElement(source, alwaysByViewport);
    // 当前节点所占的区域, left/top/width/height
    var elRegion = $d3ef512d6139f433$var$getRegion(source);
    // 将 offset 转换成数值，支持百分比
    $d3ef512d6139f433$var$normalizeOffset(offset, elRegion);
    $d3ef512d6139f433$var$normalizeOffset(targetOffset, tgtRegion);
    // 当前节点将要被放置的位置
    var elFuturePos = $d3ef512d6139f433$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
    // 当前节点将要所处的区域
    var newElRegion = $d3ef512d6139f433$var$utils.merge(elRegion, elFuturePos);
    // 如果可视区域不能完全放置当前节点时允许调整
    if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
        if (overflow.adjustX) // 如果横向不能放下
        {
            if ($d3ef512d6139f433$var$isFailX(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var newPoints = $d3ef512d6139f433$var$flip(points, /[lr]/gi, {
                    l: 'r',
                    r: 'l'
                });
                // 偏移量也反下
                var newOffset = $d3ef512d6139f433$var$flipOffset(offset, 0);
                var newTargetOffset = $d3ef512d6139f433$var$flipOffset(targetOffset, 0);
                var newElFuturePos = $d3ef512d6139f433$var$getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
                if (!$d3ef512d6139f433$var$isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = newPoints;
                    offset = newOffset;
                    targetOffset = newTargetOffset;
                }
            }
        }
        if (overflow.adjustY) // 如果纵向不能放下
        {
            if ($d3ef512d6139f433$var$isFailY(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var _newPoints = $d3ef512d6139f433$var$flip(points, /[tb]/gi, {
                    t: 'b',
                    b: 't'
                });
                // 偏移量也反下
                var _newOffset = $d3ef512d6139f433$var$flipOffset(offset, 1);
                var _newTargetOffset = $d3ef512d6139f433$var$flipOffset(targetOffset, 1);
                var _newElFuturePos = $d3ef512d6139f433$var$getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
                if (!$d3ef512d6139f433$var$isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = _newPoints;
                    offset = _newOffset;
                    targetOffset = _newTargetOffset;
                }
            }
        }
        // 如果失败，重新计算当前节点将要被放置的位置
        if (fail) {
            elFuturePos = $d3ef512d6139f433$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
            $d3ef512d6139f433$var$utils.mix(newElRegion, elFuturePos);
        }
        var isStillFailX = $d3ef512d6139f433$var$isFailX(elFuturePos, elRegion, visibleRect);
        var isStillFailY = $d3ef512d6139f433$var$isFailY(elFuturePos, elRegion, visibleRect);
        // 检查反下后的位置是否可以放下了，如果仍然放不下：
        // 1. 复原修改过的定位参数
        if (isStillFailX || isStillFailY) {
            var _newPoints2 = points;
            // 重置对应部分的翻转逻辑
            if (isStillFailX) _newPoints2 = $d3ef512d6139f433$var$flip(points, /[lr]/gi, {
                l: 'r',
                r: 'l'
            });
            if (isStillFailY) _newPoints2 = $d3ef512d6139f433$var$flip(points, /[tb]/gi, {
                t: 'b',
                b: 't'
            });
            points = _newPoints2;
            offset = align.offset || [
                0,
                0
            ];
            targetOffset = align.targetOffset || [
                0,
                0
            ];
        }
        // 2. 只有指定了可以调整当前方向才调整
        newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
        newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
        // 确实要调整，甚至可能会调整高度宽度
        if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) newElRegion = $d3ef512d6139f433$var$adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
    // need judge to in case set fixed with in css on height auto element
    if (newElRegion.width !== elRegion.width) $d3ef512d6139f433$var$utils.css(source, 'width', $d3ef512d6139f433$var$utils.width(source) + newElRegion.width - elRegion.width);
    if (newElRegion.height !== elRegion.height) $d3ef512d6139f433$var$utils.css(source, 'height', $d3ef512d6139f433$var$utils.height(source) + newElRegion.height - elRegion.height);
    // https://github.com/kissyteam/kissy/issues/190
    // 相对于屏幕位置没变，而 left/top 变了
    // 例如 <div 'relative'><el absolute></div>
    $d3ef512d6139f433$var$utils.offset(source, {
        left: newElRegion.left,
        top: newElRegion.top
    }, {
        useCssRight: align.useCssRight,
        useCssBottom: align.useCssBottom,
        useCssTransform: align.useCssTransform,
        ignoreShake: align.ignoreShake
    });
    return {
        points: points,
        offset: offset,
        targetOffset: targetOffset,
        overflow: newOverflowCfg
    };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/ function $d3ef512d6139f433$var$isOutOfVisibleRect(target, alwaysByViewport) {
    var visibleRect = $d3ef512d6139f433$var$getVisibleRectForElement(target, alwaysByViewport);
    var targetRegion = $d3ef512d6139f433$var$getRegion(target);
    return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function $d3ef512d6139f433$export$ec21431d5ee6c534(el, refNode, align) {
    var target = align.target || refNode;
    var refNodeRegion = $d3ef512d6139f433$var$getRegion(target);
    var isTargetNotOutOfVisible = !$d3ef512d6139f433$var$isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
    return $d3ef512d6139f433$var$doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
$d3ef512d6139f433$export$ec21431d5ee6c534.__getOffsetParent = $d3ef512d6139f433$var$getOffsetParent;
$d3ef512d6139f433$export$ec21431d5ee6c534.__getVisibleRectForElement = $d3ef512d6139f433$var$getVisibleRectForElement;
/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */ function $d3ef512d6139f433$export$38f0e12f0aa28098(el, tgtPoint, align) {
    var pageX;
    var pageY;
    var doc = $d3ef512d6139f433$var$utils.getDocument(el);
    var win = doc.defaultView || doc.parentWindow;
    var scrollX = $d3ef512d6139f433$var$utils.getWindowScrollLeft(win);
    var scrollY = $d3ef512d6139f433$var$utils.getWindowScrollTop(win);
    var viewportWidth = $d3ef512d6139f433$var$utils.viewportWidth(win);
    var viewportHeight = $d3ef512d6139f433$var$utils.viewportHeight(win);
    if ('pageX' in tgtPoint) pageX = tgtPoint.pageX;
    else pageX = scrollX + tgtPoint.clientX;
    if ('pageY' in tgtPoint) pageY = tgtPoint.pageY;
    else pageY = scrollY + tgtPoint.clientY;
    var tgtRegion = {
        left: pageX,
        top: pageY,
        width: 0,
        height: 0
    };
    var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
    // Provide default target point
    var points = [
        align.points[0],
        'cc'
    ];
    return $d3ef512d6139f433$var$doAlign(el, tgtRegion, $d3ef512d6139f433$var$_objectSpread2($d3ef512d6139f433$var$_objectSpread2({}, align), {}, {
        points: points
    }), pointInView);
}
var $d3ef512d6139f433$export$2e2bcd8739ae039 = $d3ef512d6139f433$export$ec21431d5ee6c534;



var $5KhTJ = parcelRequire("5KhTJ");

var $3mXQ2 = parcelRequire("3mXQ2");
/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $ae3c1fae8a247572$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $3mXQ2.default)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $5KhTJ.default)(a) === 'object' && (0, $5KhTJ.default)(b) === 'object') {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $ae3c1fae8a247572$export$2e2bcd8739ae039 = $ae3c1fae8a247572$var$isEqual;



var $5335db4432c3f914$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};



var $dNZA9 = parcelRequire("dNZA9");

var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");
var $b7b5592847a06c49$export$2e2bcd8739ae039 = function(callback, buffer) {
    var calledRef = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useRef(false);
    var timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useRef(null);
    function cancelTrigger() {
        window.clearTimeout(timeoutRef.current);
    }
    function trigger(force) {
        cancelTrigger();
        if (!calledRef.current || force === true) {
            if (callback(force) === false) // Not delay since callback cancelled self
            return;
            calledRef.current = true;
            timeoutRef.current = window.setTimeout(function() {
                calledRef.current = false;
            }, buffer);
        } else timeoutRef.current = window.setTimeout(function() {
            calledRef.current = false;
            trigger();
        }, buffer);
    }
    return [
        trigger,
        function() {
            calledRef.current = false;
            cancelTrigger();
        }
    ];
};



var $jP8CL = parcelRequire("jP8CL");


function $20dfb88ba76c6162$export$792a4d7b8e9efb33(prev, next) {
    if (prev === next) return true;
    if (!prev || !next) return false;
    if ('pageX' in next && 'pageY' in next) return prev.pageX === next.pageX && prev.pageY === next.pageY;
    if ('clientX' in next && 'clientY' in next) return prev.clientX === next.clientX && prev.clientY === next.clientY;
    return false;
}
function $20dfb88ba76c6162$export$2284e449d64b22d5(activeElement, container) {
    // Focus back if is in the container
    if (activeElement !== document.activeElement && (0, $b5cc600be516f1fa$export$2e2bcd8739ae039)(container, activeElement) && typeof activeElement.focus === 'function') activeElement.focus();
}
function $20dfb88ba76c6162$export$f56787db9e74dfe(element, callback) {
    var prevWidth = null;
    var prevHeight = null;
    function onResize(_ref) {
        var _ref2 = (0, $jP8CL.default)(_ref, 1), target = _ref2[0].target;
        if (!document.documentElement.contains(target)) return;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) // https://webkit.org/blog/9997/resizeobserver-in-webkit/
        Promise.resolve().then(function() {
            callback({
                width: fixedWidth,
                height: fixedHeight
            });
        });
        prevWidth = fixedWidth;
        prevHeight = fixedHeight;
    }
    var resizeObserver = new (0, $b6545e955638aae9$export$2e2bcd8739ae039)(onResize);
    if (element) resizeObserver.observe(element);
    return function() {
        resizeObserver.disconnect();
    };
}


function $1bc9cf03e641bb1a$var$getElement(func) {
    if (typeof func !== 'function') return null;
    return func();
}
function $1bc9cf03e641bb1a$var$getPoint(point) {
    if ((0, $5KhTJ.default)(point) !== 'object' || !point) return null;
    return point;
}
var $1bc9cf03e641bb1a$var$Align = function Align(_ref, ref) {
    var children = _ref.children, disabled = _ref.disabled, target = _ref.target, align = _ref.align, onAlign = _ref.onAlign, monitorWindowResize = _ref.monitorWindowResize, _ref$monitorBufferTim = _ref.monitorBufferTime, monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
    var cacheRef = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useRef({});
    /** Popup node ref */ var nodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useRef();
    var childNode = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Children.only(children); // ===================== Align ======================
    // We save the props here to avoid closure makes props ood
    var forceAlignPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useRef({});
    forceAlignPropsRef.current.disabled = disabled;
    forceAlignPropsRef.current.target = target;
    forceAlignPropsRef.current.align = align;
    forceAlignPropsRef.current.onAlign = onAlign;
    var _useBuffer = (0, $b7b5592847a06c49$export$2e2bcd8739ae039)(function() {
        var _forceAlignPropsRef$c = forceAlignPropsRef.current, latestDisabled = _forceAlignPropsRef$c.disabled, latestTarget = _forceAlignPropsRef$c.target, latestAlign = _forceAlignPropsRef$c.align, latestOnAlign = _forceAlignPropsRef$c.onAlign;
        var source = nodeRef.current;
        if (!latestDisabled && latestTarget && source) {
            var _result;
            var _element = $1bc9cf03e641bb1a$var$getElement(latestTarget);
            var _point = $1bc9cf03e641bb1a$var$getPoint(latestTarget);
            cacheRef.current.element = _element;
            cacheRef.current.point = _point;
            cacheRef.current.align = latestAlign; // IE lose focus after element realign
            // We should record activeElement and restore later
            var _document = document, activeElement = _document.activeElement; // We only align when element is visible
            if (_element && (0, $5335db4432c3f914$export$2e2bcd8739ae039)(_element)) _result = (0, $d3ef512d6139f433$export$ec21431d5ee6c534)(source, _element, latestAlign);
            else if (_point) _result = (0, $d3ef512d6139f433$export$38f0e12f0aa28098)(source, _point, latestAlign);
            (0, $20dfb88ba76c6162$export$2284e449d64b22d5)(activeElement, source);
            if (latestOnAlign && _result) latestOnAlign(source, _result);
            return true;
        }
        return false;
    }, monitorBufferTime), _useBuffer2 = (0, $jP8CL.default)(_useBuffer, 2), _forceAlign = _useBuffer2[0], cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
    // Handle props change
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useState(), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useState(), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), point = _React$useState4[0], setPoint = _React$useState4[1];
    (0, $dNZA9.default)(function() {
        setElement($1bc9cf03e641bb1a$var$getElement(target));
        setPoint($1bc9cf03e641bb1a$var$getPoint(target));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useEffect(function() {
        if (cacheRef.current.element !== element || !(0, $20dfb88ba76c6162$export$792a4d7b8e9efb33)(cacheRef.current.point, point) || !(0, $ae3c1fae8a247572$export$2e2bcd8739ae039)(cacheRef.current.align, align)) _forceAlign();
    }); // Watch popup element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useEffect(function() {
        var cancelFn = (0, $20dfb88ba76c6162$export$f56787db9e74dfe)(nodeRef.current, _forceAlign);
        return cancelFn;
    }, [
        nodeRef.current
    ]); // Watch target element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useEffect(function() {
        var cancelFn = (0, $20dfb88ba76c6162$export$f56787db9e74dfe)(element, _forceAlign);
        return cancelFn;
    }, [
        element
    ]); // Listen for disabled change
    (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useEffect(function() {
        if (!disabled) _forceAlign();
        else cancelForceAlign();
    }, [
        disabled
    ]); // Listen for window resize
    (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useEffect(function() {
        if (monitorWindowResize) {
            var cancelFn = (0, $5184338d6a99a234$export$2e2bcd8739ae039)(window, 'resize', _forceAlign);
            return cancelFn.remove;
        }
    }, [
        monitorWindowResize
    ]); // Clear all if unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useEffect(function() {
        return function() {
            cancelForceAlign();
        };
    }, []); // ====================== Ref =======================
    (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {
                return _forceAlign(true);
            }
        };
    }); // ===================== Render =====================
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).isValidElement(childNode)) childNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).cloneElement(childNode, {
        ref: (0, $3BOWT.composeRef)(childNode.ref, nodeRef)
    });
    return childNode;
};
var $1bc9cf03e641bb1a$var$RcAlign = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef($1bc9cf03e641bb1a$var$Align);
$1bc9cf03e641bb1a$var$RcAlign.displayName = 'Align';
var $1bc9cf03e641bb1a$export$2e2bcd8739ae039 = $1bc9cf03e641bb1a$var$RcAlign;


var $727a8a70cb2929b1$export$2e2bcd8739ae039 = (0, $1bc9cf03e641bb1a$export$2e2bcd8739ae039);



var $dNZA9 = parcelRequire("dNZA9");

var $5EVeC = parcelRequire("5EVeC");

var $fActo = parcelRequire("fActo");

var $1WWLf = parcelRequire("1WWLf");

var $47DhB = parcelRequire("47DhB");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $hqic8 = parcelRequire("hqic8");

var $lqiy0 = parcelRequire("lqiy0");
/**
 * Popup should follow the steps for each component work correctly:
 * measure - check for the current stretch size
 * align - let component align the position
 * aligned - re-align again in case additional className changed the size
 * afterAlign - choice next step is trigger motion or finished
 * beforeMotion - should reset motion to invisible so that CSSMotion can do normal motion
 * motion - play the motion
 * stable - everything is done
 */ var $fdec897077d1fbab$var$StatusQueue = [
    'measure',
    'alignPre',
    'align',
    null,
    'motion'
];
var $fdec897077d1fbab$export$2e2bcd8739ae039 = function(visible, doMeasure) {
    var _useState = (0, $lqiy0.default)(null), _useState2 = (0, $jP8CL.default)(_useState, 2), status = _useState2[0], setInternalStatus = _useState2[1];
    var rafRef = (0, $6fFrj.useRef)();
    function setStatus(nextStatus) {
        setInternalStatus(nextStatus, true);
    }
    function cancelRaf() {
        (0, $hqic8.default).cancel(rafRef.current);
    }
    function goNextStatus(callback) {
        cancelRaf();
        rafRef.current = (0, $hqic8.default)(function() {
            // Only align should be manually trigger
            setStatus(function(prev) {
                switch(status){
                    case 'align':
                        return 'motion';
                    case 'motion':
                        return 'stable';
                    default:
                }
                return prev;
            });
            callback === null || callback === void 0 || callback();
        });
    } // Init status
    (0, $6fFrj.useEffect)(function() {
        setStatus('measure');
    }, [
        visible
    ]); // Go next status
    (0, $6fFrj.useEffect)(function() {
        switch(status){
            case 'measure':
                doMeasure();
                break;
            default:
        }
        if (status) rafRef.current = (0, $hqic8.default)(/*#__PURE__*/ (0, $47DhB.default)(/*#__PURE__*/ (0, $1WWLf.default)().mark(function _callee() {
            var index, nextStatus;
            return (0, $1WWLf.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        index = $fdec897077d1fbab$var$StatusQueue.indexOf(status);
                        nextStatus = $fdec897077d1fbab$var$StatusQueue[index + 1];
                        if (nextStatus && index !== -1) setStatus(nextStatus);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
    }, [
        status
    ]);
    (0, $6fFrj.useEffect)(function() {
        return function() {
            cancelRaf();
        };
    }, []);
    return [
        status,
        goNextStatus
    ];
};




var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
var $7679cd8e292b0db8$export$2e2bcd8739ae039 = function(stretch) {
    var _React$useState = $6fFrj.useState({
        width: 0,
        height: 0
    }), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), targetSize = _React$useState2[0], setTargetSize = _React$useState2[1];
    function measureStretch(element) {
        var tgtWidth = element.offsetWidth, tgtHeight = element.offsetHeight;
        var _element$getBoundingC = element.getBoundingClientRect(), width = _element$getBoundingC.width, height = _element$getBoundingC.height; // Rect is more accurate than offset, use if near
        if (Math.abs(tgtWidth - width) < 1 && Math.abs(tgtHeight - height) < 1) {
            tgtWidth = width;
            tgtHeight = height;
        }
        setTargetSize({
            width: tgtWidth,
            height: tgtHeight
        });
    } // Merge stretch style
    var style = $6fFrj.useMemo(function() {
        var sizeStyle = {};
        if (stretch) {
            var width = targetSize.width, height = targetSize.height; // Stretch with target
            if (stretch.indexOf('height') !== -1 && height) sizeStyle.height = height;
            else if (stretch.indexOf('minHeight') !== -1 && height) sizeStyle.minHeight = height;
            if (stretch.indexOf('width') !== -1 && width) sizeStyle.width = width;
            else if (stretch.indexOf('minWidth') !== -1 && width) sizeStyle.minWidth = width;
        }
        return sizeStyle;
    }, [
        stretch,
        targetSize
    ]);
    return [
        style,
        measureStretch
    ];
};


var $ef26e1827320ca72$var$PopupInner = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var visible = props.visible, prefixCls = props.prefixCls, className = props.className, style = props.style, children = props.children, zIndex = props.zIndex, stretch = props.stretch, destroyPopupOnHide = props.destroyPopupOnHide, forceRender = props.forceRender, align = props.align, point = props.point, getRootDomNode = props.getRootDomNode, getClassNameFromAlign = props.getClassNameFromAlign, onAlign = props.onAlign, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onMouseDown = props.onMouseDown, onTouchStart = props.onTouchStart, onClick = props.onClick;
    var alignRef = (0, $6fFrj.useRef)();
    var elementRef = (0, $6fFrj.useRef)();
    var _useState = (0, $6fFrj.useState)(), _useState2 = (0, $jP8CL.default)(_useState, 2), alignedClassName = _useState2[0], setAlignedClassName = _useState2[1]; // ======================= Measure ========================
    var _useStretchStyle = (0, $7679cd8e292b0db8$export$2e2bcd8739ae039)(stretch), _useStretchStyle2 = (0, $jP8CL.default)(_useStretchStyle, 2), stretchStyle = _useStretchStyle2[0], measureStretchStyle = _useStretchStyle2[1];
    function doMeasure() {
        if (stretch) measureStretchStyle(getRootDomNode());
    } // ======================== Status ========================
    var _useVisibleStatus = (0, $fdec897077d1fbab$export$2e2bcd8739ae039)(visible, doMeasure), _useVisibleStatus2 = (0, $jP8CL.default)(_useVisibleStatus, 2), status = _useVisibleStatus2[0], goNextStatus = _useVisibleStatus2[1]; // ======================== Aligns ========================
    /**
   * `alignedClassName` may modify `source` size,
   * which means one time align may not move to the correct position at once.
   *
   * We will reset `alignTimes` for each status switch to `alignPre`
   * and let `rc-align` to align for multiple times to ensure get final stable place.
   * Currently we mark `alignTimes < 2` repeat align, it will increase if user report for align issue.
   * 
   * Update:
   * In React 18. `rc-align` effect of align may faster than ref called trigger `forceAlign`.
   * We adjust this to `alignTimes < 2`.
   * We need refactor `rc-align` to support mark of `forceAlign` call if this still happen.
   */ var _useState3 = (0, $6fFrj.useState)(0), _useState4 = (0, $jP8CL.default)(_useState3, 2), alignTimes = _useState4[0], setAlignTimes = _useState4[1];
    var prepareResolveRef = (0, $6fFrj.useRef)();
    (0, $dNZA9.default)(function() {
        if (status === 'alignPre') setAlignTimes(0);
    }, [
        status
    ]); // `target` on `rc-align` can accept as a function to get the bind element or a point.
    // ref: https://www.npmjs.com/package/rc-align
    function getAlignTarget() {
        if (point) return point;
        return getRootDomNode;
    }
    function forceAlign() {
        var _alignRef$current;
        (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 || _alignRef$current.forceAlign();
    }
    function onInternalAlign(popupDomNode, matchAlign) {
        var nextAlignedClassName = getClassNameFromAlign(matchAlign);
        if (alignedClassName !== nextAlignedClassName) setAlignedClassName(nextAlignedClassName);
         // We will retry multi times to make sure that the element has been align in the right position.
        setAlignTimes(function(val) {
            return val + 1;
        });
        if (status === 'align') onAlign === null || onAlign === void 0 || onAlign(popupDomNode, matchAlign);
    } // Delay to go to next status
    (0, $dNZA9.default)(function() {
        if (status === 'align') {
            // Repeat until not more align needed
            if (alignTimes < 3) forceAlign();
            else goNextStatus(function() {
                var _prepareResolveRef$cu;
                (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 || _prepareResolveRef$cu.call(prepareResolveRef);
            });
        }
    }, [
        alignTimes
    ]); // ======================== Motion ========================
    var motion = (0, $kNxFX.default)({}, (0, $c01032bdb736b76a$export$7b8936ddc277a29a)(props));
    [
        'onAppearEnd',
        'onEnterEnd',
        'onLeaveEnd'
    ].forEach(function(eventName) {
        var originHandler = motion[eventName];
        motion[eventName] = function(element, event) {
            goNextStatus();
            return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
        };
    });
    function onShowPrepare() {
        return new Promise(function(resolve) {
            prepareResolveRef.current = resolve;
        });
    } // Go to stable directly when motion not provided
    $6fFrj.useEffect(function() {
        if (!motion.motionName && status === 'motion') goNextStatus();
    }, [
        motion.motionName,
        status
    ]); // ========================= Refs =========================
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            forceAlign: forceAlign,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $kNxFX.default)((0, $kNxFX.default)({}, stretchStyle), {}, {
        zIndex: zIndex,
        opacity: status === 'motion' || status === 'stable' || !visible ? undefined : 0,
        // Cannot interact with disappearing elements
        // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
        pointerEvents: !visible && status !== 'stable' ? 'none' : undefined
    }, style); // Align status
    var alignDisabled = true;
    if (align !== null && align !== void 0 && align.points && (status === 'align' || status === 'stable')) alignDisabled = false;
    var childNode = children; // Wrapper when multiple children
    if ($6fFrj.Children.count(children) > 1) childNode = /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
    return /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), (0, $fIrcP.default)({
        visible: visible,
        ref: elementRef,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }, motion, {
        onAppearPrepare: onShowPrepare,
        onEnterPrepare: onShowPrepare,
        removeOnLeave: destroyPopupOnHide,
        forceRender: forceRender
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className, alignedClassName, motionClassName);
        return /*#__PURE__*/ $6fFrj.createElement((0, $727a8a70cb2929b1$export$2e2bcd8739ae039), {
            target: getAlignTarget(),
            key: "popup",
            ref: alignRef,
            monitorWindowResize: true,
            disabled: alignDisabled,
            align: align,
            onAlign: onInternalAlign
        }, /*#__PURE__*/ $6fFrj.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseDownCapture: onMouseDown,
            onTouchStartCapture: onTouchStart,
            onClick: onClick,
            style: (0, $kNxFX.default)((0, $kNxFX.default)({}, motionStyle), mergedStyle)
        }, childNode));
    });
});
$ef26e1827320ca72$var$PopupInner.displayName = 'PopupInner';
var $ef26e1827320ca72$export$2e2bcd8739ae039 = $ef26e1827320ca72$var$PopupInner;



var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");

var $5EVeC = parcelRequire("5EVeC");

var $fActo = parcelRequire("fActo");
var $0c7eb47d3d4f26c0$var$MobilePopupInner = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, children = props.children, _props$mobile = props.mobile;
    _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
    var popupClassName = _props$mobile.popupClassName, popupStyle = _props$mobile.popupStyle, _props$mobile$popupMo = _props$mobile.popupMotion, popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo, popupRender = _props$mobile.popupRender, onClick = props.onClick;
    var elementRef = $6fFrj.useRef(); // ========================= Refs =========================
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {},
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $kNxFX.default)({
        zIndex: zIndex
    }, popupStyle);
    var childNode = children; // Wrapper when multiple children
    if ($6fFrj.Children.count(children) > 1) childNode = /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
     // Mobile support additional render
    if (popupRender) childNode = popupRender(childNode);
    return /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), (0, $fIrcP.default)({
        visible: visible,
        ref: elementRef,
        removeOnLeave: true
    }, popupMotion), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, popupClassName, motionClassName);
        return /*#__PURE__*/ $6fFrj.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onClick: onClick,
            style: (0, $kNxFX.default)((0, $kNxFX.default)({}, motionStyle), mergedStyle)
        }, childNode);
    });
});
$0c7eb47d3d4f26c0$var$MobilePopupInner.displayName = 'MobilePopupInner';
var $0c7eb47d3d4f26c0$export$2e2bcd8739ae039 = $0c7eb47d3d4f26c0$var$MobilePopupInner;


var $52e0845e8abdd114$var$_excluded = [
    "visible",
    "mobile"
];
var $52e0845e8abdd114$var$Popup = /*#__PURE__*/ $6fFrj.forwardRef(function(_ref, ref) {
    var visible = _ref.visible, mobile = _ref.mobile, props = (0, $04RxA.default)(_ref, $52e0845e8abdd114$var$_excluded);
    var _useState = (0, $6fFrj.useState)(visible), _useState2 = (0, $jP8CL.default)(_useState, 2), innerVisible = _useState2[0], serInnerVisible = _useState2[1];
    var _useState3 = (0, $6fFrj.useState)(false), _useState4 = (0, $jP8CL.default)(_useState3, 2), inMobile = _useState4[0], setInMobile = _useState4[1];
    var cloneProps = (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        visible: innerVisible
    }); // We check mobile in visible changed here.
    // And this also delay set `innerVisible` to avoid popup component render flash
    (0, $6fFrj.useEffect)(function() {
        serInnerVisible(visible);
        if (visible && mobile) setInMobile((0, $fee6da8402dc892a$export$2e2bcd8739ae039)());
    }, [
        visible,
        mobile
    ]);
    var popupNode = inMobile ? /*#__PURE__*/ $6fFrj.createElement((0, $0c7eb47d3d4f26c0$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, cloneProps, {
        mobile: mobile,
        ref: ref
    })) : /*#__PURE__*/ $6fFrj.createElement((0, $ef26e1827320ca72$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, cloneProps, {
        ref: ref
    })); // We can use fragment directly but this may failed some selector usage. Keep as origin logic
    return /*#__PURE__*/ $6fFrj.createElement("div", null, /*#__PURE__*/ $6fFrj.createElement((0, $00bef2784a16c0d4$export$2e2bcd8739ae039), cloneProps), popupNode);
});
$52e0845e8abdd114$var$Popup.displayName = 'Popup';
var $52e0845e8abdd114$export$2e2bcd8739ae039 = $52e0845e8abdd114$var$Popup;



var $6fFrj = parcelRequire("6fFrj");
var $1f97c559576d2e27$var$TriggerContext = /*#__PURE__*/ $6fFrj.createContext(null);
var $1f97c559576d2e27$export$2e2bcd8739ae039 = $1f97c559576d2e27$var$TriggerContext;


function $2c9abce2aaa5219e$var$noop() {}
function $2c9abce2aaa5219e$var$returnEmptyString() {
    return '';
}
function $2c9abce2aaa5219e$var$returnDocument(element) {
    if (element) return element.ownerDocument;
    return window.document;
}
var $2c9abce2aaa5219e$var$ALL_HANDLERS = [
    'onClick',
    'onMouseDown',
    'onTouchStart',
    'onMouseEnter',
    'onMouseLeave',
    'onFocus',
    'onBlur',
    'onContextMenu'
];
function $2c9abce2aaa5219e$export$55e99723d7f71b47(PortalComponent) {
    var Trigger = /*#__PURE__*/ function(_React$Component) {
        (0, $bxC2Y.default)(Trigger, _React$Component);
        var _super = (0, $lSufv.default)(Trigger);
        // ensure `getContainer` will be called only once
        function Trigger(props) {
            var _this;
            (0, $kjNeN.default)(this, Trigger);
            _this = _super.call(this, props);
            (0, $43449.default)((0, $3mZgl.default)(_this), "popupRef", /*#__PURE__*/ $6fFrj.createRef());
            (0, $43449.default)((0, $3mZgl.default)(_this), "triggerRef", /*#__PURE__*/ $6fFrj.createRef());
            (0, $43449.default)((0, $3mZgl.default)(_this), "portalContainer", void 0);
            (0, $43449.default)((0, $3mZgl.default)(_this), "attachId", void 0);
            (0, $43449.default)((0, $3mZgl.default)(_this), "clickOutsideHandler", void 0);
            (0, $43449.default)((0, $3mZgl.default)(_this), "touchOutsideHandler", void 0);
            (0, $43449.default)((0, $3mZgl.default)(_this), "contextMenuOutsideHandler1", void 0);
            (0, $43449.default)((0, $3mZgl.default)(_this), "contextMenuOutsideHandler2", void 0);
            (0, $43449.default)((0, $3mZgl.default)(_this), "mouseDownTimeout", void 0);
            (0, $43449.default)((0, $3mZgl.default)(_this), "focusTime", void 0);
            (0, $43449.default)((0, $3mZgl.default)(_this), "preClickTime", void 0);
            (0, $43449.default)((0, $3mZgl.default)(_this), "preTouchTime", void 0);
            (0, $43449.default)((0, $3mZgl.default)(_this), "delayTimer", void 0);
            (0, $43449.default)((0, $3mZgl.default)(_this), "hasPopupMouseDown", void 0);
            (0, $43449.default)((0, $3mZgl.default)(_this), "onMouseEnter", function(e) {
                var mouseEnterDelay = _this.props.mouseEnterDelay;
                _this.fireEvents('onMouseEnter', e);
                _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "onMouseMove", function(e) {
                _this.fireEvents('onMouseMove', e);
                _this.setPoint(e);
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "onMouseLeave", function(e) {
                _this.fireEvents('onMouseLeave', e);
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "onPopupMouseEnter", function() {
                _this.clearDelayTimer();
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "onPopupMouseLeave", function(e) {
                var _this$popupRef$curren;
                // https://github.com/react-component/trigger/pull/13
                // react bug?
                if (e.relatedTarget && !e.relatedTarget.setTimeout && (0, $b5cc600be516f1fa$export$2e2bcd8739ae039)((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e.relatedTarget)) return;
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "onFocus", function(e) {
                _this.fireEvents('onFocus', e); // incase focusin and focusout
                _this.clearDelayTimer();
                if (_this.isFocusToShow()) {
                    _this.focusTime = Date.now();
                    _this.delaySetPopupVisible(true, _this.props.focusDelay);
                }
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "onMouseDown", function(e) {
                _this.fireEvents('onMouseDown', e);
                _this.preClickTime = Date.now();
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "onTouchStart", function(e) {
                _this.fireEvents('onTouchStart', e);
                _this.preTouchTime = Date.now();
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "onBlur", function(e) {
                _this.fireEvents('onBlur', e);
                _this.clearDelayTimer();
                if (_this.isBlurToHide()) _this.delaySetPopupVisible(false, _this.props.blurDelay);
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "onContextMenu", function(e) {
                e.preventDefault();
                _this.fireEvents('onContextMenu', e);
                _this.setPopupVisible(true, e);
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "onContextMenuClose", function() {
                if (_this.isContextMenuToShow()) _this.close();
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "onClick", function(event) {
                _this.fireEvents('onClick', event); // focus will trigger click
                if (_this.focusTime) {
                    var preTime;
                    if (_this.preClickTime && _this.preTouchTime) preTime = Math.min(_this.preClickTime, _this.preTouchTime);
                    else if (_this.preClickTime) preTime = _this.preClickTime;
                    else if (_this.preTouchTime) preTime = _this.preTouchTime;
                    if (Math.abs(preTime - _this.focusTime) < 20) return;
                    _this.focusTime = 0;
                }
                _this.preClickTime = 0;
                _this.preTouchTime = 0; // Only prevent default when all the action is click.
                // https://github.com/ant-design/ant-design/issues/17043
                // https://github.com/ant-design/ant-design/issues/17291
                if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) event.preventDefault();
                var nextVisible = !_this.state.popupVisible;
                if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) _this.setPopupVisible(!_this.state.popupVisible, event);
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "onPopupMouseDown", function() {
                _this.hasPopupMouseDown = true;
                clearTimeout(_this.mouseDownTimeout);
                _this.mouseDownTimeout = window.setTimeout(function() {
                    _this.hasPopupMouseDown = false;
                }, 0);
                if (_this.context) {
                    var _this$context;
                    (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
                }
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "onDocumentClick", function(event) {
                if (_this.props.mask && !_this.props.maskClosable) return;
                var target = event.target;
                var root = _this.getRootDomNode();
                var popupNode = _this.getPopupDomNode();
                if (// https://github.com/ant-design/ant-design/issues/29853
                (!(0, $b5cc600be516f1fa$export$2e2bcd8739ae039)(root, target) || _this.isContextMenuOnly()) && !(0, $b5cc600be516f1fa$export$2e2bcd8739ae039)(popupNode, target) && !_this.hasPopupMouseDown) _this.close();
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "getRootDomNode", function() {
                var getTriggerDOMNode = _this.props.getTriggerDOMNode;
                if (getTriggerDOMNode) return getTriggerDOMNode(_this.triggerRef.current);
                try {
                    var domNode = (0, $k5B64.default)(_this.triggerRef.current);
                    if (domNode) return domNode;
                } catch (err) {}
                return (0, (/*@__PURE__*/$parcel$interopDefault($8CZEB))).findDOMNode((0, $3mZgl.default)(_this));
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "getPopupClassNameFromAlign", function(align) {
                var className = [];
                var _this$props = _this.props, popupPlacement = _this$props.popupPlacement, builtinPlacements = _this$props.builtinPlacements, prefixCls = _this$props.prefixCls, alignPoint = _this$props.alignPoint, getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;
                if (popupPlacement && builtinPlacements) className.push((0, $4d04d717f294539c$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, align, alignPoint));
                if (getPopupClassNameFromAlign) className.push(getPopupClassNameFromAlign(align));
                return className.join(' ');
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "getComponent", function() {
                var _this$props2 = _this.props, prefixCls = _this$props2.prefixCls, destroyPopupOnHide = _this$props2.destroyPopupOnHide, popupClassName = _this$props2.popupClassName, onPopupAlign = _this$props2.onPopupAlign, popupMotion = _this$props2.popupMotion, popupAnimation = _this$props2.popupAnimation, popupTransitionName = _this$props2.popupTransitionName, popupStyle = _this$props2.popupStyle, mask = _this$props2.mask, maskAnimation = _this$props2.maskAnimation, maskTransitionName = _this$props2.maskTransitionName, maskMotion = _this$props2.maskMotion, zIndex = _this$props2.zIndex, popup = _this$props2.popup, stretch = _this$props2.stretch, alignPoint = _this$props2.alignPoint, mobile = _this$props2.mobile, forceRender = _this$props2.forceRender, onPopupClick = _this$props2.onPopupClick;
                var _this$state = _this.state, popupVisible = _this$state.popupVisible, point = _this$state.point;
                var align = _this.getPopupAlign();
                var mouseProps = {};
                if (_this.isMouseEnterToShow()) mouseProps.onMouseEnter = _this.onPopupMouseEnter;
                if (_this.isMouseLeaveToHide()) mouseProps.onMouseLeave = _this.onPopupMouseLeave;
                mouseProps.onMouseDown = _this.onPopupMouseDown;
                mouseProps.onTouchStart = _this.onPopupMouseDown;
                return /*#__PURE__*/ $6fFrj.createElement((0, $52e0845e8abdd114$export$2e2bcd8739ae039), (0, $fIrcP.default)({
                    prefixCls: prefixCls,
                    destroyPopupOnHide: destroyPopupOnHide,
                    visible: popupVisible,
                    point: alignPoint && point,
                    className: popupClassName,
                    align: align,
                    onAlign: onPopupAlign,
                    animation: popupAnimation,
                    getClassNameFromAlign: _this.getPopupClassNameFromAlign
                }, mouseProps, {
                    stretch: stretch,
                    getRootDomNode: _this.getRootDomNode,
                    style: popupStyle,
                    mask: mask,
                    zIndex: zIndex,
                    transitionName: popupTransitionName,
                    maskAnimation: maskAnimation,
                    maskTransitionName: maskTransitionName,
                    maskMotion: maskMotion,
                    ref: _this.popupRef,
                    motion: popupMotion,
                    mobile: mobile,
                    forceRender: forceRender,
                    onClick: onPopupClick
                }), typeof popup === 'function' ? popup() : popup);
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "attachParent", function(popupContainer) {
                (0, $hqic8.default).cancel(_this.attachId);
                var _this$props3 = _this.props, getPopupContainer = _this$props3.getPopupContainer, getDocument = _this$props3.getDocument;
                var domNode = _this.getRootDomNode();
                var mountNode;
                if (!getPopupContainer) mountNode = getDocument(_this.getRootDomNode()).body;
                else if (domNode || getPopupContainer.length === 0) // Compatible for legacy getPopupContainer with domNode argument.
                // If no need `domNode` argument, will call directly.
                // https://codesandbox.io/s/eloquent-mclean-ss93m?file=/src/App.js
                mountNode = getPopupContainer(domNode);
                if (mountNode) mountNode.appendChild(popupContainer);
                else // Retry after frame render in case parent not ready
                _this.attachId = (0, $hqic8.default)(function() {
                    _this.attachParent(popupContainer);
                });
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "getContainer", function() {
                if (!_this.portalContainer) {
                    // In React.StrictMode component will call render multiple time in first mount.
                    // When you want to refactor with FC, useRef will also init multiple time and
                    // point to different useRef instance which will create multiple element
                    // (This multiple render will not trigger effect so you can not clean up this
                    // in effect). But this is safe with class component since it always point to same class instance.
                    var getDocument = _this.props.getDocument;
                    var popupContainer = getDocument(_this.getRootDomNode()).createElement('div'); // Make sure default popup container will never cause scrollbar appearing
                    // https://github.com/react-component/trigger/issues/41
                    popupContainer.style.position = 'absolute';
                    popupContainer.style.top = '0';
                    popupContainer.style.left = '0';
                    popupContainer.style.width = '100%';
                    _this.portalContainer = popupContainer;
                }
                _this.attachParent(_this.portalContainer);
                return _this.portalContainer;
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "setPoint", function(point) {
                var alignPoint = _this.props.alignPoint;
                if (!alignPoint || !point) return;
                _this.setState({
                    point: {
                        pageX: point.pageX,
                        pageY: point.pageY
                    }
                });
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "handlePortalUpdate", function() {
                if (_this.state.prevPopupVisible !== _this.state.popupVisible) _this.props.afterPopupVisibleChange(_this.state.popupVisible);
            });
            (0, $43449.default)((0, $3mZgl.default)(_this), "triggerContextValue", {
                onPopupMouseDown: _this.onPopupMouseDown
            });
            var _popupVisible;
            if ('popupVisible' in props) _popupVisible = !!props.popupVisible;
            else _popupVisible = !!props.defaultPopupVisible;
            _this.state = {
                prevPopupVisible: _popupVisible,
                popupVisible: _popupVisible
            };
            $2c9abce2aaa5219e$var$ALL_HANDLERS.forEach(function(h) {
                _this["fire".concat(h)] = function(e) {
                    _this.fireEvents(h, e);
                };
            });
            return _this;
        }
        (0, $5KQxu.default)(Trigger, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.componentDidUpdate();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    var props = this.props;
                    var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
                    // https://github.com/ant-design/ant-design/issues/5804
                    // https://github.com/react-component/calendar/issues/250
                    // https://github.com/react-component/trigger/issues/50
                    if (state.popupVisible) {
                        var currentDocument;
                        if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
                            currentDocument = props.getDocument(this.getRootDomNode());
                            this.clickOutsideHandler = (0, $5184338d6a99a234$export$2e2bcd8739ae039)(currentDocument, 'mousedown', this.onDocumentClick);
                        } // always hide on mobile
                        if (!this.touchOutsideHandler) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.touchOutsideHandler = (0, $5184338d6a99a234$export$2e2bcd8739ae039)(currentDocument, 'touchstart', this.onDocumentClick);
                        } // close popup when trigger type contains 'onContextMenu' and document is scrolling.
                        if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.contextMenuOutsideHandler1 = (0, $5184338d6a99a234$export$2e2bcd8739ae039)(currentDocument, 'scroll', this.onContextMenuClose);
                        } // close popup when trigger type contains 'onContextMenu' and window is blur.
                        if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) this.contextMenuOutsideHandler2 = (0, $5184338d6a99a234$export$2e2bcd8739ae039)(window, 'blur', this.onContextMenuClose);
                        return;
                    }
                    this.clearOutsideHandler();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDelayTimer();
                    this.clearOutsideHandler();
                    clearTimeout(this.mouseDownTimeout);
                    (0, $hqic8.default).cancel(this.attachId);
                }
            },
            {
                key: "getPopupDomNode",
                value: function getPopupDomNode() {
                    var _this$popupRef$curren2;
                    // for test
                    return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
                }
            },
            {
                key: "getPopupAlign",
                value: function getPopupAlign() {
                    var props = this.props;
                    var popupPlacement = props.popupPlacement, popupAlign = props.popupAlign, builtinPlacements = props.builtinPlacements;
                    if (popupPlacement && builtinPlacements) return (0, $4d04d717f294539c$export$44605b74f7c5d944)(builtinPlacements, popupPlacement, popupAlign);
                    return popupAlign;
                }
            },
            {
                key: "setPopupVisible",
                value: /**
       * @param popupVisible    Show or not the popup element
       * @param event           SyntheticEvent, used for `pointAlign`
       */ function setPopupVisible(popupVisible, event) {
                    var alignPoint = this.props.alignPoint;
                    var prevPopupVisible = this.state.popupVisible;
                    this.clearDelayTimer();
                    if (prevPopupVisible !== popupVisible) {
                        if (!('popupVisible' in this.props)) this.setState({
                            popupVisible: popupVisible,
                            prevPopupVisible: prevPopupVisible
                        });
                        this.props.onPopupVisibleChange(popupVisible);
                    } // Always record the point position since mouseEnterDelay will delay the show
                    if (alignPoint && event && popupVisible) this.setPoint(event);
                }
            },
            {
                key: "delaySetPopupVisible",
                value: function delaySetPopupVisible(visible, delayS, event) {
                    var _this2 = this;
                    var delay = delayS * 1000;
                    this.clearDelayTimer();
                    if (delay) {
                        var point = event ? {
                            pageX: event.pageX,
                            pageY: event.pageY
                        } : null;
                        this.delayTimer = window.setTimeout(function() {
                            _this2.setPopupVisible(visible, point);
                            _this2.clearDelayTimer();
                        }, delay);
                    } else this.setPopupVisible(visible, event);
                }
            },
            {
                key: "clearDelayTimer",
                value: function clearDelayTimer() {
                    if (this.delayTimer) {
                        clearTimeout(this.delayTimer);
                        this.delayTimer = null;
                    }
                }
            },
            {
                key: "clearOutsideHandler",
                value: function clearOutsideHandler() {
                    if (this.clickOutsideHandler) {
                        this.clickOutsideHandler.remove();
                        this.clickOutsideHandler = null;
                    }
                    if (this.contextMenuOutsideHandler1) {
                        this.contextMenuOutsideHandler1.remove();
                        this.contextMenuOutsideHandler1 = null;
                    }
                    if (this.contextMenuOutsideHandler2) {
                        this.contextMenuOutsideHandler2.remove();
                        this.contextMenuOutsideHandler2 = null;
                    }
                    if (this.touchOutsideHandler) {
                        this.touchOutsideHandler.remove();
                        this.touchOutsideHandler = null;
                    }
                }
            },
            {
                key: "createTwoChains",
                value: function createTwoChains(event) {
                    var childPros = this.props.children.props;
                    var props = this.props;
                    if (childPros[event] && props[event]) return this["fire".concat(event)];
                    return childPros[event] || props[event];
                }
            },
            {
                key: "isClickToShow",
                value: function isClickToShow() {
                    var _this$props4 = this.props, action = _this$props4.action, showAction = _this$props4.showAction;
                    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
                }
            },
            {
                key: "isContextMenuOnly",
                value: function isContextMenuOnly() {
                    var action = this.props.action;
                    return action === 'contextMenu' || action.length === 1 && action[0] === 'contextMenu';
                }
            },
            {
                key: "isContextMenuToShow",
                value: function isContextMenuToShow() {
                    var _this$props5 = this.props, action = _this$props5.action, showAction = _this$props5.showAction;
                    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
                }
            },
            {
                key: "isClickToHide",
                value: function isClickToHide() {
                    var _this$props6 = this.props, action = _this$props6.action, hideAction = _this$props6.hideAction;
                    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
                }
            },
            {
                key: "isMouseEnterToShow",
                value: function isMouseEnterToShow() {
                    var _this$props7 = this.props, action = _this$props7.action, showAction = _this$props7.showAction;
                    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
                }
            },
            {
                key: "isMouseLeaveToHide",
                value: function isMouseLeaveToHide() {
                    var _this$props8 = this.props, action = _this$props8.action, hideAction = _this$props8.hideAction;
                    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
                }
            },
            {
                key: "isFocusToShow",
                value: function isFocusToShow() {
                    var _this$props9 = this.props, action = _this$props9.action, showAction = _this$props9.showAction;
                    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
                }
            },
            {
                key: "isBlurToHide",
                value: function isBlurToHide() {
                    var _this$props10 = this.props, action = _this$props10.action, hideAction = _this$props10.hideAction;
                    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
                }
            },
            {
                key: "forcePopupAlign",
                value: function forcePopupAlign() {
                    if (this.state.popupVisible) {
                        var _this$popupRef$curren3;
                        (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 || _this$popupRef$curren3.forceAlign();
                    }
                }
            },
            {
                key: "fireEvents",
                value: function fireEvents(type, e) {
                    var childCallback = this.props.children.props[type];
                    if (childCallback) childCallback(e);
                    var callback = this.props[type];
                    if (callback) callback(e);
                }
            },
            {
                key: "close",
                value: function close() {
                    this.setPopupVisible(false);
                }
            },
            {
                key: "render",
                value: function render() {
                    var popupVisible = this.state.popupVisible;
                    var _this$props11 = this.props, children = _this$props11.children, forceRender = _this$props11.forceRender, alignPoint = _this$props11.alignPoint, className = _this$props11.className, autoDestroy = _this$props11.autoDestroy;
                    var child = $6fFrj.Children.only(children);
                    var newChildProps = {
                        key: 'trigger'
                    }; // ============================== Visible Handlers ==============================
                    // >>> ContextMenu
                    if (this.isContextMenuToShow()) newChildProps.onContextMenu = this.onContextMenu;
                    else newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
                     // >>> Click
                    if (this.isClickToHide() || this.isClickToShow()) {
                        newChildProps.onClick = this.onClick;
                        newChildProps.onMouseDown = this.onMouseDown;
                        newChildProps.onTouchStart = this.onTouchStart;
                    } else {
                        newChildProps.onClick = this.createTwoChains('onClick');
                        newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
                        newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
                    } // >>> Hover(enter)
                    if (this.isMouseEnterToShow()) {
                        newChildProps.onMouseEnter = this.onMouseEnter; // Point align
                        if (alignPoint) newChildProps.onMouseMove = this.onMouseMove;
                    } else newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
                     // >>> Hover(leave)
                    if (this.isMouseLeaveToHide()) newChildProps.onMouseLeave = this.onMouseLeave;
                    else newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
                     // >>> Focus
                    if (this.isFocusToShow() || this.isBlurToHide()) {
                        newChildProps.onFocus = this.onFocus;
                        newChildProps.onBlur = this.onBlur;
                    } else {
                        newChildProps.onFocus = this.createTwoChains('onFocus');
                        newChildProps.onBlur = this.createTwoChains('onBlur');
                    } // =================================== Render ===================================
                    var childrenClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(child && child.props && child.props.className, className);
                    if (childrenClassName) newChildProps.className = childrenClassName;
                    var cloneProps = (0, $kNxFX.default)({}, newChildProps);
                    if ((0, $3BOWT.supportRef)(child)) cloneProps.ref = (0, $3BOWT.composeRef)(this.triggerRef, child.ref);
                    var trigger = /*#__PURE__*/ $6fFrj.cloneElement(child, cloneProps);
                    var portal; // prevent unmounting after it's rendered
                    if (popupVisible || this.popupRef.current || forceRender) portal = /*#__PURE__*/ $6fFrj.createElement(PortalComponent, {
                        key: "portal",
                        getContainer: this.getContainer,
                        didUpdate: this.handlePortalUpdate
                    }, this.getComponent());
                    if (!popupVisible && autoDestroy) portal = null;
                    return /*#__PURE__*/ $6fFrj.createElement((0, $1f97c559576d2e27$export$2e2bcd8739ae039).Provider, {
                        value: this.triggerContextValue
                    }, trigger, portal);
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref, prevState) {
                    var popupVisible = _ref.popupVisible;
                    var newState = {};
                    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
                        newState.popupVisible = popupVisible;
                        newState.prevPopupVisible = prevState.popupVisible;
                    }
                    return newState;
                }
            }
        ]);
        return Trigger;
    }($6fFrj.Component);
    (0, $43449.default)(Trigger, "contextType", (0, $1f97c559576d2e27$export$2e2bcd8739ae039));
    (0, $43449.default)(Trigger, "defaultProps", {
        prefixCls: 'rc-trigger-popup',
        getPopupClassNameFromAlign: $2c9abce2aaa5219e$var$returnEmptyString,
        getDocument: $2c9abce2aaa5219e$var$returnDocument,
        onPopupVisibleChange: $2c9abce2aaa5219e$var$noop,
        afterPopupVisibleChange: $2c9abce2aaa5219e$var$noop,
        onPopupAlign: $2c9abce2aaa5219e$var$noop,
        popupClassName: '',
        mouseEnterDelay: 0,
        mouseLeaveDelay: 0.1,
        focusDelay: 0,
        blurDelay: 0.15,
        popupStyle: {},
        destroyPopupOnHide: false,
        popupAlign: {},
        defaultPopupVisible: false,
        mask: false,
        maskClosable: true,
        action: [],
        showAction: [],
        hideAction: [],
        autoDestroy: false
    });
    return Trigger;
}
var $2c9abce2aaa5219e$export$2e2bcd8739ae039 = $2c9abce2aaa5219e$export$55e99723d7f71b47((0, $a87dbe925d56f62d$export$2e2bcd8739ae039));


var $de36959db23b6324$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $de36959db23b6324$var$targetOffset = [
    0,
    0
];
var $de36959db23b6324$export$803cd8101b6c182b = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        overflow: $de36959db23b6324$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $de36959db23b6324$var$targetOffset
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        overflow: $de36959db23b6324$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $de36959db23b6324$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $de36959db23b6324$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $de36959db23b6324$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $de36959db23b6324$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $de36959db23b6324$var$targetOffset
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $de36959db23b6324$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $de36959db23b6324$var$targetOffset
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $de36959db23b6324$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $de36959db23b6324$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $de36959db23b6324$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $de36959db23b6324$var$targetOffset
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $de36959db23b6324$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $de36959db23b6324$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $de36959db23b6324$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $de36959db23b6324$var$targetOffset
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $de36959db23b6324$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $de36959db23b6324$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $de36959db23b6324$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $de36959db23b6324$var$targetOffset
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $de36959db23b6324$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $de36959db23b6324$var$targetOffset
    }
};
var $de36959db23b6324$export$2e2bcd8739ae039 = $de36959db23b6324$export$803cd8101b6c182b;



var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");
function $c5b895ed839422b2$export$2e2bcd8739ae039(props) {
    var showArrow = props.showArrow, arrowContent = props.arrowContent, children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style = props.style;
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-content"), className),
        style: style
    }, showArrow !== false && /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-arrow"),
        key: "arrow"
    }, arrowContent), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-inner"),
        id: id,
        role: "tooltip",
        style: overlayInnerStyle
    }, typeof children === 'function' ? children() : children));
}


var $48684719bc168c02$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        'hover'
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? 'right' : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, showArrow = props.showArrow, restProps = (0, $04RxA.default)(props, [
        "overlayClassName",
        "trigger",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayStyle",
        "prefixCls",
        "children",
        "onVisibleChange",
        "afterVisibleChange",
        "transitionName",
        "animation",
        "motion",
        "placement",
        "align",
        "destroyTooltipOnHide",
        "defaultVisible",
        "getTooltipContainer",
        "overlayInnerStyle",
        "arrowContent",
        "overlay",
        "id",
        "showArrow"
    ]);
    var domRef = (0, $6fFrj.useRef)(null);
    (0, $6fFrj.useImperativeHandle)(ref, function() {
        return domRef.current;
    });
    var extraProps = (0, $kNxFX.default)({}, restProps);
    if ('visible' in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $6fFrj.createElement((0, $c5b895ed839422b2$export$2e2bcd8739ae039), {
            showArrow: showArrow,
            arrowContent: arrowContent,
            key: "content",
            prefixCls: prefixCls,
            id: id,
            overlayInnerStyle: overlayInnerStyle
        }, overlay);
    };
    var destroyTooltip = false;
    var autoDestroy = false;
    if (typeof destroyTooltipOnHide === 'boolean') destroyTooltip = destroyTooltipOnHide;
    else if (destroyTooltipOnHide && (0, $5KhTJ.default)(destroyTooltipOnHide) === 'object') {
        var keepParent = destroyTooltipOnHide.keepParent;
        destroyTooltip = keepParent === true;
        autoDestroy = keepParent === false;
    }
    return /*#__PURE__*/ $6fFrj.createElement((0, $2c9abce2aaa5219e$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        popupClassName: overlayClassName,
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $de36959db23b6324$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: domRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltip,
        autoDestroy: autoDestroy,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
    }, extraProps), children);
};
var $48684719bc168c02$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $6fFrj.forwardRef)($48684719bc168c02$var$Tooltip);



var $23abdb423fb5af3b$export$2e2bcd8739ae039 = (0, $48684719bc168c02$export$2e2bcd8739ae039);



var $gfhff = parcelRequire("gfhff");

var $6fFrj = parcelRequire("6fFrj");


var $b43ce6bf43415109$export$bb684163c94c55ae = (0, $cacd97b96801cebe$export$65e3907585753458)('success', 'processing', 'error', 'default', 'warning');
var $b43ce6bf43415109$export$37ea70cc324d3d0e = (0, $cacd97b96801cebe$export$65e3907585753458)('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');




var $fIrcP = parcelRequire("fIrcP");

var $d37ba5a2b0fdef06$var$autoAdjustOverflowEnabled = {
    adjustX: 1,
    adjustY: 1
};
var $d37ba5a2b0fdef06$var$autoAdjustOverflowDisabled = {
    adjustX: 0,
    adjustY: 0
};
var $d37ba5a2b0fdef06$var$targetOffset = [
    0,
    0
];
function $d37ba5a2b0fdef06$export$fde75e5b410c093f(autoAdjustOverflow) {
    if (typeof autoAdjustOverflow === 'boolean') return autoAdjustOverflow ? $d37ba5a2b0fdef06$var$autoAdjustOverflowEnabled : $d37ba5a2b0fdef06$var$autoAdjustOverflowDisabled;
    return (0, $fIrcP.default)((0, $fIrcP.default)({}, $d37ba5a2b0fdef06$var$autoAdjustOverflowDisabled), autoAdjustOverflow);
}
function $d37ba5a2b0fdef06$export$2e2bcd8739ae039(config) {
    var _config$arrowWidth = config.arrowWidth, arrowWidth = _config$arrowWidth === void 0 ? 4 : _config$arrowWidth, _config$horizontalArr = config.horizontalArrowShift, horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr, _config$verticalArrow = config.verticalArrowShift, verticalArrowShift = _config$verticalArrow === void 0 ? 8 : _config$verticalArrow, autoAdjustOverflow = config.autoAdjustOverflow, arrowPointAtCenter = config.arrowPointAtCenter;
    var placementMap = {
        left: {
            points: [
                'cr',
                'cl'
            ],
            offset: [
                -4,
                0
            ]
        },
        right: {
            points: [
                'cl',
                'cr'
            ],
            offset: [
                4,
                0
            ]
        },
        top: {
            points: [
                'bc',
                'tc'
            ],
            offset: [
                0,
                -4
            ]
        },
        bottom: {
            points: [
                'tc',
                'bc'
            ],
            offset: [
                0,
                4
            ]
        },
        topLeft: {
            points: [
                'bl',
                'tc'
            ],
            offset: [
                -(horizontalArrowShift + arrowWidth),
                -4
            ]
        },
        leftTop: {
            points: [
                'tr',
                'cl'
            ],
            offset: [
                -4,
                -(verticalArrowShift + arrowWidth)
            ]
        },
        topRight: {
            points: [
                'br',
                'tc'
            ],
            offset: [
                horizontalArrowShift + arrowWidth,
                -4
            ]
        },
        rightTop: {
            points: [
                'tl',
                'cr'
            ],
            offset: [
                4,
                -(verticalArrowShift + arrowWidth)
            ]
        },
        bottomRight: {
            points: [
                'tr',
                'bc'
            ],
            offset: [
                horizontalArrowShift + arrowWidth,
                4
            ]
        },
        rightBottom: {
            points: [
                'bl',
                'cr'
            ],
            offset: [
                4,
                verticalArrowShift + arrowWidth
            ]
        },
        bottomLeft: {
            points: [
                'tl',
                'bc'
            ],
            offset: [
                -(horizontalArrowShift + arrowWidth),
                4
            ]
        },
        leftBottom: {
            points: [
                'br',
                'cl'
            ],
            offset: [
                -4,
                verticalArrowShift + arrowWidth
            ]
        }
    };
    Object.keys(placementMap).forEach(function(key) {
        placementMap[key] = arrowPointAtCenter ? (0, $fIrcP.default)((0, $fIrcP.default)({}, placementMap[key]), {
            overflow: $d37ba5a2b0fdef06$export$fde75e5b410c093f(autoAdjustOverflow),
            targetOffset: $d37ba5a2b0fdef06$var$targetOffset
        }) : (0, $fIrcP.default)((0, $fIrcP.default)({}, (0, $de36959db23b6324$export$803cd8101b6c182b)[key]), {
            overflow: $d37ba5a2b0fdef06$export$fde75e5b410c093f(autoAdjustOverflow)
        });
        placementMap[key].ignoreShake = true;
    });
    return placementMap;
}




var $fd177f0fd45f56a6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fd177f0fd45f56a6$var$splitObject = function splitObject(obj, keys) {
    var picked = {};
    var omitted = (0, $fIrcP.default)({}, obj);
    keys.forEach(function(key) {
        if (obj && key in obj) {
            picked[key] = obj[key];
            delete omitted[key];
        }
    });
    return {
        picked: picked,
        omitted: omitted
    };
};
var $fd177f0fd45f56a6$var$PresetColorRegex = new RegExp("^(".concat((0, $b43ce6bf43415109$export$37ea70cc324d3d0e).join('|'), ")(-inverse)?$"));
// Fix Tooltip won't hide at disabled button
// mouse events don't trigger at disabled button in Chrome
// https://github.com/react-component/tooltip/issues/18
function $fd177f0fd45f56a6$var$getDisabledCompatibleChildren(element, prefixCls) {
    var elementType = element.type;
    if ((elementType.__ANT_BUTTON === true || element.type === 'button') && element.props.disabled || elementType.__ANT_SWITCH === true && (element.props.disabled || element.props.loading) || elementType.__ANT_RADIO === true && element.props.disabled) {
        // Pick some layout related style properties up to span
        // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
        var _splitObject = $fd177f0fd45f56a6$var$splitObject(element.props.style, [
            'position',
            'left',
            'right',
            'top',
            'bottom',
            'float',
            'display',
            'zIndex'
        ]), picked = _splitObject.picked, omitted = _splitObject.omitted;
        var spanStyle = (0, $fIrcP.default)((0, $fIrcP.default)({
            display: 'inline-block'
        }, picked), {
            cursor: 'not-allowed',
            width: element.props.block ? '100%' : undefined
        });
        var buttonStyle = (0, $fIrcP.default)((0, $fIrcP.default)({}, omitted), {
            pointerEvents: 'none'
        });
        var child = (0, $79365009d9b77ac6$export$e530037191fcd5d7)(element, {
            style: buttonStyle,
            className: null
        });
        return /*#__PURE__*/ $6fFrj.createElement("span", {
            style: spanStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(element.props.className, "".concat(prefixCls, "-disabled-compatible-wrapper"))
        }, child);
    }
    return element;
}
var $fd177f0fd45f56a6$var$Tooltip = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var _useMergedState = (0, $gfhff.default)(false, {
        value: props.open !== undefined ? props.open : props.visible,
        defaultValue: props.defaultOpen !== undefined ? props.defaultOpen : props.defaultVisible
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), open = _useMergedState2[0], setOpen = _useMergedState2[1];
    var isNoTitle = function isNoTitle() {
        var title = props.title, overlay = props.overlay;
        return !title && !overlay && title !== 0; // overlay for old version compatibility
    };
    var onOpenChange = function onOpenChange(vis) {
        var _a, _b;
        setOpen(isNoTitle() ? false : vis);
        if (!isNoTitle()) {
            (_a = props.onOpenChange) === null || _a === void 0 || _a.call(props, vis);
            (_b = props.onVisibleChange) === null || _b === void 0 || _b.call(props, vis);
        }
    };
    var getTooltipPlacements = function getTooltipPlacements() {
        var builtinPlacements = props.builtinPlacements, _props$arrowPointAtCe = props.arrowPointAtCenter, arrowPointAtCenter = _props$arrowPointAtCe === void 0 ? false : _props$arrowPointAtCe, _props$autoAdjustOver = props.autoAdjustOverflow, autoAdjustOverflow = _props$autoAdjustOver === void 0 ? true : _props$autoAdjustOver;
        return builtinPlacements || (0, $d37ba5a2b0fdef06$export$2e2bcd8739ae039)({
            arrowPointAtCenter: arrowPointAtCenter,
            autoAdjustOverflow: autoAdjustOverflow
        });
    };
    // 动态设置动画点
    var onPopupAlign = function onPopupAlign(domNode, align) {
        var placements = getTooltipPlacements();
        // 当前返回的位置
        var placement = Object.keys(placements).find(function(key) {
            var _a, _b;
            return placements[key].points[0] === ((_a = align.points) === null || _a === void 0 ? void 0 : _a[0]) && placements[key].points[1] === ((_b = align.points) === null || _b === void 0 ? void 0 : _b[1]);
        });
        if (!placement) return;
        // 根据当前坐标设置动画点
        var rect = domNode.getBoundingClientRect();
        var transformOrigin = {
            top: '50%',
            left: '50%'
        };
        if (/top|Bottom/.test(placement)) transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
        else if (/Top|bottom/.test(placement)) transformOrigin.top = "".concat(-align.offset[1], "px");
        if (/left|Right/.test(placement)) transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
        else if (/right|Left/.test(placement)) transformOrigin.left = "".concat(-align.offset[0], "px");
        domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
    };
    var getOverlay = function getOverlay() {
        var title = props.title, overlay = props.overlay;
        if (title === 0) return title;
        return overlay || title || '';
    };
    var getPopupContainer = props.getPopupContainer, _props$placement = props.placement, placement = _props$placement === void 0 ? 'top' : _props$placement, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0.1 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, otherProps = $fd177f0fd45f56a6$var$__rest(props, [
        "getPopupContainer",
        "placement",
        "mouseEnterDelay",
        "mouseLeaveDelay"
    ]);
    var customizePrefixCls = props.prefixCls, openClassName = props.openClassName, getTooltipContainer = props.getTooltipContainer, overlayClassName = props.overlayClassName, color = props.color, overlayInnerStyle = props.overlayInnerStyle, children = props.children;
    var prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var tempOpen = open;
    // Hide tooltip when there is no title
    if (!('open' in props) && !('visible' in props) && isNoTitle()) tempOpen = false;
    var child = $fd177f0fd45f56a6$var$getDisabledCompatibleChildren((0, $79365009d9b77ac6$export$a8257692ac88316c)(children) && !(0, $79365009d9b77ac6$export$9522e17588c12572)(children) ? children : /*#__PURE__*/ $6fFrj.createElement("span", null, children), prefixCls);
    var childProps = child.props;
    var childCls = !childProps.className || typeof childProps.className === 'string' ? (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(childProps.className, (0, $43449.default)({}, openClassName || "".concat(prefixCls, "-open"), true)) : childProps.className;
    var customOverlayClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(overlayClassName, (0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-").concat(color), color && $fd177f0fd45f56a6$var$PresetColorRegex.test(color)));
    var formattedOverlayInnerStyle = overlayInnerStyle;
    var arrowContentStyle = {};
    if (color && !$fd177f0fd45f56a6$var$PresetColorRegex.test(color)) {
        formattedOverlayInnerStyle = (0, $fIrcP.default)((0, $fIrcP.default)({}, overlayInnerStyle), {
            background: color
        });
        // @ts-ignore
        arrowContentStyle = {
            '--antd-arrow-background-color': color
        };
    }
    return /*#__PURE__*/ $6fFrj.createElement((0, $23abdb423fb5af3b$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, otherProps, {
        placement: placement,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        prefixCls: prefixCls,
        overlayClassName: customOverlayClassName,
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: ref,
        builtinPlacements: getTooltipPlacements(),
        overlay: getOverlay(),
        visible: tempOpen,
        onVisibleChange: onOpenChange,
        onPopupAlign: onPopupAlign,
        overlayInnerStyle: formattedOverlayInnerStyle,
        arrowContent: /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-arrow-content"),
            style: arrowContentStyle
        }),
        motion: {
            motionName: (0, $779588b2444df86c$export$27c72201b1d09951)(rootPrefixCls, 'zoom-big-fast', props.transitionName),
            motionDeadline: 1000
        }
    }), tempOpen ? (0, $79365009d9b77ac6$export$e530037191fcd5d7)(child, {
        className: childCls
    }) : child);
});
var $fd177f0fd45f56a6$export$2e2bcd8739ae039 = $fd177f0fd45f56a6$var$Tooltip;


var $1eeb7f423c3f3d14$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1eeb7f423c3f3d14$var$Overlay = function Overlay(_ref) {
    var title = _ref.title, content = _ref.content, prefixCls = _ref.prefixCls;
    return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, title && /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-title")
    }, (0, $fc871912853a3dce$export$15e5fca53711d340)(title)), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-inner-content")
    }, (0, $fc871912853a3dce$export$15e5fca53711d340)(content)));
};
var $1eeb7f423c3f3d14$var$Popover = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, title = props.title, content = props.content, _overlay = props._overlay, _props$placement = props.placement, placement = _props$placement === void 0 ? 'top' : _props$placement, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? 'hover' : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0.1 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, _props$overlayStyle = props.overlayStyle, overlayStyle = _props$overlayStyle === void 0 ? {} : _props$overlayStyle, otherProps = $1eeb7f423c3f3d14$var$__rest(props, [
        "prefixCls",
        "title",
        "content",
        "_overlay",
        "placement",
        "trigger",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayStyle"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('popover', customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var mergedOverlay = $6fFrj.useMemo(function() {
        if (_overlay) return _overlay;
        if (!title && !content) return null;
        return /*#__PURE__*/ $6fFrj.createElement($1eeb7f423c3f3d14$var$Overlay, {
            prefixCls: prefixCls,
            title: title,
            content: content
        });
    }, [
        _overlay,
        title,
        content,
        prefixCls
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        placement: placement,
        trigger: trigger,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        overlayStyle: overlayStyle
    }, otherProps, {
        prefixCls: prefixCls,
        ref: ref,
        overlay: mergedOverlay,
        transitionName: (0, $779588b2444df86c$export$27c72201b1d09951)(rootPrefixCls, 'zoom-big', otherProps.transitionName)
    }));
});
var $1eeb7f423c3f3d14$export$2e2bcd8739ae039 = $1eeb7f423c3f3d14$var$Popover;





var $6914915fb84d37b2$var$Group = function Group(props) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, maxCount = props.maxCount, maxStyle = props.maxStyle, size = props.size;
    var prefixCls = getPrefixCls('avatar-group', customizePrefixCls);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    var children = props.children, _props$maxPopoverPlac = props.maxPopoverPlacement, maxPopoverPlacement = _props$maxPopoverPlac === void 0 ? 'top' : _props$maxPopoverPlac, _props$maxPopoverTrig = props.maxPopoverTrigger, maxPopoverTrigger = _props$maxPopoverTrig === void 0 ? 'hover' : _props$maxPopoverTrig;
    var childrenWithProps = (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(children).map(function(child, index) {
        return (0, $79365009d9b77ac6$export$e530037191fcd5d7)(child, {
            key: "avatar-key-".concat(index)
        });
    });
    var numOfChildren = childrenWithProps.length;
    if (maxCount && maxCount < numOfChildren) {
        var childrenShow = childrenWithProps.slice(0, maxCount);
        var childrenHidden = childrenWithProps.slice(maxCount, numOfChildren);
        childrenShow.push(/*#__PURE__*/ $6fFrj.createElement((0, $1eeb7f423c3f3d14$export$2e2bcd8739ae039), {
            key: "avatar-popover-key",
            content: childrenHidden,
            trigger: maxPopoverTrigger,
            placement: maxPopoverPlacement,
            overlayClassName: "".concat(prefixCls, "-popover")
        }, /*#__PURE__*/ $6fFrj.createElement((0, $422f183daa56b489$export$2e2bcd8739ae039), {
            style: maxStyle
        }, "+".concat(numOfChildren - maxCount))));
        return /*#__PURE__*/ $6fFrj.createElement((0, $8be80b6dadc13335$export$dbc92d89fabc8ebe), {
            size: size
        }, /*#__PURE__*/ $6fFrj.createElement("div", {
            className: cls,
            style: props.style
        }, childrenShow));
    }
    return /*#__PURE__*/ $6fFrj.createElement((0, $8be80b6dadc13335$export$dbc92d89fabc8ebe), {
        size: size
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: cls,
        style: props.style
    }, childrenWithProps));
};
var $6914915fb84d37b2$export$2e2bcd8739ae039 = $6914915fb84d37b2$var$Group;


var $1089f078d9068e78$var$Avatar = (0, $422f183daa56b489$export$2e2bcd8739ae039);
$1089f078d9068e78$var$Avatar.Group = (0, $6914915fb84d37b2$export$2e2bcd8739ae039);
var $1089f078d9068e78$export$2e2bcd8739ae039 = $1089f078d9068e78$var$Avatar;


var $43449 = parcelRequire("43449");

var $5KhTJ = parcelRequire("5KhTJ");

var $fIrcP = parcelRequire("fIrcP");

var $fActo = parcelRequire("fActo");

var $5EVeC = parcelRequire("5EVeC");

var $6fFrj = parcelRequire("6fFrj");



var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");


function $195c8e183a479c17$export$ee62ebd6a58c4884(color) {
    return (0, $b43ce6bf43415109$export$37ea70cc324d3d0e).includes(color);
}


var $3243ad3f3709cd69$var$Ribbon = function Ribbon(_ref) {
    var className = _ref.className, customizePrefixCls = _ref.prefixCls, style = _ref.style, color = _ref.color, children = _ref.children, text = _ref.text, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'end' : _ref$placement;
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var prefixCls = getPrefixCls('ribbon', customizePrefixCls);
    var colorInPreset = (0, $195c8e183a479c17$export$ee62ebd6a58c4884)(color);
    var ribbonCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-placement-").concat(placement), (0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-color-").concat(color), colorInPreset), className);
    var colorStyle = {};
    var cornerColorStyle = {};
    if (color && !colorInPreset) {
        colorStyle.background = color;
        cornerColorStyle.color = color;
    }
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-wrapper")
    }, children, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: ribbonCls,
        style: (0, $fIrcP.default)((0, $fIrcP.default)({}, colorStyle), style)
    }, /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-text")
    }, text), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-corner"),
        style: cornerColorStyle
    })));
};
var $3243ad3f3709cd69$export$2e2bcd8739ae039 = $3243ad3f3709cd69$var$Ribbon;



var $fIrcP = parcelRequire("fIrcP");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");



var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");
function $9afdfa7f2f5d9693$var$UnitNumber(_ref) {
    var prefixCls = _ref.prefixCls, value = _ref.value, current = _ref.current, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? 0 : _ref$offset;
    var style;
    if (offset) style = {
        position: 'absolute',
        top: "".concat(offset, "00%"),
        left: 0
    };
    return /*#__PURE__*/ $6fFrj.createElement("span", {
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-only-unit"), {
            current: current
        })
    }, value);
}
function $9afdfa7f2f5d9693$var$getOffset(start, end, unit) {
    var index = start;
    var offset = 0;
    while((index + 10) % 10 !== end){
        index += unit;
        offset += unit;
    }
    return offset;
}
function $9afdfa7f2f5d9693$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, originCount = props.count, originValue = props.value;
    var value = Number(originValue);
    var count = Math.abs(originCount);
    var _React$useState = $6fFrj.useState(value), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), prevValue = _React$useState2[0], setPrevValue = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState(count), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), prevCount = _React$useState4[0], setPrevCount = _React$useState4[1];
    // ============================= Events =============================
    var onTransitionEnd = function onTransitionEnd() {
        setPrevValue(value);
        setPrevCount(count);
    };
    // Fallback if transition event not support
    $6fFrj.useEffect(function() {
        var timeout = setTimeout(function() {
            onTransitionEnd();
        }, 1000);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        value
    ]);
    // ============================= Render =============================
    // Render unit list
    var unitNodes;
    var offsetStyle;
    if (prevValue === value || Number.isNaN(value) || Number.isNaN(prevValue)) {
        // Nothing to change
        unitNodes = [
            /*#__PURE__*/ $6fFrj.createElement($9afdfa7f2f5d9693$var$UnitNumber, (0, $fIrcP.default)({}, props, {
                key: value,
                current: true
            }))
        ];
        offsetStyle = {
            transition: 'none'
        };
    } else {
        unitNodes = [];
        // Fill basic number units
        var end = value + 10;
        var unitNumberList = [];
        for(var index = value; index <= end; index += 1)unitNumberList.push(index);
        // Fill with number unit nodes
        var prevIndex = unitNumberList.findIndex(function(n) {
            return n % 10 === prevValue;
        });
        unitNodes = unitNumberList.map(function(n, index) {
            var singleUnit = n % 10;
            return /*#__PURE__*/ $6fFrj.createElement($9afdfa7f2f5d9693$var$UnitNumber, (0, $fIrcP.default)({}, props, {
                key: n,
                value: singleUnit,
                offset: index - prevIndex,
                current: index === prevIndex
            }));
        });
        // Calculate container offset value
        var unit = prevCount < count ? 1 : -1;
        offsetStyle = {
            transform: "translateY(".concat(-$9afdfa7f2f5d9693$var$getOffset(prevValue, value, unit), "00%)")
        };
    }
    return /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-only"),
        style: offsetStyle,
        onTransitionEnd: onTransitionEnd
    }, unitNodes);
}


var $4d00b8b00c0c1e34$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4d00b8b00c0c1e34$var$ScrollNumber = function ScrollNumber(_a) {
    var customizePrefixCls = _a.prefixCls, count = _a.count, className = _a.className, motionClassName = _a.motionClassName, style = _a.style, title = _a.title, show = _a.show, _a$component = _a.component, component = _a$component === void 0 ? 'sup' : _a$component, children = _a.children, restProps = $4d00b8b00c0c1e34$var$__rest(_a, [
        "prefixCls",
        "count",
        "className",
        "motionClassName",
        "style",
        "title",
        "show",
        "component",
        "children"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('scroll-number', customizePrefixCls);
    // ============================ Render ============================
    var newProps = (0, $fIrcP.default)((0, $fIrcP.default)({}, restProps), {
        'data-show': show,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className, motionClassName),
        title: title
    });
    // Only integer need motion
    var numberNodes = count;
    if (count && Number(count) % 1 === 0) {
        var numberList = String(count).split('');
        numberNodes = numberList.map(function(num, i) {
            return /*#__PURE__*/ $6fFrj.createElement((0, $9afdfa7f2f5d9693$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                count: Number(count),
                value: num,
                // eslint-disable-next-line react/no-array-index-key
                key: numberList.length - i
            });
        });
    }
    // allow specify the border
    // mock border-color by box-shadow for compatible with old usage:
    // <Badge count={4} style={{ backgroundColor: '#fff', color: '#999', borderColor: '#d9d9d9' }} />
    if (style && style.borderColor) newProps.style = (0, $fIrcP.default)((0, $fIrcP.default)({}, style), {
        boxShadow: "0 0 0 1px ".concat(style.borderColor, " inset")
    });
    if (children) return (0, $79365009d9b77ac6$export$e530037191fcd5d7)(children, function(oriProps) {
        return {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-custom-component"), oriProps === null || oriProps === void 0 ? void 0 : oriProps.className, motionClassName)
        };
    });
    return /*#__PURE__*/ $6fFrj.createElement(component, newProps, numberNodes);
};
var $4d00b8b00c0c1e34$export$2e2bcd8739ae039 = $4d00b8b00c0c1e34$var$ScrollNumber;



var $0e541b76c0e3ec69$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0e541b76c0e3ec69$var$Badge = function Badge(_a) {
    var customizePrefixCls = _a.prefixCls, customizeScrollNumberPrefixCls = _a.scrollNumberPrefixCls, children = _a.children, status = _a.status, text = _a.text, color = _a.color, _a$count = _a.count, count = _a$count === void 0 ? null : _a$count, _a$overflowCount = _a.overflowCount, overflowCount = _a$overflowCount === void 0 ? 99 : _a$overflowCount, _a$dot = _a.dot, dot = _a$dot === void 0 ? false : _a$dot, _a$size = _a.size, size = _a$size === void 0 ? 'default' : _a$size, title = _a.title, offset = _a.offset, style = _a.style, className = _a.className, _a$showZero = _a.showZero, showZero = _a$showZero === void 0 ? false : _a$showZero, restProps = $0e541b76c0e3ec69$var$__rest(_a, [
        "prefixCls",
        "scrollNumberPrefixCls",
        "children",
        "status",
        "text",
        "color",
        "count",
        "overflowCount",
        "dot",
        "size",
        "title",
        "offset",
        "style",
        "className",
        "showZero"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var prefixCls = getPrefixCls('badge', customizePrefixCls);
    // ================================ Misc ================================
    var numberedDisplayCount = count > overflowCount ? "".concat(overflowCount, "+") : count;
    var isZero = numberedDisplayCount === '0' || numberedDisplayCount === 0;
    var ignoreCount = count === null || isZero && !showZero;
    var hasStatus = (status !== null && status !== undefined || color !== null && color !== undefined) && ignoreCount;
    var showAsDot = dot && !isZero;
    var mergedCount = showAsDot ? '' : numberedDisplayCount;
    var isHidden = (0, $6fFrj.useMemo)(function() {
        var isEmpty = mergedCount === null || mergedCount === undefined || mergedCount === '';
        return (isEmpty || isZero && !showZero) && !showAsDot;
    }, [
        mergedCount,
        isZero,
        showZero,
        showAsDot
    ]);
    // Count should be cache in case hidden change it
    var countRef = (0, $6fFrj.useRef)(count);
    if (!isHidden) countRef.current = count;
    var livingCount = countRef.current;
    // We need cache count since remove motion should not change count display
    var displayCountRef = (0, $6fFrj.useRef)(mergedCount);
    if (!isHidden) displayCountRef.current = mergedCount;
    var displayCount = displayCountRef.current;
    // We will cache the dot status to avoid shaking on leaved motion
    var isDotRef = (0, $6fFrj.useRef)(showAsDot);
    if (!isHidden) isDotRef.current = showAsDot;
    // =============================== Styles ===============================
    var mergedStyle = (0, $6fFrj.useMemo)(function() {
        if (!offset) return (0, $fIrcP.default)({}, style);
        var offsetStyle = {
            marginTop: offset[1]
        };
        if (direction === 'rtl') offsetStyle.left = parseInt(offset[0], 10);
        else offsetStyle.right = -parseInt(offset[0], 10);
        return (0, $fIrcP.default)((0, $fIrcP.default)({}, offsetStyle), style);
    }, [
        direction,
        offset,
        style
    ]);
    // =============================== Render ===============================
    // >>> Title
    var titleNode = title !== null && title !== void 0 ? title : typeof livingCount === 'string' || typeof livingCount === 'number' ? livingCount : undefined;
    // >>> Status Text
    var statusTextNode = isHidden || !text ? null : /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-status-text")
    }, text);
    // >>> Display Component
    var displayNode = !livingCount || (0, $5KhTJ.default)(livingCount) !== 'object' ? undefined : (0, $79365009d9b77ac6$export$e530037191fcd5d7)(livingCount, function(oriProps) {
        return {
            style: (0, $fIrcP.default)((0, $fIrcP.default)({}, mergedStyle), oriProps.style)
        };
    });
    // Shared styles
    var statusCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-status-dot"), hasStatus), "".concat(prefixCls, "-status-").concat(status), !!status), "".concat(prefixCls, "-status-").concat(color), (0, $195c8e183a479c17$export$ee62ebd6a58c4884)(color)));
    var statusStyle = {};
    if (color && !(0, $195c8e183a479c17$export$ee62ebd6a58c4884)(color)) statusStyle.background = color;
    var badgeClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-status"), hasStatus), "".concat(prefixCls, "-not-a-wrapper"), !children), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    // <Badge status="success" />
    if (!children && hasStatus) {
        var statusTextColor = mergedStyle.color;
        return /*#__PURE__*/ $6fFrj.createElement("span", (0, $fIrcP.default)({}, restProps, {
            className: badgeClassName,
            style: mergedStyle
        }), /*#__PURE__*/ $6fFrj.createElement("span", {
            className: statusCls,
            style: statusStyle
        }), text && /*#__PURE__*/ $6fFrj.createElement("span", {
            style: {
                color: statusTextColor
            },
            className: "".concat(prefixCls, "-status-text")
        }, text));
    }
    // <Badge status="success" count={<Icon type="xxx" />}></Badge>
    return /*#__PURE__*/ $6fFrj.createElement("span", (0, $fIrcP.default)({}, restProps, {
        className: badgeClassName
    }), children, /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), {
        visible: !isHidden,
        motionName: "".concat(prefixCls, "-zoom"),
        motionAppear: false,
        motionDeadline: 1000
    }, function(_ref) {
        var motionClassName = _ref.className;
        var scrollNumberPrefixCls = getPrefixCls('scroll-number', customizeScrollNumberPrefixCls);
        var isDot = isDotRef.current;
        var scrollNumberCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-dot"), isDot), "".concat(prefixCls, "-count"), !isDot), "".concat(prefixCls, "-count-sm"), size === 'small'), "".concat(prefixCls, "-multiple-words"), !isDot && displayCount && displayCount.toString().length > 1), "".concat(prefixCls, "-status-").concat(status), !!status), "".concat(prefixCls, "-status-").concat(color), (0, $195c8e183a479c17$export$ee62ebd6a58c4884)(color)));
        var scrollNumberStyle = (0, $fIrcP.default)({}, mergedStyle);
        if (color && !(0, $195c8e183a479c17$export$ee62ebd6a58c4884)(color)) {
            scrollNumberStyle = scrollNumberStyle || {};
            scrollNumberStyle.background = color;
        }
        return /*#__PURE__*/ $6fFrj.createElement((0, $4d00b8b00c0c1e34$export$2e2bcd8739ae039), {
            prefixCls: scrollNumberPrefixCls,
            show: !isHidden,
            motionClassName: motionClassName,
            className: scrollNumberCls,
            count: displayCount,
            title: titleNode,
            style: scrollNumberStyle,
            key: "scrollNumber"
        }, displayNode);
    }), statusTextNode);
};
$0e541b76c0e3ec69$var$Badge.Ribbon = (0, $3243ad3f3709cd69$export$2e2bcd8739ae039);
var $0e541b76c0e3ec69$export$2e2bcd8739ae039 = $0e541b76c0e3ec69$var$Badge;


var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $5KhTJ = parcelRequire("5KhTJ");

var $fActo = parcelRequire("fActo");
function $c2870fd62d155a62$export$2e2bcd8739ae039(obj, fields) {
    var clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}



var $6fFrj = parcelRequire("6fFrj");




var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");

var $87f4fe035d0a15fd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $87f4fe035d0a15fd$export$8d1c486ac0db0a7d = /*#__PURE__*/ $6fFrj.createContext(null);
var $87f4fe035d0a15fd$export$cd8cf9d7bab8dd4 = function useCompactItemContext(prefixCls, direction) {
    var compactItemContext = $6fFrj.useContext($87f4fe035d0a15fd$export$8d1c486ac0db0a7d);
    var compactItemClassnames = $6fFrj.useMemo(function() {
        if (!compactItemContext) return '';
        var compactDirection = compactItemContext.compactDirection, isFirstItem = compactItemContext.isFirstItem, isLastItem = compactItemContext.isLastItem;
        var separator = compactDirection === 'vertical' ? '-vertical-' : '-';
        return (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-compact").concat(separator, "item"), true), "".concat(prefixCls, "-compact").concat(separator, "first-item"), isFirstItem), "".concat(prefixCls, "-compact").concat(separator, "last-item"), isLastItem), "".concat(prefixCls, "-compact").concat(separator, "item-rtl"), direction === 'rtl'));
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
        compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
var $87f4fe035d0a15fd$export$5f56e610a4afb685 = function NoCompactStyle(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $6fFrj.createElement($87f4fe035d0a15fd$export$8d1c486ac0db0a7d.Provider, {
        value: null
    }, children);
};
var $87f4fe035d0a15fd$var$CompactItem = function CompactItem(_a) {
    var children = _a.children, otherProps = $87f4fe035d0a15fd$var$__rest(_a, [
        "children"
    ]);
    return /*#__PURE__*/ $6fFrj.createElement($87f4fe035d0a15fd$export$8d1c486ac0db0a7d.Provider, {
        value: otherProps
    }, children);
};
var $87f4fe035d0a15fd$var$Compact = function Compact(props) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, directionConfig = _React$useContext.direction;
    var _props$size = props.size, size = _props$size === void 0 ? 'middle' : _props$size, direction = props.direction, block = props.block, customizePrefixCls = props.prefixCls, className = props.className, children = props.children, restProps = $87f4fe035d0a15fd$var$__rest(props, [
        "size",
        "direction",
        "block",
        "prefixCls",
        "className",
        "children"
    ]);
    var prefixCls = getPrefixCls('space-compact', customizePrefixCls);
    var clx = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-rtl"), directionConfig === 'rtl'), "".concat(prefixCls, "-block"), block), "".concat(prefixCls, "-vertical"), direction === 'vertical'), className);
    var compactItemContext = $6fFrj.useContext($87f4fe035d0a15fd$export$8d1c486ac0db0a7d);
    var childNodes = (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(children);
    var nodes = $6fFrj.useMemo(function() {
        return childNodes.map(function(child, i) {
            var key = child && child.key || "".concat(prefixCls, "-item-").concat(i);
            return /*#__PURE__*/ $6fFrj.createElement($87f4fe035d0a15fd$var$CompactItem, {
                key: key,
                compactSize: size,
                compactDirection: direction,
                isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
            }, child);
        });
    }, [
        size,
        childNodes,
        compactItemContext
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        className: clx
    }, restProps), nodes);
};
var $87f4fe035d0a15fd$export$2e2bcd8739ae039 = $87f4fe035d0a15fd$var$Compact;






var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $82HU4 = parcelRequire("82HU4");

var $jbuPt = parcelRequire("jbuPt");

var $744q1 = parcelRequire("744q1");

var $3mZgl = parcelRequire("3mZgl");

var $bxC2Y = parcelRequire("bxC2Y");


var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");


var $hqic8 = parcelRequire("hqic8");
var $db1ae29b616ab9a6$var$id = 0;
var $db1ae29b616ab9a6$var$ids = {};
function $db1ae29b616ab9a6$export$2e2bcd8739ae039(callback) {
    var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var myId = $db1ae29b616ab9a6$var$id++;
    var restFrames = delayFrames;
    function internalCallback() {
        restFrames -= 1;
        if (restFrames <= 0) {
            callback();
            delete $db1ae29b616ab9a6$var$ids[myId];
        } else $db1ae29b616ab9a6$var$ids[myId] = (0, $hqic8.default)(internalCallback);
    }
    $db1ae29b616ab9a6$var$ids[myId] = (0, $hqic8.default)(internalCallback);
    return myId;
}
$db1ae29b616ab9a6$export$2e2bcd8739ae039.cancel = function cancel(pid) {
    if (pid === undefined) return;
    (0, $hqic8.default).cancel($db1ae29b616ab9a6$var$ids[pid]);
    delete $db1ae29b616ab9a6$var$ids[pid];
};
$db1ae29b616ab9a6$export$2e2bcd8739ae039.ids = $db1ae29b616ab9a6$var$ids; // export this for test usage



function $3b8de09695d8518a$var$_callSuper(t, o, e) {
    return o = (0, $744q1.default)(o), (0, $82HU4.default)(t, (0, $jbuPt.default)() ? Reflect.construct(o, e || [], (0, $744q1.default)(t).constructor) : o.apply(t, e));
}
var $3b8de09695d8518a$var$styleForPseudo;
// Where el is the DOM element you'd like to test for visibility
function $3b8de09695d8518a$var$isHidden(element) {
    return !element || element.offsetParent === null || element.hidden;
}
function $3b8de09695d8518a$var$getValidateContainer(nodeRoot) {
    if (nodeRoot instanceof Document) return nodeRoot.body;
    return Array.from(nodeRoot.childNodes).find(function(ele) {
        return (ele === null || ele === void 0 ? void 0 : ele.nodeType) === Node.ELEMENT_NODE;
    });
}
function $3b8de09695d8518a$var$isNotGrey(color) {
    // eslint-disable-next-line no-useless-escape
    var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
    if (match && match[1] && match[2] && match[3]) return !(match[1] === match[2] && match[2] === match[3]);
    return true;
}
var $3b8de09695d8518a$var$Wave = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(Wave, _React$Component);
    function Wave() {
        var _this;
        (0, $kjNeN.default)(this, Wave);
        _this = $3b8de09695d8518a$var$_callSuper(this, Wave, arguments);
        _this.containerRef = /*#__PURE__*/ $6fFrj.createRef();
        _this.animationStart = false;
        _this.destroyed = false;
        _this.onClick = function(node, waveColor) {
            var _a, _b;
            var _this$props = _this.props, insertExtraNode = _this$props.insertExtraNode, disabled = _this$props.disabled;
            if (disabled || !node || $3b8de09695d8518a$var$isHidden(node) || node.className.includes('-leave')) return;
            _this.extraNode = document.createElement('div');
            var _assertThisInitialize = (0, $3mZgl.default)(_this), extraNode = _assertThisInitialize.extraNode;
            var getPrefixCls = _this.context.getPrefixCls;
            extraNode.className = "".concat(getPrefixCls(''), "-click-animating-node");
            var attributeName = _this.getAttributeName();
            node.setAttribute(attributeName, 'true');
            // Not white or transparent or grey
            if (waveColor && waveColor !== '#fff' && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && waveColor !== 'rgba(255, 255, 255, 1)' && $3b8de09695d8518a$var$isNotGrey(waveColor) && !/rgba\((?:\d*, ){3}0\)/.test(waveColor) && // any transparent rgba color
            waveColor !== 'transparent') {
                extraNode.style.borderColor = waveColor;
                var nodeRoot = ((_a = node.getRootNode) === null || _a === void 0 ? void 0 : _a.call(node)) || node.ownerDocument;
                var nodeBody = (_b = $3b8de09695d8518a$var$getValidateContainer(nodeRoot)) !== null && _b !== void 0 ? _b : nodeRoot;
                $3b8de09695d8518a$var$styleForPseudo = (0, $be1cee03a7a68105$export$4d99a2890bb989f0)("\n      [".concat(getPrefixCls(''), "-click-animating-without-extra-node='true']::after, .").concat(getPrefixCls(''), "-click-animating-node {\n        --antd-wave-shadow-color: ").concat(waveColor, ";\n      }"), 'antd-wave', {
                    csp: _this.csp,
                    attachTo: nodeBody
                });
            }
            if (insertExtraNode) node.appendChild(extraNode);
            [
                'transition',
                'animation'
            ].forEach(function(name) {
                node.addEventListener("".concat(name, "start"), _this.onTransitionStart);
                node.addEventListener("".concat(name, "end"), _this.onTransitionEnd);
            });
        };
        _this.onTransitionStart = function(e) {
            if (_this.destroyed) return;
            var node = _this.containerRef.current;
            if (!e || e.target !== node || _this.animationStart) return;
            _this.resetEffect(node);
        };
        _this.onTransitionEnd = function(e) {
            if (!e || e.animationName !== 'fadeEffect') return;
            _this.resetEffect(e.target);
        };
        _this.bindAnimationEvent = function(node) {
            if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.includes('disabled')) return;
            var onClick = function onClick(e) {
                // Fix radio button click twice
                if (e.target.tagName === 'INPUT' || $3b8de09695d8518a$var$isHidden(e.target)) return;
                _this.resetEffect(node);
                // Get wave color from target
                var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
                getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
                _this.clickWaveTimeoutId = window.setTimeout(function() {
                    return _this.onClick(node, waveColor);
                }, 0);
                (0, $db1ae29b616ab9a6$export$2e2bcd8739ae039).cancel(_this.animationStartId);
                _this.animationStart = true;
                // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.
                _this.animationStartId = (0, $db1ae29b616ab9a6$export$2e2bcd8739ae039)(function() {
                    _this.animationStart = false;
                }, 10);
            };
            node.addEventListener('click', onClick, true);
            return {
                cancel: function cancel() {
                    node.removeEventListener('click', onClick, true);
                }
            };
        };
        _this.renderWave = function(_ref) {
            var csp = _ref.csp;
            var children = _this.props.children;
            _this.csp = csp;
            if (!/*#__PURE__*/ $6fFrj.isValidElement(children)) return children;
            var ref = _this.containerRef;
            if ((0, $3BOWT.supportRef)(children)) ref = (0, $3BOWT.composeRef)(children.ref, _this.containerRef);
            return (0, $79365009d9b77ac6$export$e530037191fcd5d7)(children, {
                ref: ref
            });
        };
        return _this;
    }
    (0, $5KQxu.default)(Wave, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.destroyed = false;
                var node = this.containerRef.current;
                if (!node || node.nodeType !== 1) return;
                this.instance = this.bindAnimationEvent(node);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.instance) this.instance.cancel();
                if (this.clickWaveTimeoutId) clearTimeout(this.clickWaveTimeoutId);
                this.destroyed = true;
            }
        },
        {
            key: "getAttributeName",
            value: function getAttributeName() {
                var getPrefixCls = this.context.getPrefixCls;
                var insertExtraNode = this.props.insertExtraNode;
                return insertExtraNode ? "".concat(getPrefixCls(''), "-click-animating") : "".concat(getPrefixCls(''), "-click-animating-without-extra-node");
            }
        },
        {
            key: "resetEffect",
            value: function resetEffect(node) {
                var _this2 = this;
                if (!node || node === this.extraNode || !(node instanceof Element)) return;
                var insertExtraNode = this.props.insertExtraNode;
                var attributeName = this.getAttributeName();
                node.setAttribute(attributeName, 'false'); // edge has bug on `removeAttribute` #14466
                if ($3b8de09695d8518a$var$styleForPseudo) $3b8de09695d8518a$var$styleForPseudo.innerHTML = '';
                if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) node.removeChild(this.extraNode);
                [
                    'transition',
                    'animation'
                ].forEach(function(name) {
                    node.removeEventListener("".concat(name, "start"), _this2.onTransitionStart);
                    node.removeEventListener("".concat(name, "end"), _this2.onTransitionEnd);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $6fFrj.createElement((0, $1bdb4c3de815e386$export$cd5442f2b8da7663), null, this.renderWave);
            }
        }
    ]);
    return Wave;
}($6fFrj.Component);
$3b8de09695d8518a$var$Wave.contextType = (0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b);
var $3b8de09695d8518a$export$2e2bcd8739ae039 = $3b8de09695d8518a$var$Wave;



var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");


var $15e0195ab716ea51$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $15e0195ab716ea51$export$ed0cc8bd1f617d6d = /*#__PURE__*/ $6fFrj.createContext(undefined);
var $15e0195ab716ea51$var$ButtonGroup = function ButtonGroup(props) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var customizePrefixCls = props.prefixCls, size = props.size, className = props.className, others = $15e0195ab716ea51$var$__rest(props, [
        "prefixCls",
        "size",
        "className"
    ]);
    var prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    // large => lg
    // small => sm
    var sizeCls = '';
    switch(size){
        case 'large':
            sizeCls = 'lg';
            break;
        case 'small':
            sizeCls = 'sm';
            break;
        case 'middle':
        case undefined:
            break;
        default:
    }
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $6fFrj.createElement($15e0195ab716ea51$export$ed0cc8bd1f617d6d.Provider, {
        value: size
    }, /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({}, others, {
        className: classes
    })));
};
var $15e0195ab716ea51$export$2e2bcd8739ae039 = $15e0195ab716ea51$var$ButtonGroup;




var $5EVeC = parcelRequire("5EVeC");

var $6fFrj = parcelRequire("6fFrj");
var $8b3b5ff02fcab719$var$getCollapsedWidth = function getCollapsedWidth() {
    return {
        width: 0,
        opacity: 0,
        transform: 'scale(0)'
    };
};
var $8b3b5ff02fcab719$var$getRealWidth = function getRealWidth(node) {
    return {
        width: node.scrollWidth,
        opacity: 1,
        transform: 'scale(1)'
    };
};
var $8b3b5ff02fcab719$var$LoadingIcon = function LoadingIcon(_ref) {
    var prefixCls = _ref.prefixCls, loading = _ref.loading, existIcon = _ref.existIcon;
    var visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
        className: "".concat(prefixCls, "-loading-icon")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $3240b41b65b5dac9$export$2e2bcd8739ae039), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $5EVeC.default), {
        visible: visible,
        // We do not really use this motionName
        motionName: "".concat(prefixCls, "-loading-icon-motion"),
        removeOnLeave: true,
        onAppearStart: $8b3b5ff02fcab719$var$getCollapsedWidth,
        onAppearActive: $8b3b5ff02fcab719$var$getRealWidth,
        onEnterStart: $8b3b5ff02fcab719$var$getCollapsedWidth,
        onEnterActive: $8b3b5ff02fcab719$var$getRealWidth,
        onLeaveStart: $8b3b5ff02fcab719$var$getRealWidth,
        onLeaveActive: $8b3b5ff02fcab719$var$getCollapsedWidth
    }, function(_ref2, ref) {
        var className = _ref2.className, style = _ref2.style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
            className: "".concat(prefixCls, "-loading-icon"),
            style: style,
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $3240b41b65b5dac9$export$2e2bcd8739ae039), {
            className: className
        }));
    });
};
var $8b3b5ff02fcab719$export$2e2bcd8739ae039 = $8b3b5ff02fcab719$var$LoadingIcon;


var $34c411687886965a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $34c411687886965a$var$rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var $34c411687886965a$var$isTwoCNChar = $34c411687886965a$var$rxTwoCNChar.test.bind($34c411687886965a$var$rxTwoCNChar);
function $34c411687886965a$var$isString(str) {
    return typeof str === 'string';
}
function $34c411687886965a$var$isUnBorderedButtonType(type) {
    return type === 'text' || type === 'link';
}
// Insert one space between two chinese characters automatically.
function $34c411687886965a$var$insertSpace(child, needInserted) {
    // Check the child if is undefined or null.
    if (child === null || child === undefined) return;
    var SPACE = needInserted ? ' ' : '';
    // strictNullChecks oops.
    if (typeof child !== 'string' && typeof child !== 'number' && $34c411687886965a$var$isString(child.type) && $34c411687886965a$var$isTwoCNChar(child.props.children)) return (0, $79365009d9b77ac6$export$e530037191fcd5d7)(child, {
        children: child.props.children.split('').join(SPACE)
    });
    if (typeof child === 'string') return $34c411687886965a$var$isTwoCNChar(child) ? /*#__PURE__*/ $6fFrj.createElement("span", null, child.split('').join(SPACE)) : /*#__PURE__*/ $6fFrj.createElement("span", null, child);
    if ((0, $79365009d9b77ac6$export$9522e17588c12572)(child)) return /*#__PURE__*/ $6fFrj.createElement("span", null, child);
    return child;
}
function $34c411687886965a$var$spaceChildren(children, needInserted) {
    var isPrevChildPure = false;
    var childList = [];
    $6fFrj.Children.forEach(children, function(child) {
        var type = (0, $5KhTJ.default)(child);
        var isCurrentChildPure = type === 'string' || type === 'number';
        if (isPrevChildPure && isCurrentChildPure) {
            var lastIndex = childList.length - 1;
            var lastChild = childList[lastIndex];
            childList[lastIndex] = "".concat(lastChild).concat(child);
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    // Pass to React.Children.map to auto fill key
    return $6fFrj.Children.map(childList, function(child) {
        return $34c411687886965a$var$insertSpace(child, needInserted);
    });
}
var $34c411687886965a$var$ButtonTypes = (0, $cacd97b96801cebe$export$65e3907585753458)('default', 'primary', 'ghost', 'dashed', 'link', 'text');
var $34c411687886965a$var$ButtonShapes = (0, $cacd97b96801cebe$export$65e3907585753458)('default', 'circle', 'round');
var $34c411687886965a$var$ButtonHTMLTypes = (0, $cacd97b96801cebe$export$65e3907585753458)('submit', 'button', 'reset');
function $34c411687886965a$export$19bc9a290855952(type) {
    if (type === 'danger') return {
        danger: true
    };
    return {
        type: type
    };
}
var $34c411687886965a$var$InternalButton = function InternalButton(props, ref) {
    var _classNames;
    var _props$loading = props.loading, loading = _props$loading === void 0 ? false : _props$loading, customizePrefixCls = props.prefixCls, _props$type = props.type, type = _props$type === void 0 ? 'default' : _props$type, danger = props.danger, _props$shape = props.shape, shape = _props$shape === void 0 ? 'default' : _props$shape, customizeSize = props.size, customDisabled = props.disabled, className = props.className, children = props.children, icon = props.icon, _props$ghost = props.ghost, ghost = _props$ghost === void 0 ? false : _props$ghost, _props$block = props.block, block = _props$block === void 0 ? false : _props$block, _props$htmlType = props.htmlType, htmlType = _props$htmlType === void 0 ? 'button' : _props$htmlType, rest = $34c411687886965a$var$__rest(props, [
        "loading",
        "prefixCls",
        "type",
        "danger",
        "shape",
        "size",
        "disabled",
        "className",
        "children",
        "icon",
        "ghost",
        "block",
        "htmlType"
    ]);
    var size = $6fFrj.useContext((0, $aefad26b74860b7e$export$2e2bcd8739ae039));
    // ===================== Disabled =====================
    var disabled = $6fFrj.useContext((0, $3880af76d17f94a3$export$2e2bcd8739ae039));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var groupSize = $6fFrj.useContext((0, $15e0195ab716ea51$export$ed0cc8bd1f617d6d));
    var _React$useState = $6fFrj.useState(!!loading), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), innerLoading = _React$useState2[0], setLoading = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState(false), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), hasTwoCNChar = _React$useState4[0], setHasTwoCNChar = _React$useState4[1];
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, autoInsertSpaceInButton = _React$useContext.autoInsertSpaceInButton, direction = _React$useContext.direction;
    var buttonRef = ref || /*#__PURE__*/ $6fFrj.createRef();
    var isNeedInserted = function isNeedInserted() {
        return $6fFrj.Children.count(children) === 1 && !icon && !$34c411687886965a$var$isUnBorderedButtonType(type);
    };
    var fixTwoCNChar = function fixTwoCNChar() {
        // Fix for HOC usage like <FormatMessage />
        if (!buttonRef || !buttonRef.current || autoInsertSpaceInButton === false) return;
        var buttonText = buttonRef.current.textContent;
        if (isNeedInserted() && $34c411687886965a$var$isTwoCNChar(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    };
    // =============== Update Loading ===============
    var loadingOrDelay = typeof loading === 'boolean' ? loading : (loading === null || loading === void 0 ? void 0 : loading.delay) || true;
    $6fFrj.useEffect(function() {
        var delayTimer = null;
        if (typeof loadingOrDelay === 'number') delayTimer = window.setTimeout(function() {
            delayTimer = null;
            setLoading(loadingOrDelay);
        }, loadingOrDelay);
        else setLoading(loadingOrDelay);
        return function() {
            if (delayTimer) {
                // in order to not perform a React state update on an unmounted component
                // and clear timer after 'loadingOrDelay' updated.
                window.clearTimeout(delayTimer);
                delayTimer = null;
            }
        };
    }, [
        loadingOrDelay
    ]);
    $6fFrj.useEffect(fixTwoCNChar, [
        buttonRef
    ]);
    var handleClick = function handleClick(e) {
        var onClick = props.onClick;
        // https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        onClick === null || onClick === void 0 || onClick(e);
    };
    var prefixCls = getPrefixCls('btn', customizePrefixCls);
    var autoInsertSpace = autoInsertSpaceInButton !== false;
    var _useCompactItemContex = (0, $87f4fe035d0a15fd$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    var sizeClassNameMap = {
        large: 'lg',
        small: 'sm',
        middle: undefined
    };
    var sizeFullname = compactSize || groupSize || customizeSize || size;
    var sizeCls = sizeFullname ? sizeClassNameMap[sizeFullname] || '' : '';
    var iconType = innerLoading ? 'loading' : icon;
    var linkButtonRestProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(rest, [
        'navigate'
    ]);
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (_classNames = {}, (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)(_classNames, "".concat(prefixCls, "-").concat(shape), shape !== 'default' && shape), "".concat(prefixCls, "-").concat(type), type), "".concat(prefixCls, "-").concat(sizeCls), sizeCls), "".concat(prefixCls, "-icon-only"), !children && children !== 0 && !!iconType), "".concat(prefixCls, "-background-ghost"), ghost && !$34c411687886965a$var$isUnBorderedButtonType(type)), "".concat(prefixCls, "-loading"), innerLoading), "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace && !innerLoading), "".concat(prefixCls, "-block"), block), "".concat(prefixCls, "-dangerous"), !!danger), "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, $43449.default)(_classNames, "".concat(prefixCls, "-disabled"), linkButtonRestProps.href !== undefined && mergedDisabled)), compactItemClassnames, className);
    var iconNode = icon && !innerLoading ? icon : /*#__PURE__*/ $6fFrj.createElement((0, $8b3b5ff02fcab719$export$2e2bcd8739ae039), {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: !!innerLoading
    });
    var kids = children || children === 0 ? $34c411687886965a$var$spaceChildren(children, isNeedInserted() && autoInsertSpace) : null;
    if (linkButtonRestProps.href !== undefined) return /*#__PURE__*/ $6fFrj.createElement("a", (0, $fIrcP.default)({}, linkButtonRestProps, {
        className: classes,
        onClick: handleClick,
        ref: buttonRef
    }), iconNode, kids);
    var buttonNode = /*#__PURE__*/ $6fFrj.createElement("button", (0, $fIrcP.default)({}, rest, {
        type: htmlType,
        className: classes,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: buttonRef
    }), iconNode, kids);
    if ($34c411687886965a$var$isUnBorderedButtonType(type)) return buttonNode;
    return /*#__PURE__*/ $6fFrj.createElement((0, $3b8de09695d8518a$export$2e2bcd8739ae039), {
        disabled: !!innerLoading
    }, buttonNode);
};
var $34c411687886965a$var$Button = /*#__PURE__*/ $6fFrj.forwardRef($34c411687886965a$var$InternalButton);
$34c411687886965a$var$Button.Group = (0, $15e0195ab716ea51$export$2e2bcd8739ae039);
$34c411687886965a$var$Button.__ANT_BUTTON = true;
var $34c411687886965a$export$2e2bcd8739ae039 = $34c411687886965a$var$Button;


var $ea0942a2e543872a$export$2e2bcd8739ae039 = (0, $34c411687886965a$export$2e2bcd8739ae039);


var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $fActo = parcelRequire("fActo");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $fActo = parcelRequire("fActo");

var $gfhff = parcelRequire("gfhff");

var $6fFrj = parcelRequire("6fFrj");
var $17f8617e16f6bea2$var$_excluded = [
    "prefixCls",
    "className",
    "style",
    "checked",
    "disabled",
    "defaultChecked",
    "type",
    "onChange"
];
var $17f8617e16f6bea2$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $6fFrj.forwardRef)(function(props, ref) {
    var _classNames;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-checkbox' : _props$prefixCls, className = props.className, style = props.style, checked = props.checked, disabled = props.disabled, _props$defaultChecked = props.defaultChecked, defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked, _props$type = props.type, type = _props$type === void 0 ? 'checkbox' : _props$type, onChange = props.onChange, inputProps = (0, $04RxA.default)(props, $17f8617e16f6bea2$var$_excluded);
    var inputRef = (0, $6fFrj.useRef)(null);
    var _useMergedState = (0, $gfhff.default)(defaultChecked, {
        value: checked
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), rawValue = _useMergedState2[0], setRawValue = _useMergedState2[1];
    (0, $6fFrj.useImperativeHandle)(ref, function() {
        return {
            focus: function focus() {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
            },
            blur: function blur() {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
            },
            input: inputRef.current
        };
    });
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(prefixCls, "-checked"), rawValue), (0, $43449.default)(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
    var handleChange = function handleChange(e) {
        if (disabled) return;
        if (!('checked' in props)) setRawValue(e.target.checked);
        onChange === null || onChange === void 0 || onChange({
            target: (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
                type: type,
                checked: e.target.checked
            }),
            stopPropagation: function stopPropagation() {
                e.stopPropagation();
            },
            preventDefault: function preventDefault() {
                e.preventDefault();
            },
            nativeEvent: e.nativeEvent
        });
    };
    return /*#__PURE__*/ $6fFrj.createElement("span", {
        className: classString,
        style: style
    }, /*#__PURE__*/ $6fFrj.createElement("input", (0, $fIrcP.default)({}, inputProps, {
        className: "".concat(prefixCls, "-input"),
        ref: inputRef,
        onChange: handleChange,
        disabled: disabled,
        checked: !!rawValue,
        type: type
    })), /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-inner")
    }));
});
var $17f8617e16f6bea2$export$2e2bcd8739ae039 = $17f8617e16f6bea2$export$48513f6b9f8ce62d;



var $6fFrj = parcelRequire("6fFrj");


var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $04RxA = parcelRequire("04RxA");

var $1WWLf = parcelRequire("1WWLf");

var $47DhB = parcelRequire("47DhB");

var $kNxFX = parcelRequire("kNxFX");

var $37xND = parcelRequire("37xND");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $3mZgl = parcelRequire("3mZgl");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $43449 = parcelRequire("43449");



var $3mXQ2 = parcelRequire("3mXQ2");

var $6fFrj = parcelRequire("6fFrj");

var $3mXQ2 = parcelRequire("3mXQ2");

var $6fFrj = parcelRequire("6fFrj");
var $096ab3393cfd7cdf$export$24829b7c0e49e9f7 = 'RC_FORM_INTERNAL_HOOKS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $096ab3393cfd7cdf$var$warningFunc = function warningFunc() {
    (0, $3mXQ2.default)(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};
var $096ab3393cfd7cdf$var$Context = /*#__PURE__*/ $6fFrj.createContext({
    getFieldValue: $096ab3393cfd7cdf$var$warningFunc,
    getFieldsValue: $096ab3393cfd7cdf$var$warningFunc,
    getFieldError: $096ab3393cfd7cdf$var$warningFunc,
    getFieldWarning: $096ab3393cfd7cdf$var$warningFunc,
    getFieldsError: $096ab3393cfd7cdf$var$warningFunc,
    isFieldsTouched: $096ab3393cfd7cdf$var$warningFunc,
    isFieldTouched: $096ab3393cfd7cdf$var$warningFunc,
    isFieldValidating: $096ab3393cfd7cdf$var$warningFunc,
    isFieldsValidating: $096ab3393cfd7cdf$var$warningFunc,
    resetFields: $096ab3393cfd7cdf$var$warningFunc,
    setFields: $096ab3393cfd7cdf$var$warningFunc,
    setFieldValue: $096ab3393cfd7cdf$var$warningFunc,
    setFieldsValue: $096ab3393cfd7cdf$var$warningFunc,
    validateFields: $096ab3393cfd7cdf$var$warningFunc,
    submit: $096ab3393cfd7cdf$var$warningFunc,
    getInternalHooks: function getInternalHooks() {
        $096ab3393cfd7cdf$var$warningFunc();
        return {
            dispatch: $096ab3393cfd7cdf$var$warningFunc,
            initEntityValue: $096ab3393cfd7cdf$var$warningFunc,
            registerField: $096ab3393cfd7cdf$var$warningFunc,
            useSubscribe: $096ab3393cfd7cdf$var$warningFunc,
            setInitialValues: $096ab3393cfd7cdf$var$warningFunc,
            destroyForm: $096ab3393cfd7cdf$var$warningFunc,
            setCallbacks: $096ab3393cfd7cdf$var$warningFunc,
            registerWatch: $096ab3393cfd7cdf$var$warningFunc,
            getFields: $096ab3393cfd7cdf$var$warningFunc,
            setValidateMessages: $096ab3393cfd7cdf$var$warningFunc,
            setPreserve: $096ab3393cfd7cdf$var$warningFunc,
            getInitialValue: $096ab3393cfd7cdf$var$warningFunc
        };
    }
});
var $096ab3393cfd7cdf$export$2e2bcd8739ae039 = $096ab3393cfd7cdf$var$Context;



var $6fFrj = parcelRequire("6fFrj");
var $cb841e38c6f3a8d1$var$ListContext = /*#__PURE__*/ $6fFrj.createContext(null);
var $cb841e38c6f3a8d1$export$2e2bcd8739ae039 = $cb841e38c6f3a8d1$var$ListContext;


function $e24ebc1f4c7a8e3c$export$45b10814cc054894(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $e24ebc1f4c7a8e3c$export$717b316e73068e8d(form) {
    return form && !!form._init;
}



var $37xND = parcelRequire("37xND");

var $43449 = parcelRequire("43449");

var $1WWLf = parcelRequire("1WWLf");

var $kNxFX = parcelRequire("kNxFX");

var $47DhB = parcelRequire("47DhB");
var $d1d9b4516838462f$exports = {};
// shim for using process in browser
var $d1d9b4516838462f$var$process = $d1d9b4516838462f$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d1d9b4516838462f$var$cachedSetTimeout;
var $d1d9b4516838462f$var$cachedClearTimeout;
function $d1d9b4516838462f$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d1d9b4516838462f$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d1d9b4516838462f$var$cachedSetTimeout = setTimeout;
        else $d1d9b4516838462f$var$cachedSetTimeout = $d1d9b4516838462f$var$defaultSetTimout;
    } catch (e) {
        $d1d9b4516838462f$var$cachedSetTimeout = $d1d9b4516838462f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d1d9b4516838462f$var$cachedClearTimeout = clearTimeout;
        else $d1d9b4516838462f$var$cachedClearTimeout = $d1d9b4516838462f$var$defaultClearTimeout;
    } catch (e) {
        $d1d9b4516838462f$var$cachedClearTimeout = $d1d9b4516838462f$var$defaultClearTimeout;
    }
})();
function $d1d9b4516838462f$var$runTimeout(fun) {
    if ($d1d9b4516838462f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d1d9b4516838462f$var$cachedSetTimeout === $d1d9b4516838462f$var$defaultSetTimout || !$d1d9b4516838462f$var$cachedSetTimeout) && setTimeout) {
        $d1d9b4516838462f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d1d9b4516838462f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d1d9b4516838462f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d1d9b4516838462f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d1d9b4516838462f$var$runClearTimeout(marker) {
    if ($d1d9b4516838462f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d1d9b4516838462f$var$cachedClearTimeout === $d1d9b4516838462f$var$defaultClearTimeout || !$d1d9b4516838462f$var$cachedClearTimeout) && clearTimeout) {
        $d1d9b4516838462f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d1d9b4516838462f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d1d9b4516838462f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d1d9b4516838462f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d1d9b4516838462f$var$queue = [];
var $d1d9b4516838462f$var$draining = false;
var $d1d9b4516838462f$var$currentQueue;
var $d1d9b4516838462f$var$queueIndex = -1;
function $d1d9b4516838462f$var$cleanUpNextTick() {
    if (!$d1d9b4516838462f$var$draining || !$d1d9b4516838462f$var$currentQueue) return;
    $d1d9b4516838462f$var$draining = false;
    if ($d1d9b4516838462f$var$currentQueue.length) $d1d9b4516838462f$var$queue = $d1d9b4516838462f$var$currentQueue.concat($d1d9b4516838462f$var$queue);
    else $d1d9b4516838462f$var$queueIndex = -1;
    if ($d1d9b4516838462f$var$queue.length) $d1d9b4516838462f$var$drainQueue();
}
function $d1d9b4516838462f$var$drainQueue() {
    if ($d1d9b4516838462f$var$draining) return;
    var timeout = $d1d9b4516838462f$var$runTimeout($d1d9b4516838462f$var$cleanUpNextTick);
    $d1d9b4516838462f$var$draining = true;
    var len = $d1d9b4516838462f$var$queue.length;
    while(len){
        $d1d9b4516838462f$var$currentQueue = $d1d9b4516838462f$var$queue;
        $d1d9b4516838462f$var$queue = [];
        while(++$d1d9b4516838462f$var$queueIndex < len)if ($d1d9b4516838462f$var$currentQueue) $d1d9b4516838462f$var$currentQueue[$d1d9b4516838462f$var$queueIndex].run();
        $d1d9b4516838462f$var$queueIndex = -1;
        len = $d1d9b4516838462f$var$queue.length;
    }
    $d1d9b4516838462f$var$currentQueue = null;
    $d1d9b4516838462f$var$draining = false;
    $d1d9b4516838462f$var$runClearTimeout(timeout);
}
$d1d9b4516838462f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d1d9b4516838462f$var$queue.push(new $d1d9b4516838462f$var$Item(fun, args));
    if ($d1d9b4516838462f$var$queue.length === 1 && !$d1d9b4516838462f$var$draining) $d1d9b4516838462f$var$runTimeout($d1d9b4516838462f$var$drainQueue);
};
// v8 likes predictible objects
function $d1d9b4516838462f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d1d9b4516838462f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d1d9b4516838462f$var$process.title = 'browser';
$d1d9b4516838462f$var$process.browser = true;
$d1d9b4516838462f$var$process.env = {};
$d1d9b4516838462f$var$process.argv = [];
$d1d9b4516838462f$var$process.version = ''; // empty string to avoid regexp issues
$d1d9b4516838462f$var$process.versions = {};
function $d1d9b4516838462f$var$noop() {}
$d1d9b4516838462f$var$process.on = $d1d9b4516838462f$var$noop;
$d1d9b4516838462f$var$process.addListener = $d1d9b4516838462f$var$noop;
$d1d9b4516838462f$var$process.once = $d1d9b4516838462f$var$noop;
$d1d9b4516838462f$var$process.off = $d1d9b4516838462f$var$noop;
$d1d9b4516838462f$var$process.removeListener = $d1d9b4516838462f$var$noop;
$d1d9b4516838462f$var$process.removeAllListeners = $d1d9b4516838462f$var$noop;
$d1d9b4516838462f$var$process.emit = $d1d9b4516838462f$var$noop;
$d1d9b4516838462f$var$process.prependListener = $d1d9b4516838462f$var$noop;
$d1d9b4516838462f$var$process.prependOnceListener = $d1d9b4516838462f$var$noop;
$d1d9b4516838462f$var$process.listeners = function(name) {
    return [];
};
$d1d9b4516838462f$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d1d9b4516838462f$var$process.cwd = function() {
    return '/';
};
$d1d9b4516838462f$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d1d9b4516838462f$var$process.umask = function() {
    return 0;
};


function $dbddff8435a61653$var$_extends() {
    $dbddff8435a61653$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dbddff8435a61653$var$_extends.apply(this, arguments);
}
function $dbddff8435a61653$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $dbddff8435a61653$var$_setPrototypeOf(subClass, superClass);
}
function $dbddff8435a61653$var$_getPrototypeOf(o) {
    $dbddff8435a61653$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $dbddff8435a61653$var$_getPrototypeOf(o);
}
function $dbddff8435a61653$var$_setPrototypeOf(o, p) {
    $dbddff8435a61653$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dbddff8435a61653$var$_setPrototypeOf(o, p);
}
function $dbddff8435a61653$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $dbddff8435a61653$var$_construct(Parent, args, Class) {
    if ($dbddff8435a61653$var$_isNativeReflectConstruct()) $dbddff8435a61653$var$_construct = Reflect.construct.bind();
    else $dbddff8435a61653$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $dbddff8435a61653$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $dbddff8435a61653$var$_construct.apply(null, arguments);
}
function $dbddff8435a61653$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $dbddff8435a61653$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $dbddff8435a61653$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$dbddff8435a61653$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $dbddff8435a61653$var$_construct(Class, arguments, $dbddff8435a61653$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $dbddff8435a61653$var$_setPrototypeOf(Wrapper, Class);
    };
    return $dbddff8435a61653$var$_wrapNativeSuper(Class);
}
/* eslint no-console:0 */ var $dbddff8435a61653$var$formatRegExp = /%[sdj%]/g;
var $dbddff8435a61653$var$warning = function warning() {}; // don't print warning message when in production env or node runtime
typeof $d1d9b4516838462f$exports !== 'undefined' && $d1d9b4516838462f$exports.env;
function $dbddff8435a61653$var$convertFieldsError(errors) {
    if (!errors || !errors.length) return null;
    var fields = {};
    errors.forEach(function(error) {
        var field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $dbddff8435a61653$var$format(template) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var i = 0;
    var len = args.length;
    if (typeof template === 'function') return template.apply(null, args);
    if (typeof template === 'string') {
        var str = template.replace($dbddff8435a61653$var$formatRegExp, function(x) {
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch(x){
                case '%s':
                    return String(args[i++]);
                case '%d':
                    return Number(args[i++]);
                case '%j':
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return '[Circular]';
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $dbddff8435a61653$var$isNativeStringType(type) {
    return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern';
}
function $dbddff8435a61653$var$isEmptyValue(value, type) {
    if (value === undefined || value === null) return true;
    if (type === 'array' && Array.isArray(value) && !value.length) return true;
    if ($dbddff8435a61653$var$isNativeStringType(type) && typeof value === 'string' && !value) return true;
    return false;
}
function $dbddff8435a61653$var$asyncParallelArray(arr, func, callback) {
    var results = [];
    var total = 0;
    var arrLength = arr.length;
    function count(errors) {
        results.push.apply(results, errors || []);
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach(function(a) {
        func(a, count);
    });
}
function $dbddff8435a61653$var$asyncSerialArray(arr, func, callback) {
    var index = 0;
    var arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        var original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $dbddff8435a61653$var$flattenObjArr(objArr) {
    var ret = [];
    Object.keys(objArr).forEach(function(k) {
        ret.push.apply(ret, objArr[k] || []);
    });
    return ret;
}
var $dbddff8435a61653$var$AsyncValidationError = /*#__PURE__*/ function(_Error) {
    $dbddff8435a61653$var$_inheritsLoose(AsyncValidationError, _Error);
    function AsyncValidationError(errors, fields) {
        var _this;
        _this = _Error.call(this, 'Async Validation Error') || this;
        _this.errors = errors;
        _this.fields = fields;
        return _this;
    }
    return AsyncValidationError;
}(/*#__PURE__*/ $dbddff8435a61653$var$_wrapNativeSuper(Error));
function $dbddff8435a61653$var$asyncMap(objArr, option, func, callback, source) {
    if (option.first) {
        var _pending = new Promise(function(resolve, reject) {
            var next = function next(errors) {
                callback(errors);
                return errors.length ? reject(new $dbddff8435a61653$var$AsyncValidationError(errors, $dbddff8435a61653$var$convertFieldsError(errors))) : resolve(source);
            };
            var flattenArr = $dbddff8435a61653$var$flattenObjArr(objArr);
            $dbddff8435a61653$var$asyncSerialArray(flattenArr, func, next);
        });
        _pending["catch"](function(e) {
            return e;
        });
        return _pending;
    }
    var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    var objArrKeys = Object.keys(objArr);
    var objArrLength = objArrKeys.length;
    var total = 0;
    var results = [];
    var pending = new Promise(function(resolve, reject) {
        var next = function next(errors) {
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $dbddff8435a61653$var$AsyncValidationError(results, $dbddff8435a61653$var$convertFieldsError(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach(function(key) {
            var arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $dbddff8435a61653$var$asyncSerialArray(arr, func, next);
            else $dbddff8435a61653$var$asyncParallelArray(arr, func, next);
        });
    });
    pending["catch"](function(e) {
        return e;
    });
    return pending;
}
function $dbddff8435a61653$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $dbddff8435a61653$var$getValue(value, path) {
    var v = value;
    for(var i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $dbddff8435a61653$var$complementError(rule, source) {
    return function(oe) {
        var fieldValue;
        if (rule.fullFields) fieldValue = $dbddff8435a61653$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($dbddff8435a61653$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === 'function' ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $dbddff8435a61653$var$deepMerge(target, source) {
    if (source) {
        for(var s in source)if (source.hasOwnProperty(s)) {
            var value = source[s];
            if (typeof value === 'object' && typeof target[s] === 'object') target[s] = $dbddff8435a61653$var$_extends({}, target[s], value);
            else target[s] = value;
        }
    }
    return target;
}
var $dbddff8435a61653$var$required$1 = function required(rule, value, source, errors, options, type) {
    if (rule.required && (!source.hasOwnProperty(rule.field) || $dbddff8435a61653$var$isEmptyValue(value, type || rule.type))) errors.push($dbddff8435a61653$var$format(options.messages.required, rule.fullField));
};
/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ var $dbddff8435a61653$var$whitespace = function whitespace(rule, value, source, errors, options) {
    if (/^\s+$/.test(value) || value === '') errors.push($dbddff8435a61653$var$format(options.messages.whitespace, rule.fullField));
};
// https://github.com/kevva/url-regex/blob/master/index.js
var $dbddff8435a61653$var$urlReg;
var $dbddff8435a61653$var$getUrlRegex = function() {
    if ($dbddff8435a61653$var$urlReg) return $dbddff8435a61653$var$urlReg;
    var word = '[a-fA-F\\d:]';
    var b = function b(options) {
        return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=" + word + ")|(?<=" + word + ")(?=\\s|$))" : '';
    };
    var v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
    var v6seg = '[a-fA-F\\d]{1,4}';
    var v6 = ("\n(?:\n(?:" + v6seg + ":){7}(?:" + v6seg + "|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:" + v6seg + ":){6}(?:" + v4 + "|:" + v6seg + "|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:" + v6seg + ":){5}(?::" + v4 + "|(?::" + v6seg + "){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:" + v6seg + ":){4}(?:(?::" + v6seg + "){0,1}:" + v4 + "|(?::" + v6seg + "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:" + v6seg + ":){3}(?:(?::" + v6seg + "){0,2}:" + v4 + "|(?::" + v6seg + "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:" + v6seg + ":){2}(?:(?::" + v6seg + "){0,3}:" + v4 + "|(?::" + v6seg + "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:" + v6seg + ":){1}(?:(?::" + v6seg + "){0,4}:" + v4 + "|(?::" + v6seg + "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::(?:(?::" + v6seg + "){0,5}:" + v4 + "|(?::" + v6seg + "){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1\n").replace(/\s*\/\/.*$/gm, '').replace(/\n/g, '').trim(); // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    var v46Exact = new RegExp("(?:^" + v4 + "$)|(?:^" + v6 + "$)");
    var v4exact = new RegExp("^" + v4 + "$");
    var v6exact = new RegExp("^" + v6 + "$");
    var ip = function ip(options) {
        return options && options.exact ? v46Exact : new RegExp("(?:" + b(options) + v4 + b(options) + ")|(?:" + b(options) + v6 + b(options) + ")", 'g');
    };
    ip.v4 = function(options) {
        return options && options.exact ? v4exact : new RegExp("" + b(options) + v4 + b(options), 'g');
    };
    ip.v6 = function(options) {
        return options && options.exact ? v6exact : new RegExp("" + b(options) + v6 + b(options), 'g');
    };
    var protocol = "(?:(?:[a-z]+:)?//)";
    var auth = '(?:\\S+(?::\\S*)?@)?';
    var ipv4 = ip.v4().source;
    var ipv6 = ip.v6().source;
    var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
    var port = '(?::\\d{2,5})?';
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:" + protocol + "|www\\.)" + auth + "(?:localhost|" + ipv4 + "|" + ipv6 + "|" + host + domain + tld + ")" + port + path;
    $dbddff8435a61653$var$urlReg = new RegExp("(?:^" + regex + "$)", 'i');
    return $dbddff8435a61653$var$urlReg;
};
/* eslint max-len:0 */ var $dbddff8435a61653$var$pattern$2 = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var $dbddff8435a61653$var$types = {
    integer: function integer(value) {
        return $dbddff8435a61653$var$types.number(value) && parseInt(value, 10) === value;
    },
    "float": function float(value) {
        return $dbddff8435a61653$var$types.number(value) && !$dbddff8435a61653$var$types.integer(value);
    },
    array: function array(value) {
        return Array.isArray(value);
    },
    regexp: function regexp(value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date: function date(value) {
        return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
    },
    number: function number(value) {
        if (isNaN(value)) return false;
        return typeof value === 'number';
    },
    object: function object(value) {
        return typeof value === 'object' && !$dbddff8435a61653$var$types.array(value);
    },
    method: function method(value) {
        return typeof value === 'function';
    },
    email: function email(value) {
        return typeof value === 'string' && value.length <= 320 && !!value.match($dbddff8435a61653$var$pattern$2.email);
    },
    url: function url(value) {
        return typeof value === 'string' && value.length <= 2048 && !!value.match($dbddff8435a61653$var$getUrlRegex());
    },
    hex: function hex(value) {
        return typeof value === 'string' && !!value.match($dbddff8435a61653$var$pattern$2.hex);
    }
};
var $dbddff8435a61653$var$type$1 = function type(rule, value, source, errors, options) {
    if (rule.required && value === undefined) {
        $dbddff8435a61653$var$required$1(rule, value, source, errors, options);
        return;
    }
    var custom = [
        'integer',
        'float',
        'array',
        'regexp',
        'object',
        'method',
        'email',
        'number',
        'date',
        'url',
        'hex'
    ];
    var ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$dbddff8435a61653$var$types[ruleType](value)) errors.push($dbddff8435a61653$var$format(options.messages.types[ruleType], rule.fullField, rule.type));
         // straight typeof check
    } else if (ruleType && typeof value !== rule.type) errors.push($dbddff8435a61653$var$format(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $dbddff8435a61653$var$range = function range(rule, value, source, errors, options) {
    var len = typeof rule.len === 'number';
    var min = typeof rule.min === 'number';
    var max = typeof rule.max === 'number'; // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var val = value;
    var key = null;
    var num = typeof value === 'number';
    var str = typeof value === 'string';
    var arr = Array.isArray(value);
    if (num) key = 'number';
    else if (str) key = 'string';
    else if (arr) key = 'array';
     // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
    if (len) {
        if (val !== rule.len) errors.push($dbddff8435a61653$var$format(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push($dbddff8435a61653$var$format(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push($dbddff8435a61653$var$format(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push($dbddff8435a61653$var$format(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $dbddff8435a61653$var$ENUM$1 = 'enum';
var $dbddff8435a61653$var$enumerable$1 = function enumerable(rule, value, source, errors, options) {
    rule[$dbddff8435a61653$var$ENUM$1] = Array.isArray(rule[$dbddff8435a61653$var$ENUM$1]) ? rule[$dbddff8435a61653$var$ENUM$1] : [];
    if (rule[$dbddff8435a61653$var$ENUM$1].indexOf(value) === -1) errors.push($dbddff8435a61653$var$format(options.messages[$dbddff8435a61653$var$ENUM$1], rule.fullField, rule[$dbddff8435a61653$var$ENUM$1].join(', ')));
};
var $dbddff8435a61653$var$pattern$1 = function pattern(rule, value, source, errors, options) {
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push($dbddff8435a61653$var$format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === 'string') {
            var _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push($dbddff8435a61653$var$format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $dbddff8435a61653$var$rules = {
    required: $dbddff8435a61653$var$required$1,
    whitespace: $dbddff8435a61653$var$whitespace,
    type: $dbddff8435a61653$var$type$1,
    range: $dbddff8435a61653$var$range,
    "enum": $dbddff8435a61653$var$enumerable$1,
    pattern: $dbddff8435a61653$var$pattern$1
};
var $dbddff8435a61653$var$string = function string(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($dbddff8435a61653$var$isEmptyValue(value, 'string') && !rule.required) return callback();
        $dbddff8435a61653$var$rules.required(rule, value, source, errors, options, 'string');
        if (!$dbddff8435a61653$var$isEmptyValue(value, 'string')) {
            $dbddff8435a61653$var$rules.type(rule, value, source, errors, options);
            $dbddff8435a61653$var$rules.range(rule, value, source, errors, options);
            $dbddff8435a61653$var$rules.pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) $dbddff8435a61653$var$rules.whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $dbddff8435a61653$var$method = function method(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($dbddff8435a61653$var$isEmptyValue(value) && !rule.required) return callback();
        $dbddff8435a61653$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $dbddff8435a61653$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $dbddff8435a61653$var$number = function number(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === '') value = undefined;
        if ($dbddff8435a61653$var$isEmptyValue(value) && !rule.required) return callback();
        $dbddff8435a61653$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $dbddff8435a61653$var$rules.type(rule, value, source, errors, options);
            $dbddff8435a61653$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $dbddff8435a61653$var$_boolean = function _boolean(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($dbddff8435a61653$var$isEmptyValue(value) && !rule.required) return callback();
        $dbddff8435a61653$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $dbddff8435a61653$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $dbddff8435a61653$var$regexp = function regexp(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($dbddff8435a61653$var$isEmptyValue(value) && !rule.required) return callback();
        $dbddff8435a61653$var$rules.required(rule, value, source, errors, options);
        if (!$dbddff8435a61653$var$isEmptyValue(value)) $dbddff8435a61653$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $dbddff8435a61653$var$integer = function integer(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($dbddff8435a61653$var$isEmptyValue(value) && !rule.required) return callback();
        $dbddff8435a61653$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $dbddff8435a61653$var$rules.type(rule, value, source, errors, options);
            $dbddff8435a61653$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $dbddff8435a61653$var$floatFn = function floatFn(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($dbddff8435a61653$var$isEmptyValue(value) && !rule.required) return callback();
        $dbddff8435a61653$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) {
            $dbddff8435a61653$var$rules.type(rule, value, source, errors, options);
            $dbddff8435a61653$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $dbddff8435a61653$var$array = function array(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        $dbddff8435a61653$var$rules.required(rule, value, source, errors, options, 'array');
        if (value !== undefined && value !== null) {
            $dbddff8435a61653$var$rules.type(rule, value, source, errors, options);
            $dbddff8435a61653$var$rules.range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $dbddff8435a61653$var$object = function object(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($dbddff8435a61653$var$isEmptyValue(value) && !rule.required) return callback();
        $dbddff8435a61653$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $dbddff8435a61653$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $dbddff8435a61653$var$ENUM = 'enum';
var $dbddff8435a61653$var$enumerable = function enumerable(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($dbddff8435a61653$var$isEmptyValue(value) && !rule.required) return callback();
        $dbddff8435a61653$var$rules.required(rule, value, source, errors, options);
        if (value !== undefined) $dbddff8435a61653$var$rules[$dbddff8435a61653$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $dbddff8435a61653$var$pattern = function pattern(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($dbddff8435a61653$var$isEmptyValue(value, 'string') && !rule.required) return callback();
        $dbddff8435a61653$var$rules.required(rule, value, source, errors, options);
        if (!$dbddff8435a61653$var$isEmptyValue(value, 'string')) $dbddff8435a61653$var$rules.pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $dbddff8435a61653$var$date = function date(rule, value, callback, source, options) {
    // console.log('integer rule called %j', rule);
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field); // console.log('validate on %s value', value);
    if (validate) {
        if ($dbddff8435a61653$var$isEmptyValue(value, 'date') && !rule.required) return callback();
        $dbddff8435a61653$var$rules.required(rule, value, source, errors, options);
        if (!$dbddff8435a61653$var$isEmptyValue(value, 'date')) {
            var dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            $dbddff8435a61653$var$rules.type(rule, dateObject, source, errors, options);
            if (dateObject) $dbddff8435a61653$var$rules.range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $dbddff8435a61653$var$required = function required(rule, value, callback, source, options) {
    var errors = [];
    var type = Array.isArray(value) ? 'array' : typeof value;
    $dbddff8435a61653$var$rules.required(rule, value, source, errors, options, type);
    callback(errors);
};
var $dbddff8435a61653$var$type = function type(rule, value, callback, source, options) {
    var ruleType = rule.type;
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($dbddff8435a61653$var$isEmptyValue(value, ruleType) && !rule.required) return callback();
        $dbddff8435a61653$var$rules.required(rule, value, source, errors, options, ruleType);
        if (!$dbddff8435a61653$var$isEmptyValue(value, ruleType)) $dbddff8435a61653$var$rules.type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $dbddff8435a61653$var$any = function any(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ($dbddff8435a61653$var$isEmptyValue(value) && !rule.required) return callback();
        $dbddff8435a61653$var$rules.required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $dbddff8435a61653$var$validators = {
    string: $dbddff8435a61653$var$string,
    method: $dbddff8435a61653$var$method,
    number: $dbddff8435a61653$var$number,
    "boolean": $dbddff8435a61653$var$_boolean,
    regexp: $dbddff8435a61653$var$regexp,
    integer: $dbddff8435a61653$var$integer,
    "float": $dbddff8435a61653$var$floatFn,
    array: $dbddff8435a61653$var$array,
    object: $dbddff8435a61653$var$object,
    "enum": $dbddff8435a61653$var$enumerable,
    pattern: $dbddff8435a61653$var$pattern,
    date: $dbddff8435a61653$var$date,
    url: $dbddff8435a61653$var$type,
    hex: $dbddff8435a61653$var$type,
    email: $dbddff8435a61653$var$type,
    required: $dbddff8435a61653$var$required,
    any: $dbddff8435a61653$var$any
};
function $dbddff8435a61653$var$newMessages() {
    return {
        "default": 'Validation error on field %s',
        required: '%s is required',
        "enum": '%s must be one of %s',
        whitespace: '%s cannot be empty',
        date: {
            format: '%s date %s is invalid for format %s',
            parse: '%s date could not be parsed, %s is invalid ',
            invalid: '%s date %s is invalid'
        },
        types: {
            string: '%s is not a %s',
            method: '%s is not a %s (function)',
            array: '%s is not an %s',
            object: '%s is not an %s',
            number: '%s is not a %s',
            date: '%s is not a %s',
            "boolean": '%s is not a %s',
            integer: '%s is not an %s',
            "float": '%s is not a %s',
            regexp: '%s is not a valid %s',
            email: '%s is not a valid %s',
            url: '%s is not a valid %s',
            hex: '%s is not a valid %s'
        },
        string: {
            len: '%s must be exactly %s characters',
            min: '%s must be at least %s characters',
            max: '%s cannot be longer than %s characters',
            range: '%s must be between %s and %s characters'
        },
        number: {
            len: '%s must equal %s',
            min: '%s cannot be less than %s',
            max: '%s cannot be greater than %s',
            range: '%s must be between %s and %s'
        },
        array: {
            len: '%s must be exactly %s in length',
            min: '%s cannot be less than %s in length',
            max: '%s cannot be greater than %s in length',
            range: '%s must be between %s and %s in length'
        },
        pattern: {
            mismatch: '%s value %s does not match pattern %s'
        },
        clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
var $dbddff8435a61653$var$messages = $dbddff8435a61653$var$newMessages();
/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ var $dbddff8435a61653$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // ========================= Static =========================
    // ======================== Instance ========================
    function Schema(descriptor) {
        this.rules = null;
        this._messages = $dbddff8435a61653$var$messages;
        this.define(descriptor);
    }
    var _proto = Schema.prototype;
    _proto.define = function define(rules) {
        var _this = this;
        if (!rules) throw new Error('Cannot configure a schema with no rules');
        if (typeof rules !== 'object' || Array.isArray(rules)) throw new Error('Rules must be an object');
        this.rules = {};
        Object.keys(rules).forEach(function(name) {
            var item = rules[name];
            _this.rules[name] = Array.isArray(item) ? item : [
                item
            ];
        });
    };
    _proto.messages = function messages(_messages) {
        if (_messages) this._messages = $dbddff8435a61653$var$deepMerge($dbddff8435a61653$var$newMessages(), _messages);
        return this._messages;
    };
    _proto.validate = function validate(source_, o, oc) {
        var _this2 = this;
        if (o === void 0) o = {};
        if (oc === void 0) oc = function oc() {};
        var source = source_;
        var options = o;
        var callback = oc;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (!this.rules || Object.keys(this.rules).length === 0) {
            if (callback) callback(null, source);
            return Promise.resolve(source);
        }
        function complete(results) {
            var errors = [];
            var fields = {};
            function add(e) {
                if (Array.isArray(e)) {
                    var _errors;
                    errors = (_errors = errors).concat.apply(_errors, e);
                } else errors.push(e);
            }
            for(var i = 0; i < results.length; i++)add(results[i]);
            if (!errors.length) callback(null, source);
            else {
                fields = $dbddff8435a61653$var$convertFieldsError(errors);
                callback(errors, fields);
            }
        }
        if (options.messages) {
            var messages$1 = this.messages();
            if (messages$1 === $dbddff8435a61653$var$messages) messages$1 = $dbddff8435a61653$var$newMessages();
            $dbddff8435a61653$var$deepMerge(messages$1, options.messages);
            options.messages = messages$1;
        } else options.messages = this.messages();
        var series = {};
        var keys = options.keys || Object.keys(this.rules);
        keys.forEach(function(z) {
            var arr = _this2.rules[z];
            var value = source[z];
            arr.forEach(function(r) {
                var rule = r;
                if (typeof rule.transform === 'function') {
                    if (source === source_) source = $dbddff8435a61653$var$_extends({}, source);
                    value = source[z] = rule.transform(value);
                }
                if (typeof rule === 'function') rule = {
                    validator: rule
                };
                else rule = $dbddff8435a61653$var$_extends({}, rule);
                 // Fill validator. Skip if nothing need to validate
                rule.validator = _this2.getValidationMethod(rule);
                if (!rule.validator) return;
                rule.field = z;
                rule.fullField = rule.fullField || z;
                rule.type = _this2.getType(rule);
                series[z] = series[z] || [];
                series[z].push({
                    rule: rule,
                    value: value,
                    source: source,
                    field: z
                });
            });
        });
        var errorFields = {};
        return $dbddff8435a61653$var$asyncMap(series, options, function(data, doIt) {
            var rule = data.rule;
            var deep = (rule.type === 'object' || rule.type === 'array') && (typeof rule.fields === 'object' || typeof rule.defaultField === 'object');
            deep = deep && (rule.required || !rule.required && data.value);
            rule.field = data.field;
            function addFullField(key, schema) {
                return $dbddff8435a61653$var$_extends({}, schema, {
                    fullField: rule.fullField + "." + key,
                    fullFields: rule.fullFields ? [].concat(rule.fullFields, [
                        key
                    ]) : [
                        key
                    ]
                });
            }
            function cb(e) {
                if (e === void 0) e = [];
                var errorList = Array.isArray(e) ? e : [
                    e
                ];
                if (!options.suppressWarning && errorList.length) Schema.warning('async-validator:', errorList);
                if (errorList.length && rule.message !== undefined) errorList = [].concat(rule.message);
                 // Fill error info
                var filledErrors = errorList.map($dbddff8435a61653$var$complementError(rule, source));
                if (options.first && filledErrors.length) {
                    errorFields[rule.field] = 1;
                    return doIt(filledErrors);
                }
                if (!deep) doIt(filledErrors);
                else {
                    // if rule is required but the target object
                    // does not exist fail at the rule level and don't
                    // go deeper
                    if (rule.required && !data.value) {
                        if (rule.message !== undefined) filledErrors = [].concat(rule.message).map($dbddff8435a61653$var$complementError(rule, source));
                        else if (options.error) filledErrors = [
                            options.error(rule, $dbddff8435a61653$var$format(options.messages.required, rule.field))
                        ];
                        return doIt(filledErrors);
                    }
                    var fieldsSchema = {};
                    if (rule.defaultField) Object.keys(data.value).map(function(key) {
                        fieldsSchema[key] = rule.defaultField;
                    });
                    fieldsSchema = $dbddff8435a61653$var$_extends({}, fieldsSchema, data.rule.fields);
                    var paredFieldsSchema = {};
                    Object.keys(fieldsSchema).forEach(function(field) {
                        var fieldSchema = fieldsSchema[field];
                        var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                            fieldSchema
                        ];
                        paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                    });
                    var schema = new Schema(paredFieldsSchema);
                    schema.messages(options.messages);
                    if (data.rule.options) {
                        data.rule.options.messages = options.messages;
                        data.rule.options.error = options.error;
                    }
                    schema.validate(data.value, data.rule.options || options, function(errs) {
                        var finalErrors = [];
                        if (filledErrors && filledErrors.length) finalErrors.push.apply(finalErrors, filledErrors);
                        if (errs && errs.length) finalErrors.push.apply(finalErrors, errs);
                        doIt(finalErrors.length ? finalErrors : null);
                    });
                }
            }
            var res;
            if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
            else if (rule.validator) {
                try {
                    res = rule.validator(rule, data.value, cb, data.source, options);
                } catch (error) {
                    console.error == null || console.error(error); // rethrow to report error
                    if (!options.suppressValidatorError) setTimeout(function() {
                        throw error;
                    }, 0);
                    cb(error.message);
                }
                if (res === true) cb();
                else if (res === false) cb(typeof rule.message === 'function' ? rule.message(rule.fullField || rule.field) : rule.message || (rule.fullField || rule.field) + " fails");
                else if (res instanceof Array) cb(res);
                else if (res instanceof Error) cb(res.message);
            }
            if (res && res.then) res.then(function() {
                return cb();
            }, function(e) {
                return cb(e);
            });
        }, function(results) {
            complete(results);
        }, source);
    };
    _proto.getType = function getType(rule) {
        if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = 'pattern';
        if (typeof rule.validator !== 'function' && rule.type && !$dbddff8435a61653$var$validators.hasOwnProperty(rule.type)) throw new Error($dbddff8435a61653$var$format('Unknown rule type %s', rule.type));
        return rule.type || 'string';
    };
    _proto.getValidationMethod = function getValidationMethod(rule) {
        if (typeof rule.validator === 'function') return rule.validator;
        var keys = Object.keys(rule);
        var messageIndex = keys.indexOf('message');
        if (messageIndex !== -1) keys.splice(messageIndex, 1);
        if (keys.length === 1 && keys[0] === 'required') return $dbddff8435a61653$var$validators.required;
        return $dbddff8435a61653$var$validators[this.getType(rule)] || undefined;
    };
    return Schema;
}();
$dbddff8435a61653$export$2e2bcd8739ae039.register = function register(type, validator) {
    if (typeof validator !== 'function') throw new Error('Cannot register a validator by type, validator is not a function');
    $dbddff8435a61653$var$validators[type] = validator;
};
$dbddff8435a61653$export$2e2bcd8739ae039.warning = $dbddff8435a61653$var$warning;
$dbddff8435a61653$export$2e2bcd8739ae039.messages = $dbddff8435a61653$var$messages;
$dbddff8435a61653$export$2e2bcd8739ae039.validators = $dbddff8435a61653$var$validators;



var $6fFrj = parcelRequire("6fFrj");

var $3mXQ2 = parcelRequire("3mXQ2");
var $ec33e4fb64ae3c21$var$typeTemplate = "'${name}' is not a valid ${type}";
var $ec33e4fb64ae3c21$export$c86b939816b8fbf8 = {
    default: "Validation error on field '${name}'",
    required: "'${name}' is required",
    enum: "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: $ec33e4fb64ae3c21$var$typeTemplate,
        method: $ec33e4fb64ae3c21$var$typeTemplate,
        array: $ec33e4fb64ae3c21$var$typeTemplate,
        object: $ec33e4fb64ae3c21$var$typeTemplate,
        number: $ec33e4fb64ae3c21$var$typeTemplate,
        date: $ec33e4fb64ae3c21$var$typeTemplate,
        boolean: $ec33e4fb64ae3c21$var$typeTemplate,
        integer: $ec33e4fb64ae3c21$var$typeTemplate,
        float: $ec33e4fb64ae3c21$var$typeTemplate,
        regexp: $ec33e4fb64ae3c21$var$typeTemplate,
        email: $ec33e4fb64ae3c21$var$typeTemplate,
        url: $ec33e4fb64ae3c21$var$typeTemplate,
        hex: $ec33e4fb64ae3c21$var$typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};



var $i5KV1 = parcelRequire("i5KV1");
// Remove incorrect original ts define
var $071b432a6a55427d$var$AsyncValidator = (0, $dbddff8435a61653$export$2e2bcd8739ae039);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function $071b432a6a55427d$var$replaceMessage(template, kv) {
    return template.replace(/\$\{\w+\}/g, function(str) {
        var key = str.slice(2, -1);
        return kv[key];
    });
}
var $071b432a6a55427d$var$CODE_LOGIC_ERROR = 'CODE_LOGIC_ERROR';
function $071b432a6a55427d$var$validateRule(_x, _x2, _x3, _x4, _x5) {
    return $071b432a6a55427d$var$_validateRule.apply(this, arguments);
}
/**
 * We use `async-validator` to validate the value.
 * But only check one value in a time to avoid namePath validate issue.
 */ function $071b432a6a55427d$var$_validateRule() {
    $071b432a6a55427d$var$_validateRule = (0, $47DhB.default)(/*#__PURE__*/ (0, $1WWLf.default)().mark(function _callee2(name, value, rule, options, messageVariables) {
        var cloneRule, originValidator, subRuleField, validator, messages, result, subResults, kv, fillVariableResult;
        return (0, $1WWLf.default)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    cloneRule = (0, $kNxFX.default)({}, rule); // Bug of `async-validator`
                    // https://github.com/react-component/field-form/issues/316
                    // https://github.com/react-component/field-form/issues/313
                    delete cloneRule.ruleIndex;
                    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
                    $071b432a6a55427d$var$AsyncValidator.warning = function() {
                        return void 0;
                    };
                    if (cloneRule.validator) {
                        originValidator = cloneRule.validator;
                        cloneRule.validator = function() {
                            try {
                                return originValidator.apply(void 0, arguments);
                            } catch (error) {
                                console.error(error);
                                return Promise.reject($071b432a6a55427d$var$CODE_LOGIC_ERROR);
                            }
                        };
                    }
                    // We should special handle array validate
                    subRuleField = null;
                    if (cloneRule && cloneRule.type === 'array' && cloneRule.defaultField) {
                        subRuleField = cloneRule.defaultField;
                        delete cloneRule.defaultField;
                    }
                    validator = new $071b432a6a55427d$var$AsyncValidator((0, $43449.default)({}, name, [
                        cloneRule
                    ]));
                    messages = (0, $i5KV1.merge)((0, $ec33e4fb64ae3c21$export$c86b939816b8fbf8), options.validateMessages);
                    validator.messages(messages);
                    result = [];
                    _context2.prev = 10;
                    _context2.next = 13;
                    return Promise.resolve(validator.validate((0, $43449.default)({}, name, value), (0, $kNxFX.default)({}, options)));
                case 13:
                    _context2.next = 18;
                    break;
                case 15:
                    _context2.prev = 15;
                    _context2.t0 = _context2["catch"](10);
                    if (_context2.t0.errors) result = _context2.t0.errors.map(function(_ref4, index) {
                        var message = _ref4.message;
                        var mergedMessage = message === $071b432a6a55427d$var$CODE_LOGIC_ERROR ? messages.default : message;
                        return /*#__PURE__*/ $6fFrj.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
                        $6fFrj.cloneElement(mergedMessage, {
                            key: "error_".concat(index)
                        }) : mergedMessage;
                    });
                case 18:
                    if (!(!result.length && subRuleField)) {
                        _context2.next = 23;
                        break;
                    }
                    _context2.next = 21;
                    return Promise.all(value.map(function(subValue, i) {
                        return $071b432a6a55427d$var$validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
                    }));
                case 21:
                    subResults = _context2.sent;
                    return _context2.abrupt("return", subResults.reduce(function(prev, errors) {
                        return [].concat((0, $37xND.default)(prev), (0, $37xND.default)(errors));
                    }, []));
                case 23:
                    // Replace message with variables
                    kv = (0, $kNxFX.default)((0, $kNxFX.default)({}, rule), {}, {
                        name: name,
                        enum: (rule.enum || []).join(', ')
                    }, messageVariables);
                    fillVariableResult = result.map(function(error) {
                        if (typeof error === 'string') return $071b432a6a55427d$var$replaceMessage(error, kv);
                        return error;
                    });
                    return _context2.abrupt("return", fillVariableResult);
                case 26:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                10,
                15
            ]
        ]);
    }));
    return $071b432a6a55427d$var$_validateRule.apply(this, arguments);
}
function $071b432a6a55427d$export$e1fc4b442d0297dd(namePath, value, rules, options, validateFirst, messageVariables) {
    var name = namePath.join('.');
    // Fill rule with context
    var filledRules = rules.map(function(currentRule, ruleIndex) {
        var originValidatorFunc = currentRule.validator;
        var cloneRule = (0, $kNxFX.default)((0, $kNxFX.default)({}, currentRule), {}, {
            ruleIndex: ruleIndex
        });
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = function(rule, val, callback) {
            var hasPromise = false;
            // Wrap callback only accept when promise not provided
            var wrappedCallback = function wrappedCallback() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(function() {
                    (0, $3mXQ2.default)(!hasPromise, 'Your validator function has already return a promise. `callback` will be ignored.');
                    if (!hasPromise) callback.apply(void 0, args);
                });
            };
            // Get promise
            var promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === 'function' && typeof promise.catch === 'function';
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, $3mXQ2.default)(hasPromise, '`callback` is deprecated. Please return a promise instead.');
            if (hasPromise) promise.then(function() {
                callback();
            }).catch(function(err) {
                callback(err || ' ');
            });
        };
        return cloneRule;
    }).sort(function(_ref, _ref2) {
        var w1 = _ref.warningOnly, i1 = _ref.ruleIndex;
        var w2 = _ref2.warningOnly, i2 = _ref2.ruleIndex;
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    var summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(/*#__PURE__*/ function() {
        var _ref3 = (0, $47DhB.default)(/*#__PURE__*/ (0, $1WWLf.default)().mark(function _callee(resolve, reject) {
            var i, rule, errors;
            return (0, $1WWLf.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        i = 0;
                    case 1:
                        if (!(i < filledRules.length)) {
                            _context.next = 12;
                            break;
                        }
                        rule = filledRules[i];
                        _context.next = 5;
                        return $071b432a6a55427d$var$validateRule(name, value, rule, options, messageVariables);
                    case 5:
                        errors = _context.sent;
                        if (!errors.length) {
                            _context.next = 9;
                            break;
                        }
                        reject([
                            {
                                errors: errors,
                                rule: rule
                            }
                        ]);
                        return _context.abrupt("return");
                    case 9:
                        i += 1;
                        _context.next = 1;
                        break;
                    case 12:
                        /* eslint-enable */ resolve([]);
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x6, _x7) {
            return _ref3.apply(this, arguments);
        };
    }());
    else {
        // >>>>> Validate by parallel
        var rulePromises = filledRules.map(function(rule) {
            return $071b432a6a55427d$var$validateRule(name, value, rule, options, messageVariables).then(function(errors) {
                return {
                    errors: errors,
                    rule: rule
                };
            });
        });
        summaryPromise = (validateFirst ? $071b432a6a55427d$var$finishOnFirstFailed(rulePromises) : $071b432a6a55427d$var$finishOnAllFailed(rulePromises)).then(function(errors) {
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise.catch(function(e) {
        return e;
    });
    return summaryPromise;
}
function $071b432a6a55427d$var$finishOnAllFailed(_x8) {
    return $071b432a6a55427d$var$_finishOnAllFailed.apply(this, arguments);
}
function $071b432a6a55427d$var$_finishOnAllFailed() {
    $071b432a6a55427d$var$_finishOnAllFailed = (0, $47DhB.default)(/*#__PURE__*/ (0, $1WWLf.default)().mark(function _callee3(rulePromises) {
        return (0, $1WWLf.default)().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", Promise.all(rulePromises).then(function(errorsList) {
                        var _ref5;
                        var errors = (_ref5 = []).concat.apply(_ref5, (0, $37xND.default)(errorsList));
                        return errors;
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $071b432a6a55427d$var$_finishOnAllFailed.apply(this, arguments);
}
function $071b432a6a55427d$var$finishOnFirstFailed(_x9) {
    return $071b432a6a55427d$var$_finishOnFirstFailed.apply(this, arguments);
}
function $071b432a6a55427d$var$_finishOnFirstFailed() {
    $071b432a6a55427d$var$_finishOnFirstFailed = (0, $47DhB.default)(/*#__PURE__*/ (0, $1WWLf.default)().mark(function _callee4(rulePromises) {
        var count;
        return (0, $1WWLf.default)().wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    count = 0;
                    return _context4.abrupt("return", new Promise(function(resolve) {
                        rulePromises.forEach(function(promise) {
                            promise.then(function(ruleError) {
                                if (ruleError.errors.length) resolve([
                                    ruleError
                                ]);
                                count += 1;
                                if (count === rulePromises.length) resolve([]);
                            });
                        });
                    }));
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return $071b432a6a55427d$var$_finishOnFirstFailed.apply(this, arguments);
}



var $37xND = parcelRequire("37xND");

var $5KhTJ = parcelRequire("5KhTJ");

var $ij6y6 = parcelRequire("ij6y6");

var $i5KV1 = parcelRequire("i5KV1");

function $3271628c61de9d87$export$f877b3cb4cb4ccf9(path) {
    return (0, $e24ebc1f4c7a8e3c$export$45b10814cc054894)(path);
}
function $3271628c61de9d87$export$f5be6dfb30403c59(store, namePathList) {
    var newStore = {};
    namePathList.forEach(function(namePath) {
        var value = (0, $ij6y6.default)(store, namePath);
        newStore = (0, $i5KV1.default)(newStore, namePath, value);
    });
    return newStore;
}
function $3271628c61de9d87$export$646d5504364ae55b(namePathList, namePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return namePathList && namePathList.some(function(path) {
        return $3271628c61de9d87$export$325a4bd0e71bdc3a(namePath, path, partialMatch);
    });
}
function $3271628c61de9d87$export$325a4bd0e71bdc3a(namePath, subNamePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every(function(nameUnit, i) {
        return namePath[i] === nameUnit;
    });
}
function $3271628c61de9d87$export$dfcec05bb7372a54(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || (0, $5KhTJ.default)(source) !== 'object' || (0, $5KhTJ.default)(target) !== 'object') return false;
    var sourceKeys = Object.keys(source);
    var targetKeys = Object.keys(target);
    var keys = new Set([].concat(sourceKeys, targetKeys));
    return (0, $37xND.default)(keys).every(function(key) {
        var sourceValue = source[key];
        var targetValue = target[key];
        if (typeof sourceValue === 'function' && typeof targetValue === 'function') return true;
        return sourceValue === targetValue;
    });
}
function $3271628c61de9d87$export$6eeac3c5b406fb30(valuePropName) {
    var event = arguments.length <= 1 ? undefined : arguments[1];
    if (event && event.target && (0, $5KhTJ.default)(event.target) === 'object' && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function $3271628c61de9d87$export$d947e5f4f4c48d48(array, moveIndex, toIndex) {
    var length = array.length;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    var item = array[moveIndex];
    var diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [].concat((0, $37xND.default)(array.slice(0, toIndex)), [
        item
    ], (0, $37xND.default)(array.slice(toIndex, moveIndex)), (0, $37xND.default)(array.slice(moveIndex + 1, length)));
    if (diff < 0) // move right
    return [].concat((0, $37xND.default)(array.slice(0, moveIndex)), (0, $37xND.default)(array.slice(moveIndex + 1, toIndex + 1)), [
        item
    ], (0, $37xND.default)(array.slice(toIndex + 1, length)));
    return array;
}


var $ij6y6 = parcelRequire("ij6y6");
var $12bf411ce1aaed8f$var$_excluded = [
    "name"
];
var $12bf411ce1aaed8f$var$EMPTY_ERRORS = [];
function $12bf411ce1aaed8f$var$requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === 'function') return shouldUpdate(prev, next, 'source' in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
var $12bf411ce1aaed8f$var$Field = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(Field, _React$Component);
    var _super = (0, $lSufv.default)(Field);
    // ============================== Subscriptions ==============================
    function Field(props) {
        var _this;
        (0, $kjNeN.default)(this, Field);
        _this = _super.call(this, props);
        // Register on init
        (0, $43449.default)((0, $3mZgl.default)(_this), "state", {
            resetCount: 0
        });
        (0, $43449.default)((0, $3mZgl.default)(_this), "cancelRegisterFunc", null);
        (0, $43449.default)((0, $3mZgl.default)(_this), "mounted", false);
        /**
     * Follow state should not management in State since it will async update by React.
     * This makes first render of form can not get correct state value.
     */ (0, $43449.default)((0, $3mZgl.default)(_this), "touched", false);
        /**
     * Mark when touched & validated. Currently only used for `dependencies`.
     * Note that we do not think field with `initialValue` is dirty
     * but this will be by `isFieldDirty` func.
     */ (0, $43449.default)((0, $3mZgl.default)(_this), "dirty", false);
        (0, $43449.default)((0, $3mZgl.default)(_this), "validatePromise", void 0);
        (0, $43449.default)((0, $3mZgl.default)(_this), "prevValidating", void 0);
        (0, $43449.default)((0, $3mZgl.default)(_this), "errors", $12bf411ce1aaed8f$var$EMPTY_ERRORS);
        (0, $43449.default)((0, $3mZgl.default)(_this), "warnings", $12bf411ce1aaed8f$var$EMPTY_ERRORS);
        (0, $43449.default)((0, $3mZgl.default)(_this), "cancelRegister", function() {
            var _this$props = _this.props, preserve = _this$props.preserve, isListField = _this$props.isListField, name = _this$props.name;
            if (_this.cancelRegisterFunc) _this.cancelRegisterFunc(isListField, preserve, (0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)(name));
            _this.cancelRegisterFunc = null;
        });
        // ================================== Utils ==================================
        (0, $43449.default)((0, $3mZgl.default)(_this), "getNamePath", function() {
            var _this$props2 = _this.props, name = _this$props2.name, fieldContext = _this$props2.fieldContext;
            var _fieldContext$prefixN = fieldContext.prefixName, prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
            return name !== undefined ? [].concat((0, $37xND.default)(prefixName), (0, $37xND.default)(name)) : [];
        });
        (0, $43449.default)((0, $3mZgl.default)(_this), "getRules", function() {
            var _this$props3 = _this.props, _this$props3$rules = _this$props3.rules, rules = _this$props3$rules === void 0 ? [] : _this$props3$rules, fieldContext = _this$props3.fieldContext;
            return rules.map(function(rule) {
                if (typeof rule === 'function') return rule(fieldContext);
                return rule;
            });
        });
        (0, $43449.default)((0, $3mZgl.default)(_this), "refresh", function() {
            if (!_this.mounted) return;
            /**
       * Clean up current node.
       */ _this.setState(function(_ref) {
                var resetCount = _ref.resetCount;
                return {
                    resetCount: resetCount + 1
                };
            });
        });
        // Event should only trigger when meta changed
        (0, $43449.default)((0, $3mZgl.default)(_this), "metaCache", null);
        (0, $43449.default)((0, $3mZgl.default)(_this), "triggerMetaEvent", function(destroy) {
            var onMetaChange = _this.props.onMetaChange;
            if (onMetaChange) {
                var _meta = (0, $kNxFX.default)((0, $kNxFX.default)({}, _this.getMeta()), {}, {
                    destroy: destroy
                });
                if (!(0, $ae3c1fae8a247572$export$2e2bcd8739ae039)(_this.metaCache, _meta)) onMetaChange(_meta);
                _this.metaCache = _meta;
            } else _this.metaCache = null;
        });
        // ========================= Field Entity Interfaces =========================
        // Trigger by store update. Check if need update the component
        (0, $43449.default)((0, $3mZgl.default)(_this), "onStoreChange", function(prevStore, namePathList, info) {
            var _this$props4 = _this.props, shouldUpdate = _this$props4.shouldUpdate, _this$props4$dependen = _this$props4.dependencies, dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen, onReset = _this$props4.onReset;
            var store = info.store;
            var namePath = _this.getNamePath();
            var prevValue = _this.getValue(prevStore);
            var curValue = _this.getValue(store);
            var namePathMatch = namePathList && (0, $3271628c61de9d87$export$646d5504364ae55b)(namePathList, namePath);
            // `setFieldsValue` is a quick access to update related status
            if (info.type === 'valueUpdate' && info.source === 'external' && prevValue !== curValue) {
                _this.touched = true;
                _this.dirty = true;
                _this.validatePromise = null;
                _this.errors = $12bf411ce1aaed8f$var$EMPTY_ERRORS;
                _this.warnings = $12bf411ce1aaed8f$var$EMPTY_ERRORS;
                _this.triggerMetaEvent();
            }
            switch(info.type){
                case 'reset':
                    if (!namePathList || namePathMatch) {
                        // Clean up state
                        _this.touched = false;
                        _this.dirty = false;
                        _this.validatePromise = undefined;
                        _this.errors = $12bf411ce1aaed8f$var$EMPTY_ERRORS;
                        _this.warnings = $12bf411ce1aaed8f$var$EMPTY_ERRORS;
                        _this.triggerMetaEvent();
                        onReset === null || onReset === void 0 || onReset();
                        _this.refresh();
                        return;
                    }
                    break;
                /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */ case 'remove':
                    if (shouldUpdate) {
                        _this.reRender();
                        return;
                    }
                    break;
                case 'setField':
                    var data = info.data;
                    if (namePathMatch) {
                        if ('touched' in data) _this.touched = data.touched;
                        if ('validating' in data && !('originRCField' in data)) _this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ('errors' in data) _this.errors = data.errors || $12bf411ce1aaed8f$var$EMPTY_ERRORS;
                        if ('warnings' in data) _this.warnings = data.warnings || $12bf411ce1aaed8f$var$EMPTY_ERRORS;
                        _this.dirty = true;
                        _this.triggerMetaEvent();
                        _this.reRender();
                        return;
                    } else if ('value' in data && (0, $3271628c61de9d87$export$646d5504364ae55b)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        _this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && $12bf411ce1aaed8f$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
                case 'dependenciesUpdate':
                    /**
             * Trigger when marked `dependencies` updated. Related fields will all update
             */ var dependencyList = dependencies.map((0, $3271628c61de9d87$export$f877b3cb4cb4ccf9));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some(function(dependency) {
                        return (0, $3271628c61de9d87$export$646d5504364ae55b)(info.relatedFields, dependency);
                    })) {
                        _this.reRender();
                        return;
                    }
                    break;
                default:
                    // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                    //      For example <List name="list"><Field name={['list', 0]}></List>
                    //      If `namePathList` is [['list']] (List value update), Field should be updated
                    //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                    // 2.
                    //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                    //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                    //       is not provided
                    //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                    //       else to check if value changed
                    if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && $12bf411ce1aaed8f$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
            }
            if (shouldUpdate === true) _this.reRender();
        });
        (0, $43449.default)((0, $3mZgl.default)(_this), "validateRules", function(options) {
            // We should fixed namePath & value to avoid developer change then by form function
            var namePath = _this.getNamePath();
            var currentValue = _this.getValue();
            var _ref2 = options || {}, triggerName = _ref2.triggerName, _ref2$validateOnly = _ref2.validateOnly, validateOnly = _ref2$validateOnly === void 0 ? false : _ref2$validateOnly;
            // Force change to async to avoid rule OOD under renderProps field
            var rootPromise = Promise.resolve().then(/*#__PURE__*/ (0, $47DhB.default)(/*#__PURE__*/ (0, $1WWLf.default)().mark(function _callee() {
                var _this$props5, _this$props5$validate, validateFirst, messageVariables, validateDebounce, filteredRules, promise;
                return (0, $1WWLf.default)().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (_this.mounted) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 2:
                            _this$props5 = _this.props, _this$props5$validate = _this$props5.validateFirst, validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate, messageVariables = _this$props5.messageVariables, validateDebounce = _this$props5.validateDebounce; // Start validate
                            filteredRules = _this.getRules();
                            if (triggerName) filteredRules = filteredRules.filter(function(rule) {
                                return rule;
                            }).filter(function(rule) {
                                var validateTrigger = rule.validateTrigger;
                                if (!validateTrigger) return true;
                                var triggerList = (0, $e24ebc1f4c7a8e3c$export$45b10814cc054894)(validateTrigger);
                                return triggerList.includes(triggerName);
                            });
                            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
                            if (!(validateDebounce && triggerName)) {
                                _context.next = 10;
                                break;
                            }
                            _context.next = 8;
                            return new Promise(function(resolve) {
                                setTimeout(resolve, validateDebounce);
                            });
                        case 8:
                            if (!(_this.validatePromise !== rootPromise)) {
                                _context.next = 10;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 10:
                            promise = (0, $071b432a6a55427d$export$e1fc4b442d0297dd)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
                            promise.catch(function(e) {
                                return e;
                            }).then(function() {
                                var ruleErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $12bf411ce1aaed8f$var$EMPTY_ERRORS;
                                if (_this.validatePromise === rootPromise) {
                                    var _ruleErrors$forEach;
                                    _this.validatePromise = null;
                                    // Get errors & warnings
                                    var nextErrors = [];
                                    var nextWarnings = [];
                                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref4) {
                                        var warningOnly = _ref4.rule.warningOnly, _ref4$errors = _ref4.errors, errors = _ref4$errors === void 0 ? $12bf411ce1aaed8f$var$EMPTY_ERRORS : _ref4$errors;
                                        if (warningOnly) nextWarnings.push.apply(nextWarnings, (0, $37xND.default)(errors));
                                        else nextErrors.push.apply(nextErrors, (0, $37xND.default)(errors));
                                    });
                                    _this.errors = nextErrors;
                                    _this.warnings = nextWarnings;
                                    _this.triggerMetaEvent();
                                    _this.reRender();
                                }
                            });
                            return _context.abrupt("return", promise);
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            })));
            if (validateOnly) return rootPromise;
            _this.validatePromise = rootPromise;
            _this.dirty = true;
            _this.errors = $12bf411ce1aaed8f$var$EMPTY_ERRORS;
            _this.warnings = $12bf411ce1aaed8f$var$EMPTY_ERRORS;
            _this.triggerMetaEvent();
            // Force trigger re-render since we need sync renderProps with new meta
            _this.reRender();
            return rootPromise;
        });
        (0, $43449.default)((0, $3mZgl.default)(_this), "isFieldValidating", function() {
            return !!_this.validatePromise;
        });
        (0, $43449.default)((0, $3mZgl.default)(_this), "isFieldTouched", function() {
            return _this.touched;
        });
        (0, $43449.default)((0, $3mZgl.default)(_this), "isFieldDirty", function() {
            // Touched or validate or has initialValue
            if (_this.dirty || _this.props.initialValue !== undefined) return true;
            // Form set initialValue
            var fieldContext = _this.props.fieldContext;
            var _fieldContext$getInte = fieldContext.getInternalHooks((0, $096ab3393cfd7cdf$export$24829b7c0e49e9f7)), getInitialValue = _fieldContext$getInte.getInitialValue;
            if (getInitialValue(_this.getNamePath()) !== undefined) return true;
            return false;
        });
        (0, $43449.default)((0, $3mZgl.default)(_this), "getErrors", function() {
            return _this.errors;
        });
        (0, $43449.default)((0, $3mZgl.default)(_this), "getWarnings", function() {
            return _this.warnings;
        });
        (0, $43449.default)((0, $3mZgl.default)(_this), "isListField", function() {
            return _this.props.isListField;
        });
        (0, $43449.default)((0, $3mZgl.default)(_this), "isList", function() {
            return _this.props.isList;
        });
        (0, $43449.default)((0, $3mZgl.default)(_this), "isPreserve", function() {
            return _this.props.preserve;
        });
        // ============================= Child Component =============================
        (0, $43449.default)((0, $3mZgl.default)(_this), "getMeta", function() {
            // Make error & validating in cache to save perf
            _this.prevValidating = _this.isFieldValidating();
            var meta = {
                touched: _this.isFieldTouched(),
                validating: _this.prevValidating,
                errors: _this.errors,
                warnings: _this.warnings,
                name: _this.getNamePath(),
                validated: _this.validatePromise === null
            };
            return meta;
        });
        // Only return validate child node. If invalidate, will do nothing about field.
        (0, $43449.default)((0, $3mZgl.default)(_this), "getOnlyChild", function(children) {
            // Support render props
            if (typeof children === 'function') {
                var _meta2 = _this.getMeta();
                return (0, $kNxFX.default)((0, $kNxFX.default)({}, _this.getOnlyChild(children(_this.getControlled(), _meta2, _this.props.fieldContext))), {}, {
                    isFunction: true
                });
            }
            // Filed element only
            var childList = (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(children);
            if (childList.length !== 1 || !/*#__PURE__*/ $6fFrj.isValidElement(childList[0])) return {
                child: childList,
                isFunction: false
            };
            return {
                child: childList[0],
                isFunction: false
            };
        });
        // ============================== Field Control ==============================
        (0, $43449.default)((0, $3mZgl.default)(_this), "getValue", function(store) {
            var getFieldsValue = _this.props.fieldContext.getFieldsValue;
            var namePath = _this.getNamePath();
            return (0, $ij6y6.default)(store || getFieldsValue(true), namePath);
        });
        (0, $43449.default)((0, $3mZgl.default)(_this), "getControlled", function() {
            var childProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _this$props6 = _this.props, trigger = _this$props6.trigger, validateTrigger = _this$props6.validateTrigger, getValueFromEvent = _this$props6.getValueFromEvent, normalize = _this$props6.normalize, valuePropName = _this$props6.valuePropName, getValueProps = _this$props6.getValueProps, fieldContext = _this$props6.fieldContext;
            var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
            var namePath = _this.getNamePath();
            var getInternalHooks = fieldContext.getInternalHooks, getFieldsValue = fieldContext.getFieldsValue;
            var _getInternalHooks = getInternalHooks((0, $096ab3393cfd7cdf$export$24829b7c0e49e9f7)), dispatch = _getInternalHooks.dispatch;
            var value = _this.getValue();
            var mergedGetValueProps = getValueProps || function(val) {
                return (0, $43449.default)({}, valuePropName, val);
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var originTriggerFunc = childProps[trigger];
            var control = (0, $kNxFX.default)((0, $kNxFX.default)({}, childProps), mergedGetValueProps(value));
            // Add trigger
            control[trigger] = function() {
                // Mark as touched
                _this.touched = true;
                _this.dirty = true;
                _this.triggerMetaEvent();
                var newValue;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (getValueFromEvent) newValue = getValueFromEvent.apply(void 0, args);
                else newValue = (0, $3271628c61de9d87$export$6eeac3c5b406fb30).apply(void 0, [
                    valuePropName
                ].concat(args));
                if (normalize) newValue = normalize(newValue, value, getFieldsValue(true));
                dispatch({
                    type: 'updateValue',
                    namePath: namePath,
                    value: newValue
                });
                if (originTriggerFunc) originTriggerFunc.apply(void 0, args);
            };
            // Add validateTrigger
            var validateTriggerList = (0, $e24ebc1f4c7a8e3c$export$45b10814cc054894)(mergedValidateTrigger || []);
            validateTriggerList.forEach(function(triggerName) {
                // Wrap additional function of component, so that we can get latest value from store
                var originTrigger = control[triggerName];
                control[triggerName] = function() {
                    if (originTrigger) originTrigger.apply(void 0, arguments);
                    // Always use latest rules
                    var rules = _this.props.rules;
                    if (rules && rules.length) // We dispatch validate to root,
                    // since it will update related data with other field with same name
                    dispatch({
                        type: 'validateField',
                        namePath: namePath,
                        triggerName: triggerName
                    });
                };
            });
            return control;
        });
        if (props.fieldContext) {
            var getInternalHooks = props.fieldContext.getInternalHooks;
            var _getInternalHooks2 = getInternalHooks((0, $096ab3393cfd7cdf$export$24829b7c0e49e9f7)), initEntityValue = _getInternalHooks2.initEntityValue;
            initEntityValue((0, $3mZgl.default)(_this));
        }
        return _this;
    }
    (0, $5KQxu.default)(Field, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props7 = this.props, shouldUpdate = _this$props7.shouldUpdate, fieldContext = _this$props7.fieldContext;
                this.mounted = true;
                // Register on init
                if (fieldContext) {
                    var getInternalHooks = fieldContext.getInternalHooks;
                    var _getInternalHooks3 = getInternalHooks((0, $096ab3393cfd7cdf$export$24829b7c0e49e9f7)), registerField = _getInternalHooks3.registerField;
                    this.cancelRegisterFunc = registerField(this);
                }
                // One more render for component in case fields not ready
                if (shouldUpdate === true) this.reRender();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelRegister();
                this.triggerMetaEvent(true);
                this.mounted = false;
            }
        },
        {
            key: "reRender",
            value: function reRender() {
                if (!this.mounted) return;
                this.forceUpdate();
            }
        },
        {
            key: "render",
            value: function render() {
                var resetCount = this.state.resetCount;
                var children = this.props.children;
                var _this$getOnlyChild = this.getOnlyChild(children), child = _this$getOnlyChild.child, isFunction = _this$getOnlyChild.isFunction;
                // Not need to `cloneElement` since user can handle this in render function self
                var returnChildNode;
                if (isFunction) returnChildNode = child;
                else if (/*#__PURE__*/ $6fFrj.isValidElement(child)) returnChildNode = /*#__PURE__*/ $6fFrj.cloneElement(child, this.getControlled(child.props));
                else {
                    (0, $3mXQ2.default)(!child, '`children` of Field is not validate ReactElement.');
                    returnChildNode = child;
                }
                return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, {
                    key: resetCount
                }, returnChildNode);
            }
        }
    ]);
    return Field;
}($6fFrj.Component);
(0, $43449.default)($12bf411ce1aaed8f$var$Field, "contextType", (0, $096ab3393cfd7cdf$export$2e2bcd8739ae039));
(0, $43449.default)($12bf411ce1aaed8f$var$Field, "defaultProps", {
    trigger: 'onChange',
    valuePropName: 'value'
});
function $12bf411ce1aaed8f$var$WrapperField(_ref6) {
    var name = _ref6.name, restProps = (0, $04RxA.default)(_ref6, $12bf411ce1aaed8f$var$_excluded);
    var fieldContext = $6fFrj.useContext((0, $096ab3393cfd7cdf$export$2e2bcd8739ae039));
    var listContext = $6fFrj.useContext((0, $cb841e38c6f3a8d1$export$2e2bcd8739ae039));
    var namePath = name !== undefined ? (0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)(name) : undefined;
    var key = 'keep';
    if (!restProps.isListField) key = "_".concat((namePath || []).join('_'));
    return /*#__PURE__*/ $6fFrj.createElement($12bf411ce1aaed8f$var$Field, (0, $fIrcP.default)({
        key: key,
        name: namePath,
        isListField: !!listContext
    }, restProps, {
        fieldContext: fieldContext
    }));
}
var $12bf411ce1aaed8f$export$2e2bcd8739ae039 = $12bf411ce1aaed8f$var$WrapperField;



var $kNxFX = parcelRequire("kNxFX");

var $37xND = parcelRequire("37xND");

var $6fFrj = parcelRequire("6fFrj");

var $3mXQ2 = parcelRequire("3mXQ2");




function $62ee9cd25e28e75b$var$List(_ref) {
    var name = _ref.name, initialValue = _ref.initialValue, children = _ref.children, rules = _ref.rules, validateTrigger = _ref.validateTrigger, isListField = _ref.isListField;
    var context = $6fFrj.useContext((0, $096ab3393cfd7cdf$export$2e2bcd8739ae039));
    var wrapperListContext = $6fFrj.useContext((0, $cb841e38c6f3a8d1$export$2e2bcd8739ae039));
    var keyRef = $6fFrj.useRef({
        keys: [],
        id: 0
    });
    var keyManager = keyRef.current;
    var prefixName = $6fFrj.useMemo(function() {
        var parentPrefixName = (0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)(context.prefixName) || [];
        return [].concat((0, $37xND.default)(parentPrefixName), (0, $37xND.default)((0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)(name)));
    }, [
        context.prefixName,
        name
    ]);
    var fieldContext = $6fFrj.useMemo(function() {
        return (0, $kNxFX.default)((0, $kNxFX.default)({}, context), {}, {
            prefixName: prefixName
        });
    }, [
        context,
        prefixName
    ]);
    // List context
    var listContext = $6fFrj.useMemo(function() {
        return {
            getKey: function getKey(namePath) {
                var len = prefixName.length;
                var pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        };
    }, [
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== 'function') {
        (0, $3mXQ2.default)(false, 'Form.List only accepts function as children.');
        return null;
    }
    var shouldUpdate = function shouldUpdate(prevValue, nextValue, _ref2) {
        var source = _ref2.source;
        if (source === 'internal') return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $cb841e38c6f3a8d1$export$2e2bcd8739ae039).Provider, {
        value: listContext
    }, /*#__PURE__*/ $6fFrj.createElement((0, $096ab3393cfd7cdf$export$2e2bcd8739ae039).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ $6fFrj.createElement((0, $12bf411ce1aaed8f$export$2e2bcd8739ae039), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField !== null && isListField !== void 0 ? isListField : !!wrapperListContext
    }, function(_ref3, meta) {
        var _ref3$value = _ref3.value, value = _ref3$value === void 0 ? [] : _ref3$value, onChange = _ref3.onChange;
        var getFieldValue = context.getFieldValue;
        var getNewValue = function getNewValue() {
            var values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ var operations = {
            add: function add(defaultValue, index) {
                // Mapping keys
                var newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [].concat((0, $37xND.default)(keyManager.keys.slice(0, index)), [
                        keyManager.id
                    ], (0, $37xND.default)(keyManager.keys.slice(index)));
                    onChange([].concat((0, $37xND.default)(newValue.slice(0, index)), [
                        defaultValue
                    ], (0, $37xND.default)(newValue.slice(index))));
                } else {
                    keyManager.keys = [].concat((0, $37xND.default)(keyManager.keys), [
                        keyManager.id
                    ]);
                    onChange([].concat((0, $37xND.default)(newValue), [
                        defaultValue
                    ]));
                }
                keyManager.id += 1;
            },
            remove: function remove(index) {
                var newValue = getNewValue();
                var indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter(function(_, keysIndex) {
                    return !indexSet.has(keysIndex);
                });
                // Trigger store change
                onChange(newValue.filter(function(_, valueIndex) {
                    return !indexSet.has(valueIndex);
                }));
            },
            move: function move(from, to) {
                if (from === to) return;
                var newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, $3271628c61de9d87$export$d947e5f4f4c48d48)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, $3271628c61de9d87$export$d947e5f4f4c48d48)(newValue, from, to));
            }
        };
        var listValue = value || [];
        if (!Array.isArray(listValue)) listValue = [];
        return children(listValue.map(function(__, index) {
            var key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key: key,
                isListField: true
            };
        }), operations, meta);
    })));
}
var $62ee9cd25e28e75b$export$2e2bcd8739ae039 = $62ee9cd25e28e75b$var$List;



var $jP8CL = parcelRequire("jP8CL");

var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");

var $37xND = parcelRequire("37xND");

var $5KhTJ = parcelRequire("5KhTJ");

var $5KQxu = parcelRequire("5KQxu");

var $kjNeN = parcelRequire("kjNeN");

var $43449 = parcelRequire("43449");

var $3mXQ2 = parcelRequire("3mXQ2");

var $6fFrj = parcelRequire("6fFrj");

function $90e2e7642263115d$export$6152adfdcc6be2b5(promiseList) {
    var hasError = false;
    var count = promiseList.length;
    var results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise(function(resolve, reject) {
        promiseList.forEach(function(promise, index) {
            promise.catch(function(e) {
                hasError = true;
                return e;
            }).then(function(result) {
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}



var $i5KV1 = parcelRequire("i5KV1");


var $jP8CL = parcelRequire("jP8CL");

var $37xND = parcelRequire("37xND");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $43449 = parcelRequire("43449");

var $5KhTJ = parcelRequire("5KhTJ");
var $c8afab3627abe12f$var$SPLIT = '__@field_split__';
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function $c8afab3627abe12f$var$normalize(namePath) {
    return namePath.map(function(cell) {
        return "".concat((0, $5KhTJ.default)(cell), ":").concat(cell);
    })// Magic split
    .join($c8afab3627abe12f$var$SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ var $c8afab3627abe12f$var$NameMap = /*#__PURE__*/ function() {
    function NameMap() {
        (0, $kjNeN.default)(this, NameMap);
        (0, $43449.default)(this, "kvs", new Map());
    }
    (0, $5KQxu.default)(NameMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.kvs.set($c8afab3627abe12f$var$normalize(key), value);
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.kvs.get($c8afab3627abe12f$var$normalize(key));
            }
        },
        {
            key: "update",
            value: function update(key, updater) {
                var origin = this.get(key);
                var next = updater(origin);
                if (!next) this.delete(key);
                else this.set(key, next);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this.kvs.delete($c8afab3627abe12f$var$normalize(key));
            }
        },
        {
            key: "map",
            value: function map(callback) {
                return (0, $37xND.default)(this.kvs.entries()).map(function(_ref) {
                    var _ref2 = (0, $jP8CL.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
                    var cells = key.split($c8afab3627abe12f$var$SPLIT);
                    return callback({
                        key: cells.map(function(cell) {
                            var _cell$match = cell.match(/^([^:]*):(.*)$/), _cell$match2 = (0, $jP8CL.default)(_cell$match, 3), type = _cell$match2[1], unit = _cell$match2[2];
                            return type === 'number' ? Number(unit) : unit;
                        }),
                        value: value
                    });
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var json = {};
                this.map(function(_ref3) {
                    var key = _ref3.key, value = _ref3.value;
                    json[key.join('.')] = value;
                    return null;
                });
                return json;
            }
        }
    ]);
    return NameMap;
}();
var $c8afab3627abe12f$export$2e2bcd8739ae039 = $c8afab3627abe12f$var$NameMap;



var $ij6y6 = parcelRequire("ij6y6");
var $i5KV1 = parcelRequire("i5KV1");
var $44d9c13e1ed4cda1$var$_excluded = [
    "name"
];
var $44d9c13e1ed4cda1$export$75ff1ab1187e691 = /*#__PURE__*/ (0, $5KQxu.default)(function FormStore(forceRootUpdate) {
    var _this = this;
    (0, $kjNeN.default)(this, FormStore);
    (0, $43449.default)(this, "formHooked", false);
    (0, $43449.default)(this, "forceRootUpdate", void 0);
    (0, $43449.default)(this, "subscribable", true);
    (0, $43449.default)(this, "store", {});
    (0, $43449.default)(this, "fieldEntities", []);
    (0, $43449.default)(this, "initialValues", {});
    (0, $43449.default)(this, "callbacks", {});
    (0, $43449.default)(this, "validateMessages", null);
    (0, $43449.default)(this, "preserve", null);
    (0, $43449.default)(this, "lastValidatePromise", null);
    (0, $43449.default)(this, "getForm", function() {
        return {
            getFieldValue: _this.getFieldValue,
            getFieldsValue: _this.getFieldsValue,
            getFieldError: _this.getFieldError,
            getFieldWarning: _this.getFieldWarning,
            getFieldsError: _this.getFieldsError,
            isFieldsTouched: _this.isFieldsTouched,
            isFieldTouched: _this.isFieldTouched,
            isFieldValidating: _this.isFieldValidating,
            isFieldsValidating: _this.isFieldsValidating,
            resetFields: _this.resetFields,
            setFields: _this.setFields,
            setFieldValue: _this.setFieldValue,
            setFieldsValue: _this.setFieldsValue,
            validateFields: _this.validateFields,
            submit: _this.submit,
            _init: true,
            getInternalHooks: _this.getInternalHooks
        };
    });
    // ======================== Internal Hooks ========================
    (0, $43449.default)(this, "getInternalHooks", function(key) {
        if (key === (0, $096ab3393cfd7cdf$export$24829b7c0e49e9f7)) {
            _this.formHooked = true;
            return {
                dispatch: _this.dispatch,
                initEntityValue: _this.initEntityValue,
                registerField: _this.registerField,
                useSubscribe: _this.useSubscribe,
                setInitialValues: _this.setInitialValues,
                destroyForm: _this.destroyForm,
                setCallbacks: _this.setCallbacks,
                setValidateMessages: _this.setValidateMessages,
                getFields: _this.getFields,
                setPreserve: _this.setPreserve,
                getInitialValue: _this.getInitialValue,
                registerWatch: _this.registerWatch
            };
        }
        (0, $3mXQ2.default)(false, '`getInternalHooks` is internal usage. Should not call directly.');
        return null;
    });
    (0, $43449.default)(this, "useSubscribe", function(subscribable) {
        _this.subscribable = subscribable;
    });
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ (0, $43449.default)(this, "prevWithoutPreserves", null);
    /**
   * First time `setInitialValues` should update store with initial value
   */ (0, $43449.default)(this, "setInitialValues", function(initialValues, init) {
        _this.initialValues = initialValues || {};
        if (init) {
            var _this$prevWithoutPres;
            var nextStore = (0, $i5KV1.merge)(initialValues, _this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            (_this$prevWithoutPres = _this.prevWithoutPreserves) === null || _this$prevWithoutPres === void 0 || _this$prevWithoutPres.map(function(_ref) {
                var namePath = _ref.key;
                nextStore = (0, $i5KV1.default)(nextStore, namePath, (0, $ij6y6.default)(initialValues, namePath));
            });
            _this.prevWithoutPreserves = null;
            _this.updateStore(nextStore);
        }
    });
    (0, $43449.default)(this, "destroyForm", function() {
        var prevWithoutPreserves = new (0, $c8afab3627abe12f$export$2e2bcd8739ae039)();
        _this.getFieldEntities(true).forEach(function(entity) {
            if (!_this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
        });
        _this.prevWithoutPreserves = prevWithoutPreserves;
    });
    (0, $43449.default)(this, "getInitialValue", function(namePath) {
        var initValue = (0, $ij6y6.default)(_this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, $i5KV1.merge)(initValue) : initValue;
    });
    (0, $43449.default)(this, "setCallbacks", function(callbacks) {
        _this.callbacks = callbacks;
    });
    (0, $43449.default)(this, "setValidateMessages", function(validateMessages) {
        _this.validateMessages = validateMessages;
    });
    (0, $43449.default)(this, "setPreserve", function(preserve) {
        _this.preserve = preserve;
    });
    // ============================= Watch ============================
    (0, $43449.default)(this, "watchList", []);
    (0, $43449.default)(this, "registerWatch", function(callback) {
        _this.watchList.push(callback);
        return function() {
            _this.watchList = _this.watchList.filter(function(fn) {
                return fn !== callback;
            });
        };
    });
    (0, $43449.default)(this, "notifyWatch", function() {
        var namePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        // No need to cost perf when nothing need to watch
        if (_this.watchList.length) {
            var values = _this.getFieldsValue();
            var allValues = _this.getFieldsValue(true);
            _this.watchList.forEach(function(callback) {
                callback(values, allValues, namePath);
            });
        }
    });
    // ========================== Dev Warning =========================
    (0, $43449.default)(this, "timeoutId", null);
    (0, $43449.default)(this, "warningUnhooked", function() {});
    // ============================ Store =============================
    (0, $43449.default)(this, "updateStore", function(nextStore) {
        _this.store = nextStore;
    });
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ (0, $43449.default)(this, "getFieldEntities", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!pure) return _this.fieldEntities;
        return _this.fieldEntities.filter(function(field) {
            return field.getNamePath().length;
        });
    });
    (0, $43449.default)(this, "getFieldsMap", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var cache = new (0, $c8afab3627abe12f$export$2e2bcd8739ae039)();
        _this.getFieldEntities(pure).forEach(function(field) {
            var namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    });
    (0, $43449.default)(this, "getFieldEntitiesForNamePathList", function(nameList) {
        if (!nameList) return _this.getFieldEntities(true);
        var cache = _this.getFieldsMap(true);
        return nameList.map(function(name) {
            var namePath = (0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)(name)
            };
        });
    });
    (0, $43449.default)(this, "getFieldsValue", function(nameList, filterFunc) {
        _this.warningUnhooked();
        // Fill args
        var mergedNameList;
        var mergedFilterFunc;
        var mergedStrict;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && (0, $5KhTJ.default)(nameList) === 'object') {
            mergedStrict = nameList.strict;
            mergedFilterFunc = nameList.filter;
        }
        if (mergedNameList === true && !mergedFilterFunc) return _this.store;
        var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
        var filteredNameList = [];
        fieldEntities.forEach(function(entity) {
            var _isListField, _ref3;
            var namePath = 'INVALIDATE_NAME_PATH' in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (mergedStrict) {
                var _isList, _ref2;
                if ((_isList = (_ref2 = entity).isList) !== null && _isList !== void 0 && _isList.call(_ref2)) return;
            } else if (!mergedNameList && (_isListField = (_ref3 = entity).isListField) !== null && _isListField !== void 0 && _isListField.call(_ref3)) return;
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                var meta = 'getMeta' in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        return (0, $3271628c61de9d87$export$f5be6dfb30403c59)(_this.store, filteredNameList.map((0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)));
    });
    (0, $43449.default)(this, "getFieldValue", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)(name);
        return (0, $ij6y6.default)(_this.store, namePath);
    });
    (0, $43449.default)(this, "getFieldsError", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map(function(entity, index) {
            if (entity && !('INVALIDATE_NAME_PATH' in entity)) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    });
    (0, $43449.default)(this, "getFieldError", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    });
    (0, $43449.default)(this, "getFieldWarning", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    });
    (0, $43449.default)(this, "isFieldsTouched", function() {
        _this.warningUnhooked();
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var arg0 = args[0], arg1 = args[1];
        var namePathList;
        var isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, $3271628c61de9d87$export$f877b3cb4cb4ccf9));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, $3271628c61de9d87$export$f877b3cb4cb4ccf9));
            isAllFieldsTouched = arg1;
        }
        var fieldEntities = _this.getFieldEntities(true);
        var isFieldTouched = function isFieldTouched(field) {
            return field.isFieldTouched();
        };
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every(isFieldTouched) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        var map = new (0, $c8afab3627abe12f$export$2e2bcd8739ae039)();
        namePathList.forEach(function(shortNamePath) {
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach(function(field) {
            var fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach(function(shortNamePath) {
                if (shortNamePath.every(function(nameUnit, i) {
                    return fieldNamePath[i] === nameUnit;
                })) map.update(shortNamePath, function(list) {
                    return [].concat((0, $37xND.default)(list), [
                        field
                    ]);
                });
            });
        });
        // Check if NameMap value is touched
        var isNamePathListTouched = function isNamePathListTouched(entities) {
            return entities.some(isFieldTouched);
        };
        var namePathListEntities = map.map(function(_ref4) {
            var value = _ref4.value;
            return value;
        });
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    });
    (0, $43449.default)(this, "isFieldTouched", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsTouched([
            name
        ]);
    });
    (0, $43449.default)(this, "isFieldsValidating", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntities();
        if (!nameList) return fieldEntities.some(function(testField) {
            return testField.isFieldValidating();
        });
        var namePathList = nameList.map((0, $3271628c61de9d87$export$f877b3cb4cb4ccf9));
        return fieldEntities.some(function(testField) {
            var fieldNamePath = testField.getNamePath();
            return (0, $3271628c61de9d87$export$646d5504364ae55b)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    });
    (0, $43449.default)(this, "isFieldValidating", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsValidating([
            name
        ]);
    });
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ (0, $43449.default)(this, "resetWithFieldInitialValue", function() {
        var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Create cache
        var cache = new (0, $c8afab3627abe12f$export$2e2bcd8739ae039)();
        var fieldEntities = _this.getFieldEntities(true);
        fieldEntities.forEach(function(field) {
            var initialValue = field.props.initialValue;
            var namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                var records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        var resetWithFields = function resetWithFields(entities) {
            entities.forEach(function(field) {
                var initialValue = field.props.initialValue;
                if (initialValue !== undefined) {
                    var namePath = field.getNamePath();
                    var formInitialValue = _this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, $3mXQ2.default)(false, "Form already set 'initialValues' with path '".concat(namePath.join('.'), "'. Field can not overwrite it."));
                    else {
                        var records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, $3mXQ2.default)(false, "Multiple Field with path '".concat(namePath.join('.'), "' set 'initialValue'. Can not decide which one to pick."));
                        else if (records) {
                            var originValue = _this.getFieldValue(namePath);
                            // Set `initialValue`
                            if (!info.skipExist || originValue === undefined) _this.updateStore((0, $i5KV1.default)(_this.store, namePath, (0, $37xND.default)(records)[0].value));
                        }
                    }
                }
            });
        };
        var requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach(function(namePath) {
                var records = cache.get(namePath);
                if (records) {
                    var _requiredFieldEntitie;
                    (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, (0, $37xND.default)((0, $37xND.default)(records).map(function(r) {
                        return r.entity;
                    })));
                }
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    });
    (0, $43449.default)(this, "resetFields", function(nameList) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (!nameList) {
            _this.updateStore((0, $i5KV1.merge)(_this.initialValues));
            _this.resetWithFieldInitialValue();
            _this.notifyObservers(prevStore, null, {
                type: 'reset'
            });
            _this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        var namePathList = nameList.map((0, $3271628c61de9d87$export$f877b3cb4cb4ccf9));
        namePathList.forEach(function(namePath) {
            var initialValue = _this.getInitialValue(namePath);
            _this.updateStore((0, $i5KV1.default)(_this.store, namePath, initialValue));
        });
        _this.resetWithFieldInitialValue({
            namePathList: namePathList
        });
        _this.notifyObservers(prevStore, namePathList, {
            type: 'reset'
        });
        _this.notifyWatch(namePathList);
    });
    (0, $43449.default)(this, "setFields", function(fields) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        var namePathList = [];
        fields.forEach(function(fieldData) {
            var name = fieldData.name, data = (0, $04RxA.default)(fieldData, $44d9c13e1ed4cda1$var$_excluded);
            var namePath = (0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)(name);
            namePathList.push(namePath);
            // Value
            if ('value' in data) _this.updateStore((0, $i5KV1.default)(_this.store, namePath, data.value));
            _this.notifyObservers(prevStore, [
                namePath
            ], {
                type: 'setField',
                data: fieldData
            });
        });
        _this.notifyWatch(namePathList);
    });
    (0, $43449.default)(this, "getFields", function() {
        var entities = _this.getFieldEntities(true);
        var fields = entities.map(function(field) {
            var namePath = field.getNamePath();
            var meta = field.getMeta();
            var fieldData = (0, $kNxFX.default)((0, $kNxFX.default)({}, meta), {}, {
                name: namePath,
                value: _this.getFieldValue(namePath)
            });
            Object.defineProperty(fieldData, 'originRCField', {
                value: true
            });
            return fieldData;
        });
        return fields;
    });
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ (0, $43449.default)(this, "initEntityValue", function(entity) {
        var initialValue = entity.props.initialValue;
        if (initialValue !== undefined) {
            var namePath = entity.getNamePath();
            var prevValue = (0, $ij6y6.default)(_this.store, namePath);
            if (prevValue === undefined) _this.updateStore((0, $i5KV1.default)(_this.store, namePath, initialValue));
        }
    });
    (0, $43449.default)(this, "isMergedPreserve", function(fieldPreserve) {
        var mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : _this.preserve;
        return mergedPreserve !== null && mergedPreserve !== void 0 ? mergedPreserve : true;
    });
    (0, $43449.default)(this, "registerField", function(entity) {
        _this.fieldEntities.push(entity);
        var namePath = entity.getNamePath();
        _this.notifyWatch([
            namePath
        ]);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            var prevStore = _this.store;
            _this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            _this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: 'valueUpdate',
                source: 'internal'
            });
        }
        // un-register field callback
        return function(isListField, preserve) {
            var subNamePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            _this.fieldEntities = _this.fieldEntities.filter(function(item) {
                return item !== entity;
            });
            // Clean up store value if not preserve
            if (!_this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                var defaultValue = isListField ? undefined : _this.getInitialValue(namePath);
                if (namePath.length && _this.getFieldValue(namePath) !== defaultValue && _this.fieldEntities.every(function(field) {
                    return(// Only reset when no namePath exist
                    !(0, $3271628c61de9d87$export$325a4bd0e71bdc3a)(field.getNamePath(), namePath));
                })) {
                    var _prevStore = _this.store;
                    _this.updateStore((0, $i5KV1.default)(_prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    _this.notifyObservers(_prevStore, [
                        namePath
                    ], {
                        type: 'remove'
                    });
                    // Dependencies update
                    _this.triggerDependenciesUpdate(_prevStore, namePath);
                }
            }
            _this.notifyWatch([
                namePath
            ]);
        };
    });
    (0, $43449.default)(this, "dispatch", function(action) {
        switch(action.type){
            case 'updateValue':
                var namePath = action.namePath, value = action.value;
                _this.updateValue(namePath, value);
                break;
            case 'validateField':
                var _namePath = action.namePath, triggerName = action.triggerName;
                _this.validateFields([
                    _namePath
                ], {
                    triggerName: triggerName
                });
                break;
            default:
        }
    });
    (0, $43449.default)(this, "notifyObservers", function(prevStore, namePathList, info) {
        if (_this.subscribable) {
            var mergedInfo = (0, $kNxFX.default)((0, $kNxFX.default)({}, info), {}, {
                store: _this.getFieldsValue(true)
            });
            _this.getFieldEntities().forEach(function(_ref5) {
                var onStoreChange = _ref5.onStoreChange;
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else _this.forceRootUpdate();
    });
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ (0, $43449.default)(this, "triggerDependenciesUpdate", function(prevStore, namePath) {
        var childrenFields = _this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) _this.validateFields(childrenFields);
        _this.notifyObservers(prevStore, childrenFields, {
            type: 'dependenciesUpdate',
            relatedFields: [
                namePath
            ].concat((0, $37xND.default)(childrenFields))
        });
        return childrenFields;
    });
    (0, $43449.default)(this, "updateValue", function(name, value) {
        var namePath = (0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)(name);
        var prevStore = _this.store;
        _this.updateStore((0, $i5KV1.default)(_this.store, namePath, value));
        _this.notifyObservers(prevStore, [
            namePath
        ], {
            type: 'valueUpdate',
            source: 'internal'
        });
        _this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        var onValuesChange = _this.callbacks.onValuesChange;
        if (onValuesChange) {
            var changedValues = (0, $3271628c61de9d87$export$f5be6dfb30403c59)(_this.store, [
                namePath
            ]);
            onValuesChange(changedValues, _this.getFieldsValue());
        }
        _this.triggerOnFieldsChange([
            namePath
        ].concat((0, $37xND.default)(childrenFields)));
    });
    // Let all child Field get update.
    (0, $43449.default)(this, "setFieldsValue", function(store) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (store) {
            var nextStore = (0, $i5KV1.merge)(_this.store, store);
            _this.updateStore(nextStore);
        }
        _this.notifyObservers(prevStore, null, {
            type: 'valueUpdate',
            source: 'external'
        });
        _this.notifyWatch();
    });
    (0, $43449.default)(this, "setFieldValue", function(name, value) {
        _this.setFields([
            {
                name: name,
                value: value
            }
        ]);
    });
    (0, $43449.default)(this, "getDependencyChildrenFields", function(rootNamePath) {
        var children = new Set();
        var childrenFields = [];
        var dependencies2fields = new (0, $c8afab3627abe12f$export$2e2bcd8739ae039)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ _this.getFieldEntities().forEach(function(field) {
            var dependencies = field.props.dependencies;
            (dependencies || []).forEach(function(dependency) {
                var dependencyNamePath = (0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)(dependency);
                dependencies2fields.update(dependencyNamePath, function() {
                    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
                    fields.add(field);
                    return fields;
                });
            });
        });
        var fillChildren = function fillChildren(namePath) {
            var fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach(function(field) {
                if (!children.has(field)) {
                    children.add(field);
                    var fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    });
    (0, $43449.default)(this, "triggerOnFieldsChange", function(namePathList, filedErrors) {
        var onFieldsChange = _this.callbacks.onFieldsChange;
        if (onFieldsChange) {
            var fields = _this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                var cache = new (0, $c8afab3627abe12f$export$2e2bcd8739ae039)();
                filedErrors.forEach(function(_ref6) {
                    var name = _ref6.name, errors = _ref6.errors;
                    cache.set(name, errors);
                });
                fields.forEach(function(field) {
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            var changedFields = fields.filter(function(_ref7) {
                var fieldName = _ref7.name;
                return (0, $3271628c61de9d87$export$646d5504364ae55b)(namePathList, fieldName);
            });
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    });
    // =========================== Validate ===========================
    (0, $43449.default)(this, "validateFields", function(arg1, arg2) {
        var _options;
        _this.warningUnhooked();
        var nameList;
        var options;
        if (Array.isArray(arg1) || typeof arg1 === 'string' || typeof arg2 === 'string') {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        var provideNameList = !!nameList;
        var namePathList = provideNameList ? nameList.map((0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)) : [];
        // Collect result in promise list
        var promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        var TMP_SPLIT = String(Date.now());
        var validateNamePathList = new Set();
        var recursive = (_options = options) === null || _options === void 0 ? void 0 : _options.recursive;
        _this.getFieldEntities(true).forEach(function(field) {
            // Add field if not provide `nameList`
            if (!provideNameList) namePathList.push(field.getNamePath());
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            var fieldNamePath = field.getNamePath();
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, $3271628c61de9d87$export$646d5504364ae55b)(namePathList, fieldNamePath, recursive)) {
                var promise = field.validateRules((0, $kNxFX.default)({
                    validateMessages: (0, $kNxFX.default)((0, $kNxFX.default)({}, (0, $ec33e4fb64ae3c21$export$c86b939816b8fbf8)), _this.validateMessages)
                }, options));
                // Wrap promise with field
                promiseList.push(promise.then(function() {
                    return {
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    };
                }).catch(function(ruleErrors) {
                    var _ruleErrors$forEach;
                    var mergedErrors = [];
                    var mergedWarnings = [];
                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref8) {
                        var warningOnly = _ref8.rule.warningOnly, errors = _ref8.errors;
                        if (warningOnly) mergedWarnings.push.apply(mergedWarnings, (0, $37xND.default)(errors));
                        else mergedErrors.push.apply(mergedErrors, (0, $37xND.default)(errors));
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        var summaryPromise = (0, $90e2e7642263115d$export$6152adfdcc6be2b5)(promiseList);
        _this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise.catch(function(results) {
            return results;
        }).then(function(results) {
            var resultNamePathList = results.map(function(_ref9) {
                var name = _ref9.name;
                return name;
            });
            _this.notifyObservers(_this.store, resultNamePathList, {
                type: 'validateFinish'
            });
            _this.triggerOnFieldsChange(resultNamePathList, results);
        });
        var returnPromise = summaryPromise.then(function() {
            if (_this.lastValidatePromise === summaryPromise) return Promise.resolve(_this.getFieldsValue(namePathList));
            return Promise.reject([]);
        }).catch(function(results) {
            var errorList = results.filter(function(result) {
                return result && result.errors.length;
            });
            return Promise.reject({
                values: _this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: _this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise.catch(function(e) {
            return e;
        });
        // `validating` changed. Trigger `onFieldsChange`
        var triggerNamePathList = namePathList.filter(function(namePath) {
            return validateNamePathList.has(namePath.join(TMP_SPLIT));
        });
        _this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    });
    // ============================ Submit ============================
    (0, $43449.default)(this, "submit", function() {
        _this.warningUnhooked();
        _this.validateFields().then(function(values) {
            var onFinish = _this.callbacks.onFinish;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        }).catch(function(e) {
            var onFinishFailed = _this.callbacks.onFinishFailed;
            if (onFinishFailed) onFinishFailed(e);
        });
    });
    this.forceRootUpdate = forceRootUpdate;
});
function $44d9c13e1ed4cda1$var$useForm(form) {
    var formRef = $6fFrj.useRef();
    var _React$useState = $6fFrj.useState({}), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), forceUpdate = _React$useState2[1];
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            var forceReRender = function forceReRender() {
                forceUpdate({});
            };
            var formStore = new $44d9c13e1ed4cda1$export$75ff1ab1187e691(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
var $44d9c13e1ed4cda1$export$2e2bcd8739ae039 = $44d9c13e1ed4cda1$var$useForm;



var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");



var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
var $7b3f24a2438c323c$var$FormContext = /*#__PURE__*/ $6fFrj.createContext({
    triggerFormChange: function triggerFormChange() {},
    triggerFormFinish: function triggerFormFinish() {},
    registerForm: function registerForm() {},
    unregisterForm: function unregisterForm() {}
});
var $7b3f24a2438c323c$export$8ce1ff4f94d08846 = function FormProvider(_ref) {
    var validateMessages = _ref.validateMessages, onFormChange = _ref.onFormChange, onFormFinish = _ref.onFormFinish, children = _ref.children;
    var formContext = $6fFrj.useContext($7b3f24a2438c323c$var$FormContext);
    var formsRef = $6fFrj.useRef({});
    return /*#__PURE__*/ $6fFrj.createElement($7b3f24a2438c323c$var$FormContext.Provider, {
        value: (0, $kNxFX.default)((0, $kNxFX.default)({}, formContext), {}, {
            validateMessages: (0, $kNxFX.default)((0, $kNxFX.default)({}, formContext.validateMessages), validateMessages),
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: function triggerFormChange(name, changedFields) {
                if (onFormChange) onFormChange(name, {
                    changedFields: changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: function triggerFormFinish(name, values) {
                if (onFormFinish) onFormFinish(name, {
                    values: values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: function registerForm(name, form) {
                if (name) formsRef.current = (0, $kNxFX.default)((0, $kNxFX.default)({}, formsRef.current), {}, (0, $43449.default)({}, name, form));
                formContext.registerForm(name, form);
            },
            unregisterForm: function unregisterForm(name) {
                var newForms = (0, $kNxFX.default)({}, formsRef.current);
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        })
    }, children);
};
var $7b3f24a2438c323c$export$2e2bcd8739ae039 = $7b3f24a2438c323c$var$FormContext;




var $cfe4ae9d9b32f066$var$_excluded = [
    "name",
    "initialValues",
    "fields",
    "form",
    "preserve",
    "children",
    "component",
    "validateMessages",
    "validateTrigger",
    "onValuesChange",
    "onFieldsChange",
    "onFinish",
    "onFinishFailed"
];
var $cfe4ae9d9b32f066$var$Form = function Form(_ref, ref) {
    var name = _ref.name, initialValues = _ref.initialValues, fields = _ref.fields, form = _ref.form, preserve = _ref.preserve, children = _ref.children, _ref$component = _ref.component, Component = _ref$component === void 0 ? 'form' : _ref$component, validateMessages = _ref.validateMessages, _ref$validateTrigger = _ref.validateTrigger, validateTrigger = _ref$validateTrigger === void 0 ? 'onChange' : _ref$validateTrigger, onValuesChange = _ref.onValuesChange, _onFieldsChange = _ref.onFieldsChange, _onFinish = _ref.onFinish, onFinishFailed = _ref.onFinishFailed, restProps = (0, $04RxA.default)(_ref, $cfe4ae9d9b32f066$var$_excluded);
    var formContext = $6fFrj.useContext((0, $7b3f24a2438c323c$export$2e2bcd8739ae039));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    var _useForm = (0, $44d9c13e1ed4cda1$export$2e2bcd8739ae039)(form), _useForm2 = (0, $jP8CL.default)(_useForm, 1), formInstance = _useForm2[0];
    var _getInternalHooks = formInstance.getInternalHooks((0, $096ab3393cfd7cdf$export$24829b7c0e49e9f7)), useSubscribe = _getInternalHooks.useSubscribe, setInitialValues = _getInternalHooks.setInitialValues, setCallbacks = _getInternalHooks.setCallbacks, setValidateMessages = _getInternalHooks.setValidateMessages, setPreserve = _getInternalHooks.setPreserve, destroyForm = _getInternalHooks.destroyForm;
    // Pass ref with form instance
    $6fFrj.useImperativeHandle(ref, function() {
        return formInstance;
    });
    // Register form into Context
    $6fFrj.useEffect(function() {
        formContext.registerForm(name, formInstance);
        return function() {
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages((0, $kNxFX.default)((0, $kNxFX.default)({}, formContext.validateMessages), validateMessages));
    setCallbacks({
        onValuesChange: onValuesChange,
        onFieldsChange: function onFieldsChange(changedFields) {
            formContext.triggerFormChange(name, changedFields);
            if (_onFieldsChange) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
                _onFieldsChange.apply(void 0, [
                    changedFields
                ].concat(rest));
            }
        },
        onFinish: function onFinish(values) {
            formContext.triggerFormFinish(name, values);
            if (_onFinish) _onFinish(values);
        },
        onFinishFailed: onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    var mountRef = $6fFrj.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    $6fFrj.useEffect(function() {
        return destroyForm;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    var childrenNode;
    var childrenRenderProps = typeof children === 'function';
    if (childrenRenderProps) {
        var _values = formInstance.getFieldsValue(true);
        childrenNode = children(_values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    var prevFieldsRef = $6fFrj.useRef();
    $6fFrj.useEffect(function() {
        if (!(0, $3271628c61de9d87$export$dfcec05bb7372a54)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    var formContextValue = $6fFrj.useMemo(function() {
        return (0, $kNxFX.default)((0, $kNxFX.default)({}, formInstance), {}, {
            validateTrigger: validateTrigger
        });
    }, [
        formInstance,
        validateTrigger
    ]);
    var wrapperNode = /*#__PURE__*/ $6fFrj.createElement((0, $cb841e38c6f3a8d1$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $6fFrj.createElement((0, $096ab3393cfd7cdf$export$2e2bcd8739ae039).Provider, {
        value: formContextValue
    }, childrenNode));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ $6fFrj.createElement(Component, (0, $fIrcP.default)({}, restProps, {
        onSubmit: function onSubmit(event) {
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: function onReset(event) {
            var _restProps$onReset;
            event.preventDefault();
            formInstance.resetFields();
            (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 || _restProps$onReset.call(restProps, event);
        }
    }), wrapperNode);
};
var $cfe4ae9d9b32f066$export$2e2bcd8739ae039 = $cfe4ae9d9b32f066$var$Form;






var $jP8CL = parcelRequire("jP8CL");
parcelRequire("3mXQ2");

var $6fFrj = parcelRequire("6fFrj");



var $ij6y6 = parcelRequire("ij6y6");
function $3faab004390268d8$export$fac44ee5b035f737(value) {
    try {
        return JSON.stringify(value);
    } catch (err) {
        return Math.random();
    }
}
var $3faab004390268d8$var$useWatchWarning = function() {};
function $3faab004390268d8$var$useWatch() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var _args$ = args[0], dependencies = _args$ === void 0 ? [] : _args$, _args$2 = args[1], _form = _args$2 === void 0 ? {} : _args$2;
    var options = (0, $e24ebc1f4c7a8e3c$export$717b316e73068e8d)(_form) ? {
        form: _form
    } : _form;
    var form = options.form;
    var _useState = (0, $6fFrj.useState)(), _useState2 = (0, $jP8CL.default)(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueStr = (0, $6fFrj.useMemo)(function() {
        return $3faab004390268d8$export$fac44ee5b035f737(value);
    }, [
        value
    ]);
    var valueStrRef = (0, $6fFrj.useRef)(valueStr);
    valueStrRef.current = valueStr;
    var fieldContext = (0, $6fFrj.useContext)((0, $096ab3393cfd7cdf$export$2e2bcd8739ae039));
    var formInstance = form || fieldContext;
    var isValidForm = formInstance && formInstance._init;
    var namePath = (0, $3271628c61de9d87$export$f877b3cb4cb4ccf9)(dependencies);
    var namePathRef = (0, $6fFrj.useRef)(namePath);
    namePathRef.current = namePath;
    $3faab004390268d8$var$useWatchWarning(namePath);
    (0, $6fFrj.useEffect)(function() {
        // Skip if not exist form instance
        if (!isValidForm) return;
        var getFieldsValue = formInstance.getFieldsValue, getInternalHooks = formInstance.getInternalHooks;
        var _getInternalHooks = getInternalHooks((0, $096ab3393cfd7cdf$export$24829b7c0e49e9f7)), registerWatch = _getInternalHooks.registerWatch;
        var cancelRegister = registerWatch(function(values, allValues) {
            var newValue = (0, $ij6y6.default)(options.preserve ? allValues : values, namePathRef.current);
            var nextValueStr = $3faab004390268d8$export$fac44ee5b035f737(newValue);
            // Compare stringify in case it's nest object
            if (valueStrRef.current !== nextValueStr) {
                valueStrRef.current = nextValueStr;
                setValue(newValue);
            }
        });
        // TODO: We can improve this perf in future
        var initialValue = (0, $ij6y6.default)(options.preserve ? getFieldsValue(true) : getFieldsValue(), namePathRef.current);
        // React 18 has the bug that will queue update twice even the value is not changed
        // ref: https://github.com/facebook/react/issues/27213
        if (value !== initialValue) setValue(initialValue);
        return cancelRegister;
    }, // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isValidForm
    ]);
    return value;
}
var $3faab004390268d8$export$2e2bcd8739ae039 = $3faab004390268d8$var$useWatch;


var $7593554a967dae45$var$InternalForm = /*#__PURE__*/ $6fFrj.forwardRef((0, $cfe4ae9d9b32f066$export$2e2bcd8739ae039));
var $7593554a967dae45$var$RefForm = $7593554a967dae45$var$InternalForm;
$7593554a967dae45$var$RefForm.FormProvider = (0, $7b3f24a2438c323c$export$8ce1ff4f94d08846);
$7593554a967dae45$var$RefForm.Field = (0, $12bf411ce1aaed8f$export$2e2bcd8739ae039);
$7593554a967dae45$var$RefForm.List = (0, $62ee9cd25e28e75b$export$2e2bcd8739ae039);
$7593554a967dae45$var$RefForm.useForm = (0, $44d9c13e1ed4cda1$export$2e2bcd8739ae039);
$7593554a967dae45$var$RefForm.useWatch = (0, $3faab004390268d8$export$2e2bcd8739ae039);
var $7593554a967dae45$export$2e2bcd8739ae039 = $7593554a967dae45$var$RefForm;




var $6fFrj = parcelRequire("6fFrj");
var $76d69cb8326089c6$export$c24727297075ec6a = /*#__PURE__*/ $6fFrj.createContext({
    labelAlign: 'right',
    vertical: false,
    itemRef: function itemRef() {}
});
var $76d69cb8326089c6$export$d718247e9f9b0b9e = /*#__PURE__*/ $6fFrj.createContext(null);
var $76d69cb8326089c6$export$8ce1ff4f94d08846 = function FormProvider(props) {
    var providerProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(props, [
        'prefixCls'
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $7b3f24a2438c323c$export$8ce1ff4f94d08846), (0, $fIrcP.default)({}, providerProps));
};
var $76d69cb8326089c6$export$fb6582d3042cc879 = /*#__PURE__*/ $6fFrj.createContext({
    prefixCls: ''
});
var $76d69cb8326089c6$export$bbb5553c6c7a14ed = /*#__PURE__*/ $6fFrj.createContext({});
var $76d69cb8326089c6$export$80e4c53cb85dcab1 = function NoFormStyle(_ref) {
    var children = _ref.children, status = _ref.status, override = _ref.override;
    var formItemInputContext = (0, $6fFrj.useContext)($76d69cb8326089c6$export$bbb5553c6c7a14ed);
    var newFormItemInputContext = (0, $6fFrj.useMemo)(function() {
        var newContext = (0, $fIrcP.default)({}, formItemInputContext);
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $6fFrj.createElement($76d69cb8326089c6$export$bbb5553c6c7a14ed.Provider, {
        value: newFormItemInputContext
    }, children);
};




var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $37xND = parcelRequire("37xND");

var $jP8CL = parcelRequire("jP8CL");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");


var $3bc617932030e5e8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3bc617932030e5e8$export$f9c6924e160136d1 = /*#__PURE__*/ $6fFrj.createContext(null);
var $3bc617932030e5e8$var$InternalCheckboxGroup = function InternalCheckboxGroup(_a, ref) {
    var defaultValue = _a.defaultValue, children = _a.children, _a$options = _a.options, options = _a$options === void 0 ? [] : _a$options, customizePrefixCls = _a.prefixCls, className = _a.className, style = _a.style, onChange = _a.onChange, restProps = $3bc617932030e5e8$var$__rest(_a, [
        "defaultValue",
        "children",
        "options",
        "prefixCls",
        "className",
        "style",
        "onChange"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var _React$useState = $6fFrj.useState(restProps.value || defaultValue || []), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState([]), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), registeredValues = _React$useState4[0], setRegisteredValues = _React$useState4[1];
    $6fFrj.useEffect(function() {
        if ('value' in restProps) setValue(restProps.value || []);
    }, [
        restProps.value
    ]);
    var getOptions = function getOptions() {
        return options.map(function(option) {
            if (typeof option === 'string' || typeof option === 'number') return {
                label: option,
                value: option
            };
            return option;
        });
    };
    var cancelValue = function cancelValue(val) {
        setRegisteredValues(function(prevValues) {
            return prevValues.filter(function(v) {
                return v !== val;
            });
        });
    };
    var registerValue = function registerValue(val) {
        setRegisteredValues(function(prevValues) {
            return [].concat((0, $37xND.default)(prevValues), [
                val
            ]);
        });
    };
    var toggleOption = function toggleOption(option) {
        var optionIndex = value.indexOf(option.value);
        var newValue = (0, $37xND.default)(value);
        if (optionIndex === -1) newValue.push(option.value);
        else newValue.splice(optionIndex, 1);
        if (!('value' in restProps)) setValue(newValue);
        var opts = getOptions();
        onChange === null || onChange === void 0 || onChange(newValue.filter(function(val) {
            return registeredValues.includes(val);
        }).sort(function(a, b) {
            var indexA = opts.findIndex(function(opt) {
                return opt.value === a;
            });
            var indexB = opts.findIndex(function(opt) {
                return opt.value === b;
            });
            return indexA - indexB;
        }));
    };
    var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var domProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(restProps, [
        'value',
        'disabled'
    ]);
    if (options && options.length > 0) children = getOptions().map(function(option) {
        return /*#__PURE__*/ $6fFrj.createElement((0, $393107ec21960c73$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: option.value.toString(),
            disabled: 'disabled' in option ? option.disabled : restProps.disabled,
            value: option.value,
            checked: value.includes(option.value),
            onChange: option.onChange,
            className: "".concat(groupPrefixCls, "-item"),
            style: option.style
        }, option.label);
    });
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    var context = {
        toggleOption: toggleOption,
        value: value,
        disabled: restProps.disabled,
        name: restProps.name,
        // https://github.com/ant-design/ant-design/issues/16376
        registerValue: registerValue,
        cancelValue: cancelValue
    };
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(groupPrefixCls, (0, $43449.default)({}, "".concat(groupPrefixCls, "-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        className: classString,
        style: style
    }, domProps, {
        ref: ref
    }), /*#__PURE__*/ $6fFrj.createElement($3bc617932030e5e8$export$f9c6924e160136d1.Provider, {
        value: context
    }, children));
};
var $3bc617932030e5e8$var$CheckboxGroup = /*#__PURE__*/ $6fFrj.forwardRef($3bc617932030e5e8$var$InternalCheckboxGroup);
var $3bc617932030e5e8$export$2e2bcd8739ae039 = /*#__PURE__*/ $6fFrj.memo($3bc617932030e5e8$var$CheckboxGroup);



var $393107ec21960c73$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $393107ec21960c73$var$InternalCheckbox = function InternalCheckbox(_a, ref) {
    var _b;
    var customizePrefixCls = _a.prefixCls, className = _a.className, children = _a.children, _a$indeterminate = _a.indeterminate, indeterminate = _a$indeterminate === void 0 ? false : _a$indeterminate, style = _a.style, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, _a$skipGroup = _a.skipGroup, skipGroup = _a$skipGroup === void 0 ? false : _a$skipGroup, disabled = _a.disabled, restProps = $393107ec21960c73$var$__rest(_a, [
        "prefixCls",
        "className",
        "children",
        "indeterminate",
        "style",
        "onMouseEnter",
        "onMouseLeave",
        "skipGroup",
        "disabled"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var checkboxGroup = $6fFrj.useContext((0, $3bc617932030e5e8$export$f9c6924e160136d1));
    var _useContext = (0, $6fFrj.useContext)((0, $76d69cb8326089c6$export$bbb5553c6c7a14ed)), isFormItemInput = _useContext.isFormItemInput;
    var contextDisabled = (0, $6fFrj.useContext)((0, $3880af76d17f94a3$export$2e2bcd8739ae039));
    var mergedDisabled = (_b = (checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.disabled) || disabled) !== null && _b !== void 0 ? _b : contextDisabled;
    var prevValue = $6fFrj.useRef(restProps.value);
    $6fFrj.useEffect(function() {
        checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.registerValue(restProps.value);
    }, []);
    $6fFrj.useEffect(function() {
        if (skipGroup) return;
        if (restProps.value !== prevValue.current) {
            checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.cancelValue(prevValue.current);
            checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.registerValue(restProps.value);
            prevValue.current = restProps.value;
        }
        return function() {
            return checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value);
        };
    }, [
        restProps.value
    ]);
    var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    var checkboxProps = (0, $fIrcP.default)({}, restProps);
    if (checkboxGroup && !skipGroup) {
        checkboxProps.onChange = function() {
            if (restProps.onChange) restProps.onChange.apply(restProps, arguments);
            if (checkboxGroup.toggleOption) checkboxGroup.toggleOption({
                label: children,
                value: restProps.value
            });
        };
        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.includes(restProps.value);
    }
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-wrapper"), true), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), "".concat(prefixCls, "-wrapper-disabled"), mergedDisabled), "".concat(prefixCls, "-wrapper-in-form-item"), isFormItemInput), className);
    var checkboxClass = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
    var ariaChecked = indeterminate ? 'mixed' : undefined;
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-associated-control
    $6fFrj.createElement("label", {
        className: classString,
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ $6fFrj.createElement((0, $17f8617e16f6bea2$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        "aria-checked": ariaChecked
    }, checkboxProps, {
        prefixCls: prefixCls,
        className: checkboxClass,
        disabled: mergedDisabled,
        ref: ref
    })), children !== undefined && /*#__PURE__*/ $6fFrj.createElement("span", null, children)));
};
var $393107ec21960c73$var$Checkbox = /*#__PURE__*/ $6fFrj.forwardRef($393107ec21960c73$var$InternalCheckbox);
var $393107ec21960c73$export$2e2bcd8739ae039 = $393107ec21960c73$var$Checkbox;



var $66ef76fa6be8ca1a$var$Checkbox = (0, $393107ec21960c73$export$2e2bcd8739ae039);
$66ef76fa6be8ca1a$var$Checkbox.Group = (0, $3bc617932030e5e8$export$2e2bcd8739ae039);
$66ef76fa6be8ca1a$var$Checkbox.__ANT_CHECKBOX = true;
var $66ef76fa6be8ca1a$export$2e2bcd8739ae039 = $66ef76fa6be8ca1a$var$Checkbox;


var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $5KhTJ = parcelRequire("5KhTJ");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");
var $243e8b0896b40e46$var$RowContext = /*#__PURE__*/ (0, $6fFrj.createContext)({});
var $243e8b0896b40e46$export$2e2bcd8739ae039 = $243e8b0896b40e46$var$RowContext;


var $00584e60fec74e25$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $00584e60fec74e25$var$parseFlex(flex) {
    if (typeof flex === 'number') return "".concat(flex, " ").concat(flex, " auto");
    if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) return "0 0 ".concat(flex);
    return flex;
}
var $00584e60fec74e25$var$sizes = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'xxl'
];
var $00584e60fec74e25$var$Col = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var _React$useContext2 = $6fFrj.useContext((0, $243e8b0896b40e46$export$2e2bcd8739ae039)), gutter = _React$useContext2.gutter, wrap = _React$useContext2.wrap, supportFlexGap = _React$useContext2.supportFlexGap;
    var customizePrefixCls = props.prefixCls, span = props.span, order = props.order, offset = props.offset, push = props.push, pull = props.pull, className = props.className, children = props.children, flex = props.flex, style = props.style, others = $00584e60fec74e25$var$__rest(props, [
        "prefixCls",
        "span",
        "order",
        "offset",
        "push",
        "pull",
        "className",
        "children",
        "flex",
        "style"
    ]);
    var prefixCls = getPrefixCls('col', customizePrefixCls);
    var sizeClassObj = {};
    $00584e60fec74e25$var$sizes.forEach(function(size) {
        var sizeProps = {};
        var propSize = props[size];
        if (typeof propSize === 'number') sizeProps.span = propSize;
        else if ((0, $5KhTJ.default)(propSize) === 'object') sizeProps = propSize || {};
        delete others[size];
        sizeClassObj = (0, $fIrcP.default)((0, $fIrcP.default)({}, sizeClassObj), (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), "".concat(prefixCls, "-rtl"), direction === 'rtl'));
    });
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-").concat(span), span !== undefined), "".concat(prefixCls, "-order-").concat(order), order), "".concat(prefixCls, "-offset-").concat(offset), offset), "".concat(prefixCls, "-push-").concat(push), push), "".concat(prefixCls, "-pull-").concat(pull), pull), className, sizeClassObj);
    var mergedStyle = {};
    // Horizontal gutter use padding
    if (gutter && gutter[0] > 0) {
        var horizontalGutter = gutter[0] / 2;
        mergedStyle.paddingLeft = horizontalGutter;
        mergedStyle.paddingRight = horizontalGutter;
    }
    // Vertical gutter use padding when gap not support
    if (gutter && gutter[1] > 0 && !supportFlexGap) {
        var verticalGutter = gutter[1] / 2;
        mergedStyle.paddingTop = verticalGutter;
        mergedStyle.paddingBottom = verticalGutter;
    }
    if (flex) {
        mergedStyle.flex = $00584e60fec74e25$var$parseFlex(flex);
        // Hack for Firefox to avoid size issue
        // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
        if (wrap === false && !mergedStyle.minWidth) mergedStyle.minWidth = 0;
    }
    return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({}, others, {
        style: (0, $fIrcP.default)((0, $fIrcP.default)({}, mergedStyle), style),
        className: classes,
        ref: ref
    }), children);
});
var $00584e60fec74e25$export$2e2bcd8739ae039 = $00584e60fec74e25$var$Col;


var $b72d204d9844548f$export$2e2bcd8739ae039 = (0, $00584e60fec74e25$export$2e2bcd8739ae039);


var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $ebde6246994415e5$var$RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
var $ebde6246994415e5$export$2e2bcd8739ae039 = $ebde6246994415e5$var$RightOutlined;



var $e7bd83ac29db4850$var$RightOutlined = function RightOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $ebde6246994415e5$export$2e2bcd8739ae039)
    }));
};
var $e7bd83ac29db4850$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($e7bd83ac29db4850$var$RightOutlined);
var $e7bd83ac29db4850$export$2e2bcd8739ae039 = $e7bd83ac29db4850$var$RefIcon;



var $fActo = parcelRequire("fActo");

var $43449 = parcelRequire("43449");

var $37xND = parcelRequire("37xND");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $5KhTJ = parcelRequire("5KhTJ");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");
var $802a1584717a396d$exports = {};
//
$802a1584717a396d$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};



var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $04RxA = parcelRequire("04RxA");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $fActo = parcelRequire("fActo");

var $5EVeC = parcelRequire("5EVeC");

var $6fFrj = parcelRequire("6fFrj");


var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");
var $77a21cd256a40298$var$PanelContent = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _classnames;
    var prefixCls = props.prefixCls, forceRender = props.forceRender, className = props.className, style = props.style, children = props.children, isActive = props.isActive, role = props.role;
    var _React$useState = $6fFrj.useState(isActive || forceRender), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), rendered = _React$useState2[0], setRendered = _React$useState2[1];
    $6fFrj.useEffect(function() {
        if (forceRender || isActive) setRendered(true);
    }, [
        forceRender,
        isActive
    ]);
    if (!rendered) return null;
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-content"), (_classnames = {}, (0, $43449.default)(_classnames, "".concat(prefixCls, "-content-active"), isActive), (0, $43449.default)(_classnames, "".concat(prefixCls, "-content-inactive"), !isActive), _classnames), className),
        style: style,
        role: role
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-content-box")
    }, children));
});
$77a21cd256a40298$var$PanelContent.displayName = 'PanelContent';
var $77a21cd256a40298$export$2e2bcd8739ae039 = $77a21cd256a40298$var$PanelContent;


var $2110ab19c5a519f2$var$_excluded = [
    "className",
    "id",
    "style",
    "prefixCls",
    "headerClass",
    "children",
    "isActive",
    "destroyInactivePanel",
    "accordion",
    "forceRender",
    "openMotion",
    "extra",
    "collapsible"
];
var $2110ab19c5a519f2$var$CollapsePanel = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(CollapsePanel, _React$Component);
    var _super = (0, $lSufv.default)(CollapsePanel);
    function CollapsePanel() {
        var _this;
        (0, $kjNeN.default)(this, CollapsePanel);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.onItemClick = function() {
            var _this$props = _this.props, onItemClick = _this$props.onItemClick, panelKey = _this$props.panelKey;
            if (typeof onItemClick === 'function') onItemClick(panelKey);
        };
        _this.handleKeyPress = function(e) {
            if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) _this.onItemClick();
        };
        _this.renderIcon = function() {
            var _this$props2 = _this.props, showArrow = _this$props2.showArrow, expandIcon = _this$props2.expandIcon, prefixCls = _this$props2.prefixCls, collapsible = _this$props2.collapsible;
            if (!showArrow) return null;
            var iconNode = typeof expandIcon === 'function' ? expandIcon(_this.props) : /*#__PURE__*/ $6fFrj.createElement("i", {
                className: "arrow"
            });
            return iconNode && /*#__PURE__*/ $6fFrj.createElement("div", {
                className: "".concat(prefixCls, "-expand-icon"),
                onClick: collapsible === 'header' || collapsible === 'icon' ? _this.onItemClick : null
            }, iconNode);
        };
        _this.renderTitle = function() {
            var _this$props3 = _this.props, header = _this$props3.header, prefixCls = _this$props3.prefixCls, collapsible = _this$props3.collapsible;
            return /*#__PURE__*/ $6fFrj.createElement("span", {
                className: "".concat(prefixCls, "-header-text"),
                onClick: collapsible === 'header' ? _this.onItemClick : null
            }, header);
        };
        return _this;
    }
    (0, $5KQxu.default)(CollapsePanel, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return !(0, (/*@__PURE__*/$parcel$interopDefault($802a1584717a396d$exports)))(this.props, nextProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _classNames, _classNames2;
                var _this$props4 = this.props, className = _this$props4.className, id = _this$props4.id, style = _this$props4.style, prefixCls = _this$props4.prefixCls, headerClass = _this$props4.headerClass, children = _this$props4.children, isActive = _this$props4.isActive, destroyInactivePanel = _this$props4.destroyInactivePanel, accordion = _this$props4.accordion, forceRender = _this$props4.forceRender, openMotion = _this$props4.openMotion, extra = _this$props4.extra, collapsible = _this$props4.collapsible, rest = (0, $04RxA.default)(_this$props4, $2110ab19c5a519f2$var$_excluded);
                var disabled = collapsible === 'disabled';
                var collapsibleHeader = collapsible === 'header';
                var collapsibleIcon = collapsible === 'icon';
                var itemCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((_classNames = {}, (0, $43449.default)(_classNames, "".concat(prefixCls, "-item"), true), (0, $43449.default)(_classNames, "".concat(prefixCls, "-item-active"), isActive), (0, $43449.default)(_classNames, "".concat(prefixCls, "-item-disabled"), disabled), _classNames), className);
                var headerCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-header"), (_classNames2 = {}, (0, $43449.default)(_classNames2, headerClass, headerClass), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-header-collapsible-only"), collapsibleHeader), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-icon-collapsible-only"), collapsibleIcon), _classNames2));
                /** header 节点属性 */ var headerProps = {
                    className: headerCls,
                    'aria-expanded': isActive,
                    'aria-disabled': disabled,
                    onKeyPress: this.handleKeyPress
                };
                if (!collapsibleHeader && !collapsibleIcon) {
                    headerProps.onClick = this.onItemClick;
                    headerProps.role = accordion ? 'tab' : 'button';
                    headerProps.tabIndex = disabled ? -1 : 0;
                }
                var ifExtraExist = extra !== null && extra !== undefined && typeof extra !== 'boolean'; // https://github.com/ant-design/ant-design/pull/37419#issuecomment-1238812797
                delete rest.header;
                delete rest.panelKey;
                delete rest.onItemClick;
                delete rest.showArrow;
                delete rest.expandIcon;
                return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({}, rest, {
                    className: itemCls,
                    style: style,
                    id: id
                }), /*#__PURE__*/ $6fFrj.createElement("div", headerProps, this.renderIcon(), this.renderTitle(), ifExtraExist && /*#__PURE__*/ $6fFrj.createElement("div", {
                    className: "".concat(prefixCls, "-extra")
                }, extra)), /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), (0, $fIrcP.default)({
                    visible: isActive,
                    leavedClassName: "".concat(prefixCls, "-content-hidden")
                }, openMotion, {
                    forceRender: forceRender,
                    removeOnLeave: destroyInactivePanel
                }), function(_ref, ref) {
                    var motionClassName = _ref.className, motionStyle = _ref.style;
                    return /*#__PURE__*/ $6fFrj.createElement((0, $77a21cd256a40298$export$2e2bcd8739ae039), {
                        ref: ref,
                        prefixCls: prefixCls,
                        className: motionClassName,
                        style: motionStyle,
                        isActive: isActive,
                        forceRender: forceRender,
                        role: accordion ? 'tabpanel' : null
                    }, children);
                }));
            }
        }
    ]);
    return CollapsePanel;
}($6fFrj.Component);
$2110ab19c5a519f2$var$CollapsePanel.defaultProps = {
    showArrow: true,
    isActive: false,
    onItemClick: function onItemClick() {},
    headerClass: '',
    forceRender: false
};
var $2110ab19c5a519f2$export$2e2bcd8739ae039 = $2110ab19c5a519f2$var$CollapsePanel;


function $f11df5e06d39b1dc$var$getActiveKeysArray(activeKey) {
    var currentActiveKey = activeKey;
    if (!Array.isArray(currentActiveKey)) {
        var activeKeyType = (0, $5KhTJ.default)(currentActiveKey);
        currentActiveKey = activeKeyType === 'number' || activeKeyType === 'string' ? [
            currentActiveKey
        ] : [];
    }
    return currentActiveKey.map(function(key) {
        return String(key);
    });
}
var $f11df5e06d39b1dc$var$Collapse = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(Collapse, _React$Component);
    var _super = (0, $lSufv.default)(Collapse);
    function Collapse(_props) {
        var _this;
        (0, $kjNeN.default)(this, Collapse);
        _this = _super.call(this, _props);
        _this.onClickItem = function(key) {
            var activeKey = _this.state.activeKey;
            if (_this.props.accordion) activeKey = activeKey[0] === key ? [] : [
                key
            ];
            else {
                activeKey = (0, $37xND.default)(activeKey);
                var index = activeKey.indexOf(key);
                var isActive = index > -1;
                if (isActive) // remove active state
                activeKey.splice(index, 1);
                else activeKey.push(key);
            }
            _this.setActiveKey(activeKey);
        };
        _this.getNewChild = function(child, index) {
            if (!child) return null;
            var activeKey = _this.state.activeKey;
            var _this$props = _this.props, prefixCls = _this$props.prefixCls, openMotion = _this$props.openMotion, accordion = _this$props.accordion, rootDestroyInactivePanel = _this$props.destroyInactivePanel, expandIcon = _this$props.expandIcon, collapsible = _this$props.collapsible; // If there is no key provide, use the panel order as default key
            var key = child.key || String(index);
            var _child$props = child.props, header = _child$props.header, headerClass = _child$props.headerClass, destroyInactivePanel = _child$props.destroyInactivePanel, childCollapsible = _child$props.collapsible;
            var isActive = false;
            if (accordion) isActive = activeKey[0] === key;
            else isActive = activeKey.indexOf(key) > -1;
            var mergeCollapsible = childCollapsible !== null && childCollapsible !== void 0 ? childCollapsible : collapsible;
            var props = {
                key: key,
                panelKey: key,
                header: header,
                headerClass: headerClass,
                isActive: isActive,
                prefixCls: prefixCls,
                destroyInactivePanel: destroyInactivePanel !== null && destroyInactivePanel !== void 0 ? destroyInactivePanel : rootDestroyInactivePanel,
                openMotion: openMotion,
                accordion: accordion,
                children: child.props.children,
                onItemClick: mergeCollapsible === 'disabled' ? null : _this.onClickItem,
                expandIcon: expandIcon,
                collapsible: mergeCollapsible
            }; // https://github.com/ant-design/ant-design/issues/20479
            if (typeof child.type === 'string') return child;
            Object.keys(props).forEach(function(propName) {
                if (typeof props[propName] === 'undefined') delete props[propName];
            });
            return /*#__PURE__*/ $6fFrj.cloneElement(child, props);
        };
        _this.getItems = function() {
            var children = _this.props.children;
            return (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(children).map(_this.getNewChild);
        };
        _this.setActiveKey = function(activeKey) {
            if (!('activeKey' in _this.props)) _this.setState({
                activeKey: activeKey
            });
            _this.props.onChange(_this.props.accordion ? activeKey[0] : activeKey);
        };
        var _activeKey = _props.activeKey, defaultActiveKey = _props.defaultActiveKey;
        var currentActiveKey = defaultActiveKey;
        if ('activeKey' in _props) currentActiveKey = _activeKey;
        _this.state = {
            activeKey: $f11df5e06d39b1dc$var$getActiveKeysArray(currentActiveKey)
        };
        return _this;
    }
    (0, $5KQxu.default)(Collapse, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                return !(0, (/*@__PURE__*/$parcel$interopDefault($802a1584717a396d$exports)))(this.props, nextProps) || !(0, (/*@__PURE__*/$parcel$interopDefault($802a1584717a396d$exports)))(this.state, nextState);
            }
        },
        {
            key: "render",
            value: function render() {
                var _classNames;
                var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, className = _this$props2.className, style = _this$props2.style, accordion = _this$props2.accordion;
                var collapseClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((_classNames = {}, (0, $43449.default)(_classNames, prefixCls, true), (0, $43449.default)(_classNames, className, !!className), _classNames));
                return /*#__PURE__*/ $6fFrj.createElement("div", {
                    className: collapseClassName,
                    style: style,
                    role: accordion ? 'tablist' : null
                }, this.getItems());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps) {
                var newState = {};
                if ('activeKey' in nextProps) newState.activeKey = $f11df5e06d39b1dc$var$getActiveKeysArray(nextProps.activeKey);
                return newState;
            }
        }
    ]);
    return Collapse;
}($6fFrj.Component);
$f11df5e06d39b1dc$var$Collapse.defaultProps = {
    prefixCls: 'rc-collapse',
    onChange: function onChange() {},
    accordion: false,
    destroyInactivePanel: false
};
$f11df5e06d39b1dc$var$Collapse.Panel = (0, $2110ab19c5a519f2$export$2e2bcd8739ae039);
var $f11df5e06d39b1dc$export$2e2bcd8739ae039 = $f11df5e06d39b1dc$var$Collapse;


var $bd0f55738e6b30c4$export$2e2bcd8739ae039 = (0, $f11df5e06d39b1dc$export$2e2bcd8739ae039);
var $bd0f55738e6b30c4$export$2ddb90ad54e5f587 = (0, $f11df5e06d39b1dc$export$2e2bcd8739ae039).Panel;



var $6fFrj = parcelRequire("6fFrj");







var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");


var $901c3054f1a5d66d$var$CollapsePanel = function CollapsePanel(props) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow;
    var prefixCls = getPrefixCls('collapse', customizePrefixCls);
    var collapsePanelClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)({}, "".concat(prefixCls, "-no-arrow"), !showArrow), className);
    return /*#__PURE__*/ $6fFrj.createElement((0, $bd0f55738e6b30c4$export$2e2bcd8739ae039).Panel, (0, $fIrcP.default)({}, props, {
        prefixCls: prefixCls,
        className: collapsePanelClassName
    }));
};
var $901c3054f1a5d66d$export$2e2bcd8739ae039 = $901c3054f1a5d66d$var$CollapsePanel;


var $dbe250b6a349746e$var$Collapse = function Collapse(props) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, _props$bordered = props.bordered, bordered = _props$bordered === void 0 ? true : _props$bordered, ghost = props.ghost, _props$expandIconPosi = props.expandIconPosition, expandIconPosition = _props$expandIconPosi === void 0 ? 'start' : _props$expandIconPosi;
    var prefixCls = getPrefixCls('collapse', customizePrefixCls);
    // Align with logic position
    var mergedExpandIconPosition = $6fFrj.useMemo(function() {
        if (expandIconPosition === 'left') return 'start';
        return expandIconPosition === 'right' ? 'end' : expandIconPosition;
    }, [
        expandIconPosition
    ]);
    var renderExpandIcon = function renderExpandIcon() {
        var panelProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var expandIcon = props.expandIcon;
        var icon = expandIcon ? expandIcon(panelProps) : /*#__PURE__*/ $6fFrj.createElement((0, $e7bd83ac29db4850$export$2e2bcd8739ae039), {
            rotate: panelProps.isActive ? 90 : undefined
        });
        return (0, $79365009d9b77ac6$export$e530037191fcd5d7)(icon, function() {
            return {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(icon.props.className, "".concat(prefixCls, "-arrow"))
            };
        });
    };
    var collapseClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-icon-position-").concat(mergedExpandIconPosition), (0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-borderless"), !bordered), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-ghost"), !!ghost), className);
    var openMotion = (0, $fIrcP.default)((0, $fIrcP.default)({}, (0, $779588b2444df86c$export$2e2bcd8739ae039)), {
        motionAppear: false,
        leavedClassName: "".concat(prefixCls, "-content-hidden")
    });
    var getItems = function getItems() {
        var children = props.children;
        return (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(children).map(function(child, index) {
            var _a;
            if ((_a = child.props) === null || _a === void 0 ? void 0 : _a.disabled) {
                var key = child.key || String(index);
                var _child$props = child.props, disabled = _child$props.disabled, collapsible = _child$props.collapsible;
                var childProps = (0, $fIrcP.default)((0, $fIrcP.default)({}, (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(child.props, [
                    'disabled'
                ])), {
                    key: key,
                    collapsible: collapsible !== null && collapsible !== void 0 ? collapsible : disabled ? 'disabled' : undefined
                });
                return (0, $79365009d9b77ac6$export$e530037191fcd5d7)(child, childProps);
            }
            return child;
        });
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $bd0f55738e6b30c4$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        openMotion: openMotion
    }, props, {
        expandIcon: renderExpandIcon,
        prefixCls: prefixCls,
        className: collapseClassName
    }), getItems());
};
$dbe250b6a349746e$var$Collapse.Panel = (0, $901c3054f1a5d66d$export$2e2bcd8739ae039);
var $dbe250b6a349746e$export$2e2bcd8739ae039 = $dbe250b6a349746e$var$Collapse;


var $45def89f679453ce$export$2e2bcd8739ae039 = (0, $dbe250b6a349746e$export$2e2bcd8739ae039);


var $7OMVO = parcelRequire("7OMVO");

var $3mXQ2 = parcelRequire("3mXQ2");
var $0bd6dd93325ef2b1$var$generateConfig = {
    // get
    getNow: function getNow() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7OMVO)))();
    },
    getFixedDate: function getFixedDate(string) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7OMVO)))(string, 'YYYY-MM-DD');
    },
    getEndDate: function getEndDate(date) {
        var clone = date.clone();
        return clone.endOf('month');
    },
    getWeekDay: function getWeekDay(date) {
        var clone = date.clone().locale('en_US');
        return clone.weekday() + clone.localeData().firstDayOfWeek();
    },
    getYear: function getYear(date) {
        return date.year();
    },
    getMonth: function getMonth(date) {
        return date.month();
    },
    getDate: function getDate(date) {
        return date.date();
    },
    getHour: function getHour(date) {
        return date.hour();
    },
    getMinute: function getMinute(date) {
        return date.minute();
    },
    getSecond: function getSecond(date) {
        return date.second();
    },
    // set
    addYear: function addYear(date, diff) {
        var clone = date.clone();
        return clone.add(diff, 'year');
    },
    addMonth: function addMonth(date, diff) {
        var clone = date.clone();
        return clone.add(diff, 'month');
    },
    addDate: function addDate(date, diff) {
        var clone = date.clone();
        return clone.add(diff, 'day');
    },
    setYear: function setYear(date, year) {
        var clone = date.clone();
        return clone.year(year);
    },
    setMonth: function setMonth(date, month) {
        var clone = date.clone();
        return clone.month(month);
    },
    setDate: function setDate(date, num) {
        var clone = date.clone();
        return clone.date(num);
    },
    setHour: function setHour(date, hour) {
        var clone = date.clone();
        return clone.hour(hour);
    },
    setMinute: function setMinute(date, minute) {
        var clone = date.clone();
        return clone.minute(minute);
    },
    setSecond: function setSecond(date, second) {
        var clone = date.clone();
        return clone.second(second);
    },
    // Compare
    isAfter: function isAfter(date1, date2) {
        return date1.isAfter(date2);
    },
    isValidate: function isValidate(date) {
        return date.isValid();
    },
    locale: {
        getWeekFirstDay: function getWeekFirstDay(locale) {
            var date = (0, (/*@__PURE__*/$parcel$interopDefault($7OMVO)))().locale(locale);
            return date.localeData().firstDayOfWeek();
        },
        getWeekFirstDate: function getWeekFirstDate(locale, date) {
            var clone = date.clone();
            var result = clone.locale(locale);
            return result.weekday(0);
        },
        getWeek: function getWeek(locale, date) {
            var clone = date.clone();
            var result = clone.locale(locale);
            return result.week();
        },
        getShortWeekDays: function getShortWeekDays(locale) {
            var date = (0, (/*@__PURE__*/$parcel$interopDefault($7OMVO)))().locale(locale);
            return date.localeData().weekdaysMin();
        },
        getShortMonths: function getShortMonths(locale) {
            var date = (0, (/*@__PURE__*/$parcel$interopDefault($7OMVO)))().locale(locale);
            return date.localeData().monthsShort();
        },
        format: function format(locale, date, _format) {
            var clone = date.clone();
            var result = clone.locale(locale);
            return result.format(_format);
        },
        parse: function parse(locale, text, formats) {
            var fallbackFormatList = [];
            for(var i = 0; i < formats.length; i += 1){
                var format = formats[i];
                var formatText = text;
                if (format.includes('wo') || format.includes('Wo')) {
                    format = format.replace(/wo/g, 'w').replace(/Wo/g, 'W');
                    var matchFormat = format.match(/[-YyMmDdHhSsWwGg]+/g);
                    var matchText = formatText.match(/[-\d]+/g);
                    if (matchFormat && matchText) {
                        format = matchFormat.join('');
                        formatText = matchText.join('');
                    } else fallbackFormatList.push(format.replace(/o/g, ''));
                }
                var date = (0, (/*@__PURE__*/$parcel$interopDefault($7OMVO)))(formatText, format, locale, true);
                if (date.isValid()) return date;
            }
            // Fallback to fuzzy matching, this should always not reach match or need fire a issue
            for(var _i = 0; _i < fallbackFormatList.length; _i += 1){
                var _date = (0, (/*@__PURE__*/$parcel$interopDefault($7OMVO)))(text, fallbackFormatList[_i], locale, false);
                /* istanbul ignore next */ if (_date.isValid()) {
                    (0, $3mXQ2.noteOnce)(false, 'Not match any format strictly and fallback to fuzzy match. Please help to fire a issue about this.');
                    return _date;
                }
            }
            return null;
        }
    }
};
var $0bd6dd93325ef2b1$export$2e2bcd8739ae039 = $0bd6dd93325ef2b1$var$generateConfig;



var $fIrcP = parcelRequire("fIrcP");


var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

function $7b59d5538be332fc$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $ea0942a2e543872a$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        size: "small",
        type: "primary"
    }, props));
}



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");


var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");





var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");

var $7aa2a0b086afda84$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7aa2a0b086afda84$var$CheckableTag = function CheckableTag(_a) {
    var customizePrefixCls = _a.prefixCls, className = _a.className, checked = _a.checked, onChange = _a.onChange, onClick = _a.onClick, restProps = $7aa2a0b086afda84$var$__rest(_a, [
        "prefixCls",
        "className",
        "checked",
        "onChange",
        "onClick"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var handleClick = function handleClick(e) {
        onChange === null || onChange === void 0 || onChange(!checked);
        onClick === null || onClick === void 0 || onClick(e);
    };
    var prefixCls = getPrefixCls('tag', customizePrefixCls);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-checkable"), true), "".concat(prefixCls, "-checkable-checked"), checked), className);
    return /*#__PURE__*/ $6fFrj.createElement("span", (0, $fIrcP.default)({}, restProps, {
        className: cls,
        onClick: handleClick
    }));
};
var $7aa2a0b086afda84$export$2e2bcd8739ae039 = $7aa2a0b086afda84$var$CheckableTag;


var $3c2758025c182ca4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3c2758025c182ca4$var$PresetColorRegex = new RegExp("^(".concat((0, $b43ce6bf43415109$export$37ea70cc324d3d0e).join('|'), ")(-inverse)?$"));
var $3c2758025c182ca4$var$PresetStatusColorRegex = new RegExp("^(".concat((0, $b43ce6bf43415109$export$bb684163c94c55ae).join('|'), ")$"));
var $3c2758025c182ca4$var$InternalTag = function InternalTag(_a, ref) {
    var customizePrefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children, icon = _a.icon, color = _a.color, onClose = _a.onClose, closeIcon = _a.closeIcon, _a$closable = _a.closable, closable = _a$closable === void 0 ? false : _a$closable, props = $3c2758025c182ca4$var$__rest(_a, [
        "prefixCls",
        "className",
        "style",
        "children",
        "icon",
        "color",
        "onClose",
        "closeIcon",
        "closable"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var _React$useState = $6fFrj.useState(true), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), visible = _React$useState2[0], setVisible = _React$useState2[1];
    $6fFrj.useEffect(function() {
        if ('visible' in props) setVisible(props.visible);
    }, [
        props.visible
    ]);
    var isPresetColor = function isPresetColor() {
        if (!color) return false;
        return $3c2758025c182ca4$var$PresetColorRegex.test(color) || $3c2758025c182ca4$var$PresetStatusColorRegex.test(color);
    };
    var tagStyle = (0, $fIrcP.default)({
        backgroundColor: color && !isPresetColor() ? color : undefined
    }, style);
    var presetColor = isPresetColor();
    var prefixCls = getPrefixCls('tag', customizePrefixCls);
    var tagClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-").concat(color), presetColor), "".concat(prefixCls, "-has-color"), color && !presetColor), "".concat(prefixCls, "-hidden"), !visible), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    var handleCloseClick = function handleCloseClick(e) {
        e.stopPropagation();
        onClose === null || onClose === void 0 || onClose(e);
        if (e.defaultPrevented) return;
        if (!('visible' in props)) setVisible(false);
    };
    var renderCloseIcon = function renderCloseIcon() {
        if (closable) return closeIcon ? /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-close-icon"),
            onClick: handleCloseClick
        }, closeIcon) : /*#__PURE__*/ $6fFrj.createElement((0, $4cb3f1f073816266$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-close-icon"),
            onClick: handleCloseClick
        });
        return null;
    };
    var isNeedWave = 'onClick' in props || children && children.type === 'a';
    var tagProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(props, [
        'visible'
    ]);
    var iconNode = icon || null;
    var kids = iconNode ? /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, iconNode, /*#__PURE__*/ $6fFrj.createElement("span", null, children)) : children;
    var tagNode = /*#__PURE__*/ $6fFrj.createElement("span", (0, $fIrcP.default)({}, tagProps, {
        ref: ref,
        className: tagClassName,
        style: tagStyle
    }), kids, renderCloseIcon());
    return isNeedWave ? /*#__PURE__*/ $6fFrj.createElement((0, $3b8de09695d8518a$export$2e2bcd8739ae039), null, tagNode) : tagNode;
};
var $3c2758025c182ca4$var$Tag = /*#__PURE__*/ $6fFrj.forwardRef($3c2758025c182ca4$var$InternalTag);
$3c2758025c182ca4$var$Tag.CheckableTag = (0, $7aa2a0b086afda84$export$2e2bcd8739ae039);
var $3c2758025c182ca4$export$2e2bcd8739ae039 = $3c2758025c182ca4$var$Tag;


function $2b092d03cca171d5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $3c2758025c182ca4$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        color: "blue"
    }, props));
}



var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $0165558dc51a5480$var$CalendarOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z"
                }
            }
        ]
    },
    "name": "calendar",
    "theme": "outlined"
};
var $0165558dc51a5480$export$2e2bcd8739ae039 = $0165558dc51a5480$var$CalendarOutlined;



var $2c8de0c8eaf4f5c0$var$CalendarOutlined = function CalendarOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $0165558dc51a5480$export$2e2bcd8739ae039)
    }));
};
var $2c8de0c8eaf4f5c0$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($2c8de0c8eaf4f5c0$var$CalendarOutlined);
var $2c8de0c8eaf4f5c0$export$2e2bcd8739ae039 = $2c8de0c8eaf4f5c0$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $876926ec33fb751c$var$ClockCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                }
            }
        ]
    },
    "name": "clock-circle",
    "theme": "outlined"
};
var $876926ec33fb751c$export$2e2bcd8739ae039 = $876926ec33fb751c$var$ClockCircleOutlined;



var $9824e6cb0e907529$var$ClockCircleOutlined = function ClockCircleOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $876926ec33fb751c$export$2e2bcd8739ae039)
    }));
};
var $9824e6cb0e907529$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($9824e6cb0e907529$var$ClockCircleOutlined);
var $9824e6cb0e907529$export$2e2bcd8739ae039 = $9824e6cb0e907529$var$RefIcon;




var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $78d4a36e214e9b93$var$SwapRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z"
                }
            }
        ]
    },
    "name": "swap-right",
    "theme": "outlined"
};
var $78d4a36e214e9b93$export$2e2bcd8739ae039 = $78d4a36e214e9b93$var$SwapRightOutlined;



var $f945346b4a79c805$var$SwapRightOutlined = function SwapRightOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $78d4a36e214e9b93$export$2e2bcd8739ae039)
    }));
};
var $f945346b4a79c805$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($f945346b4a79c805$var$SwapRightOutlined);
var $f945346b4a79c805$export$2e2bcd8739ae039 = $f945346b4a79c805$var$RefIcon;



var $fActo = parcelRequire("fActo");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $3mXQ2 = parcelRequire("3mXQ2");

var $gfhff = parcelRequire("gfhff");

var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $5KhTJ = parcelRequire("5KhTJ");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $d1496e6c3ad7f80f$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $d1496e6c3ad7f80f$var$KeyCode.F1 && keyCode <= $d1496e6c3ad7f80f$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $d1496e6c3ad7f80f$var$KeyCode.ALT:
            case $d1496e6c3ad7f80f$var$KeyCode.CAPS_LOCK:
            case $d1496e6c3ad7f80f$var$KeyCode.CONTEXT_MENU:
            case $d1496e6c3ad7f80f$var$KeyCode.CTRL:
            case $d1496e6c3ad7f80f$var$KeyCode.DOWN:
            case $d1496e6c3ad7f80f$var$KeyCode.END:
            case $d1496e6c3ad7f80f$var$KeyCode.ESC:
            case $d1496e6c3ad7f80f$var$KeyCode.HOME:
            case $d1496e6c3ad7f80f$var$KeyCode.INSERT:
            case $d1496e6c3ad7f80f$var$KeyCode.LEFT:
            case $d1496e6c3ad7f80f$var$KeyCode.MAC_FF_META:
            case $d1496e6c3ad7f80f$var$KeyCode.META:
            case $d1496e6c3ad7f80f$var$KeyCode.NUMLOCK:
            case $d1496e6c3ad7f80f$var$KeyCode.NUM_CENTER:
            case $d1496e6c3ad7f80f$var$KeyCode.PAGE_DOWN:
            case $d1496e6c3ad7f80f$var$KeyCode.PAGE_UP:
            case $d1496e6c3ad7f80f$var$KeyCode.PAUSE:
            case $d1496e6c3ad7f80f$var$KeyCode.PRINT_SCREEN:
            case $d1496e6c3ad7f80f$var$KeyCode.RIGHT:
            case $d1496e6c3ad7f80f$var$KeyCode.SHIFT:
            case $d1496e6c3ad7f80f$var$KeyCode.UP:
            case $d1496e6c3ad7f80f$var$KeyCode.WIN_KEY:
            case $d1496e6c3ad7f80f$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $d1496e6c3ad7f80f$var$KeyCode.ZERO && keyCode <= $d1496e6c3ad7f80f$var$KeyCode.NINE) return true;
        if (keyCode >= $d1496e6c3ad7f80f$var$KeyCode.NUM_ZERO && keyCode <= $d1496e6c3ad7f80f$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $d1496e6c3ad7f80f$var$KeyCode.A && keyCode <= $d1496e6c3ad7f80f$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $d1496e6c3ad7f80f$var$KeyCode.SPACE:
            case $d1496e6c3ad7f80f$var$KeyCode.QUESTION_MARK:
            case $d1496e6c3ad7f80f$var$KeyCode.NUM_PLUS:
            case $d1496e6c3ad7f80f$var$KeyCode.NUM_MINUS:
            case $d1496e6c3ad7f80f$var$KeyCode.NUM_PERIOD:
            case $d1496e6c3ad7f80f$var$KeyCode.NUM_DIVISION:
            case $d1496e6c3ad7f80f$var$KeyCode.SEMICOLON:
            case $d1496e6c3ad7f80f$var$KeyCode.DASH:
            case $d1496e6c3ad7f80f$var$KeyCode.EQUALS:
            case $d1496e6c3ad7f80f$var$KeyCode.COMMA:
            case $d1496e6c3ad7f80f$var$KeyCode.PERIOD:
            case $d1496e6c3ad7f80f$var$KeyCode.SLASH:
            case $d1496e6c3ad7f80f$var$KeyCode.APOSTROPHE:
            case $d1496e6c3ad7f80f$var$KeyCode.SINGLE_QUOTE:
            case $d1496e6c3ad7f80f$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $d1496e6c3ad7f80f$var$KeyCode.BACKSLASH:
            case $d1496e6c3ad7f80f$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $d1496e6c3ad7f80f$export$2e2bcd8739ae039 = $d1496e6c3ad7f80f$var$KeyCode;



var $3mXQ2 = parcelRequire("3mXQ2");

var $gfhff = parcelRequire("gfhff");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");
var $03d96fa1dbfe5ae5$var$PanelContext = /*#__PURE__*/ $6fFrj.createContext({});
var $03d96fa1dbfe5ae5$export$2e2bcd8739ae039 = $03d96fa1dbfe5ae5$var$PanelContext;


var $ed92577a8a4d6745$var$HIDDEN_STYLE = {
    visibility: 'hidden'
};
function $ed92577a8a4d6745$var$Header(_ref) {
    var prefixCls = _ref.prefixCls, _ref$prevIcon = _ref.prevIcon, prevIcon = _ref$prevIcon === void 0 ? "\u2039" : _ref$prevIcon, _ref$nextIcon = _ref.nextIcon, nextIcon = _ref$nextIcon === void 0 ? "\u203A" : _ref$nextIcon, _ref$superPrevIcon = _ref.superPrevIcon, superPrevIcon = _ref$superPrevIcon === void 0 ? "\xAB" : _ref$superPrevIcon, _ref$superNextIcon = _ref.superNextIcon, superNextIcon = _ref$superNextIcon === void 0 ? "\xBB" : _ref$superNextIcon, onSuperPrev = _ref.onSuperPrev, onSuperNext = _ref.onSuperNext, onPrev = _ref.onPrev, onNext = _ref.onNext, children = _ref.children;
    var _React$useContext = $6fFrj.useContext((0, $03d96fa1dbfe5ae5$export$2e2bcd8739ae039)), hideNextBtn = _React$useContext.hideNextBtn, hidePrevBtn = _React$useContext.hidePrevBtn;
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: prefixCls
    }, onSuperPrev && /*#__PURE__*/ $6fFrj.createElement("button", {
        type: "button",
        onClick: onSuperPrev,
        tabIndex: -1,
        className: "".concat(prefixCls, "-super-prev-btn"),
        style: hidePrevBtn ? $ed92577a8a4d6745$var$HIDDEN_STYLE : {}
    }, superPrevIcon), onPrev && /*#__PURE__*/ $6fFrj.createElement("button", {
        type: "button",
        onClick: onPrev,
        tabIndex: -1,
        className: "".concat(prefixCls, "-prev-btn"),
        style: hidePrevBtn ? $ed92577a8a4d6745$var$HIDDEN_STYLE : {}
    }, prevIcon), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-view")
    }, children), onNext && /*#__PURE__*/ $6fFrj.createElement("button", {
        type: "button",
        onClick: onNext,
        tabIndex: -1,
        className: "".concat(prefixCls, "-next-btn"),
        style: hideNextBtn ? $ed92577a8a4d6745$var$HIDDEN_STYLE : {}
    }, nextIcon), onSuperNext && /*#__PURE__*/ $6fFrj.createElement("button", {
        type: "button",
        onClick: onSuperNext,
        tabIndex: -1,
        className: "".concat(prefixCls, "-super-next-btn"),
        style: hideNextBtn ? $ed92577a8a4d6745$var$HIDDEN_STYLE : {}
    }, superNextIcon));
}
var $ed92577a8a4d6745$export$2e2bcd8739ae039 = $ed92577a8a4d6745$var$Header;




var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");



function $c27ca652b764a64b$var$DecadeHeader(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, viewDate = props.viewDate, onPrevDecades = props.onPrevDecades, onNextDecades = props.onNextDecades;
    var _React$useContext = $6fFrj.useContext((0, $03d96fa1dbfe5ae5$export$2e2bcd8739ae039)), hideHeader = _React$useContext.hideHeader;
    if (hideHeader) return null;
    var headerPrefixCls = "".concat(prefixCls, "-header");
    var yearNumber = generateConfig.getYear(viewDate);
    var startYear = Math.floor(yearNumber / (0, $7345567541ec02b1$export$cd67ebcccd286127)) * (0, $7345567541ec02b1$export$cd67ebcccd286127);
    var endYear = startYear + (0, $7345567541ec02b1$export$cd67ebcccd286127) - 1;
    return /*#__PURE__*/ $6fFrj.createElement((0, $ed92577a8a4d6745$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: headerPrefixCls,
        onSuperPrev: onPrevDecades,
        onSuperNext: onNextDecades
    }), startYear, "-", endYear);
}
var $c27ca652b764a64b$export$2e2bcd8739ae039 = $c27ca652b764a64b$var$DecadeHeader;



var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");


var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

function $bf5c2cfe19b8eb58$export$e5d5e1c1822b6e56(generateConfig, date, hour, minute, second) {
    var nextTime = generateConfig.setHour(date, hour);
    nextTime = generateConfig.setMinute(nextTime, minute);
    nextTime = generateConfig.setSecond(nextTime, second);
    return nextTime;
}
function $bf5c2cfe19b8eb58$export$3a84b9eda98e95dc(generateConfig, date, defaultDate) {
    if (!defaultDate) return date;
    var newDate = date;
    newDate = generateConfig.setHour(newDate, generateConfig.getHour(defaultDate));
    newDate = generateConfig.setMinute(newDate, generateConfig.getMinute(defaultDate));
    newDate = generateConfig.setSecond(newDate, generateConfig.getSecond(defaultDate));
    return newDate;
}
function $bf5c2cfe19b8eb58$export$6ebc74d7e616149(hour, minute, second, hourStep, minuteStep, secondStep) {
    var lowerBoundHour = Math.floor(hour / hourStep) * hourStep;
    if (lowerBoundHour < hour) return [
        lowerBoundHour,
        60 - minuteStep,
        60 - secondStep
    ];
    var lowerBoundMinute = Math.floor(minute / minuteStep) * minuteStep;
    if (lowerBoundMinute < minute) return [
        lowerBoundHour,
        lowerBoundMinute,
        60 - secondStep
    ];
    var lowerBoundSecond = Math.floor(second / secondStep) * secondStep;
    return [
        lowerBoundHour,
        lowerBoundMinute,
        lowerBoundSecond
    ];
}
function $bf5c2cfe19b8eb58$export$6c3baea86681d743(generateConfig, date) {
    var year = generateConfig.getYear(date);
    var month = generateConfig.getMonth(date) + 1;
    var endDate = generateConfig.getEndDate(generateConfig.getFixedDate("".concat(year, "-").concat(month, "-01")));
    var lastDay = generateConfig.getDate(endDate);
    var monthShow = month < 10 ? "0".concat(month) : "".concat(month);
    return "".concat(year, "-").concat(monthShow, "-").concat(lastDay);
}



function $d7c6689876c548a6$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, disabledDate = _ref.disabledDate, onSelect = _ref.onSelect, picker = _ref.picker, rowNum = _ref.rowNum, colNum = _ref.colNum, prefixColumn = _ref.prefixColumn, rowClassName = _ref.rowClassName, baseDate = _ref.baseDate, getCellClassName = _ref.getCellClassName, getCellText = _ref.getCellText, getCellNode = _ref.getCellNode, getCellDate = _ref.getCellDate, generateConfig = _ref.generateConfig, titleCell = _ref.titleCell, headerCells = _ref.headerCells;
    var _React$useContext = $6fFrj.useContext((0, $03d96fa1dbfe5ae5$export$2e2bcd8739ae039)), onDateMouseEnter = _React$useContext.onDateMouseEnter, onDateMouseLeave = _React$useContext.onDateMouseLeave, mode = _React$useContext.mode;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    // =============================== Body ===============================
    var rows = [];
    for(var i = 0; i < rowNum; i += 1){
        var row = [];
        var rowStartDate = void 0;
        var _loop = function _loop() {
            var _objectSpread2;
            var offset = i * colNum + j;
            var currentDate = getCellDate(baseDate, offset);
            var disabled = (0, $69bfe3a3f4b23cc1$export$c503c160691b0dfe)({
                cellDate: currentDate,
                mode: mode,
                disabledDate: disabledDate,
                generateConfig: generateConfig
            });
            if (j === 0) {
                rowStartDate = currentDate;
                if (prefixColumn) row.push(prefixColumn(rowStartDate));
            }
            var title = titleCell && titleCell(currentDate);
            row.push(/*#__PURE__*/ $6fFrj.createElement("td", {
                key: j,
                title: title,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(cellPrefixCls, (0, $kNxFX.default)((_objectSpread2 = {}, (0, $43449.default)(_objectSpread2, "".concat(cellPrefixCls, "-disabled"), disabled), (0, $43449.default)(_objectSpread2, "".concat(cellPrefixCls, "-start"), getCellText(currentDate) === 1 || picker === 'year' && Number(title) % 10 === 0), (0, $43449.default)(_objectSpread2, "".concat(cellPrefixCls, "-end"), title === (0, $bf5c2cfe19b8eb58$export$6c3baea86681d743)(generateConfig, currentDate) || picker === 'year' && Number(title) % 10 === 9), _objectSpread2), getCellClassName(currentDate))),
                onClick: function onClick() {
                    if (!disabled) onSelect(currentDate);
                },
                onMouseEnter: function onMouseEnter() {
                    if (!disabled && onDateMouseEnter) onDateMouseEnter(currentDate);
                },
                onMouseLeave: function onMouseLeave() {
                    if (!disabled && onDateMouseLeave) onDateMouseLeave(currentDate);
                }
            }, getCellNode ? getCellNode(currentDate) : /*#__PURE__*/ $6fFrj.createElement("div", {
                className: "".concat(cellPrefixCls, "-inner")
            }, getCellText(currentDate))));
        };
        for(var j = 0; j < colNum; j += 1)_loop();
        rows.push(/*#__PURE__*/ $6fFrj.createElement("tr", {
            key: i,
            className: rowClassName && rowClassName(rowStartDate)
        }, row));
    }
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-body")
    }, /*#__PURE__*/ $6fFrj.createElement("table", {
        className: "".concat(prefixCls, "-content")
    }, headerCells && /*#__PURE__*/ $6fFrj.createElement("thead", null, /*#__PURE__*/ $6fFrj.createElement("tr", null, headerCells)), /*#__PURE__*/ $6fFrj.createElement("tbody", null, rows)));
}


var $27c780f2b277dffa$export$dfe66ab72640953 = 3;
var $27c780f2b277dffa$var$DECADE_ROW_COUNT = 4;
function $27c780f2b277dffa$var$DecadeBody(props) {
    var DECADE_UNIT_DIFF_DES = (0, $7345567541ec02b1$export$2714f720f9350aa) - 1;
    var prefixCls = props.prefixCls, viewDate = props.viewDate, generateConfig = props.generateConfig;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var yearNumber = generateConfig.getYear(viewDate);
    var decadeYearNumber = Math.floor(yearNumber / (0, $7345567541ec02b1$export$2714f720f9350aa)) * (0, $7345567541ec02b1$export$2714f720f9350aa);
    var startDecadeYear = Math.floor(yearNumber / (0, $7345567541ec02b1$export$cd67ebcccd286127)) * (0, $7345567541ec02b1$export$cd67ebcccd286127);
    var endDecadeYear = startDecadeYear + (0, $7345567541ec02b1$export$cd67ebcccd286127) - 1;
    var baseDecadeYear = generateConfig.setYear(viewDate, startDecadeYear - Math.ceil(($27c780f2b277dffa$export$dfe66ab72640953 * $27c780f2b277dffa$var$DECADE_ROW_COUNT * (0, $7345567541ec02b1$export$2714f720f9350aa) - (0, $7345567541ec02b1$export$cd67ebcccd286127)) / 2));
    var getCellClassName = function getCellClassName(date) {
        var _ref;
        var startDecadeNumber = generateConfig.getYear(date);
        var endDecadeNumber = startDecadeNumber + DECADE_UNIT_DIFF_DES;
        return _ref = {}, (0, $43449.default)(_ref, "".concat(cellPrefixCls, "-in-view"), startDecadeYear <= startDecadeNumber && endDecadeNumber <= endDecadeYear), (0, $43449.default)(_ref, "".concat(cellPrefixCls, "-selected"), startDecadeNumber === decadeYearNumber), _ref;
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $d7c6689876c548a6$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        rowNum: $27c780f2b277dffa$var$DECADE_ROW_COUNT,
        colNum: $27c780f2b277dffa$export$dfe66ab72640953,
        baseDate: baseDecadeYear,
        getCellText: function getCellText(date) {
            var startDecadeNumber = generateConfig.getYear(date);
            return "".concat(startDecadeNumber, "-").concat(startDecadeNumber + DECADE_UNIT_DIFF_DES);
        },
        getCellClassName: getCellClassName,
        getCellDate: function getCellDate(date, offset) {
            return generateConfig.addYear(date, offset * (0, $7345567541ec02b1$export$2714f720f9350aa));
        }
    }));
}
var $27c780f2b277dffa$export$2e2bcd8739ae039 = $27c780f2b277dffa$var$DecadeBody;



var $37xND = parcelRequire("37xND");


var $hqic8 = parcelRequire("hqic8");

var $92cb4f3f33042a05$var$scrollIds = new Map();
function $92cb4f3f33042a05$export$55c3897747695e9b(element, callback) {
    var id;
    function tryOrNextFrame() {
        if ((0, $5335db4432c3f914$export$2e2bcd8739ae039)(element)) callback();
        else id = (0, $hqic8.default)(function() {
            tryOrNextFrame();
        });
    }
    tryOrNextFrame();
    return function() {
        (0, $hqic8.default).cancel(id);
    };
}
function $92cb4f3f33042a05$export$3f99968195accfaf(element, to, duration) {
    if ($92cb4f3f33042a05$var$scrollIds.get(element)) cancelAnimationFrame($92cb4f3f33042a05$var$scrollIds.get(element));
    // jump to target if duration zero
    if (duration <= 0) {
        $92cb4f3f33042a05$var$scrollIds.set(element, requestAnimationFrame(function() {
            element.scrollTop = to;
        }));
        return;
    }
    var difference = to - element.scrollTop;
    var perTick = difference / duration * 10;
    $92cb4f3f33042a05$var$scrollIds.set(element, requestAnimationFrame(function() {
        element.scrollTop += perTick;
        if (element.scrollTop !== to) $92cb4f3f33042a05$export$3f99968195accfaf(element, to, duration - 10);
    }));
}
function $92cb4f3f33042a05$export$a507db46d3f03278(event, _ref) {
    var onLeftRight = _ref.onLeftRight, onCtrlLeftRight = _ref.onCtrlLeftRight, onUpDown = _ref.onUpDown, onPageUpDown = _ref.onPageUpDown, onEnter = _ref.onEnter;
    var which = event.which, ctrlKey = event.ctrlKey, metaKey = event.metaKey;
    switch(which){
        case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).LEFT:
            if (ctrlKey || metaKey) {
                if (onCtrlLeftRight) {
                    onCtrlLeftRight(-1);
                    return true;
                }
            } else if (onLeftRight) {
                onLeftRight(-1);
                return true;
            }
            break;
        case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).RIGHT:
            if (ctrlKey || metaKey) {
                if (onCtrlLeftRight) {
                    onCtrlLeftRight(1);
                    return true;
                }
            } else if (onLeftRight) {
                onLeftRight(1);
                return true;
            }
            break;
        case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).UP:
            if (onUpDown) {
                onUpDown(-1);
                return true;
            }
            break;
        case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).DOWN:
            if (onUpDown) {
                onUpDown(1);
                return true;
            }
            break;
        case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).PAGE_UP:
            if (onPageUpDown) {
                onPageUpDown(-1);
                return true;
            }
            break;
        case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).PAGE_DOWN:
            if (onPageUpDown) {
                onPageUpDown(1);
                return true;
            }
            break;
        case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER:
            if (onEnter) {
                onEnter();
                return true;
            }
            break;
    }
    return false;
}
function $92cb4f3f33042a05$export$3e0385bd234197e6(format, picker, showTime, use12Hours) {
    var mergedFormat = format;
    if (!mergedFormat) switch(picker){
        case 'time':
            mergedFormat = use12Hours ? 'hh:mm:ss a' : 'HH:mm:ss';
            break;
        case 'week':
            mergedFormat = 'gggg-wo';
            break;
        case 'month':
            mergedFormat = 'YYYY-MM';
            break;
        case 'quarter':
            mergedFormat = 'YYYY-[Q]Q';
            break;
        case 'year':
            mergedFormat = 'YYYY';
            break;
        default:
            mergedFormat = showTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
    }
    return mergedFormat;
}
function $92cb4f3f33042a05$export$c4929e7560bc7c3e(picker, format, generateConfig) {
    var defaultSize = picker === 'time' ? 8 : 10;
    var length = typeof format === 'function' ? format(generateConfig.getNow()).length : format.length;
    return Math.max(defaultSize, length) + 2;
}
var $92cb4f3f33042a05$var$globalClickFunc = null;
var $92cb4f3f33042a05$var$clickCallbacks = new Set();
function $92cb4f3f33042a05$export$1ccf549497681f00(callback) {
    if (!$92cb4f3f33042a05$var$globalClickFunc && typeof window !== 'undefined' && window.addEventListener) {
        $92cb4f3f33042a05$var$globalClickFunc = function globalClickFunc(e) {
            // Clone a new list to avoid repeat trigger events
            (0, $37xND.default)($92cb4f3f33042a05$var$clickCallbacks).forEach(function(queueFunc) {
                queueFunc(e);
            });
        };
        window.addEventListener('mousedown', $92cb4f3f33042a05$var$globalClickFunc);
    }
    $92cb4f3f33042a05$var$clickCallbacks.add(callback);
    return function() {
        $92cb4f3f33042a05$var$clickCallbacks.delete(callback);
        if ($92cb4f3f33042a05$var$clickCallbacks.size === 0) {
            window.removeEventListener('mousedown', $92cb4f3f33042a05$var$globalClickFunc);
            $92cb4f3f33042a05$var$globalClickFunc = null;
        }
    };
}
function $92cb4f3f33042a05$export$2fb4f2d524461006(e) {
    var target = e.target;
    // get target if in shadow dom
    if (e.composed && target.shadowRoot) {
        var _e$composedPath;
        return ((_e$composedPath = e.composedPath) === null || _e$composedPath === void 0 ? void 0 : _e$composedPath.call(e)[0]) || target;
    }
    return target;
}
// ====================== Mode ======================
var $92cb4f3f33042a05$var$getYearNextMode = function getYearNextMode(next) {
    if (next === 'month' || next === 'date') return 'year';
    return next;
};
var $92cb4f3f33042a05$var$getMonthNextMode = function getMonthNextMode(next) {
    if (next === 'date') return 'month';
    return next;
};
var $92cb4f3f33042a05$var$getQuarterNextMode = function getQuarterNextMode(next) {
    if (next === 'month' || next === 'date') return 'quarter';
    return next;
};
var $92cb4f3f33042a05$var$getWeekNextMode = function getWeekNextMode(next) {
    if (next === 'date') return 'week';
    return next;
};
var $92cb4f3f33042a05$export$6b35bb792c096c09 = {
    year: $92cb4f3f33042a05$var$getYearNextMode,
    month: $92cb4f3f33042a05$var$getMonthNextMode,
    quarter: $92cb4f3f33042a05$var$getQuarterNextMode,
    week: $92cb4f3f33042a05$var$getWeekNextMode,
    time: null,
    date: null
};
function $92cb4f3f33042a05$export$9350e4ea4b8364(elements, target) {
    return elements.some(function(ele) {
        return ele && ele.contains(target);
    });
}


var $7345567541ec02b1$export$2714f720f9350aa = 10;
var $7345567541ec02b1$export$cd67ebcccd286127 = $7345567541ec02b1$export$2714f720f9350aa * 10;
function $7345567541ec02b1$var$DecadePanel(props) {
    var prefixCls = props.prefixCls, onViewDateChange = props.onViewDateChange, generateConfig = props.generateConfig, viewDate = props.viewDate, operationRef = props.operationRef, onSelect = props.onSelect, onPanelChange = props.onPanelChange;
    var panelPrefixCls = "".concat(prefixCls, "-decade-panel");
    // ======================= Keyboard =======================
    operationRef.current = {
        onKeyDown: function onKeyDown(event) {
            return (0, $92cb4f3f33042a05$export$a507db46d3f03278)(event, {
                onLeftRight: function onLeftRight(diff) {
                    onSelect(generateConfig.addYear(viewDate, diff * $7345567541ec02b1$export$2714f720f9350aa), 'key');
                },
                onCtrlLeftRight: function onCtrlLeftRight(diff) {
                    onSelect(generateConfig.addYear(viewDate, diff * $7345567541ec02b1$export$cd67ebcccd286127), 'key');
                },
                onUpDown: function onUpDown(diff) {
                    onSelect(generateConfig.addYear(viewDate, diff * $7345567541ec02b1$export$2714f720f9350aa * (0, $27c780f2b277dffa$export$dfe66ab72640953)), 'key');
                },
                onEnter: function onEnter() {
                    onPanelChange('year', viewDate);
                }
            });
        }
    };
    // ==================== View Operation ====================
    var onDecadesChange = function onDecadesChange(diff) {
        var newDate = generateConfig.addYear(viewDate, diff * $7345567541ec02b1$export$cd67ebcccd286127);
        onViewDateChange(newDate);
        onPanelChange(null, newDate);
    };
    var onInternalSelect = function onInternalSelect(date) {
        onSelect(date, 'mouse');
        onPanelChange('year', date);
    };
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $6fFrj.createElement((0, $c27ca652b764a64b$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: prefixCls,
        onPrevDecades: function onPrevDecades() {
            onDecadesChange(-1);
        },
        onNextDecades: function onNextDecades() {
            onDecadesChange(1);
        }
    })), /*#__PURE__*/ $6fFrj.createElement((0, $27c780f2b277dffa$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: prefixCls,
        onSelect: onInternalSelect
    })));
}
var $7345567541ec02b1$export$2e2bcd8739ae039 = $7345567541ec02b1$var$DecadePanel;


var $69bfe3a3f4b23cc1$export$fe62c2dddb4d77ea = 7;
function $69bfe3a3f4b23cc1$export$e523b58b4eb7fe76(value1, value2) {
    if (!value1 && !value2) return true;
    if (!value1 || !value2) return false;
    return undefined;
}
function $69bfe3a3f4b23cc1$export$22ab546651b3be18(generateConfig, decade1, decade2) {
    var equal = $69bfe3a3f4b23cc1$export$e523b58b4eb7fe76(decade1, decade2);
    if (typeof equal === 'boolean') return equal;
    var num1 = Math.floor(generateConfig.getYear(decade1) / 10);
    var num2 = Math.floor(generateConfig.getYear(decade2) / 10);
    return num1 === num2;
}
function $69bfe3a3f4b23cc1$export$5841f9eb9773f25f(generateConfig, year1, year2) {
    var equal = $69bfe3a3f4b23cc1$export$e523b58b4eb7fe76(year1, year2);
    if (typeof equal === 'boolean') return equal;
    return generateConfig.getYear(year1) === generateConfig.getYear(year2);
}
function $69bfe3a3f4b23cc1$export$de90a4bb31c25221(generateConfig, date) {
    var quota = Math.floor(generateConfig.getMonth(date) / 3);
    return quota + 1;
}
function $69bfe3a3f4b23cc1$export$5c60e4190867161c(generateConfig, quarter1, quarter2) {
    var equal = $69bfe3a3f4b23cc1$export$e523b58b4eb7fe76(quarter1, quarter2);
    if (typeof equal === 'boolean') return equal;
    return $69bfe3a3f4b23cc1$export$5841f9eb9773f25f(generateConfig, quarter1, quarter2) && $69bfe3a3f4b23cc1$export$de90a4bb31c25221(generateConfig, quarter1) === $69bfe3a3f4b23cc1$export$de90a4bb31c25221(generateConfig, quarter2);
}
function $69bfe3a3f4b23cc1$export$a18c89cbd24170ff(generateConfig, month1, month2) {
    var equal = $69bfe3a3f4b23cc1$export$e523b58b4eb7fe76(month1, month2);
    if (typeof equal === 'boolean') return equal;
    return $69bfe3a3f4b23cc1$export$5841f9eb9773f25f(generateConfig, month1, month2) && generateConfig.getMonth(month1) === generateConfig.getMonth(month2);
}
function $69bfe3a3f4b23cc1$export$a8b2a21161763694(generateConfig, date1, date2) {
    var equal = $69bfe3a3f4b23cc1$export$e523b58b4eb7fe76(date1, date2);
    if (typeof equal === 'boolean') return equal;
    return generateConfig.getYear(date1) === generateConfig.getYear(date2) && generateConfig.getMonth(date1) === generateConfig.getMonth(date2) && generateConfig.getDate(date1) === generateConfig.getDate(date2);
}
function $69bfe3a3f4b23cc1$export$dd2b4b46b4a2f5c9(generateConfig, time1, time2) {
    var equal = $69bfe3a3f4b23cc1$export$e523b58b4eb7fe76(time1, time2);
    if (typeof equal === 'boolean') return equal;
    return generateConfig.getHour(time1) === generateConfig.getHour(time2) && generateConfig.getMinute(time1) === generateConfig.getMinute(time2) && generateConfig.getSecond(time1) === generateConfig.getSecond(time2);
}
function $69bfe3a3f4b23cc1$export$6ea683876c36b8d2(generateConfig, locale, date1, date2) {
    var equal = $69bfe3a3f4b23cc1$export$e523b58b4eb7fe76(date1, date2);
    if (typeof equal === 'boolean') return equal;
    return $69bfe3a3f4b23cc1$export$5841f9eb9773f25f(generateConfig, date1, date2) && generateConfig.locale.getWeek(locale, date1) === generateConfig.locale.getWeek(locale, date2);
}
function $69bfe3a3f4b23cc1$export$248d38f6296296c5(generateConfig, value1, value2) {
    return $69bfe3a3f4b23cc1$export$a8b2a21161763694(generateConfig, value1, value2) && $69bfe3a3f4b23cc1$export$dd2b4b46b4a2f5c9(generateConfig, value1, value2);
}
function $69bfe3a3f4b23cc1$export$6dabbcb26357acf4(generateConfig, startDate, endDate, current) {
    if (!startDate || !endDate || !current) return false;
    return !$69bfe3a3f4b23cc1$export$a8b2a21161763694(generateConfig, startDate, current) && !$69bfe3a3f4b23cc1$export$a8b2a21161763694(generateConfig, endDate, current) && generateConfig.isAfter(current, startDate) && generateConfig.isAfter(endDate, current);
}
function $69bfe3a3f4b23cc1$export$e91829c600881133(locale, generateConfig, value) {
    var weekFirstDay = generateConfig.locale.getWeekFirstDay(locale);
    var monthStartDate = generateConfig.setDate(value, 1);
    var startDateWeekDay = generateConfig.getWeekDay(monthStartDate);
    var alignStartDate = generateConfig.addDate(monthStartDate, weekFirstDay - startDateWeekDay);
    if (generateConfig.getMonth(alignStartDate) === generateConfig.getMonth(value) && generateConfig.getDate(alignStartDate) > 1) alignStartDate = generateConfig.addDate(alignStartDate, -7);
    return alignStartDate;
}
function $69bfe3a3f4b23cc1$export$d9ec313bf7ad18e1(viewDate, picker, generateConfig) {
    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    switch(picker){
        case 'year':
            return generateConfig.addYear(viewDate, offset * 10);
        case 'quarter':
        case 'month':
            return generateConfig.addYear(viewDate, offset);
        default:
            return generateConfig.addMonth(viewDate, offset);
    }
}
function $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c(value, _ref) {
    var generateConfig = _ref.generateConfig, locale = _ref.locale, format = _ref.format;
    return typeof format === 'function' ? format(value) : generateConfig.locale.format(locale.locale, value, format);
}
function $69bfe3a3f4b23cc1$export$5303528d1070ff6f(value, _ref2) {
    var generateConfig = _ref2.generateConfig, locale = _ref2.locale, formatList = _ref2.formatList;
    if (!value || typeof formatList[0] === 'function') return null;
    return generateConfig.locale.parse(locale.locale, value, formatList);
}
function $69bfe3a3f4b23cc1$export$c503c160691b0dfe(_ref3) {
    var cellDate = _ref3.cellDate, mode = _ref3.mode, disabledDate = _ref3.disabledDate, generateConfig = _ref3.generateConfig;
    if (!disabledDate) return false;
    // Whether cellDate is disabled in range
    var getDisabledFromRange = function getDisabledFromRange(currentMode, start, end) {
        var current = start;
        while(current <= end){
            var date = void 0;
            switch(currentMode){
                case 'date':
                    date = generateConfig.setDate(cellDate, current);
                    if (!disabledDate(date)) return false;
                    break;
                case 'month':
                    date = generateConfig.setMonth(cellDate, current);
                    if (!$69bfe3a3f4b23cc1$export$c503c160691b0dfe({
                        cellDate: date,
                        mode: 'month',
                        generateConfig: generateConfig,
                        disabledDate: disabledDate
                    })) return false;
                    break;
                case 'year':
                    date = generateConfig.setYear(cellDate, current);
                    if (!$69bfe3a3f4b23cc1$export$c503c160691b0dfe({
                        cellDate: date,
                        mode: 'year',
                        generateConfig: generateConfig,
                        disabledDate: disabledDate
                    })) return false;
                    break;
            }
            current += 1;
        }
        return true;
    };
    switch(mode){
        case 'date':
        case 'week':
            return disabledDate(cellDate);
        case 'month':
            var startDate = 1;
            var endDate = generateConfig.getDate(generateConfig.getEndDate(cellDate));
            return getDisabledFromRange('date', startDate, endDate);
        case 'quarter':
            var startMonth = Math.floor(generateConfig.getMonth(cellDate) / 3) * 3;
            var endMonth = startMonth + 2;
            return getDisabledFromRange('month', startMonth, endMonth);
        case 'year':
            return getDisabledFromRange('month', 0, 11);
        case 'decade':
            var year = generateConfig.getYear(cellDate);
            var startYear = Math.floor(year / (0, $7345567541ec02b1$export$2714f720f9350aa)) * (0, $7345567541ec02b1$export$2714f720f9350aa);
            var endYear = startYear + (0, $7345567541ec02b1$export$2714f720f9350aa) - 1;
            return getDisabledFromRange('year', startYear, endYear);
    }
}


function $48477c70e45df362$var$TimeHeader(props) {
    var _React$useContext = $6fFrj.useContext((0, $03d96fa1dbfe5ae5$export$2e2bcd8739ae039)), hideHeader = _React$useContext.hideHeader;
    if (hideHeader) return null;
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, locale = props.locale, value = props.value, format = props.format;
    var headerPrefixCls = "".concat(prefixCls, "-header");
    return /*#__PURE__*/ $6fFrj.createElement((0, $ed92577a8a4d6745$export$2e2bcd8739ae039), {
        prefixCls: headerPrefixCls
    }, value ? (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(value, {
        locale: locale,
        format: format,
        generateConfig: generateConfig
    }) : "\xA0");
}
var $48477c70e45df362$export$2e2bcd8739ae039 = $48477c70e45df362$var$TimeHeader;



var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $a5lfY = parcelRequire("a5lfY");

var $6fFrj = parcelRequire("6fFrj");

function $09cfe43f9c68508a$export$2e2bcd8739ae039(_ref) {
    var value = _ref.value, generateConfig = _ref.generateConfig, disabledMinutes = _ref.disabledMinutes, disabledSeconds = _ref.disabledSeconds, minutes = _ref.minutes, seconds = _ref.seconds, use12Hours = _ref.use12Hours;
    var setTime = function setTime(isNewPM, newHour, newMinute, newSecond) {
        var newDate = value || generateConfig.getNow();
        var mergedHour = Math.max(0, newHour);
        var mergedMinute = Math.max(0, newMinute);
        var mergedSecond = Math.max(0, newSecond);
        var newDisabledMinutes = disabledMinutes && disabledMinutes(mergedHour);
        if (newDisabledMinutes === null || newDisabledMinutes === void 0 ? void 0 : newDisabledMinutes.includes(mergedMinute)) {
            // find the first available minute in minutes
            var availableMinute = minutes.find(function(i) {
                return !newDisabledMinutes.includes(i.value);
            });
            if (availableMinute) mergedMinute = availableMinute.value;
            else return null;
        }
        var newDisabledSeconds = disabledSeconds && disabledSeconds(mergedHour, mergedMinute);
        if (newDisabledSeconds === null || newDisabledSeconds === void 0 ? void 0 : newDisabledSeconds.includes(mergedSecond)) {
            // find the first available second in seconds
            var availableSecond = seconds.find(function(i) {
                return !newDisabledSeconds.includes(i.value);
            });
            if (availableSecond) mergedSecond = availableSecond.value;
            else return null;
        }
        newDate = (0, $bf5c2cfe19b8eb58$export$e5d5e1c1822b6e56)(generateConfig, newDate, !use12Hours || !isNewPM ? mergedHour : mergedHour + 12, mergedMinute, mergedSecond);
        return newDate;
    };
    return setTime;
}


function $80a563586615a9e1$export$cbb503201166aab7(str, length) {
    var fill = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
    var current = String(str);
    while(current.length < length)current = "".concat(fill).concat(str);
    return current;
}
var $80a563586615a9e1$export$65e3907585753458 = function tuple() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return args;
};
function $80a563586615a9e1$export$45b10814cc054894(val) {
    if (val === null || val === undefined) return [];
    return Array.isArray(val) ? val : [
        val
    ];
}
function $80a563586615a9e1$export$2e2bcd8739ae039(props) {
    var retProps = {};
    Object.keys(props).forEach(function(key) {
        if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role' || key === 'name') && key.substr(0, 7) !== 'data-__') retProps[key] = props[key];
    });
    return retProps;
}
function $80a563586615a9e1$export$bf7199a9ebcb84a9(values, index) {
    return values ? values[index] : null;
}
function $80a563586615a9e1$export$1af566b8db6b8ac2(values, value, index) {
    var newValues = [
        $80a563586615a9e1$export$bf7199a9ebcb84a9(values, 0),
        $80a563586615a9e1$export$bf7199a9ebcb84a9(values, 1)
    ];
    newValues[index] = typeof value === 'function' ? value(newValues[index]) : value;
    if (!newValues[0] && !newValues[1]) return null;
    return newValues;
}



var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


function $02b79102548fb96c$var$TimeUnitColumn(props) {
    var prefixCls = props.prefixCls, units = props.units, onSelect = props.onSelect, value = props.value, active = props.active, hideDisabledOptions = props.hideDisabledOptions;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var _React$useContext = $6fFrj.useContext((0, $03d96fa1dbfe5ae5$export$2e2bcd8739ae039)), open = _React$useContext.open;
    var ulRef = (0, $6fFrj.useRef)(null);
    var liRefs = (0, $6fFrj.useRef)(new Map());
    var scrollRef = (0, $6fFrj.useRef)();
    // `useLayoutEffect` here to avoid blink by duration is 0
    (0, $6fFrj.useLayoutEffect)(function() {
        var li = liRefs.current.get(value);
        if (li && open !== false) (0, $92cb4f3f33042a05$export$3f99968195accfaf)(ulRef.current, li.offsetTop, 120);
    }, [
        value
    ]);
    (0, $6fFrj.useLayoutEffect)(function() {
        if (open) {
            var li = liRefs.current.get(value);
            if (li) scrollRef.current = (0, $92cb4f3f33042a05$export$55c3897747695e9b)(li, function() {
                (0, $92cb4f3f33042a05$export$3f99968195accfaf)(ulRef.current, li.offsetTop, 0);
            });
        }
        return function() {
            var _scrollRef$current;
            (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 || _scrollRef$current.call(scrollRef);
        };
    }, [
        open
    ]);
    return /*#__PURE__*/ $6fFrj.createElement("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-column"), (0, $43449.default)({}, "".concat(prefixCls, "-column-active"), active)),
        ref: ulRef,
        style: {
            position: 'relative'
        }
    }, units.map(function(unit) {
        var _classNames2;
        if (hideDisabledOptions && unit.disabled) return null;
        return /*#__PURE__*/ $6fFrj.createElement("li", {
            key: unit.value,
            ref: function ref(element) {
                liRefs.current.set(unit.value, element);
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(cellPrefixCls, (_classNames2 = {}, (0, $43449.default)(_classNames2, "".concat(cellPrefixCls, "-disabled"), unit.disabled), (0, $43449.default)(_classNames2, "".concat(cellPrefixCls, "-selected"), value === unit.value), _classNames2)),
            onClick: function onClick() {
                if (unit.disabled) return;
                onSelect(unit.value);
            }
        }, /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(cellPrefixCls, "-inner")
        }, unit.label));
    }));
}
var $02b79102548fb96c$export$2e2bcd8739ae039 = $02b79102548fb96c$var$TimeUnitColumn;


function $34dcd7854aef3607$var$shouldUnitsUpdate(prevUnits, nextUnits) {
    if (prevUnits.length !== nextUnits.length) return true;
    // if any unit's disabled status is different, the units should be re-evaluted
    for(var i = 0; i < prevUnits.length; i += 1){
        if (prevUnits[i].disabled !== nextUnits[i].disabled) return true;
    }
    return false;
}
function $34dcd7854aef3607$var$generateUnits(start, end, step, disabledUnits) {
    var units = [];
    var integerStep = step >= 1 ? step | 0 : 1;
    for(var i = start; i <= end; i += integerStep)units.push({
        label: (0, $80a563586615a9e1$export$cbb503201166aab7)(i, 2),
        value: i,
        disabled: (disabledUnits || []).includes(i)
    });
    return units;
}
function $34dcd7854aef3607$var$TimeBody(props) {
    var generateConfig = props.generateConfig, prefixCls = props.prefixCls, operationRef = props.operationRef, activeColumnIndex = props.activeColumnIndex, value = props.value, showHour = props.showHour, showMinute = props.showMinute, showSecond = props.showSecond, use12Hours = props.use12Hours, _props$hourStep = props.hourStep, hourStep = _props$hourStep === void 0 ? 1 : _props$hourStep, _props$minuteStep = props.minuteStep, minuteStep = _props$minuteStep === void 0 ? 1 : _props$minuteStep, _props$secondStep = props.secondStep, secondStep = _props$secondStep === void 0 ? 1 : _props$secondStep, disabledHours = props.disabledHours, disabledMinutes = props.disabledMinutes, disabledSeconds = props.disabledSeconds, disabledTime = props.disabledTime, hideDisabledOptions = props.hideDisabledOptions, onSelect = props.onSelect;
    // Misc
    var columns = [];
    var contentPrefixCls = "".concat(prefixCls, "-content");
    var columnPrefixCls = "".concat(prefixCls, "-time-panel");
    var isPM;
    var originHour = value ? generateConfig.getHour(value) : -1;
    var hour = originHour;
    var minute = value ? generateConfig.getMinute(value) : -1;
    var second = value ? generateConfig.getSecond(value) : -1;
    // Disabled Time
    var now = generateConfig.getNow();
    var _React$useMemo = $6fFrj.useMemo(function() {
        if (disabledTime) {
            var disabledConfig = disabledTime(now);
            return [
                disabledConfig.disabledHours,
                disabledConfig.disabledMinutes,
                disabledConfig.disabledSeconds
            ];
        }
        return [
            disabledHours,
            disabledMinutes,
            disabledSeconds
        ];
    }, [
        disabledHours,
        disabledMinutes,
        disabledSeconds,
        disabledTime,
        now
    ]), _React$useMemo2 = (0, $jP8CL.default)(_React$useMemo, 3), mergedDisabledHours = _React$useMemo2[0], mergedDisabledMinutes = _React$useMemo2[1], mergedDisabledSeconds = _React$useMemo2[2];
    // ========================= Unit =========================
    var rawHours = $34dcd7854aef3607$var$generateUnits(0, 23, hourStep, mergedDisabledHours && mergedDisabledHours());
    var memorizedRawHours = (0, $a5lfY.default)(function() {
        return rawHours;
    }, rawHours, $34dcd7854aef3607$var$shouldUnitsUpdate);
    // Should additional logic to handle 12 hours
    if (use12Hours) {
        isPM = hour >= 12; // -1 means should display AM
        hour %= 12;
    }
    var _React$useMemo3 = $6fFrj.useMemo(function() {
        if (!use12Hours) return [
            false,
            false
        ];
        var AMPMDisabled = [
            true,
            true
        ];
        memorizedRawHours.forEach(function(_ref) {
            var disabled = _ref.disabled, hourValue = _ref.value;
            if (disabled) return;
            if (hourValue >= 12) AMPMDisabled[1] = false;
            else AMPMDisabled[0] = false;
        });
        return AMPMDisabled;
    }, [
        use12Hours,
        memorizedRawHours
    ]), _React$useMemo4 = (0, $jP8CL.default)(_React$useMemo3, 2), AMDisabled = _React$useMemo4[0], PMDisabled = _React$useMemo4[1];
    var hours = $6fFrj.useMemo(function() {
        if (!use12Hours) return memorizedRawHours;
        return memorizedRawHours.filter(isPM ? function(hourMeta) {
            return hourMeta.value >= 12;
        } : function(hourMeta) {
            return hourMeta.value < 12;
        }).map(function(hourMeta) {
            var hourValue = hourMeta.value % 12;
            var hourLabel = hourValue === 0 ? '12' : (0, $80a563586615a9e1$export$cbb503201166aab7)(hourValue, 2);
            return (0, $kNxFX.default)((0, $kNxFX.default)({}, hourMeta), {}, {
                label: hourLabel,
                value: hourValue
            });
        });
    }, [
        use12Hours,
        isPM,
        memorizedRawHours
    ]);
    var minutes = $34dcd7854aef3607$var$generateUnits(0, 59, minuteStep, mergedDisabledMinutes && mergedDisabledMinutes(originHour));
    var seconds = $34dcd7854aef3607$var$generateUnits(0, 59, secondStep, mergedDisabledSeconds && mergedDisabledSeconds(originHour, minute));
    // Set Time
    var setTime = (0, $09cfe43f9c68508a$export$2e2bcd8739ae039)({
        value: value,
        generateConfig: generateConfig,
        disabledMinutes: mergedDisabledMinutes,
        disabledSeconds: mergedDisabledSeconds,
        minutes: minutes,
        seconds: seconds,
        use12Hours: use12Hours
    });
    // ====================== Operations ======================
    operationRef.current = {
        onUpDown: function onUpDown(diff) {
            var column = columns[activeColumnIndex];
            if (column) {
                var valueIndex = column.units.findIndex(function(unit) {
                    return unit.value === column.value;
                });
                var unitLen = column.units.length;
                for(var i = 1; i < unitLen; i += 1){
                    var nextUnit = column.units[(valueIndex + diff * i + unitLen) % unitLen];
                    if (nextUnit.disabled !== true) {
                        column.onSelect(nextUnit.value);
                        break;
                    }
                }
            }
        }
    };
    // ======================== Render ========================
    function addColumnNode(condition, node, columnValue, units, onColumnSelect) {
        if (condition !== false) columns.push({
            node: /*#__PURE__*/ $6fFrj.cloneElement(node, {
                prefixCls: columnPrefixCls,
                value: columnValue,
                active: activeColumnIndex === columns.length,
                onSelect: onColumnSelect,
                units: units,
                hideDisabledOptions: hideDisabledOptions
            }),
            onSelect: onColumnSelect,
            value: columnValue,
            units: units
        });
    }
    // Hour
    addColumnNode(showHour, /*#__PURE__*/ $6fFrj.createElement((0, $02b79102548fb96c$export$2e2bcd8739ae039), {
        key: "hour"
    }), hour, hours, function(num) {
        onSelect(setTime(isPM, num, minute, second), 'mouse');
    });
    // Minute
    addColumnNode(showMinute, /*#__PURE__*/ $6fFrj.createElement((0, $02b79102548fb96c$export$2e2bcd8739ae039), {
        key: "minute"
    }), minute, minutes, function(num) {
        onSelect(setTime(isPM, hour, num, second), 'mouse');
    });
    // Second
    addColumnNode(showSecond, /*#__PURE__*/ $6fFrj.createElement((0, $02b79102548fb96c$export$2e2bcd8739ae039), {
        key: "second"
    }), second, seconds, function(num) {
        onSelect(setTime(isPM, hour, minute, num), 'mouse');
    });
    // 12 Hours
    var PMIndex = -1;
    if (typeof isPM === 'boolean') PMIndex = isPM ? 1 : 0;
    addColumnNode(use12Hours === true, /*#__PURE__*/ $6fFrj.createElement((0, $02b79102548fb96c$export$2e2bcd8739ae039), {
        key: "12hours"
    }), PMIndex, [
        {
            label: 'AM',
            value: 0,
            disabled: AMDisabled
        },
        {
            label: 'PM',
            value: 1,
            disabled: PMDisabled
        }
    ], function(num) {
        onSelect(setTime(!!num, hour, minute, second), 'mouse');
    });
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: contentPrefixCls
    }, columns.map(function(_ref2) {
        var node = _ref2.node;
        return node;
    }));
}
var $34dcd7854aef3607$export$2e2bcd8739ae039 = $34dcd7854aef3607$var$TimeBody;



var $d7d3258430bf7b8f$var$countBoolean = function countBoolean(boolList) {
    return boolList.filter(function(bool) {
        return bool !== false;
    }).length;
};
function $d7d3258430bf7b8f$var$TimePanel(props) {
    var generateConfig = props.generateConfig, _props$format = props.format, format = _props$format === void 0 ? 'HH:mm:ss' : _props$format, prefixCls = props.prefixCls, active = props.active, operationRef = props.operationRef, showHour = props.showHour, showMinute = props.showMinute, showSecond = props.showSecond, _props$use12Hours = props.use12Hours, use12Hours = _props$use12Hours === void 0 ? false : _props$use12Hours, onSelect = props.onSelect, value = props.value;
    var panelPrefixCls = "".concat(prefixCls, "-time-panel");
    var bodyOperationRef = $6fFrj.useRef();
    // ======================= Keyboard =======================
    var _React$useState = $6fFrj.useState(-1), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), activeColumnIndex = _React$useState2[0], setActiveColumnIndex = _React$useState2[1];
    var columnsCount = $d7d3258430bf7b8f$var$countBoolean([
        showHour,
        showMinute,
        showSecond,
        use12Hours
    ]);
    operationRef.current = {
        onKeyDown: function onKeyDown(event) {
            return (0, $92cb4f3f33042a05$export$a507db46d3f03278)(event, {
                onLeftRight: function onLeftRight(diff) {
                    setActiveColumnIndex((activeColumnIndex + diff + columnsCount) % columnsCount);
                },
                onUpDown: function onUpDown(diff) {
                    if (activeColumnIndex === -1) setActiveColumnIndex(0);
                    else if (bodyOperationRef.current) bodyOperationRef.current.onUpDown(diff);
                },
                onEnter: function onEnter() {
                    onSelect(value || generateConfig.getNow(), 'key');
                    setActiveColumnIndex(-1);
                }
            });
        },
        onBlur: function onBlur() {
            setActiveColumnIndex(-1);
        }
    };
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(panelPrefixCls, (0, $43449.default)({}, "".concat(panelPrefixCls, "-active"), active))
    }, /*#__PURE__*/ $6fFrj.createElement((0, $48477c70e45df362$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        format: format,
        prefixCls: prefixCls
    })), /*#__PURE__*/ $6fFrj.createElement((0, $34dcd7854aef3607$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: prefixCls,
        activeColumnIndex: activeColumnIndex,
        operationRef: bodyOperationRef
    })));
}
var $d7d3258430bf7b8f$export$2e2bcd8739ae039 = $d7d3258430bf7b8f$var$TimePanel;



var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $5KhTJ = parcelRequire("5KhTJ");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");
var $612ffa32a7ba0396$var$RangeContext = /*#__PURE__*/ $6fFrj.createContext({});
var $612ffa32a7ba0396$export$2e2bcd8739ae039 = $612ffa32a7ba0396$var$RangeContext;



var $43449 = parcelRequire("43449");


function $7a79f2bc0701f69e$export$2e2bcd8739ae039(_ref) {
    var cellPrefixCls = _ref.cellPrefixCls, generateConfig = _ref.generateConfig, rangedValue = _ref.rangedValue, hoverRangedValue = _ref.hoverRangedValue, isInView = _ref.isInView, isSameCell = _ref.isSameCell, offsetCell = _ref.offsetCell, today = _ref.today, value = _ref.value;
    function getClassName(currentDate) {
        var _ref2;
        var prevDate = offsetCell(currentDate, -1);
        var nextDate = offsetCell(currentDate, 1);
        var rangeStart = (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(rangedValue, 0);
        var rangeEnd = (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(rangedValue, 1);
        var hoverStart = (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(hoverRangedValue, 0);
        var hoverEnd = (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(hoverRangedValue, 1);
        var isRangeHovered = (0, $69bfe3a3f4b23cc1$export$6dabbcb26357acf4)(generateConfig, hoverStart, hoverEnd, currentDate);
        function isRangeStart(date) {
            return isSameCell(rangeStart, date);
        }
        function isRangeEnd(date) {
            return isSameCell(rangeEnd, date);
        }
        var isHoverStart = isSameCell(hoverStart, currentDate);
        var isHoverEnd = isSameCell(hoverEnd, currentDate);
        var isHoverEdgeStart = (isRangeHovered || isHoverEnd) && (!isInView(prevDate) || isRangeEnd(prevDate));
        var isHoverEdgeEnd = (isRangeHovered || isHoverStart) && (!isInView(nextDate) || isRangeStart(nextDate));
        return _ref2 = {}, (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-in-view"), isInView(currentDate)), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-in-range"), (0, $69bfe3a3f4b23cc1$export$6dabbcb26357acf4)(generateConfig, rangeStart, rangeEnd, currentDate)), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-range-start"), isRangeStart(currentDate)), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-range-end"), isRangeEnd(currentDate)), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-range-start-single"), isRangeStart(currentDate) && !rangeEnd), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-range-end-single"), isRangeEnd(currentDate) && !rangeStart), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-range-start-near-hover"), isRangeStart(currentDate) && (isSameCell(prevDate, hoverStart) || (0, $69bfe3a3f4b23cc1$export$6dabbcb26357acf4)(generateConfig, hoverStart, hoverEnd, prevDate))), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-range-end-near-hover"), isRangeEnd(currentDate) && (isSameCell(nextDate, hoverEnd) || (0, $69bfe3a3f4b23cc1$export$6dabbcb26357acf4)(generateConfig, hoverStart, hoverEnd, nextDate))), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-range-hover"), isRangeHovered), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-range-hover-start"), isHoverStart), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-range-hover-end"), isHoverEnd), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-start"), isHoverEdgeStart), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-end"), isHoverEdgeEnd), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-start-near-range"), isHoverEdgeStart && isSameCell(prevDate, rangeEnd)), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-range-hover-edge-end-near-range"), isHoverEdgeEnd && isSameCell(nextDate, rangeStart)), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-today"), isSameCell(today, currentDate)), (0, $43449.default)(_ref2, "".concat(cellPrefixCls, "-selected"), isSameCell(value, currentDate)), _ref2;
    }
    return getClassName;
}



function $44bfb07e0095b7ad$var$DateBody(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, prefixColumn = props.prefixColumn, locale = props.locale, rowCount = props.rowCount, viewDate = props.viewDate, value = props.value, dateRender = props.dateRender;
    var _React$useContext = $6fFrj.useContext((0, $612ffa32a7ba0396$export$2e2bcd8739ae039)), rangedValue = _React$useContext.rangedValue, hoverRangedValue = _React$useContext.hoverRangedValue;
    var baseDate = (0, $69bfe3a3f4b23cc1$export$e91829c600881133)(locale.locale, generateConfig, viewDate);
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var weekFirstDay = generateConfig.locale.getWeekFirstDay(locale.locale);
    var today = generateConfig.getNow();
    // ============================== Header ==============================
    var headerCells = [];
    var weekDaysLocale = locale.shortWeekDays || (generateConfig.locale.getShortWeekDays ? generateConfig.locale.getShortWeekDays(locale.locale) : []);
    if (prefixColumn) headerCells.push(/*#__PURE__*/ $6fFrj.createElement("th", {
        key: "empty",
        "aria-label": "empty cell"
    }));
    for(var i = 0; i < (0, $69bfe3a3f4b23cc1$export$fe62c2dddb4d77ea); i += 1)headerCells.push(/*#__PURE__*/ $6fFrj.createElement("th", {
        key: i
    }, weekDaysLocale[(i + weekFirstDay) % (0, $69bfe3a3f4b23cc1$export$fe62c2dddb4d77ea)]));
    // =============================== Body ===============================
    var getCellClassName = (0, $7a79f2bc0701f69e$export$2e2bcd8739ae039)({
        cellPrefixCls: cellPrefixCls,
        today: today,
        value: value,
        generateConfig: generateConfig,
        rangedValue: prefixColumn ? null : rangedValue,
        hoverRangedValue: prefixColumn ? null : hoverRangedValue,
        isSameCell: function isSameCell(current, target) {
            return (0, $69bfe3a3f4b23cc1$export$a8b2a21161763694)(generateConfig, current, target);
        },
        isInView: function isInView(date) {
            return (0, $69bfe3a3f4b23cc1$export$a18c89cbd24170ff)(generateConfig, date, viewDate);
        },
        offsetCell: function offsetCell(date, offset) {
            return generateConfig.addDate(date, offset);
        }
    });
    var getCellNode = dateRender ? function(date) {
        return dateRender(date, today);
    } : undefined;
    return /*#__PURE__*/ $6fFrj.createElement((0, $d7c6689876c548a6$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        rowNum: rowCount,
        colNum: (0, $69bfe3a3f4b23cc1$export$fe62c2dddb4d77ea),
        baseDate: baseDate,
        getCellNode: getCellNode,
        getCellText: generateConfig.getDate,
        getCellClassName: getCellClassName,
        getCellDate: generateConfig.addDate,
        titleCell: function titleCell(date) {
            return (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(date, {
                locale: locale,
                format: 'YYYY-MM-DD',
                generateConfig: generateConfig
            });
        },
        headerCells: headerCells
    }));
}
var $44bfb07e0095b7ad$export$2e2bcd8739ae039 = $44bfb07e0095b7ad$var$DateBody;



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");



function $db709021baaf63fa$var$DateHeader(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, locale = props.locale, viewDate = props.viewDate, onNextMonth = props.onNextMonth, onPrevMonth = props.onPrevMonth, onNextYear = props.onNextYear, onPrevYear = props.onPrevYear, onYearClick = props.onYearClick, onMonthClick = props.onMonthClick;
    var _React$useContext = $6fFrj.useContext((0, $03d96fa1dbfe5ae5$export$2e2bcd8739ae039)), hideHeader = _React$useContext.hideHeader;
    if (hideHeader) return null;
    var headerPrefixCls = "".concat(prefixCls, "-header");
    var monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);
    var month = generateConfig.getMonth(viewDate);
    // =================== Month & Year ===================
    var yearNode = /*#__PURE__*/ $6fFrj.createElement("button", {
        type: "button",
        key: "year",
        onClick: onYearClick,
        tabIndex: -1,
        className: "".concat(prefixCls, "-year-btn")
    }, (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(viewDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    var monthNode = /*#__PURE__*/ $6fFrj.createElement("button", {
        type: "button",
        key: "month",
        onClick: onMonthClick,
        tabIndex: -1,
        className: "".concat(prefixCls, "-month-btn")
    }, locale.monthFormat ? (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(viewDate, {
        locale: locale,
        format: locale.monthFormat,
        generateConfig: generateConfig
    }) : monthsLocale[month]);
    var monthYearNodes = locale.monthBeforeYear ? [
        monthNode,
        yearNode
    ] : [
        yearNode,
        monthNode
    ];
    return /*#__PURE__*/ $6fFrj.createElement((0, $ed92577a8a4d6745$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: headerPrefixCls,
        onSuperPrev: onPrevYear,
        onPrev: onPrevMonth,
        onNext: onNextMonth,
        onSuperNext: onNextYear
    }), monthYearNodes);
}
var $db709021baaf63fa$export$2e2bcd8739ae039 = $db709021baaf63fa$var$DateHeader;




var $f3e084a0c0b898f4$var$DATE_ROW_COUNT = 6;
function $f3e084a0c0b898f4$var$DatePanel(props) {
    var prefixCls = props.prefixCls, _props$panelName = props.panelName, panelName = _props$panelName === void 0 ? 'date' : _props$panelName, keyboardConfig = props.keyboardConfig, active = props.active, operationRef = props.operationRef, generateConfig = props.generateConfig, value = props.value, viewDate = props.viewDate, onViewDateChange = props.onViewDateChange, onPanelChange = props.onPanelChange, _onSelect = props.onSelect;
    var panelPrefixCls = "".concat(prefixCls, "-").concat(panelName, "-panel");
    // ======================= Keyboard =======================
    operationRef.current = {
        onKeyDown: function onKeyDown(event) {
            return (0, $92cb4f3f33042a05$export$a507db46d3f03278)(event, (0, $kNxFX.default)({
                onLeftRight: function onLeftRight(diff) {
                    _onSelect(generateConfig.addDate(value || viewDate, diff), 'key');
                },
                onCtrlLeftRight: function onCtrlLeftRight(diff) {
                    _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
                },
                onUpDown: function onUpDown(diff) {
                    _onSelect(generateConfig.addDate(value || viewDate, diff * (0, $69bfe3a3f4b23cc1$export$fe62c2dddb4d77ea)), 'key');
                },
                onPageUpDown: function onPageUpDown(diff) {
                    _onSelect(generateConfig.addMonth(value || viewDate, diff), 'key');
                }
            }, keyboardConfig));
        }
    };
    // ==================== View Operation ====================
    var onYearChange = function onYearChange(diff) {
        var newDate = generateConfig.addYear(viewDate, diff);
        onViewDateChange(newDate);
        onPanelChange(null, newDate);
    };
    var onMonthChange = function onMonthChange(diff) {
        var newDate = generateConfig.addMonth(viewDate, diff);
        onViewDateChange(newDate);
        onPanelChange(null, newDate);
    };
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(panelPrefixCls, (0, $43449.default)({}, "".concat(panelPrefixCls, "-active"), active))
    }, /*#__PURE__*/ $6fFrj.createElement((0, $db709021baaf63fa$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: prefixCls,
        value: value,
        viewDate: viewDate,
        onPrevYear: function onPrevYear() {
            onYearChange(-1);
        },
        onNextYear: function onNextYear() {
            onYearChange(1);
        },
        onPrevMonth: function onPrevMonth() {
            onMonthChange(-1);
        },
        onNextMonth: function onNextMonth() {
            onMonthChange(1);
        },
        onMonthClick: function onMonthClick() {
            onPanelChange('month', viewDate);
        },
        onYearClick: function onYearClick() {
            onPanelChange('year', viewDate);
        }
    })), /*#__PURE__*/ $6fFrj.createElement((0, $44bfb07e0095b7ad$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        onSelect: function onSelect(date) {
            return _onSelect(date, 'mouse');
        },
        prefixCls: prefixCls,
        value: value,
        viewDate: viewDate,
        rowCount: $f3e084a0c0b898f4$var$DATE_ROW_COUNT
    })));
}
var $f3e084a0c0b898f4$export$2e2bcd8739ae039 = $f3e084a0c0b898f4$var$DatePanel;





var $d114d62d9b90d24e$var$ACTIVE_PANEL = (0, $80a563586615a9e1$export$65e3907585753458)('date', 'time');
function $d114d62d9b90d24e$var$DatetimePanel(props) {
    var prefixCls = props.prefixCls, operationRef = props.operationRef, generateConfig = props.generateConfig, value = props.value, defaultValue = props.defaultValue, disabledTime = props.disabledTime, showTime = props.showTime, onSelect = props.onSelect;
    var panelPrefixCls = "".concat(prefixCls, "-datetime-panel");
    var _React$useState = $6fFrj.useState(null), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), activePanel = _React$useState2[0], setActivePanel = _React$useState2[1];
    var dateOperationRef = $6fFrj.useRef({});
    var timeOperationRef = $6fFrj.useRef({});
    var timeProps = (0, $5KhTJ.default)(showTime) === 'object' ? (0, $kNxFX.default)({}, showTime) : {};
    // ======================= Keyboard =======================
    function getNextActive(offset) {
        var activeIndex = $d114d62d9b90d24e$var$ACTIVE_PANEL.indexOf(activePanel) + offset;
        var nextActivePanel = $d114d62d9b90d24e$var$ACTIVE_PANEL[activeIndex] || null;
        return nextActivePanel;
    }
    var onBlur = function onBlur(e) {
        if (timeOperationRef.current.onBlur) timeOperationRef.current.onBlur(e);
        setActivePanel(null);
    };
    operationRef.current = {
        onKeyDown: function onKeyDown(event) {
            // Switch active panel
            if (event.which === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).TAB) {
                var nextActivePanel = getNextActive(event.shiftKey ? -1 : 1);
                setActivePanel(nextActivePanel);
                if (nextActivePanel) event.preventDefault();
                return true;
            }
            // Operate on current active panel
            if (activePanel) {
                var ref = activePanel === 'date' ? dateOperationRef : timeOperationRef;
                if (ref.current && ref.current.onKeyDown) ref.current.onKeyDown(event);
                return true;
            }
            // Switch first active panel if operate without panel
            if ([
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).LEFT,
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).RIGHT,
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).UP,
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).DOWN
            ].includes(event.which)) {
                setActivePanel('date');
                return true;
            }
            return false;
        },
        onBlur: onBlur,
        onClose: onBlur
    };
    // ======================== Events ========================
    var onInternalSelect = function onInternalSelect(date, source) {
        var selectedDate = date;
        if (source === 'date' && !value && timeProps.defaultValue) {
            // Date with time defaultValue
            selectedDate = generateConfig.setHour(selectedDate, generateConfig.getHour(timeProps.defaultValue));
            selectedDate = generateConfig.setMinute(selectedDate, generateConfig.getMinute(timeProps.defaultValue));
            selectedDate = generateConfig.setSecond(selectedDate, generateConfig.getSecond(timeProps.defaultValue));
        } else if (source === 'time' && !value && defaultValue) {
            selectedDate = generateConfig.setYear(selectedDate, generateConfig.getYear(defaultValue));
            selectedDate = generateConfig.setMonth(selectedDate, generateConfig.getMonth(defaultValue));
            selectedDate = generateConfig.setDate(selectedDate, generateConfig.getDate(defaultValue));
        }
        if (onSelect) onSelect(selectedDate, 'mouse');
    };
    // ======================== Render ========================
    var disabledTimes = disabledTime ? disabledTime(value || null) : {};
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(panelPrefixCls, (0, $43449.default)({}, "".concat(panelPrefixCls, "-active"), activePanel))
    }, /*#__PURE__*/ $6fFrj.createElement((0, $f3e084a0c0b898f4$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        operationRef: dateOperationRef,
        active: activePanel === 'date',
        onSelect: function onSelect(date) {
            onInternalSelect((0, $bf5c2cfe19b8eb58$export$3a84b9eda98e95dc)(generateConfig, date, !value && (0, $5KhTJ.default)(showTime) === 'object' ? showTime.defaultValue : null), 'date');
        }
    })), /*#__PURE__*/ $6fFrj.createElement((0, $d7d3258430bf7b8f$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        format: undefined
    }, timeProps, disabledTimes, {
        disabledTime: null,
        defaultValue: undefined,
        operationRef: timeOperationRef,
        active: activePanel === 'time',
        onSelect: function onSelect(date) {
            onInternalSelect(date, 'time');
        }
    })));
}
var $d114d62d9b90d24e$export$2e2bcd8739ae039 = $d114d62d9b90d24e$var$DatetimePanel;




var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


function $db95832eff3d6d3b$var$WeekPanel(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, locale = props.locale, value = props.value;
    // Render additional column
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var prefixColumn = function prefixColumn(date) {
        return /*#__PURE__*/ $6fFrj.createElement("td", {
            key: "week",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(cellPrefixCls, "".concat(cellPrefixCls, "-week"))
        }, generateConfig.locale.getWeek(locale.locale, date));
    };
    // Add row className
    var rowPrefixCls = "".concat(prefixCls, "-week-panel-row");
    var rowClassName = function rowClassName(date) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(rowPrefixCls, (0, $43449.default)({}, "".concat(rowPrefixCls, "-selected"), (0, $69bfe3a3f4b23cc1$export$6ea683876c36b8d2)(generateConfig, locale.locale, value, date)));
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $f3e084a0c0b898f4$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        panelName: "week",
        prefixColumn: prefixColumn,
        rowClassName: rowClassName,
        keyboardConfig: {
            onLeftRight: null
        }
    }));
}
var $db95832eff3d6d3b$export$2e2bcd8739ae039 = $db95832eff3d6d3b$var$WeekPanel;



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");



function $3ee5c5d29e429f88$var$MonthHeader(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, locale = props.locale, viewDate = props.viewDate, onNextYear = props.onNextYear, onPrevYear = props.onPrevYear, onYearClick = props.onYearClick;
    var _React$useContext = $6fFrj.useContext((0, $03d96fa1dbfe5ae5$export$2e2bcd8739ae039)), hideHeader = _React$useContext.hideHeader;
    if (hideHeader) return null;
    var headerPrefixCls = "".concat(prefixCls, "-header");
    return /*#__PURE__*/ $6fFrj.createElement((0, $ed92577a8a4d6745$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: headerPrefixCls,
        onSuperPrev: onPrevYear,
        onSuperNext: onNextYear
    }), /*#__PURE__*/ $6fFrj.createElement("button", {
        type: "button",
        onClick: onYearClick,
        className: "".concat(prefixCls, "-year-btn")
    }, (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(viewDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    })));
}
var $3ee5c5d29e429f88$export$2e2bcd8739ae039 = $3ee5c5d29e429f88$var$MonthHeader;



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");




var $9f883d34af634b4f$export$49f80bd546511120 = 3;
var $9f883d34af634b4f$var$MONTH_ROW_COUNT = 4;
function $9f883d34af634b4f$var$MonthBody(props) {
    var prefixCls = props.prefixCls, locale = props.locale, value = props.value, viewDate = props.viewDate, generateConfig = props.generateConfig, monthCellRender = props.monthCellRender;
    var _React$useContext = $6fFrj.useContext((0, $612ffa32a7ba0396$export$2e2bcd8739ae039)), rangedValue = _React$useContext.rangedValue, hoverRangedValue = _React$useContext.hoverRangedValue;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var getCellClassName = (0, $7a79f2bc0701f69e$export$2e2bcd8739ae039)({
        cellPrefixCls: cellPrefixCls,
        value: value,
        generateConfig: generateConfig,
        rangedValue: rangedValue,
        hoverRangedValue: hoverRangedValue,
        isSameCell: function isSameCell(current, target) {
            return (0, $69bfe3a3f4b23cc1$export$a18c89cbd24170ff)(generateConfig, current, target);
        },
        isInView: function isInView() {
            return true;
        },
        offsetCell: function offsetCell(date, offset) {
            return generateConfig.addMonth(date, offset);
        }
    });
    var monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);
    var baseMonth = generateConfig.setMonth(viewDate, 0);
    var getCellNode = monthCellRender ? function(date) {
        return monthCellRender(date, locale);
    } : undefined;
    return /*#__PURE__*/ $6fFrj.createElement((0, $d7c6689876c548a6$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        rowNum: $9f883d34af634b4f$var$MONTH_ROW_COUNT,
        colNum: $9f883d34af634b4f$export$49f80bd546511120,
        baseDate: baseMonth,
        getCellNode: getCellNode,
        getCellText: function getCellText(date) {
            return locale.monthFormat ? (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(date, {
                locale: locale,
                format: locale.monthFormat,
                generateConfig: generateConfig
            }) : monthsLocale[generateConfig.getMonth(date)];
        },
        getCellClassName: getCellClassName,
        getCellDate: generateConfig.addMonth,
        titleCell: function titleCell(date) {
            return (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(date, {
                locale: locale,
                format: 'YYYY-MM',
                generateConfig: generateConfig
            });
        }
    }));
}
var $9f883d34af634b4f$export$2e2bcd8739ae039 = $9f883d34af634b4f$var$MonthBody;



function $b7c60963694f877a$var$MonthPanel(props) {
    var prefixCls = props.prefixCls, operationRef = props.operationRef, onViewDateChange = props.onViewDateChange, generateConfig = props.generateConfig, value = props.value, viewDate = props.viewDate, onPanelChange = props.onPanelChange, _onSelect = props.onSelect;
    var panelPrefixCls = "".concat(prefixCls, "-month-panel");
    // ======================= Keyboard =======================
    operationRef.current = {
        onKeyDown: function onKeyDown(event) {
            return (0, $92cb4f3f33042a05$export$a507db46d3f03278)(event, {
                onLeftRight: function onLeftRight(diff) {
                    _onSelect(generateConfig.addMonth(value || viewDate, diff), 'key');
                },
                onCtrlLeftRight: function onCtrlLeftRight(diff) {
                    _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
                },
                onUpDown: function onUpDown(diff) {
                    _onSelect(generateConfig.addMonth(value || viewDate, diff * (0, $9f883d34af634b4f$export$49f80bd546511120)), 'key');
                },
                onEnter: function onEnter() {
                    onPanelChange('date', value || viewDate);
                }
            });
        }
    };
    // ==================== View Operation ====================
    var onYearChange = function onYearChange(diff) {
        var newDate = generateConfig.addYear(viewDate, diff);
        onViewDateChange(newDate);
        onPanelChange(null, newDate);
    };
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $6fFrj.createElement((0, $3ee5c5d29e429f88$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: prefixCls,
        onPrevYear: function onPrevYear() {
            onYearChange(-1);
        },
        onNextYear: function onNextYear() {
            onYearChange(1);
        },
        onYearClick: function onYearClick() {
            onPanelChange('year', viewDate);
        }
    })), /*#__PURE__*/ $6fFrj.createElement((0, $9f883d34af634b4f$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: prefixCls,
        onSelect: function onSelect(date) {
            _onSelect(date, 'mouse');
            onPanelChange('date', date);
        }
    })));
}
var $b7c60963694f877a$export$2e2bcd8739ae039 = $b7c60963694f877a$var$MonthPanel;



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");



function $4d1e2bfd406345da$var$QuarterHeader(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, locale = props.locale, viewDate = props.viewDate, onNextYear = props.onNextYear, onPrevYear = props.onPrevYear, onYearClick = props.onYearClick;
    var _React$useContext = $6fFrj.useContext((0, $03d96fa1dbfe5ae5$export$2e2bcd8739ae039)), hideHeader = _React$useContext.hideHeader;
    if (hideHeader) return null;
    var headerPrefixCls = "".concat(prefixCls, "-header");
    return /*#__PURE__*/ $6fFrj.createElement((0, $ed92577a8a4d6745$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: headerPrefixCls,
        onSuperPrev: onPrevYear,
        onSuperNext: onNextYear
    }), /*#__PURE__*/ $6fFrj.createElement("button", {
        type: "button",
        onClick: onYearClick,
        className: "".concat(prefixCls, "-year-btn")
    }, (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(viewDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    })));
}
var $4d1e2bfd406345da$export$2e2bcd8739ae039 = $4d1e2bfd406345da$var$QuarterHeader;



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");




var $0d300046fabde761$export$ea79b61dfefe9355 = 4;
var $0d300046fabde761$var$QUARTER_ROW_COUNT = 1;
function $0d300046fabde761$var$QuarterBody(props) {
    var prefixCls = props.prefixCls, locale = props.locale, value = props.value, viewDate = props.viewDate, generateConfig = props.generateConfig;
    var _React$useContext = $6fFrj.useContext((0, $612ffa32a7ba0396$export$2e2bcd8739ae039)), rangedValue = _React$useContext.rangedValue, hoverRangedValue = _React$useContext.hoverRangedValue;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var getCellClassName = (0, $7a79f2bc0701f69e$export$2e2bcd8739ae039)({
        cellPrefixCls: cellPrefixCls,
        value: value,
        generateConfig: generateConfig,
        rangedValue: rangedValue,
        hoverRangedValue: hoverRangedValue,
        isSameCell: function isSameCell(current, target) {
            return (0, $69bfe3a3f4b23cc1$export$5c60e4190867161c)(generateConfig, current, target);
        },
        isInView: function isInView() {
            return true;
        },
        offsetCell: function offsetCell(date, offset) {
            return generateConfig.addMonth(date, offset * 3);
        }
    });
    var baseQuarter = generateConfig.setDate(generateConfig.setMonth(viewDate, 0), 1);
    return /*#__PURE__*/ $6fFrj.createElement((0, $d7c6689876c548a6$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        rowNum: $0d300046fabde761$var$QUARTER_ROW_COUNT,
        colNum: $0d300046fabde761$export$ea79b61dfefe9355,
        baseDate: baseQuarter,
        getCellText: function getCellText(date) {
            return (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(date, {
                locale: locale,
                format: locale.quarterFormat || '[Q]Q',
                generateConfig: generateConfig
            });
        },
        getCellClassName: getCellClassName,
        getCellDate: function getCellDate(date, offset) {
            return generateConfig.addMonth(date, offset * 3);
        },
        titleCell: function titleCell(date) {
            return (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(date, {
                locale: locale,
                format: 'YYYY-[Q]Q',
                generateConfig: generateConfig
            });
        }
    }));
}
var $0d300046fabde761$export$2e2bcd8739ae039 = $0d300046fabde761$var$QuarterBody;



function $2e221785818509e1$var$QuarterPanel(props) {
    var prefixCls = props.prefixCls, operationRef = props.operationRef, onViewDateChange = props.onViewDateChange, generateConfig = props.generateConfig, value = props.value, viewDate = props.viewDate, onPanelChange = props.onPanelChange, _onSelect = props.onSelect;
    var panelPrefixCls = "".concat(prefixCls, "-quarter-panel");
    // ======================= Keyboard =======================
    operationRef.current = {
        onKeyDown: function onKeyDown(event) {
            return (0, $92cb4f3f33042a05$export$a507db46d3f03278)(event, {
                onLeftRight: function onLeftRight(diff) {
                    _onSelect(generateConfig.addMonth(value || viewDate, diff * 3), 'key');
                },
                onCtrlLeftRight: function onCtrlLeftRight(diff) {
                    _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
                },
                onUpDown: function onUpDown(diff) {
                    _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
                }
            });
        }
    };
    // ==================== View Operation ====================
    var onYearChange = function onYearChange(diff) {
        var newDate = generateConfig.addYear(viewDate, diff);
        onViewDateChange(newDate);
        onPanelChange(null, newDate);
    };
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $6fFrj.createElement((0, $4d1e2bfd406345da$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: prefixCls,
        onPrevYear: function onPrevYear() {
            onYearChange(-1);
        },
        onNextYear: function onNextYear() {
            onYearChange(1);
        },
        onYearClick: function onYearClick() {
            onPanelChange('year', viewDate);
        }
    })), /*#__PURE__*/ $6fFrj.createElement((0, $0d300046fabde761$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: prefixCls,
        onSelect: function onSelect(date) {
            _onSelect(date, 'mouse');
        }
    })));
}
var $2e221785818509e1$export$2e2bcd8739ae039 = $2e221785818509e1$var$QuarterPanel;



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");



function $3b9b518880f36bcc$var$YearHeader(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, viewDate = props.viewDate, onPrevDecade = props.onPrevDecade, onNextDecade = props.onNextDecade, onDecadeClick = props.onDecadeClick;
    var _React$useContext = $6fFrj.useContext((0, $03d96fa1dbfe5ae5$export$2e2bcd8739ae039)), hideHeader = _React$useContext.hideHeader;
    if (hideHeader) return null;
    var headerPrefixCls = "".concat(prefixCls, "-header");
    var yearNumber = generateConfig.getYear(viewDate);
    var startYear = Math.floor(yearNumber / (0, $9d56a0f3e1c81db4$export$7e6e0078f5dd4028)) * (0, $9d56a0f3e1c81db4$export$7e6e0078f5dd4028);
    var endYear = startYear + (0, $9d56a0f3e1c81db4$export$7e6e0078f5dd4028) - 1;
    return /*#__PURE__*/ $6fFrj.createElement((0, $ed92577a8a4d6745$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: headerPrefixCls,
        onSuperPrev: onPrevDecade,
        onSuperNext: onNextDecade
    }), /*#__PURE__*/ $6fFrj.createElement("button", {
        type: "button",
        onClick: onDecadeClick,
        className: "".concat(prefixCls, "-decade-btn")
    }, startYear, "-", endYear));
}
var $3b9b518880f36bcc$export$2e2bcd8739ae039 = $3b9b518880f36bcc$var$YearHeader;



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");





var $6beb79e0839e025d$export$608dede485114b93 = 3;
var $6beb79e0839e025d$var$YEAR_ROW_COUNT = 4;
function $6beb79e0839e025d$var$YearBody(props) {
    var prefixCls = props.prefixCls, value = props.value, viewDate = props.viewDate, locale = props.locale, generateConfig = props.generateConfig;
    var _React$useContext = $6fFrj.useContext((0, $612ffa32a7ba0396$export$2e2bcd8739ae039)), rangedValue = _React$useContext.rangedValue, hoverRangedValue = _React$useContext.hoverRangedValue;
    var yearPrefixCls = "".concat(prefixCls, "-cell");
    // =============================== Year ===============================
    var yearNumber = generateConfig.getYear(viewDate);
    var startYear = Math.floor(yearNumber / (0, $9d56a0f3e1c81db4$export$7e6e0078f5dd4028)) * (0, $9d56a0f3e1c81db4$export$7e6e0078f5dd4028);
    var endYear = startYear + (0, $9d56a0f3e1c81db4$export$7e6e0078f5dd4028) - 1;
    var baseYear = generateConfig.setYear(viewDate, startYear - Math.ceil(($6beb79e0839e025d$export$608dede485114b93 * $6beb79e0839e025d$var$YEAR_ROW_COUNT - (0, $9d56a0f3e1c81db4$export$7e6e0078f5dd4028)) / 2));
    var isInView = function isInView(date) {
        var currentYearNumber = generateConfig.getYear(date);
        return startYear <= currentYearNumber && currentYearNumber <= endYear;
    };
    var getCellClassName = (0, $7a79f2bc0701f69e$export$2e2bcd8739ae039)({
        cellPrefixCls: yearPrefixCls,
        value: value,
        generateConfig: generateConfig,
        rangedValue: rangedValue,
        hoverRangedValue: hoverRangedValue,
        isSameCell: function isSameCell(current, target) {
            return (0, $69bfe3a3f4b23cc1$export$5841f9eb9773f25f)(generateConfig, current, target);
        },
        isInView: isInView,
        offsetCell: function offsetCell(date, offset) {
            return generateConfig.addYear(date, offset);
        }
    });
    return /*#__PURE__*/ $6fFrj.createElement((0, $d7c6689876c548a6$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        rowNum: $6beb79e0839e025d$var$YEAR_ROW_COUNT,
        colNum: $6beb79e0839e025d$export$608dede485114b93,
        baseDate: baseYear,
        getCellText: generateConfig.getYear,
        getCellClassName: getCellClassName,
        getCellDate: generateConfig.addYear,
        titleCell: function titleCell(date) {
            return (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(date, {
                locale: locale,
                format: 'YYYY',
                generateConfig: generateConfig
            });
        }
    }));
}
var $6beb79e0839e025d$export$2e2bcd8739ae039 = $6beb79e0839e025d$var$YearBody;



var $9d56a0f3e1c81db4$export$7e6e0078f5dd4028 = 10;
function $9d56a0f3e1c81db4$var$YearPanel(props) {
    var prefixCls = props.prefixCls, operationRef = props.operationRef, onViewDateChange = props.onViewDateChange, generateConfig = props.generateConfig, value = props.value, viewDate = props.viewDate, sourceMode = props.sourceMode, _onSelect = props.onSelect, onPanelChange = props.onPanelChange;
    var panelPrefixCls = "".concat(prefixCls, "-year-panel");
    // ======================= Keyboard =======================
    operationRef.current = {
        onKeyDown: function onKeyDown(event) {
            return (0, $92cb4f3f33042a05$export$a507db46d3f03278)(event, {
                onLeftRight: function onLeftRight(diff) {
                    _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
                },
                onCtrlLeftRight: function onCtrlLeftRight(diff) {
                    _onSelect(generateConfig.addYear(value || viewDate, diff * $9d56a0f3e1c81db4$export$7e6e0078f5dd4028), 'key');
                },
                onUpDown: function onUpDown(diff) {
                    _onSelect(generateConfig.addYear(value || viewDate, diff * (0, $6beb79e0839e025d$export$608dede485114b93)), 'key');
                },
                onEnter: function onEnter() {
                    onPanelChange(sourceMode === 'date' ? 'date' : 'month', value || viewDate);
                }
            });
        }
    };
    // ==================== View Operation ====================
    var onDecadeChange = function onDecadeChange(diff) {
        var newDate = generateConfig.addYear(viewDate, diff * 10);
        onViewDateChange(newDate);
        onPanelChange(null, newDate);
    };
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $6fFrj.createElement((0, $3b9b518880f36bcc$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: prefixCls,
        onPrevDecade: function onPrevDecade() {
            onDecadeChange(-1);
        },
        onNextDecade: function onNextDecade() {
            onDecadeChange(1);
        },
        onDecadeClick: function onDecadeClick() {
            onPanelChange('decade', viewDate);
        }
    })), /*#__PURE__*/ $6fFrj.createElement((0, $6beb79e0839e025d$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: prefixCls,
        onSelect: function onSelect(date) {
            onPanelChange(sourceMode === 'date' ? 'date' : 'month', date);
            _onSelect(date, 'mouse');
        }
    })));
}
var $9d56a0f3e1c81db4$export$2e2bcd8739ae039 = $9d56a0f3e1c81db4$var$YearPanel;









var $6fFrj = parcelRequire("6fFrj");
function $552933cde41046e6$export$2e2bcd8739ae039(prefixCls, mode, renderExtraFooter) {
    if (!renderExtraFooter) return null;
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-footer-extra")
    }, renderExtraFooter(mode));
}



var $6fFrj = parcelRequire("6fFrj");
function $53ea13bd8b354d62$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, _ref$rangeList = _ref.rangeList, rangeList = _ref$rangeList === void 0 ? [] : _ref$rangeList, _ref$components = _ref.components, components = _ref$components === void 0 ? {} : _ref$components, needConfirmButton = _ref.needConfirmButton, onNow = _ref.onNow, onOk = _ref.onOk, okDisabled = _ref.okDisabled, showNow = _ref.showNow, locale = _ref.locale;
    var presetNode;
    var okNode;
    if (rangeList.length) {
        var Item = components.rangeItem || 'span';
        presetNode = /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, rangeList.map(function(_ref2) {
            var label = _ref2.label, onClick = _ref2.onClick, onMouseEnter = _ref2.onMouseEnter, onMouseLeave = _ref2.onMouseLeave;
            return /*#__PURE__*/ $6fFrj.createElement("li", {
                key: label,
                className: "".concat(prefixCls, "-preset")
            }, /*#__PURE__*/ $6fFrj.createElement(Item, {
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave
            }, label));
        }));
    }
    if (needConfirmButton) {
        var Button = components.button || 'button';
        if (onNow && !presetNode && showNow !== false) presetNode = /*#__PURE__*/ $6fFrj.createElement("li", {
            className: "".concat(prefixCls, "-now")
        }, /*#__PURE__*/ $6fFrj.createElement("a", {
            className: "".concat(prefixCls, "-now-btn"),
            onClick: onNow
        }, locale.now));
        okNode = needConfirmButton && /*#__PURE__*/ $6fFrj.createElement("li", {
            className: "".concat(prefixCls, "-ok")
        }, /*#__PURE__*/ $6fFrj.createElement(Button, {
            disabled: okDisabled,
            onClick: onOk
        }, locale.ok));
    }
    if (!presetNode && !okNode) return null;
    return /*#__PURE__*/ $6fFrj.createElement("ul", {
        className: "".concat(prefixCls, "-ranges")
    }, presetNode, okNode);
}



// Calendar picker type
var $198a41f58792240c$var$CALENDAR_PANEL_MODE = [
    'date',
    'month'
];
function $198a41f58792240c$var$PickerPanel(props) {
    var _classNames;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-picker' : _props$prefixCls, className = props.className, style = props.style, locale = props.locale, generateConfig = props.generateConfig, value = props.value, defaultValue = props.defaultValue, pickerValue = props.pickerValue, defaultPickerValue = props.defaultPickerValue, disabledDate = props.disabledDate, mode = props.mode, _props$picker = props.picker, picker = _props$picker === void 0 ? 'date' : _props$picker, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, showNow = props.showNow, showTime = props.showTime, showToday = props.showToday, renderExtraFooter = props.renderExtraFooter, hideHeader = props.hideHeader, onSelect = props.onSelect, onChange = props.onChange, onPanelChange = props.onPanelChange, onMouseDown = props.onMouseDown, onPickerValueChange = props.onPickerValueChange, _onOk = props.onOk, components = props.components, direction = props.direction, _props$hourStep = props.hourStep, hourStep = _props$hourStep === void 0 ? 1 : _props$hourStep, _props$minuteStep = props.minuteStep, minuteStep = _props$minuteStep === void 0 ? 1 : _props$minuteStep, _props$secondStep = props.secondStep, secondStep = _props$secondStep === void 0 ? 1 : _props$secondStep;
    var needConfirmButton = picker === 'date' && !!showTime || picker === 'time';
    var isHourStepValid = 24 % hourStep === 0;
    var isMinuteStepValid = 60 % minuteStep === 0;
    var isSecondStepValid = 60 % secondStep === 0;
    // ============================ State =============================
    var panelContext = $6fFrj.useContext((0, $03d96fa1dbfe5ae5$export$2e2bcd8739ae039));
    var operationRef = panelContext.operationRef, panelDivRef = panelContext.panelRef, onContextSelect = panelContext.onSelect, hideRanges = panelContext.hideRanges, defaultOpenValue = panelContext.defaultOpenValue;
    var _React$useContext = $6fFrj.useContext((0, $612ffa32a7ba0396$export$2e2bcd8739ae039)), inRange = _React$useContext.inRange, panelPosition = _React$useContext.panelPosition, rangedValue = _React$useContext.rangedValue, hoverRangedValue = _React$useContext.hoverRangedValue;
    var panelRef = $6fFrj.useRef({});
    // Handle init logic
    var initRef = $6fFrj.useRef(true);
    // Value
    var _useMergedState = (0, $gfhff.default)(null, {
        value: value,
        defaultValue: defaultValue,
        postState: function postState(val) {
            if (!val && defaultOpenValue && picker === 'time') return defaultOpenValue;
            return val;
        }
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), mergedValue = _useMergedState2[0], setInnerValue = _useMergedState2[1];
    // View date control
    var _useMergedState3 = (0, $gfhff.default)(null, {
        value: pickerValue,
        defaultValue: defaultPickerValue || mergedValue,
        postState: function postState(date) {
            var now = generateConfig.getNow();
            if (!date) return now;
            // When value is null and set showTime
            if (!mergedValue && showTime) {
                var defaultDateObject = (0, $5KhTJ.default)(showTime) === 'object' ? showTime.defaultValue : defaultValue;
                return (0, $bf5c2cfe19b8eb58$export$3a84b9eda98e95dc)(generateConfig, Array.isArray(date) ? date[0] : date, defaultDateObject || now);
            }
            return Array.isArray(date) ? date[0] : date;
        }
    }), _useMergedState4 = (0, $jP8CL.default)(_useMergedState3, 2), viewDate = _useMergedState4[0], setInnerViewDate = _useMergedState4[1];
    var setViewDate = function setViewDate(date) {
        setInnerViewDate(date);
        if (onPickerValueChange) onPickerValueChange(date);
    };
    // Panel control
    var getInternalNextMode = function getInternalNextMode(nextMode) {
        var getNextMode = (0, $92cb4f3f33042a05$export$6b35bb792c096c09)[picker];
        if (getNextMode) return getNextMode(nextMode);
        return nextMode;
    };
    // Save panel is changed from which panel
    var _useMergedState5 = (0, $gfhff.default)(function() {
        if (picker === 'time') return 'time';
        return getInternalNextMode('date');
    }, {
        value: mode
    }), _useMergedState6 = (0, $jP8CL.default)(_useMergedState5, 2), mergedMode = _useMergedState6[0], setInnerMode = _useMergedState6[1];
    $6fFrj.useEffect(function() {
        setInnerMode(picker);
    }, [
        picker
    ]);
    var _React$useState = $6fFrj.useState(function() {
        return mergedMode;
    }), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), sourceMode = _React$useState2[0], setSourceMode = _React$useState2[1];
    var onInternalPanelChange = function onInternalPanelChange(newMode, viewValue) {
        var nextMode = getInternalNextMode(newMode || mergedMode);
        setSourceMode(mergedMode);
        setInnerMode(nextMode);
        if (onPanelChange && (mergedMode !== nextMode || (0, $69bfe3a3f4b23cc1$export$248d38f6296296c5)(generateConfig, viewDate, viewDate))) onPanelChange(viewValue, nextMode);
    };
    var triggerSelect = function triggerSelect(date, type) {
        var forceTriggerSelect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        if (mergedMode === picker || forceTriggerSelect) {
            setInnerValue(date);
            if (onSelect) onSelect(date);
            if (onContextSelect) onContextSelect(date, type);
            if (onChange && !(0, $69bfe3a3f4b23cc1$export$248d38f6296296c5)(generateConfig, date, mergedValue) && !(disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date))) onChange(date);
        }
    };
    var isSelectable = function isSelectable(key) {
        if ($198a41f58792240c$var$CALENDAR_PANEL_MODE.includes(mergedMode)) {
            var date;
            var operationFnc;
            var isDateMode = mergedMode === 'date';
            if (key === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).PAGE_UP || key === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).PAGE_DOWN) operationFnc = isDateMode ? generateConfig.addMonth : generateConfig.addYear;
            else operationFnc = isDateMode ? generateConfig.addDate : generateConfig.addMonth;
            switch(key){
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).LEFT:
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).PAGE_UP:
                    date = operationFnc(viewDate, -1);
                    break;
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).RIGHT:
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).PAGE_DOWN:
                    date = operationFnc(viewDate, 1);
                    break;
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).UP:
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).DOWN:
                    date = operationFnc(viewDate, Number("".concat(key === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).UP ? '-' : '').concat(isDateMode ? (0, $69bfe3a3f4b23cc1$export$fe62c2dddb4d77ea) : (0, $9f883d34af634b4f$export$49f80bd546511120))));
                    break;
            }
            if (date) return !(disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date));
        }
        return true;
    };
    // ========================= Interactive ==========================
    var onInternalKeyDown = function onInternalKeyDown(e) {
        if (panelRef.current && panelRef.current.onKeyDown) {
            var selectable = true;
            var which = e.which;
            if ([
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).LEFT,
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).RIGHT,
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).UP,
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).DOWN,
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).PAGE_UP,
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).PAGE_DOWN,
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER
            ].includes(which)) {
                e.preventDefault();
                if (which !== (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER && tabIndex === 0) selectable = isSelectable(which);
            }
            // Cannot use keyboard to select disabled date
            if (selectable) return panelRef.current.onKeyDown(e);
        }
        (0, $3mXQ2.default)(false, 'Panel not correct handle keyDown event. Please help to fire issue about this.');
        return false;
    /* eslint-enable no-lone-blocks */ };
    var onInternalBlur = function onInternalBlur(e) {
        if (panelRef.current && panelRef.current.onBlur) panelRef.current.onBlur(e);
    };
    if (operationRef && panelPosition !== 'right') operationRef.current = {
        onKeyDown: onInternalKeyDown,
        onClose: function onClose() {
            if (panelRef.current && panelRef.current.onClose) panelRef.current.onClose();
        }
    };
    // ============================ Effect ============================
    $6fFrj.useEffect(function() {
        if (value && !initRef.current) setInnerViewDate(value);
    }, [
        value
    ]);
    $6fFrj.useEffect(function() {
        initRef.current = false;
    }, []);
    // ============================ Panels ============================
    var panelNode;
    var pickerProps = (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        operationRef: panelRef,
        prefixCls: prefixCls,
        viewDate: viewDate,
        value: mergedValue,
        onViewDateChange: setViewDate,
        sourceMode: sourceMode,
        onPanelChange: onInternalPanelChange,
        disabledDate: disabledDate
    });
    delete pickerProps.onChange;
    delete pickerProps.onSelect;
    switch(mergedMode){
        case 'decade':
            panelNode = /*#__PURE__*/ $6fFrj.createElement((0, $7345567541ec02b1$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, pickerProps, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
            break;
        case 'year':
            panelNode = /*#__PURE__*/ $6fFrj.createElement((0, $9d56a0f3e1c81db4$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, pickerProps, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
            break;
        case 'month':
            panelNode = /*#__PURE__*/ $6fFrj.createElement((0, $b7c60963694f877a$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, pickerProps, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
            break;
        case 'quarter':
            panelNode = /*#__PURE__*/ $6fFrj.createElement((0, $2e221785818509e1$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, pickerProps, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
            break;
        case 'week':
            panelNode = /*#__PURE__*/ $6fFrj.createElement((0, $db95832eff3d6d3b$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, pickerProps, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
            break;
        case 'time':
            delete pickerProps.showTime;
            panelNode = /*#__PURE__*/ $6fFrj.createElement((0, $d7d3258430bf7b8f$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, pickerProps, (0, $5KhTJ.default)(showTime) === 'object' ? showTime : null, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
            break;
        default:
            if (showTime) panelNode = /*#__PURE__*/ $6fFrj.createElement((0, $d114d62d9b90d24e$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, pickerProps, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
            else panelNode = /*#__PURE__*/ $6fFrj.createElement((0, $f3e084a0c0b898f4$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, pickerProps, {
                onSelect: function onSelect(date, type) {
                    setViewDate(date);
                    triggerSelect(date, type);
                }
            }));
    }
    // ============================ Footer ============================
    var extraFooter;
    var rangesNode;
    var onNow = function onNow() {
        var now = generateConfig.getNow();
        var lowerBoundTime = (0, $bf5c2cfe19b8eb58$export$6ebc74d7e616149)(generateConfig.getHour(now), generateConfig.getMinute(now), generateConfig.getSecond(now), isHourStepValid ? hourStep : 1, isMinuteStepValid ? minuteStep : 1, isSecondStepValid ? secondStep : 1);
        var adjustedNow = (0, $bf5c2cfe19b8eb58$export$e5d5e1c1822b6e56)(generateConfig, now, lowerBoundTime[0], // hour
        lowerBoundTime[1], // minute
        lowerBoundTime[2]);
        triggerSelect(adjustedNow, 'submit');
    };
    if (!hideRanges) {
        extraFooter = (0, $552933cde41046e6$export$2e2bcd8739ae039)(prefixCls, mergedMode, renderExtraFooter);
        rangesNode = (0, $53ea13bd8b354d62$export$2e2bcd8739ae039)({
            prefixCls: prefixCls,
            components: components,
            needConfirmButton: needConfirmButton,
            okDisabled: !mergedValue || disabledDate && disabledDate(mergedValue),
            locale: locale,
            showNow: showNow,
            onNow: needConfirmButton && onNow,
            onOk: function onOk() {
                if (mergedValue) {
                    triggerSelect(mergedValue, 'submit', true);
                    if (_onOk) _onOk(mergedValue);
                }
            }
        });
    }
    var todayNode;
    if (showToday && mergedMode === 'date' && picker === 'date' && !showTime) {
        var now = generateConfig.getNow();
        var todayCls = "".concat(prefixCls, "-today-btn");
        var disabled = disabledDate && disabledDate(now);
        todayNode = /*#__PURE__*/ $6fFrj.createElement("a", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(todayCls, disabled && "".concat(todayCls, "-disabled")),
            "aria-disabled": disabled,
            onClick: function onClick() {
                if (!disabled) triggerSelect(now, 'mouse', true);
            }
        }, locale.today);
    }
    return /*#__PURE__*/ $6fFrj.createElement((0, $03d96fa1dbfe5ae5$export$2e2bcd8739ae039).Provider, {
        value: (0, $kNxFX.default)((0, $kNxFX.default)({}, panelContext), {}, {
            mode: mergedMode,
            hideHeader: 'hideHeader' in props ? hideHeader : panelContext.hideHeader,
            hidePrevBtn: inRange && panelPosition === 'right',
            hideNextBtn: inRange && panelPosition === 'left'
        })
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        tabIndex: tabIndex,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-panel"), className, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(prefixCls, "-panel-has-range"), rangedValue && rangedValue[0] && rangedValue[1]), (0, $43449.default)(_classNames, "".concat(prefixCls, "-panel-has-range-hover"), hoverRangedValue && hoverRangedValue[0] && hoverRangedValue[1]), (0, $43449.default)(_classNames, "".concat(prefixCls, "-panel-rtl"), direction === 'rtl'), _classNames)),
        style: style,
        onKeyDown: onInternalKeyDown,
        onBlur: onInternalBlur,
        onMouseDown: onMouseDown,
        ref: panelDivRef
    }, panelNode, extraFooter || rangesNode || todayNode ? /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-footer")
    }, extraFooter, rangesNode, todayNode) : null));
}
var $198a41f58792240c$export$2e2bcd8739ae039 /* eslint-enable */  = $198a41f58792240c$var$PickerPanel;



var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $cf4fdeb80ffb87d6$var$BUILT_IN_PLACEMENTS = {
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        offset: [
            0,
            4
        ],
        overflow: {
            adjustX: 1,
            adjustY: 1
        }
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        offset: [
            0,
            4
        ],
        overflow: {
            adjustX: 1,
            adjustY: 1
        }
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        offset: [
            0,
            -4
        ],
        overflow: {
            adjustX: 0,
            adjustY: 1
        }
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        offset: [
            0,
            -4
        ],
        overflow: {
            adjustX: 0,
            adjustY: 1
        }
    }
};
function $cf4fdeb80ffb87d6$var$PickerTrigger(_ref) {
    var _classNames;
    var prefixCls = _ref.prefixCls, popupElement = _ref.popupElement, popupStyle = _ref.popupStyle, visible = _ref.visible, dropdownClassName = _ref.dropdownClassName, dropdownAlign = _ref.dropdownAlign, transitionName = _ref.transitionName, getPopupContainer = _ref.getPopupContainer, children = _ref.children, range = _ref.range, popupPlacement = _ref.popupPlacement, direction = _ref.direction;
    var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
    var getPopupPlacement = function getPopupPlacement() {
        if (popupPlacement !== undefined) return popupPlacement;
        return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $2c9abce2aaa5219e$export$2e2bcd8739ae039), {
        showAction: [],
        hideAction: [],
        popupPlacement: getPopupPlacement(),
        builtinPlacements: $cf4fdeb80ffb87d6$var$BUILT_IN_PLACEMENTS,
        prefixCls: dropdownPrefixCls,
        popupTransitionName: transitionName,
        popup: popupElement,
        popupAlign: dropdownAlign,
        popupVisible: visible,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(dropdownClassName, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(dropdownPrefixCls, "-range"), range), (0, $43449.default)(_classNames, "".concat(dropdownPrefixCls, "-rtl"), direction === 'rtl'), _classNames)),
        popupStyle: popupStyle,
        getPopupContainer: getPopupContainer
    }, children);
}
var $cf4fdeb80ffb87d6$export$2e2bcd8739ae039 = $cf4fdeb80ffb87d6$var$PickerTrigger;







var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");


function $23d3f8e3416f930f$export$2e2bcd8739ae039(_ref) {
    var open = _ref.open, value = _ref.value, isClickOutside = _ref.isClickOutside, triggerOpen = _ref.triggerOpen, forwardKeyDown = _ref.forwardKeyDown, _onKeyDown = _ref.onKeyDown, blurToCancel = _ref.blurToCancel, onSubmit = _ref.onSubmit, onCancel = _ref.onCancel, _onFocus = _ref.onFocus, _onBlur = _ref.onBlur, currentFocusedKey = _ref.currentFocusedKey, _ref$key = _ref.key, key = _ref$key === void 0 ? 'start' : _ref$key;
    var _useState = (0, $6fFrj.useState)(false), _useState2 = (0, $jP8CL.default)(_useState, 2), typing = _useState2[0], setTyping = _useState2[1];
    var _useState3 = (0, $6fFrj.useState)(false), _useState4 = (0, $jP8CL.default)(_useState3, 2), focused = _useState4[0], setFocused = _useState4[1];
    var delayBlurTimer = (0, $6fFrj.useRef)();
    /**
   * We will prevent blur to handle open event when user click outside,
   * since this will repeat trigger `onOpenChange` event.
   */ var preventBlurRef = (0, $6fFrj.useRef)(false);
    var valueChangedRef = (0, $6fFrj.useRef)(false);
    var preventDefaultRef = (0, $6fFrj.useRef)(false);
    var inputProps = {
        onMouseDown: function onMouseDown() {
            setTyping(true);
            triggerOpen(true);
        },
        onKeyDown: function onKeyDown(e) {
            var preventDefault = function preventDefault() {
                preventDefaultRef.current = true;
            };
            _onKeyDown(e, preventDefault);
            if (preventDefaultRef.current) return;
            switch(e.which){
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER:
                    if (!open) triggerOpen(true);
                    else if (onSubmit() !== false) setTyping(true);
                    e.preventDefault();
                    return;
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).TAB:
                    if (typing && open && !e.shiftKey) {
                        setTyping(false);
                        e.preventDefault();
                    } else if (!typing && open) {
                        if (!forwardKeyDown(e) && e.shiftKey) {
                            setTyping(true);
                            e.preventDefault();
                        }
                    }
                    return;
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ESC:
                    setTyping(true);
                    onCancel();
                    return;
            }
            if (!open && ![
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).SHIFT
            ].includes(e.which)) triggerOpen(true);
            else if (!typing) // Let popup panel handle keyboard
            forwardKeyDown(e);
        },
        onFocus: function onFocus(e) {
            setTyping(true);
            setFocused(true);
            if (currentFocusedKey) currentFocusedKey.current = key;
            clearTimeout(delayBlurTimer.current);
            if (_onFocus) _onFocus(e);
        },
        onBlur: function onBlur(e) {
            if (preventBlurRef.current || !isClickOutside(document.activeElement)) {
                preventBlurRef.current = false;
                return;
            }
            if (blurToCancel) setTimeout(function() {
                var _document = document, activeElement = _document.activeElement;
                while(activeElement && activeElement.shadowRoot)activeElement = activeElement.shadowRoot.activeElement;
                if (isClickOutside(activeElement)) onCancel();
            }, 0);
            else if (open) {
                triggerOpen(false);
                if (valueChangedRef.current) onSubmit();
            }
            setFocused(false);
            if (currentFocusedKey) {
                currentFocusedKey.current = '';
                // Delay to prevent 'range' focus transitions from firing resulting in incorrect out-of-focus events
                delayBlurTimer.current = setTimeout(function() {
                    // Prevent the 'blur' event from firing when there is currently a focused input
                    if (currentFocusedKey.current) return;
                    _onBlur === null || _onBlur === void 0 || _onBlur(e);
                }, 100);
            } else _onBlur === null || _onBlur === void 0 || _onBlur(e);
        }
    };
    // check if value changed
    (0, $6fFrj.useEffect)(function() {
        valueChangedRef.current = false;
    }, [
        open
    ]);
    (0, $6fFrj.useEffect)(function() {
        valueChangedRef.current = true;
    }, [
        value
    ]);
    // Global click handler
    (0, $6fFrj.useEffect)(function() {
        return (0, $92cb4f3f33042a05$export$1ccf549497681f00)(function(e) {
            var target = (0, $92cb4f3f33042a05$export$2fb4f2d524461006)(e);
            var clickedOutside = isClickOutside(target);
            if (open) {
                if (!clickedOutside) {
                    preventBlurRef.current = true;
                    // Always set back in case `onBlur` prevented by user
                    requestAnimationFrame(function() {
                        preventBlurRef.current = false;
                    });
                } else if (!focused || clickedOutside) triggerOpen(false);
            } else if (focused && !clickedOutside) preventBlurRef.current = true;
        });
    });
    (0, $6fFrj.useEffect)(function() {
        return function() {
            return clearTimeout(delayBlurTimer.current);
        };
    }, []);
    return [
        inputProps,
        {
            focused: focused,
            typing: typing
        }
    ];
}



var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
function $da4eef76e2d8760e$export$2e2bcd8739ae039(_ref) {
    var valueTexts = _ref.valueTexts, onTextChange = _ref.onTextChange;
    var _React$useState = $6fFrj.useState(''), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), text = _React$useState2[0], setInnerText = _React$useState2[1];
    var valueTextsRef = $6fFrj.useRef([]);
    valueTextsRef.current = valueTexts;
    function triggerTextChange(value) {
        setInnerText(value);
        onTextChange(value);
    }
    function resetText() {
        setInnerText(valueTextsRef.current[0]);
    }
    $6fFrj.useEffect(function() {
        if (valueTexts.every(function(valText) {
            return valText !== text;
        })) resetText();
    }, [
        valueTexts.join('||')
    ]);
    return [
        text,
        triggerTextChange,
        resetText
    ];
}



var $a5lfY = parcelRequire("a5lfY");


function $f47343546dd22f33$export$2e2bcd8739ae039(value, _ref) {
    var formatList = _ref.formatList, generateConfig = _ref.generateConfig, locale = _ref.locale;
    return (0, $a5lfY.default)(function() {
        if (!value) return [
            [
                ''
            ],
            ''
        ];
        // We will convert data format back to first format
        var firstValueText = '';
        var fullValueTexts = [];
        for(var i = 0; i < formatList.length; i += 1){
            var format = formatList[i];
            var formatStr = (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(value, {
                generateConfig: generateConfig,
                locale: locale,
                format: format
            });
            fullValueTexts.push(formatStr);
            if (i === 0) firstValueText = formatStr;
        }
        return [
            fullValueTexts,
            firstValueText
        ];
    }, [
        value,
        formatList,
        locale
    ], function(prev, next) {
        return(// Not Same Date
        !(0, $69bfe3a3f4b23cc1$export$248d38f6296296c5)(generateConfig, prev[0], next[0]) || // Not Same format
        !(0, $ae3c1fae8a247572$export$2e2bcd8739ae039)(prev[1], next[1], true) || // Not Same locale
        !(0, $ae3c1fae8a247572$export$2e2bcd8739ae039)(prev[2], next[2], true));
    });
}



var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

function $c2797eaa7b0b38f1$export$2e2bcd8739ae039(valueText, _ref) {
    var formatList = _ref.formatList, generateConfig = _ref.generateConfig, locale = _ref.locale;
    var _useState = (0, $6fFrj.useState)(null), _useState2 = (0, $jP8CL.default)(_useState, 2), value = _useState2[0], internalSetValue = _useState2[1];
    var raf = (0, $6fFrj.useRef)(null);
    function setValue(val) {
        var immediately = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        cancelAnimationFrame(raf.current);
        if (immediately) {
            internalSetValue(val);
            return;
        }
        raf.current = requestAnimationFrame(function() {
            internalSetValue(val);
        });
    }
    var _useValueTexts = (0, $f47343546dd22f33$export$2e2bcd8739ae039)(value, {
        formatList: formatList,
        generateConfig: generateConfig,
        locale: locale
    }), _useValueTexts2 = (0, $jP8CL.default)(_useValueTexts, 2), firstText = _useValueTexts2[1];
    function onEnter(date) {
        setValue(date);
    }
    function onLeave() {
        var immediately = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        setValue(null, immediately);
    }
    (0, $6fFrj.useEffect)(function() {
        onLeave(true);
    }, [
        valueText
    ]);
    (0, $6fFrj.useEffect)(function() {
        return function() {
            return cancelAnimationFrame(raf.current);
        };
    }, []);
    return [
        firstText,
        onEnter,
        onLeave
    ];
}



var $3mXQ2 = parcelRequire("3mXQ2");
function $6863957ec9faa374$export$cfe7369d67de3234(props) {
    var picker = props.picker, disabledHours = props.disabledHours, disabledMinutes = props.disabledMinutes, disabledSeconds = props.disabledSeconds;
    if (picker === 'time' && (disabledHours || disabledMinutes || disabledSeconds)) (0, $3mXQ2.default)(false, "'disabledHours', 'disabledMinutes', 'disabledSeconds' will be removed in the next major version, please use 'disabledTime' instead.");
}


function $f715b201770c56f7$var$InnerPicker(props) {
    var _classNames2;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-picker' : _props$prefixCls, id = props.id, tabIndex = props.tabIndex, style = props.style, className = props.className, dropdownClassName = props.dropdownClassName, dropdownAlign = props.dropdownAlign, popupStyle = props.popupStyle, transitionName = props.transitionName, generateConfig = props.generateConfig, locale = props.locale, inputReadOnly = props.inputReadOnly, allowClear = props.allowClear, autoFocus = props.autoFocus, showTime = props.showTime, _props$picker = props.picker, picker = _props$picker === void 0 ? 'date' : _props$picker, format = props.format, use12Hours = props.use12Hours, value = props.value, defaultValue = props.defaultValue, open = props.open, defaultOpen = props.defaultOpen, defaultOpenValue = props.defaultOpenValue, suffixIcon = props.suffixIcon, clearIcon = props.clearIcon, disabled = props.disabled, disabledDate = props.disabledDate, placeholder = props.placeholder, getPopupContainer = props.getPopupContainer, pickerRef = props.pickerRef, panelRender = props.panelRender, onChange = props.onChange, onOpenChange = props.onOpenChange, onFocus = props.onFocus, onBlur = props.onBlur, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onContextMenu = props.onContextMenu, onClick = props.onClick, _onKeyDown = props.onKeyDown, _onSelect = props.onSelect, direction = props.direction, _props$autoComplete = props.autoComplete, autoComplete = _props$autoComplete === void 0 ? 'off' : _props$autoComplete, inputRender = props.inputRender;
    var inputRef = $6fFrj.useRef(null);
    var needConfirmButton = picker === 'date' && !!showTime || picker === 'time';
    // ============================= State =============================
    var formatList = (0, $80a563586615a9e1$export$45b10814cc054894)((0, $92cb4f3f33042a05$export$3e0385bd234197e6)(format, picker, showTime, use12Hours));
    // Panel ref
    var panelDivRef = $6fFrj.useRef(null);
    var inputDivRef = $6fFrj.useRef(null);
    var containerRef = $6fFrj.useRef(null);
    // Real value
    var _useMergedState = (0, $gfhff.default)(null, {
        value: value,
        defaultValue: defaultValue
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), mergedValue = _useMergedState2[0], setInnerValue = _useMergedState2[1];
    // Selected value
    var _React$useState = $6fFrj.useState(mergedValue), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), selectedValue = _React$useState2[0], setSelectedValue = _React$useState2[1];
    // Operation ref
    var operationRef = $6fFrj.useRef(null);
    // Open
    var _useMergedState3 = (0, $gfhff.default)(false, {
        value: open,
        defaultValue: defaultOpen,
        postState: function postState(postOpen) {
            return disabled ? false : postOpen;
        },
        onChange: function onChange(newOpen) {
            if (onOpenChange) onOpenChange(newOpen);
            if (!newOpen && operationRef.current && operationRef.current.onClose) operationRef.current.onClose();
        }
    }), _useMergedState4 = (0, $jP8CL.default)(_useMergedState3, 2), mergedOpen = _useMergedState4[0], triggerInnerOpen = _useMergedState4[1];
    // ============================= Text ==============================
    var _useValueTexts = (0, $f47343546dd22f33$export$2e2bcd8739ae039)(selectedValue, {
        formatList: formatList,
        generateConfig: generateConfig,
        locale: locale
    }), _useValueTexts2 = (0, $jP8CL.default)(_useValueTexts, 2), valueTexts = _useValueTexts2[0], firstValueText = _useValueTexts2[1];
    var _useTextValueMapping = (0, $da4eef76e2d8760e$export$2e2bcd8739ae039)({
        valueTexts: valueTexts,
        onTextChange: function onTextChange(newText) {
            var inputDate = (0, $69bfe3a3f4b23cc1$export$5303528d1070ff6f)(newText, {
                locale: locale,
                formatList: formatList,
                generateConfig: generateConfig
            });
            if (inputDate && (!disabledDate || !disabledDate(inputDate))) setSelectedValue(inputDate);
        }
    }), _useTextValueMapping2 = (0, $jP8CL.default)(_useTextValueMapping, 3), text = _useTextValueMapping2[0], triggerTextChange = _useTextValueMapping2[1], resetText = _useTextValueMapping2[2];
    // ============================ Trigger ============================
    var triggerChange = function triggerChange(newValue) {
        setSelectedValue(newValue);
        setInnerValue(newValue);
        if (onChange && !(0, $69bfe3a3f4b23cc1$export$248d38f6296296c5)(generateConfig, mergedValue, newValue)) onChange(newValue, newValue ? (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(newValue, {
            generateConfig: generateConfig,
            locale: locale,
            format: formatList[0]
        }) : '');
    };
    var triggerOpen = function triggerOpen(newOpen) {
        if (disabled && newOpen) return;
        triggerInnerOpen(newOpen);
    };
    var forwardKeyDown = function forwardKeyDown(e) {
        if (mergedOpen && operationRef.current && operationRef.current.onKeyDown) // Let popup panel handle keyboard
        return operationRef.current.onKeyDown(e);
        (0, $3mXQ2.default)(false, 'Picker not correct forward KeyDown operation. Please help to fire issue about this.');
        return false;
    };
    var onInternalClick = function onInternalClick() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        onClick === null || onClick === void 0 || onClick.apply(void 0, args);
        if (inputRef.current) {
            inputRef.current.focus();
            triggerOpen(true);
        }
    };
    // ============================= Input =============================
    var _usePickerInput = (0, $23d3f8e3416f930f$export$2e2bcd8739ae039)({
        blurToCancel: needConfirmButton,
        open: mergedOpen,
        value: text,
        triggerOpen: triggerOpen,
        forwardKeyDown: forwardKeyDown,
        isClickOutside: function isClickOutside(target) {
            return !(0, $92cb4f3f33042a05$export$9350e4ea4b8364)([
                panelDivRef.current,
                inputDivRef.current,
                containerRef.current
            ], target);
        },
        onSubmit: function onSubmit() {
            if (// When user typing disabledDate with keyboard and enter, this value will be empty
            !selectedValue || // Normal disabled check
            disabledDate && disabledDate(selectedValue)) return false;
            triggerChange(selectedValue);
            triggerOpen(false);
            resetText();
            return true;
        },
        onCancel: function onCancel() {
            triggerOpen(false);
            setSelectedValue(mergedValue);
            resetText();
        },
        onKeyDown: function onKeyDown(e, preventDefault) {
            _onKeyDown === null || _onKeyDown === void 0 || _onKeyDown(e, preventDefault);
        },
        onFocus: onFocus,
        onBlur: onBlur
    }), _usePickerInput2 = (0, $jP8CL.default)(_usePickerInput, 2), inputProps = _usePickerInput2[0], _usePickerInput2$ = _usePickerInput2[1], focused = _usePickerInput2$.focused, typing = _usePickerInput2$.typing;
    // ============================= Sync ==============================
    // Close should sync back with text value
    $6fFrj.useEffect(function() {
        if (!mergedOpen) {
            setSelectedValue(mergedValue);
            if (!valueTexts.length || valueTexts[0] === '') triggerTextChange('');
            else if (firstValueText !== text) resetText();
        }
    }, [
        mergedOpen,
        valueTexts
    ]);
    // Change picker should sync back with text value
    $6fFrj.useEffect(function() {
        if (!mergedOpen) resetText();
    }, [
        picker
    ]);
    // Sync innerValue with control mode
    $6fFrj.useEffect(function() {
        // Sync select value
        setSelectedValue(mergedValue);
    }, [
        mergedValue
    ]);
    // ============================ Private ============================
    if (pickerRef) pickerRef.current = {
        focus: function focus() {
            if (inputRef.current) inputRef.current.focus();
        },
        blur: function blur() {
            if (inputRef.current) inputRef.current.blur();
        }
    };
    var _useHoverValue = (0, $c2797eaa7b0b38f1$export$2e2bcd8739ae039)(text, {
        formatList: formatList,
        generateConfig: generateConfig,
        locale: locale
    }), _useHoverValue2 = (0, $jP8CL.default)(_useHoverValue, 3), hoverValue = _useHoverValue2[0], onEnter = _useHoverValue2[1], onLeave = _useHoverValue2[2];
    // ============================= Panel =============================
    var panelProps = (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        className: undefined,
        style: undefined,
        pickerValue: undefined,
        onPickerValueChange: undefined,
        onChange: null
    });
    var panelNode = /*#__PURE__*/ $6fFrj.createElement((0, $198a41f58792240c$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, panelProps, {
        generateConfig: generateConfig,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)({}, "".concat(prefixCls, "-panel-focused"), !typing)),
        value: selectedValue,
        locale: locale,
        tabIndex: -1,
        onSelect: function onSelect(date) {
            _onSelect === null || _onSelect === void 0 || _onSelect(date);
            setSelectedValue(date);
        },
        direction: direction,
        onPanelChange: function onPanelChange(viewDate, mode) {
            var onPanelChange = props.onPanelChange;
            onLeave(true);
            onPanelChange === null || onPanelChange === void 0 || onPanelChange(viewDate, mode);
        }
    }));
    if (panelRender) panelNode = panelRender(panelNode);
    var panel = /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-panel-container"),
        onMouseDown: function onMouseDown(e) {
            e.preventDefault();
        }
    }, panelNode);
    var suffixNode;
    if (suffixIcon) suffixNode = /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-suffix")
    }, suffixIcon);
    var clearNode;
    if (allowClear && mergedValue && !disabled) clearNode = /*#__PURE__*/ $6fFrj.createElement("span", {
        onMouseDown: function onMouseDown(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        onMouseUp: function onMouseUp(e) {
            e.preventDefault();
            e.stopPropagation();
            triggerChange(null);
            triggerOpen(false);
        },
        className: "".concat(prefixCls, "-clear"),
        role: "button"
    }, clearIcon || /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-clear-btn")
    }));
    var mergedInputProps = (0, $kNxFX.default)((0, $kNxFX.default)((0, $kNxFX.default)({
        id: id,
        tabIndex: tabIndex,
        disabled: disabled,
        readOnly: inputReadOnly || typeof formatList[0] === 'function' || !typing,
        value: hoverValue || text,
        onChange: function onChange(e) {
            triggerTextChange(e.target.value);
        },
        autoFocus: autoFocus,
        placeholder: placeholder,
        ref: inputRef,
        title: text
    }, inputProps), {}, {
        size: (0, $92cb4f3f33042a05$export$c4929e7560bc7c3e)(picker, formatList[0], generateConfig)
    }, (0, $80a563586615a9e1$export$2e2bcd8739ae039)(props)), {}, {
        autoComplete: autoComplete
    });
    var inputNode = inputRender ? inputRender(mergedInputProps) : /*#__PURE__*/ $6fFrj.createElement("input", mergedInputProps);
    // ============================ Return =============================
    var onContextSelect = function onContextSelect(date, type) {
        if (type === 'submit' || type !== 'key' && !needConfirmButton) {
            // triggerChange will also update selected values
            triggerChange(date);
            triggerOpen(false);
        }
    };
    var popupPlacement = direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    return /*#__PURE__*/ $6fFrj.createElement((0, $03d96fa1dbfe5ae5$export$2e2bcd8739ae039).Provider, {
        value: {
            operationRef: operationRef,
            hideHeader: picker === 'time',
            panelRef: panelDivRef,
            onSelect: onContextSelect,
            open: mergedOpen,
            defaultOpenValue: defaultOpenValue,
            onDateMouseEnter: onEnter,
            onDateMouseLeave: onLeave
        }
    }, /*#__PURE__*/ $6fFrj.createElement((0, $cf4fdeb80ffb87d6$export$2e2bcd8739ae039), {
        visible: mergedOpen,
        popupElement: panel,
        popupStyle: popupStyle,
        prefixCls: prefixCls,
        dropdownClassName: dropdownClassName,
        dropdownAlign: dropdownAlign,
        getPopupContainer: getPopupContainer,
        transitionName: transitionName,
        popupPlacement: popupPlacement,
        direction: direction
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className, (_classNames2 = {}, (0, $43449.default)(_classNames2, "".concat(prefixCls, "-disabled"), disabled), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-focused"), focused), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames2)),
        style: style,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onContextMenu: onContextMenu,
        onClick: onInternalClick
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-input"), (0, $43449.default)({}, "".concat(prefixCls, "-input-placeholder"), !!hoverValue)),
        ref: inputDivRef
    }, inputNode, suffixNode, clearNode))));
}
// Wrap with class component to enable pass generic with instance method
var $f715b201770c56f7$var$Picker = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(Picker, _React$Component);
    var _super = (0, $lSufv.default)(Picker);
    function Picker() {
        var _this;
        (0, $kjNeN.default)(this, Picker);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.pickerRef = /*#__PURE__*/ $6fFrj.createRef();
        _this.focus = function() {
            if (_this.pickerRef.current) _this.pickerRef.current.focus();
        };
        _this.blur = function() {
            if (_this.pickerRef.current) _this.pickerRef.current.blur();
        };
        return _this;
    }
    (0, $5KQxu.default)(Picker, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $6fFrj.createElement($f715b201770c56f7$var$InnerPicker, (0, $fIrcP.default)({}, this.props, {
                    pickerRef: this.pickerRef
                }));
            }
        }
    ]);
    return Picker;
}($6fFrj.Component);
var $f715b201770c56f7$export$2e2bcd8739ae039 = $f715b201770c56f7$var$Picker;




var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $fIrcP = parcelRequire("fIrcP");

var $5KhTJ = parcelRequire("5KhTJ");

var $kNxFX = parcelRequire("kNxFX");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $3mXQ2 = parcelRequire("3mXQ2");

var $gfhff = parcelRequire("gfhff");











var $6fFrj = parcelRequire("6fFrj");


function $138dc79cf8327b14$export$2e2bcd8739ae039(_ref, disabledStart, disabledEnd) {
    var picker = _ref.picker, locale = _ref.locale, selectedValue = _ref.selectedValue, disabledDate = _ref.disabledDate, disabled = _ref.disabled, generateConfig = _ref.generateConfig;
    var startDate = (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(selectedValue, 0);
    var endDate = (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(selectedValue, 1);
    function weekFirstDate(date) {
        return generateConfig.locale.getWeekFirstDate(locale.locale, date);
    }
    function monthNumber(date) {
        var year = generateConfig.getYear(date);
        var month = generateConfig.getMonth(date);
        return year * 100 + month;
    }
    function quarterNumber(date) {
        var year = generateConfig.getYear(date);
        var quarter = (0, $69bfe3a3f4b23cc1$export$de90a4bb31c25221)(generateConfig, date);
        return year * 10 + quarter;
    }
    var disabledStartDate = $6fFrj.useCallback(function(date) {
        if (disabledDate && disabledDate(date)) return true;
        // Disabled range
        if (disabled[1] && endDate) return !(0, $69bfe3a3f4b23cc1$export$a8b2a21161763694)(generateConfig, date, endDate) && generateConfig.isAfter(date, endDate);
        // Disabled part
        if (disabledStart && endDate) switch(picker){
            case 'quarter':
                return quarterNumber(date) > quarterNumber(endDate);
            case 'month':
                return monthNumber(date) > monthNumber(endDate);
            case 'week':
                return weekFirstDate(date) > weekFirstDate(endDate);
            default:
                return !(0, $69bfe3a3f4b23cc1$export$a8b2a21161763694)(generateConfig, date, endDate) && generateConfig.isAfter(date, endDate);
        }
        return false;
    }, [
        disabledDate,
        disabled[1],
        endDate,
        disabledStart
    ]);
    var disabledEndDate = $6fFrj.useCallback(function(date) {
        if (disabledDate && disabledDate(date)) return true;
        // Disabled range
        if (disabled[0] && startDate) return !(0, $69bfe3a3f4b23cc1$export$a8b2a21161763694)(generateConfig, date, endDate) && generateConfig.isAfter(startDate, date);
        // Disabled part
        if (disabledEnd && startDate) switch(picker){
            case 'quarter':
                return quarterNumber(date) < quarterNumber(startDate);
            case 'month':
                return monthNumber(date) < monthNumber(startDate);
            case 'week':
                return weekFirstDate(date) < weekFirstDate(startDate);
            default:
                return !(0, $69bfe3a3f4b23cc1$export$a8b2a21161763694)(generateConfig, date, startDate) && generateConfig.isAfter(startDate, date);
        }
        return false;
    }, [
        disabledDate,
        disabled[0],
        startDate,
        disabledEnd
    ]);
    return [
        disabledStartDate,
        disabledEndDate
    ];
}





var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");


function $86ce0ef0656e4acc$var$getStartEndDistance(startDate, endDate, picker, generateConfig) {
    var startNext = (0, $69bfe3a3f4b23cc1$export$d9ec313bf7ad18e1)(startDate, picker, generateConfig, 1);
    function getDistance(compareFunc) {
        if (compareFunc(startDate, endDate)) return 'same';
        if (compareFunc(startNext, endDate)) return 'closing';
        return 'far';
    }
    switch(picker){
        case 'year':
            return getDistance(function(start, end) {
                return (0, $69bfe3a3f4b23cc1$export$22ab546651b3be18)(generateConfig, start, end);
            });
        case 'quarter':
        case 'month':
            return getDistance(function(start, end) {
                return (0, $69bfe3a3f4b23cc1$export$5841f9eb9773f25f)(generateConfig, start, end);
            });
        default:
            return getDistance(function(start, end) {
                return (0, $69bfe3a3f4b23cc1$export$a18c89cbd24170ff)(generateConfig, start, end);
            });
    }
}
function $86ce0ef0656e4acc$var$getRangeViewDate(values, index, picker, generateConfig) {
    var startDate = (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(values, 0);
    var endDate = (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(values, 1);
    if (index === 0) return startDate;
    if (startDate && endDate) {
        var distance = $86ce0ef0656e4acc$var$getStartEndDistance(startDate, endDate, picker, generateConfig);
        switch(distance){
            case 'same':
                return startDate;
            case 'closing':
                return startDate;
            default:
                return (0, $69bfe3a3f4b23cc1$export$d9ec313bf7ad18e1)(endDate, picker, generateConfig, -1);
        }
    }
    return startDate;
}
function $86ce0ef0656e4acc$export$2e2bcd8739ae039(_ref) {
    var values = _ref.values, picker = _ref.picker, defaultDates = _ref.defaultDates, generateConfig = _ref.generateConfig;
    var _React$useState = $6fFrj.useState(function() {
        return [
            (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(defaultDates, 0),
            (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(defaultDates, 1)
        ];
    }), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), defaultViewDates = _React$useState2[0], setDefaultViewDates = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState(null), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), viewDates = _React$useState4[0], setInternalViewDates = _React$useState4[1];
    var startDate = (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(values, 0);
    var endDate = (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(values, 1);
    function getViewDate(index) {
        // If set default view date, use it
        if (defaultViewDates[index]) return defaultViewDates[index];
        return (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(viewDates, index) || $86ce0ef0656e4acc$var$getRangeViewDate(values, index, picker, generateConfig) || startDate || endDate || generateConfig.getNow();
    }
    function setViewDate(viewDate, index) {
        if (viewDate) {
            var newViewDates = (0, $80a563586615a9e1$export$1af566b8db6b8ac2)(viewDates, viewDate, index);
            // Set view date will clean up default one
            setDefaultViewDates(// Should always be an array
            (0, $80a563586615a9e1$export$1af566b8db6b8ac2)(defaultViewDates, null, index) || [
                null,
                null
            ]);
            // Reset another one when not have value
            var anotherIndex = (index + 1) % 2;
            if (!(0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(values, anotherIndex)) newViewDates = (0, $80a563586615a9e1$export$1af566b8db6b8ac2)(newViewDates, viewDate, anotherIndex);
            setInternalViewDates(newViewDates);
        } else if (startDate || endDate) // Reset all when has values when `viewDate` is `null` which means from open trigger
        setInternalViewDates(null);
    }
    return [
        getViewDate,
        setViewDate
    ];
}




function $02c7939a592e021b$var$reorderValues(values, generateConfig) {
    if (values && values[0] && values[1] && generateConfig.isAfter(values[0], values[1])) return [
        values[1],
        values[0]
    ];
    return values;
}
function $02c7939a592e021b$var$canValueTrigger(value, index, disabled, allowEmpty) {
    if (value) return true;
    if (allowEmpty && allowEmpty[index]) return true;
    if (disabled[(index + 1) % 2]) return true;
    return false;
}
function $02c7939a592e021b$var$InnerRangePicker(props) {
    var _classNames2, _classNames3, _classNames4;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-picker' : _props$prefixCls, id = props.id, style = props.style, className = props.className, popupStyle = props.popupStyle, dropdownClassName = props.dropdownClassName, transitionName = props.transitionName, dropdownAlign = props.dropdownAlign, getPopupContainer = props.getPopupContainer, generateConfig = props.generateConfig, locale = props.locale, placeholder = props.placeholder, autoFocus = props.autoFocus, disabled = props.disabled, format = props.format, _props$picker = props.picker, picker = _props$picker === void 0 ? 'date' : _props$picker, showTime = props.showTime, use12Hours = props.use12Hours, _props$separator = props.separator, separator = _props$separator === void 0 ? '~' : _props$separator, value = props.value, defaultValue = props.defaultValue, defaultPickerValue = props.defaultPickerValue, open = props.open, defaultOpen = props.defaultOpen, disabledDate = props.disabledDate, _disabledTime = props.disabledTime, dateRender = props.dateRender, panelRender = props.panelRender, ranges = props.ranges, allowEmpty = props.allowEmpty, allowClear = props.allowClear, suffixIcon = props.suffixIcon, clearIcon = props.clearIcon, pickerRef = props.pickerRef, inputReadOnly = props.inputReadOnly, mode = props.mode, renderExtraFooter = props.renderExtraFooter, onChange = props.onChange, onOpenChange = props.onOpenChange, onPanelChange = props.onPanelChange, onCalendarChange = props.onCalendarChange, _onFocus = props.onFocus, onBlur = props.onBlur, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onClick = props.onClick, _onOk = props.onOk, _onKeyDown = props.onKeyDown, components = props.components, order = props.order, direction = props.direction, activePickerIndex = props.activePickerIndex, _props$autoComplete = props.autoComplete, autoComplete = _props$autoComplete === void 0 ? 'off' : _props$autoComplete;
    var needConfirmButton = picker === 'date' && !!showTime || picker === 'time';
    // We record opened status here in case repeat open with picker
    var openRecordsRef = (0, $6fFrj.useRef)({});
    var containerRef = (0, $6fFrj.useRef)(null);
    var panelDivRef = (0, $6fFrj.useRef)(null);
    var startInputDivRef = (0, $6fFrj.useRef)(null);
    var endInputDivRef = (0, $6fFrj.useRef)(null);
    var separatorRef = (0, $6fFrj.useRef)(null);
    var startInputRef = (0, $6fFrj.useRef)(null);
    var endInputRef = (0, $6fFrj.useRef)(null);
    var arrowRef = (0, $6fFrj.useRef)(null);
    // ============================= Misc ==============================
    var formatList = (0, $80a563586615a9e1$export$45b10814cc054894)((0, $92cb4f3f33042a05$export$3e0385bd234197e6)(format, picker, showTime, use12Hours));
    // Active picker
    var _useMergedState = (0, $gfhff.default)(0, {
        value: activePickerIndex
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), mergedActivePickerIndex = _useMergedState2[0], setMergedActivePickerIndex = _useMergedState2[1];
    // Operation ref
    var operationRef = (0, $6fFrj.useRef)(null);
    var mergedDisabled = $6fFrj.useMemo(function() {
        if (Array.isArray(disabled)) return disabled;
        return [
            disabled || false,
            disabled || false
        ];
    }, [
        disabled
    ]);
    // ============================= Value =============================
    var _useMergedState3 = (0, $gfhff.default)(null, {
        value: value,
        defaultValue: defaultValue,
        postState: function postState(values) {
            return picker === 'time' && !order ? values : $02c7939a592e021b$var$reorderValues(values, generateConfig);
        }
    }), _useMergedState4 = (0, $jP8CL.default)(_useMergedState3, 2), mergedValue = _useMergedState4[0], setInnerValue = _useMergedState4[1];
    // =========================== View Date ===========================
    // Config view panel
    var _useRangeViewDates = (0, $86ce0ef0656e4acc$export$2e2bcd8739ae039)({
        values: mergedValue,
        picker: picker,
        defaultDates: defaultPickerValue,
        generateConfig: generateConfig
    }), _useRangeViewDates2 = (0, $jP8CL.default)(_useRangeViewDates, 2), getViewDate = _useRangeViewDates2[0], setViewDate = _useRangeViewDates2[1];
    // ========================= Select Values =========================
    var _useMergedState5 = (0, $gfhff.default)(mergedValue, {
        postState: function postState(values) {
            var postValues = values;
            if (mergedDisabled[0] && mergedDisabled[1]) return postValues;
            // Fill disabled unit
            for(var i = 0; i < 2; i += 1)if (mergedDisabled[i] && !postValues && !(0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(postValues, i) && !(0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(allowEmpty, i)) postValues = (0, $80a563586615a9e1$export$1af566b8db6b8ac2)(postValues, generateConfig.getNow(), i);
            return postValues;
        }
    }), _useMergedState6 = (0, $jP8CL.default)(_useMergedState5, 2), selectedValue = _useMergedState6[0], setSelectedValue = _useMergedState6[1];
    // ============================= Modes =============================
    var _useMergedState7 = (0, $gfhff.default)([
        picker,
        picker
    ], {
        value: mode
    }), _useMergedState8 = (0, $jP8CL.default)(_useMergedState7, 2), mergedModes = _useMergedState8[0], setInnerModes = _useMergedState8[1];
    (0, $6fFrj.useEffect)(function() {
        setInnerModes([
            picker,
            picker
        ]);
    }, [
        picker
    ]);
    var triggerModesChange = function triggerModesChange(modes, values) {
        setInnerModes(modes);
        if (onPanelChange) onPanelChange(values, modes);
    };
    // ========================= Disable Date ==========================
    var _useRangeDisabled = (0, $138dc79cf8327b14$export$2e2bcd8739ae039)({
        picker: picker,
        selectedValue: selectedValue,
        locale: locale,
        disabled: mergedDisabled,
        disabledDate: disabledDate,
        generateConfig: generateConfig
    }, openRecordsRef.current[1], openRecordsRef.current[0]), _useRangeDisabled2 = (0, $jP8CL.default)(_useRangeDisabled, 2), disabledStartDate = _useRangeDisabled2[0], disabledEndDate = _useRangeDisabled2[1];
    // ============================= Open ==============================
    var _useMergedState9 = (0, $gfhff.default)(false, {
        value: open,
        defaultValue: defaultOpen,
        postState: function postState(postOpen) {
            return mergedDisabled[mergedActivePickerIndex] ? false : postOpen;
        },
        onChange: function onChange(newOpen) {
            if (onOpenChange) onOpenChange(newOpen);
            if (!newOpen && operationRef.current && operationRef.current.onClose) operationRef.current.onClose();
        }
    }), _useMergedState10 = (0, $jP8CL.default)(_useMergedState9, 2), mergedOpen = _useMergedState10[0], triggerInnerOpen = _useMergedState10[1];
    var startOpen = mergedOpen && mergedActivePickerIndex === 0;
    var endOpen = mergedOpen && mergedActivePickerIndex === 1;
    // ============================= Popup =============================
    // Popup min width
    var _useState = (0, $6fFrj.useState)(0), _useState2 = (0, $jP8CL.default)(_useState, 2), popupMinWidth = _useState2[0], setPopupMinWidth = _useState2[1];
    (0, $6fFrj.useEffect)(function() {
        if (!mergedOpen && containerRef.current) setPopupMinWidth(containerRef.current.offsetWidth);
    }, [
        mergedOpen
    ]);
    // ============================ Trigger ============================
    var triggerRef = $6fFrj.useRef();
    function _triggerOpen(newOpen, index) {
        if (newOpen) {
            clearTimeout(triggerRef.current);
            openRecordsRef.current[index] = true;
            setMergedActivePickerIndex(index);
            triggerInnerOpen(newOpen);
            // Open to reset view date
            if (!mergedOpen) setViewDate(null, index);
        } else if (mergedActivePickerIndex === index) {
            triggerInnerOpen(newOpen);
            // Clean up async
            // This makes ref not quick refresh in case user open another input with blur trigger
            var openRecords = openRecordsRef.current;
            triggerRef.current = setTimeout(function() {
                if (openRecords === openRecordsRef.current) openRecordsRef.current = {};
            });
        }
    }
    function triggerOpenAndFocus(index) {
        _triggerOpen(true, index);
        // Use setTimeout to make sure panel DOM exists
        setTimeout(function() {
            var inputRef = [
                startInputRef,
                endInputRef
            ][index];
            if (inputRef.current) inputRef.current.focus();
        }, 0);
    }
    function triggerChange(newValue, sourceIndex) {
        var values = newValue;
        var startValue = (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(values, 0);
        var endValue = (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(values, 1);
        // >>>>> Format start & end values
        if (startValue && endValue && generateConfig.isAfter(startValue, endValue)) {
            if (// WeekPicker only compare week
            picker === 'week' && !(0, $69bfe3a3f4b23cc1$export$6ea683876c36b8d2)(generateConfig, locale.locale, startValue, endValue) || // QuotaPicker only compare week
            picker === 'quarter' && !(0, $69bfe3a3f4b23cc1$export$5c60e4190867161c)(generateConfig, startValue, endValue) || // Other non-TimePicker compare date
            picker !== 'week' && picker !== 'quarter' && picker !== 'time' && !(0, $69bfe3a3f4b23cc1$export$a8b2a21161763694)(generateConfig, startValue, endValue)) {
                // Clean up end date when start date is after end date
                if (sourceIndex === 0) {
                    values = [
                        startValue,
                        null
                    ];
                    endValue = null;
                } else {
                    startValue = null;
                    values = [
                        null,
                        endValue
                    ];
                }
                // Clean up cache since invalidate
                openRecordsRef.current = (0, $43449.default)({}, sourceIndex, true);
            } else if (picker !== 'time' || order !== false) // Reorder when in same date
            values = $02c7939a592e021b$var$reorderValues(values, generateConfig);
        }
        setSelectedValue(values);
        var startStr = values && values[0] ? (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(values[0], {
            generateConfig: generateConfig,
            locale: locale,
            format: formatList[0]
        }) : '';
        var endStr = values && values[1] ? (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(values[1], {
            generateConfig: generateConfig,
            locale: locale,
            format: formatList[0]
        }) : '';
        if (onCalendarChange) {
            var info = {
                range: sourceIndex === 0 ? 'start' : 'end'
            };
            onCalendarChange(values, [
                startStr,
                endStr
            ], info);
        }
        // >>>>> Trigger `onChange` event
        var canStartValueTrigger = $02c7939a592e021b$var$canValueTrigger(startValue, 0, mergedDisabled, allowEmpty);
        var canEndValueTrigger = $02c7939a592e021b$var$canValueTrigger(endValue, 1, mergedDisabled, allowEmpty);
        var canTrigger = values === null || canStartValueTrigger && canEndValueTrigger;
        if (canTrigger) {
            // Trigger onChange only when value is validate
            setInnerValue(values);
            if (onChange && (!(0, $69bfe3a3f4b23cc1$export$248d38f6296296c5)(generateConfig, (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(mergedValue, 0), startValue) || !(0, $69bfe3a3f4b23cc1$export$248d38f6296296c5)(generateConfig, (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(mergedValue, 1), endValue))) onChange(values, [
                startStr,
                endStr
            ]);
        }
        // >>>>> Open picker when
        // Always open another picker if possible
        var nextOpenIndex = null;
        if (sourceIndex === 0 && !mergedDisabled[1]) nextOpenIndex = 1;
        else if (sourceIndex === 1 && !mergedDisabled[0]) nextOpenIndex = 0;
        if (nextOpenIndex !== null && nextOpenIndex !== mergedActivePickerIndex && (!openRecordsRef.current[nextOpenIndex] || !(0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(values, nextOpenIndex)) && (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(values, sourceIndex)) // Delay to focus to avoid input blur trigger expired selectedValues
        triggerOpenAndFocus(nextOpenIndex);
        else _triggerOpen(false, sourceIndex);
    }
    var forwardKeyDown = function forwardKeyDown(e) {
        if (mergedOpen && operationRef.current && operationRef.current.onKeyDown) // Let popup panel handle keyboard
        return operationRef.current.onKeyDown(e);
        (0, $3mXQ2.default)(false, 'Picker not correct forward KeyDown operation. Please help to fire issue about this.');
        return false;
    };
    // ============================= Text ==============================
    var sharedTextHooksProps = {
        formatList: formatList,
        generateConfig: generateConfig,
        locale: locale
    };
    var _useValueTexts = (0, $f47343546dd22f33$export$2e2bcd8739ae039)((0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(selectedValue, 0), sharedTextHooksProps), _useValueTexts2 = (0, $jP8CL.default)(_useValueTexts, 2), startValueTexts = _useValueTexts2[0], firstStartValueText = _useValueTexts2[1];
    var _useValueTexts3 = (0, $f47343546dd22f33$export$2e2bcd8739ae039)((0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(selectedValue, 1), sharedTextHooksProps), _useValueTexts4 = (0, $jP8CL.default)(_useValueTexts3, 2), endValueTexts = _useValueTexts4[0], firstEndValueText = _useValueTexts4[1];
    var _onTextChange = function onTextChange(newText, index) {
        var inputDate = (0, $69bfe3a3f4b23cc1$export$5303528d1070ff6f)(newText, {
            locale: locale,
            formatList: formatList,
            generateConfig: generateConfig
        });
        var disabledFunc = index === 0 ? disabledStartDate : disabledEndDate;
        if (inputDate && !disabledFunc(inputDate)) {
            setSelectedValue((0, $80a563586615a9e1$export$1af566b8db6b8ac2)(selectedValue, inputDate, index));
            setViewDate(inputDate, index);
        }
    };
    var _useTextValueMapping = (0, $da4eef76e2d8760e$export$2e2bcd8739ae039)({
        valueTexts: startValueTexts,
        onTextChange: function onTextChange(newText) {
            return _onTextChange(newText, 0);
        }
    }), _useTextValueMapping2 = (0, $jP8CL.default)(_useTextValueMapping, 3), startText = _useTextValueMapping2[0], triggerStartTextChange = _useTextValueMapping2[1], resetStartText = _useTextValueMapping2[2];
    var _useTextValueMapping3 = (0, $da4eef76e2d8760e$export$2e2bcd8739ae039)({
        valueTexts: endValueTexts,
        onTextChange: function onTextChange(newText) {
            return _onTextChange(newText, 1);
        }
    }), _useTextValueMapping4 = (0, $jP8CL.default)(_useTextValueMapping3, 3), endText = _useTextValueMapping4[0], triggerEndTextChange = _useTextValueMapping4[1], resetEndText = _useTextValueMapping4[2];
    var _useState3 = (0, $6fFrj.useState)(null), _useState4 = (0, $jP8CL.default)(_useState3, 2), rangeHoverValue = _useState4[0], setRangeHoverValue = _useState4[1];
    // ========================== Hover Range ==========================
    var _useState5 = (0, $6fFrj.useState)(null), _useState6 = (0, $jP8CL.default)(_useState5, 2), hoverRangedValue = _useState6[0], setHoverRangedValue = _useState6[1];
    var _useHoverValue = (0, $c2797eaa7b0b38f1$export$2e2bcd8739ae039)(startText, {
        formatList: formatList,
        generateConfig: generateConfig,
        locale: locale
    }), _useHoverValue2 = (0, $jP8CL.default)(_useHoverValue, 3), startHoverValue = _useHoverValue2[0], onStartEnter = _useHoverValue2[1], onStartLeave = _useHoverValue2[2];
    var _useHoverValue3 = (0, $c2797eaa7b0b38f1$export$2e2bcd8739ae039)(endText, {
        formatList: formatList,
        generateConfig: generateConfig,
        locale: locale
    }), _useHoverValue4 = (0, $jP8CL.default)(_useHoverValue3, 3), endHoverValue = _useHoverValue4[0], onEndEnter = _useHoverValue4[1], onEndLeave = _useHoverValue4[2];
    var onDateMouseEnter = function onDateMouseEnter(date) {
        setHoverRangedValue((0, $80a563586615a9e1$export$1af566b8db6b8ac2)(selectedValue, date, mergedActivePickerIndex));
        if (mergedActivePickerIndex === 0) onStartEnter(date);
        else onEndEnter(date);
    };
    var onDateMouseLeave = function onDateMouseLeave() {
        setHoverRangedValue((0, $80a563586615a9e1$export$1af566b8db6b8ac2)(selectedValue, null, mergedActivePickerIndex));
        if (mergedActivePickerIndex === 0) onStartLeave();
        else onEndLeave();
    };
    // ============================= Input =============================
    var getSharedInputHookProps = function getSharedInputHookProps(index, resetText) {
        return {
            blurToCancel: needConfirmButton,
            forwardKeyDown: forwardKeyDown,
            onBlur: onBlur,
            isClickOutside: function isClickOutside(target) {
                return !(0, $92cb4f3f33042a05$export$9350e4ea4b8364)([
                    panelDivRef.current,
                    startInputDivRef.current,
                    endInputDivRef.current,
                    containerRef.current
                ], target);
            },
            onFocus: function onFocus(e) {
                setMergedActivePickerIndex(index);
                if (_onFocus) _onFocus(e);
            },
            triggerOpen: function triggerOpen(newOpen) {
                _triggerOpen(newOpen, index);
            },
            onSubmit: function onSubmit() {
                if (// When user typing disabledDate with keyboard and enter, this value will be empty
                !selectedValue || // Normal disabled check
                disabledDate && disabledDate(selectedValue[index])) return false;
                triggerChange(selectedValue, index);
                resetText();
            },
            onCancel: function onCancel() {
                _triggerOpen(false, index);
                setSelectedValue(mergedValue);
                resetText();
            }
        };
    };
    var currentFocusedKey = (0, $6fFrj.useRef)('');
    var _usePickerInput = (0, $23d3f8e3416f930f$export$2e2bcd8739ae039)((0, $kNxFX.default)((0, $kNxFX.default)({}, getSharedInputHookProps(0, resetStartText)), {}, {
        open: startOpen,
        value: startText,
        currentFocusedKey: currentFocusedKey,
        key: 'start',
        onKeyDown: function onKeyDown(e, preventDefault) {
            _onKeyDown === null || _onKeyDown === void 0 || _onKeyDown(e, preventDefault);
        }
    })), _usePickerInput2 = (0, $jP8CL.default)(_usePickerInput, 2), startInputProps = _usePickerInput2[0], _usePickerInput2$ = _usePickerInput2[1], startFocused = _usePickerInput2$.focused, startTyping = _usePickerInput2$.typing;
    var _usePickerInput3 = (0, $23d3f8e3416f930f$export$2e2bcd8739ae039)((0, $kNxFX.default)((0, $kNxFX.default)({}, getSharedInputHookProps(1, resetEndText)), {}, {
        open: endOpen,
        value: endText,
        currentFocusedKey: currentFocusedKey,
        key: 'end',
        onKeyDown: function onKeyDown(e, preventDefault) {
            _onKeyDown === null || _onKeyDown === void 0 || _onKeyDown(e, preventDefault);
        }
    })), _usePickerInput4 = (0, $jP8CL.default)(_usePickerInput3, 2), endInputProps = _usePickerInput4[0], _usePickerInput4$ = _usePickerInput4[1], endFocused = _usePickerInput4$.focused, endTyping = _usePickerInput4$.typing;
    // ========================== Click Picker ==========================
    var onPickerClick = function onPickerClick(e) {
        // When click inside the picker & outside the picker's input elements
        // the panel should still be opened
        if (onClick) onClick(e);
        if (!mergedOpen && !startInputRef.current.contains(e.target) && !endInputRef.current.contains(e.target)) {
            if (!mergedDisabled[0]) triggerOpenAndFocus(0);
            else if (!mergedDisabled[1]) triggerOpenAndFocus(1);
        }
    };
    var onPickerMouseDown = function onPickerMouseDown(e) {
        // shouldn't affect input elements if picker is active
        if (onMouseDown) onMouseDown(e);
        if (mergedOpen && (startFocused || endFocused) && !startInputRef.current.contains(e.target) && !endInputRef.current.contains(e.target)) e.preventDefault();
    };
    // ============================= Sync ==============================
    // Close should sync back with text value
    var startStr = mergedValue && mergedValue[0] ? (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(mergedValue[0], {
        locale: locale,
        format: 'YYYYMMDDHHmmss',
        generateConfig: generateConfig
    }) : '';
    var endStr = mergedValue && mergedValue[1] ? (0, $69bfe3a3f4b23cc1$export$7c4d25c0c3217d8c)(mergedValue[1], {
        locale: locale,
        format: 'YYYYMMDDHHmmss',
        generateConfig: generateConfig
    }) : '';
    (0, $6fFrj.useEffect)(function() {
        if (!mergedOpen) {
            setSelectedValue(mergedValue);
            if (!startValueTexts.length || startValueTexts[0] === '') triggerStartTextChange('');
            else if (firstStartValueText !== startText) resetStartText();
            if (!endValueTexts.length || endValueTexts[0] === '') triggerEndTextChange('');
            else if (firstEndValueText !== endText) resetEndText();
        }
    }, [
        mergedOpen,
        startValueTexts,
        endValueTexts
    ]);
    // Sync innerValue with control mode
    (0, $6fFrj.useEffect)(function() {
        setSelectedValue(mergedValue);
    }, [
        startStr,
        endStr
    ]);
    // ============================ Private ============================
    if (pickerRef) pickerRef.current = {
        focus: function focus() {
            if (startInputRef.current) startInputRef.current.focus();
        },
        blur: function blur() {
            if (startInputRef.current) startInputRef.current.blur();
            if (endInputRef.current) endInputRef.current.blur();
        }
    };
    // ============================ Ranges =============================
    var rangeLabels = Object.keys(ranges || {});
    var rangeList = rangeLabels.map(function(label) {
        var range = ranges[label];
        var newValues = typeof range === 'function' ? range() : range;
        return {
            label: label,
            onClick: function onClick() {
                triggerChange(newValues, null);
                _triggerOpen(false, mergedActivePickerIndex);
            },
            onMouseEnter: function onMouseEnter() {
                setRangeHoverValue(newValues);
            },
            onMouseLeave: function onMouseLeave() {
                setRangeHoverValue(null);
            }
        };
    });
    // ============================= Panel =============================
    function renderPanel() {
        var panelPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var panelProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var panelHoverRangedValue = null;
        if (mergedOpen && hoverRangedValue && hoverRangedValue[0] && hoverRangedValue[1] && generateConfig.isAfter(hoverRangedValue[1], hoverRangedValue[0])) panelHoverRangedValue = hoverRangedValue;
        var panelShowTime = showTime;
        if (showTime && (0, $5KhTJ.default)(showTime) === 'object' && showTime.defaultValue) {
            var timeDefaultValues = showTime.defaultValue;
            panelShowTime = (0, $kNxFX.default)((0, $kNxFX.default)({}, showTime), {}, {
                defaultValue: (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(timeDefaultValues, mergedActivePickerIndex) || undefined
            });
        }
        var panelDateRender = null;
        if (dateRender) panelDateRender = function panelDateRender(date, today) {
            return dateRender(date, today, {
                range: mergedActivePickerIndex ? 'end' : 'start'
            });
        };
        return /*#__PURE__*/ $6fFrj.createElement((0, $612ffa32a7ba0396$export$2e2bcd8739ae039).Provider, {
            value: {
                inRange: true,
                panelPosition: panelPosition,
                rangedValue: rangeHoverValue || selectedValue,
                hoverRangedValue: panelHoverRangedValue
            }
        }, /*#__PURE__*/ $6fFrj.createElement((0, $198a41f58792240c$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, panelProps, {
            dateRender: panelDateRender,
            showTime: panelShowTime,
            mode: mergedModes[mergedActivePickerIndex],
            generateConfig: generateConfig,
            style: undefined,
            direction: direction,
            disabledDate: mergedActivePickerIndex === 0 ? disabledStartDate : disabledEndDate,
            disabledTime: function disabledTime(date) {
                if (_disabledTime) return _disabledTime(date, mergedActivePickerIndex === 0 ? 'start' : 'end');
                return false;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)({}, "".concat(prefixCls, "-panel-focused"), mergedActivePickerIndex === 0 ? !startTyping : !endTyping)),
            value: (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(selectedValue, mergedActivePickerIndex),
            locale: locale,
            tabIndex: -1,
            onPanelChange: function onPanelChange(date, newMode) {
                // clear hover value when panel change
                if (mergedActivePickerIndex === 0) onStartLeave(true);
                if (mergedActivePickerIndex === 1) onEndLeave(true);
                triggerModesChange((0, $80a563586615a9e1$export$1af566b8db6b8ac2)(mergedModes, newMode, mergedActivePickerIndex), (0, $80a563586615a9e1$export$1af566b8db6b8ac2)(selectedValue, date, mergedActivePickerIndex));
                var viewDate = date;
                if (panelPosition === 'right' && mergedModes[mergedActivePickerIndex] === newMode) viewDate = (0, $69bfe3a3f4b23cc1$export$d9ec313bf7ad18e1)(viewDate, newMode, generateConfig, -1);
                setViewDate(viewDate, mergedActivePickerIndex);
            },
            onOk: null,
            onSelect: undefined,
            onChange: undefined,
            defaultValue: mergedActivePickerIndex === 0 ? (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(selectedValue, 1) : (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(selectedValue, 0)
        })));
    }
    var arrowLeft = 0;
    var panelLeft = 0;
    if (mergedActivePickerIndex && startInputDivRef.current && separatorRef.current && panelDivRef.current) {
        // Arrow offset
        arrowLeft = startInputDivRef.current.offsetWidth + separatorRef.current.offsetWidth;
        // If panelWidth - arrowWidth - arrowMarginLeft < arrowLeft, panel should move to right side.
        // If arrowOffsetLeft > arrowLeft, arrowMarginLeft = arrowOffsetLeft - arrowLeft
        var arrowMarginLeft = arrowRef.current.offsetLeft > arrowLeft ? arrowRef.current.offsetLeft - arrowLeft : arrowRef.current.offsetLeft;
        if (panelDivRef.current.offsetWidth && arrowRef.current.offsetWidth && arrowLeft > panelDivRef.current.offsetWidth - arrowRef.current.offsetWidth - (direction === 'rtl' ? 0 : arrowMarginLeft)) panelLeft = arrowLeft;
    }
    var arrowPositionStyle = direction === 'rtl' ? {
        right: arrowLeft
    } : {
        left: arrowLeft
    };
    function renderPanels() {
        var panels;
        var extraNode = (0, $552933cde41046e6$export$2e2bcd8739ae039)(prefixCls, mergedModes[mergedActivePickerIndex], renderExtraFooter);
        var rangesNode = (0, $53ea13bd8b354d62$export$2e2bcd8739ae039)({
            prefixCls: prefixCls,
            components: components,
            needConfirmButton: needConfirmButton,
            okDisabled: !(0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(selectedValue, mergedActivePickerIndex) || disabledDate && disabledDate(selectedValue[mergedActivePickerIndex]),
            locale: locale,
            rangeList: rangeList,
            onOk: function onOk() {
                if ((0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(selectedValue, mergedActivePickerIndex)) {
                    // triggerChangeOld(selectedValue);
                    triggerChange(selectedValue, mergedActivePickerIndex);
                    if (_onOk) _onOk(selectedValue);
                }
            }
        });
        if (picker !== 'time' && !showTime) {
            var viewDate = getViewDate(mergedActivePickerIndex);
            var nextViewDate = (0, $69bfe3a3f4b23cc1$export$d9ec313bf7ad18e1)(viewDate, picker, generateConfig);
            var currentMode = mergedModes[mergedActivePickerIndex];
            var showDoublePanel = currentMode === picker;
            var leftPanel = renderPanel(showDoublePanel ? 'left' : false, {
                pickerValue: viewDate,
                onPickerValueChange: function onPickerValueChange(newViewDate) {
                    setViewDate(newViewDate, mergedActivePickerIndex);
                }
            });
            var rightPanel = renderPanel('right', {
                pickerValue: nextViewDate,
                onPickerValueChange: function onPickerValueChange(newViewDate) {
                    setViewDate((0, $69bfe3a3f4b23cc1$export$d9ec313bf7ad18e1)(newViewDate, picker, generateConfig, -1), mergedActivePickerIndex);
                }
            });
            if (direction === 'rtl') panels = /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, rightPanel, showDoublePanel && leftPanel);
            else panels = /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, leftPanel, showDoublePanel && rightPanel);
        } else panels = renderPanel();
        var mergedNodes = /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-panels")
        }, panels), (extraNode || rangesNode) && /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-footer")
        }, extraNode, rangesNode));
        if (panelRender) mergedNodes = panelRender(mergedNodes);
        return /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-panel-container"),
            style: {
                marginLeft: panelLeft
            },
            ref: panelDivRef,
            onMouseDown: function onMouseDown(e) {
                e.preventDefault();
            }
        }, mergedNodes);
    }
    var rangePanel = /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-range-wrapper"), "".concat(prefixCls, "-").concat(picker, "-range-wrapper")),
        style: {
            minWidth: popupMinWidth
        }
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        ref: arrowRef,
        className: "".concat(prefixCls, "-range-arrow"),
        style: arrowPositionStyle
    }), renderPanels());
    // ============================= Icons =============================
    var suffixNode;
    if (suffixIcon) suffixNode = /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-suffix")
    }, suffixIcon);
    var clearNode;
    if (allowClear && ((0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(mergedValue, 0) && !mergedDisabled[0] || (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(mergedValue, 1) && !mergedDisabled[1])) clearNode = /*#__PURE__*/ $6fFrj.createElement("span", {
        onMouseDown: function onMouseDown(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        onMouseUp: function onMouseUp(e) {
            e.preventDefault();
            e.stopPropagation();
            var values = mergedValue;
            if (!mergedDisabled[0]) values = (0, $80a563586615a9e1$export$1af566b8db6b8ac2)(values, null, 0);
            if (!mergedDisabled[1]) values = (0, $80a563586615a9e1$export$1af566b8db6b8ac2)(values, null, 1);
            triggerChange(values, null);
            _triggerOpen(false, mergedActivePickerIndex);
        },
        className: "".concat(prefixCls, "-clear")
    }, clearIcon || /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-clear-btn")
    }));
    var inputSharedProps = {
        size: (0, $92cb4f3f33042a05$export$c4929e7560bc7c3e)(picker, formatList[0], generateConfig)
    };
    var activeBarLeft = 0;
    var activeBarWidth = 0;
    if (startInputDivRef.current && endInputDivRef.current && separatorRef.current) {
        if (mergedActivePickerIndex === 0) activeBarWidth = startInputDivRef.current.offsetWidth;
        else {
            activeBarLeft = arrowLeft;
            activeBarWidth = endInputDivRef.current.offsetWidth;
        }
    }
    var activeBarPositionStyle = direction === 'rtl' ? {
        right: activeBarLeft
    } : {
        left: activeBarLeft
    };
    // ============================ Return =============================
    var onContextSelect = function onContextSelect(date, type) {
        var values = (0, $80a563586615a9e1$export$1af566b8db6b8ac2)(selectedValue, date, mergedActivePickerIndex);
        if (type === 'submit' || type !== 'key' && !needConfirmButton) {
            // triggerChange will also update selected values
            triggerChange(values, mergedActivePickerIndex);
            // clear hover value style
            if (mergedActivePickerIndex === 0) onStartLeave();
            else onEndLeave();
        } else setSelectedValue(values);
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $03d96fa1dbfe5ae5$export$2e2bcd8739ae039).Provider, {
        value: {
            operationRef: operationRef,
            hideHeader: picker === 'time',
            onDateMouseEnter: onDateMouseEnter,
            onDateMouseLeave: onDateMouseLeave,
            hideRanges: true,
            onSelect: onContextSelect,
            open: mergedOpen
        }
    }, /*#__PURE__*/ $6fFrj.createElement((0, $cf4fdeb80ffb87d6$export$2e2bcd8739ae039), {
        visible: mergedOpen,
        popupElement: rangePanel,
        popupStyle: popupStyle,
        prefixCls: prefixCls,
        dropdownClassName: dropdownClassName,
        dropdownAlign: dropdownAlign,
        getPopupContainer: getPopupContainer,
        transitionName: transitionName,
        range: true,
        direction: direction
    }, /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-range"), className, (_classNames2 = {}, (0, $43449.default)(_classNames2, "".concat(prefixCls, "-disabled"), mergedDisabled[0] && mergedDisabled[1]), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-focused"), mergedActivePickerIndex === 0 ? startFocused : endFocused), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames2)),
        style: style,
        onClick: onPickerClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onPickerMouseDown,
        onMouseUp: onMouseUp
    }, (0, $80a563586615a9e1$export$2e2bcd8739ae039)(props)), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-input"), (_classNames3 = {}, (0, $43449.default)(_classNames3, "".concat(prefixCls, "-input-active"), mergedActivePickerIndex === 0), (0, $43449.default)(_classNames3, "".concat(prefixCls, "-input-placeholder"), !!startHoverValue), _classNames3)),
        ref: startInputDivRef
    }, /*#__PURE__*/ $6fFrj.createElement("input", (0, $fIrcP.default)({
        id: id,
        disabled: mergedDisabled[0],
        readOnly: inputReadOnly || typeof formatList[0] === 'function' || !startTyping,
        value: startHoverValue || startText,
        onChange: function onChange(e) {
            triggerStartTextChange(e.target.value);
        },
        autoFocus: autoFocus,
        placeholder: (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(placeholder, 0) || '',
        ref: startInputRef
    }, startInputProps, inputSharedProps, {
        autoComplete: autoComplete
    }))), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-range-separator"),
        ref: separatorRef
    }, separator), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-input"), (_classNames4 = {}, (0, $43449.default)(_classNames4, "".concat(prefixCls, "-input-active"), mergedActivePickerIndex === 1), (0, $43449.default)(_classNames4, "".concat(prefixCls, "-input-placeholder"), !!endHoverValue), _classNames4)),
        ref: endInputDivRef
    }, /*#__PURE__*/ $6fFrj.createElement("input", (0, $fIrcP.default)({
        disabled: mergedDisabled[1],
        readOnly: inputReadOnly || typeof formatList[0] === 'function' || !endTyping,
        value: endHoverValue || endText,
        onChange: function onChange(e) {
            triggerEndTextChange(e.target.value);
        },
        placeholder: (0, $80a563586615a9e1$export$bf7199a9ebcb84a9)(placeholder, 1) || '',
        ref: endInputRef
    }, endInputProps, inputSharedProps, {
        autoComplete: autoComplete
    }))), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-active-bar"),
        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, activeBarPositionStyle), {}, {
            width: activeBarWidth,
            position: 'absolute'
        })
    }), suffixNode, clearNode)));
}
// Wrap with class component to enable pass generic with instance method
var $02c7939a592e021b$var$RangePicker = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(RangePicker, _React$Component);
    var _super = (0, $lSufv.default)(RangePicker);
    function RangePicker() {
        var _this;
        (0, $kjNeN.default)(this, RangePicker);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.pickerRef = /*#__PURE__*/ $6fFrj.createRef();
        _this.focus = function() {
            if (_this.pickerRef.current) _this.pickerRef.current.focus();
        };
        _this.blur = function() {
            if (_this.pickerRef.current) _this.pickerRef.current.blur();
        };
        return _this;
    }
    (0, $5KQxu.default)(RangePicker, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $6fFrj.createElement($02c7939a592e021b$var$InnerRangePicker, (0, $fIrcP.default)({}, this.props, {
                    pickerRef: this.pickerRef
                }));
            }
        }
    ]);
    return RangePicker;
}($6fFrj.Component);
var $02c7939a592e021b$export$2e2bcd8739ae039 = $02c7939a592e021b$var$RangePicker;


var $5dd1f2de52ed40c4$export$2e2bcd8739ae039 = (0, $f715b201770c56f7$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");








var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");

var $d372c831fd1c9007$var$InputStatuses = (0, $cacd97b96801cebe$export$65e3907585753458)('warning', 'error', '');
function $d372c831fd1c9007$export$b08e7b47149942a2(prefixCls, status, hasFeedback) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-status-success"), status === 'success'), "".concat(prefixCls, "-status-warning"), status === 'warning'), "".concat(prefixCls, "-status-error"), status === 'error'), "".concat(prefixCls, "-status-validating"), status === 'validating'), "".concat(prefixCls, "-has-feedback"), hasFeedback));
}
var $d372c831fd1c9007$export$314e193082d7ba49 = function getMergedStatus(contextStatus, customStatus) {
    return customStatus || contextStatus;
};



function $d0f069ca8d476c10$export$d3f5c5e0a5023fa0(picker, locale, customizePlaceholder) {
    if (customizePlaceholder !== undefined) return customizePlaceholder;
    if (picker === 'year' && locale.lang.yearPlaceholder) return locale.lang.yearPlaceholder;
    if (picker === 'quarter' && locale.lang.quarterPlaceholder) return locale.lang.quarterPlaceholder;
    if (picker === 'month' && locale.lang.monthPlaceholder) return locale.lang.monthPlaceholder;
    if (picker === 'week' && locale.lang.weekPlaceholder) return locale.lang.weekPlaceholder;
    if (picker === 'time' && locale.timePickerLocale.placeholder) return locale.timePickerLocale.placeholder;
    return locale.lang.placeholder;
}
function $d0f069ca8d476c10$export$9793711a144eaeae(picker, locale, customizePlaceholder) {
    if (customizePlaceholder !== undefined) return customizePlaceholder;
    if (picker === 'year' && locale.lang.yearPlaceholder) return locale.lang.rangeYearPlaceholder;
    if (picker === 'quarter' && locale.lang.quarterPlaceholder) return locale.lang.rangeQuarterPlaceholder;
    if (picker === 'month' && locale.lang.monthPlaceholder) return locale.lang.rangeMonthPlaceholder;
    if (picker === 'week' && locale.lang.weekPlaceholder) return locale.lang.rangeWeekPlaceholder;
    if (picker === 'time' && locale.timePickerLocale.placeholder) return locale.timePickerLocale.rangePlaceholder;
    return locale.lang.rangePlaceholder;
}
function $d0f069ca8d476c10$export$eb66ca17c6a72c49(direction, placement) {
    var overflow = {
        adjustX: 1,
        adjustY: 1
    };
    switch(placement){
        case 'bottomLeft':
            return {
                points: [
                    'tl',
                    'bl'
                ],
                offset: [
                    0,
                    4
                ],
                overflow: overflow
            };
        case 'bottomRight':
            return {
                points: [
                    'tr',
                    'br'
                ],
                offset: [
                    0,
                    4
                ],
                overflow: overflow
            };
        case 'topLeft':
            return {
                points: [
                    'bl',
                    'tl'
                ],
                offset: [
                    0,
                    -4
                ],
                overflow: overflow
            };
        case 'topRight':
            return {
                points: [
                    'br',
                    'tr'
                ],
                offset: [
                    0,
                    -4
                ],
                overflow: overflow
            };
        default:
            return {
                points: direction === 'rtl' ? [
                    'tr',
                    'br'
                ] : [
                    'tl',
                    'bl'
                ],
                offset: [
                    0,
                    4
                ],
                overflow: overflow
            };
    }
}



var $64041e3fd42e0639$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $64041e3fd42e0639$export$2e2bcd8739ae039(generateConfig) {
    var RangePicker = /*#__PURE__*/ (0, $6fFrj.forwardRef)(function(props, ref) {
        var customizePrefixCls = props.prefixCls, customGetPopupContainer = props.getPopupContainer, className = props.className, placement = props.placement, customizeSize = props.size, customDisabled = props.disabled, _props$bordered = props.bordered, bordered = _props$bordered === void 0 ? true : _props$bordered, placeholder = props.placeholder, popupClassName = props.popupClassName, dropdownClassName = props.dropdownClassName, customStatus = props.status, restProps = $64041e3fd42e0639$var$__rest(props, [
            "prefixCls",
            "getPopupContainer",
            "className",
            "placement",
            "size",
            "disabled",
            "bordered",
            "placeholder",
            "popupClassName",
            "dropdownClassName",
            "status"
        ]);
        var innerRef = $6fFrj.useRef(null);
        var _useContext = (0, $6fFrj.useContext)((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext.getPrefixCls, direction = _useContext.direction, getPopupContainer = _useContext.getPopupContainer;
        var prefixCls = getPrefixCls('picker', customizePrefixCls);
        var _useCompactItemContex = (0, $87f4fe035d0a15fd$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
        var format = props.format, showTime = props.showTime, picker = props.picker;
        var rootPrefixCls = getPrefixCls();
        var additionalOverrideProps = {};
        additionalOverrideProps = (0, $fIrcP.default)((0, $fIrcP.default)((0, $fIrcP.default)({}, additionalOverrideProps), showTime ? (0, $ba1749f2af0731c1$export$6c7e3619a08d795a)((0, $fIrcP.default)({
            format: format,
            picker: picker
        }, showTime)) : {}), picker === 'time' ? (0, $ba1749f2af0731c1$export$6c7e3619a08d795a)((0, $fIrcP.default)((0, $fIrcP.default)({
            format: format
        }, props), {
            picker: picker
        })) : {});
        // ===================== Size =====================
        var size = $6fFrj.useContext((0, $aefad26b74860b7e$export$2e2bcd8739ae039));
        var mergedSize = compactSize || customizeSize || size;
        // ===================== Disabled =====================
        var disabled = $6fFrj.useContext((0, $3880af76d17f94a3$export$2e2bcd8739ae039));
        var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
        // ===================== FormItemInput =====================
        var formItemContext = (0, $6fFrj.useContext)((0, $76d69cb8326089c6$export$bbb5553c6c7a14ed));
        var hasFeedback = formItemContext.hasFeedback, contextStatus = formItemContext.status, feedbackIcon = formItemContext.feedbackIcon;
        var suffixNode = /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, picker === 'time' ? /*#__PURE__*/ $6fFrj.createElement((0, $9824e6cb0e907529$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $6fFrj.createElement((0, $2c8de0c8eaf4f5c0$export$2e2bcd8739ae039), null), hasFeedback && feedbackIcon);
        (0, $6fFrj.useImperativeHandle)(ref, function() {
            return {
                focus: function focus() {
                    var _a;
                    return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                },
                blur: function blur() {
                    var _a;
                    return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                }
            };
        });
        return /*#__PURE__*/ $6fFrj.createElement((0, $d37c6ecde78f75e8$export$2e2bcd8739ae039), {
            componentName: "DatePicker",
            defaultLocale: (0, $e0bfb08c543235f2$export$2e2bcd8739ae039)
        }, function(contextLocale) {
            var locale = (0, $fIrcP.default)((0, $fIrcP.default)({}, contextLocale), props.locale);
            return /*#__PURE__*/ $6fFrj.createElement((0, $02c7939a592e021b$export$2e2bcd8739ae039), (0, $fIrcP.default)({
                separator: /*#__PURE__*/ $6fFrj.createElement("span", {
                    "aria-label": "to",
                    className: "".concat(prefixCls, "-separator")
                }, /*#__PURE__*/ $6fFrj.createElement((0, $f945346b4a79c805$export$2e2bcd8739ae039), null)),
                disabled: mergedDisabled,
                ref: innerRef,
                dropdownAlign: (0, $d0f069ca8d476c10$export$eb66ca17c6a72c49)(direction, placement),
                placeholder: (0, $d0f069ca8d476c10$export$9793711a144eaeae)(picker, locale, placeholder),
                suffixIcon: suffixNode,
                clearIcon: /*#__PURE__*/ $6fFrj.createElement((0, $9429a61ddf5bc264$export$2e2bcd8739ae039), null),
                prevIcon: /*#__PURE__*/ $6fFrj.createElement("span", {
                    className: "".concat(prefixCls, "-prev-icon")
                }),
                nextIcon: /*#__PURE__*/ $6fFrj.createElement("span", {
                    className: "".concat(prefixCls, "-next-icon")
                }),
                superPrevIcon: /*#__PURE__*/ $6fFrj.createElement("span", {
                    className: "".concat(prefixCls, "-super-prev-icon")
                }),
                superNextIcon: /*#__PURE__*/ $6fFrj.createElement("span", {
                    className: "".concat(prefixCls, "-super-next-icon")
                }),
                allowClear: true,
                transitionName: "".concat(rootPrefixCls, "-slide-up")
            }, restProps, additionalOverrideProps, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-").concat(mergedSize), mergedSize), "".concat(prefixCls, "-borderless"), !bordered), (0, $d372c831fd1c9007$export$b08e7b47149942a2)(prefixCls, (0, $d372c831fd1c9007$export$314e193082d7ba49)(contextStatus, customStatus), hasFeedback), compactItemClassnames, className),
                locale: locale.lang,
                prefixCls: prefixCls,
                getPopupContainer: customGetPopupContainer || getPopupContainer,
                generateConfig: generateConfig,
                components: (0, $ba1749f2af0731c1$export$cdb8a2fe02a819d9),
                direction: direction,
                dropdownClassName: popupClassName || dropdownClassName
            }));
        });
    });
    return RangePicker;
}



var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");




var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");











var $23187350293a3e99$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $23187350293a3e99$export$2e2bcd8739ae039(generateConfig) {
    function getPicker(picker, displayName) {
        var Picker = /*#__PURE__*/ (0, $6fFrj.forwardRef)(function(props, ref) {
            var customizePrefixCls = props.prefixCls, customizeGetPopupContainer = props.getPopupContainer, className = props.className, customizeSize = props.size, _props$bordered = props.bordered, bordered = _props$bordered === void 0 ? true : _props$bordered, placement = props.placement, placeholder = props.placeholder, popupClassName = props.popupClassName, dropdownClassName = props.dropdownClassName, customDisabled = props.disabled, customStatus = props.status, restProps = $23187350293a3e99$var$__rest(props, [
                "prefixCls",
                "getPopupContainer",
                "className",
                "size",
                "bordered",
                "placement",
                "placeholder",
                "popupClassName",
                "dropdownClassName",
                "disabled",
                "status"
            ]);
            var _useContext = (0, $6fFrj.useContext)((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext.getPrefixCls, direction = _useContext.direction, getPopupContainer = _useContext.getPopupContainer;
            var prefixCls = getPrefixCls('picker', customizePrefixCls);
            var _useCompactItemContex = (0, $87f4fe035d0a15fd$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
            var innerRef = $6fFrj.useRef(null);
            var format = props.format, showTime = props.showTime;
            (0, $6fFrj.useImperativeHandle)(ref, function() {
                return {
                    focus: function focus() {
                        var _a;
                        return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    },
                    blur: function blur() {
                        var _a;
                        return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                    }
                };
            });
            var additionalProps = {
                showToday: true
            };
            var additionalOverrideProps = {};
            if (picker) additionalOverrideProps.picker = picker;
            var mergedPicker = picker || props.picker;
            additionalOverrideProps = (0, $fIrcP.default)((0, $fIrcP.default)((0, $fIrcP.default)({}, additionalOverrideProps), showTime ? (0, $ba1749f2af0731c1$export$6c7e3619a08d795a)((0, $fIrcP.default)({
                format: format,
                picker: mergedPicker
            }, showTime)) : {}), mergedPicker === 'time' ? (0, $ba1749f2af0731c1$export$6c7e3619a08d795a)((0, $fIrcP.default)((0, $fIrcP.default)({
                format: format
            }, props), {
                picker: mergedPicker
            })) : {});
            var rootPrefixCls = getPrefixCls();
            // ===================== Size =====================
            var size = $6fFrj.useContext((0, $aefad26b74860b7e$export$2e2bcd8739ae039));
            var mergedSize = compactSize || customizeSize || size;
            // ===================== Disabled =====================
            var disabled = $6fFrj.useContext((0, $3880af76d17f94a3$export$2e2bcd8739ae039));
            var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
            // ===================== FormItemInput =====================
            var formItemContext = (0, $6fFrj.useContext)((0, $76d69cb8326089c6$export$bbb5553c6c7a14ed));
            var hasFeedback = formItemContext.hasFeedback, contextStatus = formItemContext.status, feedbackIcon = formItemContext.feedbackIcon;
            var suffixNode = /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, mergedPicker === 'time' ? /*#__PURE__*/ $6fFrj.createElement((0, $9824e6cb0e907529$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $6fFrj.createElement((0, $2c8de0c8eaf4f5c0$export$2e2bcd8739ae039), null), hasFeedback && feedbackIcon);
            return /*#__PURE__*/ $6fFrj.createElement((0, $d37c6ecde78f75e8$export$2e2bcd8739ae039), {
                componentName: "DatePicker",
                defaultLocale: (0, $e0bfb08c543235f2$export$2e2bcd8739ae039)
            }, function(contextLocale) {
                var locale = (0, $fIrcP.default)((0, $fIrcP.default)({}, contextLocale), props.locale);
                return /*#__PURE__*/ $6fFrj.createElement((0, $5dd1f2de52ed40c4$export$2e2bcd8739ae039), (0, $fIrcP.default)({
                    ref: innerRef,
                    placeholder: (0, $d0f069ca8d476c10$export$d3f5c5e0a5023fa0)(mergedPicker, locale, placeholder),
                    suffixIcon: suffixNode,
                    dropdownAlign: (0, $d0f069ca8d476c10$export$eb66ca17c6a72c49)(direction, placement),
                    clearIcon: /*#__PURE__*/ $6fFrj.createElement((0, $9429a61ddf5bc264$export$2e2bcd8739ae039), null),
                    prevIcon: /*#__PURE__*/ $6fFrj.createElement("span", {
                        className: "".concat(prefixCls, "-prev-icon")
                    }),
                    nextIcon: /*#__PURE__*/ $6fFrj.createElement("span", {
                        className: "".concat(prefixCls, "-next-icon")
                    }),
                    superPrevIcon: /*#__PURE__*/ $6fFrj.createElement("span", {
                        className: "".concat(prefixCls, "-super-prev-icon")
                    }),
                    superNextIcon: /*#__PURE__*/ $6fFrj.createElement("span", {
                        className: "".concat(prefixCls, "-super-next-icon")
                    }),
                    allowClear: true,
                    transitionName: "".concat(rootPrefixCls, "-slide-up")
                }, additionalProps, restProps, additionalOverrideProps, {
                    locale: locale.lang,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-").concat(mergedSize), mergedSize), "".concat(prefixCls, "-borderless"), !bordered), (0, $d372c831fd1c9007$export$b08e7b47149942a2)(prefixCls, (0, $d372c831fd1c9007$export$314e193082d7ba49)(contextStatus, customStatus), hasFeedback), compactItemClassnames, className),
                    prefixCls: prefixCls,
                    getPopupContainer: customizeGetPopupContainer || getPopupContainer,
                    generateConfig: generateConfig,
                    components: (0, $ba1749f2af0731c1$export$cdb8a2fe02a819d9),
                    direction: direction,
                    disabled: mergedDisabled,
                    dropdownClassName: popupClassName || dropdownClassName
                }));
            });
        });
        if (displayName) Picker.displayName = displayName;
        return Picker;
    }
    var DatePicker = getPicker();
    var WeekPicker = getPicker('week', 'WeekPicker');
    var MonthPicker = getPicker('month', 'MonthPicker');
    var YearPicker = getPicker('year', 'YearPicker');
    var TimePicker = getPicker('time', 'TimePicker');
    var QuarterPicker = getPicker('quarter', 'QuarterPicker');
    return {
        DatePicker: DatePicker,
        WeekPicker: WeekPicker,
        MonthPicker: MonthPicker,
        YearPicker: YearPicker,
        TimePicker: TimePicker,
        QuarterPicker: QuarterPicker
    };
}


var $ba1749f2af0731c1$export$cdb8a2fe02a819d9 = {
    button: (0, $7b59d5538be332fc$export$2e2bcd8739ae039),
    rangeItem: (0, $2b092d03cca171d5$export$2e2bcd8739ae039)
};
function $ba1749f2af0731c1$var$toArray(list) {
    if (!list) return [];
    return Array.isArray(list) ? list : [
        list
    ];
}
function $ba1749f2af0731c1$export$6c7e3619a08d795a(props) {
    var format = props.format, picker = props.picker, showHour = props.showHour, showMinute = props.showMinute, showSecond = props.showSecond, use12Hours = props.use12Hours;
    var firstFormat = $ba1749f2af0731c1$var$toArray(format)[0];
    var showTimeObj = (0, $fIrcP.default)({}, props);
    if (firstFormat && typeof firstFormat === 'string') {
        if (!firstFormat.includes('s') && showSecond === undefined) showTimeObj.showSecond = false;
        if (!firstFormat.includes('m') && showMinute === undefined) showTimeObj.showMinute = false;
        if (!firstFormat.includes('H') && !firstFormat.includes('h') && showHour === undefined) showTimeObj.showHour = false;
        if ((firstFormat.includes('a') || firstFormat.includes('A')) && use12Hours === undefined) showTimeObj.use12Hours = true;
    }
    if (picker === 'time') return showTimeObj;
    if (typeof firstFormat === 'function') // format of showTime should use default when format is custom format function
    delete showTimeObj.format;
    return {
        showTime: showTimeObj
    };
}
var $ba1749f2af0731c1$var$DataPickerPlacements = (0, $cacd97b96801cebe$export$65e3907585753458)('bottomLeft', 'bottomRight', 'topLeft', 'topRight');
function $ba1749f2af0731c1$var$generatePicker(generateConfig) {
    // =========================== Picker ===========================
    var _generateSinglePicker = (0, $23187350293a3e99$export$2e2bcd8739ae039)(generateConfig), DatePicker = _generateSinglePicker.DatePicker, WeekPicker = _generateSinglePicker.WeekPicker, MonthPicker = _generateSinglePicker.MonthPicker, YearPicker = _generateSinglePicker.YearPicker, TimePicker = _generateSinglePicker.TimePicker, QuarterPicker = _generateSinglePicker.QuarterPicker;
    // ======================== Range Picker ========================
    var RangePicker = (0, $64041e3fd42e0639$export$2e2bcd8739ae039)(generateConfig);
    var MergedDatePicker = DatePicker;
    MergedDatePicker.WeekPicker = WeekPicker;
    MergedDatePicker.MonthPicker = MonthPicker;
    MergedDatePicker.YearPicker = YearPicker;
    MergedDatePicker.RangePicker = RangePicker;
    MergedDatePicker.TimePicker = TimePicker;
    MergedDatePicker.QuarterPicker = QuarterPicker;
    return MergedDatePicker;
}
var $ba1749f2af0731c1$export$2e2bcd8739ae039 = $ba1749f2af0731c1$var$generatePicker;


var $e07b4718354cbfe5$var$DatePicker = (0, $ba1749f2af0731c1$export$2e2bcd8739ae039)((0, $0bd6dd93325ef2b1$export$2e2bcd8739ae039));
var $e07b4718354cbfe5$export$2e2bcd8739ae039 = $e07b4718354cbfe5$var$DatePicker;


var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");


var $d81b70d88f5c0cb1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d81b70d88f5c0cb1$var$Divider = function Divider(props) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var customizePrefixCls = props.prefixCls, _props$type = props.type, type = _props$type === void 0 ? 'horizontal' : _props$type, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? 'center' : _props$orientation, orientationMargin = props.orientationMargin, className = props.className, children = props.children, dashed = props.dashed, plain = props.plain, restProps = $d81b70d88f5c0cb1$var$__rest(props, [
        "prefixCls",
        "type",
        "orientation",
        "orientationMargin",
        "className",
        "children",
        "dashed",
        "plain"
    ]);
    var prefixCls = getPrefixCls('divider', customizePrefixCls);
    var orientationPrefix = orientation.length > 0 ? "-".concat(orientation) : orientation;
    var hasChildren = !!children;
    var hasCustomMarginLeft = orientation === 'left' && orientationMargin != null;
    var hasCustomMarginRight = orientation === 'right' && orientationMargin != null;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-").concat(type), (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-with-text"), hasChildren), "".concat(prefixCls, "-with-text").concat(orientationPrefix), hasChildren), "".concat(prefixCls, "-dashed"), !!dashed), "".concat(prefixCls, "-plain"), !!plain), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-no-default-orientation-margin-left"), hasCustomMarginLeft), "".concat(prefixCls, "-no-default-orientation-margin-right"), hasCustomMarginRight), className);
    var innerStyle = (0, $fIrcP.default)((0, $fIrcP.default)({}, hasCustomMarginLeft && {
        marginLeft: orientationMargin
    }), hasCustomMarginRight && {
        marginRight: orientationMargin
    });
    return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        className: classString
    }, restProps, {
        role: "separator"
    }), children && type !== 'vertical' && /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-inner-text"),
        style: innerStyle
    }, children));
};
var $d81b70d88f5c0cb1$export$2e2bcd8739ae039 = $d81b70d88f5c0cb1$var$Divider;


var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");


var $fActo = parcelRequire("fActo");
// export this package's api

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $8CZEB = parcelRequire("8CZEB");

var $aSXdS = parcelRequire("aSXdS");
parcelRequire("3mXQ2");

var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");
var $55325da80a3e2284$var$OrderContext = /*#__PURE__*/ $6fFrj.createContext(null);
var $55325da80a3e2284$export$2e2bcd8739ae039 = $55325da80a3e2284$var$OrderContext;



var $37xND = parcelRequire("37xND");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $dNZA9 = parcelRequire("dNZA9");

var $aSXdS = parcelRequire("aSXdS");

var $19135f07a4522ab7$var$EMPTY_LIST = [];
function $19135f07a4522ab7$export$2e2bcd8739ae039(render, debug) {
    var _React$useState = $6fFrj.useState(function() {
        if (!(0, $aSXdS.default)()) return null;
        var defaultEle = document.createElement('div');
        return defaultEle;
    }), _React$useState2 = (0, $jP8CL.default)(_React$useState, 1), ele = _React$useState2[0];
    // ========================== Order ==========================
    var appendedRef = $6fFrj.useRef(false);
    var queueCreate = $6fFrj.useContext((0, $55325da80a3e2284$export$2e2bcd8739ae039));
    var _React$useState3 = $6fFrj.useState($19135f07a4522ab7$var$EMPTY_LIST), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), queue = _React$useState4[0], setQueue = _React$useState4[1];
    var mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : function(appendFn) {
        setQueue(function(origin) {
            var newQueue = [
                appendFn
            ].concat((0, $37xND.default)(origin));
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        var _ele$parentElement;
        (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 || _ele$parentElement.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $dNZA9.default)(function() {
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $dNZA9.default)(function() {
        if (queue.length) {
            queue.forEach(function(appendFn) {
                return appendFn();
            });
            setQueue($19135f07a4522ab7$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}



var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");


var $dNZA9 = parcelRequire("dNZA9");
/* eslint-disable no-param-reassign */ 
var $4e9e0b76ae3600bd$var$cached;
function $4e9e0b76ae3600bd$var$measureScrollbarSize(ele) {
    var randomId = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7));
    var measureEle = document.createElement('div');
    measureEle.id = randomId;
    // Create Style
    var measureStyle = measureEle.style;
    measureStyle.position = 'absolute';
    measureStyle.left = '0';
    measureStyle.top = '0';
    measureStyle.width = '100px';
    measureStyle.height = '100px';
    measureStyle.overflow = 'scroll';
    // Clone Style if needed
    var fallbackWidth;
    var fallbackHeight;
    if (ele) {
        var targetStyle = getComputedStyle(ele);
        measureStyle.scrollbarColor = targetStyle.scrollbarColor;
        measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;
        // Set Webkit style
        var webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
        var width = parseInt(webkitScrollbarStyle.width, 10);
        var height = parseInt(webkitScrollbarStyle.height, 10);
        // Try wrap to handle CSP case
        try {
            var widthStyle = width ? "width: ".concat(webkitScrollbarStyle.width, ";") : '';
            var heightStyle = height ? "height: ".concat(webkitScrollbarStyle.height, ";") : '';
            (0, $be1cee03a7a68105$export$4d99a2890bb989f0)("\n#".concat(randomId, "::-webkit-scrollbar {\n").concat(widthStyle, "\n").concat(heightStyle, "\n}"), randomId);
        } catch (e) {
            // Can't wrap, just log error
            console.error(e);
            // Get from style directly
            fallbackWidth = width;
            fallbackHeight = height;
        }
    }
    document.body.appendChild(measureEle);
    // Measure. Get fallback style if provided
    var scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
    var scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;
    // Clean up
    document.body.removeChild(measureEle);
    (0, $be1cee03a7a68105$export$2232e336aecaa80a)(randomId);
    return {
        width: scrollWidth,
        height: scrollHeight
    };
}
function $4e9e0b76ae3600bd$export$2e2bcd8739ae039(fresh) {
    if (typeof document === 'undefined') return 0;
    if (fresh || $4e9e0b76ae3600bd$var$cached === undefined) $4e9e0b76ae3600bd$var$cached = $4e9e0b76ae3600bd$var$measureScrollbarSize();
    return $4e9e0b76ae3600bd$var$cached.width;
}
function $4e9e0b76ae3600bd$export$4f3ef2310365b56a(target) {
    if (typeof document === 'undefined' || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    return $4e9e0b76ae3600bd$var$measureScrollbarSize(target);
}


/**
 * Test usage export. Do not use in your production
 */ function $7ff32de4e8a05ef2$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}


var $891c515551b9f857$var$UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var $891c515551b9f857$var$uuid = 0;
function $891c515551b9f857$export$2e2bcd8739ae039(lock) {
    var mergedLock = !!lock;
    var _React$useState = $6fFrj.useState(function() {
        $891c515551b9f857$var$uuid += 1;
        return "".concat($891c515551b9f857$var$UNIQUE_ID, "_").concat($891c515551b9f857$var$uuid);
    }), _React$useState2 = (0, $jP8CL.default)(_React$useState, 1), id = _React$useState2[0];
    (0, $dNZA9.default)(function() {
        if (mergedLock) {
            var scrollbarSize = (0, $4e9e0b76ae3600bd$export$4f3ef2310365b56a)(document.body).width;
            var isOverflow = (0, $7ff32de4e8a05ef2$export$31b5c8f1131a3a52)();
            (0, $be1cee03a7a68105$export$4d99a2890bb989f0)("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : '', "\n}"), id);
        } else (0, $be1cee03a7a68105$export$2232e336aecaa80a)(id);
        return function() {
            (0, $be1cee03a7a68105$export$2232e336aecaa80a)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}


var $0da0b0ddfa251699$export$18c8ad048e32c7d5 = false;
function $0da0b0ddfa251699$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === 'boolean') $0da0b0ddfa251699$export$18c8ad048e32c7d5 = nextInline;
    return $0da0b0ddfa251699$export$18c8ad048e32c7d5;
}


var $0b2bc4ab3cf480b0$var$getPortalContainer = function getPortalContainer(getContainer) {
    if (getContainer === false) return false;
    if (!(0, $aSXdS.default)() || !getContainer) return null;
    if (typeof getContainer === 'string') return document.querySelector(getContainer);
    if (typeof getContainer === 'function') return getContainer();
    return getContainer;
};
var $0b2bc4ab3cf480b0$var$Portal = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var open = props.open, autoLock = props.autoLock, getContainer = props.getContainer, debug = props.debug, _props$autoDestroy = props.autoDestroy, autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy, children = props.children;
    var _React$useState = $6fFrj.useState(open), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), shouldRender = _React$useState2[0], setShouldRender = _React$useState2[1];
    var mergedRender = shouldRender || open;
    // ====================== Should Render ======================
    $6fFrj.useEffect(function() {
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    var _React$useState3 = $6fFrj.useState(function() {
        return $0b2bc4ab3cf480b0$var$getPortalContainer(getContainer);
    }), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), innerContainer = _React$useState4[0], setInnerContainer = _React$useState4[1];
    $6fFrj.useEffect(function() {
        var customizeContainer = $0b2bc4ab3cf480b0$var$getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
    });
    var _useDom = (0, $19135f07a4522ab7$export$2e2bcd8739ae039)(mergedRender && !innerContainer, debug), _useDom2 = (0, $jP8CL.default)(_useDom, 2), defaultContainer = _useDom2[0], queueCreate = _useDom2[1];
    var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer;
    // ========================= Locker ==========================
    (0, $891c515551b9f857$export$2e2bcd8739ae039)(autoLock && open && (0, $aSXdS.default)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // =========================== Ref ===========================
    var childRef = null;
    if (children && (0, $3BOWT.supportRef)(children) && ref) {
        var _ref = children;
        childRef = _ref.ref;
    }
    var mergedRef = (0, $3BOWT.useComposeRef)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $aSXdS.default)() || innerContainer === undefined) return null;
    // Render inline
    var renderInline = mergedContainer === false || (0, $0da0b0ddfa251699$export$121d9fd0ca615463)();
    var reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $6fFrj.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $6fFrj.createElement((0, $55325da80a3e2284$export$2e2bcd8739ae039).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $8CZEB.createPortal)(reffedChildren, mergedContainer));
});
var $0b2bc4ab3cf480b0$export$2e2bcd8739ae039 = $0b2bc4ab3cf480b0$var$Portal;



var $8190793b254f77a3$export$2e2bcd8739ae039 = (0, $0b2bc4ab3cf480b0$export$2e2bcd8739ae039);



var $dNZA9 = parcelRequire("dNZA9");

var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $fActo = parcelRequire("fActo");

var $5EVeC = parcelRequire("5EVeC");


var $kNxFX = parcelRequire("kNxFX");
var $c7e00e8671f36d19$var$attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var $c7e00e8671f36d19$var$eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var $c7e00e8671f36d19$var$propList = "".concat($c7e00e8671f36d19$var$attributes, " ").concat($c7e00e8671f36d19$var$eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */ var $c7e00e8671f36d19$var$ariaPrefix = 'aria-';
var $c7e00e8671f36d19$var$dataPrefix = 'data-';
function $c7e00e8671f36d19$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $c7e00e8671f36d19$export$2e2bcd8739ae039(props) {
    var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = (0, $kNxFX.default)({}, ariaOnly);
    var attrs = {};
    Object.keys(props).forEach(function(key) {
        if (// Aria
        mergedConfig.aria && (key === 'role' || $c7e00e8671f36d19$var$match(key, $c7e00e8671f36d19$var$ariaPrefix)) || // Data
        mergedConfig.data && $c7e00e8671f36d19$var$match(key, $c7e00e8671f36d19$var$dataPrefix) || // Attr
        mergedConfig.attr && $c7e00e8671f36d19$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}



var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");
var $2d7d7fdd924f59da$var$DrawerContext = /*#__PURE__*/ $6fFrj.createContext(null);
var $2d7d7fdd924f59da$export$2e2bcd8739ae039 = $2d7d7fdd924f59da$var$DrawerContext;



var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");
var $f84c6d632aec97e7$var$DrawerPanel = function DrawerPanel(props) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, children = props.children, containerRef = props.containerRef, id = props.id, onMouseEnter = props.onMouseEnter, onMouseOver = props.onMouseOver, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp;
    var eventHandlers = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    };
    // =============================== Render ===============================
    return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-content"), className),
        style: (0, $kNxFX.default)({}, style),
        "aria-modal": "true",
        role: "dialog",
        ref: containerRef
    }, eventHandlers), children));
};
var $f84c6d632aec97e7$export$2e2bcd8739ae039 = $f84c6d632aec97e7$var$DrawerPanel;



var $3mXQ2 = parcelRequire("3mXQ2");

var $aSXdS = parcelRequire("aSXdS");
function $f2c95c6b98c735af$export$efeadb1af96d0a6d(value) {
    if (typeof value === 'string' && String(Number(value)) === value) {
        (0, $3mXQ2.default)(false, 'Invalid value type of `width` or `height` which should be number type instead.');
        return Number(value);
    }
    return value;
}
function $f2c95c6b98c735af$export$e77176dc71180add(props) {
    (0, $3mXQ2.default)(!('wrapperClassName' in props), "'wrapperClassName' is removed. Please use 'rootClassName' instead.");
    (0, $3mXQ2.default)((0, $aSXdS.default)() || !props.open, "Drawer with 'open' in SSR is not work since no place to createPortal. Please move to 'useEffect' instead.");
}


var $b558110605325f3f$var$sentinelStyle = {
    width: 0,
    height: 0,
    overflow: 'hidden',
    outline: 'none',
    position: 'absolute'
};
function $b558110605325f3f$var$DrawerPopup(props, ref) {
    var _ref, _pushConfig$distance, _pushConfig, _classNames;
    var prefixCls = props.prefixCls, open = props.open, placement = props.placement, inline = props.inline, push = props.push, forceRender = props.forceRender, autoFocus = props.autoFocus, keyboard = props.keyboard, rootClassName = props.rootClassName, rootStyle = props.rootStyle, zIndex = props.zIndex, className = props.className, id = props.id, style = props.style, motion = props.motion, width = props.width, height = props.height, children = props.children, contentWrapperStyle = props.contentWrapperStyle, mask = props.mask, maskClosable = props.maskClosable, maskMotion = props.maskMotion, maskClassName = props.maskClassName, maskStyle = props.maskStyle, afterOpenChange = props.afterOpenChange, onClose = props.onClose, onMouseEnter = props.onMouseEnter, onMouseOver = props.onMouseOver, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp;
    // ================================ Refs ================================
    var panelRef = $6fFrj.useRef();
    var sentinelStartRef = $6fFrj.useRef();
    var sentinelEndRef = $6fFrj.useRef();
    $6fFrj.useImperativeHandle(ref, function() {
        return panelRef.current;
    });
    var onPanelKeyDown = function onPanelKeyDown(event) {
        var keyCode = event.keyCode, shiftKey = event.shiftKey;
        switch(keyCode){
            // Tab active
            case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).TAB:
                if (keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).TAB) {
                    if (!shiftKey && document.activeElement === sentinelEndRef.current) {
                        var _sentinelStartRef$cur;
                        (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus({
                            preventScroll: true
                        });
                    } else if (shiftKey && document.activeElement === sentinelStartRef.current) {
                        var _sentinelEndRef$curre;
                        (_sentinelEndRef$curre = sentinelEndRef.current) === null || _sentinelEndRef$curre === void 0 || _sentinelEndRef$curre.focus({
                            preventScroll: true
                        });
                    }
                }
                break;
            // Close
            case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ESC:
                if (onClose && keyboard) {
                    event.stopPropagation();
                    onClose(event);
                }
                break;
        }
    };
    // ========================== Control ===========================
    // Auto Focus
    $6fFrj.useEffect(function() {
        if (open && autoFocus) {
            var _panelRef$current;
            (_panelRef$current = panelRef.current) === null || _panelRef$current === void 0 || _panelRef$current.focus({
                preventScroll: true
            });
        }
    }, [
        open
    ]);
    // ============================ Push ============================
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), pushed = _React$useState2[0], setPushed = _React$useState2[1];
    var parentContext = $6fFrj.useContext((0, $2d7d7fdd924f59da$export$2e2bcd8739ae039));
    // Merge push distance
    var pushConfig;
    if (push === false) pushConfig = {
        distance: 0
    };
    else if (push === true) pushConfig = {};
    else pushConfig = push || {};
    var pushDistance = (_ref = (_pushConfig$distance = (_pushConfig = pushConfig) === null || _pushConfig === void 0 ? void 0 : _pushConfig.distance) !== null && _pushConfig$distance !== void 0 ? _pushConfig$distance : parentContext === null || parentContext === void 0 ? void 0 : parentContext.pushDistance) !== null && _ref !== void 0 ? _ref : 180;
    var mergedContext = $6fFrj.useMemo(function() {
        return {
            pushDistance: pushDistance,
            push: function push() {
                setPushed(true);
            },
            pull: function pull() {
                setPushed(false);
            }
        };
    }, [
        pushDistance
    ]);
    // ========================= ScrollLock =========================
    // Tell parent to push
    $6fFrj.useEffect(function() {
        if (open) {
            var _parentContext$push;
            parentContext === null || parentContext === void 0 || (_parentContext$push = parentContext.push) === null || _parentContext$push === void 0 || _parentContext$push.call(parentContext);
        } else {
            var _parentContext$pull;
            parentContext === null || parentContext === void 0 || (_parentContext$pull = parentContext.pull) === null || _parentContext$pull === void 0 || _parentContext$pull.call(parentContext);
        }
    }, [
        open
    ]);
    // Clean up
    $6fFrj.useEffect(function() {
        return function() {
            var _parentContext$pull2;
            parentContext === null || parentContext === void 0 || (_parentContext$pull2 = parentContext.pull) === null || _parentContext$pull2 === void 0 || _parentContext$pull2.call(parentContext);
        };
    }, []);
    // ============================ Mask ============================
    var maskNode = mask && /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), (0, $fIrcP.default)({
        key: "mask"
    }, maskMotion, {
        visible: open
    }), function(_ref2, maskRef) {
        var motionMaskClassName = _ref2.className, motionMaskStyle = _ref2.style;
        return /*#__PURE__*/ $6fFrj.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-mask"), motionMaskClassName, maskClassName),
            style: (0, $kNxFX.default)((0, $kNxFX.default)({}, motionMaskStyle), maskStyle),
            onClick: maskClosable && open ? onClose : undefined,
            ref: maskRef
        });
    });
    // =========================== Panel ============================
    var motionProps = typeof motion === 'function' ? motion(placement) : motion;
    var wrapperStyle = {};
    if (pushed && pushDistance) switch(placement){
        case 'top':
            wrapperStyle.transform = "translateY(".concat(pushDistance, "px)");
            break;
        case 'bottom':
            wrapperStyle.transform = "translateY(".concat(-pushDistance, "px)");
            break;
        case 'left':
            wrapperStyle.transform = "translateX(".concat(pushDistance, "px)");
            break;
        default:
            wrapperStyle.transform = "translateX(".concat(-pushDistance, "px)");
            break;
    }
    if (placement === 'left' || placement === 'right') wrapperStyle.width = (0, $f2c95c6b98c735af$export$efeadb1af96d0a6d)(width);
    else wrapperStyle.height = (0, $f2c95c6b98c735af$export$efeadb1af96d0a6d)(height);
    var eventHandlers = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    };
    var panelNode = /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), (0, $fIrcP.default)({
        key: "panel"
    }, motionProps, {
        visible: open,
        forceRender: forceRender,
        onVisibleChanged: function onVisibleChanged(nextVisible) {
            afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(nextVisible);
        },
        removeOnLeave: false,
        leavedClassName: "".concat(prefixCls, "-content-wrapper-hidden")
    }), function(_ref3, motionRef) {
        var motionClassName = _ref3.className, motionStyle = _ref3.style;
        return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-content-wrapper"), motionClassName),
            style: (0, $kNxFX.default)((0, $kNxFX.default)((0, $kNxFX.default)({}, wrapperStyle), motionStyle), contentWrapperStyle)
        }, (0, $c7e00e8671f36d19$export$2e2bcd8739ae039)(props, {
            data: true
        })), /*#__PURE__*/ $6fFrj.createElement((0, $f84c6d632aec97e7$export$2e2bcd8739ae039), (0, $fIrcP.default)({
            id: id,
            containerRef: motionRef,
            prefixCls: prefixCls,
            className: className,
            style: style
        }, eventHandlers), children));
    });
    // =========================== Render ===========================
    var containerStyle = (0, $kNxFX.default)({}, rootStyle);
    if (zIndex) containerStyle.zIndex = zIndex;
    return /*#__PURE__*/ $6fFrj.createElement((0, $2d7d7fdd924f59da$export$2e2bcd8739ae039).Provider, {
        value: mergedContext
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-").concat(placement), rootClassName, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(prefixCls, "-open"), open), (0, $43449.default)(_classNames, "".concat(prefixCls, "-inline"), inline), _classNames)),
        style: containerStyle,
        tabIndex: -1,
        ref: panelRef,
        onKeyDown: onPanelKeyDown
    }, maskNode, /*#__PURE__*/ $6fFrj.createElement("div", {
        tabIndex: 0,
        ref: sentinelStartRef,
        style: $b558110605325f3f$var$sentinelStyle,
        "aria-hidden": "true",
        "data-sentinel": "start"
    }), panelNode, /*#__PURE__*/ $6fFrj.createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: $b558110605325f3f$var$sentinelStyle,
        "aria-hidden": "true",
        "data-sentinel": "end"
    })));
}
var $b558110605325f3f$var$RefDrawerPopup = /*#__PURE__*/ $6fFrj.forwardRef($b558110605325f3f$var$DrawerPopup);
var $b558110605325f3f$export$2e2bcd8739ae039 = $b558110605325f3f$var$RefDrawerPopup;



var $db6465880eea26b1$var$Drawer = function Drawer(props) {
    var _props$open = props.open, open = _props$open === void 0 ? false : _props$open, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-drawer' : _props$prefixCls, _props$placement = props.placement, placement = _props$placement === void 0 ? 'right' : _props$placement, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$width = props.width, width = _props$width === void 0 ? 378 : _props$width, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, getContainer = props.getContainer, forceRender = props.forceRender, afterOpenChange = props.afterOpenChange, destroyOnClose = props.destroyOnClose, onMouseEnter = props.onMouseEnter, onMouseOver = props.onMouseOver, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp;
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    // ============================= Open =============================
    var _React$useState3 = $6fFrj.useState(false), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), mounted = _React$useState4[0], setMounted = _React$useState4[1];
    (0, $dNZA9.default)(function() {
        setMounted(true);
    }, []);
    var mergedOpen = mounted ? open : false;
    // ============================ Focus =============================
    var panelRef = $6fFrj.useRef();
    var lastActiveRef = $6fFrj.useRef();
    (0, $dNZA9.default)(function() {
        if (mergedOpen) lastActiveRef.current = document.activeElement;
    }, [
        mergedOpen
    ]);
    // ============================= Open =============================
    var internalAfterOpenChange = function internalAfterOpenChange(nextVisible) {
        var _panelRef$current;
        setAnimatedVisible(nextVisible);
        afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(nextVisible);
        if (!nextVisible && lastActiveRef.current && !((_panelRef$current = panelRef.current) === null || _panelRef$current === void 0 ? void 0 : _panelRef$current.contains(lastActiveRef.current))) {
            var _lastActiveRef$curren;
            (_lastActiveRef$curren = lastActiveRef.current) === null || _lastActiveRef$curren === void 0 || _lastActiveRef$curren.focus({
                preventScroll: true
            });
        }
    };
    // ============================ Render ============================
    if (!forceRender && !animatedVisible && !mergedOpen && destroyOnClose) return null;
    var eventHandlers = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    };
    var drawerPopupProps = (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        open: mergedOpen,
        prefixCls: prefixCls,
        placement: placement,
        autoFocus: autoFocus,
        keyboard: keyboard,
        width: width,
        mask: mask,
        maskClosable: maskClosable,
        inline: getContainer === false,
        afterOpenChange: internalAfterOpenChange,
        ref: panelRef
    }, eventHandlers);
    return /*#__PURE__*/ $6fFrj.createElement((0, $8190793b254f77a3$export$2e2bcd8739ae039), {
        open: mergedOpen || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: mask && (mergedOpen || animatedVisible)
    }, /*#__PURE__*/ $6fFrj.createElement((0, $b558110605325f3f$export$2e2bcd8739ae039), drawerPopupProps));
};
var $db6465880eea26b1$export$2e2bcd8739ae039 = $db6465880eea26b1$var$Drawer;


var $862c784e26ca273e$export$2e2bcd8739ae039 = (0, $db6465880eea26b1$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");






var $67e53ef2d660b7d8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $67e53ef2d660b7d8$var$SizeTypes = (0, $cacd97b96801cebe$export$65e3907585753458)('default', 'large');
var $67e53ef2d660b7d8$var$defaultPushState = {
    distance: 180
};
function $67e53ef2d660b7d8$var$Drawer(props) {
    var width = props.width, height = props.height, _props$size = props.size, size = _props$size === void 0 ? 'default' : _props$size, _props$closable = props.closable, closable = _props$closable === void 0 ? true : _props$closable, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, _props$push = props.push, push = _props$push === void 0 ? $67e53ef2d660b7d8$var$defaultPushState : _props$push, _props$closeIcon = props.closeIcon, closeIcon = _props$closeIcon === void 0 ? /*#__PURE__*/ $6fFrj.createElement((0, $4cb3f1f073816266$export$2e2bcd8739ae039), null) : _props$closeIcon, bodyStyle = props.bodyStyle, drawerStyle = props.drawerStyle, className = props.className, visible = props.visible, open = props.open, children = props.children, style = props.style, title = props.title, headerStyle = props.headerStyle, onClose = props.onClose, footer = props.footer, footerStyle = props.footerStyle, customizePrefixCls = props.prefixCls, customizeGetContainer = props.getContainer, extra = props.extra, afterVisibleChange = props.afterVisibleChange, _afterOpenChange = props.afterOpenChange, rest = $67e53ef2d660b7d8$var$__rest(props, [
        "width",
        "height",
        "size",
        "closable",
        "mask",
        "push",
        "closeIcon",
        "bodyStyle",
        "drawerStyle",
        "className",
        "visible",
        "open",
        "children",
        "style",
        "title",
        "headerStyle",
        "onClose",
        "footer",
        "footerStyle",
        "prefixCls",
        "getContainer",
        "extra",
        "afterVisibleChange",
        "afterOpenChange"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var prefixCls = getPrefixCls('drawer', customizePrefixCls);
    var getContainer = // 有可能为 false，所以不能直接判断
    customizeGetContainer === undefined && getPopupContainer ? function() {
        return getPopupContainer(document.body);
    } : customizeGetContainer;
    var closeIconNode = closable && /*#__PURE__*/ $6fFrj.createElement("button", {
        type: "button",
        onClick: onClose,
        "aria-label": "Close",
        className: "".concat(prefixCls, "-close")
    }, closeIcon);
    [
        [
            'visible',
            'open'
        ],
        [
            'afterVisibleChange',
            'afterOpenChange'
        ]
    ].forEach(function(_ref) {
        var _ref2 = (0, $jP8CL.default)(_ref, 2), deprecatedName = _ref2[0], newName = _ref2[1];
    });
    function renderHeader() {
        if (!title && !closable) return null;
        return /*#__PURE__*/ $6fFrj.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-header"), (0, $43449.default)({}, "".concat(prefixCls, "-header-close-only"), closable && !title && !extra)),
            style: headerStyle
        }, /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-header-title")
        }, closeIconNode, title && /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-title")
        }, title)), extra && /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-extra")
        }, extra));
    }
    function renderFooter() {
        if (!footer) return null;
        var footerClassName = "".concat(prefixCls, "-footer");
        return /*#__PURE__*/ $6fFrj.createElement("div", {
            className: footerClassName,
            style: footerStyle
        }, footer);
    }
    var drawerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)({
        'no-mask': !mask
    }, "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    // ============================ Size ============================
    var mergedWidth = $6fFrj.useMemo(function() {
        return width !== null && width !== void 0 ? width : size === 'large' ? 736 : 378;
    }, [
        width,
        size
    ]);
    var mergedHeight = $6fFrj.useMemo(function() {
        return height !== null && height !== void 0 ? height : size === 'large' ? 736 : 378;
    }, [
        height,
        size
    ]);
    // =========================== Motion ===========================
    var maskMotion = {
        motionName: (0, $779588b2444df86c$export$27c72201b1d09951)(prefixCls, 'mask-motion'),
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        motionDeadline: 500
    };
    var panelMotion = function panelMotion(motionPlacement) {
        return {
            motionName: (0, $779588b2444df86c$export$27c72201b1d09951)(prefixCls, "panel-motion-".concat(motionPlacement)),
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            motionDeadline: 500
        };
    };
    // =========================== Render ===========================
    return /*#__PURE__*/ $6fFrj.createElement((0, $87f4fe035d0a15fd$export$5f56e610a4afb685), null, /*#__PURE__*/ $6fFrj.createElement((0, $76d69cb8326089c6$export$80e4c53cb85dcab1), {
        status: true,
        override: true
    }, /*#__PURE__*/ $6fFrj.createElement((0, $862c784e26ca273e$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        prefixCls: prefixCls,
        onClose: onClose
    }, rest, {
        open: open !== null && open !== void 0 ? open : visible,
        mask: mask,
        push: push,
        width: mergedWidth,
        height: mergedHeight,
        rootClassName: drawerClassName,
        getContainer: getContainer,
        afterOpenChange: function afterOpenChange(isOpen) {
            _afterOpenChange === null || _afterOpenChange === void 0 || _afterOpenChange(isOpen);
            afterVisibleChange === null || afterVisibleChange === void 0 || afterVisibleChange(isOpen);
        },
        maskMotion: maskMotion,
        motion: panelMotion,
        rootStyle: style
    }), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-wrapper-body"),
        style: (0, $fIrcP.default)({}, drawerStyle)
    }, renderHeader(), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-body"),
        style: bodyStyle
    }, children), renderFooter()))));
}
var $67e53ef2d660b7d8$export$2e2bcd8739ae039 = $67e53ef2d660b7d8$var$Drawer;


var $fIrcP = parcelRequire("fIrcP");

var $5KhTJ = parcelRequire("5KhTJ");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");


var $fActo = parcelRequire("fActo");

var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");


var $fActo = parcelRequire("fActo");
var $96b1383c1ead5ba4$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $96b1383c1ead5ba4$var$targetOffset = [
    0,
    0
];
var $96b1383c1ead5ba4$var$placements = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $96b1383c1ead5ba4$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $96b1383c1ead5ba4$var$targetOffset
    },
    topCenter: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $96b1383c1ead5ba4$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $96b1383c1ead5ba4$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $96b1383c1ead5ba4$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $96b1383c1ead5ba4$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $96b1383c1ead5ba4$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $96b1383c1ead5ba4$var$targetOffset
    },
    bottomCenter: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $96b1383c1ead5ba4$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $96b1383c1ead5ba4$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $96b1383c1ead5ba4$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $96b1383c1ead5ba4$var$targetOffset
    }
};
var $96b1383c1ead5ba4$export$2e2bcd8739ae039 = $96b1383c1ead5ba4$var$placements;



var $6fFrj = parcelRequire("6fFrj");


var $hqic8 = parcelRequire("hqic8");

var $37xND = parcelRequire("37xND");

function $22fc973f01fa8b1e$var$focusable(node) {
    var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if ((0, $5335db4432c3f914$export$2e2bcd8739ae039)(node)) {
        var nodeName = node.nodeName.toLowerCase();
        var isFocusableElement = // Focusable element
        [
            'input',
            'select',
            'textarea',
            'button'
        ].includes(nodeName) || // Editable element
        node.isContentEditable || // Anchor with href element
        nodeName === 'a' && !!node.getAttribute('href');
        // Get tabIndex
        var tabIndexAttr = node.getAttribute('tabindex');
        var tabIndexNum = Number(tabIndexAttr);
        // Parse as number if validate
        var tabIndex = null;
        if (tabIndexAttr && !Number.isNaN(tabIndexNum)) tabIndex = tabIndexNum;
        else if (isFocusableElement && tabIndex === null) tabIndex = 0;
        // Block focusable if disabled
        if (isFocusableElement && node.disabled) tabIndex = null;
        return tabIndex !== null && (tabIndex >= 0 || includePositive && tabIndex < 0);
    }
    return false;
}
function $22fc973f01fa8b1e$export$bbc7b5f11aba534b(node) {
    var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var res = (0, $37xND.default)(node.querySelectorAll('*')).filter(function(child) {
        return $22fc973f01fa8b1e$var$focusable(child, includePositive);
    });
    if ($22fc973f01fa8b1e$var$focusable(node, includePositive)) res.unshift(node);
    return res;
}
var $22fc973f01fa8b1e$var$lastFocusElement = null;
function $22fc973f01fa8b1e$export$79fea02f7a83293d() {
    $22fc973f01fa8b1e$var$lastFocusElement = document.activeElement;
}
function $22fc973f01fa8b1e$export$8785654047fe7352() {
    $22fc973f01fa8b1e$var$lastFocusElement = null;
}
function $22fc973f01fa8b1e$export$fac0a9974415d98f() {
    if ($22fc973f01fa8b1e$var$lastFocusElement) try {
        // 元素可能已经被移动了
        $22fc973f01fa8b1e$var$lastFocusElement.focus();
    /* eslint-disable no-empty */ } catch (e) {
    // empty
    }
}
function $22fc973f01fa8b1e$export$5717027f63f8addb(node, e) {
    if (e.keyCode === 9) {
        var tabNodeList = $22fc973f01fa8b1e$export$bbc7b5f11aba534b(node);
        var lastTabNode = tabNodeList[e.shiftKey ? 0 : tabNodeList.length - 1];
        var leavingTab = lastTabNode === document.activeElement || node === document.activeElement;
        if (leavingTab) {
            var target = tabNodeList[e.shiftKey ? tabNodeList.length - 1 : 0];
            target.focus();
            e.preventDefault();
        }
    }
}


var $797f3388babe07ef$var$ESC = (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ESC, $797f3388babe07ef$var$TAB = (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).TAB;
function $797f3388babe07ef$export$2e2bcd8739ae039(_ref) {
    var visible = _ref.visible, setTriggerVisible = _ref.setTriggerVisible, triggerRef = _ref.triggerRef, onVisibleChange = _ref.onVisibleChange, autoFocus = _ref.autoFocus;
    var focusMenuRef = $6fFrj.useRef(false);
    var handleCloseMenuAndReturnFocus = function handleCloseMenuAndReturnFocus() {
        if (visible && triggerRef.current) {
            var _triggerRef$current, _triggerRef$current$t, _triggerRef$current$t2, _triggerRef$current$t3;
            (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || (_triggerRef$current$t = _triggerRef$current.triggerRef) === null || _triggerRef$current$t === void 0 || (_triggerRef$current$t2 = _triggerRef$current$t.current) === null || _triggerRef$current$t2 === void 0 || (_triggerRef$current$t3 = _triggerRef$current$t2.focus) === null || _triggerRef$current$t3 === void 0 || _triggerRef$current$t3.call(_triggerRef$current$t2);
            setTriggerVisible(false);
            if (typeof onVisibleChange === 'function') onVisibleChange(false);
        }
    };
    var focusMenu = function focusMenu() {
        var _triggerRef$current2, _triggerRef$current2$, _triggerRef$current2$2, _triggerRef$current2$3;
        var elements = (0, $22fc973f01fa8b1e$export$bbc7b5f11aba534b)((_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : (_triggerRef$current2$ = _triggerRef$current2.popupRef) === null || _triggerRef$current2$ === void 0 ? void 0 : (_triggerRef$current2$2 = _triggerRef$current2$.current) === null || _triggerRef$current2$2 === void 0 ? void 0 : (_triggerRef$current2$3 = _triggerRef$current2$2.getElement) === null || _triggerRef$current2$3 === void 0 ? void 0 : _triggerRef$current2$3.call(_triggerRef$current2$2));
        var firstElement = elements[0];
        if (firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus) {
            firstElement.focus();
            focusMenuRef.current = true;
            return true;
        }
        return false;
    };
    var handleKeyDown = function handleKeyDown(event) {
        switch(event.keyCode){
            case $797f3388babe07ef$var$ESC:
                handleCloseMenuAndReturnFocus();
                break;
            case $797f3388babe07ef$var$TAB:
                var focusResult = false;
                if (!focusMenuRef.current) focusResult = focusMenu();
                if (focusResult) event.preventDefault();
                else handleCloseMenuAndReturnFocus();
                break;
        }
    };
    $6fFrj.useEffect(function() {
        if (visible) {
            window.addEventListener('keydown', handleKeyDown);
            if (autoFocus) // FIXME: hack with raf
            (0, $hqic8.default)(focusMenu, 3);
            return function() {
                window.removeEventListener('keydown', handleKeyDown);
                focusMenuRef.current = false;
            };
        }
        return function() {
            focusMenuRef.current = false;
        };
    }, [
        visible
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}


var $c8a2de71d54fb263$var$_excluded = [
    "arrow",
    "prefixCls",
    "transitionName",
    "animation",
    "align",
    "placement",
    "placements",
    "getPopupContainer",
    "showAction",
    "hideAction",
    "overlayClassName",
    "overlayStyle",
    "visible",
    "trigger",
    "autoFocus"
];
function $c8a2de71d54fb263$var$Dropdown(props, ref) {
    var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-dropdown' : _props$prefixCls, transitionName = props.transitionName, animation = props.animation, align = props.align, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottomLeft' : _props$placement, _props$placements = props.placements, placements = _props$placements === void 0 ? (0, $96b1383c1ead5ba4$export$2e2bcd8739ae039) : _props$placements, getPopupContainer = props.getPopupContainer, showAction = props.showAction, hideAction = props.hideAction, overlayClassName = props.overlayClassName, overlayStyle = props.overlayStyle, visible = props.visible, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        'hover'
    ] : _props$trigger, autoFocus = props.autoFocus, otherProps = (0, $04RxA.default)(props, $c8a2de71d54fb263$var$_excluded);
    var _React$useState = $6fFrj.useState(), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), triggerVisible = _React$useState2[0], setTriggerVisible = _React$useState2[1];
    var mergedVisible = 'visible' in props ? visible : triggerVisible;
    var triggerRef = $6fFrj.useRef(null);
    $6fFrj.useImperativeHandle(ref, function() {
        return triggerRef.current;
    });
    (0, $797f3388babe07ef$export$2e2bcd8739ae039)({
        visible: mergedVisible,
        setTriggerVisible: setTriggerVisible,
        triggerRef: triggerRef,
        onVisibleChange: props.onVisibleChange,
        autoFocus: autoFocus
    });
    var getOverlayElement = function getOverlayElement() {
        var overlay = props.overlay;
        var overlayElement;
        if (typeof overlay === 'function') overlayElement = overlay();
        else overlayElement = overlay;
        return overlayElement;
    };
    var onClick = function onClick(e) {
        var onOverlayClick = props.onOverlayClick;
        setTriggerVisible(false);
        if (onOverlayClick) onOverlayClick(e);
    };
    var onVisibleChange = function onVisibleChange(newVisible) {
        var onVisibleChangeProp = props.onVisibleChange;
        setTriggerVisible(newVisible);
        if (typeof onVisibleChangeProp === 'function') onVisibleChangeProp(newVisible);
    };
    var getMenuElement = function getMenuElement() {
        var overlayElement = getOverlayElement();
        return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, arrow && /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-arrow")
        }), overlayElement);
    };
    var getMenuElementOrLambda = function getMenuElementOrLambda() {
        var overlay = props.overlay;
        if (typeof overlay === 'function') return getMenuElement;
        return getMenuElement();
    };
    var getMinOverlayWidthMatchTrigger = function getMinOverlayWidthMatchTrigger() {
        var minOverlayWidthMatchTrigger = props.minOverlayWidthMatchTrigger, alignPoint = props.alignPoint;
        if ('minOverlayWidthMatchTrigger' in props) return minOverlayWidthMatchTrigger;
        return !alignPoint;
    };
    var getOpenClassName = function getOpenClassName() {
        var openClassName = props.openClassName;
        if (openClassName !== undefined) return openClassName;
        return "".concat(prefixCls, "-open");
    };
    var renderChildren = function renderChildren() {
        var children = props.children;
        var childrenProps = children.props ? children.props : {};
        var childClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(childrenProps.className, getOpenClassName());
        return mergedVisible && children ? /*#__PURE__*/ $6fFrj.cloneElement(children, {
            className: childClassName
        }) : children;
    };
    var triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) triggerHideAction = [
        'click'
    ];
    return /*#__PURE__*/ $6fFrj.createElement((0, $2c9abce2aaa5219e$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({
        builtinPlacements: placements
    }, otherProps), {}, {
        prefixCls: prefixCls,
        ref: triggerRef,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(overlayClassName, (0, $43449.default)({}, "".concat(prefixCls, "-show-arrow"), arrow)),
        popupStyle: overlayStyle,
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction || [],
        popupPlacement: placement,
        popupAlign: align,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupVisible: mergedVisible,
        stretch: getMinOverlayWidthMatchTrigger() ? 'minWidth' : '',
        popup: getMenuElementOrLambda(),
        onPopupVisibleChange: onVisibleChange,
        onPopupClick: onClick,
        getPopupContainer: getPopupContainer
    }), renderChildren());
}
var $c8a2de71d54fb263$export$2e2bcd8739ae039 = /*#__PURE__*/ $6fFrj.forwardRef($c8a2de71d54fb263$var$Dropdown);


var $35d13f388ca7de9e$export$2e2bcd8739ae039 = (0, $c8a2de71d54fb263$export$2e2bcd8739ae039);



var $2c6ch = parcelRequire("2c6ch");

var $gfhff = parcelRequire("gfhff");

var $6fFrj = parcelRequire("6fFrj");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $82HU4 = parcelRequire("82HU4");

var $jbuPt = parcelRequire("jbuPt");

var $744q1 = parcelRequire("744q1");

var $bxC2Y = parcelRequire("bxC2Y");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $bab4cc86d5ef6165$var$EllipsisOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "ellipsis",
    "theme": "outlined"
};
var $bab4cc86d5ef6165$export$2e2bcd8739ae039 = $bab4cc86d5ef6165$var$EllipsisOutlined;



var $982a9c0f9e1ff223$var$EllipsisOutlined = function EllipsisOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $bab4cc86d5ef6165$export$2e2bcd8739ae039)
    }));
};
var $982a9c0f9e1ff223$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($982a9c0f9e1ff223$var$EllipsisOutlined);
var $982a9c0f9e1ff223$export$2e2bcd8739ae039 = $982a9c0f9e1ff223$var$RefIcon;



var $fActo = parcelRequire("fActo");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $37xND = parcelRequire("37xND");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $fActo = parcelRequire("fActo");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


var $dNZA9 = parcelRequire("dNZA9");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $1f354648a2ad5384$var$_excluded = [
    "prefixCls",
    "invalidate",
    "item",
    "renderItem",
    "responsive",
    "responsiveDisabled",
    "registerSize",
    "itemKey",
    "className",
    "style",
    "children",
    "display",
    "order",
    "component"
];
// Use shared variable to save bundle size
var $1f354648a2ad5384$var$UNDEFINED = undefined;
function $1f354648a2ad5384$var$InternalItem(props, ref) {
    var prefixCls = props.prefixCls, invalidate = props.invalidate, item = props.item, renderItem = props.renderItem, responsive = props.responsive, responsiveDisabled = props.responsiveDisabled, registerSize = props.registerSize, itemKey = props.itemKey, className = props.className, style = props.style, children = props.children, display = props.display, order = props.order, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, restProps = (0, $04RxA.default)(props, $1f354648a2ad5384$var$_excluded);
    var mergedHidden = responsive && !display;
    // ================================ Effect ================================
    function internalRegisterSize(width) {
        registerSize(itemKey, width);
    }
    $6fFrj.useEffect(function() {
        return function() {
            internalRegisterSize(null);
        };
    }, []);
    // ================================ Render ================================
    var childNode = renderItem && item !== $1f354648a2ad5384$var$UNDEFINED ? renderItem(item) : children;
    var overflowStyle;
    if (!invalidate) overflowStyle = {
        opacity: mergedHidden ? 0 : 1,
        height: mergedHidden ? 0 : $1f354648a2ad5384$var$UNDEFINED,
        overflowY: mergedHidden ? 'hidden' : $1f354648a2ad5384$var$UNDEFINED,
        order: responsive ? order : $1f354648a2ad5384$var$UNDEFINED,
        pointerEvents: mergedHidden ? 'none' : $1f354648a2ad5384$var$UNDEFINED,
        position: mergedHidden ? 'absolute' : $1f354648a2ad5384$var$UNDEFINED
    };
    var overflowProps = {};
    if (mergedHidden) overflowProps['aria-hidden'] = true;
    var itemNode = /*#__PURE__*/ $6fFrj.createElement(Component, (0, $fIrcP.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(!invalidate && prefixCls, className),
        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, overflowStyle), style)
    }, overflowProps, restProps, {
        ref: ref
    }), childNode);
    if (responsive) itemNode = /*#__PURE__*/ $6fFrj.createElement((0, $8e6bb008621f90f5$export$2e2bcd8739ae039), {
        onResize: function onResize(_ref) {
            var offsetWidth = _ref.offsetWidth;
            internalRegisterSize(offsetWidth);
        },
        disabled: responsiveDisabled
    }, itemNode);
    return itemNode;
}
var $1f354648a2ad5384$var$Item = /*#__PURE__*/ $6fFrj.forwardRef($1f354648a2ad5384$var$InternalItem);
$1f354648a2ad5384$var$Item.displayName = 'Item';
var $1f354648a2ad5384$export$2e2bcd8739ae039 = $1f354648a2ad5384$var$Item;



var $jP8CL = parcelRequire("jP8CL");

var $2c6ch = parcelRequire("2c6ch");

var $6fFrj = parcelRequire("6fFrj");

var $8CZEB = parcelRequire("8CZEB");

var $hqic8 = parcelRequire("hqic8");
function $cd39752834a14efd$export$2e2bcd8739ae039(callback) {
    if (typeof MessageChannel === 'undefined') (0, $hqic8.default)(callback);
    else {
        var channel = new MessageChannel();
        channel.port1.onmessage = function() {
            return callback();
        };
        channel.port2.postMessage(undefined);
    }
}


function $38ba160e8146b122$export$eedf51fe9d751c7a() {
    // Updater Trigger
    var updateFuncRef = $6fFrj.useRef(null);
    // Notify update
    var notifyEffectUpdate = function notifyEffectUpdate(callback) {
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            (0, $cd39752834a14efd$export$2e2bcd8739ae039)(function() {
                (0, $8CZEB.unstable_batchedUpdates)(function() {
                    updateFuncRef.current.forEach(function(fn) {
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}
function $38ba160e8146b122$export$2e2bcd8739ae039(notifyEffectUpdate, defaultValue) {
    // Value
    var _React$useState = $6fFrj.useState(defaultValue), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), stateValue = _React$useState2[0], setStateValue = _React$useState2[1];
    // Set State
    var setEffectVal = (0, $2c6ch.default)(function(nextValue) {
        notifyEffectUpdate(function() {
            setStateValue(nextValue);
        });
    });
    return [
        stateValue,
        setEffectVal
    ];
}



var $fIrcP = parcelRequire("fIrcP");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");
var $88989b8c4ef26515$export$79f16dd643143c25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createContext(null);


var $73961540cbae84f5$var$_excluded = [
    "component"
], $73961540cbae84f5$var$_excluded2 = [
    "className"
], $73961540cbae84f5$var$_excluded3 = [
    "className"
];
var $73961540cbae84f5$var$InternalRawItem = function InternalRawItem(props, ref) {
    var context = $6fFrj.useContext((0, $88989b8c4ef26515$export$79f16dd643143c25));
    // Render directly when context not provided
    if (!context) {
        var _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _restProps = (0, $04RxA.default)(props, $73961540cbae84f5$var$_excluded);
        return /*#__PURE__*/ $6fFrj.createElement(Component, (0, $fIrcP.default)({}, _restProps, {
            ref: ref
        }));
    }
    var contextClassName = context.className, restContext = (0, $04RxA.default)(context, $73961540cbae84f5$var$_excluded2);
    var className = props.className, restProps = (0, $04RxA.default)(props, $73961540cbae84f5$var$_excluded3);
    // Do not pass context to sub item to avoid multiple measure
    return /*#__PURE__*/ $6fFrj.createElement((0, $88989b8c4ef26515$export$79f16dd643143c25).Provider, {
        value: null
    }, /*#__PURE__*/ $6fFrj.createElement((0, $1f354648a2ad5384$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(contextClassName, className)
    }, restContext, restProps)));
};
var $73961540cbae84f5$var$RawItem = /*#__PURE__*/ $6fFrj.forwardRef($73961540cbae84f5$var$InternalRawItem);
$73961540cbae84f5$var$RawItem.displayName = 'RawItem';
var $73961540cbae84f5$export$2e2bcd8739ae039 = $73961540cbae84f5$var$RawItem;



var $61696641a8ba319f$var$_excluded = [
    "prefixCls",
    "data",
    "renderItem",
    "renderRawItem",
    "itemKey",
    "itemWidth",
    "ssr",
    "style",
    "className",
    "maxCount",
    "renderRest",
    "renderRawRest",
    "suffix",
    "component",
    "itemComponent",
    "onVisibleChange"
];
var $61696641a8ba319f$var$RESPONSIVE = 'responsive';
var $61696641a8ba319f$var$INVALIDATE = 'invalidate';
function $61696641a8ba319f$var$defaultRenderRest(omittedItems) {
    return "+ ".concat(omittedItems.length, " ...");
}
function $61696641a8ba319f$var$Overflow(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-overflow' : _props$prefixCls, _props$data = props.data, data = _props$data === void 0 ? [] : _props$data, renderItem = props.renderItem, renderRawItem = props.renderRawItem, itemKey = props.itemKey, _props$itemWidth = props.itemWidth, itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth, ssr = props.ssr, style = props.style, className = props.className, maxCount = props.maxCount, renderRest = props.renderRest, renderRawRest = props.renderRawRest, suffix = props.suffix, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, itemComponent = props.itemComponent, onVisibleChange = props.onVisibleChange, restProps = (0, $04RxA.default)(props, $61696641a8ba319f$var$_excluded);
    var fullySSR = ssr === 'full';
    var notifyEffectUpdate = (0, $38ba160e8146b122$export$eedf51fe9d751c7a)();
    var _useEffectState = (0, $38ba160e8146b122$export$2e2bcd8739ae039)(notifyEffectUpdate, null), _useEffectState2 = (0, $jP8CL.default)(_useEffectState, 2), containerWidth = _useEffectState2[0], setContainerWidth = _useEffectState2[1];
    var mergedContainerWidth = containerWidth || 0;
    var _useEffectState3 = (0, $38ba160e8146b122$export$2e2bcd8739ae039)(notifyEffectUpdate, new Map()), _useEffectState4 = (0, $jP8CL.default)(_useEffectState3, 2), itemWidths = _useEffectState4[0], setItemWidths = _useEffectState4[1];
    var _useEffectState5 = (0, $38ba160e8146b122$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState6 = (0, $jP8CL.default)(_useEffectState5, 2), prevRestWidth = _useEffectState6[0], setPrevRestWidth = _useEffectState6[1];
    var _useEffectState7 = (0, $38ba160e8146b122$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState8 = (0, $jP8CL.default)(_useEffectState7, 2), restWidth = _useEffectState8[0], setRestWidth = _useEffectState8[1];
    var _useEffectState9 = (0, $38ba160e8146b122$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState10 = (0, $jP8CL.default)(_useEffectState9, 2), suffixWidth = _useEffectState10[0], setSuffixWidth = _useEffectState10[1];
    var _useState = (0, $6fFrj.useState)(null), _useState2 = (0, $jP8CL.default)(_useState, 2), suffixFixedStart = _useState2[0], setSuffixFixedStart = _useState2[1];
    var _useState3 = (0, $6fFrj.useState)(null), _useState4 = (0, $jP8CL.default)(_useState3, 2), displayCount = _useState4[0], setDisplayCount = _useState4[1];
    var mergedDisplayCount = $6fFrj.useMemo(function() {
        if (displayCount === null && fullySSR) return Number.MAX_SAFE_INTEGER;
        return displayCount || 0;
    }, [
        displayCount,
        containerWidth
    ]);
    var _useState5 = (0, $6fFrj.useState)(false), _useState6 = (0, $jP8CL.default)(_useState5, 2), restReady = _useState6[0], setRestReady = _useState6[1];
    var itemPrefixCls = "".concat(prefixCls, "-item");
    // Always use the max width to avoid blink
    var mergedRestWidth = Math.max(prevRestWidth, restWidth);
    // ================================= Data =================================
    var isResponsive = maxCount === $61696641a8ba319f$var$RESPONSIVE;
    var shouldResponsive = data.length && isResponsive;
    var invalidate = maxCount === $61696641a8ba319f$var$INVALIDATE;
    /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */ var showRest = shouldResponsive || typeof maxCount === 'number' && data.length > maxCount;
    var mergedData = (0, $6fFrj.useMemo)(function() {
        var items = data;
        if (shouldResponsive) {
            if (containerWidth === null && fullySSR) items = data;
            else items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
        } else if (typeof maxCount === 'number') items = data.slice(0, maxCount);
        return items;
    }, [
        data,
        itemWidth,
        containerWidth,
        maxCount,
        shouldResponsive
    ]);
    var omittedItems = (0, $6fFrj.useMemo)(function() {
        if (shouldResponsive) return data.slice(mergedDisplayCount + 1);
        return data.slice(mergedData.length);
    }, [
        data,
        mergedData,
        shouldResponsive,
        mergedDisplayCount
    ]);
    // ================================= Item =================================
    var getKey = (0, $6fFrj.useCallback)(function(item, index) {
        var _ref;
        if (typeof itemKey === 'function') return itemKey(item);
        return (_ref = itemKey && (item === null || item === void 0 ? void 0 : item[itemKey])) !== null && _ref !== void 0 ? _ref : index;
    }, [
        itemKey
    ]);
    var mergedRenderItem = (0, $6fFrj.useCallback)(renderItem || function(item) {
        return item;
    }, [
        renderItem
    ]);
    function updateDisplayCount(count, suffixFixedStartVal, notReady) {
        // React 18 will sync render even when the value is same in some case.
        // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
        // ref: https://github.com/ant-design/ant-design/issues/36559
        if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) return;
        setDisplayCount(count);
        if (!notReady) {
            setRestReady(count < data.length - 1);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(count);
        }
        if (suffixFixedStartVal !== undefined) setSuffixFixedStart(suffixFixedStartVal);
    }
    // ================================= Size =================================
    function onOverflowResize(_, element) {
        setContainerWidth(element.clientWidth);
    }
    function registerSize(key, width) {
        setItemWidths(function(origin) {
            var clone = new Map(origin);
            if (width === null) clone.delete(key);
            else clone.set(key, width);
            return clone;
        });
    }
    function registerOverflowSize(_, width) {
        setRestWidth(width);
        setPrevRestWidth(restWidth);
    }
    function registerSuffixSize(_, width) {
        setSuffixWidth(width);
    }
    // ================================ Effect ================================
    function getItemWidth(index) {
        return itemWidths.get(getKey(mergedData[index], index));
    }
    (0, $dNZA9.default)(function() {
        if (mergedContainerWidth && typeof mergedRestWidth === 'number' && mergedData) {
            var totalWidth = suffixWidth;
            var len = mergedData.length;
            var lastIndex = len - 1;
            // When data count change to 0, reset this since not loop will reach
            if (!len) {
                updateDisplayCount(0, null);
                return;
            }
            for(var i = 0; i < len; i += 1){
                var currentItemWidth = getItemWidth(i);
                // Fully will always render
                if (fullySSR) currentItemWidth = currentItemWidth || 0;
                // Break since data not ready
                if (currentItemWidth === undefined) {
                    updateDisplayCount(i - 1, undefined, true);
                    break;
                }
                // Find best match
                totalWidth += currentItemWidth;
                if (// Only one means `totalWidth` is the final width
                lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
                i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
                    // Additional check if match the end
                    updateDisplayCount(lastIndex, null);
                    break;
                } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
                    // Can not hold all the content to show rest
                    updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
                    break;
                }
            }
            if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) setSuffixFixedStart(null);
        }
    }, [
        mergedContainerWidth,
        itemWidths,
        restWidth,
        suffixWidth,
        getKey,
        mergedData
    ]);
    // ================================ Render ================================
    var displayRest = restReady && !!omittedItems.length;
    var suffixStyle = {};
    if (suffixFixedStart !== null && shouldResponsive) suffixStyle = {
        position: 'absolute',
        left: suffixFixedStart,
        top: 0
    };
    var itemSharedProps = {
        prefixCls: itemPrefixCls,
        responsive: shouldResponsive,
        component: itemComponent,
        invalidate: invalidate
    };
    // >>>>> Choice render fun by `renderRawItem`
    var internalRenderItemNode = renderRawItem ? function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $6fFrj.createElement((0, $88989b8c4ef26515$export$79f16dd643143c25).Provider, {
            key: key,
            value: (0, $kNxFX.default)((0, $kNxFX.default)({}, itemSharedProps), {}, {
                order: index,
                item: item,
                itemKey: key,
                registerSize: registerSize,
                display: index <= mergedDisplayCount
            })
        }, renderRawItem(item, index));
    } : function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $6fFrj.createElement((0, $1f354648a2ad5384$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, itemSharedProps, {
            order: index,
            key: key,
            item: item,
            renderItem: mergedRenderItem,
            itemKey: key,
            registerSize: registerSize,
            display: index <= mergedDisplayCount
        }));
    };
    // >>>>> Rest node
    var restNode;
    var restContextProps = {
        order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
        className: "".concat(itemPrefixCls, "-rest"),
        registerSize: registerOverflowSize,
        display: displayRest
    };
    if (!renderRawRest) {
        var mergedRenderRest = renderRest || $61696641a8ba319f$var$defaultRenderRest;
        restNode = /*#__PURE__*/ $6fFrj.createElement((0, $1f354648a2ad5384$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === 'function' ? mergedRenderRest(omittedItems) : mergedRenderRest);
    } else if (renderRawRest) restNode = /*#__PURE__*/ $6fFrj.createElement((0, $88989b8c4ef26515$export$79f16dd643143c25).Provider, {
        value: (0, $kNxFX.default)((0, $kNxFX.default)({}, itemSharedProps), restContextProps)
    }, renderRawRest(omittedItems));
    var overflowNode = /*#__PURE__*/ $6fFrj.createElement(Component, (0, $fIrcP.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(!invalidate && prefixCls, className),
        style: style,
        ref: ref
    }, restProps), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/ $6fFrj.createElement((0, $1f354648a2ad5384$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: mergedDisplayCount,
        className: "".concat(itemPrefixCls, "-suffix"),
        registerSize: registerSuffixSize,
        display: true,
        style: suffixStyle
    }), suffix));
    if (isResponsive) overflowNode = /*#__PURE__*/ $6fFrj.createElement((0, $8e6bb008621f90f5$export$2e2bcd8739ae039), {
        onResize: onOverflowResize,
        disabled: !shouldResponsive
    }, overflowNode);
    return overflowNode;
}
var $61696641a8ba319f$var$ForwardOverflow = /*#__PURE__*/ $6fFrj.forwardRef($61696641a8ba319f$var$Overflow);
$61696641a8ba319f$var$ForwardOverflow.displayName = 'Overflow';
$61696641a8ba319f$var$ForwardOverflow.Item = (0, $73961540cbae84f5$export$2e2bcd8739ae039);
$61696641a8ba319f$var$ForwardOverflow.RESPONSIVE = $61696641a8ba319f$var$RESPONSIVE;
$61696641a8ba319f$var$ForwardOverflow.INVALIDATE = $61696641a8ba319f$var$INVALIDATE;
var // Convert to generic type
$61696641a8ba319f$export$2e2bcd8739ae039 = $61696641a8ba319f$var$ForwardOverflow;


var $fc57648bf28f775c$export$2e2bcd8739ae039 = (0, $61696641a8ba319f$export$2e2bcd8739ae039);



var $gfhff = parcelRequire("gfhff");
parcelRequire("3mXQ2");

var $6fFrj = parcelRequire("6fFrj");

var $8CZEB = parcelRequire("8CZEB");


var $6fFrj = parcelRequire("6fFrj");
var $9e8d0e518a1dc972$export$26537912ea160acd = /*#__PURE__*/ $6fFrj.createContext(null);
function $9e8d0e518a1dc972$export$80c871fe8d6b896(uuid, eventKey) {
    if (uuid === undefined) return null;
    return "".concat(uuid, "-").concat(eventKey);
}
function $9e8d0e518a1dc972$export$a276eb4e9be640f8(eventKey) {
    var id = $6fFrj.useContext($9e8d0e518a1dc972$export$26537912ea160acd);
    return $9e8d0e518a1dc972$export$80c871fe8d6b896(id, eventKey);
}



var $04RxA = parcelRequire("04RxA");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");

var $a5lfY = parcelRequire("a5lfY");

var $ce084908a5b6df24$var$_excluded = [
    "children",
    "locked"
];
var $ce084908a5b6df24$export$c7e742effb1c51e2 = /*#__PURE__*/ $6fFrj.createContext(null);
function $ce084908a5b6df24$var$mergeProps(origin, target) {
    var clone = (0, $kNxFX.default)({}, origin);
    Object.keys(target).forEach(function(key) {
        var value = target[key];
        if (value !== undefined) clone[key] = value;
    });
    return clone;
}
function $ce084908a5b6df24$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, locked = _ref.locked, restProps = (0, $04RxA.default)(_ref, $ce084908a5b6df24$var$_excluded);
    var context = $6fFrj.useContext($ce084908a5b6df24$export$c7e742effb1c51e2);
    var inheritableContext = (0, $a5lfY.default)(function() {
        return $ce084908a5b6df24$var$mergeProps(context, restProps);
    }, [
        context,
        restProps
    ], function(prev, next) {
        return !locked && (prev[0] !== next[0] || !(0, $ae3c1fae8a247572$export$2e2bcd8739ae039)(prev[1], next[1], true));
    });
    return /*#__PURE__*/ $6fFrj.createElement($ce084908a5b6df24$export$c7e742effb1c51e2.Provider, {
        value: inheritableContext
    }, children);
}



var $37xND = parcelRequire("37xND");

var $6fFrj = parcelRequire("6fFrj");
var $67da814b8e602a99$var$EmptyList = [];
var $67da814b8e602a99$export$d9ffb5bfd108b003 = /*#__PURE__*/ $6fFrj.createContext(null);
function $67da814b8e602a99$export$e295b0c537d32d7d() {
    return $6fFrj.useContext($67da814b8e602a99$export$d9ffb5bfd108b003);
}
var $67da814b8e602a99$export$54d9e16aa4c8a7fa = /*#__PURE__*/ $6fFrj.createContext($67da814b8e602a99$var$EmptyList);
function $67da814b8e602a99$export$d3d2d0a05677870a(eventKey) {
    var parentKeyPath = $6fFrj.useContext($67da814b8e602a99$export$54d9e16aa4c8a7fa);
    return $6fFrj.useMemo(function() {
        return eventKey !== undefined ? [].concat((0, $37xND.default)(parentKeyPath), [
            eventKey
        ]) : parentKeyPath;
    }, [
        parentKeyPath,
        eventKey
    ]);
}
var $67da814b8e602a99$export$f0b9e0db98edfa53 = /*#__PURE__*/ $6fFrj.createContext(null);



var $6fFrj = parcelRequire("6fFrj");
var $f381238ea25fd8cc$var$PrivateContext = /*#__PURE__*/ $6fFrj.createContext({});
var $f381238ea25fd8cc$export$2e2bcd8739ae039 = $f381238ea25fd8cc$var$PrivateContext;



var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");


var $hqic8 = parcelRequire("hqic8");


// destruct to reduce minify size
var $3110c80b4066b713$var$LEFT = (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).LEFT, $3110c80b4066b713$var$RIGHT = (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).RIGHT, $3110c80b4066b713$var$UP = (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).UP, $3110c80b4066b713$var$DOWN = (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).DOWN, $3110c80b4066b713$var$ENTER = (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER, $3110c80b4066b713$var$ESC = (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ESC, $3110c80b4066b713$var$HOME = (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).HOME, $3110c80b4066b713$var$END = (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).END;
var $3110c80b4066b713$var$ArrowKeys = [
    $3110c80b4066b713$var$UP,
    $3110c80b4066b713$var$DOWN,
    $3110c80b4066b713$var$LEFT,
    $3110c80b4066b713$var$RIGHT
];
function $3110c80b4066b713$var$getOffset(mode, isRootLevel, isRtl, which) {
    var _inline, _horizontal, _vertical, _offsets;
    var prev = 'prev';
    var next = 'next';
    var children = 'children';
    var parent = 'parent';
    // Inline enter is special that we use unique operation
    if (mode === 'inline' && which === $3110c80b4066b713$var$ENTER) return {
        inlineTrigger: true
    };
    var inline = (_inline = {}, (0, $43449.default)(_inline, $3110c80b4066b713$var$UP, prev), (0, $43449.default)(_inline, $3110c80b4066b713$var$DOWN, next), _inline);
    var horizontal = (_horizontal = {}, (0, $43449.default)(_horizontal, $3110c80b4066b713$var$LEFT, isRtl ? next : prev), (0, $43449.default)(_horizontal, $3110c80b4066b713$var$RIGHT, isRtl ? prev : next), (0, $43449.default)(_horizontal, $3110c80b4066b713$var$DOWN, children), (0, $43449.default)(_horizontal, $3110c80b4066b713$var$ENTER, children), _horizontal);
    var vertical = (_vertical = {}, (0, $43449.default)(_vertical, $3110c80b4066b713$var$UP, prev), (0, $43449.default)(_vertical, $3110c80b4066b713$var$DOWN, next), (0, $43449.default)(_vertical, $3110c80b4066b713$var$ENTER, children), (0, $43449.default)(_vertical, $3110c80b4066b713$var$ESC, parent), (0, $43449.default)(_vertical, $3110c80b4066b713$var$LEFT, isRtl ? children : parent), (0, $43449.default)(_vertical, $3110c80b4066b713$var$RIGHT, isRtl ? parent : children), _vertical);
    var offsets = {
        inline: inline,
        horizontal: horizontal,
        vertical: vertical,
        inlineSub: inline,
        horizontalSub: vertical,
        verticalSub: vertical
    };
    var type = (_offsets = offsets["".concat(mode).concat(isRootLevel ? '' : 'Sub')]) === null || _offsets === void 0 ? void 0 : _offsets[which];
    switch(type){
        case prev:
            return {
                offset: -1,
                sibling: true
            };
        case next:
            return {
                offset: 1,
                sibling: true
            };
        case parent:
            return {
                offset: -1,
                sibling: false
            };
        case children:
            return {
                offset: 1,
                sibling: false
            };
        default:
            return null;
    }
}
function $3110c80b4066b713$var$findContainerUL(element) {
    var current = element;
    while(current){
        if (current.getAttribute('data-menu-list')) return current;
        current = current.parentElement;
    }
    // Normally should not reach this line
    /* istanbul ignore next */ return null;
}
/**
 * Find focused element within element set provided
 */ function $3110c80b4066b713$var$getFocusElement(activeElement, elements) {
    var current = activeElement || document.activeElement;
    while(current){
        if (elements.has(current)) return current;
        current = current.parentElement;
    }
    return null;
}
/**
 * Get focusable elements from the element set under provided container
 */ function $3110c80b4066b713$var$getFocusableElements(container, elements) {
    var list = (0, $22fc973f01fa8b1e$export$bbc7b5f11aba534b)(container, true);
    return list.filter(function(ele) {
        return elements.has(ele);
    });
}
function $3110c80b4066b713$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement) {
    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    // Key on the menu item will not get validate parent container
    if (!parentQueryContainer) return null;
    // List current level menu item elements
    var sameLevelFocusableMenuElementList = $3110c80b4066b713$var$getFocusableElements(parentQueryContainer, elements);
    // Find next focus index
    var count = sameLevelFocusableMenuElementList.length;
    var focusIndex = sameLevelFocusableMenuElementList.findIndex(function(ele) {
        return focusMenuElement === ele;
    });
    if (offset < 0) {
        if (focusIndex === -1) focusIndex = count - 1;
        else focusIndex -= 1;
    } else if (offset > 0) focusIndex += 1;
    focusIndex = (focusIndex + count) % count;
    // Focus menu item
    return sameLevelFocusableMenuElementList[focusIndex];
}
function $3110c80b4066b713$export$2e2bcd8739ae039(mode, activeKey, isRtl, id, containerRef, getKeys, getKeyPath, triggerActiveKey, triggerAccessibilityOpen, originOnKeyDown) {
    var rafRef = $6fFrj.useRef();
    var activeRef = $6fFrj.useRef();
    activeRef.current = activeKey;
    var cleanRaf = function cleanRaf() {
        (0, $hqic8.default).cancel(rafRef.current);
    };
    $6fFrj.useEffect(function() {
        return function() {
            cleanRaf();
        };
    }, []);
    return function(e) {
        var which = e.which;
        if ([].concat($3110c80b4066b713$var$ArrowKeys, [
            $3110c80b4066b713$var$ENTER,
            $3110c80b4066b713$var$ESC,
            $3110c80b4066b713$var$HOME,
            $3110c80b4066b713$var$END
        ]).includes(which)) {
            // Convert key to elements
            var elements;
            var key2element;
            var element2key;
            // >>> Wrap as function since we use raf for some case
            var refreshElements = function refreshElements() {
                elements = new Set();
                key2element = new Map();
                element2key = new Map();
                var keys = getKeys();
                keys.forEach(function(key) {
                    var element = document.querySelector("[data-menu-id='".concat((0, $9e8d0e518a1dc972$export$80c871fe8d6b896)(id, key), "']"));
                    if (element) {
                        elements.add(element);
                        element2key.set(element, key);
                        key2element.set(key, element);
                    }
                });
                return elements;
            };
            refreshElements();
            // First we should find current focused MenuItem/SubMenu element
            var activeElement = key2element.get(activeKey);
            var focusMenuElement = $3110c80b4066b713$var$getFocusElement(activeElement, elements);
            var focusMenuKey = element2key.get(focusMenuElement);
            var offsetObj = $3110c80b4066b713$var$getOffset(mode, getKeyPath(focusMenuKey, true).length === 1, isRtl, which);
            // Some mode do not have fully arrow operation like inline
            if (!offsetObj && which !== $3110c80b4066b713$var$HOME && which !== $3110c80b4066b713$var$END) return;
            // Arrow prevent default to avoid page scroll
            if ($3110c80b4066b713$var$ArrowKeys.includes(which) || [
                $3110c80b4066b713$var$HOME,
                $3110c80b4066b713$var$END
            ].includes(which)) e.preventDefault();
            var tryFocus = function tryFocus(menuElement) {
                if (menuElement) {
                    var focusTargetElement = menuElement;
                    // Focus to link instead of menu item if possible
                    var link = menuElement.querySelector('a');
                    if (link !== null && link !== void 0 && link.getAttribute('href')) focusTargetElement = link;
                    var targetKey = element2key.get(menuElement);
                    triggerActiveKey(targetKey);
                    /**
           * Do not `useEffect` here since `tryFocus` may trigger async
           * which makes React sync update the `activeKey`
           * that force render before `useRef` set the next activeKey
           */ cleanRaf();
                    rafRef.current = (0, $hqic8.default)(function() {
                        if (activeRef.current === targetKey) focusTargetElement.focus();
                    });
                }
            };
            if ([
                $3110c80b4066b713$var$HOME,
                $3110c80b4066b713$var$END
            ].includes(which) || offsetObj.sibling || !focusMenuElement) {
                // ========================== Sibling ==========================
                // Find walkable focus menu element container
                var parentQueryContainer;
                if (!focusMenuElement || mode === 'inline') parentQueryContainer = containerRef.current;
                else parentQueryContainer = $3110c80b4066b713$var$findContainerUL(focusMenuElement);
                // Get next focus element
                var targetElement;
                var focusableElements = $3110c80b4066b713$var$getFocusableElements(parentQueryContainer, elements);
                if (which === $3110c80b4066b713$var$HOME) targetElement = focusableElements[0];
                else if (which === $3110c80b4066b713$var$END) targetElement = focusableElements[focusableElements.length - 1];
                else targetElement = $3110c80b4066b713$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offsetObj.offset);
                // Focus menu item
                tryFocus(targetElement);
            // ======================= InlineTrigger =======================
            } else if (offsetObj.inlineTrigger) // Inline trigger no need switch to sub menu item
            triggerAccessibilityOpen(focusMenuKey);
            else if (offsetObj.offset > 0) {
                triggerAccessibilityOpen(focusMenuKey, true);
                cleanRaf();
                rafRef.current = (0, $hqic8.default)(function() {
                    // Async should resync elements
                    refreshElements();
                    var controlId = focusMenuElement.getAttribute('aria-controls');
                    var subQueryContainer = document.getElementById(controlId);
                    // Get sub focusable menu item
                    var targetElement = $3110c80b4066b713$var$getNextFocusElement(subQueryContainer, elements);
                    // Focus menu item
                    tryFocus(targetElement);
                }, 5);
            } else if (offsetObj.offset < 0) {
                var keyPath = getKeyPath(focusMenuKey, true);
                var parentKey = keyPath[keyPath.length - 2];
                var parentMenuElement = key2element.get(parentKey);
                // Focus menu item
                triggerAccessibilityOpen(parentKey, false);
                tryFocus(parentMenuElement);
            }
        }
        // Pass origin key down event
        originOnKeyDown === null || originOnKeyDown === void 0 || originOnKeyDown(e);
    };
}



var $37xND = parcelRequire("37xND");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
parcelRequire("3mXQ2");
function $e1609dd2394340ab$export$7693db51ef834b40(callback) {
    /* istanbul ignore next */ Promise.resolve().then(callback);
}


var $e3c6045630e6874f$var$PATH_SPLIT = '__RC_UTIL_PATH_SPLIT__';
var $e3c6045630e6874f$var$getPathStr = function getPathStr(keyPath) {
    return keyPath.join($e3c6045630e6874f$var$PATH_SPLIT);
};
var $e3c6045630e6874f$var$getPathKeys = function getPathKeys(keyPathStr) {
    return keyPathStr.split($e3c6045630e6874f$var$PATH_SPLIT);
};
var $e3c6045630e6874f$export$20a0132c46ce5b04 = 'rc-menu-more';
function $e3c6045630e6874f$export$2e2bcd8739ae039() {
    var _React$useState = $6fFrj.useState({}), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), internalForceUpdate = _React$useState2[1];
    var key2pathRef = (0, $6fFrj.useRef)(new Map());
    var path2keyRef = (0, $6fFrj.useRef)(new Map());
    var _React$useState3 = $6fFrj.useState([]), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), overflowKeys = _React$useState4[0], setOverflowKeys = _React$useState4[1];
    var updateRef = (0, $6fFrj.useRef)(0);
    var destroyRef = (0, $6fFrj.useRef)(false);
    var forceUpdate = function forceUpdate() {
        if (!destroyRef.current) internalForceUpdate({});
    };
    var registerPath = (0, $6fFrj.useCallback)(function(key, keyPath) {
        // Fill map
        var connectedPath = $e3c6045630e6874f$var$getPathStr(keyPath);
        path2keyRef.current.set(connectedPath, key);
        key2pathRef.current.set(key, connectedPath);
        updateRef.current += 1;
        var id = updateRef.current;
        (0, $e1609dd2394340ab$export$7693db51ef834b40)(function() {
            if (id === updateRef.current) forceUpdate();
        });
    }, []);
    var unregisterPath = (0, $6fFrj.useCallback)(function(key, keyPath) {
        var connectedPath = $e3c6045630e6874f$var$getPathStr(keyPath);
        path2keyRef.current.delete(connectedPath);
        key2pathRef.current.delete(key);
    }, []);
    var refreshOverflowKeys = (0, $6fFrj.useCallback)(function(keys) {
        setOverflowKeys(keys);
    }, []);
    var getKeyPath = (0, $6fFrj.useCallback)(function(eventKey, includeOverflow) {
        var fullPath = key2pathRef.current.get(eventKey) || '';
        var keys = $e3c6045630e6874f$var$getPathKeys(fullPath);
        if (includeOverflow && overflowKeys.includes(keys[0])) keys.unshift($e3c6045630e6874f$export$20a0132c46ce5b04);
        return keys;
    }, [
        overflowKeys
    ]);
    var isSubPathKey = (0, $6fFrj.useCallback)(function(pathKeys, eventKey) {
        return pathKeys.some(function(pathKey) {
            var pathKeyList = getKeyPath(pathKey, true);
            return pathKeyList.includes(eventKey);
        });
    }, [
        getKeyPath
    ]);
    var getKeys = function getKeys() {
        var keys = (0, $37xND.default)(key2pathRef.current.keys());
        if (overflowKeys.length) keys.push($e3c6045630e6874f$export$20a0132c46ce5b04);
        return keys;
    };
    /**
   * Find current key related child path keys
   */ var getSubPathKeys = (0, $6fFrj.useCallback)(function(key) {
        var connectedPath = "".concat(key2pathRef.current.get(key)).concat($e3c6045630e6874f$var$PATH_SPLIT);
        var pathKeys = new Set();
        (0, $37xND.default)(path2keyRef.current.keys()).forEach(function(pathKey) {
            if (pathKey.startsWith(connectedPath)) pathKeys.add(path2keyRef.current.get(pathKey));
        });
        return pathKeys;
    }, []);
    $6fFrj.useEffect(function() {
        return function() {
            destroyRef.current = true;
        };
    }, []);
    return {
        // Register
        registerPath: registerPath,
        unregisterPath: unregisterPath,
        refreshOverflowKeys: refreshOverflowKeys,
        // Util
        isSubPathKey: isSubPathKey,
        getKeyPath: getKeyPath,
        getKeys: getKeys,
        getSubPathKeys: getSubPathKeys
    };
}



var $6fFrj = parcelRequire("6fFrj");
function $24e48e9f32415e6c$export$2e2bcd8739ae039(func) {
    var funRef = $6fFrj.useRef(func);
    funRef.current = func;
    var callback = $6fFrj.useCallback(function() {
        var _funRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_funRef$current = funRef.current) === null || _funRef$current === void 0 ? void 0 : _funRef$current.call.apply(_funRef$current, [
            funRef
        ].concat(args));
    }, []);
    return func ? callback : undefined;
}



var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $gfhff = parcelRequire("gfhff");
var $c8b292dfb920a361$var$uniquePrefix = Math.random().toFixed(5).toString().slice(2);
var $c8b292dfb920a361$var$internalId = 0;
function $c8b292dfb920a361$export$2e2bcd8739ae039(id) {
    var _useMergedState = (0, $gfhff.default)(id, {
        value: id
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), uuid = _useMergedState2[0], setUUID = _useMergedState2[1];
    $6fFrj.useEffect(function() {
        $c8b292dfb920a361$var$internalId += 1;
        var newId = "".concat($c8b292dfb920a361$var$uniquePrefix, "-").concat($c8b292dfb920a361$var$internalId);
        setUUID("rc-menu-uuid-".concat(newId));
    }, []);
    return uuid;
}



var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $37xND = parcelRequire("37xND");

var $fIrcP = parcelRequire("fIrcP");

var $04RxA = parcelRequire("04RxA");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $fActo = parcelRequire("fActo");




var $3BOWT = parcelRequire("3BOWT");

var $3mXQ2 = parcelRequire("3mXQ2");

var $6fFrj = parcelRequire("6fFrj");





var $6fFrj = parcelRequire("6fFrj");

function $c17982cef67c66ea$export$2e2bcd8739ae039(eventKey, disabled, onMouseEnter, onMouseLeave) {
    var _React$useContext = $6fFrj.useContext((0, $ce084908a5b6df24$export$c7e742effb1c51e2)), activeKey = _React$useContext.activeKey, onActive = _React$useContext.onActive, onInactive = _React$useContext.onInactive;
    var ret = {
        active: activeKey === eventKey
    };
    // Skip when disabled
    if (!disabled) {
        ret.onMouseEnter = function(domEvent) {
            onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
                key: eventKey,
                domEvent: domEvent
            });
            onActive(eventKey);
        };
        ret.onMouseLeave = function(domEvent) {
            onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
                key: eventKey,
                domEvent: domEvent
            });
            onInactive(eventKey);
        };
    }
    return ret;
}



var $6fFrj = parcelRequire("6fFrj");

function $6d0a74bc15e6364f$export$2e2bcd8739ae039(level) {
    var _React$useContext = $6fFrj.useContext((0, $ce084908a5b6df24$export$c7e742effb1c51e2)), mode = _React$useContext.mode, rtl = _React$useContext.rtl, inlineIndent = _React$useContext.inlineIndent;
    if (mode !== 'inline') return null;
    var len = level;
    return rtl ? {
        paddingRight: len * inlineIndent
    } : {
        paddingLeft: len * inlineIndent
    };
}



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
function $d0ba4ba893e82bd8$export$2e2bcd8739ae039(_ref) {
    var icon = _ref.icon, props = _ref.props, children = _ref.children;
    var iconNode;
    if (typeof icon === 'function') iconNode = /*#__PURE__*/ $6fFrj.createElement(icon, (0, $kNxFX.default)({}, props));
    else // Compatible for origin definition
    iconNode = icon;
    return iconNode || children || null;
}



var $04RxA = parcelRequire("04RxA");

var $3mXQ2 = parcelRequire("3mXQ2");
var $19cf396193749cc8$var$_excluded = [
    "item"
];
function $19cf396193749cc8$export$e189bcd94b66c1db(_ref) {
    var item = _ref.item, restInfo = (0, $04RxA.default)(_ref, $19cf396193749cc8$var$_excluded);
    Object.defineProperty(restInfo, 'item', {
        get: function get() {
            (0, $3mXQ2.default)(false, '`info.item` is deprecated since we will move to function component that not provides React Node instance in future.');
            return item;
        }
    });
    return restInfo;
}


var $cfbb4b13af7f52cb$var$_excluded = [
    "title",
    "attribute",
    "elementRef"
], $cfbb4b13af7f52cb$var$_excluded2 = [
    "style",
    "className",
    "eventKey",
    "warnKey",
    "disabled",
    "itemIcon",
    "children",
    "role",
    "onMouseEnter",
    "onMouseLeave",
    "onClick",
    "onKeyDown",
    "onFocus"
], $cfbb4b13af7f52cb$var$_excluded3 = [
    "active"
];
// Since Menu event provide the `info.item` which point to the MenuItem node instance.
// We have to use class component here.
// This should be removed from doc & api in future.
var $cfbb4b13af7f52cb$var$LegacyMenuItem = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(LegacyMenuItem, _React$Component);
    var _super = (0, $lSufv.default)(LegacyMenuItem);
    function LegacyMenuItem() {
        (0, $kjNeN.default)(this, LegacyMenuItem);
        return _super.apply(this, arguments);
    }
    (0, $5KQxu.default)(LegacyMenuItem, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, title = _this$props.title, attribute = _this$props.attribute, elementRef = _this$props.elementRef, restProps = (0, $04RxA.default)(_this$props, $cfbb4b13af7f52cb$var$_excluded);
                // Here the props are eventually passed to the DOM element.
                // React does not recognize non-standard attributes.
                // Therefore, remove the props that is not used here.
                // ref: https://github.com/ant-design/ant-design/issues/41395
                var passedProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(restProps, [
                    'eventKey',
                    'popupClassName',
                    'popupOffset',
                    'onTitleClick'
                ]);
                (0, $3mXQ2.default)(!attribute, '`attribute` of Menu.Item is deprecated. Please pass attribute directly.');
                return /*#__PURE__*/ $6fFrj.createElement((0, $fc57648bf28f775c$export$2e2bcd8739ae039).Item, (0, $fIrcP.default)({}, attribute, {
                    title: typeof title === 'string' ? title : undefined
                }, passedProps, {
                    ref: elementRef
                }));
            }
        }
    ]);
    return LegacyMenuItem;
}($6fFrj.Component);
/**
 * Real Menu Item component
 */ var $cfbb4b13af7f52cb$var$InternalMenuItem = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _classNames;
    var style = props.style, className = props.className, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, itemIcon = props.itemIcon, children = props.children, role = props.role, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown = props.onKeyDown, onFocus = props.onFocus, restProps = (0, $04RxA.default)(props, $cfbb4b13af7f52cb$var$_excluded2);
    var domDataId = (0, $9e8d0e518a1dc972$export$a276eb4e9be640f8)(eventKey);
    var _React$useContext = $6fFrj.useContext((0, $ce084908a5b6df24$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, onItemClick = _React$useContext.onItemClick, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, contextItemIcon = _React$useContext.itemIcon, selectedKeys = _React$useContext.selectedKeys, onActive = _React$useContext.onActive;
    var _React$useContext2 = $6fFrj.useContext((0, $f381238ea25fd8cc$export$2e2bcd8739ae039)), _internalRenderMenuItem = _React$useContext2._internalRenderMenuItem;
    var itemCls = "".concat(prefixCls, "-item");
    var legacyMenuItemRef = $6fFrj.useRef();
    var elementRef = $6fFrj.useRef();
    var mergedDisabled = contextDisabled || disabled;
    var mergedEleRef = (0, $3BOWT.useComposeRef)(ref, elementRef);
    var connectedKeys = (0, $67da814b8e602a99$export$d3d2d0a05677870a)(eventKey);
    // ============================= Info =============================
    var getEventInfo = function getEventInfo(e) {
        return {
            key: eventKey,
            // Note: For legacy code is reversed which not like other antd component
            keyPath: (0, $37xND.default)(connectedKeys).reverse(),
            item: legacyMenuItemRef.current,
            domEvent: e
        };
    };
    // ============================= Icon =============================
    var mergedItemIcon = itemIcon || contextItemIcon;
    // ============================ Active ============================
    var _useActive = (0, $c17982cef67c66ea$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onMouseEnter, onMouseLeave), active = _useActive.active, activeProps = (0, $04RxA.default)(_useActive, $cfbb4b13af7f52cb$var$_excluded3);
    // ============================ Select ============================
    var selected = selectedKeys.includes(eventKey);
    // ======================== DirectionStyle ========================
    var directionStyle = (0, $6d0a74bc15e6364f$export$2e2bcd8739ae039)(connectedKeys.length);
    // ============================ Events ============================
    var onInternalClick = function onInternalClick(e) {
        if (mergedDisabled) return;
        var info = getEventInfo(e);
        onClick === null || onClick === void 0 || onClick((0, $19cf396193749cc8$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    };
    var onInternalKeyDown = function onInternalKeyDown(e) {
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
        if (e.which === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER) {
            var info = getEventInfo(e);
            // Legacy. Key will also trigger click event
            onClick === null || onClick === void 0 || onClick((0, $19cf396193749cc8$export$e189bcd94b66c1db)(info));
            onItemClick(info);
        }
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ var onInternalFocus = function onInternalFocus(e) {
        onActive(eventKey);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    // ============================ Render ============================
    var optionRoleProps = {};
    if (props.role === 'option') optionRoleProps['aria-selected'] = selected;
    var renderNode = /*#__PURE__*/ $6fFrj.createElement($cfbb4b13af7f52cb$var$LegacyMenuItem, (0, $fIrcP.default)({
        ref: legacyMenuItemRef,
        elementRef: mergedEleRef,
        role: role === null ? 'none' : role || 'menuitem',
        tabIndex: disabled ? null : -1,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId
    }, restProps, activeProps, optionRoleProps, {
        component: "li",
        "aria-disabled": disabled,
        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, directionStyle), style),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(itemCls, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(itemCls, "-active"), active), (0, $43449.default)(_classNames, "".concat(itemCls, "-selected"), selected), (0, $43449.default)(_classNames, "".concat(itemCls, "-disabled"), mergedDisabled), _classNames), className),
        onClick: onInternalClick,
        onKeyDown: onInternalKeyDown,
        onFocus: onInternalFocus
    }), children, /*#__PURE__*/ $6fFrj.createElement((0, $d0ba4ba893e82bd8$export$2e2bcd8739ae039), {
        props: (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
            isSelected: selected
        }),
        icon: mergedItemIcon
    }));
    if (_internalRenderMenuItem) renderNode = _internalRenderMenuItem(renderNode, props, {
        selected: selected
    });
    return renderNode;
});
function $cfbb4b13af7f52cb$var$MenuItem(props, ref) {
    var eventKey = props.eventKey;
    // ==================== Record KeyPath ====================
    var measure = (0, $67da814b8e602a99$export$e295b0c537d32d7d)();
    var connectedKeyPath = (0, $67da814b8e602a99$export$d3d2d0a05677870a)(eventKey);
    // eslint-disable-next-line consistent-return
    $6fFrj.useEffect(function() {
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return function() {
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    if (measure) return null;
    // ======================== Render ========================
    return /*#__PURE__*/ $6fFrj.createElement($cfbb4b13af7f52cb$var$InternalMenuItem, (0, $fIrcP.default)({}, props, {
        ref: ref
    }));
}
var $cfbb4b13af7f52cb$export$2e2bcd8739ae039 = /*#__PURE__*/ $6fFrj.forwardRef($cfbb4b13af7f52cb$var$MenuItem);



var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

parcelRequire("3mXQ2");

var $fIrcP = parcelRequire("fIrcP");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $1dd3c5eee5c7e0af$var$_excluded = [
    "className",
    "children"
];
var $1dd3c5eee5c7e0af$var$InternalSubMenuList = function InternalSubMenuList(_ref, ref) {
    var className = _ref.className, children = _ref.children, restProps = (0, $04RxA.default)(_ref, $1dd3c5eee5c7e0af$var$_excluded);
    var _React$useContext = $6fFrj.useContext((0, $ce084908a5b6df24$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, rtl = _React$useContext.rtl;
    return /*#__PURE__*/ $6fFrj.createElement("ul", (0, $fIrcP.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, rtl && "".concat(prefixCls, "-rtl"), "".concat(prefixCls, "-sub"), "".concat(prefixCls, "-").concat(mode === 'inline' ? 'inline' : 'vertical'), className),
        role: "menu"
    }, restProps, {
        "data-menu-list": true,
        ref: ref
    }), children);
};
var $1dd3c5eee5c7e0af$var$SubMenuList = /*#__PURE__*/ $6fFrj.forwardRef($1dd3c5eee5c7e0af$var$InternalSubMenuList);
$1dd3c5eee5c7e0af$var$SubMenuList.displayName = 'SubMenuList';
var $1dd3c5eee5c7e0af$export$2e2bcd8739ae039 = $1dd3c5eee5c7e0af$var$SubMenuList;



var $fIrcP = parcelRequire("fIrcP");

var $04RxA = parcelRequire("04RxA");

var $5KhTJ = parcelRequire("5KhTJ");

var $37xND = parcelRequire("37xND");

var $6fFrj = parcelRequire("6fFrj");


var $69416edeb618b526$var$_excluded = [
    "label",
    "children",
    "key",
    "type"
];
function $69416edeb618b526$export$cd230e97e668be9(children, keyPath) {
    return (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(children).map(function(child, index) {
        if (/*#__PURE__*/ $6fFrj.isValidElement(child)) {
            var _eventKey, _child$props;
            var key = child.key;
            var eventKey = (_eventKey = (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.eventKey) !== null && _eventKey !== void 0 ? _eventKey : key;
            var emptyKey = eventKey === null || eventKey === undefined;
            if (emptyKey) eventKey = "tmp_key-".concat([].concat((0, $37xND.default)(keyPath), [
                index
            ]).join('-'));
            var cloneProps = {
                key: eventKey,
                eventKey: eventKey
            };
            return /*#__PURE__*/ $6fFrj.cloneElement(child, cloneProps);
        }
        return child;
    });
}
function $69416edeb618b526$var$convertItemsToNodes(list) {
    return (list || []).map(function(opt, index) {
        if (opt && (0, $5KhTJ.default)(opt) === 'object') {
            var _ref = opt, label = _ref.label, children = _ref.children, key = _ref.key, type = _ref.type, restProps = (0, $04RxA.default)(_ref, $69416edeb618b526$var$_excluded);
            var mergedKey = key !== null && key !== void 0 ? key : "tmp-".concat(index);
            // MenuItemGroup & SubMenuItem
            if (children || type === 'group') {
                if (type === 'group') // Group
                return /*#__PURE__*/ $6fFrj.createElement((0, $cdb8e70fed13b889$export$2e2bcd8739ae039), (0, $fIrcP.default)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $69416edeb618b526$var$convertItemsToNodes(children));
                // Sub Menu
                return /*#__PURE__*/ $6fFrj.createElement((0, $e492d8fcbd34a95f$export$2e2bcd8739ae039), (0, $fIrcP.default)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $69416edeb618b526$var$convertItemsToNodes(children));
            }
            // MenuItem & Divider
            if (type === 'divider') return /*#__PURE__*/ $6fFrj.createElement((0, $690ad7706592297b$export$2e2bcd8739ae039), (0, $fIrcP.default)({
                key: mergedKey
            }, restProps));
            return /*#__PURE__*/ $6fFrj.createElement((0, $cfbb4b13af7f52cb$export$2e2bcd8739ae039), (0, $fIrcP.default)({
                key: mergedKey
            }, restProps), label);
        }
        return null;
    }).filter(function(opt) {
        return opt;
    });
}
function $69416edeb618b526$export$50458dc1a9a0f894(children, items, keyPath) {
    var childNodes = children;
    if (items) childNodes = $69416edeb618b526$var$convertItemsToNodes(items);
    return $69416edeb618b526$export$cd230e97e668be9(childNodes, keyPath);
}





var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");


var $fActo = parcelRequire("fActo");

var $hqic8 = parcelRequire("hqic8");

var $cd2db73954cd8883$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $cd2db73954cd8883$export$803cd8101b6c182b = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $cd2db73954cd8883$var$autoAdjustOverflow,
        offset: [
            0,
            -7
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $cd2db73954cd8883$var$autoAdjustOverflow,
        offset: [
            0,
            7
        ]
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $cd2db73954cd8883$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ]
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $cd2db73954cd8883$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ]
    }
};
var $cd2db73954cd8883$export$e2b3f69b0a16e1f = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $cd2db73954cd8883$var$autoAdjustOverflow,
        offset: [
            0,
            -7
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $cd2db73954cd8883$var$autoAdjustOverflow,
        offset: [
            0,
            7
        ]
    },
    rightTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $cd2db73954cd8883$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ]
    },
    leftTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $cd2db73954cd8883$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ]
    }
};
var $cd2db73954cd8883$export$2e2bcd8739ae039 = $cd2db73954cd8883$export$803cd8101b6c182b;


function $7e2a1704922a44af$export$7b8936ddc277a29a(mode, motion, defaultMotions) {
    if (motion) return motion;
    if (defaultMotions) return defaultMotions[mode] || defaultMotions.other;
    return undefined;
}


var $16084f5b04393abb$var$popupPlacementMap = {
    horizontal: 'bottomLeft',
    vertical: 'rightTop',
    'vertical-left': 'rightTop',
    'vertical-right': 'leftTop'
};
function $16084f5b04393abb$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, visible = _ref.visible, children = _ref.children, popup = _ref.popup, popupClassName = _ref.popupClassName, popupOffset = _ref.popupOffset, disabled = _ref.disabled, mode = _ref.mode, onVisibleChange = _ref.onVisibleChange;
    var _React$useContext = $6fFrj.useContext((0, $ce084908a5b6df24$export$c7e742effb1c51e2)), getPopupContainer = _React$useContext.getPopupContainer, rtl = _React$useContext.rtl, subMenuOpenDelay = _React$useContext.subMenuOpenDelay, subMenuCloseDelay = _React$useContext.subMenuCloseDelay, builtinPlacements = _React$useContext.builtinPlacements, triggerSubMenuAction = _React$useContext.triggerSubMenuAction, forceSubMenuRender = _React$useContext.forceSubMenuRender, rootClassName = _React$useContext.rootClassName, motion = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions;
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), innerVisible = _React$useState2[0], setInnerVisible = _React$useState2[1];
    var placement = rtl ? (0, $kNxFX.default)((0, $kNxFX.default)({}, (0, $cd2db73954cd8883$export$e2b3f69b0a16e1f)), builtinPlacements) : (0, $kNxFX.default)((0, $kNxFX.default)({}, (0, $cd2db73954cd8883$export$803cd8101b6c182b)), builtinPlacements);
    var popupPlacement = $16084f5b04393abb$var$popupPlacementMap[mode];
    var targetMotion = (0, $7e2a1704922a44af$export$7b8936ddc277a29a)(mode, motion, defaultMotions);
    var targetMotionRef = $6fFrj.useRef(targetMotion);
    if (mode !== 'inline') /**
     * PopupTrigger is only used for vertical and horizontal types.
     * When collapsed is unfolded, the inline animation will destroy the vertical animation.
     */ targetMotionRef.current = targetMotion;
    var mergedMotion = (0, $kNxFX.default)((0, $kNxFX.default)({}, targetMotionRef.current), {}, {
        leavedClassName: "".concat(prefixCls, "-hidden"),
        removeOnLeave: false,
        motionAppear: true
    });
    // Delay to change visible
    var visibleRef = $6fFrj.useRef();
    $6fFrj.useEffect(function() {
        visibleRef.current = (0, $hqic8.default)(function() {
            setInnerVisible(visible);
        });
        return function() {
            (0, $hqic8.default).cancel(visibleRef.current);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $2c9abce2aaa5219e$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-popup"), (0, $43449.default)({}, "".concat(prefixCls, "-rtl"), rtl), popupClassName, rootClassName),
        stretch: mode === 'horizontal' ? 'minWidth' : null,
        getPopupContainer: getPopupContainer,
        builtinPlacements: placement,
        popupPlacement: popupPlacement,
        popupVisible: innerVisible,
        popup: popup,
        popupAlign: popupOffset && {
            offset: popupOffset
        },
        action: disabled ? [] : [
            triggerSubMenuAction
        ],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: onVisibleChange,
        forceRender: forceSubMenuRender,
        popupMotion: mergedMotion
    }, children);
}







var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $5EVeC = parcelRequire("5EVeC");



function $b2e537a69b18f7d5$export$2e2bcd8739ae039(_ref) {
    var id = _ref.id, open = _ref.open, keyPath = _ref.keyPath, children = _ref.children;
    var fixedMode = 'inline';
    var _React$useContext = $6fFrj.useContext((0, $ce084908a5b6df24$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, forceSubMenuRender = _React$useContext.forceSubMenuRender, motion = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions, mode = _React$useContext.mode;
    // Always use latest mode check
    var sameModeRef = $6fFrj.useRef(false);
    sameModeRef.current = mode === fixedMode;
    // We record `destroy` mark here since when mode change from `inline` to others.
    // The inline list should remove when motion end.
    var _React$useState = $6fFrj.useState(!sameModeRef.current), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), destroy = _React$useState2[0], setDestroy = _React$useState2[1];
    var mergedOpen = sameModeRef.current ? open : false;
    // ================================= Effect =================================
    // Reset destroy state when mode change back
    $6fFrj.useEffect(function() {
        if (sameModeRef.current) setDestroy(false);
    }, [
        mode
    ]);
    // ================================= Render =================================
    var mergedMotion = (0, $kNxFX.default)({}, (0, $7e2a1704922a44af$export$7b8936ddc277a29a)(fixedMode, motion, defaultMotions));
    // No need appear since nest inlineCollapse changed
    if (keyPath.length > 1) mergedMotion.motionAppear = false;
    // Hide inline list when mode changed and motion end
    var originOnVisibleChanged = mergedMotion.onVisibleChanged;
    mergedMotion.onVisibleChanged = function(newVisible) {
        if (!sameModeRef.current && !newVisible) setDestroy(true);
        return originOnVisibleChanged === null || originOnVisibleChanged === void 0 ? void 0 : originOnVisibleChanged(newVisible);
    };
    if (destroy) return null;
    return /*#__PURE__*/ $6fFrj.createElement((0, $ce084908a5b6df24$export$2e2bcd8739ae039), {
        mode: fixedMode,
        locked: !sameModeRef.current
    }, /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), (0, $fIrcP.default)({
        visible: mergedOpen
    }, mergedMotion, {
        forceRender: forceSubMenuRender,
        removeOnLeave: false,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }), function(_ref2) {
        var motionClassName = _ref2.className, motionStyle = _ref2.style;
        return /*#__PURE__*/ $6fFrj.createElement((0, $1dd3c5eee5c7e0af$export$2e2bcd8739ae039), {
            id: id,
            className: motionClassName,
            style: motionStyle
        }, children);
    }));
}





var $e492d8fcbd34a95f$var$_excluded = [
    "style",
    "className",
    "title",
    "eventKey",
    "warnKey",
    "disabled",
    "internalPopupClose",
    "children",
    "itemIcon",
    "expandIcon",
    "popupClassName",
    "popupOffset",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onTitleClick",
    "onTitleMouseEnter",
    "onTitleMouseLeave"
], $e492d8fcbd34a95f$var$_excluded2 = [
    "active"
];
var $e492d8fcbd34a95f$var$InternalSubMenu = function InternalSubMenu(props) {
    var _classNames;
    var style = props.style, className = props.className, title = props.title, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, internalPopupClose = props.internalPopupClose, children = props.children, itemIcon = props.itemIcon, expandIcon = props.expandIcon, popupClassName = props.popupClassName, popupOffset = props.popupOffset, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onTitleClick = props.onTitleClick, onTitleMouseEnter = props.onTitleMouseEnter, onTitleMouseLeave = props.onTitleMouseLeave, restProps = (0, $04RxA.default)(props, $e492d8fcbd34a95f$var$_excluded);
    var domDataId = (0, $9e8d0e518a1dc972$export$a276eb4e9be640f8)(eventKey);
    var _React$useContext = $6fFrj.useContext((0, $ce084908a5b6df24$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, openKeys = _React$useContext.openKeys, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, activeKey = _React$useContext.activeKey, selectedKeys = _React$useContext.selectedKeys, contextItemIcon = _React$useContext.itemIcon, contextExpandIcon = _React$useContext.expandIcon, onItemClick = _React$useContext.onItemClick, onOpenChange = _React$useContext.onOpenChange, onActive = _React$useContext.onActive;
    var _React$useContext2 = $6fFrj.useContext((0, $f381238ea25fd8cc$export$2e2bcd8739ae039)), _internalRenderSubMenuItem = _React$useContext2._internalRenderSubMenuItem;
    var _React$useContext3 = $6fFrj.useContext((0, $67da814b8e602a99$export$f0b9e0db98edfa53)), isSubPathKey = _React$useContext3.isSubPathKey;
    var connectedPath = (0, $67da814b8e602a99$export$d3d2d0a05677870a)();
    var subMenuPrefixCls = "".concat(prefixCls, "-submenu");
    var mergedDisabled = contextDisabled || disabled;
    var elementRef = $6fFrj.useRef();
    var popupRef = $6fFrj.useRef();
    // ================================ Icon ================================
    var mergedItemIcon = itemIcon || contextItemIcon;
    var mergedExpandIcon = expandIcon || contextExpandIcon;
    // ================================ Open ================================
    var originOpen = openKeys.includes(eventKey);
    var open = !overflowDisabled && originOpen;
    // =============================== Select ===============================
    var childrenSelected = isSubPathKey(selectedKeys, eventKey);
    // =============================== Active ===============================
    var _useActive = (0, $c17982cef67c66ea$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onTitleMouseEnter, onTitleMouseLeave), active = _useActive.active, activeProps = (0, $04RxA.default)(_useActive, $e492d8fcbd34a95f$var$_excluded2);
    // Fallback of active check to avoid hover on menu title or disabled item
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), childrenActive = _React$useState2[0], setChildrenActive = _React$useState2[1];
    var triggerChildrenActive = function triggerChildrenActive(newActive) {
        if (!mergedDisabled) setChildrenActive(newActive);
    };
    var onInternalMouseEnter = function onInternalMouseEnter(domEvent) {
        triggerChildrenActive(true);
        onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
            key: eventKey,
            domEvent: domEvent
        });
    };
    var onInternalMouseLeave = function onInternalMouseLeave(domEvent) {
        triggerChildrenActive(false);
        onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
            key: eventKey,
            domEvent: domEvent
        });
    };
    var mergedActive = $6fFrj.useMemo(function() {
        if (active) return active;
        if (mode !== 'inline') return childrenActive || isSubPathKey([
            activeKey
        ], eventKey);
        return false;
    }, [
        mode,
        active,
        activeKey,
        childrenActive,
        eventKey,
        isSubPathKey
    ]);
    // ========================== DirectionStyle ==========================
    var directionStyle = (0, $6d0a74bc15e6364f$export$2e2bcd8739ae039)(connectedPath.length);
    // =============================== Events ===============================
    // >>>> Title click
    var onInternalTitleClick = function onInternalTitleClick(e) {
        // Skip if disabled
        if (mergedDisabled) return;
        onTitleClick === null || onTitleClick === void 0 || onTitleClick({
            key: eventKey,
            domEvent: e
        });
        // Trigger open by click when mode is `inline`
        if (mode === 'inline') onOpenChange(eventKey, !originOpen);
    };
    // >>>> Context for children click
    var onMergedItemClick = (0, $24e48e9f32415e6c$export$2e2bcd8739ae039)(function(info) {
        onClick === null || onClick === void 0 || onClick((0, $19cf396193749cc8$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    });
    // >>>>> Visible change
    var onPopupVisibleChange = function onPopupVisibleChange(newVisible) {
        if (mode !== 'inline') onOpenChange(eventKey, newVisible);
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ var onInternalFocus = function onInternalFocus() {
        onActive(eventKey);
    };
    // =============================== Render ===============================
    var popupId = domDataId && "".concat(domDataId, "-popup");
    // >>>>> Title
    var titleNode = /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        role: "menuitem",
        style: directionStyle,
        className: "".concat(subMenuPrefixCls, "-title"),
        tabIndex: mergedDisabled ? null : -1,
        ref: elementRef,
        title: typeof title === 'string' ? title : null,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId,
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": popupId,
        "aria-disabled": mergedDisabled,
        onClick: onInternalTitleClick,
        onFocus: onInternalFocus
    }, activeProps), title, /*#__PURE__*/ $6fFrj.createElement((0, $d0ba4ba893e82bd8$export$2e2bcd8739ae039), {
        icon: mode !== 'horizontal' ? mergedExpandIcon : null,
        props: (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
            isOpen: open,
            // [Legacy] Not sure why need this mark
            isSubMenu: true
        })
    }, /*#__PURE__*/ $6fFrj.createElement("i", {
        className: "".concat(subMenuPrefixCls, "-arrow")
    })));
    // Cache mode if it change to `inline` which do not have popup motion
    var triggerModeRef = $6fFrj.useRef(mode);
    if (mode !== 'inline' && connectedPath.length > 1) triggerModeRef.current = 'vertical';
    else triggerModeRef.current = mode;
    if (!overflowDisabled) {
        var triggerMode = triggerModeRef.current;
        // Still wrap with Trigger here since we need avoid react re-mount dom node
        // Which makes motion failed
        titleNode = /*#__PURE__*/ $6fFrj.createElement((0, $16084f5b04393abb$export$2e2bcd8739ae039), {
            mode: triggerMode,
            prefixCls: subMenuPrefixCls,
            visible: !internalPopupClose && open && mode !== 'inline',
            popupClassName: popupClassName,
            popupOffset: popupOffset,
            popup: /*#__PURE__*/ $6fFrj.createElement((0, $ce084908a5b6df24$export$2e2bcd8739ae039), {
                mode: triggerMode === 'horizontal' ? 'vertical' : triggerMode
            }, /*#__PURE__*/ $6fFrj.createElement((0, $1dd3c5eee5c7e0af$export$2e2bcd8739ae039), {
                id: popupId,
                ref: popupRef
            }, children)),
            disabled: mergedDisabled,
            onVisibleChange: onPopupVisibleChange
        }, titleNode);
    }
    // >>>>> List node
    var listNode = /*#__PURE__*/ $6fFrj.createElement((0, $fc57648bf28f775c$export$2e2bcd8739ae039).Item, (0, $fIrcP.default)({
        role: "none"
    }, restProps, {
        component: "li",
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(subMenuPrefixCls, "".concat(subMenuPrefixCls, "-").concat(mode), className, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(subMenuPrefixCls, "-open"), open), (0, $43449.default)(_classNames, "".concat(subMenuPrefixCls, "-active"), mergedActive), (0, $43449.default)(_classNames, "".concat(subMenuPrefixCls, "-selected"), childrenSelected), (0, $43449.default)(_classNames, "".concat(subMenuPrefixCls, "-disabled"), mergedDisabled), _classNames)),
        onMouseEnter: onInternalMouseEnter,
        onMouseLeave: onInternalMouseLeave
    }), titleNode, !overflowDisabled && /*#__PURE__*/ $6fFrj.createElement((0, $b2e537a69b18f7d5$export$2e2bcd8739ae039), {
        id: popupId,
        open: open,
        keyPath: connectedPath
    }, children));
    if (_internalRenderSubMenuItem) listNode = _internalRenderSubMenuItem(listNode, props, {
        selected: childrenSelected,
        active: mergedActive,
        open: open,
        disabled: mergedDisabled
    });
    // >>>>> Render
    return /*#__PURE__*/ $6fFrj.createElement((0, $ce084908a5b6df24$export$2e2bcd8739ae039), {
        onItemClick: onMergedItemClick,
        mode: mode === 'horizontal' ? 'vertical' : mode,
        itemIcon: mergedItemIcon,
        expandIcon: mergedExpandIcon
    }, listNode);
};
function $e492d8fcbd34a95f$export$2e2bcd8739ae039(props) {
    var eventKey = props.eventKey, children = props.children;
    var connectedKeyPath = (0, $67da814b8e602a99$export$d3d2d0a05677870a)(eventKey);
    var childList = (0, $69416edeb618b526$export$cd230e97e668be9)(children, connectedKeyPath);
    // ==================== Record KeyPath ====================
    var measure = (0, $67da814b8e602a99$export$e295b0c537d32d7d)();
    // eslint-disable-next-line consistent-return
    $6fFrj.useEffect(function() {
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return function() {
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    var renderNode;
    // ======================== Render ========================
    if (measure) renderNode = childList;
    else renderNode = /*#__PURE__*/ $6fFrj.createElement($e492d8fcbd34a95f$var$InternalSubMenu, props, childList);
    return /*#__PURE__*/ $6fFrj.createElement((0, $67da814b8e602a99$export$54d9e16aa4c8a7fa).Provider, {
        value: connectedKeyPath
    }, renderNode);
}




var $48c817e880394fae$var$_excluded = [
    "prefixCls",
    "rootClassName",
    "style",
    "className",
    "tabIndex",
    "items",
    "children",
    "direction",
    "id",
    "mode",
    "inlineCollapsed",
    "disabled",
    "disabledOverflow",
    "subMenuOpenDelay",
    "subMenuCloseDelay",
    "forceSubMenuRender",
    "defaultOpenKeys",
    "openKeys",
    "activeKey",
    "defaultActiveFirst",
    "selectable",
    "multiple",
    "defaultSelectedKeys",
    "selectedKeys",
    "onSelect",
    "onDeselect",
    "inlineIndent",
    "motion",
    "defaultMotions",
    "triggerSubMenuAction",
    "builtinPlacements",
    "itemIcon",
    "expandIcon",
    "overflowedIndicator",
    "overflowedIndicatorPopupClassName",
    "getPopupContainer",
    "onClick",
    "onOpenChange",
    "onKeyDown",
    "openAnimation",
    "openTransitionName",
    "_internalRenderMenuItem",
    "_internalRenderSubMenuItem"
];
/**
 * Menu modify after refactor:
 * ## Add
 * - disabled
 *
 * ## Remove
 * - openTransitionName
 * - openAnimation
 * - onDestroy
 * - siderCollapsed: Seems antd do not use this prop (Need test in antd)
 * - collapsedWidth: Seems this logic should be handle by antd Layout.Sider
 */ // optimize for render
var $48c817e880394fae$var$EMPTY_LIST = [];
var $48c817e880394fae$var$Menu = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _childList$, _classNames;
    var _ref = props, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? 'rc-menu' : _ref$prefixCls, rootClassName = _ref.rootClassName, style = _ref.style, className = _ref.className, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex, items = _ref.items, children = _ref.children, direction = _ref.direction, id = _ref.id, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'vertical' : _ref$mode, inlineCollapsed = _ref.inlineCollapsed, disabled = _ref.disabled, disabledOverflow = _ref.disabledOverflow, _ref$subMenuOpenDelay = _ref.subMenuOpenDelay, subMenuOpenDelay = _ref$subMenuOpenDelay === void 0 ? 0.1 : _ref$subMenuOpenDelay, _ref$subMenuCloseDela = _ref.subMenuCloseDelay, subMenuCloseDelay = _ref$subMenuCloseDela === void 0 ? 0.1 : _ref$subMenuCloseDela, forceSubMenuRender = _ref.forceSubMenuRender, defaultOpenKeys = _ref.defaultOpenKeys, openKeys = _ref.openKeys, activeKey = _ref.activeKey, defaultActiveFirst = _ref.defaultActiveFirst, _ref$selectable = _ref.selectable, selectable = _ref$selectable === void 0 ? true : _ref$selectable, _ref$multiple = _ref.multiple, multiple = _ref$multiple === void 0 ? false : _ref$multiple, defaultSelectedKeys = _ref.defaultSelectedKeys, selectedKeys = _ref.selectedKeys, onSelect = _ref.onSelect, onDeselect = _ref.onDeselect, _ref$inlineIndent = _ref.inlineIndent, inlineIndent = _ref$inlineIndent === void 0 ? 24 : _ref$inlineIndent, motion = _ref.motion, defaultMotions = _ref.defaultMotions, _ref$triggerSubMenuAc = _ref.triggerSubMenuAction, triggerSubMenuAction = _ref$triggerSubMenuAc === void 0 ? 'hover' : _ref$triggerSubMenuAc, builtinPlacements = _ref.builtinPlacements, itemIcon = _ref.itemIcon, expandIcon = _ref.expandIcon, _ref$overflowedIndica = _ref.overflowedIndicator, overflowedIndicator = _ref$overflowedIndica === void 0 ? '...' : _ref$overflowedIndica, overflowedIndicatorPopupClassName = _ref.overflowedIndicatorPopupClassName, getPopupContainer = _ref.getPopupContainer, onClick = _ref.onClick, onOpenChange = _ref.onOpenChange, onKeyDown = _ref.onKeyDown, openAnimation = _ref.openAnimation, openTransitionName = _ref.openTransitionName, _internalRenderMenuItem = _ref._internalRenderMenuItem, _internalRenderSubMenuItem = _ref._internalRenderSubMenuItem, restProps = (0, $04RxA.default)(_ref, $48c817e880394fae$var$_excluded);
    var childList = $6fFrj.useMemo(function() {
        return (0, $69416edeb618b526$export$50458dc1a9a0f894)(children, items, $48c817e880394fae$var$EMPTY_LIST);
    }, [
        children,
        items
    ]);
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), mounted = _React$useState2[0], setMounted = _React$useState2[1];
    var containerRef = $6fFrj.useRef();
    var uuid = (0, $c8b292dfb920a361$export$2e2bcd8739ae039)(id);
    var isRtl = direction === 'rtl';
    // ========================= Open =========================
    var _useMergedState = (0, $gfhff.default)(defaultOpenKeys, {
        value: openKeys,
        postState: function postState(keys) {
            return keys || $48c817e880394fae$var$EMPTY_LIST;
        }
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), mergedOpenKeys = _useMergedState2[0], setMergedOpenKeys = _useMergedState2[1];
    // React 18 will merge mouse event which means we open key will not sync
    // ref: https://github.com/ant-design/ant-design/issues/38818
    var triggerOpenKeys = function triggerOpenKeys(keys) {
        var forceFlush = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        function doUpdate() {
            setMergedOpenKeys(keys);
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(keys);
        }
        if (forceFlush) (0, $8CZEB.flushSync)(doUpdate);
        else doUpdate();
    };
    // >>>>> Cache & Reset open keys when inlineCollapsed changed
    var _React$useState3 = $6fFrj.useState(mergedOpenKeys), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), inlineCacheOpenKeys = _React$useState4[0], setInlineCacheOpenKeys = _React$useState4[1];
    var mountRef = $6fFrj.useRef(false);
    // ========================= Mode =========================
    var _React$useMemo = $6fFrj.useMemo(function() {
        if ((mode === 'inline' || mode === 'vertical') && inlineCollapsed) return [
            'vertical',
            inlineCollapsed
        ];
        return [
            mode,
            false
        ];
    }, [
        mode,
        inlineCollapsed
    ]), _React$useMemo2 = (0, $jP8CL.default)(_React$useMemo, 2), mergedMode = _React$useMemo2[0], mergedInlineCollapsed = _React$useMemo2[1];
    var isInlineMode = mergedMode === 'inline';
    var _React$useState5 = $6fFrj.useState(mergedMode), _React$useState6 = (0, $jP8CL.default)(_React$useState5, 2), internalMode = _React$useState6[0], setInternalMode = _React$useState6[1];
    var _React$useState7 = $6fFrj.useState(mergedInlineCollapsed), _React$useState8 = (0, $jP8CL.default)(_React$useState7, 2), internalInlineCollapsed = _React$useState8[0], setInternalInlineCollapsed = _React$useState8[1];
    $6fFrj.useEffect(function() {
        setInternalMode(mergedMode);
        setInternalInlineCollapsed(mergedInlineCollapsed);
        if (!mountRef.current) return;
        // Synchronously update MergedOpenKeys
        if (isInlineMode) setMergedOpenKeys(inlineCacheOpenKeys);
        else // Trigger open event in case its in control
        triggerOpenKeys($48c817e880394fae$var$EMPTY_LIST);
    }, [
        mergedMode,
        mergedInlineCollapsed
    ]);
    // ====================== Responsive ======================
    var _React$useState9 = $6fFrj.useState(0), _React$useState10 = (0, $jP8CL.default)(_React$useState9, 2), lastVisibleIndex = _React$useState10[0], setLastVisibleIndex = _React$useState10[1];
    var allVisible = lastVisibleIndex >= childList.length - 1 || internalMode !== 'horizontal' || disabledOverflow;
    // Cache
    $6fFrj.useEffect(function() {
        if (isInlineMode) setInlineCacheOpenKeys(mergedOpenKeys);
    }, [
        mergedOpenKeys
    ]);
    $6fFrj.useEffect(function() {
        mountRef.current = true;
        return function() {
            mountRef.current = false;
        };
    }, []);
    // ========================= Path =========================
    var _useKeyRecords = (0, $e3c6045630e6874f$export$2e2bcd8739ae039)(), registerPath = _useKeyRecords.registerPath, unregisterPath = _useKeyRecords.unregisterPath, refreshOverflowKeys = _useKeyRecords.refreshOverflowKeys, isSubPathKey = _useKeyRecords.isSubPathKey, getKeyPath = _useKeyRecords.getKeyPath, getKeys = _useKeyRecords.getKeys, getSubPathKeys = _useKeyRecords.getSubPathKeys;
    var registerPathContext = $6fFrj.useMemo(function() {
        return {
            registerPath: registerPath,
            unregisterPath: unregisterPath
        };
    }, [
        registerPath,
        unregisterPath
    ]);
    var pathUserContext = $6fFrj.useMemo(function() {
        return {
            isSubPathKey: isSubPathKey
        };
    }, [
        isSubPathKey
    ]);
    $6fFrj.useEffect(function() {
        refreshOverflowKeys(allVisible ? $48c817e880394fae$var$EMPTY_LIST : childList.slice(lastVisibleIndex + 1).map(function(child) {
            return child.key;
        }));
    }, [
        lastVisibleIndex,
        allVisible
    ]);
    // ======================== Active ========================
    var _useMergedState3 = (0, $gfhff.default)(activeKey || defaultActiveFirst && ((_childList$ = childList[0]) === null || _childList$ === void 0 ? void 0 : _childList$.key), {
        value: activeKey
    }), _useMergedState4 = (0, $jP8CL.default)(_useMergedState3, 2), mergedActiveKey = _useMergedState4[0], setMergedActiveKey = _useMergedState4[1];
    var onActive = (0, $24e48e9f32415e6c$export$2e2bcd8739ae039)(function(key) {
        setMergedActiveKey(key);
    });
    var onInactive = (0, $24e48e9f32415e6c$export$2e2bcd8739ae039)(function() {
        setMergedActiveKey(undefined);
    });
    (0, $6fFrj.useImperativeHandle)(ref, function() {
        return {
            list: containerRef.current,
            focus: function focus(options) {
                var _childList$find;
                var shouldFocusKey = mergedActiveKey !== null && mergedActiveKey !== void 0 ? mergedActiveKey : (_childList$find = childList.find(function(node) {
                    return !node.props.disabled;
                })) === null || _childList$find === void 0 ? void 0 : _childList$find.key;
                if (shouldFocusKey) {
                    var _containerRef$current, _containerRef$current2, _containerRef$current3;
                    (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current2 = _containerRef$current.querySelector("li[data-menu-id='".concat((0, $9e8d0e518a1dc972$export$80c871fe8d6b896)(uuid, shouldFocusKey), "']"))) === null || _containerRef$current2 === void 0 || (_containerRef$current3 = _containerRef$current2.focus) === null || _containerRef$current3 === void 0 || _containerRef$current3.call(_containerRef$current2, options);
                }
            }
        };
    });
    // ======================== Select ========================
    // >>>>> Select keys
    var _useMergedState5 = (0, $gfhff.default)(defaultSelectedKeys || [], {
        value: selectedKeys,
        // Legacy convert key to array
        postState: function postState(keys) {
            if (Array.isArray(keys)) return keys;
            if (keys === null || keys === undefined) return $48c817e880394fae$var$EMPTY_LIST;
            return [
                keys
            ];
        }
    }), _useMergedState6 = (0, $jP8CL.default)(_useMergedState5, 2), mergedSelectKeys = _useMergedState6[0], setMergedSelectKeys = _useMergedState6[1];
    // >>>>> Trigger select
    var triggerSelection = function triggerSelection(info) {
        if (selectable) {
            // Insert or Remove
            var targetKey = info.key;
            var exist = mergedSelectKeys.includes(targetKey);
            var newSelectKeys;
            if (multiple) {
                if (exist) newSelectKeys = mergedSelectKeys.filter(function(key) {
                    return key !== targetKey;
                });
                else newSelectKeys = [].concat((0, $37xND.default)(mergedSelectKeys), [
                    targetKey
                ]);
            } else newSelectKeys = [
                targetKey
            ];
            setMergedSelectKeys(newSelectKeys);
            // Trigger event
            var selectInfo = (0, $kNxFX.default)((0, $kNxFX.default)({}, info), {}, {
                selectedKeys: newSelectKeys
            });
            if (exist) onDeselect === null || onDeselect === void 0 || onDeselect(selectInfo);
            else onSelect === null || onSelect === void 0 || onSelect(selectInfo);
        }
        // Whatever selectable, always close it
        if (!multiple && mergedOpenKeys.length && internalMode !== 'inline') triggerOpenKeys($48c817e880394fae$var$EMPTY_LIST);
    };
    // ========================= Open =========================
    /**
   * Click for item. SubMenu do not have selection status
   */ var onInternalClick = (0, $24e48e9f32415e6c$export$2e2bcd8739ae039)(function(info) {
        onClick === null || onClick === void 0 || onClick((0, $19cf396193749cc8$export$e189bcd94b66c1db)(info));
        triggerSelection(info);
    });
    var onInternalOpenChange = (0, $24e48e9f32415e6c$export$2e2bcd8739ae039)(function(key, open) {
        var newOpenKeys = mergedOpenKeys.filter(function(k) {
            return k !== key;
        });
        if (open) newOpenKeys.push(key);
        else if (internalMode !== 'inline') {
            // We need find all related popup to close
            var subPathKeys = getSubPathKeys(key);
            newOpenKeys = newOpenKeys.filter(function(k) {
                return !subPathKeys.has(k);
            });
        }
        if (!(0, $ae3c1fae8a247572$export$2e2bcd8739ae039)(mergedOpenKeys, newOpenKeys, true)) triggerOpenKeys(newOpenKeys, true);
    });
    var getInternalPopupContainer = (0, $24e48e9f32415e6c$export$2e2bcd8739ae039)(getPopupContainer);
    // ==================== Accessibility =====================
    var triggerAccessibilityOpen = function triggerAccessibilityOpen(key, open) {
        var nextOpen = open !== null && open !== void 0 ? open : !mergedOpenKeys.includes(key);
        onInternalOpenChange(key, nextOpen);
    };
    var onInternalKeyDown = (0, $3110c80b4066b713$export$2e2bcd8739ae039)(internalMode, mergedActiveKey, isRtl, uuid, containerRef, getKeys, getKeyPath, setMergedActiveKey, triggerAccessibilityOpen, onKeyDown);
    // ======================== Effect ========================
    $6fFrj.useEffect(function() {
        setMounted(true);
    }, []);
    // ======================= Context ========================
    var privateContext = $6fFrj.useMemo(function() {
        return {
            _internalRenderMenuItem: _internalRenderMenuItem,
            _internalRenderSubMenuItem: _internalRenderSubMenuItem
        };
    }, [
        _internalRenderMenuItem,
        _internalRenderSubMenuItem
    ]);
    // ======================== Render ========================
    // >>>>> Children
    var wrappedChildList = internalMode !== 'horizontal' || disabledOverflow ? childList : // Need wrap for overflow dropdown that do not response for open
    childList.map(function(child, index) {
        return(/*#__PURE__*/ // Always wrap provider to avoid sub node re-mount
        $6fFrj.createElement((0, $ce084908a5b6df24$export$2e2bcd8739ae039), {
            key: child.key,
            overflowDisabled: index > lastVisibleIndex
        }, child));
    });
    // >>>>> Container
    var container = /*#__PURE__*/ $6fFrj.createElement((0, $fc57648bf28f775c$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        id: id,
        ref: containerRef,
        prefixCls: "".concat(prefixCls, "-overflow"),
        component: "ul",
        itemComponent: (0, $cfbb4b13af7f52cb$export$2e2bcd8739ae039),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-root"), "".concat(prefixCls, "-").concat(internalMode), className, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(prefixCls, "-inline-collapsed"), internalInlineCollapsed), (0, $43449.default)(_classNames, "".concat(prefixCls, "-rtl"), isRtl), _classNames), rootClassName),
        dir: direction,
        style: style,
        role: "menu",
        tabIndex: tabIndex,
        data: wrappedChildList,
        renderRawItem: function renderRawItem(node) {
            return node;
        },
        renderRawRest: function renderRawRest(omitItems) {
            // We use origin list since wrapped list use context to prevent open
            var len = omitItems.length;
            var originOmitItems = len ? childList.slice(-len) : null;
            return /*#__PURE__*/ $6fFrj.createElement((0, $e492d8fcbd34a95f$export$2e2bcd8739ae039), {
                eventKey: (0, $e3c6045630e6874f$export$20a0132c46ce5b04),
                title: overflowedIndicator,
                disabled: allVisible,
                internalPopupClose: len === 0,
                popupClassName: overflowedIndicatorPopupClassName
            }, originOmitItems);
        },
        maxCount: internalMode !== 'horizontal' || disabledOverflow ? (0, $fc57648bf28f775c$export$2e2bcd8739ae039).INVALIDATE : (0, $fc57648bf28f775c$export$2e2bcd8739ae039).RESPONSIVE,
        ssr: "full",
        "data-menu-list": true,
        onVisibleChange: function onVisibleChange(newLastIndex) {
            setLastVisibleIndex(newLastIndex);
        },
        onKeyDown: onInternalKeyDown
    }, restProps));
    // >>>>> Render
    return /*#__PURE__*/ $6fFrj.createElement((0, $f381238ea25fd8cc$export$2e2bcd8739ae039).Provider, {
        value: privateContext
    }, /*#__PURE__*/ $6fFrj.createElement((0, $9e8d0e518a1dc972$export$26537912ea160acd).Provider, {
        value: uuid
    }, /*#__PURE__*/ $6fFrj.createElement((0, $ce084908a5b6df24$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        mode: internalMode,
        openKeys: mergedOpenKeys,
        rtl: isRtl,
        disabled: disabled,
        motion: mounted ? motion : null,
        defaultMotions: mounted ? defaultMotions : null,
        activeKey: mergedActiveKey,
        onActive: onActive,
        onInactive: onInactive,
        selectedKeys: mergedSelectKeys,
        inlineIndent: inlineIndent,
        subMenuOpenDelay: subMenuOpenDelay,
        subMenuCloseDelay: subMenuCloseDelay,
        forceSubMenuRender: forceSubMenuRender,
        builtinPlacements: builtinPlacements,
        triggerSubMenuAction: triggerSubMenuAction,
        getPopupContainer: getInternalPopupContainer,
        itemIcon: itemIcon,
        expandIcon: expandIcon,
        onItemClick: onInternalClick,
        onOpenChange: onInternalOpenChange
    }, /*#__PURE__*/ $6fFrj.createElement((0, $67da814b8e602a99$export$f0b9e0db98edfa53).Provider, {
        value: pathUserContext
    }, container), /*#__PURE__*/ $6fFrj.createElement("div", {
        style: {
            display: 'none'
        },
        "aria-hidden": true
    }, /*#__PURE__*/ $6fFrj.createElement((0, $67da814b8e602a99$export$d9ffb5bfd108b003).Provider, {
        value: registerPathContext
    }, childList)))));
});
var $48c817e880394fae$export$2e2bcd8739ae039 = $48c817e880394fae$var$Menu;





var $fIrcP = parcelRequire("fIrcP");

var $04RxA = parcelRequire("04RxA");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");



var $cdb8e70fed13b889$var$_excluded = [
    "className",
    "title",
    "eventKey",
    "children"
], $cdb8e70fed13b889$var$_excluded2 = [
    "children"
];
var $cdb8e70fed13b889$var$InternalMenuItemGroup = function InternalMenuItemGroup(_ref) {
    var className = _ref.className, title = _ref.title, eventKey = _ref.eventKey, children = _ref.children, restProps = (0, $04RxA.default)(_ref, $cdb8e70fed13b889$var$_excluded);
    var _React$useContext = $6fFrj.useContext((0, $ce084908a5b6df24$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls;
    var groupPrefixCls = "".concat(prefixCls, "-item-group");
    return /*#__PURE__*/ $6fFrj.createElement("li", (0, $fIrcP.default)({
        role: "presentation"
    }, restProps, {
        onClick: function onClick(e) {
            return e.stopPropagation();
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(groupPrefixCls, className)
    }), /*#__PURE__*/ $6fFrj.createElement("div", {
        role: "presentation",
        className: "".concat(groupPrefixCls, "-title"),
        title: typeof title === 'string' ? title : undefined
    }, title), /*#__PURE__*/ $6fFrj.createElement("ul", {
        role: "group",
        className: "".concat(groupPrefixCls, "-list")
    }, children));
};
function $cdb8e70fed13b889$export$2e2bcd8739ae039(_ref2) {
    var children = _ref2.children, props = (0, $04RxA.default)(_ref2, $cdb8e70fed13b889$var$_excluded2);
    var connectedKeyPath = (0, $67da814b8e602a99$export$d3d2d0a05677870a)(props.eventKey);
    var childList = (0, $69416edeb618b526$export$cd230e97e668be9)(children, connectedKeyPath);
    var measure = (0, $67da814b8e602a99$export$e295b0c537d32d7d)();
    if (measure) return childList;
    return /*#__PURE__*/ $6fFrj.createElement($cdb8e70fed13b889$var$InternalMenuItemGroup, (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(props, [
        'warnKey'
    ]), childList);
}




var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


function $690ad7706592297b$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, style = _ref.style;
    var _React$useContext = $6fFrj.useContext((0, $ce084908a5b6df24$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls;
    var measure = (0, $67da814b8e602a99$export$e295b0c537d32d7d)();
    if (measure) return null;
    return /*#__PURE__*/ $6fFrj.createElement("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-item-divider"), className),
        style: style
    });
}


var $7fff6aa471b37d3c$var$ExportMenu = (0, $48c817e880394fae$export$2e2bcd8739ae039);
$7fff6aa471b37d3c$var$ExportMenu.Item = (0, $cfbb4b13af7f52cb$export$2e2bcd8739ae039);
$7fff6aa471b37d3c$var$ExportMenu.SubMenu = (0, $e492d8fcbd34a95f$export$2e2bcd8739ae039);
$7fff6aa471b37d3c$var$ExportMenu.ItemGroup = (0, $cdb8e70fed13b889$export$2e2bcd8739ae039);
$7fff6aa471b37d3c$var$ExportMenu.Divider = (0, $690ad7706592297b$export$2e2bcd8739ae039);
var $7fff6aa471b37d3c$export$2e2bcd8739ae039 = $7fff6aa471b37d3c$var$ExportMenu;



var $2c6ch = parcelRequire("2c6ch");


var $6fFrj = parcelRequire("6fFrj");


var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $2a06ffe20158ccf3$var$BarsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "bars",
    "theme": "outlined"
};
var $2a06ffe20158ccf3$export$2e2bcd8739ae039 = $2a06ffe20158ccf3$var$BarsOutlined;



var $f10680e12ec7945e$var$BarsOutlined = function BarsOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $2a06ffe20158ccf3$export$2e2bcd8739ae039)
    }));
};
var $f10680e12ec7945e$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($f10680e12ec7945e$var$BarsOutlined);
var $f10680e12ec7945e$export$2e2bcd8739ae039 = $f10680e12ec7945e$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $977b4b1c33aa4cfb$var$LeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    },
    "name": "left",
    "theme": "outlined"
};
var $977b4b1c33aa4cfb$export$2e2bcd8739ae039 = $977b4b1c33aa4cfb$var$LeftOutlined;



var $ae5877404f2a0345$var$LeftOutlined = function LeftOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $977b4b1c33aa4cfb$export$2e2bcd8739ae039)
    }));
};
var $ae5877404f2a0345$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($ae5877404f2a0345$var$LeftOutlined);
var $ae5877404f2a0345$export$2e2bcd8739ae039 = $ae5877404f2a0345$var$RefIcon;




var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");

var $537dadc866584cf4$var$isNumeric = function isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
};
var $537dadc866584cf4$export$2e2bcd8739ae039 = $537dadc866584cf4$var$isNumeric;



var $37xND = parcelRequire("37xND");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $fIrcP = parcelRequire("fIrcP");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");

var $bc6ab8efd9ad3e35$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bc6ab8efd9ad3e35$export$964282a2c3979546 = /*#__PURE__*/ $6fFrj.createContext({
    siderHook: {
        addSider: function addSider() {
            return null;
        },
        removeSider: function removeSider() {
            return null;
        }
    }
});
function $bc6ab8efd9ad3e35$var$generator(_ref) {
    var suffixCls = _ref.suffixCls, tagName = _ref.tagName, displayName = _ref.displayName;
    return function(BasicComponent) {
        var Adapter = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
            var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
            var customizePrefixCls = props.prefixCls;
            var prefixCls = getPrefixCls(suffixCls, customizePrefixCls);
            return /*#__PURE__*/ $6fFrj.createElement(BasicComponent, (0, $fIrcP.default)({
                ref: ref,
                prefixCls: prefixCls,
                tagName: tagName
            }, props));
        });
        return Adapter;
    };
}
var $bc6ab8efd9ad3e35$var$Basic = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, children = props.children, tagName = props.tagName, others = $bc6ab8efd9ad3e35$var$__rest(props, [
        "prefixCls",
        "className",
        "children",
        "tagName"
    ]);
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className);
    return /*#__PURE__*/ $6fFrj.createElement(tagName, (0, $fIrcP.default)((0, $fIrcP.default)({
        className: classString
    }, others), {
        ref: ref
    }), children);
});
var $bc6ab8efd9ad3e35$var$BasicLayout = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _React$useContext2 = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), direction = _React$useContext2.direction;
    var _React$useState = $6fFrj.useState([]), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), siders = _React$useState2[0], setSiders = _React$useState2[1];
    var prefixCls = props.prefixCls, className = props.className, children = props.children, hasSider = props.hasSider, Tag = props.tagName, others = $bc6ab8efd9ad3e35$var$__rest(props, [
        "prefixCls",
        "className",
        "children",
        "hasSider",
        "tagName"
    ]);
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-has-sider"), typeof hasSider === 'boolean' ? hasSider : siders.length > 0), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    var contextValue = $6fFrj.useMemo(function() {
        return {
            siderHook: {
                addSider: function addSider(id) {
                    setSiders(function(prev) {
                        return [].concat((0, $37xND.default)(prev), [
                            id
                        ]);
                    });
                },
                removeSider: function removeSider(id) {
                    setSiders(function(prev) {
                        return prev.filter(function(currentId) {
                            return currentId !== id;
                        });
                    });
                }
            }
        };
    }, []);
    return /*#__PURE__*/ $6fFrj.createElement($bc6ab8efd9ad3e35$export$964282a2c3979546.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $6fFrj.createElement(Tag, (0, $fIrcP.default)({
        ref: ref,
        className: classString
    }, others), children));
});
var $bc6ab8efd9ad3e35$var$Layout = $bc6ab8efd9ad3e35$var$generator({
    suffixCls: 'layout',
    tagName: 'section',
    displayName: 'Layout'
})($bc6ab8efd9ad3e35$var$BasicLayout);
var $bc6ab8efd9ad3e35$export$8b251419efc915eb = $bc6ab8efd9ad3e35$var$generator({
    suffixCls: 'layout-header',
    tagName: 'header',
    displayName: 'Header'
})($bc6ab8efd9ad3e35$var$Basic);
var $bc6ab8efd9ad3e35$export$a06f1c675e846f6f = $bc6ab8efd9ad3e35$var$generator({
    suffixCls: 'layout-footer',
    tagName: 'footer',
    displayName: 'Footer'
})($bc6ab8efd9ad3e35$var$Basic);
var $bc6ab8efd9ad3e35$export$7c6e2c02157bb7d2 = $bc6ab8efd9ad3e35$var$generator({
    suffixCls: 'layout-content',
    tagName: 'main',
    displayName: 'Content'
})($bc6ab8efd9ad3e35$var$Basic);
var $bc6ab8efd9ad3e35$export$2e2bcd8739ae039 = $bc6ab8efd9ad3e35$var$Layout;


var $d2d8cb132a1de079$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d2d8cb132a1de079$var$dimensionMaxMap = {
    xs: '479.98px',
    sm: '575.98px',
    md: '767.98px',
    lg: '991.98px',
    xl: '1199.98px',
    xxl: '1599.98px'
};
var $d2d8cb132a1de079$export$63554aebd2a6d54c = /*#__PURE__*/ $6fFrj.createContext({});
var $d2d8cb132a1de079$var$generateId = function() {
    var i = 0;
    return function() {
        var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        i += 1;
        return "".concat(prefix).concat(i);
    };
}();
var $d2d8cb132a1de079$var$Sider = /*#__PURE__*/ $6fFrj.forwardRef(function(_a, ref) {
    var customizePrefixCls = _a.prefixCls, className = _a.className, trigger = _a.trigger, children = _a.children, _a$defaultCollapsed = _a.defaultCollapsed, defaultCollapsed = _a$defaultCollapsed === void 0 ? false : _a$defaultCollapsed, _a$theme = _a.theme, theme = _a$theme === void 0 ? 'dark' : _a$theme, _a$style = _a.style, style = _a$style === void 0 ? {} : _a$style, _a$collapsible = _a.collapsible, collapsible = _a$collapsible === void 0 ? false : _a$collapsible, _a$reverseArrow = _a.reverseArrow, reverseArrow = _a$reverseArrow === void 0 ? false : _a$reverseArrow, _a$width = _a.width, width = _a$width === void 0 ? 200 : _a$width, _a$collapsedWidth = _a.collapsedWidth, collapsedWidth = _a$collapsedWidth === void 0 ? 80 : _a$collapsedWidth, zeroWidthTriggerStyle = _a.zeroWidthTriggerStyle, breakpoint = _a.breakpoint, onCollapse = _a.onCollapse, onBreakpoint = _a.onBreakpoint, props = $d2d8cb132a1de079$var$__rest(_a, [
        "prefixCls",
        "className",
        "trigger",
        "children",
        "defaultCollapsed",
        "theme",
        "style",
        "collapsible",
        "reverseArrow",
        "width",
        "collapsedWidth",
        "zeroWidthTriggerStyle",
        "breakpoint",
        "onCollapse",
        "onBreakpoint"
    ]);
    var _useContext = (0, $6fFrj.useContext)((0, $bc6ab8efd9ad3e35$export$964282a2c3979546)), siderHook = _useContext.siderHook;
    var _useState = (0, $6fFrj.useState)('collapsed' in props ? props.collapsed : defaultCollapsed), _useState2 = (0, $jP8CL.default)(_useState, 2), collapsed = _useState2[0], setCollapsed = _useState2[1];
    var _useState3 = (0, $6fFrj.useState)(false), _useState4 = (0, $jP8CL.default)(_useState3, 2), below = _useState4[0], setBelow = _useState4[1];
    (0, $6fFrj.useEffect)(function() {
        if ('collapsed' in props) setCollapsed(props.collapsed);
    }, [
        props.collapsed
    ]);
    var handleSetCollapsed = function handleSetCollapsed(value, type) {
        if (!('collapsed' in props)) setCollapsed(value);
        onCollapse === null || onCollapse === void 0 || onCollapse(value, type);
    };
    // ========================= Responsive =========================
    var responsiveHandlerRef = (0, $6fFrj.useRef)();
    responsiveHandlerRef.current = function(mql) {
        setBelow(mql.matches);
        onBreakpoint === null || onBreakpoint === void 0 || onBreakpoint(mql.matches);
        if (collapsed !== mql.matches) handleSetCollapsed(mql.matches, 'responsive');
    };
    (0, $6fFrj.useEffect)(function() {
        function responsiveHandler(mql) {
            return responsiveHandlerRef.current(mql);
        }
        var mql;
        if (typeof window !== 'undefined') {
            var _window = window, matchMedia = _window.matchMedia;
            if (matchMedia && breakpoint && breakpoint in $d2d8cb132a1de079$var$dimensionMaxMap) {
                mql = matchMedia("(max-width: ".concat($d2d8cb132a1de079$var$dimensionMaxMap[breakpoint], ")"));
                try {
                    mql.addEventListener('change', responsiveHandler);
                } catch (error) {
                    mql.addListener(responsiveHandler);
                }
                responsiveHandler(mql);
            }
        }
        return function() {
            try {
                mql === null || mql === void 0 || mql.removeEventListener('change', responsiveHandler);
            } catch (error) {
                mql === null || mql === void 0 || mql.removeListener(responsiveHandler);
            }
        };
    }, [
        breakpoint
    ]); // in order to accept dynamic 'breakpoint' property, we need to add 'breakpoint' into dependency array.
    (0, $6fFrj.useEffect)(function() {
        var uniqueId = $d2d8cb132a1de079$var$generateId('ant-sider-');
        siderHook.addSider(uniqueId);
        return function() {
            return siderHook.removeSider(uniqueId);
        };
    }, []);
    var toggle = function toggle() {
        handleSetCollapsed(!collapsed, 'clickTrigger');
    };
    var _useContext2 = (0, $6fFrj.useContext)((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext2.getPrefixCls;
    var renderSider = function renderSider() {
        var prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
        var divProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(props, [
            'collapsed'
        ]);
        var rawWidth = collapsed ? collapsedWidth : width;
        // use "px" as fallback unit for width
        var siderWidth = (0, $537dadc866584cf4$export$2e2bcd8739ae039)(rawWidth) ? "".concat(rawWidth, "px") : String(rawWidth);
        // special trigger when collapsedWidth == 0
        var zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/ $6fFrj.createElement("span", {
            onClick: toggle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-zero-width-trigger"), "".concat(prefixCls, "-zero-width-trigger-").concat(reverseArrow ? 'right' : 'left')),
            style: zeroWidthTriggerStyle
        }, trigger || /*#__PURE__*/ $6fFrj.createElement((0, $f10680e12ec7945e$export$2e2bcd8739ae039), null)) : null;
        var iconObj = {
            expanded: reverseArrow ? /*#__PURE__*/ $6fFrj.createElement((0, $e7bd83ac29db4850$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $6fFrj.createElement((0, $ae5877404f2a0345$export$2e2bcd8739ae039), null),
            collapsed: reverseArrow ? /*#__PURE__*/ $6fFrj.createElement((0, $ae5877404f2a0345$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $6fFrj.createElement((0, $e7bd83ac29db4850$export$2e2bcd8739ae039), null)
        };
        var status = collapsed ? 'collapsed' : 'expanded';
        var defaultTrigger = iconObj[status];
        var triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-trigger"),
            onClick: toggle,
            style: {
                width: siderWidth
            }
        }, trigger || defaultTrigger) : null;
        var divStyle = (0, $fIrcP.default)((0, $fIrcP.default)({}, style), {
            flex: "0 0 ".concat(siderWidth),
            maxWidth: siderWidth,
            minWidth: siderWidth,
            width: siderWidth
        });
        var siderCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-").concat(theme), (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-collapsed"), !!collapsed), "".concat(prefixCls, "-has-trigger"), collapsible && trigger !== null && !zeroWidthTrigger), "".concat(prefixCls, "-below"), !!below), "".concat(prefixCls, "-zero-width"), parseFloat(siderWidth) === 0), className);
        return /*#__PURE__*/ $6fFrj.createElement("aside", (0, $fIrcP.default)({
            className: siderCls
        }, divProps, {
            style: divStyle,
            ref: ref
        }), /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-children")
        }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null);
    };
    var contextValue = $6fFrj.useMemo(function() {
        return {
            siderCollapsed: collapsed
        };
    }, [
        collapsed
    ]);
    return /*#__PURE__*/ $6fFrj.createElement($d2d8cb132a1de079$export$63554aebd2a6d54c.Provider, {
        value: contextValue
    }, renderSider());
});
var $d2d8cb132a1de079$export$2e2bcd8739ae039 = $d2d8cb132a1de079$var$Sider;






var $fIrcP = parcelRequire("fIrcP");

var $5KhTJ = parcelRequire("5KhTJ");


var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");

var $2097bad67e992316$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2097bad67e992316$var$MenuDivider = function MenuDivider(_a) {
    var customizePrefixCls = _a.prefixCls, className = _a.className, dashed = _a.dashed, restProps = $2097bad67e992316$var$__rest(_a, [
        "prefixCls",
        "className",
        "dashed"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('menu', customizePrefixCls);
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)({}, "".concat(prefixCls, "-item-divider-dashed"), !!dashed), className);
    return /*#__PURE__*/ $6fFrj.createElement((0, $690ad7706592297b$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        className: classString
    }, restProps));
};
var $2097bad67e992316$export$2e2bcd8739ae039 = $2097bad67e992316$var$MenuDivider;



var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $82HU4 = parcelRequire("82HU4");

var $jbuPt = parcelRequire("jbuPt");

var $744q1 = parcelRequire("744q1");

var $bxC2Y = parcelRequire("bxC2Y");

var $fActo = parcelRequire("fActo");



var $6fFrj = parcelRequire("6fFrj");




var $6fFrj = parcelRequire("6fFrj");
var $324754238ddf2353$var$MenuContext = /*#__PURE__*/ (0, $6fFrj.createContext)({
    prefixCls: '',
    firstLevel: true,
    inlineCollapsed: false
});
var $324754238ddf2353$export$2e2bcd8739ae039 = $324754238ddf2353$var$MenuContext;


function $15c1a9cf1096afbd$var$_callSuper(t, o, e) {
    return o = (0, $744q1.default)(o), (0, $82HU4.default)(t, (0, $jbuPt.default)() ? Reflect.construct(o, e || [], (0, $744q1.default)(t).constructor) : o.apply(t, e));
}
var $15c1a9cf1096afbd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $15c1a9cf1096afbd$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(MenuItem, _React$Component);
    function MenuItem() {
        var _this;
        (0, $kjNeN.default)(this, MenuItem);
        _this = $15c1a9cf1096afbd$var$_callSuper(this, MenuItem, arguments);
        _this.renderItem = function(_ref) {
            var siderCollapsed = _ref.siderCollapsed;
            var _a;
            var _this$context = _this.context, prefixCls = _this$context.prefixCls, firstLevel = _this$context.firstLevel, inlineCollapsed = _this$context.inlineCollapsed, direction = _this$context.direction, disableMenuItemTitleTooltip = _this$context.disableMenuItemTitleTooltip;
            var _this$props = _this.props, className = _this$props.className, children = _this$props.children;
            var _b = _this.props, title = _b.title, icon = _b.icon, danger = _b.danger, rest = $15c1a9cf1096afbd$var$__rest(_b, [
                "title",
                "icon",
                "danger"
            ]);
            var tooltipTitle = title;
            if (typeof title === 'undefined') tooltipTitle = firstLevel ? children : '';
            else if (title === false) tooltipTitle = '';
            var tooltipProps = {
                title: tooltipTitle
            };
            if (!siderCollapsed && !inlineCollapsed) {
                tooltipProps.title = null;
                // Reset `open` to fix control mode tooltip display not correct
                // ref: https://github.com/ant-design/ant-design/issues/16742
                tooltipProps.open = false;
            }
            var childrenLength = (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(children).length;
            var returnNode = /*#__PURE__*/ $6fFrj.createElement((0, $cfbb4b13af7f52cb$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, rest, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-item-danger"), danger), "".concat(prefixCls, "-item-only-child"), (icon ? childrenLength + 1 : childrenLength) === 1), className),
                title: typeof title === 'string' ? title : undefined
            }), (0, $79365009d9b77ac6$export$e530037191fcd5d7)(icon, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $79365009d9b77ac6$export$a8257692ac88316c)(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', "".concat(prefixCls, "-item-icon"))
            }), _this.renderItemChildren(inlineCollapsed));
            if (!disableMenuItemTitleTooltip) returnNode = /*#__PURE__*/ $6fFrj.createElement((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, tooltipProps, {
                placement: direction === 'rtl' ? 'left' : 'right',
                overlayClassName: "".concat(prefixCls, "-inline-collapsed-tooltip")
            }), returnNode);
            return returnNode;
        };
        return _this;
    }
    (0, $5KQxu.default)(MenuItem, [
        {
            key: "renderItemChildren",
            value: function renderItemChildren(inlineCollapsed) {
                var _this$context2 = this.context, prefixCls = _this$context2.prefixCls, firstLevel = _this$context2.firstLevel;
                var _this$props2 = this.props, icon = _this$props2.icon, children = _this$props2.children;
                var wrapNode = /*#__PURE__*/ $6fFrj.createElement("span", {
                    className: "".concat(prefixCls, "-title-content")
                }, children);
                // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
                // ref: https://github.com/ant-design/ant-design/pull/23456
                if (!icon || (0, $79365009d9b77ac6$export$a8257692ac88316c)(children) && children.type === 'span') {
                    if (children && inlineCollapsed && firstLevel && typeof children === 'string') return /*#__PURE__*/ $6fFrj.createElement("div", {
                        className: "".concat(prefixCls, "-inline-collapsed-noicon")
                    }, children.charAt(0));
                }
                return wrapNode;
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $6fFrj.createElement((0, $d2d8cb132a1de079$export$63554aebd2a6d54c).Consumer, null, this.renderItem);
            }
        }
    ]);
    return MenuItem;
}($6fFrj.Component);
$15c1a9cf1096afbd$export$2e2bcd8739ae039.contextType = (0, $324754238ddf2353$export$2e2bcd8739ae039);



var $fIrcP = parcelRequire("fIrcP");

var $fActo = parcelRequire("fActo");



var $6fFrj = parcelRequire("6fFrj");


function $1f18a455391ddf84$var$SubMenu(props) {
    var _a;
    var popupClassName = props.popupClassName, icon = props.icon, title = props.title, theme = props.theme;
    var context = $6fFrj.useContext((0, $324754238ddf2353$export$2e2bcd8739ae039));
    var prefixCls = context.prefixCls, inlineCollapsed = context.inlineCollapsed, antdMenuTheme = context.antdMenuTheme;
    var parentPath = (0, $67da814b8e602a99$export$d3d2d0a05677870a)();
    var titleNode;
    if (!icon) titleNode = inlineCollapsed && !parentPath.length && title && typeof title === 'string' ? /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-inline-collapsed-noicon")
    }, title.charAt(0)) : /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-title-content")
    }, title);
    else {
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        var titleIsSpan = (0, $79365009d9b77ac6$export$a8257692ac88316c)(title) && title.type === 'span';
        titleNode = /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, (0, $79365009d9b77ac6$export$e530037191fcd5d7)(icon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $79365009d9b77ac6$export$a8257692ac88316c)(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', "".concat(prefixCls, "-item-icon"))
        }), titleIsSpan ? title : /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-title-content")
        }, title));
    }
    var contextValue = $6fFrj.useMemo(function() {
        return (0, $fIrcP.default)((0, $fIrcP.default)({}, context), {
            firstLevel: false
        });
    }, [
        context
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $324754238ddf2353$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $6fFrj.createElement((0, $e492d8fcbd34a95f$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(props, [
        'icon'
    ]), {
        title: titleNode,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-").concat(theme || antdMenuTheme), popupClassName)
    })));
}
var $1f18a455391ddf84$export$2e2bcd8739ae039 = $1f18a455391ddf84$var$SubMenu;


var $d83a990cd35f1743$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $d83a990cd35f1743$var$convertItemsToNodes(list) {
    return (list || []).map(function(opt, index) {
        if (opt && (0, $5KhTJ.default)(opt) === 'object') {
            var _a = opt, label = _a.label, children = _a.children, key = _a.key, type = _a.type, restProps = $d83a990cd35f1743$var$__rest(_a, [
                "label",
                "children",
                "key",
                "type"
            ]);
            var mergedKey = key !== null && key !== void 0 ? key : "tmp-".concat(index);
            // MenuItemGroup & SubMenuItem
            if (children || type === 'group') {
                if (type === 'group') // Group
                return /*#__PURE__*/ $6fFrj.createElement((0, $cdb8e70fed13b889$export$2e2bcd8739ae039), (0, $fIrcP.default)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $d83a990cd35f1743$var$convertItemsToNodes(children));
                // Sub Menu
                return /*#__PURE__*/ $6fFrj.createElement((0, $1f18a455391ddf84$export$2e2bcd8739ae039), (0, $fIrcP.default)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $d83a990cd35f1743$var$convertItemsToNodes(children));
            }
            // MenuItem & Divider
            if (type === 'divider') return /*#__PURE__*/ $6fFrj.createElement((0, $2097bad67e992316$export$2e2bcd8739ae039), (0, $fIrcP.default)({
                key: mergedKey
            }, restProps));
            return /*#__PURE__*/ $6fFrj.createElement((0, $15c1a9cf1096afbd$export$2e2bcd8739ae039), (0, $fIrcP.default)({
                key: mergedKey
            }, restProps), label);
        }
        return null;
    }).filter(function(opt) {
        return opt;
    });
}
function $d83a990cd35f1743$export$2e2bcd8739ae039(items) {
    return $6fFrj.useMemo(function() {
        if (!items) return items;
        return $d83a990cd35f1743$var$convertItemsToNodes(items);
    }, [
        items
    ]);
}






var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");
var $d2b8d671bb21642d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/** @internal Only used for Dropdown component. Do not use this in your production. */ var $d2b8d671bb21642d$var$OverrideContext = /*#__PURE__*/ $6fFrj.createContext(null);
var $d2b8d671bb21642d$export$9bd434816b0530d0 = function OverrideProvider(_a) {
    var children = _a.children, restProps = $d2b8d671bb21642d$var$__rest(_a, [
        "children"
    ]);
    var override = $6fFrj.useContext($d2b8d671bb21642d$var$OverrideContext);
    var context = $6fFrj.useMemo(function() {
        return (0, $fIrcP.default)((0, $fIrcP.default)({}, override), restProps);
    }, [
        override,
        restProps.prefixCls,
        // restProps.expandIcon, Not mark as deps since this is a ReactNode
        restProps.mode,
        restProps.selectable
    ]);
    return /*#__PURE__*/ $6fFrj.createElement($d2b8d671bb21642d$var$OverrideContext.Provider, {
        value: context
    }, children);
};
var $d2b8d671bb21642d$export$2e2bcd8739ae039 = $d2b8d671bb21642d$var$OverrideContext;



function $d93242227496acaa$var$_callSuper(t, o, e) {
    return o = (0, $744q1.default)(o), (0, $82HU4.default)(t, (0, $jbuPt.default)() ? Reflect.construct(o, e || [], (0, $744q1.default)(t).constructor) : o.apply(t, e));
}
var $d93242227496acaa$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d93242227496acaa$var$InternalMenu = /*#__PURE__*/ (0, $6fFrj.forwardRef)(function(props, ref) {
    var _a;
    var override = $6fFrj.useContext((0, $d2b8d671bb21642d$export$2e2bcd8739ae039)) || {};
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, getPopupContainer = _React$useContext.getPopupContainer, direction = _React$useContext.direction;
    var rootPrefixCls = getPrefixCls();
    var customizePrefixCls = props.prefixCls, className = props.className, _props$theme = props.theme, theme = _props$theme === void 0 ? 'light' : _props$theme, expandIcon = props.expandIcon, _internalDisableMenuItemTitleTooltip = props._internalDisableMenuItemTitleTooltip, inlineCollapsed = props.inlineCollapsed, siderCollapsed = props.siderCollapsed, items = props.items, children = props.children, mode = props.mode, selectable = props.selectable, onClick = props.onClick, restProps = $d93242227496acaa$var$__rest(props, [
        "prefixCls",
        "className",
        "theme",
        "expandIcon",
        "_internalDisableMenuItemTitleTooltip",
        "inlineCollapsed",
        "siderCollapsed",
        "items",
        "children",
        "mode",
        "selectable",
        "onClick"
    ]);
    var passedProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(restProps, [
        'collapsedWidth'
    ]);
    // ========================= Items ===========================
    var mergedChildren = (0, $d83a990cd35f1743$export$2e2bcd8739ae039)(items) || children;
    (_a = override.validator) === null || _a === void 0 || _a.call(override, {
        mode: mode
    });
    // ========================== Click ==========================
    // Tell dropdown that item clicked
    var onItemClick = (0, $2c6ch.default)(function() {
        var _a;
        onClick === null || onClick === void 0 || onClick.apply(void 0, arguments);
        (_a = override === null || override === void 0 ? void 0 : override.onClick) === null || _a === void 0 || _a.call(override);
    });
    // ========================== Mode ===========================
    var mergedMode = override.mode || mode;
    // ======================= Selectable ========================
    var mergedSelectable = selectable !== null && selectable !== void 0 ? selectable : override.selectable;
    // ======================== Collapsed ========================
    // Inline Collapsed
    var mergedInlineCollapsed = $6fFrj.useMemo(function() {
        if (siderCollapsed !== undefined) return siderCollapsed;
        return inlineCollapsed;
    }, [
        inlineCollapsed,
        siderCollapsed
    ]);
    var defaultMotions = {
        horizontal: {
            motionName: "".concat(rootPrefixCls, "-slide-up")
        },
        inline: (0, $779588b2444df86c$export$2e2bcd8739ae039),
        other: {
            motionName: "".concat(rootPrefixCls, "-zoom-big")
        }
    };
    var prefixCls = getPrefixCls('menu', customizePrefixCls || override.prefixCls);
    var menuClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-").concat(theme), className);
    // ====================== Expand Icon ========================
    var mergedExpandIcon;
    if (typeof expandIcon === 'function') mergedExpandIcon = expandIcon;
    else mergedExpandIcon = (0, $79365009d9b77ac6$export$e530037191fcd5d7)(expandIcon || override.expandIcon, {
        className: "".concat(prefixCls, "-submenu-expand-icon")
    });
    // ======================== Context ==========================
    var contextValue = $6fFrj.useMemo(function() {
        return {
            prefixCls: prefixCls,
            inlineCollapsed: mergedInlineCollapsed || false,
            antdMenuTheme: theme,
            direction: direction,
            firstLevel: true,
            disableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip
        };
    }, [
        prefixCls,
        mergedInlineCollapsed,
        theme,
        direction,
        _internalDisableMenuItemTitleTooltip
    ]);
    // ========================= Render ==========================
    return /*#__PURE__*/ $6fFrj.createElement((0, $d2b8d671bb21642d$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $6fFrj.createElement((0, $324754238ddf2353$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $6fFrj.createElement((0, $7fff6aa471b37d3c$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        getPopupContainer: getPopupContainer,
        overflowedIndicator: /*#__PURE__*/ $6fFrj.createElement((0, $982a9c0f9e1ff223$export$2e2bcd8739ae039), null),
        overflowedIndicatorPopupClassName: "".concat(prefixCls, "-").concat(theme),
        mode: mergedMode,
        selectable: mergedSelectable,
        onClick: onItemClick
    }, passedProps, {
        inlineCollapsed: mergedInlineCollapsed,
        className: menuClassName,
        prefixCls: prefixCls,
        direction: direction,
        defaultMotions: defaultMotions,
        expandIcon: mergedExpandIcon,
        ref: ref
    }), mergedChildren)));
});
// We should keep this as ref-able
var $d93242227496acaa$var$Menu = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(Menu, _React$Component);
    function Menu() {
        var _this;
        (0, $kjNeN.default)(this, Menu);
        _this = $d93242227496acaa$var$_callSuper(this, Menu, arguments);
        _this.focus = function(options) {
            var _a;
            (_a = _this.menu) === null || _a === void 0 || _a.focus(options);
        };
        return _this;
    }
    (0, $5KQxu.default)(Menu, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                return /*#__PURE__*/ $6fFrj.createElement((0, $d2d8cb132a1de079$export$63554aebd2a6d54c).Consumer, null, function(context) {
                    return /*#__PURE__*/ $6fFrj.createElement($d93242227496acaa$var$InternalMenu, (0, $fIrcP.default)({
                        ref: function ref(node) {
                            _this2.menu = node;
                        }
                    }, _this2.props, context));
                });
            }
        }
    ]);
    return Menu;
}($6fFrj.Component);
$d93242227496acaa$var$Menu.Divider = (0, $2097bad67e992316$export$2e2bcd8739ae039);
$d93242227496acaa$var$Menu.Item = (0, $15c1a9cf1096afbd$export$2e2bcd8739ae039);
$d93242227496acaa$var$Menu.SubMenu = (0, $1f18a455391ddf84$export$2e2bcd8739ae039);
$d93242227496acaa$var$Menu.ItemGroup = (0, $cdb8e70fed13b889$export$2e2bcd8739ae039);
var $d93242227496acaa$export$2e2bcd8739ae039 = $d93242227496acaa$var$Menu;









var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");


var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");





var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");


var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $aSXdS = parcelRequire("aSXdS");

var $aSXdS = parcelRequire("aSXdS");
var $8f55e1da1d754100$var$isStyleNameSupport = function isStyleNameSupport(styleName) {
    if ((0, $aSXdS.default)() && window.document.documentElement) {
        var styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        var documentElement = window.document.documentElement;
        return styleNameList.some(function(name) {
            return name in documentElement.style;
        });
    }
    return false;
};
var $8f55e1da1d754100$var$isStyleValueSupport = function isStyleValueSupport(styleName, value) {
    if (!$8f55e1da1d754100$var$isStyleNameSupport(styleName)) return false;
    var ele = document.createElement('div');
    var origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function $8f55e1da1d754100$export$d616d7831008e86c(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return $8f55e1da1d754100$var$isStyleValueSupport(styleName, styleValue);
    return $8f55e1da1d754100$var$isStyleNameSupport(styleName);
}


var $f43587e78228a7cc$export$7dbdadf5e9653129 = function canUseDocElement() {
    return (0, $aSXdS.default)() && window.document.documentElement;
};
var $f43587e78228a7cc$var$flexGapSupported;
var $f43587e78228a7cc$export$bb61d27183d1477 = function detectFlexGapSupported() {
    if (!$f43587e78228a7cc$export$7dbdadf5e9653129()) return false;
    if ($f43587e78228a7cc$var$flexGapSupported !== undefined) return $f43587e78228a7cc$var$flexGapSupported;
    // create flex container with row-gap set
    var flex = document.createElement('div');
    flex.style.display = 'flex';
    flex.style.flexDirection = 'column';
    flex.style.rowGap = '1px';
    // create two, elements inside it
    flex.appendChild(document.createElement('div'));
    flex.appendChild(document.createElement('div'));
    // append to the DOM (needed to obtain scrollHeight)
    document.body.appendChild(flex);
    $f43587e78228a7cc$var$flexGapSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
    document.body.removeChild(flex);
    return $f43587e78228a7cc$var$flexGapSupported;
};


var $f73ca2a82d55ff05$export$2e2bcd8739ae039 = function() {
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), flexible = _React$useState2[0], setFlexible = _React$useState2[1];
    $6fFrj.useEffect(function() {
        setFlexible((0, $f43587e78228a7cc$export$bb61d27183d1477)());
    }, []);
    return flexible;
};



var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

function $1c962cf6d99c15dd$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, direction = _ref.direction, index = _ref.index, marginDirection = _ref.marginDirection, children = _ref.children, split = _ref.split, wrap = _ref.wrap;
    var _React$useContext = $6fFrj.useContext((0, $4563a45a032814da$export$853f607fd5cc208b)), horizontalSize = _React$useContext.horizontalSize, verticalSize = _React$useContext.verticalSize, latestIndex = _React$useContext.latestIndex, supportFlexGap = _React$useContext.supportFlexGap;
    var style = {};
    if (!supportFlexGap) {
        if (direction === 'vertical') {
            if (index < latestIndex) style = {
                marginBottom: horizontalSize / (split ? 2 : 1)
            };
        } else style = (0, $fIrcP.default)((0, $fIrcP.default)({}, index < latestIndex && (0, $43449.default)({}, marginDirection, horizontalSize / (split ? 2 : 1))), wrap && {
            paddingBottom: verticalSize
        });
    }
    if (children === null || children === undefined) return null;
    return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: className,
        style: style
    }, children), index < latestIndex && split && /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(className, "-split"),
        style: style
    }, split));
}



var $4563a45a032814da$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4563a45a032814da$export$853f607fd5cc208b = /*#__PURE__*/ $6fFrj.createContext({
    latestIndex: 0,
    horizontalSize: 0,
    verticalSize: 0,
    supportFlexGap: false
});
var $4563a45a032814da$var$spaceSize = {
    small: 8,
    middle: 16,
    large: 24
};
function $4563a45a032814da$var$getNumberSize(size) {
    return typeof size === 'string' ? $4563a45a032814da$var$spaceSize[size] : size || 0;
}
var $4563a45a032814da$var$Space = function Space(props) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, space = _React$useContext.space, directionConfig = _React$useContext.direction;
    var _props$size = props.size, size = _props$size === void 0 ? (space === null || space === void 0 ? void 0 : space.size) || 'small' : _props$size, align = props.align, className = props.className, children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? 'horizontal' : _props$direction, customizePrefixCls = props.prefixCls, split = props.split, style = props.style, _props$wrap = props.wrap, wrap = _props$wrap === void 0 ? false : _props$wrap, otherProps = $4563a45a032814da$var$__rest(props, [
        "size",
        "align",
        "className",
        "children",
        "direction",
        "prefixCls",
        "split",
        "style",
        "wrap"
    ]);
    var supportFlexGap = (0, $f73ca2a82d55ff05$export$2e2bcd8739ae039)();
    var _React$useMemo = $6fFrj.useMemo(function() {
        return (Array.isArray(size) ? size : [
            size,
            size
        ]).map(function(item) {
            return $4563a45a032814da$var$getNumberSize(item);
        });
    }, [
        size
    ]), _React$useMemo2 = (0, $jP8CL.default)(_React$useMemo, 2), horizontalSize = _React$useMemo2[0], verticalSize = _React$useMemo2[1];
    var childNodes = (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(children, {
        keepEmpty: true
    });
    var mergedAlign = align === undefined && direction === 'horizontal' ? 'center' : align;
    var prefixCls = getPrefixCls('space', customizePrefixCls);
    var cn = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-").concat(direction), (0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-rtl"), directionConfig === 'rtl'), "".concat(prefixCls, "-align-").concat(mergedAlign), mergedAlign), className);
    var itemClassName = "".concat(prefixCls, "-item");
    var marginDirection = directionConfig === 'rtl' ? 'marginLeft' : 'marginRight';
    // Calculate latest one
    var latestIndex = 0;
    var nodes = childNodes.map(function(child, i) {
        if (child !== null && child !== undefined) latestIndex = i;
        var key = child && child.key || "".concat(itemClassName, "-").concat(i);
        return /*#__PURE__*/ $6fFrj.createElement((0, $1c962cf6d99c15dd$export$2e2bcd8739ae039), {
            className: itemClassName,
            key: key,
            direction: direction,
            index: i,
            marginDirection: marginDirection,
            split: split,
            wrap: wrap
        }, child);
    });
    var spaceContext = $6fFrj.useMemo(function() {
        return {
            horizontalSize: horizontalSize,
            verticalSize: verticalSize,
            latestIndex: latestIndex,
            supportFlexGap: supportFlexGap
        };
    }, [
        horizontalSize,
        verticalSize,
        latestIndex,
        supportFlexGap
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    var gapStyle = {};
    if (wrap) {
        gapStyle.flexWrap = 'wrap';
        // Patch for gap not support
        if (!supportFlexGap) gapStyle.marginBottom = -verticalSize;
    }
    if (supportFlexGap) {
        gapStyle.columnGap = horizontalSize;
        gapStyle.rowGap = verticalSize;
    }
    return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        className: cn,
        style: (0, $fIrcP.default)((0, $fIrcP.default)({}, gapStyle), style)
    }, otherProps), /*#__PURE__*/ $6fFrj.createElement($4563a45a032814da$export$853f607fd5cc208b.Provider, {
        value: spaceContext
    }, nodes));
};
var $4563a45a032814da$var$CompoundedSpace = $4563a45a032814da$var$Space;
$4563a45a032814da$var$CompoundedSpace.Compact = (0, $87f4fe035d0a15fd$export$2e2bcd8739ae039);
var $4563a45a032814da$export$2e2bcd8739ae039 = $4563a45a032814da$var$CompoundedSpace;


var $0810611491292635$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0810611491292635$var$DropdownButton = function DropdownButton(props) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var customizePrefixCls = props.prefixCls, _props$type = props.type, type = _props$type === void 0 ? 'default' : _props$type, danger = props.danger, disabled = props.disabled, loading = props.loading, onClick = props.onClick, htmlType = props.htmlType, children = props.children, className = props.className, menu = props.menu, arrow = props.arrow, autoFocus = props.autoFocus, overlay = props.overlay, trigger = props.trigger, align = props.align, visible = props.visible, open = props.open, onVisibleChange = props.onVisibleChange, onOpenChange = props.onOpenChange, placement = props.placement, getPopupContainer = props.getPopupContainer, href = props.href, _props$icon = props.icon, icon = _props$icon === void 0 ? /*#__PURE__*/ $6fFrj.createElement((0, $982a9c0f9e1ff223$export$2e2bcd8739ae039), null) : _props$icon, title = props.title, _props$buttonsRender = props.buttonsRender, buttonsRender = _props$buttonsRender === void 0 ? function(buttons) {
        return buttons;
    } : _props$buttonsRender, mouseEnterDelay = props.mouseEnterDelay, mouseLeaveDelay = props.mouseLeaveDelay, overlayClassName = props.overlayClassName, overlayStyle = props.overlayStyle, destroyPopupOnHide = props.destroyPopupOnHide, restProps = $0810611491292635$var$__rest(props, [
        "prefixCls",
        "type",
        "danger",
        "disabled",
        "loading",
        "onClick",
        "htmlType",
        "children",
        "className",
        "menu",
        "arrow",
        "autoFocus",
        "overlay",
        "trigger",
        "align",
        "visible",
        "open",
        "onVisibleChange",
        "onOpenChange",
        "placement",
        "getPopupContainer",
        "href",
        "icon",
        "title",
        "buttonsRender",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayClassName",
        "overlayStyle",
        "destroyPopupOnHide"
    ]);
    var prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
    var dropdownProps = {
        menu: menu,
        arrow: arrow,
        autoFocus: autoFocus,
        align: align,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        onOpenChange: onOpenChange || onVisibleChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        overlayClassName: overlayClassName,
        overlayStyle: overlayStyle,
        destroyPopupOnHide: destroyPopupOnHide
    };
    var _useCompactItemContex = (0, $87f4fe035d0a15fd$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, compactItemClassnames, className);
    if ('overlay' in props) dropdownProps.overlay = overlay;
    if ('open' in props) dropdownProps.open = open;
    else if ('visible' in props) dropdownProps.open = visible;
    if ('placement' in props) dropdownProps.placement = placement;
    else dropdownProps.placement = direction === 'rtl' ? 'bottomLeft' : 'bottomRight';
    var leftButton = /*#__PURE__*/ $6fFrj.createElement((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        disabled: disabled,
        loading: loading,
        onClick: onClick,
        htmlType: htmlType,
        href: href,
        title: title
    }, children);
    var rightButton = /*#__PURE__*/ $6fFrj.createElement((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        icon: icon
    });
    var _buttonsRender = buttonsRender([
        leftButton,
        rightButton
    ]), _buttonsRender2 = (0, $jP8CL.default)(_buttonsRender, 2), leftButtonToRender = _buttonsRender2[0], rightButtonToRender = _buttonsRender2[1];
    return /*#__PURE__*/ $6fFrj.createElement((0, $4563a45a032814da$export$2e2bcd8739ae039).Compact, (0, $fIrcP.default)({
        className: classes,
        size: compactSize,
        block: true
    }, restProps), leftButtonToRender, /*#__PURE__*/ $6fFrj.createElement((0, $0c3681e83b80e1fa$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, dropdownProps), rightButtonToRender));
};
$0810611491292635$var$DropdownButton.__ANT_BUTTON = true;
var $0810611491292635$export$2e2bcd8739ae039 = $0810611491292635$var$DropdownButton;



var $0c3681e83b80e1fa$var$Placements = (0, $cacd97b96801cebe$export$65e3907585753458)('topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight', 'top', 'bottom');
var $0c3681e83b80e1fa$var$Dropdown = function Dropdown(props) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var getTransitionName = function getTransitionName() {
        var rootPrefixCls = getPrefixCls();
        var _props$placement = props.placement, placement = _props$placement === void 0 ? '' : _props$placement, transitionName = props.transitionName;
        if (transitionName !== undefined) return transitionName;
        if (placement.includes('top')) return "".concat(rootPrefixCls, "-slide-down");
        return "".concat(rootPrefixCls, "-slide-up");
    };
    var getPlacement = function getPlacement() {
        var placement = props.placement;
        if (!placement) return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
        if (placement.includes('Center')) {
            var newPlacement = placement.slice(0, placement.indexOf('Center'));
            return newPlacement;
        }
        return placement;
    };
    var menu = props.menu, arrow = props.arrow, customizePrefixCls = props.prefixCls, children = props.children, trigger = props.trigger, disabled = props.disabled, dropdownRender = props.dropdownRender, getPopupContainer = props.getPopupContainer, overlayClassName = props.overlayClassName, visible = props.visible, open = props.open, onVisibleChange = props.onVisibleChange, onOpenChange = props.onOpenChange, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0.15 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, _props$autoAdjustOver = props.autoAdjustOverflow, autoAdjustOverflow = _props$autoAdjustOver === void 0 ? true : _props$autoAdjustOver;
    var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    var child = $6fFrj.Children.only(children);
    var dropdownTrigger = (0, $79365009d9b77ac6$export$e530037191fcd5d7)(child, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-trigger"), (0, $43449.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), child.props.className),
        disabled: disabled
    });
    var triggerActions = disabled ? [] : trigger;
    var alignPoint;
    if (triggerActions && triggerActions.includes('contextMenu')) alignPoint = true;
    // =========================== Visible ============================
    var _useMergedState = (0, $gfhff.default)(false, {
        value: open !== undefined ? open : visible
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), mergedOpen = _useMergedState2[0], setOpen = _useMergedState2[1];
    var onInnerOpenChange = (0, $2c6ch.default)(function(nextOpen) {
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(nextOpen);
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(nextOpen);
        setOpen(nextOpen);
    });
    // =========================== Overlay ============================
    var overlayClassNameCustomized = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(overlayClassName, (0, $43449.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'));
    var builtinPlacements = (0, $d37ba5a2b0fdef06$export$2e2bcd8739ae039)({
        arrowPointAtCenter: (0, $5KhTJ.default)(arrow) === 'object' && arrow.pointAtCenter,
        autoAdjustOverflow: autoAdjustOverflow
    });
    var onMenuClick = $6fFrj.useCallback(function() {
        setOpen(false);
    }, []);
    var renderOverlay = function renderOverlay() {
        // rc-dropdown already can process the function of overlay, but we have check logic here.
        // So we need render the element to check and pass back to rc-dropdown.
        var overlay = props.overlay;
        var overlayNode;
        if (menu === null || menu === void 0 ? void 0 : menu.items) overlayNode = /*#__PURE__*/ $6fFrj.createElement((0, $d93242227496acaa$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, menu));
        else if (typeof overlay === 'function') overlayNode = overlay();
        else overlayNode = overlay;
        if (dropdownRender) overlayNode = dropdownRender(overlayNode);
        overlayNode = $6fFrj.Children.only(typeof overlayNode === 'string' ? /*#__PURE__*/ $6fFrj.createElement("span", null, overlayNode) : overlayNode);
        return /*#__PURE__*/ $6fFrj.createElement((0, $d2b8d671bb21642d$export$9bd434816b0530d0), {
            prefixCls: "".concat(prefixCls, "-menu"),
            expandIcon: /*#__PURE__*/ $6fFrj.createElement("span", {
                className: "".concat(prefixCls, "-menu-submenu-arrow")
            }, /*#__PURE__*/ $6fFrj.createElement((0, $e7bd83ac29db4850$export$2e2bcd8739ae039), {
                className: "".concat(prefixCls, "-menu-submenu-arrow-icon")
            })),
            mode: "vertical",
            selectable: false,
            onClick: onMenuClick,
            validator: function validator(_ref3) {
                var mode = _ref3.mode;
            }
        }, /*#__PURE__*/ $6fFrj.createElement((0, $87f4fe035d0a15fd$export$5f56e610a4afb685), null, overlayNode));
    };
    // ============================ Render ============================
    return /*#__PURE__*/ $6fFrj.createElement((0, $35d13f388ca7de9e$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        alignPoint: alignPoint
    }, props, {
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        visible: mergedOpen,
        builtinPlacements: builtinPlacements,
        arrow: !!arrow,
        overlayClassName: overlayClassNameCustomized,
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: getTransitionName(),
        trigger: triggerActions,
        overlay: renderOverlay,
        placement: getPlacement(),
        onVisibleChange: onInnerOpenChange
    }), dropdownTrigger);
};
$0c3681e83b80e1fa$var$Dropdown.Button = (0, $0810611491292635$export$2e2bcd8739ae039);
var $0c3681e83b80e1fa$export$2e2bcd8739ae039 = $0c3681e83b80e1fa$var$Dropdown;


var $7372c2afe14f5106$export$2e2bcd8739ae039 = (0, $0c3681e83b80e1fa$export$2e2bcd8739ae039);


var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");



var $6fFrj = parcelRequire("6fFrj");

var $4c069033e92966b1$var$Empty = function Empty() {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('empty-img-default');
    return /*#__PURE__*/ $6fFrj.createElement("svg", {
        className: prefixCls,
        width: "184",
        height: "152",
        viewBox: "0 0 184 152",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $6fFrj.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $6fFrj.createElement("g", {
        transform: "translate(24 31.67)"
    }, /*#__PURE__*/ $6fFrj.createElement("ellipse", {
        className: "".concat(prefixCls, "-ellipse"),
        cx: "67.797",
        cy: "106.89",
        rx: "67.797",
        ry: "12.668"
    }), /*#__PURE__*/ $6fFrj.createElement("path", {
        className: "".concat(prefixCls, "-path-1"),
        d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
    }), /*#__PURE__*/ $6fFrj.createElement("path", {
        className: "".concat(prefixCls, "-path-2"),
        d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
        transform: "translate(13.56)"
    }), /*#__PURE__*/ $6fFrj.createElement("path", {
        className: "".concat(prefixCls, "-path-3"),
        d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
    }), /*#__PURE__*/ $6fFrj.createElement("path", {
        className: "".concat(prefixCls, "-path-4"),
        d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
    })), /*#__PURE__*/ $6fFrj.createElement("path", {
        className: "".concat(prefixCls, "-path-5"),
        d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
    }), /*#__PURE__*/ $6fFrj.createElement("g", {
        className: "".concat(prefixCls, "-g"),
        transform: "translate(149.65 15.383)"
    }, /*#__PURE__*/ $6fFrj.createElement("ellipse", {
        cx: "20.654",
        cy: "3.167",
        rx: "2.849",
        ry: "2.815"
    }), /*#__PURE__*/ $6fFrj.createElement("path", {
        d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
    }))));
};
var $4c069033e92966b1$export$2e2bcd8739ae039 = $4c069033e92966b1$var$Empty;



var $6fFrj = parcelRequire("6fFrj");

var $7022cc43116fd438$var$Simple = function Simple() {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('empty-img-simple');
    return /*#__PURE__*/ $6fFrj.createElement("svg", {
        className: prefixCls,
        width: "64",
        height: "41",
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $6fFrj.createElement("g", {
        transform: "translate(0 1)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $6fFrj.createElement("ellipse", {
        className: "".concat(prefixCls, "-ellipse"),
        cx: "32",
        cy: "33",
        rx: "32",
        ry: "7"
    }), /*#__PURE__*/ $6fFrj.createElement("g", {
        className: "".concat(prefixCls, "-g"),
        fillRule: "nonzero"
    }, /*#__PURE__*/ $6fFrj.createElement("path", {
        d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
    }), /*#__PURE__*/ $6fFrj.createElement("path", {
        d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
        className: "".concat(prefixCls, "-path")
    }))));
};
var $7022cc43116fd438$export$2e2bcd8739ae039 = $7022cc43116fd438$var$Simple;


var $9150234f0969a884$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9150234f0969a884$var$defaultEmptyImg = /*#__PURE__*/ $6fFrj.createElement((0, $4c069033e92966b1$export$2e2bcd8739ae039), null);
var $9150234f0969a884$var$simpleEmptyImg = /*#__PURE__*/ $6fFrj.createElement((0, $7022cc43116fd438$export$2e2bcd8739ae039), null);
var $9150234f0969a884$var$Empty = function Empty(_a) {
    var className = _a.className, customizePrefixCls = _a.prefixCls, _a$image = _a.image, image = _a$image === void 0 ? $9150234f0969a884$var$defaultEmptyImg : _a$image, description = _a.description, children = _a.children, imageStyle = _a.imageStyle, restProps = $9150234f0969a884$var$__rest(_a, [
        "className",
        "prefixCls",
        "image",
        "description",
        "children",
        "imageStyle"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    return /*#__PURE__*/ $6fFrj.createElement((0, $d37c6ecde78f75e8$export$2e2bcd8739ae039), {
        componentName: "Empty"
    }, function(contextLocale) {
        var prefixCls = getPrefixCls('empty', customizePrefixCls);
        var des = typeof description !== 'undefined' ? description : contextLocale.description;
        var alt = typeof des === 'string' ? des : 'empty';
        var imageNode = null;
        if (typeof image === 'string') imageNode = /*#__PURE__*/ $6fFrj.createElement("img", {
            alt: alt,
            src: image
        });
        else imageNode = image;
        return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-normal"), image === $9150234f0969a884$var$simpleEmptyImg), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className)
        }, restProps), /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-image"),
            style: imageStyle
        }, imageNode), des && /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-description")
        }, des), children && /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-footer")
        }, children));
    });
};
$9150234f0969a884$var$Empty.PRESENTED_IMAGE_DEFAULT = $9150234f0969a884$var$defaultEmptyImg;
$9150234f0969a884$var$Empty.PRESENTED_IMAGE_SIMPLE = $9150234f0969a884$var$simpleEmptyImg;
var $9150234f0969a884$export$2e2bcd8739ae039 = $9150234f0969a884$var$Empty;




var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $37xND = parcelRequire("37xND");

var $fActo = parcelRequire("fActo");
parcelRequire("5EVeC");
var $2ZBO2 = parcelRequire("2ZBO2");
var $5EVeC = parcelRequire("5EVeC");

var $6fFrj = parcelRequire("6fFrj");




var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
function $022c88bd41a3a001$export$2e2bcd8739ae039(value) {
    var _React$useState = $6fFrj.useState(value), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), cacheValue = _React$useState2[0], setCacheValue = _React$useState2[1];
    $6fFrj.useEffect(function() {
        var timeout = setTimeout(function() {
            setCacheValue(value);
        }, value.length ? 0 : 10);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        value
    ]);
    return cacheValue;
}


var $14fc1bd106b69eac$var$EMPTY_LIST = [];
function $14fc1bd106b69eac$var$toErrorEntity(error, errorStatus, prefix) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    return {
        key: typeof error === 'string' ? error : "".concat(prefix, "-").concat(index),
        error: error,
        errorStatus: errorStatus
    };
}
function $14fc1bd106b69eac$export$2e2bcd8739ae039(_ref) {
    var help = _ref.help, helpStatus = _ref.helpStatus, _ref$errors = _ref.errors, errors = _ref$errors === void 0 ? $14fc1bd106b69eac$var$EMPTY_LIST : _ref$errors, _ref$warnings = _ref.warnings, warnings = _ref$warnings === void 0 ? $14fc1bd106b69eac$var$EMPTY_LIST : _ref$warnings, rootClassName = _ref.className, fieldId = _ref.fieldId, onVisibleChanged = _ref.onVisibleChanged;
    var _React$useContext = $6fFrj.useContext((0, $76d69cb8326089c6$export$fb6582d3042cc879)), prefixCls = _React$useContext.prefixCls;
    var _React$useContext2 = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext2.getPrefixCls;
    var baseClassName = "".concat(prefixCls, "-item-explain");
    var rootPrefixCls = getPrefixCls();
    // We have to debounce here again since somewhere use ErrorList directly still need no shaking
    // ref: https://github.com/ant-design/ant-design/issues/36336
    var debounceErrors = (0, $022c88bd41a3a001$export$2e2bcd8739ae039)(errors);
    var debounceWarnings = (0, $022c88bd41a3a001$export$2e2bcd8739ae039)(warnings);
    var fullKeyList = $6fFrj.useMemo(function() {
        if (help !== undefined && help !== null) return [
            $14fc1bd106b69eac$var$toErrorEntity(help, helpStatus, 'help')
        ];
        return [].concat((0, $37xND.default)(debounceErrors.map(function(error, index) {
            return $14fc1bd106b69eac$var$toErrorEntity(error, 'error', 'error', index);
        })), (0, $37xND.default)(debounceWarnings.map(function(warning, index) {
            return $14fc1bd106b69eac$var$toErrorEntity(warning, 'warning', 'warning', index);
        })));
    }, [
        help,
        helpStatus,
        debounceErrors,
        debounceWarnings
    ]);
    var helpProps = {};
    if (fieldId) helpProps.id = "".concat(fieldId, "_help");
    return /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), {
        motionDeadline: (0, $779588b2444df86c$export$2e2bcd8739ae039).motionDeadline,
        motionName: "".concat(rootPrefixCls, "-show-help"),
        visible: !!fullKeyList.length,
        onVisibleChanged: onVisibleChanged
    }, function(holderProps) {
        var holderClassName = holderProps.className, holderStyle = holderProps.style;
        return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({}, helpProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(baseClassName, holderClassName, rootClassName),
            style: holderStyle,
            role: "alert"
        }), /*#__PURE__*/ $6fFrj.createElement((0, $2ZBO2.default), (0, $fIrcP.default)({
            keys: fullKeyList
        }, (0, $779588b2444df86c$export$2e2bcd8739ae039), {
            motionName: "".concat(rootPrefixCls, "-show-help-item"),
            component: false
        }), function(itemProps) {
            var key = itemProps.key, error = itemProps.error, errorStatus = itemProps.errorStatus, itemClassName = itemProps.className, itemStyle = itemProps.style;
            return /*#__PURE__*/ $6fFrj.createElement("div", {
                key: key,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(itemClassName, (0, $43449.default)({}, "".concat(baseClassName, "-").concat(errorStatus), errorStatus)),
                style: itemStyle
            }, error);
        }));
    });
}



var $fIrcP = parcelRequire("fIrcP");

var $5KhTJ = parcelRequire("5KhTJ");

var $jP8CL = parcelRequire("jP8CL");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");






var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");


var $6fFrj = parcelRequire("6fFrj");
function $9c15d38a19b445a9$var$t(t) {
    return "object" == typeof t && null != t && 1 === t.nodeType;
}
function $9c15d38a19b445a9$var$e(t, e) {
    return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function $9c15d38a19b445a9$var$n(t, n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return $9c15d38a19b445a9$var$e(r.overflowY, n) || $9c15d38a19b445a9$var$e(r.overflowX, n) || function(t) {
            var e = function(t) {
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            }(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
    }
    return !1;
}
function $9c15d38a19b445a9$var$r(t, e, n, r, i, o, l, d) {
    return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
var $9c15d38a19b445a9$export$2e2bcd8739ae039 = function(e, i) {
    var o = window, l = i.scrollMode, d = i.block, f = i.inline, h = i.boundary, u = i.skipOverflowHiddenElements, s = "function" == typeof h ? h : function(t) {
        return t !== h;
    };
    if (!$9c15d38a19b445a9$var$t(e)) throw new TypeError("Invalid target");
    for(var a, c, g = document.scrollingElement || document.documentElement, p = [], m = e; $9c15d38a19b445a9$var$t(m) && s(m);){
        if ((m = null == (c = (a = m).parentElement) ? a.getRootNode().host || null : c) === g) {
            p.push(m);
            break;
        }
        null != m && m === document.body && $9c15d38a19b445a9$var$n(m) && !$9c15d38a19b445a9$var$n(document.documentElement) || null != m && $9c15d38a19b445a9$var$n(m, u) && p.push(m);
    }
    for(var w = o.visualViewport ? o.visualViewport.width : innerWidth, v = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, E = b.width, M = b.top, V = b.right, x = b.bottom, I = b.left, C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2, R = "center" === f ? I + E / 2 : "end" === f ? V : I, T = [], k = 0; k < p.length; k++){
        var B = p[k], D = B.getBoundingClientRect(), O = D.height, X = D.width, Y = D.top, L = D.right, S = D.bottom, j = D.left;
        if ("if-needed" === l && M >= 0 && I >= 0 && x <= v && V <= w && M >= Y && x <= S && I >= j && V <= L) return T;
        var N = getComputedStyle(B), q = parseInt(N.borderLeftWidth, 10), z = parseInt(N.borderTopWidth, 10), A = parseInt(N.borderRightWidth, 10), F = parseInt(N.borderBottomWidth, 10), G = 0, J = 0, K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0, P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0, Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0, U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
        if (g === B) G = "start" === d ? C : "end" === d ? C - v : "nearest" === d ? $9c15d38a19b445a9$var$r(H, H + v, v, z, F, H + C, H + C + y, y) : C - v / 2, J = "start" === f ? R : "center" === f ? R - w / 2 : "end" === f ? R - w : $9c15d38a19b445a9$var$r(W, W + w, w, q, A, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);
        else {
            G = "start" === d ? C - Y - z : "end" === d ? C - S + F + P : "nearest" === d ? $9c15d38a19b445a9$var$r(Y, S, O, z, F + P, C, C + y, y) : C - (Y + O / 2) + P / 2, J = "start" === f ? R - j - q : "center" === f ? R - (j + X / 2) + K / 2 : "end" === f ? R - L + A + K : $9c15d38a19b445a9$var$r(j, L, X, q, A + K, R, R + E, E);
            var Z = B.scrollLeft, $ = B.scrollTop;
            C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
        }
        T.push({
            el: B,
            top: G,
            left: J
        });
    }
    return T;
};


function $ed0598ef2ec57603$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $ed0598ef2ec57603$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $ed0598ef2ec57603$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($ed0598ef2ec57603$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $ed0598ef2ec57603$var$scrollIntoView(target, options) {
    var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
    if ($ed0598ef2ec57603$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(isTargetAttached ? (0, $9c15d38a19b445a9$export$2e2bcd8739ae039)(target, options) : []);
    if (!isTargetAttached) return;
    var computeOptions = $ed0598ef2ec57603$var$getOptions(options);
    return $ed0598ef2ec57603$var$defaultBehavior((0, $9c15d38a19b445a9$export$2e2bcd8739ae039)(target, computeOptions), computeOptions.behavior);
}
var $ed0598ef2ec57603$export$2e2bcd8739ae039 = $ed0598ef2ec57603$var$scrollIntoView;


// form item name black list.  in form ,you can use form.id get the form item element.
// use object hasOwnProperty will get better performance if black list is longer.
var $e51608610e29b4c6$var$formItemNameBlackList = [
    'parentNode'
];
// default form item id prefix.
var $e51608610e29b4c6$var$defaultItemNamePrefixCls = 'form_item';
function $e51608610e29b4c6$export$45b10814cc054894(candidate) {
    if (candidate === undefined || candidate === false) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
}
function $e51608610e29b4c6$export$f4457e83c74ac000(namePath, formName) {
    if (!namePath.length) return undefined;
    var mergedId = namePath.join('_');
    if (formName) return "".concat(formName, "_").concat(mergedId);
    var isIllegalName = $e51608610e29b4c6$var$formItemNameBlackList.includes(mergedId);
    return isIllegalName ? "".concat($e51608610e29b4c6$var$defaultItemNamePrefixCls, "_").concat(mergedId) : mergedId;
}


function $48e68a99c10419d1$var$toNamePathStr(name) {
    var namePath = (0, $e51608610e29b4c6$export$45b10814cc054894)(name);
    return namePath.join('_');
}
function $48e68a99c10419d1$export$2e2bcd8739ae039(form) {
    var _useRcForm = (0, $44d9c13e1ed4cda1$export$2e2bcd8739ae039)(), _useRcForm2 = (0, $jP8CL.default)(_useRcForm, 1), rcForm = _useRcForm2[0];
    var itemsRef = $6fFrj.useRef({});
    var wrapForm = $6fFrj.useMemo(function() {
        return form !== null && form !== void 0 ? form : (0, $fIrcP.default)((0, $fIrcP.default)({}, rcForm), {
            __INTERNAL__: {
                itemRef: function itemRef(name) {
                    return function(node) {
                        var namePathStr = $48e68a99c10419d1$var$toNamePathStr(name);
                        if (node) itemsRef.current[namePathStr] = node;
                        else delete itemsRef.current[namePathStr];
                    };
                }
            },
            scrollToField: function scrollToField(name) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var namePath = (0, $e51608610e29b4c6$export$45b10814cc054894)(name);
                var fieldId = (0, $e51608610e29b4c6$export$f4457e83c74ac000)(namePath, wrapForm.__INTERNAL__.name);
                var node = fieldId ? document.getElementById(fieldId) : null;
                if (node) (0, $ed0598ef2ec57603$export$2e2bcd8739ae039)(node, (0, $fIrcP.default)({
                    scrollMode: 'if-needed',
                    block: 'nearest'
                }, options));
            },
            getFieldInstance: function getFieldInstance(name) {
                var namePathStr = $48e68a99c10419d1$var$toNamePathStr(name);
                return itemsRef.current[namePathStr];
            }
        });
    }, [
        form,
        rcForm
    ]);
    return [
        wrapForm
    ];
}


var $b6a9e8ffa0690d50$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b6a9e8ffa0690d50$var$InternalForm = function InternalForm(props, ref) {
    var contextSize = $6fFrj.useContext((0, $aefad26b74860b7e$export$2e2bcd8739ae039));
    var contextDisabled = $6fFrj.useContext((0, $3880af76d17f94a3$export$2e2bcd8739ae039));
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, contextForm = _React$useContext.form;
    var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, _props$size = props.size, size = _props$size === void 0 ? contextSize : _props$size, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? contextDisabled : _props$disabled, form = props.form, colon = props.colon, labelAlign = props.labelAlign, labelWrap = props.labelWrap, labelCol = props.labelCol, wrapperCol = props.wrapperCol, hideRequiredMark = props.hideRequiredMark, _props$layout = props.layout, layout = _props$layout === void 0 ? 'horizontal' : _props$layout, scrollToFirstError = props.scrollToFirstError, requiredMark = props.requiredMark, onFinishFailed = props.onFinishFailed, name = props.name, restFormProps = $b6a9e8ffa0690d50$var$__rest(props, [
        "prefixCls",
        "className",
        "size",
        "disabled",
        "form",
        "colon",
        "labelAlign",
        "labelWrap",
        "labelCol",
        "wrapperCol",
        "hideRequiredMark",
        "layout",
        "scrollToFirstError",
        "requiredMark",
        "onFinishFailed",
        "name"
    ]);
    var contextValidateMessages = $6fFrj.useContext((0, $5022a8205bf86c7a$export$2e2bcd8739ae039));
    var mergedRequiredMark = (0, $6fFrj.useMemo)(function() {
        if (requiredMark !== undefined) return requiredMark;
        if (contextForm && contextForm.requiredMark !== undefined) return contextForm.requiredMark;
        if (hideRequiredMark) return false;
        return true;
    }, [
        hideRequiredMark,
        requiredMark,
        contextForm
    ]);
    var mergedColon = colon !== null && colon !== void 0 ? colon : contextForm === null || contextForm === void 0 ? void 0 : contextForm.colon;
    var prefixCls = getPrefixCls('form', customizePrefixCls);
    var formClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-").concat(layout), true), "".concat(prefixCls, "-hide-required-mark"), mergedRequiredMark === false), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-").concat(size), size), className);
    var _useForm = (0, $48e68a99c10419d1$export$2e2bcd8739ae039)(form), _useForm2 = (0, $jP8CL.default)(_useForm, 1), wrapForm = _useForm2[0];
    var __INTERNAL__ = wrapForm.__INTERNAL__;
    __INTERNAL__.name = name;
    var formContextValue = (0, $6fFrj.useMemo)(function() {
        return {
            name: name,
            labelAlign: labelAlign,
            labelCol: labelCol,
            labelWrap: labelWrap,
            wrapperCol: wrapperCol,
            vertical: layout === 'vertical',
            colon: mergedColon,
            requiredMark: mergedRequiredMark,
            itemRef: __INTERNAL__.itemRef,
            form: wrapForm
        };
    }, [
        name,
        labelAlign,
        labelCol,
        wrapperCol,
        layout,
        mergedColon,
        mergedRequiredMark,
        wrapForm
    ]);
    $6fFrj.useImperativeHandle(ref, function() {
        return wrapForm;
    });
    var onInternalFinishFailed = function onInternalFinishFailed(errorInfo) {
        onFinishFailed === null || onFinishFailed === void 0 || onFinishFailed(errorInfo);
        var defaultScrollToFirstError = {
            block: 'nearest'
        };
        if (scrollToFirstError && errorInfo.errorFields.length) {
            if ((0, $5KhTJ.default)(scrollToFirstError) === 'object') defaultScrollToFirstError = scrollToFirstError;
            wrapForm.scrollToField(errorInfo.errorFields[0].name, defaultScrollToFirstError);
        }
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $3880af76d17f94a3$export$6adb5f3b918b11bb), {
        disabled: disabled
    }, /*#__PURE__*/ $6fFrj.createElement((0, $aefad26b74860b7e$export$dbc92d89fabc8ebe), {
        size: size
    }, /*#__PURE__*/ $6fFrj.createElement((0, $76d69cb8326089c6$export$8ce1ff4f94d08846), (0, $fIrcP.default)({}, {
        // This is not list in API, we pass with spread
        validateMessages: contextValidateMessages
    }), /*#__PURE__*/ $6fFrj.createElement((0, $76d69cb8326089c6$export$c24727297075ec6a).Provider, {
        value: formContextValue
    }, /*#__PURE__*/ $6fFrj.createElement((0, $7593554a967dae45$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        id: name
    }, restFormProps, {
        name: name,
        onFinishFailed: onInternalFinishFailed,
        form: wrapForm,
        className: formClassName
    }))))));
};
var $b6a9e8ffa0690d50$var$Form = /*#__PURE__*/ $6fFrj.forwardRef($b6a9e8ffa0690d50$var$InternalForm);
var $b6a9e8ffa0690d50$export$2e2bcd8739ae039 = $b6a9e8ffa0690d50$var$Form;



var $5KhTJ = parcelRequire("5KhTJ");

var $fIrcP = parcelRequire("fIrcP");

var $37xND = parcelRequire("37xND");

var $jP8CL = parcelRequire("jP8CL");


var $lqiy0 = parcelRequire("lqiy0");

var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");


var $8ea0dc17dc838596$var$useFormItemStatus = function useFormItemStatus() {
    var _useContext = (0, $6fFrj.useContext)((0, $76d69cb8326089c6$export$bbb5553c6c7a14ed)), status = _useContext.status;
    return {
        status: status
    };
};
var $8ea0dc17dc838596$export$2e2bcd8739ae039 = $8ea0dc17dc838596$var$useFormItemStatus;








var $jP8CL = parcelRequire("jP8CL");

var $hqic8 = parcelRequire("hqic8");

var $6fFrj = parcelRequire("6fFrj");
function $327c0999882a4c4c$export$2e2bcd8739ae039(defaultValue) {
    var _React$useState = $6fFrj.useState(defaultValue), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    var frameRef = (0, $6fFrj.useRef)(null);
    var batchRef = (0, $6fFrj.useRef)([]);
    var destroyRef = (0, $6fFrj.useRef)(false);
    $6fFrj.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
            (0, $hqic8.default).cancel(frameRef.current);
            frameRef.current = null;
        };
    }, []);
    function setFrameValue(updater) {
        if (destroyRef.current) return;
        if (frameRef.current === null) {
            batchRef.current = [];
            frameRef.current = (0, $hqic8.default)(function() {
                frameRef.current = null;
                setValue(function(prevValue) {
                    var current = prevValue;
                    batchRef.current.forEach(function(func) {
                        current = func(current);
                    });
                    return current;
                });
            });
        }
        batchRef.current.push(updater);
    }
    return [
        value,
        setFrameValue
    ];
}



var $5KhTJ = parcelRequire("5KhTJ");

var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");

function $6825295cce06bceb$export$2e2bcd8739ae039() {
    var _React$useContext = $6fFrj.useContext((0, $76d69cb8326089c6$export$c24727297075ec6a)), itemRef = _React$useContext.itemRef;
    var cacheRef = $6fFrj.useRef({});
    function getRef(name, children) {
        var childrenRef = children && (0, $5KhTJ.default)(children) === 'object' && children.ref;
        var nameStr = name.join('_');
        if (cacheRef.current.name !== nameStr || cacheRef.current.originRef !== childrenRef) {
            cacheRef.current.name = nameStr;
            cacheRef.current.originRef = childrenRef;
            cacheRef.current.ref = (0, $3BOWT.composeRef)(itemRef(name), childrenRef);
        }
        return cacheRef.current.ref;
    }
    return getRef;
}




var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");





var $dNZA9 = parcelRequire("dNZA9");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");


var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $5KhTJ = parcelRequire("5KhTJ");

var $jP8CL = parcelRequire("jP8CL");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");





var $4a8085e587664aad$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4a8085e587664aad$var$RowAligns = (0, $cacd97b96801cebe$export$65e3907585753458)('top', 'middle', 'bottom', 'stretch');
var $4a8085e587664aad$var$RowJustify = (0, $cacd97b96801cebe$export$65e3907585753458)('start', 'end', 'center', 'space-around', 'space-between', 'space-evenly');
function $4a8085e587664aad$var$useMergePropByScreen(oriProp, screen) {
    var _React$useState = $6fFrj.useState(typeof oriProp === 'string' ? oriProp : ''), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), prop = _React$useState2[0], setProp = _React$useState2[1];
    var clacMergeAlignOrJustify = function clacMergeAlignOrJustify() {
        if (typeof oriProp === 'string') setProp(oriProp);
        if ((0, $5KhTJ.default)(oriProp) !== 'object') return;
        for(var i = 0; i < (0, $ba9d944a99636e67$export$74c1bf8296b1541f).length; i++){
            var breakpoint = (0, $ba9d944a99636e67$export$74c1bf8296b1541f)[i];
            // if do not match, do nothing
            if (!screen[breakpoint]) continue;
            var curVal = oriProp[breakpoint];
            if (curVal !== undefined) {
                setProp(curVal);
                return;
            }
        }
    };
    $6fFrj.useEffect(function() {
        clacMergeAlignOrJustify();
    }, [
        JSON.stringify(oriProp),
        screen
    ]);
    return prop;
}
var $4a8085e587664aad$var$Row = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, justify = props.justify, align = props.align, className = props.className, style = props.style, children = props.children, _props$gutter = props.gutter, gutter = _props$gutter === void 0 ? 0 : _props$gutter, wrap = props.wrap, others = $4a8085e587664aad$var$__rest(props, [
        "prefixCls",
        "justify",
        "align",
        "className",
        "style",
        "children",
        "gutter",
        "wrap"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var _React$useState3 = $6fFrj.useState({
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true
    }), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), screens = _React$useState4[0], setScreens = _React$useState4[1];
    // to save screens info when responsiveObserve callback had been call
    var _React$useState5 = $6fFrj.useState({
        xs: false,
        sm: false,
        md: false,
        lg: false,
        xl: false,
        xxl: false
    }), _React$useState6 = (0, $jP8CL.default)(_React$useState5, 2), curScreens = _React$useState6[0], setCurScreens = _React$useState6[1];
    // ================================== calc reponsive data ==================================
    var mergeAlign = $4a8085e587664aad$var$useMergePropByScreen(align, curScreens);
    var mergeJustify = $4a8085e587664aad$var$useMergePropByScreen(justify, curScreens);
    var supportFlexGap = (0, $f73ca2a82d55ff05$export$2e2bcd8739ae039)();
    var gutterRef = $6fFrj.useRef(gutter);
    // ================================== Effect ==================================
    $6fFrj.useEffect(function() {
        var token = (0, $ba9d944a99636e67$export$2e2bcd8739ae039).subscribe(function(screen) {
            setCurScreens(screen);
            var currentGutter = gutterRef.current || 0;
            if (!Array.isArray(currentGutter) && (0, $5KhTJ.default)(currentGutter) === 'object' || Array.isArray(currentGutter) && ((0, $5KhTJ.default)(currentGutter[0]) === 'object' || (0, $5KhTJ.default)(currentGutter[1]) === 'object')) setScreens(screen);
        });
        return function() {
            return (0, $ba9d944a99636e67$export$2e2bcd8739ae039).unsubscribe(token);
        };
    }, []);
    // ================================== Render ==================================
    var getGutter = function getGutter() {
        var results = [
            undefined,
            undefined
        ];
        var normalizedGutter = Array.isArray(gutter) ? gutter : [
            gutter,
            undefined
        ];
        normalizedGutter.forEach(function(g, index) {
            if ((0, $5KhTJ.default)(g) === 'object') for(var i = 0; i < (0, $ba9d944a99636e67$export$74c1bf8296b1541f).length; i++){
                var breakpoint = (0, $ba9d944a99636e67$export$74c1bf8296b1541f)[i];
                if (screens[breakpoint] && g[breakpoint] !== undefined) {
                    results[index] = g[breakpoint];
                    break;
                }
            }
            else results[index] = g;
        });
        return results;
    };
    var prefixCls = getPrefixCls('row', customizePrefixCls);
    var gutters = getGutter();
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-no-wrap"), wrap === false), "".concat(prefixCls, "-").concat(mergeJustify), mergeJustify), "".concat(prefixCls, "-").concat(mergeAlign), mergeAlign), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    // Add gutter related style
    var rowStyle = {};
    var horizontalGutter = gutters[0] != null && gutters[0] > 0 ? gutters[0] / -2 : undefined;
    var verticalGutter = gutters[1] != null && gutters[1] > 0 ? gutters[1] / -2 : undefined;
    if (horizontalGutter) {
        rowStyle.marginLeft = horizontalGutter;
        rowStyle.marginRight = horizontalGutter;
    }
    if (supportFlexGap) {
        // Set gap direct if flex gap support
        var _gutters = (0, $jP8CL.default)(gutters, 2);
        rowStyle.rowGap = _gutters[1];
    } else if (verticalGutter) {
        rowStyle.marginTop = verticalGutter;
        rowStyle.marginBottom = verticalGutter;
    }
    // "gutters" is a new array in each rendering phase, it'll make 'React.useMemo' effectless.
    // So we deconstruct "gutters" variable here.
    var _gutters2 = (0, $jP8CL.default)(gutters, 2), gutterH = _gutters2[0], gutterV = _gutters2[1];
    var rowContext = $6fFrj.useMemo(function() {
        return {
            gutter: [
                gutterH,
                gutterV
            ],
            wrap: wrap,
            supportFlexGap: supportFlexGap
        };
    }, [
        gutterH,
        gutterV,
        wrap,
        supportFlexGap
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $243e8b0896b40e46$export$2e2bcd8739ae039).Provider, {
        value: rowContext
    }, /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({}, others, {
        className: classes,
        style: (0, $fIrcP.default)((0, $fIrcP.default)({}, rowStyle), style),
        ref: ref
    }), children));
});
var $4a8085e587664aad$export$2e2bcd8739ae039 = $4a8085e587664aad$var$Row;



var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $5KhTJ = parcelRequire("5KhTJ");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $05da850f44d58525$var$QuestionCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "question-circle",
    "theme": "outlined"
};
var $05da850f44d58525$export$2e2bcd8739ae039 = $05da850f44d58525$var$QuestionCircleOutlined;



var $1793aba1e6a16988$var$QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $05da850f44d58525$export$2e2bcd8739ae039)
    }));
};
var $1793aba1e6a16988$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($1793aba1e6a16988$var$QuestionCircleOutlined);
var $1793aba1e6a16988$export$2e2bcd8739ae039 = $1793aba1e6a16988$var$RefIcon;



var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");





var $01e39d8f60874752$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $01e39d8f60874752$var$toTooltipProps(tooltip) {
    if (!tooltip) return null;
    if ((0, $5KhTJ.default)(tooltip) === 'object' && !/*#__PURE__*/ $6fFrj.isValidElement(tooltip)) return tooltip;
    return {
        title: tooltip
    };
}
var $01e39d8f60874752$var$FormItemLabel = function FormItemLabel(_ref) {
    var prefixCls = _ref.prefixCls, label = _ref.label, htmlFor = _ref.htmlFor, labelCol = _ref.labelCol, labelAlign = _ref.labelAlign, colon = _ref.colon, required = _ref.required, requiredMark = _ref.requiredMark, tooltip = _ref.tooltip;
    var _useLocaleReceiver = (0, $d37c6ecde78f75e8$export$52f95bab0279a481)('Form'), _useLocaleReceiver2 = (0, $jP8CL.default)(_useLocaleReceiver, 1), formLocale = _useLocaleReceiver2[0];
    if (!label) return null;
    return /*#__PURE__*/ $6fFrj.createElement((0, $76d69cb8326089c6$export$c24727297075ec6a).Consumer, {
        key: "label"
    }, function(_ref2) {
        var vertical = _ref2.vertical, contextLabelAlign = _ref2.labelAlign, contextLabelCol = _ref2.labelCol, labelWrap = _ref2.labelWrap, contextColon = _ref2.colon;
        var _a;
        var mergedLabelCol = labelCol || contextLabelCol || {};
        var mergedLabelAlign = labelAlign || contextLabelAlign;
        var labelClsBasic = "".concat(prefixCls, "-item-label");
        var labelColClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(labelClsBasic, mergedLabelAlign === 'left' && "".concat(labelClsBasic, "-left"), mergedLabelCol.className, (0, $43449.default)({}, "".concat(labelClsBasic, "-wrap"), !!labelWrap));
        var labelChildren = label;
        // Keep label is original where there should have no colon
        var computedColon = colon === true || contextColon !== false && colon !== false;
        var haveColon = computedColon && !vertical;
        // Remove duplicated user input colon
        if (haveColon && typeof label === 'string' && label.trim() !== '') labelChildren = label.replace(/[:|：]\s*$/, '');
        // Tooltip
        var tooltipProps = $01e39d8f60874752$var$toTooltipProps(tooltip);
        if (tooltipProps) {
            var _tooltipProps$icon = tooltipProps.icon, icon = _tooltipProps$icon === void 0 ? /*#__PURE__*/ $6fFrj.createElement((0, $1793aba1e6a16988$export$2e2bcd8739ae039), null) : _tooltipProps$icon, restTooltipProps = $01e39d8f60874752$var$__rest(tooltipProps, [
                "icon"
            ]);
            var tooltipNode = /*#__PURE__*/ $6fFrj.createElement((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, restTooltipProps), /*#__PURE__*/ $6fFrj.cloneElement(icon, {
                className: "".concat(prefixCls, "-item-tooltip"),
                title: '',
                onClick: function onClick(e) {
                    // Prevent label behavior in tooltip icon
                    // https://github.com/ant-design/ant-design/issues/46154
                    e.preventDefault();
                },
                tabIndex: null
            }));
            labelChildren = /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, labelChildren, tooltipNode);
        }
        // Add required mark if optional
        if (requiredMark === 'optional' && !required) labelChildren = /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, labelChildren, /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-item-optional"),
            title: ""
        }, (formLocale === null || formLocale === void 0 ? void 0 : formLocale.optional) || ((_a = (0, $da4c09bd655d3c55$export$2e2bcd8739ae039).Form) === null || _a === void 0 ? void 0 : _a.optional)));
        var labelClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-item-required"), required), "".concat(prefixCls, "-item-required-mark-optional"), requiredMark === 'optional'), "".concat(prefixCls, "-item-no-colon"), !computedColon));
        return /*#__PURE__*/ $6fFrj.createElement((0, $00584e60fec74e25$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, mergedLabelCol, {
            className: labelColClassName
        }), /*#__PURE__*/ $6fFrj.createElement("label", {
            htmlFor: htmlFor,
            className: labelClassName,
            title: typeof label === 'string' ? label : ''
        }, labelChildren));
    });
};
var $01e39d8f60874752$export$2e2bcd8739ae039 = $01e39d8f60874752$var$FormItemLabel;



var $fIrcP = parcelRequire("fIrcP");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");



var $231c6f8da12b9bfd$var$FormItemInput = function FormItemInput(props) {
    var prefixCls = props.prefixCls, status = props.status, wrapperCol = props.wrapperCol, children = props.children, errors = props.errors, warnings = props.warnings, formItemRender = props._internalItemRender, extra = props.extra, help = props.help, fieldId = props.fieldId, marginBottom = props.marginBottom, onErrorVisibleChanged = props.onErrorVisibleChanged;
    var baseClassName = "".concat(prefixCls, "-item");
    var formContext = $6fFrj.useContext((0, $76d69cb8326089c6$export$c24727297075ec6a));
    var mergedWrapperCol = wrapperCol || formContext.wrapperCol || {};
    var className = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(baseClassName, "-control"), mergedWrapperCol.className);
    // Pass to sub FormItem should not with col info
    var subFormContext = $6fFrj.useMemo(function() {
        return (0, $fIrcP.default)({}, formContext);
    }, [
        formContext
    ]);
    delete subFormContext.labelCol;
    delete subFormContext.wrapperCol;
    var inputDom = /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(baseClassName, "-control-input")
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(baseClassName, "-control-input-content")
    }, children));
    var formItemContext = $6fFrj.useMemo(function() {
        return {
            prefixCls: prefixCls,
            status: status
        };
    }, [
        prefixCls,
        status
    ]);
    var errorListDom = marginBottom !== null || errors.length || warnings.length ? /*#__PURE__*/ $6fFrj.createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'nowrap'
        }
    }, /*#__PURE__*/ $6fFrj.createElement((0, $76d69cb8326089c6$export$fb6582d3042cc879).Provider, {
        value: formItemContext
    }, /*#__PURE__*/ $6fFrj.createElement((0, $14fc1bd106b69eac$export$2e2bcd8739ae039), {
        fieldId: fieldId,
        errors: errors,
        warnings: warnings,
        help: help,
        helpStatus: status,
        className: "".concat(baseClassName, "-explain-connected"),
        onVisibleChanged: onErrorVisibleChanged
    })), !!marginBottom && /*#__PURE__*/ $6fFrj.createElement("div", {
        style: {
            width: 0,
            height: marginBottom
        }
    })) : null;
    var extraProps = {};
    if (fieldId) extraProps.id = "".concat(fieldId, "_extra");
    // If extra = 0, && will goes wrong
    // 0&&error -> 0
    var extraDom = extra ? /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({}, extraProps, {
        className: "".concat(baseClassName, "-extra")
    }), extra) : null;
    var dom = formItemRender && formItemRender.mark === 'pro_table_render' && formItemRender.render ? formItemRender.render(props, {
        input: inputDom,
        errorList: errorListDom,
        extra: extraDom
    }) : /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, inputDom, errorListDom, extraDom);
    return /*#__PURE__*/ $6fFrj.createElement((0, $76d69cb8326089c6$export$c24727297075ec6a).Provider, {
        value: subFormContext
    }, /*#__PURE__*/ $6fFrj.createElement((0, $00584e60fec74e25$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, mergedWrapperCol, {
        className: className
    }), dom));
};
var $231c6f8da12b9bfd$export$2e2bcd8739ae039 = $231c6f8da12b9bfd$var$FormItemInput;




var $c68af878598a8be0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c68af878598a8be0$var$iconMap = {
    success: (0, $a539793a765f8968$export$2e2bcd8739ae039),
    warning: (0, $4b49a895caf27162$export$2e2bcd8739ae039),
    error: (0, $9429a61ddf5bc264$export$2e2bcd8739ae039),
    validating: (0, $3240b41b65b5dac9$export$2e2bcd8739ae039)
};
function $c68af878598a8be0$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, help = props.help, errors = props.errors, warnings = props.warnings, validateStatus = props.validateStatus, meta = props.meta, hasFeedback = props.hasFeedback, hidden = props.hidden, children = props.children, fieldId = props.fieldId, isRequired = props.isRequired, onSubItemMetaChange = props.onSubItemMetaChange, restProps = $c68af878598a8be0$var$__rest(props, [
        "prefixCls",
        "className",
        "style",
        "help",
        "errors",
        "warnings",
        "validateStatus",
        "meta",
        "hasFeedback",
        "hidden",
        "children",
        "fieldId",
        "isRequired",
        "onSubItemMetaChange"
    ]);
    var itemPrefixCls = "".concat(prefixCls, "-item");
    var _React$useContext = $6fFrj.useContext((0, $76d69cb8326089c6$export$c24727297075ec6a)), requiredMark = _React$useContext.requiredMark;
    // ======================== Margin ========================
    var itemRef = $6fFrj.useRef(null);
    var debounceErrors = (0, $022c88bd41a3a001$export$2e2bcd8739ae039)(errors);
    var debounceWarnings = (0, $022c88bd41a3a001$export$2e2bcd8739ae039)(warnings);
    var hasHelp = help !== undefined && help !== null;
    var hasError = !!(hasHelp || errors.length || warnings.length);
    var _React$useState = $6fFrj.useState(null), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), marginBottom = _React$useState2[0], setMarginBottom = _React$useState2[1];
    (0, $dNZA9.default)(function() {
        if (hasError && itemRef.current) {
            var itemStyle = getComputedStyle(itemRef.current);
            setMarginBottom(parseInt(itemStyle.marginBottom, 10));
        }
    }, [
        hasError
    ]);
    var onErrorVisibleChanged = function onErrorVisibleChanged(nextVisible) {
        if (!nextVisible) setMarginBottom(null);
    };
    // ======================== Status ========================
    var mergedValidateStatus = '';
    if (validateStatus !== undefined) mergedValidateStatus = validateStatus;
    else if (meta.validating) mergedValidateStatus = 'validating';
    else if (debounceErrors.length) mergedValidateStatus = 'error';
    else if (debounceWarnings.length) mergedValidateStatus = 'warning';
    else if (meta.touched) mergedValidateStatus = 'success';
    var formItemStatusContext = $6fFrj.useMemo(function() {
        var feedbackIcon;
        if (hasFeedback) {
            var IconNode = mergedValidateStatus && $c68af878598a8be0$var$iconMap[mergedValidateStatus];
            feedbackIcon = IconNode ? /*#__PURE__*/ $6fFrj.createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(itemPrefixCls, "-feedback-icon"), "".concat(itemPrefixCls, "-feedback-icon-").concat(mergedValidateStatus))
            }, /*#__PURE__*/ $6fFrj.createElement(IconNode, null)) : null;
        }
        return {
            status: mergedValidateStatus,
            hasFeedback: hasFeedback,
            feedbackIcon: feedbackIcon,
            isFormItemInput: true
        };
    }, [
        mergedValidateStatus,
        hasFeedback
    ]);
    // ======================== Render ========================
    var itemClassName = (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, itemPrefixCls, true), "".concat(itemPrefixCls, "-with-help"), hasHelp || debounceErrors.length || debounceWarnings.length), "".concat(className), !!className), "".concat(itemPrefixCls, "-has-feedback"), mergedValidateStatus && hasFeedback), "".concat(itemPrefixCls, "-has-success"), mergedValidateStatus === 'success'), "".concat(itemPrefixCls, "-has-warning"), mergedValidateStatus === 'warning'), "".concat(itemPrefixCls, "-has-error"), mergedValidateStatus === 'error'), "".concat(itemPrefixCls, "-is-validating"), mergedValidateStatus === 'validating'), "".concat(itemPrefixCls, "-hidden"), hidden);
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(itemClassName),
        style: style,
        ref: itemRef
    }, /*#__PURE__*/ $6fFrj.createElement((0, $4a8085e587664aad$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        className: "".concat(itemPrefixCls, "-row")
    }, (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(restProps, [
        '_internalItemRender',
        'colon',
        'dependencies',
        'extra',
        'fieldKey',
        'getValueFromEvent',
        'getValueProps',
        'htmlFor',
        'id',
        'initialValue',
        'isListField',
        'label',
        'labelAlign',
        'labelCol',
        'labelWrap',
        'messageVariables',
        'name',
        'normalize',
        'noStyle',
        'preserve',
        'required',
        'requiredMark',
        'rules',
        'shouldUpdate',
        'trigger',
        'tooltip',
        'validateFirst',
        'validateTrigger',
        'valuePropName',
        'wrapperCol'
    ])), /*#__PURE__*/ $6fFrj.createElement((0, $01e39d8f60874752$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        htmlFor: fieldId,
        required: isRequired,
        requiredMark: requiredMark
    }, props, {
        prefixCls: prefixCls
    })), /*#__PURE__*/ $6fFrj.createElement((0, $231c6f8da12b9bfd$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, meta, {
        errors: debounceErrors,
        warnings: debounceWarnings,
        prefixCls: prefixCls,
        status: mergedValidateStatus,
        help: help,
        marginBottom: marginBottom,
        onErrorVisibleChanged: onErrorVisibleChanged
    }), /*#__PURE__*/ $6fFrj.createElement((0, $76d69cb8326089c6$export$d718247e9f9b0b9e).Provider, {
        value: onSubItemMetaChange
    }, /*#__PURE__*/ $6fFrj.createElement((0, $76d69cb8326089c6$export$bbb5553c6c7a14ed).Provider, {
        value: formItemStatusContext
    }, children)))), !!marginBottom && /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(itemPrefixCls, "-margin-offset"),
        style: {
            marginBottom: -marginBottom
        }
    }));
}


var $4a7605ab6ab1d185$var$NAME_SPLIT = '__SPLIT__';
var $4a7605ab6ab1d185$var$ValidateStatuses = (0, $cacd97b96801cebe$export$65e3907585753458)('success', 'warning', 'error', 'validating', '');
var $4a7605ab6ab1d185$var$MemoInput = /*#__PURE__*/ $6fFrj.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(prev, next) {
    return prev.value === next.value && prev.update === next.update && prev.childProps.length === next.childProps.length && prev.childProps.every(function(value, index) {
        return value === next.childProps[index];
    });
});
function $4a7605ab6ab1d185$var$hasValidName(name) {
    name;
    return !(name === undefined || name === null);
}
function $4a7605ab6ab1d185$var$genEmptyMeta() {
    return {
        errors: [],
        warnings: [],
        touched: false,
        validating: false,
        validated: false,
        name: []
    };
}
function $4a7605ab6ab1d185$var$InternalFormItem(props) {
    var name = props.name, noStyle = props.noStyle, dependencies = props.dependencies, customizePrefixCls = props.prefixCls, shouldUpdate = props.shouldUpdate, rules = props.rules, children = props.children, required = props.required, label = props.label, messageVariables = props.messageVariables, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? 'onChange' : _props$trigger, validateTrigger = props.validateTrigger, hidden = props.hidden;
    var _useContext = (0, $6fFrj.useContext)((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext.getPrefixCls;
    var _useContext2 = (0, $6fFrj.useContext)((0, $76d69cb8326089c6$export$c24727297075ec6a)), formName = _useContext2.name;
    var isRenderProps = typeof children === 'function';
    var notifyParentMetaChange = (0, $6fFrj.useContext)((0, $76d69cb8326089c6$export$d718247e9f9b0b9e));
    var _useContext3 = (0, $6fFrj.useContext)((0, $096ab3393cfd7cdf$export$2e2bcd8739ae039)), contextValidateTrigger = _useContext3.validateTrigger;
    var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : contextValidateTrigger;
    var hasName = $4a7605ab6ab1d185$var$hasValidName(name);
    var prefixCls = getPrefixCls('form', customizePrefixCls);
    // ========================= MISC =========================
    // Get `noStyle` required info
    var listContext = $6fFrj.useContext((0, $cb841e38c6f3a8d1$export$2e2bcd8739ae039));
    var fieldKeyPathRef = $6fFrj.useRef();
    // ======================== Errors ========================
    // >>>>> Collect sub field errors
    var _useFrameState = (0, $327c0999882a4c4c$export$2e2bcd8739ae039)({}), _useFrameState2 = (0, $jP8CL.default)(_useFrameState, 2), subFieldErrors = _useFrameState2[0], setSubFieldErrors = _useFrameState2[1];
    // >>>>> Current field errors
    var _useState = (0, $lqiy0.default)(function() {
        return $4a7605ab6ab1d185$var$genEmptyMeta();
    }), _useState2 = (0, $jP8CL.default)(_useState, 2), meta = _useState2[0], setMeta = _useState2[1];
    var onMetaChange = function onMetaChange(nextMeta) {
        // This keyInfo is not correct when field is removed
        // Since origin keyManager no longer keep the origin key anymore
        // Which means we need cache origin one and reuse when removed
        var keyInfo = listContext === null || listContext === void 0 ? void 0 : listContext.getKey(nextMeta.name);
        // Destroy will reset all the meta
        setMeta(nextMeta.destroy ? $4a7605ab6ab1d185$var$genEmptyMeta() : nextMeta, true);
        // Bump to parent since noStyle
        if (noStyle && notifyParentMetaChange) {
            var namePath = nextMeta.name;
            if (!nextMeta.destroy) {
                if (keyInfo !== undefined) {
                    var _keyInfo = (0, $jP8CL.default)(keyInfo, 2), fieldKey = _keyInfo[0], restPath = _keyInfo[1];
                    namePath = [
                        fieldKey
                    ].concat((0, $37xND.default)(restPath));
                    fieldKeyPathRef.current = namePath;
                }
            } else // Use origin cache data
            namePath = fieldKeyPathRef.current || namePath;
            notifyParentMetaChange(nextMeta, namePath);
        }
    };
    // >>>>> Collect noStyle Field error to the top FormItem
    var onSubItemMetaChange = function onSubItemMetaChange(subMeta, uniqueKeys) {
        // Only `noStyle` sub item will trigger
        setSubFieldErrors(function(prevSubFieldErrors) {
            var clone = (0, $fIrcP.default)({}, prevSubFieldErrors);
            // name: ['user', 1] + key: [4] = ['user', 4]
            var mergedNamePath = [].concat((0, $37xND.default)(subMeta.name.slice(0, -1)), (0, $37xND.default)(uniqueKeys));
            var mergedNameKey = mergedNamePath.join($4a7605ab6ab1d185$var$NAME_SPLIT);
            if (subMeta.destroy) // Remove
            delete clone[mergedNameKey];
            else // Update
            clone[mergedNameKey] = subMeta;
            return clone;
        });
    };
    // >>>>> Get merged errors
    var _React$useMemo = $6fFrj.useMemo(function() {
        var errorList = (0, $37xND.default)(meta.errors);
        var warningList = (0, $37xND.default)(meta.warnings);
        Object.values(subFieldErrors).forEach(function(subFieldError) {
            errorList.push.apply(errorList, (0, $37xND.default)(subFieldError.errors || []));
            warningList.push.apply(warningList, (0, $37xND.default)(subFieldError.warnings || []));
        });
        return [
            errorList,
            warningList
        ];
    }, [
        subFieldErrors,
        meta.errors,
        meta.warnings
    ]), _React$useMemo2 = (0, $jP8CL.default)(_React$useMemo, 2), mergedErrors = _React$useMemo2[0], mergedWarnings = _React$useMemo2[1];
    // ===================== Children Ref =====================
    var getItemRef = (0, $6825295cce06bceb$export$2e2bcd8739ae039)();
    // ======================== Render ========================
    function renderLayout(baseChildren, fieldId, isRequired) {
        if (noStyle && !hidden) return baseChildren;
        return /*#__PURE__*/ $6fFrj.createElement((0, $c68af878598a8be0$export$2e2bcd8739ae039), (0, $fIrcP.default)({
            key: "row"
        }, props, {
            prefixCls: prefixCls,
            fieldId: fieldId,
            isRequired: isRequired,
            errors: mergedErrors,
            warnings: mergedWarnings,
            meta: meta,
            onSubItemMetaChange: onSubItemMetaChange
        }), baseChildren);
    }
    if (!hasName && !isRenderProps && !dependencies) return renderLayout(children);
    var variables = {};
    if (typeof label === 'string') variables.label = label;
    else if (name) variables.label = String(name);
    if (messageVariables) variables = (0, $fIrcP.default)((0, $fIrcP.default)({}, variables), messageVariables);
    // >>>>> With Field
    return /*#__PURE__*/ $6fFrj.createElement((0, $12bf411ce1aaed8f$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        messageVariables: variables,
        trigger: trigger,
        validateTrigger: mergedValidateTrigger,
        onMetaChange: onMetaChange
    }), function(control, renderMeta, context) {
        var mergedName = (0, $e51608610e29b4c6$export$45b10814cc054894)(name).length && renderMeta ? renderMeta.name : [];
        var fieldId = (0, $e51608610e29b4c6$export$f4457e83c74ac000)(mergedName, formName);
        var isRequired = required !== undefined ? required : !!(rules && rules.some(function(rule) {
            if (rule && (0, $5KhTJ.default)(rule) === 'object' && rule.required && !rule.warningOnly) return true;
            if (typeof rule === 'function') {
                var ruleEntity = rule(context);
                return ruleEntity && ruleEntity.required && !ruleEntity.warningOnly;
            }
            return false;
        }));
        // ======================= Children =======================
        var mergedControl = (0, $fIrcP.default)({}, control);
        var childNode = null;
        if (Array.isArray(children) && hasName) childNode = children;
        else if (isRenderProps && (!(shouldUpdate || dependencies) || hasName)) ;
        else if (dependencies && !isRenderProps && !hasName) ;
        else if ((0, $79365009d9b77ac6$export$a8257692ac88316c)(children)) {
            var childProps = (0, $fIrcP.default)((0, $fIrcP.default)({}, children.props), mergedControl);
            if (!childProps.id) childProps.id = fieldId;
            if (props.help || mergedErrors.length > 0 || mergedWarnings.length > 0 || props.extra) {
                var describedbyArr = [];
                if (props.help || mergedErrors.length > 0) describedbyArr.push("".concat(fieldId, "_help"));
                if (props.extra) describedbyArr.push("".concat(fieldId, "_extra"));
                childProps['aria-describedby'] = describedbyArr.join(' ');
            }
            if (mergedErrors.length > 0) childProps['aria-invalid'] = 'true';
            if (isRequired) childProps['aria-required'] = 'true';
            if ((0, $3BOWT.supportRef)(children)) childProps.ref = getItemRef(mergedName, children);
            // We should keep user origin event handler
            var triggers = new Set([].concat((0, $37xND.default)((0, $e51608610e29b4c6$export$45b10814cc054894)(trigger)), (0, $37xND.default)((0, $e51608610e29b4c6$export$45b10814cc054894)(mergedValidateTrigger))));
            triggers.forEach(function(eventName) {
                childProps[eventName] = function() {
                    var _a2, _c2;
                    var _a, _b, _c;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    (_a = mergedControl[eventName]) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                        mergedControl
                    ].concat(args));
                    (_c = (_b = children.props)[eventName]) === null || _c === void 0 || (_c2 = _c).call.apply(_c2, [
                        _b
                    ].concat(args));
                };
            });
            // List of props that need to be watched for changes -> if changes are detected in MemoInput -> rerender
            var watchingChildProps = [
                childProps['aria-required'],
                childProps['aria-invalid'],
                childProps['aria-describedby']
            ];
            childNode = /*#__PURE__*/ $6fFrj.createElement($4a7605ab6ab1d185$var$MemoInput, {
                value: mergedControl[props.valuePropName || 'value'],
                update: children,
                childProps: watchingChildProps
            }, (0, $79365009d9b77ac6$export$e530037191fcd5d7)(children, childProps));
        } else if (isRenderProps && (shouldUpdate || dependencies) && !hasName) childNode = children(context);
        else childNode = children;
        return renderLayout(childNode, fieldId, isRequired);
    });
}
var $4a7605ab6ab1d185$var$FormItem = $4a7605ab6ab1d185$var$InternalFormItem;
$4a7605ab6ab1d185$var$FormItem.useStatus = (0, $8ea0dc17dc838596$export$2e2bcd8739ae039);
var $4a7605ab6ab1d185$export$2e2bcd8739ae039 = $4a7605ab6ab1d185$var$FormItem;



var $fIrcP = parcelRequire("fIrcP");


var $6fFrj = parcelRequire("6fFrj");



var $6402a463f9aed980$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6402a463f9aed980$var$FormList = function FormList(_a) {
    var customizePrefixCls = _a.prefixCls, children = _a.children, props = $6402a463f9aed980$var$__rest(_a, [
        "prefixCls",
        "children"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('form', customizePrefixCls);
    var contextValue = $6fFrj.useMemo(function() {
        return {
            prefixCls: prefixCls,
            status: 'error'
        };
    }, [
        prefixCls
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $62ee9cd25e28e75b$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props), function(fields, operation, meta) {
        return /*#__PURE__*/ $6fFrj.createElement((0, $76d69cb8326089c6$export$fb6582d3042cc879).Provider, {
            value: contextValue
        }, children(fields.map(function(field) {
            return (0, $fIrcP.default)((0, $fIrcP.default)({}, field), {
                fieldKey: field.key
            });
        }), operation, {
            errors: meta.errors,
            warnings: meta.warnings
        }));
    });
};
var $6402a463f9aed980$export$2e2bcd8739ae039 = $6402a463f9aed980$var$FormList;



var $6fFrj = parcelRequire("6fFrj");

function $b4709f938c767825$export$2e2bcd8739ae039() {
    var _useContext = (0, $6fFrj.useContext)((0, $76d69cb8326089c6$export$c24727297075ec6a)), form = _useContext.form;
    return form;
}


var $6ee812964d9db826$var$Form = (0, $b6a9e8ffa0690d50$export$2e2bcd8739ae039);
$6ee812964d9db826$var$Form.Item = (0, $4a7605ab6ab1d185$export$2e2bcd8739ae039);
$6ee812964d9db826$var$Form.List = (0, $6402a463f9aed980$export$2e2bcd8739ae039);
$6ee812964d9db826$var$Form.ErrorList = (0, $14fc1bd106b69eac$export$2e2bcd8739ae039);
$6ee812964d9db826$var$Form.useForm = (0, $48e68a99c10419d1$export$2e2bcd8739ae039);
$6ee812964d9db826$var$Form.useFormInstance = (0, $b4709f938c767825$export$2e2bcd8739ae039);
$6ee812964d9db826$var$Form.useWatch = (0, $3faab004390268d8$export$2e2bcd8739ae039);
$6ee812964d9db826$var$Form.Provider = (0, $76d69cb8326089c6$export$8ce1ff4f94d08846);
$6ee812964d9db826$var$Form.create = function() {};
var $6ee812964d9db826$export$2e2bcd8739ae039 = $6ee812964d9db826$var$Form;




// Do not export params
function $89d88a41b53d163f$var$useBreakpoint() {
    return (0, $60fdd98823a1708b$export$2e2bcd8739ae039)();
}
var $89d88a41b53d163f$export$2e2bcd8739ae039 = {
    useBreakpoint: $89d88a41b53d163f$var$useBreakpoint
};


var $fIrcP = parcelRequire("fIrcP");

var $5KhTJ = parcelRequire("5KhTJ");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $cac88eefe2920e57$var$EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
var $cac88eefe2920e57$export$2e2bcd8739ae039 = $cac88eefe2920e57$var$EyeOutlined;



var $eca7e40229c3d459$var$EyeOutlined = function EyeOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $cac88eefe2920e57$export$2e2bcd8739ae039)
    }));
};
var $eca7e40229c3d459$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($eca7e40229c3d459$var$EyeOutlined);
var $eca7e40229c3d459$export$2e2bcd8739ae039 = $eca7e40229c3d459$var$RefIcon;



var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $5KhTJ = parcelRequire("5KhTJ");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");
/* eslint-disable no-nested-ternary */ var $cfb7a0d68d50ecbf$var$PIXEL_PATTERN = /margin|padding|width|height|max|min|offset/;
var $cfb7a0d68d50ecbf$var$removePixel = {
    left: true,
    top: true
};
var $cfb7a0d68d50ecbf$var$floatMap = {
    cssFloat: 1,
    styleFloat: 1,
    float: 1
};
function $cfb7a0d68d50ecbf$var$getComputedStyle(node) {
    return node.nodeType === 1 ? node.ownerDocument.defaultView.getComputedStyle(node, null) : {};
}
function $cfb7a0d68d50ecbf$var$getStyleValue(node, type, value) {
    type = type.toLowerCase();
    if (value === 'auto') {
        if (type === 'height') return node.offsetHeight;
        if (type === 'width') return node.offsetWidth;
    }
    if (!(type in $cfb7a0d68d50ecbf$var$removePixel)) $cfb7a0d68d50ecbf$var$removePixel[type] = $cfb7a0d68d50ecbf$var$PIXEL_PATTERN.test(type);
    return $cfb7a0d68d50ecbf$var$removePixel[type] ? parseFloat(value) || 0 : value;
}
function $cfb7a0d68d50ecbf$export$3988ae62b71be9a3(node, name) {
    var length = arguments.length;
    var style = $cfb7a0d68d50ecbf$var$getComputedStyle(node);
    name = $cfb7a0d68d50ecbf$var$floatMap[name] ? 'cssFloat' in node.style ? 'cssFloat' : 'styleFloat' : name;
    return length === 1 ? style : $cfb7a0d68d50ecbf$var$getStyleValue(node, name, style[name] || node.style[name]);
}
function $cfb7a0d68d50ecbf$export$adaa4cf7ef1b65be(node, name, value) {
    var length = arguments.length;
    name = $cfb7a0d68d50ecbf$var$floatMap[name] ? 'cssFloat' in node.style ? 'cssFloat' : 'styleFloat' : name;
    if (length === 3) {
        if (typeof value === 'number' && $cfb7a0d68d50ecbf$var$PIXEL_PATTERN.test(name)) value = "".concat(value, "px");
        node.style[name] = value; // Number
        return value;
    }
    for(var x in name)if (name.hasOwnProperty(x)) $cfb7a0d68d50ecbf$export$adaa4cf7ef1b65be(node, x, name[x]);
    return $cfb7a0d68d50ecbf$var$getComputedStyle(node);
}
function $cfb7a0d68d50ecbf$export$18e9b0709c75d4c5(el) {
    if (el === document.body) return document.documentElement.clientWidth;
    return el.offsetWidth;
}
function $cfb7a0d68d50ecbf$export$3ef1368fc1aa92de(el) {
    if (el === document.body) return window.innerHeight || document.documentElement.clientHeight;
    return el.offsetHeight;
}
function $cfb7a0d68d50ecbf$export$fddbd22e9c622ca7() {
    var width = Math.max(document.documentElement.scrollWidth, document.body.scrollWidth);
    var height = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    return {
        width: width,
        height: height
    };
}
function $cfb7a0d68d50ecbf$export$1feb45891927fcb4() {
    var width = document.documentElement.clientWidth;
    var height = window.innerHeight || document.documentElement.clientHeight;
    return {
        width: width,
        height: height
    };
}
function $cfb7a0d68d50ecbf$export$ff41c598de81c14a() {
    return {
        scrollLeft: Math.max(document.documentElement.scrollLeft, document.body.scrollLeft),
        scrollTop: Math.max(document.documentElement.scrollTop, document.body.scrollTop)
    };
}
function $cfb7a0d68d50ecbf$export$622cea445a1c5b7d(node) {
    var box = node.getBoundingClientRect();
    var docElem = document.documentElement;
    // < ie8 不支持 win.pageXOffset, 则使用 docElem.scrollLeft
    return {
        left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
        top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
    };
}



var $gfhff = parcelRequire("gfhff");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");


var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


var $jP8CL = parcelRequire("jP8CL");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
function $bca30f6ced71d698$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    var fullClone = (0, $kNxFX.default)({}, $6fFrj);
    return fullClone.useId;
}
var $bca30f6ced71d698$var$uuid = 0;
function $bca30f6ced71d698$export$2f0435a662835942() {}
var $bca30f6ced71d698$var$useOriginId = $bca30f6ced71d698$var$getUseId();
var $bca30f6ced71d698$export$2e2bcd8739ae039 = $bca30f6ced71d698$var$useOriginId ? // Use React `useId`
function useId(id) {
    var reactId = $bca30f6ced71d698$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $6fFrj.useState('ssr-id'), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $6fFrj.useEffect(function() {
        var nextId = $bca30f6ced71d698$var$uuid;
        $bca30f6ced71d698$var$uuid += 1;
        setInnerId("rc_unique_".concat(nextId));
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};





var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $5EVeC = parcelRequire("5EVeC");
function $6861756737226f5d$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, style = props.style, visible = props.visible, maskProps = props.maskProps, motionName = props.motionName;
    return /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), {
        key: "mask",
        visible: visible,
        motionName: motionName,
        leavedClassName: "".concat(prefixCls, "-mask-hidden")
    }, function(_ref, ref) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
            ref: ref,
            style: (0, $kNxFX.default)((0, $kNxFX.default)({}, motionStyle), style),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-mask"), motionClassName)
        }, maskProps));
    });
}


// =============================== Motion ===============================
function $1673dec1b2fea735$export$ec1a7ebf4579c1c3(prefixCls, transitionName, animationName) {
    var motionName = transitionName;
    if (!motionName && animationName) motionName = "".concat(prefixCls, "-").concat(animationName);
    return motionName;
}
// =============================== Offset ===============================
function $1673dec1b2fea735$var$getScroll(w, top) {
    var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
    var method = "scroll".concat(top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== 'number') ret = d.body[method];
    }
    return ret;
}
function $1673dec1b2fea735$export$cc800923e997bb8(el) {
    var rect = el.getBoundingClientRect();
    var pos = {
        left: rect.left,
        top: rect.top
    };
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $1673dec1b2fea735$var$getScroll(w);
    pos.top += $1673dec1b2fea735$var$getScroll(w, true);
    return pos;
}



var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $5EVeC = parcelRequire("5EVeC");


var $kNxFX = parcelRequire("kNxFX");

var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");
var $4cdb613625d4960b$export$2e2bcd8739ae039 = /*#__PURE__*/ $6fFrj.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, _ref2) {
    var shouldUpdate = _ref2.shouldUpdate;
    return !shouldUpdate;
});


var $ba55461be3ff86f1$var$sentinelStyle = {
    width: 0,
    height: 0,
    overflow: 'hidden',
    outline: 'none'
};
var $ba55461be3ff86f1$var$Panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, title = props.title, ariaId = props.ariaId, footer = props.footer, closable = props.closable, closeIcon = props.closeIcon, onClose = props.onClose, children = props.children, bodyStyle = props.bodyStyle, bodyProps = props.bodyProps, modalRender = props.modalRender, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, holderRef = props.holderRef, visible = props.visible, forceRender = props.forceRender, width = props.width, height = props.height;
    // ================================= Refs =================================
    var sentinelStartRef = (0, $6fFrj.useRef)();
    var sentinelEndRef = (0, $6fFrj.useRef)();
    (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                var _sentinelStartRef$cur;
                (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus({
                    preventScroll: true
                });
            },
            changeActive: function changeActive(next) {
                var _document = document, activeElement = _document.activeElement;
                if (next && activeElement === sentinelEndRef.current) sentinelStartRef.current.focus({
                    preventScroll: true
                });
                else if (!next && activeElement === sentinelStartRef.current) sentinelEndRef.current.focus({
                    preventScroll: true
                });
            }
        };
    });
    // ================================ Style =================================
    var contentStyle = {};
    if (width !== undefined) contentStyle.width = width;
    if (height !== undefined) contentStyle.height = height;
    // ================================ Render ================================
    var footerNode;
    if (footer) footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "".concat(prefixCls, "-footer")
    }, footer);
    var headerNode;
    if (title) headerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "".concat(prefixCls, "-header")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "".concat(prefixCls, "-title"),
        id: ariaId
    }, title));
    var closer;
    if (closable) closer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
        type: "button",
        onClick: onClose,
        "aria-label": "Close",
        className: "".concat(prefixCls, "-close")
    }, closeIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
        className: "".concat(prefixCls, "-close-x")
    }));
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, closer, headerNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", (0, $fIrcP.default)({
        className: "".concat(prefixCls, "-body"),
        style: bodyStyle
    }, bodyProps), children), footerNode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        key: "dialog-element",
        role: "dialog",
        "aria-labelledby": title ? ariaId : null,
        "aria-modal": "true",
        ref: holderRef,
        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, style), contentStyle),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className),
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        tabIndex: 0,
        ref: sentinelStartRef,
        style: $ba55461be3ff86f1$var$sentinelStyle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $4cdb613625d4960b$export$2e2bcd8739ae039), {
        shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: $ba55461be3ff86f1$var$sentinelStyle
    }));
});
var $ba55461be3ff86f1$export$2e2bcd8739ae039 = $ba55461be3ff86f1$var$Panel;


var $b2354ee2045b36f4$var$Content = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, title = props.title, style = props.style, className = props.className, visible = props.visible, forceRender = props.forceRender, destroyOnClose = props.destroyOnClose, motionName = props.motionName, ariaId = props.ariaId, onVisibleChanged = props.onVisibleChanged, mousePosition = props.mousePosition;
    var dialogRef = (0, $6fFrj.useRef)();
    // ============================= Style ==============================
    var _React$useState = $6fFrj.useState(), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), transformOrigin = _React$useState2[0], setTransformOrigin = _React$useState2[1];
    var contentStyle = {};
    if (transformOrigin) contentStyle.transformOrigin = transformOrigin;
    function onPrepare() {
        var elementOffset = (0, $1673dec1b2fea735$export$cc800923e997bb8)(dialogRef.current);
        setTransformOrigin(mousePosition ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : '');
    }
    // ============================= Render =============================
    return /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), {
        visible: visible,
        onVisibleChanged: onVisibleChanged,
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        forceRender: forceRender,
        motionName: motionName,
        removeOnLeave: destroyOnClose,
        ref: dialogRef
    }, function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $6fFrj.createElement((0, $ba55461be3ff86f1$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
            ref: ref,
            title: title,
            ariaId: ariaId,
            prefixCls: prefixCls,
            holderRef: motionRef,
            style: (0, $kNxFX.default)((0, $kNxFX.default)((0, $kNxFX.default)({}, motionStyle), style), contentStyle),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(className, motionClassName)
        }));
    });
});
$b2354ee2045b36f4$var$Content.displayName = 'Content';
var $b2354ee2045b36f4$export$2e2bcd8739ae039 = $b2354ee2045b36f4$var$Content;


function $261d508d146ed41e$export$2e2bcd8739ae039(props) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-dialog' : _props$prefixCls, zIndex = props.zIndex, _props$visible = props.visible, visible = _props$visible === void 0 ? false : _props$visible, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$focusTriggerAf = props.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, wrapStyle = props.wrapStyle, wrapClassName = props.wrapClassName, wrapProps = props.wrapProps, onClose = props.onClose, afterClose = props.afterClose, transitionName = props.transitionName, animation = props.animation, _props$closable = props.closable, closable = _props$closable === void 0 ? true : _props$closable, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, maskStyle = props.maskStyle, maskProps = props.maskProps, rootClassName = props.rootClassName;
    var lastOutSideActiveElementRef = (0, $6fFrj.useRef)();
    var wrapperRef = (0, $6fFrj.useRef)();
    var contentRef = (0, $6fFrj.useRef)();
    var _React$useState = $6fFrj.useState(visible), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    // ========================== Init ==========================
    var ariaId = (0, $bca30f6ced71d698$export$2e2bcd8739ae039)();
    function saveLastOutSideActiveElementRef() {
        if (!(0, $b5cc600be516f1fa$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) lastOutSideActiveElementRef.current = document.activeElement;
    }
    function focusDialogContent() {
        if (!(0, $b5cc600be516f1fa$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) {
            var _contentRef$current;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
        }
    }
    // ========================= Events =========================
    function onDialogVisibleChanged(newVisible) {
        // Try to focus
        if (newVisible) focusDialogContent();
        else {
            // Clean up scroll bar & focus back
            setAnimatedVisible(false);
            if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
                try {
                    lastOutSideActiveElementRef.current.focus({
                        preventScroll: true
                    });
                } catch (e) {
                // Do nothing
                }
                lastOutSideActiveElementRef.current = null;
            }
            // Trigger afterClose only when change visible from true to false
            if (animatedVisible) afterClose === null || afterClose === void 0 || afterClose();
        }
    }
    function onInternalClose(e) {
        onClose === null || onClose === void 0 || onClose(e);
    }
    // >>> Content
    var contentClickRef = (0, $6fFrj.useRef)(false);
    var contentTimeoutRef = (0, $6fFrj.useRef)();
    // We need record content click incase content popup out of dialog
    var onContentMouseDown = function onContentMouseDown() {
        clearTimeout(contentTimeoutRef.current);
        contentClickRef.current = true;
    };
    var onContentMouseUp = function onContentMouseUp() {
        contentTimeoutRef.current = setTimeout(function() {
            contentClickRef.current = false;
        });
    };
    // >>> Wrapper
    // Close only when element not on dialog
    var onWrapperClick = null;
    if (maskClosable) onWrapperClick = function onWrapperClick(e) {
        if (contentClickRef.current) contentClickRef.current = false;
        else if (wrapperRef.current === e.target) onInternalClose(e);
    };
    function onWrapperKeyDown(e) {
        if (keyboard && e.keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ESC) {
            e.stopPropagation();
            onInternalClose(e);
            return;
        }
        // keep focus inside dialog
        if (visible && e.keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).TAB) contentRef.current.changeActive(!e.shiftKey);
    }
    // ========================= Effect =========================
    (0, $6fFrj.useEffect)(function() {
        if (visible) {
            setAnimatedVisible(true);
            saveLastOutSideActiveElementRef();
        }
    }, [
        visible
    ]);
    // Remove direct should also check the scroll bar update
    (0, $6fFrj.useEffect)(function() {
        return function() {
            clearTimeout(contentTimeoutRef.current);
        };
    }, []);
    // ========================= Render =========================
    return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-root"), rootClassName)
    }, (0, $c7e00e8671f36d19$export$2e2bcd8739ae039)(props, {
        data: true
    })), /*#__PURE__*/ $6fFrj.createElement((0, $6861756737226f5d$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        visible: mask && visible,
        motionName: (0, $1673dec1b2fea735$export$ec1a7ebf4579c1c3)(prefixCls, maskTransitionName, maskAnimation),
        style: (0, $kNxFX.default)({
            zIndex: zIndex
        }, maskStyle),
        maskProps: maskProps
    }), /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        tabIndex: -1,
        onKeyDown: onWrapperKeyDown,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-wrap"), wrapClassName),
        ref: wrapperRef,
        onClick: onWrapperClick,
        style: (0, $kNxFX.default)((0, $kNxFX.default)({
            zIndex: zIndex
        }, wrapStyle), {}, {
            display: !animatedVisible ? 'none' : null
        })
    }, wrapProps), /*#__PURE__*/ $6fFrj.createElement((0, $b2354ee2045b36f4$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        onMouseDown: onContentMouseDown,
        onMouseUp: onContentMouseUp,
        ref: contentRef,
        closable: closable,
        ariaId: ariaId,
        prefixCls: prefixCls,
        visible: visible && animatedVisible,
        onClose: onInternalClose,
        onVisibleChanged: onDialogVisibleChanged,
        motionName: (0, $1673dec1b2fea735$export$ec1a7ebf4579c1c3)(prefixCls, transitionName, animation)
    }))));
}


// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */ var $df27b60aeb23c8a5$var$DialogWrap = function DialogWrap(props) {
    var visible = props.visible, getContainer = props.getContainer, forceRender = props.forceRender, _props$destroyOnClose = props.destroyOnClose, destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose, _afterClose = props.afterClose;
    var _React$useState = $6fFrj.useState(visible), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    $6fFrj.useEffect(function() {
        if (visible) setAnimatedVisible(true);
    }, [
        visible
    ]);
    // // 渲染在当前 dom 里；
    // if (getContainer === false) {
    //   return (
    //     <Dialog
    //       {...props}
    //       getOpenCount={() => 2} // 不对 body 做任何操作。。
    //     />
    //   );
    // }
    // Destroy on close will remove wrapped div
    if (!forceRender && destroyOnClose && !animatedVisible) return null;
    return /*#__PURE__*/ $6fFrj.createElement((0, $8190793b254f77a3$export$2e2bcd8739ae039), {
        open: visible || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: visible || animatedVisible
    }, /*#__PURE__*/ $6fFrj.createElement((0, $261d508d146ed41e$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        destroyOnClose: destroyOnClose,
        afterClose: function afterClose() {
            _afterClose === null || _afterClose === void 0 || _afterClose();
            setAnimatedVisible(false);
        }
    })));
};
$df27b60aeb23c8a5$var$DialogWrap.displayName = 'Dialog';
var $df27b60aeb23c8a5$export$2e2bcd8739ae039 = $df27b60aeb23c8a5$var$DialogWrap;



var $5a2c78a8da70f218$export$2e2bcd8739ae039 = (0, $df27b60aeb23c8a5$export$2e2bcd8739ae039);



var $fActo = parcelRequire("fActo");



var $3mXQ2 = parcelRequire("3mXQ2");

var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $5KhTJ = parcelRequire("5KhTJ");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $gfhff = parcelRequire("gfhff");

var $3cad9afd1779a871$var$_excluded = [
    "visible",
    "onVisibleChange",
    "getContainer",
    "current",
    "countRender"
];
var $3cad9afd1779a871$export$a078c61943f9dbbe = /*#__PURE__*/ $6fFrj.createContext({
    previewUrls: new Map(),
    setPreviewUrls: function setPreviewUrls() {
        return null;
    },
    current: null,
    setCurrent: function setCurrent() {
        return null;
    },
    setShowPreview: function setShowPreview() {
        return null;
    },
    setMousePosition: function setMousePosition() {
        return null;
    },
    registerImage: function registerImage() {
        return function() {
            return null;
        };
    },
    rootClassName: ''
});
var $3cad9afd1779a871$var$Provider = $3cad9afd1779a871$export$a078c61943f9dbbe.Provider;
var $3cad9afd1779a871$var$Group = function Group(_ref) {
    var _ref$previewPrefixCls = _ref.previewPrefixCls, previewPrefixCls = _ref$previewPrefixCls === void 0 ? 'rc-image-preview' : _ref$previewPrefixCls, children = _ref.children, _ref$icons = _ref.icons, icons = _ref$icons === void 0 ? {} : _ref$icons, preview = _ref.preview;
    var _ref2 = (0, $5KhTJ.default)(preview) === 'object' ? preview : {}, _ref2$visible = _ref2.visible, previewVisible = _ref2$visible === void 0 ? undefined : _ref2$visible, _ref2$onVisibleChange = _ref2.onVisibleChange, onPreviewVisibleChange = _ref2$onVisibleChange === void 0 ? undefined : _ref2$onVisibleChange, _ref2$getContainer = _ref2.getContainer, getContainer = _ref2$getContainer === void 0 ? undefined : _ref2$getContainer, _ref2$current = _ref2.current, currentIndex = _ref2$current === void 0 ? 0 : _ref2$current, _ref2$countRender = _ref2.countRender, countRender = _ref2$countRender === void 0 ? undefined : _ref2$countRender, dialogProps = (0, $04RxA.default)(_ref2, $3cad9afd1779a871$var$_excluded);
    var _useState = (0, $6fFrj.useState)(new Map()), _useState2 = (0, $jP8CL.default)(_useState, 2), previewUrls = _useState2[0], setPreviewUrls = _useState2[1];
    var _useState3 = (0, $6fFrj.useState)(), _useState4 = (0, $jP8CL.default)(_useState3, 2), current = _useState4[0], setCurrent = _useState4[1];
    var _useMergedState = (0, $gfhff.default)(!!previewVisible, {
        value: previewVisible,
        onChange: onPreviewVisibleChange
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), isShowPreview = _useMergedState2[0], setShowPreview = _useMergedState2[1];
    var _useState5 = (0, $6fFrj.useState)(null), _useState6 = (0, $jP8CL.default)(_useState5, 2), mousePosition = _useState6[0], setMousePosition = _useState6[1];
    var isControlled = previewVisible !== undefined;
    var previewUrlsKeys = Array.from(previewUrls.keys());
    var currentControlledKey = previewUrlsKeys[currentIndex];
    var canPreviewUrls = new Map(Array.from(previewUrls).filter(function(_ref3) {
        var _ref4 = (0, $jP8CL.default)(_ref3, 2), canPreview = _ref4[1].canPreview;
        return !!canPreview;
    }).map(function(_ref5) {
        var _ref6 = (0, $jP8CL.default)(_ref5, 2), id = _ref6[0], url = _ref6[1].url;
        return [
            id,
            url
        ];
    }));
    var registerImage = function registerImage(id, url) {
        var canPreview = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var unRegister = function unRegister() {
            setPreviewUrls(function(oldPreviewUrls) {
                var clonePreviewUrls = new Map(oldPreviewUrls);
                var deleteResult = clonePreviewUrls.delete(id);
                return deleteResult ? clonePreviewUrls : oldPreviewUrls;
            });
        };
        setPreviewUrls(function(oldPreviewUrls) {
            return new Map(oldPreviewUrls).set(id, {
                url: url,
                canPreview: canPreview
            });
        });
        return unRegister;
    };
    var onPreviewClose = function onPreviewClose(e) {
        e.stopPropagation();
        setShowPreview(false);
        setMousePosition(null);
    };
    $6fFrj.useEffect(function() {
        setCurrent(currentControlledKey);
    }, [
        currentControlledKey
    ]);
    $6fFrj.useEffect(function() {
        if (!isShowPreview && isControlled) setCurrent(currentControlledKey);
    }, [
        currentControlledKey,
        isControlled,
        isShowPreview
    ]);
    return /*#__PURE__*/ $6fFrj.createElement($3cad9afd1779a871$var$Provider, {
        value: {
            isPreviewGroup: true,
            previewUrls: canPreviewUrls,
            setPreviewUrls: setPreviewUrls,
            current: current,
            setCurrent: setCurrent,
            setShowPreview: setShowPreview,
            setMousePosition: setMousePosition,
            registerImage: registerImage
        }
    }, children, /*#__PURE__*/ $6fFrj.createElement((0, $af145c071811f62a$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        "aria-hidden": !isShowPreview,
        visible: isShowPreview,
        prefixCls: previewPrefixCls,
        onClose: onPreviewClose,
        mousePosition: mousePosition,
        src: canPreviewUrls.get(current),
        icons: icons,
        getContainer: getContainer,
        countRender: countRender
    }, dialogProps)));
};
var $3cad9afd1779a871$export$2e2bcd8739ae039 = $3cad9afd1779a871$var$Group;



var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $5EVeC = parcelRequire("5EVeC");

/** Minimum scale */ var $298365afe53007cc$export$e4985ca28e204935 = 1;
var $298365afe53007cc$export$44e5bd0fef8d913c = 50;
var $298365afe53007cc$export$6e76060232ffaf48 = 1;
var $298365afe53007cc$export$137a7d87d4a2aae5 = 0.2;


var $07eaefe91cc789a1$var$Operations = function Operations(props) {
    var _countRender;
    var visible = props.visible, maskTransitionName = props.maskTransitionName, getContainer = props.getContainer, prefixCls = props.prefixCls, rootClassName = props.rootClassName, icons = props.icons, countRender = props.countRender, showSwitch = props.showSwitch, showProgress = props.showProgress, current = props.current, count = props.count, scale = props.scale, onSwitchLeft = props.onSwitchLeft, onSwitchRight = props.onSwitchRight, onClose = props.onClose, onZoomIn = props.onZoomIn, onZoomOut = props.onZoomOut, onRotateRight = props.onRotateRight, onRotateLeft = props.onRotateLeft;
    var rotateLeft = icons.rotateLeft, rotateRight = icons.rotateRight, zoomIn = icons.zoomIn, zoomOut = icons.zoomOut, close = icons.close, left = icons.left, right = icons.right;
    var toolClassName = "".concat(prefixCls, "-operations-operation");
    var iconClassName = "".concat(prefixCls, "-operations-icon");
    var tools = [
        {
            icon: close,
            onClick: onClose,
            type: 'close'
        },
        {
            icon: zoomIn,
            onClick: onZoomIn,
            type: 'zoomIn',
            disabled: scale === (0, $298365afe53007cc$export$44e5bd0fef8d913c)
        },
        {
            icon: zoomOut,
            onClick: onZoomOut,
            type: 'zoomOut',
            disabled: scale === (0, $298365afe53007cc$export$e4985ca28e204935)
        },
        {
            icon: rotateRight,
            onClick: onRotateRight,
            type: 'rotateRight'
        },
        {
            icon: rotateLeft,
            onClick: onRotateLeft,
            type: 'rotateLeft'
        }
    ];
    var operations = /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, showSwitch && /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-switch-left"), (0, $43449.default)({}, "".concat(prefixCls, "-switch-left-disabled"), current === 0)),
        onClick: onSwitchLeft
    }, left), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-switch-right"), (0, $43449.default)({}, "".concat(prefixCls, "-switch-right-disabled"), current === count - 1)),
        onClick: onSwitchRight
    }, right)), /*#__PURE__*/ $6fFrj.createElement("ul", {
        className: "".concat(prefixCls, "-operations")
    }, showProgress && /*#__PURE__*/ $6fFrj.createElement("li", {
        className: "".concat(prefixCls, "-operations-progress")
    }, (_countRender = countRender === null || countRender === void 0 ? void 0 : countRender(current + 1, count)) !== null && _countRender !== void 0 ? _countRender : "".concat(current + 1, " / ").concat(count)), tools.map(function(_ref) {
        var _classnames3;
        var icon = _ref.icon, onClick = _ref.onClick, type = _ref.type, disabled = _ref.disabled;
        return /*#__PURE__*/ $6fFrj.createElement("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(toolClassName, (_classnames3 = {}, (0, $43449.default)(_classnames3, "".concat(prefixCls, "-operations-operation-").concat(type), true), (0, $43449.default)(_classnames3, "".concat(prefixCls, "-operations-operation-disabled"), !!disabled), _classnames3)),
            onClick: onClick,
            key: type
        }, /*#__PURE__*/ $6fFrj.isValidElement(icon) ? /*#__PURE__*/ $6fFrj.cloneElement(icon, {
            className: iconClassName
        }) : icon);
    })));
    return /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), {
        visible: visible,
        motionName: maskTransitionName
    }, function(_ref2) {
        var className = _ref2.className, style = _ref2.style;
        return /*#__PURE__*/ $6fFrj.createElement((0, $8190793b254f77a3$export$2e2bcd8739ae039), {
            open: true,
            getContainer: getContainer !== null && getContainer !== void 0 ? getContainer : document.body
        }, /*#__PURE__*/ $6fFrj.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-operations-wrapper"), className, rootClassName),
            style: style
        }, operations));
    });
};
var $07eaefe91cc789a1$export$2e2bcd8739ae039 = $07eaefe91cc789a1$var$Operations;



var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $hqic8 = parcelRequire("hqic8");


var $c26863f632e15a4e$var$initialTransform = {
    x: 0,
    y: 0,
    rotate: 0,
    scale: 1
};
function $c26863f632e15a4e$export$2e2bcd8739ae039(imgRef) {
    var frame = (0, $6fFrj.useRef)(null);
    var queue = (0, $6fFrj.useRef)([]);
    var _useState = (0, $6fFrj.useState)($c26863f632e15a4e$var$initialTransform), _useState2 = (0, $jP8CL.default)(_useState, 2), transform = _useState2[0], setTransform = _useState2[1];
    var resetTransform = function resetTransform() {
        setTransform($c26863f632e15a4e$var$initialTransform);
    };
    /** Direct update transform */ var updateTransform = function updateTransform(newTransform) {
        if (frame.current === null) {
            queue.current = [];
            frame.current = (0, $hqic8.default)(function() {
                setTransform(function(preState) {
                    var memoState = preState;
                    queue.current.forEach(function(queueState) {
                        memoState = (0, $kNxFX.default)((0, $kNxFX.default)({}, memoState), queueState);
                    });
                    frame.current = null;
                    return memoState;
                });
            });
        }
        queue.current.push((0, $kNxFX.default)((0, $kNxFX.default)({}, transform), newTransform));
    };
    /** Scale according to the position of clientX and clientY */ var dispatchZoonChange = function dispatchZoonChange(ratio, clientX, clientY) {
        var _imgRef$current = imgRef.current, width = _imgRef$current.width, height = _imgRef$current.height, offsetWidth = _imgRef$current.offsetWidth, offsetHeight = _imgRef$current.offsetHeight, offsetLeft = _imgRef$current.offsetLeft, offsetTop = _imgRef$current.offsetTop;
        var newRatio = ratio;
        var newScale = transform.scale * ratio;
        if (newScale > (0, $298365afe53007cc$export$44e5bd0fef8d913c)) {
            newRatio = (0, $298365afe53007cc$export$44e5bd0fef8d913c) / transform.scale;
            newScale = (0, $298365afe53007cc$export$44e5bd0fef8d913c);
        } else if (newScale < (0, $298365afe53007cc$export$e4985ca28e204935)) {
            newRatio = (0, $298365afe53007cc$export$e4985ca28e204935) / transform.scale;
            newScale = (0, $298365afe53007cc$export$e4985ca28e204935);
        }
        /** Default center point scaling */ var mergedClientX = clientX !== null && clientX !== void 0 ? clientX : innerWidth / 2;
        var mergedClientY = clientY !== null && clientY !== void 0 ? clientY : innerHeight / 2;
        var diffRatio = newRatio - 1;
        /** Deviation calculated from image size */ var diffImgX = diffRatio * width * 0.5;
        var diffImgY = diffRatio * height * 0.5;
        /** The difference between the click position and the edge of the document */ var diffOffsetLeft = diffRatio * (mergedClientX - transform.x - offsetLeft);
        var diffOffsetTop = diffRatio * (mergedClientY - transform.y - offsetTop);
        /** Final positioning */ var newX = transform.x - (diffOffsetLeft - diffImgX);
        var newY = transform.y - (diffOffsetTop - diffImgY);
        /**
     * When zooming the image
     * When the image size is smaller than the width and height of the window, the position is initialized
     */ if (ratio < 1 && newScale === 1) {
            var mergedWidth = offsetWidth * newScale;
            var mergedHeight = offsetHeight * newScale;
            var _getClientSize = (0, $cfb7a0d68d50ecbf$export$1feb45891927fcb4)(), clientWidth = _getClientSize.width, clientHeight = _getClientSize.height;
            if (mergedWidth <= clientWidth && mergedHeight <= clientHeight) {
                newX = 0;
                newY = 0;
            }
        }
        updateTransform({
            x: newX,
            y: newY,
            scale: newScale
        });
    };
    return {
        transform: transform,
        resetTransform: resetTransform,
        updateTransform: updateTransform,
        dispatchZoonChange: dispatchZoonChange
    };
}



var $kNxFX = parcelRequire("kNxFX");

var $43449 = parcelRequire("43449");

function $f033545606cb0b21$var$fixPoint(key, start, width, clientWidth) {
    var startAddWidth = start + width;
    var offsetStart = (width - clientWidth) / 2;
    if (width > clientWidth) {
        if (start > 0) return (0, $43449.default)({}, key, offsetStart);
        if (start < 0 && startAddWidth < clientWidth) return (0, $43449.default)({}, key, -offsetStart);
    } else if (start < 0 || startAddWidth > clientWidth) return (0, $43449.default)({}, key, start < 0 ? offsetStart : -offsetStart);
    return {};
}
function $f033545606cb0b21$export$2e2bcd8739ae039(width, height, left, top) {
    var _getClientSize = (0, $cfb7a0d68d50ecbf$export$1feb45891927fcb4)(), clientWidth = _getClientSize.width, clientHeight = _getClientSize.height;
    var fixPos = null;
    if (width <= clientWidth && height <= clientHeight) fixPos = {
        x: 0,
        y: 0
    };
    else if (width > clientWidth || height > clientHeight) fixPos = (0, $kNxFX.default)((0, $kNxFX.default)({}, $f033545606cb0b21$var$fixPoint('x', left, width, clientWidth)), $f033545606cb0b21$var$fixPoint('y', top, height, clientHeight));
    return fixPos;
}



var $af145c071811f62a$var$_excluded = [
    "prefixCls",
    "src",
    "alt",
    "onClose",
    "afterClose",
    "visible",
    "icons",
    "rootClassName",
    "getContainer",
    "countRender",
    "scaleStep",
    "transitionName",
    "maskTransitionName"
];
var $af145c071811f62a$var$Preview = function Preview(props) {
    var prefixCls = props.prefixCls, src = props.src, alt = props.alt, onClose = props.onClose, afterClose = props.afterClose, visible = props.visible, _props$icons = props.icons, icons = _props$icons === void 0 ? {} : _props$icons, rootClassName = props.rootClassName, getContainer = props.getContainer, countRender = props.countRender, _props$scaleStep = props.scaleStep, scaleStep = _props$scaleStep === void 0 ? 0.5 : _props$scaleStep, _props$transitionName = props.transitionName, transitionName = _props$transitionName === void 0 ? 'zoom' : _props$transitionName, _props$maskTransition = props.maskTransitionName, maskTransitionName = _props$maskTransition === void 0 ? 'fade' : _props$maskTransition, restProps = (0, $04RxA.default)(props, $af145c071811f62a$var$_excluded);
    var imgRef = (0, $6fFrj.useRef)();
    var downPositionRef = (0, $6fFrj.useRef)({
        deltaX: 0,
        deltaY: 0,
        transformX: 0,
        transformY: 0
    });
    var _useState = (0, $6fFrj.useState)(false), _useState2 = (0, $jP8CL.default)(_useState, 2), isMoving = _useState2[0], setMoving = _useState2[1];
    var _useContext = (0, $6fFrj.useContext)((0, $3cad9afd1779a871$export$a078c61943f9dbbe)), previewUrls = _useContext.previewUrls, current = _useContext.current, isPreviewGroup = _useContext.isPreviewGroup, setCurrent = _useContext.setCurrent;
    var previewGroupCount = previewUrls.size;
    var previewUrlsKeys = Array.from(previewUrls.keys());
    var currentPreviewIndex = previewUrlsKeys.indexOf(current);
    var combinationSrc = isPreviewGroup ? previewUrls.get(current) : src;
    var showLeftOrRightSwitches = isPreviewGroup && previewGroupCount > 1;
    var showOperationsProgress = isPreviewGroup && previewGroupCount >= 1;
    var _useImageTransform = (0, $c26863f632e15a4e$export$2e2bcd8739ae039)(imgRef), transform = _useImageTransform.transform, resetTransform = _useImageTransform.resetTransform, updateTransform = _useImageTransform.updateTransform, dispatchZoonChange = _useImageTransform.dispatchZoonChange;
    var rotate = transform.rotate, scale = transform.scale;
    var wrapClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)({}, "".concat(prefixCls, "-moving"), isMoving));
    var onAfterClose = function onAfterClose() {
        resetTransform();
    };
    var onZoomIn = function onZoomIn() {
        dispatchZoonChange((0, $298365afe53007cc$export$6e76060232ffaf48) + scaleStep);
    };
    var onZoomOut = function onZoomOut() {
        dispatchZoonChange((0, $298365afe53007cc$export$6e76060232ffaf48) - scaleStep);
    };
    var onRotateRight = function onRotateRight() {
        updateTransform({
            rotate: rotate + 90
        });
    };
    var onRotateLeft = function onRotateLeft() {
        updateTransform({
            rotate: rotate - 90
        });
    };
    var onSwitchLeft = function onSwitchLeft(event) {
        event.preventDefault();
        event.stopPropagation();
        if (currentPreviewIndex > 0) setCurrent(previewUrlsKeys[currentPreviewIndex - 1]);
    };
    var onSwitchRight = function onSwitchRight(event) {
        event.preventDefault();
        event.stopPropagation();
        if (currentPreviewIndex < previewGroupCount - 1) setCurrent(previewUrlsKeys[currentPreviewIndex + 1]);
    };
    var onMouseUp = function onMouseUp() {
        if (visible && isMoving) {
            setMoving(false);
            /** No need to restore the position when the picture is not moved, So as not to interfere with the click */ var _downPositionRef$curr = downPositionRef.current, transformX = _downPositionRef$curr.transformX, transformY = _downPositionRef$curr.transformY;
            var hasChangedPosition = transform.x !== transformX && transform.y !== transformY;
            if (!hasChangedPosition) return;
            var width = imgRef.current.offsetWidth * scale;
            var height = imgRef.current.offsetHeight * scale; // eslint-disable-next-line @typescript-eslint/no-shadow
            var _imgRef$current$getBo = imgRef.current.getBoundingClientRect(), left = _imgRef$current$getBo.left, top = _imgRef$current$getBo.top;
            var isRotate = rotate % 180 !== 0;
            var fixState = (0, $f033545606cb0b21$export$2e2bcd8739ae039)(isRotate ? height : width, isRotate ? width : height, left, top);
            if (fixState) updateTransform((0, $kNxFX.default)({}, fixState));
        }
    };
    var onMouseDown = function onMouseDown(event) {
        // Only allow main button
        if (event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        downPositionRef.current = {
            deltaX: event.pageX - transform.x,
            deltaY: event.pageY - transform.y,
            transformX: transform.x,
            transformY: transform.y
        };
        setMoving(true);
    };
    var onMouseMove = function onMouseMove(event) {
        if (visible && isMoving) updateTransform({
            x: event.pageX - downPositionRef.current.deltaX,
            y: event.pageY - downPositionRef.current.deltaY
        });
    };
    var onWheel = function onWheel(event) {
        if (!visible || event.deltaY == 0) return; // Scale ratio depends on the deltaY size
        var scaleRatio = Math.abs(event.deltaY / 100); // Limit the maximum scale ratio
        var mergedScaleRatio = Math.min(scaleRatio, (0, $298365afe53007cc$export$137a7d87d4a2aae5)); // Scale the ratio each time
        var ratio = (0, $298365afe53007cc$export$6e76060232ffaf48) + mergedScaleRatio * scaleStep;
        if (event.deltaY > 0) ratio = (0, $298365afe53007cc$export$6e76060232ffaf48) / ratio;
        dispatchZoonChange(ratio, event.clientX, event.clientY);
    };
    var onKeyDown = (0, $6fFrj.useCallback)(function(event) {
        if (!visible || !showLeftOrRightSwitches) return;
        if (event.keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).LEFT) {
            if (currentPreviewIndex > 0) setCurrent(previewUrlsKeys[currentPreviewIndex - 1]);
        } else if (event.keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).RIGHT) {
            if (currentPreviewIndex < previewGroupCount - 1) setCurrent(previewUrlsKeys[currentPreviewIndex + 1]);
        }
    }, [
        currentPreviewIndex,
        previewGroupCount,
        previewUrlsKeys,
        setCurrent,
        showLeftOrRightSwitches,
        visible
    ]);
    var onDoubleClick = function onDoubleClick(event) {
        if (visible) {
            if (scale !== 1) updateTransform({
                x: 0,
                y: 0,
                scale: 1
            });
            else dispatchZoonChange((0, $298365afe53007cc$export$6e76060232ffaf48) + scaleStep, event.clientX, event.clientY);
        }
    };
    (0, $6fFrj.useEffect)(function() {
        var onTopMouseUpListener;
        var onTopMouseMoveListener;
        var onMouseUpListener = (0, $5184338d6a99a234$export$2e2bcd8739ae039)(window, 'mouseup', onMouseUp, false);
        var onMouseMoveListener = (0, $5184338d6a99a234$export$2e2bcd8739ae039)(window, 'mousemove', onMouseMove, false);
        var onKeyDownListener = (0, $5184338d6a99a234$export$2e2bcd8739ae039)(window, 'keydown', onKeyDown, false);
        try {
            // Resolve if in iframe lost event
            /* istanbul ignore next */ if (window.top !== window.self) {
                onTopMouseUpListener = (0, $5184338d6a99a234$export$2e2bcd8739ae039)(window.top, 'mouseup', onMouseUp, false);
                onTopMouseMoveListener = (0, $5184338d6a99a234$export$2e2bcd8739ae039)(window.top, 'mousemove', onMouseMove, false);
            }
        } catch (error) {
            /* istanbul ignore next */ (0, $3mXQ2.warning)(false, "[rc-image] ".concat(error));
        }
        return function() {
            var _onTopMouseUpListener, _onTopMouseMoveListen;
            onMouseUpListener.remove();
            onMouseMoveListener.remove();
            onKeyDownListener.remove();
            /* istanbul ignore next */ (_onTopMouseUpListener = onTopMouseUpListener) === null || _onTopMouseUpListener === void 0 || _onTopMouseUpListener.remove();
            /* istanbul ignore next */ (_onTopMouseMoveListen = onTopMouseMoveListener) === null || _onTopMouseMoveListen === void 0 || _onTopMouseMoveListen.remove();
        };
    }, [
        visible,
        isMoving,
        onKeyDown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $5a2c78a8da70f218$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        transitionName: transitionName,
        maskTransitionName: maskTransitionName,
        closable: false,
        keyboard: true,
        prefixCls: prefixCls,
        onClose: onClose,
        afterClose: onAfterClose,
        visible: visible,
        wrapClassName: wrapClassName,
        rootClassName: rootClassName,
        getContainer: getContainer
    }, restProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "".concat(prefixCls, "-img-wrapper")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("img", {
        width: props.width,
        height: props.height,
        onWheel: onWheel,
        onMouseDown: onMouseDown,
        onDoubleClick: onDoubleClick,
        ref: imgRef,
        className: "".concat(prefixCls, "-img"),
        src: combinationSrc,
        alt: alt,
        style: {
            transform: "translate3d(".concat(transform.x, "px, ").concat(transform.y, "px, 0) scale3d(").concat(scale, ", ").concat(scale, ", 1) rotate(").concat(rotate, "deg)")
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $07eaefe91cc789a1$export$2e2bcd8739ae039), {
        visible: visible,
        maskTransitionName: maskTransitionName,
        getContainer: getContainer,
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        icons: icons,
        countRender: countRender,
        showSwitch: showLeftOrRightSwitches,
        showProgress: showOperationsProgress,
        current: currentPreviewIndex,
        count: previewGroupCount,
        scale: scale,
        onSwitchLeft: onSwitchLeft,
        onSwitchRight: onSwitchRight,
        onZoomIn: onZoomIn,
        onZoomOut: onZoomOut,
        onRotateRight: onRotateRight,
        onRotateLeft: onRotateLeft,
        onClose: onClose
    }));
};
var $af145c071811f62a$export$2e2bcd8739ae039 = $af145c071811f62a$var$Preview;



var $f776bf83731c11bd$var$_excluded = [
    "src",
    "alt",
    "onPreviewClose",
    "prefixCls",
    "previewPrefixCls",
    "placeholder",
    "fallback",
    "width",
    "height",
    "style",
    "preview",
    "className",
    "onClick",
    "onError",
    "wrapperClassName",
    "wrapperStyle",
    "rootClassName",
    "crossOrigin",
    "decoding",
    "loading",
    "referrerPolicy",
    "sizes",
    "srcSet",
    "useMap",
    "draggable"
], $f776bf83731c11bd$var$_excluded2 = [
    "src",
    "visible",
    "onVisibleChange",
    "getContainer",
    "mask",
    "maskClassName",
    "icons",
    "scaleStep"
];
var $f776bf83731c11bd$var$uuid = 0;
var $f776bf83731c11bd$var$ImageInternal = function ImageInternal(_ref) {
    var _imgCommonProps$style;
    var imgSrc = _ref.src, alt = _ref.alt, onInitialPreviewClose = _ref.onPreviewClose, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? 'rc-image' : _ref$prefixCls, _ref$previewPrefixCls = _ref.previewPrefixCls, previewPrefixCls = _ref$previewPrefixCls === void 0 ? "".concat(prefixCls, "-preview") : _ref$previewPrefixCls, placeholder = _ref.placeholder, fallback = _ref.fallback, width = _ref.width, height = _ref.height, style = _ref.style, _ref$preview = _ref.preview, preview = _ref$preview === void 0 ? true : _ref$preview, className = _ref.className, onClick = _ref.onClick, onImageError = _ref.onError, wrapperClassName = _ref.wrapperClassName, wrapperStyle = _ref.wrapperStyle, rootClassName = _ref.rootClassName, crossOrigin = _ref.crossOrigin, decoding = _ref.decoding, loading = _ref.loading, referrerPolicy = _ref.referrerPolicy, sizes = _ref.sizes, srcSet = _ref.srcSet, useMap = _ref.useMap, draggable = _ref.draggable, otherProps = (0, $04RxA.default)(_ref, $f776bf83731c11bd$var$_excluded);
    var isCustomPlaceholder = placeholder && placeholder !== true;
    var _ref2 = (0, $5KhTJ.default)(preview) === 'object' ? preview : {}, previewSrc = _ref2.src, _ref2$visible = _ref2.visible, previewVisible = _ref2$visible === void 0 ? undefined : _ref2$visible, _ref2$onVisibleChange = _ref2.onVisibleChange, onPreviewVisibleChange = _ref2$onVisibleChange === void 0 ? onInitialPreviewClose : _ref2$onVisibleChange, _ref2$getContainer = _ref2.getContainer, getPreviewContainer = _ref2$getContainer === void 0 ? undefined : _ref2$getContainer, previewMask = _ref2.mask, maskClassName = _ref2.maskClassName, icons = _ref2.icons, scaleStep = _ref2.scaleStep, dialogProps = (0, $04RxA.default)(_ref2, $f776bf83731c11bd$var$_excluded2);
    var src = previewSrc !== null && previewSrc !== void 0 ? previewSrc : imgSrc;
    var isControlled = previewVisible !== undefined;
    var _useMergedState = (0, $gfhff.default)(!!previewVisible, {
        value: previewVisible,
        onChange: onPreviewVisibleChange
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), isShowPreview = _useMergedState2[0], setShowPreview = _useMergedState2[1];
    var _useState = (0, $6fFrj.useState)(isCustomPlaceholder ? 'loading' : 'normal'), _useState2 = (0, $jP8CL.default)(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var _useState3 = (0, $6fFrj.useState)(null), _useState4 = (0, $jP8CL.default)(_useState3, 2), mousePosition = _useState4[0], setMousePosition = _useState4[1];
    var isError = status === 'error';
    var _React$useContext = $6fFrj.useContext((0, $3cad9afd1779a871$export$a078c61943f9dbbe)), isPreviewGroup = _React$useContext.isPreviewGroup, setCurrent = _React$useContext.setCurrent, setGroupShowPreview = _React$useContext.setShowPreview, setGroupMousePosition = _React$useContext.setMousePosition, registerImage = _React$useContext.registerImage;
    var _React$useState = $6fFrj.useState(function() {
        $f776bf83731c11bd$var$uuid += 1;
        return $f776bf83731c11bd$var$uuid;
    }), _React$useState2 = (0, $jP8CL.default)(_React$useState, 1), currentId = _React$useState2[0];
    var canPreview = !!preview;
    var isLoaded = $6fFrj.useRef(false);
    var onLoad = function onLoad() {
        setStatus('normal');
    };
    var onError = function onError(e) {
        if (onImageError) onImageError(e);
        setStatus('error');
    };
    var onPreview = function onPreview(e) {
        if (!isControlled) {
            var _getOffset = (0, $cfb7a0d68d50ecbf$export$622cea445a1c5b7d)(e.target), left = _getOffset.left, top = _getOffset.top;
            if (isPreviewGroup) {
                setCurrent(currentId);
                setGroupMousePosition({
                    x: left,
                    y: top
                });
            } else setMousePosition({
                x: left,
                y: top
            });
        }
        if (isPreviewGroup) setGroupShowPreview(true);
        else setShowPreview(true);
        if (onClick) onClick(e);
    };
    var onPreviewClose = function onPreviewClose(e) {
        e.stopPropagation();
        setShowPreview(false);
        if (!isControlled) setMousePosition(null);
    };
    var getImgRef = function getImgRef(img) {
        isLoaded.current = false;
        if (status !== 'loading') return;
        if (img !== null && img !== void 0 && img.complete && (img.naturalWidth || img.naturalHeight)) {
            isLoaded.current = true;
            onLoad();
        }
    }; // Keep order start
    // Resolve https://github.com/ant-design/ant-design/issues/28881
    // Only need unRegister when component unMount
    $6fFrj.useEffect(function() {
        var unRegister = registerImage(currentId, src);
        return unRegister;
    }, []);
    $6fFrj.useEffect(function() {
        registerImage(currentId, src, canPreview);
    }, [
        src,
        canPreview
    ]); // Keep order end
    $6fFrj.useEffect(function() {
        if (isError) setStatus('normal');
        if (isCustomPlaceholder && !isLoaded.current) setStatus('loading');
    }, [
        imgSrc
    ]);
    var wrapperClass = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, wrapperClassName, rootClassName, (0, $43449.default)({}, "".concat(prefixCls, "-error"), isError));
    var mergedSrc = isError && fallback ? fallback : src;
    var imgCommonProps = {
        crossOrigin: crossOrigin,
        decoding: decoding,
        draggable: draggable,
        loading: loading,
        referrerPolicy: referrerPolicy,
        sizes: sizes,
        srcSet: srcSet,
        useMap: useMap,
        alt: alt,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-img"), (0, $43449.default)({}, "".concat(prefixCls, "-img-placeholder"), placeholder === true), className),
        style: (0, $kNxFX.default)({
            height: height
        }, style)
    };
    return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({}, otherProps, {
        className: wrapperClass,
        onClick: canPreview ? onPreview : onClick,
        style: (0, $kNxFX.default)({
            width: width,
            height: height
        }, wrapperStyle)
    }), /*#__PURE__*/ $6fFrj.createElement("img", (0, $fIrcP.default)({}, imgCommonProps, {
        ref: getImgRef
    }, isError && fallback ? {
        src: fallback
    } : {
        onLoad: onLoad,
        onError: onError,
        src: imgSrc
    }, {
        width: width,
        height: height
    })), status === 'loading' && /*#__PURE__*/ $6fFrj.createElement("div", {
        "aria-hidden": "true",
        className: "".concat(prefixCls, "-placeholder")
    }, placeholder), previewMask && canPreview && /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-mask"), maskClassName),
        style: {
            display: ((_imgCommonProps$style = imgCommonProps.style) === null || _imgCommonProps$style === void 0 ? void 0 : _imgCommonProps$style.display) === 'none' ? 'none' : undefined
        }
    }, previewMask)), !isPreviewGroup && canPreview && /*#__PURE__*/ $6fFrj.createElement((0, $af145c071811f62a$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        "aria-hidden": !isShowPreview,
        visible: isShowPreview,
        prefixCls: previewPrefixCls,
        onClose: onPreviewClose,
        mousePosition: mousePosition,
        src: mergedSrc,
        alt: alt,
        getContainer: getPreviewContainer,
        icons: icons,
        scaleStep: scaleStep,
        rootClassName: rootClassName
    }, dialogProps)));
};
$f776bf83731c11bd$var$ImageInternal.PreviewGroup = (0, $3cad9afd1779a871$export$2e2bcd8739ae039);
$f776bf83731c11bd$var$ImageInternal.displayName = 'Image';
var $f776bf83731c11bd$export$2e2bcd8739ae039 = $f776bf83731c11bd$var$ImageInternal;


var $4b97885aea3bb05e$export$2e2bcd8739ae039 = (0, $f776bf83731c11bd$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");


var $601d9fcc95befd4d$export$2e2bcd8739ae039 = (0, $da4c09bd655d3c55$export$2e2bcd8739ae039);




var $fIrcP = parcelRequire("fIrcP");

var $5KhTJ = parcelRequire("5KhTJ");




var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $fa75dba538cb24e6$var$RotateLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z"
                }
            }
        ]
    },
    "name": "rotate-left",
    "theme": "outlined"
};
var $fa75dba538cb24e6$export$2e2bcd8739ae039 = $fa75dba538cb24e6$var$RotateLeftOutlined;



var $21d69e44665e3149$var$RotateLeftOutlined = function RotateLeftOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $fa75dba538cb24e6$export$2e2bcd8739ae039)
    }));
};
var $21d69e44665e3149$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($21d69e44665e3149$var$RotateLeftOutlined);
var $21d69e44665e3149$export$2e2bcd8739ae039 = $21d69e44665e3149$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $c1494489da8376b9$var$RotateRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z"
                }
            }
        ]
    },
    "name": "rotate-right",
    "theme": "outlined"
};
var $c1494489da8376b9$export$2e2bcd8739ae039 = $c1494489da8376b9$var$RotateRightOutlined;



var $f89f1bf42cfca4c4$var$RotateRightOutlined = function RotateRightOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $c1494489da8376b9$export$2e2bcd8739ae039)
    }));
};
var $f89f1bf42cfca4c4$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($f89f1bf42cfca4c4$var$RotateRightOutlined);
var $f89f1bf42cfca4c4$export$2e2bcd8739ae039 = $f89f1bf42cfca4c4$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $185c8d7aa59a9d06$var$ZoomInOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    },
    "name": "zoom-in",
    "theme": "outlined"
};
var $185c8d7aa59a9d06$export$2e2bcd8739ae039 = $185c8d7aa59a9d06$var$ZoomInOutlined;



var $25484b6aeecba8f0$var$ZoomInOutlined = function ZoomInOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $185c8d7aa59a9d06$export$2e2bcd8739ae039)
    }));
};
var $25484b6aeecba8f0$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($25484b6aeecba8f0$var$ZoomInOutlined);
var $25484b6aeecba8f0$export$2e2bcd8739ae039 = $25484b6aeecba8f0$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $112891879f8487ac$var$ZoomOutOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    },
    "name": "zoom-out",
    "theme": "outlined"
};
var $112891879f8487ac$export$2e2bcd8739ae039 = $112891879f8487ac$var$ZoomOutOutlined;



var $9c3126632a9e4c1b$var$ZoomOutOutlined = function ZoomOutOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $112891879f8487ac$export$2e2bcd8739ae039)
    }));
};
var $9c3126632a9e4c1b$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($9c3126632a9e4c1b$var$ZoomOutOutlined);
var $9c3126632a9e4c1b$export$2e2bcd8739ae039 = $9c3126632a9e4c1b$var$RefIcon;




var $6fFrj = parcelRequire("6fFrj");


var $94a8c3433419d013$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $94a8c3433419d013$export$df03f54e09e486fa = {
    rotateLeft: /*#__PURE__*/ $6fFrj.createElement((0, $21d69e44665e3149$export$2e2bcd8739ae039), null),
    rotateRight: /*#__PURE__*/ $6fFrj.createElement((0, $f89f1bf42cfca4c4$export$2e2bcd8739ae039), null),
    zoomIn: /*#__PURE__*/ $6fFrj.createElement((0, $25484b6aeecba8f0$export$2e2bcd8739ae039), null),
    zoomOut: /*#__PURE__*/ $6fFrj.createElement((0, $9c3126632a9e4c1b$export$2e2bcd8739ae039), null),
    close: /*#__PURE__*/ $6fFrj.createElement((0, $4cb3f1f073816266$export$2e2bcd8739ae039), null),
    left: /*#__PURE__*/ $6fFrj.createElement((0, $ae5877404f2a0345$export$2e2bcd8739ae039), null),
    right: /*#__PURE__*/ $6fFrj.createElement((0, $e7bd83ac29db4850$export$2e2bcd8739ae039), null)
};
var $94a8c3433419d013$var$InternalPreviewGroup = function InternalPreviewGroup(_a) {
    var customizePrefixCls = _a.previewPrefixCls, preview = _a.preview, props = $94a8c3433419d013$var$__rest(_a, [
        "previewPrefixCls",
        "preview"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('image-preview', customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var mergedPreview = $6fFrj.useMemo(function() {
        if (preview === false) return preview;
        var _preview = (0, $5KhTJ.default)(preview) === 'object' ? preview : {};
        return (0, $fIrcP.default)((0, $fIrcP.default)({}, _preview), {
            transitionName: (0, $779588b2444df86c$export$27c72201b1d09951)(rootPrefixCls, 'zoom', _preview.transitionName),
            maskTransitionName: (0, $779588b2444df86c$export$27c72201b1d09951)(rootPrefixCls, 'fade', _preview.maskTransitionName)
        });
    }, [
        preview
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $4b97885aea3bb05e$export$2e2bcd8739ae039).PreviewGroup, (0, $fIrcP.default)({
        preview: mergedPreview,
        previewPrefixCls: prefixCls,
        icons: $94a8c3433419d013$export$df03f54e09e486fa
    }, props));
};
var $94a8c3433419d013$export$2e2bcd8739ae039 = $94a8c3433419d013$var$InternalPreviewGroup;


var $290d39e90e1ee9b2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $290d39e90e1ee9b2$var$Image = function Image(_a) {
    var customizePrefixCls = _a.prefixCls, preview = _a.preview, otherProps = $290d39e90e1ee9b2$var$__rest(_a, [
        "prefixCls",
        "preview"
    ]);
    var _useContext = (0, $6fFrj.useContext)((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext.getPrefixCls, _useContext$locale = _useContext.locale, contextLocale = _useContext$locale === void 0 ? (0, $601d9fcc95befd4d$export$2e2bcd8739ae039) : _useContext$locale, getContextPopupContainer = _useContext.getPopupContainer;
    var prefixCls = getPrefixCls('image', customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var imageLocale = contextLocale.Image || (0, $601d9fcc95befd4d$export$2e2bcd8739ae039).Image;
    var mergedPreview = $6fFrj.useMemo(function() {
        if (preview === false) return preview;
        var _preview = (0, $5KhTJ.default)(preview) === 'object' ? preview : {};
        var getContainer = _preview.getContainer, restPreviewProps = $290d39e90e1ee9b2$var$__rest(_preview, [
            "getContainer"
        ]);
        return (0, $fIrcP.default)((0, $fIrcP.default)({
            mask: /*#__PURE__*/ $6fFrj.createElement("div", {
                className: "".concat(prefixCls, "-mask-info")
            }, /*#__PURE__*/ $6fFrj.createElement((0, $eca7e40229c3d459$export$2e2bcd8739ae039), null), imageLocale === null || imageLocale === void 0 ? void 0 : imageLocale.preview),
            icons: (0, $94a8c3433419d013$export$df03f54e09e486fa)
        }, restPreviewProps), {
            getContainer: getContainer || getContextPopupContainer,
            transitionName: (0, $779588b2444df86c$export$27c72201b1d09951)(rootPrefixCls, 'zoom', _preview.transitionName),
            maskTransitionName: (0, $779588b2444df86c$export$27c72201b1d09951)(rootPrefixCls, 'fade', _preview.maskTransitionName)
        });
    }, [
        preview,
        imageLocale
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $4b97885aea3bb05e$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        prefixCls: prefixCls,
        preview: mergedPreview
    }, otherProps));
};
$290d39e90e1ee9b2$var$Image.PreviewGroup = (0, $94a8c3433419d013$export$2e2bcd8739ae039);
var $290d39e90e1ee9b2$export$2e2bcd8739ae039 = $290d39e90e1ee9b2$var$Image;


var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $5KhTJ = parcelRequire("5KhTJ");

var $jP8CL = parcelRequire("jP8CL");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $6f815f3e8a2ecfbe$var$DownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    "name": "down",
    "theme": "outlined"
};
var $6f815f3e8a2ecfbe$export$2e2bcd8739ae039 = $6f815f3e8a2ecfbe$var$DownOutlined;



var $344ef0cbd3adff87$var$DownOutlined = function DownOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $6f815f3e8a2ecfbe$export$2e2bcd8739ae039)
    }));
};
var $344ef0cbd3adff87$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($344ef0cbd3adff87$var$DownOutlined);
var $344ef0cbd3adff87$export$2e2bcd8739ae039 = $344ef0cbd3adff87$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $671cbaa9fff027d8$var$UpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"
                }
            }
        ]
    },
    "name": "up",
    "theme": "outlined"
};
var $671cbaa9fff027d8$export$2e2bcd8739ae039 = $671cbaa9fff027d8$var$UpOutlined;



var $630d786a8c58d6ad$var$UpOutlined = function UpOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $671cbaa9fff027d8$export$2e2bcd8739ae039)
    }));
};
var $630d786a8c58d6ad$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($630d786a8c58d6ad$var$UpOutlined);
var $630d786a8c58d6ad$export$2e2bcd8739ae039 = $630d786a8c58d6ad$var$RefIcon;



var $fActo = parcelRequire("fActo");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $5KhTJ = parcelRequire("5KhTJ");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


var $dNZA9 = parcelRequire("dNZA9");

var $3BOWT = parcelRequire("3BOWT");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");
function $4e0d028db4ff21e6$export$d5c7b2f63580e8f5() {
    return typeof BigInt === 'function';
}


function $e99cf0d1e555d520$export$5be79a0015c5ab12(numStr) {
    var str = numStr.trim();
    var negative = str.startsWith('-');
    if (negative) str = str.slice(1);
    str = str// Remove decimal 0. `1.000` => `1.`, `1.100` => `1.1`
    .replace(/(\.\d*[^0])0*$/, '$1')// Remove useless decimal. `1.` => `1`
    .replace(/\.0*$/, '')// Remove integer 0. `0001` => `1`, 000.1' => `.1`
    .replace(/^0+/, '');
    if (str.startsWith('.')) str = "0".concat(str);
    var trimStr = str || '0';
    var splitNumber = trimStr.split('.');
    var integerStr = splitNumber[0] || '0';
    var decimalStr = splitNumber[1] || '0';
    if (integerStr === '0' && decimalStr === '0') negative = false;
    var negativeStr = negative ? '-' : '';
    return {
        negative: negative,
        negativeStr: negativeStr,
        trimStr: trimStr,
        integerStr: integerStr,
        decimalStr: decimalStr,
        fullStr: "".concat(negativeStr).concat(trimStr)
    };
}
function $e99cf0d1e555d520$export$ee6c12ef7f6d8b32(number) {
    var str = String(number);
    return !Number.isNaN(Number(str)) && str.includes('e');
}
function $e99cf0d1e555d520$export$2e56483e4ad90ee6(number) {
    var numStr = String(number);
    if ($e99cf0d1e555d520$export$ee6c12ef7f6d8b32(number)) {
        var precision = Number(numStr.slice(numStr.indexOf('e-') + 2));
        var decimalMatch = numStr.match(/\.(\d+)/);
        if (decimalMatch === null || decimalMatch === void 0 ? void 0 : decimalMatch[1]) precision += decimalMatch[1].length;
        return precision;
    }
    return numStr.includes('.') && $e99cf0d1e555d520$export$b3d198e17b370bec(numStr) ? numStr.length - numStr.indexOf('.') - 1 : 0;
}
function $e99cf0d1e555d520$export$fdc98affa95a4322(number) {
    var numStr = String(number);
    if ($e99cf0d1e555d520$export$ee6c12ef7f6d8b32(number)) {
        if (number > Number.MAX_SAFE_INTEGER) return String((0, $4e0d028db4ff21e6$export$d5c7b2f63580e8f5)() ? BigInt(number).toString() : Number.MAX_SAFE_INTEGER);
        if (number < Number.MIN_SAFE_INTEGER) return String((0, $4e0d028db4ff21e6$export$d5c7b2f63580e8f5)() ? BigInt(number).toString() : Number.MIN_SAFE_INTEGER);
        numStr = number.toFixed($e99cf0d1e555d520$export$2e56483e4ad90ee6(numStr));
    }
    return $e99cf0d1e555d520$export$5be79a0015c5ab12(numStr).fullStr;
}
function $e99cf0d1e555d520$export$b3d198e17b370bec(num) {
    if (typeof num === 'number') return !Number.isNaN(num);
    // Empty
    if (!num) return false;
    return(// Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(num) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(num) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(num));
}
function $e99cf0d1e555d520$export$d2883c6c6307c415(step) {
    var stepStr = typeof step === 'number' ? $e99cf0d1e555d520$export$fdc98affa95a4322(step) : $e99cf0d1e555d520$export$5be79a0015c5ab12(step).fullStr;
    var hasPoint = stepStr.includes('.');
    if (!hasPoint) return step + '0';
    return $e99cf0d1e555d520$export$5be79a0015c5ab12(stepStr.replace(/(\d)\.(\d)/g, '$1$2.')).fullStr;
}



var $496d321a8242e147$export$8030d902f75ebb28 = /*#__PURE__*/ function() {
    function NumberDecimal(value) {
        (0, $kjNeN.default)(this, NumberDecimal);
        this.origin = '';
        this.number = void 0;
        this.empty = void 0;
        if (!value && value !== 0 || !String(value).trim()) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        this.number = Number(value);
    }
    (0, $5KQxu.default)(NumberDecimal, [
        {
            key: "negate",
            value: function negate() {
                return new NumberDecimal(-this.toNumber());
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new NumberDecimal(value);
                var target = Number(value);
                if (Number.isNaN(target)) return this;
                var number = this.number + target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, $e99cf0d1e555d520$export$2e56483e4ad90ee6)(this.number), (0, $e99cf0d1e555d520$export$2e56483e4ad90ee6)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.number);
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toNumber() === (target === null || target === void 0 ? void 0 : target.toNumber());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                return this.number;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return '';
                return (0, $e99cf0d1e555d520$export$fdc98affa95a4322)(this.number);
            }
        }
    ]);
    return NumberDecimal;
}();
var $496d321a8242e147$export$f5e82d1c4ceba475 = /*#__PURE__*/ function() {
    /** BigInt will convert `0009` to `9`. We need record the len of decimal */ function BigIntDecimal(value) {
        (0, $kjNeN.default)(this, BigIntDecimal);
        this.origin = '';
        this.negative = void 0;
        this.integer = void 0;
        this.decimal = void 0;
        this.decimalLen = void 0;
        this.empty = void 0;
        this.nan = void 0;
        if (!value && value !== 0 || !String(value).trim()) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        // Act like Number convert
        if (value === '-') {
            this.nan = true;
            return;
        }
        var mergedValue = value;
        // We need convert back to Number since it require `toFixed` to handle this
        if ((0, $e99cf0d1e555d520$export$ee6c12ef7f6d8b32)(mergedValue)) mergedValue = Number(mergedValue);
        mergedValue = typeof mergedValue === 'string' ? mergedValue : (0, $e99cf0d1e555d520$export$fdc98affa95a4322)(mergedValue);
        if ((0, $e99cf0d1e555d520$export$b3d198e17b370bec)(mergedValue)) {
            var trimRet = (0, $e99cf0d1e555d520$export$5be79a0015c5ab12)(mergedValue);
            this.negative = trimRet.negative;
            var numbers = trimRet.trimStr.split('.');
            this.integer = BigInt(numbers[0]);
            var decimalStr = numbers[1] || '0';
            this.decimal = BigInt(decimalStr);
            this.decimalLen = decimalStr.length;
        } else this.nan = true;
    }
    (0, $5KQxu.default)(BigIntDecimal, [
        {
            key: "getMark",
            value: function getMark() {
                return this.negative ? '-' : '';
            }
        },
        {
            key: "getIntegerStr",
            value: function getIntegerStr() {
                return this.integer.toString();
            }
        },
        {
            key: "getDecimalStr",
            value: function getDecimalStr() {
                return this.decimal.toString().padStart(this.decimalLen, '0');
            }
        },
        {
            key: "alignDecimal",
            value: function alignDecimal(decimalLength) {
                var str = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(decimalLength, '0'));
                return BigInt(str);
            }
        },
        {
            key: "negate",
            value: function negate() {
                var clone = new BigIntDecimal(this.toString());
                clone.negative = !clone.negative;
                return clone;
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new BigIntDecimal(value);
                var offset = new BigIntDecimal(value);
                if (offset.isInvalidate()) return this;
                var maxDecimalLength = Math.max(this.getDecimalStr().length, offset.getDecimalStr().length);
                var myAlignedDecimal = this.alignDecimal(maxDecimalLength);
                var offsetAlignedDecimal = offset.alignDecimal(maxDecimalLength);
                var valueStr = (myAlignedDecimal + offsetAlignedDecimal).toString();
                // We need fill string length back to `maxDecimalLength` to avoid parser failed
                var _trimNumber = (0, $e99cf0d1e555d520$export$5be79a0015c5ab12)(valueStr), negativeStr = _trimNumber.negativeStr, trimStr = _trimNumber.trimStr;
                var hydrateValueStr = "".concat(negativeStr).concat(trimStr.padStart(maxDecimalLength + 1, '0'));
                return new BigIntDecimal("".concat(hydrateValueStr.slice(0, -maxDecimalLength), ".").concat(hydrateValueStr.slice(-maxDecimalLength)));
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return this.nan;
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toString() === (target === null || target === void 0 ? void 0 : target.toString());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                if (this.isNaN()) return NaN;
                return Number(this.toString());
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return '';
                return (0, $e99cf0d1e555d520$export$5be79a0015c5ab12)("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr;
            }
        }
    ]);
    return BigIntDecimal;
}();
function $496d321a8242e147$export$2e2bcd8739ae039(value) {
    // We use BigInt here.
    // Will fallback to Number if not support.
    if ((0, $4e0d028db4ff21e6$export$d5c7b2f63580e8f5)()) return new $496d321a8242e147$export$f5e82d1c4ceba475(value);
    return new $496d321a8242e147$export$8030d902f75ebb28(value);
}
function $496d321a8242e147$export$a81f732198733497(numStr, separatorStr, precision) {
    var cutOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (numStr === '') return '';
    var _trimNumber2 = (0, $e99cf0d1e555d520$export$5be79a0015c5ab12)(numStr), negativeStr = _trimNumber2.negativeStr, integerStr = _trimNumber2.integerStr, decimalStr = _trimNumber2.decimalStr;
    var precisionDecimalStr = "".concat(separatorStr).concat(decimalStr);
    var numberWithoutDecimal = "".concat(negativeStr).concat(integerStr);
    if (precision >= 0) {
        // We will get last + 1 number to check if need advanced number
        var advancedNum = Number(decimalStr[precision]);
        if (advancedNum >= 5 && !cutOnly) {
            var advancedDecimal = $496d321a8242e147$export$2e2bcd8739ae039(numStr).add("".concat(negativeStr, "0.").concat('0'.repeat(precision)).concat(10 - advancedNum));
            return $496d321a8242e147$export$a81f732198733497(advancedDecimal.toString(), separatorStr, precision, cutOnly);
        }
        if (precision === 0) return numberWithoutDecimal;
        return "".concat(numberWithoutDecimal).concat(separatorStr).concat(decimalStr.padEnd(precision, '0').slice(0, precision));
    }
    if (precisionDecimalStr === '.0') return numberWithoutDecimal;
    return "".concat(numberWithoutDecimal).concat(precisionDecimalStr);
}



var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

/**
 * When click and hold on a button - the speed of auto changing the value.
 */ var $dea39b3c679058b1$var$STEP_INTERVAL = 200;
/**
 * When click and hold on a button - the delay before auto changing the value.
 */ var $dea39b3c679058b1$var$STEP_DELAY = 600;
function $dea39b3c679058b1$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, upNode = _ref.upNode, downNode = _ref.downNode, upDisabled = _ref.upDisabled, downDisabled = _ref.downDisabled, onStep = _ref.onStep;
    // ======================== Step ========================
    var stepTimeoutRef = $6fFrj.useRef();
    var onStepRef = $6fFrj.useRef();
    onStepRef.current = onStep;
    // We will interval update step when hold mouse down
    var onStepMouseDown = function onStepMouseDown(e, up) {
        e.preventDefault();
        onStepRef.current(up);
        // Loop step for interval
        function loopStep() {
            onStepRef.current(up);
            stepTimeoutRef.current = setTimeout(loopStep, $dea39b3c679058b1$var$STEP_INTERVAL);
        }
        // First time press will wait some time to trigger loop step update
        stepTimeoutRef.current = setTimeout(loopStep, $dea39b3c679058b1$var$STEP_DELAY);
    };
    var onStopStep = function onStopStep() {
        clearTimeout(stepTimeoutRef.current);
    };
    $6fFrj.useEffect(function() {
        return onStopStep;
    }, []);
    // ======================= Render =======================
    if ((0, $fee6da8402dc892a$export$2e2bcd8739ae039)()) return null;
    var handlerClassName = "".concat(prefixCls, "-handler");
    var upClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(handlerClassName, "".concat(handlerClassName, "-up"), (0, $43449.default)({}, "".concat(handlerClassName, "-up-disabled"), upDisabled));
    var downClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(handlerClassName, "".concat(handlerClassName, "-down"), (0, $43449.default)({}, "".concat(handlerClassName, "-down-disabled"), downDisabled));
    var sharedHandlerProps = {
        unselectable: 'on',
        role: 'button',
        onMouseUp: onStopStep,
        onMouseLeave: onStopStep
    };
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(handlerClassName, "-wrap")
    }, /*#__PURE__*/ $6fFrj.createElement("span", (0, $fIrcP.default)({}, sharedHandlerProps, {
        onMouseDown: function onMouseDown(e) {
            onStepMouseDown(e, true);
        },
        "aria-label": "Increase Value",
        "aria-disabled": upDisabled,
        className: upClassName
    }), upNode || /*#__PURE__*/ $6fFrj.createElement("span", {
        unselectable: "on",
        className: "".concat(prefixCls, "-handler-up-inner")
    })), /*#__PURE__*/ $6fFrj.createElement("span", (0, $fIrcP.default)({}, sharedHandlerProps, {
        onMouseDown: function onMouseDown(e) {
            onStepMouseDown(e, false);
        },
        "aria-label": "Decrease Value",
        "aria-disabled": downDisabled,
        className: downClassName
    }), downNode || /*#__PURE__*/ $6fFrj.createElement("span", {
        unselectable: "on",
        className: "".concat(prefixCls, "-handler-down-inner")
    })));
}




var $6fFrj = parcelRequire("6fFrj");

var $3mXQ2 = parcelRequire("3mXQ2");
function $d149e07c30bf2e3e$export$2e2bcd8739ae039(input, focused) {
    var selectionRef = (0, $6fFrj.useRef)(null);
    function recordCursor() {
        // Record position
        try {
            var start = input.selectionStart, end = input.selectionEnd, value = input.value;
            var beforeTxt = value.substring(0, start);
            var afterTxt = value.substring(end);
            selectionRef.current = {
                start: start,
                end: end,
                value: value,
                beforeTxt: beforeTxt,
                afterTxt: afterTxt
            };
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    }
    /**
   * Restore logic:
   *  1. back string same
   *  2. start string same
   */ function restoreCursor() {
        if (input && selectionRef.current && focused) try {
            var value = input.value;
            var _selectionRef$current = selectionRef.current, beforeTxt = _selectionRef$current.beforeTxt, afterTxt = _selectionRef$current.afterTxt, start = _selectionRef$current.start;
            var startPos = value.length;
            if (value.endsWith(afterTxt)) startPos = value.length - selectionRef.current.afterTxt.length;
            else if (value.startsWith(beforeTxt)) startPos = beforeTxt.length;
            else {
                var beforeLastChar = beforeTxt[start - 1];
                var newIndex = value.indexOf(beforeLastChar, start - 1);
                if (newIndex !== -1) startPos = newIndex + 1;
            }
            input.setSelectionRange(startPos, startPos);
        } catch (e) {
            (0, $3mXQ2.default)(false, "Something warning of cursor restore. Please fire issue about this: ".concat(e.message));
        }
    }
    return [
        recordCursor,
        restoreCursor
    ];
}



var $6fFrj = parcelRequire("6fFrj");

var $hqic8 = parcelRequire("hqic8");
var /**
 * Always trigger latest once when call multiple time
 */ $6c885b7d2236ee19$export$2e2bcd8739ae039 = function() {
    var idRef = (0, $6fFrj.useRef)(0);
    var cleanUp = function cleanUp() {
        (0, $hqic8.default).cancel(idRef.current);
    };
    (0, $6fFrj.useEffect)(function() {
        return cleanUp;
    }, []);
    return function(callback) {
        cleanUp();
        idRef.current = (0, $hqic8.default)(function() {
            callback();
        });
    };
};


var $c168746e73e50243$var$_excluded = [
    "prefixCls",
    "className",
    "style",
    "min",
    "max",
    "step",
    "defaultValue",
    "value",
    "disabled",
    "readOnly",
    "upHandler",
    "downHandler",
    "keyboard",
    "controls",
    "stringMode",
    "parser",
    "formatter",
    "precision",
    "decimalSeparator",
    "onChange",
    "onInput",
    "onPressEnter",
    "onStep"
];
/**
 * We support `stringMode` which need handle correct type when user call in onChange
 * format max or min value
 * 1. if isInvalid return null
 * 2. if precision is undefined, return decimal
 * 3. format with precision
 *    I. if max > 0, round down with precision. Example: max= 3.5, precision=0  afterFormat: 3
 *    II. if max < 0, round up with precision. Example: max= -3.5, precision=0  afterFormat: -4
 *    III. if min > 0, round up with precision. Example: min= 3.5, precision=0  afterFormat: 4
 *    IV. if min < 0, round down with precision. Example: max= -3.5, precision=0  afterFormat: -3
 */ var $c168746e73e50243$var$getDecimalValue = function getDecimalValue(stringMode, decimalValue) {
    if (stringMode || decimalValue.isEmpty()) return decimalValue.toString();
    return decimalValue.toNumber();
};
var $c168746e73e50243$var$getDecimalIfValidate = function getDecimalIfValidate(value) {
    var decimal = (0, $496d321a8242e147$export$2e2bcd8739ae039)(value);
    return decimal.isInvalidate() ? null : decimal;
};
var $c168746e73e50243$var$InputNumber = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _classNames;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-input-number' : _props$prefixCls, className = props.className, style = props.style, min = props.min, max = props.max, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, defaultValue = props.defaultValue, value = props.value, disabled = props.disabled, readOnly = props.readOnly, upHandler = props.upHandler, downHandler = props.downHandler, keyboard = props.keyboard, _props$controls = props.controls, controls = _props$controls === void 0 ? true : _props$controls, stringMode = props.stringMode, parser = props.parser, formatter = props.formatter, precision = props.precision, decimalSeparator = props.decimalSeparator, onChange = props.onChange, onInput = props.onInput, onPressEnter = props.onPressEnter, onStep = props.onStep, inputProps = (0, $04RxA.default)(props, $c168746e73e50243$var$_excluded);
    var inputClassName = "".concat(prefixCls, "-input");
    var inputRef = $6fFrj.useRef(null);
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), focus = _React$useState2[0], setFocus = _React$useState2[1];
    var userTypingRef = $6fFrj.useRef(false);
    var compositionRef = $6fFrj.useRef(false);
    var shiftKeyRef = $6fFrj.useRef(false);
    // ============================ Value =============================
    // Real value control
    var _React$useState3 = $6fFrj.useState(function() {
        return (0, $496d321a8242e147$export$2e2bcd8739ae039)(value !== null && value !== void 0 ? value : defaultValue);
    }), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), decimalValue = _React$useState4[0], setDecimalValue = _React$useState4[1];
    function setUncontrolledDecimalValue(newDecimal) {
        if (value === undefined) setDecimalValue(newDecimal);
    }
    // ====================== Parser & Formatter ======================
    /**
   * `precision` is used for formatter & onChange.
   * It will auto generate by `value` & `step`.
   * But it will not block user typing.
   *
   * Note: Auto generate `precision` is used for legacy logic.
   * We should remove this since we already support high precision with BigInt.
   *
   * @param number  Provide which number should calculate precision
   * @param userTyping  Change by user typing
   */ var getPrecision = $6fFrj.useCallback(function(numStr, userTyping) {
        if (userTyping) return undefined;
        if (precision >= 0) return precision;
        return Math.max((0, $e99cf0d1e555d520$export$2e56483e4ad90ee6)(numStr), (0, $e99cf0d1e555d520$export$2e56483e4ad90ee6)(step));
    }, [
        precision,
        step
    ]);
    // >>> Parser
    var mergedParser = $6fFrj.useCallback(function(num) {
        var numStr = String(num);
        if (parser) return parser(numStr);
        var parsedStr = numStr;
        if (decimalSeparator) parsedStr = parsedStr.replace(decimalSeparator, '.');
        // [Legacy] We still support auto convert `$ 123,456` to `123456`
        return parsedStr.replace(/[^\w.-]+/g, '');
    }, [
        parser,
        decimalSeparator
    ]);
    // >>> Formatter
    var inputValueRef = $6fFrj.useRef('');
    var mergedFormatter = $6fFrj.useCallback(function(number, userTyping) {
        if (formatter) return formatter(number, {
            userTyping: userTyping,
            input: String(inputValueRef.current)
        });
        var str = typeof number === 'number' ? (0, $e99cf0d1e555d520$export$fdc98affa95a4322)(number) : number;
        // User typing will not auto format with precision directly
        if (!userTyping) {
            var mergedPrecision = getPrecision(str, userTyping);
            if ((0, $e99cf0d1e555d520$export$b3d198e17b370bec)(str) && (decimalSeparator || mergedPrecision >= 0)) {
                // Separator
                var separatorStr = decimalSeparator || '.';
                str = (0, $496d321a8242e147$export$a81f732198733497)(str, separatorStr, mergedPrecision);
            }
        }
        return str;
    }, [
        formatter,
        getPrecision,
        decimalSeparator
    ]);
    // ========================== InputValue ==========================
    /**
   * Input text value control
   *
   * User can not update input content directly. It update with follow rules by priority:
   *  1. controlled `value` changed
   *    * [SPECIAL] Typing like `1.` should not immediately convert to `1`
   *  2. User typing with format (not precision)
   *  3. Blur or Enter trigger revalidate
   */ var _React$useState5 = $6fFrj.useState(function() {
        var initValue = defaultValue !== null && defaultValue !== void 0 ? defaultValue : value;
        if (decimalValue.isInvalidate() && [
            'string',
            'number'
        ].includes((0, $5KhTJ.default)(initValue))) return Number.isNaN(initValue) ? '' : initValue;
        return mergedFormatter(decimalValue.toString(), false);
    }), _React$useState6 = (0, $jP8CL.default)(_React$useState5, 2), inputValue = _React$useState6[0], setInternalInputValue = _React$useState6[1];
    inputValueRef.current = inputValue;
    // Should always be string
    function setInputValue(newValue, userTyping) {
        setInternalInputValue(mergedFormatter(// Invalidate number is sometime passed by external control, we should let it go
        // Otherwise is controlled by internal interactive logic which check by userTyping
        // You can ref 'show limited value when input is not focused' test for more info.
        newValue.isInvalidate() ? newValue.toString(false) : newValue.toString(!userTyping), userTyping));
    }
    // >>> Max & Min limit
    var maxDecimal = $6fFrj.useMemo(function() {
        return $c168746e73e50243$var$getDecimalIfValidate(max);
    }, [
        max,
        precision
    ]);
    var minDecimal = $6fFrj.useMemo(function() {
        return $c168746e73e50243$var$getDecimalIfValidate(min);
    }, [
        min,
        precision
    ]);
    var upDisabled = $6fFrj.useMemo(function() {
        if (!maxDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return maxDecimal.lessEquals(decimalValue);
    }, [
        maxDecimal,
        decimalValue
    ]);
    var downDisabled = $6fFrj.useMemo(function() {
        if (!minDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return decimalValue.lessEquals(minDecimal);
    }, [
        minDecimal,
        decimalValue
    ]);
    // Cursor controller
    var _useCursor = (0, $d149e07c30bf2e3e$export$2e2bcd8739ae039)(inputRef.current, focus), _useCursor2 = (0, $jP8CL.default)(_useCursor, 2), recordCursor = _useCursor2[0], restoreCursor = _useCursor2[1];
    // ============================= Data =============================
    /**
   * Find target value closet within range.
   * e.g. [11, 28]:
   *    3  => 11
   *    23 => 23
   *    99 => 28
   */ var getRangeValue = function getRangeValue(target) {
        // target > max
        if (maxDecimal && !target.lessEquals(maxDecimal)) return maxDecimal;
        // target < min
        if (minDecimal && !minDecimal.lessEquals(target)) return minDecimal;
        return null;
    };
    /**
   * Check value is in [min, max] range
   */ var isInRange = function isInRange(target) {
        return !getRangeValue(target);
    };
    /**
   * Trigger `onChange` if value validated and not equals of origin.
   * Return the value that re-align in range.
   */ var triggerValueUpdate = function triggerValueUpdate(newValue, userTyping) {
        var updateValue = newValue;
        var isRangeValidate = isInRange(updateValue) || updateValue.isEmpty();
        // Skip align value when trigger value is empty.
        // We just trigger onChange(null)
        // This should not block user typing
        if (!updateValue.isEmpty() && !userTyping) {
            // Revert value in range if needed
            updateValue = getRangeValue(updateValue) || updateValue;
            isRangeValidate = true;
        }
        if (!readOnly && !disabled && isRangeValidate) {
            var numStr = updateValue.toString();
            var mergedPrecision = getPrecision(numStr, userTyping);
            if (mergedPrecision >= 0) {
                updateValue = (0, $496d321a8242e147$export$2e2bcd8739ae039)((0, $496d321a8242e147$export$a81f732198733497)(numStr, '.', mergedPrecision));
                // When to fixed. The value may out of min & max range.
                // 4 in [0, 3.8] => 3.8 => 4 (toFixed)
                if (!isInRange(updateValue)) updateValue = (0, $496d321a8242e147$export$2e2bcd8739ae039)((0, $496d321a8242e147$export$a81f732198733497)(numStr, '.', mergedPrecision, true));
            }
            // Trigger event
            if (!updateValue.equals(decimalValue)) {
                setUncontrolledDecimalValue(updateValue);
                onChange === null || onChange === void 0 || onChange(updateValue.isEmpty() ? null : $c168746e73e50243$var$getDecimalValue(stringMode, updateValue));
                // Reformat input if value is not controlled
                if (value === undefined) setInputValue(updateValue, userTyping);
            }
            return updateValue;
        }
        return decimalValue;
    };
    // ========================== User Input ==========================
    var onNextPromise = (0, $6c885b7d2236ee19$export$2e2bcd8739ae039)();
    // >>> Collect input value
    var collectInputValue = function collectInputValue(inputStr) {
        recordCursor();
        // Update inputValue incase input can not parse as number
        setInternalInputValue(inputStr);
        // Parse number
        if (!compositionRef.current) {
            var finalValue = mergedParser(inputStr);
            var finalDecimal = (0, $496d321a8242e147$export$2e2bcd8739ae039)(finalValue);
            if (!finalDecimal.isNaN()) triggerValueUpdate(finalDecimal, true);
        }
        // Trigger onInput later to let user customize value if they want do handle something after onChange
        onInput === null || onInput === void 0 || onInput(inputStr);
        // optimize for chinese input experience
        // https://github.com/ant-design/ant-design/issues/8196
        onNextPromise(function() {
            var nextInputStr = inputStr;
            if (!parser) nextInputStr = inputStr.replace(/。/g, '.');
            if (nextInputStr !== inputStr) collectInputValue(nextInputStr);
        });
    };
    // >>> Composition
    var onCompositionStart = function onCompositionStart() {
        compositionRef.current = true;
    };
    var onCompositionEnd = function onCompositionEnd() {
        compositionRef.current = false;
        collectInputValue(inputRef.current.value);
    };
    // >>> Input
    var onInternalInput = function onInternalInput(e) {
        collectInputValue(e.target.value);
    };
    // ============================= Step =============================
    var onInternalStep = function onInternalStep(up) {
        var _inputRef$current;
        // Ignore step since out of range
        if (up && upDisabled || !up && downDisabled) return;
        // Clear typing status since it may caused by up & down key.
        // We should sync with input value.
        userTypingRef.current = false;
        var stepDecimal = (0, $496d321a8242e147$export$2e2bcd8739ae039)(shiftKeyRef.current ? (0, $e99cf0d1e555d520$export$d2883c6c6307c415)(step) : step);
        if (!up) stepDecimal = stepDecimal.negate();
        var target = (decimalValue || (0, $496d321a8242e147$export$2e2bcd8739ae039)(0)).add(stepDecimal.toString());
        var updatedValue = triggerValueUpdate(target, false);
        onStep === null || onStep === void 0 || onStep($c168746e73e50243$var$getDecimalValue(stringMode, updatedValue), {
            offset: shiftKeyRef.current ? (0, $e99cf0d1e555d520$export$d2883c6c6307c415)(step) : step,
            type: up ? 'up' : 'down'
        });
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    };
    // ============================ Flush =============================
    /**
   * Flush current input content to trigger value change & re-formatter input if needed
   */ var flushInputValue = function flushInputValue(userTyping) {
        var parsedValue = (0, $496d321a8242e147$export$2e2bcd8739ae039)(mergedParser(inputValue));
        var formatValue = parsedValue;
        if (!parsedValue.isNaN()) // Only validate value or empty value can be re-fill to inputValue
        // Reassign the formatValue within ranged of trigger control
        formatValue = triggerValueUpdate(parsedValue, userTyping);
        else formatValue = decimalValue;
        if (value !== undefined) // Reset back with controlled value first
        setInputValue(decimalValue, false);
        else if (!formatValue.isNaN()) // Reset input back since no validate value
        setInputValue(formatValue, false);
    };
    // Solve the issue of the event triggering sequence when entering numbers in chinese input (Safari)
    var onBeforeInput = function onBeforeInput() {
        userTypingRef.current = true;
    };
    var onKeyDown = function onKeyDown(event) {
        var which = event.which, shiftKey = event.shiftKey;
        userTypingRef.current = true;
        if (shiftKey) shiftKeyRef.current = true;
        else shiftKeyRef.current = false;
        if (which === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER) {
            if (!compositionRef.current) userTypingRef.current = false;
            flushInputValue(false);
            onPressEnter === null || onPressEnter === void 0 || onPressEnter(event);
        }
        if (keyboard === false) return;
        // Do step
        if (!compositionRef.current && [
            (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).UP,
            (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).DOWN
        ].includes(which)) {
            onInternalStep((0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).UP === which);
            event.preventDefault();
        }
    };
    var onKeyUp = function onKeyUp() {
        userTypingRef.current = false;
        shiftKeyRef.current = false;
    };
    // >>> Focus & Blur
    var onBlur = function onBlur() {
        flushInputValue(false);
        setFocus(false);
        userTypingRef.current = false;
    };
    // ========================== Controlled ==========================
    // Input by precision
    (0, $dNZA9.useLayoutUpdateEffect)(function() {
        if (!decimalValue.isInvalidate()) setInputValue(decimalValue, false);
    }, [
        precision
    ]);
    // Input by value
    (0, $dNZA9.useLayoutUpdateEffect)(function() {
        var newValue = (0, $496d321a8242e147$export$2e2bcd8739ae039)(value);
        setDecimalValue(newValue);
        var currentParsedValue = (0, $496d321a8242e147$export$2e2bcd8739ae039)(mergedParser(inputValue));
        // When user typing from `1.2` to `1.`, we should not convert to `1` immediately.
        // But let it go if user set `formatter`
        if (!newValue.equals(currentParsedValue) || !userTypingRef.current || formatter) // Update value as effect
        setInputValue(newValue, userTypingRef.current);
    }, [
        value
    ]);
    // ============================ Cursor ============================
    (0, $dNZA9.useLayoutUpdateEffect)(function() {
        if (formatter) restoreCursor();
    }, [
        inputValue
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(prefixCls, "-focused"), focus), (0, $43449.default)(_classNames, "".concat(prefixCls, "-disabled"), disabled), (0, $43449.default)(_classNames, "".concat(prefixCls, "-readonly"), readOnly), (0, $43449.default)(_classNames, "".concat(prefixCls, "-not-a-number"), decimalValue.isNaN()), (0, $43449.default)(_classNames, "".concat(prefixCls, "-out-of-range"), !decimalValue.isInvalidate() && !isInRange(decimalValue)), _classNames)),
        style: style,
        onFocus: function onFocus() {
            setFocus(true);
        },
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBeforeInput: onBeforeInput
    }, controls && /*#__PURE__*/ $6fFrj.createElement((0, $dea39b3c679058b1$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        upNode: upHandler,
        downNode: downHandler,
        upDisabled: upDisabled,
        downDisabled: downDisabled,
        onStep: onInternalStep
    }), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(inputClassName, "-wrap")
    }, /*#__PURE__*/ $6fFrj.createElement("input", (0, $fIrcP.default)({
        autoComplete: "off",
        role: "spinbutton",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": decimalValue.isInvalidate() ? null : decimalValue.toString(),
        step: step
    }, inputProps, {
        ref: (0, $3BOWT.composeRef)(inputRef, ref),
        className: inputClassName,
        value: inputValue,
        onChange: onInternalInput,
        disabled: disabled,
        readOnly: readOnly
    }))));
});
$c168746e73e50243$var$InputNumber.displayName = 'InputNumber';
var $c168746e73e50243$export$2e2bcd8739ae039 = $c168746e73e50243$var$InputNumber;


var $0563bed5edb34718$export$2e2bcd8739ae039 = (0, $c168746e73e50243$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");







var $4d58e046767e1c41$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4d58e046767e1c41$var$InputNumber = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var size = $6fFrj.useContext((0, $aefad26b74860b7e$export$2e2bcd8739ae039));
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), focused = _React$useState2[0], setFocus = _React$useState2[1];
    var inputRef = $6fFrj.useRef(null);
    $6fFrj.useImperativeHandle(ref, function() {
        return inputRef.current;
    });
    var className = props.className, customizeSize = props.size, customDisabled = props.disabled, customizePrefixCls = props.prefixCls, addonBefore = props.addonBefore, addonAfter = props.addonAfter, prefix = props.prefix, _props$bordered = props.bordered, bordered = _props$bordered === void 0 ? true : _props$bordered, readOnly = props.readOnly, customStatus = props.status, controls = props.controls, others = $4d58e046767e1c41$var$__rest(props, [
        "className",
        "size",
        "disabled",
        "prefixCls",
        "addonBefore",
        "addonAfter",
        "prefix",
        "bordered",
        "readOnly",
        "status",
        "controls"
    ]);
    var prefixCls = getPrefixCls('input-number', customizePrefixCls);
    var _useCompactItemContex = (0, $87f4fe035d0a15fd$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    var upIcon = /*#__PURE__*/ $6fFrj.createElement((0, $630d786a8c58d6ad$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-handler-up-inner")
    });
    var downIcon = /*#__PURE__*/ $6fFrj.createElement((0, $344ef0cbd3adff87$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-handler-down-inner")
    });
    var controlsTemp = typeof controls === 'boolean' ? controls : undefined;
    if ((0, $5KhTJ.default)(controls) === 'object') {
        upIcon = typeof controls.upIcon === 'undefined' ? upIcon : /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-handler-up-inner")
        }, controls.upIcon);
        downIcon = typeof controls.downIcon === 'undefined' ? downIcon : /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-handler-down-inner")
        }, controls.downIcon);
    }
    var _useContext = (0, $6fFrj.useContext)((0, $76d69cb8326089c6$export$bbb5553c6c7a14ed)), hasFeedback = _useContext.hasFeedback, contextStatus = _useContext.status, isFormItemInput = _useContext.isFormItemInput, feedbackIcon = _useContext.feedbackIcon;
    var mergedStatus = (0, $d372c831fd1c9007$export$314e193082d7ba49)(contextStatus, customStatus);
    var mergeSize = compactSize || customizeSize || size;
    // ===================== Disabled =====================
    var disabled = $6fFrj.useContext((0, $3880af76d17f94a3$export$2e2bcd8739ae039));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var inputNumberClass = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-lg"), mergeSize === 'large'), "".concat(prefixCls, "-sm"), mergeSize === 'small'), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-borderless"), !bordered), "".concat(prefixCls, "-in-form-item"), isFormItemInput), (0, $d372c831fd1c9007$export$b08e7b47149942a2)(prefixCls, mergedStatus), compactItemClassnames, className);
    var element = /*#__PURE__*/ $6fFrj.createElement((0, $0563bed5edb34718$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        ref: inputRef,
        disabled: mergedDisabled,
        className: inputNumberClass,
        upHandler: upIcon,
        downHandler: downIcon,
        prefixCls: prefixCls,
        readOnly: readOnly,
        controls: controlsTemp
    }, others));
    if (prefix != null || hasFeedback) {
        var affixWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-affix-wrapper"), (0, $d372c831fd1c9007$export$b08e7b47149942a2)("".concat(prefixCls, "-affix-wrapper"), mergedStatus, hasFeedback), (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-affix-wrapper-focused"), focused), "".concat(prefixCls, "-affix-wrapper-disabled"), props.disabled), "".concat(prefixCls, "-affix-wrapper-sm"), size === 'small'), "".concat(prefixCls, "-affix-wrapper-lg"), size === 'large'), "".concat(prefixCls, "-affix-wrapper-rtl"), direction === 'rtl'), "".concat(prefixCls, "-affix-wrapper-readonly"), readOnly), "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), "".concat(className), !(addonBefore || addonAfter) && className));
        element = /*#__PURE__*/ $6fFrj.createElement("div", {
            className: affixWrapperCls,
            style: props.style,
            onMouseUp: function onMouseUp() {
                return inputRef.current.focus();
            }
        }, prefix && /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-prefix")
        }, prefix), (0, $79365009d9b77ac6$export$e530037191fcd5d7)(element, {
            style: null,
            value: props.value,
            onFocus: function onFocus(event) {
                var _a;
                setFocus(true);
                (_a = props.onFocus) === null || _a === void 0 || _a.call(props, event);
            },
            onBlur: function onBlur(event) {
                var _a;
                setFocus(false);
                (_a = props.onBlur) === null || _a === void 0 || _a.call(props, event);
            }
        }), hasFeedback && /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-suffix")
        }, feedbackIcon));
    }
    if (addonBefore != null || addonAfter != null) {
        var wrapperClassName = "".concat(prefixCls, "-group");
        var addonClassName = "".concat(wrapperClassName, "-addon");
        var addonBeforeNode = addonBefore ? /*#__PURE__*/ $6fFrj.createElement("div", {
            className: addonClassName
        }, addonBefore) : null;
        var addonAfterNode = addonAfter ? /*#__PURE__*/ $6fFrj.createElement("div", {
            className: addonClassName
        }, addonAfter) : null;
        var mergedWrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-wrapper"), wrapperClassName, (0, $43449.default)({}, "".concat(wrapperClassName, "-rtl"), direction === 'rtl'));
        var mergedGroupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-group-wrapper"), (0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-group-wrapper-sm"), size === 'small'), "".concat(prefixCls, "-group-wrapper-lg"), size === 'large'), "".concat(prefixCls, "-group-wrapper-rtl"), direction === 'rtl'), (0, $d372c831fd1c9007$export$b08e7b47149942a2)("".concat(prefixCls, "-group-wrapper"), mergedStatus, hasFeedback), className);
        element = /*#__PURE__*/ $6fFrj.createElement("div", {
            className: mergedGroupClassName,
            style: props.style
        }, /*#__PURE__*/ $6fFrj.createElement("div", {
            className: mergedWrapperClassName
        }, addonBeforeNode && /*#__PURE__*/ $6fFrj.createElement((0, $87f4fe035d0a15fd$export$5f56e610a4afb685), null, /*#__PURE__*/ $6fFrj.createElement((0, $76d69cb8326089c6$export$80e4c53cb85dcab1), {
            status: true,
            override: true
        }, addonBeforeNode)), (0, $79365009d9b77ac6$export$e530037191fcd5d7)(element, {
            style: null,
            disabled: mergedDisabled
        }), addonAfterNode && /*#__PURE__*/ $6fFrj.createElement((0, $87f4fe035d0a15fd$export$5f56e610a4afb685), null, /*#__PURE__*/ $6fFrj.createElement((0, $76d69cb8326089c6$export$80e4c53cb85dcab1), {
            status: true,
            override: true
        }, addonAfterNode))));
    }
    return element;
});
var $4d58e046767e1c41$export$2e2bcd8739ae039 = $4d58e046767e1c41$var$InputNumber;


var $37xND = parcelRequire("37xND");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $5KhTJ = parcelRequire("5KhTJ");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");


var $94fec351dda17415$var$defaultRenderEmpty = function defaultRenderEmpty(componentName) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $1bdb4c3de815e386$export$cd5442f2b8da7663), null, function(_ref) {
        var getPrefixCls = _ref.getPrefixCls;
        var prefix = getPrefixCls('empty');
        switch(componentName){
            case 'Table':
            case 'List':
                return /*#__PURE__*/ $6fFrj.createElement((0, $9150234f0969a884$export$2e2bcd8739ae039), {
                    image: (0, $9150234f0969a884$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE
                });
            case 'Select':
            case 'TreeSelect':
            case 'Cascader':
            case 'Transfer':
            case 'Mentions':
                return /*#__PURE__*/ $6fFrj.createElement((0, $9150234f0969a884$export$2e2bcd8739ae039), {
                    image: (0, $9150234f0969a884$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                    className: "".concat(prefix, "-small")
                });
            /* istanbul ignore next */ default:
                // Should never hit if we take all the component into consider.
                return /*#__PURE__*/ $6fFrj.createElement((0, $9150234f0969a884$export$2e2bcd8739ae039), null);
        }
    });
};
var $94fec351dda17415$export$2e2bcd8739ae039 = $94fec351dda17415$var$defaultRenderEmpty;





var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $629403316931ff3d$var$DoubleLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
                }
            }
        ]
    },
    "name": "double-left",
    "theme": "outlined"
};
var $629403316931ff3d$export$2e2bcd8739ae039 = $629403316931ff3d$var$DoubleLeftOutlined;



var $054e84529e7e99ee$var$DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $629403316931ff3d$export$2e2bcd8739ae039)
    }));
};
var $054e84529e7e99ee$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($054e84529e7e99ee$var$DoubleLeftOutlined);
var $054e84529e7e99ee$export$2e2bcd8739ae039 = $054e84529e7e99ee$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $8406005f7b3aa9b5$var$DoubleRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
                }
            }
        ]
    },
    "name": "double-right",
    "theme": "outlined"
};
var $8406005f7b3aa9b5$export$2e2bcd8739ae039 = $8406005f7b3aa9b5$var$DoubleRightOutlined;



var $9edb2f28b9e902c3$var$DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $8406005f7b3aa9b5$export$2e2bcd8739ae039)
    }));
};
var $9edb2f28b9e902c3$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($9edb2f28b9e902c3$var$DoubleRightOutlined);
var $9edb2f28b9e902c3$export$2e2bcd8739ae039 = $9edb2f28b9e902c3$var$RefIcon;





var $fActo = parcelRequire("fActo");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");
var $e109829a48a92317$var$Pager = function Pager(props) {
    var _classNames;
    var prefixCls = "".concat(props.rootPrefixCls, "-item");
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-").concat(props.page), (_classNames = {}, (0, $43449.default)(_classNames, "".concat(prefixCls, "-active"), props.active), (0, $43449.default)(_classNames, "".concat(prefixCls, "-disabled"), !props.page), (0, $43449.default)(_classNames, props.className, !!props.className), _classNames));
    var handleClick = function handleClick() {
        props.onClick(props.page);
    };
    var handleKeyPress = function handleKeyPress(e) {
        props.onKeyPress(e, props.onClick, props.page);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("li", {
        title: props.showTitle ? props.page : null,
        className: cls,
        onClick: handleClick,
        onKeyPress: handleKeyPress,
        tabIndex: "0"
    }, props.itemRender(props.page, 'page', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("a", {
        rel: "nofollow"
    }, props.page)));
};
var $e109829a48a92317$export$2e2bcd8739ae039 = $e109829a48a92317$var$Pager;



var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $6fFrj = parcelRequire("6fFrj");
var $6240422de1ca2201$export$2e2bcd8739ae039 = {
    ZERO: 48,
    NINE: 57,
    NUMPAD_ZERO: 96,
    NUMPAD_NINE: 105,
    BACKSPACE: 8,
    DELETE: 46,
    ENTER: 13,
    ARROW_UP: 38,
    ARROW_DOWN: 40
};


var $1419333dc6c46093$var$Options = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(Options, _React$Component);
    var _super = (0, $lSufv.default)(Options);
    function Options() {
        var _this;
        (0, $kjNeN.default)(this, Options);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            goInputText: ''
        };
        _this.buildOptionText = function(value) {
            return "".concat(value, " ").concat(_this.props.locale.items_per_page);
        };
        _this.changeSize = function(value) {
            _this.props.changeSize(Number(value));
        };
        _this.handleChange = function(e) {
            _this.setState({
                goInputText: e.target.value
            });
        };
        _this.handleBlur = function(e) {
            var _this$props = _this.props, goButton = _this$props.goButton, quickGo = _this$props.quickGo, rootPrefixCls = _this$props.rootPrefixCls;
            var goInputText = _this.state.goInputText;
            if (goButton || goInputText === '') return;
            _this.setState({
                goInputText: ''
            });
            if (e.relatedTarget && (e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item-link")) >= 0 || e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item")) >= 0)) return;
            quickGo(_this.getValidValue());
        };
        _this.go = function(e) {
            var goInputText = _this.state.goInputText;
            if (goInputText === '') return;
            if (e.keyCode === (0, $6240422de1ca2201$export$2e2bcd8739ae039).ENTER || e.type === 'click') {
                _this.setState({
                    goInputText: ''
                });
                _this.props.quickGo(_this.getValidValue());
            }
        };
        return _this;
    }
    (0, $5KQxu.default)(Options, [
        {
            key: "getValidValue",
            value: function getValidValue() {
                var goInputText = this.state.goInputText;
                // eslint-disable-next-line no-restricted-globals
                return !goInputText || isNaN(goInputText) ? undefined : Number(goInputText);
            }
        },
        {
            key: "getPageSizeOptions",
            value: function getPageSizeOptions() {
                var _this$props2 = this.props, pageSize = _this$props2.pageSize, pageSizeOptions = _this$props2.pageSizeOptions;
                if (pageSizeOptions.some(function(option) {
                    return option.toString() === pageSize.toString();
                })) return pageSizeOptions;
                return pageSizeOptions.concat([
                    pageSize.toString()
                ]).sort(function(a, b) {
                    // eslint-disable-next-line no-restricted-globals
                    var numberA = isNaN(Number(a)) ? 0 : Number(a);
                    // eslint-disable-next-line no-restricted-globals
                    var numberB = isNaN(Number(b)) ? 0 : Number(b);
                    return numberA - numberB;
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, pageSize = _this$props3.pageSize, locale = _this$props3.locale, rootPrefixCls = _this$props3.rootPrefixCls, changeSize = _this$props3.changeSize, quickGo = _this$props3.quickGo, goButton = _this$props3.goButton, selectComponentClass = _this$props3.selectComponentClass, buildOptionText = _this$props3.buildOptionText, selectPrefixCls = _this$props3.selectPrefixCls, disabled = _this$props3.disabled;
                var goInputText = this.state.goInputText;
                var prefixCls = "".concat(rootPrefixCls, "-options");
                var Select = selectComponentClass;
                var changeSelect = null;
                var goInput = null;
                var gotoButton = null;
                if (!changeSize && !quickGo) return null;
                var pageSizeOptions = this.getPageSizeOptions();
                if (changeSize && Select) {
                    var options = pageSizeOptions.map(function(opt, i) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Select.Option, {
                            key: i,
                            value: opt.toString()
                        }, (buildOptionText || _this2.buildOptionText)(opt));
                    });
                    changeSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Select, {
                        disabled: disabled,
                        prefixCls: selectPrefixCls,
                        showSearch: false,
                        className: "".concat(prefixCls, "-size-changer"),
                        optionLabelProp: "children",
                        dropdownMatchSelectWidth: false,
                        value: (pageSize || pageSizeOptions[0]).toString(),
                        onChange: this.changeSize,
                        getPopupContainer: function getPopupContainer(triggerNode) {
                            return triggerNode.parentNode;
                        },
                        "aria-label": locale.page_size,
                        defaultOpen: false
                    }, options);
                }
                if (quickGo) {
                    if (goButton) gotoButton = typeof goButton === 'boolean' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
                        type: "button",
                        onClick: this.go,
                        onKeyUp: this.go,
                        disabled: disabled,
                        className: "".concat(prefixCls, "-quick-jumper-button")
                    }, locale.jump_to_confirm) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
                        onClick: this.go,
                        onKeyUp: this.go
                    }, goButton);
                    goInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                        className: "".concat(prefixCls, "-quick-jumper")
                    }, locale.jump_to, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("input", {
                        disabled: disabled,
                        type: "text",
                        value: goInputText,
                        onChange: this.handleChange,
                        onKeyUp: this.go,
                        onBlur: this.handleBlur,
                        "aria-label": locale.page
                    }), locale.page, gotoButton);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("li", {
                    className: "".concat(prefixCls)
                }, changeSelect, goInput);
            }
        }
    ]);
    return Options;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
$1419333dc6c46093$var$Options.defaultProps = {
    pageSizeOptions: [
        '10',
        '20',
        '50',
        '100'
    ]
};
var $1419333dc6c46093$export$2e2bcd8739ae039 = $1419333dc6c46093$var$Options;



var $ccfe296b815b019a$export$2e2bcd8739ae039 = {
    // Options.jsx
    items_per_page: "\u6761/\u9875",
    jump_to: "\u8DF3\u81F3",
    jump_to_confirm: "\u786E\u5B9A",
    page: "\u9875",
    // Pagination.jsx
    prev_page: "\u4E0A\u4E00\u9875",
    next_page: "\u4E0B\u4E00\u9875",
    prev_5: "\u5411\u524D 5 \u9875",
    next_5: "\u5411\u540E 5 \u9875",
    prev_3: "\u5411\u524D 3 \u9875",
    next_3: "\u5411\u540E 3 \u9875",
    page_size: "\u9875\u7801"
};


function $9b82f0e1c8fbf9ac$var$noop() {}
function $9b82f0e1c8fbf9ac$var$isInteger(v) {
    var value = Number(v);
    return(// eslint-disable-next-line no-restricted-globals
    typeof value === 'number' && !isNaN(value) && isFinite(value) && Math.floor(value) === value);
}
function $9b82f0e1c8fbf9ac$var$defaultItemRender(page, type, element) {
    return element;
}
function $9b82f0e1c8fbf9ac$var$calculatePage(p, state, props) {
    var pageSize = typeof p === 'undefined' ? state.pageSize : p;
    return Math.floor((props.total - 1) / pageSize) + 1;
}
var $9b82f0e1c8fbf9ac$var$Pagination = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(Pagination, _React$Component);
    var _super = (0, $lSufv.default)(Pagination);
    function Pagination(props) {
        var _this;
        (0, $kjNeN.default)(this, Pagination);
        _this = _super.call(this, props);
        _this.getJumpPrevPage = function() {
            return Math.max(1, _this.state.current - (_this.props.showLessItems ? 3 : 5));
        };
        _this.getJumpNextPage = function() {
            return Math.min($9b82f0e1c8fbf9ac$var$calculatePage(undefined, _this.state, _this.props), _this.state.current + (_this.props.showLessItems ? 3 : 5));
        };
        _this.getItemIcon = function(icon, label) {
            var prefixCls = _this.props.prefixCls;
            var iconNode = icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
                type: "button",
                "aria-label": label,
                className: "".concat(prefixCls, "-item-link")
            });
            if (typeof icon === 'function') iconNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(icon, (0, $kNxFX.default)({}, _this.props));
            return iconNode;
        };
        _this.savePaginationNode = function(node) {
            _this.paginationNode = node;
        };
        _this.isValid = function(page) {
            var total = _this.props.total;
            return $9b82f0e1c8fbf9ac$var$isInteger(page) && page !== _this.state.current && $9b82f0e1c8fbf9ac$var$isInteger(total) && total > 0;
        };
        _this.shouldDisplayQuickJumper = function() {
            var _this$props = _this.props, showQuickJumper = _this$props.showQuickJumper, total = _this$props.total;
            var pageSize = _this.state.pageSize;
            if (total <= pageSize) return false;
            return showQuickJumper;
        };
        _this.handleKeyDown = function(e) {
            if (e.keyCode === (0, $6240422de1ca2201$export$2e2bcd8739ae039).ARROW_UP || e.keyCode === (0, $6240422de1ca2201$export$2e2bcd8739ae039).ARROW_DOWN) e.preventDefault();
        };
        _this.handleKeyUp = function(e) {
            var value = _this.getValidValue(e);
            var currentInputValue = _this.state.currentInputValue;
            if (value !== currentInputValue) _this.setState({
                currentInputValue: value
            });
            if (e.keyCode === (0, $6240422de1ca2201$export$2e2bcd8739ae039).ENTER) _this.handleChange(value);
            else if (e.keyCode === (0, $6240422de1ca2201$export$2e2bcd8739ae039).ARROW_UP) _this.handleChange(value - 1);
            else if (e.keyCode === (0, $6240422de1ca2201$export$2e2bcd8739ae039).ARROW_DOWN) _this.handleChange(value + 1);
        };
        _this.handleBlur = function(e) {
            var value = _this.getValidValue(e);
            _this.handleChange(value);
        };
        _this.changePageSize = function(size) {
            var current = _this.state.current;
            var newCurrent = $9b82f0e1c8fbf9ac$var$calculatePage(size, _this.state, _this.props);
            current = current > newCurrent ? newCurrent : current;
            // fix the issue:
            // Once 'total' is 0, 'current' in 'onShowSizeChange' is 0, which is not correct.
            if (newCurrent === 0) // eslint-disable-next-line prefer-destructuring
            current = _this.state.current;
            if (typeof size === 'number') {
                if (!('pageSize' in _this.props)) _this.setState({
                    pageSize: size
                });
                if (!('current' in _this.props)) _this.setState({
                    current: current,
                    currentInputValue: current
                });
            }
            _this.props.onShowSizeChange(current, size);
            if ('onChange' in _this.props && _this.props.onChange) _this.props.onChange(current, size);
        };
        _this.handleChange = function(page) {
            var _this$props2 = _this.props, disabled = _this$props2.disabled, onChange = _this$props2.onChange;
            var _this$state = _this.state, pageSize = _this$state.pageSize, current = _this$state.current, currentInputValue = _this$state.currentInputValue;
            if (_this.isValid(page) && !disabled) {
                var currentPage = $9b82f0e1c8fbf9ac$var$calculatePage(undefined, _this.state, _this.props);
                var newPage = page;
                if (page > currentPage) newPage = currentPage;
                else if (page < 1) newPage = 1;
                if (!('current' in _this.props)) _this.setState({
                    current: newPage
                });
                if (newPage !== currentInputValue) _this.setState({
                    currentInputValue: newPage
                });
                onChange(newPage, pageSize);
                return newPage;
            }
            return current;
        };
        _this.prev = function() {
            if (_this.hasPrev()) _this.handleChange(_this.state.current - 1);
        };
        _this.next = function() {
            if (_this.hasNext()) _this.handleChange(_this.state.current + 1);
        };
        _this.jumpPrev = function() {
            _this.handleChange(_this.getJumpPrevPage());
        };
        _this.jumpNext = function() {
            _this.handleChange(_this.getJumpNextPage());
        };
        _this.hasPrev = function() {
            return _this.state.current > 1;
        };
        _this.hasNext = function() {
            return _this.state.current < $9b82f0e1c8fbf9ac$var$calculatePage(undefined, _this.state, _this.props);
        };
        _this.runIfEnter = function(event, callback) {
            if (event.key === 'Enter' || event.charCode === 13) {
                for(var _len = arguments.length, restParams = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)restParams[_key - 2] = arguments[_key];
                callback.apply(void 0, restParams);
            }
        };
        _this.runIfEnterPrev = function(e) {
            _this.runIfEnter(e, _this.prev);
        };
        _this.runIfEnterNext = function(e) {
            _this.runIfEnter(e, _this.next);
        };
        _this.runIfEnterJumpPrev = function(e) {
            _this.runIfEnter(e, _this.jumpPrev);
        };
        _this.runIfEnterJumpNext = function(e) {
            _this.runIfEnter(e, _this.jumpNext);
        };
        _this.handleGoTO = function(e) {
            if (e.keyCode === (0, $6240422de1ca2201$export$2e2bcd8739ae039).ENTER || e.type === 'click') _this.handleChange(_this.state.currentInputValue);
        };
        var hasOnChange = props.onChange !== $9b82f0e1c8fbf9ac$var$noop;
        var hasCurrent = 'current' in props;
        if (hasCurrent && !hasOnChange) // eslint-disable-next-line no-console
        console.warn('Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.');
        var _current = props.defaultCurrent;
        if ('current' in props) // eslint-disable-next-line prefer-destructuring
        _current = props.current;
        var _pageSize = props.defaultPageSize;
        if ('pageSize' in props) // eslint-disable-next-line prefer-destructuring
        _pageSize = props.pageSize;
        _current = Math.min(_current, $9b82f0e1c8fbf9ac$var$calculatePage(_pageSize, undefined, props));
        _this.state = {
            current: _current,
            currentInputValue: _current,
            pageSize: _pageSize
        };
        return _this;
    }
    (0, $5KQxu.default)(Pagination, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                // When current page change, fix focused style of prev item
                // A hacky solution of https://github.com/ant-design/ant-design/issues/8948
                var prefixCls = this.props.prefixCls;
                if (prevState.current !== this.state.current && this.paginationNode) {
                    var lastCurrentNode = this.paginationNode.querySelector(".".concat(prefixCls, "-item-").concat(prevState.current));
                    if (lastCurrentNode && document.activeElement === lastCurrentNode) lastCurrentNode.blur();
                }
            }
        },
        {
            key: "getValidValue",
            value: function getValidValue(e) {
                var inputValue = e.target.value;
                var allPages = $9b82f0e1c8fbf9ac$var$calculatePage(undefined, this.state, this.props);
                var currentInputValue = this.state.currentInputValue;
                var value;
                if (inputValue === '') value = inputValue;
                else if (isNaN(Number(inputValue))) value = currentInputValue;
                else if (inputValue >= allPages) value = allPages;
                else value = Number(inputValue);
                return value;
            }
        },
        {
            key: "getShowSizeChanger",
            value: function getShowSizeChanger() {
                var _this$props3 = this.props, showSizeChanger = _this$props3.showSizeChanger, total = _this$props3.total, totalBoundaryShowSizeChanger = _this$props3.totalBoundaryShowSizeChanger;
                if (typeof showSizeChanger !== 'undefined') return showSizeChanger;
                return total > totalBoundaryShowSizeChanger;
            }
        },
        {
            key: "renderPrev",
            value: function renderPrev(prevPage) {
                var _this$props4 = this.props, prevIcon = _this$props4.prevIcon, itemRender = _this$props4.itemRender;
                var prevButton = itemRender(prevPage, 'prev', this.getItemIcon(prevIcon, 'prev page'));
                var disabled = !this.hasPrev();
                return /*#__PURE__*/ (0, $6fFrj.isValidElement)(prevButton) ? /*#__PURE__*/ (0, $6fFrj.cloneElement)(prevButton, {
                    disabled: disabled
                }) : prevButton;
            }
        },
        {
            key: "renderNext",
            value: function renderNext(nextPage) {
                var _this$props5 = this.props, nextIcon = _this$props5.nextIcon, itemRender = _this$props5.itemRender;
                var nextButton = itemRender(nextPage, 'next', this.getItemIcon(nextIcon, 'next page'));
                var disabled = !this.hasNext();
                return /*#__PURE__*/ (0, $6fFrj.isValidElement)(nextButton) ? /*#__PURE__*/ (0, $6fFrj.cloneElement)(nextButton, {
                    disabled: disabled
                }) : nextButton;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props6 = this.props, prefixCls = _this$props6.prefixCls, className = _this$props6.className, style = _this$props6.style, disabled = _this$props6.disabled, hideOnSinglePage = _this$props6.hideOnSinglePage, total = _this$props6.total, locale = _this$props6.locale, showQuickJumper = _this$props6.showQuickJumper, showLessItems = _this$props6.showLessItems, showTitle = _this$props6.showTitle, showTotal = _this$props6.showTotal, simple = _this$props6.simple, itemRender = _this$props6.itemRender, showPrevNextJumpers = _this$props6.showPrevNextJumpers, jumpPrevIcon = _this$props6.jumpPrevIcon, jumpNextIcon = _this$props6.jumpNextIcon, selectComponentClass = _this$props6.selectComponentClass, selectPrefixCls = _this$props6.selectPrefixCls, pageSizeOptions = _this$props6.pageSizeOptions;
                var _this$state2 = this.state, current = _this$state2.current, pageSize = _this$state2.pageSize, currentInputValue = _this$state2.currentInputValue;
                // When hideOnSinglePage is true and there is only 1 page, hide the pager
                if (hideOnSinglePage === true && total <= pageSize) return null;
                var allPages = $9b82f0e1c8fbf9ac$var$calculatePage(undefined, this.state, this.props);
                var pagerList = [];
                var jumpPrev = null;
                var jumpNext = null;
                var firstPager = null;
                var lastPager = null;
                var gotoButton = null;
                var goButton = showQuickJumper && showQuickJumper.goButton;
                var pageBufferSize = showLessItems ? 1 : 2;
                var prevPage = current - 1 > 0 ? current - 1 : 0;
                var nextPage = current + 1 < allPages ? current + 1 : allPages;
                var dataOrAriaAttributeProps = Object.keys(this.props).reduce(function(prev, key) {
                    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') // eslint-disable-next-line no-param-reassign
                    prev[key] = _this2.props[key];
                    return prev;
                }, {});
                var totalText = showTotal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("li", {
                    className: "".concat(prefixCls, "-total-text")
                }, showTotal(total, [
                    total === 0 ? 0 : (current - 1) * pageSize + 1,
                    current * pageSize > total ? total : current * pageSize
                ]));
                if (simple) {
                    if (goButton) {
                        if (typeof goButton === 'boolean') gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
                            type: "button",
                            onClick: this.handleGoTO,
                            onKeyUp: this.handleGoTO
                        }, locale.jump_to_confirm);
                        else gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
                            onClick: this.handleGoTO,
                            onKeyUp: this.handleGoTO
                        }, goButton);
                        gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("li", {
                            title: showTitle ? "".concat(locale.jump_to).concat(current, "/").concat(allPages) : null,
                            className: "".concat(prefixCls, "-simple-pager")
                        }, gotoButton);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("ul", (0, $fIrcP.default)({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-simple"), (0, $43449.default)({}, "".concat(prefixCls, "-disabled"), disabled), className),
                        style: style,
                        ref: this.savePaginationNode
                    }, dataOrAriaAttributeProps), totalText, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("li", {
                        title: showTitle ? locale.prev_page : null,
                        onClick: this.prev,
                        tabIndex: this.hasPrev() ? 0 : null,
                        onKeyPress: this.runIfEnterPrev,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-prev"), (0, $43449.default)({}, "".concat(prefixCls, "-disabled"), !this.hasPrev())),
                        "aria-disabled": !this.hasPrev()
                    }, this.renderPrev(prevPage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("li", {
                        title: showTitle ? "".concat(current, "/").concat(allPages) : null,
                        className: "".concat(prefixCls, "-simple-pager")
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("input", {
                        type: "text",
                        value: currentInputValue,
                        disabled: disabled,
                        onKeyDown: this.handleKeyDown,
                        onKeyUp: this.handleKeyUp,
                        onChange: this.handleKeyUp,
                        onBlur: this.handleBlur,
                        size: "3"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
                        className: "".concat(prefixCls, "-slash")
                    }, "/"), allPages), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("li", {
                        title: showTitle ? locale.next_page : null,
                        onClick: this.next,
                        tabIndex: this.hasPrev() ? 0 : null,
                        onKeyPress: this.runIfEnterNext,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-next"), (0, $43449.default)({}, "".concat(prefixCls, "-disabled"), !this.hasNext())),
                        "aria-disabled": !this.hasNext()
                    }, this.renderNext(nextPage)), gotoButton);
                }
                if (allPages <= 3 + pageBufferSize * 2) {
                    var pagerProps = {
                        locale: locale,
                        rootPrefixCls: prefixCls,
                        onClick: this.handleChange,
                        onKeyPress: this.runIfEnter,
                        showTitle: showTitle,
                        itemRender: itemRender
                    };
                    if (!allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $e109829a48a92317$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, pagerProps, {
                        key: "noPager",
                        page: 1,
                        className: "".concat(prefixCls, "-item-disabled")
                    })));
                    for(var i = 1; i <= allPages; i += 1){
                        var active = current === i;
                        pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $e109829a48a92317$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, pagerProps, {
                            key: i,
                            page: i,
                            active: active
                        })));
                    }
                } else {
                    var prevItemTitle = showLessItems ? locale.prev_3 : locale.prev_5;
                    var nextItemTitle = showLessItems ? locale.next_3 : locale.next_5;
                    if (showPrevNextJumpers) {
                        jumpPrev = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("li", {
                            title: showTitle ? prevItemTitle : null,
                            key: "prev",
                            onClick: this.jumpPrev,
                            tabIndex: "0",
                            onKeyPress: this.runIfEnterJumpPrev,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-jump-prev"), (0, $43449.default)({}, "".concat(prefixCls, "-jump-prev-custom-icon"), !!jumpPrevIcon))
                        }, itemRender(this.getJumpPrevPage(), 'jump-prev', this.getItemIcon(jumpPrevIcon, 'prev page')));
                        jumpNext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("li", {
                            title: showTitle ? nextItemTitle : null,
                            key: "next",
                            tabIndex: "0",
                            onClick: this.jumpNext,
                            onKeyPress: this.runIfEnterJumpNext,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-jump-next"), (0, $43449.default)({}, "".concat(prefixCls, "-jump-next-custom-icon"), !!jumpNextIcon))
                        }, itemRender(this.getJumpNextPage(), 'jump-next', this.getItemIcon(jumpNextIcon, 'next page')));
                    }
                    lastPager = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $e109829a48a92317$export$2e2bcd8739ae039), {
                        locale: locale,
                        last: true,
                        rootPrefixCls: prefixCls,
                        onClick: this.handleChange,
                        onKeyPress: this.runIfEnter,
                        key: allPages,
                        page: allPages,
                        active: false,
                        showTitle: showTitle,
                        itemRender: itemRender
                    });
                    firstPager = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $e109829a48a92317$export$2e2bcd8739ae039), {
                        locale: locale,
                        rootPrefixCls: prefixCls,
                        onClick: this.handleChange,
                        onKeyPress: this.runIfEnter,
                        key: 1,
                        page: 1,
                        active: false,
                        showTitle: showTitle,
                        itemRender: itemRender
                    });
                    var left = Math.max(1, current - pageBufferSize);
                    var right = Math.min(current + pageBufferSize, allPages);
                    if (current - 1 <= pageBufferSize) right = 1 + pageBufferSize * 2;
                    if (allPages - current <= pageBufferSize) left = allPages - pageBufferSize * 2;
                    for(var _i = left; _i <= right; _i += 1){
                        var _active = current === _i;
                        pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $e109829a48a92317$export$2e2bcd8739ae039), {
                            locale: locale,
                            rootPrefixCls: prefixCls,
                            onClick: this.handleChange,
                            onKeyPress: this.runIfEnter,
                            key: _i,
                            page: _i,
                            active: _active,
                            showTitle: showTitle,
                            itemRender: itemRender
                        }));
                    }
                    if (current - 1 >= pageBufferSize * 2 && current !== 3) {
                        pagerList[0] = /*#__PURE__*/ (0, $6fFrj.cloneElement)(pagerList[0], {
                            className: "".concat(prefixCls, "-item-after-jump-prev")
                        });
                        pagerList.unshift(jumpPrev);
                    }
                    if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
                        pagerList[pagerList.length - 1] = /*#__PURE__*/ (0, $6fFrj.cloneElement)(pagerList[pagerList.length - 1], {
                            className: "".concat(prefixCls, "-item-before-jump-next")
                        });
                        pagerList.push(jumpNext);
                    }
                    if (left !== 1) pagerList.unshift(firstPager);
                    if (right !== allPages) pagerList.push(lastPager);
                }
                var prevDisabled = !this.hasPrev() || !allPages;
                var nextDisabled = !this.hasNext() || !allPages;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("ul", (0, $fIrcP.default)({
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className, (0, $43449.default)({}, "".concat(prefixCls, "-disabled"), disabled)),
                    style: style,
                    ref: this.savePaginationNode
                }, dataOrAriaAttributeProps), totalText, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("li", {
                    title: showTitle ? locale.prev_page : null,
                    onClick: this.prev,
                    tabIndex: prevDisabled ? null : 0,
                    onKeyPress: this.runIfEnterPrev,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-prev"), (0, $43449.default)({}, "".concat(prefixCls, "-disabled"), prevDisabled)),
                    "aria-disabled": prevDisabled
                }, this.renderPrev(prevPage)), pagerList, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("li", {
                    title: showTitle ? locale.next_page : null,
                    onClick: this.next,
                    tabIndex: nextDisabled ? null : 0,
                    onKeyPress: this.runIfEnterNext,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-next"), (0, $43449.default)({}, "".concat(prefixCls, "-disabled"), nextDisabled)),
                    "aria-disabled": nextDisabled
                }, this.renderNext(nextPage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $1419333dc6c46093$export$2e2bcd8739ae039), {
                    disabled: disabled,
                    locale: locale,
                    rootPrefixCls: prefixCls,
                    selectComponentClass: selectComponentClass,
                    selectPrefixCls: selectPrefixCls,
                    changeSize: this.getShowSizeChanger() ? this.changePageSize : null,
                    current: current,
                    pageSize: pageSize,
                    pageSizeOptions: pageSizeOptions,
                    quickGo: this.shouldDisplayQuickJumper() ? this.handleChange : null,
                    goButton: goButton
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, prevState) {
                var newState = {};
                if ('current' in props) {
                    newState.current = props.current;
                    if (props.current !== prevState.current) newState.currentInputValue = newState.current;
                }
                if ('pageSize' in props && props.pageSize !== prevState.pageSize) {
                    var current = prevState.current;
                    var newCurrent = $9b82f0e1c8fbf9ac$var$calculatePage(props.pageSize, prevState, props);
                    current = current > newCurrent ? newCurrent : current;
                    if (!('current' in props)) {
                        newState.current = current;
                        newState.currentInputValue = current;
                    }
                    newState.pageSize = props.pageSize;
                }
                return newState;
            }
        }
    ]);
    return Pagination;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
$9b82f0e1c8fbf9ac$var$Pagination.defaultProps = {
    defaultCurrent: 1,
    total: 0,
    defaultPageSize: 10,
    onChange: $9b82f0e1c8fbf9ac$var$noop,
    className: '',
    selectPrefixCls: 'rc-select',
    prefixCls: 'rc-pagination',
    selectComponentClass: null,
    hideOnSinglePage: false,
    showPrevNextJumpers: true,
    showQuickJumper: false,
    showLessItems: false,
    showTitle: true,
    onShowSizeChange: $9b82f0e1c8fbf9ac$var$noop,
    locale: (0, $ccfe296b815b019a$export$2e2bcd8739ae039),
    style: {},
    itemRender: $9b82f0e1c8fbf9ac$var$defaultItemRender,
    totalBoundaryShowSizeChanger: 50
};
var $9b82f0e1c8fbf9ac$export$2e2bcd8739ae039 = $9b82f0e1c8fbf9ac$var$Pagination;






var $6fFrj = parcelRequire("6fFrj");




var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $fActo = parcelRequire("fActo");

var $fIrcP = parcelRequire("fIrcP");

var $37xND = parcelRequire("37xND");

var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $5KhTJ = parcelRequire("5KhTJ");

var $gfhff = parcelRequire("gfhff");
parcelRequire("3mXQ2");

var $6fFrj = parcelRequire("6fFrj");

var $5KhTJ = parcelRequire("5KhTJ");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $37xND = parcelRequire("37xND");

var $jP8CL = parcelRequire("jP8CL");

var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");

var $fActo = parcelRequire("fActo");

var $dNZA9 = parcelRequire("dNZA9");

var $gfhff = parcelRequire("gfhff");



var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");
/**
 * BaseSelect provide some parsed data into context.
 * You can use this hooks to get them.
 */ 
var $6fFrj = parcelRequire("6fFrj");
var $985f86b34f131ed8$export$8234047c0aea33cf = /*#__PURE__*/ $6fFrj.createContext(null);
function $985f86b34f131ed8$export$2e2bcd8739ae039() {
    return $6fFrj.useContext($985f86b34f131ed8$export$8234047c0aea33cf);
}



var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
function $2c9f05ebb113cd98$export$2e2bcd8739ae039() {
    var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), bool = _React$useState2[0], setBool = _React$useState2[1];
    var delayRef = $6fFrj.useRef(null);
    var cancelLatest = function cancelLatest() {
        window.clearTimeout(delayRef.current);
    };
    $6fFrj.useEffect(function() {
        return cancelLatest;
    }, []);
    var delaySetBool = function delaySetBool(value, callback) {
        cancelLatest();
        delayRef.current = window.setTimeout(function() {
            setBool(value);
            if (callback) callback();
        }, timeout);
    };
    return [
        bool,
        delaySetBool,
        cancelLatest
    ];
}



var $6fFrj = parcelRequire("6fFrj");
function $e66954a07fb189fd$export$2e2bcd8739ae039() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
    var lockRef = $6fFrj.useRef(null);
    var timeoutRef = $6fFrj.useRef(null);
    // Clean up
    $6fFrj.useEffect(function() {
        return function() {
            window.clearTimeout(timeoutRef.current);
        };
    }, []);
    function doLock(locked) {
        if (locked || lockRef.current === null) lockRef.current = locked;
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(function() {
            lockRef.current = null;
        }, duration);
    }
    return [
        function() {
            return lockRef.current;
        },
        doLock
    ];
}



var $6fFrj = parcelRequire("6fFrj");
function $ebc15b80ab2e30c4$export$2e2bcd8739ae039(elements, open, triggerOpen, customizedTrigger) {
    var propsRef = $6fFrj.useRef(null);
    propsRef.current = {
        open: open,
        triggerOpen: triggerOpen,
        customizedTrigger: customizedTrigger
    };
    $6fFrj.useEffect(function() {
        function onGlobalMouseDown(event) {
            var _propsRef$current;
            // If trigger is customized, Trigger will take control of popupVisible
            if ((_propsRef$current = propsRef.current) !== null && _propsRef$current !== void 0 && _propsRef$current.customizedTrigger) return;
            var target = event.target;
            if (target.shadowRoot && event.composed) target = event.composedPath()[0] || target;
            if (propsRef.current.open && elements().filter(function(element) {
                return element;
            }).every(function(element) {
                return !element.contains(target) && element !== target;
            })) // Should trigger close
            propsRef.current.triggerOpen(false);
        }
        window.addEventListener('mousedown', onGlobalMouseDown);
        return function() {
            return window.removeEventListener('mousedown', onGlobalMouseDown);
        };
    }, []);
}



var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");


var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");



var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");
var $cee3ce72adcc66e2$var$TransBtn = function TransBtn(_ref) {
    var className = _ref.className, customizeIcon = _ref.customizeIcon, customizeIconProps = _ref.customizeIconProps, _onMouseDown = _ref.onMouseDown, onClick = _ref.onClick, children = _ref.children;
    var icon;
    if (typeof customizeIcon === 'function') icon = customizeIcon(customizeIconProps);
    else icon = customizeIcon;
    return /*#__PURE__*/ $6fFrj.createElement("span", {
        className: className,
        onMouseDown: function onMouseDown(event) {
            event.preventDefault();
            if (_onMouseDown) _onMouseDown(event);
        },
        style: {
            userSelect: 'none',
            WebkitUserSelect: 'none'
        },
        unselectable: "on",
        onClick: onClick,
        "aria-hidden": true
    }, icon !== undefined ? icon : /*#__PURE__*/ $6fFrj.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(className.split(/\s+/).map(function(cls) {
            return "".concat(cls, "-icon");
        }))
    }, children));
};
var $cee3ce72adcc66e2$export$2e2bcd8739ae039 = $cee3ce72adcc66e2$var$TransBtn;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $3BOWT = parcelRequire("3BOWT");

var $3mXQ2 = parcelRequire("3mXQ2");
var $39fc61540c8c535d$var$Input = function Input(_ref, ref) {
    var _inputNode2, _inputNode2$props;
    var prefixCls = _ref.prefixCls, id = _ref.id, inputElement = _ref.inputElement, disabled = _ref.disabled, tabIndex = _ref.tabIndex, autoFocus = _ref.autoFocus, autoComplete = _ref.autoComplete, editable = _ref.editable, activeDescendantId = _ref.activeDescendantId, value = _ref.value, maxLength = _ref.maxLength, _onKeyDown = _ref.onKeyDown, _onMouseDown = _ref.onMouseDown, _onChange = _ref.onChange, onPaste = _ref.onPaste, _onCompositionStart = _ref.onCompositionStart, _onCompositionEnd = _ref.onCompositionEnd, open = _ref.open, attrs = _ref.attrs;
    var inputNode = inputElement || /*#__PURE__*/ $6fFrj.createElement("input", null);
    var _inputNode = inputNode, originRef = _inputNode.ref, originProps = _inputNode.props;
    var onOriginKeyDown = originProps.onKeyDown, onOriginChange = originProps.onChange, onOriginMouseDown = originProps.onMouseDown, onOriginCompositionStart = originProps.onCompositionStart, onOriginCompositionEnd = originProps.onCompositionEnd, style = originProps.style;
    (0, $3mXQ2.warning)(!('maxLength' in inputNode.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled.");
    inputNode = /*#__PURE__*/ $6fFrj.cloneElement(inputNode, (0, $kNxFX.default)((0, $kNxFX.default)((0, $kNxFX.default)({
        type: 'search'
    }, originProps), {}, {
        // Override over origin props
        id: id,
        ref: (0, $3BOWT.composeRef)(ref, originRef),
        disabled: disabled,
        tabIndex: tabIndex,
        autoComplete: autoComplete || 'off',
        autoFocus: autoFocus,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-selection-search-input"), (_inputNode2 = inputNode) === null || _inputNode2 === void 0 ? void 0 : (_inputNode2$props = _inputNode2.props) === null || _inputNode2$props === void 0 ? void 0 : _inputNode2$props.className),
        role: 'combobox',
        'aria-expanded': open,
        'aria-haspopup': 'listbox',
        'aria-owns': "".concat(id, "_list"),
        'aria-autocomplete': 'list',
        'aria-controls': "".concat(id, "_list"),
        'aria-activedescendant': activeDescendantId
    }, attrs), {}, {
        value: editable ? value : '',
        maxLength: maxLength,
        readOnly: !editable,
        unselectable: !editable ? 'on' : null,
        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, style), {}, {
            opacity: editable ? null : 0
        }),
        onKeyDown: function onKeyDown(event) {
            _onKeyDown(event);
            if (onOriginKeyDown) onOriginKeyDown(event);
        },
        onMouseDown: function onMouseDown(event) {
            _onMouseDown(event);
            if (onOriginMouseDown) onOriginMouseDown(event);
        },
        onChange: function onChange(event) {
            _onChange(event);
            if (onOriginChange) onOriginChange(event);
        },
        onCompositionStart: function onCompositionStart(event) {
            _onCompositionStart(event);
            if (onOriginCompositionStart) onOriginCompositionStart(event);
        },
        onCompositionEnd: function onCompositionEnd(event) {
            _onCompositionEnd(event);
            if (onOriginCompositionEnd) onOriginCompositionEnd(event);
        },
        onPaste: onPaste
    }));
    return inputNode;
};
var $39fc61540c8c535d$var$RefInput = /*#__PURE__*/ $6fFrj.forwardRef($39fc61540c8c535d$var$Input);
$39fc61540c8c535d$var$RefInput.displayName = 'Input';
var $39fc61540c8c535d$export$2e2bcd8739ae039 = $39fc61540c8c535d$var$RefInput;


/* eslint-disable react-hooks/rules-of-hooks */ 
var $6fFrj = parcelRequire("6fFrj");

var $5KhTJ = parcelRequire("5KhTJ");
function $b7fa77966f4f591e$export$45b10814cc054894(value) {
    if (Array.isArray(value)) return value;
    return value !== undefined ? [
        value
    ] : [];
}
var $b7fa77966f4f591e$export$7383f122bf48ec30 = typeof window !== 'undefined' && window.document && window.document.documentElement;
var $b7fa77966f4f591e$export$df7146797a248522 = $b7fa77966f4f591e$export$7383f122bf48ec30;
function $b7fa77966f4f591e$export$96bdbc84526f3739(value) {
    return value !== undefined && value !== null;
}
function $b7fa77966f4f591e$var$isTitleType(title) {
    return [
        'string',
        'number'
    ].includes((0, $5KhTJ.default)(title));
}
function $b7fa77966f4f591e$export$70d1bf7729efff40(item) {
    var title = undefined;
    if (item) {
        if ($b7fa77966f4f591e$var$isTitleType(item.title)) title = item.title.toString();
        else if ($b7fa77966f4f591e$var$isTitleType(item.label)) title = item.label.toString();
    }
    return title;
}


function $1ad621e9ef9d5e0f$export$2e2bcd8739ae039(effect, deps) {
    // Never happen in test env
    if (0, $b7fa77966f4f591e$export$df7146797a248522) /* istanbul ignore next */ $6fFrj.useLayoutEffect(effect, deps);
    else $6fFrj.useEffect(effect, deps);
} /* eslint-enable */ 



function $0e9dc65b2dd42fab$var$itemKey(value) {
    var _value$key;
    return (_value$key = value.key) !== null && _value$key !== void 0 ? _value$key : value.value;
}
var $0e9dc65b2dd42fab$var$onPreventMouseDown = function onPreventMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
};
var $0e9dc65b2dd42fab$var$SelectSelector = function SelectSelector(props) {
    var id = props.id, prefixCls = props.prefixCls, values = props.values, open = props.open, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, inputRef = props.inputRef, placeholder = props.placeholder, disabled = props.disabled, mode = props.mode, showSearch = props.showSearch, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, tabIndex = props.tabIndex, removeIcon = props.removeIcon, maxTagCount = props.maxTagCount, maxTagTextLength = props.maxTagTextLength, _props$maxTagPlacehol = props.maxTagPlaceholder, maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function(omittedValues) {
        return "+ ".concat(omittedValues.length, " ...");
    } : _props$maxTagPlacehol, tagRender = props.tagRender, onToggleOpen = props.onToggleOpen, onRemove = props.onRemove, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd;
    var measureRef = $6fFrj.useRef(null);
    var _useState = (0, $6fFrj.useState)(0), _useState2 = (0, $jP8CL.default)(_useState, 2), inputWidth = _useState2[0], setInputWidth = _useState2[1];
    var _useState3 = (0, $6fFrj.useState)(false), _useState4 = (0, $jP8CL.default)(_useState3, 2), focused = _useState4[0], setFocused = _useState4[1];
    var selectionPrefixCls = "".concat(prefixCls, "-selection");
    // ===================== Search ======================
    var inputValue = open || mode === "multiple" && autoClearSearchValue === false || mode === 'tags' ? searchValue : '';
    var inputEditable = mode === 'tags' || mode === "multiple" && autoClearSearchValue === false || showSearch && (open || focused);
    // We measure width and set to the input immediately
    (0, $1ad621e9ef9d5e0f$export$2e2bcd8739ae039)(function() {
        setInputWidth(measureRef.current.scrollWidth);
    }, [
        inputValue
    ]);
    // ===================== Render ======================
    // >>> Render Selector Node. Includes Item & Rest
    function defaultRenderSelector(item, content, itemDisabled, closable, onClose) {
        return /*#__PURE__*/ $6fFrj.createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(selectionPrefixCls, "-item"), (0, $43449.default)({}, "".concat(selectionPrefixCls, "-item-disabled"), itemDisabled)),
            title: (0, $b7fa77966f4f591e$export$70d1bf7729efff40)(item)
        }, /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(selectionPrefixCls, "-item-content")
        }, content), closable && /*#__PURE__*/ $6fFrj.createElement((0, $cee3ce72adcc66e2$export$2e2bcd8739ae039), {
            className: "".concat(selectionPrefixCls, "-item-remove"),
            onMouseDown: $0e9dc65b2dd42fab$var$onPreventMouseDown,
            onClick: onClose,
            customizeIcon: removeIcon
        }, "\xD7"));
    }
    function customizeRenderSelector(value, content, itemDisabled, closable, onClose) {
        var onMouseDown = function onMouseDown(e) {
            $0e9dc65b2dd42fab$var$onPreventMouseDown(e);
            onToggleOpen(!open);
        };
        return /*#__PURE__*/ $6fFrj.createElement("span", {
            onMouseDown: onMouseDown
        }, tagRender({
            label: content,
            value: value,
            disabled: itemDisabled,
            closable: closable,
            onClose: onClose
        }));
    }
    function renderItem(valueItem) {
        var itemDisabled = valueItem.disabled, label = valueItem.label, value = valueItem.value;
        var closable = !disabled && !itemDisabled;
        var displayLabel = label;
        if (typeof maxTagTextLength === 'number') {
            if (typeof label === 'string' || typeof label === 'number') {
                var strLabel = String(displayLabel);
                if (strLabel.length > maxTagTextLength) displayLabel = "".concat(strLabel.slice(0, maxTagTextLength), "...");
            }
        }
        var onClose = function onClose(event) {
            if (event) event.stopPropagation();
            onRemove(valueItem);
        };
        return typeof tagRender === 'function' ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
    }
    function renderRest(omittedValues) {
        var content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
        return defaultRenderSelector({
            title: content
        }, content, false);
    }
    // >>> Input Node
    var inputNode = /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(selectionPrefixCls, "-search"),
        style: {
            width: inputWidth
        },
        onFocus: function onFocus() {
            setFocused(true);
        },
        onBlur: function onBlur() {
            setFocused(false);
        }
    }, /*#__PURE__*/ $6fFrj.createElement((0, $39fc61540c8c535d$export$2e2bcd8739ae039), {
        ref: inputRef,
        open: open,
        prefixCls: prefixCls,
        id: id,
        inputElement: null,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: onInputChange,
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        tabIndex: tabIndex,
        attrs: (0, $c7e00e8671f36d19$export$2e2bcd8739ae039)(props, true)
    }), /*#__PURE__*/ $6fFrj.createElement("span", {
        ref: measureRef,
        className: "".concat(selectionPrefixCls, "-search-mirror"),
        "aria-hidden": true
    }, inputValue, "\xA0"));
    // >>> Selections
    var selectionNode = /*#__PURE__*/ $6fFrj.createElement((0, $fc57648bf28f775c$export$2e2bcd8739ae039), {
        prefixCls: "".concat(selectionPrefixCls, "-overflow"),
        data: values,
        renderItem: renderItem,
        renderRest: renderRest,
        suffix: inputNode,
        itemKey: $0e9dc65b2dd42fab$var$itemKey,
        maxCount: maxTagCount
    });
    return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, selectionNode, !values.length && !inputValue && /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(selectionPrefixCls, "-placeholder")
    }, placeholder));
};
var $0e9dc65b2dd42fab$export$2e2bcd8739ae039 = $0e9dc65b2dd42fab$var$SelectSelector;



var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");



var $38862f5bcafdb184$var$SingleSelector = function SingleSelector(props) {
    var inputElement = props.inputElement, prefixCls = props.prefixCls, id = props.id, inputRef = props.inputRef, disabled = props.disabled, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, mode = props.mode, open = props.open, values = props.values, placeholder = props.placeholder, tabIndex = props.tabIndex, showSearch = props.showSearch, searchValue = props.searchValue, activeValue = props.activeValue, maxLength = props.maxLength, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd;
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), inputChanged = _React$useState2[0], setInputChanged = _React$useState2[1];
    var combobox = mode === 'combobox';
    var inputEditable = combobox || showSearch;
    var item = values[0];
    var inputValue = searchValue || '';
    if (combobox && activeValue && !inputChanged) inputValue = activeValue;
    $6fFrj.useEffect(function() {
        if (combobox) setInputChanged(false);
    }, [
        combobox,
        activeValue
    ]);
    // Not show text when closed expect combobox mode
    var hasTextInput = mode !== 'combobox' && !open && !showSearch ? false : !!inputValue;
    // Get title
    var title = (0, $b7fa77966f4f591e$export$70d1bf7729efff40)(item);
    var renderPlaceholder = function renderPlaceholder() {
        if (item) return null;
        var hiddenStyle = hasTextInput ? {
            visibility: 'hidden'
        } : undefined;
        return /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-selection-placeholder"),
            style: hiddenStyle
        }, placeholder);
    };
    return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-selection-search")
    }, /*#__PURE__*/ $6fFrj.createElement((0, $39fc61540c8c535d$export$2e2bcd8739ae039), {
        ref: inputRef,
        prefixCls: prefixCls,
        id: id,
        open: open,
        inputElement: inputElement,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: function onChange(e) {
            setInputChanged(true);
            onInputChange(e);
        },
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        tabIndex: tabIndex,
        attrs: (0, $c7e00e8671f36d19$export$2e2bcd8739ae039)(props, true),
        maxLength: combobox ? maxLength : undefined
    })), !combobox && item ? /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-selection-item"),
        title: title,
        style: hasTextInput ? {
            visibility: 'hidden'
        } : undefined
    }, item.label) : null, renderPlaceholder());
};
var $38862f5bcafdb184$export$2e2bcd8739ae039 = $38862f5bcafdb184$var$SingleSelector;




function $e7bec5b67ec6d336$export$48ac81d4a07c29c(currentKeyCode) {
    return ![
        // System function button
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ESC,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).SHIFT,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).BACKSPACE,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).TAB,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).WIN_KEY,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ALT,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).META,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).WIN_KEY_RIGHT,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).CTRL,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).SEMICOLON,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).EQUALS,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).CAPS_LOCK,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).CONTEXT_MENU,
        // F1-F12
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).F1,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).F2,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).F3,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).F4,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).F5,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).F6,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).F7,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).F8,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).F9,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).F10,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).F11,
        (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).F12
    ].includes(currentKeyCode);
}


var $409a5de037f1543a$var$Selector = function Selector(props, ref) {
    var inputRef = (0, $6fFrj.useRef)(null);
    var compositionStatusRef = (0, $6fFrj.useRef)(false);
    var prefixCls = props.prefixCls, open = props.open, mode = props.mode, showSearch = props.showSearch, tokenWithEnter = props.tokenWithEnter, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSubmit = props.onSearchSubmit, onToggleOpen = props.onToggleOpen, onInputKeyDown = props.onInputKeyDown, domRef = props.domRef;
    // ======================= Ref =======================
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                inputRef.current.focus();
            },
            blur: function blur() {
                inputRef.current.blur();
            }
        };
    });
    // ====================== Input ======================
    var _useLock = (0, $e66954a07fb189fd$export$2e2bcd8739ae039)(0), _useLock2 = (0, $jP8CL.default)(_useLock, 2), getInputMouseDown = _useLock2[0], setInputMouseDown = _useLock2[1];
    var onInternalInputKeyDown = function onInternalInputKeyDown(event) {
        var which = event.which;
        if (which === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).UP || which === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).DOWN) event.preventDefault();
        if (onInputKeyDown) onInputKeyDown(event);
        if (which === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER && mode === 'tags' && !compositionStatusRef.current && !open) // When menu isn't open, OptionList won't trigger a value change
        // So when enter is pressed, the tag's input value should be emitted here to let selector know
        onSearchSubmit === null || onSearchSubmit === void 0 || onSearchSubmit(event.target.value);
        if ((0, $e7bec5b67ec6d336$export$48ac81d4a07c29c)(which)) onToggleOpen(true);
    };
    /**
   * We can not use `findDOMNode` sine it will get warning,
   * have to use timer to check if is input element.
   */ var onInternalInputMouseDown = function onInternalInputMouseDown() {
        setInputMouseDown(true);
    };
    // When paste come, ignore next onChange
    var pastedTextRef = (0, $6fFrj.useRef)(null);
    var triggerOnSearch = function triggerOnSearch(value) {
        if (onSearch(value, true, compositionStatusRef.current) !== false) onToggleOpen(true);
    };
    var onInputCompositionStart = function onInputCompositionStart() {
        compositionStatusRef.current = true;
    };
    var onInputCompositionEnd = function onInputCompositionEnd(e) {
        compositionStatusRef.current = false;
        // Trigger search again to support `tokenSeparators` with typewriting
        if (mode !== 'combobox') triggerOnSearch(e.target.value);
    };
    var onInputChange = function onInputChange(event) {
        var value = event.target.value;
        // Pasted text should replace back to origin content
        if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
            // CRLF will be treated as a single space for input element
            var replacedText = pastedTextRef.current.replace(/[\r\n]+$/, '').replace(/\r\n/g, ' ').replace(/[\r\n]/g, ' ');
            value = value.replace(replacedText, pastedTextRef.current);
        }
        pastedTextRef.current = null;
        triggerOnSearch(value);
    };
    var onInputPaste = function onInputPaste(e) {
        var clipboardData = e.clipboardData;
        var value = clipboardData.getData('text');
        pastedTextRef.current = value;
    };
    var onClick = function onClick(_ref) {
        var target = _ref.target;
        if (target !== inputRef.current) {
            // Should focus input if click the selector
            var isIE = document.body.style.msTouchAction !== undefined;
            if (isIE) setTimeout(function() {
                inputRef.current.focus();
            });
            else inputRef.current.focus();
        }
    };
    var onMouseDown = function onMouseDown(event) {
        var inputMouseDown = getInputMouseDown();
        // when mode is combobox, don't prevent default behavior
        // https://github.com/ant-design/ant-design/issues/37320
        if (event.target !== inputRef.current && !inputMouseDown && mode !== 'combobox') event.preventDefault();
        if (mode !== 'combobox' && (!showSearch || !inputMouseDown) || !open) {
            if (open && autoClearSearchValue !== false) onSearch('', true, false);
            onToggleOpen();
        }
    };
    // ================= Inner Selector ==================
    var sharedProps = {
        inputRef: inputRef,
        onInputKeyDown: onInternalInputKeyDown,
        onInputMouseDown: onInternalInputMouseDown,
        onInputChange: onInputChange,
        onInputPaste: onInputPaste,
        onInputCompositionStart: onInputCompositionStart,
        onInputCompositionEnd: onInputCompositionEnd
    };
    var selectNode = mode === 'multiple' || mode === 'tags' ? /*#__PURE__*/ $6fFrj.createElement((0, $0e9dc65b2dd42fab$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, sharedProps)) : /*#__PURE__*/ $6fFrj.createElement((0, $38862f5bcafdb184$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, sharedProps));
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        ref: domRef,
        className: "".concat(prefixCls, "-selector"),
        onClick: onClick,
        onMouseDown: onMouseDown
    }, selectNode);
};
var $409a5de037f1543a$var$ForwardSelector = /*#__PURE__*/ $6fFrj.forwardRef($409a5de037f1543a$var$Selector);
$409a5de037f1543a$var$ForwardSelector.displayName = 'Selector';
var $409a5de037f1543a$export$2e2bcd8739ae039 = $409a5de037f1543a$var$ForwardSelector;



var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");


var $fActo = parcelRequire("fActo");
var $facb87704719e132$var$_excluded = [
    "prefixCls",
    "disabled",
    "visible",
    "children",
    "popupElement",
    "containerWidth",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "direction",
    "placement",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "getPopupContainer",
    "empty",
    "getTriggerDOMNode",
    "onPopupVisibleChange",
    "onPopupMouseEnter"
];
var $facb87704719e132$var$getBuiltInPlacements = function getBuiltInPlacements(dropdownMatchSelectWidth) {
    // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
    var adjustX = dropdownMatchSelectWidth === true ? 0 : 1;
    return {
        bottomLeft: {
            points: [
                'tl',
                'bl'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            }
        },
        bottomRight: {
            points: [
                'tr',
                'br'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            }
        },
        topLeft: {
            points: [
                'bl',
                'tl'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            }
        },
        topRight: {
            points: [
                'br',
                'tr'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            }
        }
    };
};
var $facb87704719e132$var$SelectTrigger = function SelectTrigger(props, ref) {
    var prefixCls = props.prefixCls, disabled = props.disabled, visible = props.visible, children = props.children, popupElement = props.popupElement, containerWidth = props.containerWidth, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, _props$direction = props.direction, direction = _props$direction === void 0 ? 'ltr' : _props$direction, placement = props.placement, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, getPopupContainer = props.getPopupContainer, empty = props.empty, getTriggerDOMNode = props.getTriggerDOMNode, onPopupVisibleChange = props.onPopupVisibleChange, onPopupMouseEnter = props.onPopupMouseEnter, restProps = (0, $04RxA.default)(props, $facb87704719e132$var$_excluded);
    var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
    var popupNode = popupElement;
    if (dropdownRender) popupNode = dropdownRender(popupElement);
    var builtInPlacements = $6fFrj.useMemo(function() {
        return $facb87704719e132$var$getBuiltInPlacements(dropdownMatchSelectWidth);
    }, [
        dropdownMatchSelectWidth
    ]);
    // ===================== Motion ======================
    var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName;
    // ======================= Ref =======================
    var popupRef = $6fFrj.useRef(null);
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            getPopupElement: function getPopupElement() {
                return popupRef.current;
            }
        };
    });
    var popupStyle = (0, $kNxFX.default)({
        minWidth: containerWidth
    }, dropdownStyle);
    if (typeof dropdownMatchSelectWidth === 'number') popupStyle.width = dropdownMatchSelectWidth;
    else if (dropdownMatchSelectWidth) popupStyle.width = containerWidth;
    return /*#__PURE__*/ $6fFrj.createElement((0, $2c9abce2aaa5219e$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, restProps, {
        showAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        hideAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        popupPlacement: placement || (direction === 'rtl' ? 'bottomRight' : 'bottomLeft'),
        builtinPlacements: builtInPlacements,
        prefixCls: dropdownPrefixCls,
        popupTransitionName: mergedTransitionName,
        popup: /*#__PURE__*/ $6fFrj.createElement("div", {
            ref: popupRef,
            onMouseEnter: onPopupMouseEnter
        }, popupNode),
        popupAlign: dropdownAlign,
        popupVisible: visible,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(dropdownClassName, (0, $43449.default)({}, "".concat(dropdownPrefixCls, "-empty"), empty)),
        popupStyle: popupStyle,
        getTriggerDOMNode: getTriggerDOMNode,
        onPopupVisibleChange: onPopupVisibleChange
    }), children);
};
var $facb87704719e132$var$RefSelectTrigger = /*#__PURE__*/ $6fFrj.forwardRef($facb87704719e132$var$SelectTrigger);
$facb87704719e132$var$RefSelectTrigger.displayName = 'SelectTrigger';
var $facb87704719e132$export$2e2bcd8739ae039 = $facb87704719e132$var$RefSelectTrigger;




var $37xND = parcelRequire("37xND");

var $hFMPf = parcelRequire("hFMPf");

var $kNxFX = parcelRequire("kNxFX");

var $3mXQ2 = parcelRequire("3mXQ2");
function $3786d4546cc0f905$var$getKey(data, index) {
    var key = data.key;
    var value;
    if ('value' in data) value = data.value;
    if (key !== null && key !== undefined) return key;
    if (value !== undefined) return value;
    return "rc-index-key-".concat(index);
}
function $3786d4546cc0f905$export$6c519d302dced239(fieldNames, childrenAsData) {
    var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, options = _ref.options;
    return {
        label: label || (childrenAsData ? 'children' : 'label'),
        value: value || 'value',
        options: options || 'options'
    };
}
function $3786d4546cc0f905$export$7baa7c13b358b002(options) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, fieldNames = _ref2.fieldNames, childrenAsData = _ref2.childrenAsData;
    var flattenList = [];
    var _fillFieldNames = $3786d4546cc0f905$export$6c519d302dced239(fieldNames, false), fieldLabel = _fillFieldNames.label, fieldValue = _fillFieldNames.value, fieldOptions = _fillFieldNames.options;
    function dig(list, isGroupOption) {
        list.forEach(function(data) {
            var label = data[fieldLabel];
            if (isGroupOption || !(fieldOptions in data)) {
                var value = data[fieldValue];
                // Option
                flattenList.push({
                    key: $3786d4546cc0f905$var$getKey(data, flattenList.length),
                    groupOption: isGroupOption,
                    data: data,
                    label: label,
                    value: value
                });
            } else {
                var grpLabel = label;
                if (grpLabel === undefined && childrenAsData) grpLabel = data.label;
                // Option Group
                flattenList.push({
                    key: $3786d4546cc0f905$var$getKey(data, flattenList.length),
                    group: true,
                    data: data,
                    label: grpLabel
                });
                dig(data[fieldOptions], true);
            }
        });
    }
    dig(options, false);
    return flattenList;
}
function $3786d4546cc0f905$export$d0b21b213c8c013c(option) {
    var newOption = (0, $kNxFX.default)({}, option);
    if (!('props' in newOption)) Object.defineProperty(newOption, 'props', {
        get: function get() {
            (0, $3mXQ2.default)(false, 'Return type is option instead of Option instance. Please read value directly instead of reading from `props`.');
            return newOption;
        }
    });
    return newOption;
}
function $3786d4546cc0f905$export$a09ca2a89e052b14(text, tokens) {
    if (!tokens || !tokens.length) return null;
    var match = false;
    function separate(str, _ref3) {
        var _ref4 = (0, $hFMPf.default)(_ref3), token = _ref4[0], restTokens = _ref4.slice(1);
        if (!token) return [
            str
        ];
        var list = str.split(token);
        match = match || list.length > 1;
        return list.reduce(function(prevList, unitStr) {
            return [].concat((0, $37xND.default)(prevList), (0, $37xND.default)(separate(unitStr, restTokens)));
        }, []).filter(function(unit) {
            return unit;
        });
    }
    var list = separate(text, tokens);
    return match ? list : null;
}


var $0f2850f876065ada$var$_excluded = [
    "id",
    "prefixCls",
    "className",
    "showSearch",
    "tagRender",
    "direction",
    "omitDomProps",
    "displayValues",
    "onDisplayValuesChange",
    "emptyOptions",
    "notFoundContent",
    "onClear",
    "mode",
    "disabled",
    "loading",
    "getInputElement",
    "getRawInputElement",
    "open",
    "defaultOpen",
    "onDropdownVisibleChange",
    "activeValue",
    "onActiveValueChange",
    "activeDescendantId",
    "searchValue",
    "autoClearSearchValue",
    "onSearch",
    "onSearchSplit",
    "tokenSeparators",
    "allowClear",
    "showArrow",
    "inputIcon",
    "clearIcon",
    "OptionList",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "placement",
    "getPopupContainer",
    "showAction",
    "onFocus",
    "onBlur",
    "onKeyUp",
    "onKeyDown",
    "onMouseDown"
];
var $0f2850f876065ada$var$DEFAULT_OMIT_PROPS = [
    'value',
    'onChange',
    'removeIcon',
    'placeholder',
    'autoFocus',
    'maxTagCount',
    'maxTagTextLength',
    'maxTagPlaceholder',
    'choiceTransitionName',
    'onInputKeyDown',
    'onPopupScroll',
    'tabIndex'
];
function $0f2850f876065ada$export$7f654ad2a77ad2ac(mode) {
    return mode === 'tags' || mode === 'multiple';
}
var $0f2850f876065ada$var$BaseSelect = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _customizeRawInputEle, _classNames2;
    var id = props.id, prefixCls = props.prefixCls, className = props.className, showSearch = props.showSearch, tagRender = props.tagRender, direction = props.direction, omitDomProps = props.omitDomProps, displayValues = props.displayValues, onDisplayValuesChange = props.onDisplayValuesChange, emptyOptions = props.emptyOptions, _props$notFoundConten = props.notFoundContent, notFoundContent = _props$notFoundConten === void 0 ? 'Not Found' : _props$notFoundConten, onClear = props.onClear, mode = props.mode, disabled = props.disabled, loading = props.loading, getInputElement = props.getInputElement, getRawInputElement = props.getRawInputElement, open = props.open, defaultOpen = props.defaultOpen, onDropdownVisibleChange = props.onDropdownVisibleChange, activeValue = props.activeValue, onActiveValueChange = props.onActiveValueChange, activeDescendantId = props.activeDescendantId, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSplit = props.onSearchSplit, tokenSeparators = props.tokenSeparators, allowClear = props.allowClear, showArrow = props.showArrow, inputIcon = props.inputIcon, clearIcon = props.clearIcon, OptionList = props.OptionList, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, placement = props.placement, getPopupContainer = props.getPopupContainer, _props$showAction = props.showAction, showAction = _props$showAction === void 0 ? [] : _props$showAction, onFocus = props.onFocus, onBlur = props.onBlur, onKeyUp = props.onKeyUp, onKeyDown = props.onKeyDown, onMouseDown = props.onMouseDown, restProps = (0, $04RxA.default)(props, $0f2850f876065ada$var$_excluded);
    // ============================== MISC ==============================
    var multiple = $0f2850f876065ada$export$7f654ad2a77ad2ac(mode);
    var mergedShowSearch = (showSearch !== undefined ? showSearch : multiple) || mode === 'combobox';
    var domProps = (0, $kNxFX.default)({}, restProps);
    $0f2850f876065ada$var$DEFAULT_OMIT_PROPS.forEach(function(propName) {
        delete domProps[propName];
    });
    omitDomProps === null || omitDomProps === void 0 || omitDomProps.forEach(function(propName) {
        delete domProps[propName];
    });
    // ============================= Mobile =============================
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
    $6fFrj.useEffect(function() {
        // Only update on the client side
        setMobile((0, $fee6da8402dc892a$export$2e2bcd8739ae039)());
    }, []);
    // ============================== Refs ==============================
    var containerRef = $6fFrj.useRef(null);
    var selectorDomRef = $6fFrj.useRef(null);
    var triggerRef = $6fFrj.useRef(null);
    var selectorRef = $6fFrj.useRef(null);
    var listRef = $6fFrj.useRef(null);
    /** Used for component focused management */ var _useDelayReset = (0, $2c9f05ebb113cd98$export$2e2bcd8739ae039)(), _useDelayReset2 = (0, $jP8CL.default)(_useDelayReset, 3), mockFocused = _useDelayReset2[0], setMockFocused = _useDelayReset2[1], cancelSetMockFocused = _useDelayReset2[2];
    // =========================== Imperative ===========================
    $6fFrj.useImperativeHandle(ref, function() {
        var _selectorRef$current, _selectorRef$current2;
        return {
            focus: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.focus,
            blur: (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 ? void 0 : _selectorRef$current2.blur,
            scrollTo: function scrollTo(arg) {
                var _listRef$current;
                return (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo(arg);
            }
        };
    });
    // ========================== Search Value ==========================
    var mergedSearchValue = $6fFrj.useMemo(function() {
        var _displayValues$;
        if (mode !== 'combobox') return searchValue;
        var val = (_displayValues$ = displayValues[0]) === null || _displayValues$ === void 0 ? void 0 : _displayValues$.value;
        return typeof val === 'string' || typeof val === 'number' ? String(val) : '';
    }, [
        searchValue,
        mode,
        displayValues
    ]);
    // ========================== Custom Input ==========================
    // Only works in `combobox`
    var customizeInputElement = mode === 'combobox' && typeof getInputElement === 'function' && getInputElement() || null;
    // Used for customize replacement for `rc-cascader`
    var customizeRawInputElement = typeof getRawInputElement === 'function' && getRawInputElement();
    var customizeRawInputRef = (0, $3BOWT.useComposeRef)(selectorDomRef, customizeRawInputElement === null || customizeRawInputElement === void 0 ? void 0 : (_customizeRawInputEle = customizeRawInputElement.props) === null || _customizeRawInputEle === void 0 ? void 0 : _customizeRawInputEle.ref);
    // ============================== Open ==============================
    var _useMergedState = (0, $gfhff.default)(undefined, {
        defaultValue: defaultOpen,
        value: open
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), innerOpen = _useMergedState2[0], setInnerOpen = _useMergedState2[1];
    var mergedOpen = innerOpen;
    // Not trigger `open` in `combobox` when `notFoundContent` is empty
    var emptyListContent = !notFoundContent && emptyOptions;
    if (disabled || emptyListContent && mergedOpen && mode === 'combobox') mergedOpen = false;
    var triggerOpen = emptyListContent ? false : mergedOpen;
    var onToggleOpen = $6fFrj.useCallback(function(newOpen) {
        var nextOpen = newOpen !== undefined ? newOpen : !mergedOpen;
        if (!disabled) {
            setInnerOpen(nextOpen);
            if (mergedOpen !== nextOpen) onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(nextOpen);
        }
    }, [
        disabled,
        mergedOpen,
        setInnerOpen,
        onDropdownVisibleChange
    ]);
    // ============================= Search =============================
    var tokenWithEnter = $6fFrj.useMemo(function() {
        return (tokenSeparators || []).some(function(tokenSeparator) {
            return [
                '\n',
                '\r\n'
            ].includes(tokenSeparator);
        });
    }, [
        tokenSeparators
    ]);
    var onInternalSearch = function onInternalSearch(searchText, fromTyping, isCompositing) {
        var ret = true;
        var newSearchText = searchText;
        onActiveValueChange === null || onActiveValueChange === void 0 || onActiveValueChange(null);
        // Check if match the `tokenSeparators`
        var patchLabels = isCompositing ? null : (0, $3786d4546cc0f905$export$a09ca2a89e052b14)(searchText, tokenSeparators);
        // Ignore combobox since it's not split-able
        if (mode !== 'combobox' && patchLabels) {
            newSearchText = '';
            onSearchSplit === null || onSearchSplit === void 0 || onSearchSplit(patchLabels);
            // Should close when paste finish
            onToggleOpen(false);
            // Tell Selector that break next actions
            ret = false;
        }
        if (onSearch && mergedSearchValue !== newSearchText) onSearch(newSearchText, {
            source: fromTyping ? 'typing' : 'effect'
        });
        return ret;
    };
    // Only triggered when menu is closed & mode is tags
    // If menu is open, OptionList will take charge
    // If mode isn't tags, press enter is not meaningful when you can't see any option
    var onInternalSearchSubmit = function onInternalSearchSubmit(searchText) {
        // prevent empty tags from appearing when you click the Enter button
        if (!searchText || !searchText.trim()) return;
        onSearch(searchText, {
            source: 'submit'
        });
    };
    // Close will clean up single mode search text
    $6fFrj.useEffect(function() {
        if (!mergedOpen && !multiple && mode !== 'combobox') onInternalSearch('', false, false);
    }, [
        mergedOpen
    ]);
    // ============================ Disabled ============================
    // Close dropdown & remove focus state when disabled change
    $6fFrj.useEffect(function() {
        if (innerOpen && disabled) setInnerOpen(false);
        if (disabled) setMockFocused(false);
    }, [
        disabled
    ]);
    // ============================ Keyboard ============================
    /**
   * We record input value here to check if can press to clean up by backspace
   * - null: Key is not down, this is reset by key up
   * - true: Search text is empty when first time backspace down
   * - false: Search text is not empty when first time backspace down
   */ var _useLock = (0, $e66954a07fb189fd$export$2e2bcd8739ae039)(), _useLock2 = (0, $jP8CL.default)(_useLock, 2), getClearLock = _useLock2[0], setClearLock = _useLock2[1];
    // KeyDown
    var onInternalKeyDown = function onInternalKeyDown(event) {
        var clearLock = getClearLock();
        var which = event.which;
        if (which === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER) {
            // Do not submit form when type in the input
            if (mode !== 'combobox') event.preventDefault();
            // We only manage open state here, close logic should handle by list component
            if (!mergedOpen) onToggleOpen(true);
        }
        setClearLock(!!mergedSearchValue);
        // Remove value by `backspace`
        if (which === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).BACKSPACE && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
            var cloneDisplayValues = (0, $37xND.default)(displayValues);
            var removedDisplayValue = null;
            for(var i = cloneDisplayValues.length - 1; i >= 0; i -= 1){
                var current = cloneDisplayValues[i];
                if (!current.disabled) {
                    cloneDisplayValues.splice(i, 1);
                    removedDisplayValue = current;
                    break;
                }
            }
            if (removedDisplayValue) onDisplayValuesChange(cloneDisplayValues, {
                type: 'remove',
                values: [
                    removedDisplayValue
                ]
            });
        }
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        if (mergedOpen && listRef.current) {
            var _listRef$current2;
            (_listRef$current2 = listRef.current).onKeyDown.apply(_listRef$current2, [
                event
            ].concat(rest));
        }
        onKeyDown === null || onKeyDown === void 0 || onKeyDown.apply(void 0, [
            event
        ].concat(rest));
    };
    // KeyUp
    var onInternalKeyUp = function onInternalKeyUp(event) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)rest[_key2 - 1] = arguments[_key2];
        if (mergedOpen && listRef.current) {
            var _listRef$current3;
            (_listRef$current3 = listRef.current).onKeyUp.apply(_listRef$current3, [
                event
            ].concat(rest));
        }
        onKeyUp === null || onKeyUp === void 0 || onKeyUp.apply(void 0, [
            event
        ].concat(rest));
    };
    // ============================ Selector ============================
    var onSelectorRemove = function onSelectorRemove(val) {
        var newValues = displayValues.filter(function(i) {
            return i !== val;
        });
        onDisplayValuesChange(newValues, {
            type: 'remove',
            values: [
                val
            ]
        });
    };
    // ========================== Focus / Blur ==========================
    /** Record real focus status */ var focusRef = $6fFrj.useRef(false);
    var onContainerFocus = function onContainerFocus() {
        setMockFocused(true);
        if (!disabled) {
            if (onFocus && !focusRef.current) onFocus.apply(void 0, arguments);
            // `showAction` should handle `focus` if set
            if (showAction.includes('focus')) onToggleOpen(true);
        }
        focusRef.current = true;
    };
    var onContainerBlur = function onContainerBlur() {
        setMockFocused(false, function() {
            focusRef.current = false;
            onToggleOpen(false);
        });
        if (disabled) return;
        if (mergedSearchValue) {
            // `tags` mode should move `searchValue` into values
            if (mode === 'tags') onSearch(mergedSearchValue, {
                source: 'submit'
            });
            else if (mode === 'multiple') // `multiple` mode only clean the search value but not trigger event
            onSearch('', {
                source: 'blur'
            });
        }
        if (onBlur) onBlur.apply(void 0, arguments);
    };
    // Give focus back of Select
    var activeTimeoutIds = [];
    $6fFrj.useEffect(function() {
        return function() {
            activeTimeoutIds.forEach(function(timeoutId) {
                return clearTimeout(timeoutId);
            });
            activeTimeoutIds.splice(0, activeTimeoutIds.length);
        };
    }, []);
    var onInternalMouseDown = function onInternalMouseDown(event) {
        var _triggerRef$current;
        var target = event.target;
        var popupElement = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getPopupElement();
        // We should give focus back to selector if clicked item is not focusable
        if (popupElement && popupElement.contains(target)) {
            var timeoutId = setTimeout(function() {
                var index = activeTimeoutIds.indexOf(timeoutId);
                if (index !== -1) activeTimeoutIds.splice(index, 1);
                cancelSetMockFocused();
                if (!mobile && !popupElement.contains(document.activeElement)) {
                    var _selectorRef$current3;
                    (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.focus();
                }
            });
            activeTimeoutIds.push(timeoutId);
        }
        for(var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)restArgs[_key3 - 1] = arguments[_key3];
        onMouseDown === null || onMouseDown === void 0 || onMouseDown.apply(void 0, [
            event
        ].concat(restArgs));
    };
    // ============================ Dropdown ============================
    var _React$useState3 = $6fFrj.useState(null), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), containerWidth = _React$useState4[0], setContainerWidth = _React$useState4[1];
    var _React$useState5 = $6fFrj.useState({}), _React$useState6 = (0, $jP8CL.default)(_React$useState5, 2), forceUpdate = _React$useState6[1];
    // We need force update here since popup dom is render async
    function onPopupMouseEnter() {
        forceUpdate({});
    }
    (0, $dNZA9.default)(function() {
        if (triggerOpen) {
            var _containerRef$current;
            var newWidth = Math.ceil((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth);
            if (containerWidth !== newWidth && !Number.isNaN(newWidth)) setContainerWidth(newWidth);
        }
    }, [
        triggerOpen
    ]);
    // Used for raw custom input trigger
    var onTriggerVisibleChange;
    if (customizeRawInputElement) onTriggerVisibleChange = function onTriggerVisibleChange(newOpen) {
        onToggleOpen(newOpen);
    };
    // Close when click on non-select element
    (0, $ebc15b80ab2e30c4$export$2e2bcd8739ae039)(function() {
        var _triggerRef$current2;
        return [
            containerRef.current,
            (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.getPopupElement()
        ];
    }, triggerOpen, onToggleOpen, !!customizeRawInputElement);
    // ============================ Context =============================
    var baseSelectContext = $6fFrj.useMemo(function() {
        return (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
            notFoundContent: notFoundContent,
            open: mergedOpen,
            triggerOpen: triggerOpen,
            id: id,
            showSearch: mergedShowSearch,
            multiple: multiple,
            toggleOpen: onToggleOpen
        });
    }, [
        props,
        notFoundContent,
        triggerOpen,
        mergedOpen,
        id,
        mergedShowSearch,
        multiple,
        onToggleOpen
    ]);
    // ==================================================================
    // ==                            Render                            ==
    // ==================================================================
    // ============================= Arrow ==============================
    var mergedShowArrow = showArrow !== undefined ? showArrow : loading || !multiple && mode !== 'combobox';
    var arrowNode;
    if (mergedShowArrow) arrowNode = /*#__PURE__*/ $6fFrj.createElement((0, $cee3ce72adcc66e2$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-arrow"), (0, $43449.default)({}, "".concat(prefixCls, "-arrow-loading"), loading)),
        customizeIcon: inputIcon,
        customizeIconProps: {
            loading: loading,
            searchValue: mergedSearchValue,
            open: mergedOpen,
            focused: mockFocused,
            showSearch: mergedShowSearch
        }
    });
    // ============================= Clear ==============================
    var clearNode;
    var onClearMouseDown = function onClearMouseDown() {
        var _selectorRef$current4;
        onClear === null || onClear === void 0 || onClear();
        (_selectorRef$current4 = selectorRef.current) === null || _selectorRef$current4 === void 0 || _selectorRef$current4.focus();
        onDisplayValuesChange([], {
            type: 'clear',
            values: displayValues
        });
        onInternalSearch('', false, false);
    };
    if (!disabled && allowClear && (displayValues.length || mergedSearchValue) && !(mode === 'combobox' && mergedSearchValue === '')) clearNode = /*#__PURE__*/ $6fFrj.createElement((0, $cee3ce72adcc66e2$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-clear"),
        onMouseDown: onClearMouseDown,
        customizeIcon: clearIcon
    }, "\xD7");
    // =========================== OptionList ===========================
    var optionList = /*#__PURE__*/ $6fFrj.createElement(OptionList, {
        ref: listRef
    });
    // ============================= Select =============================
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className, (_classNames2 = {}, (0, $43449.default)(_classNames2, "".concat(prefixCls, "-focused"), mockFocused), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-multiple"), multiple), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-single"), !multiple), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-allow-clear"), allowClear), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-show-arrow"), mergedShowArrow), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-disabled"), disabled), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-loading"), loading), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-open"), mergedOpen), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-customize-input"), customizeInputElement), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-show-search"), mergedShowSearch), _classNames2));
    // >>> Selector
    var selectorNode = /*#__PURE__*/ $6fFrj.createElement((0, $facb87704719e132$export$2e2bcd8739ae039), {
        ref: triggerRef,
        disabled: disabled,
        prefixCls: prefixCls,
        visible: triggerOpen,
        popupElement: optionList,
        containerWidth: containerWidth,
        animation: animation,
        transitionName: transitionName,
        dropdownStyle: dropdownStyle,
        dropdownClassName: dropdownClassName,
        direction: direction,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        dropdownRender: dropdownRender,
        dropdownAlign: dropdownAlign,
        placement: placement,
        getPopupContainer: getPopupContainer,
        empty: emptyOptions,
        getTriggerDOMNode: function getTriggerDOMNode() {
            return selectorDomRef.current;
        },
        onPopupVisibleChange: onTriggerVisibleChange,
        onPopupMouseEnter: onPopupMouseEnter
    }, customizeRawInputElement ? /*#__PURE__*/ $6fFrj.cloneElement(customizeRawInputElement, {
        ref: customizeRawInputRef
    }) : /*#__PURE__*/ $6fFrj.createElement((0, $409a5de037f1543a$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        domRef: selectorDomRef,
        prefixCls: prefixCls,
        inputElement: customizeInputElement,
        ref: selectorRef,
        id: id,
        showSearch: mergedShowSearch,
        autoClearSearchValue: autoClearSearchValue,
        mode: mode,
        activeDescendantId: activeDescendantId,
        tagRender: tagRender,
        values: displayValues,
        open: mergedOpen,
        onToggleOpen: onToggleOpen,
        activeValue: activeValue,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        onSearchSubmit: onInternalSearchSubmit,
        onRemove: onSelectorRemove,
        tokenWithEnter: tokenWithEnter
    })));
    // >>> Render
    var renderNode;
    // Render raw
    if (customizeRawInputElement) renderNode = selectorNode;
    else renderNode = /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        className: mergedClassName
    }, domProps, {
        ref: containerRef,
        onMouseDown: onInternalMouseDown,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onFocus: onContainerFocus,
        onBlur: onContainerBlur
    }), mockFocused && !mergedOpen && /*#__PURE__*/ $6fFrj.createElement("span", {
        style: {
            width: 0,
            height: 0,
            position: 'absolute',
            overflow: 'hidden',
            opacity: 0
        },
        "aria-live": "polite"
    }, "".concat(displayValues.map(function(_ref) {
        var label = _ref.label, value = _ref.value;
        return [
            'number',
            'string'
        ].includes((0, $5KhTJ.default)(label)) ? label : value;
    }).join(', '))), selectorNode, arrowNode, clearNode);
    return /*#__PURE__*/ $6fFrj.createElement((0, $985f86b34f131ed8$export$8234047c0aea33cf).Provider, {
        value: baseSelectContext
    }, renderNode);
});
var $0f2850f876065ada$export$2e2bcd8739ae039 = $0f2850f876065ada$var$BaseSelect;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
var /**
 * Cache `value` related LabeledValue & options.
 */ $4770823214efc890$export$2e2bcd8739ae039 = function(labeledValues, valueOptions) {
    var cacheRef = $6fFrj.useRef({
        values: new Map(),
        options: new Map()
    });
    var filledLabeledValues = $6fFrj.useMemo(function() {
        var _cacheRef$current = cacheRef.current, prevValueCache = _cacheRef$current.values, prevOptionCache = _cacheRef$current.options;
        // Fill label by cache
        var patchedValues = labeledValues.map(function(item) {
            if (item.label === undefined) {
                var _prevValueCache$get;
                return (0, $kNxFX.default)((0, $kNxFX.default)({}, item), {}, {
                    label: (_prevValueCache$get = prevValueCache.get(item.value)) === null || _prevValueCache$get === void 0 ? void 0 : _prevValueCache$get.label
                });
            }
            return item;
        });
        // Refresh cache
        var valueCache = new Map();
        var optionCache = new Map();
        patchedValues.forEach(function(item) {
            valueCache.set(item.value, item);
            optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
        });
        cacheRef.current.values = valueCache;
        cacheRef.current.options = optionCache;
        return patchedValues;
    }, [
        labeledValues,
        valueOptions
    ]);
    var getOption = $6fFrj.useCallback(function(val) {
        return valueOptions.get(val) || cacheRef.current.options.get(val);
    }, [
        valueOptions
    ]);
    return [
        filledLabeledValues,
        getOption
    ];
};



var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");


function $b0028e6aa1f93e77$var$includes(test, search) {
    return (0, $b7fa77966f4f591e$export$45b10814cc054894)(test).join('').toUpperCase().includes(search);
}
var $b0028e6aa1f93e77$export$2e2bcd8739ae039 = function(options, fieldNames, searchValue, filterOption, optionFilterProp) {
    return $6fFrj.useMemo(function() {
        if (!searchValue || filterOption === false) return options;
        var fieldOptions = fieldNames.options, fieldLabel = fieldNames.label, fieldValue = fieldNames.value;
        var filteredOptions = [];
        var customizeFilter = typeof filterOption === 'function';
        var upperSearch = searchValue.toUpperCase();
        var filterFunc = customizeFilter ? filterOption : function(_, option) {
            // Use provided `optionFilterProp`
            if (optionFilterProp) return $b0028e6aa1f93e77$var$includes(option[optionFilterProp], upperSearch);
            // Auto select `label` or `value` by option type
            if (option[fieldOptions]) // hack `fieldLabel` since `OptionGroup` children is not `label`
            return $b0028e6aa1f93e77$var$includes(option[fieldLabel !== 'children' ? fieldLabel : 'label'], upperSearch);
            return $b0028e6aa1f93e77$var$includes(option[fieldValue], upperSearch);
        };
        var wrapOption = customizeFilter ? function(opt) {
            return (0, $3786d4546cc0f905$export$d0b21b213c8c013c)(opt);
        } : function(opt) {
            return opt;
        };
        options.forEach(function(item) {
            // Group should check child options
            if (item[fieldOptions]) {
                // Check group first
                var matchGroup = filterFunc(searchValue, wrapOption(item));
                if (matchGroup) filteredOptions.push(item);
                else {
                    // Check option
                    var subOptions = item[fieldOptions].filter(function(subItem) {
                        return filterFunc(searchValue, wrapOption(subItem));
                    });
                    if (subOptions.length) filteredOptions.push((0, $kNxFX.default)((0, $kNxFX.default)({}, item), {}, (0, $43449.default)({}, fieldOptions, subOptions)));
                }
                return;
            }
            if (filterFunc(searchValue, wrapOption(item))) filteredOptions.push(item);
        });
        return filteredOptions;
    }, [
        options,
        filterOption,
        optionFilterProp,
        searchValue,
        fieldNames
    ]);
};



var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $aSXdS = parcelRequire("aSXdS");
var $20e3a582558bc653$var$uuid = 0;
var $20e3a582558bc653$export$df7146797a248522 = (0, $aSXdS.default)();
function $20e3a582558bc653$export$36ec425867d538d7() {
    var retId;
    // Test never reach
    /* istanbul ignore if */ if ($20e3a582558bc653$export$df7146797a248522) {
        retId = $20e3a582558bc653$var$uuid;
        $20e3a582558bc653$var$uuid += 1;
    } else retId = 'TEST_OR_SSR';
    return retId;
}
function $20e3a582558bc653$export$2e2bcd8739ae039(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $6fFrj.useState(), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $6fFrj.useEffect(function() {
        setInnerId("rc_select_".concat($20e3a582558bc653$export$36ec425867d538d7()));
    }, []);
    return id || innerId;
}



var $6fFrj = parcelRequire("6fFrj");

var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $97c4086725496a31$var$_excluded = [
    "children",
    "value"
], $97c4086725496a31$var$_excluded2 = [
    "children"
];
function $97c4086725496a31$var$convertNodeToOption(node) {
    var _ref = node, key = _ref.key, _ref$props = _ref.props, children = _ref$props.children, value = _ref$props.value, restProps = (0, $04RxA.default)(_ref$props, $97c4086725496a31$var$_excluded);
    return (0, $kNxFX.default)({
        key: key,
        value: value !== undefined ? value : key,
        children: children
    }, restProps);
}
function $97c4086725496a31$export$3beca35db74c3985(nodes) {
    var optionOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(nodes).map(function(node, index) {
        if (!/*#__PURE__*/ $6fFrj.isValidElement(node) || !node.type) return null;
        var _ref2 = node, isSelectOptGroup = _ref2.type.isSelectOptGroup, key = _ref2.key, _ref2$props = _ref2.props, children = _ref2$props.children, restProps = (0, $04RxA.default)(_ref2$props, $97c4086725496a31$var$_excluded2);
        if (optionOnly || !isSelectOptGroup) return $97c4086725496a31$var$convertNodeToOption(node);
        return (0, $kNxFX.default)((0, $kNxFX.default)({
            key: "__RC_SELECT_GRP__".concat(key === null ? index : key, "__"),
            label: key
        }, restProps), {}, {
            options: $97c4086725496a31$export$3beca35db74c3985(children)
        });
    }).filter(function(data) {
        return data;
    });
}


function $513303323bda481f$export$2e2bcd8739ae039(options, children, fieldNames, optionFilterProp, optionLabelProp) {
    return $6fFrj.useMemo(function() {
        var mergedOptions = options;
        var childrenAsData = !options;
        if (childrenAsData) mergedOptions = (0, $97c4086725496a31$export$3beca35db74c3985)(children);
        var valueOptions = new Map();
        var labelOptions = new Map();
        var setLabelOptions = function setLabelOptions(labelOptionsMap, option, key) {
            if (key && typeof key === 'string') labelOptionsMap.set(option[key], option);
        };
        function dig(optionList) {
            var isChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            // for loop to speed up collection speed
            for(var i = 0; i < optionList.length; i += 1){
                var option = optionList[i];
                if (!option[fieldNames.options] || isChildren) {
                    valueOptions.set(option[fieldNames.value], option);
                    setLabelOptions(labelOptions, option, fieldNames.label);
                    // https://github.com/ant-design/ant-design/issues/35304
                    setLabelOptions(labelOptions, option, optionFilterProp);
                    setLabelOptions(labelOptions, option, optionLabelProp);
                } else dig(option[fieldNames.options], true);
            }
        }
        dig(mergedOptions);
        return {
            options: mergedOptions,
            valueOptions: valueOptions,
            labelOptions: labelOptions
        };
    }, [
        options,
        children,
        fieldNames,
        optionFilterProp,
        optionLabelProp
    ]);
}



var $6fFrj = parcelRequire("6fFrj");
function $5b6ab98badd23101$export$2e2bcd8739ae039(callback) {
    var funcRef = $6fFrj.useRef();
    funcRef.current = callback;
    var cacheFn = $6fFrj.useCallback(function() {
        return funcRef.current.apply(funcRef, arguments);
    }, []);
    return cacheFn;
}


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $a0f7385503db84a6$var$OptGroup = function OptGroup() {
    return null;
};
$a0f7385503db84a6$var$OptGroup.isSelectOptGroup = true;
var $a0f7385503db84a6$export$2e2bcd8739ae039 = $a0f7385503db84a6$var$OptGroup;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $b75b06eef9361259$var$Option = function Option() {
    return null;
};
$b75b06eef9361259$var$Option.isSelectOption = true;
var $b75b06eef9361259$export$2e2bcd8739ae039 = $b75b06eef9361259$var$Option;



var $43449 = parcelRequire("43449");

var $04RxA = parcelRequire("04RxA");

var $fIrcP = parcelRequire("fIrcP");

var $37xND = parcelRequire("37xND");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");




var $a5lfY = parcelRequire("a5lfY");

var $fActo = parcelRequire("fActo");

var $fIrcP = parcelRequire("fIrcP");

var $5KhTJ = parcelRequire("5KhTJ");

var $kNxFX = parcelRequire("kNxFX");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $fActo = parcelRequire("fActo");

parcelRequire("iVfr3");
var $2c6ch = parcelRequire("2c6ch");

var $dNZA9 = parcelRequire("dNZA9");

var $6fFrj = parcelRequire("6fFrj");

var $8CZEB = parcelRequire("8CZEB");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");


var $fActo = parcelRequire("fActo");
/**
 * Fill component to provided the scroll content real height.
 */ var $61c3b1811378a1af$var$Filler = /*#__PURE__*/ $6fFrj.forwardRef(function(_ref, ref) {
    var height = _ref.height, offsetY = _ref.offsetY, offsetX = _ref.offsetX, children = _ref.children, prefixCls = _ref.prefixCls, onInnerResize = _ref.onInnerResize, innerProps = _ref.innerProps, rtl = _ref.rtl, extra = _ref.extra;
    var outerStyle = {};
    var innerStyle = {
        display: 'flex',
        flexDirection: 'column'
    };
    if (offsetY !== undefined) {
        // Not set `width` since this will break `sticky: right`
        outerStyle = {
            height: height,
            position: 'relative',
            overflow: 'hidden'
        };
        innerStyle = (0, $kNxFX.default)((0, $kNxFX.default)({}, innerStyle), {}, (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({
            transform: "translateY(".concat(offsetY, "px)")
        }, rtl ? 'marginRight' : 'marginLeft', -offsetX), "position", 'absolute'), "left", 0), "right", 0), "top", 0));
    }
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        style: outerStyle
    }, /*#__PURE__*/ $6fFrj.createElement((0, $8e6bb008621f90f5$export$2e2bcd8739ae039), {
        onResize: function onResize(_ref2) {
            var offsetHeight = _ref2.offsetHeight;
            if (offsetHeight && onInnerResize) onInnerResize();
        }
    }, /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        style: innerStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
        ref: ref
    }, innerProps), children, extra)));
});
$61c3b1811378a1af$var$Filler.displayName = 'Filler';
var $61c3b1811378a1af$export$2e2bcd8739ae039 = $61c3b1811378a1af$var$Filler;



var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");
function $e0c7d1db396bbc23$export$6d08773d2e66f8f2(_ref) {
    var children = _ref.children, setRef = _ref.setRef;
    var refFunc = $6fFrj.useCallback(function(node) {
        setRef(node);
    }, []);
    return /*#__PURE__*/ $6fFrj.cloneElement(children, {
        ref: refFunc
    });
}


function $f22ab6ec8f7347c8$export$2e2bcd8739ae039(list, startIndex, endIndex, scrollWidth, offsetX, setNodeRef, renderFunc, _ref) {
    var getKey = _ref.getKey;
    return list.slice(startIndex, endIndex + 1).map(function(item, index) {
        var eleIndex = startIndex + index;
        var node = renderFunc(item, eleIndex, {
            style: {
                width: scrollWidth
            },
            offsetX: offsetX
        });
        var key = getKey(item);
        return /*#__PURE__*/ $6fFrj.createElement((0, $e0c7d1db396bbc23$export$6d08773d2e66f8f2), {
            key: key,
            setRef: function setRef(ele) {
                return setNodeRef(item, ele);
            }
        }, node);
    });
}



var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */ function $af365046ca215a55$export$38f9023d45dd4a23(min, max, start, index) {
    var beforeCount = start - min;
    var afterCount = max - start;
    var balanceCount = Math.min(beforeCount, afterCount) * 2;
    // Balance
    if (index <= balanceCount) {
        var stepIndex = Math.floor(index / 2);
        if (index % 2) return start + stepIndex + 1;
        return start - stepIndex;
    }
    // One is out of range
    if (beforeCount > afterCount) return start - (index - afterCount);
    return start + (index - beforeCount);
}
function $af365046ca215a55$export$418b8d8b03eefdf5(originList, targetList, getKey) {
    var originLen = originList.length;
    var targetLen = targetList.length;
    var shortList;
    var longList;
    if (originLen === 0 && targetLen === 0) return null;
    if (originLen < targetLen) {
        shortList = originList;
        longList = targetList;
    } else {
        shortList = targetList;
        longList = originList;
    }
    var notExistKey = {
        __EMPTY_ITEM__: true
    };
    function getItemKey(item) {
        if (item !== undefined) return getKey(item);
        return notExistKey;
    }
    // Loop to find diff one
    var diffIndex = null;
    var multiple = Math.abs(originLen - targetLen) !== 1;
    for(var i = 0; i < longList.length; i += 1){
        var shortKey = getItemKey(shortList[i]);
        var longKey = getItemKey(longList[i]);
        if (shortKey !== longKey) {
            diffIndex = i;
            multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
            break;
        }
    }
    return diffIndex === null ? null : {
        index: diffIndex,
        multiple: multiple
    };
}


function $7c787590174d303b$export$2e2bcd8739ae039(data, getKey, onDiff) {
    var _React$useState = $6fFrj.useState(data), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), prevData = _React$useState2[0], setPrevData = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState(null), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), diffItem = _React$useState4[0], setDiffItem = _React$useState4[1];
    $6fFrj.useEffect(function() {
        var diff = (0, $af365046ca215a55$export$418b8d8b03eefdf5)(prevData || [], data || [], getKey);
        if ((diff === null || diff === void 0 ? void 0 : diff.index) !== undefined) {
            onDiff === null || onDiff === void 0 || onDiff(diff.index);
            setDiffItem(data[diff.index]);
        }
        setPrevData(data);
    }, [
        data
    ]);
    return [
        diffItem
    ];
}



var $hqic8 = parcelRequire("hqic8");

var $6fFrj = parcelRequire("6fFrj");

var $5KhTJ = parcelRequire("5KhTJ");
var $cca467234e868044$var$isFF = (typeof navigator === "undefined" ? "undefined" : (0, $5KhTJ.default)(navigator)) === 'object' && /Firefox/i.test(navigator.userAgent);
var $cca467234e868044$export$2e2bcd8739ae039 = $cca467234e868044$var$isFF;



var $6fFrj = parcelRequire("6fFrj");
var $e3999430a384dee7$export$2e2bcd8739ae039 = function(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight) {
    // Do lock for a wheel when scrolling
    var lockRef = (0, $6fFrj.useRef)(false);
    var lockTimeoutRef = (0, $6fFrj.useRef)(null);
    function lockScroll() {
        clearTimeout(lockTimeoutRef.current);
        lockRef.current = true;
        lockTimeoutRef.current = setTimeout(function() {
            lockRef.current = false;
        }, 50);
    }
    // Pass to ref since global add is in closure
    var scrollPingRef = (0, $6fFrj.useRef)({
        top: isScrollAtTop,
        bottom: isScrollAtBottom,
        left: isScrollAtLeft,
        right: isScrollAtRight
    });
    scrollPingRef.current.top = isScrollAtTop;
    scrollPingRef.current.bottom = isScrollAtBottom;
    scrollPingRef.current.left = isScrollAtLeft;
    scrollPingRef.current.right = isScrollAtRight;
    return function(isHorizontal, delta) {
        var smoothOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var originScroll = isHorizontal ? // Pass origin wheel when on the left
        delta < 0 && scrollPingRef.current.left || // Pass origin wheel when on the right
        delta > 0 && scrollPingRef.current.right // Pass origin wheel when on the top
         : delta < 0 && scrollPingRef.current.top || // Pass origin wheel when on the bottom
        delta > 0 && scrollPingRef.current.bottom;
        if (smoothOffset && originScroll) {
            // No need lock anymore when it's smooth offset from touchMove interval
            clearTimeout(lockTimeoutRef.current);
            lockRef.current = false;
        } else if (!originScroll || lockRef.current) lockScroll();
        return !lockRef.current && originScroll;
    };
};


function $dbc441870a13e7fd$export$2e2bcd8739ae039(inVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, horizontalScroll, /***
 * Return `true` when you need to prevent default event
 */ onWheelDelta) {
    var offsetRef = (0, $6fFrj.useRef)(0);
    var nextFrameRef = (0, $6fFrj.useRef)(null);
    // Firefox patch
    var wheelValueRef = (0, $6fFrj.useRef)(null);
    var isMouseScrollRef = (0, $6fFrj.useRef)(false);
    // Scroll status sync
    var originScroll = (0, $e3999430a384dee7$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    function onWheelY(e, deltaY) {
        (0, $hqic8.default).cancel(nextFrameRef.current);
        // Do nothing when scroll at the edge, Skip check when is in scroll
        if (originScroll(false, deltaY)) return;
        // Skip if nest List has handled this event
        var event = e;
        if (!event._virtualHandled) event._virtualHandled = true;
        else return;
        offsetRef.current += deltaY;
        wheelValueRef.current = deltaY;
        // Proxy of scroll events
        if (!(0, $cca467234e868044$export$2e2bcd8739ae039)) event.preventDefault();
        nextFrameRef.current = (0, $hqic8.default)(function() {
            // Patch a multiple for Firefox to fix wheel number too small
            // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
            var patchMultiple = isMouseScrollRef.current ? 10 : 1;
            onWheelDelta(offsetRef.current * patchMultiple, false);
            offsetRef.current = 0;
        });
    }
    function onWheelX(event, deltaX) {
        onWheelDelta(deltaX, true);
        if (!(0, $cca467234e868044$export$2e2bcd8739ae039)) event.preventDefault();
    }
    // Check for which direction does wheel do. `sx` means `shift + wheel`
    var wheelDirectionRef = (0, $6fFrj.useRef)(null);
    var wheelDirectionCleanRef = (0, $6fFrj.useRef)(null);
    function onWheel(event) {
        if (!inVirtual) return;
        // Wait for 2 frame to clean direction
        (0, $hqic8.default).cancel(wheelDirectionCleanRef.current);
        wheelDirectionCleanRef.current = (0, $hqic8.default)(function() {
            wheelDirectionRef.current = null;
        }, 2);
        var deltaX = event.deltaX, deltaY = event.deltaY, shiftKey = event.shiftKey;
        var mergedDeltaX = deltaX;
        var mergedDeltaY = deltaY;
        if (wheelDirectionRef.current === 'sx' || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
            mergedDeltaX = deltaY;
            mergedDeltaY = 0;
            wheelDirectionRef.current = 'sx';
        }
        var absX = Math.abs(mergedDeltaX);
        var absY = Math.abs(mergedDeltaY);
        if (wheelDirectionRef.current === null) wheelDirectionRef.current = horizontalScroll && absX > absY ? 'x' : 'y';
        if (wheelDirectionRef.current === 'y') onWheelY(event, mergedDeltaY);
        else onWheelX(event, mergedDeltaX);
    }
    // A patch for firefox
    function onFireFoxScroll(event) {
        if (!inVirtual) return;
        isMouseScrollRef.current = event.detail === wheelValueRef.current;
    }
    return [
        onWheel,
        onFireFoxScroll
    ];
}



var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
function $c4a02bf9a7c05b3c$export$a1d82723752af087(mergedData, getKey, heights, itemHeight) {
    var _React$useMemo = $6fFrj.useMemo(function() {
        return [
            new Map(),
            []
        ];
    }, [
        mergedData,
        heights.id,
        itemHeight
    ]), _React$useMemo2 = (0, $jP8CL.default)(_React$useMemo, 2), key2Index = _React$useMemo2[0], bottomList = _React$useMemo2[1];
    var getSize = function getSize(startKey) {
        var endKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startKey;
        // Get from cache first
        var startIndex = key2Index.get(startKey);
        var endIndex = key2Index.get(endKey);
        // Loop to fill the cache
        if (startIndex === undefined || endIndex === undefined) {
            var dataLen = mergedData.length;
            for(var i = bottomList.length; i < dataLen; i += 1){
                var _heights$get;
                var item = mergedData[i];
                var key = getKey(item);
                key2Index.set(key, i);
                var cacheHeight = (_heights$get = heights.get(key)) !== null && _heights$get !== void 0 ? _heights$get : itemHeight;
                bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
                if (key === startKey) startIndex = i;
                if (key === endKey) endIndex = i;
                if (startIndex !== undefined && endIndex !== undefined) break;
            }
        }
        return {
            top: bottomList[startIndex - 1] || 0,
            bottom: bottomList[endIndex]
        };
    };
    return getSize;
}



var $jP8CL = parcelRequire("jP8CL");

var $k5B64 = parcelRequire("k5B64");

var $hqic8 = parcelRequire("hqic8");

var $6fFrj = parcelRequire("6fFrj");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $43449 = parcelRequire("43449");
// Firefox has low performance of map.
var $a1bbf4edbaad1243$var$CacheMap = /*#__PURE__*/ function() {
    function CacheMap() {
        (0, $kjNeN.default)(this, CacheMap);
        (0, $43449.default)(this, "maps", void 0);
        // Used for cache key
        // `useMemo` no need to update if `id` not change
        (0, $43449.default)(this, "id", 0);
        this.maps = Object.create(null);
    }
    (0, $5KQxu.default)(CacheMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.maps[key] = value;
                this.id += 1;
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.maps[key];
            }
        }
    ]);
    return CacheMap;
}();
var $a1bbf4edbaad1243$export$2e2bcd8739ae039 = $a1bbf4edbaad1243$var$CacheMap;


function $d184ad1b53202be6$var$parseNumber(value) {
    var num = parseFloat(value);
    return isNaN(num) ? 0 : num;
}
function $d184ad1b53202be6$export$2e2bcd8739ae039(getKey, onItemAdd, onItemRemove) {
    var _React$useState = $6fFrj.useState(0), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), updatedMark = _React$useState2[0], setUpdatedMark = _React$useState2[1];
    var instanceRef = (0, $6fFrj.useRef)(new Map());
    var heightsRef = (0, $6fFrj.useRef)(new (0, $a1bbf4edbaad1243$export$2e2bcd8739ae039)());
    var collectRafRef = (0, $6fFrj.useRef)();
    function cancelRaf() {
        (0, $hqic8.default).cancel(collectRafRef.current);
    }
    function collectHeight() {
        var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        cancelRaf();
        var doCollect = function doCollect() {
            instanceRef.current.forEach(function(element, key) {
                if (element && element.offsetParent) {
                    var htmlElement = (0, $k5B64.default)(element);
                    var offsetHeight = htmlElement.offsetHeight;
                    var _getComputedStyle = getComputedStyle(htmlElement), marginTop = _getComputedStyle.marginTop, marginBottom = _getComputedStyle.marginBottom;
                    var marginTopNum = $d184ad1b53202be6$var$parseNumber(marginTop);
                    var marginBottomNum = $d184ad1b53202be6$var$parseNumber(marginBottom);
                    var totalHeight = offsetHeight + marginTopNum + marginBottomNum;
                    if (heightsRef.current.get(key) !== totalHeight) heightsRef.current.set(key, totalHeight);
                }
            });
            // Always trigger update mark to tell parent that should re-calculate heights when resized
            setUpdatedMark(function(c) {
                return c + 1;
            });
        };
        if (sync) doCollect();
        else collectRafRef.current = (0, $hqic8.default)(doCollect);
    }
    function setInstanceRef(item, instance) {
        var key = getKey(item);
        var origin = instanceRef.current.get(key);
        if (instance) {
            instanceRef.current.set(key, instance);
            collectHeight();
        } else instanceRef.current.delete(key);
        // Instance changed
        if (!origin !== !instance) {
            if (instance) onItemAdd === null || onItemAdd === void 0 || onItemAdd(item);
            else onItemRemove === null || onItemRemove === void 0 || onItemRemove(item);
        }
    }
    (0, $6fFrj.useEffect)(function() {
        return cancelRaf;
    }, []);
    return [
        setInstanceRef,
        collectHeight,
        heightsRef.current,
        updatedMark
    ];
}



var $dNZA9 = parcelRequire("dNZA9");

var $6fFrj = parcelRequire("6fFrj");
var $6ced69326f336dcb$var$SMOOTH_PTG = 14 / 15;
function $6ced69326f336dcb$export$2e2bcd8739ae039(inVirtual, listRef, callback) {
    var touchedRef = (0, $6fFrj.useRef)(false);
    var touchXRef = (0, $6fFrj.useRef)(0);
    var touchYRef = (0, $6fFrj.useRef)(0);
    var elementRef = (0, $6fFrj.useRef)(null);
    // Smooth scroll
    var intervalRef = (0, $6fFrj.useRef)(null);
    /* eslint-disable prefer-const */ var cleanUpEvents;
    var onTouchMove = function onTouchMove(e) {
        if (touchedRef.current) {
            var currentX = Math.ceil(e.touches[0].pageX);
            var currentY = Math.ceil(e.touches[0].pageY);
            var offsetX = touchXRef.current - currentX;
            var offsetY = touchYRef.current - currentY;
            var _isHorizontal = Math.abs(offsetX) > Math.abs(offsetY);
            if (_isHorizontal) touchXRef.current = currentX;
            else touchYRef.current = currentY;
            var scrollHandled = callback(_isHorizontal, _isHorizontal ? offsetX : offsetY, false, e);
            if (scrollHandled) e.preventDefault();
            // Smooth interval
            clearInterval(intervalRef.current);
            if (scrollHandled) intervalRef.current = setInterval(function() {
                if (_isHorizontal) offsetX *= $6ced69326f336dcb$var$SMOOTH_PTG;
                else offsetY *= $6ced69326f336dcb$var$SMOOTH_PTG;
                var offset = Math.floor(_isHorizontal ? offsetX : offsetY);
                if (!callback(_isHorizontal, offset, true) || Math.abs(offset) <= 0.1) clearInterval(intervalRef.current);
            }, 16);
        }
    };
    var onTouchEnd = function onTouchEnd() {
        touchedRef.current = false;
        cleanUpEvents();
    };
    var onTouchStart = function onTouchStart(e) {
        cleanUpEvents();
        if (e.touches.length === 1 && !touchedRef.current) {
            touchedRef.current = true;
            touchXRef.current = Math.ceil(e.touches[0].pageX);
            touchYRef.current = Math.ceil(e.touches[0].pageY);
            elementRef.current = e.target;
            elementRef.current.addEventListener('touchmove', onTouchMove, {
                passive: false
            });
            elementRef.current.addEventListener('touchend', onTouchEnd, {
                passive: true
            });
        }
    };
    cleanUpEvents = function cleanUpEvents() {
        if (elementRef.current) {
            elementRef.current.removeEventListener('touchmove', onTouchMove);
            elementRef.current.removeEventListener('touchend', onTouchEnd);
        }
    };
    (0, $dNZA9.default)(function() {
        if (inVirtual) listRef.current.addEventListener('touchstart', onTouchStart, {
            passive: true
        });
        return function() {
            var _listRef$current;
            (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.removeEventListener('touchstart', onTouchStart);
            cleanUpEvents();
            clearInterval(intervalRef.current);
        };
    }, [
        inVirtual
    ]);
}




var $hqic8 = parcelRequire("hqic8");

var $6fFrj = parcelRequire("6fFrj");
function $83130f490ecddc47$var$smoothScrollOffset(offset) {
    return Math.floor(Math.pow(offset, 0.5));
}
function $83130f490ecddc47$export$dbd0143e191dc2e5(e, horizontal) {
    var obj = 'touches' in e ? e.touches[0] : e;
    return obj[horizontal ? 'pageX' : 'pageY'] - window[horizontal ? 'scrollX' : 'scrollY'];
}
function $83130f490ecddc47$export$2e2bcd8739ae039(inVirtual, componentRef, onScrollOffset) {
    $6fFrj.useEffect(function() {
        var ele = componentRef.current;
        if (inVirtual && ele) {
            var mouseDownLock = false;
            var rafId;
            var _offset;
            var stopScroll = function stopScroll() {
                (0, $hqic8.default).cancel(rafId);
            };
            var continueScroll = function continueScroll() {
                stopScroll();
                rafId = (0, $hqic8.default)(function() {
                    onScrollOffset(_offset);
                    continueScroll();
                });
            };
            var onMouseDown = function onMouseDown(e) {
                // Skip if nest List has handled this event
                var event = e;
                if (!event._virtualHandled) {
                    event._virtualHandled = true;
                    mouseDownLock = true;
                }
            };
            var onMouseUp = function onMouseUp() {
                mouseDownLock = false;
                stopScroll();
            };
            var onMouseMove = function onMouseMove(e) {
                if (mouseDownLock) {
                    var mouseY = $83130f490ecddc47$export$dbd0143e191dc2e5(e, false);
                    var _ele$getBoundingClien = ele.getBoundingClientRect(), top = _ele$getBoundingClien.top, bottom = _ele$getBoundingClien.bottom;
                    if (mouseY <= top) {
                        var diff = top - mouseY;
                        _offset = -$83130f490ecddc47$var$smoothScrollOffset(diff);
                        continueScroll();
                    } else if (mouseY >= bottom) {
                        var _diff = mouseY - bottom;
                        _offset = $83130f490ecddc47$var$smoothScrollOffset(_diff);
                        continueScroll();
                    } else stopScroll();
                }
            };
            ele.addEventListener('mousedown', onMouseDown);
            ele.ownerDocument.addEventListener('mouseup', onMouseUp);
            ele.ownerDocument.addEventListener('mousemove', onMouseMove);
            return function() {
                ele.removeEventListener('mousedown', onMouseDown);
                ele.ownerDocument.removeEventListener('mouseup', onMouseUp);
                ele.ownerDocument.removeEventListener('mousemove', onMouseMove);
                stopScroll();
            };
        }
    }, [
        inVirtual
    ]);
}



var $5KhTJ = parcelRequire("5KhTJ");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $hqic8 = parcelRequire("hqic8");

var $dNZA9 = parcelRequire("dNZA9");
parcelRequire("iVfr3");
var $cee9e1b4d1eee547$var$MAX_TIMES = 10;
function $cee9e1b4d1eee547$export$2e2bcd8739ae039(containerRef, data, heights, itemHeight, getKey, collectHeight, syncScrollTop, triggerFlash) {
    var scrollRef = $6fFrj.useRef();
    var _React$useState = $6fFrj.useState(null), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), syncState = _React$useState2[0], setSyncState = _React$useState2[1];
    // ========================== Sync Scroll ==========================
    (0, $dNZA9.default)(function() {
        if (syncState && syncState.times < $cee9e1b4d1eee547$var$MAX_TIMES) {
            // Never reach
            if (!containerRef.current) {
                setSyncState(function(ori) {
                    return (0, $kNxFX.default)({}, ori);
                });
                return;
            }
            collectHeight();
            var targetAlign = syncState.targetAlign, originAlign = syncState.originAlign, index = syncState.index, offset = syncState.offset;
            var height = containerRef.current.clientHeight;
            var needCollectHeight = false;
            var newTargetAlign = targetAlign;
            var targetTop = null;
            // Go to next frame if height not exist
            if (height) {
                var mergedAlign = targetAlign || originAlign;
                // Get top & bottom
                var stackTop = 0;
                var itemTop = 0;
                var itemBottom = 0;
                var maxLen = Math.min(data.length - 1, index);
                for(var i = 0; i <= maxLen; i += 1){
                    var key = getKey(data[i]);
                    itemTop = stackTop;
                    var cacheHeight = heights.get(key);
                    itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
                    stackTop = itemBottom;
                }
                // Check if need sync height (visible range has item not record height)
                var leftHeight = mergedAlign === 'top' ? offset : height - offset;
                for(var _i = maxLen; _i >= 0; _i -= 1){
                    var _key = getKey(data[_i]);
                    var _cacheHeight = heights.get(_key);
                    if (_cacheHeight === undefined) {
                        needCollectHeight = true;
                        break;
                    }
                    leftHeight -= _cacheHeight;
                    if (leftHeight <= 0) break;
                }
                // Scroll to
                switch(mergedAlign){
                    case 'top':
                        targetTop = itemTop - offset;
                        break;
                    case 'bottom':
                        targetTop = itemBottom - height + offset;
                        break;
                    default:
                        var scrollTop = containerRef.current.scrollTop;
                        var scrollBottom = scrollTop + height;
                        if (itemTop < scrollTop) newTargetAlign = 'top';
                        else if (itemBottom > scrollBottom) newTargetAlign = 'bottom';
                }
                if (targetTop !== null) syncScrollTop(targetTop);
                // One more time for sync
                if (targetTop !== syncState.lastTop) needCollectHeight = true;
            }
            // Trigger next effect
            if (needCollectHeight) setSyncState((0, $kNxFX.default)((0, $kNxFX.default)({}, syncState), {}, {
                times: syncState.times + 1,
                targetAlign: newTargetAlign,
                lastTop: targetTop
            }));
        }
    }, [
        syncState,
        containerRef.current
    ]);
    // =========================== Scroll To ===========================
    return function(arg) {
        // When not argument provided, we think dev may want to show the scrollbar
        if (arg === null || arg === undefined) {
            triggerFlash();
            return;
        }
        // Normal scroll logic
        (0, $hqic8.default).cancel(scrollRef.current);
        if (typeof arg === 'number') syncScrollTop(arg);
        else if (arg && (0, $5KhTJ.default)(arg) === 'object') {
            var index;
            var align = arg.align;
            if ('index' in arg) index = arg.index;
            else index = data.findIndex(function(item) {
                return getKey(item) === arg.key;
            });
            var _arg$offset = arg.offset, offset = _arg$offset === void 0 ? 0 : _arg$offset;
            setSyncState({
                times: 0,
                index: index,
                offset: offset,
                originAlign: align
            });
        }
    };
}



var $kNxFX = parcelRequire("kNxFX");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $fActo = parcelRequire("fActo");

var $hqic8 = parcelRequire("hqic8");

var $6fFrj = parcelRequire("6fFrj");

var $41eafd18575d2334$var$ScrollBar = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, rtl = props.rtl, scrollOffset = props.scrollOffset, scrollRange = props.scrollRange, onStartMove = props.onStartMove, onStopMove = props.onStopMove, onScroll = props.onScroll, horizontal = props.horizontal, spinSize = props.spinSize, containerSize = props.containerSize, style = props.style, propsThumbStyle = props.thumbStyle;
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), dragging = _React$useState2[0], setDragging = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState(null), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), pageXY = _React$useState4[0], setPageXY = _React$useState4[1];
    var _React$useState5 = $6fFrj.useState(null), _React$useState6 = (0, $jP8CL.default)(_React$useState5, 2), startTop = _React$useState6[0], setStartTop = _React$useState6[1];
    var isLTR = !rtl;
    // ========================= Refs =========================
    var scrollbarRef = $6fFrj.useRef();
    var thumbRef = $6fFrj.useRef();
    // ======================= Visible ========================
    var _React$useState7 = $6fFrj.useState(false), _React$useState8 = (0, $jP8CL.default)(_React$useState7, 2), visible = _React$useState8[0], setVisible = _React$useState8[1];
    var visibleTimeoutRef = $6fFrj.useRef();
    var delayHidden = function delayHidden() {
        clearTimeout(visibleTimeoutRef.current);
        setVisible(true);
        visibleTimeoutRef.current = setTimeout(function() {
            setVisible(false);
        }, 3000);
    };
    // ======================== Range =========================
    var enableScrollRange = scrollRange - containerSize || 0;
    var enableOffsetRange = containerSize - spinSize || 0;
    // ========================= Top ==========================
    var top = $6fFrj.useMemo(function() {
        if (scrollOffset === 0 || enableScrollRange === 0) return 0;
        var ptg = scrollOffset / enableScrollRange;
        return ptg * enableOffsetRange;
    }, [
        scrollOffset,
        enableScrollRange,
        enableOffsetRange
    ]);
    // ====================== Container =======================
    var onContainerMouseDown = function onContainerMouseDown(e) {
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Thumb =========================
    var stateRef = $6fFrj.useRef({
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    });
    stateRef.current = {
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    };
    var onThumbMouseDown = function onThumbMouseDown(e) {
        setDragging(true);
        setPageXY((0, $83130f490ecddc47$export$dbd0143e191dc2e5)(e, horizontal));
        setStartTop(stateRef.current.top);
        onStartMove();
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Effect ========================
    // React make event as passive, but we need to preventDefault
    // Add event on dom directly instead.
    // ref: https://github.com/facebook/react/issues/9809
    $6fFrj.useEffect(function() {
        var onScrollbarTouchStart = function onScrollbarTouchStart(e) {
            e.preventDefault();
        };
        var scrollbarEle = scrollbarRef.current;
        var thumbEle = thumbRef.current;
        scrollbarEle.addEventListener('touchstart', onScrollbarTouchStart, {
            passive: false
        });
        thumbEle.addEventListener('touchstart', onThumbMouseDown, {
            passive: false
        });
        return function() {
            scrollbarEle.removeEventListener('touchstart', onScrollbarTouchStart);
            thumbEle.removeEventListener('touchstart', onThumbMouseDown);
        };
    }, []);
    // Pass to effect
    var enableScrollRangeRef = $6fFrj.useRef();
    enableScrollRangeRef.current = enableScrollRange;
    var enableOffsetRangeRef = $6fFrj.useRef();
    enableOffsetRangeRef.current = enableOffsetRange;
    $6fFrj.useEffect(function() {
        if (dragging) {
            var moveRafId;
            var onMouseMove = function onMouseMove(e) {
                var _stateRef$current = stateRef.current, stateDragging = _stateRef$current.dragging, statePageY = _stateRef$current.pageY, stateStartTop = _stateRef$current.startTop;
                (0, $hqic8.default).cancel(moveRafId);
                var rect = scrollbarRef.current.getBoundingClientRect();
                var scale = containerSize / (horizontal ? rect.width : rect.height);
                if (stateDragging) {
                    var offset = ((0, $83130f490ecddc47$export$dbd0143e191dc2e5)(e, horizontal) - statePageY) * scale;
                    var newTop = stateStartTop;
                    if (!isLTR && horizontal) newTop -= offset;
                    else newTop += offset;
                    var tmpEnableScrollRange = enableScrollRangeRef.current;
                    var tmpEnableOffsetRange = enableOffsetRangeRef.current;
                    var ptg = tmpEnableOffsetRange ? newTop / tmpEnableOffsetRange : 0;
                    var newScrollTop = Math.ceil(ptg * tmpEnableScrollRange);
                    newScrollTop = Math.max(newScrollTop, 0);
                    newScrollTop = Math.min(newScrollTop, tmpEnableScrollRange);
                    moveRafId = (0, $hqic8.default)(function() {
                        onScroll(newScrollTop, horizontal);
                    });
                }
            };
            var onMouseUp = function onMouseUp() {
                setDragging(false);
                onStopMove();
            };
            window.addEventListener('mousemove', onMouseMove, {
                passive: true
            });
            window.addEventListener('touchmove', onMouseMove, {
                passive: true
            });
            window.addEventListener('mouseup', onMouseUp, {
                passive: true
            });
            window.addEventListener('touchend', onMouseUp, {
                passive: true
            });
            return function() {
                window.removeEventListener('mousemove', onMouseMove);
                window.removeEventListener('touchmove', onMouseMove);
                window.removeEventListener('mouseup', onMouseUp);
                window.removeEventListener('touchend', onMouseUp);
                (0, $hqic8.default).cancel(moveRafId);
            };
        }
    }, [
        dragging
    ]);
    $6fFrj.useEffect(function() {
        delayHidden();
        return function() {
            clearTimeout(visibleTimeoutRef.current);
        };
    }, [
        scrollOffset
    ]);
    // ====================== Imperative ======================
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            delayHidden: delayHidden
        };
    });
    // ======================== Render ========================
    var scrollbarPrefixCls = "".concat(prefixCls, "-scrollbar");
    var containerStyle = {
        position: 'absolute',
        visibility: visible ? null : 'hidden'
    };
    var thumbStyle = {
        position: 'absolute',
        background: 'rgba(0, 0, 0, 0.5)',
        borderRadius: 99,
        cursor: 'pointer',
        userSelect: 'none'
    };
    if (horizontal) {
        // Container
        containerStyle.height = 8;
        containerStyle.left = 0;
        containerStyle.right = 0;
        containerStyle.bottom = 0;
        // Thumb
        thumbStyle.height = '100%';
        thumbStyle.width = spinSize;
        if (isLTR) thumbStyle.left = top;
        else thumbStyle.right = top;
    } else {
        // Container
        containerStyle.width = 8;
        containerStyle.top = 0;
        containerStyle.bottom = 0;
        if (isLTR) containerStyle.right = 0;
        else containerStyle.left = 0;
        // Thumb
        thumbStyle.width = '100%';
        thumbStyle.height = spinSize;
        thumbStyle.top = top;
    }
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        ref: scrollbarRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(scrollbarPrefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(scrollbarPrefixCls, "-horizontal"), horizontal), "".concat(scrollbarPrefixCls, "-vertical"), !horizontal), "".concat(scrollbarPrefixCls, "-visible"), visible)),
        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, containerStyle), style),
        onMouseDown: onContainerMouseDown,
        onMouseMove: delayHidden
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        ref: thumbRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(scrollbarPrefixCls, "-thumb"), (0, $43449.default)({}, "".concat(scrollbarPrefixCls, "-thumb-moving"), dragging)),
        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, thumbStyle), propsThumbStyle),
        onMouseDown: onThumbMouseDown
    }));
});
var $41eafd18575d2334$export$2e2bcd8739ae039 = $41eafd18575d2334$var$ScrollBar;


var $deeefb6569db0322$var$MIN_SIZE = 20;
function $deeefb6569db0322$export$f2ca68955ab35ace() {
    var containerSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var scrollRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var baseSize = containerSize / scrollRange * containerSize;
    if (isNaN(baseSize)) baseSize = 0;
    baseSize = Math.max(baseSize, $deeefb6569db0322$var$MIN_SIZE);
    return Math.floor(baseSize);
}


var $a4482c7f07480f40$var$_excluded = [
    "prefixCls",
    "className",
    "height",
    "itemHeight",
    "fullHeight",
    "style",
    "data",
    "children",
    "itemKey",
    "virtual",
    "direction",
    "scrollWidth",
    "component",
    "onScroll",
    "onVirtualScroll",
    "onVisibleChange",
    "innerProps",
    "extraRender",
    "styles"
];
var $a4482c7f07480f40$var$EMPTY_DATA = [];
var $a4482c7f07480f40$var$ScrollStyle = {
    overflowY: 'auto',
    overflowAnchor: 'none'
};
function $a4482c7f07480f40$export$cc3be4e46e8486ed(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-virtual-list' : _props$prefixCls, className = props.className, height = props.height, itemHeight = props.itemHeight, _props$fullHeight = props.fullHeight, fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight, style = props.style, data = props.data, children = props.children, itemKey = props.itemKey, virtual = props.virtual, direction = props.direction, scrollWidth = props.scrollWidth, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, onScroll = props.onScroll, onVirtualScroll = props.onVirtualScroll, onVisibleChange = props.onVisibleChange, innerProps = props.innerProps, extraRender = props.extraRender, styles = props.styles, restProps = (0, $04RxA.default)(props, $a4482c7f07480f40$var$_excluded);
    // =============================== Item Key ===============================
    var getKey = $6fFrj.useCallback(function(item) {
        if (typeof itemKey === 'function') return itemKey(item);
        return item === null || item === void 0 ? void 0 : item[itemKey];
    }, [
        itemKey
    ]);
    // ================================ Height ================================
    var _useHeights = (0, $d184ad1b53202be6$export$2e2bcd8739ae039)(getKey, null, null), _useHeights2 = (0, $jP8CL.default)(_useHeights, 4), setInstanceRef = _useHeights2[0], collectHeight = _useHeights2[1], heights = _useHeights2[2], heightUpdatedMark = _useHeights2[3];
    // ================================= MISC =================================
    var useVirtual = !!(virtual !== false && height && itemHeight);
    var containerHeight = $6fFrj.useMemo(function() {
        return Object.values(heights.maps).reduce(function(total, curr) {
            return total + curr;
        }, 0);
    }, [
        heights.id,
        heights.maps
    ]);
    var inVirtual = useVirtual && data && (Math.max(itemHeight * data.length, containerHeight) > height || !!scrollWidth);
    var isRTL = direction === 'rtl';
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)({}, "".concat(prefixCls, "-rtl"), isRTL), className);
    var mergedData = data || $a4482c7f07480f40$var$EMPTY_DATA;
    var componentRef = (0, $6fFrj.useRef)();
    var fillerInnerRef = (0, $6fFrj.useRef)();
    var containerRef = (0, $6fFrj.useRef)();
    // =============================== Item Key ===============================
    var _useState = (0, $6fFrj.useState)(0), _useState2 = (0, $jP8CL.default)(_useState, 2), offsetTop = _useState2[0], setOffsetTop = _useState2[1];
    var _useState3 = (0, $6fFrj.useState)(0), _useState4 = (0, $jP8CL.default)(_useState3, 2), offsetLeft = _useState4[0], setOffsetLeft = _useState4[1];
    var _useState5 = (0, $6fFrj.useState)(false), _useState6 = (0, $jP8CL.default)(_useState5, 2), scrollMoving = _useState6[0], setScrollMoving = _useState6[1];
    var onScrollbarStartMove = function onScrollbarStartMove() {
        setScrollMoving(true);
    };
    var onScrollbarStopMove = function onScrollbarStopMove() {
        setScrollMoving(false);
    };
    var sharedConfig = {
        getKey: getKey
    };
    // ================================ Scroll ================================
    function syncScrollTop(newTop) {
        setOffsetTop(function(origin) {
            var value;
            if (typeof newTop === 'function') value = newTop(origin);
            else value = newTop;
            var alignedTop = keepInRange(value);
            componentRef.current.scrollTop = alignedTop;
            return alignedTop;
        });
    }
    // ================================ Legacy ================================
    // Put ref here since the range is generate by follow
    var rangeRef = (0, $6fFrj.useRef)({
        start: 0,
        end: mergedData.length
    });
    var diffItemRef = (0, $6fFrj.useRef)();
    var _useDiffItem = (0, $7c787590174d303b$export$2e2bcd8739ae039)(mergedData, getKey), _useDiffItem2 = (0, $jP8CL.default)(_useDiffItem, 1), diffItem = _useDiffItem2[0];
    diffItemRef.current = diffItem;
    // ========================== Visible Calculation =========================
    var _React$useMemo = $6fFrj.useMemo(function() {
        if (!useVirtual) return {
            scrollHeight: undefined,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        // Always use virtual scroll bar in avoid shaking
        if (!inVirtual) {
            var _fillerInnerRef$curre;
            return {
                scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
                start: 0,
                end: mergedData.length - 1,
                offset: undefined
            };
        }
        var itemTop = 0;
        var startIndex;
        var startOffset;
        var endIndex;
        var dataLen = mergedData.length;
        for(var i = 0; i < dataLen; i += 1){
            var _item = mergedData[i];
            var key = getKey(_item);
            var cacheHeight = heights.get(key);
            var currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
            // Check item top in the range
            if (currentItemBottom >= offsetTop && startIndex === undefined) {
                startIndex = i;
                startOffset = itemTop;
            }
            // Check item bottom in the range. We will render additional one item for motion usage
            if (currentItemBottom > offsetTop + height && endIndex === undefined) endIndex = i;
            itemTop = currentItemBottom;
        }
        // When scrollTop at the end but data cut to small count will reach this
        if (startIndex === undefined) {
            startIndex = 0;
            startOffset = 0;
            endIndex = Math.ceil(height / itemHeight);
        }
        if (endIndex === undefined) endIndex = mergedData.length - 1;
        // Give cache to improve scroll experience
        endIndex = Math.min(endIndex + 1, mergedData.length - 1);
        return {
            scrollHeight: itemTop,
            start: startIndex,
            end: endIndex,
            offset: startOffset
        };
    }, [
        inVirtual,
        useVirtual,
        offsetTop,
        mergedData,
        heightUpdatedMark,
        height
    ]), scrollHeight = _React$useMemo.scrollHeight, start = _React$useMemo.start, end = _React$useMemo.end, fillerOffset = _React$useMemo.offset;
    rangeRef.current.start = start;
    rangeRef.current.end = end;
    // ================================= Size =================================
    var _React$useState = $6fFrj.useState({
        width: 0,
        height: height
    }), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), size = _React$useState2[0], setSize = _React$useState2[1];
    var onHolderResize = function onHolderResize(sizeInfo) {
        setSize({
            width: sizeInfo.offsetWidth,
            height: sizeInfo.offsetHeight
        });
    };
    // Hack on scrollbar to enable flash call
    var verticalScrollBarRef = (0, $6fFrj.useRef)();
    var horizontalScrollBarRef = (0, $6fFrj.useRef)();
    var horizontalScrollBarSpinSize = $6fFrj.useMemo(function() {
        return (0, $deeefb6569db0322$export$f2ca68955ab35ace)(size.width, scrollWidth);
    }, [
        size.width,
        scrollWidth
    ]);
    var verticalScrollBarSpinSize = $6fFrj.useMemo(function() {
        return (0, $deeefb6569db0322$export$f2ca68955ab35ace)(size.height, scrollHeight);
    }, [
        size.height,
        scrollHeight
    ]);
    // =============================== In Range ===============================
    var maxScrollHeight = scrollHeight - height;
    var maxScrollHeightRef = (0, $6fFrj.useRef)(maxScrollHeight);
    maxScrollHeightRef.current = maxScrollHeight;
    function keepInRange(newScrollTop) {
        var newTop = newScrollTop;
        if (!Number.isNaN(maxScrollHeightRef.current)) newTop = Math.min(newTop, maxScrollHeightRef.current);
        newTop = Math.max(newTop, 0);
        return newTop;
    }
    var isScrollAtTop = offsetTop <= 0;
    var isScrollAtBottom = offsetTop >= maxScrollHeight;
    var isScrollAtLeft = offsetLeft <= 0;
    var isScrollAtRight = offsetLeft >= scrollWidth;
    var originScroll = (0, $e3999430a384dee7$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    // ================================ Scroll ================================
    var getVirtualScrollInfo = function getVirtualScrollInfo() {
        return {
            x: isRTL ? -offsetLeft : offsetLeft,
            y: offsetTop
        };
    };
    var lastVirtualScrollInfoRef = (0, $6fFrj.useRef)(getVirtualScrollInfo());
    var triggerScroll = (0, $2c6ch.default)(function(params) {
        if (onVirtualScroll) {
            var nextInfo = (0, $kNxFX.default)((0, $kNxFX.default)({}, getVirtualScrollInfo()), params);
            // Trigger when offset changed
            if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
                onVirtualScroll(nextInfo);
                lastVirtualScrollInfoRef.current = nextInfo;
            }
        }
    });
    function onScrollBar(newScrollOffset, horizontal) {
        var newOffset = newScrollOffset;
        if (horizontal) {
            (0, $8CZEB.flushSync)(function() {
                setOffsetLeft(newOffset);
            });
            triggerScroll();
        } else syncScrollTop(newOffset);
    }
    // When data size reduce. It may trigger native scroll event back to fit scroll position
    function onFallbackScroll(e) {
        var newScrollTop = e.currentTarget.scrollTop;
        if (newScrollTop !== offsetTop) syncScrollTop(newScrollTop);
        // Trigger origin onScroll
        onScroll === null || onScroll === void 0 || onScroll(e);
        triggerScroll();
    }
    var keepInHorizontalRange = function keepInHorizontalRange(nextOffsetLeft) {
        var tmpOffsetLeft = nextOffsetLeft;
        var max = !!scrollWidth ? scrollWidth - size.width : 0;
        tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
        tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
        return tmpOffsetLeft;
    };
    var onWheelDelta = (0, $2c6ch.default)(function(offsetXY, fromHorizontal) {
        if (fromHorizontal) {
            (0, $8CZEB.flushSync)(function() {
                setOffsetLeft(function(left) {
                    var nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
                    return keepInHorizontalRange(nextOffsetLeft);
                });
            });
            triggerScroll();
        } else syncScrollTop(function(top) {
            var newTop = top + offsetXY;
            return newTop;
        });
    });
    // Since this added in global,should use ref to keep update
    var _useFrameWheel = (0, $dbc441870a13e7fd$export$2e2bcd8739ae039)(useVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, !!scrollWidth, onWheelDelta), _useFrameWheel2 = (0, $jP8CL.default)(_useFrameWheel, 2), onRawWheel = _useFrameWheel2[0], onFireFoxScroll = _useFrameWheel2[1];
    // Mobile touch move
    (0, $6ced69326f336dcb$export$2e2bcd8739ae039)(useVirtual, componentRef, function(isHorizontal, delta, smoothOffset, e) {
        var event = e;
        if (originScroll(isHorizontal, delta, smoothOffset)) return false;
        // Fix nest List trigger TouchMove event
        if (!event || !event._virtualHandled) {
            if (event) event._virtualHandled = true;
            onRawWheel({
                preventDefault: function preventDefault() {},
                deltaX: isHorizontal ? delta : 0,
                deltaY: isHorizontal ? 0 : delta
            });
            return true;
        }
        return false;
    });
    // MouseDown drag for scroll
    (0, $83130f490ecddc47$export$2e2bcd8739ae039)(inVirtual, componentRef, function(offset) {
        syncScrollTop(function(top) {
            return top + offset;
        });
    });
    (0, $dNZA9.default)(function() {
        // Firefox only
        function onMozMousePixelScroll(e) {
            // scrolling at top/bottom limit
            var scrollingUpAtTop = isScrollAtTop && e.detail < 0;
            var scrollingDownAtBottom = isScrollAtBottom && e.detail > 0;
            if (useVirtual && !scrollingUpAtTop && !scrollingDownAtBottom) e.preventDefault();
        }
        var componentEle = componentRef.current;
        componentEle.addEventListener('wheel', onRawWheel, {
            passive: false
        });
        componentEle.addEventListener('DOMMouseScroll', onFireFoxScroll, {
            passive: true
        });
        componentEle.addEventListener('MozMousePixelScroll', onMozMousePixelScroll, {
            passive: false
        });
        return function() {
            componentEle.removeEventListener('wheel', onRawWheel);
            componentEle.removeEventListener('DOMMouseScroll', onFireFoxScroll);
            componentEle.removeEventListener('MozMousePixelScroll', onMozMousePixelScroll);
        };
    }, [
        useVirtual,
        isScrollAtTop,
        isScrollAtBottom
    ]);
    // Sync scroll left
    (0, $dNZA9.default)(function() {
        if (scrollWidth) {
            var newOffsetLeft = keepInHorizontalRange(offsetLeft);
            setOffsetLeft(newOffsetLeft);
            triggerScroll({
                x: newOffsetLeft
            });
        }
    }, [
        size.width,
        scrollWidth
    ]);
    // ================================= Ref ==================================
    var delayHideScrollBar = function delayHideScrollBar() {
        var _verticalScrollBarRef, _horizontalScrollBarR;
        (_verticalScrollBarRef = verticalScrollBarRef.current) === null || _verticalScrollBarRef === void 0 || _verticalScrollBarRef.delayHidden();
        (_horizontalScrollBarR = horizontalScrollBarRef.current) === null || _horizontalScrollBarR === void 0 || _horizontalScrollBarR.delayHidden();
    };
    var _scrollTo = (0, $cee9e1b4d1eee547$export$2e2bcd8739ae039)(componentRef, mergedData, heights, itemHeight, getKey, function() {
        return collectHeight(true);
    }, syncScrollTop, delayHideScrollBar);
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            nativeElement: containerRef.current,
            getScrollInfo: getVirtualScrollInfo,
            scrollTo: function scrollTo(config) {
                function isPosScroll(arg) {
                    return arg && (0, $5KhTJ.default)(arg) === 'object' && ('left' in arg || 'top' in arg);
                }
                if (isPosScroll(config)) {
                    // Scroll X
                    if (config.left !== undefined) setOffsetLeft(keepInHorizontalRange(config.left));
                    // Scroll Y
                    _scrollTo(config.top);
                } else _scrollTo(config);
            }
        };
    });
    // ================================ Effect ================================
    /** We need told outside that some list not rendered */ (0, $dNZA9.default)(function() {
        if (onVisibleChange) {
            var renderList = mergedData.slice(start, end + 1);
            onVisibleChange(renderList, mergedData);
        }
    }, [
        start,
        end,
        mergedData
    ]);
    // ================================ Extra =================================
    var getSize = (0, $c4a02bf9a7c05b3c$export$a1d82723752af087)(mergedData, getKey, heights, itemHeight);
    var extraContent = extraRender === null || extraRender === void 0 ? void 0 : extraRender({
        start: start,
        end: end,
        virtual: inVirtual,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        rtl: isRTL,
        getSize: getSize
    });
    // ================================ Render ================================
    var listChildren = (0, $f22ab6ec8f7347c8$export$2e2bcd8739ae039)(mergedData, start, end, scrollWidth, offsetLeft, setInstanceRef, children, sharedConfig);
    var componentStyle = null;
    if (height) {
        componentStyle = (0, $kNxFX.default)((0, $43449.default)({}, fullHeight ? 'height' : 'maxHeight', height), $a4482c7f07480f40$var$ScrollStyle);
        if (useVirtual) {
            componentStyle.overflowY = 'hidden';
            if (scrollWidth) componentStyle.overflowX = 'hidden';
            if (scrollMoving) componentStyle.pointerEvents = 'none';
        }
    }
    var containerProps = {};
    if (isRTL) containerProps.dir = 'rtl';
    return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        ref: containerRef,
        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, style), {}, {
            position: 'relative'
        }),
        className: mergedClassName
    }, containerProps, restProps), /*#__PURE__*/ $6fFrj.createElement((0, $8e6bb008621f90f5$export$2e2bcd8739ae039), {
        onResize: onHolderResize
    }, /*#__PURE__*/ $6fFrj.createElement(Component, {
        className: "".concat(prefixCls, "-holder"),
        style: componentStyle,
        ref: componentRef,
        onScroll: onFallbackScroll,
        onMouseEnter: delayHideScrollBar
    }, /*#__PURE__*/ $6fFrj.createElement((0, $61c3b1811378a1af$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        height: scrollHeight,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        scrollWidth: scrollWidth,
        onInnerResize: collectHeight,
        ref: fillerInnerRef,
        innerProps: innerProps,
        rtl: isRTL,
        extra: extraContent
    }, listChildren))), inVirtual && scrollHeight > height && /*#__PURE__*/ $6fFrj.createElement((0, $41eafd18575d2334$export$2e2bcd8739ae039), {
        ref: verticalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetTop,
        scrollRange: scrollHeight,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: verticalScrollBarSpinSize,
        containerSize: size.height,
        style: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBarThumb
    }), inVirtual && scrollWidth > size.width && /*#__PURE__*/ $6fFrj.createElement((0, $41eafd18575d2334$export$2e2bcd8739ae039), {
        ref: horizontalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetLeft,
        scrollRange: scrollWidth,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: horizontalScrollBarSpinSize,
        containerSize: size.width,
        horizontal: true,
        style: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBarThumb
    }));
}
var $a4482c7f07480f40$var$List = /*#__PURE__*/ $6fFrj.forwardRef($a4482c7f07480f40$export$cc3be4e46e8486ed);
$a4482c7f07480f40$var$List.displayName = 'List';
var $a4482c7f07480f40$export$2e2bcd8739ae039 = $a4482c7f07480f40$var$List;


var $13ab939f4939c91c$export$2e2bcd8739ae039 = (0, $a4482c7f07480f40$export$2e2bcd8739ae039);



/* istanbul ignore file */ function $135efdb28e913c83$export$3bbcfec016973a77() {
    return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}




var $6fFrj = parcelRequire("6fFrj");
// Use any here since we do not get the type during compilation
var $fc3ef034765080be$var$SelectContext = /*#__PURE__*/ $6fFrj.createContext(null);
var $fc3ef034765080be$export$2e2bcd8739ae039 = $fc3ef034765080be$var$SelectContext;


var $7954078c708c5e35$var$_excluded = [
    "disabled",
    "title",
    "children",
    "style",
    "className"
];
// export interface OptionListProps<OptionsType extends object[]> {
function $7954078c708c5e35$var$isTitleType(content) {
    return typeof content === 'string' || typeof content === 'number';
}
/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */ var $7954078c708c5e35$var$OptionList = function OptionList(_, ref) {
    var _useBaseProps = (0, $985f86b34f131ed8$export$2e2bcd8739ae039)(), prefixCls = _useBaseProps.prefixCls, id = _useBaseProps.id, open = _useBaseProps.open, multiple = _useBaseProps.multiple, mode = _useBaseProps.mode, searchValue = _useBaseProps.searchValue, toggleOpen = _useBaseProps.toggleOpen, notFoundContent = _useBaseProps.notFoundContent, onPopupScroll = _useBaseProps.onPopupScroll;
    var _React$useContext = $6fFrj.useContext((0, $fc3ef034765080be$export$2e2bcd8739ae039)), flattenOptions = _React$useContext.flattenOptions, onActiveValue = _React$useContext.onActiveValue, defaultActiveFirstOption = _React$useContext.defaultActiveFirstOption, onSelect = _React$useContext.onSelect, menuItemSelectedIcon = _React$useContext.menuItemSelectedIcon, rawValues = _React$useContext.rawValues, fieldNames = _React$useContext.fieldNames, virtual = _React$useContext.virtual, listHeight = _React$useContext.listHeight, listItemHeight = _React$useContext.listItemHeight;
    var itemPrefixCls = "".concat(prefixCls, "-item");
    var memoFlattenOptions = (0, $a5lfY.default)(function() {
        return flattenOptions;
    }, [
        open,
        flattenOptions
    ], function(prev, next) {
        return next[0] && prev[1] !== next[1];
    });
    // =========================== List ===========================
    var listRef = $6fFrj.useRef(null);
    var onListMouseDown = function onListMouseDown(event) {
        event.preventDefault();
    };
    var scrollIntoView = function scrollIntoView(args) {
        if (listRef.current) listRef.current.scrollTo(typeof args === 'number' ? {
            index: args
        } : args);
    };
    // ========================== Active ==========================
    var getEnabledActiveIndex = function getEnabledActiveIndex(index) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var len = memoFlattenOptions.length;
        for(var i = 0; i < len; i += 1){
            var current = (index + i * offset + len) % len;
            var _memoFlattenOptions$c = memoFlattenOptions[current], group = _memoFlattenOptions$c.group, data = _memoFlattenOptions$c.data;
            if (!group && !data.disabled) return current;
        }
        return -1;
    };
    var _React$useState = $6fFrj.useState(function() {
        return getEnabledActiveIndex(0);
    }), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
    var setActive = function setActive(index) {
        var fromKeyboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        setActiveIndex(index);
        var info = {
            source: fromKeyboard ? 'keyboard' : 'mouse'
        };
        // Trigger active event
        var flattenItem = memoFlattenOptions[index];
        if (!flattenItem) {
            onActiveValue(null, -1, info);
            return;
        }
        onActiveValue(flattenItem.value, index, info);
    };
    // Auto active first item when list length or searchValue changed
    (0, $6fFrj.useEffect)(function() {
        setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
    }, [
        memoFlattenOptions.length,
        searchValue
    ]);
    // https://github.com/ant-design/ant-design/issues/34975
    var isSelected = $6fFrj.useCallback(function(value) {
        return rawValues.has(value) && mode !== 'combobox';
    }, [
        mode,
        (0, $37xND.default)(rawValues).toString(),
        rawValues.size
    ]);
    // Auto scroll to item position in single mode
    (0, $6fFrj.useEffect)(function() {
        /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */ var timeoutId = setTimeout(function() {
            if (!multiple && open && rawValues.size === 1) {
                var value = Array.from(rawValues)[0];
                var index = memoFlattenOptions.findIndex(function(_ref) {
                    var data = _ref.data;
                    return data.value === value;
                });
                if (index !== -1) {
                    setActive(index);
                    scrollIntoView(index);
                }
            }
        });
        // Force trigger scrollbar visible when open
        if (open) {
            var _listRef$current;
            (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(undefined);
        }
        return function() {
            return clearTimeout(timeoutId);
        };
    }, [
        open,
        searchValue
    ]);
    // ========================== Values ==========================
    var onSelectValue = function onSelectValue(value) {
        if (value !== undefined) onSelect(value, {
            selected: !rawValues.has(value)
        });
        // Single mode should always close by select
        if (!multiple) toggleOpen(false);
    };
    // ========================= Keyboard =========================
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            onKeyDown: function onKeyDown(event) {
                var which = event.which, ctrlKey = event.ctrlKey;
                switch(which){
                    // >>> Arrow keys & ctrl + n/p on Mac
                    case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).N:
                    case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).P:
                    case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).UP:
                    case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).DOWN:
                        var offset = 0;
                        if (which === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).UP) offset = -1;
                        else if (which === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).DOWN) offset = 1;
                        else if ((0, $135efdb28e913c83$export$3bbcfec016973a77)() && ctrlKey) {
                            if (which === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).N) offset = 1;
                            else if (which === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).P) offset = -1;
                        }
                        if (offset !== 0) {
                            var nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                            scrollIntoView(nextActiveIndex);
                            setActive(nextActiveIndex, true);
                        }
                        break;
                    // >>> Select
                    case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER:
                        // value
                        var item = memoFlattenOptions[activeIndex];
                        if (item && !item.data.disabled) onSelectValue(item.value);
                        else onSelectValue(undefined);
                        if (open) event.preventDefault();
                        break;
                    // >>> Close
                    case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ESC:
                        toggleOpen(false);
                        if (open) event.stopPropagation();
                }
            },
            onKeyUp: function onKeyUp() {},
            scrollTo: function scrollTo(index) {
                scrollIntoView(index);
            }
        };
    });
    // ========================== Render ==========================
    if (memoFlattenOptions.length === 0) return /*#__PURE__*/ $6fFrj.createElement("div", {
        role: "listbox",
        id: "".concat(id, "_list"),
        className: "".concat(itemPrefixCls, "-empty"),
        onMouseDown: onListMouseDown
    }, notFoundContent);
    var omitFieldNameList = Object.keys(fieldNames).map(function(key) {
        return fieldNames[key];
    });
    var getLabel = function getLabel(item) {
        return item.label;
    };
    var renderItem = function renderItem(index) {
        var item = memoFlattenOptions[index];
        if (!item) return null;
        var itemData = item.data || {};
        var value = itemData.value;
        var group = item.group;
        var attrs = (0, $c7e00e8671f36d19$export$2e2bcd8739ae039)(itemData, true);
        var mergedLabel = getLabel(item);
        return item ? /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
            "aria-label": typeof mergedLabel === 'string' && !group ? mergedLabel : null
        }, attrs, {
            key: index,
            role: group ? 'presentation' : 'option',
            id: "".concat(id, "_list_").concat(index),
            "aria-selected": isSelected(value)
        }), value) : null;
    };
    return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, /*#__PURE__*/ $6fFrj.createElement("div", {
        role: "listbox",
        id: "".concat(id, "_list"),
        style: {
            height: 0,
            width: 0,
            overflow: 'hidden'
        }
    }, renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/ $6fFrj.createElement((0, $13ab939f4939c91c$export$2e2bcd8739ae039), {
        itemKey: "key",
        ref: listRef,
        data: memoFlattenOptions,
        height: listHeight,
        itemHeight: listItemHeight,
        fullHeight: false,
        onMouseDown: onListMouseDown,
        onScroll: onPopupScroll,
        virtual: virtual
    }, function(item, itemIndex) {
        var _classNames;
        var group = item.group, groupOption = item.groupOption, data = item.data, label = item.label, value = item.value;
        var key = data.key;
        // Group
        if (group) {
            var _data$title;
            var groupTitle = (_data$title = data.title) !== null && _data$title !== void 0 ? _data$title : $7954078c708c5e35$var$isTitleType(label) ? label.toString() : undefined;
            return /*#__PURE__*/ $6fFrj.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(itemPrefixCls, "".concat(itemPrefixCls, "-group")),
                title: groupTitle
            }, label !== undefined ? label : key);
        }
        var disabled = data.disabled, title = data.title, children = data.children, style = data.style, className = data.className, otherProps = (0, $04RxA.default)(data, $7954078c708c5e35$var$_excluded);
        var passedProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(otherProps, omitFieldNameList);
        // Option
        var selected = isSelected(value);
        var optionPrefixCls = "".concat(itemPrefixCls, "-option");
        var optionClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(itemPrefixCls, optionPrefixCls, className, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(optionPrefixCls, "-grouped"), groupOption), (0, $43449.default)(_classNames, "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !disabled), (0, $43449.default)(_classNames, "".concat(optionPrefixCls, "-disabled"), disabled), (0, $43449.default)(_classNames, "".concat(optionPrefixCls, "-selected"), selected), _classNames));
        var mergedLabel = getLabel(item);
        var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === 'function' || selected;
        // https://github.com/ant-design/ant-design/issues/34145
        var content = typeof mergedLabel === 'number' ? mergedLabel : mergedLabel || value;
        // https://github.com/ant-design/ant-design/issues/26717
        var optionTitle = $7954078c708c5e35$var$isTitleType(content) ? content.toString() : undefined;
        if (title !== undefined) optionTitle = title;
        return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({}, (0, $c7e00e8671f36d19$export$2e2bcd8739ae039)(passedProps), {
            "aria-selected": selected,
            className: optionClassName,
            title: optionTitle,
            onMouseMove: function onMouseMove() {
                if (activeIndex === itemIndex || disabled) return;
                setActive(itemIndex);
            },
            onClick: function onClick() {
                if (!disabled) onSelectValue(value);
            },
            style: style
        }), /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(optionPrefixCls, "-content")
        }, content), /*#__PURE__*/ $6fFrj.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/ $6fFrj.createElement((0, $cee3ce72adcc66e2$export$2e2bcd8739ae039), {
            className: "".concat(itemPrefixCls, "-option-state"),
            customizeIcon: menuItemSelectedIcon,
            customizeIconProps: {
                isSelected: selected
            }
        }, selected ? "\u2713" : null));
    }));
};
var $7954078c708c5e35$var$RefOptionList = /*#__PURE__*/ $6fFrj.forwardRef($7954078c708c5e35$var$OptionList);
$7954078c708c5e35$var$RefOptionList.displayName = 'OptionList';
var $7954078c708c5e35$export$2e2bcd8739ae039 = $7954078c708c5e35$var$RefOptionList;






var $5KhTJ = parcelRequire("5KhTJ");


var $3mXQ2 = parcelRequire("3mXQ2");

var $6fFrj = parcelRequire("6fFrj");



function $c930b7e07755b4e8$var$warningProps(props) {
    var mode = props.mode, options = props.options, children = props.children, backfill = props.backfill, allowClear = props.allowClear, placeholder = props.placeholder, getInputElement = props.getInputElement, showSearch = props.showSearch, onSearch = props.onSearch, defaultOpen = props.defaultOpen, autoFocus = props.autoFocus, labelInValue = props.labelInValue, value = props.value, inputValue = props.inputValue, optionLabelProp = props.optionLabelProp;
    var multiple = (0, $0f2850f876065ada$export$7f654ad2a77ad2ac)(mode);
    var mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === 'combobox';
    var mergedOptions = options || (0, $97c4086725496a31$export$3beca35db74c3985)(children);
    // `tags` should not set option as disabled
    (0, $3mXQ2.default)(mode !== 'tags' || mergedOptions.every(function(opt) {
        return !opt.disabled;
    }), 'Please avoid setting option to disabled in tags mode since user can always type text as tag.');
    // `combobox` & `tags` should option be `string` type
    if (mode === 'tags' || mode === 'combobox') {
        var hasNumberValue = mergedOptions.some(function(item) {
            if (item.options) return item.options.some(function(opt) {
                return typeof ('value' in opt ? opt.value : opt.key) === 'number';
            });
            return typeof ('value' in item ? item.value : item.key) === 'number';
        });
        (0, $3mXQ2.default)(!hasNumberValue, '`value` of Option should not use number type when `mode` is `tags` or `combobox`.');
    }
    // `combobox` should not use `optionLabelProp`
    (0, $3mXQ2.default)(mode !== 'combobox' || !optionLabelProp, '`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.');
    // Only `combobox` support `backfill`
    (0, $3mXQ2.default)(mode === 'combobox' || !backfill, '`backfill` only works with `combobox` mode.');
    // Only `combobox` support `getInputElement`
    (0, $3mXQ2.default)(mode === 'combobox' || !getInputElement, '`getInputElement` only work with `combobox` mode.');
    // Customize `getInputElement` should not use `allowClear` & `placeholder`
    (0, $3mXQ2.noteOnce)(mode !== 'combobox' || !getInputElement || !allowClear || !placeholder, 'Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.');
    // `onSearch` should use in `combobox` or `showSearch`
    if (onSearch && !mergedShowSearch && mode !== 'combobox' && mode !== 'tags') (0, $3mXQ2.default)(false, '`onSearch` should work with `showSearch` instead of use alone.');
    (0, $3mXQ2.noteOnce)(!defaultOpen || autoFocus, '`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.');
    if (value !== undefined && value !== null) {
        var values = (0, $b7fa77966f4f591e$export$45b10814cc054894)(value);
        (0, $3mXQ2.default)(!labelInValue || values.every(function(val) {
            return (0, $5KhTJ.default)(val) === 'object' && ('key' in val || 'value' in val);
        }), '`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`');
        (0, $3mXQ2.default)(!multiple || Array.isArray(value), '`value` should be array when `mode` is `multiple` or `tags`');
    }
    // Syntactic sugar should use correct children type
    if (children) {
        var invalidateChildType = null;
        (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(children).some(function(node) {
            if (!/*#__PURE__*/ $6fFrj.isValidElement(node) || !node.type) return false;
            var _ref = node, type = _ref.type;
            if (type.isSelectOption) return false;
            if (type.isSelectOptGroup) {
                var allChildrenValid = (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(node.props.children).every(function(subNode) {
                    if (!/*#__PURE__*/ $6fFrj.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) return true;
                    invalidateChildType = subNode.type;
                    return false;
                });
                if (allChildrenValid) return false;
                return true;
            }
            invalidateChildType = type;
            return true;
        });
        if (invalidateChildType) (0, $3mXQ2.default)(false, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(invalidateChildType.displayName || invalidateChildType.name || invalidateChildType, "`."));
        (0, $3mXQ2.default)(inputValue === undefined, '`inputValue` is deprecated, please use `searchValue` instead.');
    }
}
function $c930b7e07755b4e8$export$c33a1be4de1ec2c(options, fieldNames) {
    if (options) {
        var recursiveOptions = function recursiveOptions(optionsList) {
            var inGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            for(var i = 0; i < optionsList.length; i++){
                var option = optionsList[i];
                if (option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.value] === null) {
                    (0, $3mXQ2.default)(false, '`value` in Select options should not be `null`.');
                    return true;
                }
                if (!inGroup && Array.isArray(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options]) && recursiveOptions(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options], true)) break;
            }
        };
        recursiveOptions(options);
    }
}
var $c930b7e07755b4e8$export$2e2bcd8739ae039 = $c930b7e07755b4e8$var$warningProps;


var $b9a837d6c156b73a$var$_excluded = [
    "id",
    "mode",
    "prefixCls",
    "backfill",
    "fieldNames",
    "inputValue",
    "searchValue",
    "onSearch",
    "autoClearSearchValue",
    "onSelect",
    "onDeselect",
    "dropdownMatchSelectWidth",
    "filterOption",
    "filterSort",
    "optionFilterProp",
    "optionLabelProp",
    "options",
    "children",
    "defaultActiveFirstOption",
    "menuItemSelectedIcon",
    "virtual",
    "listHeight",
    "listItemHeight",
    "value",
    "defaultValue",
    "labelInValue",
    "onChange"
];
var $b9a837d6c156b73a$var$OMIT_DOM_PROPS = [
    'inputValue'
];
function $b9a837d6c156b73a$var$isRawValue(value) {
    return !value || (0, $5KhTJ.default)(value) !== 'object';
}
var $b9a837d6c156b73a$var$Select = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var id = props.id, mode = props.mode, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-select' : _props$prefixCls, backfill = props.backfill, fieldNames = props.fieldNames, inputValue = props.inputValue, searchValue = props.searchValue, onSearch = props.onSearch, _props$autoClearSearc = props.autoClearSearchValue, autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc, onSelect = props.onSelect, onDeselect = props.onDeselect, _props$dropdownMatchS = props.dropdownMatchSelectWidth, dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS, filterOption = props.filterOption, filterSort = props.filterSort, optionFilterProp = props.optionFilterProp, optionLabelProp = props.optionLabelProp, options = props.options, children = props.children, defaultActiveFirstOption = props.defaultActiveFirstOption, menuItemSelectedIcon = props.menuItemSelectedIcon, virtual = props.virtual, _props$listHeight = props.listHeight, listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight, _props$listItemHeight = props.listItemHeight, listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight, value = props.value, defaultValue = props.defaultValue, labelInValue = props.labelInValue, onChange = props.onChange, restProps = (0, $04RxA.default)(props, $b9a837d6c156b73a$var$_excluded);
    var mergedId = (0, $20e3a582558bc653$export$2e2bcd8739ae039)(id);
    var multiple = (0, $0f2850f876065ada$export$7f654ad2a77ad2ac)(mode);
    var childrenAsData = !!(!options && children);
    var mergedFilterOption = $6fFrj.useMemo(function() {
        if (filterOption === undefined && mode === 'combobox') return false;
        return filterOption;
    }, [
        filterOption,
        mode
    ]);
    // ========================= FieldNames =========================
    var mergedFieldNames = $6fFrj.useMemo(function() {
        return (0, $3786d4546cc0f905$export$6c519d302dced239)(fieldNames, childrenAsData);
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        // We stringify fieldNames to avoid unnecessary re-renders.
        JSON.stringify(fieldNames),
        childrenAsData
    ]);
    // =========================== Search ===========================
    var _useMergedState = (0, $gfhff.default)('', {
        value: searchValue !== undefined ? searchValue : inputValue,
        postState: function postState(search) {
            return search || '';
        }
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), mergedSearchValue = _useMergedState2[0], setSearchValue = _useMergedState2[1];
    // =========================== Option ===========================
    var parsedOptions = (0, $513303323bda481f$export$2e2bcd8739ae039)(options, children, mergedFieldNames, optionFilterProp, optionLabelProp);
    var valueOptions = parsedOptions.valueOptions, labelOptions = parsedOptions.labelOptions, mergedOptions = parsedOptions.options;
    // ========================= Wrap Value =========================
    var convert2LabelValues = $6fFrj.useCallback(function(draftValues) {
        // Convert to array
        var valueList = (0, $b7fa77966f4f591e$export$45b10814cc054894)(draftValues);
        // Convert to labelInValue type
        return valueList.map(function(val) {
            var rawValue;
            var rawLabel;
            var rawKey;
            var rawDisabled;
            var rawTitle;
            // Fill label & value
            if ($b9a837d6c156b73a$var$isRawValue(val)) rawValue = val;
            else {
                var _val$value;
                rawKey = val.key;
                rawLabel = val.label;
                rawValue = (_val$value = val.value) !== null && _val$value !== void 0 ? _val$value : rawKey;
            }
            var option = valueOptions.get(rawValue);
            if (option) {
                var _option$key;
                // Fill missing props
                if (rawLabel === undefined) rawLabel = option === null || option === void 0 ? void 0 : option[optionLabelProp || mergedFieldNames.label];
                if (rawKey === undefined) rawKey = (_option$key = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key !== void 0 ? _option$key : rawValue;
                rawDisabled = option === null || option === void 0 ? void 0 : option.disabled;
                rawTitle = option === null || option === void 0 ? void 0 : option.title;
                var optionLabel;
            }
            return {
                label: rawLabel,
                value: rawValue,
                key: rawKey,
                disabled: rawDisabled,
                title: rawTitle
            };
        });
    }, [
        mergedFieldNames,
        optionLabelProp,
        valueOptions
    ]);
    // =========================== Values ===========================
    var _useMergedState3 = (0, $gfhff.default)(defaultValue, {
        value: value
    }), _useMergedState4 = (0, $jP8CL.default)(_useMergedState3, 2), internalValue = _useMergedState4[0], setInternalValue = _useMergedState4[1];
    // Merged value with LabelValueType
    var rawLabeledValues = $6fFrj.useMemo(function() {
        var _values$;
        var values = convert2LabelValues(internalValue);
        // combobox no need save value when it's no value
        if (mode === 'combobox' && !((_values$ = values[0]) !== null && _values$ !== void 0 && _values$.value)) return [];
        return values;
    }, [
        internalValue,
        convert2LabelValues,
        mode
    ]);
    // Fill label with cache to avoid option remove
    var _useCache = (0, $4770823214efc890$export$2e2bcd8739ae039)(rawLabeledValues, valueOptions), _useCache2 = (0, $jP8CL.default)(_useCache, 2), mergedValues = _useCache2[0], getMixedOption = _useCache2[1];
    var displayValues = $6fFrj.useMemo(function() {
        // `null` need show as placeholder instead
        // https://github.com/ant-design/ant-design/issues/25057
        if (!mode && mergedValues.length === 1) {
            var firstValue = mergedValues[0];
            if (firstValue.value === null && (firstValue.label === null || firstValue.label === undefined)) return [];
        }
        return mergedValues.map(function(item) {
            var _item$label;
            return (0, $kNxFX.default)((0, $kNxFX.default)({}, item), {}, {
                label: (_item$label = item.label) !== null && _item$label !== void 0 ? _item$label : item.value
            });
        });
    }, [
        mode,
        mergedValues
    ]);
    /** Convert `displayValues` to raw value type set */ var rawValues = $6fFrj.useMemo(function() {
        return new Set(mergedValues.map(function(val) {
            return val.value;
        }));
    }, [
        mergedValues
    ]);
    $6fFrj.useEffect(function() {
        if (mode === 'combobox') {
            var _mergedValues$;
            var strValue = (_mergedValues$ = mergedValues[0]) === null || _mergedValues$ === void 0 ? void 0 : _mergedValues$.value;
            setSearchValue((0, $b7fa77966f4f591e$export$96bdbc84526f3739)(strValue) ? String(strValue) : '');
        }
    }, [
        mergedValues
    ]);
    // ======================= Display Option =======================
    // Create a placeholder item if not exist in `options`
    var createTagOption = (0, $5b6ab98badd23101$export$2e2bcd8739ae039)(function(val, label) {
        var _ref;
        var mergedLabel = label !== null && label !== void 0 ? label : val;
        return _ref = {}, (0, $43449.default)(_ref, mergedFieldNames.value, val), (0, $43449.default)(_ref, mergedFieldNames.label, mergedLabel), _ref;
    });
    // Fill tag as option if mode is `tags`
    var filledTagOptions = $6fFrj.useMemo(function() {
        if (mode !== 'tags') return mergedOptions;
        // >>> Tag mode
        var cloneOptions = (0, $37xND.default)(mergedOptions);
        // Check if value exist in options (include new patch item)
        var existOptions = function existOptions(val) {
            return valueOptions.has(val);
        };
        // Fill current value as option
        (0, $37xND.default)(mergedValues).sort(function(a, b) {
            return a.value < b.value ? -1 : 1;
        }).forEach(function(item) {
            var val = item.value;
            if (!existOptions(val)) cloneOptions.push(createTagOption(val, item.label));
        });
        return cloneOptions;
    }, [
        createTagOption,
        mergedOptions,
        valueOptions,
        mergedValues,
        mode
    ]);
    var filteredOptions = (0, $b0028e6aa1f93e77$export$2e2bcd8739ae039)(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, optionFilterProp);
    // Fill options with search value if needed
    var filledSearchOptions = $6fFrj.useMemo(function() {
        if (mode !== 'tags' || !mergedSearchValue || filteredOptions.some(function(item) {
            return item[optionFilterProp || 'value'] === mergedSearchValue;
        })) return filteredOptions;
        // Fill search value as option
        return [
            createTagOption(mergedSearchValue)
        ].concat((0, $37xND.default)(filteredOptions));
    }, [
        createTagOption,
        optionFilterProp,
        mode,
        filteredOptions,
        mergedSearchValue
    ]);
    var orderedFilteredOptions = $6fFrj.useMemo(function() {
        if (!filterSort) return filledSearchOptions;
        return (0, $37xND.default)(filledSearchOptions).sort(function(a, b) {
            return filterSort(a, b);
        });
    }, [
        filledSearchOptions,
        filterSort
    ]);
    var displayOptions = $6fFrj.useMemo(function() {
        return (0, $3786d4546cc0f905$export$7baa7c13b358b002)(orderedFilteredOptions, {
            fieldNames: mergedFieldNames,
            childrenAsData: childrenAsData
        });
    }, [
        orderedFilteredOptions,
        mergedFieldNames,
        childrenAsData
    ]);
    // =========================== Change ===========================
    var triggerChange = function triggerChange(values) {
        var labeledValues = convert2LabelValues(values);
        setInternalValue(labeledValues);
        if (onChange && // Trigger event only when value changed
        (labeledValues.length !== mergedValues.length || labeledValues.some(function(newVal, index) {
            var _mergedValues$index;
            return ((_mergedValues$index = mergedValues[index]) === null || _mergedValues$index === void 0 ? void 0 : _mergedValues$index.value) !== (newVal === null || newVal === void 0 ? void 0 : newVal.value);
        }))) {
            var returnValues = labelInValue ? labeledValues : labeledValues.map(function(v) {
                return v.value;
            });
            var returnOptions = labeledValues.map(function(v) {
                return (0, $3786d4546cc0f905$export$d0b21b213c8c013c)(getMixedOption(v.value));
            });
            onChange(// Value
            multiple ? returnValues : returnValues[0], // Option
            multiple ? returnOptions : returnOptions[0]);
        }
    };
    // ======================= Accessibility ========================
    var _React$useState = $6fFrj.useState(null), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), activeValue = _React$useState2[0], setActiveValue = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState(0), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), accessibilityIndex = _React$useState4[0], setAccessibilityIndex = _React$useState4[1];
    var mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== 'combobox';
    var onActiveValue = $6fFrj.useCallback(function(active, index) {
        var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref2$source = _ref2.source, source = _ref2$source === void 0 ? 'keyboard' : _ref2$source;
        setAccessibilityIndex(index);
        if (backfill && mode === 'combobox' && active !== null && source === 'keyboard') setActiveValue(String(active));
    }, [
        backfill,
        mode
    ]);
    // ========================= OptionList =========================
    var triggerSelect = function triggerSelect(val, selected, type) {
        var getSelectEnt = function getSelectEnt() {
            var _option$key2;
            var option = getMixedOption(val);
            return [
                labelInValue ? {
                    label: option === null || option === void 0 ? void 0 : option[mergedFieldNames.label],
                    value: val,
                    key: (_option$key2 = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key2 !== void 0 ? _option$key2 : val
                } : val,
                (0, $3786d4546cc0f905$export$d0b21b213c8c013c)(option)
            ];
        };
        if (selected && onSelect) {
            var _getSelectEnt = getSelectEnt(), _getSelectEnt2 = (0, $jP8CL.default)(_getSelectEnt, 2), wrappedValue = _getSelectEnt2[0], _option = _getSelectEnt2[1];
            onSelect(wrappedValue, _option);
        } else if (!selected && onDeselect && type !== 'clear') {
            var _getSelectEnt3 = getSelectEnt(), _getSelectEnt4 = (0, $jP8CL.default)(_getSelectEnt3, 2), _wrappedValue = _getSelectEnt4[0], _option2 = _getSelectEnt4[1];
            onDeselect(_wrappedValue, _option2);
        }
    };
    // Used for OptionList selection
    var onInternalSelect = (0, $5b6ab98badd23101$export$2e2bcd8739ae039)(function(val, info) {
        var cloneValues;
        // Single mode always trigger select only with option list
        var mergedSelect = multiple ? info.selected : true;
        if (mergedSelect) cloneValues = multiple ? [].concat((0, $37xND.default)(mergedValues), [
            val
        ]) : [
            val
        ];
        else cloneValues = mergedValues.filter(function(v) {
            return v.value !== val;
        });
        triggerChange(cloneValues);
        triggerSelect(val, mergedSelect);
        // Clean search value if single or configured
        if (mode === 'combobox') // setSearchValue(String(val));
        setActiveValue('');
        else if (!(0, $0f2850f876065ada$export$7f654ad2a77ad2ac) || autoClearSearchValue) {
            setSearchValue('');
            setActiveValue('');
        }
    });
    // ======================= Display Change =======================
    // BaseSelect display values change
    var onDisplayValuesChange = function onDisplayValuesChange(nextValues, info) {
        triggerChange(nextValues);
        var type = info.type, values = info.values;
        if (type === 'remove' || type === 'clear') values.forEach(function(item) {
            triggerSelect(item.value, false, type);
        });
    };
    // =========================== Search ===========================
    var onInternalSearch = function onInternalSearch(searchText, info) {
        setSearchValue(searchText);
        setActiveValue(null);
        // [Submit] Tag mode should flush input
        if (info.source === 'submit') {
            var formatted = (searchText || '').trim();
            // prevent empty tags from appearing when you click the Enter button
            if (formatted) {
                var newRawValues = Array.from(new Set([].concat((0, $37xND.default)(rawValues), [
                    formatted
                ])));
                triggerChange(newRawValues);
                triggerSelect(formatted, true);
                setSearchValue('');
            }
            return;
        }
        if (info.source !== 'blur') {
            if (mode === 'combobox') triggerChange(searchText);
            onSearch === null || onSearch === void 0 || onSearch(searchText);
        }
    };
    var onInternalSearchSplit = function onInternalSearchSplit(words) {
        var patchValues = words;
        if (mode !== 'tags') patchValues = words.map(function(word) {
            var opt = labelOptions.get(word);
            return opt === null || opt === void 0 ? void 0 : opt.value;
        }).filter(function(val) {
            return val !== undefined;
        });
        var newRawValues = Array.from(new Set([].concat((0, $37xND.default)(rawValues), (0, $37xND.default)(patchValues))));
        triggerChange(newRawValues);
        newRawValues.forEach(function(newRawValue) {
            triggerSelect(newRawValue, true);
        });
    };
    // ========================== Context ===========================
    var selectContext = $6fFrj.useMemo(function() {
        var realVirtual = virtual !== false && dropdownMatchSelectWidth !== false;
        return (0, $kNxFX.default)((0, $kNxFX.default)({}, parsedOptions), {}, {
            flattenOptions: displayOptions,
            onActiveValue: onActiveValue,
            defaultActiveFirstOption: mergedDefaultActiveFirstOption,
            onSelect: onInternalSelect,
            menuItemSelectedIcon: menuItemSelectedIcon,
            rawValues: rawValues,
            fieldNames: mergedFieldNames,
            virtual: realVirtual,
            listHeight: listHeight,
            listItemHeight: listItemHeight,
            childrenAsData: childrenAsData
        });
    }, [
        parsedOptions,
        displayOptions,
        onActiveValue,
        mergedDefaultActiveFirstOption,
        onInternalSelect,
        menuItemSelectedIcon,
        rawValues,
        mergedFieldNames,
        virtual,
        dropdownMatchSelectWidth,
        listHeight,
        listItemHeight,
        childrenAsData
    ]);
    // ==============================================================
    // ==                          Render                          ==
    // ==============================================================
    return /*#__PURE__*/ $6fFrj.createElement((0, $fc3ef034765080be$export$2e2bcd8739ae039).Provider, {
        value: selectContext
    }, /*#__PURE__*/ $6fFrj.createElement((0, $0f2850f876065ada$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, restProps, {
        // >>> MISC
        id: mergedId,
        prefixCls: prefixCls,
        ref: ref,
        omitDomProps: $b9a837d6c156b73a$var$OMIT_DOM_PROPS,
        mode: mode,
        displayValues: displayValues,
        onDisplayValuesChange: onDisplayValuesChange,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        autoClearSearchValue: autoClearSearchValue,
        onSearchSplit: onInternalSearchSplit,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        OptionList: (0, $7954078c708c5e35$export$2e2bcd8739ae039),
        emptyOptions: !displayOptions.length,
        activeValue: activeValue,
        activeDescendantId: "".concat(mergedId, "_list_").concat(accessibilityIndex)
    })));
});
var $b9a837d6c156b73a$var$TypedSelect = $b9a837d6c156b73a$var$Select;
$b9a837d6c156b73a$var$TypedSelect.Option = (0, $b75b06eef9361259$export$2e2bcd8739ae039);
$b9a837d6c156b73a$var$TypedSelect.OptGroup = (0, $a0f7385503db84a6$export$2e2bcd8739ae039);
var $b9a837d6c156b73a$export$2e2bcd8739ae039 = $b9a837d6c156b73a$var$TypedSelect;






var $6a4b2f5407289fed$export$2e2bcd8739ae039 = (0, $b9a837d6c156b73a$export$2e2bcd8739ae039);




var $6fFrj = parcelRequire("6fFrj");








var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $da7c7d2334d54a27$var$CheckOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    "name": "check",
    "theme": "outlined"
};
var $da7c7d2334d54a27$export$2e2bcd8739ae039 = $da7c7d2334d54a27$var$CheckOutlined;



var $97e498ed1184adf1$var$CheckOutlined = function CheckOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $da7c7d2334d54a27$export$2e2bcd8739ae039)
    }));
};
var $97e498ed1184adf1$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($97e498ed1184adf1$var$CheckOutlined);
var $97e498ed1184adf1$export$2e2bcd8739ae039 = $97e498ed1184adf1$var$RefIcon;







var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $99b0cec369db9564$var$SearchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    "name": "search",
    "theme": "outlined"
};
var $99b0cec369db9564$export$2e2bcd8739ae039 = $99b0cec369db9564$var$SearchOutlined;



var $37763468bed476f0$var$SearchOutlined = function SearchOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $99b0cec369db9564$export$2e2bcd8739ae039)
    }));
};
var $37763468bed476f0$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($37763468bed476f0$var$SearchOutlined);
var $37763468bed476f0$export$2e2bcd8739ae039 = $37763468bed476f0$var$RefIcon;



var $6fFrj = parcelRequire("6fFrj");
function $cde06fed9d0f15c5$export$2e2bcd8739ae039(_ref) {
    var suffixIcon = _ref.suffixIcon, clearIcon = _ref.clearIcon, menuItemSelectedIcon = _ref.menuItemSelectedIcon, removeIcon = _ref.removeIcon, loading = _ref.loading, multiple = _ref.multiple, hasFeedback = _ref.hasFeedback, prefixCls = _ref.prefixCls, showArrow = _ref.showArrow, feedbackIcon = _ref.feedbackIcon;
    // Clear Icon
    var mergedClearIcon = clearIcon !== null && clearIcon !== void 0 ? clearIcon : /*#__PURE__*/ $6fFrj.createElement((0, $9429a61ddf5bc264$export$2e2bcd8739ae039), null);
    // Validation Feedback Icon
    var getSuffixIconNode = function getSuffixIconNode(arrowIcon) {
        return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, showArrow !== false && arrowIcon, hasFeedback && feedbackIcon);
    };
    // Arrow item icon
    var mergedSuffixIcon = null;
    if (suffixIcon !== undefined) mergedSuffixIcon = getSuffixIconNode(suffixIcon);
    else if (loading) mergedSuffixIcon = getSuffixIconNode(/*#__PURE__*/ $6fFrj.createElement((0, $3240b41b65b5dac9$export$2e2bcd8739ae039), {
        spin: true
    }));
    else {
        var iconCls = "".concat(prefixCls, "-suffix");
        mergedSuffixIcon = function mergedSuffixIcon(_ref2) {
            var open = _ref2.open, showSearch = _ref2.showSearch;
            if (open && showSearch) return getSuffixIconNode(/*#__PURE__*/ $6fFrj.createElement((0, $37763468bed476f0$export$2e2bcd8739ae039), {
                className: iconCls
            }));
            return getSuffixIconNode(/*#__PURE__*/ $6fFrj.createElement((0, $344ef0cbd3adff87$export$2e2bcd8739ae039), {
                className: iconCls
            }));
        };
    }
    // Checked item icon
    var mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) mergedItemIcon = menuItemSelectedIcon;
    else if (multiple) mergedItemIcon = /*#__PURE__*/ $6fFrj.createElement((0, $97e498ed1184adf1$export$2e2bcd8739ae039), null);
    else mergedItemIcon = null;
    var mergedRemoveIcon = null;
    if (removeIcon !== undefined) mergedRemoveIcon = removeIcon;
    else mergedRemoveIcon = /*#__PURE__*/ $6fFrj.createElement((0, $4cb3f1f073816266$export$2e2bcd8739ae039), null);
    return {
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon
    };
}




// TODO: 4.0 - codemod should help to change `filterOption` to support node props.
var $f53bdf45f7cdc99e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f53bdf45f7cdc99e$var$SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
var $f53bdf45f7cdc99e$var$InternalSelect = function InternalSelect(_a, ref) {
    var customizePrefixCls = _a.prefixCls, _a$bordered = _a.bordered, bordered = _a$bordered === void 0 ? true : _a$bordered, className = _a.className, getPopupContainer = _a.getPopupContainer, dropdownClassName = _a.dropdownClassName, popupClassName = _a.popupClassName, _a$listHeight = _a.listHeight, listHeight = _a$listHeight === void 0 ? 256 : _a$listHeight, placement = _a.placement, _a$listItemHeight = _a.listItemHeight, listItemHeight = _a$listItemHeight === void 0 ? 32 : _a$listItemHeight, customizeSize = _a.size, customDisabled = _a.disabled, notFoundContent = _a.notFoundContent, customStatus = _a.status, showArrow = _a.showArrow, props = $f53bdf45f7cdc99e$var$__rest(_a, [
        "prefixCls",
        "bordered",
        "className",
        "getPopupContainer",
        "dropdownClassName",
        "popupClassName",
        "listHeight",
        "placement",
        "listItemHeight",
        "size",
        "disabled",
        "notFoundContent",
        "status",
        "showArrow"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, renderEmpty = _React$useContext.renderEmpty, direction = _React$useContext.direction, virtual = _React$useContext.virtual, dropdownMatchSelectWidth = _React$useContext.dropdownMatchSelectWidth;
    var size = $6fFrj.useContext((0, $aefad26b74860b7e$export$2e2bcd8739ae039));
    var prefixCls = getPrefixCls('select', customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var _useCompactItemContex = (0, $87f4fe035d0a15fd$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    var mode = $6fFrj.useMemo(function() {
        var m = props.mode;
        if (m === 'combobox') return undefined;
        if (m === $f53bdf45f7cdc99e$var$SECRET_COMBOBOX_MODE_DO_NOT_USE) return 'combobox';
        return m;
    }, [
        props.mode
    ]);
    var isMultiple = mode === 'multiple' || mode === 'tags';
    var mergedShowArrow = showArrow !== undefined ? showArrow : props.loading || !(isMultiple || mode === 'combobox');
    // ===================== Form Status =====================
    var _useContext = (0, $6fFrj.useContext)((0, $76d69cb8326089c6$export$bbb5553c6c7a14ed)), contextStatus = _useContext.status, hasFeedback = _useContext.hasFeedback, isFormItemInput = _useContext.isFormItemInput, feedbackIcon = _useContext.feedbackIcon;
    var mergedStatus = (0, $d372c831fd1c9007$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Empty =====================
    var mergedNotFound;
    if (notFoundContent !== undefined) mergedNotFound = notFoundContent;
    else if (mode === 'combobox') mergedNotFound = null;
    else mergedNotFound = (renderEmpty || (0, $94fec351dda17415$export$2e2bcd8739ae039))('Select');
    // ===================== Icons =====================
    var _getIcons = (0, $cde06fed9d0f15c5$export$2e2bcd8739ae039)((0, $fIrcP.default)((0, $fIrcP.default)({}, props), {
        multiple: isMultiple,
        hasFeedback: hasFeedback,
        feedbackIcon: feedbackIcon,
        showArrow: mergedShowArrow,
        prefixCls: prefixCls
    })), suffixIcon = _getIcons.suffixIcon, itemIcon = _getIcons.itemIcon, removeIcon = _getIcons.removeIcon, clearIcon = _getIcons.clearIcon;
    var selectProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(props, [
        'suffixIcon',
        'itemIcon'
    ]);
    var rcSelectRtlDropdownClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(popupClassName || dropdownClassName, (0, $43449.default)({}, "".concat(prefixCls, "-dropdown-").concat(direction), direction === 'rtl'));
    var mergedSize = compactSize || customizeSize || size;
    // ===================== Disabled =====================
    var disabled = $6fFrj.useContext((0, $3880af76d17f94a3$export$2e2bcd8739ae039));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-lg"), mergedSize === 'large'), "".concat(prefixCls, "-sm"), mergedSize === 'small'), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-borderless"), !bordered), "".concat(prefixCls, "-in-form-item"), isFormItemInput), (0, $d372c831fd1c9007$export$b08e7b47149942a2)(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, className);
    // ===================== Placement =====================
    var getPlacement = function getPlacement() {
        if (placement !== undefined) return placement;
        return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $6a4b2f5407289fed$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        ref: ref,
        virtual: virtual,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }, selectProps, {
        transitionName: (0, $779588b2444df86c$export$27c72201b1d09951)(rootPrefixCls, (0, $779588b2444df86c$export$b2382d4a41c58fef)(placement), props.transitionName),
        listHeight: listHeight,
        listItemHeight: listItemHeight,
        mode: mode,
        prefixCls: prefixCls,
        placement: getPlacement(),
        direction: direction,
        inputIcon: suffixIcon,
        menuItemSelectedIcon: itemIcon,
        removeIcon: removeIcon,
        clearIcon: clearIcon,
        notFoundContent: mergedNotFound,
        className: mergedClassName,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        dropdownClassName: rcSelectRtlDropdownClassName,
        showArrow: hasFeedback || showArrow,
        disabled: mergedDisabled
    }));
};
var $f53bdf45f7cdc99e$var$Select = /*#__PURE__*/ $6fFrj.forwardRef($f53bdf45f7cdc99e$var$InternalSelect);
$f53bdf45f7cdc99e$var$Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = $f53bdf45f7cdc99e$var$SECRET_COMBOBOX_MODE_DO_NOT_USE;
$f53bdf45f7cdc99e$var$Select.Option = (0, $b75b06eef9361259$export$2e2bcd8739ae039);
$f53bdf45f7cdc99e$var$Select.OptGroup = (0, $a0f7385503db84a6$export$2e2bcd8739ae039);
var $f53bdf45f7cdc99e$export$2e2bcd8739ae039 = $f53bdf45f7cdc99e$var$Select;


var $724d38e31e32d092$export$40e3292f13ea8c60 = function MiniSelect(props) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $f53bdf45f7cdc99e$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        size: "small"
    }));
};
var $724d38e31e32d092$export$c1344b3dabe19d01 = function MiddleSelect(props) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $f53bdf45f7cdc99e$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        size: "middle"
    }));
};
$724d38e31e32d092$export$40e3292f13ea8c60.Option = (0, $f53bdf45f7cdc99e$export$2e2bcd8739ae039).Option;
$724d38e31e32d092$export$c1344b3dabe19d01.Option = (0, $f53bdf45f7cdc99e$export$2e2bcd8739ae039).Option;


var $e70d19284285557f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e70d19284285557f$var$Pagination = function Pagination(_a) {
    var customizePrefixCls = _a.prefixCls, customizeSelectPrefixCls = _a.selectPrefixCls, className = _a.className, size = _a.size, customLocale = _a.locale, selectComponentClass = _a.selectComponentClass, responsive = _a.responsive, showSizeChanger = _a.showSizeChanger, restProps = $e70d19284285557f$var$__rest(_a, [
        "prefixCls",
        "selectPrefixCls",
        "className",
        "size",
        "locale",
        "selectComponentClass",
        "responsive",
        "showSizeChanger"
    ]);
    var _useBreakpoint = (0, $60fdd98823a1708b$export$2e2bcd8739ae039)(responsive), xs = _useBreakpoint.xs;
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, _React$useContext$pag = _React$useContext.pagination, pagination = _React$useContext$pag === void 0 ? {} : _React$useContext$pag;
    var prefixCls = getPrefixCls('pagination', customizePrefixCls);
    var mergedShowSizeChanger = showSizeChanger !== null && showSizeChanger !== void 0 ? showSizeChanger : pagination.showSizeChanger;
    var getIconsProps = function getIconsProps() {
        var ellipsis = /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-item-ellipsis")
        }, "\u2022\u2022\u2022");
        var prevIcon = /*#__PURE__*/ $6fFrj.createElement("button", {
            className: "".concat(prefixCls, "-item-link"),
            type: "button",
            tabIndex: -1
        }, /*#__PURE__*/ $6fFrj.createElement((0, $ae5877404f2a0345$export$2e2bcd8739ae039), null));
        var nextIcon = /*#__PURE__*/ $6fFrj.createElement("button", {
            className: "".concat(prefixCls, "-item-link"),
            type: "button",
            tabIndex: -1
        }, /*#__PURE__*/ $6fFrj.createElement((0, $e7bd83ac29db4850$export$2e2bcd8739ae039), null));
        var jumpPrevIcon = /*#__PURE__*/ $6fFrj.createElement("a", {
            className: "".concat(prefixCls, "-item-link")
        }, /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-item-container")
        }, /*#__PURE__*/ $6fFrj.createElement((0, $054e84529e7e99ee$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-item-link-icon")
        }), ellipsis));
        var jumpNextIcon = /*#__PURE__*/ $6fFrj.createElement("a", {
            className: "".concat(prefixCls, "-item-link")
        }, /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-item-container")
        }, /*#__PURE__*/ $6fFrj.createElement((0, $9edb2f28b9e902c3$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-item-link-icon")
        }), ellipsis));
        // change arrows direction in right-to-left direction
        if (direction === 'rtl') {
            var _ref = [
                nextIcon,
                prevIcon
            ];
            prevIcon = _ref[0];
            nextIcon = _ref[1];
            var _ref2 = [
                jumpNextIcon,
                jumpPrevIcon
            ];
            jumpPrevIcon = _ref2[0];
            jumpNextIcon = _ref2[1];
        }
        return {
            prevIcon: prevIcon,
            nextIcon: nextIcon,
            jumpPrevIcon: jumpPrevIcon,
            jumpNextIcon: jumpNextIcon
        };
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $d37c6ecde78f75e8$export$2e2bcd8739ae039), {
        componentName: "Pagination",
        defaultLocale: (0, $d2585e4c74ed0f46$export$2e2bcd8739ae039)
    }, function(contextLocale) {
        var locale = (0, $fIrcP.default)((0, $fIrcP.default)({}, contextLocale), customLocale);
        var isSmall = size === 'small' || !!(xs && !size && responsive);
        var selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
        var extendedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-mini"), isSmall), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
        return /*#__PURE__*/ $6fFrj.createElement((0, $9b82f0e1c8fbf9ac$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, getIconsProps(), restProps, {
            prefixCls: prefixCls,
            selectPrefixCls: selectPrefixCls,
            className: extendedClassName,
            selectComponentClass: selectComponentClass || (isSmall ? (0, $724d38e31e32d092$export$40e3292f13ea8c60) : (0, $724d38e31e32d092$export$c1344b3dabe19d01)),
            locale: locale,
            showSizeChanger: mergedShowSizeChanger
        }));
    });
};
var $e70d19284285557f$export$2e2bcd8739ae039 = $e70d19284285557f$var$Pagination;


var $e5809665964e3ab6$export$2e2bcd8739ae039 = (0, $e70d19284285557f$export$2e2bcd8739ae039);



var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $fActo = parcelRequire("fActo");
var $562af9b9f81485c2$exports = {};
var $aaebd2a43568f36a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $aaebd2a43568f36a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$aaebd2a43568f36a$exports = $aaebd2a43568f36a$var$isObject;


var $16bb6804e421696b$exports = {};

var $kqNAI = parcelRequire("kqNAI");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $16bb6804e421696b$var$now = function() {
    return $kqNAI.Date.now();
};
$16bb6804e421696b$exports = $16bb6804e421696b$var$now;


var $4bcc34f8cd22cc6a$exports = {};
var $b7250667cdf52739$exports = {};
var $4bd6b744d61c5b22$exports = {};
/** Used to match a single whitespace character. */ var $4bd6b744d61c5b22$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $4bd6b744d61c5b22$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $4bd6b744d61c5b22$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$4bd6b744d61c5b22$exports = $4bd6b744d61c5b22$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $b7250667cdf52739$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $b7250667cdf52739$var$baseTrim(string) {
    return string ? string.slice(0, $4bd6b744d61c5b22$exports(string) + 1).replace($b7250667cdf52739$var$reTrimStart, '') : string;
}
$b7250667cdf52739$exports = $b7250667cdf52739$var$baseTrim;




var $87L1g = parcelRequire("87L1g");
/** Used as references for various `Number` constants. */ var $4bcc34f8cd22cc6a$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $4bcc34f8cd22cc6a$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $4bcc34f8cd22cc6a$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $4bcc34f8cd22cc6a$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $4bcc34f8cd22cc6a$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $4bcc34f8cd22cc6a$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($87L1g(value)) return $4bcc34f8cd22cc6a$var$NAN;
    if ($aaebd2a43568f36a$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $aaebd2a43568f36a$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $b7250667cdf52739$exports(value);
    var isBinary = $4bcc34f8cd22cc6a$var$reIsBinary.test(value);
    return isBinary || $4bcc34f8cd22cc6a$var$reIsOctal.test(value) ? $4bcc34f8cd22cc6a$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $4bcc34f8cd22cc6a$var$reIsBadHex.test(value) ? $4bcc34f8cd22cc6a$var$NAN : +value;
}
$4bcc34f8cd22cc6a$exports = $4bcc34f8cd22cc6a$var$toNumber;


/** Error message constants. */ var $562af9b9f81485c2$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $562af9b9f81485c2$var$nativeMax = Math.max, $562af9b9f81485c2$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $562af9b9f81485c2$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($562af9b9f81485c2$var$FUNC_ERROR_TEXT);
    wait = $4bcc34f8cd22cc6a$exports(wait) || 0;
    if ($aaebd2a43568f36a$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $562af9b9f81485c2$var$nativeMax($4bcc34f8cd22cc6a$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $562af9b9f81485c2$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $16bb6804e421696b$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($16bb6804e421696b$exports());
    }
    function debounced() {
        var time = $16bb6804e421696b$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$562af9b9f81485c2$exports = $562af9b9f81485c2$var$debounce;




var $6fFrj = parcelRequire("6fFrj");



var $80a5ad5fdc1497cd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $80a5ad5fdc1497cd$var$SpinSizes = (0, $cacd97b96801cebe$export$65e3907585753458)('small', 'default', 'large');
// Render indicator
var $80a5ad5fdc1497cd$var$defaultIndicator = null;
function $80a5ad5fdc1497cd$var$renderIndicator(prefixCls, props) {
    var indicator = props.indicator;
    var dotClassName = "".concat(prefixCls, "-dot");
    // should not be render default indicator when indicator value is null
    if (indicator === null) return null;
    if ((0, $79365009d9b77ac6$export$a8257692ac88316c)(indicator)) return (0, $79365009d9b77ac6$export$e530037191fcd5d7)(indicator, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(indicator.props.className, dotClassName)
    });
    if ((0, $79365009d9b77ac6$export$a8257692ac88316c)($80a5ad5fdc1497cd$var$defaultIndicator)) return (0, $79365009d9b77ac6$export$e530037191fcd5d7)($80a5ad5fdc1497cd$var$defaultIndicator, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))($80a5ad5fdc1497cd$var$defaultIndicator.props.className, dotClassName)
    });
    return /*#__PURE__*/ $6fFrj.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(dotClassName, "".concat(prefixCls, "-dot-spin"))
    }, /*#__PURE__*/ $6fFrj.createElement("i", {
        className: "".concat(prefixCls, "-dot-item")
    }), /*#__PURE__*/ $6fFrj.createElement("i", {
        className: "".concat(prefixCls, "-dot-item")
    }), /*#__PURE__*/ $6fFrj.createElement("i", {
        className: "".concat(prefixCls, "-dot-item")
    }), /*#__PURE__*/ $6fFrj.createElement("i", {
        className: "".concat(prefixCls, "-dot-item")
    }));
}
function $80a5ad5fdc1497cd$var$shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !isNaN(Number(delay));
}
var $80a5ad5fdc1497cd$var$Spin = function Spin(props) {
    var prefixCls = props.spinPrefixCls, _props$spinning = props.spinning, customSpinning = _props$spinning === void 0 ? true : _props$spinning, delay = props.delay, className = props.className, _props$size = props.size, size = _props$size === void 0 ? 'default' : _props$size, tip = props.tip, wrapperClassName = props.wrapperClassName, style = props.style, children = props.children, restProps = $80a5ad5fdc1497cd$var$__rest(props, [
        "spinPrefixCls",
        "spinning",
        "delay",
        "className",
        "size",
        "tip",
        "wrapperClassName",
        "style",
        "children"
    ]);
    var _React$useState = $6fFrj.useState(function() {
        return customSpinning && !$80a5ad5fdc1497cd$var$shouldDelay(customSpinning, delay);
    }), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), spinning = _React$useState2[0], setSpinning = _React$useState2[1];
    $6fFrj.useEffect(function() {
        var updateSpinning = (0, (/*@__PURE__*/$parcel$interopDefault($562af9b9f81485c2$exports)))(function() {
            setSpinning(customSpinning);
        }, delay);
        updateSpinning();
        return function() {
            var _a;
            (_a = updateSpinning === null || updateSpinning === void 0 ? void 0 : updateSpinning.cancel) === null || _a === void 0 || _a.call(updateSpinning);
        };
    }, [
        delay,
        customSpinning
    ]);
    var isNestedPattern = function isNestedPattern() {
        return typeof children !== 'undefined';
    };
    var renderSpin = function renderSpin(_ref) {
        var direction = _ref.direction;
        var spinClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-sm"), size === 'small'), "".concat(prefixCls, "-lg"), size === 'large'), "".concat(prefixCls, "-spinning"), spinning), "".concat(prefixCls, "-show-text"), !!tip), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
        // fix https://fb.me/react-unknown-prop
        var divProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(restProps, [
            'indicator',
            'prefixCls'
        ]);
        var spinElement = /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({}, divProps, {
            style: style,
            className: spinClassName,
            "aria-live": "polite",
            "aria-busy": spinning
        }), $80a5ad5fdc1497cd$var$renderIndicator(prefixCls, props), tip ? /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-text")
        }, tip) : null);
        if (isNestedPattern()) {
            var containerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-container"), (0, $43449.default)({}, "".concat(prefixCls, "-blur"), spinning));
            return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({}, divProps, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-nested-loading"), wrapperClassName)
            }), spinning && /*#__PURE__*/ $6fFrj.createElement("div", {
                key: "loading"
            }, spinElement), /*#__PURE__*/ $6fFrj.createElement("div", {
                className: containerClassName,
                key: "container"
            }, children));
        }
        return spinElement;
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $1bdb4c3de815e386$export$cd5442f2b8da7663), null, renderSpin);
};
var $80a5ad5fdc1497cd$var$SpinFC = function SpinFC(props) {
    var customizePrefixCls = props.prefixCls;
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var spinPrefixCls = getPrefixCls('spin', customizePrefixCls);
    var spinClassProps = (0, $fIrcP.default)((0, $fIrcP.default)({}, props), {
        spinPrefixCls: spinPrefixCls
    });
    return /*#__PURE__*/ $6fFrj.createElement($80a5ad5fdc1497cd$var$Spin, (0, $fIrcP.default)({}, spinClassProps));
};
$80a5ad5fdc1497cd$var$SpinFC.setDefaultIndicator = function(indicator) {
    $80a5ad5fdc1497cd$var$defaultIndicator = indicator;
};
var $80a5ad5fdc1497cd$export$2e2bcd8739ae039 = $80a5ad5fdc1497cd$var$SpinFC;




var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");




var $017ecc8a8f383a2a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $017ecc8a8f383a2a$export$b08a9033b36413fb = function Meta(_a) {
    var customizePrefixCls = _a.prefixCls, className = _a.className, avatar = _a.avatar, title = _a.title, description = _a.description, others = $017ecc8a8f383a2a$var$__rest(_a, [
        "prefixCls",
        "className",
        "avatar",
        "title",
        "description"
    ]);
    var _useContext = (0, $6fFrj.useContext)((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext.getPrefixCls;
    var prefixCls = getPrefixCls('list', customizePrefixCls);
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-item-meta"), className);
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "".concat(prefixCls, "-item-meta-content")
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("h4", {
        className: "".concat(prefixCls, "-item-meta-title")
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "".concat(prefixCls, "-item-meta-description")
    }, description));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", (0, $fIrcP.default)({}, others, {
        className: classString
    }), avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "".concat(prefixCls, "-item-meta-avatar")
    }, avatar), (title || description) && content);
};
var $017ecc8a8f383a2a$var$InternalItem = function InternalItem(_a, ref) {
    var customizePrefixCls = _a.prefixCls, children = _a.children, actions = _a.actions, extra = _a.extra, className = _a.className, colStyle = _a.colStyle, others = $017ecc8a8f383a2a$var$__rest(_a, [
        "prefixCls",
        "children",
        "actions",
        "extra",
        "className",
        "colStyle"
    ]);
    var _useContext2 = (0, $6fFrj.useContext)((0, $550318ddff00815a$export$52411773e0d6f15d)), grid = _useContext2.grid, itemLayout = _useContext2.itemLayout;
    var _useContext3 = (0, $6fFrj.useContext)((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext3.getPrefixCls;
    var isItemContainsTextNodeAndNotSingular = function isItemContainsTextNodeAndNotSingular() {
        var result;
        (0, $6fFrj.Children).forEach(children, function(element) {
            if (typeof element === 'string') result = true;
        });
        return result && (0, $6fFrj.Children).count(children) > 1;
    };
    var isFlexMode = function isFlexMode() {
        if (itemLayout === 'vertical') return !!extra;
        return !isItemContainsTextNodeAndNotSingular();
    };
    var prefixCls = getPrefixCls('list', customizePrefixCls);
    var actionsContent = actions && actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("ul", {
        className: "".concat(prefixCls, "-item-action"),
        key: "actions"
    }, actions.map(function(action, i) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("li", {
            key: "".concat(prefixCls, "-item-action-").concat(i)
        }, action, i !== actions.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("em", {
            className: "".concat(prefixCls, "-item-action-split")
        })));
    }));
    var Element = grid ? 'div' : 'li';
    var itemChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Element, (0, $fIrcP.default)({}, others, !grid ? {
        ref: ref
    } : {}, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-item"), (0, $43449.default)({}, "".concat(prefixCls, "-item-no-flex"), !isFlexMode()), className)
    }), itemLayout === 'vertical' && extra ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
            className: "".concat(prefixCls, "-item-main"),
            key: "content"
        }, children, actionsContent),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
            className: "".concat(prefixCls, "-item-extra"),
            key: "extra"
        }, extra)
    ] : [
        children,
        actionsContent,
        (0, $79365009d9b77ac6$export$e530037191fcd5d7)(extra, {
            key: 'extra'
        })
    ]);
    return grid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $00584e60fec74e25$export$2e2bcd8739ae039), {
        ref: ref,
        flex: 1,
        style: colStyle
    }, itemChildren) : itemChildren;
};
var $017ecc8a8f383a2a$var$Item = /*#__PURE__*/ (0, $6fFrj.forwardRef)($017ecc8a8f383a2a$var$InternalItem);
$017ecc8a8f383a2a$var$Item.Meta = $017ecc8a8f383a2a$export$b08a9033b36413fb;
var $017ecc8a8f383a2a$export$2e2bcd8739ae039 = $017ecc8a8f383a2a$var$Item;


var $550318ddff00815a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $550318ddff00815a$export$52411773e0d6f15d = /*#__PURE__*/ $6fFrj.createContext({});
var $550318ddff00815a$export$a3183b990150745c = $550318ddff00815a$export$52411773e0d6f15d.Consumer;
function $550318ddff00815a$var$List(_a) {
    var _a$pagination = _a.pagination, pagination = _a$pagination === void 0 ? false : _a$pagination, customizePrefixCls = _a.prefixCls, _a$bordered = _a.bordered, bordered = _a$bordered === void 0 ? false : _a$bordered, _a$split = _a.split, split = _a$split === void 0 ? true : _a$split, className = _a.className, children = _a.children, itemLayout = _a.itemLayout, loadMore = _a.loadMore, grid = _a.grid, _a$dataSource = _a.dataSource, dataSource = _a$dataSource === void 0 ? [] : _a$dataSource, size = _a.size, header = _a.header, footer = _a.footer, _a$loading = _a.loading, loading = _a$loading === void 0 ? false : _a$loading, rowKey = _a.rowKey, renderItem = _a.renderItem, locale = _a.locale, rest = $550318ddff00815a$var$__rest(_a, [
        "pagination",
        "prefixCls",
        "bordered",
        "split",
        "className",
        "children",
        "itemLayout",
        "loadMore",
        "grid",
        "dataSource",
        "size",
        "header",
        "footer",
        "loading",
        "rowKey",
        "renderItem",
        "locale"
    ]);
    var paginationObj = pagination && (0, $5KhTJ.default)(pagination) === 'object' ? pagination : {};
    var _React$useState = $6fFrj.useState(paginationObj.defaultCurrent || 1), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), paginationCurrent = _React$useState2[0], setPaginationCurrent = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState(paginationObj.defaultPageSize || 10), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), paginationSize = _React$useState4[0], setPaginationSize = _React$useState4[1];
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, renderEmpty = _React$useContext.renderEmpty, direction = _React$useContext.direction;
    var defaultPaginationProps = {
        current: 1,
        total: 0
    };
    var triggerPaginationEvent = function triggerPaginationEvent(eventName) {
        return function(page, pageSize) {
            setPaginationCurrent(page);
            setPaginationSize(pageSize);
            if (pagination && pagination[eventName]) pagination[eventName](page, pageSize);
        };
    };
    var onPaginationChange = triggerPaginationEvent('onChange');
    var onPaginationShowSizeChange = triggerPaginationEvent('onShowSizeChange');
    var renderInnerItem = function renderInnerItem(item, index) {
        if (!renderItem) return null;
        var key;
        if (typeof rowKey === 'function') key = rowKey(item);
        else if (rowKey) key = item[rowKey];
        else key = item.key;
        if (!key) key = "list-item-".concat(index);
        return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, {
            key: key
        }, renderItem(item, index));
    };
    var isSomethingAfterLastItem = function isSomethingAfterLastItem() {
        return !!(loadMore || pagination || footer);
    };
    var renderEmptyFunc = function renderEmptyFunc(prefixCls, renderEmptyHandler) {
        return /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-empty-text")
        }, locale && locale.emptyText || renderEmptyHandler('List'));
    };
    var prefixCls = getPrefixCls('list', customizePrefixCls);
    var loadingProp = loading;
    if (typeof loadingProp === 'boolean') loadingProp = {
        spinning: loadingProp
    };
    var isLoading = loadingProp && loadingProp.spinning;
    // large => lg
    // small => sm
    var sizeCls = '';
    switch(size){
        case 'large':
            sizeCls = 'lg';
            break;
        case 'small':
            sizeCls = 'sm';
            break;
        default:
            break;
    }
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-vertical"), itemLayout === 'vertical'), "".concat(prefixCls, "-").concat(sizeCls), sizeCls), "".concat(prefixCls, "-split"), split), "".concat(prefixCls, "-bordered"), bordered), "".concat(prefixCls, "-loading"), isLoading), "".concat(prefixCls, "-grid"), !!grid), "".concat(prefixCls, "-something-after-last-item"), isSomethingAfterLastItem()), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    var paginationProps = (0, $fIrcP.default)((0, $fIrcP.default)((0, $fIrcP.default)({}, defaultPaginationProps), {
        total: dataSource.length,
        current: paginationCurrent,
        pageSize: paginationSize
    }), pagination || {});
    var largestPage = Math.ceil(paginationProps.total / paginationProps.pageSize);
    if (paginationProps.current > largestPage) paginationProps.current = largestPage;
    var paginationContent = pagination ? /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-pagination")
    }, /*#__PURE__*/ $6fFrj.createElement((0, $e5809665964e3ab6$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, paginationProps, {
        onChange: onPaginationChange,
        onShowSizeChange: onPaginationShowSizeChange
    }))) : null;
    var splitDataSource = (0, $37xND.default)(dataSource);
    if (pagination) {
        if (dataSource.length > (paginationProps.current - 1) * paginationProps.pageSize) splitDataSource = (0, $37xND.default)(dataSource).splice((paginationProps.current - 1) * paginationProps.pageSize, paginationProps.pageSize);
    }
    var needResponsive = Object.keys(grid || {}).some(function(key) {
        return [
            'xs',
            'sm',
            'md',
            'lg',
            'xl',
            'xxl'
        ].includes(key);
    });
    var screens = (0, $60fdd98823a1708b$export$2e2bcd8739ae039)(needResponsive);
    var currentBreakpoint = $6fFrj.useMemo(function() {
        for(var i = 0; i < (0, $ba9d944a99636e67$export$74c1bf8296b1541f).length; i += 1){
            var breakpoint = (0, $ba9d944a99636e67$export$74c1bf8296b1541f)[i];
            if (screens[breakpoint]) return breakpoint;
        }
        return undefined;
    }, [
        screens
    ]);
    var colStyle = $6fFrj.useMemo(function() {
        if (!grid) return undefined;
        var columnCount = currentBreakpoint && grid[currentBreakpoint] ? grid[currentBreakpoint] : grid.column;
        if (columnCount) return {
            width: "".concat(100 / columnCount, "%"),
            maxWidth: "".concat(100 / columnCount, "%")
        };
    }, [
        grid === null || grid === void 0 ? void 0 : grid.column,
        currentBreakpoint
    ]);
    var childrenContent = isLoading && /*#__PURE__*/ $6fFrj.createElement("div", {
        style: {
            minHeight: 53
        }
    });
    if (splitDataSource.length > 0) {
        var items = splitDataSource.map(function(item, index) {
            return renderInnerItem(item, index);
        });
        childrenContent = grid ? /*#__PURE__*/ $6fFrj.createElement((0, $4a8085e587664aad$export$2e2bcd8739ae039), {
            gutter: grid.gutter
        }, $6fFrj.Children.map(items, function(child) {
            return /*#__PURE__*/ $6fFrj.createElement("div", {
                key: child === null || child === void 0 ? void 0 : child.key,
                style: colStyle
            }, child);
        })) : /*#__PURE__*/ $6fFrj.createElement("ul", {
            className: "".concat(prefixCls, "-items")
        }, items);
    } else if (!children && !isLoading) childrenContent = renderEmptyFunc(prefixCls, renderEmpty || (0, $94fec351dda17415$export$2e2bcd8739ae039));
    var paginationPosition = paginationProps.position || 'bottom';
    var contextValue = $6fFrj.useMemo(function() {
        return {
            grid: grid,
            itemLayout: itemLayout
        };
    }, [
        JSON.stringify(grid),
        itemLayout
    ]);
    return /*#__PURE__*/ $6fFrj.createElement($550318ddff00815a$export$52411773e0d6f15d.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        className: classString
    }, rest), (paginationPosition === 'top' || paginationPosition === 'both') && paginationContent, header && /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-header")
    }, header), /*#__PURE__*/ $6fFrj.createElement((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, loadingProp), childrenContent, children), footer && /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-footer")
    }, footer), loadMore || (paginationPosition === 'bottom' || paginationPosition === 'both') && paginationContent));
}
$550318ddff00815a$var$List.Item = (0, $017ecc8a8f383a2a$export$2e2bcd8739ae039);
var $550318ddff00815a$export$2e2bcd8739ae039 = $550318ddff00815a$var$List;


var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $251ab651017721ea$var$ArrowLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "arrow-left",
    "theme": "outlined"
};
var $251ab651017721ea$export$2e2bcd8739ae039 = $251ab651017721ea$var$ArrowLeftOutlined;



var $01ad9e8a3bd19b36$var$ArrowLeftOutlined = function ArrowLeftOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $251ab651017721ea$export$2e2bcd8739ae039)
    }));
};
var $01ad9e8a3bd19b36$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($01ad9e8a3bd19b36$var$ArrowLeftOutlined);
var $01ad9e8a3bd19b36$export$2e2bcd8739ae039 = $01ad9e8a3bd19b36$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $847f79d3a55c2b31$var$ArrowRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z"
                }
            }
        ]
    },
    "name": "arrow-right",
    "theme": "outlined"
};
var $847f79d3a55c2b31$export$2e2bcd8739ae039 = $847f79d3a55c2b31$var$ArrowRightOutlined;



var $ac69dec4428cf061$var$ArrowRightOutlined = function ArrowRightOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $847f79d3a55c2b31$export$2e2bcd8739ae039)
    }));
};
var $ac69dec4428cf061$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($ac69dec4428cf061$var$ArrowRightOutlined);
var $ac69dec4428cf061$export$2e2bcd8739ae039 = $ac69dec4428cf061$var$RefIcon;



var $fActo = parcelRequire("fActo");


var $lqiy0 = parcelRequire("lqiy0");

var $6fFrj = parcelRequire("6fFrj");


var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $37xND = parcelRequire("37xND");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");





var $fIrcP = parcelRequire("fIrcP");


var $6fFrj = parcelRequire("6fFrj");



var $5c5002b715d0de2b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5c5002b715d0de2b$var$BreadcrumbItem = function BreadcrumbItem(props) {
    var customizePrefixCls = props.prefixCls, _props$separator = props.separator, separator = _props$separator === void 0 ? '/' : _props$separator, children = props.children, menu = props.menu, overlay = props.overlay, dropdownProps = props.dropdownProps, restProps = $5c5002b715d0de2b$var$__rest(props, [
        "prefixCls",
        "separator",
        "children",
        "menu",
        "overlay",
        "dropdownProps"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
    /** If overlay is have Wrap a Dropdown */ var renderBreadcrumbNode = function renderBreadcrumbNode(breadcrumbItem) {
        if (menu || overlay) {
            var mergeDropDownProps = (0, $fIrcP.default)({}, dropdownProps);
            if ('overlay' in props) mergeDropDownProps.overlay = overlay;
            return /*#__PURE__*/ $6fFrj.createElement((0, $0c3681e83b80e1fa$export$2e2bcd8739ae039), (0, $fIrcP.default)({
                menu: menu,
                placement: "bottom"
            }, mergeDropDownProps), /*#__PURE__*/ $6fFrj.createElement("span", {
                className: "".concat(prefixCls, "-overlay-link")
            }, breadcrumbItem, /*#__PURE__*/ $6fFrj.createElement((0, $344ef0cbd3adff87$export$2e2bcd8739ae039), null)));
        }
        return breadcrumbItem;
    };
    var link;
    if ('href' in restProps) link = /*#__PURE__*/ $6fFrj.createElement("a", (0, $fIrcP.default)({
        className: "".concat(prefixCls, "-link")
    }, restProps), children);
    else link = /*#__PURE__*/ $6fFrj.createElement("span", (0, $fIrcP.default)({
        className: "".concat(prefixCls, "-link")
    }, restProps), children);
    // wrap to dropDown
    link = renderBreadcrumbNode(link);
    if (children !== undefined && children !== null) return /*#__PURE__*/ $6fFrj.createElement("li", null, link, separator && /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-separator")
    }, separator));
    return null;
};
$5c5002b715d0de2b$var$BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
var $5c5002b715d0de2b$export$2e2bcd8739ae039 = $5c5002b715d0de2b$var$BreadcrumbItem;



var $6fFrj = parcelRequire("6fFrj");

var $96c5cd8fb1679018$var$BreadcrumbSeparator = function BreadcrumbSeparator(_ref) {
    var children = _ref.children;
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('breadcrumb');
    return /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-separator")
    }, children || '/');
};
$96c5cd8fb1679018$var$BreadcrumbSeparator.__ANT_BREADCRUMB_SEPARATOR = true;
var $96c5cd8fb1679018$export$2e2bcd8739ae039 = $96c5cd8fb1679018$var$BreadcrumbSeparator;


var $a9446621cf672208$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $a9446621cf672208$var$getBreadcrumbName(route, params) {
    if (!route.breadcrumbName) return null;
    var paramsKeys = Object.keys(params).join('|');
    var name = route.breadcrumbName.replace(new RegExp(":(".concat(paramsKeys, ")"), 'g'), function(replacement, key) {
        return params[key] || replacement;
    });
    return name;
}
function $a9446621cf672208$var$defaultItemRender(route, params, routes, paths) {
    var isLastItem = routes.indexOf(route) === routes.length - 1;
    var name = $a9446621cf672208$var$getBreadcrumbName(route, params);
    return isLastItem ? /*#__PURE__*/ $6fFrj.createElement("span", null, name) : /*#__PURE__*/ $6fFrj.createElement("a", {
        href: "#/".concat(paths.join('/'))
    }, name);
}
var $a9446621cf672208$var$getPath = function getPath(path, params) {
    path = (path || '').replace(/^\//, '');
    Object.keys(params).forEach(function(key) {
        path = path.replace(":".concat(key), params[key]);
    });
    return path;
};
var $a9446621cf672208$var$addChildPath = function addChildPath(paths, childPath, params) {
    var originalPaths = (0, $37xND.default)(paths);
    var path = $a9446621cf672208$var$getPath(childPath || '', params);
    if (path) originalPaths.push(path);
    return originalPaths;
};
var $a9446621cf672208$var$Breadcrumb = function Breadcrumb(_a) {
    var customizePrefixCls = _a.prefixCls, _a$separator = _a.separator, separator = _a$separator === void 0 ? '/' : _a$separator, style = _a.style, className = _a.className, routes = _a.routes, children = _a.children, _a$itemRender = _a.itemRender, itemRender = _a$itemRender === void 0 ? $a9446621cf672208$var$defaultItemRender : _a$itemRender, _a$params = _a.params, params = _a$params === void 0 ? {} : _a$params, restProps = $a9446621cf672208$var$__rest(_a, [
        "prefixCls",
        "separator",
        "style",
        "className",
        "routes",
        "children",
        "itemRender",
        "params"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var crumbs;
    var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
    if (routes && routes.length > 0) {
        // generated by route
        var paths = [];
        crumbs = routes.map(function(route) {
            var path = $a9446621cf672208$var$getPath(route.path, params);
            if (path) paths.push(path);
            // generated overlay by route.children
            var overlay;
            if (route.children && route.children.length) overlay = /*#__PURE__*/ $6fFrj.createElement((0, $d93242227496acaa$export$2e2bcd8739ae039), {
                items: route.children.map(function(child) {
                    return {
                        key: child.path || child.breadcrumbName,
                        label: itemRender(child, params, routes, $a9446621cf672208$var$addChildPath(paths, child.path, params))
                    };
                })
            });
            var itemProps = {
                separator: separator
            };
            if (overlay) itemProps.overlay = overlay;
            return /*#__PURE__*/ $6fFrj.createElement((0, $5c5002b715d0de2b$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, itemProps, {
                key: path || route.breadcrumbName
            }), itemRender(route, params, routes, paths));
        });
    } else if (children) crumbs = (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(children).map(function(element, index) {
        if (!element) return element;
        return (0, $79365009d9b77ac6$export$e530037191fcd5d7)(element, {
            separator: separator,
            key: index
        });
    });
    var breadcrumbClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $6fFrj.createElement("nav", (0, $fIrcP.default)({
        className: breadcrumbClassName,
        style: style
    }, restProps), /*#__PURE__*/ $6fFrj.createElement("ol", null, crumbs));
};
$a9446621cf672208$var$Breadcrumb.Item = (0, $5c5002b715d0de2b$export$2e2bcd8739ae039);
$a9446621cf672208$var$Breadcrumb.Separator = (0, $96c5cd8fb1679018$export$2e2bcd8739ae039);
var $a9446621cf672208$export$2e2bcd8739ae039 = $a9446621cf672208$var$Breadcrumb;


var $e9e71e1a76b579b8$export$2e2bcd8739ae039 = (0, $a9446621cf672208$export$2e2bcd8739ae039);






var $fIrcP = parcelRequire("fIrcP");


var $6fFrj = parcelRequire("6fFrj");
var $f2c761931619ec0a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f2c761931619ec0a$var$inlineStyle = {
    border: 0,
    background: 'transparent',
    padding: 0,
    lineHeight: 'inherit',
    display: 'inline-block'
};
var $f2c761931619ec0a$var$TransButton = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var onKeyDown = function onKeyDown(event) {
        var keyCode = event.keyCode;
        if (keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER) event.preventDefault();
    };
    var onKeyUp = function onKeyUp(event) {
        var keyCode = event.keyCode;
        var onClick = props.onClick;
        if (keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER && onClick) onClick();
    };
    var style = props.style, noStyle = props.noStyle, disabled = props.disabled, restProps = $f2c761931619ec0a$var$__rest(props, [
        "style",
        "noStyle",
        "disabled"
    ]);
    var mergedStyle = {};
    if (!noStyle) mergedStyle = (0, $fIrcP.default)({}, $f2c761931619ec0a$var$inlineStyle);
    if (disabled) mergedStyle.pointerEvents = 'none';
    mergedStyle = (0, $fIrcP.default)((0, $fIrcP.default)({}, mergedStyle), style);
    return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        role: "button",
        tabIndex: 0,
        ref: ref
    }, restProps, {
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        style: mergedStyle
    }));
});
var $f2c761931619ec0a$export$2e2bcd8739ae039 = $f2c761931619ec0a$var$TransButton;


var $d8be83256c7630cc$var$renderBack = function renderBack(prefixCls, backIcon, onBack) {
    if (!backIcon || !onBack) return null;
    return /*#__PURE__*/ $6fFrj.createElement((0, $d37c6ecde78f75e8$export$2e2bcd8739ae039), {
        componentName: "PageHeader"
    }, function(contextLocale) {
        return /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-back")
        }, /*#__PURE__*/ $6fFrj.createElement((0, $f2c761931619ec0a$export$2e2bcd8739ae039), {
            onClick: function onClick(e) {
                onBack === null || onBack === void 0 || onBack(e);
            },
            className: "".concat(prefixCls, "-back-button"),
            "aria-label": contextLocale.back
        }, backIcon));
    });
};
var $d8be83256c7630cc$var$renderBreadcrumb = function renderBreadcrumb(breadcrumb) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $e9e71e1a76b579b8$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, breadcrumb));
};
var $d8be83256c7630cc$var$getBackIcon = function getBackIcon(props) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ltr';
    if (props.backIcon !== undefined) return props.backIcon;
    return direction === 'rtl' ? /*#__PURE__*/ $6fFrj.createElement((0, $ac69dec4428cf061$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $6fFrj.createElement((0, $01ad9e8a3bd19b36$export$2e2bcd8739ae039), null);
};
var $d8be83256c7630cc$var$renderTitle = function renderTitle(prefixCls, props) {
    var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ltr';
    var title = props.title, avatar = props.avatar, subTitle = props.subTitle, tags = props.tags, extra = props.extra, onBack = props.onBack;
    var headingPrefixCls = "".concat(prefixCls, "-heading");
    var hasHeading = title || subTitle || tags || extra;
    // If there is nothing, return a null
    if (!hasHeading) return null;
    var backIcon = $d8be83256c7630cc$var$getBackIcon(props, direction);
    var backIconDom = $d8be83256c7630cc$var$renderBack(prefixCls, backIcon, onBack);
    var hasTitle = backIconDom || avatar || hasHeading;
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: headingPrefixCls
    }, hasTitle && /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(headingPrefixCls, "-left")
    }, backIconDom, avatar && /*#__PURE__*/ $6fFrj.createElement((0, $1089f078d9068e78$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, avatar)), title && /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(headingPrefixCls, "-title"),
        title: typeof title === 'string' ? title : undefined
    }, title), subTitle && /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(headingPrefixCls, "-sub-title"),
        title: typeof subTitle === 'string' ? subTitle : undefined
    }, subTitle), tags && /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(headingPrefixCls, "-tags")
    }, tags)), extra && /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(headingPrefixCls, "-extra")
    }, /*#__PURE__*/ $6fFrj.createElement((0, $4563a45a032814da$export$2e2bcd8739ae039), null, extra)));
};
var $d8be83256c7630cc$var$renderFooter = function renderFooter(prefixCls, footer) {
    if (footer) return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-footer")
    }, footer);
    return null;
};
var $d8be83256c7630cc$var$renderChildren = function renderChildren(prefixCls, children) {
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
};
var $d8be83256c7630cc$var$PageHeader = function PageHeader(props) {
    var _useState = (0, $lqiy0.default)(false), _useState2 = (0, $jP8CL.default)(_useState, 2), compact = _useState2[0], updateCompact = _useState2[1];
    var onResize = function onResize(_ref) {
        var width = _ref.width;
        updateCompact(width < 768, true);
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $1bdb4c3de815e386$export$cd5442f2b8da7663), null, function(_ref2) {
        var getPrefixCls = _ref2.getPrefixCls, pageHeader = _ref2.pageHeader, direction = _ref2.direction;
        var _a;
        var customizePrefixCls = props.prefixCls, style = props.style, footer = props.footer, children = props.children, breadcrumb = props.breadcrumb, breadcrumbRender = props.breadcrumbRender, customizeClassName = props.className;
        var ghost = true;
        // Use `ghost` from `props` or from `ConfigProvider` instead.
        if ('ghost' in props) ghost = props.ghost;
        else if (pageHeader && 'ghost' in pageHeader) ghost = pageHeader.ghost;
        var prefixCls = getPrefixCls('page-header', customizePrefixCls);
        var getDefaultBreadcrumbDom = function getDefaultBreadcrumbDom() {
            if (breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.routes) return $d8be83256c7630cc$var$renderBreadcrumb(breadcrumb);
            return null;
        };
        var defaultBreadcrumbDom = getDefaultBreadcrumbDom();
        var isBreadcrumbComponent = breadcrumb && 'props' in breadcrumb;
        // support breadcrumbRender function
        var breadcrumbRenderDomFromProps = (_a = breadcrumbRender === null || breadcrumbRender === void 0 ? void 0 : breadcrumbRender(props, defaultBreadcrumbDom)) !== null && _a !== void 0 ? _a : defaultBreadcrumbDom;
        var breadcrumbDom = isBreadcrumbComponent ? breadcrumb : breadcrumbRenderDomFromProps;
        var className = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, customizeClassName, (0, $43449.default)((0, $43449.default)((0, $43449.default)({
            'has-breadcrumb': !!breadcrumbDom,
            'has-footer': !!footer
        }, "".concat(prefixCls, "-ghost"), ghost), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-compact"), compact));
        return /*#__PURE__*/ $6fFrj.createElement((0, $8e6bb008621f90f5$export$2e2bcd8739ae039), {
            onResize: onResize
        }, /*#__PURE__*/ $6fFrj.createElement("div", {
            className: className,
            style: style
        }, breadcrumbDom, $d8be83256c7630cc$var$renderTitle(prefixCls, props, direction), children && $d8be83256c7630cc$var$renderChildren(prefixCls, children), $d8be83256c7630cc$var$renderFooter(prefixCls, footer)));
    });
};
var $d8be83256c7630cc$export$2e2bcd8739ae039 = $d8be83256c7630cc$var$PageHeader;


var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");


var $fActo = parcelRequire("fActo");

var $gfhff = parcelRequire("gfhff");


var $6fFrj = parcelRequire("6fFrj");




var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");



var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $lqiy0 = parcelRequire("lqiy0");

var $6fFrj = parcelRequire("6fFrj");


function $78552d1d483c77c7$var$isThenable(thing) {
    return !!(thing && !!thing.then);
}
var $78552d1d483c77c7$var$ActionButton = function ActionButton(props) {
    var clickedRef = $6fFrj.useRef(false);
    var ref = $6fFrj.useRef(null);
    var _useState = (0, $lqiy0.default)(false), _useState2 = (0, $jP8CL.default)(_useState, 2), loading = _useState2[0], setLoading = _useState2[1];
    var close = props.close;
    var onInternalClose = function onInternalClose() {
        close === null || close === void 0 || close.apply(void 0, arguments);
    };
    $6fFrj.useEffect(function() {
        var timeoutId = null;
        if (props.autoFocus) timeoutId = setTimeout(function() {
            var _a;
            (_a = ref.current) === null || _a === void 0 || _a.focus();
        });
        return function() {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, []);
    var handlePromiseOnOk = function handlePromiseOnOk(returnValueOfOnOk) {
        if (!$78552d1d483c77c7$var$isThenable(returnValueOfOnOk)) return;
        setLoading(true);
        returnValueOfOnOk.then(function() {
            setLoading(false, true);
            onInternalClose.apply(void 0, arguments);
            clickedRef.current = false;
        }, function(e) {
            // See: https://github.com/ant-design/ant-design/issues/6183
            setLoading(false, true);
            clickedRef.current = false;
            return Promise.reject(e);
        });
    };
    var onClick = function onClick(e) {
        var actionFn = props.actionFn;
        if (clickedRef.current) return;
        clickedRef.current = true;
        if (!actionFn) {
            onInternalClose();
            return;
        }
        var returnValueOfOnOk;
        if (props.emitEvent) {
            returnValueOfOnOk = actionFn(e);
            if (props.quitOnNullishReturnValue && !$78552d1d483c77c7$var$isThenable(returnValueOfOnOk)) {
                clickedRef.current = false;
                onInternalClose(e);
                return;
            }
        } else if (actionFn.length) {
            returnValueOfOnOk = actionFn(close);
            // https://github.com/ant-design/ant-design/issues/23358
            clickedRef.current = false;
        } else {
            returnValueOfOnOk = actionFn();
            if (!returnValueOfOnOk) {
                onInternalClose();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    var type = props.type, children = props.children, prefixCls = props.prefixCls, buttonProps = props.buttonProps;
    return /*#__PURE__*/ $6fFrj.createElement((0, $ea0942a2e543872a$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, (0, $34c411687886965a$export$19bc9a290855952)(type), {
        onClick: onClick,
        loading: loading,
        prefixCls: prefixCls
    }, buttonProps, {
        ref: ref
    }), children);
};
var $78552d1d483c77c7$export$2e2bcd8739ae039 = $78552d1d483c77c7$var$ActionButton;






var $6653c7a26c4889c1$export$c6fdb837b070b4ff = function Overlay(props) {
    var prefixCls = props.prefixCls, okButtonProps = props.okButtonProps, cancelButtonProps = props.cancelButtonProps, title = props.title, cancelText = props.cancelText, okText = props.okText, okType = props.okType, icon = props.icon, _props$showCancel = props.showCancel, showCancel = _props$showCancel === void 0 ? true : _props$showCancel, close = props.close, onConfirm = props.onConfirm, onCancel = props.onCancel;
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    return /*#__PURE__*/ $6fFrj.createElement((0, $d37c6ecde78f75e8$export$2e2bcd8739ae039), {
        componentName: "Popconfirm",
        defaultLocale: (0, $da4c09bd655d3c55$export$2e2bcd8739ae039).Popconfirm
    }, function(contextLocale) {
        return /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-inner-content")
        }, /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-message")
        }, icon && /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-message-icon")
        }, icon), /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-message-title")
        }, (0, $fc871912853a3dce$export$15e5fca53711d340)(title))), /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-buttons")
        }, showCancel && /*#__PURE__*/ $6fFrj.createElement((0, $ea0942a2e543872a$export$2e2bcd8739ae039), (0, $fIrcP.default)({
            onClick: onCancel,
            size: "small"
        }, cancelButtonProps), cancelText !== null && cancelText !== void 0 ? cancelText : contextLocale.cancelText), /*#__PURE__*/ $6fFrj.createElement((0, $78552d1d483c77c7$export$2e2bcd8739ae039), {
            buttonProps: (0, $fIrcP.default)((0, $fIrcP.default)({
                size: 'small'
            }, (0, $34c411687886965a$export$19bc9a290855952)(okType)), okButtonProps),
            actionFn: onConfirm,
            close: close,
            prefixCls: getPrefixCls('btn'),
            quitOnNullishReturnValue: true,
            emitEvent: true
        }, okText !== null && okText !== void 0 ? okText : contextLocale.okText)));
    });
};


var $a361442371f1d4e9$var$_this = undefined;
var $a361442371f1d4e9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a361442371f1d4e9$var$Popconfirm = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, _props$placement = props.placement, placement = _props$placement === void 0 ? 'top' : _props$placement, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? 'click' : _props$trigger, _props$okType = props.okType, okType = _props$okType === void 0 ? 'primary' : _props$okType, _props$icon = props.icon, icon = _props$icon === void 0 ? /*#__PURE__*/ $6fFrj.createElement((0, $4b49a895caf27162$export$2e2bcd8739ae039), null) : _props$icon, children = props.children, overlayClassName = props.overlayClassName, onOpenChange = props.onOpenChange, onVisibleChange = props.onVisibleChange, restProps = $a361442371f1d4e9$var$__rest(props, [
        "prefixCls",
        "placement",
        "trigger",
        "okType",
        "icon",
        "children",
        "overlayClassName",
        "onOpenChange",
        "onVisibleChange"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var _useMergedState = (0, $gfhff.default)(false, {
        value: props.open !== undefined ? props.open : props.visible,
        defaultValue: props.defaultOpen !== undefined ? props.defaultOpen : props.defaultVisible
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), open = _useMergedState2[0], setOpen = _useMergedState2[1];
    // const isDestroyed = useDestroyed();
    var settingOpen = function settingOpen(value, e) {
        setOpen(value, true);
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(value, e);
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(value, e);
    };
    var close = function close(e) {
        settingOpen(false, e);
    };
    var onConfirm = function onConfirm(e) {
        var _a;
        return (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call($a361442371f1d4e9$var$_this, e);
    };
    var onCancel = function onCancel(e) {
        var _a;
        settingOpen(false, e);
        (_a = props.onCancel) === null || _a === void 0 || _a.call($a361442371f1d4e9$var$_this, e);
    };
    var _onKeyDown = function onKeyDown(e) {
        if (e.keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ESC && open) settingOpen(false, e);
    };
    var onInternalOpenChange = function onInternalOpenChange(value) {
        var _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled;
        if (disabled) return;
        settingOpen(value);
    };
    var prefixCls = getPrefixCls('popover', customizePrefixCls);
    var prefixClsConfirm = getPrefixCls('popconfirm', customizePrefixCls);
    var overlayClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixClsConfirm, overlayClassName);
    return /*#__PURE__*/ $6fFrj.createElement((0, $1eeb7f423c3f3d14$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, restProps, {
        trigger: trigger,
        prefixCls: prefixCls,
        placement: placement,
        onOpenChange: onInternalOpenChange,
        open: open,
        ref: ref,
        overlayClassName: overlayClassNames,
        _overlay: /*#__PURE__*/ $6fFrj.createElement((0, $6653c7a26c4889c1$export$c6fdb837b070b4ff), (0, $fIrcP.default)({
            okType: okType,
            icon: icon
        }, props, {
            prefixCls: prefixCls,
            close: close,
            onConfirm: onConfirm,
            onCancel: onCancel
        }))
    }), (0, $79365009d9b77ac6$export$e530037191fcd5d7)(children, {
        onKeyDown: function onKeyDown(e) {
            var _a, _b;
            if (/*#__PURE__*/ $6fFrj.isValidElement(children)) (_b = children === null || children === void 0 ? void 0 : (_a = children.props).onKeyDown) === null || _b === void 0 || _b.call(_a, e);
            _onKeyDown(e);
        }
    }));
});
var $a361442371f1d4e9$export$2e2bcd8739ae039 = $a361442371f1d4e9$var$Popconfirm;


var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");





var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");




var $43449 = parcelRequire("43449");


var $fActo = parcelRequire("fActo");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");
var $6ee0ed96cf1a0d72$export$9c21a3269931e1e6 = {
    percent: 0,
    prefixCls: 'rc-progress',
    strokeColor: '#2db7f5',
    strokeLinecap: 'round',
    strokeWidth: 1,
    trailColor: '#D9D9D9',
    trailWidth: 1,
    gapPosition: 'bottom'
};
var $6ee0ed96cf1a0d72$export$7685006d504ecf0b = function useTransitionDuration() {
    var pathsRef = (0, $6fFrj.useRef)([]);
    var prevTimeStamp = (0, $6fFrj.useRef)(null);
    (0, $6fFrj.useEffect)(function() {
        var now = Date.now();
        var updated = false;
        pathsRef.current.forEach(function(path) {
            if (!path) return;
            updated = true;
            var pathStyle = path.style;
            pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';
            if (prevTimeStamp.current && now - prevTimeStamp.current < 100) pathStyle.transitionDuration = '0s, 0s';
        });
        if (updated) prevTimeStamp.current = Date.now();
    });
    return pathsRef.current;
};


var $7210b3b1eaf3ad01$var$_excluded = [
    "className",
    "percent",
    "prefixCls",
    "strokeColor",
    "strokeLinecap",
    "strokeWidth",
    "style",
    "trailColor",
    "trailWidth",
    "transition"
];
var $7210b3b1eaf3ad01$var$Line = function Line(props) {
    var _defaultProps$props = (0, $kNxFX.default)((0, $kNxFX.default)({}, (0, $6ee0ed96cf1a0d72$export$9c21a3269931e1e6)), props), className = _defaultProps$props.className, percent = _defaultProps$props.percent, prefixCls = _defaultProps$props.prefixCls, strokeColor = _defaultProps$props.strokeColor, strokeLinecap = _defaultProps$props.strokeLinecap, strokeWidth = _defaultProps$props.strokeWidth, style = _defaultProps$props.style, trailColor = _defaultProps$props.trailColor, trailWidth = _defaultProps$props.trailWidth, transition = _defaultProps$props.transition, restProps = (0, $04RxA.default)(_defaultProps$props, $7210b3b1eaf3ad01$var$_excluded);
    // eslint-disable-next-line no-param-reassign
    delete restProps.gapPosition;
    var percentList = Array.isArray(percent) ? percent : [
        percent
    ];
    var strokeColorList = Array.isArray(strokeColor) ? strokeColor : [
        strokeColor
    ];
    var paths = (0, $6ee0ed96cf1a0d72$export$7685006d504ecf0b)();
    var center = strokeWidth / 2;
    var right = 100 - strokeWidth / 2;
    var pathString = "M ".concat(strokeLinecap === 'round' ? center : 0, ",").concat(center, "\n         L ").concat(strokeLinecap === 'round' ? right : 100, ",").concat(center);
    var viewBoxString = "0 0 100 ".concat(strokeWidth);
    var stackPtg = 0;
    return /*#__PURE__*/ $6fFrj.createElement("svg", (0, $fIrcP.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-line"), className),
        viewBox: viewBoxString,
        preserveAspectRatio: "none",
        style: style
    }, restProps), /*#__PURE__*/ $6fFrj.createElement("path", {
        className: "".concat(prefixCls, "-line-trail"),
        d: pathString,
        strokeLinecap: strokeLinecap,
        stroke: trailColor,
        strokeWidth: trailWidth || strokeWidth,
        fillOpacity: "0"
    }), percentList.map(function(ptg, index) {
        var dashPercent = 1;
        switch(strokeLinecap){
            case 'round':
                dashPercent = 1 - strokeWidth / 100;
                break;
            case 'square':
                dashPercent = 1 - strokeWidth / 2 / 100;
                break;
            default:
                dashPercent = 1;
                break;
        }
        var pathStyle = {
            strokeDasharray: "".concat(ptg * dashPercent, "px, 100px"),
            strokeDashoffset: "-".concat(stackPtg, "px"),
            transition: transition || 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray .3s ease 0s, stroke 0.3s linear'
        };
        var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
        stackPtg += ptg;
        return /*#__PURE__*/ $6fFrj.createElement("path", {
            key: index,
            className: "".concat(prefixCls, "-line-path"),
            d: pathString,
            strokeLinecap: strokeLinecap,
            stroke: color,
            strokeWidth: strokeWidth,
            fillOpacity: "0",
            ref: function ref(elem) {
                // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
                // React will call the ref callback with the DOM element when the component mounts,
                // and call it with `null` when it unmounts.
                // Refs are guaranteed to be up-to-date before componentDidMount or componentDidUpdate fires.
                paths[index] = elem;
            },
            style: pathStyle
        });
    }));
};
var $7210b3b1eaf3ad01$export$2e2bcd8739ae039 = $7210b3b1eaf3ad01$var$Line;



var $fIrcP = parcelRequire("fIrcP");

var $5KhTJ = parcelRequire("5KhTJ");

var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $aSXdS = parcelRequire("aSXdS");
var $6d2c04a39eedc82b$var$uuid = 0;
var $6d2c04a39eedc82b$export$df7146797a248522 = (0, $aSXdS.default)();
/** Get unique id for accessibility usage */ function $6d2c04a39eedc82b$var$getUUID() {
    var retId;
    // Test never reach
    /* istanbul ignore if */ if ($6d2c04a39eedc82b$export$df7146797a248522) {
        retId = $6d2c04a39eedc82b$var$uuid;
        $6d2c04a39eedc82b$var$uuid += 1;
    } else retId = 'TEST_OR_SSR';
    return retId;
}
var $6d2c04a39eedc82b$export$2e2bcd8739ae039 = function(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $6fFrj.useState(), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $6fFrj.useEffect(function() {
        setInnerId("rc_progress_".concat($6d2c04a39eedc82b$var$getUUID()));
    }, []);
    return id || innerId;
};


var $a9e966689f2af249$var$_excluded = [
    "id",
    "prefixCls",
    "steps",
    "strokeWidth",
    "trailWidth",
    "gapDegree",
    "gapPosition",
    "trailColor",
    "strokeLinecap",
    "style",
    "className",
    "strokeColor",
    "percent"
];
function $a9e966689f2af249$var$stripPercentToNumber(percent) {
    return +percent.replace('%', '');
}
function $a9e966689f2af249$var$toArray(value) {
    var mergedValue = value !== null && value !== void 0 ? value : [];
    return Array.isArray(mergedValue) ? mergedValue : [
        mergedValue
    ];
}
var $a9e966689f2af249$var$VIEW_BOX_SIZE = 100;
var $a9e966689f2af249$var$getCircleStyle = function getCircleStyle(perimeter, perimeterWithoutGap, offset, percent, rotateDeg, gapDegree, gapPosition, strokeColor, strokeLinecap, strokeWidth) {
    var stepSpace = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : 0;
    var offsetDeg = offset / 100 * 360 * ((360 - gapDegree) / 360);
    var positionDeg = gapDegree === 0 ? 0 : ({
        bottom: 0,
        top: 180,
        left: 90,
        right: -90
    })[gapPosition];
    var strokeDashoffset = (100 - percent) / 100 * perimeterWithoutGap;
    // Fix percent accuracy when strokeLinecap is round
    // https://github.com/ant-design/ant-design/issues/35009
    if (strokeLinecap === 'round' && percent !== 100) {
        strokeDashoffset += strokeWidth / 2;
        // when percent is small enough (<= 1%), keep smallest value to avoid it's disappearance
        if (strokeDashoffset >= perimeterWithoutGap) strokeDashoffset = perimeterWithoutGap - 0.01;
    }
    return {
        stroke: typeof strokeColor === 'string' ? strokeColor : undefined,
        strokeDasharray: "".concat(perimeterWithoutGap, "px ").concat(perimeter),
        strokeDashoffset: strokeDashoffset + stepSpace,
        transform: "rotate(".concat(rotateDeg + offsetDeg + positionDeg, "deg)"),
        transformOrigin: '0 0',
        transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s',
        fillOpacity: 0
    };
};
var $a9e966689f2af249$var$Circle = function Circle(props) {
    var _defaultProps$props = (0, $kNxFX.default)((0, $kNxFX.default)({}, (0, $6ee0ed96cf1a0d72$export$9c21a3269931e1e6)), props), id = _defaultProps$props.id, prefixCls = _defaultProps$props.prefixCls, steps = _defaultProps$props.steps, strokeWidth = _defaultProps$props.strokeWidth, trailWidth = _defaultProps$props.trailWidth, _defaultProps$props$g = _defaultProps$props.gapDegree, gapDegree = _defaultProps$props$g === void 0 ? 0 : _defaultProps$props$g, gapPosition = _defaultProps$props.gapPosition, trailColor = _defaultProps$props.trailColor, strokeLinecap = _defaultProps$props.strokeLinecap, style = _defaultProps$props.style, className = _defaultProps$props.className, strokeColor = _defaultProps$props.strokeColor, percent = _defaultProps$props.percent, restProps = (0, $04RxA.default)(_defaultProps$props, $a9e966689f2af249$var$_excluded);
    var mergedId = (0, $6d2c04a39eedc82b$export$2e2bcd8739ae039)(id);
    var gradientId = "".concat(mergedId, "-gradient");
    var radius = $a9e966689f2af249$var$VIEW_BOX_SIZE / 2 - strokeWidth / 2;
    var perimeter = Math.PI * 2 * radius;
    var rotateDeg = gapDegree > 0 ? 90 + gapDegree / 2 : -90;
    var perimeterWithoutGap = perimeter * ((360 - gapDegree) / 360);
    var _ref = (0, $5KhTJ.default)(steps) === 'object' ? steps : {
        count: steps,
        space: 2
    }, stepCount = _ref.count, stepSpace = _ref.space;
    var circleStyle = $a9e966689f2af249$var$getCircleStyle(perimeter, perimeterWithoutGap, 0, 100, rotateDeg, gapDegree, gapPosition, trailColor, strokeLinecap, strokeWidth);
    var percentList = $a9e966689f2af249$var$toArray(percent);
    var strokeColorList = $a9e966689f2af249$var$toArray(strokeColor);
    var gradient = strokeColorList.find(function(color) {
        return color && (0, $5KhTJ.default)(color) === 'object';
    });
    var paths = (0, $6ee0ed96cf1a0d72$export$7685006d504ecf0b)();
    var getStokeList = function getStokeList() {
        var stackPtg = 0;
        return percentList.map(function(ptg, index) {
            var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
            var stroke = color && (0, $5KhTJ.default)(color) === 'object' ? "url(#".concat(gradientId, ")") : undefined;
            var circleStyleForStack = $a9e966689f2af249$var$getCircleStyle(perimeter, perimeterWithoutGap, stackPtg, ptg, rotateDeg, gapDegree, gapPosition, color, strokeLinecap, strokeWidth);
            stackPtg += ptg;
            return /*#__PURE__*/ $6fFrj.createElement("circle", {
                key: index,
                className: "".concat(prefixCls, "-circle-path"),
                r: radius,
                cx: 0,
                cy: 0,
                stroke: stroke,
                strokeLinecap: strokeLinecap,
                strokeWidth: strokeWidth,
                opacity: ptg === 0 ? 0 : 1,
                style: circleStyleForStack,
                ref: function ref(elem) {
                    // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
                    // React will call the ref callback with the DOM element when the component mounts,
                    // and call it with `null` when it unmounts.
                    // Refs are guaranteed to be up-to-date before componentDidMount or componentDidUpdate fires.
                    paths[index] = elem;
                }
            });
        }).reverse();
    };
    var getStepStokeList = function getStepStokeList() {
        // only show the first percent when pass steps
        var current = Math.round(stepCount * (percentList[0] / 100));
        var stepPtg = 100 / stepCount;
        var stackPtg = 0;
        return new Array(stepCount).fill(null).map(function(_, index) {
            var color = index <= current - 1 ? strokeColorList[0] : trailColor;
            var stroke = color && (0, $5KhTJ.default)(color) === 'object' ? "url(#".concat(gradientId, ")") : undefined;
            var circleStyleForStack = $a9e966689f2af249$var$getCircleStyle(perimeter, perimeterWithoutGap, stackPtg, stepPtg, rotateDeg, gapDegree, gapPosition, color, 'butt', strokeWidth, stepSpace);
            stackPtg += (perimeterWithoutGap - circleStyleForStack.strokeDashoffset + stepSpace) * 100 / perimeterWithoutGap;
            return /*#__PURE__*/ $6fFrj.createElement("circle", {
                key: index,
                className: "".concat(prefixCls, "-circle-path"),
                r: radius,
                cx: 0,
                cy: 0,
                stroke: stroke,
                strokeWidth: strokeWidth,
                opacity: 1,
                style: circleStyleForStack,
                ref: function ref(elem) {
                    paths[index] = elem;
                }
            });
        });
    };
    return /*#__PURE__*/ $6fFrj.createElement("svg", (0, $fIrcP.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-circle"), className),
        viewBox: "".concat(-$a9e966689f2af249$var$VIEW_BOX_SIZE / 2, " ").concat(-$a9e966689f2af249$var$VIEW_BOX_SIZE / 2, " ").concat($a9e966689f2af249$var$VIEW_BOX_SIZE, " ").concat($a9e966689f2af249$var$VIEW_BOX_SIZE),
        style: style,
        id: id,
        role: "presentation"
    }, restProps), gradient && /*#__PURE__*/ $6fFrj.createElement("defs", null, /*#__PURE__*/ $6fFrj.createElement("linearGradient", {
        id: gradientId,
        x1: "100%",
        y1: "0%",
        x2: "0%",
        y2: "0%"
    }, Object.keys(gradient).sort(function(a, b) {
        return $a9e966689f2af249$var$stripPercentToNumber(a) - $a9e966689f2af249$var$stripPercentToNumber(b);
    }).map(function(key, index) {
        return /*#__PURE__*/ $6fFrj.createElement("stop", {
            key: index,
            offset: key,
            stopColor: gradient[key]
        });
    }))), !stepCount && /*#__PURE__*/ $6fFrj.createElement("circle", {
        className: "".concat(prefixCls, "-circle-trail"),
        r: radius,
        cx: 0,
        cy: 0,
        stroke: trailColor,
        strokeLinecap: strokeLinecap,
        strokeWidth: trailWidth || strokeWidth,
        style: circleStyle
    }), stepCount ? getStepStokeList() : getStokeList());
};
var $a9e966689f2af249$export$2e2bcd8739ae039 = $a9e966689f2af249$var$Circle;


var $e102ae7b80762e0e$export$2e2bcd8739ae039 = {
    Line: (0, $7210b3b1eaf3ad01$export$2e2bcd8739ae039),
    Circle: (0, $a9e966689f2af249$export$2e2bcd8739ae039)
};



var $6fFrj = parcelRequire("6fFrj");

function $210729f122b42d90$export$2caef35201f951a0(progress) {
    if (!progress || progress < 0) return 0;
    if (progress > 100) return 100;
    return progress;
}
function $210729f122b42d90$export$4ab1c09ce4ee99b(_ref) {
    var success = _ref.success, successPercent = _ref.successPercent;
    var percent = successPercent;
    /** @deprecated Use `percent` instead */ if (success && 'progress' in success) percent = success.progress;
    if (success && 'percent' in success) percent = success.percent;
    return percent;
}


function $174d810a2a1a9565$var$getPercentage(_ref) {
    var percent = _ref.percent, success = _ref.success, successPercent = _ref.successPercent;
    var realSuccessPercent = (0, $210729f122b42d90$export$2caef35201f951a0)((0, $210729f122b42d90$export$4ab1c09ce4ee99b)({
        success: success,
        successPercent: successPercent
    }));
    return [
        realSuccessPercent,
        (0, $210729f122b42d90$export$2caef35201f951a0)((0, $210729f122b42d90$export$2caef35201f951a0)(percent) - realSuccessPercent)
    ];
}
function $174d810a2a1a9565$var$getStrokeColor(_ref2) {
    var _ref2$success = _ref2.success, success = _ref2$success === void 0 ? {} : _ref2$success, strokeColor = _ref2.strokeColor;
    var successColor = success.strokeColor;
    return [
        successColor || (0, $f98afff48ee41fa5$export$3968a3afc810b5f5).green,
        strokeColor || null
    ];
}
var $174d810a2a1a9565$var$Circle = function Circle(props) {
    var prefixCls = props.prefixCls, width = props.width, strokeWidth = props.strokeWidth, _props$trailColor = props.trailColor, trailColor = _props$trailColor === void 0 ? null : _props$trailColor, _props$strokeLinecap = props.strokeLinecap, strokeLinecap = _props$strokeLinecap === void 0 ? 'round' : _props$strokeLinecap, gapPosition = props.gapPosition, gapDegree = props.gapDegree, type = props.type, children = props.children, success = props.success;
    var circleSize = width || 120;
    var circleStyle = {
        width: circleSize,
        height: circleSize,
        fontSize: circleSize * 0.15 + 6
    };
    var circleWidth = strokeWidth || 6;
    var gapPos = gapPosition || type === 'dashboard' && 'bottom' || undefined;
    var getGapDegree = function getGapDegree() {
        // Support gapDeg = 0 when type = 'dashboard'
        if (gapDegree || gapDegree === 0) return gapDegree;
        if (type === 'dashboard') return 75;
        return undefined;
    };
    // using className to style stroke color
    var isGradient = Object.prototype.toString.call(props.strokeColor) === '[object Object]';
    var strokeColor = $174d810a2a1a9565$var$getStrokeColor({
        success: success,
        strokeColor: props.strokeColor
    });
    var wrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-inner"), (0, $43449.default)({}, "".concat(prefixCls, "-circle-gradient"), isGradient));
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: wrapperClassName,
        style: circleStyle
    }, /*#__PURE__*/ $6fFrj.createElement((0, $a9e966689f2af249$export$2e2bcd8739ae039), {
        percent: $174d810a2a1a9565$var$getPercentage(props),
        strokeWidth: circleWidth,
        trailWidth: circleWidth,
        strokeColor: strokeColor,
        strokeLinecap: strokeLinecap,
        trailColor: trailColor,
        prefixCls: prefixCls,
        gapDegree: getGapDegree(),
        gapPosition: gapPos
    }), children);
};
var $174d810a2a1a9565$export$2e2bcd8739ae039 = $174d810a2a1a9565$var$Circle;



var $fIrcP = parcelRequire("fIrcP");


var $6fFrj = parcelRequire("6fFrj");

var $9a26dedd38134b79$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9a26dedd38134b79$export$8947b167cf78cbe = function sortGradient(gradients) {
    var tempArr = [];
    Object.keys(gradients).forEach(function(key) {
        var formattedKey = parseFloat(key.replace(/%/g, ''));
        if (!isNaN(formattedKey)) tempArr.push({
            key: formattedKey,
            value: gradients[key]
        });
    });
    tempArr = tempArr.sort(function(a, b) {
        return a.key - b.key;
    });
    return tempArr.map(function(_ref) {
        var key = _ref.key, value = _ref.value;
        return "".concat(value, " ").concat(key, "%");
    }).join(', ');
};
var $9a26dedd38134b79$export$22b6122229807a9f = function handleGradient(strokeColor, directionConfig) {
    var _strokeColor$from = strokeColor.from, from = _strokeColor$from === void 0 ? (0, $f98afff48ee41fa5$export$3968a3afc810b5f5).blue : _strokeColor$from, _strokeColor$to = strokeColor.to, to = _strokeColor$to === void 0 ? (0, $f98afff48ee41fa5$export$3968a3afc810b5f5).blue : _strokeColor$to, _strokeColor$directio = strokeColor.direction, direction = _strokeColor$directio === void 0 ? directionConfig === 'rtl' ? 'to left' : 'to right' : _strokeColor$directio, rest = $9a26dedd38134b79$var$__rest(strokeColor, [
        "from",
        "to",
        "direction"
    ]);
    if (Object.keys(rest).length !== 0) {
        var sortedGradients = $9a26dedd38134b79$export$8947b167cf78cbe(rest);
        return {
            backgroundImage: "linear-gradient(".concat(direction, ", ").concat(sortedGradients, ")")
        };
    }
    return {
        backgroundImage: "linear-gradient(".concat(direction, ", ").concat(from, ", ").concat(to, ")")
    };
};
var $9a26dedd38134b79$var$Line = function Line(props) {
    var prefixCls = props.prefixCls, directionConfig = props.direction, percent = props.percent, strokeWidth = props.strokeWidth, size = props.size, strokeColor = props.strokeColor, _props$strokeLinecap = props.strokeLinecap, strokeLinecap = _props$strokeLinecap === void 0 ? 'round' : _props$strokeLinecap, children = props.children, _props$trailColor = props.trailColor, trailColor = _props$trailColor === void 0 ? null : _props$trailColor, success = props.success;
    var backgroundProps = strokeColor && typeof strokeColor !== 'string' ? $9a26dedd38134b79$export$22b6122229807a9f(strokeColor, directionConfig) : {
        background: strokeColor
    };
    var borderRadius = strokeLinecap === 'square' || strokeLinecap === 'butt' ? 0 : undefined;
    var trailStyle = {
        backgroundColor: trailColor || undefined,
        borderRadius: borderRadius
    };
    var percentStyle = (0, $fIrcP.default)({
        width: "".concat((0, $210729f122b42d90$export$2caef35201f951a0)(percent), "%"),
        height: strokeWidth || (size === 'small' ? 6 : 8),
        borderRadius: borderRadius
    }, backgroundProps);
    var successPercent = (0, $210729f122b42d90$export$4ab1c09ce4ee99b)(props);
    var successPercentStyle = {
        width: "".concat((0, $210729f122b42d90$export$2caef35201f951a0)(successPercent), "%"),
        height: strokeWidth || (size === 'small' ? 6 : 8),
        borderRadius: borderRadius,
        backgroundColor: success === null || success === void 0 ? void 0 : success.strokeColor
    };
    var successSegment = successPercent !== undefined ? /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-success-bg"),
        style: successPercentStyle
    }) : null;
    return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-outer")
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-inner"),
        style: trailStyle
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-bg"),
        style: percentStyle
    }), successSegment)), children);
};
var $9a26dedd38134b79$export$2e2bcd8739ae039 = $9a26dedd38134b79$var$Line;



var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");
var $74801f810fbad8b4$var$Steps = function Steps(props) {
    var size = props.size, steps = props.steps, _props$percent = props.percent, percent = _props$percent === void 0 ? 0 : _props$percent, _props$strokeWidth = props.strokeWidth, strokeWidth = _props$strokeWidth === void 0 ? 8 : _props$strokeWidth, strokeColor = props.strokeColor, _props$trailColor = props.trailColor, trailColor = _props$trailColor === void 0 ? null : _props$trailColor, prefixCls = props.prefixCls, children = props.children;
    var current = Math.round(steps * (percent / 100));
    var stepWidth = size === 'small' ? 2 : 14;
    var styledSteps = new Array(steps);
    for(var i = 0; i < steps; i++){
        var color = Array.isArray(strokeColor) ? strokeColor[i] : strokeColor;
        styledSteps[i] = /*#__PURE__*/ $6fFrj.createElement("div", {
            key: i,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-steps-item"), (0, $43449.default)({}, "".concat(prefixCls, "-steps-item-active"), i <= current - 1)),
            style: {
                backgroundColor: i <= current - 1 ? color : trailColor,
                width: stepWidth,
                height: strokeWidth
            }
        });
    }
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-steps-outer")
    }, styledSteps, children);
};
var $74801f810fbad8b4$export$2e2bcd8739ae039 = $74801f810fbad8b4$var$Steps;



var $aa0a078ed043cd53$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $aa0a078ed043cd53$var$ProgressTypes = (0, $cacd97b96801cebe$export$65e3907585753458)('line', 'circle', 'dashboard');
var $aa0a078ed043cd53$var$ProgressStatuses = (0, $cacd97b96801cebe$export$65e3907585753458)('normal', 'exception', 'active', 'success');
var $aa0a078ed043cd53$var$Progress = function Progress(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, steps = props.steps, strokeColor = props.strokeColor, _props$percent = props.percent, percent = _props$percent === void 0 ? 0 : _props$percent, _props$size = props.size, size = _props$size === void 0 ? 'default' : _props$size, _props$showInfo = props.showInfo, showInfo = _props$showInfo === void 0 ? true : _props$showInfo, _props$type = props.type, type = _props$type === void 0 ? 'line' : _props$type, restProps = $aa0a078ed043cd53$var$__rest(props, [
        "prefixCls",
        "className",
        "steps",
        "strokeColor",
        "percent",
        "size",
        "showInfo",
        "type"
    ]);
    function getPercentNumber() {
        var successPercent = (0, $210729f122b42d90$export$4ab1c09ce4ee99b)(props);
        return parseInt(successPercent !== undefined ? successPercent.toString() : percent.toString(), 10);
    }
    function getProgressStatus() {
        var status = props.status;
        if (!$aa0a078ed043cd53$var$ProgressStatuses.includes(status) && getPercentNumber() >= 100) return 'success';
        return status || 'normal';
    }
    function renderProcessInfo(prefixCls, progressStatus) {
        var format = props.format;
        var successPercent = (0, $210729f122b42d90$export$4ab1c09ce4ee99b)(props);
        if (!showInfo) return null;
        var text;
        var textFormatter = format || function(percentNumber) {
            return "".concat(percentNumber, "%");
        };
        var isLineType = type === 'line';
        if (format || progressStatus !== 'exception' && progressStatus !== 'success') text = textFormatter((0, $210729f122b42d90$export$2caef35201f951a0)(percent), (0, $210729f122b42d90$export$2caef35201f951a0)(successPercent));
        else if (progressStatus === 'exception') text = isLineType ? /*#__PURE__*/ $6fFrj.createElement((0, $9429a61ddf5bc264$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $6fFrj.createElement((0, $4cb3f1f073816266$export$2e2bcd8739ae039), null);
        else if (progressStatus === 'success') text = isLineType ? /*#__PURE__*/ $6fFrj.createElement((0, $a539793a765f8968$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $6fFrj.createElement((0, $97e498ed1184adf1$export$2e2bcd8739ae039), null);
        return /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-text"),
            title: typeof text === 'string' ? text : undefined
        }, text);
    }
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var prefixCls = getPrefixCls('progress', customizePrefixCls);
    var progressStatus = getProgressStatus();
    var progressInfo = renderProcessInfo(prefixCls, progressStatus);
    var strokeColorNotArray = Array.isArray(strokeColor) ? strokeColor[0] : strokeColor;
    var strokeColorNotGradient = typeof strokeColor === 'string' || Array.isArray(strokeColor) ? strokeColor : undefined;
    var progress;
    // Render progress shape
    if (type === 'line') progress = steps ? /*#__PURE__*/ $6fFrj.createElement((0, $74801f810fbad8b4$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        strokeColor: strokeColorNotGradient,
        prefixCls: prefixCls,
        steps: steps
    }), progressInfo) : /*#__PURE__*/ $6fFrj.createElement((0, $9a26dedd38134b79$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        strokeColor: strokeColorNotArray,
        prefixCls: prefixCls,
        direction: direction
    }), progressInfo);
    else if (type === 'circle' || type === 'dashboard') progress = /*#__PURE__*/ $6fFrj.createElement((0, $174d810a2a1a9565$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        strokeColor: strokeColorNotArray,
        prefixCls: prefixCls,
        progressStatus: progressStatus
    }), progressInfo);
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-").concat(type === 'dashboard' && 'circle' || steps && 'steps' || type), true), "".concat(prefixCls, "-status-").concat(progressStatus), true), "".concat(prefixCls, "-show-info"), showInfo), "".concat(prefixCls, "-").concat(size), size), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({}, (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(restProps, [
        'status',
        'format',
        'trailColor',
        'strokeWidth',
        'width',
        'gapDegree',
        'gapPosition',
        'strokeLinecap',
        'success',
        'successPercent'
    ]), {
        className: classString,
        role: "progressbar"
    }), progress);
};
var $aa0a078ed043cd53$export$2e2bcd8739ae039 = $aa0a078ed043cd53$var$Progress;


var $35ec803a48e00dda$export$2e2bcd8739ae039 = (0, $aa0a078ed043cd53$export$2e2bcd8739ae039);


var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $fActo = parcelRequire("fActo");

var $gfhff = parcelRequire("gfhff");

var $6fFrj = parcelRequire("6fFrj");




var $6fFrj = parcelRequire("6fFrj");
var $cd70798b07bb5531$var$RadioGroupContext = /*#__PURE__*/ $6fFrj.createContext(null);
var $cd70798b07bb5531$export$67d4730aee04efd2 = $cd70798b07bb5531$var$RadioGroupContext.Provider;
var $cd70798b07bb5531$export$2e2bcd8739ae039 = $cd70798b07bb5531$var$RadioGroupContext;
var $cd70798b07bb5531$export$4fbd9581b41e971f = /*#__PURE__*/ $6fFrj.createContext(null);
var $cd70798b07bb5531$export$1b5d1f64a577990e = $cd70798b07bb5531$export$4fbd9581b41e971f.Provider;



var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $fActo = parcelRequire("fActo");


var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");





var $e7f729d101130db8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e7f729d101130db8$var$InternalRadio = function InternalRadio(props, ref) {
    var _a, _b;
    var groupContext = $6fFrj.useContext((0, $cd70798b07bb5531$export$2e2bcd8739ae039));
    var radioOptionTypeContext = $6fFrj.useContext((0, $cd70798b07bb5531$export$4fbd9581b41e971f));
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var innerRef = $6fFrj.useRef();
    var mergedRef = (0, $3BOWT.composeRef)(ref, innerRef);
    var _useContext = (0, $6fFrj.useContext)((0, $76d69cb8326089c6$export$bbb5553c6c7a14ed)), isFormItemInput = _useContext.isFormItemInput;
    var onChange = function onChange(e) {
        var _a, _b;
        (_a = props.onChange) === null || _a === void 0 || _a.call(props, e);
        (_b = groupContext === null || groupContext === void 0 ? void 0 : groupContext.onChange) === null || _b === void 0 || _b.call(groupContext, e);
    };
    var customizePrefixCls = props.prefixCls, className = props.className, children = props.children, style = props.style, restProps = $e7f729d101130db8$var$__rest(props, [
        "prefixCls",
        "className",
        "children",
        "style"
    ]);
    var radioPrefixCls = getPrefixCls('radio', customizePrefixCls);
    var prefixCls = ((groupContext === null || groupContext === void 0 ? void 0 : groupContext.optionType) || radioOptionTypeContext) === 'button' ? "".concat(radioPrefixCls, "-button") : radioPrefixCls;
    var radioProps = (0, $fIrcP.default)({}, restProps);
    // ===================== Disabled =====================
    var disabled = $6fFrj.useContext((0, $3880af76d17f94a3$export$2e2bcd8739ae039));
    if (groupContext) {
        radioProps.name = groupContext.name;
        radioProps.onChange = onChange;
        radioProps.checked = props.value === groupContext.value;
        radioProps.disabled = (_a = radioProps.disabled) !== null && _a !== void 0 ? _a : groupContext.disabled;
    }
    radioProps.disabled = (_b = radioProps.disabled) !== null && _b !== void 0 ? _b : disabled;
    var wrapperClassString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-wrapper"), (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), "".concat(prefixCls, "-wrapper-rtl"), direction === 'rtl'), "".concat(prefixCls, "-wrapper-in-form-item"), isFormItemInput), className);
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-associated-control
    $6fFrj.createElement("label", {
        className: wrapperClassString,
        style: style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave
    }, /*#__PURE__*/ $6fFrj.createElement((0, $17f8617e16f6bea2$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, radioProps, {
        type: "radio",
        prefixCls: prefixCls,
        ref: mergedRef
    })), children !== undefined ? /*#__PURE__*/ $6fFrj.createElement("span", null, children) : null));
};
var $e7f729d101130db8$var$Radio = /*#__PURE__*/ $6fFrj.forwardRef($e7f729d101130db8$var$InternalRadio);
var $e7f729d101130db8$export$2e2bcd8739ae039 = $e7f729d101130db8$var$Radio;


var $11b9bb0d84bfb24f$var$RadioGroup = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var size = $6fFrj.useContext((0, $aefad26b74860b7e$export$2e2bcd8739ae039));
    var _useMergedState = (0, $gfhff.default)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var onRadioChange = function onRadioChange(ev) {
        var lastValue = value;
        var val = ev.target.value;
        if (!('value' in props)) setValue(val);
        var onChange = props.onChange;
        if (onChange && val !== lastValue) onChange(ev);
    };
    var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, options = props.options, _props$buttonStyle = props.buttonStyle, buttonStyle = _props$buttonStyle === void 0 ? 'outline' : _props$buttonStyle, disabled = props.disabled, children = props.children, customizeSize = props.size, style = props.style, id = props.id, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onFocus = props.onFocus, onBlur = props.onBlur;
    var prefixCls = getPrefixCls('radio', customizePrefixCls);
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var childrenToRender = children;
    // 如果存在 options, 优先使用
    if (options && options.length > 0) childrenToRender = options.map(function(option) {
        if (typeof option === 'string' || typeof option === 'number') // 此处类型自动推导为 string
        return /*#__PURE__*/ $6fFrj.createElement((0, $e7f729d101130db8$export$2e2bcd8739ae039), {
            key: option.toString(),
            prefixCls: prefixCls,
            disabled: disabled,
            value: option,
            checked: value === option
        }, option);
        // 此处类型自动推导为 { label: string value: string }
        return /*#__PURE__*/ $6fFrj.createElement((0, $e7f729d101130db8$export$2e2bcd8739ae039), {
            key: "radio-group-value-options-".concat(option.value),
            prefixCls: prefixCls,
            disabled: option.disabled || disabled,
            value: option.value,
            checked: value === option.value,
            style: option.style
        }, option.label);
    });
    var mergedSize = customizeSize || size;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), (0, $43449.default)((0, $43449.default)({}, "".concat(groupPrefixCls, "-").concat(mergedSize), mergedSize), "".concat(groupPrefixCls, "-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({}, (0, $2341cdaa45fe261f$export$2e2bcd8739ae039)(props), {
        className: classString,
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        id: id,
        ref: ref
    }), /*#__PURE__*/ $6fFrj.createElement((0, $cd70798b07bb5531$export$67d4730aee04efd2), {
        value: {
            onChange: onRadioChange,
            value: value,
            disabled: props.disabled,
            name: props.name,
            optionType: props.optionType
        }
    }, childrenToRender));
});
var $11b9bb0d84bfb24f$export$2e2bcd8739ae039 = /*#__PURE__*/ $6fFrj.memo($11b9bb0d84bfb24f$var$RadioGroup);




var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");



var $973a738408942954$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $973a738408942954$var$RadioButton = function RadioButton(props, ref) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var customizePrefixCls = props.prefixCls, radioProps = $973a738408942954$var$__rest(props, [
        "prefixCls"
    ]);
    var prefixCls = getPrefixCls('radio', customizePrefixCls);
    return /*#__PURE__*/ $6fFrj.createElement((0, $cd70798b07bb5531$export$1b5d1f64a577990e), {
        value: "button"
    }, /*#__PURE__*/ $6fFrj.createElement((0, $e7f729d101130db8$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        prefixCls: prefixCls
    }, radioProps, {
        type: "radio",
        ref: ref
    })));
};
var $973a738408942954$export$2e2bcd8739ae039 = /*#__PURE__*/ $6fFrj.forwardRef($973a738408942954$var$RadioButton);


var $d2c10fe172769914$var$Radio = (0, $e7f729d101130db8$export$2e2bcd8739ae039);
$d2c10fe172769914$var$Radio.Button = (0, $973a738408942954$export$2e2bcd8739ae039);
$d2c10fe172769914$var$Radio.Group = (0, $11b9bb0d84bfb24f$export$2e2bcd8739ae039);
$d2c10fe172769914$var$Radio.__ANT_RADIO = true;
var $d2c10fe172769914$export$2e2bcd8739ae039 = $d2c10fe172769914$var$Radio;


var $66a23e9427b53328$export$2e2bcd8739ae039 = (0, $4a8085e587664aad$export$2e2bcd8739ae039);


var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $5KhTJ = parcelRequire("5KhTJ");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");


var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");


var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");
var $d42423cf7c452496$var$Element = function Element(props) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, size = props.size, shape = props.shape;
    var sizeCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-lg"), size === 'large'), "".concat(prefixCls, "-sm"), size === 'small'));
    var shapeCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-circle"), shape === 'circle'), "".concat(prefixCls, "-square"), shape === 'square'), "".concat(prefixCls, "-round"), shape === 'round'));
    var sizeStyle = $6fFrj.useMemo(function() {
        return typeof size === 'number' ? {
            width: size,
            height: size,
            lineHeight: "".concat(size, "px")
        } : {};
    }, [
        size
    ]);
    return /*#__PURE__*/ $6fFrj.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, sizeCls, shapeCls, className),
        style: (0, $fIrcP.default)((0, $fIrcP.default)({}, sizeStyle), style)
    });
};
var $d42423cf7c452496$export$2e2bcd8739ae039 = $d42423cf7c452496$var$Element;


var $078cffabbebdc24a$var$SkeletonAvatar = function SkeletonAvatar(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, active = props.active, _props$shape = props.shape, shape = _props$shape === void 0 ? 'circle' : _props$shape, _props$size = props.size, size = _props$size === void 0 ? 'default' : _props$size;
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var otherProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(props, [
        'prefixCls',
        'className'
    ]);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-element"), (0, $43449.default)({}, "".concat(prefixCls, "-active"), active), className);
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $6fFrj.createElement((0, $d42423cf7c452496$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        prefixCls: "".concat(prefixCls, "-avatar"),
        shape: shape,
        size: size
    }, otherProps)));
};
var $078cffabbebdc24a$export$2e2bcd8739ae039 = $078cffabbebdc24a$var$SkeletonAvatar;



var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");


var $186c0f284600fb04$var$SkeletonButton = function SkeletonButton(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, active = props.active, _props$block = props.block, block = _props$block === void 0 ? false : _props$block, _props$size = props.size, size = _props$size === void 0 ? 'default' : _props$size;
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var otherProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(props, [
        'prefixCls'
    ]);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-element"), (0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-active"), active), "".concat(prefixCls, "-block"), block), className);
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $6fFrj.createElement((0, $d42423cf7c452496$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        prefixCls: "".concat(prefixCls, "-button"),
        size: size
    }, otherProps)));
};
var $186c0f284600fb04$export$2e2bcd8739ae039 = $186c0f284600fb04$var$SkeletonButton;



var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $ddbc5eae23c0813b$var$DotChartOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 10128 0 64 64 0 10-128 0zm118-224a48 48 0 1096 0 48 48 0 10-96 0zm158 228a96 96 0 10192 0 96 96 0 10-192 0zm148-314a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "dot-chart",
    "theme": "outlined"
};
var $ddbc5eae23c0813b$export$2e2bcd8739ae039 = $ddbc5eae23c0813b$var$DotChartOutlined;



var $1012f4ce838c106b$var$DotChartOutlined = function DotChartOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $ddbc5eae23c0813b$export$2e2bcd8739ae039)
    }));
};
var $1012f4ce838c106b$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($1012f4ce838c106b$var$DotChartOutlined);
var $1012f4ce838c106b$export$2e2bcd8739ae039 = $1012f4ce838c106b$var$RefIcon;



var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");

var $13449c92aad77e67$var$SkeletonNode = function SkeletonNode(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, style = props.style, active = props.active, children = props.children;
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-element"), (0, $43449.default)({}, "".concat(prefixCls, "-active"), active), className);
    var content = children !== null && children !== void 0 ? children : /*#__PURE__*/ $6fFrj.createElement((0, $1012f4ce838c106b$export$2e2bcd8739ae039), null);
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-image"), className),
        style: style
    }, content));
};
var $13449c92aad77e67$export$2e2bcd8739ae039 = $13449c92aad77e67$var$SkeletonNode;




var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");

var $f59e809c6c13f5a3$var$path = 'M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z';
var $f59e809c6c13f5a3$var$SkeletonImage = function SkeletonImage(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, style = props.style, active = props.active;
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-element"), (0, $43449.default)({}, "".concat(prefixCls, "-active"), active), className);
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-image"), className),
        style: style
    }, /*#__PURE__*/ $6fFrj.createElement("svg", {
        viewBox: "0 0 1098 1024",
        xmlns: "http://www.w3.org/2000/svg",
        className: "".concat(prefixCls, "-image-svg")
    }, /*#__PURE__*/ $6fFrj.createElement("path", {
        d: $f59e809c6c13f5a3$var$path,
        className: "".concat(prefixCls, "-image-path")
    }))));
};
var $f59e809c6c13f5a3$export$2e2bcd8739ae039 = $f59e809c6c13f5a3$var$SkeletonImage;



var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");


var $8e2b52feea4fa1b6$var$SkeletonInput = function SkeletonInput(props) {
    var customizePrefixCls = props.prefixCls, className = props.className, active = props.active, block = props.block, _props$size = props.size, size = _props$size === void 0 ? 'default' : _props$size;
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var otherProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(props, [
        'prefixCls'
    ]);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-element"), (0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-active"), active), "".concat(prefixCls, "-block"), block), className);
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $6fFrj.createElement((0, $d42423cf7c452496$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        prefixCls: "".concat(prefixCls, "-input"),
        size: size
    }, otherProps)));
};
var $8e2b52feea4fa1b6$export$2e2bcd8739ae039 = $8e2b52feea4fa1b6$var$SkeletonInput;



var $37xND = parcelRequire("37xND");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");
var $13c529a625da7feb$var$Paragraph = function Paragraph(props) {
    var getWidth = function getWidth(index) {
        var width = props.width, _props$rows = props.rows, rows = _props$rows === void 0 ? 2 : _props$rows;
        if (Array.isArray(width)) return width[index];
        // last paragraph
        if (rows - 1 === index) return width;
        return undefined;
    };
    var prefixCls = props.prefixCls, className = props.className, style = props.style, rows = props.rows;
    var rowList = (0, $37xND.default)(Array(rows)).map(function(_, index) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $6fFrj.createElement("li", {
            key: index,
            style: {
                width: getWidth(index)
            }
        }));
    });
    return /*#__PURE__*/ $6fFrj.createElement("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className),
        style: style
    }, rowList);
};
var $13c529a625da7feb$export$2e2bcd8739ae039 = $13c529a625da7feb$var$Paragraph;



var $fIrcP = parcelRequire("fIrcP");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");
var $b5b7dc93731dc710$var$Title = function Title(_ref) {
    var prefixCls = _ref.prefixCls, className = _ref.className, width = _ref.width, style = _ref.style;
    return /*#__PURE__*/ $6fFrj.createElement("h3", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className),
        style: (0, $fIrcP.default)({
            width: width
        }, style)
    });
};
var $b5b7dc93731dc710$export$2e2bcd8739ae039 = $b5b7dc93731dc710$var$Title;


function $4047ae2a30b36e1c$var$getComponentProps(prop) {
    if (prop && (0, $5KhTJ.default)(prop) === 'object') return prop;
    return {};
}
function $4047ae2a30b36e1c$var$getAvatarBasicProps(hasTitle, hasParagraph) {
    if (hasTitle && !hasParagraph) // Square avatar
    return {
        size: 'large',
        shape: 'square'
    };
    return {
        size: 'large',
        shape: 'circle'
    };
}
function $4047ae2a30b36e1c$var$getTitleBasicProps(hasAvatar, hasParagraph) {
    if (!hasAvatar && hasParagraph) return {
        width: '38%'
    };
    if (hasAvatar && hasParagraph) return {
        width: '50%'
    };
    return {};
}
function $4047ae2a30b36e1c$var$getParagraphBasicProps(hasAvatar, hasTitle) {
    var basicProps = {};
    // Width
    if (!hasAvatar || !hasTitle) basicProps.width = '61%';
    // Rows
    if (!hasAvatar && hasTitle) basicProps.rows = 3;
    else basicProps.rows = 2;
    return basicProps;
}
var $4047ae2a30b36e1c$var$Skeleton = function Skeleton(props) {
    var customizePrefixCls = props.prefixCls, loading = props.loading, className = props.className, style = props.style, children = props.children, _props$avatar = props.avatar, avatar = _props$avatar === void 0 ? false : _props$avatar, _props$title = props.title, title = _props$title === void 0 ? true : _props$title, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? true : _props$paragraph, active = props.active, round = props.round;
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    if (loading || !('loading' in props)) {
        var hasAvatar = !!avatar;
        var hasTitle = !!title;
        var hasParagraph = !!paragraph;
        // Avatar
        var avatarNode;
        if (hasAvatar) {
            var avatarProps = (0, $fIrcP.default)((0, $fIrcP.default)({
                prefixCls: "".concat(prefixCls, "-avatar")
            }, $4047ae2a30b36e1c$var$getAvatarBasicProps(hasTitle, hasParagraph)), $4047ae2a30b36e1c$var$getComponentProps(avatar));
            // We direct use SkeletonElement as avatar in skeleton internal.
            avatarNode = /*#__PURE__*/ $6fFrj.createElement("div", {
                className: "".concat(prefixCls, "-header")
            }, /*#__PURE__*/ $6fFrj.createElement((0, $d42423cf7c452496$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, avatarProps)));
        }
        var contentNode;
        if (hasTitle || hasParagraph) {
            // Title
            var $title;
            if (hasTitle) {
                var titleProps = (0, $fIrcP.default)((0, $fIrcP.default)({
                    prefixCls: "".concat(prefixCls, "-title")
                }, $4047ae2a30b36e1c$var$getTitleBasicProps(hasAvatar, hasParagraph)), $4047ae2a30b36e1c$var$getComponentProps(title));
                $title = /*#__PURE__*/ $6fFrj.createElement((0, $b5b7dc93731dc710$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, titleProps));
            }
            // Paragraph
            var paragraphNode;
            if (hasParagraph) {
                var paragraphProps = (0, $fIrcP.default)((0, $fIrcP.default)({
                    prefixCls: "".concat(prefixCls, "-paragraph")
                }, $4047ae2a30b36e1c$var$getParagraphBasicProps(hasAvatar, hasTitle)), $4047ae2a30b36e1c$var$getComponentProps(paragraph));
                paragraphNode = /*#__PURE__*/ $6fFrj.createElement((0, $13c529a625da7feb$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, paragraphProps));
            }
            contentNode = /*#__PURE__*/ $6fFrj.createElement("div", {
                className: "".concat(prefixCls, "-content")
            }, $title, paragraphNode);
        }
        var cls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-with-avatar"), hasAvatar), "".concat(prefixCls, "-active"), active), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-round"), round), className);
        return /*#__PURE__*/ $6fFrj.createElement("div", {
            className: cls,
            style: style
        }, avatarNode, contentNode);
    }
    return typeof children !== 'undefined' ? children : null;
};
$4047ae2a30b36e1c$var$Skeleton.Button = (0, $186c0f284600fb04$export$2e2bcd8739ae039);
$4047ae2a30b36e1c$var$Skeleton.Avatar = (0, $078cffabbebdc24a$export$2e2bcd8739ae039);
$4047ae2a30b36e1c$var$Skeleton.Input = (0, $8e2b52feea4fa1b6$export$2e2bcd8739ae039);
$4047ae2a30b36e1c$var$Skeleton.Image = (0, $f59e809c6c13f5a3$export$2e2bcd8739ae039);
$4047ae2a30b36e1c$var$Skeleton.Node = (0, $13449c92aad77e67$export$2e2bcd8739ae039);
var $4047ae2a30b36e1c$export$2e2bcd8739ae039 = $4047ae2a30b36e1c$var$Skeleton;


var $6277e5722f665338$export$2e2bcd8739ae039 = (0, $4047ae2a30b36e1c$export$2e2bcd8739ae039);


var $5KhTJ = parcelRequire("5KhTJ");

var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $fActo = parcelRequire("fActo");

var $43449 = parcelRequire("43449");

var $37xND = parcelRequire("37xND");

var $jP8CL = parcelRequire("jP8CL");

var $5KhTJ = parcelRequire("5KhTJ");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


var $gfhff = parcelRequire("gfhff");

var $fIrcP = parcelRequire("fIrcP");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $43449 = parcelRequire("43449");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");
var $f0202c0e9f64e0c1$var$SliderContext = /*#__PURE__*/ $6fFrj.createContext({
    min: 0,
    max: 0,
    direction: 'ltr',
    step: 1,
    includedStart: 0,
    includedEnd: 0,
    tabIndex: 0
});
var $f0202c0e9f64e0c1$export$2e2bcd8739ae039 = $f0202c0e9f64e0c1$var$SliderContext;


function $19da6ead1c64ce0d$export$622cea445a1c5b7d(value, min, max) {
    return (value - min) / (max - min);
}
function $19da6ead1c64ce0d$export$a41628415415e6e(direction, value, min, max) {
    var offset = $19da6ead1c64ce0d$export$622cea445a1c5b7d(value, min, max);
    var positionStyle = {};
    switch(direction){
        case 'rtl':
            positionStyle.right = "".concat(offset * 100, "%");
            positionStyle.transform = 'translateX(50%)';
            break;
        case 'btt':
            positionStyle.bottom = "".concat(offset * 100, "%");
            positionStyle.transform = 'translateY(50%)';
            break;
        case 'ttb':
            positionStyle.top = "".concat(offset * 100, "%");
            positionStyle.transform = 'translateY(-50%)';
            break;
        default:
            positionStyle.left = "".concat(offset * 100, "%");
            positionStyle.transform = 'translateX(-50%)';
            break;
    }
    return positionStyle;
}
function $19da6ead1c64ce0d$export$ddfa24987dade61b(value, index) {
    return Array.isArray(value) ? value[index] : value;
}


var $0693faea4a4f0dfb$var$_excluded = [
    "prefixCls",
    "value",
    "valueIndex",
    "onStartMove",
    "style",
    "render",
    "dragging",
    "onOffsetChange"
];
var $0693faea4a4f0dfb$var$Handle = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _classNames, _getIndex;
    var prefixCls = props.prefixCls, value = props.value, valueIndex = props.valueIndex, onStartMove = props.onStartMove, style = props.style, render = props.render, dragging = props.dragging, onOffsetChange = props.onOffsetChange, restProps = (0, $04RxA.default)(props, $0693faea4a4f0dfb$var$_excluded);
    var _React$useContext = $6fFrj.useContext((0, $f0202c0e9f64e0c1$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, disabled = _React$useContext.disabled, range = _React$useContext.range, tabIndex = _React$useContext.tabIndex, ariaLabelForHandle = _React$useContext.ariaLabelForHandle, ariaLabelledByForHandle = _React$useContext.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = _React$useContext.ariaValueTextFormatterForHandle;
    var handlePrefixCls = "".concat(prefixCls, "-handle"); // ============================ Events ============================
    var onInternalStartMove = function onInternalStartMove(e) {
        if (!disabled) onStartMove(e, valueIndex);
    }; // =========================== Keyboard ===========================
    var onKeyDown = function onKeyDown(e) {
        if (!disabled) {
            var offset = null; // Change the value
            switch(e.which || e.keyCode){
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).LEFT:
                    offset = direction === 'ltr' || direction === 'btt' ? -1 : 1;
                    break;
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).RIGHT:
                    offset = direction === 'ltr' || direction === 'btt' ? 1 : -1;
                    break;
                // Up is plus
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).UP:
                    offset = direction !== 'ttb' ? 1 : -1;
                    break;
                // Down is minus
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).DOWN:
                    offset = direction !== 'ttb' ? -1 : 1;
                    break;
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).HOME:
                    offset = 'min';
                    break;
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).END:
                    offset = 'max';
                    break;
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).PAGE_UP:
                    offset = 2;
                    break;
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).PAGE_DOWN:
                    offset = -2;
                    break;
            }
            if (offset !== null) {
                e.preventDefault();
                onOffsetChange(offset, valueIndex);
            }
        }
    }; // ============================ Offset ============================
    var positionStyle = (0, $19da6ead1c64ce0d$export$a41628415415e6e)(direction, value, min, max); // ============================ Render ============================
    var handleNode = /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(handlePrefixCls, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(handlePrefixCls, "-").concat(valueIndex + 1), range), (0, $43449.default)(_classNames, "".concat(handlePrefixCls, "-dragging"), dragging), _classNames)),
        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, positionStyle), style),
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove,
        onKeyDown: onKeyDown,
        tabIndex: disabled ? null : (0, $19da6ead1c64ce0d$export$ddfa24987dade61b)(tabIndex, valueIndex),
        role: "slider",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value,
        "aria-disabled": disabled,
        "aria-label": (0, $19da6ead1c64ce0d$export$ddfa24987dade61b)(ariaLabelForHandle, valueIndex),
        "aria-labelledby": (0, $19da6ead1c64ce0d$export$ddfa24987dade61b)(ariaLabelledByForHandle, valueIndex),
        "aria-valuetext": (_getIndex = (0, $19da6ead1c64ce0d$export$ddfa24987dade61b)(ariaValueTextFormatterForHandle, valueIndex)) === null || _getIndex === void 0 ? void 0 : _getIndex(value)
    }, restProps)); // Customize
    if (render) handleNode = render(handleNode, {
        index: valueIndex,
        prefixCls: prefixCls,
        value: value,
        dragging: dragging
    });
    return handleNode;
});
var $0693faea4a4f0dfb$export$2e2bcd8739ae039 = $0693faea4a4f0dfb$var$Handle;



var $8f2cee7eec29aaa5$var$_excluded = [
    "prefixCls",
    "style",
    "onStartMove",
    "onOffsetChange",
    "values",
    "handleRender",
    "draggingIndex"
];
var $8f2cee7eec29aaa5$var$Handles = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, style = props.style, onStartMove = props.onStartMove, onOffsetChange = props.onOffsetChange, values = props.values, handleRender = props.handleRender, draggingIndex = props.draggingIndex, restProps = (0, $04RxA.default)(props, $8f2cee7eec29aaa5$var$_excluded);
    var handlesRef = $6fFrj.useRef({});
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            focus: function focus(index) {
                var _handlesRef$current$i;
                (_handlesRef$current$i = handlesRef.current[index]) === null || _handlesRef$current$i === void 0 || _handlesRef$current$i.focus();
            }
        };
    });
    return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, values.map(function(value, index) {
        return /*#__PURE__*/ $6fFrj.createElement((0, $0693faea4a4f0dfb$export$2e2bcd8739ae039), (0, $fIrcP.default)({
            ref: function ref(node) {
                if (!node) delete handlesRef.current[index];
                else handlesRef.current[index] = node;
            },
            dragging: draggingIndex === index,
            prefixCls: prefixCls,
            style: (0, $19da6ead1c64ce0d$export$ddfa24987dade61b)(style, index),
            key: index,
            value: value,
            valueIndex: index,
            onStartMove: onStartMove,
            onOffsetChange: onOffsetChange,
            render: handleRender
        }, restProps));
    }));
});
var $8f2cee7eec29aaa5$export$2e2bcd8739ae039 = $8f2cee7eec29aaa5$var$Handles;



var $37xND = parcelRequire("37xND");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
function $23928d4f03dec0bd$var$getPosition(e) {
    var obj = 'touches' in e ? e.touches[0] : e;
    return {
        pageX: obj.pageX,
        pageY: obj.pageY
    };
}
function $23928d4f03dec0bd$export$2e2bcd8739ae039(containerRef, direction, rawValues, min, max, formatValue, triggerChange, finishChange, offsetValues) {
    var _React$useState = $6fFrj.useState(null), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), draggingValue = _React$useState2[0], setDraggingValue = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState(-1), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), draggingIndex = _React$useState4[0], setDraggingIndex = _React$useState4[1];
    var _React$useState5 = $6fFrj.useState(rawValues), _React$useState6 = (0, $jP8CL.default)(_React$useState5, 2), cacheValues = _React$useState6[0], setCacheValues = _React$useState6[1];
    var _React$useState7 = $6fFrj.useState(rawValues), _React$useState8 = (0, $jP8CL.default)(_React$useState7, 2), originValues = _React$useState8[0], setOriginValues = _React$useState8[1];
    var mouseMoveEventRef = $6fFrj.useRef(null);
    var mouseUpEventRef = $6fFrj.useRef(null);
    $6fFrj.useEffect(function() {
        if (draggingIndex === -1) setCacheValues(rawValues);
    }, [
        rawValues,
        draggingIndex
    ]); // Clean up event
    $6fFrj.useEffect(function() {
        return function() {
            document.removeEventListener('mousemove', mouseMoveEventRef.current);
            document.removeEventListener('mouseup', mouseUpEventRef.current);
            document.removeEventListener('touchmove', mouseMoveEventRef.current);
            document.removeEventListener('touchend', mouseUpEventRef.current);
        };
    }, []);
    var flushValues = function flushValues(nextValues, nextValue) {
        // Perf: Only update state when value changed
        if (cacheValues.some(function(val, i) {
            return val !== nextValues[i];
        })) {
            if (nextValue !== undefined) setDraggingValue(nextValue);
            setCacheValues(nextValues);
            triggerChange(nextValues);
        }
    };
    var updateCacheValue = function updateCacheValue(valueIndex, offsetPercent) {
        // Basic point offset
        if (valueIndex === -1) {
            // >>>> Dragging on the track
            var startValue = originValues[0];
            var endValue = originValues[originValues.length - 1];
            var maxStartOffset = min - startValue;
            var maxEndOffset = max - endValue; // Get valid offset
            var offset = offsetPercent * (max - min);
            offset = Math.max(offset, maxStartOffset);
            offset = Math.min(offset, maxEndOffset); // Use first value to revert back of valid offset (like steps marks)
            var formatStartValue = formatValue(startValue + offset);
            offset = formatStartValue - startValue;
            var cloneCacheValues = originValues.map(function(val) {
                return val + offset;
            });
            flushValues(cloneCacheValues);
        } else {
            // >>>> Dragging on the handle
            var offsetDist = (max - min) * offsetPercent; // Always start with the valueIndex origin value
            var cloneValues = (0, $37xND.default)(cacheValues);
            cloneValues[valueIndex] = originValues[valueIndex];
            var next = offsetValues(cloneValues, offsetDist, valueIndex, 'dist');
            flushValues(next.values, next.value);
        }
    }; // Resolve closure
    var updateCacheValueRef = $6fFrj.useRef(updateCacheValue);
    updateCacheValueRef.current = updateCacheValue;
    var onStartMove = function onStartMove(e, valueIndex) {
        e.stopPropagation();
        var originValue = rawValues[valueIndex];
        setDraggingIndex(valueIndex);
        setDraggingValue(originValue);
        setOriginValues(rawValues);
        var _getPosition = $23928d4f03dec0bd$var$getPosition(e), startX = _getPosition.pageX, startY = _getPosition.pageY; // Moving
        var onMouseMove = function onMouseMove(event) {
            event.preventDefault();
            var _getPosition2 = $23928d4f03dec0bd$var$getPosition(event), moveX = _getPosition2.pageX, moveY = _getPosition2.pageY;
            var offsetX = moveX - startX;
            var offsetY = moveY - startY;
            var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height;
            var offSetPercent;
            switch(direction){
                case 'btt':
                    offSetPercent = -offsetY / height;
                    break;
                case 'ttb':
                    offSetPercent = offsetY / height;
                    break;
                case 'rtl':
                    offSetPercent = -offsetX / width;
                    break;
                default:
                    offSetPercent = offsetX / width;
            }
            updateCacheValueRef.current(valueIndex, offSetPercent);
        }; // End
        var onMouseUp = function onMouseUp(event) {
            event.preventDefault();
            document.removeEventListener('mouseup', onMouseUp);
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('touchend', onMouseUp);
            document.removeEventListener('touchmove', onMouseMove);
            mouseMoveEventRef.current = null;
            mouseUpEventRef.current = null;
            setDraggingIndex(-1);
            finishChange();
        };
        document.addEventListener('mouseup', onMouseUp);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('touchend', onMouseUp);
        document.addEventListener('touchmove', onMouseMove);
        mouseMoveEventRef.current = onMouseMove;
        mouseUpEventRef.current = onMouseUp;
    }; // Only return cache value when it mapping with rawValues
    var returnValues = $6fFrj.useMemo(function() {
        var sourceValues = (0, $37xND.default)(rawValues).sort(function(a, b) {
            return a - b;
        });
        var targetValues = (0, $37xND.default)(cacheValues).sort(function(a, b) {
            return a - b;
        });
        return sourceValues.every(function(val, index) {
            return val === targetValues[index];
        }) ? cacheValues : rawValues;
    }, [
        rawValues,
        cacheValues
    ]);
    return [
        draggingIndex,
        draggingValue,
        returnValues,
        onStartMove
    ];
}




var $6fFrj = parcelRequire("6fFrj");


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


function $42de50e028f1b25f$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, style = props.style, start = props.start, end = props.end, index = props.index, onStartMove = props.onStartMove;
    var _React$useContext = $6fFrj.useContext((0, $f0202c0e9f64e0c1$export$2e2bcd8739ae039)), direction = _React$useContext.direction, min = _React$useContext.min, max = _React$useContext.max, disabled = _React$useContext.disabled, range = _React$useContext.range;
    var trackPrefixCls = "".concat(prefixCls, "-track");
    var offsetStart = (0, $19da6ead1c64ce0d$export$622cea445a1c5b7d)(start, min, max);
    var offsetEnd = (0, $19da6ead1c64ce0d$export$622cea445a1c5b7d)(end, min, max); // ============================ Events ============================
    var onInternalStartMove = function onInternalStartMove(e) {
        if (!disabled && onStartMove) onStartMove(e, -1);
    }; // ============================ Render ============================
    var positionStyle = {};
    switch(direction){
        case 'rtl':
            positionStyle.right = "".concat(offsetStart * 100, "%");
            positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        case 'btt':
            positionStyle.bottom = "".concat(offsetStart * 100, "%");
            positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        case 'ttb':
            positionStyle.top = "".concat(offsetStart * 100, "%");
            positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        default:
            positionStyle.left = "".concat(offsetStart * 100, "%");
            positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
    }
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(trackPrefixCls, range && "".concat(trackPrefixCls, "-").concat(index + 1)),
        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, positionStyle), style),
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove
    });
}



function $6f7df0fa5ef78b7b$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, style = props.style, values = props.values, startPoint = props.startPoint, onStartMove = props.onStartMove;
    var _React$useContext = $6fFrj.useContext((0, $f0202c0e9f64e0c1$export$2e2bcd8739ae039)), included = _React$useContext.included, range = _React$useContext.range, min = _React$useContext.min;
    var trackList = $6fFrj.useMemo(function() {
        if (!range) {
            // null value do not have track
            if (values.length === 0) return [];
            var startValue = startPoint !== null && startPoint !== void 0 ? startPoint : min;
            var endValue = values[0];
            return [
                {
                    start: Math.min(startValue, endValue),
                    end: Math.max(startValue, endValue)
                }
            ];
        } // Multiple
        var list = [];
        for(var i = 0; i < values.length - 1; i += 1)list.push({
            start: values[i],
            end: values[i + 1]
        });
        return list;
    }, [
        values,
        range,
        startPoint,
        min
    ]);
    return included ? trackList.map(function(_ref, index) {
        var start = _ref.start, end = _ref.end;
        return /*#__PURE__*/ $6fFrj.createElement((0, $42de50e028f1b25f$export$2e2bcd8739ae039), {
            index: index,
            prefixCls: prefixCls,
            style: (0, $19da6ead1c64ce0d$export$ddfa24987dade61b)(style, index),
            start: start,
            end: end,
            key: index,
            onStartMove: onStartMove
        });
    }) : null;
}



var $6fFrj = parcelRequire("6fFrj");

var $kNxFX = parcelRequire("kNxFX");

var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


function $9a226c694bf04ed0$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, style = props.style, children = props.children, value = props.value, _onClick = props.onClick;
    var _React$useContext = $6fFrj.useContext((0, $f0202c0e9f64e0c1$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, includedStart = _React$useContext.includedStart, includedEnd = _React$useContext.includedEnd, included = _React$useContext.included;
    var textCls = "".concat(prefixCls, "-text"); // ============================ Offset ============================
    var positionStyle = (0, $19da6ead1c64ce0d$export$a41628415415e6e)(direction, value, min, max);
    return /*#__PURE__*/ $6fFrj.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(textCls, (0, $43449.default)({}, "".concat(textCls, "-active"), included && includedStart <= value && value <= includedEnd)),
        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, positionStyle), style),
        onMouseDown: function onMouseDown(e) {
            e.stopPropagation();
        },
        onClick: function onClick() {
            _onClick(value);
        }
    }, children);
}


function $14d1b4c60fc9cc30$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, marks = props.marks, onClick = props.onClick;
    var markPrefixCls = "".concat(prefixCls, "-mark"); // Not render mark if empty
    if (!marks.length) return null;
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: markPrefixCls
    }, marks.map(function(_ref) {
        var value = _ref.value, style = _ref.style, label = _ref.label;
        return /*#__PURE__*/ $6fFrj.createElement((0, $9a226c694bf04ed0$export$2e2bcd8739ae039), {
            key: value,
            prefixCls: markPrefixCls,
            style: style,
            value: value,
            onClick: onClick
        }, label);
    }));
}



var $6fFrj = parcelRequire("6fFrj");


var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


function $3afe13f6c893638d$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, value = props.value, style = props.style, activeStyle = props.activeStyle;
    var _React$useContext = $6fFrj.useContext((0, $f0202c0e9f64e0c1$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, included = _React$useContext.included, includedStart = _React$useContext.includedStart, includedEnd = _React$useContext.includedEnd;
    var dotClassName = "".concat(prefixCls, "-dot");
    var active = included && includedStart <= value && value <= includedEnd; // ============================ Offset ============================
    var mergedStyle = (0, $kNxFX.default)((0, $kNxFX.default)({}, (0, $19da6ead1c64ce0d$export$a41628415415e6e)(direction, value, min, max)), typeof style === 'function' ? style(value) : style);
    if (active) mergedStyle = (0, $kNxFX.default)((0, $kNxFX.default)({}, mergedStyle), typeof activeStyle === 'function' ? activeStyle(value) : activeStyle);
    return /*#__PURE__*/ $6fFrj.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(dotClassName, (0, $43449.default)({}, "".concat(dotClassName, "-active"), active)),
        style: mergedStyle
    });
}


function $6e1079d1fcb6ac08$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, marks = props.marks, dots = props.dots, style = props.style, activeStyle = props.activeStyle;
    var _React$useContext = $6fFrj.useContext((0, $f0202c0e9f64e0c1$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, step = _React$useContext.step;
    var stepDots = $6fFrj.useMemo(function() {
        var dotSet = new Set(); // Add marks
        marks.forEach(function(mark) {
            dotSet.add(mark.value);
        }); // Fill dots
        if (dots && step !== null) {
            var current = min;
            while(current <= max){
                dotSet.add(current);
                current += step;
            }
        }
        return Array.from(dotSet);
    }, [
        min,
        max,
        step,
        dots,
        marks
    ]);
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-step")
    }, stepDots.map(function(dotValue) {
        return /*#__PURE__*/ $6fFrj.createElement((0, $3afe13f6c893638d$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: dotValue,
            value: dotValue,
            style: style,
            activeStyle: activeStyle
        });
    }));
}



var $37xND = parcelRequire("37xND");

var $6fFrj = parcelRequire("6fFrj");
function $4dc73b1278484077$export$2e2bcd8739ae039(min, max, step, markList, allowCross, pushable) {
    var formatRangeValue = $6fFrj.useCallback(function(val) {
        var formatNextValue = isFinite(val) ? val : min;
        formatNextValue = Math.min(max, val);
        formatNextValue = Math.max(min, formatNextValue);
        return formatNextValue;
    }, [
        min,
        max
    ]);
    var formatStepValue = $6fFrj.useCallback(function(val) {
        if (step !== null) {
            var stepValue = min + Math.round((formatRangeValue(val) - min) / step) * step; // Cut number in case to be like 0.30000000000000004
            var getDecimal = function getDecimal(num) {
                return (String(num).split('.')[1] || '').length;
            };
            var maxDecimal = Math.max(getDecimal(step), getDecimal(max), getDecimal(min));
            var fixedValue = Number(stepValue.toFixed(maxDecimal));
            return min <= fixedValue && fixedValue <= max ? fixedValue : null;
        }
        return null;
    }, [
        step,
        min,
        max,
        formatRangeValue
    ]);
    var formatValue = $6fFrj.useCallback(function(val) {
        var formatNextValue = formatRangeValue(val); // List align values
        var alignValues = markList.map(function(mark) {
            return mark.value;
        });
        if (step !== null) alignValues.push(formatStepValue(val));
         // min & max
        alignValues.push(min, max); // Align with marks
        var closeValue = alignValues[0];
        var closeDist = max - min;
        alignValues.forEach(function(alignValue) {
            var dist = Math.abs(formatNextValue - alignValue);
            if (dist <= closeDist) {
                closeValue = alignValue;
                closeDist = dist;
            }
        });
        return closeValue;
    }, [
        min,
        max,
        markList,
        step,
        formatRangeValue,
        formatStepValue
    ]); // ========================== Offset ==========================
    // Single Value
    var offsetValue = function offsetValue(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
        if (typeof offset === 'number') {
            var nextValue;
            var originValue = values[valueIndex]; // Only used for `dist` mode
            var targetDistValue = originValue + offset; // Compare next step value & mark value which is best match
            var potentialValues = [];
            markList.forEach(function(mark) {
                potentialValues.push(mark.value);
            }); // Min & Max
            potentialValues.push(min, max); // In case origin value is align with mark but not with step
            potentialValues.push(formatStepValue(originValue)); // Put offset step value also
            var sign = offset > 0 ? 1 : -1;
            if (mode === 'unit') potentialValues.push(formatStepValue(originValue + sign * step));
            else potentialValues.push(formatStepValue(targetDistValue));
             // Find close one
            potentialValues = potentialValues.filter(function(val) {
                return val !== null;
            }) // Remove reverse value
            .filter(function(val) {
                return offset < 0 ? val <= originValue : val >= originValue;
            });
            if (mode === 'unit') // `unit` mode can not contain itself
            potentialValues = potentialValues.filter(function(val) {
                return val !== originValue;
            });
            var compareValue = mode === 'unit' ? originValue : targetDistValue;
            nextValue = potentialValues[0];
            var valueDist = Math.abs(nextValue - compareValue);
            potentialValues.forEach(function(potentialValue) {
                var dist = Math.abs(potentialValue - compareValue);
                if (dist < valueDist) {
                    nextValue = potentialValue;
                    valueDist = dist;
                }
            }); // Out of range will back to range
            if (nextValue === undefined) return offset < 0 ? min : max;
             // `dist` mode
            if (mode === 'dist') return nextValue;
             // `unit` mode may need another round
            if (Math.abs(offset) > 1) {
                var cloneValues = (0, $37xND.default)(values);
                cloneValues[valueIndex] = nextValue;
                return offsetValue(cloneValues, offset - sign, valueIndex, mode);
            }
            return nextValue;
        } else if (offset === 'min') return min;
        else if (offset === 'max') return max;
    };
    /** Same as `offsetValue` but return `changed` mark to tell value changed */ var offsetChangedValue = function offsetChangedValue(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
        var originValue = values[valueIndex];
        var nextValue = offsetValue(values, offset, valueIndex, mode);
        return {
            value: nextValue,
            changed: nextValue !== originValue
        };
    };
    var needPush = function needPush(dist) {
        return pushable === null && dist === 0 || typeof pushable === 'number' && dist < pushable;
    }; // Values
    var offsetValues = function offsetValues(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
        var nextValues = values.map(formatValue);
        var originValue = nextValues[valueIndex];
        var nextValue = offsetValue(nextValues, offset, valueIndex, mode);
        nextValues[valueIndex] = nextValue;
        if (allowCross === false) {
            // >>>>> Allow Cross
            var pushNum = pushable || 0; // ============ AllowCross ===============
            if (valueIndex > 0 && nextValues[valueIndex - 1] !== originValue) nextValues[valueIndex] = Math.max(nextValues[valueIndex], nextValues[valueIndex - 1] + pushNum);
            if (valueIndex < nextValues.length - 1 && nextValues[valueIndex + 1] !== originValue) nextValues[valueIndex] = Math.min(nextValues[valueIndex], nextValues[valueIndex + 1] - pushNum);
        } else if (typeof pushable === 'number' || pushable === null) {
            // >>>>> Pushable
            // =============== Push ==================
            // >>>>>> Basic push
            // End values
            for(var i = valueIndex + 1; i < nextValues.length; i += 1){
                var changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed){
                    var _offsetChangedValue = offsetChangedValue(nextValues, 1, i);
                    nextValues[i] = _offsetChangedValue.value;
                    changed = _offsetChangedValue.changed;
                }
            } // Start values
            for(var _i = valueIndex; _i > 0; _i -= 1){
                var _changed = true;
                while(needPush(nextValues[_i] - nextValues[_i - 1]) && _changed){
                    var _offsetChangedValue2 = offsetChangedValue(nextValues, -1, _i - 1);
                    nextValues[_i - 1] = _offsetChangedValue2.value;
                    _changed = _offsetChangedValue2.changed;
                }
            } // >>>>> Revert back to safe push range
            // End to Start
            for(var _i2 = nextValues.length - 1; _i2 > 0; _i2 -= 1){
                var _changed2 = true;
                while(needPush(nextValues[_i2] - nextValues[_i2 - 1]) && _changed2){
                    var _offsetChangedValue3 = offsetChangedValue(nextValues, -1, _i2 - 1);
                    nextValues[_i2 - 1] = _offsetChangedValue3.value;
                    _changed2 = _offsetChangedValue3.changed;
                }
            } // Start to End
            for(var _i3 = 0; _i3 < nextValues.length - 1; _i3 += 1){
                var _changed3 = true;
                while(needPush(nextValues[_i3 + 1] - nextValues[_i3]) && _changed3){
                    var _offsetChangedValue4 = offsetChangedValue(nextValues, 1, _i3 + 1);
                    nextValues[_i3 + 1] = _offsetChangedValue4.value;
                    _changed3 = _offsetChangedValue4.changed;
                }
            }
        }
        return {
            value: nextValues[valueIndex],
            values: nextValues
        };
    };
    return [
        formatValue,
        offsetValues
    ];
}


parcelRequire("3mXQ2");
var $6e9b401ee4edc0ac$var$Slider = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _classNames;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-slider' : _props$prefixCls, className = props.className, style = props.style, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, autoFocus = props.autoFocus, onFocus = props.onFocus, onBlur = props.onBlur, _props$min = props.min, min = _props$min === void 0 ? 0 : _props$min, _props$max = props.max, max = _props$max === void 0 ? 100 : _props$max, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, value = props.value, defaultValue = props.defaultValue, range = props.range, count = props.count, onChange = props.onChange, onBeforeChange = props.onBeforeChange, onAfterChange = props.onAfterChange, _props$allowCross = props.allowCross, allowCross = _props$allowCross === void 0 ? true : _props$allowCross, _props$pushable = props.pushable, pushable = _props$pushable === void 0 ? false : _props$pushable, draggableTrack = props.draggableTrack, reverse = props.reverse, vertical = props.vertical, _props$included = props.included, included = _props$included === void 0 ? true : _props$included, startPoint = props.startPoint, trackStyle = props.trackStyle, handleStyle = props.handleStyle, railStyle = props.railStyle, dotStyle = props.dotStyle, activeDotStyle = props.activeDotStyle, marks = props.marks, dots = props.dots, handleRender = props.handleRender, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, ariaLabelForHandle = props.ariaLabelForHandle, ariaLabelledByForHandle = props.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = props.ariaValueTextFormatterForHandle;
    var handlesRef = $6fFrj.useRef();
    var containerRef = $6fFrj.useRef();
    var direction = $6fFrj.useMemo(function() {
        if (vertical) return reverse ? 'ttb' : 'btt';
        return reverse ? 'rtl' : 'ltr';
    }, [
        reverse,
        vertical
    ]); // ============================ Range =============================
    var mergedMin = $6fFrj.useMemo(function() {
        return isFinite(min) ? min : 0;
    }, [
        min
    ]);
    var mergedMax = $6fFrj.useMemo(function() {
        return isFinite(max) ? max : 100;
    }, [
        max
    ]); // ============================= Step =============================
    var mergedStep = $6fFrj.useMemo(function() {
        return step !== null && step <= 0 ? 1 : step;
    }, [
        step
    ]); // ============================= Push =============================
    var mergedPush = $6fFrj.useMemo(function() {
        if (pushable === true) return mergedStep;
        return pushable >= 0 ? pushable : false;
    }, [
        pushable,
        mergedStep
    ]); // ============================ Marks =============================
    var markList = $6fFrj.useMemo(function() {
        var keys = Object.keys(marks || {});
        return keys.map(function(key) {
            var mark = marks[key];
            var markObj = {
                value: Number(key)
            };
            if (mark && (0, $5KhTJ.default)(mark) === 'object' && !/*#__PURE__*/ $6fFrj.isValidElement(mark) && ('label' in mark || 'style' in mark)) {
                markObj.style = mark.style;
                markObj.label = mark.label;
            } else markObj.label = mark;
            return markObj;
        }).filter(function(_ref) {
            var label = _ref.label;
            return label || typeof label === 'number';
        }).sort(function(a, b) {
            return a.value - b.value;
        });
    }, [
        marks
    ]); // ============================ Format ============================
    var _useOffset = (0, $4dc73b1278484077$export$2e2bcd8739ae039)(mergedMin, mergedMax, mergedStep, markList, allowCross, mergedPush), _useOffset2 = (0, $jP8CL.default)(_useOffset, 2), formatValue = _useOffset2[0], offsetValues = _useOffset2[1]; // ============================ Values ============================
    var _useMergedState = (0, $gfhff.default)(defaultValue, {
        value: value
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), mergedValue = _useMergedState2[0], setValue = _useMergedState2[1];
    var rawValues = $6fFrj.useMemo(function() {
        var valueList = mergedValue === null || mergedValue === undefined ? [] : Array.isArray(mergedValue) ? mergedValue : [
            mergedValue
        ];
        var _valueList = (0, $jP8CL.default)(valueList, 1), _valueList$ = _valueList[0], val0 = _valueList$ === void 0 ? mergedMin : _valueList$;
        var returnValues = mergedValue === null ? [] : [
            val0
        ]; // Format as range
        if (range) {
            returnValues = (0, $37xND.default)(valueList); // When count provided or value is `undefined`, we fill values
            if (count || mergedValue === undefined) {
                var pointCount = count >= 0 ? count + 1 : 2;
                returnValues = returnValues.slice(0, pointCount); // Fill with count
                while(returnValues.length < pointCount){
                    var _returnValues;
                    returnValues.push((_returnValues = returnValues[returnValues.length - 1]) !== null && _returnValues !== void 0 ? _returnValues : mergedMin);
                }
            }
            returnValues.sort(function(a, b) {
                return a - b;
            });
        } // Align in range
        returnValues.forEach(function(val, index) {
            returnValues[index] = formatValue(val);
        });
        return returnValues;
    }, [
        mergedValue,
        range,
        mergedMin,
        count,
        formatValue
    ]); // =========================== onChange ===========================
    var rawValuesRef = $6fFrj.useRef(rawValues);
    rawValuesRef.current = rawValues;
    var getTriggerValue = function getTriggerValue(triggerValues) {
        return range ? triggerValues : triggerValues[0];
    };
    var triggerChange = function triggerChange(nextValues) {
        // Order first
        var cloneNextValues = (0, $37xND.default)(nextValues).sort(function(a, b) {
            return a - b;
        }); // Trigger event if needed
        if (onChange && !(0, (/*@__PURE__*/$parcel$interopDefault($802a1584717a396d$exports)))(cloneNextValues, rawValuesRef.current)) onChange(getTriggerValue(cloneNextValues));
         // We set this later since it will re-render component immediately
        setValue(cloneNextValues);
    };
    var changeToCloseValue = function changeToCloseValue(newValue) {
        if (!disabled) {
            var valueIndex = 0;
            var valueDist = mergedMax - mergedMin;
            rawValues.forEach(function(val, index) {
                var dist = Math.abs(newValue - val);
                if (dist <= valueDist) {
                    valueDist = dist;
                    valueIndex = index;
                }
            }); // Create new values
            var cloneNextValues = (0, $37xND.default)(rawValues);
            cloneNextValues[valueIndex] = newValue; // Fill value to match default 2
            if (range && !rawValues.length && count === undefined) cloneNextValues.push(newValue);
            onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(cloneNextValues));
            triggerChange(cloneNextValues);
            onAfterChange === null || onAfterChange === void 0 || onAfterChange(getTriggerValue(cloneNextValues));
        }
    }; // ============================ Click =============================
    var onSliderMouseDown = function onSliderMouseDown(e) {
        e.preventDefault();
        var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height, left = _containerRef$current.left, top = _containerRef$current.top, bottom = _containerRef$current.bottom, right = _containerRef$current.right;
        var clientX = e.clientX, clientY = e.clientY;
        var percent;
        switch(direction){
            case 'btt':
                percent = (bottom - clientY) / height;
                break;
            case 'ttb':
                percent = (clientY - top) / height;
                break;
            case 'rtl':
                percent = (right - clientX) / width;
                break;
            default:
                percent = (clientX - left) / width;
        }
        var nextValue = mergedMin + percent * (mergedMax - mergedMin);
        changeToCloseValue(formatValue(nextValue));
    }; // =========================== Keyboard ===========================
    var _React$useState = $6fFrj.useState(null), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), keyboardValue = _React$useState2[0], setKeyboardValue = _React$useState2[1];
    var onHandleOffsetChange = function onHandleOffsetChange(offset, valueIndex) {
        if (!disabled) {
            var next = offsetValues(rawValues, offset, valueIndex);
            onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValues));
            triggerChange(next.values);
            onAfterChange === null || onAfterChange === void 0 || onAfterChange(getTriggerValue(next.values));
            setKeyboardValue(next.value);
        }
    };
    $6fFrj.useEffect(function() {
        if (keyboardValue !== null) {
            var valueIndex = rawValues.indexOf(keyboardValue);
            if (valueIndex >= 0) handlesRef.current.focus(valueIndex);
        }
        setKeyboardValue(null);
    }, [
        keyboardValue
    ]); // ============================= Drag =============================
    var mergedDraggableTrack = $6fFrj.useMemo(function() {
        if (draggableTrack && mergedStep === null) return false;
        return draggableTrack;
    }, [
        draggableTrack,
        mergedStep
    ]);
    var finishChange = function finishChange() {
        onAfterChange === null || onAfterChange === void 0 || onAfterChange(getTriggerValue(rawValuesRef.current));
    };
    var _useDrag = (0, $23928d4f03dec0bd$export$2e2bcd8739ae039)(containerRef, direction, rawValues, mergedMin, mergedMax, formatValue, triggerChange, finishChange, offsetValues), _useDrag2 = (0, $jP8CL.default)(_useDrag, 4), draggingIndex = _useDrag2[0], draggingValue = _useDrag2[1], cacheValues = _useDrag2[2], onStartDrag = _useDrag2[3];
    var onStartMove = function onStartMove(e, valueIndex) {
        onStartDrag(e, valueIndex);
        onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValuesRef.current));
    }; // Auto focus for updated handle
    var dragging = draggingIndex !== -1;
    $6fFrj.useEffect(function() {
        if (!dragging) {
            var valueIndex = rawValues.lastIndexOf(draggingValue);
            handlesRef.current.focus(valueIndex);
        }
    }, [
        dragging
    ]); // =========================== Included ===========================
    var sortedCacheValues = $6fFrj.useMemo(function() {
        return (0, $37xND.default)(cacheValues).sort(function(a, b) {
            return a - b;
        });
    }, [
        cacheValues
    ]); // Provide a range values with included [min, max]
    // Used for Track, Mark & Dot
    var _React$useMemo = $6fFrj.useMemo(function() {
        if (!range) return [
            mergedMin,
            sortedCacheValues[0]
        ];
        return [
            sortedCacheValues[0],
            sortedCacheValues[sortedCacheValues.length - 1]
        ];
    }, [
        sortedCacheValues,
        range,
        mergedMin
    ]), _React$useMemo2 = (0, $jP8CL.default)(_React$useMemo, 2), includedStart = _React$useMemo2[0], includedEnd = _React$useMemo2[1]; // ============================= Refs =============================
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                handlesRef.current.focus(0);
            },
            blur: function blur() {
                var _document = document, activeElement = _document.activeElement;
                if (containerRef.current.contains(activeElement)) activeElement === null || activeElement === void 0 || activeElement.blur();
            }
        };
    }); // ========================== Auto Focus ==========================
    $6fFrj.useEffect(function() {
        if (autoFocus) handlesRef.current.focus(0);
    }, []); // =========================== Context ============================
    var context = $6fFrj.useMemo(function() {
        return {
            min: mergedMin,
            max: mergedMax,
            direction: direction,
            disabled: disabled,
            step: mergedStep,
            included: included,
            includedStart: includedStart,
            includedEnd: includedEnd,
            range: range,
            tabIndex: tabIndex,
            ariaLabelForHandle: ariaLabelForHandle,
            ariaLabelledByForHandle: ariaLabelledByForHandle,
            ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle
        };
    }, [
        mergedMin,
        mergedMax,
        direction,
        disabled,
        mergedStep,
        included,
        includedStart,
        includedEnd,
        range,
        tabIndex,
        ariaLabelForHandle,
        ariaLabelledByForHandle,
        ariaValueTextFormatterForHandle
    ]); // ============================ Render ============================
    return /*#__PURE__*/ $6fFrj.createElement((0, $f0202c0e9f64e0c1$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(prefixCls, "-disabled"), disabled), (0, $43449.default)(_classNames, "".concat(prefixCls, "-vertical"), vertical), (0, $43449.default)(_classNames, "".concat(prefixCls, "-horizontal"), !vertical), (0, $43449.default)(_classNames, "".concat(prefixCls, "-with-marks"), markList.length), _classNames)),
        style: style,
        onMouseDown: onSliderMouseDown
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-rail"),
        style: railStyle
    }), /*#__PURE__*/ $6fFrj.createElement((0, $6f7df0fa5ef78b7b$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        style: trackStyle,
        values: sortedCacheValues,
        startPoint: startPoint,
        onStartMove: mergedDraggableTrack ? onStartMove : null
    }), /*#__PURE__*/ $6fFrj.createElement((0, $6e1079d1fcb6ac08$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        dots: dots,
        style: dotStyle,
        activeStyle: activeDotStyle
    }), /*#__PURE__*/ $6fFrj.createElement((0, $8f2cee7eec29aaa5$export$2e2bcd8739ae039), {
        ref: handlesRef,
        prefixCls: prefixCls,
        style: handleStyle,
        values: cacheValues,
        draggingIndex: draggingIndex,
        onStartMove: onStartMove,
        onOffsetChange: onHandleOffsetChange,
        onFocus: onFocus,
        onBlur: onBlur,
        handleRender: handleRender
    }), /*#__PURE__*/ $6fFrj.createElement((0, $14d1b4c60fc9cc30$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        onClick: changeToCloseValue
    })));
});
var $6e9b401ee4edc0ac$export$2e2bcd8739ae039 = $6e9b401ee4edc0ac$var$Slider;


var $b61624669f663db5$export$2e2bcd8739ae039 = (0, $6e9b401ee4edc0ac$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");



var $fIrcP = parcelRequire("fIrcP");

var $hqic8 = parcelRequire("hqic8");

var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");

var $320600e0fe40b850$var$SliderTooltip = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var open = props.open;
    var innerRef = (0, $6fFrj.useRef)(null);
    var rafRef = (0, $6fFrj.useRef)(null);
    function cancelKeepAlign() {
        (0, $hqic8.default).cancel(rafRef.current);
        rafRef.current = null;
    }
    function keepAlign() {
        rafRef.current = (0, $hqic8.default)(function() {
            var _a;
            (_a = innerRef.current) === null || _a === void 0 || _a.forcePopupAlign();
            rafRef.current = null;
        });
    }
    $6fFrj.useEffect(function() {
        if (open) keepAlign();
        else cancelKeepAlign();
        return cancelKeepAlign;
    }, [
        open,
        props.title
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        ref: (0, $3BOWT.composeRef)(innerRef, ref)
    }, props));
});
var $320600e0fe40b850$export$2e2bcd8739ae039 = $320600e0fe40b850$var$SliderTooltip;


var $57c08ab8caa428cc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $57c08ab8caa428cc$var$Slider = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, getPopupContainer = _React$useContext.getPopupContainer;
    var _React$useState = $6fFrj.useState({}), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), opens = _React$useState2[0], setOpens = _React$useState2[1];
    var toggleTooltipOpen = function toggleTooltipOpen(index, open) {
        setOpens(function(prev) {
            return (0, $fIrcP.default)((0, $fIrcP.default)({}, prev), (0, $43449.default)({}, index, open));
        });
    };
    var getTooltipPlacement = function getTooltipPlacement(tooltipPlacement, vertical) {
        if (tooltipPlacement) return tooltipPlacement;
        if (!vertical) return 'top';
        return direction === 'rtl' ? 'left' : 'right';
    };
    var customizePrefixCls = props.prefixCls, range = props.range, className = props.className, restProps = $57c08ab8caa428cc$var$__rest(props, [
        "prefixCls",
        "range",
        "className"
    ]);
    var prefixCls = getPrefixCls('slider', customizePrefixCls);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(className, (0, $43449.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'));
    // make reverse default on rtl direction
    if (direction === 'rtl' && !restProps.vertical) restProps.reverse = !restProps.reverse;
    // Range config
    var _React$useMemo = $6fFrj.useMemo(function() {
        if (!range) return [
            false
        ];
        return (0, $5KhTJ.default)(range) === 'object' ? [
            true,
            range.draggableTrack
        ] : [
            true,
            false
        ];
    }, [
        range
    ]), _React$useMemo2 = (0, $jP8CL.default)(_React$useMemo, 2), mergedRange = _React$useMemo2[0], draggableTrack = _React$useMemo2[1];
    var handleRender = function handleRender(node, info) {
        var _a;
        var index = info.index, dragging = info.dragging;
        var rootPrefixCls = getPrefixCls();
        var _props$tooltip = props.tooltip, tooltip = _props$tooltip === void 0 ? {} : _props$tooltip, vertical = props.vertical;
        var tooltipProps = (0, $fIrcP.default)({
            formatter: (_a = props.tipFormatter) !== null && _a !== void 0 ? _a : // eslint-disable-next-line func-names
            function(value) {
                return typeof value === 'number' ? value.toString() : '';
            },
            open: props.tooltipVisible,
            placement: props.tooltipPlacement,
            getPopupContainer: props.getTooltipPopupContainer
        }, tooltip);
        var tooltipOpen = tooltipProps.open, tooltipPlacement = tooltipProps.placement, getTooltipPopupContainer = tooltipProps.getPopupContainer, customizeTooltipPrefixCls = tooltipProps.prefixCls, tipFormatter = tooltipProps.formatter;
        var isTipFormatter = tipFormatter ? opens[index] || dragging : false;
        var open = tooltipOpen || tooltipOpen === undefined && isTipFormatter;
        var passedProps = (0, $fIrcP.default)((0, $fIrcP.default)({}, node.props), {
            onMouseEnter: function onMouseEnter() {
                return toggleTooltipOpen(index, true);
            },
            onMouseLeave: function onMouseLeave() {
                return toggleTooltipOpen(index, false);
            }
        });
        var tooltipPrefixCls = getPrefixCls('tooltip', customizeTooltipPrefixCls);
        return /*#__PURE__*/ $6fFrj.createElement((0, $320600e0fe40b850$export$2e2bcd8739ae039), {
            prefixCls: tooltipPrefixCls,
            title: tipFormatter ? tipFormatter(info.value) : '',
            open: open,
            placement: getTooltipPlacement(tooltipPlacement, vertical),
            transitionName: "".concat(rootPrefixCls, "-zoom-down"),
            key: index,
            overlayClassName: "".concat(prefixCls, "-tooltip"),
            getPopupContainer: getTooltipPopupContainer || getPopupContainer
        }, /*#__PURE__*/ $6fFrj.cloneElement(node, passedProps));
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $b61624669f663db5$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, restProps, {
        step: restProps.step,
        range: mergedRange,
        draggableTrack: draggableTrack,
        className: cls,
        ref: ref,
        prefixCls: prefixCls,
        handleRender: handleRender
    }));
});
var $57c08ab8caa428cc$export$2e2bcd8739ae039 = $57c08ab8caa428cc$var$Slider;


var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");



var $fActo = parcelRequire("fActo");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $3mZgl = parcelRequire("3mZgl");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $3mZgl = parcelRequire("3mZgl");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");
var $fdf948b6b501504b$var$_excluded = [
    "className",
    "prefixCls",
    "style",
    "active",
    "status",
    "iconPrefix",
    "icon",
    "wrapperStyle",
    "stepNumber",
    "disabled",
    "description",
    "title",
    "subTitle",
    "progressDot",
    "stepIcon",
    "tailContent",
    "icons",
    "stepIndex",
    "onStepClick",
    "onClick"
];
function $fdf948b6b501504b$var$isString(str) {
    return typeof str === 'string';
}
var $fdf948b6b501504b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(Step, _React$Component);
    var _super = (0, $lSufv.default)(Step);
    function Step() {
        var _this;
        (0, $kjNeN.default)(this, Step);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(_args));
        (0, $43449.default)((0, $3mZgl.default)(_this), "onClick", function() {
            var _this$props = _this.props, onClick = _this$props.onClick, onStepClick = _this$props.onStepClick, stepIndex = _this$props.stepIndex;
            if (onClick) onClick.apply(void 0, arguments);
            onStepClick(stepIndex);
        });
        return _this;
    }
    (0, $5KQxu.default)(Step, [
        {
            key: "renderIconNode",
            value: function renderIconNode() {
                var _classNames;
                var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, progressDot = _this$props2.progressDot, stepIcon = _this$props2.stepIcon, stepNumber = _this$props2.stepNumber, status = _this$props2.status, title = _this$props2.title, description = _this$props2.description, icon = _this$props2.icon, iconPrefix = _this$props2.iconPrefix, icons = _this$props2.icons;
                var iconNode;
                var iconClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-icon"), "".concat(iconPrefix, "icon"), (_classNames = {}, (0, $43449.default)(_classNames, "".concat(iconPrefix, "icon-").concat(icon), icon && $fdf948b6b501504b$var$isString(icon)), (0, $43449.default)(_classNames, "".concat(iconPrefix, "icon-check"), !icon && status === 'finish' && (icons && !icons.finish || !icons)), (0, $43449.default)(_classNames, "".concat(iconPrefix, "icon-cross"), !icon && status === 'error' && (icons && !icons.error || !icons)), _classNames));
                var iconDot = /*#__PURE__*/ $6fFrj.createElement("span", {
                    className: "".concat(prefixCls, "-icon-dot")
                }); // `progressDot` enjoy the highest priority
                if (progressDot) {
                    if (typeof progressDot === 'function') iconNode = /*#__PURE__*/ $6fFrj.createElement("span", {
                        className: "".concat(prefixCls, "-icon")
                    }, progressDot(iconDot, {
                        index: stepNumber - 1,
                        status: status,
                        title: title,
                        description: description
                    }));
                    else iconNode = /*#__PURE__*/ $6fFrj.createElement("span", {
                        className: "".concat(prefixCls, "-icon")
                    }, iconDot);
                } else if (icon && !$fdf948b6b501504b$var$isString(icon)) iconNode = /*#__PURE__*/ $6fFrj.createElement("span", {
                    className: "".concat(prefixCls, "-icon")
                }, icon);
                else if (icons && icons.finish && status === 'finish') iconNode = /*#__PURE__*/ $6fFrj.createElement("span", {
                    className: "".concat(prefixCls, "-icon")
                }, icons.finish);
                else if (icons && icons.error && status === 'error') iconNode = /*#__PURE__*/ $6fFrj.createElement("span", {
                    className: "".concat(prefixCls, "-icon")
                }, icons.error);
                else if (icon || status === 'finish' || status === 'error') iconNode = /*#__PURE__*/ $6fFrj.createElement("span", {
                    className: iconClassName
                });
                else iconNode = /*#__PURE__*/ $6fFrj.createElement("span", {
                    className: "".concat(prefixCls, "-icon")
                }, stepNumber);
                if (stepIcon) iconNode = stepIcon({
                    index: stepNumber - 1,
                    status: status,
                    title: title,
                    description: description,
                    node: iconNode
                });
                return iconNode;
            }
        },
        {
            key: "render",
            value: function render() {
                var _classNames2;
                var _this$props3 = this.props, className = _this$props3.className, prefixCls = _this$props3.prefixCls, style = _this$props3.style, active = _this$props3.active, _this$props3$status = _this$props3.status, status = _this$props3$status === void 0 ? 'wait' : _this$props3$status, iconPrefix = _this$props3.iconPrefix, icon = _this$props3.icon, wrapperStyle = _this$props3.wrapperStyle, stepNumber = _this$props3.stepNumber, disabled = _this$props3.disabled, description = _this$props3.description, title = _this$props3.title, subTitle = _this$props3.subTitle, progressDot = _this$props3.progressDot, stepIcon = _this$props3.stepIcon, tailContent = _this$props3.tailContent, icons = _this$props3.icons, stepIndex = _this$props3.stepIndex, onStepClick = _this$props3.onStepClick, onClick = _this$props3.onClick, restProps = (0, $04RxA.default)(_this$props3, $fdf948b6b501504b$var$_excluded);
                var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-item"), "".concat(prefixCls, "-item-").concat(status), className, (_classNames2 = {}, (0, $43449.default)(_classNames2, "".concat(prefixCls, "-item-custom"), icon), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-item-active"), active), (0, $43449.default)(_classNames2, "".concat(prefixCls, "-item-disabled"), disabled === true), _classNames2));
                var stepItemStyle = (0, $kNxFX.default)({}, style);
                var accessibilityProps = {};
                if (onStepClick && !disabled) {
                    accessibilityProps.role = 'button';
                    accessibilityProps.tabIndex = 0;
                    accessibilityProps.onClick = this.onClick;
                }
                return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({}, restProps, {
                    className: classString,
                    style: stepItemStyle
                }), /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
                    onClick: onClick
                }, accessibilityProps, {
                    className: "".concat(prefixCls, "-item-container")
                }), /*#__PURE__*/ $6fFrj.createElement("div", {
                    className: "".concat(prefixCls, "-item-tail")
                }, tailContent), /*#__PURE__*/ $6fFrj.createElement("div", {
                    className: "".concat(prefixCls, "-item-icon")
                }, this.renderIconNode()), /*#__PURE__*/ $6fFrj.createElement("div", {
                    className: "".concat(prefixCls, "-item-content")
                }, /*#__PURE__*/ $6fFrj.createElement("div", {
                    className: "".concat(prefixCls, "-item-title")
                }, title, subTitle && /*#__PURE__*/ $6fFrj.createElement("div", {
                    title: typeof subTitle === 'string' ? subTitle : undefined,
                    className: "".concat(prefixCls, "-item-subtitle")
                }, subTitle)), description && /*#__PURE__*/ $6fFrj.createElement("div", {
                    className: "".concat(prefixCls, "-item-description")
                }, description))));
            }
        }
    ]);
    return Step;
}($6fFrj.Component);


var $39bc05a46f6e7b7f$var$_excluded = [
    "prefixCls",
    "style",
    "className",
    "children",
    "direction",
    "type",
    "labelPlacement",
    "iconPrefix",
    "status",
    "size",
    "current",
    "progressDot",
    "stepIcon",
    "initial",
    "icons",
    "onChange",
    "items"
];
var $39bc05a46f6e7b7f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(Steps, _React$Component);
    var _super = (0, $lSufv.default)(Steps);
    function Steps() {
        var _this;
        (0, $kjNeN.default)(this, Steps);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $43449.default)((0, $3mZgl.default)(_this), "onStepClick", function(next) {
            var _this$props = _this.props, onChange = _this$props.onChange, current = _this$props.current;
            if (onChange && current !== next) onChange(next);
        });
        return _this;
    }
    (0, $5KQxu.default)(Steps, [
        {
            key: "render",
            value: function render() {
                var _classNames, _this2 = this;
                var _this$props2 = this.props, prefixCls = _this$props2.prefixCls, _this$props2$style = _this$props2.style, style = _this$props2$style === void 0 ? {} : _this$props2$style, className = _this$props2.className, children = _this$props2.children, direction = _this$props2.direction, type = _this$props2.type, labelPlacement = _this$props2.labelPlacement, iconPrefix = _this$props2.iconPrefix, status = _this$props2.status, size = _this$props2.size, current = _this$props2.current, progressDot = _this$props2.progressDot, stepIcon = _this$props2.stepIcon, initial = _this$props2.initial, icons = _this$props2.icons, onChange = _this$props2.onChange, _this$props2$items = _this$props2.items, items = _this$props2$items === void 0 ? [] : _this$props2$items, restProps = (0, $04RxA.default)(_this$props2, $39bc05a46f6e7b7f$var$_excluded);
                var isNav = type === 'navigation';
                var adjustedLabelPlacement = progressDot ? 'vertical' : labelPlacement;
                var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-").concat(direction), className, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(prefixCls, "-").concat(size), size), (0, $43449.default)(_classNames, "".concat(prefixCls, "-label-").concat(adjustedLabelPlacement), direction === 'horizontal'), (0, $43449.default)(_classNames, "".concat(prefixCls, "-dot"), !!progressDot), (0, $43449.default)(_classNames, "".concat(prefixCls, "-navigation"), isNav), _classNames));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", (0, $fIrcP.default)({
                    className: classString,
                    style: style
                }, restProps), items.filter(function(item) {
                    return item;
                }).map(function(item, index) {
                    var mergedItem = (0, $kNxFX.default)({}, item);
                    var stepNumber = initial + index; // fix tail color
                    if (status === 'error' && index === current - 1) mergedItem.className = "".concat(prefixCls, "-next-error");
                    if (!mergedItem.status) {
                        if (stepNumber === current) mergedItem.status = status;
                        else if (stepNumber < current) mergedItem.status = 'finish';
                        else mergedItem.status = 'wait';
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $fdf948b6b501504b$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, mergedItem, {
                        active: stepNumber === current,
                        stepNumber: stepNumber + 1,
                        stepIndex: stepNumber,
                        key: stepNumber,
                        prefixCls: prefixCls,
                        iconPrefix: iconPrefix,
                        wrapperStyle: style,
                        progressDot: progressDot,
                        stepIcon: stepIcon,
                        icons: icons,
                        onStepClick: onChange && _this2.onStepClick
                    }));
                }));
            }
        }
    ]);
    return Steps;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
(0, $43449.default)($39bc05a46f6e7b7f$export$2e2bcd8739ae039, "Step", (0, $fdf948b6b501504b$export$2e2bcd8739ae039));
(0, $43449.default)($39bc05a46f6e7b7f$export$2e2bcd8739ae039, "defaultProps", {
    type: 'default',
    prefixCls: 'rc-steps',
    iconPrefix: 'rc',
    direction: 'horizontal',
    labelPlacement: 'horizontal',
    initial: 0,
    current: 0,
    status: 'process',
    size: '',
    progressDot: false
});



var $89790b8d1b048896$export$2e2bcd8739ae039 = (0, $39bc05a46f6e7b7f$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");




var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");


function $366d95e8a5437b9e$var$filter(items) {
    return items.filter(function(item) {
        return item;
    });
}
function $366d95e8a5437b9e$export$2e2bcd8739ae039(items, children) {
    if (items) return items;
    var childrenItems = (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(children).map(function(node) {
        if (/*#__PURE__*/ $6fFrj.isValidElement(node)) {
            var props = node.props;
            var item = (0, $fIrcP.default)({}, props);
            return item;
        }
        return null;
    });
    return $366d95e8a5437b9e$var$filter(childrenItems);
}


var $226121d160d93575$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $226121d160d93575$var$Steps = function Steps(props) {
    var percent = props.percent, size = props.size, className = props.className, direction = props.direction, items = props.items, _props$responsive = props.responsive, responsive = _props$responsive === void 0 ? true : _props$responsive, _props$current = props.current, current = _props$current === void 0 ? 0 : _props$current, children = props.children, restProps = $226121d160d93575$var$__rest(props, [
        "percent",
        "size",
        "className",
        "direction",
        "items",
        "responsive",
        "current",
        "children"
    ]);
    var _useBreakpoint = (0, $60fdd98823a1708b$export$2e2bcd8739ae039)(responsive), xs = _useBreakpoint.xs;
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, rtlDirection = _React$useContext.direction;
    var getDirection = $6fFrj.useCallback(function() {
        return responsive && xs ? 'vertical' : direction;
    }, [
        xs,
        direction
    ]);
    var prefixCls = getPrefixCls('steps', props.prefixCls);
    var iconPrefix = getPrefixCls('', props.iconPrefix);
    var mergedItems = (0, $366d95e8a5437b9e$export$2e2bcd8739ae039)(items, children);
    var stepsClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-rtl"), rtlDirection === 'rtl'), "".concat(prefixCls, "-with-progress"), percent !== undefined), className);
    var icons = {
        finish: /*#__PURE__*/ $6fFrj.createElement((0, $97e498ed1184adf1$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-finish-icon")
        }),
        error: /*#__PURE__*/ $6fFrj.createElement((0, $4cb3f1f073816266$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-error-icon")
        })
    };
    var stepIconRender = function stepIconRender(_ref) {
        var node = _ref.node, status = _ref.status;
        if (status === 'process' && percent !== undefined) {
            // currently it's hard-coded, since we can't easily read the actually width of icon
            var progressWidth = size === 'small' ? 32 : 40;
            // iconWithProgress
            return /*#__PURE__*/ $6fFrj.createElement("div", {
                className: "".concat(prefixCls, "-progress-icon")
            }, /*#__PURE__*/ $6fFrj.createElement((0, $35ec803a48e00dda$export$2e2bcd8739ae039), {
                type: "circle",
                percent: percent,
                width: progressWidth,
                strokeWidth: 4,
                format: function format() {
                    return null;
                }
            }), node);
        }
        return node;
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $89790b8d1b048896$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        icons: icons
    }, restProps, {
        current: current,
        size: size,
        items: mergedItems,
        direction: getDirection(),
        stepIcon: stepIconRender,
        prefixCls: prefixCls,
        iconPrefix: iconPrefix,
        className: stepsClassName
    }));
};
$226121d160d93575$var$Steps.Step = (0, $89790b8d1b048896$export$2e2bcd8739ae039).Step;
var $226121d160d93575$export$2e2bcd8739ae039 = $226121d160d93575$var$Steps;


var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");


var $fActo = parcelRequire("fActo");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $gfhff = parcelRequire("gfhff");

var $57c0892c4b750240$var$Switch = $6fFrj.forwardRef(function(_ref, ref) {
    var _classNames;
    var _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? 'rc-switch' : _ref$prefixCls, className = _ref.className, checked = _ref.checked, defaultChecked = _ref.defaultChecked, disabled = _ref.disabled, loadingIcon = _ref.loadingIcon, checkedChildren = _ref.checkedChildren, unCheckedChildren = _ref.unCheckedChildren, onClick = _ref.onClick, onChange = _ref.onChange, onKeyDown = _ref.onKeyDown, restProps = (0, $04RxA.default)(_ref, [
        "prefixCls",
        "className",
        "checked",
        "defaultChecked",
        "disabled",
        "loadingIcon",
        "checkedChildren",
        "unCheckedChildren",
        "onClick",
        "onChange",
        "onKeyDown"
    ]);
    var _useMergedState = (0, $gfhff.default)(false, {
        value: checked,
        defaultValue: defaultChecked
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), innerChecked = _useMergedState2[0], setInnerChecked = _useMergedState2[1];
    function triggerChange(newChecked, event) {
        var mergedChecked = innerChecked;
        if (!disabled) {
            mergedChecked = newChecked;
            setInnerChecked(mergedChecked);
            onChange === null || onChange === void 0 || onChange(mergedChecked, event);
        }
        return mergedChecked;
    }
    function onInternalKeyDown(e) {
        if (e.which === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).LEFT) triggerChange(false, e);
        else if (e.which === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).RIGHT) triggerChange(true, e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    }
    function onInternalClick(e) {
        var ret = triggerChange(!innerChecked, e); // [Legacy] trigger onClick with value
        onClick === null || onClick === void 0 || onClick(ret, e);
    }
    var switchClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(prefixCls, "-checked"), innerChecked), (0, $43449.default)(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
    return $6fFrj.createElement("button", Object.assign({}, restProps, {
        type: "button",
        role: "switch",
        "aria-checked": innerChecked,
        disabled: disabled,
        className: switchClassName,
        ref: ref,
        onKeyDown: onInternalKeyDown,
        onClick: onInternalClick
    }), loadingIcon, $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-inner")
    }, innerChecked ? checkedChildren : unCheckedChildren));
});
$57c0892c4b750240$var$Switch.displayName = 'Switch';
var $57c0892c4b750240$export$2e2bcd8739ae039 = $57c0892c4b750240$var$Switch;



var $6fFrj = parcelRequire("6fFrj");





var $4fd303306a27e42e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4fd303306a27e42e$var$Switch = /*#__PURE__*/ $6fFrj.forwardRef(function(_a, ref) {
    var customizePrefixCls = _a.prefixCls, customizeSize = _a.size, customDisabled = _a.disabled, loading = _a.loading, _a$className = _a.className, className = _a$className === void 0 ? '' : _a$className, props = $4fd303306a27e42e$var$__rest(_a, [
        "prefixCls",
        "size",
        "disabled",
        "loading",
        "className"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var size = $6fFrj.useContext((0, $aefad26b74860b7e$export$2e2bcd8739ae039));
    // ===================== Disabled =====================
    var disabled = $6fFrj.useContext((0, $3880af76d17f94a3$export$2e2bcd8739ae039));
    var mergedDisabled = (customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled) || loading;
    var prefixCls = getPrefixCls('switch', customizePrefixCls);
    var loadingIcon = /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-handle")
    }, loading && /*#__PURE__*/ $6fFrj.createElement((0, $3240b41b65b5dac9$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-loading-icon")
    }));
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-small"), (customizeSize || size) === 'small'), "".concat(prefixCls, "-loading"), loading), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $6fFrj.createElement((0, $3b8de09695d8518a$export$2e2bcd8739ae039), {
        insertExtraNode: true
    }, /*#__PURE__*/ $6fFrj.createElement((0, $57c0892c4b750240$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        prefixCls: prefixCls,
        className: classes,
        disabled: mergedDisabled,
        ref: ref,
        loadingIcon: loadingIcon
    })));
});
$4fd303306a27e42e$var$Switch.__ANT_SWITCH = true;
var $4fd303306a27e42e$export$2e2bcd8739ae039 = $4fd303306a27e42e$var$Switch;


var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $1WWLf = parcelRequire("1WWLf");

var $5KhTJ = parcelRequire("5KhTJ");

var $37xND = parcelRequire("37xND");

var $jP8CL = parcelRequire("jP8CL");

var $fActo = parcelRequire("fActo");

var $fIrcP = parcelRequire("fIrcP");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $04RxA = parcelRequire("04RxA");

var $1WWLf = parcelRequire("1WWLf");

var $5KhTJ = parcelRequire("5KhTJ");

var $47DhB = parcelRequire("47DhB");

var $37xND = parcelRequire("37xND");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

function $4a139222dca106a7$var$getError(option, xhr) {
    var msg = "cannot ".concat(option.method, " ").concat(option.action, " ").concat(xhr.status, "'");
    var err = new Error(msg);
    err.status = xhr.status;
    err.method = option.method;
    err.url = option.action;
    return err;
}
function $4a139222dca106a7$var$getBody(xhr) {
    var text = xhr.responseText || xhr.response;
    if (!text) return text;
    try {
        return JSON.parse(text);
    } catch (e) {
        return text;
    }
}
function $4a139222dca106a7$export$2e2bcd8739ae039(option) {
    // eslint-disable-next-line no-undef
    var xhr = new XMLHttpRequest();
    if (option.onProgress && xhr.upload) xhr.upload.onprogress = function progress(e) {
        if (e.total > 0) e.percent = e.loaded / e.total * 100;
        option.onProgress(e);
    };
    // eslint-disable-next-line no-undef
    var formData = new FormData();
    if (option.data) Object.keys(option.data).forEach(function(key) {
        var value = option.data[key];
        // support key-value array data
        if (Array.isArray(value)) {
            value.forEach(function(item) {
                // { list: [ 11, 22 ] }
                // formData.append('list[]', 11);
                formData.append("".concat(key, "[]"), item);
            });
            return;
        }
        formData.append(key, value);
    });
    // eslint-disable-next-line no-undef
    if (option.file instanceof Blob) formData.append(option.filename, option.file, option.file.name);
    else formData.append(option.filename, option.file);
    xhr.onerror = function error(e) {
        option.onError(e);
    };
    xhr.onload = function onload() {
        // allow success when 2xx status
        // see https://github.com/react-component/upload/issues/34
        if (xhr.status < 200 || xhr.status >= 300) return option.onError($4a139222dca106a7$var$getError(option, xhr), $4a139222dca106a7$var$getBody(xhr));
        return option.onSuccess($4a139222dca106a7$var$getBody(xhr), xhr);
    };
    xhr.open(option.method, option.action, true);
    // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
    if (option.withCredentials && 'withCredentials' in xhr) xhr.withCredentials = true;
    var headers = option.headers || {};
    // when set headers['X-Requested-With'] = null , can close default XHR header
    // see https://github.com/react-component/upload/issues/33
    if (headers['X-Requested-With'] !== null) xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    Object.keys(headers).forEach(function(h) {
        if (headers[h] !== null) xhr.setRequestHeader(h, headers[h]);
    });
    xhr.send(formData);
    return {
        abort: function abort() {
            xhr.abort();
        }
    };
}


var $d5ddf83c1a58c8a6$var$now = +new Date();
var $d5ddf83c1a58c8a6$var$index = 0;
function $d5ddf83c1a58c8a6$export$2e2bcd8739ae039() {
    // eslint-disable-next-line no-plusplus
    return "rc-upload-".concat($d5ddf83c1a58c8a6$var$now, "-").concat(++$d5ddf83c1a58c8a6$var$index);
}



var $3mXQ2 = parcelRequire("3mXQ2");
var $b65da3027f1c4757$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        var fileName = file.name || '';
        var mimeType = file.type || '';
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim();
            // This is something like */*,*  allow all files
            if (/^\*(\/\*)?$/.test(type)) return true;
            // like .jpg, .png
            if (validType.charAt(0) === '.') {
                var lowerFileName = fileName.toLowerCase();
                var lowerType = validType.toLowerCase();
                var affixList = [
                    lowerType
                ];
                if (lowerType === '.jpg' || lowerType === '.jpeg') affixList = [
                    '.jpg',
                    '.jpeg'
                ];
                return affixList.some(function(affix) {
                    return lowerFileName.endsWith(affix);
                });
            }
            // This is something like a image/* mime type
            if (/\/\*$/.test(validType)) return baseMimeType === validType.replace(/\/.*$/, '');
            // Full match
            if (mimeType === validType) return true;
            // Invalidate type should skip
            if (/^\w+$/.test(validType)) {
                (0, $3mXQ2.default)(false, "Upload takes an invalidate 'accept' type '".concat(validType, "'.Skip for check."));
                return true;
            }
            return false;
        });
    }
    return true;
};


function $0d8f7b528246eca5$var$loopFiles(item, callback) {
    var dirReader = item.createReader();
    var fileList = [];
    function sequence() {
        dirReader.readEntries(function(entries) {
            var entryList = Array.prototype.slice.apply(entries);
            fileList = fileList.concat(entryList);
            // Check if all the file has been viewed
            var isFinished = !entryList.length;
            if (isFinished) callback(fileList);
            else sequence();
        });
    }
    sequence();
}
var $0d8f7b528246eca5$var$traverseFileTree = function traverseFileTree(files, callback, isAccepted) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _traverseFileTree = function _traverseFileTree(item, path) {
        if (!item) return;
        // eslint-disable-next-line no-param-reassign
        item.path = path || '';
        if (item.isFile) item.file(function(file) {
            if (isAccepted(file)) {
                // https://github.com/ant-design/ant-design/issues/16426
                if (item.fullPath && !file.webkitRelativePath) {
                    Object.defineProperties(file, {
                        webkitRelativePath: {
                            writable: true
                        }
                    });
                    // eslint-disable-next-line no-param-reassign
                    file.webkitRelativePath = item.fullPath.replace(/^\//, '');
                    Object.defineProperties(file, {
                        webkitRelativePath: {
                            writable: false
                        }
                    });
                }
                callback([
                    file
                ]);
            }
        });
        else if (item.isDirectory) $0d8f7b528246eca5$var$loopFiles(item, function(entries) {
            entries.forEach(function(entryItem) {
                _traverseFileTree(entryItem, "".concat(path).concat(item.name, "/"));
            });
        });
    };
    files.forEach(function(file) {
        _traverseFileTree(file.webkitGetAsEntry());
    });
};
var $0d8f7b528246eca5$export$2e2bcd8739ae039 = $0d8f7b528246eca5$var$traverseFileTree;


var $8ed9d8d4a990f9da$var$_excluded = [
    "component",
    "prefixCls",
    "className",
    "disabled",
    "id",
    "style",
    "multiple",
    "accept",
    "capture",
    "children",
    "directory",
    "openFileDialogOnClick",
    "onMouseEnter",
    "onMouseLeave"
];
var $8ed9d8d4a990f9da$var$AjaxUploader = /*#__PURE__*/ function(_Component) {
    (0, $bxC2Y.default)(AjaxUploader, _Component);
    var _super = (0, $lSufv.default)(AjaxUploader);
    function AjaxUploader() {
        var _this;
        (0, $kjNeN.default)(this, AjaxUploader);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            uid: (0, $d5ddf83c1a58c8a6$export$2e2bcd8739ae039)()
        };
        _this.reqs = {};
        _this.fileInput = void 0;
        _this._isMounted = void 0;
        _this.onChange = function(e) {
            var _this$props = _this.props, accept = _this$props.accept, directory = _this$props.directory;
            var files = e.target.files;
            var acceptedFiles = (0, $37xND.default)(files).filter(function(file) {
                return !directory || (0, $b65da3027f1c4757$export$2e2bcd8739ae039)(file, accept);
            });
            _this.uploadFiles(acceptedFiles);
            _this.reset();
        };
        _this.onClick = function(e) {
            var el = _this.fileInput;
            if (!el) return;
            var target = e.target;
            var onClick = _this.props.onClick;
            if (target && target.tagName === 'BUTTON') {
                var parent = el.parentNode;
                parent.focus();
                target.blur();
            }
            el.click();
            if (onClick) onClick(e);
        };
        _this.onKeyDown = function(e) {
            if (e.key === 'Enter') _this.onClick(e);
        };
        _this.onFileDrop = function(e) {
            var multiple = _this.props.multiple;
            e.preventDefault();
            if (e.type === 'dragover') return;
            if (_this.props.directory) (0, $0d8f7b528246eca5$export$2e2bcd8739ae039)(Array.prototype.slice.call(e.dataTransfer.items), _this.uploadFiles, function(_file) {
                return (0, $b65da3027f1c4757$export$2e2bcd8739ae039)(_file, _this.props.accept);
            });
            else {
                var files = (0, $37xND.default)(e.dataTransfer.files).filter(function(file) {
                    return (0, $b65da3027f1c4757$export$2e2bcd8739ae039)(file, _this.props.accept);
                });
                if (multiple === false) files = files.slice(0, 1);
                _this.uploadFiles(files);
            }
        };
        _this.uploadFiles = function(files) {
            var originFiles = (0, $37xND.default)(files);
            var postFiles = originFiles.map(function(file) {
                // eslint-disable-next-line no-param-reassign
                file.uid = (0, $d5ddf83c1a58c8a6$export$2e2bcd8739ae039)();
                return _this.processFile(file, originFiles);
            });
            // Batch upload files
            Promise.all(postFiles).then(function(fileList) {
                var onBatchStart = _this.props.onBatchStart;
                onBatchStart === null || onBatchStart === void 0 || onBatchStart(fileList.map(function(_ref) {
                    var origin = _ref.origin, parsedFile = _ref.parsedFile;
                    return {
                        file: origin,
                        parsedFile: parsedFile
                    };
                }));
                fileList.filter(function(file) {
                    return file.parsedFile !== null;
                }).forEach(function(file) {
                    _this.post(file);
                });
            });
        };
        /**
     * Process file before upload. When all the file is ready, we start upload.
     */ _this.processFile = /*#__PURE__*/ function() {
            var _ref2 = (0, $47DhB.default)(/*#__PURE__*/ (0, $1WWLf.default)().mark(function _callee(file, fileList) {
                var beforeUpload, transformedFile, action, mergedAction, data, mergedData, parsedData, parsedFile, mergedParsedFile;
                return (0, $1WWLf.default)().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            beforeUpload = _this.props.beforeUpload;
                            transformedFile = file;
                            if (!beforeUpload) {
                                _context.next = 14;
                                break;
                            }
                            _context.prev = 3;
                            _context.next = 6;
                            return beforeUpload(file, fileList);
                        case 6:
                            transformedFile = _context.sent;
                            _context.next = 12;
                            break;
                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context["catch"](3);
                            // Rejection will also trade as false
                            transformedFile = false;
                        case 12:
                            if (!(transformedFile === false)) {
                                _context.next = 14;
                                break;
                            }
                            return _context.abrupt("return", {
                                origin: file,
                                parsedFile: null,
                                action: null,
                                data: null
                            });
                        case 14:
                            // Get latest action
                            action = _this.props.action;
                            if (!(typeof action === 'function')) {
                                _context.next = 21;
                                break;
                            }
                            _context.next = 18;
                            return action(file);
                        case 18:
                            mergedAction = _context.sent;
                            _context.next = 22;
                            break;
                        case 21:
                            mergedAction = action;
                        case 22:
                            // Get latest data
                            data = _this.props.data;
                            if (!(typeof data === 'function')) {
                                _context.next = 29;
                                break;
                            }
                            _context.next = 26;
                            return data(file);
                        case 26:
                            mergedData = _context.sent;
                            _context.next = 30;
                            break;
                        case 29:
                            mergedData = data;
                        case 30:
                            parsedData = // string type is from legacy `transformFile`.
                            // Not sure if this will work since no related test case works with it
                            ((0, $5KhTJ.default)(transformedFile) === 'object' || typeof transformedFile === 'string') && transformedFile ? transformedFile : file;
                            if (parsedData instanceof File) parsedFile = parsedData;
                            else parsedFile = new File([
                                parsedData
                            ], file.name, {
                                type: file.type
                            });
                            mergedParsedFile = parsedFile;
                            mergedParsedFile.uid = file.uid;
                            return _context.abrupt("return", {
                                origin: file,
                                data: mergedData,
                                parsedFile: mergedParsedFile,
                                action: mergedAction
                            });
                        case 35:
                        case "end":
                            return _context.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        9
                    ]
                ]);
            }));
            return function(_x, _x2) {
                return _ref2.apply(this, arguments);
            };
        }();
        _this.saveFileInput = function(node) {
            _this.fileInput = node;
        };
        return _this;
    }
    (0, $5KQxu.default)(AjaxUploader, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._isMounted = true;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._isMounted = false;
                this.abort();
            }
        },
        {
            key: "post",
            value: function post(_ref3) {
                var _this2 = this;
                var data = _ref3.data, origin = _ref3.origin, action = _ref3.action, parsedFile = _ref3.parsedFile;
                if (!this._isMounted) return;
                var _this$props2 = this.props, onStart = _this$props2.onStart, customRequest = _this$props2.customRequest, name = _this$props2.name, headers = _this$props2.headers, withCredentials = _this$props2.withCredentials, method = _this$props2.method;
                var uid = origin.uid;
                var request = customRequest || (0, $4a139222dca106a7$export$2e2bcd8739ae039);
                var requestOption = {
                    action: action,
                    filename: name,
                    data: data,
                    file: parsedFile,
                    headers: headers,
                    withCredentials: withCredentials,
                    method: method || 'post',
                    onProgress: function onProgress(e) {
                        var onProgress = _this2.props.onProgress;
                        onProgress === null || onProgress === void 0 || onProgress(e, parsedFile);
                    },
                    onSuccess: function onSuccess(ret, xhr) {
                        var onSuccess = _this2.props.onSuccess;
                        onSuccess === null || onSuccess === void 0 || onSuccess(ret, parsedFile, xhr);
                        delete _this2.reqs[uid];
                    },
                    onError: function onError(err, ret) {
                        var onError = _this2.props.onError;
                        onError === null || onError === void 0 || onError(err, ret, parsedFile);
                        delete _this2.reqs[uid];
                    }
                };
                onStart(origin);
                this.reqs[uid] = request(requestOption);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.setState({
                    uid: (0, $d5ddf83c1a58c8a6$export$2e2bcd8739ae039)()
                });
            }
        },
        {
            key: "abort",
            value: function abort(file) {
                var reqs = this.reqs;
                if (file) {
                    var uid = file.uid ? file.uid : file;
                    if (reqs[uid] && reqs[uid].abort) reqs[uid].abort();
                    delete reqs[uid];
                } else Object.keys(reqs).forEach(function(uid) {
                    if (reqs[uid] && reqs[uid].abort) reqs[uid].abort();
                    delete reqs[uid];
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props3 = this.props, Tag = _this$props3.component, prefixCls = _this$props3.prefixCls, className = _this$props3.className, disabled = _this$props3.disabled, id = _this$props3.id, style = _this$props3.style, multiple = _this$props3.multiple, accept = _this$props3.accept, capture = _this$props3.capture, children = _this$props3.children, directory = _this$props3.directory, openFileDialogOnClick = _this$props3.openFileDialogOnClick, onMouseEnter = _this$props3.onMouseEnter, onMouseLeave = _this$props3.onMouseLeave, otherProps = (0, $04RxA.default)(_this$props3, $8ed9d8d4a990f9da$var$_excluded);
                var cls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, prefixCls, true), "".concat(prefixCls, "-disabled"), disabled), className, className));
                // because input don't have directory/webkitdirectory type declaration
                var dirProps = directory ? {
                    directory: 'directory',
                    webkitdirectory: 'webkitdirectory'
                } : {};
                var events = disabled ? {} : {
                    onClick: openFileDialogOnClick ? this.onClick : function() {},
                    onKeyDown: openFileDialogOnClick ? this.onKeyDown : function() {},
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    onDrop: this.onFileDrop,
                    onDragOver: this.onFileDrop,
                    tabIndex: '0'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Tag, (0, $fIrcP.default)({}, events, {
                    className: cls,
                    role: "button",
                    style: style
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("input", (0, $fIrcP.default)({}, (0, $c7e00e8671f36d19$export$2e2bcd8739ae039)(otherProps, {
                    aria: true,
                    data: true
                }), {
                    id: id,
                    disabled: disabled,
                    type: "file",
                    ref: this.saveFileInput,
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    } // https://github.com/ant-design/ant-design/issues/19948
                    ,
                    key: this.state.uid,
                    style: {
                        display: 'none'
                    },
                    accept: accept
                }, dirProps, {
                    multiple: multiple,
                    onChange: this.onChange
                }, capture != null ? {
                    capture: capture
                } : {})), children);
            }
        }
    ]);
    return AjaxUploader;
}((0, $6fFrj.Component));
var $8ed9d8d4a990f9da$export$2e2bcd8739ae039 = $8ed9d8d4a990f9da$var$AjaxUploader;


function $be4199404b526753$var$empty() {}
var $be4199404b526753$var$Upload = /*#__PURE__*/ function(_Component) {
    (0, $bxC2Y.default)(Upload, _Component);
    var _super = (0, $lSufv.default)(Upload);
    function Upload() {
        var _this;
        (0, $kjNeN.default)(this, Upload);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.uploader = void 0;
        _this.saveUploader = function(node) {
            _this.uploader = node;
        };
        return _this;
    }
    (0, $5KQxu.default)(Upload, [
        {
            key: "abort",
            value: function abort(file) {
                this.uploader.abort(file);
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $8ed9d8d4a990f9da$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, this.props, {
                    ref: this.saveUploader
                }));
            }
        }
    ]);
    return Upload;
}((0, $6fFrj.Component));
$be4199404b526753$var$Upload.defaultProps = {
    component: 'span',
    prefixCls: 'rc-upload',
    data: {},
    headers: {},
    name: 'file',
    multipart: false,
    onStart: $be4199404b526753$var$empty,
    onError: $be4199404b526753$var$empty,
    onSuccess: $be4199404b526753$var$empty,
    multiple: false,
    beforeUpload: null,
    customRequest: null,
    withCredentials: false,
    openFileDialogOnClick: true
};
var $be4199404b526753$export$2e2bcd8739ae039 = $be4199404b526753$var$Upload;


var $03b3cc7cba4ce6f9$export$2e2bcd8739ae039 = (0, $be4199404b526753$export$2e2bcd8739ae039);



var $gfhff = parcelRequire("gfhff");

var $6fFrj = parcelRequire("6fFrj");

var $8CZEB = parcelRequire("8CZEB");






var $37xND = parcelRequire("37xND");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $f20d7343bf52b681$var$FileTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "file",
    "theme": "twotone"
};
var $f20d7343bf52b681$export$2e2bcd8739ae039 = $f20d7343bf52b681$var$FileTwoTone;



var $309b6625012ced82$var$FileTwoTone = function FileTwoTone(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $f20d7343bf52b681$export$2e2bcd8739ae039)
    }));
};
var $309b6625012ced82$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($309b6625012ced82$var$FileTwoTone);
var $309b6625012ced82$export$2e2bcd8739ae039 = $309b6625012ced82$var$RefIcon;




var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $871e58c8a5752936$var$PaperClipOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"
                }
            }
        ]
    },
    "name": "paper-clip",
    "theme": "outlined"
};
var $871e58c8a5752936$export$2e2bcd8739ae039 = $871e58c8a5752936$var$PaperClipOutlined;



var $1597dd9bb1148789$var$PaperClipOutlined = function PaperClipOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $871e58c8a5752936$export$2e2bcd8739ae039)
    }));
};
var $1597dd9bb1148789$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($1597dd9bb1148789$var$PaperClipOutlined);
var $1597dd9bb1148789$export$2e2bcd8739ae039 = $1597dd9bb1148789$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $a0ae286ef3d0eebd$var$PictureTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z",
                        "fill": primaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M276 368a28 28 0 1056 0 28 28 0 10-56 0z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "picture",
    "theme": "twotone"
};
var $a0ae286ef3d0eebd$export$2e2bcd8739ae039 = $a0ae286ef3d0eebd$var$PictureTwoTone;



var $ae8c3535cd876a71$var$PictureTwoTone = function PictureTwoTone(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $a0ae286ef3d0eebd$export$2e2bcd8739ae039)
    }));
};
var $ae8c3535cd876a71$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($ae8c3535cd876a71$var$PictureTwoTone);
var $ae8c3535cd876a71$export$2e2bcd8739ae039 = $ae8c3535cd876a71$var$RefIcon;



var $fActo = parcelRequire("fActo");
parcelRequire("5EVeC");
var $2ZBO2 = parcelRequire("2ZBO2");
var $5EVeC = parcelRequire("5EVeC");

var $6fFrj = parcelRequire("6fFrj");






var $37xND = parcelRequire("37xND");

var $fIrcP = parcelRequire("fIrcP");
function $aff3574838d54506$export$6dc848fd109e803d(file) {
    return (0, $fIrcP.default)((0, $fIrcP.default)({}, file), {
        lastModified: file.lastModified,
        lastModifiedDate: file.lastModifiedDate,
        name: file.name,
        size: file.size,
        type: file.type,
        uid: file.uid,
        percent: 0,
        originFileObj: file
    });
}
function $aff3574838d54506$export$65c2063f64290f37(file, fileList) {
    var nextFileList = (0, $37xND.default)(fileList);
    var fileIndex = nextFileList.findIndex(function(_ref) {
        var uid = _ref.uid;
        return uid === file.uid;
    });
    if (fileIndex === -1) nextFileList.push(file);
    else nextFileList[fileIndex] = file;
    return nextFileList;
}
function $aff3574838d54506$export$1165ac073f485fae(file, fileList) {
    var matchKey = file.uid !== undefined ? 'uid' : 'name';
    return fileList.filter(function(item) {
        return item[matchKey] === file[matchKey];
    })[0];
}
function $aff3574838d54506$export$f3bced642db28a96(file, fileList) {
    var matchKey = file.uid !== undefined ? 'uid' : 'name';
    var removed = fileList.filter(function(item) {
        return item[matchKey] !== file[matchKey];
    });
    if (removed.length === fileList.length) return null;
    return removed;
}
// ==================== Default Image Preview ====================
var $aff3574838d54506$var$extname = function extname() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var temp = url.split('/');
    var filename = temp[temp.length - 1];
    var filenameWithoutSuffix = filename.split(/#|\?/)[0];
    return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [
        ''
    ])[0];
};
var $aff3574838d54506$var$isImageFileType = function isImageFileType(type) {
    return type.indexOf('image/') === 0;
};
var $aff3574838d54506$export$431d13c2db3f6781 = function isImageUrl(file) {
    if (file.type && !file.thumbUrl) return $aff3574838d54506$var$isImageFileType(file.type);
    var url = file.thumbUrl || file.url || '';
    var extension = $aff3574838d54506$var$extname(url);
    if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico|heic|heif)$/i.test(extension)) return true;
    if (/^data:/.test(url)) // other file types of base64
    return false;
    if (extension) // other file types which have extension
    return false;
    return true;
};
var $aff3574838d54506$var$MEASURE_SIZE = 200;
function $aff3574838d54506$export$b5db251096956c0d(file) {
    return new Promise(function(resolve) {
        if (!file.type || !$aff3574838d54506$var$isImageFileType(file.type)) {
            resolve('');
            return;
        }
        var canvas = document.createElement('canvas');
        canvas.width = $aff3574838d54506$var$MEASURE_SIZE;
        canvas.height = $aff3574838d54506$var$MEASURE_SIZE;
        canvas.style.cssText = "position: fixed; left: 0; top: 0; width: ".concat($aff3574838d54506$var$MEASURE_SIZE, "px; height: ").concat($aff3574838d54506$var$MEASURE_SIZE, "px; z-index: 9999; display: none;");
        document.body.appendChild(canvas);
        var ctx = canvas.getContext('2d');
        var img = new Image();
        img.onload = function() {
            var width = img.width, height = img.height;
            var drawWidth = $aff3574838d54506$var$MEASURE_SIZE;
            var drawHeight = $aff3574838d54506$var$MEASURE_SIZE;
            var offsetX = 0;
            var offsetY = 0;
            if (width > height) {
                drawHeight = height * ($aff3574838d54506$var$MEASURE_SIZE / width);
                offsetY = -(drawHeight - drawWidth) / 2;
            } else {
                drawWidth = width * ($aff3574838d54506$var$MEASURE_SIZE / height);
                offsetX = -(drawWidth - drawHeight) / 2;
            }
            ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
            var dataURL = canvas.toDataURL();
            document.body.removeChild(canvas);
            window.URL.revokeObjectURL(img.src);
            resolve(dataURL);
        };
        img.crossOrigin = 'anonymous';
        if (file.type.startsWith('image/svg+xml')) {
            var reader = new FileReader();
            reader.onload = function() {
                if (reader.result) img.src = reader.result;
            };
            reader.readAsDataURL(file);
        } else if (file.type.startsWith('image/gif')) {
            var _reader = new FileReader();
            _reader.onload = function() {
                if (_reader.result) resolve(_reader.result);
            };
            _reader.readAsDataURL(file);
        } else img.src = window.URL.createObjectURL(file);
    });
}



var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $e556badc5fa25ca2$var$DeleteOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
                }
            }
        ]
    },
    "name": "delete",
    "theme": "outlined"
};
var $e556badc5fa25ca2$export$2e2bcd8739ae039 = $e556badc5fa25ca2$var$DeleteOutlined;



var $0ccc7a2b4648ccac$var$DeleteOutlined = function DeleteOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $e556badc5fa25ca2$export$2e2bcd8739ae039)
    }));
};
var $0ccc7a2b4648ccac$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($0ccc7a2b4648ccac$var$DeleteOutlined);
var $0ccc7a2b4648ccac$export$2e2bcd8739ae039 = $0ccc7a2b4648ccac$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $143ca52d6523414a$var$DownloadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "download",
    "theme": "outlined"
};
var $143ca52d6523414a$export$2e2bcd8739ae039 = $143ca52d6523414a$var$DownloadOutlined;



var $2a7b50db1abe79fd$var$DownloadOutlined = function DownloadOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $143ca52d6523414a$export$2e2bcd8739ae039)
    }));
};
var $2a7b50db1abe79fd$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($2a7b50db1abe79fd$var$DownloadOutlined);
var $2a7b50db1abe79fd$export$2e2bcd8739ae039 = $2a7b50db1abe79fd$var$RefIcon;




var $fActo = parcelRequire("fActo");

var $5EVeC = parcelRequire("5EVeC");

var $6fFrj = parcelRequire("6fFrj");



var $78ac356a2ee72073$var$ListItem = /*#__PURE__*/ $6fFrj.forwardRef(function(_ref, ref) {
    var prefixCls = _ref.prefixCls, className = _ref.className, style = _ref.style, locale = _ref.locale, listType = _ref.listType, file = _ref.file, items = _ref.items, progressProps = _ref.progress, iconRender = _ref.iconRender, actionIconRender = _ref.actionIconRender, itemRender = _ref.itemRender, isImgUrl = _ref.isImgUrl, showPreviewIcon = _ref.showPreviewIcon, showRemoveIcon = _ref.showRemoveIcon, showDownloadIcon = _ref.showDownloadIcon, customPreviewIcon = _ref.previewIcon, customRemoveIcon = _ref.removeIcon, customDownloadIcon = _ref.downloadIcon, onPreview = _ref.onPreview, onDownload = _ref.onDownload, onClose = _ref.onClose;
    var _a, _b;
    // Status: which will ignore `removed` status
    var status = file.status;
    var _React$useState = $6fFrj.useState(status), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), mergedStatus = _React$useState2[0], setMergedStatus = _React$useState2[1];
    $6fFrj.useEffect(function() {
        if (status !== 'removed') setMergedStatus(status);
    }, [
        status
    ]);
    // Delay to show the progress bar
    var _React$useState3 = $6fFrj.useState(false), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), showProgress = _React$useState4[0], setShowProgress = _React$useState4[1];
    var progressRafRef = $6fFrj.useRef(null);
    $6fFrj.useEffect(function() {
        progressRafRef.current = setTimeout(function() {
            setShowProgress(true);
        }, 300);
        return function() {
            if (progressRafRef.current) clearTimeout(progressRafRef.current);
        };
    }, []);
    // This is used for legacy span make scrollHeight the wrong value.
    // We will force these to be `display: block` with non `picture-card`
    var spanClassName = "".concat(prefixCls, "-span");
    var iconNode = iconRender(file);
    var icon = /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-text-icon")
    }, iconNode);
    if (listType === 'picture' || listType === 'picture-card') {
        if (mergedStatus === 'uploading' || !file.thumbUrl && !file.url) {
            var uploadingClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-list-item-thumbnail"), true), "".concat(prefixCls, "-list-item-file"), mergedStatus !== 'uploading'));
            icon = /*#__PURE__*/ $6fFrj.createElement("div", {
                className: uploadingClassName
            }, iconNode);
        } else {
            var thumbnail = (isImgUrl === null || isImgUrl === void 0 ? void 0 : isImgUrl(file)) ? /*#__PURE__*/ $6fFrj.createElement("img", {
                src: file.thumbUrl || file.url,
                alt: file.name,
                className: "".concat(prefixCls, "-list-item-image"),
                crossOrigin: file.crossOrigin
            }) : iconNode;
            var aClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-list-item-thumbnail"), true), "".concat(prefixCls, "-list-item-file"), isImgUrl && !isImgUrl(file)));
            icon = /*#__PURE__*/ $6fFrj.createElement("a", {
                className: aClassName,
                onClick: function onClick(e) {
                    return onPreview(file, e);
                },
                href: file.url || file.thumbUrl,
                target: "_blank",
                rel: "noopener noreferrer"
            }, thumbnail);
        }
    }
    var infoUploadingClass = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-list-item"), true), "".concat(prefixCls, "-list-item-").concat(mergedStatus), true), "".concat(prefixCls, "-list-item-list-type-").concat(listType), true));
    var linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
    var removeIcon = showRemoveIcon ? actionIconRender((typeof customRemoveIcon === 'function' ? customRemoveIcon(file) : customRemoveIcon) || /*#__PURE__*/ $6fFrj.createElement((0, $0ccc7a2b4648ccac$export$2e2bcd8739ae039), null), function() {
        return onClose(file);
    }, prefixCls, locale.removeFile) : null;
    var downloadIcon = showDownloadIcon && mergedStatus === 'done' ? actionIconRender((typeof customDownloadIcon === 'function' ? customDownloadIcon(file) : customDownloadIcon) || /*#__PURE__*/ $6fFrj.createElement((0, $2a7b50db1abe79fd$export$2e2bcd8739ae039), null), function() {
        return onDownload(file);
    }, prefixCls, locale.downloadFile) : null;
    var downloadOrDelete = listType !== 'picture-card' && /*#__PURE__*/ $6fFrj.createElement("span", {
        key: "download-delete",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-list-item-card-actions"), {
            picture: listType === 'picture'
        })
    }, downloadIcon, removeIcon);
    var listItemNameClass = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-list-item-name"));
    var preview = file.url ? [
        /*#__PURE__*/ $6fFrj.createElement("a", (0, $fIrcP.default)({
            key: "view",
            target: "_blank",
            rel: "noopener noreferrer",
            className: listItemNameClass,
            title: file.name
        }, linkProps, {
            href: file.url,
            onClick: function onClick(e) {
                return onPreview(file, e);
            }
        }), file.name),
        downloadOrDelete
    ] : [
        /*#__PURE__*/ $6fFrj.createElement("span", {
            key: "view",
            className: listItemNameClass,
            onClick: function onClick(e) {
                return onPreview(file, e);
            },
            title: file.name
        }, file.name),
        downloadOrDelete
    ];
    var previewStyle = {
        pointerEvents: 'none',
        opacity: 0.5
    };
    var previewIcon = showPreviewIcon ? /*#__PURE__*/ $6fFrj.createElement("a", {
        href: file.url || file.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        style: file.url || file.thumbUrl ? undefined : previewStyle,
        onClick: function onClick(e) {
            return onPreview(file, e);
        },
        title: locale.previewFile
    }, typeof customPreviewIcon === 'function' ? customPreviewIcon(file) : customPreviewIcon || /*#__PURE__*/ $6fFrj.createElement((0, $eca7e40229c3d459$export$2e2bcd8739ae039), null)) : null;
    var actions = listType === 'picture-card' && mergedStatus !== 'uploading' && /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-list-item-actions")
    }, previewIcon, mergedStatus === 'done' && downloadIcon, removeIcon);
    var message;
    if (file.response && typeof file.response === 'string') message = file.response;
    else message = ((_a = file.error) === null || _a === void 0 ? void 0 : _a.statusText) || ((_b = file.error) === null || _b === void 0 ? void 0 : _b.message) || locale.uploadError;
    var iconAndPreview = /*#__PURE__*/ $6fFrj.createElement("span", {
        className: spanClassName
    }, icon, preview);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls;
    var rootPrefixCls = getPrefixCls();
    var dom = /*#__PURE__*/ $6fFrj.createElement("div", {
        className: infoUploadingClass
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-list-item-info")
    }, iconAndPreview), actions, showProgress && /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), {
        motionName: "".concat(rootPrefixCls, "-fade"),
        visible: mergedStatus === 'uploading',
        motionDeadline: 2000
    }, function(_ref2) {
        var motionClassName = _ref2.className;
        // show loading icon if upload progress listener is disabled
        var loadingProgress = 'percent' in file ? /*#__PURE__*/ $6fFrj.createElement((0, $35ec803a48e00dda$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, progressProps, {
            type: "line",
            percent: file.percent
        })) : null;
        return /*#__PURE__*/ $6fFrj.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-list-item-progress"), motionClassName)
        }, loadingProgress);
    }));
    var listContainerNameClass = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-list-").concat(listType, "-container"), className);
    var item = mergedStatus === 'error' ? /*#__PURE__*/ $6fFrj.createElement((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        title: message,
        getPopupContainer: function getPopupContainer(node) {
            return node.parentNode;
        }
    }, dom) : dom;
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: listContainerNameClass,
        style: style,
        ref: ref
    }, itemRender ? itemRender(item, file, items, {
        download: onDownload.bind(null, file),
        preview: onPreview.bind(null, file),
        remove: onClose.bind(null, file)
    }) : item);
});
var $78ac356a2ee72073$export$2e2bcd8739ae039 = $78ac356a2ee72073$var$ListItem;


var $f93cff41bb7bb7c4$var$listItemMotion = (0, $fIrcP.default)({}, (0, $779588b2444df86c$export$2e2bcd8739ae039));
delete $f93cff41bb7bb7c4$var$listItemMotion.onAppearEnd;
delete $f93cff41bb7bb7c4$var$listItemMotion.onEnterEnd;
delete $f93cff41bb7bb7c4$var$listItemMotion.onLeaveEnd;
var $f93cff41bb7bb7c4$var$InternalUploadList = function InternalUploadList(props, ref) {
    var _props$listType = props.listType, listType = _props$listType === void 0 ? 'text' : _props$listType, _props$previewFile = props.previewFile, previewFile = _props$previewFile === void 0 ? (0, $aff3574838d54506$export$b5db251096956c0d) : _props$previewFile, onPreview = props.onPreview, onDownload = props.onDownload, onRemove = props.onRemove, locale = props.locale, iconRender = props.iconRender, _props$isImageUrl = props.isImageUrl, isImgUrl = _props$isImageUrl === void 0 ? (0, $aff3574838d54506$export$431d13c2db3f6781) : _props$isImageUrl, customizePrefixCls = props.prefixCls, _props$items = props.items, items = _props$items === void 0 ? [] : _props$items, _props$showPreviewIco = props.showPreviewIcon, showPreviewIcon = _props$showPreviewIco === void 0 ? true : _props$showPreviewIco, _props$showRemoveIcon = props.showRemoveIcon, showRemoveIcon = _props$showRemoveIcon === void 0 ? true : _props$showRemoveIcon, _props$showDownloadIc = props.showDownloadIcon, showDownloadIcon = _props$showDownloadIc === void 0 ? false : _props$showDownloadIc, removeIcon = props.removeIcon, previewIcon = props.previewIcon, downloadIcon = props.downloadIcon, _props$progress = props.progress, progress = _props$progress === void 0 ? {
        strokeWidth: 2,
        showInfo: false
    } : _props$progress, appendAction = props.appendAction, _props$appendActionVi = props.appendActionVisible, appendActionVisible = _props$appendActionVi === void 0 ? true : _props$appendActionVi, itemRender = props.itemRender, disabled = props.disabled;
    var forceUpdate = (0, $930b14fa9874af4b$export$2e2bcd8739ae039)();
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), motionAppear = _React$useState2[0], setMotionAppear = _React$useState2[1];
    // ============================= Effect =============================
    $6fFrj.useEffect(function() {
        if (listType !== 'picture' && listType !== 'picture-card') return;
        (items || []).forEach(function(file) {
            if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) return;
            file.thumbUrl = '';
            if (previewFile) previewFile(file.originFileObj).then(function(previewDataUrl) {
                // Need append '' to avoid dead loop
                file.thumbUrl = previewDataUrl || '';
                forceUpdate();
            });
        });
    }, [
        listType,
        items,
        previewFile
    ]);
    $6fFrj.useEffect(function() {
        setMotionAppear(true);
    }, []);
    // ============================= Events =============================
    var onInternalPreview = function onInternalPreview(file, e) {
        if (!onPreview) return;
        e === null || e === void 0 || e.preventDefault();
        return onPreview(file);
    };
    var onInternalDownload = function onInternalDownload(file) {
        if (typeof onDownload === 'function') onDownload(file);
        else if (file.url) window.open(file.url);
    };
    var onInternalClose = function onInternalClose(file) {
        onRemove === null || onRemove === void 0 || onRemove(file);
    };
    var internalIconRender = function internalIconRender(file) {
        if (iconRender) return iconRender(file, listType);
        var isLoading = file.status === 'uploading';
        var fileIcon = isImgUrl && isImgUrl(file) ? /*#__PURE__*/ $6fFrj.createElement((0, $ae8c3535cd876a71$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $6fFrj.createElement((0, $309b6625012ced82$export$2e2bcd8739ae039), null);
        var icon = isLoading ? /*#__PURE__*/ $6fFrj.createElement((0, $3240b41b65b5dac9$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $6fFrj.createElement((0, $1597dd9bb1148789$export$2e2bcd8739ae039), null);
        if (listType === 'picture') icon = isLoading ? /*#__PURE__*/ $6fFrj.createElement((0, $3240b41b65b5dac9$export$2e2bcd8739ae039), null) : fileIcon;
        else if (listType === 'picture-card') icon = isLoading ? locale.uploading : fileIcon;
        return icon;
    };
    var actionIconRender = function actionIconRender(customIcon, callback, prefixCls, title) {
        var btnProps = {
            type: 'text',
            size: 'small',
            title: title,
            disabled: disabled,
            onClick: function onClick(e) {
                callback();
                if ((0, $79365009d9b77ac6$export$a8257692ac88316c)(customIcon) && customIcon.props.onClick) customIcon.props.onClick(e);
            },
            className: "".concat(prefixCls, "-list-item-card-actions-btn")
        };
        if ((0, $79365009d9b77ac6$export$a8257692ac88316c)(customIcon)) {
            var btnIcon = (0, $79365009d9b77ac6$export$e530037191fcd5d7)(customIcon, (0, $fIrcP.default)((0, $fIrcP.default)({}, customIcon.props), {
                onClick: function onClick() {}
            }));
            return /*#__PURE__*/ $6fFrj.createElement((0, $ea0942a2e543872a$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, btnProps, {
                icon: btnIcon
            }));
        }
        return /*#__PURE__*/ $6fFrj.createElement((0, $ea0942a2e543872a$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, btnProps), /*#__PURE__*/ $6fFrj.createElement("span", null, customIcon));
    };
    // ============================== Ref ===============================
    // Test needs
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            handlePreview: onInternalPreview,
            handleDownload: onInternalDownload
        };
    });
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    // ============================= Render =============================
    var prefixCls = getPrefixCls('upload', customizePrefixCls);
    var listClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-list"), true), "".concat(prefixCls, "-list-").concat(listType), true), "".concat(prefixCls, "-list-rtl"), direction === 'rtl'));
    // >>> Motion config
    var motionKeyList = (0, $37xND.default)(items.map(function(file) {
        return {
            key: file.uid,
            file: file
        };
    }));
    var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
    // const transitionName = list.length === 0 ? '' : `${prefixCls}-${animationDirection}`;
    var motionConfig = {
        motionDeadline: 2000,
        motionName: "".concat(prefixCls, "-").concat(animationDirection),
        keys: motionKeyList,
        motionAppear: motionAppear
    };
    if (listType !== 'picture-card') motionConfig = (0, $fIrcP.default)((0, $fIrcP.default)({}, $f93cff41bb7bb7c4$var$listItemMotion), motionConfig);
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: listClassNames
    }, /*#__PURE__*/ $6fFrj.createElement((0, $2ZBO2.default), (0, $fIrcP.default)({}, motionConfig, {
        component: false
    }), function(_ref) {
        var key = _ref.key, file = _ref.file, motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $6fFrj.createElement((0, $78ac356a2ee72073$export$2e2bcd8739ae039), {
            key: key,
            locale: locale,
            prefixCls: prefixCls,
            className: motionClassName,
            style: motionStyle,
            file: file,
            items: items,
            progress: progress,
            listType: listType,
            isImgUrl: isImgUrl,
            showPreviewIcon: showPreviewIcon,
            showRemoveIcon: showRemoveIcon,
            showDownloadIcon: showDownloadIcon,
            removeIcon: removeIcon,
            previewIcon: previewIcon,
            downloadIcon: downloadIcon,
            iconRender: internalIconRender,
            actionIconRender: actionIconRender,
            itemRender: itemRender,
            onPreview: onInternalPreview,
            onDownload: onInternalDownload,
            onClose: onInternalClose
        });
    }), appendAction && /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), (0, $fIrcP.default)({}, motionConfig, {
        visible: appendActionVisible,
        forceRender: true
    }), function(_ref2) {
        var motionClassName = _ref2.className, motionStyle = _ref2.style;
        return (0, $79365009d9b77ac6$export$e530037191fcd5d7)(appendAction, function(oriProps) {
            return {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(oriProps.className, motionClassName),
                style: (0, $fIrcP.default)((0, $fIrcP.default)((0, $fIrcP.default)({}, motionStyle), {
                    // prevent the element has hover css pseudo-class that may cause animation to end prematurely.
                    pointerEvents: motionClassName ? 'none' : undefined
                }), oriProps.style)
            };
        });
    }));
};
var $f93cff41bb7bb7c4$var$UploadList = /*#__PURE__*/ $6fFrj.forwardRef($f93cff41bb7bb7c4$var$InternalUploadList);
var $f93cff41bb7bb7c4$export$2e2bcd8739ae039 = $f93cff41bb7bb7c4$var$UploadList;



var $8d656b340281b85d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8d656b340281b85d$export$8f9bb9ff126b1bf5 = "__LIST_IGNORE_".concat(Date.now(), "__");
var $8d656b340281b85d$var$InternalUpload = function InternalUpload(props, ref) {
    var fileList = props.fileList, defaultFileList = props.defaultFileList, onRemove = props.onRemove, _props$showUploadList = props.showUploadList, showUploadList = _props$showUploadList === void 0 ? true : _props$showUploadList, _props$listType = props.listType, listType = _props$listType === void 0 ? 'text' : _props$listType, onPreview = props.onPreview, onDownload = props.onDownload, onChange = props.onChange, onDrop = props.onDrop, previewFile = props.previewFile, customDisabled = props.disabled, propLocale = props.locale, iconRender = props.iconRender, isImageUrl = props.isImageUrl, progress = props.progress, customizePrefixCls = props.prefixCls, className = props.className, _props$type = props.type, type = _props$type === void 0 ? 'select' : _props$type, children = props.children, style = props.style, itemRender = props.itemRender, maxCount = props.maxCount, _props$data = props.data, data = _props$data === void 0 ? {} : _props$data, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$action = props.action, action = _props$action === void 0 ? '' : _props$action, _props$accept = props.accept, accept = _props$accept === void 0 ? '' : _props$accept, _props$supportServerR = props.supportServerRender, supportServerRender = _props$supportServerR === void 0 ? true : _props$supportServerR;
    // ===================== Disabled =====================
    var disabled = $6fFrj.useContext((0, $3880af76d17f94a3$export$2e2bcd8739ae039));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var _useMergedState = (0, $gfhff.default)(defaultFileList || [], {
        value: fileList,
        postState: function postState(list) {
            return list !== null && list !== void 0 ? list : [];
        }
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), mergedFileList = _useMergedState2[0], setMergedFileList = _useMergedState2[1];
    var _React$useState = $6fFrj.useState('drop'), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), dragState = _React$useState2[0], setDragState = _React$useState2[1];
    var upload = $6fFrj.useRef(null);
    // Control mode will auto fill file uid if not provided
    $6fFrj.useMemo(function() {
        var timestamp = Date.now();
        (fileList || []).forEach(function(file, index) {
            if (!file.uid && !Object.isFrozen(file)) file.uid = "__AUTO__".concat(timestamp, "_").concat(index, "__");
        });
    }, [
        fileList
    ]);
    var onInternalChange = function onInternalChange(file, changedFileList, event) {
        var cloneList = (0, $37xND.default)(changedFileList);
        // Cut to match count
        if (maxCount === 1) cloneList = cloneList.slice(-1);
        else if (maxCount) cloneList = cloneList.slice(0, maxCount);
        // Prevent React18 auto batch since input[upload] trigger process at same time
        // which makes fileList closure problem
        (0, $8CZEB.flushSync)(function() {
            setMergedFileList(cloneList);
        });
        var changeInfo = {
            file: file,
            fileList: cloneList
        };
        if (event) changeInfo.event = event;
        (0, $8CZEB.flushSync)(function() {
            onChange === null || onChange === void 0 || onChange(changeInfo);
        });
    };
    var mergedBeforeUpload = function mergedBeforeUpload(file, fileListArgs) {
        return $8d656b340281b85d$var$__awaiter(void 0, void 0, void 0, /*#__PURE__*/ (0, $1WWLf.default)().mark(function _callee() {
            var beforeUpload, transformFile, parsedFile, result;
            return (0, $1WWLf.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        beforeUpload = props.beforeUpload, transformFile = props.transformFile;
                        parsedFile = file;
                        if (!beforeUpload) {
                            _context.next = 13;
                            break;
                        }
                        _context.next = 5;
                        return beforeUpload(file, fileListArgs);
                    case 5:
                        result = _context.sent;
                        if (!(result === false)) {
                            _context.next = 8;
                            break;
                        }
                        return _context.abrupt("return", false);
                    case 8:
                        // Hack for LIST_IGNORE, we add additional info to remove from the list
                        delete file[$8d656b340281b85d$export$8f9bb9ff126b1bf5];
                        if (!(result === $8d656b340281b85d$export$8f9bb9ff126b1bf5)) {
                            _context.next = 12;
                            break;
                        }
                        Object.defineProperty(file, $8d656b340281b85d$export$8f9bb9ff126b1bf5, {
                            value: true,
                            configurable: true
                        });
                        return _context.abrupt("return", false);
                    case 12:
                        if ((0, $5KhTJ.default)(result) === 'object' && result) parsedFile = result;
                    case 13:
                        if (!transformFile) {
                            _context.next = 17;
                            break;
                        }
                        _context.next = 16;
                        return transformFile(parsedFile);
                    case 16:
                        parsedFile = _context.sent;
                    case 17:
                        return _context.abrupt("return", parsedFile);
                    case 18:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
    };
    var onBatchStart = function onBatchStart(batchFileInfoList) {
        // Skip file which marked as `LIST_IGNORE`, these file will not add to file list
        var filteredFileInfoList = batchFileInfoList.filter(function(info) {
            return !info.file[$8d656b340281b85d$export$8f9bb9ff126b1bf5];
        });
        // Nothing to do since no file need upload
        if (!filteredFileInfoList.length) return;
        var objectFileList = filteredFileInfoList.map(function(info) {
            return (0, $aff3574838d54506$export$6dc848fd109e803d)(info.file);
        });
        // Concat new files with prev files
        var newFileList = (0, $37xND.default)(mergedFileList);
        objectFileList.forEach(function(fileObj) {
            // Replace file if exist
            newFileList = (0, $aff3574838d54506$export$65c2063f64290f37)(fileObj, newFileList);
        });
        objectFileList.forEach(function(fileObj, index) {
            // Repeat trigger `onChange` event for compatible
            var triggerFileObj = fileObj;
            if (!filteredFileInfoList[index].parsedFile) {
                // `beforeUpload` return false
                var originFileObj = fileObj.originFileObj;
                var clone;
                try {
                    clone = new File([
                        originFileObj
                    ], originFileObj.name, {
                        type: originFileObj.type
                    });
                } catch (e) {
                    clone = new Blob([
                        originFileObj
                    ], {
                        type: originFileObj.type
                    });
                    clone.name = originFileObj.name;
                    clone.lastModifiedDate = new Date();
                    clone.lastModified = new Date().getTime();
                }
                clone.uid = fileObj.uid;
                triggerFileObj = clone;
            } else // Inject `uploading` status
            fileObj.status = 'uploading';
            onInternalChange(triggerFileObj, newFileList);
        });
    };
    var onSuccess = function onSuccess(response, file, xhr) {
        try {
            if (typeof response === 'string') response = JSON.parse(response);
        } catch (e) {
        /* do nothing */ }
        // removed
        if (!(0, $aff3574838d54506$export$1165ac073f485fae)(file, mergedFileList)) return;
        var targetItem = (0, $aff3574838d54506$export$6dc848fd109e803d)(file);
        targetItem.status = 'done';
        targetItem.percent = 100;
        targetItem.response = response;
        targetItem.xhr = xhr;
        var nextFileList = (0, $aff3574838d54506$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList);
    };
    var onProgress = function onProgress(e, file) {
        // removed
        if (!(0, $aff3574838d54506$export$1165ac073f485fae)(file, mergedFileList)) return;
        var targetItem = (0, $aff3574838d54506$export$6dc848fd109e803d)(file);
        targetItem.status = 'uploading';
        targetItem.percent = e.percent;
        var nextFileList = (0, $aff3574838d54506$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList, e);
    };
    var onError = function onError(error, response, file) {
        // removed
        if (!(0, $aff3574838d54506$export$1165ac073f485fae)(file, mergedFileList)) return;
        var targetItem = (0, $aff3574838d54506$export$6dc848fd109e803d)(file);
        targetItem.error = error;
        targetItem.response = response;
        targetItem.status = 'error';
        var nextFileList = (0, $aff3574838d54506$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList);
    };
    var handleRemove = function handleRemove(file) {
        var currentFile;
        Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function(ret) {
            var _a;
            // Prevent removing file
            if (ret === false) return;
            var removedFileList = (0, $aff3574838d54506$export$f3bced642db28a96)(file, mergedFileList);
            if (removedFileList) {
                currentFile = (0, $fIrcP.default)((0, $fIrcP.default)({}, file), {
                    status: 'removed'
                });
                mergedFileList === null || mergedFileList === void 0 || mergedFileList.forEach(function(item) {
                    var matchKey = currentFile.uid !== undefined ? 'uid' : 'name';
                    if (item[matchKey] === currentFile[matchKey] && !Object.isFrozen(item)) item.status = 'removed';
                });
                (_a = upload.current) === null || _a === void 0 || _a.abort(currentFile);
                onInternalChange(currentFile, removedFileList);
            }
        });
    };
    var onFileDrop = function onFileDrop(e) {
        setDragState(e.type);
        if (e.type === 'drop') onDrop === null || onDrop === void 0 || onDrop(e);
    };
    // Test needs
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            onBatchStart: onBatchStart,
            onSuccess: onSuccess,
            onProgress: onProgress,
            onError: onError,
            fileList: mergedFileList,
            upload: upload.current
        };
    });
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var prefixCls = getPrefixCls('upload', customizePrefixCls);
    var rcUploadProps = (0, $fIrcP.default)((0, $fIrcP.default)({
        onBatchStart: onBatchStart,
        onError: onError,
        onProgress: onProgress,
        onSuccess: onSuccess
    }, props), {
        data: data,
        multiple: multiple,
        action: action,
        accept: accept,
        supportServerRender: supportServerRender,
        prefixCls: prefixCls,
        disabled: mergedDisabled,
        beforeUpload: mergedBeforeUpload,
        onChange: undefined
    });
    delete rcUploadProps.className;
    delete rcUploadProps.style;
    // Remove id to avoid open by label when trigger is hidden
    // !children: https://github.com/ant-design/ant-design/issues/14298
    // disabled: https://github.com/ant-design/ant-design/issues/16478
    //           https://github.com/ant-design/ant-design/issues/24197
    if (!children || mergedDisabled) delete rcUploadProps.id;
    var renderUploadList = function renderUploadList(button, buttonVisible) {
        return showUploadList ? /*#__PURE__*/ $6fFrj.createElement((0, $d37c6ecde78f75e8$export$2e2bcd8739ae039), {
            componentName: 'Upload',
            defaultLocale: (0, $da4c09bd655d3c55$export$2e2bcd8739ae039).Upload
        }, function(contextLocale) {
            var _ref = typeof showUploadList === 'boolean' ? {} : showUploadList, showRemoveIcon = _ref.showRemoveIcon, showPreviewIcon = _ref.showPreviewIcon, showDownloadIcon = _ref.showDownloadIcon, removeIcon = _ref.removeIcon, previewIcon = _ref.previewIcon, downloadIcon = _ref.downloadIcon;
            return /*#__PURE__*/ $6fFrj.createElement((0, $f93cff41bb7bb7c4$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                listType: listType,
                items: mergedFileList,
                previewFile: previewFile,
                onPreview: onPreview,
                onDownload: onDownload,
                onRemove: handleRemove,
                showRemoveIcon: !mergedDisabled && showRemoveIcon,
                showPreviewIcon: showPreviewIcon,
                showDownloadIcon: showDownloadIcon,
                removeIcon: removeIcon,
                previewIcon: previewIcon,
                downloadIcon: downloadIcon,
                iconRender: iconRender,
                locale: (0, $fIrcP.default)((0, $fIrcP.default)({}, contextLocale), propLocale),
                isImageUrl: isImageUrl,
                progress: progress,
                appendAction: button,
                appendActionVisible: buttonVisible,
                itemRender: itemRender,
                disabled: mergedDisabled
            });
        }) : button;
    };
    if (type === 'drag') {
        var dragCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-drag"), true), "".concat(prefixCls, "-drag-uploading"), mergedFileList.some(function(file) {
            return file.status === 'uploading';
        })), "".concat(prefixCls, "-drag-hover"), dragState === 'dragover'), "".concat(prefixCls, "-disabled"), mergedDisabled), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
        return /*#__PURE__*/ $6fFrj.createElement("span", null, /*#__PURE__*/ $6fFrj.createElement("div", {
            className: dragCls,
            onDrop: onFileDrop,
            onDragOver: onFileDrop,
            onDragLeave: onFileDrop,
            style: style
        }, /*#__PURE__*/ $6fFrj.createElement((0, $03b3cc7cba4ce6f9$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, rcUploadProps, {
            ref: upload,
            className: "".concat(prefixCls, "-btn")
        }), /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-drag-container")
        }, children))), renderUploadList());
    }
    var uploadButtonCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-select"), true), "".concat(prefixCls, "-select-").concat(listType), true), "".concat(prefixCls, "-disabled"), mergedDisabled), "".concat(prefixCls, "-rtl"), direction === 'rtl'));
    var renderUploadButton = function renderUploadButton(uploadButtonStyle) {
        return /*#__PURE__*/ $6fFrj.createElement("div", {
            className: uploadButtonCls,
            style: uploadButtonStyle
        }, /*#__PURE__*/ $6fFrj.createElement((0, $03b3cc7cba4ce6f9$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, rcUploadProps, {
            ref: upload
        })));
    };
    var uploadButton = renderUploadButton(children ? undefined : {
        display: 'none'
    });
    if (listType === 'picture-card') return /*#__PURE__*/ $6fFrj.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-picture-card-wrapper"), className)
    }, renderUploadList(uploadButton, !!children));
    return /*#__PURE__*/ $6fFrj.createElement("span", {
        className: className
    }, uploadButton, renderUploadList());
};
var $8d656b340281b85d$var$Upload = /*#__PURE__*/ $6fFrj.forwardRef($8d656b340281b85d$var$InternalUpload);
var $8d656b340281b85d$export$2e2bcd8739ae039 = $8d656b340281b85d$var$Upload;


var $290954538b1076ee$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $290954538b1076ee$var$Dragger = /*#__PURE__*/ $6fFrj.forwardRef(function(_a, ref) {
    var style = _a.style, height = _a.height, restProps = $290954538b1076ee$var$__rest(_a, [
        "style",
        "height"
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $8d656b340281b85d$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        ref: ref
    }, restProps, {
        type: "drag",
        style: (0, $fIrcP.default)((0, $fIrcP.default)({}, style), {
            height: height
        })
    }));
});
var $290954538b1076ee$export$2e2bcd8739ae039 = $290954538b1076ee$var$Dragger;



var $09e7a312b8c0b52f$var$Upload = (0, $8d656b340281b85d$export$2e2bcd8739ae039);
$09e7a312b8c0b52f$var$Upload.Dragger = (0, $290954538b1076ee$export$2e2bcd8739ae039);
$09e7a312b8c0b52f$var$Upload.LIST_IGNORE = (0, $8d656b340281b85d$export$8f9bb9ff126b1bf5);
var $09e7a312b8c0b52f$export$2e2bcd8739ae039 = $09e7a312b8c0b52f$var$Upload;





var $6fFrj = parcelRequire("6fFrj");

var $22535f243906d5a2$var$__assign = undefined && undefined.__assign || function() {
    $22535f243906d5a2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $22535f243906d5a2$var$__assign.apply(this, arguments);
};
var $22535f243906d5a2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $22535f243906d5a2$var$Button = function(_a) {
    var _b = _a.type, type = _b === void 0 ? 'default' : _b, _c = _a.iconDirection, iconDirection = _c === void 0 ? 'right' : _c, icon = _a.icon, children = _a.children, className = _a.className, rest = $22535f243906d5a2$var$__rest(_a, [
        "type",
        "iconDirection",
        "icon",
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $ea0942a2e543872a$export$2e2bcd8739ae039), $22535f243906d5a2$var$__assign({
        type: type,
        // icon={iconDirection === 'left' && icon}
        className: !children ? "justAnIcon ".concat(className) : className
    }, rest), icon && iconDirection === 'left' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", null, icon), children, icon && iconDirection === 'right' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", null, icon));
};
var $22535f243906d5a2$export$2e2bcd8739ae039 = $22535f243906d5a2$var$Button;


var $8c24ac1f2368b964$export$2e2bcd8739ae039 = (0, $22535f243906d5a2$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");

var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");




var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $5a3f44b456feb45b$var$PlusOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"
                }
            }
        ]
    },
    "name": "plus",
    "theme": "outlined"
};
var $5a3f44b456feb45b$export$2e2bcd8739ae039 = $5a3f44b456feb45b$var$PlusOutlined;



var $dfe3e0e661ee2f16$var$PlusOutlined = function PlusOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $5a3f44b456feb45b$export$2e2bcd8739ae039)
    }));
};
var $dfe3e0e661ee2f16$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($dfe3e0e661ee2f16$var$PlusOutlined);
var $dfe3e0e661ee2f16$export$2e2bcd8739ae039 = $dfe3e0e661ee2f16$var$RefIcon;



var $fActo = parcelRequire("fActo");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $5KhTJ = parcelRequire("5KhTJ");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


var $gfhff = parcelRequire("gfhff");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");

var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $5EVeC = parcelRequire("5EVeC");

var $6fFrj = parcelRequire("6fFrj");
var $91461dd758492e28$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $6fFrj.createContext)(null);



var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");
var $344abaa628a7c181$var$TabPane = /*#__PURE__*/ $6fFrj.forwardRef(function(_ref, ref) {
    var prefixCls = _ref.prefixCls, className = _ref.className, style = _ref.style, id = _ref.id, active = _ref.active, tabKey = _ref.tabKey, children = _ref.children;
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        id: id && "".concat(id, "-panel-").concat(tabKey),
        role: "tabpanel",
        tabIndex: active ? 0 : -1,
        "aria-labelledby": id && "".concat(id, "-tab-").concat(tabKey),
        "aria-hidden": !active,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, active && "".concat(prefixCls, "-active"), className),
        ref: ref
    }, children);
});
var $344abaa628a7c181$export$2e2bcd8739ae039 = $344abaa628a7c181$var$TabPane;


var $0b36b0be1fe5431a$var$_excluded = [
    "key",
    "forceRender",
    "style",
    "className"
];
function $0b36b0be1fe5431a$export$2e2bcd8739ae039(_ref) {
    var id = _ref.id, activeKey = _ref.activeKey, animated = _ref.animated, tabPosition = _ref.tabPosition, destroyInactiveTabPane = _ref.destroyInactiveTabPane;
    var _React$useContext = $6fFrj.useContext((0, $91461dd758492e28$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
    var tabPaneAnimated = animated.tabPane;
    var tabPanePrefixCls = "".concat(prefixCls, "-tabpane");
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-content-holder"))
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-content"), "".concat(prefixCls, "-content-").concat(tabPosition), (0, $43449.default)({}, "".concat(prefixCls, "-content-animated"), tabPaneAnimated))
    }, tabs.map(function(_ref2) {
        var key = _ref2.key, forceRender = _ref2.forceRender, paneStyle = _ref2.style, paneClassName = _ref2.className, restTabProps = (0, $04RxA.default)(_ref2, $0b36b0be1fe5431a$var$_excluded);
        var active = key === activeKey;
        return /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), (0, $fIrcP.default)({
            key: key,
            visible: active,
            forceRender: forceRender,
            removeOnLeave: !!destroyInactiveTabPane,
            leavedClassName: "".concat(tabPanePrefixCls, "-hidden")
        }, animated.tabPaneMotion), function(_ref3, ref) {
            var motionStyle = _ref3.style, motionClassName = _ref3.className;
            return /*#__PURE__*/ $6fFrj.createElement((0, $344abaa628a7c181$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, restTabProps, {
                prefixCls: tabPanePrefixCls,
                id: id,
                tabKey: key,
                animated: tabPaneAnimated,
                active: active,
                style: (0, $kNxFX.default)((0, $kNxFX.default)({}, paneStyle), motionStyle),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(paneClassName, motionClassName),
                ref: ref
            }));
        });
    })));
}




var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $37xND = parcelRequire("37xND");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $fActo = parcelRequire("fActo");


var $2c6ch = parcelRequire("2c6ch");

var $hqic8 = parcelRequire("hqic8");

var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
var $f87304cf38f91ed8$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0
};
function $f87304cf38f91ed8$export$2e2bcd8739ae039(tabs, tabSizes, holderScrollWidth) {
    return (0, $6fFrj.useMemo)(function() {
        var _tabs$;
        var map = new Map();
        var lastOffset = tabSizes.get((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key) || $f87304cf38f91ed8$var$DEFAULT_SIZE;
        var rightOffset = lastOffset.left + lastOffset.width;
        for(var i = 0; i < tabs.length; i += 1){
            var key = tabs[i].key;
            var data = tabSizes.get(key);
            // Reuse last one when not exist yet
            if (!data) {
                var _tabs;
                data = tabSizes.get((_tabs = tabs[i - 1]) === null || _tabs === void 0 ? void 0 : _tabs.key) || $f87304cf38f91ed8$var$DEFAULT_SIZE;
            }
            var entity = map.get(key) || (0, $kNxFX.default)({}, data);
            // Right
            entity.right = rightOffset - entity.left - entity.width;
            // Update entity
            map.set(key, entity);
        }
        return map;
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join('_'),
        tabSizes,
        holderScrollWidth
    ]);
}



var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
function $cd9772050ed41277$export$2e2bcd8739ae039(defaultState, onChange) {
    var stateRef = $6fFrj.useRef(defaultState);
    var _React$useState = $6fFrj.useState({}), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), forceUpdate = _React$useState2[1];
    function setState(updater) {
        var newValue = typeof updater === 'function' ? updater(stateRef.current) : updater;
        if (newValue !== stateRef.current) onChange(newValue, stateRef.current);
        stateRef.current = newValue;
        forceUpdate({});
    }
    return [
        stateRef.current,
        setState
    ];
}



var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
var $43c6f7afbeb2fa7c$var$MIN_SWIPE_DISTANCE = 0.1;
var $43c6f7afbeb2fa7c$var$STOP_SWIPE_DISTANCE = 0.01;
var $43c6f7afbeb2fa7c$var$REFRESH_INTERVAL = 20;
var $43c6f7afbeb2fa7c$var$SPEED_OFF_MULTIPLE = Math.pow(0.995, $43c6f7afbeb2fa7c$var$REFRESH_INTERVAL);
function $43c6f7afbeb2fa7c$export$2e2bcd8739ae039(ref, onOffset) {
    var _useState = (0, $6fFrj.useState)(), _useState2 = (0, $jP8CL.default)(_useState, 2), touchPosition = _useState2[0], setTouchPosition = _useState2[1];
    var _useState3 = (0, $6fFrj.useState)(0), _useState4 = (0, $jP8CL.default)(_useState3, 2), lastTimestamp = _useState4[0], setLastTimestamp = _useState4[1];
    var _useState5 = (0, $6fFrj.useState)(0), _useState6 = (0, $jP8CL.default)(_useState5, 2), lastTimeDiff = _useState6[0], setLastTimeDiff = _useState6[1];
    var _useState7 = (0, $6fFrj.useState)(), _useState8 = (0, $jP8CL.default)(_useState7, 2), lastOffset = _useState8[0], setLastOffset = _useState8[1];
    var motionRef = (0, $6fFrj.useRef)();
    // ========================= Events =========================
    // >>> Touch events
    function onTouchStart(e) {
        var _e$touches$ = e.touches[0], screenX = _e$touches$.screenX, screenY = _e$touches$.screenY;
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        window.clearInterval(motionRef.current);
    }
    function onTouchMove(e) {
        if (!touchPosition) return;
        e.preventDefault();
        var _e$touches$2 = e.touches[0], screenX = _e$touches$2.screenX, screenY = _e$touches$2.screenY;
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        var offsetX = screenX - touchPosition.x;
        var offsetY = screenY - touchPosition.y;
        onOffset(offsetX, offsetY);
        var now = Date.now();
        setLastTimestamp(now);
        setLastTimeDiff(now - lastTimestamp);
        setLastOffset({
            x: offsetX,
            y: offsetY
        });
    }
    function onTouchEnd() {
        if (!touchPosition) return;
        setTouchPosition(null);
        setLastOffset(null);
        // Swipe if needed
        if (lastOffset) {
            var distanceX = lastOffset.x / lastTimeDiff;
            var distanceY = lastOffset.y / lastTimeDiff;
            var absX = Math.abs(distanceX);
            var absY = Math.abs(distanceY);
            // Skip swipe if low distance
            if (Math.max(absX, absY) < $43c6f7afbeb2fa7c$var$MIN_SWIPE_DISTANCE) return;
            var currentX = distanceX;
            var currentY = distanceY;
            motionRef.current = window.setInterval(function() {
                if (Math.abs(currentX) < $43c6f7afbeb2fa7c$var$STOP_SWIPE_DISTANCE && Math.abs(currentY) < $43c6f7afbeb2fa7c$var$STOP_SWIPE_DISTANCE) {
                    window.clearInterval(motionRef.current);
                    return;
                }
                currentX *= $43c6f7afbeb2fa7c$var$SPEED_OFF_MULTIPLE;
                currentY *= $43c6f7afbeb2fa7c$var$SPEED_OFF_MULTIPLE;
                onOffset(currentX * $43c6f7afbeb2fa7c$var$REFRESH_INTERVAL, currentY * $43c6f7afbeb2fa7c$var$REFRESH_INTERVAL);
            }, $43c6f7afbeb2fa7c$var$REFRESH_INTERVAL);
        }
    }
    // >>> Wheel event
    var lastWheelDirectionRef = (0, $6fFrj.useRef)();
    function onWheel(e) {
        var deltaX = e.deltaX, deltaY = e.deltaY;
        // Convert both to x & y since wheel only happened on PC
        var mixed = 0;
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);
        if (absX === absY) mixed = lastWheelDirectionRef.current === 'x' ? deltaX : deltaY;
        else if (absX > absY) {
            mixed = deltaX;
            lastWheelDirectionRef.current = 'x';
        } else {
            mixed = deltaY;
            lastWheelDirectionRef.current = 'y';
        }
        if (onOffset(-mixed, -mixed)) e.preventDefault();
    }
    // ========================= Effect =========================
    var touchEventsRef = (0, $6fFrj.useRef)(null);
    touchEventsRef.current = {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        onWheel: onWheel
    };
    $6fFrj.useEffect(function() {
        function onProxyTouchStart(e) {
            touchEventsRef.current.onTouchStart(e);
        }
        function onProxyTouchMove(e) {
            touchEventsRef.current.onTouchMove(e);
        }
        function onProxyTouchEnd(e) {
            touchEventsRef.current.onTouchEnd(e);
        }
        function onProxyWheel(e) {
            touchEventsRef.current.onWheel(e);
        }
        document.addEventListener('touchmove', onProxyTouchMove, {
            passive: false
        });
        document.addEventListener('touchend', onProxyTouchEnd, {
            passive: false
        });
        // No need to clean up since element removed
        ref.current.addEventListener('touchstart', onProxyTouchStart, {
            passive: false
        });
        ref.current.addEventListener('wheel', onProxyWheel);
        return function() {
            document.removeEventListener('touchmove', onProxyTouchMove);
            document.removeEventListener('touchend', onProxyTouchEnd);
        };
    }, []);
}



var $jP8CL = parcelRequire("jP8CL");

var $dNZA9 = parcelRequire("dNZA9");

var $6fFrj = parcelRequire("6fFrj");
function $e0a15af902182331$export$2e2bcd8739ae039(callback) {
    var _useState = (0, $6fFrj.useState)(0), _useState2 = (0, $jP8CL.default)(_useState, 2), count = _useState2[0], setCount = _useState2[1];
    var effectRef = (0, $6fFrj.useRef)(0);
    var callbackRef = (0, $6fFrj.useRef)();
    callbackRef.current = callback;
    // Trigger on `useLayoutEffect`
    (0, $dNZA9.useLayoutUpdateEffect)(function() {
        var _callbackRef$current;
        (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 || _callbackRef$current.call(callbackRef);
    }, [
        count
    ]);
    // Trigger to update count
    return function() {
        if (effectRef.current !== count) return;
        effectRef.current += 1;
        setCount(effectRef.current);
    };
}
function $e0a15af902182331$export$aefd2a30eb6d999e(defaultState) {
    var batchRef = (0, $6fFrj.useRef)([]);
    var _useState3 = (0, $6fFrj.useState)({}), _useState4 = (0, $jP8CL.default)(_useState3, 2), forceUpdate = _useState4[1];
    var state = (0, $6fFrj.useRef)(typeof defaultState === 'function' ? defaultState() : defaultState);
    var flushUpdate = $e0a15af902182331$export$2e2bcd8739ae039(function() {
        var current = state.current;
        batchRef.current.forEach(function(callback) {
            current = callback(current);
        });
        batchRef.current = [];
        state.current = current;
        forceUpdate({});
    });
    function updater(callback) {
        batchRef.current.push(callback);
        flushUpdate();
    }
    return [
        state.current,
        updater
    ];
}



var $6fFrj = parcelRequire("6fFrj");
var $e923871132025a25$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    right: 0
};
function $e923871132025a25$export$2e2bcd8739ae039(tabOffsets, visibleTabContentValue, transform, tabContentSizeValue, addNodeSizeValue, operationNodeSizeValue, _ref) {
    var tabs = _ref.tabs, tabPosition = _ref.tabPosition, rtl = _ref.rtl;
    var charUnit;
    var position;
    var transformSize;
    if ([
        'top',
        'bottom'
    ].includes(tabPosition)) {
        charUnit = 'width';
        position = rtl ? 'right' : 'left';
        transformSize = Math.abs(transform);
    } else {
        charUnit = 'height';
        position = 'top';
        transformSize = -transform;
    }
    return (0, $6fFrj.useMemo)(function() {
        if (!tabs.length) return [
            0,
            0
        ];
        var len = tabs.length;
        var endIndex = len;
        for(var i = 0; i < len; i += 1){
            var offset = tabOffsets.get(tabs[i].key) || $e923871132025a25$var$DEFAULT_SIZE;
            if (offset[position] + offset[charUnit] > transformSize + visibleTabContentValue) {
                endIndex = i - 1;
                break;
            }
        }
        var startIndex = 0;
        for(var _i = len - 1; _i >= 0; _i -= 1){
            var _offset = tabOffsets.get(tabs[_i].key) || $e923871132025a25$var$DEFAULT_SIZE;
            if (_offset[position] < transformSize) {
                startIndex = _i + 1;
                break;
            }
        }
        return [
            startIndex,
            endIndex
        ];
    }, [
        tabOffsets,
        visibleTabContentValue,
        tabContentSizeValue,
        addNodeSizeValue,
        operationNodeSizeValue,
        transformSize,
        tabPosition,
        tabs.map(function(tab) {
            return tab.key;
        }).join('_'),
        rtl
    ]);
}



/**
 * We trade Map as deps which may change with same value but different ref object.
 * We should make it as hash for deps
 * */ function $4e91ce4e7f19c0cd$export$fac44ee5b035f737(obj) {
    var tgt;
    if (obj instanceof Map) {
        tgt = {};
        obj.forEach(function(v, k) {
            tgt[k] = v;
        });
    } else tgt = obj;
    return JSON.stringify(tgt);
}
var $4e91ce4e7f19c0cd$var$RC_TABS_DOUBLE_QUOTE = 'TABS_DQ';
function $4e91ce4e7f19c0cd$export$c55417729a96230c(key) {
    return String(key).replace(/"/g, $4e91ce4e7f19c0cd$var$RC_TABS_DOUBLE_QUOTE);
}



var $6fFrj = parcelRequire("6fFrj");
function $e7944e82a72190de$var$AddButton(_ref, ref) {
    var prefixCls = _ref.prefixCls, editable = _ref.editable, locale = _ref.locale, style = _ref.style;
    if (!editable || editable.showAdd === false) return null;
    return /*#__PURE__*/ $6fFrj.createElement("button", {
        ref: ref,
        type: "button",
        className: "".concat(prefixCls, "-nav-add"),
        style: style,
        "aria-label": (locale === null || locale === void 0 ? void 0 : locale.addAriaLabel) || 'Add tab',
        onClick: function onClick(event) {
            editable.onEdit('add', {
                event: event
            });
        }
    }, editable.addIcon || '+');
}
var $e7944e82a72190de$export$2e2bcd8739ae039 = /*#__PURE__*/ $6fFrj.forwardRef($e7944e82a72190de$var$AddButton);



var $5KhTJ = parcelRequire("5KhTJ");

var $6fFrj = parcelRequire("6fFrj");
var $af9430cc89aeeda9$var$ExtraContent = /*#__PURE__*/ $6fFrj.forwardRef(function(_ref, ref) {
    var position = _ref.position, prefixCls = _ref.prefixCls, extra = _ref.extra;
    if (!extra) return null;
    var content;
    // Parse extra
    var assertExtra = {};
    if ((0, $5KhTJ.default)(extra) === 'object' && !/*#__PURE__*/ $6fFrj.isValidElement(extra)) assertExtra = extra;
    else assertExtra.right = extra;
    if (position === 'right') content = assertExtra.right;
    if (position === 'left') content = assertExtra.left;
    return content ? /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-extra-content"),
        ref: ref
    }, content) : null;
});
var $af9430cc89aeeda9$export$2e2bcd8739ae039 = $af9430cc89aeeda9$var$ExtraContent;



var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $fActo = parcelRequire("fActo");




var $6fFrj = parcelRequire("6fFrj");

function $a71ed0bc50140e1b$var$OperationNode(_ref, ref) {
    var prefixCls = _ref.prefixCls, id = _ref.id, tabs = _ref.tabs, locale = _ref.locale, mobile = _ref.mobile, _ref$moreIcon = _ref.moreIcon, moreIcon = _ref$moreIcon === void 0 ? 'More' : _ref$moreIcon, moreTransitionName = _ref.moreTransitionName, style = _ref.style, className = _ref.className, editable = _ref.editable, tabBarGutter = _ref.tabBarGutter, rtl = _ref.rtl, removeAriaLabel = _ref.removeAriaLabel, onTabClick = _ref.onTabClick, getPopupContainer = _ref.getPopupContainer, popupClassName = _ref.popupClassName;
    // ======================== Dropdown ========================
    var _useState = (0, $6fFrj.useState)(false), _useState2 = (0, $jP8CL.default)(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    var _useState3 = (0, $6fFrj.useState)(null), _useState4 = (0, $jP8CL.default)(_useState3, 2), selectedKey = _useState4[0], setSelectedKey = _useState4[1];
    var popupId = "".concat(id, "-more-popup");
    var dropdownPrefix = "".concat(prefixCls, "-dropdown");
    var selectedItemId = selectedKey !== null ? "".concat(popupId, "-").concat(selectedKey) : null;
    var dropdownAriaLabel = locale === null || locale === void 0 ? void 0 : locale.dropdownAriaLabel;
    function onRemoveTab(event, key) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit('remove', {
            key: key,
            event: event
        });
    }
    var menu = /*#__PURE__*/ $6fFrj.createElement((0, $7fff6aa471b37d3c$export$2e2bcd8739ae039), {
        onClick: function onClick(_ref2) {
            var key = _ref2.key, domEvent = _ref2.domEvent;
            onTabClick(key, domEvent);
            setOpen(false);
        },
        prefixCls: "".concat(dropdownPrefix, "-menu"),
        id: popupId,
        tabIndex: -1,
        role: "listbox",
        "aria-activedescendant": selectedItemId,
        selectedKeys: [
            selectedKey
        ],
        "aria-label": dropdownAriaLabel !== undefined ? dropdownAriaLabel : 'expanded dropdown'
    }, tabs.map(function(tab) {
        var removable = editable && tab.closable !== false && !tab.disabled;
        return /*#__PURE__*/ $6fFrj.createElement((0, $cfbb4b13af7f52cb$export$2e2bcd8739ae039), {
            key: tab.key,
            id: "".concat(popupId, "-").concat(tab.key),
            role: "option",
            "aria-controls": id && "".concat(id, "-panel-").concat(tab.key),
            disabled: tab.disabled
        }, /*#__PURE__*/ $6fFrj.createElement("span", null, tab.label), removable && /*#__PURE__*/ $6fFrj.createElement("button", {
            type: "button",
            "aria-label": removeAriaLabel || 'remove',
            tabIndex: 0,
            className: "".concat(dropdownPrefix, "-menu-item-remove"),
            onClick: function onClick(e) {
                e.stopPropagation();
                onRemoveTab(e, tab.key);
            }
        }, tab.closeIcon || editable.removeIcon || "\xd7"));
    }));
    function selectOffset(offset) {
        var enabledTabs = tabs.filter(function(tab) {
            return !tab.disabled;
        });
        var selectedIndex = enabledTabs.findIndex(function(tab) {
            return tab.key === selectedKey;
        }) || 0;
        var len = enabledTabs.length;
        for(var i = 0; i < len; i += 1){
            selectedIndex = (selectedIndex + offset + len) % len;
            var tab = enabledTabs[selectedIndex];
            if (!tab.disabled) {
                setSelectedKey(tab.key);
                return;
            }
        }
    }
    function onKeyDown(e) {
        var which = e.which;
        if (!open) {
            if ([
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).DOWN,
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).SPACE,
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER
            ].includes(which)) {
                setOpen(true);
                e.preventDefault();
            }
            return;
        }
        switch(which){
            case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).UP:
                selectOffset(-1);
                e.preventDefault();
                break;
            case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).DOWN:
                selectOffset(1);
                e.preventDefault();
                break;
            case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ESC:
                setOpen(false);
                break;
            case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).SPACE:
            case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER:
                if (selectedKey !== null) onTabClick(selectedKey, e);
                break;
        }
    }
    // ========================= Effect =========================
    (0, $6fFrj.useEffect)(function() {
        // We use query element here to avoid React strict warning
        var ele = document.getElementById(selectedItemId);
        if (ele && ele.scrollIntoView) ele.scrollIntoView(false);
    }, [
        selectedKey
    ]);
    (0, $6fFrj.useEffect)(function() {
        if (!open) setSelectedKey(null);
    }, [
        open
    ]);
    // ========================= Render =========================
    var moreStyle = (0, $43449.default)({}, rtl ? 'marginRight' : 'marginLeft', tabBarGutter);
    if (!tabs.length) {
        moreStyle.visibility = 'hidden';
        moreStyle.order = 1;
    }
    var overlayClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)({}, "".concat(dropdownPrefix, "-rtl"), rtl));
    var moreNode = mobile ? null : /*#__PURE__*/ $6fFrj.createElement((0, $35d13f388ca7de9e$export$2e2bcd8739ae039), {
        prefixCls: dropdownPrefix,
        overlay: menu,
        trigger: [
            'hover'
        ],
        visible: tabs.length ? open : false,
        transitionName: moreTransitionName,
        onVisibleChange: setOpen,
        overlayClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(overlayClassName, popupClassName),
        mouseEnterDelay: 0.1,
        mouseLeaveDelay: 0.1,
        getPopupContainer: getPopupContainer
    }, /*#__PURE__*/ $6fFrj.createElement("button", {
        type: "button",
        className: "".concat(prefixCls, "-nav-more"),
        style: moreStyle,
        tabIndex: -1,
        "aria-hidden": "true",
        "aria-haspopup": "listbox",
        "aria-controls": popupId,
        id: "".concat(id, "-more"),
        "aria-expanded": open,
        onKeyDown: onKeyDown
    }, moreIcon));
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-nav-operations"), className),
        style: style,
        ref: ref
    }, moreNode, /*#__PURE__*/ $6fFrj.createElement((0, $e7944e82a72190de$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        locale: locale,
        editable: editable
    }));
}
var $a71ed0bc50140e1b$export$2e2bcd8739ae039 = /*#__PURE__*/ $6fFrj.memo(/*#__PURE__*/ $6fFrj.forwardRef($a71ed0bc50140e1b$var$OperationNode), function(_, next) {
    return(// https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    next.tabMoving);
});



var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");

function $2464c88a4d3d8902$var$TabNode(_ref) {
    var _classNames;
    var prefixCls = _ref.prefixCls, id = _ref.id, active = _ref.active, _ref$tab = _ref.tab, key = _ref$tab.key, label = _ref$tab.label, disabled = _ref$tab.disabled, closeIcon = _ref$tab.closeIcon, closable = _ref.closable, renderWrapper = _ref.renderWrapper, removeAriaLabel = _ref.removeAriaLabel, editable = _ref.editable, onClick = _ref.onClick, onFocus = _ref.onFocus, style = _ref.style;
    var tabPrefix = "".concat(prefixCls, "-tab");
    var removable = editable && closable !== false && !disabled;
    function onInternalClick(e) {
        if (disabled) return;
        onClick(e);
    }
    function onRemoveTab(event) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit('remove', {
            key: key,
            event: event
        });
    }
    var node = /*#__PURE__*/ $6fFrj.createElement("div", {
        key: key,
        "data-node-key": (0, $4e91ce4e7f19c0cd$export$c55417729a96230c)(key),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(tabPrefix, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(tabPrefix, "-with-remove"), removable), (0, $43449.default)(_classNames, "".concat(tabPrefix, "-active"), active), (0, $43449.default)(_classNames, "".concat(tabPrefix, "-disabled"), disabled), _classNames)),
        style: style,
        onClick: onInternalClick
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        role: "tab",
        "aria-selected": active,
        id: id && "".concat(id, "-tab-").concat(key),
        className: "".concat(tabPrefix, "-btn"),
        "aria-controls": id && "".concat(id, "-panel-").concat(key),
        "aria-disabled": disabled,
        tabIndex: disabled ? null : 0,
        onClick: function onClick(e) {
            e.stopPropagation();
            onInternalClick(e);
        },
        onKeyDown: function onKeyDown(e) {
            if ([
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).SPACE,
                (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER
            ].includes(e.which)) {
                e.preventDefault();
                onInternalClick(e);
            }
        },
        onFocus: onFocus
    }, label), removable && /*#__PURE__*/ $6fFrj.createElement("button", {
        type: "button",
        "aria-label": removeAriaLabel || 'remove',
        tabIndex: 0,
        className: "".concat(tabPrefix, "-remove"),
        onClick: function onClick(e) {
            e.stopPropagation();
            onRemoveTab(e);
        }
    }, closeIcon || editable.removeIcon || "\xd7"));
    return renderWrapper ? renderWrapper(node) : node;
}
var $2464c88a4d3d8902$export$2e2bcd8739ae039 = $2464c88a4d3d8902$var$TabNode;


var $ce0cc0cf7ce64a48$var$getSize = function getSize(refObj) {
    var _ref = refObj.current || {}, _ref$offsetWidth = _ref.offsetWidth, offsetWidth = _ref$offsetWidth === void 0 ? 0 : _ref$offsetWidth, _ref$offsetHeight = _ref.offsetHeight, offsetHeight = _ref$offsetHeight === void 0 ? 0 : _ref$offsetHeight;
    return [
        offsetWidth,
        offsetHeight
    ];
};
/**
 * Convert `SizeInfo` to unit value. Such as [123, 456] with `top` position get `123`
 */ var $ce0cc0cf7ce64a48$var$getUnitValue = function getUnitValue(size, tabPositionTopOrBottom) {
    return size[tabPositionTopOrBottom ? 0 : 1];
};
function $ce0cc0cf7ce64a48$var$TabNavList(props, ref) {
    var _classNames;
    var _React$useContext = $6fFrj.useContext((0, $91461dd758492e28$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
    var className = props.className, style = props.style, id = props.id, animated = props.animated, activeKey = props.activeKey, rtl = props.rtl, extra = props.extra, editable = props.editable, locale = props.locale, tabPosition = props.tabPosition, tabBarGutter = props.tabBarGutter, children = props.children, onTabClick = props.onTabClick, onTabScroll = props.onTabScroll;
    var containerRef = (0, $6fFrj.useRef)();
    var extraLeftRef = (0, $6fFrj.useRef)();
    var extraRightRef = (0, $6fFrj.useRef)();
    var tabsWrapperRef = (0, $6fFrj.useRef)();
    var tabListRef = (0, $6fFrj.useRef)();
    var operationsRef = (0, $6fFrj.useRef)();
    var innerAddButtonRef = (0, $6fFrj.useRef)();
    // const [getBtnRef, removeBtnRef] = useRefs<HTMLDivElement>();
    var tabPositionTopOrBottom = tabPosition === 'top' || tabPosition === 'bottom';
    var _useSyncState = (0, $cd9772050ed41277$export$2e2bcd8739ae039)(0, function(next, prev) {
        if (tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? 'left' : 'right'
        });
    }), _useSyncState2 = (0, $jP8CL.default)(_useSyncState, 2), transformLeft = _useSyncState2[0], setTransformLeft = _useSyncState2[1];
    var _useSyncState3 = (0, $cd9772050ed41277$export$2e2bcd8739ae039)(0, function(next, prev) {
        if (!tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? 'top' : 'bottom'
        });
    }), _useSyncState4 = (0, $jP8CL.default)(_useSyncState3, 2), transformTop = _useSyncState4[0], setTransformTop = _useSyncState4[1];
    var _useState = (0, $6fFrj.useState)([
        0,
        0
    ]), _useState2 = (0, $jP8CL.default)(_useState, 2), containerExcludeExtraSize = _useState2[0], setContainerExcludeExtraSize = _useState2[1];
    var _useState3 = (0, $6fFrj.useState)([
        0,
        0
    ]), _useState4 = (0, $jP8CL.default)(_useState3, 2), tabContentSize = _useState4[0], setTabContentSize = _useState4[1];
    var _useState5 = (0, $6fFrj.useState)([
        0,
        0
    ]), _useState6 = (0, $jP8CL.default)(_useState5, 2), addSize = _useState6[0], setAddSize = _useState6[1];
    var _useState7 = (0, $6fFrj.useState)([
        0,
        0
    ]), _useState8 = (0, $jP8CL.default)(_useState7, 2), operationSize = _useState8[0], setOperationSize = _useState8[1];
    var _useUpdateState = (0, $e0a15af902182331$export$aefd2a30eb6d999e)(new Map()), _useUpdateState2 = (0, $jP8CL.default)(_useUpdateState, 2), tabSizes = _useUpdateState2[0], setTabSizes = _useUpdateState2[1];
    var tabOffsets = (0, $f87304cf38f91ed8$export$2e2bcd8739ae039)(tabs, tabSizes, tabContentSize[0]);
    // ========================== Unit =========================
    var containerExcludeExtraSizeValue = $ce0cc0cf7ce64a48$var$getUnitValue(containerExcludeExtraSize, tabPositionTopOrBottom);
    var tabContentSizeValue = $ce0cc0cf7ce64a48$var$getUnitValue(tabContentSize, tabPositionTopOrBottom);
    var addSizeValue = $ce0cc0cf7ce64a48$var$getUnitValue(addSize, tabPositionTopOrBottom);
    var operationSizeValue = $ce0cc0cf7ce64a48$var$getUnitValue(operationSize, tabPositionTopOrBottom);
    var needScroll = containerExcludeExtraSizeValue < tabContentSizeValue + addSizeValue;
    var visibleTabContentValue = needScroll ? containerExcludeExtraSizeValue - operationSizeValue : containerExcludeExtraSizeValue - addSizeValue;
    // ========================== Util =========================
    var operationsHiddenClassName = "".concat(prefixCls, "-nav-operations-hidden");
    var transformMin = 0;
    var transformMax = 0;
    if (!tabPositionTopOrBottom) {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    } else if (rtl) {
        transformMin = 0;
        transformMax = Math.max(0, tabContentSizeValue - visibleTabContentValue);
    } else {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    }
    function alignInRange(value) {
        if (value < transformMin) return transformMin;
        if (value > transformMax) return transformMax;
        return value;
    }
    // ========================= Mobile ========================
    var touchMovingRef = (0, $6fFrj.useRef)();
    var _useState9 = (0, $6fFrj.useState)(), _useState10 = (0, $jP8CL.default)(_useState9, 2), lockAnimation = _useState10[0], setLockAnimation = _useState10[1];
    function doLockAnimation() {
        setLockAnimation(Date.now());
    }
    function clearTouchMoving() {
        window.clearTimeout(touchMovingRef.current);
    }
    (0, $43c6f7afbeb2fa7c$export$2e2bcd8739ae039)(tabsWrapperRef, function(offsetX, offsetY) {
        function doMove(setState, offset) {
            setState(function(value) {
                var newValue = alignInRange(value + offset);
                return newValue;
            });
        }
        // Skip scroll if place is enough
        if (!needScroll) return false;
        if (tabPositionTopOrBottom) doMove(setTransformLeft, offsetX);
        else doMove(setTransformTop, offsetY);
        clearTouchMoving();
        doLockAnimation();
        return true;
    });
    (0, $6fFrj.useEffect)(function() {
        clearTouchMoving();
        if (lockAnimation) touchMovingRef.current = window.setTimeout(function() {
            setLockAnimation(0);
        }, 100);
        return clearTouchMoving;
    }, [
        lockAnimation
    ]);
    // ===================== Visible Range =====================
    // Render tab node & collect tab offset
    var _useVisibleRange = (0, $e923871132025a25$export$2e2bcd8739ae039)(tabOffsets, // Container
    visibleTabContentValue, // Transform
    tabPositionTopOrBottom ? transformLeft : transformTop, // Tabs
    tabContentSizeValue, // Add
    addSizeValue, // Operation
    operationSizeValue, (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        tabs: tabs
    })), _useVisibleRange2 = (0, $jP8CL.default)(_useVisibleRange, 2), visibleStart = _useVisibleRange2[0], visibleEnd = _useVisibleRange2[1];
    // ========================= Scroll ========================
    var scrollToTab = (0, $2c6ch.default)(function() {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : activeKey;
        var tabOffset = tabOffsets.get(key) || {
            width: 0,
            height: 0,
            left: 0,
            right: 0,
            top: 0
        };
        if (tabPositionTopOrBottom) {
            // ============ Align with top & bottom ============
            var newTransform = transformLeft;
            // RTL
            if (rtl) {
                if (tabOffset.right < transformLeft) newTransform = tabOffset.right;
                else if (tabOffset.right + tabOffset.width > transformLeft + visibleTabContentValue) newTransform = tabOffset.right + tabOffset.width - visibleTabContentValue;
            } else if (tabOffset.left < -transformLeft) newTransform = -tabOffset.left;
            else if (tabOffset.left + tabOffset.width > -transformLeft + visibleTabContentValue) newTransform = -(tabOffset.left + tabOffset.width - visibleTabContentValue);
            setTransformTop(0);
            setTransformLeft(alignInRange(newTransform));
        } else {
            // ============ Align with left & right ============
            var _newTransform = transformTop;
            if (tabOffset.top < -transformTop) _newTransform = -tabOffset.top;
            else if (tabOffset.top + tabOffset.height > -transformTop + visibleTabContentValue) _newTransform = -(tabOffset.top + tabOffset.height - visibleTabContentValue);
            setTransformLeft(0);
            setTransformTop(alignInRange(_newTransform));
        }
    });
    // ========================== Tab ==========================
    var tabNodeStyle = {};
    if (tabPosition === 'top' || tabPosition === 'bottom') tabNodeStyle[rtl ? 'marginRight' : 'marginLeft'] = tabBarGutter;
    else tabNodeStyle.marginTop = tabBarGutter;
    var tabNodes = tabs.map(function(tab, i) {
        var key = tab.key;
        return /*#__PURE__*/ $6fFrj.createElement((0, $2464c88a4d3d8902$export$2e2bcd8739ae039), {
            id: id,
            prefixCls: prefixCls,
            key: key,
            tab: tab,
            style: i === 0 ? undefined : tabNodeStyle,
            closable: tab.closable,
            editable: editable,
            active: key === activeKey,
            renderWrapper: children,
            removeAriaLabel: locale === null || locale === void 0 ? void 0 : locale.removeAriaLabel,
            onClick: function onClick(e) {
                onTabClick(key, e);
            },
            onFocus: function onFocus() {
                scrollToTab(key);
                doLockAnimation();
                if (!tabsWrapperRef.current) return;
                // Focus element will make scrollLeft change which we should reset back
                if (!rtl) tabsWrapperRef.current.scrollLeft = 0;
                tabsWrapperRef.current.scrollTop = 0;
            }
        });
    });
    // Update buttons records
    var updateTabSizes = function updateTabSizes() {
        return setTabSizes(function() {
            var newSizes = new Map();
            tabs.forEach(function(_ref2) {
                var _tabListRef$current;
                var key = _ref2.key;
                var btnNode = (_tabListRef$current = tabListRef.current) === null || _tabListRef$current === void 0 ? void 0 : _tabListRef$current.querySelector("[data-node-key=\"".concat((0, $4e91ce4e7f19c0cd$export$c55417729a96230c)(key), "\"]"));
                if (btnNode) newSizes.set(key, {
                    width: btnNode.offsetWidth,
                    height: btnNode.offsetHeight,
                    left: btnNode.offsetLeft,
                    top: btnNode.offsetTop
                });
            });
            return newSizes;
        });
    };
    (0, $6fFrj.useEffect)(function() {
        updateTabSizes();
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join('_')
    ]);
    var onListHolderResize = (0, $e0a15af902182331$export$2e2bcd8739ae039)(function() {
        // Update wrapper records
        var containerSize = $ce0cc0cf7ce64a48$var$getSize(containerRef);
        var extraLeftSize = $ce0cc0cf7ce64a48$var$getSize(extraLeftRef);
        var extraRightSize = $ce0cc0cf7ce64a48$var$getSize(extraRightRef);
        setContainerExcludeExtraSize([
            containerSize[0] - extraLeftSize[0] - extraRightSize[0],
            containerSize[1] - extraLeftSize[1] - extraRightSize[1]
        ]);
        var newAddSize = $ce0cc0cf7ce64a48$var$getSize(innerAddButtonRef);
        setAddSize(newAddSize);
        var newOperationSize = $ce0cc0cf7ce64a48$var$getSize(operationsRef);
        setOperationSize(newOperationSize);
        // Which includes add button size
        var tabContentFullSize = $ce0cc0cf7ce64a48$var$getSize(tabListRef);
        setTabContentSize([
            tabContentFullSize[0] - newAddSize[0],
            tabContentFullSize[1] - newAddSize[1]
        ]);
        // Update buttons records
        updateTabSizes();
    });
    // ======================== Dropdown =======================
    var startHiddenTabs = tabs.slice(0, visibleStart);
    var endHiddenTabs = tabs.slice(visibleEnd + 1);
    var hiddenTabs = [].concat((0, $37xND.default)(startHiddenTabs), (0, $37xND.default)(endHiddenTabs));
    // =================== Link & Operations ===================
    var _useState11 = (0, $6fFrj.useState)(), _useState12 = (0, $jP8CL.default)(_useState11, 2), inkStyle = _useState12[0], setInkStyle = _useState12[1];
    var activeTabOffset = tabOffsets.get(activeKey);
    // Delay set ink style to avoid remove tab blink
    var inkBarRafRef = (0, $6fFrj.useRef)();
    function cleanInkBarRaf() {
        (0, $hqic8.default).cancel(inkBarRafRef.current);
    }
    (0, $6fFrj.useEffect)(function() {
        var newInkStyle = {};
        if (activeTabOffset) {
            if (tabPositionTopOrBottom) {
                if (rtl) newInkStyle.right = activeTabOffset.right;
                else newInkStyle.left = activeTabOffset.left;
                newInkStyle.width = activeTabOffset.width;
            } else {
                newInkStyle.top = activeTabOffset.top;
                newInkStyle.height = activeTabOffset.height;
            }
        }
        cleanInkBarRaf();
        inkBarRafRef.current = (0, $hqic8.default)(function() {
            setInkStyle(newInkStyle);
        });
        return cleanInkBarRaf;
    }, [
        activeTabOffset,
        tabPositionTopOrBottom,
        rtl
    ]);
    // ========================= Effect ========================
    (0, $6fFrj.useEffect)(function() {
        scrollToTab();
    // eslint-disable-next-line
    }, [
        activeKey,
        transformMin,
        transformMax,
        (0, $4e91ce4e7f19c0cd$export$fac44ee5b035f737)(activeTabOffset),
        (0, $4e91ce4e7f19c0cd$export$fac44ee5b035f737)(tabOffsets),
        tabPositionTopOrBottom
    ]);
    // Should recalculate when rtl changed
    (0, $6fFrj.useEffect)(function() {
        onListHolderResize();
    // eslint-disable-next-line
    }, [
        rtl
    ]);
    // ========================= Render ========================
    var hasDropdown = !!hiddenTabs.length;
    var wrapPrefix = "".concat(prefixCls, "-nav-wrap");
    var pingLeft;
    var pingRight;
    var pingTop;
    var pingBottom;
    if (tabPositionTopOrBottom) {
        if (rtl) {
            pingRight = transformLeft > 0;
            pingLeft = transformLeft !== transformMax;
        } else {
            pingLeft = transformLeft < 0;
            pingRight = transformLeft !== transformMin;
        }
    } else {
        pingTop = transformTop < 0;
        pingBottom = transformTop !== transformMin;
    }
    return /*#__PURE__*/ $6fFrj.createElement((0, $8e6bb008621f90f5$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        ref: (0, $3BOWT.useComposeRef)(ref, containerRef),
        role: "tablist",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-nav"), className),
        style: style,
        onKeyDown: function onKeyDown() {
            // No need animation when use keyboard
            doLockAnimation();
        }
    }, /*#__PURE__*/ $6fFrj.createElement((0, $af9430cc89aeeda9$export$2e2bcd8739ae039), {
        ref: extraLeftRef,
        position: "left",
        extra: extra,
        prefixCls: prefixCls
    }), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(wrapPrefix, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(wrapPrefix, "-ping-left"), pingLeft), (0, $43449.default)(_classNames, "".concat(wrapPrefix, "-ping-right"), pingRight), (0, $43449.default)(_classNames, "".concat(wrapPrefix, "-ping-top"), pingTop), (0, $43449.default)(_classNames, "".concat(wrapPrefix, "-ping-bottom"), pingBottom), _classNames)),
        ref: tabsWrapperRef
    }, /*#__PURE__*/ $6fFrj.createElement((0, $8e6bb008621f90f5$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        ref: tabListRef,
        className: "".concat(prefixCls, "-nav-list"),
        style: {
            transform: "translate(".concat(transformLeft, "px, ").concat(transformTop, "px)"),
            transition: lockAnimation ? 'none' : undefined
        }
    }, tabNodes, /*#__PURE__*/ $6fFrj.createElement((0, $e7944e82a72190de$export$2e2bcd8739ae039), {
        ref: innerAddButtonRef,
        prefixCls: prefixCls,
        locale: locale,
        editable: editable,
        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, tabNodes.length === 0 ? undefined : tabNodeStyle), {}, {
            visibility: hasDropdown ? 'hidden' : null
        })
    }), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-ink-bar"), (0, $43449.default)({}, "".concat(prefixCls, "-ink-bar-animated"), animated.inkBar)),
        style: inkStyle
    })))), /*#__PURE__*/ $6fFrj.createElement((0, $a71ed0bc50140e1b$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
        removeAriaLabel: locale === null || locale === void 0 ? void 0 : locale.removeAriaLabel,
        ref: operationsRef,
        prefixCls: prefixCls,
        tabs: hiddenTabs,
        className: !hasDropdown && operationsHiddenClassName,
        tabMoving: !!lockAnimation
    })), /*#__PURE__*/ $6fFrj.createElement((0, $af9430cc89aeeda9$export$2e2bcd8739ae039), {
        ref: extraRightRef,
        position: "right",
        extra: extra,
        prefixCls: prefixCls
    })));
/* eslint-enable */ }
var $ce0cc0cf7ce64a48$export$2e2bcd8739ae039 = /*#__PURE__*/ $6fFrj.forwardRef($ce0cc0cf7ce64a48$var$TabNavList);




var $c2156da3aec218f7$var$_excluded = [
    "renderTabBar"
], $c2156da3aec218f7$var$_excluded2 = [
    "label",
    "key"
];
function $c2156da3aec218f7$export$2e2bcd8739ae039(_ref) {
    var renderTabBar = _ref.renderTabBar, restProps = (0, $04RxA.default)(_ref, $c2156da3aec218f7$var$_excluded);
    var _React$useContext = $6fFrj.useContext((0, $91461dd758492e28$export$2e2bcd8739ae039)), tabs = _React$useContext.tabs;
    if (renderTabBar) {
        var tabNavBarProps = (0, $kNxFX.default)((0, $kNxFX.default)({}, restProps), {}, {
            // Legacy support. We do not use this actually
            panes: tabs.map(function(_ref2) {
                var label = _ref2.label, key = _ref2.key, restTabProps = (0, $04RxA.default)(_ref2, $c2156da3aec218f7$var$_excluded2);
                return /*#__PURE__*/ $6fFrj.createElement((0, $344abaa628a7c181$export$2e2bcd8739ae039), (0, $fIrcP.default)({
                    tab: label,
                    key: key,
                    tabKey: key
                }, restTabProps));
            })
        });
        return renderTabBar(tabNavBarProps, (0, $ce0cc0cf7ce64a48$export$2e2bcd8739ae039));
    }
    return /*#__PURE__*/ $6fFrj.createElement((0, $ce0cc0cf7ce64a48$export$2e2bcd8739ae039), restProps);
}



var $5KhTJ = parcelRequire("5KhTJ");

var $kNxFX = parcelRequire("kNxFX");
parcelRequire("3mXQ2");
function $48f230ff9334a37e$export$2e2bcd8739ae039() {
    var animated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        inkBar: true,
        tabPane: false
    };
    var mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: false
    };
    else mergedAnimated = (0, $kNxFX.default)({
        inkBar: true
    }, (0, $5KhTJ.default)(animated) === 'object' ? animated : {});
    // Enable tabPane animation if provide motion
    if (mergedAnimated.tabPaneMotion && mergedAnimated.tabPane === undefined) mergedAnimated.tabPane = true;
    if (!mergedAnimated.tabPaneMotion && mergedAnimated.tabPane) mergedAnimated.tabPane = false;
    return mergedAnimated;
}


var $4427dcb923a9106c$var$_excluded = [
    "id",
    "prefixCls",
    "className",
    "items",
    "direction",
    "activeKey",
    "defaultActiveKey",
    "editable",
    "animated",
    "tabPosition",
    "tabBarGutter",
    "tabBarStyle",
    "tabBarExtraContent",
    "locale",
    "moreIcon",
    "moreTransitionName",
    "destroyInactiveTabPane",
    "renderTabBar",
    "onChange",
    "onTabClick",
    "onTabScroll",
    "getPopupContainer",
    "popupClassName"
];
/**
 * Should added antd:
 * - type
 *
 * Removed:
 * - onNextClick
 * - onPrevClick
 * - keyboard
 */ // Used for accessibility
var $4427dcb923a9106c$var$uuid = 0;
function $4427dcb923a9106c$var$Tabs(_ref, ref) {
    var _classNames;
    var id = _ref.id, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? 'rc-tabs' : _ref$prefixCls, className = _ref.className, items = _ref.items, direction = _ref.direction, activeKey = _ref.activeKey, defaultActiveKey = _ref.defaultActiveKey, editable = _ref.editable, animated = _ref.animated, _ref$tabPosition = _ref.tabPosition, tabPosition = _ref$tabPosition === void 0 ? 'top' : _ref$tabPosition, tabBarGutter = _ref.tabBarGutter, tabBarStyle = _ref.tabBarStyle, tabBarExtraContent = _ref.tabBarExtraContent, locale = _ref.locale, moreIcon = _ref.moreIcon, moreTransitionName = _ref.moreTransitionName, destroyInactiveTabPane = _ref.destroyInactiveTabPane, renderTabBar = _ref.renderTabBar, onChange = _ref.onChange, onTabClick = _ref.onTabClick, onTabScroll = _ref.onTabScroll, getPopupContainer = _ref.getPopupContainer, popupClassName = _ref.popupClassName, restProps = (0, $04RxA.default)(_ref, $4427dcb923a9106c$var$_excluded);
    var tabs = $6fFrj.useMemo(function() {
        return (items || []).filter(function(item) {
            return item && (0, $5KhTJ.default)(item) === 'object' && 'key' in item;
        });
    }, [
        items
    ]);
    var rtl = direction === 'rtl';
    var mergedAnimated = (0, $48f230ff9334a37e$export$2e2bcd8739ae039)(animated);
    // ======================== Mobile ========================
    var _useState = (0, $6fFrj.useState)(false), _useState2 = (0, $jP8CL.default)(_useState, 2), mobile = _useState2[0], setMobile = _useState2[1];
    (0, $6fFrj.useEffect)(function() {
        // Only update on the client side
        setMobile((0, $fee6da8402dc892a$export$2e2bcd8739ae039)());
    }, []);
    // ====================== Active Key ======================
    var _useMergedState = (0, $gfhff.default)(function() {
        var _tabs$;
        return (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key;
    }, {
        value: activeKey,
        defaultValue: defaultActiveKey
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), mergedActiveKey = _useMergedState2[0], setMergedActiveKey = _useMergedState2[1];
    var _useState3 = (0, $6fFrj.useState)(function() {
        return tabs.findIndex(function(tab) {
            return tab.key === mergedActiveKey;
        });
    }), _useState4 = (0, $jP8CL.default)(_useState3, 2), activeIndex = _useState4[0], setActiveIndex = _useState4[1];
    // Reset active key if not exist anymore
    (0, $6fFrj.useEffect)(function() {
        var newActiveIndex = tabs.findIndex(function(tab) {
            return tab.key === mergedActiveKey;
        });
        if (newActiveIndex === -1) {
            var _tabs$newActiveIndex;
            newActiveIndex = Math.max(0, Math.min(activeIndex, tabs.length - 1));
            setMergedActiveKey((_tabs$newActiveIndex = tabs[newActiveIndex]) === null || _tabs$newActiveIndex === void 0 ? void 0 : _tabs$newActiveIndex.key);
        }
        setActiveIndex(newActiveIndex);
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join('_'),
        mergedActiveKey,
        activeIndex
    ]);
    // ===================== Accessibility ====================
    var _useMergedState3 = (0, $gfhff.default)(null, {
        value: id
    }), _useMergedState4 = (0, $jP8CL.default)(_useMergedState3, 2), mergedId = _useMergedState4[0], setMergedId = _useMergedState4[1];
    // Async generate id to avoid ssr mapping failed
    (0, $6fFrj.useEffect)(function() {
        if (!id) {
            setMergedId("rc-tabs-".concat($4427dcb923a9106c$var$uuid));
            $4427dcb923a9106c$var$uuid += 1;
        }
    }, []);
    // ======================== Events ========================
    function onInternalTabClick(key, e) {
        onTabClick === null || onTabClick === void 0 || onTabClick(key, e);
        var isActiveChanged = key !== mergedActiveKey;
        setMergedActiveKey(key);
        if (isActiveChanged) onChange === null || onChange === void 0 || onChange(key);
    }
    // ======================== Render ========================
    var sharedProps = {
        id: mergedId,
        activeKey: mergedActiveKey,
        animated: mergedAnimated,
        tabPosition: tabPosition,
        rtl: rtl,
        mobile: mobile
    };
    var tabNavBar;
    var tabNavBarProps = (0, $kNxFX.default)((0, $kNxFX.default)({}, sharedProps), {}, {
        editable: editable,
        locale: locale,
        moreIcon: moreIcon,
        moreTransitionName: moreTransitionName,
        tabBarGutter: tabBarGutter,
        onTabClick: onInternalTabClick,
        onTabScroll: onTabScroll,
        extra: tabBarExtraContent,
        style: tabBarStyle,
        panes: null,
        getPopupContainer: getPopupContainer,
        popupClassName: popupClassName
    });
    return /*#__PURE__*/ $6fFrj.createElement((0, $91461dd758492e28$export$2e2bcd8739ae039).Provider, {
        value: {
            tabs: tabs,
            prefixCls: prefixCls
        }
    }, /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        ref: ref,
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-").concat(tabPosition), (_classNames = {}, (0, $43449.default)(_classNames, "".concat(prefixCls, "-mobile"), mobile), (0, $43449.default)(_classNames, "".concat(prefixCls, "-editable"), editable), (0, $43449.default)(_classNames, "".concat(prefixCls, "-rtl"), rtl), _classNames), className)
    }, restProps), tabNavBar, /*#__PURE__*/ $6fFrj.createElement((0, $c2156da3aec218f7$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, tabNavBarProps, {
        renderTabBar: renderTabBar
    })), /*#__PURE__*/ $6fFrj.createElement((0, $0b36b0be1fe5431a$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        destroyInactiveTabPane: destroyInactiveTabPane
    }, sharedProps, {
        animated: mergedAnimated
    }))));
}
var $4427dcb923a9106c$var$ForwardTabs = /*#__PURE__*/ $6fFrj.forwardRef($4427dcb923a9106c$var$Tabs);
var $4427dcb923a9106c$export$2e2bcd8739ae039 = $4427dcb923a9106c$var$ForwardTabs;


var $73a9af875c0fda1f$export$2e2bcd8739ae039 = (0, $4427dcb923a9106c$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");




var $5KhTJ = parcelRequire("5KhTJ");

var $fIrcP = parcelRequire("fIrcP");

var $133095625763aedc$var$motion = {
    motionAppear: false,
    motionEnter: true,
    motionLeave: true
};
function $133095625763aedc$export$2e2bcd8739ae039(prefixCls) {
    var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        inkBar: true,
        tabPane: false
    };
    var mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: true
    };
    else mergedAnimated = (0, $fIrcP.default)({
        inkBar: true
    }, (0, $5KhTJ.default)(animated) === 'object' ? animated : {});
    if (mergedAnimated.tabPane) mergedAnimated.tabPaneMotion = (0, $fIrcP.default)((0, $fIrcP.default)({}, $133095625763aedc$var$motion), {
        motionName: (0, $779588b2444df86c$export$27c72201b1d09951)(prefixCls, 'switch')
    });
    return mergedAnimated;
}



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");


var $007cabef51eefed1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $007cabef51eefed1$var$filter(items) {
    return items.filter(function(item) {
        return item;
    });
}
function $007cabef51eefed1$export$2e2bcd8739ae039(items, children) {
    if (items) return items;
    var childrenItems = (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(children).map(function(node) {
        if (/*#__PURE__*/ $6fFrj.isValidElement(node)) {
            var key = node.key, props = node.props;
            var _a = props || {}, tab = _a.tab, restProps = $007cabef51eefed1$var$__rest(_a, [
                "tab"
            ]);
            var item = (0, $fIrcP.default)((0, $fIrcP.default)({
                key: String(key)
            }, restProps), {
                label: tab
            });
            return item;
        }
        return null;
    });
    return $007cabef51eefed1$var$filter(childrenItems);
}


var $7deb34c1411a26c5$var$TabPane = function TabPane() {
    return null;
};
var $7deb34c1411a26c5$export$2e2bcd8739ae039 = $7deb34c1411a26c5$var$TabPane;


var $3fe3f92467129298$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $3fe3f92467129298$var$Tabs(_a) {
    var type = _a.type, className = _a.className, propSize = _a.size, _onEdit = _a.onEdit, hideAdd = _a.hideAdd, centered = _a.centered, addIcon = _a.addIcon, children = _a.children, items = _a.items, animated = _a.animated, props = $3fe3f92467129298$var$__rest(_a, [
        "type",
        "className",
        "size",
        "onEdit",
        "hideAdd",
        "centered",
        "addIcon",
        "children",
        "items",
        "animated"
    ]);
    var customizePrefixCls = props.prefixCls, _props$moreIcon = props.moreIcon, moreIcon = _props$moreIcon === void 0 ? /*#__PURE__*/ $6fFrj.createElement((0, $982a9c0f9e1ff223$export$2e2bcd8739ae039), null) : _props$moreIcon;
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, getPopupContainer = _React$useContext.getPopupContainer;
    var prefixCls = getPrefixCls('tabs', customizePrefixCls);
    var editable;
    if (type === 'editable-card') editable = {
        onEdit: function onEdit(editType, _ref) {
            var key = _ref.key, event = _ref.event;
            _onEdit === null || _onEdit === void 0 || _onEdit(editType === 'add' ? event : key, editType);
        },
        removeIcon: /*#__PURE__*/ $6fFrj.createElement((0, $4cb3f1f073816266$export$2e2bcd8739ae039), null),
        addIcon: addIcon || /*#__PURE__*/ $6fFrj.createElement((0, $dfe3e0e661ee2f16$export$2e2bcd8739ae039), null),
        showAdd: hideAdd !== true
    };
    var rootPrefixCls = getPrefixCls();
    var mergedItems = (0, $007cabef51eefed1$export$2e2bcd8739ae039)(items, children);
    var mergedAnimated = (0, $133095625763aedc$export$2e2bcd8739ae039)(prefixCls, animated);
    return /*#__PURE__*/ $6fFrj.createElement((0, $aefad26b74860b7e$export$2e2bcd8739ae039).Consumer, null, function(contextSize) {
        var size = propSize !== undefined ? propSize : contextSize;
        return /*#__PURE__*/ $6fFrj.createElement((0, $73a9af875c0fda1f$export$2e2bcd8739ae039), (0, $fIrcP.default)({
            direction: direction,
            getPopupContainer: getPopupContainer,
            moreTransitionName: "".concat(rootPrefixCls, "-slide-up")
        }, props, {
            items: mergedItems,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-").concat(size), size), "".concat(prefixCls, "-card"), [
                'card',
                'editable-card'
            ].includes(type)), "".concat(prefixCls, "-editable-card"), type === 'editable-card'), "".concat(prefixCls, "-centered"), centered), className),
            editable: editable,
            moreIcon: moreIcon,
            prefixCls: prefixCls,
            animated: mergedAnimated
        }));
    });
}
$3fe3f92467129298$var$Tabs.TabPane = (0, $7deb34c1411a26c5$export$2e2bcd8739ae039);
var $3fe3f92467129298$export$2e2bcd8739ae039 = $3fe3f92467129298$var$Tabs;



var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");

var $2d73334492279a9b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2d73334492279a9b$var$Grid = function Grid(_a) {
    var prefixCls = _a.prefixCls, className = _a.className, _a$hoverable = _a.hoverable, hoverable = _a$hoverable === void 0 ? true : _a$hoverable, props = $2d73334492279a9b$var$__rest(_a, [
        "prefixCls",
        "className",
        "hoverable"
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $1bdb4c3de815e386$export$cd5442f2b8da7663), null, function(_ref) {
        var getPrefixCls = _ref.getPrefixCls;
        var prefix = getPrefixCls('card', prefixCls);
        var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefix, "-grid"), className, (0, $43449.default)({}, "".concat(prefix, "-grid-hoverable"), hoverable));
        return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({}, props, {
            className: classString
        }));
    });
};
var $2d73334492279a9b$export$2e2bcd8739ae039 = $2d73334492279a9b$var$Grid;


var $d0575818043e7285$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $d0575818043e7285$var$getAction(actions) {
    var actionList = actions.map(function(action, index) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $6fFrj.createElement("li", {
            style: {
                width: "".concat(100 / actions.length, "%")
            },
            key: "action-".concat(index)
        }, /*#__PURE__*/ $6fFrj.createElement("span", null, action)));
    });
    return actionList;
}
var $d0575818043e7285$var$Card = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var size = $6fFrj.useContext((0, $aefad26b74860b7e$export$2e2bcd8739ae039));
    var onTabChange = function onTabChange(key) {
        var _a;
        (_a = props.onTabChange) === null || _a === void 0 || _a.call(props, key);
    };
    var isContainGrid = function isContainGrid() {
        var containGrid;
        $6fFrj.Children.forEach(props.children, function(element) {
            if (element && element.type && element.type === (0, $2d73334492279a9b$export$2e2bcd8739ae039)) containGrid = true;
        });
        return containGrid;
    };
    var customizePrefixCls = props.prefixCls, className = props.className, extra = props.extra, _props$headStyle = props.headStyle, headStyle = _props$headStyle === void 0 ? {} : _props$headStyle, _props$bodyStyle = props.bodyStyle, bodyStyle = _props$bodyStyle === void 0 ? {} : _props$bodyStyle, title = props.title, loading = props.loading, _props$bordered = props.bordered, bordered = _props$bordered === void 0 ? true : _props$bordered, customizeSize = props.size, type = props.type, cover = props.cover, actions = props.actions, tabList = props.tabList, children = props.children, activeTabKey = props.activeTabKey, defaultActiveTabKey = props.defaultActiveTabKey, tabBarExtraContent = props.tabBarExtraContent, hoverable = props.hoverable, _props$tabProps = props.tabProps, tabProps = _props$tabProps === void 0 ? {} : _props$tabProps, others = $d0575818043e7285$var$__rest(props, [
        "prefixCls",
        "className",
        "extra",
        "headStyle",
        "bodyStyle",
        "title",
        "loading",
        "bordered",
        "size",
        "type",
        "cover",
        "actions",
        "tabList",
        "children",
        "activeTabKey",
        "defaultActiveTabKey",
        "tabBarExtraContent",
        "hoverable",
        "tabProps"
    ]);
    var prefixCls = getPrefixCls('card', customizePrefixCls);
    var loadingBlock = /*#__PURE__*/ $6fFrj.createElement((0, $6277e5722f665338$export$2e2bcd8739ae039), {
        loading: true,
        active: true,
        paragraph: {
            rows: 4
        },
        title: false
    }, children);
    var hasActiveTabKey = activeTabKey !== undefined;
    var extraProps = (0, $fIrcP.default)((0, $fIrcP.default)({}, tabProps), (0, $43449.default)((0, $43449.default)({}, hasActiveTabKey ? 'activeKey' : 'defaultActiveKey', hasActiveTabKey ? activeTabKey : defaultActiveTabKey), "tabBarExtraContent", tabBarExtraContent));
    var head;
    var tabs = tabList && tabList.length ? /*#__PURE__*/ $6fFrj.createElement((0, $3fe3f92467129298$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        size: "large"
    }, extraProps, {
        className: "".concat(prefixCls, "-head-tabs"),
        onChange: onTabChange,
        items: tabList.map(function(item) {
            var _a;
            return {
                label: item.tab,
                key: item.key,
                disabled: (_a = item.disabled) !== null && _a !== void 0 ? _a : false
            };
        })
    })) : null;
    if (title || extra || tabs) head = /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-head"),
        style: headStyle
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-head-wrapper")
    }, title && /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-head-title")
    }, title), extra && /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-extra")
    }, extra)), tabs);
    var coverDom = cover ? /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-cover")
    }, cover) : null;
    var body = /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-body"),
        style: bodyStyle
    }, loading ? loadingBlock : children);
    var actionDom = actions && actions.length ? /*#__PURE__*/ $6fFrj.createElement("ul", {
        className: "".concat(prefixCls, "-actions")
    }, $d0575818043e7285$var$getAction(actions)) : null;
    var divProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(others, [
        'onTabChange'
    ]);
    var mergedSize = customizeSize || size;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-loading"), loading), "".concat(prefixCls, "-bordered"), bordered), "".concat(prefixCls, "-hoverable"), hoverable), "".concat(prefixCls, "-contain-grid"), isContainGrid()), "".concat(prefixCls, "-contain-tabs"), tabList && tabList.length), "".concat(prefixCls, "-").concat(mergedSize), mergedSize), "".concat(prefixCls, "-type-").concat(type), !!type), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        ref: ref
    }, divProps, {
        className: classString
    }), head, coverDom, body, actionDom);
});
var $d0575818043e7285$export$2e2bcd8739ae039 = $d0575818043e7285$var$Card;




var $fIrcP = parcelRequire("fIrcP");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");

var $f6e4bb86473b20a4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f6e4bb86473b20a4$var$Meta = function Meta(props) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $1bdb4c3de815e386$export$cd5442f2b8da7663), null, function(_ref) {
        var getPrefixCls = _ref.getPrefixCls;
        var customizePrefixCls = props.prefixCls, className = props.className, avatar = props.avatar, title = props.title, description = props.description, others = $f6e4bb86473b20a4$var$__rest(props, [
            "prefixCls",
            "className",
            "avatar",
            "title",
            "description"
        ]);
        var prefixCls = getPrefixCls('card', customizePrefixCls);
        var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-meta"), className);
        var avatarDom = avatar ? /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-meta-avatar")
        }, avatar) : null;
        var titleDom = title ? /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-meta-title")
        }, title) : null;
        var descriptionDom = description ? /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-meta-description")
        }, description) : null;
        var MetaDetail = titleDom || descriptionDom ? /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-meta-detail")
        }, titleDom, descriptionDom) : null;
        return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({}, others, {
            className: classString
        }), avatarDom, MetaDetail);
    });
};
var $f6e4bb86473b20a4$export$2e2bcd8739ae039 = $f6e4bb86473b20a4$var$Meta;


var $08e63124e43c40a7$var$Card = (0, $d0575818043e7285$export$2e2bcd8739ae039);
$08e63124e43c40a7$var$Card.Grid = (0, $2d73334492279a9b$export$2e2bcd8739ae039);
$08e63124e43c40a7$var$Card.Meta = (0, $f6e4bb86473b20a4$export$2e2bcd8739ae039);
var $08e63124e43c40a7$export$2e2bcd8739ae039 = $08e63124e43c40a7$var$Card;


var $342a7f89abe7b8eb$var$__assign = undefined && undefined.__assign || function() {
    $342a7f89abe7b8eb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $342a7f89abe7b8eb$var$__assign.apply(this, arguments);
};
var $342a7f89abe7b8eb$var$Card = function(props) {
    var elevated = props.elevated, className = props.className;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $08e63124e43c40a7$export$2e2bcd8739ae039), $342a7f89abe7b8eb$var$__assign({}, props, {
        className: [
            className,
            elevated && 'elevated'
        ].filter(Boolean).join(' '),
        bordered: false
    }));
};
$342a7f89abe7b8eb$var$Card.Meta = (0, $08e63124e43c40a7$export$2e2bcd8739ae039).Meta;
$342a7f89abe7b8eb$var$Card.Grid = (0, $08e63124e43c40a7$export$2e2bcd8739ae039).Grid;
var $342a7f89abe7b8eb$export$2e2bcd8739ae039 = $342a7f89abe7b8eb$var$Card;


var $5e9046d6437d332e$export$2e2bcd8739ae039 = (0, $342a7f89abe7b8eb$export$2e2bcd8739ae039);



var $37xND = parcelRequire("37xND");

var $fIrcP = parcelRequire("fIrcP");





var $Z1x3o = parcelRequire("Z1x3o");

var $6fFrj = parcelRequire("6fFrj");



var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");





var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");


var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");










var $e372a0cb6dfa5ffb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e372a0cb6dfa5ffb$var$mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
var $e372a0cb6dfa5ffb$var$getClickPosition = function getClickPosition(e) {
    $e372a0cb6dfa5ffb$var$mousePosition = {
        x: e.pageX,
        y: e.pageY
    };
    // 100ms 内发生过点击事件，则从点击位置动画展示
    // 否则直接 zoom 展示
    // 这样可以兼容非点击方式展开
    setTimeout(function() {
        $e372a0cb6dfa5ffb$var$mousePosition = null;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if ((0, $f43587e78228a7cc$export$7dbdadf5e9653129)()) document.documentElement.addEventListener('click', $e372a0cb6dfa5ffb$var$getClickPosition, true);
var $e372a0cb6dfa5ffb$var$Modal = function Modal(props) {
    var _a;
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getContextPopupContainer = _React$useContext.getPopupContainer, getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var handleCancel = function handleCancel(e) {
        var onCancel = props.onCancel;
        onCancel === null || onCancel === void 0 || onCancel(e);
    };
    var handleOk = function handleOk(e) {
        var onOk = props.onOk;
        onOk === null || onOk === void 0 || onOk(e);
    };
    var customizePrefixCls = props.prefixCls, footer = props.footer, visible = props.visible, _props$open = props.open, open = _props$open === void 0 ? false : _props$open, wrapClassName = props.wrapClassName, centered = props.centered, getContainer = props.getContainer, closeIcon = props.closeIcon, _props$focusTriggerAf = props.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, _props$width = props.width, width = _props$width === void 0 ? 520 : _props$width, restProps = $e372a0cb6dfa5ffb$var$__rest(props, [
        "prefixCls",
        "footer",
        "visible",
        "open",
        "wrapClassName",
        "centered",
        "getContainer",
        "closeIcon",
        "focusTriggerAfterClose",
        "width"
    ]);
    var prefixCls = getPrefixCls('modal', customizePrefixCls);
    var rootPrefixCls = getPrefixCls();
    var defaultFooter = /*#__PURE__*/ $6fFrj.createElement((0, $d37c6ecde78f75e8$export$2e2bcd8739ae039), {
        componentName: "Modal",
        defaultLocale: (0, $882906c8305330eb$export$1b6004afda18cd51)()
    }, function(contextLocale) {
        var okText = props.okText, _props$okType = props.okType, okType = _props$okType === void 0 ? 'primary' : _props$okType, cancelText = props.cancelText, _props$confirmLoading = props.confirmLoading, confirmLoading = _props$confirmLoading === void 0 ? false : _props$confirmLoading;
        return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, /*#__PURE__*/ $6fFrj.createElement((0, $ea0942a2e543872a$export$2e2bcd8739ae039), (0, $fIrcP.default)({
            onClick: handleCancel
        }, props.cancelButtonProps), cancelText || contextLocale.cancelText), /*#__PURE__*/ $6fFrj.createElement((0, $ea0942a2e543872a$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, (0, $34c411687886965a$export$19bc9a290855952)(okType), {
            loading: confirmLoading,
            onClick: handleOk
        }, props.okButtonProps), okText !== null && okText !== void 0 ? okText : contextLocale.okText));
    });
    var closeIconToRender = /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(prefixCls, "-close-x")
    }, closeIcon || /*#__PURE__*/ $6fFrj.createElement((0, $4cb3f1f073816266$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-close-icon")
    }));
    var wrapClassNameExtended = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(wrapClassName, (0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-centered"), !!centered), "".concat(prefixCls, "-wrap-rtl"), direction === 'rtl'));
    return /*#__PURE__*/ $6fFrj.createElement((0, $87f4fe035d0a15fd$export$5f56e610a4afb685), null, /*#__PURE__*/ $6fFrj.createElement((0, $76d69cb8326089c6$export$80e4c53cb85dcab1), {
        status: true,
        override: true
    }, /*#__PURE__*/ $6fFrj.createElement((0, $5a2c78a8da70f218$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        width: width
    }, restProps, {
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        wrapClassName: wrapClassNameExtended,
        footer: footer === undefined ? defaultFooter : footer,
        visible: open || visible,
        mousePosition: (_a = restProps.mousePosition) !== null && _a !== void 0 ? _a : $e372a0cb6dfa5ffb$var$mousePosition,
        onClose: handleCancel,
        closeIcon: closeIconToRender,
        focusTriggerAfterClose: focusTriggerAfterClose,
        transitionName: (0, $779588b2444df86c$export$27c72201b1d09951)(rootPrefixCls, 'zoom', props.transitionName),
        maskTransitionName: (0, $779588b2444df86c$export$27c72201b1d09951)(rootPrefixCls, 'fade', props.maskTransitionName)
    }))));
};
var $e372a0cb6dfa5ffb$export$2e2bcd8739ae039 = $e372a0cb6dfa5ffb$var$Modal;


var $02d630c1d662890e$var$ConfirmDialog = function ConfirmDialog(props) {
    var icon = props.icon, onCancel = props.onCancel, onOk = props.onOk, close = props.close, zIndex = props.zIndex, afterClose = props.afterClose, visible = props.visible, open = props.open, keyboard = props.keyboard, centered = props.centered, getContainer = props.getContainer, maskStyle = props.maskStyle, okText = props.okText, okButtonProps = props.okButtonProps, cancelText = props.cancelText, cancelButtonProps = props.cancelButtonProps, direction = props.direction, prefixCls = props.prefixCls, wrapClassName = props.wrapClassName, rootPrefixCls = props.rootPrefixCls, iconPrefixCls = props.iconPrefixCls, bodyStyle = props.bodyStyle, _props$closable = props.closable, closable = _props$closable === void 0 ? false : _props$closable, closeIcon = props.closeIcon, modalRender = props.modalRender, focusTriggerAfterClose = props.focusTriggerAfterClose;
    // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
    var okType = props.okType || 'primary';
    var contentPrefixCls = "".concat(prefixCls, "-confirm");
    // 默认为 true，保持向下兼容
    var okCancel = 'okCancel' in props ? props.okCancel : true;
    var width = props.width || 416;
    var style = props.style || {};
    var mask = props.mask === undefined ? true : props.mask;
    // 默认为 false，保持旧版默认行为
    var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
    var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(props.type), (0, $43449.default)({}, "".concat(contentPrefixCls, "-rtl"), direction === 'rtl'), props.className);
    var cancelButton = okCancel && /*#__PURE__*/ $6fFrj.createElement((0, $78552d1d483c77c7$export$2e2bcd8739ae039), {
        actionFn: onCancel,
        close: close,
        autoFocus: autoFocusButton === 'cancel',
        buttonProps: cancelButtonProps,
        prefixCls: "".concat(rootPrefixCls, "-btn")
    }, cancelText);
    return /*#__PURE__*/ $6fFrj.createElement((0, $f681578438e08b9b$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        direction: direction
    }, /*#__PURE__*/ $6fFrj.createElement((0, $e372a0cb6dfa5ffb$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: classString,
        wrapClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)({}, "".concat(contentPrefixCls, "-centered"), !!props.centered), wrapClassName),
        onCancel: function onCancel() {
            return close === null || close === void 0 ? void 0 : close({
                triggerCancel: true
            });
        },
        open: open || visible,
        title: "",
        footer: "",
        transitionName: (0, $779588b2444df86c$export$27c72201b1d09951)(rootPrefixCls, 'zoom', props.transitionName),
        maskTransitionName: (0, $779588b2444df86c$export$27c72201b1d09951)(rootPrefixCls, 'fade', props.maskTransitionName),
        mask: mask,
        maskClosable: maskClosable,
        maskStyle: maskStyle,
        style: style,
        bodyStyle: bodyStyle,
        width: width,
        zIndex: zIndex,
        afterClose: afterClose,
        keyboard: keyboard,
        centered: centered,
        getContainer: getContainer,
        closable: closable,
        closeIcon: closeIcon,
        modalRender: modalRender,
        focusTriggerAfterClose: focusTriggerAfterClose
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(contentPrefixCls, "-body-wrapper")
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(contentPrefixCls, "-body")
    }, icon, props.title === undefined ? null : /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(contentPrefixCls, "-title")
    }, props.title), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(contentPrefixCls, "-content")
    }, props.content)), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(contentPrefixCls, "-btns")
    }, cancelButton, /*#__PURE__*/ $6fFrj.createElement((0, $78552d1d483c77c7$export$2e2bcd8739ae039), {
        type: okType,
        actionFn: onOk,
        close: close,
        autoFocus: autoFocusButton === 'ok',
        buttonProps: okButtonProps,
        prefixCls: "".concat(rootPrefixCls, "-btn")
    }, okText)))));
};
var $02d630c1d662890e$export$2e2bcd8739ae039 = $02d630c1d662890e$var$ConfirmDialog;


var $44eeb391f01b5fd3$var$destroyFns = [];
var $44eeb391f01b5fd3$export$2e2bcd8739ae039 = $44eeb391f01b5fd3$var$destroyFns;



var $e3c0b5f282171097$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e3c0b5f282171097$var$defaultRootPrefixCls = '';
function $e3c0b5f282171097$var$getRootPrefixCls() {
    return $e3c0b5f282171097$var$defaultRootPrefixCls;
}
function $e3c0b5f282171097$export$2e2bcd8739ae039(config) {
    var container = document.createDocumentFragment();
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    var currentConfig = (0, $fIrcP.default)((0, $fIrcP.default)({}, config), {
        close: close,
        open: true
    });
    var timeoutId;
    function destroy() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var triggerCancel = args.some(function(param) {
            return param && param.triggerCancel;
        });
        if (config.onCancel && triggerCancel) config.onCancel.apply(config, [
            function() {}
        ].concat((0, $37xND.default)(args.slice(1))));
        for(var i = 0; i < (0, $44eeb391f01b5fd3$export$2e2bcd8739ae039).length; i++){
            var fn = (0, $44eeb391f01b5fd3$export$2e2bcd8739ae039)[i];
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            if (fn === close) {
                (0, $44eeb391f01b5fd3$export$2e2bcd8739ae039).splice(i, 1);
                break;
            }
        }
        (0, $Z1x3o.unmount)(container);
    }
    function render(_a) {
        var okText = _a.okText, cancelText = _a.cancelText, customizePrefixCls = _a.prefixCls, props = $e3c0b5f282171097$var$__rest(_a, [
            "okText",
            "cancelText",
            "prefixCls"
        ]);
        clearTimeout(timeoutId);
        /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */ timeoutId = setTimeout(function() {
            var runtimeLocale = (0, $882906c8305330eb$export$1b6004afda18cd51)();
            var _globalConfig = (0, $f681578438e08b9b$export$f9cd1e43211d8a4a)(), getPrefixCls = _globalConfig.getPrefixCls, getIconPrefixCls = _globalConfig.getIconPrefixCls;
            // because Modal.config  set rootPrefixCls, which is different from other components
            var rootPrefixCls = getPrefixCls(undefined, $e3c0b5f282171097$var$getRootPrefixCls());
            var prefixCls = customizePrefixCls || "".concat(rootPrefixCls, "-modal");
            var iconPrefixCls = getIconPrefixCls();
            (0, $Z1x3o.render)(/*#__PURE__*/ $6fFrj.createElement((0, $02d630c1d662890e$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, props, {
                prefixCls: prefixCls,
                rootPrefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                okText: okText || (props.okCancel ? runtimeLocale.okText : runtimeLocale.justOkText),
                cancelText: cancelText || runtimeLocale.cancelText
            })), container);
        });
    }
    function close() {
        var _this = this;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        currentConfig = (0, $fIrcP.default)((0, $fIrcP.default)({}, currentConfig), {
            open: false,
            afterClose: function afterClose() {
                if (typeof config.afterClose === 'function') config.afterClose();
                destroy.apply(_this, args);
            }
        });
        // Legacy support
        if (currentConfig.visible) delete currentConfig.visible;
        render(currentConfig);
    }
    function update(configUpdate) {
        if (typeof configUpdate === 'function') currentConfig = configUpdate(currentConfig);
        else currentConfig = (0, $fIrcP.default)((0, $fIrcP.default)({}, currentConfig), configUpdate);
        render(currentConfig);
    }
    render(currentConfig);
    (0, $44eeb391f01b5fd3$export$2e2bcd8739ae039).push(close);
    return {
        destroy: close,
        update: update
    };
}
function $e3c0b5f282171097$export$503fa8fed137d104(props) {
    return (0, $fIrcP.default)((0, $fIrcP.default)({
        icon: /*#__PURE__*/ $6fFrj.createElement((0, $5a26a3af64ff8e01$export$2e2bcd8739ae039), null),
        okCancel: false
    }, props), {
        type: 'warning'
    });
}
function $e3c0b5f282171097$export$2f728eab0dacbb2e(props) {
    return (0, $fIrcP.default)((0, $fIrcP.default)({
        icon: /*#__PURE__*/ $6fFrj.createElement((0, $60bea5c3f0793107$export$2e2bcd8739ae039), null),
        okCancel: false
    }, props), {
        type: 'info'
    });
}
function $e3c0b5f282171097$export$2b5f8d7f29c805d4(props) {
    return (0, $fIrcP.default)((0, $fIrcP.default)({
        icon: /*#__PURE__*/ $6fFrj.createElement((0, $996a31538a9d5bb4$export$2e2bcd8739ae039), null),
        okCancel: false
    }, props), {
        type: 'success'
    });
}
function $e3c0b5f282171097$export$60e9e0884ce12b55(props) {
    return (0, $fIrcP.default)((0, $fIrcP.default)({
        icon: /*#__PURE__*/ $6fFrj.createElement((0, $83dc1c57eab38fbc$export$2e2bcd8739ae039), null),
        okCancel: false
    }, props), {
        type: 'error'
    });
}
function $e3c0b5f282171097$export$665b64399d4af99c(props) {
    return (0, $fIrcP.default)((0, $fIrcP.default)({
        icon: /*#__PURE__*/ $6fFrj.createElement((0, $5a26a3af64ff8e01$export$2e2bcd8739ae039), null),
        okCancel: true
    }, props), {
        type: 'confirm'
    });
}
function $e3c0b5f282171097$export$ff0b30c638ae2396(_ref) {
    var rootPrefixCls = _ref.rootPrefixCls;
    $e3c0b5f282171097$var$defaultRootPrefixCls = rootPrefixCls;
}





var $37xND = parcelRequire("37xND");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $37xND = parcelRequire("37xND");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
function $ccfb90e202778fe2$export$2e2bcd8739ae039() {
    var _React$useState = $6fFrj.useState([]), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), elements = _React$useState2[0], setElements = _React$useState2[1];
    var patchElement = $6fFrj.useCallback(function(element) {
        // append a new element to elements (and create a new ref)
        setElements(function(originElements) {
            return [].concat((0, $37xND.default)(originElements), [
                element
            ]);
        });
        // return a function that removes the new element out of elements (and create a new ref)
        // it works a little like useEffect
        return function() {
            setElements(function(originElements) {
                return originElements.filter(function(ele) {
                    return ele !== element;
                });
            });
        };
    }, []);
    return [
        elements,
        patchElement
    ];
}




var $fIrcP = parcelRequire("fIrcP");

var $37xND = parcelRequire("37xND");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");




var $7b5669739f88dedf$var$HookModal = function HookModal(_ref, ref) {
    var afterClose = _ref.afterClose, config = _ref.config;
    var _React$useState = $6fFrj.useState(true), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), open = _React$useState2[0], setOpen = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState(config), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), innerConfig = _React$useState4[0], setInnerConfig = _React$useState4[1];
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), direction = _React$useContext.direction, getPrefixCls = _React$useContext.getPrefixCls;
    var prefixCls = getPrefixCls('modal');
    var rootPrefixCls = getPrefixCls();
    var close = function close() {
        setOpen(false);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var triggerCancel = args.some(function(param) {
            return param && param.triggerCancel;
        });
        if (innerConfig.onCancel && triggerCancel) innerConfig.onCancel.apply(innerConfig, [
            function() {}
        ].concat((0, $37xND.default)(args.slice(1))));
    };
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            destroy: close,
            update: function update(newConfig) {
                setInnerConfig(function(originConfig) {
                    return (0, $fIrcP.default)((0, $fIrcP.default)({}, originConfig), newConfig);
                });
            }
        };
    });
    return /*#__PURE__*/ $6fFrj.createElement((0, $d37c6ecde78f75e8$export$2e2bcd8739ae039), {
        componentName: "Modal",
        defaultLocale: (0, $da4c09bd655d3c55$export$2e2bcd8739ae039).Modal
    }, function(contextLocale) {
        return /*#__PURE__*/ $6fFrj.createElement((0, $02d630c1d662890e$export$2e2bcd8739ae039), (0, $fIrcP.default)({
            prefixCls: prefixCls,
            rootPrefixCls: rootPrefixCls
        }, innerConfig, {
            close: close,
            open: open,
            afterClose: afterClose,
            okText: innerConfig.okText || (innerConfig.okCancel ? contextLocale.okText : contextLocale.justOkText),
            direction: direction,
            cancelText: innerConfig.cancelText || contextLocale.cancelText
        }));
    });
};
var $7b5669739f88dedf$export$2e2bcd8739ae039 = /*#__PURE__*/ $6fFrj.forwardRef($7b5669739f88dedf$var$HookModal);


var $7d599c1e62456396$var$uuid = 0;
var $7d599c1e62456396$var$ElementsHolder = /*#__PURE__*/ $6fFrj.memo(/*#__PURE__*/ $6fFrj.forwardRef(function(_props, ref) {
    var _usePatchElement = (0, $ccfb90e202778fe2$export$2e2bcd8739ae039)(), _usePatchElement2 = (0, $jP8CL.default)(_usePatchElement, 2), elements = _usePatchElement2[0], patchElement = _usePatchElement2[1];
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            patchElement: patchElement
        };
    }, []);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, elements);
}));
function $7d599c1e62456396$export$2e2bcd8739ae039() {
    var holderRef = $6fFrj.useRef(null);
    // ========================== Effect ==========================
    var _React$useState = $6fFrj.useState([]), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), actionQueue = _React$useState2[0], setActionQueue = _React$useState2[1];
    $6fFrj.useEffect(function() {
        if (actionQueue.length) {
            var cloneQueue = (0, $37xND.default)(actionQueue);
            cloneQueue.forEach(function(action) {
                action();
            });
            setActionQueue([]);
        }
    }, [
        actionQueue
    ]);
    // =========================== Hook ===========================
    var getConfirmFunc = $6fFrj.useCallback(function(withFunc) {
        return function hookConfirm(config) {
            var _a;
            $7d599c1e62456396$var$uuid += 1;
            var modalRef = /*#__PURE__*/ $6fFrj.createRef();
            var closeFunc;
            var modal = /*#__PURE__*/ $6fFrj.createElement((0, $7b5669739f88dedf$export$2e2bcd8739ae039), {
                key: "modal-".concat($7d599c1e62456396$var$uuid),
                config: withFunc(config),
                ref: modalRef,
                afterClose: function afterClose() {
                    closeFunc === null || closeFunc === void 0 || closeFunc();
                }
            });
            closeFunc = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(modal);
            return {
                destroy: function destroy() {
                    function destroyAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.destroy();
                    }
                    if (modalRef.current) destroyAction();
                    else setActionQueue(function(prev) {
                        return [].concat((0, $37xND.default)(prev), [
                            destroyAction
                        ]);
                    });
                },
                update: function update(newConfig) {
                    function updateAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.update(newConfig);
                    }
                    if (modalRef.current) updateAction();
                    else setActionQueue(function(prev) {
                        return [].concat((0, $37xND.default)(prev), [
                            updateAction
                        ]);
                    });
                }
            };
        };
    }, []);
    var fns = $6fFrj.useMemo(function() {
        return {
            info: getConfirmFunc((0, $e3c0b5f282171097$export$2f728eab0dacbb2e)),
            success: getConfirmFunc((0, $e3c0b5f282171097$export$2b5f8d7f29c805d4)),
            error: getConfirmFunc((0, $e3c0b5f282171097$export$60e9e0884ce12b55)),
            warning: getConfirmFunc((0, $e3c0b5f282171097$export$503fa8fed137d104)),
            confirm: getConfirmFunc((0, $e3c0b5f282171097$export$665b64399d4af99c))
        };
    }, []);
    // eslint-disable-next-line react/jsx-key
    return [
        fns,
        /*#__PURE__*/ $6fFrj.createElement($7d599c1e62456396$var$ElementsHolder, {
            ref: holderRef
        })
    ];
}


function $559174634f1b3871$var$modalWarn(props) {
    return (0, $e3c0b5f282171097$export$2e2bcd8739ae039)((0, $e3c0b5f282171097$export$503fa8fed137d104)(props));
}
var $559174634f1b3871$var$Modal = (0, $e372a0cb6dfa5ffb$export$2e2bcd8739ae039);
$559174634f1b3871$var$Modal.useModal = (0, $7d599c1e62456396$export$2e2bcd8739ae039);
$559174634f1b3871$var$Modal.info = function infoFn(props) {
    return (0, $e3c0b5f282171097$export$2e2bcd8739ae039)((0, $e3c0b5f282171097$export$2f728eab0dacbb2e)(props));
};
$559174634f1b3871$var$Modal.success = function successFn(props) {
    return (0, $e3c0b5f282171097$export$2e2bcd8739ae039)((0, $e3c0b5f282171097$export$2b5f8d7f29c805d4)(props));
};
$559174634f1b3871$var$Modal.error = function errorFn(props) {
    return (0, $e3c0b5f282171097$export$2e2bcd8739ae039)((0, $e3c0b5f282171097$export$60e9e0884ce12b55)(props));
};
$559174634f1b3871$var$Modal.warning = $559174634f1b3871$var$modalWarn;
$559174634f1b3871$var$Modal.warn = $559174634f1b3871$var$modalWarn;
$559174634f1b3871$var$Modal.confirm = function confirmFn(props) {
    return (0, $e3c0b5f282171097$export$2e2bcd8739ae039)((0, $e3c0b5f282171097$export$665b64399d4af99c)(props));
};
$559174634f1b3871$var$Modal.destroyAll = function destroyAllFn() {
    while((0, $44eeb391f01b5fd3$export$2e2bcd8739ae039).length){
        var close = (0, $44eeb391f01b5fd3$export$2e2bcd8739ae039).pop();
        if (close) close();
    }
};
$559174634f1b3871$var$Modal.config = (0, $e3c0b5f282171097$export$ff0b30c638ae2396);
var $559174634f1b3871$export$2e2bcd8739ae039 = $559174634f1b3871$var$Modal;




var $6fFrj = parcelRequire("6fFrj");
var $2f822ed00829f0e5$var$__assign = undefined && undefined.__assign || function() {
    $2f822ed00829f0e5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2f822ed00829f0e5$var$__assign.apply(this, arguments);
};
var $2f822ed00829f0e5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2f822ed00829f0e5$var$antConfirm = (0, $559174634f1b3871$export$2e2bcd8739ae039).confirm;
var $2f822ed00829f0e5$var$Modal = function(_a) {
    var _b = _a.type, type = _b === void 0 ? 'default' : _b, title = _a.title, prefix = _a.prefix, className = _a.className, smallTitle = _a.smallTitle, children = _a.children, rest = $2f822ed00829f0e5$var$__rest(_a, [
        "type",
        "title",
        "prefix",
        "className",
        "smallTitle",
        "children"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $559174634f1b3871$export$2e2bcd8739ae039), $2f822ed00829f0e5$var$__assign({}, rest, {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", null, prefix, title),
        className: [
            className,
            "modal-type-".concat(type),
            smallTitle && 'small-title'
        ].filter(Boolean).join(' ')
    }), children);
};
$2f822ed00829f0e5$var$Modal.confirm = $2f822ed00829f0e5$var$antConfirm;
var $2f822ed00829f0e5$export$2e2bcd8739ae039 = $2f822ed00829f0e5$var$Modal;


var $6db0040c215ed6e9$export$2e2bcd8739ae039 = (0, $2f822ed00829f0e5$export$2e2bcd8739ae039);
var $6db0040c215ed6e9$export$341c47594849c7de = (0, $559174634f1b3871$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");
parcelRequire("5KhTJ");

var $6fFrj = parcelRequire("6fFrj");


var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $5KhTJ = parcelRequire("5KhTJ");

var $jP8CL = parcelRequire("jP8CL");


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $08217b5a6b88ce2f$var$CopyOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    },
    "name": "copy",
    "theme": "outlined"
};
var $08217b5a6b88ce2f$export$2e2bcd8739ae039 = $08217b5a6b88ce2f$var$CopyOutlined;



var $c038d55eb32ecd6b$var$CopyOutlined = function CopyOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $08217b5a6b88ce2f$export$2e2bcd8739ae039)
    }));
};
var $c038d55eb32ecd6b$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($c038d55eb32ecd6b$var$CopyOutlined);
var $c038d55eb32ecd6b$export$2e2bcd8739ae039 = $c038d55eb32ecd6b$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $022be52d373c4c58$var$EditOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    },
    "name": "edit",
    "theme": "outlined"
};
var $022be52d373c4c58$export$2e2bcd8739ae039 = $022be52d373c4c58$var$EditOutlined;



var $88348658f25c3b04$var$EditOutlined = function EditOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $022be52d373c4c58$export$2e2bcd8739ae039)
    }));
};
var $88348658f25c3b04$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($88348658f25c3b04$var$EditOutlined);
var $88348658f25c3b04$export$2e2bcd8739ae039 = $88348658f25c3b04$var$RefIcon;



var $fActo = parcelRequire("fActo");
var $9d6f8dce2baa1c27$exports = {};
"use strict";
var $cb6399cab4e1f179$exports = {};
$cb6399cab4e1f179$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $9d6f8dce2baa1c27$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $9d6f8dce2baa1c27$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $9d6f8dce2baa1c27$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $9d6f8dce2baa1c27$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $cb6399cab4e1f179$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $9d6f8dce2baa1c27$var$clipboardToIE11Formatting[options.format] || $9d6f8dce2baa1c27$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $9d6f8dce2baa1c27$var$format("message" in options ? options.message : $9d6f8dce2baa1c27$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$9d6f8dce2baa1c27$exports = $9d6f8dce2baa1c27$var$copy;





var $dNZA9 = parcelRequire("dNZA9");

var $gfhff = parcelRequire("gfhff");


var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");






var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $50a785685fac9508$var$EnterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "enter",
    "theme": "outlined"
};
var $50a785685fac9508$export$2e2bcd8739ae039 = $50a785685fac9508$var$EnterOutlined;



var $c3f50770a5fa5707$var$EnterOutlined = function EnterOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $50a785685fac9508$export$2e2bcd8739ae039)
    }));
};
var $c3f50770a5fa5707$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($c3f50770a5fa5707$var$EnterOutlined);
var $c3f50770a5fa5707$export$2e2bcd8739ae039 = $c3f50770a5fa5707$var$RefIcon;



var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");

var $5KhTJ = parcelRequire("5KhTJ");

var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $37xND = parcelRequire("37xND");

var $fActo = parcelRequire("fActo");

var $fIrcP = parcelRequire("fIrcP");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $5KhTJ = parcelRequire("5KhTJ");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");


var $dNZA9 = parcelRequire("dNZA9");

var $hqic8 = parcelRequire("hqic8");

var $gfhff = parcelRequire("gfhff");

var $fActo = parcelRequire("fActo");
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ var $3a0219d36c42c54f$var$HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n  pointer-events: none !important;\n";
var $3a0219d36c42c54f$var$SIZING_STYLE = [
    'letter-spacing',
    'line-height',
    'padding-top',
    'padding-bottom',
    'font-family',
    'font-weight',
    'font-size',
    'font-variant',
    'text-rendering',
    'text-transform',
    'width',
    'text-indent',
    'padding-left',
    'padding-right',
    'border-width',
    'box-sizing',
    'word-break'
];
var $3a0219d36c42c54f$var$computedStyleCache = {};
var $3a0219d36c42c54f$var$hiddenTextarea;
function $3a0219d36c42c54f$export$1a56dc6a39385a18(node) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
    if (useCache && $3a0219d36c42c54f$var$computedStyleCache[nodeRef]) return $3a0219d36c42c54f$var$computedStyleCache[nodeRef];
    var style = window.getComputedStyle(node);
    var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
    var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
    var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
    var sizingStyle = $3a0219d36c42c54f$var$SIZING_STYLE.map(function(name) {
        return "".concat(name, ":").concat(style.getPropertyValue(name));
    }).join(';');
    var nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) $3a0219d36c42c54f$var$computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}
function $3a0219d36c42c54f$export$2e2bcd8739ae039(uiTextNode) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (!$3a0219d36c42c54f$var$hiddenTextarea) {
        $3a0219d36c42c54f$var$hiddenTextarea = document.createElement('textarea');
        $3a0219d36c42c54f$var$hiddenTextarea.setAttribute('tab-index', '-1');
        $3a0219d36c42c54f$var$hiddenTextarea.setAttribute('aria-hidden', 'true');
        document.body.appendChild($3a0219d36c42c54f$var$hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute('wrap')) $3a0219d36c42c54f$var$hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
    else $3a0219d36c42c54f$var$hiddenTextarea.removeAttribute('wrap');
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    var _calculateNodeStyling = $3a0219d36c42c54f$export$1a56dc6a39385a18(uiTextNode, useCache), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, sizingStyle = _calculateNodeStyling.sizingStyle;
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    $3a0219d36c42c54f$var$hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat($3a0219d36c42c54f$var$HIDDEN_TEXTAREA_STYLE));
    $3a0219d36c42c54f$var$hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
    var minHeight = undefined;
    var maxHeight = undefined;
    var overflowY;
    var height = $3a0219d36c42c54f$var$hiddenTextarea.scrollHeight;
    if (boxSizing === 'border-box') // border-box: add border, since height = content + padding + border
    height += borderSize;
    else if (boxSizing === 'content-box') // remove padding, since height = content
    height -= paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        $3a0219d36c42c54f$var$hiddenTextarea.value = ' ';
        var singleRowHeight = $3a0219d36c42c54f$var$hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === 'border-box') minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === 'border-box') maxHeight = maxHeight + paddingSize + borderSize;
            overflowY = height > maxHeight ? '' : 'hidden';
            height = Math.min(maxHeight, height);
        }
    }
    var style = {
        height: height,
        overflowY: overflowY,
        resize: 'none'
    };
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    return style;
}


var $ced99a0e0f09e874$var$_excluded = [
    "prefixCls",
    "onPressEnter",
    "defaultValue",
    "value",
    "autoSize",
    "onResize",
    "className",
    "style",
    "disabled",
    "onChange",
    "onInternalAutoSize"
];
var $ced99a0e0f09e874$var$RESIZE_START = 0;
var $ced99a0e0f09e874$var$RESIZE_MEASURING = 1;
var $ced99a0e0f09e874$var$RESIZE_STABLE = 2;
var $ced99a0e0f09e874$var$ResizableTextArea = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-textarea' : _props$prefixCls, onPressEnter = props.onPressEnter, defaultValue = props.defaultValue, value = props.value, autoSize = props.autoSize, onResize = props.onResize, className = props.className, style = props.style, disabled = props.disabled, onChange = props.onChange, onInternalAutoSize = props.onInternalAutoSize, restProps = (0, $04RxA.default)(props, $ced99a0e0f09e874$var$_excluded);
    // =============================== Value ================================
    var _useMergedState = (0, $gfhff.default)(defaultValue, {
        value: value,
        postState: function postState(val) {
            return val !== null && val !== void 0 ? val : '';
        }
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), mergedValue = _useMergedState2[0], setMergedValue = _useMergedState2[1];
    var onInternalChange = function onInternalChange(event) {
        setMergedValue(event.target.value);
        onChange === null || onChange === void 0 || onChange(event);
    };
    // ================================ Ref =================================
    var textareaRef = $6fFrj.useRef();
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            textArea: textareaRef.current
        };
    });
    // ============================== AutoSize ==============================
    var _React$useMemo = $6fFrj.useMemo(function() {
        if (autoSize && (0, $5KhTJ.default)(autoSize) === 'object') return [
            autoSize.minRows,
            autoSize.maxRows
        ];
        return [];
    }, [
        autoSize
    ]), _React$useMemo2 = (0, $jP8CL.default)(_React$useMemo, 2), minRows = _React$useMemo2[0], maxRows = _React$useMemo2[1];
    var needAutoSize = !!autoSize;
    // =============================== Scroll ===============================
    // https://github.com/ant-design/ant-design/issues/21870
    var fixFirefoxAutoScroll = function fixFirefoxAutoScroll() {
        try {
            // FF has bug with jump of scroll to top. We force back here.
            if (document.activeElement === textareaRef.current) {
                var _textareaRef$current = textareaRef.current, selectionStart = _textareaRef$current.selectionStart, selectionEnd = _textareaRef$current.selectionEnd, scrollTop = _textareaRef$current.scrollTop;
                // Fix Safari bug which not rollback when break line
                // This makes Chinese IME can't input. Do not fix this
                // const { value: tmpValue } = textareaRef.current;
                // textareaRef.current.value = '';
                // textareaRef.current.value = tmpValue;
                textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
                textareaRef.current.scrollTop = scrollTop;
            }
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    };
    // =============================== Resize ===============================
    var _React$useState = $6fFrj.useState($ced99a0e0f09e874$var$RESIZE_STABLE), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), resizeState = _React$useState2[0], setResizeState = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState(), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), autoSizeStyle = _React$useState4[0], setAutoSizeStyle = _React$useState4[1];
    var startResize = function startResize() {
        setResizeState($ced99a0e0f09e874$var$RESIZE_START);
    };
    // Change to trigger resize measure
    (0, $dNZA9.default)(function() {
        if (needAutoSize) startResize();
    }, [
        value,
        minRows,
        maxRows,
        needAutoSize
    ]);
    (0, $dNZA9.default)(function() {
        if (resizeState === $ced99a0e0f09e874$var$RESIZE_START) setResizeState($ced99a0e0f09e874$var$RESIZE_MEASURING);
        else if (resizeState === $ced99a0e0f09e874$var$RESIZE_MEASURING) {
            var textareaStyles = (0, $3a0219d36c42c54f$export$2e2bcd8739ae039)(textareaRef.current, false, minRows, maxRows);
            // Safari has bug that text will keep break line on text cut when it's prev is break line.
            // ZombieJ: This not often happen. So we just skip it.
            // const { selectionStart, selectionEnd, scrollTop } = textareaRef.current;
            // const { value: tmpValue } = textareaRef.current;
            // textareaRef.current.value = '';
            // textareaRef.current.value = tmpValue;
            // if (document.activeElement === textareaRef.current) {
            //   textareaRef.current.scrollTop = scrollTop;
            //   textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
            // }
            setResizeState($ced99a0e0f09e874$var$RESIZE_STABLE);
            setAutoSizeStyle(textareaStyles);
        } else fixFirefoxAutoScroll();
    }, [
        resizeState
    ]);
    // We lock resize trigger by raf to avoid Safari warning
    var resizeRafRef = $6fFrj.useRef();
    var cleanRaf = function cleanRaf() {
        (0, $hqic8.default).cancel(resizeRafRef.current);
    };
    var onInternalResize = function onInternalResize(size) {
        if (resizeState === $ced99a0e0f09e874$var$RESIZE_STABLE) {
            onResize === null || onResize === void 0 || onResize(size);
            if (autoSize) {
                cleanRaf();
                resizeRafRef.current = (0, $hqic8.default)(function() {
                    startResize();
                });
            }
        }
    };
    $6fFrj.useEffect(function() {
        return cleanRaf;
    }, []);
    // =============================== Render ===============================
    var mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
    var mergedStyle = (0, $kNxFX.default)((0, $kNxFX.default)({}, style), mergedAutoSizeStyle);
    if (resizeState === $ced99a0e0f09e874$var$RESIZE_START || resizeState === $ced99a0e0f09e874$var$RESIZE_MEASURING) {
        mergedStyle.overflowY = 'hidden';
        mergedStyle.overflowX = 'hidden';
    }
    return /*#__PURE__*/ $6fFrj.createElement((0, $8e6bb008621f90f5$export$2e2bcd8739ae039), {
        onResize: onInternalResize,
        disabled: !(autoSize || onResize)
    }, /*#__PURE__*/ $6fFrj.createElement("textarea", (0, $fIrcP.default)({}, restProps, {
        ref: textareaRef,
        style: mergedStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className, (0, $43449.default)({}, "".concat(prefixCls, "-disabled"), disabled)),
        disabled: disabled,
        value: mergedValue,
        onChange: onInternalChange
    })));
});
var $ced99a0e0f09e874$export$2e2bcd8739ae039 = $ced99a0e0f09e874$var$ResizableTextArea;


var $647b24291807edf2$var$TextArea = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(TextArea, _React$Component);
    var _super = (0, $lSufv.default)(TextArea);
    function TextArea(props) {
        var _this;
        (0, $kjNeN.default)(this, TextArea);
        _this = _super.call(this, props);
        _this.resizableTextArea = void 0;
        _this.focus = function() {
            _this.resizableTextArea.textArea.focus();
        };
        _this.saveTextArea = function(resizableTextArea) {
            _this.resizableTextArea = resizableTextArea;
        };
        _this.handleChange = function(e) {
            var onChange = _this.props.onChange;
            _this.setValue(e.target.value);
            if (onChange) onChange(e);
        };
        _this.handleKeyDown = function(e) {
            var _this$props = _this.props, onPressEnter = _this$props.onPressEnter, onKeyDown = _this$props.onKeyDown;
            if (e.keyCode === 13 && onPressEnter) onPressEnter(e);
            if (onKeyDown) onKeyDown(e);
        };
        var value = typeof props.value === 'undefined' || props.value === null ? props.defaultValue : props.value;
        _this.state = {
            value: value
        };
        return _this;
    }
    (0, $5KQxu.default)(TextArea, [
        {
            key: "setValue",
            value: function setValue(value, callback) {
                if (!('value' in this.props)) this.setState({
                    value: value
                }, callback);
            }
        },
        {
            key: "blur",
            value: function blur() {
                this.resizableTextArea.textArea.blur();
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $6fFrj.createElement((0, $ced99a0e0f09e874$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, this.props, {
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    ref: this.saveTextArea
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps) {
                if ('value' in nextProps) return {
                    value: nextProps.value
                };
                return null;
            }
        }
    ]);
    return TextArea;
}($6fFrj.Component);
var $647b24291807edf2$export$2e2bcd8739ae039 = $647b24291807edf2$var$TextArea;



var $gfhff = parcelRequire("gfhff");


var $6fFrj = parcelRequire("6fFrj");






var $43449 = parcelRequire("43449");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $82HU4 = parcelRequire("82HU4");

var $jbuPt = parcelRequire("jbuPt");

var $744q1 = parcelRequire("744q1");

var $bxC2Y = parcelRequire("bxC2Y");


var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");




function $06d5ccf8f414c56b$var$_callSuper(t, o, e) {
    return o = (0, $744q1.default)(o), (0, $82HU4.default)(t, (0, $jbuPt.default)() ? Reflect.construct(o, e || [], (0, $744q1.default)(t).constructor) : o.apply(t, e));
}
var $06d5ccf8f414c56b$var$ClearableInputType = (0, $cacd97b96801cebe$export$65e3907585753458)('text', 'input');
function $06d5ccf8f414c56b$var$hasAddon(props) {
    return !!(props.addonBefore || props.addonAfter);
}
var $06d5ccf8f414c56b$var$ClearableLabeledInput = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(ClearableLabeledInput, _React$Component);
    function ClearableLabeledInput() {
        (0, $kjNeN.default)(this, ClearableLabeledInput);
        return $06d5ccf8f414c56b$var$_callSuper(this, ClearableLabeledInput, arguments);
    }
    (0, $5KQxu.default)(ClearableLabeledInput, [
        {
            key: "renderClearIcon",
            value: function renderClearIcon(prefixCls) {
                var _this$props = this.props, value = _this$props.value, disabled = _this$props.disabled, readOnly = _this$props.readOnly, handleReset = _this$props.handleReset, suffix = _this$props.suffix;
                var needClear = !disabled && !readOnly && value;
                var className = "".concat(prefixCls, "-clear-icon");
                return /*#__PURE__*/ $6fFrj.createElement((0, $9429a61ddf5bc264$export$2e2bcd8739ae039), {
                    onClick: handleReset,
                    // Do not trigger onBlur when clear input
                    // https://github.com/ant-design/ant-design/issues/31200
                    onMouseDown: function onMouseDown(e) {
                        return e.preventDefault();
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)({}, "".concat(className, "-hidden"), !needClear), "".concat(className, "-has-suffix"), !!suffix), className),
                    role: "button"
                });
            }
        },
        {
            key: "renderTextAreaWithClearIcon",
            value: function renderTextAreaWithClearIcon(prefixCls, element, statusContext) {
                var _this$props2 = this.props, value = _this$props2.value, allowClear = _this$props2.allowClear, className = _this$props2.className, focused = _this$props2.focused, style = _this$props2.style, direction = _this$props2.direction, bordered = _this$props2.bordered, hidden = _this$props2.hidden, customStatus = _this$props2.status;
                var contextStatus = statusContext.status, hasFeedback = statusContext.hasFeedback;
                if (!allowClear) return (0, $79365009d9b77ac6$export$e530037191fcd5d7)(element, {
                    value: value
                });
                var affixWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-affix-wrapper"), "".concat(prefixCls, "-affix-wrapper-textarea-with-clear-btn"), (0, $d372c831fd1c9007$export$b08e7b47149942a2)("".concat(prefixCls, "-affix-wrapper"), (0, $d372c831fd1c9007$export$314e193082d7ba49)(contextStatus, customStatus), hasFeedback), (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-affix-wrapper-focused"), focused), "".concat(prefixCls, "-affix-wrapper-rtl"), direction === 'rtl'), "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), "".concat(className), !$06d5ccf8f414c56b$var$hasAddon(this.props) && className));
                return /*#__PURE__*/ $6fFrj.createElement("span", {
                    className: affixWrapperCls,
                    style: style,
                    hidden: hidden
                }, (0, $79365009d9b77ac6$export$e530037191fcd5d7)(element, {
                    style: null,
                    value: value
                }), this.renderClearIcon(prefixCls));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return /*#__PURE__*/ $6fFrj.createElement((0, $76d69cb8326089c6$export$bbb5553c6c7a14ed).Consumer, null, function(statusContext) {
                    var _this$props3 = _this.props, prefixCls = _this$props3.prefixCls, inputType = _this$props3.inputType, element = _this$props3.element;
                    if (inputType === $06d5ccf8f414c56b$var$ClearableInputType[0]) return _this.renderTextAreaWithClearIcon(prefixCls, element, statusContext);
                });
            }
        }
    ]);
    return ClearableLabeledInput;
}($6fFrj.Component);
var $06d5ccf8f414c56b$export$2e2bcd8739ae039 = $06d5ccf8f414c56b$var$ClearableLabeledInput;



var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $5KhTJ = parcelRequire("5KhTJ");


var $fActo = parcelRequire("fActo");

var $43449 = parcelRequire("43449");

var $5KhTJ = parcelRequire("5KhTJ");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");
function $a016049cb8bbd60e$export$ae6255aa850a31d1(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function $a016049cb8bbd60e$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
function $a016049cb8bbd60e$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    var event = e;
    if (e.type === 'click') {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        var currentTarget = target.cloneNode(true); // click clear icon
        event = Object.create(e, {
            target: {
                value: currentTarget
            },
            currentTarget: {
                value: currentTarget
            }
        });
        currentTarget.value = '';
        onChange(event);
        return;
    } // Trigger by composition event, this means we need force change the input value
    if (targetValue !== undefined) {
        event = Object.create(e, {
            target: {
                value: target
            },
            currentTarget: {
                value: target
            }
        });
        target.value = targetValue;
        onChange(event);
        return;
    }
    onChange(event);
}
function $a016049cb8bbd60e$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option); // Selection content
    var _ref = option || {}, cursor = _ref.cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}
function $a016049cb8bbd60e$export$ef94f7f24276a29c(value) {
    if (typeof value === 'undefined' || value === null) return '';
    return String(value);
}


var $296c7da8bddb9c26$var$BaseInput = function BaseInput(props) {
    var inputElement = props.inputElement, prefixCls = props.prefixCls, prefix = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className = props.className, style = props.style, affixWrapperClassName = props.affixWrapperClassName, groupClassName = props.groupClassName, wrapperClassName = props.wrapperClassName, disabled = props.disabled, readOnly = props.readOnly, focused = props.focused, triggerFocus = props.triggerFocus, allowClear = props.allowClear, value = props.value, handleReset = props.handleReset, hidden = props.hidden;
    var containerRef = (0, $6fFrj.useRef)(null);
    var onInputClick = function onInputClick(e) {
        var _containerRef$current;
        if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target)) triggerFocus === null || triggerFocus === void 0 || triggerFocus();
    }; // ================== Clear Icon ================== //
    var getClearIcon = function getClearIcon() {
        var _classNames;
        if (!allowClear) return null;
        var needClear = !disabled && !readOnly && value;
        var clearIconCls = "".concat(prefixCls, "-clear-icon");
        var iconNode = (0, $5KhTJ.default)(allowClear) === 'object' && allowClear !== null && allowClear !== void 0 && allowClear.clearIcon ? allowClear.clearIcon : "\u2716";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
            onClick: handleReset // Do not trigger onBlur when clear input
            ,
            onMouseDown: function onMouseDown(e) {
                return e.preventDefault();
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(clearIconCls, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(clearIconCls, "-hidden"), !needClear), (0, $43449.default)(_classNames, "".concat(clearIconCls, "-has-suffix"), !!suffix), _classNames)),
            role: "button",
            tabIndex: -1
        }, iconNode);
    };
    var element = /*#__PURE__*/ (0, $6fFrj.cloneElement)(inputElement, {
        value: value,
        hidden: hidden
    }); // ================== Prefix & Suffix ================== //
    if ((0, $a016049cb8bbd60e$export$a19010aeeaa0c7a)(props)) {
        var _classNames2;
        var affixWrapperPrefixCls = "".concat(prefixCls, "-affix-wrapper");
        var affixWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(affixWrapperPrefixCls, (_classNames2 = {}, (0, $43449.default)(_classNames2, "".concat(affixWrapperPrefixCls, "-disabled"), disabled), (0, $43449.default)(_classNames2, "".concat(affixWrapperPrefixCls, "-focused"), focused), (0, $43449.default)(_classNames2, "".concat(affixWrapperPrefixCls, "-readonly"), readOnly), (0, $43449.default)(_classNames2, "".concat(affixWrapperPrefixCls, "-input-with-clear-btn"), suffix && allowClear && value), _classNames2), !(0, $a016049cb8bbd60e$export$ae6255aa850a31d1)(props) && className, affixWrapperClassName);
        var suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
            className: "".concat(prefixCls, "-suffix")
        }, getClearIcon(), suffix);
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
            className: affixWrapperCls,
            style: style,
            hidden: !(0, $a016049cb8bbd60e$export$ae6255aa850a31d1)(props) && hidden,
            onClick: onInputClick,
            ref: containerRef
        }, prefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
            className: "".concat(prefixCls, "-prefix")
        }, prefix), /*#__PURE__*/ (0, $6fFrj.cloneElement)(inputElement, {
            style: null,
            value: value,
            hidden: null
        }), suffixNode);
    } // ================== Addon ================== //
    if ((0, $a016049cb8bbd60e$export$ae6255aa850a31d1)(props)) {
        var wrapperCls = "".concat(prefixCls, "-group");
        var addonCls = "".concat(wrapperCls, "-addon");
        var mergedWrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-wrapper"), wrapperCls, wrapperClassName);
        var mergedGroupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-group-wrapper"), className, groupClassName); // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
            className: mergedGroupClassName,
            style: style,
            hidden: hidden
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
            className: addonCls
        }, addonBefore), /*#__PURE__*/ (0, $6fFrj.cloneElement)(element, {
            style: null,
            hidden: null
        }), addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
            className: addonCls
        }, addonAfter)));
    }
    return element;
};
var $296c7da8bddb9c26$export$2e2bcd8739ae039 = $296c7da8bddb9c26$var$BaseInput;



var $5KhTJ = parcelRequire("5KhTJ");

var $37xND = parcelRequire("37xND");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");




var $fActo = parcelRequire("fActo");

var $gfhff = parcelRequire("gfhff");
var $156b8338c55c426f$var$_excluded = [
    "autoComplete",
    "onChange",
    "onFocus",
    "onBlur",
    "onPressEnter",
    "onKeyDown",
    "prefixCls",
    "disabled",
    "htmlSize",
    "className",
    "maxLength",
    "suffix",
    "showCount",
    "type",
    "inputClassName"
];
var $156b8338c55c426f$var$Input = /*#__PURE__*/ (0, $6fFrj.forwardRef)(function(props, ref) {
    var autoComplete = props.autoComplete, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, onPressEnter = props.onPressEnter, onKeyDown = props.onKeyDown, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-input' : _props$prefixCls, disabled = props.disabled, htmlSize = props.htmlSize, className = props.className, maxLength = props.maxLength, suffix = props.suffix, showCount = props.showCount, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, inputClassName = props.inputClassName, rest = (0, $04RxA.default)(props, $156b8338c55c426f$var$_excluded);
    var _useMergedState = (0, $gfhff.default)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var _useState = (0, $6fFrj.useState)(false), _useState2 = (0, $jP8CL.default)(_useState, 2), focused = _useState2[0], setFocused = _useState2[1];
    var inputRef = (0, $6fFrj.useRef)(null);
    var focus = function focus(option) {
        if (inputRef.current) (0, $a016049cb8bbd60e$export$2b92016deb0b7aad)(inputRef.current, option);
    };
    (0, $6fFrj.useImperativeHandle)(ref, function() {
        return {
            focus: focus,
            blur: function blur() {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
            },
            setSelectionRange: function setSelectionRange(start, end, direction) {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.setSelectionRange(start, end, direction);
            },
            select: function select() {
                var _inputRef$current3;
                (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.select();
            },
            input: inputRef.current
        };
    });
    (0, $6fFrj.useEffect)(function() {
        setFocused(function(prev) {
            return prev && disabled ? false : prev;
        });
    }, [
        disabled
    ]);
    var handleChange = function handleChange(e) {
        if (props.value === undefined) setValue(e.target.value);
        if (inputRef.current) (0, $a016049cb8bbd60e$export$c28984794956ddc0)(inputRef.current, e, onChange);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (onPressEnter && e.key === 'Enter') onPressEnter(e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleReset = function handleReset(e) {
        setValue('');
        focus();
        if (inputRef.current) (0, $a016049cb8bbd60e$export$c28984794956ddc0)(inputRef.current, e, onChange);
    };
    var getInputElement = function getInputElement() {
        // Fix https://fb.me/react-unknown-prop
        var otherProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(props, [
            'prefixCls',
            'onPressEnter',
            'addonBefore',
            'addonAfter',
            'prefix',
            'suffix',
            'allowClear',
            // specify either the value prop, or the defaultValue prop, but not both.
            'defaultValue',
            'showCount',
            'affixWrapperClassName',
            'groupClassName',
            'inputClassName',
            'wrapperClassName',
            'htmlSize'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("input", (0, $fIrcP.default)({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: handleChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)({}, "".concat(prefixCls, "-disabled"), disabled), inputClassName, !(0, $a016049cb8bbd60e$export$ae6255aa850a31d1)(props) && !(0, $a016049cb8bbd60e$export$a19010aeeaa0c7a)(props) && className),
            ref: inputRef,
            size: htmlSize,
            type: type
        }));
    };
    var getSuffix = function getSuffix() {
        // Max length value
        var hasMaxLength = Number(maxLength) > 0;
        if (suffix || showCount) {
            var val = (0, $a016049cb8bbd60e$export$ef94f7f24276a29c)(value);
            var valueLength = (0, $37xND.default)(val).length;
            var dataCount = (0, $5KhTJ.default)(showCount) === 'object' ? showCount.formatter({
                value: val,
                count: valueLength,
                maxLength: maxLength
            }) : "".concat(valueLength).concat(hasMaxLength ? " / ".concat(maxLength) : '');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Fragment, null, !!showCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-show-count-suffix"), (0, $43449.default)({}, "".concat(prefixCls, "-show-count-has-suffix"), !!suffix))
            }, dataCount), suffix);
        }
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $296c7da8bddb9c26$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, rest, {
        prefixCls: prefixCls,
        className: className,
        inputElement: getInputElement(),
        handleReset: handleReset,
        value: (0, $a016049cb8bbd60e$export$ef94f7f24276a29c)(value),
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled
    }));
});
var $156b8338c55c426f$export$2e2bcd8739ae039 = $156b8338c55c426f$var$Input;


var $66dd9c59b4494177$export$2e2bcd8739ae039 = (0, $156b8338c55c426f$export$2e2bcd8739ae039);



var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");








var $6fFrj = parcelRequire("6fFrj");
function $96f60ff10b537cc4$export$2e2bcd8739ae039(inputRef, triggerOnMount) {
    var removePasswordTimeoutRef = (0, $6fFrj.useRef)([]);
    var removePasswordTimeout = function removePasswordTimeout() {
        removePasswordTimeoutRef.current.push(setTimeout(function() {
            var _a, _b, _c, _d;
            if (((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) && ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.input.getAttribute('type')) === 'password' && ((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.input.hasAttribute('value'))) (_d = inputRef.current) === null || _d === void 0 || _d.input.removeAttribute('value');
        }));
    };
    (0, $6fFrj.useEffect)(function() {
        if (triggerOnMount) removePasswordTimeout();
        return function() {
            return removePasswordTimeoutRef.current.forEach(function(timer) {
                if (timer) clearTimeout(timer);
            });
        };
    }, []);
    return removePasswordTimeout;
}


// eslint-disable-next-line import/prefer-default-export
function $2df14111bc70bf6e$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}


var $d283d087f79aff06$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $d283d087f79aff06$export$ef94f7f24276a29c(value) {
    if (typeof value === 'undefined' || value === null) return '';
    return String(value);
}
function $d283d087f79aff06$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    var event = e;
    if (e.type === 'click') {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        var currentTarget = target.cloneNode(true);
        // click clear icon
        event = Object.create(e, {
            target: {
                value: currentTarget
            },
            currentTarget: {
                value: currentTarget
            }
        });
        currentTarget.value = '';
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    if (targetValue !== undefined) {
        event = Object.create(e, {
            target: {
                value: target
            },
            currentTarget: {
                value: target
            }
        });
        target.value = targetValue;
        onChange(event);
        return;
    }
    onChange(event);
}
function $d283d087f79aff06$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    var _ref = option || {}, cursor = _ref.cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
                break;
        }
    }
}
var $d283d087f79aff06$var$Input = /*#__PURE__*/ (0, $6fFrj.forwardRef)(function(props, ref) {
    var customizePrefixCls = props.prefixCls, _props$bordered = props.bordered, bordered = _props$bordered === void 0 ? true : _props$bordered, customStatus = props.status, customSize = props.size, customDisabled = props.disabled, onBlur = props.onBlur, onFocus = props.onFocus, suffix = props.suffix, allowClear = props.allowClear, addonAfter = props.addonAfter, addonBefore = props.addonBefore, className = props.className, onChange = props.onChange, rest = $d283d087f79aff06$var$__rest(props, [
        "prefixCls",
        "bordered",
        "status",
        "size",
        "disabled",
        "onBlur",
        "onFocus",
        "suffix",
        "allowClear",
        "addonAfter",
        "addonBefore",
        "className",
        "onChange"
    ]);
    var _React$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, input = _React$useContext.input;
    var prefixCls = getPrefixCls('input', customizePrefixCls);
    var inputRef = (0, $6fFrj.useRef)(null);
    // ===================== Compact Item =====================
    var _useCompactItemContex = (0, $87f4fe035d0a15fd$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize, compactItemClassnames = _useCompactItemContex.compactItemClassnames;
    // ===================== Size =====================
    var size = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useContext((0, $aefad26b74860b7e$export$2e2bcd8739ae039));
    var mergedSize = compactSize || customSize || size;
    // ===================== Disabled =====================
    var disabled = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).useContext((0, $3880af76d17f94a3$export$2e2bcd8739ae039));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    var _useContext = (0, $6fFrj.useContext)((0, $76d69cb8326089c6$export$bbb5553c6c7a14ed)), contextStatus = _useContext.status, hasFeedback = _useContext.hasFeedback, feedbackIcon = _useContext.feedbackIcon;
    var mergedStatus = (0, $d372c831fd1c9007$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    var inputHasPrefixSuffix = (0, $2df14111bc70bf6e$export$a19010aeeaa0c7a)(props) || !!hasFeedback;
    var prevHasPrefixSuffix = (0, $6fFrj.useRef)(inputHasPrefixSuffix);
    (0, $6fFrj.useEffect)(function() {
        var _a;
        inputHasPrefixSuffix && prevHasPrefixSuffix.current;
        prevHasPrefixSuffix.current = inputHasPrefixSuffix;
    }, [
        inputHasPrefixSuffix
    ]);
    // ===================== Remove Password value =====================
    var removePasswordTimeout = (0, $96f60ff10b537cc4$export$2e2bcd8739ae039)(inputRef, true);
    var handleBlur = function handleBlur(e) {
        removePasswordTimeout();
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleFocus = function handleFocus(e) {
        removePasswordTimeout();
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleChange = function handleChange(e) {
        removePasswordTimeout();
        onChange === null || onChange === void 0 || onChange(e);
    };
    var suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Fragment, null, suffix, hasFeedback && feedbackIcon);
    // Allow clear
    var mergedAllowClear;
    if ((0, $5KhTJ.default)(allowClear) === 'object' && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $9429a61ddf5bc264$export$2e2bcd8739ae039), null)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $66dd9c59b4494177$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        ref: (0, $3BOWT.composeRef)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: input === null || input === void 0 ? void 0 : input.autoComplete
    }, rest, {
        disabled: mergedDisabled || undefined,
        onBlur: handleBlur,
        onFocus: handleFocus,
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(className, compactItemClassnames),
        onChange: handleChange,
        addonAfter: addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $87f4fe035d0a15fd$export$5f56e610a4afb685), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $76d69cb8326089c6$export$80e4c53cb85dcab1), {
            override: true,
            status: true
        }, addonAfter)),
        addonBefore: addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $87f4fe035d0a15fd$export$5f56e610a4afb685), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $76d69cb8326089c6$export$80e4c53cb85dcab1), {
            override: true,
            status: true
        }, addonBefore)),
        inputClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-sm"), mergedSize === 'small'), "".concat(prefixCls, "-lg"), mergedSize === 'large'), "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-borderless"), !bordered), !inputHasPrefixSuffix && (0, $d372c831fd1c9007$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
        affixWrapperClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-affix-wrapper-sm"), mergedSize === 'small'), "".concat(prefixCls, "-affix-wrapper-lg"), mergedSize === 'large'), "".concat(prefixCls, "-affix-wrapper-rtl"), direction === 'rtl'), "".concat(prefixCls, "-affix-wrapper-borderless"), !bordered), (0, $d372c831fd1c9007$export$b08e7b47149942a2)("".concat(prefixCls, "-affix-wrapper"), mergedStatus, hasFeedback)),
        wrapperClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)({}, "".concat(prefixCls, "-group-rtl"), direction === 'rtl')),
        groupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-group-wrapper-sm"), mergedSize === 'small'), "".concat(prefixCls, "-group-wrapper-lg"), mergedSize === 'large'), "".concat(prefixCls, "-group-wrapper-rtl"), direction === 'rtl'), (0, $d372c831fd1c9007$export$b08e7b47149942a2)("".concat(prefixCls, "-group-wrapper"), mergedStatus, hasFeedback))
    }));
});
var $d283d087f79aff06$export$2e2bcd8739ae039 = $d283d087f79aff06$var$Input;


var $c1a08c926cc02e95$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $c1a08c926cc02e95$var$fixEmojiLength(value, maxLength) {
    return (0, $37xND.default)(value || '').slice(0, maxLength).join('');
}
function $c1a08c926cc02e95$var$setTriggerValue(isCursorInEnd, preValue, triggerValue, maxLength) {
    var newTriggerValue = triggerValue;
    if (isCursorInEnd) // 光标在尾部，直接截断
    newTriggerValue = $c1a08c926cc02e95$var$fixEmojiLength(triggerValue, maxLength);
    else if ((0, $37xND.default)(preValue || '').length < triggerValue.length && (0, $37xND.default)(triggerValue || '').length > maxLength) // 光标在中间，如果最后的值超过最大值，则采用原先的值
    newTriggerValue = preValue;
    return newTriggerValue;
}
var $c1a08c926cc02e95$var$TextArea = /*#__PURE__*/ $6fFrj.forwardRef(function(_a, ref) {
    var customizePrefixCls = _a.prefixCls, _a$bordered = _a.bordered, bordered = _a$bordered === void 0 ? true : _a$bordered, _a$showCount = _a.showCount, showCount = _a$showCount === void 0 ? false : _a$showCount, maxLength = _a.maxLength, className = _a.className, style = _a.style, customizeSize = _a.size, customDisabled = _a.disabled, onCompositionStart = _a.onCompositionStart, onCompositionEnd = _a.onCompositionEnd, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, customStatus = _a.status, props = $c1a08c926cc02e95$var$__rest(_a, [
        "prefixCls",
        "bordered",
        "showCount",
        "maxLength",
        "className",
        "style",
        "size",
        "disabled",
        "onCompositionStart",
        "onCompositionEnd",
        "onChange",
        "onFocus",
        "onBlur",
        "status"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var size = $6fFrj.useContext((0, $aefad26b74860b7e$export$2e2bcd8739ae039));
    // ===================== Disabled =====================
    var disabled = $6fFrj.useContext((0, $3880af76d17f94a3$export$2e2bcd8739ae039));
    var mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    var _React$useContext2 = $6fFrj.useContext((0, $76d69cb8326089c6$export$bbb5553c6c7a14ed)), contextStatus = _React$useContext2.status, hasFeedback = _React$useContext2.hasFeedback, isFormItemInput = _React$useContext2.isFormItemInput, feedbackIcon = _React$useContext2.feedbackIcon;
    var mergedStatus = (0, $d372c831fd1c9007$export$314e193082d7ba49)(contextStatus, customStatus);
    var innerRef = $6fFrj.useRef(null);
    var clearableInputRef = $6fFrj.useRef(null);
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), compositing = _React$useState2[0], setCompositing = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState(false), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), focused = _React$useState4[0], setFocused = _React$useState4[1];
    var oldCompositionValueRef = $6fFrj.useRef();
    var oldSelectionStartRef = $6fFrj.useRef(0);
    var _useMergedState = (0, $gfhff.default)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var hidden = props.hidden;
    var handleSetValue = function handleSetValue(val, callback) {
        if (props.value === undefined) {
            setValue(val);
            callback === null || callback === void 0 || callback();
        }
    };
    // =========================== Value Update ===========================
    // Max length value
    var hasMaxLength = Number(maxLength) > 0;
    var onInternalCompositionStart = function onInternalCompositionStart(e) {
        setCompositing(true);
        // 拼音输入前保存一份旧值
        oldCompositionValueRef.current = value;
        // 保存旧的光标位置
        oldSelectionStartRef.current = e.currentTarget.selectionStart;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        var _a;
        setCompositing(false);
        var triggerValue = e.currentTarget.value;
        if (hasMaxLength) {
            var isCursorInEnd = oldSelectionStartRef.current >= maxLength + 1 || oldSelectionStartRef.current === ((_a = oldCompositionValueRef.current) === null || _a === void 0 ? void 0 : _a.length);
            triggerValue = $c1a08c926cc02e95$var$setTriggerValue(isCursorInEnd, oldCompositionValueRef.current, triggerValue, maxLength);
        }
        // Patch composition onChange when value changed
        if (triggerValue !== value) {
            handleSetValue(triggerValue);
            (0, $d283d087f79aff06$export$c28984794956ddc0)(e.currentTarget, e, onChange, triggerValue);
        }
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var handleChange = function handleChange(e) {
        var triggerValue = e.target.value;
        if (!compositing && hasMaxLength) {
            // 1. 复制粘贴超过maxlength的情况 2.未超过maxlength的情况
            var isCursorInEnd = e.target.selectionStart >= maxLength + 1 || e.target.selectionStart === triggerValue.length || !e.target.selectionStart;
            triggerValue = $c1a08c926cc02e95$var$setTriggerValue(isCursorInEnd, value, triggerValue, maxLength);
        }
        handleSetValue(triggerValue);
        (0, $d283d087f79aff06$export$c28984794956ddc0)(e.currentTarget, e, onChange, triggerValue);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    $6fFrj.useEffect(function() {
        setFocused(function(prev) {
            return !mergedDisabled && prev;
        });
    }, [
        mergedDisabled
    ]);
    // ============================== Reset ===============================
    var handleReset = function handleReset(e) {
        var _a, _b, _c;
        handleSetValue('');
        (_a = innerRef.current) === null || _a === void 0 || _a.focus();
        (0, $d283d087f79aff06$export$c28984794956ddc0)((_c = (_b = innerRef.current) === null || _b === void 0 ? void 0 : _b.resizableTextArea) === null || _c === void 0 ? void 0 : _c.textArea, e, onChange);
    };
    var prefixCls = getPrefixCls('input', customizePrefixCls);
    $6fFrj.useImperativeHandle(ref, function() {
        var _a;
        return {
            resizableTextArea: (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea,
            focus: function focus(option) {
                var _a, _b;
                (0, $d283d087f79aff06$export$2b92016deb0b7aad)((_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
            },
            blur: function blur() {
                var _a;
                return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
        };
    });
    var textArea = /*#__PURE__*/ $6fFrj.createElement((0, $647b24291807edf2$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(props, [
        'allowClear'
    ]), {
        disabled: mergedDisabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-borderless"), !bordered), className, className && !showCount), "".concat(prefixCls, "-sm"), size === 'small' || customizeSize === 'small'), "".concat(prefixCls, "-lg"), size === 'large' || customizeSize === 'large'), (0, $d372c831fd1c9007$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
        style: showCount ? {
            resize: style === null || style === void 0 ? void 0 : style.resize
        } : style,
        prefixCls: prefixCls,
        onCompositionStart: onInternalCompositionStart,
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onCompositionEnd: onInternalCompositionEnd,
        ref: innerRef
    }));
    var val = (0, $d283d087f79aff06$export$ef94f7f24276a29c)(value);
    if (!compositing && hasMaxLength && (props.value === null || props.value === undefined)) // fix #27612 将value转为数组进行截取，解决 '😂'.length === 2 等emoji表情导致的截取乱码的问题
    val = $c1a08c926cc02e95$var$fixEmojiLength(val, maxLength);
    // TextArea
    var textareaNode = /*#__PURE__*/ $6fFrj.createElement((0, $06d5ccf8f414c56b$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        disabled: mergedDisabled,
        focused: focused
    }, props, {
        prefixCls: prefixCls,
        direction: direction,
        inputType: "text",
        value: val,
        element: textArea,
        handleReset: handleReset,
        ref: clearableInputRef,
        bordered: bordered,
        status: customStatus,
        style: showCount ? undefined : style
    }));
    // Only show text area wrapper when needed
    if (showCount || hasFeedback) {
        var valueLength = (0, $37xND.default)(val).length;
        var dataCount = '';
        if ((0, $5KhTJ.default)(showCount) === 'object') dataCount = showCount.formatter({
            value: val,
            count: valueLength,
            maxLength: maxLength
        });
        else dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(maxLength) : '');
        return /*#__PURE__*/ $6fFrj.createElement("div", {
            hidden: hidden,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-textarea"), (0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-textarea-rtl"), direction === 'rtl'), "".concat(prefixCls, "-textarea-show-count"), showCount), "".concat(prefixCls, "-textarea-in-form-item"), isFormItemInput), (0, $d372c831fd1c9007$export$b08e7b47149942a2)("".concat(prefixCls, "-textarea"), mergedStatus, hasFeedback), className),
            style: style,
            "data-count": dataCount
        }, textareaNode, hasFeedback && /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-textarea-suffix")
        }, feedbackIcon));
    }
    return textareaNode;
});
var $c1a08c926cc02e95$export$2e2bcd8739ae039 = $c1a08c926cc02e95$var$TextArea;



var $4122e51d6f126cd0$var$Editable = function Editable(_ref) {
    var prefixCls = _ref.prefixCls, ariaLabel = _ref['aria-label'], className = _ref.className, style = _ref.style, direction = _ref.direction, maxLength = _ref.maxLength, _ref$autoSize = _ref.autoSize, autoSize = _ref$autoSize === void 0 ? true : _ref$autoSize, value = _ref.value, onSave = _ref.onSave, onCancel = _ref.onCancel, onEnd = _ref.onEnd, component = _ref.component, _ref$enterIcon = _ref.enterIcon, enterIcon = _ref$enterIcon === void 0 ? /*#__PURE__*/ $6fFrj.createElement((0, $c3f50770a5fa5707$export$2e2bcd8739ae039), null) : _ref$enterIcon;
    var ref = $6fFrj.useRef(null);
    var inComposition = $6fFrj.useRef(false);
    var lastKeyCode = $6fFrj.useRef();
    var _React$useState = $6fFrj.useState(value), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), current = _React$useState2[0], setCurrent = _React$useState2[1];
    $6fFrj.useEffect(function() {
        setCurrent(value);
    }, [
        value
    ]);
    $6fFrj.useEffect(function() {
        if (ref.current && ref.current.resizableTextArea) {
            var textArea = ref.current.resizableTextArea.textArea;
            textArea.focus();
            var length = textArea.value.length;
            textArea.setSelectionRange(length, length);
        }
    }, []);
    var onChange = function onChange(_ref2) {
        var target = _ref2.target;
        setCurrent(target.value.replace(/[\n\r]/g, ''));
    };
    var onCompositionStart = function onCompositionStart() {
        inComposition.current = true;
    };
    var onCompositionEnd = function onCompositionEnd() {
        inComposition.current = false;
    };
    var onKeyDown = function onKeyDown(_ref3) {
        var keyCode = _ref3.keyCode;
        // We don't record keyCode when IME is using
        if (inComposition.current) return;
        lastKeyCode.current = keyCode;
    };
    var confirmChange = function confirmChange() {
        onSave(current.trim());
    };
    var onKeyUp = function onKeyUp(_ref4) {
        var keyCode = _ref4.keyCode, ctrlKey = _ref4.ctrlKey, altKey = _ref4.altKey, metaKey = _ref4.metaKey, shiftKey = _ref4.shiftKey;
        // Check if it's a real key
        if (lastKeyCode.current === keyCode && !inComposition.current && !ctrlKey && !altKey && !metaKey && !shiftKey) {
            if (keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER) {
                confirmChange();
                onEnd === null || onEnd === void 0 || onEnd();
            } else if (keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ESC) onCancel();
        }
    };
    var onBlur = function onBlur() {
        confirmChange();
    };
    var textClassName = component ? "".concat(prefixCls, "-").concat(component) : '';
    var textAreaClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, "".concat(prefixCls, "-edit-content"), (0, $43449.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), className, textClassName);
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: textAreaClassName,
        style: style
    }, /*#__PURE__*/ $6fFrj.createElement((0, $c1a08c926cc02e95$export$2e2bcd8739ae039), {
        ref: ref,
        maxLength: maxLength,
        value: current,
        onChange: onChange,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBlur: onBlur,
        "aria-label": ariaLabel,
        rows: 1,
        autoSize: autoSize
    }), enterIcon !== null ? (0, $79365009d9b77ac6$export$e530037191fcd5d7)(enterIcon, {
        className: "".concat(prefixCls, "-edit-content-confirm")
    }) : null);
};
var $4122e51d6f126cd0$export$2e2bcd8739ae039 = $4122e51d6f126cd0$var$Editable;



var $5KhTJ = parcelRequire("5KhTJ");

var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");
function $960da78eb77fab1c$export$2e2bcd8739ae039(propConfig, templateConfig) {
    return $6fFrj.useMemo(function() {
        var support = !!propConfig;
        return [
            support,
            (0, $fIrcP.default)((0, $fIrcP.default)({}, templateConfig), support && (0, $5KhTJ.default)(propConfig) === 'object' ? propConfig : null)
        ];
    }, [
        propConfig
    ]);
}



var $6fFrj = parcelRequire("6fFrj");
/** Similar with `useEffect` but only trigger after mounted */ var $d8886f7259ff1f33$var$useUpdatedEffect = function useUpdatedEffect(callback, conditions) {
    var mountRef = $6fFrj.useRef(false);
    $6fFrj.useEffect(function() {
        if (mountRef.current) callback();
        else mountRef.current = true;
    }, conditions);
};
var $d8886f7259ff1f33$export$2e2bcd8739ae039 = $d8886f7259ff1f33$var$useUpdatedEffect;



var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");

var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");


var $e8e0dffaa2c9739f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e8e0dffaa2c9739f$var$Typography = /*#__PURE__*/ $6fFrj.forwardRef(function(_a, ref) {
    var customizePrefixCls = _a.prefixCls, _a$component = _a.component, Component = _a$component === void 0 ? 'article' : _a$component, className = _a.className, setContentRef = _a.setContentRef, children = _a.children, typographyDirection = _a.direction, restProps = $e8e0dffaa2c9739f$var$__rest(_a, [
        "prefixCls",
        "component",
        "className",
        "setContentRef",
        "children",
        "direction"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, contextDirection = _React$useContext.direction;
    var direction = typographyDirection !== null && typographyDirection !== void 0 ? typographyDirection : contextDirection;
    var mergedRef = ref;
    if (setContentRef) mergedRef = (0, $3BOWT.composeRef)(ref, setContentRef);
    var prefixCls = getPrefixCls('typography', customizePrefixCls);
    var componentClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    return(/*#__PURE__*/ // @ts-expect-error: Expression produces a union type that is too complex to represent.
    $6fFrj.createElement(Component, (0, $fIrcP.default)({
        className: componentClassName,
        ref: mergedRef
    }, restProps), children));
});
var // es default export should use const instead of let
$e8e0dffaa2c9739f$export$2e2bcd8739ae039 = $e8e0dffaa2c9739f$var$Typography;



var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $5KhTJ = parcelRequire("5KhTJ");


var $dNZA9 = parcelRequire("dNZA9");

var $6fFrj = parcelRequire("6fFrj");
function $8ba5ab6e81135c05$var$cuttable(node) {
    var type = (0, $5KhTJ.default)(node);
    return type === 'string' || type === 'number';
}
function $8ba5ab6e81135c05$var$getNodesLen(nodeList) {
    var totalLen = 0;
    nodeList.forEach(function(node) {
        if ($8ba5ab6e81135c05$var$cuttable(node)) totalLen += String(node).length;
        else totalLen += 1;
    });
    return totalLen;
}
function $8ba5ab6e81135c05$var$sliceNodes(nodeList, len) {
    var currLen = 0;
    var currentNodeList = [];
    for(var i = 0; i < nodeList.length; i += 1){
        // Match to return
        if (currLen === len) return currentNodeList;
        var node = nodeList[i];
        var canCut = $8ba5ab6e81135c05$var$cuttable(node);
        var nodeLen = canCut ? String(node).length : 1;
        var nextLen = currLen + nodeLen;
        // Exceed but current not which means we need cut this
        // This will not happen on validate ReactElement
        if (nextLen > len) {
            var restLen = len - currLen;
            currentNodeList.push(String(node).slice(0, restLen));
            return currentNodeList;
        }
        currentNodeList.push(node);
        currLen = nextLen;
    }
    return nodeList;
}
var $8ba5ab6e81135c05$var$NONE = 0;
var $8ba5ab6e81135c05$var$PREPARE = 1;
var $8ba5ab6e81135c05$var$WALKING = 2;
var $8ba5ab6e81135c05$var$DONE_WITH_ELLIPSIS = 3;
var $8ba5ab6e81135c05$var$DONE_WITHOUT_ELLIPSIS = 4;
var $8ba5ab6e81135c05$var$Ellipsis = function Ellipsis(_ref) {
    var enabledMeasure = _ref.enabledMeasure, children = _ref.children, text = _ref.text, width = _ref.width, fontSize = _ref.fontSize, rows = _ref.rows, onEllipsis = _ref.onEllipsis;
    var _React$useState = $6fFrj.useState([
        0,
        0,
        0
    ]), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), _React$useState2$ = (0, $jP8CL.default)(_React$useState2[0], 3), startLen = _React$useState2$[0], midLen = _React$useState2$[1], endLen = _React$useState2$[2], setCutLength = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState($8ba5ab6e81135c05$var$NONE), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), walkingState = _React$useState4[0], setWalkingState = _React$useState4[1];
    var _React$useState5 = $6fFrj.useState(0), _React$useState6 = (0, $jP8CL.default)(_React$useState5, 2), singleRowHeight = _React$useState6[0], setSingleRowHeight = _React$useState6[1];
    var singleRowRef = $6fFrj.useRef(null);
    var midRowRef = $6fFrj.useRef(null);
    var nodeList = $6fFrj.useMemo(function() {
        return (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(text);
    }, [
        text
    ]);
    var totalLen = $6fFrj.useMemo(function() {
        return $8ba5ab6e81135c05$var$getNodesLen(nodeList);
    }, [
        nodeList
    ]);
    var mergedChildren = $6fFrj.useMemo(function() {
        if (!enabledMeasure || walkingState !== $8ba5ab6e81135c05$var$DONE_WITH_ELLIPSIS) return children(nodeList, false);
        return children($8ba5ab6e81135c05$var$sliceNodes(nodeList, midLen), midLen < totalLen);
    }, [
        enabledMeasure,
        walkingState,
        children,
        nodeList,
        midLen,
        totalLen
    ]);
    // ======================== Walk ========================
    (0, $dNZA9.default)(function() {
        if (enabledMeasure && width && fontSize && totalLen) {
            setWalkingState($8ba5ab6e81135c05$var$PREPARE);
            setCutLength([
                0,
                Math.ceil(totalLen / 2),
                totalLen
            ]);
        }
    }, [
        enabledMeasure,
        width,
        fontSize,
        text,
        totalLen,
        rows
    ]);
    (0, $dNZA9.default)(function() {
        var _a;
        if (walkingState === $8ba5ab6e81135c05$var$PREPARE) setSingleRowHeight(((_a = singleRowRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0);
    }, [
        walkingState
    ]);
    (0, $dNZA9.default)(function() {
        var _a, _b;
        if (singleRowHeight) {
            if (walkingState === $8ba5ab6e81135c05$var$PREPARE) {
                // Ignore if position is enough
                var midHeight = ((_a = midRowRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
                var maxHeight = rows * singleRowHeight;
                if (midHeight <= maxHeight) {
                    setWalkingState($8ba5ab6e81135c05$var$DONE_WITHOUT_ELLIPSIS);
                    onEllipsis(false);
                } else setWalkingState($8ba5ab6e81135c05$var$WALKING);
            } else if (walkingState === $8ba5ab6e81135c05$var$WALKING) {
                if (startLen !== endLen) {
                    var _midHeight = ((_b = midRowRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
                    var _maxHeight = rows * singleRowHeight;
                    var nextStartLen = startLen;
                    var nextEndLen = endLen;
                    // We reach the last round
                    if (startLen === endLen - 1) nextEndLen = startLen;
                    else if (_midHeight <= _maxHeight) nextStartLen = midLen;
                    else nextEndLen = midLen;
                    var nextMidLen = Math.ceil((nextStartLen + nextEndLen) / 2);
                    setCutLength([
                        nextStartLen,
                        nextMidLen,
                        nextEndLen
                    ]);
                } else {
                    setWalkingState($8ba5ab6e81135c05$var$DONE_WITH_ELLIPSIS);
                    onEllipsis(true);
                }
            }
        }
    }, [
        walkingState,
        startLen,
        endLen,
        rows,
        singleRowHeight
    ]);
    // ======================= Render =======================
    var measureStyle = {
        width: width,
        whiteSpace: 'normal',
        margin: 0,
        padding: 0
    };
    var renderMeasure = function renderMeasure(content, ref, style) {
        return /*#__PURE__*/ $6fFrj.createElement("span", {
            "aria-hidden": true,
            ref: ref,
            style: (0, $fIrcP.default)({
                position: 'fixed',
                display: 'block',
                left: 0,
                top: 0,
                zIndex: -9999,
                visibility: 'hidden',
                pointerEvents: 'none',
                fontSize: Math.floor(fontSize / 2) * 2
            }, style)
        }, content);
    };
    var renderMeasureSlice = function renderMeasureSlice(len, ref) {
        var sliceNodeList = $8ba5ab6e81135c05$var$sliceNodes(nodeList, len);
        return renderMeasure(children(sliceNodeList, true), ref, measureStyle);
    };
    return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, mergedChildren, enabledMeasure && walkingState !== $8ba5ab6e81135c05$var$DONE_WITH_ELLIPSIS && walkingState !== $8ba5ab6e81135c05$var$DONE_WITHOUT_ELLIPSIS && /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, renderMeasure('lg', singleRowRef, {
        wordBreak: 'keep-all',
        whiteSpace: 'nowrap'
    }), walkingState === $8ba5ab6e81135c05$var$PREPARE ? renderMeasure(children(nodeList, false), midRowRef, measureStyle) : renderMeasureSlice(midLen, midRowRef)));
};
var $8ba5ab6e81135c05$export$2e2bcd8739ae039 = $8ba5ab6e81135c05$var$Ellipsis;



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

var $0d95029295460ef3$var$EllipsisTooltip = function EllipsisTooltip(_ref) {
    var enabledEllipsis = _ref.enabledEllipsis, isEllipsis = _ref.isEllipsis, children = _ref.children, tooltipProps = _ref.tooltipProps;
    if (!(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.title) || !enabledEllipsis) return children;
    return /*#__PURE__*/ $6fFrj.createElement((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        open: isEllipsis ? undefined : false
    }, tooltipProps), children);
};
var $0d95029295460ef3$export$2e2bcd8739ae039 = $0d95029295460ef3$var$EllipsisTooltip;


var $ac573e500f1c366f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $ac573e500f1c366f$var$wrapperDecorations(_ref, content) {
    var mark = _ref.mark, code = _ref.code, underline = _ref.underline, del = _ref["delete"], strong = _ref.strong, keyboard = _ref.keyboard, italic = _ref.italic;
    var currentContent = content;
    function wrap(needed, tag) {
        if (!needed) return;
        currentContent = /*#__PURE__*/ $6fFrj.createElement(tag, {}, currentContent);
    }
    wrap(strong, 'strong');
    wrap(underline, 'u');
    wrap(del, 'del');
    wrap(code, 'code');
    wrap(mark, 'mark');
    wrap(keyboard, 'kbd');
    wrap(italic, 'i');
    return currentContent;
}
function $ac573e500f1c366f$var$getNode(dom, defaultNode, needDom) {
    if (dom === true || dom === undefined) return defaultNode;
    return dom || needDom && defaultNode;
}
function $ac573e500f1c366f$var$toList(val) {
    if (val === false) return [
        false,
        false
    ];
    return Array.isArray(val) ? val : [
        val
    ];
}
var $ac573e500f1c366f$var$ELLIPSIS_STR = '...';
var $ac573e500f1c366f$var$Base = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _a, _b, _c;
    var customizePrefixCls = props.prefixCls, className = props.className, style = props.style, type = props.type, disabled = props.disabled, children = props.children, ellipsis = props.ellipsis, editable = props.editable, copyable = props.copyable, component = props.component, title = props.title, restProps = $ac573e500f1c366f$var$__rest(props, [
        "prefixCls",
        "className",
        "style",
        "type",
        "disabled",
        "children",
        "ellipsis",
        "editable",
        "copyable",
        "component",
        "title"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var textLocale = (0, $d37c6ecde78f75e8$export$52f95bab0279a481)('Text')[0]; // Force TS get this
    var typographyRef = $6fFrj.useRef(null);
    var editIconRef = $6fFrj.useRef(null);
    // ============================ MISC ============================
    var prefixCls = getPrefixCls('typography', customizePrefixCls);
    var textProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(restProps, [
        'mark',
        'code',
        'delete',
        'underline',
        'strong',
        'keyboard',
        'italic'
    ]);
    // ========================== Editable ==========================
    var _useMergedConfig = (0, $960da78eb77fab1c$export$2e2bcd8739ae039)(editable), _useMergedConfig2 = (0, $jP8CL.default)(_useMergedConfig, 2), enableEdit = _useMergedConfig2[0], editConfig = _useMergedConfig2[1];
    var _useMergedState = (0, $gfhff.default)(false, {
        value: editConfig.editing
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), editing = _useMergedState2[0], setEditing = _useMergedState2[1];
    var _editConfig$triggerTy = editConfig.triggerType, triggerType = _editConfig$triggerTy === void 0 ? [
        'icon'
    ] : _editConfig$triggerTy;
    var triggerEdit = function triggerEdit(edit) {
        var _a;
        if (edit) (_a = editConfig.onStart) === null || _a === void 0 || _a.call(editConfig);
        setEditing(edit);
    };
    // Focus edit icon when back
    (0, $d8886f7259ff1f33$export$2e2bcd8739ae039)(function() {
        var _a;
        if (!editing) (_a = editIconRef.current) === null || _a === void 0 || _a.focus();
    }, [
        editing
    ]);
    var onEditClick = function onEditClick(e) {
        e === null || e === void 0 || e.preventDefault();
        triggerEdit(true);
    };
    var onEditChange = function onEditChange(value) {
        var _a;
        (_a = editConfig.onChange) === null || _a === void 0 || _a.call(editConfig, value);
        triggerEdit(false);
    };
    var onEditCancel = function onEditCancel() {
        var _a;
        (_a = editConfig.onCancel) === null || _a === void 0 || _a.call(editConfig);
        triggerEdit(false);
    };
    // ========================== Copyable ==========================
    var _useMergedConfig3 = (0, $960da78eb77fab1c$export$2e2bcd8739ae039)(copyable), _useMergedConfig4 = (0, $jP8CL.default)(_useMergedConfig3, 2), enableCopy = _useMergedConfig4[0], copyConfig = _useMergedConfig4[1];
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), copied = _React$useState2[0], setCopied = _React$useState2[1];
    var copyIdRef = $6fFrj.useRef();
    var copyOptions = {};
    if (copyConfig.format) copyOptions.format = copyConfig.format;
    var cleanCopyId = function cleanCopyId() {
        window.clearTimeout(copyIdRef.current);
    };
    var onCopyClick = function onCopyClick(e) {
        var _a;
        e === null || e === void 0 || e.preventDefault();
        e === null || e === void 0 || e.stopPropagation();
        (0, (/*@__PURE__*/$parcel$interopDefault($9d6f8dce2baa1c27$exports)))(copyConfig.text || String(children) || '', copyOptions);
        setCopied(true);
        // Trigger tips update
        cleanCopyId();
        copyIdRef.current = window.setTimeout(function() {
            setCopied(false);
        }, 3000);
        (_a = copyConfig.onCopy) === null || _a === void 0 || _a.call(copyConfig, e);
    };
    $6fFrj.useEffect(function() {
        return cleanCopyId;
    }, []);
    // ========================== Ellipsis ==========================
    var _React$useState3 = $6fFrj.useState(false), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), isLineClampSupport = _React$useState4[0], setIsLineClampSupport = _React$useState4[1];
    var _React$useState5 = $6fFrj.useState(false), _React$useState6 = (0, $jP8CL.default)(_React$useState5, 2), isTextOverflowSupport = _React$useState6[0], setIsTextOverflowSupport = _React$useState6[1];
    var _React$useState7 = $6fFrj.useState(false), _React$useState8 = (0, $jP8CL.default)(_React$useState7, 2), expanded = _React$useState8[0], setExpanded = _React$useState8[1];
    var _React$useState9 = $6fFrj.useState(false), _React$useState10 = (0, $jP8CL.default)(_React$useState9, 2), isJsEllipsis = _React$useState10[0], setIsJsEllipsis = _React$useState10[1];
    var _React$useState11 = $6fFrj.useState(false), _React$useState12 = (0, $jP8CL.default)(_React$useState11, 2), isNativeEllipsis = _React$useState12[0], setIsNativeEllipsis = _React$useState12[1];
    var _React$useState13 = $6fFrj.useState(true), _React$useState14 = (0, $jP8CL.default)(_React$useState13, 2), isNativeVisible = _React$useState14[0], setIsNativeVisible = _React$useState14[1];
    var _useMergedConfig5 = (0, $960da78eb77fab1c$export$2e2bcd8739ae039)(ellipsis, {
        expandable: false
    }), _useMergedConfig6 = (0, $jP8CL.default)(_useMergedConfig5, 2), enableEllipsis = _useMergedConfig6[0], ellipsisConfig = _useMergedConfig6[1];
    var mergedEnableEllipsis = enableEllipsis && !expanded;
    // Shared prop to reduce bundle size
    var _ellipsisConfig$rows = ellipsisConfig.rows, rows = _ellipsisConfig$rows === void 0 ? 1 : _ellipsisConfig$rows;
    var needMeasureEllipsis = $6fFrj.useMemo(function() {
        return(// Disable ellipsis
        !mergedEnableEllipsis || // Provide suffix
        ellipsisConfig.suffix !== undefined || ellipsisConfig.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
        ellipsisConfig.expandable || enableEdit || enableCopy);
    }, [
        mergedEnableEllipsis,
        ellipsisConfig,
        enableEdit,
        enableCopy
    ]);
    (0, $dNZA9.default)(function() {
        if (enableEllipsis && !needMeasureEllipsis) {
            setIsLineClampSupport((0, $8f55e1da1d754100$export$d616d7831008e86c)('webkitLineClamp'));
            setIsTextOverflowSupport((0, $8f55e1da1d754100$export$d616d7831008e86c)('textOverflow'));
        }
    }, [
        needMeasureEllipsis,
        enableEllipsis
    ]);
    var cssEllipsis = $6fFrj.useMemo(function() {
        if (needMeasureEllipsis) return false;
        if (rows === 1) return isTextOverflowSupport;
        return isLineClampSupport;
    }, [
        needMeasureEllipsis,
        isTextOverflowSupport,
        isLineClampSupport
    ]);
    var isMergedEllipsis = mergedEnableEllipsis && (cssEllipsis ? isNativeEllipsis : isJsEllipsis);
    var cssTextOverflow = mergedEnableEllipsis && rows === 1 && cssEllipsis;
    var cssLineClamp = mergedEnableEllipsis && rows > 1 && cssEllipsis;
    // >>>>> Expand
    var onExpandClick = function onExpandClick(e) {
        var _a;
        setExpanded(true);
        (_a = ellipsisConfig.onExpand) === null || _a === void 0 || _a.call(ellipsisConfig, e);
    };
    var _React$useState15 = $6fFrj.useState(0), _React$useState16 = (0, $jP8CL.default)(_React$useState15, 2), ellipsisWidth = _React$useState16[0], setEllipsisWidth = _React$useState16[1];
    var _React$useState17 = $6fFrj.useState(0), _React$useState18 = (0, $jP8CL.default)(_React$useState17, 2), ellipsisFontSize = _React$useState18[0], setEllipsisFontSize = _React$useState18[1];
    var onResize = function onResize(_ref2, element) {
        var offsetWidth = _ref2.offsetWidth;
        var _a;
        setEllipsisWidth(offsetWidth);
        setEllipsisFontSize(parseInt((_a = window.getComputedStyle) === null || _a === void 0 ? void 0 : _a.call(window, element).fontSize, 10) || 0);
    };
    // >>>>> JS Ellipsis
    var onJsEllipsis = function onJsEllipsis(jsEllipsis) {
        var _a;
        setIsJsEllipsis(jsEllipsis);
        // Trigger if changed
        if (isJsEllipsis !== jsEllipsis) (_a = ellipsisConfig.onEllipsis) === null || _a === void 0 || _a.call(ellipsisConfig, jsEllipsis);
    };
    // >>>>> Native ellipsis
    $6fFrj.useEffect(function() {
        var textEle = typographyRef.current;
        if (enableEllipsis && cssEllipsis && textEle) {
            var currentEllipsis = cssLineClamp ? textEle.offsetHeight < textEle.scrollHeight : textEle.offsetWidth < textEle.scrollWidth;
            if (isNativeEllipsis !== currentEllipsis) setIsNativeEllipsis(currentEllipsis);
        }
    }, [
        enableEllipsis,
        cssEllipsis,
        children,
        cssLineClamp,
        isNativeVisible
    ]);
    // https://github.com/ant-design/ant-design/issues/36786
    // Use IntersectionObserver to check if element is invisible
    $6fFrj.useEffect(function() {
        var textEle = typographyRef.current;
        if (typeof IntersectionObserver === 'undefined' || !textEle || !cssEllipsis || !mergedEnableEllipsis) return;
        /* eslint-disable-next-line compat/compat */ var observer = new IntersectionObserver(function() {
            setIsNativeVisible(!!textEle.offsetParent);
        });
        observer.observe(textEle);
        return function() {
            observer.disconnect();
        };
    }, [
        cssEllipsis,
        mergedEnableEllipsis
    ]);
    // ========================== Tooltip ===========================
    var tooltipProps = {};
    if (ellipsisConfig.tooltip === true) tooltipProps = {
        title: (_a = editConfig.text) !== null && _a !== void 0 ? _a : children
    };
    else if (/*#__PURE__*/ $6fFrj.isValidElement(ellipsisConfig.tooltip)) tooltipProps = {
        title: ellipsisConfig.tooltip
    };
    else if ((0, $5KhTJ.default)(ellipsisConfig.tooltip) === 'object') tooltipProps = (0, $fIrcP.default)({
        title: (_b = editConfig.text) !== null && _b !== void 0 ? _b : children
    }, ellipsisConfig.tooltip);
    else tooltipProps = {
        title: ellipsisConfig.tooltip
    };
    var topAriaLabel = $6fFrj.useMemo(function() {
        var isValid = function isValid(val) {
            return [
                'string',
                'number'
            ].includes((0, $5KhTJ.default)(val));
        };
        if (!enableEllipsis || cssEllipsis) return undefined;
        if (isValid(editConfig.text)) return editConfig.text;
        if (isValid(children)) return children;
        if (isValid(title)) return title;
        if (isValid(tooltipProps.title)) return tooltipProps.title;
        return undefined;
    }, [
        enableEllipsis,
        cssEllipsis,
        title,
        tooltipProps.title,
        isMergedEllipsis
    ]);
    // =========================== Render ===========================
    // >>>>>>>>>>> Editing input
    if (editing) return /*#__PURE__*/ $6fFrj.createElement((0, $4122e51d6f126cd0$export$2e2bcd8739ae039), {
        value: (_c = editConfig.text) !== null && _c !== void 0 ? _c : typeof children === 'string' ? children : '',
        onSave: onEditChange,
        onCancel: onEditCancel,
        onEnd: editConfig.onEnd,
        prefixCls: prefixCls,
        className: className,
        style: style,
        direction: direction,
        component: component,
        maxLength: editConfig.maxLength,
        autoSize: editConfig.autoSize,
        enterIcon: editConfig.enterIcon
    });
    // >>>>>>>>>>> Typography
    // Expand
    var renderExpand = function renderExpand() {
        var expandable = ellipsisConfig.expandable, symbol = ellipsisConfig.symbol;
        if (!expandable) return null;
        var expandContent;
        if (symbol) expandContent = symbol;
        else expandContent = textLocale.expand;
        return /*#__PURE__*/ $6fFrj.createElement("a", {
            key: "expand",
            className: "".concat(prefixCls, "-expand"),
            onClick: onExpandClick,
            "aria-label": textLocale.expand
        }, expandContent);
    };
    // Edit
    var renderEdit = function renderEdit() {
        if (!enableEdit) return;
        var icon = editConfig.icon, tooltip = editConfig.tooltip;
        var editTitle = (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(tooltip)[0] || textLocale.edit;
        var ariaLabel = typeof editTitle === 'string' ? editTitle : '';
        return triggerType.includes('icon') ? /*#__PURE__*/ $6fFrj.createElement((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            key: "edit",
            title: tooltip === false ? '' : editTitle
        }, /*#__PURE__*/ $6fFrj.createElement((0, $f2c761931619ec0a$export$2e2bcd8739ae039), {
            ref: editIconRef,
            className: "".concat(prefixCls, "-edit"),
            onClick: onEditClick,
            "aria-label": ariaLabel
        }, icon || /*#__PURE__*/ $6fFrj.createElement((0, $88348658f25c3b04$export$2e2bcd8739ae039), {
            role: "button"
        }))) : null;
    };
    // Copy
    var renderCopy = function renderCopy() {
        if (!enableCopy) return;
        var tooltips = copyConfig.tooltips, icon = copyConfig.icon;
        var tooltipNodes = $ac573e500f1c366f$var$toList(tooltips);
        var iconNodes = $ac573e500f1c366f$var$toList(icon);
        var copyTitle = copied ? $ac573e500f1c366f$var$getNode(tooltipNodes[1], textLocale.copied) : $ac573e500f1c366f$var$getNode(tooltipNodes[0], textLocale.copy);
        var systemStr = copied ? textLocale.copied : textLocale.copy;
        var ariaLabel = typeof copyTitle === 'string' ? copyTitle : systemStr;
        return /*#__PURE__*/ $6fFrj.createElement((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            key: "copy",
            title: copyTitle
        }, /*#__PURE__*/ $6fFrj.createElement((0, $f2c761931619ec0a$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-copy"), copied && "".concat(prefixCls, "-copy-success")),
            onClick: onCopyClick,
            "aria-label": ariaLabel
        }, copied ? $ac573e500f1c366f$var$getNode(iconNodes[1], /*#__PURE__*/ $6fFrj.createElement((0, $97e498ed1184adf1$export$2e2bcd8739ae039), null), true) : $ac573e500f1c366f$var$getNode(iconNodes[0], /*#__PURE__*/ $6fFrj.createElement((0, $c038d55eb32ecd6b$export$2e2bcd8739ae039), null), true)));
    };
    var renderOperations = function renderOperations(renderExpanded) {
        return [
            renderExpanded && renderExpand(),
            renderEdit(),
            renderCopy()
        ];
    };
    var renderEllipsis = function renderEllipsis(needEllipsis) {
        return [
            needEllipsis && /*#__PURE__*/ $6fFrj.createElement("span", {
                "aria-hidden": true,
                key: "ellipsis"
            }, $ac573e500f1c366f$var$ELLIPSIS_STR),
            ellipsisConfig.suffix,
            renderOperations(needEllipsis)
        ];
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $8e6bb008621f90f5$export$2e2bcd8739ae039), {
        onResize: onResize,
        disabled: !mergedEnableEllipsis || cssEllipsis
    }, function(resizeRef) {
        return /*#__PURE__*/ $6fFrj.createElement((0, $0d95029295460ef3$export$2e2bcd8739ae039), {
            tooltipProps: tooltipProps,
            enabledEllipsis: mergedEnableEllipsis,
            isEllipsis: isMergedEllipsis
        }, /*#__PURE__*/ $6fFrj.createElement((0, $e8e0dffaa2c9739f$export$2e2bcd8739ae039), (0, $fIrcP.default)({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-").concat(type), type), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-ellipsis"), enableEllipsis), "".concat(prefixCls, "-single-line"), mergedEnableEllipsis && rows === 1), "".concat(prefixCls, "-ellipsis-single-line"), cssTextOverflow), "".concat(prefixCls, "-ellipsis-multiple-line"), cssLineClamp), className),
            prefixCls: customizePrefixCls,
            style: (0, $fIrcP.default)((0, $fIrcP.default)({}, style), {
                WebkitLineClamp: cssLineClamp ? rows : undefined
            }),
            component: component,
            ref: (0, $3BOWT.composeRef)(resizeRef, typographyRef, ref),
            direction: direction,
            onClick: triggerType.includes('text') ? onEditClick : undefined,
            "aria-label": topAriaLabel === null || topAriaLabel === void 0 ? void 0 : topAriaLabel.toString(),
            title: title
        }, textProps), /*#__PURE__*/ $6fFrj.createElement((0, $8ba5ab6e81135c05$export$2e2bcd8739ae039), {
            enabledMeasure: mergedEnableEllipsis && !cssEllipsis,
            text: children,
            rows: rows,
            width: ellipsisWidth,
            fontSize: ellipsisFontSize,
            onEllipsis: onJsEllipsis
        }, function(node, needEllipsis) {
            var renderNode = node;
            if (node.length && needEllipsis && topAriaLabel) renderNode = /*#__PURE__*/ $6fFrj.createElement("span", {
                key: "show-content",
                "aria-hidden": true
            }, renderNode);
            var wrappedContext = $ac573e500f1c366f$var$wrapperDecorations(props, /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, renderNode, renderEllipsis(needEllipsis)));
            return wrappedContext;
        })));
    });
});
var $ac573e500f1c366f$export$2e2bcd8739ae039 = $ac573e500f1c366f$var$Base;


var $f62f1c81a8178ad9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f62f1c81a8178ad9$var$Link = /*#__PURE__*/ $6fFrj.forwardRef(function(_a, ref) {
    var ellipsis = _a.ellipsis, rel = _a.rel, restProps = $f62f1c81a8178ad9$var$__rest(_a, [
        "ellipsis",
        "rel"
    ]);
    var mergedProps = (0, $fIrcP.default)((0, $fIrcP.default)({}, restProps), {
        rel: rel === undefined && restProps.target === '_blank' ? 'noopener noreferrer' : rel
    });
    // @ts-expect-error: https://github.com/ant-design/ant-design/issues/26622
    delete mergedProps.navigate;
    return /*#__PURE__*/ $6fFrj.createElement((0, $ac573e500f1c366f$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, mergedProps, {
        ref: ref,
        ellipsis: !!ellipsis,
        component: "a"
    }));
});
var $f62f1c81a8178ad9$export$2e2bcd8739ae039 = $f62f1c81a8178ad9$var$Link;



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

var $57b7b700f50544b9$var$Paragraph = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $ac573e500f1c366f$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        ref: ref
    }, props, {
        component: "div"
    }));
});
var $57b7b700f50544b9$export$2e2bcd8739ae039 = $57b7b700f50544b9$var$Paragraph;



var $fIrcP = parcelRequire("fIrcP");

var $5KhTJ = parcelRequire("5KhTJ");


var $6fFrj = parcelRequire("6fFrj");


var $821c9ca5a06620c3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $821c9ca5a06620c3$var$Text = function Text(_a, ref) {
    var ellipsis = _a.ellipsis, restProps = $821c9ca5a06620c3$var$__rest(_a, [
        "ellipsis"
    ]);
    var mergedEllipsis = $6fFrj.useMemo(function() {
        if (ellipsis && (0, $5KhTJ.default)(ellipsis) === 'object') return (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(ellipsis, [
            'expandable',
            'rows'
        ]);
        return ellipsis;
    }, [
        ellipsis
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $ac573e500f1c366f$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        ref: ref
    }, restProps, {
        ellipsis: mergedEllipsis,
        component: "span"
    }));
};
var $821c9ca5a06620c3$export$2e2bcd8739ae039 = /*#__PURE__*/ $6fFrj.forwardRef($821c9ca5a06620c3$var$Text);



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");



var $964837f59e950f3d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $964837f59e950f3d$var$TITLE_ELE_LIST = (0, $cacd97b96801cebe$export$1ada10640a0e4dad)(1, 2, 3, 4, 5);
var $964837f59e950f3d$var$Title = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _props$level = props.level, level = _props$level === void 0 ? 1 : _props$level, restProps = $964837f59e950f3d$var$__rest(props, [
        "level"
    ]);
    var component;
    if ($964837f59e950f3d$var$TITLE_ELE_LIST.includes(level)) component = "h".concat(level);
    else component = 'h1';
    return /*#__PURE__*/ $6fFrj.createElement((0, $ac573e500f1c366f$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        ref: ref
    }, restProps, {
        component: component
    }));
});
var $964837f59e950f3d$export$2e2bcd8739ae039 = $964837f59e950f3d$var$Title;



var $384b89a85bcb79c5$var$Typography = (0, $e8e0dffaa2c9739f$export$2e2bcd8739ae039);
$384b89a85bcb79c5$var$Typography.Text = (0, $821c9ca5a06620c3$export$2e2bcd8739ae039);
$384b89a85bcb79c5$var$Typography.Link = (0, $f62f1c81a8178ad9$export$2e2bcd8739ae039);
$384b89a85bcb79c5$var$Typography.Title = (0, $964837f59e950f3d$export$2e2bcd8739ae039);
$384b89a85bcb79c5$var$Typography.Paragraph = (0, $57b7b700f50544b9$export$2e2bcd8739ae039);
var $384b89a85bcb79c5$export$2e2bcd8739ae039 = $384b89a85bcb79c5$var$Typography;


var $9c2d5834e4bf064d$var$__assign = undefined && undefined.__assign || function() {
    $9c2d5834e4bf064d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9c2d5834e4bf064d$var$__assign.apply(this, arguments);
};
var $9c2d5834e4bf064d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9c2d5834e4bf064d$var$Text = function(_a) {
    var className = _a.className, small = _a.small, rest = $9c2d5834e4bf064d$var$__rest(_a, [
        "className",
        "small"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $384b89a85bcb79c5$export$2e2bcd8739ae039).Text, $9c2d5834e4bf064d$var$__assign({
        className: [
            className,
            'tax-typography',
            small && 'small'
        ].filter(Boolean).join(' ')
    }, rest));
};
var $9c2d5834e4bf064d$var$Paragraph = function(_a) {
    var className = _a.className, small = _a.small, rest = $9c2d5834e4bf064d$var$__rest(_a, [
        "className",
        "small"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $384b89a85bcb79c5$export$2e2bcd8739ae039).Paragraph, $9c2d5834e4bf064d$var$__assign({
        className: [
            className,
            'tax-typography',
            small && 'small'
        ].filter(Boolean).join(' ')
    }, rest));
};
var $9c2d5834e4bf064d$var$Title = function(_a) {
    var className = _a.className, rest = $9c2d5834e4bf064d$var$__rest(_a, [
        "className"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $384b89a85bcb79c5$export$2e2bcd8739ae039).Title, $9c2d5834e4bf064d$var$__assign({
        className: [
            className,
            'tax-typography'
        ].filter(Boolean).join(' ')
    }, rest));
};
var $9c2d5834e4bf064d$var$Link = function(_a) {
    var className = _a.className, rest = $9c2d5834e4bf064d$var$__rest(_a, [
        "className"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $384b89a85bcb79c5$export$2e2bcd8739ae039).Link, $9c2d5834e4bf064d$var$__assign({
        className: [
            className,
            'tax-typography'
        ].filter(Boolean).join(' ')
    }, rest));
};
var $9c2d5834e4bf064d$var$Button = function(_a) {
    var className = _a.className, icon = _a.icon, children = _a.children, rest = $9c2d5834e4bf064d$var$__rest(_a, [
        "className",
        "icon",
        "children"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $ea0942a2e543872a$export$2e2bcd8739ae039), $9c2d5834e4bf064d$var$__assign({
        type: "text",
        className: [
            className,
            'tax-typography'
        ].filter(Boolean).join(' ')
    }, rest), children, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
        style: {
            marginLeft: 10
        }
    }, icon));
};
/**
 * Typography component for text display
 */ var $9c2d5834e4bf064d$var$Typography = function(_a) {
    var className = _a.className, _b = _a.small, small = _b === void 0 ? false : _b, rest = $9c2d5834e4bf064d$var$__rest(_a, [
        "className",
        "small"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $384b89a85bcb79c5$export$2e2bcd8739ae039).Paragraph, $9c2d5834e4bf064d$var$__assign({
        className: [
            className,
            'tax-typography',
            small && 'small'
        ].filter(Boolean).join(' ')
    }, rest));
};
$9c2d5834e4bf064d$var$Typography.Text = $9c2d5834e4bf064d$var$Text;
$9c2d5834e4bf064d$var$Typography.Paragraph = $9c2d5834e4bf064d$var$Paragraph;
$9c2d5834e4bf064d$var$Typography.Title = $9c2d5834e4bf064d$var$Title;
$9c2d5834e4bf064d$var$Typography.Button = $9c2d5834e4bf064d$var$Button;
$9c2d5834e4bf064d$var$Typography.Link = $9c2d5834e4bf064d$var$Link;
var $9c2d5834e4bf064d$export$2e2bcd8739ae039 = $9c2d5834e4bf064d$var$Typography;


var $e8201deab6acaf74$export$2e2bcd8739ae039 = (0, $9c2d5834e4bf064d$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");

var $1f1b64eb37a20081$var$__assign = undefined && undefined.__assign || function() {
    $1f1b64eb37a20081$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1f1b64eb37a20081$var$__assign.apply(this, arguments);
};
var $1f1b64eb37a20081$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1f1b64eb37a20081$var$Tabs = function(_a) {
    var className = _a.className, _b = _a.bordered, bordered = _b === void 0 ? true : _b, rest = $1f1b64eb37a20081$var$__rest(_a, [
        "className",
        "bordered"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $3fe3f92467129298$export$2e2bcd8739ae039), $1f1b64eb37a20081$var$__assign({}, rest, {
        className: [
            !bordered && 'unbordered'
        ].filter(Boolean).join(' ')
    }));
};
$1f1b64eb37a20081$var$Tabs.TabPane = (0, $3fe3f92467129298$export$2e2bcd8739ae039).TabPane;
var $1f1b64eb37a20081$export$2e2bcd8739ae039 = $1f1b64eb37a20081$var$Tabs;


var $5024ed5b7bb39672$export$2e2bcd8739ae039 = (0, $1f1b64eb37a20081$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");

var $5KhTJ = parcelRequire("5KhTJ");

var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $fActo = parcelRequire("fActo");

var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $37xND = parcelRequire("37xND");

var $jP8CL = parcelRequire("jP8CL");

var $5KhTJ = parcelRequire("5KhTJ");

var $6fFrj = parcelRequire("6fFrj");




var $fActo = parcelRequire("fActo");


var $3mXQ2 = parcelRequire("3mXQ2");


/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $702ddf5d0009f4ad$var$ColumnGroup(_) {
    return null;
}
var $702ddf5d0009f4ad$export$2e2bcd8739ae039 = $702ddf5d0009f4ad$var$ColumnGroup;


/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $9d2150425b4d3196$var$Column(_) {
    return null;
}
var $9d2150425b4d3196$export$2e2bcd8739ae039 = $9d2150425b4d3196$var$Column;



var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");

var $jP8CL = parcelRequire("jP8CL");

var $5KhTJ = parcelRequire("5KhTJ");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");


var $3BOWT = parcelRequire("3BOWT");
var $7d023320b5dd5fb7$var$INTERNAL_KEY_PREFIX = 'RC_TABLE_KEY';
function $7d023320b5dd5fb7$var$toArray(arr) {
    if (arr === undefined || arr === null) return [];
    return Array.isArray(arr) ? arr : [
        arr
    ];
}
function $7d023320b5dd5fb7$export$964131d48d6e4d94(record, path) {
    // Skip if path is empty
    if (!path && typeof path !== 'number') return record;
    var pathList = $7d023320b5dd5fb7$var$toArray(path);
    var current = record;
    for(var i = 0; i < pathList.length; i += 1){
        if (!current) return null;
        var prop = pathList[i];
        current = current[prop];
    }
    return current;
}
function $7d023320b5dd5fb7$export$fd2ca5407d9be470(columns) {
    var columnKeys = [];
    var keys = {};
    columns.forEach(function(column) {
        var _ref = column || {}, key = _ref.key, dataIndex = _ref.dataIndex;
        var mergedKey = key || $7d023320b5dd5fb7$var$toArray(dataIndex).join('-') || $7d023320b5dd5fb7$var$INTERNAL_KEY_PREFIX;
        while(keys[mergedKey])mergedKey = "".concat(mergedKey, "_next");
        keys[mergedKey] = true;
        columnKeys.push(mergedKey);
    });
    return columnKeys;
}
function $7d023320b5dd5fb7$export$b76e9316566cc26e(val) {
    return val !== null && val !== undefined;
}



var $6fFrj = parcelRequire("6fFrj");
var $d06cf1a7a845970c$var$StickyContext = /*#__PURE__*/ $6fFrj.createContext(false);
var $d06cf1a7a845970c$export$2e2bcd8739ae039 = $d06cf1a7a845970c$var$StickyContext;



var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $dNZA9 = parcelRequire("dNZA9");

var $2c6ch = parcelRequire("2c6ch");

function $e335d904edbf3e32$export$fd42f52fd3ae1109() {
    var Context = /*#__PURE__*/ $6fFrj.createContext(null);
    var Provider = function Provider(_ref) {
        var value = _ref.value, children = _ref.children;
        var valueRef = $6fFrj.useRef(value);
        valueRef.current = value;
        var _React$useState = $6fFrj.useState(function() {
            return {
                getValue: function getValue() {
                    return valueRef.current;
                },
                listeners: new Set()
            };
        }), _React$useState2 = (0, $jP8CL.default)(_React$useState, 1), context = _React$useState2[0];
        (0, $dNZA9.default)(function() {
            context.listeners.forEach(function(listener) {
                listener(value);
            });
        }, [
            value
        ]);
        return /*#__PURE__*/ $6fFrj.createElement(Context.Provider, {
            value: context
        }, children);
    };
    return {
        Context: Context,
        Provider: Provider
    };
}
function $e335d904edbf3e32$export$30b2013e16e635d0(holder, selector) {
    var eventSelector = (0, $2c6ch.default)(selector);
    var context = $6fFrj.useContext(holder === null || holder === void 0 ? void 0 : holder.Context);
    var _ref2 = context || {}, listeners = _ref2.listeners, getValue = _ref2.getValue;
    var _React$useState3 = $6fFrj.useState(function() {
        return eventSelector(context ? getValue() : null);
    }), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), value = _React$useState4[0], setValue = _React$useState4[1];
    (0, $dNZA9.default)(function() {
        if (!context) return;
        function trigger(nextValue) {
            setValue(function(prev) {
                var selectedValue = eventSelector(nextValue);
                return (0, (/*@__PURE__*/$parcel$interopDefault($802a1584717a396d$exports)))(prev, selectedValue) ? prev : selectedValue;
            });
        }
        listeners.add(trigger);
        return function() {
            listeners.delete(trigger);
        };
    }, [
        context
    ]);
    return value;
}


var $dc76e9514d25190e$var$HoverContext = (0, $e335d904edbf3e32$export$fd42f52fd3ae1109)();
var $dc76e9514d25190e$export$2e2bcd8739ae039 = $dc76e9514d25190e$var$HoverContext;



var $6fFrj = parcelRequire("6fFrj");
var $531ee63ef59dd731$var$BodyContext = /*#__PURE__*/ $6fFrj.createContext(null);
var $531ee63ef59dd731$export$2e2bcd8739ae039 = $531ee63ef59dd731$var$BodyContext;


parcelRequire("3mXQ2");

var $6fFrj = parcelRequire("6fFrj");
var $0b69e3c5446363d0$var$PerfContext = /*#__PURE__*/ $6fFrj.createContext({
    renderWithProps: false
});
var $0b69e3c5446363d0$export$2e2bcd8739ae039 = $0b69e3c5446363d0$var$PerfContext;



var $d03a31adffb8f073$var$_excluded = [
    "colSpan",
    "rowSpan",
    "style",
    "className"
];
/** Check if cell is in hover range */ function $d03a31adffb8f073$var$inHoverRange(cellStartRow, cellRowSpan, startRow, endRow) {
    var cellEndRow = cellStartRow + cellRowSpan - 1;
    return cellStartRow <= endRow && cellEndRow >= startRow;
}
function $d03a31adffb8f073$var$isRenderCell(data) {
    return data && (0, $5KhTJ.default)(data) === 'object' && !Array.isArray(data) && !/*#__PURE__*/ $6fFrj.isValidElement(data);
}
function $d03a31adffb8f073$var$isRefComponent(component) {
    // String tag component also support ref
    if (typeof component === 'string') return true;
    return (0, $3BOWT.supportRef)(component);
}
var $d03a31adffb8f073$var$getTitleFromCellRenderChildren = function getTitleFromCellRenderChildren(_ref) {
    var ellipsis = _ref.ellipsis, rowType = _ref.rowType, children = _ref.children;
    var title;
    var ellipsisConfig = ellipsis === true ? {
        showTitle: true
    } : ellipsis;
    if (ellipsisConfig && (ellipsisConfig.showTitle || rowType === 'header')) {
        if (typeof children === 'string' || typeof children === 'number') title = children.toString();
        else if (/*#__PURE__*/ $6fFrj.isValidElement(children) && typeof children.props.children === 'string') title = children.props.children;
    }
    return title;
};
function $d03a31adffb8f073$var$Cell(_ref2, ref) {
    var _ref4, _ref5, _classNames;
    var prefixCls = _ref2.prefixCls, className = _ref2.className, record = _ref2.record, index = _ref2.index, renderIndex = _ref2.renderIndex, dataIndex = _ref2.dataIndex, render = _ref2.render, children = _ref2.children, _ref2$component = _ref2.component, Component = _ref2$component === void 0 ? 'td' : _ref2$component, colSpan = _ref2.colSpan, rowSpan = _ref2.rowSpan, fixLeft = _ref2.fixLeft, fixRight = _ref2.fixRight, firstFixLeft = _ref2.firstFixLeft, lastFixLeft = _ref2.lastFixLeft, firstFixRight = _ref2.firstFixRight, lastFixRight = _ref2.lastFixRight, appendNode = _ref2.appendNode, _ref2$additionalProps = _ref2.additionalProps, additionalProps = _ref2$additionalProps === void 0 ? {} : _ref2$additionalProps, ellipsis = _ref2.ellipsis, align = _ref2.align, rowType = _ref2.rowType, isSticky = _ref2.isSticky, hovering = _ref2.hovering, onHover = _ref2.onHover;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var perfRecord = $6fFrj.useContext((0, $0b69e3c5446363d0$export$2e2bcd8739ae039));
    var supportSticky = $6fFrj.useContext((0, $d06cf1a7a845970c$export$2e2bcd8739ae039));
    var _React$useContext = $6fFrj.useContext((0, $531ee63ef59dd731$export$2e2bcd8739ae039)), allColumnsFixedLeft = _React$useContext.allColumnsFixedLeft; // ==================== Child Node ====================
    var _React$useMemo = $6fFrj.useMemo(function() {
        if ((0, $7d023320b5dd5fb7$export$b76e9316566cc26e)(children)) return [
            children
        ];
        var value = (0, $7d023320b5dd5fb7$export$964131d48d6e4d94)(record, dataIndex); // Customize render node
        var returnChildNode = value;
        var returnCellProps = undefined;
        if (render) {
            var renderData = render(value, record, renderIndex);
            if ($d03a31adffb8f073$var$isRenderCell(renderData)) {
                returnChildNode = renderData.children;
                returnCellProps = renderData.props;
                perfRecord.renderWithProps = true;
            } else returnChildNode = renderData;
        }
        return [
            returnChildNode,
            returnCellProps
        ];
    }, [
        /* eslint-disable react-hooks/exhaustive-deps */ // Always re-render if `renderWithProps`
        perfRecord.renderWithProps ? Math.random() : 0,
        /* eslint-enable */ children,
        dataIndex,
        perfRecord,
        record,
        render,
        renderIndex
    ]), _React$useMemo2 = (0, $jP8CL.default)(_React$useMemo, 2), childNode = _React$useMemo2[0], legacyCellProps = _React$useMemo2[1];
    var mergedChildNode = childNode; // Not crash if final `childNode` is not validate ReactNode
    if ((0, $5KhTJ.default)(mergedChildNode) === 'object' && !Array.isArray(mergedChildNode) && !/*#__PURE__*/ $6fFrj.isValidElement(mergedChildNode)) mergedChildNode = null;
    if (ellipsis && (lastFixLeft || firstFixRight)) mergedChildNode = /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(cellPrefixCls, "-content")
    }, mergedChildNode);
    var _ref3 = legacyCellProps || {}, cellColSpan = _ref3.colSpan, cellRowSpan = _ref3.rowSpan, cellStyle = _ref3.style, cellClassName = _ref3.className, restCellProps = (0, $04RxA.default)(_ref3, $d03a31adffb8f073$var$_excluded);
    var mergedColSpan = (_ref4 = cellColSpan !== undefined ? cellColSpan : colSpan) !== null && _ref4 !== void 0 ? _ref4 : 1;
    var mergedRowSpan = (_ref5 = cellRowSpan !== undefined ? cellRowSpan : rowSpan) !== null && _ref5 !== void 0 ? _ref5 : 1;
    if (mergedColSpan === 0 || mergedRowSpan === 0) return null;
     // ====================== Fixed =======================
    var fixedStyle = {};
    var isFixLeft = typeof fixLeft === 'number' && supportSticky;
    var isFixRight = typeof fixRight === 'number' && supportSticky;
    if (isFixLeft) {
        fixedStyle.position = 'sticky';
        fixedStyle.left = fixLeft;
    }
    if (isFixRight) {
        fixedStyle.position = 'sticky';
        fixedStyle.right = fixRight;
    } // ====================== Align =======================
    var alignStyle = {};
    if (align) alignStyle.textAlign = align;
     // ====================== Hover =======================
    var onMouseEnter = function onMouseEnter(event) {
        var _additionalProps$onMo;
        if (record) onHover(index, index + mergedRowSpan - 1);
        additionalProps === null || additionalProps === void 0 || (_additionalProps$onMo = additionalProps.onMouseEnter) === null || _additionalProps$onMo === void 0 || _additionalProps$onMo.call(additionalProps, event);
    };
    var onMouseLeave = function onMouseLeave(event) {
        var _additionalProps$onMo2;
        if (record) onHover(-1, -1);
        additionalProps === null || additionalProps === void 0 || (_additionalProps$onMo2 = additionalProps.onMouseLeave) === null || _additionalProps$onMo2 === void 0 || _additionalProps$onMo2.call(additionalProps, event);
    }; // ====================== Render ======================
    var title = $d03a31adffb8f073$var$getTitleFromCellRenderChildren({
        rowType: rowType,
        ellipsis: ellipsis,
        children: childNode
    });
    var componentProps = (0, $kNxFX.default)((0, $kNxFX.default)((0, $kNxFX.default)({
        title: title
    }, restCellProps), additionalProps), {}, {
        colSpan: mergedColSpan !== 1 ? mergedColSpan : null,
        rowSpan: mergedRowSpan !== 1 ? mergedRowSpan : null,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(cellPrefixCls, className, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(cellPrefixCls, "-fix-left"), isFixLeft && supportSticky), (0, $43449.default)(_classNames, "".concat(cellPrefixCls, "-fix-left-first"), firstFixLeft && supportSticky), (0, $43449.default)(_classNames, "".concat(cellPrefixCls, "-fix-left-last"), lastFixLeft && supportSticky), (0, $43449.default)(_classNames, "".concat(cellPrefixCls, "-fix-left-all"), lastFixLeft && allColumnsFixedLeft && supportSticky), (0, $43449.default)(_classNames, "".concat(cellPrefixCls, "-fix-right"), isFixRight && supportSticky), (0, $43449.default)(_classNames, "".concat(cellPrefixCls, "-fix-right-first"), firstFixRight && supportSticky), (0, $43449.default)(_classNames, "".concat(cellPrefixCls, "-fix-right-last"), lastFixRight && supportSticky), (0, $43449.default)(_classNames, "".concat(cellPrefixCls, "-ellipsis"), ellipsis), (0, $43449.default)(_classNames, "".concat(cellPrefixCls, "-with-append"), appendNode), (0, $43449.default)(_classNames, "".concat(cellPrefixCls, "-fix-sticky"), (isFixLeft || isFixRight) && isSticky && supportSticky), (0, $43449.default)(_classNames, "".concat(cellPrefixCls, "-row-hover"), !legacyCellProps && hovering), _classNames), additionalProps.className, cellClassName),
        style: (0, $kNxFX.default)((0, $kNxFX.default)((0, $kNxFX.default)((0, $kNxFX.default)({}, additionalProps.style), alignStyle), fixedStyle), cellStyle),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: $d03a31adffb8f073$var$isRefComponent(Component) ? ref : null
    });
    return /*#__PURE__*/ $6fFrj.createElement(Component, componentProps, appendNode, mergedChildNode);
}
var $d03a31adffb8f073$var$RefCell = /*#__PURE__*/ $6fFrj.forwardRef($d03a31adffb8f073$var$Cell);
$d03a31adffb8f073$var$RefCell.displayName = 'Cell';
var $d03a31adffb8f073$var$comparePropList = [
    'expanded',
    'className',
    'hovering'
];
var $d03a31adffb8f073$var$MemoCell = /*#__PURE__*/ $6fFrj.memo($d03a31adffb8f073$var$RefCell, function(prev, next) {
    if (next.shouldCellUpdate) return $d03a31adffb8f073$var$comparePropList.every(function(propName) {
        return prev[propName] === next[propName];
    }) && // User control update logic
    !next.shouldCellUpdate(next.record, prev.record);
    return (0, (/*@__PURE__*/$parcel$interopDefault($802a1584717a396d$exports)))(prev, next);
});
/** Inject hover data here, we still wish MemoCell keep simple `shouldCellUpdate` logic */ var $d03a31adffb8f073$var$WrappedCell = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var index = props.index, _props$additionalProp = props.additionalProps, additionalProps = _props$additionalProp === void 0 ? {} : _props$additionalProp, colSpan = props.colSpan, rowSpan = props.rowSpan;
    var cellColSpan = additionalProps.colSpan, cellRowSpan = additionalProps.rowSpan;
    var mergedColSpan = colSpan !== null && colSpan !== void 0 ? colSpan : cellColSpan;
    var mergedRowSpan = rowSpan !== null && rowSpan !== void 0 ? rowSpan : cellRowSpan;
    var _useContextSelector = (0, $e335d904edbf3e32$export$30b2013e16e635d0)((0, $dc76e9514d25190e$export$2e2bcd8739ae039), function(cxt) {
        var isHovering = $d03a31adffb8f073$var$inHoverRange(index, mergedRowSpan || 1, cxt === null || cxt === void 0 ? void 0 : cxt.startRow, cxt === null || cxt === void 0 ? void 0 : cxt.endRow);
        return {
            onHover: cxt === null || cxt === void 0 ? void 0 : cxt.onHover,
            hovering: isHovering
        };
    }), onHover = _useContextSelector.onHover, hovering = _useContextSelector.hovering;
    return /*#__PURE__*/ $6fFrj.createElement($d03a31adffb8f073$var$MemoCell, (0, $fIrcP.default)({}, props, {
        colSpan: mergedColSpan,
        rowSpan: mergedRowSpan,
        hovering: hovering,
        ref: ref,
        onHover: onHover
    }));
});
$d03a31adffb8f073$var$WrappedCell.displayName = 'WrappedCell';
var $d03a31adffb8f073$export$2e2bcd8739ae039 = $d03a31adffb8f073$var$WrappedCell;



var $6fFrj = parcelRequire("6fFrj");
var $8434d0e3abd7ec15$var$TableContext = /*#__PURE__*/ $6fFrj.createContext(null);
var $8434d0e3abd7ec15$export$2e2bcd8739ae039 = $8434d0e3abd7ec15$var$TableContext;


function $7f782721787757c9$export$695db918331141f3(colStart, colEnd, columns, stickyOffsets, direction) {
    var startColumn = columns[colStart] || {};
    var endColumn = columns[colEnd] || {};
    var fixLeft;
    var fixRight;
    if (startColumn.fixed === 'left') fixLeft = stickyOffsets.left[colStart];
    else if (endColumn.fixed === 'right') fixRight = stickyOffsets.right[colEnd];
    var lastFixLeft = false;
    var firstFixRight = false;
    var lastFixRight = false;
    var firstFixLeft = false;
    var nextColumn = columns[colEnd + 1];
    var prevColumn = columns[colStart - 1];
    if (direction === 'rtl') {
        if (fixLeft !== undefined) {
            var prevFixLeft = prevColumn && prevColumn.fixed === 'left';
            firstFixLeft = !prevFixLeft;
        } else if (fixRight !== undefined) {
            var nextFixRight = nextColumn && nextColumn.fixed === 'right';
            lastFixRight = !nextFixRight;
        }
    } else if (fixLeft !== undefined) {
        var nextFixLeft = nextColumn && nextColumn.fixed === 'left';
        lastFixLeft = !nextFixLeft;
    } else if (fixRight !== undefined) {
        var prevFixRight = prevColumn && prevColumn.fixed === 'right';
        firstFixRight = !prevFixRight;
    }
    return {
        fixLeft: fixLeft,
        fixRight: fixRight,
        lastFixLeft: lastFixLeft,
        firstFixRight: firstFixRight,
        lastFixRight: lastFixRight,
        firstFixLeft: firstFixLeft,
        isSticky: stickyOffsets.isSticky
    };
}



function $165ac387f429e14c$var$HeaderRow(_ref) {
    var cells = _ref.cells, stickyOffsets = _ref.stickyOffsets, flattenColumns = _ref.flattenColumns, RowComponent = _ref.rowComponent, CellComponent = _ref.cellComponent, onHeaderRow = _ref.onHeaderRow, index = _ref.index;
    var _React$useContext = $6fFrj.useContext((0, $8434d0e3abd7ec15$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, direction = _React$useContext.direction;
    var rowProps;
    if (onHeaderRow) rowProps = onHeaderRow(cells.map(function(cell) {
        return cell.column;
    }), index);
    var columnsKey = (0, $7d023320b5dd5fb7$export$fd2ca5407d9be470)(cells.map(function(cell) {
        return cell.column;
    }));
    return /*#__PURE__*/ $6fFrj.createElement(RowComponent, rowProps, cells.map(function(cell, cellIndex) {
        var column = cell.column;
        var fixedInfo = (0, $7f782721787757c9$export$695db918331141f3)(cell.colStart, cell.colEnd, flattenColumns, stickyOffsets, direction);
        var additionalProps;
        if (column && column.onHeaderCell) additionalProps = cell.column.onHeaderCell(column);
        return /*#__PURE__*/ $6fFrj.createElement((0, $d03a31adffb8f073$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, cell, {
            ellipsis: column.ellipsis,
            align: column.align,
            component: CellComponent,
            prefixCls: prefixCls,
            key: columnsKey[cellIndex]
        }, fixedInfo, {
            additionalProps: additionalProps,
            rowType: "header"
        }));
    }));
}
$165ac387f429e14c$var$HeaderRow.displayName = 'HeaderRow';
var $165ac387f429e14c$export$2e2bcd8739ae039 = $165ac387f429e14c$var$HeaderRow;



function $a97da572ca9b7806$var$parseHeaderRows(rootColumns) {
    var rows = [];
    function fillRowCells(columns, colIndex) {
        var rowIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        // Init rows
        rows[rowIndex] = rows[rowIndex] || [];
        var currentColIndex = colIndex;
        var colSpans = columns.filter(Boolean).map(function(column) {
            var cell = {
                key: column.key,
                className: column.className || '',
                children: column.title,
                column: column,
                colStart: currentColIndex
            };
            var colSpan = 1;
            var subColumns = column.children;
            if (subColumns && subColumns.length > 0) {
                colSpan = fillRowCells(subColumns, currentColIndex, rowIndex + 1).reduce(function(total, count) {
                    return total + count;
                }, 0);
                cell.hasSubColumns = true;
            }
            if ('colSpan' in column) colSpan = column.colSpan;
            if ('rowSpan' in column) cell.rowSpan = column.rowSpan;
            cell.colSpan = colSpan;
            cell.colEnd = cell.colStart + colSpan - 1;
            rows[rowIndex].push(cell);
            currentColIndex += colSpan;
            return colSpan;
        });
        return colSpans;
    } // Generate `rows` cell data
    fillRowCells(rootColumns, 0); // Handle `rowSpan`
    var rowCount = rows.length;
    var _loop = function _loop(rowIndex) {
        rows[rowIndex].forEach(function(cell) {
            if (!('rowSpan' in cell) && !cell.hasSubColumns) // eslint-disable-next-line no-param-reassign
            cell.rowSpan = rowCount - rowIndex;
        });
    };
    for(var rowIndex = 0; rowIndex < rowCount; rowIndex += 1)_loop(rowIndex);
    return rows;
}
function $a97da572ca9b7806$var$Header(_ref) {
    var stickyOffsets = _ref.stickyOffsets, columns = _ref.columns, flattenColumns = _ref.flattenColumns, onHeaderRow = _ref.onHeaderRow;
    var _React$useContext = $6fFrj.useContext((0, $8434d0e3abd7ec15$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, getComponent = _React$useContext.getComponent;
    var rows = $6fFrj.useMemo(function() {
        return $a97da572ca9b7806$var$parseHeaderRows(columns);
    }, [
        columns
    ]);
    var WrapperComponent = getComponent([
        'header',
        'wrapper'
    ], 'thead');
    var trComponent = getComponent([
        'header',
        'row'
    ], 'tr');
    var thComponent = getComponent([
        'header',
        'cell'
    ], 'th');
    return /*#__PURE__*/ $6fFrj.createElement(WrapperComponent, {
        className: "".concat(prefixCls, "-thead")
    }, rows.map(function(row, rowIndex) {
        var rowNode = /*#__PURE__*/ $6fFrj.createElement((0, $165ac387f429e14c$export$2e2bcd8739ae039), {
            key: rowIndex,
            flattenColumns: flattenColumns,
            cells: row,
            stickyOffsets: stickyOffsets,
            rowComponent: trComponent,
            cellComponent: thComponent,
            onHeaderRow: onHeaderRow,
            index: rowIndex
        });
        return rowNode;
    }));
}
var $a97da572ca9b7806$export$2e2bcd8739ae039 = $a97da572ca9b7806$var$Header;





var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");



var $6fFrj = parcelRequire("6fFrj");
var $41a9814d3c65b4c6$var$ExpandedRowContext = /*#__PURE__*/ $6fFrj.createContext(null);
var $41a9814d3c65b4c6$export$2e2bcd8739ae039 = $41a9814d3c65b4c6$var$ExpandedRowContext;


function $84b5051ba0166e8f$var$ExpandedRow(_ref) {
    var prefixCls = _ref.prefixCls, children = _ref.children, Component = _ref.component, cellComponent = _ref.cellComponent, className = _ref.className, expanded = _ref.expanded, colSpan = _ref.colSpan, isEmpty = _ref.isEmpty;
    var _React$useContext = $6fFrj.useContext((0, $8434d0e3abd7ec15$export$2e2bcd8739ae039)), scrollbarSize = _React$useContext.scrollbarSize;
    var _React$useContext2 = $6fFrj.useContext((0, $41a9814d3c65b4c6$export$2e2bcd8739ae039)), fixHeader = _React$useContext2.fixHeader, fixColumn = _React$useContext2.fixColumn, componentWidth = _React$useContext2.componentWidth, horizonScroll = _React$useContext2.horizonScroll; // Cache render node
    return $6fFrj.useMemo(function() {
        var contentNode = children;
        if (isEmpty ? horizonScroll : fixColumn) contentNode = /*#__PURE__*/ $6fFrj.createElement("div", {
            style: {
                width: componentWidth - (fixHeader ? scrollbarSize : 0),
                position: 'sticky',
                left: 0,
                overflow: 'hidden'
            },
            className: "".concat(prefixCls, "-expanded-row-fixed")
        }, componentWidth !== 0 && contentNode);
        return /*#__PURE__*/ $6fFrj.createElement(Component, {
            className: className,
            style: {
                display: expanded ? null : 'none'
            }
        }, /*#__PURE__*/ $6fFrj.createElement((0, $d03a31adffb8f073$export$2e2bcd8739ae039), {
            component: cellComponent,
            prefixCls: prefixCls,
            colSpan: colSpan
        }, contentNode));
    }, [
        children,
        Component,
        className,
        expanded,
        colSpan,
        isEmpty,
        scrollbarSize,
        componentWidth,
        fixColumn,
        fixHeader,
        horizonScroll
    ]);
}
var $84b5051ba0166e8f$export$2e2bcd8739ae039 = $84b5051ba0166e8f$var$ExpandedRow;





var $6fFrj = parcelRequire("6fFrj");
var $9d0d755dab66343f$var$ResizeContext = /*#__PURE__*/ $6fFrj.createContext(null);
var $9d0d755dab66343f$export$2e2bcd8739ae039 = $9d0d755dab66343f$var$ResizeContext;



var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");





function $1bb655f6f89fb8b2$var$BodyRow(props) {
    var className = props.className, style = props.style, record = props.record, index = props.index, renderIndex = props.renderIndex, rowKey = props.rowKey, rowExpandable = props.rowExpandable, expandedKeys = props.expandedKeys, onRow = props.onRow, _props$indent = props.indent, indent = _props$indent === void 0 ? 0 : _props$indent, RowComponent = props.rowComponent, cellComponent = props.cellComponent, childrenColumnName = props.childrenColumnName;
    var _React$useContext = $6fFrj.useContext((0, $8434d0e3abd7ec15$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, fixedInfoList = _React$useContext.fixedInfoList;
    var _React$useContext2 = $6fFrj.useContext((0, $531ee63ef59dd731$export$2e2bcd8739ae039)), flattenColumns = _React$useContext2.flattenColumns, expandableType = _React$useContext2.expandableType, expandRowByClick = _React$useContext2.expandRowByClick, onTriggerExpand = _React$useContext2.onTriggerExpand, rowClassName = _React$useContext2.rowClassName, expandedRowClassName = _React$useContext2.expandedRowClassName, indentSize = _React$useContext2.indentSize, expandIcon = _React$useContext2.expandIcon, expandedRowRender = _React$useContext2.expandedRowRender, expandIconColumnIndex = _React$useContext2.expandIconColumnIndex;
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), expandRended = _React$useState2[0], setExpandRended = _React$useState2[1];
    var expanded = expandedKeys && expandedKeys.has(props.recordKey);
    $6fFrj.useEffect(function() {
        if (expanded) setExpandRended(true);
    }, [
        expanded
    ]);
    var rowSupportExpand = expandableType === 'row' && (!rowExpandable || rowExpandable(record)); // Only when row is not expandable and `children` exist in record
    var nestExpandable = expandableType === 'nest';
    var hasNestChildren = childrenColumnName && record && record[childrenColumnName];
    var mergedExpandable = rowSupportExpand || nestExpandable; // ======================== Expandable =========================
    var onExpandRef = $6fFrj.useRef(onTriggerExpand);
    onExpandRef.current = onTriggerExpand;
    var onInternalTriggerExpand = function onInternalTriggerExpand() {
        onExpandRef.current.apply(onExpandRef, arguments);
    }; // =========================== onRow ===========================
    var additionalProps = onRow === null || onRow === void 0 ? void 0 : onRow(record, index);
    var onClick = function onClick(event) {
        var _additionalProps$onCl;
        if (expandRowByClick && mergedExpandable) onInternalTriggerExpand(record, event);
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        additionalProps === null || additionalProps === void 0 || (_additionalProps$onCl = additionalProps.onClick) === null || _additionalProps$onCl === void 0 || _additionalProps$onCl.call.apply(_additionalProps$onCl, [
            additionalProps,
            event
        ].concat(args));
    }; // ======================== Base tr row ========================
    var computeRowClassName;
    if (typeof rowClassName === 'string') computeRowClassName = rowClassName;
    else if (typeof rowClassName === 'function') computeRowClassName = rowClassName(record, index, indent);
    var columnsKey = (0, $7d023320b5dd5fb7$export$fd2ca5407d9be470)(flattenColumns);
    var baseRowNode = /*#__PURE__*/ $6fFrj.createElement(RowComponent, (0, $fIrcP.default)({}, additionalProps, {
        "data-row-key": rowKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(className, "".concat(prefixCls, "-row"), "".concat(prefixCls, "-row-level-").concat(indent), computeRowClassName, additionalProps && additionalProps.className),
        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, style), additionalProps ? additionalProps.style : null),
        onClick: onClick
    }), flattenColumns.map(function(column, colIndex) {
        var render = column.render, dataIndex = column.dataIndex, columnClassName = column.className;
        var key = columnsKey[colIndex];
        var fixedInfo = fixedInfoList[colIndex]; // ============= Used for nest expandable =============
        var appendCellNode;
        if (colIndex === (expandIconColumnIndex || 0) && nestExpandable) appendCellNode = /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, /*#__PURE__*/ $6fFrj.createElement("span", {
            style: {
                paddingLeft: "".concat(indentSize * indent, "px")
            },
            className: "".concat(prefixCls, "-row-indent indent-level-").concat(indent)
        }), expandIcon({
            prefixCls: prefixCls,
            expanded: expanded,
            expandable: hasNestChildren,
            record: record,
            onExpand: onInternalTriggerExpand
        }));
        var additionalCellProps;
        if (column.onCell) additionalCellProps = column.onCell(record, index);
        return /*#__PURE__*/ $6fFrj.createElement((0, $d03a31adffb8f073$export$2e2bcd8739ae039), (0, $fIrcP.default)({
            className: columnClassName,
            ellipsis: column.ellipsis,
            align: column.align,
            component: cellComponent,
            prefixCls: prefixCls,
            key: key,
            record: record,
            index: index,
            renderIndex: renderIndex,
            dataIndex: dataIndex,
            render: render,
            shouldCellUpdate: column.shouldCellUpdate,
            expanded: appendCellNode && expanded
        }, fixedInfo, {
            appendNode: appendCellNode,
            additionalProps: additionalCellProps
        }));
    })); // ======================== Expand Row =========================
    var expandRowNode;
    if (rowSupportExpand && (expandRended || expanded)) {
        var expandContent = expandedRowRender(record, index, indent + 1, expanded);
        var computedExpandedRowClassName = expandedRowClassName && expandedRowClassName(record, index, indent);
        expandRowNode = /*#__PURE__*/ $6fFrj.createElement((0, $84b5051ba0166e8f$export$2e2bcd8739ae039), {
            expanded: expanded,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-expanded-row"), "".concat(prefixCls, "-expanded-row-level-").concat(indent + 1), computedExpandedRowClassName),
            prefixCls: prefixCls,
            component: RowComponent,
            cellComponent: cellComponent,
            colSpan: flattenColumns.length,
            isEmpty: false
        }, expandContent);
    }
    return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, baseRowNode, expandRowNode);
}
$1bb655f6f89fb8b2$var$BodyRow.displayName = 'BodyRow';
var $1bb655f6f89fb8b2$export$2e2bcd8739ae039 = $1bb655f6f89fb8b2$var$BodyRow;



var $37xND = parcelRequire("37xND");

var $6fFrj = parcelRequire("6fFrj");
function $390cdc4f4ee42042$var$flatRecord(record, indent, childrenColumnName, expandedKeys, getRowKey, index) {
    var arr = [];
    arr.push({
        record: record,
        indent: indent,
        index: index
    });
    var key = getRowKey(record);
    var expanded = expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.has(key);
    if (record && Array.isArray(record[childrenColumnName]) && expanded) // expanded state, flat record
    for(var i = 0; i < record[childrenColumnName].length; i += 1){
        var tempArr = $390cdc4f4ee42042$var$flatRecord(record[childrenColumnName][i], indent + 1, childrenColumnName, expandedKeys, getRowKey, i);
        arr.push.apply(arr, (0, $37xND.default)(tempArr));
    }
    return arr;
}
function $390cdc4f4ee42042$export$2e2bcd8739ae039(data, childrenColumnName, expandedKeys, getRowKey) {
    var arr = $6fFrj.useMemo(function() {
        if (expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.size) {
            var temp = []; // collect flattened record
            for(var i = 0; i < (data === null || data === void 0 ? void 0 : data.length); i += 1){
                var record = data[i];
                temp.push.apply(temp, (0, $37xND.default)($390cdc4f4ee42042$var$flatRecord(record, 0, childrenColumnName, expandedKeys, getRowKey, i)));
            }
            return temp;
        }
        return data === null || data === void 0 ? void 0 : data.map(function(item, index) {
            return {
                record: item,
                indent: 0,
                index: index
            };
        });
    }, [
        data,
        childrenColumnName,
        expandedKeys,
        getRowKey
    ]);
    return arr;
}





var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");

function $6849ff2ef7429665$export$2e2bcd8739ae039(_ref) {
    var columnKey = _ref.columnKey, onColumnResize = _ref.onColumnResize;
    var cellRef = $6fFrj.useRef();
    $6fFrj.useEffect(function() {
        if (cellRef.current) onColumnResize(columnKey, cellRef.current.offsetWidth);
    }, []);
    return /*#__PURE__*/ $6fFrj.createElement((0, $8e6bb008621f90f5$export$2e2bcd8739ae039), {
        data: columnKey
    }, /*#__PURE__*/ $6fFrj.createElement("td", {
        ref: cellRef,
        style: {
            padding: 0,
            border: 0,
            height: 0
        }
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        style: {
            height: 0,
            overflow: 'hidden'
        }
    }, "\xA0")));
}


function $c551db8fb18127e0$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, columnsKey = _ref.columnsKey, onColumnResize = _ref.onColumnResize;
    return /*#__PURE__*/ $6fFrj.createElement("tr", {
        "aria-hidden": "true",
        className: "".concat(prefixCls, "-measure-row"),
        style: {
            height: 0,
            fontSize: 0
        }
    }, /*#__PURE__*/ $6fFrj.createElement((0, $8e6bb008621f90f5$export$2e2bcd8739ae039).Collection, {
        onBatchResize: function onBatchResize(infoList) {
            infoList.forEach(function(_ref2) {
                var columnKey = _ref2.data, size = _ref2.size;
                onColumnResize(columnKey, size.offsetWidth);
            });
        }
    }, columnsKey.map(function(columnKey) {
        return /*#__PURE__*/ $6fFrj.createElement((0, $6849ff2ef7429665$export$2e2bcd8739ae039), {
            key: columnKey,
            columnKey: columnKey,
            onColumnResize: onColumnResize
        });
    })));
}


function $6b7076aa407e45f1$var$Body(_ref) {
    var data = _ref.data, getRowKey = _ref.getRowKey, measureColumnWidth = _ref.measureColumnWidth, expandedKeys = _ref.expandedKeys, onRow = _ref.onRow, rowExpandable = _ref.rowExpandable, emptyNode = _ref.emptyNode, childrenColumnName = _ref.childrenColumnName;
    var _React$useContext = $6fFrj.useContext((0, $9d0d755dab66343f$export$2e2bcd8739ae039)), onColumnResize = _React$useContext.onColumnResize;
    var _React$useContext2 = $6fFrj.useContext((0, $8434d0e3abd7ec15$export$2e2bcd8739ae039)), prefixCls = _React$useContext2.prefixCls, getComponent = _React$useContext2.getComponent;
    var _React$useContext3 = $6fFrj.useContext((0, $531ee63ef59dd731$export$2e2bcd8739ae039)), flattenColumns = _React$useContext3.flattenColumns;
    var flattenData = (0, $390cdc4f4ee42042$export$2e2bcd8739ae039)(data, childrenColumnName, expandedKeys, getRowKey); // =================== Performance ====================
    var perfRef = $6fFrj.useRef({
        renderWithProps: false
    }); // ====================== Hover =======================
    var _React$useState = $6fFrj.useState(-1), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), startRow = _React$useState2[0], setStartRow = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState(-1), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), endRow = _React$useState4[0], setEndRow = _React$useState4[1];
    var onHover = $6fFrj.useCallback(function(start, end) {
        setStartRow(start);
        setEndRow(end);
    }, []); // ====================== Render ======================
    var bodyNode = $6fFrj.useMemo(function() {
        var WrapperComponent = getComponent([
            'body',
            'wrapper'
        ], 'tbody');
        var trComponent = getComponent([
            'body',
            'row'
        ], 'tr');
        var tdComponent = getComponent([
            'body',
            'cell'
        ], 'td');
        var rows;
        if (data.length) rows = flattenData.map(function(item, idx) {
            var record = item.record, indent = item.indent, renderIndex = item.index;
            var key = getRowKey(record, idx);
            return /*#__PURE__*/ $6fFrj.createElement((0, $1bb655f6f89fb8b2$export$2e2bcd8739ae039), {
                key: key,
                rowKey: key,
                record: record,
                recordKey: key,
                index: idx,
                renderIndex: renderIndex,
                rowComponent: trComponent,
                cellComponent: tdComponent,
                expandedKeys: expandedKeys,
                onRow: onRow,
                getRowKey: getRowKey,
                rowExpandable: rowExpandable,
                childrenColumnName: childrenColumnName,
                indent: indent
            });
        });
        else rows = /*#__PURE__*/ $6fFrj.createElement((0, $84b5051ba0166e8f$export$2e2bcd8739ae039), {
            expanded: true,
            className: "".concat(prefixCls, "-placeholder"),
            prefixCls: prefixCls,
            component: trComponent,
            cellComponent: tdComponent,
            colSpan: flattenColumns.length,
            isEmpty: true
        }, emptyNode);
        var columnsKey = (0, $7d023320b5dd5fb7$export$fd2ca5407d9be470)(flattenColumns);
        return /*#__PURE__*/ $6fFrj.createElement(WrapperComponent, {
            className: "".concat(prefixCls, "-tbody")
        }, measureColumnWidth && /*#__PURE__*/ $6fFrj.createElement((0, $c551db8fb18127e0$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            columnsKey: columnsKey,
            onColumnResize: onColumnResize
        }), rows);
    }, [
        data,
        prefixCls,
        onRow,
        measureColumnWidth,
        expandedKeys,
        getRowKey,
        getComponent,
        emptyNode,
        flattenColumns,
        childrenColumnName,
        onColumnResize,
        rowExpandable,
        flattenData
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $0b69e3c5446363d0$export$2e2bcd8739ae039).Provider, {
        value: perfRef.current
    }, /*#__PURE__*/ $6fFrj.createElement((0, $dc76e9514d25190e$export$2e2bcd8739ae039).Provider, {
        value: {
            startRow: startRow,
            endRow: endRow,
            onHover: onHover
        }
    }, bodyNode));
}
var $6b7076aa407e45f1$var$MemoBody = /*#__PURE__*/ $6fFrj.memo($6b7076aa407e45f1$var$Body);
$6b7076aa407e45f1$var$MemoBody.displayName = 'Body';
var $6b7076aa407e45f1$export$2e2bcd8739ae039 = $6b7076aa407e45f1$var$MemoBody;



var $43449 = parcelRequire("43449");

var $37xND = parcelRequire("37xND");

var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $3mXQ2 = parcelRequire("3mXQ2");


var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");
parcelRequire("3mXQ2");
var $91cd49b10058c8a6$var$_excluded = [
    "expandable"
];
var $91cd49b10058c8a6$export$f8dba99c0d5b6b87 = 'RC_TABLE_INTERNAL_COL_DEFINE';
function $91cd49b10058c8a6$export$e215b9806eacdfb5(props) {
    var expandable = props.expandable, legacyExpandableConfig = (0, $04RxA.default)(props, $91cd49b10058c8a6$var$_excluded);
    var config;
    if ('expandable' in props) config = (0, $kNxFX.default)((0, $kNxFX.default)({}, legacyExpandableConfig), expandable);
    else config = legacyExpandableConfig;
    if (config.showExpandColumn === false) config.expandIconColumnIndex = -1;
    return config;
}


var $aedad8117e1ff1f2$export$e1053575ddfcb301 = {};


var $f010cefebeb2fe47$var$_excluded = [
    "children"
], $f010cefebeb2fe47$var$_excluded2 = [
    "fixed"
];
function $f010cefebeb2fe47$export$d87a97eba44e0f9c(children) {
    return (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(children).filter(function(node) {
        return /*#__PURE__*/ $6fFrj.isValidElement(node);
    }).map(function(_ref) {
        var key = _ref.key, props = _ref.props;
        var nodeChildren = props.children, restProps = (0, $04RxA.default)(props, $f010cefebeb2fe47$var$_excluded);
        var column = (0, $kNxFX.default)({
            key: key
        }, restProps);
        if (nodeChildren) column.children = $f010cefebeb2fe47$export$d87a97eba44e0f9c(nodeChildren);
        return column;
    });
}
function $f010cefebeb2fe47$var$flatColumns(columns) {
    return columns.reduce(function(list, column) {
        var fixed = column.fixed; // Convert `fixed='true'` to `fixed='left'` instead
        var parsedFixed = fixed === true ? 'left' : fixed;
        var subColumns = column.children;
        if (subColumns && subColumns.length > 0) return [].concat((0, $37xND.default)(list), (0, $37xND.default)($f010cefebeb2fe47$var$flatColumns(subColumns).map(function(subColum) {
            return (0, $kNxFX.default)({
                fixed: parsedFixed
            }, subColum);
        })));
        return [].concat((0, $37xND.default)(list), [
            (0, $kNxFX.default)((0, $kNxFX.default)({}, column), {}, {
                fixed: parsedFixed
            })
        ]);
    }, []);
}
function $f010cefebeb2fe47$var$warningFixed(flattenColumns) {
    var allFixLeft = true;
    for(var i = 0; i < flattenColumns.length; i += 1){
        var col = flattenColumns[i];
        if (allFixLeft && col.fixed !== 'left') allFixLeft = false;
        else if (!allFixLeft && col.fixed === 'left') {
            (0, $3mXQ2.default)(false, "Index ".concat(i - 1, " of `columns` missing `fixed='left'` prop."));
            break;
        }
    }
    var allFixRight = true;
    for(var _i = flattenColumns.length - 1; _i >= 0; _i -= 1){
        var _col = flattenColumns[_i];
        if (allFixRight && _col.fixed !== 'right') allFixRight = false;
        else if (!allFixRight && _col.fixed === 'right') {
            (0, $3mXQ2.default)(false, "Index ".concat(_i + 1, " of `columns` missing `fixed='right'` prop."));
            break;
        }
    }
}
function $f010cefebeb2fe47$var$revertForRtl(columns) {
    return columns.map(function(column) {
        var fixed = column.fixed, restProps = (0, $04RxA.default)(column, $f010cefebeb2fe47$var$_excluded2); // Convert `fixed='left'` to `fixed='right'` instead
        var parsedFixed = fixed;
        if (fixed === 'left') parsedFixed = 'right';
        else if (fixed === 'right') parsedFixed = 'left';
        return (0, $kNxFX.default)({
            fixed: parsedFixed
        }, restProps);
    });
}
/**
 * Parse `columns` & `children` into `columns`.
 */ function $f010cefebeb2fe47$var$useColumns(_ref2, transformColumns) {
    var prefixCls = _ref2.prefixCls, columns = _ref2.columns, children = _ref2.children, expandable = _ref2.expandable, expandedKeys = _ref2.expandedKeys, columnTitle = _ref2.columnTitle, getRowKey = _ref2.getRowKey, onTriggerExpand = _ref2.onTriggerExpand, expandIcon = _ref2.expandIcon, rowExpandable = _ref2.rowExpandable, expandIconColumnIndex = _ref2.expandIconColumnIndex, direction = _ref2.direction, expandRowByClick = _ref2.expandRowByClick, columnWidth = _ref2.columnWidth, fixed = _ref2.fixed;
    var baseColumns = $6fFrj.useMemo(function() {
        return columns || $f010cefebeb2fe47$export$d87a97eba44e0f9c(children);
    }, [
        columns,
        children
    ]); // ========================== Expand ==========================
    var withExpandColumns = $6fFrj.useMemo(function() {
        if (expandable) {
            var _expandColumn;
            var cloneColumns = baseColumns.slice(); // >>> Warning if use `expandIconColumnIndex`
            if (!cloneColumns.includes((0, $aedad8117e1ff1f2$export$e1053575ddfcb301))) {
                var expandColIndex = expandIconColumnIndex || 0;
                if (expandColIndex >= 0) cloneColumns.splice(expandColIndex, 0, (0, $aedad8117e1ff1f2$export$e1053575ddfcb301));
            } // >>> Deduplicate additional expand column
            var expandColumnIndex = cloneColumns.indexOf((0, $aedad8117e1ff1f2$export$e1053575ddfcb301));
            cloneColumns = cloneColumns.filter(function(column, index) {
                return column !== (0, $aedad8117e1ff1f2$export$e1053575ddfcb301) || index === expandColumnIndex;
            }); // >>> Check if expand column need to fixed
            var prevColumn = baseColumns[expandColumnIndex];
            var fixedColumn;
            if ((fixed === 'left' || fixed) && !expandIconColumnIndex) fixedColumn = 'left';
            else if ((fixed === 'right' || fixed) && expandIconColumnIndex === baseColumns.length) fixedColumn = 'right';
            else fixedColumn = prevColumn ? prevColumn.fixed : null;
             // >>> Create expandable column
            var expandColumn = (_expandColumn = {}, (0, $43449.default)(_expandColumn, (0, $91cd49b10058c8a6$export$f8dba99c0d5b6b87), {
                className: "".concat(prefixCls, "-expand-icon-col"),
                columnType: 'EXPAND_COLUMN'
            }), (0, $43449.default)(_expandColumn, "title", columnTitle), (0, $43449.default)(_expandColumn, "fixed", fixedColumn), (0, $43449.default)(_expandColumn, "className", "".concat(prefixCls, "-row-expand-icon-cell")), (0, $43449.default)(_expandColumn, "width", columnWidth), (0, $43449.default)(_expandColumn, "render", function render(_, record, index) {
                var rowKey = getRowKey(record, index);
                var expanded = expandedKeys.has(rowKey);
                var recordExpandable = rowExpandable ? rowExpandable(record) : true;
                var icon = expandIcon({
                    prefixCls: prefixCls,
                    expanded: expanded,
                    expandable: recordExpandable,
                    record: record,
                    onExpand: onTriggerExpand
                });
                if (expandRowByClick) return /*#__PURE__*/ $6fFrj.createElement("span", {
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    }
                }, icon);
                return icon;
            }), _expandColumn);
            return cloneColumns.map(function(col) {
                return col === (0, $aedad8117e1ff1f2$export$e1053575ddfcb301) ? expandColumn : col;
            });
        }
        return baseColumns.filter(function(col) {
            return col !== (0, $aedad8117e1ff1f2$export$e1053575ddfcb301);
        });
    }, [
        expandable,
        baseColumns,
        getRowKey,
        expandedKeys,
        expandIcon,
        direction
    ]); // ========================= Transform ========================
    var mergedColumns = $6fFrj.useMemo(function() {
        var finalColumns = withExpandColumns;
        if (transformColumns) finalColumns = transformColumns(finalColumns);
         // Always provides at least one column for table display
        if (!finalColumns.length) finalColumns = [
            {
                render: function render() {
                    return null;
                }
            }
        ];
        return finalColumns;
    }, [
        transformColumns,
        withExpandColumns,
        direction
    ]); // ========================== Flatten =========================
    var flattenColumns = $6fFrj.useMemo(function() {
        if (direction === 'rtl') return $f010cefebeb2fe47$var$revertForRtl($f010cefebeb2fe47$var$flatColumns(mergedColumns));
        return $f010cefebeb2fe47$var$flatColumns(mergedColumns);
    }, [
        mergedColumns,
        direction
    ]); // Only check out of production since it's waste for each render
    return [
        mergedColumns,
        flattenColumns
    ];
}
var $f010cefebeb2fe47$export$2e2bcd8739ae039 = $f010cefebeb2fe47$var$useColumns;



var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
function $ddf8567d6de61db5$export$510e4dd13e0b67dd(defaultState) {
    var stateRef = (0, $6fFrj.useRef)(defaultState);
    var _useState = (0, $6fFrj.useState)({}), _useState2 = (0, $jP8CL.default)(_useState, 2), forceUpdate = _useState2[1];
    var lastPromiseRef = (0, $6fFrj.useRef)(null);
    var updateBatchRef = (0, $6fFrj.useRef)([]);
    function setFrameState(updater) {
        updateBatchRef.current.push(updater);
        var promise = Promise.resolve();
        lastPromiseRef.current = promise;
        promise.then(function() {
            if (lastPromiseRef.current === promise) {
                var prevBatch = updateBatchRef.current;
                var prevState = stateRef.current;
                updateBatchRef.current = [];
                prevBatch.forEach(function(batchUpdater) {
                    stateRef.current = batchUpdater(stateRef.current);
                });
                lastPromiseRef.current = null;
                if (prevState !== stateRef.current) forceUpdate({});
            }
        });
    }
    (0, $6fFrj.useEffect)(function() {
        return function() {
            lastPromiseRef.current = null;
        };
    }, []);
    return [
        stateRef.current,
        setFrameState
    ];
}
function $ddf8567d6de61db5$export$d63c72d5e6d02249(defaultState) {
    var frameRef = (0, $6fFrj.useRef)(defaultState || null);
    var timeoutRef = (0, $6fFrj.useRef)();
    function cleanUp() {
        window.clearTimeout(timeoutRef.current);
    }
    function setState(newState) {
        frameRef.current = newState;
        cleanUp();
        timeoutRef.current = window.setTimeout(function() {
            frameRef.current = null;
            timeoutRef.current = undefined;
        }, 100);
    }
    function getState() {
        return frameRef.current;
    }
    (0, $6fFrj.useEffect)(function() {
        return cleanUp;
    }, []);
    return [
        setState,
        getState
    ];
}





var $6fFrj = parcelRequire("6fFrj");
/**
 * Get sticky column offset width
 */ function $7bbf4b3236227744$var$useStickyOffsets(colWidths, columnCount, direction) {
    var stickyOffsets = (0, $6fFrj.useMemo)(function() {
        var leftOffsets = [];
        var rightOffsets = [];
        var left = 0;
        var right = 0;
        for(var start = 0; start < columnCount; start += 1)if (direction === 'rtl') {
            // Left offset
            rightOffsets[start] = right;
            right += colWidths[start] || 0; // Right offset
            var end = columnCount - start - 1;
            leftOffsets[end] = left;
            left += colWidths[end] || 0;
        } else {
            // Left offset
            leftOffsets[start] = left;
            left += colWidths[start] || 0; // Right offset
            var _end = columnCount - start - 1;
            rightOffsets[_end] = right;
            right += colWidths[_end] || 0;
        }
        return {
            left: leftOffsets,
            right: rightOffsets
        };
    }, [
        colWidths,
        columnCount,
        direction
    ]);
    return stickyOffsets;
}
var $7bbf4b3236227744$export$2e2bcd8739ae039 = $7bbf4b3236227744$var$useStickyOffsets;



var $fIrcP = parcelRequire("fIrcP");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $74fe57c7ba9725ad$var$_excluded = [
    "columnType"
];
function $74fe57c7ba9725ad$var$ColGroup(_ref) {
    var colWidths = _ref.colWidths, columns = _ref.columns, columCount = _ref.columCount;
    var cols = [];
    var len = columCount || columns.length; // Only insert col with width & additional props
    // Skip if rest col do not have any useful info
    var mustInsert = false;
    for(var i = len - 1; i >= 0; i -= 1){
        var width = colWidths[i];
        var column = columns && columns[i];
        var additionalProps = column && column[0, $91cd49b10058c8a6$export$f8dba99c0d5b6b87];
        if (width || additionalProps || mustInsert) {
            var _ref2 = additionalProps || {}, columnType = _ref2.columnType, restAdditionalProps = (0, $04RxA.default)(_ref2, $74fe57c7ba9725ad$var$_excluded);
            cols.unshift(/*#__PURE__*/ $6fFrj.createElement("col", (0, $fIrcP.default)({
                key: i,
                style: {
                    width: width
                }
            }, restAdditionalProps)));
            mustInsert = true;
        }
    }
    return /*#__PURE__*/ $6fFrj.createElement("colgroup", null, cols);
}
var $74fe57c7ba9725ad$export$2e2bcd8739ae039 = $74fe57c7ba9725ad$var$ColGroup;




var $6fFrj = parcelRequire("6fFrj");
function $b46970e0e0191165$var$Panel(_ref) {
    var className = _ref.className, children = _ref.children;
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: className
    }, children);
}
var $b46970e0e0191165$export$2e2bcd8739ae039 = $b46970e0e0191165$var$Panel;



var $6fFrj = parcelRequire("6fFrj");


var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");
var $adce16139c973c53$var$SummaryContext = /*#__PURE__*/ $6fFrj.createContext({});
var $adce16139c973c53$export$2e2bcd8739ae039 = $adce16139c973c53$var$SummaryContext;





function $9f3be6373cb84a8f$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, index = _ref.index, children = _ref.children, _ref$colSpan = _ref.colSpan, colSpan = _ref$colSpan === void 0 ? 1 : _ref$colSpan, rowSpan = _ref.rowSpan, align = _ref.align;
    var _React$useContext = $6fFrj.useContext((0, $8434d0e3abd7ec15$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, direction = _React$useContext.direction;
    var _React$useContext2 = $6fFrj.useContext((0, $adce16139c973c53$export$2e2bcd8739ae039)), scrollColumnIndex = _React$useContext2.scrollColumnIndex, stickyOffsets = _React$useContext2.stickyOffsets, flattenColumns = _React$useContext2.flattenColumns;
    var lastIndex = index + colSpan - 1;
    var mergedColSpan = lastIndex + 1 === scrollColumnIndex ? colSpan + 1 : colSpan;
    var fixedInfo = (0, $7f782721787757c9$export$695db918331141f3)(index, index + mergedColSpan - 1, flattenColumns, stickyOffsets, direction);
    return /*#__PURE__*/ $6fFrj.createElement((0, $d03a31adffb8f073$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        className: className,
        index: index,
        component: "td",
        prefixCls: prefixCls,
        record: null,
        dataIndex: null,
        align: align,
        colSpan: mergedColSpan,
        rowSpan: rowSpan,
        render: function render() {
            return children;
        }
    }, fixedInfo));
}



var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");
var $bbcd6b23fda342f0$var$_excluded = [
    "children"
];
function $bbcd6b23fda342f0$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $04RxA.default)(_ref, $bbcd6b23fda342f0$var$_excluded);
    return /*#__PURE__*/ $6fFrj.createElement("tr", props, children);
}


/**
 * Syntactic sugar. Do not support HOC.
 */ function $f9096ec2a768fb9c$var$Summary(_ref) {
    var children = _ref.children;
    return children;
}
$f9096ec2a768fb9c$var$Summary.Row = (0, $bbcd6b23fda342f0$export$2e2bcd8739ae039);
$f9096ec2a768fb9c$var$Summary.Cell = (0, $9f3be6373cb84a8f$export$2e2bcd8739ae039);
var $f9096ec2a768fb9c$export$2e2bcd8739ae039 = $f9096ec2a768fb9c$var$Summary;



function $e248b732ce653607$var$Footer(_ref) {
    var children = _ref.children, stickyOffsets = _ref.stickyOffsets, flattenColumns = _ref.flattenColumns;
    var tableContext = $6fFrj.useContext((0, $8434d0e3abd7ec15$export$2e2bcd8739ae039));
    var prefixCls = tableContext.prefixCls;
    var lastColumnIndex = flattenColumns.length - 1;
    var scrollColumn = flattenColumns[lastColumnIndex];
    var summaryContext = $6fFrj.useMemo(function() {
        return {
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns,
            scrollColumnIndex: (scrollColumn === null || scrollColumn === void 0 ? void 0 : scrollColumn.scrollbar) ? lastColumnIndex : null
        };
    }, [
        scrollColumn,
        flattenColumns,
        lastColumnIndex,
        stickyOffsets
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $adce16139c973c53$export$2e2bcd8739ae039).Provider, {
        value: summaryContext
    }, /*#__PURE__*/ $6fFrj.createElement("tfoot", {
        className: "".concat(prefixCls, "-summary")
    }, children));
}
var $e248b732ce653607$export$2e2bcd8739ae039 = $e248b732ce653607$var$Footer;
var $e248b732ce653607$export$d605f3af09eef683 = (0, $f9096ec2a768fb9c$export$2e2bcd8739ae039);



var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");
function $3ad1bf6d97b64687$export$ae14373a7f810e33(_ref) {
    var _classNames;
    var prefixCls = _ref.prefixCls, record = _ref.record, onExpand = _ref.onExpand, expanded = _ref.expanded, expandable = _ref.expandable;
    var expandClassName = "".concat(prefixCls, "-row-expand-icon");
    if (!expandable) return /*#__PURE__*/ $6fFrj.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(expandClassName, "".concat(prefixCls, "-row-spaced"))
    });
    var onClick = function onClick(event) {
        onExpand(record, event);
        event.stopPropagation();
    };
    return /*#__PURE__*/ $6fFrj.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(expandClassName, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(prefixCls, "-row-expanded"), expanded), (0, $43449.default)(_classNames, "".concat(prefixCls, "-row-collapsed"), !expanded), _classNames)),
        onClick: onClick
    });
}
function $3ad1bf6d97b64687$export$49bec56f6055f375(data, getRowKey, childrenColumnName) {
    var keys = [];
    function dig(list) {
        (list || []).forEach(function(item, index) {
            keys.push(getRowKey(item, index));
            dig(item[childrenColumnName]);
        });
    }
    dig(data);
    return keys;
}




var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");



var $fActo = parcelRequire("fActo");



var $b32d53690c8914b5$var$StickyScrollBar = function StickyScrollBar(_ref, ref) {
    var _scrollBodyRef$curren, _scrollBodyRef$curren2;
    var scrollBodyRef = _ref.scrollBodyRef, onScroll = _ref.onScroll, offsetScroll = _ref.offsetScroll, container = _ref.container;
    var _React$useContext = $6fFrj.useContext((0, $8434d0e3abd7ec15$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls;
    var bodyScrollWidth = ((_scrollBodyRef$curren = scrollBodyRef.current) === null || _scrollBodyRef$curren === void 0 ? void 0 : _scrollBodyRef$curren.scrollWidth) || 0;
    var bodyWidth = ((_scrollBodyRef$curren2 = scrollBodyRef.current) === null || _scrollBodyRef$curren2 === void 0 ? void 0 : _scrollBodyRef$curren2.clientWidth) || 0;
    var scrollBarWidth = bodyScrollWidth && bodyWidth * (bodyWidth / bodyScrollWidth);
    var scrollBarRef = $6fFrj.useRef();
    var _useLayoutState = (0, $ddf8567d6de61db5$export$510e4dd13e0b67dd)({
        scrollLeft: 0,
        isHiddenScrollBar: false
    }), _useLayoutState2 = (0, $jP8CL.default)(_useLayoutState, 2), scrollState = _useLayoutState2[0], setScrollState = _useLayoutState2[1];
    var refState = $6fFrj.useRef({
        delta: 0,
        x: 0
    });
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), isActive = _React$useState2[0], setActive = _React$useState2[1];
    var onMouseUp = function onMouseUp() {
        setActive(false);
    };
    var onMouseDown = function onMouseDown(event) {
        event.persist();
        refState.current.delta = event.pageX - scrollState.scrollLeft;
        refState.current.x = 0;
        setActive(true);
        event.preventDefault();
    };
    var onMouseMove = function onMouseMove(event) {
        var _window;
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
        var _ref2 = event || ((_window = window) === null || _window === void 0 ? void 0 : _window.event), buttons = _ref2.buttons;
        if (!isActive || buttons === 0) {
            // If out body mouse up, we can set isActive false when mouse move
            if (isActive) setActive(false);
            return;
        }
        var left = refState.current.x + event.pageX - refState.current.x - refState.current.delta;
        if (left <= 0) left = 0;
        if (left + scrollBarWidth >= bodyWidth) left = bodyWidth - scrollBarWidth;
        onScroll({
            scrollLeft: left / bodyWidth * (bodyScrollWidth + 2)
        });
        refState.current.x = event.pageX;
    };
    var onContainerScroll = function onContainerScroll() {
        if (!scrollBodyRef.current) return;
        var tableOffsetTop = (0, $cfb7a0d68d50ecbf$export$622cea445a1c5b7d)(scrollBodyRef.current).top;
        var tableBottomOffset = tableOffsetTop + scrollBodyRef.current.offsetHeight;
        var currentClientOffset = container === window ? document.documentElement.scrollTop + window.innerHeight : (0, $cfb7a0d68d50ecbf$export$622cea445a1c5b7d)(container).top + container.clientHeight;
        if (tableBottomOffset - (0, $4e9e0b76ae3600bd$export$2e2bcd8739ae039)() <= currentClientOffset || tableOffsetTop >= currentClientOffset - offsetScroll) setScrollState(function(state) {
            return (0, $kNxFX.default)((0, $kNxFX.default)({}, state), {}, {
                isHiddenScrollBar: true
            });
        });
        else setScrollState(function(state) {
            return (0, $kNxFX.default)((0, $kNxFX.default)({}, state), {}, {
                isHiddenScrollBar: false
            });
        });
    };
    var setScrollLeft = function setScrollLeft(left) {
        setScrollState(function(state) {
            return (0, $kNxFX.default)((0, $kNxFX.default)({}, state), {}, {
                scrollLeft: left / bodyScrollWidth * bodyWidth || 0
            });
        });
    };
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            setScrollLeft: setScrollLeft
        };
    });
    $6fFrj.useEffect(function() {
        var onMouseUpListener = (0, $5184338d6a99a234$export$2e2bcd8739ae039)(document.body, 'mouseup', onMouseUp, false);
        var onMouseMoveListener = (0, $5184338d6a99a234$export$2e2bcd8739ae039)(document.body, 'mousemove', onMouseMove, false);
        onContainerScroll();
        return function() {
            onMouseUpListener.remove();
            onMouseMoveListener.remove();
        };
    }, [
        scrollBarWidth,
        isActive
    ]);
    $6fFrj.useEffect(function() {
        var onScrollListener = (0, $5184338d6a99a234$export$2e2bcd8739ae039)(container, 'scroll', onContainerScroll, false);
        var onResizeListener = (0, $5184338d6a99a234$export$2e2bcd8739ae039)(window, 'resize', onContainerScroll, false);
        return function() {
            onScrollListener.remove();
            onResizeListener.remove();
        };
    }, [
        container
    ]);
    $6fFrj.useEffect(function() {
        if (!scrollState.isHiddenScrollBar) setScrollState(function(state) {
            var bodyNode = scrollBodyRef.current;
            if (!bodyNode) return state;
            return (0, $kNxFX.default)((0, $kNxFX.default)({}, state), {}, {
                scrollLeft: bodyNode.scrollLeft / bodyNode.scrollWidth * bodyNode.clientWidth
            });
        });
    }, [
        scrollState.isHiddenScrollBar
    ]);
    if (bodyScrollWidth <= bodyWidth || !scrollBarWidth || scrollState.isHiddenScrollBar) return null;
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        style: {
            height: (0, $4e9e0b76ae3600bd$export$2e2bcd8739ae039)(),
            width: bodyWidth,
            bottom: offsetScroll
        },
        className: "".concat(prefixCls, "-sticky-scroll")
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        onMouseDown: onMouseDown,
        ref: scrollBarRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-sticky-scroll-bar"), (0, $43449.default)({}, "".concat(prefixCls, "-sticky-scroll-bar-active"), isActive)),
        style: {
            width: "".concat(scrollBarWidth, "px"),
            transform: "translate3d(".concat(scrollState.scrollLeft, "px, 0, 0)")
        }
    }));
};
var $b32d53690c8914b5$export$2e2bcd8739ae039 = /*#__PURE__*/ $6fFrj.forwardRef($b32d53690c8914b5$var$StickyScrollBar);



var $5KhTJ = parcelRequire("5KhTJ");

var $6fFrj = parcelRequire("6fFrj");

var $aSXdS = parcelRequire("aSXdS");
var $1a57d8e3919d27a3$var$defaultContainer = (0, $aSXdS.default)() ? window : null;
function $1a57d8e3919d27a3$export$2e2bcd8739ae039(sticky, prefixCls) {
    var _ref = (0, $5KhTJ.default)(sticky) === 'object' ? sticky : {}, _ref$offsetHeader = _ref.offsetHeader, offsetHeader = _ref$offsetHeader === void 0 ? 0 : _ref$offsetHeader, _ref$offsetSummary = _ref.offsetSummary, offsetSummary = _ref$offsetSummary === void 0 ? 0 : _ref$offsetSummary, _ref$offsetScroll = _ref.offsetScroll, offsetScroll = _ref$offsetScroll === void 0 ? 0 : _ref$offsetScroll, _ref$getContainer = _ref.getContainer, getContainer = _ref$getContainer === void 0 ? function() {
        return $1a57d8e3919d27a3$var$defaultContainer;
    } : _ref$getContainer;
    var container = getContainer() || $1a57d8e3919d27a3$var$defaultContainer;
    return $6fFrj.useMemo(function() {
        var isSticky = !!sticky;
        return {
            isSticky: isSticky,
            stickyClassName: isSticky ? "".concat(prefixCls, "-sticky-holder") : '',
            offsetHeader: offsetHeader,
            offsetSummary: offsetSummary,
            offsetScroll: offsetScroll,
            container: container
        };
    }, [
        offsetScroll,
        offsetHeader,
        offsetSummary,
        prefixCls,
        container
    ]);
}



var $43449 = parcelRequire("43449");

var $kNxFX = parcelRequire("kNxFX");

var $37xND = parcelRequire("37xND");

var $04RxA = parcelRequire("04RxA");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");

var $3BOWT = parcelRequire("3BOWT");


var $897f44c7fc845a9d$var$_excluded = [
    "className",
    "noData",
    "columns",
    "flattenColumns",
    "colWidths",
    "columCount",
    "stickyOffsets",
    "direction",
    "fixHeader",
    "stickyTopOffset",
    "stickyBottomOffset",
    "stickyClassName",
    "onScroll",
    "maxContentScroll",
    "children"
];
function $897f44c7fc845a9d$var$useColumnWidth(colWidths, columCount) {
    return (0, $6fFrj.useMemo)(function() {
        var cloneColumns = [];
        for(var i = 0; i < columCount; i += 1){
            var val = colWidths[i];
            if (val !== undefined) cloneColumns[i] = val;
            else return null;
        }
        return cloneColumns;
    }, [
        colWidths.join('_'),
        columCount
    ]);
}
var $897f44c7fc845a9d$var$FixedHolder = /*#__PURE__*/ $6fFrj.forwardRef(function(_ref, ref) {
    var className = _ref.className, noData = _ref.noData, columns = _ref.columns, flattenColumns = _ref.flattenColumns, colWidths = _ref.colWidths, columCount = _ref.columCount, stickyOffsets = _ref.stickyOffsets, direction = _ref.direction, fixHeader = _ref.fixHeader, stickyTopOffset = _ref.stickyTopOffset, stickyBottomOffset = _ref.stickyBottomOffset, stickyClassName = _ref.stickyClassName, onScroll = _ref.onScroll, maxContentScroll = _ref.maxContentScroll, children = _ref.children, props = (0, $04RxA.default)(_ref, $897f44c7fc845a9d$var$_excluded);
    var _React$useContext = $6fFrj.useContext((0, $8434d0e3abd7ec15$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, scrollbarSize = _React$useContext.scrollbarSize, isSticky = _React$useContext.isSticky;
    var combinationScrollBarSize = isSticky && !fixHeader ? 0 : scrollbarSize; // Pass wheel to scroll event
    var scrollRef = $6fFrj.useRef(null);
    var setScrollRef = $6fFrj.useCallback(function(element) {
        (0, $3BOWT.fillRef)(ref, element);
        (0, $3BOWT.fillRef)(scrollRef, element);
    }, []);
    $6fFrj.useEffect(function() {
        var _scrollRef$current;
        function onWheel(e) {
            var currentTarget = e.currentTarget, deltaX = e.deltaX;
            if (deltaX) {
                onScroll({
                    currentTarget: currentTarget,
                    scrollLeft: currentTarget.scrollLeft + deltaX
                });
                e.preventDefault();
            }
        }
        (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 || _scrollRef$current.addEventListener('wheel', onWheel);
        return function() {
            var _scrollRef$current2;
            (_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 || _scrollRef$current2.removeEventListener('wheel', onWheel);
        };
    }, []); // Check if all flattenColumns has width
    var allFlattenColumnsWithWidth = $6fFrj.useMemo(function() {
        return flattenColumns.every(function(column) {
            return column.width >= 0;
        });
    }, [
        flattenColumns
    ]); // Add scrollbar column
    var lastColumn = flattenColumns[flattenColumns.length - 1];
    var ScrollBarColumn = {
        fixed: lastColumn ? lastColumn.fixed : null,
        scrollbar: true,
        onHeaderCell: function onHeaderCell() {
            return {
                className: "".concat(prefixCls, "-cell-scrollbar")
            };
        }
    };
    var columnsWithScrollbar = (0, $6fFrj.useMemo)(function() {
        return combinationScrollBarSize ? [].concat((0, $37xND.default)(columns), [
            ScrollBarColumn
        ]) : columns;
    }, [
        combinationScrollBarSize,
        columns
    ]);
    var flattenColumnsWithScrollbar = (0, $6fFrj.useMemo)(function() {
        return combinationScrollBarSize ? [].concat((0, $37xND.default)(flattenColumns), [
            ScrollBarColumn
        ]) : flattenColumns;
    }, [
        combinationScrollBarSize,
        flattenColumns
    ]); // Calculate the sticky offsets
    var headerStickyOffsets = (0, $6fFrj.useMemo)(function() {
        var right = stickyOffsets.right, left = stickyOffsets.left;
        return (0, $kNxFX.default)((0, $kNxFX.default)({}, stickyOffsets), {}, {
            left: direction === 'rtl' ? [].concat((0, $37xND.default)(left.map(function(width) {
                return width + combinationScrollBarSize;
            })), [
                0
            ]) : left,
            right: direction === 'rtl' ? right : [].concat((0, $37xND.default)(right.map(function(width) {
                return width + combinationScrollBarSize;
            })), [
                0
            ]),
            isSticky: isSticky
        });
    }, [
        combinationScrollBarSize,
        stickyOffsets,
        isSticky
    ]);
    var mergedColumnWidth = $897f44c7fc845a9d$var$useColumnWidth(colWidths, columCount);
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        style: (0, $kNxFX.default)({
            overflow: 'hidden'
        }, isSticky ? {
            top: stickyTopOffset,
            bottom: stickyBottomOffset
        } : {}),
        ref: setScrollRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(className, (0, $43449.default)({}, stickyClassName, !!stickyClassName))
    }, /*#__PURE__*/ $6fFrj.createElement("table", {
        style: {
            tableLayout: 'fixed',
            visibility: noData || mergedColumnWidth ? null : 'hidden'
        }
    }, (!noData || !maxContentScroll || allFlattenColumnsWithWidth) && /*#__PURE__*/ $6fFrj.createElement((0, $74fe57c7ba9725ad$export$2e2bcd8739ae039), {
        colWidths: mergedColumnWidth ? [].concat((0, $37xND.default)(mergedColumnWidth), [
            combinationScrollBarSize
        ]) : [],
        columCount: columCount + 1,
        columns: flattenColumnsWithScrollbar
    }), children((0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        stickyOffsets: headerStickyOffsets,
        columns: columnsWithScrollbar,
        flattenColumns: flattenColumnsWithScrollbar
    }))));
});
$897f44c7fc845a9d$var$FixedHolder.displayName = 'FixedHolder';
var $897f44c7fc845a9d$export$2e2bcd8739ae039 = $897f44c7fc845a9d$var$FixedHolder;






var $06d7f51aacc8a77b$var$EMPTY_DATA = []; // Used for customize scroll
var $06d7f51aacc8a77b$var$EMPTY_SCROLL_TARGET = {};
var $06d7f51aacc8a77b$export$91b75cf262680225 = 'rc-table-internal-hook';
var $06d7f51aacc8a77b$var$MemoTableContent = /*#__PURE__*/ $6fFrj.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(prev, next) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($802a1584717a396d$exports)))(prev.props, next.props)) return false;
     // No additional render when pinged status change.
    // This is not a bug.
    return prev.pingLeft !== next.pingLeft || prev.pingRight !== next.pingRight;
});
function $06d7f51aacc8a77b$var$Table(props) {
    var _classNames;
    var prefixCls = props.prefixCls, className = props.className, rowClassName = props.rowClassName, style = props.style, data = props.data, rowKey = props.rowKey, scroll = props.scroll, tableLayout = props.tableLayout, direction = props.direction, title = props.title, footer = props.footer, summary = props.summary, id = props.id, showHeader = props.showHeader, components = props.components, emptyText = props.emptyText, onRow = props.onRow, onHeaderRow = props.onHeaderRow, internalHooks = props.internalHooks, transformColumns = props.transformColumns, internalRefs = props.internalRefs, sticky = props.sticky;
    var mergedData = data || $06d7f51aacc8a77b$var$EMPTY_DATA;
    var hasData = !!mergedData.length; // ===================== Warning ======================
    var getComponent = $6fFrj.useCallback(function(path, defaultComponent) {
        return (0, $7d023320b5dd5fb7$export$964131d48d6e4d94)(components || {}, path) || defaultComponent;
    }, [
        components
    ]);
    var getRowKey = $6fFrj.useMemo(function() {
        if (typeof rowKey === 'function') return rowKey;
        return function(record) {
            var key = record && record[rowKey];
            return key;
        };
    }, [
        rowKey
    ]); // ====================== Expand ======================
    var expandableConfig = (0, $91cd49b10058c8a6$export$e215b9806eacdfb5)(props);
    var expandIcon = expandableConfig.expandIcon, expandedRowKeys = expandableConfig.expandedRowKeys, defaultExpandedRowKeys = expandableConfig.defaultExpandedRowKeys, defaultExpandAllRows = expandableConfig.defaultExpandAllRows, expandedRowRender = expandableConfig.expandedRowRender, columnTitle = expandableConfig.columnTitle, onExpand = expandableConfig.onExpand, onExpandedRowsChange = expandableConfig.onExpandedRowsChange, expandRowByClick = expandableConfig.expandRowByClick, rowExpandable = expandableConfig.rowExpandable, expandIconColumnIndex = expandableConfig.expandIconColumnIndex, expandedRowClassName = expandableConfig.expandedRowClassName, childrenColumnName = expandableConfig.childrenColumnName, indentSize = expandableConfig.indentSize;
    var mergedExpandIcon = expandIcon || (0, $3ad1bf6d97b64687$export$ae14373a7f810e33);
    var mergedChildrenColumnName = childrenColumnName || 'children';
    var expandableType = $6fFrj.useMemo(function() {
        if (expandedRowRender) return 'row';
        /* eslint-disable no-underscore-dangle */ /**
     * Fix https://github.com/ant-design/ant-design/issues/21154
     * This is a workaround to not to break current behavior.
     * We can remove follow code after final release.
     *
     * To other developer:
     *  Do not use `__PARENT_RENDER_ICON__` in prod since we will remove this when refactor
     */ if (props.expandable && internalHooks === $06d7f51aacc8a77b$export$91b75cf262680225 && props.expandable.__PARENT_RENDER_ICON__ || mergedData.some(function(record) {
            return record && (0, $5KhTJ.default)(record) === 'object' && record[mergedChildrenColumnName];
        })) return 'nest';
        /* eslint-enable */ return false;
    }, [
        !!expandedRowRender,
        mergedData
    ]);
    var _React$useState = $6fFrj.useState(function() {
        if (defaultExpandedRowKeys) return defaultExpandedRowKeys;
        if (defaultExpandAllRows) return (0, $3ad1bf6d97b64687$export$49bec56f6055f375)(mergedData, getRowKey, mergedChildrenColumnName);
        return [];
    }), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), innerExpandedKeys = _React$useState2[0], setInnerExpandedKeys = _React$useState2[1];
    var mergedExpandedKeys = $6fFrj.useMemo(function() {
        return new Set(expandedRowKeys || innerExpandedKeys || []);
    }, [
        expandedRowKeys,
        innerExpandedKeys
    ]);
    var onTriggerExpand = $6fFrj.useCallback(function(record) {
        var key = getRowKey(record, mergedData.indexOf(record));
        var newExpandedKeys;
        var hasKey = mergedExpandedKeys.has(key);
        if (hasKey) {
            mergedExpandedKeys.delete(key);
            newExpandedKeys = (0, $37xND.default)(mergedExpandedKeys);
        } else newExpandedKeys = [].concat((0, $37xND.default)(mergedExpandedKeys), [
            key
        ]);
        setInnerExpandedKeys(newExpandedKeys);
        if (onExpand) onExpand(!hasKey, record);
        if (onExpandedRowsChange) onExpandedRowsChange(newExpandedKeys);
    }, [
        getRowKey,
        mergedExpandedKeys,
        mergedData,
        onExpand,
        onExpandedRowsChange
    ]); // Warning if use `expandedRowRender` and nest children in the same time
    var _React$useState3 = $6fFrj.useState(0), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), componentWidth = _React$useState4[0], setComponentWidth = _React$useState4[1];
    var _useColumns = (0, $f010cefebeb2fe47$export$2e2bcd8739ae039)((0, $kNxFX.default)((0, $kNxFX.default)((0, $kNxFX.default)({}, props), expandableConfig), {}, {
        expandable: !!expandedRowRender,
        columnTitle: columnTitle,
        expandedKeys: mergedExpandedKeys,
        getRowKey: getRowKey,
        // https://github.com/ant-design/ant-design/issues/23894
        onTriggerExpand: onTriggerExpand,
        expandIcon: mergedExpandIcon,
        expandIconColumnIndex: expandIconColumnIndex,
        direction: direction
    }), internalHooks === $06d7f51aacc8a77b$export$91b75cf262680225 ? transformColumns : null), _useColumns2 = (0, $jP8CL.default)(_useColumns, 2), columns = _useColumns2[0], flattenColumns = _useColumns2[1];
    var columnContext = $6fFrj.useMemo(function() {
        return {
            columns: columns,
            flattenColumns: flattenColumns
        };
    }, [
        columns,
        flattenColumns
    ]); // ====================== Scroll ======================
    var fullTableRef = $6fFrj.useRef();
    var scrollHeaderRef = $6fFrj.useRef();
    var scrollBodyRef = $6fFrj.useRef();
    var scrollBodyContainerRef = $6fFrj.useRef();
    var scrollSummaryRef = $6fFrj.useRef();
    var _React$useState5 = $6fFrj.useState(false), _React$useState6 = (0, $jP8CL.default)(_React$useState5, 2), pingedLeft = _React$useState6[0], setPingedLeft = _React$useState6[1];
    var _React$useState7 = $6fFrj.useState(false), _React$useState8 = (0, $jP8CL.default)(_React$useState7, 2), pingedRight = _React$useState8[0], setPingedRight = _React$useState8[1];
    var _useLayoutState = (0, $ddf8567d6de61db5$export$510e4dd13e0b67dd)(new Map()), _useLayoutState2 = (0, $jP8CL.default)(_useLayoutState, 2), colsWidths = _useLayoutState2[0], updateColsWidths = _useLayoutState2[1]; // Convert map to number width
    var colsKeys = (0, $7d023320b5dd5fb7$export$fd2ca5407d9be470)(flattenColumns);
    var pureColWidths = colsKeys.map(function(columnKey) {
        return colsWidths.get(columnKey);
    });
    var colWidths = $6fFrj.useMemo(function() {
        return pureColWidths;
    }, [
        pureColWidths.join('_')
    ]);
    var stickyOffsets = (0, $7bbf4b3236227744$export$2e2bcd8739ae039)(colWidths, flattenColumns.length, direction);
    var fixHeader = scroll && (0, $7d023320b5dd5fb7$export$b76e9316566cc26e)(scroll.y);
    var horizonScroll = scroll && (0, $7d023320b5dd5fb7$export$b76e9316566cc26e)(scroll.x) || Boolean(expandableConfig.fixed);
    var fixColumn = horizonScroll && flattenColumns.some(function(_ref2) {
        var fixed = _ref2.fixed;
        return fixed;
    }); // Sticky
    var stickyRef = $6fFrj.useRef();
    var _useSticky = (0, $1a57d8e3919d27a3$export$2e2bcd8739ae039)(sticky, prefixCls), isSticky = _useSticky.isSticky, offsetHeader = _useSticky.offsetHeader, offsetSummary = _useSticky.offsetSummary, offsetScroll = _useSticky.offsetScroll, stickyClassName = _useSticky.stickyClassName, container = _useSticky.container; // Footer (Fix footer must fixed header)
    var summaryNode = summary === null || summary === void 0 ? void 0 : summary(mergedData);
    var fixFooter = (fixHeader || isSticky) && /*#__PURE__*/ $6fFrj.isValidElement(summaryNode) && summaryNode.type === (0, $f9096ec2a768fb9c$export$2e2bcd8739ae039) && summaryNode.props.fixed; // Scroll
    var scrollXStyle;
    var scrollYStyle;
    var scrollTableStyle;
    if (fixHeader) scrollYStyle = {
        overflowY: 'scroll',
        maxHeight: scroll.y
    };
    if (horizonScroll) {
        scrollXStyle = {
            overflowX: 'auto'
        }; // When no vertical scrollbar, should hide it
        // https://github.com/ant-design/ant-design/pull/20705
        // https://github.com/ant-design/ant-design/issues/21879
        if (!fixHeader) scrollYStyle = {
            overflowY: 'hidden'
        };
        scrollTableStyle = {
            width: (scroll === null || scroll === void 0 ? void 0 : scroll.x) === true ? 'auto' : scroll === null || scroll === void 0 ? void 0 : scroll.x,
            minWidth: '100%'
        };
    }
    var onColumnResize = $6fFrj.useCallback(function(columnKey, width) {
        if ((0, $5335db4432c3f914$export$2e2bcd8739ae039)(fullTableRef.current)) updateColsWidths(function(widths) {
            if (widths.get(columnKey) !== width) {
                var newWidths = new Map(widths);
                newWidths.set(columnKey, width);
                return newWidths;
            }
            return widths;
        });
    }, []);
    var _useTimeoutLock = (0, $ddf8567d6de61db5$export$d63c72d5e6d02249)(null), _useTimeoutLock2 = (0, $jP8CL.default)(_useTimeoutLock, 2), setScrollTarget = _useTimeoutLock2[0], getScrollTarget = _useTimeoutLock2[1];
    function forceScroll(scrollLeft, target) {
        if (!target) return;
        if (typeof target === 'function') target(scrollLeft);
        else if (target.scrollLeft !== scrollLeft) // eslint-disable-next-line no-param-reassign
        target.scrollLeft = scrollLeft;
    }
    var onScroll = function onScroll(_ref3) {
        var currentTarget = _ref3.currentTarget, scrollLeft = _ref3.scrollLeft;
        var isRTL = direction === 'rtl';
        var mergedScrollLeft = typeof scrollLeft === 'number' ? scrollLeft : currentTarget.scrollLeft;
        var compareTarget = currentTarget || $06d7f51aacc8a77b$var$EMPTY_SCROLL_TARGET;
        if (!getScrollTarget() || getScrollTarget() === compareTarget) {
            var _stickyRef$current;
            setScrollTarget(compareTarget);
            forceScroll(mergedScrollLeft, scrollHeaderRef.current);
            forceScroll(mergedScrollLeft, scrollBodyRef.current);
            forceScroll(mergedScrollLeft, scrollSummaryRef.current);
            forceScroll(mergedScrollLeft, (_stickyRef$current = stickyRef.current) === null || _stickyRef$current === void 0 ? void 0 : _stickyRef$current.setScrollLeft);
        }
        if (currentTarget) {
            var scrollWidth = currentTarget.scrollWidth, clientWidth = currentTarget.clientWidth; // There is no space to scroll
            if (scrollWidth === clientWidth) {
                setPingedLeft(false);
                setPingedRight(false);
                return;
            }
            if (isRTL) {
                setPingedLeft(-mergedScrollLeft < scrollWidth - clientWidth);
                setPingedRight(-mergedScrollLeft > 0);
            } else {
                setPingedLeft(mergedScrollLeft > 0);
                setPingedRight(mergedScrollLeft < scrollWidth - clientWidth);
            }
        }
    };
    var triggerOnScroll = function triggerOnScroll() {
        if (horizonScroll && scrollBodyRef.current) onScroll({
            currentTarget: scrollBodyRef.current
        });
        else {
            setPingedLeft(false);
            setPingedRight(false);
        }
    };
    var onFullTableResize = function onFullTableResize(_ref4) {
        var width = _ref4.width;
        if (width !== componentWidth) {
            triggerOnScroll();
            setComponentWidth(fullTableRef.current ? fullTableRef.current.offsetWidth : width);
        }
    }; // Sync scroll bar when init or `horizonScroll`, `data` and `columns.length` changed
    var mounted = $6fFrj.useRef(false);
    $6fFrj.useEffect(function() {
        // onFullTableResize will be trigger once when ResizeObserver is mounted
        // This will reduce one duplicated triggerOnScroll time
        if (mounted.current) triggerOnScroll();
    }, [
        horizonScroll,
        data,
        columns.length
    ]);
    $6fFrj.useEffect(function() {
        mounted.current = true;
    }, []); // ===================== Effects ======================
    var _React$useState9 = $6fFrj.useState(0), _React$useState10 = (0, $jP8CL.default)(_React$useState9, 2), scrollbarSize = _React$useState10[0], setScrollbarSize = _React$useState10[1];
    var _React$useState11 = $6fFrj.useState(true), _React$useState12 = (0, $jP8CL.default)(_React$useState11, 2), supportSticky = _React$useState12[0], setSupportSticky = _React$useState12[1]; // Only IE not support, we mark as support first
    $6fFrj.useEffect(function() {
        if (scrollBodyRef.current instanceof Element) setScrollbarSize((0, $4e9e0b76ae3600bd$export$4f3ef2310365b56a)(scrollBodyRef.current).width);
        else setScrollbarSize((0, $4e9e0b76ae3600bd$export$4f3ef2310365b56a)(scrollBodyContainerRef.current).width);
        setSupportSticky((0, $8f55e1da1d754100$export$d616d7831008e86c)('position', 'sticky'));
    }, []); // ================== INTERNAL HOOKS ==================
    $6fFrj.useEffect(function() {
        if (internalHooks === $06d7f51aacc8a77b$export$91b75cf262680225 && internalRefs) internalRefs.body.current = scrollBodyRef.current;
    }); // ====================== Render ======================
    var TableComponent = getComponent([
        'table'
    ], 'table'); // Table layout
    var mergedTableLayout = $6fFrj.useMemo(function() {
        if (tableLayout) return tableLayout;
         // https://github.com/ant-design/ant-design/issues/25227
        // When scroll.x is max-content, no need to fix table layout
        // it's width should stretch out to fit content
        if (fixColumn) return (scroll === null || scroll === void 0 ? void 0 : scroll.x) === 'max-content' ? 'auto' : 'fixed';
        if (fixHeader || isSticky || flattenColumns.some(function(_ref5) {
            var ellipsis = _ref5.ellipsis;
            return ellipsis;
        })) return 'fixed';
        return 'auto';
    }, [
        fixHeader,
        fixColumn,
        flattenColumns,
        tableLayout,
        isSticky
    ]);
    var groupTableNode; // Header props
    var headerProps = {
        colWidths: colWidths,
        columCount: flattenColumns.length,
        stickyOffsets: stickyOffsets,
        onHeaderRow: onHeaderRow,
        fixHeader: fixHeader,
        scroll: scroll
    }; // Empty
    var emptyNode = $6fFrj.useMemo(function() {
        if (hasData) return null;
        if (typeof emptyText === 'function') return emptyText();
        return emptyText;
    }, [
        hasData,
        emptyText
    ]); // Body
    var bodyTable = /*#__PURE__*/ $6fFrj.createElement((0, $6b7076aa407e45f1$export$2e2bcd8739ae039), {
        data: mergedData,
        measureColumnWidth: fixHeader || horizonScroll || isSticky,
        expandedKeys: mergedExpandedKeys,
        rowExpandable: rowExpandable,
        getRowKey: getRowKey,
        onRow: onRow,
        emptyNode: emptyNode,
        childrenColumnName: mergedChildrenColumnName
    });
    var bodyColGroup = /*#__PURE__*/ $6fFrj.createElement((0, $74fe57c7ba9725ad$export$2e2bcd8739ae039), {
        colWidths: flattenColumns.map(function(_ref6) {
            var width = _ref6.width;
            return width;
        }),
        columns: flattenColumns
    });
    var customizeScrollBody = getComponent([
        'body'
    ]);
    if (fixHeader || isSticky) {
        // >>>>>> Fixed Header
        var bodyContent;
        if (typeof customizeScrollBody === 'function') {
            bodyContent = customizeScrollBody(mergedData, {
                scrollbarSize: scrollbarSize,
                ref: scrollBodyRef,
                onScroll: onScroll
            });
            headerProps.colWidths = flattenColumns.map(function(_ref7, index) {
                var width = _ref7.width;
                var colWidth = index === columns.length - 1 ? width - scrollbarSize : width;
                if (typeof colWidth === 'number' && !Number.isNaN(colWidth)) return colWidth;
                (0, $3mXQ2.default)(false, 'When use `components.body` with render props. Each column should have a fixed `width` value.');
                return 0;
            });
        } else bodyContent = /*#__PURE__*/ $6fFrj.createElement("div", {
            style: (0, $kNxFX.default)((0, $kNxFX.default)({}, scrollXStyle), scrollYStyle),
            onScroll: onScroll,
            ref: scrollBodyRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-body"))
        }, /*#__PURE__*/ $6fFrj.createElement(TableComponent, {
            style: (0, $kNxFX.default)((0, $kNxFX.default)({}, scrollTableStyle), {}, {
                tableLayout: mergedTableLayout
            })
        }, bodyColGroup, bodyTable, !fixFooter && summaryNode && /*#__PURE__*/ $6fFrj.createElement((0, $e248b732ce653607$export$2e2bcd8739ae039), {
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns
        }, summaryNode)));
         // Fixed holder share the props
        var fixedHolderProps = (0, $kNxFX.default)((0, $kNxFX.default)((0, $kNxFX.default)({
            noData: !mergedData.length,
            maxContentScroll: horizonScroll && scroll.x === 'max-content'
        }, headerProps), columnContext), {}, {
            direction: direction,
            stickyClassName: stickyClassName,
            onScroll: onScroll
        });
        groupTableNode = /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, showHeader !== false && /*#__PURE__*/ $6fFrj.createElement((0, $897f44c7fc845a9d$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, fixedHolderProps, {
            stickyTopOffset: offsetHeader,
            className: "".concat(prefixCls, "-header"),
            ref: scrollHeaderRef
        }), function(fixedHolderPassProps) {
            return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, /*#__PURE__*/ $6fFrj.createElement((0, $a97da572ca9b7806$export$2e2bcd8739ae039), fixedHolderPassProps), fixFooter === 'top' && /*#__PURE__*/ $6fFrj.createElement((0, $e248b732ce653607$export$2e2bcd8739ae039), fixedHolderPassProps, summaryNode));
        }), bodyContent, fixFooter && fixFooter !== 'top' && /*#__PURE__*/ $6fFrj.createElement((0, $897f44c7fc845a9d$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, fixedHolderProps, {
            stickyBottomOffset: offsetSummary,
            className: "".concat(prefixCls, "-summary"),
            ref: scrollSummaryRef
        }), function(fixedHolderPassProps) {
            return /*#__PURE__*/ $6fFrj.createElement((0, $e248b732ce653607$export$2e2bcd8739ae039), fixedHolderPassProps, summaryNode);
        }), isSticky && /*#__PURE__*/ $6fFrj.createElement((0, $b32d53690c8914b5$export$2e2bcd8739ae039), {
            ref: stickyRef,
            offsetScroll: offsetScroll,
            scrollBodyRef: scrollBodyRef,
            onScroll: onScroll,
            container: container
        }));
    } else // >>>>>> Unique table
    groupTableNode = /*#__PURE__*/ $6fFrj.createElement("div", {
        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, scrollXStyle), scrollYStyle),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-content")),
        onScroll: onScroll,
        ref: scrollBodyRef
    }, /*#__PURE__*/ $6fFrj.createElement(TableComponent, {
        style: (0, $kNxFX.default)((0, $kNxFX.default)({}, scrollTableStyle), {}, {
            tableLayout: mergedTableLayout
        })
    }, bodyColGroup, showHeader !== false && /*#__PURE__*/ $6fFrj.createElement((0, $a97da572ca9b7806$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, headerProps, columnContext)), bodyTable, summaryNode && /*#__PURE__*/ $6fFrj.createElement((0, $e248b732ce653607$export$2e2bcd8739ae039), {
        stickyOffsets: stickyOffsets,
        flattenColumns: flattenColumns
    }, summaryNode)));
    var ariaProps = (0, $c7e00e8671f36d19$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    });
    var fullTable = /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0, $43449.default)(_classNames, "".concat(prefixCls, "-ping-left"), pingedLeft), (0, $43449.default)(_classNames, "".concat(prefixCls, "-ping-right"), pingedRight), (0, $43449.default)(_classNames, "".concat(prefixCls, "-layout-fixed"), tableLayout === 'fixed'), (0, $43449.default)(_classNames, "".concat(prefixCls, "-fixed-header"), fixHeader), (0, $43449.default)(_classNames, "".concat(prefixCls, "-fixed-column"), fixColumn), (0, $43449.default)(_classNames, "".concat(prefixCls, "-scroll-horizontal"), horizonScroll), (0, $43449.default)(_classNames, "".concat(prefixCls, "-has-fix-left"), flattenColumns[0] && flattenColumns[0].fixed), (0, $43449.default)(_classNames, "".concat(prefixCls, "-has-fix-right"), flattenColumns[flattenColumns.length - 1] && flattenColumns[flattenColumns.length - 1].fixed === 'right'), _classNames)),
        style: style,
        id: id,
        ref: fullTableRef
    }, ariaProps), /*#__PURE__*/ $6fFrj.createElement($06d7f51aacc8a77b$var$MemoTableContent, {
        pingLeft: pingedLeft,
        pingRight: pingedRight,
        props: (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
            stickyOffsets: stickyOffsets,
            mergedExpandedKeys: mergedExpandedKeys
        })
    }, title && /*#__PURE__*/ $6fFrj.createElement((0, $b46970e0e0191165$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-title")
    }, title(mergedData)), /*#__PURE__*/ $6fFrj.createElement("div", {
        ref: scrollBodyContainerRef,
        className: "".concat(prefixCls, "-container")
    }, groupTableNode), footer && /*#__PURE__*/ $6fFrj.createElement((0, $b46970e0e0191165$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-footer")
    }, footer(mergedData))));
    if (horizonScroll) fullTable = /*#__PURE__*/ $6fFrj.createElement((0, $8e6bb008621f90f5$export$2e2bcd8739ae039), {
        onResize: onFullTableResize
    }, fullTable);
    var TableContextValue = $6fFrj.useMemo(function() {
        return {
            prefixCls: prefixCls,
            getComponent: getComponent,
            scrollbarSize: scrollbarSize,
            direction: direction,
            fixedInfoList: flattenColumns.map(function(_, colIndex) {
                return (0, $7f782721787757c9$export$695db918331141f3)(colIndex, colIndex, flattenColumns, stickyOffsets, direction);
            }),
            isSticky: isSticky
        };
    }, [
        prefixCls,
        getComponent,
        scrollbarSize,
        direction,
        flattenColumns,
        stickyOffsets,
        isSticky
    ]);
    var BodyContextValue = $6fFrj.useMemo(function() {
        return (0, $kNxFX.default)((0, $kNxFX.default)({}, columnContext), {}, {
            tableLayout: mergedTableLayout,
            rowClassName: rowClassName,
            expandedRowClassName: expandedRowClassName,
            expandIcon: mergedExpandIcon,
            expandableType: expandableType,
            expandRowByClick: expandRowByClick,
            expandedRowRender: expandedRowRender,
            onTriggerExpand: onTriggerExpand,
            expandIconColumnIndex: expandIconColumnIndex,
            indentSize: indentSize,
            allColumnsFixedLeft: columnContext.flattenColumns.every(function(col) {
                return col.fixed === 'left';
            })
        });
    }, [
        columnContext,
        mergedTableLayout,
        rowClassName,
        expandedRowClassName,
        mergedExpandIcon,
        expandableType,
        expandRowByClick,
        expandedRowRender,
        onTriggerExpand,
        expandIconColumnIndex,
        indentSize
    ]);
    var ExpandedRowContextValue = $6fFrj.useMemo(function() {
        return {
            componentWidth: componentWidth,
            fixHeader: fixHeader,
            fixColumn: fixColumn,
            horizonScroll: horizonScroll
        };
    }, [
        componentWidth,
        fixHeader,
        fixColumn,
        horizonScroll
    ]);
    var ResizeContextValue = $6fFrj.useMemo(function() {
        return {
            onColumnResize: onColumnResize
        };
    }, [
        onColumnResize
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $d06cf1a7a845970c$export$2e2bcd8739ae039).Provider, {
        value: supportSticky
    }, /*#__PURE__*/ $6fFrj.createElement((0, $8434d0e3abd7ec15$export$2e2bcd8739ae039).Provider, {
        value: TableContextValue
    }, /*#__PURE__*/ $6fFrj.createElement((0, $531ee63ef59dd731$export$2e2bcd8739ae039).Provider, {
        value: BodyContextValue
    }, /*#__PURE__*/ $6fFrj.createElement((0, $41a9814d3c65b4c6$export$2e2bcd8739ae039).Provider, {
        value: ExpandedRowContextValue
    }, /*#__PURE__*/ $6fFrj.createElement((0, $9d0d755dab66343f$export$2e2bcd8739ae039).Provider, {
        value: ResizeContextValue
    }, fullTable)))));
}
$06d7f51aacc8a77b$var$Table.EXPAND_COLUMN = (0, $aedad8117e1ff1f2$export$e1053575ddfcb301);
$06d7f51aacc8a77b$var$Table.Column = (0, $9d2150425b4d3196$export$2e2bcd8739ae039);
$06d7f51aacc8a77b$var$Table.ColumnGroup = (0, $702ddf5d0009f4ad$export$2e2bcd8739ae039);
$06d7f51aacc8a77b$var$Table.Summary = (0, $e248b732ce653607$export$d605f3af09eef683);
$06d7f51aacc8a77b$var$Table.defaultProps = {
    rowKey: 'key',
    prefixCls: 'rc-table',
    emptyText: function emptyText() {
        return 'No Data';
    }
};
var $06d7f51aacc8a77b$export$2e2bcd8739ae039 = $06d7f51aacc8a77b$var$Table;






var $f549334765213713$export$2e2bcd8739ae039 = (0, $06d7f51aacc8a77b$export$2e2bcd8739ae039);






var $6fFrj = parcelRequire("6fFrj");








var $hqic8 = parcelRequire("hqic8");
// eslint-disable-next-line import/prefer-default-export
function $9f69005fce6a52ed$export$24656b269d8df7d6(t, b, c, d) {
    var cc = c - b;
    t /= d / 2;
    if (t < 1) return cc / 2 * t * t * t + b;
    // eslint-disable-next-line no-return-assign
    return cc / 2 * ((t -= 2) * t * t + 2) + b;
}


function $dcfa91c3160dde8e$export$5a096129d439f843(obj) {
    return obj !== null && obj !== undefined && obj === obj.window;
}
function $dcfa91c3160dde8e$export$2e2bcd8739ae039(target, top) {
    var _a, _b;
    if (typeof window === 'undefined') return 0;
    var method = top ? 'scrollTop' : 'scrollLeft';
    var result = 0;
    if ($dcfa91c3160dde8e$export$5a096129d439f843(target)) result = target[top ? 'pageYOffset' : 'pageXOffset'];
    else if (target instanceof Document) result = target.documentElement[method];
    else if (target instanceof HTMLElement) result = target[method];
    else if (target) // According to the type inference, the `target` is `never` type.
    // Since we configured the loose mode type checking, and supports mocking the target with such shape below::
    //    `{ documentElement: { scrollLeft: 200, scrollTop: 400 } }`,
    //    the program may falls into this branch.
    // Check the corresponding tests for details. Don't sure what is the real scenario this happens.
    result = target[method];
    if (target && !$dcfa91c3160dde8e$export$5a096129d439f843(target) && typeof result !== 'number') result = (_b = ((_a = target.ownerDocument) !== null && _a !== void 0 ? _a : target).documentElement) === null || _b === void 0 ? void 0 : _b[method];
    return result;
}


function $a5404eb492cf564d$export$2e2bcd8739ae039(y) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$getContainer = options.getContainer, getContainer = _options$getContainer === void 0 ? function() {
        return window;
    } : _options$getContainer, callback = options.callback, _options$duration = options.duration, duration = _options$duration === void 0 ? 450 : _options$duration;
    var container = getContainer();
    var scrollTop = (0, $dcfa91c3160dde8e$export$2e2bcd8739ae039)(container, true);
    var startTime = Date.now();
    var frameFunc = function frameFunc() {
        var timestamp = Date.now();
        var time = timestamp - startTime;
        var nextScrollTop = (0, $9f69005fce6a52ed$export$24656b269d8df7d6)(time > duration ? duration : time, scrollTop, y, duration);
        if ((0, $dcfa91c3160dde8e$export$5a096129d439f843)(container)) container.scrollTo(window.pageXOffset, nextScrollTop);
        else if (container instanceof Document || container.constructor.name === 'HTMLDocument') container.documentElement.scrollTop = nextScrollTop;
        else container.scrollTop = nextScrollTop;
        if (time < duration) (0, $hqic8.default)(frameFunc);
        else if (typeof callback === 'function') callback();
    };
    (0, $hqic8.default)(frameFunc);
}



/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ // eslint-disable-next-line no-unused-vars
function $90643cbcc1ad3a5b$var$Column(_) {
    return null;
}
var $90643cbcc1ad3a5b$export$2e2bcd8739ae039 = $90643cbcc1ad3a5b$var$Column;


/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ // eslint-disable-next-line no-unused-vars
function $815c663a28b62a97$var$ColumnGroup(_) {
    return null;
}
var $815c663a28b62a97$export$2e2bcd8739ae039 = $815c663a28b62a97$var$ColumnGroup;



var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");
function $be6382bbd6e956e1$var$renderExpandIcon(locale) {
    return function expandIcon(_ref) {
        var prefixCls = _ref.prefixCls, onExpand = _ref.onExpand, record = _ref.record, expanded = _ref.expanded, expandable = _ref.expandable;
        var iconPrefix = "".concat(prefixCls, "-row-expand-icon");
        return /*#__PURE__*/ $6fFrj.createElement("button", {
            type: "button",
            onClick: function onClick(e) {
                onExpand(record, e);
                e.stopPropagation();
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(iconPrefix, (0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(iconPrefix, "-spaced"), !expandable), "".concat(iconPrefix, "-expanded"), expandable && expanded), "".concat(iconPrefix, "-collapsed"), expandable && !expanded)),
            "aria-label": expanded ? locale.collapse : locale.expand,
            "aria-expanded": expanded
        });
    };
}
var $be6382bbd6e956e1$export$2e2bcd8739ae039 = $be6382bbd6e956e1$var$renderExpandIcon;



var $jP8CL = parcelRequire("jP8CL");

var $fIrcP = parcelRequire("fIrcP");

var $37xND = parcelRequire("37xND");

var $6fFrj = parcelRequire("6fFrj");

function $9660a16a644c556b$export$480219a02f196e72(column, defaultKey) {
    if ('key' in column && column.key !== undefined && column.key !== null) return column.key;
    if (column.dataIndex) return Array.isArray(column.dataIndex) ? column.dataIndex.join('.') : column.dataIndex;
    return defaultKey;
}
function $9660a16a644c556b$export$7e4db04adce9b4db(index, pos) {
    return pos ? "".concat(pos, "-").concat(index) : "".concat(index);
}
function $9660a16a644c556b$export$cfda450db2088de7(title, props) {
    if (typeof title === 'function') return title(props);
    return title;
}
function $9660a16a644c556b$export$1c24e0676a106839(title, props) {
    var res = $9660a16a644c556b$export$cfda450db2088de7(title, props);
    if (Object.prototype.toString.call(res) === '[object Object]') return '';
    return res;
}



var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $62625f140d336647$var$FilterFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z"
                }
            }
        ]
    },
    "name": "filter",
    "theme": "filled"
};
var $62625f140d336647$export$2e2bcd8739ae039 = $62625f140d336647$var$FilterFilled;



var $bf159c3c03590c56$var$FilterFilled = function FilterFilled(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $62625f140d336647$export$2e2bcd8739ae039)
    }));
};
var $bf159c3c03590c56$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($bf159c3c03590c56$var$FilterFilled);
var $bf159c3c03590c56$export$2e2bcd8739ae039 = $bf159c3c03590c56$var$RefIcon;



var $fActo = parcelRequire("fActo");
var $0aaac3f8a867d076$exports = {};
var $204a924ef706f07d$exports = {};
var $e093ce881f5e54d7$exports = {};
var $40b82f8d2fb04f5e$exports = {};
var $ffdd0bb2fe19dd0b$exports = {};
var $c266269dc940a3c8$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $c266269dc940a3c8$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$c266269dc940a3c8$exports = $c266269dc940a3c8$var$listCacheClear;


var $7b61c0a98a5edcbd$exports = {};
var $23b2acf153d855dc$exports = {};
var $b24e368740be49a0$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $b24e368740be49a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$b24e368740be49a0$exports = $b24e368740be49a0$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $23b2acf153d855dc$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($b24e368740be49a0$exports(array[length][0], key)) return length;
    }
    return -1;
}
$23b2acf153d855dc$exports = $23b2acf153d855dc$var$assocIndexOf;


/** Used for built-in method references. */ var $7b61c0a98a5edcbd$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $7b61c0a98a5edcbd$var$splice = $7b61c0a98a5edcbd$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7b61c0a98a5edcbd$var$listCacheDelete(key) {
    var data = this.__data__, index = $23b2acf153d855dc$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $7b61c0a98a5edcbd$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$7b61c0a98a5edcbd$exports = $7b61c0a98a5edcbd$var$listCacheDelete;


var $e18dba7199af4b09$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e18dba7199af4b09$var$listCacheGet(key) {
    var data = this.__data__, index = $23b2acf153d855dc$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$e18dba7199af4b09$exports = $e18dba7199af4b09$var$listCacheGet;


var $deb7256b6623b7a6$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $deb7256b6623b7a6$var$listCacheHas(key) {
    return $23b2acf153d855dc$exports(this.__data__, key) > -1;
}
$deb7256b6623b7a6$exports = $deb7256b6623b7a6$var$listCacheHas;


var $e2c7d6173bcefc54$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $e2c7d6173bcefc54$var$listCacheSet(key, value) {
    var data = this.__data__, index = $23b2acf153d855dc$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$e2c7d6173bcefc54$exports = $e2c7d6173bcefc54$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ffdd0bb2fe19dd0b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$ffdd0bb2fe19dd0b$var$ListCache.prototype.clear = $c266269dc940a3c8$exports;
$ffdd0bb2fe19dd0b$var$ListCache.prototype['delete'] = $7b61c0a98a5edcbd$exports;
$ffdd0bb2fe19dd0b$var$ListCache.prototype.get = $e18dba7199af4b09$exports;
$ffdd0bb2fe19dd0b$var$ListCache.prototype.has = $deb7256b6623b7a6$exports;
$ffdd0bb2fe19dd0b$var$ListCache.prototype.set = $e2c7d6173bcefc54$exports;
$ffdd0bb2fe19dd0b$exports = $ffdd0bb2fe19dd0b$var$ListCache;


var $6e210344e5ff63ec$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $6e210344e5ff63ec$var$stackClear() {
    this.__data__ = new $ffdd0bb2fe19dd0b$exports;
    this.size = 0;
}
$6e210344e5ff63ec$exports = $6e210344e5ff63ec$var$stackClear;


var $95c1cd05d2c9dbcf$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $95c1cd05d2c9dbcf$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$95c1cd05d2c9dbcf$exports = $95c1cd05d2c9dbcf$var$stackDelete;


var $af72a4d62a055824$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $af72a4d62a055824$var$stackGet(key) {
    return this.__data__.get(key);
}
$af72a4d62a055824$exports = $af72a4d62a055824$var$stackGet;


var $19f1b43ec6a4bd30$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $19f1b43ec6a4bd30$var$stackHas(key) {
    return this.__data__.has(key);
}
$19f1b43ec6a4bd30$exports = $19f1b43ec6a4bd30$var$stackHas;


var $8d74ad93b5a0cee8$exports = {};

var $9c7ea88729fb6881$exports = {};
var $898ac8779b0a4dac$exports = {};
var $16f3a1270ea04bb2$exports = {};
var $de26704b56a493fb$exports = {};

var $euXSx = parcelRequire("euXSx");

/** `Object#toString` result references. */ var $de26704b56a493fb$var$asyncTag = '[object AsyncFunction]', $de26704b56a493fb$var$funcTag = '[object Function]', $de26704b56a493fb$var$genTag = '[object GeneratorFunction]', $de26704b56a493fb$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $de26704b56a493fb$var$isFunction(value) {
    if (!$aaebd2a43568f36a$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $euXSx(value);
    return tag == $de26704b56a493fb$var$funcTag || tag == $de26704b56a493fb$var$genTag || tag == $de26704b56a493fb$var$asyncTag || tag == $de26704b56a493fb$var$proxyTag;
}
$de26704b56a493fb$exports = $de26704b56a493fb$var$isFunction;


var $34a25ef4e770fee1$exports = {};
var $edbc1347f30fe547$exports = {};

var $kqNAI = parcelRequire("kqNAI");
/** Used to detect overreaching core-js shims. */ var $edbc1347f30fe547$var$coreJsData = $kqNAI["__core-js_shared__"];
$edbc1347f30fe547$exports = $edbc1347f30fe547$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $34a25ef4e770fee1$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($edbc1347f30fe547$exports && $edbc1347f30fe547$exports.keys && $edbc1347f30fe547$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $34a25ef4e770fee1$var$isMasked(func) {
    return !!$34a25ef4e770fee1$var$maskSrcKey && $34a25ef4e770fee1$var$maskSrcKey in func;
}
$34a25ef4e770fee1$exports = $34a25ef4e770fee1$var$isMasked;



var $7a2f7216696cc973$exports = {};
/** Used for built-in method references. */ var $7a2f7216696cc973$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $7a2f7216696cc973$var$funcToString = $7a2f7216696cc973$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $7a2f7216696cc973$var$toSource(func) {
    if (func != null) {
        try {
            return $7a2f7216696cc973$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$7a2f7216696cc973$exports = $7a2f7216696cc973$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $16f3a1270ea04bb2$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $16f3a1270ea04bb2$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $16f3a1270ea04bb2$var$funcProto = Function.prototype, $16f3a1270ea04bb2$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $16f3a1270ea04bb2$var$funcToString = $16f3a1270ea04bb2$var$funcProto.toString;
/** Used to check objects for own properties. */ var $16f3a1270ea04bb2$var$hasOwnProperty = $16f3a1270ea04bb2$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $16f3a1270ea04bb2$var$reIsNative = RegExp('^' + $16f3a1270ea04bb2$var$funcToString.call($16f3a1270ea04bb2$var$hasOwnProperty).replace($16f3a1270ea04bb2$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $16f3a1270ea04bb2$var$baseIsNative(value) {
    if (!$aaebd2a43568f36a$exports(value) || $34a25ef4e770fee1$exports(value)) return false;
    var pattern = $de26704b56a493fb$exports(value) ? $16f3a1270ea04bb2$var$reIsNative : $16f3a1270ea04bb2$var$reIsHostCtor;
    return pattern.test($7a2f7216696cc973$exports(value));
}
$16f3a1270ea04bb2$exports = $16f3a1270ea04bb2$var$baseIsNative;


var $c0776e82bd0886a8$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $c0776e82bd0886a8$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$c0776e82bd0886a8$exports = $c0776e82bd0886a8$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $898ac8779b0a4dac$var$getNative(object, key) {
    var value = $c0776e82bd0886a8$exports(object, key);
    return $16f3a1270ea04bb2$exports(value) ? value : undefined;
}
$898ac8779b0a4dac$exports = $898ac8779b0a4dac$var$getNative;



var $kqNAI = parcelRequire("kqNAI");
/* Built-in method references that are verified to be native. */ var $9c7ea88729fb6881$var$Map = $898ac8779b0a4dac$exports($kqNAI, 'Map');
$9c7ea88729fb6881$exports = $9c7ea88729fb6881$var$Map;


var $d9c2de0063554eef$exports = {};
var $172b622c09831a48$exports = {};
var $dd3ca463f0a53d8f$exports = {};
var $2b3f8763c746aeec$exports = {};
var $0c3c45af0a7bef25$exports = {};

/* Built-in method references that are verified to be native. */ var $0c3c45af0a7bef25$var$nativeCreate = $898ac8779b0a4dac$exports(Object, 'create');
$0c3c45af0a7bef25$exports = $0c3c45af0a7bef25$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $2b3f8763c746aeec$var$hashClear() {
    this.__data__ = $0c3c45af0a7bef25$exports ? $0c3c45af0a7bef25$exports(null) : {};
    this.size = 0;
}
$2b3f8763c746aeec$exports = $2b3f8763c746aeec$var$hashClear;


var $9c75b7d95bee6051$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9c75b7d95bee6051$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$9c75b7d95bee6051$exports = $9c75b7d95bee6051$var$hashDelete;


var $08416dd187021c22$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $08416dd187021c22$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $08416dd187021c22$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $08416dd187021c22$var$hasOwnProperty = $08416dd187021c22$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $08416dd187021c22$var$hashGet(key) {
    var data = this.__data__;
    if ($0c3c45af0a7bef25$exports) {
        var result = data[key];
        return result === $08416dd187021c22$var$HASH_UNDEFINED ? undefined : result;
    }
    return $08416dd187021c22$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$08416dd187021c22$exports = $08416dd187021c22$var$hashGet;


var $5feed56b5e95fb6e$exports = {};

/** Used for built-in method references. */ var $5feed56b5e95fb6e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5feed56b5e95fb6e$var$hasOwnProperty = $5feed56b5e95fb6e$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5feed56b5e95fb6e$var$hashHas(key) {
    var data = this.__data__;
    return $0c3c45af0a7bef25$exports ? data[key] !== undefined : $5feed56b5e95fb6e$var$hasOwnProperty.call(data, key);
}
$5feed56b5e95fb6e$exports = $5feed56b5e95fb6e$var$hashHas;


var $db51e189b3a8dfe2$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $db51e189b3a8dfe2$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $db51e189b3a8dfe2$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $0c3c45af0a7bef25$exports && value === undefined ? $db51e189b3a8dfe2$var$HASH_UNDEFINED : value;
    return this;
}
$db51e189b3a8dfe2$exports = $db51e189b3a8dfe2$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd3ca463f0a53d8f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$dd3ca463f0a53d8f$var$Hash.prototype.clear = $2b3f8763c746aeec$exports;
$dd3ca463f0a53d8f$var$Hash.prototype['delete'] = $9c75b7d95bee6051$exports;
$dd3ca463f0a53d8f$var$Hash.prototype.get = $08416dd187021c22$exports;
$dd3ca463f0a53d8f$var$Hash.prototype.has = $5feed56b5e95fb6e$exports;
$dd3ca463f0a53d8f$var$Hash.prototype.set = $db51e189b3a8dfe2$exports;
$dd3ca463f0a53d8f$exports = $dd3ca463f0a53d8f$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $172b622c09831a48$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $dd3ca463f0a53d8f$exports,
        'map': new ($9c7ea88729fb6881$exports || $ffdd0bb2fe19dd0b$exports),
        'string': new $dd3ca463f0a53d8f$exports
    };
}
$172b622c09831a48$exports = $172b622c09831a48$var$mapCacheClear;


var $28242eb394aa8435$exports = {};
var $03857a7e768220be$exports = {};
var $5c6705e048082649$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $5c6705e048082649$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$5c6705e048082649$exports = $5c6705e048082649$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $03857a7e768220be$var$getMapData(map, key) {
    var data = map.__data__;
    return $5c6705e048082649$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$03857a7e768220be$exports = $03857a7e768220be$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $28242eb394aa8435$var$mapCacheDelete(key) {
    var result = $03857a7e768220be$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$28242eb394aa8435$exports = $28242eb394aa8435$var$mapCacheDelete;


var $ebf1255c084017c5$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ebf1255c084017c5$var$mapCacheGet(key) {
    return $03857a7e768220be$exports(this, key).get(key);
}
$ebf1255c084017c5$exports = $ebf1255c084017c5$var$mapCacheGet;


var $fce19a7acd196865$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fce19a7acd196865$var$mapCacheHas(key) {
    return $03857a7e768220be$exports(this, key).has(key);
}
$fce19a7acd196865$exports = $fce19a7acd196865$var$mapCacheHas;


var $bfe216c835535d5f$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $bfe216c835535d5f$var$mapCacheSet(key, value) {
    var data = $03857a7e768220be$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$bfe216c835535d5f$exports = $bfe216c835535d5f$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d9c2de0063554eef$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$d9c2de0063554eef$var$MapCache.prototype.clear = $172b622c09831a48$exports;
$d9c2de0063554eef$var$MapCache.prototype['delete'] = $28242eb394aa8435$exports;
$d9c2de0063554eef$var$MapCache.prototype.get = $ebf1255c084017c5$exports;
$d9c2de0063554eef$var$MapCache.prototype.has = $fce19a7acd196865$exports;
$d9c2de0063554eef$var$MapCache.prototype.set = $bfe216c835535d5f$exports;
$d9c2de0063554eef$exports = $d9c2de0063554eef$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $8d74ad93b5a0cee8$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $8d74ad93b5a0cee8$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $ffdd0bb2fe19dd0b$exports) {
        var pairs = data.__data__;
        if (!$9c7ea88729fb6881$exports || pairs.length < $8d74ad93b5a0cee8$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $d9c2de0063554eef$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$8d74ad93b5a0cee8$exports = $8d74ad93b5a0cee8$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $40b82f8d2fb04f5e$var$Stack(entries) {
    var data = this.__data__ = new $ffdd0bb2fe19dd0b$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$40b82f8d2fb04f5e$var$Stack.prototype.clear = $6e210344e5ff63ec$exports;
$40b82f8d2fb04f5e$var$Stack.prototype['delete'] = $95c1cd05d2c9dbcf$exports;
$40b82f8d2fb04f5e$var$Stack.prototype.get = $af72a4d62a055824$exports;
$40b82f8d2fb04f5e$var$Stack.prototype.has = $19f1b43ec6a4bd30$exports;
$40b82f8d2fb04f5e$var$Stack.prototype.set = $8d74ad93b5a0cee8$exports;
$40b82f8d2fb04f5e$exports = $40b82f8d2fb04f5e$var$Stack;


var $2ee53541c1e894e9$exports = {};
var $8ad5666fe7b9841f$exports = {};

var $f08564bf4434c7e5$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $f08564bf4434c7e5$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $f08564bf4434c7e5$var$setCacheAdd(value) {
    this.__data__.set(value, $f08564bf4434c7e5$var$HASH_UNDEFINED);
    return this;
}
$f08564bf4434c7e5$exports = $f08564bf4434c7e5$var$setCacheAdd;


var $18d69031a99f0c2a$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $18d69031a99f0c2a$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$18d69031a99f0c2a$exports = $18d69031a99f0c2a$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $8ad5666fe7b9841f$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $d9c2de0063554eef$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$8ad5666fe7b9841f$var$SetCache.prototype.add = $8ad5666fe7b9841f$var$SetCache.prototype.push = $f08564bf4434c7e5$exports;
$8ad5666fe7b9841f$var$SetCache.prototype.has = $18d69031a99f0c2a$exports;
$8ad5666fe7b9841f$exports = $8ad5666fe7b9841f$var$SetCache;


var $ff432b32ab17b7f1$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $ff432b32ab17b7f1$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$ff432b32ab17b7f1$exports = $ff432b32ab17b7f1$var$arraySome;


var $cb0f21e4a5f01a60$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cb0f21e4a5f01a60$var$cacheHas(cache, key) {
    return cache.has(key);
}
$cb0f21e4a5f01a60$exports = $cb0f21e4a5f01a60$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $2ee53541c1e894e9$var$COMPARE_PARTIAL_FLAG = 1, $2ee53541c1e894e9$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $2ee53541c1e894e9$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $2ee53541c1e894e9$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $2ee53541c1e894e9$var$COMPARE_UNORDERED_FLAG ? new $8ad5666fe7b9841f$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$ff432b32ab17b7f1$exports(other, function(othValue, othIndex) {
                if (!$cb0f21e4a5f01a60$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$2ee53541c1e894e9$exports = $2ee53541c1e894e9$var$equalArrays;


var $690cd9f8dc574d99$exports = {};

var $az0v2 = parcelRequire("az0v2");
var $97d31d41c9d6a9f2$exports = {};

var $kqNAI = parcelRequire("kqNAI");
/** Built-in value references. */ var $97d31d41c9d6a9f2$var$Uint8Array = $kqNAI.Uint8Array;
$97d31d41c9d6a9f2$exports = $97d31d41c9d6a9f2$var$Uint8Array;




var $3517a65469a6092d$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $3517a65469a6092d$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$3517a65469a6092d$exports = $3517a65469a6092d$var$mapToArray;


var $b9d4bf1ebb0056d5$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $b9d4bf1ebb0056d5$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$b9d4bf1ebb0056d5$exports = $b9d4bf1ebb0056d5$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $690cd9f8dc574d99$var$COMPARE_PARTIAL_FLAG = 1, $690cd9f8dc574d99$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $690cd9f8dc574d99$var$boolTag = '[object Boolean]', $690cd9f8dc574d99$var$dateTag = '[object Date]', $690cd9f8dc574d99$var$errorTag = '[object Error]', $690cd9f8dc574d99$var$mapTag = '[object Map]', $690cd9f8dc574d99$var$numberTag = '[object Number]', $690cd9f8dc574d99$var$regexpTag = '[object RegExp]', $690cd9f8dc574d99$var$setTag = '[object Set]', $690cd9f8dc574d99$var$stringTag = '[object String]', $690cd9f8dc574d99$var$symbolTag = '[object Symbol]';
var $690cd9f8dc574d99$var$arrayBufferTag = '[object ArrayBuffer]', $690cd9f8dc574d99$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $690cd9f8dc574d99$var$symbolProto = $az0v2 ? $az0v2.prototype : undefined, $690cd9f8dc574d99$var$symbolValueOf = $690cd9f8dc574d99$var$symbolProto ? $690cd9f8dc574d99$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $690cd9f8dc574d99$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $690cd9f8dc574d99$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $690cd9f8dc574d99$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $97d31d41c9d6a9f2$exports(object), new $97d31d41c9d6a9f2$exports(other))) return false;
            return true;
        case $690cd9f8dc574d99$var$boolTag:
        case $690cd9f8dc574d99$var$dateTag:
        case $690cd9f8dc574d99$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $b24e368740be49a0$exports(+object, +other);
        case $690cd9f8dc574d99$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $690cd9f8dc574d99$var$regexpTag:
        case $690cd9f8dc574d99$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $690cd9f8dc574d99$var$mapTag:
            var convert = $3517a65469a6092d$exports;
        case $690cd9f8dc574d99$var$setTag:
            var isPartial = bitmask & $690cd9f8dc574d99$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $b9d4bf1ebb0056d5$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $690cd9f8dc574d99$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $2ee53541c1e894e9$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $690cd9f8dc574d99$var$symbolTag:
            if ($690cd9f8dc574d99$var$symbolValueOf) return $690cd9f8dc574d99$var$symbolValueOf.call(object) == $690cd9f8dc574d99$var$symbolValueOf.call(other);
    }
    return false;
}
$690cd9f8dc574d99$exports = $690cd9f8dc574d99$var$equalByTag;


var $18ba0421249dab3a$exports = {};
var $250dfb0a3141541b$exports = {};
var $248b19c1411f6003$exports = {};
var $d6bbffc0f155be5b$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $d6bbffc0f155be5b$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$d6bbffc0f155be5b$exports = $d6bbffc0f155be5b$var$arrayPush;



var $3SBIi = parcelRequire("3SBIi");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $248b19c1411f6003$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $3SBIi(object) ? result : $d6bbffc0f155be5b$exports(result, symbolsFunc(object));
}
$248b19c1411f6003$exports = $248b19c1411f6003$var$baseGetAllKeys;


var $a07f6e2defb381b8$exports = {};
var $126e299155f0eba5$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $126e299155f0eba5$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$126e299155f0eba5$exports = $126e299155f0eba5$var$arrayFilter;


var $85652c61092f8327$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $85652c61092f8327$var$stubArray() {
    return [];
}
$85652c61092f8327$exports = $85652c61092f8327$var$stubArray;


/** Used for built-in method references. */ var $a07f6e2defb381b8$var$objectProto = Object.prototype;
/** Built-in value references. */ var $a07f6e2defb381b8$var$propertyIsEnumerable = $a07f6e2defb381b8$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a07f6e2defb381b8$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $a07f6e2defb381b8$var$getSymbols = !$a07f6e2defb381b8$var$nativeGetSymbols ? $85652c61092f8327$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $126e299155f0eba5$exports($a07f6e2defb381b8$var$nativeGetSymbols(object), function(symbol) {
        return $a07f6e2defb381b8$var$propertyIsEnumerable.call(object, symbol);
    });
};
$a07f6e2defb381b8$exports = $a07f6e2defb381b8$var$getSymbols;


var $77c9fcc19d83d589$exports = {};
var $558beaa1638fcea4$exports = {};
var $bb2ef0dea47ca67a$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $bb2ef0dea47ca67a$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$bb2ef0dea47ca67a$exports = $bb2ef0dea47ca67a$var$baseTimes;


var $34b8d0f9e7ea735f$exports = {};
var $03583c9fe9863269$exports = {};

var $euXSx = parcelRequire("euXSx");

var $dPKCC = parcelRequire("dPKCC");
/** `Object#toString` result references. */ var $03583c9fe9863269$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $03583c9fe9863269$var$baseIsArguments(value) {
    return $dPKCC(value) && $euXSx(value) == $03583c9fe9863269$var$argsTag;
}
$03583c9fe9863269$exports = $03583c9fe9863269$var$baseIsArguments;



var $dPKCC = parcelRequire("dPKCC");
/** Used for built-in method references. */ var $34b8d0f9e7ea735f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $34b8d0f9e7ea735f$var$hasOwnProperty = $34b8d0f9e7ea735f$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $34b8d0f9e7ea735f$var$propertyIsEnumerable = $34b8d0f9e7ea735f$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $34b8d0f9e7ea735f$var$isArguments = $03583c9fe9863269$exports(function() {
    return arguments;
}()) ? $03583c9fe9863269$exports : function(value) {
    return $dPKCC(value) && $34b8d0f9e7ea735f$var$hasOwnProperty.call(value, 'callee') && !$34b8d0f9e7ea735f$var$propertyIsEnumerable.call(value, 'callee');
};
$34b8d0f9e7ea735f$exports = $34b8d0f9e7ea735f$var$isArguments;



var $3SBIi = parcelRequire("3SBIi");

var $fDpdg = parcelRequire("fDpdg");
var $d3157aaee478484e$exports = {};
/** Used as references for various `Number` constants. */ var $d3157aaee478484e$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d3157aaee478484e$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d3157aaee478484e$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d3157aaee478484e$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d3157aaee478484e$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$d3157aaee478484e$exports = $d3157aaee478484e$var$isIndex;


var $aef576db44ee5bda$exports = {};
var $ce9486a55f9eb3eb$exports = {};

var $euXSx = parcelRequire("euXSx");
var $c9d8dae03646b588$exports = {};
/** Used as references for various `Number` constants. */ var $c9d8dae03646b588$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $c9d8dae03646b588$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $c9d8dae03646b588$var$MAX_SAFE_INTEGER;
}
$c9d8dae03646b588$exports = $c9d8dae03646b588$var$isLength;



var $dPKCC = parcelRequire("dPKCC");
/** `Object#toString` result references. */ var $ce9486a55f9eb3eb$var$argsTag = '[object Arguments]', $ce9486a55f9eb3eb$var$arrayTag = '[object Array]', $ce9486a55f9eb3eb$var$boolTag = '[object Boolean]', $ce9486a55f9eb3eb$var$dateTag = '[object Date]', $ce9486a55f9eb3eb$var$errorTag = '[object Error]', $ce9486a55f9eb3eb$var$funcTag = '[object Function]', $ce9486a55f9eb3eb$var$mapTag = '[object Map]', $ce9486a55f9eb3eb$var$numberTag = '[object Number]', $ce9486a55f9eb3eb$var$objectTag = '[object Object]', $ce9486a55f9eb3eb$var$regexpTag = '[object RegExp]', $ce9486a55f9eb3eb$var$setTag = '[object Set]', $ce9486a55f9eb3eb$var$stringTag = '[object String]', $ce9486a55f9eb3eb$var$weakMapTag = '[object WeakMap]';
var $ce9486a55f9eb3eb$var$arrayBufferTag = '[object ArrayBuffer]', $ce9486a55f9eb3eb$var$dataViewTag = '[object DataView]', $ce9486a55f9eb3eb$var$float32Tag = '[object Float32Array]', $ce9486a55f9eb3eb$var$float64Tag = '[object Float64Array]', $ce9486a55f9eb3eb$var$int8Tag = '[object Int8Array]', $ce9486a55f9eb3eb$var$int16Tag = '[object Int16Array]', $ce9486a55f9eb3eb$var$int32Tag = '[object Int32Array]', $ce9486a55f9eb3eb$var$uint8Tag = '[object Uint8Array]', $ce9486a55f9eb3eb$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ce9486a55f9eb3eb$var$uint16Tag = '[object Uint16Array]', $ce9486a55f9eb3eb$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $ce9486a55f9eb3eb$var$typedArrayTags = {};
$ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$float32Tag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$float64Tag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$int8Tag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$int16Tag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$int32Tag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$uint8Tag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$uint8ClampedTag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$uint16Tag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$uint32Tag] = true;
$ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$argsTag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$arrayTag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$arrayBufferTag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$boolTag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$dataViewTag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$dateTag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$errorTag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$funcTag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$mapTag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$numberTag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$objectTag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$regexpTag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$setTag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$stringTag] = $ce9486a55f9eb3eb$var$typedArrayTags[$ce9486a55f9eb3eb$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $ce9486a55f9eb3eb$var$baseIsTypedArray(value) {
    return $dPKCC(value) && $c9d8dae03646b588$exports(value.length) && !!$ce9486a55f9eb3eb$var$typedArrayTags[$euXSx(value)];
}
$ce9486a55f9eb3eb$exports = $ce9486a55f9eb3eb$var$baseIsTypedArray;


var $44c7511895282e3a$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $44c7511895282e3a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$44c7511895282e3a$exports = $44c7511895282e3a$var$baseUnary;



var $7UBHT = parcelRequire("7UBHT");
/* Node.js helper references. */ var $aef576db44ee5bda$var$nodeIsTypedArray = $7UBHT && $7UBHT.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $aef576db44ee5bda$var$isTypedArray = $aef576db44ee5bda$var$nodeIsTypedArray ? $44c7511895282e3a$exports($aef576db44ee5bda$var$nodeIsTypedArray) : $ce9486a55f9eb3eb$exports;
$aef576db44ee5bda$exports = $aef576db44ee5bda$var$isTypedArray;


/** Used for built-in method references. */ var $558beaa1638fcea4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $558beaa1638fcea4$var$hasOwnProperty = $558beaa1638fcea4$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $558beaa1638fcea4$var$arrayLikeKeys(value, inherited) {
    var isArr = $3SBIi(value), isArg = !isArr && $34b8d0f9e7ea735f$exports(value), isBuff = !isArr && !isArg && $fDpdg(value), isType = !isArr && !isArg && !isBuff && $aef576db44ee5bda$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $bb2ef0dea47ca67a$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $558beaa1638fcea4$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $d3157aaee478484e$exports(key, length)))) result.push(key);
    return result;
}
$558beaa1638fcea4$exports = $558beaa1638fcea4$var$arrayLikeKeys;


var $ee9eeff90e7e2dc0$exports = {};
var $2e44e5650e95b597$exports = {};
/** Used for built-in method references. */ var $2e44e5650e95b597$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $2e44e5650e95b597$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $2e44e5650e95b597$var$objectProto;
    return value === proto;
}
$2e44e5650e95b597$exports = $2e44e5650e95b597$var$isPrototype;


var $be5cd0ae0765f8b1$exports = {};
var $825dbb274c48366d$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $825dbb274c48366d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$825dbb274c48366d$exports = $825dbb274c48366d$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $be5cd0ae0765f8b1$var$nativeKeys = $825dbb274c48366d$exports(Object.keys, Object);
$be5cd0ae0765f8b1$exports = $be5cd0ae0765f8b1$var$nativeKeys;


/** Used for built-in method references. */ var $ee9eeff90e7e2dc0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ee9eeff90e7e2dc0$var$hasOwnProperty = $ee9eeff90e7e2dc0$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ee9eeff90e7e2dc0$var$baseKeys(object) {
    if (!$2e44e5650e95b597$exports(object)) return $be5cd0ae0765f8b1$exports(object);
    var result = [];
    for(var key in Object(object))if ($ee9eeff90e7e2dc0$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$ee9eeff90e7e2dc0$exports = $ee9eeff90e7e2dc0$var$baseKeys;


var $88de3f5f4e3f212e$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $88de3f5f4e3f212e$var$isArrayLike(value) {
    return value != null && $c9d8dae03646b588$exports(value.length) && !$de26704b56a493fb$exports(value);
}
$88de3f5f4e3f212e$exports = $88de3f5f4e3f212e$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $77c9fcc19d83d589$var$keys(object) {
    return $88de3f5f4e3f212e$exports(object) ? $558beaa1638fcea4$exports(object) : $ee9eeff90e7e2dc0$exports(object);
}
$77c9fcc19d83d589$exports = $77c9fcc19d83d589$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $250dfb0a3141541b$var$getAllKeys(object) {
    return $248b19c1411f6003$exports(object, $77c9fcc19d83d589$exports, $a07f6e2defb381b8$exports);
}
$250dfb0a3141541b$exports = $250dfb0a3141541b$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $18ba0421249dab3a$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $18ba0421249dab3a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $18ba0421249dab3a$var$hasOwnProperty = $18ba0421249dab3a$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $18ba0421249dab3a$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $18ba0421249dab3a$var$COMPARE_PARTIAL_FLAG, objProps = $250dfb0a3141541b$exports(object), objLength = objProps.length, othProps = $250dfb0a3141541b$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $18ba0421249dab3a$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$18ba0421249dab3a$exports = $18ba0421249dab3a$var$equalObjects;


var $56355502efa180b2$exports = {};
var $2d49b3dcd99d0d70$exports = {};


var $kqNAI = parcelRequire("kqNAI");
/* Built-in method references that are verified to be native. */ var $2d49b3dcd99d0d70$var$DataView = $898ac8779b0a4dac$exports($kqNAI, 'DataView');
$2d49b3dcd99d0d70$exports = $2d49b3dcd99d0d70$var$DataView;



var $5fcab55529e6fc59$exports = {};


var $kqNAI = parcelRequire("kqNAI");
/* Built-in method references that are verified to be native. */ var $5fcab55529e6fc59$var$Promise = $898ac8779b0a4dac$exports($kqNAI, 'Promise');
$5fcab55529e6fc59$exports = $5fcab55529e6fc59$var$Promise;


var $56afccc5bdfc53be$exports = {};


var $kqNAI = parcelRequire("kqNAI");
/* Built-in method references that are verified to be native. */ var $56afccc5bdfc53be$var$Set = $898ac8779b0a4dac$exports($kqNAI, 'Set');
$56afccc5bdfc53be$exports = $56afccc5bdfc53be$var$Set;


var $cef9504478956853$exports = {};


var $kqNAI = parcelRequire("kqNAI");
/* Built-in method references that are verified to be native. */ var $cef9504478956853$var$WeakMap = $898ac8779b0a4dac$exports($kqNAI, 'WeakMap');
$cef9504478956853$exports = $cef9504478956853$var$WeakMap;



var $euXSx = parcelRequire("euXSx");

/** `Object#toString` result references. */ var $56355502efa180b2$var$mapTag = '[object Map]', $56355502efa180b2$var$objectTag = '[object Object]', $56355502efa180b2$var$promiseTag = '[object Promise]', $56355502efa180b2$var$setTag = '[object Set]', $56355502efa180b2$var$weakMapTag = '[object WeakMap]';
var $56355502efa180b2$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $56355502efa180b2$var$dataViewCtorString = $7a2f7216696cc973$exports($2d49b3dcd99d0d70$exports), $56355502efa180b2$var$mapCtorString = $7a2f7216696cc973$exports($9c7ea88729fb6881$exports), $56355502efa180b2$var$promiseCtorString = $7a2f7216696cc973$exports($5fcab55529e6fc59$exports), $56355502efa180b2$var$setCtorString = $7a2f7216696cc973$exports($56afccc5bdfc53be$exports), $56355502efa180b2$var$weakMapCtorString = $7a2f7216696cc973$exports($cef9504478956853$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $56355502efa180b2$var$getTag = $euXSx;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($2d49b3dcd99d0d70$exports && $56355502efa180b2$var$getTag(new $2d49b3dcd99d0d70$exports(new ArrayBuffer(1))) != $56355502efa180b2$var$dataViewTag || $9c7ea88729fb6881$exports && $56355502efa180b2$var$getTag(new $9c7ea88729fb6881$exports) != $56355502efa180b2$var$mapTag || $5fcab55529e6fc59$exports && $56355502efa180b2$var$getTag($5fcab55529e6fc59$exports.resolve()) != $56355502efa180b2$var$promiseTag || $56afccc5bdfc53be$exports && $56355502efa180b2$var$getTag(new $56afccc5bdfc53be$exports) != $56355502efa180b2$var$setTag || $cef9504478956853$exports && $56355502efa180b2$var$getTag(new $cef9504478956853$exports) != $56355502efa180b2$var$weakMapTag) $56355502efa180b2$var$getTag = function(value) {
    var result = $euXSx(value), Ctor = result == $56355502efa180b2$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $7a2f7216696cc973$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $56355502efa180b2$var$dataViewCtorString:
            return $56355502efa180b2$var$dataViewTag;
        case $56355502efa180b2$var$mapCtorString:
            return $56355502efa180b2$var$mapTag;
        case $56355502efa180b2$var$promiseCtorString:
            return $56355502efa180b2$var$promiseTag;
        case $56355502efa180b2$var$setCtorString:
            return $56355502efa180b2$var$setTag;
        case $56355502efa180b2$var$weakMapCtorString:
            return $56355502efa180b2$var$weakMapTag;
    }
    return result;
};
$56355502efa180b2$exports = $56355502efa180b2$var$getTag;



var $3SBIi = parcelRequire("3SBIi");

var $fDpdg = parcelRequire("fDpdg");

/** Used to compose bitmasks for value comparisons. */ var $e093ce881f5e54d7$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $e093ce881f5e54d7$var$argsTag = '[object Arguments]', $e093ce881f5e54d7$var$arrayTag = '[object Array]', $e093ce881f5e54d7$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $e093ce881f5e54d7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e093ce881f5e54d7$var$hasOwnProperty = $e093ce881f5e54d7$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e093ce881f5e54d7$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $3SBIi(object), othIsArr = $3SBIi(other), objTag = objIsArr ? $e093ce881f5e54d7$var$arrayTag : $56355502efa180b2$exports(object), othTag = othIsArr ? $e093ce881f5e54d7$var$arrayTag : $56355502efa180b2$exports(other);
    objTag = objTag == $e093ce881f5e54d7$var$argsTag ? $e093ce881f5e54d7$var$objectTag : objTag;
    othTag = othTag == $e093ce881f5e54d7$var$argsTag ? $e093ce881f5e54d7$var$objectTag : othTag;
    var objIsObj = objTag == $e093ce881f5e54d7$var$objectTag, othIsObj = othTag == $e093ce881f5e54d7$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $fDpdg(object)) {
        if (!$fDpdg(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $40b82f8d2fb04f5e$exports);
        return objIsArr || $aef576db44ee5bda$exports(object) ? $2ee53541c1e894e9$exports(object, other, bitmask, customizer, equalFunc, stack) : $690cd9f8dc574d99$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $e093ce881f5e54d7$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $e093ce881f5e54d7$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $e093ce881f5e54d7$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $40b82f8d2fb04f5e$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $40b82f8d2fb04f5e$exports);
    return $18ba0421249dab3a$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$e093ce881f5e54d7$exports = $e093ce881f5e54d7$var$baseIsEqualDeep;



var $dPKCC = parcelRequire("dPKCC");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $204a924ef706f07d$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$dPKCC(value) && !$dPKCC(other)) return value !== value && other !== other;
    return $e093ce881f5e54d7$exports(value, other, bitmask, customizer, $204a924ef706f07d$var$baseIsEqual, stack);
}
$204a924ef706f07d$exports = $204a924ef706f07d$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $0aaac3f8a867d076$var$isEqual(value, other) {
    return $204a924ef706f07d$exports(value, other);
}
$0aaac3f8a867d076$exports = $0aaac3f8a867d076$var$isEqual;



var $6fFrj = parcelRequire("6fFrj");










var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $5KhTJ = parcelRequire("5KhTJ");

var $kNxFX = parcelRequire("kNxFX");

var $37xND = parcelRequire("37xND");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $3mZgl = parcelRequire("3mZgl");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $fActo = parcelRequire("fActo");



var $3mXQ2 = parcelRequire("3mXQ2");

var $6fFrj = parcelRequire("6fFrj");
/**
 * Webpack has bug for import loop, which is not the same behavior as ES module.
 * When util.js imports the TreeNode for tree generate will cause treeContextTypes be empty.
 */ 
var $6fFrj = parcelRequire("6fFrj");
var $73625c1f8b3860d0$export$dfae7d399eea2568 = /*#__PURE__*/ $6fFrj.createContext(null);



var $6fFrj = parcelRequire("6fFrj");
function $d7cb019f7dc4c67c$export$2e2bcd8739ae039(_ref) {
    var dropPosition = _ref.dropPosition, dropLevelOffset = _ref.dropLevelOffset, indent = _ref.indent;
    var style = {
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        backgroundColor: 'red',
        height: 2
    };
    switch(dropPosition){
        case -1:
            style.top = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 1:
            style.bottom = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 0:
            style.bottom = 0;
            style.left = indent;
            break;
    }
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        style: style
    });
}


function $d9554b49ebbb9fba$export$2e2bcd8739ae039(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}



var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $dNZA9 = parcelRequire("dNZA9");


var $6fFrj = parcelRequire("6fFrj");


var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $04RxA = parcelRequire("04RxA");

var $fActo = parcelRequire("fActo");

var $5EVeC = parcelRequire("5EVeC");

var $dNZA9 = parcelRequire("dNZA9");

var $6fFrj = parcelRequire("6fFrj");


var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $04RxA = parcelRequire("04RxA");

var $kNxFX = parcelRequire("kNxFX");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $3mZgl = parcelRequire("3mZgl");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");


var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");

var $fActo = parcelRequire("fActo");
var $035e1563e1fb55fe$var$Indent = function Indent(_ref) {
    var prefixCls = _ref.prefixCls, level = _ref.level, isStart = _ref.isStart, isEnd = _ref.isEnd;
    var baseClassName = "".concat(prefixCls, "-indent-unit");
    var list = [];
    for(var i = 0; i < level; i += 1){
        var _classNames;
        list.push(/*#__PURE__*/ $6fFrj.createElement("span", {
            key: i,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(baseClassName, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(baseClassName, "-start"), isStart[i]), (0, $43449.default)(_classNames, "".concat(baseClassName, "-end"), isEnd[i]), _classNames))
        }));
    }
    return /*#__PURE__*/ $6fFrj.createElement("span", {
        "aria-hidden": "true",
        className: "".concat(prefixCls, "-indent")
    }, list);
};
var $035e1563e1fb55fe$export$2e2bcd8739ae039 = /*#__PURE__*/ $6fFrj.memo($035e1563e1fb55fe$var$Indent);


function $3b1032c8cfe29d42$export$2e2bcd8739ae039(keyEntities, key) {
    return keyEntities[key];
}



var $5KhTJ = parcelRequire("5KhTJ");

var $37xND = parcelRequire("37xND");

var $kNxFX = parcelRequire("kNxFX");

var $04RxA = parcelRequire("04RxA");



var $3mXQ2 = parcelRequire("3mXQ2");

var $35a937288f4ed5dd$var$_excluded = [
    "children"
];
function $35a937288f4ed5dd$export$1690e12b840569b9(level, index) {
    return "".concat(level, "-").concat(index);
}
function $35a937288f4ed5dd$export$1c189858aa1437d7(node) {
    return node && node.type && node.type.isTreeNode;
}
function $35a937288f4ed5dd$export$a47fb462a08de82f(key, pos) {
    if (key !== null && key !== undefined) return key;
    return pos;
}
function $35a937288f4ed5dd$export$6c519d302dced239(fieldNames) {
    var _ref = fieldNames || {}, title = _ref.title, _title = _ref._title, key = _ref.key, children = _ref.children;
    var mergedTitle = title || 'title';
    return {
        title: mergedTitle,
        _title: _title || [
            mergedTitle
        ],
        key: key || 'key',
        children: children || 'children'
    };
}
function $35a937288f4ed5dd$export$702780ec64d148df(treeData, fieldNames) {
    var keys = new Map();
    function dig(list) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        (list || []).forEach(function(treeNode) {
            var key = treeNode[fieldNames.key];
            var children = treeNode[fieldNames.children];
            (0, $3mXQ2.default)(key !== null && key !== undefined, "Tree node must have a certain key: [".concat(path).concat(key, "]"));
            var recordKey = String(key);
            (0, $3mXQ2.default)(!keys.has(recordKey) || key === null || key === undefined, "Same 'key' exist in the Tree: ".concat(recordKey));
            keys.set(recordKey, true);
            dig(children, "".concat(path).concat(recordKey, " > "));
        });
    }
    dig(treeData);
}
function $35a937288f4ed5dd$export$6d8b10995563b669(rootNodes) {
    function dig(node) {
        var treeNodes = (0, $a41a9a7924b187f8$export$2e2bcd8739ae039)(node);
        return treeNodes.map(function(treeNode) {
            // Filter invalidate node
            if (!$35a937288f4ed5dd$export$1c189858aa1437d7(treeNode)) {
                (0, $3mXQ2.default)(!treeNode, 'Tree/TreeNode can only accept TreeNode as children.');
                return null;
            }
            var key = treeNode.key;
            var _treeNode$props = treeNode.props, children = _treeNode$props.children, rest = (0, $04RxA.default)(_treeNode$props, $35a937288f4ed5dd$var$_excluded);
            var dataNode = (0, $kNxFX.default)({
                key: key
            }, rest);
            var parsedChildren = dig(children);
            if (parsedChildren.length) dataNode.children = parsedChildren;
            return dataNode;
        }).filter(function(dataNode) {
            return dataNode;
        });
    }
    return dig(rootNodes);
}
function $35a937288f4ed5dd$export$215c1b4f1ba88b23(treeNodeList, expandedKeys, fieldNames) {
    var _fillFieldNames = $35a937288f4ed5dd$export$6c519d302dced239(fieldNames), fieldTitles = _fillFieldNames._title, fieldKey = _fillFieldNames.key, fieldChildren = _fillFieldNames.children;
    var expandedKeySet = new Set(expandedKeys === true ? [] : expandedKeys);
    var flattenList = [];
    function dig(list) {
        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return list.map(function(treeNode, index) {
            var pos = $35a937288f4ed5dd$export$1690e12b840569b9(parent ? parent.pos : '0', index);
            var mergedKey = $35a937288f4ed5dd$export$a47fb462a08de82f(treeNode[fieldKey], pos);
            // Pick matched title in field title list
            var mergedTitle;
            for(var i = 0; i < fieldTitles.length; i += 1){
                var fieldTitle = fieldTitles[i];
                if (treeNode[fieldTitle] !== undefined) {
                    mergedTitle = treeNode[fieldTitle];
                    break;
                }
            }
            // Add FlattenDataNode into list
            var flattenNode = (0, $kNxFX.default)((0, $kNxFX.default)({}, (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(treeNode, [].concat((0, $37xND.default)(fieldTitles), [
                fieldKey,
                fieldChildren
            ]))), {}, {
                title: mergedTitle,
                key: mergedKey,
                parent: parent,
                pos: pos,
                children: null,
                data: treeNode,
                isStart: [].concat((0, $37xND.default)(parent ? parent.isStart : []), [
                    index === 0
                ]),
                isEnd: [].concat((0, $37xND.default)(parent ? parent.isEnd : []), [
                    index === list.length - 1
                ])
            });
            flattenList.push(flattenNode);
            // Loop treeNode children
            if (expandedKeys === true || expandedKeySet.has(mergedKey)) flattenNode.children = dig(treeNode[fieldChildren] || [], flattenNode);
            else flattenNode.children = [];
            return flattenNode;
        });
    }
    dig(treeNodeList);
    return flattenList;
}
function $35a937288f4ed5dd$export$4b2e27469b557f9d(dataNodes, callback, // To avoid too many params, let use config instead of origin param
config) {
    var mergedConfig = {};
    if ((0, $5KhTJ.default)(config) === 'object') mergedConfig = config;
    else mergedConfig = {
        externalGetKey: config
    };
    mergedConfig = mergedConfig || {};
    // Init config
    var _mergedConfig = mergedConfig, childrenPropName = _mergedConfig.childrenPropName, externalGetKey = _mergedConfig.externalGetKey, fieldNames = _mergedConfig.fieldNames;
    var _fillFieldNames2 = $35a937288f4ed5dd$export$6c519d302dced239(fieldNames), fieldKey = _fillFieldNames2.key, fieldChildren = _fillFieldNames2.children;
    var mergeChildrenPropName = childrenPropName || fieldChildren;
    // Get keys
    var syntheticGetKey;
    if (externalGetKey) {
        if (typeof externalGetKey === 'string') syntheticGetKey = function syntheticGetKey(node) {
            return node[externalGetKey];
        };
        else if (typeof externalGetKey === 'function') syntheticGetKey = function syntheticGetKey(node) {
            return externalGetKey(node);
        };
    } else syntheticGetKey = function syntheticGetKey(node, pos) {
        return $35a937288f4ed5dd$export$a47fb462a08de82f(node[fieldKey], pos);
    };
    // Process
    function processNode(node, index, parent, pathNodes) {
        var children = node ? node[mergeChildrenPropName] : dataNodes;
        var pos = node ? $35a937288f4ed5dd$export$1690e12b840569b9(parent.pos, index) : '0';
        var connectNodes = node ? [].concat((0, $37xND.default)(pathNodes), [
            node
        ]) : [];
        // Process node if is not root
        if (node) {
            var key = syntheticGetKey(node, pos);
            var data = {
                node: node,
                index: index,
                pos: pos,
                key: key,
                parentPos: parent.node ? parent.pos : null,
                level: parent.level + 1,
                nodes: connectNodes
            };
            callback(data);
        }
        // Process children node
        if (children) children.forEach(function(subNode, subIndex) {
            processNode(subNode, subIndex, {
                node: node,
                pos: pos,
                level: parent ? parent.level + 1 : -1
            }, connectNodes);
        });
    }
    processNode(null);
}
function $35a937288f4ed5dd$export$e5d831ce033a4615(dataNodes) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, initWrapper = _ref2.initWrapper, processEntity = _ref2.processEntity, onProcessFinished = _ref2.onProcessFinished, externalGetKey = _ref2.externalGetKey, childrenPropName = _ref2.childrenPropName, fieldNames = _ref2.fieldNames;
    var /** @deprecated Use `config.externalGetKey` instead */ legacyExternalGetKey = arguments.length > 2 ? arguments[2] : undefined;
    // Init config
    var mergedExternalGetKey = externalGetKey || legacyExternalGetKey;
    var posEntities = {};
    var keyEntities = {};
    var wrapper = {
        posEntities: posEntities,
        keyEntities: keyEntities
    };
    if (initWrapper) wrapper = initWrapper(wrapper) || wrapper;
    $35a937288f4ed5dd$export$4b2e27469b557f9d(dataNodes, function(item) {
        var node = item.node, index = item.index, pos = item.pos, key = item.key, parentPos = item.parentPos, level = item.level, nodes = item.nodes;
        var entity = {
            node: node,
            nodes: nodes,
            index: index,
            key: key,
            pos: pos,
            level: level
        };
        var mergedKey = $35a937288f4ed5dd$export$a47fb462a08de82f(key, pos);
        posEntities[pos] = entity;
        keyEntities[mergedKey] = entity;
        // Fill children
        entity.parent = posEntities[parentPos];
        if (entity.parent) {
            entity.parent.children = entity.parent.children || [];
            entity.parent.children.push(entity);
        }
        if (processEntity) processEntity(entity, wrapper);
    }, {
        externalGetKey: mergedExternalGetKey,
        childrenPropName: childrenPropName,
        fieldNames: fieldNames
    });
    if (onProcessFinished) onProcessFinished(wrapper);
    return wrapper;
}
function $35a937288f4ed5dd$export$d961fd523a514db5(key, _ref3) {
    var expandedKeys = _ref3.expandedKeys, selectedKeys = _ref3.selectedKeys, loadedKeys = _ref3.loadedKeys, loadingKeys = _ref3.loadingKeys, checkedKeys = _ref3.checkedKeys, halfCheckedKeys = _ref3.halfCheckedKeys, dragOverNodeKey = _ref3.dragOverNodeKey, dropPosition = _ref3.dropPosition, keyEntities = _ref3.keyEntities;
    var entity = (0, $3b1032c8cfe29d42$export$2e2bcd8739ae039)(keyEntities, key);
    var treeNodeProps = {
        eventKey: key,
        expanded: expandedKeys.indexOf(key) !== -1,
        selected: selectedKeys.indexOf(key) !== -1,
        loaded: loadedKeys.indexOf(key) !== -1,
        loading: loadingKeys.indexOf(key) !== -1,
        checked: checkedKeys.indexOf(key) !== -1,
        halfChecked: halfCheckedKeys.indexOf(key) !== -1,
        pos: String(entity ? entity.pos : ''),
        // [Legacy] Drag props
        // Since the interaction of drag is changed, the semantic of the props are
        // not accuracy, I think it should be finally removed
        dragOver: dragOverNodeKey === key && dropPosition === 0,
        dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
        dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
    };
    return treeNodeProps;
}
function $35a937288f4ed5dd$export$7bd1b0fd4a8b540b(props) {
    var data = props.data, expanded = props.expanded, selected = props.selected, checked = props.checked, loaded = props.loaded, loading = props.loading, halfChecked = props.halfChecked, dragOver = props.dragOver, dragOverGapTop = props.dragOverGapTop, dragOverGapBottom = props.dragOverGapBottom, pos = props.pos, active = props.active, eventKey = props.eventKey;
    var eventData = (0, $kNxFX.default)((0, $kNxFX.default)({}, data), {}, {
        expanded: expanded,
        selected: selected,
        checked: checked,
        loaded: loaded,
        loading: loading,
        halfChecked: halfChecked,
        dragOver: dragOver,
        dragOverGapTop: dragOverGapTop,
        dragOverGapBottom: dragOverGapBottom,
        pos: pos,
        active: active,
        key: eventKey
    });
    if (!('props' in eventData)) Object.defineProperty(eventData, 'props', {
        get: function get() {
            (0, $3mXQ2.default)(false, 'Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`.');
            return props;
        }
    });
    return eventData;
}


var $c40e2bb393cde7f6$var$_excluded = [
    "eventKey",
    "className",
    "style",
    "dragOver",
    "dragOverGapTop",
    "dragOverGapBottom",
    "isLeaf",
    "isStart",
    "isEnd",
    "expanded",
    "selected",
    "checked",
    "halfChecked",
    "loading",
    "domRef",
    "active",
    "data",
    "onMouseMove",
    "selectable"
];
var $c40e2bb393cde7f6$var$ICON_OPEN = 'open';
var $c40e2bb393cde7f6$var$ICON_CLOSE = 'close';
var $c40e2bb393cde7f6$var$defaultTitle = '---';
var $c40e2bb393cde7f6$var$InternalTreeNode = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(InternalTreeNode, _React$Component);
    var _super = (0, $lSufv.default)(InternalTreeNode);
    function InternalTreeNode() {
        var _this;
        (0, $kjNeN.default)(this, InternalTreeNode);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            dragNodeHighlight: false
        };
        _this.selectHandle = void 0;
        _this.cacheIndent = void 0;
        _this.onSelectorClick = function(e) {
            // Click trigger before select/check operation
            var onNodeClick = _this.props.context.onNodeClick;
            onNodeClick(e, (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(_this.props));
            if (_this.isSelectable()) _this.onSelect(e);
            else _this.onCheck(e);
        };
        _this.onSelectorDoubleClick = function(e) {
            var onNodeDoubleClick = _this.props.context.onNodeDoubleClick;
            onNodeDoubleClick(e, (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(_this.props));
        };
        _this.onSelect = function(e) {
            if (_this.isDisabled()) return;
            var onNodeSelect = _this.props.context.onNodeSelect;
            onNodeSelect(e, (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(_this.props));
        };
        _this.onCheck = function(e) {
            if (_this.isDisabled()) return;
            var _this$props = _this.props, disableCheckbox = _this$props.disableCheckbox, checked = _this$props.checked;
            var onNodeCheck = _this.props.context.onNodeCheck;
            if (!_this.isCheckable() || disableCheckbox) return;
            var targetChecked = !checked;
            onNodeCheck(e, (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(_this.props), targetChecked);
        };
        _this.onMouseEnter = function(e) {
            var onNodeMouseEnter = _this.props.context.onNodeMouseEnter;
            onNodeMouseEnter(e, (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(_this.props));
        };
        _this.onMouseLeave = function(e) {
            var onNodeMouseLeave = _this.props.context.onNodeMouseLeave;
            onNodeMouseLeave(e, (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(_this.props));
        };
        _this.onContextMenu = function(e) {
            var onNodeContextMenu = _this.props.context.onNodeContextMenu;
            onNodeContextMenu(e, (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(_this.props));
        };
        _this.onDragStart = function(e) {
            var onNodeDragStart = _this.props.context.onNodeDragStart;
            e.stopPropagation();
            _this.setState({
                dragNodeHighlight: true
            });
            onNodeDragStart(e, (0, $3mZgl.default)(_this));
            try {
                // ie throw error
                // firefox-need-it
                e.dataTransfer.setData('text/plain', '');
            } catch (error) {
            // empty
            }
        };
        _this.onDragEnter = function(e) {
            var onNodeDragEnter = _this.props.context.onNodeDragEnter;
            e.preventDefault();
            e.stopPropagation();
            onNodeDragEnter(e, (0, $3mZgl.default)(_this));
        };
        _this.onDragOver = function(e) {
            var onNodeDragOver = _this.props.context.onNodeDragOver;
            e.preventDefault();
            e.stopPropagation();
            onNodeDragOver(e, (0, $3mZgl.default)(_this));
        };
        _this.onDragLeave = function(e) {
            var onNodeDragLeave = _this.props.context.onNodeDragLeave;
            e.stopPropagation();
            onNodeDragLeave(e, (0, $3mZgl.default)(_this));
        };
        _this.onDragEnd = function(e) {
            var onNodeDragEnd = _this.props.context.onNodeDragEnd;
            e.stopPropagation();
            _this.setState({
                dragNodeHighlight: false
            });
            onNodeDragEnd(e, (0, $3mZgl.default)(_this));
        };
        _this.onDrop = function(e) {
            var onNodeDrop = _this.props.context.onNodeDrop;
            e.preventDefault();
            e.stopPropagation();
            _this.setState({
                dragNodeHighlight: false
            });
            onNodeDrop(e, (0, $3mZgl.default)(_this));
        };
        // Disabled item still can be switch
        _this.onExpand = function(e) {
            var _this$props2 = _this.props, loading = _this$props2.loading, onNodeExpand = _this$props2.context.onNodeExpand;
            if (loading) return;
            onNodeExpand(e, (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(_this.props));
        };
        // Drag usage
        _this.setSelectHandle = function(node) {
            _this.selectHandle = node;
        };
        _this.getNodeState = function() {
            var expanded = _this.props.expanded;
            if (_this.isLeaf()) return null;
            return expanded ? $c40e2bb393cde7f6$var$ICON_OPEN : $c40e2bb393cde7f6$var$ICON_CLOSE;
        };
        _this.hasChildren = function() {
            var eventKey = _this.props.eventKey;
            var keyEntities = _this.props.context.keyEntities;
            var _ref = (0, $3b1032c8cfe29d42$export$2e2bcd8739ae039)(keyEntities, eventKey) || {}, children = _ref.children;
            return !!(children || []).length;
        };
        _this.isLeaf = function() {
            var _this$props3 = _this.props, isLeaf = _this$props3.isLeaf, loaded = _this$props3.loaded;
            var loadData = _this.props.context.loadData;
            var hasChildren = _this.hasChildren();
            if (isLeaf === false) return false;
            return isLeaf || !loadData && !hasChildren || loadData && loaded && !hasChildren;
        };
        _this.isDisabled = function() {
            var disabled = _this.props.disabled;
            var treeDisabled = _this.props.context.disabled;
            return !!(treeDisabled || disabled);
        };
        _this.isCheckable = function() {
            var checkable = _this.props.checkable;
            var treeCheckable = _this.props.context.checkable;
            // Return false if tree or treeNode is not checkable
            if (!treeCheckable || checkable === false) return false;
            return treeCheckable;
        };
        // Load data to avoid default expanded tree without data
        _this.syncLoadData = function(props) {
            var expanded = props.expanded, loading = props.loading, loaded = props.loaded;
            var _this$props$context = _this.props.context, loadData = _this$props$context.loadData, onNodeLoad = _this$props$context.onNodeLoad;
            if (loading) return;
            // read from state to avoid loadData at same time
            if (loadData && expanded && !_this.isLeaf()) // We needn't reload data when has children in sync logic
            // It's only needed in node expanded
            {
                if (!_this.hasChildren() && !loaded) onNodeLoad((0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(_this.props));
            }
        };
        _this.isDraggable = function() {
            var _this$props4 = _this.props, data = _this$props4.data, draggable = _this$props4.context.draggable;
            return !!(draggable && (!draggable.nodeDraggable || draggable.nodeDraggable(data)));
        };
        // ==================== Render: Drag Handler ====================
        _this.renderDragHandler = function() {
            var _this$props$context2 = _this.props.context, draggable = _this$props$context2.draggable, prefixCls = _this$props$context2.prefixCls;
            return (draggable === null || draggable === void 0 ? void 0 : draggable.icon) ? /*#__PURE__*/ $6fFrj.createElement("span", {
                className: "".concat(prefixCls, "-draggable-icon")
            }, draggable.icon) : null;
        };
        // ====================== Render: Switcher ======================
        _this.renderSwitcherIconDom = function(isLeaf) {
            var switcherIconFromProps = _this.props.switcherIcon;
            var switcherIconFromCtx = _this.props.context.switcherIcon;
            var switcherIcon = switcherIconFromProps || switcherIconFromCtx;
            // if switcherIconDom is null, no render switcher span
            if (typeof switcherIcon === 'function') return switcherIcon((0, $kNxFX.default)((0, $kNxFX.default)({}, _this.props), {}, {
                isLeaf: isLeaf
            }));
            return switcherIcon;
        };
        // Switcher
        _this.renderSwitcher = function() {
            var expanded = _this.props.expanded;
            var prefixCls = _this.props.context.prefixCls;
            if (_this.isLeaf()) {
                // if switcherIconDom is null, no render switcher span
                var _switcherIconDom = _this.renderSwitcherIconDom(true);
                return _switcherIconDom !== false ? /*#__PURE__*/ $6fFrj.createElement("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher-noop"))
                }, _switcherIconDom) : null;
            }
            var switcherCls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher_").concat(expanded ? $c40e2bb393cde7f6$var$ICON_OPEN : $c40e2bb393cde7f6$var$ICON_CLOSE));
            var switcherIconDom = _this.renderSwitcherIconDom(false);
            return switcherIconDom !== false ? /*#__PURE__*/ $6fFrj.createElement("span", {
                onClick: _this.onExpand,
                className: switcherCls
            }, switcherIconDom) : null;
        };
        // ====================== Render: Checkbox ======================
        // Checkbox
        _this.renderCheckbox = function() {
            var _this$props5 = _this.props, checked = _this$props5.checked, halfChecked = _this$props5.halfChecked, disableCheckbox = _this$props5.disableCheckbox;
            var prefixCls = _this.props.context.prefixCls;
            var disabled = _this.isDisabled();
            var checkable = _this.isCheckable();
            if (!checkable) return null;
            // [Legacy] Custom element should be separate with `checkable` in future
            var $custom = typeof checkable !== 'boolean' ? checkable : null;
            return /*#__PURE__*/ $6fFrj.createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-checkbox"), checked && "".concat(prefixCls, "-checkbox-checked"), !checked && halfChecked && "".concat(prefixCls, "-checkbox-indeterminate"), (disabled || disableCheckbox) && "".concat(prefixCls, "-checkbox-disabled")),
                onClick: _this.onCheck
            }, $custom);
        };
        // ==================== Render: Title + Icon ====================
        _this.renderIcon = function() {
            var loading = _this.props.loading;
            var prefixCls = _this.props.context.prefixCls;
            return /*#__PURE__*/ $6fFrj.createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__").concat(_this.getNodeState() || 'docu'), loading && "".concat(prefixCls, "-icon_loading"))
            });
        };
        // Icon + Title
        _this.renderSelector = function() {
            var dragNodeHighlight = _this.state.dragNodeHighlight;
            var _this$props6 = _this.props, _this$props6$title = _this$props6.title, title = _this$props6$title === void 0 ? $c40e2bb393cde7f6$var$defaultTitle : _this$props6$title, selected = _this$props6.selected, icon = _this$props6.icon, loading = _this$props6.loading, data = _this$props6.data;
            var _this$props$context3 = _this.props.context, prefixCls = _this$props$context3.prefixCls, showIcon = _this$props$context3.showIcon, treeIcon = _this$props$context3.icon, loadData = _this$props$context3.loadData, titleRender = _this$props$context3.titleRender;
            var disabled = _this.isDisabled();
            var wrapClass = "".concat(prefixCls, "-node-content-wrapper");
            // Icon - Still show loading icon when loading without showIcon
            var $icon;
            if (showIcon) {
                var currentIcon = icon || treeIcon;
                $icon = currentIcon ? /*#__PURE__*/ $6fFrj.createElement("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__customize"))
                }, typeof currentIcon === 'function' ? currentIcon(_this.props) : currentIcon) : _this.renderIcon();
            } else if (loadData && loading) $icon = _this.renderIcon();
            // Title
            var titleNode;
            if (typeof title === 'function') titleNode = title(data);
            else if (titleRender) titleNode = titleRender(data);
            else titleNode = title;
            var $title = /*#__PURE__*/ $6fFrj.createElement("span", {
                className: "".concat(prefixCls, "-title")
            }, titleNode);
            return /*#__PURE__*/ $6fFrj.createElement("span", {
                ref: _this.setSelectHandle,
                title: typeof title === 'string' ? title : '',
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(wrapClass), "".concat(wrapClass, "-").concat(_this.getNodeState() || 'normal'), !disabled && (selected || dragNodeHighlight) && "".concat(prefixCls, "-node-selected")),
                onMouseEnter: _this.onMouseEnter,
                onMouseLeave: _this.onMouseLeave,
                onContextMenu: _this.onContextMenu,
                onClick: _this.onSelectorClick,
                onDoubleClick: _this.onSelectorDoubleClick
            }, $icon, $title, _this.renderDropIndicator());
        };
        // =================== Render: Drop Indicator ===================
        _this.renderDropIndicator = function() {
            var _this$props7 = _this.props, disabled = _this$props7.disabled, eventKey = _this$props7.eventKey;
            var _this$props$context4 = _this.props.context, draggable = _this$props$context4.draggable, dropLevelOffset = _this$props$context4.dropLevelOffset, dropPosition = _this$props$context4.dropPosition, prefixCls = _this$props$context4.prefixCls, indent = _this$props$context4.indent, dropIndicatorRender = _this$props$context4.dropIndicatorRender, dragOverNodeKey = _this$props$context4.dragOverNodeKey, direction = _this$props$context4.direction;
            var rootDraggable = !!draggable;
            // allowDrop is calculated in Tree.tsx, there is no need for calc it here
            var showIndicator = !disabled && rootDraggable && dragOverNodeKey === eventKey;
            // This is a hot fix which is already fixed in
            // https://github.com/react-component/tree/pull/743/files
            // But some case need break point so we hack on this
            // ref https://github.com/ant-design/ant-design/issues/43493
            var mergedIndent = indent !== null && indent !== void 0 ? indent : _this.cacheIndent;
            _this.cacheIndent = indent;
            return showIndicator ? dropIndicatorRender({
                dropPosition: dropPosition,
                dropLevelOffset: dropLevelOffset,
                indent: mergedIndent,
                prefixCls: prefixCls,
                direction: direction
            }) : null;
        };
        return _this;
    }
    (0, $5KQxu.default)(InternalTreeNode, [
        {
            key: "componentDidMount",
            value: // Isomorphic needn't load data in server side
            function componentDidMount() {
                this.syncLoadData(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.syncLoadData(this.props);
            }
        },
        {
            key: "isSelectable",
            value: function isSelectable() {
                var selectable = this.props.selectable;
                var treeSelectable = this.props.context.selectable;
                // Ignore when selectable is undefined or null
                if (typeof selectable === 'boolean') return selectable;
                return treeSelectable;
            }
        },
        {
            key: "render",
            value: // =========================== Render ===========================
            function render() {
                var _classNames;
                var _this$props8 = this.props, eventKey = _this$props8.eventKey, className = _this$props8.className, style = _this$props8.style, dragOver = _this$props8.dragOver, dragOverGapTop = _this$props8.dragOverGapTop, dragOverGapBottom = _this$props8.dragOverGapBottom, isLeaf = _this$props8.isLeaf, isStart = _this$props8.isStart, isEnd = _this$props8.isEnd, expanded = _this$props8.expanded, selected = _this$props8.selected, checked = _this$props8.checked, halfChecked = _this$props8.halfChecked, loading = _this$props8.loading, domRef = _this$props8.domRef, active = _this$props8.active, data = _this$props8.data, onMouseMove = _this$props8.onMouseMove, selectable = _this$props8.selectable, otherProps = (0, $04RxA.default)(_this$props8, $c40e2bb393cde7f6$var$_excluded);
                var _this$props$context5 = this.props.context, prefixCls = _this$props$context5.prefixCls, filterTreeNode = _this$props$context5.filterTreeNode, keyEntities = _this$props$context5.keyEntities, dropContainerKey = _this$props$context5.dropContainerKey, dropTargetKey = _this$props$context5.dropTargetKey, draggingNodeKey = _this$props$context5.draggingNodeKey;
                var disabled = this.isDisabled();
                var dataOrAriaAttributeProps = (0, $c7e00e8671f36d19$export$2e2bcd8739ae039)(otherProps, {
                    aria: true,
                    data: true
                });
                var _ref2 = (0, $3b1032c8cfe29d42$export$2e2bcd8739ae039)(keyEntities, eventKey) || {}, level = _ref2.level;
                var isEndNode = isEnd[isEnd.length - 1];
                var mergedDraggable = this.isDraggable();
                var draggableWithoutDisabled = !disabled && mergedDraggable;
                var dragging = draggingNodeKey === eventKey;
                var ariaSelected = selectable !== undefined ? {
                    'aria-selected': !!selectable
                } : undefined;
                return /*#__PURE__*/ $6fFrj.createElement("div", (0, $fIrcP.default)({
                    ref: domRef,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(className, "".concat(prefixCls, "-treenode"), (_classNames = {}, (0, $43449.default)(_classNames, "".concat(prefixCls, "-treenode-disabled"), disabled), (0, $43449.default)(_classNames, "".concat(prefixCls, "-treenode-switcher-").concat(expanded ? 'open' : 'close'), !isLeaf), (0, $43449.default)(_classNames, "".concat(prefixCls, "-treenode-checkbox-checked"), checked), (0, $43449.default)(_classNames, "".concat(prefixCls, "-treenode-checkbox-indeterminate"), halfChecked), (0, $43449.default)(_classNames, "".concat(prefixCls, "-treenode-selected"), selected), (0, $43449.default)(_classNames, "".concat(prefixCls, "-treenode-loading"), loading), (0, $43449.default)(_classNames, "".concat(prefixCls, "-treenode-active"), active), (0, $43449.default)(_classNames, "".concat(prefixCls, "-treenode-leaf-last"), isEndNode), (0, $43449.default)(_classNames, "".concat(prefixCls, "-treenode-draggable"), mergedDraggable), (0, $43449.default)(_classNames, "dragging", dragging), (0, $43449.default)(_classNames, 'drop-target', dropTargetKey === eventKey), (0, $43449.default)(_classNames, 'drop-container', dropContainerKey === eventKey), (0, $43449.default)(_classNames, 'drag-over', !disabled && dragOver), (0, $43449.default)(_classNames, 'drag-over-gap-top', !disabled && dragOverGapTop), (0, $43449.default)(_classNames, 'drag-over-gap-bottom', !disabled && dragOverGapBottom), (0, $43449.default)(_classNames, 'filter-node', filterTreeNode && filterTreeNode((0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(this.props))), _classNames)),
                    style: style,
                    draggable: draggableWithoutDisabled,
                    "aria-grabbed": dragging,
                    onDragStart: draggableWithoutDisabled ? this.onDragStart : undefined,
                    onDragEnter: mergedDraggable ? this.onDragEnter : undefined,
                    onDragOver: mergedDraggable ? this.onDragOver : undefined,
                    onDragLeave: mergedDraggable ? this.onDragLeave : undefined,
                    onDrop: mergedDraggable ? this.onDrop : undefined,
                    onDragEnd: mergedDraggable ? this.onDragEnd : undefined,
                    onMouseMove: onMouseMove
                }, ariaSelected, dataOrAriaAttributeProps), /*#__PURE__*/ $6fFrj.createElement((0, $035e1563e1fb55fe$export$2e2bcd8739ae039), {
                    prefixCls: prefixCls,
                    level: level,
                    isStart: isStart,
                    isEnd: isEnd
                }), this.renderDragHandler(), this.renderSwitcher(), this.renderCheckbox(), this.renderSelector());
            }
        }
    ]);
    return InternalTreeNode;
}($6fFrj.Component);
var $c40e2bb393cde7f6$var$ContextTreeNode = function ContextTreeNode(props) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $73625c1f8b3860d0$export$dfae7d399eea2568).Consumer, null, function(context) {
        return /*#__PURE__*/ $6fFrj.createElement($c40e2bb393cde7f6$var$InternalTreeNode, (0, $fIrcP.default)({}, props, {
            context: context
        }));
    });
};
$c40e2bb393cde7f6$var$ContextTreeNode.displayName = 'TreeNode';
$c40e2bb393cde7f6$var$ContextTreeNode.isTreeNode = 1;
var $c40e2bb393cde7f6$export$2e2bcd8739ae039 = $c40e2bb393cde7f6$var$ContextTreeNode;



var $jP8CL = parcelRequire("jP8CL");

var $6fFrj = parcelRequire("6fFrj");
function $241a0f560f2f7b47$export$2e2bcd8739ae039(triggerStart, triggerEnd) {
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), firstMount = _React$useState2[0], setFirstMount = _React$useState2[1];
    $6fFrj.useLayoutEffect(function() {
        if (firstMount) {
            triggerStart();
            return function() {
                triggerEnd();
            };
        }
    }, [
        firstMount
    ]);
    $6fFrj.useLayoutEffect(function() {
        setFirstMount(true);
        return function() {
            setFirstMount(false);
        };
    }, []);
}



var $88b43ee9ae7be474$var$_excluded = [
    "className",
    "style",
    "motion",
    "motionNodes",
    "motionType",
    "onMotionStart",
    "onMotionEnd",
    "active",
    "treeNodeRequiredProps"
];
var $88b43ee9ae7be474$var$MotionTreeNode = function MotionTreeNode(_ref, ref) {
    var className = _ref.className, style = _ref.style, motion = _ref.motion, motionNodes = _ref.motionNodes, motionType = _ref.motionType, onOriginMotionStart = _ref.onMotionStart, onOriginMotionEnd = _ref.onMotionEnd, active = _ref.active, treeNodeRequiredProps = _ref.treeNodeRequiredProps, props = (0, $04RxA.default)(_ref, $88b43ee9ae7be474$var$_excluded);
    var _React$useState = $6fFrj.useState(true), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), visible = _React$useState2[0], setVisible = _React$useState2[1];
    var _React$useContext = $6fFrj.useContext((0, $73625c1f8b3860d0$export$dfae7d399eea2568)), prefixCls = _React$useContext.prefixCls;
    // Calculate target visible here.
    // And apply in effect to make `leave` motion work.
    var targetVisible = motionNodes && motionType !== 'hide';
    (0, $dNZA9.default)(function() {
        if (motionNodes) {
            if (targetVisible !== visible) setVisible(targetVisible);
        }
    }, [
        motionNodes
    ]);
    var triggerMotionStart = function triggerMotionStart() {
        if (motionNodes) onOriginMotionStart();
    };
    // Should only trigger once
    var triggerMotionEndRef = $6fFrj.useRef(false);
    var triggerMotionEnd = function triggerMotionEnd() {
        if (motionNodes && !triggerMotionEndRef.current) {
            triggerMotionEndRef.current = true;
            onOriginMotionEnd();
        }
    };
    // Effect if unmount
    (0, $241a0f560f2f7b47$export$2e2bcd8739ae039)(triggerMotionStart, triggerMotionEnd);
    // Motion end event
    var onVisibleChanged = function onVisibleChanged(nextVisible) {
        if (targetVisible === nextVisible) triggerMotionEnd();
    };
    if (motionNodes) return /*#__PURE__*/ $6fFrj.createElement((0, $5EVeC.default), (0, $fIrcP.default)({
        ref: ref,
        visible: visible
    }, motion, {
        motionAppear: motionType === 'show',
        onVisibleChanged: onVisibleChanged
    }), function(_ref2, motionRef) {
        var motionClassName = _ref2.className, motionStyle = _ref2.style;
        return /*#__PURE__*/ $6fFrj.createElement("div", {
            ref: motionRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-treenode-motion"), motionClassName),
            style: motionStyle
        }, motionNodes.map(function(treeNode) {
            var restProps = (0, $fIrcP.default)({}, ((0, $d9554b49ebbb9fba$export$2e2bcd8739ae039)(treeNode.data), treeNode.data)), title = treeNode.title, key = treeNode.key, isStart = treeNode.isStart, isEnd = treeNode.isEnd;
            delete restProps.children;
            var treeNodeProps = (0, $35a937288f4ed5dd$export$d961fd523a514db5)(key, treeNodeRequiredProps);
            return /*#__PURE__*/ $6fFrj.createElement((0, $c40e2bb393cde7f6$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, restProps, treeNodeProps, {
                title: title,
                active: active,
                data: treeNode.data,
                key: key,
                isStart: isStart,
                isEnd: isEnd
            }));
        }));
    });
    return /*#__PURE__*/ $6fFrj.createElement((0, $c40e2bb393cde7f6$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        domRef: ref,
        className: className,
        style: style
    }, props, {
        active: active
    }));
};
$88b43ee9ae7be474$var$MotionTreeNode.displayName = 'MotionTreeNode';
var $88b43ee9ae7be474$var$RefMotionTreeNode = /*#__PURE__*/ $6fFrj.forwardRef($88b43ee9ae7be474$var$MotionTreeNode);
var $88b43ee9ae7be474$export$2e2bcd8739ae039 = $88b43ee9ae7be474$var$RefMotionTreeNode;


function $c9db180a104e0dc1$export$d561f9b5d6be9236() {
    var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var prevLen = prev.length;
    var nextLen = next.length;
    if (Math.abs(prevLen - nextLen) !== 1) return {
        add: false,
        key: null
    };
    function find(shorter, longer) {
        var cache = new Map();
        shorter.forEach(function(key) {
            cache.set(key, true);
        });
        var keys = longer.filter(function(key) {
            return !cache.has(key);
        });
        return keys.length === 1 ? keys[0] : null;
    }
    if (prevLen < nextLen) return {
        add: true,
        key: find(prev, next)
    };
    return {
        add: false,
        key: find(next, prev)
    };
}
function $c9db180a104e0dc1$export$d9cfb1169163442d(shorter, longer, key) {
    var shorterStartIndex = shorter.findIndex(function(data) {
        return data.key === key;
    });
    var shorterEndNode = shorter[shorterStartIndex + 1];
    var longerStartIndex = longer.findIndex(function(data) {
        return data.key === key;
    });
    if (shorterEndNode) {
        var longerEndIndex = longer.findIndex(function(data) {
            return data.key === shorterEndNode.key;
        });
        return longer.slice(longerStartIndex + 1, longerEndIndex);
    }
    return longer.slice(longerStartIndex + 1);
}



var $ef9ab4c4404dc2cb$var$_excluded = [
    "prefixCls",
    "data",
    "selectable",
    "checkable",
    "expandedKeys",
    "selectedKeys",
    "checkedKeys",
    "loadedKeys",
    "loadingKeys",
    "halfCheckedKeys",
    "keyEntities",
    "disabled",
    "dragging",
    "dragOverNodeKey",
    "dropPosition",
    "motion",
    "height",
    "itemHeight",
    "virtual",
    "focusable",
    "activeItem",
    "focused",
    "tabIndex",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onActiveChange",
    "onListChangeStart",
    "onListChangeEnd"
];
var $ef9ab4c4404dc2cb$var$HIDDEN_STYLE = {
    width: 0,
    height: 0,
    display: 'flex',
    overflow: 'hidden',
    opacity: 0,
    border: 0,
    padding: 0,
    margin: 0
};
var $ef9ab4c4404dc2cb$var$noop = function noop() {};
var $ef9ab4c4404dc2cb$export$17c02cdd52a7d889 = "RC_TREE_MOTION_".concat(Math.random());
var $ef9ab4c4404dc2cb$var$MotionNode = {
    key: $ef9ab4c4404dc2cb$export$17c02cdd52a7d889
};
var $ef9ab4c4404dc2cb$export$2d18abad5109a402 = {
    key: $ef9ab4c4404dc2cb$export$17c02cdd52a7d889,
    level: 0,
    index: 0,
    pos: '0',
    node: $ef9ab4c4404dc2cb$var$MotionNode,
    nodes: [
        $ef9ab4c4404dc2cb$var$MotionNode
    ]
};
var $ef9ab4c4404dc2cb$var$MotionFlattenData = {
    parent: null,
    children: [],
    pos: $ef9ab4c4404dc2cb$export$2d18abad5109a402.pos,
    data: $ef9ab4c4404dc2cb$var$MotionNode,
    title: null,
    key: $ef9ab4c4404dc2cb$export$17c02cdd52a7d889,
    /** Hold empty list here since we do not use it */ isStart: [],
    isEnd: []
};
function $ef9ab4c4404dc2cb$export$435bacc8d7a01e14(list, virtual, height, itemHeight) {
    if (virtual === false || !height) return list;
    return list.slice(0, Math.ceil(height / itemHeight) + 1);
}
function $ef9ab4c4404dc2cb$var$itemKey(item) {
    var key = item.key, pos = item.pos;
    return (0, $35a937288f4ed5dd$export$a47fb462a08de82f)(key, pos);
}
function $ef9ab4c4404dc2cb$var$getAccessibilityPath(item) {
    var path = String(item.data.key);
    var current = item;
    while(current.parent){
        current = current.parent;
        path = "".concat(current.data.key, " > ").concat(path);
    }
    return path;
}
var $ef9ab4c4404dc2cb$var$NodeList = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, data = props.data, selectable = props.selectable, checkable = props.checkable, expandedKeys = props.expandedKeys, selectedKeys = props.selectedKeys, checkedKeys = props.checkedKeys, loadedKeys = props.loadedKeys, loadingKeys = props.loadingKeys, halfCheckedKeys = props.halfCheckedKeys, keyEntities = props.keyEntities, disabled = props.disabled, dragging = props.dragging, dragOverNodeKey = props.dragOverNodeKey, dropPosition = props.dropPosition, motion = props.motion, height = props.height, itemHeight = props.itemHeight, virtual = props.virtual, focusable = props.focusable, activeItem = props.activeItem, focused = props.focused, tabIndex = props.tabIndex, onKeyDown = props.onKeyDown, onFocus = props.onFocus, onBlur = props.onBlur, onActiveChange = props.onActiveChange, onListChangeStart = props.onListChangeStart, onListChangeEnd = props.onListChangeEnd, domProps = (0, $04RxA.default)(props, $ef9ab4c4404dc2cb$var$_excluded);
    // =============================== Ref ================================
    var listRef = $6fFrj.useRef(null);
    var indentMeasurerRef = $6fFrj.useRef(null);
    $6fFrj.useImperativeHandle(ref, function() {
        return {
            scrollTo: function scrollTo(scroll) {
                listRef.current.scrollTo(scroll);
            },
            getIndentWidth: function getIndentWidth() {
                return indentMeasurerRef.current.offsetWidth;
            }
        };
    });
    // ============================== Motion ==============================
    var _React$useState = $6fFrj.useState(expandedKeys), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), prevExpandedKeys = _React$useState2[0], setPrevExpandedKeys = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState(data), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), prevData = _React$useState4[0], setPrevData = _React$useState4[1];
    var _React$useState5 = $6fFrj.useState(data), _React$useState6 = (0, $jP8CL.default)(_React$useState5, 2), transitionData = _React$useState6[0], setTransitionData = _React$useState6[1];
    var _React$useState7 = $6fFrj.useState([]), _React$useState8 = (0, $jP8CL.default)(_React$useState7, 2), transitionRange = _React$useState8[0], setTransitionRange = _React$useState8[1];
    var _React$useState9 = $6fFrj.useState(null), _React$useState10 = (0, $jP8CL.default)(_React$useState9, 2), motionType = _React$useState10[0], setMotionType = _React$useState10[1];
    // When motion end but data change, this will makes data back to previous one
    var dataRef = $6fFrj.useRef(data);
    dataRef.current = data;
    function onMotionEnd() {
        var latestData = dataRef.current;
        setPrevData(latestData);
        setTransitionData(latestData);
        setTransitionRange([]);
        setMotionType(null);
        onListChangeEnd();
    }
    // Do animation if expanded keys changed
    // layoutEffect here to avoid blink of node removing
    (0, $dNZA9.default)(function() {
        setPrevExpandedKeys(expandedKeys);
        var diffExpanded = (0, $c9db180a104e0dc1$export$d561f9b5d6be9236)(prevExpandedKeys, expandedKeys);
        if (diffExpanded.key !== null) {
            if (diffExpanded.add) {
                var keyIndex = prevData.findIndex(function(_ref) {
                    var key = _ref.key;
                    return key === diffExpanded.key;
                });
                var rangeNodes = $ef9ab4c4404dc2cb$export$435bacc8d7a01e14((0, $c9db180a104e0dc1$export$d9cfb1169163442d)(prevData, data, diffExpanded.key), virtual, height, itemHeight);
                var newTransitionData = prevData.slice();
                newTransitionData.splice(keyIndex + 1, 0, $ef9ab4c4404dc2cb$var$MotionFlattenData);
                setTransitionData(newTransitionData);
                setTransitionRange(rangeNodes);
                setMotionType('show');
            } else {
                var _keyIndex = data.findIndex(function(_ref2) {
                    var key = _ref2.key;
                    return key === diffExpanded.key;
                });
                var _rangeNodes = $ef9ab4c4404dc2cb$export$435bacc8d7a01e14((0, $c9db180a104e0dc1$export$d9cfb1169163442d)(data, prevData, diffExpanded.key), virtual, height, itemHeight);
                var _newTransitionData = data.slice();
                _newTransitionData.splice(_keyIndex + 1, 0, $ef9ab4c4404dc2cb$var$MotionFlattenData);
                setTransitionData(_newTransitionData);
                setTransitionRange(_rangeNodes);
                setMotionType('hide');
            }
        } else if (prevData !== data) {
            // If whole data changed, we just refresh the list
            setPrevData(data);
            setTransitionData(data);
        }
    }, [
        expandedKeys,
        data
    ]);
    // We should clean up motion if is changed by dragging
    $6fFrj.useEffect(function() {
        if (!dragging) onMotionEnd();
    }, [
        dragging
    ]);
    var mergedData = motion ? transitionData : data;
    var treeNodeRequiredProps = {
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        loadedKeys: loadedKeys,
        loadingKeys: loadingKeys,
        checkedKeys: checkedKeys,
        halfCheckedKeys: halfCheckedKeys,
        dragOverNodeKey: dragOverNodeKey,
        dropPosition: dropPosition,
        keyEntities: keyEntities
    };
    return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, focused && activeItem && /*#__PURE__*/ $6fFrj.createElement("span", {
        style: $ef9ab4c4404dc2cb$var$HIDDEN_STYLE,
        "aria-live": "assertive"
    }, $ef9ab4c4404dc2cb$var$getAccessibilityPath(activeItem)), /*#__PURE__*/ $6fFrj.createElement("div", null, /*#__PURE__*/ $6fFrj.createElement("input", {
        style: $ef9ab4c4404dc2cb$var$HIDDEN_STYLE,
        disabled: focusable === false || disabled,
        tabIndex: focusable !== false ? tabIndex : null,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        value: "",
        onChange: $ef9ab4c4404dc2cb$var$noop,
        "aria-label": "for screen reader"
    })), /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-treenode"),
        "aria-hidden": true,
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            visibility: 'hidden',
            height: 0,
            overflow: 'hidden',
            border: 0,
            padding: 0
        }
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-indent")
    }, /*#__PURE__*/ $6fFrj.createElement("div", {
        ref: indentMeasurerRef,
        className: "".concat(prefixCls, "-indent-unit")
    }))), /*#__PURE__*/ $6fFrj.createElement((0, $13ab939f4939c91c$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, domProps, {
        data: mergedData,
        itemKey: $ef9ab4c4404dc2cb$var$itemKey,
        height: height,
        fullHeight: false,
        virtual: virtual,
        itemHeight: itemHeight,
        prefixCls: "".concat(prefixCls, "-list"),
        ref: listRef,
        onVisibleChange: function onVisibleChange(originList, fullList) {
            var originSet = new Set(originList);
            var restList = fullList.filter(function(item) {
                return !originSet.has(item);
            });
            // Motion node is not render. Skip motion
            if (restList.some(function(item) {
                return $ef9ab4c4404dc2cb$var$itemKey(item) === $ef9ab4c4404dc2cb$export$17c02cdd52a7d889;
            })) onMotionEnd();
        }
    }), function(treeNode) {
        var pos = treeNode.pos, restProps = (0, $fIrcP.default)({}, ((0, $d9554b49ebbb9fba$export$2e2bcd8739ae039)(treeNode.data), treeNode.data)), title = treeNode.title, key = treeNode.key, isStart = treeNode.isStart, isEnd = treeNode.isEnd;
        var mergedKey = (0, $35a937288f4ed5dd$export$a47fb462a08de82f)(key, pos);
        delete restProps.key;
        delete restProps.children;
        var treeNodeProps = (0, $35a937288f4ed5dd$export$d961fd523a514db5)(mergedKey, treeNodeRequiredProps);
        return /*#__PURE__*/ $6fFrj.createElement((0, $88b43ee9ae7be474$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, restProps, treeNodeProps, {
            title: title,
            active: !!activeItem && key === activeItem.key,
            pos: pos,
            data: treeNode.data,
            isStart: isStart,
            isEnd: isEnd,
            motion: motion,
            motionNodes: key === $ef9ab4c4404dc2cb$export$17c02cdd52a7d889 ? transitionRange : null,
            motionType: motionType,
            onMotionStart: onListChangeStart,
            onMotionEnd: onMotionEnd,
            treeNodeRequiredProps: treeNodeRequiredProps,
            onMouseMove: function onMouseMove() {
                onActiveChange(null);
            }
        }));
    }));
});
$ef9ab4c4404dc2cb$var$NodeList.displayName = 'NodeList';
var $ef9ab4c4404dc2cb$export$2e2bcd8739ae039 = $ef9ab4c4404dc2cb$var$NodeList;




var $37xND = parcelRequire("37xND");

var $5KhTJ = parcelRequire("5KhTJ");

var $fIrcP = parcelRequire("fIrcP");

var $04RxA = parcelRequire("04RxA");

var $3mXQ2 = parcelRequire("3mXQ2");

var $6fFrj = parcelRequire("6fFrj");



var $aa69ce1278dbe319$var$_excluded = [
    "children"
];
function $aa69ce1278dbe319$export$5bfb9ff497fe2298(list, value) {
    if (!list) return [];
    var clone = list.slice();
    var index = clone.indexOf(value);
    if (index >= 0) clone.splice(index, 1);
    return clone;
}
function $aa69ce1278dbe319$export$10663f6bbd2fd717(list, value) {
    var clone = (list || []).slice();
    if (clone.indexOf(value) === -1) clone.push(value);
    return clone;
}
function $aa69ce1278dbe319$export$ddaee97dc8907312(pos) {
    return pos.split('-');
}
function $aa69ce1278dbe319$export$b0610c44bcbb051c(dragNodeKey, keyEntities) {
    // not contains self
    // self for left or right drag
    var dragChildrenKeys = [];
    var entity = (0, $3b1032c8cfe29d42$export$2e2bcd8739ae039)(keyEntities, dragNodeKey);
    function dig() {
        var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        list.forEach(function(_ref) {
            var key = _ref.key, children = _ref.children;
            dragChildrenKeys.push(key);
            dig(children);
        });
    }
    dig(entity.children);
    return dragChildrenKeys;
}
function $aa69ce1278dbe319$export$a9933931a4af6704(treeNodeEntity) {
    if (treeNodeEntity.parent) {
        var posArr = $aa69ce1278dbe319$export$ddaee97dc8907312(treeNodeEntity.pos);
        return Number(posArr[posArr.length - 1]) === treeNodeEntity.parent.children.length - 1;
    }
    return false;
}
function $aa69ce1278dbe319$export$b823688e4155eb8d(treeNodeEntity) {
    var posArr = $aa69ce1278dbe319$export$ddaee97dc8907312(treeNodeEntity.pos);
    return Number(posArr[posArr.length - 1]) === 0;
}
function $aa69ce1278dbe319$export$78a5519d0fb779c3(event, dragNode, targetNode, indent, startMousePosition, allowDrop, flattenedNodes, keyEntities, expandKeys, direction) {
    var _abstractDropNodeEnti;
    var clientX = event.clientX, clientY = event.clientY;
    var _event$target$getBoun = event.target.getBoundingClientRect(), top = _event$target$getBoun.top, height = _event$target$getBoun.height;
    // optional chain for testing
    var horizontalMouseOffset = (direction === 'rtl' ? -1 : 1) * (((startMousePosition === null || startMousePosition === void 0 ? void 0 : startMousePosition.x) || 0) - clientX);
    var rawDropLevelOffset = (horizontalMouseOffset - 12) / indent;
    // find abstract drop node by horizontal offset
    var abstractDropNodeEntity = (0, $3b1032c8cfe29d42$export$2e2bcd8739ae039)(keyEntities, targetNode.props.eventKey);
    if (clientY < top + height / 2) {
        // first half, set abstract drop node to previous node
        var nodeIndex = flattenedNodes.findIndex(function(flattenedNode) {
            return flattenedNode.key === abstractDropNodeEntity.key;
        });
        var prevNodeIndex = nodeIndex <= 0 ? 0 : nodeIndex - 1;
        var prevNodeKey = flattenedNodes[prevNodeIndex].key;
        abstractDropNodeEntity = (0, $3b1032c8cfe29d42$export$2e2bcd8739ae039)(keyEntities, prevNodeKey);
    }
    var initialAbstractDropNodeKey = abstractDropNodeEntity.key;
    var abstractDragOverEntity = abstractDropNodeEntity;
    var dragOverNodeKey = abstractDropNodeEntity.key;
    var dropPosition = 0;
    var dropLevelOffset = 0;
    // Only allow cross level drop when dragging on a non-expanded node
    if (!expandKeys.includes(initialAbstractDropNodeKey)) for(var i = 0; i < rawDropLevelOffset; i += 1){
        if ($aa69ce1278dbe319$export$a9933931a4af6704(abstractDropNodeEntity)) {
            abstractDropNodeEntity = abstractDropNodeEntity.parent;
            dropLevelOffset += 1;
        } else break;
    }
    var abstractDragDataNode = dragNode.props.data;
    var abstractDropDataNode = abstractDropNodeEntity.node;
    var dropAllowed = true;
    if ($aa69ce1278dbe319$export$b823688e4155eb8d(abstractDropNodeEntity) && abstractDropNodeEntity.level === 0 && clientY < top + height / 2 && allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: -1
    }) && abstractDropNodeEntity.key === targetNode.props.eventKey) // first half of first node in first level
    dropPosition = -1;
    else if ((abstractDragOverEntity.children || []).length && expandKeys.includes(dragOverNodeKey)) {
        // drop on expanded node
        // only allow drop inside
        if (allowDrop({
            dragNode: abstractDragDataNode,
            dropNode: abstractDropDataNode,
            dropPosition: 0
        })) dropPosition = 0;
        else dropAllowed = false;
    } else if (dropLevelOffset === 0) {
        if (rawDropLevelOffset > -1.5) {
            // | Node     | <- abstractDropNode
            // | -^-===== | <- mousePosition
            // 1. try drop after
            // 2. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        } else {
            // | Node     | <- abstractDropNode
            // | ---==^== | <- mousePosition
            // whether it has children or doesn't has children
            // always
            // 1. try drop inside
            // 2. try drop after
            // 3. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 0
            })) dropPosition = 0;
            else if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        }
    } else // | Node1 | <- abstractDropNode
    //      |  Node2  |
    // --^--|----=====| <- mousePosition
    // 1. try insert after Node1
    // 2. do not allow drop
    if (allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 1
    })) dropPosition = 1;
    else dropAllowed = false;
    return {
        dropPosition: dropPosition,
        dropLevelOffset: dropLevelOffset,
        dropTargetKey: abstractDropNodeEntity.key,
        dropTargetPos: abstractDropNodeEntity.pos,
        dragOverNodeKey: dragOverNodeKey,
        dropContainerKey: dropPosition === 0 ? null : ((_abstractDropNodeEnti = abstractDropNodeEntity.parent) === null || _abstractDropNodeEnti === void 0 ? void 0 : _abstractDropNodeEnti.key) || null,
        dropAllowed: dropAllowed
    };
}
function $aa69ce1278dbe319$export$fffc10811828fd68(selectedKeys, props) {
    if (!selectedKeys) return undefined;
    var multiple = props.multiple;
    if (multiple) return selectedKeys.slice();
    if (selectedKeys.length) return [
        selectedKeys[0]
    ];
    return selectedKeys;
}
var $aa69ce1278dbe319$var$internalProcessProps = function internalProcessProps(props) {
    return props;
};
function $aa69ce1278dbe319$export$b28621e8354d6749(treeData, processor) {
    if (!treeData) return [];
    var _ref2 = processor || {}, _ref2$processProps = _ref2.processProps, processProps = _ref2$processProps === void 0 ? $aa69ce1278dbe319$var$internalProcessProps : _ref2$processProps;
    var list = Array.isArray(treeData) ? treeData : [
        treeData
    ];
    return list.map(function(_ref3) {
        var children = _ref3.children, props = (0, $04RxA.default)(_ref3, $aa69ce1278dbe319$var$_excluded);
        var childrenNodes = $aa69ce1278dbe319$export$b28621e8354d6749(children, processor);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $c40e2bb393cde7f6$export$2e2bcd8739ae039), (0, $fIrcP.default)({
            key: props.key
        }, processProps(props)), childrenNodes);
    });
}
function $aa69ce1278dbe319$export$29d4989c23990d41(keys) {
    if (!keys) return null;
    // Convert keys to object format
    var keyProps;
    if (Array.isArray(keys)) // [Legacy] Follow the api doc
    keyProps = {
        checkedKeys: keys,
        halfCheckedKeys: undefined
    };
    else if ((0, $5KhTJ.default)(keys) === 'object') keyProps = {
        checkedKeys: keys.checked || undefined,
        halfCheckedKeys: keys.halfChecked || undefined
    };
    else {
        (0, $3mXQ2.default)(false, '`checkedKeys` is not an array or an object');
        return null;
    }
    return keyProps;
}
function $aa69ce1278dbe319$export$fac4a40c345ccd80(keyList, keyEntities) {
    var expandedKeys = new Set();
    function conductUp(key) {
        if (expandedKeys.has(key)) return;
        var entity = (0, $3b1032c8cfe29d42$export$2e2bcd8739ae039)(keyEntities, key);
        if (!entity) return;
        expandedKeys.add(key);
        var parent = entity.parent, node = entity.node;
        if (node.disabled) return;
        if (parent) conductUp(parent.key);
    }
    (keyList || []).forEach(function(key) {
        conductUp(key);
    });
    return (0, $37xND.default)(expandedKeys);
}



var $3mXQ2 = parcelRequire("3mXQ2");

function $d68df472f315bb8e$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys) {
    var filteredKeys = new Set();
    halfCheckedKeys.forEach(function(key) {
        if (!checkedKeys.has(key)) filteredKeys.add(key);
    });
    return filteredKeys;
}
function $d68df472f315bb8e$export$ab01c86170b1dea0(node) {
    var _ref = node || {}, disabled = _ref.disabled, disableCheckbox = _ref.disableCheckbox, checkable = _ref.checkable;
    return !!(disabled || disableCheckbox) || checkable === false;
}
// Fill miss keys
function $d68df472f315bb8e$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    var checkedKeys = new Set(keys);
    var halfCheckedKeys = new Set();
    // Add checked keys top to bottom
    for(var level = 0; level <= maxLevel; level += 1){
        var entities = levelEntities.get(level) || new Set();
        entities.forEach(function(entity) {
            var key = entity.key, node = entity.node, _entity$children = entity.children, children = _entity$children === void 0 ? [] : _entity$children;
            if (checkedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(childEntity) {
                checkedKeys.add(childEntity.key);
            });
        });
    }
    // Add checked keys from bottom to top
    var visitedKeys = new Set();
    for(var _level = maxLevel; _level >= 0; _level -= 1){
        var _entities = levelEntities.get(_level) || new Set();
        _entities.forEach(function(entity) {
            var parent = entity.parent, node = entity.node;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            var allChecked = true;
            var partialChecked = false;
            (parent.children || []).filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(_ref2) {
                var key = _ref2.key;
                var checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (allChecked) checkedKeys.add(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($d68df472f315bb8e$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
// Remove useless key
function $d68df472f315bb8e$var$cleanConductCheck(keys, halfKeys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    var checkedKeys = new Set(keys);
    var halfCheckedKeys = new Set(halfKeys);
    // Remove checked keys from top to bottom
    for(var level = 0; level <= maxLevel; level += 1){
        var entities = levelEntities.get(level) || new Set();
        entities.forEach(function(entity) {
            var key = entity.key, node = entity.node, _entity$children2 = entity.children, children = _entity$children2 === void 0 ? [] : _entity$children2;
            if (!checkedKeys.has(key) && !halfCheckedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(childEntity) {
                checkedKeys.delete(childEntity.key);
            });
        });
    }
    // Remove checked keys form bottom to top
    halfCheckedKeys = new Set();
    var visitedKeys = new Set();
    for(var _level2 = maxLevel; _level2 >= 0; _level2 -= 1){
        var _entities2 = levelEntities.get(_level2) || new Set();
        _entities2.forEach(function(entity) {
            var parent = entity.parent, node = entity.node;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            var allChecked = true;
            var partialChecked = false;
            (parent.children || []).filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(_ref3) {
                var key = _ref3.key;
                var checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (!allChecked) checkedKeys.delete(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($d68df472f315bb8e$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
function $d68df472f315bb8e$export$43adf2c483e3e633(keyList, checked, keyEntities, getCheckDisabled) {
    var warningMissKeys = [];
    var syntheticGetCheckDisabled;
    if (getCheckDisabled) syntheticGetCheckDisabled = getCheckDisabled;
    else syntheticGetCheckDisabled = $d68df472f315bb8e$export$ab01c86170b1dea0;
    // We only handle exist keys
    var keys = new Set(keyList.filter(function(key) {
        var hasEntity = !!(0, $3b1032c8cfe29d42$export$2e2bcd8739ae039)(keyEntities, key);
        if (!hasEntity) warningMissKeys.push(key);
        return hasEntity;
    }));
    var levelEntities = new Map();
    var maxLevel = 0;
    // Convert entities by level for calculation
    Object.keys(keyEntities).forEach(function(key) {
        var entity = keyEntities[key];
        var level = entity.level;
        var levelSet = levelEntities.get(level);
        if (!levelSet) {
            levelSet = new Set();
            levelEntities.set(level, levelSet);
        }
        levelSet.add(entity);
        maxLevel = Math.max(maxLevel, level);
    });
    (0, $3mXQ2.default)(!warningMissKeys.length, "Tree missing follow keys: ".concat(warningMissKeys.slice(0, 100).map(function(key) {
        return "'".concat(key, "'");
    }).join(', ')));
    var result;
    if (checked === true) result = $d68df472f315bb8e$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    else result = $d68df472f315bb8e$var$cleanConductCheck(keys, checked.halfCheckedKeys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    return result;
}




var $a5e30f887ded552c$var$MAX_RETRY_TIMES = 10;
var $a5e30f887ded552c$var$Tree = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(Tree, _React$Component);
    var _super = (0, $lSufv.default)(Tree);
    function Tree() {
        var _this;
        (0, $kjNeN.default)(this, Tree);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(_args));
        _this.destroyed = false;
        _this.delayedDragEnterLogic = void 0;
        _this.loadingRetryTimes = {};
        _this.state = {
            keyEntities: {},
            indent: null,
            selectedKeys: [],
            checkedKeys: [],
            halfCheckedKeys: [],
            loadedKeys: [],
            loadingKeys: [],
            expandedKeys: [],
            draggingNodeKey: null,
            dragChildrenKeys: [],
            // dropTargetKey is the key of abstract-drop-node
            // the abstract-drop-node is the real drop node when drag and drop
            // not the DOM drag over node
            dropTargetKey: null,
            dropPosition: null,
            dropContainerKey: null,
            dropLevelOffset: null,
            dropTargetPos: null,
            dropAllowed: true,
            // the abstract-drag-over-node
            // if mouse is on the bottom of top dom node or no the top of the bottom dom node
            // abstract-drag-over-node is the top node
            dragOverNodeKey: null,
            treeData: [],
            flattenNodes: [],
            focused: false,
            activeKey: null,
            listChanging: false,
            prevProps: null,
            fieldNames: (0, $35a937288f4ed5dd$export$6c519d302dced239)()
        };
        _this.dragStartMousePosition = null;
        _this.dragNode = void 0;
        _this.currentMouseOverDroppableNodeKey = null;
        _this.listRef = /*#__PURE__*/ $6fFrj.createRef();
        _this.onNodeDragStart = function(event, node) {
            var _this$state = _this.state, expandedKeys = _this$state.expandedKeys, keyEntities = _this$state.keyEntities;
            var onDragStart = _this.props.onDragStart;
            var eventKey = node.props.eventKey;
            _this.dragNode = node;
            _this.dragStartMousePosition = {
                x: event.clientX,
                y: event.clientY
            };
            var newExpandedKeys = (0, $aa69ce1278dbe319$export$5bfb9ff497fe2298)(expandedKeys, eventKey);
            _this.setState({
                draggingNodeKey: eventKey,
                dragChildrenKeys: (0, $aa69ce1278dbe319$export$b0610c44bcbb051c)(eventKey, keyEntities),
                indent: _this.listRef.current.getIndentWidth()
            });
            _this.setExpandedKeys(newExpandedKeys);
            window.addEventListener('dragend', _this.onWindowDragEnd);
            onDragStart === null || onDragStart === void 0 || onDragStart({
                event: event,
                node: (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(node.props)
            });
        };
        /**
     * [Legacy] Select handler is smaller than node,
     * so that this will trigger when drag enter node or select handler.
     * This is a little tricky if customize css without padding.
     * Better for use mouse move event to refresh drag state.
     * But let's just keep it to avoid event trigger logic change.
     */ _this.onNodeDragEnter = function(event, node) {
            var _this$state2 = _this.state, expandedKeys = _this$state2.expandedKeys, keyEntities = _this$state2.keyEntities, dragChildrenKeys = _this$state2.dragChildrenKeys, flattenNodes = _this$state2.flattenNodes, indent = _this$state2.indent;
            var _this$props = _this.props, onDragEnter = _this$props.onDragEnter, onExpand = _this$props.onExpand, allowDrop = _this$props.allowDrop, direction = _this$props.direction;
            var _node$props = node.props, pos = _node$props.pos, eventKey = _node$props.eventKey;
            var _assertThisInitialize = (0, $3mZgl.default)(_this), dragNode = _assertThisInitialize.dragNode;
            // record the key of node which is latest entered, used in dragleave event.
            if (_this.currentMouseOverDroppableNodeKey !== eventKey) _this.currentMouseOverDroppableNodeKey = eventKey;
            if (!dragNode) {
                _this.resetDragState();
                return;
            }
            var _calcDropPosition = (0, $aa69ce1278dbe319$export$78a5519d0fb779c3)(event, dragNode, node, indent, _this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction), dropPosition = _calcDropPosition.dropPosition, dropLevelOffset = _calcDropPosition.dropLevelOffset, dropTargetKey = _calcDropPosition.dropTargetKey, dropContainerKey = _calcDropPosition.dropContainerKey, dropTargetPos = _calcDropPosition.dropTargetPos, dropAllowed = _calcDropPosition.dropAllowed, dragOverNodeKey = _calcDropPosition.dragOverNodeKey;
            if (// don't allow drop inside its children
            dragChildrenKeys.indexOf(dropTargetKey) !== -1 || // don't allow drop when drop is not allowed caculated by calcDropPosition
            !dropAllowed) {
                _this.resetDragState();
                return;
            }
            // Side effect for delay drag
            if (!_this.delayedDragEnterLogic) _this.delayedDragEnterLogic = {};
            Object.keys(_this.delayedDragEnterLogic).forEach(function(key) {
                clearTimeout(_this.delayedDragEnterLogic[key]);
            });
            if (dragNode.props.eventKey !== node.props.eventKey) {
                // hoist expand logic here
                // since if logic is on the bottom
                // it will be blocked by abstract dragover node check
                //   => if you dragenter from top, you mouse will still be consider as in the top node
                event.persist();
                _this.delayedDragEnterLogic[pos] = window.setTimeout(function() {
                    if (_this.state.draggingNodeKey === null) return;
                    var newExpandedKeys = (0, $37xND.default)(expandedKeys);
                    var entity = (0, $3b1032c8cfe29d42$export$2e2bcd8739ae039)(keyEntities, node.props.eventKey);
                    if (entity && (entity.children || []).length) newExpandedKeys = (0, $aa69ce1278dbe319$export$10663f6bbd2fd717)(expandedKeys, node.props.eventKey);
                    if (!('expandedKeys' in _this.props)) _this.setExpandedKeys(newExpandedKeys);
                    onExpand === null || onExpand === void 0 || onExpand(newExpandedKeys, {
                        node: (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(node.props),
                        expanded: true,
                        nativeEvent: event.nativeEvent
                    });
                }, 800);
            }
            // Skip if drag node is self
            if (dragNode.props.eventKey === dropTargetKey && dropLevelOffset === 0) {
                _this.resetDragState();
                return;
            }
            // Update drag over node and drag state
            _this.setState({
                dragOverNodeKey: dragOverNodeKey,
                dropPosition: dropPosition,
                dropLevelOffset: dropLevelOffset,
                dropTargetKey: dropTargetKey,
                dropContainerKey: dropContainerKey,
                dropTargetPos: dropTargetPos,
                dropAllowed: dropAllowed
            });
            onDragEnter === null || onDragEnter === void 0 || onDragEnter({
                event: event,
                node: (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(node.props),
                expandedKeys: expandedKeys
            });
        };
        _this.onNodeDragOver = function(event, node) {
            var _this$state3 = _this.state, dragChildrenKeys = _this$state3.dragChildrenKeys, flattenNodes = _this$state3.flattenNodes, keyEntities = _this$state3.keyEntities, expandedKeys = _this$state3.expandedKeys, indent = _this$state3.indent;
            var _this$props2 = _this.props, onDragOver = _this$props2.onDragOver, allowDrop = _this$props2.allowDrop, direction = _this$props2.direction;
            var _assertThisInitialize2 = (0, $3mZgl.default)(_this), dragNode = _assertThisInitialize2.dragNode;
            if (!dragNode) return;
            var _calcDropPosition2 = (0, $aa69ce1278dbe319$export$78a5519d0fb779c3)(event, dragNode, node, indent, _this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction), dropPosition = _calcDropPosition2.dropPosition, dropLevelOffset = _calcDropPosition2.dropLevelOffset, dropTargetKey = _calcDropPosition2.dropTargetKey, dropContainerKey = _calcDropPosition2.dropContainerKey, dropAllowed = _calcDropPosition2.dropAllowed, dropTargetPos = _calcDropPosition2.dropTargetPos, dragOverNodeKey = _calcDropPosition2.dragOverNodeKey;
            if (dragChildrenKeys.indexOf(dropTargetKey) !== -1 || !dropAllowed) // don't allow drop inside its children
            // don't allow drop when drop is not allowed caculated by calcDropPosition
            return;
            // Update drag position
            if (dragNode.props.eventKey === dropTargetKey && dropLevelOffset === 0) {
                if (!(_this.state.dropPosition === null && _this.state.dropLevelOffset === null && _this.state.dropTargetKey === null && _this.state.dropContainerKey === null && _this.state.dropTargetPos === null && _this.state.dropAllowed === false && _this.state.dragOverNodeKey === null)) _this.resetDragState();
            } else if (!(dropPosition === _this.state.dropPosition && dropLevelOffset === _this.state.dropLevelOffset && dropTargetKey === _this.state.dropTargetKey && dropContainerKey === _this.state.dropContainerKey && dropTargetPos === _this.state.dropTargetPos && dropAllowed === _this.state.dropAllowed && dragOverNodeKey === _this.state.dragOverNodeKey)) _this.setState({
                dropPosition: dropPosition,
                dropLevelOffset: dropLevelOffset,
                dropTargetKey: dropTargetKey,
                dropContainerKey: dropContainerKey,
                dropTargetPos: dropTargetPos,
                dropAllowed: dropAllowed,
                dragOverNodeKey: dragOverNodeKey
            });
            onDragOver === null || onDragOver === void 0 || onDragOver({
                event: event,
                node: (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(node.props)
            });
        };
        _this.onNodeDragLeave = function(event, node) {
            // if it is outside the droppable area
            // currentMouseOverDroppableNodeKey will be updated in dragenter event when into another droppable receiver.
            if (_this.currentMouseOverDroppableNodeKey === node.props.eventKey && !event.currentTarget.contains(event.relatedTarget)) {
                _this.resetDragState();
                _this.currentMouseOverDroppableNodeKey = null;
            }
            var onDragLeave = _this.props.onDragLeave;
            onDragLeave === null || onDragLeave === void 0 || onDragLeave({
                event: event,
                node: (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(node.props)
            });
        };
        // since stopPropagation() is called in treeNode
        // if onWindowDrag is called, whice means state is keeped, drag state should be cleared
        _this.onWindowDragEnd = function(event) {
            _this.onNodeDragEnd(event, null, true);
            window.removeEventListener('dragend', _this.onWindowDragEnd);
        };
        // if onNodeDragEnd is called, onWindowDragEnd won't be called since stopPropagation() is called
        _this.onNodeDragEnd = function(event, node) {
            var onDragEnd = _this.props.onDragEnd;
            _this.setState({
                dragOverNodeKey: null
            });
            _this.cleanDragState();
            onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                event: event,
                node: (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(node.props)
            });
            _this.dragNode = null;
            window.removeEventListener('dragend', _this.onWindowDragEnd);
        };
        _this.onNodeDrop = function(event, node) {
            var _this$getActiveItem;
            var outsideTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var _this$state4 = _this.state, dragChildrenKeys = _this$state4.dragChildrenKeys, dropPosition = _this$state4.dropPosition, dropTargetKey = _this$state4.dropTargetKey, dropTargetPos = _this$state4.dropTargetPos, dropAllowed = _this$state4.dropAllowed;
            if (!dropAllowed) return;
            var onDrop = _this.props.onDrop;
            _this.setState({
                dragOverNodeKey: null
            });
            _this.cleanDragState();
            if (dropTargetKey === null) return;
            var abstractDropNodeProps = (0, $kNxFX.default)((0, $kNxFX.default)({}, (0, $35a937288f4ed5dd$export$d961fd523a514db5)(dropTargetKey, _this.getTreeNodeRequiredProps())), {}, {
                active: ((_this$getActiveItem = _this.getActiveItem()) === null || _this$getActiveItem === void 0 ? void 0 : _this$getActiveItem.key) === dropTargetKey,
                data: (0, $3b1032c8cfe29d42$export$2e2bcd8739ae039)(_this.state.keyEntities, dropTargetKey).node
            });
            var dropToChild = dragChildrenKeys.indexOf(dropTargetKey) !== -1;
            (0, $3mXQ2.default)(!dropToChild, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
            var posArr = (0, $aa69ce1278dbe319$export$ddaee97dc8907312)(dropTargetPos);
            var dropResult = {
                event: event,
                node: (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(abstractDropNodeProps),
                dragNode: _this.dragNode ? (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)(_this.dragNode.props) : null,
                dragNodesKeys: [
                    _this.dragNode.props.eventKey
                ].concat(dragChildrenKeys),
                dropToGap: dropPosition !== 0,
                dropPosition: dropPosition + Number(posArr[posArr.length - 1])
            };
            if (!outsideTree) onDrop === null || onDrop === void 0 || onDrop(dropResult);
            _this.dragNode = null;
        };
        _this.cleanDragState = function() {
            var draggingNodeKey = _this.state.draggingNodeKey;
            if (draggingNodeKey !== null) _this.setState({
                draggingNodeKey: null,
                dropPosition: null,
                dropContainerKey: null,
                dropTargetKey: null,
                dropLevelOffset: null,
                dropAllowed: true,
                dragOverNodeKey: null
            });
            _this.dragStartMousePosition = null;
            _this.currentMouseOverDroppableNodeKey = null;
        };
        _this.triggerExpandActionExpand = function(e, treeNode) {
            var _this$state5 = _this.state, expandedKeys = _this$state5.expandedKeys, flattenNodes = _this$state5.flattenNodes;
            var expanded = treeNode.expanded, key = treeNode.key, isLeaf = treeNode.isLeaf;
            if (isLeaf || e.shiftKey || e.metaKey || e.ctrlKey) return;
            var node = flattenNodes.filter(function(nodeItem) {
                return nodeItem.key === key;
            })[0];
            var eventNode = (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)((0, $kNxFX.default)((0, $kNxFX.default)({}, (0, $35a937288f4ed5dd$export$d961fd523a514db5)(key, _this.getTreeNodeRequiredProps())), {}, {
                data: node.data
            }));
            _this.setExpandedKeys(expanded ? (0, $aa69ce1278dbe319$export$5bfb9ff497fe2298)(expandedKeys, key) : (0, $aa69ce1278dbe319$export$10663f6bbd2fd717)(expandedKeys, key));
            _this.onNodeExpand(e, eventNode);
        };
        _this.onNodeClick = function(e, treeNode) {
            var _this$props3 = _this.props, onClick = _this$props3.onClick, expandAction = _this$props3.expandAction;
            if (expandAction === 'click') _this.triggerExpandActionExpand(e, treeNode);
            onClick === null || onClick === void 0 || onClick(e, treeNode);
        };
        _this.onNodeDoubleClick = function(e, treeNode) {
            var _this$props4 = _this.props, onDoubleClick = _this$props4.onDoubleClick, expandAction = _this$props4.expandAction;
            if (expandAction === 'doubleClick') _this.triggerExpandActionExpand(e, treeNode);
            onDoubleClick === null || onDoubleClick === void 0 || onDoubleClick(e, treeNode);
        };
        _this.onNodeSelect = function(e, treeNode) {
            var selectedKeys = _this.state.selectedKeys;
            var _this$state6 = _this.state, keyEntities = _this$state6.keyEntities, fieldNames = _this$state6.fieldNames;
            var _this$props5 = _this.props, onSelect = _this$props5.onSelect, multiple = _this$props5.multiple;
            var selected = treeNode.selected;
            var key = treeNode[fieldNames.key];
            var targetSelected = !selected;
            // Update selected keys
            if (!targetSelected) selectedKeys = (0, $aa69ce1278dbe319$export$5bfb9ff497fe2298)(selectedKeys, key);
            else if (!multiple) selectedKeys = [
                key
            ];
            else selectedKeys = (0, $aa69ce1278dbe319$export$10663f6bbd2fd717)(selectedKeys, key);
            // [Legacy] Not found related usage in doc or upper libs
            var selectedNodes = selectedKeys.map(function(selectedKey) {
                var entity = (0, $3b1032c8cfe29d42$export$2e2bcd8739ae039)(keyEntities, selectedKey);
                if (!entity) return null;
                return entity.node;
            }).filter(function(node) {
                return node;
            });
            _this.setUncontrolledState({
                selectedKeys: selectedKeys
            });
            onSelect === null || onSelect === void 0 || onSelect(selectedKeys, {
                event: 'select',
                selected: targetSelected,
                node: treeNode,
                selectedNodes: selectedNodes,
                nativeEvent: e.nativeEvent
            });
        };
        _this.onNodeCheck = function(e, treeNode, checked) {
            var _this$state7 = _this.state, keyEntities = _this$state7.keyEntities, oriCheckedKeys = _this$state7.checkedKeys, oriHalfCheckedKeys = _this$state7.halfCheckedKeys;
            var _this$props6 = _this.props, checkStrictly = _this$props6.checkStrictly, onCheck = _this$props6.onCheck;
            var key = treeNode.key;
            // Prepare trigger arguments
            var checkedObj;
            var eventObj = {
                event: 'check',
                node: treeNode,
                checked: checked,
                nativeEvent: e.nativeEvent
            };
            if (checkStrictly) {
                var checkedKeys = checked ? (0, $aa69ce1278dbe319$export$10663f6bbd2fd717)(oriCheckedKeys, key) : (0, $aa69ce1278dbe319$export$5bfb9ff497fe2298)(oriCheckedKeys, key);
                var halfCheckedKeys = (0, $aa69ce1278dbe319$export$5bfb9ff497fe2298)(oriHalfCheckedKeys, key);
                checkedObj = {
                    checked: checkedKeys,
                    halfChecked: halfCheckedKeys
                };
                eventObj.checkedNodes = checkedKeys.map(function(checkedKey) {
                    return (0, $3b1032c8cfe29d42$export$2e2bcd8739ae039)(keyEntities, checkedKey);
                }).filter(function(entity) {
                    return entity;
                }).map(function(entity) {
                    return entity.node;
                });
                _this.setUncontrolledState({
                    checkedKeys: checkedKeys
                });
            } else {
                // Always fill first
                var _conductCheck = (0, $d68df472f315bb8e$export$43adf2c483e3e633)([].concat((0, $37xND.default)(oriCheckedKeys), [
                    key
                ]), true, keyEntities), _checkedKeys = _conductCheck.checkedKeys, _halfCheckedKeys = _conductCheck.halfCheckedKeys;
                // If remove, we do it again to correction
                if (!checked) {
                    var keySet = new Set(_checkedKeys);
                    keySet.delete(key);
                    var _conductCheck2 = (0, $d68df472f315bb8e$export$43adf2c483e3e633)(Array.from(keySet), {
                        checked: false,
                        halfCheckedKeys: _halfCheckedKeys
                    }, keyEntities);
                    _checkedKeys = _conductCheck2.checkedKeys;
                    _halfCheckedKeys = _conductCheck2.halfCheckedKeys;
                }
                checkedObj = _checkedKeys;
                // [Legacy] This is used for `rc-tree-select`
                eventObj.checkedNodes = [];
                eventObj.checkedNodesPositions = [];
                eventObj.halfCheckedKeys = _halfCheckedKeys;
                _checkedKeys.forEach(function(checkedKey) {
                    var entity = (0, $3b1032c8cfe29d42$export$2e2bcd8739ae039)(keyEntities, checkedKey);
                    if (!entity) return;
                    var node = entity.node, pos = entity.pos;
                    eventObj.checkedNodes.push(node);
                    eventObj.checkedNodesPositions.push({
                        node: node,
                        pos: pos
                    });
                });
                _this.setUncontrolledState({
                    checkedKeys: _checkedKeys
                }, false, {
                    halfCheckedKeys: _halfCheckedKeys
                });
            }
            onCheck === null || onCheck === void 0 || onCheck(checkedObj, eventObj);
        };
        _this.onNodeLoad = function(treeNode) {
            var key = treeNode.key;
            var loadPromise = new Promise(function(resolve, reject) {
                // We need to get the latest state of loading/loaded keys
                _this.setState(function(_ref) {
                    var _ref$loadedKeys = _ref.loadedKeys, loadedKeys = _ref$loadedKeys === void 0 ? [] : _ref$loadedKeys, _ref$loadingKeys = _ref.loadingKeys, loadingKeys = _ref$loadingKeys === void 0 ? [] : _ref$loadingKeys;
                    var _this$props7 = _this.props, loadData = _this$props7.loadData, onLoad = _this$props7.onLoad;
                    if (!loadData || loadedKeys.indexOf(key) !== -1 || loadingKeys.indexOf(key) !== -1) return null;
                    // Process load data
                    var promise = loadData(treeNode);
                    promise.then(function() {
                        var currentLoadedKeys = _this.state.loadedKeys;
                        var newLoadedKeys = (0, $aa69ce1278dbe319$export$10663f6bbd2fd717)(currentLoadedKeys, key);
                        // onLoad should trigger before internal setState to avoid `loadData` trigger twice.
                        // https://github.com/ant-design/ant-design/issues/12464
                        onLoad === null || onLoad === void 0 || onLoad(newLoadedKeys, {
                            event: 'load',
                            node: treeNode
                        });
                        _this.setUncontrolledState({
                            loadedKeys: newLoadedKeys
                        });
                        _this.setState(function(prevState) {
                            return {
                                loadingKeys: (0, $aa69ce1278dbe319$export$5bfb9ff497fe2298)(prevState.loadingKeys, key)
                            };
                        });
                        resolve();
                    }).catch(function(e) {
                        _this.setState(function(prevState) {
                            return {
                                loadingKeys: (0, $aa69ce1278dbe319$export$5bfb9ff497fe2298)(prevState.loadingKeys, key)
                            };
                        });
                        // If exceed max retry times, we give up retry
                        _this.loadingRetryTimes[key] = (_this.loadingRetryTimes[key] || 0) + 1;
                        if (_this.loadingRetryTimes[key] >= $a5e30f887ded552c$var$MAX_RETRY_TIMES) {
                            var currentLoadedKeys = _this.state.loadedKeys;
                            (0, $3mXQ2.default)(false, 'Retry for `loadData` many times but still failed. No more retry.');
                            _this.setUncontrolledState({
                                loadedKeys: (0, $aa69ce1278dbe319$export$10663f6bbd2fd717)(currentLoadedKeys, key)
                            });
                            resolve();
                        }
                        reject(e);
                    });
                    return {
                        loadingKeys: (0, $aa69ce1278dbe319$export$10663f6bbd2fd717)(loadingKeys, key)
                    };
                });
            });
            // Not care warning if we ignore this
            loadPromise.catch(function() {});
            return loadPromise;
        };
        _this.onNodeMouseEnter = function(event, node) {
            var onMouseEnter = _this.props.onMouseEnter;
            onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
                event: event,
                node: node
            });
        };
        _this.onNodeMouseLeave = function(event, node) {
            var onMouseLeave = _this.props.onMouseLeave;
            onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
                event: event,
                node: node
            });
        };
        _this.onNodeContextMenu = function(event, node) {
            var onRightClick = _this.props.onRightClick;
            if (onRightClick) {
                event.preventDefault();
                onRightClick({
                    event: event,
                    node: node
                });
            }
        };
        _this.onFocus = function() {
            var onFocus = _this.props.onFocus;
            _this.setState({
                focused: true
            });
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            onFocus === null || onFocus === void 0 || onFocus.apply(void 0, args);
        };
        _this.onBlur = function() {
            var onBlur = _this.props.onBlur;
            _this.setState({
                focused: false
            });
            _this.onActiveChange(null);
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            onBlur === null || onBlur === void 0 || onBlur.apply(void 0, args);
        };
        _this.getTreeNodeRequiredProps = function() {
            var _this$state8 = _this.state, expandedKeys = _this$state8.expandedKeys, selectedKeys = _this$state8.selectedKeys, loadedKeys = _this$state8.loadedKeys, loadingKeys = _this$state8.loadingKeys, checkedKeys = _this$state8.checkedKeys, halfCheckedKeys = _this$state8.halfCheckedKeys, dragOverNodeKey = _this$state8.dragOverNodeKey, dropPosition = _this$state8.dropPosition, keyEntities = _this$state8.keyEntities;
            return {
                expandedKeys: expandedKeys || [],
                selectedKeys: selectedKeys || [],
                loadedKeys: loadedKeys || [],
                loadingKeys: loadingKeys || [],
                checkedKeys: checkedKeys || [],
                halfCheckedKeys: halfCheckedKeys || [],
                dragOverNodeKey: dragOverNodeKey,
                dropPosition: dropPosition,
                keyEntities: keyEntities
            };
        };
        // =========================== Expanded ===========================
        /** Set uncontrolled `expandedKeys`. This will also auto update `flattenNodes`. */ _this.setExpandedKeys = function(expandedKeys) {
            var _this$state9 = _this.state, treeData = _this$state9.treeData, fieldNames = _this$state9.fieldNames;
            var flattenNodes = (0, $35a937288f4ed5dd$export$215c1b4f1ba88b23)(treeData, expandedKeys, fieldNames);
            _this.setUncontrolledState({
                expandedKeys: expandedKeys,
                flattenNodes: flattenNodes
            }, true);
        };
        _this.onNodeExpand = function(e, treeNode) {
            var expandedKeys = _this.state.expandedKeys;
            var _this$state10 = _this.state, listChanging = _this$state10.listChanging, fieldNames = _this$state10.fieldNames;
            var _this$props8 = _this.props, onExpand = _this$props8.onExpand, loadData = _this$props8.loadData;
            var expanded = treeNode.expanded;
            var key = treeNode[fieldNames.key];
            // Do nothing when motion is in progress
            if (listChanging) return;
            // Update selected keys
            var index = expandedKeys.indexOf(key);
            var targetExpanded = !expanded;
            (0, $3mXQ2.default)(expanded && index !== -1 || !expanded && index === -1, 'Expand state not sync with index check');
            if (targetExpanded) expandedKeys = (0, $aa69ce1278dbe319$export$10663f6bbd2fd717)(expandedKeys, key);
            else expandedKeys = (0, $aa69ce1278dbe319$export$5bfb9ff497fe2298)(expandedKeys, key);
            _this.setExpandedKeys(expandedKeys);
            onExpand === null || onExpand === void 0 || onExpand(expandedKeys, {
                node: treeNode,
                expanded: targetExpanded,
                nativeEvent: e.nativeEvent
            });
            // Async Load data
            if (targetExpanded && loadData) {
                var loadPromise = _this.onNodeLoad(treeNode);
                if (loadPromise) loadPromise.then(function() {
                    // [Legacy] Refresh logic
                    var newFlattenTreeData = (0, $35a937288f4ed5dd$export$215c1b4f1ba88b23)(_this.state.treeData, expandedKeys, fieldNames);
                    _this.setUncontrolledState({
                        flattenNodes: newFlattenTreeData
                    });
                }).catch(function() {
                    var currentExpandedKeys = _this.state.expandedKeys;
                    var expandedKeysToRestore = (0, $aa69ce1278dbe319$export$5bfb9ff497fe2298)(currentExpandedKeys, key);
                    _this.setExpandedKeys(expandedKeysToRestore);
                });
            }
        };
        _this.onListChangeStart = function() {
            _this.setUncontrolledState({
                listChanging: true
            });
        };
        _this.onListChangeEnd = function() {
            setTimeout(function() {
                _this.setUncontrolledState({
                    listChanging: false
                });
            });
        };
        // =========================== Keyboard ===========================
        _this.onActiveChange = function(newActiveKey) {
            var activeKey = _this.state.activeKey;
            var onActiveChange = _this.props.onActiveChange;
            if (activeKey === newActiveKey) return;
            _this.setState({
                activeKey: newActiveKey
            });
            if (newActiveKey !== null) _this.scrollTo({
                key: newActiveKey
            });
            onActiveChange === null || onActiveChange === void 0 || onActiveChange(newActiveKey);
        };
        _this.getActiveItem = function() {
            var _this$state11 = _this.state, activeKey = _this$state11.activeKey, flattenNodes = _this$state11.flattenNodes;
            if (activeKey === null) return null;
            return flattenNodes.find(function(_ref2) {
                var key = _ref2.key;
                return key === activeKey;
            }) || null;
        };
        _this.offsetActiveKey = function(offset) {
            var _this$state12 = _this.state, flattenNodes = _this$state12.flattenNodes, activeKey = _this$state12.activeKey;
            var index = flattenNodes.findIndex(function(_ref3) {
                var key = _ref3.key;
                return key === activeKey;
            });
            // Align with index
            if (index === -1 && offset < 0) index = flattenNodes.length;
            index = (index + offset + flattenNodes.length) % flattenNodes.length;
            var item = flattenNodes[index];
            if (item) {
                var key = item.key;
                _this.onActiveChange(key);
            } else _this.onActiveChange(null);
        };
        _this.onKeyDown = function(event) {
            var _this$state13 = _this.state, activeKey = _this$state13.activeKey, expandedKeys = _this$state13.expandedKeys, checkedKeys = _this$state13.checkedKeys, fieldNames = _this$state13.fieldNames;
            var _this$props9 = _this.props, onKeyDown = _this$props9.onKeyDown, checkable = _this$props9.checkable, selectable = _this$props9.selectable;
            // >>>>>>>>>> Direction
            switch(event.which){
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).UP:
                    _this.offsetActiveKey(-1);
                    event.preventDefault();
                    break;
                case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).DOWN:
                    _this.offsetActiveKey(1);
                    event.preventDefault();
                    break;
            }
            // >>>>>>>>>> Expand & Selection
            var activeItem = _this.getActiveItem();
            if (activeItem && activeItem.data) {
                var treeNodeRequiredProps = _this.getTreeNodeRequiredProps();
                var expandable = activeItem.data.isLeaf === false || !!(activeItem.data[fieldNames.children] || []).length;
                var eventNode = (0, $35a937288f4ed5dd$export$7bd1b0fd4a8b540b)((0, $kNxFX.default)((0, $kNxFX.default)({}, (0, $35a937288f4ed5dd$export$d961fd523a514db5)(activeKey, treeNodeRequiredProps)), {}, {
                    data: activeItem.data,
                    active: true
                }));
                switch(event.which){
                    // >>> Expand
                    case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).LEFT:
                        // Collapse if possible
                        if (expandable && expandedKeys.includes(activeKey)) _this.onNodeExpand({}, eventNode);
                        else if (activeItem.parent) _this.onActiveChange(activeItem.parent.key);
                        event.preventDefault();
                        break;
                    case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).RIGHT:
                        // Expand if possible
                        if (expandable && !expandedKeys.includes(activeKey)) _this.onNodeExpand({}, eventNode);
                        else if (activeItem.children && activeItem.children.length) _this.onActiveChange(activeItem.children[0].key);
                        event.preventDefault();
                        break;
                    // Selection
                    case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER:
                    case (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).SPACE:
                        if (checkable && !eventNode.disabled && eventNode.checkable !== false && !eventNode.disableCheckbox) _this.onNodeCheck({}, eventNode, !checkedKeys.includes(activeKey));
                        else if (!checkable && selectable && !eventNode.disabled && eventNode.selectable !== false) _this.onNodeSelect({}, eventNode);
                        break;
                }
            }
            onKeyDown === null || onKeyDown === void 0 || onKeyDown(event);
        };
        /**
     * Only update the value which is not in props
     */ _this.setUncontrolledState = function(state) {
            var atomic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var forceState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            if (!_this.destroyed) {
                var needSync = false;
                var allPassed = true;
                var newState = {};
                Object.keys(state).forEach(function(name) {
                    if (name in _this.props) {
                        allPassed = false;
                        return;
                    }
                    needSync = true;
                    newState[name] = state[name];
                });
                if (needSync && (!atomic || allPassed)) _this.setState((0, $kNxFX.default)((0, $kNxFX.default)({}, newState), forceState));
            }
        };
        _this.scrollTo = function(scroll) {
            _this.listRef.current.scrollTo(scroll);
        };
        return _this;
    }
    (0, $5KQxu.default)(Tree, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.destroyed = false;
                this.onUpdated();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.onUpdated();
            }
        },
        {
            key: "onUpdated",
            value: function onUpdated() {
                var activeKey = this.props.activeKey;
                if (activeKey !== undefined && activeKey !== this.state.activeKey) {
                    this.setState({
                        activeKey: activeKey
                    });
                    if (activeKey !== null) this.scrollTo({
                        key: activeKey
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener('dragend', this.onWindowDragEnd);
                this.destroyed = true;
            }
        },
        {
            key: "resetDragState",
            value: function resetDragState() {
                this.setState({
                    dragOverNodeKey: null,
                    dropPosition: null,
                    dropLevelOffset: null,
                    dropTargetKey: null,
                    dropContainerKey: null,
                    dropTargetPos: null,
                    dropAllowed: false
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _classNames;
                var _this$state14 = this.state, focused = _this$state14.focused, flattenNodes = _this$state14.flattenNodes, keyEntities = _this$state14.keyEntities, draggingNodeKey = _this$state14.draggingNodeKey, activeKey = _this$state14.activeKey, dropLevelOffset = _this$state14.dropLevelOffset, dropContainerKey = _this$state14.dropContainerKey, dropTargetKey = _this$state14.dropTargetKey, dropPosition = _this$state14.dropPosition, dragOverNodeKey = _this$state14.dragOverNodeKey, indent = _this$state14.indent;
                var _this$props10 = this.props, prefixCls = _this$props10.prefixCls, className = _this$props10.className, style = _this$props10.style, showLine = _this$props10.showLine, focusable = _this$props10.focusable, _this$props10$tabInde = _this$props10.tabIndex, tabIndex = _this$props10$tabInde === void 0 ? 0 : _this$props10$tabInde, selectable = _this$props10.selectable, showIcon = _this$props10.showIcon, icon = _this$props10.icon, switcherIcon = _this$props10.switcherIcon, draggable = _this$props10.draggable, checkable = _this$props10.checkable, checkStrictly = _this$props10.checkStrictly, disabled = _this$props10.disabled, motion = _this$props10.motion, loadData = _this$props10.loadData, filterTreeNode = _this$props10.filterTreeNode, height = _this$props10.height, itemHeight = _this$props10.itemHeight, virtual = _this$props10.virtual, titleRender = _this$props10.titleRender, dropIndicatorRender = _this$props10.dropIndicatorRender, onContextMenu = _this$props10.onContextMenu, onScroll = _this$props10.onScroll, direction = _this$props10.direction, rootClassName = _this$props10.rootClassName, rootStyle = _this$props10.rootStyle;
                var domProps = (0, $c7e00e8671f36d19$export$2e2bcd8739ae039)(this.props, {
                    aria: true,
                    data: true
                });
                // It's better move to hooks but we just simply keep here
                var draggableConfig;
                if (draggable) {
                    if ((0, $5KhTJ.default)(draggable) === 'object') draggableConfig = draggable;
                    else if (typeof draggable === 'function') draggableConfig = {
                        nodeDraggable: draggable
                    };
                    else draggableConfig = {};
                }
                return /*#__PURE__*/ $6fFrj.createElement((0, $73625c1f8b3860d0$export$dfae7d399eea2568).Provider, {
                    value: {
                        prefixCls: prefixCls,
                        selectable: selectable,
                        showIcon: showIcon,
                        icon: icon,
                        switcherIcon: switcherIcon,
                        draggable: draggableConfig,
                        draggingNodeKey: draggingNodeKey,
                        checkable: checkable,
                        checkStrictly: checkStrictly,
                        disabled: disabled,
                        keyEntities: keyEntities,
                        dropLevelOffset: dropLevelOffset,
                        dropContainerKey: dropContainerKey,
                        dropTargetKey: dropTargetKey,
                        dropPosition: dropPosition,
                        dragOverNodeKey: dragOverNodeKey,
                        indent: indent,
                        direction: direction,
                        dropIndicatorRender: dropIndicatorRender,
                        loadData: loadData,
                        filterTreeNode: filterTreeNode,
                        titleRender: titleRender,
                        onNodeClick: this.onNodeClick,
                        onNodeDoubleClick: this.onNodeDoubleClick,
                        onNodeExpand: this.onNodeExpand,
                        onNodeSelect: this.onNodeSelect,
                        onNodeCheck: this.onNodeCheck,
                        onNodeLoad: this.onNodeLoad,
                        onNodeMouseEnter: this.onNodeMouseEnter,
                        onNodeMouseLeave: this.onNodeMouseLeave,
                        onNodeContextMenu: this.onNodeContextMenu,
                        onNodeDragStart: this.onNodeDragStart,
                        onNodeDragEnter: this.onNodeDragEnter,
                        onNodeDragOver: this.onNodeDragOver,
                        onNodeDragLeave: this.onNodeDragLeave,
                        onNodeDragEnd: this.onNodeDragEnd,
                        onNodeDrop: this.onNodeDrop
                    }
                }, /*#__PURE__*/ $6fFrj.createElement("div", {
                    role: "tree",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className, rootClassName, (_classNames = {}, (0, $43449.default)(_classNames, "".concat(prefixCls, "-show-line"), showLine), (0, $43449.default)(_classNames, "".concat(prefixCls, "-focused"), focused), (0, $43449.default)(_classNames, "".concat(prefixCls, "-active-focused"), activeKey !== null), _classNames)),
                    style: rootStyle
                }, /*#__PURE__*/ $6fFrj.createElement((0, $ef9ab4c4404dc2cb$export$2e2bcd8739ae039), (0, $fIrcP.default)({
                    ref: this.listRef,
                    prefixCls: prefixCls,
                    style: style,
                    data: flattenNodes,
                    disabled: disabled,
                    selectable: selectable,
                    checkable: !!checkable,
                    motion: motion,
                    dragging: draggingNodeKey !== null,
                    height: height,
                    itemHeight: itemHeight,
                    virtual: virtual,
                    focusable: focusable,
                    focused: focused,
                    tabIndex: tabIndex,
                    activeItem: this.getActiveItem(),
                    onFocus: this.onFocus,
                    onBlur: this.onBlur,
                    onKeyDown: this.onKeyDown,
                    onActiveChange: this.onActiveChange,
                    onListChangeStart: this.onListChangeStart,
                    onListChangeEnd: this.onListChangeEnd,
                    onContextMenu: onContextMenu,
                    onScroll: onScroll
                }, this.getTreeNodeRequiredProps(), domProps))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, prevState) {
                var prevProps = prevState.prevProps;
                var newState = {
                    prevProps: props
                };
                function needSync(name) {
                    return !prevProps && name in props || prevProps && prevProps[name] !== props[name];
                }
                // ================== Tree Node ==================
                var treeData;
                // fieldNames
                var fieldNames = prevState.fieldNames;
                if (needSync('fieldNames')) {
                    fieldNames = (0, $35a937288f4ed5dd$export$6c519d302dced239)(props.fieldNames);
                    newState.fieldNames = fieldNames;
                }
                // Check if `treeData` or `children` changed and save into the state.
                if (needSync('treeData')) treeData = props.treeData;
                else if (needSync('children')) {
                    (0, $3mXQ2.default)(false, '`children` of Tree is deprecated. Please use `treeData` instead.');
                    treeData = (0, $35a937288f4ed5dd$export$6d8b10995563b669)(props.children);
                }
                // Save flatten nodes info and convert `treeData` into keyEntities
                if (treeData) {
                    newState.treeData = treeData;
                    var entitiesMap = (0, $35a937288f4ed5dd$export$e5d831ce033a4615)(treeData, {
                        fieldNames: fieldNames
                    });
                    newState.keyEntities = (0, $kNxFX.default)((0, $43449.default)({}, (0, $ef9ab4c4404dc2cb$export$17c02cdd52a7d889), (0, $ef9ab4c4404dc2cb$export$2d18abad5109a402)), entitiesMap.keyEntities);
                }
                var keyEntities = newState.keyEntities || prevState.keyEntities;
                // ================ expandedKeys =================
                if (needSync('expandedKeys') || prevProps && needSync('autoExpandParent')) newState.expandedKeys = props.autoExpandParent || !prevProps && props.defaultExpandParent ? (0, $aa69ce1278dbe319$export$fac4a40c345ccd80)(props.expandedKeys, keyEntities) : props.expandedKeys;
                else if (!prevProps && props.defaultExpandAll) {
                    var cloneKeyEntities = (0, $kNxFX.default)({}, keyEntities);
                    delete cloneKeyEntities[0, $ef9ab4c4404dc2cb$export$17c02cdd52a7d889];
                    newState.expandedKeys = Object.keys(cloneKeyEntities).map(function(key) {
                        return cloneKeyEntities[key].key;
                    });
                } else if (!prevProps && props.defaultExpandedKeys) newState.expandedKeys = props.autoExpandParent || props.defaultExpandParent ? (0, $aa69ce1278dbe319$export$fac4a40c345ccd80)(props.defaultExpandedKeys, keyEntities) : props.defaultExpandedKeys;
                if (!newState.expandedKeys) delete newState.expandedKeys;
                // ================ flattenNodes =================
                if (treeData || newState.expandedKeys) {
                    var flattenNodes = (0, $35a937288f4ed5dd$export$215c1b4f1ba88b23)(treeData || prevState.treeData, newState.expandedKeys || prevState.expandedKeys, fieldNames);
                    newState.flattenNodes = flattenNodes;
                }
                // ================ selectedKeys =================
                if (props.selectable) {
                    if (needSync('selectedKeys')) newState.selectedKeys = (0, $aa69ce1278dbe319$export$fffc10811828fd68)(props.selectedKeys, props);
                    else if (!prevProps && props.defaultSelectedKeys) newState.selectedKeys = (0, $aa69ce1278dbe319$export$fffc10811828fd68)(props.defaultSelectedKeys, props);
                }
                // ================= checkedKeys =================
                if (props.checkable) {
                    var checkedKeyEntity;
                    if (needSync('checkedKeys')) checkedKeyEntity = (0, $aa69ce1278dbe319$export$29d4989c23990d41)(props.checkedKeys) || {};
                    else if (!prevProps && props.defaultCheckedKeys) checkedKeyEntity = (0, $aa69ce1278dbe319$export$29d4989c23990d41)(props.defaultCheckedKeys) || {};
                    else if (treeData) // If `treeData` changed, we also need check it
                    checkedKeyEntity = (0, $aa69ce1278dbe319$export$29d4989c23990d41)(props.checkedKeys) || {
                        checkedKeys: prevState.checkedKeys,
                        halfCheckedKeys: prevState.halfCheckedKeys
                    };
                    if (checkedKeyEntity) {
                        var _checkedKeyEntity = checkedKeyEntity, _checkedKeyEntity$che = _checkedKeyEntity.checkedKeys, checkedKeys = _checkedKeyEntity$che === void 0 ? [] : _checkedKeyEntity$che, _checkedKeyEntity$hal = _checkedKeyEntity.halfCheckedKeys, halfCheckedKeys = _checkedKeyEntity$hal === void 0 ? [] : _checkedKeyEntity$hal;
                        if (!props.checkStrictly) {
                            var conductKeys = (0, $d68df472f315bb8e$export$43adf2c483e3e633)(checkedKeys, true, keyEntities);
                            checkedKeys = conductKeys.checkedKeys;
                            halfCheckedKeys = conductKeys.halfCheckedKeys;
                        }
                        newState.checkedKeys = checkedKeys;
                        newState.halfCheckedKeys = halfCheckedKeys;
                    }
                }
                // ================= loadedKeys ==================
                if (needSync('loadedKeys')) newState.loadedKeys = props.loadedKeys;
                return newState;
            }
        }
    ]);
    return Tree;
}($6fFrj.Component);
$a5e30f887ded552c$var$Tree.defaultProps = {
    prefixCls: 'rc-tree',
    showLine: false,
    showIcon: true,
    selectable: true,
    multiple: false,
    checkable: false,
    disabled: false,
    checkStrictly: false,
    draggable: false,
    defaultExpandParent: true,
    autoExpandParent: false,
    defaultExpandAll: false,
    defaultExpandedKeys: [],
    defaultCheckedKeys: [],
    defaultSelectedKeys: [],
    dropIndicatorRender: (0, $d7cb019f7dc4c67c$export$2e2bcd8739ae039),
    allowDrop: function allowDrop() {
        return true;
    },
    expandAction: false
};
$a5e30f887ded552c$var$Tree.TreeNode = (0, $c40e2bb393cde7f6$export$2e2bcd8739ae039);
var $a5e30f887ded552c$export$2e2bcd8739ae039 = $a5e30f887ded552c$var$Tree;



var $249d3330af137cae$export$2e2bcd8739ae039 = (0, $a5e30f887ded552c$export$2e2bcd8739ae039);



var $43449 = parcelRequire("43449");

var $5KhTJ = parcelRequire("5KhTJ");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $7905cc1b0770a368$var$HolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"
                }
            }
        ]
    },
    "name": "holder",
    "theme": "outlined"
};
var $7905cc1b0770a368$export$2e2bcd8739ae039 = $7905cc1b0770a368$var$HolderOutlined;



var $58b103470ee52b6f$var$HolderOutlined = function HolderOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $7905cc1b0770a368$export$2e2bcd8739ae039)
    }));
};
var $58b103470ee52b6f$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($58b103470ee52b6f$var$HolderOutlined);
var $58b103470ee52b6f$export$2e2bcd8739ae039 = $58b103470ee52b6f$var$RefIcon;



var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");



var $43449 = parcelRequire("43449");

var $6fFrj = parcelRequire("6fFrj");
var $c1a92511ad0fee8d$export$cc800923e997bb8 = 4;
function $c1a92511ad0fee8d$export$2e2bcd8739ae039(props) {
    var dropPosition = props.dropPosition, dropLevelOffset = props.dropLevelOffset, prefixCls = props.prefixCls, indent = props.indent, _props$direction = props.direction, direction = _props$direction === void 0 ? 'ltr' : _props$direction;
    var startPosition = direction === 'ltr' ? 'left' : 'right';
    var endPosition = direction === 'ltr' ? 'right' : 'left';
    var style = (0, $43449.default)((0, $43449.default)({}, startPosition, -dropLevelOffset * indent + $c1a92511ad0fee8d$export$cc800923e997bb8), endPosition, 0);
    switch(dropPosition){
        case -1:
            style.top = -3;
            break;
        case 1:
            style.bottom = -3;
            break;
        default:
            // dropPosition === 0
            style.bottom = -3;
            style[startPosition] = indent + $c1a92511ad0fee8d$export$cc800923e997bb8;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        style: style,
        className: "".concat(prefixCls, "-drop-indicator")
    });
}



var $5KhTJ = parcelRequire("5KhTJ");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $309ab7844b9e4880$var$CaretDownFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "filled"
};
var $309ab7844b9e4880$export$2e2bcd8739ae039 = $309ab7844b9e4880$var$CaretDownFilled;



var $1e491249baa904da$var$CaretDownFilled = function CaretDownFilled(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $309ab7844b9e4880$export$2e2bcd8739ae039)
    }));
};
var $1e491249baa904da$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($1e491249baa904da$var$CaretDownFilled);
var $1e491249baa904da$export$2e2bcd8739ae039 = $1e491249baa904da$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $23f6ae03a22e3a40$var$FileOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file",
    "theme": "outlined"
};
var $23f6ae03a22e3a40$export$2e2bcd8739ae039 = $23f6ae03a22e3a40$var$FileOutlined;



var $4cde82d2a4ea2cd1$var$FileOutlined = function FileOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $23f6ae03a22e3a40$export$2e2bcd8739ae039)
    }));
};
var $4cde82d2a4ea2cd1$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($4cde82d2a4ea2cd1$var$FileOutlined);
var $4cde82d2a4ea2cd1$export$2e2bcd8739ae039 = $4cde82d2a4ea2cd1$var$RefIcon;




var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $3b51f4a76fd3cab5$var$MinusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "minus-square",
    "theme": "outlined"
};
var $3b51f4a76fd3cab5$export$2e2bcd8739ae039 = $3b51f4a76fd3cab5$var$MinusSquareOutlined;



var $5f7d56357bd13558$var$MinusSquareOutlined = function MinusSquareOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $3b51f4a76fd3cab5$export$2e2bcd8739ae039)
    }));
};
var $5f7d56357bd13558$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($5f7d56357bd13558$var$MinusSquareOutlined);
var $5f7d56357bd13558$export$2e2bcd8739ae039 = $5f7d56357bd13558$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $ea0a4439df12b22a$var$PlusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "plus-square",
    "theme": "outlined"
};
var $ea0a4439df12b22a$export$2e2bcd8739ae039 = $ea0a4439df12b22a$var$PlusSquareOutlined;



var $e5ab1382d66dc0eb$var$PlusSquareOutlined = function PlusSquareOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $ea0a4439df12b22a$export$2e2bcd8739ae039)
    }));
};
var $e5ab1382d66dc0eb$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($e5ab1382d66dc0eb$var$PlusSquareOutlined);
var $e5ab1382d66dc0eb$export$2e2bcd8739ae039 = $e5ab1382d66dc0eb$var$RefIcon;



var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");

function $0e0c2aea5830b331$export$2e2bcd8739ae039(prefixCls, switcherIcon, showLine, treeNodeProps) {
    var isLeaf = treeNodeProps.isLeaf, expanded = treeNodeProps.expanded, loading = treeNodeProps.loading;
    if (loading) return /*#__PURE__*/ $6fFrj.createElement((0, $3240b41b65b5dac9$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-switcher-loading-icon")
    });
    var showLeafIcon;
    if (showLine && (0, $5KhTJ.default)(showLine) === 'object') showLeafIcon = showLine.showLeafIcon;
    if (isLeaf) {
        if (!showLine) return null;
        if (typeof showLeafIcon !== 'boolean' && !!showLeafIcon) {
            var leafIcon = typeof showLeafIcon === 'function' ? showLeafIcon(treeNodeProps) : showLeafIcon;
            var leafCls = "".concat(prefixCls, "-switcher-line-custom-icon");
            if ((0, $79365009d9b77ac6$export$a8257692ac88316c)(leafIcon)) return (0, $79365009d9b77ac6$export$e530037191fcd5d7)(leafIcon, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(leafIcon.props.className || '', leafCls)
            });
            return leafIcon;
        }
        return showLeafIcon ? /*#__PURE__*/ $6fFrj.createElement((0, $4cde82d2a4ea2cd1$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-switcher-line-icon")
        }) : /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-switcher-leaf-line")
        });
    }
    var switcherCls = "".concat(prefixCls, "-switcher-icon");
    var switcher = typeof switcherIcon === 'function' ? switcherIcon(treeNodeProps) : switcherIcon;
    if ((0, $79365009d9b77ac6$export$a8257692ac88316c)(switcher)) return (0, $79365009d9b77ac6$export$e530037191fcd5d7)(switcher, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(switcher.props.className || '', switcherCls)
    });
    if (switcher) return switcher;
    if (showLine) return expanded ? /*#__PURE__*/ $6fFrj.createElement((0, $5f7d56357bd13558$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-switcher-line-icon")
    }) : /*#__PURE__*/ $6fFrj.createElement((0, $e5ab1382d66dc0eb$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-switcher-line-icon")
    });
    return /*#__PURE__*/ $6fFrj.createElement((0, $1e491249baa904da$export$2e2bcd8739ae039), {
        className: switcherCls
    });
}


var $17f6b94eda9c596a$var$Tree = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction, virtual = _React$useContext.virtual;
    var customizePrefixCls = props.prefixCls, className = props.className, _props$showIcon = props.showIcon, showIcon = _props$showIcon === void 0 ? false : _props$showIcon, showLine = props.showLine, _switcherIcon = props.switcherIcon, _props$blockNode = props.blockNode, blockNode = _props$blockNode === void 0 ? false : _props$blockNode, children = props.children, _props$checkable = props.checkable, checkable = _props$checkable === void 0 ? false : _props$checkable, _props$selectable = props.selectable, selectable = _props$selectable === void 0 ? true : _props$selectable, draggable = props.draggable, _props$motion = props.motion, motion = _props$motion === void 0 ? (0, $fIrcP.default)((0, $fIrcP.default)({}, (0, $779588b2444df86c$export$2e2bcd8739ae039)), {
        motionAppear: false
    }) : _props$motion;
    var prefixCls = getPrefixCls('tree', customizePrefixCls);
    var newProps = (0, $fIrcP.default)((0, $fIrcP.default)({}, props), {
        checkable: checkable,
        selectable: selectable,
        showIcon: showIcon,
        motion: motion,
        blockNode: blockNode,
        showLine: Boolean(showLine),
        dropIndicatorRender: (0, $c1a92511ad0fee8d$export$2e2bcd8739ae039)
    });
    var draggableConfig = $6fFrj.useMemo(function() {
        if (!draggable) return false;
        var mergedDraggable = {};
        switch((0, $5KhTJ.default)(draggable)){
            case 'function':
                mergedDraggable.nodeDraggable = draggable;
                break;
            case 'object':
                mergedDraggable = (0, $fIrcP.default)({}, draggable);
                break;
            default:
                break;
        }
        if (mergedDraggable.icon !== false) mergedDraggable.icon = mergedDraggable.icon || /*#__PURE__*/ $6fFrj.createElement((0, $58b103470ee52b6f$export$2e2bcd8739ae039), null);
        return mergedDraggable;
    }, [
        draggable
    ]);
    return /*#__PURE__*/ $6fFrj.createElement((0, $249d3330af137cae$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        itemHeight: 20,
        ref: ref,
        virtual: virtual
    }, newProps, {
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-icon-hide"), !showIcon), "".concat(prefixCls, "-block-node"), blockNode), "".concat(prefixCls, "-unselectable"), !selectable), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className),
        direction: direction,
        checkable: checkable ? /*#__PURE__*/ $6fFrj.createElement("span", {
            className: "".concat(prefixCls, "-checkbox-inner")
        }) : checkable,
        selectable: selectable,
        switcherIcon: function switcherIcon(nodeProps) {
            return (0, $0e0c2aea5830b331$export$2e2bcd8739ae039)(prefixCls, _switcherIcon, showLine, nodeProps);
        },
        draggable: draggableConfig
    }), children);
});
var $17f6b94eda9c596a$export$2e2bcd8739ae039 = $17f6b94eda9c596a$var$Tree;



var $43449 = parcelRequire("43449");

var $37xND = parcelRequire("37xND");

var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $d3eb46379f2a8398$var$FolderOpenOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    },
    "name": "folder-open",
    "theme": "outlined"
};
var $d3eb46379f2a8398$export$2e2bcd8739ae039 = $d3eb46379f2a8398$var$FolderOpenOutlined;



var $b35b50fcc668a8ed$var$FolderOpenOutlined = function FolderOpenOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $d3eb46379f2a8398$export$2e2bcd8739ae039)
    }));
};
var $b35b50fcc668a8ed$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($b35b50fcc668a8ed$var$FolderOpenOutlined);
var $b35b50fcc668a8ed$export$2e2bcd8739ae039 = $b35b50fcc668a8ed$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $f5f7e6e4a6cf1d8a$var$FolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    },
    "name": "folder",
    "theme": "outlined"
};
var $f5f7e6e4a6cf1d8a$export$2e2bcd8739ae039 = $f5f7e6e4a6cf1d8a$var$FolderOutlined;



var $027134e1fff91a3e$var$FolderOutlined = function FolderOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $f5f7e6e4a6cf1d8a$export$2e2bcd8739ae039)
    }));
};
var $027134e1fff91a3e$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($027134e1fff91a3e$var$FolderOutlined);
var $027134e1fff91a3e$export$2e2bcd8739ae039 = $027134e1fff91a3e$var$RefIcon;



var $fActo = parcelRequire("fActo");



var $6fFrj = parcelRequire("6fFrj");



var $37xND = parcelRequire("37xND");
var $e9ee33833fa54cab$var$Record;
(function(Record) {
    Record[Record["None"] = 0] = "None";
    Record[Record["Start"] = 1] = "Start";
    Record[Record["End"] = 2] = "End";
})($e9ee33833fa54cab$var$Record || ($e9ee33833fa54cab$var$Record = {}));
function $e9ee33833fa54cab$var$traverseNodesKey(treeData, callback) {
    function processNode(dataNode) {
        var key = dataNode.key, children = dataNode.children;
        if (callback(key, dataNode) !== false) $e9ee33833fa54cab$var$traverseNodesKey(children || [], callback);
    }
    treeData.forEach(processNode);
}
function $e9ee33833fa54cab$export$aad0b800290b42ab(_ref) {
    var treeData = _ref.treeData, expandedKeys = _ref.expandedKeys, startKey = _ref.startKey, endKey = _ref.endKey;
    var keys = [];
    var record = $e9ee33833fa54cab$var$Record.None;
    if (startKey && startKey === endKey) return [
        startKey
    ];
    if (!startKey || !endKey) return [];
    function matchKey(key) {
        return key === startKey || key === endKey;
    }
    $e9ee33833fa54cab$var$traverseNodesKey(treeData, function(key) {
        if (record === $e9ee33833fa54cab$var$Record.End) return false;
        if (matchKey(key)) {
            // Match test
            keys.push(key);
            if (record === $e9ee33833fa54cab$var$Record.None) record = $e9ee33833fa54cab$var$Record.Start;
            else if (record === $e9ee33833fa54cab$var$Record.Start) {
                record = $e9ee33833fa54cab$var$Record.End;
                return false;
            }
        } else if (record === $e9ee33833fa54cab$var$Record.Start) // Append selection
        keys.push(key);
        return expandedKeys.includes(key);
    });
    return keys;
}
function $e9ee33833fa54cab$export$7d40a46ab3886826(treeData, keys) {
    var restKeys = (0, $37xND.default)(keys);
    var nodes = [];
    $e9ee33833fa54cab$var$traverseNodesKey(treeData, function(key, node) {
        var index = restKeys.indexOf(key);
        if (index !== -1) {
            nodes.push(node);
            restKeys.splice(index, 1);
        }
        return !!restKeys.length;
    });
    return nodes;
}


var $61a59004e0d1cdd3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $61a59004e0d1cdd3$var$getIcon(props) {
    var isLeaf = props.isLeaf, expanded = props.expanded;
    if (isLeaf) return /*#__PURE__*/ $6fFrj.createElement((0, $4cde82d2a4ea2cd1$export$2e2bcd8739ae039), null);
    return expanded ? /*#__PURE__*/ $6fFrj.createElement((0, $b35b50fcc668a8ed$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $6fFrj.createElement((0, $027134e1fff91a3e$export$2e2bcd8739ae039), null);
}
function $61a59004e0d1cdd3$var$getTreeData(_ref) {
    var treeData = _ref.treeData, children = _ref.children;
    return treeData || (0, $35a937288f4ed5dd$export$6d8b10995563b669)(children);
}
var $61a59004e0d1cdd3$var$DirectoryTree = function DirectoryTree(_a, ref) {
    var defaultExpandAll = _a.defaultExpandAll, defaultExpandParent = _a.defaultExpandParent, defaultExpandedKeys = _a.defaultExpandedKeys, props = $61a59004e0d1cdd3$var$__rest(_a, [
        "defaultExpandAll",
        "defaultExpandParent",
        "defaultExpandedKeys"
    ]);
    // Shift click usage
    var lastSelectedKey = $6fFrj.useRef();
    var cachedSelectedKeys = $6fFrj.useRef();
    var getInitExpandedKeys = function getInitExpandedKeys() {
        var _convertDataToEntitie = (0, $35a937288f4ed5dd$export$e5d831ce033a4615)($61a59004e0d1cdd3$var$getTreeData(props)), keyEntities = _convertDataToEntitie.keyEntities;
        var initExpandedKeys;
        // Expanded keys
        if (defaultExpandAll) initExpandedKeys = Object.keys(keyEntities);
        else if (defaultExpandParent) initExpandedKeys = (0, $aa69ce1278dbe319$export$fac4a40c345ccd80)(props.expandedKeys || defaultExpandedKeys || [], keyEntities);
        else initExpandedKeys = props.expandedKeys || defaultExpandedKeys;
        return initExpandedKeys;
    };
    var _React$useState = $6fFrj.useState(props.selectedKeys || props.defaultSelectedKeys || []), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), selectedKeys = _React$useState2[0], setSelectedKeys = _React$useState2[1];
    var _React$useState3 = $6fFrj.useState(function() {
        return getInitExpandedKeys();
    }), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), expandedKeys = _React$useState4[0], setExpandedKeys = _React$useState4[1];
    $6fFrj.useEffect(function() {
        if ('selectedKeys' in props) setSelectedKeys(props.selectedKeys);
    }, [
        props.selectedKeys
    ]);
    $6fFrj.useEffect(function() {
        if ('expandedKeys' in props) setExpandedKeys(props.expandedKeys);
    }, [
        props.expandedKeys
    ]);
    var onExpand = function onExpand(keys, info) {
        var _a;
        if (!('expandedKeys' in props)) setExpandedKeys(keys);
        // Call origin function
        return (_a = props.onExpand) === null || _a === void 0 ? void 0 : _a.call(props, keys, info);
    };
    var onSelect = function onSelect(keys, event) {
        var _a;
        var multiple = props.multiple;
        var node = event.node, nativeEvent = event.nativeEvent;
        var _node$key = node.key, key = _node$key === void 0 ? '' : _node$key;
        var treeData = $61a59004e0d1cdd3$var$getTreeData(props);
        // const newState: DirectoryTreeState = {};
        // We need wrap this event since some value is not same
        var newEvent = (0, $fIrcP.default)((0, $fIrcP.default)({}, event), {
            selected: true
        });
        // Windows / Mac single pick
        var ctrlPick = (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.ctrlKey) || (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.metaKey);
        var shiftPick = nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.shiftKey;
        // Generate new selected keys
        var newSelectedKeys;
        if (multiple && ctrlPick) {
            // Control click
            newSelectedKeys = keys;
            lastSelectedKey.current = key;
            cachedSelectedKeys.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $e9ee33833fa54cab$export$7d40a46ab3886826)(treeData, newSelectedKeys);
        } else if (multiple && shiftPick) {
            // Shift click
            newSelectedKeys = Array.from(new Set([].concat((0, $37xND.default)(cachedSelectedKeys.current || []), (0, $37xND.default)((0, $e9ee33833fa54cab$export$aad0b800290b42ab)({
                treeData: treeData,
                expandedKeys: expandedKeys,
                startKey: key,
                endKey: lastSelectedKey.current
            })))));
            newEvent.selectedNodes = (0, $e9ee33833fa54cab$export$7d40a46ab3886826)(treeData, newSelectedKeys);
        } else {
            // Single click
            newSelectedKeys = [
                key
            ];
            lastSelectedKey.current = key;
            cachedSelectedKeys.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $e9ee33833fa54cab$export$7d40a46ab3886826)(treeData, newSelectedKeys);
        }
        (_a = props.onSelect) === null || _a === void 0 || _a.call(props, newSelectedKeys, newEvent);
        if (!('selectedKeys' in props)) setSelectedKeys(newSelectedKeys);
    };
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var customizePrefixCls = props.prefixCls, className = props.className, _props$showIcon = props.showIcon, showIcon = _props$showIcon === void 0 ? true : _props$showIcon, _props$expandAction = props.expandAction, expandAction = _props$expandAction === void 0 ? 'click' : _props$expandAction, otherProps = $61a59004e0d1cdd3$var$__rest(props, [
        "prefixCls",
        "className",
        "showIcon",
        "expandAction"
    ]);
    var prefixCls = getPrefixCls('tree', customizePrefixCls);
    var connectClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-directory"), (0, $43449.default)({}, "".concat(prefixCls, "-directory-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $6fFrj.createElement((0, $17f6b94eda9c596a$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        icon: $61a59004e0d1cdd3$var$getIcon,
        ref: ref,
        blockNode: true
    }, otherProps, {
        showIcon: showIcon,
        expandAction: expandAction,
        prefixCls: prefixCls,
        className: connectClassName,
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        onSelect: onSelect,
        onExpand: onExpand
    }));
};
var $61a59004e0d1cdd3$var$ForwardDirectoryTree = /*#__PURE__*/ $6fFrj.forwardRef($61a59004e0d1cdd3$var$DirectoryTree);
var $61a59004e0d1cdd3$export$2e2bcd8739ae039 = $61a59004e0d1cdd3$var$ForwardDirectoryTree;


var $0dad0951e76ed555$var$Tree = (0, $17f6b94eda9c596a$export$2e2bcd8739ae039);
$0dad0951e76ed555$var$Tree.DirectoryTree = (0, $61a59004e0d1cdd3$export$2e2bcd8739ae039);
$0dad0951e76ed555$var$Tree.TreeNode = (0, $c40e2bb393cde7f6$export$2e2bcd8739ae039);
var $0dad0951e76ed555$export$2e2bcd8739ae039 = $0dad0951e76ed555$var$Tree;



var $6fFrj = parcelRequire("6fFrj");

function $25abd000707076af$export$2e2bcd8739ae039(initialValue) {
    var ref = $6fFrj.useRef(initialValue);
    var forceUpdate = (0, $930b14fa9874af4b$export$2e2bcd8739ae039)();
    return [
        function() {
            return ref.current;
        },
        function(newValue) {
            ref.current = newValue;
            // re-render
            forceUpdate();
        }
    ];
}




var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $fActo = parcelRequire("fActo");

var $6fFrj = parcelRequire("6fFrj");


var $21f5bd0c7572f764$var$Group = function Group(props) {
    var _useContext = (0, $6fFrj.useContext)((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _useContext.getPrefixCls, direction = _useContext.direction;
    var customizePrefixCls = props.prefixCls, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className;
    var prefixCls = getPrefixCls('input-group', customizePrefixCls);
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-lg"), props.size === 'large'), "".concat(prefixCls, "-sm"), props.size === 'small'), "".concat(prefixCls, "-compact"), props.compact), "".concat(prefixCls, "-rtl"), direction === 'rtl'), className);
    var formItemContext = (0, $6fFrj.useContext)((0, $76d69cb8326089c6$export$bbb5553c6c7a14ed));
    var groupFormItemContext = (0, $6fFrj.useMemo)(function() {
        return (0, $fIrcP.default)((0, $fIrcP.default)({}, formItemContext), {
            isFormItemInput: false
        });
    }, [
        formItemContext
    ]);
    return /*#__PURE__*/ $6fFrj.createElement("span", {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, /*#__PURE__*/ $6fFrj.createElement((0, $76d69cb8326089c6$export$bbb5553c6c7a14ed).Provider, {
        value: groupFormItemContext
    }, props.children));
};
var $21f5bd0c7572f764$export$2e2bcd8739ae039 = $21f5bd0c7572f764$var$Group;




var $fIrcP = parcelRequire("fIrcP");

var $43449 = parcelRequire("43449");

var $jP8CL = parcelRequire("jP8CL");

var $5KhTJ = parcelRequire("5KhTJ");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $675a9122e32c2c4e$var$EyeInvisibleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    "name": "eye-invisible",
    "theme": "outlined"
};
var $675a9122e32c2c4e$export$2e2bcd8739ae039 = $675a9122e32c2c4e$var$EyeInvisibleOutlined;



var $da7f5f8cb02d6609$var$EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $675a9122e32c2c4e$export$2e2bcd8739ae039)
    }));
};
var $da7f5f8cb02d6609$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($da7f5f8cb02d6609$var$EyeInvisibleOutlined);
var $da7f5f8cb02d6609$export$2e2bcd8739ae039 = $da7f5f8cb02d6609$var$RefIcon;




var $fActo = parcelRequire("fActo");


var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");



var $08e8bce0f00b7ee1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $08e8bce0f00b7ee1$var$defaultIconRender = function defaultIconRender(visible) {
    return visible ? /*#__PURE__*/ $6fFrj.createElement((0, $eca7e40229c3d459$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $6fFrj.createElement((0, $da7f5f8cb02d6609$export$2e2bcd8739ae039), null);
};
var $08e8bce0f00b7ee1$var$ActionMap = {
    click: 'onClick',
    hover: 'onMouseOver'
};
var $08e8bce0f00b7ee1$var$Password = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var _props$visibilityTogg = props.visibilityToggle, visibilityToggle = _props$visibilityTogg === void 0 ? true : _props$visibilityTogg;
    var visibilityControlled = (0, $5KhTJ.default)(visibilityToggle) === 'object' && visibilityToggle.visible !== undefined;
    var _useState = (0, $6fFrj.useState)(function() {
        return visibilityControlled ? visibilityToggle.visible : false;
    }), _useState2 = (0, $jP8CL.default)(_useState, 2), visible = _useState2[0], setVisible = _useState2[1];
    var inputRef = (0, $6fFrj.useRef)(null);
    $6fFrj.useEffect(function() {
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    var removePasswordTimeout = (0, $96f60ff10b537cc4$export$2e2bcd8739ae039)(inputRef);
    var onVisibleChange = function onVisibleChange() {
        var disabled = props.disabled;
        if (disabled) return;
        if (visible) removePasswordTimeout();
        setVisible(function(prevState) {
            var _a;
            var newState = !prevState;
            if ((0, $5KhTJ.default)(visibilityToggle) === 'object') (_a = visibilityToggle.onVisibleChange) === null || _a === void 0 || _a.call(visibilityToggle, newState);
            return newState;
        });
    };
    var getIcon = function getIcon(prefixCls) {
        var _props$action = props.action, action = _props$action === void 0 ? 'click' : _props$action, _props$iconRender = props.iconRender, iconRender = _props$iconRender === void 0 ? $08e8bce0f00b7ee1$var$defaultIconRender : _props$iconRender;
        var iconTrigger = $08e8bce0f00b7ee1$var$ActionMap[action] || '';
        var icon = iconRender(visible);
        var iconProps = (0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, iconTrigger, onVisibleChange), "className", "".concat(prefixCls, "-icon")), "key", 'passwordIcon'), "onMouseDown", function onMouseDown(e) {
            // Prevent focused state lost
            // https://github.com/ant-design/ant-design/issues/15173
            e.preventDefault();
        }), "onMouseUp", function onMouseUp(e) {
            // Prevent caret position change
            // https://github.com/ant-design/ant-design/issues/23524
            e.preventDefault();
        });
        return /*#__PURE__*/ $6fFrj.cloneElement(/*#__PURE__*/ $6fFrj.isValidElement(icon) ? icon : /*#__PURE__*/ $6fFrj.createElement("span", null, icon), iconProps);
    };
    var renderPassword = function renderPassword(_ref) {
        var getPrefixCls = _ref.getPrefixCls;
        var className = props.className, customizePrefixCls = props.prefixCls, customizeInputPrefixCls = props.inputPrefixCls, size = props.size, restProps = $08e8bce0f00b7ee1$var$__rest(props, [
            "className",
            "prefixCls",
            "inputPrefixCls",
            "size"
        ]);
        var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
        var prefixCls = getPrefixCls('input-password', customizePrefixCls);
        var suffixIcon = visibilityToggle && getIcon(prefixCls);
        var inputClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, className, (0, $43449.default)({}, "".concat(prefixCls, "-").concat(size), !!size));
        var omittedProps = (0, $fIrcP.default)((0, $fIrcP.default)({}, (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(restProps, [
            'suffix',
            'iconRender',
            'visibilityToggle'
        ])), {
            type: visible ? 'text' : 'password',
            className: inputClassName,
            prefixCls: inputPrefixCls,
            suffix: suffixIcon
        });
        if (size) omittedProps.size = size;
        return /*#__PURE__*/ $6fFrj.createElement((0, $d283d087f79aff06$export$2e2bcd8739ae039), (0, $fIrcP.default)({
            ref: (0, $3BOWT.composeRef)(ref, inputRef)
        }, omittedProps));
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $1bdb4c3de815e386$export$cd5442f2b8da7663), null, renderPassword);
});
var $08e8bce0f00b7ee1$export$2e2bcd8739ae039 = $08e8bce0f00b7ee1$var$Password;



var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");


var $fActo = parcelRequire("fActo");

var $3BOWT = parcelRequire("3BOWT");

var $6fFrj = parcelRequire("6fFrj");






var $3fa9fbaf0b48cb55$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3fa9fbaf0b48cb55$var$Search = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var customizePrefixCls = props.prefixCls, customizeInputPrefixCls = props.inputPrefixCls, className = props.className, customizeSize = props.size, suffix = props.suffix, _props$enterButton = props.enterButton, enterButton = _props$enterButton === void 0 ? false : _props$enterButton, addonAfter = props.addonAfter, loading = props.loading, disabled = props.disabled, customOnSearch = props.onSearch, customOnChange = props.onChange, onCompositionStart = props.onCompositionStart, onCompositionEnd = props.onCompositionEnd, restProps = $3fa9fbaf0b48cb55$var$__rest(props, [
        "prefixCls",
        "inputPrefixCls",
        "className",
        "size",
        "suffix",
        "enterButton",
        "addonAfter",
        "loading",
        "disabled",
        "onSearch",
        "onChange",
        "onCompositionStart",
        "onCompositionEnd"
    ]);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var contextSize = $6fFrj.useContext((0, $aefad26b74860b7e$export$2e2bcd8739ae039));
    var composedRef = $6fFrj.useRef(false);
    var prefixCls = getPrefixCls('input-search', customizePrefixCls);
    var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    var _useCompactItemContex = (0, $87f4fe035d0a15fd$export$cd8cf9d7bab8dd4)(prefixCls, direction), compactSize = _useCompactItemContex.compactSize;
    var size = compactSize || customizeSize || contextSize;
    var inputRef = $6fFrj.useRef(null);
    var onChange = function onChange(e) {
        if (e && e.target && e.type === 'click' && customOnSearch) customOnSearch(e.target.value, e);
        if (customOnChange) customOnChange(e);
    };
    var onMouseDown = function onMouseDown(e) {
        var _a;
        if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) e.preventDefault();
    };
    var onSearch = function onSearch(e) {
        var _a, _b;
        if (customOnSearch) customOnSearch((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.value, e);
    };
    var onPressEnter = function onPressEnter(e) {
        if (composedRef.current || loading) return;
        onSearch(e);
    };
    var searchIcon = typeof enterButton === 'boolean' ? /*#__PURE__*/ $6fFrj.createElement((0, $37763468bed476f0$export$2e2bcd8739ae039), null) : null;
    var btnClassName = "".concat(prefixCls, "-button");
    var button;
    var enterButtonAsElement = enterButton || {};
    var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === 'button') button = (0, $79365009d9b77ac6$export$e530037191fcd5d7)(enterButtonAsElement, (0, $fIrcP.default)({
        onMouseDown: onMouseDown,
        onClick: function onClick(e) {
            var _a, _b;
            (_b = (_a = enterButtonAsElement === null || enterButtonAsElement === void 0 ? void 0 : enterButtonAsElement.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 || _b.call(_a, e);
            onSearch(e);
        },
        key: 'enterButton'
    }, isAntdButton ? {
        className: btnClassName,
        size: size
    } : {}));
    else button = /*#__PURE__*/ $6fFrj.createElement((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
        className: btnClassName,
        type: enterButton ? 'primary' : undefined,
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, $79365009d9b77ac6$export$e530037191fcd5d7)(addonAfter, {
            key: 'addonAfter'
        })
    ];
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, (0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'), "".concat(prefixCls, "-").concat(size), !!size), "".concat(prefixCls, "-with-button"), !!enterButton), className);
    var handleOnCompositionStart = function handleOnCompositionStart(e) {
        composedRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    var handleOnCompositionEnd = function handleOnCompositionEnd(e) {
        composedRef.current = false;
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    return /*#__PURE__*/ $6fFrj.createElement((0, $d283d087f79aff06$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        ref: (0, $3BOWT.composeRef)(inputRef, ref),
        onPressEnter: onPressEnter
    }, restProps, {
        size: size,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        prefixCls: inputPrefixCls,
        addonAfter: button,
        suffix: suffix,
        onChange: onChange,
        className: cls,
        disabled: disabled
    }));
});
var $3fa9fbaf0b48cb55$export$2e2bcd8739ae039 = $3fa9fbaf0b48cb55$var$Search;



var $9251a7488fdfff45$var$Input = (0, $d283d087f79aff06$export$2e2bcd8739ae039);
$9251a7488fdfff45$var$Input.Group = (0, $21f5bd0c7572f764$export$2e2bcd8739ae039);
$9251a7488fdfff45$var$Input.Search = (0, $3fa9fbaf0b48cb55$export$2e2bcd8739ae039);
$9251a7488fdfff45$var$Input.TextArea = (0, $c1a08c926cc02e95$export$2e2bcd8739ae039);
$9251a7488fdfff45$var$Input.Password = (0, $08e8bce0f00b7ee1$export$2e2bcd8739ae039);
var $9251a7488fdfff45$export$2e2bcd8739ae039 = $9251a7488fdfff45$var$Input;


function $c49f783d969aa32a$var$FilterSearch(_ref) {
    var value = _ref.value, onChange = _ref.onChange, filterSearch = _ref.filterSearch, tablePrefixCls = _ref.tablePrefixCls, locale = _ref.locale;
    if (!filterSearch) return null;
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(tablePrefixCls, "-filter-dropdown-search")
    }, /*#__PURE__*/ $6fFrj.createElement((0, $9251a7488fdfff45$export$2e2bcd8739ae039), {
        prefix: /*#__PURE__*/ $6fFrj.createElement((0, $37763468bed476f0$export$2e2bcd8739ae039), null),
        placeholder: locale.filterSearchPlaceholder,
        onChange: onChange,
        value: value,
        // for skip min-width of input
        htmlSize: 1,
        className: "".concat(tablePrefixCls, "-filter-dropdown-search-input")
    }));
}
var $c49f783d969aa32a$export$2e2bcd8739ae039 = $c49f783d969aa32a$var$FilterSearch;



var $6fFrj = parcelRequire("6fFrj");

var $535b5231af9416fa$var$onKeyDown = function onKeyDown(event) {
    var keyCode = event.keyCode;
    if (keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER) event.stopPropagation();
};
var $535b5231af9416fa$var$FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(props) {
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: props.className,
        onClick: function onClick(e) {
            return e.stopPropagation();
        },
        onKeyDown: $535b5231af9416fa$var$onKeyDown
    }, props.children);
};
var $535b5231af9416fa$export$2e2bcd8739ae039 = $535b5231af9416fa$var$FilterDropdownMenuWrapper;


function $b92b669c63495038$var$hasSubMenu(filters) {
    return filters.some(function(_ref) {
        var children = _ref.children;
        return children;
    });
}
function $b92b669c63495038$var$searchValueMatched(searchValue, text) {
    if (typeof text === 'string' || typeof text === 'number') return text === null || text === void 0 ? void 0 : text.toString().toLowerCase().includes(searchValue.trim().toLowerCase());
    return false;
}
function $b92b669c63495038$var$renderFilterItems(_ref2) {
    var filters = _ref2.filters, prefixCls = _ref2.prefixCls, filteredKeys = _ref2.filteredKeys, filterMultiple = _ref2.filterMultiple, searchValue = _ref2.searchValue, filterSearch = _ref2.filterSearch;
    return filters.map(function(filter, index) {
        var key = String(filter.value);
        if (filter.children) return {
            key: key || index,
            label: filter.text,
            popupClassName: "".concat(prefixCls, "-dropdown-submenu"),
            children: $b92b669c63495038$var$renderFilterItems({
                filters: filter.children,
                prefixCls: prefixCls,
                filteredKeys: filteredKeys,
                filterMultiple: filterMultiple,
                searchValue: searchValue,
                filterSearch: filterSearch
            })
        };
        var Component = filterMultiple ? (0, $66ef76fa6be8ca1a$export$2e2bcd8739ae039) : (0, $d2c10fe172769914$export$2e2bcd8739ae039);
        var item = {
            key: filter.value !== undefined ? key : index,
            label: /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, /*#__PURE__*/ $6fFrj.createElement(Component, {
                checked: filteredKeys.includes(key)
            }), /*#__PURE__*/ $6fFrj.createElement("span", null, filter.text))
        };
        if (searchValue.trim()) {
            if (typeof filterSearch === 'function') return filterSearch(searchValue, filter) ? item : null;
            return $b92b669c63495038$var$searchValueMatched(searchValue, filter.text) ? item : null;
        }
        return item;
    });
}
function $b92b669c63495038$var$wrapStringListType(keys) {
    return keys || [];
}
function $b92b669c63495038$var$FilterDropdown(props) {
    var _a;
    var tablePrefixCls = props.tablePrefixCls, prefixCls = props.prefixCls, column = props.column, dropdownPrefixCls = props.dropdownPrefixCls, columnKey = props.columnKey, filterMultiple = props.filterMultiple, _props$filterMode = props.filterMode, filterMode = _props$filterMode === void 0 ? 'menu' : _props$filterMode, _props$filterSearch = props.filterSearch, filterSearch = _props$filterSearch === void 0 ? false : _props$filterSearch, filterState = props.filterState, triggerFilter = props.triggerFilter, locale = props.locale, children = props.children, getPopupContainer = props.getPopupContainer;
    var filterDropdownOpen = column.filterDropdownOpen, onFilterDropdownOpenChange = column.onFilterDropdownOpenChange, filterDropdownVisible = column.filterDropdownVisible, onFilterDropdownVisibleChange = column.onFilterDropdownVisibleChange, filterResetToDefaultFilteredValue = column.filterResetToDefaultFilteredValue, defaultFilteredValue = column.defaultFilteredValue;
    var _React$useState = $6fFrj.useState(false), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), visible = _React$useState2[0], setVisible = _React$useState2[1];
    var filtered = !!(filterState && (((_a = filterState.filteredKeys) === null || _a === void 0 ? void 0 : _a.length) || filterState.forceFiltered));
    var triggerVisible = function triggerVisible(newVisible) {
        setVisible(newVisible);
        onFilterDropdownOpenChange === null || onFilterDropdownOpenChange === void 0 || onFilterDropdownOpenChange(newVisible);
        onFilterDropdownVisibleChange === null || onFilterDropdownVisibleChange === void 0 || onFilterDropdownVisibleChange(newVisible);
    };
    var mergedVisible;
    if (typeof filterDropdownOpen === 'boolean') mergedVisible = filterDropdownOpen;
    else mergedVisible = typeof filterDropdownVisible === 'boolean' ? filterDropdownVisible : visible;
    // ===================== Select Keys =====================
    var propFilteredKeys = filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys;
    var _useSyncState = (0, $25abd000707076af$export$2e2bcd8739ae039)($b92b669c63495038$var$wrapStringListType(propFilteredKeys)), _useSyncState2 = (0, $jP8CL.default)(_useSyncState, 2), getFilteredKeysSync = _useSyncState2[0], setFilteredKeysSync = _useSyncState2[1];
    var onSelectKeys = function onSelectKeys(_ref3) {
        var selectedKeys = _ref3.selectedKeys;
        setFilteredKeysSync(selectedKeys);
    };
    var onCheck = function onCheck(keys, _ref4) {
        var node = _ref4.node, checked = _ref4.checked;
        if (!filterMultiple) onSelectKeys({
            selectedKeys: checked && node.key ? [
                node.key
            ] : []
        });
        else onSelectKeys({
            selectedKeys: keys
        });
    };
    $6fFrj.useEffect(function() {
        if (!visible) return;
        onSelectKeys({
            selectedKeys: $b92b669c63495038$var$wrapStringListType(propFilteredKeys)
        });
    }, [
        propFilteredKeys
    ]);
    // ====================== Open Keys ======================
    var _React$useState3 = $6fFrj.useState([]), _React$useState4 = (0, $jP8CL.default)(_React$useState3, 2), openKeys = _React$useState4[0], setOpenKeys = _React$useState4[1];
    var onOpenChange = function onOpenChange(keys) {
        setOpenKeys(keys);
    };
    // search in tree mode column filter
    var _React$useState5 = $6fFrj.useState(''), _React$useState6 = (0, $jP8CL.default)(_React$useState5, 2), searchValue = _React$useState6[0], setSearchValue = _React$useState6[1];
    var onSearch = function onSearch(e) {
        var value = e.target.value;
        setSearchValue(value);
    };
    // clear search value after close filter dropdown
    $6fFrj.useEffect(function() {
        if (!visible) setSearchValue('');
    }, [
        visible
    ]);
    // ======================= Submit ========================
    var internalTriggerFilter = function internalTriggerFilter(keys) {
        var mergedKeys = keys && keys.length ? keys : null;
        if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) return null;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($0aaac3f8a867d076$exports)))(mergedKeys, filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys)) return null;
        triggerFilter({
            column: column,
            key: columnKey,
            filteredKeys: mergedKeys
        });
    };
    var onConfirm = function onConfirm() {
        triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    var onReset = function onReset() {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            confirm: false,
            closeDropdown: false
        }, confirm = _ref5.confirm, closeDropdown = _ref5.closeDropdown;
        if (confirm) internalTriggerFilter([]);
        if (closeDropdown) triggerVisible(false);
        setSearchValue('');
        if (filterResetToDefaultFilteredValue) setFilteredKeysSync((defaultFilteredValue || []).map(function(key) {
            return String(key);
        }));
        else setFilteredKeysSync([]);
    };
    var doFilter = function doFilter() {
        var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            closeDropdown: true
        }, closeDropdown = _ref6.closeDropdown;
        if (closeDropdown) triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    var onVisibleChange = function onVisibleChange(newVisible) {
        if (newVisible && propFilteredKeys !== undefined) // Sync filteredKeys on appear in controlled mode (propFilteredKeys !== undefiend)
        setFilteredKeysSync($b92b669c63495038$var$wrapStringListType(propFilteredKeys));
        triggerVisible(newVisible);
        // Default will filter when closed
        if (!newVisible && !column.filterDropdown) onConfirm();
    };
    // ======================== Style ========================
    var dropdownMenuClass = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)({}, "".concat(dropdownPrefixCls, "-menu-without-submenu"), !$b92b669c63495038$var$hasSubMenu(column.filters || [])));
    var onCheckAll = function onCheckAll(e) {
        if (e.target.checked) {
            var allFilterKeys = (0, $8bace871b9ed5b3b$export$50792ddeed01ab0a)(column === null || column === void 0 ? void 0 : column.filters).map(function(key) {
                return String(key);
            });
            setFilteredKeysSync(allFilterKeys);
        } else setFilteredKeysSync([]);
    };
    var getTreeData = function getTreeData(_ref7) {
        var filters = _ref7.filters;
        return (filters || []).map(function(filter, index) {
            var key = String(filter.value);
            var item = {
                title: filter.text,
                key: filter.value !== undefined ? key : String(index)
            };
            if (filter.children) item.children = getTreeData({
                filters: filter.children
            });
            return item;
        });
    };
    var getFilterData = function getFilterData(node) {
        var _a;
        return (0, $fIrcP.default)((0, $fIrcP.default)({}, node), {
            text: node.title,
            value: node.key,
            children: ((_a = node.children) === null || _a === void 0 ? void 0 : _a.map(function(item) {
                return getFilterData(item);
            })) || []
        });
    };
    var dropdownContent;
    if (typeof column.filterDropdown === 'function') dropdownContent = column.filterDropdown({
        prefixCls: "".concat(dropdownPrefixCls, "-custom"),
        setSelectedKeys: function setSelectedKeys(selectedKeys) {
            return onSelectKeys({
                selectedKeys: selectedKeys
            });
        },
        selectedKeys: getFilteredKeysSync(),
        confirm: doFilter,
        clearFilters: onReset,
        filters: column.filters,
        visible: mergedVisible,
        close: function close() {
            triggerVisible(false);
        }
    });
    else if (column.filterDropdown) dropdownContent = column.filterDropdown;
    else {
        var selectedKeys = getFilteredKeysSync() || [];
        var getFilterComponent = function getFilterComponent() {
            if ((column.filters || []).length === 0) return /*#__PURE__*/ $6fFrj.createElement((0, $9150234f0969a884$export$2e2bcd8739ae039), {
                image: (0, $9150234f0969a884$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                description: locale.filterEmptyText,
                imageStyle: {
                    height: 24
                },
                style: {
                    margin: 0,
                    padding: '16px 0'
                }
            });
            if (filterMode === 'tree') return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, /*#__PURE__*/ $6fFrj.createElement((0, $c49f783d969aa32a$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), /*#__PURE__*/ $6fFrj.createElement("div", {
                className: "".concat(tablePrefixCls, "-filter-dropdown-tree")
            }, filterMultiple ? /*#__PURE__*/ $6fFrj.createElement((0, $66ef76fa6be8ca1a$export$2e2bcd8739ae039), {
                checked: selectedKeys.length === (0, $8bace871b9ed5b3b$export$50792ddeed01ab0a)(column.filters).length,
                indeterminate: selectedKeys.length > 0 && selectedKeys.length < (0, $8bace871b9ed5b3b$export$50792ddeed01ab0a)(column.filters).length,
                className: "".concat(tablePrefixCls, "-filter-dropdown-checkall"),
                onChange: onCheckAll
            }, locale.filterCheckall) : null, /*#__PURE__*/ $6fFrj.createElement((0, $0dad0951e76ed555$export$2e2bcd8739ae039), {
                checkable: true,
                selectable: false,
                blockNode: true,
                multiple: filterMultiple,
                checkStrictly: !filterMultiple,
                className: "".concat(dropdownPrefixCls, "-menu"),
                onCheck: onCheck,
                checkedKeys: selectedKeys,
                selectedKeys: selectedKeys,
                showIcon: false,
                treeData: getTreeData({
                    filters: column.filters
                }),
                autoExpandParent: true,
                defaultExpandAll: true,
                filterTreeNode: searchValue.trim() ? function(node) {
                    if (typeof filterSearch === 'function') return filterSearch(searchValue, getFilterData(node));
                    return $b92b669c63495038$var$searchValueMatched(searchValue, node.title);
                } : undefined
            })));
            return /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, /*#__PURE__*/ $6fFrj.createElement((0, $c49f783d969aa32a$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), /*#__PURE__*/ $6fFrj.createElement((0, $d93242227496acaa$export$2e2bcd8739ae039), {
                selectable: true,
                multiple: filterMultiple,
                prefixCls: "".concat(dropdownPrefixCls, "-menu"),
                className: dropdownMenuClass,
                onSelect: onSelectKeys,
                onDeselect: onSelectKeys,
                selectedKeys: selectedKeys,
                getPopupContainer: getPopupContainer,
                openKeys: openKeys,
                onOpenChange: onOpenChange,
                items: $b92b669c63495038$var$renderFilterItems({
                    filters: column.filters || [],
                    filterSearch: filterSearch,
                    prefixCls: prefixCls,
                    filteredKeys: getFilteredKeysSync(),
                    filterMultiple: filterMultiple,
                    searchValue: searchValue
                })
            }));
        };
        var getResetDisabled = function getResetDisabled() {
            if (filterResetToDefaultFilteredValue) return (0, (/*@__PURE__*/$parcel$interopDefault($0aaac3f8a867d076$exports)))((defaultFilteredValue || []).map(function(key) {
                return String(key);
            }), selectedKeys);
            return selectedKeys.length === 0;
        };
        dropdownContent = /*#__PURE__*/ $6fFrj.createElement($6fFrj.Fragment, null, getFilterComponent(), /*#__PURE__*/ $6fFrj.createElement("div", {
            className: "".concat(prefixCls, "-dropdown-btns")
        }, /*#__PURE__*/ $6fFrj.createElement((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
            type: "link",
            size: "small",
            disabled: getResetDisabled(),
            onClick: function onClick() {
                return onReset();
            }
        }, locale.filterReset), /*#__PURE__*/ $6fFrj.createElement((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
            type: "primary",
            size: "small",
            onClick: onConfirm
        }, locale.filterConfirm)));
    }
    // We should not block customize Menu with additional props
    if (column.filterDropdown) dropdownContent = /*#__PURE__*/ $6fFrj.createElement((0, $d2b8d671bb21642d$export$9bd434816b0530d0), {
        selectable: undefined
    }, dropdownContent);
    var menu = function menu() {
        return /*#__PURE__*/ $6fFrj.createElement((0, $535b5231af9416fa$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-dropdown")
        }, dropdownContent);
    };
    var filterIcon;
    if (typeof column.filterIcon === 'function') filterIcon = column.filterIcon(filtered);
    else if (column.filterIcon) filterIcon = column.filterIcon;
    else filterIcon = /*#__PURE__*/ $6fFrj.createElement((0, $bf159c3c03590c56$export$2e2bcd8739ae039), null);
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), direction = _React$useContext.direction;
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        className: "".concat(prefixCls, "-column")
    }, /*#__PURE__*/ $6fFrj.createElement("span", {
        className: "".concat(tablePrefixCls, "-column-title")
    }, children), /*#__PURE__*/ $6fFrj.createElement((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        dropdownRender: menu,
        trigger: [
            'click'
        ],
        open: mergedVisible,
        onOpenChange: onVisibleChange,
        getPopupContainer: getPopupContainer,
        placement: direction === 'rtl' ? 'bottomLeft' : 'bottomRight'
    }, /*#__PURE__*/ $6fFrj.createElement("span", {
        role: "button",
        tabIndex: -1,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-trigger"), {
            active: filtered
        }),
        onClick: function onClick(e) {
            e.stopPropagation();
        }
    }, filterIcon)));
}
var $b92b669c63495038$export$2e2bcd8739ae039 = $b92b669c63495038$var$FilterDropdown;


function $8bace871b9ed5b3b$var$collectFilterStates(columns, init, pos) {
    var filterStates = [];
    (columns || []).forEach(function(column, index) {
        var _a;
        var columnPos = (0, $9660a16a644c556b$export$7e4db04adce9b4db)(index, pos);
        if (column.filters || 'filterDropdown' in column || 'onFilter' in column) {
            if ('filteredValue' in column) {
                // Controlled
                var filteredValues = column.filteredValue;
                if (!('filterDropdown' in column)) filteredValues = (_a = filteredValues === null || filteredValues === void 0 ? void 0 : filteredValues.map(String)) !== null && _a !== void 0 ? _a : filteredValues;
                filterStates.push({
                    column: column,
                    key: (0, $9660a16a644c556b$export$480219a02f196e72)(column, columnPos),
                    filteredKeys: filteredValues,
                    forceFiltered: column.filtered
                });
            } else // Uncontrolled
            filterStates.push({
                column: column,
                key: (0, $9660a16a644c556b$export$480219a02f196e72)(column, columnPos),
                filteredKeys: init && column.defaultFilteredValue ? column.defaultFilteredValue : undefined,
                forceFiltered: column.filtered
            });
        }
        if ('children' in column) filterStates = [].concat((0, $37xND.default)(filterStates), (0, $37xND.default)($8bace871b9ed5b3b$var$collectFilterStates(column.children, init, columnPos)));
    });
    return filterStates;
}
function $8bace871b9ed5b3b$var$injectFilter(prefixCls, dropdownPrefixCls, columns, filterStates, triggerFilter, getPopupContainer, locale, pos) {
    return columns.map(function(column, index) {
        var columnPos = (0, $9660a16a644c556b$export$7e4db04adce9b4db)(index, pos);
        var _column$filterMultipl = column.filterMultiple, filterMultiple = _column$filterMultipl === void 0 ? true : _column$filterMultipl, filterMode = column.filterMode, filterSearch = column.filterSearch;
        var newColumn = column;
        if (newColumn.filters || newColumn.filterDropdown) {
            var columnKey = (0, $9660a16a644c556b$export$480219a02f196e72)(newColumn, columnPos);
            var filterState = filterStates.find(function(_ref) {
                var key = _ref.key;
                return columnKey === key;
            });
            newColumn = (0, $fIrcP.default)((0, $fIrcP.default)({}, newColumn), {
                title: function title(renderProps) {
                    return /*#__PURE__*/ $6fFrj.createElement((0, $b92b669c63495038$export$2e2bcd8739ae039), {
                        tablePrefixCls: prefixCls,
                        prefixCls: "".concat(prefixCls, "-filter"),
                        dropdownPrefixCls: dropdownPrefixCls,
                        column: newColumn,
                        columnKey: columnKey,
                        filterState: filterState,
                        filterMultiple: filterMultiple,
                        filterMode: filterMode,
                        filterSearch: filterSearch,
                        triggerFilter: triggerFilter,
                        locale: locale,
                        getPopupContainer: getPopupContainer
                    }, (0, $9660a16a644c556b$export$cfda450db2088de7)(column.title, renderProps));
                }
            });
        }
        if ('children' in newColumn) newColumn = (0, $fIrcP.default)((0, $fIrcP.default)({}, newColumn), {
            children: $8bace871b9ed5b3b$var$injectFilter(prefixCls, dropdownPrefixCls, newColumn.children, filterStates, triggerFilter, getPopupContainer, locale, columnPos)
        });
        return newColumn;
    });
}
function $8bace871b9ed5b3b$export$50792ddeed01ab0a(filters) {
    var keys = [];
    (filters || []).forEach(function(_ref2) {
        var value = _ref2.value, children = _ref2.children;
        keys.push(value);
        if (children) keys = [].concat((0, $37xND.default)(keys), (0, $37xND.default)($8bace871b9ed5b3b$export$50792ddeed01ab0a(children)));
    });
    return keys;
}
function $8bace871b9ed5b3b$var$generateFilterInfo(filterStates) {
    var currentFilters = {};
    filterStates.forEach(function(_ref3) {
        var key = _ref3.key, filteredKeys = _ref3.filteredKeys, column = _ref3.column;
        var keyAsString = key;
        var filters = column.filters, filterDropdown = column.filterDropdown;
        if (filterDropdown) currentFilters[keyAsString] = filteredKeys || null;
        else if (Array.isArray(filteredKeys)) {
            var keys = $8bace871b9ed5b3b$export$50792ddeed01ab0a(filters);
            currentFilters[keyAsString] = keys.filter(function(originKey) {
                return filteredKeys.includes(String(originKey));
            });
        } else currentFilters[keyAsString] = null;
    });
    return currentFilters;
}
function $8bace871b9ed5b3b$export$37643bb40f4c1c56(data, filterStates) {
    return filterStates.reduce(function(currentData, filterState) {
        var _filterState$column = filterState.column, onFilter = _filterState$column.onFilter, filters = _filterState$column.filters, filteredKeys = filterState.filteredKeys;
        if (onFilter && filteredKeys && filteredKeys.length) return currentData.filter(function(record) {
            return filteredKeys.some(function(key) {
                var keys = $8bace871b9ed5b3b$export$50792ddeed01ab0a(filters);
                var keyIndex = keys.findIndex(function(k) {
                    return String(k) === String(key);
                });
                var realKey = keyIndex !== -1 ? keys[keyIndex] : key;
                return onFilter(realKey, record);
            });
        });
        return currentData;
    }, data);
}
function $8bace871b9ed5b3b$var$useFilter(_ref4) {
    var prefixCls = _ref4.prefixCls, dropdownPrefixCls = _ref4.dropdownPrefixCls, mergedColumns = _ref4.mergedColumns, onFilterChange = _ref4.onFilterChange, getPopupContainer = _ref4.getPopupContainer, tableLocale = _ref4.locale;
    var _React$useState = $6fFrj.useState(function() {
        return $8bace871b9ed5b3b$var$collectFilterStates(mergedColumns, true);
    }), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), filterStates = _React$useState2[0], setFilterStates = _React$useState2[1];
    var mergedFilterStates = $6fFrj.useMemo(function() {
        var collectedStates = $8bace871b9ed5b3b$var$collectFilterStates(mergedColumns, false);
        var filteredKeysIsAllNotControlled = true;
        var filteredKeysIsAllControlled = true;
        collectedStates.forEach(function(_ref5) {
            var filteredKeys = _ref5.filteredKeys;
            if (filteredKeys !== undefined) filteredKeysIsAllNotControlled = false;
            else filteredKeysIsAllControlled = false;
        });
        // Return if not controlled
        if (filteredKeysIsAllNotControlled) return filterStates;
        return collectedStates;
    }, [
        mergedColumns,
        filterStates
    ]);
    var filters = $6fFrj.useMemo(function() {
        return $8bace871b9ed5b3b$var$generateFilterInfo(mergedFilterStates);
    }, [
        mergedFilterStates
    ]);
    var triggerFilter = function triggerFilter(filterState) {
        var newFilterStates = mergedFilterStates.filter(function(_ref6) {
            var key = _ref6.key;
            return key !== filterState.key;
        });
        newFilterStates.push(filterState);
        setFilterStates(newFilterStates);
        onFilterChange($8bace871b9ed5b3b$var$generateFilterInfo(newFilterStates), newFilterStates);
    };
    var transformColumns = function transformColumns(innerColumns) {
        return $8bace871b9ed5b3b$var$injectFilter(prefixCls, dropdownPrefixCls, innerColumns, mergedFilterStates, triggerFilter, getPopupContainer, tableLocale);
    };
    return [
        transformColumns,
        mergedFilterStates,
        filters
    ];
}
var $8bace871b9ed5b3b$export$2e2bcd8739ae039 = $8bace871b9ed5b3b$var$useFilter;



var $5KhTJ = parcelRequire("5KhTJ");

var $6fFrj = parcelRequire("6fFrj");
function $89514f95ab0139cb$export$2e2bcd8739ae039(data, childrenColumnName, getRowKey) {
    var mapCacheRef = $6fFrj.useRef({});
    function getRecordByKey(key) {
        if (!mapCacheRef.current || mapCacheRef.current.data !== data || mapCacheRef.current.childrenColumnName !== childrenColumnName || mapCacheRef.current.getRowKey !== getRowKey) {
            var kvMap = new Map();
            /* eslint-disable no-inner-declarations */ function dig(records) {
                records.forEach(function(record, index) {
                    var rowKey = getRowKey(record, index);
                    kvMap.set(rowKey, record);
                    if (record && (0, $5KhTJ.default)(record) === 'object' && childrenColumnName in record) dig(record[childrenColumnName] || []);
                });
            }
            /* eslint-enable */ dig(data);
            mapCacheRef.current = {
                data: data,
                childrenColumnName: childrenColumnName,
                kvMap: kvMap,
                getRowKey: getRowKey
            };
        }
        return mapCacheRef.current.kvMap.get(key);
    }
    return [
        getRecordByKey
    ];
}



var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $5KhTJ = parcelRequire("5KhTJ");

var $6fFrj = parcelRequire("6fFrj");
var $288095e2cfe15a37$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $288095e2cfe15a37$export$5716e8bcb003888d = 10;
function $288095e2cfe15a37$export$27eceeed7bf0f4c2(pagination, mergedPagination) {
    var param = {
        current: mergedPagination.current,
        pageSize: mergedPagination.pageSize
    };
    var paginationObj = pagination && (0, $5KhTJ.default)(pagination) === 'object' ? pagination : {};
    Object.keys(paginationObj).forEach(function(pageProp) {
        var value = mergedPagination[pageProp];
        if (typeof value !== 'function') param[pageProp] = value;
    });
    return param;
}
function $288095e2cfe15a37$var$extendsObject() {
    var result = {};
    for(var _len = arguments.length, list = new Array(_len), _key = 0; _key < _len; _key++)list[_key] = arguments[_key];
    list.forEach(function(obj) {
        if (obj) Object.keys(obj).forEach(function(key) {
            var val = obj[key];
            if (val !== undefined) result[key] = val;
        });
    });
    return result;
}
function $288095e2cfe15a37$export$2e2bcd8739ae039(total, pagination, onChange) {
    var _a = pagination && (0, $5KhTJ.default)(pagination) === 'object' ? pagination : {}, _a$total = _a.total, paginationTotal = _a$total === void 0 ? 0 : _a$total, paginationObj = $288095e2cfe15a37$var$__rest(_a, [
        "total"
    ]);
    var _useState = (0, $6fFrj.useState)(function() {
        return {
            current: 'defaultCurrent' in paginationObj ? paginationObj.defaultCurrent : 1,
            pageSize: 'defaultPageSize' in paginationObj ? paginationObj.defaultPageSize : $288095e2cfe15a37$export$5716e8bcb003888d
        };
    }), _useState2 = (0, $jP8CL.default)(_useState, 2), innerPagination = _useState2[0], setInnerPagination = _useState2[1];
    // ============ Basic Pagination Config ============
    var mergedPagination = $288095e2cfe15a37$var$extendsObject(innerPagination, paginationObj, {
        total: paginationTotal > 0 ? paginationTotal : total
    });
    // Reset `current` if data length or pageSize changed
    var maxPage = Math.ceil((paginationTotal || total) / mergedPagination.pageSize);
    if (mergedPagination.current > maxPage) // Prevent a maximum page count of 0
    mergedPagination.current = maxPage || 1;
    var refreshPagination = function refreshPagination(current, pageSize) {
        setInnerPagination({
            current: current !== null && current !== void 0 ? current : 1,
            pageSize: pageSize || mergedPagination.pageSize
        });
    };
    var onInternalChange = function onInternalChange(current, pageSize) {
        var _a;
        if (pagination) (_a = pagination.onChange) === null || _a === void 0 || _a.call(pagination, current, pageSize);
        refreshPagination(current, pageSize);
        onChange(current, pageSize || (mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.pageSize));
    };
    if (pagination === false) return [
        {},
        function() {}
    ];
    return [
        (0, $fIrcP.default)((0, $fIrcP.default)({}, mergedPagination), {
            onChange: onInternalChange
        }),
        refreshPagination
    ];
}



var $43449 = parcelRequire("43449");

var $hFMPf = parcelRequire("hFMPf");

var $fIrcP = parcelRequire("fIrcP");

var $jP8CL = parcelRequire("jP8CL");

var $37xND = parcelRequire("37xND");

var $5KhTJ = parcelRequire("5KhTJ");






var $gfhff = parcelRequire("gfhff");

var $6fFrj = parcelRequire("6fFrj");




var $cf46a44a1c69f671$export$ed10248435b8f218 = {};
var $cf46a44a1c69f671$export$14159cd9e2a500c8 = 'SELECT_ALL';
var $cf46a44a1c69f671$export$625c4f68eaaf8cfd = 'SELECT_INVERT';
var $cf46a44a1c69f671$export$c1a725540f5a63bd = 'SELECT_NONE';
var $cf46a44a1c69f671$var$EMPTY_LIST = [];
function $cf46a44a1c69f671$var$flattenData(data, childrenColumnName) {
    var list = [];
    (data || []).forEach(function(record) {
        list.push(record);
        if (record && (0, $5KhTJ.default)(record) === 'object' && childrenColumnName in record) list = [].concat((0, $37xND.default)(list), (0, $37xND.default)($cf46a44a1c69f671$var$flattenData(record[childrenColumnName], childrenColumnName)));
    });
    return list;
}
function $cf46a44a1c69f671$export$2e2bcd8739ae039(rowSelection, config) {
    var _ref = rowSelection || {}, preserveSelectedRowKeys = _ref.preserveSelectedRowKeys, selectedRowKeys = _ref.selectedRowKeys, defaultSelectedRowKeys = _ref.defaultSelectedRowKeys, getCheckboxProps = _ref.getCheckboxProps, onSelectionChange = _ref.onChange, onSelect = _ref.onSelect, onSelectAll = _ref.onSelectAll, onSelectInvert = _ref.onSelectInvert, onSelectNone = _ref.onSelectNone, onSelectMultiple = _ref.onSelectMultiple, selectionColWidth = _ref.columnWidth, selectionType = _ref.type, selections = _ref.selections, fixed = _ref.fixed, customizeRenderCell = _ref.renderCell, hideSelectAll = _ref.hideSelectAll, _ref$checkStrictly = _ref.checkStrictly, checkStrictly = _ref$checkStrictly === void 0 ? true : _ref$checkStrictly;
    var prefixCls = config.prefixCls, data = config.data, pageData = config.pageData, getRecordByKey = config.getRecordByKey, getRowKey = config.getRowKey, expandType = config.expandType, childrenColumnName = config.childrenColumnName, tableLocale = config.locale, getPopupContainer = config.getPopupContainer;
    // ========================= Keys =========================
    var _useMergedState = (0, $gfhff.default)(selectedRowKeys || defaultSelectedRowKeys || $cf46a44a1c69f671$var$EMPTY_LIST, {
        value: selectedRowKeys
    }), _useMergedState2 = (0, $jP8CL.default)(_useMergedState, 2), mergedSelectedKeys = _useMergedState2[0], setMergedSelectedKeys = _useMergedState2[1];
    // ======================== Caches ========================
    var preserveRecordsRef = $6fFrj.useRef(new Map());
    var updatePreserveRecordsCache = (0, $6fFrj.useCallback)(function(keys) {
        if (preserveSelectedRowKeys) {
            var newCache = new Map();
            // Keep key if mark as preserveSelectedRowKeys
            keys.forEach(function(key) {
                var record = getRecordByKey(key);
                if (!record && preserveRecordsRef.current.has(key)) record = preserveRecordsRef.current.get(key);
                newCache.set(key, record);
            });
            // Refresh to new cache
            preserveRecordsRef.current = newCache;
        }
    }, [
        getRecordByKey,
        preserveSelectedRowKeys
    ]);
    // Update cache with selectedKeys
    $6fFrj.useEffect(function() {
        updatePreserveRecordsCache(mergedSelectedKeys);
    }, [
        mergedSelectedKeys
    ]);
    var _useMemo = (0, $6fFrj.useMemo)(function() {
        return checkStrictly ? {
            keyEntities: null
        } : (0, $35a937288f4ed5dd$export$e5d831ce033a4615)(data, {
            externalGetKey: getRowKey,
            childrenPropName: childrenColumnName
        });
    }, [
        data,
        getRowKey,
        checkStrictly,
        childrenColumnName
    ]), keyEntities = _useMemo.keyEntities;
    // Get flatten data
    var flattedData = (0, $6fFrj.useMemo)(function() {
        return $cf46a44a1c69f671$var$flattenData(pageData, childrenColumnName);
    }, [
        pageData,
        childrenColumnName
    ]);
    // Get all checkbox props
    var checkboxPropsMap = (0, $6fFrj.useMemo)(function() {
        var map = new Map();
        flattedData.forEach(function(record, index) {
            var key = getRowKey(record, index);
            var checkboxProps = (getCheckboxProps ? getCheckboxProps(record) : null) || {};
            map.set(key, checkboxProps);
        });
        return map;
    }, [
        flattedData,
        getRowKey,
        getCheckboxProps
    ]);
    var isCheckboxDisabled = (0, $6fFrj.useCallback)(function(r) {
        var _a;
        return !!((_a = checkboxPropsMap.get(getRowKey(r))) === null || _a === void 0 ? void 0 : _a.disabled);
    }, [
        checkboxPropsMap,
        getRowKey
    ]);
    var _useMemo2 = (0, $6fFrj.useMemo)(function() {
        if (checkStrictly) return [
            mergedSelectedKeys || [],
            []
        ];
        var _conductCheck = (0, $d68df472f315bb8e$export$43adf2c483e3e633)(mergedSelectedKeys, true, keyEntities, isCheckboxDisabled), checkedKeys = _conductCheck.checkedKeys, halfCheckedKeys = _conductCheck.halfCheckedKeys;
        return [
            checkedKeys || [],
            halfCheckedKeys
        ];
    }, [
        mergedSelectedKeys,
        checkStrictly,
        keyEntities,
        isCheckboxDisabled
    ]), _useMemo3 = (0, $jP8CL.default)(_useMemo2, 2), derivedSelectedKeys = _useMemo3[0], derivedHalfSelectedKeys = _useMemo3[1];
    var derivedSelectedKeySet = (0, $6fFrj.useMemo)(function() {
        var keys = selectionType === 'radio' ? derivedSelectedKeys.slice(0, 1) : derivedSelectedKeys;
        return new Set(keys);
    }, [
        derivedSelectedKeys,
        selectionType
    ]);
    var derivedHalfSelectedKeySet = (0, $6fFrj.useMemo)(function() {
        return selectionType === 'radio' ? new Set() : new Set(derivedHalfSelectedKeys);
    }, [
        derivedHalfSelectedKeys,
        selectionType
    ]);
    // Save last selected key to enable range selection
    var _useState = (0, $6fFrj.useState)(null), _useState2 = (0, $jP8CL.default)(_useState, 2), lastSelectedKey = _useState2[0], setLastSelectedKey = _useState2[1];
    // Reset if rowSelection reset
    $6fFrj.useEffect(function() {
        if (!rowSelection) setMergedSelectedKeys($cf46a44a1c69f671$var$EMPTY_LIST);
    }, [
        !!rowSelection
    ]);
    var setSelectedKeys = (0, $6fFrj.useCallback)(function(keys, method) {
        var availableKeys;
        var records;
        updatePreserveRecordsCache(keys);
        if (preserveSelectedRowKeys) {
            availableKeys = keys;
            records = keys.map(function(key) {
                return preserveRecordsRef.current.get(key);
            });
        } else {
            // Filter key which not exist in the `dataSource`
            availableKeys = [];
            records = [];
            keys.forEach(function(key) {
                var record = getRecordByKey(key);
                if (record !== undefined) {
                    availableKeys.push(key);
                    records.push(record);
                }
            });
        }
        setMergedSelectedKeys(availableKeys);
        onSelectionChange === null || onSelectionChange === void 0 || onSelectionChange(availableKeys, records, {
            type: method
        });
    }, [
        setMergedSelectedKeys,
        getRecordByKey,
        onSelectionChange,
        preserveSelectedRowKeys
    ]);
    // ====================== Selections ======================
    // Trigger single `onSelect` event
    var triggerSingleSelection = (0, $6fFrj.useCallback)(function(key, selected, keys, event) {
        if (onSelect) {
            var rows = keys.map(function(k) {
                return getRecordByKey(k);
            });
            onSelect(getRecordByKey(key), selected, rows, event);
        }
        setSelectedKeys(keys, 'single');
    }, [
        onSelect,
        getRecordByKey,
        setSelectedKeys
    ]);
    var mergedSelections = (0, $6fFrj.useMemo)(function() {
        if (!selections || hideSelectAll) return null;
        var selectionList = selections === true ? [
            $cf46a44a1c69f671$export$14159cd9e2a500c8,
            $cf46a44a1c69f671$export$625c4f68eaaf8cfd,
            $cf46a44a1c69f671$export$c1a725540f5a63bd
        ] : selections;
        return selectionList.map(function(selection) {
            if (selection === $cf46a44a1c69f671$export$14159cd9e2a500c8) return {
                key: 'all',
                text: tableLocale.selectionAll,
                onSelect: function onSelect() {
                    setSelectedKeys(data.map(function(record, index) {
                        return getRowKey(record, index);
                    }).filter(function(key) {
                        var checkProps = checkboxPropsMap.get(key);
                        return !(checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled) || derivedSelectedKeySet.has(key);
                    }), 'all');
                }
            };
            if (selection === $cf46a44a1c69f671$export$625c4f68eaaf8cfd) return {
                key: 'invert',
                text: tableLocale.selectInvert,
                onSelect: function onSelect() {
                    var keySet = new Set(derivedSelectedKeySet);
                    pageData.forEach(function(record, index) {
                        var key = getRowKey(record, index);
                        var checkProps = checkboxPropsMap.get(key);
                        if (!(checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled)) {
                            if (keySet.has(key)) keySet["delete"](key);
                            else keySet.add(key);
                        }
                    });
                    var keys = Array.from(keySet);
                    if (onSelectInvert) onSelectInvert(keys);
                    setSelectedKeys(keys, 'invert');
                }
            };
            if (selection === $cf46a44a1c69f671$export$c1a725540f5a63bd) return {
                key: 'none',
                text: tableLocale.selectNone,
                onSelect: function onSelect() {
                    onSelectNone === null || onSelectNone === void 0 || onSelectNone();
                    setSelectedKeys(Array.from(derivedSelectedKeySet).filter(function(key) {
                        var checkProps = checkboxPropsMap.get(key);
                        return checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled;
                    }), 'none');
                }
            };
            return selection;
        }).map(function(selection) {
            return (0, $fIrcP.default)((0, $fIrcP.default)({}, selection), {
                onSelect: function onSelect() {
                    var _a2;
                    var _a;
                    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++)rest[_key] = arguments[_key];
                    (_a = selection.onSelect) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                        selection
                    ].concat(rest));
                    setLastSelectedKey(null);
                }
            });
        });
    }, [
        selections,
        derivedSelectedKeySet,
        pageData,
        getRowKey,
        onSelectInvert,
        setSelectedKeys
    ]);
    // ======================= Columns ========================
    var transformColumns = (0, $6fFrj.useCallback)(function(columns) {
        var _a;
        // >>>>>>>>>>> Skip if not exists `rowSelection`
        if (!rowSelection) return columns.filter(function(col) {
            return col !== $cf46a44a1c69f671$export$ed10248435b8f218;
        });
        // >>>>>>>>>>> Support selection
        var cloneColumns = (0, $37xND.default)(columns);
        var keySet = new Set(derivedSelectedKeySet);
        // Record key only need check with enabled
        var recordKeys = flattedData.map(getRowKey).filter(function(key) {
            return !checkboxPropsMap.get(key).disabled;
        });
        var checkedCurrentAll = recordKeys.every(function(key) {
            return keySet.has(key);
        });
        var checkedCurrentSome = recordKeys.some(function(key) {
            return keySet.has(key);
        });
        var onSelectAllChange = function onSelectAllChange() {
            var changeKeys = [];
            if (checkedCurrentAll) recordKeys.forEach(function(key) {
                keySet["delete"](key);
                changeKeys.push(key);
            });
            else recordKeys.forEach(function(key) {
                if (!keySet.has(key)) {
                    keySet.add(key);
                    changeKeys.push(key);
                }
            });
            var keys = Array.from(keySet);
            onSelectAll === null || onSelectAll === void 0 || onSelectAll(!checkedCurrentAll, keys.map(function(k) {
                return getRecordByKey(k);
            }), changeKeys.map(function(k) {
                return getRecordByKey(k);
            }));
            setSelectedKeys(keys, 'all');
            setLastSelectedKey(null);
        };
        // ===================== Render =====================
        // Title Cell
        var title;
        if (selectionType !== 'radio') {
            var customizeSelections;
            if (mergedSelections) {
                var menu = {
                    getPopupContainer: getPopupContainer,
                    items: mergedSelections.map(function(selection, index) {
                        var key = selection.key, text = selection.text, onSelectionClick = selection.onSelect;
                        return {
                            key: key || index,
                            onClick: function onClick() {
                                onSelectionClick === null || onSelectionClick === void 0 || onSelectionClick(recordKeys);
                            },
                            label: text
                        };
                    })
                };
                customizeSelections = /*#__PURE__*/ $6fFrj.createElement("div", {
                    className: "".concat(prefixCls, "-selection-extra")
                }, /*#__PURE__*/ $6fFrj.createElement((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
                    menu: menu,
                    getPopupContainer: getPopupContainer
                }, /*#__PURE__*/ $6fFrj.createElement("span", null, /*#__PURE__*/ $6fFrj.createElement((0, $344ef0cbd3adff87$export$2e2bcd8739ae039), null))));
            }
            var allDisabledData = flattedData.map(function(record, index) {
                var key = getRowKey(record, index);
                var checkboxProps = checkboxPropsMap.get(key) || {};
                return (0, $fIrcP.default)({
                    checked: keySet.has(key)
                }, checkboxProps);
            }).filter(function(_ref2) {
                var disabled = _ref2.disabled;
                return disabled;
            });
            var allDisabled = !!allDisabledData.length && allDisabledData.length === flattedData.length;
            var allDisabledAndChecked = allDisabled && allDisabledData.every(function(_ref3) {
                var checked = _ref3.checked;
                return checked;
            });
            var allDisabledSomeChecked = allDisabled && allDisabledData.some(function(_ref4) {
                var checked = _ref4.checked;
                return checked;
            });
            title = !hideSelectAll && /*#__PURE__*/ $6fFrj.createElement("div", {
                className: "".concat(prefixCls, "-selection")
            }, /*#__PURE__*/ $6fFrj.createElement((0, $66ef76fa6be8ca1a$export$2e2bcd8739ae039), {
                checked: !allDisabled ? !!flattedData.length && checkedCurrentAll : allDisabledAndChecked,
                indeterminate: !allDisabled ? !checkedCurrentAll && checkedCurrentSome : !allDisabledAndChecked && allDisabledSomeChecked,
                onChange: onSelectAllChange,
                disabled: flattedData.length === 0 || allDisabled,
                "aria-label": customizeSelections ? 'Custom selection' : 'Select all',
                skipGroup: true
            }), customizeSelections);
        }
        // Body Cell
        var renderCell;
        if (selectionType === 'radio') renderCell = function renderCell(_, record, index) {
            var key = getRowKey(record, index);
            var checked = keySet.has(key);
            return {
                node: /*#__PURE__*/ $6fFrj.createElement((0, $d2c10fe172769914$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, checkboxPropsMap.get(key), {
                    checked: checked,
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    },
                    onChange: function onChange(event) {
                        if (!keySet.has(key)) triggerSingleSelection(key, true, [
                            key
                        ], event.nativeEvent);
                    }
                })),
                checked: checked
            };
        };
        else renderCell = function renderCell(_, record, index) {
            var _a;
            var key = getRowKey(record, index);
            var checked = keySet.has(key);
            var indeterminate = derivedHalfSelectedKeySet.has(key);
            var checkboxProps = checkboxPropsMap.get(key);
            var mergedIndeterminate;
            if (expandType === 'nest') mergedIndeterminate = indeterminate;
            else mergedIndeterminate = (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.indeterminate) !== null && _a !== void 0 ? _a : indeterminate;
            // Record checked
            return {
                node: /*#__PURE__*/ $6fFrj.createElement((0, $66ef76fa6be8ca1a$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, checkboxProps, {
                    indeterminate: mergedIndeterminate,
                    checked: checked,
                    skipGroup: true,
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    },
                    onChange: function onChange(_ref5) {
                        var nativeEvent = _ref5.nativeEvent;
                        var shiftKey = nativeEvent.shiftKey;
                        var startIndex = -1;
                        var endIndex = -1;
                        // Get range of this
                        if (shiftKey && checkStrictly) {
                            var pointKeys = new Set([
                                lastSelectedKey,
                                key
                            ]);
                            recordKeys.some(function(recordKey, recordIndex) {
                                if (pointKeys.has(recordKey)) {
                                    if (startIndex === -1) startIndex = recordIndex;
                                    else {
                                        endIndex = recordIndex;
                                        return true;
                                    }
                                }
                                return false;
                            });
                        }
                        if (endIndex !== -1 && startIndex !== endIndex && checkStrictly) {
                            // Batch update selections
                            var rangeKeys = recordKeys.slice(startIndex, endIndex + 1);
                            var changedKeys = [];
                            if (checked) rangeKeys.forEach(function(recordKey) {
                                if (keySet.has(recordKey)) {
                                    changedKeys.push(recordKey);
                                    keySet["delete"](recordKey);
                                }
                            });
                            else rangeKeys.forEach(function(recordKey) {
                                if (!keySet.has(recordKey)) {
                                    changedKeys.push(recordKey);
                                    keySet.add(recordKey);
                                }
                            });
                            var keys = Array.from(keySet);
                            onSelectMultiple === null || onSelectMultiple === void 0 || onSelectMultiple(!checked, keys.map(function(recordKey) {
                                return getRecordByKey(recordKey);
                            }), changedKeys.map(function(recordKey) {
                                return getRecordByKey(recordKey);
                            }));
                            setSelectedKeys(keys, 'multiple');
                        } else {
                            // Single record selected
                            var originCheckedKeys = derivedSelectedKeys;
                            if (checkStrictly) {
                                var checkedKeys = checked ? (0, $aa69ce1278dbe319$export$5bfb9ff497fe2298)(originCheckedKeys, key) : (0, $aa69ce1278dbe319$export$10663f6bbd2fd717)(originCheckedKeys, key);
                                triggerSingleSelection(key, !checked, checkedKeys, nativeEvent);
                            } else {
                                // Always fill first
                                var result = (0, $d68df472f315bb8e$export$43adf2c483e3e633)([].concat((0, $37xND.default)(originCheckedKeys), [
                                    key
                                ]), true, keyEntities, isCheckboxDisabled);
                                var _checkedKeys = result.checkedKeys, halfCheckedKeys = result.halfCheckedKeys;
                                var nextCheckedKeys = _checkedKeys;
                                // If remove, we do it again to correction
                                if (checked) {
                                    var tempKeySet = new Set(_checkedKeys);
                                    tempKeySet["delete"](key);
                                    nextCheckedKeys = (0, $d68df472f315bb8e$export$43adf2c483e3e633)(Array.from(tempKeySet), {
                                        checked: false,
                                        halfCheckedKeys: halfCheckedKeys
                                    }, keyEntities, isCheckboxDisabled).checkedKeys;
                                }
                                triggerSingleSelection(key, !checked, nextCheckedKeys, nativeEvent);
                            }
                        }
                        if (checked) setLastSelectedKey(null);
                        else setLastSelectedKey(key);
                    }
                })),
                checked: checked
            };
        };
        var renderSelectionCell = function renderSelectionCell(_, record, index) {
            var _renderCell = renderCell(_, record, index), node = _renderCell.node, checked = _renderCell.checked;
            if (customizeRenderCell) return customizeRenderCell(checked, record, index, node);
            return node;
        };
        // Insert selection column if not exist
        if (!cloneColumns.includes($cf46a44a1c69f671$export$ed10248435b8f218)) {
            // Always after expand icon
            if (cloneColumns.findIndex(function(col) {
                var _a;
                return ((_a = col[0, $91cd49b10058c8a6$export$f8dba99c0d5b6b87]) === null || _a === void 0 ? void 0 : _a.columnType) === 'EXPAND_COLUMN';
            }) === 0) {
                var _cloneColumns = cloneColumns, _cloneColumns2 = (0, $hFMPf.default)(_cloneColumns), expandColumn = _cloneColumns2[0], restColumns = _cloneColumns2.slice(1);
                cloneColumns = [
                    expandColumn,
                    $cf46a44a1c69f671$export$ed10248435b8f218
                ].concat((0, $37xND.default)(restColumns));
            } else // Normal insert at first column
            cloneColumns = [
                $cf46a44a1c69f671$export$ed10248435b8f218
            ].concat((0, $37xND.default)(cloneColumns));
        }
        // Deduplicate selection column
        var selectionColumnIndex = cloneColumns.indexOf($cf46a44a1c69f671$export$ed10248435b8f218);
        cloneColumns = cloneColumns.filter(function(column, index) {
            return column !== $cf46a44a1c69f671$export$ed10248435b8f218 || index === selectionColumnIndex;
        });
        // Fixed column logic
        var prevCol = cloneColumns[selectionColumnIndex - 1];
        var nextCol = cloneColumns[selectionColumnIndex + 1];
        var mergedFixed = fixed;
        if (mergedFixed === undefined) {
            if ((nextCol === null || nextCol === void 0 ? void 0 : nextCol.fixed) !== undefined) mergedFixed = nextCol.fixed;
            else if ((prevCol === null || prevCol === void 0 ? void 0 : prevCol.fixed) !== undefined) mergedFixed = prevCol.fixed;
        }
        if (mergedFixed && prevCol && ((_a = prevCol[0, $91cd49b10058c8a6$export$f8dba99c0d5b6b87]) === null || _a === void 0 ? void 0 : _a.columnType) === 'EXPAND_COLUMN' && prevCol.fixed === undefined) prevCol.fixed = mergedFixed;
        // Replace with real selection column
        var selectionColumn = (0, $43449.default)({
            fixed: mergedFixed,
            width: selectionColWidth,
            className: "".concat(prefixCls, "-selection-column"),
            title: rowSelection.columnTitle || title,
            render: renderSelectionCell
        }, (0, $91cd49b10058c8a6$export$f8dba99c0d5b6b87), {
            className: "".concat(prefixCls, "-selection-col")
        });
        return cloneColumns.map(function(col) {
            return col === $cf46a44a1c69f671$export$ed10248435b8f218 ? selectionColumn : col;
        });
    }, [
        getRowKey,
        flattedData,
        rowSelection,
        derivedSelectedKeys,
        derivedSelectedKeySet,
        derivedHalfSelectedKeySet,
        selectionColWidth,
        mergedSelections,
        expandType,
        lastSelectedKey,
        checkboxPropsMap,
        onSelectMultiple,
        triggerSingleSelection,
        isCheckboxDisabled
    ]);
    return [
        transformColumns,
        derivedSelectedKeySet
    ];
}



var $jP8CL = parcelRequire("jP8CL");

var $43449 = parcelRequire("43449");

var $fIrcP = parcelRequire("fIrcP");

var $37xND = parcelRequire("37xND");

var $5KhTJ = parcelRequire("5KhTJ");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $cc69c0d4628b3266$var$CaretDownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "outlined"
};
var $cc69c0d4628b3266$export$2e2bcd8739ae039 = $cc69c0d4628b3266$var$CaretDownOutlined;



var $68897272bf30099a$var$CaretDownOutlined = function CaretDownOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $cc69c0d4628b3266$export$2e2bcd8739ae039)
    }));
};
var $68897272bf30099a$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($68897272bf30099a$var$CaretDownOutlined);
var $68897272bf30099a$export$2e2bcd8739ae039 = $68897272bf30099a$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $c61fe5bc98e04c22$var$CaretUpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
                }
            }
        ]
    },
    "name": "caret-up",
    "theme": "outlined"
};
var $c61fe5bc98e04c22$export$2e2bcd8739ae039 = $c61fe5bc98e04c22$var$CaretUpOutlined;



var $e1ecab95285b9ebd$var$CaretUpOutlined = function CaretUpOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $c61fe5bc98e04c22$export$2e2bcd8739ae039)
    }));
};
var $e1ecab95285b9ebd$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($e1ecab95285b9ebd$var$CaretUpOutlined);
var $e1ecab95285b9ebd$export$2e2bcd8739ae039 = $e1ecab95285b9ebd$var$RefIcon;



var $fActo = parcelRequire("fActo");


var $6fFrj = parcelRequire("6fFrj");


var $11141e3afc7b4afe$var$ASCEND = 'ascend';
var $11141e3afc7b4afe$var$DESCEND = 'descend';
function $11141e3afc7b4afe$var$getMultiplePriority(column) {
    if ((0, $5KhTJ.default)(column.sorter) === 'object' && typeof column.sorter.multiple === 'number') return column.sorter.multiple;
    return false;
}
function $11141e3afc7b4afe$var$getSortFunction(sorter) {
    if (typeof sorter === 'function') return sorter;
    if (sorter && (0, $5KhTJ.default)(sorter) === 'object' && sorter.compare) return sorter.compare;
    return false;
}
function $11141e3afc7b4afe$var$nextSortDirection(sortDirections, current) {
    if (!current) return sortDirections[0];
    return sortDirections[sortDirections.indexOf(current) + 1];
}
function $11141e3afc7b4afe$var$collectSortStates(columns, init, pos) {
    var sortStates = [];
    function pushState(column, columnPos) {
        sortStates.push({
            column: column,
            key: (0, $9660a16a644c556b$export$480219a02f196e72)(column, columnPos),
            multiplePriority: $11141e3afc7b4afe$var$getMultiplePriority(column),
            sortOrder: column.sortOrder
        });
    }
    (columns || []).forEach(function(column, index) {
        var columnPos = (0, $9660a16a644c556b$export$7e4db04adce9b4db)(index, pos);
        if (column.children) {
            if ('sortOrder' in column) // Controlled
            pushState(column, columnPos);
            sortStates = [].concat((0, $37xND.default)(sortStates), (0, $37xND.default)($11141e3afc7b4afe$var$collectSortStates(column.children, init, columnPos)));
        } else if (column.sorter) {
            if ('sortOrder' in column) // Controlled
            pushState(column, columnPos);
            else if (init && column.defaultSortOrder) // Default sorter
            sortStates.push({
                column: column,
                key: (0, $9660a16a644c556b$export$480219a02f196e72)(column, columnPos),
                multiplePriority: $11141e3afc7b4afe$var$getMultiplePriority(column),
                sortOrder: column.defaultSortOrder
            });
        }
    });
    return sortStates;
}
function $11141e3afc7b4afe$var$injectSorter(prefixCls, columns, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, pos) {
    return (columns || []).map(function(column, index) {
        var columnPos = (0, $9660a16a644c556b$export$7e4db04adce9b4db)(index, pos);
        var newColumn = column;
        if (newColumn.sorter) {
            var sortDirections = newColumn.sortDirections || defaultSortDirections;
            var showSorterTooltip = newColumn.showSorterTooltip === undefined ? tableShowSorterTooltip : newColumn.showSorterTooltip;
            var columnKey = (0, $9660a16a644c556b$export$480219a02f196e72)(newColumn, columnPos);
            var sorterState = sorterStates.find(function(_ref) {
                var key = _ref.key;
                return key === columnKey;
            });
            var sorterOrder = sorterState ? sorterState.sortOrder : null;
            var nextSortOrder = $11141e3afc7b4afe$var$nextSortDirection(sortDirections, sorterOrder);
            var upNode = sortDirections.includes($11141e3afc7b4afe$var$ASCEND) && /*#__PURE__*/ $6fFrj.createElement((0, $e1ecab95285b9ebd$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-column-sorter-up"), {
                    active: sorterOrder === $11141e3afc7b4afe$var$ASCEND
                }),
                role: "presentation"
            });
            var downNode = sortDirections.includes($11141e3afc7b4afe$var$DESCEND) && /*#__PURE__*/ $6fFrj.createElement((0, $68897272bf30099a$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-column-sorter-down"), {
                    active: sorterOrder === $11141e3afc7b4afe$var$DESCEND
                }),
                role: "presentation"
            });
            var _ref2 = tableLocale || {}, cancelSort = _ref2.cancelSort, triggerAsc = _ref2.triggerAsc, triggerDesc = _ref2.triggerDesc;
            var sortTip = cancelSort;
            if (nextSortOrder === $11141e3afc7b4afe$var$DESCEND) sortTip = triggerDesc;
            else if (nextSortOrder === $11141e3afc7b4afe$var$ASCEND) sortTip = triggerAsc;
            var tooltipProps = (0, $5KhTJ.default)(showSorterTooltip) === 'object' ? showSorterTooltip : {
                title: sortTip
            };
            newColumn = (0, $fIrcP.default)((0, $fIrcP.default)({}, newColumn), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(newColumn.className, (0, $43449.default)({}, "".concat(prefixCls, "-column-sort"), sorterOrder)),
                title: function title(renderProps) {
                    var renderSortTitle = /*#__PURE__*/ $6fFrj.createElement("div", {
                        className: "".concat(prefixCls, "-column-sorters")
                    }, /*#__PURE__*/ $6fFrj.createElement("span", {
                        className: "".concat(prefixCls, "-column-title")
                    }, (0, $9660a16a644c556b$export$cfda450db2088de7)(column.title, renderProps)), /*#__PURE__*/ $6fFrj.createElement("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-column-sorter"), (0, $43449.default)({}, "".concat(prefixCls, "-column-sorter-full"), !!(upNode && downNode)))
                    }, /*#__PURE__*/ $6fFrj.createElement("span", {
                        className: "".concat(prefixCls, "-column-sorter-inner")
                    }, upNode, downNode)));
                    return showSorterTooltip ? /*#__PURE__*/ $6fFrj.createElement((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, tooltipProps), renderSortTitle) : renderSortTitle;
                },
                onHeaderCell: function onHeaderCell(col) {
                    var cell = column.onHeaderCell && column.onHeaderCell(col) || {};
                    var originOnClick = cell.onClick;
                    var originOKeyDown = cell.onKeyDown;
                    cell.onClick = function(event) {
                        triggerSorter({
                            column: column,
                            key: columnKey,
                            sortOrder: nextSortOrder,
                            multiplePriority: $11141e3afc7b4afe$var$getMultiplePriority(column)
                        });
                        originOnClick === null || originOnClick === void 0 || originOnClick(event);
                    };
                    cell.onKeyDown = function(event) {
                        if (event.keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).ENTER) {
                            triggerSorter({
                                column: column,
                                key: columnKey,
                                sortOrder: nextSortOrder,
                                multiplePriority: $11141e3afc7b4afe$var$getMultiplePriority(column)
                            });
                            originOKeyDown === null || originOKeyDown === void 0 || originOKeyDown(event);
                        }
                    };
                    var renderTitle = (0, $9660a16a644c556b$export$1c24e0676a106839)(column.title, {});
                    var displayTitle = renderTitle === null || renderTitle === void 0 ? void 0 : renderTitle.toString();
                    // Inform the screen-reader so it can tell the visually impaired user which column is sorted
                    if (sorterOrder) cell['aria-sort'] = sorterOrder === 'ascend' ? 'ascending' : 'descending';
                    else cell['aria-label'] = displayTitle || '';
                    cell.className = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(cell.className, "".concat(prefixCls, "-column-has-sorters"));
                    cell.tabIndex = 0;
                    if (column.ellipsis) cell.title = (renderTitle !== null && renderTitle !== void 0 ? renderTitle : '').toString();
                    return cell;
                }
            });
        }
        if ('children' in newColumn) newColumn = (0, $fIrcP.default)((0, $fIrcP.default)({}, newColumn), {
            children: $11141e3afc7b4afe$var$injectSorter(prefixCls, newColumn.children, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, columnPos)
        });
        return newColumn;
    });
}
function $11141e3afc7b4afe$var$stateToInfo(sorterStates) {
    var column = sorterStates.column, sortOrder = sorterStates.sortOrder;
    return {
        column: column,
        order: sortOrder,
        field: column.dataIndex,
        columnKey: column.key
    };
}
function $11141e3afc7b4afe$var$generateSorterInfo(sorterStates) {
    var list = sorterStates.filter(function(_ref3) {
        var sortOrder = _ref3.sortOrder;
        return sortOrder;
    }).map($11141e3afc7b4afe$var$stateToInfo);
    // =========== Legacy compatible support ===========
    // https://github.com/ant-design/ant-design/pull/19226
    if (list.length === 0 && sorterStates.length) return (0, $fIrcP.default)((0, $fIrcP.default)({}, $11141e3afc7b4afe$var$stateToInfo(sorterStates[sorterStates.length - 1])), {
        column: undefined
    });
    if (list.length <= 1) return list[0] || {};
    return list;
}
function $11141e3afc7b4afe$export$594b2c8da4a70ee(data, sortStates, childrenColumnName) {
    var innerSorterStates = sortStates.slice().sort(function(a, b) {
        return b.multiplePriority - a.multiplePriority;
    });
    var cloneData = data.slice();
    var runningSorters = innerSorterStates.filter(function(_ref4) {
        var sorter = _ref4.column.sorter, sortOrder = _ref4.sortOrder;
        return $11141e3afc7b4afe$var$getSortFunction(sorter) && sortOrder;
    });
    // Skip if no sorter needed
    if (!runningSorters.length) return cloneData;
    return cloneData.sort(function(record1, record2) {
        for(var i = 0; i < runningSorters.length; i += 1){
            var sorterState = runningSorters[i];
            var sorter = sorterState.column.sorter, sortOrder = sorterState.sortOrder;
            var compareFn = $11141e3afc7b4afe$var$getSortFunction(sorter);
            if (compareFn && sortOrder) {
                var compareResult = compareFn(record1, record2, sortOrder);
                if (compareResult !== 0) return sortOrder === $11141e3afc7b4afe$var$ASCEND ? compareResult : -compareResult;
            }
        }
        return 0;
    }).map(function(record) {
        var subRecords = record[childrenColumnName];
        if (subRecords) return (0, $fIrcP.default)((0, $fIrcP.default)({}, record), (0, $43449.default)({}, childrenColumnName, $11141e3afc7b4afe$export$594b2c8da4a70ee(subRecords, sortStates, childrenColumnName)));
        return record;
    });
}
function $11141e3afc7b4afe$export$2e2bcd8739ae039(_ref5) {
    var prefixCls = _ref5.prefixCls, mergedColumns = _ref5.mergedColumns, onSorterChange = _ref5.onSorterChange, sortDirections = _ref5.sortDirections, tableLocale = _ref5.tableLocale, showSorterTooltip = _ref5.showSorterTooltip;
    var _React$useState = $6fFrj.useState($11141e3afc7b4afe$var$collectSortStates(mergedColumns, true)), _React$useState2 = (0, $jP8CL.default)(_React$useState, 2), sortStates = _React$useState2[0], setSortStates = _React$useState2[1];
    var mergedSorterStates = $6fFrj.useMemo(function() {
        var validate = true;
        var collectedStates = $11141e3afc7b4afe$var$collectSortStates(mergedColumns, false);
        // Return if not controlled
        if (!collectedStates.length) return sortStates;
        var validateStates = [];
        function patchStates(state) {
            if (validate) validateStates.push(state);
            else validateStates.push((0, $fIrcP.default)((0, $fIrcP.default)({}, state), {
                sortOrder: null
            }));
        }
        var multipleMode = null;
        collectedStates.forEach(function(state) {
            if (multipleMode === null) {
                patchStates(state);
                if (state.sortOrder) {
                    if (state.multiplePriority === false) validate = false;
                    else multipleMode = true;
                }
            } else if (multipleMode && state.multiplePriority !== false) patchStates(state);
            else {
                validate = false;
                patchStates(state);
            }
        });
        return validateStates;
    }, [
        mergedColumns,
        sortStates
    ]);
    // Get render columns title required props
    var columnTitleSorterProps = $6fFrj.useMemo(function() {
        var sortColumns = mergedSorterStates.map(function(_ref6) {
            var column = _ref6.column, sortOrder = _ref6.sortOrder;
            return {
                column: column,
                order: sortOrder
            };
        });
        return {
            sortColumns: sortColumns,
            // Legacy
            sortColumn: sortColumns[0] && sortColumns[0].column,
            sortOrder: sortColumns[0] && sortColumns[0].order
        };
    }, [
        mergedSorterStates
    ]);
    function triggerSorter(sortState) {
        var newSorterStates;
        if (sortState.multiplePriority === false || !mergedSorterStates.length || mergedSorterStates[0].multiplePriority === false) newSorterStates = [
            sortState
        ];
        else newSorterStates = [].concat((0, $37xND.default)(mergedSorterStates.filter(function(_ref7) {
            var key = _ref7.key;
            return key !== sortState.key;
        })), [
            sortState
        ]);
        setSortStates(newSorterStates);
        onSorterChange($11141e3afc7b4afe$var$generateSorterInfo(newSorterStates), newSorterStates);
    }
    var transformColumns = function transformColumns(innerColumns) {
        return $11141e3afc7b4afe$var$injectSorter(prefixCls, innerColumns, mergedSorterStates, triggerSorter, sortDirections, tableLocale, showSorterTooltip);
    };
    var getSorters = function getSorters() {
        return $11141e3afc7b4afe$var$generateSorterInfo(mergedSorterStates);
    };
    return [
        transformColumns,
        mergedSorterStates,
        columnTitleSorterProps,
        getSorters
    ];
}



var $fIrcP = parcelRequire("fIrcP");

var $6fFrj = parcelRequire("6fFrj");

function $0ac8b4a9b0dcb1f3$var$fillTitle(columns, columnTitleProps) {
    return columns.map(function(column) {
        var cloneColumn = (0, $fIrcP.default)({}, column);
        cloneColumn.title = (0, $9660a16a644c556b$export$cfda450db2088de7)(column.title, columnTitleProps);
        if ('children' in cloneColumn) cloneColumn.children = $0ac8b4a9b0dcb1f3$var$fillTitle(cloneColumn.children, columnTitleProps);
        return cloneColumn;
    });
}
function $0ac8b4a9b0dcb1f3$export$2e2bcd8739ae039(columnTitleProps) {
    var filledColumns = $6fFrj.useCallback(function(columns) {
        return $0ac8b4a9b0dcb1f3$var$fillTitle(columns, columnTitleProps);
    }, [
        columnTitleProps
    ]);
    return [
        filledColumns
    ];
}


var $661805e566dcd32d$var$EMPTY_LIST = [];
function $661805e566dcd32d$var$InternalTable(props, ref) {
    var customizePrefixCls = props.prefixCls, className = props.className, style = props.style, customizeSize = props.size, bordered = props.bordered, customizeDropdownPrefixCls = props.dropdownPrefixCls, dataSource = props.dataSource, pagination = props.pagination, rowSelection = props.rowSelection, _props$rowKey = props.rowKey, rowKey = _props$rowKey === void 0 ? 'key' : _props$rowKey, rowClassName = props.rowClassName, columns = props.columns, children = props.children, legacyChildrenColumnName = props.childrenColumnName, onChange = props.onChange, getPopupContainer = props.getPopupContainer, loading = props.loading, expandIcon = props.expandIcon, expandable = props.expandable, expandedRowRender = props.expandedRowRender, expandIconColumnIndex = props.expandIconColumnIndex, indentSize = props.indentSize, scroll = props.scroll, sortDirections = props.sortDirections, locale = props.locale, _props$showSorterTool = props.showSorterTooltip, showSorterTooltip = _props$showSorterTool === void 0 ? true : _props$showSorterTool;
    [
        [
            'filterDropdownVisible',
            'filterDropdownOpen'
        ],
        [
            'onFilterDropdownVisibleChange',
            'onFilterDropdownOpenChange'
        ]
    ].forEach(function(_ref) {
        var _ref2 = (0, $jP8CL.default)(_ref, 2), deprecatedName = _ref2[0], newName = _ref2[1];
    });
    var baseColumns = $6fFrj.useMemo(function() {
        return columns || (0, $f010cefebeb2fe47$export$d87a97eba44e0f9c)(children);
    }, [
        columns,
        children
    ]);
    var needResponsive = $6fFrj.useMemo(function() {
        return baseColumns.some(function(col) {
            return col.responsive;
        });
    }, [
        baseColumns
    ]);
    var screens = (0, $60fdd98823a1708b$export$2e2bcd8739ae039)(needResponsive);
    var mergedColumns = $6fFrj.useMemo(function() {
        var matched = new Set(Object.keys(screens).filter(function(m) {
            return screens[m];
        }));
        return baseColumns.filter(function(c) {
            return !c.responsive || c.responsive.some(function(r) {
                return matched.has(r);
            });
        });
    }, [
        baseColumns,
        screens
    ]);
    var tableProps = (0, $c2870fd62d155a62$export$2e2bcd8739ae039)(props, [
        'className',
        'style',
        'columns'
    ]);
    var size = $6fFrj.useContext((0, $aefad26b74860b7e$export$2e2bcd8739ae039));
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), _React$useContext$loc = _React$useContext.locale, contextLocale = _React$useContext$loc === void 0 ? (0, $601d9fcc95befd4d$export$2e2bcd8739ae039) : _React$useContext$loc, renderEmpty = _React$useContext.renderEmpty, direction = _React$useContext.direction;
    var mergedSize = customizeSize || size;
    var tableLocale = (0, $fIrcP.default)((0, $fIrcP.default)({}, contextLocale.Table), locale);
    var rawData = dataSource || $661805e566dcd32d$var$EMPTY_LIST;
    var _React$useContext2 = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext2.getPrefixCls;
    var prefixCls = getPrefixCls('table', customizePrefixCls);
    var dropdownPrefixCls = getPrefixCls('dropdown', customizeDropdownPrefixCls);
    var mergedExpandable = (0, $fIrcP.default)({
        childrenColumnName: legacyChildrenColumnName,
        expandIconColumnIndex: expandIconColumnIndex
    }, expandable);
    var _mergedExpandable$chi = mergedExpandable.childrenColumnName, childrenColumnName = _mergedExpandable$chi === void 0 ? 'children' : _mergedExpandable$chi;
    var expandType = $6fFrj.useMemo(function() {
        if (rawData.some(function(item) {
            return item === null || item === void 0 ? void 0 : item[childrenColumnName];
        })) return 'nest';
        if (expandedRowRender || expandable && expandable.expandedRowRender) return 'row';
        return null;
    }, [
        rawData
    ]);
    var internalRefs = {
        body: $6fFrj.useRef()
    };
    // ============================ RowKey ============================
    var getRowKey = $6fFrj.useMemo(function() {
        if (typeof rowKey === 'function') return rowKey;
        return function(record) {
            return record === null || record === void 0 ? void 0 : record[rowKey];
        };
    }, [
        rowKey
    ]);
    var _useLazyKVMap = (0, $89514f95ab0139cb$export$2e2bcd8739ae039)(rawData, childrenColumnName, getRowKey), _useLazyKVMap2 = (0, $jP8CL.default)(_useLazyKVMap, 1), getRecordByKey = _useLazyKVMap2[0];
    // ============================ Events =============================
    var changeEventInfo = {};
    var triggerOnChange = function triggerOnChange(info, action) {
        var reset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var changeInfo = (0, $fIrcP.default)((0, $fIrcP.default)({}, changeEventInfo), info);
        if (reset) {
            changeEventInfo.resetPagination();
            // Reset event param
            if (changeInfo.pagination.current) changeInfo.pagination.current = 1;
            // Trigger pagination events
            if (pagination && pagination.onChange) pagination.onChange(1, changeInfo.pagination.pageSize);
        }
        if (scroll && scroll.scrollToFirstRowOnChange !== false && internalRefs.body.current) (0, $a5404eb492cf564d$export$2e2bcd8739ae039)(0, {
            getContainer: function getContainer() {
                return internalRefs.body.current;
            }
        });
        onChange === null || onChange === void 0 || onChange(changeInfo.pagination, changeInfo.filters, changeInfo.sorter, {
            currentDataSource: (0, $8bace871b9ed5b3b$export$37643bb40f4c1c56)((0, $11141e3afc7b4afe$export$594b2c8da4a70ee)(rawData, changeInfo.sorterStates, childrenColumnName), changeInfo.filterStates),
            action: action
        });
    };
    /**
   * Controlled state in `columns` is not a good idea that makes too many code (1000+ line?) to read
   * state out and then put it back to title render. Move these code into `hooks` but still too
   * complex. We should provides Table props like `sorter` & `filter` to handle control in next big
   * version.
   */ // ============================ Sorter =============================
    var onSorterChange = function onSorterChange(sorter, sorterStates) {
        triggerOnChange({
            sorter: sorter,
            sorterStates: sorterStates
        }, 'sort', false);
    };
    var _useSorter = (0, $11141e3afc7b4afe$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        mergedColumns: mergedColumns,
        onSorterChange: onSorterChange,
        sortDirections: sortDirections || [
            'ascend',
            'descend'
        ],
        tableLocale: tableLocale,
        showSorterTooltip: showSorterTooltip
    }), _useSorter2 = (0, $jP8CL.default)(_useSorter, 4), transformSorterColumns = _useSorter2[0], sortStates = _useSorter2[1], sorterTitleProps = _useSorter2[2], getSorters = _useSorter2[3];
    var sortedData = $6fFrj.useMemo(function() {
        return (0, $11141e3afc7b4afe$export$594b2c8da4a70ee)(rawData, sortStates, childrenColumnName);
    }, [
        rawData,
        sortStates
    ]);
    changeEventInfo.sorter = getSorters();
    changeEventInfo.sorterStates = sortStates;
    // ============================ Filter ============================
    var onFilterChange = function onFilterChange(filters, filterStates) {
        triggerOnChange({
            filters: filters,
            filterStates: filterStates
        }, 'filter', true);
    };
    var _useFilter = (0, $8bace871b9ed5b3b$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        locale: tableLocale,
        dropdownPrefixCls: dropdownPrefixCls,
        mergedColumns: mergedColumns,
        onFilterChange: onFilterChange,
        getPopupContainer: getPopupContainer
    }), _useFilter2 = (0, $jP8CL.default)(_useFilter, 3), transformFilterColumns = _useFilter2[0], filterStates = _useFilter2[1], filters = _useFilter2[2];
    var mergedData = (0, $8bace871b9ed5b3b$export$37643bb40f4c1c56)(sortedData, filterStates);
    changeEventInfo.filters = filters;
    changeEventInfo.filterStates = filterStates;
    // ============================ Column ============================
    var columnTitleProps = $6fFrj.useMemo(function() {
        var mergedFilters = {};
        Object.keys(filters).forEach(function(filterKey) {
            if (filters[filterKey] !== null) mergedFilters[filterKey] = filters[filterKey];
        });
        return (0, $fIrcP.default)((0, $fIrcP.default)({}, sorterTitleProps), {
            filters: mergedFilters
        });
    }, [
        sorterTitleProps,
        filters
    ]);
    var _useTitleColumns = (0, $0ac8b4a9b0dcb1f3$export$2e2bcd8739ae039)(columnTitleProps), _useTitleColumns2 = (0, $jP8CL.default)(_useTitleColumns, 1), transformTitleColumns = _useTitleColumns2[0];
    // ========================== Pagination ==========================
    var onPaginationChange = function onPaginationChange(current, pageSize) {
        triggerOnChange({
            pagination: (0, $fIrcP.default)((0, $fIrcP.default)({}, changeEventInfo.pagination), {
                current: current,
                pageSize: pageSize
            })
        }, 'paginate');
    };
    var _usePagination = (0, $288095e2cfe15a37$export$2e2bcd8739ae039)(mergedData.length, pagination, onPaginationChange), _usePagination2 = (0, $jP8CL.default)(_usePagination, 2), mergedPagination = _usePagination2[0], resetPagination = _usePagination2[1];
    changeEventInfo.pagination = pagination === false ? {} : (0, $288095e2cfe15a37$export$27eceeed7bf0f4c2)(pagination, mergedPagination);
    changeEventInfo.resetPagination = resetPagination;
    // ============================= Data =============================
    var pageData = $6fFrj.useMemo(function() {
        if (pagination === false || !mergedPagination.pageSize) return mergedData;
        var _mergedPagination$cur = mergedPagination.current, current = _mergedPagination$cur === void 0 ? 1 : _mergedPagination$cur, total = mergedPagination.total, _mergedPagination$pag = mergedPagination.pageSize, pageSize = _mergedPagination$pag === void 0 ? (0, $288095e2cfe15a37$export$5716e8bcb003888d) : _mergedPagination$pag;
        // Dynamic table data
        if (mergedData.length < total) {
            if (mergedData.length > pageSize) return mergedData.slice((current - 1) * pageSize, current * pageSize);
            return mergedData;
        }
        return mergedData.slice((current - 1) * pageSize, current * pageSize);
    }, [
        !!pagination,
        mergedData,
        mergedPagination && mergedPagination.current,
        mergedPagination && mergedPagination.pageSize,
        mergedPagination && mergedPagination.total
    ]);
    // ========================== Selections ==========================
    var _useSelection = (0, $cf46a44a1c69f671$export$2e2bcd8739ae039)(rowSelection, {
        prefixCls: prefixCls,
        data: mergedData,
        pageData: pageData,
        getRowKey: getRowKey,
        getRecordByKey: getRecordByKey,
        expandType: expandType,
        childrenColumnName: childrenColumnName,
        locale: tableLocale,
        getPopupContainer: getPopupContainer
    }), _useSelection2 = (0, $jP8CL.default)(_useSelection, 2), transformSelectionColumns = _useSelection2[0], selectedKeySet = _useSelection2[1];
    var internalRowClassName = function internalRowClassName(record, index, indent) {
        var mergedRowClassName;
        if (typeof rowClassName === 'function') mergedRowClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(rowClassName(record, index, indent));
        else mergedRowClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(rowClassName);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)({}, "".concat(prefixCls, "-row-selected"), selectedKeySet.has(getRowKey(record, index))), mergedRowClassName);
    };
    // ========================== Expandable ==========================
    // Pass origin render status into `rc-table`, this can be removed when refactor with `rc-table`
    mergedExpandable.__PARENT_RENDER_ICON__ = mergedExpandable.expandIcon;
    // Customize expandable icon
    mergedExpandable.expandIcon = mergedExpandable.expandIcon || expandIcon || (0, $be6382bbd6e956e1$export$2e2bcd8739ae039)(tableLocale);
    // Adjust expand icon index, no overwrite expandIconColumnIndex if set.
    if (expandType === 'nest' && mergedExpandable.expandIconColumnIndex === undefined) mergedExpandable.expandIconColumnIndex = rowSelection ? 1 : 0;
    else if (mergedExpandable.expandIconColumnIndex > 0 && rowSelection) mergedExpandable.expandIconColumnIndex -= 1;
    // Indent size
    if (typeof mergedExpandable.indentSize !== 'number') mergedExpandable.indentSize = typeof indentSize === 'number' ? indentSize : 15;
    // ============================ Render ============================
    var transformColumns = $6fFrj.useCallback(function(innerColumns) {
        return transformTitleColumns(transformSelectionColumns(transformFilterColumns(transformSorterColumns(innerColumns))));
    }, [
        transformSorterColumns,
        transformFilterColumns,
        transformSelectionColumns
    ]);
    var topPaginationNode;
    var bottomPaginationNode;
    if (pagination !== false && (mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.total)) {
        var paginationSize;
        if (mergedPagination.size) paginationSize = mergedPagination.size;
        else paginationSize = mergedSize === 'small' || mergedSize === 'middle' ? 'small' : undefined;
        var renderPagination = function renderPagination(position) {
            return /*#__PURE__*/ $6fFrj.createElement((0, $e5809665964e3ab6$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, mergedPagination, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-pagination ").concat(prefixCls, "-pagination-").concat(position), mergedPagination.className),
                size: paginationSize
            }));
        };
        var defaultPosition = direction === 'rtl' ? 'left' : 'right';
        var position = mergedPagination.position;
        if (position !== null && Array.isArray(position)) {
            var topPos = position.find(function(p) {
                return p.includes('top');
            });
            var bottomPos = position.find(function(p) {
                return p.includes('bottom');
            });
            var isDisable = position.every(function(p) {
                return "".concat(p) === 'none';
            });
            if (!topPos && !bottomPos && !isDisable) bottomPaginationNode = renderPagination(defaultPosition);
            if (topPos) topPaginationNode = renderPagination(topPos.toLowerCase().replace('top', ''));
            if (bottomPos) bottomPaginationNode = renderPagination(bottomPos.toLowerCase().replace('bottom', ''));
        } else bottomPaginationNode = renderPagination(defaultPosition);
    }
    // >>>>>>>>> Spinning
    var spinProps;
    if (typeof loading === 'boolean') spinProps = {
        spinning: loading
    };
    else if ((0, $5KhTJ.default)(loading) === 'object') spinProps = (0, $fIrcP.default)({
        spinning: true
    }, loading);
    var wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))("".concat(prefixCls, "-wrapper"), (0, $43449.default)({}, "".concat(prefixCls, "-wrapper-rtl"), direction === 'rtl'), className);
    return /*#__PURE__*/ $6fFrj.createElement("div", {
        ref: ref,
        className: wrapperClassNames,
        style: style
    }, /*#__PURE__*/ $6fFrj.createElement((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        spinning: false
    }, spinProps), topPaginationNode, /*#__PURE__*/ $6fFrj.createElement((0, $f549334765213713$export$2e2bcd8739ae039), (0, $fIrcP.default)({}, tableProps, {
        columns: mergedColumns,
        direction: direction,
        expandable: mergedExpandable,
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))((0, $43449.default)((0, $43449.default)((0, $43449.default)((0, $43449.default)({}, "".concat(prefixCls, "-middle"), mergedSize === 'middle'), "".concat(prefixCls, "-small"), mergedSize === 'small'), "".concat(prefixCls, "-bordered"), bordered), "".concat(prefixCls, "-empty"), rawData.length === 0)),
        data: pageData,
        rowKey: getRowKey,
        rowClassName: internalRowClassName,
        emptyText: locale && locale.emptyText || (renderEmpty || (0, $94fec351dda17415$export$2e2bcd8739ae039))('Table'),
        // Internal
        internalHooks: (0, $06d7f51aacc8a77b$export$91b75cf262680225),
        internalRefs: internalRefs,
        transformColumns: transformColumns
    })), bottomPaginationNode));
}
var $661805e566dcd32d$var$ForwardTable = /*#__PURE__*/ $6fFrj.forwardRef($661805e566dcd32d$var$InternalTable);
var $661805e566dcd32d$var$Table = $661805e566dcd32d$var$ForwardTable;
$661805e566dcd32d$var$Table.SELECTION_COLUMN = (0, $cf46a44a1c69f671$export$ed10248435b8f218);
$661805e566dcd32d$var$Table.EXPAND_COLUMN = (0, $f549334765213713$export$2e2bcd8739ae039).EXPAND_COLUMN;
$661805e566dcd32d$var$Table.SELECTION_ALL = (0, $cf46a44a1c69f671$export$14159cd9e2a500c8);
$661805e566dcd32d$var$Table.SELECTION_INVERT = (0, $cf46a44a1c69f671$export$625c4f68eaaf8cfd);
$661805e566dcd32d$var$Table.SELECTION_NONE = (0, $cf46a44a1c69f671$export$c1a725540f5a63bd);
$661805e566dcd32d$var$Table.Column = (0, $90643cbcc1ad3a5b$export$2e2bcd8739ae039);
$661805e566dcd32d$var$Table.ColumnGroup = (0, $815c663a28b62a97$export$2e2bcd8739ae039);
$661805e566dcd32d$var$Table.Summary = (0, $e248b732ce653607$export$d605f3af09eef683);
var $661805e566dcd32d$export$2e2bcd8739ae039 = $661805e566dcd32d$var$Table;


var $5c207ce4beedc4d7$export$2e2bcd8739ae039 = (0, $661805e566dcd32d$export$2e2bcd8739ae039);




var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $88bd26e66b6928eb$var$ApartmentOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z"
                }
            }
        ]
    },
    "name": "apartment",
    "theme": "outlined"
};
var $88bd26e66b6928eb$export$2e2bcd8739ae039 = $88bd26e66b6928eb$var$ApartmentOutlined;



var $ae76d9d871e3b56f$var$ApartmentOutlined = function ApartmentOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $88bd26e66b6928eb$export$2e2bcd8739ae039)
    }));
};
var $ae76d9d871e3b56f$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($ae76d9d871e3b56f$var$ApartmentOutlined);
var $ae76d9d871e3b56f$export$2e2bcd8739ae039 = $ae76d9d871e3b56f$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $3b78b620d831a3ee$var$ApiOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 00-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 000 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 00-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 00-11.3 0L363 475.3l-43-43a7.85 7.85 0 00-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 000 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 01-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 01-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z"
                }
            }
        ]
    },
    "name": "api",
    "theme": "outlined"
};
var $3b78b620d831a3ee$export$2e2bcd8739ae039 = $3b78b620d831a3ee$var$ApiOutlined;



var $fcba857743b4bdb3$var$ApiOutlined = function ApiOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $3b78b620d831a3ee$export$2e2bcd8739ae039)
    }));
};
var $fcba857743b4bdb3$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($fcba857743b4bdb3$var$ApiOutlined);
var $fcba857743b4bdb3$export$2e2bcd8739ae039 = $fcba857743b4bdb3$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $018287f1375ef933$var$AppleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-10.6 267c-14.3 19.9-28.7 35.6-41.9 45.7-10.5 8-18.6 11.4-24 11.6-9-.1-17.7-2.3-34.7-8.8-1.2-.5-2.5-1-4.2-1.6l-4.4-1.7c-17.4-6.7-27.8-10.3-41.1-13.8-18.6-4.8-37.1-7.4-56.9-7.4-20.2 0-39.2 2.5-58.1 7.2-13.9 3.5-25.6 7.4-42.7 13.8-.7.3-8.1 3.1-10.2 3.9-3.5 1.3-6.2 2.3-8.7 3.2-10.4 3.6-17 5.1-22.9 5.2-.7 0-1.3-.1-1.8-.2-1.1-.2-2.5-.6-4.1-1.3-4.5-1.8-9.9-5.1-16-9.8-14-10.9-29.4-28-45.1-49.9-27.5-38.6-53.5-89.8-66-125.7-15.4-44.8-23-87.7-23-128.6 0-60.2 17.8-106 48.4-137.1 26.3-26.6 61.7-41.5 97.8-42.3 5.9.1 14.5 1.5 25.4 4.5 8.6 2.3 18 5.4 30.7 9.9 3.8 1.4 16.9 6.1 18.5 6.7 7.7 2.8 13.5 4.8 19.2 6.6 18.2 5.8 32.3 9 47.6 9 15.5 0 28.8-3.3 47.7-9.8 7.1-2.4 32.9-12 37.5-13.6 25.6-9.1 44.5-14 60.8-15.2 4.8-.4 9.1-.4 13.2-.1 22.7 1.8 42.1 6.3 58.6 13.8-37.6 43.4-57 96.5-56.9 158.4-.3 14.7.9 31.7 5.1 51.8 6.4 30.5 18.6 60.7 37.9 89 14.7 21.5 32.9 40.9 54.7 57.8-11.5 23.7-25.6 48.2-40.4 68.8zm-94.5-572c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"
                }
            }
        ]
    },
    "name": "apple",
    "theme": "outlined"
};
var $018287f1375ef933$export$2e2bcd8739ae039 = $018287f1375ef933$var$AppleOutlined;



var $d14a4157864152af$var$AppleOutlined = function AppleOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $018287f1375ef933$export$2e2bcd8739ae039)
    }));
};
var $d14a4157864152af$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($d14a4157864152af$var$AppleOutlined);
var $d14a4157864152af$export$2e2bcd8739ae039 = $d14a4157864152af$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $9f4adb05db150d95$var$AppstoreAddOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zm52 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200zM424 712H296V584c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v128H104c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h128v128c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V776h128c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "appstore-add",
    "theme": "outlined"
};
var $9f4adb05db150d95$export$2e2bcd8739ae039 = $9f4adb05db150d95$var$AppstoreAddOutlined;



var $0b18e607ccfd1e7a$var$AppstoreAddOutlined = function AppstoreAddOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $9f4adb05db150d95$export$2e2bcd8739ae039)
    }));
};
var $0b18e607ccfd1e7a$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($0b18e607ccfd1e7a$var$AppstoreAddOutlined);
var $0b18e607ccfd1e7a$export$2e2bcd8739ae039 = $0b18e607ccfd1e7a$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $187933c9fc21265e$var$ArrowDownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0048.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z"
                }
            }
        ]
    },
    "name": "arrow-down",
    "theme": "outlined"
};
var $187933c9fc21265e$export$2e2bcd8739ae039 = $187933c9fc21265e$var$ArrowDownOutlined;



var $de57d19d5d51a7e8$var$ArrowDownOutlined = function ArrowDownOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $187933c9fc21265e$export$2e2bcd8739ae039)
    }));
};
var $de57d19d5d51a7e8$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($de57d19d5d51a7e8$var$ArrowDownOutlined);
var $de57d19d5d51a7e8$export$2e2bcd8739ae039 = $de57d19d5d51a7e8$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $47c13f5685ab4b48$var$BankOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 00-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM512 196.7l271.1 197.2H240.9L512 196.7zM264 462h117v374H264V462zm189 0h117v374H453V462zm307 374H642V462h118v374z"
                }
            }
        ]
    },
    "name": "bank",
    "theme": "outlined"
};
var $47c13f5685ab4b48$export$2e2bcd8739ae039 = $47c13f5685ab4b48$var$BankOutlined;



var $923ad284c7e7c01f$var$BankOutlined = function BankOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $47c13f5685ab4b48$export$2e2bcd8739ae039)
    }));
};
var $923ad284c7e7c01f$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($923ad284c7e7c01f$var$BankOutlined);
var $923ad284c7e7c01f$export$2e2bcd8739ae039 = $923ad284c7e7c01f$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $65fe01a6464ed8b7$var$BarChartOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-600-80h56c4.4 0 8-3.6 8-8V560c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v320c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V462c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v242c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    },
    "name": "bar-chart",
    "theme": "outlined"
};
var $65fe01a6464ed8b7$export$2e2bcd8739ae039 = $65fe01a6464ed8b7$var$BarChartOutlined;



var $463d007432312983$var$BarChartOutlined = function BarChartOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $65fe01a6464ed8b7$export$2e2bcd8739ae039)
    }));
};
var $463d007432312983$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($463d007432312983$var$BarChartOutlined);
var $463d007432312983$export$2e2bcd8739ae039 = $463d007432312983$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $17b5d97709bd2f41$var$BgColorsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zm-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-.6-.6-1.3-1.2-2-1.7l-78.2-78.2a9.11 9.11 0 00-12.8 0l-48 48a9.11 9.11 0 000 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256zm12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "bg-colors",
    "theme": "outlined"
};
var $17b5d97709bd2f41$export$2e2bcd8739ae039 = $17b5d97709bd2f41$var$BgColorsOutlined;



var $49f5a0bb3d2ed4da$var$BgColorsOutlined = function BgColorsOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $17b5d97709bd2f41$export$2e2bcd8739ae039)
    }));
};
var $49f5a0bb3d2ed4da$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($49f5a0bb3d2ed4da$var$BgColorsOutlined);
var $49f5a0bb3d2ed4da$export$2e2bcd8739ae039 = $49f5a0bb3d2ed4da$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $402111751fade89e$var$BulbOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z"
                }
            }
        ]
    },
    "name": "bulb",
    "theme": "outlined"
};
var $402111751fade89e$export$2e2bcd8739ae039 = $402111751fade89e$var$BulbOutlined;



var $f64518499a4fb680$var$BulbOutlined = function BulbOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $402111751fade89e$export$2e2bcd8739ae039)
    }));
};
var $f64518499a4fb680$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($f64518499a4fb680$var$BulbOutlined);
var $f64518499a4fb680$export$2e2bcd8739ae039 = $f64518499a4fb680$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $cb84a03966b55777$var$CalendarFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M112 880c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V460H112v420zm768-696H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v176h800V216c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    },
    "name": "calendar",
    "theme": "filled"
};
var $cb84a03966b55777$export$2e2bcd8739ae039 = $cb84a03966b55777$var$CalendarFilled;



var $7abf264acbeec97b$var$CalendarFilled = function CalendarFilled(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $cb84a03966b55777$export$2e2bcd8739ae039)
    }));
};
var $7abf264acbeec97b$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($7abf264acbeec97b$var$CalendarFilled);
var $7abf264acbeec97b$export$2e2bcd8739ae039 = $7abf264acbeec97b$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $f89c70640775b5d9$var$CalendarTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "calendar",
    "theme": "twotone"
};
var $f89c70640775b5d9$export$2e2bcd8739ae039 = $f89c70640775b5d9$var$CalendarTwoTone;



var $207db351f0724b47$var$CalendarTwoTone = function CalendarTwoTone(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $f89c70640775b5d9$export$2e2bcd8739ae039)
    }));
};
var $207db351f0724b47$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($207db351f0724b47$var$CalendarTwoTone);
var $207db351f0724b47$export$2e2bcd8739ae039 = $207db351f0724b47$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $7006a2f4a8f5fc92$var$CheckCircleTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z",
                        "fill": primaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm193.4 225.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 5 25.9 13.3l71.2 98.8 157.2-218c6-8.4 15.7-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.4 12.7z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "check-circle",
    "theme": "twotone"
};
var $7006a2f4a8f5fc92$export$2e2bcd8739ae039 = $7006a2f4a8f5fc92$var$CheckCircleTwoTone;



var $5b171aec1295c863$var$CheckCircleTwoTone = function CheckCircleTwoTone(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $7006a2f4a8f5fc92$export$2e2bcd8739ae039)
    }));
};
var $5b171aec1295c863$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($5b171aec1295c863$var$CheckCircleTwoTone);
var $5b171aec1295c863$export$2e2bcd8739ae039 = $5b171aec1295c863$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $93376b4b38f0e14f$var$CloudDownloadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 01-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"
                }
            }
        ]
    },
    "name": "cloud-download",
    "theme": "outlined"
};
var $93376b4b38f0e14f$export$2e2bcd8739ae039 = $93376b4b38f0e14f$var$CloudDownloadOutlined;



var $68c44dc06def2993$var$CloudDownloadOutlined = function CloudDownloadOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $93376b4b38f0e14f$export$2e2bcd8739ae039)
    }));
};
var $68c44dc06def2993$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($68c44dc06def2993$var$CloudDownloadOutlined);
var $68c44dc06def2993$export$2e2bcd8739ae039 = $68c44dc06def2993$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $2765c99519afea92$var$CloudOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 01-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 01140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0166.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z"
                }
            }
        ]
    },
    "name": "cloud",
    "theme": "outlined"
};
var $2765c99519afea92$export$2e2bcd8739ae039 = $2765c99519afea92$var$CloudOutlined;



var $c381dc84ef659a87$var$CloudOutlined = function CloudOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $2765c99519afea92$export$2e2bcd8739ae039)
    }));
};
var $c381dc84ef659a87$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($c381dc84ef659a87$var$CloudOutlined);
var $c381dc84ef659a87$export$2e2bcd8739ae039 = $c381dc84ef659a87$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $be3a876e44faf132$var$CloudUploadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M518.3 459a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 01-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"
                }
            }
        ]
    },
    "name": "cloud-upload",
    "theme": "outlined"
};
var $be3a876e44faf132$export$2e2bcd8739ae039 = $be3a876e44faf132$var$CloudUploadOutlined;



var $0cbe1920d2403395$var$CloudUploadOutlined = function CloudUploadOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $be3a876e44faf132$export$2e2bcd8739ae039)
    }));
};
var $0cbe1920d2403395$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($0cbe1920d2403395$var$CloudUploadOutlined);
var $0cbe1920d2403395$export$2e2bcd8739ae039 = $0cbe1920d2403395$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $0b4636abdd177008$var$CodeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 00308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 00-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "code",
    "theme": "outlined"
};
var $0b4636abdd177008$export$2e2bcd8739ae039 = $0b4636abdd177008$var$CodeOutlined;



var $97364f466b54923c$var$CodeOutlined = function CodeOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $0b4636abdd177008$export$2e2bcd8739ae039)
    }));
};
var $97364f466b54923c$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($97364f466b54923c$var$CodeOutlined);
var $97364f466b54923c$export$2e2bcd8739ae039 = $97364f466b54923c$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $3901f7b3821d98fd$var$CoffeeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M275 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm613 144H768c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v248c0 3.4.2 6.7.7 9.9-.5 7-.7 14-.7 21.1 0 176.7 143.3 320 320 320 160.1 0 292.7-117.5 316.3-271H888c39.8 0 72-32.2 72-72V497c0-39.8-32.2-72-72-72zM696 681h-1.1c.7 7.6 1.1 15.2 1.1 23 0 137-111 248-248 248S200 841 200 704c0-7.8.4-15.4 1.1-23H200V425h496v256zm192-8H776V497h112v176zM613 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm-170 0c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36z"
                }
            }
        ]
    },
    "name": "coffee",
    "theme": "outlined"
};
var $3901f7b3821d98fd$export$2e2bcd8739ae039 = $3901f7b3821d98fd$var$CoffeeOutlined;



var $8cd47d2c217339e1$var$CoffeeOutlined = function CoffeeOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $3901f7b3821d98fd$export$2e2bcd8739ae039)
    }));
};
var $8cd47d2c217339e1$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($8cd47d2c217339e1$var$CoffeeOutlined);
var $8cd47d2c217339e1$export$2e2bcd8739ae039 = $8cd47d2c217339e1$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $2fe961afd9e2d8cb$var$CreditCardOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-792 72h752v120H136V232zm752 560H136V440h752v352zm-237-64h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    },
    "name": "credit-card",
    "theme": "outlined"
};
var $2fe961afd9e2d8cb$export$2e2bcd8739ae039 = $2fe961afd9e2d8cb$var$CreditCardOutlined;



var $1089a0c68d382406$var$CreditCardOutlined = function CreditCardOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $2fe961afd9e2d8cb$export$2e2bcd8739ae039)
    }));
};
var $1089a0c68d382406$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($1089a0c68d382406$var$CreditCardOutlined);
var $1089a0c68d382406$export$2e2bcd8739ae039 = $1089a0c68d382406$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $1867eb2a306b2ed4$var$DashboardOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 01140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276zM623.5 421.5a8.03 8.03 0 00-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 000 79.2 55.95 55.95 0 0079.2 0 55.87 55.87 0 0014.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm12.7-197.2l-31.1-31.1a8.03 8.03 0 00-11.3 0l-56.6 56.6a8.03 8.03 0 000 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zm-458.6-31.1a8.03 8.03 0 00-11.3 0l-31.1 31.1a8.03 8.03 0 000 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "dashboard",
    "theme": "outlined"
};
var $1867eb2a306b2ed4$export$2e2bcd8739ae039 = $1867eb2a306b2ed4$var$DashboardOutlined;



var $a20907b54279d5ba$var$DashboardOutlined = function DashboardOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $1867eb2a306b2ed4$export$2e2bcd8739ae039)
    }));
};
var $a20907b54279d5ba$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($a20907b54279d5ba$var$DashboardOutlined);
var $a20907b54279d5ba$export$2e2bcd8739ae039 = $a20907b54279d5ba$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $4c7d1b9d5b71f264$var$DeleteTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M292.7 840h438.6l24.2-512h-487z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-504-72h304v72H360v-72zm371.3 656H292.7l-24.2-512h487l-24.2 512z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "delete",
    "theme": "twotone"
};
var $4c7d1b9d5b71f264$export$2e2bcd8739ae039 = $4c7d1b9d5b71f264$var$DeleteTwoTone;



var $de47a51a480c0f82$var$DeleteTwoTone = function DeleteTwoTone(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $4c7d1b9d5b71f264$export$2e2bcd8739ae039)
    }));
};
var $de47a51a480c0f82$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($de47a51a480c0f82$var$DeleteTwoTone);
var $de47a51a480c0f82$export$2e2bcd8739ae039 = $de47a51a480c0f82$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $8cb4663646402b38$var$DesktopOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z"
                }
            }
        ]
    },
    "name": "desktop",
    "theme": "outlined"
};
var $8cb4663646402b38$export$2e2bcd8739ae039 = $8cb4663646402b38$var$DesktopOutlined;



var $e453b8b6b5ad3749$var$DesktopOutlined = function DesktopOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $8cb4663646402b38$export$2e2bcd8739ae039)
    }));
};
var $e453b8b6b5ad3749$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($e453b8b6b5ad3749$var$DesktopOutlined);
var $e453b8b6b5ad3749$export$2e2bcd8739ae039 = $e453b8b6b5ad3749$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $2805d9ea4c7c82f7$var$DollarOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"
                }
            }
        ]
    },
    "name": "dollar",
    "theme": "outlined"
};
var $2805d9ea4c7c82f7$export$2e2bcd8739ae039 = $2805d9ea4c7c82f7$var$DollarOutlined;



var $51a61f5300870abf$var$DollarOutlined = function DollarOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $2805d9ea4c7c82f7$export$2e2bcd8739ae039)
    }));
};
var $51a61f5300870abf$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($51a61f5300870abf$var$DollarOutlined);
var $51a61f5300870abf$export$2e2bcd8739ae039 = $51a61f5300870abf$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $bf85fa9f23cdec31$var$DragOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.3 506.3L781.7 405.6a7.23 7.23 0 00-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 00-11.3 0L405.6 242.3a7.23 7.23 0 005.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 00.1-11.4z"
                }
            }
        ]
    },
    "name": "drag",
    "theme": "outlined"
};
var $bf85fa9f23cdec31$export$2e2bcd8739ae039 = $bf85fa9f23cdec31$var$DragOutlined;



var $f28b9bb416ebdab1$var$DragOutlined = function DragOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $bf85fa9f23cdec31$export$2e2bcd8739ae039)
    }));
};
var $f28b9bb416ebdab1$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($f28b9bb416ebdab1$var$DragOutlined);
var $f28b9bb416ebdab1$export$2e2bcd8739ae039 = $f28b9bb416ebdab1$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $3adc3607368aa409$var$EditTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M761.1 288.3L687.8 215 325.1 577.6l-15.6 89 88.9-15.7z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "edit",
    "theme": "twotone"
};
var $3adc3607368aa409$export$2e2bcd8739ae039 = $3adc3607368aa409$var$EditTwoTone;



var $e99c463f3db5d26f$var$EditTwoTone = function EditTwoTone(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $3adc3607368aa409$export$2e2bcd8739ae039)
    }));
};
var $e99c463f3db5d26f$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($e99c463f3db5d26f$var$EditTwoTone);
var $e99c463f3db5d26f$export$2e2bcd8739ae039 = $e99c463f3db5d26f$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $1b3b94f7b65f720a$var$FileAddOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z"
                }
            }
        ]
    },
    "name": "file-add",
    "theme": "outlined"
};
var $1b3b94f7b65f720a$export$2e2bcd8739ae039 = $1b3b94f7b65f720a$var$FileAddOutlined;



var $fcd2424c0c464cbe$var$FileAddOutlined = function FileAddOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $1b3b94f7b65f720a$export$2e2bcd8739ae039)
    }));
};
var $fcd2424c0c464cbe$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($fcd2424c0c464cbe$var$FileAddOutlined);
var $fcd2424c0c464cbe$export$2e2bcd8739ae039 = $fcd2424c0c464cbe$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $a3c8657af1beec4e$var$FilterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z"
                }
            }
        ]
    },
    "name": "filter",
    "theme": "outlined"
};
var $a3c8657af1beec4e$export$2e2bcd8739ae039 = $a3c8657af1beec4e$var$FilterOutlined;



var $2ee09c629f9f231d$var$FilterOutlined = function FilterOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $a3c8657af1beec4e$export$2e2bcd8739ae039)
    }));
};
var $2ee09c629f9f231d$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($2ee09c629f9f231d$var$FilterOutlined);
var $2ee09c629f9f231d$export$2e2bcd8739ae039 = $2ee09c629f9f231d$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $5a890267efdbe8f7$var$FormatPainterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 .6.1 1.3.2 1.9A83.99 83.99 0 00457 960c46.4 0 84-37.6 84-84 0-2.1-.1-4.1-.2-6.1.1-.6.2-1.2.2-1.9V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40zM720 352H208V160h512v192zM477 876c0 11-9 20-20 20s-20-9-20-20V696h40v180z"
                }
            }
        ]
    },
    "name": "format-painter",
    "theme": "outlined"
};
var $5a890267efdbe8f7$export$2e2bcd8739ae039 = $5a890267efdbe8f7$var$FormatPainterOutlined;



var $55708caa31c4d8e9$var$FormatPainterOutlined = function FormatPainterOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $5a890267efdbe8f7$export$2e2bcd8739ae039)
    }));
};
var $55708caa31c4d8e9$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($55708caa31c4d8e9$var$FormatPainterOutlined);
var $55708caa31c4d8e9$export$2e2bcd8739ae039 = $55708caa31c4d8e9$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $fd5944468c9216af$var$FormOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 00-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z"
                }
            }
        ]
    },
    "name": "form",
    "theme": "outlined"
};
var $fd5944468c9216af$export$2e2bcd8739ae039 = $fd5944468c9216af$var$FormOutlined;



var $d735dd92a3f8793e$var$FormOutlined = function FormOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $fd5944468c9216af$export$2e2bcd8739ae039)
    }));
};
var $d735dd92a3f8793e$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($d735dd92a3f8793e$var$FormOutlined);
var $d735dd92a3f8793e$export$2e2bcd8739ae039 = $d735dd92a3f8793e$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $601183723846d58b$var$FullscreenOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M290 236.4l43.9-43.9a8.01 8.01 0 00-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0013.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 000 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 00-11.3 0l-42.4 42.3a8.03 8.03 0 000 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 004.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 00-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 00-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z"
                }
            }
        ]
    },
    "name": "fullscreen",
    "theme": "outlined"
};
var $601183723846d58b$export$2e2bcd8739ae039 = $601183723846d58b$var$FullscreenOutlined;



var $436a9dbf290cd345$var$FullscreenOutlined = function FullscreenOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $601183723846d58b$export$2e2bcd8739ae039)
    }));
};
var $436a9dbf290cd345$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($436a9dbf290cd345$var$FullscreenOutlined);
var $436a9dbf290cd345$export$2e2bcd8739ae039 = $436a9dbf290cd345$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $b02f87502da74698$var$HighlightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M957.6 507.4L603.2 158.2a7.9 7.9 0 00-11.2 0L353.3 393.4a8.03 8.03 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0011.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0011.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.2H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.2l68.6-67.6 171.4 168.9-68.6 67.6zM713.1 658L450.3 399.1 597.6 254l262.8 259-147.3 145z"
                }
            }
        ]
    },
    "name": "highlight",
    "theme": "outlined"
};
var $b02f87502da74698$export$2e2bcd8739ae039 = $b02f87502da74698$var$HighlightOutlined;



var $c27bdb2761765bf0$var$HighlightOutlined = function HighlightOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $b02f87502da74698$export$2e2bcd8739ae039)
    }));
};
var $c27bdb2761765bf0$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($c27bdb2761765bf0$var$HighlightOutlined);
var $c27bdb2761765bf0$export$2e2bcd8739ae039 = $c27bdb2761765bf0$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $017300e826cb986c$var$HighlightTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M229.6 796.3h160.2l54.3-54.1-80.1-78.9zm220.7-397.1l262.8 258.9 147.3-145-262.8-259zm-77.1 166.1l171.4 168.9 68.6-67.6-171.4-168.9z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M957.6 507.5L603.2 158.3a7.9 7.9 0 00-11.2 0L353.3 393.5a8.03 8.03 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8v55.2c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6L539 830a7.9 7.9 0 0011.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0011.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.3H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.3l68.6-67.6 171.4 168.9-68.6 67.6zm168.5-76.1L450.3 399.2l147.3-145.1 262.8 259-147.3 145z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "highlight",
    "theme": "twotone"
};
var $017300e826cb986c$export$2e2bcd8739ae039 = $017300e826cb986c$var$HighlightTwoTone;



var $0cc8834b873afb0a$var$HighlightTwoTone = function HighlightTwoTone(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $017300e826cb986c$export$2e2bcd8739ae039)
    }));
};
var $0cc8834b873afb0a$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($0cc8834b873afb0a$var$HighlightTwoTone);
var $0cc8834b873afb0a$export$2e2bcd8739ae039 = $0cc8834b873afb0a$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $508b0d15cb771a94$var$HomeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.9 63.9 0 00-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0018.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"
                }
            }
        ]
    },
    "name": "home",
    "theme": "outlined"
};
var $508b0d15cb771a94$export$2e2bcd8739ae039 = $508b0d15cb771a94$var$HomeOutlined;



var $8c1e96cbe9d7c5e8$var$HomeOutlined = function HomeOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $508b0d15cb771a94$export$2e2bcd8739ae039)
    }));
};
var $8c1e96cbe9d7c5e8$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($8c1e96cbe9d7c5e8$var$HomeOutlined);
var $8c1e96cbe9d7c5e8$export$2e2bcd8739ae039 = $8c1e96cbe9d7c5e8$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $d81e2de0acbde038$var$HourglassOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 01354 318V184h316v134z"
                }
            }
        ]
    },
    "name": "hourglass",
    "theme": "outlined"
};
var $d81e2de0acbde038$export$2e2bcd8739ae039 = $d81e2de0acbde038$var$HourglassOutlined;



var $9d073373336b7dc4$var$HourglassOutlined = function HourglassOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $d81e2de0acbde038$export$2e2bcd8739ae039)
    }));
};
var $9d073373336b7dc4$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($9d073373336b7dc4$var$HourglassOutlined);
var $9d073373336b7dc4$export$2e2bcd8739ae039 = $9d073373336b7dc4$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $062f82e8f5cd191d$var$InboxOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0060.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z"
                }
            }
        ]
    },
    "name": "inbox",
    "theme": "outlined"
};
var $062f82e8f5cd191d$export$2e2bcd8739ae039 = $062f82e8f5cd191d$var$InboxOutlined;



var $1fe526a850b3b089$var$InboxOutlined = function InboxOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $062f82e8f5cd191d$export$2e2bcd8739ae039)
    }));
};
var $1fe526a850b3b089$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($1fe526a850b3b089$var$InboxOutlined);
var $1fe526a850b3b089$export$2e2bcd8739ae039 = $1fe526a850b3b089$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $67417c921514a13d$var$InfoCircleTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z",
                        "fill": primaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "info-circle",
    "theme": "twotone"
};
var $67417c921514a13d$export$2e2bcd8739ae039 = $67417c921514a13d$var$InfoCircleTwoTone;



var $646bfab0dc84d404$var$InfoCircleTwoTone = function InfoCircleTwoTone(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $67417c921514a13d$export$2e2bcd8739ae039)
    }));
};
var $646bfab0dc84d404$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($646bfab0dc84d404$var$InfoCircleTwoTone);
var $646bfab0dc84d404$export$2e2bcd8739ae039 = $646bfab0dc84d404$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $972bba083c71afa6$var$LaptopOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M956.9 845.1L896.4 632V168c0-17.7-14.3-32-32-32h-704c-17.7 0-32 14.3-32 32v464L67.9 845.1C60.4 866 75.8 888 98 888h828.8c22.2 0 37.6-22 30.1-42.9zM200.4 208h624v395h-624V208zm228.3 608l8.1-37h150.3l8.1 37H428.7zm224 0l-19.1-86.7c-.8-3.7-4.1-6.3-7.8-6.3H398.2c-3.8 0-7 2.6-7.8 6.3L371.3 816H151l42.3-149h638.2l42.3 149H652.7z"
                }
            }
        ]
    },
    "name": "laptop",
    "theme": "outlined"
};
var $972bba083c71afa6$export$2e2bcd8739ae039 = $972bba083c71afa6$var$LaptopOutlined;



var $84d74f042482ef70$var$LaptopOutlined = function LaptopOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $972bba083c71afa6$export$2e2bcd8739ae039)
    }));
};
var $84d74f042482ef70$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($84d74f042482ef70$var$LaptopOutlined);
var $84d74f042482ef70$export$2e2bcd8739ae039 = $84d74f042482ef70$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $2dcb70ba3e60362b$var$LikeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 00-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 00471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0142.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z"
                }
            }
        ]
    },
    "name": "like",
    "theme": "outlined"
};
var $2dcb70ba3e60362b$export$2e2bcd8739ae039 = $2dcb70ba3e60362b$var$LikeOutlined;



var $1c948112d2b074e5$var$LikeOutlined = function LikeOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $2dcb70ba3e60362b$export$2e2bcd8739ae039)
    }));
};
var $1c948112d2b074e5$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($1c948112d2b074e5$var$LikeOutlined);
var $1c948112d2b074e5$export$2e2bcd8739ae039 = $1c948112d2b074e5$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $c72db97a82870ee4$var$LinkOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M574 665.4a8.03 8.03 0 00-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 00-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 000 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 000 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 00-11.3 0L372.3 598.7a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z"
                }
            }
        ]
    },
    "name": "link",
    "theme": "outlined"
};
var $c72db97a82870ee4$export$2e2bcd8739ae039 = $c72db97a82870ee4$var$LinkOutlined;



var $2e124d85086d77f3$var$LinkOutlined = function LinkOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $c72db97a82870ee4$export$2e2bcd8739ae039)
    }));
};
var $2e124d85086d77f3$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($2e124d85086d77f3$var$LinkOutlined);
var $2e124d85086d77f3$export$2e2bcd8739ae039 = $2e124d85086d77f3$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $6148b01adaf532f2$var$LockFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1156 0zm152-237H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224z"
                }
            }
        ]
    },
    "name": "lock",
    "theme": "filled"
};
var $6148b01adaf532f2$export$2e2bcd8739ae039 = $6148b01adaf532f2$var$LockFilled;



var $f8d4ada68a8c7ad7$var$LockFilled = function LockFilled(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $6148b01adaf532f2$export$2e2bcd8739ae039)
    }));
};
var $f8d4ada68a8c7ad7$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($f8d4ada68a8c7ad7$var$LockFilled);
var $f8d4ada68a8c7ad7$export$2e2bcd8739ae039 = $f8d4ada68a8c7ad7$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $e0c955626c671687$var$LockOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z"
                }
            }
        ]
    },
    "name": "lock",
    "theme": "outlined"
};
var $e0c955626c671687$export$2e2bcd8739ae039 = $e0c955626c671687$var$LockOutlined;



var $a8cdd3c5c720cb5b$var$LockOutlined = function LockOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $e0c955626c671687$export$2e2bcd8739ae039)
    }));
};
var $a8cdd3c5c720cb5b$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($a8cdd3c5c720cb5b$var$LockOutlined);
var $a8cdd3c5c720cb5b$export$2e2bcd8739ae039 = $a8cdd3c5c720cb5b$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $cb681f5ed9bface7$var$MailOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0068.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z"
                }
            }
        ]
    },
    "name": "mail",
    "theme": "outlined"
};
var $cb681f5ed9bface7$export$2e2bcd8739ae039 = $cb681f5ed9bface7$var$MailOutlined;



var $4833597913ab9bd3$var$MailOutlined = function MailOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $cb681f5ed9bface7$export$2e2bcd8739ae039)
    }));
};
var $4833597913ab9bd3$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($4833597913ab9bd3$var$MailOutlined);
var $4833597913ab9bd3$export$2e2bcd8739ae039 = $4833597913ab9bd3$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $62308e7811a95a47$var$MenuFoldOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 000 13.8z"
                }
            }
        ]
    },
    "name": "menu-fold",
    "theme": "outlined"
};
var $62308e7811a95a47$export$2e2bcd8739ae039 = $62308e7811a95a47$var$MenuFoldOutlined;



var $3d5af726d5e6b537$var$MenuFoldOutlined = function MenuFoldOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $62308e7811a95a47$export$2e2bcd8739ae039)
    }));
};
var $3d5af726d5e6b537$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($3d5af726d5e6b537$var$MenuFoldOutlined);
var $3d5af726d5e6b537$export$2e2bcd8739ae039 = $3d5af726d5e6b537$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $0b5fcf1ef474fa66$var$MenuOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "menu",
    "theme": "outlined"
};
var $0b5fcf1ef474fa66$export$2e2bcd8739ae039 = $0b5fcf1ef474fa66$var$MenuOutlined;



var $a6a04a0106e14094$var$MenuOutlined = function MenuOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $0b5fcf1ef474fa66$export$2e2bcd8739ae039)
    }));
};
var $a6a04a0106e14094$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($a6a04a0106e14094$var$MenuOutlined);
var $a6a04a0106e14094$export$2e2bcd8739ae039 = $a6a04a0106e14094$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $2b5d68a9ed2b4c62$var$MenuUnfoldOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 000-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0014.4 7z"
                }
            }
        ]
    },
    "name": "menu-unfold",
    "theme": "outlined"
};
var $2b5d68a9ed2b4c62$export$2e2bcd8739ae039 = $2b5d68a9ed2b4c62$var$MenuUnfoldOutlined;



var $c2f330c5232bc2dc$var$MenuUnfoldOutlined = function MenuUnfoldOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $2b5d68a9ed2b4c62$export$2e2bcd8739ae039)
    }));
};
var $c2f330c5232bc2dc$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($c2f330c5232bc2dc$var$MenuUnfoldOutlined);
var $c2f330c5232bc2dc$export$2e2bcd8739ae039 = $c2f330c5232bc2dc$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $f551506b43790dee$var$MessageOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 512a48 48 0 1096 0 48 48 0 10-96 0zm200 0a48 48 0 1096 0 48 48 0 10-96 0zm-400 0a48 48 0 1096 0 48 48 0 10-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 00-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 00-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 00112 714v152a46 46 0 0046 46h152.1A449.4 449.4 0 00510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 00142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z"
                }
            }
        ]
    },
    "name": "message",
    "theme": "outlined"
};
var $f551506b43790dee$export$2e2bcd8739ae039 = $f551506b43790dee$var$MessageOutlined;



var $34702b8cdd2f2497$var$MessageOutlined = function MessageOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $f551506b43790dee$export$2e2bcd8739ae039)
    }));
};
var $34702b8cdd2f2497$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($34702b8cdd2f2497$var$MessageOutlined);
var $34702b8cdd2f2497$export$2e2bcd8739ae039 = $34702b8cdd2f2497$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $fbfe4f7b4e01a2a5$var$MobileOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "mobile",
    "theme": "outlined"
};
var $fbfe4f7b4e01a2a5$export$2e2bcd8739ae039 = $fbfe4f7b4e01a2a5$var$MobileOutlined;



var $fb5ec7b17953b1c4$var$MobileOutlined = function MobileOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $fbfe4f7b4e01a2a5$export$2e2bcd8739ae039)
    }));
};
var $fb5ec7b17953b1c4$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($fb5ec7b17953b1c4$var$MobileOutlined);
var $fb5ec7b17953b1c4$export$2e2bcd8739ae039 = $fb5ec7b17953b1c4$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $31ae72153fd85223$var$MobileTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z",
                        "fill": primaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M472 786a40 40 0 1080 0 40 40 0 10-80 0z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "mobile",
    "theme": "twotone"
};
var $31ae72153fd85223$export$2e2bcd8739ae039 = $31ae72153fd85223$var$MobileTwoTone;



var $ab4bce0f06ced2d9$var$MobileTwoTone = function MobileTwoTone(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $31ae72153fd85223$export$2e2bcd8739ae039)
    }));
};
var $ab4bce0f06ced2d9$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($ab4bce0f06ced2d9$var$MobileTwoTone);
var $ab4bce0f06ced2d9$export$2e2bcd8739ae039 = $ab4bce0f06ced2d9$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $bf035cdec7f3db94$var$PhoneOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 01-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 00-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 00285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z"
                }
            }
        ]
    },
    "name": "phone",
    "theme": "outlined"
};
var $bf035cdec7f3db94$export$2e2bcd8739ae039 = $bf035cdec7f3db94$var$PhoneOutlined;



var $fd427e2a52ad3552$var$PhoneOutlined = function PhoneOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $bf035cdec7f3db94$export$2e2bcd8739ae039)
    }));
};
var $fd427e2a52ad3552$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($fd427e2a52ad3552$var$PhoneOutlined);
var $fd427e2a52ad3552$export$2e2bcd8739ae039 = $fd427e2a52ad3552$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $9e4b3d7a473d3094$var$PictureOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z"
                }
            }
        ]
    },
    "name": "picture",
    "theme": "outlined"
};
var $9e4b3d7a473d3094$export$2e2bcd8739ae039 = $9e4b3d7a473d3094$var$PictureOutlined;



var $59fdf667c4ec190a$var$PictureOutlined = function PictureOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $9e4b3d7a473d3094$export$2e2bcd8739ae039)
    }));
};
var $59fdf667c4ec190a$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($59fdf667c4ec190a$var$PictureOutlined);
var $59fdf667c4ec190a$export$2e2bcd8739ae039 = $59fdf667c4ec190a$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $e2570d1d2a529577$var$PlusCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    },
    "name": "plus-circle",
    "theme": "filled"
};
var $e2570d1d2a529577$export$2e2bcd8739ae039 = $e2570d1d2a529577$var$PlusCircleFilled;



var $1cd000ebab28847b$var$PlusCircleFilled = function PlusCircleFilled(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $e2570d1d2a529577$export$2e2bcd8739ae039)
    }));
};
var $1cd000ebab28847b$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($1cd000ebab28847b$var$PlusCircleFilled);
var $1cd000ebab28847b$export$2e2bcd8739ae039 = $1cd000ebab28847b$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $43111cc5abea1d39$var$PlusCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    },
    "name": "plus-circle",
    "theme": "outlined"
};
var $43111cc5abea1d39$export$2e2bcd8739ae039 = $43111cc5abea1d39$var$PlusCircleOutlined;



var $790517d03e06adcc$var$PlusCircleOutlined = function PlusCircleOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $43111cc5abea1d39$export$2e2bcd8739ae039)
    }));
};
var $790517d03e06adcc$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($790517d03e06adcc$var$PlusCircleOutlined);
var $790517d03e06adcc$export$2e2bcd8739ae039 = $790517d03e06adcc$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $d014ea3b4168f1fd$var$PlusSquareTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z",
                        "fill": primaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "plus-square",
    "theme": "twotone"
};
var $d014ea3b4168f1fd$export$2e2bcd8739ae039 = $d014ea3b4168f1fd$var$PlusSquareTwoTone;



var $aef4894c67616d0d$var$PlusSquareTwoTone = function PlusSquareTwoTone(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $d014ea3b4168f1fd$export$2e2bcd8739ae039)
    }));
};
var $aef4894c67616d0d$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($aef4894c67616d0d$var$PlusSquareTwoTone);
var $aef4894c67616d0d$export$2e2bcd8739ae039 = $aef4894c67616d0d$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $dad173fbc1ecf6e9$var$PrinterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z"
                }
            }
        ]
    },
    "name": "printer",
    "theme": "outlined"
};
var $dad173fbc1ecf6e9$export$2e2bcd8739ae039 = $dad173fbc1ecf6e9$var$PrinterOutlined;



var $28a9070bd488fc82$var$PrinterOutlined = function PrinterOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $dad173fbc1ecf6e9$export$2e2bcd8739ae039)
    }));
};
var $28a9070bd488fc82$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($28a9070bd488fc82$var$PrinterOutlined);
var $28a9070bd488fc82$export$2e2bcd8739ae039 = $28a9070bd488fc82$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $b8fd7859af55fb73$var$PushpinOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 00-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 00-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 01-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z"
                }
            }
        ]
    },
    "name": "pushpin",
    "theme": "outlined"
};
var $b8fd7859af55fb73$export$2e2bcd8739ae039 = $b8fd7859af55fb73$var$PushpinOutlined;



var $560e06db43c03a01$var$PushpinOutlined = function PushpinOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $b8fd7859af55fb73$export$2e2bcd8739ae039)
    }));
};
var $560e06db43c03a01$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($560e06db43c03a01$var$PushpinOutlined);
var $560e06db43c03a01$export$2e2bcd8739ae039 = $560e06db43c03a01$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $aa0280e290ea4262$var$ReloadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 00-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 01655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 01279 755.2a342.16 342.16 0 01-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 01109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z"
                }
            }
        ]
    },
    "name": "reload",
    "theme": "outlined"
};
var $aa0280e290ea4262$export$2e2bcd8739ae039 = $aa0280e290ea4262$var$ReloadOutlined;



var $104294e0a489d9fd$var$ReloadOutlined = function ReloadOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $aa0280e290ea4262$export$2e2bcd8739ae039)
    }));
};
var $104294e0a489d9fd$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($104294e0a489d9fd$var$ReloadOutlined);
var $104294e0a489d9fd$export$2e2bcd8739ae039 = $104294e0a489d9fd$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $652bf4a7e127a649$var$RobotOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M300 328a60 60 0 10120 0 60 60 0 10-120 0zM852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-32 660H204V128h616v596zM604 328a60 60 0 10120 0 60 60 0 10-120 0zm250.2 556H169.8c-16.5 0-29.8 14.3-29.8 32v36c0 4.4 3.3 8 7.4 8h729.1c4.1 0 7.4-3.6 7.4-8v-36c.1-17.7-13.2-32-29.7-32zM664 508H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "robot",
    "theme": "outlined"
};
var $652bf4a7e127a649$export$2e2bcd8739ae039 = $652bf4a7e127a649$var$RobotOutlined;



var $73999fbdbc44146e$var$RobotOutlined = function RobotOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $652bf4a7e127a649$export$2e2bcd8739ae039)
    }));
};
var $73999fbdbc44146e$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($73999fbdbc44146e$var$RobotOutlined);
var $73999fbdbc44146e$export$2e2bcd8739ae039 = $73999fbdbc44146e$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $e9fe8d354a35b80f$var$SaveOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"
                }
            }
        ]
    },
    "name": "save",
    "theme": "outlined"
};
var $e9fe8d354a35b80f$export$2e2bcd8739ae039 = $e9fe8d354a35b80f$var$SaveOutlined;



var $f37b312e553a188a$var$SaveOutlined = function SaveOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $e9fe8d354a35b80f$export$2e2bcd8739ae039)
    }));
};
var $f37b312e553a188a$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($f37b312e553a188a$var$SaveOutlined);
var $f37b312e553a188a$export$2e2bcd8739ae039 = $f37b312e553a188a$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $d5738e33e387a0e2$var$ScheduleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 136H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm308.2-177.4L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0025.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5z"
                }
            }
        ]
    },
    "name": "schedule",
    "theme": "outlined"
};
var $d5738e33e387a0e2$export$2e2bcd8739ae039 = $d5738e33e387a0e2$var$ScheduleOutlined;



var $bf4639b62f89209b$var$ScheduleOutlined = function ScheduleOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $d5738e33e387a0e2$export$2e2bcd8739ae039)
    }));
};
var $bf4639b62f89209b$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($bf4639b62f89209b$var$ScheduleOutlined);
var $bf4639b62f89209b$export$2e2bcd8739ae039 = $bf4639b62f89209b$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $019ca2352c5d1122$var$SendOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M931.4 498.9L94.9 79.5c-3.4-1.7-7.3-2.1-11-1.2a15.99 15.99 0 00-11.7 19.3l86.2 352.2c1.3 5.3 5.2 9.6 10.4 11.3l147.7 50.7-147.6 50.7c-5.2 1.8-9.1 6-10.3 11.3L72.2 926.5c-.9 3.7-.5 7.6 1.2 10.9 3.9 7.9 13.5 11.1 21.5 7.2l836.5-417c3.1-1.5 5.6-4.1 7.2-7.1 3.9-8 .7-17.6-7.2-21.6zM170.8 826.3l50.3-205.6 295.2-101.3c2.3-.8 4.2-2.6 5-5 1.4-4.2-.8-8.7-5-10.2L221.1 403 171 198.2l628 314.9-628.2 313.2z"
                }
            }
        ]
    },
    "name": "send",
    "theme": "outlined"
};
var $019ca2352c5d1122$export$2e2bcd8739ae039 = $019ca2352c5d1122$var$SendOutlined;



var $bfc5e0f858ca9368$var$SendOutlined = function SendOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $019ca2352c5d1122$export$2e2bcd8739ae039)
    }));
};
var $bfc5e0f858ca9368$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($bfc5e0f858ca9368$var$SendOutlined);
var $bfc5e0f858ca9368$export$2e2bcd8739ae039 = $bfc5e0f858ca9368$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $457e57cf83eb1cd6$var$SettingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 009.3-35.2l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5a449.4 449.4 0 00159 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2z"
                }
            }
        ]
    },
    "name": "setting",
    "theme": "outlined"
};
var $457e57cf83eb1cd6$export$2e2bcd8739ae039 = $457e57cf83eb1cd6$var$SettingOutlined;



var $70469b58bfd64ab3$var$SettingOutlined = function SettingOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $457e57cf83eb1cd6$export$2e2bcd8739ae039)
    }));
};
var $70469b58bfd64ab3$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($70469b58bfd64ab3$var$SettingOutlined);
var $70469b58bfd64ab3$export$2e2bcd8739ae039 = $70469b58bfd64ab3$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $4b5421c171dde2eb$var$SmileOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm352 0a48 48 0 1096 0 48 48 0 10-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 01248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 01249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 01775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 01775 775zM664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 00-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 00-8-8.4z"
                }
            }
        ]
    },
    "name": "smile",
    "theme": "outlined"
};
var $4b5421c171dde2eb$export$2e2bcd8739ae039 = $4b5421c171dde2eb$var$SmileOutlined;



var $fc6eb82020815110$var$SmileOutlined = function SmileOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $4b5421c171dde2eb$export$2e2bcd8739ae039)
    }));
};
var $fc6eb82020815110$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($fc6eb82020815110$var$SmileOutlined);
var $fc6eb82020815110$export$2e2bcd8739ae039 = $fc6eb82020815110$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $fc9c5e6f977be8f6$var$StopOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z"
                }
            }
        ]
    },
    "name": "stop",
    "theme": "outlined"
};
var $fc9c5e6f977be8f6$export$2e2bcd8739ae039 = $fc9c5e6f977be8f6$var$StopOutlined;



var $5d7bdd071c827bc0$var$StopOutlined = function StopOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $fc9c5e6f977be8f6$export$2e2bcd8739ae039)
    }));
};
var $5d7bdd071c827bc0$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($5d7bdd071c827bc0$var$StopOutlined);
var $5d7bdd071c827bc0$export$2e2bcd8739ae039 = $5d7bdd071c827bc0$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $83fb2d732ccd9cff$var$SwapOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "swap",
    "theme": "outlined"
};
var $83fb2d732ccd9cff$export$2e2bcd8739ae039 = $83fb2d732ccd9cff$var$SwapOutlined;



var $14cfe26aa22fe24f$var$SwapOutlined = function SwapOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $83fb2d732ccd9cff$export$2e2bcd8739ae039)
    }));
};
var $14cfe26aa22fe24f$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($14cfe26aa22fe24f$var$SwapOutlined);
var $14cfe26aa22fe24f$export$2e2bcd8739ae039 = $14cfe26aa22fe24f$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $ad06d587ae98c52c$var$SyncOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 01755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 01512.1 856a342.24 342.24 0 01-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 00-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 00-8-8.2z"
                }
            }
        ]
    },
    "name": "sync",
    "theme": "outlined"
};
var $ad06d587ae98c52c$export$2e2bcd8739ae039 = $ad06d587ae98c52c$var$SyncOutlined;



var $8a4e9e4d8385f177$var$SyncOutlined = function SyncOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $ad06d587ae98c52c$export$2e2bcd8739ae039)
    }));
};
var $8a4e9e4d8385f177$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($8a4e9e4d8385f177$var$SyncOutlined);
var $8a4e9e4d8385f177$export$2e2bcd8739ae039 = $8a4e9e4d8385f177$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $e4e977f660e90cb8$var$TagOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    },
    "name": "tag",
    "theme": "outlined"
};
var $e4e977f660e90cb8$export$2e2bcd8739ae039 = $e4e977f660e90cb8$var$TagOutlined;



var $ab9eae44195c9daa$var$TagOutlined = function TagOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $e4e977f660e90cb8$export$2e2bcd8739ae039)
    }));
};
var $ab9eae44195c9daa$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($ab9eae44195c9daa$var$TagOutlined);
var $ab9eae44195c9daa$export$2e2bcd8739ae039 = $ab9eae44195c9daa$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $584592960cdbc641$var$TeamOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M824.2 699.9a301.55 301.55 0 00-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 01612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 008-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 01612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z"
                }
            }
        ]
    },
    "name": "team",
    "theme": "outlined"
};
var $584592960cdbc641$export$2e2bcd8739ae039 = $584592960cdbc641$var$TeamOutlined;



var $7aefd47409106a35$var$TeamOutlined = function TeamOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $584592960cdbc641$export$2e2bcd8739ae039)
    }));
};
var $7aefd47409106a35$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($7aefd47409106a35$var$TeamOutlined);
var $7aefd47409106a35$export$2e2bcd8739ae039 = $7aefd47409106a35$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $0f19e5d91e917c46$var$ToolFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M865.3 244.7c-.3-.3-61.1 59.8-182.1 180.6l-84.9-84.9 180.9-180.9c-95.2-57.3-217.5-42.6-296.8 36.7A244.42 244.42 0 00419 432l1.8 6.7-283.5 283.4c-6.2 6.2-6.2 16.4 0 22.6l141.4 141.4c6.2 6.2 16.4 6.2 22.6 0l283.3-283.3 6.7 1.8c83.7 22.3 173.6-.9 236-63.3 79.4-79.3 94.1-201.6 38-296.6z"
                }
            }
        ]
    },
    "name": "tool",
    "theme": "filled"
};
var $0f19e5d91e917c46$export$2e2bcd8739ae039 = $0f19e5d91e917c46$var$ToolFilled;



var $4ec06a4e9b8c9a54$var$ToolFilled = function ToolFilled(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $0f19e5d91e917c46$export$2e2bcd8739ae039)
    }));
};
var $4ec06a4e9b8c9a54$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($4ec06a4e9b8c9a54$var$ToolFilled);
var $4ec06a4e9b8c9a54$export$2e2bcd8739ae039 = $4ec06a4e9b8c9a54$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $5e62d2eb865340e3$var$TranslationOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M140 188h584v164h76V144c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h544v-76H140V188z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M414.3 256h-60.6c-3.4 0-6.4 2.2-7.6 5.4L219 629.4c-.3.8-.4 1.7-.4 2.6 0 4.4 3.6 8 8 8h55.1c3.4 0 6.4-2.2 7.6-5.4L322 540h196.2L422 261.4a8.42 8.42 0 00-7.7-5.4zm12.4 228h-85.5L384 360.2 426.7 484zM936 528H800v-93c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v93H592c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24h136v152c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V752h136c13.3 0 24-10.7 24-24V552c0-13.3-10.7-24-24-24zM728 680h-88v-80h88v80zm160 0h-88v-80h88v80z"
                }
            }
        ]
    },
    "name": "translation",
    "theme": "outlined"
};
var $5e62d2eb865340e3$export$2e2bcd8739ae039 = $5e62d2eb865340e3$var$TranslationOutlined;



var $2bed8d310734df3f$var$TranslationOutlined = function TranslationOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $5e62d2eb865340e3$export$2e2bcd8739ae039)
    }));
};
var $2bed8d310734df3f$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($2bed8d310734df3f$var$TranslationOutlined);
var $2bed8d310734df3f$export$2e2bcd8739ae039 = $2bed8d310734df3f$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $2404c56138d4f658$var$UndoOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 00-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 00-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z"
                }
            }
        ]
    },
    "name": "undo",
    "theme": "outlined"
};
var $2404c56138d4f658$export$2e2bcd8739ae039 = $2404c56138d4f658$var$UndoOutlined;



var $8ff1831dfd9aa155$var$UndoOutlined = function UndoOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $2404c56138d4f658$export$2e2bcd8739ae039)
    }));
};
var $8ff1831dfd9aa155$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($8ff1831dfd9aa155$var$UndoOutlined);
var $8ff1831dfd9aa155$export$2e2bcd8739ae039 = $8ff1831dfd9aa155$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $a635d5524c6de822$var$UnorderedListOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "unordered-list",
    "theme": "outlined"
};
var $a635d5524c6de822$export$2e2bcd8739ae039 = $a635d5524c6de822$var$UnorderedListOutlined;



var $00686183a293aac8$var$UnorderedListOutlined = function UnorderedListOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $a635d5524c6de822$export$2e2bcd8739ae039)
    }));
};
var $00686183a293aac8$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($00686183a293aac8$var$UnorderedListOutlined);
var $00686183a293aac8$export$2e2bcd8739ae039 = $00686183a293aac8$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $2515ccdde9446d46$var$UserAddOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 00-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00137 888.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 008.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 01340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 01683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "user-add",
    "theme": "outlined"
};
var $2515ccdde9446d46$export$2e2bcd8739ae039 = $2515ccdde9446d46$var$UserAddOutlined;



var $b9656fef745ec0a7$var$UserAddOutlined = function UserAddOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $2515ccdde9446d46$export$2e2bcd8739ae039)
    }));
};
var $b9656fef745ec0a7$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($b9656fef745ec0a7$var$UserAddOutlined);
var $b9656fef745ec0a7$export$2e2bcd8739ae039 = $b9656fef745ec0a7$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $da13f67c3cc37067$var$UsergroupAddOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M892 772h-80v-80c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v80h-80c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-80h80c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 498.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.8-1.7-203.2 89.2-203.2 200 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.8-1.1 6.4-4.8 5.9-8.8zM824 472c0-109.4-87.9-198.3-196.9-200C516.3 270.3 424 361.2 424 472c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C357 742.6 326 814.8 324 891.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 695.7 563 672 624 672c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 586.7 658.2 600 624 600s-66.3-13.3-90.5-37.5a127.26 127.26 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z"
                }
            }
        ]
    },
    "name": "usergroup-add",
    "theme": "outlined"
};
var $da13f67c3cc37067$export$2e2bcd8739ae039 = $da13f67c3cc37067$var$UsergroupAddOutlined;



var $139fb6a0dd94d98d$var$UsergroupAddOutlined = function UsergroupAddOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $da13f67c3cc37067$export$2e2bcd8739ae039)
    }));
};
var $139fb6a0dd94d98d$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($139fb6a0dd94d98d$var$UsergroupAddOutlined);
var $139fb6a0dd94d98d$export$2e2bcd8739ae039 = $139fb6a0dd94d98d$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $25f04e9e45aac586$var$UsergroupDeleteOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M888 784H664c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7zM824 484c0-109.4-87.9-198.3-196.9-200C516.3 282.3 424 373.2 424 484c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C357 754.6 326 826.8 324 903.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 707.7 563 684 624 684c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 598.7 658.2 612 624 612s-66.3-13.3-90.5-37.5a127.26 127.26 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z"
                }
            }
        ]
    },
    "name": "usergroup-delete",
    "theme": "outlined"
};
var $25f04e9e45aac586$export$2e2bcd8739ae039 = $25f04e9e45aac586$var$UsergroupDeleteOutlined;



var $fd18eafcbb7e612f$var$UsergroupDeleteOutlined = function UsergroupDeleteOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $25f04e9e45aac586$export$2e2bcd8739ae039)
    }));
};
var $fd18eafcbb7e612f$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($fd18eafcbb7e612f$var$UsergroupDeleteOutlined);
var $fd18eafcbb7e612f$export$2e2bcd8739ae039 = $fd18eafcbb7e612f$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $f56f51575879d96a$var$UserOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"
                }
            }
        ]
    },
    "name": "user",
    "theme": "outlined"
};
var $f56f51575879d96a$export$2e2bcd8739ae039 = $f56f51575879d96a$var$UserOutlined;



var $f3fb1de77e65387d$var$UserOutlined = function UserOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $f56f51575879d96a$export$2e2bcd8739ae039)
    }));
};
var $f3fb1de77e65387d$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($f3fb1de77e65387d$var$UserOutlined);
var $f3fb1de77e65387d$export$2e2bcd8739ae039 = $f3fb1de77e65387d$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $c81a5828b1e143c9$var$UserSwitchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M759 335c0-137-111-248-248-248S263 198 263 335c0 82.8 40.6 156.2 103 201.2-.4.2-.7.3-.9.4-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00136 874.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C356 614.2 431 583 511 583c137 0 248-111 248-248zM511 507c-95 0-172-77-172-172s77-172 172-172 172 77 172 172-77 172-172 172zm105 221h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H703.5l47.2-60.1a8.1 8.1 0 001.7-4.9c0-4.4-3.6-8-8-8h-72.6c-4.9 0-9.5 2.3-12.6 6.1l-68.5 87.1c-4.4 5.6-6.8 12.6-6.8 19.8.1 17.7 14.4 32 32.1 32zm240 64H592c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h176.5l-47.2 60.1a8.1 8.1 0 00-1.7 4.9c0 4.4 3.6 8 8 8h72.6c4.9 0 9.5-2.3 12.6-6.1l68.5-87.1c4.4-5.6 6.8-12.6 6.8-19.8-.1-17.7-14.4-32-32.1-32z"
                }
            }
        ]
    },
    "name": "user-switch",
    "theme": "outlined"
};
var $c81a5828b1e143c9$export$2e2bcd8739ae039 = $c81a5828b1e143c9$var$UserSwitchOutlined;



var $14e48b6abe83a6ea$var$UserSwitchOutlined = function UserSwitchOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $c81a5828b1e143c9$export$2e2bcd8739ae039)
    }));
};
var $14e48b6abe83a6ea$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($14e48b6abe83a6ea$var$UserSwitchOutlined);
var $14e48b6abe83a6ea$export$2e2bcd8739ae039 = $14e48b6abe83a6ea$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $47f2f5c1936d7fa3$var$VideoCameraOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226zM208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    },
    "name": "video-camera",
    "theme": "outlined"
};
var $47f2f5c1936d7fa3$export$2e2bcd8739ae039 = $47f2f5c1936d7fa3$var$VideoCameraOutlined;



var $d2288c3b4773575a$var$VideoCameraOutlined = function VideoCameraOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $47f2f5c1936d7fa3$export$2e2bcd8739ae039)
    }));
};
var $d2288c3b4773575a$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($d2288c3b4773575a$var$VideoCameraOutlined);
var $d2288c3b4773575a$export$2e2bcd8739ae039 = $d2288c3b4773575a$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $355a76a9fa1f2eeb$var$WarningFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "warning",
    "theme": "filled"
};
var $355a76a9fa1f2eeb$export$2e2bcd8739ae039 = $355a76a9fa1f2eeb$var$WarningFilled;



var $d6a61d49428c173c$var$WarningFilled = function WarningFilled(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $355a76a9fa1f2eeb$export$2e2bcd8739ae039)
    }));
};
var $d6a61d49428c173c$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($d6a61d49428c173c$var$WarningFilled);
var $d6a61d49428c173c$export$2e2bcd8739ae039 = $d6a61d49428c173c$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $94371caeaf95cdb4$var$WechatFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 019.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 006.4-2.6 9 9 0 002.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 01-36 35.9z"
                }
            }
        ]
    },
    "name": "wechat",
    "theme": "filled"
};
var $94371caeaf95cdb4$export$2e2bcd8739ae039 = $94371caeaf95cdb4$var$WechatFilled;



var $288748fd086449c0$var$WechatFilled = function WechatFilled(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $94371caeaf95cdb4$export$2e2bcd8739ae039)
    }));
};
var $288748fd086449c0$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($288748fd086449c0$var$WechatFilled);
var $288748fd086449c0$export$2e2bcd8739ae039 = $288748fd086449c0$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $610d8bb98f7c2aba$var$WechatOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 019.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 006.4-2.6 9 9 0 002.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 01-36 35.9z"
                }
            }
        ]
    },
    "name": "wechat",
    "theme": "outlined"
};
var $610d8bb98f7c2aba$export$2e2bcd8739ae039 = $610d8bb98f7c2aba$var$WechatOutlined;



var $794ecf3026f9f5ba$var$WechatOutlined = function WechatOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $610d8bb98f7c2aba$export$2e2bcd8739ae039)
    }));
};
var $794ecf3026f9f5ba$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($794ecf3026f9f5ba$var$WechatOutlined);
var $794ecf3026f9f5ba$export$2e2bcd8739ae039 = $794ecf3026f9f5ba$var$RefIcon;


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $4c533b66509a908b$var$WindowsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M120.1 770.6L443 823.2V543.8H120.1v226.8zm63.4-163.5h196.2v141.6l-196.2-31.9V607.1zm340.3 226.5l382 62.2v-352h-382v289.8zm63.4-226.5h255.3v214.4l-255.3-41.6V607.1zm-63.4-415.7v288.8h382V128.1l-382 63.3zm318.7 225.5H587.3V245l255.3-42.3v214.2zm-722.4 63.3H443V201.9l-322.9 53.5v224.8zM183.5 309l196.2-32.5v140.4H183.5V309z"
                }
            }
        ]
    },
    "name": "windows",
    "theme": "outlined"
};
var $4c533b66509a908b$export$2e2bcd8739ae039 = $4c533b66509a908b$var$WindowsOutlined;



var $90f770e65b8bbb46$var$WindowsOutlined = function WindowsOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $4c533b66509a908b$export$2e2bcd8739ae039)
    }));
};
var $90f770e65b8bbb46$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($90f770e65b8bbb46$var$WindowsOutlined);
var $90f770e65b8bbb46$export$2e2bcd8739ae039 = $90f770e65b8bbb46$var$RefIcon;



var $6fFrj = parcelRequire("6fFrj");
var $e990c645e6d287ad$var$__assign = undefined && undefined.__assign || function() {
    $e990c645e6d287ad$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e990c645e6d287ad$var$__assign.apply(this, arguments);
};
var $e990c645e6d287ad$var$ChevronDown = function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", $e990c645e6d287ad$var$__assign({
        // width="20"
        // height="20"
        viewBox: "0 0 20 20",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.30376 15.3007L1.55203 7.64881C0.849497 6.85356 0.775861 5.55638 1.57326 4.7113C2.30483 3.90831 3.53255 3.825 4.30771 4.7442L9.99485 11.1885L15.7087 4.64403C16.443 3.8228 17.6902 3.73735 18.4683 4.67671C19.1524 5.47383 19.2165 6.75543 18.4249 7.59214L11.7643 15.1446L11.7417 15.1667C11.7249 15.1831 11.7057 15.203 11.6736 15.2362C11.6648 15.2454 11.6549 15.2557 11.6438 15.2671C11.5989 15.3136 11.5409 15.373 11.4769 15.4337C11.3628 15.5419 11.168 15.7147 10.9269 15.8215C10.5578 15.9848 10.215 16 9.99992 16C9.30099 16 8.76678 15.6816 8.37881 15.3625L8.30376 15.3007Z"
    }));
};
var $e990c645e6d287ad$export$2e2bcd8739ae039 = $e990c645e6d287ad$var$ChevronDown;



var $6fFrj = parcelRequire("6fFrj");
var $80b77d3b68b851f2$var$__assign = undefined && undefined.__assign || function() {
    $80b77d3b68b851f2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $80b77d3b68b851f2$var$__assign.apply(this, arguments);
};
var $80b77d3b68b851f2$var$Circle = function(props) {
    var title = props.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", $80b77d3b68b851f2$var$__assign({
        width: "1em",
        height: "1em",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        shapeRendering: "geometricPrecision",
        viewBox: "0 0 25 25",
        focusable: "false"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        strokeWidth: "3",
        fill: "transparent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("title", null, title)));
};
var $80b77d3b68b851f2$export$2e2bcd8739ae039 = $80b77d3b68b851f2$var$Circle;



var $6fFrj = parcelRequire("6fFrj");
var $a3aab24a49cfd524$var$__assign = undefined && undefined.__assign || function() {
    $a3aab24a49cfd524$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a3aab24a49cfd524$var$__assign.apply(this, arguments);
};
var $a3aab24a49cfd524$var$HandleBar = function(props) {
    var title = props.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", $a3aab24a49cfd524$var$__assign({
        viewBox: "64 64 896 896",
        focusable: "false",
        width: "20",
        height: "20",
        fill: "currentColor",
        "aria-hidden": "true"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
        d: "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("title", null, title)));
};
var $a3aab24a49cfd524$export$2e2bcd8739ae039 = $a3aab24a49cfd524$var$HandleBar;


var $f62360d97c6e7e3d$export$2e2bcd8739ae039 = {
    ChevronDownBold: (0, $e990c645e6d287ad$export$2e2bcd8739ae039),
    Circle: (0, $80b77d3b68b851f2$export$2e2bcd8739ae039),
    HandleBar: (0, $a3aab24a49cfd524$export$2e2bcd8739ae039),
    BulbOutlined: (0, $f64518499a4fb680$export$2e2bcd8739ae039),
    DashboardOutlined: (0, $a20907b54279d5ba$export$2e2bcd8739ae039),
    CalendarOutlined: (0, $2c8de0c8eaf4f5c0$export$2e2bcd8739ae039),
    MessageOutlined: (0, $34702b8cdd2f2497$export$2e2bcd8739ae039),
    EditOutlined: (0, $88348658f25c3b04$export$2e2bcd8739ae039),
    BarChartOutlined: (0, $463d007432312983$export$2e2bcd8739ae039),
    SettingOutlined: (0, $70469b58bfd64ab3$export$2e2bcd8739ae039),
    LeftOutlined: (0, $ae5877404f2a0345$export$2e2bcd8739ae039),
    RightOutlined: (0, $e7bd83ac29db4850$export$2e2bcd8739ae039),
    DownOutlined: (0, $344ef0cbd3adff87$export$2e2bcd8739ae039),
    UserOutlined: (0, $f3fb1de77e65387d$export$2e2bcd8739ae039),
    UnorderedListOutlined: (0, $00686183a293aac8$export$2e2bcd8739ae039),
    InboxOutlined: (0, $1fe526a850b3b089$export$2e2bcd8739ae039),
    FolderOpenOutlined: (0, $b35b50fcc668a8ed$export$2e2bcd8739ae039),
    CheckOutlined: (0, $97e498ed1184adf1$export$2e2bcd8739ae039),
    MenuOutlined: (0, $a6a04a0106e14094$export$2e2bcd8739ae039),
    LinkOutlined: (0, $2e124d85086d77f3$export$2e2bcd8739ae039),
    CopyOutlined: (0, $c038d55eb32ecd6b$export$2e2bcd8739ae039),
    InfoCircleOutlined: (0, $60bea5c3f0793107$export$2e2bcd8739ae039),
    PrinterOutlined: (0, $28a9070bd488fc82$export$2e2bcd8739ae039),
    CloudOutlined: (0, $c381dc84ef659a87$export$2e2bcd8739ae039),
    CloudDownloadOutlined: (0, $68c44dc06def2993$export$2e2bcd8739ae039),
    PlusOutlined: (0, $dfe3e0e661ee2f16$export$2e2bcd8739ae039),
    UserAddOutlined: (0, $b9656fef745ec0a7$export$2e2bcd8739ae039),
    CloudUploadOutlined: (0, $0cbe1920d2403395$export$2e2bcd8739ae039),
    FileAddOutlined: (0, $fcd2424c0c464cbe$export$2e2bcd8739ae039),
    CalendarFilled: (0, $7abf264acbeec97b$export$2e2bcd8739ae039),
    CalendarTwoTone: (0, $207db351f0724b47$export$2e2bcd8739ae039),
    ClockCircleOutlined: (0, $9824e6cb0e907529$export$2e2bcd8739ae039),
    HourglassOutlined: (0, $9d073373336b7dc4$export$2e2bcd8739ae039),
    PushpinOutlined: (0, $560e06db43c03a01$export$2e2bcd8739ae039),
    TeamOutlined: (0, $7aefd47409106a35$export$2e2bcd8739ae039),
    PhoneOutlined: (0, $fd427e2a52ad3552$export$2e2bcd8739ae039),
    HomeOutlined: (0, $8c1e96cbe9d7c5e8$export$2e2bcd8739ae039),
    DesktopOutlined: (0, $e453b8b6b5ad3749$export$2e2bcd8739ae039),
    CoffeeOutlined: (0, $8cd47d2c217339e1$export$2e2bcd8739ae039),
    DeleteOutlined: (0, $0ccc7a2b4648ccac$export$2e2bcd8739ae039),
    ExclamationCircleOutlined: (0, $5a26a3af64ff8e01$export$2e2bcd8739ae039),
    UsergroupAddOutlined: (0, $139fb6a0dd94d98d$export$2e2bcd8739ae039),
    DownloadOutlined: (0, $2a7b50db1abe79fd$export$2e2bcd8739ae039),
    MailOutlined: (0, $4833597913ab9bd3$export$2e2bcd8739ae039),
    FileOutlined: (0, $4cde82d2a4ea2cd1$export$2e2bcd8739ae039),
    FormOutlined: (0, $d735dd92a3f8793e$export$2e2bcd8739ae039),
    CheckCircleOutlined: (0, $996a31538a9d5bb4$export$2e2bcd8739ae039),
    DollarOutlined: (0, $51a61f5300870abf$export$2e2bcd8739ae039),
    LikeOutlined: (0, $1c948112d2b074e5$export$2e2bcd8739ae039),
    ScheduleOutlined: (0, $bf4639b62f89209b$export$2e2bcd8739ae039),
    VideoCameraOutlined: (0, $d2288c3b4773575a$export$2e2bcd8739ae039),
    CloseCircleOutlined: (0, $83dc1c57eab38fbc$export$2e2bcd8739ae039),
    CloseOutlined: (0, $4cb3f1f073816266$export$2e2bcd8739ae039),
    LoadingOutlined: (0, $3240b41b65b5dac9$export$2e2bcd8739ae039),
    MobileTwoTone: (0, $ab4bce0f06ced2d9$export$2e2bcd8739ae039),
    PaperClipOutlined: (0, $1597dd9bb1148789$export$2e2bcd8739ae039),
    SendOutlined: (0, $bfc5e0f858ca9368$export$2e2bcd8739ae039),
    SmileOutlined: (0, $fc6eb82020815110$export$2e2bcd8739ae039),
    QuestionCircleOutlined: (0, $1793aba1e6a16988$export$2e2bcd8739ae039),
    MobileOutlined: (0, $fb5ec7b17953b1c4$export$2e2bcd8739ae039),
    WechatFilled: (0, $288748fd086449c0$export$2e2bcd8739ae039),
    WechatOutlined: (0, $794ecf3026f9f5ba$export$2e2bcd8739ae039),
    UsergroupDeleteOutlined: (0, $fd18eafcbb7e612f$export$2e2bcd8739ae039),
    PlusSquareTwoTone: (0, $aef4894c67616d0d$export$2e2bcd8739ae039),
    MenuUnfoldOutlined: (0, $c2f330c5232bc2dc$export$2e2bcd8739ae039),
    MenuFoldOutlined: (0, $3d5af726d5e6b537$export$2e2bcd8739ae039),
    PlusCircleFilled: (0, $1cd000ebab28847b$export$2e2bcd8739ae039),
    TranslationOutlined: (0, $2bed8d310734df3f$export$2e2bcd8739ae039),
    FullscreenOutlined: (0, $436a9dbf290cd345$export$2e2bcd8739ae039),
    PlusCircleOutlined: (0, $790517d03e06adcc$export$2e2bcd8739ae039),
    SwapOutlined: (0, $14cfe26aa22fe24f$export$2e2bcd8739ae039),
    PictureTwoTone: (0, $ae8c3535cd876a71$export$2e2bcd8739ae039),
    CheckCircleTwoTone: (0, $5b171aec1295c863$export$2e2bcd8739ae039),
    CheckCircleFilled: (0, $a539793a765f8968$export$2e2bcd8739ae039),
    DragOutlined: (0, $f28b9bb416ebdab1$export$2e2bcd8739ae039),
    InfoCircleTwoTone: (0, $646bfab0dc84d404$export$2e2bcd8739ae039),
    EllipsisOutlined: (0, $982a9c0f9e1ff223$export$2e2bcd8739ae039),
    ReloadOutlined: (0, $104294e0a489d9fd$export$2e2bcd8739ae039),
    UndoOutlined: (0, $8ff1831dfd9aa155$export$2e2bcd8739ae039),
    SaveOutlined: (0, $f37b312e553a188a$export$2e2bcd8739ae039),
    SyncOutlined: (0, $8a4e9e4d8385f177$export$2e2bcd8739ae039),
    EyeOutlined: (0, $eca7e40229c3d459$export$2e2bcd8739ae039),
    AppleOutlined: (0, $d14a4157864152af$export$2e2bcd8739ae039),
    WindowsOutlined: (0, $90f770e65b8bbb46$export$2e2bcd8739ae039),
    LaptopOutlined: (0, $84d74f042482ef70$export$2e2bcd8739ae039),
    ApiOutlined: (0, $fcba857743b4bdb3$export$2e2bcd8739ae039),
    BgColorsOutlined: (0, $49f5a0bb3d2ed4da$export$2e2bcd8739ae039),
    ArrowDownOutlined: (0, $de57d19d5d51a7e8$export$2e2bcd8739ae039),
    HighlightOutlined: (0, $c27bdb2761765bf0$export$2e2bcd8739ae039),
    DeleteTwoTone: (0, $de47a51a480c0f82$export$2e2bcd8739ae039),
    HighlightTwoTone: (0, $0cc8834b873afb0a$export$2e2bcd8739ae039),
    EditTwoTone: (0, $e99c463f3db5d26f$export$2e2bcd8739ae039),
    LockFilled: (0, $f8d4ada68a8c7ad7$export$2e2bcd8739ae039),
    WarningFilled: (0, $d6a61d49428c173c$export$2e2bcd8739ae039),
    ToolFilled: (0, $4ec06a4e9b8c9a54$export$2e2bcd8739ae039),
    BankOutlined: (0, $923ad284c7e7c01f$export$2e2bcd8739ae039),
    PictureOutlined: (0, $59fdf667c4ec190a$export$2e2bcd8739ae039),
    FormatPainterOutlined: (0, $55708caa31c4d8e9$export$2e2bcd8739ae039),
    CreditCardOutlined: (0, $1089a0c68d382406$export$2e2bcd8739ae039),
    AppstoreAddOutlined: (0, $0b18e607ccfd1e7a$export$2e2bcd8739ae039),
    CodeOutlined: (0, $97364f466b54923c$export$2e2bcd8739ae039),
    ApartmentOutlined: (0, $ae76d9d871e3b56f$export$2e2bcd8739ae039),
    LockOutlined: (0, $a8cdd3c5c720cb5b$export$2e2bcd8739ae039),
    StopOutlined: (0, $5d7bdd071c827bc0$export$2e2bcd8739ae039),
    TagOutlined: (0, $ab9eae44195c9daa$export$2e2bcd8739ae039),
    RobotOutlined: (0, $73999fbdbc44146e$export$2e2bcd8739ae039),
    UserSwitchOutlined: (0, $14e48b6abe83a6ea$export$2e2bcd8739ae039),
    FilterOutlined: (0, $2ee09c629f9f231d$export$2e2bcd8739ae039)
};


var $8097886f86aed232$var$__assign = undefined && undefined.__assign || function() {
    $8097886f86aed232$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8097886f86aed232$var$__assign.apply(this, arguments);
};
var $8097886f86aed232$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8097886f86aed232$var$Text = (0, $e8201deab6acaf74$export$2e2bcd8739ae039).Text;
var $8097886f86aed232$var$FolderOpenOutlined = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039).FolderOpenOutlined;
var $8097886f86aed232$var$EmptyTable = function(_a) {
    var _b = _a.title, title = _b === void 0 ? 'No Data' : _b, _c = _a.icon, icon = _c === void 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($8097886f86aed232$var$FolderOpenOutlined, {
        style: {
            fontSize: 60
        }
    }) : _c, extra = _a.extra;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        style: {
            padding: '15px 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        justify: "center"
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        justify: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($8097886f86aed232$var$Text, {
        style: {
            color: 'gray'
        }
    }, title)), extra);
};
var $8097886f86aed232$var$Table = function(_a) {
    var className = _a.className, noDataProps = _a.noDataProps, rest = $8097886f86aed232$var$__rest(_a, [
        "className",
        "noDataProps"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $5c207ce4beedc4d7$export$2e2bcd8739ae039), $8097886f86aed232$var$__assign({
        locale: {
            emptyText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($8097886f86aed232$var$EmptyTable, $8097886f86aed232$var$__assign({}, noDataProps))
        }
    }, rest));
};
var $8097886f86aed232$export$2e2bcd8739ae039 = $8097886f86aed232$var$Table;


var $2eb2b7b37988b8f9$export$2e2bcd8739ae039 = (0, $8097886f86aed232$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $3e7201ce9921e05b$var$extendStatics = function(d, b) {
    $3e7201ce9921e05b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $3e7201ce9921e05b$var$extendStatics(d, b);
};
function $3e7201ce9921e05b$var$__extends(d, b) {
    $3e7201ce9921e05b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3e7201ce9921e05b$var$__assign = function() {
    $3e7201ce9921e05b$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3e7201ce9921e05b$var$__assign.apply(this, arguments);
};
/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */ function $3e7201ce9921e05b$var$throttle(delay, noTrailing, callback, debounceMode) {
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.
    var lastExec = 0; // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    } // Function to cancel next exec
    function cancel() {
        clearExistingTimeout();
        cancelled = true;
    } // `noTrailing` defaults to falsy.
    if (typeof noTrailing !== 'boolean') {
        debounceMode = callback;
        callback = noTrailing;
        noTrailing = undefined;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        var self = this;
        var elapsed = Date.now() - lastExec;
        var args = arguments;
        if (cancelled) return;
         // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, args);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */ exec();
        else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel; // Return the wrapper function.
    return wrapper;
}
var $3e7201ce9921e05b$var$ThresholdUnits = {
    Pixel: 'Pixel',
    Percent: 'Percent'
};
var $3e7201ce9921e05b$var$defaultThreshold = {
    unit: $3e7201ce9921e05b$var$ThresholdUnits.Percent,
    value: 0.8
};
function $3e7201ce9921e05b$var$parseThreshold(scrollThreshold) {
    if (typeof scrollThreshold === 'number') return {
        unit: $3e7201ce9921e05b$var$ThresholdUnits.Percent,
        value: scrollThreshold * 100
    };
    if (typeof scrollThreshold === 'string') {
        if (scrollThreshold.match(/^(\d*(\.\d+)?)px$/)) return {
            unit: $3e7201ce9921e05b$var$ThresholdUnits.Pixel,
            value: parseFloat(scrollThreshold)
        };
        if (scrollThreshold.match(/^(\d*(\.\d+)?)%$/)) return {
            unit: $3e7201ce9921e05b$var$ThresholdUnits.Percent,
            value: parseFloat(scrollThreshold)
        };
        console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...');
        return $3e7201ce9921e05b$var$defaultThreshold;
    }
    console.warn('scrollThreshold should be string or number');
    return $3e7201ce9921e05b$var$defaultThreshold;
}
var $3e7201ce9921e05b$var$InfiniteScroll = /** @class */ function(_super) {
    $3e7201ce9921e05b$var$__extends(InfiniteScroll, _super);
    function InfiniteScroll(props) {
        var _this = _super.call(this, props) || this;
        _this.lastScrollTop = 0;
        _this.actionTriggered = false;
        // variables to keep track of pull down behaviour
        _this.startY = 0;
        _this.currentY = 0;
        _this.dragging = false;
        // will be populated in componentDidMount
        // based on the height of the pull down element
        _this.maxPullDownDistance = 0;
        _this.getScrollableTarget = function() {
            if (_this.props.scrollableTarget instanceof HTMLElement) return _this.props.scrollableTarget;
            if (typeof _this.props.scrollableTarget === 'string') return document.getElementById(_this.props.scrollableTarget);
            if (_this.props.scrollableTarget === null) console.warn("You are trying to pass scrollableTarget but it is null. This might\n        happen because the element may not have been added to DOM yet.\n        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.\n      ");
            return null;
        };
        _this.onStart = function(evt) {
            if (_this.lastScrollTop) return;
            _this.dragging = true;
            if (evt instanceof MouseEvent) _this.startY = evt.pageY;
            else if (evt instanceof TouchEvent) _this.startY = evt.touches[0].pageY;
            _this.currentY = _this.startY;
            if (_this._infScroll) {
                _this._infScroll.style.willChange = 'transform';
                _this._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)";
            }
        };
        _this.onMove = function(evt) {
            if (!_this.dragging) return;
            if (evt instanceof MouseEvent) _this.currentY = evt.pageY;
            else if (evt instanceof TouchEvent) _this.currentY = evt.touches[0].pageY;
            // user is scrolling down to up
            if (_this.currentY < _this.startY) return;
            if (_this.currentY - _this.startY >= Number(_this.props.pullDownToRefreshThreshold)) _this.setState({
                pullToRefreshThresholdBreached: true
            });
            // so you can drag upto 1.5 times of the maxPullDownDistance
            if (_this.currentY - _this.startY > _this.maxPullDownDistance * 1.5) return;
            if (_this._infScroll) {
                _this._infScroll.style.overflow = 'visible';
                _this._infScroll.style.transform = "translate3d(0px, " + (_this.currentY - _this.startY) + "px, 0px)";
            }
        };
        _this.onEnd = function() {
            _this.startY = 0;
            _this.currentY = 0;
            _this.dragging = false;
            if (_this.state.pullToRefreshThresholdBreached) {
                _this.props.refreshFunction && _this.props.refreshFunction();
                _this.setState({
                    pullToRefreshThresholdBreached: false
                });
            }
            requestAnimationFrame(function() {
                // this._infScroll
                if (_this._infScroll) {
                    _this._infScroll.style.overflow = 'auto';
                    _this._infScroll.style.transform = 'none';
                    _this._infScroll.style.willChange = 'unset';
                }
            });
        };
        _this.onScrollListener = function(event) {
            if (typeof _this.props.onScroll === 'function') // Execute this callback in next tick so that it does not affect the
            // functionality of the library.
            setTimeout(function() {
                return _this.props.onScroll && _this.props.onScroll(event);
            }, 0);
            var target = _this.props.height || _this._scrollableNode ? event.target : document.documentElement.scrollTop ? document.documentElement : document.body;
            // return immediately if the action has already been triggered,
            // prevents multiple triggers.
            if (_this.actionTriggered) return;
            var atBottom = _this.props.inverse ? _this.isElementAtTop(target, _this.props.scrollThreshold) : _this.isElementAtBottom(target, _this.props.scrollThreshold);
            // call the `next` function in the props to trigger the next data fetch
            if (atBottom && _this.props.hasMore) {
                _this.actionTriggered = true;
                _this.setState({
                    showLoader: true
                });
                _this.props.next && _this.props.next();
            }
            _this.lastScrollTop = target.scrollTop;
        };
        _this.state = {
            showLoader: false,
            pullToRefreshThresholdBreached: false,
            prevDataLength: props.dataLength
        };
        _this.throttledOnScrollListener = $3e7201ce9921e05b$var$throttle(150, _this.onScrollListener).bind(_this);
        _this.onStart = _this.onStart.bind(_this);
        _this.onMove = _this.onMove.bind(_this);
        _this.onEnd = _this.onEnd.bind(_this);
        return _this;
    }
    InfiniteScroll.prototype.componentDidMount = function() {
        if (typeof this.props.dataLength === 'undefined') throw new Error('mandatory prop "dataLength" is missing. The prop is needed when loading more content. Check README.md for usage');
        this._scrollableNode = this.getScrollableTarget();
        this.el = this.props.height ? this._infScroll : this._scrollableNode || window;
        if (this.el) this.el.addEventListener('scroll', this.throttledOnScrollListener);
        if (typeof this.props.initialScrollY === 'number' && this.el && this.el instanceof HTMLElement && this.el.scrollHeight > this.props.initialScrollY) this.el.scrollTo(0, this.props.initialScrollY);
        if (this.props.pullDownToRefresh && this.el) {
            this.el.addEventListener('touchstart', this.onStart);
            this.el.addEventListener('touchmove', this.onMove);
            this.el.addEventListener('touchend', this.onEnd);
            this.el.addEventListener('mousedown', this.onStart);
            this.el.addEventListener('mousemove', this.onMove);
            this.el.addEventListener('mouseup', this.onEnd);
            // get BCR of pullDown element to position it above
            this.maxPullDownDistance = this._pullDown && this._pullDown.firstChild && this._pullDown.firstChild.getBoundingClientRect().height || 0;
            this.forceUpdate();
            if (typeof this.props.refreshFunction !== 'function') throw new Error("Mandatory prop \"refreshFunction\" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage'");
        }
    };
    InfiniteScroll.prototype.componentWillUnmount = function() {
        if (this.el) {
            this.el.removeEventListener('scroll', this.throttledOnScrollListener);
            if (this.props.pullDownToRefresh) {
                this.el.removeEventListener('touchstart', this.onStart);
                this.el.removeEventListener('touchmove', this.onMove);
                this.el.removeEventListener('touchend', this.onEnd);
                this.el.removeEventListener('mousedown', this.onStart);
                this.el.removeEventListener('mousemove', this.onMove);
                this.el.removeEventListener('mouseup', this.onEnd);
            }
        }
    };
    InfiniteScroll.prototype.componentDidUpdate = function(prevProps) {
        // do nothing when dataLength is unchanged
        if (this.props.dataLength === prevProps.dataLength) return;
        this.actionTriggered = false;
        // update state when new data was sent in
        this.setState({
            showLoader: false
        });
    };
    InfiniteScroll.getDerivedStateFromProps = function(nextProps, prevState) {
        var dataLengthChanged = nextProps.dataLength !== prevState.prevDataLength;
        // reset when data changes
        if (dataLengthChanged) return $3e7201ce9921e05b$var$__assign($3e7201ce9921e05b$var$__assign({}, prevState), {
            prevDataLength: nextProps.dataLength
        });
        return null;
    };
    InfiniteScroll.prototype.isElementAtTop = function(target, scrollThreshold) {
        if (scrollThreshold === void 0) scrollThreshold = 0.8;
        var clientHeight = target === document.body || target === document.documentElement ? window.screen.availHeight : target.clientHeight;
        var threshold = $3e7201ce9921e05b$var$parseThreshold(scrollThreshold);
        if (threshold.unit === $3e7201ce9921e05b$var$ThresholdUnits.Pixel) return target.scrollTop <= threshold.value + clientHeight - target.scrollHeight + 1;
        return target.scrollTop <= threshold.value / 100 + clientHeight - target.scrollHeight + 1;
    };
    InfiniteScroll.prototype.isElementAtBottom = function(target, scrollThreshold) {
        if (scrollThreshold === void 0) scrollThreshold = 0.8;
        var clientHeight = target === document.body || target === document.documentElement ? window.screen.availHeight : target.clientHeight;
        var threshold = $3e7201ce9921e05b$var$parseThreshold(scrollThreshold);
        if (threshold.unit === $3e7201ce9921e05b$var$ThresholdUnits.Pixel) return target.scrollTop + clientHeight >= target.scrollHeight - threshold.value;
        return target.scrollTop + clientHeight >= threshold.value / 100 * target.scrollHeight;
    };
    InfiniteScroll.prototype.render = function() {
        var _this = this;
        var style = $3e7201ce9921e05b$var$__assign({
            height: this.props.height || 'auto',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch'
        }, this.props.style);
        var hasChildren = this.props.hasChildren || !!(this.props.children && this.props.children instanceof Array && this.props.children.length);
        // because heighted infiniteScroll visualy breaks
        // on drag down as overflow becomes visible
        var outerDivStyle = this.props.pullDownToRefresh && this.props.height ? {
            overflow: 'auto'
        } : {};
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
            style: outerDivStyle,
            className: "infinite-scroll-component__outerdiv"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
            className: "infinite-scroll-component " + (this.props.className || ''),
            ref: function(infScroll) {
                return _this._infScroll = infScroll;
            },
            style: style
        }, this.props.pullDownToRefresh && (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
            style: {
                position: 'relative'
            },
            ref: function(pullDown) {
                return _this._pullDown = pullDown;
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
            style: {
                position: 'absolute',
                left: 0,
                right: 0,
                top: -1 * this.maxPullDownDistance
            }
        }, this.state.pullToRefreshThresholdBreached ? this.props.releaseToRefreshContent : this.props.pullDownToRefreshContent)), this.props.children, !this.state.showLoader && !hasChildren && this.props.hasMore && this.props.loader, this.state.showLoader && this.props.hasMore && this.props.loader, !this.props.hasMore && this.props.endMessage));
    };
    return InfiniteScroll;
}((0, $6fFrj.Component));
var $3e7201ce9921e05b$export$2e2bcd8739ae039 = $3e7201ce9921e05b$var$InfiniteScroll;


var $5334b31635606ef3$var$__assign = undefined && undefined.__assign || function() {
    $5334b31635606ef3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5334b31635606ef3$var$__assign.apply(this, arguments);
};
var $5334b31635606ef3$var$InfiniteScrollWrapper = function(_a) {
    var isInfiniteScrollOn = _a.isInfiniteScrollOn, infiniteScrollProps = _a.infiniteScrollProps, children = _a.children;
    if (!isInfiniteScrollOn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $3e7201ce9921e05b$export$2e2bcd8739ae039), $5334b31635606ef3$var$__assign({}, infiniteScrollProps, {
        loader: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("h4", null, "Loading..."),
        endMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("p", {
            style: {
                textAlign: 'center'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("b", null, "Yay! You have seen it all"))
    }), children));
};
var $5334b31635606ef3$export$2e2bcd8739ae039 = $5334b31635606ef3$var$InfiniteScrollWrapper;


var $0c4bb8d774d1db17$var$__assign = undefined && undefined.__assign || function() {
    $0c4bb8d774d1db17$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0c4bb8d774d1db17$var$__assign.apply(this, arguments);
};
var $0c4bb8d774d1db17$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0c4bb8d774d1db17$var$TaxInfiniteScrollTable = function(_a) {
    var infiniteScrollProps = _a.infiniteScrollProps, rest = $0c4bb8d774d1db17$var$__rest(_a, [
        "infiniteScrollProps"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $5334b31635606ef3$export$2e2bcd8739ae039), {
        isInfiniteScrollOn: true,
        infiniteScrollProps: infiniteScrollProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $2eb2b7b37988b8f9$export$2e2bcd8739ae039), $0c4bb8d774d1db17$var$__assign({}, rest)));
};
var $0c4bb8d774d1db17$export$2e2bcd8739ae039 = $0c4bb8d774d1db17$var$TaxInfiniteScrollTable;


var $9b8be8f23b56e98a$export$2e2bcd8739ae039 = (0, $0c4bb8d774d1db17$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");


var $61d3c1ba7d87586b$var$Layout = (0, $bc6ab8efd9ad3e35$export$2e2bcd8739ae039);
$61d3c1ba7d87586b$var$Layout.Header = (0, $bc6ab8efd9ad3e35$export$8b251419efc915eb);
$61d3c1ba7d87586b$var$Layout.Footer = (0, $bc6ab8efd9ad3e35$export$a06f1c675e846f6f);
$61d3c1ba7d87586b$var$Layout.Content = (0, $bc6ab8efd9ad3e35$export$7c6e2c02157bb7d2);
$61d3c1ba7d87586b$var$Layout.Sider = (0, $d2d8cb132a1de079$export$2e2bcd8739ae039);
$61d3c1ba7d87586b$var$Layout._InternalSiderContext = (0, $d2d8cb132a1de079$export$63554aebd2a6d54c);
var $61d3c1ba7d87586b$export$2e2bcd8739ae039 = $61d3c1ba7d87586b$var$Layout;


var $8084bb0c9b54fa18$var$__assign = undefined && undefined.__assign || function() {
    $8084bb0c9b54fa18$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8084bb0c9b54fa18$var$__assign.apply(this, arguments);
};
var $8084bb0c9b54fa18$var$Layout = function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $61d3c1ba7d87586b$export$2e2bcd8739ae039), $8084bb0c9b54fa18$var$__assign({}, props));
};
$8084bb0c9b54fa18$var$Layout.Header = (0, $61d3c1ba7d87586b$export$2e2bcd8739ae039).Header;
$8084bb0c9b54fa18$var$Layout.Sider = (0, $61d3c1ba7d87586b$export$2e2bcd8739ae039).Sider;
$8084bb0c9b54fa18$var$Layout.Content = (0, $61d3c1ba7d87586b$export$2e2bcd8739ae039).Content;
$8084bb0c9b54fa18$var$Layout.Footer = (0, $61d3c1ba7d87586b$export$2e2bcd8739ae039).Footer;
var $8084bb0c9b54fa18$export$2e2bcd8739ae039 = $8084bb0c9b54fa18$var$Layout;


var $0102c485edc5bdcf$export$2e2bcd8739ae039 = (0, $8084bb0c9b54fa18$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");

var $8d4c54d0d67d65a0$var$__assign = undefined && undefined.__assign || function() {
    $8d4c54d0d67d65a0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8d4c54d0d67d65a0$var$__assign.apply(this, arguments);
};
var $8d4c54d0d67d65a0$var$Menu = function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $d93242227496acaa$export$2e2bcd8739ae039), $8d4c54d0d67d65a0$var$__assign({}, props));
};
$8d4c54d0d67d65a0$var$Menu.Item = (0, $d93242227496acaa$export$2e2bcd8739ae039).Item;
$8d4c54d0d67d65a0$var$Menu.SubMenu = (0, $d93242227496acaa$export$2e2bcd8739ae039).SubMenu;
$8d4c54d0d67d65a0$var$Menu.ItemGroup = (0, $d93242227496acaa$export$2e2bcd8739ae039).ItemGroup;
$8d4c54d0d67d65a0$var$Menu.Divider = (0, $d93242227496acaa$export$2e2bcd8739ae039).Divider;
var $8d4c54d0d67d65a0$export$2e2bcd8739ae039 = $8d4c54d0d67d65a0$var$Menu;


var $cd46f582474e92de$export$2e2bcd8739ae039 = (0, $8d4c54d0d67d65a0$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");



var $7OMVO = parcelRequire("7OMVO");



var $5a27d14980efc199$var$Calendar = function(_a) {
    //const calendarRef = useRef<TuiCalendar>(null);
    var // height,
    style = _a.style;
    var _b = (0, $6fFrj.useState)('month'), view = _b[0], setView = _b[1];
    var _c = (0, $6fFrj.useState)((0, (/*@__PURE__*/$parcel$interopDefault($7OMVO)))()), date = _c[0], setDate = _c[1];
    /*useEffect(() => {
      if (calendarRef.current) {
        const instance = calendarRef.current.getInstance();
        instance.setDate(date.toDate());
      }
    }, [date]);*/ var prev = function() {
        var day = date.date();
        setDate((0, (/*@__PURE__*/$parcel$interopDefault($7OMVO)))(date).set('date', day - (view === 'day' ? 1 : 7)));
    };
    var next = function() {
        var day = date.date();
        setDate((0, (/*@__PURE__*/$parcel$interopDefault($7OMVO)))(date).set('date', day + (view === 'day' ? 1 : 7)));
    };
    // const pickerHandler = (v: Moment | null) => {
    //   if (v) {
    //     setDate(v);
    //   }
    // };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $5024ed5b7bb39672$export$2e2bcd8739ae039), {
        bordered: false,
        activeKey: view,
        onChange: function(v) {
            return setView(v);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $5024ed5b7bb39672$export$2e2bcd8739ae039).TabPane, {
        tab: "Month",
        key: "month"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $5024ed5b7bb39672$export$2e2bcd8739ae039).TabPane, {
        tab: "Week",
        key: "week"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $5024ed5b7bb39672$export$2e2bcd8739ae039).TabPane, {
        tab: "Day",
        key: "day"
    })), view === 'month' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $66a23e9427b53328$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        style: {
            marginTop: -32
        },
        justify: "center"
    })), (view === 'week' || view === 'day') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        style: {
            textAlign: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $e8201deab6acaf74$export$2e2bcd8739ae039).Title, {
        level: 3
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7OMVO)))(date).format('MMMM')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $e8201deab6acaf74$export$2e2bcd8739ae039).Text, {
        type: "secondary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $ae5877404f2a0345$export$2e2bcd8739ae039), {
        onClick: prev
    }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
        style: {
            minWidth: 120,
            display: 'inline-block'
        }
    }, view === 'week' && "".concat((0, (/*@__PURE__*/$parcel$interopDefault($7OMVO)))(date).startOf('week').date(), "\n                  - ").concat((0, (/*@__PURE__*/$parcel$interopDefault($7OMVO)))(date).endOf('week').date()), view === 'day' && (0, (/*@__PURE__*/$parcel$interopDefault($7OMVO)))(date).format('dddd D')), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $e7bd83ac29db4850$export$2e2bcd8739ae039), {
        onClick: next
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
        message: "You selected date ".concat(date.toDate().toDateString()),
        style: {
            marginBottom: 16
        }
    }));
};
var $5a27d14980efc199$export$2e2bcd8739ae039 = $5a27d14980efc199$var$Calendar;


var $44f8758f44cee46a$export$2e2bcd8739ae039 = (0, $5a27d14980efc199$export$2e2bcd8739ae039);




var $6fFrj = parcelRequire("6fFrj");
var $c4567295647dd6ed$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c4567295647dd6ed$var$ReactIs, $c4567295647dd6ed$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$c4567295647dd6ed$exports = (parcelRequire("6wBJ8"))();



var $75474577df335d2b$export$89ed721f32609a91;
var $75474577df335d2b$export$d1306404e7143ece;
var $75474577df335d2b$export$e93cf3c69233ac6c;
var $75474577df335d2b$export$84a4b6c9faa13efb;
var $75474577df335d2b$export$14fc679146fcc99a;
var $75474577df335d2b$export$7c9d8289980864b5;
var $75474577df335d2b$export$ae779cf0eda20fc1;
var $75474577df335d2b$export$d94e7b7804ac0248;
var $75474577df335d2b$export$30c822c433d45070;
var $75474577df335d2b$export$aab32f7a8d7f6880;
$75474577df335d2b$export$89ed721f32609a91 = `SrrAsa_cc_badge`;
$75474577df335d2b$export$d1306404e7143ece = `SrrAsa_cc_container`;
$75474577df335d2b$export$e93cf3c69233ac6c = `SrrAsa_cc_containerData`;
$75474577df335d2b$export$84a4b6c9faa13efb = `SrrAsa_cc_count`;
$75474577df335d2b$export$14fc679146fcc99a = `SrrAsa_cc_date`;
$75474577df335d2b$export$7c9d8289980864b5 = `SrrAsa_cc_last`;
$75474577df335d2b$export$ae779cf0eda20fc1 = `SrrAsa_cc_message`;
$75474577df335d2b$export$d94e7b7804ac0248 = `SrrAsa_cc_name`;
$75474577df335d2b$export$30c822c433d45070 = `SrrAsa_cc_selected`;
$75474577df335d2b$export$aab32f7a8d7f6880 = `SrrAsa_containerBadge`;


// console.log('asddddddddddd: ', headerStyles);
var $cb1861adce2967d6$var$styles = {
    container: 'cc_container',
    selected: 'cc_selected',
    badge: 'cc_badge',
    containerData: 'cc_containerData',
    name: 'cc_name',
    date: 'cc_date',
    last: 'cc_last',
    message: 'cc_message',
    count: 'cc_count'
};
var $cb1861adce2967d6$var$Text = (0, $384b89a85bcb79c5$export$2e2bcd8739ae039).Text;
// const styles: any = {};
var $cb1861adce2967d6$var$getAcronim = function(str) {
    var matches = str.match(/\b(\w)/g);
    var acronym = matches === null || matches === void 0 ? void 0 : matches.join('');
    return acronym === null || acronym === void 0 ? void 0 : acronym.substring(0, 2).toUpperCase();
};
var $cb1861adce2967d6$var$ChatChannel = function(_a) {
    var data = _a.data, setChannel = _a.setChannel, selected = _a.selected, userId = _a.userId, dateFromNow = _a.dateFromNow;
    var ChannelMembers = data.ChannelMembers, Messages = data.Messages, status = data.status;
    /* const date = () => {
      if (Messages.length <= 0) return '';
      const { updatedAt } = Messages[Messages.length - 1];
      const dateMoment = moment(updatedAt);
      return dateMoment.fromNow();
    }; */ var getName = function(obj) {
        if (!obj) return '';
        var firstName = '';
        var lastName = '';
        if (obj.Users && obj.Users.PreparerDetails) {
            firstName = obj.Users.PreparerDetails.firstName;
            lastName = obj.Users.PreparerDetails.lastName;
        } else if (obj.Users.Clients_Clients_clientUserIdToUsers) {
            firstName = obj.Users.Clients_Clients_clientUserIdToUsers.firstName;
            lastName = obj.Users.Clients_Clients_clientUserIdToUsers.lastName;
        }
        return "".concat(firstName, " ").concat(lastName);
    };
    var getChannelMembersNames = function() {
        var member = ChannelMembers.find(function(mb) {
            return mb.Users.id !== userId;
        });
        return getName(member);
    };
    var lastMessage = function() {
        if (Messages.length <= 0) return '';
        var text = Messages[Messages.length - 1].text;
        if (!text) return '';
        if (text.includes('#{meetingId}=')) return '#Incoming meeting';
        return text.split('~#*')[0];
    };
    var filterMessages = function() {
        if (Messages.length <= 0) return undefined;
        var messages = Messages.filter(function(msg) {
            return !msg.readDate && msg.userId !== userId;
        });
        return messages.length <= 0 ? undefined : messages.length;
    };
    var getStatusConnection = function() {
        if (status) return 'green';
        return 'gray';
    };
    var selectChannel = function() {
        setChannel(data.id);
    };
    var unreadMessages = filterMessages();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "".concat($cb1861adce2967d6$var$styles === null || $cb1861adce2967d6$var$styles === void 0 ? void 0 : $cb1861adce2967d6$var$styles.container, " ").concat(selected && ($cb1861adce2967d6$var$styles === null || $cb1861adce2967d6$var$styles === void 0 ? void 0 : $cb1861adce2967d6$var$styles.selected)),
        onClick: selectChannel,
        onKeyDown: selectChannel,
        role: "button",
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $0e541b76c0e3ec69$export$2e2bcd8739ae039), {
        dot: true,
        className: $cb1861adce2967d6$var$styles === null || $cb1861adce2967d6$var$styles === void 0 ? void 0 : $cb1861adce2967d6$var$styles.badge,
        color: getStatusConnection()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
        style: {
            backgroundColor: '#22A7E7'
        },
        size: 50
    }, $cb1861adce2967d6$var$getAcronim(getChannelMembersNames()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: $cb1861adce2967d6$var$styles === null || $cb1861adce2967d6$var$styles === void 0 ? void 0 : $cb1861adce2967d6$var$styles.containerData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($cb1861adce2967d6$var$Text, {
        className: $cb1861adce2967d6$var$styles === null || $cb1861adce2967d6$var$styles === void 0 ? void 0 : $cb1861adce2967d6$var$styles.name
    }, getChannelMembersNames()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($cb1861adce2967d6$var$Text, {
        className: $cb1861adce2967d6$var$styles === null || $cb1861adce2967d6$var$styles === void 0 ? void 0 : $cb1861adce2967d6$var$styles.date
    }, dateFromNow)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: $cb1861adce2967d6$var$styles === null || $cb1861adce2967d6$var$styles === void 0 ? void 0 : $cb1861adce2967d6$var$styles.last
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($cb1861adce2967d6$var$Text, {
        className: $cb1861adce2967d6$var$styles === null || $cb1861adce2967d6$var$styles === void 0 ? void 0 : $cb1861adce2967d6$var$styles.message
    }, lastMessage()), ' ', unreadMessages && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("p", {
        className: $cb1861adce2967d6$var$styles === null || $cb1861adce2967d6$var$styles === void 0 ? void 0 : $cb1861adce2967d6$var$styles.count
    }, unreadMessages))));
};
$cb1861adce2967d6$var$ChatChannel.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c4567295647dd6ed$exports))).object.isRequired,
    setChannel: (0, (/*@__PURE__*/$parcel$interopDefault($c4567295647dd6ed$exports))).func.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($c4567295647dd6ed$exports))).bool.isRequired,
    userId: (0, (/*@__PURE__*/$parcel$interopDefault($c4567295647dd6ed$exports))).number.isRequired,
    dateFromNow: (0, (/*@__PURE__*/$parcel$interopDefault($c4567295647dd6ed$exports))).string.isRequired
};
var $cb1861adce2967d6$export$2e2bcd8739ae039 = $cb1861adce2967d6$var$ChatChannel;


// import { Select as AntSelect } from 'antd';


var $6fFrj = parcelRequire("6fFrj");
var $f062defb07330c27$var$__assign = undefined && undefined.__assign || function() {
    $f062defb07330c27$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f062defb07330c27$var$__assign.apply(this, arguments);
};
var $f062defb07330c27$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
// const { Option } = AntSelect;
var $f062defb07330c27$var$Option = function(_a) {
    var className = _a.className, rest = $f062defb07330c27$var$__rest(_a, [
        "className"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $f53bdf45f7cdc99e$export$2e2bcd8739ae039).Option, $f062defb07330c27$var$__assign({
        className: [
            className
        ].filter(Boolean).join(' ')
    }, rest));
};
var $f062defb07330c27$var$Select = function(_a) {
    var ref = _a.ref, className = _a.className, rest = $f062defb07330c27$var$__rest(_a, [
        "ref",
        "className"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $f53bdf45f7cdc99e$export$2e2bcd8739ae039), $f062defb07330c27$var$__assign({}, rest, {
        ref: ref,
        className: [
            className
        ].filter(Boolean).join(' ')
    }));
};
$f062defb07330c27$var$Select.Option = $f062defb07330c27$var$Option;
var $f062defb07330c27$export$2e2bcd8739ae039 = $f062defb07330c27$var$Select;


var $f7b06a01f57032f1$export$2e2bcd8739ae039 // export const TaxarooSelect = AntSelect;
 = (0, $f062defb07330c27$export$2e2bcd8739ae039);


/* eslint-disable no-unused-vars */ 
var $6fFrj = parcelRequire("6fFrj");


var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $8fb89f5aea392dc2$var$FilePdfOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file-pdf",
    "theme": "outlined"
};
var $8fb89f5aea392dc2$export$2e2bcd8739ae039 = $8fb89f5aea392dc2$var$FilePdfOutlined;



var $b2cfeb84fa1c2ac1$var$FilePdfOutlined = function FilePdfOutlined(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $8fb89f5aea392dc2$export$2e2bcd8739ae039)
    }));
};
var $b2cfeb84fa1c2ac1$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($b2cfeb84fa1c2ac1$var$FilePdfOutlined);
var $b2cfeb84fa1c2ac1$export$2e2bcd8739ae039 = $b2cfeb84fa1c2ac1$var$RefIcon;


var $b37b828dc25e0ed9$var$__assign = undefined && undefined.__assign || function() {
    $b37b828dc25e0ed9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b37b828dc25e0ed9$var$__assign.apply(this, arguments);
};
var $b37b828dc25e0ed9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b37b828dc25e0ed9$var$Dragger = (0, $09e7a312b8c0b52f$export$2e2bcd8739ae039).Dragger;
// eslint-disable-next-line arrow-body-style
var $b37b828dc25e0ed9$var$FileUploadDragger = function(_a) {
    var createTemplate = _a.createTemplate, deleteFile = _a.deleteFile, fileList = _a.fileList, rest = $b37b828dc25e0ed9$var$__rest(_a, [
        "createTemplate",
        "deleteFile",
        "fileList"
    ]);
    var listHeight = 100;
    listHeight = (fileList === null || fileList === void 0 ? void 0 : fileList.length) === 0 ? 0 : listHeight;
    listHeight = (fileList === null || fileList === void 0 ? void 0 : fileList.length) === 1 ? 50 : listHeight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($b37b828dc25e0ed9$var$Dragger, $b37b828dc25e0ed9$var$__assign({}, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("p", {
        className: "ant-upload-drag-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $1fe526a850b3b089$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("p", {
        className: "ant-upload-text"
    }, "Click or drag file to this area to upload")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $550318ddff00815a$export$2e2bcd8739ae039), {
        size: "small",
        style: {
            height: listHeight,
            overflowY: 'scroll'
        },
        dataSource: fileList,
        renderItem: function(item, index) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $550318ddff00815a$export$2e2bcd8739ae039).Item, {
                key: item.name
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $550318ddff00815a$export$2e2bcd8739ae039).Item.Meta, {
                avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b2cfeb84fa1c2ac1$export$2e2bcd8739ae039), null)
                }),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("strong", null, item.name))
            }), createTemplate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                title: "Save as Template"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $dfe3e0e661ee2f16$export$2e2bcd8739ae039), {
                    onClick: function() {
                        createTemplate(item.uid);
                    }
                })
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                title: "Delete File"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $0ccc7a2b4648ccac$export$2e2bcd8739ae039), {
                    onClick: function() {
                        deleteFile(item.uid, index);
                    }
                })
            })));
        }
    }));
};
var $b37b828dc25e0ed9$export$2e2bcd8739ae039 = $b37b828dc25e0ed9$var$FileUploadDragger;


var $9c37b10a97eda40c$export$2e2bcd8739ae039 = (0, $b37b828dc25e0ed9$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");

var $0ce584eee7e10492$var$__assign = undefined && undefined.__assign || function() {
    $0ce584eee7e10492$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0ce584eee7e10492$var$__assign.apply(this, arguments);
};
var $0ce584eee7e10492$var$Popover = function(props) {
    var className = props.className;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $1eeb7f423c3f3d14$export$2e2bcd8739ae039), $0ce584eee7e10492$var$__assign({}, props, {
        className: [
            className
        ].filter(Boolean).join(' ')
    }));
};
var $0ce584eee7e10492$export$2e2bcd8739ae039 = $0ce584eee7e10492$var$Popover;


var $66cce4f0794ba24e$export$2e2bcd8739ae039 = (0, $0ce584eee7e10492$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");

var $9ce2b479d453b45d$var$__assign = undefined && undefined.__assign || function() {
    $9ce2b479d453b45d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9ce2b479d453b45d$var$__assign.apply(this, arguments);
};
var $9ce2b479d453b45d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9ce2b479d453b45d$var$Breadcrumb = function(_a) {
    var items = _a.items, rest = $9ce2b479d453b45d$var$__rest(_a, [
        "items"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $e9e71e1a76b579b8$export$2e2bcd8739ae039), $9ce2b479d453b45d$var$__assign({
        separator: ""
    }, rest), items.map(function(_a, index) {
        var href = _a.href, label = _a.label, icon = _a.icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $e9e71e1a76b579b8$export$2e2bcd8739ae039).Item, $9ce2b479d453b45d$var$__assign({}, href ? {
            href: href
        } : {}), label, ' '), icon && icon, index !== items.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $e9e71e1a76b579b8$export$2e2bcd8739ae039).Separator, null, "/"));
    })));
};
var $9ce2b479d453b45d$export$2e2bcd8739ae039 = $9ce2b479d453b45d$var$Breadcrumb;



var $6fFrj = parcelRequire("6fFrj");

var $fIrcP = parcelRequire("fIrcP");

var $kNxFX = parcelRequire("kNxFX");

var $6fFrj = parcelRequire("6fFrj");
// This icon file is generated automatically.
var $6db54b9321b05fa1$var$StarFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"
                }
            }
        ]
    },
    "name": "star",
    "theme": "filled"
};
var $6db54b9321b05fa1$export$2e2bcd8739ae039 = $6db54b9321b05fa1$var$StarFilled;



var $ccca2030d6409d93$var$StarFilled = function StarFilled(props, ref) {
    return /*#__PURE__*/ $6fFrj.createElement((0, $dc0e0091f50fc261$export$2e2bcd8739ae039), (0, $kNxFX.default)((0, $kNxFX.default)({}, props), {}, {
        ref: ref,
        icon: (0, $6db54b9321b05fa1$export$2e2bcd8739ae039)
    }));
};
var $ccca2030d6409d93$var$RefIcon = /*#__PURE__*/ $6fFrj.forwardRef($ccca2030d6409d93$var$StarFilled);
var $ccca2030d6409d93$export$2e2bcd8739ae039 = $ccca2030d6409d93$var$RefIcon;



var $kNxFX = parcelRequire("kNxFX");

var $43449 = parcelRequire("43449");

var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $6fFrj = parcelRequire("6fFrj");

var $k5B64 = parcelRequire("k5B64");

var $fActo = parcelRequire("fActo");

function $d4bfa5ed31b84798$var$getScroll(w) {
    var ret = w.pageXOffset;
    var method = 'scrollLeft';
    if (typeof ret !== 'number') {
        var d = w.document;
        // ie6,7,8 standard mode
        ret = d.documentElement[method];
        if (typeof ret !== 'number') // quirks mode
        ret = d.body[method];
    }
    return ret;
}
function $d4bfa5ed31b84798$var$getClientPosition(elem) {
    var x;
    var y;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement;
    var box = elem.getBoundingClientRect();
    x = box.left;
    y = box.top;
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
        left: x,
        top: y
    };
}
function $d4bfa5ed31b84798$export$a6a488ff68b1bf7b(el) {
    var pos = $d4bfa5ed31b84798$var$getClientPosition(el);
    var doc = el.ownerDocument;
    // Only IE use `parentWindow`
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $d4bfa5ed31b84798$var$getScroll(w);
    return pos.left;
}



var $kjNeN = parcelRequire("kjNeN");

var $5KQxu = parcelRequire("5KQxu");

var $bxC2Y = parcelRequire("bxC2Y");

var $lSufv = parcelRequire("lSufv");

var $6fFrj = parcelRequire("6fFrj");
var $053e97fab9bddb42$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(Star, _React$Component);
    var _super = (0, $lSufv.default)(Star);
    function Star() {
        var _this;
        (0, $kjNeN.default)(this, Star);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.onHover = function(e) {
            var _this$props = _this.props, onHover = _this$props.onHover, index = _this$props.index;
            onHover(e, index);
        };
        _this.onClick = function(e) {
            var _this$props2 = _this.props, onClick = _this$props2.onClick, index = _this$props2.index;
            onClick(e, index);
        };
        _this.onKeyDown = function(e) {
            var _this$props3 = _this.props, onClick = _this$props3.onClick, index = _this$props3.index;
            if (e.keyCode === 13) onClick(e, index);
        };
        return _this;
    }
    (0, $5KQxu.default)(Star, [
        {
            key: "getClassName",
            value: function getClassName() {
                var _this$props4 = this.props, prefixCls = _this$props4.prefixCls, index = _this$props4.index, value = _this$props4.value, allowHalf = _this$props4.allowHalf, focused = _this$props4.focused;
                var starValue = index + 1;
                var className = prefixCls;
                if (value === 0 && index === 0 && focused) className += " ".concat(prefixCls, "-focused");
                else if (allowHalf && value + 0.5 >= starValue && value < starValue) {
                    className += " ".concat(prefixCls, "-half ").concat(prefixCls, "-active");
                    if (focused) className += " ".concat(prefixCls, "-focused");
                } else {
                    className += starValue <= value ? " ".concat(prefixCls, "-full") : " ".concat(prefixCls, "-zero");
                    if (starValue === value && focused) className += " ".concat(prefixCls, "-focused");
                }
                return className;
            }
        },
        {
            key: "render",
            value: function render() {
                var onHover = this.onHover, onClick = this.onClick, onKeyDown = this.onKeyDown;
                var _this$props5 = this.props, disabled = _this$props5.disabled, prefixCls = _this$props5.prefixCls, character = _this$props5.character, characterRender = _this$props5.characterRender, index = _this$props5.index, count = _this$props5.count, value = _this$props5.value;
                var characterNode = typeof character === 'function' ? character(this.props) : character;
                var start = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("li", {
                    className: this.getClassName()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    onClick: disabled ? null : onClick,
                    onKeyDown: disabled ? null : onKeyDown,
                    onMouseMove: disabled ? null : onHover,
                    role: "radio",
                    "aria-checked": value > index ? 'true' : 'false',
                    "aria-posinset": index + 1,
                    "aria-setsize": count,
                    tabIndex: disabled ? -1 : 0
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "".concat(prefixCls, "-first")
                }, characterNode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "".concat(prefixCls, "-second")
                }, characterNode)));
                if (characterRender) start = characterRender(start, this.props);
                return start;
            }
        }
    ]);
    return Star;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);


function $961de3a79c988530$var$noop() {}
var $961de3a79c988530$var$Rate = /*#__PURE__*/ function(_React$Component) {
    (0, $bxC2Y.default)(Rate, _React$Component);
    var _super = (0, $lSufv.default)(Rate);
    function Rate(props) {
        var _this;
        (0, $kjNeN.default)(this, Rate);
        _this = _super.call(this, props);
        _this.stars = void 0;
        _this.rate = void 0;
        _this.onHover = function(event, index) {
            var onHoverChange = _this.props.onHoverChange;
            var hoverValue = _this.getStarValue(index, event.pageX);
            var cleanedValue = _this.state.cleanedValue;
            if (hoverValue !== cleanedValue) _this.setState({
                hoverValue: hoverValue,
                cleanedValue: null
            });
            onHoverChange(hoverValue);
        };
        _this.onMouseLeave = function() {
            var onHoverChange = _this.props.onHoverChange;
            _this.setState({
                hoverValue: undefined,
                cleanedValue: null
            });
            onHoverChange(undefined);
        };
        _this.onClick = function(event, index) {
            var allowClear = _this.props.allowClear;
            var value = _this.state.value;
            var newValue = _this.getStarValue(index, event.pageX);
            var isReset = false;
            if (allowClear) isReset = newValue === value;
            _this.onMouseLeave();
            _this.changeValue(isReset ? 0 : newValue);
            _this.setState({
                cleanedValue: isReset ? newValue : null
            });
        };
        _this.onFocus = function() {
            var onFocus = _this.props.onFocus;
            _this.setState({
                focused: true
            });
            if (onFocus) onFocus();
        };
        _this.onBlur = function() {
            var onBlur = _this.props.onBlur;
            _this.setState({
                focused: false
            });
            if (onBlur) onBlur();
        };
        _this.onKeyDown = function(event) {
            var keyCode = event.keyCode;
            var _this$props = _this.props, count = _this$props.count, allowHalf = _this$props.allowHalf, onKeyDown = _this$props.onKeyDown, direction = _this$props.direction;
            var reverse = direction === 'rtl';
            var value = _this.state.value;
            if (keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).RIGHT && value < count && !reverse) {
                if (allowHalf) value += 0.5;
                else value += 1;
                _this.changeValue(value);
                event.preventDefault();
            } else if (keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).LEFT && value > 0 && !reverse) {
                if (allowHalf) value -= 0.5;
                else value -= 1;
                _this.changeValue(value);
                event.preventDefault();
            } else if (keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).RIGHT && value > 0 && reverse) {
                if (allowHalf) value -= 0.5;
                else value -= 1;
                _this.changeValue(value);
                event.preventDefault();
            } else if (keyCode === (0, $d1496e6c3ad7f80f$export$2e2bcd8739ae039).LEFT && value < count && reverse) {
                if (allowHalf) value += 0.5;
                else value += 1;
                _this.changeValue(value);
                event.preventDefault();
            }
            if (onKeyDown) onKeyDown(event);
        };
        _this.saveRef = function(index) {
            return function(node) {
                _this.stars[index] = node;
            };
        };
        _this.saveRate = function(node) {
            _this.rate = node;
        };
        var _value = props.value;
        if (_value === undefined) _value = props.defaultValue;
        _this.stars = {};
        _this.state = {
            value: _value,
            focused: false,
            cleanedValue: null
        };
        return _this;
    }
    (0, $5KQxu.default)(Rate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, autoFocus = _this$props2.autoFocus, disabled = _this$props2.disabled;
                if (autoFocus && !disabled) this.focus();
            }
        },
        {
            key: "getStarDOM",
            value: function getStarDOM(index) {
                return (0, $k5B64.default)(this.stars[index]);
            }
        },
        {
            key: "getStarValue",
            value: function getStarValue(index, x) {
                var _this$props3 = this.props, allowHalf = _this$props3.allowHalf, direction = _this$props3.direction;
                var reverse = direction === 'rtl';
                var value = index + 1;
                if (allowHalf) {
                    var starEle = this.getStarDOM(index);
                    var leftDis = (0, $d4bfa5ed31b84798$export$a6a488ff68b1bf7b)(starEle);
                    var width = starEle.clientWidth;
                    if (reverse && x - leftDis > width / 2) value -= 0.5;
                    else if (!reverse && x - leftDis < width / 2) value -= 0.5;
                }
                return value;
            }
        },
        {
            key: "focus",
            value: function focus() {
                var disabled = this.props.disabled;
                if (!disabled) this.rate.focus();
            }
        },
        {
            key: "blur",
            value: function blur() {
                var disabled = this.props.disabled;
                if (!disabled) this.rate.blur();
            }
        },
        {
            key: "changeValue",
            value: function changeValue(value) {
                var onChange = this.props.onChange;
                if (!('value' in this.props)) this.setState({
                    value: value
                });
                onChange(value);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, count = _this$props4.count, allowHalf = _this$props4.allowHalf, style = _this$props4.style, id = _this$props4.id, prefixCls = _this$props4.prefixCls, disabled = _this$props4.disabled, className = _this$props4.className, character = _this$props4.character, characterRender = _this$props4.characterRender, tabIndex = _this$props4.tabIndex, direction = _this$props4.direction;
                var _this$state = this.state, value = _this$state.value, hoverValue = _this$state.hoverValue, focused = _this$state.focused;
                var stars = [];
                var disabledClass = disabled ? "".concat(prefixCls, "-disabled") : '';
                for(var index = 0; index < count; index += 1)stars.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $053e97fab9bddb42$export$2e2bcd8739ae039), {
                    ref: this.saveRef(index),
                    index: index,
                    count: count,
                    disabled: disabled,
                    prefixCls: "".concat(prefixCls, "-star"),
                    allowHalf: allowHalf,
                    value: hoverValue === undefined ? value : hoverValue,
                    onClick: this.onClick,
                    onHover: this.onHover,
                    key: index,
                    character: character,
                    characterRender: characterRender,
                    focused: focused
                }));
                var rateClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fActo)))(prefixCls, disabledClass, className, (0, $43449.default)({}, "".concat(prefixCls, "-rtl"), direction === 'rtl'));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("ul", {
                    className: rateClassName,
                    style: style,
                    id: id,
                    onMouseLeave: disabled ? null : this.onMouseLeave,
                    tabIndex: disabled ? -1 : tabIndex,
                    onFocus: disabled ? null : this.onFocus,
                    onBlur: disabled ? null : this.onBlur,
                    onKeyDown: disabled ? null : this.onKeyDown,
                    ref: this.saveRate,
                    role: "radiogroup"
                }, stars);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, state) {
                if ('value' in nextProps && nextProps.value !== undefined) return (0, $kNxFX.default)((0, $kNxFX.default)({}, state), {}, {
                    value: nextProps.value
                });
                return state;
            }
        }
    ]);
    return Rate;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
$961de3a79c988530$var$Rate.defaultProps = {
    defaultValue: 0,
    count: 5,
    allowHalf: false,
    allowClear: true,
    style: {},
    prefixCls: 'rc-rate',
    onChange: $961de3a79c988530$var$noop,
    character: "\u2605",
    onHoverChange: $961de3a79c988530$var$noop,
    tabIndex: 0,
    direction: 'ltr'
};
var $961de3a79c988530$export$2e2bcd8739ae039 = $961de3a79c988530$var$Rate;


var $8c845badadfeea3e$export$2e2bcd8739ae039 = (0, $961de3a79c988530$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");


var $4a23ac7e00d3d5bb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4a23ac7e00d3d5bb$var$Rate = /*#__PURE__*/ $6fFrj.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, tooltips = props.tooltips, _props$character = props.character, character = _props$character === void 0 ? /*#__PURE__*/ $6fFrj.createElement((0, $ccca2030d6409d93$export$2e2bcd8739ae039), null) : _props$character, rest = $4a23ac7e00d3d5bb$var$__rest(props, [
        "prefixCls",
        "tooltips",
        "character"
    ]);
    var characterRender = function characterRender(node, _ref) {
        var index = _ref.index;
        if (!tooltips) return node;
        return /*#__PURE__*/ $6fFrj.createElement((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: tooltips[index]
        }, node);
    };
    var _React$useContext = $6fFrj.useContext((0, $1bdb4c3de815e386$export$a92f85ab3e9ad68b)), getPrefixCls = _React$useContext.getPrefixCls, direction = _React$useContext.direction;
    var ratePrefixCls = getPrefixCls('rate', prefixCls);
    return /*#__PURE__*/ $6fFrj.createElement((0, $8c845badadfeea3e$export$2e2bcd8739ae039), (0, $fIrcP.default)({
        ref: ref,
        character: character,
        characterRender: characterRender
    }, rest, {
        prefixCls: ratePrefixCls,
        direction: direction
    }));
});
var $4a23ac7e00d3d5bb$export$2e2bcd8739ae039 = $4a23ac7e00d3d5bb$var$Rate;


var $61ea95fcac4f0200$var$__assign = undefined && undefined.__assign || function() {
    $61ea95fcac4f0200$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $61ea95fcac4f0200$var$__assign.apply(this, arguments);
};
var $61ea95fcac4f0200$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $61ea95fcac4f0200$var$Rate = function(_a) {
    var rest = $61ea95fcac4f0200$var$__rest(_a, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $4a23ac7e00d3d5bb$export$2e2bcd8739ae039), $61ea95fcac4f0200$var$__assign({}, rest));
};
var $61ea95fcac4f0200$export$2e2bcd8739ae039 = $61ea95fcac4f0200$var$Rate;


var $2577bd2133f02183$export$2e2bcd8739ae039 = (0, $61ea95fcac4f0200$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");

var $3572a03cb42de137$var$__assign = undefined && undefined.__assign || function() {
    $3572a03cb42de137$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3572a03cb42de137$var$__assign.apply(this, arguments);
};
var $3572a03cb42de137$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3572a03cb42de137$var$DEFAULT_FORMAT = 'MM/DD/YYYY';
var $3572a03cb42de137$var$SEPARATOR = '/';
var $3572a03cb42de137$var$DatePicker = function(_a) {
    var format = _a.format, restProps = $3572a03cb42de137$var$__rest(_a, [
        "format"
    ]);
    var realFormat = format !== null && format !== void 0 ? format : $3572a03cb42de137$var$DEFAULT_FORMAT;
    var handleKeyDown = function(event) {
        var _a;
        if (realFormat !== $3572a03cb42de137$var$DEFAULT_FORMAT || event.key < '0' || event.key > '9') return;
        var input = event.target;
        var srcValue = input.value;
        var pos = (_a = event.currentTarget.selectionStart) !== null && _a !== void 0 ? _a : 0;
        var newValue = srcValue.substring(0, pos) + event.key + srcValue.substring(pos);
        if (![
            2,
            5
        ].includes(newValue.length)) return;
        newValue += $3572a03cb42de137$var$SEPARATOR;
        input.value = newValue;
        event.preventDefault();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $e07b4718354cbfe5$export$2e2bcd8739ae039), $3572a03cb42de137$var$__assign({
        onKeyDown: handleKeyDown,
        picker: "date",
        format: realFormat
    }, restProps));
};
var $3572a03cb42de137$export$2e2bcd8739ae039 = $3572a03cb42de137$var$DatePicker;


var $dd1293f125eb7a8a$export$2e2bcd8739ae039 = (0, $3572a03cb42de137$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");

var $5cdda7090c24a397$var$__assign = undefined && undefined.__assign || function() {
    $5cdda7090c24a397$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5cdda7090c24a397$var$__assign.apply(this, arguments);
};
var $5cdda7090c24a397$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5cdda7090c24a397$var$Input = function(_a) {
    var _b = _a.type, type = _b === void 0 ? 'default' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, rest = $5cdda7090c24a397$var$__rest(_a, [
        "type",
        "className"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $9251a7488fdfff45$export$2e2bcd8739ae039), $5cdda7090c24a397$var$__assign({
        className: type === 'white' ? "whiteInput ".concat(className) : className
    }, rest));
};
var $5cdda7090c24a397$var$Password = function(_a) {
    var _b = _a.type, type = _b === void 0 ? 'default' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, rest = $5cdda7090c24a397$var$__rest(_a, [
        "type",
        "className"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $9251a7488fdfff45$export$2e2bcd8739ae039).Password, $5cdda7090c24a397$var$__assign({
        className: type === 'white' ? "whiteInput ".concat(className) : className
    }, rest));
};
$5cdda7090c24a397$var$Input.TextArea = (0, $9251a7488fdfff45$export$2e2bcd8739ae039).TextArea;
$5cdda7090c24a397$var$Input.Search = (0, $9251a7488fdfff45$export$2e2bcd8739ae039).Search;
$5cdda7090c24a397$var$Input.Group = (0, $9251a7488fdfff45$export$2e2bcd8739ae039).Group;
$5cdda7090c24a397$var$Input.Password = $5cdda7090c24a397$var$Password;
var $5cdda7090c24a397$export$2e2bcd8739ae039 = $5cdda7090c24a397$var$Input;


var $1fb834916a156dcf$export$2e2bcd8739ae039 = (0, $5cdda7090c24a397$export$2e2bcd8739ae039);


var $daaf8072fce14d91$export$47d4850b9fdf5af1 = (0, $09e7a312b8c0b52f$export$2e2bcd8739ae039).Dragger;











var $d82c09c0cc7fbc8e$export$5fc74f25506aa9c = function() {
    function ApolloCache() {
        this.getFragmentDoc = (0, $bf80b665eb3927c6$export$4997ffc0176396a6)((0, $5e4d569a846b5f9e$export$abbf37c7cf644e41));
    }
    ApolloCache.prototype.batch = function(options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function() {
            return updateResult = options.update(_this);
        }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
            rootId: options.id || 'ROOT_QUERY',
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            rootId: options.id,
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.writeQuery = function(_a) {
        var id = _a.id, data = _a.data, options = (0, $7455305bac30ddd9$export$3c9a16f847548506)(_a, [
            "id",
            "data"
        ]);
        return this.write(Object.assign(options, {
            dataId: id || 'ROOT_QUERY',
            result: data
        }));
    };
    ApolloCache.prototype.writeFragment = function(_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0, $7455305bac30ddd9$export$3c9a16f847548506)(_a, [
            "id",
            "data",
            "fragment",
            "fragmentName"
        ]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    };
    ApolloCache.prototype.updateQuery = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    ApolloCache.prototype.updateFragment = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    return ApolloCache;
}();



var $c135c3f6bc7fc93a$export$257c68286583b0f9 = function(_super) {
    (0, $7455305bac30ddd9$export$a8ba968b8961cb8a)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for(var i = _this.path.length - 1; i >= 0; --i)_this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
        } else _this.missing = _this.path;
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error);















var $1a1b4f4e447ff6ab$var$DELETE = Object.create(null);
var $1a1b4f4e447ff6ab$var$delModifier = function() {
    return $1a1b4f4e447ff6ab$var$DELETE;
};
var $1a1b4f4e447ff6ab$var$INVALIDATE = Object.create(null);
var $1a1b4f4e447ff6ab$export$cb507f57054c7321 = function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        this.rootIds = Object.create(null);
        this.refs = Object.create(null);
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $62d5a3f8d8ea93ca$export$7f9c177735b71f18)((0, $6fe96515315d55c4$export$fa99cac1c0883c47)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        this.canRead = function(objOrRef) {
            return (0, $6fe96515315d55c4$export$fa99cac1c0883c47)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $6fe96515315d55c4$export$634ae0e932e9be99)(objOrIdOrRef);
            if ((0, $6fe96515315d55c4$export$fa99cac1c0883c47)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $6fe96515315d55c4$export$634ae0e932e9be99)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    EntityStore.prototype.toObject = function() {
        return (0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $1a1b4f4e447ff6ab$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $1a1b4f4e447ff6ab$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(older, newer) {
        var _this = this;
        var dataId;
        if ((0, $6fe96515315d55c4$export$fa99cac1c0883c47)(older)) older = older.__ref;
        if ((0, $6fe96515315d55c4$export$fa99cac1c0883c47)(newer)) newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        if (!incoming) return;
        __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(typeof dataId === "string", "store.merge expects a string ID") : (0, $03191bfc90720c4f$export$f5708dca728d7177)(typeof dataId === "string", 1);
        var merged = new (0, $104323fd517dfc25$export$509e11c221f576c0)($1a1b4f4e447ff6ab$var$storeObjectReconciler).merge(existing, incoming);
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                if (!existing) fieldsToDirty_1.__exists = 1;
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        fieldsToDirty_1[storeFieldName] = 1;
                        var fieldName = (0, $7cf1a004cfc57df5$export$37874422037b6029)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $1a1b4f4e447ff6ab$var$Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty_1.__typename;
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $1a1b4f4e447ff6ab$var$DELETE,
                INVALIDATE: $1a1b4f4e447ff6ab$var$INVALIDATE,
                isReference: (0, $6fe96515315d55c4$export$fa99cac1c0883c47),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $6fe96515315d55c4$export$634ae0e932e9be99)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $7cf1a004cfc57df5$export$37874422037b6029)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $1a1b4f4e447ff6ab$var$delModifier ? $1a1b4f4e447ff6ab$var$DELETE : modify((0, $62d5a3f8d8ea93ca$export$7f9c177735b71f18)(fieldValue), (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $1a1b4f4e447ff6ab$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $1a1b4f4e447ff6ab$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $1a1b4f4e447ff6ab$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $1a1b4f4e447ff6ab$var$delModifier, _a) : $1a1b4f4e447ff6ab$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options, limit) {
        var evicted = false;
        if (options.id) {
            if ((0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $1a1b4f4e447ff6ab$var$Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, $7455305bac30ddd9$export$3c9a16f847548506)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $1a1b4f4e447ff6ab$var$Layer) this.parent.getRootIdSet(ids);
        else Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(snapshot, id)) {
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $1a1b4f4e447ff6ab$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root) return found_1;
            var workSet_1 = new Set([
                root
            ]);
            workSet_1.forEach(function(obj) {
                if ((0, $6fe96515315d55c4$export$fa99cac1c0883c47)(obj)) found_1[obj.__ref] = true;
                if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(obj)) Object.keys(obj).forEach(function(key) {
                    var child = obj[key];
                    if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(child)) workSet_1.add(child);
                });
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}();
var $1a1b4f4e447ff6ab$var$CacheGroup = function() {
    function CacheGroup(caching, parent) {
        if (parent === void 0) parent = null;
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function() {
        this.d = this.caching ? (0, $bf80b665eb3927c6$export$c723b7eff9d8f870)() : null;
        this.keyMaker = new (0, $a8424dc7ce80e30f$export$73571c50d0f2507e)((0, $b97fc55b2a1fddda$export$772fbc04a0ad4ce9));
    };
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d($1a1b4f4e447ff6ab$var$makeDepKey(dataId, storeFieldName));
            var fieldName = (0, $7cf1a004cfc57df5$export$37874422037b6029)(storeFieldName);
            if (fieldName !== storeFieldName) this.d($1a1b4f4e447ff6ab$var$makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($1a1b4f4e447ff6ab$var$makeDepKey(dataId, storeFieldName), storeFieldName === "__exists" ? "forget" : "setDirty");
    };
    return CacheGroup;
}();
function $1a1b4f4e447ff6ab$var$makeDepKey(dataId, storeFieldName) {
    return storeFieldName + '#' + dataId;
}
function $1a1b4f4e447ff6ab$export$f8068a30967ddc18(store, entityId) {
    if ($1a1b4f4e447ff6ab$export$488c0743feab3d61(store)) store.group.depend(entityId, "__exists");
}
(function(EntityStore) {
    var Root = function(_super) {
        (0, $7455305bac30ddd9$export$a8ba968b8961cb8a)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $1a1b4f4e447ff6ab$var$CacheGroup(resultCaching)) || this;
            _this.stump = new $1a1b4f4e447ff6ab$var$Stump(_this);
            _this.storageTrie = new (0, $a8424dc7ce80e30f$export$73571c50d0f2507e)((0, $b97fc55b2a1fddda$export$772fbc04a0ad4ce9));
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function() {
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($1a1b4f4e447ff6ab$export$cb507f57054c7321 || ($1a1b4f4e447ff6ab$export$cb507f57054c7321 = {}));
var $1a1b4f4e447ff6ab$var$Layer = function(_super) {
    (0, $7455305bac30ddd9$export$a8ba968b8961cb8a)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) Object.keys(this.data).forEach(function(dataId) {
                var ownStoreObject = _this.data[dataId];
                var parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) _this.delete(dataId);
                else if (!ownStoreObject) {
                    _this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach(function(storeFieldName) {
                        _this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) Object.keys(ownStoreObject).forEach(function(storeFieldName) {
                    if (!(0, $9675d5b886252616$export$2e2bcd8739ae039)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) _this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        if (parent === this.parent) return this;
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(this.data, dataId) ? (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, arguments);
    };
    return Layer;
}($1a1b4f4e447ff6ab$export$cb507f57054c7321);
var $1a1b4f4e447ff6ab$var$Stump = function(_super) {
    (0, $7455305bac30ddd9$export$a8ba968b8961cb8a)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function() {}, new $1a1b4f4e447ff6ab$var$CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function() {
        return this;
    };
    Stump.prototype.merge = function() {
        return this.parent.merge.apply(this.parent, arguments);
    };
    return Stump;
}($1a1b4f4e447ff6ab$var$Layer);
function $1a1b4f4e447ff6ab$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    return (0, $9675d5b886252616$export$2e2bcd8739ae039)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $1a1b4f4e447ff6ab$export$488c0743feab3d61(store) {
    return !!(store instanceof $1a1b4f4e447ff6ab$export$cb507f57054c7321 && store.group.caching);
}





function $938c86776b724f26$var$execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        options.context.canonizeResults
    ];
}
var $938c86776b724f26$export$628ef07ba8965f12 = function() {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new ((0, $b97fc55b2a1fddda$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        this.config = (0, $20c8e93b6072aee9$export$8e16b83750b44988)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0, $7cf1a004cfc57df5$export$3ac2a95fbd99c479)(config)
        });
        this.canon = config.canon || new (0, $38af0b4df3538bbb$export$c2e7fdd82233f4a4);
        this.executeSelectionSet = (0, $bf80b665eb3927c6$export$4997ffc0176396a6)(function(options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = $938c86776b724f26$var$execSelectionSetKeyArgs(options);
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) return (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, other), {
                    result: _this.canon.admit(other.result)
                });
                return other;
            }
            (0, $1a1b4f4e447ff6ab$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            keyArgs: $938c86776b724f26$var$execSelectionSetKeyArgs,
            makeCacheKey: function(selectionSet, parent, context, canonizeResults) {
                if ((0, $1a1b4f4e447ff6ab$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $6fe96515315d55c4$export$fa99cac1c0883c47)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
            }
        });
        this.executeSubSelectedArray = (0, $bf80b665eb3927c6$export$4997ffc0176396a6)(function(options) {
            (0, $1a1b4f4e447ff6ab$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $1a1b4f4e447ff6ab$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    StoreReader.prototype.resetCanon = function() {
        this.canon = new (0, $38af0b4df3538bbb$export$c2e7fdd82233f4a4);
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? 'ROOT_QUERY' : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, (0, $2424e121a4289e63$export$84c19026e616569e)((0, $2424e121a4289e63$export$d96b2213c1b9d3a9)(query))), variables);
        var rootRef = (0, $6fe96515315d55c4$export$634ae0e932e9be99)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $2424e121a4289e63$export$f431198736b7f96d)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0, $7455305bac30ddd9$export$18ce0697a983be9b)({
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, $38af0b4df3538bbb$export$88a0ad9b6f961b51)(variables),
                canonizeResults: canonizeResults
            }, (0, $7cf1a004cfc57df5$export$3a33c00f0ae4a480)(query, this.config.fragments))
        });
        var missing;
        if (execResult.missing) {
            missing = [
                new (0, $c135c3f6bc7fc93a$export$257c68286583b0f9)($938c86776b724f26$var$firstMissing(execResult.missing), execResult.missing, query, variables)
            ];
            if (!returnPartialData) throw missing[0];
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $1a1b4f4e447ff6ab$export$488c0743feab3d61)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, this.canon.isKnown(result));
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0, $6fe96515315d55c4$export$fa99cac1c0883c47)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new (0, $104323fd517dfc25$export$509e11c221f576c0)();
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a, _b;
            if (!(0, $7ec532f319e0861b$export$3dc388a5f013b4a5)(selection, variables)) return;
            if ((0, $6fe96515315d55c4$export$fb56ad75dd311c12)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $6fe96515315d55c4$export$7d1ad22471852218)(selection);
                if (fieldValue === void 0) {
                    if (!(0, $695d33c6ff5cdb34$export$43b332f87950a467).added(selection)) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0, $6fe96515315d55c4$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
                } else if ((0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(fieldValue)) fieldValue = handleMissing(_this.executeSubSelectedArray({
                    field: selection,
                    array: fieldValue,
                    enclosingRef: enclosingRef,
                    context: context
                }), resultName);
                else if (!selection.selectionSet) {
                    if (context.canonizeResults) fieldValue = _this.canon.pass(fieldValue);
                } else if (fieldValue != null) fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, $6fe96515315d55c4$export$fa99cac1c0883c47)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
            } else {
                var fragment = (0, $5e4d569a846b5f9e$export$f80bdb85f299186)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, $5050f41989ff6c78$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw __DEV__ ? new (0, $03191bfc90720c4f$export$cea12affaee22fe8)("No fragment named ".concat(selection.name.value)) : new (0, $03191bfc90720c4f$export$cea12affaee22fe8)(5);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        var result = (0, $104323fd517dfc25$export$160070228be94b08)(objectsToMerge);
        var finalResult = {
            result: result,
            missing: missing
        };
        var frozen = context.canonizeResults ? this.canon.admit(finalResult) : (0, $62d5a3f8d8ea93ca$export$7f9c177735b71f18)(finalResult);
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    };
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new (0, $104323fd517dfc25$export$509e11c221f576c0)();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            if (item === null) return null;
            if ((0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, $6fe96515315d55c4$export$fa99cac1c0883c47)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (__DEV__) $938c86776b724f26$var$assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $938c86776b724f26$var$firstMissing(tree) {
    try {
        JSON.stringify(tree, function(_, value) {
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function $938c86776b724f26$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(value)) {
                __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(!(0, $6fe96515315d55c4$export$fa99cac1c0883c47)(value), "Missing selection set for object of type ".concat((0, $7cf1a004cfc57df5$export$fdef206c83ff2c09)(store, value), " returned for query field ").concat(field.name.value)) : (0, $03191bfc90720c4f$export$f5708dca728d7177)(!(0, $6fe96515315d55c4$export$fa99cac1c0883c47)(value), 6);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}













function $24d0fe55a2eefc3d$export$f341b4883239463f(value) {
    var undefId = (0, $fab8b8d7adece54d$export$d0c8ec0fe1b18b70)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }).split(JSON.stringify(undefId)).join("<undefined>");
}








var $a89a64d96f737d36$var$specifierInfoCache = Object.create(null);
function $a89a64d96f737d36$var$lookupSpecifierInfo(spec) {
    var cacheKey = JSON.stringify(spec);
    return $a89a64d96f737d36$var$specifierInfoCache[cacheKey] || ($a89a64d96f737d36$var$specifierInfoCache[cacheKey] = Object.create(null));
}
function $a89a64d96f737d36$export$f1953a0407594d2c(specifier) {
    var info = $a89a64d96f737d36$var$lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function(object, context) {
        var extract = function(from, key) {
            return context.readField(key, from);
        };
        var keyObject = context.keyObject = $a89a64d96f737d36$export$2db31da99613c21f(specifier, function(schemaKeyPath) {
            var extracted = $a89a64d96f737d36$export$e8f64f7a025887d3(context.storeObject, schemaKeyPath, extract);
            if (extracted === void 0 && object !== context.storeObject && (0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(object, schemaKeyPath[0])) extracted = $a89a64d96f737d36$export$e8f64f7a025887d3(object, schemaKeyPath, $a89a64d96f737d36$var$extractKey);
            __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(extracted !== void 0, "Missing field '".concat(schemaKeyPath.join('.'), "' while extracting keyFields from ").concat(JSON.stringify(object))) : (0, $03191bfc90720c4f$export$f5708dca728d7177)(extracted !== void 0, 2);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function $a89a64d96f737d36$export$550737ee0cc371ac(specifier) {
    var info = $a89a64d96f737d36$var$lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function(args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = $a89a64d96f737d36$export$2db31da99613c21f(specifier, function(keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, $d974c0bd81b7c069$export$d307f5934e447d0e)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    var d = field.directives.find(function(d) {
                        return d.name.value === directiveName_1;
                    });
                    var directiveArgs = d && (0, $6fe96515315d55c4$export$3f5a60fb6a781b4f)(d, variables);
                    return directiveArgs && $a89a64d96f737d36$export$e8f64f7a025887d3(directiveArgs, keyPath.slice(1));
                }
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && (0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return $a89a64d96f737d36$export$e8f64f7a025887d3(variables, varKeyPath);
                }
                return;
            }
            if (args) return $a89a64d96f737d36$export$e8f64f7a025887d3(args, keyPath);
        });
        var suffix = JSON.stringify(collected);
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function $a89a64d96f737d36$export$2db31da99613c21f(specifier, extractor) {
    var merger = new (0, $104323fd517dfc25$export$509e11c221f576c0);
    return $a89a64d96f737d36$export$eca459f173e85801(specifier).reduce(function(collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            for(var i = path.length - 1; i >= 0; --i)toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function $a89a64d96f737d36$export$eca459f173e85801(spec) {
    var info = $a89a64d96f737d36$var$lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function(s, i) {
            if ((0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(s)) {
                $a89a64d96f737d36$export$eca459f173e85801(s).forEach(function(p) {
                    return paths_1.push(currentPath_1.concat(p));
                });
                currentPath_1.length = 0;
            } else {
                currentPath_1.push(s);
                if (!(0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function $a89a64d96f737d36$var$extractKey(object, key) {
    return object[key];
}
function $a89a64d96f737d36$export$e8f64f7a025887d3(object, path, extract) {
    extract = extract || $a89a64d96f737d36$var$extractKey;
    return $a89a64d96f737d36$var$normalize(path.reduce(function reducer(obj, key) {
        return (0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(obj) ? obj.map(function(child) {
            return reducer(child, key);
        }) : obj && extract(obj, key);
    }, object));
}
function $a89a64d96f737d36$var$normalize(value) {
    if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(value)) {
        if ((0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(value)) return value.map($a89a64d96f737d36$var$normalize);
        return $a89a64d96f737d36$export$2db31da99613c21f(Object.keys(value).sort(), function(path) {
            return $a89a64d96f737d36$export$e8f64f7a025887d3(value, path);
        });
    }
    return value;
}


(0, $6fe96515315d55c4$export$3cdb6c178b88cabe).setStringify((0, $38af0b4df3538bbb$export$88a0ad9b6f961b51));
function $dd94544546bec897$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $6fe96515315d55c4$export$3f5a60fb6a781b4f)(spec.field, spec.variables) : null;
}
var $dd94544546bec897$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $dd94544546bec897$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
var $dd94544546bec897$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $dd94544546bec897$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $dd94544546bec897$export$e9859ad90648930b = function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        this.supertypeMap = new Map();
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $7455305bac30ddd9$export$18ce0697a983be9b)({
            dataIdFromObject: (0, $7cf1a004cfc57df5$export$bd03c5a9c99d6bce)
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, partialContext), {
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || function() {
                var options = $dd94544546bec897$export$1ad7a877581bdf2e(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            }
        });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while(keyFn){
            var specifierOrId = keyFn(object, context);
            if ((0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(specifierOrId)) keyFn = (0, $a89a64d96f737d36$export$f1953a0407594d2c)(specifierOrId);
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, $7455305bac30ddd9$export$3c9a16f847548506)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $dd94544546bec897$var$mergeTrueFn : merge === false ? $dd94544546bec897$var$mergeFalseFn : existing.merge;
        }
        setMerge(existing, incoming.merge);
        existing.keyFn = keyFields === false ? $dd94544546bec897$var$nullKeyFieldsFn : (0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(keyFields) ? (0, $a89a64d96f737d36$export$f1953a0407594d2c)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = _this.getFieldPolicy(typename, fieldName, true);
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = keyArgs === false ? $dd94544546bec897$var$simpleKeyArgsFn : (0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(keyArgs) ? (0, $a89a64d96f737d36$export$550737ee0cc371ac)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) existing.keyFn = existing.keyFn || $dd94544546bec897$var$simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            __DEV__ ? (0, $03191bfc90720c4f$export$f5708dca728d7177)(!old || old === which, "Cannot change root ".concat(which, " __typename more than once")) : (0, $03191bfc90720c4f$export$f5708dca728d7177)(!old || old === which, 3);
            if (old) delete this.rootIdsByTypename[old];
            this.rootIdsByTypename[typename] = rootId;
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $7cf1a004cfc57df5$export$6ed54d4784f1ce28));
                if (!match || match[0] !== subtype) _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            var supertypes = this.supertypeMap.get(typename);
            if (supertypes && supertypes.size) supertypes.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, $7455305bac30ddd9$export$3c9a16f847548506)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) inbox.splice(0).forEach(function(policy) {
            _this.updateTypePolicy(typename, policy);
        });
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || createIfMissing && (fieldPolicies[fieldName] = Object.create(null));
        }
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).warn("Inferring subtype ".concat(typename, " of supertype ").concat(supertype));
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && i === workQueue_1.length - 1 && (0, $7cf1a004cfc57df5$export$60bd1cbb09c1a4a2)(fragment.selectionSet, result, variables)) {
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $dd94544546bec897$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if ((0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(specifierOrString)) keyFn = (0, $a89a64d96f737d36$export$550737ee0cc371ac)(specifierOrString);
                else {
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $6fe96515315d55c4$export$54be8689c65f3b56)(fieldSpec.field, fieldSpec.variables) : (0, $6fe96515315d55c4$export$3cdb6c178b88cabe)(fieldName, $dd94544546bec897$var$argsFromFieldSpecifier(fieldSpec));
        if (storeFieldName === false) return fieldName;
        return fieldName === (0, $7cf1a004cfc57df5$export$37874422037b6029)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $7cf1a004cfc57df5$export$37874422037b6029)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $dd94544546bec897$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $6fe96515315d55c4$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            return (0, $f14668c1009c897e$export$ac9723609f5c76c2).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === $dd94544546bec897$var$mergeTrueFn) return $dd94544546bec897$var$makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === $dd94544546bec897$var$mergeFalseFn) return incoming;
        if (context.overwrite) existing = void 0;
        return merge(existing, incoming, $dd94544546bec897$var$makeFieldFunctionOptions(this, void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function $dd94544546bec897$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $7cf1a004cfc57df5$export$37874422037b6029)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $dd94544546bec897$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $6fe96515315d55c4$export$fa99cac1c0883c47),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function() {
            return policies.readField($dd94544546bec897$export$1ad7a877581bdf2e(arguments, objectOrReference, variables), context);
        },
        mergeObjects: $dd94544546bec897$var$makeMergeObjectsFunction(context.store)
    };
}
function $dd94544546bec897$export$1ad7a877581bdf2e(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = (0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, fieldNameOrOptions);
        if (!(0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(options, "from")) options.from = objectOrReference;
    }
    if (__DEV__ && options.from === void 0) __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).warn("Undefined 'from' passed to readField with arguments ".concat((0, $24d0fe55a2eefc3d$export$f341b4883239463f)(Array.from(readFieldArgs))));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function $dd94544546bec897$var$makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(existing) || (0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(incoming)) throw __DEV__ ? new (0, $03191bfc90720c4f$export$cea12affaee22fe8)("Cannot automatically merge arrays") : new (0, $03191bfc90720c4f$export$cea12affaee22fe8)(4);
        if ((0, $604f10e48f8d6e7b$export$417207af72fad9c9)(existing) && (0, $604f10e48f8d6e7b$export$417207af72fad9c9)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, $6fe96515315d55c4$export$fa99cac1c0883c47)(existing) && (0, $7cf1a004cfc57df5$export$4f39afca21bd938e)(incoming)) {
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, $7cf1a004cfc57df5$export$4f39afca21bd938e)(existing) && (0, $6fe96515315d55c4$export$fa99cac1c0883c47)(incoming)) {
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, $7cf1a004cfc57df5$export$4f39afca21bd938e)(existing) && (0, $7cf1a004cfc57df5$export$4f39afca21bd938e)(incoming)) return (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, existing), incoming);
        }
        return incoming;
    };
}


function $2bf93987bd62d77f$var$getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, context), {
        clientOnly: clientOnly,
        deferred: deferred
    }));
    return flavored;
}
var $2bf93987bd62d77f$export$eb8361c5d132fb8f = function() {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function(store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0, $2424e121a4289e63$export$7a5b1fa979d2c158)(query);
        var merger = (0, $7cf1a004cfc57df5$export$b874a818f7a2fa6d)();
        variables = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, (0, $2424e121a4289e63$export$84c19026e616569e)(operationDefinition)), variables);
        var context = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({
            store: store,
            written: Object.create(null),
            merge: function(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, $38af0b4df3538bbb$export$88a0ad9b6f961b51)(variables)
        }, (0, $7cf1a004cfc57df5$export$3a33c00f0ae4a480)(query, this.fragments)), {
            overwrite: !!overwrite,
            incomingById: new Map,
            clientOnly: false,
            deferred: false,
            flavors: new Map
        });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map
            },
            context: context
        });
        if (!(0, $6fe96515315d55c4$export$fa99cac1c0883c47)(ref)) throw __DEV__ ? new (0, $03191bfc90720c4f$export$cea12affaee22fe8)("Could not identify object ".concat(JSON.stringify(result))) : new (0, $03191bfc90720c4f$export$cea12affaee22fe8)(7);
        context.incomingById.forEach(function(_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0, $6fe96515315d55c4$export$634ae0e932e9be99)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, $6fe96515315d55c4$export$fa99cac1c0883c47)(applied)) return;
                storeObject = applied;
            }
            if (__DEV__ && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function(field) {
                    if (field.selectionSet) fieldsWithSelectionSets_1[field.name.value] = true;
                });
                var hasSelectionSet_1 = function(storeFieldName) {
                    return fieldsWithSelectionSets_1[(0, $7cf1a004cfc57df5$export$37874422037b6029)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function(storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function(storeFieldName) {
                    if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) $2bf93987bd62d77f$var$warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        var incoming = Object.create(null);
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $6fe96515315d55c4$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        var readField = function() {
            var options = (0, $dd94544546bec897$export$1ad7a877581bdf2e)(arguments, incoming, context.variables);
            if ((0, $6fe96515315d55c4$export$fa99cac1c0883c47)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
                        from: info.storeObject
                    }), context);
                    if (result_1 !== void 0) return result_1;
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, context, typename).forEach(function(context, field) {
            var _a;
            var resultFieldKey = (0, $6fe96515315d55c4$export$7d1ad22471852218)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                var childTree = $2bf93987bd62d77f$var$getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, field.selectionSet ? $2bf93987bd62d77f$var$getContextFlavor(context, false, false) : context, childTree);
                var childTypename = void 0;
                if (field.selectionSet && ((0, $6fe96515315d55c4$export$fa99cac1c0883c47)(incomingValue) || (0, $7cf1a004cfc57df5$export$4f39afca21bd938e)(incomingValue))) childTypename = readField("__typename", incomingValue);
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    field: field,
                    typename: typename,
                    merge: merge
                };
                else $2bf93987bd62d77f$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
            } else if (__DEV__ && !context.clientOnly && !context.deferred && !(0, $695d33c6ff5cdb34$export$43b332f87950a467).added(field) && !policies.getReadFunction(typename, field.name.value)) __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).error("Missing field '".concat((0, $6fe96515315d55c4$export$7d1ad22471852218)(field), "' while writing result ").concat(JSON.stringify(result, null, 2)).substring(0, 1000));
        });
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            }), id = _b[0], keyObject = _b[1];
            dataId = dataId || id;
            if (keyObject) incoming = context.merge(incoming, keyObject);
        } catch (e) {
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0, $6fe96515315d55c4$export$634ae0e932e9be99)(dataId);
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = $2bf93987bd62d77f$var$mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function(field) {
                    return previous_1.fieldNodeSet.add(field);
                });
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                mergeTree: $2bf93987bd62d77f$var$mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) return __DEV__ ? (0, $aa264210ed31b6df$export$629a2bd3f5a49ecc)(value) : value;
        if ((0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, $2bf93987bd62d77f$var$getChildMergeTree(mergeTree, i));
            $2bf93987bd62d77f$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    StoreWriter.prototype.flattenFields = function(selectionSet, result, context, typename) {
        if (typename === void 0) typename = (0, $6fe96515315d55c4$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap);
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new (0, $a8424dc7ce80e30f$export$73571c50d0f2507e)(false);
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function(selection) {
                if (!(0, $7ec532f319e0861b$export$3dc388a5f013b4a5)(selection, context.variables)) return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (!(clientOnly && deferred) && (0, $d974c0bd81b7c069$export$d307f5934e447d0e)(selection.directives)) selection.directives.forEach(function(dir) {
                    var name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        var args = (0, $6fe96515315d55c4$export$3f5a60fb6a781b4f)(dir, context.variables);
                        if (!args || args.if !== false) deferred = true;
                    }
                });
                if ((0, $6fe96515315d55c4$export$fb56ad75dd311c12)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, $2bf93987bd62d77f$var$getContextFlavor(context, clientOnly, deferred));
                } else {
                    var fragment = (0, $5e4d569a846b5f9e$export$f80bdb85f299186)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, $5050f41989ff6c78$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw __DEV__ ? new (0, $03191bfc90720c4f$export$cea12affaee22fe8)("No fragment named ".concat(selection.name.value)) : new (0, $03191bfc90720c4f$export$cea12affaee22fe8)(8);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, $2bf93987bd62d77f$var$getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, $6fe96515315d55c4$export$fa99cac1c0883c47)(incoming)) {
            var e_1 = !(0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(incoming) && ((0, $6fe96515315d55c4$export$fa99cac1c0883c47)(existing) || (0, $7cf1a004cfc57df5$export$4f39afca21bd938e)(existing)) ? existing : void 0;
            var i_1 = incoming;
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, $6fe96515315d55c4$export$fa99cac1c0883c47)(e_1) ? e_1.__ref : e_1
            ];
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return (0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map;
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $03191bfc90720c4f$export$f5708dca728d7177)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                incoming = (0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(i_1) ? i_1.slice(0) : (0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var $2bf93987bd62d77f$var$emptyMergeTreePool = [];
function $2bf93987bd62d77f$var$getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, $2bf93987bd62d77f$var$emptyMergeTreePool.pop() || {
        map: new Map
    });
    return map.get(name);
}
function $2bf93987bd62d77f$var$mergeMergeTrees(left, right) {
    if (left === right || !right || $2bf93987bd62d77f$var$mergeTreeIsEmpty(right)) return left;
    if (!left || $2bf93987bd62d77f$var$mergeTreeIsEmpty(left)) return right;
    var info = left.info && right.info ? (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map : left.map.size ? left.map : right.map;
    var merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function(leftTree, key) {
            merged.map.set(key, $2bf93987bd62d77f$var$mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function(key) {
            merged.map.set(key, $2bf93987bd62d77f$var$mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function $2bf93987bd62d77f$var$mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function $2bf93987bd62d77f$var$maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && $2bf93987bd62d77f$var$mergeTreeIsEmpty(childTree)) {
        $2bf93987bd62d77f$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var $2bf93987bd62d77f$var$warnings = new Set();
function $2bf93987bd62d77f$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    if ((0, $6fe96515315d55c4$export$fa99cac1c0883c47)(existing)) return;
    if ((0, $9675d5b886252616$export$2e2bcd8739ae039)(existing, incoming)) return;
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $7cf1a004cfc57df5$export$37874422037b6029)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    if ($2bf93987bd62d77f$var$warnings.has(typeDotName)) return;
    $2bf93987bd62d77f$var$warnings.add(typeDotName);
    var childTypenames = [];
    if (!(0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(existing) && !(0, $7cf1a004cfc57df5$export$43bee75e5e14138e)(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).warn("Cache data may be lost when replacing the ".concat(fieldName, " field of a ").concat(parentType, " object.\n\nTo address this problem (which is not a bug in Apollo Client), ").concat(childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", "define a custom merge function for the ").concat(typeDotName, " field, so InMemoryCache can safely merge these objects:\n\n  existing: ").concat(JSON.stringify(existing).slice(0, 1000), "\n  incoming: ").concat(JSON.stringify(incoming).slice(0, 1000), "\n\nFor more information about these options, please refer to the documentation:\n\n  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers\n  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects\n"));
}







var $31a53b60bb0b908b$export$467265324939f47f = function(_super) {
    (0, $7455305bac30ddd9$export$a8ba968b8961cb8a)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.makeVar = (0, $f14668c1009c897e$export$5345c8ac69b4a9db);
        _this.txCount = 0;
        _this.config = (0, $7cf1a004cfc57df5$export$fa542f9ee3f7f4e2)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $dd94544546bec897$export$e9859ad90648930b)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function() {
        var rootStore = this.data = new (0, $1a1b4f4e447ff6ab$export$cb507f57054c7321).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function(resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        this.storeWriter = new (0, $2bf93987bd62d77f$export$eb8361c5d132fb8f)(this, this.storeReader = new (0, $938c86776b724f26$export$628ef07ba8965f12)({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0, $7cf1a004cfc57df5$export$3ac2a95fbd99c479)(this.config),
            canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, $bf80b665eb3927c6$export$4997ffc0176396a6)(function(c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function(c) {
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $1a1b4f4e447ff6ab$export$488c0743feab3d61)(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, c.callback, (0, $38af0b4df3538bbb$export$88a0ad9b6f961b51)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach(function(group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function(data) {
        this.init();
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        var _a = options.returnPartialData, returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
                store: options.optimistic ? this.optimisticData : this.data,
                config: this.config,
                returnPartialData: returnPartialData
            })).result || null;
        } catch (e) {
            if (e instanceof (0, $c135c3f6bc7fc93a$export$257c68286583b0f9)) return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(options, "id") && !options.id) return false;
        var store = options.optimistic ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        return this.storeReader.diffQueryAgainstStore((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        }));
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) (0, $f14668c1009c897e$export$f342bdd61b3e9412)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            if (_this.watches.delete(watch) && !_this.watches.size) (0, $f14668c1009c897e$export$cbe12faed7725318)(_this);
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function(options) {
        (0, $38af0b4df3538bbb$export$88a0ad9b6f961b51).reset();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) this.resetResultCache(options.resetResultIdentities);
            else if (options.resetResultIdentities) this.storeReader.resetCanon();
        }
        return ids;
    };
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    InMemoryCache.prototype.identify = function(object) {
        if ((0, $6fe96515315d55c4$export$fa99cac1c0883c47)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            __DEV__ && (0, $03191bfc90720c4f$export$f5708dca728d7177).warn(e);
        }
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $7cf1a004cfc57df5$export$b5a638e9b3fff9f3).call(options, "id")) return false;
            options = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            ++this.txCount;
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function(options) {
        var _this = this;
        this.init();
        (0, $38af0b4df3538bbb$export$88a0ad9b6f961b51).reset();
        if (options && options.discardWatches) {
            this.watches.forEach(function(watch) {
                return _this.maybeBroadcastWatch.forget(watch);
            });
            this.watches.clear();
            (0, $f14668c1009c897e$export$cbe12faed7725318)(this);
        } else this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function(options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                return updateResult = update(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) this.broadcastWatches((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
            onWatchUpdated: function(watch) {
                alreadyDirty.add(watch);
                return false;
            }
        }));
        if (typeof optimistic === 'string') this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) perform(this.data);
        else perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
                onWatchUpdated: function(watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) alreadyDirty.delete(watch);
                    return result;
                }
            }));
            if (alreadyDirty.size) alreadyDirty.forEach(function(watch) {
                return _this.maybeBroadcastWatch.dirty(watch);
            });
        } else this.broadcastWatches(options);
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $695d33c6ff5cdb34$export$43b332f87950a467)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.transformForLink = function(document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.broadcastWatches = function(options) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, options);
        });
    };
    InMemoryCache.prototype.broadcastWatch = function(c, options) {
        var lastDiff = c.lastDiff;
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) return;
        }
        if (!lastDiff || !(0, $9675d5b886252616$export$2e2bcd8739ae039)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    };
    return InMemoryCache;
}((0, $d82c09c0cc7fbc8e$export$5fc74f25506aa9c));


const $d2dcc1acacbd89bc$export$c16848faee2ad07b = (0, $f14668c1009c897e$export$5345c8ac69b4a9db)(false);
const $d2dcc1acacbd89bc$export$69a3209f1a06c04d = new (0, $31a53b60bb0b908b$export$467265324939f47f)();



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

const $0316ae7d1654226a$var$MAX_MOBILE_WIDTH = 700;
const $0316ae7d1654226a$export$e6cb66ef7dc7e1f = ()=>window.screen.width;
const $0316ae7d1654226a$export$4d7649080cd89b80 = ()=>window.screen.height;
const $0316ae7d1654226a$export$7d9f9b4046392aed = ()=>$0316ae7d1654226a$export$e6cb66ef7dc7e1f() <= $0316ae7d1654226a$var$MAX_MOBILE_WIDTH;
const $0316ae7d1654226a$export$b042f465f6c08a24 = ()=>document.body.clientWidth;
const $0316ae7d1654226a$export$aaf21884801bb4b4 = ()=>document.body.clientHeight;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");





const { Text: $ca186f7b6f461205$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { Item: $ca186f7b6f461205$var$Item } = (0, $cd46f582474e92de$export$2e2bcd8739ae039);
const { BulbOutlined: $ca186f7b6f461205$var$BulbOutlined, DashboardOutlined: $ca186f7b6f461205$var$DashboardOutlined, CalendarOutlined: $ca186f7b6f461205$var$CalendarOutlined, MessageOutlined: $ca186f7b6f461205$var$MessageOutlined, EditOutlined: $ca186f7b6f461205$var$EditOutlined, BarChartOutlined: $ca186f7b6f461205$var$BarChartOutlined, SettingOutlined: $ca186f7b6f461205$var$SettingOutlined, InfoCircleOutlined: $ca186f7b6f461205$var$InfoCircleOutlined, RobotOutlined: $ca186f7b6f461205$var$RobotOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $ca186f7b6f461205$var$MyMenu = ({ onClick: onClick })=>{
    const { showModal: showModal, accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    const [selectedKeys, setSelectedKeys] = (0, $6fFrj.useState)([
        'dashboard'
    ]);
    const location = (0, $990f835fb2356f36$export$45d76561a5302f2b)();
    const { userRole: userRole } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$ca779d385d6ad982));
    (0, $6fFrj.useEffect)(()=>{
        const key = location.pathname.split('/')[1] || '/';
        setSelectedKeys([
            key
        ]);
    }, [
        location.key
    ]);
    return (0, $bb3TF.jsxs)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
        defaultOpenKeys: [
            'sub1'
        ],
        defaultSelectedKeys: [
            '1'
        ],
        mode: "inline",
        style: {
            borderRight: 0,
            height: '100%',
            marginTop: '12px'
        },
        theme: "dark",
        selectedKeys: selectedKeys,
        onClick: ()=>onClick?.(),
        children: [
            (0, $bb3TF.jsx)($ca186f7b6f461205$var$Item, {
                icon: (0, $bb3TF.jsx)($ca186f7b6f461205$var$BulbOutlined, {}),
                children: (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                    to: "/onboarding",
                    children: "Get Started"
                })
            }, "onboarding"),
            (0, $bb3TF.jsx)($ca186f7b6f461205$var$Item, {
                icon: (0, $bb3TF.jsx)($ca186f7b6f461205$var$DashboardOutlined, {}),
                children: (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: "Dashboard"
                })
            }, "/"),
            !accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).appointments] ? (0, $bb3TF.jsx)($ca186f7b6f461205$var$Item, {
                icon: (0, $bb3TF.jsx)($ca186f7b6f461205$var$CalendarOutlined, {}),
                onClick: ()=>showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).appointments),
                children: (0, $bb3TF.jsx)($ca186f7b6f461205$var$Text, {
                    style: {
                        color: 'white'
                    },
                    children: "Appointments"
                })
            }, "appointments") : (0, $bb3TF.jsx)($ca186f7b6f461205$var$Item, {
                icon: (0, $bb3TF.jsx)($ca186f7b6f461205$var$CalendarOutlined, {}),
                children: (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                    to: "/appointments",
                    children: "Appointments"
                })
            }, "appointments"),
            (0, $bb3TF.jsx)($ca186f7b6f461205$var$Item, {
                icon: (0, $bb3TF.jsx)($ca186f7b6f461205$var$MessageOutlined, {}),
                children: (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                    to: "/chat",
                    children: "Messaging"
                })
            }, "chat"),
            userRole !== 'STAFF' && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                children: [
                    (0, $bb3TF.jsx)($ca186f7b6f461205$var$Item, {
                        icon: (0, $bb3TF.jsx)($ca186f7b6f461205$var$EditOutlined, {}),
                        children: (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                            to: "/interviews",
                            children: "Interviews"
                        })
                    }, "interviews"),
                    (0, $bb3TF.jsx)($ca186f7b6f461205$var$Item, {
                        icon: (0, $bb3TF.jsx)($ca186f7b6f461205$var$BarChartOutlined, {}),
                        children: (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                            to: "/analytics",
                            children: "Analytics"
                        })
                    }, "analytics")
                ]
            }),
            (0, $bb3TF.jsx)($ca186f7b6f461205$var$Item, {
                icon: (0, $bb3TF.jsx)($ca186f7b6f461205$var$SettingOutlined, {}),
                children: (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                    to: "/settings",
                    children: "Settings"
                })
            }, "settings"),
            !accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).aiResearch] ? (0, $bb3TF.jsx)($ca186f7b6f461205$var$Item, {
                icon: (0, $bb3TF.jsx)($ca186f7b6f461205$var$CalendarOutlined, {}),
                onClick: ()=>showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).aiResearch),
                children: (0, $bb3TF.jsx)($ca186f7b6f461205$var$Text, {
                    style: {
                        color: 'white'
                    },
                    children: "AI Research"
                })
            }, "AIResearch") : (0, $bb3TF.jsx)($ca186f7b6f461205$var$Item, {
                icon: (0, $bb3TF.jsx)($ca186f7b6f461205$var$RobotOutlined, {}),
                className: "openLandbot",
                children: "AI Research"
            }, "AIResearch"),
            (0, $bb3TF.jsx)($ca186f7b6f461205$var$Item, {
                icon: (0, $bb3TF.jsx)($ca186f7b6f461205$var$InfoCircleOutlined, {}),
                children: (0, $bb3TF.jsx)("a", {
                    href: "https://help.taxaroo.com/",
                    target: "_blank",
                    rel: "noreferrer",
                    children: "Help Center"
                })
            }, "helpCenter")
        ]
    });
};
var $ca186f7b6f461205$export$2e2bcd8739ae039 = $ca186f7b6f461205$var$MyMenu;


const { Sider: $1f5c1bf3677eafd4$var$Sider } = (0, $0102c485edc5bdcf$export$2e2bcd8739ae039);
const $1f5c1bf3677eafd4$var$LeftSideMenu = ({ stateChanged: stateChanged })=>{
    const [collapsed, setCollapsed] = (0, $6fFrj.useState)(false);
    (0, $6fFrj.useEffect)(()=>stateChanged(collapsed), [
        collapsed
    ]);
    return (0, $bb3TF.jsx)($1f5c1bf3677eafd4$var$Sider, {
        className: "site-layout-background",
        width: 175,
        breakpoint: "md",
        onBreakpoint: (broken)=>{
            if (broken) {
                if (!collapsed) setCollapsed(!collapsed);
            }
        },
        collapsed: collapsed,
        collapsible: true,
        onCollapse: ()=>setCollapsed(!collapsed),
        children: (0, $bb3TF.jsx)((0, $ca186f7b6f461205$export$2e2bcd8739ae039), {
            onClick: (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? ()=>setCollapsed(true) : undefined
        })
    });
};
var $1f5c1bf3677eafd4$export$2e2bcd8739ae039 = $1f5c1bf3677eafd4$var$LeftSideMenu;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $167b795c990efc2d$exports = {};
/*!
 * Pusher JavaScript Library v7.5.0
 * https://pusher.com/
 *
 * Copyright 2020, Pusher
 * Released under the MIT licence.
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $167b795c990efc2d$exports = factory();
})(window, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
            });
            /******/ Object.defineProperty(exports, '__esModule', {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, 'default', {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != 'string') for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 2);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Copyright (C) 2016 Dmitry Chestnykh
            // MIT License. See LICENSE file for details.
            var __extends = this && this.__extends || function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /**
 * Package base64 implements Base64 encoding and decoding.
 */ // Invalid character used in decoding to indicate
            // that the character to decode is out of range of
            // alphabet and cannot be decoded.
            var INVALID_BYTE = 256;
            /**
 * Implements standard Base64 encoding.
 *
 * Operates in constant time.
 */ var Coder = /** @class */ function() {
                // TODO(dchest): methods to encode chunk-by-chunk.
                function Coder(_paddingCharacter) {
                    if (_paddingCharacter === void 0) _paddingCharacter = "=";
                    this._paddingCharacter = _paddingCharacter;
                }
                Coder.prototype.encodedLength = function(length) {
                    if (!this._paddingCharacter) return (length * 8 + 5) / 6 | 0;
                    return (length + 2) / 3 * 4 | 0;
                };
                Coder.prototype.encode = function(data) {
                    var out = "";
                    var i = 0;
                    for(; i < data.length - 2; i += 3){
                        var c = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                        out += this._encodeByte(c >>> 18 & 63);
                        out += this._encodeByte(c >>> 12 & 63);
                        out += this._encodeByte(c >>> 6 & 63);
                        out += this._encodeByte(c >>> 0 & 63);
                    }
                    var left = data.length - i;
                    if (left > 0) {
                        var c = data[i] << 16 | (left === 2 ? data[i + 1] << 8 : 0);
                        out += this._encodeByte(c >>> 18 & 63);
                        out += this._encodeByte(c >>> 12 & 63);
                        if (left === 2) out += this._encodeByte(c >>> 6 & 63);
                        else out += this._paddingCharacter || "";
                        out += this._paddingCharacter || "";
                    }
                    return out;
                };
                Coder.prototype.maxDecodedLength = function(length) {
                    if (!this._paddingCharacter) return (length * 6 + 7) / 8 | 0;
                    return length / 4 * 3 | 0;
                };
                Coder.prototype.decodedLength = function(s) {
                    return this.maxDecodedLength(s.length - this._getPaddingLength(s));
                };
                Coder.prototype.decode = function(s) {
                    if (s.length === 0) return new Uint8Array(0);
                    var paddingLength = this._getPaddingLength(s);
                    var length = s.length - paddingLength;
                    var out = new Uint8Array(this.maxDecodedLength(length));
                    var op = 0;
                    var i = 0;
                    var haveBad = 0;
                    var v0 = 0, v1 = 0, v2 = 0, v3 = 0;
                    for(; i < length - 4; i += 4){
                        v0 = this._decodeChar(s.charCodeAt(i + 0));
                        v1 = this._decodeChar(s.charCodeAt(i + 1));
                        v2 = this._decodeChar(s.charCodeAt(i + 2));
                        v3 = this._decodeChar(s.charCodeAt(i + 3));
                        out[op++] = v0 << 2 | v1 >>> 4;
                        out[op++] = v1 << 4 | v2 >>> 2;
                        out[op++] = v2 << 6 | v3;
                        haveBad |= v0 & INVALID_BYTE;
                        haveBad |= v1 & INVALID_BYTE;
                        haveBad |= v2 & INVALID_BYTE;
                        haveBad |= v3 & INVALID_BYTE;
                    }
                    if (i < length - 1) {
                        v0 = this._decodeChar(s.charCodeAt(i));
                        v1 = this._decodeChar(s.charCodeAt(i + 1));
                        out[op++] = v0 << 2 | v1 >>> 4;
                        haveBad |= v0 & INVALID_BYTE;
                        haveBad |= v1 & INVALID_BYTE;
                    }
                    if (i < length - 2) {
                        v2 = this._decodeChar(s.charCodeAt(i + 2));
                        out[op++] = v1 << 4 | v2 >>> 2;
                        haveBad |= v2 & INVALID_BYTE;
                    }
                    if (i < length - 3) {
                        v3 = this._decodeChar(s.charCodeAt(i + 3));
                        out[op++] = v2 << 6 | v3;
                        haveBad |= v3 & INVALID_BYTE;
                    }
                    if (haveBad !== 0) throw new Error("Base64Coder: incorrect characters for decoding");
                    return out;
                };
                // Standard encoding have the following encoded/decoded ranges,
                // which we need to convert between.
                //
                // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  +   /
                // Index:   0 - 25                    26 - 51              52 - 61   62  63
                // ASCII:  65 - 90                    97 - 122             48 - 57   43  47
                //
                // Encode 6 bits in b into a new character.
                Coder.prototype._encodeByte = function(b) {
                    // Encoding uses constant time operations as follows:
                    //
                    // 1. Define comparison of A with B using (A - B) >>> 8:
                    //          if A > B, then result is positive integer
                    //          if A <= B, then result is 0
                    //
                    // 2. Define selection of C or 0 using bitwise AND: X & C:
                    //          if X == 0, then result is 0
                    //          if X != 0, then result is C
                    //
                    // 3. Start with the smallest comparison (b >= 0), which is always
                    //    true, so set the result to the starting ASCII value (65).
                    //
                    // 4. Continue comparing b to higher ASCII values, and selecting
                    //    zero if comparison isn't true, otherwise selecting a value
                    //    to add to result, which:
                    //
                    //          a) undoes the previous addition
                    //          b) provides new value to add
                    //
                    var result = b;
                    // b >= 0
                    result += 65;
                    // b > 25
                    result += 25 - b >>> 8 & 6;
                    // b > 51
                    result += 51 - b >>> 8 & -75;
                    // b > 61
                    result += 61 - b >>> 8 & -15;
                    // b > 62
                    result += 62 - b >>> 8 & 3;
                    return String.fromCharCode(result);
                };
                // Decode a character code into a byte.
                // Must return 256 if character is out of alphabet range.
                Coder.prototype._decodeChar = function(c) {
                    // Decoding works similar to encoding: using the same comparison
                    // function, but now it works on ranges: result is always incremented
                    // by value, but this value becomes zero if the range is not
                    // satisfied.
                    //
                    // Decoding starts with invalid value, 256, which is then
                    // subtracted when the range is satisfied. If none of the ranges
                    // apply, the function returns 256, which is then checked by
                    // the caller to throw error.
                    var result = INVALID_BYTE; // start with invalid character
                    // c == 43 (c > 42 and c < 44)
                    result += (42 - c & c - 44) >>> 8 & -INVALID_BYTE + c - 43 + 62;
                    // c == 47 (c > 46 and c < 48)
                    result += (46 - c & c - 48) >>> 8 & -INVALID_BYTE + c - 47 + 63;
                    // c > 47 and c < 58
                    result += (47 - c & c - 58) >>> 8 & -INVALID_BYTE + c - 48 + 52;
                    // c > 64 and c < 91
                    result += (64 - c & c - 91) >>> 8 & -INVALID_BYTE + c - 65 + 0;
                    // c > 96 and c < 123
                    result += (96 - c & c - 123) >>> 8 & -INVALID_BYTE + c - 97 + 26;
                    return result;
                };
                Coder.prototype._getPaddingLength = function(s) {
                    var paddingLength = 0;
                    if (this._paddingCharacter) {
                        for(var i = s.length - 1; i >= 0; i--){
                            if (s[i] !== this._paddingCharacter) break;
                            paddingLength++;
                        }
                        if (s.length < 4 || paddingLength > 2) throw new Error("Base64Coder: incorrect padding");
                    }
                    return paddingLength;
                };
                return Coder;
            }();
            exports.Coder = Coder;
            var stdCoder = new Coder();
            function encode(data) {
                return stdCoder.encode(data);
            }
            exports.encode = encode;
            function decode(s) {
                return stdCoder.decode(s);
            }
            exports.decode = decode;
            /**
 * Implements URL-safe Base64 encoding.
 * (Same as Base64, but '+' is replaced with '-', and '/' with '_').
 *
 * Operates in constant time.
 */ var URLSafeCoder = /** @class */ function(_super) {
                __extends(URLSafeCoder, _super);
                function URLSafeCoder() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                // URL-safe encoding have the following encoded/decoded ranges:
                //
                // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  -   _
                // Index:   0 - 25                    26 - 51              52 - 61   62  63
                // ASCII:  65 - 90                    97 - 122             48 - 57   45  95
                //
                URLSafeCoder.prototype._encodeByte = function(b) {
                    var result = b;
                    // b >= 0
                    result += 65;
                    // b > 25
                    result += 25 - b >>> 8 & 6;
                    // b > 51
                    result += 51 - b >>> 8 & -75;
                    // b > 61
                    result += 61 - b >>> 8 & -13;
                    // b > 62
                    result += 62 - b >>> 8 & 49;
                    return String.fromCharCode(result);
                };
                URLSafeCoder.prototype._decodeChar = function(c) {
                    var result = INVALID_BYTE;
                    // c == 45 (c > 44 and c < 46)
                    result += (44 - c & c - 46) >>> 8 & -INVALID_BYTE + c - 45 + 62;
                    // c == 95 (c > 94 and c < 96)
                    result += (94 - c & c - 96) >>> 8 & -INVALID_BYTE + c - 95 + 63;
                    // c > 47 and c < 58
                    result += (47 - c & c - 58) >>> 8 & -INVALID_BYTE + c - 48 + 52;
                    // c > 64 and c < 91
                    result += (64 - c & c - 91) >>> 8 & -INVALID_BYTE + c - 65 + 0;
                    // c > 96 and c < 123
                    result += (96 - c & c - 123) >>> 8 & -INVALID_BYTE + c - 97 + 26;
                    return result;
                };
                return URLSafeCoder;
            }(Coder);
            exports.URLSafeCoder = URLSafeCoder;
            var urlSafeCoder = new URLSafeCoder();
            function encodeURLSafe(data) {
                return urlSafeCoder.encode(data);
            }
            exports.encodeURLSafe = encodeURLSafe;
            function decodeURLSafe(s) {
                return urlSafeCoder.decode(s);
            }
            exports.decodeURLSafe = decodeURLSafe;
            exports.encodedLength = function(length) {
                return stdCoder.encodedLength(length);
            };
            exports.maxDecodedLength = function(length) {
                return stdCoder.maxDecodedLength(length);
            };
            exports.decodedLength = function(s) {
                return stdCoder.decodedLength(s);
            };
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Copyright (C) 2016 Dmitry Chestnykh
            // MIT License. See LICENSE file for details.
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /**
 * Package utf8 implements UTF-8 encoding and decoding.
 */ var INVALID_UTF16 = "utf8: invalid string";
            var INVALID_UTF8 = "utf8: invalid source encoding";
            /**
 * Encodes the given string into UTF-8 byte array.
 * Throws if the source string has invalid UTF-16 encoding.
 */ function encode(s) {
                // Calculate result length and allocate output array.
                // encodedLength() also validates string and throws errors,
                // so we don't need repeat validation here.
                var arr = new Uint8Array(encodedLength(s));
                var pos = 0;
                for(var i = 0; i < s.length; i++){
                    var c = s.charCodeAt(i);
                    if (c < 0x80) arr[pos++] = c;
                    else if (c < 0x800) {
                        arr[pos++] = 0xc0 | c >> 6;
                        arr[pos++] = 0x80 | c & 0x3f;
                    } else if (c < 0xd800) {
                        arr[pos++] = 0xe0 | c >> 12;
                        arr[pos++] = 0x80 | c >> 6 & 0x3f;
                        arr[pos++] = 0x80 | c & 0x3f;
                    } else {
                        i++; // get one more character
                        c = (c & 0x3ff) << 10;
                        c |= s.charCodeAt(i) & 0x3ff;
                        c += 0x10000;
                        arr[pos++] = 0xf0 | c >> 18;
                        arr[pos++] = 0x80 | c >> 12 & 0x3f;
                        arr[pos++] = 0x80 | c >> 6 & 0x3f;
                        arr[pos++] = 0x80 | c & 0x3f;
                    }
                }
                return arr;
            }
            exports.encode = encode;
            /**
 * Returns the number of bytes required to encode the given string into UTF-8.
 * Throws if the source string has invalid UTF-16 encoding.
 */ function encodedLength(s) {
                var result = 0;
                for(var i = 0; i < s.length; i++){
                    var c = s.charCodeAt(i);
                    if (c < 0x80) result += 1;
                    else if (c < 0x800) result += 2;
                    else if (c < 0xd800) result += 3;
                    else if (c <= 0xdfff) {
                        if (i >= s.length - 1) throw new Error(INVALID_UTF16);
                        i++; // "eat" next character
                        result += 4;
                    } else throw new Error(INVALID_UTF16);
                }
                return result;
            }
            exports.encodedLength = encodedLength;
            /**
 * Decodes the given byte array from UTF-8 into a string.
 * Throws if encoding is invalid.
 */ function decode(arr) {
                var chars = [];
                for(var i = 0; i < arr.length; i++){
                    var b = arr[i];
                    if (b & 0x80) {
                        var min = void 0;
                        if (b < 0xe0) {
                            // Need 1 more byte.
                            if (i >= arr.length) throw new Error(INVALID_UTF8);
                            var n1 = arr[++i];
                            if ((n1 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                            b = (b & 0x1f) << 6 | n1 & 0x3f;
                            min = 0x80;
                        } else if (b < 0xf0) {
                            // Need 2 more bytes.
                            if (i >= arr.length - 1) throw new Error(INVALID_UTF8);
                            var n1 = arr[++i];
                            var n2 = arr[++i];
                            if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                            b = (b & 0x0f) << 12 | (n1 & 0x3f) << 6 | n2 & 0x3f;
                            min = 0x800;
                        } else if (b < 0xf8) {
                            // Need 3 more bytes.
                            if (i >= arr.length - 2) throw new Error(INVALID_UTF8);
                            var n1 = arr[++i];
                            var n2 = arr[++i];
                            var n3 = arr[++i];
                            if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80 || (n3 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                            b = (b & 0x0f) << 18 | (n1 & 0x3f) << 12 | (n2 & 0x3f) << 6 | n3 & 0x3f;
                            min = 0x10000;
                        } else throw new Error(INVALID_UTF8);
                        if (b < min || b >= 0xd800 && b <= 0xdfff) throw new Error(INVALID_UTF8);
                        if (b >= 0x10000) {
                            // Surrogate pair.
                            if (b > 0x10ffff) throw new Error(INVALID_UTF8);
                            b -= 0x10000;
                            chars.push(String.fromCharCode(0xd800 | b >> 10));
                            b = 0xdc00 | b & 0x3ff;
                        }
                    }
                    chars.push(String.fromCharCode(b));
                }
                return chars.join("");
            }
            exports.decode = decode;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            // required so we don't have to do require('pusher').default etc.
            module1.exports = __webpack_require__(3).default;
        /***/ },
        /* 3 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            // ESM COMPAT FLAG
            __webpack_require__.r(__webpack_exports__);
            // CONCATENATED MODULE: ./src/runtimes/web/dom/script_receiver_factory.ts
            var ScriptReceiverFactory = function() {
                function ScriptReceiverFactory(prefix, name) {
                    this.lastId = 0;
                    this.prefix = prefix;
                    this.name = name;
                }
                ScriptReceiverFactory.prototype.create = function(callback) {
                    this.lastId++;
                    var number = this.lastId;
                    var id = this.prefix + number;
                    var name = this.name + '[' + number + ']';
                    var called = false;
                    var callbackWrapper = function() {
                        if (!called) {
                            callback.apply(null, arguments);
                            called = true;
                        }
                    };
                    this[number] = callbackWrapper;
                    return {
                        number: number,
                        id: id,
                        name: name,
                        callback: callbackWrapper
                    };
                };
                ScriptReceiverFactory.prototype.remove = function(receiver) {
                    delete this[receiver.number];
                };
                return ScriptReceiverFactory;
            }();
            var ScriptReceivers = new ScriptReceiverFactory('_pusher_script_', 'Pusher.ScriptReceivers');
            // CONCATENATED MODULE: ./src/core/defaults.ts
            var Defaults = {
                VERSION: "7.5.0",
                PROTOCOL: 7,
                wsPort: 80,
                wssPort: 443,
                wsPath: '',
                httpHost: 'sockjs.pusher.com',
                httpPort: 80,
                httpsPort: 443,
                httpPath: '/pusher',
                stats_host: 'stats.pusher.com',
                authEndpoint: '/pusher/auth',
                authTransport: 'ajax',
                activityTimeout: 120000,
                pongTimeout: 30000,
                unavailableTimeout: 10000,
                cluster: 'mt1',
                userAuthentication: {
                    endpoint: '/pusher/user-auth',
                    transport: 'ajax'
                },
                channelAuthorization: {
                    endpoint: '/pusher/auth',
                    transport: 'ajax'
                },
                cdn_http: "http://js.pusher.com",
                cdn_https: "https://js.pusher.com",
                dependency_suffix: ""
            };
            /* harmony default export */ var defaults = Defaults;
            // CONCATENATED MODULE: ./src/runtimes/web/dom/dependency_loader.ts
            var dependency_loader_DependencyLoader = function() {
                function DependencyLoader(options) {
                    this.options = options;
                    this.receivers = options.receivers || ScriptReceivers;
                    this.loading = {};
                }
                DependencyLoader.prototype.load = function(name, options, callback) {
                    var self = this;
                    if (self.loading[name] && self.loading[name].length > 0) self.loading[name].push(callback);
                    else {
                        self.loading[name] = [
                            callback
                        ];
                        var request = runtime.createScriptRequest(self.getPath(name, options));
                        var receiver = self.receivers.create(function(error) {
                            self.receivers.remove(receiver);
                            if (self.loading[name]) {
                                var callbacks = self.loading[name];
                                delete self.loading[name];
                                var successCallback = function(wasSuccessful) {
                                    if (!wasSuccessful) request.cleanup();
                                };
                                for(var i = 0; i < callbacks.length; i++)callbacks[i](error, successCallback);
                            }
                        });
                        request.send(receiver);
                    }
                };
                DependencyLoader.prototype.getRoot = function(options) {
                    var cdn;
                    var protocol = runtime.getDocument().location.protocol;
                    if (options && options.useTLS || protocol === 'https:') cdn = this.options.cdn_https;
                    else cdn = this.options.cdn_http;
                    return cdn.replace(/\/*$/, '') + '/' + this.options.version;
                };
                DependencyLoader.prototype.getPath = function(name, options) {
                    return this.getRoot(options) + '/' + name + this.options.suffix + '.js';
                };
                return DependencyLoader;
            }();
            /* harmony default export */ var dependency_loader = dependency_loader_DependencyLoader;
            // CONCATENATED MODULE: ./src/runtimes/web/dom/dependencies.ts
            var DependenciesReceivers = new ScriptReceiverFactory('_pusher_dependencies', 'Pusher.DependenciesReceivers');
            var Dependencies = new dependency_loader({
                cdn_http: defaults.cdn_http,
                cdn_https: defaults.cdn_https,
                version: defaults.VERSION,
                suffix: defaults.dependency_suffix,
                receivers: DependenciesReceivers
            });
            // CONCATENATED MODULE: ./src/core/utils/url_store.ts
            var urlStore = {
                baseUrl: 'https://pusher.com',
                urls: {
                    authenticationEndpoint: {
                        path: '/docs/channels/server_api/authenticating_users'
                    },
                    authorizationEndpoint: {
                        path: '/docs/channels/server_api/authorizing-users/'
                    },
                    javascriptQuickStart: {
                        path: '/docs/javascript_quick_start'
                    },
                    triggeringClientEvents: {
                        path: '/docs/client_api_guide/client_events#trigger-events'
                    },
                    encryptedChannelSupport: {
                        fullUrl: 'https://github.com/pusher/pusher-js/tree/cc491015371a4bde5743d1c87a0fbac0feb53195#encrypted-channel-support'
                    }
                }
            };
            var buildLogSuffix = function(key) {
                var urlPrefix = 'See:';
                var urlObj = urlStore.urls[key];
                if (!urlObj) return '';
                var url;
                if (urlObj.fullUrl) url = urlObj.fullUrl;
                else if (urlObj.path) url = urlStore.baseUrl + urlObj.path;
                if (!url) return '';
                return urlPrefix + " " + url;
            };
            /* harmony default export */ var url_store = {
                buildLogSuffix: buildLogSuffix
            };
            // CONCATENATED MODULE: ./src/core/auth/options.ts
            var AuthRequestType;
            (function(AuthRequestType) {
                AuthRequestType["UserAuthentication"] = "user-authentication";
                AuthRequestType["ChannelAuthorization"] = "channel-authorization";
            })(AuthRequestType || (AuthRequestType = {}));
            // CONCATENATED MODULE: ./src/core/errors.ts
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var BadEventName = function(_super) {
                __extends(BadEventName, _super);
                function BadEventName(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return BadEventName;
            }(Error);
            var BadChannelName = function(_super) {
                __extends(BadChannelName, _super);
                function BadChannelName(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return BadChannelName;
            }(Error);
            var RequestTimedOut = function(_super) {
                __extends(RequestTimedOut, _super);
                function RequestTimedOut(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return RequestTimedOut;
            }(Error);
            var TransportPriorityTooLow = function(_super) {
                __extends(TransportPriorityTooLow, _super);
                function TransportPriorityTooLow(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return TransportPriorityTooLow;
            }(Error);
            var TransportClosed = function(_super) {
                __extends(TransportClosed, _super);
                function TransportClosed(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return TransportClosed;
            }(Error);
            var UnsupportedFeature = function(_super) {
                __extends(UnsupportedFeature, _super);
                function UnsupportedFeature(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return UnsupportedFeature;
            }(Error);
            var UnsupportedTransport = function(_super) {
                __extends(UnsupportedTransport, _super);
                function UnsupportedTransport(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return UnsupportedTransport;
            }(Error);
            var UnsupportedStrategy = function(_super) {
                __extends(UnsupportedStrategy, _super);
                function UnsupportedStrategy(msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return UnsupportedStrategy;
            }(Error);
            var HTTPAuthError = function(_super) {
                __extends(HTTPAuthError, _super);
                function HTTPAuthError(status, msg) {
                    var _newTarget = this.constructor;
                    var _this = _super.call(this, msg) || this;
                    _this.status = status;
                    Object.setPrototypeOf(_this, _newTarget.prototype);
                    return _this;
                }
                return HTTPAuthError;
            }(Error);
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/auth/xhr_auth.ts
            var ajax = function(context, query, authOptions, authRequestType, callback) {
                var xhr = runtime.createXHR();
                xhr.open('POST', authOptions.endpoint, true);
                xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                for(var headerName in authOptions.headers)xhr.setRequestHeader(headerName, authOptions.headers[headerName]);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            var data = void 0;
                            var parsed = false;
                            try {
                                data = JSON.parse(xhr.responseText);
                                parsed = true;
                            } catch (e) {
                                callback(new HTTPAuthError(200, "JSON returned from " + authRequestType.toString() + " endpoint was invalid, yet status code was 200. Data was: " + xhr.responseText), null);
                            }
                            if (parsed) callback(null, data);
                        } else {
                            var suffix = '';
                            switch(authRequestType){
                                case AuthRequestType.UserAuthentication:
                                    suffix = url_store.buildLogSuffix('authenticationEndpoint');
                                    break;
                                case AuthRequestType.ChannelAuthorization:
                                    suffix = "Clients must be authorized to join private or presence channels. " + url_store.buildLogSuffix('authorizationEndpoint');
                                    break;
                            }
                            callback(new HTTPAuthError(xhr.status, "Unable to retrieve auth string from " + authRequestType.toString() + " endpoint - " + ("received status: " + xhr.status + " from " + authOptions.endpoint + ". " + suffix)), null);
                        }
                    }
                };
                xhr.send(query);
                return xhr;
            };
            /* harmony default export */ var xhr_auth = ajax;
            // CONCATENATED MODULE: ./src/core/base64.ts
            function encode(s) {
                return btoa(utob(s));
            }
            var fromCharCode = String.fromCharCode;
            var b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
            var b64tab = {};
            for(var base64_i = 0, l = b64chars.length; base64_i < l; base64_i++)b64tab[b64chars.charAt(base64_i)] = base64_i;
            var cb_utob = function(c) {
                var cc = c.charCodeAt(0);
                return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
            };
            var utob = function(u) {
                return u.replace(/[^\x00-\x7F]/g, cb_utob);
            };
            var cb_encode = function(ccc) {
                var padlen = [
                    0,
                    2,
                    1
                ][ccc.length % 3];
                var ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0);
                var chars = [
                    b64chars.charAt(ord >>> 18),
                    b64chars.charAt(ord >>> 12 & 63),
                    padlen >= 2 ? '=' : b64chars.charAt(ord >>> 6 & 63),
                    padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
                ];
                return chars.join('');
            };
            var btoa = window.btoa || function(b) {
                return b.replace(/[\s\S]{1,3}/g, cb_encode);
            };
            // CONCATENATED MODULE: ./src/core/utils/timers/abstract_timer.ts
            var Timer = function() {
                function Timer(set, clear, delay, callback) {
                    var _this = this;
                    this.clear = clear;
                    this.timer = set(function() {
                        if (_this.timer) _this.timer = callback(_this.timer);
                    }, delay);
                }
                Timer.prototype.isRunning = function() {
                    return this.timer !== null;
                };
                Timer.prototype.ensureAborted = function() {
                    if (this.timer) {
                        this.clear(this.timer);
                        this.timer = null;
                    }
                };
                return Timer;
            }();
            /* harmony default export */ var abstract_timer = Timer;
            // CONCATENATED MODULE: ./src/core/utils/timers/index.ts
            var timers_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            function timers_clearTimeout(timer) {
                window.clearTimeout(timer);
            }
            function timers_clearInterval(timer) {
                window.clearInterval(timer);
            }
            var OneOffTimer = function(_super) {
                timers_extends(OneOffTimer, _super);
                function OneOffTimer(delay, callback) {
                    return _super.call(this, setTimeout, timers_clearTimeout, delay, function(timer) {
                        callback();
                        return null;
                    }) || this;
                }
                return OneOffTimer;
            }(abstract_timer);
            var PeriodicTimer = function(_super) {
                timers_extends(PeriodicTimer, _super);
                function PeriodicTimer(delay, callback) {
                    return _super.call(this, setInterval, timers_clearInterval, delay, function(timer) {
                        callback();
                        return timer;
                    }) || this;
                }
                return PeriodicTimer;
            }(abstract_timer);
            // CONCATENATED MODULE: ./src/core/util.ts
            var Util = {
                now: function() {
                    if (Date.now) return Date.now();
                    else return new Date().valueOf();
                },
                defer: function(callback) {
                    return new OneOffTimer(0, callback);
                },
                method: function(name) {
                    var args = [];
                    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                    var boundArguments = Array.prototype.slice.call(arguments, 1);
                    return function(object) {
                        return object[name].apply(object, boundArguments.concat(arguments));
                    };
                }
            };
            /* harmony default export */ var util = Util;
            // CONCATENATED MODULE: ./src/core/utils/collections.ts
            function extend(target) {
                var sources = [];
                for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
                for(var i = 0; i < sources.length; i++){
                    var extensions = sources[i];
                    for(var property in extensions)if (extensions[property] && extensions[property].constructor && extensions[property].constructor === Object) target[property] = extend(target[property] || {}, extensions[property]);
                    else target[property] = extensions[property];
                }
                return target;
            }
            function stringify() {
                var m = [
                    'Pusher'
                ];
                for(var i = 0; i < arguments.length; i++)if (typeof arguments[i] === 'string') m.push(arguments[i]);
                else m.push(safeJSONStringify(arguments[i]));
                return m.join(' : ');
            }
            function arrayIndexOf(array, item) {
                var nativeIndexOf = Array.prototype.indexOf;
                if (array === null) return -1;
                if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item);
                for(var i = 0, l = array.length; i < l; i++){
                    if (array[i] === item) return i;
                }
                return -1;
            }
            function objectApply(object, f) {
                for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) f(object[key], key, object);
            }
            function keys(object) {
                var keys = [];
                objectApply(object, function(_, key) {
                    keys.push(key);
                });
                return keys;
            }
            function values(object) {
                var values = [];
                objectApply(object, function(value) {
                    values.push(value);
                });
                return values;
            }
            function apply(array, f, context) {
                for(var i = 0; i < array.length; i++)f.call(context || window, array[i], i, array);
            }
            function map(array, f) {
                var result = [];
                for(var i = 0; i < array.length; i++)result.push(f(array[i], i, array, result));
                return result;
            }
            function mapObject(object, f) {
                var result = {};
                objectApply(object, function(value, key) {
                    result[key] = f(value);
                });
                return result;
            }
            function filter(array, test) {
                test = test || function(value) {
                    return !!value;
                };
                var result = [];
                for(var i = 0; i < array.length; i++)if (test(array[i], i, array, result)) result.push(array[i]);
                return result;
            }
            function filterObject(object, test) {
                var result = {};
                objectApply(object, function(value, key) {
                    if (test && test(value, key, object, result) || Boolean(value)) result[key] = value;
                });
                return result;
            }
            function flatten(object) {
                var result = [];
                objectApply(object, function(value, key) {
                    result.push([
                        key,
                        value
                    ]);
                });
                return result;
            }
            function any(array, test) {
                for(var i = 0; i < array.length; i++){
                    if (test(array[i], i, array)) return true;
                }
                return false;
            }
            function collections_all(array, test) {
                for(var i = 0; i < array.length; i++){
                    if (!test(array[i], i, array)) return false;
                }
                return true;
            }
            function encodeParamsObject(data) {
                return mapObject(data, function(value) {
                    if (typeof value === 'object') value = safeJSONStringify(value);
                    return encodeURIComponent(encode(value.toString()));
                });
            }
            function buildQueryString(data) {
                var params = filterObject(data, function(value) {
                    return value !== undefined;
                });
                var query = map(flatten(encodeParamsObject(params)), util.method('join', '=')).join('&');
                return query;
            }
            function decycleObject(object) {
                var objects = [], paths = [];
                return function derez(value, path) {
                    var i, name, nu;
                    switch(typeof value){
                        case 'object':
                            if (!value) return null;
                            for(i = 0; i < objects.length; i += 1){
                                if (objects[i] === value) return {
                                    $ref: paths[i]
                                };
                            }
                            objects.push(value);
                            paths.push(path);
                            if (Object.prototype.toString.apply(value) === '[object Array]') {
                                nu = [];
                                for(i = 0; i < value.length; i += 1)nu[i] = derez(value[i], path + '[' + i + ']');
                            } else {
                                nu = {};
                                for(name in value)if (Object.prototype.hasOwnProperty.call(value, name)) nu[name] = derez(value[name], path + '[' + JSON.stringify(name) + ']');
                            }
                            return nu;
                        case 'number':
                        case 'string':
                        case 'boolean':
                            return value;
                    }
                }(object, '$');
            }
            function safeJSONStringify(source) {
                try {
                    return JSON.stringify(source);
                } catch (e) {
                    return JSON.stringify(decycleObject(source));
                }
            }
            // CONCATENATED MODULE: ./src/core/logger.ts
            var logger_Logger = function() {
                function Logger() {
                    this.globalLog = function(message) {
                        if (window.console && window.console.log) window.console.log(message);
                    };
                }
                Logger.prototype.debug = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    this.log(this.globalLog, args);
                };
                Logger.prototype.warn = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    this.log(this.globalLogWarn, args);
                };
                Logger.prototype.error = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    this.log(this.globalLogError, args);
                };
                Logger.prototype.globalLogWarn = function(message) {
                    if (window.console && window.console.warn) window.console.warn(message);
                    else this.globalLog(message);
                };
                Logger.prototype.globalLogError = function(message) {
                    if (window.console && window.console.error) window.console.error(message);
                    else this.globalLogWarn(message);
                };
                Logger.prototype.log = function(defaultLoggingFunction) {
                    var args = [];
                    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                    var message = stringify.apply(this, arguments);
                    if (core_pusher.log) core_pusher.log(message);
                    else if (core_pusher.logToConsole) {
                        var log = defaultLoggingFunction.bind(this);
                        log(message);
                    }
                };
                return Logger;
            }();
            /* harmony default export */ var logger = new logger_Logger();
            // CONCATENATED MODULE: ./src/runtimes/web/auth/jsonp_auth.ts
            var jsonp = function(context, query, authOptions, authRequestType, callback) {
                if (authOptions.headers !== undefined) logger.warn("To send headers with the " + authRequestType.toString() + " request, you must use AJAX, rather than JSONP.");
                var callbackName = context.nextAuthCallbackID.toString();
                context.nextAuthCallbackID++;
                var document1 = context.getDocument();
                var script = document1.createElement('script');
                context.auth_callbacks[callbackName] = function(data) {
                    callback(null, data);
                };
                var callback_name = "Pusher.auth_callbacks['" + callbackName + "']";
                script.src = authOptions.endpoint + '?callback=' + encodeURIComponent(callback_name) + '&' + query;
                var head = document1.getElementsByTagName('head')[0] || document1.documentElement;
                head.insertBefore(script, head.firstChild);
            };
            /* harmony default export */ var jsonp_auth = jsonp;
            // CONCATENATED MODULE: ./src/runtimes/web/dom/script_request.ts
            var ScriptRequest = function() {
                function ScriptRequest(src) {
                    this.src = src;
                }
                ScriptRequest.prototype.send = function(receiver) {
                    var self = this;
                    var errorString = 'Error loading ' + self.src;
                    self.script = document.createElement('script');
                    self.script.id = receiver.id;
                    self.script.src = self.src;
                    self.script.type = 'text/javascript';
                    self.script.charset = 'UTF-8';
                    if (self.script.addEventListener) {
                        self.script.onerror = function() {
                            receiver.callback(errorString);
                        };
                        self.script.onload = function() {
                            receiver.callback(null);
                        };
                    } else self.script.onreadystatechange = function() {
                        if (self.script.readyState === 'loaded' || self.script.readyState === 'complete') receiver.callback(null);
                    };
                    if (self.script.async === undefined && document.attachEvent && /opera/i.test(navigator.userAgent)) {
                        self.errorScript = document.createElement('script');
                        self.errorScript.id = receiver.id + '_error';
                        self.errorScript.text = receiver.name + "('" + errorString + "');";
                        self.script.async = self.errorScript.async = false;
                    } else self.script.async = true;
                    var head = document.getElementsByTagName('head')[0];
                    head.insertBefore(self.script, head.firstChild);
                    if (self.errorScript) head.insertBefore(self.errorScript, self.script.nextSibling);
                };
                ScriptRequest.prototype.cleanup = function() {
                    if (this.script) {
                        this.script.onload = this.script.onerror = null;
                        this.script.onreadystatechange = null;
                    }
                    if (this.script && this.script.parentNode) this.script.parentNode.removeChild(this.script);
                    if (this.errorScript && this.errorScript.parentNode) this.errorScript.parentNode.removeChild(this.errorScript);
                    this.script = null;
                    this.errorScript = null;
                };
                return ScriptRequest;
            }();
            /* harmony default export */ var script_request = ScriptRequest;
            // CONCATENATED MODULE: ./src/runtimes/web/dom/jsonp_request.ts
            var jsonp_request_JSONPRequest = function() {
                function JSONPRequest(url, data) {
                    this.url = url;
                    this.data = data;
                }
                JSONPRequest.prototype.send = function(receiver) {
                    if (this.request) return;
                    var query = buildQueryString(this.data);
                    var url = this.url + '/' + receiver.number + '?' + query;
                    this.request = runtime.createScriptRequest(url);
                    this.request.send(receiver);
                };
                JSONPRequest.prototype.cleanup = function() {
                    if (this.request) this.request.cleanup();
                };
                return JSONPRequest;
            }();
            /* harmony default export */ var jsonp_request = jsonp_request_JSONPRequest;
            // CONCATENATED MODULE: ./src/runtimes/web/timeline/jsonp_timeline.ts
            var getAgent = function(sender, useTLS) {
                return function(data, callback) {
                    var scheme = 'http' + (useTLS ? 's' : '') + '://';
                    var url = scheme + (sender.host || sender.options.host) + sender.options.path;
                    var request = runtime.createJSONPRequest(url, data);
                    var receiver = runtime.ScriptReceivers.create(function(error, result) {
                        ScriptReceivers.remove(receiver);
                        request.cleanup();
                        if (result && result.host) sender.host = result.host;
                        if (callback) callback(error, result);
                    });
                    request.send(receiver);
                };
            };
            var jsonp_timeline_jsonp = {
                name: 'jsonp',
                getAgent: getAgent
            };
            /* harmony default export */ var jsonp_timeline = jsonp_timeline_jsonp;
            // CONCATENATED MODULE: ./src/core/transports/url_schemes.ts
            function getGenericURL(baseScheme, params, path) {
                var scheme = baseScheme + (params.useTLS ? 's' : '');
                var host = params.useTLS ? params.hostTLS : params.hostNonTLS;
                return scheme + '://' + host + path;
            }
            function getGenericPath(key, queryString) {
                var path = '/app/' + key;
                var query = '?protocol=' + defaults.PROTOCOL + '&client=js' + '&version=' + defaults.VERSION + (queryString ? '&' + queryString : '');
                return path + query;
            }
            var ws = {
                getInitial: function(key, params) {
                    var path = (params.httpPath || '') + getGenericPath(key, 'flash=false');
                    return getGenericURL('ws', params, path);
                }
            };
            var http = {
                getInitial: function(key, params) {
                    var path = (params.httpPath || '/pusher') + getGenericPath(key);
                    return getGenericURL('http', params, path);
                }
            };
            var sockjs = {
                getInitial: function(key, params) {
                    return getGenericURL('http', params, params.httpPath || '/pusher');
                },
                getPath: function(key, params) {
                    return getGenericPath(key);
                }
            };
            // CONCATENATED MODULE: ./src/core/events/callback_registry.ts
            var callback_registry_CallbackRegistry = function() {
                function CallbackRegistry() {
                    this._callbacks = {};
                }
                CallbackRegistry.prototype.get = function(name) {
                    return this._callbacks[prefix(name)];
                };
                CallbackRegistry.prototype.add = function(name, callback, context) {
                    var prefixedEventName = prefix(name);
                    this._callbacks[prefixedEventName] = this._callbacks[prefixedEventName] || [];
                    this._callbacks[prefixedEventName].push({
                        fn: callback,
                        context: context
                    });
                };
                CallbackRegistry.prototype.remove = function(name, callback, context) {
                    if (!name && !callback && !context) {
                        this._callbacks = {};
                        return;
                    }
                    var names = name ? [
                        prefix(name)
                    ] : keys(this._callbacks);
                    if (callback || context) this.removeCallback(names, callback, context);
                    else this.removeAllCallbacks(names);
                };
                CallbackRegistry.prototype.removeCallback = function(names, callback, context) {
                    apply(names, function(name) {
                        this._callbacks[name] = filter(this._callbacks[name] || [], function(binding) {
                            return callback && callback !== binding.fn || context && context !== binding.context;
                        });
                        if (this._callbacks[name].length === 0) delete this._callbacks[name];
                    }, this);
                };
                CallbackRegistry.prototype.removeAllCallbacks = function(names) {
                    apply(names, function(name) {
                        delete this._callbacks[name];
                    }, this);
                };
                return CallbackRegistry;
            }();
            /* harmony default export */ var callback_registry = callback_registry_CallbackRegistry;
            function prefix(name) {
                return '_' + name;
            }
            // CONCATENATED MODULE: ./src/core/events/dispatcher.ts
            var dispatcher_Dispatcher = function() {
                function Dispatcher(failThrough) {
                    this.callbacks = new callback_registry();
                    this.global_callbacks = [];
                    this.failThrough = failThrough;
                }
                Dispatcher.prototype.bind = function(eventName, callback, context) {
                    this.callbacks.add(eventName, callback, context);
                    return this;
                };
                Dispatcher.prototype.bind_global = function(callback) {
                    this.global_callbacks.push(callback);
                    return this;
                };
                Dispatcher.prototype.unbind = function(eventName, callback, context) {
                    this.callbacks.remove(eventName, callback, context);
                    return this;
                };
                Dispatcher.prototype.unbind_global = function(callback) {
                    if (!callback) {
                        this.global_callbacks = [];
                        return this;
                    }
                    this.global_callbacks = filter(this.global_callbacks || [], function(c) {
                        return c !== callback;
                    });
                    return this;
                };
                Dispatcher.prototype.unbind_all = function() {
                    this.unbind();
                    this.unbind_global();
                    return this;
                };
                Dispatcher.prototype.emit = function(eventName, data, metadata) {
                    for(var i = 0; i < this.global_callbacks.length; i++)this.global_callbacks[i](eventName, data);
                    var callbacks = this.callbacks.get(eventName);
                    var args = [];
                    if (metadata) args.push(data, metadata);
                    else if (data) args.push(data);
                    if (callbacks && callbacks.length > 0) for(var i = 0; i < callbacks.length; i++)callbacks[i].fn.apply(callbacks[i].context || window, args);
                    else if (this.failThrough) this.failThrough(eventName, data);
                    return this;
                };
                return Dispatcher;
            }();
            /* harmony default export */ var dispatcher = dispatcher_Dispatcher;
            // CONCATENATED MODULE: ./src/core/transports/transport_connection.ts
            var transport_connection_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var transport_connection_TransportConnection = function(_super) {
                transport_connection_extends(TransportConnection, _super);
                function TransportConnection(hooks, name, priority, key, options) {
                    var _this = _super.call(this) || this;
                    _this.initialize = runtime.transportConnectionInitializer;
                    _this.hooks = hooks;
                    _this.name = name;
                    _this.priority = priority;
                    _this.key = key;
                    _this.options = options;
                    _this.state = 'new';
                    _this.timeline = options.timeline;
                    _this.activityTimeout = options.activityTimeout;
                    _this.id = _this.timeline.generateUniqueID();
                    return _this;
                }
                TransportConnection.prototype.handlesActivityChecks = function() {
                    return Boolean(this.hooks.handlesActivityChecks);
                };
                TransportConnection.prototype.supportsPing = function() {
                    return Boolean(this.hooks.supportsPing);
                };
                TransportConnection.prototype.connect = function() {
                    var _this = this;
                    if (this.socket || this.state !== 'initialized') return false;
                    var url = this.hooks.urls.getInitial(this.key, this.options);
                    try {
                        this.socket = this.hooks.getSocket(url, this.options);
                    } catch (e) {
                        util.defer(function() {
                            _this.onError(e);
                            _this.changeState('closed');
                        });
                        return false;
                    }
                    this.bindListeners();
                    logger.debug('Connecting', {
                        transport: this.name,
                        url: url
                    });
                    this.changeState('connecting');
                    return true;
                };
                TransportConnection.prototype.close = function() {
                    if (this.socket) {
                        this.socket.close();
                        return true;
                    } else return false;
                };
                TransportConnection.prototype.send = function(data) {
                    var _this = this;
                    if (this.state === 'open') {
                        util.defer(function() {
                            if (_this.socket) _this.socket.send(data);
                        });
                        return true;
                    } else return false;
                };
                TransportConnection.prototype.ping = function() {
                    if (this.state === 'open' && this.supportsPing()) this.socket.ping();
                };
                TransportConnection.prototype.onOpen = function() {
                    if (this.hooks.beforeOpen) this.hooks.beforeOpen(this.socket, this.hooks.urls.getPath(this.key, this.options));
                    this.changeState('open');
                    this.socket.onopen = undefined;
                };
                TransportConnection.prototype.onError = function(error) {
                    this.emit('error', {
                        type: 'WebSocketError',
                        error: error
                    });
                    this.timeline.error(this.buildTimelineMessage({
                        error: error.toString()
                    }));
                };
                TransportConnection.prototype.onClose = function(closeEvent) {
                    if (closeEvent) this.changeState('closed', {
                        code: closeEvent.code,
                        reason: closeEvent.reason,
                        wasClean: closeEvent.wasClean
                    });
                    else this.changeState('closed');
                    this.unbindListeners();
                    this.socket = undefined;
                };
                TransportConnection.prototype.onMessage = function(message) {
                    this.emit('message', message);
                };
                TransportConnection.prototype.onActivity = function() {
                    this.emit('activity');
                };
                TransportConnection.prototype.bindListeners = function() {
                    var _this = this;
                    this.socket.onopen = function() {
                        _this.onOpen();
                    };
                    this.socket.onerror = function(error) {
                        _this.onError(error);
                    };
                    this.socket.onclose = function(closeEvent) {
                        _this.onClose(closeEvent);
                    };
                    this.socket.onmessage = function(message) {
                        _this.onMessage(message);
                    };
                    if (this.supportsPing()) this.socket.onactivity = function() {
                        _this.onActivity();
                    };
                };
                TransportConnection.prototype.unbindListeners = function() {
                    if (this.socket) {
                        this.socket.onopen = undefined;
                        this.socket.onerror = undefined;
                        this.socket.onclose = undefined;
                        this.socket.onmessage = undefined;
                        if (this.supportsPing()) this.socket.onactivity = undefined;
                    }
                };
                TransportConnection.prototype.changeState = function(state, params) {
                    this.state = state;
                    this.timeline.info(this.buildTimelineMessage({
                        state: state,
                        params: params
                    }));
                    this.emit(state, params);
                };
                TransportConnection.prototype.buildTimelineMessage = function(message) {
                    return extend({
                        cid: this.id
                    }, message);
                };
                return TransportConnection;
            }(dispatcher);
            /* harmony default export */ var transport_connection = transport_connection_TransportConnection;
            // CONCATENATED MODULE: ./src/core/transports/transport.ts
            var transport_Transport = function() {
                function Transport(hooks) {
                    this.hooks = hooks;
                }
                Transport.prototype.isSupported = function(environment) {
                    return this.hooks.isSupported(environment);
                };
                Transport.prototype.createConnection = function(name, priority, key, options) {
                    return new transport_connection(this.hooks, name, priority, key, options);
                };
                return Transport;
            }();
            /* harmony default export */ var transports_transport = transport_Transport;
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/transports/transports.ts
            var WSTransport = new transports_transport({
                urls: ws,
                handlesActivityChecks: false,
                supportsPing: false,
                isInitialized: function() {
                    return Boolean(runtime.getWebSocketAPI());
                },
                isSupported: function() {
                    return Boolean(runtime.getWebSocketAPI());
                },
                getSocket: function(url) {
                    return runtime.createWebSocket(url);
                }
            });
            var httpConfiguration = {
                urls: http,
                handlesActivityChecks: false,
                supportsPing: true,
                isInitialized: function() {
                    return true;
                }
            };
            var streamingConfiguration = extend({
                getSocket: function(url) {
                    return runtime.HTTPFactory.createStreamingSocket(url);
                }
            }, httpConfiguration);
            var pollingConfiguration = extend({
                getSocket: function(url) {
                    return runtime.HTTPFactory.createPollingSocket(url);
                }
            }, httpConfiguration);
            var xhrConfiguration = {
                isSupported: function() {
                    return runtime.isXHRSupported();
                }
            };
            var XHRStreamingTransport = new transports_transport(extend({}, streamingConfiguration, xhrConfiguration));
            var XHRPollingTransport = new transports_transport(extend({}, pollingConfiguration, xhrConfiguration));
            var Transports = {
                ws: WSTransport,
                xhr_streaming: XHRStreamingTransport,
                xhr_polling: XHRPollingTransport
            };
            /* harmony default export */ var transports = Transports;
            // CONCATENATED MODULE: ./src/runtimes/web/transports/transports.ts
            var SockJSTransport = new transports_transport({
                file: 'sockjs',
                urls: sockjs,
                handlesActivityChecks: true,
                supportsPing: false,
                isSupported: function() {
                    return true;
                },
                isInitialized: function() {
                    return window.SockJS !== undefined;
                },
                getSocket: function(url, options) {
                    return new window.SockJS(url, null, {
                        js_path: Dependencies.getPath('sockjs', {
                            useTLS: options.useTLS
                        }),
                        ignore_null_origin: options.ignoreNullOrigin
                    });
                },
                beforeOpen: function(socket, path) {
                    socket.send(JSON.stringify({
                        path: path
                    }));
                }
            });
            var xdrConfiguration = {
                isSupported: function(environment) {
                    var yes = runtime.isXDRSupported(environment.useTLS);
                    return yes;
                }
            };
            var XDRStreamingTransport = new transports_transport(extend({}, streamingConfiguration, xdrConfiguration));
            var XDRPollingTransport = new transports_transport(extend({}, pollingConfiguration, xdrConfiguration));
            transports.xdr_streaming = XDRStreamingTransport;
            transports.xdr_polling = XDRPollingTransport;
            transports.sockjs = SockJSTransport;
            /* harmony default export */ var transports_transports = transports;
            // CONCATENATED MODULE: ./src/runtimes/web/net_info.ts
            var net_info_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var NetInfo = function(_super) {
                net_info_extends(NetInfo, _super);
                function NetInfo() {
                    var _this = _super.call(this) || this;
                    var self = _this;
                    if (window.addEventListener !== undefined) {
                        window.addEventListener('online', function() {
                            self.emit('online');
                        }, false);
                        window.addEventListener('offline', function() {
                            self.emit('offline');
                        }, false);
                    }
                    return _this;
                }
                NetInfo.prototype.isOnline = function() {
                    if (window.navigator.onLine === undefined) return true;
                    else return window.navigator.onLine;
                };
                return NetInfo;
            }(dispatcher);
            var net_info_Network = new NetInfo();
            // CONCATENATED MODULE: ./src/core/transports/assistant_to_the_transport_manager.ts
            var assistant_to_the_transport_manager_AssistantToTheTransportManager = function() {
                function AssistantToTheTransportManager(manager, transport, options) {
                    this.manager = manager;
                    this.transport = transport;
                    this.minPingDelay = options.minPingDelay;
                    this.maxPingDelay = options.maxPingDelay;
                    this.pingDelay = undefined;
                }
                AssistantToTheTransportManager.prototype.createConnection = function(name, priority, key, options) {
                    var _this = this;
                    options = extend({}, options, {
                        activityTimeout: this.pingDelay
                    });
                    var connection = this.transport.createConnection(name, priority, key, options);
                    var openTimestamp = null;
                    var onOpen = function() {
                        connection.unbind('open', onOpen);
                        connection.bind('closed', onClosed);
                        openTimestamp = util.now();
                    };
                    var onClosed = function(closeEvent) {
                        connection.unbind('closed', onClosed);
                        if (closeEvent.code === 1002 || closeEvent.code === 1003) _this.manager.reportDeath();
                        else if (!closeEvent.wasClean && openTimestamp) {
                            var lifespan = util.now() - openTimestamp;
                            if (lifespan < 2 * _this.maxPingDelay) {
                                _this.manager.reportDeath();
                                _this.pingDelay = Math.max(lifespan / 2, _this.minPingDelay);
                            }
                        }
                    };
                    connection.bind('open', onOpen);
                    return connection;
                };
                AssistantToTheTransportManager.prototype.isSupported = function(environment) {
                    return this.manager.isAlive() && this.transport.isSupported(environment);
                };
                return AssistantToTheTransportManager;
            }();
            /* harmony default export */ var assistant_to_the_transport_manager = assistant_to_the_transport_manager_AssistantToTheTransportManager;
            // CONCATENATED MODULE: ./src/core/connection/protocol/protocol.ts
            var Protocol = {
                decodeMessage: function(messageEvent) {
                    try {
                        var messageData = JSON.parse(messageEvent.data);
                        var pusherEventData = messageData.data;
                        if (typeof pusherEventData === 'string') try {
                            pusherEventData = JSON.parse(messageData.data);
                        } catch (e) {}
                        var pusherEvent = {
                            event: messageData.event,
                            channel: messageData.channel,
                            data: pusherEventData
                        };
                        if (messageData.user_id) pusherEvent.user_id = messageData.user_id;
                        return pusherEvent;
                    } catch (e) {
                        throw {
                            type: 'MessageParseError',
                            error: e,
                            data: messageEvent.data
                        };
                    }
                },
                encodeMessage: function(event) {
                    return JSON.stringify(event);
                },
                processHandshake: function(messageEvent) {
                    var message = Protocol.decodeMessage(messageEvent);
                    if (message.event === 'pusher:connection_established') {
                        if (!message.data.activity_timeout) throw 'No activity timeout specified in handshake';
                        return {
                            action: 'connected',
                            id: message.data.socket_id,
                            activityTimeout: message.data.activity_timeout * 1000
                        };
                    } else if (message.event === 'pusher:error') return {
                        action: this.getCloseAction(message.data),
                        error: this.getCloseError(message.data)
                    };
                    else throw 'Invalid handshake';
                },
                getCloseAction: function(closeEvent) {
                    if (closeEvent.code < 4000) {
                        if (closeEvent.code >= 1002 && closeEvent.code <= 1004) return 'backoff';
                        else return null;
                    } else if (closeEvent.code === 4000) return 'tls_only';
                    else if (closeEvent.code < 4100) return 'refused';
                    else if (closeEvent.code < 4200) return 'backoff';
                    else if (closeEvent.code < 4300) return 'retry';
                    else return 'refused';
                },
                getCloseError: function(closeEvent) {
                    if (closeEvent.code !== 1000 && closeEvent.code !== 1001) return {
                        type: 'PusherError',
                        data: {
                            code: closeEvent.code,
                            message: closeEvent.reason || closeEvent.message
                        }
                    };
                    else return null;
                }
            };
            /* harmony default export */ var protocol_protocol = Protocol;
            // CONCATENATED MODULE: ./src/core/connection/connection.ts
            var connection_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var connection_Connection = function(_super) {
                connection_extends(Connection, _super);
                function Connection(id, transport) {
                    var _this = _super.call(this) || this;
                    _this.id = id;
                    _this.transport = transport;
                    _this.activityTimeout = transport.activityTimeout;
                    _this.bindListeners();
                    return _this;
                }
                Connection.prototype.handlesActivityChecks = function() {
                    return this.transport.handlesActivityChecks();
                };
                Connection.prototype.send = function(data) {
                    return this.transport.send(data);
                };
                Connection.prototype.send_event = function(name, data, channel) {
                    var event = {
                        event: name,
                        data: data
                    };
                    if (channel) event.channel = channel;
                    logger.debug('Event sent', event);
                    return this.send(protocol_protocol.encodeMessage(event));
                };
                Connection.prototype.ping = function() {
                    if (this.transport.supportsPing()) this.transport.ping();
                    else this.send_event('pusher:ping', {});
                };
                Connection.prototype.close = function() {
                    this.transport.close();
                };
                Connection.prototype.bindListeners = function() {
                    var _this = this;
                    var listeners = {
                        message: function(messageEvent) {
                            var pusherEvent;
                            try {
                                pusherEvent = protocol_protocol.decodeMessage(messageEvent);
                            } catch (e) {
                                _this.emit('error', {
                                    type: 'MessageParseError',
                                    error: e,
                                    data: messageEvent.data
                                });
                            }
                            if (pusherEvent !== undefined) {
                                logger.debug('Event recd', pusherEvent);
                                switch(pusherEvent.event){
                                    case 'pusher:error':
                                        _this.emit('error', {
                                            type: 'PusherError',
                                            data: pusherEvent.data
                                        });
                                        break;
                                    case 'pusher:ping':
                                        _this.emit('ping');
                                        break;
                                    case 'pusher:pong':
                                        _this.emit('pong');
                                        break;
                                }
                                _this.emit('message', pusherEvent);
                            }
                        },
                        activity: function() {
                            _this.emit('activity');
                        },
                        error: function(error) {
                            _this.emit('error', error);
                        },
                        closed: function(closeEvent) {
                            unbindListeners();
                            if (closeEvent && closeEvent.code) _this.handleCloseEvent(closeEvent);
                            _this.transport = null;
                            _this.emit('closed');
                        }
                    };
                    var unbindListeners = function() {
                        objectApply(listeners, function(listener, event) {
                            _this.transport.unbind(event, listener);
                        });
                    };
                    objectApply(listeners, function(listener, event) {
                        _this.transport.bind(event, listener);
                    });
                };
                Connection.prototype.handleCloseEvent = function(closeEvent) {
                    var action = protocol_protocol.getCloseAction(closeEvent);
                    var error = protocol_protocol.getCloseError(closeEvent);
                    if (error) this.emit('error', error);
                    if (action) this.emit(action, {
                        action: action,
                        error: error
                    });
                };
                return Connection;
            }(dispatcher);
            /* harmony default export */ var connection_connection = connection_Connection;
            // CONCATENATED MODULE: ./src/core/connection/handshake/index.ts
            var handshake_Handshake = function() {
                function Handshake(transport, callback) {
                    this.transport = transport;
                    this.callback = callback;
                    this.bindListeners();
                }
                Handshake.prototype.close = function() {
                    this.unbindListeners();
                    this.transport.close();
                };
                Handshake.prototype.bindListeners = function() {
                    var _this = this;
                    this.onMessage = function(m) {
                        _this.unbindListeners();
                        var result;
                        try {
                            result = protocol_protocol.processHandshake(m);
                        } catch (e) {
                            _this.finish('error', {
                                error: e
                            });
                            _this.transport.close();
                            return;
                        }
                        if (result.action === 'connected') _this.finish('connected', {
                            connection: new connection_connection(result.id, _this.transport),
                            activityTimeout: result.activityTimeout
                        });
                        else {
                            _this.finish(result.action, {
                                error: result.error
                            });
                            _this.transport.close();
                        }
                    };
                    this.onClosed = function(closeEvent) {
                        _this.unbindListeners();
                        var action = protocol_protocol.getCloseAction(closeEvent) || 'backoff';
                        var error = protocol_protocol.getCloseError(closeEvent);
                        _this.finish(action, {
                            error: error
                        });
                    };
                    this.transport.bind('message', this.onMessage);
                    this.transport.bind('closed', this.onClosed);
                };
                Handshake.prototype.unbindListeners = function() {
                    this.transport.unbind('message', this.onMessage);
                    this.transport.unbind('closed', this.onClosed);
                };
                Handshake.prototype.finish = function(action, params) {
                    this.callback(extend({
                        transport: this.transport,
                        action: action
                    }, params));
                };
                return Handshake;
            }();
            /* harmony default export */ var connection_handshake = handshake_Handshake;
            // CONCATENATED MODULE: ./src/core/timeline/timeline_sender.ts
            var timeline_sender_TimelineSender = function() {
                function TimelineSender(timeline, options) {
                    this.timeline = timeline;
                    this.options = options || {};
                }
                TimelineSender.prototype.send = function(useTLS, callback) {
                    if (this.timeline.isEmpty()) return;
                    this.timeline.send(runtime.TimelineTransport.getAgent(this, useTLS), callback);
                };
                return TimelineSender;
            }();
            /* harmony default export */ var timeline_sender = timeline_sender_TimelineSender;
            // CONCATENATED MODULE: ./src/core/channels/channel.ts
            var channel_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var channel_Channel = function(_super) {
                channel_extends(Channel, _super);
                function Channel(name, pusher) {
                    var _this = _super.call(this, function(event, data) {
                        logger.debug('No callbacks on ' + name + ' for ' + event);
                    }) || this;
                    _this.name = name;
                    _this.pusher = pusher;
                    _this.subscribed = false;
                    _this.subscriptionPending = false;
                    _this.subscriptionCancelled = false;
                    return _this;
                }
                Channel.prototype.authorize = function(socketId, callback) {
                    return callback(null, {
                        auth: ''
                    });
                };
                Channel.prototype.trigger = function(event, data) {
                    if (event.indexOf('client-') !== 0) throw new BadEventName("Event '" + event + "' does not start with 'client-'");
                    if (!this.subscribed) {
                        var suffix = url_store.buildLogSuffix('triggeringClientEvents');
                        logger.warn("Client event triggered before channel 'subscription_succeeded' event . " + suffix);
                    }
                    return this.pusher.send_event(event, data, this.name);
                };
                Channel.prototype.disconnect = function() {
                    this.subscribed = false;
                    this.subscriptionPending = false;
                };
                Channel.prototype.handleEvent = function(event) {
                    var eventName = event.event;
                    var data = event.data;
                    if (eventName === 'pusher_internal:subscription_succeeded') this.handleSubscriptionSucceededEvent(event);
                    else if (eventName === 'pusher_internal:subscription_count') this.handleSubscriptionCountEvent(event);
                    else if (eventName.indexOf('pusher_internal:') !== 0) {
                        var metadata = {};
                        this.emit(eventName, data, metadata);
                    }
                };
                Channel.prototype.handleSubscriptionSucceededEvent = function(event) {
                    this.subscriptionPending = false;
                    this.subscribed = true;
                    if (this.subscriptionCancelled) this.pusher.unsubscribe(this.name);
                    else this.emit('pusher:subscription_succeeded', event.data);
                };
                Channel.prototype.handleSubscriptionCountEvent = function(event) {
                    if (event.data.subscription_count) this.subscriptionCount = event.data.subscription_count;
                    this.emit('pusher:subscription_count', event.data);
                };
                Channel.prototype.subscribe = function() {
                    var _this = this;
                    if (this.subscribed) return;
                    this.subscriptionPending = true;
                    this.subscriptionCancelled = false;
                    this.authorize(this.pusher.connection.socket_id, function(error, data) {
                        if (error) {
                            _this.subscriptionPending = false;
                            logger.error(error.toString());
                            _this.emit('pusher:subscription_error', Object.assign({}, {
                                type: 'AuthError',
                                error: error.message
                            }, error instanceof HTTPAuthError ? {
                                status: error.status
                            } : {}));
                        } else _this.pusher.send_event('pusher:subscribe', {
                            auth: data.auth,
                            channel_data: data.channel_data,
                            channel: _this.name
                        });
                    });
                };
                Channel.prototype.unsubscribe = function() {
                    this.subscribed = false;
                    this.pusher.send_event('pusher:unsubscribe', {
                        channel: this.name
                    });
                };
                Channel.prototype.cancelSubscription = function() {
                    this.subscriptionCancelled = true;
                };
                Channel.prototype.reinstateSubscription = function() {
                    this.subscriptionCancelled = false;
                };
                return Channel;
            }(dispatcher);
            /* harmony default export */ var channels_channel = channel_Channel;
            // CONCATENATED MODULE: ./src/core/channels/private_channel.ts
            var private_channel_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var PrivateChannel = function(_super) {
                private_channel_extends(PrivateChannel, _super);
                function PrivateChannel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                PrivateChannel.prototype.authorize = function(socketId, callback) {
                    return this.pusher.config.channelAuthorizer({
                        channelName: this.name,
                        socketId: socketId
                    }, callback);
                };
                return PrivateChannel;
            }(channels_channel);
            /* harmony default export */ var private_channel = PrivateChannel;
            // CONCATENATED MODULE: ./src/core/channels/members.ts
            var members_Members = function() {
                function Members() {
                    this.reset();
                }
                Members.prototype.get = function(id) {
                    if (Object.prototype.hasOwnProperty.call(this.members, id)) return {
                        id: id,
                        info: this.members[id]
                    };
                    else return null;
                };
                Members.prototype.each = function(callback) {
                    var _this = this;
                    objectApply(this.members, function(member, id) {
                        callback(_this.get(id));
                    });
                };
                Members.prototype.setMyID = function(id) {
                    this.myID = id;
                };
                Members.prototype.onSubscription = function(subscriptionData) {
                    this.members = subscriptionData.presence.hash;
                    this.count = subscriptionData.presence.count;
                    this.me = this.get(this.myID);
                };
                Members.prototype.addMember = function(memberData) {
                    if (this.get(memberData.user_id) === null) this.count++;
                    this.members[memberData.user_id] = memberData.user_info;
                    return this.get(memberData.user_id);
                };
                Members.prototype.removeMember = function(memberData) {
                    var member = this.get(memberData.user_id);
                    if (member) {
                        delete this.members[memberData.user_id];
                        this.count--;
                    }
                    return member;
                };
                Members.prototype.reset = function() {
                    this.members = {};
                    this.count = 0;
                    this.myID = null;
                    this.me = null;
                };
                return Members;
            }();
            /* harmony default export */ var members = members_Members;
            // CONCATENATED MODULE: ./src/core/channels/presence_channel.ts
            var presence_channel_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __awaiter = function(thisArg, _arguments, P, generator) {
                function adopt(value) {
                    return value instanceof P ? value : new P(function(resolve) {
                        resolve(value);
                    });
                }
                return new (P || (P = Promise))(function(resolve, reject) {
                    function fulfilled(value) {
                        try {
                            step(generator.next(value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function rejected(value) {
                        try {
                            step(generator["throw"](value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function step(result) {
                        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                    }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };
            var __generator = function(thisArg, body) {
                var _ = {
                    label: 0,
                    sent: function() {
                        if (t[0] & 1) throw t[1];
                        return t[1];
                    },
                    trys: [],
                    ops: []
                }, f, y, t, g;
                return g = {
                    next: verb(0),
                    "throw": verb(1),
                    "return": verb(2)
                }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                    return this;
                }), g;
                function verb(n) {
                    return function(v) {
                        return step([
                            n,
                            v
                        ]);
                    };
                }
                function step(op) {
                    if (f) throw new TypeError("Generator is already executing.");
                    while(_)try {
                        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                        if (y = 0, t) op = [
                            op[0] & 2,
                            t.value
                        ];
                        switch(op[0]){
                            case 0:
                            case 1:
                                t = op;
                                break;
                            case 4:
                                _.label++;
                                return {
                                    value: op[1],
                                    done: false
                                };
                            case 5:
                                _.label++;
                                y = op[1];
                                op = [
                                    0
                                ];
                                continue;
                            case 7:
                                op = _.ops.pop();
                                _.trys.pop();
                                continue;
                            default:
                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                    _ = 0;
                                    continue;
                                }
                                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                    _.label = op[1];
                                    break;
                                }
                                if (op[0] === 6 && _.label < t[1]) {
                                    _.label = t[1];
                                    t = op;
                                    break;
                                }
                                if (t && _.label < t[2]) {
                                    _.label = t[2];
                                    _.ops.push(op);
                                    break;
                                }
                                if (t[2]) _.ops.pop();
                                _.trys.pop();
                                continue;
                        }
                        op = body.call(thisArg, _);
                    } catch (e) {
                        op = [
                            6,
                            e
                        ];
                        y = 0;
                    } finally{
                        f = t = 0;
                    }
                    if (op[0] & 5) throw op[1];
                    return {
                        value: op[0] ? op[1] : void 0,
                        done: true
                    };
                }
            };
            var presence_channel_PresenceChannel = function(_super) {
                presence_channel_extends(PresenceChannel, _super);
                function PresenceChannel(name, pusher) {
                    var _this = _super.call(this, name, pusher) || this;
                    _this.members = new members();
                    return _this;
                }
                PresenceChannel.prototype.authorize = function(socketId, callback) {
                    var _this = this;
                    _super.prototype.authorize.call(this, socketId, function(error, authData) {
                        return __awaiter(_this, void 0, void 0, function() {
                            var channelData, suffix;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!!error) return [
                                            3,
                                            3
                                        ];
                                        authData;
                                        if (!(authData.channel_data != null)) return [
                                            3,
                                            1
                                        ];
                                        channelData = JSON.parse(authData.channel_data);
                                        this.members.setMyID(channelData.user_id);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 1:
                                        return [
                                            4,
                                            this.pusher.user.signinDonePromise
                                        ];
                                    case 2:
                                        _a.sent();
                                        if (this.pusher.user.user_data != null) this.members.setMyID(this.pusher.user.user_data.id);
                                        else {
                                            suffix = url_store.buildLogSuffix('authorizationEndpoint');
                                            logger.error("Invalid auth response for channel '" + this.name + "', " + ("expected 'channel_data' field. " + suffix + ", ") + "or the user should be signed in.");
                                            callback('Invalid auth response');
                                            return [
                                                2
                                            ];
                                        }
                                        _a.label = 3;
                                    case 3:
                                        callback(error, authData);
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    });
                };
                PresenceChannel.prototype.handleEvent = function(event) {
                    var eventName = event.event;
                    if (eventName.indexOf('pusher_internal:') === 0) this.handleInternalEvent(event);
                    else {
                        var data = event.data;
                        var metadata = {};
                        if (event.user_id) metadata.user_id = event.user_id;
                        this.emit(eventName, data, metadata);
                    }
                };
                PresenceChannel.prototype.handleInternalEvent = function(event) {
                    var eventName = event.event;
                    var data = event.data;
                    switch(eventName){
                        case 'pusher_internal:subscription_succeeded':
                            this.handleSubscriptionSucceededEvent(event);
                            break;
                        case 'pusher_internal:subscription_count':
                            this.handleSubscriptionCountEvent(event);
                            break;
                        case 'pusher_internal:member_added':
                            var addedMember = this.members.addMember(data);
                            this.emit('pusher:member_added', addedMember);
                            break;
                        case 'pusher_internal:member_removed':
                            var removedMember = this.members.removeMember(data);
                            if (removedMember) this.emit('pusher:member_removed', removedMember);
                            break;
                    }
                };
                PresenceChannel.prototype.handleSubscriptionSucceededEvent = function(event) {
                    this.subscriptionPending = false;
                    this.subscribed = true;
                    if (this.subscriptionCancelled) this.pusher.unsubscribe(this.name);
                    else {
                        this.members.onSubscription(event.data);
                        this.emit('pusher:subscription_succeeded', this.members);
                    }
                };
                PresenceChannel.prototype.disconnect = function() {
                    this.members.reset();
                    _super.prototype.disconnect.call(this);
                };
                return PresenceChannel;
            }(private_channel);
            /* harmony default export */ var presence_channel = presence_channel_PresenceChannel;
            // EXTERNAL MODULE: ./node_modules/@stablelib/utf8/lib/utf8.js
            var utf8 = __webpack_require__(1);
            // EXTERNAL MODULE: ./node_modules/@stablelib/base64/lib/base64.js
            var base64 = __webpack_require__(0);
            // CONCATENATED MODULE: ./src/core/channels/encrypted_channel.ts
            var encrypted_channel_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var encrypted_channel_EncryptedChannel = function(_super) {
                encrypted_channel_extends(EncryptedChannel, _super);
                function EncryptedChannel(name, pusher, nacl) {
                    var _this = _super.call(this, name, pusher) || this;
                    _this.key = null;
                    _this.nacl = nacl;
                    return _this;
                }
                EncryptedChannel.prototype.authorize = function(socketId, callback) {
                    var _this = this;
                    _super.prototype.authorize.call(this, socketId, function(error, authData) {
                        if (error) {
                            callback(error, authData);
                            return;
                        }
                        var sharedSecret = authData['shared_secret'];
                        if (!sharedSecret) {
                            callback(new Error("No shared_secret key in auth payload for encrypted channel: " + _this.name), null);
                            return;
                        }
                        _this.key = Object(base64["decode"])(sharedSecret);
                        delete authData['shared_secret'];
                        callback(null, authData);
                    });
                };
                EncryptedChannel.prototype.trigger = function(event, data) {
                    throw new UnsupportedFeature('Client events are not currently supported for encrypted channels');
                };
                EncryptedChannel.prototype.handleEvent = function(event) {
                    var eventName = event.event;
                    var data = event.data;
                    if (eventName.indexOf('pusher_internal:') === 0 || eventName.indexOf('pusher:') === 0) {
                        _super.prototype.handleEvent.call(this, event);
                        return;
                    }
                    this.handleEncryptedEvent(eventName, data);
                };
                EncryptedChannel.prototype.handleEncryptedEvent = function(event, data) {
                    var _this = this;
                    if (!this.key) {
                        logger.debug('Received encrypted event before key has been retrieved from the authEndpoint');
                        return;
                    }
                    if (!data.ciphertext || !data.nonce) {
                        logger.error('Unexpected format for encrypted event, expected object with `ciphertext` and `nonce` fields, got: ' + data);
                        return;
                    }
                    var cipherText = Object(base64["decode"])(data.ciphertext);
                    if (cipherText.length < this.nacl.secretbox.overheadLength) {
                        logger.error("Expected encrypted event ciphertext length to be " + this.nacl.secretbox.overheadLength + ", got: " + cipherText.length);
                        return;
                    }
                    var nonce = Object(base64["decode"])(data.nonce);
                    if (nonce.length < this.nacl.secretbox.nonceLength) {
                        logger.error("Expected encrypted event nonce length to be " + this.nacl.secretbox.nonceLength + ", got: " + nonce.length);
                        return;
                    }
                    var bytes = this.nacl.secretbox.open(cipherText, nonce, this.key);
                    if (bytes === null) {
                        logger.debug('Failed to decrypt an event, probably because it was encrypted with a different key. Fetching a new key from the authEndpoint...');
                        this.authorize(this.pusher.connection.socket_id, function(error, authData) {
                            if (error) {
                                logger.error("Failed to make a request to the authEndpoint: " + authData + ". Unable to fetch new key, so dropping encrypted event");
                                return;
                            }
                            bytes = _this.nacl.secretbox.open(cipherText, nonce, _this.key);
                            if (bytes === null) {
                                logger.error("Failed to decrypt event with new key. Dropping encrypted event");
                                return;
                            }
                            _this.emit(event, _this.getDataToEmit(bytes));
                            return;
                        });
                        return;
                    }
                    this.emit(event, this.getDataToEmit(bytes));
                };
                EncryptedChannel.prototype.getDataToEmit = function(bytes) {
                    var raw = Object(utf8["decode"])(bytes);
                    try {
                        return JSON.parse(raw);
                    } catch (_a) {
                        return raw;
                    }
                };
                return EncryptedChannel;
            }(private_channel);
            /* harmony default export */ var encrypted_channel = encrypted_channel_EncryptedChannel;
            // CONCATENATED MODULE: ./src/core/connection/connection_manager.ts
            var connection_manager_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var connection_manager_ConnectionManager = function(_super) {
                connection_manager_extends(ConnectionManager, _super);
                function ConnectionManager(key, options) {
                    var _this = _super.call(this) || this;
                    _this.state = 'initialized';
                    _this.connection = null;
                    _this.key = key;
                    _this.options = options;
                    _this.timeline = _this.options.timeline;
                    _this.usingTLS = _this.options.useTLS;
                    _this.errorCallbacks = _this.buildErrorCallbacks();
                    _this.connectionCallbacks = _this.buildConnectionCallbacks(_this.errorCallbacks);
                    _this.handshakeCallbacks = _this.buildHandshakeCallbacks(_this.errorCallbacks);
                    var Network = runtime.getNetwork();
                    Network.bind('online', function() {
                        _this.timeline.info({
                            netinfo: 'online'
                        });
                        if (_this.state === 'connecting' || _this.state === 'unavailable') _this.retryIn(0);
                    });
                    Network.bind('offline', function() {
                        _this.timeline.info({
                            netinfo: 'offline'
                        });
                        if (_this.connection) _this.sendActivityCheck();
                    });
                    _this.updateStrategy();
                    return _this;
                }
                ConnectionManager.prototype.connect = function() {
                    if (this.connection || this.runner) return;
                    if (!this.strategy.isSupported()) {
                        this.updateState('failed');
                        return;
                    }
                    this.updateState('connecting');
                    this.startConnecting();
                    this.setUnavailableTimer();
                };
                ConnectionManager.prototype.send = function(data) {
                    if (this.connection) return this.connection.send(data);
                    else return false;
                };
                ConnectionManager.prototype.send_event = function(name, data, channel) {
                    if (this.connection) return this.connection.send_event(name, data, channel);
                    else return false;
                };
                ConnectionManager.prototype.disconnect = function() {
                    this.disconnectInternally();
                    this.updateState('disconnected');
                };
                ConnectionManager.prototype.isUsingTLS = function() {
                    return this.usingTLS;
                };
                ConnectionManager.prototype.startConnecting = function() {
                    var _this = this;
                    var callback = function(error, handshake) {
                        if (error) _this.runner = _this.strategy.connect(0, callback);
                        else if (handshake.action === 'error') {
                            _this.emit('error', {
                                type: 'HandshakeError',
                                error: handshake.error
                            });
                            _this.timeline.error({
                                handshakeError: handshake.error
                            });
                        } else {
                            _this.abortConnecting();
                            _this.handshakeCallbacks[handshake.action](handshake);
                        }
                    };
                    this.runner = this.strategy.connect(0, callback);
                };
                ConnectionManager.prototype.abortConnecting = function() {
                    if (this.runner) {
                        this.runner.abort();
                        this.runner = null;
                    }
                };
                ConnectionManager.prototype.disconnectInternally = function() {
                    this.abortConnecting();
                    this.clearRetryTimer();
                    this.clearUnavailableTimer();
                    if (this.connection) {
                        var connection = this.abandonConnection();
                        connection.close();
                    }
                };
                ConnectionManager.prototype.updateStrategy = function() {
                    this.strategy = this.options.getStrategy({
                        key: this.key,
                        timeline: this.timeline,
                        useTLS: this.usingTLS
                    });
                };
                ConnectionManager.prototype.retryIn = function(delay) {
                    var _this = this;
                    this.timeline.info({
                        action: 'retry',
                        delay: delay
                    });
                    if (delay > 0) this.emit('connecting_in', Math.round(delay / 1000));
                    this.retryTimer = new OneOffTimer(delay || 0, function() {
                        _this.disconnectInternally();
                        _this.connect();
                    });
                };
                ConnectionManager.prototype.clearRetryTimer = function() {
                    if (this.retryTimer) {
                        this.retryTimer.ensureAborted();
                        this.retryTimer = null;
                    }
                };
                ConnectionManager.prototype.setUnavailableTimer = function() {
                    var _this = this;
                    this.unavailableTimer = new OneOffTimer(this.options.unavailableTimeout, function() {
                        _this.updateState('unavailable');
                    });
                };
                ConnectionManager.prototype.clearUnavailableTimer = function() {
                    if (this.unavailableTimer) this.unavailableTimer.ensureAborted();
                };
                ConnectionManager.prototype.sendActivityCheck = function() {
                    var _this = this;
                    this.stopActivityCheck();
                    this.connection.ping();
                    this.activityTimer = new OneOffTimer(this.options.pongTimeout, function() {
                        _this.timeline.error({
                            pong_timed_out: _this.options.pongTimeout
                        });
                        _this.retryIn(0);
                    });
                };
                ConnectionManager.prototype.resetActivityCheck = function() {
                    var _this = this;
                    this.stopActivityCheck();
                    if (this.connection && !this.connection.handlesActivityChecks()) this.activityTimer = new OneOffTimer(this.activityTimeout, function() {
                        _this.sendActivityCheck();
                    });
                };
                ConnectionManager.prototype.stopActivityCheck = function() {
                    if (this.activityTimer) this.activityTimer.ensureAborted();
                };
                ConnectionManager.prototype.buildConnectionCallbacks = function(errorCallbacks) {
                    var _this = this;
                    return extend({}, errorCallbacks, {
                        message: function(message) {
                            _this.resetActivityCheck();
                            _this.emit('message', message);
                        },
                        ping: function() {
                            _this.send_event('pusher:pong', {});
                        },
                        activity: function() {
                            _this.resetActivityCheck();
                        },
                        error: function(error) {
                            _this.emit('error', error);
                        },
                        closed: function() {
                            _this.abandonConnection();
                            if (_this.shouldRetry()) _this.retryIn(1000);
                        }
                    });
                };
                ConnectionManager.prototype.buildHandshakeCallbacks = function(errorCallbacks) {
                    var _this = this;
                    return extend({}, errorCallbacks, {
                        connected: function(handshake) {
                            _this.activityTimeout = Math.min(_this.options.activityTimeout, handshake.activityTimeout, handshake.connection.activityTimeout || Infinity);
                            _this.clearUnavailableTimer();
                            _this.setConnection(handshake.connection);
                            _this.socket_id = _this.connection.id;
                            _this.updateState('connected', {
                                socket_id: _this.socket_id
                            });
                        }
                    });
                };
                ConnectionManager.prototype.buildErrorCallbacks = function() {
                    var _this = this;
                    var withErrorEmitted = function(callback) {
                        return function(result) {
                            if (result.error) _this.emit('error', {
                                type: 'WebSocketError',
                                error: result.error
                            });
                            callback(result);
                        };
                    };
                    return {
                        tls_only: withErrorEmitted(function() {
                            _this.usingTLS = true;
                            _this.updateStrategy();
                            _this.retryIn(0);
                        }),
                        refused: withErrorEmitted(function() {
                            _this.disconnect();
                        }),
                        backoff: withErrorEmitted(function() {
                            _this.retryIn(1000);
                        }),
                        retry: withErrorEmitted(function() {
                            _this.retryIn(0);
                        })
                    };
                };
                ConnectionManager.prototype.setConnection = function(connection) {
                    this.connection = connection;
                    for(var event in this.connectionCallbacks)this.connection.bind(event, this.connectionCallbacks[event]);
                    this.resetActivityCheck();
                };
                ConnectionManager.prototype.abandonConnection = function() {
                    if (!this.connection) return;
                    this.stopActivityCheck();
                    for(var event in this.connectionCallbacks)this.connection.unbind(event, this.connectionCallbacks[event]);
                    var connection = this.connection;
                    this.connection = null;
                    return connection;
                };
                ConnectionManager.prototype.updateState = function(newState, data) {
                    var previousState = this.state;
                    this.state = newState;
                    if (previousState !== newState) {
                        var newStateDescription = newState;
                        if (newStateDescription === 'connected') newStateDescription += ' with new socket ID ' + data.socket_id;
                        logger.debug('State changed', previousState + ' -> ' + newStateDescription);
                        this.timeline.info({
                            state: newState,
                            params: data
                        });
                        this.emit('state_change', {
                            previous: previousState,
                            current: newState
                        });
                        this.emit(newState, data);
                    }
                };
                ConnectionManager.prototype.shouldRetry = function() {
                    return this.state === 'connecting' || this.state === 'connected';
                };
                return ConnectionManager;
            }(dispatcher);
            /* harmony default export */ var connection_manager = connection_manager_ConnectionManager;
            // CONCATENATED MODULE: ./src/core/channels/channels.ts
            var channels_Channels = function() {
                function Channels() {
                    this.channels = {};
                }
                Channels.prototype.add = function(name, pusher) {
                    if (!this.channels[name]) this.channels[name] = createChannel(name, pusher);
                    return this.channels[name];
                };
                Channels.prototype.all = function() {
                    return values(this.channels);
                };
                Channels.prototype.find = function(name) {
                    return this.channels[name];
                };
                Channels.prototype.remove = function(name) {
                    var channel = this.channels[name];
                    delete this.channels[name];
                    return channel;
                };
                Channels.prototype.disconnect = function() {
                    objectApply(this.channels, function(channel) {
                        channel.disconnect();
                    });
                };
                return Channels;
            }();
            /* harmony default export */ var channels = channels_Channels;
            function createChannel(name, pusher) {
                if (name.indexOf('private-encrypted-') === 0) {
                    if (pusher.config.nacl) return factory.createEncryptedChannel(name, pusher, pusher.config.nacl);
                    var errMsg = 'Tried to subscribe to a private-encrypted- channel but no nacl implementation available';
                    var suffix = url_store.buildLogSuffix('encryptedChannelSupport');
                    throw new UnsupportedFeature(errMsg + ". " + suffix);
                } else if (name.indexOf('private-') === 0) return factory.createPrivateChannel(name, pusher);
                else if (name.indexOf('presence-') === 0) return factory.createPresenceChannel(name, pusher);
                else if (name.indexOf('#') === 0) throw new BadChannelName('Cannot create a channel with name "' + name + '".');
                else return factory.createChannel(name, pusher);
            }
            // CONCATENATED MODULE: ./src/core/utils/factory.ts
            var Factory = {
                createChannels: function() {
                    return new channels();
                },
                createConnectionManager: function(key, options) {
                    return new connection_manager(key, options);
                },
                createChannel: function(name, pusher) {
                    return new channels_channel(name, pusher);
                },
                createPrivateChannel: function(name, pusher) {
                    return new private_channel(name, pusher);
                },
                createPresenceChannel: function(name, pusher) {
                    return new presence_channel(name, pusher);
                },
                createEncryptedChannel: function(name, pusher, nacl) {
                    return new encrypted_channel(name, pusher, nacl);
                },
                createTimelineSender: function(timeline, options) {
                    return new timeline_sender(timeline, options);
                },
                createHandshake: function(transport, callback) {
                    return new connection_handshake(transport, callback);
                },
                createAssistantToTheTransportManager: function(manager, transport, options) {
                    return new assistant_to_the_transport_manager(manager, transport, options);
                }
            };
            /* harmony default export */ var factory = Factory;
            // CONCATENATED MODULE: ./src/core/transports/transport_manager.ts
            var transport_manager_TransportManager = function() {
                function TransportManager(options) {
                    this.options = options || {};
                    this.livesLeft = this.options.lives || Infinity;
                }
                TransportManager.prototype.getAssistant = function(transport) {
                    return factory.createAssistantToTheTransportManager(this, transport, {
                        minPingDelay: this.options.minPingDelay,
                        maxPingDelay: this.options.maxPingDelay
                    });
                };
                TransportManager.prototype.isAlive = function() {
                    return this.livesLeft > 0;
                };
                TransportManager.prototype.reportDeath = function() {
                    this.livesLeft -= 1;
                };
                return TransportManager;
            }();
            /* harmony default export */ var transport_manager = transport_manager_TransportManager;
            // CONCATENATED MODULE: ./src/core/strategies/sequential_strategy.ts
            var sequential_strategy_SequentialStrategy = function() {
                function SequentialStrategy(strategies, options) {
                    this.strategies = strategies;
                    this.loop = Boolean(options.loop);
                    this.failFast = Boolean(options.failFast);
                    this.timeout = options.timeout;
                    this.timeoutLimit = options.timeoutLimit;
                }
                SequentialStrategy.prototype.isSupported = function() {
                    return any(this.strategies, util.method('isSupported'));
                };
                SequentialStrategy.prototype.connect = function(minPriority, callback) {
                    var _this = this;
                    var strategies = this.strategies;
                    var current = 0;
                    var timeout = this.timeout;
                    var runner = null;
                    var tryNextStrategy = function(error, handshake) {
                        if (handshake) callback(null, handshake);
                        else {
                            current = current + 1;
                            if (_this.loop) current = current % strategies.length;
                            if (current < strategies.length) {
                                if (timeout) {
                                    timeout = timeout * 2;
                                    if (_this.timeoutLimit) timeout = Math.min(timeout, _this.timeoutLimit);
                                }
                                runner = _this.tryStrategy(strategies[current], minPriority, {
                                    timeout: timeout,
                                    failFast: _this.failFast
                                }, tryNextStrategy);
                            } else callback(true);
                        }
                    };
                    runner = this.tryStrategy(strategies[current], minPriority, {
                        timeout: timeout,
                        failFast: this.failFast
                    }, tryNextStrategy);
                    return {
                        abort: function() {
                            runner.abort();
                        },
                        forceMinPriority: function(p) {
                            minPriority = p;
                            if (runner) runner.forceMinPriority(p);
                        }
                    };
                };
                SequentialStrategy.prototype.tryStrategy = function(strategy, minPriority, options, callback) {
                    var timer = null;
                    var runner = null;
                    if (options.timeout > 0) timer = new OneOffTimer(options.timeout, function() {
                        runner.abort();
                        callback(true);
                    });
                    runner = strategy.connect(minPriority, function(error, handshake) {
                        if (error && timer && timer.isRunning() && !options.failFast) return;
                        if (timer) timer.ensureAborted();
                        callback(error, handshake);
                    });
                    return {
                        abort: function() {
                            if (timer) timer.ensureAborted();
                            runner.abort();
                        },
                        forceMinPriority: function(p) {
                            runner.forceMinPriority(p);
                        }
                    };
                };
                return SequentialStrategy;
            }();
            /* harmony default export */ var sequential_strategy = sequential_strategy_SequentialStrategy;
            // CONCATENATED MODULE: ./src/core/strategies/best_connected_ever_strategy.ts
            var best_connected_ever_strategy_BestConnectedEverStrategy = function() {
                function BestConnectedEverStrategy(strategies) {
                    this.strategies = strategies;
                }
                BestConnectedEverStrategy.prototype.isSupported = function() {
                    return any(this.strategies, util.method('isSupported'));
                };
                BestConnectedEverStrategy.prototype.connect = function(minPriority, callback) {
                    return connect(this.strategies, minPriority, function(i, runners) {
                        return function(error, handshake) {
                            runners[i].error = error;
                            if (error) {
                                if (allRunnersFailed(runners)) callback(true);
                                return;
                            }
                            apply(runners, function(runner) {
                                runner.forceMinPriority(handshake.transport.priority);
                            });
                            callback(null, handshake);
                        };
                    });
                };
                return BestConnectedEverStrategy;
            }();
            /* harmony default export */ var best_connected_ever_strategy = best_connected_ever_strategy_BestConnectedEverStrategy;
            function connect(strategies, minPriority, callbackBuilder) {
                var runners = map(strategies, function(strategy, i, _, rs) {
                    return strategy.connect(minPriority, callbackBuilder(i, rs));
                });
                return {
                    abort: function() {
                        apply(runners, abortRunner);
                    },
                    forceMinPriority: function(p) {
                        apply(runners, function(runner) {
                            runner.forceMinPriority(p);
                        });
                    }
                };
            }
            function allRunnersFailed(runners) {
                return collections_all(runners, function(runner) {
                    return Boolean(runner.error);
                });
            }
            function abortRunner(runner) {
                if (!runner.error && !runner.aborted) {
                    runner.abort();
                    runner.aborted = true;
                }
            }
            // CONCATENATED MODULE: ./src/core/strategies/cached_strategy.ts
            var cached_strategy_CachedStrategy = function() {
                function CachedStrategy(strategy, transports, options) {
                    this.strategy = strategy;
                    this.transports = transports;
                    this.ttl = options.ttl || 1800000;
                    this.usingTLS = options.useTLS;
                    this.timeline = options.timeline;
                }
                CachedStrategy.prototype.isSupported = function() {
                    return this.strategy.isSupported();
                };
                CachedStrategy.prototype.connect = function(minPriority, callback) {
                    var usingTLS = this.usingTLS;
                    var info = fetchTransportCache(usingTLS);
                    var strategies = [
                        this.strategy
                    ];
                    if (info && info.timestamp + this.ttl >= util.now()) {
                        var transport = this.transports[info.transport];
                        if (transport) {
                            this.timeline.info({
                                cached: true,
                                transport: info.transport,
                                latency: info.latency
                            });
                            strategies.push(new sequential_strategy([
                                transport
                            ], {
                                timeout: info.latency * 2 + 1000,
                                failFast: true
                            }));
                        }
                    }
                    var startTimestamp = util.now();
                    var runner = strategies.pop().connect(minPriority, function cb(error, handshake) {
                        if (error) {
                            flushTransportCache(usingTLS);
                            if (strategies.length > 0) {
                                startTimestamp = util.now();
                                runner = strategies.pop().connect(minPriority, cb);
                            } else callback(error);
                        } else {
                            storeTransportCache(usingTLS, handshake.transport.name, util.now() - startTimestamp);
                            callback(null, handshake);
                        }
                    });
                    return {
                        abort: function() {
                            runner.abort();
                        },
                        forceMinPriority: function(p) {
                            minPriority = p;
                            if (runner) runner.forceMinPriority(p);
                        }
                    };
                };
                return CachedStrategy;
            }();
            /* harmony default export */ var cached_strategy = cached_strategy_CachedStrategy;
            function getTransportCacheKey(usingTLS) {
                return 'pusherTransport' + (usingTLS ? 'TLS' : 'NonTLS');
            }
            function fetchTransportCache(usingTLS) {
                var storage = runtime.getLocalStorage();
                if (storage) try {
                    var serializedCache = storage[getTransportCacheKey(usingTLS)];
                    if (serializedCache) return JSON.parse(serializedCache);
                } catch (e) {
                    flushTransportCache(usingTLS);
                }
                return null;
            }
            function storeTransportCache(usingTLS, transport, latency) {
                var storage = runtime.getLocalStorage();
                if (storage) try {
                    storage[getTransportCacheKey(usingTLS)] = safeJSONStringify({
                        timestamp: util.now(),
                        transport: transport,
                        latency: latency
                    });
                } catch (e) {}
            }
            function flushTransportCache(usingTLS) {
                var storage = runtime.getLocalStorage();
                if (storage) try {
                    delete storage[getTransportCacheKey(usingTLS)];
                } catch (e) {}
            }
            // CONCATENATED MODULE: ./src/core/strategies/delayed_strategy.ts
            var delayed_strategy_DelayedStrategy = function() {
                function DelayedStrategy(strategy, _a) {
                    var number = _a.delay;
                    this.strategy = strategy;
                    this.options = {
                        delay: number
                    };
                }
                DelayedStrategy.prototype.isSupported = function() {
                    return this.strategy.isSupported();
                };
                DelayedStrategy.prototype.connect = function(minPriority, callback) {
                    var strategy = this.strategy;
                    var runner;
                    var timer = new OneOffTimer(this.options.delay, function() {
                        runner = strategy.connect(minPriority, callback);
                    });
                    return {
                        abort: function() {
                            timer.ensureAborted();
                            if (runner) runner.abort();
                        },
                        forceMinPriority: function(p) {
                            minPriority = p;
                            if (runner) runner.forceMinPriority(p);
                        }
                    };
                };
                return DelayedStrategy;
            }();
            /* harmony default export */ var delayed_strategy = delayed_strategy_DelayedStrategy;
            // CONCATENATED MODULE: ./src/core/strategies/if_strategy.ts
            var IfStrategy = function() {
                function IfStrategy(test, trueBranch, falseBranch) {
                    this.test = test;
                    this.trueBranch = trueBranch;
                    this.falseBranch = falseBranch;
                }
                IfStrategy.prototype.isSupported = function() {
                    var branch = this.test() ? this.trueBranch : this.falseBranch;
                    return branch.isSupported();
                };
                IfStrategy.prototype.connect = function(minPriority, callback) {
                    var branch = this.test() ? this.trueBranch : this.falseBranch;
                    return branch.connect(minPriority, callback);
                };
                return IfStrategy;
            }();
            /* harmony default export */ var if_strategy = IfStrategy;
            // CONCATENATED MODULE: ./src/core/strategies/first_connected_strategy.ts
            var FirstConnectedStrategy = function() {
                function FirstConnectedStrategy(strategy) {
                    this.strategy = strategy;
                }
                FirstConnectedStrategy.prototype.isSupported = function() {
                    return this.strategy.isSupported();
                };
                FirstConnectedStrategy.prototype.connect = function(minPriority, callback) {
                    var runner = this.strategy.connect(minPriority, function(error, handshake) {
                        if (handshake) runner.abort();
                        callback(error, handshake);
                    });
                    return runner;
                };
                return FirstConnectedStrategy;
            }();
            /* harmony default export */ var first_connected_strategy = FirstConnectedStrategy;
            // CONCATENATED MODULE: ./src/runtimes/web/default_strategy.ts
            function testSupportsStrategy(strategy) {
                return function() {
                    return strategy.isSupported();
                };
            }
            var getDefaultStrategy = function(config, baseOptions, defineTransport) {
                var definedTransports = {};
                function defineTransportStrategy(name, type, priority, options, manager) {
                    var transport = defineTransport(config, name, type, priority, options, manager);
                    definedTransports[name] = transport;
                    return transport;
                }
                var ws_options = Object.assign({}, baseOptions, {
                    hostNonTLS: config.wsHost + ':' + config.wsPort,
                    hostTLS: config.wsHost + ':' + config.wssPort,
                    httpPath: config.wsPath
                });
                var wss_options = Object.assign({}, ws_options, {
                    useTLS: true
                });
                var sockjs_options = Object.assign({}, baseOptions, {
                    hostNonTLS: config.httpHost + ':' + config.httpPort,
                    hostTLS: config.httpHost + ':' + config.httpsPort,
                    httpPath: config.httpPath
                });
                var timeouts = {
                    loop: true,
                    timeout: 15000,
                    timeoutLimit: 60000
                };
                var ws_manager = new transport_manager({
                    lives: 2,
                    minPingDelay: 10000,
                    maxPingDelay: config.activityTimeout
                });
                var streaming_manager = new transport_manager({
                    lives: 2,
                    minPingDelay: 10000,
                    maxPingDelay: config.activityTimeout
                });
                var ws_transport = defineTransportStrategy('ws', 'ws', 3, ws_options, ws_manager);
                var wss_transport = defineTransportStrategy('wss', 'ws', 3, wss_options, ws_manager);
                var sockjs_transport = defineTransportStrategy('sockjs', 'sockjs', 1, sockjs_options);
                var xhr_streaming_transport = defineTransportStrategy('xhr_streaming', 'xhr_streaming', 1, sockjs_options, streaming_manager);
                var xdr_streaming_transport = defineTransportStrategy('xdr_streaming', 'xdr_streaming', 1, sockjs_options, streaming_manager);
                var xhr_polling_transport = defineTransportStrategy('xhr_polling', 'xhr_polling', 1, sockjs_options);
                var xdr_polling_transport = defineTransportStrategy('xdr_polling', 'xdr_polling', 1, sockjs_options);
                var ws_loop = new sequential_strategy([
                    ws_transport
                ], timeouts);
                var wss_loop = new sequential_strategy([
                    wss_transport
                ], timeouts);
                var sockjs_loop = new sequential_strategy([
                    sockjs_transport
                ], timeouts);
                var streaming_loop = new sequential_strategy([
                    new if_strategy(testSupportsStrategy(xhr_streaming_transport), xhr_streaming_transport, xdr_streaming_transport)
                ], timeouts);
                var polling_loop = new sequential_strategy([
                    new if_strategy(testSupportsStrategy(xhr_polling_transport), xhr_polling_transport, xdr_polling_transport)
                ], timeouts);
                var http_loop = new sequential_strategy([
                    new if_strategy(testSupportsStrategy(streaming_loop), new best_connected_ever_strategy([
                        streaming_loop,
                        new delayed_strategy(polling_loop, {
                            delay: 4000
                        })
                    ]), polling_loop)
                ], timeouts);
                var http_fallback_loop = new if_strategy(testSupportsStrategy(http_loop), http_loop, sockjs_loop);
                var wsStrategy;
                if (baseOptions.useTLS) wsStrategy = new best_connected_ever_strategy([
                    ws_loop,
                    new delayed_strategy(http_fallback_loop, {
                        delay: 2000
                    })
                ]);
                else wsStrategy = new best_connected_ever_strategy([
                    ws_loop,
                    new delayed_strategy(wss_loop, {
                        delay: 2000
                    }),
                    new delayed_strategy(http_fallback_loop, {
                        delay: 5000
                    })
                ]);
                return new cached_strategy(new first_connected_strategy(new if_strategy(testSupportsStrategy(ws_transport), wsStrategy, http_fallback_loop)), definedTransports, {
                    ttl: 1800000,
                    timeline: baseOptions.timeline,
                    useTLS: baseOptions.useTLS
                });
            };
            /* harmony default export */ var default_strategy = getDefaultStrategy;
            // CONCATENATED MODULE: ./src/runtimes/web/transports/transport_connection_initializer.ts
            /* harmony default export */ var transport_connection_initializer = function() {
                var self = this;
                self.timeline.info(self.buildTimelineMessage({
                    transport: self.name + (self.options.useTLS ? 's' : '')
                }));
                if (self.hooks.isInitialized()) self.changeState('initialized');
                else if (self.hooks.file) {
                    self.changeState('initializing');
                    Dependencies.load(self.hooks.file, {
                        useTLS: self.options.useTLS
                    }, function(error, callback) {
                        if (self.hooks.isInitialized()) {
                            self.changeState('initialized');
                            callback(true);
                        } else {
                            if (error) self.onError(error);
                            self.onClose();
                            callback(false);
                        }
                    });
                } else self.onClose();
            };
            // CONCATENATED MODULE: ./src/runtimes/web/http/http_xdomain_request.ts
            var http_xdomain_request_hooks = {
                getRequest: function(socket) {
                    var xdr = new window.XDomainRequest();
                    xdr.ontimeout = function() {
                        socket.emit('error', new RequestTimedOut());
                        socket.close();
                    };
                    xdr.onerror = function(e) {
                        socket.emit('error', e);
                        socket.close();
                    };
                    xdr.onprogress = function() {
                        if (xdr.responseText && xdr.responseText.length > 0) socket.onChunk(200, xdr.responseText);
                    };
                    xdr.onload = function() {
                        if (xdr.responseText && xdr.responseText.length > 0) socket.onChunk(200, xdr.responseText);
                        socket.emit('finished', 200);
                        socket.close();
                    };
                    return xdr;
                },
                abortRequest: function(xdr) {
                    xdr.ontimeout = xdr.onerror = xdr.onprogress = xdr.onload = null;
                    xdr.abort();
                }
            };
            /* harmony default export */ var http_xdomain_request = http_xdomain_request_hooks;
            // CONCATENATED MODULE: ./src/core/http/http_request.ts
            var http_request_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var MAX_BUFFER_LENGTH = 262144;
            var http_request_HTTPRequest = function(_super) {
                http_request_extends(HTTPRequest, _super);
                function HTTPRequest(hooks, method, url) {
                    var _this = _super.call(this) || this;
                    _this.hooks = hooks;
                    _this.method = method;
                    _this.url = url;
                    return _this;
                }
                HTTPRequest.prototype.start = function(payload) {
                    var _this = this;
                    this.position = 0;
                    this.xhr = this.hooks.getRequest(this);
                    this.unloader = function() {
                        _this.close();
                    };
                    runtime.addUnloadListener(this.unloader);
                    this.xhr.open(this.method, this.url, true);
                    if (this.xhr.setRequestHeader) this.xhr.setRequestHeader('Content-Type', 'application/json');
                    this.xhr.send(payload);
                };
                HTTPRequest.prototype.close = function() {
                    if (this.unloader) {
                        runtime.removeUnloadListener(this.unloader);
                        this.unloader = null;
                    }
                    if (this.xhr) {
                        this.hooks.abortRequest(this.xhr);
                        this.xhr = null;
                    }
                };
                HTTPRequest.prototype.onChunk = function(status, data) {
                    while(true){
                        var chunk = this.advanceBuffer(data);
                        if (chunk) this.emit('chunk', {
                            status: status,
                            data: chunk
                        });
                        else break;
                    }
                    if (this.isBufferTooLong(data)) this.emit('buffer_too_long');
                };
                HTTPRequest.prototype.advanceBuffer = function(buffer) {
                    var unreadData = buffer.slice(this.position);
                    var endOfLinePosition = unreadData.indexOf('\n');
                    if (endOfLinePosition !== -1) {
                        this.position += endOfLinePosition + 1;
                        return unreadData.slice(0, endOfLinePosition);
                    } else return null;
                };
                HTTPRequest.prototype.isBufferTooLong = function(buffer) {
                    return this.position === buffer.length && buffer.length > MAX_BUFFER_LENGTH;
                };
                return HTTPRequest;
            }(dispatcher);
            /* harmony default export */ var http_request = http_request_HTTPRequest;
            // CONCATENATED MODULE: ./src/core/http/state.ts
            var State;
            (function(State) {
                State[State["CONNECTING"] = 0] = "CONNECTING";
                State[State["OPEN"] = 1] = "OPEN";
                State[State["CLOSED"] = 3] = "CLOSED";
            })(State || (State = {}));
            /* harmony default export */ var state = State;
            // CONCATENATED MODULE: ./src/core/http/http_socket.ts
            var autoIncrement = 1;
            var http_socket_HTTPSocket = function() {
                function HTTPSocket(hooks, url) {
                    this.hooks = hooks;
                    this.session = randomNumber(1000) + '/' + randomString(8);
                    this.location = getLocation(url);
                    this.readyState = state.CONNECTING;
                    this.openStream();
                }
                HTTPSocket.prototype.send = function(payload) {
                    return this.sendRaw(JSON.stringify([
                        payload
                    ]));
                };
                HTTPSocket.prototype.ping = function() {
                    this.hooks.sendHeartbeat(this);
                };
                HTTPSocket.prototype.close = function(code, reason) {
                    this.onClose(code, reason, true);
                };
                HTTPSocket.prototype.sendRaw = function(payload) {
                    if (this.readyState === state.OPEN) try {
                        runtime.createSocketRequest('POST', getUniqueURL(getSendURL(this.location, this.session))).start(payload);
                        return true;
                    } catch (e) {
                        return false;
                    }
                    else return false;
                };
                HTTPSocket.prototype.reconnect = function() {
                    this.closeStream();
                    this.openStream();
                };
                HTTPSocket.prototype.onClose = function(code, reason, wasClean) {
                    this.closeStream();
                    this.readyState = state.CLOSED;
                    if (this.onclose) this.onclose({
                        code: code,
                        reason: reason,
                        wasClean: wasClean
                    });
                };
                HTTPSocket.prototype.onChunk = function(chunk) {
                    if (chunk.status !== 200) return;
                    if (this.readyState === state.OPEN) this.onActivity();
                    var payload;
                    var type = chunk.data.slice(0, 1);
                    switch(type){
                        case 'o':
                            payload = JSON.parse(chunk.data.slice(1) || '{}');
                            this.onOpen(payload);
                            break;
                        case 'a':
                            payload = JSON.parse(chunk.data.slice(1) || '[]');
                            for(var i = 0; i < payload.length; i++)this.onEvent(payload[i]);
                            break;
                        case 'm':
                            payload = JSON.parse(chunk.data.slice(1) || 'null');
                            this.onEvent(payload);
                            break;
                        case 'h':
                            this.hooks.onHeartbeat(this);
                            break;
                        case 'c':
                            payload = JSON.parse(chunk.data.slice(1) || '[]');
                            this.onClose(payload[0], payload[1], true);
                            break;
                    }
                };
                HTTPSocket.prototype.onOpen = function(options) {
                    if (this.readyState === state.CONNECTING) {
                        if (options && options.hostname) this.location.base = replaceHost(this.location.base, options.hostname);
                        this.readyState = state.OPEN;
                        if (this.onopen) this.onopen();
                    } else this.onClose(1006, 'Server lost session', true);
                };
                HTTPSocket.prototype.onEvent = function(event) {
                    if (this.readyState === state.OPEN && this.onmessage) this.onmessage({
                        data: event
                    });
                };
                HTTPSocket.prototype.onActivity = function() {
                    if (this.onactivity) this.onactivity();
                };
                HTTPSocket.prototype.onError = function(error) {
                    if (this.onerror) this.onerror(error);
                };
                HTTPSocket.prototype.openStream = function() {
                    var _this = this;
                    this.stream = runtime.createSocketRequest('POST', getUniqueURL(this.hooks.getReceiveURL(this.location, this.session)));
                    this.stream.bind('chunk', function(chunk) {
                        _this.onChunk(chunk);
                    });
                    this.stream.bind('finished', function(status) {
                        _this.hooks.onFinished(_this, status);
                    });
                    this.stream.bind('buffer_too_long', function() {
                        _this.reconnect();
                    });
                    try {
                        this.stream.start();
                    } catch (error) {
                        util.defer(function() {
                            _this.onError(error);
                            _this.onClose(1006, 'Could not start streaming', false);
                        });
                    }
                };
                HTTPSocket.prototype.closeStream = function() {
                    if (this.stream) {
                        this.stream.unbind_all();
                        this.stream.close();
                        this.stream = null;
                    }
                };
                return HTTPSocket;
            }();
            function getLocation(url) {
                var parts = /([^\?]*)\/*(\??.*)/.exec(url);
                return {
                    base: parts[1],
                    queryString: parts[2]
                };
            }
            function getSendURL(url, session) {
                return url.base + '/' + session + '/xhr_send';
            }
            function getUniqueURL(url) {
                var separator = url.indexOf('?') === -1 ? '?' : '&';
                return url + separator + 't=' + +new Date() + '&n=' + autoIncrement++;
            }
            function replaceHost(url, hostname) {
                var urlParts = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(url);
                return urlParts[1] + hostname + urlParts[3];
            }
            function randomNumber(max) {
                return runtime.randomInt(max);
            }
            function randomString(length) {
                var result = [];
                for(var i = 0; i < length; i++)result.push(randomNumber(32).toString(32));
                return result.join('');
            }
            /* harmony default export */ var http_socket = http_socket_HTTPSocket;
            // CONCATENATED MODULE: ./src/core/http/http_streaming_socket.ts
            var http_streaming_socket_hooks = {
                getReceiveURL: function(url, session) {
                    return url.base + '/' + session + '/xhr_streaming' + url.queryString;
                },
                onHeartbeat: function(socket) {
                    socket.sendRaw('[]');
                },
                sendHeartbeat: function(socket) {
                    socket.sendRaw('[]');
                },
                onFinished: function(socket, status) {
                    socket.onClose(1006, 'Connection interrupted (' + status + ')', false);
                }
            };
            /* harmony default export */ var http_streaming_socket = http_streaming_socket_hooks;
            // CONCATENATED MODULE: ./src/core/http/http_polling_socket.ts
            var http_polling_socket_hooks = {
                getReceiveURL: function(url, session) {
                    return url.base + '/' + session + '/xhr' + url.queryString;
                },
                onHeartbeat: function() {},
                sendHeartbeat: function(socket) {
                    socket.sendRaw('[]');
                },
                onFinished: function(socket, status) {
                    if (status === 200) socket.reconnect();
                    else socket.onClose(1006, 'Connection interrupted (' + status + ')', false);
                }
            };
            /* harmony default export */ var http_polling_socket = http_polling_socket_hooks;
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/http/http_xhr_request.ts
            var http_xhr_request_hooks = {
                getRequest: function(socket) {
                    var Constructor = runtime.getXHRAPI();
                    var xhr = new Constructor();
                    xhr.onreadystatechange = xhr.onprogress = function() {
                        switch(xhr.readyState){
                            case 3:
                                if (xhr.responseText && xhr.responseText.length > 0) socket.onChunk(xhr.status, xhr.responseText);
                                break;
                            case 4:
                                if (xhr.responseText && xhr.responseText.length > 0) socket.onChunk(xhr.status, xhr.responseText);
                                socket.emit('finished', xhr.status);
                                socket.close();
                                break;
                        }
                    };
                    return xhr;
                },
                abortRequest: function(xhr) {
                    xhr.onreadystatechange = null;
                    xhr.abort();
                }
            };
            /* harmony default export */ var http_xhr_request = http_xhr_request_hooks;
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/http/http.ts
            var HTTP = {
                createStreamingSocket: function(url) {
                    return this.createSocket(http_streaming_socket, url);
                },
                createPollingSocket: function(url) {
                    return this.createSocket(http_polling_socket, url);
                },
                createSocket: function(hooks, url) {
                    return new http_socket(hooks, url);
                },
                createXHR: function(method, url) {
                    return this.createRequest(http_xhr_request, method, url);
                },
                createRequest: function(hooks, method, url) {
                    return new http_request(hooks, method, url);
                }
            };
            /* harmony default export */ var http_http = HTTP;
            // CONCATENATED MODULE: ./src/runtimes/web/http/http.ts
            http_http.createXDR = function(method, url) {
                return this.createRequest(http_xdomain_request, method, url);
            };
            /* harmony default export */ var web_http_http = http_http;
            // CONCATENATED MODULE: ./src/runtimes/web/runtime.ts
            var Runtime = {
                nextAuthCallbackID: 1,
                auth_callbacks: {},
                ScriptReceivers: ScriptReceivers,
                DependenciesReceivers: DependenciesReceivers,
                getDefaultStrategy: default_strategy,
                Transports: transports_transports,
                transportConnectionInitializer: transport_connection_initializer,
                HTTPFactory: web_http_http,
                TimelineTransport: jsonp_timeline,
                getXHRAPI: function() {
                    return window.XMLHttpRequest;
                },
                getWebSocketAPI: function() {
                    return window.WebSocket || window.MozWebSocket;
                },
                setup: function(PusherClass) {
                    var _this = this;
                    window.Pusher = PusherClass;
                    var initializeOnDocumentBody = function() {
                        _this.onDocumentBody(PusherClass.ready);
                    };
                    if (!window.JSON) Dependencies.load('json2', {}, initializeOnDocumentBody);
                    else initializeOnDocumentBody();
                },
                getDocument: function() {
                    return document;
                },
                getProtocol: function() {
                    return this.getDocument().location.protocol;
                },
                getAuthorizers: function() {
                    return {
                        ajax: xhr_auth,
                        jsonp: jsonp_auth
                    };
                },
                onDocumentBody: function(callback) {
                    var _this = this;
                    if (document.body) callback();
                    else setTimeout(function() {
                        _this.onDocumentBody(callback);
                    }, 0);
                },
                createJSONPRequest: function(url, data) {
                    return new jsonp_request(url, data);
                },
                createScriptRequest: function(src) {
                    return new script_request(src);
                },
                getLocalStorage: function() {
                    try {
                        return window.localStorage;
                    } catch (e) {
                        return undefined;
                    }
                },
                createXHR: function() {
                    if (this.getXHRAPI()) return this.createXMLHttpRequest();
                    else return this.createMicrosoftXHR();
                },
                createXMLHttpRequest: function() {
                    var Constructor = this.getXHRAPI();
                    return new Constructor();
                },
                createMicrosoftXHR: function() {
                    return new ActiveXObject('Microsoft.XMLHTTP');
                },
                getNetwork: function() {
                    return net_info_Network;
                },
                createWebSocket: function(url) {
                    var Constructor = this.getWebSocketAPI();
                    return new Constructor(url);
                },
                createSocketRequest: function(method, url) {
                    if (this.isXHRSupported()) return this.HTTPFactory.createXHR(method, url);
                    else if (this.isXDRSupported(url.indexOf('https:') === 0)) return this.HTTPFactory.createXDR(method, url);
                    else throw 'Cross-origin HTTP requests are not supported';
                },
                isXHRSupported: function() {
                    var Constructor = this.getXHRAPI();
                    return Boolean(Constructor) && new Constructor().withCredentials !== undefined;
                },
                isXDRSupported: function(useTLS) {
                    var protocol = useTLS ? 'https:' : 'http:';
                    var documentProtocol = this.getProtocol();
                    return Boolean(window['XDomainRequest']) && documentProtocol === protocol;
                },
                addUnloadListener: function(listener) {
                    if (window.addEventListener !== undefined) window.addEventListener('unload', listener, false);
                    else if (window.attachEvent !== undefined) window.attachEvent('onunload', listener);
                },
                removeUnloadListener: function(listener) {
                    if (window.addEventListener !== undefined) window.removeEventListener('unload', listener, false);
                    else if (window.detachEvent !== undefined) window.detachEvent('onunload', listener);
                },
                randomInt: function(max) {
                    var random = function() {
                        var crypto = window.crypto || window['msCrypto'];
                        var random = crypto.getRandomValues(new Uint32Array(1))[0];
                        return random / Math.pow(2, 32);
                    };
                    return Math.floor(random() * max);
                }
            };
            /* harmony default export */ var runtime = Runtime;
            // CONCATENATED MODULE: ./src/core/timeline/level.ts
            var TimelineLevel;
            (function(TimelineLevel) {
                TimelineLevel[TimelineLevel["ERROR"] = 3] = "ERROR";
                TimelineLevel[TimelineLevel["INFO"] = 6] = "INFO";
                TimelineLevel[TimelineLevel["DEBUG"] = 7] = "DEBUG";
            })(TimelineLevel || (TimelineLevel = {}));
            /* harmony default export */ var timeline_level = TimelineLevel;
            // CONCATENATED MODULE: ./src/core/timeline/timeline.ts
            var timeline_Timeline = function() {
                function Timeline(key, session, options) {
                    this.key = key;
                    this.session = session;
                    this.events = [];
                    this.options = options || {};
                    this.sent = 0;
                    this.uniqueID = 0;
                }
                Timeline.prototype.log = function(level, event) {
                    if (level <= this.options.level) {
                        this.events.push(extend({}, event, {
                            timestamp: util.now()
                        }));
                        if (this.options.limit && this.events.length > this.options.limit) this.events.shift();
                    }
                };
                Timeline.prototype.error = function(event) {
                    this.log(timeline_level.ERROR, event);
                };
                Timeline.prototype.info = function(event) {
                    this.log(timeline_level.INFO, event);
                };
                Timeline.prototype.debug = function(event) {
                    this.log(timeline_level.DEBUG, event);
                };
                Timeline.prototype.isEmpty = function() {
                    return this.events.length === 0;
                };
                Timeline.prototype.send = function(sendfn, callback) {
                    var _this = this;
                    var data = extend({
                        session: this.session,
                        bundle: this.sent + 1,
                        key: this.key,
                        lib: 'js',
                        version: this.options.version,
                        cluster: this.options.cluster,
                        features: this.options.features,
                        timeline: this.events
                    }, this.options.params);
                    this.events = [];
                    sendfn(data, function(error, result) {
                        if (!error) _this.sent++;
                        if (callback) callback(error, result);
                    });
                    return true;
                };
                Timeline.prototype.generateUniqueID = function() {
                    this.uniqueID++;
                    return this.uniqueID;
                };
                return Timeline;
            }();
            /* harmony default export */ var timeline_timeline = timeline_Timeline;
            // CONCATENATED MODULE: ./src/core/strategies/transport_strategy.ts
            var transport_strategy_TransportStrategy = function() {
                function TransportStrategy(name, priority, transport, options) {
                    this.name = name;
                    this.priority = priority;
                    this.transport = transport;
                    this.options = options || {};
                }
                TransportStrategy.prototype.isSupported = function() {
                    return this.transport.isSupported({
                        useTLS: this.options.useTLS
                    });
                };
                TransportStrategy.prototype.connect = function(minPriority, callback) {
                    var _this = this;
                    if (!this.isSupported()) return failAttempt(new UnsupportedStrategy(), callback);
                    else if (this.priority < minPriority) return failAttempt(new TransportPriorityTooLow(), callback);
                    var connected = false;
                    var transport = this.transport.createConnection(this.name, this.priority, this.options.key, this.options);
                    var handshake = null;
                    var onInitialized = function() {
                        transport.unbind('initialized', onInitialized);
                        transport.connect();
                    };
                    var onOpen = function() {
                        handshake = factory.createHandshake(transport, function(result) {
                            connected = true;
                            unbindListeners();
                            callback(null, result);
                        });
                    };
                    var onError = function(error) {
                        unbindListeners();
                        callback(error);
                    };
                    var onClosed = function() {
                        unbindListeners();
                        var serializedTransport;
                        serializedTransport = safeJSONStringify(transport);
                        callback(new TransportClosed(serializedTransport));
                    };
                    var unbindListeners = function() {
                        transport.unbind('initialized', onInitialized);
                        transport.unbind('open', onOpen);
                        transport.unbind('error', onError);
                        transport.unbind('closed', onClosed);
                    };
                    transport.bind('initialized', onInitialized);
                    transport.bind('open', onOpen);
                    transport.bind('error', onError);
                    transport.bind('closed', onClosed);
                    transport.initialize();
                    return {
                        abort: function() {
                            if (connected) return;
                            unbindListeners();
                            if (handshake) handshake.close();
                            else transport.close();
                        },
                        forceMinPriority: function(p) {
                            if (connected) return;
                            if (_this.priority < p) {
                                if (handshake) handshake.close();
                                else transport.close();
                            }
                        }
                    };
                };
                return TransportStrategy;
            }();
            /* harmony default export */ var transport_strategy = transport_strategy_TransportStrategy;
            function failAttempt(error, callback) {
                util.defer(function() {
                    callback(error);
                });
                return {
                    abort: function() {},
                    forceMinPriority: function() {}
                };
            }
            // CONCATENATED MODULE: ./src/core/strategies/strategy_builder.ts
            var strategy_builder_Transports = runtime.Transports;
            var strategy_builder_defineTransport = function(config, name, type, priority, options, manager) {
                var transportClass = strategy_builder_Transports[type];
                if (!transportClass) throw new UnsupportedTransport(type);
                var enabled = (!config.enabledTransports || arrayIndexOf(config.enabledTransports, name) !== -1) && (!config.disabledTransports || arrayIndexOf(config.disabledTransports, name) === -1);
                var transport;
                if (enabled) {
                    options = Object.assign({
                        ignoreNullOrigin: config.ignoreNullOrigin
                    }, options);
                    transport = new transport_strategy(name, priority, manager ? manager.getAssistant(transportClass) : transportClass, options);
                } else transport = strategy_builder_UnsupportedStrategy;
                return transport;
            };
            var strategy_builder_UnsupportedStrategy = {
                isSupported: function() {
                    return false;
                },
                connect: function(_, callback) {
                    var deferred = util.defer(function() {
                        callback(new UnsupportedStrategy());
                    });
                    return {
                        abort: function() {
                            deferred.ensureAborted();
                        },
                        forceMinPriority: function() {}
                    };
                }
            };
            // CONCATENATED MODULE: ./src/core/auth/user_authenticator.ts
            var composeChannelQuery = function(params, authOptions) {
                var query = 'socket_id=' + encodeURIComponent(params.socketId);
                for(var i in authOptions.params)query += '&' + encodeURIComponent(i) + '=' + encodeURIComponent(authOptions.params[i]);
                return query;
            };
            var UserAuthenticator = function(authOptions) {
                if (typeof runtime.getAuthorizers()[authOptions.transport] === 'undefined') throw "'" + authOptions.transport + "' is not a recognized auth transport";
                return function(params, callback) {
                    var query = composeChannelQuery(params, authOptions);
                    runtime.getAuthorizers()[authOptions.transport](runtime, query, authOptions, AuthRequestType.UserAuthentication, callback);
                };
            };
            /* harmony default export */ var user_authenticator = UserAuthenticator;
            // CONCATENATED MODULE: ./src/core/auth/channel_authorizer.ts
            var channel_authorizer_composeChannelQuery = function(params, authOptions) {
                var query = 'socket_id=' + encodeURIComponent(params.socketId);
                query += '&channel_name=' + encodeURIComponent(params.channelName);
                for(var i in authOptions.params)query += '&' + encodeURIComponent(i) + '=' + encodeURIComponent(authOptions.params[i]);
                return query;
            };
            var ChannelAuthorizer = function(authOptions) {
                if (typeof runtime.getAuthorizers()[authOptions.transport] === 'undefined') throw "'" + authOptions.transport + "' is not a recognized auth transport";
                return function(params, callback) {
                    var query = channel_authorizer_composeChannelQuery(params, authOptions);
                    runtime.getAuthorizers()[authOptions.transport](runtime, query, authOptions, AuthRequestType.ChannelAuthorization, callback);
                };
            };
            /* harmony default export */ var channel_authorizer = ChannelAuthorizer;
            // CONCATENATED MODULE: ./src/core/auth/deprecated_channel_authorizer.ts
            var ChannelAuthorizerProxy = function(pusher, authOptions, channelAuthorizerGenerator) {
                var deprecatedAuthorizerOptions = {
                    authTransport: authOptions.transport,
                    authEndpoint: authOptions.endpoint,
                    auth: {
                        params: authOptions.params,
                        headers: authOptions.headers
                    }
                };
                return function(params, callback) {
                    var channel = pusher.channel(params.channelName);
                    var channelAuthorizer = channelAuthorizerGenerator(channel, deprecatedAuthorizerOptions);
                    channelAuthorizer.authorize(params.socketId, callback);
                };
            };
            // CONCATENATED MODULE: ./src/core/config.ts
            var __assign = function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            function getConfig(opts, pusher) {
                var config = {
                    activityTimeout: opts.activityTimeout || defaults.activityTimeout,
                    cluster: opts.cluster || defaults.cluster,
                    httpPath: opts.httpPath || defaults.httpPath,
                    httpPort: opts.httpPort || defaults.httpPort,
                    httpsPort: opts.httpsPort || defaults.httpsPort,
                    pongTimeout: opts.pongTimeout || defaults.pongTimeout,
                    statsHost: opts.statsHost || defaults.stats_host,
                    unavailableTimeout: opts.unavailableTimeout || defaults.unavailableTimeout,
                    wsPath: opts.wsPath || defaults.wsPath,
                    wsPort: opts.wsPort || defaults.wsPort,
                    wssPort: opts.wssPort || defaults.wssPort,
                    enableStats: getEnableStatsConfig(opts),
                    httpHost: getHttpHost(opts),
                    useTLS: shouldUseTLS(opts),
                    wsHost: getWebsocketHost(opts),
                    userAuthenticator: buildUserAuthenticator(opts),
                    channelAuthorizer: buildChannelAuthorizer(opts, pusher)
                };
                if ('disabledTransports' in opts) config.disabledTransports = opts.disabledTransports;
                if ('enabledTransports' in opts) config.enabledTransports = opts.enabledTransports;
                if ('ignoreNullOrigin' in opts) config.ignoreNullOrigin = opts.ignoreNullOrigin;
                if ('timelineParams' in opts) config.timelineParams = opts.timelineParams;
                if ('nacl' in opts) config.nacl = opts.nacl;
                return config;
            }
            function getHttpHost(opts) {
                if (opts.httpHost) return opts.httpHost;
                if (opts.cluster) return "sockjs-" + opts.cluster + ".pusher.com";
                return defaults.httpHost;
            }
            function getWebsocketHost(opts) {
                if (opts.wsHost) return opts.wsHost;
                if (opts.cluster) return getWebsocketHostFromCluster(opts.cluster);
                return getWebsocketHostFromCluster(defaults.cluster);
            }
            function getWebsocketHostFromCluster(cluster) {
                return "ws-" + cluster + ".pusher.com";
            }
            function shouldUseTLS(opts) {
                if (runtime.getProtocol() === 'https:') return true;
                else if (opts.forceTLS === false) return false;
                return true;
            }
            function getEnableStatsConfig(opts) {
                if ('enableStats' in opts) return opts.enableStats;
                if ('disableStats' in opts) return !opts.disableStats;
                return false;
            }
            function buildUserAuthenticator(opts) {
                var userAuthentication = __assign(__assign({}, defaults.userAuthentication), opts.userAuthentication);
                if ('customHandler' in userAuthentication && userAuthentication['customHandler'] != null) return userAuthentication['customHandler'];
                return user_authenticator(userAuthentication);
            }
            function buildChannelAuth(opts, pusher) {
                var channelAuthorization;
                if ('channelAuthorization' in opts) channelAuthorization = __assign(__assign({}, defaults.channelAuthorization), opts.channelAuthorization);
                else {
                    channelAuthorization = {
                        transport: opts.authTransport || defaults.authTransport,
                        endpoint: opts.authEndpoint || defaults.authEndpoint
                    };
                    if ('auth' in opts) {
                        if ('params' in opts.auth) channelAuthorization.params = opts.auth.params;
                        if ('headers' in opts.auth) channelAuthorization.headers = opts.auth.headers;
                    }
                    if ('authorizer' in opts) channelAuthorization.customHandler = ChannelAuthorizerProxy(pusher, channelAuthorization, opts.authorizer);
                }
                return channelAuthorization;
            }
            function buildChannelAuthorizer(opts, pusher) {
                var channelAuthorization = buildChannelAuth(opts, pusher);
                if ('customHandler' in channelAuthorization && channelAuthorization['customHandler'] != null) return channelAuthorization['customHandler'];
                return channel_authorizer(channelAuthorization);
            }
            // CONCATENATED MODULE: ./src/core/watchlist.ts
            var watchlist_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var watchlist_WatchlistFacade = function(_super) {
                watchlist_extends(WatchlistFacade, _super);
                function WatchlistFacade(pusher) {
                    var _this = _super.call(this, function(eventName, data) {
                        logger.debug("No callbacks on watchlist events for " + eventName);
                    }) || this;
                    _this.pusher = pusher;
                    _this.bindWatchlistInternalEvent();
                    return _this;
                }
                WatchlistFacade.prototype.handleEvent = function(pusherEvent) {
                    var _this = this;
                    pusherEvent.data.events.forEach(function(watchlistEvent) {
                        _this.emit(watchlistEvent.name, watchlistEvent);
                    });
                };
                WatchlistFacade.prototype.bindWatchlistInternalEvent = function() {
                    var _this = this;
                    this.pusher.connection.bind('message', function(pusherEvent) {
                        var eventName = pusherEvent.event;
                        if (eventName === 'pusher_internal:watchlist_events') _this.handleEvent(pusherEvent);
                    });
                };
                return WatchlistFacade;
            }(dispatcher);
            /* harmony default export */ var watchlist = watchlist_WatchlistFacade;
            // CONCATENATED MODULE: ./src/core/utils/flat_promise.ts
            function flatPromise() {
                var resolve, reject;
                var promise = new Promise(function(res, rej) {
                    resolve = res;
                    reject = rej;
                });
                return {
                    promise: promise,
                    resolve: resolve,
                    reject: reject
                };
            }
            /* harmony default export */ var flat_promise = flatPromise;
            // CONCATENATED MODULE: ./src/core/user.ts
            var user_extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var user_UserFacade = function(_super) {
                user_extends(UserFacade, _super);
                function UserFacade(pusher) {
                    var _this = _super.call(this, function(eventName, data) {
                        logger.debug('No callbacks on user for ' + eventName);
                    }) || this;
                    _this.signin_requested = false;
                    _this.user_data = null;
                    _this.serverToUserChannel = null;
                    _this.signinDonePromise = null;
                    _this._signinDoneResolve = null;
                    _this._onAuthorize = function(err, authData) {
                        if (err) {
                            logger.warn("Error during signin: " + err);
                            _this._cleanup();
                            return;
                        }
                        _this.pusher.send_event('pusher:signin', {
                            auth: authData.auth,
                            user_data: authData.user_data
                        });
                    };
                    _this.pusher = pusher;
                    _this.pusher.connection.bind('state_change', function(_a) {
                        var previous = _a.previous, current = _a.current;
                        if (previous !== 'connected' && current === 'connected') _this._signin();
                        if (previous === 'connected' && current !== 'connected') {
                            _this._cleanup();
                            _this._newSigninPromiseIfNeeded();
                        }
                    });
                    _this.watchlist = new watchlist(pusher);
                    _this.pusher.connection.bind('message', function(event) {
                        var eventName = event.event;
                        if (eventName === 'pusher:signin_success') _this._onSigninSuccess(event.data);
                        if (_this.serverToUserChannel && _this.serverToUserChannel.name === event.channel) _this.serverToUserChannel.handleEvent(event);
                    });
                    return _this;
                }
                UserFacade.prototype.signin = function() {
                    if (this.signin_requested) return;
                    this.signin_requested = true;
                    this._signin();
                };
                UserFacade.prototype._signin = function() {
                    if (!this.signin_requested) return;
                    this._newSigninPromiseIfNeeded();
                    if (this.pusher.connection.state !== 'connected') return;
                    this.pusher.config.userAuthenticator({
                        socketId: this.pusher.connection.socket_id
                    }, this._onAuthorize);
                };
                UserFacade.prototype._onSigninSuccess = function(data) {
                    try {
                        this.user_data = JSON.parse(data.user_data);
                    } catch (e) {
                        logger.error("Failed parsing user data after signin: " + data.user_data);
                        this._cleanup();
                        return;
                    }
                    if (typeof this.user_data.id !== 'string' || this.user_data.id === '') {
                        logger.error("user_data doesn't contain an id. user_data: " + this.user_data);
                        this._cleanup();
                        return;
                    }
                    this._signinDoneResolve();
                    this._subscribeChannels();
                };
                UserFacade.prototype._subscribeChannels = function() {
                    var _this = this;
                    var ensure_subscribed = function(channel) {
                        if (channel.subscriptionPending && channel.subscriptionCancelled) channel.reinstateSubscription();
                        else if (!channel.subscriptionPending && _this.pusher.connection.state === 'connected') channel.subscribe();
                    };
                    this.serverToUserChannel = new channels_channel("#server-to-user-" + this.user_data.id, this.pusher);
                    this.serverToUserChannel.bind_global(function(eventName, data) {
                        if (eventName.indexOf('pusher_internal:') === 0 || eventName.indexOf('pusher:') === 0) return;
                        _this.emit(eventName, data);
                    });
                    ensure_subscribed(this.serverToUserChannel);
                };
                UserFacade.prototype._cleanup = function() {
                    this.user_data = null;
                    if (this.serverToUserChannel) {
                        this.serverToUserChannel.unbind_all();
                        this.serverToUserChannel.disconnect();
                        this.serverToUserChannel = null;
                    }
                    if (this.signin_requested) this._signinDoneResolve();
                };
                UserFacade.prototype._newSigninPromiseIfNeeded = function() {
                    if (!this.signin_requested) return;
                    if (this.signinDonePromise && !this.signinDonePromise.done) return;
                    var _a = flat_promise(), promise = _a.promise, resolve = _a.resolve, _ = _a.reject;
                    promise.done = false;
                    var setDone = function() {
                        promise.done = true;
                    };
                    promise.then(setDone)["catch"](setDone);
                    this.signinDonePromise = promise;
                    this._signinDoneResolve = resolve;
                };
                return UserFacade;
            }(dispatcher);
            /* harmony default export */ var user = user_UserFacade;
            // CONCATENATED MODULE: ./src/core/pusher.ts
            var pusher_Pusher = function() {
                function Pusher(app_key, options) {
                    var _this = this;
                    checkAppKey(app_key);
                    options = options || {};
                    if (!options.cluster && !(options.wsHost || options.httpHost)) {
                        var suffix = url_store.buildLogSuffix('javascriptQuickStart');
                        logger.warn("You should always specify a cluster when connecting. " + suffix);
                    }
                    if ('disableStats' in options) logger.warn('The disableStats option is deprecated in favor of enableStats');
                    this.key = app_key;
                    this.config = getConfig(options, this);
                    this.channels = factory.createChannels();
                    this.global_emitter = new dispatcher();
                    this.sessionID = runtime.randomInt(1000000000);
                    this.timeline = new timeline_timeline(this.key, this.sessionID, {
                        cluster: this.config.cluster,
                        features: Pusher.getClientFeatures(),
                        params: this.config.timelineParams || {},
                        limit: 50,
                        level: timeline_level.INFO,
                        version: defaults.VERSION
                    });
                    if (this.config.enableStats) this.timelineSender = factory.createTimelineSender(this.timeline, {
                        host: this.config.statsHost,
                        path: '/timeline/v2/' + runtime.TimelineTransport.name
                    });
                    var getStrategy = function(options) {
                        return runtime.getDefaultStrategy(_this.config, options, strategy_builder_defineTransport);
                    };
                    this.connection = factory.createConnectionManager(this.key, {
                        getStrategy: getStrategy,
                        timeline: this.timeline,
                        activityTimeout: this.config.activityTimeout,
                        pongTimeout: this.config.pongTimeout,
                        unavailableTimeout: this.config.unavailableTimeout,
                        useTLS: Boolean(this.config.useTLS)
                    });
                    this.connection.bind('connected', function() {
                        _this.subscribeAll();
                        if (_this.timelineSender) _this.timelineSender.send(_this.connection.isUsingTLS());
                    });
                    this.connection.bind('message', function(event) {
                        var eventName = event.event;
                        var internal = eventName.indexOf('pusher_internal:') === 0;
                        if (event.channel) {
                            var channel = _this.channel(event.channel);
                            if (channel) channel.handleEvent(event);
                        }
                        if (!internal) _this.global_emitter.emit(event.event, event.data);
                    });
                    this.connection.bind('connecting', function() {
                        _this.channels.disconnect();
                    });
                    this.connection.bind('disconnected', function() {
                        _this.channels.disconnect();
                    });
                    this.connection.bind('error', function(err) {
                        logger.warn(err);
                    });
                    Pusher.instances.push(this);
                    this.timeline.info({
                        instances: Pusher.instances.length
                    });
                    this.user = new user(this);
                    if (Pusher.isReady) this.connect();
                }
                Pusher.ready = function() {
                    Pusher.isReady = true;
                    for(var i = 0, l = Pusher.instances.length; i < l; i++)Pusher.instances[i].connect();
                };
                Pusher.getClientFeatures = function() {
                    return keys(filterObject({
                        ws: runtime.Transports.ws
                    }, function(t) {
                        return t.isSupported({});
                    }));
                };
                Pusher.prototype.channel = function(name) {
                    return this.channels.find(name);
                };
                Pusher.prototype.allChannels = function() {
                    return this.channels.all();
                };
                Pusher.prototype.connect = function() {
                    this.connection.connect();
                    if (this.timelineSender) {
                        if (!this.timelineSenderTimer) {
                            var usingTLS = this.connection.isUsingTLS();
                            var timelineSender = this.timelineSender;
                            this.timelineSenderTimer = new PeriodicTimer(60000, function() {
                                timelineSender.send(usingTLS);
                            });
                        }
                    }
                };
                Pusher.prototype.disconnect = function() {
                    this.connection.disconnect();
                    if (this.timelineSenderTimer) {
                        this.timelineSenderTimer.ensureAborted();
                        this.timelineSenderTimer = null;
                    }
                };
                Pusher.prototype.bind = function(event_name, callback, context) {
                    this.global_emitter.bind(event_name, callback, context);
                    return this;
                };
                Pusher.prototype.unbind = function(event_name, callback, context) {
                    this.global_emitter.unbind(event_name, callback, context);
                    return this;
                };
                Pusher.prototype.bind_global = function(callback) {
                    this.global_emitter.bind_global(callback);
                    return this;
                };
                Pusher.prototype.unbind_global = function(callback) {
                    this.global_emitter.unbind_global(callback);
                    return this;
                };
                Pusher.prototype.unbind_all = function(callback) {
                    this.global_emitter.unbind_all();
                    return this;
                };
                Pusher.prototype.subscribeAll = function() {
                    var channelName;
                    for(channelName in this.channels.channels)if (this.channels.channels.hasOwnProperty(channelName)) this.subscribe(channelName);
                };
                Pusher.prototype.subscribe = function(channel_name) {
                    var channel = this.channels.add(channel_name, this);
                    if (channel.subscriptionPending && channel.subscriptionCancelled) channel.reinstateSubscription();
                    else if (!channel.subscriptionPending && this.connection.state === 'connected') channel.subscribe();
                    return channel;
                };
                Pusher.prototype.unsubscribe = function(channel_name) {
                    var channel = this.channels.find(channel_name);
                    if (channel && channel.subscriptionPending) channel.cancelSubscription();
                    else {
                        channel = this.channels.remove(channel_name);
                        if (channel && channel.subscribed) channel.unsubscribe();
                    }
                };
                Pusher.prototype.send_event = function(event_name, data, channel) {
                    return this.connection.send_event(event_name, data, channel);
                };
                Pusher.prototype.shouldUseTLS = function() {
                    return this.config.useTLS;
                };
                Pusher.prototype.signin = function() {
                    this.user.signin();
                };
                Pusher.instances = [];
                Pusher.isReady = false;
                Pusher.logToConsole = false;
                Pusher.Runtime = runtime;
                Pusher.ScriptReceivers = runtime.ScriptReceivers;
                Pusher.DependenciesReceivers = runtime.DependenciesReceivers;
                Pusher.auth_callbacks = runtime.auth_callbacks;
                return Pusher;
            }();
            /* harmony default export */ var core_pusher = __webpack_exports__["default"] = pusher_Pusher;
            function checkAppKey(key) {
                if (key === null || key === undefined) throw 'You must pass your app key when you instantiate Pusher.';
            }
            runtime.setup(pusher_Pusher);
        /***/ }
    ]);
});



class $8e6a5083674a4148$export$beef90f2411195d8 extends (0, (/*@__PURE__*/$parcel$interopDefault($167b795c990efc2d$exports))) {
    constructor(token){
        if (typeof $8e6a5083674a4148$export$beef90f2411195d8.instance === 'object') // eslint-disable-next-line no-constructor-return
        return $8e6a5083674a4148$export$beef90f2411195d8.instance;
        super((0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).pusherKey, {
            cluster: 'us2',
            channelAuthorization: {
                transport: 'ajax',
                endpoint: `${(0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).serverUrl}/pusher`,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        });
        $8e6a5083674a4148$export$beef90f2411195d8.instance = this;
        // eslint-disable-next-line no-constructor-return
        return this;
    }
}







var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $1cbcb18aa67bf12c$var$SvgTaxarooLogo = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        id: "taxaroo_logo_svg__Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: 0,
        y: 0,
        viewBox: "0 0 125 30",
        style: {
            enableBackground: "new 0 0 125 30"
        },
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("style", {
                children: ".taxaroo_logo_svg__st0{fill:#0057a5}.taxaroo_logo_svg__st1{fill:#009be0}"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "taxaroo_logo_svg__st0",
                d: "M15.6 20.4c.7 0 2.9-.6 2.9-3.1s-2.5-3.8-5-4c-1-.1-2.5.1-3.4.1-.8 0-2.4-.1-4.1-.9-.1.7-.2 1.4-.2 2.1 0 8.1 6.5 14.6 14.6 14.6 1.5 0 2.9-.2 4.2-.6l-9.9-8.3c0 .1.2.1.9.1z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "taxaroo_logo_svg__st1",
                d: "M35.1 14.6C35.1 6.5 28.5 0 20.4 0 14.1 0 8.6 4.1 6.6 9.8 3.3 9.7.1 6.6.1 6.6s2 3.1 6.2 4.1c.8.2 1.7.3 2.6.3 1 0 2.9-.3 4.7-1.2C15.4 9 17 8.7 18 8.7c2.9 0 4.9 1.1 6 1.9 1.1.8 2.4 2 4.5 2 2 0 2.4-.4 2.4-.4s-.3-.7-.8-.7-1.8-.4-1.8-1.8c0 0 1.4.1 2.5 1 1 .9 1.1 1.7 1.1 1.7s.6 0 1.2.5 1.5 1.4 1.2 1.6c-.2.2-1.3-.7-3.2-.7s-5.5 1.2-6.6 5.3c0 0 0-8.5-9-7.8 0 0 6.5-.3 6.5 5.1 0 4-3.5 5-4 5 0 0 3.2.5 5.8 3.4 1.2 1.3 1.8 2.5 2.2 3.4.4 1.1.4 1.8.4 1.8s.2-.9.2-2.1c4.9-2.3 8.5-7.3 8.5-13.3z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "taxaroo_logo_svg__st0",
                d: "M41.4 6.3V18c0 2.1 1.2 3.7 3.3 3.7s4.1-1.1 4.1-1.1L47.5 19s-.7.6-1.5.6-1.7-.4-1.7-2.7v-5.1h3.3V9.1h-3.2V6.3h-3z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "taxaroo_logo_svg__st0",
                d: "M54.6 11.4c2.1 0 3.8 1.7 3.8 3.8 0 2.1-1.7 3.8-3.8 3.8-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8m0-2.7c-3.6 0-6.6 2.9-6.6 6.6s2.9 6.6 6.6 6.6c3.6 0 6.6-2.9 6.6-6.6s-2.9-6.6-6.6-6.6z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "taxaroo_logo_svg__st1",
                d: "M82.5 10.3c2.7 0 4.9 2.2 4.9 4.9s-2.2 4.9-4.9 4.9-4.9-2.2-4.9-4.9c-.1-2.7 2.2-4.9 4.9-4.9m0-1.6c-3.6 0-6.6 2.9-6.6 6.6s2.9 6.6 6.6 6.6c3.6 0 6.6-2.9 6.6-6.6s-3-6.6-6.6-6.6z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "taxaroo_logo_svg__st0",
                d: "M58.5 8.7h2.7v13.1h-2.7z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "taxaroo_logo_svg__st1",
                d: "M87.4 8.7H89v13.1h-1.6z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "taxaroo_logo_svg__st0",
                d: "M62.4 8.7h3.7l10 13.1h-3.9z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "taxaroo_logo_svg__st1",
                d: "m72.6 8.7-2.5 3.2 1.9 2.5 4.4-5.7z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "taxaroo_logo_svg__st0",
                d: "m67.4 15.4-.4.5-.3.5-4.1 5.4h3.9l2.1-2.8.4-.5.4-.5 1.9-2.6-1.9-2.5z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "taxaroo_logo_svg__st1",
                d: "M103.8 10.3c2.7 0 4.9 2.2 4.9 4.9s-2.2 4.9-4.9 4.9-4.9-2.2-4.9-4.9 2.2-4.9 4.9-4.9m0-1.6c-3.6 0-6.6 2.9-6.6 6.6s2.9 6.6 6.6 6.6c3.6 0 6.6-2.9 6.6-6.6s-2.9-6.6-6.6-6.6zM118.3 10.3c2.7 0 4.9 2.2 4.9 4.9s-2.2 4.9-4.9 4.9-4.9-2.2-4.9-4.9 2.2-4.9 4.9-4.9m0-1.6c-3.6 0-6.6 2.9-6.6 6.6s2.9 6.6 6.6 6.6c3.6 0 6.6-2.9 6.6-6.6s-3-6.6-6.6-6.6zM91.4 21.8V8.7H93v2c.2-.6.6-1.1 1.2-1.5.6-.4 1.9-.5 2.6-.5h.7v1.6h-.7c-.9 0-2.3.4-3 1.1-.5.6-.8 1.4-.8 2.4v8h-1.6z"
            })
        ]
    });
var $1cbcb18aa67bf12c$export$2e2bcd8739ae039 = $1cbcb18aa67bf12c$var$SvgTaxarooLogo;





var $6fFrj = parcelRequire("6fFrj");





function $e23899b62b96dde3$export$609860bf8b0084c(mutation, options) {
    var client = (0, $35f6182eda3ba50d$export$eb9a56e7a29e494)(options === null || options === void 0 ? void 0 : options.client);
    (0, $316cfcdad6602aa8$export$6dfb8732f737404c)(mutation, (0, $316cfcdad6602aa8$export$d1d99cf900472499).Mutation);
    var _a = (0, $6fFrj.useState)({
        called: false,
        loading: false,
        client: client
    }), result = _a[0], setResult = _a[1];
    var ref = (0, $6fFrj.useRef)({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options
    });
    Object.assign(ref.current, {
        client: client,
        options: options,
        mutation: mutation
    });
    var execute = (0, $6fFrj.useCallback)(function(executeOptions) {
        if (executeOptions === void 0) executeOptions = {};
        var _a = ref.current, client = _a.client, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0, $7455305bac30ddd9$export$18ce0697a983be9b)((0, $7455305bac30ddd9$export$18ce0697a983be9b)({}, options), {
            mutation: mutation
        });
        if (!ref.current.result.loading && !baseOptions.ignoreResults && ref.current.isMounted) setResult(ref.current.result = {
            loading: true,
            error: void 0,
            data: void 0,
            called: true,
            client: client
        });
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0, $68f062d2048ef6b4$export$235b7fc70b9fc359)(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function(response) {
            var _a, _b, _c;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ? new (0, $94d00a3b1a6b6d00$export$26a337512320b8c6)({
                graphQLErrors: errors
            }) : void 0;
            if (mutationId === ref.current.mutationId && !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client
                };
                if (ref.current.isMounted && !(0, $9675d5b886252616$export$2e2bcd8739ae039)(ref.current.result, result_1)) setResult(ref.current.result = result_1);
            }
            (_b = (_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onCompleted) === null || _b === void 0 || _b.call(_a, response.data, clientOptions);
            (_c = executeOptions.onCompleted) === null || _c === void 0 || _c.call(executeOptions, response.data, clientOptions);
            return response;
        }).catch(function(error) {
            var _a, _b, _c, _d;
            if (mutationId === ref.current.mutationId && ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client
                };
                if (!(0, $9675d5b886252616$export$2e2bcd8739ae039)(ref.current.result, result_2)) setResult(ref.current.result = result_2);
            }
            if (((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError) || clientOptions.onError) {
                (_c = (_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onError) === null || _c === void 0 || _c.call(_b, error, clientOptions);
                (_d = executeOptions.onError) === null || _d === void 0 || _d.call(executeOptions, error, clientOptions);
                return {
                    data: void 0,
                    errors: error
                };
            }
            throw error;
        });
    }, []);
    var reset = (0, $6fFrj.useCallback)(function() {
        if (ref.current.isMounted) setResult({
            called: false,
            loading: false,
            client: client
        });
    }, []);
    (0, $6fFrj.useEffect)(function() {
        ref.current.isMounted = true;
        return function() {
            ref.current.isMounted = false;
        };
    }, []);
    return [
        execute,
        (0, $7455305bac30ddd9$export$18ce0697a983be9b)({
            reset: reset
        }, result)
    ];
}


const $edf372aa0dea9531$var$defaultOptions = {};
const $edf372aa0dea9531$export$d8cf341a374b2613 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment Answers on AnswerEntity {
  id
  description
  taxYearInterviewId
  questionId
  createAt
  updateAt
  completedAt
  requestAt
}
    `;
const $edf372aa0dea9531$export$659fb92f17a06d95 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment Tasks on TaskEntity {
  id
  taxYearId
  taskType
  completedAt
  deletedAt
  createAt
  updateAt
  FileRequests {
    id
    userId
    signedFileId
    compiledFileId
    title
    notes
    signatureRequest
    signatureComplete
    compiledHash
    clientId
    taxYearInterviewId
    taskId
    firmAccountId
    createAt
    updateAt
  }
  Payments {
    id
    entityId
    taskId
    taxYearInterviewId
    firmAccountId
    paymentProcessorId
    totalDollarAmount
    paymentProcessorFee
    referralFee
    preparerFee
    requestAt
    completedAt
    promisedAt
    discountApplied
    paidOffline
    deletedAt
    createAt
    updateAt
    Invoices {
      id
      description
      priceEach
      paymentId
      quantity
      createAt
      updateAt
    }
  }
}
    `;
const $edf372aa0dea9531$export$632cef82dcb2e525 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateClient($updateClientInput: UpdateClientInput!) {
  UpdateClient(updateClientInput: $updateClientInput) {
    success
  }
}
    `;
function $edf372aa0dea9531$export$4d2f387ef3a8c19f(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$632cef82dcb2e525, options);
}
const $edf372aa0dea9531$export$7951872326c674b3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation LoginAs($userId: String!, $token: String!) {
  LoginAs(userId: $userId, token: $token) {
    accessToken
    headToURL
    selectedFirmAccount
    RelatedFirms {
      userId
      entityId
      FirmAccount {
        id
        name
      }
      Users {
        UserInformation {
          firstName
          lastName
        }
      }
      Roles {
        id
        description
      }
    }
    UserFirmAccount {
      userId
      entityId
      FirmAccount {
        id
        name
      }
      Entity {
        Users {
          id
          email
          languageId
          UserInformation {
            id
            firstName
            lastName
            birthday
            profilePhoto
            ssn
          }
        }
      }
      Roles {
        id
        description
      }
    }
  }
}
    `;
function $edf372aa0dea9531$export$7fec4024e0a20599(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$7951872326c674b3, options);
}
const $edf372aa0dea9531$export$61b1959a8ddb1b12 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation ReturnToAccount {
  ReturnToAccount {
    accessToken
    headToURL
    selectedFirmAccount
    RelatedFirms {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
      }
      Users {
        UserInformation {
          firstName
          lastName
        }
      }
      Roles {
        id
        description
      }
    }
    UserFirmAccount {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
        businessType
        BusinessInformation {
          id
          Phones {
            id
            value
            createAt
            updateAt
            type
          }
          Address {
            id
            lineOne
            lineTwo
            city
            state
            type
            zip
            createAt
            updateAt
          }
        }
        Users {
          id
          email
          languageId
          UserInformation {
            id
            firstName
            lastName
            birthday
            profilePhoto
            ssn
            Phones {
              id
              value
              type
              createAt
              updateAt
            }
            Address {
              id
              lineOne
              lineTwo
              city
              state
              type
              zip
              createAt
              updateAt
            }
          }
        }
        ProgressStatuses {
          id
          firmAccountId
          status
          createAt
          updateAt
          underlyingStatus
          index
        }
      }
      Users {
        id
        email
        languageId
        UserInformation {
          id
          firstName
          lastName
          birthday
          profilePhoto
          ssn
        }
      }
      Roles {
        id
        description
      }
    }
  }
}
    `;
function $edf372aa0dea9531$export$5c66c0f66bf05ea5(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$61b1959a8ddb1b12, options);
}
const $edf372aa0dea9531$export$b0ef8ac33a0912ce = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation ResendActivation($userId: String!) {
  ResendActivation(userId: $userId) {
    success
  }
}
    `;
function $edf372aa0dea9531$export$e475b5f069030ded(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$b0ef8ac33a0912ce, options);
}
const $edf372aa0dea9531$export$18cb76dd1405ddc = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation AddTaxYearInterviewJob($addJobInput: AddJobInput!) {
  AddTaxYearInterviewJob(addJobInput: $addJobInput) {
    id
    taxYearId
    preparedId
    reviewedId
    interviewId
    progressStatusId
    notes
    reviewStatus
    createAt
    updateAt
    completedAt
    assignedAt
    PreparedUser {
      id
      email
      UserInformation {
        id
        userId
        userId
        birthday
        firstName
        lastName
        createAt
        updateAt
      }
    }
    ReviewedUser {
      id
      email
      UserInformation {
        id
        userId
        userId
        birthday
        firstName
        lastName
        createAt
        updateAt
      }
    }
    TaxYear {
      id
      entityId
      year
      createAt
      Entity {
        id
        ownerId
        Users {
          id
          email
          createAt
          languageId
          updateAt
          UserInformation {
            id
            userId
            birthday
            firstName
            lastName
            createAt
            updateAt
          }
        }
      }
    }
    Interviews {
      id
      name
      isLive
      createAt
      updateAt
      isTemplate
      firmAccountId
    }
  }
}
    `;
function $edf372aa0dea9531$export$6f506beac00a714a(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$18cb76dd1405ddc, options);
}
const $edf372aa0dea9531$export$9a9ca31c373d807 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation GetPresignedURL($fileName: String!, $fileType: String!) {
  generatePreSignedPutUrl(fileName: $fileName, fileType: $fileType) {
    url
    signedUrl
  }
}
    `;
function $edf372aa0dea9531$export$ea7e982b7f736995(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$9a9ca31c373d807, options);
}
const $edf372aa0dea9531$export$b2e9253da000bf1d = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UploadFileToUserOnDB($fileRoute: String!, $userId: String!, $taxYearInterviewId: String!, $size: Float!) {
  uploadFileToUserOnDB(
    fileRoute: $fileRoute
    userId: $userId
    taxYearInterviewId: $taxYearInterviewId
    size: $size
  ) {
    id
    userId
    firmAccountId
    taxYearInterviewId
    s3Key
    name
    size
    folder
    pages
    documentUsed
    createAt
    updateAt
  }
}
    `;
function $edf372aa0dea9531$export$768a55502f95551d(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$b2e9253da000bf1d, options);
}
const $edf372aa0dea9531$export$855cef9bcfedd29b = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation DeleteClientFile($s3Key: String!) {
  deleteClientFile(s3Key: $s3Key) {
    success
  }
}
    `;
function $edf372aa0dea9531$export$fa2331e991764c0d(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$855cef9bcfedd29b, options);
}
const $edf372aa0dea9531$export$a195ff82f1d836ce = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation DeleteClientRequestedFile($id: String!) {
  DeleteClientRequestedFile(id: $id) {
    id
  }
}
    `;
function $edf372aa0dea9531$export$5c97bcc38cdaaa9b(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$a195ff82f1d836ce, options);
}
const $edf372aa0dea9531$export$b7d0530336f621f5 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateClientFile($updateFileInput: UpdateFileInput!) {
  updateFile(updateFileInput: $updateFileInput) {
    id
    userId
    firmAccountId
    taxYearInterviewId
    s3Key
    name
    size
    folder
    pages
    documentUsed
    documentReviewed
    createAt
    updateAt
  }
}
    `;
function $edf372aa0dea9531$export$a44423915c3bd8dd(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$b7d0530336f621f5, options);
}
const $edf372aa0dea9531$export$104ff88439778770 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UploadFileToFirmOnDB($fileRoute: String!, $taxYearInterviewId: String!, $size: Float!) {
  uploadFileToFirmOnDB(
    fileRoute: $fileRoute
    taxYearInterviewId: $taxYearInterviewId
    size: $size
  ) {
    id
    userId
    firmAccountId
    taxYearInterviewId
    s3Key
    name
    size
    folder
    pages
    documentUsed
    createAt
    updateAt
  }
}
    `;
function $edf372aa0dea9531$export$c1a2b6ae89e60708(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$104ff88439778770, options);
}
const $edf372aa0dea9531$export$f9ba4277ad78bf05 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation DownloadFileFromS3($s3Key: String!, $messageId: String) {
  downloadFile(s3Key: $s3Key, messageId: $messageId) {
    success
    signedUrl
  }
}
    `;
function $edf372aa0dea9531$export$4747d4e17950f93f(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$f9ba4277ad78bf05, options);
}
const $edf372aa0dea9531$export$8b8fffa79be7e461 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation DownloadAllFilesFromS3($s3Keys: [String!]!) {
  downloadAllFiles(s3Keys: $s3Keys) {
    success
    signedUrlArray {
      url
      name
    }
  }
}
    `;
function $edf372aa0dea9531$export$b64d91815d7c1b44(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$8b8fffa79be7e461, options);
}
const $edf372aa0dea9531$export$1e07a0b4d9075c84 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation MarkInterviewAsCompleted($id: String!) {
  markInterviewAsCompleted(id: $id) {
    completedAt
  }
}
    `;
function $edf372aa0dea9531$export$355bcfc02b1246d4(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$1e07a0b4d9075c84, options);
}
const $edf372aa0dea9531$export$64d36318137fce0c = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation MarkInterviewAsNotCompleted($id: String!) {
  markInterviewAsNotCompleted(id: $id) {
    completedAt
  }
}
    `;
function $edf372aa0dea9531$export$a4a0ee16bc2f284e(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$64d36318137fce0c, options);
}
const $edf372aa0dea9531$export$d37efb65323673c2 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateAnswer($createAnswerInput: CreateAnswerInput!) {
  createAnswer(createAnswerInput: $createAnswerInput) {
    ...Answers
  }
}
    ${$edf372aa0dea9531$export$d8cf341a374b2613}`;
function $edf372aa0dea9531$export$28026c59decaabef(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$d37efb65323673c2, options);
}
const $edf372aa0dea9531$export$5fa2c3f266c9e184 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateAnswer($updateAnswerInput: UpdateAnswerInput!) {
  updateAnswer(updateAnswerInput: $updateAnswerInput) {
    ...Answers
  }
}
    ${$edf372aa0dea9531$export$d8cf341a374b2613}`;
function $edf372aa0dea9531$export$40439c9bae1c027a(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$5fa2c3f266c9e184, options);
}
const $edf372aa0dea9531$export$abc988ffbf4f72c4 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation SendInterview($taxYearInterviewId: String!) {
  SendInterview(taxYearInterviewId: $taxYearInterviewId) {
    success
  }
}
    `;
function $edf372aa0dea9531$export$a505897ebde01618(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$abc988ffbf4f72c4, options);
}
const $edf372aa0dea9531$export$ff6c74349979ba40 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation MarkFilesReceived($taxYearInterviewId: String!) {
  markFilesReceived(taxYearInterviewId: $taxYearInterviewId) {
    ...Tasks
  }
}
    ${$edf372aa0dea9531$export$659fb92f17a06d95}`;
function $edf372aa0dea9531$export$89e42d43f689d6e1(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$ff6c74349979ba40, options);
}
const $edf372aa0dea9531$export$848b1bd0f5b715c3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation MarkFilesNotReceived($taxYearInterviewId: String!) {
  markFilesNotReceived(taxYearInterviewId: $taxYearInterviewId) {
    ...Tasks
  }
}
    ${$edf372aa0dea9531$export$659fb92f17a06d95}`;
function $edf372aa0dea9531$export$1ba060ba13025dae(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$848b1bd0f5b715c3, options);
}
const $edf372aa0dea9531$export$3dd229cf92cea4eb = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation MarkPaymentsCompleted($taxYearInterviewId: String!) {
  markPaymentsCompleted(taxYearInterviewId: $taxYearInterviewId) {
    ...Tasks
  }
}
    ${$edf372aa0dea9531$export$659fb92f17a06d95}`;
function $edf372aa0dea9531$export$34f766c519f1eea4(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$3dd229cf92cea4eb, options);
}
const $edf372aa0dea9531$export$168574b06dfd2e6b = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation MarkPaymentsNotCompleted($taxYearInterviewId: String!) {
  markPaymentsNotCompleted(taxYearInterviewId: $taxYearInterviewId) {
    ...Tasks
  }
}
    ${$edf372aa0dea9531$export$659fb92f17a06d95}`;
function $edf372aa0dea9531$export$d5eebacae61f7ff2(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$168574b06dfd2e6b, options);
}
const $edf372aa0dea9531$export$9fe1acdfc2895e74 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation ExportToPDF($paymentId: String!) {
  exportToPDF(paymentId: $paymentId) {
    success
    stringData
  }
}
    `;
function $edf372aa0dea9531$export$4985049acf1b6694(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$9fe1acdfc2895e74, options);
}
const $edf372aa0dea9531$export$61614a8a1ba3828a = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation getEncryptMyToken {
  EncryptMyToken {
    accessToken
    selectedFirmAccount
    headToURL
  }
}
    `;
function $edf372aa0dea9531$export$e667747ad459634e(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$61614a8a1ba3828a, options);
}
const $edf372aa0dea9531$export$d465f8afa47b4eb = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateUserInformationNotes($userInformationId: String!, $notes: String) {
  UpdateUserInformation(
    updateUserInformationInput: {id: $userInformationId, notes: $notes}
  ) {
    id
    notes
  }
}
    `;
function $edf372aa0dea9531$export$488d2ca0cc91d182(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$d465f8afa47b4eb, options);
}
const $edf372aa0dea9531$export$3f33ac05ceae90d3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation RemoveClient2FA($userId: String!) {
  RemoveClient2FA(userId: $userId) {
    id
    has2Fa
  }
}
    `;
function $edf372aa0dea9531$export$c590036ed7747782(baseOptions) {
    const options = {
        ...$edf372aa0dea9531$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($edf372aa0dea9531$export$3f33ac05ceae90d3, options);
}
const $edf372aa0dea9531$export$39ac829ab91f0716 = {
    Mutation: {
        UpdateClient: 'UpdateClient',
        LoginAs: 'LoginAs',
        ReturnToAccount: 'ReturnToAccount',
        ResendActivation: 'ResendActivation',
        AddTaxYearInterviewJob: 'AddTaxYearInterviewJob',
        GetPresignedURL: 'GetPresignedURL',
        UploadFileToUserOnDB: 'UploadFileToUserOnDB',
        DeleteClientFile: 'DeleteClientFile',
        DeleteClientRequestedFile: 'DeleteClientRequestedFile',
        UpdateClientFile: 'UpdateClientFile',
        UploadFileToFirmOnDB: 'UploadFileToFirmOnDB',
        DownloadFileFromS3: 'DownloadFileFromS3',
        DownloadAllFilesFromS3: 'DownloadAllFilesFromS3',
        MarkInterviewAsCompleted: 'MarkInterviewAsCompleted',
        MarkInterviewAsNotCompleted: 'MarkInterviewAsNotCompleted',
        CreateAnswer: 'CreateAnswer',
        UpdateAnswer: 'UpdateAnswer',
        SendInterview: 'SendInterview',
        MarkFilesReceived: 'MarkFilesReceived',
        MarkFilesNotReceived: 'MarkFilesNotReceived',
        MarkPaymentsCompleted: 'MarkPaymentsCompleted',
        MarkPaymentsNotCompleted: 'MarkPaymentsNotCompleted',
        ExportToPDF: 'ExportToPDF',
        getEncryptMyToken: 'getEncryptMyToken',
        UpdateUserInformationNotes: 'UpdateUserInformationNotes',
        RemoveClient2FA: 'RemoveClient2FA'
    },
    Fragment: {
        Answers: 'Answers',
        Tasks: 'Tasks'
    }
};



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");






const $7e016fc573eed7c4$var$defaultOptions = {};
const $7e016fc573eed7c4$export$e934c7e7cbd240d3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation Login($loginInput: LoginInput!) {
  Login(loginInput: $loginInput) {
    accessToken
    headToURL
    selectedFirmAccount
    Entity {
      id
      Users {
        email
        languageId
        UserInformation {
          id
          userId
          firstName
          lastName
          birthday
          ssn
          profilePhoto
        }
      }
    }
    RelatedFirms {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
      }
      Users {
        UserInformation {
          firstName
          lastName
        }
      }
      Roles {
        id
        description
      }
    }
    UserFirmAccount {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
        type
        businessType
        Users {
          id
          email
          createAt
          updateAt
          languageId
          UserInformation {
            id
            userId
            birthday
            lastName
            firstName
            createAt
            updateAt
            Phones {
              id
              value
              type
              createAt
              updateAt
            }
            Address {
              id
              lineOne
              lineTwo
              city
              state
              type
              zip
              createAt
              updateAt
            }
          }
        }
        BusinessInformation {
          id
          Phones {
            id
            value
            type
            createAt
            updateAt
          }
          Address {
            id
            lineOne
            lineTwo
            city
            state
            type
            zip
            createAt
            updateAt
          }
        }
        ProgressStatuses {
          id
          firmAccountId
          status
          createAt
          updateAt
          underlyingStatus
          index
        }
      }
      Entity {
        id
        Users {
          id
          email
          languageId
          createAt
          UserInformation {
            id
            firstName
            lastName
            birthday
            ssn
            profilePhoto
          }
        }
      }
      Users {
        UserInformation {
          id
          userId
          firstName
          lastName
          birthday
          ssn
          profilePhoto
        }
        email
        languageId
        createAt
      }
      Roles {
        id
        description
      }
    }
  }
}
    `;
function $7e016fc573eed7c4$export$cddfb6c1bfa4d45f(baseOptions) {
    const options = {
        ...$7e016fc573eed7c4$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($7e016fc573eed7c4$export$e934c7e7cbd240d3, options);
}
const $7e016fc573eed7c4$export$a5fb2e9d8d40c592 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation LoginAsFirm($userId: String!, $token: String!, $firmId: String!) {
  LoginAsFirm(userId: $userId, token: $token, firmId: $firmId) {
    accessToken
    headToURL
    selectedFirmAccount
    RelatedFirms {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
      }
      Users {
        UserInformation {
          firstName
          lastName
        }
      }
      Roles {
        id
        description
      }
    }
    UserFirmAccount {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
        businessType
        BusinessInformation {
          id
          Phones {
            id
            value
            createAt
            updateAt
            type
          }
          Address {
            id
            lineOne
            lineTwo
            city
            state
            type
            zip
            createAt
            updateAt
          }
        }
        Users {
          id
          email
          languageId
          UserInformation {
            id
            firstName
            lastName
            birthday
            profilePhoto
            ssn
            Phones {
              id
              value
              type
              createAt
              updateAt
            }
            Address {
              id
              lineOne
              lineTwo
              city
              state
              type
              zip
              createAt
              updateAt
            }
          }
        }
        ProgressStatuses {
          id
          firmAccountId
          status
          createAt
          updateAt
          underlyingStatus
          index
        }
      }
      Users {
        id
        email
        languageId
        UserInformation {
          id
          userId
          firstName
          lastName
          birthday
          profilePhoto
          ssn
        }
      }
      Roles {
        id
        description
      }
    }
  }
}
    `;
function $7e016fc573eed7c4$export$affaa2272344e1c5(baseOptions) {
    const options = {
        ...$7e016fc573eed7c4$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($7e016fc573eed7c4$export$a5fb2e9d8d40c592, options);
}
const $7e016fc573eed7c4$export$39ac829ab91f0716 = {
    Mutation: {
        Login: 'Login',
        LoginAsFirm: 'LoginAsFirm'
    }
};




var $e0fb3ae7d1429331$export$fb614e1a95434ae;
var $e0fb3ae7d1429331$export$d6c0fbe55d3a4d57;
$e0fb3ae7d1429331$export$fb614e1a95434ae = `_0wTetG_loginPage`;
$e0fb3ae7d1429331$export$d6c0fbe55d3a4d57 = `_0wTetG_loginWrapper`;


const { Text: $bc55ebad68166096$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { useBreakpoint: $bc55ebad68166096$var$useBreakpoint } = (0, $89d88a41b53d163f$export$2e2bcd8739ae039);
const $bc55ebad68166096$var$getFirmAddress = (businessType, { User: User, BusinessInformation: BusinessInformation })=>{
    if (businessType === 'INDIVIDUAL') {
        const [Address] = User.UserInformation.Address.filter(({ type: type })=>type === 'PERSONAL');
        if (Address) {
            const { lineOne: lineOne, lineTwo: lineTwo, city: city, state: state, zip: zip } = Address;
            return `${lineOne ?? ''}, ${lineTwo ?? ''} ${city}, ${state} ${zip}`;
        }
    }
    const [Address] = BusinessInformation?.Address.filter(({ type: type })=>type === 'BUSINESS') ?? [];
    if (Address) {
        const { lineOne: lineOne, lineTwo: lineTwo, city: city, state: state, zip: zip } = Address;
        return `${lineOne ?? ''}, ${lineTwo ?? ''} ${city}, ${state} ${zip}`;
    }
    return '';
};
const $bc55ebad68166096$var$getFirmPhoneNumber = (businessType, { User: User, BusinessInformation: BusinessInformation })=>{
    if (businessType === 'INDIVIDUAL') {
        const [Phone] = User.UserInformation.Phones.filter(({ type: type })=>type === 'PERSONAL');
        if (Phone) {
            const { value: value } = Phone;
            return value ?? '';
        }
        return '';
    }
    const [Phone] = BusinessInformation.Phones.filter(({ type: type })=>type === 'OFFICE');
    if (Phone) {
        const { value: value } = Phone;
        return value ?? '';
    }
    return '';
};
const $bc55ebad68166096$export$4001836ab2b836f2 = (dispatch, accessToken, UserFirmAccount)=>{
    const { FirmAccount: FirmAccount } = UserFirmAccount;
    const { businessType: businessType, Users: FirmUser, BusinessInformation: BusinessInformation } = FirmAccount;
    dispatch((0, $e3b9937a336ce5aa$export$b94982631f8f9752)({
        email: UserFirmAccount.Users.email,
        accessToken: accessToken,
        id: UserFirmAccount.Users.UserInformation.id,
        userId: UserFirmAccount.Users.UserInformation.userId,
        userInformationId: UserFirmAccount.Users.UserInformation.id,
        firstName: UserFirmAccount.Users.UserInformation?.firstName,
        lastName: UserFirmAccount.Users.UserInformation?.lastName,
        birthday: UserFirmAccount.Users.UserInformation?.birthday,
        ssn: UserFirmAccount.Users.UserInformation.ssn,
        profilePhoto: UserFirmAccount.Users.UserInformation.profilePhoto,
        firmAccountId: UserFirmAccount.FirmAccount.id,
        languageId: UserFirmAccount.Users.languageId,
        userRole: UserFirmAccount.Roles.description,
        // eslint-disable-next-line
        progressStatuses: UserFirmAccount.FirmAccount.ProgressStatuses?.map(({ status: status, underlyingStatus: underlyingStatus, index: index, id: id })=>({
                status: status,
                underlyingStatus: underlyingStatus,
                index: index,
                id: id
            })) ?? undefined,
        firmName: UserFirmAccount.FirmAccount.name || `${UserFirmAccount.FirmAccount.Users.UserInformation.firstName || ''} ${UserFirmAccount.FirmAccount.Users.UserInformation.lastName || ''}`,
        firmAddress: $bc55ebad68166096$var$getFirmAddress(businessType, {
            User: FirmUser,
            BusinessInformation: BusinessInformation
        }),
        firmPhoneNumber: $bc55ebad68166096$var$getFirmPhoneNumber(businessType, {
            User: FirmUser,
            BusinessInformation: BusinessInformation
        }),
        firmCreatedAt: UserFirmAccount.FirmAccount.createAt,
        userCreatedAt: UserFirmAccount?.Users?.createAt
    }));
};
function $bc55ebad68166096$var$Login() {
    const screens = $bc55ebad68166096$var$useBreakpoint();
    const navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const [login, { data: data, loading: loading, error: error }] = (0, $7e016fc573eed7c4$export$cddfb6c1bfa4d45f)();
    const [isMfaUsed, setMfaUsed] = (0, $6fFrj.useState)(false);
    const [errorDescription, setErrorDescription] = (0, $6fFrj.useState)('');
    const location = (0, $990f835fb2356f36$export$45d76561a5302f2b)();
    const fromStateSearch = location.state?.from?.search || '';
    const fromStateSearchParams = new URLSearchParams(fromStateSearch);
    const fromStateSearchParamsObject = {};
    Array.from(fromStateSearchParams.entries()).forEach(([key, value])=>{
        fromStateSearchParamsObject[key] = value;
    });
    const OnFinish = async (values)=>{
        try {
            await login({
                variables: {
                    loginInput: {
                        email: values.email,
                        password: values.password,
                        code: values.code
                    }
                }
            });
        } catch (e) {
            console.warn(e);
        }
    };
    (0, $6fFrj.useEffect)(()=>{
        const errorMessage = error?.message;
        const graphqlError = error?.graphQLErrors?.at(0);
        const graphqlErrorName = graphqlError?.name;
        if (errorMessage === 'Not Found') setErrorDescription('Username/email not registered');
        else if (errorMessage === 'Unauthorized') setErrorDescription('Incorrect password');
        else if (errorMessage === 'Account Login Suspended') setErrorDescription('Your account has been suspended due to 5 incorrect login attempts. A password reset link has been sent to your email. Please update your password and then log in again.');
        else if (errorMessage === 'GoogleAuthenticatorCodeMissed') setErrorDescription(''); // not an error
        else if (graphqlErrorName === 'GoogleAuthenticatorCodeNotValid') setErrorDescription('Incorrect code');
        else setErrorDescription(errorMessage);
        if (errorMessage === 'GoogleAuthenticatorCodeMissed') setMfaUsed(true);
        if (data) {
            if (data.Login?.UserFirmAccount?.Entity) {
                // * This case is for TAXPAYER role
                const { UserFirmAccount: UserFirmAccount, accessToken: accessToken } = data.Login;
                const { Users: Users } = UserFirmAccount.Entity;
                const { id: userId, email: email, UserInformation: UserInformation, languageId: languageId } = Users;
                const { id: userInformationId, firstName: firstName, lastName: lastName, birthday: birthday, ssn: ssn, profilePhoto: profilePhoto } = UserInformation;
                const { Roles: Roles } = UserFirmAccount;
                const { id: firmAccountId, ProgressStatuses: ProgressStatuses, name: firmName, businessType: businessType, Users: FirmUser, BusinessInformation: BusinessInformation, createAt: createAt } = UserFirmAccount.FirmAccount;
                dispatch((0, $e3b9937a336ce5aa$export$b94982631f8f9752)({
                    ssn: ssn,
                    email: email,
                    userId: userId,
                    lastName: lastName,
                    birthday: birthday,
                    firmName: firmName ?? '',
                    firstName: firstName,
                    languageId: languageId,
                    accessToken: accessToken,
                    profilePhoto: profilePhoto,
                    firmAccountId: firmAccountId,
                    userInformationId: userInformationId,
                    id: userInformationId,
                    firmAddress: $bc55ebad68166096$var$getFirmAddress(businessType, {
                        User: FirmUser,
                        BusinessInformation: BusinessInformation
                    }),
                    firmPhoneNumber: $bc55ebad68166096$var$getFirmPhoneNumber(businessType, {
                        User: FirmUser,
                        BusinessInformation: BusinessInformation
                    }),
                    firmCreatedAt: createAt ?? '',
                    userCreatedAt: UserFirmAccount?.Entity?.Users?.createAt,
                    userRole: Roles.description,
                    progressStatuses: ProgressStatuses?.map(({ status: status, underlyingStatus: underlyingStatus, index: index, id: id })=>({
                            status: status,
                            underlyingStatus: underlyingStatus,
                            index: index,
                            id: id
                        })) ?? undefined
                }));
                navigate('/clients');
            } else {
                // * This is for Tax Preparer role
                const { UserFirmAccount: UserFirmAccount } = data.Login;
                $bc55ebad68166096$export$4001836ab2b836f2(dispatch, data.Login.accessToken, UserFirmAccount);
                (0, $dfc6a33c14790f87$export$212bca99edcd2b5f)();
                // eslint-disable-next-line
                window['profitwell']('start', {
                    user_email: UserFirmAccount.Users.email
                });
                navigate('/');
            }
        }
    }, [
        error,
        data,
        navigate,
        dispatch
    ]);
    const formWidth = (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? (0, $0316ae7d1654226a$export$b042f465f6c08a24)() * 0.7 : 375;
    return (0, $bb3TF.jsx)("div", {
        className: $e0fb3ae7d1429331$export$fb614e1a95434ae,
        children: (0, $bb3TF.jsx)("div", {
            className: $e0fb3ae7d1429331$export$d6c0fbe55d3a4d57,
            children: (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                // elevated
                style: {
                    padding: screens.md ? '10px 80px' : '5px',
                    maxWidth: '900px',
                    width: (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? '100%' : undefined
                },
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        style: {
                            margin: '0 0 60px 0'
                        },
                        children: (0, $bb3TF.jsx)((0, $1cbcb18aa67bf12c$export$2e2bcd8739ae039), {
                            width: "170",
                            height: "40"
                        })
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        children: [
                            errorDescription && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                                style: {
                                    marginBottom: 15,
                                    width: (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? '100%' : `${formWidth}px`
                                },
                                type: "warning",
                                message: "Please fix the errors below:",
                                description: errorDescription
                            }),
                            fromStateSearchParamsObject?.from === 'taxaroo' && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                                style: {
                                    marginBottom: 20,
                                    width: (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? '100%' : `${formWidth}px`
                                },
                                type: "success",
                                message: (0, $bb3TF.jsx)($bc55ebad68166096$var$Text, {
                                    style: {
                                        color: 'white',
                                        fontWeight: 'bolder',
                                        fontSize: 19
                                    },
                                    children: "Congratulations! Your migration to Taxaroo 3.0 is complete."
                                }),
                                description: `
                  From now on, you will log in here at ${window.location.origin} and enjoy the enhancements of your trusted software. Thank you for upgrading!
                `
                            })
                        ]
                    }),
                    (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                        name: "login",
                        layout: "vertical",
                        onFinish: OnFinish,
                        style: {
                            width: (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? '100%' : `${formWidth}px`
                        },
                        children: [
                            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                label: "Email Address",
                                name: "email",
                                rules: [
                                    {
                                        required: true,
                                        type: 'email',
                                        message: 'Please input a valid email!'
                                    }
                                ],
                                children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                    size: "large"
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                label: "Password",
                                name: "password",
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please input your password!'
                                    }
                                ],
                                children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039).Password, {
                                    size: "large"
                                })
                            }),
                            isMfaUsed && (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                label: "Two-Factor Authentication Code",
                                extra: (0, $bb3TF.jsx)("div", {
                                    style: {
                                        fontSize: '0.9em',
                                        lineHeight: 1.2
                                    },
                                    children: "To continue, please enter the 6-digit verification code generated by your authenticator app."
                                }),
                                name: "code",
                                rules: [
                                    {
                                        required: isMfaUsed,
                                        message: 'Please input a valid code!'
                                    }
                                ],
                                children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                    size: "large"
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    htmlType: "submit",
                                    loading: loading,
                                    style: {
                                        width: '100%',
                                        justifyContent: 'center'
                                    },
                                    children: "Login"
                                })
                            }),
                            (0, $bb3TF.jsxs)("div", {
                                style: {
                                    textAlign: 'center'
                                },
                                children: [
                                    (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                                        to: "/forgot-password",
                                        children: "Forgot Password?"
                                    }),
                                    (0, $bb3TF.jsxs)("p", {
                                        children: [
                                            "New to Taxaroo?",
                                            ' ',
                                            (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                                                to: "/register",
                                                children: "Create Account"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var $bc55ebad68166096$export$2e2bcd8739ae039 = $bc55ebad68166096$var$Login;





var $bb3TF = parcelRequire("bb3TF");

// ES6 Map
var $346f9e710560eb2a$var$map;
try {
    $346f9e710560eb2a$var$map = Map;
} catch (_) {}
var $346f9e710560eb2a$var$set;
// ES6 Set
try {
    $346f9e710560eb2a$var$set = Set;
} catch (_) {}
function $346f9e710560eb2a$var$baseClone(src, circulars, clones) {
    // Null/undefined/functions/etc
    if (!src || typeof src !== 'object' || typeof src === 'function') return src;
    // DOM Node
    if (src.nodeType && 'cloneNode' in src) return src.cloneNode(true);
    // Date
    if (src instanceof Date) return new Date(src.getTime());
    // RegExp
    if (src instanceof RegExp) return new RegExp(src);
    // Arrays
    if (Array.isArray(src)) return src.map($346f9e710560eb2a$export$2e2bcd8739ae039);
    // ES6 Maps
    if ($346f9e710560eb2a$var$map && src instanceof $346f9e710560eb2a$var$map) return new Map(Array.from(src.entries()));
    // ES6 Sets
    if ($346f9e710560eb2a$var$set && src instanceof $346f9e710560eb2a$var$set) return new Set(Array.from(src.values()));
    // Object
    if (src instanceof Object) {
        circulars.push(src);
        var obj = Object.create(src);
        clones.push(obj);
        for(var key in src){
            var idx = circulars.findIndex(function(i) {
                return i === src[key];
            });
            obj[key] = idx > -1 ? clones[idx] : $346f9e710560eb2a$var$baseClone(src[key], circulars, clones);
        }
        return obj;
    }
    // ???
    return src;
}
function $346f9e710560eb2a$export$2e2bcd8739ae039(src) {
    return $346f9e710560eb2a$var$baseClone(src, [], []);
}


const $6e275c2ea1928bcc$var$toString = Object.prototype.toString;
const $6e275c2ea1928bcc$var$errorToString = Error.prototype.toString;
const $6e275c2ea1928bcc$var$regExpToString = RegExp.prototype.toString;
const $6e275c2ea1928bcc$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $6e275c2ea1928bcc$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $6e275c2ea1928bcc$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $6e275c2ea1928bcc$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $6e275c2ea1928bcc$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $6e275c2ea1928bcc$var$symbolToString.call(val).replace($6e275c2ea1928bcc$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $6e275c2ea1928bcc$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $6e275c2ea1928bcc$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $6e275c2ea1928bcc$var$regExpToString.call(val);
    return null;
}
function $6e275c2ea1928bcc$export$2e2bcd8739ae039(value, quoteStrings) {
    let result = $6e275c2ea1928bcc$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $6e275c2ea1928bcc$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}


let $29e8e7a2eb806720$export$9b30b6294c1449a8 = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        let isCast = originalValue != null && originalValue !== value;
        let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${(0, $6e275c2ea1928bcc$export$2e2bcd8739ae039)(value, true)}\`` + (isCast ? ` (cast from the value \`${(0, $6e275c2ea1928bcc$export$2e2bcd8739ae039)(originalValue, true)}\`).` : '.');
        if (value === null) msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
        return msg;
    },
    defined: '${path} must be defined'
};
let $29e8e7a2eb806720$export$22b082955e083ec3 = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $29e8e7a2eb806720$export$98e628dec113755e = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $29e8e7a2eb806720$export$324d90190a8b822a = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $29e8e7a2eb806720$export$4a21f16c33752377 = {
    isValue: '${path} field must be ${value}'
};
let $29e8e7a2eb806720$export$be5493f9613cbbe = {
    noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let $29e8e7a2eb806720$export$2f23118c22fb2630 = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
var $29e8e7a2eb806720$export$2e2bcd8739ae039 = Object.assign(Object.create(null), {
    mixed: $29e8e7a2eb806720$export$9b30b6294c1449a8,
    string: $29e8e7a2eb806720$export$22b082955e083ec3,
    number: $29e8e7a2eb806720$export$98e628dec113755e,
    date: $29e8e7a2eb806720$export$324d90190a8b822a,
    object: $29e8e7a2eb806720$export$be5493f9613cbbe,
    array: $29e8e7a2eb806720$export$2f23118c22fb2630,
    boolean: $29e8e7a2eb806720$export$4a21f16c33752377
});


var $892682e2ec181f97$exports = {};
var $f5983519e15dd9c2$exports = {};
/** Used for built-in method references. */ var $f5983519e15dd9c2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f5983519e15dd9c2$var$hasOwnProperty = $f5983519e15dd9c2$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $f5983519e15dd9c2$var$baseHas(object, key) {
    return object != null && $f5983519e15dd9c2$var$hasOwnProperty.call(object, key);
}
$f5983519e15dd9c2$exports = $f5983519e15dd9c2$var$baseHas;


var $62505984236a9ccf$exports = {};
var $01b5d0091863e8cd$exports = {};
var $2a0fbf166027c360$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $2a0fbf166027c360$var$isArray = Array.isArray;
$2a0fbf166027c360$exports = $2a0fbf166027c360$var$isArray;


var $32f1917baeda9885$exports = {};

var $5b689df6650cdbfc$exports = {};
var $b35c5a96e6a9987b$exports = {};
var $57507d7d7570b777$exports = {};

var $8qdJN = parcelRequire("8qdJN");
/** Built-in value references. */ var $57507d7d7570b777$var$Symbol = $8qdJN.Symbol;
$57507d7d7570b777$exports = $57507d7d7570b777$var$Symbol;


var $5cf3f087ada30aaf$exports = {};

/** Used for built-in method references. */ var $5cf3f087ada30aaf$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5cf3f087ada30aaf$var$hasOwnProperty = $5cf3f087ada30aaf$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $5cf3f087ada30aaf$var$nativeObjectToString = $5cf3f087ada30aaf$var$objectProto.toString;
/** Built-in value references. */ var $5cf3f087ada30aaf$var$symToStringTag = $57507d7d7570b777$exports ? $57507d7d7570b777$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $5cf3f087ada30aaf$var$getRawTag(value) {
    var isOwn = $5cf3f087ada30aaf$var$hasOwnProperty.call(value, $5cf3f087ada30aaf$var$symToStringTag), tag = value[$5cf3f087ada30aaf$var$symToStringTag];
    try {
        value[$5cf3f087ada30aaf$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $5cf3f087ada30aaf$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$5cf3f087ada30aaf$var$symToStringTag] = tag;
        else delete value[$5cf3f087ada30aaf$var$symToStringTag];
    }
    return result;
}
$5cf3f087ada30aaf$exports = $5cf3f087ada30aaf$var$getRawTag;


var $d118152ccbe9af3c$exports = {};
/** Used for built-in method references. */ var $d118152ccbe9af3c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d118152ccbe9af3c$var$nativeObjectToString = $d118152ccbe9af3c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $d118152ccbe9af3c$var$objectToString(value) {
    return $d118152ccbe9af3c$var$nativeObjectToString.call(value);
}
$d118152ccbe9af3c$exports = $d118152ccbe9af3c$var$objectToString;


/** `Object#toString` result references. */ var $b35c5a96e6a9987b$var$nullTag = '[object Null]', $b35c5a96e6a9987b$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $b35c5a96e6a9987b$var$symToStringTag = $57507d7d7570b777$exports ? $57507d7d7570b777$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $b35c5a96e6a9987b$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $b35c5a96e6a9987b$var$undefinedTag : $b35c5a96e6a9987b$var$nullTag;
    return $b35c5a96e6a9987b$var$symToStringTag && $b35c5a96e6a9987b$var$symToStringTag in Object(value) ? $5cf3f087ada30aaf$exports(value) : $d118152ccbe9af3c$exports(value);
}
$b35c5a96e6a9987b$exports = $b35c5a96e6a9987b$var$baseGetTag;


var $2491d5b87f6f34f9$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $2491d5b87f6f34f9$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$2491d5b87f6f34f9$exports = $2491d5b87f6f34f9$var$isObjectLike;


/** `Object#toString` result references. */ var $5b689df6650cdbfc$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5b689df6650cdbfc$var$isSymbol(value) {
    return typeof value == 'symbol' || $2491d5b87f6f34f9$exports(value) && $b35c5a96e6a9987b$exports(value) == $5b689df6650cdbfc$var$symbolTag;
}
$5b689df6650cdbfc$exports = $5b689df6650cdbfc$var$isSymbol;


/** Used to match property names within property paths. */ var $32f1917baeda9885$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $32f1917baeda9885$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $32f1917baeda9885$var$isKey(value, object) {
    if ($2a0fbf166027c360$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $5b689df6650cdbfc$exports(value)) return true;
    return $32f1917baeda9885$var$reIsPlainProp.test(value) || !$32f1917baeda9885$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$32f1917baeda9885$exports = $32f1917baeda9885$var$isKey;


var $c356fd5422cc2bc6$exports = {};
var $927df2ce8b82fcbd$exports = {};
var $71e174047c0c3d6f$exports = {};
var $4f2cc624e4624515$exports = {};
var $736296ddd0f354cc$exports = {};
var $1a92a8a91a39640e$exports = {};
var $59616c237c0425c4$exports = {};
var $cd73e8342aadf68b$exports = {};
var $45c073923688f884$exports = {};
var $4e2b04c8c8d6012f$exports = {};
var $42b6ba2ef8e23e96$exports = {};

var $de338c730ce7636d$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $de338c730ce7636d$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$de338c730ce7636d$exports = $de338c730ce7636d$var$isObject;


/** `Object#toString` result references. */ var $42b6ba2ef8e23e96$var$asyncTag = '[object AsyncFunction]', $42b6ba2ef8e23e96$var$funcTag = '[object Function]', $42b6ba2ef8e23e96$var$genTag = '[object GeneratorFunction]', $42b6ba2ef8e23e96$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $42b6ba2ef8e23e96$var$isFunction(value) {
    if (!$de338c730ce7636d$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $b35c5a96e6a9987b$exports(value);
    return tag == $42b6ba2ef8e23e96$var$funcTag || tag == $42b6ba2ef8e23e96$var$genTag || tag == $42b6ba2ef8e23e96$var$asyncTag || tag == $42b6ba2ef8e23e96$var$proxyTag;
}
$42b6ba2ef8e23e96$exports = $42b6ba2ef8e23e96$var$isFunction;


var $606ccc7948ccd196$exports = {};
var $d062bcd3cc5e0e73$exports = {};

var $8qdJN = parcelRequire("8qdJN");
/** Used to detect overreaching core-js shims. */ var $d062bcd3cc5e0e73$var$coreJsData = $8qdJN["__core-js_shared__"];
$d062bcd3cc5e0e73$exports = $d062bcd3cc5e0e73$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $606ccc7948ccd196$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($d062bcd3cc5e0e73$exports && $d062bcd3cc5e0e73$exports.keys && $d062bcd3cc5e0e73$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $606ccc7948ccd196$var$isMasked(func) {
    return !!$606ccc7948ccd196$var$maskSrcKey && $606ccc7948ccd196$var$maskSrcKey in func;
}
$606ccc7948ccd196$exports = $606ccc7948ccd196$var$isMasked;



var $b38296444a19076e$exports = {};
/** Used for built-in method references. */ var $b38296444a19076e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $b38296444a19076e$var$funcToString = $b38296444a19076e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $b38296444a19076e$var$toSource(func) {
    if (func != null) {
        try {
            return $b38296444a19076e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$b38296444a19076e$exports = $b38296444a19076e$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $4e2b04c8c8d6012f$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $4e2b04c8c8d6012f$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $4e2b04c8c8d6012f$var$funcProto = Function.prototype, $4e2b04c8c8d6012f$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $4e2b04c8c8d6012f$var$funcToString = $4e2b04c8c8d6012f$var$funcProto.toString;
/** Used to check objects for own properties. */ var $4e2b04c8c8d6012f$var$hasOwnProperty = $4e2b04c8c8d6012f$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $4e2b04c8c8d6012f$var$reIsNative = RegExp('^' + $4e2b04c8c8d6012f$var$funcToString.call($4e2b04c8c8d6012f$var$hasOwnProperty).replace($4e2b04c8c8d6012f$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $4e2b04c8c8d6012f$var$baseIsNative(value) {
    if (!$de338c730ce7636d$exports(value) || $606ccc7948ccd196$exports(value)) return false;
    var pattern = $42b6ba2ef8e23e96$exports(value) ? $4e2b04c8c8d6012f$var$reIsNative : $4e2b04c8c8d6012f$var$reIsHostCtor;
    return pattern.test($b38296444a19076e$exports(value));
}
$4e2b04c8c8d6012f$exports = $4e2b04c8c8d6012f$var$baseIsNative;


var $e013f8be40460ad7$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e013f8be40460ad7$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$e013f8be40460ad7$exports = $e013f8be40460ad7$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $45c073923688f884$var$getNative(object, key) {
    var value = $e013f8be40460ad7$exports(object, key);
    return $4e2b04c8c8d6012f$exports(value) ? value : undefined;
}
$45c073923688f884$exports = $45c073923688f884$var$getNative;


/* Built-in method references that are verified to be native. */ var $cd73e8342aadf68b$var$nativeCreate = $45c073923688f884$exports(Object, 'create');
$cd73e8342aadf68b$exports = $cd73e8342aadf68b$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $59616c237c0425c4$var$hashClear() {
    this.__data__ = $cd73e8342aadf68b$exports ? $cd73e8342aadf68b$exports(null) : {};
    this.size = 0;
}
$59616c237c0425c4$exports = $59616c237c0425c4$var$hashClear;


var $5394b6a490760f89$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5394b6a490760f89$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$5394b6a490760f89$exports = $5394b6a490760f89$var$hashDelete;


var $60cbca75397baa76$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $60cbca75397baa76$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $60cbca75397baa76$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $60cbca75397baa76$var$hasOwnProperty = $60cbca75397baa76$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $60cbca75397baa76$var$hashGet(key) {
    var data = this.__data__;
    if ($cd73e8342aadf68b$exports) {
        var result = data[key];
        return result === $60cbca75397baa76$var$HASH_UNDEFINED ? undefined : result;
    }
    return $60cbca75397baa76$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$60cbca75397baa76$exports = $60cbca75397baa76$var$hashGet;


var $d836285a72ccedf9$exports = {};

/** Used for built-in method references. */ var $d836285a72ccedf9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d836285a72ccedf9$var$hasOwnProperty = $d836285a72ccedf9$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d836285a72ccedf9$var$hashHas(key) {
    var data = this.__data__;
    return $cd73e8342aadf68b$exports ? data[key] !== undefined : $d836285a72ccedf9$var$hasOwnProperty.call(data, key);
}
$d836285a72ccedf9$exports = $d836285a72ccedf9$var$hashHas;


var $f0ddf51b2f4dd001$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $f0ddf51b2f4dd001$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $f0ddf51b2f4dd001$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $cd73e8342aadf68b$exports && value === undefined ? $f0ddf51b2f4dd001$var$HASH_UNDEFINED : value;
    return this;
}
$f0ddf51b2f4dd001$exports = $f0ddf51b2f4dd001$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1a92a8a91a39640e$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$1a92a8a91a39640e$var$Hash.prototype.clear = $59616c237c0425c4$exports;
$1a92a8a91a39640e$var$Hash.prototype['delete'] = $5394b6a490760f89$exports;
$1a92a8a91a39640e$var$Hash.prototype.get = $60cbca75397baa76$exports;
$1a92a8a91a39640e$var$Hash.prototype.has = $d836285a72ccedf9$exports;
$1a92a8a91a39640e$var$Hash.prototype.set = $f0ddf51b2f4dd001$exports;
$1a92a8a91a39640e$exports = $1a92a8a91a39640e$var$Hash;


var $545e3e1214f1ef3a$exports = {};
var $5b3f662e6d1663ff$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $5b3f662e6d1663ff$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$5b3f662e6d1663ff$exports = $5b3f662e6d1663ff$var$listCacheClear;


var $fb4235308b6f841e$exports = {};
var $52f81716c8bc147a$exports = {};
var $bb5d7160ba902670$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $bb5d7160ba902670$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$bb5d7160ba902670$exports = $bb5d7160ba902670$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $52f81716c8bc147a$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($bb5d7160ba902670$exports(array[length][0], key)) return length;
    }
    return -1;
}
$52f81716c8bc147a$exports = $52f81716c8bc147a$var$assocIndexOf;


/** Used for built-in method references. */ var $fb4235308b6f841e$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $fb4235308b6f841e$var$splice = $fb4235308b6f841e$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $fb4235308b6f841e$var$listCacheDelete(key) {
    var data = this.__data__, index = $52f81716c8bc147a$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $fb4235308b6f841e$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$fb4235308b6f841e$exports = $fb4235308b6f841e$var$listCacheDelete;


var $c9270c8d715baaed$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c9270c8d715baaed$var$listCacheGet(key) {
    var data = this.__data__, index = $52f81716c8bc147a$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$c9270c8d715baaed$exports = $c9270c8d715baaed$var$listCacheGet;


var $5819d8536879e54a$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5819d8536879e54a$var$listCacheHas(key) {
    return $52f81716c8bc147a$exports(this.__data__, key) > -1;
}
$5819d8536879e54a$exports = $5819d8536879e54a$var$listCacheHas;


var $b9905b5115880474$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $b9905b5115880474$var$listCacheSet(key, value) {
    var data = this.__data__, index = $52f81716c8bc147a$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$b9905b5115880474$exports = $b9905b5115880474$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $545e3e1214f1ef3a$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$545e3e1214f1ef3a$var$ListCache.prototype.clear = $5b3f662e6d1663ff$exports;
$545e3e1214f1ef3a$var$ListCache.prototype['delete'] = $fb4235308b6f841e$exports;
$545e3e1214f1ef3a$var$ListCache.prototype.get = $c9270c8d715baaed$exports;
$545e3e1214f1ef3a$var$ListCache.prototype.has = $5819d8536879e54a$exports;
$545e3e1214f1ef3a$var$ListCache.prototype.set = $b9905b5115880474$exports;
$545e3e1214f1ef3a$exports = $545e3e1214f1ef3a$var$ListCache;


var $c4bbeb9a8b68fcae$exports = {};


var $8qdJN = parcelRequire("8qdJN");
/* Built-in method references that are verified to be native. */ var $c4bbeb9a8b68fcae$var$Map = $45c073923688f884$exports($8qdJN, 'Map');
$c4bbeb9a8b68fcae$exports = $c4bbeb9a8b68fcae$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $736296ddd0f354cc$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $1a92a8a91a39640e$exports,
        'map': new ($c4bbeb9a8b68fcae$exports || $545e3e1214f1ef3a$exports),
        'string': new $1a92a8a91a39640e$exports
    };
}
$736296ddd0f354cc$exports = $736296ddd0f354cc$var$mapCacheClear;


var $e5aa5ea10920c01c$exports = {};
var $42d445c4c09f0188$exports = {};
var $d40680f7e83693fc$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $d40680f7e83693fc$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$d40680f7e83693fc$exports = $d40680f7e83693fc$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $42d445c4c09f0188$var$getMapData(map, key) {
    var data = map.__data__;
    return $d40680f7e83693fc$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$42d445c4c09f0188$exports = $42d445c4c09f0188$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e5aa5ea10920c01c$var$mapCacheDelete(key) {
    var result = $42d445c4c09f0188$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$e5aa5ea10920c01c$exports = $e5aa5ea10920c01c$var$mapCacheDelete;


var $1723acc824419a02$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1723acc824419a02$var$mapCacheGet(key) {
    return $42d445c4c09f0188$exports(this, key).get(key);
}
$1723acc824419a02$exports = $1723acc824419a02$var$mapCacheGet;


var $ebc1f126b10a15bb$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ebc1f126b10a15bb$var$mapCacheHas(key) {
    return $42d445c4c09f0188$exports(this, key).has(key);
}
$ebc1f126b10a15bb$exports = $ebc1f126b10a15bb$var$mapCacheHas;


var $ead62d7c702d9660$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $ead62d7c702d9660$var$mapCacheSet(key, value) {
    var data = $42d445c4c09f0188$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$ead62d7c702d9660$exports = $ead62d7c702d9660$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4f2cc624e4624515$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4f2cc624e4624515$var$MapCache.prototype.clear = $736296ddd0f354cc$exports;
$4f2cc624e4624515$var$MapCache.prototype['delete'] = $e5aa5ea10920c01c$exports;
$4f2cc624e4624515$var$MapCache.prototype.get = $1723acc824419a02$exports;
$4f2cc624e4624515$var$MapCache.prototype.has = $ebc1f126b10a15bb$exports;
$4f2cc624e4624515$var$MapCache.prototype.set = $ead62d7c702d9660$exports;
$4f2cc624e4624515$exports = $4f2cc624e4624515$var$MapCache;


/** Error message constants. */ var $71e174047c0c3d6f$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $71e174047c0c3d6f$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($71e174047c0c3d6f$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($71e174047c0c3d6f$var$memoize.Cache || $4f2cc624e4624515$exports);
    return memoized;
}
// Expose `MapCache`.
$71e174047c0c3d6f$var$memoize.Cache = $4f2cc624e4624515$exports;
$71e174047c0c3d6f$exports = $71e174047c0c3d6f$var$memoize;


/** Used as the maximum memoize cache size. */ var $927df2ce8b82fcbd$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $927df2ce8b82fcbd$var$memoizeCapped(func) {
    var result = $71e174047c0c3d6f$exports(func, function(key) {
        if (cache.size === $927df2ce8b82fcbd$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$927df2ce8b82fcbd$exports = $927df2ce8b82fcbd$var$memoizeCapped;


/** Used to match property names within property paths. */ var $c356fd5422cc2bc6$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $c356fd5422cc2bc6$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $c356fd5422cc2bc6$var$stringToPath = $927df2ce8b82fcbd$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($c356fd5422cc2bc6$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($c356fd5422cc2bc6$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$c356fd5422cc2bc6$exports = $c356fd5422cc2bc6$var$stringToPath;


var $d9b09c9b2e860fe7$exports = {};
var $46fae5be610d1705$exports = {};

var $f66d194dd2fd382e$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $f66d194dd2fd382e$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$f66d194dd2fd382e$exports = $f66d194dd2fd382e$var$arrayMap;




/** Used as references for various `Number` constants. */ var $46fae5be610d1705$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $46fae5be610d1705$var$symbolProto = $57507d7d7570b777$exports ? $57507d7d7570b777$exports.prototype : undefined, $46fae5be610d1705$var$symbolToString = $46fae5be610d1705$var$symbolProto ? $46fae5be610d1705$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $46fae5be610d1705$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($2a0fbf166027c360$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $f66d194dd2fd382e$exports(value, $46fae5be610d1705$var$baseToString) + '';
    if ($5b689df6650cdbfc$exports(value)) return $46fae5be610d1705$var$symbolToString ? $46fae5be610d1705$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$46fae5be610d1705$var$INFINITY ? '-0' : result;
}
$46fae5be610d1705$exports = $46fae5be610d1705$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $d9b09c9b2e860fe7$var$toString(value) {
    return value == null ? '' : $46fae5be610d1705$exports(value);
}
$d9b09c9b2e860fe7$exports = $d9b09c9b2e860fe7$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $01b5d0091863e8cd$var$castPath(value, object) {
    if ($2a0fbf166027c360$exports(value)) return value;
    return $32f1917baeda9885$exports(value, object) ? [
        value
    ] : $c356fd5422cc2bc6$exports($d9b09c9b2e860fe7$exports(value));
}
$01b5d0091863e8cd$exports = $01b5d0091863e8cd$var$castPath;


var $b825681d46d8740e$exports = {};
var $a02eefd09a7625fc$exports = {};


/** `Object#toString` result references. */ var $a02eefd09a7625fc$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $a02eefd09a7625fc$var$baseIsArguments(value) {
    return $2491d5b87f6f34f9$exports(value) && $b35c5a96e6a9987b$exports(value) == $a02eefd09a7625fc$var$argsTag;
}
$a02eefd09a7625fc$exports = $a02eefd09a7625fc$var$baseIsArguments;



/** Used for built-in method references. */ var $b825681d46d8740e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b825681d46d8740e$var$hasOwnProperty = $b825681d46d8740e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $b825681d46d8740e$var$propertyIsEnumerable = $b825681d46d8740e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $b825681d46d8740e$var$isArguments = $a02eefd09a7625fc$exports(function() {
    return arguments;
}()) ? $a02eefd09a7625fc$exports : function(value) {
    return $2491d5b87f6f34f9$exports(value) && $b825681d46d8740e$var$hasOwnProperty.call(value, 'callee') && !$b825681d46d8740e$var$propertyIsEnumerable.call(value, 'callee');
};
$b825681d46d8740e$exports = $b825681d46d8740e$var$isArguments;



var $34c6bc0f433a5029$exports = {};
/** Used as references for various `Number` constants. */ var $34c6bc0f433a5029$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $34c6bc0f433a5029$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $34c6bc0f433a5029$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $34c6bc0f433a5029$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $34c6bc0f433a5029$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$34c6bc0f433a5029$exports = $34c6bc0f433a5029$var$isIndex;


var $fe64242c905a27a3$exports = {};
/** Used as references for various `Number` constants. */ var $fe64242c905a27a3$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $fe64242c905a27a3$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $fe64242c905a27a3$var$MAX_SAFE_INTEGER;
}
$fe64242c905a27a3$exports = $fe64242c905a27a3$var$isLength;


var $f1862dc5b8aedcb3$exports = {};

/** Used as references for various `Number` constants. */ var $f1862dc5b8aedcb3$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $f1862dc5b8aedcb3$var$toKey(value) {
    if (typeof value == 'string' || $5b689df6650cdbfc$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$f1862dc5b8aedcb3$var$INFINITY ? '-0' : result;
}
$f1862dc5b8aedcb3$exports = $f1862dc5b8aedcb3$var$toKey;


/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $62505984236a9ccf$var$hasPath(object, path, hasFunc) {
    path = $01b5d0091863e8cd$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $f1862dc5b8aedcb3$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $fe64242c905a27a3$exports(length) && $34c6bc0f433a5029$exports(key, length) && ($2a0fbf166027c360$exports(object) || $b825681d46d8740e$exports(object));
}
$62505984236a9ccf$exports = $62505984236a9ccf$var$hasPath;


/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $892682e2ec181f97$var$has(object, path) {
    return object != null && $62505984236a9ccf$exports(object, path, $f5983519e15dd9c2$exports);
}
$892682e2ec181f97$exports = $892682e2ec181f97$var$has;


const $f2191a4ad394fb0a$var$isSchema = (obj)=>obj && obj.__isYupSchema__;
var $f2191a4ad394fb0a$export$2e2bcd8739ae039 = $f2191a4ad394fb0a$var$isSchema;


class $db981fe59e3c8136$var$Condition {
    constructor(refs, options){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        if (typeof options === 'function') {
            this.fn = options;
            return;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($892682e2ec181f97$exports)))(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
        if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = options;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        this.fn = function(...args) {
            let options = args.pop();
            let schema = args.pop();
            let branch = check(...args) ? then : otherwise;
            if (!branch) return undefined;
            if (typeof branch === 'function') return branch(schema);
            return schema.concat(branch.resolve(options));
        };
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn.apply(base, values.concat(base, options));
        if (schema === undefined || schema === base) return base;
        if (!(0, $f2191a4ad394fb0a$export$2e2bcd8739ae039)(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
var $db981fe59e3c8136$export$2e2bcd8739ae039 = $db981fe59e3c8136$var$Condition;



function $3f226c5fc6e3a1e8$export$2e2bcd8739ae039(value) {
    return value == null ? [] : [].concat(value);
}


function $436abf1934e89390$var$_extends() {
    $436abf1934e89390$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $436abf1934e89390$var$_extends.apply(this, arguments);
}
let $436abf1934e89390$var$strReg = /\$\{\s*(\w+)\s*\}/g;
class $436abf1934e89390$export$2e2bcd8739ae039 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || 'this';
        if (path !== params.path) params = $436abf1934e89390$var$_extends({}, params, {
            path: path
        });
        if (typeof message === 'string') return message.replace($436abf1934e89390$var$strReg, (_, key)=>(0, $6e275c2ea1928bcc$export$2e2bcd8739ae039)(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        (0, $3f226c5fc6e3a1e8$export$2e2bcd8739ae039)(errorOrErrors).forEach((err)=>{
            if ($436abf1934e89390$export$2e2bcd8739ae039.isError(err)) {
                this.errors.push(...err.errors);
                this.inner = this.inner.concat(err.inner.length ? err.inner : err);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $436abf1934e89390$export$2e2bcd8739ae039);
    }
}


const $65dc7f44eb17b152$var$once = (cb)=>{
    let fired = false;
    return (...args)=>{
        if (fired) return;
        fired = true;
        cb(...args);
    };
};
function $65dc7f44eb17b152$export$2e2bcd8739ae039(options, cb) {
    let { endEarly: endEarly, tests: tests, args: args, value: value, errors: errors, sort: sort, path: path } = options;
    let callback = $65dc7f44eb17b152$var$once(cb);
    let count = tests.length;
    const nestedErrors = [];
    errors = errors ? errors : [];
    if (!count) return errors.length ? callback(new (0, $436abf1934e89390$export$2e2bcd8739ae039)(errors, value, path)) : callback(null, value);
    for(let i = 0; i < tests.length; i++){
        const test = tests[i];
        test(args, function finishTestRun(err) {
            if (err) {
                // always return early for non validation errors
                if (!(0, $436abf1934e89390$export$2e2bcd8739ae039).isError(err)) return callback(err, value);
                if (endEarly) {
                    err.value = value;
                    return callback(err, value);
                }
                nestedErrors.push(err);
            }
            if (--count <= 0) {
                if (nestedErrors.length) {
                    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name
                    if (errors.length) nestedErrors.push(...errors);
                    errors = nestedErrors;
                }
                if (errors.length) {
                    callback(new (0, $436abf1934e89390$export$2e2bcd8739ae039)(errors, value, path), value);
                    return;
                }
                callback(null, value);
            }
        });
    }
}


var $b6f664cd9e1ba448$exports = {};
var $f50513f2ca42f446$exports = {};
var $3fd97c7f560ec5e5$exports = {};

var $3fd97c7f560ec5e5$var$defineProperty = function() {
    try {
        var func = $45c073923688f884$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$3fd97c7f560ec5e5$exports = $3fd97c7f560ec5e5$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $f50513f2ca42f446$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $3fd97c7f560ec5e5$exports) $3fd97c7f560ec5e5$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$f50513f2ca42f446$exports = $f50513f2ca42f446$var$baseAssignValue;


var $edb97d32e8dcec56$exports = {};
var $5119c96e221eb96c$exports = {};
var $74e70a6473b52f57$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $74e70a6473b52f57$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$74e70a6473b52f57$exports = $74e70a6473b52f57$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $5119c96e221eb96c$var$baseFor = $74e70a6473b52f57$exports();
$5119c96e221eb96c$exports = $5119c96e221eb96c$var$baseFor;


var $9a87f3ff62ea94fb$exports = {};
var $e0a95b40dee71b57$exports = {};
var $069c9c2e1b7d2d1e$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $069c9c2e1b7d2d1e$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$069c9c2e1b7d2d1e$exports = $069c9c2e1b7d2d1e$var$baseTimes;





var $a1BUX = parcelRequire("a1BUX");

var $bcd8a081503667d3$exports = {};
var $4df3d29100335a9a$exports = {};



/** `Object#toString` result references. */ var $4df3d29100335a9a$var$argsTag = '[object Arguments]', $4df3d29100335a9a$var$arrayTag = '[object Array]', $4df3d29100335a9a$var$boolTag = '[object Boolean]', $4df3d29100335a9a$var$dateTag = '[object Date]', $4df3d29100335a9a$var$errorTag = '[object Error]', $4df3d29100335a9a$var$funcTag = '[object Function]', $4df3d29100335a9a$var$mapTag = '[object Map]', $4df3d29100335a9a$var$numberTag = '[object Number]', $4df3d29100335a9a$var$objectTag = '[object Object]', $4df3d29100335a9a$var$regexpTag = '[object RegExp]', $4df3d29100335a9a$var$setTag = '[object Set]', $4df3d29100335a9a$var$stringTag = '[object String]', $4df3d29100335a9a$var$weakMapTag = '[object WeakMap]';
var $4df3d29100335a9a$var$arrayBufferTag = '[object ArrayBuffer]', $4df3d29100335a9a$var$dataViewTag = '[object DataView]', $4df3d29100335a9a$var$float32Tag = '[object Float32Array]', $4df3d29100335a9a$var$float64Tag = '[object Float64Array]', $4df3d29100335a9a$var$int8Tag = '[object Int8Array]', $4df3d29100335a9a$var$int16Tag = '[object Int16Array]', $4df3d29100335a9a$var$int32Tag = '[object Int32Array]', $4df3d29100335a9a$var$uint8Tag = '[object Uint8Array]', $4df3d29100335a9a$var$uint8ClampedTag = '[object Uint8ClampedArray]', $4df3d29100335a9a$var$uint16Tag = '[object Uint16Array]', $4df3d29100335a9a$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $4df3d29100335a9a$var$typedArrayTags = {};
$4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$float32Tag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$float64Tag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$int8Tag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$int16Tag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$int32Tag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$uint8Tag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$uint8ClampedTag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$uint16Tag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$uint32Tag] = true;
$4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$argsTag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$arrayTag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$arrayBufferTag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$boolTag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$dataViewTag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$dateTag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$errorTag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$funcTag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$mapTag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$numberTag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$objectTag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$regexpTag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$setTag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$stringTag] = $4df3d29100335a9a$var$typedArrayTags[$4df3d29100335a9a$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $4df3d29100335a9a$var$baseIsTypedArray(value) {
    return $2491d5b87f6f34f9$exports(value) && $fe64242c905a27a3$exports(value.length) && !!$4df3d29100335a9a$var$typedArrayTags[$b35c5a96e6a9987b$exports(value)];
}
$4df3d29100335a9a$exports = $4df3d29100335a9a$var$baseIsTypedArray;


var $db45b4386c3091ab$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $db45b4386c3091ab$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$db45b4386c3091ab$exports = $db45b4386c3091ab$var$baseUnary;



var $Etj01 = parcelRequire("Etj01");
/* Node.js helper references. */ var $bcd8a081503667d3$var$nodeIsTypedArray = $Etj01 && $Etj01.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $bcd8a081503667d3$var$isTypedArray = $bcd8a081503667d3$var$nodeIsTypedArray ? $db45b4386c3091ab$exports($bcd8a081503667d3$var$nodeIsTypedArray) : $4df3d29100335a9a$exports;
$bcd8a081503667d3$exports = $bcd8a081503667d3$var$isTypedArray;


/** Used for built-in method references. */ var $e0a95b40dee71b57$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e0a95b40dee71b57$var$hasOwnProperty = $e0a95b40dee71b57$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $e0a95b40dee71b57$var$arrayLikeKeys(value, inherited) {
    var isArr = $2a0fbf166027c360$exports(value), isArg = !isArr && $b825681d46d8740e$exports(value), isBuff = !isArr && !isArg && $a1BUX(value), isType = !isArr && !isArg && !isBuff && $bcd8a081503667d3$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $069c9c2e1b7d2d1e$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $e0a95b40dee71b57$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $34c6bc0f433a5029$exports(key, length)))) result.push(key);
    return result;
}
$e0a95b40dee71b57$exports = $e0a95b40dee71b57$var$arrayLikeKeys;


var $d88c7f81fbf2f391$exports = {};
var $b27431a634574c41$exports = {};
/** Used for built-in method references. */ var $b27431a634574c41$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $b27431a634574c41$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $b27431a634574c41$var$objectProto;
    return value === proto;
}
$b27431a634574c41$exports = $b27431a634574c41$var$isPrototype;


var $81a9116b9c83eb0c$exports = {};
var $ceb759ab72d88965$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ceb759ab72d88965$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$ceb759ab72d88965$exports = $ceb759ab72d88965$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $81a9116b9c83eb0c$var$nativeKeys = $ceb759ab72d88965$exports(Object.keys, Object);
$81a9116b9c83eb0c$exports = $81a9116b9c83eb0c$var$nativeKeys;


/** Used for built-in method references. */ var $d88c7f81fbf2f391$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d88c7f81fbf2f391$var$hasOwnProperty = $d88c7f81fbf2f391$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $d88c7f81fbf2f391$var$baseKeys(object) {
    if (!$b27431a634574c41$exports(object)) return $81a9116b9c83eb0c$exports(object);
    var result = [];
    for(var key in Object(object))if ($d88c7f81fbf2f391$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$d88c7f81fbf2f391$exports = $d88c7f81fbf2f391$var$baseKeys;


var $a50a26323cccf7ad$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $a50a26323cccf7ad$var$isArrayLike(value) {
    return value != null && $fe64242c905a27a3$exports(value.length) && !$42b6ba2ef8e23e96$exports(value);
}
$a50a26323cccf7ad$exports = $a50a26323cccf7ad$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $9a87f3ff62ea94fb$var$keys(object) {
    return $a50a26323cccf7ad$exports(object) ? $e0a95b40dee71b57$exports(object) : $d88c7f81fbf2f391$exports(object);
}
$9a87f3ff62ea94fb$exports = $9a87f3ff62ea94fb$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $edb97d32e8dcec56$var$baseForOwn(object, iteratee) {
    return object && $5119c96e221eb96c$exports(object, iteratee, $9a87f3ff62ea94fb$exports);
}
$edb97d32e8dcec56$exports = $edb97d32e8dcec56$var$baseForOwn;


var $30aaebbdaff8808f$exports = {};
var $853d053d79744c39$exports = {};
var $46f0d8f7e888a674$exports = {};
var $458be4e30e44f6b5$exports = {};

var $482512f7e4157923$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $482512f7e4157923$var$stackClear() {
    this.__data__ = new $545e3e1214f1ef3a$exports;
    this.size = 0;
}
$482512f7e4157923$exports = $482512f7e4157923$var$stackClear;


var $343ace9f5c000396$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $343ace9f5c000396$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$343ace9f5c000396$exports = $343ace9f5c000396$var$stackDelete;


var $4723be08661cf897$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4723be08661cf897$var$stackGet(key) {
    return this.__data__.get(key);
}
$4723be08661cf897$exports = $4723be08661cf897$var$stackGet;


var $a418839b98e9b99d$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a418839b98e9b99d$var$stackHas(key) {
    return this.__data__.has(key);
}
$a418839b98e9b99d$exports = $a418839b98e9b99d$var$stackHas;


var $517c1fd6da920e83$exports = {};



/** Used as the size to enable large array optimizations. */ var $517c1fd6da920e83$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $517c1fd6da920e83$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $545e3e1214f1ef3a$exports) {
        var pairs = data.__data__;
        if (!$c4bbeb9a8b68fcae$exports || pairs.length < $517c1fd6da920e83$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $4f2cc624e4624515$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$517c1fd6da920e83$exports = $517c1fd6da920e83$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $458be4e30e44f6b5$var$Stack(entries) {
    var data = this.__data__ = new $545e3e1214f1ef3a$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$458be4e30e44f6b5$var$Stack.prototype.clear = $482512f7e4157923$exports;
$458be4e30e44f6b5$var$Stack.prototype['delete'] = $343ace9f5c000396$exports;
$458be4e30e44f6b5$var$Stack.prototype.get = $4723be08661cf897$exports;
$458be4e30e44f6b5$var$Stack.prototype.has = $a418839b98e9b99d$exports;
$458be4e30e44f6b5$var$Stack.prototype.set = $517c1fd6da920e83$exports;
$458be4e30e44f6b5$exports = $458be4e30e44f6b5$var$Stack;


var $b22fde80644dd7ea$exports = {};
var $d36a5ea762b431a1$exports = {};

var $7d842d7f26a7a002$exports = {};
var $9906a04e63e6cc7b$exports = {};

var $ec55a48bde135544$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $ec55a48bde135544$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $ec55a48bde135544$var$setCacheAdd(value) {
    this.__data__.set(value, $ec55a48bde135544$var$HASH_UNDEFINED);
    return this;
}
$ec55a48bde135544$exports = $ec55a48bde135544$var$setCacheAdd;


var $db9b74665ca9ce2a$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $db9b74665ca9ce2a$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$db9b74665ca9ce2a$exports = $db9b74665ca9ce2a$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $9906a04e63e6cc7b$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $4f2cc624e4624515$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$9906a04e63e6cc7b$var$SetCache.prototype.add = $9906a04e63e6cc7b$var$SetCache.prototype.push = $ec55a48bde135544$exports;
$9906a04e63e6cc7b$var$SetCache.prototype.has = $db9b74665ca9ce2a$exports;
$9906a04e63e6cc7b$exports = $9906a04e63e6cc7b$var$SetCache;


var $d1753d90cd762c92$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $d1753d90cd762c92$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$d1753d90cd762c92$exports = $d1753d90cd762c92$var$arraySome;


var $b8c37a1b17c786ba$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b8c37a1b17c786ba$var$cacheHas(cache, key) {
    return cache.has(key);
}
$b8c37a1b17c786ba$exports = $b8c37a1b17c786ba$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $7d842d7f26a7a002$var$COMPARE_PARTIAL_FLAG = 1, $7d842d7f26a7a002$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $7d842d7f26a7a002$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $7d842d7f26a7a002$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $7d842d7f26a7a002$var$COMPARE_UNORDERED_FLAG ? new $9906a04e63e6cc7b$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$d1753d90cd762c92$exports(other, function(othValue, othIndex) {
                if (!$b8c37a1b17c786ba$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$7d842d7f26a7a002$exports = $7d842d7f26a7a002$var$equalArrays;


var $71eb887eaee6d894$exports = {};

var $e5099552f7860df1$exports = {};

var $8qdJN = parcelRequire("8qdJN");
/** Built-in value references. */ var $e5099552f7860df1$var$Uint8Array = $8qdJN.Uint8Array;
$e5099552f7860df1$exports = $e5099552f7860df1$var$Uint8Array;




var $48730dce2970ebb3$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $48730dce2970ebb3$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$48730dce2970ebb3$exports = $48730dce2970ebb3$var$mapToArray;


var $921ff93e5157c54b$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $921ff93e5157c54b$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$921ff93e5157c54b$exports = $921ff93e5157c54b$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $71eb887eaee6d894$var$COMPARE_PARTIAL_FLAG = 1, $71eb887eaee6d894$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $71eb887eaee6d894$var$boolTag = '[object Boolean]', $71eb887eaee6d894$var$dateTag = '[object Date]', $71eb887eaee6d894$var$errorTag = '[object Error]', $71eb887eaee6d894$var$mapTag = '[object Map]', $71eb887eaee6d894$var$numberTag = '[object Number]', $71eb887eaee6d894$var$regexpTag = '[object RegExp]', $71eb887eaee6d894$var$setTag = '[object Set]', $71eb887eaee6d894$var$stringTag = '[object String]', $71eb887eaee6d894$var$symbolTag = '[object Symbol]';
var $71eb887eaee6d894$var$arrayBufferTag = '[object ArrayBuffer]', $71eb887eaee6d894$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $71eb887eaee6d894$var$symbolProto = $57507d7d7570b777$exports ? $57507d7d7570b777$exports.prototype : undefined, $71eb887eaee6d894$var$symbolValueOf = $71eb887eaee6d894$var$symbolProto ? $71eb887eaee6d894$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $71eb887eaee6d894$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $71eb887eaee6d894$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $71eb887eaee6d894$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $e5099552f7860df1$exports(object), new $e5099552f7860df1$exports(other))) return false;
            return true;
        case $71eb887eaee6d894$var$boolTag:
        case $71eb887eaee6d894$var$dateTag:
        case $71eb887eaee6d894$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $bb5d7160ba902670$exports(+object, +other);
        case $71eb887eaee6d894$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $71eb887eaee6d894$var$regexpTag:
        case $71eb887eaee6d894$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $71eb887eaee6d894$var$mapTag:
            var convert = $48730dce2970ebb3$exports;
        case $71eb887eaee6d894$var$setTag:
            var isPartial = bitmask & $71eb887eaee6d894$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $921ff93e5157c54b$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $71eb887eaee6d894$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $7d842d7f26a7a002$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $71eb887eaee6d894$var$symbolTag:
            if ($71eb887eaee6d894$var$symbolValueOf) return $71eb887eaee6d894$var$symbolValueOf.call(object) == $71eb887eaee6d894$var$symbolValueOf.call(other);
    }
    return false;
}
$71eb887eaee6d894$exports = $71eb887eaee6d894$var$equalByTag;


var $94cf90b39bd394ce$exports = {};
var $ad88cc8579f89995$exports = {};
var $c48a2981800f40c6$exports = {};
var $b29d179f784da4ca$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $b29d179f784da4ca$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$b29d179f784da4ca$exports = $b29d179f784da4ca$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c48a2981800f40c6$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $2a0fbf166027c360$exports(object) ? result : $b29d179f784da4ca$exports(result, symbolsFunc(object));
}
$c48a2981800f40c6$exports = $c48a2981800f40c6$var$baseGetAllKeys;


var $c59b9f4107bbf907$exports = {};
var $f7c63bef6ced5a8e$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $f7c63bef6ced5a8e$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$f7c63bef6ced5a8e$exports = $f7c63bef6ced5a8e$var$arrayFilter;


var $0d5a99df1493d0e9$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $0d5a99df1493d0e9$var$stubArray() {
    return [];
}
$0d5a99df1493d0e9$exports = $0d5a99df1493d0e9$var$stubArray;


/** Used for built-in method references. */ var $c59b9f4107bbf907$var$objectProto = Object.prototype;
/** Built-in value references. */ var $c59b9f4107bbf907$var$propertyIsEnumerable = $c59b9f4107bbf907$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c59b9f4107bbf907$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $c59b9f4107bbf907$var$getSymbols = !$c59b9f4107bbf907$var$nativeGetSymbols ? $0d5a99df1493d0e9$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $f7c63bef6ced5a8e$exports($c59b9f4107bbf907$var$nativeGetSymbols(object), function(symbol) {
        return $c59b9f4107bbf907$var$propertyIsEnumerable.call(object, symbol);
    });
};
$c59b9f4107bbf907$exports = $c59b9f4107bbf907$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $ad88cc8579f89995$var$getAllKeys(object) {
    return $c48a2981800f40c6$exports(object, $9a87f3ff62ea94fb$exports, $c59b9f4107bbf907$exports);
}
$ad88cc8579f89995$exports = $ad88cc8579f89995$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $94cf90b39bd394ce$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $94cf90b39bd394ce$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $94cf90b39bd394ce$var$hasOwnProperty = $94cf90b39bd394ce$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $94cf90b39bd394ce$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $94cf90b39bd394ce$var$COMPARE_PARTIAL_FLAG, objProps = $ad88cc8579f89995$exports(object), objLength = objProps.length, othProps = $ad88cc8579f89995$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $94cf90b39bd394ce$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$94cf90b39bd394ce$exports = $94cf90b39bd394ce$var$equalObjects;


var $fd96f3e23fe5aefe$exports = {};
var $16cf41a643873818$exports = {};


var $8qdJN = parcelRequire("8qdJN");
/* Built-in method references that are verified to be native. */ var $16cf41a643873818$var$DataView = $45c073923688f884$exports($8qdJN, 'DataView');
$16cf41a643873818$exports = $16cf41a643873818$var$DataView;



var $c5fcd6487f181571$exports = {};


var $8qdJN = parcelRequire("8qdJN");
/* Built-in method references that are verified to be native. */ var $c5fcd6487f181571$var$Promise = $45c073923688f884$exports($8qdJN, 'Promise');
$c5fcd6487f181571$exports = $c5fcd6487f181571$var$Promise;


var $6f7778055cb19d80$exports = {};


var $8qdJN = parcelRequire("8qdJN");
/* Built-in method references that are verified to be native. */ var $6f7778055cb19d80$var$Set = $45c073923688f884$exports($8qdJN, 'Set');
$6f7778055cb19d80$exports = $6f7778055cb19d80$var$Set;


var $02053b94d4df3ecd$exports = {};


var $8qdJN = parcelRequire("8qdJN");
/* Built-in method references that are verified to be native. */ var $02053b94d4df3ecd$var$WeakMap = $45c073923688f884$exports($8qdJN, 'WeakMap');
$02053b94d4df3ecd$exports = $02053b94d4df3ecd$var$WeakMap;




/** `Object#toString` result references. */ var $fd96f3e23fe5aefe$var$mapTag = '[object Map]', $fd96f3e23fe5aefe$var$objectTag = '[object Object]', $fd96f3e23fe5aefe$var$promiseTag = '[object Promise]', $fd96f3e23fe5aefe$var$setTag = '[object Set]', $fd96f3e23fe5aefe$var$weakMapTag = '[object WeakMap]';
var $fd96f3e23fe5aefe$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $fd96f3e23fe5aefe$var$dataViewCtorString = $b38296444a19076e$exports($16cf41a643873818$exports), $fd96f3e23fe5aefe$var$mapCtorString = $b38296444a19076e$exports($c4bbeb9a8b68fcae$exports), $fd96f3e23fe5aefe$var$promiseCtorString = $b38296444a19076e$exports($c5fcd6487f181571$exports), $fd96f3e23fe5aefe$var$setCtorString = $b38296444a19076e$exports($6f7778055cb19d80$exports), $fd96f3e23fe5aefe$var$weakMapCtorString = $b38296444a19076e$exports($02053b94d4df3ecd$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $fd96f3e23fe5aefe$var$getTag = $b35c5a96e6a9987b$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($16cf41a643873818$exports && $fd96f3e23fe5aefe$var$getTag(new $16cf41a643873818$exports(new ArrayBuffer(1))) != $fd96f3e23fe5aefe$var$dataViewTag || $c4bbeb9a8b68fcae$exports && $fd96f3e23fe5aefe$var$getTag(new $c4bbeb9a8b68fcae$exports) != $fd96f3e23fe5aefe$var$mapTag || $c5fcd6487f181571$exports && $fd96f3e23fe5aefe$var$getTag($c5fcd6487f181571$exports.resolve()) != $fd96f3e23fe5aefe$var$promiseTag || $6f7778055cb19d80$exports && $fd96f3e23fe5aefe$var$getTag(new $6f7778055cb19d80$exports) != $fd96f3e23fe5aefe$var$setTag || $02053b94d4df3ecd$exports && $fd96f3e23fe5aefe$var$getTag(new $02053b94d4df3ecd$exports) != $fd96f3e23fe5aefe$var$weakMapTag) $fd96f3e23fe5aefe$var$getTag = function(value) {
    var result = $b35c5a96e6a9987b$exports(value), Ctor = result == $fd96f3e23fe5aefe$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $b38296444a19076e$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $fd96f3e23fe5aefe$var$dataViewCtorString:
            return $fd96f3e23fe5aefe$var$dataViewTag;
        case $fd96f3e23fe5aefe$var$mapCtorString:
            return $fd96f3e23fe5aefe$var$mapTag;
        case $fd96f3e23fe5aefe$var$promiseCtorString:
            return $fd96f3e23fe5aefe$var$promiseTag;
        case $fd96f3e23fe5aefe$var$setCtorString:
            return $fd96f3e23fe5aefe$var$setTag;
        case $fd96f3e23fe5aefe$var$weakMapCtorString:
            return $fd96f3e23fe5aefe$var$weakMapTag;
    }
    return result;
};
$fd96f3e23fe5aefe$exports = $fd96f3e23fe5aefe$var$getTag;




var $a1BUX = parcelRequire("a1BUX");

/** Used to compose bitmasks for value comparisons. */ var $d36a5ea762b431a1$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $d36a5ea762b431a1$var$argsTag = '[object Arguments]', $d36a5ea762b431a1$var$arrayTag = '[object Array]', $d36a5ea762b431a1$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $d36a5ea762b431a1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d36a5ea762b431a1$var$hasOwnProperty = $d36a5ea762b431a1$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $d36a5ea762b431a1$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $2a0fbf166027c360$exports(object), othIsArr = $2a0fbf166027c360$exports(other), objTag = objIsArr ? $d36a5ea762b431a1$var$arrayTag : $fd96f3e23fe5aefe$exports(object), othTag = othIsArr ? $d36a5ea762b431a1$var$arrayTag : $fd96f3e23fe5aefe$exports(other);
    objTag = objTag == $d36a5ea762b431a1$var$argsTag ? $d36a5ea762b431a1$var$objectTag : objTag;
    othTag = othTag == $d36a5ea762b431a1$var$argsTag ? $d36a5ea762b431a1$var$objectTag : othTag;
    var objIsObj = objTag == $d36a5ea762b431a1$var$objectTag, othIsObj = othTag == $d36a5ea762b431a1$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $a1BUX(object)) {
        if (!$a1BUX(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $458be4e30e44f6b5$exports);
        return objIsArr || $bcd8a081503667d3$exports(object) ? $7d842d7f26a7a002$exports(object, other, bitmask, customizer, equalFunc, stack) : $71eb887eaee6d894$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $d36a5ea762b431a1$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $d36a5ea762b431a1$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $d36a5ea762b431a1$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $458be4e30e44f6b5$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $458be4e30e44f6b5$exports);
    return $94cf90b39bd394ce$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$d36a5ea762b431a1$exports = $d36a5ea762b431a1$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $b22fde80644dd7ea$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$2491d5b87f6f34f9$exports(value) && !$2491d5b87f6f34f9$exports(other)) return value !== value && other !== other;
    return $d36a5ea762b431a1$exports(value, other, bitmask, customizer, $b22fde80644dd7ea$var$baseIsEqual, stack);
}
$b22fde80644dd7ea$exports = $b22fde80644dd7ea$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $46f0d8f7e888a674$var$COMPARE_PARTIAL_FLAG = 1, $46f0d8f7e888a674$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $46f0d8f7e888a674$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $458be4e30e44f6b5$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $b22fde80644dd7ea$exports(srcValue, objValue, $46f0d8f7e888a674$var$COMPARE_PARTIAL_FLAG | $46f0d8f7e888a674$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$46f0d8f7e888a674$exports = $46f0d8f7e888a674$var$baseIsMatch;


var $fab4bd3ac63366a9$exports = {};
var $e870bf63f450f50c$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $e870bf63f450f50c$var$isStrictComparable(value) {
    return value === value && !$de338c730ce7636d$exports(value);
}
$e870bf63f450f50c$exports = $e870bf63f450f50c$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $fab4bd3ac63366a9$var$getMatchData(object) {
    var result = $9a87f3ff62ea94fb$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $e870bf63f450f50c$exports(value)
        ];
    }
    return result;
}
$fab4bd3ac63366a9$exports = $fab4bd3ac63366a9$var$getMatchData;


var $8916f28765fb020d$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $8916f28765fb020d$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$8916f28765fb020d$exports = $8916f28765fb020d$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $853d053d79744c39$var$baseMatches(source) {
    var matchData = $fab4bd3ac63366a9$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $8916f28765fb020d$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $46f0d8f7e888a674$exports(object, source, matchData);
    };
}
$853d053d79744c39$exports = $853d053d79744c39$var$baseMatches;


var $2f17e7d76ac5128e$exports = {};

var $89a36c2cd9990c5e$exports = {};
var $74ba91727cb9fd63$exports = {};


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $74ba91727cb9fd63$var$baseGet(object, path) {
    path = $01b5d0091863e8cd$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$f1862dc5b8aedcb3$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$74ba91727cb9fd63$exports = $74ba91727cb9fd63$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $89a36c2cd9990c5e$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $74ba91727cb9fd63$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$89a36c2cd9990c5e$exports = $89a36c2cd9990c5e$var$get;


var $025dad205539b252$exports = {};
var $856317ccbf15c138$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $856317ccbf15c138$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$856317ccbf15c138$exports = $856317ccbf15c138$var$baseHasIn;



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $025dad205539b252$var$hasIn(object, path) {
    return object != null && $62505984236a9ccf$exports(object, path, $856317ccbf15c138$exports);
}
$025dad205539b252$exports = $025dad205539b252$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $2f17e7d76ac5128e$var$COMPARE_PARTIAL_FLAG = 1, $2f17e7d76ac5128e$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $2f17e7d76ac5128e$var$baseMatchesProperty(path, srcValue) {
    if ($32f1917baeda9885$exports(path) && $e870bf63f450f50c$exports(srcValue)) return $8916f28765fb020d$exports($f1862dc5b8aedcb3$exports(path), srcValue);
    return function(object) {
        var objValue = $89a36c2cd9990c5e$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $025dad205539b252$exports(object, path) : $b22fde80644dd7ea$exports(srcValue, objValue, $2f17e7d76ac5128e$var$COMPARE_PARTIAL_FLAG | $2f17e7d76ac5128e$var$COMPARE_UNORDERED_FLAG);
    };
}
$2f17e7d76ac5128e$exports = $2f17e7d76ac5128e$var$baseMatchesProperty;


var $1b0ac323385ce009$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $1b0ac323385ce009$var$identity(value) {
    return value;
}
$1b0ac323385ce009$exports = $1b0ac323385ce009$var$identity;



var $5439d691b30440ab$exports = {};
var $c5331019695748c7$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $c5331019695748c7$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$c5331019695748c7$exports = $c5331019695748c7$var$baseProperty;


var $c6797166edda0087$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $c6797166edda0087$var$basePropertyDeep(path) {
    return function(object) {
        return $74ba91727cb9fd63$exports(object, path);
    };
}
$c6797166edda0087$exports = $c6797166edda0087$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $5439d691b30440ab$var$property(path) {
    return $32f1917baeda9885$exports(path) ? $c5331019695748c7$exports($f1862dc5b8aedcb3$exports(path)) : $c6797166edda0087$exports(path);
}
$5439d691b30440ab$exports = $5439d691b30440ab$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $30aaebbdaff8808f$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $1b0ac323385ce009$exports;
    if (typeof value == 'object') return $2a0fbf166027c360$exports(value) ? $2f17e7d76ac5128e$exports(value[0], value[1]) : $853d053d79744c39$exports(value);
    return $5439d691b30440ab$exports(value);
}
$30aaebbdaff8808f$exports = $30aaebbdaff8808f$var$baseIteratee;


/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $b6f664cd9e1ba448$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $30aaebbdaff8808f$exports(iteratee, 3);
    $edb97d32e8dcec56$exports(object, function(value, key, object) {
        $f50513f2ca42f446$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$b6f664cd9e1ba448$exports = $b6f664cd9e1ba448$var$mapValues;



var $410374687b1da032$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $410374687b1da032$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$410374687b1da032$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$410374687b1da032$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$410374687b1da032$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $410374687b1da032$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $410374687b1da032$var$DIGIT_REGEX = /^\d+$/, $410374687b1da032$var$LEAD_DIGIT_REGEX = /^\d/, $410374687b1da032$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $410374687b1da032$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $410374687b1da032$var$MAX_CACHE_SIZE = 512;
var $410374687b1da032$var$pathCache = new $410374687b1da032$var$Cache($410374687b1da032$var$MAX_CACHE_SIZE), $410374687b1da032$var$setCache = new $410374687b1da032$var$Cache($410374687b1da032$var$MAX_CACHE_SIZE), $410374687b1da032$var$getCache = new $410374687b1da032$var$Cache($410374687b1da032$var$MAX_CACHE_SIZE);
var $410374687b1da032$var$config;
$410374687b1da032$exports = {
    Cache: $410374687b1da032$var$Cache,
    split: $410374687b1da032$var$split,
    normalizePath: $410374687b1da032$var$normalizePath,
    setter: function(path) {
        var parts = $410374687b1da032$var$normalizePath(path);
        return $410374687b1da032$var$setCache.get(path) || $410374687b1da032$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $410374687b1da032$var$normalizePath(path);
        return $410374687b1da032$var$getCache.get(path) || $410374687b1da032$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($410374687b1da032$var$isQuoted(part) || $410374687b1da032$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $410374687b1da032$var$forEach(Array.isArray(path) ? path : $410374687b1da032$var$split(path), cb, thisArg);
    }
};
function $410374687b1da032$var$normalizePath(path) {
    return $410374687b1da032$var$pathCache.get(path) || $410374687b1da032$var$pathCache.set(path, $410374687b1da032$var$split(path).map(function(part) {
        return part.replace($410374687b1da032$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $410374687b1da032$var$split(path) {
    return path.match($410374687b1da032$var$SPLIT_REGEX) || [
        ''
    ];
}
function $410374687b1da032$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($410374687b1da032$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $410374687b1da032$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $410374687b1da032$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $410374687b1da032$var$hasLeadingNumber(part) {
    return part.match($410374687b1da032$var$LEAD_DIGIT_REGEX) && !part.match($410374687b1da032$var$DIGIT_REGEX);
}
function $410374687b1da032$var$hasSpecialChars(part) {
    return $410374687b1da032$var$SPEC_CHAR_REGEX.test(part);
}
function $410374687b1da032$var$shouldBeQuoted(part) {
    return !$410374687b1da032$var$isQuoted(part) && ($410374687b1da032$var$hasLeadingNumber(part) || $410374687b1da032$var$hasSpecialChars(part));
}


const $a30d53bf69a44d9d$var$prefixes = {
    context: '$',
    value: '.'
};
function $a30d53bf69a44d9d$export$185802fd694ee1f5(key, options) {
    return new $a30d53bf69a44d9d$export$2e2bcd8739ae039(key, options);
}
class $a30d53bf69a44d9d$export$2e2bcd8739ae039 {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $a30d53bf69a44d9d$var$prefixes.context;
        this.isValue = this.key[0] === $a30d53bf69a44d9d$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $a30d53bf69a44d9d$var$prefixes.context : this.isValue ? $a30d53bf69a44d9d$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $410374687b1da032$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
} // @ts-ignore
$a30d53bf69a44d9d$export$2e2bcd8739ae039.prototype.__isYupRef = true;


function $77ade06455e620b6$var$_extends() {
    $77ade06455e620b6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $77ade06455e620b6$var$_extends.apply(this, arguments);
}
function $77ade06455e620b6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $77ade06455e620b6$export$2e2bcd8739ae039(config) {
    function validate(_ref, cb) {
        let { value: value, path: path = '', label: label, options: options, originalValue: originalValue, sync: sync } = _ref, rest = $77ade06455e620b6$var$_objectWithoutPropertiesLoose(_ref, [
            "value",
            "path",
            "label",
            "options",
            "originalValue",
            "sync"
        ]);
        const { name: name, test: test, params: params, message: message } = config;
        let { parent: parent, context: context } = options;
        function resolve(item) {
            return (0, $a30d53bf69a44d9d$export$2e2bcd8739ae039).isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = (0, (/*@__PURE__*/$parcel$interopDefault($b6f664cd9e1ba448$exports)))($77ade06455e620b6$var$_extends({
                value: value,
                originalValue: originalValue,
                label: label,
                path: overrides.path || path
            }, params, overrides.params), resolve);
            const error = new (0, $436abf1934e89390$export$2e2bcd8739ae039)((0, $436abf1934e89390$export$2e2bcd8739ae039).formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
            error.params = nextParams;
            return error;
        }
        let ctx = $77ade06455e620b6$var$_extends({
            path: path,
            parent: parent,
            type: name,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue
        }, rest);
        if (!sync) {
            try {
                Promise.resolve(test.call(ctx, value, ctx)).then((validOrError)=>{
                    if ((0, $436abf1934e89390$export$2e2bcd8739ae039).isError(validOrError)) cb(validOrError);
                    else if (!validOrError) cb(createError());
                    else cb(null, validOrError);
                }).catch(cb);
            } catch (err) {
                cb(err);
            }
            return;
        }
        let result;
        try {
            var _ref2;
            result = test.call(ctx, value, ctx);
            if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        } catch (err) {
            cb(err);
            return;
        }
        if ((0, $436abf1934e89390$export$2e2bcd8739ae039).isError(result)) cb(result);
        else if (!result) cb(createError());
        else cb(null, result);
    }
    validate.OPTIONS = config;
    return validate;
}





let $2a35dd17de749f44$var$trim = (part)=>part.substr(0, part.length - 1).substr(1);
function $2a35dd17de749f44$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug; // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $410374687b1da032$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? $2a35dd17de749f44$var$trim(_part) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        if (schema.innerType) {
            let idx = isArray ? parseInt(part, 10) : 0;
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = schema.innerType;
        } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
const $2a35dd17de749f44$var$reach = (obj, path, value, context)=>$2a35dd17de749f44$export$c52e5867d5879e24(obj, path, value, context).schema;
var $2a35dd17de749f44$export$2e2bcd8739ae039 = $2a35dd17de749f44$var$reach;




class $c22e5cd03bcb90ef$export$2e2bcd8739ae039 {
    constructor(){
        this.list = void 0;
        this.refs = void 0;
        this.list = new Set();
        this.refs = new Map();
    }
    get size() {
        return this.list.size + this.refs.size;
    }
    describe() {
        const description = [];
        for (const item of this.list)description.push(item);
        for (const [, ref] of this.refs)description.push(ref.describe());
        return description;
    }
    toArray() {
        return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
    resolveAll(resolve) {
        return this.toArray().reduce((acc, e)=>acc.concat((0, $a30d53bf69a44d9d$export$2e2bcd8739ae039).isRef(e) ? resolve(e) : e), []);
    }
    add(value) {
        (0, $a30d53bf69a44d9d$export$2e2bcd8739ae039).isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
    delete(value) {
        (0, $a30d53bf69a44d9d$export$2e2bcd8739ae039).isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
    clone() {
        const next = new $c22e5cd03bcb90ef$export$2e2bcd8739ae039();
        next.list = new Set(this.list);
        next.refs = new Map(this.refs);
        return next;
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.list.forEach((value)=>next.add(value));
        newItems.refs.forEach((value)=>next.add(value));
        removeItems.list.forEach((value)=>next.delete(value));
        removeItems.refs.forEach((value)=>next.delete(value));
        return next;
    }
}



function $37ab42079f247083$var$_extends() {
    $37ab42079f247083$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $37ab42079f247083$var$_extends.apply(this, arguments);
}
class $37ab42079f247083$export$2e2bcd8739ae039 {
    constructor(options){
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this._typeError = void 0;
        this._whitelist = new (0, $c22e5cd03bcb90ef$export$2e2bcd8739ae039)();
        this._blacklist = new (0, $c22e5cd03bcb90ef$export$2e2bcd8739ae039)();
        this.exclusiveTests = Object.create(null);
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError((0, $29e8e7a2eb806720$export$9b30b6294c1449a8).notType);
        });
        this.type = (options == null ? void 0 : options.type) || 'mixed';
        this.spec = $37ab42079f247083$var$_extends({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            nullable: false,
            presence: 'optional'
        }, options == null ? void 0 : options.spec);
    }
    get _type() {
        return this.type;
    }
    _typeCheck(_value) {
        return true;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        } // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeError = this._typeError;
        next._whitelistError = this._whitelistError;
        next._blacklistError = this._blacklistError;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.exclusiveTests = $37ab42079f247083$var$_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = (0, $346f9e710560eb2a$export$2e2bcd8739ae039)($37ab42079f247083$var$_extends({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = $37ab42079f247083$var$_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
        //   mergedSpec.nullable = base.spec.nullable;
        // if (combined.spec.presence === UNSET)
        //   mergedSpec.presence = base.spec.presence;
        combined.spec = mergedSpec;
        combined._typeError || (combined._typeError = base._typeError);
        combined._whitelistError || (combined._whitelistError = base._whitelistError);
        combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (this.spec.nullable && v === null) return true;
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((schema, condition)=>condition.resolve(schema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve($37ab42079f247083$var$_extends({
            value: value
        }, options));
        let result = resolvedSchema._cast(value, options);
        if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
            let formattedValue = (0, $6e275c2ea1928bcc$export$2e2bcd8739ae039)(value);
            let formattedResult = (0, $6e275c2ea1928bcc$export$2e2bcd8739ae039)(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, _options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn)=>fn.call(this, value, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault();
        return value;
    }
    _validate(_value, options = {}, cb) {
        let { sync: sync, path: path, from: from = [], originalValue: originalValue = _value, strict: strict = this.spec.strict, abortEarly: abortEarly = this.spec.abortEarly } = options;
        let value = _value;
        if (!strict) // this._validating = true;
        value = this._cast(value, $37ab42079f247083$var$_extends({
            assert: false
        }, options)); // this._validating = false;
         // value is cast, we can check if it meets type requirements
        let args = {
            value: value,
            path: path,
            options: options,
            originalValue: originalValue,
            schema: this,
            label: this.spec.label,
            sync: sync,
            from: from
        };
        let initialTests = [];
        if (this._typeError) initialTests.push(this._typeError);
        let finalTests = [];
        if (this._whitelistError) finalTests.push(this._whitelistError);
        if (this._blacklistError) finalTests.push(this._blacklistError);
        (0, $65dc7f44eb17b152$export$2e2bcd8739ae039)({
            args: args,
            value: value,
            path: path,
            sync: sync,
            tests: initialTests,
            endEarly: abortEarly
        }, (err)=>{
            if (err) return void cb(err, value);
            (0, $65dc7f44eb17b152$export$2e2bcd8739ae039)({
                tests: this.tests.concat(finalTests),
                args: args,
                path: path,
                sync: sync,
                value: value,
                endEarly: abortEarly
            }, cb);
        });
    }
    validate(value, options, maybeCb) {
        let schema = this.resolve($37ab42079f247083$var$_extends({}, options, {
            value: value
        })); // callback case is for nested validations
        return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject)=>schema._validate(value, options, (err, value)=>{
                if (err) reject(err);
                else resolve(value);
            }));
    }
    validateSync(value, options) {
        let schema = this.resolve($37ab42079f247083$var$_extends({}, options, {
            value: value
        }));
        let result;
        schema._validate(value, $37ab42079f247083$var$_extends({}, options, {
            sync: true
        }), (err, value)=>{
            if (err) throw err;
            result = value;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ((0, $436abf1934e89390$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ((0, $436abf1934e89390$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        }
    }
    _getDefault() {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, $346f9e710560eb2a$export$2e2bcd8739ae039)(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault();
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        let next = this.clone();
        next.spec.strict = isStrict;
        return next;
    }
    _isPresent(value) {
        return value != null;
    }
    defined(message = (0, $29e8e7a2eb806720$export$9b30b6294c1449a8).defined) {
        return this.test({
            message: message,
            name: 'defined',
            exclusive: true,
            test (value) {
                return value !== undefined;
            }
        });
    }
    required(message = (0, $29e8e7a2eb806720$export$9b30b6294c1449a8).required) {
        return this.clone({
            presence: 'required'
        }).withMutation((s)=>s.test({
                message: message,
                name: 'required',
                exclusive: true,
                test (value) {
                    return this.schema._isPresent(value);
                }
            }));
    }
    notRequired() {
        let next = this.clone({
            presence: 'optional'
        });
        next.tests = next.tests.filter((test)=>test.OPTIONS.name !== 'required');
        return next;
    }
    nullable(isNullable = true) {
        let next = this.clone({
            nullable: isNullable !== false
        });
        return next;
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = (0, $29e8e7a2eb806720$export$9b30b6294c1449a8).default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = (0, $77ade06455e620b6$export$2e2bcd8739ae039)(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = (0, $3f226c5fc6e3a1e8$export$2e2bcd8739ae039)(keys).map((key)=>new (0, $a30d53bf69a44d9d$export$2e2bcd8739ae039)(key));
        deps.forEach((dep)=>{
            // @ts-ignore
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(new (0, $db981fe59e3c8136$export$2e2bcd8739ae039)(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next._typeError = (0, $77ade06455e620b6$export$2e2bcd8739ae039)({
            message: message,
            name: 'typeError',
            test (value) {
                if (value !== undefined && !this.schema.isType(value)) return this.createError({
                    params: {
                        type: this.schema._type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = (0, $29e8e7a2eb806720$export$9b30b6294c1449a8).oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next._whitelistError = (0, $77ade06455e620b6$export$2e2bcd8739ae039)({
            message: message,
            name: 'oneOf',
            test (value) {
                if (value === undefined) return true;
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: valids.toArray().join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = (0, $29e8e7a2eb806720$export$9b30b6294c1449a8).notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next._blacklistError = (0, $77ade06455e620b6$export$2e2bcd8739ae039)({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: invalids.toArray().join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    describe() {
        const next = this.clone();
        const { label: label, meta: meta } = next.spec;
        const description = {
            meta: meta,
            label: label,
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-expect-error
$37ab42079f247083$export$2e2bcd8739ae039.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$37ab42079f247083$export$2e2bcd8739ae039.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = (0, $2a35dd17de749f44$export$c52e5867d5879e24)(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], $37ab42079f247083$var$_extends({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$37ab42079f247083$export$2e2bcd8739ae039.prototype[alias] = $37ab42079f247083$export$2e2bcd8739ae039.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$37ab42079f247083$export$2e2bcd8739ae039.prototype[alias] = $37ab42079f247083$export$2e2bcd8739ae039.prototype.notOneOf;
$37ab42079f247083$export$2e2bcd8739ae039.prototype.optional = $37ab42079f247083$export$2e2bcd8739ae039.prototype.notRequired;


const $8bd36ef6ffb4ab48$var$Mixed = (0, $37ab42079f247083$export$2e2bcd8739ae039);
var $8bd36ef6ffb4ab48$export$2e2bcd8739ae039 = $8bd36ef6ffb4ab48$var$Mixed;
function $8bd36ef6ffb4ab48$export$185802fd694ee1f5() {
    return new $8bd36ef6ffb4ab48$var$Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class
$8bd36ef6ffb4ab48$export$185802fd694ee1f5.prototype = $8bd36ef6ffb4ab48$var$Mixed.prototype;




const $a192f827c26e21b2$var$isAbsent = (value)=>value == null;
var $a192f827c26e21b2$export$2e2bcd8739ae039 = $a192f827c26e21b2$var$isAbsent;


function $fb77e000a80648d3$export$185802fd694ee1f5() {
    return new $fb77e000a80648d3$export$2e2bcd8739ae039();
}
class $fb77e000a80648d3$export$2e2bcd8739ae039 extends (0, $37ab42079f247083$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'boolean'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (!this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    _typeCheck(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === 'boolean';
    }
    isTrue(message = (0, $29e8e7a2eb806720$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return (0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value === true;
            }
        });
    }
    isFalse(message = (0, $29e8e7a2eb806720$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return (0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value === false;
            }
        });
    }
}
$fb77e000a80648d3$export$185802fd694ee1f5.prototype = $fb77e000a80648d3$export$2e2bcd8739ae039.prototype;





let $2746dd37f1d91ea1$var$rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line
let $2746dd37f1d91ea1$var$rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line
let $2746dd37f1d91ea1$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $2746dd37f1d91ea1$var$isTrimmed = (value)=>(0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value === value.trim();
let $2746dd37f1d91ea1$var$objStringTag = ({}).toString();
function $2746dd37f1d91ea1$export$185802fd694ee1f5() {
    return new $2746dd37f1d91ea1$export$2e2bcd8739ae039();
}
class $2746dd37f1d91ea1$export$2e2bcd8739ae039 extends (0, $37ab42079f247083$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'string'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                if (strValue === $2746dd37f1d91ea1$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === 'string';
    }
    _isPresent(value) {
        return super._isPresent(value) && !!value.length;
    }
    length(length, message = (0, $29e8e7a2eb806720$export$22b082955e083ec3).length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message = (0, $29e8e7a2eb806720$export$22b082955e083ec3).min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $29e8e7a2eb806720$export$22b082955e083ec3).max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            test (value) {
                return (0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || (0, $29e8e7a2eb806720$export$22b082955e083ec3).matches,
            params: {
                regex: regex
            },
            test: (value)=>(0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = (0, $29e8e7a2eb806720$export$22b082955e083ec3).email) {
        return this.matches($2746dd37f1d91ea1$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = (0, $29e8e7a2eb806720$export$22b082955e083ec3).url) {
        return this.matches($2746dd37f1d91ea1$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = (0, $29e8e7a2eb806720$export$22b082955e083ec3).uuid) {
        return this.matches($2746dd37f1d91ea1$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = (0, $29e8e7a2eb806720$export$22b082955e083ec3).trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $2746dd37f1d91ea1$var$isTrimmed
        });
    }
    lowercase(message = (0, $29e8e7a2eb806720$export$22b082955e083ec3).lowercase) {
        return this.transform((value)=>!(0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: (value)=>(0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = (0, $29e8e7a2eb806720$export$22b082955e083ec3).uppercase) {
        return this.transform((value)=>!(0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: (value)=>(0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value === value.toUpperCase()
        });
    }
}
$2746dd37f1d91ea1$export$185802fd694ee1f5.prototype = $2746dd37f1d91ea1$export$2e2bcd8739ae039.prototype; //
 // String Interfaces
 //





let $4b40952b17040dfe$var$isNaN = (value)=>value != +value;
function $4b40952b17040dfe$export$185802fd694ee1f5() {
    return new $4b40952b17040dfe$export$2e2bcd8739ae039();
}
class $4b40952b17040dfe$export$2e2bcd8739ae039 extends (0, $37ab42079f247083$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'number'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                if (this.isType(parsed)) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === 'number' && !$4b40952b17040dfe$var$isNaN(value);
    }
    min(min, message = (0, $29e8e7a2eb806720$export$98e628dec113755e).min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $29e8e7a2eb806720$export$98e628dec113755e).max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = (0, $29e8e7a2eb806720$export$98e628dec113755e).lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            test (value) {
                return (0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = (0, $29e8e7a2eb806720$export$98e628dec113755e).moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            test (value) {
                return (0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value > this.resolve(more);
            }
        });
    }
    positive(msg = (0, $29e8e7a2eb806720$export$98e628dec113755e).positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = (0, $29e8e7a2eb806720$export$98e628dec113755e).negative) {
        return this.lessThan(0, msg);
    }
    integer(message = (0, $29e8e7a2eb806720$export$98e628dec113755e).integer) {
        return this.test({
            name: 'integer',
            message: message,
            test: (val)=>(0, $a192f827c26e21b2$export$2e2bcd8739ae039)(val) || Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!(0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!(0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) ? Math[method](value) : value);
    }
}
$4b40952b17040dfe$export$185802fd694ee1f5.prototype = $4b40952b17040dfe$export$2e2bcd8739ae039.prototype; //
 // Number Interfaces
 //


// @ts-ignore
/* eslint-disable */ /**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var $8fe12752480b0512$var$isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $8fe12752480b0512$export$2e2bcd8739ae039(date) {
    var numericKeys = [
        1,
        4,
        5,
        6,
        7,
        10,
        11
    ], minutesOffset = 0, timestamp, struct;
    if (struct = $8fe12752480b0512$var$isoReg.exec(date)) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for(var i = 0, k; k = numericKeys[i]; ++i)struct[k] = +struct[k] || 0; // allow undefined days and months
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds
        struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time
        if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        else {
            if (struct[8] !== 'Z' && struct[9] !== undefined) {
                minutesOffset = struct[10] * 60 + struct[11];
                if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
            }
            timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
        }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;
    return timestamp;
}






let $b2e6c69aab0808b6$var$invalidDate = new Date('');
let $b2e6c69aab0808b6$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $b2e6c69aab0808b6$export$185802fd694ee1f5() {
    return new $b2e6c69aab0808b6$export$2e2bcd8739ae039();
}
class $b2e6c69aab0808b6$export$2e2bcd8739ae039 extends (0, $37ab42079f247083$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'date'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                value = (0, $8fe12752480b0512$export$2e2bcd8739ae039)(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $b2e6c69aab0808b6$var$invalidDate;
            });
        });
    }
    _typeCheck(v) {
        return $b2e6c69aab0808b6$var$isDate(v) && !isNaN(v.getTime());
    }
    prepareParam(ref, name) {
        let param;
        if (!(0, $a30d53bf69a44d9d$export$2e2bcd8739ae039).isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = (0, $29e8e7a2eb806720$export$324d90190a8b822a).min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value >= this.resolve(limit);
            }
        });
    }
    max(max, message = (0, $29e8e7a2eb806720$export$324d90190a8b822a).max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value <= this.resolve(limit);
            }
        });
    }
}
$b2e6c69aab0808b6$export$2e2bcd8739ae039.INVALID_DATE = $b2e6c69aab0808b6$var$invalidDate;
$b2e6c69aab0808b6$export$185802fd694ee1f5.prototype = $b2e6c69aab0808b6$export$2e2bcd8739ae039.prototype;
$b2e6c69aab0808b6$export$185802fd694ee1f5.INVALID_DATE = $b2e6c69aab0808b6$var$invalidDate;



var $24ee46190a27cc85$exports = {};
var $98e1234e2fd80890$exports = {};
var $b02c1369c4aea724$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $b02c1369c4aea724$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$b02c1369c4aea724$exports = $b02c1369c4aea724$var$arrayReduce;


var $b8e2f9c7cf4a6b5f$exports = {};
var $efb0101d606b9ccb$exports = {};
var $30135c3a7a34c825$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $30135c3a7a34c825$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$30135c3a7a34c825$exports = $30135c3a7a34c825$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $efb0101d606b9ccb$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $efb0101d606b9ccb$var$deburrLetter = $30135c3a7a34c825$exports($efb0101d606b9ccb$var$deburredLetters);
$efb0101d606b9ccb$exports = $efb0101d606b9ccb$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $b8e2f9c7cf4a6b5f$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $b8e2f9c7cf4a6b5f$var$rsComboMarksRange = '\\u0300-\\u036f', $b8e2f9c7cf4a6b5f$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $b8e2f9c7cf4a6b5f$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $b8e2f9c7cf4a6b5f$var$rsComboRange = $b8e2f9c7cf4a6b5f$var$rsComboMarksRange + $b8e2f9c7cf4a6b5f$var$reComboHalfMarksRange + $b8e2f9c7cf4a6b5f$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $b8e2f9c7cf4a6b5f$var$rsCombo = '[' + $b8e2f9c7cf4a6b5f$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $b8e2f9c7cf4a6b5f$var$reComboMark = RegExp($b8e2f9c7cf4a6b5f$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $b8e2f9c7cf4a6b5f$var$deburr(string) {
    string = $d9b09c9b2e860fe7$exports(string);
    return string && string.replace($b8e2f9c7cf4a6b5f$var$reLatin, $efb0101d606b9ccb$exports).replace($b8e2f9c7cf4a6b5f$var$reComboMark, '');
}
$b8e2f9c7cf4a6b5f$exports = $b8e2f9c7cf4a6b5f$var$deburr;


var $c1745544bd02927e$exports = {};
var $2fad5819a0ae99b3$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $2fad5819a0ae99b3$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $2fad5819a0ae99b3$var$asciiWords(string) {
    return string.match($2fad5819a0ae99b3$var$reAsciiWord) || [];
}
$2fad5819a0ae99b3$exports = $2fad5819a0ae99b3$var$asciiWords;


var $d3e3c245d711415e$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $d3e3c245d711415e$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $d3e3c245d711415e$var$hasUnicodeWord(string) {
    return $d3e3c245d711415e$var$reHasUnicodeWord.test(string);
}
$d3e3c245d711415e$exports = $d3e3c245d711415e$var$hasUnicodeWord;



var $ba60837ce5a48062$exports = {};
/** Used to compose unicode character classes. */ var $ba60837ce5a48062$var$rsAstralRange = '\\ud800-\\udfff', $ba60837ce5a48062$var$rsComboMarksRange = '\\u0300-\\u036f', $ba60837ce5a48062$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ba60837ce5a48062$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ba60837ce5a48062$var$rsComboRange = $ba60837ce5a48062$var$rsComboMarksRange + $ba60837ce5a48062$var$reComboHalfMarksRange + $ba60837ce5a48062$var$rsComboSymbolsRange, $ba60837ce5a48062$var$rsDingbatRange = '\\u2700-\\u27bf', $ba60837ce5a48062$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $ba60837ce5a48062$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $ba60837ce5a48062$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $ba60837ce5a48062$var$rsPunctuationRange = '\\u2000-\\u206f', $ba60837ce5a48062$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $ba60837ce5a48062$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $ba60837ce5a48062$var$rsVarRange = '\\ufe0e\\ufe0f', $ba60837ce5a48062$var$rsBreakRange = $ba60837ce5a48062$var$rsMathOpRange + $ba60837ce5a48062$var$rsNonCharRange + $ba60837ce5a48062$var$rsPunctuationRange + $ba60837ce5a48062$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $ba60837ce5a48062$var$rsApos = "['\u2019]", $ba60837ce5a48062$var$rsBreak = '[' + $ba60837ce5a48062$var$rsBreakRange + ']', $ba60837ce5a48062$var$rsCombo = '[' + $ba60837ce5a48062$var$rsComboRange + ']', $ba60837ce5a48062$var$rsDigits = '\\d+', $ba60837ce5a48062$var$rsDingbat = '[' + $ba60837ce5a48062$var$rsDingbatRange + ']', $ba60837ce5a48062$var$rsLower = '[' + $ba60837ce5a48062$var$rsLowerRange + ']', $ba60837ce5a48062$var$rsMisc = '[^' + $ba60837ce5a48062$var$rsAstralRange + $ba60837ce5a48062$var$rsBreakRange + $ba60837ce5a48062$var$rsDigits + $ba60837ce5a48062$var$rsDingbatRange + $ba60837ce5a48062$var$rsLowerRange + $ba60837ce5a48062$var$rsUpperRange + ']', $ba60837ce5a48062$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $ba60837ce5a48062$var$rsModifier = '(?:' + $ba60837ce5a48062$var$rsCombo + '|' + $ba60837ce5a48062$var$rsFitz + ')', $ba60837ce5a48062$var$rsNonAstral = '[^' + $ba60837ce5a48062$var$rsAstralRange + ']', $ba60837ce5a48062$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $ba60837ce5a48062$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $ba60837ce5a48062$var$rsUpper = '[' + $ba60837ce5a48062$var$rsUpperRange + ']', $ba60837ce5a48062$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $ba60837ce5a48062$var$rsMiscLower = '(?:' + $ba60837ce5a48062$var$rsLower + '|' + $ba60837ce5a48062$var$rsMisc + ')', $ba60837ce5a48062$var$rsMiscUpper = '(?:' + $ba60837ce5a48062$var$rsUpper + '|' + $ba60837ce5a48062$var$rsMisc + ')', $ba60837ce5a48062$var$rsOptContrLower = '(?:' + $ba60837ce5a48062$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $ba60837ce5a48062$var$rsOptContrUpper = '(?:' + $ba60837ce5a48062$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $ba60837ce5a48062$var$reOptMod = $ba60837ce5a48062$var$rsModifier + '?', $ba60837ce5a48062$var$rsOptVar = '[' + $ba60837ce5a48062$var$rsVarRange + ']?', $ba60837ce5a48062$var$rsOptJoin = '(?:' + $ba60837ce5a48062$var$rsZWJ + '(?:' + [
    $ba60837ce5a48062$var$rsNonAstral,
    $ba60837ce5a48062$var$rsRegional,
    $ba60837ce5a48062$var$rsSurrPair
].join('|') + ')' + $ba60837ce5a48062$var$rsOptVar + $ba60837ce5a48062$var$reOptMod + ')*', $ba60837ce5a48062$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $ba60837ce5a48062$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $ba60837ce5a48062$var$rsSeq = $ba60837ce5a48062$var$rsOptVar + $ba60837ce5a48062$var$reOptMod + $ba60837ce5a48062$var$rsOptJoin, $ba60837ce5a48062$var$rsEmoji = '(?:' + [
    $ba60837ce5a48062$var$rsDingbat,
    $ba60837ce5a48062$var$rsRegional,
    $ba60837ce5a48062$var$rsSurrPair
].join('|') + ')' + $ba60837ce5a48062$var$rsSeq;
/** Used to match complex or compound words. */ var $ba60837ce5a48062$var$reUnicodeWord = RegExp([
    $ba60837ce5a48062$var$rsUpper + '?' + $ba60837ce5a48062$var$rsLower + '+' + $ba60837ce5a48062$var$rsOptContrLower + '(?=' + [
        $ba60837ce5a48062$var$rsBreak,
        $ba60837ce5a48062$var$rsUpper,
        '$'
    ].join('|') + ')',
    $ba60837ce5a48062$var$rsMiscUpper + '+' + $ba60837ce5a48062$var$rsOptContrUpper + '(?=' + [
        $ba60837ce5a48062$var$rsBreak,
        $ba60837ce5a48062$var$rsUpper + $ba60837ce5a48062$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $ba60837ce5a48062$var$rsUpper + '?' + $ba60837ce5a48062$var$rsMiscLower + '+' + $ba60837ce5a48062$var$rsOptContrLower,
    $ba60837ce5a48062$var$rsUpper + '+' + $ba60837ce5a48062$var$rsOptContrUpper,
    $ba60837ce5a48062$var$rsOrdUpper,
    $ba60837ce5a48062$var$rsOrdLower,
    $ba60837ce5a48062$var$rsDigits,
    $ba60837ce5a48062$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $ba60837ce5a48062$var$unicodeWords(string) {
    return string.match($ba60837ce5a48062$var$reUnicodeWord) || [];
}
$ba60837ce5a48062$exports = $ba60837ce5a48062$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $c1745544bd02927e$var$words(string, pattern, guard) {
    string = $d9b09c9b2e860fe7$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $d3e3c245d711415e$exports(string) ? $ba60837ce5a48062$exports(string) : $2fad5819a0ae99b3$exports(string);
    return string.match(pattern) || [];
}
$c1745544bd02927e$exports = $c1745544bd02927e$var$words;


/** Used to compose unicode capture groups. */ var $98e1234e2fd80890$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $98e1234e2fd80890$var$reApos = RegExp($98e1234e2fd80890$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $98e1234e2fd80890$var$createCompounder(callback) {
    return function(string) {
        return $b02c1369c4aea724$exports($c1745544bd02927e$exports($b8e2f9c7cf4a6b5f$exports(string).replace($98e1234e2fd80890$var$reApos, '')), callback, '');
    };
}
$98e1234e2fd80890$exports = $98e1234e2fd80890$var$createCompounder;


/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $24ee46190a27cc85$var$snakeCase = $98e1234e2fd80890$exports(function(result, word, index) {
    return result + (index ? '_' : '') + word.toLowerCase();
});
$24ee46190a27cc85$exports = $24ee46190a27cc85$var$snakeCase;


var $613c311aac31d238$exports = {};
var $c91caa84f60127ed$exports = {};

var $dddfb1a1dd91df4d$exports = {};
var $4e906791f19cff1d$exports = {};
var $698f8c2f8a4064d5$exports = {};
var $ace0c76fcd5d7ce0$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $ace0c76fcd5d7ce0$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$ace0c76fcd5d7ce0$exports = $ace0c76fcd5d7ce0$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $698f8c2f8a4064d5$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $ace0c76fcd5d7ce0$exports(array, start, end);
}
$698f8c2f8a4064d5$exports = $698f8c2f8a4064d5$var$castSlice;


var $722d2ecb3e7b94c9$exports = {};
/** Used to compose unicode character classes. */ var $722d2ecb3e7b94c9$var$rsAstralRange = '\\ud800-\\udfff', $722d2ecb3e7b94c9$var$rsComboMarksRange = '\\u0300-\\u036f', $722d2ecb3e7b94c9$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $722d2ecb3e7b94c9$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $722d2ecb3e7b94c9$var$rsComboRange = $722d2ecb3e7b94c9$var$rsComboMarksRange + $722d2ecb3e7b94c9$var$reComboHalfMarksRange + $722d2ecb3e7b94c9$var$rsComboSymbolsRange, $722d2ecb3e7b94c9$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $722d2ecb3e7b94c9$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $722d2ecb3e7b94c9$var$reHasUnicode = RegExp('[' + $722d2ecb3e7b94c9$var$rsZWJ + $722d2ecb3e7b94c9$var$rsAstralRange + $722d2ecb3e7b94c9$var$rsComboRange + $722d2ecb3e7b94c9$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $722d2ecb3e7b94c9$var$hasUnicode(string) {
    return $722d2ecb3e7b94c9$var$reHasUnicode.test(string);
}
$722d2ecb3e7b94c9$exports = $722d2ecb3e7b94c9$var$hasUnicode;


var $a520f87d0deabb09$exports = {};
var $934e6d9eb1512f97$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $934e6d9eb1512f97$var$asciiToArray(string) {
    return string.split('');
}
$934e6d9eb1512f97$exports = $934e6d9eb1512f97$var$asciiToArray;



var $a57b8200cab8dd56$exports = {};
/** Used to compose unicode character classes. */ var $a57b8200cab8dd56$var$rsAstralRange = '\\ud800-\\udfff', $a57b8200cab8dd56$var$rsComboMarksRange = '\\u0300-\\u036f', $a57b8200cab8dd56$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $a57b8200cab8dd56$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $a57b8200cab8dd56$var$rsComboRange = $a57b8200cab8dd56$var$rsComboMarksRange + $a57b8200cab8dd56$var$reComboHalfMarksRange + $a57b8200cab8dd56$var$rsComboSymbolsRange, $a57b8200cab8dd56$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $a57b8200cab8dd56$var$rsAstral = '[' + $a57b8200cab8dd56$var$rsAstralRange + ']', $a57b8200cab8dd56$var$rsCombo = '[' + $a57b8200cab8dd56$var$rsComboRange + ']', $a57b8200cab8dd56$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $a57b8200cab8dd56$var$rsModifier = '(?:' + $a57b8200cab8dd56$var$rsCombo + '|' + $a57b8200cab8dd56$var$rsFitz + ')', $a57b8200cab8dd56$var$rsNonAstral = '[^' + $a57b8200cab8dd56$var$rsAstralRange + ']', $a57b8200cab8dd56$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $a57b8200cab8dd56$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $a57b8200cab8dd56$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $a57b8200cab8dd56$var$reOptMod = $a57b8200cab8dd56$var$rsModifier + '?', $a57b8200cab8dd56$var$rsOptVar = '[' + $a57b8200cab8dd56$var$rsVarRange + ']?', $a57b8200cab8dd56$var$rsOptJoin = '(?:' + $a57b8200cab8dd56$var$rsZWJ + '(?:' + [
    $a57b8200cab8dd56$var$rsNonAstral,
    $a57b8200cab8dd56$var$rsRegional,
    $a57b8200cab8dd56$var$rsSurrPair
].join('|') + ')' + $a57b8200cab8dd56$var$rsOptVar + $a57b8200cab8dd56$var$reOptMod + ')*', $a57b8200cab8dd56$var$rsSeq = $a57b8200cab8dd56$var$rsOptVar + $a57b8200cab8dd56$var$reOptMod + $a57b8200cab8dd56$var$rsOptJoin, $a57b8200cab8dd56$var$rsSymbol = '(?:' + [
    $a57b8200cab8dd56$var$rsNonAstral + $a57b8200cab8dd56$var$rsCombo + '?',
    $a57b8200cab8dd56$var$rsCombo,
    $a57b8200cab8dd56$var$rsRegional,
    $a57b8200cab8dd56$var$rsSurrPair,
    $a57b8200cab8dd56$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $a57b8200cab8dd56$var$reUnicode = RegExp($a57b8200cab8dd56$var$rsFitz + '(?=' + $a57b8200cab8dd56$var$rsFitz + ')|' + $a57b8200cab8dd56$var$rsSymbol + $a57b8200cab8dd56$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $a57b8200cab8dd56$var$unicodeToArray(string) {
    return string.match($a57b8200cab8dd56$var$reUnicode) || [];
}
$a57b8200cab8dd56$exports = $a57b8200cab8dd56$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $a520f87d0deabb09$var$stringToArray(string) {
    return $722d2ecb3e7b94c9$exports(string) ? $a57b8200cab8dd56$exports(string) : $934e6d9eb1512f97$exports(string);
}
$a520f87d0deabb09$exports = $a520f87d0deabb09$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $4e906791f19cff1d$var$createCaseFirst(methodName) {
    return function(string) {
        string = $d9b09c9b2e860fe7$exports(string);
        var strSymbols = $722d2ecb3e7b94c9$exports(string) ? $a520f87d0deabb09$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $698f8c2f8a4064d5$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$4e906791f19cff1d$exports = $4e906791f19cff1d$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $dddfb1a1dd91df4d$var$upperFirst = $4e906791f19cff1d$exports('toUpperCase');
$dddfb1a1dd91df4d$exports = $dddfb1a1dd91df4d$var$upperFirst;


/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $c91caa84f60127ed$var$capitalize(string) {
    return $dddfb1a1dd91df4d$exports($d9b09c9b2e860fe7$exports(string).toLowerCase());
}
$c91caa84f60127ed$exports = $c91caa84f60127ed$var$capitalize;



/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $613c311aac31d238$var$camelCase = $98e1234e2fd80890$exports(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $c91caa84f60127ed$exports(word) : word);
});
$613c311aac31d238$exports = $613c311aac31d238$var$camelCase;


var $e8d46bbed80cf1fe$exports = {};



/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $e8d46bbed80cf1fe$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $30aaebbdaff8808f$exports(iteratee, 3);
    $edb97d32e8dcec56$exports(object, function(value, key, object) {
        $f50513f2ca42f446$exports(result, iteratee(value, key, object), value);
    });
    return result;
}
$e8d46bbed80cf1fe$exports = $e8d46bbed80cf1fe$var$mapKeys;






var $cba13e93caa67058$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $cba13e93caa67058$exports = function(edges) {
    return $cba13e93caa67058$var$toposort($cba13e93caa67058$var$uniqueNodes(edges), edges);
};
$cba13e93caa67058$exports.array = $cba13e93caa67058$var$toposort;
function $cba13e93caa67058$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $cba13e93caa67058$var$makeOutgoingEdges(edges), nodesHash = $cba13e93caa67058$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $cba13e93caa67058$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $cba13e93caa67058$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $cba13e93caa67058$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}





function $a6fb08f58cea86d3$export$2e2bcd8739ae039(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $410374687b1da032$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for(const key in fields)if ((0, (/*@__PURE__*/$parcel$interopDefault($892682e2ec181f97$exports)))(fields, key)) {
        let value = fields[key];
        nodes.add(key);
        if ((0, $a30d53bf69a44d9d$export$2e2bcd8739ae039).isRef(value) && value.isSibling) addNode(value.path, key);
        else if ((0, $f2191a4ad394fb0a$export$2e2bcd8739ae039)(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($cba13e93caa67058$exports))).array(Array.from(nodes), edges).reverse();
}


function $884f5e6e0f5639c1$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $884f5e6e0f5639c1$export$2e2bcd8739ae039(keys) {
    return (a, b)=>{
        return $884f5e6e0f5639c1$var$findIndex(keys, a) - $884f5e6e0f5639c1$var$findIndex(keys, b);
    };
}





function $ee6ba11cc5736d52$var$_extends() {
    $ee6ba11cc5736d52$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ee6ba11cc5736d52$var$_extends.apply(this, arguments);
}
let $ee6ba11cc5736d52$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $ee6ba11cc5736d52$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $ee6ba11cc5736d52$var$defaultSort = (0, $884f5e6e0f5639c1$export$2e2bcd8739ae039)([]);
class $ee6ba11cc5736d52$export$2e2bcd8739ae039 extends (0, $37ab42079f247083$export$2e2bcd8739ae039) {
    constructor(spec){
        super({
            type: 'object'
        });
        this.fields = Object.create(null);
        this._sortErrors = $ee6ba11cc5736d52$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            this.transform(function coerce(value) {
                if (typeof value === 'string') try {
                    value = JSON.parse(value);
                } catch (err) {
                    value = null;
                }
                if (this.isType(value)) return value;
                return null;
            });
            if (spec) this.shape(spec);
        });
    }
    _typeCheck(value) {
        return $ee6ba11cc5736d52$var$isObject(value) || typeof value === 'function';
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options); //should ignore nulls here
        if (value === undefined) return this.getDefault();
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = this._nodes.concat(Object.keys(value).filter((v)=>this._nodes.indexOf(v) === -1));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = $ee6ba11cc5736d52$var$_extends({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = (0, (/*@__PURE__*/$parcel$interopDefault($892682e2ec181f97$exports)))(value, prop);
            if (field) {
                let fieldValue;
                let inputValue = value[prop]; // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop; // innerOptions.value = value[prop];
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = 'spec' in field ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec == null ? void 0 : fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, opts = {}, callback) {
        let errors = [];
        let { sync: sync, from: from = [], originalValue: originalValue = _value, abortEarly: abortEarly = this.spec.abortEarly, recursive: recursive = this.spec.recursive } = opts;
        from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ]; // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        opts.__validating = true;
        opts.originalValue = originalValue;
        opts.from = from;
        super._validate(_value, opts, (err, value)=>{
            if (err) {
                if (!(0, $436abf1934e89390$export$2e2bcd8739ae039).isError(err) || abortEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !$ee6ba11cc5736d52$var$isObject(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = this._nodes.map((key)=>(_, cb)=>{
                    let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
                    let field = this.fields[key];
                    if (field && 'validate' in field) {
                        field.validate(value[key], $ee6ba11cc5736d52$var$_extends({}, opts, {
                            path: // @ts-ignore
                            path,
                            from: from,
                            // inner fields are always strict:
                            // 1. this isn't strict so the casting will also have cast inner values
                            // 2. this is strict in which case the nested values weren't cast either
                            strict: true,
                            parent: value,
                            originalValue: originalValue[key]
                        }), cb);
                        return;
                    }
                    cb(null);
                });
            (0, $65dc7f44eb17b152$export$2e2bcd8739ae039)({
                sync: sync,
                tests: tests,
                value: value,
                errors: errors,
                endEarly: abortEarly,
                sort: this._sortErrors,
                path: opts.path
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = $ee6ba11cc5736d52$var$_extends({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            if (target === undefined) nextFields[field] = schemaOrRef;
            else if (target instanceof (0, $37ab42079f247083$export$2e2bcd8739ae039) && schemaOrRef instanceof (0, $37ab42079f247083$export$2e2bcd8739ae039)) nextFields[field] = schemaOrRef.concat(target);
        }
        return next.withMutation(()=>next.shape(nextFields, this._excludedEdges));
    }
    getDefaultFromShape() {
        let dft = {};
        this._nodes.forEach((key)=>{
            const field = this.fields[key];
            dft[key] = 'default' in field ? field.getDefault() : undefined;
        });
        return dft;
    }
    _getDefault() {
        if ('default' in this.spec) return super._getDefault();
         // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        return this.getDefaultFromShape();
    }
    shape(additions, excludes = []) {
        let next = this.clone();
        let fields = Object.assign(next.fields, additions);
        next.fields = fields;
        next._sortErrors = (0, $884f5e6e0f5639c1$export$2e2bcd8739ae039)(Object.keys(fields));
        if (excludes.length) {
            // this is a convenience for when users only supply a single pair
            if (!Array.isArray(excludes[0])) excludes = [
                excludes
            ];
            next._excludedEdges = [
                ...next._excludedEdges,
                ...excludes
            ];
        }
        next._nodes = (0, $a6fb08f58cea86d3$export$2e2bcd8739ae039)(fields, next._excludedEdges);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.clone().withMutation((next)=>{
            next.fields = {};
            return next.shape(picked);
        });
    }
    omit(keys) {
        const next = this.clone();
        const fields = next.fields;
        next.fields = {};
        for (const key of keys)delete fields[key];
        return next.withMutation(()=>next.shape(fields));
    }
    from(from, to, alias) {
        let fromGetter = (0, $410374687b1da032$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (obj == null) return obj;
            let newObj = obj;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($892682e2ec181f97$exports)))(obj, from)) {
                newObj = $ee6ba11cc5736d52$var$_extends({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    noUnknown(noAllow = true, message = (0, $29e8e7a2eb806720$export$be5493f9613cbbe).noUnknown) {
        if (typeof noAllow === 'string') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $ee6ba11cc5736d52$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = (0, $29e8e7a2eb806720$export$be5493f9613cbbe).noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>obj && (0, (/*@__PURE__*/$parcel$interopDefault($e8d46bbed80cf1fe$exports)))(obj, (_, key)=>fn(key)));
    }
    camelCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($613c311aac31d238$exports))));
    }
    snakeCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($24ee46190a27cc85$exports))));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($24ee46190a27cc85$exports)))(key).toUpperCase());
    }
    describe() {
        let base = super.describe();
        base.fields = (0, (/*@__PURE__*/$parcel$interopDefault($b6f664cd9e1ba448$exports)))(this.fields, (value)=>value.describe());
        return base;
    }
}
function $ee6ba11cc5736d52$export$185802fd694ee1f5(spec) {
    return new $ee6ba11cc5736d52$export$2e2bcd8739ae039(spec);
}
$ee6ba11cc5736d52$export$185802fd694ee1f5.prototype = $ee6ba11cc5736d52$export$2e2bcd8739ae039.prototype;









function $81158f0d6874164b$var$_extends() {
    $81158f0d6874164b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $81158f0d6874164b$var$_extends.apply(this, arguments);
}
function $81158f0d6874164b$export$185802fd694ee1f5(type) {
    return new $81158f0d6874164b$export$2e2bcd8739ae039(type);
}
class $81158f0d6874164b$export$2e2bcd8739ae039 extends (0, $37ab42079f247083$export$2e2bcd8739ae039) {
    constructor(type){
        super({
            type: 'array'
        }); // `undefined` specifically means uninitialized, as opposed to
        // "no subtype"
        this.innerType = void 0;
        this.innerType = type;
        this.withMutation(()=>{
            this.transform(function(values) {
                if (typeof values === 'string') try {
                    values = JSON.parse(values);
                } catch (err) {
                    values = null;
                }
                return this.isType(values) ? values : null;
            });
        });
    }
    _typeCheck(v) {
        return Array.isArray(v);
    }
    get _subType() {
        return this.innerType;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts); //should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, $81158f0d6874164b$var$_extends({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, callback) {
        var _options$abortEarly, _options$recursive;
        let errors = [];
        let sync = options.sync;
        let path = options.path;
        let innerType = this.innerType;
        let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        let originalValue = options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, (err, value)=>{
            if (err) {
                if (!(0, $436abf1934e89390$export$2e2bcd8739ae039).isError(err) || endEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !innerType || !this._typeCheck(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let idx = 0; idx < value.length; idx++){
                let item = value[idx];
                let path = `${options.path || ''}[${idx}]`; // object._validate note for isStrict explanation
                let innerOptions = $81158f0d6874164b$var$_extends({}, options, {
                    path: path,
                    strict: true,
                    parent: value,
                    index: idx,
                    originalValue: originalValue[idx]
                });
                tests[idx] = (_, cb)=>innerType.validate(item, innerOptions, cb);
            }
            (0, $65dc7f44eb17b152$export$2e2bcd8739ae039)({
                sync: sync,
                path: path,
                value: value,
                errors: errors,
                endEarly: endEarly,
                tests: tests
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.innerType = this.innerType;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        next.innerType = this.innerType;
        if (schema.innerType) next.innerType = next.innerType ? next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!(0, $f2191a4ad394fb0a$export$2e2bcd8739ae039)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + (0, $6e275c2ea1928bcc$export$2e2bcd8739ae039)(schema)); // FIXME(ts):
        next.innerType = schema;
        return next;
    }
    length(length, message = (0, $29e8e7a2eb806720$export$2f23118c22fb2630).length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || (0, $29e8e7a2eb806720$export$2f23118c22fb2630).min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            // FIXME(ts): Array<typeof T>
            test (value) {
                return (0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || (0, $29e8e7a2eb806720$export$2f23118c22fb2630).max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $a192f827c26e21b2$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe() {
        let base = super.describe();
        if (this.innerType) base.innerType = this.innerType.describe();
        return base;
    }
    nullable(isNullable = true) {
        return super.nullable(isNullable);
    }
    defined() {
        return super.defined();
    }
    required(msg) {
        return super.required(msg);
    }
}
$81158f0d6874164b$export$185802fd694ee1f5.prototype = $81158f0d6874164b$export$2e2bcd8739ae039.prototype; //
 // Interfaces
 //




function $66592cb1be84d756$export$185802fd694ee1f5(builder) {
    return new $66592cb1be84d756$var$Lazy(builder);
}
class $66592cb1be84d756$var$Lazy {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.__inputType = void 0;
        this.__outputType = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!(0, $f2191a4ad394fb0a$export$2e2bcd8739ae039)(schema)) throw new TypeError('lazy() functions must return a valid schema');
            return schema.resolve(options);
        };
        this.builder = builder;
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    validate(value, options, maybeCb) {
        // @ts-expect-error missing public callback on type
        return this._resolve(value, options).validate(value, options, maybeCb);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    describe() {
        return null;
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
}
var $66592cb1be84d756$export$2e2bcd8739ae039 = $66592cb1be84d756$var$Lazy;






function $a292ac81fcbf72a5$export$2e2bcd8739ae039(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            (0, $29e8e7a2eb806720$export$2e2bcd8739ae039)[type][method] = custom[type][method];
        });
    });
}



function $5529954a1da35fdb$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !(0, $f2191a4ad394fb0a$export$2e2bcd8739ae039)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}



var $ipnkk = parcelRequire("ipnkk");


var $bb3TF = parcelRequire("bb3TF");
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $9dfc8eccc5634193$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([457]\\d{6})$",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2457]\\d{6})$",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([267]\\d{6})$",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "0|(183[12])",
            0,
            0,
            0,
            [
                [
                    "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[047]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "(?:[25689]\\d|40)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "(?:590|(?:69|80)\\d|976)\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976[01]\\d{5}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-8]\\d{6})$",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([3-8]\\d{6})$",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-79]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|68|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|13|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-7]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "0|([59]\\d{7})$",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "(?:10|2[0-57-9])(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "0|(1(?:[12]\\d|79)\\d\\d)",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0(4(?:[14]4|56)|[579])?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "0|([59]\\d{7})$",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[0568]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-7]\\d{6})$",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[189]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "[2568][1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[12]00|[368]|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[1245]|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[013579])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-246-9])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "(?:[56]94|80\\d|976)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "0|([25-9]\\d{5})$",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d\\d|606)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "(?:590|(?:69|80)\\d|976)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|6[0-289]|7[08]|8[0-689]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976[01]\\d{5}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([3-9]\\d{6})$",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "[2-489]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-489]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "0|([25-8]\\d{5})$",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "0|([0-24-8]\\d{5})$",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|(?:[235-8]\\d|99)\\d{7}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-7]\\d{6})$",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-8]\\d{6})$",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "0|(1001)"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[4-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1-$2",
                    [
                        "5(?:29|38)",
                        "5(?:29[89]|389)",
                        "5(?:29[89]|389)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|892",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:29(?:[189][05]|2[29]|3[01])|389[05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[08]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "592(?:4[0-2]|93)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "(?:590|(?:69|80)\\d|976)\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "976[01]\\d{5}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0|([24-9]\\d{6})$",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "(?:69|80)\\d{7}|(?:59|97)6\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([34]\\d{6})$",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[3467]|9[13-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:(?:44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[017]\\d|[235][1-9]|4[0-35-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[04]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[489]|59"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[47]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-579]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|[89]0",
                        "50(?:[0367]|88)|[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[59]|80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7|86"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "(?:[45]|80\\d\\d)\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[126]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "976\\d{6}|(?:26|[68]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "26[23]|69|[89]"
        ],
        "RO": [
            "40",
            "00",
            "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[237-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-5]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "24|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[3478]|64|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|(5\\d{6})$",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-479]\\d{6})$",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "(?:00|[1-57-9]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[34]7|91[78]"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|616)",
                        "5(?:[0-59]|6161)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-46-8]\\d{6})$",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "505(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "405|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "(?:33|55|[679]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[35-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-7]\\d{6})$",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-578]\\d{6})$",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "1|([2-9]\\d{6})$",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[69]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[3578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7[24-68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "80\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "269|63"
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "[0-36-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-36-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "4"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-3]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:210|370\\d\\d)\\d{7}|51\\d{7}(?:\\d{3})?",
            [
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:210|(?:370[1-9]|51[013]0)\\d)\\d{7}|5100\\d{5}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// The minimum length of the national significant number.
var $4dcf27eddf865fa7$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $4dcf27eddf865fa7$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $4dcf27eddf865fa7$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $4dcf27eddf865fa7$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $4dcf27eddf865fa7$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $4dcf27eddf865fa7$var$SLASHES = "\uFF0F/";
var $4dcf27eddf865fa7$var$DOTS = "\uFF0E.";
var $4dcf27eddf865fa7$export$20542845033f576e = " \xA0\xAD\u200B\u2060\u3000";
var $4dcf27eddf865fa7$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $4dcf27eddf865fa7$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $4dcf27eddf865fa7$export$7f01587e28f9194 = "".concat($4dcf27eddf865fa7$var$DASHES).concat($4dcf27eddf865fa7$var$SLASHES).concat($4dcf27eddf865fa7$var$DOTS).concat($4dcf27eddf865fa7$export$20542845033f576e).concat($4dcf27eddf865fa7$var$BRACKETS).concat($4dcf27eddf865fa7$var$TILDES);
var $4dcf27eddf865fa7$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


function $581d2488ab78f488$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $581d2488ab78f488$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $581d2488ab78f488$var$_typeof(obj);
}
function $581d2488ab78f488$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $581d2488ab78f488$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $581d2488ab78f488$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $581d2488ab78f488$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $581d2488ab78f488$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $581d2488ab78f488$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $581d2488ab78f488$var$_setPrototypeOf(subClass, superClass);
}
function $581d2488ab78f488$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $581d2488ab78f488$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $581d2488ab78f488$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $581d2488ab78f488$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $581d2488ab78f488$var$_possibleConstructorReturn(this, result);
    };
}
function $581d2488ab78f488$var$_possibleConstructorReturn(self, call) {
    if (call && ($581d2488ab78f488$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $581d2488ab78f488$var$_assertThisInitialized(self);
}
function $581d2488ab78f488$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $581d2488ab78f488$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $581d2488ab78f488$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$581d2488ab78f488$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $581d2488ab78f488$var$_construct(Class, arguments, $581d2488ab78f488$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $581d2488ab78f488$var$_setPrototypeOf(Wrapper, Class);
    };
    return $581d2488ab78f488$var$_wrapNativeSuper(Class);
}
function $581d2488ab78f488$var$_construct(Parent, args, Class) {
    if ($581d2488ab78f488$var$_isNativeReflectConstruct()) $581d2488ab78f488$var$_construct = Reflect.construct;
    else $581d2488ab78f488$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $581d2488ab78f488$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $581d2488ab78f488$var$_construct.apply(null, arguments);
}
function $581d2488ab78f488$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $581d2488ab78f488$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $581d2488ab78f488$var$_setPrototypeOf(o, p) {
    $581d2488ab78f488$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $581d2488ab78f488$var$_setPrototypeOf(o, p);
}
function $581d2488ab78f488$var$_getPrototypeOf(o) {
    $581d2488ab78f488$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $581d2488ab78f488$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $581d2488ab78f488$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $581d2488ab78f488$var$_inherits(ParseError, _Error);
    var _super = $581d2488ab78f488$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $581d2488ab78f488$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($581d2488ab78f488$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $581d2488ab78f488$var$_createClass(ParseError);
}(/*#__PURE__*/ $581d2488ab78f488$var$_wrapNativeSuper(Error));


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $7b250da1b08f7583$export$2e2bcd8739ae039(a, b) {
    a = a.split('-');
    b = b.split('-');
    var pa = a[0].split('.');
    var pb = b[0].split('.');
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}


function $9015f651de9f4947$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9015f651de9f4947$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9015f651de9f4947$var$_typeof(obj);
}
function $9015f651de9f4947$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9015f651de9f4947$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9015f651de9f4947$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9015f651de9f4947$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9015f651de9f4947$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $9015f651de9f4947$var$V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".
var $9015f651de9f4947$var$V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.
var $9015f651de9f4947$var$V4 = '1.7.35';
var $9015f651de9f4947$var$DEFAULT_EXT_PREFIX = ' ext. ';
var $9015f651de9f4947$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $9015f651de9f4947$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $9015f651de9f4947$var$_classCallCheck(this, Metadata);
        $9015f651de9f4947$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $9015f651de9f4947$var$setVersion.call(this, metadata);
    }
    $9015f651de9f4947$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== '001';
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $9015f651de9f4947$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== '001') {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $9015f651de9f4947$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $9015f651de9f4947$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return this.metadata.countries['001'];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $9015f651de9f4947$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $9015f651de9f4947$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $9015f651de9f4947$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $9015f651de9f4947$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $9015f651de9f4947$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $9015f651de9f4947$var$getType(this.types(), _type2)) return new $9015f651de9f4947$var$Type($9015f651de9f4947$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $9015f651de9f4947$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $9015f651de9f4947$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $9015f651de9f4947$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $9015f651de9f4947$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $9015f651de9f4947$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$9015f651de9f4947$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $9015f651de9f4947$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $9015f651de9f4947$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $9015f651de9f4947$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $9015f651de9f4947$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $9015f651de9f4947$var$getType(types, type) {
    switch(type){
        case 'FIXED_LINE':
            return types[0];
        case 'MOBILE':
            return types[1];
        case 'TOLL_FREE':
            return types[2];
        case 'PREMIUM_RATE':
            return types[3];
        case 'PERSONAL_NUMBER':
            return types[4];
        case 'VOICEMAIL':
            return types[5];
        case 'UAN':
            return types[6];
        case 'PAGER':
            return types[7];
        case 'VOIP':
            return types[8];
        case 'SHARED_COST':
            return types[9];
    }
}
function $9015f651de9f4947$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!$9015f651de9f4947$var$is_object(metadata) || !$9015f651de9f4947$var$is_object(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat($9015f651de9f4947$var$is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + $9015f651de9f4947$var$type_of(metadata) + ': ' + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $9015f651de9f4947$var$is_object = function is_object(_) {
    return $9015f651de9f4947$var$_typeof(_) === 'object';
}; // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $9015f651de9f4947$var$type_of = function type_of(_) {
    return $9015f651de9f4947$var$_typeof(_);
};
function $9015f651de9f4947$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $9015f651de9f4947$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $9015f651de9f4947$var$DEFAULT_EXT_PREFIX;
}
function $9015f651de9f4947$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $9015f651de9f4947$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $9015f651de9f4947$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries[country] !== undefined;
}
function $9015f651de9f4947$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === 'number') {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $7b250da1b08f7583$export$2e2bcd8739ae039)(version, $9015f651de9f4947$var$V3) === -1) this.v2 = true;
        else if ((0, $7b250da1b08f7583$export$2e2bcd8739ae039)(version, $9015f651de9f4947$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




var $6b6e340b2d57181b$var$RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $6b6e340b2d57181b$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $4dcf27eddf865fa7$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $6b6e340b2d57181b$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = '20';
    /** @type {string} */ var extLimitAfterLikelyLabel = '15';
    /** @type {string} */ var extLimitAfterAmbiguousChar = '9';
    /** @type {string} */ var extLimitWhenNotSure = '6';
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $6b6e340b2d57181b$var$RFC3966_EXTN_PREFIX + $6b6e340b2d57181b$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $6b6e340b2d57181b$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $6b6e340b2d57181b$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $6b6e340b2d57181b$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $6b6e340b2d57181b$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $6b6e340b2d57181b$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $3d2447d044ba7f08$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + (0, $4dcf27eddf865fa7$export$852d1d4a47329634) + ']{' + (0, $4dcf27eddf865fa7$export$cd8355bcbe13154) + '}'; //
var $3d2447d044ba7f08$export$a77dd7471651eee = '[' + (0, $4dcf27eddf865fa7$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $4dcf27eddf865fa7$export$7f01587e28f9194) + ']*' + '[' + (0, $4dcf27eddf865fa7$export$852d1d4a47329634) + ']' + '){3,}' + '[' + (0, $4dcf27eddf865fa7$export$7f01587e28f9194) + (0, $4dcf27eddf865fa7$export$852d1d4a47329634) + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $3d2447d044ba7f08$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $4dcf27eddf865fa7$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $4dcf27eddf865fa7$export$7f01587e28f9194) + ']*' + '[' + (0, $4dcf27eddf865fa7$export$852d1d4a47329634) + ']' + '){1,2}' + '$', 'i');
var $3d2447d044ba7f08$export$a2d12a04749c087d = $3d2447d044ba7f08$export$a77dd7471651eee + // Phone number extensions
'(?:' + (0, $6b6e340b2d57181b$export$2e2bcd8739ae039)() + ')?'; // The combined regular expression for valid phone numbers:
//
var $3d2447d044ba7f08$var$VALID_PHONE_NUMBER_PATTERN = new RegExp('^' + $3d2447d044ba7f08$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + $3d2447d044ba7f08$export$a2d12a04749c087d + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
function $3d2447d044ba7f08$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $4dcf27eddf865fa7$export$cd8355bcbe13154) && $3d2447d044ba7f08$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $3d2447d044ba7f08$export$4c3f76c95c05197c(number) {
    return $3d2447d044ba7f08$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}



// 1 or more valid digits, for use when parsing.
var $57b39c5729bba6b3$var$EXTN_PATTERN = new RegExp('(?:' + (0, $6b6e340b2d57181b$export$2e2bcd8739ae039)() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
function $57b39c5729bba6b3$export$2e2bcd8739ae039(number) {
    var start = number.search($57b39c5729bba6b3$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($57b39c5729bba6b3$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}


function $36e358bc9b5a1121$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $36e358bc9b5a1121$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $36e358bc9b5a1121$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $36e358bc9b5a1121$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $36e358bc9b5a1121$var$_arrayLikeToArray(o, minLen);
}
function $36e358bc9b5a1121$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $36e358bc9b5a1121$export$2848f3d68c08fe69 = {
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    "\uFF10": '0',
    // Fullwidth digit 0
    "\uFF11": '1',
    // Fullwidth digit 1
    "\uFF12": '2',
    // Fullwidth digit 2
    "\uFF13": '3',
    // Fullwidth digit 3
    "\uFF14": '4',
    // Fullwidth digit 4
    "\uFF15": '5',
    // Fullwidth digit 5
    "\uFF16": '6',
    // Fullwidth digit 6
    "\uFF17": '7',
    // Fullwidth digit 7
    "\uFF18": '8',
    // Fullwidth digit 8
    "\uFF19": '9',
    // Fullwidth digit 9
    "\u0660": '0',
    // Arabic-indic digit 0
    "\u0661": '1',
    // Arabic-indic digit 1
    "\u0662": '2',
    // Arabic-indic digit 2
    "\u0663": '3',
    // Arabic-indic digit 3
    "\u0664": '4',
    // Arabic-indic digit 4
    "\u0665": '5',
    // Arabic-indic digit 5
    "\u0666": '6',
    // Arabic-indic digit 6
    "\u0667": '7',
    // Arabic-indic digit 7
    "\u0668": '8',
    // Arabic-indic digit 8
    "\u0669": '9',
    // Arabic-indic digit 9
    "\u06F0": '0',
    // Eastern-Arabic digit 0
    "\u06F1": '1',
    // Eastern-Arabic digit 1
    "\u06F2": '2',
    // Eastern-Arabic digit 2
    "\u06F3": '3',
    // Eastern-Arabic digit 3
    "\u06F4": '4',
    // Eastern-Arabic digit 4
    "\u06F5": '5',
    // Eastern-Arabic digit 5
    "\u06F6": '6',
    // Eastern-Arabic digit 6
    "\u06F7": '7',
    // Eastern-Arabic digit 7
    "\u06F8": '8',
    // Eastern-Arabic digit 8
    "\u06F9": '9' // Eastern-Arabic digit 9
};
function $36e358bc9b5a1121$export$1d16fddea1437169(character) {
    return $36e358bc9b5a1121$export$2848f3d68c08fe69[character];
}
function $36e358bc9b5a1121$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $36e358bc9b5a1121$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $36e358bc9b5a1121$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}


function $d8bf16d5fafeec82$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d8bf16d5fafeec82$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d8bf16d5fafeec82$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d8bf16d5fafeec82$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d8bf16d5fafeec82$var$_arrayLikeToArray(o, minLen);
}
function $d8bf16d5fafeec82$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d8bf16d5fafeec82$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $d8bf16d5fafeec82$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $d8bf16d5fafeec82$export$13d8790d7fb84c28(character, result) || '';
    }
    return result;
}
function $d8bf16d5fafeec82$export$13d8790d7fb84c28(character, prevParsedCharacters) {
    // Only allow a leading `+`.
    if (character === '+') {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) return;
        return '+';
    } // Allow digits.
    return (0, $36e358bc9b5a1121$export$1d16fddea1437169)(character);
}




function $179738fda2a7d2bd$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $179738fda2a7d2bd$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $179738fda2a7d2bd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $179738fda2a7d2bd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $179738fda2a7d2bd$var$_arrayLikeToArray(o, minLen);
}
function $179738fda2a7d2bd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $179738fda2a7d2bd$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $179738fda2a7d2bd$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $869b1294b63aee25$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $869b1294b63aee25$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $869b1294b63aee25$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return 'IS_POSSIBLE';
    if (type === 'FIXED_LINE_OR_MOBILE') {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type('FIXED_LINE')) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $869b1294b63aee25$export$69333f603c7d5931(nationalNumber, 'MOBILE', metadata);
        var mobile_type = metadata.type('MOBILE');
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $179738fda2a7d2bd$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return 'INVALID_LENGTH';
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return 'IS_POSSIBLE';
    if (minimum_length > actual_length) return 'TOO_SHORT';
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return 'TOO_LONG';
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}


function $e006f14dd42652b2$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $e006f14dd42652b2$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $e006f14dd42652b2$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $869b1294b63aee25$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case 'IS_POSSIBLE':
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}



function $be289f172febac88$var$_slicedToArray(arr, i) {
    return $be289f172febac88$var$_arrayWithHoles(arr) || $be289f172febac88$var$_iterableToArrayLimit(arr, i) || $be289f172febac88$var$_unsupportedIterableToArray(arr, i) || $be289f172febac88$var$_nonIterableRest();
}
function $be289f172febac88$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $be289f172febac88$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $be289f172febac88$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $be289f172febac88$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $be289f172febac88$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $be289f172febac88$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $be289f172febac88$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $be289f172febac88$var$_arrayLikeToArray(o, minLen);
}
function $be289f172febac88$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $be289f172febac88$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, 'tel=');
    for(var _iterator = $be289f172febac88$var$_createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split('='), _part$split2 = $be289f172febac88$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case 'tel':
                number = value;
                break;
            case 'ext':
                ext = value;
                break;
            case 'phone-context':
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === '+') number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $3d2447d044ba7f08$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $be289f172febac88$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return '';
    if (number[0] !== '+') throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
    return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}





/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $8044f3ebcf8b24b6$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || '';
    return new RegExp('^(?:' + regular_expression + ')$').test(text);
}




function $fc6aa5e4b5eeebd6$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $fc6aa5e4b5eeebd6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fc6aa5e4b5eeebd6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fc6aa5e4b5eeebd6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fc6aa5e4b5eeebd6$var$_arrayLikeToArray(o, minLen);
}
function $fc6aa5e4b5eeebd6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $fc6aa5e4b5eeebd6$var$NON_FIXED_LINE_PHONE_TYPES = [
    'MOBILE',
    'PREMIUM_RATE',
    'TOLL_FREE',
    'SHARED_COST',
    'VOIP',
    'PERSONAL_NUMBER',
    'PAGER',
    'UAN',
    'VOICEMAIL'
]; // Finds out national phone number type (fixed line, mobile, etc)
function $fc6aa5e4b5eeebd6$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returned `{}`
    // meaning that the phone number is not a valid one.
    if (!input.country) return;
    metadata = new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $8044f3ebcf8b24b6$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($fc6aa5e4b5eeebd6$export$7bd37b39ade0214d(nationalNumber, 'FIXED_LINE', metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') return 'FIXED_LINE_OR_MOBILE';
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type('MOBILE')) return 'FIXED_LINE_OR_MOBILE';
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($fc6aa5e4b5eeebd6$export$7bd37b39ade0214d(nationalNumber, 'MOBILE', metadata)) return 'FIXED_LINE_OR_MOBILE';
        return 'FIXED_LINE';
    }
    for(var _iterator = $fc6aa5e4b5eeebd6$var$_createForOfIteratorHelperLoose($fc6aa5e4b5eeebd6$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($fc6aa5e4b5eeebd6$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $fc6aa5e4b5eeebd6$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $8044f3ebcf8b24b6$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $b9fe382fad118608$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(metadata); // This is just to support `isValidNumber({})`
    // for cases when `parseNumber()` returns `{}`.
    if (!input.country) return false;
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $fc6aa5e4b5eeebd6$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var national_number = options.v2 ? input.nationalNumber : input.phone;
    return (0, $8044f3ebcf8b24b6$export$2e2bcd8739ae039)(national_number, metadata.nationalNumberPattern());
}






function $5e8dd20dbd59d7da$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $4dcf27eddf865fa7$export$7f01587e28f9194), "]+"), 'g'), ' ').trim();
}


var $b5a4891b4cbcc12b$export$4f32ad1c51a7a6be = /(\$\d)/;
function $b5a4891b4cbcc12b$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($b5a4891b4cbcc12b$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $5e8dd20dbd59d7da$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $df6a9c235632286d$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $df6a9c235632286d$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($df6a9c235632286d$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}



function $2902c761e76537bf$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $2902c761e76537bf$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2902c761e76537bf$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2902c761e76537bf$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2902c761e76537bf$var$_arrayLikeToArray(o, minLen);
}
function $2902c761e76537bf$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2902c761e76537bf$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2902c761e76537bf$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2902c761e76537bf$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2902c761e76537bf$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2902c761e76537bf$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2902c761e76537bf$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $2902c761e76537bf$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
}; // Formats a phone number
function $2902c761e76537bf$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $2902c761e76537bf$var$_objectSpread($2902c761e76537bf$var$_objectSpread({}, $2902c761e76537bf$var$DEFAULT_OPTIONS), options);
    else options = $2902c761e76537bf$var$DEFAULT_OPTIONS;
    metadata = new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== '001') {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || '';
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case 'NATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return '';
            number = $2902c761e76537bf$var$formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
            return $2902c761e76537bf$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'INTERNATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $2902c761e76537bf$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $2902c761e76537bf$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'E.164':
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case 'RFC3966':
            return (0, $be289f172febac88$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case 'IDD':
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $2902c761e76537bf$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $2902c761e76537bf$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
    }
}
function $2902c761e76537bf$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $2902c761e76537bf$var$chooseFormatForNumber(metadata.formats(), number);
    if (!format) return number;
    return (0, $b5a4891b4cbcc12b$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === 'INTERNATIONAL',
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $2902c761e76537bf$var$chooseFormatForNumber(availableFormats, nationalNnumber) {
    for(var _iterator = $2902c761e76537bf$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $8044f3ebcf8b24b6$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $2902c761e76537bf$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $2902c761e76537bf$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $9015f651de9f4947$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $2902c761e76537bf$var$formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === '1') return countryCallingCode + ' ' + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $df6a9c235632286d$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($2902c761e76537bf$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
}


function $b0f4723857faab4e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b0f4723857faab4e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b0f4723857faab4e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b0f4723857faab4e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b0f4723857faab4e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b0f4723857faab4e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b0f4723857faab4e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b0f4723857faab4e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b0f4723857faab4e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b0f4723857faab4e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b0f4723857faab4e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $b0f4723857faab4e$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $b0f4723857faab4e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
        $b0f4723857faab4e$var$_classCallCheck(this, PhoneNumber);
        if (!countryCallingCode) throw new TypeError('`country` or `countryCallingCode` not passed');
        if (!nationalNumber) throw new TypeError('`nationalNumber` not passed');
        if (!metadata) throw new TypeError('`metadata` not passed');
        var _metadata = new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(metadata); // If country code is passed then derive `countryCallingCode` from it.
        // Also store the country code as `.country`.
        if ($b0f4723857faab4e$var$isCountryCode(countryCallingCode)) {
            this.country = countryCallingCode;
            _metadata.country(countryCallingCode);
            countryCallingCode = _metadata.countryCallingCode();
        } else {
            /* istanbul ignore if */ if ($b0f4723857faab4e$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (_metadata.isNonGeographicCallingCode(countryCallingCode)) this.country = '001';
            }
        }
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = '+' + this.countryCallingCode + this.nationalNumber;
        this.metadata = metadata;
    }
    $b0f4723857faab4e$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $e006f14dd42652b2$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $b9fe382fad118608$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(this.metadata);
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // // Is just an alias for `this.isValid() && this.country === country`.
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $fc6aa5e4b5eeebd6$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $2902c761e76537bf$export$2e2bcd8739ae039)(this, _format, options ? $b0f4723857faab4e$var$_objectSpread($b0f4723857faab4e$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.metadata);
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format('NATIONAL', options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format('INTERNATIONAL', options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format('RFC3966', options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $b0f4723857faab4e$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};





var $eba8fd39ff2a7e3d$var$CAPTURING_DIGIT_PATTERN = new RegExp('([' + (0, $4dcf27eddf865fa7$export$852d1d4a47329634) + '])');
function $eba8fd39ff2a7e3d$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($eba8fd39ff2a7e3d$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === '0') return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $c72e6e88f61eb1d1$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $e7738c707d820085$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $c72e6e88f61eb1d1$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$e7738c707d820085$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$e7738c707d820085$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $e7738c707d820085$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $8044f3ebcf8b24b6$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $8044f3ebcf8b24b6$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $e7738c707d820085$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $869b1294b63aee25$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $b3dc7c8e6f22ab9d$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $9015f651de9f4947$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $e7738c707d820085$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $e7738c707d820085$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $8044f3ebcf8b24b6$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $8044f3ebcf8b24b6$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $869b1294b63aee25$export$2e2bcd8739ae039)(nationalNumber, metadata) === 'TOO_LONG') return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $d5feb9b8d0531eb2$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
     // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== '+') {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $eba8fd39ff2a7e3d$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) number = '+' + numberWithoutIDD;
        else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $b3dc7c8e6f22ab9d$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === '0') return {};
    metadata = new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $4dcf27eddf865fa7$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
}







function $468a09d2825a0975$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $468a09d2825a0975$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $468a09d2825a0975$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $468a09d2825a0975$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $468a09d2825a0975$var$_arrayLikeToArray(o, minLen);
}
function $468a09d2825a0975$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $468a09d2825a0975$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $468a09d2825a0975$export$2e2bcd8739ae039(callingCode, nationalPhoneNumber, metadata) {
    /* istanbul ignore if */ if ($468a09d2825a0975$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return '001';
    } // Is always non-empty, because `callingCode` is always valid
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return $468a09d2825a0975$var$selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata.metadata);
}
function $468a09d2825a0975$var$selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata) {
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(metadata);
    for(var _iterator = $468a09d2825a0975$var$_createForOfIteratorHelperLoose(possibleCountries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // Leading digits check would be the simplest and fastest one.
        // Leading digits patterns are only defined for about 20% of all countries.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // Matching "leading digits" is a sufficient but not necessary condition.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $fc6aa5e4b5eeebd6$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) return country;
    }
}


// This prevents malicious input from consuming CPU.
var $2857b715eeaaec33$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $2857b715eeaaec33$var$PHONE_NUMBER_START_PATTERN = new RegExp('[' + (0, $4dcf27eddf865fa7$export$207c99ccf3902df8) + (0, $4dcf27eddf865fa7$export$852d1d4a47329634) + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $2857b715eeaaec33$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + (0, $4dcf27eddf865fa7$export$852d1d4a47329634) + '#' + ']+$');
var $2857b715eeaaec33$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $2857b715eeaaec33$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $581d2488ab78f488$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $2857b715eeaaec33$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === 'TOO_SHORT') throw new (0, $581d2488ab78f488$export$2e2bcd8739ae039)('TOO_SHORT');
            throw new (0, $581d2488ab78f488$export$2e2bcd8739ae039)('NOT_A_NUMBER');
        }
        return {};
    }
    var _parsePhoneNumber = $2857b715eeaaec33$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $581d2488ab78f488$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $4dcf27eddf865fa7$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $581d2488ab78f488$export$2e2bcd8739ae039)('TOO_SHORT');
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $4dcf27eddf865fa7$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $581d2488ab78f488$export$2e2bcd8739ae039)('TOO_LONG');
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $b0f4723857faab4e$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $8044f3ebcf8b24b6$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $2857b715eeaaec33$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $e006f14dd42652b2$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $2857b715eeaaec33$var$extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $2857b715eeaaec33$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $581d2488ab78f488$export$2e2bcd8739ae039)('TOO_LONG');
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($2857b715eeaaec33$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($2857b715eeaaec33$var$AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $2857b715eeaaec33$var$parseInput(text, v2, extract) {
    // Parse RFC 3966 phone number URI.
    if (text && text.indexOf('tel:') === 0) return (0, $be289f172febac88$export$26fe644d7d92bb13)(text);
    var number = $2857b715eeaaec33$var$extractFormattedPhoneNumber(text, extract, v2); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $3d2447d044ba7f08$export$2e2bcd8739ae039)(number)) {
        if ((0, $3d2447d044ba7f08$export$4c3f76c95c05197c)(number)) return {
            error: 'TOO_SHORT'
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $57b39c5729bba6b3$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $2857b715eeaaec33$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $2857b715eeaaec33$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $d5feb9b8d0531eb2$export$2e2bcd8739ae039)((0, $d8bf16d5fafeec82$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($2857b715eeaaec33$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = '001';
            }
        }
        countryCallingCode = defaultCallingCode || (0, $9015f651de9f4947$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $e7738c707d820085$export$2e2bcd8739ae039)((0, $d8bf16d5fafeec82$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $468a09d2825a0975$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata);
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === '001') ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $c3e9fb29262b9e07$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c3e9fb29262b9e07$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c3e9fb29262b9e07$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c3e9fb29262b9e07$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c3e9fb29262b9e07$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c3e9fb29262b9e07$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c3e9fb29262b9e07$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $2857b715eeaaec33$export$2e2bcd8739ae039)(text, $c3e9fb29262b9e07$var$_objectSpread($c3e9fb29262b9e07$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}


function $11ccabd346d4ce10$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $11ccabd346d4ce10$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $11ccabd346d4ce10$var$_typeof(obj);
}
function $11ccabd346d4ce10$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $11ccabd346d4ce10$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $11ccabd346d4ce10$var$ownKeys(Object(source), !0).forEach(function(key) {
            $11ccabd346d4ce10$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $11ccabd346d4ce10$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $11ccabd346d4ce10$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $11ccabd346d4ce10$var$_slicedToArray(arr, i) {
    return $11ccabd346d4ce10$var$_arrayWithHoles(arr) || $11ccabd346d4ce10$var$_iterableToArrayLimit(arr, i) || $11ccabd346d4ce10$var$_unsupportedIterableToArray(arr, i) || $11ccabd346d4ce10$var$_nonIterableRest();
}
function $11ccabd346d4ce10$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $11ccabd346d4ce10$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $11ccabd346d4ce10$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $11ccabd346d4ce10$var$_arrayLikeToArray(o, minLen);
}
function $11ccabd346d4ce10$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $11ccabd346d4ce10$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $11ccabd346d4ce10$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $11ccabd346d4ce10$export$2e2bcd8739ae039() {
    var _normalizeArguments = $11ccabd346d4ce10$export$abc60e668512edf9(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $c3e9fb29262b9e07$export$2e2bcd8739ae039)(text, options, metadata);
}
function $11ccabd346d4ce10$export$abc60e668512edf9(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $11ccabd346d4ce10$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === 'string') text = arg_1;
    else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === 'string') {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $11ccabd346d4ce10$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ($11ccabd346d4ce10$var$isObject(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
} // Otherwise istanbul would show this as "branch not covered".
/* istanbul ignore next */ var $11ccabd346d4ce10$var$isObject = function isObject(_) {
    return $11ccabd346d4ce10$var$_typeof(_) === 'object';
};





function $bba73b2996a39da5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bba73b2996a39da5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bba73b2996a39da5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bba73b2996a39da5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bba73b2996a39da5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bba73b2996a39da5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bba73b2996a39da5$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $9015f651de9f4947$export$bd9e113b8b17202a)(options.defaultCountry, metadata)) options = $bba73b2996a39da5$var$_objectSpread($bba73b2996a39da5$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $c3e9fb29262b9e07$export$2e2bcd8739ae039)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $581d2488ab78f488$export$2e2bcd8739ae039)) ;
        else throw error;
    }
}


function $f39fb66294e78ae2$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $11ccabd346d4ce10$export$abc60e668512edf9)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $bba73b2996a39da5$export$2e2bcd8739ae039)(text, options, metadata);
}


function $cd11044a8c1dceb8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $cd11044a8c1dceb8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $cd11044a8c1dceb8$var$_typeof(obj);
}
function $cd11044a8c1dceb8$export$2e2bcd8739ae039(value, format, metadata) {
    if (!metadata) {
        if ($cd11044a8c1dceb8$var$_typeof(format) === 'object') {
            metadata = format;
            format = 'NATIONAL';
        }
    }
    if (!value) return '';
    var phoneNumber = (0, $f39fb66294e78ae2$export$2e2bcd8739ae039)(value, metadata);
    if (!phoneNumber) return '';
     // Deprecated.
    // Legacy `format`s.
    switch(format){
        case 'National':
            format = 'NATIONAL';
            break;
        case 'International':
            format = 'INTERNATIONAL';
            break;
    }
    return phoneNumber.format(format);
}
function $cd11044a8c1dceb8$export$88012462592bc004(value, metadata) {
    return $cd11044a8c1dceb8$export$2e2bcd8739ae039(value, 'INTERNATIONAL', metadata);
}


function $8075aa160ef6a59f$export$2e2bcd8739ae039(metadata) {
    return new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(metadata).getCountries();
}



function $b5d7fc59ba37c407$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b5d7fc59ba37c407$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b5d7fc59ba37c407$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b5d7fc59ba37c407$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b5d7fc59ba37c407$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b5d7fc59ba37c407$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b5d7fc59ba37c407$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $11ccabd346d4ce10$export$abc60e668512edf9)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $b5d7fc59ba37c407$var$_objectSpread($b5d7fc59ba37c407$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $bba73b2996a39da5$export$2e2bcd8739ae039)(text, options, metadata);
    return phoneNumber && phoneNumber.isPossible() || false;
}



function $5ed2bcabcdbe614f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5ed2bcabcdbe614f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5ed2bcabcdbe614f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5ed2bcabcdbe614f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5ed2bcabcdbe614f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5ed2bcabcdbe614f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5ed2bcabcdbe614f$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $11ccabd346d4ce10$export$abc60e668512edf9)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $5ed2bcabcdbe614f$var$_objectSpread($5ed2bcabcdbe614f$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $bba73b2996a39da5$export$2e2bcd8739ae039)(text, options, metadata);
    return phoneNumber && phoneNumber.isValid() || false;
}



var $6fFrj = parcelRequire("6fFrj");

var $640ed058ec39342f$export$2e2bcd8739ae039 = {
    "ext": "ext.",
    "country": "Phone number country",
    "phone": "Phone",
    "AB": "Abkhazia",
    "AC": "Ascension Island",
    "AD": "Andorra",
    "AE": "United Arab Emirates",
    "AF": "Afghanistan",
    "AG": "Antigua and Barbuda",
    "AI": "Anguilla",
    "AL": "Albania",
    "AM": "Armenia",
    "AO": "Angola",
    "AQ": "Antarctica",
    "AR": "Argentina",
    "AS": "American Samoa",
    "AT": "Austria",
    "AU": "Australia",
    "AW": "Aruba",
    "AX": "\xc5land Islands",
    "AZ": "Azerbaijan",
    "BA": "Bosnia and Herzegovina",
    "BB": "Barbados",
    "BD": "Bangladesh",
    "BE": "Belgium",
    "BF": "Burkina Faso",
    "BG": "Bulgaria",
    "BH": "Bahrain",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "Saint Barth\xe9lemy",
    "BM": "Bermuda",
    "BN": "Brunei Darussalam",
    "BO": "Bolivia",
    "BQ": "Bonaire, Sint Eustatius and Saba",
    "BR": "Brazil",
    "BS": "Bahamas",
    "BT": "Bhutan",
    "BV": "Bouvet Island",
    "BW": "Botswana",
    "BY": "Belarus",
    "BZ": "Belize",
    "CA": "Canada",
    "CC": "Cocos (Keeling) Islands",
    "CD": "Congo, Democratic Republic of the",
    "CF": "Central African Republic",
    "CG": "Congo",
    "CH": "Switzerland",
    "CI": "Cote d'Ivoire",
    "CK": "Cook Islands",
    "CL": "Chile",
    "CM": "Cameroon",
    "CN": "China",
    "CO": "Colombia",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Cape Verde",
    "CW": "Cura\xe7ao",
    "CX": "Christmas Island",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DE": "Germany",
    "DJ": "Djibouti",
    "DK": "Denmark",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "DZ": "Algeria",
    "EC": "Ecuador",
    "EE": "Estonia",
    "EG": "Egypt",
    "EH": "Western Sahara",
    "ER": "Eritrea",
    "ES": "Spain",
    "ET": "Ethiopia",
    "FI": "Finland",
    "FJ": "Fiji",
    "FK": "Falkland Islands",
    "FM": "Federated States of Micronesia",
    "FO": "Faroe Islands",
    "FR": "France",
    "GA": "Gabon",
    "GB": "United Kingdom",
    "GD": "Grenada",
    "GE": "Georgia",
    "GF": "French Guiana",
    "GG": "Guernsey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GL": "Greenland",
    "GM": "Gambia",
    "GN": "Guinea",
    "GP": "Guadeloupe",
    "GQ": "Equatorial Guinea",
    "GR": "Greece",
    "GS": "South Georgia and the South Sandwich Islands",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HK": "Hong Kong",
    "HM": "Heard Island and McDonald Islands",
    "HN": "Honduras",
    "HR": "Croatia",
    "HT": "Haiti",
    "HU": "Hungary",
    "ID": "Indonesia",
    "IE": "Ireland",
    "IL": "Israel",
    "IM": "Isle of Man",
    "IN": "India",
    "IO": "British Indian Ocean Territory",
    "IQ": "Iraq",
    "IR": "Iran",
    "IS": "Iceland",
    "IT": "Italy",
    "JE": "Jersey",
    "JM": "Jamaica",
    "JO": "Jordan",
    "JP": "Japan",
    "KE": "Kenya",
    "KG": "Kyrgyzstan",
    "KH": "Cambodia",
    "KI": "Kiribati",
    "KM": "Comoros",
    "KN": "Saint Kitts and Nevis",
    "KP": "North Korea",
    "KR": "South Korea",
    "KW": "Kuwait",
    "KY": "Cayman Islands",
    "KZ": "Kazakhstan",
    "LA": "Laos",
    "LB": "Lebanon",
    "LC": "Saint Lucia",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesotho",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "LV": "Latvia",
    "LY": "Libya",
    "MA": "Morocco",
    "MC": "Monaco",
    "MD": "Moldova",
    "ME": "Montenegro",
    "MF": "Saint Martin (French Part)",
    "MG": "Madagascar",
    "MH": "Marshall Islands",
    "MK": "North Macedonia",
    "ML": "Mali",
    "MM": "Myanmar",
    "MN": "Mongolia",
    "MO": "Macao",
    "MP": "Northern Mariana Islands",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Mauritius",
    "MV": "Maldives",
    "MW": "Malawi",
    "MX": "Mexico",
    "MY": "Malaysia",
    "MZ": "Mozambique",
    "NA": "Namibia",
    "NC": "New Caledonia",
    "NE": "Niger",
    "NF": "Norfolk Island",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Netherlands",
    "NO": "Norway",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "New Zealand",
    "OM": "Oman",
    "OS": "South Ossetia",
    "PA": "Panama",
    "PE": "Peru",
    "PF": "French Polynesia",
    "PG": "Papua New Guinea",
    "PH": "Philippines",
    "PK": "Pakistan",
    "PL": "Poland",
    "PM": "Saint Pierre and Miquelon",
    "PN": "Pitcairn",
    "PR": "Puerto Rico",
    "PS": "Palestine",
    "PT": "Portugal",
    "PW": "Palau",
    "PY": "Paraguay",
    "QA": "Qatar",
    "RE": "Reunion",
    "RO": "Romania",
    "RS": "Serbia",
    "RU": "Russia",
    "RW": "Rwanda",
    "SA": "Saudi Arabia",
    "SB": "Solomon Islands",
    "SC": "Seychelles",
    "SD": "Sudan",
    "SE": "Sweden",
    "SG": "Singapore",
    "SH": "Saint Helena",
    "SI": "Slovenia",
    "SJ": "Svalbard and Jan Mayen",
    "SK": "Slovakia",
    "SL": "Sierra Leone",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somalia",
    "SR": "Suriname",
    "SS": "South Sudan",
    "ST": "Sao Tome and Principe",
    "SV": "El Salvador",
    "SX": "Sint Maarten",
    "SY": "Syria",
    "SZ": "Swaziland",
    "TA": "Tristan da Cunha",
    "TC": "Turks and Caicos Islands",
    "TD": "Chad",
    "TF": "French Southern Territories",
    "TG": "Togo",
    "TH": "Thailand",
    "TJ": "Tajikistan",
    "TK": "Tokelau",
    "TL": "Timor-Leste",
    "TM": "Turkmenistan",
    "TN": "Tunisia",
    "TO": "Tonga",
    "TR": "Turkey",
    "TT": "Trinidad and Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwan",
    "TZ": "Tanzania",
    "UA": "Ukraine",
    "UG": "Uganda",
    "UM": "United States Minor Outlying Islands",
    "US": "United States",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VA": "Holy See (Vatican City State)",
    "VC": "Saint Vincent and the Grenadines",
    "VE": "Venezuela",
    "VG": "Virgin Islands, British",
    "VI": "Virgin Islands, U.S.",
    "VN": "Vietnam",
    "VU": "Vanuatu",
    "WF": "Wallis and Futuna",
    "WS": "Samoa",
    "XK": "Kosovo",
    "YE": "Yemen",
    "YT": "Mayotte",
    "ZA": "South Africa",
    "ZM": "Zambia",
    "ZW": "Zimbabwe",
    "ZZ": "International"
};



var $cgjHV = parcelRequire("cgjHV");
var $f666091b30e08e9b$export$dbb5e893e736e4ee = (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).shape({
    country_calling_codes: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
    countries: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired
});
var $f666091b30e08e9b$export$a238cb463698c900 = (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string);



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");
var $9c33d2044c0b2f89$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = '[native code]';
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(' ');
    }
    if (0, $9c33d2044c0b2f89$exports) {
        classNames.default = classNames;
        $9c33d2044c0b2f89$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");

var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");
// Edits text `value` (if `operation` is passed) and repositions the `caret` if needed.
//
// Example:
//
// value - '88005553535'
// caret - 2 // starting from 0; is positioned before the first zero
// operation - 'Backspace'
//
// Returns
// {
// 	value: '8005553535'
// 	caret: 1
// }
//
// Currently supports just 'Delete' and 'Backspace' operations
//
function $27c7bf4284f2ed42$export$2e2bcd8739ae039(value, caret, operation) {
    switch(operation){
        case 'Backspace':
            // If there exists the previous character,
            // then erase it and reposition the caret.
            if (caret > 0) {
                // Remove the previous character
                value = value.slice(0, caret - 1) + value.slice(caret); // Position the caret where the previous (erased) character was
                caret--;
            }
            break;
        case 'Delete':
            // Remove current digit (if any)
            value = value.slice(0, caret) + value.slice(caret + 1);
            break;
    }
    return {
        value: value,
        caret: caret
    };
}


// Parses the `text`.
//
// Returns `{ value, caret }` where `caret` is
// the caret position inside `value`
// corresponding to the `caret_position` inside `text`.
//
// The `text` is parsed by feeding each character sequentially to
// `parse_character(character, value)` function
// and appending the result (if it's not `undefined`) to `value`.
//
// Example:
//
// `text` is `8 (800) 555-35-35`,
// `caret_position` is `4` (before the first `0`).
// `parse_character` is `(character, value) =>
//   if (character >= '0' && character <= '9') { return character }`.
//
// then `parse()` outputs `{ value: '88005553535', caret: 2 }`.
//
function $16929506c1b34d97$export$2e2bcd8739ae039(text, caret_position, parse_character) {
    var value = '';
    var focused_input_character_index = 0;
    var index = 0;
    while(index < text.length){
        var character = parse_character(text[index], value);
        if (character !== undefined) {
            value += character;
            if (caret_position !== undefined) {
                if (caret_position === index) focused_input_character_index = value.length - 1;
                else if (caret_position > index) focused_input_character_index = value.length;
            }
        }
        index++;
    } // If caret position wasn't specified
    if (caret_position === undefined) // Then set caret position to "after the last input character"
    focused_input_character_index = value.length;
    var result = {
        value: value,
        caret: focused_input_character_index
    };
    return result;
}


function $70369746cf6e9a9b$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $70369746cf6e9a9b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $70369746cf6e9a9b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $70369746cf6e9a9b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $70369746cf6e9a9b$var$_arrayLikeToArray(o, minLen);
}
function $70369746cf6e9a9b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $70369746cf6e9a9b$export$15741e15817e73b8(symbol, string) {
    var count = 0; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes)
    // but template placeholder characters don't fall into that range
    // so skipping such miscellaneous "exotic" characters
    // won't matter here for just counting placeholder character occurrences.
    for(var _iterator = $70369746cf6e9a9b$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        if (character === symbol) count++;
    }
    return count;
}



function $ae2a3e0c2519a287$export$2e2bcd8739ae039(retained_template, template) {
    var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
    var empty_placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
    var cut_before = retained_template.length;
    var opening_braces = (0, $70369746cf6e9a9b$export$15741e15817e73b8)('(', retained_template);
    var closing_braces = (0, $70369746cf6e9a9b$export$15741e15817e73b8)(')', retained_template);
    var dangling_braces = opening_braces - closing_braces;
    while(dangling_braces > 0 && cut_before < template.length){
        retained_template += template[cut_before].replace(placeholder, empty_placeholder);
        if (template[cut_before] === ')') dangling_braces--;
        cut_before++;
    }
    return retained_template;
}


function $805542e451922db6$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $805542e451922db6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $805542e451922db6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $805542e451922db6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $805542e451922db6$var$_arrayLikeToArray(o, minLen);
}
function $805542e451922db6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $805542e451922db6$export$2e2bcd8739ae039(template) {
    var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
    var should_close_braces = arguments.length > 2 ? arguments[2] : undefined;
    if (!template) return function(value) {
        return {
            text: value
        };
    };
    var characters_in_template = (0, $70369746cf6e9a9b$export$15741e15817e73b8)(placeholder, template);
    return function(value) {
        if (!value) return {
            text: '',
            template: template
        };
        var value_character_index = 0;
        var filled_in_template = ''; // Using `.split('')` here instead of normal `for ... of`
        // because the importing application doesn't neccessarily include an ES6 polyfill.
        // The `.split('')` approach discards "exotic" UTF-8 characters
        // (the ones consisting of four bytes)
        // but template placeholder characters don't fall into that range
        // and appending UTF-8 characters to a string in parts still works.
        for(var _iterator = $805542e451922db6$var$_createForOfIteratorHelperLoose(template.split('')), _step; !(_step = _iterator()).done;){
            var character = _step.value;
            if (character !== placeholder) {
                filled_in_template += character;
                continue;
            }
            filled_in_template += value[value_character_index];
            value_character_index++; // If the last available value character has been filled in,
            // then return the filled in template
            // (either trim the right part or retain it,
            //  if no more character placeholders in there)
            if (value_character_index === value.length) {
                // If there are more character placeholders
                // in the right part of the template
                // then simply trim it.
                if (value.length < characters_in_template) break;
            }
        }
        if (should_close_braces) filled_in_template = (0, $ae2a3e0c2519a287$export$2e2bcd8739ae039)(filled_in_template, template);
        return {
            text: filled_in_template,
            template: template
        };
    };
}


function $9b4f8045bb8c35ae$export$2e2bcd8739ae039(value, caret, formatter) {
    if (typeof formatter === 'string') formatter = (0, $805542e451922db6$export$2e2bcd8739ae039)(formatter);
    var _ref = formatter(value) || {}, text = _ref.text, template = _ref.template;
    if (text === undefined) text = value;
    if (template) {
        if (caret === undefined) caret = text.length;
        else {
            var index = 0;
            var found = false;
            var possibly_last_input_character_index = -1;
            while(index < text.length && index < template.length){
                // Character placeholder found
                if (text[index] !== template[index]) {
                    if (caret === 0) {
                        found = true;
                        caret = index;
                        break;
                    }
                    possibly_last_input_character_index = index;
                    caret--;
                }
                index++;
            } // If the caret was positioned after last input character,
            // then the text caret index is just after the last input character.
            if (!found) caret = possibly_last_input_character_index + 1;
        }
    }
    return {
        text: text,
        caret: caret
    };
}


function $fc124985204eb338$export$2498094d90b6ac72(element) {
    return element.hasAttribute('readonly');
} // Gets <input/> selection bounds
function $fc124985204eb338$export$ca798a7e6e94638c(element) {
    // If no selection, return nothing
    if (element.selectionStart === element.selectionEnd) return;
    return {
        start: element.selectionStart,
        end: element.selectionEnd
    };
} // Key codes
var $fc124985204eb338$export$4b0075e5ea5e1f26 = {
    Backspace: 8,
    Delete: 46
}; // Finds out the operation to be intercepted and performed
function $fc124985204eb338$export$d4e837035315abd8(event) {
    switch(event.keyCode){
        case $fc124985204eb338$export$4b0075e5ea5e1f26.Backspace:
            return 'Backspace';
        case $fc124985204eb338$export$4b0075e5ea5e1f26.Delete:
            return 'Delete';
    }
} // Gets <input/> caret position
function $fc124985204eb338$export$7d120213748299d3(element) {
    return element.selectionStart;
} // Sets <input/> caret position
function $fc124985204eb338$export$97ab23b40042f8af(element, caret_position) {
    // Sanity check
    if (caret_position === undefined) return;
     // Set caret position.
    // There has been an issue with caret positioning on Android devices.
    // https://github.com/catamphetamine/input-format/issues/2
    // I was revisiting this issue and looked for similar issues in other libraries.
    // For example, there's [`text-mask`](https://github.com/text-mask/text-mask) library.
    // They've had exactly the same issue when the caret seemingly refused to be repositioned programmatically.
    // The symptoms were the same: whenever the caret passed through a non-digit character of a mask (a whitespace, a bracket, a dash, etc), it looked as if it placed itself one character before its correct position.
    // https://github.com/text-mask/text-mask/issues/300
    // They seem to have found a basic fix for it: calling `input.setSelectionRange()` in a timeout rather than instantly for Android devices.
    // https://github.com/text-mask/text-mask/pull/400/files
    // I've implemented the same workaround here.
    if ($fc124985204eb338$var$isAndroid()) setTimeout(function() {
        return element.setSelectionRange(caret_position, caret_position);
    }, 0);
    else element.setSelectionRange(caret_position, caret_position);
}
function $fc124985204eb338$var$isAndroid() {
    // `navigator` is not defined when running mocha tests.
    if (typeof navigator !== 'undefined') return $fc124985204eb338$var$ANDROID_USER_AGENT_REG_EXP.test(navigator.userAgent);
}
var $fc124985204eb338$var$ANDROID_USER_AGENT_REG_EXP = /Android/i;


function $d8dbb45b0ad9721a$export$330ca67a316b532c(event, input, _parse, _format, on_change) {
    if ((0, $fc124985204eb338$export$2498094d90b6ac72)(input)) return;
     // The actual cut hasn't happened just yet hence the timeout.
    setTimeout(function() {
        return $d8dbb45b0ad9721a$var$formatInputText(input, _parse, _format, undefined, on_change);
    }, 0);
} // Deprecated.
function $d8dbb45b0ad9721a$export$48aae1120b60938a(event, input, _parse, _format, on_change) {
    if ((0, $fc124985204eb338$export$2498094d90b6ac72)(input)) return;
    var selection = (0, $fc124985204eb338$export$ca798a7e6e94638c)(input); // If selection is made,
    // just erase the selected text
    // prior to pasting
    if (selection) $d8dbb45b0ad9721a$var$eraseSelection(input, selection);
    $d8dbb45b0ad9721a$var$formatInputText(input, _parse, _format, undefined, on_change);
}
function $d8dbb45b0ad9721a$export$bd913411069e59d3(event, input, _parse, _format, on_change) {
    $d8dbb45b0ad9721a$var$formatInputText(input, _parse, _format, undefined, on_change);
} // "Delete" and "Backspace" keys are special
function $d8dbb45b0ad9721a$export$de8e1b1372cdb41b(event, input, _parse, _format, on_change) {
    if ((0, $fc124985204eb338$export$2498094d90b6ac72)(input)) return;
    var operation = (0, $fc124985204eb338$export$d4e837035315abd8)(event);
    switch(operation){
        case 'Delete':
        case 'Backspace':
            // Intercept this operation and perform it manually.
            event.preventDefault();
            var selection = (0, $fc124985204eb338$export$ca798a7e6e94638c)(input); // If a selection is made, just erase the selected text.
            if (selection) {
                $d8dbb45b0ad9721a$var$eraseSelection(input, selection);
                return $d8dbb45b0ad9721a$var$formatInputText(input, _parse, _format, undefined, on_change);
            } // Else, perform the (character erasing) operation manually.
            return $d8dbb45b0ad9721a$var$formatInputText(input, _parse, _format, operation, on_change);
        default:
    }
}
/**
 * Erases the selected text inside an `<input/>`.
 * @param  {DOMElement} input
 * @param  {Selection} selection
 */ function $d8dbb45b0ad9721a$var$eraseSelection(input, selection) {
    var text = input.value;
    text = text.slice(0, selection.start) + text.slice(selection.end);
    input.value = text;
    (0, $fc124985204eb338$export$97ab23b40042f8af)(input, selection.start);
}
/**
 * Parses and re-formats `<input/>` textual value.
 * E.g. when a user enters something into the `<input/>`
 * that raw input must first be parsed and the re-formatted properly.
 * Is called either after some user input (e.g. entered a character, pasted something)
 * or after the user performed an `operation` (e.g. "Backspace", "Delete").
 * @param  {DOMElement} input
 * @param  {Function} parse
 * @param  {Function} format
 * @param  {string} [operation] - The operation that triggered `<input/>` textual value change. E.g. "Backspace", "Delete".
 * @param  {Function} onChange
 */ function $d8dbb45b0ad9721a$var$formatInputText(input, _parse, _format, operation, on_change) {
    // Parse `<input/>` textual value.
    // Get the `value` and `caret` position.
    var _parse2 = (0, $16929506c1b34d97$export$2e2bcd8739ae039)(input.value, (0, $fc124985204eb338$export$7d120213748299d3)(input), _parse), value = _parse2.value, caret = _parse2.caret; // If a user performed an operation ("Backspace", "Delete")
    // then apply that operation and get the new `value` and `caret` position.
    if (operation) {
        var newValueAndCaret = (0, $27c7bf4284f2ed42$export$2e2bcd8739ae039)(value, caret, operation);
        value = newValueAndCaret.value;
        caret = newValueAndCaret.caret;
    } // Format the `value`.
    // (and reposition the caret accordingly)
    var formatted = (0, $9b4f8045bb8c35ae$export$2e2bcd8739ae039)(value, caret, _format);
    var text = formatted.text;
    caret = formatted.caret; // Set `<input/>` textual value manually
    // to prevent React from resetting the caret position
    // later inside a subsequent `render()`.
    // Doesn't work for custom `inputComponent`s for some reason.
    input.value = text; // Position the caret properly.
    (0, $fc124985204eb338$export$97ab23b40042f8af)(input, caret); // If the `<input/>` textual value did change,
    // then the parsed `value` may have changed too.
    on_change(value);
}


var $346aa9da61e1b764$var$_excluded = [
    "value",
    "parse",
    "format",
    "inputComponent",
    "onChange",
    "onKeyDown"
];
function $346aa9da61e1b764$var$_extends() {
    $346aa9da61e1b764$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $346aa9da61e1b764$var$_extends.apply(this, arguments);
}
function $346aa9da61e1b764$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $346aa9da61e1b764$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $346aa9da61e1b764$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
//
// <ReactInput
// 	value={this.state.phone}
// 	onChange={phone => this.setState({ phone })}
// 	parse={character => character}
// 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
//
function $346aa9da61e1b764$var$Input(_ref, ref) {
    var value = _ref.value, parse = _ref.parse, format = _ref.format, InputComponent = _ref.inputComponent, onChange = _ref.onChange, onKeyDown = _ref.onKeyDown, rest = $346aa9da61e1b764$var$_objectWithoutProperties(_ref, $346aa9da61e1b764$var$_excluded);
    var internalRef = (0, $6fFrj.useRef)();
    var setRef = (0, $6fFrj.useCallback)(function(instance) {
        internalRef.current = instance;
        if (ref) {
            if (typeof ref === 'function') ref(instance);
            else ref.current = instance;
        }
    }, [
        ref
    ]);
    var _onChange = (0, $6fFrj.useCallback)(function(event) {
        return (0, $d8dbb45b0ad9721a$export$bd913411069e59d3)(event, internalRef.current, parse, format, onChange);
    }, [
        internalRef,
        parse,
        format,
        onChange
    ]);
    var _onKeyDown = (0, $6fFrj.useCallback)(function(event) {
        if (onKeyDown) onKeyDown(event);
        return (0, $d8dbb45b0ad9721a$export$de8e1b1372cdb41b)(event, internalRef.current, parse, format, onChange);
    }, [
        internalRef,
        parse,
        format,
        onChange,
        onKeyDown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(InputComponent, $346aa9da61e1b764$var$_extends({}, rest, {
        ref: setRef,
        value: format($346aa9da61e1b764$var$isEmptyValue(value) ? '' : value).text,
        onKeyDown: _onKeyDown,
        onChange: _onChange
    }));
}
$346aa9da61e1b764$var$Input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef($346aa9da61e1b764$var$Input);
$346aa9da61e1b764$var$Input.propTypes = {
    // Parses a single characher of `<input/>` text.
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired,
    // Formats `value` into `<input/>` text.
    format: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired,
    // Renders `<input/>` by default.
    inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).elementType.isRequired,
    // `<input/>` `type` attribute.
    type: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired,
    // Is parsed from <input/> text.
    value: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    // This handler is called each time `<input/>` text is changed.
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired,
    // Passthrough
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onCut: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onPaste: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func
};
$346aa9da61e1b764$var$Input.defaultProps = {
    // Renders `<input/>` by default.
    inputComponent: 'input',
    // `<input/>` `type` attribute.
    type: 'text'
};
var $346aa9da61e1b764$export$2e2bcd8739ae039 = $346aa9da61e1b764$var$Input;
function $346aa9da61e1b764$var$isEmptyValue(value) {
    return value === undefined || value === null;
}




function $0047f7ab4f91ccb1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0047f7ab4f91ccb1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0047f7ab4f91ccb1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0047f7ab4f91ccb1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0047f7ab4f91ccb1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $0047f7ab4f91ccb1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeState(_ref) {
        var onCountryChange = _ref.onCountryChange, onCallingCodeChange = _ref.onCallingCodeChange;
        $0047f7ab4f91ccb1$var$_classCallCheck(this, AsYouTypeState);
        this.onCountryChange = onCountryChange;
        this.onCallingCodeChange = onCallingCodeChange;
    }
    $0047f7ab4f91ccb1$var$_createClass(AsYouTypeState, [
        {
            key: "reset",
            value: function reset(defaultCountry, defaultCallingCode) {
                this.international = false;
                this.IDDPrefix = undefined;
                this.missingPlus = undefined;
                this.callingCode = undefined;
                this.digits = '';
                this.resetNationalSignificantNumber();
                this.initCountryAndCallingCode(defaultCountry, defaultCallingCode);
            }
        },
        {
            key: "resetNationalSignificantNumber",
            value: function resetNationalSignificantNumber() {
                this.nationalSignificantNumber = this.getNationalDigits();
                this.nationalSignificantNumberMatchesInput = true;
                this.nationalPrefix = undefined;
                this.carrierCode = undefined;
                this.complexPrefixBeforeNationalSignificantNumber = undefined;
            }
        },
        {
            key: "update",
            value: function update(properties) {
                for(var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++){
                    var key = _Object$keys[_i];
                    this[key] = properties[key];
                }
            }
        },
        {
            key: "initCountryAndCallingCode",
            value: function initCountryAndCallingCode(country, callingCode) {
                this.setCountry(country);
                this.setCallingCode(callingCode);
            }
        },
        {
            key: "setCountry",
            value: function setCountry(country) {
                this.country = country;
                this.onCountryChange(country);
            }
        },
        {
            key: "setCallingCode",
            value: function setCallingCode(callingCode) {
                this.callingCode = callingCode;
                this.onCallingCodeChange(callingCode, this.country);
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(country, callingCode) {
                // Prepend the `+` to parsed input.
                this.international = true; // If a default country was set then reset it
                // because an explicitly international phone
                // number is being entered.
                this.initCountryAndCallingCode(country, callingCode);
            }
        },
        {
            key: "appendDigits",
            value: function appendDigits(nextDigits) {
                this.digits += nextDigits;
            }
        },
        {
            key: "appendNationalSignificantNumberDigits",
            value: function appendNationalSignificantNumberDigits(nextDigits) {
                this.nationalSignificantNumber += nextDigits;
            }
        },
        {
            key: "getNationalDigits",
            value: function getNationalDigits() {
                if (this.international) return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
                return this.digits;
            }
        },
        {
            key: "getDigitsWithoutInternationalPrefix",
            value: function getDigitsWithoutInternationalPrefix() {
                if (this.international) {
                    if (this.IDDPrefix) return this.digits.slice(this.IDDPrefix.length);
                }
                return this.digits;
            }
        }
    ]);
    return AsYouTypeState;
}();


function $20276fa3fe3d75a9$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $20276fa3fe3d75a9$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $20276fa3fe3d75a9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $20276fa3fe3d75a9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $20276fa3fe3d75a9$var$_arrayLikeToArray(o, minLen);
}
function $20276fa3fe3d75a9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $20276fa3fe3d75a9$export$2a0174a7c311f338 = 'x'; // '\u2008' (punctuation space)
var $20276fa3fe3d75a9$var$DIGIT_PLACEHOLDER_MATCHER = new RegExp($20276fa3fe3d75a9$export$2a0174a7c311f338); // Counts all occurences of a symbol in a string.
function $20276fa3fe3d75a9$export$af0de81b5898251d(symbol, string) {
    var count = 0; // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for counting brackets it is safe.
    // for (const character of string)
    for(var _iterator = $20276fa3fe3d75a9$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        if (character === symbol) count++;
    }
    return count;
} // Repeats a string (or a symbol) N times.
function $20276fa3fe3d75a9$export$76d90c956114f2c2(string, times) {
    if (times < 1) return '';
    var result = '';
    while(times > 1){
        if (times & 1) result += string;
        times >>= 1;
        string += string;
    }
    return result + string;
}
function $20276fa3fe3d75a9$export$ac095dcff0205861(string, cutBeforeIndex) {
    if (string[cutBeforeIndex] === ')') cutBeforeIndex++;
    return $20276fa3fe3d75a9$export$a464e056bc212edb(string.slice(0, cutBeforeIndex));
}
function $20276fa3fe3d75a9$export$54ba366c9ffed8f9(template, cut_before) {
    var retained_template = template.slice(0, cut_before);
    var opening_braces = $20276fa3fe3d75a9$export$af0de81b5898251d('(', retained_template);
    var closing_braces = $20276fa3fe3d75a9$export$af0de81b5898251d(')', retained_template);
    var dangling_braces = opening_braces - closing_braces;
    while(dangling_braces > 0 && cut_before < template.length){
        if (template[cut_before] === ')') dangling_braces--;
        cut_before++;
    }
    return template.slice(0, cut_before);
}
function $20276fa3fe3d75a9$export$a464e056bc212edb(string) {
    var dangling_braces = [];
    var i = 0;
    while(i < string.length){
        if (string[i] === '(') dangling_braces.push(i);
        else if (string[i] === ')') dangling_braces.pop();
        i++;
    }
    var start = 0;
    var cleared_string = '';
    dangling_braces.push(string.length);
    for(var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++){
        var index = _dangling_braces[_i];
        cleared_string += string.slice(start, index);
        start = index + 1;
    }
    return cleared_string;
}
function $20276fa3fe3d75a9$export$a15547494b55ca4e(template, position, digits) {
    // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for `digits` it is safe.
    // for (const digit of digits)
    for(var _iterator2 = $20276fa3fe3d75a9$var$_createForOfIteratorHelperLoose(digits.split('')), _step2; !(_step2 = _iterator2()).done;){
        var digit = _step2.value;
        // If there is room for more digits in current `template`,
        // then set the next digit in the `template`,
        // and return the formatted digits so far.
        // If more digits are entered than the current format could handle.
        if (template.slice(position + 1).search($20276fa3fe3d75a9$var$DIGIT_PLACEHOLDER_MATCHER) < 0) return;
        position = template.search($20276fa3fe3d75a9$var$DIGIT_PLACEHOLDER_MATCHER);
        template = template.replace($20276fa3fe3d75a9$var$DIGIT_PLACEHOLDER_MATCHER, digit);
    }
    return [
        template,
        position
    ];
}





function $58a38209305e84b5$export$2e2bcd8739ae039(state, format, _ref) {
    var metadata = _ref.metadata, shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
    var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));
    if (matcher.test(state.nationalSignificantNumber)) return $58a38209305e84b5$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
        metadata: metadata,
        shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
}
function $58a38209305e84b5$export$9e33d25ea5d3e526(nationalSignificantNumber, metadata) {
    return (0, $869b1294b63aee25$export$2e2bcd8739ae039)(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}
function $58a38209305e84b5$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
    var metadata = _ref2.metadata, shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
    // `format` has already been checked for `nationalPrefix` requirement.
    var nationalSignificantNumber = state.nationalSignificantNumber, international = state.international, nationalPrefix = state.nationalPrefix, carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
    // If the resulting formatted number is a valid formatted number, then return it.
    //
    // Google's AsYouType formatter is different in a way that it doesn't try
    // to format using the "national prefix formatting rule", and instead it
    // simply prepends a national prefix followed by a " " character.
    // This code does that too, but as a fallback.
    // The reason is that "national prefix formatting rule" may use parentheses,
    // which wouldn't be included has it used the simpler Google's way.
    //
    if (shouldTryNationalPrefixFormattingRule(format)) {
        var formattedNumber = $58a38209305e84b5$var$formatNationalNumber(state, format, {
            useNationalPrefixFormattingRule: true,
            getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
            metadata: metadata
        });
        if (formattedNumber) return formattedNumber;
    } // Format the number without using `national_prefix_formatting_rule`.
    return $58a38209305e84b5$var$formatNationalNumber(state, format, {
        useNationalPrefixFormattingRule: false,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
        metadata: metadata
    });
}
function $58a38209305e84b5$var$formatNationalNumber(state, format, _ref3) {
    var metadata = _ref3.metadata, useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
    var formattedNationalNumber = (0, $b5a4891b4cbcc12b$export$2e2bcd8739ae039)(state.nationalSignificantNumber, format, {
        carrierCode: state.carrierCode,
        useInternationalFormat: state.international,
        withNationalPrefix: useNationalPrefixFormattingRule,
        metadata: metadata
    });
    if (!useNationalPrefixFormattingRule) {
        if (state.nationalPrefix) // If a national prefix was extracted, then just prepend it,
        // followed by a " " character.
        formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
        else if (state.complexPrefixBeforeNationalSignificantNumber) formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
    if ($58a38209305e84b5$var$isValidFormattedNationalNumber(formattedNationalNumber, state)) return formattedNationalNumber;
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//
function $58a38209305e84b5$var$isValidFormattedNationalNumber(formattedNationalNumber, state) {
    return (0, $36e358bc9b5a1121$export$2e2bcd8739ae039)(formattedNationalNumber) === state.getNationalDigits();
}


function $5aad9b85855dd30c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5aad9b85855dd30c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5aad9b85855dd30c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5aad9b85855dd30c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5aad9b85855dd30c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $5aad9b85855dd30c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PatternParser() {
        $5aad9b85855dd30c$var$_classCallCheck(this, PatternParser);
    }
    $5aad9b85855dd30c$var$_createClass(PatternParser, [
        {
            key: "parse",
            value: function parse(pattern) {
                this.context = [
                    {
                        or: true,
                        instructions: []
                    }
                ];
                this.parsePattern(pattern);
                if (this.context.length !== 1) throw new Error('Non-finalized contexts left when pattern parse ended');
                var _this$context$ = this.context[0], branches = _this$context$.branches, instructions = _this$context$.instructions;
                if (branches) return {
                    op: '|',
                    args: branches.concat([
                        $5aad9b85855dd30c$var$expandSingleElementArray(instructions)
                    ])
                };
                /* istanbul ignore if */ if (instructions.length === 0) throw new Error('Pattern is required');
                if (instructions.length === 1) return instructions[0];
                return instructions;
            }
        },
        {
            key: "startContext",
            value: function startContext(context) {
                this.context.push(context);
            }
        },
        {
            key: "endContext",
            value: function endContext() {
                this.context.pop();
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return this.context[this.context.length - 1];
            }
        },
        {
            key: "parsePattern",
            value: function parsePattern(pattern) {
                if (!pattern) throw new Error('Pattern is required');
                var match = pattern.match($5aad9b85855dd30c$var$OPERATOR);
                if (!match) {
                    if ($5aad9b85855dd30c$var$ILLEGAL_CHARACTER_REGEXP.test(pattern)) throw new Error("Illegal characters found in a pattern: ".concat(pattern));
                    this.getContext().instructions = this.getContext().instructions.concat(pattern.split(''));
                    return;
                }
                var operator = match[1];
                var before = pattern.slice(0, match.index);
                var rightPart = pattern.slice(match.index + operator.length);
                switch(operator){
                    case '(?:':
                        if (before) this.parsePattern(before);
                        this.startContext({
                            or: true,
                            instructions: [],
                            branches: []
                        });
                        break;
                    case ')':
                        if (!this.getContext().or) throw new Error('")" operator must be preceded by "(?:" operator');
                        if (before) this.parsePattern(before);
                        if (this.getContext().instructions.length === 0) throw new Error('No instructions found after "|" operator in an "or" group');
                        var _this$getContext = this.getContext(), branches = _this$getContext.branches;
                        branches.push($5aad9b85855dd30c$var$expandSingleElementArray(this.getContext().instructions));
                        this.endContext();
                        this.getContext().instructions.push({
                            op: '|',
                            args: branches
                        });
                        break;
                    case '|':
                        if (!this.getContext().or) throw new Error('"|" operator can only be used inside "or" groups');
                        if (before) this.parsePattern(before);
                         // The top-level is an implicit "or" group, if required.
                        if (!this.getContext().branches) {
                            // `branches` are not defined only for the root implicit "or" operator.
                            /* istanbul ignore else */ if (this.context.length === 1) this.getContext().branches = [];
                            else throw new Error('"branches" not found in an "or" group context');
                        }
                        this.getContext().branches.push($5aad9b85855dd30c$var$expandSingleElementArray(this.getContext().instructions));
                        this.getContext().instructions = [];
                        break;
                    case '[':
                        if (before) this.parsePattern(before);
                        this.startContext({
                            oneOfSet: true
                        });
                        break;
                    case ']':
                        if (!this.getContext().oneOfSet) throw new Error('"]" operator must be preceded by "[" operator');
                        this.endContext();
                        this.getContext().instructions.push({
                            op: '[]',
                            args: $5aad9b85855dd30c$var$parseOneOfSet(before)
                        });
                        break;
                    /* istanbul ignore next */ default:
                        throw new Error("Unknown operator: ".concat(operator));
                }
                if (rightPart) this.parsePattern(rightPart);
            }
        }
    ]);
    return PatternParser;
}();
function $5aad9b85855dd30c$var$parseOneOfSet(pattern) {
    var values = [];
    var i = 0;
    while(i < pattern.length){
        if (pattern[i] === '-') {
            if (i === 0 || i === pattern.length - 1) throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
            var prevValue = pattern[i - 1].charCodeAt(0) + 1;
            var nextValue = pattern[i + 1].charCodeAt(0) - 1;
            var value = prevValue;
            while(value <= nextValue){
                values.push(String.fromCharCode(value));
                value++;
            }
        } else values.push(pattern[i]);
        i++;
    }
    return values;
}
var $5aad9b85855dd30c$var$ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
var $5aad9b85855dd30c$var$OPERATOR = new RegExp("(\\||\\(\\?\\:|\\)|\\[|\\])");
function $5aad9b85855dd30c$var$expandSingleElementArray(array) {
    if (array.length === 1) return array[0];
    return array;
}


function $63fd28f5f7876235$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $63fd28f5f7876235$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $63fd28f5f7876235$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $63fd28f5f7876235$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $63fd28f5f7876235$var$_arrayLikeToArray(o, minLen);
}
function $63fd28f5f7876235$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $63fd28f5f7876235$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $63fd28f5f7876235$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $63fd28f5f7876235$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $63fd28f5f7876235$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $63fd28f5f7876235$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $63fd28f5f7876235$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PatternMatcher(pattern) {
        $63fd28f5f7876235$var$_classCallCheck(this, PatternMatcher);
        this.matchTree = new (0, $5aad9b85855dd30c$export$2e2bcd8739ae039)().parse(pattern);
    }
    $63fd28f5f7876235$var$_createClass(PatternMatcher, [
        {
            key: "match",
            value: function match(string) {
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, allowOverflow = _ref.allowOverflow;
                if (!string) throw new Error('String is required');
                var result = $63fd28f5f7876235$var$_match(string.split(''), this.matchTree, true);
                if (result && result.match) delete result.matchedChars;
                if (result && result.overflow) {
                    if (!allowOverflow) return;
                }
                return result;
            }
        }
    ]);
    return PatternMatcher;
}();
function $63fd28f5f7876235$var$_match(characters, tree, last) {
    // If `tree` is a string, then `tree` is a single character.
    // That's because when a pattern is parsed, multi-character-string parts
    // of a pattern are compiled into arrays of single characters.
    // I still wrote this piece of code for a "general" hypothetical case
    // when `tree` could be a string of several characters, even though
    // such case is not possible with the current implementation.
    if (typeof tree === 'string') {
        var characterString = characters.join('');
        if (tree.indexOf(characterString) === 0) {
            // `tree` is always a single character.
            // If `tree.indexOf(characterString) === 0`
            // then `characters.length === tree.length`.
            /* istanbul ignore else */ if (characters.length === tree.length) return {
                match: true,
                matchedChars: characters
            };
             // `tree` is always a single character.
            // If `tree.indexOf(characterString) === 0`
            // then `characters.length === tree.length`.
            /* istanbul ignore next */ return {
                partialMatch: true // matchedChars: characters
            };
        }
        if (characterString.indexOf(tree) === 0) {
            if (last) {
                // The `else` path is not possible because `tree` is always a single character.
                // The `else` case for `characters.length > tree.length` would be
                // `characters.length <= tree.length` which means `characters.length <= 1`.
                // `characters` array can't be empty, so that means `characters === [tree]`,
                // which would also mean `tree.indexOf(characterString) === 0` and that'd mean
                // that the `if (tree.indexOf(characterString) === 0)` condition before this
                // `if` condition would be entered, and returned from there, not reaching this code.
                /* istanbul ignore else */ if (characters.length > tree.length) return {
                    overflow: true
                };
            }
            return {
                match: true,
                matchedChars: characters.slice(0, tree.length)
            };
        }
        return;
    }
    if (Array.isArray(tree)) {
        var restCharacters = characters.slice();
        var i = 0;
        while(i < tree.length){
            var subtree = tree[i];
            var result = $63fd28f5f7876235$var$_match(restCharacters, subtree, last && i === tree.length - 1);
            if (!result) return;
            else if (result.overflow) return result;
            else if (result.match) {
                // Continue with the next subtree with the rest of the characters.
                restCharacters = restCharacters.slice(result.matchedChars.length);
                if (restCharacters.length === 0) {
                    if (i === tree.length - 1) return {
                        match: true,
                        matchedChars: characters
                    };
                    else return {
                        partialMatch: true // matchedChars: characters
                    };
                }
            } else {
                /* istanbul ignore else */ if (result.partialMatch) return {
                    partialMatch: true // matchedChars: characters
                };
                else throw new Error("Unsupported match result:\n".concat(JSON.stringify(result, null, 2)));
            }
            i++;
        } // If `last` then overflow has already been checked
        // by the last element of the `tree` array.
        /* istanbul ignore if */ if (last) return {
            overflow: true
        };
        return {
            match: true,
            matchedChars: characters.slice(0, characters.length - restCharacters.length)
        };
    }
    switch(tree.op){
        case '|':
            var partialMatch;
            for(var _iterator = $63fd28f5f7876235$var$_createForOfIteratorHelperLoose(tree.args), _step; !(_step = _iterator()).done;){
                var branch = _step.value;
                var _result = $63fd28f5f7876235$var$_match(characters, branch, last);
                if (_result) {
                    if (_result.overflow) return _result;
                    else if (_result.match) return {
                        match: true,
                        matchedChars: _result.matchedChars
                    };
                    else {
                        /* istanbul ignore else */ if (_result.partialMatch) partialMatch = true;
                        else throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
                    }
                }
            }
            if (partialMatch) return {
                partialMatch: true // matchedChars: ...
            };
             // Not even a partial match.
            return;
        case '[]':
            for(var _iterator2 = $63fd28f5f7876235$var$_createForOfIteratorHelperLoose(tree.args), _step2; !(_step2 = _iterator2()).done;){
                var _char = _step2.value;
                if (characters[0] === _char) {
                    if (characters.length === 1) return {
                        match: true,
                        matchedChars: characters
                    };
                    if (last) return {
                        overflow: true
                    };
                    return {
                        match: true,
                        matchedChars: [
                            _char
                        ]
                    };
                }
            } // No character matches.
            return;
        /* istanbul ignore next */ default:
            throw new Error("Unsupported instruction tree: ".concat(tree));
    }
}






function $2a672013d8ef6cc4$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $2a672013d8ef6cc4$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2a672013d8ef6cc4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2a672013d8ef6cc4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2a672013d8ef6cc4$var$_arrayLikeToArray(o, minLen);
}
function $2a672013d8ef6cc4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2a672013d8ef6cc4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2a672013d8ef6cc4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2a672013d8ef6cc4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2a672013d8ef6cc4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2a672013d8ef6cc4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// Could be any digit, I guess.
var $2a672013d8ef6cc4$var$DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`
var $2a672013d8ef6cc4$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.
var $2a672013d8ef6cc4$var$LONGEST_DUMMY_PHONE_NUMBER = (0, $20276fa3fe3d75a9$export$76d90c956114f2c2)($2a672013d8ef6cc4$var$DUMMY_DIGIT, $2a672013d8ef6cc4$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.
var $2a672013d8ef6cc4$var$NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
// "We no longer have numbers in formatting matching patterns, only \d."
// Because this library supports generating custom metadata
// some users may still be using old metadata so the relevant
// code seems to stay until some next major version update.
var $2a672013d8ef6cc4$var$SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".
var $2a672013d8ef6cc4$var$CREATE_CHARACTER_CLASS_PATTERN = $2a672013d8ef6cc4$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.
var $2a672013d8ef6cc4$var$CREATE_STANDALONE_DIGIT_PATTERN = $2a672013d8ef6cc4$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//
var $2a672013d8ef6cc4$var$NON_ALTERING_FORMAT_REG_EXP = new RegExp('[' + (0, $4dcf27eddf865fa7$export$7f01587e28f9194) + ']*' + // Google developers say:
// "We require that the first matching group is present in the
//  output pattern to ensure no data is lost while formatting."
'\\$1' + '[' + (0, $4dcf27eddf865fa7$export$7f01587e28f9194) + ']*' + '(\\$\\d[' + (0, $4dcf27eddf865fa7$export$7f01587e28f9194) + ']*)*' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.
var $2a672013d8ef6cc4$var$MIN_LEADING_DIGITS_LENGTH = 3;
var $2a672013d8ef6cc4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeFormatter(_ref) {
        var state = _ref.state, metadata = _ref.metadata;
        $2a672013d8ef6cc4$var$_classCallCheck(this, AsYouTypeFormatter);
        this.metadata = metadata;
        this.resetFormat();
    }
    $2a672013d8ef6cc4$var$_createClass(AsYouTypeFormatter, [
        {
            key: "resetFormat",
            value: function resetFormat() {
                this.chosenFormat = undefined;
                this.template = undefined;
                this.nationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplatePosition = -1;
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan, state) {
                this.resetFormat();
                if (numberingPlan) {
                    this.isNANP = numberingPlan.callingCode() === '1';
                    this.matchingFormats = numberingPlan.formats();
                    if (state.nationalSignificantNumber) this.narrowDownMatchingFormats(state);
                } else {
                    this.isNANP = undefined;
                    this.matchingFormats = [];
                }
            }
        },
        {
            key: "format",
            value: function format(nextDigits, state) {
                var _this = this;
                // See if the phone number digits can be formatted as a complete phone number.
                // If not, use the results from `formatNationalNumberWithNextDigits()`,
                // which formats based on the chosen formatting pattern.
                //
                // Attempting to format complete phone number first is how it's done
                // in Google's `libphonenumber`, so this library just follows it.
                // Google's `libphonenumber` code doesn't explain in detail why does it
                // attempt to format digits as a complete phone number
                // instead of just going with a previoulsy (or newly) chosen `format`:
                //
                // "Checks to see if there is an exact pattern match for these digits.
                //  If so, we should use this instead of any other formatting template
                //  whose leadingDigitsPattern also matches the input."
                //
                if ((0, $58a38209305e84b5$export$9e33d25ea5d3e526)(state.nationalSignificantNumber, this.metadata)) for(var _iterator = $2a672013d8ef6cc4$var$_createForOfIteratorHelperLoose(this.matchingFormats), _step; !(_step = _iterator()).done;){
                    var format = _step.value;
                    var formattedCompleteNumber = (0, $58a38209305e84b5$export$2e2bcd8739ae039)(state, format, {
                        metadata: this.metadata,
                        shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
                            return _this.shouldTryNationalPrefixFormattingRule(format, {
                                international: state.international,
                                nationalPrefix: state.nationalPrefix
                            });
                        },
                        getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(format) {
                            return _this.getSeparatorAfterNationalPrefix(format);
                        }
                    });
                    if (formattedCompleteNumber) {
                        this.resetFormat();
                        this.chosenFormat = format;
                        this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, (0, $20276fa3fe3d75a9$export$2a0174a7c311f338)), state);
                        this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
                        // using the old template needs to be reset.
                        this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf((0, $20276fa3fe3d75a9$export$2a0174a7c311f338));
                        return formattedCompleteNumber;
                    }
                }
                 // Format the digits as a partial (incomplete) phone number
                // using the previously chosen formatting pattern (or a newly chosen one).
                return this.formatNationalNumberWithNextDigits(nextDigits, state);
            } // Formats the next phone number digits.
        },
        {
            key: "formatNationalNumberWithNextDigits",
            value: function formatNationalNumberWithNextDigits(nextDigits, state) {
                var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.
                var newlyChosenFormat = this.chooseFormat(state);
                if (newlyChosenFormat) {
                    if (newlyChosenFormat === previouslyChosenFormat) // If it can format the next (current) digits
                    // using the previously chosen phone number format
                    // then return the updated formatted number.
                    return this.formatNextNationalNumberDigits(nextDigits);
                    else // If a more appropriate phone number format
                    // has been chosen for these "leading digits",
                    // then re-format the national phone number part
                    // using the newly selected format.
                    return this.formatNextNationalNumberDigits(state.getNationalDigits());
                }
            }
        },
        {
            key: "narrowDownMatchingFormats",
            value: function narrowDownMatchingFormats(_ref2) {
                var _this2 = this;
                var nationalSignificantNumber = _ref2.nationalSignificantNumber, nationalPrefix = _ref2.nationalPrefix, international = _ref2.international;
                var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
                // "leading digits" pattern fitting a maximum of 3 leading digits.
                // So, after a user inputs 3 digits of a national (significant) phone number
                // this national (significant) number can already be formatted.
                // The next "leading digits" pattern is for 4 leading digits max,
                // and the "leading digits" pattern after it is for 5 leading digits max, etc.
                // This implementation is different from Google's
                // in that it searches for a fitting format
                // even if the user has entered less than
                // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
                // Because some leading digit patterns already match for a single first digit.
                var leadingDigitsPatternIndex = leadingDigits.length - $2a672013d8ef6cc4$var$MIN_LEADING_DIGITS_LENGTH;
                if (leadingDigitsPatternIndex < 0) leadingDigitsPatternIndex = 0;
                this.matchingFormats = this.matchingFormats.filter(function(format) {
                    return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
                }); // If there was a phone number format chosen
                // and it no longer holds given the new leading digits then reset it.
                // The test for this `if` condition is marked as:
                // "Reset a chosen format when it no longer holds given the new leading digits".
                // To construct a valid test case for this one can find a country
                // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
                // and yielding another format for 4 `<leadingDigits>` (Australia in this case).
                if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) this.resetFormat();
            }
        },
        {
            key: "formatSuits",
            value: function formatSuits(format, international, nationalPrefix) {
                // When a prefix before a national (significant) number is
                // simply a national prefix, then it's parsed as `this.nationalPrefix`.
                // In more complex cases, a prefix before national (significant) number
                // could include a national prefix as well as some "capturing groups",
                // and in that case there's no info whether a national prefix has been parsed.
                // If national prefix is not used when formatting a phone number
                // using this format, but a national prefix has been entered by the user,
                // and was extracted, then discard such phone number format.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
                if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
                !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) return false;
                 // If national prefix is mandatory for this phone number format
                // and there're no guarantees that a national prefix is present in user input
                // then discard this phone number format as not suitable.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193
                if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) return false;
                return true;
            }
        },
        {
            key: "formatMatches",
            value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
                var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
                // leading digits pattern then it fits.
                // The test case could be found by searching for "leadingDigitsPatternsCount === 0".
                if (leadingDigitsPatternsCount === 0) return true;
                 // Start narrowing down the list of possible formats based on the leading digits.
                // (only previously matched formats take part in the narrowing down process)
                // `leading_digits_patterns` start with 3 digits min
                // and then go up from there one digit at a time.
                leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
                var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Google imposes a requirement on the leading digits
                // to be minimum 3 digits long in order to be eligible
                // for checking those with a leading digits pattern.
                //
                // Since `leading_digits_patterns` start with 3 digits min,
                // Google's original `libphonenumber` library only starts
                // excluding any non-matching formats only when the
                // national number entered so far is at least 3 digits long,
                // otherwise format matching would give false negatives.
                //
                // For example, when the digits entered so far are `2`
                // and the leading digits pattern is `21` –
                // it's quite obvious in this case that the format could be the one
                // but due to the absence of further digits it would give false negative.
                //
                // Also, `leading_digits_patterns` doesn't always correspond to a single
                // digits count. For example, `60|8` pattern would already match `8`
                // but the `60` part would require having at least two leading digits,
                // so the whole pattern would require inputting two digits first in order to
                // decide on whether it matches the input, even when the input is "80".
                //
                // This library — `libphonenumber-js` — allows filtering by `leading_digits_patterns`
                // even when there's only 1 or 2 digits of the national (significant) number.
                // To do that, it uses a non-strict pattern matcher written specifically for that.
                //
                if (leadingDigits.length < $2a672013d8ef6cc4$var$MIN_LEADING_DIGITS_LENGTH) // Before leading digits < 3 matching was implemented:
                // return true
                //
                // After leading digits < 3 matching was implemented:
                try {
                    return new (0, $63fd28f5f7876235$export$2e2bcd8739ae039)(leadingDigitsPattern).match(leadingDigits, {
                        allowOverflow: true
                    }) !== undefined;
                } catch (error) /* istanbul ignore next */ {
                    // There's a slight possibility that there could be some undiscovered bug
                    // in the pattern matcher code. Since the "leading digits < 3 matching"
                    // feature is not "essential" for operation, it can fall back to the old way
                    // in case of any issues rather than halting the application's execution.
                    console.error(error);
                    return true;
                }
                 // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are
                // available then use the usual regular expression matching.
                //
                // The whole pattern is wrapped in round brackets (`()`) because
                // the pattern can use "or" operator (`|`) at the top level of the pattern.
                //
                return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
            }
        },
        {
            key: "getFormatFormat",
            value: function getFormatFormat(format, international) {
                return international ? format.internationalFormat() : format.format();
            }
        },
        {
            key: "chooseFormat",
            value: function chooseFormat(state) {
                var _this3 = this;
                var _loop = function _loop() {
                    var format = _step2.value;
                    // If this format is currently being used
                    // and is still suitable, then stick to it.
                    if (_this3.chosenFormat === format) return "break";
                     // Sometimes, a formatting rule inserts additional digits in a phone number,
                    // and "as you type" formatter can't do that: it should only use the digits
                    // that the user has input.
                    //
                    // For example, in Argentina, there's a format for mobile phone numbers:
                    //
                    // {
                    //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    //    "leading_digits_patterns": ["91"],
                    //    "national_prefix_formatting_rule": "0$1",
                    //    "format": "$2 15-$3-$4",
                    //    "international_format": "$1 $2 $3-$4"
                    // }
                    //
                    // In that format, `international_format` is used instead of `format`
                    // because `format` inserts `15` in the formatted number,
                    // and `AsYouType` formatter should only use the digits
                    // the user has actually input, without adding any extra digits.
                    // In this case, it wouldn't make a difference, because the `15`
                    // is first stripped when applying `national_prefix_for_parsing`
                    // and then re-added when using `format`, so in reality it doesn't
                    // add any new digits to the number, but to detect that, the code
                    // would have to be more complex: it would have to try formatting
                    // the digits using the format and then see if any digits have
                    // actually been added or removed, and then, every time a new digit
                    // is input, it should re-check whether the chosen format doesn't
                    // alter the digits.
                    //
                    // Google's code doesn't go that far, and so does this library:
                    // it simply requires that a `format` doesn't add any additonal
                    // digits to user's input.
                    //
                    // Also, people in general should move from inputting phone numbers
                    // in national format (possibly with national prefixes)
                    // and use international phone number format instead:
                    // it's a logical thing in the modern age of mobile phones,
                    // globalization and the internet.
                    //
                    /* istanbul ignore if */ if (!$2a672013d8ef6cc4$var$NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international))) return "continue";
                    if (!_this3.createTemplateForFormat(format, state)) {
                        // Remove the format if it can't generate a template.
                        _this3.matchingFormats = _this3.matchingFormats.filter(function(_) {
                            return _ !== format;
                        });
                        return "continue";
                    }
                    _this3.chosenFormat = format;
                    return "break";
                };
                // When there are multiple available formats, the formatter uses the first
                // format where a formatting template could be created.
                //
                // For some weird reason, `istanbul` says "else path not taken"
                // for the `for of` line below. Supposedly that means that
                // the loop doesn't ever go over the last element in the list.
                // That's true because there always is `this.chosenFormat`
                // when `this.matchingFormats` is non-empty.
                // And, for some weird reason, it doesn't think that the case
                // with empty `this.matchingFormats` qualifies for a valid "else" path.
                // So simply muting this `istanbul` warning.
                // It doesn't skip the contents of the `for of` loop,
                // it just skips the `for of` line.
                //
                /* istanbul ignore next */ for(var _iterator2 = $2a672013d8ef6cc4$var$_createForOfIteratorHelperLoose(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done;){
                    var _ret = _loop();
                    if (_ret === "break") break;
                    if (_ret === "continue") continue;
                }
                if (!this.chosenFormat) // No format matches the national (significant) phone number.
                this.resetFormat();
                return this.chosenFormat;
            }
        },
        {
            key: "createTemplateForFormat",
            value: function createTemplateForFormat(format, state) {
                // The formatter doesn't format numbers when numberPattern contains '|', e.g.
                // (20|3)\d{4}. In those cases we quickly return.
                // (Though there's no such format in current metadata)
                /* istanbul ignore if */ if ($2a672013d8ef6cc4$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) return;
                 // Get formatting template for this phone number format
                var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
                // for any phone number format, then abort.
                if (template) {
                    this.setNationalNumberTemplate(template, state);
                    return true;
                }
            }
        },
        {
            key: "getSeparatorAfterNationalPrefix",
            value: function getSeparatorAfterNationalPrefix(format) {
                // `US` metadata doesn't have a `national_prefix_formatting_rule`,
                // so the `if` condition below doesn't apply to `US`,
                // but in reality there shoudl be a separator
                // between a national prefix and a national (significant) number.
                // So `US` national prefix separator is a "special" "hardcoded" case.
                if (this.isNANP) return ' ';
                 // If a `format` has a `national_prefix_formatting_rule`
                // and that rule has a separator after a national prefix,
                // then it means that there should be a separator
                // between a national prefix and a national (significant) number.
                if (format && format.nationalPrefixFormattingRule() && $2a672013d8ef6cc4$var$NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) return ' ';
                 // At this point, there seems to be no clear evidence that
                // there should be a separator between a national prefix
                // and a national (significant) number. So don't insert one.
                return '';
            }
        },
        {
            key: "getInternationalPrefixBeforeCountryCallingCode",
            value: function getInternationalPrefixBeforeCountryCallingCode(_ref3, options) {
                var IDDPrefix = _ref3.IDDPrefix, missingPlus = _ref3.missingPlus;
                if (IDDPrefix) return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
                if (missingPlus) return '';
                return '+';
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate(state) {
                if (!this.template) return;
                 // `this.template` holds the template for a "complete" phone number.
                // The currently entered phone number is most likely not "complete",
                // so trim all non-populated digits.
                var index = -1;
                var i = 0;
                var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
                    spacing: false
                }) : '';
                while(i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length){
                    index = this.template.indexOf((0, $20276fa3fe3d75a9$export$2a0174a7c311f338), index + 1);
                    i++;
                }
                return (0, $20276fa3fe3d75a9$export$ac095dcff0205861)(this.template, index + 1);
            }
        },
        {
            key: "setNationalNumberTemplate",
            value: function setNationalNumberTemplate(template, state) {
                this.nationalNumberTemplate = template;
                this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
                // using the old template needs to be reset.
                this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
                // contains the whole international number
                // if the phone number being input is international:
                // 'x' for the '+' sign, 'x'es for the country phone code,
                // a spacebar and then the template for the formatted national number.
                if (state.international) this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, (0, $20276fa3fe3d75a9$export$2a0174a7c311f338)) + (0, $20276fa3fe3d75a9$export$76d90c956114f2c2)((0, $20276fa3fe3d75a9$export$2a0174a7c311f338), state.callingCode.length) + ' ' + template;
                else this.template = template;
            }
        },
        {
            key: "getTemplateForFormat",
            value: function getTemplateForFormat(format, _ref4) {
                var nationalSignificantNumber = _ref4.nationalSignificantNumber, international = _ref4.international, nationalPrefix = _ref4.nationalPrefix, complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber;
                var pattern = format.pattern();
                /* istanbul ignore else */ if ($2a672013d8ef6cc4$var$SUPPORT_LEGACY_FORMATTING_PATTERNS) pattern = pattern // Replace anything in the form of [..] with \d
                .replace($2a672013d8ef6cc4$var$CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
                .replace($2a672013d8ef6cc4$var$CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
                 // Generate a dummy national number (consisting of `9`s)
                // that fits this format's `pattern`.
                //
                // This match will always succeed,
                // because the "longest dummy phone number"
                // has enough length to accomodate any possible
                // national phone number format pattern.
                //
                var digits = $2a672013d8ef6cc4$var$LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
                // for any phone number format, then abort.
                if (nationalSignificantNumber.length > digits.length) return;
                 // Get a formatting template which can be used to efficiently format
                // a partial number where digits are added one by one.
                // Below `strictPattern` is used for the
                // regular expression (with `^` and `$`).
                // This wasn't originally in Google's `libphonenumber`
                // and I guess they don't really need it
                // because they're not using "templates" to format phone numbers
                // but I added `strictPattern` after encountering
                // South Korean phone number formatting bug.
                //
                // Non-strict regular expression bug demonstration:
                //
                // this.nationalSignificantNumber : `111111111` (9 digits)
                //
                // pattern : (\d{2})(\d{3,4})(\d{4})
                // format : `$1 $2 $3`
                // digits : `9999999999` (10 digits)
                //
                // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
                //
                // template : xx xxxx xxxx
                //
                // But the correct template in this case is `xx xxx xxxx`.
                // The template was generated incorrectly because of the
                // `{3,4}` variability in the `pattern`.
                //
                // The fix is, if `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
                // is used instead of `digits`.
                var strictPattern = new RegExp('^' + pattern + '$');
                var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, $2a672013d8ef6cc4$var$DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then use it
                // instead of `digits`.
                if (strictPattern.test(nationalNumberDummyDigits)) digits = nationalNumberDummyDigits;
                var numberFormat = this.getFormatFormat(format, international);
                var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
                // and if a `format` does have a national prefix formatting rule,
                // then see if that national prefix formatting rule
                // prepends exactly the same national prefix the user has input.
                // If that's the case, then use the `format` with the national prefix formatting rule.
                // Otherwise, use  the `format` without the national prefix formatting rule,
                // and prepend a national prefix manually to it.
                if (this.shouldTryNationalPrefixFormattingRule(format, {
                    international: international,
                    nationalPrefix: nationalPrefix
                })) {
                    var numberFormatWithNationalPrefix = numberFormat.replace((0, $b5a4891b4cbcc12b$export$4f32ad1c51a7a6be), format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
                    // national prefix at the start of a national (significant) number,
                    // then such formatting can be used with `AsYouType` formatter.
                    // There seems to be no `else` case: everywhere in metadata,
                    // national prefix formatting rule is national prefix + $1,
                    // or `($1)`, in which case such format isn't even considered
                    // when the user has input a national prefix.
                    /* istanbul ignore else */ if ((0, $36e358bc9b5a1121$export$2e2bcd8739ae039)(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + (0, $36e358bc9b5a1121$export$2e2bcd8739ae039)('$1')) {
                        numberFormat = numberFormatWithNationalPrefix;
                        nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
                        // with `DIGIT_PLACEHOLDER`s.
                        if (nationalPrefix) {
                            var i = nationalPrefix.length;
                            while(i > 0){
                                numberFormat = numberFormat.replace(/\d/, (0, $20276fa3fe3d75a9$export$2a0174a7c311f338));
                                i--;
                            }
                        }
                    }
                } // Generate formatting template for this phone number format.
                var template = digits // Format the dummy phone number according to the format.
                .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
                .replace(new RegExp($2a672013d8ef6cc4$var$DUMMY_DIGIT, 'g'), (0, $20276fa3fe3d75a9$export$2a0174a7c311f338)); // If a prefix of a national (significant) number is not as simple
                // as just a basic national prefix, then just prepend such prefix
                // before the national (significant) number, optionally spacing
                // the two with a whitespace.
                if (!nationalPrefixIncludedInTemplate) {
                    if (complexPrefixBeforeNationalSignificantNumber) // Prepend the prefix to the template manually.
                    template = (0, $20276fa3fe3d75a9$export$76d90c956114f2c2)((0, $20276fa3fe3d75a9$export$2a0174a7c311f338), complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
                    else if (nationalPrefix) // Prepend national prefix to the template manually.
                    template = (0, $20276fa3fe3d75a9$export$76d90c956114f2c2)((0, $20276fa3fe3d75a9$export$2a0174a7c311f338), nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
                }
                if (international) template = (0, $5e8dd20dbd59d7da$export$2e2bcd8739ae039)(template);
                return template;
            }
        },
        {
            key: "formatNextNationalNumberDigits",
            value: function formatNextNationalNumberDigits(digits) {
                var result = (0, $20276fa3fe3d75a9$export$a15547494b55ca4e)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);
                if (!result) {
                    // Reset the format.
                    this.resetFormat();
                    return;
                }
                this.populatedNationalNumberTemplate = result[0];
                this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.
                return (0, $20276fa3fe3d75a9$export$ac095dcff0205861)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
            // for `react-phone-number-input`'s default input (`InputBasic`).
            // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
            // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
            }
        },
        {
            key: "shouldTryNationalPrefixFormattingRule",
            value: function shouldTryNationalPrefixFormattingRule(format, _ref5) {
                var international = _ref5.international, nationalPrefix = _ref5.nationalPrefix;
                if (format.nationalPrefixFormattingRule()) {
                    // In some countries, `national_prefix_formatting_rule` is `($1)`,
                    // so it applies even if the user hasn't input a national prefix.
                    // `format.usesNationalPrefix()` detects such cases.
                    var usesNationalPrefix = format.usesNationalPrefix();
                    if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) return true;
                }
            }
        }
    ]);
    return AsYouTypeFormatter;
}();








function $eae7f381de655e78$var$_slicedToArray(arr, i) {
    return $eae7f381de655e78$var$_arrayWithHoles(arr) || $eae7f381de655e78$var$_iterableToArrayLimit(arr, i) || $eae7f381de655e78$var$_unsupportedIterableToArray(arr, i) || $eae7f381de655e78$var$_nonIterableRest();
}
function $eae7f381de655e78$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $eae7f381de655e78$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $eae7f381de655e78$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $eae7f381de655e78$var$_arrayLikeToArray(o, minLen);
}
function $eae7f381de655e78$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $eae7f381de655e78$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $eae7f381de655e78$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $eae7f381de655e78$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $eae7f381de655e78$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $eae7f381de655e78$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $eae7f381de655e78$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $eae7f381de655e78$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $eae7f381de655e78$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + (0, $4dcf27eddf865fa7$export$7f01587e28f9194) + (0, $4dcf27eddf865fa7$export$852d1d4a47329634) + ']+';
var $eae7f381de655e78$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + $eae7f381de655e78$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var $eae7f381de655e78$var$VALID_FORMATTED_PHONE_NUMBER_PART = "(?:[" + (0, $4dcf27eddf865fa7$export$207c99ccf3902df8) + ']' + '[' + (0, $4dcf27eddf865fa7$export$7f01587e28f9194) + (0, $4dcf27eddf865fa7$export$852d1d4a47329634) + ']*' + '|' + '[' + (0, $4dcf27eddf865fa7$export$7f01587e28f9194) + (0, $4dcf27eddf865fa7$export$852d1d4a47329634) + ']+' + ')';
var $eae7f381de655e78$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + (0, $4dcf27eddf865fa7$export$7f01587e28f9194) + (0, $4dcf27eddf865fa7$export$852d1d4a47329634) + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.
var $eae7f381de655e78$var$COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;
var $eae7f381de655e78$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeParser(_ref) {
        var defaultCountry = _ref.defaultCountry, defaultCallingCode = _ref.defaultCallingCode, metadata = _ref.metadata, onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;
        $eae7f381de655e78$var$_classCallCheck(this, AsYouTypeParser);
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.metadata = metadata;
        this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
    }
    $eae7f381de655e78$var$_createClass(AsYouTypeParser, [
        {
            key: "input",
            value: function input(text, state) {
                var _extractFormattedDigi = $eae7f381de655e78$export$84f1aacb72e7dba5(text), _extractFormattedDigi2 = $eae7f381de655e78$var$_slicedToArray(_extractFormattedDigi, 2), formattedDigits = _extractFormattedDigi2[0], hasPlus = _extractFormattedDigi2[1];
                var digits = (0, $36e358bc9b5a1121$export$2e2bcd8739ae039)(formattedDigits); // Checks for a special case: just a leading `+` has been entered.
                var justLeadingPlus;
                if (hasPlus) {
                    if (!state.digits) {
                        state.startInternationalNumber();
                        if (!digits) justLeadingPlus = true;
                    }
                }
                if (digits) this.inputDigits(digits, state);
                return {
                    digits: digits,
                    justLeadingPlus: justLeadingPlus
                };
            }
        },
        {
            key: "inputDigits",
            value: function inputDigits(nextDigits, state) {
                var digits = state.digits;
                var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.
                state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
                // Some users input their phone number in international format,
                // but in an "out-of-country" dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers as soon as there're at least 3 digits.
                // Google's library attempts to extract IDD prefix at 3 digits,
                // so this library just copies that behavior.
                // I guess that's because the most commot IDD prefixes are
                // `00` (Europe) and `011` (US).
                // There exist really long IDD prefixes too:
                // for example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                // An IDD prefix is extracted here, and then every time when
                // there's a new digit and the number couldn't be formatted.
                if (hasReceivedThreeLeadingDigits) this.extractIddPrefix(state);
                if (this.isWaitingForCountryCallingCode(state)) {
                    if (!this.extractCountryCallingCode(state)) return;
                } else state.appendNationalSignificantNumberDigits(nextDigits);
                 // If a phone number is being input in international format,
                // then it's not valid for it to have a national prefix.
                // Still, some people incorrectly input such numbers with a national prefix.
                // In such cases, only attempt to strip a national prefix if the number becomes too long.
                // (but that is done later, not here)
                if (!state.international) {
                    if (!this.hasExtractedNationalSignificantNumber) this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
                        return state.update(stateUpdate);
                    });
                }
            }
        },
        {
            key: "isWaitingForCountryCallingCode",
            value: function isWaitingForCountryCallingCode(_ref2) {
                var international = _ref2.international, callingCode = _ref2.callingCode;
                return international && !callingCode;
            } // Extracts a country calling code from a number
        },
        {
            key: "extractCountryCallingCode",
            value: function extractCountryCallingCode(state) {
                var _extractCountryCallin = (0, $d5feb9b8d0531eb2$export$2e2bcd8739ae039)('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                if (countryCallingCode) {
                    state.setCallingCode(countryCallingCode);
                    state.update({
                        nationalSignificantNumber: number
                    });
                    return true;
                }
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan) {
                if (numberingPlan) {
                    this.hasSelectedNumberingPlan = true;
                    var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && $eae7f381de655e78$var$COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
                } else {
                    this.hasSelectedNumberingPlan = undefined;
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractNationalSignificantNumber",
            value: function extractNationalSignificantNumber(nationalDigits, setState) {
                if (!this.hasSelectedNumberingPlan) return;
                var _extractNationalNumbe = (0, $c72e6e88f61eb1d1$export$2e2bcd8739ae039)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe.nationalPrefix, nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
                if (nationalNumber === nationalDigits) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "extractAnotherNationalSignificantNumber",
            value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
                if (!this.hasExtractedNationalSignificantNumber) return this.extractNationalSignificantNumber(nationalDigits, setState);
                if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) return;
                var _extractNationalNumbe2 = (0, $c72e6e88f61eb1d1$export$2e2bcd8739ae039)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe2.nationalPrefix, nationalNumber = _extractNationalNumbe2.nationalNumber, carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
                // then it's always extracted as additional digits are added.
                // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
                // doesn't do anything different from what it currently does.
                // So, just in case, here's this check, though it doesn't occur.
                /* istanbul ignore if */ if (nationalNumber === prevNationalSignificantNumber) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "onExtractedNationalNumber",
            value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
                var complexPrefixBeforeNationalSignificantNumber;
                var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.
                var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
                // last substring of the `digits`, then it means that it hasn't been altered:
                // no digits have been removed from the national (significant) number
                // while applying `national_prefix_transform_rule`.
                // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
                if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
                    nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
                    // as just a basic national prefix, then such prefix is stored in
                    // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
                    // prepended "as is" to the national (significant) number to produce
                    // a formatted result.
                    var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
                    // because `onExtractedNationalNumber()` isn't called
                    // when a national (significant) number hasn't been actually "extracted":
                    // when a national (significant) number is equal to the national part of `digits`,
                    // then `onExtractedNationalNumber()` doesn't get called.
                    if (prefixBeforeNationalNumber !== nationalPrefix) complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
                }
                setState({
                    nationalPrefix: nationalPrefix,
                    carrierCode: carrierCode,
                    nationalSignificantNumber: nationalSignificantNumber,
                    nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
                    complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
                }); // `onExtractedNationalNumber()` is only called when
                // the national (significant) number actually did change.
                this.hasExtractedNationalSignificantNumber = true;
                this.onNationalSignificantNumberChange();
            }
        },
        {
            key: "reExtractNationalSignificantNumber",
            value: function reExtractNationalSignificantNumber(state) {
                // Attempt to extract a national prefix.
                //
                // Some people incorrectly input national prefix
                // in an international phone number.
                // For example, some people write British phone numbers as `+44(0)...`.
                //
                // Also, in some rare cases, it is valid for a national prefix
                // to be a part of an international phone number.
                // For example, mobile phone numbers in Mexico are supposed to be
                // dialled internationally using a `1` national prefix,
                // so the national prefix will be part of an international number.
                //
                // Quote from:
                // https://www.mexperience.com/dialing-cell-phones-in-mexico/
                //
                // "Dialing a Mexican cell phone from abroad
                // When you are calling a cell phone number in Mexico from outside Mexico,
                // it’s necessary to dial an additional “1” after Mexico’s country code
                // (which is “52”) and before the area code.
                // You also ignore the 045, and simply dial the area code and the
                // cell phone’s number.
                //
                // If you don’t add the “1”, you’ll receive a recorded announcement
                // asking you to redial using it.
                //
                // For example, if you are calling from the USA to a cell phone
                // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
                // (Note that this is different to calling a land line in Mexico City
                // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
                //
                // Google's demo output:
                // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
                //
                if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function(stateUpdate) {
                    return state.update(stateUpdate);
                })) return true;
                 // If no format matches the phone number, then it could be
                // "a really long IDD" (quote from a comment in Google's library).
                // An IDD prefix is first extracted when the user has entered at least 3 digits,
                // and then here — every time when there's a new digit and the number
                // couldn't be formatted.
                // For example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                //
                // Could also check `!hasReceivedThreeLeadingDigits` here
                // to filter out the case when this check duplicates the one
                // already performed when there're 3 leading digits,
                // but it's not a big deal, and in most cases there
                // will be a suitable `format` when there're 3 leading digits.
                //
                if (this.extractIddPrefix(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                } // Google's AsYouType formatter supports sort of an "autocorrection" feature
                // when it "autocorrects" numbers that have been input for a country
                // with that country's calling code.
                // Such "autocorrection" feature looks weird, but different people have been requesting it:
                // https://github.com/catamphetamine/libphonenumber-js/issues/376
                // https://github.com/catamphetamine/libphonenumber-js/issues/375
                // https://github.com/catamphetamine/libphonenumber-js/issues/316
                if (this.fixMissingPlus(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                }
            }
        },
        {
            key: "extractIddPrefix",
            value: function extractIddPrefix(state) {
                // An IDD prefix can't be present in a number written with a `+`.
                // Also, don't re-extract an IDD prefix if has already been extracted.
                var international = state.international, IDDPrefix = state.IDDPrefix, digits = state.digits, nationalSignificantNumber = state.nationalSignificantNumber;
                if (international || IDDPrefix) return;
                 // Some users input their phone number in "out-of-country"
                // dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers.
                var numberWithoutIDD = (0, $eba8fd39ff2a7e3d$export$2e2bcd8739ae039)(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
                if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
                    // If an IDD prefix was stripped then convert the IDD-prefixed number
                    // to international number for subsequent parsing.
                    state.update({
                        IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
                    });
                    this.startInternationalNumber(state, {
                        country: undefined,
                        callingCode: undefined
                    });
                    return true;
                }
            }
        },
        {
            key: "fixMissingPlus",
            value: function fixMissingPlus(state) {
                if (!state.international) {
                    var _extractCountryCallin2 = (0, $b3dc7c8e6f22ab9d$export$2e2bcd8739ae039)(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), newCallingCode = _extractCountryCallin2.countryCallingCode, number = _extractCountryCallin2.number;
                    if (newCallingCode) {
                        state.update({
                            missingPlus: true
                        });
                        this.startInternationalNumber(state, {
                            country: state.country,
                            callingCode: newCallingCode
                        });
                        return true;
                    }
                }
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(state, _ref3) {
                var country = _ref3.country, callingCode = _ref3.callingCode;
                state.startInternationalNumber(country, callingCode); // If a national (significant) number has been extracted before, reset it.
                if (state.nationalSignificantNumber) {
                    state.resetNationalSignificantNumber();
                    this.onNationalSignificantNumberChange();
                    this.hasExtractedNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractCallingCodeAndNationalSignificantNumber",
            value: function extractCallingCodeAndNationalSignificantNumber(state) {
                if (this.extractCountryCallingCode(state)) // `this.extractCallingCode()` is currently called when the number
                // couldn't be formatted during the standard procedure.
                // Normally, the national prefix would be re-extracted
                // for an international number if such number couldn't be formatted,
                // but since it's already not able to be formatted,
                // there won't be yet another retry, so also extract national prefix here.
                this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
                    return state.update(stateUpdate);
                });
            }
        }
    ]);
    return AsYouTypeParser;
}();
function $eae7f381de655e78$var$extractFormattedPhoneNumber(text) {
    // Attempt to extract a possible number from the string passed in.
    var startsAt = text.search($eae7f381de655e78$var$VALID_FORMATTED_PHONE_NUMBER_PART);
    if (startsAt < 0) return;
     // Trim everything to the left of the phone number.
    text = text.slice(startsAt); // Trim the `+`.
    var hasPlus;
    if (text[0] === '+') {
        hasPlus = true;
        text = text.slice(1);
    } // Trim everything to the right of the phone number.
    text = text.replace($eae7f381de655e78$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.
    if (hasPlus) text = '+' + text;
    return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */ function $eae7f381de655e78$var$_extractFormattedDigitsAndPlus(text) {
    // Extract a formatted phone number part from text.
    var extractedNumber = $eae7f381de655e78$var$extractFormattedPhoneNumber(text) || ''; // Trim a `+`.
    if (extractedNumber[0] === '+') return [
        extractedNumber.slice(1),
        true
    ];
    return [
        extractedNumber
    ];
}
function $eae7f381de655e78$export$84f1aacb72e7dba5(text) {
    var _extractFormattedDigi3 = $eae7f381de655e78$var$_extractFormattedDigitsAndPlus(text), _extractFormattedDigi4 = $eae7f381de655e78$var$_slicedToArray(_extractFormattedDigi3, 2), formattedDigits = _extractFormattedDigi4[0], hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
    // can possibly be a part of some valid phone number
    // then parse phone number characters from a formatted phone number.
    if (!$eae7f381de655e78$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) formattedDigits = '';
    return [
        formattedDigits,
        hasPlus
    ];
}



function $9b2e537f138e27d6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9b2e537f138e27d6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9b2e537f138e27d6$var$_typeof(obj);
}
function $9b2e537f138e27d6$var$_slicedToArray(arr, i) {
    return $9b2e537f138e27d6$var$_arrayWithHoles(arr) || $9b2e537f138e27d6$var$_iterableToArrayLimit(arr, i) || $9b2e537f138e27d6$var$_unsupportedIterableToArray(arr, i) || $9b2e537f138e27d6$var$_nonIterableRest();
}
function $9b2e537f138e27d6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9b2e537f138e27d6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9b2e537f138e27d6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9b2e537f138e27d6$var$_arrayLikeToArray(o, minLen);
}
function $9b2e537f138e27d6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9b2e537f138e27d6$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9b2e537f138e27d6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9b2e537f138e27d6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9b2e537f138e27d6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9b2e537f138e27d6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9b2e537f138e27d6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9b2e537f138e27d6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $9b2e537f138e27d6$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $9b2e537f138e27d6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */ function AsYouType(optionsOrDefaultCountry, metadata) {
        $9b2e537f138e27d6$var$_classCallCheck(this, AsYouType);
        this.metadata = new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(metadata);
        var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry), _this$getCountryAndCa2 = $9b2e537f138e27d6$var$_slicedToArray(_this$getCountryAndCa, 2), defaultCountry = _this$getCountryAndCa2[0], defaultCallingCode = _this$getCountryAndCa2[1];
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.reset();
    }
    $9b2e537f138e27d6$var$_createClass(AsYouType, [
        {
            key: "getCountryAndCallingCode",
            value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
                // Set `defaultCountry` and `defaultCallingCode` options.
                var defaultCountry;
                var defaultCallingCode; // Turns out `null` also has type "object". Weird.
                if (optionsOrDefaultCountry) {
                    if ($9b2e537f138e27d6$var$_typeof(optionsOrDefaultCountry) === 'object') {
                        defaultCountry = optionsOrDefaultCountry.defaultCountry;
                        defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
                    } else defaultCountry = optionsOrDefaultCountry;
                }
                if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) defaultCountry = undefined;
                if (defaultCallingCode) {
                    /* istanbul ignore if */ if ($9b2e537f138e27d6$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                        if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) defaultCountry = '001';
                    }
                }
                return [
                    defaultCountry,
                    defaultCallingCode
                ];
            }
        },
        {
            key: "input",
            value: function input(text) {
                var _this$parser$input = this.parser.input(text, this.state), digits = _this$parser$input.digits, justLeadingPlus = _this$parser$input.justLeadingPlus;
                if (justLeadingPlus) this.formattedOutput = '+';
                else if (digits) {
                    this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.
                    if (this.state.nationalSignificantNumber) this.formatter.narrowDownMatchingFormats(this.state);
                    var formattedNationalNumber;
                    if (this.metadata.hasSelectedNumberingPlan()) formattedNationalNumber = this.formatter.format(digits, this.state);
                    if (formattedNationalNumber === undefined) // See if another national (significant) number could be re-extracted.
                    {
                        if (this.parser.reExtractNationalSignificantNumber(this.state)) {
                            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.
                            var nationalDigits = this.state.getNationalDigits();
                            if (nationalDigits) formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
                        }
                    }
                    this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
                }
                return this.formattedOutput;
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                this.state = new (0, $0047f7ab4f91ccb1$export$2e2bcd8739ae039)({
                    onCountryChange: function onCountryChange(country) {
                        // Before version `1.6.0`, the official `AsYouType` formatter API
                        // included the `.country` property of an `AsYouType` instance.
                        // Since that property (along with the others) have been moved to
                        // `this.state`, `this.country` property is emulated for compatibility
                        // with the old versions.
                        _this.country = country;
                    },
                    onCallingCodeChange: function onCallingCodeChange(callingCode, country) {
                        _this.metadata.selectNumberingPlan(country, callingCode);
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                        _this.parser.reset(_this.metadata.numberingPlan);
                    }
                });
                this.formatter = new (0, $2a672013d8ef6cc4$export$2e2bcd8739ae039)({
                    state: this.state,
                    metadata: this.metadata
                });
                this.parser = new (0, $eae7f381de655e78$export$2e2bcd8739ae039)({
                    defaultCountry: this.defaultCountry,
                    defaultCallingCode: this.defaultCallingCode,
                    metadata: this.metadata,
                    state: this.state,
                    onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
                        _this.determineTheCountryIfNeeded();
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                    }
                });
                this.state.reset(this.defaultCountry, this.defaultCallingCode);
                this.formattedOutput = '';
                return this;
            }
        },
        {
            key: "isInternational",
            value: function isInternational() {
                return this.state.international;
            }
        },
        {
            key: "getCallingCode",
            value: function getCallingCode() {
                // If the number is being input in national format and some "default calling code"
                // has been passed to `AsYouType` constructor, then `this.state.callingCode`
                // is equal to that "default calling code".
                //
                // If the number is being input in national format and no "default calling code"
                // has been passed to `AsYouType` constructor, then returns `undefined`,
                // even if a "default country" has been passed to `AsYouType` constructor.
                //
                if (this.isInternational()) return this.state.callingCode;
            } // A legacy alias.
        },
        {
            key: "getCountryCallingCode",
            value: function getCountryCallingCode() {
                return this.getCallingCode();
            }
        },
        {
            key: "getCountry",
            value: function getCountry() {
                var digits = this.state.digits; // Return `undefined` if no digits have been input yet.
                if (digits) return this._getCountry();
            }
        },
        {
            key: "_getCountry",
            value: function _getCountry() {
                var country = this.state.country;
                /* istanbul ignore if */ if ($9b2e537f138e27d6$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                    // `AsYouType.getCountry()` returns `undefined`
                    // for "non-geographic" phone numbering plans.
                    if (country === '001') return;
                }
                return country;
            }
        },
        {
            key: "determineTheCountryIfNeeded",
            value: function determineTheCountryIfNeeded() {
                // Suppose a user enters a phone number in international format,
                // and there're several countries corresponding to that country calling code,
                // and a country has been derived from the number, and then
                // a user enters one more digit and the number is no longer
                // valid for the derived country, so the country should be re-derived
                // on every new digit in those cases.
                //
                // If the phone number is being input in national format,
                // then it could be a case when `defaultCountry` wasn't specified
                // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
                // and that "calling code" could correspond to a "non-geographic entity",
                // or there could be several countries corresponding to that country calling code.
                // In those cases, `this.country` is `undefined` and should be derived
                // from the number. Again, if country calling code is ambiguous, then
                // `this.country` should be re-derived with each new digit.
                //
                if (!this.state.country || this.isCountryCallingCodeAmbiguous()) this.determineTheCountry();
            } // Prepends `+CountryCode ` in case of an international phone number
        },
        {
            key: "getFullNumber",
            value: function getFullNumber(formattedNationalNumber) {
                var _this2 = this;
                if (this.isInternational()) {
                    var prefix = function prefix(text) {
                        return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
                            spacing: text ? true : false
                        }) + text;
                    };
                    var callingCode = this.state.callingCode;
                    if (!callingCode) return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
                    if (!formattedNationalNumber) return prefix(callingCode);
                    return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
                }
                return formattedNationalNumber;
            }
        },
        {
            key: "getNonFormattedNationalNumberWithPrefix",
            value: function getNonFormattedNationalNumberWithPrefix() {
                var _this$state = this.state, nationalSignificantNumber = _this$state.nationalSignificantNumber, complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber, nationalPrefix = _this$state.nationalPrefix;
                var number = nationalSignificantNumber;
                var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;
                if (prefix) number = prefix + number;
                return number;
            }
        },
        {
            key: "getNonFormattedNumber",
            value: function getNonFormattedNumber() {
                var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
                return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
            }
        },
        {
            key: "getNonFormattedTemplate",
            value: function getNonFormattedTemplate() {
                var number = this.getNonFormattedNumber();
                if (number) return number.replace(/[\+\d]/g, (0, $20276fa3fe3d75a9$export$2a0174a7c311f338));
            }
        },
        {
            key: "isCountryCallingCodeAmbiguous",
            value: function isCountryCallingCodeAmbiguous() {
                var callingCode = this.state.callingCode;
                var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
                return countryCodes && countryCodes.length > 1;
            } // Determines the country of the phone number
        },
        {
            key: "determineTheCountry",
            value: function determineTheCountry() {
                this.state.setCountry((0, $468a09d2825a0975$export$2e2bcd8739ae039)(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
            }
        },
        {
            key: "getNumberValue",
            value: function getNumberValue() {
                var _this$state2 = this.state, digits = _this$state2.digits, callingCode = _this$state2.callingCode, country = _this$state2.country, nationalSignificantNumber = _this$state2.nationalSignificantNumber; // Will return `undefined` if no digits have been input.
                if (!digits) return;
                if (this.isInternational()) {
                    if (callingCode) return '+' + callingCode + nationalSignificantNumber;
                    else return '+' + digits;
                } else if (country || callingCode) {
                    var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
                    return '+' + callingCode_ + nationalSignificantNumber;
                }
            }
        },
        {
            key: "getNumber",
            value: function getNumber() {
                var _this$state3 = this.state, nationalSignificantNumber = _this$state3.nationalSignificantNumber, carrierCode = _this$state3.carrierCode, callingCode = _this$state3.callingCode; // `this._getCountry()` is basically same as `this.state.country`
                // with the only change that it return `undefined` in case of a
                // "non-geographic" numbering plan instead of `"001"` "internal use" value.
                var country = this._getCountry();
                if (!nationalSignificantNumber) return;
                if (!country && !callingCode) return;
                var phoneNumber = new (0, $b0f4723857faab4e$export$2e2bcd8739ae039)(country || callingCode, nationalSignificantNumber, this.metadata.metadata);
                if (carrierCode) phoneNumber.carrierCode = carrierCode;
                 // Phone number extensions are not supported by "As You Type" formatter.
                return phoneNumber;
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isPossible();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isValid();
            }
        },
        {
            key: "getNationalNumber",
            value: function getNationalNumber() {
                return this.state.nationalSignificantNumber;
            }
        },
        {
            key: "getChars",
            value: function getChars() {
                return (this.state.international ? '+' : '') + this.state.digits;
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate() {
                return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
            }
        }
    ]);
    return AsYouType;
}();



function $b72fa5f3c2e6eaf3$export$64c976c619d11c0e(_ref) {
    var country = _ref.country, international = _ref.international, withCountryCallingCode = _ref.withCountryCallingCode, metadata = _ref.metadata;
    return country && international && !withCountryCallingCode ? "+".concat((0, $9015f651de9f4947$export$32876ca2f1919cf0)(country, metadata)) : '';
}
function $b72fa5f3c2e6eaf3$export$3ecf28b47966f258(value, prefix) {
    if (prefix) {
        value = value.slice(prefix.length);
        if (value[0] === ' ') value = value.slice(1);
    }
    return value;
}


var $9ebe3f87ca88bd46$var$_excluded = [
    "country",
    "international",
    "withCountryCallingCode",
    "metadata"
];
function $9ebe3f87ca88bd46$var$_extends() {
    $9ebe3f87ca88bd46$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9ebe3f87ca88bd46$var$_extends.apply(this, arguments);
}
function $9ebe3f87ca88bd46$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9ebe3f87ca88bd46$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9ebe3f87ca88bd46$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9ebe3f87ca88bd46$export$d80fffb1deb3b97e(defaultMetadata) {
    /**
   * `InputSmart` is a "smarter" implementation of a `Component`
   * that can be passed to `<PhoneInput/>`. It parses and formats
   * the user's and maintains the caret's position in the process.
   * The caret positioning is maintained using `input-format` library.
   * Relies on being run in a DOM environment for calling caret positioning functions.
   */ function InputSmart(_ref, ref) {
        var country = _ref.country, international = _ref.international, withCountryCallingCode = _ref.withCountryCallingCode, metadata = _ref.metadata, rest = $9ebe3f87ca88bd46$var$_objectWithoutProperties(_ref, $9ebe3f87ca88bd46$var$_excluded);
        var format = (0, $6fFrj.useCallback)(function(value) {
            // "As you type" formatter.
            var formatter = new (0, $9b2e537f138e27d6$export$2e2bcd8739ae039)(country, metadata);
            var prefix = (0, $b72fa5f3c2e6eaf3$export$64c976c619d11c0e)({
                country: country,
                international: international,
                withCountryCallingCode: withCountryCallingCode,
                metadata: metadata
            }); // Format the number.
            var text = formatter.input(prefix + value);
            var template = formatter.getTemplate();
            if (prefix) {
                text = (0, $b72fa5f3c2e6eaf3$export$3ecf28b47966f258)(text, prefix); // `AsYouType.getTemplate()` can be `undefined`.
                if (template) template = (0, $b72fa5f3c2e6eaf3$export$3ecf28b47966f258)(template, prefix);
            }
            return {
                text: text,
                template: template
            };
        }, [
            country,
            metadata
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $346aa9da61e1b764$export$2e2bcd8739ae039), $9ebe3f87ca88bd46$var$_extends({}, rest, {
            ref: ref,
            parse: (0, $d8bf16d5fafeec82$export$13d8790d7fb84c28),
            format: format
        }));
    }
    InputSmart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef(InputSmart);
    InputSmart.propTypes = {
        /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */ value: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired,
        /**
     * A function of `value: string`.
     * Updates the `value` property.
     */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired,
        /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */ country: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */ international: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
        /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */ withCountryCallingCode: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
        /**
     * `libphonenumber-js` metadata.
     */ metadata: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired
    };
    InputSmart.defaultProps = {
        metadata: defaultMetadata
    };
    return InputSmart;
}
var $9ebe3f87ca88bd46$export$2e2bcd8739ae039 = $9ebe3f87ca88bd46$export$d80fffb1deb3b97e();



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");

function $8a720063f5357128$export$2e2bcd8739ae039(value, country, metadata) {
    if (!metadata) {
        metadata = country;
        country = undefined;
    }
    return new (0, $9b2e537f138e27d6$export$2e2bcd8739ae039)(country, metadata).input(value);
}



var $479164b8746bd89e$var$_excluded = [
    "value",
    "onChange",
    "country",
    "international",
    "withCountryCallingCode",
    "metadata",
    "inputComponent"
];
function $479164b8746bd89e$var$_extends() {
    $479164b8746bd89e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $479164b8746bd89e$var$_extends.apply(this, arguments);
}
function $479164b8746bd89e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $479164b8746bd89e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $479164b8746bd89e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $479164b8746bd89e$export$d80fffb1deb3b97e(defaultMetadata) {
    /**
   * `InputBasic` is the most basic implementation of a `Component`
   * that can be passed to `<PhoneInput/>`. It parses and formats
   * the user's input but doesn't control the caret in the process:
   * when erasing or inserting digits in the middle of a phone number
   * the caret usually jumps to the end (this is the expected behavior).
   * Why does `InputBasic` exist when there's `InputSmart`?
   * One reason is working around the [Samsung Galaxy smart caret positioning bug]
   * (https://github.com/catamphetamine/react-phone-number-input/issues/75).
   * Another reason is that, unlike `InputSmart`, it doesn't require DOM environment.
   */ function InputBasic(_ref, ref) {
        var value = _ref.value, onChange = _ref.onChange, country = _ref.country, international = _ref.international, withCountryCallingCode = _ref.withCountryCallingCode, metadata = _ref.metadata, Input = _ref.inputComponent, rest = $479164b8746bd89e$var$_objectWithoutProperties(_ref, $479164b8746bd89e$var$_excluded);
        var prefix = (0, $b72fa5f3c2e6eaf3$export$64c976c619d11c0e)({
            country: country,
            international: international,
            withCountryCallingCode: withCountryCallingCode,
            metadata: metadata
        });
        var _onChange = (0, $6fFrj.useCallback)(function(event) {
            var newValue = (0, $d8bf16d5fafeec82$export$2e2bcd8739ae039)(event.target.value); // By default, if a value is something like `"(123)"`
            // then Backspace would only erase the rightmost brace
            // becoming something like `"(123"`
            // which would give the same `"123"` value
            // which would then be formatted back to `"(123)"`
            // and so a user wouldn't be able to erase the phone number.
            // Working around this issue with this simple hack.
            if (newValue === value) {
                var newValueFormatted = $479164b8746bd89e$var$format(prefix, newValue, country, metadata);
                if (newValueFormatted.indexOf(event.target.value) === 0) // Trim the last digit (or plus sign).
                newValue = newValue.slice(0, -1);
            }
            onChange(newValue);
        }, [
            prefix,
            value,
            onChange,
            country,
            metadata
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Input, $479164b8746bd89e$var$_extends({}, rest, {
            ref: ref,
            value: $479164b8746bd89e$var$format(prefix, value, country, metadata),
            onChange: _onChange
        }));
    }
    InputBasic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef(InputBasic);
    InputBasic.propTypes = {
        /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */ value: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired,
        /**
     * A function of `value: string`.
     * Updates the `value` property.
     */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired,
        /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */ country: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */ international: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
        /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */ withCountryCallingCode: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
        /**
     * `libphonenumber-js` metadata.
     */ metadata: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
        /**
     * The `<input/>` component.
     */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).elementType.isRequired
    };
    InputBasic.defaultProps = {
        metadata: defaultMetadata,
        inputComponent: 'input'
    };
    return InputBasic;
}
var $479164b8746bd89e$export$2e2bcd8739ae039 = $479164b8746bd89e$export$d80fffb1deb3b97e();
function $479164b8746bd89e$var$format(prefix, value, country, metadata) {
    return (0, $b72fa5f3c2e6eaf3$export$3ecf28b47966f258)((0, $8a720063f5357128$export$2e2bcd8739ae039)(prefix + value, country, metadata), prefix);
}



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");

/**
 * Creates Unicode flag from a two-letter ISO country code.
 * https://stackoverflow.com/questions/24050671/how-to-put-japan-flag-character-in-a-string
 * @param  {string} country — A two-letter ISO country code (case-insensitive).
 * @return {string}
 */ function $82d3de7e2d8dbcbc$export$2e2bcd8739ae039(country) {
    return $82d3de7e2d8dbcbc$var$getRegionalIndicatorSymbol(country[0]) + $82d3de7e2d8dbcbc$var$getRegionalIndicatorSymbol(country[1]);
}
/**
 * Converts a letter to a Regional Indicator Symbol.
 * @param  {string} letter
 * @return {string}
 */ function $82d3de7e2d8dbcbc$var$getRegionalIndicatorSymbol(letter) {
    return String.fromCodePoint(127397 + letter.toUpperCase().charCodeAt(0));
}


var $747ce7eea7f38edd$var$_excluded = [
    "value",
    "onChange",
    "options"
], $747ce7eea7f38edd$var$_excluded2 = [
    "value",
    "options",
    "className",
    "iconComponent",
    "getIconAspectRatio",
    "arrowComponent",
    "unicodeFlags"
];
function $747ce7eea7f38edd$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $747ce7eea7f38edd$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $747ce7eea7f38edd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $747ce7eea7f38edd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $747ce7eea7f38edd$var$_arrayLikeToArray(o, minLen);
}
function $747ce7eea7f38edd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $747ce7eea7f38edd$var$_extends() {
    $747ce7eea7f38edd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $747ce7eea7f38edd$var$_extends.apply(this, arguments);
}
function $747ce7eea7f38edd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $747ce7eea7f38edd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $747ce7eea7f38edd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $747ce7eea7f38edd$export$2e2bcd8739ae039(_ref) {
    var value = _ref.value, onChange = _ref.onChange, options = _ref.options, rest = $747ce7eea7f38edd$var$_objectWithoutProperties(_ref, $747ce7eea7f38edd$var$_excluded);
    var onChange_ = (0, $6fFrj.useCallback)(function(event) {
        var value = event.target.value;
        onChange(value === 'ZZ' ? undefined : value);
    }, [
        onChange
    ]);
    var selectedOption = (0, $6fFrj.useMemo)(function() {
        return $747ce7eea7f38edd$var$getSelectedOption(options, value);
    }, [
        options,
        value
    ]); // "ZZ" means "International".
    // (HTML requires each `<option/>` have some string `value`).
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("select", $747ce7eea7f38edd$var$_extends({}, rest, {
        value: value || 'ZZ',
        onChange: onChange_
    }), options.map(function(_ref2) {
        var value = _ref2.value, label = _ref2.label, divider = _ref2.divider;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("option", {
            key: divider ? '|' : value || 'ZZ',
            value: divider ? '|' : value || 'ZZ',
            disabled: divider ? true : false,
            style: divider ? $747ce7eea7f38edd$var$DIVIDER_STYLE : undefined
        }, label);
    }));
}
$747ce7eea7f38edd$export$2e2bcd8739ae039.propTypes = {
    /**
   * A two-letter country code.
   * Example: "US", "RU", etc.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    /**
   * A function of `value: string`.
   * Updates the `value` property.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired,
    // `<select/>` options.
    options: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).shape({
        value: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        divider: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool
    })).isRequired
};
var $747ce7eea7f38edd$var$DIVIDER_STYLE = {
    fontSize: '1px',
    backgroundColor: 'currentColor',
    color: 'inherit'
};
function $747ce7eea7f38edd$export$2d95fe84e9746c91(_ref3) {
    var value = _ref3.value, options = _ref3.options, className = _ref3.className, Icon = _ref3.iconComponent, getIconAspectRatio = _ref3.getIconAspectRatio, Arrow = _ref3.arrowComponent, unicodeFlags = _ref3.unicodeFlags, rest = $747ce7eea7f38edd$var$_objectWithoutProperties(_ref3, $747ce7eea7f38edd$var$_excluded2);
    var selectedOption = (0, $6fFrj.useMemo)(function() {
        return $747ce7eea7f38edd$var$getSelectedOption(options, value);
    }, [
        options,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "PhoneInputCountry"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($747ce7eea7f38edd$export$2e2bcd8739ae039, $747ce7eea7f38edd$var$_extends({}, rest, {
        value: value,
        options: options,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9c33d2044c0b2f89$exports)))('PhoneInputCountrySelect', className)
    })), unicodeFlags && value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "PhoneInputCountryIconUnicode"
    }, (0, $82d3de7e2d8dbcbc$export$2e2bcd8739ae039)(value)), !(unicodeFlags && value) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Icon, {
        "aria-hidden": true,
        country: value,
        label: selectedOption && selectedOption.label,
        aspectRatio: unicodeFlags ? 1 : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Arrow, null));
}
$747ce7eea7f38edd$export$2d95fe84e9746c91.propTypes = {
    // Country flag component.
    iconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).elementType,
    // Select arrow component.
    arrowComponent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).elementType.isRequired,
    // Set to `true` to render Unicode flag icons instead of SVG images.
    unicodeFlags: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool
};
$747ce7eea7f38edd$export$2d95fe84e9746c91.defaultProps = {
    arrowComponent: function arrowComponent() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
            className: "PhoneInputCountrySelectArrow"
        });
    }
};
function $747ce7eea7f38edd$var$getSelectedOption(options, value) {
    for(var _iterator = $747ce7eea7f38edd$var$_createForOfIteratorHelperLoose(options), _step; !(_step = _iterator()).done;){
        var option = _step.value;
        if (!option.divider && option.value === value) return option;
    }
}



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");

var $0053744d0b1cec56$var$_excluded = [
    "country",
    "countryName",
    "flags",
    "flagUrl"
];
function $0053744d0b1cec56$var$_extends() {
    $0053744d0b1cec56$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0053744d0b1cec56$var$_extends.apply(this, arguments);
}
function $0053744d0b1cec56$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0053744d0b1cec56$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0053744d0b1cec56$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0053744d0b1cec56$export$2e2bcd8739ae039(_ref) {
    var country = _ref.country, countryName = _ref.countryName, flags = _ref.flags, flagUrl = _ref.flagUrl, rest = $0053744d0b1cec56$var$_objectWithoutProperties(_ref, $0053744d0b1cec56$var$_excluded);
    if (flags && flags[country]) return flags[country]({
        title: countryName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("img", $0053744d0b1cec56$var$_extends({}, rest, {
        alt: countryName,
        role: countryName ? undefined : "presentation",
        src: flagUrl.replace('{XX}', country).replace('{xx}', country.toLowerCase())
    }));
}
$0053744d0b1cec56$export$2e2bcd8739ae039.propTypes = {
    // The country to be selected by default.
    // Two-letter country code ("ISO 3166-1 alpha-2").
    country: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired,
    // Will be HTML `title` attribute of the `<img/>`.
    countryName: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired,
    // Country flag icon components.
    // By default flag icons are inserted as `<img/>`s
    // with their `src` pointed to `country-flag-icons` gitlab pages website.
    // There might be cases (e.g. an offline application)
    // where having a large (3 megabyte) `<svg/>` flags
    // bundle is more appropriate.
    // `import flags from 'react-phone-number-input/flags'`.
    flags: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).elementType),
    // A URL for a country flag icon.
    // By default it points to `country-flag-icons` gitlab pages website.
    flagUrl: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired
};



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");
var $191fc45265b3c625$var$_excluded = [
    "aspectRatio"
], $191fc45265b3c625$var$_excluded2 = [
    "title"
], $191fc45265b3c625$var$_excluded3 = [
    "title"
];
function $191fc45265b3c625$var$_extends() {
    $191fc45265b3c625$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $191fc45265b3c625$var$_extends.apply(this, arguments);
}
function $191fc45265b3c625$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $191fc45265b3c625$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $191fc45265b3c625$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $191fc45265b3c625$export$2e2bcd8739ae039(_ref) {
    var aspectRatio = _ref.aspectRatio, rest = $191fc45265b3c625$var$_objectWithoutProperties(_ref, $191fc45265b3c625$var$_excluded);
    if (aspectRatio === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($191fc45265b3c625$var$InternationalIcon1x1, rest);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($191fc45265b3c625$var$InternationalIcon3x2, rest);
}
$191fc45265b3c625$export$2e2bcd8739ae039.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired,
    aspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
}; // 3x2.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title
function $191fc45265b3c625$var$InternationalIcon3x2(_ref2) {
    var title = _ref2.title, rest = $191fc45265b3c625$var$_objectWithoutProperties(_ref2, $191fc45265b3c625$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", $191fc45265b3c625$var$_extends({}, rest, {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 75 50"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("g", {
        className: "PhoneInputInternationalIconGlobe",
        stroke: "currentColor",
        fill: "none",
        strokeWidth: "2",
        strokeMiterlimit: "10"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
        strokeLinecap: "round",
        d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
        d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("line", {
        x1: "26",
        y1: "25",
        x2: "74",
        y2: "25"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("line", {
        x1: "50",
        y1: "1",
        x2: "50",
        y2: "49"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
        strokeLinecap: "round",
        d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
        strokeLinecap: "round",
        d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
        className: "PhoneInputInternationalIconPhone",
        stroke: "none",
        fill: "currentColor",
        d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
    }));
}
$191fc45265b3c625$var$InternationalIcon3x2.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired
}; // 1x1.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title
function $191fc45265b3c625$var$InternationalIcon1x1(_ref3) {
    var title = _ref3.title, rest = $191fc45265b3c625$var$_objectWithoutProperties(_ref3, $191fc45265b3c625$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", $191fc45265b3c625$var$_extends({}, rest, {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 50 50"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("g", {
        className: "PhoneInputInternationalIconGlobe",
        stroke: "currentColor",
        fill: "none",
        strokeWidth: "2",
        strokeLinecap: "round"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
        d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
        d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
        d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
        d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("line", {
        x1: "27.8",
        y1: "0.85",
        x2: "27.8",
        y2: "34.61"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("line", {
        x1: "15.2",
        y1: "22.23",
        x2: "49.15",
        y2: "22.23"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
        className: "PhoneInputInternationalIconPhone",
        stroke: "transparent",
        fill: "currentColor",
        d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
    }));
}
$191fc45265b3c625$var$InternationalIcon1x1.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired
};



function $9200c417dc66b970$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $9200c417dc66b970$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9200c417dc66b970$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9200c417dc66b970$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9200c417dc66b970$var$_arrayLikeToArray(o, minLen);
}
function $9200c417dc66b970$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9200c417dc66b970$export$5e75b0f0f43cd233(options, order) {
    if (!order) return options;
    var optionsOnTop = [];
    var optionsOnBottom = [];
    var appendTo = optionsOnTop;
    for(var _iterator = $9200c417dc66b970$var$_createForOfIteratorHelperLoose(order), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (element === '|') appendTo.push({
            divider: true
        });
        else if (element === '...' || element === "\u2026") appendTo = optionsOnBottom;
        else (function() {
            var countryCode = void 0;
            if (element === "\uD83C\uDF10") countryCode = undefined;
            else countryCode = element;
             // Find the position of the option.
            var index = options.indexOf(options.filter(function(option) {
                return option.value === countryCode;
            })[0]); // Get the option.
            var option = options[index]; // Remove the option from its default position.
            options.splice(index, 1); // Add the option on top.
            appendTo.push(option);
        })();
    }
    return optionsOnTop.concat(options).concat(optionsOnBottom);
}
function $9200c417dc66b970$export$afcb8c072b7545af(countryOptions, metadata) {
    if (countryOptions) {
        countryOptions = countryOptions.filter(function(option) {
            switch(option){
                case "\uD83C\uDF10":
                case '|':
                case '...':
                case "\u2026":
                    return true;
                default:
                    return $9200c417dc66b970$export$92e6622a86b85d10(option, metadata);
            }
        });
        if (countryOptions.length > 0) return countryOptions;
    }
}
function $9200c417dc66b970$export$92e6622a86b85d10(country, metadata) {
    if ((0, $9015f651de9f4947$export$bd9e113b8b17202a)(country, metadata)) return true;
    else {
        console.error("Country not found: ".concat(country));
        return false;
    }
}
function $9200c417dc66b970$export$823f1bbb8700cf79(countries, metadata) {
    if (countries) {
        countries = countries.filter(function(country) {
            return $9200c417dc66b970$export$92e6622a86b85d10(country, metadata);
        });
        if (countries.length === 0) countries = undefined;
    }
    return countries;
}



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");



var $9b85cfa16afba0ba$var$_excluded = [
    "country",
    "label",
    "aspectRatio"
];
function $9b85cfa16afba0ba$var$_extends() {
    $9b85cfa16afba0ba$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9b85cfa16afba0ba$var$_extends.apply(this, arguments);
}
function $9b85cfa16afba0ba$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9b85cfa16afba0ba$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9b85cfa16afba0ba$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9b85cfa16afba0ba$export$c8cd064d62c67fdc(_ref) {
    var flags = _ref.flags, flagUrl = _ref.flagUrl, FlagComponent = _ref.flagComponent, InternationalIcon = _ref.internationalIcon;
    function CountryIcon(_ref2) {
        var country = _ref2.country, label = _ref2.label, aspectRatio = _ref2.aspectRatio, rest = $9b85cfa16afba0ba$var$_objectWithoutProperties(_ref2, $9b85cfa16afba0ba$var$_excluded);
        // `aspectRatio` is currently a hack for the default "International" icon
        // to render it as a square when Unicode flag icons are used.
        // So `aspectRatio` property is only used with the default "International" icon.
        var _aspectRatio = InternationalIcon === (0, $191fc45265b3c625$export$2e2bcd8739ae039) ? aspectRatio : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", $9b85cfa16afba0ba$var$_extends({}, rest, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9c33d2044c0b2f89$exports)))('PhoneInputCountryIcon', {
                'PhoneInputCountryIcon--square': _aspectRatio === 1,
                'PhoneInputCountryIcon--border': country
            })
        }), country ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(FlagComponent, {
            country: country,
            countryName: label,
            flags: flags,
            flagUrl: flagUrl,
            className: "PhoneInputCountryIconImg"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(InternationalIcon, {
            title: label,
            aspectRatio: _aspectRatio,
            className: "PhoneInputCountryIconImg"
        }));
    }
    CountryIcon.propTypes = {
        country: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired,
        aspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    };
    return CountryIcon;
}
var $9b85cfa16afba0ba$export$2e2bcd8739ae039 = $9b85cfa16afba0ba$export$c8cd064d62c67fdc({
    // Must be equal to `defaultProps.flagUrl` in `./PhoneInputWithCountry.js`.
    flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',
    flagComponent: (0, $0053744d0b1cec56$export$2e2bcd8739ae039),
    internationalIcon: (0, $191fc45265b3c625$export$2e2bcd8739ae039)
});





var $989b883aa76c4c38$var$ONLY_DIGITS_REGEXP = /^\d+$/;
function $989b883aa76c4c38$export$2e2bcd8739ae039(country, metadata) {
    // Standard international phone number prefix: "+" and "country calling code".
    var prefix = '+' + (0, $9015f651de9f4947$export$32876ca2f1919cf0)(country, metadata); // Get "leading digits" for a phone number of the country.
    // If there're "leading digits" then they can be part of the prefix too.
    metadata = new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(country);
    if (metadata.numberingPlan.leadingDigits() && $989b883aa76c4c38$var$ONLY_DIGITS_REGEXP.test(metadata.numberingPlan.leadingDigits())) prefix += metadata.numberingPlan.leadingDigits();
    return prefix;
}


function $f6847e6e765e4a43$export$5b746bf50fbb3c55(_ref) {
    var value = _ref.value, phoneNumber = _ref.phoneNumber, defaultCountry = _ref.defaultCountry, getAnyCountry = _ref.getAnyCountry, countries = _ref.countries, required = _ref.required, metadata = _ref.metadata;
    var country; // If can get country from E.164 phone number
    // then it overrides the `country` passed (or not passed).
    if (phoneNumber && phoneNumber.country) // `country` will be left `undefined` in case of non-detection.
    country = phoneNumber.country;
    else if (defaultCountry) {
        if (!value || $f6847e6e765e4a43$export$c3b71c8ffbba4219(value, defaultCountry, metadata)) country = defaultCountry;
    } // Only pre-select a country if it's in the available `countries` list.
    if (countries && countries.indexOf(country) < 0) country = undefined;
     // If there will be no "International" option
    // then some `country` must be selected.
    // It will still be the wrong country though.
    // But still country `<select/>` can't be left in a broken state.
    if (!country && required && countries && countries.length > 0) country = getAnyCountry(); // noCountryMatchesTheNumber = true
    return country;
}
function $f6847e6e765e4a43$export$85590f0e7cf668c8(_ref2) {
    var countries = _ref2.countries, countryNames = _ref2.countryNames, addInternationalOption = _ref2.addInternationalOption, compareStringsLocales = _ref2.compareStringsLocales, _compareStrings = _ref2.compareStrings;
    // Default country name comparator uses `String.localeCompare()`.
    if (!_compareStrings) _compareStrings = $f6847e6e765e4a43$export$633da1651c3bd3f9;
     // Generates a `<Select/>` option for each country.
    var countrySelectOptions = countries.map(function(country) {
        return {
            value: country,
            // All `locale` country names included in this library
            // include all countries (this is checked at build time).
            // The only case when a country name might be missing
            // is when a developer supplies their own `labels` property.
            // To guard against such cases, a missing country name
            // is substituted by country code.
            label: countryNames[country] || country
        };
    }); // Sort the list of countries alphabetically.
    countrySelectOptions.sort(function(a, b) {
        return _compareStrings(a.label, b.label, compareStringsLocales);
    }); // Add the "International" option to the country list (if suitable)
    if (addInternationalOption) countrySelectOptions.unshift({
        label: countryNames.ZZ
    });
    return countrySelectOptions;
}
function $f6847e6e765e4a43$export$da44e4eaa54bc82e(value, metadata) {
    return (0, $f39fb66294e78ae2$export$2e2bcd8739ae039)(value || '', metadata);
}
function $f6847e6e765e4a43$export$3a77a656b43ad765(phoneNumber) {
    return phoneNumber.formatNational().replace(/\D/g, '');
}
function $f6847e6e765e4a43$export$4222dedf18d79e22(phoneDigits, _ref3) {
    var prevCountry = _ref3.prevCountry, newCountry = _ref3.newCountry, metadata = _ref3.metadata, useNationalFormat = _ref3.useNationalFormat;
    if (prevCountry === newCountry) return phoneDigits;
     // If `parsed_input` is empty
    // then no need to migrate anything.
    if (!phoneDigits) {
        if (useNationalFormat) return '';
        else // If `phoneDigits` is empty then set `phoneDigits` to
        // `+{getCountryCallingCode(newCountry)}`.
        return (0, $989b883aa76c4c38$export$2e2bcd8739ae039)(newCountry, metadata);
    } // If switching to some country.
    // (from "International" or another country)
    // If switching from "International" then `phoneDigits` starts with a `+`.
    // Otherwise it may or may not start with a `+`.
    if (newCountry) // If the phone number was entered in international format
    // then migrate it to the newly selected country.
    // The phone number may be incomplete.
    // The phone number entered not necessarily starts with
    // the previously selected country phone prefix.
    {
        if (phoneDigits[0] === '+') {
            // If the international phone number is for the new country
            // then convert it to local if required.
            if (useNationalFormat) {
                // // If a phone number is being input in international form
                // // and the country can already be derived from it,
                // // and if it is the new country, then format as a national number.
                // const derived_country = getCountryFromPossiblyIncompleteInternationalPhoneNumber(phoneDigits, metadata)
                // if (derived_country === newCountry) {
                // 	return stripCountryCallingCode(phoneDigits, derived_country, metadata)
                // }
                // Actually, the two countries don't necessarily need to match:
                // the condition could be looser here, because several countries
                // might share the same international phone number format
                // (for example, "NANPA" countries like US, Canada, etc).
                // The looser condition would be just "same nternational phone number format"
                // which would mean "same country calling code" in the context of `libphonenumber-js`.
                if (phoneDigits.indexOf('+' + (0, $9015f651de9f4947$export$32876ca2f1919cf0)(newCountry, metadata)) === 0) return $f6847e6e765e4a43$export$4d2c4a09d0258b4e(phoneDigits, newCountry, metadata);
                 // Simply discard the previously entered international phone number,
                // because otherwise any "smart" transformation like getting the
                // "national (significant) number" part and then prepending the
                // newly selected country's "country calling code" to it
                // would just be confusing for a user without being actually useful.
                return ''; // // Simply strip the leading `+` character
            // // therefore simply converting all digits into a "local" phone number.
            // // https://github.com/catamphetamine/react-phone-number-input/issues/287
            // return phoneDigits.slice(1)
            }
            if (prevCountry) {
                var newCountryPrefix = (0, $989b883aa76c4c38$export$2e2bcd8739ae039)(newCountry, metadata);
                if (phoneDigits.indexOf(newCountryPrefix) === 0) return phoneDigits;
                else return newCountryPrefix;
            } else {
                var defaultValue = (0, $989b883aa76c4c38$export$2e2bcd8739ae039)(newCountry, metadata); // If `phoneDigits`'s country calling code part is the same
                // as for the new `country`, then leave `phoneDigits` as is.
                if (phoneDigits.indexOf(defaultValue) === 0) return phoneDigits;
                 // If `phoneDigits`'s country calling code part is not the same
                // as for the new `country`, then set `phoneDigits` to
                // `+{getCountryCallingCode(newCountry)}`.
                return defaultValue;
            } // // If the international phone number already contains
        // // any country calling code then trim the country calling code part.
        // // (that could also be the newly selected country phone code prefix as well)
        // // `phoneDigits` doesn't neccessarily belong to `prevCountry`.
        // // (e.g. if a user enters an international number
        // //  not belonging to any of the reduced `countries` list).
        // phoneDigits = stripCountryCallingCode(phoneDigits, prevCountry, metadata)
        // // Prepend country calling code prefix
        // // for the newly selected country.
        // return e164(phoneDigits, newCountry, metadata) || `+${getCountryCallingCode(newCountry, metadata)}`
        }
    } else {
        // If the phone number was entered in national format.
        if (phoneDigits[0] !== '+') // Format the national phone number as an international one.
        // The phone number entered not necessarily even starts with
        // the previously selected country phone prefix.
        // Even if the phone number belongs to whole another country
        // it will still be parsed into some national phone number.
        //
        // Ignore the now-uncovered `|| ''` code branch:
        // previously `e164()` function could return an empty string
        // even when `phoneDigits` were not empty.
        // Now it always returns some `value` when there're any `phoneDigits`.
        // Still, didn't remove the `|| ''` code branch just in case
        // that logic changes somehow in some future, so there're no
        // possible bugs related to that.
        //
        // (ignore the `|| ''` code branch)
        /* istanbul ignore next */ return $f6847e6e765e4a43$export$2fa5ed24c9ef198e(phoneDigits, prevCountry, metadata) || '';
    }
    return phoneDigits;
}
function $f6847e6e765e4a43$export$2fa5ed24c9ef198e(number, country, metadata) {
    if (!number) return;
     // If the phone number is being input in international format.
    if (number[0] === '+') {
        // If it's just the `+` sign then return nothing.
        if (number === '+') return;
         // Return a E.164 phone number.
        //
        // Could return `number` "as is" here, but there's a possibility
        // that some user might incorrectly input an international number
        // with a "national prefix". Such numbers aren't considered valid,
        // but `libphonenumber-js` is "forgiving" when it comes to parsing
        // user's input, and this input component follows that behavior.
        //
        var asYouType = new (0, $9b2e537f138e27d6$export$2e2bcd8739ae039)(country, metadata);
        asYouType.input(number); // This function would return `undefined` only when `number` is `"+"`,
        // but at this point it is known that `number` is not `"+"`.
        return asYouType.getNumberValue();
    } // For non-international phone numbers
    // an accompanying country code is required.
    // The situation when `country` is `undefined`
    // and a non-international phone number is passed
    // to this function shouldn't happen.
    if (!country) return;
    var partial_national_significant_number = $f6847e6e765e4a43$export$457f4dd428dea2cc(number, country, metadata); //
    // Even if no "national (significant) number" digits have been input,
    // still return a non-`undefined` value.
    // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/113
    //
    // For example, if the user has selected country `US` and entered `"1"`
    // then that `"1"` is just a "national prefix" and no "national (significant) number"
    // digits have been input yet. Still, return `"+1"` as `value` in such cases,
    // because otherwise the app would think that the input is empty and mark it as such
    // while in reality it isn't empty, which might be thought of as a "bug", or just
    // a "weird" behavior.
    //
    // if (partial_national_significant_number) {
    return "+".concat((0, $9015f651de9f4947$export$32876ca2f1919cf0)(country, metadata)).concat(partial_national_significant_number || ''); // }
}
function $f6847e6e765e4a43$export$5be79a0015c5ab12(number, country, metadata) {
    var nationalSignificantNumberPart = $f6847e6e765e4a43$export$457f4dd428dea2cc(number, country, metadata);
    if (nationalSignificantNumberPart) {
        var overflowDigitsCount = nationalSignificantNumberPart.length - $f6847e6e765e4a43$var$getMaxNumberLength(country, metadata);
        if (overflowDigitsCount > 0) return number.slice(0, number.length - overflowDigitsCount);
    }
    return number;
}
function $f6847e6e765e4a43$var$getMaxNumberLength(country, metadata) {
    // Get "possible lengths" for a phone number of the country.
    metadata = new (0, $9015f651de9f4947$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(country); // Return the last "possible length".
    return metadata.numberingPlan.possibleLengths()[metadata.numberingPlan.possibleLengths().length - 1];
} // If the phone number being input is an international one
function $f6847e6e765e4a43$export$e7408f1ddc48b26e(partialE164Number, _ref4) {
    var country = _ref4.country, countries = _ref4.countries, required = _ref4.required, metadata = _ref4.metadata;
    if (partialE164Number === '+') // Don't change the currently selected country yet.
    return country;
    var derived_country = $f6847e6e765e4a43$export$848ed6f49dfa5296(partialE164Number, metadata); // If a phone number is being input in international form
    // and the country can already be derived from it,
    // then select that country.
    if (derived_country && (!countries || countries.indexOf(derived_country) >= 0)) return derived_country;
    else if (country && !required && !$f6847e6e765e4a43$export$c3b71c8ffbba4219(partialE164Number, country, metadata)) return undefined;
     // Don't change the currently selected country.
    return country;
}
function $f6847e6e765e4a43$export$b48270ccb996e66(phoneDigits, _ref5) {
    var prevPhoneDigits = _ref5.prevPhoneDigits, country = _ref5.country, defaultCountry = _ref5.defaultCountry, countryRequired = _ref5.countryRequired, getAnyCountry = _ref5.getAnyCountry, countries = _ref5.countries, international = _ref5.international, limitMaxLength = _ref5.limitMaxLength, countryCallingCodeEditable = _ref5.countryCallingCodeEditable, metadata = _ref5.metadata;
    if (international && countryCallingCodeEditable === false) {
        var prefix = (0, $989b883aa76c4c38$export$2e2bcd8739ae039)(country, metadata); // The `<input/>` value must start with the country calling code.
        if (phoneDigits.indexOf(prefix) !== 0) {
            var _value; // If a phone number input is declared as
            // `international` and `withCountryCallingCode`,
            // then it's gonna be non-empty even before the user
            // has input anything in it.
            // This will result in its contents (the country calling code part)
            // being selected when the user tabs into such field.
            // If the user then starts inputting the national part digits,
            // then `<input/>` value changes from `+xxx` to `y`
            // because inputting anything while having the `<input/>` value
            // selected results in erasing the `<input/>` value.
            // So, the component handles such case by restoring
            // the intended `<input/>` value: `+xxxy`.
            // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/43
            if (phoneDigits && phoneDigits[0] !== '+') {
                phoneDigits = prefix + phoneDigits;
                _value = $f6847e6e765e4a43$export$2fa5ed24c9ef198e(phoneDigits, country, metadata);
            } else phoneDigits = prefix;
            return {
                phoneDigits: phoneDigits,
                value: _value,
                country: country
            };
        }
    } // If `international` property is `false`, then it means
    // "enforce national-only format during input",
    // so, if that's the case, then remove all `+` characters,
    // but only if some country is currently selected.
    // (not if "International" country is selected).
    if (international === false && country && phoneDigits && phoneDigits[0] === '+') phoneDigits = $f6847e6e765e4a43$var$convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata);
     // Trim the input to not exceed the maximum possible number length.
    if (phoneDigits && country && limitMaxLength) phoneDigits = $f6847e6e765e4a43$export$5be79a0015c5ab12(phoneDigits, country, metadata);
     // If this `onChange()` event was triggered
    // as a result of selecting "International" country,
    // then force-prepend a `+` sign if the phone number
    // `<input/>` value isn't in international format.
    // Also, force-prepend a `+` sign if international
    // phone number input format is set.
    if (phoneDigits && phoneDigits[0] !== '+' && (!country || international)) phoneDigits = '+' + phoneDigits;
     // If the previously entered phone number
    // has been entered in international format
    // and the user decides to erase it,
    // then also reset the `country`
    // because it was most likely automatically selected
    // while the user was typing in the phone number
    // in international format.
    // This fixes the issue when a user is presented
    // with a phone number input with no country selected
    // and then types in their local phone number
    // then discovers that the input's messed up
    // (a `+` has been prepended at the start of their input
    //  and a random country has been selected),
    // decides to undo it all by erasing everything
    // and then types in their local phone number again
    // resulting in a seemingly correct phone number
    // but in reality that phone number has incorrect country.
    // https://github.com/catamphetamine/react-phone-number-input/issues/273
    if (!phoneDigits && prevPhoneDigits && prevPhoneDigits[0] === '+') {
        if (international) country = undefined;
        else country = defaultCountry;
    } // Also resets such "randomly" selected country
    // as soon as the user erases the number
    // digit-by-digit up to the leading `+` sign.
    if (phoneDigits === '+' && prevPhoneDigits && prevPhoneDigits[0] === '+' && prevPhoneDigits.length > 1) country = undefined;
     // Generate the new `value` property.
    var value;
    if (phoneDigits) {
        if (phoneDigits[0] === '+') {
            if (phoneDigits === '+') value = undefined;
            else if (country && (0, $989b883aa76c4c38$export$2e2bcd8739ae039)(country, metadata).indexOf(phoneDigits) === 0) // Selected a `country` but started inputting an
            // international phone number for another country.
            // Even though the input value is non-empty,
            // the `value` is assumed `undefined` in such case.
            // The `country` will be reset (or re-selected)
            // immediately after such mismatch has been detected
            // by the phone number input component, and `value`
            // will be set to the currently entered international prefix.
            //
            // For example, if selected `country` `"US"`
            // and started inputting phone number `"+2"`
            // then `value` `undefined` will be returned from this function,
            // and then, immediately after that, `country` will be reset
            // and the `value` will be set to `"+2"`.
            //
            value = undefined;
            else value = $f6847e6e765e4a43$export$2fa5ed24c9ef198e(phoneDigits, country, metadata);
        } else value = $f6847e6e765e4a43$export$2fa5ed24c9ef198e(phoneDigits, country, metadata);
    } // Derive the country from the phone number.
    // (regardless of whether there's any country currently selected,
    //  because there could be several countries corresponding to one country calling code)
    if (value) {
        country = $f6847e6e765e4a43$export$e7408f1ddc48b26e(value, {
            country: country,
            countries: countries,
            metadata: metadata
        }); // If `international` property is `false`, then it means
        // "enforce national-only format during input",
        // so, if that's the case, then remove all `+` characters,
        // but only if some country is currently selected.
        // (not if "International" country is selected).
        if (international === false && country && phoneDigits && phoneDigits[0] === '+') {
            phoneDigits = $f6847e6e765e4a43$var$convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata); // Re-calculate `value` because `phoneDigits` has changed.
            value = $f6847e6e765e4a43$export$2fa5ed24c9ef198e(phoneDigits, country, metadata);
        }
    }
    if (!country && countryRequired) country = defaultCountry || getAnyCountry();
    return {
        phoneDigits: phoneDigits,
        country: country,
        value: value
    };
}
function $f6847e6e765e4a43$var$convertInternationalPhoneDigitsToNational(input, country, metadata) {
    // Handle the case when a user might have pasted
    // a phone number in international format.
    if (input.indexOf((0, $989b883aa76c4c38$export$2e2bcd8739ae039)(country, metadata)) === 0) {
        // Create "as you type" formatter.
        var formatter = new (0, $9b2e537f138e27d6$export$2e2bcd8739ae039)(country, metadata); // Input partial national phone number.
        formatter.input(input); // Return the parsed partial national phone number.
        var phoneNumber = formatter.getNumber();
        if (phoneNumber) // Transform the number to a national one,
        // and remove all non-digits.
        return phoneNumber.formatNational().replace(/\D/g, '');
        else return '';
    } else // Just remove the `+` sign.
    return input.replace(/\D/g, '');
}
function $f6847e6e765e4a43$export$848ed6f49dfa5296(number, metadata) {
    var formatter = new (0, $9b2e537f138e27d6$export$2e2bcd8739ae039)(null, metadata);
    formatter.input(number); // // `001` is a special "non-geograpical entity" code
    // // in Google's `libphonenumber` library.
    // if (formatter.getCountry() === '001') {
    // 	return
    // }
    return formatter.getCountry();
}
function $f6847e6e765e4a43$export$633da1651c3bd3f9(a, b, locales) {
    // Use `String.localeCompare` if it's available.
    // https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
    // Which means everyone except IE <= 10 and Safari <= 10.
    // `localeCompare()` is available in latest Node.js versions.
    /* istanbul ignore else */ if (String.prototype.localeCompare) return a.localeCompare(b, locales);
    /* istanbul ignore next */ return a < b ? -1 : a > b ? 1 : 0;
}
function $f6847e6e765e4a43$export$4d2c4a09d0258b4e(number, country, metadata) {
    // Just an optimization, so that it
    // doesn't have to iterate through all country calling codes.
    if (country) {
        var countryCallingCodePrefix = '+' + (0, $9015f651de9f4947$export$32876ca2f1919cf0)(country, metadata); // If `country` fits the actual `number`.
        if (number.length < countryCallingCodePrefix.length) {
            if (countryCallingCodePrefix.indexOf(number) === 0) return '';
        } else {
            if (number.indexOf(countryCallingCodePrefix) === 0) return number.slice(countryCallingCodePrefix.length);
        }
    } // If `country` doesn't fit the actual `number`.
    // Try all available country calling codes.
    for(var _i = 0, _Object$keys = Object.keys(metadata.country_calling_codes); _i < _Object$keys.length; _i++){
        var country_calling_code = _Object$keys[_i];
        if (number.indexOf(country_calling_code) === 1) return number.slice(1 + country_calling_code.length);
    }
    return '';
}
function $f6847e6e765e4a43$export$457f4dd428dea2cc(number, country, metadata) {
    // Create "as you type" formatter.
    var formatter = new (0, $9b2e537f138e27d6$export$2e2bcd8739ae039)(country, metadata); // Input partial national phone number.
    formatter.input(number); // Return the parsed partial national phone number.
    var phoneNumber = formatter.getNumber();
    return phoneNumber && phoneNumber.nationalNumber;
}
function $f6847e6e765e4a43$export$c3b71c8ffbba4219(number, country, metadata) {
    var intlPhoneNumberPrefix = (0, $989b883aa76c4c38$export$2e2bcd8739ae039)(country, metadata);
    var i = 0;
    while(i < number.length && i < intlPhoneNumberPrefix.length){
        if (number[i] !== intlPhoneNumberPrefix[i]) return false;
        i++;
    }
    return true;
}
function $f6847e6e765e4a43$export$3b7f83419d3c9d9c(_ref6) {
    var value = _ref6.value, phoneNumber = _ref6.phoneNumber, defaultCountry = _ref6.defaultCountry, international = _ref6.international, useNationalFormat = _ref6.useNationalFormat, metadata = _ref6.metadata;
    // If the `value` (E.164 phone number)
    // belongs to the currently selected country
    // and `useNationalFormat` is `true`
    // then convert `value` (E.164 phone number)
    // to a local phone number digits.
    // E.g. '+78005553535' -> '88005553535'.
    if ((international === false || useNationalFormat) && phoneNumber && phoneNumber.country) return $f6847e6e765e4a43$export$3a77a656b43ad765(phoneNumber);
     // If `international` property is `true`,
    // meaning "enforce international phone number format",
    // then always show country calling code in the input field.
    if (!value && international && defaultCountry) return (0, $989b883aa76c4c38$export$2e2bcd8739ae039)(defaultCountry, metadata);
    return value;
}




function $4df25d792c00472a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4df25d792c00472a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4df25d792c00472a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4df25d792c00472a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4df25d792c00472a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4df25d792c00472a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4df25d792c00472a$export$2e2bcd8739ae039(props, prevProps, state) {
    var metadata = props.metadata, countries = props.countries, newDefaultCountry = props.defaultCountry, newValue = props.value, newReset = props.reset, international = props.international, displayInitialValueAsLocalNumber = props.displayInitialValueAsLocalNumber, initialValueFormat = props.initialValueFormat;
    var prevDefaultCountry = prevProps.defaultCountry, prevValue = prevProps.value, prevReset = prevProps.reset;
    var country = state.country, value = state.value, hasUserSelectedACountry = state.hasUserSelectedACountry;
    var _getInitialPhoneDigits = function _getInitialPhoneDigits(parameters) {
        return (0, $f6847e6e765e4a43$export$3b7f83419d3c9d9c)($4df25d792c00472a$var$_objectSpread($4df25d792c00472a$var$_objectSpread({}, parameters), {}, {
            international: international,
            useNationalFormat: displayInitialValueAsLocalNumber || initialValueFormat === 'national',
            metadata: metadata
        }));
    }; // Some users requested a way to reset the component
    // (both number `<input/>` and country `<select/>`).
    // Whenever `reset` property changes both number `<input/>`
    // and country `<select/>` are reset.
    // It's not implemented as some instance `.reset()` method
    // because `ref` is forwarded to `<input/>`.
    // It's also not replaced with just resetting `country` on
    // external `value` reset, because a user could select a country
    // and then not input any `value`, and so the selected country
    // would be "stuck", if not using this `reset` property.
    // https://github.com/catamphetamine/react-phone-number-input/issues/300
    if (newReset !== prevReset) return {
        phoneDigits: _getInitialPhoneDigits({
            value: undefined,
            defaultCountry: newDefaultCountry
        }),
        value: undefined,
        country: newDefaultCountry,
        hasUserSelectedACountry: undefined
    };
     // `value` is the value currently shown in the component:
    // it's stored in the component's `state`, and it's not the `value` property.
    // `prevValue` is "previous `value` property".
    // `newValue` is "new `value` property".
    // If the default country changed
    // (e.g. in case of ajax GeoIP detection after page loaded)
    // then select it, but only if the user hasn't already manually
    // selected a country, and no phone number has been manually entered so far.
    // Because if the user has already started inputting a phone number
    // then they're okay with no country being selected at all ("International")
    // and they don't want to be disturbed, don't want their input to be screwed, etc.
    if (newDefaultCountry !== prevDefaultCountry) {
        var isNewDefaultCountrySupported = !newDefaultCountry || (0, $9200c417dc66b970$export$92e6622a86b85d10)(newDefaultCountry, metadata);
        var noValueHasBeenEnteredByTheUser = !value || // When `international` is `true`, and some country has been pre-selected,
        // then the `<input/>` contains a pre-filled value of `+${countryCallingCode}${leadingDigits}`,
        // so in case of `international` being `true`, "the user hasn't entered anything" situation
        // doesn't just mean `value` is `undefined`, but could also mean `value` is `+${countryCallingCode}`.
        international && value === _getInitialPhoneDigits({
            value: undefined,
            defaultCountry: prevDefaultCountry
        }); // Only update the `defaultCountry` property if no phone number
        // has been entered by the user or pre-set by the application.
        var noValueHasBeenEntered = !newValue && noValueHasBeenEnteredByTheUser;
        if (!hasUserSelectedACountry && isNewDefaultCountrySupported && noValueHasBeenEntered) return {
            country: newDefaultCountry,
            // If `phoneDigits` is empty, then automatically select the new `country`
            // and set `phoneDigits` to `+{getCountryCallingCode(newCountry)}`.
            // The code assumes that "no phone number has been entered by the user",
            // and no `value` property has been passed, so the `phoneNumber` parameter
            // of `_getInitialPhoneDigits({ value, phoneNumber, ... })` is `undefined`.
            phoneDigits: _getInitialPhoneDigits({
                value: undefined,
                defaultCountry: newDefaultCountry
            }),
            // `value` is `undefined` and it stays so.
            value: undefined
        };
    } // If a new `value` is set externally.
    // (e.g. as a result of an ajax API request
    //  to get user's phone after page loaded)
    // The first part — `newValue !== prevValue` —
    // is basically `props.value !== prevProps.value`
    // so it means "if value property was changed externally".
    // The second part — `newValue !== value` —
    // is for ignoring the `getDerivedStateFromProps()` call
    // which happens in `this.onChange()` right after `this.setState()`.
    // If this `getDerivedStateFromProps()` call isn't ignored
    // then the country flag would reset on each input.
    if (newValue !== prevValue && newValue !== value) {
        var phoneNumber;
        var parsedCountry;
        if (newValue) {
            phoneNumber = (0, $f6847e6e765e4a43$export$da44e4eaa54bc82e)(newValue, metadata);
            var supportedCountries = (0, $9200c417dc66b970$export$823f1bbb8700cf79)(countries, metadata);
            if (phoneNumber && phoneNumber.country) // Ignore `else` because all countries are supported in metadata.
            /* istanbul ignore next */ {
                if (!supportedCountries || supportedCountries.indexOf(phoneNumber.country) >= 0) parsedCountry = phoneNumber.country;
            } else parsedCountry = (0, $f6847e6e765e4a43$export$e7408f1ddc48b26e)(newValue, {
                country: undefined,
                countries: supportedCountries,
                metadata: metadata
            });
        }
        var hasUserSelectedACountryUpdate;
        if (!newValue) // Reset `hasUserSelectedACountry` flag in `state`.
        hasUserSelectedACountryUpdate = {
            hasUserSelectedACountry: undefined
        };
        return $4df25d792c00472a$var$_objectSpread($4df25d792c00472a$var$_objectSpread({}, hasUserSelectedACountryUpdate), {}, {
            phoneDigits: _getInitialPhoneDigits({
                phoneNumber: phoneNumber,
                value: newValue,
                defaultCountry: newDefaultCountry
            }),
            value: newValue,
            country: newValue ? parsedCountry : newDefaultCountry
        });
    } // `defaultCountry` didn't change.
// `value` didn't change.
// `phoneDigits` didn't change, because `value` didn't change.
//
// So no need to update state.
}


function $3ce94d6ac4f63762$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3ce94d6ac4f63762$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3ce94d6ac4f63762$var$_typeof(obj);
}
var $3ce94d6ac4f63762$var$_excluded = [
    "name",
    "disabled",
    "readOnly",
    "autoComplete",
    "style",
    "className",
    "inputRef",
    "inputComponent",
    "numberInputProps",
    "smartCaret",
    "countrySelectComponent",
    "countrySelectProps",
    "containerComponent",
    "defaultCountry",
    "countries",
    "countryOptionsOrder",
    "labels",
    "flags",
    "flagComponent",
    "flagUrl",
    "addInternationalOption",
    "internationalIcon",
    "displayInitialValueAsLocalNumber",
    "initialValueFormat",
    "onCountryChange",
    "limitMaxLength",
    "countryCallingCodeEditable",
    "focusInputOnCountrySelection",
    "reset",
    "metadata",
    "international",
    "locales"
];
function $3ce94d6ac4f63762$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3ce94d6ac4f63762$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3ce94d6ac4f63762$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3ce94d6ac4f63762$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3ce94d6ac4f63762$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3ce94d6ac4f63762$var$_extends() {
    $3ce94d6ac4f63762$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3ce94d6ac4f63762$var$_extends.apply(this, arguments);
}
function $3ce94d6ac4f63762$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3ce94d6ac4f63762$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3ce94d6ac4f63762$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3ce94d6ac4f63762$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3ce94d6ac4f63762$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3ce94d6ac4f63762$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3ce94d6ac4f63762$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3ce94d6ac4f63762$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3ce94d6ac4f63762$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3ce94d6ac4f63762$var$_setPrototypeOf(subClass, superClass);
}
function $3ce94d6ac4f63762$var$_setPrototypeOf(o, p) {
    $3ce94d6ac4f63762$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3ce94d6ac4f63762$var$_setPrototypeOf(o, p);
}
function $3ce94d6ac4f63762$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3ce94d6ac4f63762$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3ce94d6ac4f63762$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3ce94d6ac4f63762$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3ce94d6ac4f63762$var$_possibleConstructorReturn(this, result);
    };
}
function $3ce94d6ac4f63762$var$_possibleConstructorReturn(self, call) {
    if (call && ($3ce94d6ac4f63762$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3ce94d6ac4f63762$var$_assertThisInitialized(self);
}
function $3ce94d6ac4f63762$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3ce94d6ac4f63762$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3ce94d6ac4f63762$var$_getPrototypeOf(o) {
    $3ce94d6ac4f63762$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3ce94d6ac4f63762$var$_getPrototypeOf(o);
}
function $3ce94d6ac4f63762$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $3ce94d6ac4f63762$var$PhoneNumberInput_ = /*#__PURE__*/ function(_React$PureComponent) {
    $3ce94d6ac4f63762$var$_inherits(PhoneNumberInput_, _React$PureComponent);
    var _super = $3ce94d6ac4f63762$var$_createSuper(PhoneNumberInput_);
    function PhoneNumberInput_(props) {
        var _this;
        $3ce94d6ac4f63762$var$_classCallCheck(this, PhoneNumberInput_);
        _this = _super.call(this, props);
        $3ce94d6ac4f63762$var$_defineProperty($3ce94d6ac4f63762$var$_assertThisInitialized(_this), "setInputRef", function(instance) {
            _this.inputRef.current = instance;
            var ref = _this.props.inputRef;
            if (ref) {
                if (typeof ref === 'function') ref(instance);
                else ref.current = instance;
            }
        });
        $3ce94d6ac4f63762$var$_defineProperty($3ce94d6ac4f63762$var$_assertThisInitialized(_this), "isCountrySupportedWithError", function(country) {
            var metadata = _this.props.metadata;
            return (0, $9200c417dc66b970$export$92e6622a86b85d10)(country, metadata);
        });
        $3ce94d6ac4f63762$var$_defineProperty($3ce94d6ac4f63762$var$_assertThisInitialized(_this), "onCountryChange", function(newCountry) {
            var _this$props = _this.props, international = _this$props.international, metadata = _this$props.metadata, onChange = _this$props.onChange, focusInputOnCountrySelection = _this$props.focusInputOnCountrySelection;
            var _this$state = _this.state, prevPhoneDigits = _this$state.phoneDigits, prevCountry = _this$state.country; // After the new `country` has been selected,
            // if the phone number `<input/>` holds any digits
            // then migrate those digits for the new `country`.
            var newPhoneDigits = (0, $f6847e6e765e4a43$export$4222dedf18d79e22)(prevPhoneDigits, {
                prevCountry: prevCountry,
                newCountry: newCountry,
                metadata: metadata,
                // Convert the phone number to "national" format
                // when the user changes the selected country by hand.
                useNationalFormat: !international
            });
            var newValue = (0, $f6847e6e765e4a43$export$2fa5ed24c9ef198e)(newPhoneDigits, newCountry, metadata); // Focus phone number `<input/>` upon country selection.
            if (focusInputOnCountrySelection) _this.inputRef.current.focus();
             // If the user has already manually selected a country
            // then don't override that already selected country
            // if the `defaultCountry` property changes.
            // That's what `hasUserSelectedACountry` flag is for.
            _this.setState({
                country: newCountry,
                hasUserSelectedACountry: true,
                phoneDigits: newPhoneDigits,
                value: newValue
            }, function() {
                // Update the new `value` property.
                // Doing it after the `state` has been updated
                // because `onChange()` will trigger `getDerivedStateFromProps()`
                // with the new `value` which will be compared to `state.value` there.
                onChange(newValue);
            });
        });
        $3ce94d6ac4f63762$var$_defineProperty($3ce94d6ac4f63762$var$_assertThisInitialized(_this), "onChange", function(_phoneDigits) {
            var _this$props2 = _this.props, defaultCountry = _this$props2.defaultCountry, onChange = _this$props2.onChange, addInternationalOption = _this$props2.addInternationalOption, international = _this$props2.international, limitMaxLength = _this$props2.limitMaxLength, countryCallingCodeEditable = _this$props2.countryCallingCodeEditable, metadata = _this$props2.metadata;
            var _this$state2 = _this.state, countries = _this$state2.countries, prevPhoneDigits = _this$state2.phoneDigits, currentlySelectedCountry = _this$state2.country;
            var _onPhoneDigitsChange = (0, $f6847e6e765e4a43$export$b48270ccb996e66)(_phoneDigits, {
                prevPhoneDigits: prevPhoneDigits,
                country: currentlySelectedCountry,
                countryRequired: !addInternationalOption,
                defaultCountry: defaultCountry,
                getAnyCountry: function getAnyCountry() {
                    return _this.getFirstSupportedCountry({
                        countries: countries
                    });
                },
                countries: countries,
                international: international,
                limitMaxLength: limitMaxLength,
                countryCallingCodeEditable: countryCallingCodeEditable,
                metadata: metadata
            }), phoneDigits = _onPhoneDigitsChange.phoneDigits, country = _onPhoneDigitsChange.country, value = _onPhoneDigitsChange.value;
            var stateUpdate = {
                phoneDigits: phoneDigits,
                value: value,
                country: country
            };
            if (countryCallingCodeEditable === false) // If it simply did `setState({ phoneDigits: intlPrefix })` here,
            // then it would have no effect when erasing an inital international prefix
            // via Backspace, because `phoneDigits` in `state` wouldn't change
            // as a result, because it was `prefix` and it became `prefix`,
            // so the component wouldn't rerender, and the user would be able
            // to erase the country calling code part, and that part is
            // assumed to be non-eraseable. That's why the component is
            // forcefully rerendered here.
            // https://github.com/catamphetamine/react-phone-number-input/issues/367#issuecomment-721703501
            {
                if (!value && phoneDigits === _this.state.phoneDigits) // Force a re-render of the `<input/>` in order to reset its value.
                stateUpdate.forceRerender = {};
            }
            _this.setState(stateUpdate, // Doing it after the `state` has been updated
            // because `onChange()` will trigger `getDerivedStateFromProps()`
            // with the new `value` which will be compared to `state.value` there.
            function() {
                return onChange(value);
            });
        });
        $3ce94d6ac4f63762$var$_defineProperty($3ce94d6ac4f63762$var$_assertThisInitialized(_this), "_onFocus", function() {
            return _this.setState({
                isFocused: true
            });
        });
        $3ce94d6ac4f63762$var$_defineProperty($3ce94d6ac4f63762$var$_assertThisInitialized(_this), "_onBlur", function() {
            return _this.setState({
                isFocused: false
            });
        });
        $3ce94d6ac4f63762$var$_defineProperty($3ce94d6ac4f63762$var$_assertThisInitialized(_this), "onFocus", function(event) {
            _this._onFocus();
            var onFocus = _this.props.onFocus;
            if (onFocus) onFocus(event);
        });
        $3ce94d6ac4f63762$var$_defineProperty($3ce94d6ac4f63762$var$_assertThisInitialized(_this), "onBlur", function(event) {
            var onBlur = _this.props.onBlur;
            _this._onBlur();
            if (onBlur) onBlur(event);
        });
        $3ce94d6ac4f63762$var$_defineProperty($3ce94d6ac4f63762$var$_assertThisInitialized(_this), "onCountryFocus", function(event) {
            _this._onFocus(); // this.setState({ countrySelectFocused: true })
            var countrySelectProps = _this.props.countrySelectProps;
            if (countrySelectProps) {
                var onFocus = countrySelectProps.onFocus;
                if (onFocus) onFocus(event);
            }
        });
        $3ce94d6ac4f63762$var$_defineProperty($3ce94d6ac4f63762$var$_assertThisInitialized(_this), "onCountryBlur", function(event) {
            _this._onBlur(); // this.setState({ countrySelectFocused: false })
            var countrySelectProps = _this.props.countrySelectProps;
            if (countrySelectProps) {
                var onBlur = countrySelectProps.onBlur;
                if (onBlur) onBlur(event);
            }
        });
        _this.inputRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createRef();
        var _this$props3 = _this.props, _value = _this$props3.value, labels = _this$props3.labels, _international = _this$props3.international, _addInternationalOption = _this$props3.addInternationalOption, displayInitialValueAsLocalNumber = _this$props3.displayInitialValueAsLocalNumber, initialValueFormat = _this$props3.initialValueFormat, _metadata = _this$props3.metadata;
        var _this$props4 = _this.props, _defaultCountry = _this$props4.defaultCountry, _countries = _this$props4.countries; // Validate `defaultCountry`.
        if (_defaultCountry) {
            if (!_this.isCountrySupportedWithError(_defaultCountry)) _defaultCountry = undefined;
        } // Validate `countries`.
        _countries = (0, $9200c417dc66b970$export$823f1bbb8700cf79)(_countries, _metadata);
        var phoneNumber = (0, $f6847e6e765e4a43$export$da44e4eaa54bc82e)(_value, _metadata);
        _this.CountryIcon = (0, $9b85cfa16afba0ba$export$c8cd064d62c67fdc)(_this.props);
        var preSelectedCountry = (0, $f6847e6e765e4a43$export$5b746bf50fbb3c55)({
            value: _value,
            phoneNumber: phoneNumber,
            defaultCountry: _defaultCountry,
            required: !_addInternationalOption,
            countries: _countries || (0, $8075aa160ef6a59f$export$2e2bcd8739ae039)(_metadata),
            getAnyCountry: function getAnyCountry() {
                return _this.getFirstSupportedCountry({
                    countries: _countries
                });
            },
            metadata: _metadata
        });
        _this.state = {
            // Workaround for `this.props` inside `getDerivedStateFromProps()`.
            props: _this.props,
            // The country selected.
            country: preSelectedCountry,
            // `countries` are stored in `this.state` because they're filtered.
            // For example, a developer might theoretically pass some unsupported
            // countries as part of the `countries` property, and because of that
            // the component uses `this.state.countries` (which are filtered)
            // instead of `this.props.countries`
            // (which could potentially contain unsupported countries).
            countries: _countries,
            // `phoneDigits` state property holds non-formatted user's input.
            // The reason is that there's no way of finding out
            // in which form should `value` be displayed: international or national.
            // E.g. if `value` is `+78005553535` then it could be input
            // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
            // Hence storing just `value` is not sufficient for correct formatting.
            // E.g. if a user entered `8 (800) 555-35-35`
            // then value is `+78005553535` and `phoneDigits` are `88005553535`
            // and if a user entered `+7 800 555 35 35`
            // then value is `+78005553535` and `phoneDigits` are `+78005553535`.
            phoneDigits: (0, $f6847e6e765e4a43$export$3b7f83419d3c9d9c)({
                value: _value,
                phoneNumber: phoneNumber,
                defaultCountry: _defaultCountry,
                international: _international,
                useNationalFormat: displayInitialValueAsLocalNumber || initialValueFormat === 'national',
                metadata: _metadata
            }),
            // `value` property is duplicated in state.
            // The reason is that `getDerivedStateFromProps()`
            // needs this `value` to compare to the new `value` property
            // to find out if `phoneDigits` needs updating:
            // If the `value` property was changed externally
            // then it won't be equal to `state.value`
            // in which case `phoneDigits` and `country` should be updated.
            value: _value
        };
        return _this;
    }
    $3ce94d6ac4f63762$var$_createClass(PhoneNumberInput_, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var onCountryChange = this.props.onCountryChange;
                var defaultCountry = this.props.defaultCountry;
                var selectedCountry = this.state.country;
                if (onCountryChange) {
                    if (defaultCountry) {
                        if (!this.isCountrySupportedWithError(defaultCountry)) defaultCountry = undefined;
                    }
                    if (selectedCountry !== defaultCountry) onCountryChange(selectedCountry);
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var onCountryChange = this.props.onCountryChange;
                var country = this.state.country; // Call `onCountryChange` when user selects another country.
                if (onCountryChange && country !== prevState.country) onCountryChange(country);
            }
        },
        {
            key: "getCountrySelectOptions",
            value: function getCountrySelectOptions(_ref) {
                var countries = _ref.countries;
                var _this$props5 = this.props, international = _this$props5.international, countryCallingCodeEditable = _this$props5.countryCallingCodeEditable, countryOptionsOrder = _this$props5.countryOptionsOrder, addInternationalOption = _this$props5.addInternationalOption, labels = _this$props5.labels, locales = _this$props5.locales, metadata = _this$props5.metadata;
                return this.useMemoCountrySelectOptions(function() {
                    return (0, $9200c417dc66b970$export$5e75b0f0f43cd233)((0, $f6847e6e765e4a43$export$85590f0e7cf668c8)({
                        countries: countries || (0, $8075aa160ef6a59f$export$2e2bcd8739ae039)(metadata),
                        countryNames: labels,
                        addInternationalOption: international && countryCallingCodeEditable === false ? false : addInternationalOption,
                        compareStringsLocales: locales // compareStrings
                    }), (0, $9200c417dc66b970$export$afcb8c072b7545af)(countryOptionsOrder, metadata));
                }, [
                    countries,
                    countryOptionsOrder,
                    addInternationalOption,
                    labels,
                    metadata
                ]);
            }
        },
        {
            key: "useMemoCountrySelectOptions",
            value: function useMemoCountrySelectOptions(generator, dependencies) {
                if (!this.countrySelectOptionsMemoDependencies || !$3ce94d6ac4f63762$var$areEqualArrays(dependencies, this.countrySelectOptionsMemoDependencies)) {
                    this.countrySelectOptionsMemo = generator();
                    this.countrySelectOptionsMemoDependencies = dependencies;
                }
                return this.countrySelectOptionsMemo;
            }
        },
        {
            key: "getFirstSupportedCountry",
            value: function getFirstSupportedCountry(_ref2) {
                var countries = _ref2.countries;
                var countryOptions = this.getCountrySelectOptions({
                    countries: countries
                });
                return countryOptions[0].value;
            } // A shorthand for not passing `metadata` as a second argument.
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, name = _this$props6.name, disabled = _this$props6.disabled, readOnly = _this$props6.readOnly, autoComplete = _this$props6.autoComplete, style = _this$props6.style, className = _this$props6.className, inputRef = _this$props6.inputRef, inputComponent = _this$props6.inputComponent, numberInputProps = _this$props6.numberInputProps, smartCaret = _this$props6.smartCaret, CountrySelectComponent = _this$props6.countrySelectComponent, countrySelectProps = _this$props6.countrySelectProps, ContainerComponent = _this$props6.containerComponent, defaultCountry = _this$props6.defaultCountry, countriesProperty = _this$props6.countries, countryOptionsOrder = _this$props6.countryOptionsOrder, labels = _this$props6.labels, flags = _this$props6.flags, flagComponent = _this$props6.flagComponent, flagUrl = _this$props6.flagUrl, addInternationalOption = _this$props6.addInternationalOption, internationalIcon = _this$props6.internationalIcon, displayInitialValueAsLocalNumber = _this$props6.displayInitialValueAsLocalNumber, initialValueFormat = _this$props6.initialValueFormat, onCountryChange = _this$props6.onCountryChange, limitMaxLength = _this$props6.limitMaxLength, countryCallingCodeEditable = _this$props6.countryCallingCodeEditable, focusInputOnCountrySelection = _this$props6.focusInputOnCountrySelection, reset = _this$props6.reset, metadata = _this$props6.metadata, international = _this$props6.international, locales = _this$props6.locales, rest = $3ce94d6ac4f63762$var$_objectWithoutProperties(_this$props6, $3ce94d6ac4f63762$var$_excluded);
                var _this$state3 = this.state, country = _this$state3.country, countries = _this$state3.countries, phoneDigits = _this$state3.phoneDigits, isFocused = _this$state3.isFocused;
                var InputComponent = smartCaret ? (0, $9ebe3f87ca88bd46$export$2e2bcd8739ae039) : (0, $479164b8746bd89e$export$2e2bcd8739ae039);
                var countrySelectOptions = this.getCountrySelectOptions({
                    countries: countries
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(ContainerComponent, {
                    style: style,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9c33d2044c0b2f89$exports)))(className, 'PhoneInput', {
                        'PhoneInput--focus': isFocused,
                        'PhoneInput--disabled': disabled,
                        'PhoneInput--readOnly': readOnly
                    })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(CountrySelectComponent, $3ce94d6ac4f63762$var$_extends({
                    name: name ? "".concat(name, "Country") : undefined,
                    "aria-label": labels.country
                }, countrySelectProps, {
                    value: country,
                    options: countrySelectOptions,
                    onChange: this.onCountryChange,
                    onFocus: this.onCountryFocus,
                    onBlur: this.onCountryBlur,
                    disabled: disabled || countrySelectProps && countrySelectProps.disabled,
                    readOnly: readOnly || countrySelectProps && countrySelectProps.readOnly,
                    iconComponent: this.CountryIcon
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(InputComponent, $3ce94d6ac4f63762$var$_extends({
                    ref: this.setInputRef,
                    type: "tel",
                    autoComplete: autoComplete
                }, numberInputProps, rest, {
                    name: name,
                    metadata: metadata,
                    country: country,
                    value: phoneDigits || '',
                    onChange: this.onChange,
                    onFocus: this.onFocus,
                    onBlur: this.onBlur,
                    disabled: disabled,
                    readOnly: readOnly,
                    inputComponent: inputComponent,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9c33d2044c0b2f89$exports)))('PhoneInputInput', numberInputProps && numberInputProps.className, rest.className)
                })));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: // * `country` — The currently selected country, e.g. `"RU"`.
            // * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
            // * `phoneDigits` — The parsed `<input/>` value, e.g. `8005553535`.
            // (and a couple of other less significant properties)
            function getDerivedStateFromProps(props, state) {
                return $3ce94d6ac4f63762$var$_objectSpread({
                    // Emulate `prevProps` via `state.props`.
                    props: props
                }, (0, $4df25d792c00472a$export$2e2bcd8739ae039)(props, state.props, state));
            }
        }
    ]);
    return PhoneNumberInput_;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).PureComponent); // This wrapper is only to `.forwardRef()` to the `<input/>`.
var $3ce94d6ac4f63762$var$PhoneNumberInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($3ce94d6ac4f63762$var$PhoneNumberInput_, $3ce94d6ac4f63762$var$_extends({}, props, {
        inputRef: ref
    }));
});
$3ce94d6ac4f63762$var$PhoneNumberInput.propTypes = {
    /**
   * Phone number in `E.164` format.
   *
   * Example:
   *
   * `"+12223333333"`
   *
   * Any "falsy" value like `undefined`, `null` or an empty string `""` is treated like "empty".
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    /**
   * A function of `value: string?`.
   *
   * Updates the `value` property as the user inputs a phone number.
   *
   * If the user erases the input value, the argument is `undefined`.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired,
    /**
   * Toggles the `--focus` CSS class.
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    /**
   * `onBlur` is usually passed by `redux-form`.
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `disabled`.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `readonly`.
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    /**
   * Sets `autoComplete` property for phone number `<input/>`.
   *
   * Web browser's "autocomplete" feature
   * remembers the phone number being input
   * and can also autofill the `<input/>`
   * with previously remembered phone numbers.
   *
   * https://developers.google.com
   * /web/updates/2015/06/checkout-faster-with-autofill
   *
   * For example, can be used to turn it off:
   *
   * "So when should you use `autocomplete="off"`?
   *  One example is when you've implemented your own version
   *  of autocomplete for search. Another example is any form field
   *  where users will input and submit different kinds of information
   *  where it would not be useful to have the browser remember
   *  what was submitted previously".
   */ // (is `"tel"` by default)
    autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired,
    /**
   * Set to `"national"` to show the initial `value` in
   * "national" format rather than "international".
   *
   * For example, if `initialValueFormat` is `"national"`
   * and the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"(213) 373-4253"`.
   *
   * By default, `initialValueFormat` is `undefined`,
   * meaning that if the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"+1 213 373 4253"`.
   *
   * The reason for such default behaviour is that
   * the newer generation grows up when there are no stationary phones
   * and therefore everyone inputs phone numbers in international format
   * in their smartphones so people gradually get more accustomed to
   * writing phone numbers in international format rather than in local format.
   * Future people won't be using "national" format, only "international".
   */ // (is `undefined` by default)
    initialValueFormat: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf([
        'national'
    ]),
    // `displayInitialValueAsLocalNumber` property has been
    // superceded by `initialValueFormat` property.
    displayInitialValueAsLocalNumber: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    /**
   * The country to be selected by default.
   * For example, can be set after a GeoIP lookup.
   *
   * Example: `"US"`.
   */ // A two-letter country code ("ISO 3166-1 alpha-2").
    defaultCountry: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    /**
   * If specified, only these countries will be available for selection.
   *
   * Example:
   *
   * `["RU", "UA", "KZ"]`
   */ countries: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string),
    /**
   * Custom country `<select/>` option names.
   * Also some labels like "ext" and country `<select/>` `aria-label`.
   *
   * Example:
   *
   * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
   *
   * See the `locales` directory for examples.
   */ labels: (0, $f666091b30e08e9b$export$a238cb463698c900).isRequired,
    /**
   * Country `<select/>` options are sorted by their labels.
   * The default sorting function uses `a.localeCompare(b, locales)`,
   * and, if that's not available, falls back to simple `a > b` / `a < b`.
   * Some languages, like Chinese, support multiple sorting variants
   * (called "collations"), and the user might prefer one or another.
   * Also, sometimes the Operating System language is not always
   * the preferred language for a person using a website or an application,
   * so there should be a way to specify custom locale.
   * This `locales` property mimicks the `locales` argument of `Intl` constructors,
   * and can be either a Unicode BCP 47 locale identifier or an array of such locale identifiers.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument
   */ locales: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string)
    ]),
    /*
   * Custom country `<select/>` options sorting function.
   * The default one uses `a.localeCompare(b)`, and,
   * if that's not available, falls back to simple `a > b`/`a < b`.
   * There have been requests to add custom sorter for cases
   * like Chinese language and "pinyin" (non-default) sorting order.
   * https://stackoverflow.com/questions/22907288/chinese-sorting-by-pinyin-in-javascript-with-localecompare
  compareStrings: PropTypes.func,
   */ /**
   * A URL template of a country flag, where
   * "{XX}" is a two-letter country code in upper case,
   * or where "{xx}" is a two-letter country code in lower case.
   * By default it points to `country-flag-icons` gitlab pages website.
   * I imagine someone might want to download those country flag icons
   * and host them on their own servers instead
   * (all flags are available in the `country-flag-icons` library).
   * There's a catch though: new countries may be added in future,
   * so when hosting country flag icons on your own server
   * one should check the `CHANGELOG.md` every time before updating this library,
   * otherwise there's a possibility that some new country flag would be missing.
   */ flagUrl: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired,
    /**
   * Custom country flag icon components.
   * These flags will be used instead of the default ones.
   * The the "Flags" section of the readme for more info.
   *
   * The shape is an object where keys are country codes
   * and values are flag icon components.
   * Flag icon components receive the same properties
   * as `flagComponent` (see below).
   *
   * Example:
   *
   * `{ "RU": (props) => <img src="..."/> }`
   *
   * Example:
   *
   * `import flags from 'country-flag-icons/react/3x2'`
   *
   * `import PhoneInput from 'react-phone-number-input'`
   *
   * `<PhoneInput flags={flags} .../>`
   */ flags: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).elementType),
    /**
   * Country flag icon component.
   *
   * Takes properties:
   *
   * * `country: string` — The country code.
   * * `countryName: string` — The country name.
   * * `flagUrl: string` — The `flagUrl` property (see above).
   * * `flags: object` — The `flags` property (see above).
   */ flagComponent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).elementType.isRequired,
    /**
   * Set to `false` to remove the "International" option from country `<select/>`.
   */ addInternationalOption: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool.isRequired,
    /**
   * "International" icon component.
   * Should have the same aspect ratio.
   *
   * Receives properties:
   *
   * * `title: string` — "International" country option label.
   */ internationalIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).elementType.isRequired,
    /**
   * Can be used to place some countries on top of the list of country `<select/>` options.
   *
   * * `"XX"` — inserts an option for "XX" country.
   * * `"🌐"` — inserts "International" option.
   * * `"|"` — inserts a separator.
   * * `"..."` — inserts options for the rest of the countries (can be omitted, in which case it will be automatically added at the end).
   *
   * Example:
   *
   * `["US", "CA", "AU", "|", "..."]`
   */ countryOptionsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string),
    /**
   * `<Phone/>` component CSS style object.
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object,
    /**
   * `<Phone/>` component CSS class.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    /**
   * Country `<select/>` component.
   *
   * Receives properties:
   *
   * * `name: string?` — HTML `name` attribute.
   * * `value: string?` — The currently selected country code.
   * * `onChange(value: string?)` — Updates the `value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * `options: object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value: string?, label: string }`.
   * * `iconComponent: PropTypes.elementType` — React component that renders a country icon: `<Icon country={value}/>`. If `country` is `undefined` then it renders an "International" icon.
   * * `disabled: boolean?` — HTML `disabled` attribute.
   * * `readOnly: boolean?` — HTML `readOnly` attribute.
   * * `tabIndex: (number|string)?` — HTML `tabIndex` attribute.
   * * `className: string` — CSS class name.
   */ countrySelectComponent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).elementType.isRequired,
    /**
   * Country `<select/>` component props.
   * Along with the usual DOM properties such as `aria-label` and `tabIndex`,
   * some custom properties are supported, such as `arrowComponent` and `unicodeFlags`.
   */ countrySelectProps: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object,
    /**
   * Phone number `<input/>` component.
   *
   * Receives properties:
   *
   * * `value: string` — The formatted `value`.
   * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
   *
   * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).elementType.isRequired,
    /**
   * Wrapping `<div/>` component.
   *
   * Receives properties:
   *
   * * `style: object` — A component CSS style object.
   * * `className: string` — Classes to attach to the component, typically changes when component focuses or blurs.
   */ containerComponent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).elementType.isRequired,
    /**
   * Phone number `<input/>` component props.
   */ numberInputProps: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object,
    /**
   * When the user attempts to insert a digit somewhere in the middle of a phone number,
   * the caret position is moved right before the next available digit skipping
   * any punctuation in between. This is called "smart" caret positioning.
   * Another case would be the phone number format changing as a result of
   * the user inserting the digit somewhere in the middle, which would require
   * re-positioning the caret because all digit positions have changed.
   * This "smart" caret positioning feature can be turned off by passing
   * `smartCaret={false}` property: use it in case of any possible issues
   * with caret position during phone number input.
   */ // Is `true` by default.
    smartCaret: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool.isRequired,
    /**
   * Set to `true` to force "international" phone number format.
   * Set to `false` to force "national" phone number format.
   * By default it's `undefined` meaning that it doesn't enforce any phone number format.
   */ international: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    /**
   * If set to `true`, the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */ limitMaxLength: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool.isRequired,
    /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */ countryCallingCodeEditable: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool.isRequired,
    /**
   * `libphonenumber-js` metadata.
   *
   * Can be used to pass custom `libphonenumber-js` metadata
   * to reduce the overall bundle size for those who compile "custom" metadata.
   */ metadata: (0, $f666091b30e08e9b$export$dbb5e893e736e4ee).isRequired,
    /**
   * Is called every time the selected country changes:
   * either programmatically or when user selects it manually from the list.
   */ // People have been asking for a way to get the selected country.
    // @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
    // For some it's just a "business requirement".
    // I guess it's about gathering as much info on the user as a website can
    // without introducing any addional fields that would complicate the form
    // therefore reducing "conversion" (that's a marketing term).
    // Assuming that the phone number's country is the user's country
    // is not 100% correct but in most cases I guess it's valid.
    onCountryChange: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */ focusInputOnCountrySelection: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool.isRequired
};
$3ce94d6ac4f63762$var$PhoneNumberInput.defaultProps = {
    /**
   * Remember (and autofill) the value as a phone number.
   */ autoComplete: 'tel',
    /**
   * Country `<select/>` component.
   */ countrySelectComponent: (0, $747ce7eea7f38edd$export$2d95fe84e9746c91),
    /**
   * Flag icon component.
   */ flagComponent: (0, $0053744d0b1cec56$export$2e2bcd8739ae039),
    /**
   * By default, uses icons from `country-flag-icons` gitlab pages website.
   */ // Must be equal to `flagUrl` in `./CountryIcon.js`.
    flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',
    /**
   * Default "International" country `<select/>` option icon.
   */ internationalIcon: (0, $191fc45265b3c625$export$2e2bcd8739ae039),
    /**
   * Phone number `<input/>` component.
   */ inputComponent: 'input',
    /**
   * Wrapping `<div/>` component.
   */ containerComponent: 'div',
    /**
   * Some users requested a way to reset the component:
   * both number `<input/>` and country `<select/>`.
   * Whenever `reset` property changes both number `<input/>`
   * and country `<select/>` are reset.
   * It's not implemented as some instance `.reset()` method
   * because `ref` is forwarded to `<input/>`.
   * It's also not replaced with just resetting `country` on
   * external `value` reset, because a user could select a country
   * and then not input any `value`, and so the selected country
   * would be "stuck", if not using this `reset` property.
   */ // https://github.com/catamphetamine/react-phone-number-input/issues/300
    reset: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).any,
    /**
   *
   */ /**
   * Set to `false` to use "basic" caret instead of the "smart" one.
   */ smartCaret: true,
    /**
   * Whether to add the "International" option
   * to the list of countries.
   */ addInternationalOption: true,
    /**
   * If set to `true` the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */ limitMaxLength: false,
    /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */ countryCallingCodeEditable: true,
    /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */ focusInputOnCountrySelection: true
};
var $3ce94d6ac4f63762$export$2e2bcd8739ae039 = $3ce94d6ac4f63762$var$PhoneNumberInput;
function $3ce94d6ac4f63762$var$areEqualArrays(a, b) {
    if (a.length !== b.length) return false;
    var i = 0;
    while(i < a.length){
        if (a[i] !== b[i]) return false;
        i++;
    }
    return true;
}


function $8ca57fc39dc048af$var$_extends() {
    $8ca57fc39dc048af$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8ca57fc39dc048af$var$_extends.apply(this, arguments);
}
function $8ca57fc39dc048af$export$6b3f3b62761c8af5(defaultMetadata) {
    var PhoneInputDefault = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef(function(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $3ce94d6ac4f63762$export$2e2bcd8739ae039), $8ca57fc39dc048af$var$_extends({
            ref: ref
        }, props));
    });
    PhoneInputDefault.propTypes = {
        metadata: (0, $f666091b30e08e9b$export$dbb5e893e736e4ee).isRequired,
        labels: (0, $f666091b30e08e9b$export$a238cb463698c900).isRequired
    };
    PhoneInputDefault.defaultProps = {
        metadata: defaultMetadata,
        labels: (0, $640ed058ec39342f$export$2e2bcd8739ae039)
    };
    return PhoneInputDefault;
}
var $8ca57fc39dc048af$export$2e2bcd8739ae039 = $8ca57fc39dc048af$export$6b3f3b62761c8af5();


function $8ffa95678d96c8dd$var$call(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $9dfc8eccc5634193$export$2e2bcd8739ae039));
    return func.apply(this, args);
}
var $8ffa95678d96c8dd$export$2e2bcd8739ae039 = (0, $8ca57fc39dc048af$export$6b3f3b62761c8af5)((0, $9dfc8eccc5634193$export$2e2bcd8739ae039));
function $8ffa95678d96c8dd$export$da44e4eaa54bc82e() {
    return $8ffa95678d96c8dd$var$call((0, $f39fb66294e78ae2$export$2e2bcd8739ae039), arguments);
}
function $8ffa95678d96c8dd$export$842dcfa371c6bb83() {
    return $8ffa95678d96c8dd$var$call((0, $cd11044a8c1dceb8$export$2e2bcd8739ae039), arguments);
}
function $8ffa95678d96c8dd$export$88012462592bc004() {
    return $8ffa95678d96c8dd$var$call((0, $cd11044a8c1dceb8$export$88012462592bc004), arguments);
}
function $8ffa95678d96c8dd$export$992e2df24bec72ba() {
    return $8ffa95678d96c8dd$var$call((0, $5ed2bcabcdbe614f$export$2e2bcd8739ae039), arguments);
}
function $8ffa95678d96c8dd$export$e102acdf1aeb3167() {
    return $8ffa95678d96c8dd$var$call((0, $b5d7fc59ba37c407$export$2e2bcd8739ae039), arguments);
}
function $8ffa95678d96c8dd$export$44f7508c6c352cc6() {
    return $8ffa95678d96c8dd$var$call((0, $8075aa160ef6a59f$export$2e2bcd8739ae039), arguments);
}
function $8ffa95678d96c8dd$export$32876ca2f1919cf0() {
    return $8ffa95678d96c8dd$var$call((0, $9015f651de9f4947$export$32876ca2f1919cf0), arguments);
}
function $8ffa95678d96c8dd$export$bd9e113b8b17202a() {
    return $8ffa95678d96c8dd$var$call((0, $9015f651de9f4947$export$bd9e113b8b17202a), arguments);
}


var $e4a70e44494a1d50$exports = {};

$parcel$export($e4a70e44494a1d50$exports, "countrySelectInsideInput", function () { return $e4a70e44494a1d50$export$92fa9f2ce10bfe90; }, function (v) { return $e4a70e44494a1d50$export$92fa9f2ce10bfe90 = v; });
$parcel$export($e4a70e44494a1d50$exports, "defaultPhoneInput", function () { return $e4a70e44494a1d50$export$6b221fb4d75ef768; }, function (v) { return $e4a70e44494a1d50$export$6b221fb4d75ef768 = v; });
$parcel$export($e4a70e44494a1d50$exports, "large", function () { return $e4a70e44494a1d50$export$f09585a853dddd32; }, function (v) { return $e4a70e44494a1d50$export$f09585a853dddd32 = v; });
$parcel$export($e4a70e44494a1d50$exports, "medium", function () { return $e4a70e44494a1d50$export$649ecc744817b5c7; }, function (v) { return $e4a70e44494a1d50$export$649ecc744817b5c7 = v; });
$parcel$export($e4a70e44494a1d50$exports, "phoneContainer", function () { return $e4a70e44494a1d50$export$bcbc0114e9f3ac1c; }, function (v) { return $e4a70e44494a1d50$export$bcbc0114e9f3ac1c = v; });
$parcel$export($e4a70e44494a1d50$exports, "small", function () { return $e4a70e44494a1d50$export$3c17b0e969a90510; }, function (v) { return $e4a70e44494a1d50$export$3c17b0e969a90510 = v; });
$parcel$export($e4a70e44494a1d50$exports, "white", function () { return $e4a70e44494a1d50$export$8fa4e5556fd77a60; }, function (v) { return $e4a70e44494a1d50$export$8fa4e5556fd77a60 = v; });
$parcel$export($e4a70e44494a1d50$exports, "whitePhoneInput", function () { return $e4a70e44494a1d50$export$f14acf69baa65e27; }, function (v) { return $e4a70e44494a1d50$export$f14acf69baa65e27 = v; });
var $e4a70e44494a1d50$export$92fa9f2ce10bfe90;
var $e4a70e44494a1d50$export$6b221fb4d75ef768;
var $e4a70e44494a1d50$export$f09585a853dddd32;
var $e4a70e44494a1d50$export$649ecc744817b5c7;
var $e4a70e44494a1d50$export$bcbc0114e9f3ac1c;
var $e4a70e44494a1d50$export$3c17b0e969a90510;
var $e4a70e44494a1d50$export$8fa4e5556fd77a60;
var $e4a70e44494a1d50$export$f14acf69baa65e27;
$e4a70e44494a1d50$export$92fa9f2ce10bfe90 = `_9CYXSG_countrySelectInsideInput`;
$e4a70e44494a1d50$export$6b221fb4d75ef768 = `_9CYXSG_defaultPhoneInput`;
$e4a70e44494a1d50$export$f09585a853dddd32 = `_9CYXSG_large`;
$e4a70e44494a1d50$export$649ecc744817b5c7 = `_9CYXSG_medium`;
$e4a70e44494a1d50$export$bcbc0114e9f3ac1c = `_9CYXSG_phoneContainer`;
$e4a70e44494a1d50$export$3c17b0e969a90510 = `_9CYXSG_small`;
$e4a70e44494a1d50$export$8fa4e5556fd77a60 = `_9CYXSG_white`;
$e4a70e44494a1d50$export$f14acf69baa65e27 = `_9CYXSG_whitePhoneInput`;



function $5ba7d8eeafddcf67$var$PhoneInputField(props) {
    const { onChange: onChange, color: color = 'default', defaultCountry: defaultCountry = 'US', size: size = 'medium', className: className = '', ...rest } = props;
    return (0, $bb3TF.jsx)("div", {
        className: `${$e4a70e44494a1d50$exports.phoneContainer} ${color === 'white' ? $e4a70e44494a1d50$exports.countrySelectInsideInput : ''}`,
        children: (0, $bb3TF.jsx)((0, $8ffa95678d96c8dd$export$2e2bcd8739ae039), {
            onChange: onChange,
            defaultCountry: defaultCountry,
            className: `${$e4a70e44494a1d50$exports[color]} ${$e4a70e44494a1d50$exports[size]} ${className}`,
            numberInputProps: {
                className: `${color === 'white' ? $e4a70e44494a1d50$exports.whitePhoneInput : $e4a70e44494a1d50$exports.defaultPhoneInput}`
            },
            ...rest
        })
    });
}
$5ba7d8eeafddcf67$var$PhoneInputField.defaultProps = {
    color: 'default',
    size: 'medium'
};
var $5ba7d8eeafddcf67$export$2e2bcd8739ae039 = $5ba7d8eeafddcf67$var$PhoneInputField;


var $8f7fe33a44836803$export$189c6ba3eaa96ac2;
(function(AddressType) {
    AddressType["Business"] = "BUSINESS";
    AddressType["Personal"] = "PERSONAL";
})($8f7fe33a44836803$export$189c6ba3eaa96ac2 || ($8f7fe33a44836803$export$189c6ba3eaa96ac2 = {}));
var $8f7fe33a44836803$export$23014ea746dc1f96;
(function(BusinessType) {
    BusinessType["Company"] = "COMPANY";
    BusinessType["Individual"] = "INDIVIDUAL";
})($8f7fe33a44836803$export$23014ea746dc1f96 || ($8f7fe33a44836803$export$23014ea746dc1f96 = {}));
var $8f7fe33a44836803$export$e5f8203198481f3c;
(function(CustomDomainStatuses) {
    CustomDomainStatuses["Expired"] = "EXPIRED";
    CustomDomainStatuses["Failed"] = "FAILED";
    CustomDomainStatuses["Inactive"] = "INACTIVE";
    CustomDomainStatuses["Issued"] = "ISSUED";
    CustomDomainStatuses["PendingValidation"] = "PENDING_VALIDATION";
    CustomDomainStatuses["Revoked"] = "REVOKED";
    CustomDomainStatuses["ValidationTimedOut"] = "VALIDATION_TIMED_OUT";
})($8f7fe33a44836803$export$e5f8203198481f3c || ($8f7fe33a44836803$export$e5f8203198481f3c = {}));
var $8f7fe33a44836803$export$1493eeed8bebfae9;
(function(EventStatuses) {
    EventStatuses["Canceled"] = "CANCELED";
    EventStatuses["Complete"] = "COMPLETE";
    EventStatuses["Confirmed"] = "CONFIRMED";
    EventStatuses["Incomplete"] = "INCOMPLETE";
    EventStatuses["Rescheduled"] = "RESCHEDULED";
    EventStatuses["Scheduled"] = "SCHEDULED";
})($8f7fe33a44836803$export$1493eeed8bebfae9 || ($8f7fe33a44836803$export$1493eeed8bebfae9 = {}));
var $8f7fe33a44836803$export$3d7865934588d77e;
(function(EventType) {
    EventType["Call"] = "CALL";
    EventType["Home"] = "HOME";
    EventType["Office"] = "OFFICE";
    EventType["Other"] = "OTHER";
    EventType["Video"] = "VIDEO";
})($8f7fe33a44836803$export$3d7865934588d77e || ($8f7fe33a44836803$export$3d7865934588d77e = {}));
var $8f7fe33a44836803$export$30fc7f1c5f6413ba;
(function(FailureReason) {
    FailureReason["AdditionalVerificationRequired"] = "ADDITIONAL_VERIFICATION_REQUIRED";
    FailureReason["CaaError"] = "CAA_ERROR";
    FailureReason["DomainNotAllowed"] = "DOMAIN_NOT_ALLOWED";
    FailureReason["DomainValidationDenied"] = "DOMAIN_VALIDATION_DENIED";
    FailureReason["InvalidPublicDomain"] = "INVALID_PUBLIC_DOMAIN";
    FailureReason["NoAvailableContacts"] = "NO_AVAILABLE_CONTACTS";
    FailureReason["Other"] = "OTHER";
    FailureReason["PcaAccessDenied"] = "PCA_ACCESS_DENIED";
    FailureReason["PcaInvalidArgs"] = "PCA_INVALID_ARGS";
    FailureReason["PcaInvalidArn"] = "PCA_INVALID_ARN";
    FailureReason["PcaInvalidDuration"] = "PCA_INVALID_DURATION";
    FailureReason["PcaInvalidState"] = "PCA_INVALID_STATE";
    FailureReason["PcaLimitExceeded"] = "PCA_LIMIT_EXCEEDED";
    FailureReason["PcaNameConstraintsValidation"] = "PCA_NAME_CONSTRAINTS_VALIDATION";
    FailureReason["PcaRequestFailed"] = "PCA_REQUEST_FAILED";
    FailureReason["PcaResourceNotFound"] = "PCA_RESOURCE_NOT_FOUND";
    FailureReason["SlrNotFound"] = "SLR_NOT_FOUND";
})($8f7fe33a44836803$export$30fc7f1c5f6413ba || ($8f7fe33a44836803$export$30fc7f1c5f6413ba = {}));
var $8f7fe33a44836803$export$c40deacab7e2491c;
(function(FeatureType) {
    FeatureType["AiAssistantBasic"] = "AI_ASSISTANT_BASIC";
    FeatureType["AiAssistantPremium"] = "AI_ASSISTANT_PREMIUM";
    FeatureType["AiAssistantTrial"] = "AI_ASSISTANT_TRIAL";
})($8f7fe33a44836803$export$c40deacab7e2491c || ($8f7fe33a44836803$export$c40deacab7e2491c = {}));
var $8f7fe33a44836803$export$ed12481c953b8653;
(function(FieldType) {
    FieldType["Date"] = "DATE";
    FieldType["Signature"] = "SIGNATURE";
    FieldType["Text"] = "TEXT";
})($8f7fe33a44836803$export$ed12481c953b8653 || ($8f7fe33a44836803$export$ed12481c953b8653 = {}));
var $8f7fe33a44836803$export$cc717174dae9aba5;
(function(FirmAccountType) {
    FirmAccountType["Arearep"] = "AREAREP";
    FirmAccountType["Enterprise"] = "ENTERPRISE";
    FirmAccountType["Office"] = "OFFICE";
    FirmAccountType["Standard"] = "STANDARD";
})($8f7fe33a44836803$export$cc717174dae9aba5 || ($8f7fe33a44836803$export$cc717174dae9aba5 = {}));
var $8f7fe33a44836803$export$929a37757e01f43a;
(function(KbaType) {
    KbaType["Basic"] = "BASIC";
    KbaType["Enhanced"] = "ENHANCED";
    KbaType["Without"] = "WITHOUT";
})($8f7fe33a44836803$export$929a37757e01f43a || ($8f7fe33a44836803$export$929a37757e01f43a = {}));
var $8f7fe33a44836803$export$9130146a86a85749;
(function(NotificationType) {
    NotificationType["Client"] = "CLIENT";
    NotificationType["Reminders"] = "REMINDERS";
    NotificationType["Team"] = "TEAM";
})($8f7fe33a44836803$export$9130146a86a85749 || ($8f7fe33a44836803$export$9130146a86a85749 = {}));
var $8f7fe33a44836803$export$a9572cd0d740fbfc;
(function(PhoneType) {
    PhoneType["Home"] = "HOME";
    PhoneType["Landline"] = "LANDLINE";
    PhoneType["Mobile"] = "MOBILE";
    PhoneType["Office"] = "OFFICE";
    PhoneType["Personal"] = "PERSONAL";
    PhoneType["Work"] = "WORK";
})($8f7fe33a44836803$export$a9572cd0d740fbfc || ($8f7fe33a44836803$export$a9572cd0d740fbfc = {}));
var $8f7fe33a44836803$export$3ae475c5deb781e2;
(function(QuestionTag) {
    QuestionTag["BankAccountNumber"] = "BANK_ACCOUNT_NUMBER";
    QuestionTag["BankMethod"] = "BANK_METHOD";
    QuestionTag["BankName"] = "BANK_NAME";
    QuestionTag["BankRoutingNumber"] = "BANK_ROUTING_NUMBER";
    QuestionTag["Conditional"] = "CONDITIONAL";
    QuestionTag["DependentAnnualIncome"] = "DEPENDENT_ANNUAL_INCOME";
    QuestionTag["DependentBirthDate"] = "DEPENDENT_BIRTH_DATE";
    QuestionTag["DependentFirstName"] = "DEPENDENT_FIRST_NAME";
    QuestionTag["DependentFullTimeStudent"] = "DEPENDENT_FULL_TIME_STUDENT";
    QuestionTag["DependentLastName"] = "DEPENDENT_LAST_NAME";
    QuestionTag["DependentMonthsInHome"] = "DEPENDENT_MONTHS_IN_HOME";
    QuestionTag["DependentRelationship"] = "DEPENDENT_RELATIONSHIP";
    QuestionTag["DependentSsn"] = "DEPENDENT_SSN";
    QuestionTag["FilingStatus"] = "FILING_STATUS";
    QuestionTag["SpouseBirthDate"] = "SPOUSE_BIRTH_DATE";
    QuestionTag["SpouseFirstName"] = "SPOUSE_FIRST_NAME";
    QuestionTag["SpouseLastName"] = "SPOUSE_LAST_NAME";
    QuestionTag["SpouseOccupation"] = "SPOUSE_OCCUPATION";
    QuestionTag["SpousePhone"] = "SPOUSE_PHONE";
    QuestionTag["SpouseSsn"] = "SPOUSE_SSN";
    QuestionTag["TaxpayerAddress_1"] = "TAXPAYER_ADDRESS_1";
    QuestionTag["TaxpayerAddress_2"] = "TAXPAYER_ADDRESS_2";
    QuestionTag["TaxpayerBirthDate"] = "TAXPAYER_BIRTH_DATE";
    QuestionTag["TaxpayerCity"] = "TAXPAYER_CITY";
    QuestionTag["TaxpayerFirstName"] = "TAXPAYER_FIRST_NAME";
    QuestionTag["TaxpayerLastName"] = "TAXPAYER_LAST_NAME";
    QuestionTag["TaxpayerOccupation"] = "TAXPAYER_OCCUPATION";
    QuestionTag["TaxpayerPhone"] = "TAXPAYER_PHONE";
    QuestionTag["TaxpayerSsn"] = "TAXPAYER_SSN";
    QuestionTag["TaxpayerState"] = "TAXPAYER_STATE";
    QuestionTag["TaxpayerZip"] = "TAXPAYER_ZIP";
})($8f7fe33a44836803$export$3ae475c5deb781e2 || ($8f7fe33a44836803$export$3ae475c5deb781e2 = {}));
var $8f7fe33a44836803$export$51940fbbacba35d4;
(function(QuestionType) {
    QuestionType["Date"] = "DATE";
    QuestionType["Dropdown"] = "DROPDOWN";
    QuestionType["Email"] = "EMAIL";
    QuestionType["EncryptedText"] = "ENCRYPTED_TEXT";
    QuestionType["Float"] = "FLOAT";
    QuestionType["Phone"] = "PHONE";
    QuestionType["Radio"] = "RADIO";
    QuestionType["Ssn"] = "SSN";
    QuestionType["Text"] = "TEXT";
    QuestionType["TextArea"] = "TEXT_AREA";
})($8f7fe33a44836803$export$51940fbbacba35d4 || ($8f7fe33a44836803$export$51940fbbacba35d4 = {}));
var $8f7fe33a44836803$export$26eb612553c8a2cb;
(function(ReminderType) {
    ReminderType["RequestDocuments"] = "REQUEST_DOCUMENTS";
    ReminderType["RequestPayment"] = "REQUEST_PAYMENT";
})($8f7fe33a44836803$export$26eb612553c8a2cb || ($8f7fe33a44836803$export$26eb612553c8a2cb = {}));
var $8f7fe33a44836803$export$ddbe8748ad68508;
(function(ReviewStatus) {
    ReviewStatus["Accepted"] = "ACCEPTED";
    ReviewStatus["In"] = "IN";
    ReviewStatus["Rejected"] = "REJECTED";
})($8f7fe33a44836803$export$ddbe8748ad68508 || ($8f7fe33a44836803$export$ddbe8748ad68508 = {}));
var $8f7fe33a44836803$export$53c00ce1d69a3728;
(function(SettingsCategory) {
    SettingsCategory["CalendarSettings"] = "CALENDAR_SETTINGS";
    SettingsCategory["FirmAiSettings"] = "FIRM_AI_SETTINGS";
    SettingsCategory["FirmMonetizationSettings"] = "FIRM_MONETIZATION_SETTINGS";
})($8f7fe33a44836803$export$53c00ce1d69a3728 || ($8f7fe33a44836803$export$53c00ce1d69a3728 = {}));
var $8f7fe33a44836803$export$c8a28fa01531a6e8;
(function(SettingsType) {
    SettingsType["Boolean"] = "BOOLEAN";
    SettingsType["Date"] = "DATE";
    SettingsType["Number"] = "NUMBER";
    SettingsType["String"] = "STRING";
})($8f7fe33a44836803$export$c8a28fa01531a6e8 || ($8f7fe33a44836803$export$c8a28fa01531a6e8 = {}));
var $8f7fe33a44836803$export$8ae99efa3d653842;
(function(SpecialSectionsType) {
    SpecialSectionsType["BasicPersonalInformation"] = "BASIC_PERSONAL_INFORMATION";
    SpecialSectionsType["DependentInformation"] = "DEPENDENT_INFORMATION";
    SpecialSectionsType["DirectDepositInformation"] = "DIRECT_DEPOSIT_INFORMATION";
})($8f7fe33a44836803$export$8ae99efa3d653842 || ($8f7fe33a44836803$export$8ae99efa3d653842 = {}));
var $8f7fe33a44836803$export$948fff9218ac3978;
(function(StripePlanType) {
    StripePlanType["Free"] = "FREE";
    StripePlanType["Lite"] = "LITE";
    StripePlanType["Pro"] = "PRO";
    StripePlanType["Trial"] = "TRIAL";
})($8f7fe33a44836803$export$948fff9218ac3978 || ($8f7fe33a44836803$export$948fff9218ac3978 = {}));
var $8f7fe33a44836803$export$a19dca1ceabeb485;
(function(StripeSubscriptionStatus) {
    StripeSubscriptionStatus["Active"] = "ACTIVE";
    StripeSubscriptionStatus["Canceled"] = "CANCELED";
    StripeSubscriptionStatus["Incomplete"] = "INCOMPLETE";
    StripeSubscriptionStatus["IncompleteExpired"] = "INCOMPLETE_EXPIRED";
    StripeSubscriptionStatus["PastDue"] = "PAST_DUE";
    StripeSubscriptionStatus["Paused"] = "PAUSED";
    StripeSubscriptionStatus["Trialing"] = "TRIALING";
    StripeSubscriptionStatus["Unpaid"] = "UNPAID";
})($8f7fe33a44836803$export$a19dca1ceabeb485 || ($8f7fe33a44836803$export$a19dca1ceabeb485 = {}));
var $8f7fe33a44836803$export$d03237d52ee1a194;
(function(TargetOsPlatform) {
    TargetOsPlatform["Darwin_386"] = "darwin_386";
    TargetOsPlatform["DarwinAmd64"] = "darwin_amd64";
    TargetOsPlatform["DarwinArm"] = "darwin_arm";
    TargetOsPlatform["DarwinArm64"] = "darwin_arm64";
    TargetOsPlatform["DragonflyAmd64"] = "dragonfly_amd64";
    TargetOsPlatform["Freebsd_386"] = "freebsd_386";
    TargetOsPlatform["FreebsdAmd64"] = "freebsd_amd64";
    TargetOsPlatform["FreebsdArm"] = "freebsd_arm";
    TargetOsPlatform["Independent"] = "independent";
    TargetOsPlatform["Linux_386"] = "linux_386";
    TargetOsPlatform["LinuxAmd64"] = "linux_amd64";
    TargetOsPlatform["LinuxArm"] = "linux_arm";
    TargetOsPlatform["LinuxArm64"] = "linux_arm64";
    TargetOsPlatform["LinuxMips"] = "linux_mips";
    TargetOsPlatform["LinuxMips64"] = "linux_mips64";
    TargetOsPlatform["LinuxMips64le"] = "linux_mips64le";
    TargetOsPlatform["LinuxMipsle"] = "linux_mipsle";
    TargetOsPlatform["LinuxPpc64"] = "linux_ppc64";
    TargetOsPlatform["LinuxPpc64le"] = "linux_ppc64le";
    TargetOsPlatform["Netbsd_386"] = "netbsd_386";
    TargetOsPlatform["NetbsdAmd64"] = "netbsd_amd64";
    TargetOsPlatform["NetbsdArm"] = "netbsd_arm";
    TargetOsPlatform["Openbsd_386"] = "openbsd_386";
    TargetOsPlatform["OpenbsdAmd64"] = "openbsd_amd64";
    TargetOsPlatform["OpenbsdArm"] = "openbsd_arm";
    TargetOsPlatform["Plan9_386"] = "plan9_386";
    TargetOsPlatform["Plan9Amd64"] = "plan9_amd64";
    TargetOsPlatform["SolarisAmd64"] = "solaris_amd64";
    TargetOsPlatform["Windows_386"] = "windows_386";
    TargetOsPlatform["WindowsAmd64"] = "windows_amd64";
})($8f7fe33a44836803$export$d03237d52ee1a194 || ($8f7fe33a44836803$export$d03237d52ee1a194 = {}));
var $8f7fe33a44836803$export$1f8b1cab05cab788;
(function(TaskType) {
    TaskType["ApproveDocuments"] = "APPROVE_DOCUMENTS";
    TaskType["Documents"] = "DOCUMENTS";
    TaskType["Interview"] = "INTERVIEW";
    TaskType["Payments"] = "PAYMENTS";
    TaskType["RequestDocuments"] = "REQUEST_DOCUMENTS";
    TaskType["Signatures"] = "SIGNATURES";
})($8f7fe33a44836803$export$1f8b1cab05cab788 || ($8f7fe33a44836803$export$1f8b1cab05cab788 = {}));
var $8f7fe33a44836803$export$f493388d2527ca1f;
(function(TaxYearStatus) {
    TaxYearStatus["All"] = "ALL";
    TaxYearStatus["Completed"] = "COMPLETED";
    TaxYearStatus["Custom"] = "CUSTOM";
    TaxYearStatus["InProgress"] = "IN_PROGRESS";
    TaxYearStatus["Unassigned"] = "UNASSIGNED";
})($8f7fe33a44836803$export$f493388d2527ca1f || ($8f7fe33a44836803$export$f493388d2527ca1f = {}));
var $8f7fe33a44836803$export$614f97abc1364581;
(function(TaxarooAiMessageType) {
    TaxarooAiMessageType["Assistant"] = "ASSISTANT";
    TaxarooAiMessageType["File"] = "FILE";
    TaxarooAiMessageType["Special"] = "SPECIAL";
    TaxarooAiMessageType["System"] = "SYSTEM";
    TaxarooAiMessageType["User"] = "USER";
})($8f7fe33a44836803$export$614f97abc1364581 || ($8f7fe33a44836803$export$614f97abc1364581 = {}));
var $8f7fe33a44836803$export$9ccd8bf0fc9737f6;
(function(UpdateFileSystemType) {
    UpdateFileSystemType["CreateDir"] = "CREATE_DIR";
    UpdateFileSystemType["CreateFile"] = "CREATE_FILE";
    UpdateFileSystemType["RemoveDir"] = "REMOVE_DIR";
    UpdateFileSystemType["RemoveFile"] = "REMOVE_FILE";
    UpdateFileSystemType["Rename"] = "RENAME";
})($8f7fe33a44836803$export$9ccd8bf0fc9737f6 || ($8f7fe33a44836803$export$9ccd8bf0fc9737f6 = {}));



const $33beb5b1bfae180c$var$defaultOptions = {};
const $33beb5b1bfae180c$export$7c8784612ed2318d = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateUserProfilePhoto($updateUserInformationInput: UpdateUserInformationInput!) {
  updateUserProfilePhoto(updateUserInformationInput: $updateUserInformationInput) {
    userId
    profilePhoto
  }
}
    `;
function $33beb5b1bfae180c$export$d289fa9f4c70490b(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$7c8784612ed2318d, options);
}
const $33beb5b1bfae180c$export$e399317ca90432ea = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateCustomDomain($createCustomDomainsInput: CreateCustomDomainsInput!) {
  createCustomDomains(createCustomDomainsInput: $createCustomDomainsInput) {
    id
    name
    firmAccountId
  }
}
    `;
function $33beb5b1bfae180c$export$b0186010bb4cc701(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$e399317ca90432ea, options);
}
const $33beb5b1bfae180c$export$73fd88fcbe133442 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation RemoveCustomDomain($id: String!) {
  removeCustomDomain(id: $id) {
    id
    name
  }
}
    `;
function $33beb5b1bfae180c$export$9692eef04d6c9776(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$73fd88fcbe133442, options);
}
const $33beb5b1bfae180c$export$adc290b25e9df7d3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateCustomLayout($createCustomLayoutInput: CreateCustomLayoutInput!) {
  createCustomLayout(createCustomLayoutInput: $createCustomLayoutInput) {
    id
    firmAccountId
    headerBackgroundColor
    headerFontColor
  }
}
    `;
function $33beb5b1bfae180c$export$7b9fe9a07323d7a9(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$adc290b25e9df7d3, options);
}
const $33beb5b1bfae180c$export$4111f7fe6257f75b = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateCustomLayout($updateCustomLayoutInput: UpdateCustomLayoutInput!) {
  updateCustomLayout(updateCustomLayoutInput: $updateCustomLayoutInput) {
    id
    firmAccountId
    headerBackgroundColor
    headerFontColor
  }
}
    `;
function $33beb5b1bfae180c$export$4b25a5e514b06217(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$4111f7fe6257f75b, options);
}
const $33beb5b1bfae180c$export$af246ff6cda88a77 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation updateUser($updateUserInput: UpdateUserInput!) {
  updateUser(updateUserInput: $updateUserInput) {
    id
    email
    languageId
  }
}
    `;
function $33beb5b1bfae180c$export$d51a7f6b32955917(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$af246ff6cda88a77, options);
}
const $33beb5b1bfae180c$export$d17216cd090cbe06 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateUserInformation($updateUserInformationInput: UpdateUserInformationInput!) {
  UpdateUserInformation(updateUserInformationInput: $updateUserInformationInput) {
    id
  }
}
    `;
function $33beb5b1bfae180c$export$e3e115fc54c52e18(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$d17216cd090cbe06, options);
}
const $33beb5b1bfae180c$export$8c4a18ea9a0689bd = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateFirmUniqueLink($updateFirmAccountInput: UpdateFirmAccountInput!) {
  updateFirmUniqueLink(updateFirmAccountInput: $updateFirmAccountInput) {
    id
    uniqueLink
  }
}
    `;
function $33beb5b1bfae180c$export$bafa3df68c8afd6d(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$8c4a18ea9a0689bd, options);
}
const $33beb5b1bfae180c$export$d8051ec7132000a0 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateUserUniqueLink($updateUserInput: UpdateUserInput!) {
  updateUserUniqueLink(updateUserInput: $updateUserInput) {
    id
    uniqueLink
  }
}
    `;
function $33beb5b1bfae180c$export$72dac375941973c9(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$d8051ec7132000a0, options);
}
const $33beb5b1bfae180c$export$990d7dc8fc1e9d5b = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateRandomUserUniqueLink($updateUserInput: UpdateUserInput!) {
  updateRandomUserUniqueLink(updateUserInput: $updateUserInput) {
    id
    uniqueLink
  }
}
    `;
function $33beb5b1bfae180c$export$9eaab3b1fb7a3ab4(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$990d7dc8fc1e9d5b, options);
}
const $33beb5b1bfae180c$export$9d8d84a43682e86e = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateSubscription($createStripeSubscriptionInput: CreateStripeSubscriptionInput!) {
  createSubscription(
    createStripeSubscriptionInput: $createStripeSubscriptionInput
  ) {
    id
  }
}
    `;
function $33beb5b1bfae180c$export$cad47f76ff30cf27(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$9d8d84a43682e86e, options);
}
const $33beb5b1bfae180c$export$1814728d7d9c7f93 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateProgressStatuses($createProgressStatusesInput: CreateProgressStatusesInput!) {
  createProgressStatuses(
    createProgressStatusesInput: $createProgressStatusesInput
  ) {
    id
    firmAccountId
    index
  }
}
    `;
function $33beb5b1bfae180c$export$677cd2e5fbceed8f(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$1814728d7d9c7f93, options);
}
const $33beb5b1bfae180c$export$a8d8775545744b1d = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateProgressStatus($updateProgressStatusInput: UpdateProgressStatusesInput!) {
  updateProgressStatus(updateProgressStatusInput: $updateProgressStatusInput) {
    id
    firmAccountId
    status
    underlyingStatus
    index
  }
}
    `;
function $33beb5b1bfae180c$export$d71ddcc0c0996419(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$a8d8775545744b1d, options);
}
const $33beb5b1bfae180c$export$f414b5ef0d6ff85e = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation SwitchOrderOfProgressStatuses($switchOrderOfProgressStatusesInput: SwitchOrderOfProgressStatusesInput!) {
  switchOrderOfProgressStatuses(
    switchOrderOfProgressStatusesInput: $switchOrderOfProgressStatusesInput
  )
}
    `;
function $33beb5b1bfae180c$export$bc017c666357fa36(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$f414b5ef0d6ff85e, options);
}
const $33beb5b1bfae180c$export$1e2d37dedddabf1c = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation RemoveProgressStatuses($id: String!) {
  removeProgressStatuses(id: $id) {
    id
    firmAccountId
    status
    underlyingStatus
    index
  }
}
    `;
function $33beb5b1bfae180c$export$1ddc74f362951435(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$1e2d37dedddabf1c, options);
}
const $33beb5b1bfae180c$export$51987b94c8b40da5 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateUserFirmAccount($createUserFirmAccountInput: CreateUserFirmAccountInput!) {
  createUserFirmAccount(createUserFirmAccountInput: $createUserFirmAccountInput) {
    id
    userId
    roleId
    firmAccountId
    createAt
    updateAt
  }
}
    `;
function $33beb5b1bfae180c$export$575baf9842d6cbba(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$51987b94c8b40da5, options);
}
const $33beb5b1bfae180c$export$d52799f8d251f484 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query CanAddMemberToFirm($firmAccountId: String!) {
  canAddMemberToFirm(firmAccountId: $firmAccountId) {
    success
  }
}
    `;
function $33beb5b1bfae180c$export$9c309a2fa08bb584(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($33beb5b1bfae180c$export$d52799f8d251f484, options);
}
function $33beb5b1bfae180c$export$80cc0b112578fdd6(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($33beb5b1bfae180c$export$d52799f8d251f484, options);
}
const $33beb5b1bfae180c$export$6787ba88b07f49b6 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation AddMemberToFirm($firmAccountId: String!, $memberAddInput: MemberAddInput!) {
  addMemberToFirm(firmAccountId: $firmAccountId, memberAddInput: $memberAddInput) {
    id
    roleId
    firmAccountId
    Users {
      id
      email
      UserInformation {
        id
        firstName
        lastName
      }
    }
    Roles {
      id
      description
    }
  }
}
    `;
function $33beb5b1bfae180c$export$4cbc8f1dda0b22be(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$6787ba88b07f49b6, options);
}
const $33beb5b1bfae180c$export$4d6e0abb142d8193 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateMemberRole($firmAccountId: String!, $userId: String!, $newRoleId: String!, $newEmail: String!) {
  updateMemberRole(
    firmAccountId: $firmAccountId
    userId: $userId
    newRoleId: $newRoleId
    newEmail: $newEmail
  ) {
    id
    roleId
    firmAccountId
    Users {
      id
      email
      UserInformation {
        id
        firstName
        lastName
      }
    }
    Roles {
      id
      description
    }
  }
}
    `;
function $33beb5b1bfae180c$export$91f6062913294367(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$4d6e0abb142d8193, options);
}
const $33beb5b1bfae180c$export$ac78b22ee8e3d64d = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation DeleteTeamMember($firmAccountId: String!, $userId: String!) {
  deleteTeamMember(firmAccountId: $firmAccountId, userId: $userId) {
    id
  }
}
    `;
function $33beb5b1bfae180c$export$83db09edaf672ed7(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$ac78b22ee8e3d64d, options);
}
const $33beb5b1bfae180c$export$3bcbc01ff0e0644f = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation ReactivateTeamMember($firmAccountId: String!, $userId: String!) {
  reactivateTeamMember(firmAccountId: $firmAccountId, userId: $userId) {
    id
  }
}
    `;
function $33beb5b1bfae180c$export$135f21ea45aea87f(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$3bcbc01ff0e0644f, options);
}
const $33beb5b1bfae180c$export$1b66e3dc3c8e512f = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation ValidateOTP($validateOtp: ValidateOtpInput!) {
  validateOTP(validateOtp: $validateOtp) {
    secretOTP
  }
}
    `;
function $33beb5b1bfae180c$export$9e48322a06db8fe9(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$1b66e3dc3c8e512f, options);
}
const $33beb5b1bfae180c$export$f09f0287eea17f31 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation DeleteTwoStepAuthFromUser($validateOtp: ValidateOtpInput!) {
  deleteTwoStepAuthFromUser(validateOtp: $validateOtp) {
    success
  }
}
    `;
function $33beb5b1bfae180c$export$b9f15128ac3e36a0(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$f09f0287eea17f31, options);
}
const $33beb5b1bfae180c$export$d4e78bb9e68438f5 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateFirmAccount($updateFirmAccountInput: UpdateFirmAccountInput!) {
  updateFirmAccount(updateFirmAccountInput: $updateFirmAccountInput) {
    id
    name
    type
    businessType
    uniqueLink
    createAt
    updateAt
    deleteAt
  }
}
    `;
function $33beb5b1bfae180c$export$3651467deb80cf0(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$d4e78bb9e68438f5, options);
}
const $33beb5b1bfae180c$export$466c15bd17aa3370 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateBusinessInformation($createBusinessInformationInput: CreateBusinessInformationInput!) {
  createBusinessInformation(
    createBusinessInformationInput: $createBusinessInformationInput
  ) {
    id
    taxReturns
    yearsInBusiness
    taxPercent
    accountingPercent
    bookKeepingPercent
    taxResolutionPercent
    payrollPercent
    other
    firmAccountId
  }
}
    `;
function $33beb5b1bfae180c$export$da7467fe254a46d8(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$466c15bd17aa3370, options);
}
const $33beb5b1bfae180c$export$6227bb0d87a5b779 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateBusinessInformation($updateBusinessInformationInput: UpdateBusinessInformationInput!) {
  updateBusinessInformation(
    updateBusinessInformationInput: $updateBusinessInformationInput
  ) {
    id
    taxReturns
    yearsInBusiness
    taxPercent
    accountingPercent
    bookKeepingPercent
    taxResolutionPercent
    payrollPercent
    other
    firmAccountId
  }
}
    `;
function $33beb5b1bfae180c$export$28256303d1a07fbc(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$6227bb0d87a5b779, options);
}
const $33beb5b1bfae180c$export$2e551014d23a1585 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation RemoveBusinessInformation($id: String!) {
  removeBusinessInformation(id: $id) {
    id
    taxReturns
    yearsInBusiness
    taxPercent
    accountingPercent
    bookKeepingPercent
    payrollPercent
    taxResolutionPercent
    other
    firmAccountId
  }
}
    `;
function $33beb5b1bfae180c$export$9ffbbb21aab6135e(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$2e551014d23a1585, options);
}
const $33beb5b1bfae180c$export$903f519c6e97e0ce = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateFirmNotifications($updateFirmNotificationsStatusInput: UpdateFirmNotificationsStatusInput!) {
  updateFirmNotificationsStatus(
    updateFirmNotificationsStatusInput: $updateFirmNotificationsStatusInput
  ) {
    id
    firmAccountId
    notificationId
    active
    Notifications {
      name
    }
  }
}
    `;
function $33beb5b1bfae180c$export$7fd593d2e3e2fa1c(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$903f519c6e97e0ce, options);
}
const $33beb5b1bfae180c$export$f583b9b5c387d6e3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateFirmNotificationReminder($createFirmNotificationReminderInput: CreateFirmNotificationReminderInput!) {
  createFirmNotificationReminder(
    createFirmNotificationReminderInput: $createFirmNotificationReminderInput
  ) {
    id
    firmNotificationId
    frequency
    maxReminders
  }
}
    `;
function $33beb5b1bfae180c$export$b2eab14b2da19b5f(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$f583b9b5c387d6e3, options);
}
const $33beb5b1bfae180c$export$fb6b98754e37025b = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateFirmNotificationReminder($updateFirmNotificationReminderInput: UpdateFirmNotificationReminderInput!) {
  updateFirmNotificationReminderWithFirmNotificationId(
    updateFirmNotificationReminderInput: $updateFirmNotificationReminderInput
  ) {
    id
    firmNotificationId
    frequency
    maxReminders
  }
}
    `;
function $33beb5b1bfae180c$export$4c20fcf201489f71(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$fb6b98754e37025b, options);
}
const $33beb5b1bfae180c$export$24eb1cc2f35265b1 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation RemoveFirmNotificationReminder($id: String!) {
  removeFirmNotificationReminder(id: $id) {
    id
    firmNotificationId
    frequency
    maxReminders
  }
}
    `;
function $33beb5b1bfae180c$export$aacbfa8f3fc4b975(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$24eb1cc2f35265b1, options);
}
const $33beb5b1bfae180c$export$1278eca418d142c4 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdatePixels($updateCustomLayoutInput: UpdateCustomLayoutInput!) {
  updatePixels(updateCustomLayoutInput: $updateCustomLayoutInput) {
    id
    pixelCode
  }
}
    `;
function $33beb5b1bfae180c$export$bae89db0f7715647(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$1278eca418d142c4, options);
}
const $33beb5b1bfae180c$export$1c98d3a78bcc9d47 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateClient($createClientInput: CreateClientInput!) {
  CreateClient(createClientInput: $createClientInput) {
    id
    email
  }
}
    `;
function $33beb5b1bfae180c$export$92443fba6b952152(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$1c98d3a78bcc9d47, options);
}
const $33beb5b1bfae180c$export$28f4bcb85d6443b1 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation SearchUnassignedClients($searchClientInput: SearchClientInput!) {
  SearchUnassigned(searchClientInput: $searchClientInput) {
    firmAccountId
    entityId
    Entity {
      Users {
        email
        id
        UserInformation {
          id
          firstName
          lastName
        }
      }
      TaxYear {
        year
        TaxYearInterview {
          id
          updateAt
          PreparedUser {
            id
            email
            UserInformation {
              firstName
              lastName
            }
          }
          ReviewedUser {
            id
            email
            UserInformation {
              firstName
              lastName
            }
          }
          Interviews {
            id
            name
          }
        }
      }
    }
  }
}
    `;
function $33beb5b1bfae180c$export$5faf96274f58b437(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$28f4bcb85d6443b1, options);
}
const $33beb5b1bfae180c$export$68f1384278b331fd = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation SearchInProgressClients($searchClientInput: SearchClientInput!) {
  SearchInProgress(searchClientInput: $searchClientInput) {
    firmAccountId
    entityId
    Entity {
      Users {
        id
        email
        UserInformation {
          id
          firstName
          lastName
        }
        email
      }
      TaxYear {
        id
        year
        TaxYearInterview {
          id
          updateAt
          ReviewedUser {
            id
            email
            UserInformation {
              firstName
              lastName
            }
          }
          PreparedUser {
            id
            email
            UserInformation {
              firstName
              lastName
            }
          }
          Interviews {
            id
            name
          }
        }
      }
    }
  }
}
    `;
function $33beb5b1bfae180c$export$617795466e48295d(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$68f1384278b331fd, options);
}
const $33beb5b1bfae180c$export$6ff4f068da76e38 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation SearchCompletedClients($searchClientInput: SearchClientInput!) {
  SearchCompleted(searchClientInput: $searchClientInput) {
    firmAccountId
    entityId
    Entity {
      Users {
        id
        email
        UserInformation {
          id
          firstName
          lastName
        }
        email
      }
      TaxYear {
        year
        TaxYearInterview {
          id
          updateAt
          Interviews {
            id
            name
          }
          ReviewedUser {
            id
            email
            UserInformation {
              firstName
              lastName
            }
          }
          PreparedUser {
            id
            email
            UserInformation {
              firstName
              lastName
            }
          }
        }
      }
    }
  }
}
    `;
function $33beb5b1bfae180c$export$38615b7bd9db7566(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$6ff4f068da76e38, options);
}
const $33beb5b1bfae180c$export$9196c8a3dd8c05da = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateTaxYearInterview($createTaxYearInterviewInput: CreateTaxYearInterviewInput!) {
  createTaxYearInterview(
    createTaxYearInterviewInput: $createTaxYearInterviewInput
  ) {
    id
    progressStatusId
    assignedAt
    createAt
    updateAt
    preparedId
    reviewedId
  }
}
    `;
function $33beb5b1bfae180c$export$63c811bdabe027b3(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$9196c8a3dd8c05da, options);
}
const $33beb5b1bfae180c$export$b37943c328bd6a45 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateTaxYearInterview($updateTaxYearInterviewInput: UpdateTaxYearInterviewInput!) {
  updateTaxYearInterview(
    updateTaxYearInterviewInput: $updateTaxYearInterviewInput
  ) {
    id
    taxYearId
    preparedId
    reviewedId
    interviewId
    progressStatusId
    notes
    reviewStatus
    createAt
    updateAt
    completedAt
    assignedAt
    PreparedUser {
      id
      email
      UserInformation {
        id
        userId
        userId
        birthday
        firstName
        lastName
        createAt
        updateAt
      }
    }
    ReviewedUser {
      id
      email
      UserInformation {
        id
        userId
        userId
        birthday
        firstName
        lastName
        createAt
        updateAt
      }
    }
    TaxYear {
      id
      entityId
      year
      createAt
      Entity {
        id
        ownerId
        Users {
          id
          email
          createAt
          languageId
          updateAt
          UserInformation {
            id
            userId
            birthday
            firstName
            lastName
            createAt
            updateAt
          }
        }
      }
    }
    Interviews {
      id
      name
      isLive
      createAt
      updateAt
      isTemplate
      firmAccountId
    }
    ProgressStatuses {
      id
      status
      underlyingStatus
      index
    }
  }
}
    `;
function $33beb5b1bfae180c$export$5ef9f018471fce4(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$b37943c328bd6a45, options);
}
const $33beb5b1bfae180c$export$a9c6b38a92a7b768 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation DeleteTaxYearInterview($id: String!) {
  DeleteJob(id: $id) {
    id
    taxYearId
    preparedId
    reviewedId
    interviewId
    progressStatusId
    notes
    assignedAt
    completedAt
    preparerAcceptedAt
    reviewStatus
    createAt
    updateAt
    deletedAt
  }
}
    `;
function $33beb5b1bfae180c$export$92ffc46af4628615(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$a9c6b38a92a7b768, options);
}
const $33beb5b1bfae180c$export$5e6e13723857cb6b = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation AssignTaxYearInterview($input: UpdateTaxYearInterviewInput!) {
  AssignTaxYearInterviewJob(updateTaxYearInterviewInput: $input) {
    id
    preparedId
    reviewedId
    progressStatusId
  }
}
    `;
function $33beb5b1bfae180c$export$232e68358ba46ee7(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$5e6e13723857cb6b, options);
}
const $33beb5b1bfae180c$export$6f48abcb4b9123f8 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateSubscription($updateStripeSubscriptionInput: UpdateStripeSubscriptionInput!, $finishTrial: Boolean, $resume: Boolean) {
  updateStripeSubscription(
    updateStripSubscriptionInput: $updateStripeSubscriptionInput
    finishTrial: $finishTrial
    resume: $resume
  ) {
    id
    object
    created
    ended_at
    customer
    livemode
    cancel_at
    canceled_at
    days_until_due
    default_source
    current_period_end
    current_period_start
    billing_cycle_anchor
    cancel_at_period_end
    default_payment_method
    application_fee_percent
    items {
      object
      data {
        id
        object
        created
        billing_thresholds {
          usage_gte
        }
        plan {
          id
          object
          active
          amount
          created
          currency
          interval
          livemode
          tiers_mode
          amount_decimal
          billing_scheme
          interval_count
          trial_period_days
          tiers {
            flat_amount
            flat_amount_decimal
            unit_amount
            unit_amount_decimal
            up_to
          }
        }
      }
    }
    metadata {
      plan_name
    }
    status
    quantity
    schedule
    trial_end
    start_date
    trial_start
    pending_setup_intent
    next_pending_invoice_item_invoice
  }
}
    `;
function $33beb5b1bfae180c$export$2533d517ac4b0c7f(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$6f48abcb4b9123f8, options);
}
const $33beb5b1bfae180c$export$66138998bd08da24 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation ResumeSubscription($subscriptionId: String!) {
  ResumeSubscription(subscriptionId: $subscriptionId) {
    id
    current_period_end
    current_period_start
    billing_cycle_anchor
    pause_collection {
      behavior
      resumes_at
    }
  }
}
    `;
function $33beb5b1bfae180c$export$2df4a6161cee6627(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$66138998bd08da24, options);
}
const $33beb5b1bfae180c$export$301b4f45d2206ae = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation SubscribeToPlan($createStripeSubscriptionInput: CreateStripeSubscriptionInput!) {
  createSubscription(
    createStripeSubscriptionInput: $createStripeSubscriptionInput
  ) {
    id
  }
}
    `;
function $33beb5b1bfae180c$export$b34d387d8a069da5(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$301b4f45d2206ae, options);
}
const $33beb5b1bfae180c$export$8a264e8b2d967883 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation DeleteSubscription($subscriptionId: String!, $deleteStripeSubscriptionInput: DeleteStripeSubscriptionInput) {
  deleteSubscription(
    subscriptionId: $subscriptionId
    deleteStripeSubscriptionInput: $deleteStripeSubscriptionInput
  ) {
    id
  }
}
    `;
function $33beb5b1bfae180c$export$9c57662aa631e6ad(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$8a264e8b2d967883, options);
}
const $33beb5b1bfae180c$export$756fbbb2ff6684bf = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateJobNotes($id: String!, $notes: String!) {
  UpdateJobNotes(id: $id, notes: $notes) {
    id
    notes
  }
}
    `;
function $33beb5b1bfae180c$export$6e786766956d6d68(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$756fbbb2ff6684bf, options);
}
const $33beb5b1bfae180c$export$d07e7f72fd84036f = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation GetSiteBrandingLogoPresignedURL($mimeType: String!) {
  GetSiteBrandingLogoPresignedURL(mimeType: $mimeType)
}
    `;
function $33beb5b1bfae180c$export$9036669b8d399532(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$d07e7f72fd84036f, options);
}
const $33beb5b1bfae180c$export$90298d12e049fd8a = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation GetUserProfilePhotoPresignedURL($updateUserInformationInput: UpdateUserInformationInput!) {
  GetUserProfilePhotoPresignedURL(
    updateUserInformationInput: $updateUserInformationInput
  )
}
    `;
function $33beb5b1bfae180c$export$3ecc2dddf1160880(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$90298d12e049fd8a, options);
}
const $33beb5b1bfae180c$export$f615a753564cb485 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CustomDomainResendEmails {
  CustomDomainResendEmails
}
    `;
function $33beb5b1bfae180c$export$f4a6b05e46e5a550(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$f615a753564cb485, options);
}
const $33beb5b1bfae180c$export$8157a0d5dba150ef = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation GetOnBoardingLink($returnUrl: String!) {
  GetOnBoardingLink(returnUrl: $returnUrl)
}
    `;
function $33beb5b1bfae180c$export$87788bf64b1c5271(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$8157a0d5dba150ef, options);
}
const $33beb5b1bfae180c$export$b96250fc360a3716 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation deleteNylasAccount($accountId: String!) {
  deleteNylasAccount(accountId: $accountId)
}
    `;
function $33beb5b1bfae180c$export$a4b187477edbbc50(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$b96250fc360a3716, options);
}
const $33beb5b1bfae180c$export$10d96fb3667fbd1f = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation getNylasAuthUrl($input: CreateNylasAuthDtoInput!) {
  getNylasAuthUrl(createNylasAuthDtoInput: $input) {
    url
  }
}
    `;
function $33beb5b1bfae180c$export$13885e468d73c1ee(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$10d96fb3667fbd1f, options);
}
const $33beb5b1bfae180c$export$3e195025eba55c6d = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation handleNylasAuthCallback($input: CreateNylasAuthorizeDtoInput!) {
  handleNylasAuthCallback(createNylasAuthorizeDtoInput: $input) {
    accountId
    provider
    syncState
    emailAddress
    accessToken
  }
}
    `;
function $33beb5b1bfae180c$export$8c193a78072ec72a(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$3e195025eba55c6d, options);
}
const $33beb5b1bfae180c$export$db8debb79772f14d = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation createFirmSetting($name: String!, $value: String!) {
  createFirmSetting(name: $name, value: $value) {
    id
    name
    description
    type
    category
    value {
      ... on BooleanValue {
        boolValue
      }
      ... on NumberValue {
        numValue
      }
      ... on DateValue {
        dateValue
      }
      ... on StringValue {
        strValue
      }
    }
  }
}
    `;
function $33beb5b1bfae180c$export$1ff58c91a8b6e9e1(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$db8debb79772f14d, options);
}
const $33beb5b1bfae180c$export$ff071da030526a98 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation updateFirmSetting($id: String!, $value: String!) {
  updateFirmSetting(id: $id, value: $value) {
    id
    name
    description
    type
    category
    value {
      ... on BooleanValue {
        boolValue
      }
      ... on NumberValue {
        numValue
      }
      ... on DateValue {
        dateValue
      }
      ... on StringValue {
        strValue
      }
    }
  }
}
    `;
function $33beb5b1bfae180c$export$1a4761718d2c597b(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$ff071da030526a98, options);
}
const $33beb5b1bfae180c$export$30dea2259dca5b53 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation RecoverDeletedClient($userFirmAccountId: String!) {
  RecoverDeletedClient(userFirmAccountId: $userFirmAccountId)
}
    `;
function $33beb5b1bfae180c$export$59e1ce8f5f054594(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$30dea2259dca5b53, options);
}
const $33beb5b1bfae180c$export$45ee257acad1dfea = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation disconnectExternalCalendar($externalCalendarId: String!) {
  disconnectExternalCalendar(externalCalendarId: $externalCalendarId) {
    id
  }
}
    `;
function $33beb5b1bfae180c$export$db8c30ad7ae8d2af(baseOptions) {
    const options = {
        ...$33beb5b1bfae180c$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($33beb5b1bfae180c$export$45ee257acad1dfea, options);
}
const $33beb5b1bfae180c$export$39ac829ab91f0716 = {
    Query: {
        CanAddMemberToFirm: 'CanAddMemberToFirm'
    },
    Mutation: {
        UpdateUserProfilePhoto: 'UpdateUserProfilePhoto',
        CreateCustomDomain: 'CreateCustomDomain',
        RemoveCustomDomain: 'RemoveCustomDomain',
        CreateCustomLayout: 'CreateCustomLayout',
        UpdateCustomLayout: 'UpdateCustomLayout',
        updateUser: 'updateUser',
        UpdateUserInformation: 'UpdateUserInformation',
        UpdateFirmUniqueLink: 'UpdateFirmUniqueLink',
        UpdateUserUniqueLink: 'UpdateUserUniqueLink',
        UpdateRandomUserUniqueLink: 'UpdateRandomUserUniqueLink',
        CreateSubscription: 'CreateSubscription',
        CreateProgressStatuses: 'CreateProgressStatuses',
        UpdateProgressStatus: 'UpdateProgressStatus',
        SwitchOrderOfProgressStatuses: 'SwitchOrderOfProgressStatuses',
        RemoveProgressStatuses: 'RemoveProgressStatuses',
        CreateUserFirmAccount: 'CreateUserFirmAccount',
        AddMemberToFirm: 'AddMemberToFirm',
        UpdateMemberRole: 'UpdateMemberRole',
        DeleteTeamMember: 'DeleteTeamMember',
        ReactivateTeamMember: 'ReactivateTeamMember',
        ValidateOTP: 'ValidateOTP',
        DeleteTwoStepAuthFromUser: 'DeleteTwoStepAuthFromUser',
        UpdateFirmAccount: 'UpdateFirmAccount',
        CreateBusinessInformation: 'CreateBusinessInformation',
        UpdateBusinessInformation: 'UpdateBusinessInformation',
        RemoveBusinessInformation: 'RemoveBusinessInformation',
        UpdateFirmNotifications: 'UpdateFirmNotifications',
        CreateFirmNotificationReminder: 'CreateFirmNotificationReminder',
        UpdateFirmNotificationReminder: 'UpdateFirmNotificationReminder',
        RemoveFirmNotificationReminder: 'RemoveFirmNotificationReminder',
        UpdatePixels: 'UpdatePixels',
        CreateClient: 'CreateClient',
        SearchUnassignedClients: 'SearchUnassignedClients',
        SearchInProgressClients: 'SearchInProgressClients',
        SearchCompletedClients: 'SearchCompletedClients',
        CreateTaxYearInterview: 'CreateTaxYearInterview',
        UpdateTaxYearInterview: 'UpdateTaxYearInterview',
        DeleteTaxYearInterview: 'DeleteTaxYearInterview',
        AssignTaxYearInterview: 'AssignTaxYearInterview',
        UpdateSubscription: 'UpdateSubscription',
        ResumeSubscription: 'ResumeSubscription',
        SubscribeToPlan: 'SubscribeToPlan',
        DeleteSubscription: 'DeleteSubscription',
        UpdateJobNotes: 'UpdateJobNotes',
        GetSiteBrandingLogoPresignedURL: 'GetSiteBrandingLogoPresignedURL',
        GetUserProfilePhotoPresignedURL: 'GetUserProfilePhotoPresignedURL',
        CustomDomainResendEmails: 'CustomDomainResendEmails',
        GetOnBoardingLink: 'GetOnBoardingLink',
        deleteNylasAccount: 'deleteNylasAccount',
        getNylasAuthUrl: 'getNylasAuthUrl',
        handleNylasAuthCallback: 'handleNylasAuthCallback',
        createFirmSetting: 'createFirmSetting',
        updateFirmSetting: 'updateFirmSetting',
        RecoverDeletedClient: 'RecoverDeletedClient',
        disconnectExternalCalendar: 'disconnectExternalCalendar'
    }
};



var $bb3TF = parcelRequire("bb3TF");


const $774cc9a1c383b6aa$var$defaultOptions = {};
const $774cc9a1c383b6aa$export$2b8b3cc3a909d741 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment ConditionalsEntity on ConditionalEntity {
  id
  createAt
  optionId
  sectionId
  picture
  hintText
  Options {
    id
    Questions {
      id
      order
      required
      tag
      Translations {
        id
        description
        languageId
        Language {
          lang
        }
      }
      Options {
        id
        Translations {
          id
          description
          languageId
          Language {
            lang
          }
        }
      }
    }
    Translations {
      id
      description
      Language {
        lang
      }
    }
  }
  Section {
    order
    id
  }
}
    `;
const $774cc9a1c383b6aa$export$76186b6862d16840 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment LanguageEntity on LanguagesEntity {
  id
  lang
  description
}
    `;
const $774cc9a1c383b6aa$export$64b643f683b3f80e = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment TranslationEntity on TranslationEntity {
  id
  description
  optionId
  questionId
  languageId
  sectionId
  createAt
  updateAt
  deleteAt
  Language {
    ...LanguageEntity
  }
}
    ${$774cc9a1c383b6aa$export$76186b6862d16840}`;
const $774cc9a1c383b6aa$export$dba4ddf19bd6fc25 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment QuestionsEntity on QuestionEntity {
  id
  sectionId
  type
  order
  required
  forwardable
  createAt
  updateAt
  deleteAt
  Translations {
    ...TranslationEntity
  }
}
    ${$774cc9a1c383b6aa$export$64b643f683b3f80e}`;
const $774cc9a1c383b6aa$export$35fbd33d8065346e = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment OptionsEntity on OptionsEntity {
  id
  questionId
  createAt
  updateAt
  deleteAt
  Translations {
    ...TranslationEntity
  }
}
    ${$774cc9a1c383b6aa$export$64b643f683b3f80e}`;
const $774cc9a1c383b6aa$export$e736e2f724f2256d = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment SectionEntity on SectionEntity {
  id
  parentId
  interviewId
  order
  createAt
  updateAt
  isSpecial
  deleteAt
  Conditionals {
    ...ConditionalsEntity
  }
  Questions {
    ...QuestionsEntity
    Options {
      ...OptionsEntity
    }
  }
  Translations {
    ...TranslationEntity
  }
}
    ${$774cc9a1c383b6aa$export$2b8b3cc3a909d741}
${$774cc9a1c383b6aa$export$dba4ddf19bd6fc25}
${$774cc9a1c383b6aa$export$35fbd33d8065346e}
${$774cc9a1c383b6aa$export$64b643f683b3f80e}`;
const $774cc9a1c383b6aa$export$833749530f15953b = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment Sections on SectionEntity {
  ...SectionEntity
  SubSections {
    ...SectionEntity
    SubSections {
      ...SectionEntity
      SubSections {
        ...SectionEntity
      }
    }
  }
}
    ${$774cc9a1c383b6aa$export$e736e2f724f2256d}`;
const $774cc9a1c383b6aa$export$fdc639303f0be8ef = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetInterviewById($id: String!) {
  interview(id: $id) {
    id
    name
    isLive
    createAt
    updateAt
    isTemplate
    firmAccountId
    Sections {
      ...Sections
    }
  }
}
    ${$774cc9a1c383b6aa$export$833749530f15953b}`;
function $774cc9a1c383b6aa$export$c596362a99823524(baseOptions) {
    const options = {
        ...$774cc9a1c383b6aa$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($774cc9a1c383b6aa$export$fdc639303f0be8ef, options);
}
function $774cc9a1c383b6aa$export$ccb3623d5ceb2c34(baseOptions) {
    const options = {
        ...$774cc9a1c383b6aa$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($774cc9a1c383b6aa$export$fdc639303f0be8ef, options);
}
const $774cc9a1c383b6aa$export$d14102da6256181a = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetInterviewNames($filterLiveInterviews: Boolean) {
  interviewNames(filterLiveInterviews: $filterLiveInterviews) {
    id
    name
    isLive
    createAt
    updateAt
    isTemplate
    firmAccountId
  }
}
    `;
function $774cc9a1c383b6aa$export$194d4356b994f52(baseOptions) {
    const options = {
        ...$774cc9a1c383b6aa$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($774cc9a1c383b6aa$export$d14102da6256181a, options);
}
function $774cc9a1c383b6aa$export$2d8ec82bd3e5a3ff(baseOptions) {
    const options = {
        ...$774cc9a1c383b6aa$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($774cc9a1c383b6aa$export$d14102da6256181a, options);
}
const $774cc9a1c383b6aa$export$39ac829ab91f0716 = {
    Query: {
        GetInterviewById: 'GetInterviewById',
        GetInterviewNames: 'GetInterviewNames'
    },
    Fragment: {
        LanguageEntity: 'LanguageEntity',
        TranslationEntity: 'TranslationEntity',
        OptionsEntity: 'OptionsEntity',
        QuestionsEntity: 'QuestionsEntity',
        ConditionalsEntity: 'ConditionalsEntity',
        SectionEntity: 'SectionEntity',
        Sections: 'Sections'
    }
};



const { Option: $89a92f440564d95a$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const $89a92f440564d95a$var$SelectJobType = (SelectComponentProps)=>{
    const { accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    // Get interviews query
    const { data: jobTypes, loading: loadingGetInterviews } = (0, $774cc9a1c383b6aa$export$194d4356b994f52)();
    return (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
        disabled: loadingGetInterviews,
        placeholder: "Select job type",
        allowClear: true,
        ...SelectComponentProps,
        children: jobTypes?.interviewNames?.map((item)=>{
            // if user doesn't have access to entity interviews, only show an individual interview
            let availableInterviewId;
            if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).entityInterviews]) availableInterviewId = jobTypes?.interviewNames?.filter((i)=>i?.name?.toLowerCase().includes('individual'))[0]?.id || jobTypes?.interviewNames?.[0]?.id;
            return (0, $bb3TF.jsx)($89a92f440564d95a$var$Option, {
                value: item.id,
                disabled: availableInterviewId && item.id !== availableInterviewId,
                children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                    visible: !(availableInterviewId && item.id !== availableInterviewId) ? false : undefined,
                    title: "These job types are only available on Pro Plan",
                    placement: "bottomLeft",
                    children: (0, $bb3TF.jsx)("span", {
                        style: {
                            width: '100%',
                            display: 'block'
                        },
                        children: item.name
                    })
                })
            }, item.id);
        })
    });
};
var $89a92f440564d95a$export$2e2bcd8739ae039 = $89a92f440564d95a$var$SelectJobType;


var $64531df0cb0d41a9$exports = {};

$parcel$export($64531df0cb0d41a9$exports, "add-client-form", function () { return $64531df0cb0d41a9$export$66b41115c560ff0a; }, function (v) { return $64531df0cb0d41a9$export$66b41115c560ff0a = v; });
$parcel$export($64531df0cb0d41a9$exports, "ant-btn", function () { return $64531df0cb0d41a9$export$3d24f79f59ee945a; }, function (v) { return $64531df0cb0d41a9$export$3d24f79f59ee945a = v; });
$parcel$export($64531df0cb0d41a9$exports, "job-type-select", function () { return $64531df0cb0d41a9$export$3a42acd00165cd84; }, function (v) { return $64531df0cb0d41a9$export$3a42acd00165cd84 = v; });
$parcel$export($64531df0cb0d41a9$exports, "progress-status-select", function () { return $64531df0cb0d41a9$export$103e9882c268aaf1; }, function (v) { return $64531df0cb0d41a9$export$103e9882c268aaf1 = v; });
$parcel$export($64531df0cb0d41a9$exports, "tax-year-select", function () { return $64531df0cb0d41a9$export$4404bb98ec13baa9; }, function (v) { return $64531df0cb0d41a9$export$4404bb98ec13baa9 = v; });
var $64531df0cb0d41a9$export$66b41115c560ff0a;
var $64531df0cb0d41a9$export$3d24f79f59ee945a;
var $64531df0cb0d41a9$export$3a42acd00165cd84;
var $64531df0cb0d41a9$export$103e9882c268aaf1;
var $64531df0cb0d41a9$export$4404bb98ec13baa9;
$64531df0cb0d41a9$export$66b41115c560ff0a = `UPq9bW_add-client-form`;
$64531df0cb0d41a9$export$3d24f79f59ee945a = `UPq9bW_ant-btn`;
$64531df0cb0d41a9$export$3a42acd00165cd84 = `UPq9bW_job-type-select`;
$64531df0cb0d41a9$export$103e9882c268aaf1 = `UPq9bW_progress-status-select`;
$64531df0cb0d41a9$export$4404bb98ec13baa9 = `UPq9bW_tax-year-select`;


const { Item: $2d52d8d286e39b3a$var$Item } = (0, $6ee812964d9db826$export$2e2bcd8739ae039);
const { InfoCircleOutlined: $2d52d8d286e39b3a$var$InfoCircleOutlined, UserAddOutlined: $2d52d8d286e39b3a$var$UserAddOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Option: $2d52d8d286e39b3a$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
// fill tax year list
const $2d52d8d286e39b3a$var$currentYear = new Date().getFullYear();
const $2d52d8d286e39b3a$var$taxYears = [
    ($2d52d8d286e39b3a$var$currentYear - 1).toString(),
    $2d52d8d286e39b3a$var$currentYear.toString()
];
for(let year = $2d52d8d286e39b3a$var$currentYear - 2; year > $2d52d8d286e39b3a$var$currentYear - 10; year -= 1)$2d52d8d286e39b3a$var$taxYears.push(year.toString());
const $2d52d8d286e39b3a$var$defaultProps = {};
const $2d52d8d286e39b3a$var$AddClientModal = ({ isModalVisible: isModalVisible, setIsModalVisible: setIsModalVisible })=>{
    const { progressStatuses: progressStatuses } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const unassignedStatus = progressStatuses.find((status)=>status.underlyingStatus === (0, $8f7fe33a44836803$export$f493388d2527ca1f).Unassigned);
    // Create client mutation
    const [createClientMutation, { loading: loading }] = (0, $33beb5b1bfae180c$export$92443fba6b952152)({
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Client added successfully');
            setIsModalVisible(false);
        },
        onError: (error)=>{
            if (error.message === 'Error code 1002') (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('This email address is being used by another user of our platform. Please use another email address in order to add a new client. If you need further assistance, please contact customer support.');
            else if (error.message === 'Error code 2001') (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Your tax firm is not currently active. Please contact your admin.');
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        },
        refetchQueries: [
            'GetClientsByProgressStatusId',
            'GetClients'
        ]
    });
    // Assign preparer mutation
    // const [updateTaxYearInterviewMutation] = useUpdateTaxYearInterviewMutation({
    //   onCompleted: () => {
    //     message.success('Preparer assigned successfully');
    //   },
    //   onError: (error) => message.info(error.message),
    // });
    const validationSchema = $ee6ba11cc5736d52$export$185802fd694ee1f5().shape({
        firstName: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('First name is required'),
        lastName: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('Last name is required'),
        birthday: $b2e6c69aab0808b6$export$185802fd694ee1f5().optional().nullable(),
        email: $2746dd37f1d91ea1$export$185802fd694ee1f5().email('Please enter a valid email').nullable(),
        phone: $2746dd37f1d91ea1$export$185802fd694ee1f5().optional().nullable(),
        taxYear: $4b40952b17040dfe$export$185802fd694ee1f5().required('Tax year is required'),
        interviewId: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('Job type is required'),
        progressStatusId: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('Progress status is required'),
        sendActivationEmail: $fb77e000a80648d3$export$185802fd694ee1f5().default(false)
    });
    const formik = (0, $ipnkk.useFormik)({
        initialValues: {
            firstName: '',
            lastName: '',
            birthday: undefined,
            email: '',
            phone: '',
            taxYear: '',
            interviewId: '',
            progressStatusId: unassignedStatus.id,
            sendActivationEmail: false
        },
        validationSchema: validationSchema,
        onSubmit: async (values)=>{
            const { firstName: firstName, lastName: lastName, birthday: birthday, email: email, phone: phone, taxYear: taxYear, interviewId: interviewId, progressStatusId: progressStatusId, sendActivationEmail: sendActivationEmail } = values;
            const res = await createClientMutation({
                variables: {
                    createClientInput: {
                        taxYear: +taxYear,
                        email: email || undefined,
                        interviewId: interviewId,
                        progressStatusId: progressStatusId,
                        sendActivationEmail: sendActivationEmail,
                        UserInformation: {
                            firstName: firstName,
                            lastName: lastName,
                            birthday: birthday?.format('YYYY-MM-DD'),
                            Phones: phone ? [
                                {
                                    type: (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Mobile,
                                    value: phone
                                }
                            ] : undefined
                        }
                    }
                }
            });
            if (res?.data) formik.resetForm();
        }
    });
    const handleCancel = ()=>{
        setIsModalVisible(false);
        formik.resetForm();
    };
    // todo: assign preparer to new client
    // Assign preparer to new client
    // useEffect(() => {
    //   if (newClient.taxYearId) {
    //     const assignPreparer = async () => {
    //       await updateTaxYearInterviewMutation({
    //         variables: {
    //           updateTaxYearInterviewInput: {
    //             id: newClient.id,
    //             taxYearId: newClient.taxYearId,
    //             preparedId: newClient.preparedId,
    //             interviewId: newClient.interviewId,
    //             status: newClient.status,
    //             assignedAt: newClient.assignedAt,
    //           },
    //         },
    //       });
    //     };
    //     assignPreparer();
    //   }
    // }, [newClient.taxYearId]);
    return (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        title: "Add Client",
        visible: isModalVisible,
        okButtonProps: {
            icon: (0, $bb3TF.jsx)($2d52d8d286e39b3a$var$UserAddOutlined, {})
        },
        okText: "Add Client",
        onCancel: handleCancel,
        onOk: ()=>formik.submitForm(),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($64531df0cb0d41a9$exports))).addClientForm,
        centered: true,
        style: {
            top: '15px'
        },
        confirmLoading: loading,
        destroyOnClose: true,
        children: (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
            style: {
                width: '100%'
            },
            layout: "vertical",
            name: "basic",
            children: [
                (0, $bb3TF.jsxs)($2d52d8d286e39b3a$var$Item, {
                    name: "firstName",
                    label: "First Name",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: [
                        (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                            disabled: loading,
                            placeholder: "Taxpayer First Name",
                            value: formik.values.firstName,
                            onChange: formik.handleChange('firstName')
                        }),
                        formik.touched.firstName && formik.errors.firstName && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            message: formik.errors.firstName,
                            type: "error"
                        })
                    ]
                }),
                (0, $bb3TF.jsxs)($2d52d8d286e39b3a$var$Item, {
                    name: "lastName",
                    label: "Last Name",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: [
                        (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                            disabled: loading,
                            placeholder: "Taxpayer Last Name",
                            value: formik.values.lastName,
                            onChange: formik.handleChange('lastName')
                        }),
                        formik.touched.lastName && formik.errors.lastName && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            message: formik.errors.lastName,
                            type: "error"
                        })
                    ]
                }),
                (0, $bb3TF.jsxs)($2d52d8d286e39b3a$var$Item, {
                    name: "birthday",
                    label: "Date of Birth",
                    children: [
                        (0, $bb3TF.jsx)((0, $dd1293f125eb7a8a$export$2e2bcd8739ae039), {
                            disabled: loading,
                            value: formik.values.birthday,
                            onChange: (value)=>{
                                formik.setFieldValue('birthday', value);
                            },
                            placeholder: "MM/DD/YYYY",
                            format: "MM/DD/YYYY",
                            style: {
                                width: '100%'
                            }
                        }),
                        formik.touched.birthday && formik.errors.birthday && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            message: formik.errors.birthday,
                            type: "error"
                        })
                    ]
                }),
                (0, $bb3TF.jsxs)($2d52d8d286e39b3a$var$Item, {
                    name: "email",
                    label: "Email",
                    rules: [
                        {
                            required: false,
                            type: 'email'
                        }
                    ],
                    children: [
                        (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                            disabled: loading,
                            placeholder: "Taxpayer Email",
                            value: formik.values.email,
                            onChange: formik.handleChange('email')
                        }),
                        formik.touched.email && formik.errors.email && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            message: formik.errors.email,
                            type: "error"
                        })
                    ]
                }),
                (0, $bb3TF.jsxs)($2d52d8d286e39b3a$var$Item, {
                    name: "phone",
                    label: "Phone Number",
                    rules: [
                        {
                            required: false
                        }
                    ],
                    children: [
                        (0, $bb3TF.jsx)((0, $5ba7d8eeafddcf67$export$2e2bcd8739ae039), {
                            onChange: (value)=>formik.setFieldValue('phone', value)
                        }),
                        formik.touched.phone && formik.errors.phone && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            message: formik.errors.phone,
                            type: "error"
                        })
                    ]
                }),
                (0, $bb3TF.jsxs)($2d52d8d286e39b3a$var$Item, {
                    name: "taxYear",
                    label: "Tax Year",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: [
                        (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($64531df0cb0d41a9$exports))).taxYearSelect,
                            disabled: loading,
                            placeholder: "Select tax year",
                            onChange: formik.handleChange('taxYear'),
                            value: formik.values.taxYear,
                            allowClear: true,
                            children: $2d52d8d286e39b3a$var$taxYears.map((item)=>(0, $bb3TF.jsx)($2d52d8d286e39b3a$var$Option, {
                                    value: item,
                                    children: item
                                }, item))
                        }),
                        formik.touched.taxYear && formik.errors.taxYear && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            message: formik.errors.taxYear,
                            type: "error"
                        })
                    ]
                }),
                (0, $bb3TF.jsxs)($2d52d8d286e39b3a$var$Item, {
                    name: "jobType",
                    label: "Job Type",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: [
                        (0, $bb3TF.jsx)((0, $89a92f440564d95a$export$2e2bcd8739ae039), {
                            onChange: formik.handleChange('interviewId'),
                            value: formik.values.interviewId
                        }),
                        formik.touched.interviewId && formik.errors.interviewId && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            message: formik.errors.interviewId,
                            type: "error"
                        })
                    ]
                }),
                (0, $bb3TF.jsxs)($2d52d8d286e39b3a$var$Item, {
                    name: "progressStatusId",
                    label: "Progress Status",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: [
                        (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($64531df0cb0d41a9$exports))).progressStatusSelect,
                            disabled: loading,
                            placeholder: "Select progress status",
                            onChange: formik.handleChange('progressStatusId'),
                            value: formik.values.progressStatusId,
                            allowClear: true,
                            children: progressStatuses.map((item)=>(0, $bb3TF.jsx)($2d52d8d286e39b3a$var$Option, {
                                    value: item.id,
                                    children: item.status
                                }, item.id))
                        }),
                        formik.touched.interviewId && formik.errors.interviewId && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            message: formik.errors.interviewId,
                            type: "error"
                        })
                    ]
                }),
                (0, $bb3TF.jsx)($2d52d8d286e39b3a$var$Item, {
                    name: "sendActivationEmail",
                    children: (0, $bb3TF.jsxs)((0, $66ef76fa6be8ca1a$export$2e2bcd8739ae039), {
                        disabled: loading,
                        value: formik.values.sendActivationEmail,
                        checked: formik.values.sendActivationEmail,
                        onChange: (event)=>{
                            formik.setFieldValue('sendActivationEmail', event.target.checked);
                        },
                        children: [
                            "Send email to request to ask client to complete on-boarding interview",
                            ' ',
                            (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                title: "We will send an email on your behalf to request that the client provide their detailed tax situation.",
                                children: (0, $bb3TF.jsx)($2d52d8d286e39b3a$var$InfoCircleOutlined, {
                                    style: {
                                        fontSize: '14px'
                                    }
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
$2d52d8d286e39b3a$var$AddClientModal.defaultProps = $2d52d8d286e39b3a$var$defaultProps;
var $2d52d8d286e39b3a$export$2e2bcd8739ae039 = $2d52d8d286e39b3a$var$AddClientModal;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


const $cfa9a099fb6315ad$var$defaultOptions = {};
const $cfa9a099fb6315ad$export$3c4839ff61ed69e3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation ValidateClientsImport($clientsArray: [ValidateClientFromFileInput!]!) {
  ValidateClientsImport(validateClientsArray: $clientsArray) {
    address1
    address2
    dob
    city
    email
    firstName
    lastName
    phones {
      type
      value
    }
    ssn
    state
    zip
    isUpdate
    updatedFields
    preparer
    jobType
    taxYear
  }
}
    `;
function $cfa9a099fb6315ad$export$b907fa095e71ccbd(baseOptions) {
    const options = {
        ...$cfa9a099fb6315ad$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($cfa9a099fb6315ad$export$3c4839ff61ed69e3, options);
}
const $cfa9a099fb6315ad$export$9a1e20ca86bc5086 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation ImportClientsFromFile($clientsArray: [ClientsImportInput!]!) {
  ImportClientsFromFile(importClientsFromFile: $clientsArray)
}
    `;
function $cfa9a099fb6315ad$export$c890badf4112c089(baseOptions) {
    const options = {
        ...$cfa9a099fb6315ad$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($cfa9a099fb6315ad$export$9a1e20ca86bc5086, options);
}
const $cfa9a099fb6315ad$export$39ac829ab91f0716 = {
    Mutation: {
        ValidateClientsImport: 'ValidateClientsImport',
        ImportClientsFromFile: 'ImportClientsFromFile'
    }
};



const $732264f53056e08f$var$defaultOptions = {};
const $732264f53056e08f$export$e6c178ccf6cad632 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment StripeMetaData on StripeMetadataEntity {
  plan_name
  taxaroo_plus
  has_roo_access
  custom_plan
}
    `;
const $732264f53056e08f$export$2cef3b0515ac7227 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment Invoices on InvoicesEntity {
  id
  quantity
  createAt
  updateAt
  priceEach
  paymentId
  description
}
    `;
const $732264f53056e08f$export$2f85e61f9f51040 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment Payments on PaymentsEntity {
  id
  taskId
  createAt
  updateAt
  entityId
  requestAt
  deletedAt
  promisedAt
  completedAt
  paidOffline
  referralFee
  preparerFee
  firmAccountId
  discountApplied
  totalDollarAmount
  taxYearInterviewId
  paymentProcessorId
  Invoices {
    ...Invoices
  }
}
    ${$732264f53056e08f$export$2cef3b0515ac7227}`;
const $732264f53056e08f$export$4bec383ab2e8e649 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment SignatureField on SignatureFieldEntity {
  id
  page
  fieldId
  createAt
  updateAt
  fieldType
  signatureId
  signerParty
  fieldTopPercentage
  fieldLeftPercentage
  fieldWidthPercentage
  fieldHeightPercentage
}
    `;
const $732264f53056e08f$export$b849c048710e8061 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment Signature on SignatureEntity {
  id
  fileId
  createAt
  updateAt
  fileRequestId
  SignatureFields {
    ...SignatureField
  }
}
    ${$732264f53056e08f$export$4bec383ab2e8e649}`;
const $732264f53056e08f$export$963cf237a259149a = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment File on FileEntity {
  id
  name
  size
  s3Key
  pages
  folder
  userId
  createAt
  updateAt
  deleteAt
  uploadedBy
  documentUsed
  firmAccountId
  taxYearInterviewId
  Signatures {
    ...Signature
  }
}
    ${$732264f53056e08f$export$b849c048710e8061}`;
const $732264f53056e08f$export$df78d3a4fb902208 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment KBAFields on KBAFieldEntity {
  id
  type
  value
  KBAId
  createAt
  updateAt
  description
}
    `;
const $732264f53056e08f$export$533537972aa45789 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment KBA on KbaEntity {
  id
  type
  createAt
  updateAt
  isValidated
  fileApprovalId
  isIdScanPassed
  isIdScanPending
  numKbaAttempts
  numFailedIdScans
  numKbaFailedAttempts
  numRequestedIdScans
  KBAFields {
    ...KBAFields
  }
}
    ${$732264f53056e08f$export$df78d3a4fb902208}`;
const $732264f53056e08f$export$e9ab528b46d26b3a = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment FileApproval on FileApprovalEntity {
  id
  expiresAt
  completedAt
  fileRequestId
  email
  name
  kbaEnable
  createAt
  updateAt
  KBA {
    ...KBA
  }
}
    ${$732264f53056e08f$export$533537972aa45789}`;
const $732264f53056e08f$export$7648b622bdf8bd99 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment FileRequest on FileRequestEntity {
  id
  title
  notes
  userId
  taskId
  clientId
  createAt
  updateAt
  compiledHash
  signedFileId
  firmAccountId
  compiledFileId
  signatureRequest
  signatureComplete
  taxYearInterviewId
  Signatures {
    ...Signature
  }
  CompiledFile {
    ...File
  }
  SignedFile {
    ...File
  }
  FileApprovals {
    ...FileApproval
  }
}
    ${$732264f53056e08f$export$b849c048710e8061}
${$732264f53056e08f$export$963cf237a259149a}
${$732264f53056e08f$export$e9ab528b46d26b3a}`;
const $732264f53056e08f$export$76186b6862d16840 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment LanguageEntity on LanguagesEntity {
  id
  lang
  description
}
    `;
const $732264f53056e08f$export$32cb2efefdbfb24c = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment ClientsByStatus on TaxYearInterviewEntity {
  id
  notes
  progressStatusId
  createAt
  updateAt
  taxYearId
  preparedId
  reviewedId
  assignedAt
  interviewId
  completedAt
  reviewStatus
  progressStatusId
  JobTracking {
    id
    expectedCompletion
    paymentsCompletedAt
    approvalsCompletedAt
    interviewCompletedAt
    filesCompletedAt
  }
  Tasks {
    id
    taskType
    createAt
    updateAt
    taxYearId
    deletedAt
    completedAt
  }
  PreparedUser {
    id
    email
    UserInformation {
      id
      userId
      birthday
      createAt
      lastName
      updateAt
      firstName
    }
  }
  ReviewedUser {
    id
    email
    UserInformation {
      id
      userId
      birthday
      lastName
      createAt
      updateAt
      firstName
    }
  }
  TaxYear {
    id
    year
    entityId
    createAt
    Entity {
      id
      ownerId
      Users {
        id
        email
        createAt
        updateAt
        languageId
        invitationEmailSent
        hasPassword
        UserInformation {
          id
          userId
          birthday
          firstName
          lastName
          createAt
          updateAt
          Phones {
            id
            type
            value
            createAt
            updateAt
          }
        }
        ReferredByUser {
          id
          email
          createAt
          updateAt
          languageId
          UserInformation {
            firstName
            lastName
          }
        }
      }
    }
  }
  Interviews {
    id
    name
    isLive
    createAt
    updateAt
    isTemplate
    firmAccountId
  }
}
    `;
const $732264f53056e08f$export$4b2f97b8ce17ee4 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetCustomDomainUser {
  CustomDomainUser {
    id
    name
    certificateArn
    cloudfrontIdId
    status
    firmAccountId
  }
}
    `;
function $732264f53056e08f$export$bd03447e34c3ce51(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$4b2f97b8ce17ee4, options);
}
function $732264f53056e08f$export$63604b178c82014f(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$4b2f97b8ce17ee4, options);
}
const $732264f53056e08f$export$dd9c433f4d2ef93a = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query CustomDomainCertificateStatus {
  CustomDomainCertificateStatus {
    id
    Status
    FailureReason
    DomainValidationOptions {
      name
      type
      value
    }
  }
}
    `;
function $732264f53056e08f$export$3bd4de5bdc32cc16(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$dd9c433f4d2ef93a, options);
}
function $732264f53056e08f$export$b1a758a27418fc73(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$dd9c433f4d2ef93a, options);
}
const $732264f53056e08f$export$af20b181305628ec = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query CustomDomainCnameStatus {
  CustomDomainCnameStatus {
    hostname
    cnameStatus
    distribution {
      Id
      ARN
      Status
      DomainName
      Aliases {
        Items
        Quantity
      }
    }
  }
}
    `;
function $732264f53056e08f$export$7b5a2dc6e467f451(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$af20b181305628ec, options);
}
function $732264f53056e08f$export$4a1ba03041072c39(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$af20b181305628ec, options);
}
const $732264f53056e08f$export$755aad1710b5857c = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query IsDomainLive($url: String!) {
  IsDomainLive(url: $url)
}
    `;
function $732264f53056e08f$export$45a0043ce976ac16(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$755aad1710b5857c, options);
}
function $732264f53056e08f$export$1a0c8fbd0bcd031a(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$755aad1710b5857c, options);
}
const $732264f53056e08f$export$7abb6f713f781dcc = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetCloudFrontDistributionByCertificateArn {
  GetCloudFrontDistributionByCertificateArn {
    Id
    ARN
    Status
    DomainName
    Aliases {
      Items
      Quantity
    }
  }
}
    `;
function $732264f53056e08f$export$f20a576d40a9b29(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$7abb6f713f781dcc, options);
}
function $732264f53056e08f$export$80af994bdcfe1f6f(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$7abb6f713f781dcc, options);
}
const $732264f53056e08f$export$dd6355313f82125f = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetCustomLayouts {
  CustomLayout {
    id
    firmAccountId
    headerBackgroundColor
    headerFontColor
    logo
    pixelCode
  }
}
    `;
function $732264f53056e08f$export$a9d926e7a1510ac6(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$dd6355313f82125f, options);
}
function $732264f53056e08f$export$713360ee854deaf2(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$dd6355313f82125f, options);
}
const $732264f53056e08f$export$73c49c0d19880aef = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetUserInformation($id: String!) {
  UserInformation(id: $id) {
    firstName
    lastName
    birthday
    ssn
    Address {
      id
      lineOne
      lineTwo
      city
      state
      type
      zip
    }
    Phones {
      id
      value
      type
    }
  }
}
    `;
function $732264f53056e08f$export$e58c984431e9a06d(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$73c49c0d19880aef, options);
}
function $732264f53056e08f$export$7fabdfe686dc652b(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$73c49c0d19880aef, options);
}
const $732264f53056e08f$export$4b048446150838fb = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetSubscription {
  GetSubscriptionByContext {
    id
    object
    application_fee_percent
    billing_cycle_anchor
    cancel_at
    cancel_at_period_end
    canceled_at
    created
    current_period_end
    current_period_start
    customer
    days_until_due
    default_payment_method
    default_source
    ended_at
    livemode
    items {
      object
      data {
        id
        object
        billing_thresholds {
          usage_gte
        }
        created
        plan {
          id
          object
          active
          amount
          amount_decimal
          billing_scheme
          created
          currency
          interval
          interval_count
          livemode
          tiers_mode
          trial_period_days
          product
          tiers {
            flat_amount
            flat_amount_decimal
            unit_amount
            unit_amount_decimal
            up_to
          }
          metadata {
            ...StripeMetaData
          }
        }
      }
    }
    metadata {
      ...StripeMetaData
    }
    next_pending_invoice_item_invoice
    pending_setup_intent
    schedule
    start_date
    status
    trial_end
    trial_start
    quantity
    pause_collection {
      behavior
      resumes_at
    }
  }
}
    ${$732264f53056e08f$export$e6c178ccf6cad632}`;
function $732264f53056e08f$export$a95e19dd5dcb47c4(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$4b048446150838fb, options);
}
function $732264f53056e08f$export$d95ebb456eb9533e(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$4b048446150838fb, options);
}
const $732264f53056e08f$export$7b4fd575d789f5ba = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetAllPlans {
  GetAllPlans {
    id
    active
    amount
    amount_decimal
    created
    currency
    interval
    interval_count
    livemode
    nickname
    tiers {
      flat_amount
      flat_amount_decimal
      unit_amount
      unit_amount_decimal
      up_to
    }
    metadata {
      ...StripeMetaData
    }
    product
    tiers_mode
    trial_period_days
  }
}
    ${$732264f53056e08f$export$e6c178ccf6cad632}`;
function $732264f53056e08f$export$c94d211362c21bbe(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$7b4fd575d789f5ba, options);
}
function $732264f53056e08f$export$119a02c7f292c53d(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$7b4fd575d789f5ba, options);
}
const $732264f53056e08f$export$4d607e19b9c22294 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetPlansByProductId($productId: String!) {
  GetPlansByProductId(productId: $productId) {
    id
    active
    amount
    amount_decimal
    created
    currency
    interval
    interval_count
    livemode
    nickname
    tiers {
      flat_amount
      flat_amount_decimal
      unit_amount
      unit_amount_decimal
      up_to
    }
    metadata {
      ...StripeMetaData
    }
    product
    tiers_mode
    billing_scheme
    trial_period_days
  }
}
    ${$732264f53056e08f$export$e6c178ccf6cad632}`;
function $732264f53056e08f$export$ccde32c2079eadfe(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$4d607e19b9c22294, options);
}
function $732264f53056e08f$export$21b262cc434c4e93(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$4d607e19b9c22294, options);
}
const $732264f53056e08f$export$2cdb675b802e06d6 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetPlan($planId: String!) {
  GetPlan(planId: $planId) {
    id
    currency
    interval
    tiers_mode
    product
  }
}
    `;
function $732264f53056e08f$export$b73421782150fa0f(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$2cdb675b802e06d6, options);
}
function $732264f53056e08f$export$aa6093dcbaa7ee10(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$2cdb675b802e06d6, options);
}
const $732264f53056e08f$export$cd6fb1839b461eb3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetUserUniqueLink($id: String!) {
  UserById(id: $id) {
    id
    uniqueLink
  }
}
    `;
function $732264f53056e08f$export$67e1b8b3789d08d(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$cd6fb1839b461eb3, options);
}
function $732264f53056e08f$export$76f2e5d1774cc453(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$cd6fb1839b461eb3, options);
}
const $732264f53056e08f$export$36883e83eb872d84 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetFirmUniqueLink($id: String!) {
  FirmAccountById(id: $id) {
    id
    uniqueLink
  }
}
    `;
function $732264f53056e08f$export$9f81c3500d5c21a0(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$36883e83eb872d84, options);
}
function $732264f53056e08f$export$58d228ac17214a7(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$36883e83eb872d84, options);
}
const $732264f53056e08f$export$b7a996941feacd9b = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetProgressStatuses {
  ProgressStatuses {
    id
    firmAccountId
    status
    underlyingStatus
    index
  }
}
    `;
function $732264f53056e08f$export$9ca2f42b9d2b732f(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$b7a996941feacd9b, options);
}
function $732264f53056e08f$export$9be91a4edb631f1f(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$b7a996941feacd9b, options);
}
const $732264f53056e08f$export$51a49c6527224f09 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetUserFirmAccountByFirmAccount($firmAccountId: String!) {
  UserFirmAccountByFirmAccount(firmAccountId: $firmAccountId) {
    id
    userId
    roleId
    firmAccountId
  }
}
    `;
function $732264f53056e08f$export$58592bb33d20f978(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$51a49c6527224f09, options);
}
function $732264f53056e08f$export$22ecd4721378dfb0(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$51a49c6527224f09, options);
}
const $732264f53056e08f$export$ddb8ce619ab577fa = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetUserById($id: String!) {
  UserById(id: $id) {
    id
    email
    uniqueLink
    UserInformation {
      firstName
      lastName
      Phones {
        id
        value
        type
        createAt
        updateAt
      }
      Address {
        id
        lineOne
        lineTwo
        city
        state
        type
        zip
        createAt
        updateAt
      }
    }
    Entity {
      id
    }
  }
}
    `;
function $732264f53056e08f$export$4898529a154e0804(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$ddb8ce619ab577fa, options);
}
function $732264f53056e08f$export$48678b7a86b520eb(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$ddb8ce619ab577fa, options);
}
const $732264f53056e08f$export$b62111fff37cc3e3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetRoles {
  Roles {
    id
    description
  }
}
    `;
function $732264f53056e08f$export$df99cc263e9b1304(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$b62111fff37cc3e3, options);
}
function $732264f53056e08f$export$9f273cfe25c4302a(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$b62111fff37cc3e3, options);
}
const $732264f53056e08f$export$7e72633a492e9933 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetUserFirmAccountByFirmAccountAndFilter($firmAccountId: String!, $filterDelete: Boolean!) {
  UserFirmAccountByFirmAccountAndFilter(
    firmAccountId: $firmAccountId
    filterDelete: $filterDelete
  ) {
    id
    roleId
    firmAccountId
    Users {
      id
      email
      deleteAt
      UserInformation {
        id
        firstName
        lastName
      }
    }
    Roles {
      id
      description
    }
  }
}
    `;
function $732264f53056e08f$export$deb804dbb627e21(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$7e72633a492e9933, options);
}
function $732264f53056e08f$export$2b919d7608f1447d(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$7e72633a492e9933, options);
}
const $732264f53056e08f$export$23db7cfb835248b6 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GenerateOTP {
  generateOTP {
    codeQR
    key
  }
}
    `;
function $732264f53056e08f$export$4926b8950ca37617(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$23db7cfb835248b6, options);
}
function $732264f53056e08f$export$b7a2b4240d22924d(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$23db7cfb835248b6, options);
}
const $732264f53056e08f$export$d420e92451a25d95 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query FirmAccountById($id: String!) {
  FirmAccountById(id: $id) {
    id
    name
    type
    businessType
    uniqueLink
    createAt
    updateAt
    deleteAt
  }
}
    `;
function $732264f53056e08f$export$54402da0a9e269fe(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$d420e92451a25d95, options);
}
function $732264f53056e08f$export$4498dc09c0d532d7(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$d420e92451a25d95, options);
}
const $732264f53056e08f$export$fde7a102bea6da56 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetBusinessInformation {
  BusinessInformation {
    id
    taxReturns
    yearsInBusiness
    taxPercent
    accountingPercent
    bookKeepingPercent
    payrollPercent
    taxResolutionPercent
    other
    firmAccountId
    Phones {
      id
      value
      userInformationId
      businessInformationId
      createAt
      updateAt
      type
    }
    Address {
      id
      lineOne
      lineTwo
      city
      state
      type
      zip
      userInformationId
      businessInformationId
      createAt
      updateAt
    }
    FirmAccount {
      id
      name
      type
      businessType
      uniqueLink
      createAt
      updateAt
      deleteAt
    }
  }
}
    `;
function $732264f53056e08f$export$c65bb1005cf74961(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$fde7a102bea6da56, options);
}
function $732264f53056e08f$export$b5406b52f6a95f21(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$fde7a102bea6da56, options);
}
const $732264f53056e08f$export$2f920ec7f11a1ff5 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetFirmNotifications {
  getFirmNotifications {
    TEAM {
      id
      firmAccountId
      notificationId
      active
      Notifications {
        name
        description
        type
      }
    }
    CLIENT {
      id
      firmAccountId
      notificationId
      active
      Notifications {
        name
        description
        type
      }
    }
    REMINDERS {
      id
      firmAccountId
      notificationId
      active
      Notifications {
        name
        description
        type
      }
      FirmNotificationReminder {
        id
        frequency
        maxReminders
      }
    }
  }
}
    `;
function $732264f53056e08f$export$1c0bc3e3ba440b3(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$2f920ec7f11a1ff5, options);
}
function $732264f53056e08f$export$1d676d2e44b2137c(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$2f920ec7f11a1ff5, options);
}
const $732264f53056e08f$export$a3bc4d02ba9c53fe = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetClients($skip: Float, $take: Float, $searchTerm: String, $orderBy: UserFirmAccountOrderByInput, $filter: ClientsFilterInput) {
  Clients(
    skip: $skip
    take: $take
    searchTerm: $searchTerm
    orderBy: $orderBy
    filter: $filter
  ) {
    pagination {
      total
    }
    data {
      Entity {
        id
        ownerId
        Users {
          id
          email
          languageId
          invitationEmailSent
          hasPassword
          UserInformation {
            id
            userId
            firstName
            lastName
            birthday
            notes
            Phones {
              id
              createAt
              updateAt
              userInformationId
              value
              type
            }
            Address {
              id
            }
          }
          ReferredByUser {
            email
            UserInformation {
              firstName
              lastName
            }
          }
        }
        TaxYear {
          id
          year
          createAt
          TaxYearInterview {
            id
            taxYearId
            preparedId
            reviewedId
            progressStatusId
            notes
            assignedAt
            completedAt
            reviewStatus
            preparerAcceptedAt
            createAt
            updateAt
            JobTracking {
              id
              expectedCompletion
              paymentsCompletedAt
              approvalsCompletedAt
              interviewCompletedAt
              filesCompletedAt
            }
            Tasks {
              id
              taskType
              createAt
              updateAt
              taxYearId
              deletedAt
              completedAt
            }
            PreparedUser {
              id
              email
              UserInformation {
                id
                userId
                birthday
                firstName
                lastName
                createAt
                updateAt
              }
            }
            ReviewedUser {
              id
              email
              UserInformation {
                id
                userId
                birthday
                firstName
                lastName
                createAt
                updateAt
              }
            }
            Interviews {
              id
              firmAccountId
              name
              isTemplate
              isLive
              drakePackage
              createAt
              updateAt
            }
          }
        }
      }
    }
  }
}
    `;
function $732264f53056e08f$export$a7142e44db2eb9b2(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$a3bc4d02ba9c53fe, options);
}
function $732264f53056e08f$export$3a19f57bf28782b1(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$a3bc4d02ba9c53fe, options);
}
const $732264f53056e08f$export$42a70e6e2bf435ce = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetDeletedClients($skip: Float, $take: Float, $orderBy: UserFirmAccountOrderByInput) {
  DeletedClients(skip: $skip, take: $take, orderBy: $orderBy) {
    pagination {
      total
    }
    data {
      deleteAt
      id
      Entity {
        id
        ownerId
        Users {
          id
          email
          UserInformation {
            id
            userId
            firstName
            lastName
            Phones {
              id
              value
              type
            }
          }
        }
        TaxYear {
          id
          year
          TaxYearInterview {
            id
            taxYearId
            Interviews {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
function $732264f53056e08f$export$52d48459b23922cf(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$42a70e6e2bf435ce, options);
}
function $732264f53056e08f$export$f495b24d594a709e(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$42a70e6e2bf435ce, options);
}
const $732264f53056e08f$export$d4e23f314f782a9d = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetClientsByProgressStatusId($progressStatusId: String!, $skip: Float, $take: Float, $searchTerm: String, $orderBy: TaxYearInterviewOrderByInput, $filter: ClientsFilterInput) {
  ClientsByTaxYearStatus(
    progressStatusId: $progressStatusId
    skip: $skip
    take: $take
    searchTerm: $searchTerm
    orderBy: $orderBy
    filter: $filter
  ) {
    data {
      ...ClientsByStatus
    }
    pagination {
      total
    }
  }
}
    ${$732264f53056e08f$export$32cb2efefdbfb24c}`;
function $732264f53056e08f$export$a2975d7a4f6b5e8e(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$d4e23f314f782a9d, options);
}
function $732264f53056e08f$export$79c9fe0a74fad20c(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$d4e23f314f782a9d, options);
}
const $732264f53056e08f$export$4e88a0f959694e05 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetOTPBoolean {
  GetOTPBoolean {
    success
    apiToken
  }
}
    `;
function $732264f53056e08f$export$b38c1895a2435d0b(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$4e88a0f959694e05, options);
}
function $732264f53056e08f$export$bc09ac90e67d6eba(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$4e88a0f959694e05, options);
}
const $732264f53056e08f$export$6ba3fa77a474aebb = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query CustomDomainUser {
  CustomDomainUser {
    id
    name
    certificateArn
    cloudfrontIdId
    status
    firmAccountId
  }
}
    `;
function $732264f53056e08f$export$65d51915dfd746a3(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$6ba3fa77a474aebb, options);
}
function $732264f53056e08f$export$da45a886c2afe94b(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$6ba3fa77a474aebb, options);
}
const $732264f53056e08f$export$419c67a2e3799658 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query CurrentStripeInformation {
  CurrentStripeInformation {
    id
    customerId
    subscriptionId
    firmAccountId
    plan
    connectAccountId
    finishedOnboarding
  }
}
    `;
function $732264f53056e08f$export$9f382c5aef9c5d4d(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$419c67a2e3799658, options);
}
function $732264f53056e08f$export$61cedb99ed846a2(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$419c67a2e3799658, options);
}
const $732264f53056e08f$export$8d51fa8c18366a60 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetInvoices {
  GetInvoices {
    id
    created
    number
    amountDue
    paid
    pdf
  }
}
    `;
function $732264f53056e08f$export$905913c79271a8d7(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$8d51fa8c18366a60, options);
}
function $732264f53056e08f$export$ac04f6c96b3cd9a1(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$8d51fa8c18366a60, options);
}
const $732264f53056e08f$export$d825d68f68526af1 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetPaymentIntents {
  GetPaymentIntents {
    id
    created
    amount
    amount_capturable
    amount_received
    receipt_email
    description
    refunds {
      id
      amount
      created
      status
    }
  }
}
    `;
function $732264f53056e08f$export$371e4b62be8521fe(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$d825d68f68526af1, options);
}
function $732264f53056e08f$export$3917bb1cb75bdd1(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$d825d68f68526af1, options);
}
const $732264f53056e08f$export$b0be6d048cf40a4d = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetUpcomingInvoice {
  GetUpcomingInvoice {
    created
    number
    amountDue
    discount
    startingBalance
    endingBalance
    nextPayment
    periodStart
    periodEnd
  }
}
    `;
function $732264f53056e08f$export$4c8ebb826cda8431(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$b0be6d048cf40a4d, options);
}
function $732264f53056e08f$export$347ab43eff268822(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$b0be6d048cf40a4d, options);
}
const $732264f53056e08f$export$958be556361890bd = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query getNylasAccounts {
  getNylasAccounts {
    accountId
    provider
    syncState
    emailAddress
    accessToken
  }
}
    `;
function $732264f53056e08f$export$d2979795b392e396(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$958be556361890bd, options);
}
function $732264f53056e08f$export$82d2c16dac29affc(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$958be556361890bd, options);
}
const $732264f53056e08f$export$f2a29e4b806003b9 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query isActiveFirm {
  isActiveFirm
}
    `;
function $732264f53056e08f$export$a4138ee1626213b6(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$f2a29e4b806003b9, options);
}
function $732264f53056e08f$export$1c2f59eb0a7cf2cc(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$f2a29e4b806003b9, options);
}
const $732264f53056e08f$export$d16c1a94a02eda7f = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query getFirmSettings($category: String!) {
  getFirmSettings(category: $category) {
    id
    name
    description
    type
    category
    value {
      ... on BooleanValue {
        boolValue
      }
      ... on NumberValue {
        numValue
      }
      ... on DateValue {
        dateValue
      }
      ... on StringValue {
        strValue
      }
    }
  }
}
    `;
function $732264f53056e08f$export$9fced88514778fe9(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$d16c1a94a02eda7f, options);
}
function $732264f53056e08f$export$b2546ad20d25f182(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$d16c1a94a02eda7f, options);
}
const $732264f53056e08f$export$d3d4606815f9ce8e = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query getClientsBasicInfo {
  getClientsBasicInfo {
    id
    Entity {
      id
      Users {
        id
        email
        UserInformation {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;
function $732264f53056e08f$export$e12e433ec87b87e7(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$d3d4606815f9ce8e, options);
}
function $732264f53056e08f$export$e4abb010403a6148(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$d3d4606815f9ce8e, options);
}
const $732264f53056e08f$export$d44bacce7a2eea3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query getFirmSetting($name: String!) {
  getFirmSetting(name: $name) {
    id
    name
    description
    type
    category
    value {
      ... on BooleanValue {
        boolValue
      }
      ... on NumberValue {
        numValue
      }
      ... on DateValue {
        dateValue
      }
      ... on StringValue {
        strValue
      }
    }
  }
}
    `;
function $732264f53056e08f$export$1757fc42814f776a(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$d44bacce7a2eea3, options);
}
function $732264f53056e08f$export$91faa2de5563b23c(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$d44bacce7a2eea3, options);
}
const $732264f53056e08f$export$1c391ecc5d16fdd6 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query getExternalCalendars {
  getExternalCalendars {
    id
    provider
    connectedEmail
  }
}
    `;
function $732264f53056e08f$export$d9ea033fb1dff7c9(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($732264f53056e08f$export$1c391ecc5d16fdd6, options);
}
function $732264f53056e08f$export$5471a1989ab571ab(baseOptions) {
    const options = {
        ...$732264f53056e08f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($732264f53056e08f$export$1c391ecc5d16fdd6, options);
}
const $732264f53056e08f$export$39ac829ab91f0716 = {
    Query: {
        GetCustomDomainUser: 'GetCustomDomainUser',
        CustomDomainCertificateStatus: 'CustomDomainCertificateStatus',
        CustomDomainCnameStatus: 'CustomDomainCnameStatus',
        IsDomainLive: 'IsDomainLive',
        GetCloudFrontDistributionByCertificateArn: 'GetCloudFrontDistributionByCertificateArn',
        GetCustomLayouts: 'GetCustomLayouts',
        GetUserInformation: 'GetUserInformation',
        GetSubscription: 'GetSubscription',
        GetAllPlans: 'GetAllPlans',
        GetPlansByProductId: 'GetPlansByProductId',
        GetPlan: 'GetPlan',
        GetUserUniqueLink: 'GetUserUniqueLink',
        GetFirmUniqueLink: 'GetFirmUniqueLink',
        GetProgressStatuses: 'GetProgressStatuses',
        GetUserFirmAccountByFirmAccount: 'GetUserFirmAccountByFirmAccount',
        GetUserById: 'GetUserById',
        GetRoles: 'GetRoles',
        GetUserFirmAccountByFirmAccountAndFilter: 'GetUserFirmAccountByFirmAccountAndFilter',
        GenerateOTP: 'GenerateOTP',
        FirmAccountById: 'FirmAccountById',
        GetBusinessInformation: 'GetBusinessInformation',
        GetFirmNotifications: 'GetFirmNotifications',
        GetClients: 'GetClients',
        GetDeletedClients: 'GetDeletedClients',
        GetClientsByProgressStatusId: 'GetClientsByProgressStatusId',
        GetOTPBoolean: 'GetOTPBoolean',
        CustomDomainUser: 'CustomDomainUser',
        CurrentStripeInformation: 'CurrentStripeInformation',
        GetInvoices: 'GetInvoices',
        GetPaymentIntents: 'GetPaymentIntents',
        GetUpcomingInvoice: 'GetUpcomingInvoice',
        getNylasAccounts: 'getNylasAccounts',
        isActiveFirm: 'isActiveFirm',
        getFirmSettings: 'getFirmSettings',
        getClientsBasicInfo: 'getClientsBasicInfo',
        getFirmSetting: 'getFirmSetting',
        getExternalCalendars: 'getExternalCalendars'
    },
    Fragment: {
        StripeMetaData: 'StripeMetaData',
        Invoices: 'Invoices',
        Payments: 'Payments',
        SignatureField: 'SignatureField',
        Signature: 'Signature',
        File: 'File',
        KBAFields: 'KBAFields',
        KBA: 'KBA',
        FileApproval: 'FileApproval',
        FileRequest: 'FileRequest',
        LanguageEntity: 'LanguageEntity',
        ClientsByStatus: 'ClientsByStatus'
    }
};



var $6Sgv0 = parcelRequire("6Sgv0");



function $2155105093c7c0cc$export$2288787135a8f66e(errorHandler) {
    return new (0, $80285925cfe0f960$export$2fed3d61f740bc7f)(function(operation, forward) {
        return new (0, $7401f4590b7a34ce$export$77cea355fa80b5f4)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $2155105093c7c0cc$export$d2c8415987899609 = function(_super) {
    (0, $7455305bac30ddd9$export$a8ba968b8961cb8a)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $2155105093c7c0cc$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $80285925cfe0f960$export$2fed3d61f740bc7f));





function $43419c17b6558349$export$2f04de43fe27971a(setter) {
    return new (0, $80285925cfe0f960$export$2fed3d61f740bc7f)(function(operation, forward) {
        var request = (0, $7455305bac30ddd9$export$3c9a16f847548506)(operation, []);
        return new (0, $7401f4590b7a34ce$export$77cea355fa80b5f4)(function(observer) {
            var handle;
            var closed = false;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                if (closed) return;
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                closed = true;
                if (handle) handle.unsubscribe();
            };
        });
    });
}



var $cbef6504e51fbf0c$export$6788812c4e6611e6 = (0, $80285925cfe0f960$export$2fed3d61f740bc7f).from;


var $18ae57eea10fd4c8$exports = {};

$18ae57eea10fd4c8$exports = (parcelRequire("6bVDu"));








const $d9c9d80f653581ac$var$isTokenExpired = async (token)=>{
    // fetch with axios
    const result = await (0, (/*@__PURE__*/$parcel$interopDefault($18ae57eea10fd4c8$exports)))({
        method: 'get',
        url: `${(0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).serverUrl}/account/isTokenExpired?token=${token}`
    });
    return result;
};
const $d9c9d80f653581ac$var$uri = "https://3v3qd22r2u.us-east-1.awsapprunner.com/graphql";
const $d9c9d80f653581ac$var$link = (0, $b2a84aefebda3329$export$95180a16573d6675)({
    uri: $d9c9d80f653581ac$var$uri,
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': true
    },
    fetch: fetch
});
const $d9c9d80f653581ac$var$authLink = (0, $43419c17b6558349$export$2f04de43fe27971a)((_, { headers: headers })=>{
    const { accessToken: accessToken } = (0, $e4ec60025026f14e$export$2e2bcd8739ae039).getState().session;
    return {
        headers: {
            ...headers,
            authorization: `Bearer ${accessToken ?? headers?.authorization ?? ''}`
        }
    };
});
const $d9c9d80f653581ac$var$logoutLink = (0, $2155105093c7c0cc$export$2288787135a8f66e)(({ graphQLErrors: graphQLErrors })=>{
    if (graphQLErrors && graphQLErrors.length) {
        /*
          * IMPORTANT: I am using any, because the typing of the variableGraphQLErrors did not detect
          * the status property, which is the one we need to handle the user's logout.
        */ const error = graphQLErrors[0];
        if (error.status === 401) {
            // check if the token has expired or not
            const { accessToken: accessToken } = (0, $e4ec60025026f14e$export$2e2bcd8739ae039).getState().session;
            if (accessToken) $d9c9d80f653581ac$var$isTokenExpired(accessToken).then((res)=>{
                if (res.data) {
                    localStorage.clear();
                    (0, $e4ec60025026f14e$export$2e2bcd8739ae039).dispatch((0, $e3b9937a336ce5aa$export$b5d16ddcd70241c7)());
                    (0, $e4ec60025026f14e$export$2e2bcd8739ae039).dispatch((0, $59a61dbb6cd2676b$export$28052446e33b6b86)());
                    (0, $e4ec60025026f14e$export$2e2bcd8739ae039).dispatch((0, $af02328711f8c5fd$export$95c2dcacae3679d3)());
                    (0, $e4ec60025026f14e$export$2e2bcd8739ae039).dispatch((0, $66a7cecdd31d321f$export$43119c4be593e906)());
                    window.location.reload();
                }
            }).catch((err)=>{
                console.error('err:', err);
                localStorage.clear();
                (0, $e4ec60025026f14e$export$2e2bcd8739ae039).dispatch((0, $e3b9937a336ce5aa$export$b5d16ddcd70241c7)());
                (0, $e4ec60025026f14e$export$2e2bcd8739ae039).dispatch((0, $59a61dbb6cd2676b$export$28052446e33b6b86)());
                (0, $e4ec60025026f14e$export$2e2bcd8739ae039).dispatch((0, $af02328711f8c5fd$export$95c2dcacae3679d3)());
                (0, $e4ec60025026f14e$export$2e2bcd8739ae039).dispatch((0, $66a7cecdd31d321f$export$43119c4be593e906)());
                window.location.reload();
            });
        }
    }
});
const $d9c9d80f653581ac$var$client = new (0, $5215b865ef3c30a6$export$13f5a5f0f1dbab88)({
    cache: new (0, $31a53b60bb0b908b$export$467265324939f47f)({
        typePolicies: {
            EventTypeEntity: {
                fields: {
                    EventTypeAvailability: {
                        // eslint-disable-next-line default-param-last
                        merge (existing = [], incoming) {
                            if (incoming) return [
                                ...incoming
                            ];
                            return [
                                ...existing
                            ];
                        }
                    }
                }
            },
            UserStepEntity: {
                keyFields: [
                    'userId',
                    'stepId'
                ]
            }
        }
    }),
    // link: authLink.concat(link),
    link: (0, $cbef6504e51fbf0c$export$6788812c4e6611e6)([
        $d9c9d80f653581ac$var$authLink,
        $d9c9d80f653581ac$var$logoutLink,
        $d9c9d80f653581ac$var$link
    ])
});
var $d9c9d80f653581ac$export$2e2bcd8739ae039 = $d9c9d80f653581ac$var$client;



var $bb3TF = parcelRequire("bb3TF");

var $c67238c4d333e283$exports = {};
/* @license
Papa Parse
v5.4.1
https://github.com/mholt/PapaParse
License: MIT
*/ !function(e, t) {
    "function" == typeof define && define.amd ? define([], t) : $c67238c4d333e283$exports = t();
}($c67238c4d333e283$exports, function s() {
    "use strict";
    var f = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== f ? f : {};
    var n = !f.document && !!f.postMessage, o = f.IS_PAPA_WORKER || !1, a = {}, u = 0, b = {
        parse: function(e, t) {
            var r = (t = t || {}).dynamicTyping || !1;
            J(r) && (t.dynamicTypingFunction = r, r = {});
            if (t.dynamicTyping = r, t.transform = !!J(t.transform) && t.transform, t.worker && b.WORKERS_SUPPORTED) {
                var i = function() {
                    if (!b.WORKERS_SUPPORTED) return !1;
                    var e = (r = f.URL || f.webkitURL || null, i = s.toString(), b.BLOB_URL || (b.BLOB_URL = r.createObjectURL(new Blob([
                        "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                        "(",
                        i,
                        ")();"
                    ], {
                        type: "text/javascript"
                    })))), t = new f.Worker(e);
                    var r, i;
                    return t.onmessage = _, t.id = u++, a[t.id] = t;
                }();
                return i.userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = J(t.step), t.chunk = J(t.chunk), t.complete = J(t.complete), t.error = J(t.error), delete t.worker, void i.postMessage({
                    input: e,
                    config: t,
                    workerId: i.id
                });
            }
            var n = null;
            b.NODE_STREAM_INPUT, "string" == typeof e ? (e = function(e) {
                if (65279 === e.charCodeAt(0)) return e.slice(1);
                return e;
            }(e), n = t.download ? new l(t) : new p(t)) : !0 === e.readable && J(e.read) && J(e.on) ? n = new g(t) : (f.File && e instanceof File || e instanceof Object) && (n = new c(t));
            return n.stream(e);
        },
        unparse: function(e, t) {
            var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, r = !1, i = null, o = !1;
            !function() {
                if ("object" != typeof t) return;
                "string" != typeof t.delimiter || b.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter);
                ("boolean" == typeof t.quotes || "function" == typeof t.quotes || Array.isArray(t.quotes)) && (n = t.quotes);
                "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (r = t.skipEmptyLines);
                "string" == typeof t.newline && (y = t.newline);
                "string" == typeof t.quoteChar && (s = t.quoteChar);
                "boolean" == typeof t.header && (_ = t.header);
                if (Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    i = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s);
                ("boolean" == typeof t.escapeFormulae || t.escapeFormulae instanceof RegExp) && (o = t.escapeFormulae instanceof RegExp ? t.escapeFormulae : /^[=+\-@\t\r].*$/);
            }();
            var u = new RegExp(Q(s), "g");
            "string" == typeof e && (e = JSON.parse(e));
            if (Array.isArray(e)) {
                if (!e.length || Array.isArray(e[0])) return h(null, e, r);
                if ("object" == typeof e[0]) return h(i || Object.keys(e[0]), e, r);
            } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || i), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
                e.data
            ])), h(e.fields || [], e.data || [], r);
            throw new Error("Unable to serialize unrecognized input");
            function h(e, t, r) {
                var i = "";
                "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
                var n = Array.isArray(e) && 0 < e.length, s = !Array.isArray(t[0]);
                if (n && _) {
                    for(var a = 0; a < e.length; a++)0 < a && (i += m), i += v(e[a], a);
                    0 < t.length && (i += y);
                }
                for(var o = 0; o < t.length; o++){
                    var u = n ? e.length : t[o].length, h = !1, f = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                    if (r && !n && (h = "greedy" === r ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === r && n) {
                        for(var d = [], l = 0; l < u; l++){
                            var c = s ? e[l] : l;
                            d.push(t[o][c]);
                        }
                        h = "" === d.join("").trim();
                    }
                    if (!h) {
                        for(var p = 0; p < u; p++){
                            0 < p && !f && (i += m);
                            var g = n && s ? e[p] : p;
                            i += v(t[o][g], p);
                        }
                        o < t.length - 1 && (!r || 0 < u && !f) && (i += y);
                    }
                }
                return i;
            }
            function v(e, t) {
                if (null == e) return "";
                if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
                var r = !1;
                o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0);
                var i = e.toString().replace(u, a);
                return (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || function(e, t) {
                    for(var r = 0; r < t.length; r++)if (-1 < e.indexOf(t[r])) return !0;
                    return !1;
                }(i, b.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i;
            }
        }
    };
    if (b.RECORD_SEP = String.fromCharCode(30), b.UNIT_SEP = String.fromCharCode(31), b.BYTE_ORDER_MARK = "\ufeff", b.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        b.BYTE_ORDER_MARK
    ], b.WORKERS_SUPPORTED = !n && !!f.Worker, b.NODE_STREAM_INPUT = 1, b.LocalChunkSize = 10485760, b.RemoteChunkSize = 5242880, b.DefaultDelimiter = ",", b.Parser = E, b.ParserHandle = r, b.NetworkStreamer = l, b.FileStreamer = c, b.StringStreamer = p, b.ReadableStreamStreamer = g, f.jQuery) {
        var d = f.jQuery;
        d.fn.parse = function(o) {
            var r = o.config || {}, u = [];
            return this.each(function(e) {
                if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && f.FileReader) || !this.files || 0 === this.files.length) return !0;
                for(var t = 0; t < this.files.length; t++)u.push({
                    file: this.files[t],
                    inputElem: this,
                    instanceConfig: d.extend({}, r)
                });
            }), e(), this;
            function e() {
                if (0 !== u.length) {
                    var e, t, r, i, n = u[0];
                    if (J(o.before)) {
                        var s = o.before(n.file, n.inputElem);
                        if ("object" == typeof s) {
                            if ("abort" === s.action) return e = "AbortError", t = n.file, r = n.inputElem, i = s.reason, void (J(o.error) && o.error({
                                name: e
                            }, t, r, i));
                            if ("skip" === s.action) return void h();
                            "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                        } else if ("skip" === s) return void h();
                    }
                    var a = n.instanceConfig.complete;
                    n.instanceConfig.complete = function(e) {
                        J(a) && a(e, n.file, n.inputElem), h();
                    }, b.parse(n.file, n.instanceConfig);
                } else J(o.complete) && o.complete();
            }
            function h() {
                u.splice(0, 1), e();
            }
        };
    }
    function h(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = w(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new r(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(e, t) {
            if (this.isFirstChunk && J(this._config.beforeFirstChunk)) {
                var r = this._config.beforeFirstChunk(e);
                void 0 !== r && (e = r);
            }
            this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + e;
            this._partialLine = "";
            var n = this._handle.parse(i, this._baseIndex, !this._finished);
            if (!this._handle.paused() && !this._handle.aborted()) {
                var s = n.meta.cursor;
                this._finished || (this._partialLine = i.substring(s - this._baseIndex), this._baseIndex = s), n && n.data && (this._rowCount += n.data.length);
                var a = this._finished || this._config.preview && this._rowCount >= this._config.preview;
                if (o) f.postMessage({
                    results: n,
                    workerId: b.WORKER_ID,
                    finished: a
                });
                else if (J(this._config.chunk) && !t) {
                    if (this._config.chunk(n, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    n = void 0, this._completeResults = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(n.data), this._completeResults.errors = this._completeResults.errors.concat(n.errors), this._completeResults.meta = n.meta), this._completed || !a || !J(this._config.complete) || n && n.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), a || n && n.meta.paused || this._nextChunk(), n;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            J(this._config.error) ? this._config.error(e) : o && this._config.error && f.postMessage({
                workerId: b.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function l(e) {
        var i;
        (e = e || {}).chunkSize || (e.chunkSize = b.RemoteChunkSize), h.call(this, e), this._nextChunk = n ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (i = new XMLHttpRequest, this._config.withCredentials && (i.withCredentials = this._config.withCredentials), n || (i.onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)), i.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !n), this._config.downloadRequestHeaders) {
                    var e = this._config.downloadRequestHeaders;
                    for(var t in e)i.setRequestHeader(t, e[t]);
                }
                if (this._config.chunkSize) {
                    var r = this._start + this._config.chunkSize - 1;
                    i.setRequestHeader("Range", "bytes=" + this._start + "-" + r);
                }
                try {
                    i.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                n && 0 === i.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === i.readyState && (i.status < 200 || 400 <= i.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : i.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(e) {
                var t = e.getResponseHeader("Content-Range");
                if (null === t) return -1;
                return parseInt(t.substring(t.lastIndexOf("/") + 1));
            }(i), this.parseChunk(i.responseText)));
        }, this._chunkError = function(e) {
            var t = i.statusText || e;
            this._sendError(new Error(t));
        };
    }
    function c(e) {
        var i, n;
        (e = e || {}).chunkSize || (e.chunkSize = b.LocalChunkSize), h.call(this, e);
        var s = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, n = e.slice || e.webkitSlice || e.mozSlice, s ? ((i = new FileReader).onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input;
            if (this._config.chunkSize) {
                var t = Math.min(this._start + this._config.chunkSize, this._input.size);
                e = n.call(e, this._start, t);
            }
            var r = i.readAsText(e, this._config.encoding);
            s || this._chunkLoaded({
                target: {
                    result: r
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function p(e) {
        var r;
        h.call(this, e = e || {}), this.stream = function(e) {
            return r = e, this._nextChunk();
        }, this._nextChunk = function() {
            if (!this._finished) {
                var e, t = this._config.chunkSize;
                return t ? (e = r.substring(0, t), r = r.substring(t)) : (e = r, r = ""), this._finished = !r, this.parseChunk(e);
            }
        };
    }
    function g(e) {
        h.call(this, e = e || {});
        var t = [], r = !0, i = !1;
        this.pause = function() {
            h.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            h.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            i && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : r = !0;
        }, this._streamData = v(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), r && (r = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = v(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = v(function() {
            this._streamCleanUp(), i = !0, this._streamData("");
        }, this), this._streamCleanUp = v(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function r(m) {
        var a, o, u, i = Math.pow(2, 53), n = -i, s = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, h = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, t = this, r = 0, f = 0, d = !1, e = !1, l = [], c = {
            data: [],
            errors: [],
            meta: {}
        };
        if (J(m.step)) {
            var p = m.step;
            m.step = function(e) {
                if (c = e, _()) g();
                else {
                    if (g(), 0 === c.data.length) return;
                    r += e.data.length, m.preview && r > m.preview ? o.abort() : (c.data = c.data[0], p(c, t));
                }
            };
        }
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            return c && u && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + b.DefaultDelimiter + "'"), u = !1), m.skipEmptyLines && (c.data = c.data.filter(function(e) {
                return !y(e);
            })), _() && function() {
                if (!c) return;
                function e(e, t) {
                    J(m.transformHeader) && (e = m.transformHeader(e, t)), l.push(e);
                }
                if (Array.isArray(c.data[0])) {
                    for(var t = 0; _() && t < c.data.length; t++)c.data[t].forEach(e);
                    c.data.splice(0, 1);
                } else c.data.forEach(e);
            }(), function() {
                if (!c || !m.header && !m.dynamicTyping && !m.transform) return c;
                function e(e, t) {
                    var r, i = m.header ? {} : [];
                    for(r = 0; r < e.length; r++){
                        var n = r, s = e[r];
                        m.header && (n = r >= l.length ? "__parsed_extra" : l[r]), m.transform && (s = m.transform(s, n)), s = v(n, s), "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                    }
                    return m.header && (r > l.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + l.length + " fields but parsed " + r, f + t) : r < l.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + l.length + " fields but parsed " + r, f + t)), i;
                }
                var t = 1;
                !c.data.length || Array.isArray(c.data[0]) ? (c.data = c.data.map(e), t = c.data.length) : c.data = e(c.data, 0);
                m.header && c.meta && (c.meta.fields = l);
                return f += t, c;
            }();
        }
        function _() {
            return m.header && 0 === l.length;
        }
        function v(e, t) {
            var r;
            return r = e, m.dynamicTypingFunction && void 0 === m.dynamicTyping[r] && (m.dynamicTyping[r] = m.dynamicTypingFunction(r)), !0 === (m.dynamicTyping[r] || m.dynamicTyping) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (function(e) {
                if (s.test(e)) {
                    var t = parseFloat(e);
                    if (n < t && t < i) return !0;
                }
                return !1;
            }(t) ? parseFloat(t) : h.test(t) ? new Date(t) : "" === t ? null : t) : t;
        }
        function k(e, t, r, i) {
            var n = {
                type: e,
                code: t,
                message: r
            };
            void 0 !== i && (n.row = i), c.errors.push(n);
        }
        this.parse = function(e, t, r) {
            var i = m.quoteChar || '"';
            if (m.newline || (m.newline = function(e, t) {
                e = e.substring(0, 1048576);
                var r = new RegExp(Q(t) + "([^]*?)" + Q(t), "gm"), i = (e = e.replace(r, "")).split("\r"), n = e.split("\n"), s = 1 < n.length && n[0].length < i[0].length;
                if (1 === i.length || s) return "\n";
                for(var a = 0, o = 0; o < i.length; o++)"\n" === i[o][0] && a++;
                return a >= i.length / 2 ? "\r\n" : "\r";
            }(e, i)), u = !1, m.delimiter) J(m.delimiter) && (m.delimiter = m.delimiter(e), c.meta.delimiter = m.delimiter);
            else {
                var n = function(e, t, r, i, n) {
                    var s, a, o, u;
                    n = n || [
                        ",",
                        "\t",
                        "|",
                        ";",
                        b.RECORD_SEP,
                        b.UNIT_SEP
                    ];
                    for(var h = 0; h < n.length; h++){
                        var f = n[h], d = 0, l = 0, c = 0;
                        o = void 0;
                        for(var p = new E({
                            comments: i,
                            delimiter: f,
                            newline: t,
                            preview: 10
                        }).parse(e), g = 0; g < p.data.length; g++)if (r && y(p.data[g])) c++;
                        else {
                            var _ = p.data[g].length;
                            l += _, void 0 !== o ? 0 < _ && (d += Math.abs(_ - o), o = _) : o = _;
                        }
                        0 < p.data.length && (l /= p.data.length - c), (void 0 === a || d <= a) && (void 0 === u || u < l) && 1.99 < l && (a = d, s = f, u = l);
                    }
                    return {
                        successful: !!(m.delimiter = s),
                        bestDelimiter: s
                    };
                }(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess);
                n.successful ? m.delimiter = n.bestDelimiter : (u = !0, m.delimiter = b.DefaultDelimiter), c.meta.delimiter = m.delimiter;
            }
            var s = w(m);
            return m.preview && m.header && s.preview++, a = e, o = new E(s), c = o.parse(a, t, r), g(), d ? {
                meta: {
                    paused: !0
                }
            } : c || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return d;
        }, this.pause = function() {
            d = !0, o.abort(), a = J(m.chunk) ? "" : a.substring(o.getCharIndex());
        }, this.resume = function() {
            t.streamer._halted ? (d = !1, t.streamer.parseChunk(a, !0)) : setTimeout(t.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, o.abort(), c.meta.aborted = !0, J(m.complete) && m.complete(c), a = "";
        };
    }
    function Q(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(j) {
        var z, M = (j = j || {}).delimiter, P = j.newline, U = j.comments, q = j.step, N = j.preview, B = j.fastMode, K = z = void 0 === j.quoteChar || null === j.quoteChar ? '"' : j.quoteChar;
        if (void 0 !== j.escapeChar && (K = j.escapeChar), ("string" != typeof M || -1 < b.BAD_DELIMITERS.indexOf(M)) && (M = ","), U === M) throw new Error("Comment character same as delimiter");
        !0 === U ? U = "#" : ("string" != typeof U || -1 < b.BAD_DELIMITERS.indexOf(U)) && (U = !1), "\n" !== P && "\r" !== P && "\r\n" !== P && (P = "\n");
        var W = 0, H = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = M.length, s = P.length, a = U.length, o = J(q), u = [], h = [], f = [], d = W = 0;
            if (!i) return L();
            if (j.header && !t) {
                var l = i.split(P)[0].split(M), c = [], p = {}, g = !1;
                for(var _ in l){
                    var m = l[_];
                    J(j.transformHeader) && (m = j.transformHeader(m, _));
                    var y = m, v = p[m] || 0;
                    for(0 < v && (g = !0, y = m + "_" + v), p[m] = v + 1; c.includes(y);)y = y + "_" + v;
                    c.push(y);
                }
                if (g) {
                    var k = i.split(P);
                    k[0] = c.join(M), i = k.join(P);
                }
            }
            if (B || !1 !== B && -1 === i.indexOf(z)) {
                for(var b = i.split(P), E = 0; E < b.length; E++){
                    if (f = b[E], W += f.length, E !== b.length - 1) W += P.length;
                    else if (r) return L();
                    if (!U || f.substring(0, a) !== U) {
                        if (o) {
                            if (u = [], I(f.split(M)), F(), H) return L();
                        } else I(f.split(M));
                        if (N && N <= E) return u = u.slice(0, N), L(!0);
                    }
                }
                return L();
            }
            for(var w = i.indexOf(M, W), R = i.indexOf(P, W), C = new RegExp(Q(K) + Q(z), "g"), S = i.indexOf(z, W);;)if (i[W] !== z) {
                if (U && 0 === f.length && i.substring(W, W + a) === U) {
                    if (-1 === R) return L();
                    W = R + s, R = i.indexOf(P, W), w = i.indexOf(M, W);
                } else if (-1 !== w && (w < R || -1 === R)) f.push(i.substring(W, w)), W = w + e, w = i.indexOf(M, W);
                else {
                    if (-1 === R) break;
                    if (f.push(i.substring(W, R)), D(R + s), o && (F(), H)) return L();
                    if (N && u.length >= N) return L(!0);
                }
            } else for(S = W, W++;;){
                if (-1 === (S = i.indexOf(z, S + 1))) return r || h.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: u.length,
                    index: W
                }), T();
                if (S === n - 1) return T(i.substring(W, S).replace(C, z));
                if (z !== K || i[S + 1] !== K) {
                    if (z === K || 0 === S || i[S - 1] !== K) {
                        -1 !== w && w < S + 1 && (w = i.indexOf(M, S + 1)), -1 !== R && R < S + 1 && (R = i.indexOf(P, S + 1));
                        var O = A(-1 === R ? w : Math.min(w, R));
                        if (i.substr(S + 1 + O, e) === M) {
                            f.push(i.substring(W, S).replace(C, z)), i[W = S + 1 + O + e] !== z && (S = i.indexOf(z, W)), w = i.indexOf(M, W), R = i.indexOf(P, W);
                            break;
                        }
                        var x = A(R);
                        if (i.substring(S + 1 + x, S + 1 + x + s) === P) {
                            if (f.push(i.substring(W, S).replace(C, z)), D(S + 1 + x + s), w = i.indexOf(M, W), S = i.indexOf(z, W), o && (F(), H)) return L();
                            if (N && u.length >= N) return L(!0);
                            break;
                        }
                        h.push({
                            type: "Quotes",
                            code: "InvalidQuotes",
                            message: "Trailing quote on quoted field is malformed",
                            row: u.length,
                            index: W
                        }), S++;
                    }
                } else S++;
            }
            return T();
            function I(e) {
                u.push(e), d = W;
            }
            function A(e) {
                var t = 0;
                if (-1 !== e) {
                    var r = i.substring(S + 1, e);
                    r && "" === r.trim() && (t = r.length);
                }
                return t;
            }
            function T(e) {
                return r || (void 0 === e && (e = i.substring(W)), f.push(e), W = n, I(f), o && F()), L();
            }
            function D(e) {
                W = e, I(f), f = [], R = i.indexOf(P, W);
            }
            function L(e) {
                return {
                    data: u,
                    errors: h,
                    meta: {
                        delimiter: M,
                        linebreak: P,
                        aborted: H,
                        truncated: !!e,
                        cursor: d + (t || 0)
                    }
                };
            }
            function F() {
                q(L()), u = [], h = [];
            }
        }, this.abort = function() {
            H = !0;
        }, this.getCharIndex = function() {
            return W;
        };
    }
    function _(e) {
        var t = e.data, r = a[t.workerId], i = !1;
        if (t.error) r.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    i = !0, m(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: y,
                resume: y
            };
            if (J(r.userStep)) {
                for(var s = 0; s < t.results.data.length && (r.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !i); s++);
                delete t.results;
            } else J(r.userChunk) && (r.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !i && m(t.workerId, t.results);
    }
    function m(e, t) {
        var r = a[e];
        J(r.userComplete) && r.userComplete(t), r.terminate(), delete a[e];
    }
    function y() {
        throw new Error("Not implemented.");
    }
    function w(e) {
        if ("object" != typeof e || null === e) return e;
        var t = Array.isArray(e) ? [] : {};
        for(var r in e)t[r] = w(e[r]);
        return t;
    }
    function v(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function J(e) {
        return "function" == typeof e;
    }
    return o && (f.onmessage = function(e) {
        var t = e.data;
        void 0 === b.WORKER_ID && t && (b.WORKER_ID = t.workerId);
        if ("string" == typeof t.input) f.postMessage({
            workerId: b.WORKER_ID,
            results: b.parse(t.input, t.config),
            finished: !0
        });
        else if (f.File && t.input instanceof File || t.input instanceof Object) {
            var r = b.parse(t.input, t.config);
            r && f.postMessage({
                workerId: b.WORKER_ID,
                results: r,
                finished: !0
            });
        }
    }), (l.prototype = Object.create(h.prototype)).constructor = l, (c.prototype = Object.create(h.prototype)).constructor = c, (p.prototype = Object.create(p.prototype)).constructor = p, (g.prototype = Object.create(h.prototype)).constructor = g, b;
});


const { DownloadOutlined: $4f9d64056079d842$var$DownloadOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Title: $4f9d64056079d842$var$Title, Paragraph: $4f9d64056079d842$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $4f9d64056079d842$var$DropzoneForm = (props)=>{
    const { setUploaded: setUploaded, handleOnError: handleOnError } = props;
    const beforeUpload = async (file)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($c67238c4d333e283$exports))).parse(file, {
            skipEmptyLines: true,
            header: true,
            complete: (data)=>{
                if (data.errors.length > 0) handleOnError({
                    message: `${file.name} has nothing to import.`
                });
                else setUploaded(data);
            }
        });
        return false;
    };
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)($4f9d64056079d842$var$Paragraph, {
                children: "Export clients from any tax software in CSV format."
            }),
            (0, $bb3TF.jsx)($4f9d64056079d842$var$Paragraph, {
                children: "Then import clients so their information is pre-populated in their portal."
            }),
            (0, $bb3TF.jsxs)((0, $daaf8072fce14d91$export$47d4850b9fdf5af1), {
                beforeUpload: beforeUpload,
                maxCount: 1,
                fileList: [],
                children: [
                    (0, $bb3TF.jsx)($4f9d64056079d842$var$DownloadOutlined, {
                        style: {
                            fontSize: 48,
                            margin: '26px 0'
                        }
                    }),
                    (0, $bb3TF.jsx)($4f9d64056079d842$var$Title, {
                        level: 3,
                        children: "Click or drag file to this area to upload"
                    }),
                    (0, $bb3TF.jsx)($4f9d64056079d842$var$Paragraph, {
                        type: "secondary",
                        children: "Support for a single file."
                    })
                ]
            })
        ]
    });
};
var $4f9d64056079d842$export$2e2bcd8739ae039 = $4f9d64056079d842$var$DropzoneForm;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



var $6Sgv0 = parcelRequire("6Sgv0");

var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $6Sgv0 = parcelRequire("6Sgv0");


const $3198fe3853f3bce8$var$defaultOptions = {};
const $3198fe3853f3bce8$export$b1ee7c8416f8d41e = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query FirmTaxPreparers {
  FirmTaxPreparers {
    id
    name
  }
}
    `;
function $3198fe3853f3bce8$export$351bee9728151e39(baseOptions) {
    const options = {
        ...$3198fe3853f3bce8$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($3198fe3853f3bce8$export$b1ee7c8416f8d41e, options);
}
function $3198fe3853f3bce8$export$8eeb7c8d0de35ffc(baseOptions) {
    const options = {
        ...$3198fe3853f3bce8$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($3198fe3853f3bce8$export$b1ee7c8416f8d41e, options);
}
const $3198fe3853f3bce8$export$39ac829ab91f0716 = {
    Query: {
        FirmTaxPreparers: 'FirmTaxPreparers'
    }
};


/*
  * This is to get <limit> years back from the current year for example if the current
  * year is 2022 and limit=5 the result would be: [2022, 2021, 2020, 2019, 2018].
  * but the result is mapped for use as options in a select element/component
*/ const $02555ecb9d643fe4$var$getTaxYearOptions = (limit)=>{
    const currentYear = new Date().getFullYear();
    const options = [
        // previous year
        {
            value: (currentYear - 1).toString(),
            label: (currentYear - 1).toString()
        },
        // current year
        {
            value: currentYear.toString(),
            label: currentYear.toString()
        }
    ];
    for(let year = currentYear - 2; year > currentYear - limit; year -= 1)options.push({
        value: year.toString(),
        label: year.toString()
    });
    return options;
};
var $02555ecb9d643fe4$export$2e2bcd8739ae039 = $02555ecb9d643fe4$var$getTaxYearOptions;



var $14f5626472be376a$export$7b1b20912a539e4f;
var $14f5626472be376a$export$74433d149609dc71;
var $14f5626472be376a$export$400082633f1f7338;
var $14f5626472be376a$export$5cd9276f272d6865;
var $14f5626472be376a$export$d7e18305320e660d;
var $14f5626472be376a$export$9f627f84c599233;
var $14f5626472be376a$export$881144413d8e0c7e;
var $14f5626472be376a$export$1cf2413a6e44709f;
$14f5626472be376a$export$7b1b20912a539e4f = `wuy7WG_backgroundBlue`;
$14f5626472be376a$export$74433d149609dc71 = `wuy7WG_backgroundGreen`;
$14f5626472be376a$export$400082633f1f7338 = `wuy7WG_backgroundLightBlue`;
$14f5626472be376a$export$5cd9276f272d6865 = `wuy7WG_backgroundOrange`;
$14f5626472be376a$export$d7e18305320e660d = `wuy7WG_badgeClientsCount`;
$14f5626472be376a$export$9f627f84c599233 = `wuy7WG_importTypeText`;
$14f5626472be376a$export$881144413d8e0c7e = `wuy7WG_updateCell`;
$14f5626472be376a$export$1cf2413a6e44709f = `wuy7WG_updateDetailsMark`;



const { Option: $d0cd9ea7d92244eb$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const { Text: $d0cd9ea7d92244eb$var$Text, Paragraph: $d0cd9ea7d92244eb$var$Paragraph, Title: $d0cd9ea7d92244eb$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { InfoCircleOutlined: $d0cd9ea7d92244eb$var$InfoCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $d0cd9ea7d92244eb$export$d40014048739ecba = {
    orange: 'rgb(235,145,58)',
    green: 'rgb(114,194,64)',
    blue: 'rgb(50,73,196)',
    red: 'rgb(250,73,96)'
};
const $d0cd9ea7d92244eb$var$TAX_YEAR_OPTIONS = (0, $02555ecb9d643fe4$export$2e2bcd8739ae039)(10);
const $d0cd9ea7d92244eb$var$TableForm = (props)=>{
    const { tableForm: tableForm, clients: clients, selectedRowKeys: selectedRowKeys, setSelectedRowKeys: setSelectedRowKeys, selectedInvitations: selectedInvitations, setSelectedInvitations: setSelectedInvitations, selectedClients: selectedClients, updateSelectedClients: updateSelectedClients, onPaginationChange: onPaginationChange } = props;
    const [isModalOpen, setIsModalOpen] = (0, $6fFrj.useState)(false);
    const { data: jobTypes, loading: loadingGetInterviews } = (0, $774cc9a1c383b6aa$export$194d4356b994f52)({
        variables: {
            filterLiveInterviews: false
        }
    });
    const { data: preparers, loading: loadingPreparers } = (0, $3198fe3853f3bce8$export$351bee9728151e39)();
    const onSelectChange = (newSelectedRowKeys)=>{
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
    };
    const sendEmailInvitationToggle = (index, check)=>{
        if (check) return setSelectedInvitations([
            ...selectedInvitations,
            index
        ]);
        return setSelectedInvitations(selectedInvitations.filter((key)=>key !== index));
    };
    const preparerFormNames = clients.map((client)=>`preparer_${client.key}`);
    const onPreparerSelect = (value)=>{
        const newPreparerValues = Object.assign({}, ...preparerFormNames.map((preparerName)=>{
            const map = new Map();
            map.set(preparerName, value);
            return Object.fromEntries(map);
        }));
        tableForm.setFieldsValue(newPreparerValues);
        updateSelectedClients();
    };
    const columns = [
        {
            dataIndex: 'isUpdate',
            key: 'import',
            title: 'Import Type',
            render: (isUpdate)=>isUpdate ? (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Text, {
                    className: `${$14f5626472be376a$export$9f627f84c599233} ${$14f5626472be376a$export$5cd9276f272d6865}`,
                    strong: true,
                    small: true,
                    children: "Update"
                }) : (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Text, {
                    className: `${$14f5626472be376a$export$9f627f84c599233} ${$14f5626472be376a$export$74433d149609dc71}`,
                    strong: true,
                    small: true,
                    children: "New Client"
                })
        },
        {
            key: 'sendInvitation',
            title: (0, $bb3TF.jsxs)("div", {
                children: [
                    "Send Invitation",
                    (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$InfoCircleOutlined, {
                        style: {
                            padding: '0 0 0 10px',
                            cursor: 'pointer'
                        },
                        onClick: ()=>setIsModalOpen(true)
                    })
                ]
            }),
            render: (text, record)=>(0, $bb3TF.jsx)((0, $4fd303306a27e42e$export$2e2bcd8739ae039), {
                    checked: selectedInvitations.some((invitation)=>invitation === record.key),
                    onChange: (check)=>sendEmailInvitationToggle(record.key, check)
                })
        },
        {
            key: 'preparer',
            title: 'Preparer',
            width: 210,
            render: (text, record)=>(0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: `preparer_${record.key}`,
                    label: "Preparer",
                    children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                        placeholder: "Select a preparer",
                        allowClear: true,
                        onChange: updateSelectedClients,
                        children: preparers?.FirmTaxPreparers.map((item)=>(0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Option, {
                                value: item.id,
                                children: item.name
                            }, item.id))
                    })
                })
        },
        {
            key: 'jobType',
            title: 'Job Type',
            width: 210,
            render: (text, record)=>(0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: `jobType_${record.key}`,
                    label: "Job Type",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: (0, $bb3TF.jsx)((0, $89a92f440564d95a$export$2e2bcd8739ae039), {
                        onChange: updateSelectedClients
                    })
                })
        }
    ];
    const generateColumnProc = (key)=>{
        if (clients.some((cli)=>cli[key])) return {
            dataIndex: key,
            key: key,
            title: (0, $6ba32ea8088dda77$export$d6ec2585aab3d343)[key],
            render: (value, record)=>{
                if (key === 'phones') return value?.map((p, index)=>(0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Paragraph, {
                        children: `${p.type[0]}${p.type.slice(1).toLowerCase()}: ${p.value}`
                    }, index));
                const recordValue = key === 'dob' && (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(value).isValid() ? (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0))).utc(value).format('MM/DD/YYYY') : value;
                if (record.updatedFields?.some((field)=>field === key)) return (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Text, {
                    style: key === 'dob' ? {
                        whiteSpace: 'nowrap'
                    } : {},
                    className: `${$14f5626472be376a$export$881144413d8e0c7e} ${$14f5626472be376a$export$400082633f1f7338}`,
                    children: recordValue
                });
                return (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Text, {
                    style: key === 'dob' ? {
                        whiteSpace: 'nowrap'
                    } : {},
                    children: recordValue
                });
            }
        };
        return undefined;
    };
    // initial form values
    const jobTypeFormNames = clients.map((client)=>`jobType_${client.key}`);
    const jobTypesInitial = Object.assign({}, ...jobTypeFormNames.map((jtName)=>{
        const map = new Map();
        const key = Number(jtName.replace('jobType_', ''));
        const value = clients[key].jobType;
        if (value) {
            map.set(jtName, value);
            return Object.fromEntries(map);
        }
        return {};
    }));
    const preparersInitial = Object.assign({}, ...preparerFormNames.map((preparerName)=>{
        const map = new Map();
        const key = Number(preparerName.replace('preparer_', ''));
        const value = clients[key].preparer;
        if (value) {
            map.set(preparerName, value);
            return Object.fromEntries(map);
        }
        return {};
    }));
    const newClients = selectedClients.filter((cli)=>!cli.isUpdate);
    const updateClients = selectedClients.filter((cli)=>cli.isUpdate);
    const generatedColumns = {
        address1: generateColumnProc('address1'),
        address2: generateColumnProc('address2'),
        city: generateColumnProc('city'),
        dob: generateColumnProc('dob'),
        email: generateColumnProc('email'),
        firstName: generateColumnProc('firstName'),
        lastName: generateColumnProc('lastName'),
        phones: generateColumnProc('phones'),
        zip: generateColumnProc('zip'),
        ssn: generateColumnProc('ssn'),
        state: generateColumnProc('state')
    };
    let sortedColumns = [];
    sortedColumns.push(columns[0]);
    if (generatedColumns.firstName) sortedColumns.push(generatedColumns.firstName);
    if (generatedColumns.lastName) sortedColumns.push(generatedColumns.lastName);
    sortedColumns = sortedColumns.concat(columns.slice(1));
    if (generatedColumns.email) sortedColumns.push(generatedColumns.email);
    if (generatedColumns.phones) sortedColumns.push(generatedColumns.phones);
    if (generatedColumns.dob) sortedColumns.push(generatedColumns.dob);
    if (generatedColumns.ssn) sortedColumns.push(generatedColumns.ssn);
    if (generatedColumns.address1) sortedColumns.push(generatedColumns.address1);
    if (generatedColumns.address2) sortedColumns.push(generatedColumns.address2);
    if (generatedColumns.city) sortedColumns.push(generatedColumns.city);
    if (generatedColumns.state) sortedColumns.push(generatedColumns.state);
    if (generatedColumns.zip) sortedColumns.push(generatedColumns.zip);
    if (loadingGetInterviews || loadingPreparers) return (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        justify: "center",
        className: "showScrollbar",
        children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
            size: "large"
        })
    });
    return (0, $bb3TF.jsxs)("section", {
        children: [
            (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                layout: "vertical",
                form: tableForm,
                // eslint-disable-next-line no-template-curly-in-string
                validateMessages: {
                    required: 'Required'
                },
                initialValues: {
                    preparer: undefined,
                    jobType: undefined,
                    taxYear: undefined,
                    sendInvitation: false,
                    ...jobTypesInitial,
                    ...preparersInitial
                },
                style: {
                    width: '100%'
                },
                children: [
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        align: "middle",
                        gutter: 25,
                        children: [
                            Boolean(newClients.length) && (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $bb3TF.jsx)((0, $0e541b76c0e3ec69$export$2e2bcd8739ae039), {
                                        overflowCount: 99999999,
                                        count: newClients.length,
                                        className: $14f5626472be376a$export$d7e18305320e660d,
                                        style: {
                                            backgroundColor: $d0cd9ea7d92244eb$export$d40014048739ecba.green
                                        }
                                    }),
                                    (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Text, {
                                        children: "New clients will be created"
                                    })
                                ]
                            }),
                            Boolean(updateClients.length) && (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $bb3TF.jsx)((0, $0e541b76c0e3ec69$export$2e2bcd8739ae039), {
                                        overflowCount: 99999999,
                                        count: updateClients.length,
                                        className: $14f5626472be376a$export$d7e18305320e660d,
                                        style: {
                                            backgroundColor: $d0cd9ea7d92244eb$export$d40014048739ecba.orange
                                        }
                                    }),
                                    (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Text, {
                                        children: "Existing clients will be updated"
                                    })
                                ]
                            }),
                            (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $bb3TF.jsx)((0, $0e541b76c0e3ec69$export$2e2bcd8739ae039), {
                                        overflowCount: 99999999,
                                        count: selectedClients.length,
                                        className: $14f5626472be376a$export$d7e18305320e660d,
                                        style: {
                                            backgroundColor: $d0cd9ea7d92244eb$export$d40014048739ecba.blue
                                        },
                                        showZero: true
                                    }),
                                    (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Text, {
                                        children: "Total Clients Imported"
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $bb3TF.jsx)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                        title: "Bulk Assignments",
                        style: {
                            margin: '30px',
                            padding: 0
                        },
                        headStyle: {
                            textAlign: 'center'
                        },
                        size: "small",
                        bordered: false,
                        children: (0, $bb3TF.jsx)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                            style: {
                                display: 'flex',
                                justifyContent: 'center'
                            },
                            children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                justify: "center",
                                align: "middle",
                                gutter: 25,
                                children: [
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                            name: "sendInvitation",
                                            label: (0, $bb3TF.jsxs)("div", {
                                                children: [
                                                    "Send Invitation",
                                                    (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$InfoCircleOutlined, {
                                                        style: {
                                                            padding: '0 0 0 10px',
                                                            cursor: 'pointer'
                                                        },
                                                        onClick: (e)=>{
                                                            setIsModalOpen(true);
                                                            e.preventDefault();
                                                        }
                                                    })
                                                ]
                                            }),
                                            children: (0, $bb3TF.jsx)((0, $4fd303306a27e42e$export$2e2bcd8739ae039), {
                                                onChange: (check)=>{
                                                    if (check) setSelectedInvitations(clients.map((c)=>c.key));
                                                    else setSelectedInvitations([]);
                                                }
                                            })
                                        })
                                    }),
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                            name: "preparer",
                                            label: "Preparer",
                                            children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                                style: {
                                                    width: '200px'
                                                },
                                                placeholder: "Select a preparer",
                                                tool: true,
                                                allowClear: true,
                                                onSelect: onPreparerSelect,
                                                onChange: onPreparerSelect,
                                                children: preparers?.FirmTaxPreparers.map((item)=>(0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Option, {
                                                        value: item.id,
                                                        children: item.name
                                                    }, item.id))
                                            })
                                        })
                                    }),
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                            name: "jobType",
                                            label: "Job Type",
                                            children: (0, $bb3TF.jsx)((0, $89a92f440564d95a$export$2e2bcd8739ae039), {
                                                onChange: updateSelectedClients,
                                                style: {
                                                    width: '200px'
                                                },
                                                onSelect: (value)=>{
                                                    const newJobTypeValues = Object.assign({}, ...jobTypeFormNames.map((jtName)=>{
                                                        const map = new Map();
                                                        map.set(jtName, value);
                                                        return Object.fromEntries(map);
                                                    }));
                                                    tableForm.setFieldsValue(newJobTypeValues);
                                                    updateSelectedClients();
                                                }
                                            })
                                        })
                                    }),
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                            name: "taxYear",
                                            label: "Tax Year",
                                            rules: [
                                                {
                                                    required: true
                                                }
                                            ],
                                            children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                                onChange: updateSelectedClients,
                                                placeholder: "Select a tax year",
                                                children: $d0cd9ea7d92244eb$var$TAX_YEAR_OPTIONS.map(({ value: value, label: label })=>(0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Option, {
                                                        value: value,
                                                        children: label
                                                    }, value))
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "start",
                        align: "middle",
                        gutter: 15,
                        children: (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: [
                                (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                                    type: "link",
                                    size: "small",
                                    onClick: ()=>setSelectedRowKeys(clients.map((client)=>client.key)),
                                    children: "Select All"
                                }),
                                (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                                    type: "link",
                                    size: "small",
                                    onClick: ()=>setSelectedRowKeys([]),
                                    children: "Unselect All"
                                }),
                                clients.filter((client)=>client.isUpdate).length > 0 && (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                    color: "rgba(0, 0, 0, 0.85)",
                                    title: (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                                        children: [
                                            "Unselect all clients with an",
                                            ' ',
                                            (0, $bb3TF.jsx)("strong", {
                                                children: "Import Type"
                                            }),
                                            ' ',
                                            "of",
                                            ' ',
                                            (0, $bb3TF.jsx)("strong", {
                                                children: "Update"
                                            }),
                                            ' ',
                                            "(clients that are already on Taxaroo)."
                                        ]
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                                        type: "link",
                                        size: "small",
                                        onClick: ()=>{
                                            const selectedUpdates = selectedClients.filter((client)=>client.isUpdate);
                                            const selectedRowsNew = selectedRowKeys.filter((key)=>!selectedUpdates.some((client)=>client.key === key));
                                            setSelectedRowKeys(selectedRowsNew);
                                        },
                                        children: "Unselect All Updates"
                                    })
                                })
                            ]
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $2eb2b7b37988b8f9$export$2e2bcd8739ae039), {
                        columns: sortedColumns,
                        pagination: {
                            defaultPageSize: 10
                        },
                        dataSource: clients,
                        rowSelection: {
                            type: 'checkbox',
                            fixed: true,
                            columnWidth: 35,
                            ...rowSelection
                        },
                        scroll: {
                            x: 1800
                        },
                        // validate form on pagination change
                        onChange: (pagination)=>onPaginationChange(pagination)
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "start",
                        align: "middle",
                        children: [
                            (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Text, {
                                className: `${$14f5626472be376a$export$1cf2413a6e44709f} ${$14f5626472be376a$export$400082633f1f7338}`
                            }),
                            (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Text, {
                                children: "Details to be update"
                            })
                        ]
                    })
                ]
            }),
            (0, $bb3TF.jsxs)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
                visible: isModalOpen,
                onCancel: ()=>setIsModalOpen(false),
                okButtonProps: {
                    style: {
                        display: 'none'
                    }
                },
                cancelText: "Close",
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        children: (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Paragraph, {
                            children: "This email will be sent to your clients upon import"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {
                        style: {
                            margin: '0 0 20px 0'
                        }
                    }),
                    (0, $bb3TF.jsxs)($d0cd9ea7d92244eb$var$Paragraph, {
                        children: [
                            "From:",
                            ' ',
                            (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Text, {
                                strong: true,
                                children: "Your Firm Name"
                            })
                        ]
                    }),
                    (0, $bb3TF.jsxs)($d0cd9ea7d92244eb$var$Paragraph, {
                        children: [
                            "To:",
                            ' ',
                            (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Text, {
                                strong: true,
                                children: "Client Name"
                            })
                        ]
                    }),
                    (0, $bb3TF.jsxs)("div", {
                        style: {
                            paddingLeft: '30px'
                        },
                        children: [
                            (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Title, {
                                level: 4,
                                style: {
                                    margin: 0
                                },
                                children: "Account activation required in secure portal."
                            }),
                            (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Paragraph, {
                                children: "Please click on the activate button below to activate your account and begin using our secure client portal."
                            }),
                            (0, $bb3TF.jsx)($d0cd9ea7d92244eb$var$Paragraph, {
                                children: "You can use our secure portal on any device to exchange information, pay invoices, and electronically sign documents and more."
                            }),
                            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                justify: "center",
                                children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    onClick: ()=>setIsModalOpen(false),
                                    children: "Activate"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}; // end tableForm
var $d0cd9ea7d92244eb$export$2e2bcd8739ae039 = $d0cd9ea7d92244eb$var$TableForm;


const { Option: $6ba32ea8088dda77$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const { Title: $6ba32ea8088dda77$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { Item: $6ba32ea8088dda77$var$Item } = (0, $6ee812964d9db826$export$2e2bcd8739ae039);
const $6ba32ea8088dda77$export$d6ec2585aab3d343 = {
    address1: 'Address Line 1',
    address2: 'Address Line 2',
    city: 'City',
    dob: 'Date of Birth',
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    phones: 'Phone',
    zip: 'Postal Code',
    ssn: 'Social Security Number',
    state: 'State'
};
const $6ba32ea8088dda77$var$MapContacts = ({ mapForm: mapForm, parseResult: parseResult, setStepOneNextDisabled: setStepOneNextDisabled })=>{
    const values = mapForm.getFieldsValue(true);
    const initialPhoneTypesState = Object.assign({}, ...parseResult.meta.fields.map((fieldName)=>({
            [`phoneType_${fieldName}`]: values[`map_${fieldName}`] !== 'phones'
        })));
    const [phoneTypesHidden, setPhoneTypesHidden] = (0, $6fFrj.useState)(initialPhoneTypesState);
    const initialBadgeColorState = Object.assign({}, ...parseResult.meta.fields.map((fieldName)=>({
            [fieldName]: values[`map_${fieldName}`] ? (0, $d0cd9ea7d92244eb$export$d40014048739ecba).green : (0, $d0cd9ea7d92244eb$export$d40014048739ecba).orange
        })));
    const [badgeColor, setBadgeColor] = (0, $6fFrj.useState)(initialBadgeColorState);
    // Filter empty columns
    const filteredFieldsToMap = parseResult.meta.fields.filter((fieldName)=>parseResult.data.find((item)=>item[fieldName]?.trim()));
    const getPreviewInitialValue = (fieldName)=>{
        if (fieldName.toLowerCase().includes('date')) return parseResult.data.find((item)=>Boolean(item[fieldName]?.trim()) && (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(item[fieldName]).isValid())?.[fieldName].trim() || 'No date preview available';
        return parseResult.data.find((item)=>item[fieldName]?.trim())?.[fieldName].trim() || 'No preview available';
    };
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsxs)($6ba32ea8088dda77$var$Title, {
                level: 4,
                children: [
                    "The left column title is the column header from your spreadsheet.",
                    (0, $bb3TF.jsx)("br", {}),
                    "Select the matching Taxaroo field from the dropdown in the right column."
                ]
            }),
            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                layout: "vertical",
                form: mapForm,
                style: {
                    width: '100%'
                },
                onFieldsChange: (changedFields, allFields)=>{
                    if (changedFields[0].name[0].indexOf('map_') === 0) {
                        const fieldName = changedFields[0].name[0].replace('map_', '');
                        const mapFields = allFields.filter((f)=>f.name[0].indexOf('map_') === 0);
                        // enable/disable "Next" button
                        if (mapFields.some((mf)=>mf.value === 'firstName') && !mapFields.some((mf)=>mf.errors.length > 0)) setStepOneNextDisabled(false);
                        else setStepOneNextDisabled(true);
                        // remove duplicate prop selection
                        if (changedFields[0].value !== 'phones') {
                            const previousSelectedField = mapFields.find((mf)=>mf.value === changedFields[0].value && mf.name[0] !== changedFields[0].name[0]);
                            if (previousSelectedField) {
                                mapForm.setFieldsValue({
                                    [previousSelectedField.name]: ''
                                });
                                setBadgeColor((prevValues)=>({
                                        ...prevValues,
                                        [previousSelectedField.name[0].replace('map_', '')]: (0, $d0cd9ea7d92244eb$export$d40014048739ecba).orange
                                    }));
                            }
                        }
                        // hide/show phone types update badge color
                        setPhoneTypesHidden({
                            ...phoneTypesHidden,
                            [`phoneType_${fieldName}`]: changedFields[0].value !== 'phones'
                        });
                        setBadgeColor((prevValues)=>({
                                ...prevValues,
                                [fieldName]: changedFields[0].value ? (0, $d0cd9ea7d92244eb$export$d40014048739ecba).green : (0, $d0cd9ea7d92244eb$export$d40014048739ecba).orange
                            }));
                        // check if dob has valid format
                        if (changedFields[0].value === 'dob') {
                            const dobVal = mapForm.getFieldsValue([
                                `preview_${fieldName}`
                            ])?.[`preview_${fieldName}`];
                            if (dobVal) {
                                const val = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(dobVal);
                                if (!val.isValid()) {
                                    mapForm.setFields([
                                        {
                                            name: changedFields[0].name,
                                            errors: [
                                                'Date format is not recognized!'
                                            ]
                                        }
                                    ]);
                                    setBadgeColor((prevValues)=>({
                                            ...prevValues,
                                            [fieldName]: (0, $d0cd9ea7d92244eb$export$d40014048739ecba).red
                                        }));
                                    setStepOneNextDisabled(true);
                                }
                            }
                        } else mapForm.setFields([
                            {
                                name: changedFields[0].name,
                                errors: []
                            }
                        ]);
                    }
                },
                children: filteredFieldsToMap.map((fieldName, key)=>(0, $bb3TF.jsxs)("section", {
                        style: key > 0 ? {
                            paddingTop: '25px'
                        } : {},
                        children: [
                            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                children: (0, $bb3TF.jsxs)($6ba32ea8088dda77$var$Title, {
                                    level: 5,
                                    children: [
                                        (0, $bb3TF.jsx)((0, $0e541b76c0e3ec69$export$2e2bcd8739ae039), {
                                            dot: true,
                                            style: {
                                                backgroundColor: badgeColor[fieldName],
                                                margin: '0 10px 0 0'
                                            }
                                        }),
                                        fieldName
                                    ]
                                })
                            }),
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                gutter: [
                                    20,
                                    0
                                ],
                                children: [
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        style: {
                                            width: '40%'
                                        },
                                        children: (0, $bb3TF.jsx)($6ba32ea8088dda77$var$Item, {
                                            name: `preview_${fieldName}`,
                                            label: "Spreadsheet Record Preview",
                                            initialValue: getPreviewInitialValue(fieldName),
                                            children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                                disabled: true
                                            })
                                        })
                                    }),
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        style: {
                                            width: '38%'
                                        },
                                        children: (0, $bb3TF.jsx)($6ba32ea8088dda77$var$Item, {
                                            name: `map_${fieldName}`,
                                            label: "Taxaroo Contact Field",
                                            initialValue: "",
                                            children: (0, $bb3TF.jsxs)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                                showSearch: true,
                                                children: [
                                                    (0, $bb3TF.jsx)($6ba32ea8088dda77$var$Option, {
                                                        value: "",
                                                        children: "Do not import"
                                                    }),
                                                    Object.keys($6ba32ea8088dda77$export$d6ec2585aab3d343).map((field)=>(0, $bb3TF.jsx)($6ba32ea8088dda77$var$Option, {
                                                            value: field,
                                                            children: $6ba32ea8088dda77$export$d6ec2585aab3d343[field]
                                                        }, field))
                                                ]
                                            })
                                        })
                                    }),
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        style: {
                                            width: '22%'
                                        },
                                        children: (0, $bb3TF.jsx)($6ba32ea8088dda77$var$Item, {
                                            name: `phoneType_${fieldName}`,
                                            label: "Phone Type",
                                            initialValue: (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Mobile,
                                            hidden: phoneTypesHidden[`phoneType_${fieldName}`],
                                            children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                                children: Object.keys((0, $8f7fe33a44836803$export$a9572cd0d740fbfc)).map((type)=>(0, $bb3TF.jsx)($6ba32ea8088dda77$var$Option, {
                                                        value: (0, $8f7fe33a44836803$export$a9572cd0d740fbfc)[type],
                                                        children: type
                                                    }, type))
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }, key))
            })
        ]
    });
};
var $6ba32ea8088dda77$export$2e2bcd8739ae039 = $6ba32ea8088dda77$var$MapContacts;



const { UsergroupAddOutlined: $b93bb6993f5424c5$var$UsergroupAddOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Text: $b93bb6993f5424c5$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { Step: $b93bb6993f5424c5$var$Step } = (0, $226121d160d93575$export$2e2bcd8739ae039);
const $b93bb6993f5424c5$var$ImportClientsModal = ({ isModalVisible: isModalVisible, setIsModalVisible: setIsModalVisible })=>{
    const [csvParseResult, setCsvParseResult] = (0, $6fFrj.useState)();
    const [mapForm] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    const [tableForm] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    const [selectedRowKeys, setSelectedRowKeys] = (0, $6fFrj.useState)([]);
    const [selectedInvitations, setSelectedInvitations] = (0, $6fFrj.useState)([]);
    const [selectedClients, setSelectedClients] = (0, $6fFrj.useState)([]);
    const [currentStep, setCurrentStep] = (0, $6fFrj.useState)(0);
    const [stepOneNextDisabled, setStepOneNextDisabled] = (0, $6fFrj.useState)(true);
    const [uploaded, setUploaded] = (0, $6fFrj.useState)([]);
    const [importInProgress, setImportInProgress] = (0, $6fFrj.useState)(false);
    const [progressPercent, setProgressPercent] = (0, $6fFrj.useState)('0');
    const [formSubmittend, setFormSubmittend] = (0, $6fFrj.useState)(false);
    const abortController = (0, $6fFrj.useRef)(new AbortController());
    const handleOnError = (error)=>{
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message, 10);
    };
    const [validateClientsImport, { loading: validateClientsLoading }] = (0, $cfa9a099fb6315ad$export$b907fa095e71ccbd)({
        onError: handleOnError
    });
    const [importClientsMutation, { loading: importClientsLoading, reset: resetImportMutation }] = (0, $cfa9a099fb6315ad$export$c890badf4112c089)({
        onError: handleOnError,
        context: {
            fetchOptions: {
                signal: abortController.current.signal
            }
        }
    });
    const closeModal = async ()=>{
        if (importInProgress) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).warn('Import process was interrupted', 20);
            abortController.current.abort();
            await (0, $d9c9d80f653581ac$export$2e2bcd8739ae039).refetchQueries({
                include: [
                    (0, $732264f53056e08f$export$a3bc4d02ba9c53fe),
                    (0, $732264f53056e08f$export$d4e23f314f782a9d)
                ]
            });
            resetImportMutation();
        }
        setIsModalVisible(false);
        setSelectedClients([]);
        setSelectedInvitations([]);
        setSelectedRowKeys([]);
        setCurrentStep(0);
        setCsvParseResult(undefined);
        setUploaded([]);
        mapForm.resetFields();
        tableForm.resetFields();
        setFormSubmittend(false);
        setProgressPercent('0');
        setImportInProgress(false);
    };
    const updateSelectedClients = ()=>{
        const selected = uploaded.filter((c)=>selectedRowKeys.some((key)=>c.key === key));
        setSelectedClients(selected.map((c)=>({
                ...c,
                sendInvitation: selectedInvitations.some((inv)=>inv === c.key),
                preparer: tableForm.getFieldValue(`preparer_${c.key}`) || null,
                jobType: tableForm.getFieldValue(`jobType_${c.key}`),
                taxYear: Number(tableForm.getFieldValue('taxYear'))
            })));
        // remove errors from unselected fields
        const unSelected = uploaded.filter((c)=>!selectedRowKeys.some((key)=>c.key === key));
        tableForm.setFields(unSelected.map((c)=>({
                name: `jobType_${c.key}`,
                errors: []
            })));
    };
    const handleOK = async ()=>{
        setFormSubmittend(true);
        if (selectedClients.some((c)=>!c.taxYear) || selectedClients.some((c)=>!c.jobType)) {
            try {
                // shows validation errors
                await tableForm.validateFields([
                    'taxYear',
                    ...selectedClients.map((c)=>`jobType_${c.key}`)
                ]);
            } catch (err) {
                console.log(err);
            }
            setImportInProgress(false);
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Some required fields are missing', 10);
            return;
        }
        const clientsArray = selectedClients.map((c)=>({
                ...c,
                phones: c?.phones?.map((p)=>({
                        type: p.type,
                        value: p.value
                    })),
                __typename: undefined,
                key: undefined
            }));
        const each = 10;
        const wait = 5000;
        setImportInProgress(true);
        for(let i = 0; i < clientsArray.length; i += each){
            setProgressPercent(Number(i * 100 / clientsArray.length).toFixed(1));
            const chunk = clientsArray.slice(i, i + each);
            // eslint-disable-next-line no-await-in-loop
            await importClientsMutation({
                variables: {
                    clientsArray: chunk
                }
            });
            setProgressPercent(Number((i + each) * 100 / clientsArray.length).toFixed(1));
            // eslint-disable-next-line
            await new Promise((resolve)=>setTimeout(resolve, wait));
        }
        setImportInProgress(false);
        closeModal();
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Import Success', 15);
        await (0, $d9c9d80f653581ac$export$2e2bcd8739ae039).refetchQueries({
            include: [
                (0, $732264f53056e08f$export$a3bc4d02ba9c53fe),
                (0, $732264f53056e08f$export$d4e23f314f782a9d)
            ]
        });
    };
    const setUploadedFileObject = (result)=>{
        if (result.data.length) {
            setCsvParseResult(result);
            setCurrentStep(1);
        }
    };
    const validateMappedValues = async ()=>{
        const values = mapForm.getFieldsValue(true);
        const mapFields = Object.keys(values).filter((key)=>key.indexOf('map_') === 0).filter((key)=>values[key]);
        const clientsParsed = csvParseResult.data.map((c)=>{
            const result = {};
            mapFields.forEach((field)=>{
                const originalField = field.replace('map_', '');
                const value = c[originalField]?.trim();
                if (value) {
                    if (values[field] === 'phones') {
                        if (!Array.isArray(result.phones)) result.phones = [];
                        const replacedValue = value.replace(/[^0-9]/g, '');
                        if (replacedValue.length >= 10) result.phones.push({
                            value: replacedValue.length === 10 ? `+1${replacedValue}` : `+${replacedValue}`,
                            type: values[`phoneType_${originalField}`]
                        });
                    } else if (values[field] === 'dob') result[values[field]] = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0))).utc(value).toDate();
                    else if (values[field] === 'email') result[values[field]] = value.toLowerCase();
                    else result[values[field]] = value;
                }
            });
            return result;
        });
        const clientsArray = [];
        clientsParsed.filter((c)=>c.firstName).forEach((c)=>{
            if (!clientsArray.some((cli)=>cli.email && cli.email === c.email)) clientsArray.push(c);
        });
        const validateResult = await validateClientsImport({
            variables: {
                clientsArray: clientsArray
            }
        });
        if (validateResult.data?.ValidateClientsImport?.length) {
            setUploaded(validateResult.data.ValidateClientsImport.map((c, key)=>({
                    ...c,
                    key: key,
                    sendInvitation: false,
                    taxYear: c.taxYear || undefined,
                    jobType: c.jobType || undefined,
                    phones: c.phones?.map((p)=>({
                            id: String(key),
                            type: p.type,
                            value: p.value,
                            createAt: new Date(),
                            updateAt: new Date()
                        }))
                })));
            setCurrentStep(2);
        } else (0, $55c6005cab9be059$export$2e2bcd8739ae039).info('Validation result is empty. Please try to update your mapping.', 10);
    };
    const onPaginationChange = (pagination)=>{
        if (formSubmittend) // hack for validateFields to work
        setTimeout(async ()=>{
            try {
                await tableForm.validateFields([
                    'taxYear',
                    ...selectedClients.filter((c)=>Number(c.key) >= (pagination.current - 1) * pagination.pageSize && Number(c.key) <= pagination.current * pagination.pageSize).map((c)=>`jobType_${c.key}`)
                ]);
            } catch (err) {
                console.log(err);
            }
        }, 5);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (uploaded.length) setSelectedRowKeys(uploaded.map((c)=>c.key)); // select all table rows
        // should reset form on clients change to prevent form values from caching
        tableForm.resetFields();
    }, [
        uploaded
    ]);
    (0, $6fFrj.useEffect)(()=>{
        updateSelectedClients();
    }, [
        selectedRowKeys,
        selectedInvitations
    ]);
    return (0, $bb3TF.jsxs)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        title: (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
            children: [
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    children: (0, $bb3TF.jsx)($b93bb6993f5424c5$var$Text, {
                        children: "Import Clients"
                    })
                }),
                (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {}),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    children: (0, $bb3TF.jsxs)((0, $226121d160d93575$export$2e2bcd8739ae039), {
                        current: currentStep,
                        size: "small",
                        children: [
                            (0, $bb3TF.jsx)($b93bb6993f5424c5$var$Step, {
                                title: "Upload",
                                status: currentStep === 0 ? 'current' : 'process'
                            }),
                            (0, $bb3TF.jsx)($b93bb6993f5424c5$var$Step, {
                                title: "Map Contacts",
                                status: currentStep === 1 ? 'current' : currentStep < 1 ? 'wait' : 'process'
                            }),
                            (0, $bb3TF.jsx)($b93bb6993f5424c5$var$Step, {
                                title: "Review",
                                status: currentStep === 2 ? 'current' : 'wait'
                            })
                        ]
                    })
                })
            ]
        }),
        visible: isModalVisible,
        footer: Boolean(currentStep === 1) && (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: stepOneNextDisabled ? 'Client first name is required' : '',
            children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 20,
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            disabled: validateClientsLoading,
                            onClick: ()=>{
                                setCsvParseResult(undefined);
                                setCurrentStep(0);
                                mapForm.resetFields();
                                setFormSubmittend(false);
                                setProgressPercent('0');
                            },
                            children: "Back"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "primary",
                            disabled: stepOneNextDisabled,
                            onClick: validateMappedValues,
                            loading: validateClientsLoading,
                            children: "Next"
                        })
                    })
                ]
            })
        }) || Boolean(currentStep === 2) && !importInProgress && (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            justify: "end",
            gutter: 20,
            children: [
                (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        disabled: importClientsLoading,
                        onClick: ()=>{
                            setUploaded([]);
                            setCurrentStep(1);
                            setSelectedClients([]);
                            setSelectedInvitations([]);
                            tableForm.resetFields();
                            setFormSubmittend(false);
                            setProgressPercent('0');
                        },
                        children: "Back"
                    })
                }),
                (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    children: (0, $bb3TF.jsx)((0, $a361442371f1d4e9$export$2e2bcd8739ae039), {
                        title: "Are you sure? This action is non reversible.",
                        onConfirm: handleOK,
                        okText: "Yes",
                        cancelText: "No",
                        placement: "topRight",
                        disabled: !selectedClients.length,
                        children: (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                            type: "primary",
                            icon: (0, $bb3TF.jsx)($b93bb6993f5424c5$var$UsergroupAddOutlined, {}),
                            disabled: !selectedClients.length,
                            loading: importClientsLoading,
                            children: (0, $bb3TF.jsx)($b93bb6993f5424c5$var$Text, {
                                style: {
                                    color: '#fff'
                                },
                                children: "Import"
                            })
                        })
                    })
                })
            ]
        }) || null,
        onCancel: closeModal,
        width: "75%",
        children: [
            Boolean(currentStep === 0) && (0, $bb3TF.jsx)((0, $4f9d64056079d842$export$2e2bcd8739ae039), {
                setUploaded: setUploadedFileObject,
                handleOnError: handleOnError
            }),
            Boolean(currentStep === 1) && (0, $bb3TF.jsx)((0, $6ba32ea8088dda77$export$2e2bcd8739ae039), {
                mapForm: mapForm,
                parseResult: csvParseResult,
                setStepOneNextDisabled: setStepOneNextDisabled
            }),
            Boolean(currentStep === 2) && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                children: [
                    (0, $bb3TF.jsx)((0, $d0cd9ea7d92244eb$export$2e2bcd8739ae039), {
                        tableForm: tableForm,
                        clients: uploaded,
                        selectedRowKeys: selectedRowKeys,
                        setSelectedRowKeys: setSelectedRowKeys,
                        selectedInvitations: selectedInvitations,
                        setSelectedInvitations: setSelectedInvitations,
                        selectedClients: selectedClients,
                        updateSelectedClients: updateSelectedClients,
                        onPaginationChange: onPaginationChange
                    }),
                    importInProgress && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                        children: [
                            (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {}),
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $bb3TF.jsx)($b93bb6993f5424c5$var$Text, {
                                        small: true,
                                        children: "Clients import is in progress and this process may take a few minutes. Please do not close this window or your import process will be interrupted."
                                    }),
                                    (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                                        size: "small",
                                        style: {
                                            paddingLeft: '20px'
                                        }
                                    })
                                ]
                            }),
                            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                children: (0, $bb3TF.jsx)((0, $35ec803a48e00dda$export$2e2bcd8739ae039), {
                                    percent: progressPercent,
                                    strokeColor: {
                                        '0%': (0, $d0cd9ea7d92244eb$export$d40014048739ecba).blue,
                                        '100%': (0, $d0cd9ea7d92244eb$export$d40014048739ecba).green
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $b93bb6993f5424c5$export$2e2bcd8739ae039 = $b93bb6993f5424c5$var$ImportClientsModal;


var $618d19b065f8dace$export$2e2bcd8739ae039 = (0, $b93bb6993f5424c5$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");
function $ee7cc8087afe0cb7$export$b10e3d92c03f6472(rv) {
    var value = rv();
    var setValue = (0, $6fFrj.useState)(value)[1];
    (0, $6fFrj.useEffect)(function() {
        var probablySameValue = rv();
        if (value !== probablySameValue) setValue(probablySameValue);
        else return rv.onNextChange(setValue);
    }, [
        value
    ]);
    return value;
}





// import * as styles from './styles.module.css';
const { CloseOutlined: $1cad7e5f5a394fbc$var$CloseOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $1cad7e5f5a394fbc$var$HamburgerMenu() {
    const isHamburgerMenuOpen = (0, $ee7cc8087afe0cb7$export$b10e3d92c03f6472)((0, $d2dcc1acacbd89bc$export$c16848faee2ad07b));
    return (0, $bb3TF.jsx)((0, $67e53ef2d660b7d8$export$2e2bcd8739ae039), {
        // title="Taxaroo"
        placement: "left",
        onClose: ()=>(0, $d2dcc1acacbd89bc$export$c16848faee2ad07b)(false),
        visible: isHamburgerMenuOpen,
        bodyStyle: {
            zoom: '1.2',
            backgroundColor: 'var(--primary-dark)',
            padding: '5px'
        },
        closeIcon: (0, $bb3TF.jsx)($1cad7e5f5a394fbc$var$CloseOutlined, {
            style: {
                color: 'white'
            }
        }),
        forceRender: true,
        children: (0, $bb3TF.jsx)((0, $ca186f7b6f461205$export$2e2bcd8739ae039), {})
    });
}
var $1cad7e5f5a394fbc$export$2e2bcd8739ae039 = $1cad7e5f5a394fbc$var$HamburgerMenu;



var $bb3TF = parcelRequire("bb3TF");

const { PlusOutlined: $e8bc3158ef462033$var$PlusOutlined, UserAddOutlined: $e8bc3158ef462033$var$UserAddOutlined, CloudUploadOutlined: $e8bc3158ef462033$var$CloudUploadOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { SubMenu: $e8bc3158ef462033$var$SubMenu, Item: $e8bc3158ef462033$var$Item } = (0, $cd46f582474e92de$export$2e2bcd8739ae039);
function $e8bc3158ef462033$var$AddSubMenu(props) {
    return (0, $bb3TF.jsxs)($e8bc3158ef462033$var$SubMenu, {
        icon: (0, $bb3TF.jsx)($e8bc3158ef462033$var$PlusOutlined, {}),
        title: "Add",
        ...props,
        children: [
            (0, $bb3TF.jsx)($e8bc3158ef462033$var$Item, {
                icon: (0, $bb3TF.jsx)($e8bc3158ef462033$var$UserAddOutlined, {}),
                children: "Add Client"
            }, "add-client"),
            (0, $bb3TF.jsx)($e8bc3158ef462033$var$Item, {
                icon: (0, $bb3TF.jsx)($e8bc3158ef462033$var$CloudUploadOutlined, {}),
                children: "Import Clients"
            }, "import-clients")
        ]
    });
}
var $e8bc3158ef462033$export$2e2bcd8739ae039 = $e8bc3158ef462033$var$AddSubMenu;



var $bb3TF = parcelRequire("bb3TF");

var $e5d97db34ea1eaf8$exports = {};
// TinyColor v1.4.2
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
(function(Math1) {
    var trimLeft = /^\s+/, trimRight = /\s+$/, tinyCounter = 0, mathRound = Math1.round, mathMin = Math1.min, mathMax = Math1.max, mathRandom = Math1.random;
    function tinycolor(color, opts) {
        color = color ? color : '';
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = mathRound(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = mathRound(this._r);
        if (this._g < 1) this._g = mathRound(this._g);
        if (this._b < 1) this._b = mathRound(this._b);
        this._ok = rgb.ok;
        this._tc_id = tinyCounter++;
    }
    tinycolor.prototype = {
        isDark: function() {
            return this.getBrightness() < 128;
        },
        isLight: function() {
            return !this.isDark();
        },
        isValid: function() {
            return this._ok;
        },
        getOriginalInput: function() {
            return this._originalInput;
        },
        getFormat: function() {
            return this._format;
        },
        getAlpha: function() {
            return this._a;
        },
        getBrightness: function() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math1.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math1.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math1.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function(value) {
            this._a = boundAlpha(value);
            this._roundA = mathRound(100 * this._a) / 100;
            return this;
        },
        toHsv: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function(allow3Char) {
            return '#' + this.toHex(allow3Char);
        },
        toHex8: function(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function(allow4Char) {
            return '#' + this.toHex8(allow4Char);
        },
        toRgb: function() {
            return {
                r: mathRound(this._r),
                g: mathRound(this._g),
                b: mathRound(this._b),
                a: this._a
            };
        },
        toRgbString: function() {
            return this._a == 1 ? "rgb(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" : "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function() {
            return {
                r: mathRound(bound01(this._r, 255) * 100) + "%",
                g: mathRound(bound01(this._g, 255) * 100) + "%",
                b: mathRound(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function() {
            return this._a == 1 ? "rgb(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" : "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function(secondColor) {
            var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function() {
            return tinycolor(this.toString());
        },
        _applyModification: function(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function() {
            return this._applyModification(lighten, arguments);
        },
        brighten: function() {
            return this._applyModification(brighten, arguments);
        },
        darken: function() {
            return this._applyModification(darken, arguments);
        },
        desaturate: function() {
            return this._applyModification(desaturate, arguments);
        },
        saturate: function() {
            return this._applyModification(saturate, arguments);
        },
        greyscale: function() {
            return this._applyModification(greyscale, arguments);
        },
        spin: function() {
            return this._applyModification(spin, arguments);
        },
        _applyCombination: function(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function() {
            return this._applyCombination(analogous, arguments);
        },
        complement: function() {
            return this._applyCombination(complement, arguments);
        },
        monochromatic: function() {
            return this._applyCombination(monochromatic, arguments);
        },
        splitcomplement: function() {
            return this._applyCombination(splitcomplement, arguments);
        },
        triad: function() {
            return this._applyCombination(triad, arguments);
        },
        tetrad: function() {
            return this._applyCombination(tetrad, arguments);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (typeof color == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (typeof color == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: mathMin(255, mathMax(rgb.r, 0)),
            g: mathMin(255, mathMax(rgb.g, 0)),
            b: mathMin(255, mathMax(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math1.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: mathRandom(),
            g: mathRandom(),
            b: mathRandom()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * -(amount / 100))));
        rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * -(amount / 100))));
        rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function triad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 120) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 240) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function tetrad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 90) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 180) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 270) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math1.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math1.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            "level": level,
            "size": size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <http://www.w3.org/TR/css3-color/#svg-color>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = mathMin(max, mathMax(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math1.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return mathMin(1, mathMax(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf('%') != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? '0' + c : '' + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math1.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, '').replace(trimRight, '').toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == 'transparent') return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            "level": "AA",
            "size": "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            "level": level,
            "size": size
        };
    }
    // Node: Export function
    if (0, $e5d97db34ea1eaf8$exports) $e5d97db34ea1eaf8$exports = tinycolor;
    else if (typeof define === 'function' && define.amd) define(function() {
        return tinycolor;
    });
    else window.tinycolor = tinycolor;
})(Math);




var $325680c80e0162e7$export$749ac0d68f68b03;
var $325680c80e0162e7$export$b195012dce46ca27;
var $325680c80e0162e7$export$510d93bcecb7d0cc;
var $325680c80e0162e7$export$b2fd85dcf8c89af0;
var $325680c80e0162e7$export$57d427e385b3f1a5;
var $325680c80e0162e7$export$97544b54418496fb;
var $325680c80e0162e7$export$2743ffd0de5ae4e9;
var $325680c80e0162e7$export$38e42c68cf43b5d4;
var $325680c80e0162e7$export$9e1e0e435ec33284;
var $325680c80e0162e7$export$770fb48d018dbaef;
var $325680c80e0162e7$export$db3c28d99448dcff;
var $325680c80e0162e7$export$749836926ab56706;
var $325680c80e0162e7$export$998c3e4280407604;
$325680c80e0162e7$export$749ac0d68f68b03 = `s3-D5q_ant-list-item-action`;
$325680c80e0162e7$export$b195012dce46ca27 = `s3-D5q_ant-list-item-meta-content`;
$325680c80e0162e7$export$510d93bcecb7d0cc = `s3-D5q_ant-menu-dark`;
$325680c80e0162e7$export$b2fd85dcf8c89af0 = `s3-D5q_ant-menu-horizontal`;
$325680c80e0162e7$export$57d427e385b3f1a5 = `s3-D5q_ant-menu-item`;
$325680c80e0162e7$export$97544b54418496fb = `s3-D5q_ant-menu-item-disabled`;
$325680c80e0162e7$export$2743ffd0de5ae4e9 = `s3-D5q_hamburgerWrapper`;
$325680c80e0162e7$export$38e42c68cf43b5d4 = `s3-D5q_header`;
$325680c80e0162e7$export$9e1e0e435ec33284 = `s3-D5q_headerShrink`;
$325680c80e0162e7$export$770fb48d018dbaef = `s3-D5q_inviteLinkItem`;
$325680c80e0162e7$export$db3c28d99448dcff = `s3-D5q_logo`;
$325680c80e0162e7$export$749836926ab56706 = `s3-D5q_noAnimation`;
$325680c80e0162e7$export$998c3e4280407604 = `s3-D5q_topHeader`;


const { SubMenu: $513eaa6d00dcbb3e$var$SubMenu, Item: $513eaa6d00dcbb3e$var$Item } = (0, $cd46f582474e92de$export$2e2bcd8739ae039);
function $513eaa6d00dcbb3e$var$AvatarSubMenu(props) {
    const { firstName: firstName, previousAccessToken: previousAccessToken } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const firstLetter = firstName.charAt(0);
    const { data: customLayoutData, loading: loadingCustomLayoutQuery } = (0, $732264f53056e08f$export$a9d926e7a1510ac6)();
    const { CustomLayout: CustomLayout } = customLayoutData || {};
    const headerBackgroundColor = CustomLayout?.headerBackgroundColor || '#f5f5f5';
    // lets set a color for the firstLetter
    // first try white
    let color = 'white';
    const readability = (0, (/*@__PURE__*/$parcel$interopDefault($e5d97db34ea1eaf8$exports))).readability(headerBackgroundColor, color);
    // if readability is poor
    if (readability < 2) // if it's not readable, try darker color
    color = (0, (/*@__PURE__*/$parcel$interopDefault($e5d97db34ea1eaf8$exports))).mostReadable(headerBackgroundColor, [
        (0, (/*@__PURE__*/$parcel$interopDefault($e5d97db34ea1eaf8$exports)))(headerBackgroundColor).darken(25).toString(),
        (0, (/*@__PURE__*/$parcel$interopDefault($e5d97db34ea1eaf8$exports)))(headerBackgroundColor).darken(37).toString(),
        (0, (/*@__PURE__*/$parcel$interopDefault($e5d97db34ea1eaf8$exports)))(headerBackgroundColor).darken(50).toString()
    ]).toHexString();
    // if background color is is white we need to use black
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e5d97db34ea1eaf8$exports)))(headerBackgroundColor).toHexString() === '#ffffff') color = 'black';
    return (0, $bb3TF.jsxs)($513eaa6d00dcbb3e$var$SubMenu, {
        className: $325680c80e0162e7$export$749836926ab56706,
        icon: (0, $bb3TF.jsx)((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
            // style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}
            style: {
                color: color,
                backgroundColor: headerBackgroundColor === '#ffffff' ? '#f5f5f5' : headerBackgroundColor
            },
            children: firstLetter.toUpperCase()
        }),
        ...props,
        children: [
            previousAccessToken && (0, $bb3TF.jsx)($513eaa6d00dcbb3e$var$Item, {
                children: "\u2190 Return to your account"
            }, "return-to-account"),
            (0, $bb3TF.jsx)($513eaa6d00dcbb3e$var$Item, {
                children: "Logout"
            }, "logout")
        ]
    });
}
var $513eaa6d00dcbb3e$export$2e2bcd8739ae039 = $513eaa6d00dcbb3e$var$AvatarSubMenu;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");





var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

const { CopyOutlined: $19603d7a6afc475f$var$CopyOutlined, CheckOutlined: $19603d7a6afc475f$var$CheckOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $19603d7a6afc475f$var$CopyButtonWithTooltip = ({ copyText: copyText })=>{
    const [tooltipTitle, setTooltipTitle] = (0, $6fFrj.useState)('Copy');
    const onCopy = (event)=>{
        event.stopPropagation();
        navigator.clipboard.writeText(copyText);
        setTooltipTitle('Copied!');
        setTimeout(()=>{
            setTooltipTitle('Copy');
        }, 1000);
    };
    return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        title: tooltipTitle,
        children: tooltipTitle === 'Copy' ? (0, $bb3TF.jsx)($19603d7a6afc475f$var$CopyOutlined, {
            onClick: onCopy
        }) : (0, $bb3TF.jsx)($19603d7a6afc475f$var$CheckOutlined, {
            style: {
                color: 'green'
            }
        })
    });
};
var $19603d7a6afc475f$export$2e2bcd8739ae039 = $19603d7a6afc475f$var$CopyButtonWithTooltip;


const { LinkOutlined: $12a59ac4b5eb9d71$var$LinkOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { useBreakpoint: $12a59ac4b5eb9d71$var$useBreakpoint } = (0, $89d88a41b53d163f$export$2e2bcd8739ae039);
const { SubMenu: $12a59ac4b5eb9d71$var$SubMenu, Item: $12a59ac4b5eb9d71$var$Item } = (0, $cd46f582474e92de$export$2e2bcd8739ae039);
const { Text: $12a59ac4b5eb9d71$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
function $12a59ac4b5eb9d71$var$InviteSubMenu(props) {
    const screens = $12a59ac4b5eb9d71$var$useBreakpoint();
    const [baseLink, setBaseLink] = (0, $6fFrj.useState)(`${"https://client.taxaroo.com"}/invite`);
    const [savedFirmLink, setSavedFirmLink] = (0, $6fFrj.useState)(null);
    const [savedPersonalLink, setSavedPersonalLink] = (0, $6fFrj.useState)(null);
    const { firmAccountId: firmAccountId, userId: userId } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    // graphql to get the custom domain
    const { data: customDomainUserData, loading: loadingCustomDomainUser } = (0, $732264f53056e08f$export$bd03447e34c3ce51)();
    const { CustomDomainUser: CustomDomainUser } = customDomainUserData || {};
    // graphql query to get the firm invite link
    const { data: customUserUniqueLinkData, loading: loadingUserUniqueLink } = (0, $732264f53056e08f$export$67e1b8b3789d08d)({
        variables: {
            id: userId
        }
    });
    // graphql query to get the user invite link
    const { data: customFirmUniqueLinkData, loading: loadingFirmUniqueLink } = (0, $732264f53056e08f$export$9f81c3500d5c21a0)({
        variables: {
            id: firmAccountId
        }
    });
    // check if custom domain is live
    const { data: domainLiveData } = (0, $732264f53056e08f$export$45a0043ce976ac16)({
        skip: !CustomDomainUser?.name,
        variables: {
            url: CustomDomainUser?.name
        }
    });
    const { IsDomainLive: isDomainLive } = domainLiveData || {};
    (0, $6fFrj.useEffect)(()=>{
        if (!isDomainLive) // if custom domain is not working
        // we need to show default invite link
        setBaseLink(`${"https://client.taxaroo.com" ?? 'https://client.taxaroo.com'}/invite`);
        else setBaseLink(`https://${CustomDomainUser?.name}/invite`);
    }, [
        isDomainLive
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (customFirmUniqueLinkData) {
            if (customFirmUniqueLinkData.FirmAccountById) {
                const { id: id, uniqueLink: uniqueLink } = customFirmUniqueLinkData.FirmAccountById;
                if (uniqueLink) setSavedFirmLink(uniqueLink);
                else setSavedFirmLink(id);
            }
        }
    }, [
        customFirmUniqueLinkData
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (customUserUniqueLinkData) {
            if (customUserUniqueLinkData.UserById) {
                const { uniqueLink: uniqueLink } = customUserUniqueLinkData.UserById;
                if (uniqueLink) setSavedPersonalLink(uniqueLink);
                else setSavedPersonalLink(userId);
            }
        }
    }, [
        customUserUniqueLinkData
    ]);
    const inviteLinks = [
        {
            name: 'Firm Invite Link',
            value: `${baseLink}/${savedFirmLink}`
        },
        {
            name: 'Personal Invite Link',
            value: `${baseLink}/${savedFirmLink}/${savedPersonalLink}`
        }
    ];
    const handleClick = (key)=>{
        // find which one clicked
        const theOneClicked = inviteLinks.filter((e)=>e.name === key)[0];
        if (theOneClicked && window) {
            const newWindow = window.open(theOneClicked.value, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
                Title: 'Invite link top menu',
                Source: 'Link click',
                value: theOneClicked.name,
                url: window.location.href
            });
        }
    };
    return (0, $bb3TF.jsx)($12a59ac4b5eb9d71$var$SubMenu, {
        icon: (0, $bb3TF.jsx)($12a59ac4b5eb9d71$var$LinkOutlined, {}),
        title: "Invite",
        // className={styles.inviteSubMenu}
        onClick: (e)=>handleClick(e.key),
        ...props,
        children: inviteLinks.map((item)=>(0, $bb3TF.jsx)($12a59ac4b5eb9d71$var$Item, {
                children: (0, $bb3TF.jsx)((0, $550318ddff00815a$export$2e2bcd8739ae039), {
                    itemLayout: screens.xs ? 'vertical' : 'horizontal',
                    style: {
                        padding: '0 10px'
                    },
                    children: (0, $bb3TF.jsx)((0, $550318ddff00815a$export$2e2bcd8739ae039).Item, {
                        actions: [
                            (0, $bb3TF.jsx)("span", {
                                onMouseDown: ()=>{
                                    (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
                                        Title: 'Invite link top menu',
                                        Source: 'Copy button click',
                                        value: item.name,
                                        url: window.location.href
                                    });
                                },
                                "aria-hidden": "true",
                                children: (0, $bb3TF.jsx)((0, $19603d7a6afc475f$export$2e2bcd8739ae039), {
                                    copyText: item.value
                                })
                            })
                        ],
                        children: (0, $bb3TF.jsx)($12a59ac4b5eb9d71$var$Text, {
                            style: {
                                paddingRight: '10px'
                            },
                            children: item.name
                        })
                    }, `invite-list-item-${item.name}`)
                }, `list-${item.name}`)
            }, item.name))
    });
}
var $12a59ac4b5eb9d71$export$2e2bcd8739ae039 = $12a59ac4b5eb9d71$var$InviteSubMenu;



const { useBreakpoint: $88deb7406c310004$var$useBreakpoint } = (0, $89d88a41b53d163f$export$2e2bcd8739ae039);
const { MenuOutlined: $88deb7406c310004$var$MenuOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Header: $88deb7406c310004$var$Header } = (0, $0102c485edc5bdcf$export$2e2bcd8739ae039);
function $88deb7406c310004$var$TopHeader() {
    const { accessToken: accessToken } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$ca779d385d6ad982));
    const pusher = new (0, $8e6a5083674a4148$export$beef90f2411195d8)(accessToken);
    const screens = $88deb7406c310004$var$useBreakpoint();
    // const [hamburgerMenuOpen, setHamburgerMenuOpen] = useState(false);
    const [shrink, setShrink] = (0, $6fFrj.useState)(false);
    const [isAddClientModalVisible, setIsAddClientModalVisible] = (0, $6fFrj.useState)(false);
    const [isImportClientsModalVisible, setIsImportClientsModalVisible] = (0, $6fFrj.useState)(false);
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    if (accessToken) (0, $dfc6a33c14790f87$export$eae5917686cce945)();
    const [returnToAccount] = (0, $edf372aa0dea9531$export$5c66c0f66bf05ea5)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`Return to account error: ${err.message}`, 5)
    });
    const location = (0, $990f835fb2356f36$export$45d76561a5302f2b)();
    let { search: search } = location;
    search = search.replace('?', '');
    let action = null;
    try {
        const paramsObj = JSON.parse(`{"${decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')}"}`);
        action = paramsObj.action;
    } catch (error) {}
    (0, $6fFrj.useEffect)(()=>{
        (0, $dfc6a33c14790f87$export$92ab14d0aa42e41e)();
    }, [
        location.pathname
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (action === 'addClient') setIsAddClientModalVisible(true);
        if (action === 'importClients') setIsImportClientsModalVisible(true);
    }, [
        action,
        setIsAddClientModalVisible,
        setIsImportClientsModalVisible
    ]);
    // const uniqueId = location?.state?.params?.uniqueId
    const onScroll = (e)=>{
        if (window.scrollY > 20) setShrink(true);
        if (window.scrollY < 2) setShrink(false);
    };
    // Detect Scroll Past Point
    (0, $6fFrj.useEffect)(()=>{
        window.addEventListener('scroll', onScroll, false);
        return ()=>window.removeEventListener('scroll', onScroll, false);
    }, []);
    const handleReturnToAccount = async ()=>{
        const result = await returnToAccount();
        if (result.data?.ReturnToAccount.accessToken) {
            const { accessToken: accessTokenReturnToAccount, UserFirmAccount: UserFirmAccount } = result.data.ReturnToAccount;
            (0, $bc55ebad68166096$export$4001836ab2b836f2)(dispatch, accessTokenReturnToAccount, UserFirmAccount);
            dispatch((0, $e3b9937a336ce5aa$export$940f9a34d01c641a)({
                accessToken: undefined
            }));
            navigate('/', {
                replace: true
            });
        }
    };
    const onClick = ({ key: key })=>{
        if (key === 'add-client') {
            setIsAddClientModalVisible(true);
            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).MODAL_SHOW, {
                'Modal Title': 'Add client modal',
                Source: 'Click from top menu',
                url: window.location.href
            });
        } else if (key === 'import-clients') {
            setIsImportClientsModalVisible(true);
            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).MODAL_SHOW, {
                'Modal Title': 'Import clients modal',
                Source: 'Click from top menu',
                url: window.location.href
            });
        } else if (key === 'logout') {
            if (pusher.connection.state === 'connected') pusher.disconnect();
            (0, $dfc6a33c14790f87$export$1e0a7af4e6017e75)();
            dispatch((0, $e3b9937a336ce5aa$export$b5d16ddcd70241c7)());
            dispatch((0, $59a61dbb6cd2676b$export$28052446e33b6b86)());
            dispatch((0, $af02328711f8c5fd$export$95c2dcacae3679d3)());
            dispatch((0, $66a7cecdd31d321f$export$43119c4be593e906)());
        } else if (key === 'return-to-account') handleReturnToAccount();
    };
    return (0, $bb3TF.jsxs)($88deb7406c310004$var$Header, {
        id: $325680c80e0162e7$export$998c3e4280407604,
        className: `${$325680c80e0162e7$export$38e42c68cf43b5d4} ${!shrink && 'elevated'} ${shrink && $325680c80e0162e7$export$9e1e0e435ec33284}`,
        children: [
            !screens.md ? (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                children: [
                    (0, $bb3TF.jsxs)("div", {
                        className: $325680c80e0162e7$export$2743ffd0de5ae4e9,
                        children: [
                            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                icon: (0, $bb3TF.jsx)($88deb7406c310004$var$MenuOutlined, {}),
                                onClick: ()=>(0, $d2dcc1acacbd89bc$export$c16848faee2ad07b)(true)
                            }),
                            (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: (0, $bb3TF.jsx)((0, $1cbcb18aa67bf12c$export$2e2bcd8739ae039), {
                                    className: $325680c80e0162e7$export$db3c28d99448dcff
                                })
                            })
                        ]
                    }),
                    (0, $bb3TF.jsx)((0, $1cad7e5f5a394fbc$export$2e2bcd8739ae039), {})
                ]
            }) : (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                to: "/",
                children: (0, $bb3TF.jsx)((0, $1cbcb18aa67bf12c$export$2e2bcd8739ae039), {
                    className: $325680c80e0162e7$export$db3c28d99448dcff
                })
            }),
            (0, $bb3TF.jsx)("div", {
                style: {
                    width: '100%'
                },
                children: (0, $bb3TF.jsxs)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
                    mode: "horizontal",
                    theme: "light",
                    onClick: onClick,
                    selectable: false,
                    style: {
                        display: 'flex'
                    },
                    children: [
                        (0, $bb3TF.jsx)((0, $e8bc3158ef462033$export$2e2bcd8739ae039), {}, "AddSubMenu"),
                        (0, $bb3TF.jsx)((0, $12a59ac4b5eb9d71$export$2e2bcd8739ae039), {}, "InviteSubMenu"),
                        (0, $bb3TF.jsx)((0, $513eaa6d00dcbb3e$export$2e2bcd8739ae039), {}, "AvatarSubMenu")
                    ]
                })
            }),
            (0, $bb3TF.jsx)((0, $2d52d8d286e39b3a$export$2e2bcd8739ae039), {
                isModalVisible: isAddClientModalVisible,
                setIsModalVisible: setIsAddClientModalVisible
            }),
            (0, $bb3TF.jsx)((0, $618d19b065f8dace$export$2e2bcd8739ae039), {
                isModalVisible: isImportClientsModalVisible,
                setIsModalVisible: setIsImportClientsModalVisible
            })
        ]
    });
}
var $88deb7406c310004$export$2e2bcd8739ae039 = $88deb7406c310004$var$TopHeader;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");
var $c8ea7419494febdf$exports = {};
typeof navigator !== "undefined" && function(global, factory) {
    $c8ea7419494febdf$exports = factory();
}($c8ea7419494febdf$exports, function() {
    'use strict';
    var svgNS = 'http://www.w3.org/2000/svg';
    var locationHref = '';
    var _useWebWorker = false;
    var initialDefaultFrame = -999999;
    var setWebWorker = function setWebWorker(flag) {
        _useWebWorker = !!flag;
    };
    var getWebWorker = function getWebWorker() {
        return _useWebWorker;
    };
    var setLocationHref = function setLocationHref(value) {
        locationHref = value;
    };
    var getLocationHref = function getLocationHref() {
        return locationHref;
    };
    function createTag(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElement(type);
    }
    function extendPrototype(sources, destination) {
        var i;
        var len = sources.length;
        var sourcePrototype;
        for(i = 0; i < len; i += 1){
            sourcePrototype = sources[i].prototype;
            for(var attr in sourcePrototype)if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
        }
    }
    function getDescriptor(object, prop) {
        return Object.getOwnPropertyDescriptor(object, prop);
    }
    function createProxyFunction(prototype) {
        function ProxyFunction() {}
        ProxyFunction.prototype = prototype;
        return ProxyFunction;
    }
    // import Howl from '../../3rd_party/howler';
    var audioControllerFactory = function() {
        function AudioController(audioFactory) {
            this.audios = [];
            this.audioFactory = audioFactory;
            this._volume = 1;
            this._isMuted = false;
        }
        AudioController.prototype = {
            addAudio: function addAudio(audio) {
                this.audios.push(audio);
            },
            pause: function pause() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].pause();
            },
            resume: function resume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].resume();
            },
            setRate: function setRate(rateValue) {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].setRate(rateValue);
            },
            createAudio: function createAudio(assetPath) {
                if (this.audioFactory) return this.audioFactory(assetPath);
                if (window.Howl) return new window.Howl({
                    src: [
                        assetPath
                    ]
                });
                return {
                    isPlaying: false,
                    play: function play() {
                        this.isPlaying = true;
                    },
                    seek: function seek() {
                        this.isPlaying = false;
                    },
                    playing: function playing() {},
                    rate: function rate() {},
                    setVolume: function setVolume() {}
                };
            },
            setAudioFactory: function setAudioFactory(audioFactory) {
                this.audioFactory = audioFactory;
            },
            setVolume: function setVolume(value) {
                this._volume = value;
                this._updateVolume();
            },
            mute: function mute() {
                this._isMuted = true;
                this._updateVolume();
            },
            unmute: function unmute() {
                this._isMuted = false;
                this._updateVolume();
            },
            getVolume: function getVolume() {
                return this._volume;
            },
            _updateVolume: function _updateVolume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
            }
        };
        return function() {
            return new AudioController();
        };
    }();
    var createTypedArray = function() {
        function createRegularArray(type, len) {
            var i = 0;
            var arr = [];
            var value;
            switch(type){
                case 'int16':
                case 'uint8c':
                    value = 1;
                    break;
                default:
                    value = 1.1;
                    break;
            }
            for(i = 0; i < len; i += 1)arr.push(value);
            return arr;
        }
        function createTypedArrayFactory(type, len) {
            if (type === 'float32') return new Float32Array(len);
            if (type === 'int16') return new Int16Array(len);
            if (type === 'uint8c') return new Uint8ClampedArray(len);
            return createRegularArray(type, len);
        }
        if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') return createTypedArrayFactory;
        return createRegularArray;
    }();
    function createSizedArray(len) {
        return Array.apply(null, {
            length: len
        });
    }
    function _typeof$3(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$3 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$3 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$3(obj);
    }
    var subframeEnabled = true;
    var expressionsPlugin = null;
    var expressionsInterfaces = null;
    var idPrefix$1 = '';
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var _shouldRoundValues = false;
    var bmPow = Math.pow;
    var bmSqrt = Math.sqrt;
    var bmFloor = Math.floor;
    var bmMax = Math.max;
    var bmMin = Math.min;
    var BMMath = {};
    (function() {
        var propertyNames = [
            'abs',
            'acos',
            'acosh',
            'asin',
            'asinh',
            'atan',
            'atanh',
            'atan2',
            'ceil',
            'cbrt',
            'expm1',
            'clz32',
            'cos',
            'cosh',
            'exp',
            'floor',
            'fround',
            'hypot',
            'imul',
            'log',
            'log1p',
            'log2',
            'log10',
            'max',
            'min',
            'pow',
            'random',
            'round',
            'sign',
            'sin',
            'sinh',
            'sqrt',
            'tan',
            'tanh',
            'trunc',
            'E',
            'LN10',
            'LN2',
            'LOG10E',
            'LOG2E',
            'PI',
            'SQRT1_2',
            'SQRT2'
        ];
        var i;
        var len = propertyNames.length;
        for(i = 0; i < len; i += 1)BMMath[propertyNames[i]] = Math[propertyNames[i]];
    })();
    function ProjectInterface$1() {
        return {};
    }
    BMMath.random = Math.random;
    BMMath.abs = function(val) {
        var tOfVal = _typeof$3(val);
        if (tOfVal === 'object' && val.length) {
            var absArr = createSizedArray(val.length);
            var i;
            var len = val.length;
            for(i = 0; i < len; i += 1)absArr[i] = Math.abs(val[i]);
            return absArr;
        }
        return Math.abs(val);
    };
    var defaultCurveSegments = 150;
    var degToRads = Math.PI / 180;
    var roundCorner = 0.5519;
    function roundValues(flag) {
        _shouldRoundValues = !!flag;
    }
    function bmRnd(value) {
        if (_shouldRoundValues) return Math.round(value);
        return value;
    }
    function styleDiv(element) {
        element.style.position = 'absolute';
        element.style.top = 0;
        element.style.left = 0;
        element.style.display = 'block';
        element.style.transformOrigin = '0 0';
        element.style.webkitTransformOrigin = '0 0';
        element.style.backfaceVisibility = 'visible';
        element.style.webkitBackfaceVisibility = 'visible';
        element.style.transformStyle = 'preserve-3d';
        element.style.webkitTransformStyle = 'preserve-3d';
        element.style.mozTransformStyle = 'preserve-3d';
    }
    function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
        this.type = type;
        this.currentTime = currentTime;
        this.totalTime = totalTime;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteEvent(type, frameMultiplier) {
        this.type = type;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
        this.type = type;
        this.currentLoop = currentLoop;
        this.totalLoops = totalLoops;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(type, firstFrame, totalFrames) {
        this.type = type;
        this.firstFrame = firstFrame;
        this.totalFrames = totalFrames;
    }
    function BMDestroyEvent(type, target) {
        this.type = type;
        this.target = target;
    }
    function BMRenderFrameErrorEvent(nativeError, currentTime) {
        this.type = 'renderFrameError';
        this.nativeError = nativeError;
        this.currentTime = currentTime;
    }
    function BMConfigErrorEvent(nativeError) {
        this.type = 'configError';
        this.nativeError = nativeError;
    }
    function BMAnimationConfigErrorEvent(type, nativeError) {
        this.type = type;
        this.nativeError = nativeError;
    }
    var createElementID = function() {
        var _count = 0;
        return function createID() {
            _count += 1;
            return idPrefix$1 + '__lottie_element_' + _count;
        };
    }();
    function HSVtoRGB(h, s, v) {
        var r;
        var g;
        var b;
        var i;
        var f;
        var p;
        var q;
        var t;
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch(i % 6){
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            case 5:
                r = v;
                g = p;
                b = q;
                break;
            default:
                break;
        }
        return [
            r,
            g,
            b
        ];
    }
    function RGBtoHSV(r, g, b) {
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var d = max - min;
        var h;
        var s = max === 0 ? 0 : d / max;
        var v = max / 255;
        switch(max){
            case min:
                h = 0;
                break;
            case r:
                h = g - b + d * (g < b ? 6 : 0);
                h /= 6 * d;
                break;
            case g:
                h = b - r + d * 2;
                h /= 6 * d;
                break;
            case b:
                h = r - g + d * 4;
                h /= 6 * d;
                break;
            default:
                break;
        }
        return [
            h,
            s,
            v
        ];
    }
    function addSaturationToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[1] += offset;
        if (hsv[1] > 1) hsv[1] = 1;
        else if (hsv[1] <= 0) hsv[1] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addBrightnessToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[2] += offset;
        if (hsv[2] > 1) hsv[2] = 1;
        else if (hsv[2] < 0) hsv[2] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addHueToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[0] += offset / 360;
        if (hsv[0] > 1) hsv[0] -= 1;
        else if (hsv[0] < 0) hsv[0] += 1;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    var rgbToHex = function() {
        var colorMap = [];
        var i;
        var hex;
        for(i = 0; i < 256; i += 1){
            hex = i.toString(16);
            colorMap[i] = hex.length === 1 ? '0' + hex : hex;
        }
        return function(r, g, b) {
            if (r < 0) r = 0;
            if (g < 0) g = 0;
            if (b < 0) b = 0;
            return '#' + colorMap[r] + colorMap[g] + colorMap[b];
        };
    }();
    var setSubframeEnabled = function setSubframeEnabled(flag) {
        subframeEnabled = !!flag;
    };
    var getSubframeEnabled = function getSubframeEnabled() {
        return subframeEnabled;
    };
    var setExpressionsPlugin = function setExpressionsPlugin(value) {
        expressionsPlugin = value;
    };
    var getExpressionsPlugin = function getExpressionsPlugin() {
        return expressionsPlugin;
    };
    var setExpressionInterfaces = function setExpressionInterfaces(value) {
        expressionsInterfaces = value;
    };
    var getExpressionInterfaces = function getExpressionInterfaces() {
        return expressionsInterfaces;
    };
    var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
        defaultCurveSegments = value;
    };
    var getDefaultCurveSegments = function getDefaultCurveSegments() {
        return defaultCurveSegments;
    };
    var setIdPrefix = function setIdPrefix(value) {
        idPrefix$1 = value;
    };
    var getIdPrefix = function getIdPrefix() {
        return idPrefix$1;
    };
    function createNS(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElementNS(svgNS, type);
    }
    function _typeof$2(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$2 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$2(obj);
    }
    var dataManager = function() {
        var _counterId = 1;
        var processes = [];
        var workerFn;
        var workerInstance;
        var workerProxy = {
            onmessage: function onmessage() {},
            postMessage: function postMessage(path) {
                workerFn({
                    data: path
                });
            }
        };
        var _workerSelf = {
            postMessage: function postMessage(data) {
                workerProxy.onmessage({
                    data: data
                });
            }
        };
        function createWorker(fn) {
            if (window.Worker && window.Blob && getWebWorker()) {
                var blob = new Blob([
                    'var _workerSelf = self; self.onmessage = ',
                    fn.toString()
                ], {
                    type: 'text/javascript'
                }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
                var url = URL.createObjectURL(blob);
                return new Worker(url);
            }
            workerFn = fn;
            return workerProxy;
        }
        function setupWorker() {
            if (!workerInstance) {
                workerInstance = createWorker(function workerStart(e) {
                    function dataFunctionManager() {
                        function completeLayers(layers, comps) {
                            var layerData;
                            var i;
                            var len = layers.length;
                            var j;
                            var jLen;
                            var k;
                            var kLen;
                            for(i = 0; i < len; i += 1){
                                layerData = layers[i];
                                if ('ks' in layerData && !layerData.completed) {
                                    layerData.completed = true;
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) convertPathsToAbsoluteValues(maskProps[j].pt.k);
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                                                if (maskProps[j].pt.k[k].e) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                                            }
                                        }
                                    }
                                    if (layerData.ty === 0) {
                                        layerData.layers = findCompLayers(layerData.refId, comps);
                                        completeLayers(layerData.layers, comps);
                                    } else if (layerData.ty === 4) completeShapes(layerData.shapes);
                                    else if (layerData.ty === 5) completeText(layerData);
                                }
                            }
                        }
                        function completeChars(chars, assets) {
                            if (chars) {
                                var i = 0;
                                var len = chars.length;
                                for(i = 0; i < len; i += 1)if (chars[i].t === 1) {
                                    // var compData = findComp(chars[i].data.refId, assets);
                                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
                                    // chars[i].data.op = 99999;
                                    // chars[i].data.st = 0;
                                    // chars[i].data.sr = 1;
                                    // chars[i].w = compData.w;
                                    // chars[i].data.ks = {
                                    //   a: { k: [0, 0, 0], a: 0 },
                                    //   p: { k: [0, -compData.h, 0], a: 0 },
                                    //   r: { k: 0, a: 0 },
                                    //   s: { k: [100, 100], a: 0 },
                                    //   o: { k: 100, a: 0 },
                                    // };
                                    completeLayers(chars[i].data.layers, assets);
                                }
                            }
                        }
                        function findComp(id, comps) {
                            var i = 0;
                            var len = comps.length;
                            while(i < len){
                                if (comps[i].id === id) return comps[i];
                                i += 1;
                            }
                            return null;
                        }
                        function findCompLayers(id, comps) {
                            var comp = findComp(id, comps);
                            if (comp) {
                                if (!comp.layers.__used) {
                                    comp.layers.__used = true;
                                    return comp.layers;
                                }
                                return JSON.parse(JSON.stringify(comp.layers));
                            }
                            return null;
                        }
                        function completeShapes(arr) {
                            var i;
                            var len = arr.length;
                            var j;
                            var jLen;
                            for(i = len - 1; i >= 0; i -= 1){
                                if (arr[i].ty === 'sh') {
                                    if (arr[i].ks.k.i) convertPathsToAbsoluteValues(arr[i].ks.k);
                                    else {
                                        jLen = arr[i].ks.k.length;
                                        for(j = 0; j < jLen; j += 1){
                                            if (arr[i].ks.k[j].s) convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                                            if (arr[i].ks.k[j].e) convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                                        }
                                    }
                                } else if (arr[i].ty === 'gr') completeShapes(arr[i].it);
                            }
                        }
                        function convertPathsToAbsoluteValues(path) {
                            var i;
                            var len = path.i.length;
                            for(i = 0; i < len; i += 1){
                                path.i[i][0] += path.v[i][0];
                                path.i[i][1] += path.v[i][1];
                                path.o[i][0] += path.v[i][0];
                                path.o[i][1] += path.v[i][1];
                            }
                        }
                        function checkVersion(minimum, animVersionString) {
                            var animVersion = animVersionString ? animVersionString.split('.') : [
                                100,
                                100,
                                100
                            ];
                            if (minimum[0] > animVersion[0]) return true;
                            if (animVersion[0] > minimum[0]) return false;
                            if (minimum[1] > animVersion[1]) return true;
                            if (animVersion[1] > minimum[1]) return false;
                            if (minimum[2] > animVersion[2]) return true;
                            if (animVersion[2] > minimum[2]) return false;
                            return null;
                        }
                        var checkText = function() {
                            var minimumVersion = [
                                4,
                                4,
                                14
                            ];
                            function updateTextLayer(textLayer) {
                                var documentData = textLayer.t.d;
                                textLayer.t.d = {
                                    k: [
                                        {
                                            s: documentData,
                                            t: 0
                                        }
                                    ]
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkChars = function() {
                            var minimumVersion = [
                                4,
                                7,
                                99
                            ];
                            return function(animationData) {
                                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                                    var i;
                                    var len = animationData.chars.length;
                                    for(i = 0; i < len; i += 1){
                                        var charData = animationData.chars[i];
                                        if (charData.data && charData.data.shapes) {
                                            completeShapes(charData.data.shapes);
                                            charData.data.ip = 0;
                                            charData.data.op = 99999;
                                            charData.data.st = 0;
                                            charData.data.sr = 1;
                                            charData.data.ks = {
                                                p: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                s: {
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    a: 0
                                                },
                                                a: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                r: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                o: {
                                                    k: 100,
                                                    a: 0
                                                }
                                            };
                                            if (!animationData.chars[i].t) {
                                                charData.data.shapes.push({
                                                    ty: 'no'
                                                });
                                                charData.data.shapes[0].it.push({
                                                    p: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    s: {
                                                        k: [
                                                            100,
                                                            100
                                                        ],
                                                        a: 0
                                                    },
                                                    a: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    r: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    o: {
                                                        k: 100,
                                                        a: 0
                                                    },
                                                    sk: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    sa: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    ty: 'tr'
                                                });
                                            }
                                        }
                                    }
                                }
                            };
                        }();
                        var checkPathProperties = function() {
                            var minimumVersion = [
                                5,
                                7,
                                15
                            ];
                            function updateTextLayer(textLayer) {
                                var pathData = textLayer.t.p;
                                if (typeof pathData.a === 'number') pathData.a = {
                                    a: 0,
                                    k: pathData.a
                                };
                                if (typeof pathData.p === 'number') pathData.p = {
                                    a: 0,
                                    k: pathData.p
                                };
                                if (typeof pathData.r === 'number') pathData.r = {
                                    a: 0,
                                    k: pathData.r
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkColors = function() {
                            var minimumVersion = [
                                4,
                                1,
                                9
                            ];
                            function iterateShapes(shapes) {
                                var i;
                                var len = shapes.length;
                                var j;
                                var jLen;
                                for(i = 0; i < len; i += 1){
                                    if (shapes[i].ty === 'gr') iterateShapes(shapes[i].it);
                                    else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                                        if (shapes[i].c.k && shapes[i].c.k[0].i) {
                                            jLen = shapes[i].c.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (shapes[i].c.k[j].s) {
                                                    shapes[i].c.k[j].s[0] /= 255;
                                                    shapes[i].c.k[j].s[1] /= 255;
                                                    shapes[i].c.k[j].s[2] /= 255;
                                                    shapes[i].c.k[j].s[3] /= 255;
                                                }
                                                if (shapes[i].c.k[j].e) {
                                                    shapes[i].c.k[j].e[0] /= 255;
                                                    shapes[i].c.k[j].e[1] /= 255;
                                                    shapes[i].c.k[j].e[2] /= 255;
                                                    shapes[i].c.k[j].e[3] /= 255;
                                                }
                                            }
                                        } else {
                                            shapes[i].c.k[0] /= 255;
                                            shapes[i].c.k[1] /= 255;
                                            shapes[i].c.k[2] /= 255;
                                            shapes[i].c.k[3] /= 255;
                                        }
                                    }
                                }
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 4) iterateShapes(layers[i].shapes);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkShapes = function() {
                            var minimumVersion = [
                                4,
                                4,
                                18
                            ];
                            function completeClosingShapes(arr) {
                                var i;
                                var len = arr.length;
                                var j;
                                var jLen;
                                for(i = len - 1; i >= 0; i -= 1){
                                    if (arr[i].ty === 'sh') {
                                        if (arr[i].ks.k.i) arr[i].ks.k.c = arr[i].closed;
                                        else {
                                            jLen = arr[i].ks.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (arr[i].ks.k[j].s) arr[i].ks.k[j].s[0].c = arr[i].closed;
                                                if (arr[i].ks.k[j].e) arr[i].ks.k[j].e[0].c = arr[i].closed;
                                            }
                                        }
                                    } else if (arr[i].ty === 'gr') completeClosingShapes(arr[i].it);
                                }
                            }
                            function iterateLayers(layers) {
                                var layerData;
                                var i;
                                var len = layers.length;
                                var j;
                                var jLen;
                                var k;
                                var kLen;
                                for(i = 0; i < len; i += 1){
                                    layerData = layers[i];
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) maskProps[j].pt.k.c = maskProps[j].cl;
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                                                if (maskProps[j].pt.k[k].e) maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                                            }
                                        }
                                    }
                                    if (layerData.ty === 4) completeClosingShapes(layerData.shapes);
                                }
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        function completeData(animationData) {
                            if (animationData.__complete) return;
                            checkColors(animationData);
                            checkText(animationData);
                            checkChars(animationData);
                            checkPathProperties(animationData);
                            checkShapes(animationData);
                            completeLayers(animationData.layers, animationData.assets);
                            completeChars(animationData.chars, animationData.assets);
                            animationData.__complete = true;
                        }
                        function completeText(data) {
                            data.t.a.length === 0 && data.t.p;
                        }
                        var moduleOb = {};
                        moduleOb.completeData = completeData;
                        moduleOb.checkColors = checkColors;
                        moduleOb.checkChars = checkChars;
                        moduleOb.checkPathProperties = checkPathProperties;
                        moduleOb.checkShapes = checkShapes;
                        moduleOb.completeLayers = completeLayers;
                        return moduleOb;
                    }
                    if (!_workerSelf.dataManager) _workerSelf.dataManager = dataFunctionManager();
                    if (!_workerSelf.assetLoader) _workerSelf.assetLoader = function() {
                        function formatResponse(xhr) {
                            // using typeof doubles the time of execution of this method,
                            // so if available, it's better to use the header to validate the type
                            var contentTypeHeader = xhr.getResponseHeader('content-type');
                            if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) return xhr.response;
                            if (xhr.response && _typeof$2(xhr.response) === 'object') return xhr.response;
                            if (xhr.response && typeof xhr.response === 'string') return JSON.parse(xhr.response);
                            if (xhr.responseText) return JSON.parse(xhr.responseText);
                            return null;
                        }
                        function loadAsset(path, fullPath, callback, errorCallback) {
                            var response;
                            var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.
                            try {
                                // This crashes on Android WebView prior to KitKat
                                xhr.responseType = 'json';
                            } catch (err) {} // eslint-disable-line no-empty
                            xhr.onreadystatechange = function() {
                                if (xhr.readyState === 4) {
                                    if (xhr.status === 200) {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } else try {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } catch (err) {
                                        if (errorCallback) errorCallback(err);
                                    }
                                }
                            };
                            try {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), path, true);
                            } catch (error) {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), fullPath + '/' + path, true);
                            }
                            xhr.send();
                        }
                        return {
                            load: loadAsset
                        };
                    }();
                    if (e.data.type === 'loadAnimation') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.dataManager.completeData(data);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                    else if (e.data.type === 'complete') {
                        var animation = e.data.animation;
                        _workerSelf.dataManager.completeData(animation);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: animation,
                            status: 'success'
                        });
                    } else if (e.data.type === 'loadData') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                });
                workerInstance.onmessage = function(event) {
                    var data = event.data;
                    var id = data.id;
                    var process = processes[id];
                    processes[id] = null;
                    if (data.status === 'success') process.onComplete(data.payload);
                    else if (process.onError) process.onError();
                };
            }
        }
        function createProcess(onComplete, onError) {
            _counterId += 1;
            var id = 'processId_' + _counterId;
            processes[id] = {
                onComplete: onComplete,
                onError: onError
            };
            return id;
        }
        function loadAnimation(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadAnimation',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function loadData(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadData',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function completeAnimation(anim, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'complete',
                animation: anim,
                id: processId
            });
        }
        return {
            loadAnimation: loadAnimation,
            loadData: loadData,
            completeAnimation: completeAnimation
        };
    }();
    var ImagePreloader = function() {
        var proxyImage = function() {
            var canvas = createTag('canvas');
            canvas.width = 1;
            canvas.height = 1;
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = 'rgba(0,0,0,0)';
            ctx.fillRect(0, 0, 1, 1);
            return canvas;
        }();
        function imageLoaded() {
            this.loadedAssets += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function footageLoaded() {
            this.loadedFootagesCount += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function getAssetsPath(assetData, assetsPath, originalPath) {
            var path = '';
            if (assetData.e) path = assetData.p;
            else if (assetsPath) {
                var imagePath = assetData.p;
                if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
                path = assetsPath + imagePath;
            } else {
                path = originalPath;
                path += assetData.u ? assetData.u : '';
                path += assetData.p;
            }
            return path;
        }
        function testImageLoaded(img) {
            var _count = 0;
            var intervalId = setInterval((function() {
                var box = img.getBBox();
                if (box.width || _count > 500) {
                    this._imageLoaded();
                    clearInterval(intervalId);
                }
                _count += 1;
            }).bind(this), 50);
        }
        function createImageData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createNS('image');
            if (isSafari) this.testImageLoaded(img);
            else img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
            if (this._elementHelper.append) this._elementHelper.append(img);
            else this._elementHelper.appendChild(img);
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createImgData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createTag('img');
            img.crossOrigin = 'anonymous';
            img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.src = path;
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createFootageData(data) {
            var ob = {
                assetData: data
            };
            var path = getAssetsPath(data, this.assetsPath, this.path);
            dataManager.loadData(path, (function(footageData) {
                ob.img = footageData;
                this._footageLoaded();
            }).bind(this), (function() {
                ob.img = {};
                this._footageLoaded();
            }).bind(this));
            return ob;
        }
        function loadAssets(assets, cb) {
            this.imagesLoadedCb = cb;
            var i;
            var len = assets.length;
            for(i = 0; i < len; i += 1)if (!assets[i].layers) {
                if (!assets[i].t || assets[i].t === 'seq') {
                    this.totalImages += 1;
                    this.images.push(this._createImageData(assets[i]));
                } else if (assets[i].t === 3) {
                    this.totalFootages += 1;
                    this.images.push(this.createFootageData(assets[i]));
                }
            }
        }
        function setPath(path) {
            this.path = path || '';
        }
        function setAssetsPath(path) {
            this.assetsPath = path || '';
        }
        function getAsset(assetData) {
            var i = 0;
            var len = this.images.length;
            while(i < len){
                if (this.images[i].assetData === assetData) return this.images[i].img;
                i += 1;
            }
            return null;
        }
        function destroy() {
            this.imagesLoadedCb = null;
            this.images.length = 0;
        }
        function loadedImages() {
            return this.totalImages === this.loadedAssets;
        }
        function loadedFootages() {
            return this.totalFootages === this.loadedFootagesCount;
        }
        function setCacheType(type, elementHelper) {
            if (type === 'svg') {
                this._elementHelper = elementHelper;
                this._createImageData = this.createImageData.bind(this);
            } else this._createImageData = this.createImgData.bind(this);
        }
        function ImagePreloaderFactory() {
            this._imageLoaded = imageLoaded.bind(this);
            this._footageLoaded = footageLoaded.bind(this);
            this.testImageLoaded = testImageLoaded.bind(this);
            this.createFootageData = createFootageData.bind(this);
            this.assetsPath = '';
            this.path = '';
            this.totalImages = 0;
            this.totalFootages = 0;
            this.loadedAssets = 0;
            this.loadedFootagesCount = 0;
            this.imagesLoadedCb = null;
            this.images = [];
        }
        ImagePreloaderFactory.prototype = {
            loadAssets: loadAssets,
            setAssetsPath: setAssetsPath,
            setPath: setPath,
            loadedImages: loadedImages,
            loadedFootages: loadedFootages,
            destroy: destroy,
            getAsset: getAsset,
            createImgData: createImgData,
            createImageData: createImageData,
            imageLoaded: imageLoaded,
            footageLoaded: footageLoaded,
            setCacheType: setCacheType
        };
        return ImagePreloaderFactory;
    }();
    function BaseEvent() {}
    BaseEvent.prototype = {
        triggerEvent: function triggerEvent(eventName, args) {
            if (this._cbs[eventName]) {
                var callbacks = this._cbs[eventName];
                for(var i = 0; i < callbacks.length; i += 1)callbacks[i](args);
            }
        },
        addEventListener: function addEventListener(eventName, callback) {
            if (!this._cbs[eventName]) this._cbs[eventName] = [];
            this._cbs[eventName].push(callback);
            return (function() {
                this.removeEventListener(eventName, callback);
            }).bind(this);
        },
        removeEventListener: function removeEventListener(eventName, callback) {
            if (!callback) this._cbs[eventName] = null;
            else if (this._cbs[eventName]) {
                var i = 0;
                var len = this._cbs[eventName].length;
                while(i < len){
                    if (this._cbs[eventName][i] === callback) {
                        this._cbs[eventName].splice(i, 1);
                        i -= 1;
                        len -= 1;
                    }
                    i += 1;
                }
                if (!this._cbs[eventName].length) this._cbs[eventName] = null;
            }
        }
    };
    var markerParser = function() {
        function parsePayloadLines(payload) {
            var lines = payload.split('\r\n');
            var keys = {};
            var line;
            var keysCount = 0;
            for(var i = 0; i < lines.length; i += 1){
                line = lines[i].split(':');
                if (line.length === 2) {
                    keys[line[0]] = line[1].trim();
                    keysCount += 1;
                }
            }
            if (keysCount === 0) throw new Error();
            return keys;
        }
        return function(_markers) {
            var markers = [];
            for(var i = 0; i < _markers.length; i += 1){
                var _marker = _markers[i];
                var markerData = {
                    time: _marker.tm,
                    duration: _marker.dr
                };
                try {
                    markerData.payload = JSON.parse(_markers[i].cm);
                } catch (_) {
                    try {
                        markerData.payload = parsePayloadLines(_markers[i].cm);
                    } catch (__) {
                        markerData.payload = {
                            name: _markers[i].cm
                        };
                    }
                }
                markers.push(markerData);
            }
            return markers;
        };
    }();
    var ProjectInterface = function() {
        function registerComposition(comp) {
            this.compositions.push(comp);
        }
        return function() {
            function _thisProjectFunction(name) {
                var i = 0;
                var len = this.compositions.length;
                while(i < len){
                    if (this.compositions[i].data && this.compositions[i].data.nm === name) {
                        if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) this.compositions[i].prepareFrame(this.currentFrame);
                        return this.compositions[i].compInterface;
                    }
                    i += 1;
                }
                return null;
            }
            _thisProjectFunction.compositions = [];
            _thisProjectFunction.currentFrame = 0;
            _thisProjectFunction.registerComposition = registerComposition;
            return _thisProjectFunction;
        };
    }();
    var renderers = {};
    var registerRenderer = function registerRenderer(key, value) {
        renderers[key] = value;
    };
    function getRenderer(key) {
        return renderers[key];
    }
    function _typeof$1(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$1 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$1(obj);
    }
    var AnimationItem = function AnimationItem() {
        this._cbs = [];
        this.name = '';
        this.path = '';
        this.isLoaded = false;
        this.currentFrame = 0;
        this.currentRawFrame = 0;
        this.firstFrame = 0;
        this.totalFrames = 0;
        this.frameRate = 0;
        this.frameMult = 0;
        this.playSpeed = 1;
        this.playDirection = 1;
        this.playCount = 0;
        this.animationData = {};
        this.assets = [];
        this.isPaused = true;
        this.autoplay = false;
        this.loop = true;
        this.renderer = null;
        this.animationID = createElementID();
        this.assetsPath = '';
        this.timeCompleted = 0;
        this.segmentPos = 0;
        this.isSubframeEnabled = getSubframeEnabled();
        this.segments = [];
        this._idle = true;
        this._completedLoop = false;
        this.projectInterface = ProjectInterface();
        this.imagePreloader = new ImagePreloader();
        this.audioController = audioControllerFactory();
        this.markers = [];
        this.configAnimation = this.configAnimation.bind(this);
        this.onSetupError = this.onSetupError.bind(this);
        this.onSegmentComplete = this.onSegmentComplete.bind(this);
        this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
    };
    extendPrototype([
        BaseEvent
    ], AnimationItem);
    AnimationItem.prototype.setParams = function(params) {
        if (params.wrapper || params.container) this.wrapper = params.wrapper || params.container;
        var animType = 'svg';
        if (params.animType) animType = params.animType;
        else if (params.renderer) animType = params.renderer;
        var RendererClass = getRenderer(animType);
        this.renderer = new RendererClass(this, params.rendererSettings);
        this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
        this.renderer.setProjectInterface(this.projectInterface);
        this.animType = animType;
        if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) this.loop = true;
        else if (params.loop === false) this.loop = false;
        else this.loop = parseInt(params.loop, 10);
        this.autoplay = 'autoplay' in params ? params.autoplay : true;
        this.name = params.name ? params.name : '';
        this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
        this.assetsPath = params.assetsPath;
        this.initialSegment = params.initialSegment;
        if (params.audioFactory) this.audioController.setAudioFactory(params.audioFactory);
        if (params.animationData) this.setupAnimation(params.animationData);
        else if (params.path) {
            if (params.path.lastIndexOf('\\') !== -1) this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
            else this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
            this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
            this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
            dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
        }
    };
    AnimationItem.prototype.onSetupError = function() {
        this.trigger('data_failed');
    };
    AnimationItem.prototype.setupAnimation = function(data) {
        dataManager.completeAnimation(data, this.configAnimation);
    };
    AnimationItem.prototype.setData = function(wrapper, animationData) {
        if (animationData) {
            if (_typeof$1(animationData) !== 'object') animationData = JSON.parse(animationData);
        }
        var params = {
            wrapper: wrapper,
            animationData: animationData
        };
        var wrapperAttributes = wrapper.attributes;
        params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
        params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : 'canvas';
        var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
        if (loop === 'false') params.loop = false;
        else if (loop === 'true') params.loop = true;
        else if (loop !== '') params.loop = parseInt(loop, 10);
        var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
        params.autoplay = autoplay !== 'false';
        params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
        var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
        if (prerender === 'false') params.prerender = false;
        this.setParams(params);
    };
    AnimationItem.prototype.includeLayers = function(data) {
        if (data.op > this.animationData.op) {
            this.animationData.op = data.op;
            this.totalFrames = Math.floor(data.op - this.animationData.ip);
        }
        var layers = this.animationData.layers;
        var i;
        var len = layers.length;
        var newLayers = data.layers;
        var j;
        var jLen = newLayers.length;
        for(j = 0; j < jLen; j += 1){
            i = 0;
            while(i < len){
                if (layers[i].id === newLayers[j].id) {
                    layers[i] = newLayers[j];
                    break;
                }
                i += 1;
            }
        }
        if (data.chars || data.fonts) {
            this.renderer.globalData.fontManager.addChars(data.chars);
            this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
        }
        if (data.assets) {
            len = data.assets.length;
            for(i = 0; i < len; i += 1)this.animationData.assets.push(data.assets[i]);
        }
        this.animationData.__complete = false;
        dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    };
    AnimationItem.prototype.onSegmentComplete = function(data) {
        this.animationData = data;
        var expressionsPlugin = getExpressionsPlugin();
        if (expressionsPlugin) expressionsPlugin.initExpressions(this);
        this.loadNextSegment();
    };
    AnimationItem.prototype.loadNextSegment = function() {
        var segments = this.animationData.segments;
        if (!segments || segments.length === 0 || !this.autoloadSegments) {
            this.trigger('data_ready');
            this.timeCompleted = this.totalFrames;
            return;
        }
        var segment = segments.shift();
        this.timeCompleted = segment.time * this.frameRate;
        var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
        this.segmentPos += 1;
        dataManager.loadData(segmentPath, this.includeLayers.bind(this), (function() {
            this.trigger('data_failed');
        }).bind(this));
    };
    AnimationItem.prototype.loadSegments = function() {
        var segments = this.animationData.segments;
        if (!segments) this.timeCompleted = this.totalFrames;
        this.loadNextSegment();
    };
    AnimationItem.prototype.imagesLoaded = function() {
        this.trigger('loaded_images');
        this.checkLoaded();
    };
    AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath);
        this.imagePreloader.setPath(this.path);
        this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    };
    AnimationItem.prototype.configAnimation = function(animData) {
        if (!this.renderer) return;
        try {
            this.animationData = animData;
            if (this.initialSegment) {
                this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
                this.firstFrame = Math.round(this.initialSegment[0]);
            } else {
                this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
                this.firstFrame = Math.round(this.animationData.ip);
            }
            this.renderer.configAnimation(animData);
            if (!animData.assets) animData.assets = [];
            this.assets = this.animationData.assets;
            this.frameRate = this.animationData.fr;
            this.frameMult = this.animationData.fr / 1000;
            this.renderer.searchExtraCompositions(animData.assets);
            this.markers = markerParser(animData.markers || []);
            this.trigger('config_ready');
            this.preloadImages();
            this.loadSegments();
            this.updaFrameModifier();
            this.waitForFontsLoaded();
            if (this.isPaused) this.audioController.pause();
        } catch (error) {
            this.triggerConfigError(error);
        }
    };
    AnimationItem.prototype.waitForFontsLoaded = function() {
        if (!this.renderer) return;
        if (this.renderer.globalData.fontManager.isLoaded) this.checkLoaded();
        else setTimeout(this.waitForFontsLoaded.bind(this), 20);
    };
    AnimationItem.prototype.checkLoaded = function() {
        if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
            this.isLoaded = true;
            var expressionsPlugin = getExpressionsPlugin();
            if (expressionsPlugin) expressionsPlugin.initExpressions(this);
            this.renderer.initItems();
            setTimeout((function() {
                this.trigger('DOMLoaded');
            }).bind(this), 0);
            this.gotoFrame();
            if (this.autoplay) this.play();
        }
    };
    AnimationItem.prototype.resize = function(width, height) {
        // Adding this validation for backwards compatibility in case an event object was being passed down
        var _width = typeof width === 'number' ? width : undefined;
        var _height = typeof height === 'number' ? height : undefined;
        this.renderer.updateContainerSize(_width, _height);
    };
    AnimationItem.prototype.setSubframe = function(flag) {
        this.isSubframeEnabled = !!flag;
    };
    AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
        if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) this.currentFrame = this.timeCompleted;
        this.trigger('enterFrame');
        this.renderFrame();
        this.trigger('drawnFrame');
    };
    AnimationItem.prototype.renderFrame = function() {
        if (this.isLoaded === false || !this.renderer) return;
        try {
            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (error) {
            this.triggerRenderFrameError(error);
        }
    };
    AnimationItem.prototype.play = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) {
            this.isPaused = false;
            this.trigger('_pause');
            this.audioController.resume();
            if (this._idle) {
                this._idle = false;
                this.trigger('_active');
            }
        }
    };
    AnimationItem.prototype.pause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === false) {
            this.isPaused = true;
            this.trigger('_play');
            this._idle = true;
            this.trigger('_idle');
            this.audioController.pause();
        }
    };
    AnimationItem.prototype.togglePause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) this.play();
        else this.pause();
    };
    AnimationItem.prototype.stop = function(name) {
        if (name && this.name !== name) return;
        this.pause();
        this.playCount = 0;
        this._completedLoop = false;
        this.setCurrentRawFrameValue(0);
    };
    AnimationItem.prototype.getMarkerData = function(markerName) {
        var marker;
        for(var i = 0; i < this.markers.length; i += 1){
            marker = this.markers[i];
            if (marker.payload && marker.payload.name === markerName) return marker;
        }
        return null;
    };
    AnimationItem.prototype.goToAndStop = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) this.goToAndStop(marker.time, true);
        } else if (isFrame) this.setCurrentRawFrameValue(value);
        else this.setCurrentRawFrameValue(value * this.frameModifier);
        this.pause();
    };
    AnimationItem.prototype.goToAndPlay = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) {
                if (!marker.duration) this.goToAndStop(marker.time, true);
                else this.playSegments([
                    marker.time,
                    marker.time + marker.duration
                ], true);
            }
        } else this.goToAndStop(numValue, isFrame, name);
        this.play();
    };
    AnimationItem.prototype.advanceTime = function(value) {
        if (this.isPaused === true || this.isLoaded === false) return;
        var nextValue = this.currentRawFrame + value * this.frameModifier;
        var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
        // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
        if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
            if (!this.loop || this.playCount === this.loop) {
                if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
                    _isComplete = true;
                    nextValue = this.totalFrames - 1;
                }
            } else if (nextValue >= this.totalFrames) {
                this.playCount += 1;
                if (!this.checkSegments(nextValue % this.totalFrames)) {
                    this.setCurrentRawFrameValue(nextValue % this.totalFrames);
                    this._completedLoop = true;
                    this.trigger('loopComplete');
                }
            } else this.setCurrentRawFrameValue(nextValue);
        } else if (nextValue < 0) {
            if (!this.checkSegments(nextValue % this.totalFrames)) {
                if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
                    // eslint-disable-line no-plusplus
                    this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
                    if (!this._completedLoop) this._completedLoop = true;
                    else this.trigger('loopComplete');
                } else {
                    _isComplete = true;
                    nextValue = 0;
                }
            }
        } else this.setCurrentRawFrameValue(nextValue);
        if (_isComplete) {
            this.setCurrentRawFrameValue(nextValue);
            this.pause();
            this.trigger('complete');
        }
    };
    AnimationItem.prototype.adjustSegment = function(arr, offset) {
        this.playCount = 0;
        if (arr[1] < arr[0]) {
            if (this.frameModifier > 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(-1);
            }
            this.totalFrames = arr[0] - arr[1];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[1];
            this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
        } else if (arr[1] > arr[0]) {
            if (this.frameModifier < 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(1);
            }
            this.totalFrames = arr[1] - arr[0];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[0];
            this.setCurrentRawFrameValue(0.001 + offset);
        }
        this.trigger('segmentStart');
    };
    AnimationItem.prototype.setSegment = function(init, end) {
        var pendingFrame = -1;
        if (this.isPaused) {
            if (this.currentRawFrame + this.firstFrame < init) pendingFrame = init;
            else if (this.currentRawFrame + this.firstFrame > end) pendingFrame = end - init;
        }
        this.firstFrame = init;
        this.totalFrames = end - init;
        this.timeCompleted = this.totalFrames;
        if (pendingFrame !== -1) this.goToAndStop(pendingFrame, true);
    };
    AnimationItem.prototype.playSegments = function(arr, forceFlag) {
        if (forceFlag) this.segments.length = 0;
        if (_typeof$1(arr[0]) === 'object') {
            var i;
            var len = arr.length;
            for(i = 0; i < len; i += 1)this.segments.push(arr[i]);
        } else this.segments.push(arr);
        if (this.segments.length && forceFlag) this.adjustSegment(this.segments.shift(), 0);
        if (this.isPaused) this.play();
    };
    AnimationItem.prototype.resetSegments = function(forceFlag) {
        this.segments.length = 0;
        this.segments.push([
            this.animationData.ip,
            this.animationData.op
        ]);
        if (forceFlag) this.checkSegments(0);
    };
    AnimationItem.prototype.checkSegments = function(offset) {
        if (this.segments.length) {
            this.adjustSegment(this.segments.shift(), offset);
            return true;
        }
        return false;
    };
    AnimationItem.prototype.destroy = function(name) {
        if (name && this.name !== name || !this.renderer) return;
        this.renderer.destroy();
        this.imagePreloader.destroy();
        this.trigger('destroy');
        this._cbs = null;
        this.onEnterFrame = null;
        this.onLoopComplete = null;
        this.onComplete = null;
        this.onSegmentStart = null;
        this.onDestroy = null;
        this.renderer = null;
        this.renderer = null;
        this.imagePreloader = null;
        this.projectInterface = null;
    };
    AnimationItem.prototype.setCurrentRawFrameValue = function(value) {
        this.currentRawFrame = value;
        this.gotoFrame();
    };
    AnimationItem.prototype.setSpeed = function(val) {
        this.playSpeed = val;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setDirection = function(val) {
        this.playDirection = val < 0 ? -1 : 1;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setVolume = function(val, name) {
        if (name && this.name !== name) return;
        this.audioController.setVolume(val);
    };
    AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
    };
    AnimationItem.prototype.mute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.mute();
    };
    AnimationItem.prototype.unmute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.unmute();
    };
    AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
        this.audioController.setRate(this.playSpeed * this.playDirection);
    };
    AnimationItem.prototype.getPath = function() {
        return this.path;
    };
    AnimationItem.prototype.getAssetsPath = function(assetData) {
        var path = '';
        if (assetData.e) path = assetData.p;
        else if (this.assetsPath) {
            var imagePath = assetData.p;
            if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
            path = this.assetsPath + imagePath;
        } else {
            path = this.path;
            path += assetData.u ? assetData.u : '';
            path += assetData.p;
        }
        return path;
    };
    AnimationItem.prototype.getAssetData = function(id) {
        var i = 0;
        var len = this.assets.length;
        while(i < len){
            if (id === this.assets[i].id) return this.assets[i];
            i += 1;
        }
        return null;
    };
    AnimationItem.prototype.hide = function() {
        this.renderer.hide();
    };
    AnimationItem.prototype.show = function() {
        this.renderer.show();
    };
    AnimationItem.prototype.getDuration = function(isFrame) {
        return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
    };
    AnimationItem.prototype.updateDocumentData = function(path, documentData, index) {
        try {
            var element = this.renderer.getElementByPath(path);
            element.updateDocumentData(documentData, index);
        } catch (error) {}
    };
    AnimationItem.prototype.trigger = function(name) {
        if (this._cbs && this._cbs[name]) switch(name){
            case 'enterFrame':
                this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
                break;
            case 'drawnFrame':
                this.drawnFrameEvent.currentTime = this.currentFrame;
                this.drawnFrameEvent.totalTime = this.totalFrames;
                this.drawnFrameEvent.direction = this.frameModifier;
                this.triggerEvent(name, this.drawnFrameEvent);
                break;
            case 'loopComplete':
                this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
                break;
            case 'complete':
                this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
                break;
            case 'segmentStart':
                this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
                break;
            case 'destroy':
                this.triggerEvent(name, new BMDestroyEvent(name, this));
                break;
            default:
                this.triggerEvent(name);
        }
        if (name === 'enterFrame' && this.onEnterFrame) this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
        if (name === 'loopComplete' && this.onLoopComplete) this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
        if (name === 'complete' && this.onComplete) this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
        if (name === 'segmentStart' && this.onSegmentStart) this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
        if (name === 'destroy' && this.onDestroy) this.onDestroy.call(this, new BMDestroyEvent(name, this));
    };
    AnimationItem.prototype.triggerRenderFrameError = function(nativeError) {
        var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    AnimationItem.prototype.triggerConfigError = function(nativeError) {
        var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    var animationManager = function() {
        var moduleOb = {};
        var registeredAnimations = [];
        var initTime = 0;
        var len = 0;
        var playingAnimationsNum = 0;
        var _stopped = true;
        var _isFrozen = false;
        function removeElement(ev) {
            var i = 0;
            var animItem = ev.target;
            while(i < len){
                if (registeredAnimations[i].animation === animItem) {
                    registeredAnimations.splice(i, 1);
                    i -= 1;
                    len -= 1;
                    if (!animItem.isPaused) subtractPlayingCount();
                }
                i += 1;
            }
        }
        function registerAnimation(element, animationData) {
            if (!element) return null;
            var i = 0;
            while(i < len){
                if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) return registeredAnimations[i].animation;
                i += 1;
            }
            var animItem = new AnimationItem();
            setupAnimation(animItem, element);
            animItem.setData(element, animationData);
            return animItem;
        }
        function getRegisteredAnimations() {
            var i;
            var lenAnims = registeredAnimations.length;
            var animations = [];
            for(i = 0; i < lenAnims; i += 1)animations.push(registeredAnimations[i].animation);
            return animations;
        }
        function addPlayingCount() {
            playingAnimationsNum += 1;
            activate();
        }
        function subtractPlayingCount() {
            playingAnimationsNum -= 1;
        }
        function setupAnimation(animItem, element) {
            animItem.addEventListener('destroy', removeElement);
            animItem.addEventListener('_active', addPlayingCount);
            animItem.addEventListener('_idle', subtractPlayingCount);
            registeredAnimations.push({
                elem: element,
                animation: animItem
            });
            len += 1;
        }
        function loadAnimation(params) {
            var animItem = new AnimationItem();
            setupAnimation(animItem, null);
            animItem.setParams(params);
            return animItem;
        }
        function setSpeed(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setSpeed(val, animation);
        }
        function setDirection(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setDirection(val, animation);
        }
        function play(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.play(animation);
        }
        function resume(nowTime) {
            var elapsedTime = nowTime - initTime;
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.advanceTime(elapsedTime);
            initTime = nowTime;
            if (playingAnimationsNum && !_isFrozen) window.requestAnimationFrame(resume);
            else _stopped = true;
        }
        function first(nowTime) {
            initTime = nowTime;
            window.requestAnimationFrame(resume);
        }
        function pause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.pause(animation);
        }
        function goToAndStop(value, isFrame, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
        }
        function stop(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.stop(animation);
        }
        function togglePause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.togglePause(animation);
        }
        function destroy(animation) {
            var i;
            for(i = len - 1; i >= 0; i -= 1)registeredAnimations[i].animation.destroy(animation);
        }
        function searchAnimations(animationData, standalone, renderer) {
            var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
            var i;
            var lenAnims = animElements.length;
            for(i = 0; i < lenAnims; i += 1){
                if (renderer) animElements[i].setAttribute('data-bm-type', renderer);
                registerAnimation(animElements[i], animationData);
            }
            if (standalone && lenAnims === 0) {
                if (!renderer) renderer = 'svg';
                var body = document.getElementsByTagName('body')[0];
                body.innerText = '';
                var div = createTag('div');
                div.style.width = '100%';
                div.style.height = '100%';
                div.setAttribute('data-bm-type', renderer);
                body.appendChild(div);
                registerAnimation(div, animationData);
            }
        }
        function resize() {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.resize();
        }
        function activate() {
            if (!_isFrozen && playingAnimationsNum) {
                if (_stopped) {
                    window.requestAnimationFrame(first);
                    _stopped = false;
                }
            }
        }
        function freeze() {
            _isFrozen = true;
        }
        function unfreeze() {
            _isFrozen = false;
            activate();
        }
        function setVolume(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setVolume(val, animation);
        }
        function mute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.mute(animation);
        }
        function unmute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.unmute(animation);
        }
        moduleOb.registerAnimation = registerAnimation;
        moduleOb.loadAnimation = loadAnimation;
        moduleOb.setSpeed = setSpeed;
        moduleOb.setDirection = setDirection;
        moduleOb.play = play;
        moduleOb.pause = pause;
        moduleOb.stop = stop;
        moduleOb.togglePause = togglePause;
        moduleOb.searchAnimations = searchAnimations;
        moduleOb.resize = resize; // moduleOb.start = start;
        moduleOb.goToAndStop = goToAndStop;
        moduleOb.destroy = destroy;
        moduleOb.freeze = freeze;
        moduleOb.unfreeze = unfreeze;
        moduleOb.setVolume = setVolume;
        moduleOb.mute = mute;
        moduleOb.unmute = unmute;
        moduleOb.getRegisteredAnimations = getRegisteredAnimations;
        return moduleOb;
    }();
    /* eslint-disable */ var BezierFactory = function() {
        /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */ var ob = {};
        ob.getBezierEasing = getBezierEasing;
        var beziers = {};
        function getBezierEasing(a, b, c, d, nm) {
            var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
            if (beziers[str]) return beziers[str];
            var bezEasing = new BezierEasing([
                a,
                b,
                c,
                d
            ]);
            beziers[str] = bezEasing;
            return bezEasing;
        } // These values are established by empiricism with tests (tradeoff: performance VS precision)
        var NEWTON_ITERATIONS = 4;
        var NEWTON_MIN_SLOPE = 0.001;
        var SUBDIVISION_PRECISION = 0.0000001;
        var SUBDIVISION_MAX_ITERATIONS = 10;
        var kSplineTableSize = 11;
        var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
        var float32ArraySupported = typeof Float32Array === 'function';
        function A(aA1, aA2) {
            return 1.0 - 3.0 * aA2 + 3.0 * aA1;
        }
        function B(aA1, aA2) {
            return 3.0 * aA2 - 6.0 * aA1;
        }
        function C(aA1) {
            return 3.0 * aA1;
        } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
        function calcBezier(aT, aA1, aA2) {
            return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
        } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
        function getSlope(aT, aA1, aA2) {
            return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
        }
        function binarySubdivide(aX, aA, aB, mX1, mX2) {
            var currentX, currentT, i = 0;
            do {
                currentT = aA + (aB - aA) / 2.0;
                currentX = calcBezier(currentT, mX1, mX2) - aX;
                if (currentX > 0.0) aB = currentT;
                else aA = currentT;
            }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
            return currentT;
        }
        function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
            for(var i = 0; i < NEWTON_ITERATIONS; ++i){
                var currentSlope = getSlope(aGuessT, mX1, mX2);
                if (currentSlope === 0.0) return aGuessT;
                var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
                aGuessT -= currentX / currentSlope;
            }
            return aGuessT;
        }
        /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */ function BezierEasing(points) {
            this._p = points;
            this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
            this._precomputed = false;
            this.get = this.get.bind(this);
        }
        BezierEasing.prototype = {
            get: function get(x) {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                if (!this._precomputed) this._precompute();
                if (mX1 === mY1 && mX2 === mY2) return x; // linear
                // Because JavaScript number are imprecise, we should guarantee the extremes are right.
                if (x === 0) return 0;
                if (x === 1) return 1;
                return calcBezier(this._getTForX(x), mY1, mY2);
            },
            // Private part
            _precompute: function _precompute() {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                this._precomputed = true;
                if (mX1 !== mY1 || mX2 !== mY2) this._calcSampleValues();
            },
            _calcSampleValues: function _calcSampleValues() {
                var mX1 = this._p[0], mX2 = this._p[2];
                for(var i = 0; i < kSplineTableSize; ++i)this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            },
            /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */ _getTForX: function _getTForX(aX) {
                var mX1 = this._p[0], mX2 = this._p[2], mSampleValues = this._mSampleValues;
                var intervalStart = 0.0;
                var currentSample = 1;
                var lastSample = kSplineTableSize - 1;
                for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
                --currentSample; // Interpolate to provide an initial guess for t
                var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
                var guessForT = intervalStart + dist * kSampleStepSize;
                var initialSlope = getSlope(guessForT, mX1, mX2);
                if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
                if (initialSlope === 0.0) return guessForT;
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
            }
        };
        return ob;
    }();
    var pooling = function() {
        function _double(arr) {
            return arr.concat(createSizedArray(arr.length));
        }
        return {
            "double": _double
        };
    }();
    var poolFactory = function() {
        return function(initialLength, _create, _release) {
            var _length = 0;
            var _maxLength = initialLength;
            var pool = createSizedArray(_maxLength);
            var ob = {
                newElement: newElement,
                release: release
            };
            function newElement() {
                var element;
                if (_length) {
                    _length -= 1;
                    element = pool[_length];
                } else element = _create();
                return element;
            }
            function release(element) {
                if (_length === _maxLength) {
                    pool = pooling["double"](pool);
                    _maxLength *= 2;
                }
                if (_release) _release(element);
                pool[_length] = element;
                _length += 1;
            }
            return ob;
        };
    }();
    var bezierLengthPool = function() {
        function create() {
            return {
                addedLength: 0,
                percents: createTypedArray('float32', getDefaultCurveSegments()),
                lengths: createTypedArray('float32', getDefaultCurveSegments())
            };
        }
        return poolFactory(8, create);
    }();
    var segmentsLengthPool = function() {
        function create() {
            return {
                lengths: [],
                totalLength: 0
            };
        }
        function release(element) {
            var i;
            var len = element.lengths.length;
            for(i = 0; i < len; i += 1)bezierLengthPool.release(element.lengths[i]);
            element.lengths.length = 0;
        }
        return poolFactory(8, create, release);
    }();
    function bezFunction() {
        var math = Math;
        function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
            var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
            return det1 > -0.001 && det1 < 0.001;
        }
        function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
            if (z1 === 0 && z2 === 0 && z3 === 0) return pointOnLine2D(x1, y1, x2, y2, x3, y3);
            var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
            var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
            var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
            var diffDist;
            if (dist1 > dist2) {
                if (dist1 > dist3) diffDist = dist1 - dist2 - dist3;
                else diffDist = dist3 - dist2 - dist1;
            } else if (dist3 > dist2) diffDist = dist3 - dist2 - dist1;
            else diffDist = dist2 - dist1 - dist3;
            return diffDist > -0.0001 && diffDist < 0.0001;
        }
        var getBezierLength = function() {
            return function(pt1, pt2, pt3, pt4) {
                var curveSegments = getDefaultCurveSegments();
                var k;
                var i;
                var len;
                var ptCoord;
                var perc;
                var addedLength = 0;
                var ptDistance;
                var point = [];
                var lastPoint = [];
                var lengthData = bezierLengthPool.newElement();
                len = pt3.length;
                for(k = 0; k < curveSegments; k += 1){
                    perc = k / (curveSegments - 1);
                    ptDistance = 0;
                    for(i = 0; i < len; i += 1){
                        ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
                        point[i] = ptCoord;
                        if (lastPoint[i] !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        lastPoint[i] = point[i];
                    }
                    if (ptDistance) {
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                    }
                    lengthData.percents[k] = perc;
                    lengthData.lengths[k] = addedLength;
                }
                lengthData.addedLength = addedLength;
                return lengthData;
            };
        }();
        function getSegmentsLength(shapeData) {
            var segmentsLength = segmentsLengthPool.newElement();
            var closed = shapeData.c;
            var pathV = shapeData.v;
            var pathO = shapeData.o;
            var pathI = shapeData.i;
            var i;
            var len = shapeData._length;
            var lengths = segmentsLength.lengths;
            var totalLength = 0;
            for(i = 0; i < len - 1; i += 1){
                lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
                totalLength += lengths[i].addedLength;
            }
            if (closed && len) {
                lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
                totalLength += lengths[i].addedLength;
            }
            segmentsLength.totalLength = totalLength;
            return segmentsLength;
        }
        function BezierData(length) {
            this.segmentLength = 0;
            this.points = new Array(length);
        }
        function PointData(partial, point) {
            this.partialLength = partial;
            this.point = point;
        }
        var buildBezierData = function() {
            var storedData = {};
            return function(pt1, pt2, pt3, pt4) {
                var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
                if (!storedData[bezierName]) {
                    var curveSegments = getDefaultCurveSegments();
                    var k;
                    var i;
                    var len;
                    var ptCoord;
                    var perc;
                    var addedLength = 0;
                    var ptDistance;
                    var point;
                    var lastPoint = null;
                    if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) curveSegments = 2;
                    var bezierData = new BezierData(curveSegments);
                    len = pt3.length;
                    for(k = 0; k < curveSegments; k += 1){
                        point = createSizedArray(len);
                        perc = k / (curveSegments - 1);
                        ptDistance = 0;
                        for(i = 0; i < len; i += 1){
                            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
                            point[i] = ptCoord;
                            if (lastPoint !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        }
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                        bezierData.points[k] = new PointData(ptDistance, point);
                        lastPoint = point;
                    }
                    bezierData.segmentLength = addedLength;
                    storedData[bezierName] = bezierData;
                }
                return storedData[bezierName];
            };
        }();
        function getDistancePerc(perc, bezierData) {
            var percents = bezierData.percents;
            var lengths = bezierData.lengths;
            var len = percents.length;
            var initPos = bmFloor((len - 1) * perc);
            var lengthPos = perc * bezierData.addedLength;
            var lPerc = 0;
            if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) return percents[initPos];
            var dir = lengths[initPos] > lengthPos ? -1 : 1;
            var flag = true;
            while(flag){
                if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
                    lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
                    flag = false;
                } else initPos += dir;
                if (initPos < 0 || initPos >= len - 1) {
                    // FIX for TypedArrays that don't store floating point values with enough accuracy
                    if (initPos === len - 1) return percents[initPos];
                    flag = false;
                }
            }
            return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
        }
        function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
            var t1 = getDistancePerc(percent, bezierData);
            var u1 = 1 - t1;
            var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
            var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
            return [
                ptX,
                ptY
            ];
        }
        var bezierSegmentPoints = createTypedArray('float32', 8);
        function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
            if (startPerc < 0) startPerc = 0;
            else if (startPerc > 1) startPerc = 1;
            var t0 = getDistancePerc(startPerc, bezierData);
            endPerc = endPerc > 1 ? 1 : endPerc;
            var t1 = getDistancePerc(endPerc, bezierData);
            var i;
            var len = pt1.length;
            var u0 = 1 - t0;
            var u1 = 1 - t1;
            var u0u0u0 = u0 * u0 * u0;
            var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0t0 = t0 * t0 * t0; //
            var u0u0u1 = u0 * u0 * u1;
            var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0t1 = t0 * t0 * t1; //
            var u0u1u1 = u0 * u1 * u1;
            var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1t1 = t0 * t1 * t1; //
            var u1u1u1 = u1 * u1 * u1;
            var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1t1 = t1 * t1 * t1;
            for(i = 0; i < len; i += 1){
                bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
            }
            return bezierSegmentPoints;
        }
        return {
            getSegmentsLength: getSegmentsLength,
            getNewSegment: getNewSegment,
            getPointInSegment: getPointInSegment,
            buildBezierData: buildBezierData,
            pointOnLine2D: pointOnLine2D,
            pointOnLine3D: pointOnLine3D
        };
    }
    var bez = bezFunction();
    var PropertyFactory = function() {
        var initFrame = initialDefaultFrame;
        var mathAbs = Math.abs;
        function interpolateValue(frameNum, caching) {
            var offsetTime = this.offsetTime;
            var newValue;
            if (this.propType === 'multidimensional') newValue = createTypedArray('float32', this.pv.length);
            var iterationIndex = caching.lastIndex;
            var i = iterationIndex;
            var len = this.keyframes.length - 1;
            var flag = true;
            var keyData;
            var nextKeyData;
            var keyframeMetadata;
            while(flag){
                keyData = this.keyframes[i];
                nextKeyData = this.keyframes[i + 1];
                if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
                    if (keyData.h) keyData = nextKeyData;
                    iterationIndex = 0;
                    break;
                }
                if (nextKeyData.t - offsetTime > frameNum) {
                    iterationIndex = i;
                    break;
                }
                if (i < len - 1) i += 1;
                else {
                    iterationIndex = 0;
                    flag = false;
                }
            }
            keyframeMetadata = this.keyframesMetadata[i] || {};
            var k;
            var kLen;
            var perc;
            var jLen;
            var j;
            var fnc;
            var nextKeyTime = nextKeyData.t - offsetTime;
            var keyTime = keyData.t - offsetTime;
            var endValue;
            if (keyData.to) {
                if (!keyframeMetadata.bezierData) keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
                var bezierData = keyframeMetadata.bezierData;
                if (frameNum >= nextKeyTime || frameNum < keyTime) {
                    var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
                    kLen = bezierData.points[ind].point.length;
                    for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[ind].point[k];
                     // caching._lastKeyframeIndex = -1;
                } else {
                    if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                    else {
                        fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
                        keyframeMetadata.__fnct = fnc;
                    }
                    perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                    var distanceInLine = bezierData.segmentLength * perc;
                    var segmentPerc;
                    var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
                    j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
                    flag = true;
                    jLen = bezierData.points.length;
                    while(flag){
                        addedLength += bezierData.points[j].partialLength;
                        if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
                            kLen = bezierData.points[j].point.length;
                            for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k];
                            break;
                        } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
                            segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
                            kLen = bezierData.points[j].point.length;
                            for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
                            break;
                        }
                        if (j < jLen - 1) j += 1;
                        else flag = false;
                    }
                    caching._lastPoint = j;
                    caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
                    caching._lastKeyframeIndex = i;
                }
            } else {
                var outX;
                var outY;
                var inX;
                var inY;
                var keyValue;
                len = keyData.s.length;
                endValue = nextKeyData.s || keyData.e;
                if (this.sh && keyData.h !== 1) {
                    if (frameNum >= nextKeyTime) {
                        newValue[0] = endValue[0];
                        newValue[1] = endValue[1];
                        newValue[2] = endValue[2];
                    } else if (frameNum <= keyTime) {
                        newValue[0] = keyData.s[0];
                        newValue[1] = keyData.s[1];
                        newValue[2] = keyData.s[2];
                    } else {
                        var quatStart = createQuaternion(keyData.s);
                        var quatEnd = createQuaternion(endValue);
                        var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
                        quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
                    }
                } else for(i = 0; i < len; i += 1){
                    if (keyData.h !== 1) {
                        if (frameNum >= nextKeyTime) perc = 1;
                        else if (frameNum < keyTime) perc = 0;
                        else {
                            if (keyData.o.x.constructor === Array) {
                                if (!keyframeMetadata.__fnct) keyframeMetadata.__fnct = [];
                                if (!keyframeMetadata.__fnct[i]) {
                                    outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                                    outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                                    inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                                    inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                                    fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                                    keyframeMetadata.__fnct[i] = fnc;
                                } else fnc = keyframeMetadata.__fnct[i];
                            } else if (!keyframeMetadata.__fnct) {
                                outX = keyData.o.x;
                                outY = keyData.o.y;
                                inX = keyData.i.x;
                                inY = keyData.i.y;
                                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                                keyData.keyframeMetadata = fnc;
                            } else fnc = keyframeMetadata.__fnct;
                            perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                        }
                    }
                    endValue = nextKeyData.s || keyData.e;
                    keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
                    if (this.propType === 'multidimensional') newValue[i] = keyValue;
                    else newValue = keyValue;
                }
            }
            caching.lastIndex = iterationIndex;
            return newValue;
        } // based on @Toji's https://github.com/toji/gl-matrix/
        function slerp(a, b, t) {
            var out = [];
            var ax = a[0];
            var ay = a[1];
            var az = a[2];
            var aw = a[3];
            var bx = b[0];
            var by = b[1];
            var bz = b[2];
            var bw = b[3];
            var omega;
            var cosom;
            var sinom;
            var scale0;
            var scale1;
            cosom = ax * bx + ay * by + az * bz + aw * bw;
            if (cosom < 0.0) {
                cosom = -cosom;
                bx = -bx;
                by = -by;
                bz = -bz;
                bw = -bw;
            }
            if (1.0 - cosom > 0.000001) {
                omega = Math.acos(cosom);
                sinom = Math.sin(omega);
                scale0 = Math.sin((1.0 - t) * omega) / sinom;
                scale1 = Math.sin(t * omega) / sinom;
            } else {
                scale0 = 1.0 - t;
                scale1 = t;
            }
            out[0] = scale0 * ax + scale1 * bx;
            out[1] = scale0 * ay + scale1 * by;
            out[2] = scale0 * az + scale1 * bz;
            out[3] = scale0 * aw + scale1 * bw;
            return out;
        }
        function quaternionToEuler(out, quat) {
            var qx = quat[0];
            var qy = quat[1];
            var qz = quat[2];
            var qw = quat[3];
            var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
            var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
            var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
            out[0] = heading / degToRads;
            out[1] = attitude / degToRads;
            out[2] = bank / degToRads;
        }
        function createQuaternion(values) {
            var heading = values[0] * degToRads;
            var attitude = values[1] * degToRads;
            var bank = values[2] * degToRads;
            var c1 = Math.cos(heading / 2);
            var c2 = Math.cos(attitude / 2);
            var c3 = Math.cos(bank / 2);
            var s1 = Math.sin(heading / 2);
            var s2 = Math.sin(attitude / 2);
            var s3 = Math.sin(bank / 2);
            var w = c1 * c2 * c3 - s1 * s2 * s3;
            var x = s1 * s2 * c3 + c1 * c2 * s3;
            var y = s1 * c2 * c3 + c1 * s2 * s3;
            var z = c1 * s2 * c3 - s1 * c2 * s3;
            return [
                x,
                y,
                z,
                w
            ];
        }
        function getValueAtCurrentTime() {
            var frameNum = this.comp.renderedFrame - this.offsetTime;
            var initTime = this.keyframes[0].t - this.offsetTime;
            var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
                if (this._caching.lastFrame >= frameNum) {
                    this._caching._lastKeyframeIndex = -1;
                    this._caching.lastIndex = 0;
                }
                var renderResult = this.interpolateValue(frameNum, this._caching);
                this.pv = renderResult;
            }
            this._caching.lastFrame = frameNum;
            return this.pv;
        }
        function setVValue(val) {
            var multipliedValue;
            if (this.propType === 'unidimensional') {
                multipliedValue = val * this.mult;
                if (mathAbs(this.v - multipliedValue) > 0.00001) {
                    this.v = multipliedValue;
                    this._mdf = true;
                }
            } else {
                var i = 0;
                var len = this.v.length;
                while(i < len){
                    multipliedValue = val[i] * this.mult;
                    if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
                        this.v[i] = multipliedValue;
                        this._mdf = true;
                    }
                    i += 1;
                }
            }
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) return;
            if (this.lock) {
                this.setVValue(this.pv);
                return;
            }
            this.lock = true;
            this._mdf = this._isFirstFrame;
            var i;
            var len = this.effectsSequence.length;
            var finalValue = this.kf ? this.pv : this.data.k;
            for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
            this.setVValue(finalValue);
            this._isFirstFrame = false;
            this.lock = false;
            this.frameId = this.elem.globalData.frameId;
        }
        function addEffect(effectFunction) {
            this.effectsSequence.push(effectFunction);
            this.container.addDynamicProperty(this);
        }
        function ValueProperty(elem, data, mult, container) {
            this.propType = 'unidimensional';
            this.mult = mult || 1;
            this.data = data;
            this.v = mult ? data.k * mult : data.k;
            this.pv = data.k;
            this._mdf = false;
            this.elem = elem;
            this.container = container;
            this.comp = elem.comp;
            this.k = false;
            this.kf = false;
            this.vel = 0;
            this.effectsSequence = [];
            this._isFirstFrame = true;
            this.getValue = processEffectsSequence;
            this.setVValue = setVValue;
            this.addEffect = addEffect;
        }
        function MultiDimensionalProperty(elem, data, mult, container) {
            this.propType = 'multidimensional';
            this.mult = mult || 1;
            this.data = data;
            this._mdf = false;
            this.elem = elem;
            this.container = container;
            this.comp = elem.comp;
            this.k = false;
            this.kf = false;
            this.frameId = -1;
            var i;
            var len = data.k.length;
            this.v = createTypedArray('float32', len);
            this.pv = createTypedArray('float32', len);
            this.vel = createTypedArray('float32', len);
            for(i = 0; i < len; i += 1){
                this.v[i] = data.k[i] * this.mult;
                this.pv[i] = data.k[i];
            }
            this._isFirstFrame = true;
            this.effectsSequence = [];
            this.getValue = processEffectsSequence;
            this.setVValue = setVValue;
            this.addEffect = addEffect;
        }
        function KeyframedValueProperty(elem, data, mult, container) {
            this.propType = 'unidimensional';
            this.keyframes = data.k;
            this.keyframesMetadata = [];
            this.offsetTime = elem.data.st;
            this.frameId = -1;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0,
                value: 0,
                _lastKeyframeIndex: -1
            };
            this.k = true;
            this.kf = true;
            this.data = data;
            this.mult = mult || 1;
            this.elem = elem;
            this.container = container;
            this.comp = elem.comp;
            this.v = initFrame;
            this.pv = initFrame;
            this._isFirstFrame = true;
            this.getValue = processEffectsSequence;
            this.setVValue = setVValue;
            this.interpolateValue = interpolateValue;
            this.effectsSequence = [
                getValueAtCurrentTime.bind(this)
            ];
            this.addEffect = addEffect;
        }
        function KeyframedMultidimensionalProperty(elem, data, mult, container) {
            this.propType = 'multidimensional';
            var i;
            var len = data.k.length;
            var s;
            var e;
            var to;
            var ti;
            for(i = 0; i < len - 1; i += 1)if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
                s = data.k[i].s;
                e = data.k[i + 1].s;
                to = data.k[i].to;
                ti = data.k[i].ti;
                if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
                    data.k[i].to = null;
                    data.k[i].ti = null;
                }
                if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
                    if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
                        data.k[i].to = null;
                        data.k[i].ti = null;
                    }
                }
            }
            this.effectsSequence = [
                getValueAtCurrentTime.bind(this)
            ];
            this.data = data;
            this.keyframes = data.k;
            this.keyframesMetadata = [];
            this.offsetTime = elem.data.st;
            this.k = true;
            this.kf = true;
            this._isFirstFrame = true;
            this.mult = mult || 1;
            this.elem = elem;
            this.container = container;
            this.comp = elem.comp;
            this.getValue = processEffectsSequence;
            this.setVValue = setVValue;
            this.interpolateValue = interpolateValue;
            this.frameId = -1;
            var arrLen = data.k[0].s.length;
            this.v = createTypedArray('float32', arrLen);
            this.pv = createTypedArray('float32', arrLen);
            for(i = 0; i < arrLen; i += 1){
                this.v[i] = initFrame;
                this.pv[i] = initFrame;
            }
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0,
                value: createTypedArray('float32', arrLen)
            };
            this.addEffect = addEffect;
        }
        function getProp(elem, data, type, mult, container) {
            var p;
            if (!data.k.length) p = new ValueProperty(elem, data, mult, container);
            else if (typeof data.k[0] === 'number') p = new MultiDimensionalProperty(elem, data, mult, container);
            else switch(type){
                case 0:
                    p = new KeyframedValueProperty(elem, data, mult, container);
                    break;
                case 1:
                    p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
                    break;
                default:
                    break;
            }
            if (p.effectsSequence.length) container.addDynamicProperty(p);
            return p;
        }
        var ob = {
            getProp: getProp
        };
        return ob;
    }();
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) {
                this.dynamicProperties.push(prop);
                this.container.addDynamicProperty(this);
                this._isAnimated = true;
            }
        },
        iterateDynamicProperties: function iterateDynamicProperties() {
            this._mdf = false;
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1){
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) this._mdf = true;
            }
        },
        initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
            this.container = container;
            this.dynamicProperties = [];
            this._mdf = false;
            this._isAnimated = false;
        }
    };
    var pointPool = function() {
        function create() {
            return createTypedArray('float32', 2);
        }
        return poolFactory(8, create);
    }();
    function ShapePath() {
        this.c = false;
        this._length = 0;
        this._maxLength = 8;
        this.v = createSizedArray(this._maxLength);
        this.o = createSizedArray(this._maxLength);
        this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(closed, len) {
        this.c = closed;
        this.setLength(len);
        var i = 0;
        while(i < len){
            this.v[i] = pointPool.newElement();
            this.o[i] = pointPool.newElement();
            this.i[i] = pointPool.newElement();
            i += 1;
        }
    };
    ShapePath.prototype.setLength = function(len) {
        while(this._maxLength < len)this.doubleArrayLength();
        this._length = len;
    };
    ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength));
        this.i = this.i.concat(createSizedArray(this._maxLength));
        this.o = this.o.concat(createSizedArray(this._maxLength));
        this._maxLength *= 2;
    };
    ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
        var arr;
        this._length = Math.max(this._length, pos + 1);
        if (this._length >= this._maxLength) this.doubleArrayLength();
        switch(type){
            case 'v':
                arr = this.v;
                break;
            case 'i':
                arr = this.i;
                break;
            case 'o':
                arr = this.o;
                break;
            default:
                arr = [];
                break;
        }
        if (!arr[pos] || arr[pos] && !replace) arr[pos] = pointPool.newElement();
        arr[pos][0] = x;
        arr[pos][1] = y;
    };
    ShapePath.prototype.setTripleAt = function(vX, vY, oX, oY, iX, iY, pos, replace) {
        this.setXYAt(vX, vY, 'v', pos, replace);
        this.setXYAt(oX, oY, 'o', pos, replace);
        this.setXYAt(iX, iY, 'i', pos, replace);
    };
    ShapePath.prototype.reverse = function() {
        var newPath = new ShapePath();
        newPath.setPathData(this.c, this._length);
        var vertices = this.v;
        var outPoints = this.o;
        var inPoints = this.i;
        var init = 0;
        if (this.c) {
            newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
            init = 1;
        }
        var cnt = this._length - 1;
        var len = this._length;
        var i;
        for(i = init; i < len; i += 1){
            newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
            cnt -= 1;
        }
        return newPath;
    };
    ShapePath.prototype.length = function() {
        return this._length;
    };
    var shapePool = function() {
        function create() {
            return new ShapePath();
        }
        function release(shapePath) {
            var len = shapePath._length;
            var i;
            for(i = 0; i < len; i += 1){
                pointPool.release(shapePath.v[i]);
                pointPool.release(shapePath.i[i]);
                pointPool.release(shapePath.o[i]);
                shapePath.v[i] = null;
                shapePath.i[i] = null;
                shapePath.o[i] = null;
            }
            shapePath._length = 0;
            shapePath.c = false;
        }
        function clone(shape) {
            var cloned = factory.newElement();
            var i;
            var len = shape._length === undefined ? shape.v.length : shape._length;
            cloned.setLength(len);
            cloned.c = shape.c;
            for(i = 0; i < len; i += 1)cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
            return cloned;
        }
        var factory = poolFactory(4, create, release);
        factory.clone = clone;
        return factory;
    }();
    function ShapeCollection() {
        this._length = 0;
        this._maxLength = 4;
        this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(shapeData) {
        if (this._length === this._maxLength) {
            this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
            this._maxLength *= 2;
        }
        this.shapes[this._length] = shapeData;
        this._length += 1;
    };
    ShapeCollection.prototype.releaseShapes = function() {
        var i;
        for(i = 0; i < this._length; i += 1)shapePool.release(this.shapes[i]);
        this._length = 0;
    };
    var shapeCollectionPool = function() {
        var ob = {
            newShapeCollection: newShapeCollection,
            release: release
        };
        var _length = 0;
        var _maxLength = 4;
        var pool = createSizedArray(_maxLength);
        function newShapeCollection() {
            var shapeCollection;
            if (_length) {
                _length -= 1;
                shapeCollection = pool[_length];
            } else shapeCollection = new ShapeCollection();
            return shapeCollection;
        }
        function release(shapeCollection) {
            var i;
            var len = shapeCollection._length;
            for(i = 0; i < len; i += 1)shapePool.release(shapeCollection.shapes[i]);
            shapeCollection._length = 0;
            if (_length === _maxLength) {
                pool = pooling["double"](pool);
                _maxLength *= 2;
            }
            pool[_length] = shapeCollection;
            _length += 1;
        }
        return ob;
    }();
    var ShapePropertyFactory = function() {
        var initFrame = -999999;
        function interpolateShape(frameNum, previousValue, caching) {
            var iterationIndex = caching.lastIndex;
            var keyPropS;
            var keyPropE;
            var isHold;
            var j;
            var k;
            var jLen;
            var kLen;
            var perc;
            var vertexValue;
            var kf = this.keyframes;
            if (frameNum < kf[0].t - this.offsetTime) {
                keyPropS = kf[0].s[0];
                isHold = true;
                iterationIndex = 0;
            } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
                keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
                /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */ isHold = true;
            } else {
                var i = iterationIndex;
                var len = kf.length - 1;
                var flag = true;
                var keyData;
                var nextKeyData;
                var keyframeMetadata;
                while(flag){
                    keyData = kf[i];
                    nextKeyData = kf[i + 1];
                    if (nextKeyData.t - this.offsetTime > frameNum) break;
                    if (i < len - 1) i += 1;
                    else flag = false;
                }
                keyframeMetadata = this.keyframesMetadata[i] || {};
                isHold = keyData.h === 1;
                iterationIndex = i;
                if (!isHold) {
                    if (frameNum >= nextKeyData.t - this.offsetTime) perc = 1;
                    else if (frameNum < keyData.t - this.offsetTime) perc = 0;
                    else {
                        var fnc;
                        if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                        else {
                            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
                            keyframeMetadata.__fnct = fnc;
                        }
                        perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
                    }
                    keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
                }
                keyPropS = keyData.s[0];
            }
            jLen = previousValue._length;
            kLen = keyPropS.i[0].length;
            caching.lastIndex = iterationIndex;
            for(j = 0; j < jLen; j += 1)for(k = 0; k < kLen; k += 1){
                vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
                previousValue.i[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
                previousValue.o[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
                previousValue.v[j][k] = vertexValue;
            }
        }
        function interpolateShapeCurrentTime() {
            var frameNum = this.comp.renderedFrame - this.offsetTime;
            var initTime = this.keyframes[0].t - this.offsetTime;
            var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            var lastFrame = this._caching.lastFrame;
            if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
                /// /
                this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
                this.interpolateShape(frameNum, this.pv, this._caching); /// /
            }
            this._caching.lastFrame = frameNum;
            return this.pv;
        }
        function resetShape() {
            this.paths = this.localShapeCollection;
        }
        function shapesEqual(shape1, shape2) {
            if (shape1._length !== shape2._length || shape1.c !== shape2.c) return false;
            var i;
            var len = shape1._length;
            for(i = 0; i < len; i += 1){
                if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) return false;
            }
            return true;
        }
        function setVValue(newPath) {
            if (!shapesEqual(this.v, newPath)) {
                this.v = shapePool.clone(newPath);
                this.localShapeCollection.releaseShapes();
                this.localShapeCollection.addShape(this.v);
                this._mdf = true;
                this.paths = this.localShapeCollection;
            }
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (!this.effectsSequence.length) {
                this._mdf = false;
                return;
            }
            if (this.lock) {
                this.setVValue(this.pv);
                return;
            }
            this.lock = true;
            this._mdf = false;
            var finalValue;
            if (this.kf) finalValue = this.pv;
            else if (this.data.ks) finalValue = this.data.ks.k;
            else finalValue = this.data.pt.k;
            var i;
            var len = this.effectsSequence.length;
            for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
            this.setVValue(finalValue);
            this.lock = false;
            this.frameId = this.elem.globalData.frameId;
        }
        function ShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.container = elem;
            this.elem = elem;
            this.data = data;
            this.k = false;
            this.kf = false;
            this._mdf = false;
            var pathData = type === 3 ? data.pt.k : data.ks.k;
            this.v = shapePool.clone(pathData);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.reset = resetShape;
            this.effectsSequence = [];
        }
        function addEffect(effectFunction) {
            this.effectsSequence.push(effectFunction);
            this.container.addDynamicProperty(this);
        }
        ShapeProperty.prototype.interpolateShape = interpolateShape;
        ShapeProperty.prototype.getValue = processEffectsSequence;
        ShapeProperty.prototype.setVValue = setVValue;
        ShapeProperty.prototype.addEffect = addEffect;
        function KeyframedShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.elem = elem;
            this.container = elem;
            this.offsetTime = elem.data.st;
            this.keyframes = type === 3 ? data.pt.k : data.ks.k;
            this.keyframesMetadata = [];
            this.k = true;
            this.kf = true;
            var len = this.keyframes[0].s[0].i.length;
            this.v = shapePool.newElement();
            this.v.setPathData(this.keyframes[0].s[0].c, len);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.lastFrame = initFrame;
            this.reset = resetShape;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0
            };
            this.effectsSequence = [
                interpolateShapeCurrentTime.bind(this)
            ];
        }
        KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
        KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
        KeyframedShapeProperty.prototype.setVValue = setVValue;
        KeyframedShapeProperty.prototype.addEffect = addEffect;
        var EllShapeProperty = function() {
            var cPoint = roundCorner;
            function EllShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 4);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.paths = this.localShapeCollection;
                this.localShapeCollection.addShape(this.v);
                this.d = data.d;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertEllToPath();
                }
            }
            EllShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertEllToPath();
                },
                convertEllToPath: function convertEllToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var s0 = this.s.v[0] / 2;
                    var s1 = this.s.v[1] / 2;
                    var _cw = this.d !== 3;
                    var _v = this.v;
                    _v.v[0][0] = p0;
                    _v.v[0][1] = p1 - s1;
                    _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.v[1][1] = p1;
                    _v.v[2][0] = p0;
                    _v.v[2][1] = p1 + s1;
                    _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.v[3][1] = p1;
                    _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.i[0][1] = p1 - s1;
                    _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.i[1][1] = p1 - s1 * cPoint;
                    _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.i[2][1] = p1 + s1;
                    _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.i[3][1] = p1 + s1 * cPoint;
                    _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.o[0][1] = p1 - s1;
                    _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.o[1][1] = p1 + s1 * cPoint;
                    _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.o[2][1] = p1 + s1;
                    _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.o[3][1] = p1 - s1 * cPoint;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], EllShapePropertyFactory);
            return EllShapePropertyFactory;
        }();
        var StarShapeProperty = function() {
            function StarShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 0);
                this.elem = elem;
                this.comp = elem.comp;
                this.data = data;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                if (data.sy === 1) {
                    this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
                    this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
                    this.convertToPath = this.convertStarToPath;
                } else this.convertToPath = this.convertPolygonToPath;
                this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
                this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
                this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertToPath();
                }
            }
            StarShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertToPath();
                },
                convertStarToPath: function convertStarToPath() {
                    var numPts = Math.floor(this.pt.v) * 2;
                    var angle = Math.PI * 2 / numPts;
                    /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */ var longFlag = true;
                    var longRad = this.or.v;
                    var shortRad = this.ir.v;
                    var longRound = this.os.v;
                    var shortRound = this.is.v;
                    var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
                    var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
                    var i;
                    var rad;
                    var roundness;
                    var perimSegment;
                    var currentAng = -Math.PI / 2;
                    currentAng += this.r.v;
                    var dir = this.data.d === 3 ? -1 : 1;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        rad = longFlag ? longRad : shortRad;
                        roundness = longFlag ? longRound : shortRound;
                        perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */ longFlag = !longFlag;
                        currentAng += angle * dir;
                    }
                },
                convertPolygonToPath: function convertPolygonToPath() {
                    var numPts = Math.floor(this.pt.v);
                    var angle = Math.PI * 2 / numPts;
                    var rad = this.or.v;
                    var roundness = this.os.v;
                    var perimSegment = 2 * Math.PI * rad / (numPts * 4);
                    var i;
                    var currentAng = -Math.PI * 0.5;
                    var dir = this.data.d === 3 ? -1 : 1;
                    currentAng += this.r.v;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        currentAng += angle * dir;
                    }
                    this.paths.length = 0;
                    this.paths[0] = this.v;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], StarShapePropertyFactory);
            return StarShapePropertyFactory;
        }();
        var RectShapeProperty = function() {
            function RectShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.c = true;
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertRectToPath();
                }
            }
            RectShapePropertyFactory.prototype = {
                convertRectToPath: function convertRectToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var v0 = this.s.v[0] / 2;
                    var v1 = this.s.v[1] / 2;
                    var round = bmMin(v0, v1, this.r.v);
                    var cPoint = round * (1 - roundCorner);
                    this.v._length = 0;
                    if (this.d === 2 || this.d === 1) {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
                        this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
                        }
                    } else {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
                        }
                    }
                },
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertRectToPath();
                },
                reset: resetShape
            };
            extendPrototype([
                DynamicPropertyContainer
            ], RectShapePropertyFactory);
            return RectShapePropertyFactory;
        }();
        function getShapeProp(elem, data, type) {
            var prop;
            if (type === 3 || type === 4) {
                var dataProp = type === 3 ? data.pt : data.ks;
                var keys = dataProp.k;
                if (keys.length) prop = new KeyframedShapeProperty(elem, data, type);
                else prop = new ShapeProperty(elem, data, type);
            } else if (type === 5) prop = new RectShapeProperty(elem, data);
            else if (type === 6) prop = new EllShapeProperty(elem, data);
            else if (type === 7) prop = new StarShapeProperty(elem, data);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        }
        function getConstructorFunction() {
            return ShapeProperty;
        }
        function getKeyframedConstructorFunction() {
            return KeyframedShapeProperty;
        }
        var ob = {};
        ob.getShapeProp = getShapeProp;
        ob.getConstructorFunction = getConstructorFunction;
        ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
        return ob;
    }();
    /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */ /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */ var Matrix = function() {
        var _cos = Math.cos;
        var _sin = Math.sin;
        var _tan = Math.tan;
        var _rnd = Math.round;
        function reset() {
            this.props[0] = 1;
            this.props[1] = 0;
            this.props[2] = 0;
            this.props[3] = 0;
            this.props[4] = 0;
            this.props[5] = 1;
            this.props[6] = 0;
            this.props[7] = 0;
            this.props[8] = 0;
            this.props[9] = 0;
            this.props[10] = 1;
            this.props[11] = 0;
            this.props[12] = 0;
            this.props[13] = 0;
            this.props[14] = 0;
            this.props[15] = 1;
            return this;
        }
        function rotate(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function rotateX(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
        }
        function rotateY(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
        }
        function rotateZ(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function shear(sx, sy) {
            return this._t(1, sy, sx, 1, 0, 0);
        }
        function skew(ax, ay) {
            return this.shear(_tan(ax), _tan(ay));
        }
        function skewFromAxis(ax, angle) {
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
        }
        function scale(sx, sy, sz) {
            if (!sz && sz !== 0) sz = 1;
            if (sx === 1 && sy === 1 && sz === 1) return this;
            return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
        }
        function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
            this.props[0] = a;
            this.props[1] = b;
            this.props[2] = c;
            this.props[3] = d;
            this.props[4] = e;
            this.props[5] = f;
            this.props[6] = g;
            this.props[7] = h;
            this.props[8] = i;
            this.props[9] = j;
            this.props[10] = k;
            this.props[11] = l;
            this.props[12] = m;
            this.props[13] = n;
            this.props[14] = o;
            this.props[15] = p;
            return this;
        }
        function translate(tx, ty, tz) {
            tz = tz || 0;
            if (tx !== 0 || ty !== 0 || tz !== 0) return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
            return this;
        }
        function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
            var _p = this.props;
            if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
                // NOTE: commenting this condition because TurboFan deoptimizes code when present
                // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
                _p[12] = _p[12] * a2 + _p[15] * m2;
                _p[13] = _p[13] * f2 + _p[15] * n2;
                _p[14] = _p[14] * k2 + _p[15] * o2;
                _p[15] *= p2; // }
                this._identityCalculated = false;
                return this;
            }
            var a1 = _p[0];
            var b1 = _p[1];
            var c1 = _p[2];
            var d1 = _p[3];
            var e1 = _p[4];
            var f1 = _p[5];
            var g1 = _p[6];
            var h1 = _p[7];
            var i1 = _p[8];
            var j1 = _p[9];
            var k1 = _p[10];
            var l1 = _p[11];
            var m1 = _p[12];
            var n1 = _p[13];
            var o1 = _p[14];
            var p1 = _p[15];
            /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */ _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
            _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
            _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
            _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
            _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
            _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
            _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
            _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
            _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
            _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
            _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
            _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
            _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
            _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
            _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
            _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
            this._identityCalculated = false;
            return this;
        }
        function isIdentity() {
            if (!this._identityCalculated) {
                this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
                this._identityCalculated = true;
            }
            return this._identity;
        }
        function equals(matr) {
            var i = 0;
            while(i < 16){
                if (matr.props[i] !== this.props[i]) return false;
                i += 1;
            }
            return true;
        }
        function clone(matr) {
            var i;
            for(i = 0; i < 16; i += 1)matr.props[i] = this.props[i];
            return matr;
        }
        function cloneFromProps(props) {
            var i;
            for(i = 0; i < 16; i += 1)this.props[i] = props[i];
        }
        function applyToPoint(x, y, z) {
            return {
                x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            };
        /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */ }
        function applyToX(x, y, z) {
            return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
        }
        function applyToY(x, y, z) {
            return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
        }
        function applyToZ(x, y, z) {
            return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
        }
        function getInverseMatrix() {
            var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
            var a = this.props[5] / determinant;
            var b = -this.props[1] / determinant;
            var c = -this.props[4] / determinant;
            var d = this.props[0] / determinant;
            var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
            var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
            var inverseMatrix = new Matrix();
            inverseMatrix.props[0] = a;
            inverseMatrix.props[1] = b;
            inverseMatrix.props[4] = c;
            inverseMatrix.props[5] = d;
            inverseMatrix.props[12] = e;
            inverseMatrix.props[13] = f;
            return inverseMatrix;
        }
        function inversePoint(pt) {
            var inverseMatrix = this.getInverseMatrix();
            return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
        }
        function inversePoints(pts) {
            var i;
            var len = pts.length;
            var retPts = [];
            for(i = 0; i < len; i += 1)retPts[i] = inversePoint(pts[i]);
            return retPts;
        }
        function applyToTriplePoints(pt1, pt2, pt3) {
            var arr = createTypedArray('float32', 6);
            if (this.isIdentity()) {
                arr[0] = pt1[0];
                arr[1] = pt1[1];
                arr[2] = pt2[0];
                arr[3] = pt2[1];
                arr[4] = pt3[0];
                arr[5] = pt3[1];
            } else {
                var p0 = this.props[0];
                var p1 = this.props[1];
                var p4 = this.props[4];
                var p5 = this.props[5];
                var p12 = this.props[12];
                var p13 = this.props[13];
                arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
                arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
                arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
                arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
                arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
                arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
            }
            return arr;
        }
        function applyToPointArray(x, y, z) {
            var arr;
            if (this.isIdentity()) arr = [
                x,
                y,
                z
            ];
            else arr = [
                x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            ];
            return arr;
        }
        function applyToPointStringified(x, y) {
            if (this.isIdentity()) return x + ',' + y;
            var _p = this.props;
            return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
        }
        function toCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var i = 0;
            var props = this.props;
            var cssValue = 'matrix3d(';
            var v = 10000;
            while(i < 16){
                cssValue += _rnd(props[i] * v) / v;
                cssValue += i === 15 ? ')' : ',';
                i += 1;
            }
            return cssValue;
        }
        function roundMatrixProperty(val) {
            var v = 10000;
            if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) return _rnd(val * v) / v;
            return val;
        }
        function to2dCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var props = this.props;
            var _a = roundMatrixProperty(props[0]);
            var _b = roundMatrixProperty(props[1]);
            var _c = roundMatrixProperty(props[4]);
            var _d = roundMatrixProperty(props[5]);
            var _e = roundMatrixProperty(props[12]);
            var _f = roundMatrixProperty(props[13]);
            return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
        }
        return function() {
            this.reset = reset;
            this.rotate = rotate;
            this.rotateX = rotateX;
            this.rotateY = rotateY;
            this.rotateZ = rotateZ;
            this.skew = skew;
            this.skewFromAxis = skewFromAxis;
            this.shear = shear;
            this.scale = scale;
            this.setTransform = setTransform;
            this.translate = translate;
            this.transform = transform;
            this.applyToPoint = applyToPoint;
            this.applyToX = applyToX;
            this.applyToY = applyToY;
            this.applyToZ = applyToZ;
            this.applyToPointArray = applyToPointArray;
            this.applyToTriplePoints = applyToTriplePoints;
            this.applyToPointStringified = applyToPointStringified;
            this.toCSS = toCSS;
            this.to2dCSS = to2dCSS;
            this.clone = clone;
            this.cloneFromProps = cloneFromProps;
            this.equals = equals;
            this.inversePoints = inversePoints;
            this.inversePoint = inversePoint;
            this.getInverseMatrix = getInverseMatrix;
            this._t = this.transform;
            this.isIdentity = isIdentity;
            this._identity = true;
            this._identityCalculated = false;
            this.props = createTypedArray('float32', 16);
            this.reset();
        };
    }();
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    var lottie = {};
    var standalone = '__[STANDALONE]__';
    var animationData = '__[ANIMATIONDATA]__';
    var renderer = '';
    function setLocation(href) {
        setLocationHref(href);
    }
    function searchAnimations() {
        if (standalone === true) animationManager.searchAnimations(animationData, standalone, renderer);
        else animationManager.searchAnimations();
    }
    function setSubframeRendering(flag) {
        setSubframeEnabled(flag);
    }
    function setPrefix(prefix) {
        setIdPrefix(prefix);
    }
    function loadAnimation(params) {
        if (standalone === true) params.animationData = JSON.parse(animationData);
        return animationManager.loadAnimation(params);
    }
    function setQuality(value) {
        if (typeof value === 'string') switch(value){
            case 'high':
                setDefaultCurveSegments(200);
                break;
            default:
            case 'medium':
                setDefaultCurveSegments(50);
                break;
            case 'low':
                setDefaultCurveSegments(10);
                break;
        }
        else if (!isNaN(value) && value > 1) setDefaultCurveSegments(value);
        if (getDefaultCurveSegments() >= 50) roundValues(false);
        else roundValues(true);
    }
    function inBrowser() {
        return typeof navigator !== 'undefined';
    }
    function installPlugin(type, plugin) {
        if (type === 'expressions') setExpressionsPlugin(plugin);
    }
    function getFactory(name) {
        switch(name){
            case 'propertyFactory':
                return PropertyFactory;
            case 'shapePropertyFactory':
                return ShapePropertyFactory;
            case 'matrix':
                return Matrix;
            default:
                return null;
        }
    }
    lottie.play = animationManager.play;
    lottie.pause = animationManager.pause;
    lottie.setLocationHref = setLocation;
    lottie.togglePause = animationManager.togglePause;
    lottie.setSpeed = animationManager.setSpeed;
    lottie.setDirection = animationManager.setDirection;
    lottie.stop = animationManager.stop;
    lottie.searchAnimations = searchAnimations;
    lottie.registerAnimation = animationManager.registerAnimation;
    lottie.loadAnimation = loadAnimation;
    lottie.setSubframeRendering = setSubframeRendering;
    lottie.resize = animationManager.resize; // lottie.start = start;
    lottie.goToAndStop = animationManager.goToAndStop;
    lottie.destroy = animationManager.destroy;
    lottie.setQuality = setQuality;
    lottie.inBrowser = inBrowser;
    lottie.installPlugin = installPlugin;
    lottie.freeze = animationManager.freeze;
    lottie.unfreeze = animationManager.unfreeze;
    lottie.setVolume = animationManager.setVolume;
    lottie.mute = animationManager.mute;
    lottie.unmute = animationManager.unmute;
    lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
    lottie.useWebWorker = setWebWorker;
    lottie.setIDPrefix = setPrefix;
    lottie.__getFactory = getFactory;
    lottie.version = '5.10.0';
    function checkReady() {
        if (document.readyState === 'complete') {
            clearInterval(readyStateCheckInterval);
            searchAnimations();
        }
    }
    function getQueryVariable(variable) {
        var vars = queryString.split('&');
        for(var i = 0; i < vars.length; i += 1){
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) // eslint-disable-line eqeqeq
            return decodeURIComponent(pair[1]);
        }
        return null;
    }
    var queryString = '';
    if (standalone) {
        var scripts = document.getElementsByTagName('script');
        var index = scripts.length - 1;
        var myScript = scripts[index] || {
            src: ''
        };
        queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape
        renderer = getQueryVariable('renderer');
    }
    var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility
    try {
        if (!(_typeof($c8ea7419494febdf$exports) === 'object' && true) && !(typeof define === 'function' && define.amd // eslint-disable-line no-undef
        )) window.bodymovin = lottie;
    } catch (err) {}
    var ShapeModifiers = function() {
        var ob = {};
        var modifiers = {};
        ob.registerModifier = registerModifier;
        ob.getModifier = getModifier;
        function registerModifier(nm, factory) {
            if (!modifiers[nm]) modifiers[nm] = factory;
        }
        function getModifier(nm, elem, data) {
            return new modifiers[nm](elem, data);
        }
        return ob;
    }();
    function ShapeModifier() {}
    ShapeModifier.prototype.initModifierProperties = function() {};
    ShapeModifier.prototype.addShapeToModifier = function() {};
    ShapeModifier.prototype.addShape = function(data) {
        if (!this.closed) {
            // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
            data.sh.container.addDynamicProperty(data.sh);
            var shapeData = {
                shape: data.sh,
                data: data,
                localShapeCollection: shapeCollectionPool.newShapeCollection()
            };
            this.shapes.push(shapeData);
            this.addShapeToModifier(shapeData);
            if (this._isAnimated) data.setAsAnimated();
        }
    };
    ShapeModifier.prototype.init = function(elem, data) {
        this.shapes = [];
        this.elem = elem;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, data);
        this.frameId = initialDefaultFrame;
        this.closed = false;
        this.k = false;
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    ShapeModifier.prototype.processKeys = function() {
        if (this.elem.globalData.frameId === this.frameId) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    extendPrototype([
        DynamicPropertyContainer
    ], ShapeModifier);
    function TrimModifier() {}
    extendPrototype([
        ShapeModifier
    ], TrimModifier);
    TrimModifier.prototype.initModifierProperties = function(elem, data) {
        this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
        this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
        this.sValue = 0;
        this.eValue = 0;
        this.getValue = this.processKeys;
        this.m = data.m;
        this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    };
    TrimModifier.prototype.addShapeToModifier = function(shapeData) {
        shapeData.pathsData = [];
    };
    TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
        var segments = [];
        if (e <= 1) segments.push({
            s: s,
            e: e
        });
        else if (s >= 1) segments.push({
            s: s - 1,
            e: e - 1
        });
        else {
            segments.push({
                s: s,
                e: 1
            });
            segments.push({
                s: 0,
                e: e - 1
            });
        }
        var shapeSegments = [];
        var i;
        var len = segments.length;
        var segmentOb;
        for(i = 0; i < len; i += 1){
            segmentOb = segments[i];
            if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
                var shapeS;
                var shapeE;
                if (segmentOb.s * totalModifierLength <= addedLength) shapeS = 0;
                else shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
                if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) shapeE = 1;
                else shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
                shapeSegments.push([
                    shapeS,
                    shapeE
                ]);
            }
        }
        if (!shapeSegments.length) shapeSegments.push([
            0,
            0
        ]);
        return shapeSegments;
    };
    TrimModifier.prototype.releasePathsData = function(pathsData) {
        var i;
        var len = pathsData.length;
        for(i = 0; i < len; i += 1)segmentsLengthPool.release(pathsData[i]);
        pathsData.length = 0;
        return pathsData;
    };
    TrimModifier.prototype.processShapes = function(_isFirstFrame) {
        var s;
        var e;
        if (this._mdf || _isFirstFrame) {
            var o = this.o.v % 360 / 360;
            if (o < 0) o += 1;
            if (this.s.v > 1) s = 1 + o;
            else if (this.s.v < 0) s = 0 + o;
            else s = this.s.v + o;
            if (this.e.v > 1) e = 1 + o;
            else if (this.e.v < 0) e = 0 + o;
            else e = this.e.v + o;
            if (s > e) {
                var _s = s;
                s = e;
                e = _s;
            }
            s = Math.round(s * 10000) * 0.0001;
            e = Math.round(e * 10000) * 0.0001;
            this.sValue = s;
            this.eValue = e;
        } else {
            s = this.sValue;
            e = this.eValue;
        }
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var pathsData;
        var pathData;
        var totalShapeLength;
        var totalModifierLength = 0;
        if (e === s) for(i = 0; i < len; i += 1){
            this.shapes[i].localShapeCollection.releaseShapes();
            this.shapes[i].shape._mdf = true;
            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
            if (this._mdf) this.shapes[i].pathsData.length = 0;
        }
        else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
            var segments = [];
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
                if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) shapeData.shape.paths = shapeData.localShapeCollection;
                else {
                    shapePaths = shapeData.shape.paths;
                    jLen = shapePaths._length;
                    totalShapeLength = 0;
                    if (!shapeData.shape._mdf && shapeData.pathsData.length) totalShapeLength = shapeData.totalShapeLength;
                    else {
                        pathsData = this.releasePathsData(shapeData.pathsData);
                        for(j = 0; j < jLen; j += 1){
                            pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
                            pathsData.push(pathData);
                            totalShapeLength += pathData.totalLength;
                        }
                        shapeData.totalShapeLength = totalShapeLength;
                        shapeData.pathsData = pathsData;
                    }
                    totalModifierLength += totalShapeLength;
                    shapeData.shape._mdf = true;
                }
            }
            var shapeS = s;
            var shapeE = e;
            var addedLength = 0;
            var edges;
            for(i = len - 1; i >= 0; i -= 1){
                shapeData = this.shapes[i];
                if (shapeData.shape._mdf) {
                    localShapeCollection = shapeData.localShapeCollection;
                    localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
                    if (this.m === 2 && len > 1) {
                        edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                        addedLength += shapeData.totalShapeLength;
                    } else edges = [
                        [
                            shapeS,
                            shapeE
                        ]
                    ];
                    jLen = edges.length;
                    for(j = 0; j < jLen; j += 1){
                        shapeS = edges[j][0];
                        shapeE = edges[j][1];
                        segments.length = 0;
                        if (shapeE <= 1) segments.push({
                            s: shapeData.totalShapeLength * shapeS,
                            e: shapeData.totalShapeLength * shapeE
                        });
                        else if (shapeS >= 1) segments.push({
                            s: shapeData.totalShapeLength * (shapeS - 1),
                            e: shapeData.totalShapeLength * (shapeE - 1)
                        });
                        else {
                            segments.push({
                                s: shapeData.totalShapeLength * shapeS,
                                e: shapeData.totalShapeLength
                            });
                            segments.push({
                                s: 0,
                                e: shapeData.totalShapeLength * (shapeE - 1)
                            });
                        }
                        var newShapesData = this.addShapes(shapeData, segments[0]);
                        if (segments[0].s !== segments[0].e) {
                            if (segments.length > 1) {
                                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
                                if (lastShapeInCollection.c) {
                                    var lastShape = newShapesData.pop();
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                                } else {
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1]);
                                }
                            }
                            this.addPaths(newShapesData, localShapeCollection);
                        }
                    }
                    shapeData.shape.paths = localShapeCollection;
                }
            }
        } else if (this._mdf) for(i = 0; i < len; i += 1){
            // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
            // Don't remove this even if it's losing cached info.
            this.shapes[i].pathsData.length = 0;
            this.shapes[i].shape._mdf = true;
        }
    };
    TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
        var i;
        var len = newPaths.length;
        for(i = 0; i < len; i += 1)localShapeCollection.addShape(newPaths[i]);
    };
    TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
        shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
        shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
        shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
    };
    TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
        shapePath.setXYAt(points[1], points[5], 'o', pos);
        shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(points[0], points[4], 'v', pos);
        shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
    };
    TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
        var pathsData = shapeData.pathsData;
        var shapePaths = shapeData.shape.paths.shapes;
        var i;
        var len = shapeData.shape.paths._length;
        var j;
        var jLen;
        var addedLength = 0;
        var currentLengthData;
        var segmentCount;
        var lengths;
        var segment;
        var shapes = [];
        var initPos;
        var newShape = true;
        if (!shapePath) {
            shapePath = shapePool.newElement();
            segmentCount = 0;
            initPos = 0;
        } else {
            segmentCount = shapePath._length;
            initPos = shapePath._length;
        }
        shapes.push(shapePath);
        for(i = 0; i < len; i += 1){
            lengths = pathsData[i].lengths;
            shapePath.c = shapePaths[i].c;
            jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
            for(j = 1; j < jLen; j += 1){
                currentLengthData = lengths[j - 1];
                if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
                    addedLength += currentLengthData.addedLength;
                    shapePath.c = false;
                } else if (addedLength > shapeSegment.e) {
                    shapePath.c = false;
                    break;
                } else {
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                    addedLength += currentLengthData.addedLength;
                    segmentCount += 1;
                }
            }
            if (shapePaths[i].c && lengths.length) {
                currentLengthData = lengths[j - 1];
                if (addedLength <= shapeSegment.e) {
                    var segmentLength = lengths[j - 1].addedLength;
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                } else shapePath.c = false;
                addedLength += currentLengthData.addedLength;
                segmentCount += 1;
            }
            if (shapePath._length) {
                shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
                shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
            }
            if (addedLength > shapeSegment.e) break;
            if (i < len - 1) {
                shapePath = shapePool.newElement();
                newShape = true;
                shapes.push(shapePath);
                segmentCount = 0;
            }
        }
        return shapes;
    };
    function PuckerAndBloatModifier() {}
    extendPrototype([
        ShapeModifier
    ], PuckerAndBloatModifier);
    PuckerAndBloatModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this._isAnimated = !!this.amount.effectsSequence.length;
    };
    PuckerAndBloatModifier.prototype.processPath = function(path, amount) {
        var percent = amount / 100;
        var centerPoint = [
            0,
            0
        ];
        var pathLength = path._length;
        var i = 0;
        for(i = 0; i < pathLength; i += 1){
            centerPoint[0] += path.v[i][0];
            centerPoint[1] += path.v[i][1];
        }
        centerPoint[0] /= pathLength;
        centerPoint[1] /= pathLength;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < pathLength; i += 1){
            vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
            vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
            oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
            oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
            iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
            iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
            clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
        }
        return clonedPath;
    };
    PuckerAndBloatModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    var TransformPropertyFactory = function() {
        var defaultVector = [
            0,
            0
        ];
        function applyToMatrix(mat) {
            var _mdf = this._mdf;
            this.iterateDynamicProperties();
            this._mdf = this._mdf || _mdf;
            if (this.a) mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            if (this.s) mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            if (this.sk) mat.skewFromAxis(-this.sk.v, this.sa.v);
            if (this.r) mat.rotate(-this.r.v);
            else mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            if (this.data.p.s) {
                if (this.data.p.z) mat.translate(this.px.v, this.py.v, -this.pz.v);
                else mat.translate(this.px.v, this.py.v, 0);
            } else mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
        function processKeys(forceRender) {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (this._isDirty) {
                this.precalculateMatrix();
                this._isDirty = false;
            }
            this.iterateDynamicProperties();
            if (this._mdf || forceRender) {
                var frameRate;
                this.v.cloneFromProps(this.pre.props);
                if (this.appliedTransformations < 1) this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                if (this.appliedTransformations < 2) this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                if (this.sk && this.appliedTransformations < 3) this.v.skewFromAxis(-this.sk.v, this.sa.v);
                if (this.r && this.appliedTransformations < 4) this.v.rotate(-this.r.v);
                else if (!this.r && this.appliedTransformations < 4) this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                if (this.autoOriented) {
                    var v1;
                    var v2;
                    frameRate = this.elem.globalData.frameRate;
                    if (this.p && this.p.keyframes && this.p.getValueAtTime) {
                        if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
                            v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
                            v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
                        } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                            v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
                            v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
                        } else {
                            v1 = this.p.pv;
                            v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
                        }
                    } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                        v1 = [];
                        v2 = [];
                        var px = this.px;
                        var py = this.py;
                        if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
                            v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
                            v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
                            v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
                            v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
                        } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
                            v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
                            v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
                            v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
                            v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
                        } else {
                            v1 = [
                                px.pv,
                                py.pv
                            ];
                            v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
                            v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
                        }
                    } else {
                        v2 = defaultVector;
                        v1 = v2;
                    }
                    this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
                }
                if (this.data.p && this.data.p.s) {
                    if (this.data.p.z) this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    else this.v.translate(this.px.v, this.py.v, 0);
                } else this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
            this.frameId = this.elem.globalData.frameId;
        }
        function precalculateMatrix() {
            if (!this.a.k) {
                this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                this.appliedTransformations = 1;
            } else return;
            if (!this.s.effectsSequence.length) {
                this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                this.appliedTransformations = 2;
            } else return;
            if (this.sk) {
                if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
                    this.pre.skewFromAxis(-this.sk.v, this.sa.v);
                    this.appliedTransformations = 3;
                } else return;
            }
            if (this.r) {
                if (!this.r.effectsSequence.length) {
                    this.pre.rotate(-this.r.v);
                    this.appliedTransformations = 4;
                }
            } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
                this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                this.appliedTransformations = 4;
            }
        }
        function autoOrient() {
        // var prevP = this.getValueAtTime();
        }
        function addDynamicProperty(prop) {
            this._addDynamicProperty(prop);
            this.elem.addDynamicProperty(prop);
            this._isDirty = true;
        }
        function TransformProperty(elem, data, container) {
            this.elem = elem;
            this.frameId = -1;
            this.propType = 'transform';
            this.data = data;
            this.v = new Matrix(); // Precalculated matrix with non animated properties
            this.pre = new Matrix();
            this.appliedTransformations = 0;
            this.initDynamicPropertyContainer(container || elem);
            if (data.p && data.p.s) {
                this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
                this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
                if (data.p.z) this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
            } else this.p = PropertyFactory.getProp(elem, data.p || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            if (data.rx) {
                this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
                this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
                this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
                if (data.or.k[0].ti) {
                    var i;
                    var len = data.or.k.length;
                    for(i = 0; i < len; i += 1){
                        data.or.k[i].to = null;
                        data.or.k[i].ti = null;
                    }
                }
                this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180
                this.or.sh = true;
            } else this.r = PropertyFactory.getProp(elem, data.r || {
                k: 0
            }, 0, degToRads, this);
            if (data.sk) {
                this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
                this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
            }
            this.a = PropertyFactory.getProp(elem, data.a || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: [
                    100,
                    100,
                    100
                ]
            }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
            if (data.o) this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
            else this.o = {
                _mdf: false,
                v: 1
            };
            this._isDirty = true;
            if (!this.dynamicProperties.length) this.getValue(true);
        }
        TransformProperty.prototype = {
            applyToMatrix: applyToMatrix,
            getValue: processKeys,
            precalculateMatrix: precalculateMatrix,
            autoOrient: autoOrient
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TransformProperty);
        TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
        TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
        function getTransformProperty(elem, data, container) {
            return new TransformProperty(elem, data, container);
        }
        return {
            getTransformProperty: getTransformProperty
        };
    }();
    function RepeaterModifier() {}
    extendPrototype([
        ShapeModifier
    ], RepeaterModifier);
    RepeaterModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
        this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
        this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
        this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
        this.data = data;
        if (!this.dynamicProperties.length) this.getValue(true);
        this._isAnimated = !!this.dynamicProperties.length;
        this.pMatrix = new Matrix();
        this.rMatrix = new Matrix();
        this.sMatrix = new Matrix();
        this.tMatrix = new Matrix();
        this.matrix = new Matrix();
    };
    RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv) {
        var dir = inv ? -1 : 1;
        var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
        var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
        pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
        rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        rMatrix.rotate(-transform.r.v * dir * perc);
        rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
        sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
        sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    };
    RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
        this.elem = elem;
        this.arr = arr;
        this.pos = pos;
        this.elemsData = elemsData;
        this._currentCopies = 0;
        this._elements = [];
        this._groups = [];
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, arr[pos]);
        while(pos > 0){
            pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);
            this._elements.unshift(arr[pos]);
        }
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    RepeaterModifier.prototype.resetElements = function(elements) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._processed = false;
            if (elements[i].ty === 'gr') this.resetElements(elements[i].it);
        }
    };
    RepeaterModifier.prototype.cloneElements = function(elements) {
        var newElements = JSON.parse(JSON.stringify(elements));
        this.resetElements(newElements);
        return newElements;
    };
    RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._render = renderFlag;
            if (elements[i].ty === 'gr') this.changeGroupRender(elements[i].it, renderFlag);
        }
    };
    RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
        var items;
        var itemsTransform;
        var i;
        var dir;
        var cont;
        var hasReloaded = false;
        if (this._mdf || _isFirstFrame) {
            var copies = Math.ceil(this.c.v);
            if (this._groups.length < copies) {
                while(this._groups.length < copies){
                    var group = {
                        it: this.cloneElements(this._elements),
                        ty: 'gr'
                    };
                    group.it.push({
                        a: {
                            a: 0,
                            ix: 1,
                            k: [
                                0,
                                0
                            ]
                        },
                        nm: 'Transform',
                        o: {
                            a: 0,
                            ix: 7,
                            k: 100
                        },
                        p: {
                            a: 0,
                            ix: 2,
                            k: [
                                0,
                                0
                            ]
                        },
                        r: {
                            a: 1,
                            ix: 6,
                            k: [
                                {
                                    s: 0,
                                    e: 0,
                                    t: 0
                                },
                                {
                                    s: 0,
                                    e: 0,
                                    t: 1
                                }
                            ]
                        },
                        s: {
                            a: 0,
                            ix: 3,
                            k: [
                                100,
                                100
                            ]
                        },
                        sa: {
                            a: 0,
                            ix: 5,
                            k: 0
                        },
                        sk: {
                            a: 0,
                            ix: 4,
                            k: 0
                        },
                        ty: 'tr'
                    });
                    this.arr.splice(0, 0, group);
                    this._groups.splice(0, 0, group);
                    this._currentCopies += 1;
                }
                this.elem.reloadShapes();
                hasReloaded = true;
            }
            cont = 0;
            var renderFlag;
            for(i = 0; i <= this._groups.length - 1; i += 1){
                renderFlag = cont < copies;
                this._groups[i]._render = renderFlag;
                this.changeGroupRender(this._groups[i].it, renderFlag);
                if (!renderFlag) {
                    var elems = this.elemsData[i].it;
                    var transformData = elems[elems.length - 1];
                    if (transformData.transform.op.v !== 0) {
                        transformData.transform.op._mdf = true;
                        transformData.transform.op.v = 0;
                    } else transformData.transform.op._mdf = false;
                }
                cont += 1;
            }
            this._currentCopies = copies; /// /
            var offset = this.o.v;
            var offsetModulo = offset % 1;
            var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
            var pProps = this.pMatrix.props;
            var rProps = this.rMatrix.props;
            var sProps = this.sMatrix.props;
            this.pMatrix.reset();
            this.rMatrix.reset();
            this.sMatrix.reset();
            this.tMatrix.reset();
            this.matrix.reset();
            var iteration = 0;
            if (offset > 0) {
                while(iteration < roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    iteration += 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
                    iteration += offsetModulo;
                }
            } else if (offset < 0) {
                while(iteration > roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                    iteration -= 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
                    iteration -= offsetModulo;
                }
            }
            i = this.data.m === 1 ? 0 : this._currentCopies - 1;
            dir = this.data.m === 1 ? 1 : -1;
            cont = this._currentCopies;
            var j;
            var jLen;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                jLen = itemsTransform.length;
                items[items.length - 1].transform.mProps._mdf = true;
                items[items.length - 1].transform.op._mdf = true;
                items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
                if (iteration !== 0) {
                    if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
                    this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
                    this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                    this.matrix.reset();
                } else {
                    this.matrix.reset();
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                }
                iteration += 1;
                cont -= 1;
                i += dir;
            }
        } else {
            cont = this._currentCopies;
            i = 0;
            dir = 1;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                items[items.length - 1].transform.mProps._mdf = false;
                items[items.length - 1].transform.op._mdf = false;
                cont -= 1;
                i += dir;
            }
        }
        return hasReloaded;
    };
    RepeaterModifier.prototype.addShape = function() {};
    function RoundCornersModifier() {}
    extendPrototype([
        ShapeModifier
    ], RoundCornersModifier);
    RoundCornersModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this._isAnimated = !!this.rd.effectsSequence.length;
    };
    RoundCornersModifier.prototype.processPath = function(path, round) {
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var i;
        var len = path._length;
        var currentV;
        var currentI;
        var currentO;
        var closerV;
        var distance;
        var newPosPerc;
        var index = 0;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < len; i += 1){
            currentV = path.v[i];
            currentO = path.o[i];
            currentI = path.i[i];
            if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
                if ((i === 0 || i === len - 1) && !path.c) {
                    clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
                    /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */ index += 1;
                } else {
                    if (i === 0) closerV = path.v[len - 1];
                    else closerV = path.v[i - 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = iX;
                    iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
                    vY = iY;
                    oX = vX - (vX - currentV[0]) * roundCorner;
                    oY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                    if (i === len - 1) closerV = path.v[0];
                    else closerV = path.v[i + 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = oX;
                    oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
                    vY = oY;
                    iX = vX - (vX - currentV[0]) * roundCorner;
                    iY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                }
            } else {
                clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
                index += 1;
            }
        }
        return clonedPath;
    };
    RoundCornersModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var rd = this.rd.v;
        if (rd !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function floatEqual(a, b) {
        return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
    }
    function floatZero(f) {
        return Math.abs(f) <= 0.00001;
    }
    function lerp(p0, p1, amount) {
        return p0 * (1 - amount) + p1 * amount;
    }
    function lerpPoint(p0, p1, amount) {
        return [
            lerp(p0[0], p1[0], amount),
            lerp(p0[1], p1[1], amount)
        ];
    }
    function quadRoots(a, b, c) {
        // no root
        if (a === 0) return [];
        var s = b * b - 4 * a * c; // Complex roots
        if (s < 0) return [];
        var singleRoot = -b / (2 * a); // 1 root
        if (s === 0) return [
            singleRoot
        ];
        var delta = Math.sqrt(s) / (2 * a); // 2 roots
        return [
            singleRoot - delta,
            singleRoot + delta
        ];
    }
    function polynomialCoefficients(p0, p1, p2, p3) {
        return [
            -p0 + 3 * p1 - 3 * p2 + p3,
            3 * p0 - 6 * p1 + 3 * p2,
            -3 * p0 + 3 * p1,
            p0
        ];
    }
    function singlePoint(p) {
        return new PolynomialBezier(p, p, p, p, false);
    }
    function PolynomialBezier(p0, p1, p2, p3, linearize) {
        if (linearize && pointEqual(p0, p1)) p1 = lerpPoint(p0, p3, 1 / 3);
        if (linearize && pointEqual(p2, p3)) p2 = lerpPoint(p0, p3, 2 / 3);
        var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
        var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
        this.a = [
            coeffx[0],
            coeffy[0]
        ];
        this.b = [
            coeffx[1],
            coeffy[1]
        ];
        this.c = [
            coeffx[2],
            coeffy[2]
        ];
        this.d = [
            coeffx[3],
            coeffy[3]
        ];
        this.points = [
            p0,
            p1,
            p2,
            p3
        ];
    }
    PolynomialBezier.prototype.point = function(t) {
        return [
            ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
            ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
        ];
    };
    PolynomialBezier.prototype.derivative = function(t) {
        return [
            (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
            (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
        ];
    };
    PolynomialBezier.prototype.tangentAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[1], p[0]);
    };
    PolynomialBezier.prototype.normalAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[0], p[1]);
    };
    PolynomialBezier.prototype.inflectionPoints = function() {
        var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(denom)) return [];
        var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
        var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
        if (square < 0) return [];
        var root = Math.sqrt(square);
        if (floatZero(root)) {
            if (root > 0 && root < 1) return [
                tcusp
            ];
            return [];
        }
        return [
            tcusp - root,
            tcusp + root
        ].filter(function(r) {
            return r > 0 && r < 1;
        });
    };
    PolynomialBezier.prototype.split = function(t) {
        if (t <= 0) return [
            singlePoint(this.points[0]),
            this
        ];
        if (t >= 1) return [
            this,
            singlePoint(this.points[this.points.length - 1])
        ];
        var p10 = lerpPoint(this.points[0], this.points[1], t);
        var p11 = lerpPoint(this.points[1], this.points[2], t);
        var p12 = lerpPoint(this.points[2], this.points[3], t);
        var p20 = lerpPoint(p10, p11, t);
        var p21 = lerpPoint(p11, p12, t);
        var p3 = lerpPoint(p20, p21, t);
        return [
            new PolynomialBezier(this.points[0], p10, p20, p3, true),
            new PolynomialBezier(p3, p21, p12, this.points[3], true)
        ];
    };
    function extrema(bez, comp) {
        var min = bez.points[0][comp];
        var max = bez.points[bez.points.length - 1][comp];
        if (min > max) {
            var e = max;
            max = min;
            min = e;
        } // Derivative roots to find min/max
        var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);
        for(var i = 0; i < f.length; i += 1)if (f[i] > 0 && f[i] < 1) {
            var val = bez.point(f[i])[comp];
            if (val < min) min = val;
            else if (val > max) max = val;
        }
        return {
            min: min,
            max: max
        };
    }
    PolynomialBezier.prototype.bounds = function() {
        return {
            x: extrema(this, 0),
            y: extrema(this, 1)
        };
    };
    PolynomialBezier.prototype.boundingBox = function() {
        var bounds = this.bounds();
        return {
            left: bounds.x.min,
            right: bounds.x.max,
            top: bounds.y.min,
            bottom: bounds.y.max,
            width: bounds.x.max - bounds.x.min,
            height: bounds.y.max - bounds.y.min,
            cx: (bounds.x.max + bounds.x.min) / 2,
            cy: (bounds.y.max + bounds.y.min) / 2
        };
    };
    function intersectData(bez, t1, t2) {
        var box = bez.boundingBox();
        return {
            cx: box.cx,
            cy: box.cy,
            width: box.width,
            height: box.height,
            bez: bez,
            t: (t1 + t2) / 2,
            t1: t1,
            t2: t2
        };
    }
    function splitData(data) {
        var split = data.bez.split(0.5);
        return [
            intersectData(split[0], data.t1, data.t),
            intersectData(split[1], data.t, data.t2)
        ];
    }
    function boxIntersect(b1, b2) {
        return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
    }
    function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
        if (!boxIntersect(d1, d2)) return;
        if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
            intersections.push([
                d1.t,
                d2.t
            ]);
            return;
        }
        var d1s = splitData(d1);
        var d2s = splitData(d2);
        intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
    }
    PolynomialBezier.prototype.intersections = function(other, tolerance, maxRecursion) {
        if (tolerance === undefined) tolerance = 2;
        if (maxRecursion === undefined) maxRecursion = 7;
        var intersections = [];
        intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
        return intersections;
    };
    PolynomialBezier.shapeSegment = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
    };
    PolynomialBezier.shapeSegmentInverted = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
    };
    function crossProduct(a, b) {
        return [
            a[1] * b[2] - a[2] * b[1],
            a[2] * b[0] - a[0] * b[2],
            a[0] * b[1] - a[1] * b[0]
        ];
    }
    function lineIntersection(start1, end1, start2, end2) {
        var v1 = [
            start1[0],
            start1[1],
            1
        ];
        var v2 = [
            end1[0],
            end1[1],
            1
        ];
        var v3 = [
            start2[0],
            start2[1],
            1
        ];
        var v4 = [
            end2[0],
            end2[1],
            1
        ];
        var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
        if (floatZero(r[2])) return null;
        return [
            r[0] / r[2],
            r[1] / r[2]
        ];
    }
    function polarOffset(p, angle, length) {
        return [
            p[0] + Math.cos(angle) * length,
            p[1] - Math.sin(angle) * length
        ];
    }
    function pointDistance(p1, p2) {
        return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
    }
    function pointEqual(p1, p2) {
        return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
    }
    function ZigZagModifier() {}
    extendPrototype([
        ShapeModifier
    ], ZigZagModifier);
    ZigZagModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
        this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
        this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
        var angO = angle - Math.PI / 2;
        var angI = angle + Math.PI / 2;
        var px = point[0] + Math.cos(angle) * direction * amplitude;
        var py = point[1] - Math.sin(angle) * direction * amplitude;
        outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
    }
    function getPerpendicularVector(pt1, pt2) {
        var vector = [
            pt2[0] - pt1[0],
            pt2[1] - pt1[1]
        ];
        var rot = -Math.PI * 0.5;
        var rotatedVector = [
            Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1],
            Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]
        ];
        return rotatedVector;
    }
    function getProjectingAngle(path, cur) {
        var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
        var nextIndex = (cur + 1) % path.length();
        var prevPoint = path.v[prevIndex];
        var nextPoint = path.v[nextIndex];
        var pVector = getPerpendicularVector(prevPoint, nextPoint);
        return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
    }
    function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
        var angle = getProjectingAngle(path, cur);
        var point = path.v[cur % path._length];
        var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
        var nextPoint = path.v[(cur + 1) % path._length];
        var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
        var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
        setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
    }
    function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
        for(var i = 0; i < frequency; i += 1){
            var t = (i + 1) / (frequency + 1);
            var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
            var angle = segment.normalAngle(t);
            var point = segment.point(t);
            setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
            direction = -direction;
        }
        return direction;
    }
    ZigZagModifier.prototype.processPath = function(path, amplitude, frequency, pointType) {
        var count = path._length;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        if (!path.c) count -= 1;
        if (count === 0) return clonedPath;
        var direction = -1;
        var segment = PolynomialBezier.shapeSegment(path, 0);
        zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);
        for(var i = 0; i < count; i += 1){
            direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
            if (i === count - 1 && !path.c) segment = null;
            else segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
            zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
        }
        return clonedPath;
    };
    ZigZagModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amplitude = this.amplitude.v;
        var frequency = Math.max(0, Math.round(this.frequency.v));
        var pointType = this.pointsType.v;
        if (amplitude !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function linearOffset(p1, p2, amount) {
        var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
        return [
            polarOffset(p1, angle, amount),
            polarOffset(p2, angle, amount)
        ];
    }
    function offsetSegment(segment, amount) {
        var p0;
        var p1a;
        var p1b;
        var p2b;
        var p2a;
        var p3;
        var e;
        e = linearOffset(segment.points[0], segment.points[1], amount);
        p0 = e[0];
        p1a = e[1];
        e = linearOffset(segment.points[1], segment.points[2], amount);
        p1b = e[0];
        p2b = e[1];
        e = linearOffset(segment.points[2], segment.points[3], amount);
        p2a = e[0];
        p3 = e[1];
        var p1 = lineIntersection(p0, p1a, p1b, p2b);
        if (p1 === null) p1 = p1a;
        var p2 = lineIntersection(p2a, p3, p1b, p2b);
        if (p2 === null) p2 = p2a;
        return new PolynomialBezier(p0, p1, p2, p3);
    }
    function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
        var p0 = seg1.points[3];
        var p1 = seg2.points[0]; // Bevel
        if (lineJoin === 3) return p0; // Connected, they don't need a joint
        if (pointEqual(p0, p1)) return p0; // Round
        if (lineJoin === 2) {
            var angleOut = -seg1.tangentAngle(1);
            var angleIn = -seg2.tangentAngle(0) + Math.PI;
            var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
            var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
            var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
            outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
            tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
            outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
            return p1;
        } // Miter
        var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
        var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
        var intersection = lineIntersection(t0, p0, p1, t1);
        if (intersection && pointDistance(intersection, p0) < miterLimit) {
            outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
            return intersection;
        }
        return p0;
    }
    function getIntersection(a, b) {
        var intersect = a.intersections(b);
        if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
        if (intersect.length) return intersect[0];
        return null;
    }
    function pruneSegmentIntersection(a, b) {
        var outa = a.slice();
        var outb = b.slice();
        var intersect = getIntersection(a[a.length - 1], b[0]);
        if (intersect) {
            outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
            outb[0] = b[0].split(intersect[1])[1];
        }
        if (a.length > 1 && b.length > 1) {
            intersect = getIntersection(a[0], b[b.length - 1]);
            if (intersect) return [
                [
                    a[0].split(intersect[0])[0]
                ],
                [
                    b[b.length - 1].split(intersect[1])[1]
                ]
            ];
        }
        return [
            outa,
            outb
        ];
    }
    function pruneIntersections(segments) {
        var e;
        for(var i = 1; i < segments.length; i += 1){
            e = pruneSegmentIntersection(segments[i - 1], segments[i]);
            segments[i - 1] = e[0];
            segments[i] = e[1];
        }
        if (segments.length > 1) {
            e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
            segments[segments.length - 1] = e[0];
            segments[0] = e[1];
        }
        return segments;
    }
    function offsetSegmentSplit(segment, amount) {
        /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
        (A cubic bezier can have none, one, or two inflection points)
    */ var flex = segment.inflectionPoints();
        var left;
        var right;
        var split;
        var mid;
        if (flex.length === 0) return [
            offsetSegment(segment, amount)
        ];
        if (flex.length === 1 || floatEqual(flex[1], 1)) {
            split = segment.split(flex[0]);
            left = split[0];
            right = split[1];
            return [
                offsetSegment(left, amount),
                offsetSegment(right, amount)
            ];
        }
        split = segment.split(flex[0]);
        left = split[0];
        var t = (flex[1] - flex[0]) / (1 - flex[0]);
        split = split[1].split(t);
        mid = split[0];
        right = split[1];
        return [
            offsetSegment(left, amount),
            offsetSegment(mid, amount),
            offsetSegment(right, amount)
        ];
    }
    function OffsetPathModifier() {}
    extendPrototype([
        ShapeModifier
    ], OffsetPathModifier);
    OffsetPathModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
        this.lineJoin = data.lj;
        this._isAnimated = this.amount.effectsSequence.length !== 0;
    };
    OffsetPathModifier.prototype.processPath = function(inputBezier, amount, lineJoin, miterLimit) {
        var outputBezier = shapePool.newElement();
        outputBezier.c = inputBezier.c;
        var count = inputBezier.length();
        if (!inputBezier.c) count -= 1;
        var i;
        var j;
        var segment;
        var multiSegments = [];
        for(i = 0; i < count; i += 1){
            segment = PolynomialBezier.shapeSegment(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        if (!inputBezier.c) for(i = count - 1; i >= 0; i -= 1){
            segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        multiSegments = pruneIntersections(multiSegments); // Add bezier segments to the output and apply line joints
        var lastPoint = null;
        var lastSeg = null;
        for(i = 0; i < multiSegments.length; i += 1){
            var multiSegment = multiSegments[i];
            if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
            lastSeg = multiSegment[multiSegment.length - 1];
            for(j = 0; j < multiSegment.length; j += 1){
                segment = multiSegment[j];
                if (lastPoint && pointEqual(segment.points[0], lastPoint)) outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
                else outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
                outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
                lastPoint = segment.points[3];
            }
        }
        if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
        return outputBezier;
    };
    OffsetPathModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        var miterLimit = this.miterLimit.v;
        var lineJoin = this.lineJoin;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function getFontProperties(fontData) {
        var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
        var fWeight = 'normal';
        var fStyle = 'normal';
        var len = styles.length;
        var styleName;
        for(var i = 0; i < len; i += 1){
            styleName = styles[i].toLowerCase();
            switch(styleName){
                case 'italic':
                    fStyle = 'italic';
                    break;
                case 'bold':
                    fWeight = '700';
                    break;
                case 'black':
                    fWeight = '900';
                    break;
                case 'medium':
                    fWeight = '500';
                    break;
                case 'regular':
                case 'normal':
                    fWeight = '400';
                    break;
                case 'light':
                case 'thin':
                    fWeight = '200';
                    break;
                default:
                    break;
            }
        }
        return {
            style: fStyle,
            weight: fontData.fWeight || fWeight
        };
    }
    var FontManager = function() {
        var maxWaitingTime = 5000;
        var emptyChar = {
            w: 0,
            size: 0,
            shapes: [],
            data: {
                shapes: []
            }
        };
        var combinedCharacters = []; // Hindi characters
        combinedCharacters = combinedCharacters.concat([
            2304,
            2305,
            2306,
            2307,
            2362,
            2363,
            2364,
            2364,
            2366,
            2367,
            2368,
            2369,
            2370,
            2371,
            2372,
            2373,
            2374,
            2375,
            2376,
            2377,
            2378,
            2379,
            2380,
            2381,
            2382,
            2383,
            2387,
            2388,
            2389,
            2390,
            2391,
            2402,
            2403
        ]);
        var surrogateModifiers = [
            'd83cdffb',
            'd83cdffc',
            'd83cdffd',
            'd83cdffe',
            'd83cdfff'
        ];
        var zeroWidthJoiner = [
            65039,
            8205
        ];
        function trimFontOptions(font) {
            var familyArray = font.split(',');
            var i;
            var len = familyArray.length;
            var enabledFamilies = [];
            for(i = 0; i < len; i += 1)if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') enabledFamilies.push(familyArray[i]);
            return enabledFamilies.join(',');
        }
        function setUpNode(font, family) {
            var parentNode = createTag('span'); // Node is invisible to screen readers.
            parentNode.setAttribute('aria-hidden', true);
            parentNode.style.fontFamily = family;
            var node = createTag('span'); // Characters that vary significantly among different fonts
            node.innerText = 'giItT1WQy@!-/#'; // Visible - so we can measure it - but not on the screen
            parentNode.style.position = 'absolute';
            parentNode.style.left = '-10000px';
            parentNode.style.top = '-10000px'; // Large font size makes even subtle changes obvious
            parentNode.style.fontSize = '300px'; // Reset any font properties
            parentNode.style.fontVariant = 'normal';
            parentNode.style.fontStyle = 'normal';
            parentNode.style.fontWeight = 'normal';
            parentNode.style.letterSpacing = '0';
            parentNode.appendChild(node);
            document.body.appendChild(parentNode); // Remember width with no applied web font
            var width = node.offsetWidth;
            node.style.fontFamily = trimFontOptions(font) + ', ' + family;
            return {
                node: node,
                w: width,
                parent: parentNode
            };
        }
        function checkLoadedFonts() {
            var i;
            var len = this.fonts.length;
            var node;
            var w;
            var loadedCount = len;
            for(i = 0; i < len; i += 1){
                if (this.fonts[i].loaded) loadedCount -= 1;
                else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) this.fonts[i].loaded = true;
                else {
                    node = this.fonts[i].monoCase.node;
                    w = this.fonts[i].monoCase.w;
                    if (node.offsetWidth !== w) {
                        loadedCount -= 1;
                        this.fonts[i].loaded = true;
                    } else {
                        node = this.fonts[i].sansCase.node;
                        w = this.fonts[i].sansCase.w;
                        if (node.offsetWidth !== w) {
                            loadedCount -= 1;
                            this.fonts[i].loaded = true;
                        }
                    }
                    if (this.fonts[i].loaded) {
                        this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                        this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
                    }
                }
            }
            if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) setTimeout(this.checkLoadedFontsBinded, 20);
            else setTimeout(this.setIsLoadedBinded, 10);
        }
        function createHelper(fontData, def) {
            var engine = document.body && def ? 'svg' : 'canvas';
            var helper;
            var fontProps = getFontProperties(fontData);
            if (engine === 'svg') {
                var tHelper = createNS('text');
                tHelper.style.fontSize = '100px'; // tHelper.style.fontFamily = fontData.fFamily;
                tHelper.setAttribute('font-family', fontData.fFamily);
                tHelper.setAttribute('font-style', fontProps.style);
                tHelper.setAttribute('font-weight', fontProps.weight);
                tHelper.textContent = '1';
                if (fontData.fClass) {
                    tHelper.style.fontFamily = 'inherit';
                    tHelper.setAttribute('class', fontData.fClass);
                } else tHelper.style.fontFamily = fontData.fFamily;
                def.appendChild(tHelper);
                helper = tHelper;
            } else {
                var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
                tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
                helper = tCanvasHelper;
            }
            function measure(text) {
                if (engine === 'svg') {
                    helper.textContent = text;
                    return helper.getComputedTextLength();
                }
                return helper.measureText(text).width;
            }
            return {
                measureText: measure
            };
        }
        function addFonts(fontData, defs) {
            if (!fontData) {
                this.isLoaded = true;
                return;
            }
            if (this.chars) {
                this.isLoaded = true;
                this.fonts = fontData.list;
                return;
            }
            if (!document.body) {
                this.isLoaded = true;
                fontData.list.forEach(function(data) {
                    data.helper = createHelper(data);
                    data.cache = {};
                });
                this.fonts = fontData.list;
                return;
            }
            var fontArr = fontData.list;
            var i;
            var len = fontArr.length;
            var _pendingFonts = len;
            for(i = 0; i < len; i += 1){
                var shouldLoadFont = true;
                var loadedSelector;
                var j;
                fontArr[i].loaded = false;
                fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
                fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
                if (!fontArr[i].fPath) {
                    fontArr[i].loaded = true;
                    _pendingFonts -= 1;
                } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
                    loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
                    if (loadedSelector.length > 0) shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var s = createTag('style');
                        s.setAttribute('f-forigin', fontArr[i].fOrigin);
                        s.setAttribute('f-origin', fontArr[i].origin);
                        s.setAttribute('f-family', fontArr[i].fFamily);
                        s.type = 'text/css';
                        s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
                        defs.appendChild(s);
                    }
                } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
                    loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var l = createTag('link');
                        l.setAttribute('f-forigin', fontArr[i].fOrigin);
                        l.setAttribute('f-origin', fontArr[i].origin);
                        l.type = 'text/css';
                        l.rel = 'stylesheet';
                        l.href = fontArr[i].fPath;
                        document.body.appendChild(l);
                    }
                } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
                    loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (fontArr[i].fPath === loadedSelector[j].src) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var sc = createTag('link');
                        sc.setAttribute('f-forigin', fontArr[i].fOrigin);
                        sc.setAttribute('f-origin', fontArr[i].origin);
                        sc.setAttribute('rel', 'stylesheet');
                        sc.setAttribute('href', fontArr[i].fPath);
                        defs.appendChild(sc);
                    }
                }
                fontArr[i].helper = createHelper(fontArr[i], defs);
                fontArr[i].cache = {};
                this.fonts.push(fontArr[i]);
            }
            if (_pendingFonts === 0) this.isLoaded = true;
            else // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
            // Adding this timeout seems to fix it
            setTimeout(this.checkLoadedFonts.bind(this), 100);
        }
        function addChars(chars) {
            if (!chars) return;
            if (!this.chars) this.chars = [];
            var i;
            var len = chars.length;
            var j;
            var jLen = this.chars.length;
            var found;
            for(i = 0; i < len; i += 1){
                j = 0;
                found = false;
                while(j < jLen){
                    if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) found = true;
                    j += 1;
                }
                if (!found) {
                    this.chars.push(chars[i]);
                    jLen += 1;
                }
            }
        }
        function getCharData(_char, style, font) {
            var i = 0;
            var len = this.chars.length;
            while(i < len){
                if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) return this.chars[i];
                i += 1;
            }
            if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
             && !this._warned) {
                this._warned = true;
                console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
            }
            return emptyChar;
        }
        function measureText(_char2, fontName, size) {
            var fontData = this.getFontByName(fontName);
            var index = _char2.charCodeAt(0);
            if (!fontData.cache[index + 1]) {
                var tHelper = fontData.helper;
                if (_char2 === ' ') {
                    var doubleSize = tHelper.measureText('|' + _char2 + '|');
                    var singleSize = tHelper.measureText('||');
                    fontData.cache[index + 1] = (doubleSize - singleSize) / 100;
                } else fontData.cache[index + 1] = tHelper.measureText(_char2) / 100;
            }
            return fontData.cache[index + 1] * size;
        }
        function getFontByName(name) {
            var i = 0;
            var len = this.fonts.length;
            while(i < len){
                if (this.fonts[i].fName === name) return this.fonts[i];
                i += 1;
            }
            return this.fonts[0];
        }
        function isModifier(firstCharCode, secondCharCode) {
            var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
            return surrogateModifiers.indexOf(sum) !== -1;
        }
        function isZeroWidthJoiner(firstCharCode, secondCharCode) {
            if (!secondCharCode) return firstCharCode === zeroWidthJoiner[1];
            return firstCharCode === zeroWidthJoiner[0] && secondCharCode === zeroWidthJoiner[1];
        }
        function isCombinedCharacter(_char3) {
            return combinedCharacters.indexOf(_char3) !== -1;
        }
        function setIsLoaded() {
            this.isLoaded = true;
        }
        var Font = function Font() {
            this.fonts = [];
            this.chars = null;
            this.typekitLoaded = 0;
            this.isLoaded = false;
            this._warned = false;
            this.initTime = Date.now();
            this.setIsLoadedBinded = this.setIsLoaded.bind(this);
            this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        Font.isModifier = isModifier;
        Font.isZeroWidthJoiner = isZeroWidthJoiner;
        Font.isCombinedCharacter = isCombinedCharacter;
        var fontPrototype = {
            addChars: addChars,
            addFonts: addFonts,
            getCharData: getCharData,
            getFontByName: getFontByName,
            measureText: measureText,
            checkLoadedFonts: checkLoadedFonts,
            setIsLoaded: setIsLoaded
        };
        Font.prototype = fontPrototype;
        return Font;
    }();
    function RenderableElement() {}
    RenderableElement.prototype = {
        initRenderable: function initRenderable() {
            // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
            this.isInRange = false; // layer's display state
            this.hidden = false; // If layer's transparency equals 0, it can be hidden
            this.isTransparent = false; // list of animated components
            this.renderableComponents = [];
        },
        addRenderableComponent: function addRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) === -1) this.renderableComponents.push(component);
        },
        removeRenderableComponent: function removeRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) !== -1) this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
        },
        prepareRenderableFrame: function prepareRenderableFrame(num) {
            this.checkLayerLimits(num);
        },
        checkTransparency: function checkTransparency() {
            if (this.finalTransform.mProp.o.v <= 0) {
                if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
                    this.isTransparent = true;
                    this.hide();
                }
            } else if (this.isTransparent) {
                this.isTransparent = false;
                this.show();
            }
        },
        /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */ checkLayerLimits: function checkLayerLimits(num) {
            if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
                if (this.isInRange !== true) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                    this.isInRange = true;
                    this.show();
                }
            } else if (this.isInRange !== false) {
                this.globalData._mdf = true;
                this.isInRange = false;
                this.hide();
            }
        },
        renderRenderable: function renderRenderable() {
            var i;
            var len = this.renderableComponents.length;
            for(i = 0; i < len; i += 1)this.renderableComponents[i].renderFrame(this._isFirstFrame);
        /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */ },
        sourceRectAtTime: function sourceRectAtTime() {
            return {
                top: 0,
                left: 0,
                width: 100,
                height: 100
            };
        },
        getLayerSize: function getLayerSize() {
            if (this.data.ty === 5) return {
                w: this.data.textData.width,
                h: this.data.textData.height
            };
            return {
                w: this.data.width,
                h: this.data.height
            };
        }
    };
    var getBlendMode = function() {
        var blendModeEnums = {
            0: 'source-over',
            1: 'multiply',
            2: 'screen',
            3: 'overlay',
            4: 'darken',
            5: 'lighten',
            6: 'color-dodge',
            7: 'color-burn',
            8: 'hard-light',
            9: 'soft-light',
            10: 'difference',
            11: 'exclusion',
            12: 'hue',
            13: 'saturation',
            14: 'color',
            15: 'luminosity'
        };
        return function(mode) {
            return blendModeEnums[mode] || '';
        };
    }();
    function SliderEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function AngleEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function ColorEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function PointEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function LayerIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function MaskIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function CheckboxEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function NoValueEffect() {
        this.p = {};
    }
    function EffectsManager(data, element) {
        var effects = data.ef || [];
        this.effectElements = [];
        var i;
        var len = effects.length;
        var effectItem;
        for(i = 0; i < len; i += 1){
            effectItem = new GroupEffect(effects[i], element);
            this.effectElements.push(effectItem);
        }
    }
    function GroupEffect(data, element) {
        this.init(data, element);
    }
    extendPrototype([
        DynamicPropertyContainer
    ], GroupEffect);
    GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
    GroupEffect.prototype.init = function(data, element) {
        this.data = data;
        this.effectElements = [];
        this.initDynamicPropertyContainer(element);
        var i;
        var len = this.data.ef.length;
        var eff;
        var effects = this.data.ef;
        for(i = 0; i < len; i += 1){
            eff = null;
            switch(effects[i].ty){
                case 0:
                    eff = new SliderEffect(effects[i], element, this);
                    break;
                case 1:
                    eff = new AngleEffect(effects[i], element, this);
                    break;
                case 2:
                    eff = new ColorEffect(effects[i], element, this);
                    break;
                case 3:
                    eff = new PointEffect(effects[i], element, this);
                    break;
                case 4:
                case 7:
                    eff = new CheckboxEffect(effects[i], element, this);
                    break;
                case 10:
                    eff = new LayerIndexEffect(effects[i], element, this);
                    break;
                case 11:
                    eff = new MaskIndexEffect(effects[i], element, this);
                    break;
                case 5:
                    eff = new EffectsManager(effects[i], element, this);
                    break;
                // case 6:
                default:
                    eff = new NoValueEffect(effects[i], element, this);
                    break;
            }
            if (eff) this.effectElements.push(eff);
        }
    };
    function BaseElement() {}
    BaseElement.prototype = {
        checkMasks: function checkMasks() {
            if (!this.data.hasMask) return false;
            var i = 0;
            var len = this.data.masksProperties.length;
            while(i < len){
                if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) return true;
                i += 1;
            }
            return false;
        },
        initExpressions: function initExpressions() {
            var expressionsInterfaces = getExpressionInterfaces();
            if (!expressionsInterfaces) return;
            var LayerExpressionInterface = expressionsInterfaces('layer');
            var EffectsExpressionInterface = expressionsInterfaces('effects');
            var ShapeExpressionInterface = expressionsInterfaces('shape');
            var TextExpressionInterface = expressionsInterfaces('text');
            var CompExpressionInterface = expressionsInterfaces('comp');
            this.layerInterface = LayerExpressionInterface(this);
            if (this.data.hasMask && this.maskManager) this.layerInterface.registerMaskInterface(this.maskManager);
            var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(effectsInterface);
            if (this.data.ty === 0 || this.data.xt) this.compInterface = CompExpressionInterface(this);
            else if (this.data.ty === 4) {
                this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
                this.layerInterface.content = this.layerInterface.shapeInterface;
            } else if (this.data.ty === 5) {
                this.layerInterface.textInterface = TextExpressionInterface(this);
                this.layerInterface.text = this.layerInterface.textInterface;
            }
        },
        setBlendMode: function setBlendMode() {
            var blendModeValue = getBlendMode(this.data.bm);
            var elem = this.baseElement || this.layerElement;
            elem.style['mix-blend-mode'] = blendModeValue;
        },
        initBaseData: function initBaseData(data, globalData, comp) {
            this.globalData = globalData;
            this.comp = comp;
            this.data = data;
            this.layerId = createElementID(); // Stretch factor for old animations missing this property.
            if (!this.data.sr) this.data.sr = 1;
             // effects manager
            this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function getType() {
            return this.type;
        },
        sourceRectAtTime: function sourceRectAtTime() {}
    };
    /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */ function FrameElement() {}
    FrameElement.prototype = {
        /**
       * @function
       * Initializes frame related properties.
       *
       */ initFrame: function initFrame() {
            // set to true when inpoint is rendered
            this._isFirstFrame = false; // list of animated properties
            this.dynamicProperties = []; // If layer has been modified in current tick this will be true
            this._mdf = false;
        },
        /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */ prepareProperties: function prepareProperties(num, isVisible) {
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1)if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                }
            }
        },
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) this.dynamicProperties.push(prop);
        }
    };
    function FootageElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.footageData = globalData.imageLoader.getAsset(this.assetData);
        this.initBaseData(data, globalData, comp);
    }
    FootageElement.prototype.prepareFrame = function() {};
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], FootageElement);
    FootageElement.prototype.getBaseElement = function() {
        return null;
    };
    FootageElement.prototype.renderFrame = function() {};
    FootageElement.prototype.destroy = function() {};
    FootageElement.prototype.initExpressions = function() {
        var expressionsInterfaces = getExpressionInterfaces();
        if (!expressionsInterfaces) return;
        var FootageInterface = expressionsInterfaces('footage');
        this.layerInterface = FootageInterface(this);
    };
    FootageElement.prototype.getFootageData = function() {
        return this.footageData;
    };
    function AudioElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.initBaseData(data, globalData, comp);
        this._isPlaying = false;
        this._canPlay = false;
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(assetPath);
        this._currentTime = 0;
        this.globalData.audioController.addAudio(this);
        this._volumeMultiplier = 1;
        this._volume = 1;
        this._previousVolume = null;
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
        this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
            k: [
                100
            ]
        }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(num) {
        this.prepareRenderableFrame(num, true);
        this.prepareProperties(num, true);
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            this._currentTime = timeRemapped;
        } else this._currentTime = num / this.data.sr;
        this._volume = this.lv.v[0];
        var totalVolume = this._volume * this._volumeMultiplier;
        if (this._previousVolume !== totalVolume) {
            this._previousVolume = totalVolume;
            this.audio.volume(totalVolume);
        }
    };
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], AudioElement);
    AudioElement.prototype.renderFrame = function() {
        if (this.isInRange && this._canPlay) {
            if (!this._isPlaying) {
                this.audio.play();
                this.audio.seek(this._currentTime / this.globalData.frameRate);
                this._isPlaying = true;
            } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) this.audio.seek(this._currentTime / this.globalData.frameRate);
        }
    };
    AudioElement.prototype.show = function() {};
    AudioElement.prototype.hide = function() {
        this.audio.pause();
        this._isPlaying = false;
    };
    AudioElement.prototype.pause = function() {
        this.audio.pause();
        this._isPlaying = false;
        this._canPlay = false;
    };
    AudioElement.prototype.resume = function() {
        this._canPlay = true;
    };
    AudioElement.prototype.setRate = function(rateValue) {
        this.audio.rate(rateValue);
    };
    AudioElement.prototype.volume = function(volumeValue) {
        this._volumeMultiplier = volumeValue;
        this._previousVolume = volumeValue * this._volume;
        this.audio.volume(this._previousVolume);
    };
    AudioElement.prototype.getBaseElement = function() {
        return null;
    };
    AudioElement.prototype.destroy = function() {};
    AudioElement.prototype.sourceRectAtTime = function() {};
    AudioElement.prototype.initExpressions = function() {};
    function BaseRenderer() {}
    BaseRenderer.prototype.checkLayers = function(num) {
        var i;
        var len = this.layers.length;
        var data;
        this.completeLayers = true;
        for(i = len - 1; i >= 0; i -= 1){
            if (!this.elements[i]) {
                data = this.layers[i];
                if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) this.buildItem(i);
            }
            this.completeLayers = this.elements[i] ? this.completeLayers : false;
        }
        this.checkPendingElements();
    };
    BaseRenderer.prototype.createItem = function(layer) {
        switch(layer.ty){
            case 2:
                return this.createImage(layer);
            case 0:
                return this.createComp(layer);
            case 1:
                return this.createSolid(layer);
            case 3:
                return this.createNull(layer);
            case 4:
                return this.createShape(layer);
            case 5:
                return this.createText(layer);
            case 6:
                return this.createAudio(layer);
            case 13:
                return this.createCamera(layer);
            case 15:
                return this.createFootage(layer);
            default:
                return this.createNull(layer);
        }
    };
    BaseRenderer.prototype.createCamera = function() {
        throw new Error('You\'re using a 3d camera. Try the html renderer.');
    };
    BaseRenderer.prototype.createAudio = function(data) {
        return new AudioElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.createFootage = function(data) {
        return new FootageElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.buildAllItems = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)this.buildItem(i);
        this.checkPendingElements();
    };
    BaseRenderer.prototype.includeLayers = function(newLayers) {
        this.completeLayers = false;
        var i;
        var len = newLayers.length;
        var j;
        var jLen = this.layers.length;
        for(i = 0; i < len; i += 1){
            j = 0;
            while(j < jLen){
                if (this.layers[j].id === newLayers[i].id) {
                    this.layers[j] = newLayers[i];
                    break;
                }
                j += 1;
            }
        }
    };
    BaseRenderer.prototype.setProjectInterface = function(pInterface) {
        this.globalData.projectInterface = pInterface;
    };
    BaseRenderer.prototype.initItems = function() {
        if (!this.globalData.progressiveLoad) this.buildAllItems();
    };
    BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
        var elements = this.elements;
        var layers = this.layers;
        var i = 0;
        var len = layers.length;
        while(i < len){
            if (layers[i].ind == parentName) {
                // eslint-disable-line eqeqeq
                if (!elements[i] || elements[i] === true) {
                    this.buildItem(i);
                    this.addPendingElement(element);
                } else {
                    hierarchy.push(elements[i]);
                    elements[i].setAsParent();
                    if (layers[i].parent !== undefined) this.buildElementParenting(element, layers[i].parent, hierarchy);
                    else element.setHierarchy(hierarchy);
                }
            }
            i += 1;
        }
    };
    BaseRenderer.prototype.addPendingElement = function(element) {
        this.pendingElements.push(element);
    };
    BaseRenderer.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i]);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    BaseRenderer.prototype.getElementByPath = function(path) {
        var pathValue = path.shift();
        var element;
        if (typeof pathValue === 'number') element = this.elements[pathValue];
        else {
            var i;
            var len = this.elements.length;
            for(i = 0; i < len; i += 1)if (this.elements[i].data.nm === pathValue) {
                element = this.elements[i];
                break;
            }
        }
        if (path.length === 0) return element;
        return element.getElementByPath(path);
    };
    BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
        this.globalData.fontManager = new FontManager();
        this.globalData.fontManager.addChars(animData.chars);
        this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
        this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
        this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
        this.globalData.imageLoader = this.animationItem.imagePreloader;
        this.globalData.audioController = this.animationItem.audioController;
        this.globalData.frameId = 0;
        this.globalData.frameRate = animData.fr;
        this.globalData.nm = animData.nm;
        this.globalData.compSize = {
            w: animData.w,
            h: animData.h
        };
    };
    function TransformElement() {}
    TransformElement.prototype = {
        initTransform: function initTransform() {
            this.finalTransform = {
                mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                    o: 0
                },
                _matMdf: false,
                _opMdf: false,
                mat: new Matrix()
            };
            if (this.data.ao) this.finalTransform.mProp.autoOriented = true;
             // TODO: check TYPE 11: Guided elements
            this.data.ty;
        },
        renderTransform: function renderTransform() {
            this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
            this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
            if (this.hierarchy) {
                var mat;
                var finalMat = this.finalTransform.mat;
                var i = 0;
                var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.
                if (!this.finalTransform._matMdf) while(i < len){
                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
                        this.finalTransform._matMdf = true;
                        break;
                    }
                    i += 1;
                }
                if (this.finalTransform._matMdf) {
                    mat = this.finalTransform.mProp.v.props;
                    finalMat.cloneFromProps(mat);
                    for(i = 0; i < len; i += 1){
                        mat = this.hierarchy[i].finalTransform.mProp.v.props;
                        finalMat.transform(mat[0], mat[1], mat[2], mat[3], mat[4], mat[5], mat[6], mat[7], mat[8], mat[9], mat[10], mat[11], mat[12], mat[13], mat[14], mat[15]);
                    }
                }
            }
        },
        globalToLocal: function globalToLocal(pt) {
            var transforms = [];
            transforms.push(this.finalTransform);
            var flag = true;
            var comp = this.comp;
            while(flag)if (comp.finalTransform) {
                if (comp.data.hasMask) transforms.splice(0, 0, comp.finalTransform);
                comp = comp.comp;
            } else flag = false;
            var i;
            var len = transforms.length;
            var ptNew;
            for(i = 0; i < len; i += 1){
                ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
                pt = [
                    pt[0] - ptNew[0],
                    pt[1] - ptNew[1],
                    0
                ];
            }
            return pt;
        },
        mHelper: new Matrix()
    };
    function MaskElement(data, element, globalData) {
        this.data = data;
        this.element = element;
        this.globalData = globalData;
        this.storedData = [];
        this.masksProperties = this.data.masksProperties || [];
        this.maskElement = null;
        var defs = this.globalData.defs;
        var i;
        var len = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(len);
        this.solidPath = '';
        var path;
        var properties = this.masksProperties;
        var count = 0;
        var currentMasks = [];
        var j;
        var jLen;
        var layerId = createElementID();
        var rect;
        var expansor;
        var feMorph;
        var x;
        var maskType = 'clipPath';
        var maskRef = 'clip-path';
        for(i = 0; i < len; i += 1){
            if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
                maskType = 'mask';
                maskRef = 'mask';
            }
            if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
                rect = createNS('rect');
                rect.setAttribute('fill', '#ffffff');
                rect.setAttribute('width', this.element.comp.data.w || 0);
                rect.setAttribute('height', this.element.comp.data.h || 0);
                currentMasks.push(rect);
            } else rect = null;
            path = createNS('path');
            if (properties[i].mode === 'n') {
                // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    elem: path,
                    lastPath: ''
                };
                defs.appendChild(path);
            } else {
                count += 1;
                path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
                path.setAttribute('clip-rule', 'nonzero');
                var filterID;
                if (properties[i].x.k !== 0) {
                    maskType = 'mask';
                    maskRef = 'mask';
                    x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
                    filterID = createElementID();
                    expansor = createNS('filter');
                    expansor.setAttribute('id', filterID);
                    feMorph = createNS('feMorphology');
                    feMorph.setAttribute('operator', 'erode');
                    feMorph.setAttribute('in', 'SourceGraphic');
                    feMorph.setAttribute('radius', '0');
                    expansor.appendChild(feMorph);
                    defs.appendChild(expansor);
                    path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
                } else {
                    feMorph = null;
                    x = null;
                } // TODO move this to a factory or to a constructor
                this.storedData[i] = {
                    elem: path,
                    x: x,
                    expan: feMorph,
                    lastPath: '',
                    lastOperator: '',
                    filterId: filterID,
                    lastRadius: 0
                };
                if (properties[i].mode === 'i') {
                    jLen = currentMasks.length;
                    var g = createNS('g');
                    for(j = 0; j < jLen; j += 1)g.appendChild(currentMasks[j]);
                    var mask = createNS('mask');
                    mask.setAttribute('mask-type', 'alpha');
                    mask.setAttribute('id', layerId + '_' + count);
                    mask.appendChild(path);
                    defs.appendChild(mask);
                    g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
                    currentMasks.length = 0;
                    currentMasks.push(g);
                } else currentMasks.push(path);
                if (properties[i].inv && !this.solidPath) this.solidPath = this.createLayerSolidPath();
                 // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    elem: path,
                    lastPath: '',
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    invRect: rect
                };
                if (!this.viewData[i].prop.k) this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
            }
        }
        this.maskElement = createNS(maskType);
        len = currentMasks.length;
        for(i = 0; i < len; i += 1)this.maskElement.appendChild(currentMasks[i]);
        if (count > 0) {
            this.maskElement.setAttribute('id', layerId);
            this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
            defs.appendChild(this.maskElement);
        }
        if (this.viewData.length) this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(pos) {
        return this.viewData[pos].prop;
    };
    MaskElement.prototype.renderFrame = function(isFirstFrame) {
        var finalMat = this.element.finalTransform.mat;
        var i;
        var len = this.masksProperties.length;
        for(i = 0; i < len; i += 1){
            if (this.viewData[i].prop._mdf || isFirstFrame) this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
            if (this.viewData[i].op._mdf || isFirstFrame) this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
            if (this.masksProperties[i].mode !== 'n') {
                if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
                if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
                    var feMorph = this.storedData[i].expan;
                    if (this.storedData[i].x.v < 0) {
                        if (this.storedData[i].lastOperator !== 'erode') {
                            this.storedData[i].lastOperator = 'erode';
                            this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
                        }
                        feMorph.setAttribute('radius', -this.storedData[i].x.v);
                    } else {
                        if (this.storedData[i].lastOperator !== 'dilate') {
                            this.storedData[i].lastOperator = 'dilate';
                            this.storedData[i].elem.setAttribute('filter', null);
                        }
                        this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
                    }
                }
            }
        }
    };
    MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
    };
    MaskElement.prototype.createLayerSolidPath = function() {
        var path = 'M0,0 ';
        path += ' h' + this.globalData.compSize.w;
        path += ' v' + this.globalData.compSize.h;
        path += ' h-' + this.globalData.compSize.w;
        path += ' v-' + this.globalData.compSize.h + ' ';
        return path;
    };
    MaskElement.prototype.drawPath = function(pathData, pathNodes, viewData) {
        var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
        var i;
        var len;
        len = pathNodes._length;
        for(i = 1; i < len; i += 1)// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
         // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
        if (pathNodes.c && len > 1) pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
         // pathNodes.__renderedString = pathString;
        if (viewData.lastPath !== pathString) {
            var pathShapeValue = '';
            if (viewData.elem) {
                if (pathNodes.c) pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
                viewData.elem.setAttribute('d', pathShapeValue);
            }
            viewData.lastPath = pathString;
        }
    };
    MaskElement.prototype.destroy = function() {
        this.element = null;
        this.globalData = null;
        this.maskElement = null;
        this.data = null;
        this.masksProperties = null;
    };
    var filtersFactory = function() {
        var ob = {};
        ob.createFilter = createFilter;
        ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
        function createFilter(filId, skipCoordinates) {
            var fil = createNS('filter');
            fil.setAttribute('id', filId);
            if (skipCoordinates !== true) {
                fil.setAttribute('filterUnits', 'objectBoundingBox');
                fil.setAttribute('x', '0%');
                fil.setAttribute('y', '0%');
                fil.setAttribute('width', '100%');
                fil.setAttribute('height', '100%');
            }
            return fil;
        }
        function createAlphaToLuminanceFilter() {
            var feColorMatrix = createNS('feColorMatrix');
            feColorMatrix.setAttribute('type', 'matrix');
            feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
            feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
            return feColorMatrix;
        }
        return ob;
    }();
    var featureSupport = function() {
        var ob = {
            maskType: true
        };
        if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) ob.maskType = false;
        return ob;
    }();
    var registeredEffects = {};
    var idPrefix = 'filter_result_';
    function SVGEffects(elem) {
        var i;
        var source = 'SourceGraphic';
        var len = elem.data.ef ? elem.data.ef.length : 0;
        var filId = createElementID();
        var fil = filtersFactory.createFilter(filId, true);
        var count = 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects[type]) {
                var Effect = registeredEffects[type].effect;
                filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
                source = idPrefix + count;
                if (registeredEffects[type].countsAsEffect) count += 1;
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (count) {
            elem.globalData.defs.appendChild(fil);
            elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    function registerEffect(id, effect, countsAsEffect) {
        registeredEffects[id] = {
            effect: effect,
            countsAsEffect: countsAsEffect
        };
    }
    function SVGBaseElement() {}
    SVGBaseElement.prototype = {
        initRendererElement: function initRendererElement() {
            this.layerElement = createNS('g');
        },
        createContainerElements: function createContainerElements() {
            this.matteElement = createNS('g');
            this.transformedElement = this.layerElement;
            this.maskedElement = this.layerElement;
            this._sizeChanged = false;
            var layerElementParent = null; // If this layer acts as a mask for the following layer
            if (this.data.td) {
                this.matteMasks = {};
                var symbolElement = createNS('symbol');
                symbolElement.setAttribute('id', this.layerId);
                var gg = createNS('g');
                gg.appendChild(this.layerElement);
                symbolElement.appendChild(gg);
                layerElementParent = gg;
                this.globalData.defs.appendChild(symbolElement);
            } else if (this.data.tt) {
                this.matteElement.appendChild(this.layerElement);
                layerElementParent = this.matteElement;
                this.baseElement = this.matteElement;
            } else this.baseElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
             // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
            if (this.data.ty === 0 && !this.data.hd) {
                var cp = createNS('clipPath');
                var pt = createNS('path');
                pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
                var clipId = createElementID();
                cp.setAttribute('id', clipId);
                cp.appendChild(pt);
                this.globalData.defs.appendChild(cp);
                if (this.checkMasks()) {
                    var cpGroup = createNS('g');
                    cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
                    cpGroup.appendChild(this.layerElement);
                    this.transformedElement = cpGroup;
                    if (layerElementParent) layerElementParent.appendChild(this.transformedElement);
                    else this.baseElement = this.transformedElement;
                } else this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
            }
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            if (this.finalTransform._matMdf) this.transformedElement.setAttribute('transform', this.finalTransform.mat.to2dCSS());
            if (this.finalTransform._opMdf) this.transformedElement.setAttribute('opacity', this.finalTransform.mProp.o.v);
        },
        destroyBaseElement: function destroyBaseElement() {
            this.layerElement = null;
            this.matteElement = null;
            this.maskManager.destroy();
        },
        getBaseElement: function getBaseElement() {
            if (this.data.hd) return null;
            return this.baseElement;
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
            this.renderableEffectsManager = new SVGEffects(this);
        },
        getMatte: function getMatte(matteType) {
            if (!this.matteMasks[matteType]) {
                var id = this.layerId + '_' + matteType;
                var filId;
                var fil;
                var useElement;
                var gg;
                if (matteType === 1 || matteType === 3) {
                    var masker = createNS('mask');
                    masker.setAttribute('id', id);
                    masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    masker.appendChild(useElement);
                    this.globalData.defs.appendChild(masker);
                    if (!featureSupport.maskType && matteType === 1) {
                        masker.setAttribute('mask-type', 'luminance');
                        filId = createElementID();
                        fil = filtersFactory.createFilter(filId);
                        this.globalData.defs.appendChild(fil);
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        gg.appendChild(useElement);
                        masker.appendChild(gg);
                        gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    }
                } else if (matteType === 2) {
                    var maskGroup = createNS('mask');
                    maskGroup.setAttribute('id', id);
                    maskGroup.setAttribute('mask-type', 'alpha');
                    var maskGrouper = createNS('g');
                    maskGroup.appendChild(maskGrouper);
                    filId = createElementID();
                    fil = filtersFactory.createFilter(filId); /// /
                    var feCTr = createNS('feComponentTransfer');
                    feCTr.setAttribute('in', 'SourceGraphic');
                    fil.appendChild(feCTr);
                    var feFunc = createNS('feFuncA');
                    feFunc.setAttribute('type', 'table');
                    feFunc.setAttribute('tableValues', '1.0 0.0');
                    feCTr.appendChild(feFunc); /// /
                    this.globalData.defs.appendChild(fil);
                    var alphaRect = createNS('rect');
                    alphaRect.setAttribute('width', this.comp.data.w);
                    alphaRect.setAttribute('height', this.comp.data.h);
                    alphaRect.setAttribute('x', '0');
                    alphaRect.setAttribute('y', '0');
                    alphaRect.setAttribute('fill', '#ffffff');
                    alphaRect.setAttribute('opacity', '0');
                    maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    maskGrouper.appendChild(alphaRect);
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    maskGrouper.appendChild(useElement);
                    if (!featureSupport.maskType) {
                        maskGroup.setAttribute('mask-type', 'luminance');
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        maskGrouper.appendChild(alphaRect);
                        gg.appendChild(this.layerElement);
                        maskGrouper.appendChild(gg);
                    }
                    this.globalData.defs.appendChild(maskGroup);
                }
                this.matteMasks[matteType] = id;
            }
            return this.matteMasks[matteType];
        },
        setMatte: function setMatte(id) {
            if (!this.matteElement) return;
            this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
        }
    };
    /**
   * @file
   * Handles AE's layer parenting property.
   *
   */ function HierarchyElement() {}
    HierarchyElement.prototype = {
        /**
       * @function
       * Initializes hierarchy properties
       *
       */ initHierarchy: function initHierarchy() {
            // element's parent list
            this.hierarchy = []; // if element is parent of another layer _isParent will be true
            this._isParent = false;
            this.checkParenting();
        },
        /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */ setHierarchy: function setHierarchy(hierarchy) {
            this.hierarchy = hierarchy;
        },
        /**
       * @function
       * Sets layer as parent.
       *
       */ setAsParent: function setAsParent() {
            this._isParent = true;
        },
        /**
       * @function
       * Searches layer's parenting chain
       *
       */ checkParenting: function checkParenting() {
            if (this.data.parent !== undefined) this.comp.buildElementParenting(this, this.data.parent, []);
        }
    };
    function RenderableDOMElement() {}
    (function() {
        var _prototype = {
            initElement: function initElement(data, globalData, comp) {
                this.initFrame();
                this.initBaseData(data, globalData, comp);
                this.initTransform(data, globalData, comp);
                this.initHierarchy();
                this.initRenderable();
                this.initRendererElement();
                this.createContainerElements();
                this.createRenderableComponents();
                this.createContent();
                this.hide();
            },
            hide: function hide() {
                // console.log('HIDE', this);
                if (!this.hidden && (!this.isInRange || this.isTransparent)) {
                    var elem = this.baseElement || this.layerElement;
                    elem.style.display = 'none';
                    this.hidden = true;
                }
            },
            show: function show() {
                // console.log('SHOW', this);
                if (this.isInRange && !this.isTransparent) {
                    if (!this.data.hd) {
                        var elem = this.baseElement || this.layerElement;
                        elem.style.display = 'block';
                    }
                    this.hidden = false;
                    this._isFirstFrame = true;
                }
            },
            renderFrame: function renderFrame() {
                // If it is exported as hidden (data.hd === true) no need to render
                // If it is not visible no need to render
                if (this.data.hd || this.hidden) return;
                this.renderTransform();
                this.renderRenderable();
                this.renderElement();
                this.renderInnerContent();
                if (this._isFirstFrame) this._isFirstFrame = false;
            },
            renderInnerContent: function renderInnerContent() {},
            prepareFrame: function prepareFrame(num) {
                this._mdf = false;
                this.prepareRenderableFrame(num);
                this.prepareProperties(num, this.isInRange);
                this.checkTransparency();
            },
            destroy: function destroy() {
                this.innerElem = null;
                this.destroyBaseElement();
            }
        };
        extendPrototype([
            RenderableElement,
            createProxyFunction(_prototype)
        ], RenderableDOMElement);
    })();
    function IImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.initElement(data, globalData, comp);
        this.sourceRect = {
            top: 0,
            left: 0,
            width: this.assetData.w,
            height: this.assetData.h
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], IImageElement);
    IImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS('image');
        this.innerElem.setAttribute('width', this.assetData.w + 'px');
        this.innerElem.setAttribute('height', this.assetData.h + 'px');
        this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
        this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
        this.layerElement.appendChild(this.innerElem);
    };
    IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
    };
    function ProcessedElement(element, position) {
        this.elem = element;
        this.pos = position;
    }
    function IShapeElement() {}
    IShapeElement.prototype = {
        addShapeToModifiers: function addShapeToModifiers(data) {
            var i;
            var len = this.shapeModifiers.length;
            for(i = 0; i < len; i += 1)this.shapeModifiers[i].addShape(data);
        },
        isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
            var i = 0;
            var len = this.shapeModifiers.length;
            while(i < len){
                if (this.shapeModifiers[i].isAnimatedWithShape(data)) return true;
            }
            return false;
        },
        renderModifiers: function renderModifiers() {
            if (!this.shapeModifiers.length) return;
            var i;
            var len = this.shapes.length;
            for(i = 0; i < len; i += 1)this.shapes[i].sh.reset();
            len = this.shapeModifiers.length;
            var shouldBreakProcess;
            for(i = len - 1; i >= 0; i -= 1){
                shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
                // TODO: find a better solution for this
                if (shouldBreakProcess) break;
            }
        },
        searchProcessedElement: function searchProcessedElement(elem) {
            var elements = this.processedElements;
            var i = 0;
            var len = elements.length;
            while(i < len){
                if (elements[i].elem === elem) return elements[i].pos;
                i += 1;
            }
            return 0;
        },
        addProcessedElement: function addProcessedElement(elem, pos) {
            var elements = this.processedElements;
            var i = elements.length;
            while(i){
                i -= 1;
                if (elements[i].elem === elem) {
                    elements[i].pos = pos;
                    return;
                }
            }
            elements.push(new ProcessedElement(elem, pos));
        },
        prepareFrame: function prepareFrame(num) {
            this.prepareRenderableFrame(num);
            this.prepareProperties(num, this.isInRange);
        }
    };
    var lineCapEnum = {
        1: 'butt',
        2: 'round',
        3: 'square'
    };
    var lineJoinEnum = {
        1: 'miter',
        2: 'round',
        3: 'bevel'
    };
    function SVGShapeData(transformers, level, shape) {
        this.caches = [];
        this.styles = [];
        this.transformers = transformers;
        this.lStr = '';
        this.sh = shape;
        this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
        // For now, since shapes add up with other shapes. They have to be calculated every time.
        // One way of finding out is checking if all styles associated to this shape depend only of this shape
        this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated
        var i = 0;
        var len = transformers.length;
        while(i < len){
            if (transformers[i].mProps.dynamicProperties.length) {
                this._isAnimated = true;
                break;
            }
            i += 1;
        }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = true;
    };
    function SVGStyleData(data, level) {
        this.data = data;
        this.type = data.ty;
        this.d = '';
        this.lvl = level;
        this._mdf = false;
        this.closed = data.hd === true;
        this.pElem = createNS('path');
        this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
        this.d = '';
        this._mdf = false;
    };
    function DashProperty(elem, data, renderer, container) {
        this.elem = elem;
        this.frameId = -1;
        this.dataProps = createSizedArray(data.length);
        this.renderer = renderer;
        this.k = false;
        this.dashStr = '';
        this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
        this.dashoffset = createTypedArray('float32', 1);
        this.initDynamicPropertyContainer(container);
        var i;
        var len = data.length || 0;
        var prop;
        for(i = 0; i < len; i += 1){
            prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
            this.k = prop.k || this.k;
            this.dataProps[i] = {
                n: data[i].n,
                p: prop
            };
        }
        if (!this.k) this.getValue(true);
        this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(forceRender) {
        if (this.elem.globalData.frameId === this.frameId && !forceRender) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        this._mdf = this._mdf || forceRender;
        if (this._mdf) {
            var i = 0;
            var len = this.dataProps.length;
            if (this.renderer === 'svg') this.dashStr = '';
            for(i = 0; i < len; i += 1)if (this.dataProps[i].n !== 'o') {
                if (this.renderer === 'svg') this.dashStr += ' ' + this.dataProps[i].p.v;
                else this.dashArray[i] = this.dataProps[i].p.v;
            } else this.dashoffset[0] = this.dataProps[i].p.v;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], DashProperty);
    function SVGStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGStrokeStyleData);
    function SVGFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGFillStyleData);
    function SVGNoStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGNoStyleData);
    function GradientProperty(elem, data, container) {
        this.data = data;
        this.c = createTypedArray('uint8c', data.p * 4);
        var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
        this.o = createTypedArray('float32', cLength);
        this._cmdf = false;
        this._omdf = false;
        this._collapsable = this.checkCollapsable();
        this._hasOpacity = cLength;
        this.initDynamicPropertyContainer(container);
        this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
        this.k = this.prop.k;
        this.getValue(true);
    }
    GradientProperty.prototype.comparePoints = function(values, points) {
        var i = 0;
        var len = this.o.length / 2;
        var diff;
        while(i < len){
            diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
            if (diff > 0.01) return false;
            i += 1;
        }
        return true;
    };
    GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 !== this.c.length / 4) return false;
        if (this.data.k.k[0].s) {
            var i = 0;
            var len = this.data.k.k.length;
            while(i < len){
                if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) return false;
                i += 1;
            }
        } else if (!this.comparePoints(this.data.k.k, this.data.p)) return false;
        return true;
    };
    GradientProperty.prototype.getValue = function(forceRender) {
        this.prop.getValue();
        this._mdf = false;
        this._cmdf = false;
        this._omdf = false;
        if (this.prop._mdf || forceRender) {
            var i;
            var len = this.data.p * 4;
            var mult;
            var val;
            for(i = 0; i < len; i += 1){
                mult = i % 4 === 0 ? 100 : 255;
                val = Math.round(this.prop.v[i] * mult);
                if (this.c[i] !== val) {
                    this.c[i] = val;
                    this._cmdf = !forceRender;
                }
            }
            if (this.o.length) {
                len = this.prop.v.length;
                for(i = this.data.p * 4; i < len; i += 1){
                    mult = i % 2 === 0 ? 100 : 1;
                    val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
                    if (this.o[i - this.data.p * 4] !== val) {
                        this.o[i - this.data.p * 4] = val;
                        this._omdf = !forceRender;
                    }
                }
            }
            this._mdf = !forceRender;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], GradientProperty);
    function SVGGradientFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.initGradientData(elem, data, styleOb);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb) {
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
        this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
        this.h = PropertyFactory.getProp(elem, data.h || {
            k: 0
        }, 0, 0.01, this);
        this.a = PropertyFactory.getProp(elem, data.a || {
            k: 0
        }, 0, degToRads, this);
        this.g = new GradientProperty(elem, data.g, this);
        this.style = styleOb;
        this.stops = [];
        this.setGradientData(styleOb.pElem, data);
        this.setGradientOpacity(data, styleOb);
        this._isAnimated = !!this._isAnimated;
    };
    SVGGradientFillStyleData.prototype.setGradientData = function(pathElement, data) {
        var gradientId = createElementID();
        var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
        gfill.setAttribute('id', gradientId);
        gfill.setAttribute('spreadMethod', 'pad');
        gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
        var stops = [];
        var stop;
        var j;
        var jLen;
        jLen = data.g.p * 4;
        for(j = 0; j < jLen; j += 4){
            stop = createNS('stop');
            gfill.appendChild(stop);
            stops.push(stop);
        }
        pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
        this.gf = gfill;
        this.cst = stops;
    };
    SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb) {
        if (this.g._hasOpacity && !this.g._collapsable) {
            var stop;
            var j;
            var jLen;
            var mask = createNS('mask');
            var maskElement = createNS('path');
            mask.appendChild(maskElement);
            var opacityId = createElementID();
            var maskId = createElementID();
            mask.setAttribute('id', maskId);
            var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
            opFill.setAttribute('id', opacityId);
            opFill.setAttribute('spreadMethod', 'pad');
            opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
            jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
            var stops = this.stops;
            for(j = data.g.p * 4; j < jLen; j += 2){
                stop = createNS('stop');
                stop.setAttribute('stop-color', 'rgb(255,255,255)');
                opFill.appendChild(stop);
                stops.push(stop);
            }
            maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');
            if (data.ty === 'gs') {
                maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
                maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
                if (data.lj === 1) maskElement.setAttribute('stroke-miterlimit', data.ml);
            }
            this.of = opFill;
            this.ms = mask;
            this.ost = stops;
            this.maskId = maskId;
            styleOb.msElem = maskElement;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.initGradientData(elem, data, styleOb);
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        SVGGradientFillStyleData,
        DynamicPropertyContainer
    ], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
        this.it = [];
        this.prevViewData = [];
        this.gr = createNS('g');
    }
    function SVGTransformData(mProps, op, container) {
        this.transform = {
            mProps: mProps,
            op: op,
            container: container
        };
        this.elements = [];
        this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
        if (length === 0) return '';
        var _o = pathNodes.o;
        var _i = pathNodes.i;
        var _v = pathNodes.v;
        var i;
        var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
        for(i = 1; i < length; i += 1)shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
        if (closed && length) {
            shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
            shapeString += 'z';
        }
        return shapeString;
    };
    var SVGElementsRenderer = function() {
        var _identityMatrix = new Matrix();
        var _matrixHelper = new Matrix();
        var ob = {
            createRenderFunction: createRenderFunction
        };
        function createRenderFunction(data) {
            switch(data.ty){
                case 'fl':
                    return renderFill;
                case 'gf':
                    return renderGradient;
                case 'gs':
                    return renderGradientStroke;
                case 'st':
                    return renderStroke;
                case 'sh':
                case 'el':
                case 'rc':
                case 'sr':
                    return renderPath;
                case 'tr':
                    return renderContentTransform;
                case 'no':
                    return renderNoop;
                default:
                    return null;
            }
        }
        function renderContentTransform(styleData, itemData, isFirstFrame) {
            if (isFirstFrame || itemData.transform.op._mdf) itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
            if (isFirstFrame || itemData.transform.mProps._mdf) itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
        }
        function renderNoop() {}
        function renderPath(styleData, itemData, isFirstFrame) {
            var j;
            var jLen;
            var pathStringTransformed;
            var redraw;
            var pathNodes;
            var l;
            var lLen = itemData.styles.length;
            var lvl = itemData.lvl;
            var paths;
            var mat;
            var props;
            var iterations;
            var k;
            for(l = 0; l < lLen; l += 1){
                redraw = itemData.sh._mdf || isFirstFrame;
                if (itemData.styles[l].lvl < lvl) {
                    mat = _matrixHelper.reset();
                    iterations = lvl - itemData.styles[l].lvl;
                    k = itemData.transformers.length - 1;
                    while(!redraw && iterations > 0){
                        redraw = itemData.transformers[k].mProps._mdf || redraw;
                        iterations -= 1;
                        k -= 1;
                    }
                    if (redraw) {
                        iterations = lvl - itemData.styles[l].lvl;
                        k = itemData.transformers.length - 1;
                        while(iterations > 0){
                            props = itemData.transformers[k].mProps.v.props;
                            mat.transform(props[0], props[1], props[2], props[3], props[4], props[5], props[6], props[7], props[8], props[9], props[10], props[11], props[12], props[13], props[14], props[15]);
                            iterations -= 1;
                            k -= 1;
                        }
                    }
                } else mat = _identityMatrix;
                paths = itemData.sh.paths;
                jLen = paths._length;
                if (redraw) {
                    pathStringTransformed = '';
                    for(j = 0; j < jLen; j += 1){
                        pathNodes = paths.shapes[j];
                        if (pathNodes && pathNodes._length) pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
                    }
                    itemData.caches[l] = pathStringTransformed;
                } else pathStringTransformed = itemData.caches[l];
                itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
                itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
            }
        }
        function renderFill(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            if (itemData.c._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
        }
        function renderGradientStroke(styleData, itemData, isFirstFrame) {
            renderGradient(styleData, itemData, isFirstFrame);
            renderStroke(styleData, itemData, isFirstFrame);
        }
        function renderGradient(styleData, itemData, isFirstFrame) {
            var gfill = itemData.gf;
            var hasOpacity = itemData.g._hasOpacity;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (itemData.o._mdf || isFirstFrame) {
                var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
                itemData.style.pElem.setAttribute(attr, itemData.o.v);
            }
            if (itemData.s._mdf || isFirstFrame) {
                var attr1 = styleData.t === 1 ? 'x1' : 'cx';
                var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
                gfill.setAttribute(attr1, pt1[0]);
                gfill.setAttribute(attr2, pt1[1]);
                if (hasOpacity && !itemData.g._collapsable) {
                    itemData.of.setAttribute(attr1, pt1[0]);
                    itemData.of.setAttribute(attr2, pt1[1]);
                }
            }
            var stops;
            var i;
            var len;
            var stop;
            if (itemData.g._cmdf || isFirstFrame) {
                stops = itemData.cst;
                var cValues = itemData.g.c;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    stop.setAttribute('offset', cValues[i * 4] + '%');
                    stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
                }
            }
            if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
                var oValues = itemData.g.o;
                if (itemData.g._collapsable) stops = itemData.cst;
                else stops = itemData.ost;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    if (!itemData.g._collapsable) stop.setAttribute('offset', oValues[i * 2] + '%');
                    stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
                }
            }
            if (styleData.t === 1) {
                if (itemData.e._mdf || isFirstFrame) {
                    gfill.setAttribute('x2', pt2[0]);
                    gfill.setAttribute('y2', pt2[1]);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('x2', pt2[0]);
                        itemData.of.setAttribute('y2', pt2[1]);
                    }
                }
            } else {
                var rad;
                if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
                    rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    gfill.setAttribute('r', rad);
                    if (hasOpacity && !itemData.g._collapsable) itemData.of.setAttribute('r', rad);
                }
                if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
                    if (!rad) rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                    var percent = itemData.h.v;
                    if (percent >= 1) percent = 0.99;
                    else if (percent <= -1) percent = -0.99;
                    var dist = rad * percent;
                    var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                    var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                    gfill.setAttribute('fx', x);
                    gfill.setAttribute('fy', y);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('fx', x);
                        itemData.of.setAttribute('fy', y);
                    }
                } // gfill.setAttribute('fy','200');
            }
        }
        function renderStroke(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            var d = itemData.d;
            if (d && (d._mdf || isFirstFrame) && d.dashStr) {
                styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
                styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
            }
            if (itemData.c && (itemData.c._mdf || isFirstFrame)) styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
            if (itemData.w._mdf || isFirstFrame) {
                styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
                if (styleElem.msElem) styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
            }
        }
        return ob;
    }();
    function SVGShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], SVGShapeElement);
    SVGShapeElement.prototype.initSecondaryElement = function() {};
    SVGShapeElement.prototype.identityMatrix = new Matrix();
    SVGShapeElement.prototype.buildExpressionInterface = function() {};
    SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
    };
    /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */ SVGShapeElement.prototype.filterUniqueShapes = function() {
        var i;
        var len = this.shapes.length;
        var shape;
        var j;
        var jLen = this.stylesList.length;
        var style;
        var tempShapes = [];
        var areAnimated = false;
        for(j = 0; j < jLen; j += 1){
            style = this.stylesList[j];
            areAnimated = false;
            tempShapes.length = 0;
            for(i = 0; i < len; i += 1){
                shape = this.shapes[i];
                if (shape.styles.indexOf(style) !== -1) {
                    tempShapes.push(shape);
                    areAnimated = shape._isAnimated || areAnimated;
                }
            }
            if (tempShapes.length > 1 && areAnimated) this.setShapesAsAnimated(tempShapes);
        }
    };
    SVGShapeElement.prototype.setShapesAsAnimated = function(shapes) {
        var i;
        var len = shapes.length;
        for(i = 0; i < len; i += 1)shapes[i].setAsAnimated();
    };
    SVGShapeElement.prototype.createStyleElement = function(data, level) {
        // TODO: prevent drawing of hidden styles
        var elementData;
        var styleOb = new SVGStyleData(data, level);
        var pathElement = styleOb.pElem;
        if (data.ty === 'st') elementData = new SVGStrokeStyleData(this, data, styleOb);
        else if (data.ty === 'fl') elementData = new SVGFillStyleData(this, data, styleOb);
        else if (data.ty === 'gf' || data.ty === 'gs') {
            var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
            elementData = new GradientConstructor(this, data, styleOb);
            this.globalData.defs.appendChild(elementData.gf);
            if (elementData.maskId) {
                this.globalData.defs.appendChild(elementData.ms);
                this.globalData.defs.appendChild(elementData.of);
                pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
            }
        } else if (data.ty === 'no') elementData = new SVGNoStyleData(this, data, styleOb);
        if (data.ty === 'st' || data.ty === 'gs') {
            pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
            pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
            pathElement.setAttribute('fill-opacity', '0');
            if (data.lj === 1) pathElement.setAttribute('stroke-miterlimit', data.ml);
        }
        if (data.r === 2) pathElement.setAttribute('fill-rule', 'evenodd');
        if (data.ln) pathElement.setAttribute('id', data.ln);
        if (data.cl) pathElement.setAttribute('class', data.cl);
        if (data.bm) pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
        this.stylesList.push(styleOb);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createGroupElement = function(data) {
        var elementData = new ShapeGroupData();
        if (data.ln) elementData.gr.setAttribute('id', data.ln);
        if (data.cl) elementData.gr.setAttribute('class', data.cl);
        if (data.bm) elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
        return elementData;
    };
    SVGShapeElement.prototype.createTransformElement = function(data, container) {
        var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
        var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
        var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
        var i = 0;
        var len = this.animatedContents.length;
        while(i < len){
            if (this.animatedContents[i].element === element) return;
            i += 1;
        }
        this.animatedContents.push({
            fn: SVGElementsRenderer.createRenderFunction(data),
            element: element,
            data: data
        });
    };
    SVGShapeElement.prototype.setElementStyles = function(elementData) {
        var arr = elementData.styles;
        var j;
        var jLen = this.stylesList.length;
        for(j = 0; j < jLen; j += 1)if (!this.stylesList[j].closed) arr.push(this.stylesList[j]);
    };
    SVGShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
    };
    SVGShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, container, level, transformers, render) {
        var ownTransformers = [].concat(transformers);
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var currentTransform;
        var modifier;
        var processedPos;
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._render = render;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], level);
                else itemsData[i].style.closed = false;
                if (arr[i]._render) {
                    if (itemsData[i].style.pElem.parentNode !== container) container.appendChild(itemsData[i].style.pElem);
                }
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
                if (arr[i]._render) {
                    if (itemsData[i].gr.parentNode !== container) container.appendChild(itemsData[i].gr);
                }
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) itemsData[i] = this.createTransformElement(arr[i], container);
                currentTransform = itemsData[i].transform;
                ownTransformers.push(currentTransform);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
                this.setElementStyles(itemsData[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    render = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        len = ownStyles.length;
        for(i = 0; i < len; i += 1)ownStyles[i].closed = true;
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    SVGShapeElement.prototype.renderInnerContent = function() {
        this.renderModifiers();
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)this.stylesList[i].reset();
        this.renderShape();
        for(i = 0; i < len; i += 1)if (this.stylesList[i]._mdf || this._isFirstFrame) {
            if (this.stylesList[i].msElem) {
                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers
                this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
            }
            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
        }
    };
    SVGShapeElement.prototype.renderShape = function() {
        var i;
        var len = this.animatedContents.length;
        var animatedContent;
        for(i = 0; i < len; i += 1){
            animatedContent = this.animatedContents[i];
            if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
        }
    };
    SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement();
        this.shapesData = null;
        this.itemsData = null;
    };
    function LetterProps(o, sw, sc, fc, m, p) {
        this.o = o;
        this.sw = sw;
        this.sc = sc;
        this.fc = fc;
        this.m = m;
        this.p = p;
        this._mdf = {
            o: true,
            sw: !!sw,
            sc: !!sc,
            fc: !!fc,
            m: true,
            p: true
        };
    }
    LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
        this._mdf.o = false;
        this._mdf.sw = false;
        this._mdf.sc = false;
        this._mdf.fc = false;
        this._mdf.m = false;
        this._mdf.p = false;
        var updated = false;
        if (this.o !== o) {
            this.o = o;
            this._mdf.o = true;
            updated = true;
        }
        if (this.sw !== sw) {
            this.sw = sw;
            this._mdf.sw = true;
            updated = true;
        }
        if (this.sc !== sc) {
            this.sc = sc;
            this._mdf.sc = true;
            updated = true;
        }
        if (this.fc !== fc) {
            this.fc = fc;
            this._mdf.fc = true;
            updated = true;
        }
        if (this.m !== m) {
            this.m = m;
            this._mdf.m = true;
            updated = true;
        }
        if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
            this.p = p;
            this._mdf.p = true;
            updated = true;
        }
        return updated;
    };
    function TextProperty(elem, data) {
        this._frameId = initialDefaultFrame;
        this.pv = '';
        this.v = '';
        this.kf = false;
        this._isFirstFrame = true;
        this._mdf = false;
        this.data = data;
        this.elem = elem;
        this.comp = this.elem.comp;
        this.keysIndex = 0;
        this.canResize = false;
        this.minimumFontSize = 1;
        this.effectsSequence = [];
        this.currentData = {
            ascent: 0,
            boxWidth: this.defaultBoxWidth,
            f: '',
            fStyle: '',
            fWeight: '',
            fc: '',
            j: '',
            justifyOffset: '',
            l: [],
            lh: 0,
            lineWidths: [],
            ls: '',
            of: '',
            s: '',
            sc: '',
            sw: 0,
            t: 0,
            tr: 0,
            sz: 0,
            ps: null,
            fillColorAnim: false,
            strokeColorAnim: false,
            strokeWidthAnim: false,
            yOffset: 0,
            finalSize: 0,
            finalText: [],
            finalLineHeight: 0,
            __complete: false
        };
        this.copyData(this.currentData, this.data.d.k[0].s);
        if (!this.searchProperty()) this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [
        0,
        0
    ];
    TextProperty.prototype.copyData = function(obj, data) {
        for(var s in data)if (Object.prototype.hasOwnProperty.call(data, s)) obj[s] = data[s];
        return obj;
    };
    TextProperty.prototype.setCurrentData = function(data) {
        if (!data.__complete) this.completeTextData(data);
        this.currentData = data;
        this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
        this._mdf = true;
    };
    TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
    };
    TextProperty.prototype.searchKeyframes = function() {
        this.kf = this.data.d.k.length > 1;
        if (this.kf) this.addEffect(this.getKeyframeValue.bind(this));
        return this.kf;
    };
    TextProperty.prototype.addEffect = function(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.getValue = function(_finalValue) {
        if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) return;
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var currentValue = this.currentData;
        var currentIndex = this.keysIndex;
        if (this.lock) {
            this.setCurrentData(this.currentData);
            return;
        }
        this.lock = true;
        this._mdf = false;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
        for(i = 0; i < len; i += 1)// Checking if index changed to prevent creating a new object every time the expression updates.
        if (currentIndex !== this.keysIndex) finalValue = this.effectsSequence[i](finalValue, finalValue.t);
        else finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
        if (currentValue !== finalValue) this.setCurrentData(finalValue);
        this.v = this.currentData;
        this.pv = this.v;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    };
    TextProperty.prototype.getKeyframeValue = function() {
        var textKeys = this.data.d.k;
        var frameNum = this.elem.comp.renderedFrame;
        var i = 0;
        var len = textKeys.length;
        while(i <= len - 1){
            if (i === len - 1 || textKeys[i + 1].t > frameNum) break;
            i += 1;
        }
        if (this.keysIndex !== i) this.keysIndex = i;
        return this.data.d.k[this.keysIndex].s;
    };
    TextProperty.prototype.buildFinalText = function(text) {
        var charactersArray = [];
        var i = 0;
        var len = text.length;
        var charCode;
        var secondCharCode;
        var shouldCombine = false;
        while(i < len){
            charCode = text.charCodeAt(i);
            if (FontManager.isCombinedCharacter(charCode)) charactersArray[charactersArray.length - 1] += text.charAt(i);
            else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
                secondCharCode = text.charCodeAt(i + 1);
                if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
                    if (shouldCombine || FontManager.isModifier(charCode, secondCharCode)) {
                        charactersArray[charactersArray.length - 1] += text.substr(i, 2);
                        shouldCombine = false;
                    } else charactersArray.push(text.substr(i, 2));
                    i += 1;
                } else charactersArray.push(text.charAt(i));
            } else if (charCode > 0xDBFF) {
                secondCharCode = text.charCodeAt(i + 1);
                if (FontManager.isZeroWidthJoiner(charCode, secondCharCode)) {
                    shouldCombine = true;
                    charactersArray[charactersArray.length - 1] += text.substr(i, 2);
                    i += 1;
                } else charactersArray.push(text.charAt(i));
            } else if (FontManager.isZeroWidthJoiner(charCode)) {
                charactersArray[charactersArray.length - 1] += text.charAt(i);
                shouldCombine = true;
            } else charactersArray.push(text.charAt(i));
            i += 1;
        }
        return charactersArray;
    };
    TextProperty.prototype.completeTextData = function(documentData) {
        documentData.__complete = true;
        var fontManager = this.elem.globalData.fontManager;
        var data = this.data;
        var letters = [];
        var i;
        var len;
        var newLineFlag;
        var index = 0;
        var val;
        var anchorGrouping = data.m.g;
        var currentSize = 0;
        var currentPos = 0;
        var currentLine = 0;
        var lineWidths = [];
        var lineWidth = 0;
        var maxLineWidth = 0;
        var j;
        var jLen;
        var fontData = fontManager.getFontByName(documentData.f);
        var charData;
        var cLength = 0;
        var fontProps = getFontProperties(fontData);
        documentData.fWeight = fontProps.weight;
        documentData.fStyle = fontProps.style;
        documentData.finalSize = documentData.s;
        documentData.finalText = this.buildFinalText(documentData.t);
        len = documentData.finalText.length;
        documentData.finalLineHeight = documentData.lh;
        var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
        var charCode;
        if (documentData.sz) {
            var flag = true;
            var boxWidth = documentData.sz[0];
            var boxHeight = documentData.sz[1];
            var currentHeight;
            var finalText;
            while(flag){
                finalText = this.buildFinalText(documentData.t);
                currentHeight = 0;
                lineWidth = 0;
                len = finalText.length;
                trackingOffset = documentData.tr / 1000 * documentData.finalSize;
                var lastSpaceIndex = -1;
                for(i = 0; i < len; i += 1){
                    charCode = finalText[i].charCodeAt(0);
                    newLineFlag = false;
                    if (finalText[i] === ' ') lastSpaceIndex = i;
                    else if (charCode === 13 || charCode === 3) {
                        lineWidth = 0;
                        newLineFlag = true;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                    }
                    if (fontManager.chars) {
                        charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
                        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
                    } else // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                    cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
                    if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
                        if (lastSpaceIndex === -1) len += 1;
                        else i = lastSpaceIndex;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                        finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r'); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
                        lastSpaceIndex = -1;
                        lineWidth = 0;
                    } else {
                        lineWidth += cLength;
                        lineWidth += trackingOffset;
                    }
                }
                currentHeight += fontData.ascent * documentData.finalSize / 100;
                if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
                    documentData.finalSize -= 1;
                    documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
                } else {
                    documentData.finalText = finalText;
                    len = documentData.finalText.length;
                    flag = false;
                }
            }
        }
        lineWidth = -trackingOffset;
        cLength = 0;
        var uncollapsedSpaces = 0;
        var currentChar;
        for(i = 0; i < len; i += 1){
            newLineFlag = false;
            currentChar = documentData.finalText[i];
            charCode = currentChar.charCodeAt(0);
            if (charCode === 13 || charCode === 3) {
                uncollapsedSpaces = 0;
                lineWidths.push(lineWidth);
                maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
                lineWidth = -2 * trackingOffset;
                val = '';
                newLineFlag = true;
                currentLine += 1;
            } else val = currentChar;
            if (fontManager.chars) {
                charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
                cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
            } else // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
            // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
            cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
             //
            if (currentChar === ' ') uncollapsedSpaces += cLength + trackingOffset;
            else {
                lineWidth += cLength + trackingOffset + uncollapsedSpaces;
                uncollapsedSpaces = 0;
            }
            letters.push({
                l: cLength,
                an: cLength,
                add: currentSize,
                n: newLineFlag,
                anIndexes: [],
                val: val,
                line: currentLine,
                animatorJustifyOffset: 0
            });
            if (anchorGrouping == 2) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || val === ' ' || i === len - 1) {
                    if (val === '' || val === ' ') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    index += 1;
                    currentSize = 0;
                }
            } else if (anchorGrouping == 3) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || i === len - 1) {
                    if (val === '') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    currentSize = 0;
                    index += 1;
                }
            } else {
                letters[index].ind = index;
                letters[index].extra = 0;
                index += 1;
            }
        }
        documentData.l = letters;
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidths.push(lineWidth);
        if (documentData.sz) {
            documentData.boxWidth = documentData.sz[0];
            documentData.justifyOffset = 0;
        } else {
            documentData.boxWidth = maxLineWidth;
            switch(documentData.j){
                case 1:
                    documentData.justifyOffset = -documentData.boxWidth;
                    break;
                case 2:
                    documentData.justifyOffset = -documentData.boxWidth / 2;
                    break;
                default:
                    documentData.justifyOffset = 0;
            }
        }
        documentData.lineWidths = lineWidths;
        var animators = data.a;
        var animatorData;
        var letterData;
        jLen = animators.length;
        var based;
        var ind;
        var indexes = [];
        for(j = 0; j < jLen; j += 1){
            animatorData = animators[j];
            if (animatorData.a.sc) documentData.strokeColorAnim = true;
            if (animatorData.a.sw) documentData.strokeWidthAnim = true;
            if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) documentData.fillColorAnim = true;
            ind = 0;
            based = animatorData.s.b;
            for(i = 0; i < len; i += 1){
                letterData = letters[i];
                letterData.anIndexes[j] = ind;
                if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
                    // eslint-disable-line eqeqeq
                    if (animatorData.s.rn === 1) indexes.push(ind);
                    ind += 1;
                }
            }
            data.a[j].s.totalChars = ind;
            var currentInd = -1;
            var newInd;
            if (animatorData.s.rn === 1) for(i = 0; i < len; i += 1){
                letterData = letters[i];
                if (currentInd != letterData.anIndexes[j]) {
                    // eslint-disable-line eqeqeq
                    currentInd = letterData.anIndexes[j];
                    newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
                }
                letterData.anIndexes[j] = newInd;
            }
        }
        documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
        documentData.ls = documentData.ls || 0;
        documentData.ascent = fontData.ascent * documentData.finalSize / 100;
    };
    TextProperty.prototype.updateDocumentData = function(newData, index) {
        index = index === undefined ? this.keysIndex : index;
        var dData = this.copyData({}, this.data.d.k[index].s);
        dData = this.copyData(dData, newData);
        this.data.d.k[index].s = dData;
        this.recalculate(index);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.recalculate = function(index) {
        var dData = this.data.d.k[index].s;
        dData.__complete = false;
        this.keysIndex = 0;
        this._isFirstFrame = true;
        this.getValue(dData);
    };
    TextProperty.prototype.canResizeFont = function(_canResize) {
        this.canResize = _canResize;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
        this.minimumFontSize = Math.floor(_fontValue) || 1;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        function TextSelectorPropFactory(elem, data) {
            this._currentTextLength = -1;
            this.k = false;
            this.data = data;
            this.elem = elem;
            this.comp = elem.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.initDynamicPropertyContainer(elem);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: 0
            }, 0, 0, this);
            if ('e' in data) this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
            else this.e = {
                v: 100
            };
            this.o = PropertyFactory.getProp(elem, data.o || {
                k: 0
            }, 0, 0, this);
            this.xe = PropertyFactory.getProp(elem, data.xe || {
                k: 0
            }, 0, 0, this);
            this.ne = PropertyFactory.getProp(elem, data.ne || {
                k: 0
            }, 0, 0, this);
            this.sm = PropertyFactory.getProp(elem, data.sm || {
                k: 100
            }, 0, 0, this);
            this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
            if (!this.dynamicProperties.length) this.getValue();
        }
        TextSelectorPropFactory.prototype = {
            getMult: function getMult(ind) {
                if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) this.getValue();
                var x1 = 0;
                var y1 = 0;
                var x2 = 1;
                var y2 = 1;
                if (this.ne.v > 0) x1 = this.ne.v / 100.0;
                else y1 = -this.ne.v / 100.0;
                if (this.xe.v > 0) x2 = 1.0 - this.xe.v / 100.0;
                else y2 = 1.0 + this.xe.v / 100.0;
                var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
                var mult = 0;
                var s = this.finalS;
                var e = this.finalE;
                var type = this.data.sh;
                if (type === 2) {
                    if (e === s) mult = ind >= e ? 1 : 0;
                    else mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 3) {
                    if (e === s) mult = ind >= e ? 0 : 1;
                    else mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 4) {
                    if (e === s) mult = 0;
                    else {
                        mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                        if (mult < 0.5) mult *= 2;
                        else mult = 1 - 2 * (mult - 0.5);
                    }
                    mult = easer(mult);
                } else if (type === 5) {
                    if (e === s) mult = 0;
                    else {
                        var tot = e - s;
                        /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ ind = min(max(0, ind + 0.5 - s), e - s);
                        var x = -tot / 2 + ind;
                        var a = tot / 2;
                        mult = Math.sqrt(1 - x * x / (a * a));
                    }
                    mult = easer(mult);
                } else if (type === 6) {
                    if (e === s) mult = 0;
                    else {
                        ind = min(max(0, ind + 0.5 - s), e - s);
                        mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
                    }
                    mult = easer(mult);
                } else {
                    if (ind >= floor(s)) {
                        if (ind - s < 0) mult = max(0, min(min(e, 1) - (s - ind), 1));
                        else mult = max(0, min(e - ind, 1));
                    }
                    mult = easer(mult);
                } // Smoothness implementation.
                // The smoothness represents a reduced range of the original [0; 1] range.
                // if smoothness is 25%, the new range will be [0.375; 0.625]
                // Steps are:
                // - find the lower value of the new range (threshold)
                // - if multiplier is smaller than that value, floor it to 0
                // - if it is larger,
                //     - subtract the threshold
                //     - divide it by the smoothness (this will return the range to [0; 1])
                // Note: If it doesn't work on some scenarios, consider applying it before the easer.
                if (this.sm.v !== 100) {
                    var smoothness = this.sm.v * 0.01;
                    if (smoothness === 0) smoothness = 0.00000001;
                    var threshold = 0.5 - smoothness * 0.5;
                    if (mult < threshold) mult = 0;
                    else {
                        mult = (mult - threshold) / smoothness;
                        if (mult > 1) mult = 1;
                    }
                }
                return mult * this.a.v;
            },
            getValue: function getValue(newCharsFlag) {
                this.iterateDynamicProperties();
                this._mdf = newCharsFlag || this._mdf;
                this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
                if (newCharsFlag && this.data.r === 2) this.e.v = this._currentTextLength;
                var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
                var o = this.o.v / divisor;
                var s = this.s.v / divisor + o;
                var e = this.e.v / divisor + o;
                if (s > e) {
                    var _s = s;
                    s = e;
                    e = _s;
                }
                this.finalS = s;
                this.finalE = e;
            }
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TextSelectorPropFactory);
        function getTextSelectorProp(elem, data, arr) {
            return new TextSelectorPropFactory(elem, data, arr);
        }
        return {
            getTextSelectorProp: getTextSelectorProp
        };
    }();
    function TextAnimatorDataProperty(elem, animatorProps, container) {
        var defaultData = {
            propType: false
        };
        var getProp = PropertyFactory.getProp;
        var textAnimatorAnimatables = animatorProps.a;
        this.a = {
            r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
            rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
            ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
            sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
            sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
            s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
            a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
            o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
            p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
            sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
            sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
            fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
            fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
            fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
            fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
            t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
        };
        this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
        this.s.t = animatorProps.s.t;
    }
    function TextAnimatorProperty(textData, renderType, elem) {
        this._isFirstFrame = true;
        this._hasMaskedPath = false;
        this._frameId = -1;
        this._textData = textData;
        this._renderType = renderType;
        this._elem = elem;
        this._animatorsData = createSizedArray(this._textData.a.length);
        this._pathData = {};
        this._moreOptions = {
            alignment: {}
        };
        this.renderedLetters = [];
        this.lettersChangedFlag = false;
        this.initDynamicPropertyContainer(elem);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
        var i;
        var len = this._textData.a.length;
        var animatorProps;
        var getProp = PropertyFactory.getProp;
        for(i = 0; i < len; i += 1){
            animatorProps = this._textData.a[i];
            this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
        }
        if (this._textData.p && 'm' in this._textData.p) {
            this._pathData = {
                a: getProp(this._elem, this._textData.p.a, 0, 0, this),
                f: getProp(this._elem, this._textData.p.f, 0, 0, this),
                l: getProp(this._elem, this._textData.p.l, 0, 0, this),
                r: getProp(this._elem, this._textData.p.r, 0, 0, this),
                p: getProp(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            };
            this._hasMaskedPath = true;
        } else this._hasMaskedPath = false;
        this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
    };
    TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag) {
        this.lettersChangedFlag = lettersChangedFlag;
        if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) return;
        this._isFirstFrame = false;
        var alignment = this._moreOptions.alignment.v;
        var animators = this._animatorsData;
        var textData = this._textData;
        var matrixHelper = this.mHelper;
        var renderType = this._renderType;
        var renderedLettersCount = this.renderedLetters.length;
        var xPos;
        var yPos;
        var i;
        var len;
        var letters = documentData.l;
        var pathInfo;
        var currentLength;
        var currentPoint;
        var segmentLength;
        var flag;
        var pointInd;
        var segmentInd;
        var prevPoint;
        var points;
        var segments;
        var partialLength;
        var totalLength;
        var perc;
        var tanAngle;
        var mask;
        if (this._hasMaskedPath) {
            mask = this._pathData.m;
            if (!this._pathData.n || this._pathData._mdf) {
                var paths = mask.v;
                if (this._pathData.r.v) paths = paths.reverse();
                 // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
                pathInfo = {
                    tLength: 0,
                    segments: []
                };
                len = paths._length - 1;
                var bezierData;
                totalLength = 0;
                for(i = 0; i < len; i += 1){
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[i + 1][0] - paths.v[i + 1][0],
                        paths.i[i + 1][1] - paths.v[i + 1][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                i = len;
                if (mask.v.c) {
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[0][0] - paths.v[0][0],
                        paths.i[0][1] - paths.v[0][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                this._pathData.pi = pathInfo;
            }
            pathInfo = this._pathData.pi;
            currentLength = this._pathData.f.v;
            segmentInd = 0;
            pointInd = 1;
            segmentLength = 0;
            flag = true;
            segments = pathInfo.segments;
            if (currentLength < 0 && mask.v.c) {
                if (pathInfo.tLength < Math.abs(currentLength)) currentLength = -Math.abs(currentLength) % pathInfo.tLength;
                segmentInd = segments.length - 1;
                points = segments[segmentInd].points;
                pointInd = points.length - 1;
                while(currentLength < 0){
                    currentLength += points[pointInd].partialLength;
                    pointInd -= 1;
                    if (pointInd < 0) {
                        segmentInd -= 1;
                        points = segments[segmentInd].points;
                        pointInd = points.length - 1;
                    }
                }
            }
            points = segments[segmentInd].points;
            prevPoint = points[pointInd - 1];
            currentPoint = points[pointInd];
            partialLength = currentPoint.partialLength;
        }
        len = letters.length;
        xPos = 0;
        yPos = 0;
        var yOff = documentData.finalSize * 1.2 * 0.714;
        var firstLine = true;
        var animatorProps;
        var animatorSelector;
        var j;
        var jLen;
        var letterValue;
        jLen = animators.length;
        var mult;
        var ind = -1;
        var offf;
        var xPathPos;
        var yPathPos;
        var initPathPos = currentLength;
        var initSegmentInd = segmentInd;
        var initPointInd = pointInd;
        var currentLine = -1;
        var elemOpacity;
        var sc;
        var sw;
        var fc;
        var k;
        var letterSw;
        var letterSc;
        var letterFc;
        var letterM = '';
        var letterP = this.defaultPropsArray;
        var letterO; //
        if (documentData.j === 2 || documentData.j === 1) {
            var animatorJustifyOffset = 0;
            var animatorFirstCharOffset = 0;
            var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
            var lastIndex = 0;
            var isNewLine = true;
            for(i = 0; i < len; i += 1)if (letters[i].n) {
                if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
                while(lastIndex < i){
                    letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                    lastIndex += 1;
                }
                animatorJustifyOffset = 0;
                isNewLine = true;
            } else {
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        if (isNewLine && documentData.j === 2) animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
                        else animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
                    }
                }
                isNewLine = false;
            }
            if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
            while(lastIndex < i){
                letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                lastIndex += 1;
            }
        } //
        for(i = 0; i < len; i += 1){
            matrixHelper.reset();
            elemOpacity = 1;
            if (letters[i].n) {
                xPos = 0;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                currentLength = initPathPos;
                firstLine = false;
                if (this._hasMaskedPath) {
                    segmentInd = initSegmentInd;
                    pointInd = initPointInd;
                    points = segments[segmentInd].points;
                    prevPoint = points[pointInd - 1];
                    currentPoint = points[pointInd];
                    partialLength = currentPoint.partialLength;
                    segmentLength = 0;
                }
                letterM = '';
                letterFc = '';
                letterSw = '';
                letterO = '';
                letterP = this.defaultPropsArray;
            } else {
                if (this._hasMaskedPath) {
                    if (currentLine !== letters[i].line) {
                        switch(documentData.j){
                            case 1:
                                currentLength += totalLength - documentData.lineWidths[letters[i].line];
                                break;
                            case 2:
                                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                                break;
                            default:
                                break;
                        }
                        currentLine = letters[i].line;
                    }
                    if (ind !== letters[i].ind) {
                        if (letters[ind]) currentLength += letters[ind].extra;
                        currentLength += letters[i].an / 2;
                        ind = letters[i].ind;
                    }
                    currentLength += alignment[0] * letters[i].an * 0.005;
                    var animatorOffset = 0;
                    for(j = 0; j < jLen; j += 1){
                        animatorProps = animators[j].a;
                        if (animatorProps.p.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.p.v[0] * mult[0];
                            else animatorOffset += animatorProps.p.v[0] * mult;
                        }
                        if (animatorProps.a.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.a.v[0] * mult[0];
                            else animatorOffset += animatorProps.a.v[0] * mult;
                        }
                    }
                    flag = true; // Force alignment only works with a single line for now
                    if (this._pathData.a.v) {
                        currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
                        currentLength += this._pathData.f.v;
                    }
                    while(flag){
                        if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                            perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                            xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                            yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                            matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
                            flag = false;
                        } else if (points) {
                            segmentLength += currentPoint.partialLength;
                            pointInd += 1;
                            if (pointInd >= points.length) {
                                pointInd = 0;
                                segmentInd += 1;
                                if (!segments[segmentInd]) {
                                    if (mask.v.c) {
                                        pointInd = 0;
                                        segmentInd = 0;
                                        points = segments[segmentInd].points;
                                    } else {
                                        segmentLength -= currentPoint.partialLength;
                                        points = null;
                                    }
                                } else points = segments[segmentInd].points;
                            }
                            if (points) {
                                prevPoint = currentPoint;
                                currentPoint = points[pointInd];
                                partialLength = currentPoint.partialLength;
                            }
                        }
                    }
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0);
                } else {
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0); // Grouping alignment
                    matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
                        if (xPos !== 0 || documentData.j !== 0) {
                            if (this._hasMaskedPath) {
                                if (mult.length) currentLength += animatorProps.t.v * mult[0];
                                else currentLength += animatorProps.t.v * mult;
                            } else if (mult.length) xPos += animatorProps.t.v * mult[0];
                            else xPos += animatorProps.t.v * mult;
                        }
                    }
                }
                if (documentData.strokeWidthAnim) sw = documentData.sw || 0;
                if (documentData.strokeColorAnim) {
                    if (documentData.sc) sc = [
                        documentData.sc[0],
                        documentData.sc[1],
                        documentData.sc[2]
                    ];
                    else sc = [
                        0,
                        0,
                        0
                    ];
                }
                if (documentData.fillColorAnim && documentData.fc) fc = [
                    documentData.fc[0],
                    documentData.fc[1],
                    documentData.fc[2]
                ];
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.a.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
                        else matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.s.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
                        else matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    if (animatorProps.sk.propType) {
                        if (mult.length) matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                        else matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                    }
                    if (animatorProps.r.propType) {
                        if (mult.length) matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                        else matrixHelper.rotateZ(-animatorProps.r.v * mult);
                    }
                    if (animatorProps.ry.propType) {
                        if (mult.length) matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
                        else matrixHelper.rotateY(animatorProps.ry.v * mult);
                    }
                    if (animatorProps.rx.propType) {
                        if (mult.length) matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
                        else matrixHelper.rotateX(animatorProps.rx.v * mult);
                    }
                    if (animatorProps.o.propType) {
                        if (mult.length) elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
                        else elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
                    }
                    if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
                        if (mult.length) sw += animatorProps.sw.v * mult[0];
                        else sw += animatorProps.sw.v * mult;
                    }
                    if (documentData.strokeColorAnim && animatorProps.sc.propType) {
                        for(k = 0; k < 3; k += 1)if (mult.length) sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
                        else sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
                    }
                    if (documentData.fillColorAnim && documentData.fc) {
                        if (animatorProps.fc.propType) {
                            for(k = 0; k < 3; k += 1)if (mult.length) fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                            else fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                        }
                        if (animatorProps.fh.propType) {
                            if (mult.length) fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
                            else fc = addHueToRGB(fc, animatorProps.fh.v * mult);
                        }
                        if (animatorProps.fs.propType) {
                            if (mult.length) fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
                            else fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
                        }
                        if (animatorProps.fb.propType) {
                            if (mult.length) fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
                            else fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
                        }
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.p.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (this._hasMaskedPath) {
                            if (mult.length) matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                            else matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        } else if (mult.length) matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                        else matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                    }
                }
                if (documentData.strokeWidthAnim) letterSw = sw < 0 ? 0 : sw;
                if (documentData.strokeColorAnim) letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
                if (documentData.fillColorAnim && documentData.fc) letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
                if (this._hasMaskedPath) {
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
                    if (this._pathData.p.v) {
                        tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                        var rot = Math.atan(tanAngle) * 180 / Math.PI;
                        if (currentPoint.point[0] < prevPoint.point[0]) rot += 180;
                        matrixHelper.rotate(-rot * Math.PI / 180);
                    }
                    matrixHelper.translate(xPathPos, yPathPos, 0);
                    currentLength -= alignment[0] * letters[i].an * 0.005;
                    if (letters[i + 1] && ind !== letters[i + 1].ind) {
                        currentLength += letters[i].an / 2;
                        currentLength += documentData.tr * 0.001 * documentData.finalSize;
                    }
                } else {
                    matrixHelper.translate(xPos, yPos, 0);
                    if (documentData.ps) // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
                    switch(documentData.j){
                        case 1:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
                            break;
                        case 2:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
                            break;
                        default:
                            break;
                    }
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(offf, 0, 0);
                    matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
                    xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
                }
                if (renderType === 'html') letterM = matrixHelper.toCSS();
                else if (renderType === 'svg') letterM = matrixHelper.to2dCSS();
                else letterP = [
                    matrixHelper.props[0],
                    matrixHelper.props[1],
                    matrixHelper.props[2],
                    matrixHelper.props[3],
                    matrixHelper.props[4],
                    matrixHelper.props[5],
                    matrixHelper.props[6],
                    matrixHelper.props[7],
                    matrixHelper.props[8],
                    matrixHelper.props[9],
                    matrixHelper.props[10],
                    matrixHelper.props[11],
                    matrixHelper.props[12],
                    matrixHelper.props[13],
                    matrixHelper.props[14],
                    matrixHelper.props[15]
                ];
                letterO = elemOpacity;
            }
            if (renderedLettersCount <= i) {
                letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
                this.renderedLetters.push(letterValue);
                renderedLettersCount += 1;
                this.lettersChangedFlag = true;
            } else {
                letterValue = this.renderedLetters[i];
                this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
            }
        }
    };
    TextAnimatorProperty.prototype.getValue = function() {
        if (this._elem.globalData.frameId === this._frameId) return;
        this._frameId = this._elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    TextAnimatorProperty.prototype.mHelper = new Matrix();
    TextAnimatorProperty.prototype.defaultPropsArray = [];
    extendPrototype([
        DynamicPropertyContainer
    ], TextAnimatorProperty);
    function ITextElement() {}
    ITextElement.prototype.initElement = function(data, globalData, comp) {
        this.lettersChangedFlag = true;
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
        this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
        this.textAnimator.searchProperties(this.dynamicProperties);
    };
    ITextElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
            this.buildNewText();
            this.textProperty._isFirstFrame = false;
            this.textProperty._mdf = false;
        }
    };
    ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
        var j;
        var jLen = shapes.length;
        var pathNodes;
        var shapeStr = '';
        for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
            pathNodes = shapes[j].ks.k;
            shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
        }
        return shapeStr;
    };
    ITextElement.prototype.updateDocumentData = function(newData, index) {
        this.textProperty.updateDocumentData(newData, index);
    };
    ITextElement.prototype.canResizeFont = function(_canResize) {
        this.textProperty.canResizeFont(_canResize);
    };
    ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
        this.textProperty.setMinimumFontSize(_fontSize);
    };
    ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
        if (documentData.ps) matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        matrixHelper.translate(0, -documentData.ls, 0);
        switch(documentData.j){
            case 1:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
                break;
            case 2:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
                break;
            default:
                break;
        }
        matrixHelper.translate(xPos, yPos, 0);
    };
    ITextElement.prototype.buildColor = function(colorData) {
        return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
    };
    ITextElement.prototype.emptyProp = new LetterProps();
    ITextElement.prototype.destroy = function() {};
    var emptyShapeData = {
        shapes: []
    };
    function SVGTextLottieElement(data, globalData, comp) {
        this.textSpans = [];
        this.renderType = 'svg';
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], SVGTextLottieElement);
    SVGTextLottieElement.prototype.createContent = function() {
        if (this.data.singleShape && !this.globalData.fontManager.chars) this.textContainer = createNS('text');
    };
    SVGTextLottieElement.prototype.buildTextContents = function(textArray) {
        var i = 0;
        var len = textArray.length;
        var textContents = [];
        var currentTextContent = '';
        while(i < len){
            if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
                textContents.push(currentTextContent);
                currentTextContent = '';
            } else currentTextContent += textArray[i];
            i += 1;
        }
        textContents.push(currentTextContent);
        return textContents;
    };
    SVGTextLottieElement.prototype.buildShapeData = function(data, scale) {
        // data should probably be cloned to apply scale separately to each instance of a text on different layers
        // but since text internal content gets only rendered once and then it's never rerendered,
        // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
        // Avoiding cloning is preferred since cloning each character shape data is expensive
        if (data.shapes && data.shapes.length) {
            var shape = data.shapes[0];
            if (shape.it) {
                var shapeItem = shape.it[shape.it.length - 1];
                if (shapeItem.s) {
                    shapeItem.s.k[0] = scale;
                    shapeItem.s.k[1] = scale;
                }
            }
        }
        return data;
    };
    SVGTextLottieElement.prototype.buildNewText = function() {
        this.addDynamicProperty(this);
        var i;
        var len;
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
        if (documentData.fc) this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
        else this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
        if (documentData.sc) {
            this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
            this.layerElement.setAttribute('stroke-width', documentData.sw);
        }
        this.layerElement.setAttribute('font-size', documentData.finalSize);
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (fontData.fClass) this.layerElement.setAttribute('class', fontData.fClass);
        else {
            this.layerElement.setAttribute('font-family', fontData.fFamily);
            var fWeight = documentData.fWeight;
            var fStyle = documentData.fStyle;
            this.layerElement.setAttribute('font-style', fStyle);
            this.layerElement.setAttribute('font-weight', fWeight);
        }
        this.layerElement.setAttribute('aria-label', documentData.t);
        var letters = documentData.l || [];
        var usesGlyphs = !!this.globalData.fontManager.chars;
        len = letters.length;
        var tSpan;
        var matrixHelper = this.mHelper;
        var shapeStr = '';
        var singleShape = this.data.singleShape;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        if (singleShape && !usesGlyphs && !documentData.sz) {
            var tElement = this.textContainer;
            var justify = 'start';
            switch(documentData.j){
                case 1:
                    justify = 'end';
                    break;
                case 2:
                    justify = 'middle';
                    break;
                default:
                    justify = 'start';
                    break;
            }
            tElement.setAttribute('text-anchor', justify);
            tElement.setAttribute('letter-spacing', trackingOffset);
            var textContent = this.buildTextContents(documentData.finalText);
            len = textContent.length;
            yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
            for(i = 0; i < len; i += 1){
                tSpan = this.textSpans[i].span || createNS('tspan');
                tSpan.textContent = textContent[i];
                tSpan.setAttribute('x', 0);
                tSpan.setAttribute('y', yPos);
                tSpan.style.display = 'inherit';
                tElement.appendChild(tSpan);
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    glyph: null
                };
                this.textSpans[i].span = tSpan;
                yPos += documentData.finalLineHeight;
            }
            this.layerElement.appendChild(tElement);
        } else {
            var cachedSpansLength = this.textSpans.length;
            var charData;
            for(i = 0; i < len; i += 1){
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    childSpan: null,
                    glyph: null
                };
                if (!usesGlyphs || !singleShape || i === 0) {
                    tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');
                    if (cachedSpansLength <= i) {
                        tSpan.setAttribute('stroke-linecap', 'butt');
                        tSpan.setAttribute('stroke-linejoin', 'round');
                        tSpan.setAttribute('stroke-miterlimit', '4');
                        this.textSpans[i].span = tSpan;
                        if (usesGlyphs) {
                            var childSpan = createNS('g');
                            tSpan.appendChild(childSpan);
                            this.textSpans[i].childSpan = childSpan;
                        }
                        this.textSpans[i].span = tSpan;
                        this.layerElement.appendChild(tSpan);
                    }
                    tSpan.style.display = 'inherit';
                }
                matrixHelper.reset();
                if (singleShape) {
                    if (letters[i].n) {
                        xPos = -trackingOffset;
                        yPos += documentData.yOffset;
                        yPos += firstLine ? 1 : 0;
                        firstLine = false;
                    }
                    this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
                    xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
                    xPos += trackingOffset;
                }
                if (usesGlyphs) {
                    charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                    var glyphElement; // t === 1 means the character has been replaced with an animated shaped
                    if (charData.t === 1) glyphElement = new SVGCompElement(charData.data, this.globalData, this);
                    else {
                        var data = emptyShapeData;
                        if (charData.data && charData.data.shapes) data = this.buildShapeData(charData.data, documentData.finalSize);
                        glyphElement = new SVGShapeElement(data, this.globalData, this);
                    }
                    if (this.textSpans[i].glyph) {
                        var glyph = this.textSpans[i].glyph;
                        this.textSpans[i].childSpan.removeChild(glyph.layerElement);
                        glyph.destroy();
                    }
                    this.textSpans[i].glyph = glyphElement;
                    glyphElement._debug = true;
                    glyphElement.prepareFrame(0);
                    glyphElement.renderFrame();
                    this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
                    // this might have issues with strokes and might need a different solution
                    if (charData.t === 1) this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
                } else {
                    if (singleShape) tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
                    tSpan.textContent = letters[i].val;
                    tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                } //
            }
            if (singleShape && tSpan) tSpan.setAttribute('d', shapeStr);
        }
        while(i < this.textSpans.length){
            this.textSpans[i].span.style.display = 'none';
            i += 1;
        }
        this._sizeChanged = true;
    };
    SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        this.prepareFrame(this.comp.renderedFrame - this.data.st);
        this.renderInnerContent();
        if (this._sizeChanged) {
            this._sizeChanged = false;
            var textBox = this.layerElement.getBBox();
            this.bbox = {
                top: textBox.y,
                left: textBox.x,
                width: textBox.width,
                height: textBox.height
            };
        }
        return this.bbox;
    };
    SVGTextLottieElement.prototype.getValue = function() {
        var i;
        var len = this.textSpans.length;
        var glyphElement;
        this.renderedFrame = this.comp.renderedFrame;
        for(i = 0; i < len; i += 1){
            glyphElement = this.textSpans[i].glyph;
            if (glyphElement) {
                glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
                if (glyphElement._mdf) this._mdf = true;
            }
        }
    };
    SVGTextLottieElement.prototype.renderInnerContent = function() {
        if (!this.data.singleShape || this._mdf) {
            this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                this._sizeChanged = true;
                var i;
                var len;
                var renderedLetters = this.textAnimator.renderedLetters;
                var letters = this.textProperty.currentData.l;
                len = letters.length;
                var renderedLetter;
                var textSpan;
                var glyphElement;
                for(i = 0; i < len; i += 1)if (!letters[i].n) {
                    renderedLetter = renderedLetters[i];
                    textSpan = this.textSpans[i].span;
                    glyphElement = this.textSpans[i].glyph;
                    if (glyphElement) glyphElement.renderFrame();
                    if (renderedLetter._mdf.m) textSpan.setAttribute('transform', renderedLetter.m);
                    if (renderedLetter._mdf.o) textSpan.setAttribute('opacity', renderedLetter.o);
                    if (renderedLetter._mdf.sw) textSpan.setAttribute('stroke-width', renderedLetter.sw);
                    if (renderedLetter._mdf.sc) textSpan.setAttribute('stroke', renderedLetter.sc);
                    if (renderedLetter._mdf.fc) textSpan.setAttribute('fill', renderedLetter.fc);
                }
            }
        }
    };
    function ISolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        IImageElement
    ], ISolidElement);
    ISolidElement.prototype.createContent = function() {
        var rect = createNS('rect'); /// /rect.style.width = this.data.sw;
        /// /rect.style.height = this.data.sh;
        /// /rect.style.fill = this.data.sc;
        rect.setAttribute('width', this.data.sw);
        rect.setAttribute('height', this.data.sh);
        rect.setAttribute('fill', this.data.sc);
        this.layerElement.appendChild(rect);
    };
    function NullElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initFrame();
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    NullElement.prototype.renderFrame = function() {};
    NullElement.prototype.getBaseElement = function() {
        return null;
    };
    NullElement.prototype.destroy = function() {};
    NullElement.prototype.sourceRectAtTime = function() {};
    NullElement.prototype.hide = function() {};
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement
    ], NullElement);
    function SVGRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], SVGRendererBase);
    SVGRendererBase.prototype.createNull = function(data) {
        return new NullElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createShape = function(data) {
        return new SVGShapeElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createText = function(data) {
        return new SVGTextLottieElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createImage = function(data) {
        return new IImageElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createSolid = function(data) {
        return new ISolidElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.configAnimation = function(animData) {
        this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
        if (this.renderConfig.viewBoxSize) this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
        else this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
        if (!this.renderConfig.viewBoxOnly) {
            this.svgElement.setAttribute('width', animData.w);
            this.svgElement.setAttribute('height', animData.h);
            this.svgElement.style.width = '100%';
            this.svgElement.style.height = '100%';
            this.svgElement.style.transform = 'translate3d(0,0,0)';
            this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
        }
        if (this.renderConfig.width) this.svgElement.setAttribute('width', this.renderConfig.width);
        if (this.renderConfig.height) this.svgElement.setAttribute('height', this.renderConfig.height);
        if (this.renderConfig.className) this.svgElement.setAttribute('class', this.renderConfig.className);
        if (this.renderConfig.id) this.svgElement.setAttribute('id', this.renderConfig.id);
        if (this.renderConfig.focusable !== undefined) this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
        this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
        // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation
        var defs = this.globalData.defs;
        this.setupGlobalData(animData, defs);
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.data = animData;
        var maskElement = createNS('clipPath');
        var rect = createNS('rect');
        rect.setAttribute('width', animData.w);
        rect.setAttribute('height', animData.h);
        rect.setAttribute('x', 0);
        rect.setAttribute('y', 0);
        var maskId = createElementID();
        maskElement.setAttribute('id', maskId);
        maskElement.appendChild(rect);
        this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
        defs.appendChild(maskElement);
        this.layers = animData.layers;
        this.elements = createSizedArray(animData.layers.length);
    };
    SVGRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.layerElement = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i]) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    SVGRendererBase.prototype.updateContainerSize = function() {};
    SVGRendererBase.prototype.findIndexByInd = function(ind) {
        var i = 0;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1){
            if (this.layers[i].ind === ind) return i;
        }
        return -1;
    };
    SVGRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        elements[pos] = true;
        var element = this.createItem(this.layers[pos]);
        elements[pos] = element;
        if (getExpressionsPlugin()) {
            if (this.layers[pos].ty === 0) this.globalData.projectInterface.registerComposition(element);
            element.initExpressions();
        }
        this.appendElementInPos(element, pos);
        if (this.layers[pos].tt) {
            var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
            if (elementIndex === -1) return;
            if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
                this.buildItem(elementIndex);
                this.addPendingElement(element);
            } else {
                var matteElement = elements[elementIndex];
                var matteMask = matteElement.getMatte(this.layers[pos].tt);
                element.setMatte(matteMask);
            }
        }
    };
    SVGRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
            if (element.data.tt) {
                var i = 0;
                var len = this.elements.length;
                while(i < len){
                    if (this.elements[i] === element) {
                        var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
                        var matteElement = this.elements[elementIndex];
                        var matteMask = matteElement.getMatte(this.layers[i].tt);
                        element.setMatte(matteMask);
                        break;
                    }
                    i += 1;
                }
            }
        }
    };
    SVGRendererBase.prototype.renderFrame = function(num) {
        if (this.renderedFrame === num || this.destroyed) return;
        if (num === null) num = this.renderedFrame;
        else this.renderedFrame = num;
         // console.log('-------');
        // console.log('FRAME ',num);
        this.globalData.frameNum = num;
        this.globalData.frameId += 1;
        this.globalData.projectInterface.currentFrame = num;
        this.globalData._mdf = false;
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
        }
    };
    SVGRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newElement = element.getBaseElement();
        if (!newElement) return;
        var i = 0;
        var nextElement;
        while(i < pos){
            if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) nextElement = this.elements[i].getBaseElement();
            i += 1;
        }
        if (nextElement) this.layerElement.insertBefore(newElement, nextElement);
        else this.layerElement.appendChild(newElement);
    };
    SVGRendererBase.prototype.hide = function() {
        this.layerElement.style.display = 'none';
    };
    SVGRendererBase.prototype.show = function() {
        this.layerElement.style.display = 'block';
    };
    function ICompElement() {}
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], ICompElement);
    ICompElement.prototype.initElement = function(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initTransform(data, globalData, comp);
        this.initRenderable();
        this.initHierarchy();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        if (this.data.xt || !globalData.progressiveLoad) this.buildAllItems();
        this.hide();
    };
    /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */ ICompElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        if (!this.isInRange && !this.data.xt) return;
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            if (timeRemapped === this.data.op) timeRemapped = this.data.op - 1;
            this.renderedFrame = timeRemapped;
        } else this.renderedFrame = num / this.data.sr;
        var i;
        var len = this.elements.length;
        if (!this.completeLayers) this.checkLayers(this.renderedFrame);
         // This iteration needs to be backwards because of how expressions connect between each other
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) {
            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
            if (this.elements[i]._mdf) this._mdf = true;
        }
    };
    ICompElement.prototype.renderInnerContent = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    ICompElement.prototype.setElements = function(elems) {
        this.elements = elems;
    };
    ICompElement.prototype.getElements = function() {
        return this.elements;
    };
    ICompElement.prototype.destroyElements = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.elements[i]) this.elements[i].destroy();
    };
    ICompElement.prototype.destroy = function() {
        this.destroyElements();
        this.destroyBaseElement();
    };
    function SVGCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = true;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        SVGRendererBase,
        ICompElement,
        SVGBaseElement
    ], SVGCompElement);
    SVGCompElement.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function SVGRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.svgElement = createNS('svg');
        var ariaLabel = '';
        if (config && config.title) {
            var titleElement = createNS('title');
            var titleId = createElementID();
            titleElement.setAttribute('id', titleId);
            titleElement.textContent = config.title;
            this.svgElement.appendChild(titleElement);
            ariaLabel += titleId;
        }
        if (config && config.description) {
            var descElement = createNS('desc');
            var descId = createElementID();
            descElement.setAttribute('id', descId);
            descElement.textContent = config.description;
            this.svgElement.appendChild(descElement);
            ariaLabel += ' ' + descId;
        }
        if (ariaLabel) this.svgElement.setAttribute('aria-labelledby', ariaLabel);
        var defs = createNS('defs');
        this.svgElement.appendChild(defs);
        var maskElement = createNS('g');
        this.svgElement.appendChild(maskElement);
        this.layerElement = maskElement;
        this.renderConfig = {
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            progressiveLoad: config && config.progressiveLoad || false,
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            viewBoxOnly: config && config.viewBoxOnly || false,
            viewBoxSize: config && config.viewBoxSize || false,
            className: config && config.className || '',
            id: config && config.id || '',
            focusable: config && config.focusable,
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '100%',
                height: config && config.filterSize && config.filterSize.height || '100%',
                x: config && config.filterSize && config.filterSize.x || '0%',
                y: config && config.filterSize && config.filterSize.y || '0%'
            },
            width: config && config.width,
            height: config && config.height,
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            defs: defs,
            renderConfig: this.renderConfig
        };
        this.elements = [];
        this.pendingElements = [];
        this.destroyed = false;
        this.rendererType = 'svg';
    }
    extendPrototype([
        SVGRendererBase
    ], SVGRenderer);
    SVGRenderer.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    registerRenderer('svg', SVGRenderer); // Registering shape modifiers
    ShapeModifiers.registerModifier('tm', TrimModifier);
    ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
    ShapeModifiers.registerModifier('rp', RepeaterModifier);
    ShapeModifiers.registerModifier('rd', RoundCornersModifier);
    ShapeModifiers.registerModifier('zz', ZigZagModifier);
    ShapeModifiers.registerModifier('op', OffsetPathModifier);
    return lottie;
});


var $0073fd4c9601c378$exports = {};
$0073fd4c9601c378$exports = JSON.parse("{\"v\":\"5.0.1\",\"fr\":10,\"ip\":0,\"op\":20,\"w\":800,\"h\":600,\"ddd\":0,\"assets\":[],\"layers\":[{\"ind\":3,\"nm\":\"Layer 3\",\"ks\":{\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[456.419,423.252,0],\"to\":[-161.825,-53.536,0],\"ti\":[-62.867,94.219,0],\"i\":{\"x\":[0.15],\"y\":[0.86]},\"o\":{\"x\":[0.785],\"y\":[0.135]},\"e\":[371.703,167.513,0]},{\"t\":10,\"s\":[371.703,167.513,0],\"to\":[0,0,0],\"ti\":[0,0,0],\"i\":{\"x\":[0.15],\"y\":[0.86]},\"o\":{\"x\":[0.785],\"y\":[0.135]},\"e\":[456.419,423.252,0]},{\"t\":20,\"s\":[456.419,423.252,0]}]},\"a\":{\"a\":0,\"k\":[-24.5,-24.5,0]},\"s\":{\"a\":0,\"k\":[100,100,100]},\"r\":{\"a\":0,\"k\":-43.065},\"o\":{\"a\":0,\"k\":100}},\"ao\":0,\"ip\":0,\"op\":20,\"st\":0,\"bm\":3,\"sr\":1,\"ty\":4,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[210.919,210.919]},\"p\":{\"a\":0,\"k\":[0,0]}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.698,1,1]},\"hd\":false,\"o\":{\"a\":0,\"k\":100},\"r\":1},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0}}],\"nm\":\"Object\",\"hd\":false}]},{\"ind\":2,\"nm\":\"Layer 2\",\"ks\":{\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[361.777,165.918,0],\"to\":[0,0,0],\"ti\":[0,0,0],\"i\":{\"x\":[0.15],\"y\":[0.86]},\"o\":{\"x\":[0.785],\"y\":[0.135]},\"e\":[214.784,406.838,0]},{\"t\":10,\"s\":[214.784,406.838,0],\"to\":[-83.035,-34.503,0],\"ti\":[0,0,0],\"i\":{\"x\":[0.15],\"y\":[0.86]},\"o\":{\"x\":[0.785],\"y\":[0.135]},\"e\":[361.777,165.918,0]},{\"t\":20,\"s\":[361.777,165.918,0]}]},\"a\":{\"a\":0,\"k\":[-66.5,-66.5,0]},\"s\":{\"a\":0,\"k\":[100,100,100]},\"r\":{\"a\":0,\"k\":-43.065},\"o\":{\"a\":0,\"k\":100}},\"ao\":0,\"ip\":0,\"op\":20,\"st\":0,\"bm\":3,\"sr\":1,\"ty\":4,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[236,236]},\"p\":{\"a\":0,\"k\":[0,0]}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.012,0,0.38,1]},\"hd\":false,\"o\":{\"a\":0,\"k\":100},\"r\":1},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0}}],\"nm\":\"Object\",\"hd\":false}]},{\"ind\":1,\"nm\":\"Layer 1\",\"ks\":{\"p\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[263.776,342.564,0],\"to\":[0,0,0],\"ti\":[0,0,0],\"i\":{\"x\":[0.15],\"y\":[0.86]},\"o\":{\"x\":[0.785],\"y\":[0.135]},\"e\":[545.716,355.446,0]},{\"t\":10,\"s\":[545.716,355.446,0],\"to\":[-7.345,74.699,0],\"ti\":[0,0,0],\"i\":{\"x\":[0.15],\"y\":[0.86]},\"o\":{\"x\":[0.785],\"y\":[0.135]},\"e\":[263.776,342.564,0]},{\"t\":20,\"s\":[263.776,342.564,0]}]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":0,\"k\":[100,100,100]},\"r\":{\"a\":0,\"k\":-43.065},\"o\":{\"a\":0,\"k\":100}},\"ao\":0,\"ip\":0,\"op\":20,\"st\":0,\"bm\":3,\"sr\":1,\"ty\":4,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[150.135,150.135]},\"p\":{\"a\":0,\"k\":[0,0]}},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.298,0.255,0.714,1]},\"hd\":false,\"o\":{\"a\":0,\"k\":100},\"r\":1},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0}}],\"nm\":\"Object\",\"hd\":false}]}],\"markers\":[]}");


var $db22660c05d29d24$exports = {};
$db22660c05d29d24$exports = JSON.parse("{\"v\":\"5.7.3\",\"fr\":30,\"ip\":0,\"op\":175,\"w\":1080,\"h\":1080,\"nm\":\"taxaroo_logo_final_a\",\"ddd\":0,\"assets\":[{\"id\":\"image_0\",\"w\":1080,\"h\":1080,\"u\":\"images/\",\"p\":\"img_0.png\",\"e\":0},{\"id\":\"comp_0\",\"layers\":[{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"ear Outlines\",\"parent\":3,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":10,\"s\":[28]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":20,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":30,\"s\":[-1]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":49,\"s\":[26]},{\"t\":60,\"s\":[0]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[399.94,527.83,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[399.94,527.83,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-1.217,-0.182],[0.322,1.452],[0,0.023],[0.383,0.766],[0.522,0.753],[3.317,1.311],[2.378,-0.035],[-0.429,-0.951],[-0.22,-0.359],[-0.035,-0.034],[-0.395,-0.476],[-0.035,-0.024],[-1.717,-0.533],[0,0],[-0.371,-0.128],[0,0],[-1.102,-1.403]],\"o\":[[1.284,0.451],[-0.014,-0.041],[-0.278,-0.835],[-0.394,-0.847],[-2.076,-2.981],[-2.146,-0.846],[0.116,1.079],[0.162,0.395],[0.023,0.047],[0.348,0.511],[0.023,0.022],[1.183,1.275],[0,0],[0.395,0.07],[0,0],[1.74,0.569],[0,0]],\"v\":[[6.64,6.972],[8.592,5.321],[8.566,5.22],[7.592,2.819],[6.212,0.43],[-2.081,-6.124],[-8.913,-7.388],[-8.078,-4.326],[-7.498,-3.213],[-7.417,-3.085],[-6.303,-1.611],[-6.223,-1.53],[-1.803,1.253],[-1.792,1.253],[-0.655,1.543],[-0.643,1.543],[3.706,4.582]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[392.85,521.592],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":309,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"body Outlines\",\"parent\":17,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":16,\"s\":[-30]},{\"t\":30,\"s\":[-1]}],\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.753,\"y\":0.959},\"o\":{\"x\":0.05,\"y\":0},\"t\":30,\"s\":[-107.75,90.75,0],\"to\":[3.44,-24.132,0],\"ti\":[-27.102,-1.029,0]},{\"i\":{\"x\":0.615,\"y\":1},\"o\":{\"x\":0.285,\"y\":0.125},\"t\":49,\"s\":[-12.44,-30.093,0],\"to\":[6.985,0.265,0],\"ti\":[1.044,-9.34,0]},{\"t\":60,\"s\":[0,0,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[308.666,526.122,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[12.783,-0.715],[0.009,0],[0.241,-0.11],[0.009,0],[8.383,0.293],[8.773,12.145],[0.117,0.209],[-11.964,-1.487],[-5.125,0.116]],\"o\":[[-11.785,0.659],[-0.232,0.111],[0,0],[-7.077,3.414],[-16.104,-0.563],[-0.12,-0.207],[7.936,8.614],[20.877,2.453],[5.438,-0.123]],\"v\":[[39.871,0.343],[20.335,5.324],[19.62,5.665],[19.61,5.673],[-3.838,10.58],[-42.786,-10.259],[-43.156,-10.874],[-12.409,4.993],[55.702,-10.616]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.607999973671,0.877999997606,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[293.157,509.804],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-2.513,0.644],[-2.424,0],[-0.429,-0.012],[-3.097,-16.39],[-0.011,-0.012],[-0.081,-0.661],[0,-0.012],[0.069,-2.053],[0.117,-1.032],[-0.487,1.669],[-2.575,3.236],[-3.492,1.995],[-0.011,0.034],[-0.012,-0.023],[-0.394,0.197],[-0.011,0],[-5.626,-0.186],[0,0],[-1.288,-0.209],[-2.796,-1.381],[-0.22,-0.012],[-0.023,0.8],[0.058,0.162],[0,0.012],[0.081,0.139],[0,0],[4.918,1.009],[1.343,-0.222],[0,0],[0.765,-0.209],[0.012,0],[0.417,-0.093],[0,0],[2.621,0.081],[1.24,0.22],[0,0],[2.471,1.206],[1.415,1.032],[0.023,-0.023],[0.186,0.151],[0.046,0.023],[0,0],[0.012,0.011],[0.023,0.011],[0.139,0.116],[0.139,0.117],[0,0],[0,0.011],[0,0],[10.219,0.881],[0.893,0.036],[7.227,-3.479],[0,0],[0.244,-0.115],[0.011,0],[8.375,0.29],[8.769,12.144],[0.116,0.209],[-7.696,-3.352],[-5.753,-0.464],[-0.777,-0.023],[-2.133,0.186],[-0.453,0.046],[0,0],[0,0]],\"o\":[[2.3,-0.59],[0.418,0],[17.375,0.603],[0,0.022],[0.128,0.661],[0.012,0.012],[0.255,1.972],[-0.035,1.055],[0.198,-1.774],[1.148,-4.107],[2.505,-3.144],[0.011,-0.047],[0.012,0.023],[0.383,-0.22],[0.012,-0.012],[4.664,-2.401],[0,0],[1.346,0.047],[3.19,0.511],[0.197,0.104],[0.812,0.023],[0.012,-0.198],[-0.012,-0.012],[-0.081,-0.139],[0,0],[-2.494,-4.129],[-1.586,-0.346],[0,0],[-0.731,0.266],[0,0],[-0.406,0.128],[0,0],[-2.447,0.557],[-1.311,-0.046],[0,0],[-2.807,-0.476],[-1.589,-0.754],[0,0.023],[-0.175,-0.162],[-0.046,-0.034],[0,0],[-0.012,-0.023],[-0.035,-0.023],[-0.15,-0.105],[-0.139,-0.116],[0,-0.011],[0,0],[0,0],[-7.586,-5.974],[-0.882,-0.082],[-8.549,-0.301],[0,0],[-0.232,0.104],[0,0],[-7.076,3.41],[-16.111,-0.568],[-0.127,-0.209],[1.183,15.264],[5.045,2.17],[0.766,0.058],[2.203,0.082],[0.43,-0.046],[0,0],[0,0],[14.162,-0.443]],\"v\":[[-9.546,-8.519],[-2.471,-9.215],[-1.183,-9.192],[33.405,20.467],[33.416,20.501],[33.729,22.484],[33.741,22.508],[34.031,28.563],[33.787,31.694],[34.808,26.522],[40.515,15.421],[49.597,7.627],[49.643,7.511],[49.678,7.58],[50.838,6.954],[50.872,6.931],[66.485,3.428],[66.531,3.439],[70.498,3.822],[79.522,6.699],[80.148,6.873],[81.656,5.458],[81.575,4.901],[81.563,4.877],[81.32,4.472],[81.32,4.46],[69.767,-3.717],[64.884,-4.448],[64.78,-4.401],[62.553,-3.694],[62.518,-3.683],[61.254,-3.358],[61.242,-3.358],[53.61,-2.627],[49.783,-3.021],[49.736,-3.021],[41.802,-5.561],[37.29,-8.252],[37.256,-8.206],[36.71,-8.682],[36.583,-8.774],[36.571,-8.786],[36.525,-8.832],[36.455,-8.89],[36.026,-9.227],[35.597,-9.575],[35.585,-9.586],[35.574,-9.609],[35.562,-9.609],[8.421,-20.338],[5.753,-20.513],[-18.176,-15.502],[-18.176,-15.49],[-18.895,-15.154],[-18.906,-15.142],[-42.348,-10.236],[-81.297,-31.079],[-81.668,-31.694],[-54.086,-2.929],[-37.813,1.085],[-35.504,1.212],[-28.998,1.038],[-27.675,0.899],[-27.594,0.899],[-27.571,0.899]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[331.672,530.622],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":309,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"leg Outlines\",\"parent\":3,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":16,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":30,\"s\":[-29]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":38,\"s\":[45]},{\"t\":60,\"s\":[0]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[309.028,529.347,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[309.028,529.347,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-0.591,-0.024],[-0.023,0],[-0.417,-0.011],[-1.148,-0.116],[-4.617,-4.384],[0.151,-4.535],[8.317,0.29],[0.812,0.162],[-4.381,-1.492],[0,0],[-3.503,4.767],[-0.174,4.883],[0.707,2.378],[0.047,0.128],[0.046,0.127],[0.035,0.104],[0.104,0.29],[0.116,0.279],[0.046,0.081],[0.046,0.082],[0.012,0.023],[10.033,0.673],[0.29,0.012],[-1.87,0.245]],\"o\":[[0.58,-0.023],[0.035,-0.012],[0.418,0],[1.16,0.046],[9.035,0.986],[3.085,2.865],[-0.301,8.294],[-0.858,-0.035],[0,0],[2.571,0.876],[6.031,-1.043],[2.691,-3.654],[0.081,-2.621],[-0.047,-0.127],[-0.034,-0.139],[-0.035,-0.105],[-0.104,-0.279],[-0.117,-0.278],[-0.047,-0.092],[-0.035,-0.093],[0,-0.023],[-4.025,-8.583],[-0.29,-0.034],[-1.972,-0.069],[-28.812,3.779]],\"v\":[[-17.189,-14.989],[-15.439,-15],[-15.345,-15.012],[-14.104,-14.989],[-10.647,-14.734],[9.141,-6.974],[13.941,4.567],[-1.659,19.089],[-4.164,18.787],[5.036,22.43],[10.753,23.867],[25.552,14.693],[30.077,1.679],[29.113,-5.849],[28.986,-6.232],[28.858,-6.637],[28.754,-6.939],[28.43,-7.798],[28.082,-8.633],[27.953,-8.888],[27.827,-9.155],[27.802,-9.224],[5.289,-24.628],[4.408,-24.674],[-1.345,-24.268]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[323.471,546.371],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":309,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":4,\"nm\":\"foot Outlines\",\"parent\":4,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":38,\"s\":[-10]},{\"t\":60,\"s\":[0]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[319.307,565.158,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[319.307,565.158,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-6.178,-28.902],[0.014,-3.534],[2.067,4.08],[5.625,4.718],[2.056,1.296],[3.897,1.36],[2.02,0.453]],\"o\":[[0.666,3.41],[-0.972,-4.583],[-3.332,-6.6],[-1.862,-1.562],[-3.431,-2.166],[-1.922,-0.669],[0,0]],\"v\":[[19.532,10.673],[20.504,20.742],[15.91,7.706],[2.309,-9.444],[-3.577,-13.739],[-14.604,-19.056],[-20.517,-20.742]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.607999973671,0.877999997606,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[354.74,590.979],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.841,-0.643],[2.065,4.048],[5.626,4.721],[2.065,1.287],[3.897,1.369],[2.018,0.452]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[1.907,1.678],[-0.974,-4.547],[-3.329,-6.599],[-1.868,-1.566],[-3.422,-2.169],[-1.925,-0.661],[0,0]],\"v\":[[-27.959,-23.239],[-23.412,-19.458],[-22.09,-18.368],[-16.082,-13.357],[0.853,0.747],[1.352,1.166],[17.776,14.84],[17.788,14.84],[19.284,16.081],[27.959,23.239],[23.378,10.293],[9.784,-6.86],[3.892,-11.152],[-7.127,-16.477],[-13.042,-18.159]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[347.266,588.397],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":309,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":4,\"nm\":\"circle Outlines 2\",\"parent\":14,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":74,\"s\":[0]},{\"t\":86,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":34,\"s\":[-282.082,104.435,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":49,\"s\":[-181.062,62.082,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":60,\"s\":[-193.582,67.435,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[346.418,607.435,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":true,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[344.5,440.5],[239,494],[290.5,527.5],[331.5,530.5],[345.5,549.5],[335,565.5],[328.5,569.5],[382,613],[427,569],[424,476.5]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,38.427],[38.427,0],[0,-38.427],[-38.427,0]],\"o\":[[0,-38.427],[-38.427,0],[0,38.427],[38.427,0]],\"v\":[[69.578,-0.001],[0,-69.579],[-69.578,-0.001],[0,69.578]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.341176480055,0.647058844566,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[346.418,537.857],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":74,\"op\":309,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":4,\"nm\":\"circle Outlines\",\"parent\":14,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":34,\"s\":[-282.082,104.435,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":49,\"s\":[-181.062,62.082,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":60,\"s\":[-193.582,67.435,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[346.418,607.435,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,38.427],[38.427,0],[0,-38.427],[-38.427,0]],\"o\":[[0,-38.427],[-38.427,0],[0,38.427],[38.427,0]],\"v\":[[69.578,-0.001],[0,-69.579],[-69.578,-0.001],[0,69.578]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.607999973671,0.877999997606,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[346.418,537.857],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":309,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":14,\"ty\":3,\"nm\":\"Zero | circle Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[540,540,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":309,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":17,\"ty\":3,\"nm\":\"Zero | body Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[308.666,526.122,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":309,\"st\":0,\"bm\":0}]}],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":3,\"nm\":\"Adjustment Layer 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[545,360,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[540,540,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ef\":[{\"ty\":5,\"nm\":\"CC Light Sweep\",\"np\":11,\"mn\":\"CC Light Sweep\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":3,\"nm\":\"Center\",\"mn\":\"CC Light Sweep-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":[544,284],\"ix\":1}},{\"ty\":0,\"nm\":\"Direction\",\"mn\":\"CC Light Sweep-0002\",\"ix\":2,\"v\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":116,\"s\":[90]},{\"t\":136,\"s\":[270]}],\"ix\":2}},{\"ty\":7,\"nm\":\"Shape\",\"mn\":\"CC Light Sweep-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":2,\"ix\":3}},{\"ty\":0,\"nm\":\"Width\",\"mn\":\"CC Light Sweep-0004\",\"ix\":4,\"v\":{\"a\":0,\"k\":50,\"ix\":4}},{\"ty\":0,\"nm\":\"Sweep Intensity\",\"mn\":\"CC Light Sweep-0005\",\"ix\":5,\"v\":{\"a\":0,\"k\":30,\"ix\":5}},{\"ty\":0,\"nm\":\"Edge Intensity\",\"mn\":\"CC Light Sweep-0006\",\"ix\":6,\"v\":{\"a\":0,\"k\":50,\"ix\":6}},{\"ty\":0,\"nm\":\"Edge Thickness\",\"mn\":\"CC Light Sweep-0007\",\"ix\":7,\"v\":{\"a\":0,\"k\":4,\"ix\":7}},{\"ty\":2,\"nm\":\"Light Color\",\"mn\":\"CC Light Sweep-0008\",\"ix\":8,\"v\":{\"a\":0,\"k\":[1,0.980392156863,0.941176470588,1],\"ix\":8}},{\"ty\":7,\"nm\":\"Light Reception\",\"mn\":\"CC Light Sweep-0009\",\"ix\":9,\"v\":{\"a\":0,\"k\":1,\"ix\":9}}]}],\"ip\":46,\"op\":346,\"st\":46,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":0,\"nm\":\"ICON\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":60,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":70,\"s\":[25]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":90,\"s\":[-25]},{\"t\":100,\"s\":[0]}],\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":0,\"s\":[593,607.5,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.248,\"y\":1},\"o\":{\"x\":0.75,\"y\":0},\"t\":74,\"s\":[593,607.5,0],\"to\":[0,0,0],\"ti\":[40.833,0,0]},{\"t\":86,\"s\":[348,607.5,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[348,607.5,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"w\":1080,\"h\":1080,\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"Layer 3 Outlines\",\"parent\":21,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.247,\"y\":1},\"o\":{\"x\":0.891,\"y\":0},\"t\":74,\"s\":[100,32.341,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.249,\"y\":1},\"o\":{\"x\":0.751,\"y\":0},\"t\":86,\"s\":[278.709,32.341,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":100,\"s\":[260.529,32.341,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[800.529,572.341,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":76,\"s\":[100,0,100]},{\"t\":81,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar amp, freq, decay, n, n, t, t, v;\\namp = 0.5;\\nfreq = 2;\\ndecay = 3;\\n$bm_rt = n = 0;\\nif (numKeys > 0) {\\n    $bm_rt = n = nearestKey(time).index;\\n    if (key(n).time > time) {\\n        n--;\\n    }\\n}\\nif (n == 0) {\\n    $bm_rt = t = 0;\\n} else {\\n    $bm_rt = t = $bm_sub(time, key(n).time);\\n}\\nif (n > 0 && t < 1) {\\n    v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\\n    $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\\n} else {\\n    $bm_rt = value;\\n}\"}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,13.551],[12.339,0],[0,-13.55],[-12.342,0]],\"o\":[[0,-13.55],[-12.342,0],[0,13.551],[12.339,0]],\"v\":[[21.539,-0.055],[0.053,-22.641],[-21.542,-0.055],[0.053,22.529]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,17.188],[-16.967,0],[0,-17.187],[16.964,0]],\"o\":[[0,-17.187],[16.964,0],[0,17.188],[-16.967,0]],\"v\":[[-29.471,-0.055],[0.053,-29.471],[29.471,-0.055],[0.053,29.471]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.607999973671,0.877999997606,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[800.529,542.87],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"Layer 4 Outlines\",\"parent\":22,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.247,\"y\":1},\"o\":{\"x\":0.891,\"y\":0},\"t\":74,\"s\":[37,32.341,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.249,\"y\":1},\"o\":{\"x\":0.751,\"y\":0},\"t\":86,\"s\":[215.258,32.341,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":100,\"s\":[196.959,32.341,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[736.959,572.341,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":77,\"s\":[100,0,100]},{\"t\":82,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar amp, freq, decay, n, n, t, t, v;\\namp = 0.5;\\nfreq = 2;\\ndecay = 3;\\n$bm_rt = n = 0;\\nif (numKeys > 0) {\\n    $bm_rt = n = nearestKey(time).index;\\n    if (key(n).time > time) {\\n        n--;\\n    }\\n}\\nif (n == 0) {\\n    $bm_rt = t = 0;\\n} else {\\n    $bm_rt = t = $bm_sub(time, key(n).time);\\n}\\nif (n > 0 && t < 1) {\\n    v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\\n    $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\\n} else {\\n    $bm_rt = value;\\n}\"}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,13.551],[12.338,0],[0,-13.55],[-12.342,0]],\"o\":[[0,-13.55],[-12.342,0],[0,13.551],[12.338,0]],\"v\":[[21.54,-0.055],[0.056,-22.641],[-21.537,-0.055],[0.056,22.529]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,17.188],[-16.97,0],[0,-17.187],[16.966,0]],\"o\":[[0,-17.187],[16.966,0],[0,17.188],[-16.97,0]],\"v\":[[-29.473,-0.055],[0.056,-29.471],[29.473,-0.055],[0.056,29.471]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.607999973671,0.877999997606,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[736.959,542.87],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":4,\"nm\":\"Layer 5 Outlines\",\"parent\":23,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.247,\"y\":1},\"o\":{\"x\":0.891,\"y\":0},\"t\":74,\"s\":[-9,31.791,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.249,\"y\":1},\"o\":{\"x\":0.751,\"y\":0},\"t\":86,\"s\":[170.024,31.791,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":100,\"s\":[151.926,31.791,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[691.926,571.791,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":78,\"s\":[100,0,100]},{\"t\":83,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar amp, freq, decay, n, n, t, t, v;\\namp = 0.5;\\nfreq = 2;\\ndecay = 3;\\n$bm_rt = n = 0;\\nif (numKeys > 0) {\\n    $bm_rt = n = nearestKey(time).index;\\n    if (key(n).time > time) {\\n        n--;\\n    }\\n}\\nif (n == 0) {\\n    $bm_rt = t = 0;\\n} else {\\n    $bm_rt = t = $bm_sub(time, key(n).time);\\n}\\nif (n > 0 && t < 1) {\\n    v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\\n    $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\\n} else {\\n    $bm_rt = value;\\n}\"}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-10.688,0],[0,0],[0.547,0],[0,-13.659],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[-0.66,0],[-12.118,0],[0,0],[0,0],[0,0],[0,0],[0,0],[3.638,-7.712]],\"v\":[[14.599,-29.196],[14.599,-21.595],[12.727,-21.705],[-6.775,-0.333],[-6.775,29.197],[-14.599,29.197],[-14.599,-28.756],[-7.108,-28.756],[-7.108,-17.408]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.607999973671,0.877999997606,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[691.926,542.595],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":4,\"nm\":\"Layer 6 Outlines\",\"parent\":24,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.247,\"y\":1},\"o\":{\"x\":0.891,\"y\":0},\"t\":74,\"s\":[-65,32.341,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.249,\"y\":1},\"o\":{\"x\":0.751,\"y\":0},\"t\":86,\"s\":[113.588,32.341,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":100,\"s\":[95.378,32.341,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[635.378,572.341,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":79,\"s\":[100,0,100]},{\"t\":84,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar amp, freq, decay, n, n, t, t, v;\\namp = 0.5;\\nfreq = 2;\\ndecay = 3;\\n$bm_rt = n = 0;\\nif (numKeys > 0) {\\n    $bm_rt = n = nearestKey(time).index;\\n    if (key(n).time > time) {\\n        n--;\\n    }\\n}\\nif (n == 0) {\\n    $bm_rt = t = 0;\\n} else {\\n    $bm_rt = t = $bm_sub(time, key(n).time);\\n}\\nif (n > 0 && t < 1) {\\n    v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\\n    $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\\n} else {\\n    $bm_rt = value;\\n}\"}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,13.551],[12.228,0],[0,-13.55],[-12.341,0]],\"o\":[[0,-13.55],[-12.341,0],[0,13.551],[12.228,0]],\"v\":[[21.648,-0.055],[0.167,-22.641],[-21.43,-0.055],[0.167,22.529]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[9.585,0],[0,17.517],[-16.529,0],[-4.848,-7.492],[0,0]],\"o\":[[0,0],[0,0],[0,0],[-4.742,7.824],[-16.529,0],[0,-17.517],[9.254,0],[0,0],[0,0]],\"v\":[[29.362,-29.031],[29.362,28.922],[21.872,28.922],[21.872,17.462],[-0.495,29.471],[-29.362,-0.055],[-0.495,-29.471],[21.54,-18.013],[21.54,-29.031]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.607999973671,0.877999997606,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[635.378,542.87],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":4,\"nm\":\"Layer 7 Outlines\",\"parent\":25,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.247,\"y\":1},\"o\":{\"x\":0.891,\"y\":0},\"t\":74,\"s\":[-107,-3.448,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.249,\"y\":1},\"o\":{\"x\":0.751,\"y\":0},\"t\":86,\"s\":[71.467,-3.448,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":100,\"s\":[53.222,-3.448,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[593.222,536.552,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":80,\"s\":[100,0,100]},{\"t\":85,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar amp, freq, decay, n, n, t, t, v;\\namp = 0.5;\\nfreq = 2;\\ndecay = 3;\\n$bm_rt = n = 0;\\nif (numKeys > 0) {\\n    $bm_rt = n = nearestKey(time).index;\\n    if (key(n).time > time) {\\n        n--;\\n    }\\n}\\nif (n == 0) {\\n    $bm_rt = t = 0;\\n} else {\\n    $bm_rt = t = $bm_sub(time, key(n).time);\\n}\\nif (n > 0 && t < 1) {\\n    v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\\n    $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\\n} else {\\n    $bm_rt = value;\\n}\"}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[12.686,-11.794],[-2.188,-11.794],[-12.685,2.204],[-5.383,11.794]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.607999973671,0.877999997606,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[593.222,524.758],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":4,\"nm\":\"Layer 8 Outlines\",\"parent\":26,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.247,\"y\":1},\"o\":{\"x\":0.891,\"y\":0},\"t\":74,\"s\":[-124,31.787,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.249,\"y\":1},\"o\":{\"x\":0.751,\"y\":0},\"t\":86,\"s\":[54.585,31.787,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":100,\"s\":[36.373,31.787,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[576.373,571.787,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":81,\"s\":[100,0,100]},{\"t\":86,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar amp, freq, decay, n, n, t, t, v;\\namp = 0.5;\\nfreq = 2;\\ndecay = 3;\\n$bm_rt = n = 0;\\nif (numKeys > 0) {\\n    $bm_rt = n = nearestKey(time).index;\\n    if (key(n).time > time) {\\n        n--;\\n    }\\n}\\nif (n == 0) {\\n    $bm_rt = t = 0;\\n} else {\\n    $bm_rt = t = $bm_sub(time, key(n).time);\\n}\\nif (n > 0 && t < 1) {\\n    v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\\n    $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\\n} else {\\n    $bm_rt = value;\\n}\"}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-14.215,-29.412],[-29.52,-29.412],[-7.609,-0.445],[-30.52,29.411],[-15.306,29.411],[-0.109,9.035],[14.982,29.411],[30.52,29.411]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.340999977261,0.647000002394,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[576.373,542.375],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":4,\"nm\":\"Layer 9 Outlines\",\"parent\":27,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.247,\"y\":1},\"o\":{\"x\":0.891,\"y\":0},\"t\":74,\"s\":[-190,32.563,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.249,\"y\":1},\"o\":{\"x\":0.751,\"y\":0},\"t\":86,\"s\":[-11.581,32.563,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":100,\"s\":[-29.835,32.563,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[510.165,572.563,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":82,\"s\":[100,0,100]},{\"t\":87,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar amp, freq, decay, n, n, t, t, v;\\namp = 0.5;\\nfreq = 2;\\ndecay = 3;\\n$bm_rt = n = 0;\\nif (numKeys > 0) {\\n    $bm_rt = n = nearestKey(time).index;\\n    if (key(n).time > time) {\\n        n--;\\n    }\\n}\\nif (n == 0) {\\n    $bm_rt = t = 0;\\n} else {\\n    $bm_rt = t = $bm_sub(time, key(n).time);\\n}\\nif (n > 0 && t < 1) {\\n    v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\\n    $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\\n} else {\\n    $bm_rt = value;\\n}\"}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,11.237],[10.024,0],[0,-11.237],[-9.919,0]],\"o\":[[0,-11.237],[-9.919,0],[0,11.237],[10.024,0]],\"v\":[[17.627,-0.056],[0.113,-18.455],[-17.298,-0.056],[0.113,18.342]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[8.042,0],[0,18.291],[-17.188,0],[-4.739,-5.288],[0,0]],\"o\":[[0,0],[0,0],[0,0],[-4.629,5.619],[-17.188,0],[0,-18.289],[7.493,0],[0,0],[0,0]],\"v\":[[31.18,-29.473],[31.18,29.361],[18.068,29.361],[18.068,21.76],[-1.432,30.133],[-31.18,-0.056],[-1.432,-30.133],[17.407,-22.312],[17.407,-29.473]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.340999977261,0.647000002394,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[510.165,542.43],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":10,\"ty\":4,\"nm\":\"Layer 10 Outlines\",\"parent\":28,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.247,\"y\":1},\"o\":{\"x\":0.891,\"y\":0},\"t\":74,\"s\":[-236,32.564,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.249,\"y\":1},\"o\":{\"x\":0.751,\"y\":0},\"t\":86,\"s\":[-58.32,32.564,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":100,\"s\":[-76.769,32.564,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[463.231,572.564,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":83,\"s\":[100,0,100]},{\"t\":88,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar amp, freq, decay, n, n, t, t, v;\\namp = 0.5;\\nfreq = 2;\\ndecay = 3;\\n$bm_rt = n = 0;\\nif (numKeys > 0) {\\n    $bm_rt = n = nearestKey(time).index;\\n    if (key(n).time > time) {\\n        n--;\\n    }\\n}\\nif (n == 0) {\\n    $bm_rt = t = 0;\\n} else {\\n    $bm_rt = t = $bm_sub(time, key(n).time);\\n}\\nif (n > 0 && t < 1) {\\n    v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\\n    $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\\n} else {\\n    $bm_rt = value;\\n}\"}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[4.958,0],[0,13.001],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-5.181,0],[-2.092,1.654]],\"o\":[[-3.306,2.644],[-12.889,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,5.725],[2.864,0],[0,0]],\"v\":[[16.747,32.337],[3.524,36.304],[-16.747,16.471],[-16.747,-36.304],[-2.975,-36.304],[-2.975,-22.861],[12.781,-22.861],[12.781,-11.844],[-2.975,-11.844],[-2.975,16.143],[5.179,24.955],[12.89,22.53]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.340999977261,0.647000002394,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[463.231,536.26],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":11,\"ty\":1,\"nm\":\"White Solid 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[540,540,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[540,540,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"sw\":1080,\"sh\":1080,\"sc\":\"#ffffff\",\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":20,\"ty\":2,\"nm\":\"Layer 1\",\"refId\":\"image_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[540,540,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[540,540,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":21,\"ty\":3,\"nm\":\"Zero | Layer 3 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[540,540,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":22,\"ty\":3,\"nm\":\"Zero | Layer 4 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[540,540,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":23,\"ty\":3,\"nm\":\"Zero | Layer 5 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[540,540,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":24,\"ty\":3,\"nm\":\"Zero | Layer 6 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[540,540,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":25,\"ty\":3,\"nm\":\"Zero | Layer 7 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[540,540,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":26,\"ty\":3,\"nm\":\"Zero | Layer 8 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[540,540,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":27,\"ty\":3,\"nm\":\"Zero | Layer 9 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[540,540,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":307,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":28,\"ty\":3,\"nm\":\"Zero | Layer 10 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[540,540,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":307,\"st\":0,\"bm\":0}],\"markers\":[]}");


var $77b0d74cee179a93$exports = {};
$77b0d74cee179a93$exports = JSON.parse("{\"v\":\"5.7.3\",\"fr\":30,\"ip\":0,\"op\":105,\"w\":500,\"h\":500,\"nm\":\"taxaroo_logo_icon_a 2\",\"ddd\":0,\"assets\":[{\"id\":\"comp_0\",\"layers\":[{\"ddd\":0,\"ind\":2,\"ty\":0,\"nm\":\"ICON 3\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[1029,540,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[540,540,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[250,250,100],\"ix\":6}},\"ao\":0,\"w\":1080,\"h\":1080,\"ip\":0,\"op\":300,\"st\":0,\"bm\":0}]},{\"id\":\"comp_1\",\"layers\":[{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"ear Outlines\",\"parent\":4,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":10,\"s\":[28]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":20,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":30,\"s\":[-1]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":49,\"s\":[26]},{\"t\":60,\"s\":[0]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[399.94,527.83,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[399.94,527.83,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-1.217,-0.182],[0.322,1.452],[0,0.023],[0.383,0.766],[0.522,0.753],[3.317,1.311],[2.378,-0.035],[-0.429,-0.951],[-0.22,-0.359],[-0.035,-0.034],[-0.395,-0.476],[-0.035,-0.024],[-1.717,-0.533],[0,0],[-0.371,-0.128],[0,0],[-1.102,-1.403]],\"o\":[[1.284,0.451],[-0.014,-0.041],[-0.278,-0.835],[-0.394,-0.847],[-2.076,-2.981],[-2.146,-0.846],[0.116,1.079],[0.162,0.395],[0.023,0.047],[0.348,0.511],[0.023,0.022],[1.183,1.275],[0,0],[0.395,0.07],[0,0],[1.74,0.569],[0,0]],\"v\":[[6.64,6.972],[8.592,5.321],[8.566,5.22],[7.592,2.819],[6.212,0.43],[-2.081,-6.124],[-8.913,-7.388],[-8.078,-4.326],[-7.498,-3.213],[-7.417,-3.085],[-6.303,-1.611],[-6.223,-1.53],[-1.803,1.253],[-1.792,1.253],[-0.655,1.543],[-0.643,1.543],[3.706,4.582]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[392.85,521.592],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":309,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"body Outlines 2\",\"parent\":19,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":49,\"s\":[0]},{\"t\":60,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":16,\"s\":[-30]},{\"t\":30,\"s\":[-1]}],\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.753,\"y\":0.961},\"o\":{\"x\":0.05,\"y\":0},\"t\":30,\"s\":[-118.25,90.75,0],\"to\":[3.44,-24.132,0],\"ti\":[-27.102,-1.029,0]},{\"i\":{\"x\":0.615,\"y\":1},\"o\":{\"x\":0.285,\"y\":0.125},\"t\":49,\"s\":[-12.44,-30.093,0],\"to\":[6.985,0.265,0],\"ti\":[1.044,-9.34,0]},{\"t\":60,\"s\":[0,0,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[308.666,526.122,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[12.783,-0.715],[0.009,0],[0.241,-0.11],[0.009,0],[8.383,0.293],[8.773,12.145],[0.117,0.209],[-11.964,-1.487],[-5.125,0.116]],\"o\":[[-11.785,0.659],[-0.232,0.111],[0,0],[-7.077,3.414],[-16.104,-0.563],[-0.12,-0.207],[7.936,8.614],[20.877,2.453],[5.438,-0.123]],\"v\":[[39.871,0.343],[20.335,5.324],[19.62,5.665],[19.61,5.673],[-3.838,10.58],[-42.786,-10.259],[-43.156,-10.874],[-12.409,4.993],[55.702,-10.616]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.607999973671,0.877999997606,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[293.157,509.804],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":309,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"body Outlines\",\"parent\":19,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":16,\"s\":[-30]},{\"t\":30,\"s\":[-1]}],\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.753,\"y\":0.961},\"o\":{\"x\":0.05,\"y\":0},\"t\":30,\"s\":[-118.25,90.75,0],\"to\":[3.44,-24.132,0],\"ti\":[-27.102,-1.029,0]},{\"i\":{\"x\":0.615,\"y\":1},\"o\":{\"x\":0.285,\"y\":0.125},\"t\":49,\"s\":[-12.44,-30.093,0],\"to\":[6.985,0.265,0],\"ti\":[1.044,-9.34,0]},{\"t\":60,\"s\":[0,0,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[308.666,526.122,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-2.513,0.644],[-2.424,0],[-0.429,-0.012],[-3.097,-16.39],[-0.011,-0.012],[-0.081,-0.661],[0,-0.012],[0.069,-2.053],[0.117,-1.032],[-0.487,1.669],[-2.575,3.236],[-3.492,1.995],[-0.011,0.034],[-0.012,-0.023],[-0.394,0.197],[-0.011,0],[-5.626,-0.186],[0,0],[-1.288,-0.209],[-2.796,-1.381],[-0.22,-0.012],[-0.023,0.8],[0.058,0.162],[0,0.012],[0.081,0.139],[0,0],[4.918,1.009],[1.343,-0.222],[0,0],[0.765,-0.209],[0.012,0],[0.417,-0.093],[0,0],[2.621,0.081],[1.24,0.22],[0,0],[2.471,1.206],[1.415,1.032],[0.023,-0.023],[0.186,0.151],[0.046,0.023],[0,0],[0.012,0.011],[0.023,0.011],[0.139,0.116],[0.139,0.117],[0,0],[0,0.011],[0,0],[10.219,0.881],[0.893,0.036],[7.227,-3.479],[0,0],[0.244,-0.115],[0.011,0],[8.375,0.29],[8.769,12.144],[0.116,0.209],[-7.696,-3.352],[-5.753,-0.464],[-0.777,-0.023],[-2.133,0.186],[-0.453,0.046],[0,0],[0,0]],\"o\":[[2.3,-0.59],[0.418,0],[17.375,0.603],[0,0.022],[0.128,0.661],[0.012,0.012],[0.255,1.972],[-0.035,1.055],[0.198,-1.774],[1.148,-4.107],[2.505,-3.144],[0.011,-0.047],[0.012,0.023],[0.383,-0.22],[0.012,-0.012],[4.664,-2.401],[0,0],[1.346,0.047],[3.19,0.511],[0.197,0.104],[0.812,0.023],[0.012,-0.198],[-0.012,-0.012],[-0.081,-0.139],[0,0],[-2.494,-4.129],[-1.586,-0.346],[0,0],[-0.731,0.266],[0,0],[-0.406,0.128],[0,0],[-2.447,0.557],[-1.311,-0.046],[0,0],[-2.807,-0.476],[-1.589,-0.754],[0,0.023],[-0.175,-0.162],[-0.046,-0.034],[0,0],[-0.012,-0.023],[-0.035,-0.023],[-0.15,-0.105],[-0.139,-0.116],[0,-0.011],[0,0],[0,0],[-7.586,-5.974],[-0.882,-0.082],[-8.549,-0.301],[0,0],[-0.232,0.104],[0,0],[-7.076,3.41],[-16.111,-0.568],[-0.127,-0.209],[1.183,15.264],[5.045,2.17],[0.766,0.058],[2.203,0.082],[0.43,-0.046],[0,0],[0,0],[14.162,-0.443]],\"v\":[[-9.546,-8.519],[-2.471,-9.215],[-1.183,-9.192],[33.405,20.467],[33.416,20.501],[33.729,22.484],[33.741,22.508],[34.031,28.563],[33.787,31.694],[34.808,26.522],[40.515,15.421],[49.597,7.627],[49.643,7.511],[49.678,7.58],[50.838,6.954],[50.872,6.931],[66.485,3.428],[66.531,3.439],[70.498,3.822],[79.522,6.699],[80.148,6.873],[81.656,5.458],[81.575,4.901],[81.563,4.877],[81.32,4.472],[81.32,4.46],[69.767,-3.717],[64.884,-4.448],[64.78,-4.401],[62.553,-3.694],[62.518,-3.683],[61.254,-3.358],[61.242,-3.358],[53.61,-2.627],[49.783,-3.021],[49.736,-3.021],[41.802,-5.561],[37.29,-8.252],[37.256,-8.206],[36.71,-8.682],[36.583,-8.774],[36.571,-8.786],[36.525,-8.832],[36.455,-8.89],[36.026,-9.227],[35.597,-9.575],[35.585,-9.586],[35.574,-9.609],[35.562,-9.609],[8.421,-20.338],[5.753,-20.513],[-18.176,-15.502],[-18.176,-15.49],[-18.895,-15.154],[-18.906,-15.142],[-42.348,-10.236],[-81.297,-31.079],[-81.668,-31.694],[-54.086,-2.929],[-37.813,1.085],[-35.504,1.212],[-28.998,1.038],[-27.675,0.899],[-27.594,0.899],[-27.571,0.899]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[331.672,530.622],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":32,\"op\":309,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":4,\"nm\":\"leg Outlines\",\"parent\":4,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":16,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":30,\"s\":[-29]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":38,\"s\":[45]},{\"t\":60,\"s\":[0]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[309.028,529.347,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[309.028,529.347,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-0.591,-0.024],[-0.023,0],[-0.417,-0.011],[-1.148,-0.116],[-4.617,-4.384],[0.151,-4.535],[8.317,0.29],[0.812,0.162],[-4.381,-1.492],[0,0],[-3.503,4.767],[-0.174,4.883],[0.707,2.378],[0.047,0.128],[0.046,0.127],[0.035,0.104],[0.104,0.29],[0.116,0.279],[0.046,0.081],[0.046,0.082],[0.012,0.023],[10.033,0.673],[0.29,0.012],[-1.87,0.245]],\"o\":[[0.58,-0.023],[0.035,-0.012],[0.418,0],[1.16,0.046],[9.035,0.986],[3.085,2.865],[-0.301,8.294],[-0.858,-0.035],[0,0],[2.571,0.876],[6.031,-1.043],[2.691,-3.654],[0.081,-2.621],[-0.047,-0.127],[-0.034,-0.139],[-0.035,-0.105],[-0.104,-0.279],[-0.117,-0.278],[-0.047,-0.092],[-0.035,-0.093],[0,-0.023],[-4.025,-8.583],[-0.29,-0.034],[-1.972,-0.069],[-28.812,3.779]],\"v\":[[-17.189,-14.989],[-15.439,-15],[-15.345,-15.012],[-14.104,-14.989],[-10.647,-14.734],[9.141,-6.974],[13.941,4.567],[-1.659,19.089],[-4.164,18.787],[5.036,22.43],[10.753,23.867],[25.552,14.693],[30.077,1.679],[29.113,-5.849],[28.986,-6.232],[28.858,-6.637],[28.754,-6.939],[28.43,-7.798],[28.082,-8.633],[27.953,-8.888],[27.827,-9.155],[27.802,-9.224],[5.289,-24.628],[4.408,-24.674],[-1.345,-24.268]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[323.471,546.371],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":309,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":4,\"nm\":\"foot Outlines 2\",\"parent\":5,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":38,\"s\":[-10]},{\"t\":60,\"s\":[0]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[319.307,565.158,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[319.307,565.158,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-6.178,-28.902],[0.014,-3.534],[2.067,4.08],[5.625,4.718],[2.056,1.296],[3.897,1.36],[2.02,0.453]],\"o\":[[0.666,3.41],[-0.972,-4.583],[-3.332,-6.6],[-1.862,-1.562],[-3.431,-2.166],[-1.922,-0.669],[0,0]],\"v\":[[19.532,10.673],[20.504,20.742],[15.91,7.706],[2.309,-9.444],[-3.577,-13.739],[-14.604,-19.056],[-20.517,-20.742]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.607999973671,0.877999997606,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[354.74,590.979],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":50,\"op\":309,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":4,\"nm\":\"foot Outlines\",\"parent\":5,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":38,\"s\":[-10]},{\"t\":60,\"s\":[0]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[319.307,565.158,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[319.307,565.158,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.841,-0.643],[2.065,4.048],[5.626,4.721],[2.065,1.287],[3.897,1.369],[2.018,0.452]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[1.907,1.678],[-0.974,-4.547],[-3.329,-6.599],[-1.868,-1.566],[-3.422,-2.169],[-1.925,-0.661],[0,0]],\"v\":[[-27.959,-23.239],[-23.412,-19.458],[-22.09,-18.368],[-16.082,-13.357],[0.853,0.747],[1.352,1.166],[17.776,14.84],[17.788,14.84],[19.284,16.081],[27.959,23.239],[23.378,10.293],[9.784,-6.86],[3.892,-11.152],[-7.127,-16.477],[-13.042,-18.159]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[347.266,588.397],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":309,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":4,\"nm\":\"circle Outlines 2\",\"parent\":16,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":57,\"s\":[0]},{\"t\":69,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-193.582,67.435,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[346.418,607.435,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[14.004,10.894],[20.082,13.222],[5.474,10.938],[0,-5.254],[-38.427,0],[-7.518,2.78]],\"o\":[[8.504,-6.856],[-13.418,-4.528],[-1.104,4.921],[0,38.427],[8.485,0],[-23.55,-25.886]],\"v\":[[-13.922,32.749],[-16.25,-8.579],[-67.892,-15.295],[-69.578,-0.001],[0,69.578],[24.133,65.279]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.341176480055,0.647058844566,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[346.418,537.857],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":57,\"op\":313,\"st\":4,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":4,\"nm\":\"circle Outlines\",\"parent\":16,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-193.582,-2.143,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[346.418,537.857,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":0,\"s\":[0,0,100]},{\"t\":10,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar amp, freq, decay, n, n, t, t, v;\\namp = 0.025;\\nfreq = 2;\\ndecay = 3;\\n$bm_rt = n = 0;\\nif (numKeys > 0) {\\n    $bm_rt = n = nearestKey(time).index;\\n    if (key(n).time > time) {\\n        n--;\\n    }\\n}\\nif (n == 0) {\\n    $bm_rt = t = 0;\\n} else {\\n    $bm_rt = t = $bm_sub(time, key(n).time);\\n}\\nif (n > 0 && t < 1) {\\n    v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10)));\\n    $bm_rt = $bm_sum(value, $bm_div($bm_mul($bm_mul(v, amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))));\\n} else {\\n    $bm_rt = value;\\n}\"}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,38.427],[38.427,0],[0,-38.427],[-38.427,0]],\"o\":[[0,-38.427],[-38.427,0],[0,38.427],[38.427,0]],\"v\":[[69.578,-0.001],[0,-69.579],[-69.578,-0.001],[0,69.578]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.607999973671,0.877999997606,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[346.418,537.857],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":309,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":16,\"ty\":3,\"nm\":\"Zero | circle Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[540,540,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":309,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":19,\"ty\":3,\"nm\":\"Zero | body Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[308.666,526.122,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":309,\"st\":0,\"bm\":0}]}],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":0,\"nm\":\"ICON+SWEEP 2\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[245.125,254.75,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[540,540,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"w\":1080,\"h\":1080,\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":1,\"nm\":\"White Solid 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[250,250,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[540,540,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"sw\":1080,\"sh\":1080,\"sc\":\"#ffffff\",\"ip\":0,\"op\":300,\"st\":0,\"bm\":0}],\"markers\":[]}");


const $53a209758b3184a9$var$LoadingIndicator = ({ size: size = 'medium', id: id, type: type = 'spin', speed: speed = 1, ...rest })=>{
    (0, $6fFrj.useEffect)(()=>{
        const Elem = document.querySelector(`#${id}`);
        let animation = (0, (/*@__PURE__*/$parcel$interopDefault($0073fd4c9601c378$exports)));
        if (type === 'icon') animation = (0, (/*@__PURE__*/$parcel$interopDefault($77b0d74cee179a93$exports)));
        if (type === 'full') animation = (0, (/*@__PURE__*/$parcel$interopDefault($db22660c05d29d24$exports)));
        if (Elem) (0, (/*@__PURE__*/$parcel$interopDefault($c8ea7419494febdf$exports))).loadAnimation({
            container: Elem,
            animationData: animation
        });
    }, [
        id,
        type
    ]);
    (0, $6fFrj.useEffect)(()=>{
        const Elem = document.querySelector(`#${id}`);
        if (Elem) (0, (/*@__PURE__*/$parcel$interopDefault($c8ea7419494febdf$exports))).setSpeed(speed);
    }, [
        speed,
        id
    ]);
    let widthHeight = size;
    if (size === 'small') widthHeight = 50;
    if (size === 'medium') widthHeight = 100;
    if (size === 'large') widthHeight = 200;
    return (0, $bb3TF.jsx)("div", {
        id: id,
        style: {
            width: widthHeight,
            height: widthHeight
        },
        ...rest
    });
};
$53a209758b3184a9$var$LoadingIndicator.defaultProps = {
    speed: 1
};
var $53a209758b3184a9$export$2e2bcd8739ae039 = $53a209758b3184a9$var$LoadingIndicator;








var $bb3TF = parcelRequire("bb3TF");




const $99ead93e2ec80d4e$var$defaultOptions = {};
const $99ead93e2ec80d4e$export$15c2d004ba2a7e37 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation createBillingPortalSession($createBillingPortalInput: CreateBillingPortalSessionInput!) {
  createBillingPortalSession(createBillingPortalInput: $createBillingPortalInput)
}
    `;
function $99ead93e2ec80d4e$export$1940481f2be3ddf2(baseOptions) {
    const options = {
        ...$99ead93e2ec80d4e$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($99ead93e2ec80d4e$export$15c2d004ba2a7e37, options);
}
const $99ead93e2ec80d4e$export$934d9d7e88e5257b = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation createCheckoutSession($createCheckoutSessionInput: CreateCheckoutSessionInput!) {
  createCheckoutSession(createCheckoutSessionInput: $createCheckoutSessionInput)
}
    `;
function $99ead93e2ec80d4e$export$821b8441ff8e0b28(baseOptions) {
    const options = {
        ...$99ead93e2ec80d4e$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($99ead93e2ec80d4e$export$934d9d7e88e5257b, options);
}
const $99ead93e2ec80d4e$export$39ac829ab91f0716 = {
    Mutation: {
        createBillingPortalSession: 'createBillingPortalSession',
        createCheckoutSession: 'createCheckoutSession'
    }
};










var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $3cf7fef67aab4fc4$var$SvgPayWallClouds = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 519,
        height: 519,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M97.313 324.375C43.588 324.375 0 280.787 0 227.062c0-43.081 27.977-79.674 66.801-92.446-1.216-6.792-1.926-13.888-1.926-21.085C64.875 50.785 115.66 0 178.406 0c43.69 0 81.601 24.632 100.557 60.82 14.901-17.334 36.999-28.383 61.631-28.383 44.804 0 81.094 36.29 81.094 81.094 0 5.575-.609 10.948-1.622 16.219h1.622c53.724 0 97.312 43.588 97.312 97.312 0 53.725-43.588 97.313-97.312 97.313H97.313Zm-14.699 34.363c12.367 5.272 18.044 19.564 12.773 31.931L46.73 504.2c-5.27 12.367-19.563 18.044-31.93 12.773-12.367-5.271-18.145-19.564-12.874-31.931l48.656-113.531c5.271-12.367 19.564-18.044 31.931-12.773h.101Zm121.641 0c12.367 5.272 18.043 19.564 12.772 31.931L168.371 504.2c-5.271 12.367-19.564 18.044-31.931 12.773-12.366-5.271-18.043-19.564-12.772-31.931l48.656-113.531c5.271-12.367 19.564-18.044 31.931-12.773Zm247.944 31.931L403.543 504.2c-5.271 12.367-19.564 18.044-31.931 12.773-12.367-5.271-18.043-19.564-12.772-31.931l48.656-113.531c5.271-12.367 19.564-18.044 31.931-12.773 12.367 5.272 18.043 19.564 12.772 31.931Zm-134.413-31.931c12.367 5.272 18.044 19.564 12.773 31.931L281.902 504.2c-5.271 12.367-19.564 18.044-31.93 12.773-12.367-5.271-18.044-19.564-12.773-31.931l48.657-113.531c5.271-12.367 19.563-18.044 31.93-12.773Z",
                fill: "url(#pay-wall-clouds_svg__a)"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("defs", {
                children: /*#__PURE__*/ (0, $bb3TF.jsxs)("linearGradient", {
                    id: "pay-wall-clouds_svg__a",
                    x1: 259.487,
                    y1: 0,
                    x2: 259.487,
                    y2: 518.94,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $bb3TF.jsx)("stop", {
                            stopColor: "#0057A5"
                        }),
                        /*#__PURE__*/ (0, $bb3TF.jsx)("stop", {
                            offset: 1,
                            stopColor: "#009BE0"
                        })
                    ]
                })
            })
        ]
    });
var $3cf7fef67aab4fc4$export$2e2bcd8739ae039 = $3cf7fef67aab4fc4$var$SvgPayWallClouds;


var $6c690e96e8e28aca$exports = {};

$6c690e96e8e28aca$exports = (parcelRequire("jN93C")).getBundleURL('a0IFD') + "pay-wall-person.a1a60f18.png";


var $4ec501a72aefc5c3$exports = {};

$parcel$export($4ec501a72aefc5c3$exports, "callToActionBox", function () { return $4ec501a72aefc5c3$export$174e538be79337bb; }, function (v) { return $4ec501a72aefc5c3$export$174e538be79337bb = v; });
$parcel$export($4ec501a72aefc5c3$exports, "callToActionButton", function () { return $4ec501a72aefc5c3$export$9d9a78ade8da911e; }, function (v) { return $4ec501a72aefc5c3$export$9d9a78ade8da911e = v; });
$parcel$export($4ec501a72aefc5c3$exports, "callToActionText", function () { return $4ec501a72aefc5c3$export$a58d1f13ccfb1a4d; }, function (v) { return $4ec501a72aefc5c3$export$a58d1f13ccfb1a4d = v; });
$parcel$export($4ec501a72aefc5c3$exports, "callToActionTitle", function () { return $4ec501a72aefc5c3$export$889ace454d9dae6a; }, function (v) { return $4ec501a72aefc5c3$export$889ace454d9dae6a = v; });
$parcel$export($4ec501a72aefc5c3$exports, "clouds", function () { return $4ec501a72aefc5c3$export$1dfd9bb6de068c7b; }, function (v) { return $4ec501a72aefc5c3$export$1dfd9bb6de068c7b = v; });
$parcel$export($4ec501a72aefc5c3$exports, "featuresList", function () { return $4ec501a72aefc5c3$export$1b7c4387d8e09bda; }, function (v) { return $4ec501a72aefc5c3$export$1b7c4387d8e09bda = v; });
$parcel$export($4ec501a72aefc5c3$exports, "layout", function () { return $4ec501a72aefc5c3$export$b3219800bda33a1f; }, function (v) { return $4ec501a72aefc5c3$export$b3219800bda33a1f = v; });
$parcel$export($4ec501a72aefc5c3$exports, "person", function () { return $4ec501a72aefc5c3$export$ea5d32a3cf17450f; }, function (v) { return $4ec501a72aefc5c3$export$ea5d32a3cf17450f = v; });
$parcel$export($4ec501a72aefc5c3$exports, "subText", function () { return $4ec501a72aefc5c3$export$5b4475bf26f40856; }, function (v) { return $4ec501a72aefc5c3$export$5b4475bf26f40856 = v; });
$parcel$export($4ec501a72aefc5c3$exports, "title", function () { return $4ec501a72aefc5c3$export$fb184b623420d9be; }, function (v) { return $4ec501a72aefc5c3$export$fb184b623420d9be = v; });
var $4ec501a72aefc5c3$export$174e538be79337bb;
var $4ec501a72aefc5c3$export$9d9a78ade8da911e;
var $4ec501a72aefc5c3$export$a58d1f13ccfb1a4d;
var $4ec501a72aefc5c3$export$889ace454d9dae6a;
var $4ec501a72aefc5c3$export$1dfd9bb6de068c7b;
var $4ec501a72aefc5c3$export$1b7c4387d8e09bda;
var $4ec501a72aefc5c3$export$b3219800bda33a1f;
var $4ec501a72aefc5c3$export$ea5d32a3cf17450f;
var $4ec501a72aefc5c3$export$5b4475bf26f40856;
var $4ec501a72aefc5c3$export$fb184b623420d9be;
$4ec501a72aefc5c3$export$174e538be79337bb = `_9uHYsW_callToActionBox`;
$4ec501a72aefc5c3$export$9d9a78ade8da911e = `_9uHYsW_callToActionButton`;
$4ec501a72aefc5c3$export$a58d1f13ccfb1a4d = `_9uHYsW_callToActionText`;
$4ec501a72aefc5c3$export$889ace454d9dae6a = `_9uHYsW_callToActionTitle`;
$4ec501a72aefc5c3$export$1dfd9bb6de068c7b = `_9uHYsW_clouds`;
$4ec501a72aefc5c3$export$1b7c4387d8e09bda = `_9uHYsW_featuresList`;
$4ec501a72aefc5c3$export$b3219800bda33a1f = `_9uHYsW_layout`;
$4ec501a72aefc5c3$export$ea5d32a3cf17450f = `_9uHYsW_person`;
$4ec501a72aefc5c3$export$5b4475bf26f40856 = `_9uHYsW_subText`;
$4ec501a72aefc5c3$export$fb184b623420d9be = `_9uHYsW_title`;


const { Title: $4a88a2e17dcaaf5e$var$Title, Paragraph: $4a88a2e17dcaaf5e$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { useBreakpoint: $4a88a2e17dcaaf5e$var$useBreakpoint } = (0, $89d88a41b53d163f$export$2e2bcd8739ae039);
const $4a88a2e17dcaaf5e$var$PayWall = ({ customerId: customerId })=>{
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const { email: email, firstName: firstName, firmAccountId: firmAccountId, userRole: userRole } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const firstLetter = firstName?.charAt(0)?.toUpperCase() || '?';
    const { sm: sm } = $4a88a2e17dcaaf5e$var$useBreakpoint();
    // graphql
    // Get subscription info query
    const { data: subscriptionData, loading: loadingSubscription } = (0, $732264f53056e08f$export$a95e19dd5dcb47c4)();
    // we also want to get the customer, because we need to check the customre for a default payment method
    const { data: customerData, loading: loadingCustomer } = (0, $fa3f5c8f35890bd3$export$eeb3a77a20e59876)({
        variables: {
            getStripeCustomerInput: {
                customerId: customerId
            }
        },
        fetchPolicy: 'network-only'
    });
    // update subscription
    const [updateSubscritpion, { loading: loadingUpdateSubscription }] = (0, $33beb5b1bfae180c$export$2533d517ac4b0c7f)();
    // create subscription
    const [createSubscritpion, { loading: loadingCreateSubscription }] = (0, $33beb5b1bfae180c$export$cad47f76ff30cf27)();
    // Create billing portal session mutation
    const [createBillingPortalSession] = (0, $99ead93e2ec80d4e$export$1940481f2be3ddf2)({
        onError: (err)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message);
        }
    });
    // create checkout session mutation
    const [createCheckoutSession, { loading: loadingCreateCheckoutSession }] = (0, $99ead93e2ec80d4e$export$821b8441ff8e0b28)({
        onError: (err)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message);
        }
    });
    const customer = customerData?.getStripeCustomer;
    const noDefaultPaymentMethod = !customer?.invoice_settings?.default_payment_method;
    const onClick = ({ key: key })=>{
        if (key === 'logout') {
            dispatch((0, $e3b9937a336ce5aa$export$b5d16ddcd70241c7)());
            dispatch((0, $59a61dbb6cd2676b$export$28052446e33b6b86)());
            dispatch((0, $af02328711f8c5fd$export$95c2dcacae3679d3)());
            dispatch((0, $66a7cecdd31d321f$export$43119c4be593e906)());
        } else if (key === 'help') window.open('https://help.taxaroo.com/', '_blank', 'noreferrer');
    };
    const handleCreateCheckoutSession = async (priceId, quantity)=>{
        createCheckoutSession({
            variables: {
                createCheckoutSessionInput: {
                    customerId: customerId,
                    customerEmail: email,
                    quantity: quantity,
                    adjustableQuantity: quantity === 1 ? {
                        enabled: false
                    } : {
                        enabled: true,
                        maximum: 99,
                        minimum: 2
                    },
                    priceId: priceId,
                    success_url: `${window.location.origin}`,
                    cancel_url: `${window.location.origin}`
                }
            }
        }).then(({ data: data })=>{
            if (data?.createCheckoutSession) window.location.href = data?.createCheckoutSession;
        }).catch((error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`Error creating checkout session - ${error.message}. Please contact customer support for assistance`, 10);
        });
    };
    const handleRenewPlan = async ()=>{
        if (loadingSubscription) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).info('Loading subscription information. Please wait a couple seconds and try again.');
            return;
        }
        console.log('noDefaultPaymentMethod', noDefaultPaymentMethod);
        if (noDefaultPaymentMethod) {
            handleCreateCheckoutSession(subscriptionData?.GetSubscriptionByContext?.items?.data?.[0]?.plan?.id || (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeMonthlyPlanPriceId, subscriptionData?.GetSubscriptionByContext?.quantity || 2);
            return;
        }
        if (subscriptionData?.GetSubscriptionByContext?.status === 'active' && subscriptionData?.GetSubscriptionByContext?.cancel_at_period_end) // update subscription to cancel at period end to false
        await updateSubscritpion({
            variables: {
                updateStripeSubscriptionInput: {
                    cancel_at_period_end: false
                }
            },
            refetchQueries: [
                'GetSubscriptionByContext',
                'isActiveFirm'
            ],
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Subscription reactivated successfully');
            },
            onError: (error)=>{
                // message.error(`Subscription could not be reactivated. ${error.message}`);
                // on error, we need to create a checkout session
                handleCreateCheckoutSession(subscriptionData?.GetSubscriptionByContext?.items?.data?.[0]?.plan?.id || (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeMonthlyPlanPriceId, subscriptionData?.GetSubscriptionByContext?.quantity || 2);
            }
        });
        else if (subscriptionData?.GetSubscriptionByContext?.status === 'canceled') // we need to start a whole new subscription
        await createSubscritpion({
            variables: {
                createStripeSubscriptionInput: {
                    customerId: subscriptionData?.GetSubscriptionByContext?.customer,
                    planId: subscriptionData?.GetSubscriptionByContext?.items.data[0].plan.id,
                    quantity: subscriptionData?.GetSubscriptionByContext?.quantity,
                    firmAccountId: firmAccountId,
                    paymentBehavior: 'error_if_incomplete'
                }
            },
            refetchQueries: [
                'GetSubscriptionByContext',
                'isActiveFirm'
            ],
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Subscription reactivated successfully');
            },
            onError: (error)=>{
                // message.error(`Subscription could not be reactivated. ${error.message}`);
                // on error, we need to create a checkout session
                handleCreateCheckoutSession(subscriptionData?.GetSubscriptionByContext?.items?.data?.[0]?.plan?.id || (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeMonthlyPlanPriceId, subscriptionData?.GetSubscriptionByContext?.quantity || 2);
            }
        });
    };
    const handleGoToBillingPortal = async ()=>{
        const { data: data } = await createBillingPortalSession({
            variables: {
                createBillingPortalInput: {
                    customer: customerId,
                    return_url: window.location.href
                }
            }
        });
        window.location.href = data.createBillingPortalSession;
    };
    if (loadingCustomer || loadingSubscription) return (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        justify: "center",
        align: "middle",
        style: {
            height: '100vh'
        },
        children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
            size: "large"
        })
    });
    const recordsShow = ()=>{
        // if the subscription is past due and there is a payment method on file
        if (subscriptionData?.GetSubscriptionByContext?.status === 'past_due' && (customer?.default_source || !noDefaultPaymentMethod)) return 'Our records show that there was difficulty processing your payment. Please update your payment method below.';
        // if there is no payment method on file
        if (noDefaultPaymentMethod) return 'Our records show you do not have a default payment method on file. Please add a payment method below.';
        // if the subscription is canceled
        if (subscriptionData?.GetSubscriptionByContext?.status === 'canceled') return 'Our records show that your subscription may have been canceled, or there was difficulty processing your payment. Please reactivate your subscription below.';
        return '';
    };
    return (0, $bb3TF.jsxs)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
        style: {
            background: 'white',
            padding: 0,
            margin: '0 auto',
            maxWidth: 1500
        },
        children: [
            (0, $bb3TF.jsx)("p", {
                style: {
                    textAlign: 'right',
                    padding: 10
                },
                children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    onClick: ()=>onClick({
                            key: 'logout'
                        }),
                    type: "link",
                    style: {
                        textTransform: 'none'
                    },
                    children: "Logout"
                })
            }),
            (0, $bb3TF.jsxs)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ec501a72aefc5c3$exports))).layout,
                children: [
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        children: [
                            (0, $bb3TF.jsx)($4a88a2e17dcaaf5e$var$Title, {
                                level: 2,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ec501a72aefc5c3$exports))).title,
                                children: subscriptionData?.GetSubscriptionByContext ? 'Oops! Your subscription at Taxaroo is no longer active' : 'Oops! You do not currently have a subscription with Taxaroo'
                            }),
                            (0, $bb3TF.jsx)($4a88a2e17dcaaf5e$var$Paragraph, {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ec501a72aefc5c3$exports))).subText,
                                children: recordsShow()
                            })
                        ]
                    }),
                    userRole !== 'STAFF' ? (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "space-between",
                        children: [
                            (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $bb3TF.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ec501a72aefc5c3$exports))).callToActionBox,
                                        children: [
                                            (0, $bb3TF.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ec501a72aefc5c3$exports))).callToActionTitle,
                                                children: "No need to worry! You can always reactivate your plan"
                                            }),
                                            (0, $bb3TF.jsx)("p", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ec501a72aefc5c3$exports))).callToActionText,
                                                children: "Click the button bellow to Reactivate your plan and keep enjoying all our most incredible features."
                                            }),
                                            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($4ec501a72aefc5c3$exports))).callToActionButton,
                                                loading: loadingUpdateSubscription || loadingCreateSubscription || loadingCreateCheckoutSession,
                                                onClick: handleRenewPlan,
                                                size: "large",
                                                children: "Reactivate Plan"
                                            })
                                        ]
                                    }),
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        children: (0, $bb3TF.jsx)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4ec501a72aefc5c3$exports))).featuresList,
                                            children: sm ? (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                                                children: [
                                                    (0, $bb3TF.jsxs)("ul", {
                                                        style: {
                                                            width: '50%'
                                                        },
                                                        children: [
                                                            (0, $bb3TF.jsx)("li", {
                                                                children: "Everything in free plus:"
                                                            }),
                                                            (0, $bb3TF.jsx)("li", {
                                                                children: "Signatures"
                                                            }),
                                                            (0, $bb3TF.jsx)("li", {
                                                                children: "Approvals"
                                                            }),
                                                            (0, $bb3TF.jsx)("li", {
                                                                children: "Follow ups"
                                                            }),
                                                            (0, $bb3TF.jsx)("li", {
                                                                children: "AI Powered Messaging"
                                                            }),
                                                            (0, $bb3TF.jsx)("li", {
                                                                children: "Mapped Drive"
                                                            }),
                                                            (0, $bb3TF.jsx)("li", {
                                                                children: "Entity Interviews"
                                                            }),
                                                            (0, $bb3TF.jsx)("li", {
                                                                children: "Reviews"
                                                            })
                                                        ]
                                                    }),
                                                    (0, $bb3TF.jsxs)("ul", {
                                                        style: {
                                                            width: '50%'
                                                        },
                                                        children: [
                                                            (0, $bb3TF.jsx)("li", {
                                                                children: "Appointments"
                                                            }),
                                                            (0, $bb3TF.jsx)("li", {
                                                                children: "AI Powered Research"
                                                            }),
                                                            (0, $bb3TF.jsx)("li", {
                                                                children: "Export to Drake"
                                                            }),
                                                            (0, $bb3TF.jsx)("li", {
                                                                children: "Video Calls"
                                                            }),
                                                            (0, $bb3TF.jsx)("li", {
                                                                children: "Birthday Emails"
                                                            }),
                                                            (0, $bb3TF.jsx)("li", {
                                                                children: "Pixels"
                                                            }),
                                                            (0, $bb3TF.jsx)("li", {
                                                                children: "Team Members"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : (0, $bb3TF.jsxs)("ul", {
                                                style: {
                                                    marginTop: -25
                                                },
                                                children: [
                                                    (0, $bb3TF.jsx)("li", {
                                                        children: "Everything in free plus:"
                                                    }),
                                                    (0, $bb3TF.jsx)("li", {
                                                        children: "Signatures"
                                                    }),
                                                    (0, $bb3TF.jsx)("li", {
                                                        children: "Approvals"
                                                    }),
                                                    (0, $bb3TF.jsx)("li", {
                                                        children: "Follow ups"
                                                    }),
                                                    (0, $bb3TF.jsx)("li", {
                                                        children: "AI Powered Messaging"
                                                    }),
                                                    (0, $bb3TF.jsx)("li", {
                                                        children: "Mapped Drive"
                                                    }),
                                                    (0, $bb3TF.jsx)("li", {
                                                        children: "Entity Interviews"
                                                    }),
                                                    (0, $bb3TF.jsx)("li", {
                                                        children: "Reviews"
                                                    }),
                                                    (0, $bb3TF.jsx)("li", {
                                                        children: "Appointments"
                                                    }),
                                                    (0, $bb3TF.jsx)("li", {
                                                        children: "AI Powered Research"
                                                    }),
                                                    (0, $bb3TF.jsx)("li", {
                                                        children: "Export to Drake"
                                                    }),
                                                    (0, $bb3TF.jsx)("li", {
                                                        children: "Video Calls"
                                                    }),
                                                    (0, $bb3TF.jsx)("li", {
                                                        children: "Birthday Emails"
                                                    }),
                                                    (0, $bb3TF.jsx)("li", {
                                                        children: "Pixels"
                                                    }),
                                                    (0, $bb3TF.jsx)("li", {
                                                        children: "Team Members"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                style: {
                                    maxWidth: 700
                                },
                                children: [
                                    (0, $bb3TF.jsx)((0, $3cf7fef67aab4fc4$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ec501a72aefc5c3$exports))).clouds
                                    }),
                                    (0, $bb3TF.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6c690e96e8e28aca$exports))),
                                        alt: "person",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4ec501a72aefc5c3$exports))).person
                                    })
                                ]
                            })
                        ]
                    }) : (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        style: {
                            textAlign: 'center',
                            marginTop: 20
                        },
                        children: (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            message: "Your subscription is no longer active. Please contact your firm administrator to reactivate your subscription.",
                            type: "warning",
                            showIcon: true
                        })
                    })
                ]
            })
        ]
    });
};
var $4a88a2e17dcaaf5e$export$2e2bcd8739ae039 = $4a88a2e17dcaaf5e$var$PayWall;




var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");





const $5b17d31504aa9ea8$export$d3795a8070b74c13 = (params)=>{
    const searchParams = new URLSearchParams(window.location.search);
    params.forEach(({ key: key, value: value })=>{
        searchParams.set(key, value);
    });
    const result = `${window.location.pathname}?${searchParams.toString()}`;
    return result;
};





const { Title: $b12c3bef87fed051$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { CheckCircleOutlined: $b12c3bef87fed051$var$CheckCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $b12c3bef87fed051$var$proFeaturesList = [
    {
        title: 'IRS e-Signatures'
    },
    {
        title: 'Payments (credit & ACH)'
    },
    {
        title: 'Automated followups'
    },
    {
        title: 'Appointment Scheduling'
    },
    {
        title: 'AI-assisted answers'
    },
    {
        title: 'AI tax research'
    },
    {
        title: 'Mapped portal drive'
    },
    {
        title: 'Export to Tax Software (Drake)'
    },
    {
        title: 'Entity interviews'
    },
    {
        title: 'Video calls'
    },
    {
        title: 'Preparer Reviews'
    },
    {
        title: 'Birthday emails'
    },
    {
        title: 'Zapier Integration'
    },
    {
        title: 'Marketing Pixels'
    },
    {
        title: '24 hour email support'
    },
    {
        title: 'Team member accounts'
    }
];
const $b12c3bef87fed051$var$liteFeaturesList = [
    {
        title: 'Interviews'
    },
    {
        title: 'Document uploads'
    },
    {
        title: 'Messaging'
    },
    {
        title: 'White Labeling'
    },
    {
        title: 'Analytics'
    },
    {
        title: 'Spanish Workflows'
    },
    {
        title: 'Referral Program'
    },
    {
        title: 'Video calls'
    },
    {
        title: 'Payments'
    },
    {
        title: 'Pixels'
    },
    {
        title: 'Birthday emails'
    }
];
const $b12c3bef87fed051$var$getLabel = (feature)=>{
    switch(feature){
        case (0, $a8c21a2ece310828$export$617d79dae526d2cf).signatures:
            return 'Signatures are';
        case (0, $a8c21a2ece310828$export$617d79dae526d2cf).approvals:
            return 'Approvals are';
        case (0, $a8c21a2ece310828$export$617d79dae526d2cf).followUps:
            return 'Follow ups are';
        case (0, $a8c21a2ece310828$export$617d79dae526d2cf).aiMessaging:
            return 'AI Messaging are';
        case (0, $a8c21a2ece310828$export$617d79dae526d2cf).mappedDrive:
            return 'Mapped Drive are';
        case (0, $a8c21a2ece310828$export$617d79dae526d2cf).entityInterviews:
            return 'Entity Interviews are';
        case (0, $a8c21a2ece310828$export$617d79dae526d2cf).reviews:
            return 'Reviews are';
        case (0, $a8c21a2ece310828$export$617d79dae526d2cf).appointments:
            return 'Appointments are';
        case (0, $a8c21a2ece310828$export$617d79dae526d2cf).aiResearch:
            return 'AI Research is';
        case (0, $a8c21a2ece310828$export$617d79dae526d2cf).export:
            return 'Export to Drake is';
        case (0, $a8c21a2ece310828$export$617d79dae526d2cf).videoCalls:
            return 'Video Calls are';
        case (0, $a8c21a2ece310828$export$617d79dae526d2cf).birthdayEmails:
            return 'Birthday Emails are';
        case (0, $a8c21a2ece310828$export$617d79dae526d2cf).pixels:
            return 'Pixels are';
        case (0, $a8c21a2ece310828$export$617d79dae526d2cf).teamMembers:
            return 'Team Members are';
        default:
            return '';
    }
};
const $b12c3bef87fed051$var$UpgradeModal = ()=>{
    const [modalType, setModalType] = (0, $6fFrj.useState)('pro');
    const { isModalVisible: isModalVisible, hideModal: hideModal, feature: feature, closable: closable } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    const { email: email } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const [createBillingPortalSession, { loading: loadingBillingPortalSession }] = (0, $99ead93e2ec80d4e$export$1940481f2be3ddf2)();
    // create checkout session mutation
    const [createCheckoutSession] = (0, $99ead93e2ec80d4e$export$821b8441ff8e0b28)({
        onError: (err)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message);
        }
    });
    // update subscription
    const [updateSubscritpion, { loading: loadingUpdateSubscription }] = (0, $33beb5b1bfae180c$export$2533d517ac4b0c7f)();
    const { data: subscriptionData, loading: loadingSubscription } = (0, $732264f53056e08f$export$a95e19dd5dcb47c4)();
    const subscription = subscriptionData?.GetSubscriptionByContext;
    const isOnFreePlan = subscription?.items.data[0]?.plan?.id === (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039)?.stripeFreePlanPriceId;
    const isOnLitePlan = subscription?.items.data[0]?.plan?.id === (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039)?.stripeLitePlanPriceId;
    const isCurrentlyPaused = subscription?.pause_collection?.behavior || subscription?.status === 'paused';
    // we also want to get the customer, because we need to check the customre for a default payment method
    const { data: currentStripeInformation } = (0, $732264f53056e08f$export$9f382c5aef9c5d4d)();
    const { customerId: customerId } = currentStripeInformation?.CurrentStripeInformation ?? {};
    const { data: customerData } = (0, $fa3f5c8f35890bd3$export$eeb3a77a20e59876)({
        variables: {
            getStripeCustomerInput: {
                customerId: customerId
            }
        }
    });
    const customer = customerData?.getStripeCustomer;
    const defaultPaymentMethod = customer?.invoice_settings?.default_payment_method || customer?.default_source;
    const resumePlan = ()=>{
        createBillingPortalSession({
            variables: {
                createBillingPortalInput: {
                    customer: customerId,
                    return_url: window.location.href
                }
            }
        }).then(({ data: billingPortalData })=>{
            window.location.href = billingPortalData?.createBillingPortalSession;
        });
    };
    const createUpgradeBillingPortalSession = ()=>{
        createBillingPortalSession({
            variables: {
                createBillingPortalInput: {
                    customer: customerId,
                    flow_data: {
                        type: 'subscription_update_confirm',
                        subscription_update_confirm: {
                            subscription: subscription?.id,
                            items: [
                                {
                                    id: subscription?.items.data[0].id,
                                    quantity: modalType === 'lite' ? 1 : 2,
                                    price: modalType === 'lite' ? (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeLitePlanPriceId : (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeMonthlyPlanPriceId
                                }
                            ]
                        },
                        after_completion: {
                            type: 'redirect',
                            redirect: {
                                return_url: `${window.location.origin}${(0, $5b17d31504aa9ea8$export$d3795a8070b74c13)([
                                    {
                                        key: 'upgraded',
                                        value: '1'
                                    },
                                    {
                                        key: 'subscribeToYearly',
                                        value: modalType === 'pro' ? '1' : '0'
                                    }
                                ])}`
                            }
                        }
                    },
                    return_url: window.location.href
                }
            }
        }).then(({ data: billingPortalData })=>{
            window.location.href = billingPortalData?.createBillingPortalSession;
        });
    };
    const createTheCheckoutSession = ()=>{
        let priceId = '';
        if (modalType === 'pro') priceId = (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeMonthlyPlanPriceId;
        else if (modalType === 'lite') priceId = (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeLitePlanPriceId;
        createCheckoutSession({
            variables: {
                createCheckoutSessionInput: {
                    customerId: customerId,
                    customerEmail: email,
                    quantity: modalType === 'lite' ? 1 : 2,
                    adjustableQuantity: modalType === 'lite' ? {
                        enabled: false
                    } : {
                        enabled: true,
                        maximum: 99,
                        minimum: 2
                    },
                    priceId: priceId,
                    success_url: `${window.location.origin}`,
                    cancel_url: `${window.location.origin}`
                }
            }
        }).then(({ data: data })=>{
            if (data?.createCheckoutSession) window.location.href = data?.createCheckoutSession;
        }).catch((error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`Error creating checkout session - ${error.message}. Please contact customer support for assistance`, 10);
        });
    };
    const handleSwitchToPlan = (priceId, quantity)=>{
        updateSubscritpion({
            variables: {
                resume: isCurrentlyPaused ? true : undefined,
                updateStripeSubscriptionInput: {
                    items: [
                        {
                            id: subscription?.items?.data[0]?.id,
                            price: priceId,
                            quantity: quantity
                        }
                    ]
                }
            },
            refetchQueries: [
                'GetSubscription',
                'GetPlanAccessLevel'
            ],
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Subscription updated!');
                hideModal();
                setModalType('pro');
            },
            onError: ()=>{
                // error could be that the user is on a free plan and has no payment method
                if (priceId === (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeLitePlanPriceId) createTheCheckoutSession();
                if (priceId === (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeMonthlyPlanPriceId) createUpgradeBillingPortalSession();
            }
        });
    };
    const upgradePlan = ()=>{
        // if upgrading to pro plan we can create billing portal session if upgrading to lite we use checkout session
        if (modalType === 'pro') {
            if (defaultPaymentMethod) handleSwitchToPlan((0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeMonthlyPlanPriceId, 2);
            else createUpgradeBillingPortalSession();
        }
        if (modalType === 'lite') {
            // if there is a payment method on file, try to upgrade, otherwise create a checkout session
            if (defaultPaymentMethod) handleSwitchToPlan((0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeLitePlanPriceId, 1);
            else createTheCheckoutSession();
        }
    };
    const updatePaymentMethod = ()=>{
        createBillingPortalSession({
            variables: {
                createBillingPortalInput: {
                    customer: customerId,
                    flow_data: {
                        type: 'payment_method_update',
                        after_completion: {
                            type: 'hosted_confirmation',
                            hosted_confirmation: {
                                custom_message: 'Your payment method has been successfully added!'
                            }
                        }
                    },
                    return_url: window.location.href
                }
            }
        }).then(({ data: billingPortalData })=>{
            window.location.href = billingPortalData?.createBillingPortalSession;
        });
    };
    const getButtonLabel = ()=>{
        console.log('isCurrentlyPaused', isCurrentlyPaused);
        console.log('modalType', modalType);
        console.log('isOnLitePlan', isOnLitePlan);
        console.log('isOnFreePlan', isOnFreePlan);
        if (isCurrentlyPaused && (modalType === 'lite' && isOnLitePlan || modalType === 'pro' && !isOnLitePlan && !isOnFreePlan)) return 'Resume Subscription';
        if (!isOnFreePlan && !isOnLitePlan && subscription?.status !== 'active') return 'Add Payment Method';
        return `Upgrade to ${modalType === 'lite' ? 'Lite Plan' : 'Pro Plan'}`;
    };
    const handleUpgrade = ()=>{
        // // if paused and modal type is same as current subscription type, we want to resume subscription
        if (isCurrentlyPaused) // prompt user to resume subscription
        resumePlan();
        else if (!isOnFreePlan && !isOnLitePlan && subscription?.status !== 'active') // prompt user to add or update payment method
        updatePaymentMethod();
        else // prompt user to upgrade if they have no default payment method they will be prompted to add a one
        upgradePlan();
    };
    const onCancel = ()=>{
        if (modalType === 'lite') {
            hideModal();
            setModalType('pro'); // for next time
            return;
        }
        // from here on out we're on a pro modal
        if (!isOnFreePlan && !isOnLitePlan) {
            hideModal();
            setModalType('pro'); // for next time
            return;
        }
        if (isOnFreePlan) {
            setModalType('lite');
            return;
        }
        if (isOnLitePlan && (isCurrentlyPaused || subscription.status !== 'active' && subscription.status !== 'trialing')) {
            setModalType('lite');
            return;
        }
        hideModal();
        setModalType('pro'); // for next time
    };
    if (loadingSubscription) return null;
    return (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        title: modalType === 'lite' ? "Okay gotcha, you\u2019re not ready for our Pro Plan yet" : 'Upgrade to Pro Plan',
        visible: isModalVisible,
        onCancel: onCancel,
        closable: closable,
        maskClosable: closable,
        width: 700,
        footer: [
            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                type: "primary",
                onClick: handleUpgrade,
                loading: loadingBillingPortalSession || loadingUpdateSubscription,
                children: getButtonLabel()
            }, "submit")
        ],
        children: (0, $bb3TF.jsx)("div", {
            children: (0, $bb3TF.jsxs)("div", {
                children: [
                    (0, $bb3TF.jsx)("div", {
                        children: modalType === 'lite' ? 'Consider upgrading to our Lite Plan to get access to all the features below at just $395 a year.' : `${$b12c3bef87fed051$var$getLabel(feature)} not available in your current plan. Upgrade to Pro to enable this feature.`
                    }),
                    (0, $bb3TF.jsx)("br", {}),
                    (0, $bb3TF.jsx)($b12c3bef87fed051$var$Title, {
                        level: 5,
                        children: `Included in the ${modalType === 'lite' ? 'Lite Plan' : 'Pro Plan'}:`
                    }),
                    (0, $bb3TF.jsx)((0, $550318ddff00815a$export$2e2bcd8739ae039), {
                        itemLayout: "horizontal",
                        dataSource: modalType === 'lite' ? $b12c3bef87fed051$var$liteFeaturesList : $b12c3bef87fed051$var$proFeaturesList,
                        style: {
                            height: '100%',
                            maxHeight: '365px',
                            overflow: 'hidden scroll'
                        },
                        grid: {
                            gutter: 10,
                            xs: 1,
                            sm: modalType === 'lite' ? 1 : 2,
                            md: modalType === 'lite' ? 1 : 2,
                            lg: modalType === 'lite' ? 1 : 2,
                            xl: modalType === 'lite' ? 1 : 2,
                            xxl: modalType === 'lite' ? 1 : 2
                        },
                        renderItem: (item, index)=>(0, $bb3TF.jsx)((0, $550318ddff00815a$export$2e2bcd8739ae039).Item, {
                                children: (0, $bb3TF.jsx)((0, $550318ddff00815a$export$2e2bcd8739ae039).Item.Meta, {
                                    avatar: (0, $bb3TF.jsx)($b12c3bef87fed051$var$CheckCircleOutlined, {
                                        style: {
                                            color: 'green'
                                        }
                                    }),
                                    title: item.title
                                })
                            })
                    })
                ]
            })
        })
    });
};
var $b12c3bef87fed051$export$2e2bcd8739ae039 = $b12c3bef87fed051$var$UpgradeModal;





var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");










var $c96e458c4dcc7dd3$export$f54428c5d46def57;
$c96e458c4dcc7dd3$export$f54428c5d46def57 = `QqBiDG_announcementBar`;



const { CloseOutlined: $c6fb91589b91dceb$var$CloseOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $c6fb91589b91dceb$var$CloseButton = ({ setCloseBar: setCloseBar })=>(0, $bb3TF.jsx)($c6fb91589b91dceb$var$CloseOutlined, {
        onClick: ()=>setCloseBar(true),
        style: {
            color: 'white',
            position: 'absolute',
            right: 10,
            top: 10
        }
    });
function $c6fb91589b91dceb$var$AnnouncementBar({ customerId: customerId }) {
    const [searchParams] = (0, $a6e470ffbc8d2470$export$f1a78c17382fe22a)();
    const { firmAccountId: firmAccountId, email: email } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    // get subscribeToYearly flag from url
    const subscribeToYearly = searchParams.get('subscribeToYearly');
    const showSubscribeToYearlyBar = subscribeToYearly === '1';
    // get upgraded flag from url
    const upgraded = searchParams.get('upgraded');
    const successfullyUpgraded = upgraded === '1';
    // get startSubscription flag from url
    const startSubscription = searchParams.get('startSubscription');
    const [closeBar, setCloseBar] = (0, $6fFrj.useState)(false);
    const [startSubscriptionFlag, setStartSubscriptionFlag] = (0, $6fFrj.useState)(startSubscription === '1');
    // State for storing the countdown components
    const [freeTrialCountdown, setFreeTrialCountdown] = (0, $6fFrj.useState)({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });
    const [cancelAtCountdown, setCancelAtCountdown] = (0, $6fFrj.useState)({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });
    // Create billing portal session mutation
    const [createBillingPortalSession] = (0, $99ead93e2ec80d4e$export$1940481f2be3ddf2)();
    // Get subscription info query
    const { data: subscriptionData, loading: loadingSubscription } = (0, $732264f53056e08f$export$a95e19dd5dcb47c4)({
        fetchPolicy: 'network-only'
    });
    const subscription = subscriptionData?.GetSubscriptionByContext;
    const isOnFreePlan = subscription?.items.data[0].plan.id === (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeFreePlanPriceId;
    // we also want to get the customer, because we need to check the customre for a default payment method
    const { data: customerData, loading: loadingCustomer } = (0, $fa3f5c8f35890bd3$export$eeb3a77a20e59876)({
        variables: {
            getStripeCustomerInput: {
                customerId: customerId
            }
        },
        skip: !customerId,
        fetchPolicy: 'network-only'
    });
    const customer = customerData?.getStripeCustomer;
    const defaultPaymentMethod = customer?.invoice_settings?.default_payment_method || customer?.default_source;
    // update subscription
    const [updateSubscritpion, { loading: loadingUpdateSubscription }] = (0, $33beb5b1bfae180c$export$2533d517ac4b0c7f)();
    // create subscription
    const [createSubscritpion, { loading: loadingCreateSubscription }] = (0, $33beb5b1bfae180c$export$cad47f76ff30cf27)();
    // resume subscription
    const [resumeSubscription, { loading: loadingResumeSubscription }] = (0, $33beb5b1bfae180c$export$2df4a6161cee6627)();
    // sent statistics to usermaven.com
    const { id: usermavenIdentify } = (0, $1b6cd4304c8b74ff$export$346b73153e5ac4d0)();
    (0, $6fFrj.useEffect)(()=>{
        const user = (0, $e4ec60025026f14e$export$2e2bcd8739ae039).getState().session;
        usermavenIdentify({
            id: user?.userId,
            email: user?.email,
            created_at: user?.userCreatedAt,
            first_name: user?.firstName,
            last_name: user?.lastName,
            custom: {
                role: user?.userRole,
                languageId: user?.languageId
            },
            company: {
                id: user?.firmAccountId,
                name: user?.firmName,
                created_at: user?.firmCreatedAt,
                custom: {
                    plan_name: subscription?.items?.data?.[0].plan?.metadata?.plan_name,
                    plan_interval: subscription?.items?.data?.[0].plan?.interval,
                    subscription_id: subscription?.id,
                    subscription_status: subscription?.status
                }
            }
        });
    }, [
        subscriptionData
    ]);
    // useEffect for after startSubscription flag is set
    (0, $6fFrj.useEffect)(()=>{
        if (startSubscriptionFlag && subscription?.id) // eslint-disable-next-line @typescript-eslint/no-use-before-define
        handleUnpauseAccount();
    }, [
        startSubscriptionFlag,
        subscription?.id
    ]);
    // useEffect for after subscription is upgraded
    (0, $6fFrj.useEffect)(()=>{
        if (successfullyUpgraded) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Account successfully upgraded.');
            // Create a URL object from the current location
            const currentUrl = new URL(window.location.href);
            // Use URLSearchParams to work with the query string easily
            const tmpSearchParams = new URLSearchParams(currentUrl.search);
            // Remove the 'upgraded' parameter
            tmpSearchParams.delete('upgraded');
            // Update the search part of the URL
            currentUrl.search = tmpSearchParams.toString();
            // Use history.pushState to update the URL without reloading the page
            window.history.pushState({}, '', currentUrl.toString());
        }
    }, [
        successfullyUpgraded
    ]);
    // useEffect for free trial countdown
    (0, $6fFrj.useEffect)(()=>{
        if (!subscription?.trial_end || isOnFreePlan) return;
        // Update the countdown every second
        const interval = setInterval(()=>{
            const now = new Date().getTime();
            const distance = subscription.trial_end * 1000 - now;
            // Calculations for days, hours, minutes, and seconds
            const days = Math.floor(distance / 86400000);
            const hours = Math.floor(distance % 86400000 / 3600000);
            const minutes = Math.floor(distance % 3600000 / 60000);
            const seconds = Math.floor(distance % 60000 / 1000);
            // Update the state with the new countdown time
            setFreeTrialCountdown({
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds
            });
            // If the countdown is over, clear the interval
            if (distance < 0) clearInterval(interval);
        }, 1000); // Every second
        // Clear interval on component unmount
        // eslint-disable-next-line consistent-return
        return ()=>clearInterval(interval);
    }, [
        subscription?.trial_end,
        isOnFreePlan
    ]);
    // useEffect for cancel at countdown
    (0, $6fFrj.useEffect)(()=>{
        if (!subscription?.cancel_at) return;
        // Update the countdown every second
        const interval = setInterval(()=>{
            const now = new Date().getTime();
            const distance = subscription.cancel_at * 1000 - now;
            // Calculations for days, hours, minutes, and seconds
            const days = Math.floor(distance / 86400000);
            const hours = Math.floor(distance % 86400000 / 3600000);
            const minutes = Math.floor(distance % 3600000 / 60000);
            const seconds = Math.floor(distance % 60000 / 1000);
            // Update the state with the new countdown time
            setCancelAtCountdown({
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds
            });
            // If the countdown is over, clear the interval
            if (distance < 0) clearInterval(interval);
        }, 1000); // Every second
        // Clear interval on component unmount
        // eslint-disable-next-line consistent-return
        return ()=>clearInterval(interval);
    }, [
        subscription?.cancel_at
    ]);
    const handleAddPaymentMethod = (unpauseOnComplete = false)=>{
        createBillingPortalSession({
            variables: {
                createBillingPortalInput: {
                    customer: customerId,
                    flow_data: {
                        type: 'payment_method_update',
                        after_completion: unpauseOnComplete ? {
                            type: 'redirect',
                            redirect: {
                                return_url: `${window.location.origin}${(0, $5b17d31504aa9ea8$export$d3795a8070b74c13)([
                                    {
                                        key: 'startSubscription',
                                        value: '1'
                                    },
                                    {
                                        key: 'subscribeToYearly',
                                        value: '1'
                                    }
                                ])}`
                            }
                        } : {
                            type: 'hosted_confirmation',
                            hosted_confirmation: {
                                custom_message: 'Your payment method has been successfully added! Consider updating to our yearly plan and save 16.7% per year.'
                            }
                        }
                    },
                    return_url: `${window.location.origin}${(0, $5b17d31504aa9ea8$export$d3795a8070b74c13)([
                        {
                            key: 'subscribeToYearly',
                            value: '1'
                        }
                    ])}`
                }
            }
        }).then(({ data: data })=>{
            window.location.href = data?.createBillingPortalSession;
        });
    };
    const handleUnpauseAccount = ()=>{
        resumeSubscription({
            variables: {
                subscriptionId: subscription?.id
            },
            refetchQueries: [
                'GetSubscriptionByContext'
            ],
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Subscription successfully reactivated.');
                setStartSubscriptionFlag(false);
            }
        });
    };
    const handleSubscribeToYearly = ()=>{
        createBillingPortalSession({
            variables: {
                createBillingPortalInput: {
                    customer: customerId,
                    // prompt the user to update their subscription to the yearly plan
                    flow_data: {
                        type: 'subscription_update_confirm',
                        subscription_update_confirm: {
                            subscription: subscription?.id,
                            items: [
                                {
                                    id: subscription?.items.data[0].id,
                                    quantity: subscription?.quantity,
                                    price: (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeYearlyPlanPriceId
                                }
                            ]
                        }
                    },
                    return_url: window.location.href
                }
            }
        }).then(({ data: data })=>{
            window.location.href = data?.createBillingPortalSession;
        });
    };
    const handleRenewPlan = async ()=>{
        if (loadingSubscription || loadingCustomer) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).info('Loading subscription information. Please wait a couple seconds and try again.');
            return;
        }
        if ((subscriptionData.GetSubscriptionByContext?.status === 'active' || subscriptionData.GetSubscriptionByContext?.status === 'trialing') && subscriptionData.GetSubscriptionByContext?.cancel_at_period_end) // update subscription to cancel at period end to false
        await updateSubscritpion({
            variables: {
                updateStripeSubscriptionInput: {
                    cancel_at_period_end: false
                }
            },
            refetchQueries: [
                'GetSubscriptionByContext'
            ],
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Subscription renewed successfully');
                setCloseBar(true);
            },
            onError: (error)=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`Subscription could not be renewed. ${error.message}`);
            }
        });
        else if (subscriptionData.GetSubscriptionByContext?.status === 'canceled') // we need to start a whole new subscription
        await createSubscritpion({
            variables: {
                createStripeSubscriptionInput: {
                    customerId: subscriptionData.GetSubscriptionByContext?.customer,
                    planId: subscriptionData.GetSubscriptionByContext?.items.data[0].plan.id,
                    quantity: subscriptionData.GetSubscriptionByContext?.quantity,
                    firmAccountId: firmAccountId
                }
            },
            refetchQueries: [
                'GetSubscriptionByContext'
            ],
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Subscription renewed successfully');
                setCloseBar(true);
            },
            onError: (error)=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`Subscription could not be renewed. ${error.message}`);
            }
        });
        else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Subscription could not be renewed. Please contact support.');
    };
    // if loading
    if (loadingSubscription || loadingCustomer || !subscription || !customer) return null;
    if (closeBar) return null;
    if (loadingResumeSubscription) return (0, $bb3TF.jsx)("div", {
        className: $c96e458c4dcc7dd3$export$f54428c5d46def57,
        children: (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            justify: "center",
            children: (0, $bb3TF.jsxs)("p", {
                children: [
                    (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                        size: "small",
                        style: {
                            marginRight: 10
                        }
                    }),
                    "One moment while we reactivate your account..."
                ]
            })
        })
    });
    // showSubscribeToYearlyBar (this one takes precedence over the others because it's an unusual temporary state)
    if (showSubscribeToYearlyBar // showSubscribeToYearlyBar flag is true
     && defaultPaymentMethod // a default payment method exists
     && subscription?.items.data[0].plan?.id === (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeMonthlyPlanPriceId // the customer is on our monthly plan
    ) return (0, $bb3TF.jsx)("div", {
        className: $c96e458c4dcc7dd3$export$f54428c5d46def57,
        children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            justify: "center",
            children: [
                (0, $bb3TF.jsx)("p", {
                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        type: "link",
                        onClick: handleSubscribeToYearly,
                        style: {
                            color: 'white',
                            textDecoration: 'underline',
                            padding: 0,
                            textTransform: 'none',
                            fontWeight: 'bolder',
                            fontSize: '16px'
                        },
                        children: "Subscribe to our yearly plan and save 16.7% per year."
                    })
                }),
                (0, $bb3TF.jsx)($c6fb91589b91dceb$var$CloseButton, {
                    setCloseBar: setCloseBar
                })
            ]
        })
    });
    // renew plan bar (already canceled)
    if (subscription?.canceled_at && !subscription?.cancel_at_period_end) return (0, $bb3TF.jsx)("div", {
        className: $c96e458c4dcc7dd3$export$f54428c5d46def57,
        children: (0, $bb3TF.jsxs)("p", {
            children: [
                "Your subscription is canceled",
                ' ',
                (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    type: "link",
                    onClick: handleRenewPlan,
                    loading: loadingUpdateSubscription || loadingCreateSubscription,
                    style: {
                        color: 'white',
                        textDecoration: 'underline',
                        padding: 0,
                        textTransform: 'none',
                        fontWeight: 'bolder',
                        fontSize: '16px'
                    },
                    children: "click here to reactivate your account"
                }),
                ' ',
                "to continue using Taxaroo."
            ]
        })
    });
    // renew plan bar (will be canceled)
    if (subscription?.cancel_at && (cancelAtCountdown.days > 0 || cancelAtCountdown.hours > 0 || cancelAtCountdown.minutes > 0 || cancelAtCountdown.seconds > 0)) return (0, $bb3TF.jsx)("div", {
        className: $c96e458c4dcc7dd3$export$f54428c5d46def57,
        children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            justify: "center",
            children: [
                (0, $bb3TF.jsxs)("p", {
                    children: [
                        "You will lose access to Taxaroo in",
                        ` ${cancelAtCountdown.days}d ${cancelAtCountdown.hours}h ${cancelAtCountdown.minutes}m ${cancelAtCountdown.seconds}s. `,
                        ' ',
                        (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "link",
                            onClick: handleRenewPlan,
                            loading: loadingUpdateSubscription || loadingCreateSubscription,
                            style: {
                                color: 'white',
                                textDecoration: 'underline',
                                padding: 0,
                                textTransform: 'none',
                                fontWeight: 'bolder',
                                fontSize: '16px'
                            },
                            children: "Reactivate your account"
                        }),
                        ' ',
                        "to continue using Taxaroo."
                    ]
                }),
                (0, $bb3TF.jsx)($c6fb91589b91dceb$var$CloseButton, {
                    setCloseBar: setCloseBar
                })
            ]
        })
    });
    // in free trial with no payment method
    if (!defaultPaymentMethod && !isOnFreePlan && (freeTrialCountdown.days > 0 || freeTrialCountdown.hours > 0 || freeTrialCountdown.minutes > 0 || freeTrialCountdown.seconds > 0)) return (0, $bb3TF.jsx)("div", {
        className: $c96e458c4dcc7dd3$export$f54428c5d46def57,
        children: (0, $bb3TF.jsxs)("p", {
            children: [
                "You free trial ends in",
                ` ${freeTrialCountdown.days}d ${freeTrialCountdown.hours}h ${freeTrialCountdown.minutes}m ${freeTrialCountdown.seconds}s. Please `,
                ' ',
                (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    type: "link",
                    onClick: handleAddPaymentMethod,
                    style: {
                        color: 'white',
                        textDecoration: 'underline',
                        padding: 0,
                        textTransform: 'none',
                        fontWeight: 'bolder',
                        fontSize: '16px'
                    },
                    children: "add a payment method"
                }),
                ' ',
                "to continue using Taxaroo."
            ]
        })
    });
    // if subscription status is past_due or unpaid, we let them know why they are on the free plan
    if (!isOnFreePlan && (subscription?.status === 'past_due' || subscription?.status === 'unpaid')) return (0, $bb3TF.jsx)("div", {
        className: $c96e458c4dcc7dd3$export$f54428c5d46def57,
        children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            justify: "center",
            children: [
                (0, $bb3TF.jsxs)("p", {
                    children: [
                        "Your subscription is currently past due. You've been downgraded to our limited access free plan. Please",
                        ' ',
                        (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "link",
                            onClick: handleAddPaymentMethod,
                            style: {
                                color: 'white',
                                textDecoration: 'underline',
                                padding: 0,
                                textTransform: 'none',
                                fontWeight: 'bolder',
                                fontSize: '16px'
                            },
                            children: "add a payment method"
                        }),
                        ' ',
                        "for full access to Taxaroo."
                    ]
                }),
                (0, $bb3TF.jsx)($c6fb91589b91dceb$var$CloseButton, {
                    setCloseBar: setCloseBar
                })
            ]
        })
    });
    // if subscription status is paused, we let them know why they are on the free plan
    if (!isOnFreePlan && subscription?.status === 'paused') return (0, $bb3TF.jsx)("div", {
        className: $c96e458c4dcc7dd3$export$f54428c5d46def57,
        children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            justify: "center",
            children: [
                (0, $bb3TF.jsxs)("p", {
                    children: [
                        "You've been downgraded to our limited access free plan. Please",
                        ' ',
                        (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "link",
                            onClick: !defaultPaymentMethod ? ()=>handleAddPaymentMethod(true) : handleUnpauseAccount,
                            style: {
                                color: 'white',
                                textDecoration: 'underline',
                                padding: 0,
                                textTransform: 'none',
                                fontWeight: 'bolder',
                                fontSize: '16px'
                            },
                            children: !defaultPaymentMethod ? 'add a payment method' : 'unpause your account'
                        }),
                        ' ',
                        "for full access to Taxaroo."
                    ]
                }),
                (0, $bb3TF.jsx)($c6fb91589b91dceb$var$CloseButton, {
                    setCloseBar: setCloseBar
                })
            ]
        })
    });
    // date between thanksgiving and cyber monday
    if (new Date().getTime() > 1700783999 && new Date().getTime() < 1701129599) return (0, $bb3TF.jsx)("div", {
        className: $c96e458c4dcc7dd3$export$f54428c5d46def57,
        children: (0, $bb3TF.jsx)("p", {
            children: (0, $bb3TF.jsx)("a", {
                href: `${window.location.origin}/special-offer/${(0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeBlackFridayPricingTableId}?email=${email}`,
                style: {
                    color: 'white',
                    textDecoration: 'underline',
                    padding: 0,
                    textTransform: 'none',
                    fontWeight: 'bolder',
                    fontSize: '17px'
                },
                children: "Subscribe to our Black Friday deal and save 43% per year (sale ends 11/27/2023)"
            })
        })
    });
    // if none of the above conditions are met, we don't show the bar
    return null;
}
var $c6fb91589b91dceb$export$2e2bcd8739ae039 = $c6fb91589b91dceb$var$AnnouncementBar;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $50c2677d39bbc7c0$var$SvgAiOpen = (props)=>/*#__PURE__*/ (0, $bb3TF.jsx)("svg", {
        width: 18,
        height: 18,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
            d: "M7.452 11.625a1.5 1.5 0 0 0-1.078-1.078L1.773 9.361a.375.375 0 0 1 0-.722l4.6-1.187a1.5 1.5 0 0 0 1.079-1.077l1.186-4.601a.375.375 0 0 1 .722 0l1.186 4.601a1.5 1.5 0 0 0 1.078 1.078l4.601 1.186a.375.375 0 0 1 0 .723l-4.601 1.185a1.5 1.5 0 0 0-1.078 1.078L9.36 16.226a.374.374 0 0 1-.723 0l-1.185-4.6ZM15 2.25v3M16.5 3.75h-3M3 12.75v1.5M3.75 13.5h-1.5",
            stroke: "#3D80F3",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $50c2677d39bbc7c0$export$2e2bcd8739ae039 = $50c2677d39bbc7c0$var$SvgAiOpen;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $7a51db8b8288e80f$var$SvgAiIcon = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        width: 19,
        height: 19,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M15.042 2.375H3.958c-.874 0-1.583.709-1.583 1.583v11.084c0 .874.709 1.583 1.583 1.583h11.084c.874 0 1.583-.709 1.583-1.583V3.958c0-.874-.709-1.583-1.583-1.583Z",
                stroke: "#3D80F3",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M9.5 10.292a2.375 2.375 0 1 0 0-4.75 2.375 2.375 0 0 0 0 4.75ZM5.543 16.625V15.04a1.583 1.583 0 0 1 1.583-1.583h4.75a1.583 1.583 0 0 1 1.584 1.583v1.584",
                stroke: "#3D80F3",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $7a51db8b8288e80f$export$2e2bcd8739ae039 = $7a51db8b8288e80f$var$SvgAiIcon;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $3206031044c2820c$var$SvgMic = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        width: 28,
        height: 28,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M14 2.333a3.5 3.5 0 0 0-3.5 3.5V14a3.5 3.5 0 1 0 7 0V5.834a3.5 3.5 0 0 0-3.5-3.5Z",
                stroke: "#B3B3B3",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M22.165 11.666V14a8.166 8.166 0 1 1-16.333 0v-2.334M14 22.166v3.5",
                stroke: "#B3B3B3",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $3206031044c2820c$export$2e2bcd8739ae039 = $3206031044c2820c$var$SvgMic;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $e31c9ce8f7532a60$var$SvgSend = (props)=>/*#__PURE__*/ (0, $bb3TF.jsx)("svg", {
        width: 20,
        height: 21,
        fill: "#fff",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
            d: "M19.457.23c.395.287.602.783.528 1.28l-2.5 17.062c-.059.398-.29.747-.625.943a1.199 1.199 0 0 1-1.094.066l-4.672-2.038-2.676 3.039c-.347.398-.894.529-1.375.332-.48-.197-.793-.685-.793-1.226v-3.43a.66.66 0 0 1 .164-.438l6.547-7.502a.675.675 0 0 0-.015-.902.603.603 0 0 0-.86-.029L4.141 14.8l-3.45-1.813a1.313 1.313 0 0 1-.69-1.136c-.012-.484.23-.936.628-1.178l17.5-10.5c.418-.25.934-.225 1.328.058Z"
        })
    });
var $e31c9ce8f7532a60$export$2e2bcd8739ae039 = $e31c9ce8f7532a60$var$SvgSend;



var $f5330f80cb38fce7$exports = {};

$f5330f80cb38fce7$exports = (parcelRequire("gfXgg"));



var $8LKEK = parcelRequire("8LKEK");
function $2d7d9af7a5367cf4$var$_mergeNamespaces(n, m) {
    m.forEach(function(e) {
        e && typeof e !== 'string' && !Array.isArray(e) && Object.keys(e).forEach(function(k) {
            if (k !== 'default' && !(k in n)) {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
    });
    return Object.freeze(n);
}
var $2d7d9af7a5367cf4$var$k = Object.defineProperty;
var $2d7d9af7a5367cf4$var$n = (s, o, c)=>o in s ? $2d7d9af7a5367cf4$var$k(s, o, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: c
    }) : s[o] = c;
var $2d7d9af7a5367cf4$var$l = (s, o, c)=>$2d7d9af7a5367cf4$var$n(s, typeof o != "symbol" ? o + "" : o, c);
class $2d7d9af7a5367cf4$export$ca12f2943758ef55 {
    constructor(){
        $2d7d9af7a5367cf4$var$l(this, "_locking");
        $2d7d9af7a5367cf4$var$l(this, "_locks");
        this._locking = Promise.resolve(), this._locks = 0;
    }
    isLocked() {
        return this._locks > 0;
    }
    lock() {
        this._locks += 1;
        let o;
        const c = new Promise((i)=>o = ()=>{
                this._locks -= 1, i();
            }), t = this._locking.then(()=>o);
        return this._locking = this._locking.then(()=>c), t;
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Assert that condition is truthy or throw error (with message)
 */ function $2d7d9af7a5367cf4$var$assert(condition, msg) {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- we want the implicit conversion to boolean
    if (!condition) throw new Error(msg);
}
const $2d7d9af7a5367cf4$var$FLOAT32_MAX = 3.4028234663852886e38, $2d7d9af7a5367cf4$var$FLOAT32_MIN = -340282346638528860000000000000000000000, $2d7d9af7a5367cf4$var$UINT32_MAX = 0xffffffff, $2d7d9af7a5367cf4$var$INT32_MAX = 0x7fffffff, $2d7d9af7a5367cf4$var$INT32_MIN = -2147483648;
/**
 * Assert a valid signed protobuf 32-bit integer.
 */ function $2d7d9af7a5367cf4$var$assertInt32(arg) {
    if (typeof arg !== "number") throw new Error("invalid int 32: " + typeof arg);
    if (!Number.isInteger(arg) || arg > $2d7d9af7a5367cf4$var$INT32_MAX || arg < $2d7d9af7a5367cf4$var$INT32_MIN) throw new Error("invalid int 32: " + arg); // eslint-disable-line @typescript-eslint/restrict-plus-operands -- we want the implicit conversion to string
}
/**
 * Assert a valid unsigned protobuf 32-bit integer.
 */ function $2d7d9af7a5367cf4$var$assertUInt32(arg) {
    if (typeof arg !== "number") throw new Error("invalid uint 32: " + typeof arg);
    if (!Number.isInteger(arg) || arg > $2d7d9af7a5367cf4$var$UINT32_MAX || arg < 0) throw new Error("invalid uint 32: " + arg); // eslint-disable-line @typescript-eslint/restrict-plus-operands -- we want the implicit conversion to string
}
/**
 * Assert a valid protobuf float value.
 */ function $2d7d9af7a5367cf4$var$assertFloat32(arg) {
    if (typeof arg !== "number") throw new Error("invalid float 32: " + typeof arg);
    if (!Number.isFinite(arg)) return;
    if (arg > $2d7d9af7a5367cf4$var$FLOAT32_MAX || arg < $2d7d9af7a5367cf4$var$FLOAT32_MIN) throw new Error("invalid float 32: " + arg); // eslint-disable-line @typescript-eslint/restrict-plus-operands -- we want the implicit conversion to string
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const $2d7d9af7a5367cf4$var$enumTypeSymbol = Symbol("@bufbuild/protobuf/enum-type");
/**
 * Get reflection information from a generated enum.
 * If this function is called on something other than a generated
 * enum, it raises an error.
 */ function $2d7d9af7a5367cf4$var$getEnumType(enumObject) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-explicit-any
    const t = enumObject[$2d7d9af7a5367cf4$var$enumTypeSymbol];
    $2d7d9af7a5367cf4$var$assert(t, "missing enum type on enum object");
    return t; // eslint-disable-line @typescript-eslint/no-unsafe-return
}
/**
 * Sets reflection information on a generated enum.
 */ function $2d7d9af7a5367cf4$var$setEnumType(enumObject, typeName, values, opt) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    enumObject[$2d7d9af7a5367cf4$var$enumTypeSymbol] = $2d7d9af7a5367cf4$var$makeEnumType(typeName, values.map((v)=>({
            no: v.no,
            name: v.name,
            localName: enumObject[v.no]
        })));
}
/**
 * Create a new EnumType with the given values.
 */ function $2d7d9af7a5367cf4$var$makeEnumType(typeName, values, // eslint-disable-next-line @typescript-eslint/no-unused-vars
_opt) {
    const names = Object.create(null);
    const numbers = Object.create(null);
    const normalValues = [];
    for (const value of values){
        // We do not surface options at this time
        // const value: EnumValueInfo = {...v, options: v.options ?? emptyReadonlyObject};
        const n = $2d7d9af7a5367cf4$var$normalizeEnumValue(value);
        normalValues.push(n);
        names[value.name] = n;
        numbers[value.no] = n;
    }
    return {
        typeName: typeName,
        values: normalValues,
        // We do not surface options at this time
        // options: opt?.options ?? Object.create(null),
        findName (name) {
            return names[name];
        },
        findNumber (no) {
            return numbers[no];
        }
    };
}
/**
 * Create a new enum object with the given values.
 * Sets reflection information.
 */ function $2d7d9af7a5367cf4$var$makeEnum(typeName, values, opt) {
    const enumObject = {};
    for (const value of values){
        const n = $2d7d9af7a5367cf4$var$normalizeEnumValue(value);
        enumObject[n.localName] = n.no;
        enumObject[n.no] = n.localName;
    }
    $2d7d9af7a5367cf4$var$setEnumType(enumObject, typeName, values);
    return enumObject;
}
function $2d7d9af7a5367cf4$var$normalizeEnumValue(value) {
    if ("localName" in value) return value;
    return Object.assign(Object.assign({}, value), {
        localName: value.name
    });
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Message is the base class of every message, generated, or created at
 * runtime.
 *
 * It is _not_ safe to extend this class. If you want to create a message at
 * run time, use proto3.makeMessageType().
 */ class $2d7d9af7a5367cf4$var$Message {
    /**
   * Compare with a message of the same type.
   * Note that this function disregards extensions and unknown fields.
   */ equals(other) {
        return this.getType().runtime.util.equals(this.getType(), this, other);
    }
    /**
   * Create a deep copy.
   */ clone() {
        return this.getType().runtime.util.clone(this);
    }
    /**
   * Parse from binary data, merging fields.
   *
   * Repeated fields are appended. Map entries are added, overwriting
   * existing keys.
   *
   * If a message field is already present, it will be merged with the
   * new data.
   */ fromBinary(bytes, options) {
        const type = this.getType(), format = type.runtime.bin, opt = format.makeReadOptions(options);
        format.readMessage(this, opt.readerFactory(bytes), bytes.byteLength, opt);
        return this;
    }
    /**
   * Parse a message from a JSON value.
   */ fromJson(jsonValue, options) {
        const type = this.getType(), format = type.runtime.json, opt = format.makeReadOptions(options);
        format.readMessage(type, jsonValue, opt, this);
        return this;
    }
    /**
   * Parse a message from a JSON string.
   */ fromJsonString(jsonString, options) {
        let json;
        try {
            json = JSON.parse(jsonString);
        } catch (e) {
            throw new Error("cannot decode ".concat(this.getType().typeName, " from JSON: ").concat(e instanceof Error ? e.message : String(e)));
        }
        return this.fromJson(json, options);
    }
    /**
   * Serialize the message to binary data.
   */ toBinary(options) {
        const type = this.getType(), bin = type.runtime.bin, opt = bin.makeWriteOptions(options), writer = opt.writerFactory();
        bin.writeMessage(this, writer, opt);
        return writer.finish();
    }
    /**
   * Serialize the message to a JSON value, a JavaScript value that can be
   * passed to JSON.stringify().
   */ toJson(options) {
        const type = this.getType(), json = type.runtime.json, opt = json.makeWriteOptions(options);
        return json.writeMessage(this, opt);
    }
    /**
   * Serialize the message to a JSON string.
   */ toJsonString(options) {
        var _a;
        const value = this.toJson(options);
        return JSON.stringify(value, null, (_a = options === null || options === void 0 ? void 0 : options.prettySpaces) !== null && _a !== void 0 ? _a : 0);
    }
    /**
   * Override for serialization behavior. This will be invoked when calling
   * JSON.stringify on this message (i.e. JSON.stringify(msg)).
   *
   * Note that this will not serialize google.protobuf.Any with a packed
   * message because the protobuf JSON format specifies that it needs to be
   * unpacked, and this is only possible with a type registry to look up the
   * message type.  As a result, attempting to serialize a message with this
   * type will throw an Error.
   *
   * This method is protected because you should not need to invoke it
   * directly -- instead use JSON.stringify or toJsonString for
   * stringified JSON.  Alternatively, if actual JSON is desired, you should
   * use toJson.
   */ toJSON() {
        return this.toJson({
            emitDefaultValues: true
        });
    }
    /**
   * Retrieve the MessageType of this message - a singleton that represents
   * the protobuf message declaration and provides metadata for reflection-
   * based operations.
   */ getType() {
        // Any class that extends Message _must_ provide a complete static
        // implementation of MessageType.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return
        return Object.getPrototypeOf(this).constructor;
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Create a new message type using the given runtime.
 */ function $2d7d9af7a5367cf4$var$makeMessageType(runtime, typeName, fields, opt) {
    var _a;
    const localName = (_a = opt === null || opt === void 0 ? void 0 : opt.localName) !== null && _a !== void 0 ? _a : typeName.substring(typeName.lastIndexOf(".") + 1);
    const type = {
        [localName]: function(data) {
            runtime.util.initFields(this);
            runtime.util.initPartial(data, this);
        }
    }[localName];
    Object.setPrototypeOf(type.prototype, new $2d7d9af7a5367cf4$var$Message());
    Object.assign(type, {
        runtime: runtime,
        typeName: typeName,
        fields: runtime.util.newFieldList(fields),
        fromBinary (bytes, options) {
            return new type().fromBinary(bytes, options);
        },
        fromJson (jsonValue, options) {
            return new type().fromJson(jsonValue, options);
        },
        fromJsonString (jsonString, options) {
            return new type().fromJsonString(jsonString, options);
        },
        equals (a, b) {
            return runtime.util.equals(type, a, b);
        }
    });
    return type;
}
// Copyright 2008 Google Inc.  All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
// * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
// * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
// * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
//
// Code generated by the Protocol Buffer compiler is owned by the owner
// of the input file used when generating it.  This code is not
// standalone and requires a support library to be linked with it.  This
// support library is itself covered by the above license.
/* eslint-disable prefer-const,@typescript-eslint/restrict-plus-operands */ /**
 * Read a 64 bit varint as two JS numbers.
 *
 * Returns tuple:
 * [0]: low bits
 * [1]: high bits
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/8a71927d74a4ce34efe2d8769fda198f52d20d12/js/experimental/runtime/kernel/buffer_decoder.js#L175
 */ function $2d7d9af7a5367cf4$var$varint64read() {
    let lowBits = 0;
    let highBits = 0;
    for(let shift = 0; shift < 28; shift += 7){
        let b = this.buf[this.pos++];
        lowBits |= (b & 0x7f) << shift;
        if ((b & 0x80) == 0) {
            this.assertBounds();
            return [
                lowBits,
                highBits
            ];
        }
    }
    let middleByte = this.buf[this.pos++];
    // last four bits of the first 32 bit number
    lowBits |= (middleByte & 0x0f) << 28;
    // 3 upper bits are part of the next 32 bit number
    highBits = (middleByte & 0x70) >> 4;
    if ((middleByte & 0x80) == 0) {
        this.assertBounds();
        return [
            lowBits,
            highBits
        ];
    }
    for(let shift = 3; shift <= 31; shift += 7){
        let b = this.buf[this.pos++];
        highBits |= (b & 0x7f) << shift;
        if ((b & 0x80) == 0) {
            this.assertBounds();
            return [
                lowBits,
                highBits
            ];
        }
    }
    throw new Error("invalid varint");
}
/**
 * Write a 64 bit varint, given as two JS numbers, to the given bytes array.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/8a71927d74a4ce34efe2d8769fda198f52d20d12/js/experimental/runtime/kernel/writer.js#L344
 */ function $2d7d9af7a5367cf4$var$varint64write(lo, hi, bytes) {
    for(let i = 0; i < 28; i = i + 7){
        const shift = lo >>> i;
        const hasNext = !(shift >>> 7 == 0 && hi == 0);
        const byte = (hasNext ? shift | 0x80 : shift) & 0xff;
        bytes.push(byte);
        if (!hasNext) return;
    }
    const splitBits = lo >>> 28 & 0x0f | (hi & 0x07) << 4;
    const hasMoreBits = !(hi >> 3 == 0);
    bytes.push((hasMoreBits ? splitBits | 0x80 : splitBits) & 0xff);
    if (!hasMoreBits) return;
    for(let i = 3; i < 31; i = i + 7){
        const shift = hi >>> i;
        const hasNext = !(shift >>> 7 == 0);
        const byte = (hasNext ? shift | 0x80 : shift) & 0xff;
        bytes.push(byte);
        if (!hasNext) return;
    }
    bytes.push(hi >>> 31 & 0x01);
}
// constants for binary math
const $2d7d9af7a5367cf4$var$TWO_PWR_32_DBL = 0x100000000;
/**
 * Parse decimal string of 64 bit integer value as two JS numbers.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf-javascript/blob/a428c58273abad07c66071d9753bc4d1289de426/experimental/runtime/int64.js#L10
 */ function $2d7d9af7a5367cf4$var$int64FromString(dec) {
    // Check for minus sign.
    const minus = dec[0] === "-";
    if (minus) dec = dec.slice(1);
    // Work 6 decimal digits at a time, acting like we're converting base 1e6
    // digits to binary. This is safe to do with floating point math because
    // Number.isSafeInteger(ALL_32_BITS * 1e6) == true.
    const base = 1e6;
    let lowBits = 0;
    let highBits = 0;
    function add1e6digit(begin, end) {
        // Note: Number('') is 0.
        const digit1e6 = Number(dec.slice(begin, end));
        highBits *= base;
        lowBits = lowBits * base + digit1e6;
        // Carry bits from lowBits to
        if (lowBits >= $2d7d9af7a5367cf4$var$TWO_PWR_32_DBL) {
            highBits = highBits + (lowBits / $2d7d9af7a5367cf4$var$TWO_PWR_32_DBL | 0);
            lowBits = lowBits % $2d7d9af7a5367cf4$var$TWO_PWR_32_DBL;
        }
    }
    add1e6digit(-24, -18);
    add1e6digit(-18, -12);
    add1e6digit(-12, -6);
    add1e6digit(-6);
    return minus ? $2d7d9af7a5367cf4$var$negate(lowBits, highBits) : $2d7d9af7a5367cf4$var$newBits(lowBits, highBits);
}
/**
 * Losslessly converts a 64-bit signed integer in 32:32 split representation
 * into a decimal string.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf-javascript/blob/a428c58273abad07c66071d9753bc4d1289de426/experimental/runtime/int64.js#L10
 */ function $2d7d9af7a5367cf4$var$int64ToString(lo, hi) {
    let bits = $2d7d9af7a5367cf4$var$newBits(lo, hi);
    // If we're treating the input as a signed value and the high bit is set, do
    // a manual two's complement conversion before the decimal conversion.
    const negative = bits.hi & 0x80000000;
    if (negative) bits = $2d7d9af7a5367cf4$var$negate(bits.lo, bits.hi);
    const result = $2d7d9af7a5367cf4$var$uInt64ToString(bits.lo, bits.hi);
    return negative ? "-" + result : result;
}
/**
 * Losslessly converts a 64-bit unsigned integer in 32:32 split representation
 * into a decimal string.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf-javascript/blob/a428c58273abad07c66071d9753bc4d1289de426/experimental/runtime/int64.js#L10
 */ function $2d7d9af7a5367cf4$var$uInt64ToString(lo, hi) {
    ({ lo: lo, hi: hi } = $2d7d9af7a5367cf4$var$toUnsigned(lo, hi));
    // Skip the expensive conversion if the number is small enough to use the
    // built-in conversions.
    // Number.MAX_SAFE_INTEGER = 0x001FFFFF FFFFFFFF, thus any number with
    // highBits <= 0x1FFFFF can be safely expressed with a double and retain
    // integer precision.
    // Proven by: Number.isSafeInteger(0x1FFFFF * 2**32 + 0xFFFFFFFF) == true.
    if (hi <= 0x1FFFFF) return String($2d7d9af7a5367cf4$var$TWO_PWR_32_DBL * hi + lo);
    // What this code is doing is essentially converting the input number from
    // base-2 to base-1e7, which allows us to represent the 64-bit range with
    // only 3 (very large) digits. Those digits are then trivial to convert to
    // a base-10 string.
    // The magic numbers used here are -
    // 2^24 = 16777216 = (1,6777216) in base-1e7.
    // 2^48 = 281474976710656 = (2,8147497,6710656) in base-1e7.
    // Split 32:32 representation into 16:24:24 representation so our
    // intermediate digits don't overflow.
    const low = lo & 0xFFFFFF;
    const mid = (lo >>> 24 | hi << 8) & 0xFFFFFF;
    const high = hi >> 16 & 0xFFFF;
    // Assemble our three base-1e7 digits, ignoring carries. The maximum
    // value in a digit at this step is representable as a 48-bit integer, which
    // can be stored in a 64-bit floating point number.
    let digitA = low + mid * 6777216 + high * 6710656;
    let digitB = mid + high * 8147497;
    let digitC = high * 2;
    // Apply carries from A to B and from B to C.
    const base = 10000000;
    if (digitA >= base) {
        digitB += Math.floor(digitA / base);
        digitA %= base;
    }
    if (digitB >= base) {
        digitC += Math.floor(digitB / base);
        digitB %= base;
    }
    // If digitC is 0, then we should have returned in the trivial code path
    // at the top for non-safe integers. Given this, we can assume both digitB
    // and digitA need leading zeros.
    return digitC.toString() + $2d7d9af7a5367cf4$var$decimalFrom1e7WithLeadingZeros(digitB) + $2d7d9af7a5367cf4$var$decimalFrom1e7WithLeadingZeros(digitA);
}
function $2d7d9af7a5367cf4$var$toUnsigned(lo, hi) {
    return {
        lo: lo >>> 0,
        hi: hi >>> 0
    };
}
function $2d7d9af7a5367cf4$var$newBits(lo, hi) {
    return {
        lo: lo | 0,
        hi: hi | 0
    };
}
/**
 * Returns two's compliment negation of input.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Bitwise_Operators#Signed_32-bit_integers
 */ function $2d7d9af7a5367cf4$var$negate(lowBits, highBits) {
    highBits = ~highBits;
    if (lowBits) lowBits = ~lowBits + 1;
    else // If lowBits is 0, then bitwise-not is 0xFFFFFFFF,
    // adding 1 to that, results in 0x100000000, which leaves
    // the low bits 0x0 and simply adds one to the high bits.
    highBits += 1;
    return $2d7d9af7a5367cf4$var$newBits(lowBits, highBits);
}
/**
 * Returns decimal representation of digit1e7 with leading zeros.
 */ const $2d7d9af7a5367cf4$var$decimalFrom1e7WithLeadingZeros = (digit1e7)=>{
    const partial = String(digit1e7);
    return "0000000".slice(partial.length) + partial;
};
/**
 * Write a 32 bit varint, signed or unsigned. Same as `varint64write(0, value, bytes)`
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/1b18833f4f2a2f681f4e4a25cdf3b0a43115ec26/js/binary/encoder.js#L144
 */ function $2d7d9af7a5367cf4$var$varint32write(value, bytes) {
    if (value >= 0) {
        // write value as varint 32
        while(value > 0x7f){
            bytes.push(value & 0x7f | 0x80);
            value = value >>> 7;
        }
        bytes.push(value);
    } else {
        for(let i = 0; i < 9; i++){
            bytes.push(value & 127 | 128);
            value = value >> 7;
        }
        bytes.push(1);
    }
}
/**
 * Read an unsigned 32 bit varint.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/8a71927d74a4ce34efe2d8769fda198f52d20d12/js/experimental/runtime/kernel/buffer_decoder.js#L220
 */ function $2d7d9af7a5367cf4$var$varint32read() {
    let b = this.buf[this.pos++];
    let result = b & 0x7f;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    b = this.buf[this.pos++];
    result |= (b & 0x7f) << 7;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    b = this.buf[this.pos++];
    result |= (b & 0x7f) << 14;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    b = this.buf[this.pos++];
    result |= (b & 0x7f) << 21;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    // Extract only last 4 bits
    b = this.buf[this.pos++];
    result |= (b & 0x0f) << 28;
    for(let readBytes = 5; (b & 0x80) !== 0 && readBytes < 10; readBytes++)b = this.buf[this.pos++];
    if ((b & 0x80) != 0) throw new Error("invalid varint");
    this.assertBounds();
    // Result can have 32 bits, convert it to unsigned
    return result >>> 0;
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function $2d7d9af7a5367cf4$var$makeInt64Support() {
    const dv = new DataView(new ArrayBuffer(8));
    // note that Safari 14 implements BigInt, but not the DataView methods
    const ok = typeof BigInt === "function" && typeof dv.getBigInt64 === "function" && typeof dv.getBigUint64 === "function" && typeof dv.setBigInt64 === "function" && typeof dv.setBigUint64 === "function" && (typeof $8LKEK != "object" || typeof $8LKEK.env != "object" || true);
    if (ok) {
        const MIN = BigInt("-9223372036854775808"), MAX = BigInt("9223372036854775807"), UMIN = BigInt("0"), UMAX = BigInt("18446744073709551615");
        return {
            zero: BigInt(0),
            supported: true,
            parse (value) {
                const bi = typeof value == "bigint" ? value : BigInt(value);
                if (bi > MAX || bi < MIN) throw new Error("int64 invalid: ".concat(value));
                return bi;
            },
            uParse (value) {
                const bi = typeof value == "bigint" ? value : BigInt(value);
                if (bi > UMAX || bi < UMIN) throw new Error("uint64 invalid: ".concat(value));
                return bi;
            },
            enc (value) {
                dv.setBigInt64(0, this.parse(value), true);
                return {
                    lo: dv.getInt32(0, true),
                    hi: dv.getInt32(4, true)
                };
            },
            uEnc (value) {
                dv.setBigInt64(0, this.uParse(value), true);
                return {
                    lo: dv.getInt32(0, true),
                    hi: dv.getInt32(4, true)
                };
            },
            dec (lo, hi) {
                dv.setInt32(0, lo, true);
                dv.setInt32(4, hi, true);
                return dv.getBigInt64(0, true);
            },
            uDec (lo, hi) {
                dv.setInt32(0, lo, true);
                dv.setInt32(4, hi, true);
                return dv.getBigUint64(0, true);
            }
        };
    }
    const assertInt64String = (value)=>$2d7d9af7a5367cf4$var$assert(/^-?[0-9]+$/.test(value), "int64 invalid: ".concat(value));
    const assertUInt64String = (value)=>$2d7d9af7a5367cf4$var$assert(/^[0-9]+$/.test(value), "uint64 invalid: ".concat(value));
    return {
        zero: "0",
        supported: false,
        parse (value) {
            if (typeof value != "string") value = value.toString();
            assertInt64String(value);
            return value;
        },
        uParse (value) {
            if (typeof value != "string") value = value.toString();
            assertUInt64String(value);
            return value;
        },
        enc (value) {
            if (typeof value != "string") value = value.toString();
            assertInt64String(value);
            return $2d7d9af7a5367cf4$var$int64FromString(value);
        },
        uEnc (value) {
            if (typeof value != "string") value = value.toString();
            assertUInt64String(value);
            return $2d7d9af7a5367cf4$var$int64FromString(value);
        },
        dec (lo, hi) {
            return $2d7d9af7a5367cf4$var$int64ToString(lo, hi);
        },
        uDec (lo, hi) {
            return $2d7d9af7a5367cf4$var$uInt64ToString(lo, hi);
        }
    };
}
const $2d7d9af7a5367cf4$var$protoInt64 = $2d7d9af7a5367cf4$var$makeInt64Support();
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Scalar value types. This is a subset of field types declared by protobuf
 * enum google.protobuf.FieldDescriptorProto.Type The types GROUP and MESSAGE
 * are omitted, but the numerical values are identical.
 */ var $2d7d9af7a5367cf4$var$ScalarType;
(function(ScalarType) {
    // 0 is reserved for errors.
    // Order is weird for historical reasons.
    ScalarType[ScalarType["DOUBLE"] = 1] = "DOUBLE";
    ScalarType[ScalarType["FLOAT"] = 2] = "FLOAT";
    // Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT64 if
    // negative values are likely.
    ScalarType[ScalarType["INT64"] = 3] = "INT64";
    ScalarType[ScalarType["UINT64"] = 4] = "UINT64";
    // Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT32 if
    // negative values are likely.
    ScalarType[ScalarType["INT32"] = 5] = "INT32";
    ScalarType[ScalarType["FIXED64"] = 6] = "FIXED64";
    ScalarType[ScalarType["FIXED32"] = 7] = "FIXED32";
    ScalarType[ScalarType["BOOL"] = 8] = "BOOL";
    ScalarType[ScalarType["STRING"] = 9] = "STRING";
    // Tag-delimited aggregate.
    // Group type is deprecated and not supported in proto3. However, Proto3
    // implementations should still be able to parse the group wire format and
    // treat group fields as unknown fields.
    // TYPE_GROUP = 10,
    // TYPE_MESSAGE = 11,  // Length-delimited aggregate.
    // New in version 2.
    ScalarType[ScalarType["BYTES"] = 12] = "BYTES";
    ScalarType[ScalarType["UINT32"] = 13] = "UINT32";
    // TYPE_ENUM = 14,
    ScalarType[ScalarType["SFIXED32"] = 15] = "SFIXED32";
    ScalarType[ScalarType["SFIXED64"] = 16] = "SFIXED64";
    ScalarType[ScalarType["SINT32"] = 17] = "SINT32";
    ScalarType[ScalarType["SINT64"] = 18] = "SINT64";
})($2d7d9af7a5367cf4$var$ScalarType || ($2d7d9af7a5367cf4$var$ScalarType = {}));
/**
 * JavaScript representation of fields with 64 bit integral types (int64, uint64,
 * sint64, fixed64, sfixed64).
 *
 * This is a subset of google.protobuf.FieldOptions.JSType, which defines JS_NORMAL,
 * JS_STRING, and JS_NUMBER. Protobuf-ES uses BigInt by default, but will use
 * String if `[jstype = JS_STRING]` is specified.
 *
 * ```protobuf
 * uint64 field_a = 1; // BigInt
 * uint64 field_b = 2 [jstype = JS_NORMAL]; // BigInt
 * uint64 field_b = 2 [jstype = JS_NUMBER]; // BigInt
 * uint64 field_b = 2 [jstype = JS_STRING]; // String
 * ```
 */ var $2d7d9af7a5367cf4$var$LongType;
(function(LongType) {
    /**
   * Use JavaScript BigInt.
   */ LongType[LongType["BIGINT"] = 0] = "BIGINT";
    /**
   * Use JavaScript String.
   *
   * Field option `[jstype = JS_STRING]`.
   */ LongType[LongType["STRING"] = 1] = "STRING";
})($2d7d9af7a5367cf4$var$LongType || ($2d7d9af7a5367cf4$var$LongType = {}));
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Returns true if both scalar values are equal.
 */ function $2d7d9af7a5367cf4$var$scalarEquals(type, a, b) {
    if (a === b) // This correctly matches equal values except BYTES and (possibly) 64-bit integers.
    return true;
    // Special case BYTES - we need to compare each byte individually
    if (type == $2d7d9af7a5367cf4$var$ScalarType.BYTES) {
        if (!(a instanceof Uint8Array) || !(b instanceof Uint8Array)) return false;
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    // Special case 64-bit integers - we support number, string and bigint representation.
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch(type){
        case $2d7d9af7a5367cf4$var$ScalarType.UINT64:
        case $2d7d9af7a5367cf4$var$ScalarType.FIXED64:
        case $2d7d9af7a5367cf4$var$ScalarType.INT64:
        case $2d7d9af7a5367cf4$var$ScalarType.SFIXED64:
        case $2d7d9af7a5367cf4$var$ScalarType.SINT64:
            // Loose comparison will match between 0n, 0 and "0".
            return a == b;
    }
    // Anything that hasn't been caught by strict comparison or special cased
    // BYTES and 64-bit integers is not equal.
    return false;
}
/**
 * Returns the zero value for the given scalar type.
 */ function $2d7d9af7a5367cf4$var$scalarZeroValue(type, longType) {
    switch(type){
        case $2d7d9af7a5367cf4$var$ScalarType.BOOL:
            return false;
        case $2d7d9af7a5367cf4$var$ScalarType.UINT64:
        case $2d7d9af7a5367cf4$var$ScalarType.FIXED64:
        case $2d7d9af7a5367cf4$var$ScalarType.INT64:
        case $2d7d9af7a5367cf4$var$ScalarType.SFIXED64:
        case $2d7d9af7a5367cf4$var$ScalarType.SINT64:
            // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- acceptable since it's covered by tests
            return longType == 0 ? $2d7d9af7a5367cf4$var$protoInt64.zero : "0";
        case $2d7d9af7a5367cf4$var$ScalarType.DOUBLE:
        case $2d7d9af7a5367cf4$var$ScalarType.FLOAT:
            return 0.0;
        case $2d7d9af7a5367cf4$var$ScalarType.BYTES:
            return new Uint8Array(0);
        case $2d7d9af7a5367cf4$var$ScalarType.STRING:
            return "";
        default:
            // Handles INT32, UINT32, SINT32, FIXED32, SFIXED32.
            // We do not use individual cases to save a few bytes code size.
            return 0;
    }
}
/**
 * Returns true for a zero-value. For example, an integer has the zero-value `0`,
 * a boolean is `false`, a string is `""`, and bytes is an empty Uint8Array.
 *
 * In proto3, zero-values are not written to the wire, unless the field is
 * optional or repeated.
 */ function $2d7d9af7a5367cf4$var$isScalarZeroValue(type, value) {
    switch(type){
        case $2d7d9af7a5367cf4$var$ScalarType.BOOL:
            return value === false;
        case $2d7d9af7a5367cf4$var$ScalarType.STRING:
            return value === "";
        case $2d7d9af7a5367cf4$var$ScalarType.BYTES:
            return value instanceof Uint8Array && !value.byteLength;
        default:
            return value == 0;
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/* eslint-disable prefer-const,no-case-declarations,@typescript-eslint/restrict-plus-operands */ /**
 * Protobuf binary format wire types.
 *
 * A wire type provides just enough information to find the length of the
 * following value.
 *
 * See https://developers.google.com/protocol-buffers/docs/encoding#structure
 */ var $2d7d9af7a5367cf4$var$WireType;
(function(WireType) {
    /**
   * Used for int32, int64, uint32, uint64, sint32, sint64, bool, enum
   */ WireType[WireType["Varint"] = 0] = "Varint";
    /**
   * Used for fixed64, sfixed64, double.
   * Always 8 bytes with little-endian byte order.
   */ WireType[WireType["Bit64"] = 1] = "Bit64";
    /**
   * Used for string, bytes, embedded messages, packed repeated fields
   *
   * Only repeated numeric types (types which use the varint, 32-bit,
   * or 64-bit wire types) can be packed. In proto3, such fields are
   * packed by default.
   */ WireType[WireType["LengthDelimited"] = 2] = "LengthDelimited";
    /**
   * Start of a tag-delimited aggregate, such as a proto2 group, or a message
   * in editions with message_encoding = DELIMITED.
   */ WireType[WireType["StartGroup"] = 3] = "StartGroup";
    /**
   * End of a tag-delimited aggregate.
   */ WireType[WireType["EndGroup"] = 4] = "EndGroup";
    /**
   * Used for fixed32, sfixed32, float.
   * Always 4 bytes with little-endian byte order.
   */ WireType[WireType["Bit32"] = 5] = "Bit32";
})($2d7d9af7a5367cf4$var$WireType || ($2d7d9af7a5367cf4$var$WireType = {}));
class $2d7d9af7a5367cf4$var$BinaryWriter {
    constructor(textEncoder){
        /**
     * Previous fork states.
     */ this.stack = [];
        this.textEncoder = textEncoder !== null && textEncoder !== void 0 ? textEncoder : new TextEncoder();
        this.chunks = [];
        this.buf = [];
    }
    /**
   * Return all bytes written and reset this writer.
   */ finish() {
        this.chunks.push(new Uint8Array(this.buf)); // flush the buffer
        let len = 0;
        for(let i = 0; i < this.chunks.length; i++)len += this.chunks[i].length;
        let bytes = new Uint8Array(len);
        let offset = 0;
        for(let i = 0; i < this.chunks.length; i++){
            bytes.set(this.chunks[i], offset);
            offset += this.chunks[i].length;
        }
        this.chunks = [];
        return bytes;
    }
    /**
   * Start a new fork for length-delimited data like a message
   * or a packed repeated field.
   *
   * Must be joined later with `join()`.
   */ fork() {
        this.stack.push({
            chunks: this.chunks,
            buf: this.buf
        });
        this.chunks = [];
        this.buf = [];
        return this;
    }
    /**
   * Join the last fork. Write its length and bytes, then
   * return to the previous state.
   */ join() {
        // get chunk of fork
        let chunk = this.finish();
        // restore previous state
        let prev = this.stack.pop();
        if (!prev) throw new Error("invalid state, fork stack empty");
        this.chunks = prev.chunks;
        this.buf = prev.buf;
        // write length of chunk as varint
        this.uint32(chunk.byteLength);
        return this.raw(chunk);
    }
    /**
   * Writes a tag (field number and wire type).
   *
   * Equivalent to `uint32( (fieldNo << 3 | type) >>> 0 )`.
   *
   * Generated code should compute the tag ahead of time and call `uint32()`.
   */ tag(fieldNo, type) {
        return this.uint32((fieldNo << 3 | type) >>> 0);
    }
    /**
   * Write a chunk of raw bytes.
   */ raw(chunk) {
        if (this.buf.length) {
            this.chunks.push(new Uint8Array(this.buf));
            this.buf = [];
        }
        this.chunks.push(chunk);
        return this;
    }
    /**
   * Write a `uint32` value, an unsigned 32 bit varint.
   */ uint32(value) {
        $2d7d9af7a5367cf4$var$assertUInt32(value);
        // write value as varint 32, inlined for speed
        while(value > 0x7f){
            this.buf.push(value & 0x7f | 0x80);
            value = value >>> 7;
        }
        this.buf.push(value);
        return this;
    }
    /**
   * Write a `int32` value, a signed 32 bit varint.
   */ int32(value) {
        $2d7d9af7a5367cf4$var$assertInt32(value);
        $2d7d9af7a5367cf4$var$varint32write(value, this.buf);
        return this;
    }
    /**
   * Write a `bool` value, a variant.
   */ bool(value) {
        this.buf.push(value ? 1 : 0);
        return this;
    }
    /**
   * Write a `bytes` value, length-delimited arbitrary data.
   */ bytes(value) {
        this.uint32(value.byteLength); // write length of chunk as varint
        return this.raw(value);
    }
    /**
   * Write a `string` value, length-delimited data converted to UTF-8 text.
   */ string(value) {
        let chunk = this.textEncoder.encode(value);
        this.uint32(chunk.byteLength); // write length of chunk as varint
        return this.raw(chunk);
    }
    /**
   * Write a `float` value, 32-bit floating point number.
   */ float(value) {
        $2d7d9af7a5367cf4$var$assertFloat32(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setFloat32(0, value, true);
        return this.raw(chunk);
    }
    /**
   * Write a `double` value, a 64-bit floating point number.
   */ double(value) {
        let chunk = new Uint8Array(8);
        new DataView(chunk.buffer).setFloat64(0, value, true);
        return this.raw(chunk);
    }
    /**
   * Write a `fixed32` value, an unsigned, fixed-length 32-bit integer.
   */ fixed32(value) {
        $2d7d9af7a5367cf4$var$assertUInt32(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setUint32(0, value, true);
        return this.raw(chunk);
    }
    /**
   * Write a `sfixed32` value, a signed, fixed-length 32-bit integer.
   */ sfixed32(value) {
        $2d7d9af7a5367cf4$var$assertInt32(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setInt32(0, value, true);
        return this.raw(chunk);
    }
    /**
   * Write a `sint32` value, a signed, zigzag-encoded 32-bit varint.
   */ sint32(value) {
        $2d7d9af7a5367cf4$var$assertInt32(value);
        // zigzag encode
        value = (value << 1 ^ value >> 31) >>> 0;
        $2d7d9af7a5367cf4$var$varint32write(value, this.buf);
        return this;
    }
    /**
   * Write a `fixed64` value, a signed, fixed-length 64-bit integer.
   */ sfixed64(value) {
        let chunk = new Uint8Array(8), view = new DataView(chunk.buffer), tc = $2d7d9af7a5367cf4$var$protoInt64.enc(value);
        view.setInt32(0, tc.lo, true);
        view.setInt32(4, tc.hi, true);
        return this.raw(chunk);
    }
    /**
   * Write a `fixed64` value, an unsigned, fixed-length 64 bit integer.
   */ fixed64(value) {
        let chunk = new Uint8Array(8), view = new DataView(chunk.buffer), tc = $2d7d9af7a5367cf4$var$protoInt64.uEnc(value);
        view.setInt32(0, tc.lo, true);
        view.setInt32(4, tc.hi, true);
        return this.raw(chunk);
    }
    /**
   * Write a `int64` value, a signed 64-bit varint.
   */ int64(value) {
        let tc = $2d7d9af7a5367cf4$var$protoInt64.enc(value);
        $2d7d9af7a5367cf4$var$varint64write(tc.lo, tc.hi, this.buf);
        return this;
    }
    /**
   * Write a `sint64` value, a signed, zig-zag-encoded 64-bit varint.
   */ sint64(value) {
        let tc = $2d7d9af7a5367cf4$var$protoInt64.enc(value), // zigzag encode
        sign = tc.hi >> 31, lo = tc.lo << 1 ^ sign, hi = (tc.hi << 1 | tc.lo >>> 31) ^ sign;
        $2d7d9af7a5367cf4$var$varint64write(lo, hi, this.buf);
        return this;
    }
    /**
   * Write a `uint64` value, an unsigned 64-bit varint.
   */ uint64(value) {
        let tc = $2d7d9af7a5367cf4$var$protoInt64.uEnc(value);
        $2d7d9af7a5367cf4$var$varint64write(tc.lo, tc.hi, this.buf);
        return this;
    }
}
class $2d7d9af7a5367cf4$var$BinaryReader {
    constructor(buf, textDecoder){
        this.varint64 = $2d7d9af7a5367cf4$var$varint64read; // dirty cast for `this`
        /**
     * Read a `uint32` field, an unsigned 32 bit varint.
     */ this.uint32 = $2d7d9af7a5367cf4$var$varint32read; // dirty cast for `this` and access to protected `buf`
        this.buf = buf;
        this.len = buf.length;
        this.pos = 0;
        this.view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
        this.textDecoder = textDecoder !== null && textDecoder !== void 0 ? textDecoder : new TextDecoder();
    }
    /**
   * Reads a tag - field number and wire type.
   */ tag() {
        let tag = this.uint32(), fieldNo = tag >>> 3, wireType = tag & 7;
        if (fieldNo <= 0 || wireType < 0 || wireType > 5) throw new Error("illegal tag: field no " + fieldNo + " wire type " + wireType);
        return [
            fieldNo,
            wireType
        ];
    }
    /**
   * Skip one element and return the skipped data.
   *
   * When skipping StartGroup, provide the tags field number to check for
   * matching field number in the EndGroup tag.
   */ skip(wireType, fieldNo) {
        let start = this.pos;
        switch(wireType){
            case $2d7d9af7a5367cf4$var$WireType.Varint:
                while(this.buf[this.pos++] & 0x80);
                break;
            // eslint-disable-next-line
            // @ts-ignore TS7029: Fallthrough case in switch
            case $2d7d9af7a5367cf4$var$WireType.Bit64:
                this.pos += 4;
            // eslint-disable-next-line
            // @ts-ignore TS7029: Fallthrough case in switch
            case $2d7d9af7a5367cf4$var$WireType.Bit32:
                this.pos += 4;
                break;
            case $2d7d9af7a5367cf4$var$WireType.LengthDelimited:
                let len = this.uint32();
                this.pos += len;
                break;
            case $2d7d9af7a5367cf4$var$WireType.StartGroup:
                for(;;){
                    const [fn, wt] = this.tag();
                    if (wt === $2d7d9af7a5367cf4$var$WireType.EndGroup) {
                        if (fieldNo !== undefined && fn !== fieldNo) throw new Error("invalid end group tag");
                        break;
                    }
                    this.skip(wt, fn);
                }
                break;
            default:
                throw new Error("cant skip wire type " + wireType);
        }
        this.assertBounds();
        return this.buf.subarray(start, this.pos);
    }
    /**
   * Throws error if position in byte array is out of range.
   */ assertBounds() {
        if (this.pos > this.len) throw new RangeError("premature EOF");
    }
    /**
   * Read a `int32` field, a signed 32 bit varint.
   */ int32() {
        return this.uint32() | 0;
    }
    /**
   * Read a `sint32` field, a signed, zigzag-encoded 32-bit varint.
   */ sint32() {
        let zze = this.uint32();
        // decode zigzag
        return zze >>> 1 ^ -(zze & 1);
    }
    /**
   * Read a `int64` field, a signed 64-bit varint.
   */ int64() {
        return $2d7d9af7a5367cf4$var$protoInt64.dec(...this.varint64());
    }
    /**
   * Read a `uint64` field, an unsigned 64-bit varint.
   */ uint64() {
        return $2d7d9af7a5367cf4$var$protoInt64.uDec(...this.varint64());
    }
    /**
   * Read a `sint64` field, a signed, zig-zag-encoded 64-bit varint.
   */ sint64() {
        let [lo, hi] = this.varint64();
        // decode zig zag
        let s = -(lo & 1);
        lo = (lo >>> 1 | (hi & 1) << 31) ^ s;
        hi = hi >>> 1 ^ s;
        return $2d7d9af7a5367cf4$var$protoInt64.dec(lo, hi);
    }
    /**
   * Read a `bool` field, a variant.
   */ bool() {
        let [lo, hi] = this.varint64();
        return lo !== 0 || hi !== 0;
    }
    /**
   * Read a `fixed32` field, an unsigned, fixed-length 32-bit integer.
   */ fixed32() {
        return this.view.getUint32((this.pos += 4) - 4, true);
    }
    /**
   * Read a `sfixed32` field, a signed, fixed-length 32-bit integer.
   */ sfixed32() {
        return this.view.getInt32((this.pos += 4) - 4, true);
    }
    /**
   * Read a `fixed64` field, an unsigned, fixed-length 64 bit integer.
   */ fixed64() {
        return $2d7d9af7a5367cf4$var$protoInt64.uDec(this.sfixed32(), this.sfixed32());
    }
    /**
   * Read a `fixed64` field, a signed, fixed-length 64-bit integer.
   */ sfixed64() {
        return $2d7d9af7a5367cf4$var$protoInt64.dec(this.sfixed32(), this.sfixed32());
    }
    /**
   * Read a `float` field, 32-bit floating point number.
   */ float() {
        return this.view.getFloat32((this.pos += 4) - 4, true);
    }
    /**
   * Read a `double` field, a 64-bit floating point number.
   */ double() {
        return this.view.getFloat64((this.pos += 8) - 8, true);
    }
    /**
   * Read a `bytes` field, length-delimited arbitrary data.
   */ bytes() {
        let len = this.uint32(), start = this.pos;
        this.pos += len;
        this.assertBounds();
        return this.buf.subarray(start, start + len);
    }
    /**
   * Read a `string` field, length-delimited data converted to UTF-8 text.
   */ string() {
        return this.textDecoder.decode(this.bytes());
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Create a new extension using the given runtime.
 */ function $2d7d9af7a5367cf4$var$makeExtension(runtime, typeName, extendee, field) {
    let fi;
    return {
        typeName: typeName,
        extendee: extendee,
        get field () {
            if (!fi) {
                const i = typeof field == "function" ? field() : field;
                i.name = typeName.split(".").pop();
                i.jsonName = "[".concat(typeName, "]");
                fi = runtime.util.newFieldList([
                    i
                ]).list()[0];
            }
            return fi;
        },
        runtime: runtime
    };
}
/**
 * Create a container that allows us to read extension fields into it with the
 * same logic as regular fields.
 */ function $2d7d9af7a5367cf4$var$createExtensionContainer(extension) {
    const localName = extension.field.localName;
    const container = Object.create(null);
    container[localName] = $2d7d9af7a5367cf4$var$initExtensionField(extension);
    return [
        container,
        ()=>container[localName]
    ];
}
function $2d7d9af7a5367cf4$var$initExtensionField(ext) {
    const field = ext.field;
    if (field.repeated) return [];
    if (field.default !== undefined) return field.default;
    switch(field.kind){
        case "enum":
            return field.T.values[0].no;
        case "scalar":
            return $2d7d9af7a5367cf4$var$scalarZeroValue(field.T, field.L);
        case "message":
            // eslint-disable-next-line no-case-declarations
            const T = field.T, value = new T();
            return T.fieldWrapper ? T.fieldWrapper.unwrapField(value) : value;
        case "map":
            throw "map fields are not allowed to be extensions";
    }
}
/**
 * Helper to filter unknown fields, optimized based on field type.
 */ function $2d7d9af7a5367cf4$var$filterUnknownFields(unknownFields, field) {
    if (!field.repeated && (field.kind == "enum" || field.kind == "scalar")) {
        // singular scalar fields do not merge, we pick the last
        for(let i = unknownFields.length - 1; i >= 0; --i){
            if (unknownFields[i].no == field.no) return [
                unknownFields[i]
            ];
        }
        return [];
    }
    return unknownFields.filter((uf)=>uf.no === field.no);
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unnecessary-condition, prefer-const */ // lookup table from base64 character to byte
let $2d7d9af7a5367cf4$var$encTable = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
// lookup table from base64 character *code* to byte because lookup by number is fast
let $2d7d9af7a5367cf4$var$decTable = [];
for(let i = 0; i < $2d7d9af7a5367cf4$var$encTable.length; i++)$2d7d9af7a5367cf4$var$decTable[$2d7d9af7a5367cf4$var$encTable[i].charCodeAt(0)] = i;
// support base64url variants
$2d7d9af7a5367cf4$var$decTable["-".charCodeAt(0)] = $2d7d9af7a5367cf4$var$encTable.indexOf("+");
$2d7d9af7a5367cf4$var$decTable["_".charCodeAt(0)] = $2d7d9af7a5367cf4$var$encTable.indexOf("/");
const $2d7d9af7a5367cf4$var$protoBase64 = {
    /**
   * Decodes a base64 string to a byte array.
   *
   * - ignores white-space, including line breaks and tabs
   * - allows inner padding (can decode concatenated base64 strings)
   * - does not require padding
   * - understands base64url encoding:
   *   "-" instead of "+",
   *   "_" instead of "/",
   *   no padding
   */ dec (base64Str) {
        // estimate byte size, not accounting for inner padding and whitespace
        let es = base64Str.length * 3 / 4;
        if (base64Str[base64Str.length - 2] == "=") es -= 2;
        else if (base64Str[base64Str.length - 1] == "=") es -= 1;
        let bytes = new Uint8Array(es), bytePos = 0, // position in byte array
        groupPos = 0, // position in base64 group
        b, // current byte
        p = 0; // previous byte
        for(let i = 0; i < base64Str.length; i++){
            b = $2d7d9af7a5367cf4$var$decTable[base64Str.charCodeAt(i)];
            if (b === undefined) switch(base64Str[i]){
                // @ts-ignore TS7029: Fallthrough case in switch
                case "=":
                    groupPos = 0;
                // reset state when padding found
                // @ts-ignore TS7029: Fallthrough case in switch
                case "\n":
                case "\r":
                case "\t":
                case " ":
                    continue;
                // skip white-space, and padding
                default:
                    throw Error("invalid base64 string.");
            }
            switch(groupPos){
                case 0:
                    p = b;
                    groupPos = 1;
                    break;
                case 1:
                    bytes[bytePos++] = p << 2 | (b & 48) >> 4;
                    p = b;
                    groupPos = 2;
                    break;
                case 2:
                    bytes[bytePos++] = (p & 15) << 4 | (b & 60) >> 2;
                    p = b;
                    groupPos = 3;
                    break;
                case 3:
                    bytes[bytePos++] = (p & 3) << 6 | b;
                    groupPos = 0;
                    break;
            }
        }
        if (groupPos == 1) throw Error("invalid base64 string.");
        return bytes.subarray(0, bytePos);
    },
    /**
   * Encode a byte array to a base64 string.
   */ enc (bytes) {
        let base64 = "", groupPos = 0, // position in base64 group
        b, // current byte
        p = 0; // carry over from previous byte
        for(let i = 0; i < bytes.length; i++){
            b = bytes[i];
            switch(groupPos){
                case 0:
                    base64 += $2d7d9af7a5367cf4$var$encTable[b >> 2];
                    p = (b & 3) << 4;
                    groupPos = 1;
                    break;
                case 1:
                    base64 += $2d7d9af7a5367cf4$var$encTable[p | b >> 4];
                    p = (b & 15) << 2;
                    groupPos = 2;
                    break;
                case 2:
                    base64 += $2d7d9af7a5367cf4$var$encTable[p | b >> 6];
                    base64 += $2d7d9af7a5367cf4$var$encTable[b & 63];
                    groupPos = 0;
                    break;
            }
        }
        // add output padding
        if (groupPos) {
            base64 += $2d7d9af7a5367cf4$var$encTable[p];
            base64 += "=";
            if (groupPos == 1) base64 += "=";
        }
        return base64;
    }
};
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Retrieve an extension value from a message.
 *
 * The function never returns undefined. Use hasExtension() to check whether an
 * extension is set. If the extension is not set, this function returns the
 * default value (if one was specified in the protobuf source), or the zero value
 * (for example `0` for numeric types, `[]` for repeated extension fields, and
 * an empty message instance for message fields).
 *
 * Extensions are stored as unknown fields on a message. To mutate an extension
 * value, make sure to store the new value with setExtension() after mutating.
 *
 * If the extension does not extend the given message, an error is raised.
 */ function $2d7d9af7a5367cf4$var$getExtension(message, extension, options) {
    $2d7d9af7a5367cf4$var$assertExtendee(extension, message);
    const opt = extension.runtime.bin.makeReadOptions(options);
    const ufs = $2d7d9af7a5367cf4$var$filterUnknownFields(message.getType().runtime.bin.listUnknownFields(message), extension.field);
    const [container, get] = $2d7d9af7a5367cf4$var$createExtensionContainer(extension);
    for (const uf of ufs)extension.runtime.bin.readField(container, opt.readerFactory(uf.data), extension.field, uf.wireType, opt);
    return get();
}
/**
 * Set an extension value on a message. If the message already has a value for
 * this extension, the value is replaced.
 *
 * If the extension does not extend the given message, an error is raised.
 */ function $2d7d9af7a5367cf4$var$setExtension(message, extension, value, options) {
    $2d7d9af7a5367cf4$var$assertExtendee(extension, message);
    const readOpt = extension.runtime.bin.makeReadOptions(options);
    const writeOpt = extension.runtime.bin.makeWriteOptions(options);
    if ($2d7d9af7a5367cf4$var$hasExtension(message, extension)) {
        const ufs = message.getType().runtime.bin.listUnknownFields(message).filter((uf)=>uf.no != extension.field.no);
        message.getType().runtime.bin.discardUnknownFields(message);
        for (const uf of ufs)message.getType().runtime.bin.onUnknownField(message, uf.no, uf.wireType, uf.data);
    }
    const writer = writeOpt.writerFactory();
    let f = extension.field;
    // Implicit presence does not apply to extensions, see https://github.com/protocolbuffers/protobuf/issues/8234
    // We patch the field info to use explicit presence:
    if (!f.opt && !f.repeated && (f.kind == "enum" || f.kind == "scalar")) f = Object.assign(Object.assign({}, extension.field), {
        opt: true
    });
    extension.runtime.bin.writeField(f, value, writer, writeOpt);
    const reader = readOpt.readerFactory(writer.finish());
    while(reader.pos < reader.len){
        const [no, wireType] = reader.tag();
        const data = reader.skip(wireType, no);
        message.getType().runtime.bin.onUnknownField(message, no, wireType, data);
    }
}
/**
 * Check whether an extension is set on a message.
 */ function $2d7d9af7a5367cf4$var$hasExtension(message, extension) {
    const messageType = message.getType();
    return extension.extendee.typeName === messageType.typeName && !!messageType.runtime.bin.listUnknownFields(message).find((uf)=>uf.no == extension.field.no);
}
function $2d7d9af7a5367cf4$var$assertExtendee(extension, message) {
    $2d7d9af7a5367cf4$var$assert(extension.extendee.typeName == message.getType().typeName, "extension ".concat(extension.typeName, " can only be applied to message ").concat(extension.extendee.typeName));
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Returns true if the field is set.
 */ function $2d7d9af7a5367cf4$var$isFieldSet(field, target) {
    const localName = field.localName;
    if (field.repeated) return target[localName].length > 0;
    if (field.oneof) return target[field.oneof.localName].case === localName; // eslint-disable-line @typescript-eslint/no-unsafe-member-access
    switch(field.kind){
        case "enum":
        case "scalar":
            if (field.opt || field.req) // explicit presence
            return target[localName] !== undefined;
            // implicit presence
            if (field.kind == "enum") return target[localName] !== field.T.values[0].no;
            return !$2d7d9af7a5367cf4$var$isScalarZeroValue(field.T, target[localName]);
        case "message":
            return target[localName] !== undefined;
        case "map":
            return Object.keys(target[localName]).length > 0;
    }
}
/**
 * Resets the field, so that isFieldSet() will return false.
 */ function $2d7d9af7a5367cf4$var$clearField(field, target) {
    const localName = field.localName;
    const implicitPresence = !field.opt && !field.req;
    if (field.repeated) target[localName] = [];
    else if (field.oneof) target[field.oneof.localName] = {
        case: undefined
    };
    else switch(field.kind){
        case "map":
            target[localName] = {};
            break;
        case "enum":
            target[localName] = implicitPresence ? field.T.values[0].no : undefined;
            break;
        case "scalar":
            target[localName] = implicitPresence ? $2d7d9af7a5367cf4$var$scalarZeroValue(field.T, field.L) : undefined;
            break;
        case "message":
            target[localName] = undefined;
            break;
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Check whether the given object is any subtype of Message or is a specific
 * Message by passing the type.
 *
 * Just like `instanceof`, `isMessage` narrows the type. The advantage of
 * `isMessage` is that it compares identity by the message type name, not by
 * class identity. This makes it robust against the dual package hazard and
 * similar situations, where the same message is duplicated.
 *
 * This function is _mostly_ equivalent to the `instanceof` operator. For
 * example, `isMessage(foo, MyMessage)` is the same as `foo instanceof MyMessage`,
 * and `isMessage(foo)` is the same as `foo instanceof Message`. In most cases,
 * `isMessage` should be preferred over `instanceof`.
 *
 * However, due to the fact that `isMessage` does not use class identity, there
 * are subtle differences between this function and `instanceof`. Notably,
 * calling `isMessage` on an explicit type of Message will return false.
 */ function $2d7d9af7a5367cf4$var$isMessage(arg, type) {
    if (arg === null || typeof arg != "object") return false;
    if (!Object.getOwnPropertyNames($2d7d9af7a5367cf4$var$Message.prototype).every((m)=>m in arg && typeof arg[m] == "function")) return false;
    const actualType = arg.getType();
    if (actualType === null || typeof actualType != "function" || !("typeName" in actualType) || typeof actualType.typeName != "string") return false;
    return type === undefined ? true : actualType.typeName == type.typeName;
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Wrap a primitive message field value in its corresponding wrapper
 * message. This function is idempotent.
 */ function $2d7d9af7a5367cf4$var$wrapField(type, value) {
    if ($2d7d9af7a5367cf4$var$isMessage(value) || !type.fieldWrapper) return value;
    return type.fieldWrapper.wrapField(value);
}
$2d7d9af7a5367cf4$var$ScalarType.DOUBLE, $2d7d9af7a5367cf4$var$ScalarType.FLOAT, $2d7d9af7a5367cf4$var$ScalarType.INT64, $2d7d9af7a5367cf4$var$ScalarType.UINT64, $2d7d9af7a5367cf4$var$ScalarType.INT32, $2d7d9af7a5367cf4$var$ScalarType.UINT32, $2d7d9af7a5367cf4$var$ScalarType.BOOL, $2d7d9af7a5367cf4$var$ScalarType.STRING, $2d7d9af7a5367cf4$var$ScalarType.BYTES;
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/* eslint-disable no-case-declarations,@typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call */ // Default options for parsing JSON.
const $2d7d9af7a5367cf4$var$jsonReadDefaults = {
    ignoreUnknownFields: false
};
// Default options for serializing to JSON.
const $2d7d9af7a5367cf4$var$jsonWriteDefaults = {
    emitDefaultValues: false,
    enumAsInteger: false,
    useProtoFieldName: false,
    prettySpaces: 0
};
function $2d7d9af7a5367cf4$var$makeReadOptions$1(options) {
    return options ? Object.assign(Object.assign({}, $2d7d9af7a5367cf4$var$jsonReadDefaults), options) : $2d7d9af7a5367cf4$var$jsonReadDefaults;
}
function $2d7d9af7a5367cf4$var$makeWriteOptions$1(options) {
    return options ? Object.assign(Object.assign({}, $2d7d9af7a5367cf4$var$jsonWriteDefaults), options) : $2d7d9af7a5367cf4$var$jsonWriteDefaults;
}
const $2d7d9af7a5367cf4$var$tokenNull = Symbol();
const $2d7d9af7a5367cf4$var$tokenIgnoredUnknownEnum = Symbol();
function $2d7d9af7a5367cf4$var$makeJsonFormat() {
    return {
        makeReadOptions: $2d7d9af7a5367cf4$var$makeReadOptions$1,
        makeWriteOptions: $2d7d9af7a5367cf4$var$makeWriteOptions$1,
        readMessage (type, json, options, message) {
            if (json == null || Array.isArray(json) || typeof json != "object") throw new Error("cannot decode message ".concat(type.typeName, " from JSON: ").concat($2d7d9af7a5367cf4$var$debugJsonValue(json)));
            message = message !== null && message !== void 0 ? message : new type();
            const oneofSeen = new Map();
            const registry = options.typeRegistry;
            for (const [jsonKey, jsonValue] of Object.entries(json)){
                const field = type.fields.findJsonName(jsonKey);
                if (field) {
                    if (field.oneof) {
                        if (jsonValue === null && field.kind == "scalar") continue;
                        const seen = oneofSeen.get(field.oneof);
                        if (seen !== undefined) throw new Error("cannot decode message ".concat(type.typeName, " from JSON: multiple keys for oneof \"").concat(field.oneof.name, "\" present: \"").concat(seen, "\", \"").concat(jsonKey, "\""));
                        oneofSeen.set(field.oneof, jsonKey);
                    }
                    $2d7d9af7a5367cf4$var$readField$1(message, jsonValue, field, options, type);
                } else {
                    let found = false;
                    if ((registry === null || registry === void 0 ? void 0 : registry.findExtension) && jsonKey.startsWith("[") && jsonKey.endsWith("]")) {
                        const ext = registry.findExtension(jsonKey.substring(1, jsonKey.length - 1));
                        if (ext && ext.extendee.typeName == type.typeName) {
                            found = true;
                            const [container, get] = $2d7d9af7a5367cf4$var$createExtensionContainer(ext);
                            $2d7d9af7a5367cf4$var$readField$1(container, jsonValue, ext.field, options, ext);
                            // We pass on the options as BinaryReadOptions/BinaryWriteOptions,
                            // so that users can bring their own binary reader and writer factories
                            // if necessary.
                            $2d7d9af7a5367cf4$var$setExtension(message, ext, get(), options);
                        }
                    }
                    if (!found && !options.ignoreUnknownFields) throw new Error("cannot decode message ".concat(type.typeName, " from JSON: key \"").concat(jsonKey, "\" is unknown"));
                }
            }
            return message;
        },
        writeMessage (message, options) {
            const type = message.getType();
            const json = {};
            let field;
            try {
                for (field of type.fields.byNumber()){
                    if (!$2d7d9af7a5367cf4$var$isFieldSet(field, message)) {
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        if (field.req) throw "required field not set";
                        if (!options.emitDefaultValues) continue;
                        if (!$2d7d9af7a5367cf4$var$canEmitFieldDefaultValue(field)) continue;
                    }
                    const value = field.oneof ? message[field.oneof.localName].value : message[field.localName];
                    const jsonValue = $2d7d9af7a5367cf4$var$writeField$1(field, value, options);
                    if (jsonValue !== undefined) json[options.useProtoFieldName ? field.name : field.jsonName] = jsonValue;
                }
                const registry = options.typeRegistry;
                if (registry === null || registry === void 0 ? void 0 : registry.findExtensionFor) for (const uf of type.runtime.bin.listUnknownFields(message)){
                    const ext = registry.findExtensionFor(type.typeName, uf.no);
                    if (ext && $2d7d9af7a5367cf4$var$hasExtension(message, ext)) {
                        // We pass on the options as BinaryReadOptions, so that users can bring their own
                        // binary reader factory if necessary.
                        const value = $2d7d9af7a5367cf4$var$getExtension(message, ext, options);
                        const jsonValue = $2d7d9af7a5367cf4$var$writeField$1(ext.field, value, options);
                        if (jsonValue !== undefined) json[ext.field.jsonName] = jsonValue;
                    }
                }
            } catch (e) {
                const m = field ? "cannot encode field ".concat(type.typeName, ".").concat(field.name, " to JSON") : "cannot encode message ".concat(type.typeName, " to JSON");
                const r = e instanceof Error ? e.message : String(e);
                throw new Error(m + (r.length > 0 ? ": ".concat(r) : ""));
            }
            return json;
        },
        readScalar (type, json, longType) {
            // The signature of our internal function has changed. For backwards-
            // compatibility, we support the old form that is part of the public API
            // through the interface JsonFormat.
            return $2d7d9af7a5367cf4$var$readScalar$1(type, json, longType !== null && longType !== void 0 ? longType : $2d7d9af7a5367cf4$var$LongType.BIGINT, true);
        },
        writeScalar (type, value, emitDefaultValues) {
            // The signature of our internal function has changed. For backwards-
            // compatibility, we support the old form that is part of the public API
            // through the interface JsonFormat.
            if (value === undefined) return undefined;
            if (emitDefaultValues || $2d7d9af7a5367cf4$var$isScalarZeroValue(type, value)) return $2d7d9af7a5367cf4$var$writeScalar$1(type, value);
            return undefined;
        },
        debug: $2d7d9af7a5367cf4$var$debugJsonValue
    };
}
function $2d7d9af7a5367cf4$var$debugJsonValue(json) {
    if (json === null) return "null";
    switch(typeof json){
        case "object":
            return Array.isArray(json) ? "array" : "object";
        case "string":
            return json.length > 100 ? "string" : "\"".concat(json.split('"').join('\\"'), "\"");
        default:
            return String(json);
    }
}
// Read a JSON value for a field.
// The "parentType" argument is only used to provide context in errors.
function $2d7d9af7a5367cf4$var$readField$1(target, jsonValue, field, options, parentType) {
    let localName = field.localName;
    if (field.repeated) {
        $2d7d9af7a5367cf4$var$assert(field.kind != "map");
        if (jsonValue === null) return;
        if (!Array.isArray(jsonValue)) throw new Error("cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($2d7d9af7a5367cf4$var$debugJsonValue(jsonValue)));
        const targetArray = target[localName];
        for (const jsonItem of jsonValue){
            if (jsonItem === null) throw new Error("cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($2d7d9af7a5367cf4$var$debugJsonValue(jsonItem)));
            switch(field.kind){
                case "message":
                    targetArray.push(field.T.fromJson(jsonItem, options));
                    break;
                case "enum":
                    const enumValue = $2d7d9af7a5367cf4$var$readEnum(field.T, jsonItem, options.ignoreUnknownFields, true);
                    if (enumValue !== $2d7d9af7a5367cf4$var$tokenIgnoredUnknownEnum) targetArray.push(enumValue);
                    break;
                case "scalar":
                    try {
                        targetArray.push($2d7d9af7a5367cf4$var$readScalar$1(field.T, jsonItem, field.L, true));
                    } catch (e) {
                        let m = "cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($2d7d9af7a5367cf4$var$debugJsonValue(jsonItem));
                        if (e instanceof Error && e.message.length > 0) m += ": ".concat(e.message);
                        throw new Error(m);
                    }
                    break;
            }
        }
    } else if (field.kind == "map") {
        if (jsonValue === null) return;
        if (typeof jsonValue != "object" || Array.isArray(jsonValue)) throw new Error("cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($2d7d9af7a5367cf4$var$debugJsonValue(jsonValue)));
        const targetMap = target[localName];
        for (const [jsonMapKey, jsonMapValue] of Object.entries(jsonValue)){
            if (jsonMapValue === null) throw new Error("cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: map value null"));
            let key;
            try {
                key = $2d7d9af7a5367cf4$var$readMapKey(field.K, jsonMapKey);
            } catch (e) {
                let m = "cannot decode map key for field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($2d7d9af7a5367cf4$var$debugJsonValue(jsonValue));
                if (e instanceof Error && e.message.length > 0) m += ": ".concat(e.message);
                throw new Error(m);
            }
            switch(field.V.kind){
                case "message":
                    targetMap[key] = field.V.T.fromJson(jsonMapValue, options);
                    break;
                case "enum":
                    const enumValue = $2d7d9af7a5367cf4$var$readEnum(field.V.T, jsonMapValue, options.ignoreUnknownFields, true);
                    if (enumValue !== $2d7d9af7a5367cf4$var$tokenIgnoredUnknownEnum) targetMap[key] = enumValue;
                    break;
                case "scalar":
                    try {
                        targetMap[key] = $2d7d9af7a5367cf4$var$readScalar$1(field.V.T, jsonMapValue, $2d7d9af7a5367cf4$var$LongType.BIGINT, true);
                    } catch (e) {
                        let m = "cannot decode map value for field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($2d7d9af7a5367cf4$var$debugJsonValue(jsonValue));
                        if (e instanceof Error && e.message.length > 0) m += ": ".concat(e.message);
                        throw new Error(m);
                    }
                    break;
            }
        }
    } else {
        if (field.oneof) {
            target = target[field.oneof.localName] = {
                case: localName
            };
            localName = "value";
        }
        switch(field.kind){
            case "message":
                const messageType = field.T;
                if (jsonValue === null && messageType.typeName != "google.protobuf.Value") return;
                let currentValue = target[localName];
                if ($2d7d9af7a5367cf4$var$isMessage(currentValue)) currentValue.fromJson(jsonValue, options);
                else {
                    target[localName] = currentValue = messageType.fromJson(jsonValue, options);
                    if (messageType.fieldWrapper && !field.oneof) target[localName] = messageType.fieldWrapper.unwrapField(currentValue);
                }
                break;
            case "enum":
                const enumValue = $2d7d9af7a5367cf4$var$readEnum(field.T, jsonValue, options.ignoreUnknownFields, false);
                switch(enumValue){
                    case $2d7d9af7a5367cf4$var$tokenNull:
                        $2d7d9af7a5367cf4$var$clearField(field, target);
                        break;
                    case $2d7d9af7a5367cf4$var$tokenIgnoredUnknownEnum:
                        break;
                    default:
                        target[localName] = enumValue;
                        break;
                }
                break;
            case "scalar":
                try {
                    const scalarValue = $2d7d9af7a5367cf4$var$readScalar$1(field.T, jsonValue, field.L, false);
                    switch(scalarValue){
                        case $2d7d9af7a5367cf4$var$tokenNull:
                            $2d7d9af7a5367cf4$var$clearField(field, target);
                            break;
                        default:
                            target[localName] = scalarValue;
                            break;
                    }
                } catch (e) {
                    let m = "cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($2d7d9af7a5367cf4$var$debugJsonValue(jsonValue));
                    if (e instanceof Error && e.message.length > 0) m += ": ".concat(e.message);
                    throw new Error(m);
                }
                break;
        }
    }
}
function $2d7d9af7a5367cf4$var$readMapKey(type, json) {
    if (type === $2d7d9af7a5367cf4$var$ScalarType.BOOL) // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch(json){
        case "true":
            json = true;
            break;
        case "false":
            json = false;
            break;
    }
    return $2d7d9af7a5367cf4$var$readScalar$1(type, json, $2d7d9af7a5367cf4$var$LongType.BIGINT, true).toString();
}
function $2d7d9af7a5367cf4$var$readScalar$1(type, json, longType, nullAsZeroValue) {
    if (json === null) {
        if (nullAsZeroValue) return $2d7d9af7a5367cf4$var$scalarZeroValue(type, longType);
        return $2d7d9af7a5367cf4$var$tokenNull;
    }
    // every valid case in the switch below returns, and every fall
    // through is regarded as a failure.
    switch(type){
        // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
        // Either numbers or strings are accepted. Exponent notation is also accepted.
        case $2d7d9af7a5367cf4$var$ScalarType.DOUBLE:
        case $2d7d9af7a5367cf4$var$ScalarType.FLOAT:
            if (json === "NaN") return Number.NaN;
            if (json === "Infinity") return Number.POSITIVE_INFINITY;
            if (json === "-Infinity") return Number.NEGATIVE_INFINITY;
            if (json === "") break;
            if (typeof json == "string" && json.trim().length !== json.length) break;
            if (typeof json != "string" && typeof json != "number") break;
            const float = Number(json);
            if (Number.isNaN(float)) break;
            if (!Number.isFinite(float)) break;
            if (type == $2d7d9af7a5367cf4$var$ScalarType.FLOAT) $2d7d9af7a5367cf4$var$assertFloat32(float);
            return float;
        // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
        case $2d7d9af7a5367cf4$var$ScalarType.INT32:
        case $2d7d9af7a5367cf4$var$ScalarType.FIXED32:
        case $2d7d9af7a5367cf4$var$ScalarType.SFIXED32:
        case $2d7d9af7a5367cf4$var$ScalarType.SINT32:
        case $2d7d9af7a5367cf4$var$ScalarType.UINT32:
            let int32;
            if (typeof json == "number") int32 = json;
            else if (typeof json == "string" && json.length > 0) {
                if (json.trim().length === json.length) int32 = Number(json);
            }
            if (int32 === undefined) break;
            if (type == $2d7d9af7a5367cf4$var$ScalarType.UINT32 || type == $2d7d9af7a5367cf4$var$ScalarType.FIXED32) $2d7d9af7a5367cf4$var$assertUInt32(int32);
            else $2d7d9af7a5367cf4$var$assertInt32(int32);
            return int32;
        // int64, fixed64, uint64: JSON value will be a decimal string. Either numbers or strings are accepted.
        case $2d7d9af7a5367cf4$var$ScalarType.INT64:
        case $2d7d9af7a5367cf4$var$ScalarType.SFIXED64:
        case $2d7d9af7a5367cf4$var$ScalarType.SINT64:
            if (typeof json != "number" && typeof json != "string") break;
            const long = $2d7d9af7a5367cf4$var$protoInt64.parse(json);
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            return longType ? long.toString() : long;
        case $2d7d9af7a5367cf4$var$ScalarType.FIXED64:
        case $2d7d9af7a5367cf4$var$ScalarType.UINT64:
            if (typeof json != "number" && typeof json != "string") break;
            const uLong = $2d7d9af7a5367cf4$var$protoInt64.uParse(json);
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            return longType ? uLong.toString() : uLong;
        // bool:
        case $2d7d9af7a5367cf4$var$ScalarType.BOOL:
            if (typeof json !== "boolean") break;
            return json;
        // string:
        case $2d7d9af7a5367cf4$var$ScalarType.STRING:
            if (typeof json !== "string") break;
            // A string must always contain UTF-8 encoded or 7-bit ASCII.
            // We validate with encodeURIComponent, which appears to be the fastest widely available option.
            try {
                encodeURIComponent(json);
            } catch (e) {
                throw new Error("invalid UTF8");
            }
            return json;
        // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
        // Either standard or URL-safe base64 encoding with/without paddings are accepted.
        case $2d7d9af7a5367cf4$var$ScalarType.BYTES:
            if (json === "") return new Uint8Array(0);
            if (typeof json !== "string") break;
            return $2d7d9af7a5367cf4$var$protoBase64.dec(json);
    }
    throw new Error();
}
function $2d7d9af7a5367cf4$var$readEnum(type, json, ignoreUnknownFields, nullAsZeroValue) {
    if (json === null) {
        if (type.typeName == "google.protobuf.NullValue") return 0; // google.protobuf.NullValue.NULL_VALUE = 0
        return nullAsZeroValue ? type.values[0].no : $2d7d9af7a5367cf4$var$tokenNull;
    }
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch(typeof json){
        case "number":
            if (Number.isInteger(json)) return json;
            break;
        case "string":
            const value = type.findName(json);
            if (value !== undefined) return value.no;
            if (ignoreUnknownFields) return $2d7d9af7a5367cf4$var$tokenIgnoredUnknownEnum;
            break;
    }
    throw new Error("cannot decode enum ".concat(type.typeName, " from JSON: ").concat($2d7d9af7a5367cf4$var$debugJsonValue(json)));
}
// Decide whether an unset field should be emitted with JSON write option `emitDefaultValues`
function $2d7d9af7a5367cf4$var$canEmitFieldDefaultValue(field) {
    if (field.repeated || field.kind == "map") // maps are {}, repeated fields are []
    return true;
    if (field.oneof) // oneof fields are never emitted
    return false;
    if (field.kind == "message") // singular message field are allowed to emit JSON null, but we do not
    return false;
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (field.opt || field.req) // the field uses explicit presence, so we cannot emit a zero value
    return false;
    return true;
}
function $2d7d9af7a5367cf4$var$writeField$1(field, value, options) {
    if (field.kind == "map") {
        $2d7d9af7a5367cf4$var$assert(typeof value == "object" && value != null);
        const jsonObj = {};
        const entries = Object.entries(value);
        switch(field.V.kind){
            case "scalar":
                for (const [entryKey, entryValue] of entries)jsonObj[entryKey.toString()] = $2d7d9af7a5367cf4$var$writeScalar$1(field.V.T, entryValue); // JSON standard allows only (double quoted) string as property key
                break;
            case "message":
                for (const [entryKey, entryValue] of entries)// JSON standard allows only (double quoted) string as property key
                jsonObj[entryKey.toString()] = entryValue.toJson(options);
                break;
            case "enum":
                const enumType = field.V.T;
                for (const [entryKey, entryValue] of entries)// JSON standard allows only (double quoted) string as property key
                jsonObj[entryKey.toString()] = $2d7d9af7a5367cf4$var$writeEnum(enumType, entryValue, options.enumAsInteger);
                break;
        }
        return options.emitDefaultValues || entries.length > 0 ? jsonObj : undefined;
    }
    if (field.repeated) {
        $2d7d9af7a5367cf4$var$assert(Array.isArray(value));
        const jsonArr = [];
        switch(field.kind){
            case "scalar":
                for(let i = 0; i < value.length; i++)jsonArr.push($2d7d9af7a5367cf4$var$writeScalar$1(field.T, value[i]));
                break;
            case "enum":
                for(let i = 0; i < value.length; i++)jsonArr.push($2d7d9af7a5367cf4$var$writeEnum(field.T, value[i], options.enumAsInteger));
                break;
            case "message":
                for(let i = 0; i < value.length; i++)jsonArr.push(value[i].toJson(options));
                break;
        }
        return options.emitDefaultValues || jsonArr.length > 0 ? jsonArr : undefined;
    }
    switch(field.kind){
        case "scalar":
            return $2d7d9af7a5367cf4$var$writeScalar$1(field.T, value);
        case "enum":
            return $2d7d9af7a5367cf4$var$writeEnum(field.T, value, options.enumAsInteger);
        case "message":
            return $2d7d9af7a5367cf4$var$wrapField(field.T, value).toJson(options);
    }
}
function $2d7d9af7a5367cf4$var$writeEnum(type, value, enumAsInteger) {
    var _a;
    $2d7d9af7a5367cf4$var$assert(typeof value == "number");
    if (type.typeName == "google.protobuf.NullValue") return null;
    if (enumAsInteger) return value;
    const val = type.findNumber(value);
    return (_a = val === null || val === void 0 ? void 0 : val.name) !== null && _a !== void 0 ? _a : value; // if we don't know the enum value, just return the number
}
function $2d7d9af7a5367cf4$var$writeScalar$1(type, value) {
    switch(type){
        // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
        case $2d7d9af7a5367cf4$var$ScalarType.INT32:
        case $2d7d9af7a5367cf4$var$ScalarType.SFIXED32:
        case $2d7d9af7a5367cf4$var$ScalarType.SINT32:
        case $2d7d9af7a5367cf4$var$ScalarType.FIXED32:
        case $2d7d9af7a5367cf4$var$ScalarType.UINT32:
            $2d7d9af7a5367cf4$var$assert(typeof value == "number");
            return value;
        // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
        // Either numbers or strings are accepted. Exponent notation is also accepted.
        case $2d7d9af7a5367cf4$var$ScalarType.FLOAT:
        // assertFloat32(value);
        case $2d7d9af7a5367cf4$var$ScalarType.DOUBLE:
            // eslint-disable-line no-fallthrough
            $2d7d9af7a5367cf4$var$assert(typeof value == "number");
            if (Number.isNaN(value)) return "NaN";
            if (value === Number.POSITIVE_INFINITY) return "Infinity";
            if (value === Number.NEGATIVE_INFINITY) return "-Infinity";
            return value;
        // string:
        case $2d7d9af7a5367cf4$var$ScalarType.STRING:
            $2d7d9af7a5367cf4$var$assert(typeof value == "string");
            return value;
        // bool:
        case $2d7d9af7a5367cf4$var$ScalarType.BOOL:
            $2d7d9af7a5367cf4$var$assert(typeof value == "boolean");
            return value;
        // JSON value will be a decimal string. Either numbers or strings are accepted.
        case $2d7d9af7a5367cf4$var$ScalarType.UINT64:
        case $2d7d9af7a5367cf4$var$ScalarType.FIXED64:
        case $2d7d9af7a5367cf4$var$ScalarType.INT64:
        case $2d7d9af7a5367cf4$var$ScalarType.SFIXED64:
        case $2d7d9af7a5367cf4$var$ScalarType.SINT64:
            $2d7d9af7a5367cf4$var$assert(typeof value == "bigint" || typeof value == "string" || typeof value == "number");
            return value.toString();
        // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
        // Either standard or URL-safe base64 encoding with/without paddings are accepted.
        case $2d7d9af7a5367cf4$var$ScalarType.BYTES:
            $2d7d9af7a5367cf4$var$assert(value instanceof Uint8Array);
            return $2d7d9af7a5367cf4$var$protoBase64.enc(value);
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/* eslint-disable prefer-const,no-case-declarations,@typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-return */ const $2d7d9af7a5367cf4$var$unknownFieldsSymbol = Symbol("@bufbuild/protobuf/unknown-fields");
// Default options for parsing binary data.
const $2d7d9af7a5367cf4$var$readDefaults = {
    readUnknownFields: true,
    readerFactory: (bytes)=>new $2d7d9af7a5367cf4$var$BinaryReader(bytes)
};
// Default options for serializing binary data.
const $2d7d9af7a5367cf4$var$writeDefaults = {
    writeUnknownFields: true,
    writerFactory: ()=>new $2d7d9af7a5367cf4$var$BinaryWriter()
};
function $2d7d9af7a5367cf4$var$makeReadOptions(options) {
    return options ? Object.assign(Object.assign({}, $2d7d9af7a5367cf4$var$readDefaults), options) : $2d7d9af7a5367cf4$var$readDefaults;
}
function $2d7d9af7a5367cf4$var$makeWriteOptions(options) {
    return options ? Object.assign(Object.assign({}, $2d7d9af7a5367cf4$var$writeDefaults), options) : $2d7d9af7a5367cf4$var$writeDefaults;
}
function $2d7d9af7a5367cf4$var$makeBinaryFormat() {
    return {
        makeReadOptions: $2d7d9af7a5367cf4$var$makeReadOptions,
        makeWriteOptions: $2d7d9af7a5367cf4$var$makeWriteOptions,
        listUnknownFields (message) {
            var _a;
            return (_a = message[$2d7d9af7a5367cf4$var$unknownFieldsSymbol]) !== null && _a !== void 0 ? _a : [];
        },
        discardUnknownFields (message) {
            delete message[$2d7d9af7a5367cf4$var$unknownFieldsSymbol];
        },
        writeUnknownFields (message, writer) {
            const m = message;
            const c = m[$2d7d9af7a5367cf4$var$unknownFieldsSymbol];
            if (c) for (const f of c)writer.tag(f.no, f.wireType).raw(f.data);
        },
        onUnknownField (message, no, wireType, data) {
            const m = message;
            if (!Array.isArray(m[$2d7d9af7a5367cf4$var$unknownFieldsSymbol])) m[$2d7d9af7a5367cf4$var$unknownFieldsSymbol] = [];
            m[$2d7d9af7a5367cf4$var$unknownFieldsSymbol].push({
                no: no,
                wireType: wireType,
                data: data
            });
        },
        readMessage (message, reader, lengthOrEndTagFieldNo, options, delimitedMessageEncoding) {
            const type = message.getType();
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            const end = delimitedMessageEncoding ? reader.len : reader.pos + lengthOrEndTagFieldNo;
            let fieldNo, wireType;
            while(reader.pos < end){
                [fieldNo, wireType] = reader.tag();
                if (delimitedMessageEncoding === true && wireType == $2d7d9af7a5367cf4$var$WireType.EndGroup) break;
                const field = type.fields.find(fieldNo);
                if (!field) {
                    const data = reader.skip(wireType, fieldNo);
                    if (options.readUnknownFields) this.onUnknownField(message, fieldNo, wireType, data);
                    continue;
                }
                $2d7d9af7a5367cf4$var$readField(message, reader, field, wireType, options);
            }
            if (delimitedMessageEncoding && // eslint-disable-line @typescript-eslint/strict-boolean-expressions
            (wireType != $2d7d9af7a5367cf4$var$WireType.EndGroup || fieldNo !== lengthOrEndTagFieldNo)) throw new Error("invalid end group tag");
        },
        readField: $2d7d9af7a5367cf4$var$readField,
        writeMessage (message, writer, options) {
            const type = message.getType();
            for (const field of type.fields.byNumber()){
                if (!$2d7d9af7a5367cf4$var$isFieldSet(field, message)) {
                    if (field.req) throw new Error("cannot encode field ".concat(type.typeName, ".").concat(field.name, " to binary: required field not set"));
                    continue;
                }
                const value = field.oneof ? message[field.oneof.localName].value : message[field.localName];
                $2d7d9af7a5367cf4$var$writeField(field, value, writer, options);
            }
            if (options.writeUnknownFields) this.writeUnknownFields(message, writer);
            return writer;
        },
        writeField (field, value, writer, options) {
            // The behavior of our internal function has changed, it does no longer
            // accept `undefined` values for singular scalar and map.
            // For backwards-compatibility, we support the old form that is part of
            // the public API through the interface BinaryFormat.
            if (value === undefined) return undefined;
            $2d7d9af7a5367cf4$var$writeField(field, value, writer, options);
        }
    };
}
function $2d7d9af7a5367cf4$var$readField(target, // eslint-disable-line @typescript-eslint/no-explicit-any -- `any` is the best choice for dynamic access
reader, field, wireType, options) {
    let { repeated: repeated, localName: localName } = field;
    if (field.oneof) {
        target = target[field.oneof.localName];
        if (target.case != localName) delete target.value;
        target.case = localName;
        localName = "value";
    }
    switch(field.kind){
        case "scalar":
        case "enum":
            const scalarType = field.kind == "enum" ? $2d7d9af7a5367cf4$var$ScalarType.INT32 : field.T;
            let read = $2d7d9af7a5367cf4$var$readScalar;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- acceptable since it's covered by tests
            if (field.kind == "scalar" && field.L > 0) read = $2d7d9af7a5367cf4$var$readScalarLTString;
            if (repeated) {
                let arr = target[localName]; // safe to assume presence of array, oneof cannot contain repeated values
                const isPacked = wireType == $2d7d9af7a5367cf4$var$WireType.LengthDelimited && scalarType != $2d7d9af7a5367cf4$var$ScalarType.STRING && scalarType != $2d7d9af7a5367cf4$var$ScalarType.BYTES;
                if (isPacked) {
                    let e = reader.uint32() + reader.pos;
                    while(reader.pos < e)arr.push(read(reader, scalarType));
                } else arr.push(read(reader, scalarType));
            } else target[localName] = read(reader, scalarType);
            break;
        case "message":
            const messageType = field.T;
            if (repeated) // safe to assume presence of array, oneof cannot contain repeated values
            target[localName].push($2d7d9af7a5367cf4$var$readMessageField(reader, new messageType(), options, field));
            else if ($2d7d9af7a5367cf4$var$isMessage(target[localName])) $2d7d9af7a5367cf4$var$readMessageField(reader, target[localName], options, field);
            else {
                target[localName] = $2d7d9af7a5367cf4$var$readMessageField(reader, new messageType(), options, field);
                if (messageType.fieldWrapper && !field.oneof && !field.repeated) target[localName] = messageType.fieldWrapper.unwrapField(target[localName]);
            }
            break;
        case "map":
            let [mapKey, mapVal] = $2d7d9af7a5367cf4$var$readMapEntry(field, reader, options);
            // safe to assume presence of map object, oneof cannot contain repeated values
            target[localName][mapKey] = mapVal;
            break;
    }
}
// Read a message, avoiding MessageType.fromBinary() to re-use the
// BinaryReadOptions and the IBinaryReader.
function $2d7d9af7a5367cf4$var$readMessageField(reader, message, options, field) {
    const format = message.getType().runtime.bin;
    const delimited = field === null || field === void 0 ? void 0 : field.delimited;
    format.readMessage(message, reader, delimited ? field.no : reader.uint32(), // eslint-disable-line @typescript-eslint/strict-boolean-expressions
    options, delimited);
    return message;
}
// Read a map field, expecting key field = 1, value field = 2
function $2d7d9af7a5367cf4$var$readMapEntry(field, reader, options) {
    const length = reader.uint32(), end = reader.pos + length;
    let key, val;
    while(reader.pos < end){
        const [fieldNo] = reader.tag();
        switch(fieldNo){
            case 1:
                key = $2d7d9af7a5367cf4$var$readScalar(reader, field.K);
                break;
            case 2:
                switch(field.V.kind){
                    case "scalar":
                        val = $2d7d9af7a5367cf4$var$readScalar(reader, field.V.T);
                        break;
                    case "enum":
                        val = reader.int32();
                        break;
                    case "message":
                        val = $2d7d9af7a5367cf4$var$readMessageField(reader, new field.V.T(), options, undefined);
                        break;
                }
                break;
        }
    }
    if (key === undefined) key = $2d7d9af7a5367cf4$var$scalarZeroValue(field.K, $2d7d9af7a5367cf4$var$LongType.BIGINT);
    if (typeof key != "string" && typeof key != "number") key = key.toString();
    if (val === undefined) switch(field.V.kind){
        case "scalar":
            val = $2d7d9af7a5367cf4$var$scalarZeroValue(field.V.T, $2d7d9af7a5367cf4$var$LongType.BIGINT);
            break;
        case "enum":
            val = field.V.T.values[0].no;
            break;
        case "message":
            val = new field.V.T();
            break;
    }
    return [
        key,
        val
    ];
}
// Read a scalar value, but return 64 bit integral types (int64, uint64,
// sint64, fixed64, sfixed64) as string instead of bigint.
function $2d7d9af7a5367cf4$var$readScalarLTString(reader, type) {
    const v = $2d7d9af7a5367cf4$var$readScalar(reader, type);
    return typeof v == "bigint" ? v.toString() : v;
}
// Does not use scalarTypeInfo() for better performance.
function $2d7d9af7a5367cf4$var$readScalar(reader, type) {
    switch(type){
        case $2d7d9af7a5367cf4$var$ScalarType.STRING:
            return reader.string();
        case $2d7d9af7a5367cf4$var$ScalarType.BOOL:
            return reader.bool();
        case $2d7d9af7a5367cf4$var$ScalarType.DOUBLE:
            return reader.double();
        case $2d7d9af7a5367cf4$var$ScalarType.FLOAT:
            return reader.float();
        case $2d7d9af7a5367cf4$var$ScalarType.INT32:
            return reader.int32();
        case $2d7d9af7a5367cf4$var$ScalarType.INT64:
            return reader.int64();
        case $2d7d9af7a5367cf4$var$ScalarType.UINT64:
            return reader.uint64();
        case $2d7d9af7a5367cf4$var$ScalarType.FIXED64:
            return reader.fixed64();
        case $2d7d9af7a5367cf4$var$ScalarType.BYTES:
            return reader.bytes();
        case $2d7d9af7a5367cf4$var$ScalarType.FIXED32:
            return reader.fixed32();
        case $2d7d9af7a5367cf4$var$ScalarType.SFIXED32:
            return reader.sfixed32();
        case $2d7d9af7a5367cf4$var$ScalarType.SFIXED64:
            return reader.sfixed64();
        case $2d7d9af7a5367cf4$var$ScalarType.SINT64:
            return reader.sint64();
        case $2d7d9af7a5367cf4$var$ScalarType.UINT32:
            return reader.uint32();
        case $2d7d9af7a5367cf4$var$ScalarType.SINT32:
            return reader.sint32();
    }
}
function $2d7d9af7a5367cf4$var$writeField(field, value, writer, options) {
    $2d7d9af7a5367cf4$var$assert(value !== undefined);
    const repeated = field.repeated;
    switch(field.kind){
        case "scalar":
        case "enum":
            let scalarType = field.kind == "enum" ? $2d7d9af7a5367cf4$var$ScalarType.INT32 : field.T;
            if (repeated) {
                $2d7d9af7a5367cf4$var$assert(Array.isArray(value));
                if (field.packed) $2d7d9af7a5367cf4$var$writePacked(writer, scalarType, field.no, value);
                else for (const item of value)$2d7d9af7a5367cf4$var$writeScalar(writer, scalarType, field.no, item);
            } else $2d7d9af7a5367cf4$var$writeScalar(writer, scalarType, field.no, value);
            break;
        case "message":
            if (repeated) {
                $2d7d9af7a5367cf4$var$assert(Array.isArray(value));
                for (const item of value)$2d7d9af7a5367cf4$var$writeMessageField(writer, options, field, item);
            } else $2d7d9af7a5367cf4$var$writeMessageField(writer, options, field, value);
            break;
        case "map":
            $2d7d9af7a5367cf4$var$assert(typeof value == "object" && value != null);
            for (const [key, val] of Object.entries(value))$2d7d9af7a5367cf4$var$writeMapEntry(writer, options, field, key, val);
            break;
    }
}
function $2d7d9af7a5367cf4$var$writeMapEntry(writer, options, field, key, value) {
    writer.tag(field.no, $2d7d9af7a5367cf4$var$WireType.LengthDelimited);
    writer.fork();
    // javascript only allows number or string for object properties
    // we convert from our representation to the protobuf type
    let keyValue = key;
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- we deliberately handle just the special cases for map keys
    switch(field.K){
        case $2d7d9af7a5367cf4$var$ScalarType.INT32:
        case $2d7d9af7a5367cf4$var$ScalarType.FIXED32:
        case $2d7d9af7a5367cf4$var$ScalarType.UINT32:
        case $2d7d9af7a5367cf4$var$ScalarType.SFIXED32:
        case $2d7d9af7a5367cf4$var$ScalarType.SINT32:
            keyValue = Number.parseInt(key);
            break;
        case $2d7d9af7a5367cf4$var$ScalarType.BOOL:
            $2d7d9af7a5367cf4$var$assert(key == "true" || key == "false");
            keyValue = key == "true";
            break;
    }
    // write key, expecting key field number = 1
    $2d7d9af7a5367cf4$var$writeScalar(writer, field.K, 1, keyValue);
    // write value, expecting value field number = 2
    switch(field.V.kind){
        case "scalar":
            $2d7d9af7a5367cf4$var$writeScalar(writer, field.V.T, 2, value);
            break;
        case "enum":
            $2d7d9af7a5367cf4$var$writeScalar(writer, $2d7d9af7a5367cf4$var$ScalarType.INT32, 2, value);
            break;
        case "message":
            $2d7d9af7a5367cf4$var$assert(value !== undefined);
            writer.tag(2, $2d7d9af7a5367cf4$var$WireType.LengthDelimited).bytes(value.toBinary(options));
            break;
    }
    writer.join();
}
// Value must not be undefined
function $2d7d9af7a5367cf4$var$writeMessageField(writer, options, field, value) {
    const message = $2d7d9af7a5367cf4$var$wrapField(field.T, value);
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (field.delimited) writer.tag(field.no, $2d7d9af7a5367cf4$var$WireType.StartGroup).raw(message.toBinary(options)).tag(field.no, $2d7d9af7a5367cf4$var$WireType.EndGroup);
    else writer.tag(field.no, $2d7d9af7a5367cf4$var$WireType.LengthDelimited).bytes(message.toBinary(options));
}
function $2d7d9af7a5367cf4$var$writeScalar(writer, type, fieldNo, value) {
    $2d7d9af7a5367cf4$var$assert(value !== undefined);
    let [wireType, method] = $2d7d9af7a5367cf4$var$scalarTypeInfo(type);
    writer.tag(fieldNo, wireType)[method](value);
}
function $2d7d9af7a5367cf4$var$writePacked(writer, type, fieldNo, value) {
    if (!value.length) return;
    writer.tag(fieldNo, $2d7d9af7a5367cf4$var$WireType.LengthDelimited).fork();
    let [, method] = $2d7d9af7a5367cf4$var$scalarTypeInfo(type);
    for(let i = 0; i < value.length; i++)writer[method](value[i]);
    writer.join();
}
/**
 * Get information for writing a scalar value.
 *
 * Returns tuple:
 * [0]: appropriate WireType
 * [1]: name of the appropriate method of IBinaryWriter
 * [2]: whether the given value is a default value for proto3 semantics
 *
 * If argument `value` is omitted, [2] is always false.
 */ // TODO replace call-sites writeScalar() and writePacked(), then remove
function $2d7d9af7a5367cf4$var$scalarTypeInfo(type) {
    let wireType = $2d7d9af7a5367cf4$var$WireType.Varint;
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- INT32, UINT32, SINT32 are covered by the defaults
    switch(type){
        case $2d7d9af7a5367cf4$var$ScalarType.BYTES:
        case $2d7d9af7a5367cf4$var$ScalarType.STRING:
            wireType = $2d7d9af7a5367cf4$var$WireType.LengthDelimited;
            break;
        case $2d7d9af7a5367cf4$var$ScalarType.DOUBLE:
        case $2d7d9af7a5367cf4$var$ScalarType.FIXED64:
        case $2d7d9af7a5367cf4$var$ScalarType.SFIXED64:
            wireType = $2d7d9af7a5367cf4$var$WireType.Bit64;
            break;
        case $2d7d9af7a5367cf4$var$ScalarType.FIXED32:
        case $2d7d9af7a5367cf4$var$ScalarType.SFIXED32:
        case $2d7d9af7a5367cf4$var$ScalarType.FLOAT:
            wireType = $2d7d9af7a5367cf4$var$WireType.Bit32;
            break;
    }
    const method = $2d7d9af7a5367cf4$var$ScalarType[type].toLowerCase();
    return [
        wireType,
        method
    ];
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-argument,no-case-declarations */ function $2d7d9af7a5367cf4$var$makeUtilCommon() {
    return {
        setEnumType: $2d7d9af7a5367cf4$var$setEnumType,
        initPartial (source, target) {
            if (source === undefined) return;
            const type = target.getType();
            for (const member of type.fields.byMember()){
                const localName = member.localName, t = target, s = source;
                if (s[localName] == null) continue;
                switch(member.kind){
                    case "oneof":
                        const sk = s[localName].case;
                        if (sk === undefined) continue;
                        const sourceField = member.findField(sk);
                        let val = s[localName].value;
                        if (sourceField && sourceField.kind == "message" && !$2d7d9af7a5367cf4$var$isMessage(val, sourceField.T)) val = new sourceField.T(val);
                        else if (sourceField && sourceField.kind === "scalar" && sourceField.T === $2d7d9af7a5367cf4$var$ScalarType.BYTES) val = $2d7d9af7a5367cf4$var$toU8Arr(val);
                        t[localName] = {
                            case: sk,
                            value: val
                        };
                        break;
                    case "scalar":
                    case "enum":
                        let copy = s[localName];
                        if (member.T === $2d7d9af7a5367cf4$var$ScalarType.BYTES) copy = member.repeated ? copy.map($2d7d9af7a5367cf4$var$toU8Arr) : $2d7d9af7a5367cf4$var$toU8Arr(copy);
                        t[localName] = copy;
                        break;
                    case "map":
                        switch(member.V.kind){
                            case "scalar":
                            case "enum":
                                if (member.V.T === $2d7d9af7a5367cf4$var$ScalarType.BYTES) for (const [k, v] of Object.entries(s[localName]))t[localName][k] = $2d7d9af7a5367cf4$var$toU8Arr(v);
                                else Object.assign(t[localName], s[localName]);
                                break;
                            case "message":
                                const messageType = member.V.T;
                                for (const k of Object.keys(s[localName])){
                                    let val = s[localName][k];
                                    if (!messageType.fieldWrapper) // We only take partial input for messages that are not a wrapper type.
                                    // For those messages, we recursively normalize the partial input.
                                    val = new messageType(val);
                                    t[localName][k] = val;
                                }
                                break;
                        }
                        break;
                    case "message":
                        const mt = member.T;
                        if (member.repeated) t[localName] = s[localName].map((val)=>$2d7d9af7a5367cf4$var$isMessage(val, mt) ? val : new mt(val));
                        else {
                            const val = s[localName];
                            if (mt.fieldWrapper) {
                                if (// We can't use BytesValue.typeName as that will create a circular import
                                mt.typeName === "google.protobuf.BytesValue") t[localName] = $2d7d9af7a5367cf4$var$toU8Arr(val);
                                else t[localName] = val;
                            } else t[localName] = $2d7d9af7a5367cf4$var$isMessage(val, mt) ? val : new mt(val);
                        }
                        break;
                }
            }
        },
        // TODO use isFieldSet() here to support future field presence
        equals (type, a, b) {
            if (a === b) return true;
            if (!a || !b) return false;
            return type.fields.byMember().every((m)=>{
                const va = a[m.localName];
                const vb = b[m.localName];
                if (m.repeated) {
                    if (va.length !== vb.length) return false;
                    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- repeated fields are never "map"
                    switch(m.kind){
                        case "message":
                            return va.every((a, i)=>m.T.equals(a, vb[i]));
                        case "scalar":
                            return va.every((a, i)=>$2d7d9af7a5367cf4$var$scalarEquals(m.T, a, vb[i]));
                        case "enum":
                            return va.every((a, i)=>$2d7d9af7a5367cf4$var$scalarEquals($2d7d9af7a5367cf4$var$ScalarType.INT32, a, vb[i]));
                    }
                    throw new Error("repeated cannot contain ".concat(m.kind));
                }
                switch(m.kind){
                    case "message":
                        return m.T.equals(va, vb);
                    case "enum":
                        return $2d7d9af7a5367cf4$var$scalarEquals($2d7d9af7a5367cf4$var$ScalarType.INT32, va, vb);
                    case "scalar":
                        return $2d7d9af7a5367cf4$var$scalarEquals(m.T, va, vb);
                    case "oneof":
                        if (va.case !== vb.case) return false;
                        const s = m.findField(va.case);
                        if (s === undefined) return true;
                        // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- oneof fields are never "map"
                        switch(s.kind){
                            case "message":
                                return s.T.equals(va.value, vb.value);
                            case "enum":
                                return $2d7d9af7a5367cf4$var$scalarEquals($2d7d9af7a5367cf4$var$ScalarType.INT32, va.value, vb.value);
                            case "scalar":
                                return $2d7d9af7a5367cf4$var$scalarEquals(s.T, va.value, vb.value);
                        }
                        throw new Error("oneof cannot contain ".concat(s.kind));
                    case "map":
                        const keys = Object.keys(va).concat(Object.keys(vb));
                        switch(m.V.kind){
                            case "message":
                                const messageType = m.V.T;
                                return keys.every((k)=>messageType.equals(va[k], vb[k]));
                            case "enum":
                                return keys.every((k)=>$2d7d9af7a5367cf4$var$scalarEquals($2d7d9af7a5367cf4$var$ScalarType.INT32, va[k], vb[k]));
                            case "scalar":
                                const scalarType = m.V.T;
                                return keys.every((k)=>$2d7d9af7a5367cf4$var$scalarEquals(scalarType, va[k], vb[k]));
                        }
                        break;
                }
            });
        },
        // TODO use isFieldSet() here to support future field presence
        clone (message) {
            const type = message.getType(), target = new type(), any = target;
            for (const member of type.fields.byMember()){
                const source = message[member.localName];
                let copy;
                if (member.repeated) copy = source.map($2d7d9af7a5367cf4$var$cloneSingularField);
                else if (member.kind == "map") {
                    copy = any[member.localName];
                    for (const [key, v] of Object.entries(source))copy[key] = $2d7d9af7a5367cf4$var$cloneSingularField(v);
                } else if (member.kind == "oneof") {
                    const f = member.findField(source.case);
                    copy = f ? {
                        case: source.case,
                        value: $2d7d9af7a5367cf4$var$cloneSingularField(source.value)
                    } : {
                        case: undefined
                    };
                } else copy = $2d7d9af7a5367cf4$var$cloneSingularField(source);
                any[member.localName] = copy;
            }
            for (const uf of type.runtime.bin.listUnknownFields(message))type.runtime.bin.onUnknownField(any, uf.no, uf.wireType, uf.data);
            return target;
        }
    };
}
// clone a single field value - i.e. the element type of repeated fields, the value type of maps
function $2d7d9af7a5367cf4$var$cloneSingularField(value) {
    if (value === undefined) return value;
    if ($2d7d9af7a5367cf4$var$isMessage(value)) return value.clone();
    if (value instanceof Uint8Array) {
        const c = new Uint8Array(value.byteLength);
        c.set(value);
        return c;
    }
    return value;
}
// converts any ArrayLike<number> to Uint8Array if necessary.
function $2d7d9af7a5367cf4$var$toU8Arr(input) {
    return input instanceof Uint8Array ? input : new Uint8Array(input);
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function $2d7d9af7a5367cf4$var$makeProtoRuntime(syntax, newFieldList, initFields) {
    return {
        syntax: syntax,
        json: $2d7d9af7a5367cf4$var$makeJsonFormat(),
        bin: $2d7d9af7a5367cf4$var$makeBinaryFormat(),
        util: Object.assign(Object.assign({}, $2d7d9af7a5367cf4$var$makeUtilCommon()), {
            newFieldList: newFieldList,
            initFields: initFields
        }),
        makeMessageType (typeName, fields, opt) {
            return $2d7d9af7a5367cf4$var$makeMessageType(this, typeName, fields, opt);
        },
        makeEnum: $2d7d9af7a5367cf4$var$makeEnum,
        makeEnumType: $2d7d9af7a5367cf4$var$makeEnumType,
        getEnumType: $2d7d9af7a5367cf4$var$getEnumType,
        makeExtension (typeName, extendee, field) {
            return $2d7d9af7a5367cf4$var$makeExtension(this, typeName, extendee, field);
        }
    };
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
class $2d7d9af7a5367cf4$var$InternalFieldList {
    constructor(fields, normalizer){
        this._fields = fields;
        this._normalizer = normalizer;
    }
    findJsonName(jsonName) {
        if (!this.jsonNames) {
            const t = {};
            for (const f of this.list())t[f.jsonName] = t[f.name] = f;
            this.jsonNames = t;
        }
        return this.jsonNames[jsonName];
    }
    find(fieldNo) {
        if (!this.numbers) {
            const t = {};
            for (const f of this.list())t[f.no] = f;
            this.numbers = t;
        }
        return this.numbers[fieldNo];
    }
    list() {
        if (!this.all) this.all = this._normalizer(this._fields);
        return this.all;
    }
    byNumber() {
        if (!this.numbersAsc) this.numbersAsc = this.list().concat().sort((a, b)=>a.no - b.no);
        return this.numbersAsc;
    }
    byMember() {
        if (!this.members) {
            this.members = [];
            const a = this.members;
            let o;
            for (const f of this.list()){
                if (f.oneof) {
                    if (f.oneof !== o) {
                        o = f.oneof;
                        a.push(o);
                    }
                } else a.push(f);
            }
        }
        return this.members;
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Returns the name of a protobuf element in generated code.
 *
 * Field names - including oneofs - are converted to lowerCamelCase. For
 * messages, enumerations and services, the package name is stripped from
 * the type name. For nested messages and enumerations, the names are joined
 * with an underscore. For methods, the first character is made lowercase.
 */ /**
 * Returns the name of a field in generated code.
 */ function $2d7d9af7a5367cf4$var$localFieldName(protoName, inOneof) {
    const name = $2d7d9af7a5367cf4$var$protoCamelCase(protoName);
    if (inOneof) // oneof member names are not properties, but values of the `case` property.
    return name;
    return $2d7d9af7a5367cf4$var$safeObjectProperty($2d7d9af7a5367cf4$var$safeMessageProperty(name));
}
/**
 * Returns the name of a oneof group in generated code.
 */ function $2d7d9af7a5367cf4$var$localOneofName(protoName) {
    return $2d7d9af7a5367cf4$var$localFieldName(protoName, false);
}
/**
 * Returns the JSON name for a protobuf field, exactly like protoc does.
 */ const $2d7d9af7a5367cf4$var$fieldJsonName = $2d7d9af7a5367cf4$var$protoCamelCase;
/**
 * Converts snake_case to protoCamelCase according to the convention
 * used by protoc to convert a field name to a JSON name.
 */ function $2d7d9af7a5367cf4$var$protoCamelCase(snakeCase) {
    let capNext = false;
    const b = [];
    for(let i = 0; i < snakeCase.length; i++){
        let c = snakeCase.charAt(i);
        switch(c){
            case "_":
                capNext = true;
                break;
            case "0":
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
                b.push(c);
                capNext = false;
                break;
            default:
                if (capNext) {
                    capNext = false;
                    c = c.toUpperCase();
                }
                b.push(c);
                break;
        }
    }
    return b.join("");
}
/**
 * Names that cannot be used for object properties because they are reserved
 * by built-in JavaScript properties.
 */ const $2d7d9af7a5367cf4$var$reservedObjectProperties = new Set([
    // names reserved by JavaScript
    "constructor",
    "toString",
    "toJSON",
    "valueOf"
]);
/**
 * Names that cannot be used for object properties because they are reserved
 * by the runtime.
 */ const $2d7d9af7a5367cf4$var$reservedMessageProperties = new Set([
    // names reserved by the runtime
    "getType",
    "clone",
    "equals",
    "fromBinary",
    "fromJson",
    "fromJsonString",
    "toBinary",
    "toJson",
    "toJsonString",
    // names reserved by the runtime for the future
    "toObject"
]);
const $2d7d9af7a5367cf4$var$fallback = (name)=>"".concat(name, "$");
/**
 * Will wrap names that are Object prototype properties or names reserved
 * for `Message`s.
 */ const $2d7d9af7a5367cf4$var$safeMessageProperty = (name)=>{
    if ($2d7d9af7a5367cf4$var$reservedMessageProperties.has(name)) return $2d7d9af7a5367cf4$var$fallback(name);
    return name;
};
/**
 * Names that cannot be used for object properties because they are reserved
 * by built-in JavaScript properties.
 */ const $2d7d9af7a5367cf4$var$safeObjectProperty = (name)=>{
    if ($2d7d9af7a5367cf4$var$reservedObjectProperties.has(name)) return $2d7d9af7a5367cf4$var$fallback(name);
    return name;
};
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
class $2d7d9af7a5367cf4$var$InternalOneofInfo {
    constructor(name){
        this.kind = "oneof";
        this.repeated = false;
        this.packed = false;
        this.opt = false;
        this.req = false;
        this.default = undefined;
        this.fields = [];
        this.name = name;
        this.localName = $2d7d9af7a5367cf4$var$localOneofName(name);
    }
    addField(field) {
        $2d7d9af7a5367cf4$var$assert(field.oneof === this, "field ".concat(field.name, " not one of ").concat(this.name));
        this.fields.push(field);
    }
    findField(localName) {
        if (!this._lookup) {
            this._lookup = Object.create(null);
            for(let i = 0; i < this.fields.length; i++)this._lookup[this.fields[i].localName] = this.fields[i];
        }
        return this._lookup[localName];
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Convert a collection of field info to an array of normalized FieldInfo.
 *
 * The argument `packedByDefault` specifies whether fields that do not specify
 * `packed` should be packed (proto3) or unpacked (proto2).
 */ function $2d7d9af7a5367cf4$var$normalizeFieldInfos(fieldInfos, packedByDefault) {
    var _a, _b, _c, _d, _e, _f;
    const r = [];
    let o;
    for (const field of typeof fieldInfos == "function" ? fieldInfos() : fieldInfos){
        const f = field;
        f.localName = $2d7d9af7a5367cf4$var$localFieldName(field.name, field.oneof !== undefined);
        f.jsonName = (_a = field.jsonName) !== null && _a !== void 0 ? _a : $2d7d9af7a5367cf4$var$fieldJsonName(field.name);
        f.repeated = (_b = field.repeated) !== null && _b !== void 0 ? _b : false;
        if (field.kind == "scalar") f.L = (_c = field.L) !== null && _c !== void 0 ? _c : $2d7d9af7a5367cf4$var$LongType.BIGINT;
        f.delimited = (_d = field.delimited) !== null && _d !== void 0 ? _d : false;
        f.req = (_e = field.req) !== null && _e !== void 0 ? _e : false;
        f.opt = (_f = field.opt) !== null && _f !== void 0 ? _f : false;
        if (field.packed === undefined) f.packed = field.kind == "enum" || field.kind == "scalar" && field.T != $2d7d9af7a5367cf4$var$ScalarType.BYTES && field.T != $2d7d9af7a5367cf4$var$ScalarType.STRING;
        // We do not surface options at this time
        // f.options = field.options ?? emptyReadonlyObject;
        if (field.oneof !== undefined) {
            const ooname = typeof field.oneof == "string" ? field.oneof : field.oneof.name;
            if (!o || o.name != ooname) o = new $2d7d9af7a5367cf4$var$InternalOneofInfo(ooname);
            f.oneof = o;
            o.addField(f);
        }
        r.push(f);
    }
    return r;
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Provides functionality for messages defined with the proto3 syntax.
 */ const $2d7d9af7a5367cf4$var$proto3 = $2d7d9af7a5367cf4$var$makeProtoRuntime("proto3", (fields)=>{
    return new $2d7d9af7a5367cf4$var$InternalFieldList(fields, (source)=>$2d7d9af7a5367cf4$var$normalizeFieldInfos(source));
}, // TODO merge with proto2 and initExtensionField, also see initPartial, equals, clone
(target)=>{
    for (const member of target.getType().fields.byMember()){
        if (member.opt) continue;
        const name = member.localName, t = target;
        if (member.repeated) {
            t[name] = [];
            continue;
        }
        switch(member.kind){
            case "oneof":
                t[name] = {
                    case: undefined
                };
                break;
            case "enum":
                t[name] = 0;
                break;
            case "map":
                t[name] = {};
                break;
            case "scalar":
                t[name] = $2d7d9af7a5367cf4$var$scalarZeroValue(member.T, member.L);
                break;
        }
    }
});
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * A Timestamp represents a point in time independent of any time zone or local
 * calendar, encoded as a count of seconds and fractions of seconds at
 * nanosecond resolution. The count is relative to an epoch at UTC midnight on
 * January 1, 1970, in the proleptic Gregorian calendar which extends the
 * Gregorian calendar backwards to year one.
 *
 * All minutes are 60 seconds long. Leap seconds are "smeared" so that no leap
 * second table is needed for interpretation, using a [24-hour linear
 * smear](https://developers.google.com/time/smear).
 *
 * The range is from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59.999999999Z. By
 * restricting to that range, we ensure that we can convert to and from [RFC
 * 3339](https://www.ietf.org/rfc/rfc3339.txt) date strings.
 *
 * # Examples
 *
 * Example 1: Compute Timestamp from POSIX `time()`.
 *
 *     Timestamp timestamp;
 *     timestamp.set_seconds(time(NULL));
 *     timestamp.set_nanos(0);
 *
 * Example 2: Compute Timestamp from POSIX `gettimeofday()`.
 *
 *     struct timeval tv;
 *     gettimeofday(&tv, NULL);
 *
 *     Timestamp timestamp;
 *     timestamp.set_seconds(tv.tv_sec);
 *     timestamp.set_nanos(tv.tv_usec * 1000);
 *
 * Example 3: Compute Timestamp from Win32 `GetSystemTimeAsFileTime()`.
 *
 *     FILETIME ft;
 *     GetSystemTimeAsFileTime(&ft);
 *     UINT64 ticks = (((UINT64)ft.dwHighDateTime) << 32) | ft.dwLowDateTime;
 *
 *     // A Windows tick is 100 nanoseconds. Windows epoch 1601-01-01T00:00:00Z
 *     // is 11644473600 seconds before Unix epoch 1970-01-01T00:00:00Z.
 *     Timestamp timestamp;
 *     timestamp.set_seconds((INT64) ((ticks / 10000000) - 11644473600LL));
 *     timestamp.set_nanos((INT32) ((ticks % 10000000) * 100));
 *
 * Example 4: Compute Timestamp from Java `System.currentTimeMillis()`.
 *
 *     long millis = System.currentTimeMillis();
 *
 *     Timestamp timestamp = Timestamp.newBuilder().setSeconds(millis / 1000)
 *         .setNanos((int) ((millis % 1000) * 1000000)).build();
 *
 * Example 5: Compute Timestamp from Java `Instant.now()`.
 *
 *     Instant now = Instant.now();
 *
 *     Timestamp timestamp =
 *         Timestamp.newBuilder().setSeconds(now.getEpochSecond())
 *             .setNanos(now.getNano()).build();
 *
 * Example 6: Compute Timestamp from current time in Python.
 *
 *     timestamp = Timestamp()
 *     timestamp.GetCurrentTime()
 *
 * # JSON Mapping
 *
 * In JSON format, the Timestamp type is encoded as a string in the
 * [RFC 3339](https://www.ietf.org/rfc/rfc3339.txt) format. That is, the
 * format is "{year}-{month}-{day}T{hour}:{min}:{sec}[.{frac_sec}]Z"
 * where {year} is always expressed using four digits while {month}, {day},
 * {hour}, {min}, and {sec} are zero-padded to two digits each. The fractional
 * seconds, which can go up to 9 digits (i.e. up to 1 nanosecond resolution),
 * are optional. The "Z" suffix indicates the timezone ("UTC"); the timezone
 * is required. A proto3 JSON serializer should always use UTC (as indicated by
 * "Z") when printing the Timestamp type and a proto3 JSON parser should be
 * able to accept both UTC and other timezones (as indicated by an offset).
 *
 * For example, "2017-01-15T01:30:15.01Z" encodes 15.01 seconds past
 * 01:30 UTC on January 15, 2017.
 *
 * In JavaScript, one can convert a Date object to this format using the
 * standard
 * [toISOString()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString)
 * method. In Python, a standard `datetime.datetime` object can be converted
 * to this format using
 * [`strftime`](https://docs.python.org/2/library/time.html#time.strftime) with
 * the time format spec '%Y-%m-%dT%H:%M:%S.%fZ'. Likewise, in Java, one can use
 * the Joda Time's [`ISODateTimeFormat.dateTime()`](
 * http://joda-time.sourceforge.net/apidocs/org/joda/time/format/ISODateTimeFormat.html#dateTime()
 * ) to obtain a formatter capable of generating timestamps in this format.
 *
 *
 * @generated from message google.protobuf.Timestamp
 */ class $2d7d9af7a5367cf4$var$Timestamp extends $2d7d9af7a5367cf4$var$Message {
    constructor(data){
        super();
        /**
     * Represents seconds of UTC time since Unix epoch
     * 1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     * 9999-12-31T23:59:59Z inclusive.
     *
     * @generated from field: int64 seconds = 1;
     */ this.seconds = $2d7d9af7a5367cf4$var$protoInt64.zero;
        /**
     * Non-negative fractions of a second at nanosecond resolution. Negative
     * second values with fractions must still have non-negative nanos values
     * that count forward in time. Must be from 0 to 999,999,999
     * inclusive.
     *
     * @generated from field: int32 nanos = 2;
     */ this.nanos = 0;
        $2d7d9af7a5367cf4$var$proto3.util.initPartial(data, this);
    }
    fromJson(json, options) {
        if (typeof json !== "string") throw new Error("cannot decode google.protobuf.Timestamp from JSON: ".concat($2d7d9af7a5367cf4$var$proto3.json.debug(json)));
        const matches = json.match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})(?:Z|\.([0-9]{3,9})Z|([+-][0-9][0-9]:[0-9][0-9]))$/);
        if (!matches) throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
        const ms = Date.parse(matches[1] + "-" + matches[2] + "-" + matches[3] + "T" + matches[4] + ":" + matches[5] + ":" + matches[6] + (matches[8] ? matches[8] : "Z"));
        if (Number.isNaN(ms)) throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
        if (ms < Date.parse("0001-01-01T00:00:00Z") || ms > Date.parse("9999-12-31T23:59:59Z")) throw new Error("cannot decode message google.protobuf.Timestamp from JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
        this.seconds = $2d7d9af7a5367cf4$var$protoInt64.parse(ms / 1000);
        this.nanos = 0;
        if (matches[7]) this.nanos = parseInt("1" + matches[7] + "0".repeat(9 - matches[7].length)) - 1000000000;
        return this;
    }
    toJson(options) {
        const ms = Number(this.seconds) * 1000;
        if (ms < Date.parse("0001-01-01T00:00:00Z") || ms > Date.parse("9999-12-31T23:59:59Z")) throw new Error("cannot encode google.protobuf.Timestamp to JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
        if (this.nanos < 0) throw new Error("cannot encode google.protobuf.Timestamp to JSON: nanos must not be negative");
        let z = "Z";
        if (this.nanos > 0) {
            const nanosStr = (this.nanos + 1000000000).toString().substring(1);
            if (nanosStr.substring(3) === "000000") z = "." + nanosStr.substring(0, 3) + "Z";
            else if (nanosStr.substring(6) === "000") z = "." + nanosStr.substring(0, 6) + "Z";
            else z = "." + nanosStr + "Z";
        }
        return new Date(ms).toISOString().replace(".000Z", z);
    }
    toDate() {
        return new Date(Number(this.seconds) * 1000 + Math.ceil(this.nanos / 1000000));
    }
    static now() {
        return $2d7d9af7a5367cf4$var$Timestamp.fromDate(new Date());
    }
    static fromDate(date) {
        const ms = date.getTime();
        return new $2d7d9af7a5367cf4$var$Timestamp({
            seconds: $2d7d9af7a5367cf4$var$protoInt64.parse(Math.floor(ms / 1000)),
            nanos: ms % 1000 * 1000000
        });
    }
    static fromBinary(bytes, options) {
        return new $2d7d9af7a5367cf4$var$Timestamp().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new $2d7d9af7a5367cf4$var$Timestamp().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new $2d7d9af7a5367cf4$var$Timestamp().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return $2d7d9af7a5367cf4$var$proto3.util.equals($2d7d9af7a5367cf4$var$Timestamp, a, b);
    }
}
$2d7d9af7a5367cf4$var$Timestamp.runtime = $2d7d9af7a5367cf4$var$proto3;
$2d7d9af7a5367cf4$var$Timestamp.typeName = "google.protobuf.Timestamp";
$2d7d9af7a5367cf4$var$Timestamp.fields = $2d7d9af7a5367cf4$var$proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seconds",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 2,
            name: "nanos",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]);
const $2d7d9af7a5367cf4$var$MetricsBatch = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.MetricsBatch", ()=>[
        {
            no: 1,
            name: "timestamp_ms",
            kind: "scalar",
            T: 3
        },
        {
            no: 2,
            name: "normalized_timestamp",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$Timestamp
        },
        {
            no: 3,
            name: "str_data",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 4,
            name: "time_series",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$TimeSeriesMetric,
            repeated: true
        },
        {
            no: 5,
            name: "events",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$EventMetric,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$TimeSeriesMetric = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.TimeSeriesMetric", ()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "participant_identity",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "track_sid",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "samples",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$MetricSample,
            repeated: true
        },
        {
            no: 5,
            name: "rid",
            kind: "scalar",
            T: 13
        }
    ]);
const $2d7d9af7a5367cf4$var$MetricSample = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.MetricSample", ()=>[
        {
            no: 1,
            name: "timestamp_ms",
            kind: "scalar",
            T: 3
        },
        {
            no: 2,
            name: "normalized_timestamp",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$Timestamp
        },
        {
            no: 3,
            name: "value",
            kind: "scalar",
            T: 2
        }
    ]);
const $2d7d9af7a5367cf4$var$EventMetric = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.EventMetric", ()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "participant_identity",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "track_sid",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "start_timestamp_ms",
            kind: "scalar",
            T: 3
        },
        {
            no: 5,
            name: "end_timestamp_ms",
            kind: "scalar",
            T: 3,
            opt: true
        },
        {
            no: 6,
            name: "normalized_start_timestamp",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$Timestamp
        },
        {
            no: 7,
            name: "normalized_end_timestamp",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$Timestamp,
            opt: true
        },
        {
            no: 8,
            name: "metadata",
            kind: "scalar",
            T: 9
        },
        {
            no: 9,
            name: "rid",
            kind: "scalar",
            T: 13
        }
    ]);
const $2d7d9af7a5367cf4$var$TrackType = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.TrackType", [
    {
        no: 0,
        name: "AUDIO"
    },
    {
        no: 1,
        name: "VIDEO"
    },
    {
        no: 2,
        name: "DATA"
    }
]);
const $2d7d9af7a5367cf4$var$TrackSource = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.TrackSource", [
    {
        no: 0,
        name: "UNKNOWN"
    },
    {
        no: 1,
        name: "CAMERA"
    },
    {
        no: 2,
        name: "MICROPHONE"
    },
    {
        no: 3,
        name: "SCREEN_SHARE"
    },
    {
        no: 4,
        name: "SCREEN_SHARE_AUDIO"
    }
]);
const $2d7d9af7a5367cf4$var$VideoQuality$1 = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.VideoQuality", [
    {
        no: 0,
        name: "LOW"
    },
    {
        no: 1,
        name: "MEDIUM"
    },
    {
        no: 2,
        name: "HIGH"
    },
    {
        no: 3,
        name: "OFF"
    }
]);
const $2d7d9af7a5367cf4$var$ConnectionQuality$1 = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.ConnectionQuality", [
    {
        no: 0,
        name: "POOR"
    },
    {
        no: 1,
        name: "GOOD"
    },
    {
        no: 2,
        name: "EXCELLENT"
    },
    {
        no: 3,
        name: "LOST"
    }
]);
const $2d7d9af7a5367cf4$var$ClientConfigSetting = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.ClientConfigSetting", [
    {
        no: 0,
        name: "UNSET"
    },
    {
        no: 1,
        name: "DISABLED"
    },
    {
        no: 2,
        name: "ENABLED"
    }
]);
const $2d7d9af7a5367cf4$export$258d16488300d83f = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.DisconnectReason", [
    {
        no: 0,
        name: "UNKNOWN_REASON"
    },
    {
        no: 1,
        name: "CLIENT_INITIATED"
    },
    {
        no: 2,
        name: "DUPLICATE_IDENTITY"
    },
    {
        no: 3,
        name: "SERVER_SHUTDOWN"
    },
    {
        no: 4,
        name: "PARTICIPANT_REMOVED"
    },
    {
        no: 5,
        name: "ROOM_DELETED"
    },
    {
        no: 6,
        name: "STATE_MISMATCH"
    },
    {
        no: 7,
        name: "JOIN_FAILURE"
    },
    {
        no: 8,
        name: "MIGRATION"
    },
    {
        no: 9,
        name: "SIGNAL_CLOSE"
    },
    {
        no: 10,
        name: "ROOM_CLOSED"
    },
    {
        no: 11,
        name: "USER_UNAVAILABLE"
    },
    {
        no: 12,
        name: "USER_REJECTED"
    },
    {
        no: 13,
        name: "SIP_TRUNK_FAILURE"
    }
]);
const $2d7d9af7a5367cf4$var$ReconnectReason = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.ReconnectReason", [
    {
        no: 0,
        name: "RR_UNKNOWN"
    },
    {
        no: 1,
        name: "RR_SIGNAL_DISCONNECTED"
    },
    {
        no: 2,
        name: "RR_PUBLISHER_FAILED"
    },
    {
        no: 3,
        name: "RR_SUBSCRIBER_FAILED"
    },
    {
        no: 4,
        name: "RR_SWITCH_CANDIDATE"
    }
]);
const $2d7d9af7a5367cf4$export$7882d1e2e5429abf = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.SubscriptionError", [
    {
        no: 0,
        name: "SE_UNKNOWN"
    },
    {
        no: 1,
        name: "SE_CODEC_UNSUPPORTED"
    },
    {
        no: 2,
        name: "SE_TRACK_NOTFOUND"
    }
]);
const $2d7d9af7a5367cf4$var$AudioTrackFeature = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.AudioTrackFeature", [
    {
        no: 0,
        name: "TF_STEREO"
    },
    {
        no: 1,
        name: "TF_NO_DTX"
    },
    {
        no: 2,
        name: "TF_AUTO_GAIN_CONTROL"
    },
    {
        no: 3,
        name: "TF_ECHO_CANCELLATION"
    },
    {
        no: 4,
        name: "TF_NOISE_SUPPRESSION"
    },
    {
        no: 5,
        name: "TF_ENHANCED_NOISE_CANCELLATION"
    }
]);
const $2d7d9af7a5367cf4$var$Room$1 = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.Room", ()=>[
        {
            no: 1,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "empty_timeout",
            kind: "scalar",
            T: 13
        },
        {
            no: 14,
            name: "departure_timeout",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "max_participants",
            kind: "scalar",
            T: 13
        },
        {
            no: 5,
            name: "creation_time",
            kind: "scalar",
            T: 3
        },
        {
            no: 6,
            name: "turn_password",
            kind: "scalar",
            T: 9
        },
        {
            no: 7,
            name: "enabled_codecs",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$Codec,
            repeated: true
        },
        {
            no: 8,
            name: "metadata",
            kind: "scalar",
            T: 9
        },
        {
            no: 9,
            name: "num_participants",
            kind: "scalar",
            T: 13
        },
        {
            no: 11,
            name: "num_publishers",
            kind: "scalar",
            T: 13
        },
        {
            no: 10,
            name: "active_recording",
            kind: "scalar",
            T: 8
        },
        {
            no: 13,
            name: "version",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$TimedVersion
        }
    ]);
const $2d7d9af7a5367cf4$var$Codec = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.Codec", ()=>[
        {
            no: 1,
            name: "mime",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "fmtp_line",
            kind: "scalar",
            T: 9
        }
    ]);
const $2d7d9af7a5367cf4$var$ParticipantPermission = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.ParticipantPermission", ()=>[
        {
            no: 1,
            name: "can_subscribe",
            kind: "scalar",
            T: 8
        },
        {
            no: 2,
            name: "can_publish",
            kind: "scalar",
            T: 8
        },
        {
            no: 3,
            name: "can_publish_data",
            kind: "scalar",
            T: 8
        },
        {
            no: 9,
            name: "can_publish_sources",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$TrackSource),
            repeated: true
        },
        {
            no: 7,
            name: "hidden",
            kind: "scalar",
            T: 8
        },
        {
            no: 8,
            name: "recorder",
            kind: "scalar",
            T: 8
        },
        {
            no: 10,
            name: "can_update_metadata",
            kind: "scalar",
            T: 8
        },
        {
            no: 11,
            name: "agent",
            kind: "scalar",
            T: 8
        },
        {
            no: 12,
            name: "can_subscribe_metrics",
            kind: "scalar",
            T: 8
        }
    ]);
const $2d7d9af7a5367cf4$var$ParticipantInfo = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.ParticipantInfo", ()=>[
        {
            no: 1,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "identity",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "state",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$ParticipantInfo_State)
        },
        {
            no: 4,
            name: "tracks",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$TrackInfo,
            repeated: true
        },
        {
            no: 5,
            name: "metadata",
            kind: "scalar",
            T: 9
        },
        {
            no: 6,
            name: "joined_at",
            kind: "scalar",
            T: 3
        },
        {
            no: 9,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 10,
            name: "version",
            kind: "scalar",
            T: 13
        },
        {
            no: 11,
            name: "permission",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ParticipantPermission
        },
        {
            no: 12,
            name: "region",
            kind: "scalar",
            T: 9
        },
        {
            no: 13,
            name: "is_publisher",
            kind: "scalar",
            T: 8
        },
        {
            no: 14,
            name: "kind",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$export$2079c0e1523aec29)
        },
        {
            no: 15,
            name: "attributes",
            kind: "map",
            K: 9,
            V: {
                kind: "scalar",
                T: 9
            }
        },
        {
            no: 16,
            name: "disconnect_reason",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$export$258d16488300d83f)
        }
    ]);
const $2d7d9af7a5367cf4$var$ParticipantInfo_State = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.ParticipantInfo.State", [
    {
        no: 0,
        name: "JOINING"
    },
    {
        no: 1,
        name: "JOINED"
    },
    {
        no: 2,
        name: "ACTIVE"
    },
    {
        no: 3,
        name: "DISCONNECTED"
    }
]);
const $2d7d9af7a5367cf4$export$2079c0e1523aec29 = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.ParticipantInfo.Kind", [
    {
        no: 0,
        name: "STANDARD"
    },
    {
        no: 1,
        name: "INGRESS"
    },
    {
        no: 2,
        name: "EGRESS"
    },
    {
        no: 3,
        name: "SIP"
    },
    {
        no: 4,
        name: "AGENT"
    }
]);
const $2d7d9af7a5367cf4$var$Encryption_Type = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.Encryption.Type", [
    {
        no: 0,
        name: "NONE"
    },
    {
        no: 1,
        name: "GCM"
    },
    {
        no: 2,
        name: "CUSTOM"
    }
]);
const $2d7d9af7a5367cf4$var$SimulcastCodecInfo = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SimulcastCodecInfo", ()=>[
        {
            no: 1,
            name: "mime_type",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "mid",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "cid",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "layers",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$VideoLayer,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$TrackInfo = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.TrackInfo", ()=>[
        {
            no: 1,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "type",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$TrackType)
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "muted",
            kind: "scalar",
            T: 8
        },
        {
            no: 5,
            name: "width",
            kind: "scalar",
            T: 13
        },
        {
            no: 6,
            name: "height",
            kind: "scalar",
            T: 13
        },
        {
            no: 7,
            name: "simulcast",
            kind: "scalar",
            T: 8
        },
        {
            no: 8,
            name: "disable_dtx",
            kind: "scalar",
            T: 8
        },
        {
            no: 9,
            name: "source",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$TrackSource)
        },
        {
            no: 10,
            name: "layers",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$VideoLayer,
            repeated: true
        },
        {
            no: 11,
            name: "mime_type",
            kind: "scalar",
            T: 9
        },
        {
            no: 12,
            name: "mid",
            kind: "scalar",
            T: 9
        },
        {
            no: 13,
            name: "codecs",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SimulcastCodecInfo,
            repeated: true
        },
        {
            no: 14,
            name: "stereo",
            kind: "scalar",
            T: 8
        },
        {
            no: 15,
            name: "disable_red",
            kind: "scalar",
            T: 8
        },
        {
            no: 16,
            name: "encryption",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$Encryption_Type)
        },
        {
            no: 17,
            name: "stream",
            kind: "scalar",
            T: 9
        },
        {
            no: 18,
            name: "version",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$TimedVersion
        },
        {
            no: 19,
            name: "audio_features",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$AudioTrackFeature),
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$VideoLayer = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.VideoLayer", ()=>[
        {
            no: 1,
            name: "quality",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$VideoQuality$1)
        },
        {
            no: 2,
            name: "width",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "height",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "bitrate",
            kind: "scalar",
            T: 13
        },
        {
            no: 5,
            name: "ssrc",
            kind: "scalar",
            T: 13
        }
    ]);
const $2d7d9af7a5367cf4$var$DataPacket = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.DataPacket", ()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6)
        },
        {
            no: 4,
            name: "participant_identity",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "destination_identities",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 2,
            name: "user",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$UserPacket,
            oneof: "value"
        },
        {
            no: 3,
            name: "speaker",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ActiveSpeakerUpdate,
            oneof: "value"
        },
        {
            no: 6,
            name: "sip_dtmf",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SipDTMF,
            oneof: "value"
        },
        {
            no: 7,
            name: "transcription",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$Transcription,
            oneof: "value"
        },
        {
            no: 8,
            name: "metrics",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$MetricsBatch,
            oneof: "value"
        },
        {
            no: 9,
            name: "chat_message",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ChatMessage,
            oneof: "value"
        },
        {
            no: 10,
            name: "rpc_request",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$RpcRequest,
            oneof: "value"
        },
        {
            no: 11,
            name: "rpc_ack",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$RpcAck,
            oneof: "value"
        },
        {
            no: 12,
            name: "rpc_response",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$RpcResponse,
            oneof: "value"
        },
        {
            no: 13,
            name: "stream_header",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$DataStream_Header,
            oneof: "value"
        },
        {
            no: 14,
            name: "stream_chunk",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$DataStream_Chunk,
            oneof: "value"
        }
    ]);
const $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6 = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.DataPacket.Kind", [
    {
        no: 0,
        name: "RELIABLE"
    },
    {
        no: 1,
        name: "LOSSY"
    }
]);
const $2d7d9af7a5367cf4$var$ActiveSpeakerUpdate = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.ActiveSpeakerUpdate", ()=>[
        {
            no: 1,
            name: "speakers",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SpeakerInfo,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$SpeakerInfo = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SpeakerInfo", ()=>[
        {
            no: 1,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "level",
            kind: "scalar",
            T: 2
        },
        {
            no: 3,
            name: "active",
            kind: "scalar",
            T: 8
        }
    ]);
const $2d7d9af7a5367cf4$var$UserPacket = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.UserPacket", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "participant_identity",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "payload",
            kind: "scalar",
            T: 12
        },
        {
            no: 3,
            name: "destination_sids",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 6,
            name: "destination_identities",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 4,
            name: "topic",
            kind: "scalar",
            T: 9,
            opt: true
        },
        {
            no: 8,
            name: "id",
            kind: "scalar",
            T: 9,
            opt: true
        },
        {
            no: 9,
            name: "start_time",
            kind: "scalar",
            T: 4,
            opt: true
        },
        {
            no: 10,
            name: "end_time",
            kind: "scalar",
            T: 4,
            opt: true
        }
    ]);
const $2d7d9af7a5367cf4$var$SipDTMF = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SipDTMF", ()=>[
        {
            no: 3,
            name: "code",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "digit",
            kind: "scalar",
            T: 9
        }
    ]);
const $2d7d9af7a5367cf4$var$Transcription = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.Transcription", ()=>[
        {
            no: 2,
            name: "transcribed_participant_identity",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "track_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "segments",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$TranscriptionSegment,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$TranscriptionSegment = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.TranscriptionSegment", ()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "text",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "start_time",
            kind: "scalar",
            T: 4
        },
        {
            no: 4,
            name: "end_time",
            kind: "scalar",
            T: 4
        },
        {
            no: 5,
            name: "final",
            kind: "scalar",
            T: 8
        },
        {
            no: 6,
            name: "language",
            kind: "scalar",
            T: 9
        }
    ]);
const $2d7d9af7a5367cf4$var$ChatMessage = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.ChatMessage", ()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "timestamp",
            kind: "scalar",
            T: 3
        },
        {
            no: 3,
            name: "edit_timestamp",
            kind: "scalar",
            T: 3,
            opt: true
        },
        {
            no: 4,
            name: "message",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "deleted",
            kind: "scalar",
            T: 8
        },
        {
            no: 6,
            name: "generated",
            kind: "scalar",
            T: 8
        }
    ]);
const $2d7d9af7a5367cf4$var$RpcRequest = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.RpcRequest", ()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "method",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "payload",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "response_timeout_ms",
            kind: "scalar",
            T: 13
        },
        {
            no: 5,
            name: "version",
            kind: "scalar",
            T: 13
        }
    ]);
const $2d7d9af7a5367cf4$var$RpcAck = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.RpcAck", ()=>[
        {
            no: 1,
            name: "request_id",
            kind: "scalar",
            T: 9
        }
    ]);
const $2d7d9af7a5367cf4$var$RpcResponse = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.RpcResponse", ()=>[
        {
            no: 1,
            name: "request_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "payload",
            kind: "scalar",
            T: 9,
            oneof: "value"
        },
        {
            no: 3,
            name: "error",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$RpcError$1,
            oneof: "value"
        }
    ]);
const $2d7d9af7a5367cf4$var$RpcError$1 = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.RpcError", ()=>[
        {
            no: 1,
            name: "code",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "message",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "data",
            kind: "scalar",
            T: 9
        }
    ]);
const $2d7d9af7a5367cf4$var$ParticipantTracks = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.ParticipantTracks", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "track_sids",
            kind: "scalar",
            T: 9,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$ServerInfo = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.ServerInfo", ()=>[
        {
            no: 1,
            name: "edition",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$ServerInfo_Edition)
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "protocol",
            kind: "scalar",
            T: 5
        },
        {
            no: 4,
            name: "region",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "node_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 6,
            name: "debug_info",
            kind: "scalar",
            T: 9
        },
        {
            no: 7,
            name: "agent_protocol",
            kind: "scalar",
            T: 5
        }
    ]);
const $2d7d9af7a5367cf4$var$ServerInfo_Edition = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.ServerInfo.Edition", [
    {
        no: 0,
        name: "Standard"
    },
    {
        no: 1,
        name: "Cloud"
    }
]);
const $2d7d9af7a5367cf4$var$ClientInfo = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.ClientInfo", ()=>[
        {
            no: 1,
            name: "sdk",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$ClientInfo_SDK)
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "protocol",
            kind: "scalar",
            T: 5
        },
        {
            no: 4,
            name: "os",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "os_version",
            kind: "scalar",
            T: 9
        },
        {
            no: 6,
            name: "device_model",
            kind: "scalar",
            T: 9
        },
        {
            no: 7,
            name: "browser",
            kind: "scalar",
            T: 9
        },
        {
            no: 8,
            name: "browser_version",
            kind: "scalar",
            T: 9
        },
        {
            no: 9,
            name: "address",
            kind: "scalar",
            T: 9
        },
        {
            no: 10,
            name: "network",
            kind: "scalar",
            T: 9
        },
        {
            no: 11,
            name: "other_sdks",
            kind: "scalar",
            T: 9
        }
    ]);
const $2d7d9af7a5367cf4$var$ClientInfo_SDK = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.ClientInfo.SDK", [
    {
        no: 0,
        name: "UNKNOWN"
    },
    {
        no: 1,
        name: "JS"
    },
    {
        no: 2,
        name: "SWIFT"
    },
    {
        no: 3,
        name: "ANDROID"
    },
    {
        no: 4,
        name: "FLUTTER"
    },
    {
        no: 5,
        name: "GO"
    },
    {
        no: 6,
        name: "UNITY"
    },
    {
        no: 7,
        name: "REACT_NATIVE"
    },
    {
        no: 8,
        name: "RUST"
    },
    {
        no: 9,
        name: "PYTHON"
    },
    {
        no: 10,
        name: "CPP"
    },
    {
        no: 11,
        name: "UNITY_WEB"
    },
    {
        no: 12,
        name: "NODE"
    }
]);
const $2d7d9af7a5367cf4$var$ClientConfiguration = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.ClientConfiguration", ()=>[
        {
            no: 1,
            name: "video",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$VideoConfiguration
        },
        {
            no: 2,
            name: "screen",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$VideoConfiguration
        },
        {
            no: 3,
            name: "resume_connection",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$ClientConfigSetting)
        },
        {
            no: 4,
            name: "disabled_codecs",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$DisabledCodecs
        },
        {
            no: 5,
            name: "force_relay",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$ClientConfigSetting)
        }
    ]);
const $2d7d9af7a5367cf4$var$VideoConfiguration = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.VideoConfiguration", ()=>[
        {
            no: 1,
            name: "hardware_encoder",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$ClientConfigSetting)
        }
    ]);
const $2d7d9af7a5367cf4$var$DisabledCodecs = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.DisabledCodecs", ()=>[
        {
            no: 1,
            name: "codecs",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$Codec,
            repeated: true
        },
        {
            no: 2,
            name: "publish",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$Codec,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$TimedVersion = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.TimedVersion", ()=>[
        {
            no: 1,
            name: "unix_micro",
            kind: "scalar",
            T: 3
        },
        {
            no: 2,
            name: "ticks",
            kind: "scalar",
            T: 5
        }
    ]);
const $2d7d9af7a5367cf4$var$DataStream_OperationType = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.DataStream.OperationType", [
    {
        no: 0,
        name: "CREATE"
    },
    {
        no: 1,
        name: "UPDATE"
    },
    {
        no: 2,
        name: "DELETE"
    },
    {
        no: 3,
        name: "REACTION"
    }
]);
const $2d7d9af7a5367cf4$var$DataStream_TextHeader = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.DataStream.TextHeader", ()=>[
        {
            no: 1,
            name: "operation_type",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$DataStream_OperationType)
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5
        },
        {
            no: 3,
            name: "reply_to_stream_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "attached_stream_ids",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 5,
            name: "generated",
            kind: "scalar",
            T: 8
        }
    ], {
    localName: "DataStream_TextHeader"
});
const $2d7d9af7a5367cf4$var$DataStream_FileHeader = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.DataStream.FileHeader", ()=>[
        {
            no: 1,
            name: "file_name",
            kind: "scalar",
            T: 9
        }
    ], {
    localName: "DataStream_FileHeader"
});
const $2d7d9af7a5367cf4$var$DataStream_Header = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.DataStream.Header", ()=>[
        {
            no: 1,
            name: "stream_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "timestamp",
            kind: "scalar",
            T: 3
        },
        {
            no: 3,
            name: "topic",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "mime_type",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "total_length",
            kind: "scalar",
            T: 4,
            opt: true
        },
        {
            no: 6,
            name: "total_chunks",
            kind: "scalar",
            T: 4,
            opt: true
        },
        {
            no: 7,
            name: "encryption_type",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$Encryption_Type)
        },
        {
            no: 8,
            name: "extensions",
            kind: "map",
            K: 9,
            V: {
                kind: "scalar",
                T: 9
            }
        },
        {
            no: 9,
            name: "text_header",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$DataStream_TextHeader,
            oneof: "content_header"
        },
        {
            no: 10,
            name: "file_header",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$DataStream_FileHeader,
            oneof: "content_header"
        }
    ], {
    localName: "DataStream_Header"
});
const $2d7d9af7a5367cf4$var$DataStream_Chunk = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.DataStream.Chunk", ()=>[
        {
            no: 1,
            name: "stream_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "chunk_index",
            kind: "scalar",
            T: 4
        },
        {
            no: 3,
            name: "content",
            kind: "scalar",
            T: 12
        },
        {
            no: 4,
            name: "complete",
            kind: "scalar",
            T: 8
        },
        {
            no: 5,
            name: "version",
            kind: "scalar",
            T: 5
        },
        {
            no: 6,
            name: "iv",
            kind: "scalar",
            T: 12,
            opt: true
        }
    ], {
    localName: "DataStream_Chunk"
});
const $2d7d9af7a5367cf4$var$SignalTarget = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.SignalTarget", [
    {
        no: 0,
        name: "PUBLISHER"
    },
    {
        no: 1,
        name: "SUBSCRIBER"
    }
]);
const $2d7d9af7a5367cf4$var$StreamState = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.StreamState", [
    {
        no: 0,
        name: "ACTIVE"
    },
    {
        no: 1,
        name: "PAUSED"
    }
]);
const $2d7d9af7a5367cf4$var$CandidateProtocol = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.CandidateProtocol", [
    {
        no: 0,
        name: "UDP"
    },
    {
        no: 1,
        name: "TCP"
    },
    {
        no: 2,
        name: "TLS"
    }
]);
const $2d7d9af7a5367cf4$var$SignalRequest = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SignalRequest", ()=>[
        {
            no: 1,
            name: "offer",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SessionDescription,
            oneof: "message"
        },
        {
            no: 2,
            name: "answer",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SessionDescription,
            oneof: "message"
        },
        {
            no: 3,
            name: "trickle",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$TrickleRequest,
            oneof: "message"
        },
        {
            no: 4,
            name: "add_track",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$AddTrackRequest,
            oneof: "message"
        },
        {
            no: 5,
            name: "mute",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$MuteTrackRequest,
            oneof: "message"
        },
        {
            no: 6,
            name: "subscription",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$UpdateSubscription,
            oneof: "message"
        },
        {
            no: 7,
            name: "track_setting",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$UpdateTrackSettings,
            oneof: "message"
        },
        {
            no: 8,
            name: "leave",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$LeaveRequest,
            oneof: "message"
        },
        {
            no: 10,
            name: "update_layers",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$UpdateVideoLayers,
            oneof: "message"
        },
        {
            no: 11,
            name: "subscription_permission",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SubscriptionPermission,
            oneof: "message"
        },
        {
            no: 12,
            name: "sync_state",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SyncState,
            oneof: "message"
        },
        {
            no: 13,
            name: "simulate",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SimulateScenario,
            oneof: "message"
        },
        {
            no: 14,
            name: "ping",
            kind: "scalar",
            T: 3,
            oneof: "message"
        },
        {
            no: 15,
            name: "update_metadata",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$UpdateParticipantMetadata,
            oneof: "message"
        },
        {
            no: 16,
            name: "ping_req",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$Ping,
            oneof: "message"
        },
        {
            no: 17,
            name: "update_audio_track",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$UpdateLocalAudioTrack,
            oneof: "message"
        },
        {
            no: 18,
            name: "update_video_track",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$UpdateLocalVideoTrack,
            oneof: "message"
        }
    ]);
const $2d7d9af7a5367cf4$var$SignalResponse = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SignalResponse", ()=>[
        {
            no: 1,
            name: "join",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$JoinResponse,
            oneof: "message"
        },
        {
            no: 2,
            name: "answer",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SessionDescription,
            oneof: "message"
        },
        {
            no: 3,
            name: "offer",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SessionDescription,
            oneof: "message"
        },
        {
            no: 4,
            name: "trickle",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$TrickleRequest,
            oneof: "message"
        },
        {
            no: 5,
            name: "update",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ParticipantUpdate,
            oneof: "message"
        },
        {
            no: 6,
            name: "track_published",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$TrackPublishedResponse,
            oneof: "message"
        },
        {
            no: 8,
            name: "leave",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$LeaveRequest,
            oneof: "message"
        },
        {
            no: 9,
            name: "mute",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$MuteTrackRequest,
            oneof: "message"
        },
        {
            no: 10,
            name: "speakers_changed",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SpeakersChanged,
            oneof: "message"
        },
        {
            no: 11,
            name: "room_update",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$RoomUpdate,
            oneof: "message"
        },
        {
            no: 12,
            name: "connection_quality",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ConnectionQualityUpdate,
            oneof: "message"
        },
        {
            no: 13,
            name: "stream_state_update",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$StreamStateUpdate,
            oneof: "message"
        },
        {
            no: 14,
            name: "subscribed_quality_update",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SubscribedQualityUpdate,
            oneof: "message"
        },
        {
            no: 15,
            name: "subscription_permission_update",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SubscriptionPermissionUpdate,
            oneof: "message"
        },
        {
            no: 16,
            name: "refresh_token",
            kind: "scalar",
            T: 9,
            oneof: "message"
        },
        {
            no: 17,
            name: "track_unpublished",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$TrackUnpublishedResponse,
            oneof: "message"
        },
        {
            no: 18,
            name: "pong",
            kind: "scalar",
            T: 3,
            oneof: "message"
        },
        {
            no: 19,
            name: "reconnect",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ReconnectResponse,
            oneof: "message"
        },
        {
            no: 20,
            name: "pong_resp",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$Pong,
            oneof: "message"
        },
        {
            no: 21,
            name: "subscription_response",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SubscriptionResponse,
            oneof: "message"
        },
        {
            no: 22,
            name: "request_response",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$RequestResponse,
            oneof: "message"
        },
        {
            no: 23,
            name: "track_subscribed",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$TrackSubscribed,
            oneof: "message"
        }
    ]);
const $2d7d9af7a5367cf4$var$SimulcastCodec = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SimulcastCodec", ()=>[
        {
            no: 1,
            name: "codec",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "cid",
            kind: "scalar",
            T: 9
        }
    ]);
const $2d7d9af7a5367cf4$var$AddTrackRequest = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.AddTrackRequest", ()=>[
        {
            no: 1,
            name: "cid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "type",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$TrackType)
        },
        {
            no: 4,
            name: "width",
            kind: "scalar",
            T: 13
        },
        {
            no: 5,
            name: "height",
            kind: "scalar",
            T: 13
        },
        {
            no: 6,
            name: "muted",
            kind: "scalar",
            T: 8
        },
        {
            no: 7,
            name: "disable_dtx",
            kind: "scalar",
            T: 8
        },
        {
            no: 8,
            name: "source",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$TrackSource)
        },
        {
            no: 9,
            name: "layers",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$VideoLayer,
            repeated: true
        },
        {
            no: 10,
            name: "simulcast_codecs",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SimulcastCodec,
            repeated: true
        },
        {
            no: 11,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 12,
            name: "stereo",
            kind: "scalar",
            T: 8
        },
        {
            no: 13,
            name: "disable_red",
            kind: "scalar",
            T: 8
        },
        {
            no: 14,
            name: "encryption",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$Encryption_Type)
        },
        {
            no: 15,
            name: "stream",
            kind: "scalar",
            T: 9
        }
    ]);
const $2d7d9af7a5367cf4$var$TrickleRequest = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.TrickleRequest", ()=>[
        {
            no: 1,
            name: "candidateInit",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "target",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$SignalTarget)
        },
        {
            no: 3,
            name: "final",
            kind: "scalar",
            T: 8
        }
    ]);
const $2d7d9af7a5367cf4$var$MuteTrackRequest = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.MuteTrackRequest", ()=>[
        {
            no: 1,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "muted",
            kind: "scalar",
            T: 8
        }
    ]);
const $2d7d9af7a5367cf4$var$JoinResponse = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.JoinResponse", ()=>[
        {
            no: 1,
            name: "room",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$Room$1
        },
        {
            no: 2,
            name: "participant",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ParticipantInfo
        },
        {
            no: 3,
            name: "other_participants",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ParticipantInfo,
            repeated: true
        },
        {
            no: 4,
            name: "server_version",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "ice_servers",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ICEServer,
            repeated: true
        },
        {
            no: 6,
            name: "subscriber_primary",
            kind: "scalar",
            T: 8
        },
        {
            no: 7,
            name: "alternative_url",
            kind: "scalar",
            T: 9
        },
        {
            no: 8,
            name: "client_configuration",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ClientConfiguration
        },
        {
            no: 9,
            name: "server_region",
            kind: "scalar",
            T: 9
        },
        {
            no: 10,
            name: "ping_timeout",
            kind: "scalar",
            T: 5
        },
        {
            no: 11,
            name: "ping_interval",
            kind: "scalar",
            T: 5
        },
        {
            no: 12,
            name: "server_info",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ServerInfo
        },
        {
            no: 13,
            name: "sif_trailer",
            kind: "scalar",
            T: 12
        },
        {
            no: 14,
            name: "enabled_publish_codecs",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$Codec,
            repeated: true
        },
        {
            no: 15,
            name: "fast_publish",
            kind: "scalar",
            T: 8
        }
    ]);
const $2d7d9af7a5367cf4$var$ReconnectResponse = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.ReconnectResponse", ()=>[
        {
            no: 1,
            name: "ice_servers",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ICEServer,
            repeated: true
        },
        {
            no: 2,
            name: "client_configuration",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ClientConfiguration
        }
    ]);
const $2d7d9af7a5367cf4$var$TrackPublishedResponse = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.TrackPublishedResponse", ()=>[
        {
            no: 1,
            name: "cid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "track",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$TrackInfo
        }
    ]);
const $2d7d9af7a5367cf4$var$TrackUnpublishedResponse = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.TrackUnpublishedResponse", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        }
    ]);
const $2d7d9af7a5367cf4$var$SessionDescription = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SessionDescription", ()=>[
        {
            no: 1,
            name: "type",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "sdp",
            kind: "scalar",
            T: 9
        }
    ]);
const $2d7d9af7a5367cf4$var$ParticipantUpdate = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.ParticipantUpdate", ()=>[
        {
            no: 1,
            name: "participants",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ParticipantInfo,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$UpdateSubscription = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.UpdateSubscription", ()=>[
        {
            no: 1,
            name: "track_sids",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 2,
            name: "subscribe",
            kind: "scalar",
            T: 8
        },
        {
            no: 3,
            name: "participant_tracks",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ParticipantTracks,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$UpdateTrackSettings = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.UpdateTrackSettings", ()=>[
        {
            no: 1,
            name: "track_sids",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 3,
            name: "disabled",
            kind: "scalar",
            T: 8
        },
        {
            no: 4,
            name: "quality",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$VideoQuality$1)
        },
        {
            no: 5,
            name: "width",
            kind: "scalar",
            T: 13
        },
        {
            no: 6,
            name: "height",
            kind: "scalar",
            T: 13
        },
        {
            no: 7,
            name: "fps",
            kind: "scalar",
            T: 13
        },
        {
            no: 8,
            name: "priority",
            kind: "scalar",
            T: 13
        }
    ]);
const $2d7d9af7a5367cf4$var$UpdateLocalAudioTrack = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.UpdateLocalAudioTrack", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "features",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$AudioTrackFeature),
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$UpdateLocalVideoTrack = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.UpdateLocalVideoTrack", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "width",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "height",
            kind: "scalar",
            T: 13
        }
    ]);
const $2d7d9af7a5367cf4$var$LeaveRequest = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.LeaveRequest", ()=>[
        {
            no: 1,
            name: "can_reconnect",
            kind: "scalar",
            T: 8
        },
        {
            no: 2,
            name: "reason",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$export$258d16488300d83f)
        },
        {
            no: 3,
            name: "action",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$LeaveRequest_Action)
        },
        {
            no: 4,
            name: "regions",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$RegionSettings
        }
    ]);
const $2d7d9af7a5367cf4$var$LeaveRequest_Action = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.LeaveRequest.Action", [
    {
        no: 0,
        name: "DISCONNECT"
    },
    {
        no: 1,
        name: "RESUME"
    },
    {
        no: 2,
        name: "RECONNECT"
    }
]);
const $2d7d9af7a5367cf4$var$UpdateVideoLayers = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.UpdateVideoLayers", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "layers",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$VideoLayer,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$UpdateParticipantMetadata = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.UpdateParticipantMetadata", ()=>[
        {
            no: 1,
            name: "metadata",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "attributes",
            kind: "map",
            K: 9,
            V: {
                kind: "scalar",
                T: 9
            }
        },
        {
            no: 4,
            name: "request_id",
            kind: "scalar",
            T: 13
        }
    ]);
const $2d7d9af7a5367cf4$var$ICEServer = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.ICEServer", ()=>[
        {
            no: 1,
            name: "urls",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 2,
            name: "username",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "credential",
            kind: "scalar",
            T: 9
        }
    ]);
const $2d7d9af7a5367cf4$var$SpeakersChanged = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SpeakersChanged", ()=>[
        {
            no: 1,
            name: "speakers",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SpeakerInfo,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$RoomUpdate = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.RoomUpdate", ()=>[
        {
            no: 1,
            name: "room",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$Room$1
        }
    ]);
const $2d7d9af7a5367cf4$var$ConnectionQualityInfo = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.ConnectionQualityInfo", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "quality",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$ConnectionQuality$1)
        },
        {
            no: 3,
            name: "score",
            kind: "scalar",
            T: 2
        }
    ]);
const $2d7d9af7a5367cf4$var$ConnectionQualityUpdate = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.ConnectionQualityUpdate", ()=>[
        {
            no: 1,
            name: "updates",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$ConnectionQualityInfo,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$StreamStateInfo = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.StreamStateInfo", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "state",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$StreamState)
        }
    ]);
const $2d7d9af7a5367cf4$var$StreamStateUpdate = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.StreamStateUpdate", ()=>[
        {
            no: 1,
            name: "stream_states",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$StreamStateInfo,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$SubscribedQuality = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SubscribedQuality", ()=>[
        {
            no: 1,
            name: "quality",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$VideoQuality$1)
        },
        {
            no: 2,
            name: "enabled",
            kind: "scalar",
            T: 8
        }
    ]);
const $2d7d9af7a5367cf4$var$SubscribedCodec = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SubscribedCodec", ()=>[
        {
            no: 1,
            name: "codec",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "qualities",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SubscribedQuality,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$SubscribedQualityUpdate = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SubscribedQualityUpdate", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "subscribed_qualities",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SubscribedQuality,
            repeated: true
        },
        {
            no: 3,
            name: "subscribed_codecs",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SubscribedCodec,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$TrackPermission = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.TrackPermission", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "all_tracks",
            kind: "scalar",
            T: 8
        },
        {
            no: 3,
            name: "track_sids",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 4,
            name: "participant_identity",
            kind: "scalar",
            T: 9
        }
    ]);
const $2d7d9af7a5367cf4$var$SubscriptionPermission = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SubscriptionPermission", ()=>[
        {
            no: 1,
            name: "all_participants",
            kind: "scalar",
            T: 8
        },
        {
            no: 2,
            name: "track_permissions",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$TrackPermission,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$SubscriptionPermissionUpdate = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SubscriptionPermissionUpdate", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "allowed",
            kind: "scalar",
            T: 8
        }
    ]);
const $2d7d9af7a5367cf4$var$SyncState = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SyncState", ()=>[
        {
            no: 1,
            name: "answer",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SessionDescription
        },
        {
            no: 2,
            name: "subscription",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$UpdateSubscription
        },
        {
            no: 3,
            name: "publish_tracks",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$TrackPublishedResponse,
            repeated: true
        },
        {
            no: 4,
            name: "data_channels",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$DataChannelInfo,
            repeated: true
        },
        {
            no: 5,
            name: "offer",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$SessionDescription
        },
        {
            no: 6,
            name: "track_sids_disabled",
            kind: "scalar",
            T: 9,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$DataChannelInfo = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.DataChannelInfo", ()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "target",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$SignalTarget)
        }
    ]);
const $2d7d9af7a5367cf4$var$SimulateScenario = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SimulateScenario", ()=>[
        {
            no: 1,
            name: "speaker_update",
            kind: "scalar",
            T: 5,
            oneof: "scenario"
        },
        {
            no: 2,
            name: "node_failure",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        },
        {
            no: 3,
            name: "migration",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        },
        {
            no: 4,
            name: "server_leave",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        },
        {
            no: 5,
            name: "switch_candidate_protocol",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$CandidateProtocol),
            oneof: "scenario"
        },
        {
            no: 6,
            name: "subscriber_bandwidth",
            kind: "scalar",
            T: 3,
            oneof: "scenario"
        },
        {
            no: 7,
            name: "disconnect_signal_on_resume",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        },
        {
            no: 8,
            name: "disconnect_signal_on_resume_no_messages",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        },
        {
            no: 9,
            name: "leave_request_full_reconnect",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        }
    ]);
const $2d7d9af7a5367cf4$var$Ping = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.Ping", ()=>[
        {
            no: 1,
            name: "timestamp",
            kind: "scalar",
            T: 3
        },
        {
            no: 2,
            name: "rtt",
            kind: "scalar",
            T: 3
        }
    ]);
const $2d7d9af7a5367cf4$var$Pong = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.Pong", ()=>[
        {
            no: 1,
            name: "last_ping_timestamp",
            kind: "scalar",
            T: 3
        },
        {
            no: 2,
            name: "timestamp",
            kind: "scalar",
            T: 3
        }
    ]);
const $2d7d9af7a5367cf4$var$RegionSettings = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.RegionSettings", ()=>[
        {
            no: 1,
            name: "regions",
            kind: "message",
            T: $2d7d9af7a5367cf4$var$RegionInfo,
            repeated: true
        }
    ]);
const $2d7d9af7a5367cf4$var$RegionInfo = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.RegionInfo", ()=>[
        {
            no: 1,
            name: "region",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "url",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "distance",
            kind: "scalar",
            T: 3
        }
    ]);
const $2d7d9af7a5367cf4$var$SubscriptionResponse = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.SubscriptionResponse", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "err",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$export$7882d1e2e5429abf)
        }
    ]);
const $2d7d9af7a5367cf4$var$RequestResponse = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.RequestResponse", ()=>[
        {
            no: 1,
            name: "request_id",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "reason",
            kind: "enum",
            T: $2d7d9af7a5367cf4$var$proto3.getEnumType($2d7d9af7a5367cf4$var$RequestResponse_Reason)
        },
        {
            no: 3,
            name: "message",
            kind: "scalar",
            T: 9
        }
    ]);
const $2d7d9af7a5367cf4$var$RequestResponse_Reason = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeEnum("livekit.RequestResponse.Reason", [
    {
        no: 0,
        name: "OK"
    },
    {
        no: 1,
        name: "NOT_FOUND"
    },
    {
        no: 2,
        name: "NOT_ALLOWED"
    },
    {
        no: 3,
        name: "LIMIT_EXCEEDED"
    }
]);
const $2d7d9af7a5367cf4$var$TrackSubscribed = /* @__PURE__ */ $2d7d9af7a5367cf4$var$proto3.makeMessageType("livekit.TrackSubscribed", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        }
    ]);
function $2d7d9af7a5367cf4$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $2d7d9af7a5367cf4$var$loglevel$1 = {
    exports: {}
};
/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/ var $2d7d9af7a5367cf4$var$loglevel = $2d7d9af7a5367cf4$var$loglevel$1.exports;
var $2d7d9af7a5367cf4$var$hasRequiredLoglevel;
function $2d7d9af7a5367cf4$var$requireLoglevel() {
    if ($2d7d9af7a5367cf4$var$hasRequiredLoglevel) return $2d7d9af7a5367cf4$var$loglevel$1.exports;
    $2d7d9af7a5367cf4$var$hasRequiredLoglevel = 1;
    (function(module) {
        (function(root, definition) {
            if (module.exports) module.exports = definition();
            else root.log = definition();
        })($2d7d9af7a5367cf4$var$loglevel, function() {
            // Slightly dubious tricks to cut down minimized file size
            var noop = function() {};
            var undefinedType = "undefined";
            var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
            var logMethods = [
                "trace",
                "debug",
                "info",
                "warn",
                "error"
            ];
            var _loggersByName = {};
            var defaultLogger = null;
            // Cross-browser bind equivalent that works at least back to IE6
            function bindMethod(obj, methodName) {
                var method = obj[methodName];
                if (typeof method.bind === 'function') return method.bind(obj);
                else try {
                    return Function.prototype.bind.call(method, obj);
                } catch (e) {
                    // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                    return function() {
                        return Function.prototype.apply.apply(method, [
                            obj,
                            arguments
                        ]);
                    };
                }
            }
            // Trace() doesn't print the message in IE, so for that case we need to wrap it
            function traceForIE() {
                if (console.log) {
                    if (console.log.apply) console.log.apply(console, arguments);
                    else // In old IE, native console methods themselves don't have apply().
                    Function.prototype.apply.apply(console.log, [
                        console,
                        arguments
                    ]);
                }
                if (console.trace) console.trace();
            }
            // Build the best logging method possible for this env
            // Wherever possible we want to bind, not wrap, to preserve stack traces
            function realMethod(methodName) {
                if (methodName === 'debug') methodName = 'log';
                if (typeof console === undefinedType) return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
                else if (methodName === 'trace' && isIE) return traceForIE;
                else if (console[methodName] !== undefined) return bindMethod(console, methodName);
                else if (console.log !== undefined) return bindMethod(console, 'log');
                else return noop;
            }
            // These private functions always need `this` to be set properly
            function replaceLoggingMethods() {
                /*jshint validthis:true */ var level = this.getLevel();
                // Replace the actual methods.
                for(var i = 0; i < logMethods.length; i++){
                    var methodName = logMethods[i];
                    this[methodName] = i < level ? noop : this.methodFactory(methodName, level, this.name);
                }
                // Define log.log as an alias for log.debug
                this.log = this.debug;
                // Return any important warnings.
                if (typeof console === undefinedType && level < this.levels.SILENT) return "No console available for logging";
            }
            // In old IE versions, the console isn't present until you first open it.
            // We build realMethod() replacements here that regenerate logging methods
            function enableLoggingWhenConsoleArrives(methodName) {
                return function() {
                    if (typeof console !== undefinedType) {
                        replaceLoggingMethods.call(this);
                        this[methodName].apply(this, arguments);
                    }
                };
            }
            // By default, we use closely bound real methods wherever possible, and
            // otherwise we wait for a console to appear, and then try again.
            function defaultMethodFactory(methodName, _level, _loggerName) {
                /*jshint validthis:true */ return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
            }
            function Logger(name, factory) {
                // Private instance variables.
                var self = this;
                /**
         * The level inherited from a parent logger (or a global default). We
         * cache this here rather than delegating to the parent so that it stays
         * in sync with the actual logging methods that we have installed (the
         * parent could change levels but we might not have rebuilt the loggers
         * in this child yet).
         * @type {number}
         */ var inheritedLevel;
                /**
         * The default level for this logger, if any. If set, this overrides
         * `inheritedLevel`.
         * @type {number|null}
         */ var defaultLevel;
                /**
         * A user-specific level for this logger. If set, this overrides
         * `defaultLevel`.
         * @type {number|null}
         */ var userLevel;
                var storageKey = "loglevel";
                if (typeof name === "string") storageKey += ":" + name;
                else if (typeof name === "symbol") storageKey = undefined;
                function persistLevelIfPossible(levelNum) {
                    var levelName = (logMethods[levelNum] || 'silent').toUpperCase();
                    if (typeof window === undefinedType || !storageKey) return;
                    // Use localStorage if available
                    try {
                        window.localStorage[storageKey] = levelName;
                        return;
                    } catch (ignore) {}
                    // Use session cookie as fallback
                    try {
                        window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
                    } catch (ignore) {}
                }
                function getPersistedLevel() {
                    var storedLevel;
                    if (typeof window === undefinedType || !storageKey) return;
                    try {
                        storedLevel = window.localStorage[storageKey];
                    } catch (ignore) {}
                    // Fallback to cookies if local storage gives us nothing
                    if (typeof storedLevel === undefinedType) try {
                        var cookie = window.document.cookie;
                        var cookieName = encodeURIComponent(storageKey);
                        var location = cookie.indexOf(cookieName + "=");
                        if (location !== -1) storedLevel = /^([^;]+)/.exec(cookie.slice(location + cookieName.length + 1))[1];
                    } catch (ignore) {}
                    // If the stored level is not valid, treat it as if nothing was stored.
                    if (self.levels[storedLevel] === undefined) storedLevel = undefined;
                    return storedLevel;
                }
                function clearPersistedLevel() {
                    if (typeof window === undefinedType || !storageKey) return;
                    // Use localStorage if available
                    try {
                        window.localStorage.removeItem(storageKey);
                    } catch (ignore) {}
                    // Use session cookie as fallback
                    try {
                        window.document.cookie = encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
                    } catch (ignore) {}
                }
                function normalizeLevel(input) {
                    var level = input;
                    if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) level = self.levels[level.toUpperCase()];
                    if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) return level;
                    else throw new TypeError("log.setLevel() called with invalid level: " + input);
                }
                /*
         *
         * Public logger API - see https://github.com/pimterry/loglevel for details
         *
         */ self.name = name;
                self.levels = {
                    "TRACE": 0,
                    "DEBUG": 1,
                    "INFO": 2,
                    "WARN": 3,
                    "ERROR": 4,
                    "SILENT": 5
                };
                self.methodFactory = factory || defaultMethodFactory;
                self.getLevel = function() {
                    if (userLevel != null) return userLevel;
                    else if (defaultLevel != null) return defaultLevel;
                    else return inheritedLevel;
                };
                self.setLevel = function(level, persist) {
                    userLevel = normalizeLevel(level);
                    if (persist !== false) // defaults to true
                    persistLevelIfPossible(userLevel);
                    // NOTE: in v2, this should call rebuild(), which updates children.
                    return replaceLoggingMethods.call(self);
                };
                self.setDefaultLevel = function(level) {
                    defaultLevel = normalizeLevel(level);
                    if (!getPersistedLevel()) self.setLevel(level, false);
                };
                self.resetLevel = function() {
                    userLevel = null;
                    clearPersistedLevel();
                    replaceLoggingMethods.call(self);
                };
                self.enableAll = function(persist) {
                    self.setLevel(self.levels.TRACE, persist);
                };
                self.disableAll = function(persist) {
                    self.setLevel(self.levels.SILENT, persist);
                };
                self.rebuild = function() {
                    if (defaultLogger !== self) inheritedLevel = normalizeLevel(defaultLogger.getLevel());
                    replaceLoggingMethods.call(self);
                    if (defaultLogger === self) for(var childName in _loggersByName)_loggersByName[childName].rebuild();
                };
                // Initialize all the internal levels.
                inheritedLevel = normalizeLevel(defaultLogger ? defaultLogger.getLevel() : "WARN");
                var initialLevel = getPersistedLevel();
                if (initialLevel != null) userLevel = normalizeLevel(initialLevel);
                replaceLoggingMethods.call(self);
            }
            /*
       *
       * Top-level API
       *
       */ defaultLogger = new Logger();
            defaultLogger.getLogger = function getLogger(name) {
                if (typeof name !== "symbol" && typeof name !== "string" || name === "") throw new TypeError("You must supply a name when creating a logger.");
                var logger = _loggersByName[name];
                if (!logger) logger = _loggersByName[name] = new Logger(name, defaultLogger.methodFactory);
                return logger;
            };
            // Grab the current global log variable in case of overwrite
            var _log = typeof window !== undefinedType ? window.log : undefined;
            defaultLogger.noConflict = function() {
                if (typeof window !== undefinedType && window.log === defaultLogger) window.log = _log;
                return defaultLogger;
            };
            defaultLogger.getLoggers = function getLoggers() {
                return _loggersByName;
            };
            // ES6 default export, for compatibility
            defaultLogger['default'] = defaultLogger;
            return defaultLogger;
        });
    })($2d7d9af7a5367cf4$var$loglevel$1);
    return $2d7d9af7a5367cf4$var$loglevel$1.exports;
}
var $2d7d9af7a5367cf4$var$loglevelExports = $2d7d9af7a5367cf4$var$requireLoglevel();
var $2d7d9af7a5367cf4$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["trace"] = 0] = "trace";
    LogLevel[LogLevel["debug"] = 1] = "debug";
    LogLevel[LogLevel["info"] = 2] = "info";
    LogLevel[LogLevel["warn"] = 3] = "warn";
    LogLevel[LogLevel["error"] = 4] = "error";
    LogLevel[LogLevel["silent"] = 5] = "silent";
})($2d7d9af7a5367cf4$export$243e62d78d3b544d || ($2d7d9af7a5367cf4$export$243e62d78d3b544d = {}));
var $2d7d9af7a5367cf4$export$69ba24dd79f4da21;
(function(LoggerNames) {
    LoggerNames["Default"] = "livekit";
    LoggerNames["Room"] = "livekit-room";
    LoggerNames["Participant"] = "livekit-participant";
    LoggerNames["Track"] = "livekit-track";
    LoggerNames["Publication"] = "livekit-track-publication";
    LoggerNames["Engine"] = "livekit-engine";
    LoggerNames["Signal"] = "livekit-signal";
    LoggerNames["PCManager"] = "livekit-pc-manager";
    LoggerNames["PCTransport"] = "livekit-pc-transport";
    LoggerNames["E2EE"] = "lk-e2ee";
})($2d7d9af7a5367cf4$export$69ba24dd79f4da21 || ($2d7d9af7a5367cf4$export$69ba24dd79f4da21 = {}));
let $2d7d9af7a5367cf4$var$livekitLogger = $2d7d9af7a5367cf4$var$loglevelExports.getLogger('livekit');
const $2d7d9af7a5367cf4$var$livekitLoggers = Object.values($2d7d9af7a5367cf4$export$69ba24dd79f4da21).map((name)=>$2d7d9af7a5367cf4$var$loglevelExports.getLogger(name));
$2d7d9af7a5367cf4$var$livekitLogger.setDefaultLevel($2d7d9af7a5367cf4$export$243e62d78d3b544d.info);
/**
 * @internal
 */ function $2d7d9af7a5367cf4$export$2b1d391cd05230fd(name) {
    const logger = $2d7d9af7a5367cf4$var$loglevelExports.getLogger(name);
    logger.setDefaultLevel($2d7d9af7a5367cf4$var$livekitLogger.getLevel());
    return logger;
}
function $2d7d9af7a5367cf4$export$c622e99c0ce7b1c9(level, loggerName) {
    if (loggerName) $2d7d9af7a5367cf4$var$loglevelExports.getLogger(loggerName).setLevel(level);
    else for (const logger of $2d7d9af7a5367cf4$var$livekitLoggers)logger.setLevel(level);
}
/**
 * use this to hook into the logging function to allow sending internal livekit logs to third party services
 * if set, the browser logs will lose their stacktrace information (see https://github.com/pimterry/loglevel#writing-plugins)
 */ function $2d7d9af7a5367cf4$export$fd7435ba5a9de34b(extension, logger) {
    const loggers = logger ? [
        logger
    ] : $2d7d9af7a5367cf4$var$livekitLoggers;
    loggers.forEach((logR)=>{
        const originalFactory = logR.methodFactory;
        logR.methodFactory = (methodName, configLevel, loggerName)=>{
            const rawMethod = originalFactory(methodName, configLevel, loggerName);
            const logLevel = $2d7d9af7a5367cf4$export$243e62d78d3b544d[methodName];
            const needLog = logLevel >= configLevel && logLevel < $2d7d9af7a5367cf4$export$243e62d78d3b544d.silent;
            return (msg, context)=>{
                if (context) rawMethod(msg, context);
                else rawMethod(msg);
                if (needLog) extension(logLevel, msg, context);
            };
        };
        logR.setLevel(logR.getLevel());
    });
}
const $2d7d9af7a5367cf4$var$workerLogger = $2d7d9af7a5367cf4$var$loglevelExports.getLogger('lk-e2ee');
const $2d7d9af7a5367cf4$var$maxRetryDelay = 7000;
const $2d7d9af7a5367cf4$var$DEFAULT_RETRY_DELAYS_IN_MS = [
    0,
    300,
    1200,
    2700,
    4800,
    $2d7d9af7a5367cf4$var$maxRetryDelay,
    $2d7d9af7a5367cf4$var$maxRetryDelay,
    $2d7d9af7a5367cf4$var$maxRetryDelay,
    $2d7d9af7a5367cf4$var$maxRetryDelay,
    $2d7d9af7a5367cf4$var$maxRetryDelay
];
class $2d7d9af7a5367cf4$export$97bc471d6a059e6e {
    constructor(retryDelays){
        this._retryDelays = retryDelays !== undefined ? [
            ...retryDelays
        ] : $2d7d9af7a5367cf4$var$DEFAULT_RETRY_DELAYS_IN_MS;
    }
    nextRetryDelayInMs(context) {
        if (context.retryCount >= this._retryDelays.length) return null;
        const retryDelay = this._retryDelays[context.retryCount];
        if (context.retryCount <= 1) return retryDelay;
        return retryDelay + Math.random() * 1000;
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $2d7d9af7a5367cf4$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2d7d9af7a5367cf4$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2d7d9af7a5367cf4$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2d7d9af7a5367cf4$var$__values === "function" ? $2d7d9af7a5367cf4$var$__values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
typeof SuppressedError === "function" && SuppressedError;
var $2d7d9af7a5367cf4$var$events = {
    exports: {}
};
var $2d7d9af7a5367cf4$var$hasRequiredEvents;
function $2d7d9af7a5367cf4$var$requireEvents() {
    if ($2d7d9af7a5367cf4$var$hasRequiredEvents) return $2d7d9af7a5367cf4$var$events.exports;
    $2d7d9af7a5367cf4$var$hasRequiredEvents = 1;
    var R = typeof Reflect === 'object' ? Reflect : null;
    var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
        return Function.prototype.apply.call(target, receiver, args);
    };
    var ReflectOwnKeys;
    if (R && typeof R.ownKeys === 'function') ReflectOwnKeys = R.ownKeys;
    else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
    };
    else ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target);
    };
    function ProcessEmitWarning(warning) {
        if (console && console.warn) console.warn(warning);
    }
    var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
        return value !== value;
    };
    function EventEmitter() {
        EventEmitter.init.call(this);
    }
    $2d7d9af7a5367cf4$var$events.exports = EventEmitter;
    $2d7d9af7a5367cf4$var$events.exports.once = once;
    // Backwards-compat with node 0.10.x
    EventEmitter.EventEmitter = EventEmitter;
    EventEmitter.prototype._events = undefined;
    EventEmitter.prototype._eventsCount = 0;
    EventEmitter.prototype._maxListeners = undefined;
    // By default EventEmitters will print a warning if more than 10 listeners are
    // added to it. This is a useful default which helps finding memory leaks.
    var defaultMaxListeners = 10;
    function checkListener(listener) {
        if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
    }
    Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
        enumerable: true,
        get: function() {
            return defaultMaxListeners;
        },
        set: function(arg) {
            if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
            defaultMaxListeners = arg;
        }
    });
    EventEmitter.init = function() {
        if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        }
        this._maxListeners = this._maxListeners || undefined;
    };
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
        if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
        this._maxListeners = n;
        return this;
    };
    function _getMaxListeners(that) {
        if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
        return that._maxListeners;
    }
    EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return _getMaxListeners(this);
    };
    EventEmitter.prototype.emit = function emit(type) {
        var args = [];
        for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
        var doError = type === 'error';
        var events = this._events;
        if (events !== undefined) doError = doError && events.error === undefined;
        else if (!doError) return false;
        // If there is no 'error' event listener then throw.
        if (doError) {
            var er;
            if (args.length > 0) er = args[0];
            if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
            // up in Node's output if this results in an unhandled exception.
            throw er; // Unhandled 'error' event
            // At least give some kind of context to the user
            var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
            err.context = er;
            throw err; // Unhandled 'error' event
        }
        var handler = events[type];
        if (handler === undefined) return false;
        if (typeof handler === 'function') ReflectApply(handler, this, args);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
        }
        return true;
    };
    function _addListener(target, type, listener, prepend) {
        var m;
        var events;
        var existing;
        checkListener(listener);
        events = target._events;
        if (events === undefined) {
            events = target._events = Object.create(null);
            target._eventsCount = 0;
        } else {
            // To avoid recursion in the case that type === "newListener"! Before
            // adding it to the listeners, first emit "newListener".
            if (events.newListener !== undefined) {
                target.emit('newListener', type, listener.listener ? listener.listener : listener);
                // Re-assign `events` because a newListener handler could have caused the
                // this._events to be assigned to a new object
                events = target._events;
            }
            existing = events[type];
        }
        if (existing === undefined) {
            // Optimize the case of one listener. Don't need the extra array object.
            existing = events[type] = listener;
            ++target._eventsCount;
        } else {
            if (typeof existing === 'function') // Adding the second element, need to change to array.
            existing = events[type] = prepend ? [
                listener,
                existing
            ] : [
                existing,
                listener
            ];
            else if (prepend) existing.unshift(listener);
            else existing.push(listener);
            // Check for listener leak
            m = _getMaxListeners(target);
            if (m > 0 && existing.length > m && !existing.warned) {
                existing.warned = true;
                // No error code for this since it is a Warning
                // eslint-disable-next-line no-restricted-syntax
                var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
                w.name = 'MaxListenersExceededWarning';
                w.emitter = target;
                w.type = type;
                w.count = existing.length;
                ProcessEmitWarning(w);
            }
        }
        return target;
    }
    EventEmitter.prototype.addListener = function addListener(type, listener) {
        return _addListener(this, type, listener, false);
    };
    EventEmitter.prototype.on = EventEmitter.prototype.addListener;
    EventEmitter.prototype.prependListener = function prependListener(type, listener) {
        return _addListener(this, type, listener, true);
    };
    function onceWrapper() {
        if (!this.fired) {
            this.target.removeListener(this.type, this.wrapFn);
            this.fired = true;
            if (arguments.length === 0) return this.listener.call(this.target);
            return this.listener.apply(this.target, arguments);
        }
    }
    function _onceWrap(target, type, listener) {
        var state = {
            fired: false,
            wrapFn: undefined,
            target: target,
            type: type,
            listener: listener
        };
        var wrapped = onceWrapper.bind(state);
        wrapped.listener = listener;
        state.wrapFn = wrapped;
        return wrapped;
    }
    EventEmitter.prototype.once = function once(type, listener) {
        checkListener(listener);
        this.on(type, _onceWrap(this, type, listener));
        return this;
    };
    EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
        checkListener(listener);
        this.prependListener(type, _onceWrap(this, type, listener));
        return this;
    };
    // Emits a 'removeListener' event if and only if the listener was removed.
    EventEmitter.prototype.removeListener = function removeListener(type, listener) {
        var list, events, position, i, originalListener;
        checkListener(listener);
        events = this._events;
        if (events === undefined) return this;
        list = events[type];
        if (list === undefined) return this;
        if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else {
                delete events[type];
                if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
            }
        } else if (typeof list !== 'function') {
            position = -1;
            for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
            }
            if (position < 0) return this;
            if (position === 0) list.shift();
            else spliceOne(list, position);
            if (list.length === 1) events[type] = list[0];
            if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
        }
        return this;
    };
    EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
    EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
        var listeners, events, i;
        events = this._events;
        if (events === undefined) return this;
        // not listening for removeListener, no need to emit
        if (events.removeListener === undefined) {
            if (arguments.length === 0) {
                this._events = Object.create(null);
                this._eventsCount = 0;
            } else if (events[type] !== undefined) {
                if (--this._eventsCount === 0) this._events = Object.create(null);
                else delete events[type];
            }
            return this;
        }
        // emit removeListener for all listeners on all events
        if (arguments.length === 0) {
            var keys = Object.keys(events);
            var key;
            for(i = 0; i < keys.length; ++i){
                key = keys[i];
                if (key === 'removeListener') continue;
                this.removeAllListeners(key);
            }
            this.removeAllListeners('removeListener');
            this._events = Object.create(null);
            this._eventsCount = 0;
            return this;
        }
        listeners = events[type];
        if (typeof listeners === 'function') this.removeListener(type, listeners);
        else if (listeners !== undefined) // LIFO order
        for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
        return this;
    };
    function _listeners(target, type, unwrap) {
        var events = target._events;
        if (events === undefined) return [];
        var evlistener = events[type];
        if (evlistener === undefined) return [];
        if (typeof evlistener === 'function') return unwrap ? [
            evlistener.listener || evlistener
        ] : [
            evlistener
        ];
        return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
    }
    EventEmitter.prototype.listeners = function listeners(type) {
        return _listeners(this, type, true);
    };
    EventEmitter.prototype.rawListeners = function rawListeners(type) {
        return _listeners(this, type, false);
    };
    EventEmitter.listenerCount = function(emitter, type) {
        if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
        else return listenerCount.call(emitter, type);
    };
    EventEmitter.prototype.listenerCount = listenerCount;
    function listenerCount(type) {
        var events = this._events;
        if (events !== undefined) {
            var evlistener = events[type];
            if (typeof evlistener === 'function') return 1;
            else if (evlistener !== undefined) return evlistener.length;
        }
        return 0;
    }
    EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
    };
    function arrayClone(arr, n) {
        var copy = new Array(n);
        for(var i = 0; i < n; ++i)copy[i] = arr[i];
        return copy;
    }
    function spliceOne(list, index) {
        for(; index + 1 < list.length; index++)list[index] = list[index + 1];
        list.pop();
    }
    function unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
        return ret;
    }
    function once(emitter, name) {
        return new Promise(function(resolve, reject) {
            function errorListener(err) {
                emitter.removeListener(name, resolver);
                reject(err);
            }
            function resolver() {
                if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
                resolve([].slice.call(arguments));
            }
            eventTargetAgnosticAddListener(emitter, name, resolver, {
                once: true
            });
            if (name !== 'error') addErrorHandlerIfEventEmitter(emitter, errorListener, {
                once: true
            });
        });
    }
    function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
        if (typeof emitter.on === 'function') eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
    }
    function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
        if (typeof emitter.on === 'function') {
            if (flags.once) emitter.once(name, listener);
            else emitter.on(name, listener);
        } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
        // EventEmitters, we do not listen for `error` events here.
        emitter.addEventListener(name, function wrapListener(arg) {
            // IE does not have builtin `{ once: true }` support so we
            // have to do it manually.
            if (flags.once) emitter.removeEventListener(name, wrapListener);
            listener(arg);
        });
        else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
    }
    return $2d7d9af7a5367cf4$var$events.exports;
}
var $2d7d9af7a5367cf4$var$eventsExports = $2d7d9af7a5367cf4$var$requireEvents();
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ let $2d7d9af7a5367cf4$var$logDisabled_ = true;
let $2d7d9af7a5367cf4$var$deprecationWarnings_ = true;
/**
 * Extract browser version out of the provided user agent string.
 *
 * @param {!string} uastring userAgent string.
 * @param {!string} expr Regular expression used as match criteria.
 * @param {!number} pos position in the version string to be returned.
 * @return {!number} browser version.
 */ function $2d7d9af7a5367cf4$var$extractVersion(uastring, expr, pos) {
    const match = uastring.match(expr);
    return match && match.length >= pos && parseInt(match[pos], 10);
}
// Wraps the peerconnection event eventNameToWrap in a function
// which returns the modified event object (or false to prevent
// the event).
function $2d7d9af7a5367cf4$var$wrapPeerConnectionEvent(window1, eventNameToWrap, wrapper) {
    if (!window1.RTCPeerConnection) return;
    const proto = window1.RTCPeerConnection.prototype;
    const nativeAddEventListener = proto.addEventListener;
    proto.addEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap) return nativeAddEventListener.apply(this, arguments);
        const wrappedCallback = (e)=>{
            const modifiedEvent = wrapper(e);
            if (modifiedEvent) {
                if (cb.handleEvent) cb.handleEvent(modifiedEvent);
                else cb(modifiedEvent);
            }
        };
        this._eventMap = this._eventMap || {};
        if (!this._eventMap[eventNameToWrap]) this._eventMap[eventNameToWrap] = new Map();
        this._eventMap[eventNameToWrap].set(cb, wrappedCallback);
        return nativeAddEventListener.apply(this, [
            nativeEventName,
            wrappedCallback
        ]);
    };
    const nativeRemoveEventListener = proto.removeEventListener;
    proto.removeEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) return nativeRemoveEventListener.apply(this, arguments);
        if (!this._eventMap[eventNameToWrap].has(cb)) return nativeRemoveEventListener.apply(this, arguments);
        const unwrappedCb = this._eventMap[eventNameToWrap].get(cb);
        this._eventMap[eventNameToWrap].delete(cb);
        if (this._eventMap[eventNameToWrap].size === 0) delete this._eventMap[eventNameToWrap];
        if (Object.keys(this._eventMap).length === 0) delete this._eventMap;
        return nativeRemoveEventListener.apply(this, [
            nativeEventName,
            unwrappedCb
        ]);
    };
    Object.defineProperty(proto, 'on' + eventNameToWrap, {
        get () {
            return this['_on' + eventNameToWrap];
        },
        set (cb) {
            if (this['_on' + eventNameToWrap]) {
                this.removeEventListener(eventNameToWrap, this['_on' + eventNameToWrap]);
                delete this['_on' + eventNameToWrap];
            }
            if (cb) this.addEventListener(eventNameToWrap, this['_on' + eventNameToWrap] = cb);
        },
        enumerable: true,
        configurable: true
    });
}
function $2d7d9af7a5367cf4$var$disableLog(bool) {
    if (typeof bool !== 'boolean') return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
    $2d7d9af7a5367cf4$var$logDisabled_ = bool;
    return bool ? 'adapter.js logging disabled' : 'adapter.js logging enabled';
}
/**
 * Disable or enable deprecation warnings
 * @param {!boolean} bool set to true to disable warnings.
 */ function $2d7d9af7a5367cf4$var$disableWarnings(bool) {
    if (typeof bool !== 'boolean') return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
    $2d7d9af7a5367cf4$var$deprecationWarnings_ = !bool;
    return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
}
function $2d7d9af7a5367cf4$var$log() {
    if (typeof window === 'object') {
        if ($2d7d9af7a5367cf4$var$logDisabled_) return;
        if (typeof console !== 'undefined' && typeof console.log === 'function') console.log.apply(console, arguments);
    }
}
/**
 * Shows a deprecation warning suggesting the modern and spec-compatible API.
 */ function $2d7d9af7a5367cf4$var$deprecated(oldMethod, newMethod) {
    if (!$2d7d9af7a5367cf4$var$deprecationWarnings_) return;
    console.warn(oldMethod + ' is deprecated, please use ' + newMethod + ' instead.');
}
/**
 * Browser detector.
 *
 * @return {object} result containing browser and version
 *     properties.
 */ function $2d7d9af7a5367cf4$var$detectBrowser(window1) {
    // Returned result object.
    const result = {
        browser: null,
        version: null
    };
    // Fail early if it's not a browser
    if (typeof window1 === 'undefined' || !window1.navigator || !window1.navigator.userAgent) {
        result.browser = 'Not a browser.';
        return result;
    }
    const { navigator: navigator1 } = window1;
    // Prefer navigator.userAgentData.
    if (navigator1.userAgentData && navigator1.userAgentData.brands) {
        const chromium = navigator1.userAgentData.brands.find((brand)=>{
            return brand.brand === 'Chromium';
        });
        if (chromium) return {
            browser: 'chrome',
            version: parseInt(chromium.version, 10)
        };
    }
    if (navigator1.mozGetUserMedia) {
        // Firefox.
        result.browser = 'firefox';
        result.version = $2d7d9af7a5367cf4$var$extractVersion(navigator1.userAgent, /Firefox\/(\d+)\./, 1);
    } else if (navigator1.webkitGetUserMedia || window1.isSecureContext === false && window1.webkitRTCPeerConnection) {
        // Chrome, Chromium, Webview, Opera.
        // Version matches Chrome/WebRTC version.
        // Chrome 74 removed webkitGetUserMedia on http as well so we need the
        // more complicated fallback to webkitRTCPeerConnection.
        result.browser = 'chrome';
        result.version = $2d7d9af7a5367cf4$var$extractVersion(navigator1.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
    } else if (window1.RTCPeerConnection && navigator1.userAgent.match(/AppleWebKit\/(\d+)\./)) {
        // Safari.
        result.browser = 'safari';
        result.version = $2d7d9af7a5367cf4$var$extractVersion(navigator1.userAgent, /AppleWebKit\/(\d+)\./, 1);
        result.supportsUnifiedPlan = window1.RTCRtpTransceiver && 'currentDirection' in window1.RTCRtpTransceiver.prototype;
    } else {
        // Default fallthrough: not supported.
        result.browser = 'Not a supported browser.';
        return result;
    }
    return result;
}
/**
 * Checks if something is an object.
 *
 * @param {*} val The something you want to check.
 * @return true if val is an object, false otherwise.
 */ function $2d7d9af7a5367cf4$var$isObject(val) {
    return Object.prototype.toString.call(val) === '[object Object]';
}
/**
 * Remove all empty objects and undefined values
 * from a nested object -- an enhanced and vanilla version
 * of Lodash's `compact`.
 */ function $2d7d9af7a5367cf4$var$compactObject(data) {
    if (!$2d7d9af7a5367cf4$var$isObject(data)) return data;
    return Object.keys(data).reduce(function(accumulator, key) {
        const isObj = $2d7d9af7a5367cf4$var$isObject(data[key]);
        const value = isObj ? $2d7d9af7a5367cf4$var$compactObject(data[key]) : data[key];
        const isEmptyObject = isObj && !Object.keys(value).length;
        if (value === undefined || isEmptyObject) return accumulator;
        return Object.assign(accumulator, {
            [key]: value
        });
    }, {});
}
/* iterates the stats graph recursively. */ function $2d7d9af7a5367cf4$var$walkStats(stats, base, resultSet) {
    if (!base || resultSet.has(base.id)) return;
    resultSet.set(base.id, base);
    Object.keys(base).forEach((name)=>{
        if (name.endsWith('Id')) $2d7d9af7a5367cf4$var$walkStats(stats, stats.get(base[name]), resultSet);
        else if (name.endsWith('Ids')) base[name].forEach((id)=>{
            $2d7d9af7a5367cf4$var$walkStats(stats, stats.get(id), resultSet);
        });
    });
}
/* filter getStats for a sender/receiver track. */ function $2d7d9af7a5367cf4$var$filterStats(result, track, outbound) {
    const streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
    const filteredResult = new Map();
    if (track === null) return filteredResult;
    const trackStats = [];
    result.forEach((value)=>{
        if (value.type === 'track' && value.trackIdentifier === track.id) trackStats.push(value);
    });
    trackStats.forEach((trackStat)=>{
        result.forEach((stats)=>{
            if (stats.type === streamStatsType && stats.trackId === trackStat.id) $2d7d9af7a5367cf4$var$walkStats(result, stats, filteredResult);
        });
    });
    return filteredResult;
}
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ const $2d7d9af7a5367cf4$var$logging = $2d7d9af7a5367cf4$var$log;
function $2d7d9af7a5367cf4$var$shimGetUserMedia$2(window1, browserDetails) {
    const navigator1 = window1 && window1.navigator;
    if (!navigator1.mediaDevices) return;
    const constraintsToChrome_ = function(c) {
        if (typeof c !== 'object' || c.mandatory || c.optional) return c;
        const cc = {};
        Object.keys(c).forEach((key)=>{
            if (key === 'require' || key === 'advanced' || key === 'mediaSource') return;
            const r = typeof c[key] === 'object' ? c[key] : {
                ideal: c[key]
            };
            if (r.exact !== undefined && typeof r.exact === 'number') r.min = r.max = r.exact;
            const oldname_ = function(prefix, name) {
                if (prefix) return prefix + name.charAt(0).toUpperCase() + name.slice(1);
                return name === 'deviceId' ? 'sourceId' : name;
            };
            if (r.ideal !== undefined) {
                cc.optional = cc.optional || [];
                let oc = {};
                if (typeof r.ideal === 'number') {
                    oc[oldname_('min', key)] = r.ideal;
                    cc.optional.push(oc);
                    oc = {};
                    oc[oldname_('max', key)] = r.ideal;
                    cc.optional.push(oc);
                } else {
                    oc[oldname_('', key)] = r.ideal;
                    cc.optional.push(oc);
                }
            }
            if (r.exact !== undefined && typeof r.exact !== 'number') {
                cc.mandatory = cc.mandatory || {};
                cc.mandatory[oldname_('', key)] = r.exact;
            } else [
                'min',
                'max'
            ].forEach((mix)=>{
                if (r[mix] !== undefined) {
                    cc.mandatory = cc.mandatory || {};
                    cc.mandatory[oldname_(mix, key)] = r[mix];
                }
            });
        });
        if (c.advanced) cc.optional = (cc.optional || []).concat(c.advanced);
        return cc;
    };
    const shimConstraints_ = function(constraints, func) {
        if (browserDetails.version >= 61) return func(constraints);
        constraints = JSON.parse(JSON.stringify(constraints));
        if (constraints && typeof constraints.audio === 'object') {
            const remap = function(obj, a, b) {
                if (a in obj && !(b in obj)) {
                    obj[b] = obj[a];
                    delete obj[a];
                }
            };
            constraints = JSON.parse(JSON.stringify(constraints));
            remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
            remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
            constraints.audio = constraintsToChrome_(constraints.audio);
        }
        if (constraints && typeof constraints.video === 'object') {
            // Shim facingMode for mobile & surface pro.
            let face = constraints.video.facingMode;
            face = face && (typeof face === 'object' ? face : {
                ideal: face
            });
            const getSupportedFacingModeLies = browserDetails.version < 66;
            if (face && (face.exact === 'user' || face.exact === 'environment' || face.ideal === 'user' || face.ideal === 'environment') && !(navigator1.mediaDevices.getSupportedConstraints && navigator1.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
                delete constraints.video.facingMode;
                let matches;
                if (face.exact === 'environment' || face.ideal === 'environment') matches = [
                    'back',
                    'rear'
                ];
                else if (face.exact === 'user' || face.ideal === 'user') matches = [
                    'front'
                ];
                if (matches) // Look for matches in label, or use last cam for back (typical).
                return navigator1.mediaDevices.enumerateDevices().then((devices)=>{
                    devices = devices.filter((d)=>d.kind === 'videoinput');
                    let dev = devices.find((d)=>matches.some((match)=>d.label.toLowerCase().includes(match)));
                    if (!dev && devices.length && matches.includes('back')) dev = devices[devices.length - 1]; // more likely the back cam
                    if (dev) constraints.video.deviceId = face.exact ? {
                        exact: dev.deviceId
                    } : {
                        ideal: dev.deviceId
                    };
                    constraints.video = constraintsToChrome_(constraints.video);
                    $2d7d9af7a5367cf4$var$logging('chrome: ' + JSON.stringify(constraints));
                    return func(constraints);
                });
            }
            constraints.video = constraintsToChrome_(constraints.video);
        }
        $2d7d9af7a5367cf4$var$logging('chrome: ' + JSON.stringify(constraints));
        return func(constraints);
    };
    const shimError_ = function(e) {
        if (browserDetails.version >= 64) return e;
        return {
            name: ({
                PermissionDeniedError: 'NotAllowedError',
                PermissionDismissedError: 'NotAllowedError',
                InvalidStateError: 'NotAllowedError',
                DevicesNotFoundError: 'NotFoundError',
                ConstraintNotSatisfiedError: 'OverconstrainedError',
                TrackStartError: 'NotReadableError',
                MediaDeviceFailedDueToShutdown: 'NotAllowedError',
                MediaDeviceKillSwitchOn: 'NotAllowedError',
                TabCaptureError: 'AbortError',
                ScreenCaptureError: 'AbortError',
                DeviceCaptureError: 'AbortError'
            })[e.name] || e.name,
            message: e.message,
            constraint: e.constraint || e.constraintName,
            toString () {
                return this.name + (this.message && ': ') + this.message;
            }
        };
    };
    const getUserMedia_ = function(constraints, onSuccess, onError) {
        shimConstraints_(constraints, (c)=>{
            navigator1.webkitGetUserMedia(c, onSuccess, (e)=>{
                if (onError) onError(shimError_(e));
            });
        });
    };
    navigator1.getUserMedia = getUserMedia_.bind(navigator1);
    // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
    // function which returns a Promise, it does not accept spec-style
    // constraints.
    if (navigator1.mediaDevices.getUserMedia) {
        const origGetUserMedia = navigator1.mediaDevices.getUserMedia.bind(navigator1.mediaDevices);
        navigator1.mediaDevices.getUserMedia = function(cs) {
            return shimConstraints_(cs, (c)=>origGetUserMedia(c).then((stream)=>{
                    if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
                        stream.getTracks().forEach((track)=>{
                            track.stop();
                        });
                        throw new DOMException('', 'NotFoundError');
                    }
                    return stream;
                }, (e)=>Promise.reject(shimError_(e))));
        };
    }
}
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ function $2d7d9af7a5367cf4$var$shimMediaStream(window1) {
    window1.MediaStream = window1.MediaStream || window1.webkitMediaStream;
}
function $2d7d9af7a5367cf4$var$shimOnTrack$1(window1) {
    if (typeof window1 === 'object' && window1.RTCPeerConnection && !('ontrack' in window1.RTCPeerConnection.prototype)) {
        Object.defineProperty(window1.RTCPeerConnection.prototype, 'ontrack', {
            get () {
                return this._ontrack;
            },
            set (f) {
                if (this._ontrack) this.removeEventListener('track', this._ontrack);
                this.addEventListener('track', this._ontrack = f);
            },
            enumerable: true,
            configurable: true
        });
        const origSetRemoteDescription = window1.RTCPeerConnection.prototype.setRemoteDescription;
        window1.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            if (!this._ontrackpoly) {
                this._ontrackpoly = (e)=>{
                    // onaddstream does not fire when a track is added to an existing
                    // stream. But stream.onaddtrack is implemented so we use that.
                    e.stream.addEventListener('addtrack', (te)=>{
                        let receiver;
                        if (window1.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === te.track.id);
                        else receiver = {
                            track: te.track
                        };
                        const event = new Event('track');
                        event.track = te.track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                    e.stream.getTracks().forEach((track)=>{
                        let receiver;
                        if (window1.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === track.id);
                        else receiver = {
                            track: track
                        };
                        const event = new Event('track');
                        event.track = track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                };
                this.addEventListener('addstream', this._ontrackpoly);
            }
            return origSetRemoteDescription.apply(this, arguments);
        };
    } else // even if RTCRtpTransceiver is in window, it is only used and
    // emitted in unified-plan. Unfortunately this means we need
    // to unconditionally wrap the event.
    $2d7d9af7a5367cf4$var$wrapPeerConnectionEvent(window1, 'track', (e)=>{
        if (!e.transceiver) Object.defineProperty(e, 'transceiver', {
            value: {
                receiver: e.receiver
            }
        });
        return e;
    });
}
function $2d7d9af7a5367cf4$var$shimGetSendersWithDtmf(window1) {
    // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
    if (typeof window1 === 'object' && window1.RTCPeerConnection && !('getSenders' in window1.RTCPeerConnection.prototype) && 'createDTMFSender' in window1.RTCPeerConnection.prototype) {
        const shimSenderWithDtmf = function(pc, track) {
            return {
                track: track,
                get dtmf () {
                    if (this._dtmf === undefined) {
                        if (track.kind === 'audio') this._dtmf = pc.createDTMFSender(track);
                        else this._dtmf = null;
                    }
                    return this._dtmf;
                },
                _pc: pc
            };
        };
        // augment addTrack when getSenders is not available.
        if (!window1.RTCPeerConnection.prototype.getSenders) {
            window1.RTCPeerConnection.prototype.getSenders = function getSenders() {
                this._senders = this._senders || [];
                return this._senders.slice(); // return a copy of the internal state.
            };
            const origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
            window1.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
                let sender = origAddTrack.apply(this, arguments);
                if (!sender) {
                    sender = shimSenderWithDtmf(this, track);
                    this._senders.push(sender);
                }
                return sender;
            };
            const origRemoveTrack = window1.RTCPeerConnection.prototype.removeTrack;
            window1.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
                origRemoveTrack.apply(this, arguments);
                const idx = this._senders.indexOf(sender);
                if (idx !== -1) this._senders.splice(idx, 1);
            };
        }
        const origAddStream = window1.RTCPeerConnection.prototype.addStream;
        window1.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            this._senders = this._senders || [];
            origAddStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                this._senders.push(shimSenderWithDtmf(this, track));
            });
        };
        const origRemoveStream = window1.RTCPeerConnection.prototype.removeStream;
        window1.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
            this._senders = this._senders || [];
            origRemoveStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                const sender = this._senders.find((s)=>s.track === track);
                if (sender) // remove sender
                this._senders.splice(this._senders.indexOf(sender), 1);
            });
        };
    } else if (typeof window1 === 'object' && window1.RTCPeerConnection && 'getSenders' in window1.RTCPeerConnection.prototype && 'createDTMFSender' in window1.RTCPeerConnection.prototype && window1.RTCRtpSender && !('dtmf' in window1.RTCRtpSender.prototype)) {
        const origGetSenders = window1.RTCPeerConnection.prototype.getSenders;
        window1.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        Object.defineProperty(window1.RTCRtpSender.prototype, 'dtmf', {
            get () {
                if (this._dtmf === undefined) {
                    if (this.track.kind === 'audio') this._dtmf = this._pc.createDTMFSender(this.track);
                    else this._dtmf = null;
                }
                return this._dtmf;
            }
        });
    }
}
function $2d7d9af7a5367cf4$var$shimSenderReceiverGetStats(window1) {
    if (!(typeof window1 === 'object' && window1.RTCPeerConnection && window1.RTCRtpSender && window1.RTCRtpReceiver)) return;
    // shim sender stats.
    if (!('getStats' in window1.RTCRtpSender.prototype)) {
        const origGetSenders = window1.RTCPeerConnection.prototype.getSenders;
        if (origGetSenders) window1.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        const origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
        if (origAddTrack) window1.RTCPeerConnection.prototype.addTrack = function addTrack() {
            const sender = origAddTrack.apply(this, arguments);
            sender._pc = this;
            return sender;
        };
        window1.RTCRtpSender.prototype.getStats = function getStats() {
            const sender = this;
            return this._pc.getStats().then((result)=>/* Note: this will include stats of all senders that
       *   send a track with the same id as sender.track as
       *   it is not possible to identify the RTCRtpSender.
       */ $2d7d9af7a5367cf4$var$filterStats(result, sender.track, true));
        };
    }
    // shim receiver stats.
    if (!('getStats' in window1.RTCRtpReceiver.prototype)) {
        const origGetReceivers = window1.RTCPeerConnection.prototype.getReceivers;
        if (origGetReceivers) window1.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
            const receivers = origGetReceivers.apply(this, []);
            receivers.forEach((receiver)=>receiver._pc = this);
            return receivers;
        };
        $2d7d9af7a5367cf4$var$wrapPeerConnectionEvent(window1, 'track', (e)=>{
            e.receiver._pc = e.srcElement;
            return e;
        });
        window1.RTCRtpReceiver.prototype.getStats = function getStats() {
            const receiver = this;
            return this._pc.getStats().then((result)=>$2d7d9af7a5367cf4$var$filterStats(result, receiver.track, false));
        };
    }
    if (!('getStats' in window1.RTCRtpSender.prototype && 'getStats' in window1.RTCRtpReceiver.prototype)) return;
    // shim RTCPeerConnection.getStats(track).
    const origGetStats = window1.RTCPeerConnection.prototype.getStats;
    window1.RTCPeerConnection.prototype.getStats = function getStats() {
        if (arguments.length > 0 && arguments[0] instanceof window1.MediaStreamTrack) {
            const track = arguments[0];
            let sender;
            let receiver;
            let err;
            this.getSenders().forEach((s)=>{
                if (s.track === track) {
                    if (sender) err = true;
                    else sender = s;
                }
            });
            this.getReceivers().forEach((r)=>{
                if (r.track === track) {
                    if (receiver) err = true;
                    else receiver = r;
                }
                return r.track === track;
            });
            if (err || sender && receiver) return Promise.reject(new DOMException('There are more than one sender or receiver for the track.', 'InvalidAccessError'));
            else if (sender) return sender.getStats();
            else if (receiver) return receiver.getStats();
            return Promise.reject(new DOMException('There is no sender or receiver for the track.', 'InvalidAccessError'));
        }
        return origGetStats.apply(this, arguments);
    };
}
function $2d7d9af7a5367cf4$var$shimAddTrackRemoveTrackWithNative(window1) {
    // shim addTrack/removeTrack with native variants in order to make
    // the interactions with legacy getLocalStreams behave as in other browsers.
    // Keeps a mapping stream.id => [stream, rtpsenders...]
    window1.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        return Object.keys(this._shimmedLocalStreams).map((streamId)=>this._shimmedLocalStreams[streamId][0]);
    };
    const origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
    window1.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (!stream) return origAddTrack.apply(this, arguments);
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        const sender = origAddTrack.apply(this, arguments);
        if (!this._shimmedLocalStreams[stream.id]) this._shimmedLocalStreams[stream.id] = [
            stream,
            sender
        ];
        else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) this._shimmedLocalStreams[stream.id].push(sender);
        return sender;
    };
    const origAddStream = window1.RTCPeerConnection.prototype.addStream;
    window1.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
        });
        const existingSenders = this.getSenders();
        origAddStream.apply(this, arguments);
        const newSenders = this.getSenders().filter((newSender)=>existingSenders.indexOf(newSender) === -1);
        this._shimmedLocalStreams[stream.id] = [
            stream
        ].concat(newSenders);
    };
    const origRemoveStream = window1.RTCPeerConnection.prototype.removeStream;
    window1.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        delete this._shimmedLocalStreams[stream.id];
        return origRemoveStream.apply(this, arguments);
    };
    const origRemoveTrack = window1.RTCPeerConnection.prototype.removeTrack;
    window1.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        if (sender) Object.keys(this._shimmedLocalStreams).forEach((streamId)=>{
            const idx = this._shimmedLocalStreams[streamId].indexOf(sender);
            if (idx !== -1) this._shimmedLocalStreams[streamId].splice(idx, 1);
            if (this._shimmedLocalStreams[streamId].length === 1) delete this._shimmedLocalStreams[streamId];
        });
        return origRemoveTrack.apply(this, arguments);
    };
}
function $2d7d9af7a5367cf4$var$shimAddTrackRemoveTrack(window1, browserDetails) {
    if (!window1.RTCPeerConnection) return;
    // shim addTrack and removeTrack.
    if (window1.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) return $2d7d9af7a5367cf4$var$shimAddTrackRemoveTrackWithNative(window1);
    // also shim pc.getLocalStreams when addTrack is shimmed
    // to return the original streams.
    const origGetLocalStreams = window1.RTCPeerConnection.prototype.getLocalStreams;
    window1.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        const nativeStreams = origGetLocalStreams.apply(this);
        this._reverseStreams = this._reverseStreams || {};
        return nativeStreams.map((stream)=>this._reverseStreams[stream.id]);
    };
    const origAddStream = window1.RTCPeerConnection.prototype.addStream;
    window1.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
        });
        // Add identity mapping for consistency with addTrack.
        // Unless this is being used with a stream from addTrack.
        if (!this._reverseStreams[stream.id]) {
            const newStream = new window1.MediaStream(stream.getTracks());
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            stream = newStream;
        }
        origAddStream.apply(this, [
            stream
        ]);
    };
    const origRemoveStream = window1.RTCPeerConnection.prototype.removeStream;
    window1.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        origRemoveStream.apply(this, [
            this._streams[stream.id] || stream
        ]);
        delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
        delete this._streams[stream.id];
    };
    window1.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (this.signalingState === 'closed') throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
        const streams = [].slice.call(arguments, 1);
        if (streams.length !== 1 || !streams[0].getTracks().find((t)=>t === track)) // this is not fully correct but all we can manage without
        // [[associated MediaStreams]] internal slot.
        throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.", 'NotSupportedError');
        const alreadyExists = this.getSenders().find((s)=>s.track === track);
        if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        const oldStream = this._streams[stream.id];
        if (oldStream) {
            // this is using odd Chrome behaviour, use with caution:
            // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
            // Note: we rely on the high-level addTrack/dtmf shim to
            // create the sender with a dtmf sender.
            oldStream.addTrack(track);
            // Trigger ONN async.
            Promise.resolve().then(()=>{
                this.dispatchEvent(new Event('negotiationneeded'));
            });
        } else {
            const newStream = new window1.MediaStream([
                track
            ]);
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            this.addStream(newStream);
        }
        return this.getSenders().find((s)=>s.track === track);
    };
    // replace the internal stream id with the external one and
    // vice versa.
    function replaceInternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(internalStream.id, 'g'), externalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    function replaceExternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(externalStream.id, 'g'), internalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    [
        'createOffer',
        'createAnswer'
    ].forEach(function(method) {
        const nativeMethod = window1.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                const args = arguments;
                const isLegacyCall = arguments.length && typeof arguments[0] === 'function';
                if (isLegacyCall) return nativeMethod.apply(this, [
                    (description)=>{
                        const desc = replaceInternalStreamId(this, description);
                        args[0].apply(null, [
                            desc
                        ]);
                    },
                    (err)=>{
                        if (args[1]) args[1].apply(null, err);
                    },
                    arguments[2]
                ]);
                return nativeMethod.apply(this, arguments).then((description)=>replaceInternalStreamId(this, description));
            }
        };
        window1.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const origSetLocalDescription = window1.RTCPeerConnection.prototype.setLocalDescription;
    window1.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        if (!arguments.length || !arguments[0].type) return origSetLocalDescription.apply(this, arguments);
        arguments[0] = replaceExternalStreamId(this, arguments[0]);
        return origSetLocalDescription.apply(this, arguments);
    };
    // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier
    const origLocalDescription = Object.getOwnPropertyDescriptor(window1.RTCPeerConnection.prototype, 'localDescription');
    Object.defineProperty(window1.RTCPeerConnection.prototype, 'localDescription', {
        get () {
            const description = origLocalDescription.get.apply(this);
            if (description.type === '') return description;
            return replaceInternalStreamId(this, description);
        }
    });
    window1.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        if (this.signalingState === 'closed') throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
        // We can not yet check for sender instanceof RTCRtpSender
        // since we shim RTPSender. So we check if sender._pc is set.
        if (!sender._pc) throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", 'TypeError');
        const isLocal = sender._pc === this;
        if (!isLocal) throw new DOMException('Sender was not created by this connection.', 'InvalidAccessError');
        // Search for the native stream the senders track belongs to.
        this._streams = this._streams || {};
        let stream;
        Object.keys(this._streams).forEach((streamid)=>{
            const hasTrack = this._streams[streamid].getTracks().find((track)=>sender.track === track);
            if (hasTrack) stream = this._streams[streamid];
        });
        if (stream) {
            if (stream.getTracks().length === 1) // if this is the last track of the stream, remove the stream. This
            // takes care of any shimmed _senders.
            this.removeStream(this._reverseStreams[stream.id]);
            else // relying on the same odd chrome behaviour as above.
            stream.removeTrack(sender.track);
            this.dispatchEvent(new Event('negotiationneeded'));
        }
    };
}
function $2d7d9af7a5367cf4$var$shimPeerConnection$1(window1, browserDetails) {
    if (!window1.RTCPeerConnection && window1.webkitRTCPeerConnection) // very basic support for old versions.
    window1.RTCPeerConnection = window1.webkitRTCPeerConnection;
    if (!window1.RTCPeerConnection) return;
    // shim implicit creation of RTCSessionDescription/RTCIceCandidate
    if (browserDetails.version < 53) [
        'setLocalDescription',
        'setRemoteDescription',
        'addIceCandidate'
    ].forEach(function(method) {
        const nativeMethod = window1.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === 'addIceCandidate' ? window1.RTCIceCandidate : window1.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window1.RTCPeerConnection.prototype[method] = methodObj[method];
    });
}
// Attempt to fix ONN in plan-b mode.
function $2d7d9af7a5367cf4$var$fixNegotiationNeeded(window1, browserDetails) {
    $2d7d9af7a5367cf4$var$wrapPeerConnectionEvent(window1, 'negotiationneeded', (e)=>{
        const pc = e.target;
        if (browserDetails.version < 72 || pc.getConfiguration && pc.getConfiguration().sdpSemantics === 'plan-b') {
            if (pc.signalingState !== 'stable') return;
        }
        return e;
    });
}
var $2d7d9af7a5367cf4$var$chromeShim = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    fixNegotiationNeeded: $2d7d9af7a5367cf4$var$fixNegotiationNeeded,
    shimAddTrackRemoveTrack: $2d7d9af7a5367cf4$var$shimAddTrackRemoveTrack,
    shimAddTrackRemoveTrackWithNative: $2d7d9af7a5367cf4$var$shimAddTrackRemoveTrackWithNative,
    shimGetSendersWithDtmf: $2d7d9af7a5367cf4$var$shimGetSendersWithDtmf,
    shimGetUserMedia: $2d7d9af7a5367cf4$var$shimGetUserMedia$2,
    shimMediaStream: $2d7d9af7a5367cf4$var$shimMediaStream,
    shimOnTrack: $2d7d9af7a5367cf4$var$shimOnTrack$1,
    shimPeerConnection: $2d7d9af7a5367cf4$var$shimPeerConnection$1,
    shimSenderReceiverGetStats: $2d7d9af7a5367cf4$var$shimSenderReceiverGetStats
});
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ function $2d7d9af7a5367cf4$var$shimGetUserMedia$1(window1, browserDetails) {
    const navigator1 = window1 && window1.navigator;
    const MediaStreamTrack1 = window1 && window1.MediaStreamTrack;
    navigator1.getUserMedia = function(constraints, onSuccess, onError) {
        // Replace Firefox 44+'s deprecation warning with unprefixed version.
        $2d7d9af7a5367cf4$var$deprecated('navigator.getUserMedia', 'navigator.mediaDevices.getUserMedia');
        navigator1.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
    };
    if (!(browserDetails.version > 55 && 'autoGainControl' in navigator1.mediaDevices.getSupportedConstraints())) {
        const remap = function(obj, a, b) {
            if (a in obj && !(b in obj)) {
                obj[b] = obj[a];
                delete obj[a];
            }
        };
        const nativeGetUserMedia = navigator1.mediaDevices.getUserMedia.bind(navigator1.mediaDevices);
        navigator1.mediaDevices.getUserMedia = function(c) {
            if (typeof c === 'object' && typeof c.audio === 'object') {
                c = JSON.parse(JSON.stringify(c));
                remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
                remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
            }
            return nativeGetUserMedia(c);
        };
        if (MediaStreamTrack1 && MediaStreamTrack1.prototype.getSettings) {
            const nativeGetSettings = MediaStreamTrack1.prototype.getSettings;
            MediaStreamTrack1.prototype.getSettings = function() {
                const obj = nativeGetSettings.apply(this, arguments);
                remap(obj, 'mozAutoGainControl', 'autoGainControl');
                remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
                return obj;
            };
        }
        if (MediaStreamTrack1 && MediaStreamTrack1.prototype.applyConstraints) {
            const nativeApplyConstraints = MediaStreamTrack1.prototype.applyConstraints;
            MediaStreamTrack1.prototype.applyConstraints = function(c) {
                if (this.kind === 'audio' && typeof c === 'object') {
                    c = JSON.parse(JSON.stringify(c));
                    remap(c, 'autoGainControl', 'mozAutoGainControl');
                    remap(c, 'noiseSuppression', 'mozNoiseSuppression');
                }
                return nativeApplyConstraints.apply(this, [
                    c
                ]);
            };
        }
    }
}
/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ function $2d7d9af7a5367cf4$var$shimGetDisplayMedia(window1, preferredMediaSource) {
    if (window1.navigator.mediaDevices && 'getDisplayMedia' in window1.navigator.mediaDevices) return;
    if (!window1.navigator.mediaDevices) return;
    window1.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        if (!(constraints && constraints.video)) {
            const err = new DOMException("getDisplayMedia without video constraints is undefined");
            err.name = 'NotFoundError';
            // from https://heycam.github.io/webidl/#idl-DOMException-error-names
            err.code = 8;
            return Promise.reject(err);
        }
        if (constraints.video === true) constraints.video = {
            mediaSource: preferredMediaSource
        };
        else constraints.video.mediaSource = preferredMediaSource;
        return window1.navigator.mediaDevices.getUserMedia(constraints);
    };
}
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ function $2d7d9af7a5367cf4$var$shimOnTrack(window1) {
    if (typeof window1 === 'object' && window1.RTCTrackEvent && 'receiver' in window1.RTCTrackEvent.prototype && !('transceiver' in window1.RTCTrackEvent.prototype)) Object.defineProperty(window1.RTCTrackEvent.prototype, 'transceiver', {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $2d7d9af7a5367cf4$var$shimPeerConnection(window1, browserDetails) {
    if (typeof window1 !== 'object' || !(window1.RTCPeerConnection || window1.mozRTCPeerConnection)) return; // probably media.peerconnection.enabled=false in about:config
    if (!window1.RTCPeerConnection && window1.mozRTCPeerConnection) // very basic support for old versions.
    window1.RTCPeerConnection = window1.mozRTCPeerConnection;
    if (browserDetails.version < 53) // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    [
        'setLocalDescription',
        'setRemoteDescription',
        'addIceCandidate'
    ].forEach(function(method) {
        const nativeMethod = window1.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === 'addIceCandidate' ? window1.RTCIceCandidate : window1.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window1.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const modernStatsTypes = {
        inboundrtp: 'inbound-rtp',
        outboundrtp: 'outbound-rtp',
        candidatepair: 'candidate-pair',
        localcandidate: 'local-candidate',
        remotecandidate: 'remote-candidate'
    };
    const nativeGetStats = window1.RTCPeerConnection.prototype.getStats;
    window1.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        return nativeGetStats.apply(this, [
            selector || null
        ]).then((stats)=>{
            if (browserDetails.version < 53 && !onSucc) // Shim only promise getStats with spec-hyphens in type names
            // Leave callback version alone; misc old uses of forEach before Map
            try {
                stats.forEach((stat)=>{
                    stat.type = modernStatsTypes[stat.type] || stat.type;
                });
            } catch (e) {
                if (e.name !== 'TypeError') throw e;
                // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
                stats.forEach((stat, i)=>{
                    stats.set(i, Object.assign({}, stat, {
                        type: modernStatsTypes[stat.type] || stat.type
                    }));
                });
            }
            return stats;
        }).then(onSucc, onErr);
    };
}
function $2d7d9af7a5367cf4$var$shimSenderGetStats(window1) {
    if (!(typeof window1 === 'object' && window1.RTCPeerConnection && window1.RTCRtpSender)) return;
    if (window1.RTCRtpSender && 'getStats' in window1.RTCRtpSender.prototype) return;
    const origGetSenders = window1.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) window1.RTCPeerConnection.prototype.getSenders = function getSenders() {
        const senders = origGetSenders.apply(this, []);
        senders.forEach((sender)=>sender._pc = this);
        return senders;
    };
    const origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) window1.RTCPeerConnection.prototype.addTrack = function addTrack() {
        const sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
    };
    window1.RTCRtpSender.prototype.getStats = function getStats() {
        return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
    };
}
function $2d7d9af7a5367cf4$var$shimReceiverGetStats(window1) {
    if (!(typeof window1 === 'object' && window1.RTCPeerConnection && window1.RTCRtpSender)) return;
    if (window1.RTCRtpSender && 'getStats' in window1.RTCRtpReceiver.prototype) return;
    const origGetReceivers = window1.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) window1.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
        const receivers = origGetReceivers.apply(this, []);
        receivers.forEach((receiver)=>receiver._pc = this);
        return receivers;
    };
    $2d7d9af7a5367cf4$var$wrapPeerConnectionEvent(window1, 'track', (e)=>{
        e.receiver._pc = e.srcElement;
        return e;
    });
    window1.RTCRtpReceiver.prototype.getStats = function getStats() {
        return this._pc.getStats(this.track);
    };
}
function $2d7d9af7a5367cf4$var$shimRemoveStream(window1) {
    if (!window1.RTCPeerConnection || 'removeStream' in window1.RTCPeerConnection.prototype) return;
    window1.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        $2d7d9af7a5367cf4$var$deprecated('removeStream', 'removeTrack');
        this.getSenders().forEach((sender)=>{
            if (sender.track && stream.getTracks().includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $2d7d9af7a5367cf4$var$shimRTCDataChannel(window1) {
    // rename DataChannel to RTCDataChannel (native fix in FF60):
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
    if (window1.DataChannel && !window1.RTCDataChannel) window1.RTCDataChannel = window1.DataChannel;
}
function $2d7d9af7a5367cf4$var$shimAddTransceiver(window1) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window1 === 'object' && window1.RTCPeerConnection)) return;
    const origAddTransceiver = window1.RTCPeerConnection.prototype.addTransceiver;
    if (origAddTransceiver) window1.RTCPeerConnection.prototype.addTransceiver = function addTransceiver() {
        this.setParametersPromises = [];
        // WebIDL input coercion and validation
        let sendEncodings = arguments[1] && arguments[1].sendEncodings;
        if (sendEncodings === undefined) sendEncodings = [];
        sendEncodings = [
            ...sendEncodings
        ];
        const shouldPerformCheck = sendEncodings.length > 0;
        if (shouldPerformCheck) // If sendEncodings params are provided, validate grammar
        sendEncodings.forEach((encodingParam)=>{
            if ('rid' in encodingParam) {
                const ridRegex = /^[a-z0-9]{0,16}$/i;
                if (!ridRegex.test(encodingParam.rid)) throw new TypeError('Invalid RID value provided.');
            }
            if ('scaleResolutionDownBy' in encodingParam) {
                if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1.0)) throw new RangeError('scale_resolution_down_by must be >= 1.0');
            }
            if ('maxFramerate' in encodingParam) {
                if (!(parseFloat(encodingParam.maxFramerate) >= 0)) throw new RangeError('max_framerate must be >= 0.0');
            }
        });
        const transceiver = origAddTransceiver.apply(this, arguments);
        if (shouldPerformCheck) {
            // Check if the init options were applied. If not we do this in an
            // asynchronous way and save the promise reference in a global object.
            // This is an ugly hack, but at the same time is way more robust than
            // checking the sender parameters before and after the createOffer
            // Also note that after the createoffer we are not 100% sure that
            // the params were asynchronously applied so we might miss the
            // opportunity to recreate offer.
            const { sender: sender } = transceiver;
            const params = sender.getParameters();
            if (!('encodings' in params) || // Avoid being fooled by patched getParameters() below.
            params.encodings.length === 1 && Object.keys(params.encodings[0]).length === 0) {
                params.encodings = sendEncodings;
                sender.sendEncodings = sendEncodings;
                this.setParametersPromises.push(sender.setParameters(params).then(()=>{
                    delete sender.sendEncodings;
                }).catch(()=>{
                    delete sender.sendEncodings;
                }));
            }
        }
        return transceiver;
    };
}
function $2d7d9af7a5367cf4$var$shimGetParameters(window1) {
    if (!(typeof window1 === 'object' && window1.RTCRtpSender)) return;
    const origGetParameters = window1.RTCRtpSender.prototype.getParameters;
    if (origGetParameters) window1.RTCRtpSender.prototype.getParameters = function getParameters() {
        const params = origGetParameters.apply(this, arguments);
        if (!('encodings' in params)) params.encodings = [].concat(this.sendEncodings || [
            {}
        ]);
        return params;
    };
}
function $2d7d9af7a5367cf4$var$shimCreateOffer(window1) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window1 === 'object' && window1.RTCPeerConnection)) return;
    const origCreateOffer = window1.RTCPeerConnection.prototype.createOffer;
    window1.RTCPeerConnection.prototype.createOffer = function createOffer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateOffer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateOffer.apply(this, arguments);
    };
}
function $2d7d9af7a5367cf4$var$shimCreateAnswer(window1) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window1 === 'object' && window1.RTCPeerConnection)) return;
    const origCreateAnswer = window1.RTCPeerConnection.prototype.createAnswer;
    window1.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateAnswer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateAnswer.apply(this, arguments);
    };
}
var $2d7d9af7a5367cf4$var$firefoxShim = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    shimAddTransceiver: $2d7d9af7a5367cf4$var$shimAddTransceiver,
    shimCreateAnswer: $2d7d9af7a5367cf4$var$shimCreateAnswer,
    shimCreateOffer: $2d7d9af7a5367cf4$var$shimCreateOffer,
    shimGetDisplayMedia: $2d7d9af7a5367cf4$var$shimGetDisplayMedia,
    shimGetParameters: $2d7d9af7a5367cf4$var$shimGetParameters,
    shimGetUserMedia: $2d7d9af7a5367cf4$var$shimGetUserMedia$1,
    shimOnTrack: $2d7d9af7a5367cf4$var$shimOnTrack,
    shimPeerConnection: $2d7d9af7a5367cf4$var$shimPeerConnection,
    shimRTCDataChannel: $2d7d9af7a5367cf4$var$shimRTCDataChannel,
    shimReceiverGetStats: $2d7d9af7a5367cf4$var$shimReceiverGetStats,
    shimRemoveStream: $2d7d9af7a5367cf4$var$shimRemoveStream,
    shimSenderGetStats: $2d7d9af7a5367cf4$var$shimSenderGetStats
});
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ function $2d7d9af7a5367cf4$var$shimLocalStreamsAPI(window1) {
    if (typeof window1 !== 'object' || !window1.RTCPeerConnection) return;
    if (!('getLocalStreams' in window1.RTCPeerConnection.prototype)) window1.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        if (!this._localStreams) this._localStreams = [];
        return this._localStreams;
    };
    if (!('addStream' in window1.RTCPeerConnection.prototype)) {
        const _addTrack = window1.RTCPeerConnection.prototype.addTrack;
        window1.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            if (!this._localStreams) this._localStreams = [];
            if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            // Try to emulate Chrome's behaviour of adding in audio-video order.
            // Safari orders by track id.
            stream.getAudioTracks().forEach((track)=>_addTrack.call(this, track, stream));
            stream.getVideoTracks().forEach((track)=>_addTrack.call(this, track, stream));
        };
        window1.RTCPeerConnection.prototype.addTrack = function addTrack(track) {
            for(var _len = arguments.length, streams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)streams[_key - 1] = arguments[_key];
            if (streams) streams.forEach((stream)=>{
                if (!this._localStreams) this._localStreams = [
                    stream
                ];
                else if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            });
            return _addTrack.apply(this, arguments);
        };
    }
    if (!('removeStream' in window1.RTCPeerConnection.prototype)) window1.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        if (!this._localStreams) this._localStreams = [];
        const index = this._localStreams.indexOf(stream);
        if (index === -1) return;
        this._localStreams.splice(index, 1);
        const tracks = stream.getTracks();
        this.getSenders().forEach((sender)=>{
            if (tracks.includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $2d7d9af7a5367cf4$var$shimRemoteStreamsAPI(window1) {
    if (typeof window1 !== 'object' || !window1.RTCPeerConnection) return;
    if (!('getRemoteStreams' in window1.RTCPeerConnection.prototype)) window1.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
        return this._remoteStreams ? this._remoteStreams : [];
    };
    if (!('onaddstream' in window1.RTCPeerConnection.prototype)) {
        Object.defineProperty(window1.RTCPeerConnection.prototype, 'onaddstream', {
            get () {
                return this._onaddstream;
            },
            set (f) {
                if (this._onaddstream) {
                    this.removeEventListener('addstream', this._onaddstream);
                    this.removeEventListener('track', this._onaddstreampoly);
                }
                this.addEventListener('addstream', this._onaddstream = f);
                this.addEventListener('track', this._onaddstreampoly = (e)=>{
                    e.streams.forEach((stream)=>{
                        if (!this._remoteStreams) this._remoteStreams = [];
                        if (this._remoteStreams.includes(stream)) return;
                        this._remoteStreams.push(stream);
                        const event = new Event('addstream');
                        event.stream = stream;
                        this.dispatchEvent(event);
                    });
                });
            }
        });
        const origSetRemoteDescription = window1.RTCPeerConnection.prototype.setRemoteDescription;
        window1.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            const pc = this;
            if (!this._onaddstreampoly) this.addEventListener('track', this._onaddstreampoly = function(e) {
                e.streams.forEach((stream)=>{
                    if (!pc._remoteStreams) pc._remoteStreams = [];
                    if (pc._remoteStreams.indexOf(stream) >= 0) return;
                    pc._remoteStreams.push(stream);
                    const event = new Event('addstream');
                    event.stream = stream;
                    pc.dispatchEvent(event);
                });
            });
            return origSetRemoteDescription.apply(pc, arguments);
        };
    }
}
function $2d7d9af7a5367cf4$var$shimCallbacksAPI(window1) {
    if (typeof window1 !== 'object' || !window1.RTCPeerConnection) return;
    const prototype = window1.RTCPeerConnection.prototype;
    const origCreateOffer = prototype.createOffer;
    const origCreateAnswer = prototype.createAnswer;
    const setLocalDescription = prototype.setLocalDescription;
    const setRemoteDescription = prototype.setRemoteDescription;
    const addIceCandidate = prototype.addIceCandidate;
    prototype.createOffer = function createOffer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateOffer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateAnswer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    let withCallback = function(description, successCallback, failureCallback) {
        const promise = setLocalDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setLocalDescription = withCallback;
    withCallback = function(description, successCallback, failureCallback) {
        const promise = setRemoteDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setRemoteDescription = withCallback;
    withCallback = function(candidate, successCallback, failureCallback) {
        const promise = addIceCandidate.apply(this, [
            candidate
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.addIceCandidate = withCallback;
}
function $2d7d9af7a5367cf4$var$shimGetUserMedia(window1) {
    const navigator1 = window1 && window1.navigator;
    if (navigator1.mediaDevices && navigator1.mediaDevices.getUserMedia) {
        // shim not needed in Safari 12.1
        const mediaDevices = navigator1.mediaDevices;
        const _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
        navigator1.mediaDevices.getUserMedia = (constraints)=>{
            return _getUserMedia($2d7d9af7a5367cf4$var$shimConstraints(constraints));
        };
    }
    if (!navigator1.getUserMedia && navigator1.mediaDevices && navigator1.mediaDevices.getUserMedia) navigator1.getUserMedia = (function getUserMedia(constraints, cb, errcb) {
        navigator1.mediaDevices.getUserMedia(constraints).then(cb, errcb);
    }).bind(navigator1);
}
function $2d7d9af7a5367cf4$var$shimConstraints(constraints) {
    if (constraints && constraints.video !== undefined) return Object.assign({}, constraints, {
        video: $2d7d9af7a5367cf4$var$compactObject(constraints.video)
    });
    return constraints;
}
function $2d7d9af7a5367cf4$var$shimRTCIceServerUrls(window1) {
    if (!window1.RTCPeerConnection) return;
    // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
    const OrigPeerConnection = window1.RTCPeerConnection;
    window1.RTCPeerConnection = function RTCPeerConnection1(pcConfig, pcConstraints) {
        if (pcConfig && pcConfig.iceServers) {
            const newIceServers = [];
            for(let i = 0; i < pcConfig.iceServers.length; i++){
                let server = pcConfig.iceServers[i];
                if (server.urls === undefined && server.url) {
                    $2d7d9af7a5367cf4$var$deprecated('RTCIceServer.url', 'RTCIceServer.urls');
                    server = JSON.parse(JSON.stringify(server));
                    server.urls = server.url;
                    delete server.url;
                    newIceServers.push(server);
                } else newIceServers.push(pcConfig.iceServers[i]);
            }
            pcConfig.iceServers = newIceServers;
        }
        return new OrigPeerConnection(pcConfig, pcConstraints);
    };
    window1.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
    // wrap static methods. Currently just generateCertificate.
    if ('generateCertificate' in OrigPeerConnection) Object.defineProperty(window1.RTCPeerConnection, 'generateCertificate', {
        get () {
            return OrigPeerConnection.generateCertificate;
        }
    });
}
function $2d7d9af7a5367cf4$var$shimTrackEventTransceiver(window1) {
    // Add event.transceiver member over deprecated event.receiver
    if (typeof window1 === 'object' && window1.RTCTrackEvent && 'receiver' in window1.RTCTrackEvent.prototype && !('transceiver' in window1.RTCTrackEvent.prototype)) Object.defineProperty(window1.RTCTrackEvent.prototype, 'transceiver', {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $2d7d9af7a5367cf4$var$shimCreateOfferLegacy(window1) {
    const origCreateOffer = window1.RTCPeerConnection.prototype.createOffer;
    window1.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
        if (offerOptions) {
            if (typeof offerOptions.offerToReceiveAudio !== 'undefined') // support bit values
            offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
            const audioTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === 'audio');
            if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
                if (audioTransceiver.direction === 'sendrecv') {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection('sendonly');
                    else audioTransceiver.direction = 'sendonly';
                } else if (audioTransceiver.direction === 'recvonly') {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection('inactive');
                    else audioTransceiver.direction = 'inactive';
                }
            } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) this.addTransceiver('audio', {
                direction: 'recvonly'
            });
            if (typeof offerOptions.offerToReceiveVideo !== 'undefined') // support bit values
            offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
            const videoTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === 'video');
            if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
                if (videoTransceiver.direction === 'sendrecv') {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection('sendonly');
                    else videoTransceiver.direction = 'sendonly';
                } else if (videoTransceiver.direction === 'recvonly') {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection('inactive');
                    else videoTransceiver.direction = 'inactive';
                }
            } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) this.addTransceiver('video', {
                direction: 'recvonly'
            });
        }
        return origCreateOffer.apply(this, arguments);
    };
}
function $2d7d9af7a5367cf4$var$shimAudioContext(window1) {
    if (typeof window1 !== 'object' || window1.AudioContext) return;
    window1.AudioContext = window1.webkitAudioContext;
}
var $2d7d9af7a5367cf4$var$safariShim = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    shimAudioContext: $2d7d9af7a5367cf4$var$shimAudioContext,
    shimCallbacksAPI: $2d7d9af7a5367cf4$var$shimCallbacksAPI,
    shimConstraints: $2d7d9af7a5367cf4$var$shimConstraints,
    shimCreateOfferLegacy: $2d7d9af7a5367cf4$var$shimCreateOfferLegacy,
    shimGetUserMedia: $2d7d9af7a5367cf4$var$shimGetUserMedia,
    shimLocalStreamsAPI: $2d7d9af7a5367cf4$var$shimLocalStreamsAPI,
    shimRTCIceServerUrls: $2d7d9af7a5367cf4$var$shimRTCIceServerUrls,
    shimRemoteStreamsAPI: $2d7d9af7a5367cf4$var$shimRemoteStreamsAPI,
    shimTrackEventTransceiver: $2d7d9af7a5367cf4$var$shimTrackEventTransceiver
});
var $2d7d9af7a5367cf4$var$sdp$1 = {
    exports: {}
};
/* eslint-env node */ var $2d7d9af7a5367cf4$var$hasRequiredSdp;
function $2d7d9af7a5367cf4$var$requireSdp() {
    if ($2d7d9af7a5367cf4$var$hasRequiredSdp) return $2d7d9af7a5367cf4$var$sdp$1.exports;
    $2d7d9af7a5367cf4$var$hasRequiredSdp = 1;
    (function(module) {
        // SDP helpers.
        const SDPUtils = {};
        // Generate an alphanumeric identifier for cname or mids.
        // TODO: use UUIDs instead? https://gist.github.com/jed/982883
        SDPUtils.generateIdentifier = function() {
            return Math.random().toString(36).substring(2, 12);
        };
        // The RTCP CNAME used by all peerconnections from the same JS.
        SDPUtils.localCName = SDPUtils.generateIdentifier();
        // Splits SDP into lines, dealing with both CRLF and LF.
        SDPUtils.splitLines = function(blob) {
            return blob.trim().split('\n').map((line)=>line.trim());
        };
        // Splits SDP into sessionpart and mediasections. Ensures CRLF.
        SDPUtils.splitSections = function(blob) {
            const parts = blob.split('\nm=');
            return parts.map((part, index)=>(index > 0 ? 'm=' + part : part).trim() + '\r\n');
        };
        // Returns the session description.
        SDPUtils.getDescription = function(blob) {
            const sections = SDPUtils.splitSections(blob);
            return sections && sections[0];
        };
        // Returns the individual media sections.
        SDPUtils.getMediaSections = function(blob) {
            const sections = SDPUtils.splitSections(blob);
            sections.shift();
            return sections;
        };
        // Returns lines that start with a certain prefix.
        SDPUtils.matchPrefix = function(blob, prefix) {
            return SDPUtils.splitLines(blob).filter((line)=>line.indexOf(prefix) === 0);
        };
        // Parses an ICE candidate line. Sample input:
        // candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
        // rport 55996"
        // Input can be prefixed with a=.
        SDPUtils.parseCandidate = function(line) {
            let parts;
            // Parse both variants.
            if (line.indexOf('a=candidate:') === 0) parts = line.substring(12).split(' ');
            else parts = line.substring(10).split(' ');
            const candidate = {
                foundation: parts[0],
                component: {
                    1: 'rtp',
                    2: 'rtcp'
                }[parts[1]] || parts[1],
                protocol: parts[2].toLowerCase(),
                priority: parseInt(parts[3], 10),
                ip: parts[4],
                address: parts[4],
                // address is an alias for ip.
                port: parseInt(parts[5], 10),
                // skip parts[6] == 'typ'
                type: parts[7]
            };
            for(let i = 8; i < parts.length; i += 2)switch(parts[i]){
                case 'raddr':
                    candidate.relatedAddress = parts[i + 1];
                    break;
                case 'rport':
                    candidate.relatedPort = parseInt(parts[i + 1], 10);
                    break;
                case 'tcptype':
                    candidate.tcpType = parts[i + 1];
                    break;
                case 'ufrag':
                    candidate.ufrag = parts[i + 1]; // for backward compatibility.
                    candidate.usernameFragment = parts[i + 1];
                    break;
                default:
                    // extension handling, in particular ufrag. Don't overwrite.
                    if (candidate[parts[i]] === undefined) candidate[parts[i]] = parts[i + 1];
                    break;
            }
            return candidate;
        };
        // Translates a candidate object into SDP candidate attribute.
        // This does not include the a= prefix!
        SDPUtils.writeCandidate = function(candidate) {
            const sdp = [];
            sdp.push(candidate.foundation);
            const component = candidate.component;
            if (component === 'rtp') sdp.push(1);
            else if (component === 'rtcp') sdp.push(2);
            else sdp.push(component);
            sdp.push(candidate.protocol.toUpperCase());
            sdp.push(candidate.priority);
            sdp.push(candidate.address || candidate.ip);
            sdp.push(candidate.port);
            const type = candidate.type;
            sdp.push('typ');
            sdp.push(type);
            if (type !== 'host' && candidate.relatedAddress && candidate.relatedPort) {
                sdp.push('raddr');
                sdp.push(candidate.relatedAddress);
                sdp.push('rport');
                sdp.push(candidate.relatedPort);
            }
            if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
                sdp.push('tcptype');
                sdp.push(candidate.tcpType);
            }
            if (candidate.usernameFragment || candidate.ufrag) {
                sdp.push('ufrag');
                sdp.push(candidate.usernameFragment || candidate.ufrag);
            }
            return 'candidate:' + sdp.join(' ');
        };
        // Parses an ice-options line, returns an array of option tags.
        // Sample input:
        // a=ice-options:foo bar
        SDPUtils.parseIceOptions = function(line) {
            return line.substring(14).split(' ');
        };
        // Parses a rtpmap line, returns RTCRtpCoddecParameters. Sample input:
        // a=rtpmap:111 opus/48000/2
        SDPUtils.parseRtpMap = function(line) {
            let parts = line.substring(9).split(' ');
            const parsed = {
                payloadType: parseInt(parts.shift(), 10) // was: id
            };
            parts = parts[0].split('/');
            parsed.name = parts[0];
            parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
            parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
            // legacy alias, got renamed back to channels in ORTC.
            parsed.numChannels = parsed.channels;
            return parsed;
        };
        // Generates a rtpmap line from RTCRtpCodecCapability or
        // RTCRtpCodecParameters.
        SDPUtils.writeRtpMap = function(codec) {
            let pt = codec.payloadType;
            if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
            const channels = codec.channels || codec.numChannels || 1;
            return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate + (channels !== 1 ? '/' + channels : '') + '\r\n';
        };
        // Parses a extmap line (headerextension from RFC 5285). Sample input:
        // a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
        // a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
        SDPUtils.parseExtmap = function(line) {
            const parts = line.substring(9).split(' ');
            return {
                id: parseInt(parts[0], 10),
                direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
                uri: parts[1],
                attributes: parts.slice(2).join(' ')
            };
        };
        // Generates an extmap line from RTCRtpHeaderExtensionParameters or
        // RTCRtpHeaderExtension.
        SDPUtils.writeExtmap = function(headerExtension) {
            return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== 'sendrecv' ? '/' + headerExtension.direction : '') + ' ' + headerExtension.uri + (headerExtension.attributes ? ' ' + headerExtension.attributes : '') + '\r\n';
        };
        // Parses a fmtp line, returns dictionary. Sample input:
        // a=fmtp:96 vbr=on;cng=on
        // Also deals with vbr=on; cng=on
        SDPUtils.parseFmtp = function(line) {
            const parsed = {};
            let kv;
            const parts = line.substring(line.indexOf(' ') + 1).split(';');
            for(let j = 0; j < parts.length; j++){
                kv = parts[j].trim().split('=');
                parsed[kv[0].trim()] = kv[1];
            }
            return parsed;
        };
        // Generates a fmtp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
        SDPUtils.writeFmtp = function(codec) {
            let line = '';
            let pt = codec.payloadType;
            if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
            if (codec.parameters && Object.keys(codec.parameters).length) {
                const params = [];
                Object.keys(codec.parameters).forEach((param)=>{
                    if (codec.parameters[param] !== undefined) params.push(param + '=' + codec.parameters[param]);
                    else params.push(param);
                });
                line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
            }
            return line;
        };
        // Parses a rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
        // a=rtcp-fb:98 nack rpsi
        SDPUtils.parseRtcpFb = function(line) {
            const parts = line.substring(line.indexOf(' ') + 1).split(' ');
            return {
                type: parts.shift(),
                parameter: parts.join(' ')
            };
        };
        // Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
        SDPUtils.writeRtcpFb = function(codec) {
            let lines = '';
            let pt = codec.payloadType;
            if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
            if (codec.rtcpFeedback && codec.rtcpFeedback.length) // FIXME: special handling for trr-int?
            codec.rtcpFeedback.forEach((fb)=>{
                lines += 'a=rtcp-fb:' + pt + ' ' + fb.type + (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') + '\r\n';
            });
            return lines;
        };
        // Parses a RFC 5576 ssrc media attribute. Sample input:
        // a=ssrc:3735928559 cname:something
        SDPUtils.parseSsrcMedia = function(line) {
            const sp = line.indexOf(' ');
            const parts = {
                ssrc: parseInt(line.substring(7, sp), 10)
            };
            const colon = line.indexOf(':', sp);
            if (colon > -1) {
                parts.attribute = line.substring(sp + 1, colon);
                parts.value = line.substring(colon + 1);
            } else parts.attribute = line.substring(sp + 1);
            return parts;
        };
        // Parse a ssrc-group line (see RFC 5576). Sample input:
        // a=ssrc-group:semantics 12 34
        SDPUtils.parseSsrcGroup = function(line) {
            const parts = line.substring(13).split(' ');
            return {
                semantics: parts.shift(),
                ssrcs: parts.map((ssrc)=>parseInt(ssrc, 10))
            };
        };
        // Extracts the MID (RFC 5888) from a media section.
        // Returns the MID or undefined if no mid line was found.
        SDPUtils.getMid = function(mediaSection) {
            const mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
            if (mid) return mid.substring(6);
        };
        // Parses a fingerprint line for DTLS-SRTP.
        SDPUtils.parseFingerprint = function(line) {
            const parts = line.substring(14).split(' ');
            return {
                algorithm: parts[0].toLowerCase(),
                // algorithm is case-sensitive in Edge.
                value: parts[1].toUpperCase() // the definition is upper-case in RFC 4572.
            };
        };
        // Extracts DTLS parameters from SDP media section or sessionpart.
        // FIXME: for consistency with other functions this should only
        //   get the fingerprint line as input. See also getIceParameters.
        SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
            const lines = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=fingerprint:');
            // Note: a=setup line is ignored since we use the 'auto' role in Edge.
            return {
                role: 'auto',
                fingerprints: lines.map(SDPUtils.parseFingerprint)
            };
        };
        // Serializes DTLS parameters to SDP.
        SDPUtils.writeDtlsParameters = function(params, setupType) {
            let sdp = 'a=setup:' + setupType + '\r\n';
            params.fingerprints.forEach((fp)=>{
                sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
            });
            return sdp;
        };
        // Parses a=crypto lines into
        //   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
        SDPUtils.parseCryptoLine = function(line) {
            const parts = line.substring(9).split(' ');
            return {
                tag: parseInt(parts[0], 10),
                cryptoSuite: parts[1],
                keyParams: parts[2],
                sessionParams: parts.slice(3)
            };
        };
        SDPUtils.writeCryptoLine = function(parameters) {
            return 'a=crypto:' + parameters.tag + ' ' + parameters.cryptoSuite + ' ' + (typeof parameters.keyParams === 'object' ? SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? ' ' + parameters.sessionParams.join(' ') : '') + '\r\n';
        };
        // Parses the crypto key parameters into
        //   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
        SDPUtils.parseCryptoKeyParams = function(keyParams) {
            if (keyParams.indexOf('inline:') !== 0) return null;
            const parts = keyParams.substring(7).split('|');
            return {
                keyMethod: 'inline',
                keySalt: parts[0],
                lifeTime: parts[1],
                mkiValue: parts[2] ? parts[2].split(':')[0] : undefined,
                mkiLength: parts[2] ? parts[2].split(':')[1] : undefined
            };
        };
        SDPUtils.writeCryptoKeyParams = function(keyParams) {
            return keyParams.keyMethod + ':' + keyParams.keySalt + (keyParams.lifeTime ? '|' + keyParams.lifeTime : '') + (keyParams.mkiValue && keyParams.mkiLength ? '|' + keyParams.mkiValue + ':' + keyParams.mkiLength : '');
        };
        // Extracts all SDES parameters.
        SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
            const lines = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=crypto:');
            return lines.map(SDPUtils.parseCryptoLine);
        };
        // Parses ICE information from SDP media section or sessionpart.
        // FIXME: for consistency with other functions this should only
        //   get the ice-ufrag and ice-pwd lines as input.
        SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
            const ufrag = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-ufrag:')[0];
            const pwd = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-pwd:')[0];
            if (!(ufrag && pwd)) return null;
            return {
                usernameFragment: ufrag.substring(12),
                password: pwd.substring(10)
            };
        };
        // Serializes ICE parameters to SDP.
        SDPUtils.writeIceParameters = function(params) {
            let sdp = 'a=ice-ufrag:' + params.usernameFragment + '\r\n' + 'a=ice-pwd:' + params.password + '\r\n';
            if (params.iceLite) sdp += 'a=ice-lite\r\n';
            return sdp;
        };
        // Parses the SDP media section and returns RTCRtpParameters.
        SDPUtils.parseRtpParameters = function(mediaSection) {
            const description = {
                codecs: [],
                headerExtensions: [],
                fecMechanisms: [],
                rtcp: []
            };
            const lines = SDPUtils.splitLines(mediaSection);
            const mline = lines[0].split(' ');
            description.profile = mline[2];
            for(let i = 3; i < mline.length; i++){
                // find all codecs from mline[3..]
                const pt = mline[i];
                const rtpmapline = SDPUtils.matchPrefix(mediaSection, 'a=rtpmap:' + pt + ' ')[0];
                if (rtpmapline) {
                    const codec = SDPUtils.parseRtpMap(rtpmapline);
                    const fmtps = SDPUtils.matchPrefix(mediaSection, 'a=fmtp:' + pt + ' ');
                    // Only the first a=fmtp:<pt> is considered.
                    codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
                    codec.rtcpFeedback = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-fb:' + pt + ' ').map(SDPUtils.parseRtcpFb);
                    description.codecs.push(codec);
                    // parse FEC mechanisms from rtpmap lines.
                    switch(codec.name.toUpperCase()){
                        case 'RED':
                        case 'ULPFEC':
                            description.fecMechanisms.push(codec.name.toUpperCase());
                            break;
                    }
                }
            }
            SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach((line)=>{
                description.headerExtensions.push(SDPUtils.parseExtmap(line));
            });
            const wildcardRtcpFb = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-fb:* ').map(SDPUtils.parseRtcpFb);
            description.codecs.forEach((codec)=>{
                wildcardRtcpFb.forEach((fb)=>{
                    const duplicate = codec.rtcpFeedback.find((existingFeedback)=>{
                        return existingFeedback.type === fb.type && existingFeedback.parameter === fb.parameter;
                    });
                    if (!duplicate) codec.rtcpFeedback.push(fb);
                });
            });
            // FIXME: parse rtcp.
            return description;
        };
        // Generates parts of the SDP media section describing the capabilities /
        // parameters.
        SDPUtils.writeRtpDescription = function(kind, caps) {
            let sdp = '';
            // Build the mline.
            sdp += 'm=' + kind + ' ';
            sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.
            sdp += ' ' + (caps.profile || 'UDP/TLS/RTP/SAVPF') + ' ';
            sdp += caps.codecs.map((codec)=>{
                if (codec.preferredPayloadType !== undefined) return codec.preferredPayloadType;
                return codec.payloadType;
            }).join(' ') + '\r\n';
            sdp += 'c=IN IP4 0.0.0.0\r\n';
            sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';
            // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
            caps.codecs.forEach((codec)=>{
                sdp += SDPUtils.writeRtpMap(codec);
                sdp += SDPUtils.writeFmtp(codec);
                sdp += SDPUtils.writeRtcpFb(codec);
            });
            let maxptime = 0;
            caps.codecs.forEach((codec)=>{
                if (codec.maxptime > maxptime) maxptime = codec.maxptime;
            });
            if (maxptime > 0) sdp += 'a=maxptime:' + maxptime + '\r\n';
            if (caps.headerExtensions) caps.headerExtensions.forEach((extension)=>{
                sdp += SDPUtils.writeExtmap(extension);
            });
            // FIXME: write fecMechanisms.
            return sdp;
        };
        // Parses the SDP media section and returns an array of
        // RTCRtpEncodingParameters.
        SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
            const encodingParameters = [];
            const description = SDPUtils.parseRtpParameters(mediaSection);
            const hasRed = description.fecMechanisms.indexOf('RED') !== -1;
            const hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;
            // filter a=ssrc:... cname:, ignore PlanB-msid
            const ssrcs = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map((line)=>SDPUtils.parseSsrcMedia(line)).filter((parts)=>parts.attribute === 'cname');
            const primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
            let secondarySsrc;
            const flows = SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID').map((line)=>{
                const parts = line.substring(17).split(' ');
                return parts.map((part)=>parseInt(part, 10));
            });
            if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) secondarySsrc = flows[0][1];
            description.codecs.forEach((codec)=>{
                if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
                    let encParam = {
                        ssrc: primarySsrc,
                        codecPayloadType: parseInt(codec.parameters.apt, 10)
                    };
                    if (primarySsrc && secondarySsrc) encParam.rtx = {
                        ssrc: secondarySsrc
                    };
                    encodingParameters.push(encParam);
                    if (hasRed) {
                        encParam = JSON.parse(JSON.stringify(encParam));
                        encParam.fec = {
                            ssrc: primarySsrc,
                            mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
                        };
                        encodingParameters.push(encParam);
                    }
                }
            });
            if (encodingParameters.length === 0 && primarySsrc) encodingParameters.push({
                ssrc: primarySsrc
            });
            // we support both b=AS and b=TIAS but interpret AS as TIAS.
            let bandwidth = SDPUtils.matchPrefix(mediaSection, 'b=');
            if (bandwidth.length) {
                if (bandwidth[0].indexOf('b=TIAS:') === 0) bandwidth = parseInt(bandwidth[0].substring(7), 10);
                else if (bandwidth[0].indexOf('b=AS:') === 0) // use formula from JSEP to convert b=AS to TIAS value.
                bandwidth = parseInt(bandwidth[0].substring(5), 10) * 950 - 16000;
                else bandwidth = undefined;
                encodingParameters.forEach((params)=>{
                    params.maxBitrate = bandwidth;
                });
            }
            return encodingParameters;
        };
        // parses http://draft.ortc.org/#rtcrtcpparameters*
        SDPUtils.parseRtcpParameters = function(mediaSection) {
            const rtcpParameters = {};
            // Gets the first SSRC. Note that with RTX there might be multiple
            // SSRCs.
            const remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map((line)=>SDPUtils.parseSsrcMedia(line)).filter((obj)=>obj.attribute === 'cname')[0];
            if (remoteSsrc) {
                rtcpParameters.cname = remoteSsrc.value;
                rtcpParameters.ssrc = remoteSsrc.ssrc;
            }
            // Edge uses the compound attribute instead of reducedSize
            // compound is !reducedSize
            const rsize = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
            rtcpParameters.reducedSize = rsize.length > 0;
            rtcpParameters.compound = rsize.length === 0;
            // parses the rtcp-mux attrіbute.
            // Note that Edge does not support unmuxed RTCP.
            const mux = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
            rtcpParameters.mux = mux.length > 0;
            return rtcpParameters;
        };
        SDPUtils.writeRtcpParameters = function(rtcpParameters) {
            let sdp = '';
            if (rtcpParameters.reducedSize) sdp += 'a=rtcp-rsize\r\n';
            if (rtcpParameters.mux) sdp += 'a=rtcp-mux\r\n';
            if (rtcpParameters.ssrc !== undefined && rtcpParameters.cname) sdp += 'a=ssrc:' + rtcpParameters.ssrc + ' cname:' + rtcpParameters.cname + '\r\n';
            return sdp;
        };
        // parses either a=msid: or a=ssrc:... msid lines and returns
        // the id of the MediaStream and MediaStreamTrack.
        SDPUtils.parseMsid = function(mediaSection) {
            let parts;
            const spec = SDPUtils.matchPrefix(mediaSection, 'a=msid:');
            if (spec.length === 1) {
                parts = spec[0].substring(7).split(' ');
                return {
                    stream: parts[0],
                    track: parts[1]
                };
            }
            const planB = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map((line)=>SDPUtils.parseSsrcMedia(line)).filter((msidParts)=>msidParts.attribute === 'msid');
            if (planB.length > 0) {
                parts = planB[0].value.split(' ');
                return {
                    stream: parts[0],
                    track: parts[1]
                };
            }
        };
        // SCTP
        // parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
        // to draft-ietf-mmusic-sctp-sdp-05
        SDPUtils.parseSctpDescription = function(mediaSection) {
            const mline = SDPUtils.parseMLine(mediaSection);
            const maxSizeLine = SDPUtils.matchPrefix(mediaSection, 'a=max-message-size:');
            let maxMessageSize;
            if (maxSizeLine.length > 0) maxMessageSize = parseInt(maxSizeLine[0].substring(19), 10);
            if (isNaN(maxMessageSize)) maxMessageSize = 65536;
            const sctpPort = SDPUtils.matchPrefix(mediaSection, 'a=sctp-port:');
            if (sctpPort.length > 0) return {
                port: parseInt(sctpPort[0].substring(12), 10),
                protocol: mline.fmt,
                maxMessageSize: maxMessageSize
            };
            const sctpMapLines = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:');
            if (sctpMapLines.length > 0) {
                const parts = sctpMapLines[0].substring(10).split(' ');
                return {
                    port: parseInt(parts[0], 10),
                    protocol: parts[1],
                    maxMessageSize: maxMessageSize
                };
            }
        };
        // SCTP
        // outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
        // support by now receiving in this format, unless we originally parsed
        // as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
        // protocol of DTLS/SCTP -- without UDP/ or TCP/)
        SDPUtils.writeSctpDescription = function(media, sctp) {
            let output = [];
            if (media.protocol !== 'DTLS/SCTP') output = [
                'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.protocol + '\r\n',
                'c=IN IP4 0.0.0.0\r\n',
                'a=sctp-port:' + sctp.port + '\r\n'
            ];
            else output = [
                'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.port + '\r\n',
                'c=IN IP4 0.0.0.0\r\n',
                'a=sctpmap:' + sctp.port + ' ' + sctp.protocol + ' 65535\r\n'
            ];
            if (sctp.maxMessageSize !== undefined) output.push('a=max-message-size:' + sctp.maxMessageSize + '\r\n');
            return output.join('');
        };
        // Generate a session ID for SDP.
        // https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
        // recommends using a cryptographically random +ve 64-bit value
        // but right now this should be acceptable and within the right range
        SDPUtils.generateSessionId = function() {
            return Math.random().toString().substr(2, 22);
        };
        // Write boiler plate for start of SDP
        // sessId argument is optional - if not supplied it will
        // be generated randomly
        // sessVersion is optional and defaults to 2
        // sessUser is optional and defaults to 'thisisadapterortc'
        SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
            let sessionId;
            const version = sessVer !== undefined ? sessVer : 2;
            if (sessId) sessionId = sessId;
            else sessionId = SDPUtils.generateSessionId();
            const user = sessUser || 'thisisadapterortc';
            // FIXME: sess-id should be an NTP timestamp.
            return "v=0\r\no=" + user + ' ' + sessionId + ' ' + version + ' IN IP4 127.0.0.1\r\n' + 's=-\r\n' + 't=0 0\r\n';
        };
        // Gets the direction from the mediaSection or the sessionpart.
        SDPUtils.getDirection = function(mediaSection, sessionpart) {
            // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
            const lines = SDPUtils.splitLines(mediaSection);
            for(let i = 0; i < lines.length; i++)switch(lines[i]){
                case 'a=sendrecv':
                case 'a=sendonly':
                case 'a=recvonly':
                case 'a=inactive':
                    return lines[i].substring(2);
            }
            if (sessionpart) return SDPUtils.getDirection(sessionpart);
            return 'sendrecv';
        };
        SDPUtils.getKind = function(mediaSection) {
            const lines = SDPUtils.splitLines(mediaSection);
            const mline = lines[0].split(' ');
            return mline[0].substring(2);
        };
        SDPUtils.isRejected = function(mediaSection) {
            return mediaSection.split(' ', 2)[1] === '0';
        };
        SDPUtils.parseMLine = function(mediaSection) {
            const lines = SDPUtils.splitLines(mediaSection);
            const parts = lines[0].substring(2).split(' ');
            return {
                kind: parts[0],
                port: parseInt(parts[1], 10),
                protocol: parts[2],
                fmt: parts.slice(3).join(' ')
            };
        };
        SDPUtils.parseOLine = function(mediaSection) {
            const line = SDPUtils.matchPrefix(mediaSection, 'o=')[0];
            const parts = line.substring(2).split(' ');
            return {
                username: parts[0],
                sessionId: parts[1],
                sessionVersion: parseInt(parts[2], 10),
                netType: parts[3],
                addressType: parts[4],
                address: parts[5]
            };
        };
        // a very naive interpretation of a valid SDP.
        SDPUtils.isValidSDP = function(blob) {
            if (typeof blob !== 'string' || blob.length === 0) return false;
            const lines = SDPUtils.splitLines(blob);
            for(let i = 0; i < lines.length; i++){
                if (lines[i].length < 2 || lines[i].charAt(1) !== '=') return false;
            // TODO: check the modifier a bit more.
            }
            return true;
        };
        module.exports = SDPUtils;
    })($2d7d9af7a5367cf4$var$sdp$1);
    return $2d7d9af7a5367cf4$var$sdp$1.exports;
}
var $2d7d9af7a5367cf4$var$sdpExports = $2d7d9af7a5367cf4$var$requireSdp();
var $2d7d9af7a5367cf4$var$SDPUtils = /*@__PURE__*/ $2d7d9af7a5367cf4$var$getDefaultExportFromCjs($2d7d9af7a5367cf4$var$sdpExports);
var $2d7d9af7a5367cf4$var$sdp = /*#__PURE__*/ $2d7d9af7a5367cf4$var$_mergeNamespaces({
    __proto__: null,
    default: $2d7d9af7a5367cf4$var$SDPUtils
}, [
    $2d7d9af7a5367cf4$var$sdpExports
]);
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ function $2d7d9af7a5367cf4$var$shimRTCIceCandidate(window1) {
    // foundation is arbitrarily chosen as an indicator for full support for
    // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
    if (!window1.RTCIceCandidate || window1.RTCIceCandidate && 'foundation' in window1.RTCIceCandidate.prototype) return;
    const NativeRTCIceCandidate = window1.RTCIceCandidate;
    window1.RTCIceCandidate = function RTCIceCandidate1(args) {
        // Remove the a= which shouldn't be part of the candidate string.
        if (typeof args === 'object' && args.candidate && args.candidate.indexOf('a=') === 0) {
            args = JSON.parse(JSON.stringify(args));
            args.candidate = args.candidate.substring(2);
        }
        if (args.candidate && args.candidate.length) {
            // Augment the native candidate with the parsed fields.
            const nativeCandidate = new NativeRTCIceCandidate(args);
            const parsedCandidate = $2d7d9af7a5367cf4$var$SDPUtils.parseCandidate(args.candidate);
            for(const key in parsedCandidate)if (!(key in nativeCandidate)) Object.defineProperty(nativeCandidate, key, {
                value: parsedCandidate[key]
            });
            // Override serializer to not serialize the extra attributes.
            nativeCandidate.toJSON = function toJSON() {
                return {
                    candidate: nativeCandidate.candidate,
                    sdpMid: nativeCandidate.sdpMid,
                    sdpMLineIndex: nativeCandidate.sdpMLineIndex,
                    usernameFragment: nativeCandidate.usernameFragment
                };
            };
            return nativeCandidate;
        }
        return new NativeRTCIceCandidate(args);
    };
    window1.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $2d7d9af7a5367cf4$var$wrapPeerConnectionEvent(window1, 'icecandidate', (e)=>{
        if (e.candidate) Object.defineProperty(e, 'candidate', {
            value: new window1.RTCIceCandidate(e.candidate),
            writable: 'false'
        });
        return e;
    });
}
function $2d7d9af7a5367cf4$var$shimRTCIceCandidateRelayProtocol(window1) {
    if (!window1.RTCIceCandidate || window1.RTCIceCandidate && 'relayProtocol' in window1.RTCIceCandidate.prototype) return;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $2d7d9af7a5367cf4$var$wrapPeerConnectionEvent(window1, 'icecandidate', (e)=>{
        if (e.candidate) {
            const parsedCandidate = $2d7d9af7a5367cf4$var$SDPUtils.parseCandidate(e.candidate.candidate);
            if (parsedCandidate.type === 'relay') // This is a libwebrtc-specific mapping of local type preference
            // to relayProtocol.
            e.candidate.relayProtocol = ({
                0: 'tls',
                1: 'tcp',
                2: 'udp'
            })[parsedCandidate.priority >> 24];
        }
        return e;
    });
}
function $2d7d9af7a5367cf4$var$shimMaxMessageSize(window1, browserDetails) {
    if (!window1.RTCPeerConnection) return;
    if (!('sctp' in window1.RTCPeerConnection.prototype)) Object.defineProperty(window1.RTCPeerConnection.prototype, 'sctp', {
        get () {
            return typeof this._sctp === 'undefined' ? null : this._sctp;
        }
    });
    const sctpInDescription = function(description) {
        if (!description || !description.sdp) return false;
        const sections = $2d7d9af7a5367cf4$var$SDPUtils.splitSections(description.sdp);
        sections.shift();
        return sections.some((mediaSection)=>{
            const mLine = $2d7d9af7a5367cf4$var$SDPUtils.parseMLine(mediaSection);
            return mLine && mLine.kind === 'application' && mLine.protocol.indexOf('SCTP') !== -1;
        });
    };
    const getRemoteFirefoxVersion = function(description) {
        // TODO: Is there a better solution for detecting Firefox?
        const match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
        if (match === null || match.length < 2) return -1;
        const version = parseInt(match[1], 10);
        // Test for NaN (yes, this is ugly)
        return version !== version ? -1 : version;
    };
    const getCanSendMaxMessageSize = function(remoteIsFirefox) {
        // Every implementation we know can send at least 64 KiB.
        // Note: Although Chrome is technically able to send up to 256 KiB, the
        //       data does not reach the other peer reliably.
        //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
        let canSendMaxMessageSize = 65536;
        if (browserDetails.browser === 'firefox') {
            if (browserDetails.version < 57) {
                if (remoteIsFirefox === -1) // FF < 57 will send in 16 KiB chunks using the deprecated PPID
                // fragmentation.
                canSendMaxMessageSize = 16384;
                else // However, other FF (and RAWRTC) can reassemble PPID-fragmented
                // messages. Thus, supporting ~2 GiB when sending.
                canSendMaxMessageSize = 2147483637;
            } else if (browserDetails.version < 60) // Currently, all FF >= 57 will reset the remote maximum message size
            // to the default value when a data channel is created at a later
            // stage. :(
            // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
            canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
            else // FF >= 60 supports sending ~2 GiB
            canSendMaxMessageSize = 2147483637;
        }
        return canSendMaxMessageSize;
    };
    const getMaxMessageSize = function(description, remoteIsFirefox) {
        // Note: 65536 bytes is the default value from the SDP spec. Also,
        //       every implementation we know supports receiving 65536 bytes.
        let maxMessageSize = 65536;
        // FF 57 has a slightly incorrect default remote max message size, so
        // we need to adjust it here to avoid a failure when sending.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
        if (browserDetails.browser === 'firefox' && browserDetails.version === 57) maxMessageSize = 65535;
        const match = $2d7d9af7a5367cf4$var$SDPUtils.matchPrefix(description.sdp, 'a=max-message-size:');
        if (match.length > 0) maxMessageSize = parseInt(match[0].substring(19), 10);
        else if (browserDetails.browser === 'firefox' && remoteIsFirefox !== -1) // If the maximum message size is not present in the remote SDP and
        // both local and remote are Firefox, the remote peer can receive
        // ~2 GiB.
        maxMessageSize = 2147483637;
        return maxMessageSize;
    };
    const origSetRemoteDescription = window1.RTCPeerConnection.prototype.setRemoteDescription;
    window1.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
        this._sctp = null;
        // Chrome decided to not expose .sctp in plan-b mode.
        // As usual, adapter.js has to do an 'ugly worakaround'
        // to cover up the mess.
        if (browserDetails.browser === 'chrome' && browserDetails.version >= 76) {
            const { sdpSemantics: sdpSemantics } = this.getConfiguration();
            if (sdpSemantics === 'plan-b') Object.defineProperty(this, 'sctp', {
                get () {
                    return typeof this._sctp === 'undefined' ? null : this._sctp;
                },
                enumerable: true,
                configurable: true
            });
        }
        if (sctpInDescription(arguments[0])) {
            // Check if the remote is FF.
            const isFirefox = getRemoteFirefoxVersion(arguments[0]);
            // Get the maximum message size the local peer is capable of sending
            const canSendMMS = getCanSendMaxMessageSize(isFirefox);
            // Get the maximum message size of the remote peer.
            const remoteMMS = getMaxMessageSize(arguments[0], isFirefox);
            // Determine final maximum message size
            let maxMessageSize;
            if (canSendMMS === 0 && remoteMMS === 0) maxMessageSize = Number.POSITIVE_INFINITY;
            else if (canSendMMS === 0 || remoteMMS === 0) maxMessageSize = Math.max(canSendMMS, remoteMMS);
            else maxMessageSize = Math.min(canSendMMS, remoteMMS);
            // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
            // attribute.
            const sctp = {};
            Object.defineProperty(sctp, 'maxMessageSize', {
                get () {
                    return maxMessageSize;
                }
            });
            this._sctp = sctp;
        }
        return origSetRemoteDescription.apply(this, arguments);
    };
}
function $2d7d9af7a5367cf4$var$shimSendThrowTypeError(window1) {
    if (!(window1.RTCPeerConnection && 'createDataChannel' in window1.RTCPeerConnection.prototype)) return;
    // Note: Although Firefox >= 57 has a native implementation, the maximum
    //       message size can be reset for all data channels at a later stage.
    //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
    function wrapDcSend(dc, pc) {
        const origDataChannelSend = dc.send;
        dc.send = function send() {
            const data = arguments[0];
            const length = data.length || data.size || data.byteLength;
            if (dc.readyState === 'open' && pc.sctp && length > pc.sctp.maxMessageSize) throw new TypeError('Message too large (can send a maximum of ' + pc.sctp.maxMessageSize + ' bytes)');
            return origDataChannelSend.apply(dc, arguments);
        };
    }
    const origCreateDataChannel = window1.RTCPeerConnection.prototype.createDataChannel;
    window1.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
        const dataChannel = origCreateDataChannel.apply(this, arguments);
        wrapDcSend(dataChannel, this);
        return dataChannel;
    };
    $2d7d9af7a5367cf4$var$wrapPeerConnectionEvent(window1, 'datachannel', (e)=>{
        wrapDcSend(e.channel, e.target);
        return e;
    });
}
/* shims RTCConnectionState by pretending it is the same as iceConnectionState.
 * See https://bugs.chromium.org/p/webrtc/issues/detail?id=6145#c12
 * for why this is a valid hack in Chrome. In Firefox it is slightly incorrect
 * since DTLS failures would be hidden. See
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1265827
 * for the Firefox tracking bug.
 */ function $2d7d9af7a5367cf4$var$shimConnectionState(window1) {
    if (!window1.RTCPeerConnection || 'connectionState' in window1.RTCPeerConnection.prototype) return;
    const proto = window1.RTCPeerConnection.prototype;
    Object.defineProperty(proto, 'connectionState', {
        get () {
            return ({
                completed: 'connected',
                checking: 'connecting'
            })[this.iceConnectionState] || this.iceConnectionState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(proto, 'onconnectionstatechange', {
        get () {
            return this._onconnectionstatechange || null;
        },
        set (cb) {
            if (this._onconnectionstatechange) {
                this.removeEventListener('connectionstatechange', this._onconnectionstatechange);
                delete this._onconnectionstatechange;
            }
            if (cb) this.addEventListener('connectionstatechange', this._onconnectionstatechange = cb);
        },
        enumerable: true,
        configurable: true
    });
    [
        'setLocalDescription',
        'setRemoteDescription'
    ].forEach((method)=>{
        const origMethod = proto[method];
        proto[method] = function() {
            if (!this._connectionstatechangepoly) {
                this._connectionstatechangepoly = (e)=>{
                    const pc = e.target;
                    if (pc._lastConnectionState !== pc.connectionState) {
                        pc._lastConnectionState = pc.connectionState;
                        const newEvent = new Event('connectionstatechange', e);
                        pc.dispatchEvent(newEvent);
                    }
                    return e;
                };
                this.addEventListener('iceconnectionstatechange', this._connectionstatechangepoly);
            }
            return origMethod.apply(this, arguments);
        };
    });
}
function $2d7d9af7a5367cf4$var$removeExtmapAllowMixed(window1, browserDetails) {
    /* remove a=extmap-allow-mixed for webrtc.org < M71 */ if (!window1.RTCPeerConnection) return;
    if (browserDetails.browser === 'chrome' && browserDetails.version >= 71) return;
    if (browserDetails.browser === 'safari' && browserDetails.version >= 605) return;
    const nativeSRD = window1.RTCPeerConnection.prototype.setRemoteDescription;
    window1.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
        if (desc && desc.sdp && desc.sdp.indexOf('\na=extmap-allow-mixed') !== -1) {
            const sdp = desc.sdp.split('\n').filter((line)=>{
                return line.trim() !== 'a=extmap-allow-mixed';
            }).join('\n');
            // Safari enforces read-only-ness of RTCSessionDescription fields.
            if (window1.RTCSessionDescription && desc instanceof window1.RTCSessionDescription) arguments[0] = new window1.RTCSessionDescription({
                type: desc.type,
                sdp: sdp
            });
            else desc.sdp = sdp;
        }
        return nativeSRD.apply(this, arguments);
    };
}
function $2d7d9af7a5367cf4$var$shimAddIceCandidateNullOrEmpty(window1, browserDetails) {
    // Support for addIceCandidate(null or undefined)
    // as well as addIceCandidate({candidate: "", ...})
    // https://bugs.chromium.org/p/chromium/issues/detail?id=978582
    // Note: must be called before other polyfills which change the signature.
    if (!(window1.RTCPeerConnection && window1.RTCPeerConnection.prototype)) return;
    const nativeAddIceCandidate = window1.RTCPeerConnection.prototype.addIceCandidate;
    if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) return;
    window1.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
        if (!arguments[0]) {
            if (arguments[1]) arguments[1].apply(null);
            return Promise.resolve();
        }
        // Firefox 68+ emits and processes {candidate: "", ...}, ignore
        // in older versions.
        // Native support for ignoring exists for Chrome M77+.
        // Safari ignores as well, exact version unknown but works in the same
        // version that also ignores addIceCandidate(null).
        if ((browserDetails.browser === 'chrome' && browserDetails.version < 78 || browserDetails.browser === 'firefox' && browserDetails.version < 68 || browserDetails.browser === 'safari') && arguments[0] && arguments[0].candidate === '') return Promise.resolve();
        return nativeAddIceCandidate.apply(this, arguments);
    };
}
// Note: Make sure to call this ahead of APIs that modify
// setLocalDescription.length
function $2d7d9af7a5367cf4$var$shimParameterlessSetLocalDescription(window1, browserDetails) {
    if (!(window1.RTCPeerConnection && window1.RTCPeerConnection.prototype)) return;
    const nativeSetLocalDescription = window1.RTCPeerConnection.prototype.setLocalDescription;
    if (!nativeSetLocalDescription || nativeSetLocalDescription.length === 0) return;
    window1.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        let desc = arguments[0] || {};
        if (typeof desc !== 'object' || desc.type && desc.sdp) return nativeSetLocalDescription.apply(this, arguments);
        // The remaining steps should technically happen when SLD comes off the
        // RTCPeerConnection's operations chain (not ahead of going on it), but
        // this is too difficult to shim. Instead, this shim only covers the
        // common case where the operations chain is empty. This is imperfect, but
        // should cover many cases. Rationale: Even if we can't reduce the glare
        // window to zero on imperfect implementations, there's value in tapping
        // into the perfect negotiation pattern that several browsers support.
        desc = {
            type: desc.type,
            sdp: desc.sdp
        };
        if (!desc.type) switch(this.signalingState){
            case 'stable':
            case 'have-local-offer':
            case 'have-remote-pranswer':
                desc.type = 'offer';
                break;
            default:
                desc.type = 'answer';
                break;
        }
        if (desc.sdp || desc.type !== 'offer' && desc.type !== 'answer') return nativeSetLocalDescription.apply(this, [
            desc
        ]);
        const func = desc.type === 'offer' ? this.createOffer : this.createAnswer;
        return func.apply(this).then((d)=>nativeSetLocalDescription.apply(this, [
                d
            ]));
    };
}
var $2d7d9af7a5367cf4$var$commonShim = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    removeExtmapAllowMixed: $2d7d9af7a5367cf4$var$removeExtmapAllowMixed,
    shimAddIceCandidateNullOrEmpty: $2d7d9af7a5367cf4$var$shimAddIceCandidateNullOrEmpty,
    shimConnectionState: $2d7d9af7a5367cf4$var$shimConnectionState,
    shimMaxMessageSize: $2d7d9af7a5367cf4$var$shimMaxMessageSize,
    shimParameterlessSetLocalDescription: $2d7d9af7a5367cf4$var$shimParameterlessSetLocalDescription,
    shimRTCIceCandidate: $2d7d9af7a5367cf4$var$shimRTCIceCandidate,
    shimRTCIceCandidateRelayProtocol: $2d7d9af7a5367cf4$var$shimRTCIceCandidateRelayProtocol,
    shimSendThrowTypeError: $2d7d9af7a5367cf4$var$shimSendThrowTypeError
});
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ // Shimming starts here.
function $2d7d9af7a5367cf4$var$adapterFactory() {
    let { window: window1 } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        shimChrome: true,
        shimFirefox: true,
        shimSafari: true
    };
    // Utils.
    const logging = $2d7d9af7a5367cf4$var$log;
    const browserDetails = $2d7d9af7a5367cf4$var$detectBrowser(window1);
    const adapter = {
        browserDetails: browserDetails,
        commonShim: $2d7d9af7a5367cf4$var$commonShim,
        extractVersion: $2d7d9af7a5367cf4$var$extractVersion,
        disableLog: $2d7d9af7a5367cf4$var$disableLog,
        disableWarnings: $2d7d9af7a5367cf4$var$disableWarnings,
        sdp: // Expose sdp as a convenience. For production apps include directly.
        $2d7d9af7a5367cf4$var$sdp
    };
    // Shim browser if found.
    switch(browserDetails.browser){
        case 'chrome':
            if (!$2d7d9af7a5367cf4$var$chromeShim || !$2d7d9af7a5367cf4$var$shimPeerConnection$1 || !options.shimChrome) {
                logging('Chrome shim is not included in this adapter release.');
                return adapter;
            }
            if (browserDetails.version === null) {
                logging('Chrome shim can not determine version, not shimming.');
                return adapter;
            }
            logging('adapter.js shimming chrome.');
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $2d7d9af7a5367cf4$var$chromeShim;
            // Must be called before shimPeerConnection.
            $2d7d9af7a5367cf4$var$shimAddIceCandidateNullOrEmpty(window1, browserDetails);
            $2d7d9af7a5367cf4$var$shimParameterlessSetLocalDescription(window1);
            $2d7d9af7a5367cf4$var$shimGetUserMedia$2(window1, browserDetails);
            $2d7d9af7a5367cf4$var$shimMediaStream(window1);
            $2d7d9af7a5367cf4$var$shimPeerConnection$1(window1, browserDetails);
            $2d7d9af7a5367cf4$var$shimOnTrack$1(window1);
            $2d7d9af7a5367cf4$var$shimAddTrackRemoveTrack(window1, browserDetails);
            $2d7d9af7a5367cf4$var$shimGetSendersWithDtmf(window1);
            $2d7d9af7a5367cf4$var$shimSenderReceiverGetStats(window1);
            $2d7d9af7a5367cf4$var$fixNegotiationNeeded(window1, browserDetails);
            $2d7d9af7a5367cf4$var$shimRTCIceCandidate(window1);
            $2d7d9af7a5367cf4$var$shimRTCIceCandidateRelayProtocol(window1);
            $2d7d9af7a5367cf4$var$shimConnectionState(window1);
            $2d7d9af7a5367cf4$var$shimMaxMessageSize(window1, browserDetails);
            $2d7d9af7a5367cf4$var$shimSendThrowTypeError(window1);
            $2d7d9af7a5367cf4$var$removeExtmapAllowMixed(window1, browserDetails);
            break;
        case 'firefox':
            if (!$2d7d9af7a5367cf4$var$firefoxShim || !$2d7d9af7a5367cf4$var$shimPeerConnection || !options.shimFirefox) {
                logging('Firefox shim is not included in this adapter release.');
                return adapter;
            }
            logging('adapter.js shimming firefox.');
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $2d7d9af7a5367cf4$var$firefoxShim;
            // Must be called before shimPeerConnection.
            $2d7d9af7a5367cf4$var$shimAddIceCandidateNullOrEmpty(window1, browserDetails);
            $2d7d9af7a5367cf4$var$shimParameterlessSetLocalDescription(window1);
            $2d7d9af7a5367cf4$var$shimGetUserMedia$1(window1, browserDetails);
            $2d7d9af7a5367cf4$var$shimPeerConnection(window1, browserDetails);
            $2d7d9af7a5367cf4$var$shimOnTrack(window1);
            $2d7d9af7a5367cf4$var$shimRemoveStream(window1);
            $2d7d9af7a5367cf4$var$shimSenderGetStats(window1);
            $2d7d9af7a5367cf4$var$shimReceiverGetStats(window1);
            $2d7d9af7a5367cf4$var$shimRTCDataChannel(window1);
            $2d7d9af7a5367cf4$var$shimAddTransceiver(window1);
            $2d7d9af7a5367cf4$var$shimGetParameters(window1);
            $2d7d9af7a5367cf4$var$shimCreateOffer(window1);
            $2d7d9af7a5367cf4$var$shimCreateAnswer(window1);
            $2d7d9af7a5367cf4$var$shimRTCIceCandidate(window1);
            $2d7d9af7a5367cf4$var$shimConnectionState(window1);
            $2d7d9af7a5367cf4$var$shimMaxMessageSize(window1, browserDetails);
            $2d7d9af7a5367cf4$var$shimSendThrowTypeError(window1);
            break;
        case 'safari':
            if (!$2d7d9af7a5367cf4$var$safariShim || !options.shimSafari) {
                logging('Safari shim is not included in this adapter release.');
                return adapter;
            }
            logging('adapter.js shimming safari.');
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $2d7d9af7a5367cf4$var$safariShim;
            // Must be called before shimCallbackAPI.
            $2d7d9af7a5367cf4$var$shimAddIceCandidateNullOrEmpty(window1, browserDetails);
            $2d7d9af7a5367cf4$var$shimParameterlessSetLocalDescription(window1);
            $2d7d9af7a5367cf4$var$shimRTCIceServerUrls(window1);
            $2d7d9af7a5367cf4$var$shimCreateOfferLegacy(window1);
            $2d7d9af7a5367cf4$var$shimCallbacksAPI(window1);
            $2d7d9af7a5367cf4$var$shimLocalStreamsAPI(window1);
            $2d7d9af7a5367cf4$var$shimRemoteStreamsAPI(window1);
            $2d7d9af7a5367cf4$var$shimTrackEventTransceiver(window1);
            $2d7d9af7a5367cf4$var$shimGetUserMedia(window1);
            $2d7d9af7a5367cf4$var$shimAudioContext(window1);
            $2d7d9af7a5367cf4$var$shimRTCIceCandidate(window1);
            $2d7d9af7a5367cf4$var$shimRTCIceCandidateRelayProtocol(window1);
            $2d7d9af7a5367cf4$var$shimMaxMessageSize(window1, browserDetails);
            $2d7d9af7a5367cf4$var$shimSendThrowTypeError(window1);
            $2d7d9af7a5367cf4$var$removeExtmapAllowMixed(window1, browserDetails);
            break;
        default:
            logging('Unsupported browser!');
            break;
    }
    return adapter;
}
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ $2d7d9af7a5367cf4$var$adapterFactory({
    window: typeof window === 'undefined' ? undefined : window
});
const $2d7d9af7a5367cf4$var$ENCRYPTION_ALGORITHM = 'AES-GCM';
// How many consecutive frames can fail decrypting before a particular key gets marked as invalid
const $2d7d9af7a5367cf4$var$DECRYPTION_FAILURE_TOLERANCE = 10;
// flag set to indicate that e2ee has been setup for sender/receiver;
const $2d7d9af7a5367cf4$var$E2EE_FLAG = 'lk_e2ee';
const $2d7d9af7a5367cf4$var$SALT = 'LKFrameEncryptionKey';
const $2d7d9af7a5367cf4$var$KEY_PROVIDER_DEFAULTS = {
    sharedKey: false,
    ratchetSalt: $2d7d9af7a5367cf4$var$SALT,
    ratchetWindowSize: 8,
    failureTolerance: $2d7d9af7a5367cf4$var$DECRYPTION_FAILURE_TOLERANCE,
    keyringSize: 16
};
var $2d7d9af7a5367cf4$export$432ceae3bd7b5ad3;
(function(KeyProviderEvent) {
    KeyProviderEvent["SetKey"] = "setKey";
    KeyProviderEvent["RatchetRequest"] = "ratchetRequest";
    KeyProviderEvent["KeyRatcheted"] = "keyRatcheted";
})($2d7d9af7a5367cf4$export$432ceae3bd7b5ad3 || ($2d7d9af7a5367cf4$export$432ceae3bd7b5ad3 = {}));
var $2d7d9af7a5367cf4$export$6da6bc56147fd1ba;
(function(KeyHandlerEvent) {
    KeyHandlerEvent["KeyRatcheted"] = "keyRatcheted";
})($2d7d9af7a5367cf4$export$6da6bc56147fd1ba || ($2d7d9af7a5367cf4$export$6da6bc56147fd1ba = {}));
var $2d7d9af7a5367cf4$export$36ec54aef832f50f;
(function(EncryptionEvent) {
    EncryptionEvent["ParticipantEncryptionStatusChanged"] = "participantEncryptionStatusChanged";
    EncryptionEvent["EncryptionError"] = "encryptionError";
})($2d7d9af7a5367cf4$export$36ec54aef832f50f || ($2d7d9af7a5367cf4$export$36ec54aef832f50f = {}));
var $2d7d9af7a5367cf4$export$d8fa3f6f75909dd5;
(function(CryptorEvent) {
    CryptorEvent["Error"] = "cryptorError";
})($2d7d9af7a5367cf4$export$d8fa3f6f75909dd5 || ($2d7d9af7a5367cf4$export$d8fa3f6f75909dd5 = {}));
function $2d7d9af7a5367cf4$export$2c53d20185b28316() {
    return $2d7d9af7a5367cf4$export$426a96d741bc81b() || $2d7d9af7a5367cf4$export$6bf50ac7ca24af81();
}
function $2d7d9af7a5367cf4$export$6bf50ac7ca24af81() {
    // @ts-ignore
    return typeof window.RTCRtpScriptTransform !== 'undefined';
}
function $2d7d9af7a5367cf4$export$426a96d741bc81b() {
    return typeof window.RTCRtpSender !== 'undefined' && // @ts-ignore
    typeof window.RTCRtpSender.prototype.createEncodedStreams !== 'undefined';
}
function $2d7d9af7a5367cf4$export$4fe547020d3f319b(frame) {
    return 'type' in frame;
}
function $2d7d9af7a5367cf4$export$16dc620a3833b13a(keyBytes_1) {
    return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function(keyBytes) {
        let algorithm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            name: $2d7d9af7a5367cf4$var$ENCRYPTION_ALGORITHM
        };
        let usage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'encrypt';
        return function*() {
            // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/importKey
            return crypto.subtle.importKey('raw', keyBytes, algorithm, false, usage === 'derive' ? [
                'deriveBits',
                'deriveKey'
            ] : [
                'encrypt',
                'decrypt'
            ]);
        }();
    });
}
function $2d7d9af7a5367cf4$export$cbc2841706abbbeb(password) {
    return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
        let enc = new TextEncoder();
        const keyMaterial = yield crypto.subtle.importKey('raw', enc.encode(password), {
            name: 'PBKDF2'
        }, false, [
            'deriveBits',
            'deriveKey'
        ]);
        return keyMaterial;
    });
}
function $2d7d9af7a5367cf4$export$46032788f1602f4b(cryptoBuffer) {
    return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
        const keyMaterial = yield crypto.subtle.importKey('raw', cryptoBuffer, 'HKDF', false, [
            'deriveBits',
            'deriveKey'
        ]);
        return keyMaterial;
    });
}
function $2d7d9af7a5367cf4$var$getAlgoOptions(algorithmName, salt) {
    const textEncoder = new TextEncoder();
    const encodedSalt = textEncoder.encode(salt);
    switch(algorithmName){
        case 'HKDF':
            return {
                name: 'HKDF',
                salt: encodedSalt,
                hash: 'SHA-256',
                info: new ArrayBuffer(128)
            };
        case 'PBKDF2':
            return {
                name: 'PBKDF2',
                salt: encodedSalt,
                hash: 'SHA-256',
                iterations: 100000
            };
        default:
            throw new Error("algorithm ".concat(algorithmName, " is currently unsupported"));
    }
}
/**
 * Derives a set of keys from the master key.
 * See https://tools.ietf.org/html/draft-omara-sframe-00#section-4.3.1
 */ function $2d7d9af7a5367cf4$export$463e47238031f308(material, salt) {
    return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
        const algorithmOptions = $2d7d9af7a5367cf4$var$getAlgoOptions(material.algorithm.name, salt);
        // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/deriveKey#HKDF
        // https://developer.mozilla.org/en-US/docs/Web/API/HkdfParams
        const encryptionKey = yield crypto.subtle.deriveKey(algorithmOptions, material, {
            name: $2d7d9af7a5367cf4$var$ENCRYPTION_ALGORITHM,
            length: 128
        }, false, [
            'encrypt',
            'decrypt'
        ]);
        return {
            material: material,
            encryptionKey: encryptionKey
        };
    });
}
function $2d7d9af7a5367cf4$export$5dfa89fd21efb3f9() {
    return window.crypto.getRandomValues(new Uint8Array(32));
}
/**
 * Ratchets a key. See
 * https://tools.ietf.org/html/draft-omara-sframe-00#section-4.3.5.1
 */ function $2d7d9af7a5367cf4$export$90588bff5e15163b(material, salt) {
    return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
        const algorithmOptions = $2d7d9af7a5367cf4$var$getAlgoOptions(material.algorithm.name, salt);
        // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/deriveBits
        return crypto.subtle.deriveBits(algorithmOptions, material, 256);
    });
}
function $2d7d9af7a5367cf4$export$8e8c01dabc426c6(frameData) {
    for(var i = 0; i < frameData.length - 3; i++){
        if (frameData[i] == 0 && frameData[i + 1] == 0 && frameData[i + 2] == 3) return true;
    }
    return false;
}
function $2d7d9af7a5367cf4$export$54fa041aa1c6dee7(stream) {
    const dataOut = [];
    var length = stream.length;
    for(var i = 0; i < stream.length;)// Be careful about over/underflow here. byte_length_ - 3 can underflow, and
    // i + 3 can overflow, but byte_length_ - i can't, because i < byte_length_
    // above, and that expression will produce the number of bytes left in
    // the stream including the byte at i.
    if (length - i >= 3 && !stream[i] && !stream[i + 1] && stream[i + 2] == 3) {
        // Two rbsp bytes.
        dataOut.push(stream[i++]);
        dataOut.push(stream[i++]);
        // Skip the emulation byte.
        i++;
    } else // Single rbsp byte.
    dataOut.push(stream[i++]);
    return new Uint8Array(dataOut);
}
const $2d7d9af7a5367cf4$var$kZerosInStartSequence = 2;
const $2d7d9af7a5367cf4$var$kEmulationByte = 3;
function $2d7d9af7a5367cf4$export$ae76453e7ef39fac(data_in) {
    const dataOut = [];
    var numConsecutiveZeros = 0;
    for(var i = 0; i < data_in.length; ++i){
        var byte = data_in[i];
        if (byte <= $2d7d9af7a5367cf4$var$kEmulationByte && numConsecutiveZeros >= $2d7d9af7a5367cf4$var$kZerosInStartSequence) {
            // Need to escape.
            dataOut.push($2d7d9af7a5367cf4$var$kEmulationByte);
            numConsecutiveZeros = 0;
        }
        dataOut.push(byte);
        if (byte == 0) ++numConsecutiveZeros;
        else numConsecutiveZeros = 0;
    }
    return new Uint8Array(dataOut);
}
/**
 * @experimental
 */ class $2d7d9af7a5367cf4$export$c4dd488dad1b29ec extends $2d7d9af7a5367cf4$var$eventsExports.EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        super();
        /**
     * callback being invoked after a ratchet request has been performed on a participant
     * that surfaces the new key material.
     * @param material
     * @param keyIndex
     */ this.onKeyRatcheted = (material, keyIndex)=>{
            $2d7d9af7a5367cf4$var$livekitLogger.debug('key ratcheted event received', {
                material: material,
                keyIndex: keyIndex
            });
        };
        this.keyInfoMap = new Map();
        this.options = Object.assign(Object.assign({}, $2d7d9af7a5367cf4$var$KEY_PROVIDER_DEFAULTS), options);
        this.on($2d7d9af7a5367cf4$export$432ceae3bd7b5ad3.KeyRatcheted, this.onKeyRatcheted);
    }
    /**
   * callback to invoke once a key has been set for a participant
   * @param key
   * @param participantIdentity
   * @param keyIndex
   */ onSetEncryptionKey(key, participantIdentity, keyIndex) {
        const keyInfo = {
            key: key,
            participantIdentity: participantIdentity,
            keyIndex: keyIndex
        };
        if (!this.options.sharedKey && !participantIdentity) throw new Error('participant identity needs to be passed for encryption key if sharedKey option is false');
        this.keyInfoMap.set("".concat(participantIdentity !== null && participantIdentity !== void 0 ? participantIdentity : 'shared', "-").concat(keyIndex !== null && keyIndex !== void 0 ? keyIndex : 0), keyInfo);
        this.emit($2d7d9af7a5367cf4$export$432ceae3bd7b5ad3.SetKey, keyInfo);
    }
    getKeys() {
        return Array.from(this.keyInfoMap.values());
    }
    getOptions() {
        return this.options;
    }
    ratchetKey(participantIdentity, keyIndex) {
        this.emit($2d7d9af7a5367cf4$export$432ceae3bd7b5ad3.RatchetRequest, participantIdentity, keyIndex);
    }
}
/**
 * A basic KeyProvider implementation intended for a single shared
 * passphrase between all participants
 * @experimental
 */ class $2d7d9af7a5367cf4$export$e4a829d2658cfe97 extends $2d7d9af7a5367cf4$export$c4dd488dad1b29ec {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const opts = Object.assign(Object.assign({}, options), {
            sharedKey: true,
            // for a shared key provider failing to decrypt for a specific participant
            // should not mark the key as invalid, so we accept wrong keys forever
            // and won't try to auto-ratchet
            ratchetWindowSize: 0,
            failureTolerance: -1
        });
        super(opts);
    }
    /**
   * Accepts a passphrase that's used to create the crypto keys.
   * When passing in a string, PBKDF2 is used.
   * When passing in an Array buffer of cryptographically random numbers, HKDF is being used. (recommended)
   * @param key
   */ setKey(key) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const derivedKey = typeof key === 'string' ? yield $2d7d9af7a5367cf4$export$cbc2841706abbbeb(key) : yield $2d7d9af7a5367cf4$export$46032788f1602f4b(key);
            this.onSetEncryptionKey(derivedKey);
        });
    }
}
class $2d7d9af7a5367cf4$export$d7a71bcd3a009497 extends Error {
    constructor(code, message){
        super(message || 'an error has occured');
        this.code = code;
    }
}
var $2d7d9af7a5367cf4$export$61182a0b21436b65;
(function(ConnectionErrorReason) {
    ConnectionErrorReason[ConnectionErrorReason["NotAllowed"] = 0] = "NotAllowed";
    ConnectionErrorReason[ConnectionErrorReason["ServerUnreachable"] = 1] = "ServerUnreachable";
    ConnectionErrorReason[ConnectionErrorReason["InternalError"] = 2] = "InternalError";
    ConnectionErrorReason[ConnectionErrorReason["Cancelled"] = 3] = "Cancelled";
    ConnectionErrorReason[ConnectionErrorReason["LeaveRequest"] = 4] = "LeaveRequest";
})($2d7d9af7a5367cf4$export$61182a0b21436b65 || ($2d7d9af7a5367cf4$export$61182a0b21436b65 = {}));
class $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb extends $2d7d9af7a5367cf4$export$d7a71bcd3a009497 {
    constructor(message, reason, status, context){
        super(1, message);
        this.status = status;
        this.reason = reason;
        this.context = context;
    }
}
class $2d7d9af7a5367cf4$export$38c5ac268e2fa84 extends $2d7d9af7a5367cf4$export$d7a71bcd3a009497 {
    constructor(message){
        super(21, message !== null && message !== void 0 ? message : 'device is unsupported');
    }
}
class $2d7d9af7a5367cf4$export$4fbb9423b5747257 extends $2d7d9af7a5367cf4$export$d7a71bcd3a009497 {
    constructor(message){
        super(20, message !== null && message !== void 0 ? message : 'track is invalid');
    }
}
class $2d7d9af7a5367cf4$export$4d307571a351c50c extends $2d7d9af7a5367cf4$export$d7a71bcd3a009497 {
    constructor(message){
        super(10, message !== null && message !== void 0 ? message : 'unsupported server');
    }
}
class $2d7d9af7a5367cf4$export$1f388e244efbf70b extends $2d7d9af7a5367cf4$export$d7a71bcd3a009497 {
    constructor(message){
        super(12, message !== null && message !== void 0 ? message : 'unexpected connection state');
    }
}
class $2d7d9af7a5367cf4$export$18c2792bacf23e39 extends $2d7d9af7a5367cf4$export$d7a71bcd3a009497 {
    constructor(message){
        super(13, message !== null && message !== void 0 ? message : 'unable to negotiate');
    }
}
class $2d7d9af7a5367cf4$export$8f27e55a613eb208 extends $2d7d9af7a5367cf4$export$d7a71bcd3a009497 {
    constructor(message){
        super(13, message !== null && message !== void 0 ? message : 'unable to publish data');
    }
}
class $2d7d9af7a5367cf4$export$cb33ebbc4df8a708 extends $2d7d9af7a5367cf4$export$d7a71bcd3a009497 {
    constructor(message, reason){
        super(15, message);
        this.reason = reason;
    }
}
var $2d7d9af7a5367cf4$export$843d4665ca980897;
(function(MediaDeviceFailure) {
    // user rejected permissions
    MediaDeviceFailure["PermissionDenied"] = "PermissionDenied";
    // device is not available
    MediaDeviceFailure["NotFound"] = "NotFound";
    // device is in use. On Windows, only a single tab may get access to a device at a time.
    MediaDeviceFailure["DeviceInUse"] = "DeviceInUse";
    MediaDeviceFailure["Other"] = "Other";
})($2d7d9af7a5367cf4$export$843d4665ca980897 || ($2d7d9af7a5367cf4$export$843d4665ca980897 = {}));
(function(MediaDeviceFailure) {
    function getFailure(error) {
        if (error && 'name' in error) {
            if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') return MediaDeviceFailure.NotFound;
            if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') return MediaDeviceFailure.PermissionDenied;
            if (error.name === 'NotReadableError' || error.name === 'TrackStartError') return MediaDeviceFailure.DeviceInUse;
            return MediaDeviceFailure.Other;
        }
    }
    MediaDeviceFailure.getFailure = getFailure;
})($2d7d9af7a5367cf4$export$843d4665ca980897 || ($2d7d9af7a5367cf4$export$843d4665ca980897 = {}));
var $2d7d9af7a5367cf4$export$9ce65eca7a94c890;
(function(CryptorErrorReason) {
    CryptorErrorReason[CryptorErrorReason["InvalidKey"] = 0] = "InvalidKey";
    CryptorErrorReason[CryptorErrorReason["MissingKey"] = 1] = "MissingKey";
    CryptorErrorReason[CryptorErrorReason["InternalError"] = 2] = "InternalError";
})($2d7d9af7a5367cf4$export$9ce65eca7a94c890 || ($2d7d9af7a5367cf4$export$9ce65eca7a94c890 = {}));
class $2d7d9af7a5367cf4$export$94d1ae2d97ba1565 extends $2d7d9af7a5367cf4$export$d7a71bcd3a009497 {
    constructor(message){
        let reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $2d7d9af7a5367cf4$export$9ce65eca7a94c890.InternalError;
        let participantIdentity = arguments.length > 2 ? arguments[2] : undefined;
        super(40, message);
        this.reason = reason;
        this.participantIdentity = participantIdentity;
    }
}
/**
 * Events are the primary way LiveKit notifies your application of changes.
 *
 * The following are events emitted by [[Room]], listen to room events like
 *
 * ```typescript
 * room.on(RoomEvent.TrackPublished, (track, publication, participant) => {})
 * ```
 */ var $2d7d9af7a5367cf4$export$3159c672e3b2293a;
(function(RoomEvent) {
    /**
   * When the connection to the server has been established
   */ RoomEvent["Connected"] = "connected";
    /**
   * When the connection to the server has been interrupted and it's attempting
   * to reconnect.
   */ RoomEvent["Reconnecting"] = "reconnecting";
    /**
   * When the signal connection to the server has been interrupted. This isn't noticeable to users most of the time.
   * It will resolve with a `RoomEvent.Reconnected` once the signal connection has been re-established.
   * If media fails additionally it an additional `RoomEvent.Reconnecting` will be emitted.
   */ RoomEvent["SignalReconnecting"] = "signalReconnecting";
    /**
   * Fires when a reconnection has been successful.
   */ RoomEvent["Reconnected"] = "reconnected";
    /**
   * When disconnected from room. This fires when room.disconnect() is called or
   * when an unrecoverable connection issue had occured.
   *
   * DisconnectReason can be used to determine why the participant was disconnected. Notable reasons are
   * - DUPLICATE_IDENTITY: another client with the same identity has joined the room
   * - PARTICIPANT_REMOVED: participant was removed by RemoveParticipant API
   * - ROOM_DELETED: the room has ended via DeleteRoom API
   *
   * args: ([[DisconnectReason]])
   */ RoomEvent["Disconnected"] = "disconnected";
    /**
   * Whenever the connection state of the room changes
   *
   * args: ([[ConnectionState]])
   */ RoomEvent["ConnectionStateChanged"] = "connectionStateChanged";
    /**
   * When input or output devices on the machine have changed.
   */ RoomEvent["MediaDevicesChanged"] = "mediaDevicesChanged";
    /**
   * When a [[RemoteParticipant]] joins *after* the local
   * participant. It will not emit events for participants that are already
   * in the room
   *
   * args: ([[RemoteParticipant]])
   */ RoomEvent["ParticipantConnected"] = "participantConnected";
    /**
   * When a [[RemoteParticipant]] leaves *after* the local
   * participant has joined.
   *
   * args: ([[RemoteParticipant]])
   */ RoomEvent["ParticipantDisconnected"] = "participantDisconnected";
    /**
   * When a new track is published to room *after* the local
   * participant has joined. It will not fire for tracks that are already published.
   *
   * A track published doesn't mean the participant has subscribed to it. It's
   * simply reflecting the state of the room.
   *
   * args: ([[RemoteTrackPublication]], [[RemoteParticipant]])
   */ RoomEvent["TrackPublished"] = "trackPublished";
    /**
   * The [[LocalParticipant]] has subscribed to a new track. This event will **always**
   * fire as long as new tracks are ready for use.
   *
   * args: ([[RemoteTrack]], [[RemoteTrackPublication]], [[RemoteParticipant]])
   */ RoomEvent["TrackSubscribed"] = "trackSubscribed";
    /**
   * Could not subscribe to a track
   *
   * args: (track sid, [[RemoteParticipant]])
   */ RoomEvent["TrackSubscriptionFailed"] = "trackSubscriptionFailed";
    /**
   * A [[RemoteParticipant]] has unpublished a track
   *
   * args: ([[RemoteTrackPublication]], [[RemoteParticipant]])
   */ RoomEvent["TrackUnpublished"] = "trackUnpublished";
    /**
   * A subscribed track is no longer available. Clients should listen to this
   * event and ensure they detach tracks.
   *
   * args: ([[Track]], [[RemoteTrackPublication]], [[RemoteParticipant]])
   */ RoomEvent["TrackUnsubscribed"] = "trackUnsubscribed";
    /**
   * A track that was muted, fires on both [[RemoteParticipant]]s and [[LocalParticipant]]
   *
   * args: ([[TrackPublication]], [[Participant]])
   */ RoomEvent["TrackMuted"] = "trackMuted";
    /**
   * A track that was unmuted, fires on both [[RemoteParticipant]]s and [[LocalParticipant]]
   *
   * args: ([[TrackPublication]], [[Participant]])
   */ RoomEvent["TrackUnmuted"] = "trackUnmuted";
    /**
   * A local track was published successfully. This event is helpful to know
   * when to update your local UI with the newly published track.
   *
   * args: ([[LocalTrackPublication]], [[LocalParticipant]])
   */ RoomEvent["LocalTrackPublished"] = "localTrackPublished";
    /**
   * A local track was unpublished. This event is helpful to know when to remove
   * the local track from your UI.
   *
   * When a user stops sharing their screen by pressing "End" on the browser UI,
   * this event will also fire.
   *
   * args: ([[LocalTrackPublication]], [[LocalParticipant]])
   */ RoomEvent["LocalTrackUnpublished"] = "localTrackUnpublished";
    /**
   * When a local audio track is published the SDK checks whether there is complete silence
   * on that track and emits the LocalAudioSilenceDetected event in that case.
   * This allows for applications to show UI informing users that they might have to
   * reset their audio hardware or check for proper device connectivity.
   */ RoomEvent["LocalAudioSilenceDetected"] = "localAudioSilenceDetected";
    /**
   * Active speakers changed. List of speakers are ordered by their audio level.
   * loudest speakers first. This will include the LocalParticipant too.
   *
   * Speaker updates are sent only to the publishing participant and their subscribers.
   *
   * args: (Array<[[Participant]]>)
   */ RoomEvent["ActiveSpeakersChanged"] = "activeSpeakersChanged";
    /**
   * Participant metadata is a simple way for app-specific state to be pushed to
   * all users.
   * When RoomService.UpdateParticipantMetadata is called to change a participant's
   * state, *all*  participants in the room will fire this event.
   *
   * args: (prevMetadata: string, [[Participant]])
   *
   */ RoomEvent["ParticipantMetadataChanged"] = "participantMetadataChanged";
    /**
   * Participant's display name changed
   *
   * args: (name: string, [[Participant]])
   *
   */ RoomEvent["ParticipantNameChanged"] = "participantNameChanged";
    /**
   * Participant attributes is an app-specific key value state to be pushed to
   * all users.
   * When a participant's attributes changed, this event will be emitted with the changed attributes and the participant
   * args: (changedAttributes: [[Record<string, string]], participant: [[Participant]])
   */ RoomEvent["ParticipantAttributesChanged"] = "participantAttributesChanged";
    /**
   * Room metadata is a simple way for app-specific state to be pushed to
   * all users.
   * When RoomService.UpdateRoomMetadata is called to change a room's state,
   * *all*  participants in the room will fire this event.
   *
   * args: (string)
   */ RoomEvent["RoomMetadataChanged"] = "roomMetadataChanged";
    /**
   * Data received from another participant.
   * Data packets provides the ability to use LiveKit to send/receive arbitrary payloads.
   * All participants in the room will receive the messages sent to the room.
   *
   * args: (payload: Uint8Array, participant: [[Participant]], kind: [[DataPacket_Kind]], topic?: string)
   */ RoomEvent["DataReceived"] = "dataReceived";
    /**
   * SIP DTMF tones received from another participant.
   *
   * args: (participant: [[Participant]], dtmf: [[DataPacket_Kind]])
   */ RoomEvent["SipDTMFReceived"] = "sipDTMFReceived";
    /**
   * Transcription received from a participant's track.
   * @beta
   */ RoomEvent["TranscriptionReceived"] = "transcriptionReceived";
    /**
   * Connection quality was changed for a Participant. It'll receive updates
   * from the local participant, as well as any [[RemoteParticipant]]s that we are
   * subscribed to.
   *
   * args: (connectionQuality: [[ConnectionQuality]], participant: [[Participant]])
   */ RoomEvent["ConnectionQualityChanged"] = "connectionQualityChanged";
    /**
   * StreamState indicates if a subscribed (remote) track has been paused by the SFU
   * (typically this happens because of subscriber's bandwidth constraints)
   *
   * When bandwidth conditions allow, the track will be resumed automatically.
   * TrackStreamStateChanged will also be emitted when that happens.
   *
   * args: (pub: [[RemoteTrackPublication]], streamState: [[Track.StreamState]],
   *        participant: [[RemoteParticipant]])
   */ RoomEvent["TrackStreamStateChanged"] = "trackStreamStateChanged";
    /**
   * One of subscribed tracks have changed its permissions for the current
   * participant. If permission was revoked, then the track will no longer
   * be subscribed. If permission was granted, a TrackSubscribed event will
   * be emitted.
   *
   * args: (pub: [[RemoteTrackPublication]],
   *        status: [[TrackPublication.PermissionStatus]],
   *        participant: [[RemoteParticipant]])
   */ RoomEvent["TrackSubscriptionPermissionChanged"] = "trackSubscriptionPermissionChanged";
    /**
   * One of subscribed tracks have changed its status for the current
   * participant.
   *
   * args: (pub: [[RemoteTrackPublication]],
   *        status: [[TrackPublication.SubscriptionStatus]],
   *        participant: [[RemoteParticipant]])
   */ RoomEvent["TrackSubscriptionStatusChanged"] = "trackSubscriptionStatusChanged";
    /**
   * LiveKit will attempt to autoplay all audio tracks when you attach them to
   * audio elements. However, if that fails, we'll notify you via AudioPlaybackStatusChanged.
   * `Room.canPlaybackAudio` will indicate if audio playback is permitted.
   */ RoomEvent["AudioPlaybackStatusChanged"] = "audioPlaybackChanged";
    /**
   * LiveKit will attempt to autoplay all video tracks when you attach them to
   * a video element. However, if that fails, we'll notify you via VideoPlaybackStatusChanged.
   * Calling `room.startVideo()` in a user gesture event handler will resume the video playback.
   */ RoomEvent["VideoPlaybackStatusChanged"] = "videoPlaybackChanged";
    /**
   * When we have encountered an error while attempting to create a track.
   * The errors take place in getUserMedia().
   * Use MediaDeviceFailure.getFailure(error) to get the reason of failure.
   * [[LocalParticipant.lastCameraError]] and [[LocalParticipant.lastMicrophoneError]]
   * will indicate if it had an error while creating the audio or video track respectively.
   *
   * args: (error: Error)
   */ RoomEvent["MediaDevicesError"] = "mediaDevicesError";
    /**
   * A participant's permission has changed.
   * args: (prevPermissions: [[ParticipantPermission]], participant: [[Participant]])
   */ RoomEvent["ParticipantPermissionsChanged"] = "participantPermissionsChanged";
    /**
   * Signal connected, can publish tracks.
   */ RoomEvent["SignalConnected"] = "signalConnected";
    /**
   * Recording of a room has started/stopped. Room.isRecording will be updated too.
   * args: (isRecording: boolean)
   */ RoomEvent["RecordingStatusChanged"] = "recordingStatusChanged";
    RoomEvent["ParticipantEncryptionStatusChanged"] = "participantEncryptionStatusChanged";
    RoomEvent["EncryptionError"] = "encryptionError";
    /**
   * Emits whenever the current buffer status of a data channel changes
   * args: (isLow: boolean, kind: [[DataPacket_Kind]])
   */ RoomEvent["DCBufferStatusChanged"] = "dcBufferStatusChanged";
    /**
   * Triggered by a call to room.switchActiveDevice
   * args: (kind: MediaDeviceKind, deviceId: string)
   */ RoomEvent["ActiveDeviceChanged"] = "activeDeviceChanged";
    RoomEvent["ChatMessage"] = "chatMessage";
    /**
   * fired when the first remote participant has subscribed to the localParticipant's track
   */ RoomEvent["LocalTrackSubscribed"] = "localTrackSubscribed";
    /**
   * fired when the client receives connection metrics from other participants
   */ RoomEvent["MetricsReceived"] = "metricsReceived";
})($2d7d9af7a5367cf4$export$3159c672e3b2293a || ($2d7d9af7a5367cf4$export$3159c672e3b2293a = {}));
var $2d7d9af7a5367cf4$export$fcdfe2b7a6750691;
(function(ParticipantEvent) {
    /**
   * When a new track is published to room *after* the local
   * participant has joined. It will not fire for tracks that are already published.
   *
   * A track published doesn't mean the participant has subscribed to it. It's
   * simply reflecting the state of the room.
   *
   * args: ([[RemoteTrackPublication]])
   */ ParticipantEvent["TrackPublished"] = "trackPublished";
    /**
   * Successfully subscribed to the [[RemoteParticipant]]'s track.
   * This event will **always** fire as long as new tracks are ready for use.
   *
   * args: ([[RemoteTrack]], [[RemoteTrackPublication]])
   */ ParticipantEvent["TrackSubscribed"] = "trackSubscribed";
    /**
   * Could not subscribe to a track
   *
   * args: (track sid)
   */ ParticipantEvent["TrackSubscriptionFailed"] = "trackSubscriptionFailed";
    /**
   * A [[RemoteParticipant]] has unpublished a track
   *
   * args: ([[RemoteTrackPublication]])
   */ ParticipantEvent["TrackUnpublished"] = "trackUnpublished";
    /**
   * A subscribed track is no longer available. Clients should listen to this
   * event and ensure they detach tracks.
   *
   * args: ([[RemoteTrack]], [[RemoteTrackPublication]])
   */ ParticipantEvent["TrackUnsubscribed"] = "trackUnsubscribed";
    /**
   * A track that was muted, fires on both [[RemoteParticipant]]s and [[LocalParticipant]]
   *
   * args: ([[TrackPublication]])
   */ ParticipantEvent["TrackMuted"] = "trackMuted";
    /**
   * A track that was unmuted, fires on both [[RemoteParticipant]]s and [[LocalParticipant]]
   *
   * args: ([[TrackPublication]])
   */ ParticipantEvent["TrackUnmuted"] = "trackUnmuted";
    /**
   * A local track was published successfully. This event is helpful to know
   * when to update your local UI with the newly published track.
   *
   * args: ([[LocalTrackPublication]])
   */ ParticipantEvent["LocalTrackPublished"] = "localTrackPublished";
    /**
   * A local track was unpublished. This event is helpful to know when to remove
   * the local track from your UI.
   *
   * When a user stops sharing their screen by pressing "End" on the browser UI,
   * this event will also fire.
   *
   * args: ([[LocalTrackPublication]])
   */ ParticipantEvent["LocalTrackUnpublished"] = "localTrackUnpublished";
    /**
   * Participant metadata is a simple way for app-specific state to be pushed to
   * all users.
   * When RoomService.UpdateParticipantMetadata is called to change a participant's
   * state, *all*  participants in the room will fire this event.
   * To access the current metadata, see [[Participant.metadata]].
   *
   * args: (prevMetadata: string)
   *
   */ ParticipantEvent["ParticipantMetadataChanged"] = "participantMetadataChanged";
    /**
   * Participant's display name changed
   *
   * args: (name: string, [[Participant]])
   *
   */ ParticipantEvent["ParticipantNameChanged"] = "participantNameChanged";
    /**
   * Data received from this participant as sender.
   * Data packets provides the ability to use LiveKit to send/receive arbitrary payloads.
   * All participants in the room will receive the messages sent to the room.
   *
   * args: (payload: Uint8Array, kind: [[DataPacket_Kind]])
   */ ParticipantEvent["DataReceived"] = "dataReceived";
    /**
   * SIP DTMF tones received from this participant as sender.
   *
   * args: (dtmf: [[DataPacket_Kind]])
   */ ParticipantEvent["SipDTMFReceived"] = "sipDTMFReceived";
    /**
   * Transcription received from this participant as data source.
   * @beta
   */ ParticipantEvent["TranscriptionReceived"] = "transcriptionReceived";
    /**
   * Has speaking status changed for the current participant
   *
   * args: (speaking: boolean)
   */ ParticipantEvent["IsSpeakingChanged"] = "isSpeakingChanged";
    /**
   * Connection quality was changed for a Participant. It'll receive updates
   * from the local participant, as well as any [[RemoteParticipant]]s that we are
   * subscribed to.
   *
   * args: (connectionQuality: [[ConnectionQuality]])
   */ ParticipantEvent["ConnectionQualityChanged"] = "connectionQualityChanged";
    /**
   * StreamState indicates if a subscribed track has been paused by the SFU
   * (typically this happens because of subscriber's bandwidth constraints)
   *
   * When bandwidth conditions allow, the track will be resumed automatically.
   * TrackStreamStateChanged will also be emitted when that happens.
   *
   * args: (pub: [[RemoteTrackPublication]], streamState: [[Track.StreamState]])
   */ ParticipantEvent["TrackStreamStateChanged"] = "trackStreamStateChanged";
    /**
   * One of subscribed tracks have changed its permissions for the current
   * participant. If permission was revoked, then the track will no longer
   * be subscribed. If permission was granted, a TrackSubscribed event will
   * be emitted.
   *
   * args: (pub: [[RemoteTrackPublication]],
   *        status: [[TrackPublication.SubscriptionStatus]])
   */ ParticipantEvent["TrackSubscriptionPermissionChanged"] = "trackSubscriptionPermissionChanged";
    /**
   * One of the remote participants publications has changed its subscription status.
   *
   */ ParticipantEvent["TrackSubscriptionStatusChanged"] = "trackSubscriptionStatusChanged";
    // fired only on LocalParticipant
    /** @internal */ ParticipantEvent["MediaDevicesError"] = "mediaDevicesError";
    // fired only on LocalParticipant
    /** @internal */ ParticipantEvent["AudioStreamAcquired"] = "audioStreamAcquired";
    /**
   * A participant's permission has changed.
   * args: (prevPermissions: [[ParticipantPermission]])
   */ ParticipantEvent["ParticipantPermissionsChanged"] = "participantPermissionsChanged";
    /** @internal */ ParticipantEvent["PCTrackAdded"] = "pcTrackAdded";
    /**
   * Participant attributes is an app-specific key value state to be pushed to
   * all users.
   * When a participant's attributes changed, this event will be emitted with the changed attributes
   * args: (changedAttributes: [[Record<string, string]])
   */ ParticipantEvent["AttributesChanged"] = "attributesChanged";
    /**
   * fired on local participant only, when the first remote participant has subscribed to the track specified in the payload
   */ ParticipantEvent["LocalTrackSubscribed"] = "localTrackSubscribed";
    /** only emitted on local participant */ ParticipantEvent["ChatMessage"] = "chatMessage";
})($2d7d9af7a5367cf4$export$fcdfe2b7a6750691 || ($2d7d9af7a5367cf4$export$fcdfe2b7a6750691 = {}));
/** @internal */ var $2d7d9af7a5367cf4$export$c09e63b8572f869;
(function(EngineEvent) {
    EngineEvent["TransportsCreated"] = "transportsCreated";
    EngineEvent["Connected"] = "connected";
    EngineEvent["Disconnected"] = "disconnected";
    EngineEvent["Resuming"] = "resuming";
    EngineEvent["Resumed"] = "resumed";
    EngineEvent["Restarting"] = "restarting";
    EngineEvent["Restarted"] = "restarted";
    EngineEvent["SignalResumed"] = "signalResumed";
    EngineEvent["SignalRestarted"] = "signalRestarted";
    EngineEvent["Closing"] = "closing";
    EngineEvent["MediaTrackAdded"] = "mediaTrackAdded";
    EngineEvent["ActiveSpeakersUpdate"] = "activeSpeakersUpdate";
    EngineEvent["DataPacketReceived"] = "dataPacketReceived";
    EngineEvent["RTPVideoMapUpdate"] = "rtpVideoMapUpdate";
    EngineEvent["DCBufferStatusChanged"] = "dcBufferStatusChanged";
    EngineEvent["ParticipantUpdate"] = "participantUpdate";
    EngineEvent["RoomUpdate"] = "roomUpdate";
    EngineEvent["SpeakersChanged"] = "speakersChanged";
    EngineEvent["StreamStateChanged"] = "streamStateChanged";
    EngineEvent["ConnectionQualityUpdate"] = "connectionQualityUpdate";
    EngineEvent["SubscriptionError"] = "subscriptionError";
    EngineEvent["SubscriptionPermissionUpdate"] = "subscriptionPermissionUpdate";
    EngineEvent["RemoteMute"] = "remoteMute";
    EngineEvent["SubscribedQualityUpdate"] = "subscribedQualityUpdate";
    EngineEvent["LocalTrackUnpublished"] = "localTrackUnpublished";
    EngineEvent["LocalTrackSubscribed"] = "localTrackSubscribed";
    EngineEvent["Offline"] = "offline";
    EngineEvent["SignalRequestResponse"] = "signalRequestResponse";
})($2d7d9af7a5367cf4$export$c09e63b8572f869 || ($2d7d9af7a5367cf4$export$c09e63b8572f869 = {}));
var $2d7d9af7a5367cf4$export$2c8510d737cc09da;
(function(TrackEvent) {
    TrackEvent["Message"] = "message";
    TrackEvent["Muted"] = "muted";
    TrackEvent["Unmuted"] = "unmuted";
    /**
   * Only fires on LocalTracks
   */ TrackEvent["Restarted"] = "restarted";
    TrackEvent["Ended"] = "ended";
    TrackEvent["Subscribed"] = "subscribed";
    TrackEvent["Unsubscribed"] = "unsubscribed";
    /** @internal */ TrackEvent["UpdateSettings"] = "updateSettings";
    /** @internal */ TrackEvent["UpdateSubscription"] = "updateSubscription";
    /** @internal */ TrackEvent["AudioPlaybackStarted"] = "audioPlaybackStarted";
    /** @internal */ TrackEvent["AudioPlaybackFailed"] = "audioPlaybackFailed";
    /**
   * @internal
   * Only fires on LocalAudioTrack instances
   */ TrackEvent["AudioSilenceDetected"] = "audioSilenceDetected";
    /** @internal */ TrackEvent["VisibilityChanged"] = "visibilityChanged";
    /** @internal */ TrackEvent["VideoDimensionsChanged"] = "videoDimensionsChanged";
    /** @internal */ TrackEvent["VideoPlaybackStarted"] = "videoPlaybackStarted";
    /** @internal */ TrackEvent["VideoPlaybackFailed"] = "videoPlaybackFailed";
    /** @internal */ TrackEvent["ElementAttached"] = "elementAttached";
    /** @internal */ TrackEvent["ElementDetached"] = "elementDetached";
    /**
   * @internal
   * Only fires on LocalTracks
   */ TrackEvent["UpstreamPaused"] = "upstreamPaused";
    /**
   * @internal
   * Only fires on LocalTracks
   */ TrackEvent["UpstreamResumed"] = "upstreamResumed";
    /**
   * @internal
   * Fires on RemoteTrackPublication
   */ TrackEvent["SubscriptionPermissionChanged"] = "subscriptionPermissionChanged";
    /**
   * Fires on RemoteTrackPublication
   */ TrackEvent["SubscriptionStatusChanged"] = "subscriptionStatusChanged";
    /**
   * Fires on RemoteTrackPublication
   */ TrackEvent["SubscriptionFailed"] = "subscriptionFailed";
    /**
   * @internal
   */ TrackEvent["TrackProcessorUpdate"] = "trackProcessorUpdate";
    /**
   * @internal
   */ TrackEvent["AudioTrackFeatureUpdate"] = "audioTrackFeatureUpdate";
    /**
   * @beta
   */ TrackEvent["TranscriptionReceived"] = "transcriptionReceived";
    /**
   * @experimental
   */ TrackEvent["TimeSyncUpdate"] = "timeSyncUpdate";
})($2d7d9af7a5367cf4$export$2c8510d737cc09da || ($2d7d9af7a5367cf4$export$2c8510d737cc09da = {}));
function $2d7d9af7a5367cf4$var$r(r, e, n) {
    var i, t, o;
    void 0 === e && (e = 50), void 0 === n && (n = {});
    var a = null != (i = n.isImmediate) && i, u = null != (t = n.callback) && t, c = n.maxWait, v = Date.now(), l = [];
    function f() {
        if (void 0 !== c) {
            var r = Date.now() - v;
            if (r + e >= c) return c - r;
        }
        return e;
    }
    var d = function() {
        var e = [].slice.call(arguments), n = this;
        return new Promise(function(i, t) {
            var c = a && void 0 === o;
            if (void 0 !== o && clearTimeout(o), o = setTimeout(function() {
                if (o = void 0, v = Date.now(), !a) {
                    var i = r.apply(n, e);
                    u && u(i), l.forEach(function(r) {
                        return (0, r.resolve)(i);
                    }), l = [];
                }
            }, f()), c) {
                var d = r.apply(n, e);
                return u && u(d), i(d);
            }
            l.push({
                resolve: i,
                reject: t
            });
        });
    };
    return d.cancel = function(r) {
        void 0 !== o && clearTimeout(o), l.forEach(function(e) {
            return (0, e.reject)(r);
        }), l = [];
    }, d;
}
// tiny, simplified version of https://github.com/lancedikson/bowser/blob/master/src/parser-browsers.js
// reduced to only differentiate Chrome(ium) based browsers / Firefox / Safari
const $2d7d9af7a5367cf4$var$commonVersionIdentifier = /version\/(\d+(\.?_?\d+)+)/i;
let $2d7d9af7a5367cf4$var$browserDetails;
/**
 * @internal
 */ function $2d7d9af7a5367cf4$export$89e15fc796a4a429(userAgent) {
    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (typeof userAgent === 'undefined' && typeof navigator === 'undefined') return;
    const ua = (userAgent !== null && userAgent !== void 0 ? userAgent : navigator.userAgent).toLowerCase();
    if ($2d7d9af7a5367cf4$var$browserDetails === undefined || force) {
        const browser = $2d7d9af7a5367cf4$var$browsersList.find((_ref)=>{
            let { test: test } = _ref;
            return test.test(ua);
        });
        $2d7d9af7a5367cf4$var$browserDetails = browser === null || browser === void 0 ? void 0 : browser.describe(ua);
    }
    return $2d7d9af7a5367cf4$var$browserDetails;
}
const $2d7d9af7a5367cf4$var$browsersList = [
    {
        test: /firefox|iceweasel|fxios/i,
        describe (ua) {
            const browser = {
                name: 'Firefox',
                version: $2d7d9af7a5367cf4$var$getMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, ua),
                os: ua.toLowerCase().includes('fxios') ? 'iOS' : undefined,
                osVersion: $2d7d9af7a5367cf4$var$getOSVersion(ua)
            };
            return browser;
        }
    },
    {
        test: /chrom|crios|crmo/i,
        describe (ua) {
            const browser = {
                name: 'Chrome',
                version: $2d7d9af7a5367cf4$var$getMatch(/(?:chrome|chromium|crios|crmo)\/(\d+(\.?_?\d+)+)/i, ua),
                os: ua.toLowerCase().includes('crios') ? 'iOS' : undefined,
                osVersion: $2d7d9af7a5367cf4$var$getOSVersion(ua)
            };
            return browser;
        }
    },
    /* Safari */ {
        test: /safari|applewebkit/i,
        describe (ua) {
            const browser = {
                name: 'Safari',
                version: $2d7d9af7a5367cf4$var$getMatch($2d7d9af7a5367cf4$var$commonVersionIdentifier, ua),
                os: ua.includes('mobile/') ? 'iOS' : 'macOS',
                osVersion: $2d7d9af7a5367cf4$var$getOSVersion(ua)
            };
            return browser;
        }
    }
];
function $2d7d9af7a5367cf4$var$getMatch(exp, ua) {
    let id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    const match = ua.match(exp);
    return match && match.length >= id && match[id] || '';
}
function $2d7d9af7a5367cf4$var$getOSVersion(ua) {
    return ua.includes('mac os') ? $2d7d9af7a5367cf4$var$getMatch(/\(.+?(\d+_\d+(:?_\d+)?)/, ua, 1).replace(/_/g, '.') : undefined;
}
var $2d7d9af7a5367cf4$var$version$1 = "2.7.5";
const $2d7d9af7a5367cf4$export$83d89fbfd8236492 = $2d7d9af7a5367cf4$var$version$1;
const $2d7d9af7a5367cf4$export$94587fadffb515a1 = 15;
/**
 * Timers that can be overridden with platform specific implementations
 * that ensure that they are fired. These should be used when it is critical
 * that the timer fires on time.
 */ class $2d7d9af7a5367cf4$export$22e737276454df96 {
}
$2d7d9af7a5367cf4$export$22e737276454df96.setTimeout = function() {
    return setTimeout(...arguments);
};
$2d7d9af7a5367cf4$export$22e737276454df96.setInterval = // eslint-disable-next-line @typescript-eslint/no-implied-eval
function() {
    return setInterval(...arguments);
};
$2d7d9af7a5367cf4$export$22e737276454df96.clearTimeout = function() {
    return clearTimeout(...arguments);
};
$2d7d9af7a5367cf4$export$22e737276454df96.clearInterval = function() {
    return clearInterval(...arguments);
};
class $2d7d9af7a5367cf4$export$73e76f4fd970cdf1 {
    constructor(widthOrOptions, height, maxBitrate, maxFramerate, priority){
        if (typeof widthOrOptions === 'object') {
            this.width = widthOrOptions.width;
            this.height = widthOrOptions.height;
            this.aspectRatio = widthOrOptions.aspectRatio;
            this.encoding = {
                maxBitrate: widthOrOptions.maxBitrate,
                maxFramerate: widthOrOptions.maxFramerate,
                priority: widthOrOptions.priority
            };
        } else if (height !== undefined && maxBitrate !== undefined) {
            this.width = widthOrOptions;
            this.height = height;
            this.aspectRatio = widthOrOptions / height;
            this.encoding = {
                maxBitrate: maxBitrate,
                maxFramerate: maxFramerate,
                priority: priority
            };
        } else throw new TypeError('Unsupported options: provide at least width, height and maxBitrate');
    }
    get resolution() {
        return {
            width: this.width,
            height: this.height,
            frameRate: this.encoding.maxFramerate,
            aspectRatio: this.aspectRatio
        };
    }
}
const $2d7d9af7a5367cf4$var$backupCodecs = [
    'vp8',
    'h264'
];
const $2d7d9af7a5367cf4$export$986dcb5e6a94a34c = [
    'vp8',
    'h264',
    'vp9',
    'av1'
];
function $2d7d9af7a5367cf4$export$da37a49ee77f9d77(codec) {
    return !!$2d7d9af7a5367cf4$var$backupCodecs.find((backup)=>backup === codec);
}
var $2d7d9af7a5367cf4$export$5da93632511fdb1f;
(function(AudioPresets) {
    AudioPresets.telephone = {
        maxBitrate: 12000
    };
    AudioPresets.speech = {
        maxBitrate: 24000
    };
    AudioPresets.music = {
        maxBitrate: 48000
    };
    AudioPresets.musicStereo = {
        maxBitrate: 64000
    };
    AudioPresets.musicHighQuality = {
        maxBitrate: 96000
    };
    AudioPresets.musicHighQualityStereo = {
        maxBitrate: 128000
    };
})($2d7d9af7a5367cf4$export$5da93632511fdb1f || ($2d7d9af7a5367cf4$export$5da93632511fdb1f = {}));
/**
 * Sane presets for video resolution/encoding
 */ const $2d7d9af7a5367cf4$export$79d56065dad1674c = {
    h90: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(160, 90, 90000, 20),
    h180: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(320, 180, 160000, 20),
    h216: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(384, 216, 180000, 20),
    h360: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(640, 360, 450000, 20),
    h540: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(960, 540, 800000, 25),
    h720: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(1280, 720, 1700000, 30),
    h1080: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(1920, 1080, 3000000, 30),
    h1440: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(2560, 1440, 5000000, 30),
    h2160: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(3840, 2160, 8000000, 30)
};
/**
 * Four by three presets
 */ const $2d7d9af7a5367cf4$export$eb5fc43ecc8ee2c7 = {
    h120: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(160, 120, 70000, 20),
    h180: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(240, 180, 125000, 20),
    h240: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(320, 240, 140000, 20),
    h360: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(480, 360, 330000, 20),
    h480: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(640, 480, 500000, 20),
    h540: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(720, 540, 600000, 25),
    h720: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(960, 720, 1300000, 30),
    h1080: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(1440, 1080, 2300000, 30),
    h1440: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(1920, 1440, 3800000, 30)
};
const $2d7d9af7a5367cf4$export$a6cdf9dcd3d32f2d = {
    h360fps3: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(640, 360, 200000, 3, 'medium'),
    h360fps15: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(640, 360, 400000, 15, 'medium'),
    h720fps5: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(1280, 720, 800000, 5, 'medium'),
    h720fps15: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(1280, 720, 1500000, 15, 'medium'),
    h720fps30: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(1280, 720, 2000000, 30, 'medium'),
    h1080fps15: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(1920, 1080, 2500000, 15, 'medium'),
    h1080fps30: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(1920, 1080, 5000000, 30, 'medium'),
    // original resolution, without resizing
    original: new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(0, 0, 7000000, 30, 'medium')
};
function $2d7d9af7a5367cf4$var$cloneDeep(value) {
    if (typeof value === 'undefined') return;
    if (typeof structuredClone === 'function') return structuredClone(value);
    else return JSON.parse(JSON.stringify(value));
}
const $2d7d9af7a5367cf4$var$BACKGROUND_REACTION_DELAY = 5000;
// keep old audio elements when detached, we would re-use them since on iOS
// Safari tracks which audio elements have been "blessed" by the user.
const $2d7d9af7a5367cf4$var$recycledElements = [];
var $2d7d9af7a5367cf4$export$a8f593954e806155;
(function(VideoQuality) {
    VideoQuality[VideoQuality["LOW"] = 0] = "LOW";
    VideoQuality[VideoQuality["MEDIUM"] = 1] = "MEDIUM";
    VideoQuality[VideoQuality["HIGH"] = 2] = "HIGH";
})($2d7d9af7a5367cf4$export$a8f593954e806155 || ($2d7d9af7a5367cf4$export$a8f593954e806155 = {}));
class $2d7d9af7a5367cf4$export$13921ac0cc260818 extends $2d7d9af7a5367cf4$var$eventsExports.EventEmitter {
    constructor(mediaTrack, kind){
        let loggerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _a;
        super();
        this.attachedElements = [];
        this.isMuted = false;
        /**
     * indicates current state of stream, it'll indicate `paused` if the track
     * has been paused by congestion controller
     */ this.streamState = $2d7d9af7a5367cf4$export$13921ac0cc260818.StreamState.Active;
        this.isInBackground = false;
        this._currentBitrate = 0;
        this.log = $2d7d9af7a5367cf4$var$livekitLogger;
        this.appVisibilityChangedListener = ()=>{
            if (this.backgroundTimeout) clearTimeout(this.backgroundTimeout);
            // delay app visibility update if it goes to hidden
            // update immediately if it comes back to focus
            if (document.visibilityState === 'hidden') this.backgroundTimeout = setTimeout(()=>this.handleAppVisibilityChanged(), $2d7d9af7a5367cf4$var$BACKGROUND_REACTION_DELAY);
            else this.handleAppVisibilityChanged();
        };
        this.log = $2d7d9af7a5367cf4$export$2b1d391cd05230fd((_a = loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $2d7d9af7a5367cf4$export$69ba24dd79f4da21.Track);
        this.loggerContextCb = loggerOptions.loggerContextCb;
        this.setMaxListeners(100);
        this.kind = kind;
        this._mediaStreamTrack = mediaTrack;
        this._mediaStreamID = mediaTrack.id;
        this.source = $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Unknown;
    }
    get logContext() {
        var _a;
        return Object.assign(Object.assign({}, (_a = this.loggerContextCb) === null || _a === void 0 ? void 0 : _a.call(this)), $2d7d9af7a5367cf4$var$getLogContextFromTrack(this));
    }
    /** current receive bits per second */ get currentBitrate() {
        return this._currentBitrate;
    }
    get mediaStreamTrack() {
        return this._mediaStreamTrack;
    }
    /**
   * @internal
   * used for keep mediaStream's first id, since it's id might change
   * if we disable/enable a track
   */ get mediaStreamID() {
        return this._mediaStreamID;
    }
    attach(element) {
        let elementType = 'audio';
        if (this.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video) elementType = 'video';
        if (this.attachedElements.length === 0 && this.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video) this.addAppVisibilityListener();
        if (!element) {
            if (elementType === 'audio') {
                $2d7d9af7a5367cf4$var$recycledElements.forEach((e)=>{
                    if (e.parentElement === null && !element) element = e;
                });
                if (element) // remove it from pool
                $2d7d9af7a5367cf4$var$recycledElements.splice($2d7d9af7a5367cf4$var$recycledElements.indexOf(element), 1);
            }
            if (!element) element = document.createElement(elementType);
        }
        if (!this.attachedElements.includes(element)) this.attachedElements.push(element);
        // even if we believe it's already attached to the element, it's possible
        // the element's srcObject was set to something else out of band.
        // we'll want to re-attach it in that case
        $2d7d9af7a5367cf4$export$b8f95ef2322890b8(this.mediaStreamTrack, element);
        // handle auto playback failures
        const allMediaStreamTracks = element.srcObject.getTracks();
        const hasAudio = allMediaStreamTracks.some((tr)=>tr.kind === 'audio');
        // manually play media to detect auto playback status
        element.play().then(()=>{
            this.emit(hasAudio ? $2d7d9af7a5367cf4$export$2c8510d737cc09da.AudioPlaybackStarted : $2d7d9af7a5367cf4$export$2c8510d737cc09da.VideoPlaybackStarted);
        }).catch((e)=>{
            if (e.name === 'NotAllowedError') this.emit(hasAudio ? $2d7d9af7a5367cf4$export$2c8510d737cc09da.AudioPlaybackFailed : $2d7d9af7a5367cf4$export$2c8510d737cc09da.VideoPlaybackFailed, e);
            else if (e.name === 'AbortError') // commonly triggered by another `play` request, only log for debugging purposes
            $2d7d9af7a5367cf4$var$livekitLogger.debug("".concat(hasAudio ? 'audio' : 'video', " playback aborted, likely due to new play request"));
            else $2d7d9af7a5367cf4$var$livekitLogger.warn("could not playback ".concat(hasAudio ? 'audio' : 'video'), e);
            // If audio playback isn't allowed make sure we still play back the video
            if (hasAudio && element && allMediaStreamTracks.some((tr)=>tr.kind === 'video') && e.name === 'NotAllowedError') {
                element.muted = true;
                element.play().catch(()=>{
                // catch for Safari, exceeded options at this point to automatically play the media element
                });
            }
        });
        this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.ElementAttached, element);
        return element;
    }
    detach(element) {
        try {
            // detach from a single element
            if (element) {
                $2d7d9af7a5367cf4$export$8ea68c6294970fa5(this.mediaStreamTrack, element);
                const idx = this.attachedElements.indexOf(element);
                if (idx >= 0) {
                    this.attachedElements.splice(idx, 1);
                    this.recycleElement(element);
                    this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.ElementDetached, element);
                }
                return element;
            }
            const detached = [];
            this.attachedElements.forEach((elm)=>{
                $2d7d9af7a5367cf4$export$8ea68c6294970fa5(this.mediaStreamTrack, elm);
                detached.push(elm);
                this.recycleElement(elm);
                this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.ElementDetached, elm);
            });
            // remove all tracks
            this.attachedElements = [];
            return detached;
        } finally{
            if (this.attachedElements.length === 0) this.removeAppVisibilityListener();
        }
    }
    stop() {
        this.stopMonitor();
        this._mediaStreamTrack.stop();
    }
    enable() {
        this._mediaStreamTrack.enabled = true;
    }
    disable() {
        this._mediaStreamTrack.enabled = false;
    }
    /* @internal */ stopMonitor() {
        if (this.monitorInterval) clearInterval(this.monitorInterval);
        if (this.timeSyncHandle) cancelAnimationFrame(this.timeSyncHandle);
    }
    /** @internal */ updateLoggerOptions(loggerOptions) {
        if (loggerOptions.loggerName) this.log = $2d7d9af7a5367cf4$export$2b1d391cd05230fd(loggerOptions.loggerName);
        if (loggerOptions.loggerContextCb) this.loggerContextCb = loggerOptions.loggerContextCb;
    }
    recycleElement(element) {
        if (element instanceof HTMLAudioElement) {
            // we only need to re-use a single element
            let shouldCache = true;
            element.pause();
            $2d7d9af7a5367cf4$var$recycledElements.forEach((e)=>{
                if (!e.parentElement) shouldCache = false;
            });
            if (shouldCache) $2d7d9af7a5367cf4$var$recycledElements.push(element);
        }
    }
    handleAppVisibilityChanged() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            this.isInBackground = document.visibilityState === 'hidden';
            if (!this.isInBackground && this.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video) setTimeout(()=>this.attachedElements.forEach((el)=>el.play().catch(()=>{
                    /** catch clause necessary for Safari */ })), 0);
        });
    }
    addAppVisibilityListener() {
        if ($2d7d9af7a5367cf4$var$isWeb()) {
            this.isInBackground = document.visibilityState === 'hidden';
            document.addEventListener('visibilitychange', this.appVisibilityChangedListener);
        } else this.isInBackground = false;
    }
    removeAppVisibilityListener() {
        if ($2d7d9af7a5367cf4$var$isWeb()) document.removeEventListener('visibilitychange', this.appVisibilityChangedListener);
    }
}
function $2d7d9af7a5367cf4$export$b8f95ef2322890b8(track, element) {
    let mediaStream;
    if (element.srcObject instanceof MediaStream) mediaStream = element.srcObject;
    else mediaStream = new MediaStream();
    // check if track matches existing track
    let existingTracks;
    if (track.kind === 'audio') existingTracks = mediaStream.getAudioTracks();
    else existingTracks = mediaStream.getVideoTracks();
    if (!existingTracks.includes(track)) {
        existingTracks.forEach((et)=>{
            mediaStream.removeTrack(et);
        });
        mediaStream.addTrack(track);
    }
    if (!$2d7d9af7a5367cf4$var$isSafari() || !(element instanceof HTMLVideoElement)) // when in low power mode (applies to both macOS and iOS), Safari will show a play/pause overlay
    // when a video starts that has the `autoplay` attribute is set.
    // we work around this by _not_ setting the autoplay attribute on safari and instead call `setTimeout(() => el.play(),0)` further down
    element.autoplay = true;
    // In case there are no audio tracks present on the mediastream, we set the element as muted to ensure autoplay works
    element.muted = mediaStream.getAudioTracks().length === 0;
    if (element instanceof HTMLVideoElement) element.playsInline = true;
    // avoid flicker
    if (element.srcObject !== mediaStream) {
        element.srcObject = mediaStream;
        if (($2d7d9af7a5367cf4$var$isSafari() || $2d7d9af7a5367cf4$var$isFireFox()) && element instanceof HTMLVideoElement) // Firefox also has a timing issue where video doesn't actually get attached unless
        // performed out-of-band
        // Safari 15 has a bug where in certain layouts, video element renders
        // black until the page is resized or other changes take place.
        // Resetting the src triggers it to render.
        // https://developer.apple.com/forums/thread/690523
        setTimeout(()=>{
            element.srcObject = mediaStream;
            // Safari 15 sometimes fails to start a video
            // when the window is backgrounded before the first frame is drawn
            // manually calling play here seems to fix that
            element.play().catch(()=>{
            /** do nothing */ });
        }, 0);
    }
}
/** @internal */ function $2d7d9af7a5367cf4$export$8ea68c6294970fa5(track, element) {
    if (element.srcObject instanceof MediaStream) {
        const mediaStream = element.srcObject;
        mediaStream.removeTrack(track);
        if (mediaStream.getTracks().length > 0) element.srcObject = mediaStream;
        else element.srcObject = null;
    }
}
(function(Track) {
    let Kind;
    (function(Kind) {
        Kind["Audio"] = "audio";
        Kind["Video"] = "video";
        Kind["Unknown"] = "unknown";
    })(Kind = Track.Kind || (Track.Kind = {}));
    let Source;
    (function(Source) {
        Source["Camera"] = "camera";
        Source["Microphone"] = "microphone";
        Source["ScreenShare"] = "screen_share";
        Source["ScreenShareAudio"] = "screen_share_audio";
        Source["Unknown"] = "unknown";
    })(Source = Track.Source || (Track.Source = {}));
    let StreamState$1;
    (function(StreamState) {
        StreamState["Active"] = "active";
        StreamState["Paused"] = "paused";
        StreamState["Unknown"] = "unknown";
    })(StreamState$1 = Track.StreamState || (Track.StreamState = {}));
    /** @internal */ function kindToProto(k) {
        switch(k){
            case Kind.Audio:
                return $2d7d9af7a5367cf4$var$TrackType.AUDIO;
            case Kind.Video:
                return $2d7d9af7a5367cf4$var$TrackType.VIDEO;
            default:
                // FIXME this was UNRECOGNIZED before
                return $2d7d9af7a5367cf4$var$TrackType.DATA;
        }
    }
    Track.kindToProto = kindToProto;
    /** @internal */ function kindFromProto(t) {
        switch(t){
            case $2d7d9af7a5367cf4$var$TrackType.AUDIO:
                return Kind.Audio;
            case $2d7d9af7a5367cf4$var$TrackType.VIDEO:
                return Kind.Video;
            default:
                return Kind.Unknown;
        }
    }
    Track.kindFromProto = kindFromProto;
    /** @internal */ function sourceToProto(s) {
        switch(s){
            case Source.Camera:
                return $2d7d9af7a5367cf4$var$TrackSource.CAMERA;
            case Source.Microphone:
                return $2d7d9af7a5367cf4$var$TrackSource.MICROPHONE;
            case Source.ScreenShare:
                return $2d7d9af7a5367cf4$var$TrackSource.SCREEN_SHARE;
            case Source.ScreenShareAudio:
                return $2d7d9af7a5367cf4$var$TrackSource.SCREEN_SHARE_AUDIO;
            default:
                return $2d7d9af7a5367cf4$var$TrackSource.UNKNOWN;
        }
    }
    Track.sourceToProto = sourceToProto;
    /** @internal */ function sourceFromProto(s) {
        switch(s){
            case $2d7d9af7a5367cf4$var$TrackSource.CAMERA:
                return Source.Camera;
            case $2d7d9af7a5367cf4$var$TrackSource.MICROPHONE:
                return Source.Microphone;
            case $2d7d9af7a5367cf4$var$TrackSource.SCREEN_SHARE:
                return Source.ScreenShare;
            case $2d7d9af7a5367cf4$var$TrackSource.SCREEN_SHARE_AUDIO:
                return Source.ScreenShareAudio;
            default:
                return Source.Unknown;
        }
    }
    Track.sourceFromProto = sourceFromProto;
    /** @internal */ function streamStateFromProto(s) {
        switch(s){
            case $2d7d9af7a5367cf4$var$StreamState.ACTIVE:
                return StreamState$1.Active;
            case $2d7d9af7a5367cf4$var$StreamState.PAUSED:
                return StreamState$1.Paused;
            default:
                return StreamState$1.Unknown;
        }
    }
    Track.streamStateFromProto = streamStateFromProto;
})($2d7d9af7a5367cf4$export$13921ac0cc260818 || ($2d7d9af7a5367cf4$export$13921ac0cc260818 = {}));
function $2d7d9af7a5367cf4$var$mergeDefaultOptions(options, audioDefaults, videoDefaults) {
    var _a;
    const { optionsWithoutProcessor: optionsWithoutProcessor, audioProcessor: audioProcessor, videoProcessor: videoProcessor } = $2d7d9af7a5367cf4$var$extractProcessorsFromOptions(options !== null && options !== void 0 ? options : {});
    const clonedOptions = (_a = $2d7d9af7a5367cf4$var$cloneDeep(optionsWithoutProcessor)) !== null && _a !== void 0 ? _a : {};
    if (clonedOptions.audio === true) clonedOptions.audio = {};
    if (clonedOptions.video === true) clonedOptions.video = {};
    // use defaults
    if (clonedOptions.audio) {
        $2d7d9af7a5367cf4$var$mergeObjectWithoutOverwriting(clonedOptions.audio, audioDefaults);
        if (audioProcessor) clonedOptions.audio.processor = audioProcessor;
    }
    if (clonedOptions.video) {
        $2d7d9af7a5367cf4$var$mergeObjectWithoutOverwriting(clonedOptions.video, videoDefaults);
        if (videoProcessor) clonedOptions.video.processor = videoProcessor;
    }
    return clonedOptions;
}
function $2d7d9af7a5367cf4$var$mergeObjectWithoutOverwriting(mainObject, objectToMerge) {
    Object.keys(objectToMerge).forEach((key)=>{
        if (mainObject[key] === undefined) mainObject[key] = objectToMerge[key];
    });
    return mainObject;
}
function $2d7d9af7a5367cf4$var$constraintsForOptions(options) {
    const constraints = {};
    if (options.video) {
        // default video options
        if (typeof options.video === 'object') {
            const videoOptions = {};
            const target = videoOptions;
            const source = options.video;
            Object.keys(source).forEach((key)=>{
                switch(key){
                    case 'resolution':
                        // flatten VideoResolution fields
                        $2d7d9af7a5367cf4$var$mergeObjectWithoutOverwriting(target, source.resolution);
                        break;
                    default:
                        target[key] = source[key];
                }
            });
            constraints.video = videoOptions;
        } else constraints.video = options.video;
    } else constraints.video = false;
    if (options.audio) {
        if (typeof options.audio === 'object') constraints.audio = options.audio;
        else constraints.audio = true;
    } else constraints.audio = false;
    return constraints;
}
/**
 * This function detects silence on a given [[Track]] instance.
 * Returns true if the track seems to be entirely silent.
 */ function $2d7d9af7a5367cf4$var$detectSilence(track_1) {
    return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function(track) {
        let timeOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
        return function*() {
            const ctx = $2d7d9af7a5367cf4$var$getNewAudioContext();
            if (ctx) {
                const analyser = ctx.createAnalyser();
                analyser.fftSize = 2048;
                const bufferLength = analyser.frequencyBinCount;
                const dataArray = new Uint8Array(bufferLength);
                const source = ctx.createMediaStreamSource(new MediaStream([
                    track.mediaStreamTrack
                ]));
                source.connect(analyser);
                yield $2d7d9af7a5367cf4$var$sleep(timeOffset);
                analyser.getByteTimeDomainData(dataArray);
                const someNoise = dataArray.some((sample)=>sample !== 128 && sample !== 0);
                ctx.close();
                return !someNoise;
            }
            return false;
        }();
    });
}
/**
 * @internal
 */ function $2d7d9af7a5367cf4$var$getNewAudioContext() {
    const AudioContext1 = // @ts-ignore
    typeof window !== 'undefined' && (window.AudioContext || window.webkitAudioContext);
    if (AudioContext1) return new AudioContext1({
        latencyHint: 'interactive'
    });
}
/**
 * @internal
 */ function $2d7d9af7a5367cf4$var$sourceToKind(source) {
    if (source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Microphone) return 'audioinput';
    else if (source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Camera) return 'videoinput';
    else return undefined;
}
/**
 * @internal
 */ function $2d7d9af7a5367cf4$var$screenCaptureToDisplayMediaStreamOptions(options) {
    var _a, _b;
    let videoConstraints = (_a = options.video) !== null && _a !== void 0 ? _a : true;
    // treat 0 as uncapped
    if (options.resolution && options.resolution.width > 0 && options.resolution.height > 0) {
        videoConstraints = typeof videoConstraints === 'boolean' ? {} : videoConstraints;
        if ($2d7d9af7a5367cf4$var$isSafari()) videoConstraints = Object.assign(Object.assign({}, videoConstraints), {
            width: {
                max: options.resolution.width
            },
            height: {
                max: options.resolution.height
            },
            frameRate: options.resolution.frameRate
        });
        else videoConstraints = Object.assign(Object.assign({}, videoConstraints), {
            width: {
                ideal: options.resolution.width
            },
            height: {
                ideal: options.resolution.height
            },
            frameRate: options.resolution.frameRate
        });
    }
    return {
        audio: (_b = options.audio) !== null && _b !== void 0 ? _b : false,
        video: videoConstraints,
        // @ts-expect-error support for experimental display media features
        controller: options.controller,
        selfBrowserSurface: options.selfBrowserSurface,
        surfaceSwitching: options.surfaceSwitching,
        systemAudio: options.systemAudio,
        preferCurrentTab: options.preferCurrentTab
    };
}
function $2d7d9af7a5367cf4$var$mimeTypeToVideoCodecString(mimeType) {
    return mimeType.split('/')[1].toLowerCase();
}
function $2d7d9af7a5367cf4$var$getTrackPublicationInfo(tracks) {
    const infos = [];
    tracks.forEach((track)=>{
        if (track.track !== undefined) infos.push(new $2d7d9af7a5367cf4$var$TrackPublishedResponse({
            cid: track.track.mediaStreamID,
            track: track.trackInfo
        }));
    });
    return infos;
}
function $2d7d9af7a5367cf4$var$getLogContextFromTrack(track) {
    if (track instanceof $2d7d9af7a5367cf4$export$13921ac0cc260818) return {
        trackID: track.sid,
        source: track.source,
        muted: track.isMuted,
        enabled: track.mediaStreamTrack.enabled,
        kind: track.kind,
        streamID: track.mediaStreamID,
        streamTrackID: track.mediaStreamTrack.id
    };
    else return {
        trackID: track.trackSid,
        enabled: track.isEnabled,
        muted: track.isMuted,
        trackInfo: Object.assign({
            mimeType: track.mimeType,
            name: track.trackName,
            encrypted: track.isEncrypted,
            kind: track.kind,
            source: track.source
        }, track.track ? $2d7d9af7a5367cf4$var$getLogContextFromTrack(track.track) : {})
    };
}
function $2d7d9af7a5367cf4$var$supportsSynchronizationSources() {
    return typeof RTCRtpReceiver !== 'undefined' && 'getSynchronizationSources' in RTCRtpReceiver;
}
function $2d7d9af7a5367cf4$var$diffAttributes(oldValues, newValues) {
    var _a;
    if (oldValues === undefined) oldValues = {};
    if (newValues === undefined) newValues = {};
    const allKeys = [
        ...Object.keys(newValues),
        ...Object.keys(oldValues)
    ];
    const diff = {};
    for (const key of allKeys)if (oldValues[key] !== newValues[key]) diff[key] = (_a = newValues[key]) !== null && _a !== void 0 ? _a : '';
    return diff;
}
/** @internal */ function $2d7d9af7a5367cf4$var$extractProcessorsFromOptions(options) {
    const newOptions = Object.assign({}, options);
    let audioProcessor;
    let videoProcessor;
    if (typeof newOptions.audio === 'object' && newOptions.audio.processor) {
        audioProcessor = newOptions.audio.processor;
        newOptions.audio = Object.assign(Object.assign({}, newOptions.audio), {
            processor: undefined
        });
    }
    if (typeof newOptions.video === 'object' && newOptions.video.processor) {
        videoProcessor = newOptions.video.processor;
        newOptions.video = Object.assign(Object.assign({}, newOptions.video), {
            processor: undefined
        });
    }
    return {
        audioProcessor: audioProcessor,
        videoProcessor: videoProcessor,
        optionsWithoutProcessor: newOptions
    };
}
const $2d7d9af7a5367cf4$var$separator = '|';
const $2d7d9af7a5367cf4$var$ddExtensionURI = 'https://aomediacodec.github.io/av1-rtp-spec/#dependency-descriptor-rtp-header-extension';
function $2d7d9af7a5367cf4$var$unpackStreamId(packed) {
    const parts = packed.split($2d7d9af7a5367cf4$var$separator);
    if (parts.length > 1) return [
        parts[0],
        packed.substr(parts[0].length + 1)
    ];
    return [
        packed,
        ''
    ];
}
function $2d7d9af7a5367cf4$var$sleep(duration) {
    return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve)=>$2d7d9af7a5367cf4$export$22e737276454df96.setTimeout(resolve, duration));
    });
}
/** @internal */ function $2d7d9af7a5367cf4$var$supportsTransceiver() {
    return 'addTransceiver' in RTCPeerConnection.prototype;
}
/** @internal */ function $2d7d9af7a5367cf4$var$supportsAddTrack() {
    return 'addTrack' in RTCPeerConnection.prototype;
}
function $2d7d9af7a5367cf4$export$5d441b0d5c2caf15() {
    return true;
}
function $2d7d9af7a5367cf4$export$54d539ea1a521c7e() {
    return $2d7d9af7a5367cf4$var$supportsTransceiver();
}
function $2d7d9af7a5367cf4$export$f157b33fe3596be1() {
    if (!('getCapabilities' in RTCRtpSender)) return false;
    if ($2d7d9af7a5367cf4$var$isSafari()) // Safari 17 on iPhone14 reports AV1 capability, but does not actually support it
    return false;
    const capabilities = RTCRtpSender.getCapabilities('video');
    let hasAV1 = false;
    if (capabilities) {
        for (const codec of capabilities.codecs)if (codec.mimeType === 'video/AV1') {
            hasAV1 = true;
            break;
        }
    }
    return hasAV1;
}
function $2d7d9af7a5367cf4$export$7c4c0f8271043129() {
    if (!('getCapabilities' in RTCRtpSender)) return false;
    if ($2d7d9af7a5367cf4$var$isFireFox()) // technically speaking FireFox supports VP9, but SVC publishing is broken
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1633876
    return false;
    if ($2d7d9af7a5367cf4$var$isSafari()) {
        const browser = $2d7d9af7a5367cf4$export$89e15fc796a4a429();
        if ((browser === null || browser === void 0 ? void 0 : browser.version) && $2d7d9af7a5367cf4$export$66e1c0999abad646(browser.version, '16') < 0) // Safari 16 and below does not support VP9
        return false;
    }
    const capabilities = RTCRtpSender.getCapabilities('video');
    let hasVP9 = false;
    if (capabilities) {
        for (const codec of capabilities.codecs)if (codec.mimeType === 'video/VP9') {
            hasVP9 = true;
            break;
        }
    }
    return hasVP9;
}
function $2d7d9af7a5367cf4$var$isSVCCodec(codec) {
    return codec === 'av1' || codec === 'vp9';
}
function $2d7d9af7a5367cf4$var$supportsSetSinkId(elm) {
    if (!document) return false;
    if (!elm) elm = document.createElement('audio');
    return 'setSinkId' in elm;
}
function $2d7d9af7a5367cf4$export$3fe402ec04821f17() {
    if (typeof RTCPeerConnection === 'undefined') return false;
    return $2d7d9af7a5367cf4$var$supportsTransceiver() || $2d7d9af7a5367cf4$var$supportsAddTrack();
}
function $2d7d9af7a5367cf4$var$isFireFox() {
    var _a;
    return ((_a = $2d7d9af7a5367cf4$export$89e15fc796a4a429()) === null || _a === void 0 ? void 0 : _a.name) === 'Firefox';
}
function $2d7d9af7a5367cf4$var$isSafari() {
    var _a;
    return ((_a = $2d7d9af7a5367cf4$export$89e15fc796a4a429()) === null || _a === void 0 ? void 0 : _a.name) === 'Safari';
}
function $2d7d9af7a5367cf4$var$isSafari17() {
    const b = $2d7d9af7a5367cf4$export$89e15fc796a4a429();
    return (b === null || b === void 0 ? void 0 : b.name) === 'Safari' && b.version.startsWith('17.');
}
function $2d7d9af7a5367cf4$var$isMobile() {
    var _a, _b;
    if (!$2d7d9af7a5367cf4$var$isWeb()) return false;
    return(// @ts-expect-error `userAgentData` is not yet part of typescript
    (_b = (_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.mobile) !== null && _b !== void 0 ? _b : /Tablet|iPad|Mobile|Android|BlackBerry/.test(navigator.userAgent));
}
function $2d7d9af7a5367cf4$var$isE2EESimulcastSupported() {
    const browser = $2d7d9af7a5367cf4$export$89e15fc796a4a429();
    const supportedSafariVersion = '17.2'; // see https://bugs.webkit.org/show_bug.cgi?id=257803
    if (browser) {
        if (browser.name !== 'Safari' && browser.os !== 'iOS') return true;
        else if (browser.os === 'iOS' && browser.osVersion && $2d7d9af7a5367cf4$export$66e1c0999abad646(supportedSafariVersion, browser.osVersion) >= 0) return true;
        else if (browser.name === 'Safari' && $2d7d9af7a5367cf4$export$66e1c0999abad646(supportedSafariVersion, browser.version) >= 0) return true;
        else return false;
    }
}
function $2d7d9af7a5367cf4$var$isWeb() {
    return typeof document !== 'undefined';
}
function $2d7d9af7a5367cf4$var$isReactNative() {
    // navigator.product is deprecated on browsers, but will be set appropriately for react-native.
    return navigator.product == 'ReactNative';
}
function $2d7d9af7a5367cf4$var$isCloud(serverUrl) {
    return serverUrl.hostname.endsWith('.livekit.cloud') || serverUrl.hostname.endsWith('.livekit.run');
}
function $2d7d9af7a5367cf4$var$getLKReactNativeInfo() {
    // global defined only for ReactNative.
    // @ts-ignore
    if ($parcel$global && $parcel$global.LiveKitReactNativeGlobal) // @ts-ignore
    return $parcel$global.LiveKitReactNativeGlobal;
    return undefined;
}
function $2d7d9af7a5367cf4$var$getReactNativeOs() {
    if (!$2d7d9af7a5367cf4$var$isReactNative()) return undefined;
    let info = $2d7d9af7a5367cf4$var$getLKReactNativeInfo();
    if (info) return info.platform;
    return undefined;
}
function $2d7d9af7a5367cf4$var$getDevicePixelRatio() {
    if ($2d7d9af7a5367cf4$var$isWeb()) return window.devicePixelRatio;
    if ($2d7d9af7a5367cf4$var$isReactNative()) {
        let info = $2d7d9af7a5367cf4$var$getLKReactNativeInfo();
        if (info) return info.devicePixelRatio;
    }
    return 1;
}
function $2d7d9af7a5367cf4$export$66e1c0999abad646(v1, v2) {
    const parts1 = v1.split('.');
    const parts2 = v2.split('.');
    const k = Math.min(parts1.length, parts2.length);
    for(let i = 0; i < k; ++i){
        const p1 = parseInt(parts1[i], 10);
        const p2 = parseInt(parts2[i], 10);
        if (p1 > p2) return 1;
        if (p1 < p2) return -1;
        if (i === k - 1 && p1 === p2) return 0;
    }
    if (v1 === '' && v2 !== '') return -1;
    else if (v2 === '') return 1;
    return parts1.length == parts2.length ? 0 : parts1.length < parts2.length ? -1 : 1;
}
function $2d7d9af7a5367cf4$var$roDispatchCallback(entries) {
    for (const entry of entries)entry.target.handleResize(entry);
}
function $2d7d9af7a5367cf4$var$ioDispatchCallback(entries) {
    for (const entry of entries)entry.target.handleVisibilityChanged(entry);
}
let $2d7d9af7a5367cf4$var$resizeObserver = null;
const $2d7d9af7a5367cf4$var$getResizeObserver = ()=>{
    if (!$2d7d9af7a5367cf4$var$resizeObserver) $2d7d9af7a5367cf4$var$resizeObserver = new ResizeObserver($2d7d9af7a5367cf4$var$roDispatchCallback);
    return $2d7d9af7a5367cf4$var$resizeObserver;
};
let $2d7d9af7a5367cf4$var$intersectionObserver = null;
const $2d7d9af7a5367cf4$var$getIntersectionObserver = ()=>{
    if (!$2d7d9af7a5367cf4$var$intersectionObserver) $2d7d9af7a5367cf4$var$intersectionObserver = new IntersectionObserver($2d7d9af7a5367cf4$var$ioDispatchCallback, {
        root: null,
        rootMargin: '0px'
    });
    return $2d7d9af7a5367cf4$var$intersectionObserver;
};
function $2d7d9af7a5367cf4$var$getClientInfo() {
    var _a;
    const info = new $2d7d9af7a5367cf4$var$ClientInfo({
        sdk: $2d7d9af7a5367cf4$var$ClientInfo_SDK.JS,
        protocol: $2d7d9af7a5367cf4$export$94587fadffb515a1,
        version: $2d7d9af7a5367cf4$export$83d89fbfd8236492
    });
    if ($2d7d9af7a5367cf4$var$isReactNative()) info.os = (_a = $2d7d9af7a5367cf4$var$getReactNativeOs()) !== null && _a !== void 0 ? _a : '';
    return info;
}
let $2d7d9af7a5367cf4$var$emptyVideoStreamTrack;
function $2d7d9af7a5367cf4$export$47f608edbac1bdf7() {
    if (!$2d7d9af7a5367cf4$var$emptyVideoStreamTrack) $2d7d9af7a5367cf4$var$emptyVideoStreamTrack = $2d7d9af7a5367cf4$var$createDummyVideoStreamTrack();
    return $2d7d9af7a5367cf4$var$emptyVideoStreamTrack.clone();
}
function $2d7d9af7a5367cf4$var$createDummyVideoStreamTrack() {
    let width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
    let height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
    let enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let paintContent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const canvas = document.createElement('canvas');
    // the canvas size is set to 16 by default, because electron apps seem to fail with smaller values
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx === null || ctx === void 0 || ctx.fillRect(0, 0, canvas.width, canvas.height);
    if (paintContent && ctx) {
        ctx.beginPath();
        ctx.arc(width / 2, height / 2, 50, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fillStyle = 'grey';
        ctx.fill();
    }
    // @ts-ignore
    const dummyStream = canvas.captureStream();
    const [dummyTrack] = dummyStream.getTracks();
    if (!dummyTrack) throw Error('Could not get empty media stream video track');
    dummyTrack.enabled = enabled;
    return dummyTrack;
}
let $2d7d9af7a5367cf4$var$emptyAudioStreamTrack;
function $2d7d9af7a5367cf4$export$59e276d6841f735c() {
    if (!$2d7d9af7a5367cf4$var$emptyAudioStreamTrack) {
        // implementation adapted from https://blog.mozilla.org/webrtc/warm-up-with-replacetrack/
        const ctx = new AudioContext();
        const oscillator = ctx.createOscillator();
        const gain = ctx.createGain();
        gain.gain.setValueAtTime(0, 0);
        const dst = ctx.createMediaStreamDestination();
        oscillator.connect(gain);
        gain.connect(dst);
        oscillator.start();
        [$2d7d9af7a5367cf4$var$emptyAudioStreamTrack] = dst.stream.getAudioTracks();
        if (!$2d7d9af7a5367cf4$var$emptyAudioStreamTrack) throw Error('Could not get empty media stream audio track');
        $2d7d9af7a5367cf4$var$emptyAudioStreamTrack.enabled = false;
    }
    return $2d7d9af7a5367cf4$var$emptyAudioStreamTrack.clone();
}
class $2d7d9af7a5367cf4$var$Future {
    constructor(futureBase, onFinally){
        this.onFinally = onFinally;
        this.promise = new Promise((resolve, reject)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                this.resolve = resolve;
                this.reject = reject;
                if (futureBase) yield futureBase(resolve, reject);
            })).finally(()=>{
            var _a;
            return (_a = this.onFinally) === null || _a === void 0 ? void 0 : _a.call(this);
        });
    }
}
/**
 * Creates and returns an analyser web audio node that is attached to the provided track.
 * Additionally returns a convenience method `calculateVolume` to perform instant volume readings on that track.
 * Call the returned `cleanup` function to close the audioContext that has been created for the instance of this helper
 */ function $2d7d9af7a5367cf4$export$c3a30182235995eb(track, options) {
    const opts = Object.assign({
        cloneTrack: false,
        fftSize: 2048,
        smoothingTimeConstant: 0.8,
        minDecibels: -100,
        maxDecibels: -80
    }, options);
    const audioContext = $2d7d9af7a5367cf4$var$getNewAudioContext();
    if (!audioContext) throw new Error('Audio Context not supported on this browser');
    const streamTrack = opts.cloneTrack ? track.mediaStreamTrack.clone() : track.mediaStreamTrack;
    const mediaStreamSource = audioContext.createMediaStreamSource(new MediaStream([
        streamTrack
    ]));
    const analyser = audioContext.createAnalyser();
    analyser.minDecibels = opts.minDecibels;
    analyser.maxDecibels = opts.maxDecibels;
    analyser.fftSize = opts.fftSize;
    analyser.smoothingTimeConstant = opts.smoothingTimeConstant;
    mediaStreamSource.connect(analyser);
    const dataArray = new Uint8Array(analyser.frequencyBinCount);
    /**
   * Calculates the current volume of the track in the range from 0 to 1
   */ const calculateVolume = ()=>{
        analyser.getByteFrequencyData(dataArray);
        let sum = 0;
        for (const amplitude of dataArray)sum += Math.pow(amplitude / 255, 2);
        const volume = Math.sqrt(sum / dataArray.length);
        return volume;
    };
    const cleanup = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            yield audioContext.close();
            if (opts.cloneTrack) streamTrack.stop();
        });
    return {
        calculateVolume: calculateVolume,
        analyser: analyser,
        cleanup: cleanup
    };
}
function $2d7d9af7a5367cf4$var$isVideoCodec(maybeCodec) {
    return $2d7d9af7a5367cf4$export$986dcb5e6a94a34c.includes(maybeCodec);
}
function $2d7d9af7a5367cf4$var$unwrapConstraint(constraint) {
    if (typeof constraint === 'string' || typeof constraint === 'number') return constraint;
    if (Array.isArray(constraint)) return constraint[0];
    if (constraint.exact) {
        if (Array.isArray(constraint.exact)) return constraint.exact[0];
        return constraint.exact;
    }
    if (constraint.ideal) {
        if (Array.isArray(constraint.ideal)) return constraint.ideal[0];
        return constraint.ideal;
    }
    throw Error('could not unwrap constraint');
}
function $2d7d9af7a5367cf4$var$toWebsocketUrl(url) {
    if (url.startsWith('http')) return url.replace(/^(http)/, 'ws');
    return url;
}
function $2d7d9af7a5367cf4$var$toHttpUrl(url) {
    if (url.startsWith('ws')) return url.replace(/^(ws)/, 'http');
    return url;
}
function $2d7d9af7a5367cf4$var$extractTranscriptionSegments(transcription, firstReceivedTimesMap) {
    return transcription.segments.map((_ref)=>{
        let { id: id, text: text, language: language, startTime: startTime, endTime: endTime, final: final } = _ref;
        var _a;
        const firstReceivedTime = (_a = firstReceivedTimesMap.get(id)) !== null && _a !== void 0 ? _a : Date.now();
        const lastReceivedTime = Date.now();
        if (final) firstReceivedTimesMap.delete(id);
        else firstReceivedTimesMap.set(id, firstReceivedTime);
        return {
            id: id,
            text: text,
            startTime: Number.parseInt(startTime.toString()),
            endTime: Number.parseInt(endTime.toString()),
            final: final,
            language: language,
            firstReceivedTime: firstReceivedTime,
            lastReceivedTime: lastReceivedTime
        };
    });
}
function $2d7d9af7a5367cf4$var$extractChatMessage(msg) {
    const { id: id, timestamp: timestamp, message: message, editTimestamp: editTimestamp } = msg;
    return {
        id: id,
        timestamp: Number.parseInt(timestamp.toString()),
        editTimestamp: editTimestamp ? Number.parseInt(editTimestamp.toString()) : undefined,
        message: message
    };
}
function $2d7d9af7a5367cf4$var$getDisconnectReasonFromConnectionError(e) {
    switch(e.reason){
        case $2d7d9af7a5367cf4$export$61182a0b21436b65.LeaveRequest:
            return e.context;
        case $2d7d9af7a5367cf4$export$61182a0b21436b65.Cancelled:
            return $2d7d9af7a5367cf4$export$258d16488300d83f.CLIENT_INITIATED;
        case $2d7d9af7a5367cf4$export$61182a0b21436b65.NotAllowed:
            return $2d7d9af7a5367cf4$export$258d16488300d83f.USER_REJECTED;
        case $2d7d9af7a5367cf4$export$61182a0b21436b65.ServerUnreachable:
            return $2d7d9af7a5367cf4$export$258d16488300d83f.JOIN_FAILURE;
        default:
            return $2d7d9af7a5367cf4$export$258d16488300d83f.UNKNOWN_REASON;
    }
}
const $2d7d9af7a5367cf4$var$defaultId = 'default';
class $2d7d9af7a5367cf4$var$DeviceManager {
    static getInstance() {
        if (this.instance === undefined) this.instance = new $2d7d9af7a5367cf4$var$DeviceManager();
        return this.instance;
    }
    getDevices(kind_1) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function(kind) {
            var _this = this;
            let requestPermissions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return function*() {
                var _a;
                if (((_a = $2d7d9af7a5367cf4$var$DeviceManager.userMediaPromiseMap) === null || _a === void 0 ? void 0 : _a.size) > 0) {
                    $2d7d9af7a5367cf4$var$livekitLogger.debug('awaiting getUserMedia promise');
                    try {
                        if (kind) yield $2d7d9af7a5367cf4$var$DeviceManager.userMediaPromiseMap.get(kind);
                        else yield Promise.all($2d7d9af7a5367cf4$var$DeviceManager.userMediaPromiseMap.values());
                    } catch (e) {
                        $2d7d9af7a5367cf4$var$livekitLogger.warn('error waiting for media permissons');
                    }
                }
                let devices = yield navigator.mediaDevices.enumerateDevices();
                if (requestPermissions && // for safari we need to skip this check, as otherwise it will re-acquire user media and fail on iOS https://bugs.webkit.org/show_bug.cgi?id=179363
                !($2d7d9af7a5367cf4$var$isSafari() && _this.hasDeviceInUse(kind))) {
                    const isDummyDeviceOrEmpty = devices.filter((d)=>d.kind === kind).length === 0 || devices.some((device)=>{
                        const noLabel = device.label === '';
                        const isRelevant = kind ? device.kind === kind : true;
                        return noLabel && isRelevant;
                    });
                    if (isDummyDeviceOrEmpty) {
                        const permissionsToAcquire = {
                            video: kind !== 'audioinput' && kind !== 'audiooutput',
                            audio: kind !== 'videoinput'
                        };
                        const stream = yield navigator.mediaDevices.getUserMedia(permissionsToAcquire);
                        devices = yield navigator.mediaDevices.enumerateDevices();
                        stream.getTracks().forEach((track)=>{
                            track.stop();
                        });
                    }
                }
                if (kind) devices = devices.filter((device)=>device.kind === kind);
                return devices;
            }();
        });
    }
    normalizeDeviceId(kind, deviceId, groupId) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (deviceId !== $2d7d9af7a5367cf4$var$defaultId) return deviceId;
            // resolve actual device id if it's 'default': Chrome returns it when no
            // device has been chosen
            const devices = yield this.getDevices(kind);
            const defaultDevice = devices.find((d)=>d.deviceId === $2d7d9af7a5367cf4$var$defaultId);
            if (!defaultDevice) {
                $2d7d9af7a5367cf4$var$livekitLogger.warn('could not reliably determine default device');
                return undefined;
            }
            const device = devices.find((d)=>d.deviceId !== $2d7d9af7a5367cf4$var$defaultId && d.groupId === (groupId !== null && groupId !== void 0 ? groupId : defaultDevice.groupId));
            if (!device) {
                $2d7d9af7a5367cf4$var$livekitLogger.warn('could not reliably determine default device');
                return undefined;
            }
            return device === null || device === void 0 ? void 0 : device.deviceId;
        });
    }
    hasDeviceInUse(kind) {
        return kind ? $2d7d9af7a5367cf4$var$DeviceManager.userMediaPromiseMap.has(kind) : $2d7d9af7a5367cf4$var$DeviceManager.userMediaPromiseMap.size > 0;
    }
}
$2d7d9af7a5367cf4$var$DeviceManager.mediaDeviceKinds = [
    'audioinput',
    'audiooutput',
    'videoinput'
];
$2d7d9af7a5367cf4$var$DeviceManager.userMediaPromiseMap = new Map();
const $2d7d9af7a5367cf4$var$defaultDimensionsTimeout = 1000;
class $2d7d9af7a5367cf4$export$3e041ce3f33f04dd extends $2d7d9af7a5367cf4$export$13921ac0cc260818 {
    /** @internal */ get sender() {
        return this._sender;
    }
    /** @internal */ set sender(sender) {
        this._sender = sender;
    }
    get constraints() {
        return this._constraints;
    }
    /**
   *
   * @param mediaTrack
   * @param kind
   * @param constraints MediaTrackConstraints that are being used when restarting or reacquiring tracks
   * @param userProvidedTrack Signals to the SDK whether or not the mediaTrack should be managed (i.e. released and reacquired) internally by the SDK
   */ constructor(mediaTrack, kind, constraints){
        let userProvidedTrack = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        let loggerOptions = arguments.length > 4 ? arguments[4] : undefined;
        super(mediaTrack, kind, loggerOptions);
        this.manuallyStopped = false;
        this._isUpstreamPaused = false;
        this.handleTrackMuteEvent = ()=>this.debouncedTrackMuteHandler().catch(()=>this.log.debug('track mute bounce got cancelled by an unmute event', this.logContext));
        this.debouncedTrackMuteHandler = $2d7d9af7a5367cf4$var$r(()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                yield this.pauseUpstream();
            }), 5000);
        this.handleTrackUnmuteEvent = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                this.debouncedTrackMuteHandler.cancel('unmute');
                yield this.resumeUpstream();
            });
        this.handleEnded = ()=>{
            if (this.isInBackground) this.reacquireTrack = true;
            this._mediaStreamTrack.removeEventListener('mute', this.handleTrackMuteEvent);
            this._mediaStreamTrack.removeEventListener('unmute', this.handleTrackUnmuteEvent);
            this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.Ended, this);
        };
        this.reacquireTrack = false;
        this.providedByUser = userProvidedTrack;
        this.muteLock = new $2d7d9af7a5367cf4$export$ca12f2943758ef55();
        this.pauseUpstreamLock = new $2d7d9af7a5367cf4$export$ca12f2943758ef55();
        this.processorLock = new $2d7d9af7a5367cf4$export$ca12f2943758ef55();
        this.restartLock = new $2d7d9af7a5367cf4$export$ca12f2943758ef55();
        this.setMediaStreamTrack(mediaTrack, true);
        // added to satisfy TS compiler, constraints are synced with MediaStreamTrack
        this._constraints = mediaTrack.getConstraints();
        if (constraints) this._constraints = constraints;
    }
    get id() {
        return this._mediaStreamTrack.id;
    }
    get dimensions() {
        if (this.kind !== $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video) return undefined;
        const { width: width, height: height } = this._mediaStreamTrack.getSettings();
        if (width && height) return {
            width: width,
            height: height
        };
        return undefined;
    }
    get isUpstreamPaused() {
        return this._isUpstreamPaused;
    }
    get isUserProvided() {
        return this.providedByUser;
    }
    get mediaStreamTrack() {
        var _a, _b;
        return (_b = (_a = this.processor) === null || _a === void 0 ? void 0 : _a.processedTrack) !== null && _b !== void 0 ? _b : this._mediaStreamTrack;
    }
    /**
   * @internal
   * returns mediaStreamTrack settings of the capturing mediastreamtrack source - ignoring processors
   */ getSourceTrackSettings() {
        return this._mediaStreamTrack.getSettings();
    }
    setMediaStreamTrack(newTrack, force) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (newTrack === this._mediaStreamTrack && !force) return;
            if (this._mediaStreamTrack) {
                // detach
                this.attachedElements.forEach((el)=>{
                    $2d7d9af7a5367cf4$export$8ea68c6294970fa5(this._mediaStreamTrack, el);
                });
                this.debouncedTrackMuteHandler.cancel('new-track');
                this._mediaStreamTrack.removeEventListener('ended', this.handleEnded);
                this._mediaStreamTrack.removeEventListener('mute', this.handleTrackMuteEvent);
                this._mediaStreamTrack.removeEventListener('unmute', this.handleTrackUnmuteEvent);
            }
            this.mediaStream = new MediaStream([
                newTrack
            ]);
            if (newTrack) {
                newTrack.addEventListener('ended', this.handleEnded);
                // when underlying track emits mute, it indicates that the device is unable
                // to produce media. In this case we'll need to signal with remote that
                // the track is "muted"
                // note this is different from LocalTrack.mute because we do not want to
                // touch MediaStreamTrack.enabled
                newTrack.addEventListener('mute', this.handleTrackMuteEvent);
                newTrack.addEventListener('unmute', this.handleTrackUnmuteEvent);
                this._constraints = newTrack.getConstraints();
            }
            let processedTrack;
            if (this.processor && newTrack) {
                const unlock = yield this.processorLock.lock();
                try {
                    this.log.debug('restarting processor', this.logContext);
                    if (this.kind === 'unknown') throw TypeError('cannot set processor on track of unknown kind');
                    if (this.processorElement) {
                        $2d7d9af7a5367cf4$export$b8f95ef2322890b8(newTrack, this.processorElement);
                        // ensure the processorElement itself stays muted
                        this.processorElement.muted = true;
                    }
                    yield this.processor.restart({
                        track: newTrack,
                        kind: this.kind,
                        element: this.processorElement
                    });
                    processedTrack = this.processor.processedTrack;
                } finally{
                    unlock();
                }
            }
            if (this.sender) yield this.sender.replaceTrack(processedTrack !== null && processedTrack !== void 0 ? processedTrack : newTrack);
            // if `newTrack` is different from the existing track, stop the
            // older track just before replacing it
            if (!this.providedByUser && this._mediaStreamTrack !== newTrack) this._mediaStreamTrack.stop();
            this._mediaStreamTrack = newTrack;
            if (newTrack) {
                // sync muted state with the enabled state of the newly provided track
                this._mediaStreamTrack.enabled = !this.isMuted;
                // when a valid track is replace, we'd want to start producing
                yield this.resumeUpstream();
                this.attachedElements.forEach((el)=>{
                    $2d7d9af7a5367cf4$export$b8f95ef2322890b8(processedTrack !== null && processedTrack !== void 0 ? processedTrack : newTrack, el);
                });
            }
        });
    }
    waitForDimensions() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function() {
            var _this = this;
            let timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $2d7d9af7a5367cf4$var$defaultDimensionsTimeout;
            return function*() {
                var _a;
                if (_this.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Audio) throw new Error('cannot get dimensions for audio tracks');
                if (((_a = $2d7d9af7a5367cf4$export$89e15fc796a4a429()) === null || _a === void 0 ? void 0 : _a.os) === 'iOS') // browsers report wrong initial resolution on iOS.
                // when slightly delaying the call to .getSettings(), the correct resolution is being reported
                yield $2d7d9af7a5367cf4$var$sleep(10);
                const started = Date.now();
                while(Date.now() - started < timeout){
                    const dims = _this.dimensions;
                    if (dims) return dims;
                    yield $2d7d9af7a5367cf4$var$sleep(50);
                }
                throw new $2d7d9af7a5367cf4$export$4fbb9423b5747257('unable to get track dimensions after timeout');
            }();
        });
    }
    /**
   * @returns DeviceID of the device that is currently being used for this track
   */ getDeviceId() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function() {
            var _this2 = this;
            let normalize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            return function*() {
                // screen share doesn't have a usable device id
                if (_this2.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShare) return;
                const { deviceId: deviceId, groupId: groupId } = _this2._mediaStreamTrack.getSettings();
                const kind = _this2.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Audio ? 'audioinput' : 'videoinput';
                return normalize ? $2d7d9af7a5367cf4$var$DeviceManager.getInstance().normalizeDeviceId(kind, deviceId, groupId) : deviceId;
            }();
        });
    }
    mute() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            this.setTrackMuted(true);
            return this;
        });
    }
    unmute() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            this.setTrackMuted(false);
            return this;
        });
    }
    replaceTrack(track, userProvidedOrOptions) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.sender) throw new $2d7d9af7a5367cf4$export$4fbb9423b5747257('unable to replace an unpublished track');
            let userProvidedTrack;
            let stopProcessor;
            if (typeof userProvidedOrOptions === 'boolean') userProvidedTrack = userProvidedOrOptions;
            else if (userProvidedOrOptions !== undefined) {
                userProvidedTrack = userProvidedOrOptions.userProvidedTrack;
                stopProcessor = userProvidedOrOptions.stopProcessor;
            }
            this.providedByUser = userProvidedTrack !== null && userProvidedTrack !== void 0 ? userProvidedTrack : true;
            this.log.debug('replace MediaStreamTrack', this.logContext);
            yield this.setMediaStreamTrack(track);
            // this must be synced *after* setting mediaStreamTrack above, since it relies
            // on the previous state in order to cleanup
            if (stopProcessor && this.processor) yield this.stopProcessor();
            return this;
        });
    }
    restart(constraints) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            this.manuallyStopped = false;
            const unlock = yield this.restartLock.lock();
            try {
                if (!constraints) constraints = this._constraints;
                this.log.debug('restarting track with constraints', Object.assign(Object.assign({}, this.logContext), {
                    constraints: constraints
                }));
                const streamConstraints = {
                    audio: false,
                    video: false
                };
                if (this.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video) streamConstraints.video = constraints;
                else streamConstraints.audio = constraints;
                // these steps are duplicated from setMediaStreamTrack because we must stop
                // the previous tracks before new tracks can be acquired
                this.attachedElements.forEach((el)=>{
                    $2d7d9af7a5367cf4$export$8ea68c6294970fa5(this.mediaStreamTrack, el);
                });
                this._mediaStreamTrack.removeEventListener('ended', this.handleEnded);
                // on Safari, the old audio track must be stopped before attempting to acquire
                // the new track, otherwise the new track will stop with
                // 'A MediaStreamTrack ended due to a capture failure`
                this._mediaStreamTrack.stop();
                // create new track and attach
                const mediaStream = yield navigator.mediaDevices.getUserMedia(streamConstraints);
                const newTrack = mediaStream.getTracks()[0];
                newTrack.addEventListener('ended', this.handleEnded);
                this.log.debug('re-acquired MediaStreamTrack', this.logContext);
                yield this.setMediaStreamTrack(newTrack);
                this._constraints = constraints;
                this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.Restarted, this);
                if (this.manuallyStopped) {
                    this.log.warn('track was stopped during a restart, stopping restarted track', this.logContext);
                    this.stop();
                }
                return this;
            } finally{
                unlock();
            }
        });
    }
    setTrackMuted(muted) {
        this.log.debug("setting ".concat(this.kind, " track ").concat(muted ? 'muted' : 'unmuted'), this.logContext);
        if (this.isMuted === muted && this._mediaStreamTrack.enabled !== muted) return;
        this.isMuted = muted;
        this._mediaStreamTrack.enabled = !muted;
        this.emit(muted ? $2d7d9af7a5367cf4$export$2c8510d737cc09da.Muted : $2d7d9af7a5367cf4$export$2c8510d737cc09da.Unmuted, this);
    }
    get needsReAcquisition() {
        return this._mediaStreamTrack.readyState !== 'live' || this._mediaStreamTrack.muted || !this._mediaStreamTrack.enabled || this.reacquireTrack;
    }
    handleAppVisibilityChanged() {
        const _super = Object.create(null, {
            handleAppVisibilityChanged: {
                get: ()=>super.handleAppVisibilityChanged
            }
        });
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            yield _super.handleAppVisibilityChanged.call(this);
            if (!$2d7d9af7a5367cf4$var$isMobile()) return;
            this.log.debug("visibility changed, is in Background: ".concat(this.isInBackground), this.logContext);
            if (!this.isInBackground && this.needsReAcquisition && !this.isUserProvided && !this.isMuted) {
                this.log.debug("track needs to be reacquired, restarting ".concat(this.source), this.logContext);
                yield this.restart();
                this.reacquireTrack = false;
            }
        });
    }
    stop() {
        var _a;
        this.manuallyStopped = true;
        super.stop();
        this._mediaStreamTrack.removeEventListener('ended', this.handleEnded);
        this._mediaStreamTrack.removeEventListener('mute', this.handleTrackMuteEvent);
        this._mediaStreamTrack.removeEventListener('unmute', this.handleTrackUnmuteEvent);
        (_a = this.processor) === null || _a === void 0 || _a.destroy();
        this.processor = undefined;
    }
    /**
   * pauses publishing to the server without disabling the local MediaStreamTrack
   * this is used to display a user's own video locally while pausing publishing to
   * the server.
   * this API is unsupported on Safari < 12 due to a bug
   **/ pauseUpstream() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.pauseUpstreamLock.lock();
            try {
                if (this._isUpstreamPaused === true) return;
                if (!this.sender) {
                    this.log.warn('unable to pause upstream for an unpublished track', this.logContext);
                    return;
                }
                this._isUpstreamPaused = true;
                this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.UpstreamPaused, this);
                const browser = $2d7d9af7a5367cf4$export$89e15fc796a4a429();
                if ((browser === null || browser === void 0 ? void 0 : browser.name) === 'Safari' && $2d7d9af7a5367cf4$export$66e1c0999abad646(browser.version, '12.0') < 0) // https://bugs.webkit.org/show_bug.cgi?id=184911
                throw new $2d7d9af7a5367cf4$export$38c5ac268e2fa84('pauseUpstream is not supported on Safari < 12.');
                yield this.sender.replaceTrack(null);
            } finally{
                unlock();
            }
        });
    }
    resumeUpstream() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.pauseUpstreamLock.lock();
            try {
                if (this._isUpstreamPaused === false) return;
                if (!this.sender) {
                    this.log.warn('unable to resume upstream for an unpublished track', this.logContext);
                    return;
                }
                this._isUpstreamPaused = false;
                this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.UpstreamResumed, this);
                // this operation is noop if mediastreamtrack is already being sent
                yield this.sender.replaceTrack(this.mediaStreamTrack);
            } finally{
                unlock();
            }
        });
    }
    /**
   * Gets the RTCStatsReport for the LocalTrack's underlying RTCRtpSender
   * See https://developer.mozilla.org/en-US/docs/Web/API/RTCStatsReport
   *
   * @returns Promise<RTCStatsReport> | undefined
   */ getRTCStatsReport() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!((_a = this.sender) === null || _a === void 0 ? void 0 : _a.getStats)) return;
            const statsReport = yield this.sender.getStats();
            return statsReport;
        });
    }
    /**
   * Sets a processor on this track.
   * See https://github.com/livekit/track-processors-js for example usage
   *
   * @experimental
   *
   * @param processor
   * @param showProcessedStreamLocally
   * @returns
   */ setProcessor(processor_1) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function(processor) {
            var _this3 = this;
            let showProcessedStreamLocally = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return function*() {
                var _a;
                const unlock = yield _this3.processorLock.lock();
                try {
                    _this3.log.debug('setting up processor', _this3.logContext);
                    const processorElement = document.createElement(_this3.kind);
                    const processorOptions = {
                        kind: _this3.kind,
                        track: _this3._mediaStreamTrack,
                        element: processorElement,
                        audioContext: _this3.audioContext
                    };
                    yield processor.init(processorOptions);
                    _this3.log.debug('processor initialized', _this3.logContext);
                    if (_this3.processor) yield _this3.stopProcessor();
                    if (_this3.kind === 'unknown') throw TypeError('cannot set processor on track of unknown kind');
                    $2d7d9af7a5367cf4$export$b8f95ef2322890b8(_this3._mediaStreamTrack, processorElement);
                    processorElement.muted = true;
                    processorElement.play().catch((error)=>_this3.log.error('failed to play processor element', Object.assign(Object.assign({}, _this3.logContext), {
                            error: error
                        })));
                    _this3.processor = processor;
                    _this3.processorElement = processorElement;
                    if (_this3.processor.processedTrack) {
                        for (const el of _this3.attachedElements)if (el !== _this3.processorElement && showProcessedStreamLocally) {
                            $2d7d9af7a5367cf4$export$8ea68c6294970fa5(_this3._mediaStreamTrack, el);
                            $2d7d9af7a5367cf4$export$b8f95ef2322890b8(_this3.processor.processedTrack, el);
                        }
                        yield (_a = _this3.sender) === null || _a === void 0 ? void 0 : _a.replaceTrack(_this3.processor.processedTrack);
                    }
                    _this3.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.TrackProcessorUpdate, _this3.processor);
                } finally{
                    unlock();
                }
            }();
        });
    }
    getProcessor() {
        return this.processor;
    }
    /**
   * Stops the track processor
   * See https://github.com/livekit/track-processors-js for example usage
   *
   * @experimental
   * @returns
   */ stopProcessor() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function() {
            var _this4 = this;
            let keepElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            return function*() {
                var _a, _b;
                if (!_this4.processor) return;
                _this4.log.debug('stopping processor', _this4.logContext);
                (_a = _this4.processor.processedTrack) === null || _a === void 0 || _a.stop();
                yield _this4.processor.destroy();
                _this4.processor = undefined;
                if (!keepElement) {
                    (_b = _this4.processorElement) === null || _b === void 0 || _b.remove();
                    _this4.processorElement = undefined;
                }
                // apply original track constraints in case the processor changed them
                yield _this4._mediaStreamTrack.applyConstraints(_this4._constraints);
                // force re-setting of the mediaStreamTrack on the sender
                yield _this4.setMediaStreamTrack(_this4._mediaStreamTrack, true);
                _this4.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.TrackProcessorUpdate);
            }();
        });
    }
}
/**
 * @experimental
 */ class $2d7d9af7a5367cf4$var$E2EEManager extends $2d7d9af7a5367cf4$var$eventsExports.EventEmitter {
    constructor(options){
        super();
        this.onWorkerMessage = (ev)=>{
            var _a, _b;
            const { kind: kind, data: data } = ev.data;
            switch(kind){
                case 'error':
                    $2d7d9af7a5367cf4$var$livekitLogger.error(data.error.message);
                    this.emit($2d7d9af7a5367cf4$export$36ec54aef832f50f.EncryptionError, data.error);
                    break;
                case 'initAck':
                    if (data.enabled) this.keyProvider.getKeys().forEach((keyInfo)=>{
                        this.postKey(keyInfo);
                    });
                    break;
                case 'enable':
                    if (data.enabled) this.keyProvider.getKeys().forEach((keyInfo)=>{
                        this.postKey(keyInfo);
                    });
                    if (this.encryptionEnabled !== data.enabled && data.participantIdentity === ((_a = this.room) === null || _a === void 0 ? void 0 : _a.localParticipant.identity)) {
                        this.emit($2d7d9af7a5367cf4$export$36ec54aef832f50f.ParticipantEncryptionStatusChanged, data.enabled, this.room.localParticipant);
                        this.encryptionEnabled = data.enabled;
                    } else if (data.participantIdentity) {
                        const participant = (_b = this.room) === null || _b === void 0 ? void 0 : _b.getParticipantByIdentity(data.participantIdentity);
                        if (!participant) throw TypeError("couldn't set encryption status, participant not found".concat(data.participantIdentity));
                        this.emit($2d7d9af7a5367cf4$export$36ec54aef832f50f.ParticipantEncryptionStatusChanged, data.enabled, participant);
                    }
                    break;
                case 'ratchetKey':
                    this.keyProvider.emit($2d7d9af7a5367cf4$export$432ceae3bd7b5ad3.KeyRatcheted, data.material, data.keyIndex);
                    break;
            }
        };
        this.onWorkerError = (ev)=>{
            $2d7d9af7a5367cf4$var$livekitLogger.error('e2ee worker encountered an error:', {
                error: ev.error
            });
            this.emit($2d7d9af7a5367cf4$export$36ec54aef832f50f.EncryptionError, ev.error);
        };
        this.keyProvider = options.keyProvider;
        this.worker = options.worker;
        this.encryptionEnabled = false;
    }
    /**
   * @internal
   */ setup(room) {
        if (!$2d7d9af7a5367cf4$export$2c53d20185b28316()) throw new $2d7d9af7a5367cf4$export$38c5ac268e2fa84('tried to setup end-to-end encryption on an unsupported browser');
        $2d7d9af7a5367cf4$var$livekitLogger.info('setting up e2ee');
        if (room !== this.room) {
            this.room = room;
            this.setupEventListeners(room, this.keyProvider);
            // this.worker = new Worker('');
            const msg = {
                kind: 'init',
                data: {
                    keyProviderOptions: this.keyProvider.getOptions(),
                    loglevel: $2d7d9af7a5367cf4$var$workerLogger.getLevel()
                }
            };
            if (this.worker) {
                $2d7d9af7a5367cf4$var$livekitLogger.info("initializing worker", {
                    worker: this.worker
                });
                this.worker.onmessage = this.onWorkerMessage;
                this.worker.onerror = this.onWorkerError;
                this.worker.postMessage(msg);
            }
        }
    }
    /**
   * @internal
   */ setParticipantCryptorEnabled(enabled, participantIdentity) {
        $2d7d9af7a5367cf4$var$livekitLogger.debug("set e2ee to ".concat(enabled, " for participant ").concat(participantIdentity));
        this.postEnable(enabled, participantIdentity);
    }
    /**
   * @internal
   */ setSifTrailer(trailer) {
        if (!trailer || trailer.length === 0) $2d7d9af7a5367cf4$var$livekitLogger.warn("ignoring server sent trailer as it's empty");
        else this.postSifTrailer(trailer);
    }
    setupEngine(engine) {
        engine.on($2d7d9af7a5367cf4$export$c09e63b8572f869.RTPVideoMapUpdate, (rtpMap)=>{
            this.postRTPMap(rtpMap);
        });
    }
    setupEventListeners(room, keyProvider) {
        room.on($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackPublished, (pub, participant)=>this.setParticipantCryptorEnabled(pub.trackInfo.encryption !== $2d7d9af7a5367cf4$var$Encryption_Type.NONE, participant.identity));
        room.on($2d7d9af7a5367cf4$export$3159c672e3b2293a.ConnectionStateChanged, (state)=>{
            if (state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Connected) room.remoteParticipants.forEach((participant)=>{
                participant.trackPublications.forEach((pub)=>{
                    this.setParticipantCryptorEnabled(pub.trackInfo.encryption !== $2d7d9af7a5367cf4$var$Encryption_Type.NONE, participant.identity);
                });
            });
        }).on($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackUnsubscribed, (track, _, participant)=>{
            var _a;
            const msg = {
                kind: 'removeTransform',
                data: {
                    participantIdentity: participant.identity,
                    trackId: track.mediaStreamID
                }
            };
            (_a = this.worker) === null || _a === void 0 || _a.postMessage(msg);
        }).on($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackSubscribed, (track, pub, participant)=>{
            this.setupE2EEReceiver(track, participant.identity, pub.trackInfo);
        }).on($2d7d9af7a5367cf4$export$3159c672e3b2293a.SignalConnected, ()=>{
            if (!this.room) throw new TypeError("expected room to be present on signal connect");
            keyProvider.getKeys().forEach((keyInfo)=>{
                this.postKey(keyInfo);
            });
            this.setParticipantCryptorEnabled(this.room.localParticipant.isE2EEEnabled, this.room.localParticipant.identity);
        });
        room.localParticipant.on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.LocalTrackPublished, (publication)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                this.setupE2EESender(publication.track, publication.track.sender);
            }));
        keyProvider.on($2d7d9af7a5367cf4$export$432ceae3bd7b5ad3.SetKey, (keyInfo)=>this.postKey(keyInfo)).on($2d7d9af7a5367cf4$export$432ceae3bd7b5ad3.RatchetRequest, (participantId, keyIndex)=>this.postRatchetRequest(participantId, keyIndex));
    }
    postRatchetRequest(participantIdentity, keyIndex) {
        if (!this.worker) throw Error('could not ratchet key, worker is missing');
        const msg = {
            kind: 'ratchetRequest',
            data: {
                participantIdentity: participantIdentity,
                keyIndex: keyIndex
            }
        };
        this.worker.postMessage(msg);
    }
    postKey(_ref) {
        let { key: key, participantIdentity: participantIdentity, keyIndex: keyIndex } = _ref;
        var _a;
        if (!this.worker) throw Error('could not set key, worker is missing');
        const msg = {
            kind: 'setKey',
            data: {
                participantIdentity: participantIdentity,
                isPublisher: participantIdentity === ((_a = this.room) === null || _a === void 0 ? void 0 : _a.localParticipant.identity),
                key: key,
                keyIndex: keyIndex
            }
        };
        this.worker.postMessage(msg);
    }
    postEnable(enabled, participantIdentity) {
        if (this.worker) {
            const enableMsg = {
                kind: 'enable',
                data: {
                    enabled: enabled,
                    participantIdentity: participantIdentity
                }
            };
            this.worker.postMessage(enableMsg);
        } else throw new ReferenceError('failed to enable e2ee, worker is not ready');
    }
    postRTPMap(map) {
        var _a;
        if (!this.worker) throw TypeError('could not post rtp map, worker is missing');
        if (!((_a = this.room) === null || _a === void 0 ? void 0 : _a.localParticipant.identity)) throw TypeError('could not post rtp map, local participant identity is missing');
        const msg = {
            kind: 'setRTPMap',
            data: {
                map: map,
                participantIdentity: this.room.localParticipant.identity
            }
        };
        this.worker.postMessage(msg);
    }
    postSifTrailer(trailer) {
        if (!this.worker) throw Error('could not post SIF trailer, worker is missing');
        const msg = {
            kind: 'setSifTrailer',
            data: {
                trailer: trailer
            }
        };
        this.worker.postMessage(msg);
    }
    setupE2EEReceiver(track, remoteId, trackInfo) {
        if (!track.receiver) return;
        if (!(trackInfo === null || trackInfo === void 0 ? void 0 : trackInfo.mimeType) || trackInfo.mimeType === '') throw new TypeError('MimeType missing from trackInfo, cannot set up E2EE cryptor');
        this.handleReceiver(track.receiver, track.mediaStreamID, remoteId, track.kind === 'video' ? $2d7d9af7a5367cf4$var$mimeTypeToVideoCodecString(trackInfo.mimeType) : undefined);
    }
    setupE2EESender(track, sender) {
        if (!(track instanceof $2d7d9af7a5367cf4$export$3e041ce3f33f04dd) || !sender) {
            if (!sender) $2d7d9af7a5367cf4$var$livekitLogger.warn('early return because sender is not ready');
            return;
        }
        this.handleSender(sender, track.mediaStreamID, undefined);
    }
    /**
   * Handles the given {@code RTCRtpReceiver} by creating a {@code TransformStream} which will inject
   * a frame decoder.
   *
   */ handleReceiver(receiver, trackId, participantIdentity, codec) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.worker) return;
            if ($2d7d9af7a5367cf4$export$6bf50ac7ca24af81()) {
                const options = {
                    kind: 'decode',
                    participantIdentity: participantIdentity,
                    trackId: trackId,
                    codec: codec
                };
                // @ts-ignore
                receiver.transform = new RTCRtpScriptTransform(this.worker, options);
            } else {
                if ($2d7d9af7a5367cf4$var$E2EE_FLAG in receiver && codec) {
                    // only update codec
                    const msg = {
                        kind: 'updateCodec',
                        data: {
                            trackId: trackId,
                            codec: codec,
                            participantIdentity: participantIdentity
                        }
                    };
                    this.worker.postMessage(msg);
                    return;
                }
                // @ts-ignore
                let writable = receiver.writableStream;
                // @ts-ignore
                let readable = receiver.readableStream;
                if (!writable || !readable) {
                    // @ts-ignore
                    const receiverStreams = receiver.createEncodedStreams();
                    // @ts-ignore
                    receiver.writableStream = receiverStreams.writable;
                    writable = receiverStreams.writable;
                    // @ts-ignore
                    receiver.readableStream = receiverStreams.readable;
                    readable = receiverStreams.readable;
                }
                const msg = {
                    kind: 'decode',
                    data: {
                        readableStream: readable,
                        writableStream: writable,
                        trackId: trackId,
                        codec: codec,
                        participantIdentity: participantIdentity
                    }
                };
                this.worker.postMessage(msg, [
                    readable,
                    writable
                ]);
            }
            // @ts-ignore
            receiver[$2d7d9af7a5367cf4$var$E2EE_FLAG] = true;
        });
    }
    /**
   * Handles the given {@code RTCRtpSender} by creating a {@code TransformStream} which will inject
   * a frame encoder.
   *
   */ handleSender(sender, trackId, codec) {
        var _a;
        if ($2d7d9af7a5367cf4$var$E2EE_FLAG in sender || !this.worker) return;
        if (!((_a = this.room) === null || _a === void 0 ? void 0 : _a.localParticipant.identity) || this.room.localParticipant.identity === '') throw TypeError('local identity needs to be known in order to set up encrypted sender');
        if ($2d7d9af7a5367cf4$export$6bf50ac7ca24af81()) {
            $2d7d9af7a5367cf4$var$livekitLogger.info('initialize script transform');
            const options = {
                kind: 'encode',
                participantIdentity: this.room.localParticipant.identity,
                trackId: trackId,
                codec: codec
            };
            // @ts-ignore
            sender.transform = new RTCRtpScriptTransform(this.worker, options);
        } else {
            $2d7d9af7a5367cf4$var$livekitLogger.info('initialize encoded streams');
            // @ts-ignore
            const senderStreams = sender.createEncodedStreams();
            const msg = {
                kind: 'encode',
                data: {
                    readableStream: senderStreams.readable,
                    writableStream: senderStreams.writable,
                    codec: codec,
                    trackId: trackId,
                    participantIdentity: this.room.localParticipant.identity
                }
            };
            this.worker.postMessage(msg, [
                senderStreams.readable,
                senderStreams.writable
            ]);
        }
        // @ts-ignore
        sender[$2d7d9af7a5367cf4$var$E2EE_FLAG] = true;
    }
}
var $2d7d9af7a5367cf4$var$QueueTaskStatus;
(function(QueueTaskStatus) {
    QueueTaskStatus[QueueTaskStatus["WAITING"] = 0] = "WAITING";
    QueueTaskStatus[QueueTaskStatus["RUNNING"] = 1] = "RUNNING";
    QueueTaskStatus[QueueTaskStatus["COMPLETED"] = 2] = "COMPLETED";
})($2d7d9af7a5367cf4$var$QueueTaskStatus || ($2d7d9af7a5367cf4$var$QueueTaskStatus = {}));
class $2d7d9af7a5367cf4$var$AsyncQueue {
    constructor(){
        this.pendingTasks = new Map();
        this.taskMutex = new $2d7d9af7a5367cf4$export$ca12f2943758ef55();
        this.nextTaskIndex = 0;
    }
    run(task) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const taskInfo = {
                id: this.nextTaskIndex++,
                enqueuedAt: Date.now(),
                status: $2d7d9af7a5367cf4$var$QueueTaskStatus.WAITING
            };
            this.pendingTasks.set(taskInfo.id, taskInfo);
            const unlock = yield this.taskMutex.lock();
            try {
                taskInfo.executedAt = Date.now();
                taskInfo.status = $2d7d9af7a5367cf4$var$QueueTaskStatus.RUNNING;
                return yield task();
            } finally{
                taskInfo.status = $2d7d9af7a5367cf4$var$QueueTaskStatus.COMPLETED;
                this.pendingTasks.delete(taskInfo.id);
                unlock();
            }
        });
    }
    flush() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            return this.run(()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {}));
        });
    }
    snapshot() {
        return Array.from(this.pendingTasks.values());
    }
}
const $2d7d9af7a5367cf4$var$passThroughQueueSignals = [
    'syncState',
    'trickle',
    'offer',
    'answer',
    'simulate',
    'leave'
];
function $2d7d9af7a5367cf4$var$canPassThroughQueue(req) {
    const canPass = $2d7d9af7a5367cf4$var$passThroughQueueSignals.indexOf(req.case) >= 0;
    $2d7d9af7a5367cf4$var$livekitLogger.trace('request allowed to bypass queue:', {
        canPass: canPass,
        req: req
    });
    return canPass;
}
var $2d7d9af7a5367cf4$var$SignalConnectionState;
(function(SignalConnectionState) {
    SignalConnectionState[SignalConnectionState["CONNECTING"] = 0] = "CONNECTING";
    SignalConnectionState[SignalConnectionState["CONNECTED"] = 1] = "CONNECTED";
    SignalConnectionState[SignalConnectionState["RECONNECTING"] = 2] = "RECONNECTING";
    SignalConnectionState[SignalConnectionState["DISCONNECTING"] = 3] = "DISCONNECTING";
    SignalConnectionState[SignalConnectionState["DISCONNECTED"] = 4] = "DISCONNECTED";
})($2d7d9af7a5367cf4$var$SignalConnectionState || ($2d7d9af7a5367cf4$var$SignalConnectionState = {}));
/** @internal */ class $2d7d9af7a5367cf4$var$SignalClient {
    get currentState() {
        return this.state;
    }
    get isDisconnected() {
        return this.state === $2d7d9af7a5367cf4$var$SignalConnectionState.DISCONNECTING || this.state === $2d7d9af7a5367cf4$var$SignalConnectionState.DISCONNECTED;
    }
    get isEstablishingConnection() {
        return this.state === $2d7d9af7a5367cf4$var$SignalConnectionState.CONNECTING || this.state === $2d7d9af7a5367cf4$var$SignalConnectionState.RECONNECTING;
    }
    getNextRequestId() {
        this._requestId += 1;
        return this._requestId;
    }
    constructor(){
        let useJSON = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        let loggerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _a;
        /** signal rtt in milliseconds */ this.rtt = 0;
        this.state = $2d7d9af7a5367cf4$var$SignalConnectionState.DISCONNECTED;
        this.log = $2d7d9af7a5367cf4$var$livekitLogger;
        this._requestId = 0;
        /** @internal */ this.resetCallbacks = ()=>{
            this.onAnswer = undefined;
            this.onLeave = undefined;
            this.onLocalTrackPublished = undefined;
            this.onLocalTrackUnpublished = undefined;
            this.onNegotiateRequested = undefined;
            this.onOffer = undefined;
            this.onRemoteMuteChanged = undefined;
            this.onSubscribedQualityUpdate = undefined;
            this.onTokenRefresh = undefined;
            this.onTrickle = undefined;
            this.onClose = undefined;
        };
        this.log = $2d7d9af7a5367cf4$export$2b1d391cd05230fd((_a = loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $2d7d9af7a5367cf4$export$69ba24dd79f4da21.Signal);
        this.loggerContextCb = loggerOptions.loggerContextCb;
        this.useJSON = useJSON;
        this.requestQueue = new $2d7d9af7a5367cf4$var$AsyncQueue();
        this.queuedRequests = [];
        this.closingLock = new $2d7d9af7a5367cf4$export$ca12f2943758ef55();
        this.connectionLock = new $2d7d9af7a5367cf4$export$ca12f2943758ef55();
        this.state = $2d7d9af7a5367cf4$var$SignalConnectionState.DISCONNECTED;
    }
    get logContext() {
        var _a, _b;
        return (_b = (_a = this.loggerContextCb) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : {};
    }
    join(url, token, opts, abortSignal) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            // during a full reconnect, we'd want to start the sequence even if currently
            // connected
            this.state = $2d7d9af7a5367cf4$var$SignalConnectionState.CONNECTING;
            this.options = opts;
            const res = yield this.connect(url, token, opts, abortSignal);
            return res;
        });
    }
    reconnect(url, token, sid, reason) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.options) {
                this.log.warn('attempted to reconnect without signal options being set, ignoring', this.logContext);
                return;
            }
            this.state = $2d7d9af7a5367cf4$var$SignalConnectionState.RECONNECTING;
            // clear ping interval and restart it once reconnected
            this.clearPingInterval();
            const res = yield this.connect(url, token, Object.assign(Object.assign({}, this.options), {
                reconnect: true,
                sid: sid,
                reconnectReason: reason
            }));
            return res;
        });
    }
    connect(url, token, opts, abortSignal) {
        this.connectOptions = opts;
        url = $2d7d9af7a5367cf4$var$toWebsocketUrl(url);
        // strip trailing slash
        url = url.replace(/\/$/, '');
        url += '/rtc';
        const clientInfo = $2d7d9af7a5367cf4$var$getClientInfo();
        const params = $2d7d9af7a5367cf4$var$createConnectionParams(token, clientInfo, opts);
        return new Promise((resolve, reject)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                const unlock = yield this.connectionLock.lock();
                try {
                    const abortHandler = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                            this.close();
                            clearTimeout(wsTimeout);
                            reject(new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb('room connection has been cancelled (signal)', $2d7d9af7a5367cf4$export$61182a0b21436b65.Cancelled));
                        });
                    const wsTimeout = setTimeout(()=>{
                        this.close();
                        reject(new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb('room connection has timed out (signal)', $2d7d9af7a5367cf4$export$61182a0b21436b65.ServerUnreachable));
                    }, opts.websocketTimeout);
                    if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) abortHandler();
                    abortSignal === null || abortSignal === void 0 || abortSignal.addEventListener('abort', abortHandler);
                    this.log.debug("connecting to ".concat(url + params), this.logContext);
                    if (this.ws) yield this.close(false);
                    this.ws = new WebSocket(url + params);
                    this.ws.binaryType = 'arraybuffer';
                    this.ws.onopen = ()=>{
                        clearTimeout(wsTimeout);
                    };
                    this.ws.onerror = (ev)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                            if (this.state !== $2d7d9af7a5367cf4$var$SignalConnectionState.CONNECTED) {
                                this.state = $2d7d9af7a5367cf4$var$SignalConnectionState.DISCONNECTED;
                                clearTimeout(wsTimeout);
                                try {
                                    const resp = yield fetch("http".concat(url.substring(2), "/validate").concat(params));
                                    if (resp.status.toFixed(0).startsWith('4')) {
                                        const msg = yield resp.text();
                                        reject(new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb(msg, $2d7d9af7a5367cf4$export$61182a0b21436b65.NotAllowed, resp.status));
                                    } else reject(new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb('Internal error', $2d7d9af7a5367cf4$export$61182a0b21436b65.InternalError, resp.status));
                                } catch (e) {
                                    reject(new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb('server was not reachable', $2d7d9af7a5367cf4$export$61182a0b21436b65.ServerUnreachable));
                                }
                                return;
                            }
                            // other errors, handle
                            this.handleWSError(ev);
                        });
                    this.ws.onmessage = (ev)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                            var _a, _b, _c;
                            // not considered connected until JoinResponse is received
                            let resp;
                            if (typeof ev.data === 'string') {
                                const json = JSON.parse(ev.data);
                                resp = $2d7d9af7a5367cf4$var$SignalResponse.fromJson(json, {
                                    ignoreUnknownFields: true
                                });
                            } else if (ev.data instanceof ArrayBuffer) resp = $2d7d9af7a5367cf4$var$SignalResponse.fromBinary(new Uint8Array(ev.data));
                            else {
                                this.log.error("could not decode websocket message: ".concat(typeof ev.data), this.logContext);
                                return;
                            }
                            if (this.state !== $2d7d9af7a5367cf4$var$SignalConnectionState.CONNECTED) {
                                let shouldProcessMessage = false;
                                // handle join message only
                                if (((_a = resp.message) === null || _a === void 0 ? void 0 : _a.case) === 'join') {
                                    this.state = $2d7d9af7a5367cf4$var$SignalConnectionState.CONNECTED;
                                    abortSignal === null || abortSignal === void 0 || abortSignal.removeEventListener('abort', abortHandler);
                                    this.pingTimeoutDuration = resp.message.value.pingTimeout;
                                    this.pingIntervalDuration = resp.message.value.pingInterval;
                                    if (this.pingTimeoutDuration && this.pingTimeoutDuration > 0) {
                                        this.log.debug('ping config', Object.assign(Object.assign({}, this.logContext), {
                                            timeout: this.pingTimeoutDuration,
                                            interval: this.pingIntervalDuration
                                        }));
                                        this.startPingInterval();
                                    }
                                    resolve(resp.message.value);
                                } else if (this.state === $2d7d9af7a5367cf4$var$SignalConnectionState.RECONNECTING && resp.message.case !== 'leave') {
                                    // in reconnecting, any message received means signal reconnected
                                    this.state = $2d7d9af7a5367cf4$var$SignalConnectionState.CONNECTED;
                                    abortSignal === null || abortSignal === void 0 || abortSignal.removeEventListener('abort', abortHandler);
                                    this.startPingInterval();
                                    if (((_b = resp.message) === null || _b === void 0 ? void 0 : _b.case) === 'reconnect') resolve(resp.message.value);
                                    else {
                                        this.log.debug('declaring signal reconnected without reconnect response received', this.logContext);
                                        resolve(undefined);
                                        shouldProcessMessage = true;
                                    }
                                } else if (this.isEstablishingConnection && resp.message.case === 'leave') reject(new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb('Received leave request while trying to (re)connect', $2d7d9af7a5367cf4$export$61182a0b21436b65.LeaveRequest, undefined, resp.message.value.reason));
                                else if (!opts.reconnect) // non-reconnect case, should receive join response first
                                reject(new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb("did not receive join response, got ".concat((_c = resp.message) === null || _c === void 0 ? void 0 : _c.case, " instead"), $2d7d9af7a5367cf4$export$61182a0b21436b65.InternalError));
                                if (!shouldProcessMessage) return;
                            }
                            if (this.signalLatency) yield $2d7d9af7a5367cf4$var$sleep(this.signalLatency);
                            this.handleSignalResponse(resp);
                        });
                    this.ws.onclose = (ev)=>{
                        if (this.isEstablishingConnection) reject(new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb('Websocket got closed during a (re)connection attempt', $2d7d9af7a5367cf4$export$61182a0b21436b65.InternalError));
                        this.log.warn("websocket closed", Object.assign(Object.assign({}, this.logContext), {
                            reason: ev.reason,
                            code: ev.code,
                            wasClean: ev.wasClean,
                            state: this.state
                        }));
                        this.handleOnClose(ev.reason);
                    };
                } finally{
                    unlock();
                }
            }));
    }
    close() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function() {
            var _this = this;
            let updateState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            return function*() {
                const unlock = yield _this.closingLock.lock();
                try {
                    _this.clearPingInterval();
                    if (updateState) _this.state = $2d7d9af7a5367cf4$var$SignalConnectionState.DISCONNECTING;
                    if (_this.ws) {
                        _this.ws.onmessage = null;
                        _this.ws.onopen = null;
                        _this.ws.onclose = null;
                        // calling `ws.close()` only starts the closing handshake (CLOSING state), prefer to wait until state is actually CLOSED
                        const closePromise = new Promise((resolve)=>{
                            if (_this.ws) _this.ws.onclose = ()=>{
                                resolve();
                            };
                            else resolve();
                        });
                        if (_this.ws.readyState < _this.ws.CLOSING) {
                            _this.ws.close();
                            // 250ms grace period for ws to close gracefully
                            yield Promise.race([
                                closePromise,
                                $2d7d9af7a5367cf4$var$sleep(250)
                            ]);
                        }
                        _this.ws = undefined;
                    }
                } finally{
                    if (updateState) _this.state = $2d7d9af7a5367cf4$var$SignalConnectionState.DISCONNECTED;
                    unlock();
                }
            }();
        });
    }
    // initial offer after joining
    sendOffer(offer) {
        this.log.debug('sending offer', Object.assign(Object.assign({}, this.logContext), {
            offerSdp: offer.sdp
        }));
        this.sendRequest({
            case: 'offer',
            value: $2d7d9af7a5367cf4$var$toProtoSessionDescription(offer)
        });
    }
    // answer a server-initiated offer
    sendAnswer(answer) {
        this.log.debug('sending answer', Object.assign(Object.assign({}, this.logContext), {
            answerSdp: answer.sdp
        }));
        return this.sendRequest({
            case: 'answer',
            value: $2d7d9af7a5367cf4$var$toProtoSessionDescription(answer)
        });
    }
    sendIceCandidate(candidate, target) {
        this.log.trace('sending ice candidate', Object.assign(Object.assign({}, this.logContext), {
            candidate: candidate
        }));
        return this.sendRequest({
            case: 'trickle',
            value: new $2d7d9af7a5367cf4$var$TrickleRequest({
                candidateInit: JSON.stringify(candidate),
                target: target
            })
        });
    }
    sendMuteTrack(trackSid, muted) {
        return this.sendRequest({
            case: 'mute',
            value: new $2d7d9af7a5367cf4$var$MuteTrackRequest({
                sid: trackSid,
                muted: muted
            })
        });
    }
    sendAddTrack(req) {
        return this.sendRequest({
            case: 'addTrack',
            value: req
        });
    }
    sendUpdateLocalMetadata(metadata_1, name_1) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function(metadata, name) {
            var _this2 = this;
            let attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return function*() {
                const requestId = _this2.getNextRequestId();
                yield _this2.sendRequest({
                    case: 'updateMetadata',
                    value: new $2d7d9af7a5367cf4$var$UpdateParticipantMetadata({
                        requestId: requestId,
                        metadata: metadata,
                        name: name,
                        attributes: attributes
                    })
                });
                return requestId;
            }();
        });
    }
    sendUpdateTrackSettings(settings) {
        this.sendRequest({
            case: 'trackSetting',
            value: settings
        });
    }
    sendUpdateSubscription(sub) {
        return this.sendRequest({
            case: 'subscription',
            value: sub
        });
    }
    sendSyncState(sync) {
        return this.sendRequest({
            case: 'syncState',
            value: sync
        });
    }
    sendUpdateVideoLayers(trackSid, layers) {
        return this.sendRequest({
            case: 'updateLayers',
            value: new $2d7d9af7a5367cf4$var$UpdateVideoLayers({
                trackSid: trackSid,
                layers: layers
            })
        });
    }
    sendUpdateSubscriptionPermissions(allParticipants, trackPermissions) {
        return this.sendRequest({
            case: 'subscriptionPermission',
            value: new $2d7d9af7a5367cf4$var$SubscriptionPermission({
                allParticipants: allParticipants,
                trackPermissions: trackPermissions
            })
        });
    }
    sendSimulateScenario(scenario) {
        return this.sendRequest({
            case: 'simulate',
            value: scenario
        });
    }
    sendPing() {
        /** send both of ping and pingReq for compatibility to old and new server */ return Promise.all([
            this.sendRequest({
                case: 'ping',
                value: $2d7d9af7a5367cf4$var$protoInt64.parse(Date.now())
            }),
            this.sendRequest({
                case: 'pingReq',
                value: new $2d7d9af7a5367cf4$var$Ping({
                    timestamp: $2d7d9af7a5367cf4$var$protoInt64.parse(Date.now()),
                    rtt: $2d7d9af7a5367cf4$var$protoInt64.parse(this.rtt)
                })
            })
        ]);
    }
    sendUpdateLocalAudioTrack(trackSid, features) {
        return this.sendRequest({
            case: 'updateAudioTrack',
            value: new $2d7d9af7a5367cf4$var$UpdateLocalAudioTrack({
                trackSid: trackSid,
                features: features
            })
        });
    }
    sendLeave() {
        return this.sendRequest({
            case: 'leave',
            value: new $2d7d9af7a5367cf4$var$LeaveRequest({
                reason: $2d7d9af7a5367cf4$export$258d16488300d83f.CLIENT_INITIATED,
                // server doesn't process this field, keeping it here to indicate the intent of a full disconnect
                action: $2d7d9af7a5367cf4$var$LeaveRequest_Action.DISCONNECT
            })
        });
    }
    sendRequest(message_1) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function(message) {
            var _this3 = this;
            let fromQueue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return function*() {
                // capture all requests while reconnecting and put them in a queue
                // unless the request originates from the queue, then don't enqueue again
                const canQueue = !fromQueue && !$2d7d9af7a5367cf4$var$canPassThroughQueue(message);
                if (canQueue && _this3.state === $2d7d9af7a5367cf4$var$SignalConnectionState.RECONNECTING) {
                    _this3.queuedRequests.push(()=>$2d7d9af7a5367cf4$var$__awaiter(_this3, void 0, void 0, function*() {
                            yield this.sendRequest(message, true);
                        }));
                    return;
                }
                // make sure previously queued requests are being sent first
                if (!fromQueue) yield _this3.requestQueue.flush();
                if (_this3.signalLatency) yield $2d7d9af7a5367cf4$var$sleep(_this3.signalLatency);
                if (!_this3.ws || _this3.ws.readyState !== _this3.ws.OPEN) {
                    _this3.log.error("cannot send signal request before connected, type: ".concat(message === null || message === void 0 ? void 0 : message.case), _this3.logContext);
                    return;
                }
                const req = new $2d7d9af7a5367cf4$var$SignalRequest({
                    message: message
                });
                try {
                    if (_this3.useJSON) _this3.ws.send(req.toJsonString());
                    else _this3.ws.send(req.toBinary());
                } catch (e) {
                    _this3.log.error('error sending signal message', Object.assign(Object.assign({}, _this3.logContext), {
                        error: e
                    }));
                }
            }();
        });
    }
    handleSignalResponse(res) {
        var _a, _b;
        const msg = res.message;
        if (msg == undefined) {
            this.log.debug('received unsupported message', this.logContext);
            return;
        }
        let pingHandled = false;
        if (msg.case === 'answer') {
            const sd = $2d7d9af7a5367cf4$var$fromProtoSessionDescription(msg.value);
            if (this.onAnswer) this.onAnswer(sd);
        } else if (msg.case === 'offer') {
            const sd = $2d7d9af7a5367cf4$var$fromProtoSessionDescription(msg.value);
            if (this.onOffer) this.onOffer(sd);
        } else if (msg.case === 'trickle') {
            const candidate = JSON.parse(msg.value.candidateInit);
            if (this.onTrickle) this.onTrickle(candidate, msg.value.target);
        } else if (msg.case === 'update') {
            if (this.onParticipantUpdate) this.onParticipantUpdate((_a = msg.value.participants) !== null && _a !== void 0 ? _a : []);
        } else if (msg.case === 'trackPublished') {
            if (this.onLocalTrackPublished) this.onLocalTrackPublished(msg.value);
        } else if (msg.case === 'speakersChanged') {
            if (this.onSpeakersChanged) this.onSpeakersChanged((_b = msg.value.speakers) !== null && _b !== void 0 ? _b : []);
        } else if (msg.case === 'leave') {
            if (this.onLeave) this.onLeave(msg.value);
        } else if (msg.case === 'mute') {
            if (this.onRemoteMuteChanged) this.onRemoteMuteChanged(msg.value.sid, msg.value.muted);
        } else if (msg.case === 'roomUpdate') {
            if (this.onRoomUpdate && msg.value.room) this.onRoomUpdate(msg.value.room);
        } else if (msg.case === 'connectionQuality') {
            if (this.onConnectionQuality) this.onConnectionQuality(msg.value);
        } else if (msg.case === 'streamStateUpdate') {
            if (this.onStreamStateUpdate) this.onStreamStateUpdate(msg.value);
        } else if (msg.case === 'subscribedQualityUpdate') {
            if (this.onSubscribedQualityUpdate) this.onSubscribedQualityUpdate(msg.value);
        } else if (msg.case === 'subscriptionPermissionUpdate') {
            if (this.onSubscriptionPermissionUpdate) this.onSubscriptionPermissionUpdate(msg.value);
        } else if (msg.case === 'refreshToken') {
            if (this.onTokenRefresh) this.onTokenRefresh(msg.value);
        } else if (msg.case === 'trackUnpublished') {
            if (this.onLocalTrackUnpublished) this.onLocalTrackUnpublished(msg.value);
        } else if (msg.case === 'subscriptionResponse') {
            if (this.onSubscriptionError) this.onSubscriptionError(msg.value);
        } else if (msg.case === 'pong') ;
        else if (msg.case === 'pongResp') {
            this.rtt = Date.now() - Number.parseInt(msg.value.lastPingTimestamp.toString());
            this.resetPingTimeout();
            pingHandled = true;
        } else if (msg.case === 'requestResponse') {
            if (this.onRequestResponse) this.onRequestResponse(msg.value);
        } else if (msg.case === 'trackSubscribed') {
            if (this.onLocalTrackSubscribed) this.onLocalTrackSubscribed(msg.value.trackSid);
        } else this.log.debug('unsupported message', Object.assign(Object.assign({}, this.logContext), {
            msgCase: msg.case
        }));
        if (!pingHandled) this.resetPingTimeout();
    }
    setReconnected() {
        while(this.queuedRequests.length > 0){
            const req = this.queuedRequests.shift();
            if (req) this.requestQueue.run(req);
        }
    }
    handleOnClose(reason) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (this.state === $2d7d9af7a5367cf4$var$SignalConnectionState.DISCONNECTED) return;
            const onCloseCallback = this.onClose;
            yield this.close();
            this.log.debug("websocket connection closed: ".concat(reason), Object.assign(Object.assign({}, this.logContext), {
                reason: reason
            }));
            if (onCloseCallback) onCloseCallback(reason);
        });
    }
    handleWSError(ev) {
        this.log.error('websocket error', Object.assign(Object.assign({}, this.logContext), {
            error: ev
        }));
    }
    /**
   * Resets the ping timeout and starts a new timeout.
   * Call this after receiving a pong message
   */ resetPingTimeout() {
        this.clearPingTimeout();
        if (!this.pingTimeoutDuration) {
            this.log.warn('ping timeout duration not set', this.logContext);
            return;
        }
        this.pingTimeout = $2d7d9af7a5367cf4$export$22e737276454df96.setTimeout(()=>{
            this.log.warn("ping timeout triggered. last pong received at: ".concat(new Date(Date.now() - this.pingTimeoutDuration * 1000).toUTCString()), this.logContext);
            this.handleOnClose('ping timeout');
        }, this.pingTimeoutDuration * 1000);
    }
    /**
   * Clears ping timeout (does not start a new timeout)
   */ clearPingTimeout() {
        if (this.pingTimeout) $2d7d9af7a5367cf4$export$22e737276454df96.clearTimeout(this.pingTimeout);
    }
    startPingInterval() {
        this.clearPingInterval();
        this.resetPingTimeout();
        if (!this.pingIntervalDuration) {
            this.log.warn('ping interval duration not set', this.logContext);
            return;
        }
        this.log.debug('start ping interval', this.logContext);
        this.pingInterval = $2d7d9af7a5367cf4$export$22e737276454df96.setInterval(()=>{
            this.sendPing();
        }, this.pingIntervalDuration * 1000);
    }
    clearPingInterval() {
        this.log.debug('clearing ping interval', this.logContext);
        this.clearPingTimeout();
        if (this.pingInterval) $2d7d9af7a5367cf4$export$22e737276454df96.clearInterval(this.pingInterval);
    }
}
function $2d7d9af7a5367cf4$var$fromProtoSessionDescription(sd) {
    const rsd = {
        type: 'offer',
        sdp: sd.sdp
    };
    switch(sd.type){
        case 'answer':
        case 'offer':
        case 'pranswer':
        case 'rollback':
            rsd.type = sd.type;
            break;
    }
    return rsd;
}
function $2d7d9af7a5367cf4$var$toProtoSessionDescription(rsd) {
    const sd = new $2d7d9af7a5367cf4$var$SessionDescription({
        sdp: rsd.sdp,
        type: rsd.type
    });
    return sd;
}
function $2d7d9af7a5367cf4$var$createConnectionParams(token, info, opts) {
    var _a;
    const params = new URLSearchParams();
    params.set('access_token', token);
    // opts
    if (opts.reconnect) {
        params.set('reconnect', '1');
        if (opts.sid) params.set('sid', opts.sid);
    }
    params.set('auto_subscribe', opts.autoSubscribe ? '1' : '0');
    // ClientInfo
    params.set('sdk', $2d7d9af7a5367cf4$var$isReactNative() ? 'reactnative' : 'js');
    params.set('version', info.version);
    params.set('protocol', info.protocol.toString());
    if (info.deviceModel) params.set('device_model', info.deviceModel);
    if (info.os) params.set('os', info.os);
    if (info.osVersion) params.set('os_version', info.osVersion);
    if (info.browser) params.set('browser', info.browser);
    if (info.browserVersion) params.set('browser_version', info.browserVersion);
    if (opts.adaptiveStream) params.set('adaptive_stream', '1');
    if (opts.reconnectReason) params.set('reconnect_reason', opts.reconnectReason.toString());
    // @ts-ignore
    if ((_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.type) // @ts-ignore
    params.set('network', navigator.connection.type);
    return "?".concat(params.toString());
}
var $2d7d9af7a5367cf4$var$lib = {};
var $2d7d9af7a5367cf4$var$parser = {};
var $2d7d9af7a5367cf4$var$grammar = {
    exports: {}
};
var $2d7d9af7a5367cf4$var$hasRequiredGrammar;
function $2d7d9af7a5367cf4$var$requireGrammar() {
    if ($2d7d9af7a5367cf4$var$hasRequiredGrammar) return $2d7d9af7a5367cf4$var$grammar.exports;
    $2d7d9af7a5367cf4$var$hasRequiredGrammar = 1;
    var grammar$1 = $2d7d9af7a5367cf4$var$grammar.exports = {
        v: [
            {
                name: 'version',
                reg: /^(\d*)$/
            }
        ],
        o: [
            {
                // o=- 20518 0 IN IP4 203.0.113.1
                // NB: sessionId will be a String in most cases because it is huge
                name: 'origin',
                reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
                names: [
                    'username',
                    'sessionId',
                    'sessionVersion',
                    'netType',
                    'ipVer',
                    'address'
                ],
                format: '%s %s %d %s IP%d %s'
            }
        ],
        // default parsing of these only (though some of these feel outdated)
        s: [
            {
                name: 'name'
            }
        ],
        i: [
            {
                name: 'description'
            }
        ],
        u: [
            {
                name: 'uri'
            }
        ],
        e: [
            {
                name: 'email'
            }
        ],
        p: [
            {
                name: 'phone'
            }
        ],
        z: [
            {
                name: 'timezones'
            }
        ],
        // TODO: this one can actually be parsed properly...
        r: [
            {
                name: 'repeats'
            }
        ],
        // TODO: this one can also be parsed properly
        // k: [{}], // outdated thing ignored
        t: [
            {
                // t=0 0
                name: 'timing',
                reg: /^(\d*) (\d*)/,
                names: [
                    'start',
                    'stop'
                ],
                format: '%d %d'
            }
        ],
        c: [
            {
                // c=IN IP4 10.47.197.26
                name: 'connection',
                reg: /^IN IP(\d) (\S*)/,
                names: [
                    'version',
                    'ip'
                ],
                format: 'IN IP%d %s'
            }
        ],
        b: [
            {
                // b=AS:4000
                push: 'bandwidth',
                reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
                names: [
                    'type',
                    'limit'
                ],
                format: '%s:%s'
            }
        ],
        m: [
            {
                // m=video 51744 RTP/AVP 126 97 98 34 31
                // NB: special - pushes to session
                // TODO: rtp/fmtp should be filtered by the payloads found here?
                reg: /^(\w*) (\d*) ([\w/]*)(?: (.*))?/,
                names: [
                    'type',
                    'port',
                    'protocol',
                    'payloads'
                ],
                format: '%s %d %s %s'
            }
        ],
        a: [
            {
                // a=rtpmap:110 opus/48000/2
                push: 'rtp',
                reg: /^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
                names: [
                    'payload',
                    'codec',
                    'rate',
                    'encoding'
                ],
                format: function(o) {
                    return o.encoding ? 'rtpmap:%d %s/%s/%s' : o.rate ? 'rtpmap:%d %s/%s' : 'rtpmap:%d %s';
                }
            },
            {
                // a=fmtp:108 profile-level-id=24;object=23;bitrate=64000
                // a=fmtp:111 minptime=10; useinbandfec=1
                push: 'fmtp',
                reg: /^fmtp:(\d*) ([\S| ]*)/,
                names: [
                    'payload',
                    'config'
                ],
                format: 'fmtp:%d %s'
            },
            {
                // a=control:streamid=0
                name: 'control',
                reg: /^control:(.*)/,
                format: 'control:%s'
            },
            {
                // a=rtcp:65179 IN IP4 193.84.77.194
                name: 'rtcp',
                reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
                names: [
                    'port',
                    'netType',
                    'ipVer',
                    'address'
                ],
                format: function(o) {
                    return o.address != null ? 'rtcp:%d %s IP%d %s' : 'rtcp:%d';
                }
            },
            {
                // a=rtcp-fb:98 trr-int 100
                push: 'rtcpFbTrrInt',
                reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
                names: [
                    'payload',
                    'value'
                ],
                format: 'rtcp-fb:%s trr-int %d'
            },
            {
                // a=rtcp-fb:98 nack rpsi
                push: 'rtcpFb',
                reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
                names: [
                    'payload',
                    'type',
                    'subtype'
                ],
                format: function(o) {
                    return o.subtype != null ? 'rtcp-fb:%s %s %s' : 'rtcp-fb:%s %s';
                }
            },
            {
                // a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
                // a=extmap:1/recvonly URI-gps-string
                // a=extmap:3 urn:ietf:params:rtp-hdrext:encrypt urn:ietf:params:rtp-hdrext:smpte-tc 25@600/24
                push: 'ext',
                reg: /^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,
                names: [
                    'value',
                    'direction',
                    'encrypt-uri',
                    'uri',
                    'config'
                ],
                format: function(o) {
                    return 'extmap:%d' + (o.direction ? '/%s' : '%v') + (o['encrypt-uri'] ? ' %s' : '%v') + ' %s' + (o.config ? ' %s' : '');
                }
            },
            {
                // a=extmap-allow-mixed
                name: 'extmapAllowMixed',
                reg: /^(extmap-allow-mixed)/
            },
            {
                // a=crypto:1 AES_CM_128_HMAC_SHA1_80 inline:PS1uQCVeeCFCanVmcjkpPywjNWhcYD0mXXtxaVBR|2^20|1:32
                push: 'crypto',
                reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
                names: [
                    'id',
                    'suite',
                    'config',
                    'sessionConfig'
                ],
                format: function(o) {
                    return o.sessionConfig != null ? 'crypto:%d %s %s %s' : 'crypto:%d %s %s';
                }
            },
            {
                // a=setup:actpass
                name: 'setup',
                reg: /^setup:(\w*)/,
                format: 'setup:%s'
            },
            {
                // a=connection:new
                name: 'connectionType',
                reg: /^connection:(new|existing)/,
                format: 'connection:%s'
            },
            {
                // a=mid:1
                name: 'mid',
                reg: /^mid:([^\s]*)/,
                format: 'mid:%s'
            },
            {
                // a=msid:0c8b064d-d807-43b4-b434-f92a889d8587 98178685-d409-46e0-8e16-7ef0db0db64a
                name: 'msid',
                reg: /^msid:(.*)/,
                format: 'msid:%s'
            },
            {
                // a=ptime:20
                name: 'ptime',
                reg: /^ptime:(\d*(?:\.\d*)*)/,
                format: 'ptime:%d'
            },
            {
                // a=maxptime:60
                name: 'maxptime',
                reg: /^maxptime:(\d*(?:\.\d*)*)/,
                format: 'maxptime:%d'
            },
            {
                // a=sendrecv
                name: 'direction',
                reg: /^(sendrecv|recvonly|sendonly|inactive)/
            },
            {
                // a=ice-lite
                name: 'icelite',
                reg: /^(ice-lite)/
            },
            {
                // a=ice-ufrag:F7gI
                name: 'iceUfrag',
                reg: /^ice-ufrag:(\S*)/,
                format: 'ice-ufrag:%s'
            },
            {
                // a=ice-pwd:x9cml/YzichV2+XlhiMu8g
                name: 'icePwd',
                reg: /^ice-pwd:(\S*)/,
                format: 'ice-pwd:%s'
            },
            {
                // a=fingerprint:SHA-1 00:11:22:33:44:55:66:77:88:99:AA:BB:CC:DD:EE:FF:00:11:22:33
                name: 'fingerprint',
                reg: /^fingerprint:(\S*) (\S*)/,
                names: [
                    'type',
                    'hash'
                ],
                format: 'fingerprint:%s %s'
            },
            {
                // a=candidate:0 1 UDP 2113667327 203.0.113.1 54400 typ host
                // a=candidate:1162875081 1 udp 2113937151 192.168.34.75 60017 typ host generation 0 network-id 3 network-cost 10
                // a=candidate:3289912957 2 udp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 generation 0 network-id 3 network-cost 10
                // a=candidate:229815620 1 tcp 1518280447 192.168.150.19 60017 typ host tcptype active generation 0 network-id 3 network-cost 10
                // a=candidate:3289912957 2 tcp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 tcptype passive generation 0 network-id 3 network-cost 10
                push: 'candidates',
                reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,
                names: [
                    'foundation',
                    'component',
                    'transport',
                    'priority',
                    'ip',
                    'port',
                    'type',
                    'raddr',
                    'rport',
                    'tcptype',
                    'generation',
                    'network-id',
                    'network-cost'
                ],
                format: function(o) {
                    var str = 'candidate:%s %d %s %d %s %d typ %s';
                    str += o.raddr != null ? ' raddr %s rport %d' : '%v%v';
                    // NB: candidate has three optional chunks, so %void middles one if it's missing
                    str += o.tcptype != null ? ' tcptype %s' : '%v';
                    if (o.generation != null) str += ' generation %d';
                    str += o['network-id'] != null ? ' network-id %d' : '%v';
                    str += o['network-cost'] != null ? ' network-cost %d' : '%v';
                    return str;
                }
            },
            {
                // a=end-of-candidates (keep after the candidates line for readability)
                name: 'endOfCandidates',
                reg: /^(end-of-candidates)/
            },
            {
                // a=remote-candidates:1 203.0.113.1 54400 2 203.0.113.1 54401 ...
                name: 'remoteCandidates',
                reg: /^remote-candidates:(.*)/,
                format: 'remote-candidates:%s'
            },
            {
                // a=ice-options:google-ice
                name: 'iceOptions',
                reg: /^ice-options:(\S*)/,
                format: 'ice-options:%s'
            },
            {
                // a=ssrc:2566107569 cname:t9YU8M1UxTF8Y1A1
                push: 'ssrcs',
                reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,
                names: [
                    'id',
                    'attribute',
                    'value'
                ],
                format: function(o) {
                    var str = 'ssrc:%d';
                    if (o.attribute != null) {
                        str += ' %s';
                        if (o.value != null) str += ':%s';
                    }
                    return str;
                }
            },
            {
                // a=ssrc-group:FEC 1 2
                // a=ssrc-group:FEC-FR 3004364195 1080772241
                push: 'ssrcGroups',
                // token-char = %x21 / %x23-27 / %x2A-2B / %x2D-2E / %x30-39 / %x41-5A / %x5E-7E
                reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,
                names: [
                    'semantics',
                    'ssrcs'
                ],
                format: 'ssrc-group:%s %s'
            },
            {
                // a=msid-semantic: WMS Jvlam5X3SX1OP6pn20zWogvaKJz5Hjf9OnlV
                name: 'msidSemantic',
                reg: /^msid-semantic:\s?(\w*) (\S*)/,
                names: [
                    'semantic',
                    'token'
                ],
                format: 'msid-semantic: %s %s' // space after ':' is not accidental
            },
            {
                // a=group:BUNDLE audio video
                push: 'groups',
                reg: /^group:(\w*) (.*)/,
                names: [
                    'type',
                    'mids'
                ],
                format: 'group:%s %s'
            },
            {
                // a=rtcp-mux
                name: 'rtcpMux',
                reg: /^(rtcp-mux)/
            },
            {
                // a=rtcp-rsize
                name: 'rtcpRsize',
                reg: /^(rtcp-rsize)/
            },
            {
                // a=sctpmap:5000 webrtc-datachannel 1024
                name: 'sctpmap',
                reg: /^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,
                names: [
                    'sctpmapNumber',
                    'app',
                    'maxMessageSize'
                ],
                format: function(o) {
                    return o.maxMessageSize != null ? 'sctpmap:%s %s %s' : 'sctpmap:%s %s';
                }
            },
            {
                // a=x-google-flag:conference
                name: 'xGoogleFlag',
                reg: /^x-google-flag:([^\s]*)/,
                format: 'x-google-flag:%s'
            },
            {
                // a=rid:1 send max-width=1280;max-height=720;max-fps=30;depend=0
                push: 'rids',
                reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,
                names: [
                    'id',
                    'direction',
                    'params'
                ],
                format: function(o) {
                    return o.params ? 'rid:%s %s %s' : 'rid:%s %s';
                }
            },
            {
                // a=imageattr:97 send [x=800,y=640,sar=1.1,q=0.6] [x=480,y=320] recv [x=330,y=250]
                // a=imageattr:* send [x=800,y=640] recv *
                // a=imageattr:100 recv [x=320,y=240]
                push: 'imageattrs',
                reg: new RegExp(// a=imageattr:97
                "^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"),
                names: [
                    'pt',
                    'dir1',
                    'attrs1',
                    'dir2',
                    'attrs2'
                ],
                format: function(o) {
                    return 'imageattr:%s %s %s' + (o.dir2 ? ' %s %s' : '');
                }
            },
            {
                // a=simulcast:send 1,2,3;~4,~5 recv 6;~7,~8
                // a=simulcast:recv 1;4,5 send 6;7
                name: 'simulcast',
                reg: new RegExp(// a=simulcast:
                "^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"),
                names: [
                    'dir1',
                    'list1',
                    'dir2',
                    'list2'
                ],
                format: function(o) {
                    return 'simulcast:%s %s' + (o.dir2 ? ' %s %s' : '');
                }
            },
            {
                // old simulcast draft 03 (implemented by Firefox)
                //   https://tools.ietf.org/html/draft-ietf-mmusic-sdp-simulcast-03
                // a=simulcast: recv pt=97;98 send pt=97
                // a=simulcast: send rid=5;6;7 paused=6,7
                name: 'simulcast_03',
                reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/,
                names: [
                    'value'
                ],
                format: 'simulcast: %s'
            },
            {
                // a=framerate:25
                // a=framerate:29.97
                name: 'framerate',
                reg: /^framerate:(\d+(?:$|\.\d+))/,
                format: 'framerate:%s'
            },
            {
                // RFC4570
                // a=source-filter: incl IN IP4 239.5.2.31 10.1.15.5
                name: 'sourceFilter',
                reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,
                names: [
                    'filterMode',
                    'netType',
                    'addressTypes',
                    'destAddress',
                    'srcList'
                ],
                format: 'source-filter: %s %s %s %s %s'
            },
            {
                // a=bundle-only
                name: 'bundleOnly',
                reg: /^(bundle-only)/
            },
            {
                // a=label:1
                name: 'label',
                reg: /^label:(.+)/,
                format: 'label:%s'
            },
            {
                // RFC version 26 for SCTP over DTLS
                // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-5
                name: 'sctpPort',
                reg: /^sctp-port:(\d+)$/,
                format: 'sctp-port:%s'
            },
            {
                // RFC version 26 for SCTP over DTLS
                // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-6
                name: 'maxMessageSize',
                reg: /^max-message-size:(\d+)$/,
                format: 'max-message-size:%s'
            },
            {
                // RFC7273
                // a=ts-refclk:ptp=IEEE1588-2008:39-A7-94-FF-FE-07-CB-D0:37
                push: 'tsRefClocks',
                reg: /^ts-refclk:([^\s=]*)(?:=(\S*))?/,
                names: [
                    'clksrc',
                    'clksrcExt'
                ],
                format: function(o) {
                    return 'ts-refclk:%s' + (o.clksrcExt != null ? '=%s' : '');
                }
            },
            {
                // RFC7273
                // a=mediaclk:direct=963214424
                name: 'mediaClk',
                reg: /^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,
                names: [
                    'id',
                    'mediaClockName',
                    'mediaClockValue',
                    'rateNumerator',
                    'rateDenominator'
                ],
                format: function(o) {
                    var str = 'mediaclk:';
                    str += o.id != null ? 'id=%s %s' : '%v%s';
                    str += o.mediaClockValue != null ? '=%s' : '';
                    str += o.rateNumerator != null ? ' rate=%s' : '';
                    str += o.rateDenominator != null ? '/%s' : '';
                    return str;
                }
            },
            {
                // a=keywds:keywords
                name: 'keywords',
                reg: /^keywds:(.+)$/,
                format: 'keywds:%s'
            },
            {
                // a=content:main
                name: 'content',
                reg: /^content:(.+)/,
                format: 'content:%s'
            },
            // BFCP https://tools.ietf.org/html/rfc4583
            {
                // a=floorctrl:c-s
                name: 'bfcpFloorCtrl',
                reg: /^floorctrl:(c-only|s-only|c-s)/,
                format: 'floorctrl:%s'
            },
            {
                // a=confid:1
                name: 'bfcpConfId',
                reg: /^confid:(\d+)/,
                format: 'confid:%s'
            },
            {
                // a=userid:1
                name: 'bfcpUserId',
                reg: /^userid:(\d+)/,
                format: 'userid:%s'
            },
            {
                // a=floorid:1
                name: 'bfcpFloorId',
                reg: /^floorid:(.+) (?:m-stream|mstrm):(.+)/,
                names: [
                    'id',
                    'mStream'
                ],
                format: 'floorid:%s mstrm:%s'
            },
            {
                // any a= that we don't understand is kept verbatim on media.invalid
                push: 'invalid',
                names: [
                    'value'
                ]
            }
        ]
    };
    // set sensible defaults to avoid polluting the grammar with boring details
    Object.keys(grammar$1).forEach(function(key) {
        var objs = grammar$1[key];
        objs.forEach(function(obj) {
            if (!obj.reg) obj.reg = /(.*)/;
            if (!obj.format) obj.format = '%s';
        });
    });
    return $2d7d9af7a5367cf4$var$grammar.exports;
}
var $2d7d9af7a5367cf4$var$hasRequiredParser;
function $2d7d9af7a5367cf4$var$requireParser() {
    if ($2d7d9af7a5367cf4$var$hasRequiredParser) return $2d7d9af7a5367cf4$var$parser;
    $2d7d9af7a5367cf4$var$hasRequiredParser = 1;
    (function(exports) {
        var toIntIfInt = function(v) {
            return String(Number(v)) === v ? Number(v) : v;
        };
        var attachProperties = function(match, location, names, rawName) {
            if (rawName && !names) location[rawName] = toIntIfInt(match[1]);
            else {
                for(var i = 0; i < names.length; i += 1)if (match[i + 1] != null) location[names[i]] = toIntIfInt(match[i + 1]);
            }
        };
        var parseReg = function(obj, location, content) {
            var needsBlank = obj.name && obj.names;
            if (obj.push && !location[obj.push]) location[obj.push] = [];
            else if (needsBlank && !location[obj.name]) location[obj.name] = {};
            var keyLocation = obj.push ? {} : // blank object that will be pushed
            needsBlank ? location[obj.name] : location; // otherwise, named location or root
            attachProperties(content.match(obj.reg), keyLocation, obj.names, obj.name);
            if (obj.push) location[obj.push].push(keyLocation);
        };
        var grammar = $2d7d9af7a5367cf4$var$requireGrammar();
        var validLine = RegExp.prototype.test.bind(/^([a-z])=(.*)/);
        exports.parse = function(sdp) {
            var session = {}, media = [], location = session; // points at where properties go under (one of the above)
            // parse lines we understand
            sdp.split(/(\r\n|\r|\n)/).filter(validLine).forEach(function(l) {
                var type = l[0];
                var content = l.slice(2);
                if (type === 'm') {
                    media.push({
                        rtp: [],
                        fmtp: []
                    });
                    location = media[media.length - 1]; // point at latest media line
                }
                for(var j = 0; j < (grammar[type] || []).length; j += 1){
                    var obj = grammar[type][j];
                    if (obj.reg.test(content)) return parseReg(obj, location, content);
                }
            });
            session.media = media; // link it up
            return session;
        };
        var paramReducer = function(acc, expr) {
            var s = expr.split(/=(.+)/, 2);
            if (s.length === 2) acc[s[0]] = toIntIfInt(s[1]);
            else if (s.length === 1 && expr.length > 1) acc[s[0]] = undefined;
            return acc;
        };
        exports.parseParams = function(str) {
            return str.split(/;\s?/).reduce(paramReducer, {});
        };
        // For backward compatibility - alias will be removed in 3.0.0
        exports.parseFmtpConfig = exports.parseParams;
        exports.parsePayloads = function(str) {
            return str.toString().split(' ').map(Number);
        };
        exports.parseRemoteCandidates = function(str) {
            var candidates = [];
            var parts = str.split(' ').map(toIntIfInt);
            for(var i = 0; i < parts.length; i += 3)candidates.push({
                component: parts[i],
                ip: parts[i + 1],
                port: parts[i + 2]
            });
            return candidates;
        };
        exports.parseImageAttributes = function(str) {
            return str.split(' ').map(function(item) {
                return item.substring(1, item.length - 1).split(',').reduce(paramReducer, {});
            });
        };
        exports.parseSimulcastStreamList = function(str) {
            return str.split(';').map(function(stream) {
                return stream.split(',').map(function(format) {
                    var scid, paused = false;
                    if (format[0] !== '~') scid = toIntIfInt(format);
                    else {
                        scid = toIntIfInt(format.substring(1, format.length));
                        paused = true;
                    }
                    return {
                        scid: scid,
                        paused: paused
                    };
                });
            });
        };
    })($2d7d9af7a5367cf4$var$parser);
    return $2d7d9af7a5367cf4$var$parser;
}
var $2d7d9af7a5367cf4$var$writer;
var $2d7d9af7a5367cf4$var$hasRequiredWriter;
function $2d7d9af7a5367cf4$var$requireWriter() {
    if ($2d7d9af7a5367cf4$var$hasRequiredWriter) return $2d7d9af7a5367cf4$var$writer;
    $2d7d9af7a5367cf4$var$hasRequiredWriter = 1;
    var grammar = $2d7d9af7a5367cf4$var$requireGrammar();
    // customized util.format - discards excess arguments and can void middle ones
    var formatRegExp = /%[sdv%]/g;
    var format = function(formatStr) {
        var i = 1;
        var args = arguments;
        var len = args.length;
        return formatStr.replace(formatRegExp, function(x) {
            if (i >= len) return x; // missing argument
            var arg = args[i];
            i += 1;
            switch(x){
                case '%%':
                    return '%';
                case '%s':
                    return String(arg);
                case '%d':
                    return Number(arg);
                case '%v':
                    return '';
            }
        });
    // NB: we discard excess arguments - they are typically undefined from makeLine
    };
    var makeLine = function(type, obj, location) {
        var str = obj.format instanceof Function ? obj.format(obj.push ? location : location[obj.name]) : obj.format;
        var args = [
            type + '=' + str
        ];
        if (obj.names) for(var i = 0; i < obj.names.length; i += 1){
            var n = obj.names[i];
            if (obj.name) args.push(location[obj.name][n]);
            else // for mLine and push attributes
            args.push(location[obj.names[i]]);
        }
        else args.push(location[obj.name]);
        return format.apply(null, args);
    };
    // RFC specified order
    // TODO: extend this with all the rest
    var defaultOuterOrder = [
        'v',
        'o',
        's',
        'i',
        'u',
        'e',
        'p',
        'c',
        'b',
        't',
        'r',
        'z',
        'a'
    ];
    var defaultInnerOrder = [
        'i',
        'c',
        'b',
        'a'
    ];
    $2d7d9af7a5367cf4$var$writer = function(session, opts) {
        opts = opts || {};
        // ensure certain properties exist
        if (session.version == null) session.version = 0; // 'v=0' must be there (only defined version atm)
        if (session.name == null) session.name = ' '; // 's= ' must be there if no meaningful name set
        session.media.forEach(function(mLine) {
            if (mLine.payloads == null) mLine.payloads = '';
        });
        var outerOrder = opts.outerOrder || defaultOuterOrder;
        var innerOrder = opts.innerOrder || defaultInnerOrder;
        var sdp = [];
        // loop through outerOrder for matching properties on session
        outerOrder.forEach(function(type) {
            grammar[type].forEach(function(obj) {
                if (obj.name in session && session[obj.name] != null) sdp.push(makeLine(type, obj, session));
                else if (obj.push in session && session[obj.push] != null) session[obj.push].forEach(function(el) {
                    sdp.push(makeLine(type, obj, el));
                });
            });
        });
        // then for each media line, follow the innerOrder
        session.media.forEach(function(mLine) {
            sdp.push(makeLine('m', grammar.m[0], mLine));
            innerOrder.forEach(function(type) {
                grammar[type].forEach(function(obj) {
                    if (obj.name in mLine && mLine[obj.name] != null) sdp.push(makeLine(type, obj, mLine));
                    else if (obj.push in mLine && mLine[obj.push] != null) mLine[obj.push].forEach(function(el) {
                        sdp.push(makeLine(type, obj, el));
                    });
                });
            });
        });
        return sdp.join('\r\n') + '\r\n';
    };
    return $2d7d9af7a5367cf4$var$writer;
}
var $2d7d9af7a5367cf4$var$hasRequiredLib;
function $2d7d9af7a5367cf4$var$requireLib() {
    if ($2d7d9af7a5367cf4$var$hasRequiredLib) return $2d7d9af7a5367cf4$var$lib;
    $2d7d9af7a5367cf4$var$hasRequiredLib = 1;
    var parser = $2d7d9af7a5367cf4$var$requireParser();
    var writer = $2d7d9af7a5367cf4$var$requireWriter();
    $2d7d9af7a5367cf4$var$lib.write = writer;
    $2d7d9af7a5367cf4$var$lib.parse = parser.parse;
    $2d7d9af7a5367cf4$var$lib.parseParams = parser.parseParams;
    $2d7d9af7a5367cf4$var$lib.parseFmtpConfig = parser.parseFmtpConfig; // Alias of parseParams().
    $2d7d9af7a5367cf4$var$lib.parsePayloads = parser.parsePayloads;
    $2d7d9af7a5367cf4$var$lib.parseRemoteCandidates = parser.parseRemoteCandidates;
    $2d7d9af7a5367cf4$var$lib.parseImageAttributes = parser.parseImageAttributes;
    $2d7d9af7a5367cf4$var$lib.parseSimulcastStreamList = parser.parseSimulcastStreamList;
    return $2d7d9af7a5367cf4$var$lib;
}
var $2d7d9af7a5367cf4$var$libExports = $2d7d9af7a5367cf4$var$requireLib();
/* The svc codec (av1/vp9) would use a very low bitrate at the begining and
increase slowly by the bandwidth estimator until it reach the target bitrate. The
process commonly cost more than 10 seconds cause subscriber will get blur video at
the first few seconds. So we use a 70% of target bitrate here as the start bitrate to
eliminate this issue.
*/ const $2d7d9af7a5367cf4$var$startBitrateForSVC = 0.7;
const $2d7d9af7a5367cf4$var$debounceInterval = 20;
const $2d7d9af7a5367cf4$var$PCEvents = {
    NegotiationStarted: 'negotiationStarted',
    NegotiationComplete: 'negotiationComplete',
    RTPVideoPayloadTypes: 'rtpVideoPayloadTypes'
};
/** @internal */ class $2d7d9af7a5367cf4$var$PCTransport extends $2d7d9af7a5367cf4$var$eventsExports.EventEmitter {
    get pc() {
        if (!this._pc) this._pc = this.createPC();
        return this._pc;
    }
    constructor(config){
        let loggerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _a;
        super();
        this.log = $2d7d9af7a5367cf4$var$livekitLogger;
        this.ddExtID = 0;
        this.pendingCandidates = [];
        this.restartingIce = false;
        this.renegotiate = false;
        this.trackBitrates = [];
        this.remoteStereoMids = [];
        this.remoteNackMids = [];
        // debounced negotiate interface
        this.negotiate = $2d7d9af7a5367cf4$var$r((onError)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                this.emit($2d7d9af7a5367cf4$var$PCEvents.NegotiationStarted);
                try {
                    yield this.createAndSendOffer();
                } catch (e) {
                    if (onError) onError(e);
                    else throw e;
                }
            }), $2d7d9af7a5367cf4$var$debounceInterval);
        this.close = ()=>{
            if (!this._pc) return;
            this._pc.close();
            this._pc.onconnectionstatechange = null;
            this._pc.oniceconnectionstatechange = null;
            this._pc.onicegatheringstatechange = null;
            this._pc.ondatachannel = null;
            this._pc.onnegotiationneeded = null;
            this._pc.onsignalingstatechange = null;
            this._pc.onicecandidate = null;
            this._pc.ondatachannel = null;
            this._pc.ontrack = null;
            this._pc.onconnectionstatechange = null;
            this._pc.oniceconnectionstatechange = null;
            this._pc = null;
        };
        this.log = $2d7d9af7a5367cf4$export$2b1d391cd05230fd((_a = loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $2d7d9af7a5367cf4$export$69ba24dd79f4da21.PCTransport);
        this.loggerOptions = loggerOptions;
        this.config = config;
        this._pc = this.createPC();
    }
    createPC() {
        const pc = new RTCPeerConnection(this.config);
        pc.onicecandidate = (ev)=>{
            var _a;
            if (!ev.candidate) return;
            (_a = this.onIceCandidate) === null || _a === void 0 || _a.call(this, ev.candidate);
        };
        pc.onicecandidateerror = (ev)=>{
            var _a;
            (_a = this.onIceCandidateError) === null || _a === void 0 || _a.call(this, ev);
        };
        pc.oniceconnectionstatechange = ()=>{
            var _a;
            (_a = this.onIceConnectionStateChange) === null || _a === void 0 || _a.call(this, pc.iceConnectionState);
        };
        pc.onsignalingstatechange = ()=>{
            var _a;
            (_a = this.onSignalingStatechange) === null || _a === void 0 || _a.call(this, pc.signalingState);
        };
        pc.onconnectionstatechange = ()=>{
            var _a;
            (_a = this.onConnectionStateChange) === null || _a === void 0 || _a.call(this, pc.connectionState);
        };
        pc.ondatachannel = (ev)=>{
            var _a;
            (_a = this.onDataChannel) === null || _a === void 0 || _a.call(this, ev);
        };
        pc.ontrack = (ev)=>{
            var _a;
            (_a = this.onTrack) === null || _a === void 0 || _a.call(this, ev);
        };
        return pc;
    }
    get logContext() {
        var _a, _b;
        return Object.assign({}, (_b = (_a = this.loggerOptions).loggerContextCb) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    get isICEConnected() {
        return this._pc !== null && (this.pc.iceConnectionState === 'connected' || this.pc.iceConnectionState === 'completed');
    }
    addIceCandidate(candidate) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (this.pc.remoteDescription && !this.restartingIce) return this.pc.addIceCandidate(candidate);
            this.pendingCandidates.push(candidate);
        });
    }
    setRemoteDescription(sd) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            let mungedSDP = undefined;
            if (sd.type === 'offer') {
                let { stereoMids: stereoMids, nackMids: nackMids } = $2d7d9af7a5367cf4$var$extractStereoAndNackAudioFromOffer(sd);
                this.remoteStereoMids = stereoMids;
                this.remoteNackMids = nackMids;
            } else if (sd.type === 'answer') {
                const sdpParsed = $2d7d9af7a5367cf4$var$libExports.parse((_a = sd.sdp) !== null && _a !== void 0 ? _a : '');
                sdpParsed.media.forEach((media)=>{
                    if (media.type === 'audio') // mung sdp for opus bitrate settings
                    this.trackBitrates.some((trackbr)=>{
                        if (!trackbr.transceiver || media.mid != trackbr.transceiver.mid) return false;
                        let codecPayload = 0;
                        media.rtp.some((rtp)=>{
                            if (rtp.codec.toUpperCase() === trackbr.codec.toUpperCase()) {
                                codecPayload = rtp.payload;
                                return true;
                            }
                            return false;
                        });
                        if (codecPayload === 0) return true;
                        let fmtpFound = false;
                        for (const fmtp of media.fmtp)if (fmtp.payload === codecPayload) {
                            fmtp.config = fmtp.config.split(';').filter((attr)=>!attr.includes('maxaveragebitrate')).join(';');
                            if (trackbr.maxbr > 0) fmtp.config += ";maxaveragebitrate=".concat(trackbr.maxbr * 1000);
                            fmtpFound = true;
                            break;
                        }
                        if (!fmtpFound) {
                            if (trackbr.maxbr > 0) media.fmtp.push({
                                payload: codecPayload,
                                config: "maxaveragebitrate=".concat(trackbr.maxbr * 1000)
                            });
                        }
                        return true;
                    });
                });
                mungedSDP = $2d7d9af7a5367cf4$var$libExports.write(sdpParsed);
            }
            yield this.setMungedSDP(sd, mungedSDP, true);
            this.pendingCandidates.forEach((candidate)=>{
                this.pc.addIceCandidate(candidate);
            });
            this.pendingCandidates = [];
            this.restartingIce = false;
            if (this.renegotiate) {
                this.renegotiate = false;
                yield this.createAndSendOffer();
            } else if (sd.type === 'answer') {
                this.emit($2d7d9af7a5367cf4$var$PCEvents.NegotiationComplete);
                if (sd.sdp) {
                    const sdpParsed = $2d7d9af7a5367cf4$var$libExports.parse(sd.sdp);
                    sdpParsed.media.forEach((media)=>{
                        if (media.type === 'video') this.emit($2d7d9af7a5367cf4$var$PCEvents.RTPVideoPayloadTypes, media.rtp);
                    });
                }
            }
        });
    }
    createAndSendOffer(options) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (this.onOffer === undefined) return;
            if (options === null || options === void 0 ? void 0 : options.iceRestart) {
                this.log.debug('restarting ICE', this.logContext);
                this.restartingIce = true;
            }
            if (this._pc && this._pc.signalingState === 'have-local-offer') {
                // we're waiting for the peer to accept our offer, so we'll just wait
                // the only exception to this is when ICE restart is needed
                const currentSD = this._pc.remoteDescription;
                if ((options === null || options === void 0 ? void 0 : options.iceRestart) && currentSD) // TODO: handle when ICE restart is needed but we don't have a remote description
                // the best thing to do is to recreate the peerconnection
                yield this._pc.setRemoteDescription(currentSD);
                else {
                    this.renegotiate = true;
                    return;
                }
            } else if (!this._pc || this._pc.signalingState === 'closed') {
                this.log.warn('could not createOffer with closed peer connection', this.logContext);
                return;
            }
            // actually negotiate
            this.log.debug('starting to negotiate', this.logContext);
            const offer = yield this.pc.createOffer(options);
            this.log.debug('original offer', Object.assign({
                sdp: offer.sdp
            }, this.logContext));
            const sdpParsed = $2d7d9af7a5367cf4$var$libExports.parse((_a = offer.sdp) !== null && _a !== void 0 ? _a : '');
            sdpParsed.media.forEach((media)=>{
                $2d7d9af7a5367cf4$var$ensureIPAddrMatchVersion(media);
                if (media.type === 'audio') $2d7d9af7a5367cf4$var$ensureAudioNackAndStereo(media, [], []);
                else if (media.type === 'video') this.trackBitrates.some((trackbr)=>{
                    if (!media.msid || !trackbr.cid || !media.msid.includes(trackbr.cid)) return false;
                    let codecPayload = 0;
                    media.rtp.some((rtp)=>{
                        if (rtp.codec.toUpperCase() === trackbr.codec.toUpperCase()) {
                            codecPayload = rtp.payload;
                            return true;
                        }
                        return false;
                    });
                    if (codecPayload === 0) return true;
                    if ($2d7d9af7a5367cf4$var$isSVCCodec(trackbr.codec)) this.ensureVideoDDExtensionForSVC(media, sdpParsed);
                    // TODO: av1 slow starting issue already fixed in chrome 124, clean this after some versions
                    // mung sdp for av1 bitrate setting that can't apply by sendEncoding
                    if (trackbr.codec !== 'av1') return true;
                    const startBitrate = Math.round(trackbr.maxbr * $2d7d9af7a5367cf4$var$startBitrateForSVC);
                    for (const fmtp of media.fmtp)if (fmtp.payload === codecPayload) {
                        // if another track's fmtp already is set, we cannot override the bitrate
                        // this has the unfortunate consequence of being forced to use the
                        // initial track's bitrate for all tracks
                        if (!fmtp.config.includes('x-google-start-bitrate')) fmtp.config += ";x-google-start-bitrate=".concat(startBitrate);
                        break;
                    }
                    return true;
                });
            });
            yield this.setMungedSDP(offer, $2d7d9af7a5367cf4$var$libExports.write(sdpParsed));
            this.onOffer(offer);
        });
    }
    createAndSetAnswer() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const answer = yield this.pc.createAnswer();
            const sdpParsed = $2d7d9af7a5367cf4$var$libExports.parse((_a = answer.sdp) !== null && _a !== void 0 ? _a : '');
            sdpParsed.media.forEach((media)=>{
                $2d7d9af7a5367cf4$var$ensureIPAddrMatchVersion(media);
                if (media.type === 'audio') $2d7d9af7a5367cf4$var$ensureAudioNackAndStereo(media, this.remoteStereoMids, this.remoteNackMids);
            });
            yield this.setMungedSDP(answer, $2d7d9af7a5367cf4$var$libExports.write(sdpParsed));
            return answer;
        });
    }
    createDataChannel(label, dataChannelDict) {
        return this.pc.createDataChannel(label, dataChannelDict);
    }
    addTransceiver(mediaStreamTrack, transceiverInit) {
        return this.pc.addTransceiver(mediaStreamTrack, transceiverInit);
    }
    addTrack(track) {
        if (!this._pc) throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('PC closed, cannot add track');
        return this._pc.addTrack(track);
    }
    setTrackCodecBitrate(info) {
        this.trackBitrates.push(info);
    }
    setConfiguration(rtcConfig) {
        var _a;
        if (!this._pc) throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('PC closed, cannot configure');
        return (_a = this._pc) === null || _a === void 0 ? void 0 : _a.setConfiguration(rtcConfig);
    }
    canRemoveTrack() {
        var _a;
        return !!((_a = this._pc) === null || _a === void 0 ? void 0 : _a.removeTrack);
    }
    removeTrack(sender) {
        var _a;
        return (_a = this._pc) === null || _a === void 0 ? void 0 : _a.removeTrack(sender);
    }
    getConnectionState() {
        var _a, _b;
        return (_b = (_a = this._pc) === null || _a === void 0 ? void 0 : _a.connectionState) !== null && _b !== void 0 ? _b : 'closed';
    }
    getICEConnectionState() {
        var _a, _b;
        return (_b = (_a = this._pc) === null || _a === void 0 ? void 0 : _a.iceConnectionState) !== null && _b !== void 0 ? _b : 'closed';
    }
    getSignallingState() {
        var _a, _b;
        return (_b = (_a = this._pc) === null || _a === void 0 ? void 0 : _a.signalingState) !== null && _b !== void 0 ? _b : 'closed';
    }
    getTransceivers() {
        var _a, _b;
        return (_b = (_a = this._pc) === null || _a === void 0 ? void 0 : _a.getTransceivers()) !== null && _b !== void 0 ? _b : [];
    }
    getSenders() {
        var _a, _b;
        return (_b = (_a = this._pc) === null || _a === void 0 ? void 0 : _a.getSenders()) !== null && _b !== void 0 ? _b : [];
    }
    getLocalDescription() {
        var _a;
        return (_a = this._pc) === null || _a === void 0 ? void 0 : _a.localDescription;
    }
    getRemoteDescription() {
        var _a;
        return (_a = this.pc) === null || _a === void 0 ? void 0 : _a.remoteDescription;
    }
    getStats() {
        return this.pc.getStats();
    }
    getConnectedAddress() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!this._pc) return;
            let selectedCandidatePairId = '';
            const candidatePairs = new Map();
            // id -> candidate ip
            const candidates = new Map();
            const stats = yield this._pc.getStats();
            stats.forEach((v)=>{
                switch(v.type){
                    case 'transport':
                        selectedCandidatePairId = v.selectedCandidatePairId;
                        break;
                    case 'candidate-pair':
                        if (selectedCandidatePairId === '' && v.selected) selectedCandidatePairId = v.id;
                        candidatePairs.set(v.id, v);
                        break;
                    case 'remote-candidate':
                        candidates.set(v.id, "".concat(v.address, ":").concat(v.port));
                        break;
                }
            });
            if (selectedCandidatePairId === '') return undefined;
            const selectedID = (_a = candidatePairs.get(selectedCandidatePairId)) === null || _a === void 0 ? void 0 : _a.remoteCandidateId;
            if (selectedID === undefined) return undefined;
            return candidates.get(selectedID);
        });
    }
    setMungedSDP(sd, munged, remote) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (munged) {
                const originalSdp = sd.sdp;
                sd.sdp = munged;
                try {
                    this.log.debug("setting munged ".concat(remote ? 'remote' : 'local', " description"), this.logContext);
                    if (remote) yield this.pc.setRemoteDescription(sd);
                    else yield this.pc.setLocalDescription(sd);
                    return;
                } catch (e) {
                    this.log.warn("not able to set ".concat(sd.type, ", falling back to unmodified sdp"), Object.assign(Object.assign({}, this.logContext), {
                        error: e,
                        sdp: munged
                    }));
                    sd.sdp = originalSdp;
                }
            }
            try {
                if (remote) yield this.pc.setRemoteDescription(sd);
                else yield this.pc.setLocalDescription(sd);
            } catch (e) {
                let msg = 'unknown error';
                if (e instanceof Error) msg = e.message;
                else if (typeof e === 'string') msg = e;
                const fields = {
                    error: msg,
                    sdp: sd.sdp
                };
                if (!remote && this.pc.remoteDescription) fields.remoteSdp = this.pc.remoteDescription;
                this.log.error("unable to set ".concat(sd.type), Object.assign(Object.assign({}, this.logContext), {
                    fields: fields
                }));
                throw new $2d7d9af7a5367cf4$export$18c2792bacf23e39(msg);
            }
        });
    }
    ensureVideoDDExtensionForSVC(media, sdp) {
        var _a, _b;
        const ddFound = (_a = media.ext) === null || _a === void 0 ? void 0 : _a.some((ext)=>{
            if (ext.uri === $2d7d9af7a5367cf4$var$ddExtensionURI) return true;
            return false;
        });
        if (!ddFound) {
            if (this.ddExtID === 0) {
                let maxID = 0;
                sdp.media.forEach((m)=>{
                    var _a;
                    if (m.type !== 'video') return;
                    (_a = m.ext) === null || _a === void 0 || _a.forEach((ext)=>{
                        if (ext.value > maxID) maxID = ext.value;
                    });
                });
                this.ddExtID = maxID + 1;
            }
            (_b = media.ext) === null || _b === void 0 || _b.push({
                value: this.ddExtID,
                uri: $2d7d9af7a5367cf4$var$ddExtensionURI
            });
        }
    }
}
function $2d7d9af7a5367cf4$var$ensureAudioNackAndStereo(media, stereoMids, nackMids) {
    // found opus codec to add nack fb
    let opusPayload = 0;
    media.rtp.some((rtp)=>{
        if (rtp.codec === 'opus') {
            opusPayload = rtp.payload;
            return true;
        }
        return false;
    });
    // add nack rtcpfb if not exist
    if (opusPayload > 0) {
        if (!media.rtcpFb) media.rtcpFb = [];
        if (nackMids.includes(media.mid) && !media.rtcpFb.some((fb)=>fb.payload === opusPayload && fb.type === 'nack')) media.rtcpFb.push({
            payload: opusPayload,
            type: 'nack'
        });
        if (stereoMids.includes(media.mid)) media.fmtp.some((fmtp)=>{
            if (fmtp.payload === opusPayload) {
                if (!fmtp.config.includes('stereo=1')) fmtp.config += ';stereo=1';
                return true;
            }
            return false;
        });
    }
}
function $2d7d9af7a5367cf4$var$extractStereoAndNackAudioFromOffer(offer) {
    var _a;
    const stereoMids = [];
    const nackMids = [];
    const sdpParsed = $2d7d9af7a5367cf4$var$libExports.parse((_a = offer.sdp) !== null && _a !== void 0 ? _a : '');
    let opusPayload = 0;
    sdpParsed.media.forEach((media)=>{
        var _a;
        if (media.type === 'audio') {
            media.rtp.some((rtp)=>{
                if (rtp.codec === 'opus') {
                    opusPayload = rtp.payload;
                    return true;
                }
                return false;
            });
            if ((_a = media.rtcpFb) === null || _a === void 0 ? void 0 : _a.some((fb)=>fb.payload === opusPayload && fb.type === 'nack')) nackMids.push(media.mid);
            media.fmtp.some((fmtp)=>{
                if (fmtp.payload === opusPayload) {
                    if (fmtp.config.includes('sprop-stereo=1')) stereoMids.push(media.mid);
                    return true;
                }
                return false;
            });
        }
    });
    return {
        stereoMids: stereoMids,
        nackMids: nackMids
    };
}
function $2d7d9af7a5367cf4$var$ensureIPAddrMatchVersion(media) {
    // Chrome could generate sdp with c = IN IP4 <ipv6 addr>
    // in edge case and return error when set sdp.This is not a
    // sdk error but correct it if the issue detected.
    if (media.connection) {
        const isV6 = media.connection.ip.indexOf(':') >= 0;
        if (media.connection.version === 4 && isV6 || media.connection.version === 6 && !isV6) {
            // fallback to dummy address
            media.connection.ip = '0.0.0.0';
            media.connection.version = 4;
        }
    }
}
const $2d7d9af7a5367cf4$var$defaultVideoCodec = 'vp8';
const $2d7d9af7a5367cf4$var$publishDefaults = {
    audioPreset: $2d7d9af7a5367cf4$export$5da93632511fdb1f.music,
    dtx: true,
    red: true,
    forceStereo: false,
    simulcast: true,
    screenShareEncoding: $2d7d9af7a5367cf4$export$a6cdf9dcd3d32f2d.h1080fps15.encoding,
    stopMicTrackOnMute: false,
    videoCodec: $2d7d9af7a5367cf4$var$defaultVideoCodec,
    backupCodec: true
};
const $2d7d9af7a5367cf4$var$audioDefaults = {
    autoGainControl: true,
    echoCancellation: true,
    noiseSuppression: true,
    voiceIsolation: true
};
const $2d7d9af7a5367cf4$var$videoDefaults = {
    resolution: $2d7d9af7a5367cf4$export$79d56065dad1674c.h720.resolution
};
const $2d7d9af7a5367cf4$var$roomOptionDefaults = {
    adaptiveStream: false,
    dynacast: false,
    stopLocalTrackOnUnpublish: true,
    reconnectPolicy: new $2d7d9af7a5367cf4$export$97bc471d6a059e6e(),
    disconnectOnPageLeave: true,
    webAudioMix: false
};
const $2d7d9af7a5367cf4$var$roomConnectOptionDefaults = {
    autoSubscribe: true,
    maxRetries: 1,
    peerConnectionTimeout: 15000,
    websocketTimeout: 15000
};
var $2d7d9af7a5367cf4$var$PCTransportState;
(function(PCTransportState) {
    PCTransportState[PCTransportState["NEW"] = 0] = "NEW";
    PCTransportState[PCTransportState["CONNECTING"] = 1] = "CONNECTING";
    PCTransportState[PCTransportState["CONNECTED"] = 2] = "CONNECTED";
    PCTransportState[PCTransportState["FAILED"] = 3] = "FAILED";
    PCTransportState[PCTransportState["CLOSING"] = 4] = "CLOSING";
    PCTransportState[PCTransportState["CLOSED"] = 5] = "CLOSED";
})($2d7d9af7a5367cf4$var$PCTransportState || ($2d7d9af7a5367cf4$var$PCTransportState = {}));
class $2d7d9af7a5367cf4$var$PCTransportManager {
    get needsPublisher() {
        return this.isPublisherConnectionRequired;
    }
    get needsSubscriber() {
        return this.isSubscriberConnectionRequired;
    }
    get currentState() {
        return this.state;
    }
    constructor(rtcConfig, subscriberPrimary, loggerOptions){
        var _a;
        this.peerConnectionTimeout = $2d7d9af7a5367cf4$var$roomConnectOptionDefaults.peerConnectionTimeout;
        this.log = $2d7d9af7a5367cf4$var$livekitLogger;
        this.updateState = ()=>{
            var _a;
            const previousState = this.state;
            const connectionStates = this.requiredTransports.map((tr)=>tr.getConnectionState());
            if (connectionStates.every((st)=>st === 'connected')) this.state = $2d7d9af7a5367cf4$var$PCTransportState.CONNECTED;
            else if (connectionStates.some((st)=>st === 'failed')) this.state = $2d7d9af7a5367cf4$var$PCTransportState.FAILED;
            else if (connectionStates.some((st)=>st === 'connecting')) this.state = $2d7d9af7a5367cf4$var$PCTransportState.CONNECTING;
            else if (connectionStates.every((st)=>st === 'closed')) this.state = $2d7d9af7a5367cf4$var$PCTransportState.CLOSED;
            else if (connectionStates.some((st)=>st === 'closed')) this.state = $2d7d9af7a5367cf4$var$PCTransportState.CLOSING;
            else if (connectionStates.every((st)=>st === 'new')) this.state = $2d7d9af7a5367cf4$var$PCTransportState.NEW;
            if (previousState !== this.state) {
                this.log.debug("pc state change: from ".concat($2d7d9af7a5367cf4$var$PCTransportState[previousState], " to ").concat($2d7d9af7a5367cf4$var$PCTransportState[this.state]), this.logContext);
                (_a = this.onStateChange) === null || _a === void 0 || _a.call(this, this.state, this.publisher.getConnectionState(), this.subscriber.getConnectionState());
            }
        };
        this.log = $2d7d9af7a5367cf4$export$2b1d391cd05230fd((_a = loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $2d7d9af7a5367cf4$export$69ba24dd79f4da21.PCManager);
        this.loggerOptions = loggerOptions;
        this.isPublisherConnectionRequired = !subscriberPrimary;
        this.isSubscriberConnectionRequired = subscriberPrimary;
        this.publisher = new $2d7d9af7a5367cf4$var$PCTransport(rtcConfig, loggerOptions);
        this.subscriber = new $2d7d9af7a5367cf4$var$PCTransport(rtcConfig, loggerOptions);
        this.publisher.onConnectionStateChange = this.updateState;
        this.subscriber.onConnectionStateChange = this.updateState;
        this.publisher.onIceConnectionStateChange = this.updateState;
        this.subscriber.onIceConnectionStateChange = this.updateState;
        this.publisher.onSignalingStatechange = this.updateState;
        this.subscriber.onSignalingStatechange = this.updateState;
        this.publisher.onIceCandidate = (candidate)=>{
            var _a;
            (_a = this.onIceCandidate) === null || _a === void 0 || _a.call(this, candidate, $2d7d9af7a5367cf4$var$SignalTarget.PUBLISHER);
        };
        this.subscriber.onIceCandidate = (candidate)=>{
            var _a;
            (_a = this.onIceCandidate) === null || _a === void 0 || _a.call(this, candidate, $2d7d9af7a5367cf4$var$SignalTarget.SUBSCRIBER);
        };
        // in subscriber primary mode, server side opens sub data channels.
        this.subscriber.onDataChannel = (ev)=>{
            var _a;
            (_a = this.onDataChannel) === null || _a === void 0 || _a.call(this, ev);
        };
        this.subscriber.onTrack = (ev)=>{
            var _a;
            (_a = this.onTrack) === null || _a === void 0 || _a.call(this, ev);
        };
        this.publisher.onOffer = (offer)=>{
            var _a;
            (_a = this.onPublisherOffer) === null || _a === void 0 || _a.call(this, offer);
        };
        this.state = $2d7d9af7a5367cf4$var$PCTransportState.NEW;
        this.connectionLock = new $2d7d9af7a5367cf4$export$ca12f2943758ef55();
        this.remoteOfferLock = new $2d7d9af7a5367cf4$export$ca12f2943758ef55();
    }
    get logContext() {
        var _a, _b;
        return Object.assign({}, (_b = (_a = this.loggerOptions).loggerContextCb) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    requirePublisher() {
        let require1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.isPublisherConnectionRequired = require1;
        this.updateState();
    }
    requireSubscriber() {
        let require1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.isSubscriberConnectionRequired = require1;
        this.updateState();
    }
    createAndSendPublisherOffer(options) {
        return this.publisher.createAndSendOffer(options);
    }
    setPublisherAnswer(sd) {
        return this.publisher.setRemoteDescription(sd);
    }
    removeTrack(sender) {
        return this.publisher.removeTrack(sender);
    }
    close() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (this.publisher && this.publisher.getSignallingState() !== 'closed') {
                const publisher = this.publisher;
                for (const sender of publisher.getSenders())try {
                    // TODO: react-native-webrtc doesn't have removeTrack yet.
                    if (publisher.canRemoveTrack()) publisher.removeTrack(sender);
                } catch (e) {
                    this.log.warn('could not removeTrack', Object.assign(Object.assign({}, this.logContext), {
                        error: e
                    }));
                }
            }
            yield Promise.all([
                this.publisher.close(),
                this.subscriber.close()
            ]);
            this.updateState();
        });
    }
    triggerIceRestart() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            this.subscriber.restartingIce = true;
            // only restart publisher if it's needed
            if (this.needsPublisher) yield this.createAndSendPublisherOffer({
                iceRestart: true
            });
        });
    }
    addIceCandidate(candidate, target) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (target === $2d7d9af7a5367cf4$var$SignalTarget.PUBLISHER) yield this.publisher.addIceCandidate(candidate);
            else yield this.subscriber.addIceCandidate(candidate);
        });
    }
    createSubscriberAnswerFromOffer(sd) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            this.log.debug('received server offer', Object.assign(Object.assign({}, this.logContext), {
                RTCSdpType: sd.type,
                sdp: sd.sdp,
                signalingState: this.subscriber.getSignallingState().toString()
            }));
            const unlock = yield this.remoteOfferLock.lock();
            try {
                yield this.subscriber.setRemoteDescription(sd);
                // answer the offer
                const answer = yield this.subscriber.createAndSetAnswer();
                return answer;
            } finally{
                unlock();
            }
        });
    }
    updateConfiguration(config, iceRestart) {
        this.publisher.setConfiguration(config);
        this.subscriber.setConfiguration(config);
        if (iceRestart) this.triggerIceRestart();
    }
    ensurePCTransportConnection(abortController, timeout) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const unlock = yield this.connectionLock.lock();
            try {
                if (this.isPublisherConnectionRequired && this.publisher.getConnectionState() !== 'connected' && this.publisher.getConnectionState() !== 'connecting') {
                    this.log.debug('negotiation required, start negotiating', this.logContext);
                    this.publisher.negotiate();
                }
                yield Promise.all((_a = this.requiredTransports) === null || _a === void 0 ? void 0 : _a.map((transport)=>this.ensureTransportConnected(transport, abortController, timeout)));
            } finally{
                unlock();
            }
        });
    }
    negotiate(abortController) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            return new Promise((resolve, reject)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                    const negotiationTimeout = setTimeout(()=>{
                        reject('negotiation timed out');
                    }, this.peerConnectionTimeout);
                    const abortHandler = ()=>{
                        clearTimeout(negotiationTimeout);
                        reject('negotiation aborted');
                    };
                    abortController.signal.addEventListener('abort', abortHandler);
                    this.publisher.once($2d7d9af7a5367cf4$var$PCEvents.NegotiationStarted, ()=>{
                        if (abortController.signal.aborted) return;
                        this.publisher.once($2d7d9af7a5367cf4$var$PCEvents.NegotiationComplete, ()=>{
                            clearTimeout(negotiationTimeout);
                            resolve();
                        });
                    });
                    yield this.publisher.negotiate((e)=>{
                        clearTimeout(negotiationTimeout);
                        reject(e);
                    });
                }));
        });
    }
    addPublisherTransceiver(track, transceiverInit) {
        return this.publisher.addTransceiver(track, transceiverInit);
    }
    addPublisherTrack(track) {
        return this.publisher.addTrack(track);
    }
    createPublisherDataChannel(label, dataChannelDict) {
        return this.publisher.createDataChannel(label, dataChannelDict);
    }
    /**
   * Returns the first required transport's address if no explicit target is specified
   */ getConnectedAddress(target) {
        if (target === $2d7d9af7a5367cf4$var$SignalTarget.PUBLISHER) return this.publisher.getConnectedAddress();
        else if (target === $2d7d9af7a5367cf4$var$SignalTarget.SUBSCRIBER) return this.publisher.getConnectedAddress();
        return this.requiredTransports[0].getConnectedAddress();
    }
    get requiredTransports() {
        const transports = [];
        if (this.isPublisherConnectionRequired) transports.push(this.publisher);
        if (this.isSubscriberConnectionRequired) transports.push(this.subscriber);
        return transports;
    }
    ensureTransportConnected(pcTransport_1, abortController_1) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function(pcTransport, abortController) {
            var _this = this;
            let timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.peerConnectionTimeout;
            return function*() {
                const connectionState = pcTransport.getConnectionState();
                if (connectionState === 'connected') return;
                return new Promise((resolve, reject)=>$2d7d9af7a5367cf4$var$__awaiter(_this, void 0, void 0, function*() {
                        const abortHandler = ()=>{
                            this.log.warn('abort transport connection', this.logContext);
                            $2d7d9af7a5367cf4$export$22e737276454df96.clearTimeout(connectTimeout);
                            reject(new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb('room connection has been cancelled', $2d7d9af7a5367cf4$export$61182a0b21436b65.Cancelled));
                        };
                        if (abortController === null || abortController === void 0 ? void 0 : abortController.signal.aborted) abortHandler();
                        abortController === null || abortController === void 0 || abortController.signal.addEventListener('abort', abortHandler);
                        const connectTimeout = $2d7d9af7a5367cf4$export$22e737276454df96.setTimeout(()=>{
                            abortController === null || abortController === void 0 || abortController.signal.removeEventListener('abort', abortHandler);
                            reject(new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb('could not establish pc connection', $2d7d9af7a5367cf4$export$61182a0b21436b65.InternalError));
                        }, timeout);
                        while(this.state !== $2d7d9af7a5367cf4$var$PCTransportState.CONNECTED){
                            yield $2d7d9af7a5367cf4$var$sleep(50); // FIXME we shouldn't rely on `sleep` in the connection paths, as it invokes `setTimeout` which can be drastically throttled by browser implementations
                            if (abortController === null || abortController === void 0 ? void 0 : abortController.signal.aborted) {
                                reject(new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb('room connection has been cancelled', $2d7d9af7a5367cf4$export$61182a0b21436b65.Cancelled));
                                return;
                            }
                        }
                        $2d7d9af7a5367cf4$export$22e737276454df96.clearTimeout(connectTimeout);
                        abortController === null || abortController === void 0 || abortController.signal.removeEventListener('abort', abortHandler);
                        resolve();
                    }));
            }();
        });
    }
}
const $2d7d9af7a5367cf4$var$monitorFrequency = 2000;
function $2d7d9af7a5367cf4$var$computeBitrate(currentStats, prevStats) {
    if (!prevStats) return 0;
    let bytesNow;
    let bytesPrev;
    if ('bytesReceived' in currentStats) {
        bytesNow = currentStats.bytesReceived;
        bytesPrev = prevStats.bytesReceived;
    } else if ('bytesSent' in currentStats) {
        bytesNow = currentStats.bytesSent;
        bytesPrev = prevStats.bytesSent;
    }
    if (bytesNow === undefined || bytesPrev === undefined || currentStats.timestamp === undefined || prevStats.timestamp === undefined) return 0;
    return (bytesNow - bytesPrev) * 8000 / (currentStats.timestamp - prevStats.timestamp);
}
class $2d7d9af7a5367cf4$export$b287427b771ca237 extends $2d7d9af7a5367cf4$export$3e041ce3f33f04dd {
    /**
   * boolean indicating whether enhanced noise cancellation is currently being used on this track
   */ get enhancedNoiseCancellation() {
        return this.isKrispNoiseFilterEnabled;
    }
    /**
   *
   * @param mediaTrack
   * @param constraints MediaTrackConstraints that are being used when restarting or reacquiring tracks
   * @param userProvidedTrack Signals to the SDK whether or not the mediaTrack should be managed (i.e. released and reacquired) internally by the SDK
   */ constructor(mediaTrack, constraints){
        let userProvidedTrack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        let audioContext = arguments.length > 3 ? arguments[3] : undefined;
        let loggerOptions = arguments.length > 4 ? arguments[4] : undefined;
        super(mediaTrack, $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Audio, constraints, userProvidedTrack, loggerOptions);
        /** @internal */ this.stopOnMute = false;
        this.isKrispNoiseFilterEnabled = false;
        this.monitorSender = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.sender) {
                    this._currentBitrate = 0;
                    return;
                }
                let stats;
                try {
                    stats = yield this.getSenderStats();
                } catch (e) {
                    this.log.error('could not get audio sender stats', Object.assign(Object.assign({}, this.logContext), {
                        error: e
                    }));
                    return;
                }
                if (stats && this.prevStats) this._currentBitrate = $2d7d9af7a5367cf4$var$computeBitrate(stats, this.prevStats);
                this.prevStats = stats;
            });
        this.handleKrispNoiseFilterEnable = ()=>{
            this.isKrispNoiseFilterEnabled = true;
            this.log.debug("Krisp noise filter enabled", this.logContext);
            this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.AudioTrackFeatureUpdate, this, $2d7d9af7a5367cf4$var$AudioTrackFeature.TF_ENHANCED_NOISE_CANCELLATION, true);
        };
        this.handleKrispNoiseFilterDisable = ()=>{
            this.isKrispNoiseFilterEnabled = false;
            this.log.debug("Krisp noise filter disabled", this.logContext);
            this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.AudioTrackFeatureUpdate, this, $2d7d9af7a5367cf4$var$AudioTrackFeature.TF_ENHANCED_NOISE_CANCELLATION, false);
        };
        this.audioContext = audioContext;
        this.checkForSilence();
    }
    setDeviceId(deviceId) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (this._constraints.deviceId === deviceId && this._mediaStreamTrack.getSettings().deviceId === $2d7d9af7a5367cf4$var$unwrapConstraint(deviceId)) return true;
            this._constraints.deviceId = deviceId;
            if (!this.isMuted) yield this.restartTrack();
            return this.isMuted || $2d7d9af7a5367cf4$var$unwrapConstraint(deviceId) === this._mediaStreamTrack.getSettings().deviceId;
        });
    }
    mute() {
        const _super = Object.create(null, {
            mute: {
                get: ()=>super.mute
            }
        });
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.muteLock.lock();
            try {
                if (this.isMuted) {
                    this.log.debug('Track already muted', this.logContext);
                    return this;
                }
                // disabled special handling as it will cause BT headsets to switch communication modes
                if (this.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Microphone && this.stopOnMute && !this.isUserProvided) {
                    this.log.debug('stopping mic track', this.logContext);
                    // also stop the track, so that microphone indicator is turned off
                    this._mediaStreamTrack.stop();
                }
                yield _super.mute.call(this);
                return this;
            } finally{
                unlock();
            }
        });
    }
    unmute() {
        const _super = Object.create(null, {
            unmute: {
                get: ()=>super.unmute
            }
        });
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.muteLock.lock();
            try {
                if (!this.isMuted) {
                    this.log.debug('Track already unmuted', this.logContext);
                    return this;
                }
                const deviceHasChanged = this._constraints.deviceId && this._mediaStreamTrack.getSettings().deviceId !== $2d7d9af7a5367cf4$var$unwrapConstraint(this._constraints.deviceId);
                if (this.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Microphone && (this.stopOnMute || this._mediaStreamTrack.readyState === 'ended' || deviceHasChanged) && !this.isUserProvided) {
                    this.log.debug('reacquiring mic track', this.logContext);
                    yield this.restartTrack();
                }
                yield _super.unmute.call(this);
                return this;
            } finally{
                unlock();
            }
        });
    }
    restartTrack(options) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            let constraints;
            if (options) {
                const streamConstraints = $2d7d9af7a5367cf4$var$constraintsForOptions({
                    audio: options
                });
                if (typeof streamConstraints.audio !== 'boolean') constraints = streamConstraints.audio;
            }
            yield this.restart(constraints);
        });
    }
    restart(constraints) {
        const _super = Object.create(null, {
            restart: {
                get: ()=>super.restart
            }
        });
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const track = yield _super.restart.call(this, constraints);
            this.checkForSilence();
            return track;
        });
    }
    /* @internal */ startMonitor() {
        if (!$2d7d9af7a5367cf4$var$isWeb()) return;
        if (this.monitorInterval) return;
        this.monitorInterval = setInterval(()=>{
            this.monitorSender();
        }, $2d7d9af7a5367cf4$var$monitorFrequency);
    }
    setProcessor(processor) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const unlock = yield this.processorLock.lock();
            try {
                if (!this.audioContext) throw Error('Audio context needs to be set on LocalAudioTrack in order to enable processors');
                if (this.processor) yield this.stopProcessor();
                const processorOptions = {
                    kind: this.kind,
                    track: this._mediaStreamTrack,
                    audioContext: this.audioContext
                };
                this.log.debug("setting up audio processor ".concat(processor.name), this.logContext);
                yield processor.init(processorOptions);
                this.processor = processor;
                if (this.processor.processedTrack) {
                    yield (_a = this.sender) === null || _a === void 0 ? void 0 : _a.replaceTrack(this.processor.processedTrack);
                    this.processor.processedTrack.addEventListener('enable-lk-krisp-noise-filter', this.handleKrispNoiseFilterEnable);
                    this.processor.processedTrack.addEventListener('disable-lk-krisp-noise-filter', this.handleKrispNoiseFilterDisable);
                }
                this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.TrackProcessorUpdate, this.processor);
            } finally{
                unlock();
            }
        });
    }
    /**
   * @internal
   * @experimental
   */ setAudioContext(audioContext) {
        this.audioContext = audioContext;
    }
    getSenderStats() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!((_a = this.sender) === null || _a === void 0 ? void 0 : _a.getStats)) return undefined;
            const stats = yield this.sender.getStats();
            let audioStats;
            stats.forEach((v)=>{
                if (v.type === 'outbound-rtp') audioStats = {
                    type: 'audio',
                    streamId: v.id,
                    packetsSent: v.packetsSent,
                    packetsLost: v.packetsLost,
                    bytesSent: v.bytesSent,
                    timestamp: v.timestamp,
                    roundTripTime: v.roundTripTime,
                    jitter: v.jitter
                };
            });
            return audioStats;
        });
    }
    checkForSilence() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const trackIsSilent = yield $2d7d9af7a5367cf4$var$detectSilence(this);
            if (trackIsSilent) {
                if (!this.isMuted) this.log.warn('silence detected on local audio track', this.logContext);
                this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.AudioSilenceDetected);
            }
            return trackIsSilent;
        });
    }
}
/** @internal */ function $2d7d9af7a5367cf4$var$mediaTrackToLocalTrack(mediaStreamTrack, constraints, loggerOptions) {
    switch(mediaStreamTrack.kind){
        case 'audio':
            return new $2d7d9af7a5367cf4$export$b287427b771ca237(mediaStreamTrack, constraints, false, undefined, loggerOptions);
        case 'video':
            return new $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc(mediaStreamTrack, constraints, false, loggerOptions);
        default:
            throw new $2d7d9af7a5367cf4$export$4fbb9423b5747257("unsupported track type: ".concat(mediaStreamTrack.kind));
    }
}
/* @internal */ const $2d7d9af7a5367cf4$var$presets169 = Object.values($2d7d9af7a5367cf4$export$79d56065dad1674c);
/* @internal */ const $2d7d9af7a5367cf4$var$presets43 = Object.values($2d7d9af7a5367cf4$export$eb5fc43ecc8ee2c7);
/* @internal */ const $2d7d9af7a5367cf4$var$presetsScreenShare = Object.values($2d7d9af7a5367cf4$export$a6cdf9dcd3d32f2d);
/* @internal */ const $2d7d9af7a5367cf4$var$defaultSimulcastPresets169 = [
    $2d7d9af7a5367cf4$export$79d56065dad1674c.h180,
    $2d7d9af7a5367cf4$export$79d56065dad1674c.h360
];
/* @internal */ const $2d7d9af7a5367cf4$var$defaultSimulcastPresets43 = [
    $2d7d9af7a5367cf4$export$eb5fc43ecc8ee2c7.h180,
    $2d7d9af7a5367cf4$export$eb5fc43ecc8ee2c7.h360
];
/* @internal */ const $2d7d9af7a5367cf4$var$computeDefaultScreenShareSimulcastPresets = (fromPreset)=>{
    const layers = [
        {
            scaleResolutionDownBy: 2,
            fps: fromPreset.encoding.maxFramerate
        }
    ];
    return layers.map((t)=>{
        var _a, _b;
        return new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(Math.floor(fromPreset.width / t.scaleResolutionDownBy), Math.floor(fromPreset.height / t.scaleResolutionDownBy), Math.max(150000, Math.floor(fromPreset.encoding.maxBitrate / (Math.pow(t.scaleResolutionDownBy, 2) * (((_a = fromPreset.encoding.maxFramerate) !== null && _a !== void 0 ? _a : 30) / ((_b = t.fps) !== null && _b !== void 0 ? _b : 30))))), t.fps, fromPreset.encoding.priority);
    });
};
// /**
//  *
//  * @internal
//  * @experimental
//  */
// const computeDefaultMultiCodecSimulcastEncodings = (width: number, height: number) => {
//   // use vp8 as a default
//   const vp8 = determineAppropriateEncoding(false, width, height);
//   const vp9 = { ...vp8, maxBitrate: vp8.maxBitrate * 0.9 };
//   const h264 = { ...vp8, maxBitrate: vp8.maxBitrate * 1.1 };
//   const av1 = { ...vp8, maxBitrate: vp8.maxBitrate * 0.7 };
//   return {
//     vp8,
//     vp9,
//     h264,
//     av1,
//   };
// };
const $2d7d9af7a5367cf4$var$videoRids = [
    'q',
    'h',
    'f'
];
/* @internal */ function $2d7d9af7a5367cf4$var$computeVideoEncodings(isScreenShare, width, height, options) {
    var _a, _b;
    let videoEncoding = options === null || options === void 0 ? void 0 : options.videoEncoding;
    if (isScreenShare) videoEncoding = options === null || options === void 0 ? void 0 : options.screenShareEncoding;
    const useSimulcast = options === null || options === void 0 ? void 0 : options.simulcast;
    const scalabilityMode = options === null || options === void 0 ? void 0 : options.scalabilityMode;
    const videoCodec = options === null || options === void 0 ? void 0 : options.videoCodec;
    if (!videoEncoding && !useSimulcast && !scalabilityMode || !width || !height) // when we aren't simulcasting or svc, will need to return a single encoding without
    // capping bandwidth. we always require a encoding for dynacast
    return [
        {}
    ];
    if (!videoEncoding) {
        // find the right encoding based on width/height
        videoEncoding = $2d7d9af7a5367cf4$var$determineAppropriateEncoding(isScreenShare, width, height, videoCodec);
        $2d7d9af7a5367cf4$var$livekitLogger.debug('using video encoding', videoEncoding);
    }
    const original = new $2d7d9af7a5367cf4$export$73e76f4fd970cdf1(width, height, videoEncoding.maxBitrate, videoEncoding.maxFramerate, videoEncoding.priority);
    if (scalabilityMode && $2d7d9af7a5367cf4$var$isSVCCodec(videoCodec)) {
        const sm = new $2d7d9af7a5367cf4$var$ScalabilityMode(scalabilityMode);
        const encodings = [];
        if (sm.spatial > 3) throw new Error("unsupported scalabilityMode: ".concat(scalabilityMode));
        // Before M113 in Chrome, defining multiple encodings with an SVC codec indicated
        // that SVC mode should be used. Safari still works this way.
        // This is a bit confusing but is due to how libwebrtc interpreted the encodings field
        // before M113.
        // Announced here: https://groups.google.com/g/discuss-webrtc/c/-QQ3pxrl-fw?pli=1
        const browser = $2d7d9af7a5367cf4$export$89e15fc796a4a429();
        if ($2d7d9af7a5367cf4$var$isSafari() || // Even tho RN runs M114, it does not produce SVC layers when a single encoding
        // is provided. So we'll use the legacy SVC specification for now.
        // TODO: when we upstream libwebrtc, this will need additional verification
        $2d7d9af7a5367cf4$var$isReactNative() || (browser === null || browser === void 0 ? void 0 : browser.name) === 'Chrome' && $2d7d9af7a5367cf4$export$66e1c0999abad646(browser === null || browser === void 0 ? void 0 : browser.version, '113') < 0) {
            const bitratesRatio = sm.suffix == 'h' ? 2 : 3;
            for(let i = 0; i < sm.spatial; i += 1)// in legacy SVC, scaleResolutionDownBy cannot be set
            encodings.push({
                rid: $2d7d9af7a5367cf4$var$videoRids[2 - i],
                maxBitrate: videoEncoding.maxBitrate / Math.pow(bitratesRatio, i),
                maxFramerate: original.encoding.maxFramerate
            });
            // legacy SVC, scalabilityMode is set only on the first encoding
            /* @ts-ignore */ encodings[0].scalabilityMode = scalabilityMode;
        } else encodings.push({
            maxBitrate: videoEncoding.maxBitrate,
            maxFramerate: original.encoding.maxFramerate,
            /* @ts-ignore */ scalabilityMode: scalabilityMode
        });
        if (original.encoding.priority) {
            encodings[0].priority = original.encoding.priority;
            encodings[0].networkPriority = original.encoding.priority;
        }
        $2d7d9af7a5367cf4$var$livekitLogger.debug("using svc encoding", {
            encodings: encodings
        });
        return encodings;
    }
    if (!useSimulcast) return [
        videoEncoding
    ];
    let presets = [];
    if (isScreenShare) presets = (_a = $2d7d9af7a5367cf4$var$sortPresets(options === null || options === void 0 ? void 0 : options.screenShareSimulcastLayers)) !== null && _a !== void 0 ? _a : $2d7d9af7a5367cf4$var$defaultSimulcastLayers(isScreenShare, original);
    else presets = (_b = $2d7d9af7a5367cf4$var$sortPresets(options === null || options === void 0 ? void 0 : options.videoSimulcastLayers)) !== null && _b !== void 0 ? _b : $2d7d9af7a5367cf4$var$defaultSimulcastLayers(isScreenShare, original);
    let midPreset;
    if (presets.length > 0) {
        const lowPreset = presets[0];
        if (presets.length > 1) [, midPreset] = presets;
        // NOTE:
        //   1. Ordering of these encodings is important. Chrome seems
        //      to use the index into encodings to decide which layer
        //      to disable when CPU constrained.
        //      So encodings should be ordered in increasing spatial
        //      resolution order.
        //   2. livekit-server translates rids into layers. So, all encodings
        //      should have the base layer `q` and then more added
        //      based on other conditions.
        const size = Math.max(width, height);
        if (size >= 960 && midPreset) return $2d7d9af7a5367cf4$var$encodingsFromPresets(width, height, [
            lowPreset,
            midPreset,
            original
        ]);
        if (size >= 480) return $2d7d9af7a5367cf4$var$encodingsFromPresets(width, height, [
            lowPreset,
            original
        ]);
    }
    return $2d7d9af7a5367cf4$var$encodingsFromPresets(width, height, [
        original
    ]);
}
function $2d7d9af7a5367cf4$var$computeTrackBackupEncodings(track, videoCodec, opts) {
    var _a, _b, _c, _d;
    // backupCodec should not be true anymore, default codec is set in LocalParticipant.publish
    if (!opts.backupCodec || opts.backupCodec === true || opts.backupCodec.codec === opts.videoCodec) // backup codec publishing is disabled
    return;
    if (videoCodec !== opts.backupCodec.codec) $2d7d9af7a5367cf4$var$livekitLogger.warn('requested a different codec than specified as backup', {
        serverRequested: videoCodec,
        backup: opts.backupCodec.codec
    });
    opts.videoCodec = videoCodec;
    // use backup encoding setting as videoEncoding for backup codec publishing
    opts.videoEncoding = opts.backupCodec.encoding;
    const settings = track.mediaStreamTrack.getSettings();
    const width = (_a = settings.width) !== null && _a !== void 0 ? _a : (_b = track.dimensions) === null || _b === void 0 ? void 0 : _b.width;
    const height = (_c = settings.height) !== null && _c !== void 0 ? _c : (_d = track.dimensions) === null || _d === void 0 ? void 0 : _d.height;
    const encodings = $2d7d9af7a5367cf4$var$computeVideoEncodings(track.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShare, width, height, opts);
    return encodings;
}
/* @internal */ function $2d7d9af7a5367cf4$var$determineAppropriateEncoding(isScreenShare, width, height, codec) {
    const presets = $2d7d9af7a5367cf4$var$presetsForResolution(isScreenShare, width, height);
    let { encoding: encoding } = presets[0];
    // handle portrait by swapping dimensions
    const size = Math.max(width, height);
    for(let i = 0; i < presets.length; i += 1){
        const preset = presets[i];
        encoding = preset.encoding;
        if (preset.width >= size) break;
    }
    // presets are based on the assumption of vp8 as a codec
    // for other codecs we adjust the maxBitrate if no specific videoEncoding has been provided
    // users should override these with ones that are optimized for their use case
    // NOTE: SVC codec bitrates are inclusive of all scalability layers. while
    // bitrate for non-SVC codecs does not include other simulcast layers.
    if (codec) switch(codec){
        case 'av1':
            encoding = Object.assign({}, encoding);
            encoding.maxBitrate = encoding.maxBitrate * 0.7;
            break;
        case 'vp9':
            encoding = Object.assign({}, encoding);
            encoding.maxBitrate = encoding.maxBitrate * 0.85;
            break;
    }
    return encoding;
}
/* @internal */ function $2d7d9af7a5367cf4$var$presetsForResolution(isScreenShare, width, height) {
    if (isScreenShare) return $2d7d9af7a5367cf4$var$presetsScreenShare;
    const aspect = width > height ? width / height : height / width;
    if (Math.abs(aspect - 16.0 / 9) < Math.abs(aspect - 4.0 / 3)) return $2d7d9af7a5367cf4$var$presets169;
    return $2d7d9af7a5367cf4$var$presets43;
}
/* @internal */ function $2d7d9af7a5367cf4$var$defaultSimulcastLayers(isScreenShare, original) {
    if (isScreenShare) return $2d7d9af7a5367cf4$var$computeDefaultScreenShareSimulcastPresets(original);
    const { width: width, height: height } = original;
    const aspect = width > height ? width / height : height / width;
    if (Math.abs(aspect - 16.0 / 9) < Math.abs(aspect - 4.0 / 3)) return $2d7d9af7a5367cf4$var$defaultSimulcastPresets169;
    return $2d7d9af7a5367cf4$var$defaultSimulcastPresets43;
}
// presets should be ordered by low, medium, high
function $2d7d9af7a5367cf4$var$encodingsFromPresets(width, height, presets) {
    const encodings = [];
    presets.forEach((preset, idx)=>{
        if (idx >= $2d7d9af7a5367cf4$var$videoRids.length) return;
        const size = Math.min(width, height);
        const rid = $2d7d9af7a5367cf4$var$videoRids[idx];
        const encoding = {
            rid: rid,
            scaleResolutionDownBy: Math.max(1, size / Math.min(preset.width, preset.height)),
            maxBitrate: preset.encoding.maxBitrate
        };
        if (preset.encoding.maxFramerate) encoding.maxFramerate = preset.encoding.maxFramerate;
        const canSetPriority = $2d7d9af7a5367cf4$var$isFireFox() || idx === 0;
        if (preset.encoding.priority && canSetPriority) {
            encoding.priority = preset.encoding.priority;
            encoding.networkPriority = preset.encoding.priority;
        }
        encodings.push(encoding);
    });
    // RN ios simulcast requires all same framerates.
    if ($2d7d9af7a5367cf4$var$isReactNative() && $2d7d9af7a5367cf4$var$getReactNativeOs() === 'ios') {
        let topFramerate = undefined;
        encodings.forEach((encoding)=>{
            if (!topFramerate) topFramerate = encoding.maxFramerate;
            else if (encoding.maxFramerate && encoding.maxFramerate > topFramerate) topFramerate = encoding.maxFramerate;
        });
        let notifyOnce = true;
        encodings.forEach((encoding)=>{
            var _a;
            if (encoding.maxFramerate != topFramerate) {
                if (notifyOnce) {
                    notifyOnce = false;
                    $2d7d9af7a5367cf4$var$livekitLogger.info("Simulcast on iOS React-Native requires all encodings to share the same framerate.");
                }
                $2d7d9af7a5367cf4$var$livekitLogger.info("Setting framerate of encoding \"".concat((_a = encoding.rid) !== null && _a !== void 0 ? _a : '', "\" to ").concat(topFramerate));
                encoding.maxFramerate = topFramerate;
            }
        });
    }
    return encodings;
}
/** @internal */ function $2d7d9af7a5367cf4$var$sortPresets(presets) {
    if (!presets) return;
    return presets.sort((a, b)=>{
        const { encoding: aEnc } = a;
        const { encoding: bEnc } = b;
        if (aEnc.maxBitrate > bEnc.maxBitrate) return 1;
        if (aEnc.maxBitrate < bEnc.maxBitrate) return -1;
        if (aEnc.maxBitrate === bEnc.maxBitrate && aEnc.maxFramerate && bEnc.maxFramerate) return aEnc.maxFramerate > bEnc.maxFramerate ? 1 : -1;
        return 0;
    });
}
/** @internal */ class $2d7d9af7a5367cf4$var$ScalabilityMode {
    constructor(scalabilityMode){
        const results = scalabilityMode.match(/^L(\d)T(\d)(h|_KEY|_KEY_SHIFT){0,1}$/);
        if (!results) throw new Error('invalid scalability mode');
        this.spatial = parseInt(results[1]);
        this.temporal = parseInt(results[2]);
        if (results.length > 3) switch(results[3]){
            case 'h':
            case '_KEY':
            case '_KEY_SHIFT':
                this.suffix = results[3];
        }
    }
    toString() {
        var _a;
        return "L".concat(this.spatial, "T").concat(this.temporal).concat((_a = this.suffix) !== null && _a !== void 0 ? _a : '');
    }
}
function $2d7d9af7a5367cf4$var$getDefaultDegradationPreference(track) {
    // a few of reasons we have different default paths:
    // 1. without this, Chrome seems to aggressively resize the SVC video stating `quality-limitation: bandwidth` even when BW isn't an issue
    // 2. since we are overriding contentHint to motion (to workaround L1T3 publishing), it overrides the default degradationPreference to `balanced`
    if (track.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShare || track.constraints.height && $2d7d9af7a5367cf4$var$unwrapConstraint(track.constraints.height) >= 1080) return 'maintain-resolution';
    else return 'balanced';
}
const $2d7d9af7a5367cf4$var$refreshSubscribedCodecAfterNewCodec = 5000;
class $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc extends $2d7d9af7a5367cf4$export$3e041ce3f33f04dd {
    get sender() {
        return this._sender;
    }
    set sender(sender) {
        this._sender = sender;
        if (this.degradationPreference) this.setDegradationPreference(this.degradationPreference);
    }
    /**
   *
   * @param mediaTrack
   * @param constraints MediaTrackConstraints that are being used when restarting or reacquiring tracks
   * @param userProvidedTrack Signals to the SDK whether or not the mediaTrack should be managed (i.e. released and reacquired) internally by the SDK
   */ constructor(mediaTrack, constraints){
        let userProvidedTrack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        let loggerOptions = arguments.length > 3 ? arguments[3] : undefined;
        super(mediaTrack, $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video, constraints, userProvidedTrack, loggerOptions);
        /* @internal */ this.simulcastCodecs = new Map();
        this.degradationPreference = 'balanced';
        this.monitorSender = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.sender) {
                    this._currentBitrate = 0;
                    return;
                }
                let stats;
                try {
                    stats = yield this.getSenderStats();
                } catch (e) {
                    this.log.error('could not get audio sender stats', Object.assign(Object.assign({}, this.logContext), {
                        error: e
                    }));
                    return;
                }
                const statsMap = new Map(stats.map((s)=>[
                        s.rid,
                        s
                    ]));
                if (this.prevStats) {
                    let totalBitrate = 0;
                    statsMap.forEach((s, key)=>{
                        var _a;
                        const prev = (_a = this.prevStats) === null || _a === void 0 ? void 0 : _a.get(key);
                        totalBitrate += $2d7d9af7a5367cf4$var$computeBitrate(s, prev);
                    });
                    this._currentBitrate = totalBitrate;
                }
                this.prevStats = statsMap;
            });
        this.senderLock = new $2d7d9af7a5367cf4$export$ca12f2943758ef55();
    }
    get isSimulcast() {
        if (this.sender && this.sender.getParameters().encodings.length > 1) return true;
        return false;
    }
    /* @internal */ startMonitor(signalClient) {
        var _a;
        this.signalClient = signalClient;
        if (!$2d7d9af7a5367cf4$var$isWeb()) return;
        // save original encodings
        // TODO : merge simulcast tracks stats
        const params = (_a = this.sender) === null || _a === void 0 ? void 0 : _a.getParameters();
        if (params) this.encodings = params.encodings;
        if (this.monitorInterval) return;
        this.monitorInterval = setInterval(()=>{
            this.monitorSender();
        }, $2d7d9af7a5367cf4$var$monitorFrequency);
    }
    stop() {
        this._mediaStreamTrack.getConstraints();
        this.simulcastCodecs.forEach((trackInfo)=>{
            trackInfo.mediaStreamTrack.stop();
        });
        super.stop();
    }
    pauseUpstream() {
        const _super = Object.create(null, {
            pauseUpstream: {
                get: ()=>super.pauseUpstream
            }
        });
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, e_1, _b, _c;
            var _d;
            yield _super.pauseUpstream.call(this);
            try {
                for(var _e = true, _f = $2d7d9af7a5367cf4$var$__asyncValues(this.simulcastCodecs.values()), _g; _g = yield _f.next(), _a = _g.done, !_a; _e = true){
                    _c = _g.value;
                    _e = false;
                    const sc = _c;
                    yield (_d = sc.sender) === null || _d === void 0 ? void 0 : _d.replaceTrack(null);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (!_e && !_a && (_b = _f.return)) yield _b.call(_f);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        });
    }
    resumeUpstream() {
        const _super = Object.create(null, {
            resumeUpstream: {
                get: ()=>super.resumeUpstream
            }
        });
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, e_2, _b, _c;
            var _d;
            yield _super.resumeUpstream.call(this);
            try {
                for(var _e = true, _f = $2d7d9af7a5367cf4$var$__asyncValues(this.simulcastCodecs.values()), _g; _g = yield _f.next(), _a = _g.done, !_a; _e = true){
                    _c = _g.value;
                    _e = false;
                    const sc = _c;
                    yield (_d = sc.sender) === null || _d === void 0 ? void 0 : _d.replaceTrack(sc.mediaStreamTrack);
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (!_e && !_a && (_b = _f.return)) yield _b.call(_f);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        });
    }
    mute() {
        const _super = Object.create(null, {
            mute: {
                get: ()=>super.mute
            }
        });
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.muteLock.lock();
            try {
                if (this.isMuted) {
                    this.log.debug('Track already muted', this.logContext);
                    return this;
                }
                if (this.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Camera && !this.isUserProvided) {
                    this.log.debug('stopping camera track', this.logContext);
                    // also stop the track, so that camera indicator is turned off
                    this._mediaStreamTrack.stop();
                }
                yield _super.mute.call(this);
                return this;
            } finally{
                unlock();
            }
        });
    }
    unmute() {
        const _super = Object.create(null, {
            unmute: {
                get: ()=>super.unmute
            }
        });
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.muteLock.lock();
            try {
                if (!this.isMuted) {
                    this.log.debug('Track already unmuted', this.logContext);
                    return this;
                }
                if (this.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Camera && !this.isUserProvided) {
                    this.log.debug('reacquiring camera track', this.logContext);
                    yield this.restartTrack();
                }
                yield _super.unmute.call(this);
                return this;
            } finally{
                unlock();
            }
        });
    }
    setTrackMuted(muted) {
        super.setTrackMuted(muted);
        for (const sc of this.simulcastCodecs.values())sc.mediaStreamTrack.enabled = !muted;
    }
    getSenderStats() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!((_a = this.sender) === null || _a === void 0 ? void 0 : _a.getStats)) return [];
            const items = [];
            const stats = yield this.sender.getStats();
            stats.forEach((v)=>{
                var _a;
                if (v.type === 'outbound-rtp') {
                    const vs = {
                        type: 'video',
                        streamId: v.id,
                        frameHeight: v.frameHeight,
                        frameWidth: v.frameWidth,
                        framesPerSecond: v.framesPerSecond,
                        framesSent: v.framesSent,
                        firCount: v.firCount,
                        pliCount: v.pliCount,
                        nackCount: v.nackCount,
                        packetsSent: v.packetsSent,
                        bytesSent: v.bytesSent,
                        qualityLimitationReason: v.qualityLimitationReason,
                        qualityLimitationDurations: v.qualityLimitationDurations,
                        qualityLimitationResolutionChanges: v.qualityLimitationResolutionChanges,
                        rid: (_a = v.rid) !== null && _a !== void 0 ? _a : v.id,
                        retransmittedPacketsSent: v.retransmittedPacketsSent,
                        targetBitrate: v.targetBitrate,
                        timestamp: v.timestamp
                    };
                    // locate the appropriate remote-inbound-rtp item
                    const r = stats.get(v.remoteId);
                    if (r) {
                        vs.jitter = r.jitter;
                        vs.packetsLost = r.packetsLost;
                        vs.roundTripTime = r.roundTripTime;
                    }
                    items.push(vs);
                }
            });
            // make sure highest res layer is always first
            items.sort((a, b)=>{
                var _a, _b;
                return ((_a = b.frameWidth) !== null && _a !== void 0 ? _a : 0) - ((_b = a.frameWidth) !== null && _b !== void 0 ? _b : 0);
            });
            return items;
        });
    }
    setPublishingQuality(maxQuality) {
        const qualities = [];
        for(let q = $2d7d9af7a5367cf4$export$a8f593954e806155.LOW; q <= $2d7d9af7a5367cf4$export$a8f593954e806155.HIGH; q += 1)qualities.push(new $2d7d9af7a5367cf4$var$SubscribedQuality({
            quality: q,
            enabled: q <= maxQuality
        }));
        this.log.debug("setting publishing quality. max quality ".concat(maxQuality), this.logContext);
        this.setPublishingLayers(qualities);
    }
    setDeviceId(deviceId) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (this._constraints.deviceId === deviceId && this._mediaStreamTrack.getSettings().deviceId === $2d7d9af7a5367cf4$var$unwrapConstraint(deviceId)) return true;
            this._constraints.deviceId = deviceId;
            // when video is muted, underlying media stream track is stopped and
            // will be restarted later
            if (!this.isMuted) yield this.restartTrack();
            return this.isMuted || $2d7d9af7a5367cf4$var$unwrapConstraint(deviceId) === this._mediaStreamTrack.getSettings().deviceId;
        });
    }
    restartTrack(options) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, e_3, _b, _c;
            let constraints;
            if (options) {
                const streamConstraints = $2d7d9af7a5367cf4$var$constraintsForOptions({
                    video: options
                });
                if (typeof streamConstraints.video !== 'boolean') constraints = streamConstraints.video;
            }
            yield this.restart(constraints);
            try {
                for(var _d = true, _e = $2d7d9af7a5367cf4$var$__asyncValues(this.simulcastCodecs.values()), _f; _f = yield _e.next(), _a = _f.done, !_a; _d = true){
                    _c = _f.value;
                    _d = false;
                    const sc = _c;
                    if (sc.sender) {
                        sc.mediaStreamTrack = this.mediaStreamTrack.clone();
                        yield sc.sender.replaceTrack(sc.mediaStreamTrack);
                    }
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (!_d && !_a && (_b = _e.return)) yield _b.call(_e);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
        });
    }
    setProcessor(processor_1) {
        const _super = Object.create(null, {
            setProcessor: {
                get: ()=>super.setProcessor
            }
        });
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function(processor) {
            var _this = this;
            let showProcessedStreamLocally = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return function*() {
                var _a, e_4, _b, _c;
                var _d, _e;
                yield _super.setProcessor.call(_this, processor, showProcessedStreamLocally);
                if ((_d = _this.processor) === null || _d === void 0 ? void 0 : _d.processedTrack) try {
                    for(var _f = true, _g = $2d7d9af7a5367cf4$var$__asyncValues(_this.simulcastCodecs.values()), _h; _h = yield _g.next(), _a = _h.done, !_a; _f = true){
                        _c = _h.value;
                        _f = false;
                        const sc = _c;
                        yield (_e = sc.sender) === null || _e === void 0 ? void 0 : _e.replaceTrack(_this.processor.processedTrack);
                    }
                } catch (e_4_1) {
                    e_4 = {
                        error: e_4_1
                    };
                } finally{
                    try {
                        if (!_f && !_a && (_b = _g.return)) yield _b.call(_g);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                }
            }();
        });
    }
    setDegradationPreference(preference) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            this.degradationPreference = preference;
            if (this.sender) try {
                this.log.debug("setting degradationPreference to ".concat(preference), this.logContext);
                const params = this.sender.getParameters();
                params.degradationPreference = preference;
                this.sender.setParameters(params);
            } catch (e) {
                this.log.warn("failed to set degradationPreference", Object.assign({
                    error: e
                }, this.logContext));
            }
        });
    }
    addSimulcastTrack(codec, encodings) {
        if (this.simulcastCodecs.has(codec)) {
            this.log.error("".concat(codec, " already added, skipping adding simulcast codec"), this.logContext);
            return;
        }
        const simulcastCodecInfo = {
            codec: codec,
            mediaStreamTrack: this.mediaStreamTrack.clone(),
            sender: undefined,
            encodings: encodings
        };
        this.simulcastCodecs.set(codec, simulcastCodecInfo);
        return simulcastCodecInfo;
    }
    setSimulcastTrackSender(codec, sender) {
        const simulcastCodecInfo = this.simulcastCodecs.get(codec);
        if (!simulcastCodecInfo) return;
        simulcastCodecInfo.sender = sender;
        // browser will reenable disabled codec/layers after new codec has been published,
        // so refresh subscribedCodecs after publish a new codec
        setTimeout(()=>{
            if (this.subscribedCodecs) this.setPublishingCodecs(this.subscribedCodecs);
        }, $2d7d9af7a5367cf4$var$refreshSubscribedCodecAfterNewCodec);
    }
    /**
   * @internal
   * Sets codecs that should be publishing, returns new codecs that have not yet
   * been published
   */ setPublishingCodecs(codecs) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, codecs_1, codecs_1_1;
            var _b, e_5, _c, _d;
            this.log.debug('setting publishing codecs', Object.assign(Object.assign({}, this.logContext), {
                codecs: codecs,
                currentCodec: this.codec
            }));
            // only enable simulcast codec for preference codec setted
            if (!this.codec && codecs.length > 0) {
                yield this.setPublishingLayers(codecs[0].qualities);
                return [];
            }
            this.subscribedCodecs = codecs;
            const newCodecs = [];
            try {
                for(_a = true, codecs_1 = $2d7d9af7a5367cf4$var$__asyncValues(codecs); codecs_1_1 = yield codecs_1.next(), _b = codecs_1_1.done, !_b; _a = true){
                    _d = codecs_1_1.value;
                    _a = false;
                    const codec = _d;
                    if (!this.codec || this.codec === codec.codec) yield this.setPublishingLayers(codec.qualities);
                    else {
                        const simulcastCodecInfo = this.simulcastCodecs.get(codec.codec);
                        this.log.debug("try setPublishingCodec for ".concat(codec.codec), Object.assign(Object.assign({}, this.logContext), {
                            simulcastCodecInfo: simulcastCodecInfo
                        }));
                        if (!simulcastCodecInfo || !simulcastCodecInfo.sender) {
                            for (const q of codec.qualities)if (q.enabled) {
                                newCodecs.push(codec.codec);
                                break;
                            }
                        } else if (simulcastCodecInfo.encodings) {
                            this.log.debug("try setPublishingLayersForSender ".concat(codec.codec), this.logContext);
                            yield $2d7d9af7a5367cf4$var$setPublishingLayersForSender(simulcastCodecInfo.sender, simulcastCodecInfo.encodings, codec.qualities, this.senderLock, this.log, this.logContext);
                        }
                    }
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (!_a && !_b && (_c = codecs_1.return)) yield _c.call(codecs_1);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            return newCodecs;
        });
    }
    /**
   * @internal
   * Sets layers that should be publishing
   */ setPublishingLayers(qualities) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            this.log.debug('setting publishing layers', Object.assign(Object.assign({}, this.logContext), {
                qualities: qualities
            }));
            if (!this.sender || !this.encodings) return;
            yield $2d7d9af7a5367cf4$var$setPublishingLayersForSender(this.sender, this.encodings, qualities, this.senderLock, this.log, this.logContext);
        });
    }
    handleAppVisibilityChanged() {
        const _super = Object.create(null, {
            handleAppVisibilityChanged: {
                get: ()=>super.handleAppVisibilityChanged
            }
        });
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            yield _super.handleAppVisibilityChanged.call(this);
            if (!$2d7d9af7a5367cf4$var$isMobile()) return;
            if (this.isInBackground && this.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Camera) this._mediaStreamTrack.enabled = false;
        });
    }
}
function $2d7d9af7a5367cf4$var$setPublishingLayersForSender(sender, senderEncodings, qualities, senderLock, log, logContext) {
    return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
        const unlock = yield senderLock.lock();
        log.debug('setPublishingLayersForSender', Object.assign(Object.assign({}, logContext), {
            sender: sender,
            qualities: qualities,
            senderEncodings: senderEncodings
        }));
        try {
            const params = sender.getParameters();
            const { encodings: encodings } = params;
            if (!encodings) return;
            if (encodings.length !== senderEncodings.length) {
                log.warn('cannot set publishing layers, encodings mismatch', Object.assign(Object.assign({}, logContext), {
                    encodings: encodings,
                    senderEncodings: senderEncodings
                }));
                return;
            }
            let hasChanged = false;
            /* disable closable spatial layer as it has video blur / frozen issue with current server / client
      1. chrome 113: when switching to up layer with scalability Mode change, it will generate a
            low resolution frame and recover very quickly, but noticable
      2. livekit sfu: additional pli request cause video frozen for a few frames, also noticable */ const closableSpatial = false;
            /* @ts-ignore */ if (closableSpatial && encodings[0].scalabilityMode) ;
            else // simulcast dynacast encodings
            encodings.forEach((encoding, idx)=>{
                var _a;
                let rid = (_a = encoding.rid) !== null && _a !== void 0 ? _a : '';
                if (rid === '') rid = 'q';
                const quality = $2d7d9af7a5367cf4$var$videoQualityForRid(rid);
                const subscribedQuality = qualities.find((q)=>q.quality === quality);
                if (!subscribedQuality) return;
                if (encoding.active !== subscribedQuality.enabled) {
                    hasChanged = true;
                    encoding.active = subscribedQuality.enabled;
                    log.debug("setting layer ".concat(subscribedQuality.quality, " to ").concat(encoding.active ? 'enabled' : 'disabled'), logContext);
                    // FireFox does not support setting encoding.active to false, so we
                    // have a workaround of lowering its bitrate and resolution to the min.
                    if ($2d7d9af7a5367cf4$var$isFireFox()) {
                        if (subscribedQuality.enabled) {
                            encoding.scaleResolutionDownBy = senderEncodings[idx].scaleResolutionDownBy;
                            encoding.maxBitrate = senderEncodings[idx].maxBitrate;
                            /* @ts-ignore */ encoding.maxFrameRate = senderEncodings[idx].maxFrameRate;
                        } else {
                            encoding.scaleResolutionDownBy = 4;
                            encoding.maxBitrate = 10;
                            /* @ts-ignore */ encoding.maxFrameRate = 2;
                        }
                    }
                }
            });
            if (hasChanged) {
                params.encodings = encodings;
                log.debug("setting encodings", Object.assign(Object.assign({}, logContext), {
                    encodings: params.encodings
                }));
                yield sender.setParameters(params);
            }
        } finally{
            unlock();
        }
    });
}
function $2d7d9af7a5367cf4$var$videoQualityForRid(rid) {
    switch(rid){
        case 'f':
            return $2d7d9af7a5367cf4$export$a8f593954e806155.HIGH;
        case 'h':
            return $2d7d9af7a5367cf4$export$a8f593954e806155.MEDIUM;
        case 'q':
            return $2d7d9af7a5367cf4$export$a8f593954e806155.LOW;
        default:
            return $2d7d9af7a5367cf4$export$a8f593954e806155.HIGH;
    }
}
function $2d7d9af7a5367cf4$var$videoLayersFromEncodings(width, height, encodings, svc) {
    // default to a single layer, HQ
    if (!encodings) return [
        new $2d7d9af7a5367cf4$var$VideoLayer({
            quality: $2d7d9af7a5367cf4$export$a8f593954e806155.HIGH,
            width: width,
            height: height,
            bitrate: 0,
            ssrc: 0
        })
    ];
    if (svc) {
        // svc layers
        /* @ts-ignore */ const encodingSM = encodings[0].scalabilityMode;
        const sm = new $2d7d9af7a5367cf4$var$ScalabilityMode(encodingSM);
        const layers = [];
        const resRatio = sm.suffix == 'h' ? 1.5 : 2;
        const bitratesRatio = sm.suffix == 'h' ? 2 : 3;
        for(let i = 0; i < sm.spatial; i += 1)layers.push(new $2d7d9af7a5367cf4$var$VideoLayer({
            quality: Math.min($2d7d9af7a5367cf4$export$a8f593954e806155.HIGH, sm.spatial - 1) - i,
            width: Math.ceil(width / Math.pow(resRatio, i)),
            height: Math.ceil(height / Math.pow(resRatio, i)),
            bitrate: encodings[0].maxBitrate ? Math.ceil(encodings[0].maxBitrate / Math.pow(bitratesRatio, i)) : 0,
            ssrc: 0
        }));
        return layers;
    }
    return encodings.map((encoding)=>{
        var _a, _b, _c;
        const scale = (_a = encoding.scaleResolutionDownBy) !== null && _a !== void 0 ? _a : 1;
        let quality = $2d7d9af7a5367cf4$var$videoQualityForRid((_b = encoding.rid) !== null && _b !== void 0 ? _b : '');
        return new $2d7d9af7a5367cf4$var$VideoLayer({
            quality: quality,
            width: Math.ceil(width / scale),
            height: Math.ceil(height / scale),
            bitrate: (_c = encoding.maxBitrate) !== null && _c !== void 0 ? _c : 0,
            ssrc: 0
        });
    });
}
const $2d7d9af7a5367cf4$var$lossyDataChannel = '_lossy';
const $2d7d9af7a5367cf4$var$reliableDataChannel = '_reliable';
const $2d7d9af7a5367cf4$var$minReconnectWait = 2000;
const $2d7d9af7a5367cf4$var$leaveReconnect = 'leave-reconnect';
var $2d7d9af7a5367cf4$var$PCState;
(function(PCState) {
    PCState[PCState["New"] = 0] = "New";
    PCState[PCState["Connected"] = 1] = "Connected";
    PCState[PCState["Disconnected"] = 2] = "Disconnected";
    PCState[PCState["Reconnecting"] = 3] = "Reconnecting";
    PCState[PCState["Closed"] = 4] = "Closed";
})($2d7d9af7a5367cf4$var$PCState || ($2d7d9af7a5367cf4$var$PCState = {}));
/** @internal */ class $2d7d9af7a5367cf4$var$RTCEngine extends $2d7d9af7a5367cf4$var$eventsExports.EventEmitter {
    get isClosed() {
        return this._isClosed;
    }
    get pendingReconnect() {
        return !!this.reconnectTimeout;
    }
    constructor(options){
        var _a;
        super();
        this.options = options;
        this.rtcConfig = {};
        this.peerConnectionTimeout = $2d7d9af7a5367cf4$var$roomConnectOptionDefaults.peerConnectionTimeout;
        this.fullReconnectOnNext = false;
        this.subscriberPrimary = false;
        this.pcState = $2d7d9af7a5367cf4$var$PCState.New;
        this._isClosed = true;
        this.pendingTrackResolvers = {};
        this.reconnectAttempts = 0;
        this.reconnectStart = 0;
        this.attemptingReconnect = false;
        /** keeps track of how often an initial join connection has been tried */ this.joinAttempts = 0;
        /** specifies how often an initial join connection is allowed to retry */ this.maxJoinAttempts = 1;
        this.shouldFailNext = false;
        this.log = $2d7d9af7a5367cf4$var$livekitLogger;
        this.handleDataChannel = (_a)=>$2d7d9af7a5367cf4$var$__awaiter(this, [
                _a
            ], void 0, function(_ref) {
                var _this = this;
                let { channel: channel } = _ref;
                return function*() {
                    if (!channel) return;
                    if (channel.label === $2d7d9af7a5367cf4$var$reliableDataChannel) _this.reliableDCSub = channel;
                    else if (channel.label === $2d7d9af7a5367cf4$var$lossyDataChannel) _this.lossyDCSub = channel;
                    else return;
                    _this.log.debug("on data channel ".concat(channel.id, ", ").concat(channel.label), _this.logContext);
                    channel.onmessage = _this.handleDataMessage;
                }();
            });
        this.handleDataMessage = (message)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b;
                // make sure to respect incoming data message order by processing message events one after the other
                const unlock = yield this.dataProcessLock.lock();
                try {
                    // decode
                    let buffer;
                    if (message.data instanceof ArrayBuffer) buffer = message.data;
                    else if (message.data instanceof Blob) buffer = yield message.data.arrayBuffer();
                    else {
                        this.log.error('unsupported data type', Object.assign(Object.assign({}, this.logContext), {
                            data: message.data
                        }));
                        return;
                    }
                    const dp = $2d7d9af7a5367cf4$var$DataPacket.fromBinary(new Uint8Array(buffer));
                    if (((_a = dp.value) === null || _a === void 0 ? void 0 : _a.case) === 'speaker') // dispatch speaker updates
                    this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.ActiveSpeakersUpdate, dp.value.value.speakers);
                    else {
                        if (((_b = dp.value) === null || _b === void 0 ? void 0 : _b.case) === 'user') // compatibility
                        $2d7d9af7a5367cf4$var$applyUserDataCompat(dp, dp.value.value);
                        this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.DataPacketReceived, dp);
                    }
                } finally{
                    unlock();
                }
            });
        this.handleDataError = (event)=>{
            const channel = event.currentTarget;
            const channelKind = channel.maxRetransmits === 0 ? 'lossy' : 'reliable';
            if (event instanceof ErrorEvent && event.error) {
                const { error: error } = event.error;
                this.log.error("DataChannel error on ".concat(channelKind, ": ").concat(event.message), Object.assign(Object.assign({}, this.logContext), {
                    error: error
                }));
            } else this.log.error("Unknown DataChannel error on ".concat(channelKind), Object.assign(Object.assign({}, this.logContext), {
                event: event
            }));
        };
        this.handleBufferedAmountLow = (event)=>{
            const channel = event.currentTarget;
            const channelKind = channel.maxRetransmits === 0 ? $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.LOSSY : $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE;
            this.updateAndEmitDCBufferStatus(channelKind);
        };
        // websocket reconnect behavior. if websocket is interrupted, and the PeerConnection
        // continues to work, we can reconnect to websocket to continue the session
        // after a number of retries, we'll close and give up permanently
        this.handleDisconnect = (connection, disconnectReason)=>{
            if (this._isClosed) return;
            this.log.warn("".concat(connection, " disconnected"), this.logContext);
            if (this.reconnectAttempts === 0) // only reset start time on the first try
            this.reconnectStart = Date.now();
            const disconnect = (duration)=>{
                this.log.warn("could not recover connection after ".concat(this.reconnectAttempts, " attempts, ").concat(duration, "ms. giving up"), this.logContext);
                this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.Disconnected);
                this.close();
            };
            const duration = Date.now() - this.reconnectStart;
            let delay = this.getNextRetryDelay({
                elapsedMs: duration,
                retryCount: this.reconnectAttempts
            });
            if (delay === null) {
                disconnect(duration);
                return;
            }
            if (connection === $2d7d9af7a5367cf4$var$leaveReconnect) delay = 0;
            this.log.debug("reconnecting in ".concat(delay, "ms"), this.logContext);
            this.clearReconnectTimeout();
            if (this.token && this.regionUrlProvider) // token may have been refreshed, we do not want to recreate the regionUrlProvider
            // since the current engine may have inherited a regional url
            this.regionUrlProvider.updateToken(this.token);
            this.reconnectTimeout = $2d7d9af7a5367cf4$export$22e737276454df96.setTimeout(()=>this.attemptReconnect(disconnectReason).finally(()=>this.reconnectTimeout = undefined), delay);
        };
        this.waitForRestarted = ()=>{
            return new Promise((resolve, reject)=>{
                if (this.pcState === $2d7d9af7a5367cf4$var$PCState.Connected) resolve();
                const onRestarted = ()=>{
                    this.off($2d7d9af7a5367cf4$export$c09e63b8572f869.Disconnected, onDisconnected);
                    resolve();
                };
                const onDisconnected = ()=>{
                    this.off($2d7d9af7a5367cf4$export$c09e63b8572f869.Restarted, onRestarted);
                    reject();
                };
                this.once($2d7d9af7a5367cf4$export$c09e63b8572f869.Restarted, onRestarted);
                this.once($2d7d9af7a5367cf4$export$c09e63b8572f869.Disconnected, onDisconnected);
            });
        };
        this.updateAndEmitDCBufferStatus = (kind)=>{
            const status = this.isBufferStatusLow(kind);
            if (typeof status !== 'undefined' && status !== this.dcBufferStatus.get(kind)) {
                this.dcBufferStatus.set(kind, status);
                this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.DCBufferStatusChanged, status, kind);
            }
        };
        this.isBufferStatusLow = (kind)=>{
            const dc = this.dataChannelForKind(kind);
            if (dc) return dc.bufferedAmount <= dc.bufferedAmountLowThreshold;
        };
        this.handleBrowserOnLine = ()=>{
            // in case the engine is currently reconnecting, attempt a reconnect immediately after the browser state has changed to 'onLine'
            if (this.client.currentState === $2d7d9af7a5367cf4$var$SignalConnectionState.RECONNECTING) {
                this.clearReconnectTimeout();
                this.attemptReconnect($2d7d9af7a5367cf4$var$ReconnectReason.RR_SIGNAL_DISCONNECTED);
            }
        };
        this.log = $2d7d9af7a5367cf4$export$2b1d391cd05230fd((_a = options.loggerName) !== null && _a !== void 0 ? _a : $2d7d9af7a5367cf4$export$69ba24dd79f4da21.Engine);
        this.loggerOptions = {
            loggerName: options.loggerName,
            loggerContextCb: ()=>this.logContext
        };
        this.client = new $2d7d9af7a5367cf4$var$SignalClient(undefined, this.loggerOptions);
        this.client.signalLatency = this.options.expSignalLatency;
        this.reconnectPolicy = this.options.reconnectPolicy;
        this.registerOnLineListener();
        this.closingLock = new $2d7d9af7a5367cf4$export$ca12f2943758ef55();
        this.dataProcessLock = new $2d7d9af7a5367cf4$export$ca12f2943758ef55();
        this.dcBufferStatus = new Map([
            [
                $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.LOSSY,
                true
            ],
            [
                $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE,
                true
            ]
        ]);
        this.client.onParticipantUpdate = (updates)=>this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.ParticipantUpdate, updates);
        this.client.onConnectionQuality = (update)=>this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.ConnectionQualityUpdate, update);
        this.client.onRoomUpdate = (update)=>this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.RoomUpdate, update);
        this.client.onSubscriptionError = (resp)=>this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.SubscriptionError, resp);
        this.client.onSubscriptionPermissionUpdate = (update)=>this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.SubscriptionPermissionUpdate, update);
        this.client.onSpeakersChanged = (update)=>this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.SpeakersChanged, update);
        this.client.onStreamStateUpdate = (update)=>this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.StreamStateChanged, update);
        this.client.onRequestResponse = (response)=>this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.SignalRequestResponse, response);
    }
    /** @internal */ get logContext() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return {
            room: (_b = (_a = this.latestJoinResponse) === null || _a === void 0 ? void 0 : _a.room) === null || _b === void 0 ? void 0 : _b.name,
            roomID: (_d = (_c = this.latestJoinResponse) === null || _c === void 0 ? void 0 : _c.room) === null || _d === void 0 ? void 0 : _d.sid,
            participant: (_f = (_e = this.latestJoinResponse) === null || _e === void 0 ? void 0 : _e.participant) === null || _f === void 0 ? void 0 : _f.identity,
            pID: (_h = (_g = this.latestJoinResponse) === null || _g === void 0 ? void 0 : _g.participant) === null || _h === void 0 ? void 0 : _h.sid
        };
    }
    join(url, token, opts, abortSignal) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            this.url = url;
            this.token = token;
            this.signalOpts = opts;
            this.maxJoinAttempts = opts.maxRetries;
            try {
                this.joinAttempts += 1;
                this.setupSignalClientCallbacks();
                const joinResponse = yield this.client.join(url, token, opts, abortSignal);
                this._isClosed = false;
                this.latestJoinResponse = joinResponse;
                this.subscriberPrimary = joinResponse.subscriberPrimary;
                if (!this.pcManager) yield this.configure(joinResponse);
                // create offer
                if (!this.subscriberPrimary || joinResponse.fastPublish) this.negotiate();
                this.clientConfiguration = joinResponse.clientConfiguration;
                return joinResponse;
            } catch (e) {
                if (e instanceof $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb) {
                    if (e.reason === $2d7d9af7a5367cf4$export$61182a0b21436b65.ServerUnreachable) {
                        this.log.warn("Couldn't connect to server, attempt ".concat(this.joinAttempts, " of ").concat(this.maxJoinAttempts), this.logContext);
                        if (this.joinAttempts < this.maxJoinAttempts) return this.join(url, token, opts, abortSignal);
                    }
                }
                throw e;
            }
        });
    }
    close() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.closingLock.lock();
            if (this.isClosed) {
                unlock();
                return;
            }
            try {
                this._isClosed = true;
                this.joinAttempts = 0;
                this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.Closing);
                this.removeAllListeners();
                this.deregisterOnLineListener();
                this.clearPendingReconnect();
                yield this.cleanupPeerConnections();
                yield this.cleanupClient();
            } finally{
                unlock();
            }
        });
    }
    cleanupPeerConnections() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            yield (_a = this.pcManager) === null || _a === void 0 ? void 0 : _a.close();
            this.pcManager = undefined;
            const dcCleanup = (dc)=>{
                if (!dc) return;
                dc.close();
                dc.onbufferedamountlow = null;
                dc.onclose = null;
                dc.onclosing = null;
                dc.onerror = null;
                dc.onmessage = null;
                dc.onopen = null;
            };
            dcCleanup(this.lossyDC);
            dcCleanup(this.lossyDCSub);
            dcCleanup(this.reliableDC);
            dcCleanup(this.reliableDCSub);
            this.lossyDC = undefined;
            this.lossyDCSub = undefined;
            this.reliableDC = undefined;
            this.reliableDCSub = undefined;
        });
    }
    cleanupClient() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            yield this.client.close();
            this.client.resetCallbacks();
        });
    }
    addTrack(req) {
        if (this.pendingTrackResolvers[req.cid]) throw new $2d7d9af7a5367cf4$export$4fbb9423b5747257('a track with the same ID has already been published');
        return new Promise((resolve, reject)=>{
            const publicationTimeout = setTimeout(()=>{
                delete this.pendingTrackResolvers[req.cid];
                reject(new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb('publication of local track timed out, no response from server', $2d7d9af7a5367cf4$export$61182a0b21436b65.InternalError));
            }, 10000);
            this.pendingTrackResolvers[req.cid] = {
                resolve: (info)=>{
                    clearTimeout(publicationTimeout);
                    resolve(info);
                },
                reject: ()=>{
                    clearTimeout(publicationTimeout);
                    reject(new Error('Cancelled publication by calling unpublish'));
                }
            };
            this.client.sendAddTrack(req);
        });
    }
    /**
   * Removes sender from PeerConnection, returning true if it was removed successfully
   * and a negotiation is necessary
   * @param sender
   * @returns
   */ removeTrack(sender) {
        if (sender.track && this.pendingTrackResolvers[sender.track.id]) {
            const { reject: reject } = this.pendingTrackResolvers[sender.track.id];
            if (reject) reject();
            delete this.pendingTrackResolvers[sender.track.id];
        }
        try {
            this.pcManager.removeTrack(sender);
            return true;
        } catch (e) {
            this.log.warn('failed to remove track', Object.assign(Object.assign({}, this.logContext), {
                error: e
            }));
        }
        return false;
    }
    updateMuteStatus(trackSid, muted) {
        this.client.sendMuteTrack(trackSid, muted);
    }
    get dataSubscriberReadyState() {
        var _a;
        return (_a = this.reliableDCSub) === null || _a === void 0 ? void 0 : _a.readyState;
    }
    getConnectedServerAddress() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            return (_a = this.pcManager) === null || _a === void 0 ? void 0 : _a.getConnectedAddress();
        });
    }
    /* @internal */ setRegionUrlProvider(provider) {
        this.regionUrlProvider = provider;
    }
    configure(joinResponse) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            // already configured
            if (this.pcManager && this.pcManager.currentState !== $2d7d9af7a5367cf4$var$PCTransportState.NEW) return;
            this.participantSid = (_a = joinResponse.participant) === null || _a === void 0 ? void 0 : _a.sid;
            const rtcConfig = this.makeRTCConfiguration(joinResponse);
            this.pcManager = new $2d7d9af7a5367cf4$var$PCTransportManager(rtcConfig, joinResponse.subscriberPrimary, this.loggerOptions);
            this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.TransportsCreated, this.pcManager.publisher, this.pcManager.subscriber);
            this.pcManager.onIceCandidate = (candidate, target)=>{
                this.client.sendIceCandidate(candidate, target);
            };
            this.pcManager.onPublisherOffer = (offer)=>{
                this.client.sendOffer(offer);
            };
            this.pcManager.onDataChannel = this.handleDataChannel;
            this.pcManager.onStateChange = (connectionState, publisherState, subscriberState)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                    this.log.debug("primary PC state changed ".concat(connectionState), this.logContext);
                    if ([
                        'closed',
                        'disconnected',
                        'failed'
                    ].includes(publisherState)) // reset publisher connection promise
                    this.publisherConnectionPromise = undefined;
                    if (connectionState === $2d7d9af7a5367cf4$var$PCTransportState.CONNECTED) {
                        const shouldEmit = this.pcState === $2d7d9af7a5367cf4$var$PCState.New;
                        this.pcState = $2d7d9af7a5367cf4$var$PCState.Connected;
                        if (shouldEmit) this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.Connected, joinResponse);
                    } else if (connectionState === $2d7d9af7a5367cf4$var$PCTransportState.FAILED) // on Safari, PeerConnection will switch to 'disconnected' during renegotiation
                    {
                        if (this.pcState === $2d7d9af7a5367cf4$var$PCState.Connected) {
                            this.pcState = $2d7d9af7a5367cf4$var$PCState.Disconnected;
                            this.handleDisconnect('peerconnection failed', subscriberState === 'failed' ? $2d7d9af7a5367cf4$var$ReconnectReason.RR_SUBSCRIBER_FAILED : $2d7d9af7a5367cf4$var$ReconnectReason.RR_PUBLISHER_FAILED);
                        }
                    }
                    // detect cases where both signal client and peer connection are severed and assume that user has lost network connection
                    const isSignalSevered = this.client.isDisconnected || this.client.currentState === $2d7d9af7a5367cf4$var$SignalConnectionState.RECONNECTING;
                    const isPCSevered = [
                        $2d7d9af7a5367cf4$var$PCTransportState.FAILED,
                        $2d7d9af7a5367cf4$var$PCTransportState.CLOSING,
                        $2d7d9af7a5367cf4$var$PCTransportState.CLOSED
                    ].includes(connectionState);
                    if (isSignalSevered && isPCSevered && !this._isClosed) this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.Offline);
                });
            this.pcManager.onTrack = (ev)=>{
                this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.MediaTrackAdded, ev.track, ev.streams[0], ev.receiver);
            };
            if (!$2d7d9af7a5367cf4$var$supportOptionalDatachannel((_b = joinResponse.serverInfo) === null || _b === void 0 ? void 0 : _b.protocol)) this.createDataChannels();
        });
    }
    setupSignalClientCallbacks() {
        // configure signaling client
        this.client.onAnswer = (sd)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.pcManager) return;
                this.log.debug('received server answer', Object.assign(Object.assign({}, this.logContext), {
                    RTCSdpType: sd.type
                }));
                yield this.pcManager.setPublisherAnswer(sd);
            });
        // add candidate on trickle
        this.client.onTrickle = (candidate, target)=>{
            if (!this.pcManager) return;
            this.log.trace('got ICE candidate from peer', Object.assign(Object.assign({}, this.logContext), {
                candidate: candidate,
                target: target
            }));
            this.pcManager.addIceCandidate(candidate, target);
        };
        // when server creates an offer for the client
        this.client.onOffer = (sd)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.pcManager) return;
                const answer = yield this.pcManager.createSubscriberAnswerFromOffer(sd);
                this.client.sendAnswer(answer);
            });
        this.client.onLocalTrackPublished = (res)=>{
            var _a;
            this.log.debug('received trackPublishedResponse', Object.assign(Object.assign({}, this.logContext), {
                cid: res.cid,
                track: (_a = res.track) === null || _a === void 0 ? void 0 : _a.sid
            }));
            if (!this.pendingTrackResolvers[res.cid]) {
                this.log.error("missing track resolver for ".concat(res.cid), Object.assign(Object.assign({}, this.logContext), {
                    cid: res.cid
                }));
                return;
            }
            const { resolve: resolve } = this.pendingTrackResolvers[res.cid];
            delete this.pendingTrackResolvers[res.cid];
            resolve(res.track);
        };
        this.client.onLocalTrackUnpublished = (response)=>{
            this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.LocalTrackUnpublished, response);
        };
        this.client.onLocalTrackSubscribed = (trackSid)=>{
            this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.LocalTrackSubscribed, trackSid);
        };
        this.client.onTokenRefresh = (token)=>{
            this.token = token;
        };
        this.client.onRemoteMuteChanged = (trackSid, muted)=>{
            this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.RemoteMute, trackSid, muted);
        };
        this.client.onSubscribedQualityUpdate = (update)=>{
            this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.SubscribedQualityUpdate, update);
        };
        this.client.onClose = ()=>{
            this.handleDisconnect('signal', $2d7d9af7a5367cf4$var$ReconnectReason.RR_SIGNAL_DISCONNECTED);
        };
        this.client.onLeave = (leave)=>{
            this.log.debug('client leave request', Object.assign(Object.assign({}, this.logContext), {
                reason: leave === null || leave === void 0 ? void 0 : leave.reason
            }));
            if (leave.regions && this.regionUrlProvider) {
                this.log.debug('updating regions', this.logContext);
                this.regionUrlProvider.setServerReportedRegions(leave.regions);
            }
            switch(leave.action){
                case $2d7d9af7a5367cf4$var$LeaveRequest_Action.DISCONNECT:
                    this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.Disconnected, leave === null || leave === void 0 ? void 0 : leave.reason);
                    this.close();
                    break;
                case $2d7d9af7a5367cf4$var$LeaveRequest_Action.RECONNECT:
                    this.fullReconnectOnNext = true;
                    // reconnect immediately instead of waiting for next attempt
                    this.handleDisconnect($2d7d9af7a5367cf4$var$leaveReconnect);
                    break;
                case $2d7d9af7a5367cf4$var$LeaveRequest_Action.RESUME:
                    // reconnect immediately instead of waiting for next attempt
                    this.handleDisconnect($2d7d9af7a5367cf4$var$leaveReconnect);
            }
        };
    }
    makeRTCConfiguration(serverResponse) {
        var _a;
        const rtcConfig = Object.assign({}, this.rtcConfig);
        if ((_a = this.signalOpts) === null || _a === void 0 ? void 0 : _a.e2eeEnabled) {
            this.log.debug('E2EE - setting up transports with insertable streams', this.logContext);
            //  this makes sure that no data is sent before the transforms are ready
            // @ts-ignore
            rtcConfig.encodedInsertableStreams = true;
        }
        // update ICE servers before creating PeerConnection
        if (serverResponse.iceServers && !rtcConfig.iceServers) {
            const rtcIceServers = [];
            serverResponse.iceServers.forEach((iceServer)=>{
                const rtcIceServer = {
                    urls: iceServer.urls
                };
                if (iceServer.username) rtcIceServer.username = iceServer.username;
                if (iceServer.credential) rtcIceServer.credential = iceServer.credential;
                rtcIceServers.push(rtcIceServer);
            });
            rtcConfig.iceServers = rtcIceServers;
        }
        if (serverResponse.clientConfiguration && serverResponse.clientConfiguration.forceRelay === $2d7d9af7a5367cf4$var$ClientConfigSetting.ENABLED) rtcConfig.iceTransportPolicy = 'relay';
        // @ts-ignore
        rtcConfig.sdpSemantics = 'unified-plan';
        // @ts-ignore
        rtcConfig.continualGatheringPolicy = 'gather_continually';
        return rtcConfig;
    }
    createDataChannels() {
        if (!this.pcManager) return;
        // clear old data channel callbacks if recreate
        if (this.lossyDC) {
            this.lossyDC.onmessage = null;
            this.lossyDC.onerror = null;
        }
        if (this.reliableDC) {
            this.reliableDC.onmessage = null;
            this.reliableDC.onerror = null;
        }
        // create data channels
        this.lossyDC = this.pcManager.createPublisherDataChannel($2d7d9af7a5367cf4$var$lossyDataChannel, {
            // will drop older packets that arrive
            ordered: true,
            maxRetransmits: 0
        });
        this.reliableDC = this.pcManager.createPublisherDataChannel($2d7d9af7a5367cf4$var$reliableDataChannel, {
            ordered: true
        });
        // also handle messages over the pub channel, for backwards compatibility
        this.lossyDC.onmessage = this.handleDataMessage;
        this.reliableDC.onmessage = this.handleDataMessage;
        // handle datachannel errors
        this.lossyDC.onerror = this.handleDataError;
        this.reliableDC.onerror = this.handleDataError;
        // set up dc buffer threshold, set to 64kB (otherwise 0 by default)
        this.lossyDC.bufferedAmountLowThreshold = 65535;
        this.reliableDC.bufferedAmountLowThreshold = 65535;
        // handle buffer amount low events
        this.lossyDC.onbufferedamountlow = this.handleBufferedAmountLow;
        this.reliableDC.onbufferedamountlow = this.handleBufferedAmountLow;
    }
    createSender(track, opts, encodings) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if ($2d7d9af7a5367cf4$var$supportsTransceiver()) {
                const sender = yield this.createTransceiverRTCRtpSender(track, opts, encodings);
                return sender;
            }
            if ($2d7d9af7a5367cf4$var$supportsAddTrack()) {
                this.log.warn('using add-track fallback', this.logContext);
                const sender = yield this.createRTCRtpSender(track.mediaStreamTrack);
                return sender;
            }
            throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('Required webRTC APIs not supported on this device');
        });
    }
    createSimulcastSender(track, simulcastTrack, opts, encodings) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            // store RTCRtpSender
            if ($2d7d9af7a5367cf4$var$supportsTransceiver()) return this.createSimulcastTransceiverSender(track, simulcastTrack, opts, encodings);
            if ($2d7d9af7a5367cf4$var$supportsAddTrack()) {
                this.log.debug('using add-track fallback', this.logContext);
                return this.createRTCRtpSender(track.mediaStreamTrack);
            }
            throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('Cannot stream on this device');
        });
    }
    createTransceiverRTCRtpSender(track, opts, encodings) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.pcManager) throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('publisher is closed');
            const streams = [];
            if (track.mediaStream) streams.push(track.mediaStream);
            if (track instanceof $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc) track.codec = opts.videoCodec;
            const transceiverInit = {
                direction: 'sendonly',
                streams: streams
            };
            if (encodings) transceiverInit.sendEncodings = encodings;
            // addTransceiver for react-native is async. web is synchronous, but await won't effect it.
            const transceiver = yield this.pcManager.addPublisherTransceiver(track.mediaStreamTrack, transceiverInit);
            return transceiver.sender;
        });
    }
    createSimulcastTransceiverSender(track, simulcastTrack, opts, encodings) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.pcManager) throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('publisher is closed');
            const transceiverInit = {
                direction: 'sendonly'
            };
            if (encodings) transceiverInit.sendEncodings = encodings;
            // addTransceiver for react-native is async. web is synchronous, but await won't effect it.
            const transceiver = yield this.pcManager.addPublisherTransceiver(simulcastTrack.mediaStreamTrack, transceiverInit);
            if (!opts.videoCodec) return;
            track.setSimulcastTrackSender(opts.videoCodec, transceiver.sender);
            return transceiver.sender;
        });
    }
    createRTCRtpSender(track) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.pcManager) throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('publisher is closed');
            return this.pcManager.addPublisherTrack(track);
        });
    }
    attemptReconnect(reason) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            if (this._isClosed) return;
            // guard for attempting reconnection multiple times while one attempt is still not finished
            if (this.attemptingReconnect) {
                $2d7d9af7a5367cf4$var$livekitLogger.warn('already attempting reconnect, returning early', this.logContext);
                return;
            }
            if (((_a = this.clientConfiguration) === null || _a === void 0 ? void 0 : _a.resumeConnection) === $2d7d9af7a5367cf4$var$ClientConfigSetting.DISABLED || // signaling state could change to closed due to hardware sleep
            // those connections cannot be resumed
            ((_c = (_b = this.pcManager) === null || _b === void 0 ? void 0 : _b.currentState) !== null && _c !== void 0 ? _c : $2d7d9af7a5367cf4$var$PCTransportState.NEW) === $2d7d9af7a5367cf4$var$PCTransportState.NEW) this.fullReconnectOnNext = true;
            try {
                this.attemptingReconnect = true;
                if (this.fullReconnectOnNext) yield this.restartConnection();
                else yield this.resumeConnection(reason);
                this.clearPendingReconnect();
                this.fullReconnectOnNext = false;
            } catch (e) {
                this.reconnectAttempts += 1;
                let recoverable = true;
                if (e instanceof $2d7d9af7a5367cf4$export$1f388e244efbf70b) {
                    this.log.debug('received unrecoverable error', Object.assign(Object.assign({}, this.logContext), {
                        error: e
                    }));
                    // unrecoverable
                    recoverable = false;
                } else if (!(e instanceof $2d7d9af7a5367cf4$var$SignalReconnectError)) // cannot resume
                this.fullReconnectOnNext = true;
                if (recoverable) this.handleDisconnect('reconnect', $2d7d9af7a5367cf4$var$ReconnectReason.RR_UNKNOWN);
                else {
                    this.log.info("could not recover connection after ".concat(this.reconnectAttempts, " attempts, ").concat(Date.now() - this.reconnectStart, "ms. giving up"), this.logContext);
                    this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.Disconnected);
                    yield this.close();
                }
            } finally{
                this.attemptingReconnect = false;
            }
        });
    }
    getNextRetryDelay(context) {
        try {
            return this.reconnectPolicy.nextRetryDelayInMs(context);
        } catch (e) {
            this.log.warn('encountered error in reconnect policy', Object.assign(Object.assign({}, this.logContext), {
                error: e
            }));
        }
        // error in user code with provided reconnect policy, stop reconnecting
        return null;
    }
    restartConnection(regionUrl) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            try {
                if (!this.url || !this.token) // permanent failure, don't attempt reconnection
                throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('could not reconnect, url or token not saved');
                this.log.info("reconnecting, attempt: ".concat(this.reconnectAttempts), this.logContext);
                this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.Restarting);
                if (!this.client.isDisconnected) yield this.client.sendLeave();
                yield this.cleanupPeerConnections();
                yield this.cleanupClient();
                let joinResponse;
                try {
                    if (!this.signalOpts) {
                        this.log.warn('attempted connection restart, without signal options present', this.logContext);
                        throw new $2d7d9af7a5367cf4$var$SignalReconnectError();
                    }
                    // in case a regionUrl is passed, the region URL takes precedence
                    joinResponse = yield this.join(regionUrl !== null && regionUrl !== void 0 ? regionUrl : this.url, this.token, this.signalOpts);
                } catch (e) {
                    if (e instanceof $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb && e.reason === $2d7d9af7a5367cf4$export$61182a0b21436b65.NotAllowed) throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('could not reconnect, token might be expired');
                    throw new $2d7d9af7a5367cf4$var$SignalReconnectError();
                }
                if (this.shouldFailNext) {
                    this.shouldFailNext = false;
                    throw new Error('simulated failure');
                }
                this.client.setReconnected();
                this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.SignalRestarted, joinResponse);
                yield this.waitForPCReconnected();
                // re-check signal connection state before setting engine as resumed
                if (this.client.currentState !== $2d7d9af7a5367cf4$var$SignalConnectionState.CONNECTED) throw new $2d7d9af7a5367cf4$var$SignalReconnectError('Signal connection got severed during reconnect');
                (_a = this.regionUrlProvider) === null || _a === void 0 || _a.resetAttempts();
                // reconnect success
                this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.Restarted);
            } catch (error) {
                const nextRegionUrl = yield (_b = this.regionUrlProvider) === null || _b === void 0 ? void 0 : _b.getNextBestRegionUrl();
                if (nextRegionUrl) {
                    yield this.restartConnection(nextRegionUrl);
                    return;
                } else {
                    // no more regions to try (or we're not on cloud)
                    (_c = this.regionUrlProvider) === null || _c === void 0 || _c.resetAttempts();
                    throw error;
                }
            }
        });
    }
    resumeConnection(reason) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!this.url || !this.token) // permanent failure, don't attempt reconnection
            throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('could not reconnect, url or token not saved');
            // trigger publisher reconnect
            if (!this.pcManager) throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('publisher and subscriber connections unset');
            this.log.info("resuming signal connection, attempt ".concat(this.reconnectAttempts), this.logContext);
            this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.Resuming);
            let res;
            try {
                this.setupSignalClientCallbacks();
                res = yield this.client.reconnect(this.url, this.token, this.participantSid, reason);
            } catch (error) {
                let message = '';
                if (error instanceof Error) {
                    message = error.message;
                    this.log.error(error.message, Object.assign(Object.assign({}, this.logContext), {
                        error: error
                    }));
                }
                if (error instanceof $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb && error.reason === $2d7d9af7a5367cf4$export$61182a0b21436b65.NotAllowed) throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('could not reconnect, token might be expired');
                if (error instanceof $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb && error.reason === $2d7d9af7a5367cf4$export$61182a0b21436b65.LeaveRequest) throw error;
                throw new $2d7d9af7a5367cf4$var$SignalReconnectError(message);
            }
            this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.SignalResumed);
            if (res) {
                const rtcConfig = this.makeRTCConfiguration(res);
                this.pcManager.updateConfiguration(rtcConfig);
            } else this.log.warn('Did not receive reconnect response', this.logContext);
            if (this.shouldFailNext) {
                this.shouldFailNext = false;
                throw new Error('simulated failure');
            }
            yield this.pcManager.triggerIceRestart();
            yield this.waitForPCReconnected();
            // re-check signal connection state before setting engine as resumed
            if (this.client.currentState !== $2d7d9af7a5367cf4$var$SignalConnectionState.CONNECTED) throw new $2d7d9af7a5367cf4$var$SignalReconnectError('Signal connection got severed during reconnect');
            this.client.setReconnected();
            // recreate publish datachannel if it's id is null
            // (for safari https://bugs.webkit.org/show_bug.cgi?id=184688)
            if (((_a = this.reliableDC) === null || _a === void 0 ? void 0 : _a.readyState) === 'open' && this.reliableDC.id === null) this.createDataChannels();
            // resume success
            this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.Resumed);
        });
    }
    waitForPCInitialConnection(timeout, abortController) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.pcManager) throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('PC manager is closed');
            yield this.pcManager.ensurePCTransportConnection(abortController, timeout);
        });
    }
    waitForPCReconnected() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            this.pcState = $2d7d9af7a5367cf4$var$PCState.Reconnecting;
            this.log.debug('waiting for peer connection to reconnect', this.logContext);
            try {
                yield $2d7d9af7a5367cf4$var$sleep($2d7d9af7a5367cf4$var$minReconnectWait); // FIXME setTimeout again not ideal for a connection critical path
                if (!this.pcManager) throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('PC manager is closed');
                yield this.pcManager.ensurePCTransportConnection(undefined, this.peerConnectionTimeout);
                this.pcState = $2d7d9af7a5367cf4$var$PCState.Connected;
            } catch (e) {
                // TODO do we need a `failed` state here for the PC?
                this.pcState = $2d7d9af7a5367cf4$var$PCState.Disconnected;
                throw new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb("could not establish PC connection, ".concat(e.message), $2d7d9af7a5367cf4$export$61182a0b21436b65.InternalError);
            }
        });
    }
    /* @internal */ sendDataPacket(packet, kind) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const msg = packet.toBinary();
            // make sure we do have a data connection
            yield this.ensurePublisherConnected(kind);
            const dc = this.dataChannelForKind(kind);
            if (dc) dc.send(msg);
            this.updateAndEmitDCBufferStatus(kind);
        });
    }
    /**
   * @internal
   */ ensureDataTransportConnected(kind_1) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function(kind) {
            var _this2 = this;
            let subscriber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.subscriberPrimary;
            return function*() {
                var _a;
                if (!_this2.pcManager) throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('PC manager is closed');
                const transport = subscriber ? _this2.pcManager.subscriber : _this2.pcManager.publisher;
                const transportName = subscriber ? 'Subscriber' : 'Publisher';
                if (!transport) throw new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb("".concat(transportName, " connection not set"), $2d7d9af7a5367cf4$export$61182a0b21436b65.InternalError);
                let needNegotiation = false;
                if (!subscriber && !_this2.dataChannelForKind(kind, subscriber)) {
                    _this2.createDataChannels();
                    needNegotiation = true;
                }
                if (!needNegotiation && !subscriber && !_this2.pcManager.publisher.isICEConnected && _this2.pcManager.publisher.getICEConnectionState() !== 'checking') needNegotiation = true;
                if (needNegotiation) // start negotiation
                _this2.negotiate();
                const targetChannel = _this2.dataChannelForKind(kind, subscriber);
                if ((targetChannel === null || targetChannel === void 0 ? void 0 : targetChannel.readyState) === 'open') return;
                // wait until ICE connected
                const endTime = new Date().getTime() + _this2.peerConnectionTimeout;
                while(new Date().getTime() < endTime){
                    if (transport.isICEConnected && ((_a = _this2.dataChannelForKind(kind, subscriber)) === null || _a === void 0 ? void 0 : _a.readyState) === 'open') return;
                    yield $2d7d9af7a5367cf4$var$sleep(50);
                }
                throw new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb("could not establish ".concat(transportName, " connection, state: ").concat(transport.getICEConnectionState()), $2d7d9af7a5367cf4$export$61182a0b21436b65.InternalError);
            }();
        });
    }
    ensurePublisherConnected(kind) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.publisherConnectionPromise) this.publisherConnectionPromise = this.ensureDataTransportConnected(kind, false);
            yield this.publisherConnectionPromise;
        });
    }
    /* @internal */ verifyTransport() {
        if (!this.pcManager) return false;
        // primary connection
        if (this.pcManager.currentState !== $2d7d9af7a5367cf4$var$PCTransportState.CONNECTED) return false;
        // ensure signal is connected
        if (!this.client.ws || this.client.ws.readyState === WebSocket.CLOSED) return false;
        return true;
    }
    /** @internal */ negotiate() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            // observe signal state
            return new Promise((resolve, reject)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                    if (!this.pcManager) {
                        reject(new $2d7d9af7a5367cf4$export$18c2792bacf23e39('PC manager is closed'));
                        return;
                    }
                    this.pcManager.requirePublisher();
                    // don't negotiate without any transceivers or data channel, it will generate sdp without ice frag then negotiate failed
                    if (this.pcManager.publisher.getTransceivers().length == 0 && !this.lossyDC && !this.reliableDC) this.createDataChannels();
                    const abortController = new AbortController();
                    const handleClosed = ()=>{
                        abortController.abort();
                        this.log.debug('engine disconnected while negotiation was ongoing', this.logContext);
                        resolve();
                        return;
                    };
                    if (this.isClosed) reject('cannot negotiate on closed engine');
                    this.on($2d7d9af7a5367cf4$export$c09e63b8572f869.Closing, handleClosed);
                    this.pcManager.publisher.once($2d7d9af7a5367cf4$var$PCEvents.RTPVideoPayloadTypes, (rtpTypes)=>{
                        const rtpMap = new Map();
                        rtpTypes.forEach((rtp)=>{
                            const codec = rtp.codec.toLowerCase();
                            if ($2d7d9af7a5367cf4$var$isVideoCodec(codec)) rtpMap.set(rtp.payload, codec);
                        });
                        this.emit($2d7d9af7a5367cf4$export$c09e63b8572f869.RTPVideoMapUpdate, rtpMap);
                    });
                    try {
                        yield this.pcManager.negotiate(abortController);
                        resolve();
                    } catch (e) {
                        if (e instanceof $2d7d9af7a5367cf4$export$18c2792bacf23e39) this.fullReconnectOnNext = true;
                        this.handleDisconnect('negotiation', $2d7d9af7a5367cf4$var$ReconnectReason.RR_UNKNOWN);
                        reject(e);
                    } finally{
                        this.off($2d7d9af7a5367cf4$export$c09e63b8572f869.Closing, handleClosed);
                    }
                }));
        });
    }
    dataChannelForKind(kind, sub) {
        if (!sub) {
            if (kind === $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.LOSSY) return this.lossyDC;
            if (kind === $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE) return this.reliableDC;
        } else {
            if (kind === $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.LOSSY) return this.lossyDCSub;
            if (kind === $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE) return this.reliableDCSub;
        }
    }
    /** @internal */ sendSyncState(remoteTracks, localTracks) {
        var _a, _b;
        if (!this.pcManager) {
            this.log.warn('sync state cannot be sent without peer connection setup', this.logContext);
            return;
        }
        const previousAnswer = this.pcManager.subscriber.getLocalDescription();
        const previousOffer = this.pcManager.subscriber.getRemoteDescription();
        /* 1. autosubscribe on, so subscribed tracks = all tracks - unsub tracks,
          in this case, we send unsub tracks, so server add all tracks to this
          subscribe pc and unsub special tracks from it.
       2. autosubscribe off, we send subscribed tracks.
    */ const autoSubscribe = (_b = (_a = this.signalOpts) === null || _a === void 0 ? void 0 : _a.autoSubscribe) !== null && _b !== void 0 ? _b : true;
        const trackSids = new Array();
        const trackSidsDisabled = new Array();
        remoteTracks.forEach((track)=>{
            if (track.isDesired !== autoSubscribe) trackSids.push(track.trackSid);
            if (!track.isEnabled) trackSidsDisabled.push(track.trackSid);
        });
        this.client.sendSyncState(new $2d7d9af7a5367cf4$var$SyncState({
            answer: previousAnswer ? $2d7d9af7a5367cf4$var$toProtoSessionDescription({
                sdp: previousAnswer.sdp,
                type: previousAnswer.type
            }) : undefined,
            offer: previousOffer ? $2d7d9af7a5367cf4$var$toProtoSessionDescription({
                sdp: previousOffer.sdp,
                type: previousOffer.type
            }) : undefined,
            subscription: new $2d7d9af7a5367cf4$var$UpdateSubscription({
                trackSids: trackSids,
                subscribe: !autoSubscribe,
                participantTracks: []
            }),
            publishTracks: $2d7d9af7a5367cf4$var$getTrackPublicationInfo(localTracks),
            dataChannels: this.dataChannelsInfo(),
            trackSidsDisabled: trackSidsDisabled
        }));
    }
    /* @internal */ failNext() {
        // debugging method to fail the next reconnect/resume attempt
        this.shouldFailNext = true;
    }
    dataChannelsInfo() {
        const infos = [];
        const getInfo = (dc, target)=>{
            if ((dc === null || dc === void 0 ? void 0 : dc.id) !== undefined && dc.id !== null) infos.push(new $2d7d9af7a5367cf4$var$DataChannelInfo({
                label: dc.label,
                id: dc.id,
                target: target
            }));
        };
        getInfo(this.dataChannelForKind($2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.LOSSY), $2d7d9af7a5367cf4$var$SignalTarget.PUBLISHER);
        getInfo(this.dataChannelForKind($2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE), $2d7d9af7a5367cf4$var$SignalTarget.PUBLISHER);
        getInfo(this.dataChannelForKind($2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.LOSSY, true), $2d7d9af7a5367cf4$var$SignalTarget.SUBSCRIBER);
        getInfo(this.dataChannelForKind($2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE, true), $2d7d9af7a5367cf4$var$SignalTarget.SUBSCRIBER);
        return infos;
    }
    clearReconnectTimeout() {
        if (this.reconnectTimeout) $2d7d9af7a5367cf4$export$22e737276454df96.clearTimeout(this.reconnectTimeout);
    }
    clearPendingReconnect() {
        this.clearReconnectTimeout();
        this.reconnectAttempts = 0;
    }
    registerOnLineListener() {
        if ($2d7d9af7a5367cf4$var$isWeb()) window.addEventListener('online', this.handleBrowserOnLine);
    }
    deregisterOnLineListener() {
        if ($2d7d9af7a5367cf4$var$isWeb()) window.removeEventListener('online', this.handleBrowserOnLine);
    }
}
class $2d7d9af7a5367cf4$var$SignalReconnectError extends Error {
}
function $2d7d9af7a5367cf4$var$supportOptionalDatachannel(protocol) {
    return protocol !== undefined && protocol > 13;
}
function $2d7d9af7a5367cf4$var$applyUserDataCompat(newObj, oldObj) {
    const participantIdentity = newObj.participantIdentity ? newObj.participantIdentity : oldObj.participantIdentity;
    newObj.participantIdentity = participantIdentity;
    oldObj.participantIdentity = participantIdentity;
    const destinationIdentities = newObj.destinationIdentities.length !== 0 ? newObj.destinationIdentities : oldObj.destinationIdentities;
    newObj.destinationIdentities = destinationIdentities;
    oldObj.destinationIdentities = destinationIdentities;
}
class $2d7d9af7a5367cf4$var$RegionUrlProvider {
    constructor(url, token){
        this.lastUpdateAt = 0;
        this.settingsCacheTime = 3000;
        this.attemptedRegions = [];
        this.serverUrl = new URL(url);
        this.token = token;
    }
    updateToken(token) {
        this.token = token;
    }
    isCloud() {
        return $2d7d9af7a5367cf4$var$isCloud(this.serverUrl);
    }
    getServerUrl() {
        return this.serverUrl;
    }
    getNextBestRegionUrl(abortSignal) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.isCloud()) throw Error('region availability is only supported for LiveKit Cloud domains');
            if (!this.regionSettings || Date.now() - this.lastUpdateAt > this.settingsCacheTime) this.regionSettings = yield this.fetchRegionSettings(abortSignal);
            const regionsLeft = this.regionSettings.regions.filter((region)=>!this.attemptedRegions.find((attempted)=>attempted.url === region.url));
            if (regionsLeft.length > 0) {
                const nextRegion = regionsLeft[0];
                this.attemptedRegions.push(nextRegion);
                $2d7d9af7a5367cf4$var$livekitLogger.debug("next region: ".concat(nextRegion.region));
                return nextRegion.url;
            } else return null;
        });
    }
    resetAttempts() {
        this.attemptedRegions = [];
    }
    /* @internal */ fetchRegionSettings(signal) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const regionSettingsResponse = yield fetch("".concat($2d7d9af7a5367cf4$var$getCloudConfigUrl(this.serverUrl), "/regions"), {
                headers: {
                    authorization: "Bearer ".concat(this.token)
                },
                signal: signal
            });
            if (regionSettingsResponse.ok) {
                const regionSettings = yield regionSettingsResponse.json();
                this.lastUpdateAt = Date.now();
                return regionSettings;
            } else throw new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb("Could not fetch region settings: ".concat(regionSettingsResponse.statusText), regionSettingsResponse.status === 401 ? $2d7d9af7a5367cf4$export$61182a0b21436b65.NotAllowed : $2d7d9af7a5367cf4$export$61182a0b21436b65.InternalError, regionSettingsResponse.status);
        });
    }
    setServerReportedRegions(regions) {
        this.regionSettings = regions;
        this.lastUpdateAt = Date.now();
    }
}
function $2d7d9af7a5367cf4$var$getCloudConfigUrl(serverUrl) {
    return "".concat(serverUrl.protocol.replace('ws', 'http'), "//").concat(serverUrl.host, "/settings");
}
// SPDX-FileCopyrightText: 2024 LiveKit, Inc.
//
// SPDX-License-Identifier: Apache-2.0
/**
 * Specialized error handling for RPC methods.
 *
 * Instances of this type, when thrown in a method handler, will have their `message`
 * serialized and sent across the wire. The sender will receive an equivalent error on the other side.
 *
 * Built-in types are included but developers may use any string, with a max length of 256 bytes.
 */ class $2d7d9af7a5367cf4$export$5460eff990f31920 extends Error {
    /**
   * Creates an error object with the given code and message, plus an optional data payload.
   *
   * If thrown in an RPC method handler, the error will be sent back to the caller.
   *
   * Error codes 1001-1999 are reserved for built-in errors (see RpcError.ErrorCode for their meanings).
   */ constructor(code, message, data){
        super(message);
        this.code = code;
        this.message = $2d7d9af7a5367cf4$var$truncateBytes(message, $2d7d9af7a5367cf4$export$5460eff990f31920.MAX_MESSAGE_BYTES);
        this.data = data ? $2d7d9af7a5367cf4$var$truncateBytes(data, $2d7d9af7a5367cf4$export$5460eff990f31920.MAX_DATA_BYTES) : undefined;
    }
    /**
   * @internal
   */ static fromProto(proto) {
        return new $2d7d9af7a5367cf4$export$5460eff990f31920(proto.code, proto.message, proto.data);
    }
    /**
   * @internal
   */ toProto() {
        return new $2d7d9af7a5367cf4$var$RpcError$1({
            code: this.code,
            message: this.message,
            data: this.data
        });
    }
    /**
   * Creates an error object from the code, with an auto-populated message.
   *
   * @internal
   */ static builtIn(key, data) {
        return new $2d7d9af7a5367cf4$export$5460eff990f31920($2d7d9af7a5367cf4$export$5460eff990f31920.ErrorCode[key], $2d7d9af7a5367cf4$export$5460eff990f31920.ErrorMessage[key], data);
    }
}
$2d7d9af7a5367cf4$export$5460eff990f31920.MAX_MESSAGE_BYTES = 256;
$2d7d9af7a5367cf4$export$5460eff990f31920.MAX_DATA_BYTES = 15360; // 15 KB
$2d7d9af7a5367cf4$export$5460eff990f31920.ErrorCode = {
    APPLICATION_ERROR: 1500,
    CONNECTION_TIMEOUT: 1501,
    RESPONSE_TIMEOUT: 1502,
    RECIPIENT_DISCONNECTED: 1503,
    RESPONSE_PAYLOAD_TOO_LARGE: 1504,
    SEND_FAILED: 1505,
    UNSUPPORTED_METHOD: 1400,
    RECIPIENT_NOT_FOUND: 1401,
    REQUEST_PAYLOAD_TOO_LARGE: 1402,
    UNSUPPORTED_SERVER: 1403,
    UNSUPPORTED_VERSION: 1404
};
/**
 * @internal
 */ $2d7d9af7a5367cf4$export$5460eff990f31920.ErrorMessage = {
    APPLICATION_ERROR: 'Application error in method handler',
    CONNECTION_TIMEOUT: 'Connection timeout',
    RESPONSE_TIMEOUT: 'Response timeout',
    RECIPIENT_DISCONNECTED: 'Recipient disconnected',
    RESPONSE_PAYLOAD_TOO_LARGE: 'Response payload too large',
    SEND_FAILED: 'Failed to send',
    UNSUPPORTED_METHOD: 'Method not supported at destination',
    RECIPIENT_NOT_FOUND: 'Recipient not found',
    REQUEST_PAYLOAD_TOO_LARGE: 'Request payload too large',
    UNSUPPORTED_SERVER: 'RPC not supported by server',
    UNSUPPORTED_VERSION: 'Unsupported RPC version'
};
/*
 * Maximum payload size for RPC requests and responses. If a payload exceeds this size,
 * the RPC call will fail with a REQUEST_PAYLOAD_TOO_LARGE(1402) or RESPONSE_PAYLOAD_TOO_LARGE(1504) error.
 */ const $2d7d9af7a5367cf4$var$MAX_PAYLOAD_BYTES = 15360; // 15 KB
/**
 * @internal
 */ function $2d7d9af7a5367cf4$var$byteLength(str) {
    const encoder = new TextEncoder();
    return encoder.encode(str).length;
}
/**
 * @internal
 */ function $2d7d9af7a5367cf4$var$truncateBytes(str, maxBytes) {
    if ($2d7d9af7a5367cf4$var$byteLength(str) <= maxBytes) return str;
    let low = 0;
    let high = str.length;
    const encoder = new TextEncoder();
    while(low < high){
        const mid = Math.floor((low + high + 1) / 2);
        if (encoder.encode(str.slice(0, mid)).length <= maxBytes) low = mid;
        else high = mid - 1;
    }
    return str.slice(0, low);
}
class $2d7d9af7a5367cf4$export$e3d2a545a239ada4 extends $2d7d9af7a5367cf4$export$13921ac0cc260818 {
    constructor(mediaTrack, sid, kind, receiver, loggerOptions){
        super(mediaTrack, kind, loggerOptions);
        this.sid = sid;
        this.receiver = receiver;
    }
    /** @internal */ setMuted(muted) {
        if (this.isMuted !== muted) {
            this.isMuted = muted;
            this._mediaStreamTrack.enabled = !muted;
            this.emit(muted ? $2d7d9af7a5367cf4$export$2c8510d737cc09da.Muted : $2d7d9af7a5367cf4$export$2c8510d737cc09da.Unmuted, this);
        }
    }
    /** @internal */ setMediaStream(stream) {
        // this is needed to determine when the track is finished
        this.mediaStream = stream;
        const onRemoveTrack = (event)=>{
            if (event.track === this._mediaStreamTrack) {
                stream.removeEventListener('removetrack', onRemoveTrack);
                if (this.receiver && 'playoutDelayHint' in this.receiver) this.receiver.playoutDelayHint = undefined;
                this.receiver = undefined;
                this._currentBitrate = 0;
                this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.Ended, this);
            }
        };
        stream.addEventListener('removetrack', onRemoveTrack);
    }
    start() {
        this.startMonitor();
        // use `enabled` of track to enable re-use of transceiver
        super.enable();
    }
    stop() {
        this.stopMonitor();
        // use `enabled` of track to enable re-use of transceiver
        super.disable();
    }
    /**
   * Gets the RTCStatsReport for the RemoteTrack's underlying RTCRtpReceiver
   * See https://developer.mozilla.org/en-US/docs/Web/API/RTCStatsReport
   *
   * @returns Promise<RTCStatsReport> | undefined
   */ getRTCStatsReport() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!((_a = this.receiver) === null || _a === void 0 ? void 0 : _a.getStats)) return;
            const statsReport = yield this.receiver.getStats();
            return statsReport;
        });
    }
    /**
   * Allows to set a playout delay (in seconds) for this track.
   * A higher value allows for more buffering of the track in the browser
   * and will result in a delay of media being played back of `delayInSeconds`
   */ setPlayoutDelay(delayInSeconds) {
        if (this.receiver) {
            if ('playoutDelayHint' in this.receiver) this.receiver.playoutDelayHint = delayInSeconds;
            else this.log.warn('Playout delay not supported in this browser');
        } else this.log.warn('Cannot set playout delay, track already ended');
    }
    /**
   * Returns the current playout delay (in seconds) of this track.
   */ getPlayoutDelay() {
        if (this.receiver) {
            if ('playoutDelayHint' in this.receiver) return this.receiver.playoutDelayHint;
            else this.log.warn('Playout delay not supported in this browser');
        } else this.log.warn('Cannot get playout delay, track already ended');
        return 0;
    }
    /* @internal */ startMonitor() {
        if (!this.monitorInterval) this.monitorInterval = setInterval(()=>this.monitorReceiver(), $2d7d9af7a5367cf4$var$monitorFrequency);
        if ($2d7d9af7a5367cf4$var$supportsSynchronizationSources()) this.registerTimeSyncUpdate();
    }
    registerTimeSyncUpdate() {
        const loop = ()=>{
            var _a;
            this.timeSyncHandle = requestAnimationFrame(()=>loop());
            const sources = (_a = this.receiver) === null || _a === void 0 ? void 0 : _a.getSynchronizationSources()[0];
            if (sources) {
                const { timestamp: timestamp, rtpTimestamp: rtpTimestamp } = sources;
                if (rtpTimestamp && this.rtpTimestamp !== rtpTimestamp) {
                    this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.TimeSyncUpdate, {
                        timestamp: timestamp,
                        rtpTimestamp: rtpTimestamp
                    });
                    this.rtpTimestamp = rtpTimestamp;
                }
            }
        };
        loop();
    }
}
class $2d7d9af7a5367cf4$export$fd37b116bd840ced extends $2d7d9af7a5367cf4$export$e3d2a545a239ada4 {
    constructor(mediaTrack, sid, receiver, audioContext, audioOutput, loggerOptions){
        super(mediaTrack, sid, $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Audio, receiver, loggerOptions);
        this.monitorReceiver = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.receiver) {
                    this._currentBitrate = 0;
                    return;
                }
                const stats = yield this.getReceiverStats();
                if (stats && this.prevStats && this.receiver) this._currentBitrate = $2d7d9af7a5367cf4$var$computeBitrate(stats, this.prevStats);
                this.prevStats = stats;
            });
        this.audioContext = audioContext;
        this.webAudioPluginNodes = [];
        if (audioOutput) this.sinkId = audioOutput.deviceId;
    }
    /**
   * sets the volume for all attached audio elements
   */ setVolume(volume) {
        var _a;
        for (const el of this.attachedElements)if (this.audioContext) (_a = this.gainNode) === null || _a === void 0 || _a.gain.setTargetAtTime(volume, 0, 0.1);
        else el.volume = volume;
        if ($2d7d9af7a5367cf4$var$isReactNative()) // @ts-ignore
        this._mediaStreamTrack._setVolume(volume);
        this.elementVolume = volume;
    }
    /**
   * gets the volume of attached audio elements (loudest)
   */ getVolume() {
        if (this.elementVolume) return this.elementVolume;
        if ($2d7d9af7a5367cf4$var$isReactNative()) // RN volume value defaults to 1.0 if hasn't been changed.
        return 1.0;
        let highestVolume = 0;
        this.attachedElements.forEach((element)=>{
            if (element.volume > highestVolume) highestVolume = element.volume;
        });
        return highestVolume;
    }
    /**
   * calls setSinkId on all attached elements, if supported
   * @param deviceId audio output device
   */ setSinkId(deviceId) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            this.sinkId = deviceId;
            yield Promise.all(this.attachedElements.map((elm)=>{
                if (!$2d7d9af7a5367cf4$var$supportsSetSinkId(elm)) return;
                /* @ts-ignore */ return elm.setSinkId(deviceId);
            }));
        });
    }
    attach(element) {
        const needsNewWebAudioConnection = this.attachedElements.length === 0;
        if (!element) element = super.attach();
        else super.attach(element);
        if (this.sinkId && $2d7d9af7a5367cf4$var$supportsSetSinkId(element)) /* @ts-ignore */ element.setSinkId(this.sinkId);
        if (this.audioContext && needsNewWebAudioConnection) {
            this.log.debug('using audio context mapping', this.logContext);
            this.connectWebAudio(this.audioContext, element);
            element.volume = 0;
            element.muted = true;
        }
        if (this.elementVolume) // make sure volume setting is being applied to the newly attached element
        this.setVolume(this.elementVolume);
        return element;
    }
    detach(element) {
        let detached;
        if (!element) {
            detached = super.detach();
            this.disconnectWebAudio();
        } else {
            detached = super.detach(element);
            // if there are still any attached elements after detaching, connect webaudio to the first element that's left
            // disconnect webaudio otherwise
            if (this.audioContext) {
                if (this.attachedElements.length > 0) this.connectWebAudio(this.audioContext, this.attachedElements[0]);
                else this.disconnectWebAudio();
            }
        }
        return detached;
    }
    /**
   * @internal
   * @experimental
   */ setAudioContext(audioContext) {
        this.audioContext = audioContext;
        if (audioContext && this.attachedElements.length > 0) this.connectWebAudio(audioContext, this.attachedElements[0]);
        else if (!audioContext) this.disconnectWebAudio();
    }
    /**
   * @internal
   * @experimental
   * @param {AudioNode[]} nodes - An array of WebAudio nodes. These nodes should not be connected to each other when passed, as the sdk will take care of connecting them in the order of the array.
   */ setWebAudioPlugins(nodes) {
        this.webAudioPluginNodes = nodes;
        if (this.attachedElements.length > 0 && this.audioContext) this.connectWebAudio(this.audioContext, this.attachedElements[0]);
    }
    connectWebAudio(context, element) {
        this.disconnectWebAudio();
        // @ts-ignore attached elements always have a srcObject set
        this.sourceNode = context.createMediaStreamSource(element.srcObject);
        let lastNode = this.sourceNode;
        this.webAudioPluginNodes.forEach((node)=>{
            lastNode.connect(node);
            lastNode = node;
        });
        this.gainNode = context.createGain();
        lastNode.connect(this.gainNode);
        this.gainNode.connect(context.destination);
        if (this.elementVolume) this.gainNode.gain.setTargetAtTime(this.elementVolume, 0, 0.1);
        // try to resume the context if it isn't running already
        if (context.state !== 'running') context.resume().then(()=>{
            if (context.state !== 'running') this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.AudioPlaybackFailed, new Error("Audio Context couldn't be started automatically"));
        }).catch((e)=>{
            this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.AudioPlaybackFailed, e);
        });
    }
    disconnectWebAudio() {
        var _a, _b;
        (_a = this.gainNode) === null || _a === void 0 || _a.disconnect();
        (_b = this.sourceNode) === null || _b === void 0 || _b.disconnect();
        this.gainNode = undefined;
        this.sourceNode = undefined;
    }
    getReceiverStats() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.receiver || !this.receiver.getStats) return;
            const stats = yield this.receiver.getStats();
            let receiverStats;
            stats.forEach((v)=>{
                if (v.type === 'inbound-rtp') receiverStats = {
                    type: 'audio',
                    timestamp: v.timestamp,
                    jitter: v.jitter,
                    bytesReceived: v.bytesReceived,
                    concealedSamples: v.concealedSamples,
                    concealmentEvents: v.concealmentEvents,
                    silentConcealedSamples: v.silentConcealedSamples,
                    silentConcealmentEvents: v.silentConcealmentEvents,
                    totalAudioEnergy: v.totalAudioEnergy,
                    totalSamplesDuration: v.totalSamplesDuration
                };
            });
            return receiverStats;
        });
    }
}
const $2d7d9af7a5367cf4$var$REACTION_DELAY = 100;
class $2d7d9af7a5367cf4$export$1db0c0ebd3ae1523 extends $2d7d9af7a5367cf4$export$e3d2a545a239ada4 {
    constructor(mediaTrack, sid, receiver, adaptiveStreamSettings, loggerOptions){
        super(mediaTrack, sid, $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video, receiver, loggerOptions);
        this.elementInfos = [];
        this.monitorReceiver = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.receiver) {
                    this._currentBitrate = 0;
                    return;
                }
                const stats = yield this.getReceiverStats();
                if (stats && this.prevStats && this.receiver) this._currentBitrate = $2d7d9af7a5367cf4$var$computeBitrate(stats, this.prevStats);
                this.prevStats = stats;
            });
        this.debouncedHandleResize = $2d7d9af7a5367cf4$var$r(()=>{
            this.updateDimensions();
        }, $2d7d9af7a5367cf4$var$REACTION_DELAY);
        this.adaptiveStreamSettings = adaptiveStreamSettings;
    }
    get isAdaptiveStream() {
        return this.adaptiveStreamSettings !== undefined;
    }
    /**
   * Note: When using adaptiveStream, you need to use remoteVideoTrack.attach() to add the track to a HTMLVideoElement, otherwise your video tracks might never start
   */ get mediaStreamTrack() {
        return this._mediaStreamTrack;
    }
    /** @internal */ setMuted(muted) {
        super.setMuted(muted);
        this.attachedElements.forEach((element)=>{
            // detach or attach
            if (muted) $2d7d9af7a5367cf4$export$8ea68c6294970fa5(this._mediaStreamTrack, element);
            else $2d7d9af7a5367cf4$export$b8f95ef2322890b8(this._mediaStreamTrack, element);
        });
    }
    attach(element) {
        if (!element) element = super.attach();
        else super.attach(element);
        // It's possible attach is called multiple times on an element. When that's
        // the case, we'd want to avoid adding duplicate elementInfos
        if (this.adaptiveStreamSettings && this.elementInfos.find((info)=>info.element === element) === undefined) {
            const elementInfo = new $2d7d9af7a5367cf4$var$HTMLElementInfo(element);
            this.observeElementInfo(elementInfo);
        }
        return element;
    }
    /**
   * Observe an ElementInfo for changes when adaptive streaming.
   * @param elementInfo
   * @internal
   */ observeElementInfo(elementInfo) {
        if (this.adaptiveStreamSettings && this.elementInfos.find((info)=>info === elementInfo) === undefined) {
            elementInfo.handleResize = ()=>{
                this.debouncedHandleResize();
            };
            elementInfo.handleVisibilityChanged = ()=>{
                this.updateVisibility();
            };
            this.elementInfos.push(elementInfo);
            elementInfo.observe();
            // trigger the first resize update cycle
            // if the tab is backgrounded, the initial resize event does not fire until
            // the tab comes into focus for the first time.
            this.debouncedHandleResize();
            this.updateVisibility();
        } else this.log.warn('visibility resize observer not triggered', this.logContext);
    }
    /**
   * Stop observing an ElementInfo for changes.
   * @param elementInfo
   * @internal
   */ stopObservingElementInfo(elementInfo) {
        if (!this.isAdaptiveStream) {
            this.log.warn('stopObservingElementInfo ignored', this.logContext);
            return;
        }
        const stopElementInfos = this.elementInfos.filter((info)=>info === elementInfo);
        for (const info of stopElementInfos)info.stopObserving();
        this.elementInfos = this.elementInfos.filter((info)=>info !== elementInfo);
        this.updateVisibility();
        this.debouncedHandleResize();
    }
    detach(element) {
        let detachedElements = [];
        if (element) {
            this.stopObservingElement(element);
            return super.detach(element);
        }
        detachedElements = super.detach();
        for (const e of detachedElements)this.stopObservingElement(e);
        return detachedElements;
    }
    /** @internal */ getDecoderImplementation() {
        var _a;
        return (_a = this.prevStats) === null || _a === void 0 ? void 0 : _a.decoderImplementation;
    }
    getReceiverStats() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.receiver || !this.receiver.getStats) return;
            const stats = yield this.receiver.getStats();
            let receiverStats;
            let codecID = '';
            let codecs = new Map();
            stats.forEach((v)=>{
                if (v.type === 'inbound-rtp') {
                    codecID = v.codecId;
                    receiverStats = {
                        type: 'video',
                        framesDecoded: v.framesDecoded,
                        framesDropped: v.framesDropped,
                        framesReceived: v.framesReceived,
                        packetsReceived: v.packetsReceived,
                        packetsLost: v.packetsLost,
                        frameWidth: v.frameWidth,
                        frameHeight: v.frameHeight,
                        pliCount: v.pliCount,
                        firCount: v.firCount,
                        nackCount: v.nackCount,
                        jitter: v.jitter,
                        timestamp: v.timestamp,
                        bytesReceived: v.bytesReceived,
                        decoderImplementation: v.decoderImplementation
                    };
                } else if (v.type === 'codec') codecs.set(v.id, v);
            });
            if (receiverStats && codecID !== '' && codecs.get(codecID)) receiverStats.mimeType = codecs.get(codecID).mimeType;
            return receiverStats;
        });
    }
    stopObservingElement(element) {
        const stopElementInfos = this.elementInfos.filter((info)=>info.element === element);
        for (const info of stopElementInfos)this.stopObservingElementInfo(info);
    }
    handleAppVisibilityChanged() {
        const _super = Object.create(null, {
            handleAppVisibilityChanged: {
                get: ()=>super.handleAppVisibilityChanged
            }
        });
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            yield _super.handleAppVisibilityChanged.call(this);
            if (!this.isAdaptiveStream) return;
            this.updateVisibility();
        });
    }
    updateVisibility() {
        var _a, _b;
        const lastVisibilityChange = this.elementInfos.reduce((prev, info)=>Math.max(prev, info.visibilityChangedAt || 0), 0);
        const backgroundPause = ((_b = (_a = this.adaptiveStreamSettings) === null || _a === void 0 ? void 0 : _a.pauseVideoInBackground) !== null && _b !== void 0 ? _b : true // default to true
        ) ? this.isInBackground : false;
        const isPiPMode = this.elementInfos.some((info)=>info.pictureInPicture);
        const isVisible = this.elementInfos.some((info)=>info.visible) && !backgroundPause || isPiPMode;
        if (this.lastVisible === isVisible) return;
        if (!isVisible && Date.now() - lastVisibilityChange < $2d7d9af7a5367cf4$var$REACTION_DELAY) {
            // delay hidden events
            $2d7d9af7a5367cf4$export$22e737276454df96.setTimeout(()=>{
                this.updateVisibility();
            }, $2d7d9af7a5367cf4$var$REACTION_DELAY);
            return;
        }
        this.lastVisible = isVisible;
        this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.VisibilityChanged, isVisible, this);
    }
    updateDimensions() {
        var _a, _b;
        let maxWidth = 0;
        let maxHeight = 0;
        const pixelDensity = this.getPixelDensity();
        for (const info of this.elementInfos){
            const currentElementWidth = info.width() * pixelDensity;
            const currentElementHeight = info.height() * pixelDensity;
            if (currentElementWidth + currentElementHeight > maxWidth + maxHeight) {
                maxWidth = currentElementWidth;
                maxHeight = currentElementHeight;
            }
        }
        if (((_a = this.lastDimensions) === null || _a === void 0 ? void 0 : _a.width) === maxWidth && ((_b = this.lastDimensions) === null || _b === void 0 ? void 0 : _b.height) === maxHeight) return;
        this.lastDimensions = {
            width: maxWidth,
            height: maxHeight
        };
        this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.VideoDimensionsChanged, this.lastDimensions, this);
    }
    getPixelDensity() {
        var _a;
        const pixelDensity = (_a = this.adaptiveStreamSettings) === null || _a === void 0 ? void 0 : _a.pixelDensity;
        if (pixelDensity === 'screen') return $2d7d9af7a5367cf4$var$getDevicePixelRatio();
        else if (!pixelDensity) {
            // when unset, we'll pick a sane default here.
            // for higher pixel density devices (mobile phones, etc), we'll use 2
            // otherwise it defaults to 1
            const devicePixelRatio = $2d7d9af7a5367cf4$var$getDevicePixelRatio();
            if (devicePixelRatio > 2) return 2;
            else return 1;
        }
        return pixelDensity;
    }
}
class $2d7d9af7a5367cf4$var$HTMLElementInfo {
    get visible() {
        return this.isPiP || this.isIntersecting;
    }
    get pictureInPicture() {
        return this.isPiP;
    }
    constructor(element, visible){
        this.onVisibilityChanged = (entry)=>{
            var _a;
            const { target: target, isIntersecting: isIntersecting } = entry;
            if (target === this.element) {
                this.isIntersecting = isIntersecting;
                this.isPiP = $2d7d9af7a5367cf4$var$isElementInPiP(this.element);
                this.visibilityChangedAt = Date.now();
                (_a = this.handleVisibilityChanged) === null || _a === void 0 || _a.call(this);
            }
        };
        this.onEnterPiP = ()=>{
            var _a, _b, _c;
            (_b = (_a = window.documentPictureInPicture) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 || _b.addEventListener('pagehide', this.onLeavePiP);
            this.isPiP = $2d7d9af7a5367cf4$var$isElementInPiP(this.element);
            (_c = this.handleVisibilityChanged) === null || _c === void 0 || _c.call(this);
        };
        this.onLeavePiP = ()=>{
            var _a;
            this.isPiP = $2d7d9af7a5367cf4$var$isElementInPiP(this.element);
            (_a = this.handleVisibilityChanged) === null || _a === void 0 || _a.call(this);
        };
        this.element = element;
        this.isIntersecting = visible !== null && visible !== void 0 ? visible : $2d7d9af7a5367cf4$var$isElementInViewport(element);
        this.isPiP = $2d7d9af7a5367cf4$var$isWeb() && $2d7d9af7a5367cf4$var$isElementInPiP(element);
        this.visibilityChangedAt = 0;
    }
    width() {
        return this.element.clientWidth;
    }
    height() {
        return this.element.clientHeight;
    }
    observe() {
        var _a, _b, _c;
        // make sure we update the current visible state once we start to observe
        this.isIntersecting = $2d7d9af7a5367cf4$var$isElementInViewport(this.element);
        this.isPiP = $2d7d9af7a5367cf4$var$isElementInPiP(this.element);
        this.element.handleResize = ()=>{
            var _a;
            (_a = this.handleResize) === null || _a === void 0 || _a.call(this);
        };
        this.element.handleVisibilityChanged = this.onVisibilityChanged;
        $2d7d9af7a5367cf4$var$getIntersectionObserver().observe(this.element);
        $2d7d9af7a5367cf4$var$getResizeObserver().observe(this.element);
        this.element.addEventListener('enterpictureinpicture', this.onEnterPiP);
        this.element.addEventListener('leavepictureinpicture', this.onLeavePiP);
        (_a = window.documentPictureInPicture) === null || _a === void 0 || _a.addEventListener('enter', this.onEnterPiP);
        (_c = (_b = window.documentPictureInPicture) === null || _b === void 0 ? void 0 : _b.window) === null || _c === void 0 || _c.addEventListener('pagehide', this.onLeavePiP);
    }
    stopObserving() {
        var _a, _b, _c, _d, _e;
        (_a = $2d7d9af7a5367cf4$var$getIntersectionObserver()) === null || _a === void 0 || _a.unobserve(this.element);
        (_b = $2d7d9af7a5367cf4$var$getResizeObserver()) === null || _b === void 0 || _b.unobserve(this.element);
        this.element.removeEventListener('enterpictureinpicture', this.onEnterPiP);
        this.element.removeEventListener('leavepictureinpicture', this.onLeavePiP);
        (_c = window.documentPictureInPicture) === null || _c === void 0 || _c.removeEventListener('enter', this.onEnterPiP);
        (_e = (_d = window.documentPictureInPicture) === null || _d === void 0 ? void 0 : _d.window) === null || _e === void 0 || _e.removeEventListener('pagehide', this.onLeavePiP);
    }
}
function $2d7d9af7a5367cf4$var$isElementInPiP(el) {
    var _a, _b;
    // Simple video PiP
    if (document.pictureInPictureElement === el) return true;
    // Document PiP
    if ((_a = window.documentPictureInPicture) === null || _a === void 0 ? void 0 : _a.window) return $2d7d9af7a5367cf4$var$isElementInViewport(el, (_b = window.documentPictureInPicture) === null || _b === void 0 ? void 0 : _b.window);
    return false;
}
// does not account for occlusion by other elements or opacity property
function $2d7d9af7a5367cf4$var$isElementInViewport(el, win) {
    const viewportWindow = win || window;
    let top = el.offsetTop;
    let left = el.offsetLeft;
    const width = el.offsetWidth;
    const height = el.offsetHeight;
    const { hidden: hidden } = el;
    const { display: display } = getComputedStyle(el);
    while(el.offsetParent){
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }
    return top < viewportWindow.pageYOffset + viewportWindow.innerHeight && left < viewportWindow.pageXOffset + viewportWindow.innerWidth && top + height > viewportWindow.pageYOffset && left + width > viewportWindow.pageXOffset && !hidden && display !== 'none';
}
class $2d7d9af7a5367cf4$export$7c531331788c3797 extends $2d7d9af7a5367cf4$var$eventsExports.EventEmitter {
    constructor(kind, id, name, loggerOptions){
        var _a;
        super();
        this.metadataMuted = false;
        this.encryption = $2d7d9af7a5367cf4$var$Encryption_Type.NONE;
        this.log = $2d7d9af7a5367cf4$var$livekitLogger;
        this.handleMuted = ()=>{
            this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.Muted);
        };
        this.handleUnmuted = ()=>{
            this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.Unmuted);
        };
        this.log = $2d7d9af7a5367cf4$export$2b1d391cd05230fd((_a = loggerOptions === null || loggerOptions === void 0 ? void 0 : loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $2d7d9af7a5367cf4$export$69ba24dd79f4da21.Publication);
        this.loggerContextCb = this.loggerContextCb;
        this.setMaxListeners(100);
        this.kind = kind;
        this.trackSid = id;
        this.trackName = name;
        this.source = $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Unknown;
    }
    /** @internal */ setTrack(track) {
        if (this.track) {
            this.track.off($2d7d9af7a5367cf4$export$2c8510d737cc09da.Muted, this.handleMuted);
            this.track.off($2d7d9af7a5367cf4$export$2c8510d737cc09da.Unmuted, this.handleUnmuted);
        }
        this.track = track;
        if (track) {
            // forward events
            track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.Muted, this.handleMuted);
            track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.Unmuted, this.handleUnmuted);
        }
    }
    get logContext() {
        var _a;
        return Object.assign(Object.assign({}, (_a = this.loggerContextCb) === null || _a === void 0 ? void 0 : _a.call(this)), $2d7d9af7a5367cf4$var$getLogContextFromTrack(this));
    }
    get isMuted() {
        return this.metadataMuted;
    }
    get isEnabled() {
        return true;
    }
    get isSubscribed() {
        return this.track !== undefined;
    }
    get isEncrypted() {
        return this.encryption !== $2d7d9af7a5367cf4$var$Encryption_Type.NONE;
    }
    /**
   * an [AudioTrack] if this publication holds an audio track
   */ get audioTrack() {
        if (this.track instanceof $2d7d9af7a5367cf4$export$b287427b771ca237 || this.track instanceof $2d7d9af7a5367cf4$export$fd37b116bd840ced) return this.track;
    }
    /**
   * an [VideoTrack] if this publication holds a video track
   */ get videoTrack() {
        if (this.track instanceof $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc || this.track instanceof $2d7d9af7a5367cf4$export$1db0c0ebd3ae1523) return this.track;
    }
    /** @internal */ updateInfo(info) {
        this.trackSid = info.sid;
        this.trackName = info.name;
        this.source = $2d7d9af7a5367cf4$export$13921ac0cc260818.sourceFromProto(info.source);
        this.mimeType = info.mimeType;
        if (this.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video && info.width > 0) {
            this.dimensions = {
                width: info.width,
                height: info.height
            };
            this.simulcasted = info.simulcast;
        }
        this.encryption = info.encryption;
        this.trackInfo = info;
        this.log.debug('update publication info', Object.assign(Object.assign({}, this.logContext), {
            info: info
        }));
    }
}
(function(TrackPublication) {
    (function(SubscriptionStatus) {
        SubscriptionStatus["Desired"] = "desired";
        SubscriptionStatus["Subscribed"] = "subscribed";
        SubscriptionStatus["Unsubscribed"] = "unsubscribed";
    })(TrackPublication.SubscriptionStatus || (TrackPublication.SubscriptionStatus = {}));
    (function(PermissionStatus) {
        PermissionStatus["Allowed"] = "allowed";
        PermissionStatus["NotAllowed"] = "not_allowed";
    })(TrackPublication.PermissionStatus || (TrackPublication.PermissionStatus = {}));
})($2d7d9af7a5367cf4$export$7c531331788c3797 || ($2d7d9af7a5367cf4$export$7c531331788c3797 = {}));
class $2d7d9af7a5367cf4$export$885a52c769210b3f extends $2d7d9af7a5367cf4$export$7c531331788c3797 {
    get isUpstreamPaused() {
        var _a;
        return (_a = this.track) === null || _a === void 0 ? void 0 : _a.isUpstreamPaused;
    }
    constructor(kind, ti, track, loggerOptions){
        super(kind, ti.sid, ti.name, loggerOptions);
        this.track = undefined;
        this.handleTrackEnded = ()=>{
            this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.Ended);
        };
        this.updateInfo(ti);
        this.setTrack(track);
    }
    setTrack(track) {
        if (this.track) this.track.off($2d7d9af7a5367cf4$export$2c8510d737cc09da.Ended, this.handleTrackEnded);
        super.setTrack(track);
        if (track) track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.Ended, this.handleTrackEnded);
    }
    get isMuted() {
        if (this.track) return this.track.isMuted;
        return super.isMuted;
    }
    get audioTrack() {
        return super.audioTrack;
    }
    get videoTrack() {
        return super.videoTrack;
    }
    /**
   * Mute the track associated with this publication
   */ mute() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            return (_a = this.track) === null || _a === void 0 ? void 0 : _a.mute();
        });
    }
    /**
   * Unmute track associated with this publication
   */ unmute() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            return (_a = this.track) === null || _a === void 0 ? void 0 : _a.unmute();
        });
    }
    /**
   * Pauses the media stream track associated with this publication from being sent to the server
   * and signals "muted" event to other participants
   * Useful if you want to pause the stream without pausing the local media stream track
   */ pauseUpstream() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            yield (_a = this.track) === null || _a === void 0 ? void 0 : _a.pauseUpstream();
        });
    }
    /**
   * Resumes sending the media stream track associated with this publication to the server after a call to [[pauseUpstream()]]
   * and signals "unmuted" event to other participants (unless the track is explicitly muted)
   */ resumeUpstream() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            yield (_a = this.track) === null || _a === void 0 ? void 0 : _a.resumeUpstream();
        });
    }
    getTrackFeatures() {
        var _a;
        if (this.track instanceof $2d7d9af7a5367cf4$export$b287427b771ca237) {
            const settings = this.track.getSourceTrackSettings();
            const features = new Set();
            if (settings.autoGainControl) features.add($2d7d9af7a5367cf4$var$AudioTrackFeature.TF_AUTO_GAIN_CONTROL);
            if (settings.echoCancellation) features.add($2d7d9af7a5367cf4$var$AudioTrackFeature.TF_ECHO_CANCELLATION);
            if (settings.noiseSuppression) features.add($2d7d9af7a5367cf4$var$AudioTrackFeature.TF_NOISE_SUPPRESSION);
            if (settings.channelCount && settings.channelCount > 1) features.add($2d7d9af7a5367cf4$var$AudioTrackFeature.TF_STEREO);
            if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.dtx)) features.add($2d7d9af7a5367cf4$var$AudioTrackFeature.TF_NO_DTX);
            if (this.track.enhancedNoiseCancellation) features.add($2d7d9af7a5367cf4$var$AudioTrackFeature.TF_ENHANCED_NOISE_CANCELLATION);
            return Array.from(features.values());
        } else return [];
    }
}
var $2d7d9af7a5367cf4$export$16148de7856f4643;
(function(ConnectionQuality) {
    ConnectionQuality["Excellent"] = "excellent";
    ConnectionQuality["Good"] = "good";
    ConnectionQuality["Poor"] = "poor";
    /**
   * Indicates that a participant has temporarily (or permanently) lost connection to LiveKit.
   * For permanent disconnection a `ParticipantDisconnected` event will be emitted after a timeout
   */ ConnectionQuality["Lost"] = "lost";
    ConnectionQuality["Unknown"] = "unknown";
})($2d7d9af7a5367cf4$export$16148de7856f4643 || ($2d7d9af7a5367cf4$export$16148de7856f4643 = {}));
function $2d7d9af7a5367cf4$var$qualityFromProto(q) {
    switch(q){
        case $2d7d9af7a5367cf4$var$ConnectionQuality$1.EXCELLENT:
            return $2d7d9af7a5367cf4$export$16148de7856f4643.Excellent;
        case $2d7d9af7a5367cf4$var$ConnectionQuality$1.GOOD:
            return $2d7d9af7a5367cf4$export$16148de7856f4643.Good;
        case $2d7d9af7a5367cf4$var$ConnectionQuality$1.POOR:
            return $2d7d9af7a5367cf4$export$16148de7856f4643.Poor;
        case $2d7d9af7a5367cf4$var$ConnectionQuality$1.LOST:
            return $2d7d9af7a5367cf4$export$16148de7856f4643.Lost;
        default:
            return $2d7d9af7a5367cf4$export$16148de7856f4643.Unknown;
    }
}
class $2d7d9af7a5367cf4$export$aada361ed1a6c65 extends $2d7d9af7a5367cf4$var$eventsExports.EventEmitter {
    get logContext() {
        var _a, _b;
        return Object.assign({}, (_b = (_a = this.loggerOptions) === null || _a === void 0 ? void 0 : _a.loggerContextCb) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    get isEncrypted() {
        return this.trackPublications.size > 0 && Array.from(this.trackPublications.values()).every((tr)=>tr.isEncrypted);
    }
    get isAgent() {
        var _a;
        return ((_a = this.permissions) === null || _a === void 0 ? void 0 : _a.agent) || this.kind === $2d7d9af7a5367cf4$export$2079c0e1523aec29.AGENT;
    }
    get kind() {
        return this._kind;
    }
    /** participant attributes, similar to metadata, but as a key/value map */ get attributes() {
        return Object.freeze(Object.assign({}, this._attributes));
    }
    /** @internal */ constructor(sid, identity, name, metadata, attributes, loggerOptions){
        let kind = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : $2d7d9af7a5367cf4$export$2079c0e1523aec29.STANDARD;
        var _a;
        super();
        /** audio level between 0-1.0, 1 being loudest, 0 being softest */ this.audioLevel = 0;
        /** if participant is currently speaking */ this.isSpeaking = false;
        this._connectionQuality = $2d7d9af7a5367cf4$export$16148de7856f4643.Unknown;
        this.log = $2d7d9af7a5367cf4$var$livekitLogger;
        this.log = $2d7d9af7a5367cf4$export$2b1d391cd05230fd((_a = loggerOptions === null || loggerOptions === void 0 ? void 0 : loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $2d7d9af7a5367cf4$export$69ba24dd79f4da21.Participant);
        this.loggerOptions = loggerOptions;
        this.setMaxListeners(100);
        this.sid = sid;
        this.identity = identity;
        this.name = name;
        this.metadata = metadata;
        this.audioTrackPublications = new Map();
        this.videoTrackPublications = new Map();
        this.trackPublications = new Map();
        this._kind = kind;
        this._attributes = attributes !== null && attributes !== void 0 ? attributes : {};
    }
    getTrackPublications() {
        return Array.from(this.trackPublications.values());
    }
    /**
   * Finds the first track that matches the source filter, for example, getting
   * the user's camera track with getTrackBySource(Track.Source.Camera).
   */ getTrackPublication(source) {
        for (const [, pub] of this.trackPublications){
            if (pub.source === source) return pub;
        }
    }
    /**
   * Finds the first track that matches the track's name.
   */ getTrackPublicationByName(name) {
        for (const [, pub] of this.trackPublications){
            if (pub.trackName === name) return pub;
        }
    }
    get connectionQuality() {
        return this._connectionQuality;
    }
    get isCameraEnabled() {
        var _a;
        const track = this.getTrackPublication($2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Camera);
        return !((_a = track === null || track === void 0 ? void 0 : track.isMuted) !== null && _a !== void 0 ? _a : true);
    }
    get isMicrophoneEnabled() {
        var _a;
        const track = this.getTrackPublication($2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Microphone);
        return !((_a = track === null || track === void 0 ? void 0 : track.isMuted) !== null && _a !== void 0 ? _a : true);
    }
    get isScreenShareEnabled() {
        const track = this.getTrackPublication($2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShare);
        return !!track;
    }
    get isLocal() {
        return false;
    }
    /** when participant joined the room */ get joinedAt() {
        if (this.participantInfo) return new Date(Number.parseInt(this.participantInfo.joinedAt.toString()) * 1000);
        return new Date();
    }
    /** @internal */ updateInfo(info) {
        // it's possible the update could be applied out of order due to await
        // during reconnect sequences. when that happens, it's possible for server
        // to have sent more recent version of participant info while JS is waiting
        // to process the existing payload.
        // when the participant sid remains the same, and we already have a later version
        // of the payload, they can be safely skipped
        if (this.participantInfo && this.participantInfo.sid === info.sid && this.participantInfo.version > info.version) return false;
        this.identity = info.identity;
        this.sid = info.sid;
        this._setName(info.name);
        this._setMetadata(info.metadata);
        this._setAttributes(info.attributes);
        if (info.permission) this.setPermissions(info.permission);
        // set this last so setMetadata can detect changes
        this.participantInfo = info;
        this.log.trace('update participant info', Object.assign(Object.assign({}, this.logContext), {
            info: info
        }));
        return true;
    }
    /**
   * Updates metadata from server
   **/ _setMetadata(md) {
        const changed = this.metadata !== md;
        const prevMetadata = this.metadata;
        this.metadata = md;
        if (changed) this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ParticipantMetadataChanged, prevMetadata);
    }
    _setName(name) {
        const changed = this.name !== name;
        this.name = name;
        if (changed) this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ParticipantNameChanged, name);
    }
    /**
   * Updates metadata from server
   **/ _setAttributes(attributes) {
        const diff = $2d7d9af7a5367cf4$var$diffAttributes(this.attributes, attributes);
        this._attributes = attributes;
        if (Object.keys(diff).length > 0) this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.AttributesChanged, diff);
    }
    /** @internal */ setPermissions(permissions) {
        var _a, _b, _c, _d, _e, _f;
        const prevPermissions = this.permissions;
        const changed = permissions.canPublish !== ((_a = this.permissions) === null || _a === void 0 ? void 0 : _a.canPublish) || permissions.canSubscribe !== ((_b = this.permissions) === null || _b === void 0 ? void 0 : _b.canSubscribe) || permissions.canPublishData !== ((_c = this.permissions) === null || _c === void 0 ? void 0 : _c.canPublishData) || permissions.hidden !== ((_d = this.permissions) === null || _d === void 0 ? void 0 : _d.hidden) || permissions.recorder !== ((_e = this.permissions) === null || _e === void 0 ? void 0 : _e.recorder) || permissions.canPublishSources.length !== this.permissions.canPublishSources.length || permissions.canPublishSources.some((value, index)=>{
            var _a;
            return value !== ((_a = this.permissions) === null || _a === void 0 ? void 0 : _a.canPublishSources[index]);
        }) || permissions.canSubscribeMetrics !== ((_f = this.permissions) === null || _f === void 0 ? void 0 : _f.canSubscribeMetrics);
        this.permissions = permissions;
        if (changed) this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ParticipantPermissionsChanged, prevPermissions);
        return changed;
    }
    /** @internal */ setIsSpeaking(speaking) {
        if (speaking === this.isSpeaking) return;
        this.isSpeaking = speaking;
        if (speaking) this.lastSpokeAt = new Date();
        this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.IsSpeakingChanged, speaking);
    }
    /** @internal */ setConnectionQuality(q) {
        const prevQuality = this._connectionQuality;
        this._connectionQuality = $2d7d9af7a5367cf4$var$qualityFromProto(q);
        if (prevQuality !== this._connectionQuality) this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ConnectionQualityChanged, this._connectionQuality);
    }
    /**
   * @internal
   */ setAudioContext(ctx) {
        this.audioContext = ctx;
        this.audioTrackPublications.forEach((track)=>(track.track instanceof $2d7d9af7a5367cf4$export$fd37b116bd840ced || track.track instanceof $2d7d9af7a5367cf4$export$b287427b771ca237) && track.track.setAudioContext(ctx));
    }
    addTrackPublication(publication) {
        // forward publication driven events
        publication.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.Muted, ()=>{
            this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackMuted, publication);
        });
        publication.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.Unmuted, ()=>{
            this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackUnmuted, publication);
        });
        const pub = publication;
        if (pub.track) pub.track.sid = publication.trackSid;
        this.trackPublications.set(publication.trackSid, publication);
        switch(publication.kind){
            case $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Audio:
                this.audioTrackPublications.set(publication.trackSid, publication);
                break;
            case $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video:
                this.videoTrackPublications.set(publication.trackSid, publication);
                break;
        }
    }
}
function $2d7d9af7a5367cf4$var$trackPermissionToProto(perms) {
    var _a, _b, _c;
    if (!perms.participantSid && !perms.participantIdentity) throw new Error('Invalid track permission, must provide at least one of participantIdentity and participantSid');
    return new $2d7d9af7a5367cf4$var$TrackPermission({
        participantIdentity: (_a = perms.participantIdentity) !== null && _a !== void 0 ? _a : '',
        participantSid: (_b = perms.participantSid) !== null && _b !== void 0 ? _b : '',
        allTracks: (_c = perms.allowAll) !== null && _c !== void 0 ? _c : false,
        trackSids: perms.allowedTrackSids || []
    });
}
class $2d7d9af7a5367cf4$export$ed007fa30041dd89 extends $2d7d9af7a5367cf4$export$aada361ed1a6c65 {
    /** @internal */ constructor(sid, identity, engine, options){
        super(sid, identity, undefined, undefined, undefined, {
            loggerName: options.loggerName,
            loggerContextCb: ()=>this.engine.logContext
        });
        this.pendingPublishing = new Set();
        this.pendingPublishPromises = new Map();
        this.participantTrackPermissions = [];
        this.allParticipantsAllowedToSubscribe = true;
        this.encryptionType = $2d7d9af7a5367cf4$var$Encryption_Type.NONE;
        this.enabledPublishVideoCodecs = [];
        this.rpcHandlers = new Map();
        this.pendingAcks = new Map();
        this.pendingResponses = new Map();
        this.handleReconnecting = ()=>{
            if (!this.reconnectFuture) this.reconnectFuture = new $2d7d9af7a5367cf4$var$Future();
        };
        this.handleReconnected = ()=>{
            var _a, _b;
            (_b = (_a = this.reconnectFuture) === null || _a === void 0 ? void 0 : _a.resolve) === null || _b === void 0 || _b.call(_a);
            this.reconnectFuture = undefined;
            this.updateTrackSubscriptionPermissions();
        };
        this.handleDisconnected = ()=>{
            var _a, _b;
            if (this.reconnectFuture) {
                this.reconnectFuture.promise.catch((e)=>this.log.warn(e.message, this.logContext));
                (_b = (_a = this.reconnectFuture) === null || _a === void 0 ? void 0 : _a.reject) === null || _b === void 0 || _b.call(_a, 'Got disconnected during reconnection attempt');
                this.reconnectFuture = undefined;
            }
        };
        this.handleSignalRequestResponse = (response)=>{
            const { requestId: requestId, reason: reason, message: message } = response;
            const targetRequest = this.pendingSignalRequests.get(requestId);
            if (targetRequest) {
                if (reason !== $2d7d9af7a5367cf4$var$RequestResponse_Reason.OK) targetRequest.reject(new $2d7d9af7a5367cf4$export$cb33ebbc4df8a708(message, reason));
                this.pendingSignalRequests.delete(requestId);
            }
        };
        this.handleDataPacket = (packet)=>{
            switch(packet.value.case){
                case 'rpcRequest':
                    let rpcRequest = packet.value.value;
                    this.handleIncomingRpcRequest(packet.participantIdentity, rpcRequest.id, rpcRequest.method, rpcRequest.payload, rpcRequest.responseTimeoutMs, rpcRequest.version);
                    break;
                case 'rpcResponse':
                    let rpcResponse = packet.value.value;
                    let payload = null;
                    let error = null;
                    if (rpcResponse.value.case === 'payload') payload = rpcResponse.value.value;
                    else if (rpcResponse.value.case === 'error') error = $2d7d9af7a5367cf4$export$5460eff990f31920.fromProto(rpcResponse.value.value);
                    this.handleIncomingRpcResponse(rpcResponse.requestId, payload, error);
                    break;
                case 'rpcAck':
                    let rpcAck = packet.value.value;
                    this.handleIncomingRpcAck(rpcAck.requestId);
                    break;
            }
        };
        this.updateTrackSubscriptionPermissions = ()=>{
            this.log.debug('updating track subscription permissions', Object.assign(Object.assign({}, this.logContext), {
                allParticipantsAllowed: this.allParticipantsAllowedToSubscribe,
                participantTrackPermissions: this.participantTrackPermissions
            }));
            this.engine.client.sendUpdateSubscriptionPermissions(this.allParticipantsAllowedToSubscribe, this.participantTrackPermissions.map((p)=>$2d7d9af7a5367cf4$var$trackPermissionToProto(p)));
        };
        /** @internal */ this.onTrackUnmuted = (track)=>{
            this.onTrackMuted(track, track.isUpstreamPaused);
        };
        // when the local track changes in mute status, we'll notify server as such
        /** @internal */ this.onTrackMuted = (track, muted)=>{
            if (muted === undefined) muted = true;
            if (!track.sid) {
                this.log.error('could not update mute status for unpublished track', Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(track)));
                return;
            }
            this.engine.updateMuteStatus(track.sid, muted);
        };
        this.onTrackUpstreamPaused = (track)=>{
            this.log.debug('upstream paused', Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(track)));
            this.onTrackMuted(track, true);
        };
        this.onTrackUpstreamResumed = (track)=>{
            this.log.debug('upstream resumed', Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(track)));
            this.onTrackMuted(track, track.isMuted);
        };
        this.onTrackFeatureUpdate = (track)=>{
            const pub = this.audioTrackPublications.get(track.sid);
            if (!pub) {
                this.log.warn("Could not update local audio track settings, missing publication for track ".concat(track.sid), this.logContext);
                return;
            }
            this.engine.client.sendUpdateLocalAudioTrack(pub.trackSid, pub.getTrackFeatures());
        };
        this.handleSubscribedQualityUpdate = (update)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                var _a, e_1, _b, _c;
                var _d, _e;
                if (!((_d = this.roomOptions) === null || _d === void 0 ? void 0 : _d.dynacast)) return;
                const pub = this.videoTrackPublications.get(update.trackSid);
                if (!pub) {
                    this.log.warn('received subscribed quality update for unknown track', Object.assign(Object.assign({}, this.logContext), {
                        trackSid: update.trackSid
                    }));
                    return;
                }
                if (update.subscribedCodecs.length > 0) {
                    if (!pub.videoTrack) return;
                    const newCodecs = yield pub.videoTrack.setPublishingCodecs(update.subscribedCodecs);
                    try {
                        for(var _f = true, newCodecs_1 = $2d7d9af7a5367cf4$var$__asyncValues(newCodecs), newCodecs_1_1; newCodecs_1_1 = yield newCodecs_1.next(), _a = newCodecs_1_1.done, !_a; _f = true){
                            _c = newCodecs_1_1.value;
                            _f = false;
                            const codec = _c;
                            if ($2d7d9af7a5367cf4$export$da37a49ee77f9d77(codec)) {
                                this.log.debug("publish ".concat(codec, " for ").concat(pub.videoTrack.sid), Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(pub)));
                                yield this.publishAdditionalCodecForTrack(pub.videoTrack, codec, pub.options);
                            }
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (!_f && !_a && (_b = newCodecs_1.return)) yield _b.call(newCodecs_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                } else if (update.subscribedQualities.length > 0) yield (_e = pub.videoTrack) === null || _e === void 0 ? void 0 : _e.setPublishingLayers(update.subscribedQualities);
            });
        this.handleLocalTrackUnpublished = (unpublished)=>{
            const track = this.trackPublications.get(unpublished.trackSid);
            if (!track) {
                this.log.warn('received unpublished event for unknown track', Object.assign(Object.assign({}, this.logContext), {
                    trackSid: unpublished.trackSid
                }));
                return;
            }
            this.unpublishTrack(track.track);
        };
        this.handleTrackEnded = (track)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                if (track.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShare || track.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShareAudio) {
                    this.log.debug('unpublishing local track due to TrackEnded', Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(track)));
                    this.unpublishTrack(track);
                } else if (track.isUserProvided) yield track.mute();
                else if (track instanceof $2d7d9af7a5367cf4$export$b287427b771ca237 || track instanceof $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc) try {
                    if ($2d7d9af7a5367cf4$var$isWeb()) try {
                        const currentPermissions = yield navigator === null || navigator === void 0 ? void 0 : navigator.permissions.query({
                            // the permission query for camera and microphone currently not supported in Safari and Firefox
                            // @ts-ignore
                            name: track.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Camera ? 'camera' : 'microphone'
                        });
                        if (currentPermissions && currentPermissions.state === 'denied') {
                            this.log.warn("user has revoked access to ".concat(track.source), Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(track)));
                            // detect granted change after permissions were denied to try and resume then
                            currentPermissions.onchange = ()=>{
                                if (currentPermissions.state !== 'denied') {
                                    if (!track.isMuted) track.restartTrack();
                                    currentPermissions.onchange = null;
                                }
                            };
                            throw new Error('GetUserMedia Permission denied');
                        }
                    } catch (e) {
                    // permissions query fails for firefox, we continue and try to restart the track
                    }
                    if (!track.isMuted) {
                        this.log.debug('track ended, attempting to use a different device', Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(track)));
                        if (track instanceof $2d7d9af7a5367cf4$export$b287427b771ca237) // fall back to default device if available
                        yield track.restartTrack({
                            deviceId: 'default'
                        });
                        else yield track.restartTrack();
                    }
                } catch (e) {
                    this.log.warn("could not restart track, muting instead", Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(track)));
                    yield track.mute();
                }
            });
        this.audioTrackPublications = new Map();
        this.videoTrackPublications = new Map();
        this.trackPublications = new Map();
        this.engine = engine;
        this.roomOptions = options;
        this.setupEngine(engine);
        this.activeDeviceMap = new Map();
        this.pendingSignalRequests = new Map();
    }
    get lastCameraError() {
        return this.cameraError;
    }
    get lastMicrophoneError() {
        return this.microphoneError;
    }
    get isE2EEEnabled() {
        return this.encryptionType !== $2d7d9af7a5367cf4$var$Encryption_Type.NONE;
    }
    getTrackPublication(source) {
        const track = super.getTrackPublication(source);
        if (track) return track;
    }
    getTrackPublicationByName(name) {
        const track = super.getTrackPublicationByName(name);
        if (track) return track;
    }
    /**
   * @internal
   */ setupEngine(engine) {
        this.engine = engine;
        this.engine.on($2d7d9af7a5367cf4$export$c09e63b8572f869.RemoteMute, (trackSid, muted)=>{
            const pub = this.trackPublications.get(trackSid);
            if (!pub || !pub.track) return;
            if (muted) pub.mute();
            else pub.unmute();
        });
        this.engine.on($2d7d9af7a5367cf4$export$c09e63b8572f869.Connected, this.handleReconnected).on($2d7d9af7a5367cf4$export$c09e63b8572f869.SignalRestarted, this.handleReconnected).on($2d7d9af7a5367cf4$export$c09e63b8572f869.SignalResumed, this.handleReconnected).on($2d7d9af7a5367cf4$export$c09e63b8572f869.Restarting, this.handleReconnecting).on($2d7d9af7a5367cf4$export$c09e63b8572f869.Resuming, this.handleReconnecting).on($2d7d9af7a5367cf4$export$c09e63b8572f869.LocalTrackUnpublished, this.handleLocalTrackUnpublished).on($2d7d9af7a5367cf4$export$c09e63b8572f869.SubscribedQualityUpdate, this.handleSubscribedQualityUpdate).on($2d7d9af7a5367cf4$export$c09e63b8572f869.Disconnected, this.handleDisconnected).on($2d7d9af7a5367cf4$export$c09e63b8572f869.SignalRequestResponse, this.handleSignalRequestResponse).on($2d7d9af7a5367cf4$export$c09e63b8572f869.DataPacketReceived, this.handleDataPacket);
    }
    /**
   * Sets and updates the metadata of the local participant.
   * Note: this requires `canUpdateOwnMetadata` permission.
   * method will throw if the user doesn't have the required permissions
   * @param metadata
   */ setMetadata(metadata) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            yield this.requestMetadataUpdate({
                metadata: metadata
            });
        });
    }
    /**
   * Sets and updates the name of the local participant.
   * Note: this requires `canUpdateOwnMetadata` permission.
   * method will throw if the user doesn't have the required permissions
   * @param metadata
   */ setName(name) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            yield this.requestMetadataUpdate({
                name: name
            });
        });
    }
    /**
   * Set or update participant attributes. It will make updates only to keys that
   * are present in `attributes`, and will not override others.
   * Note: this requires `canUpdateOwnMetadata` permission.
   * @param attributes attributes to update
   */ setAttributes(attributes) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            yield this.requestMetadataUpdate({
                attributes: attributes
            });
        });
    }
    requestMetadataUpdate(_a) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function(_ref) {
            var _this = this;
            let { metadata: metadata, name: name, attributes: attributes } = _ref;
            return function*() {
                return new Promise((resolve, reject)=>$2d7d9af7a5367cf4$var$__awaiter(_this, void 0, void 0, function*() {
                        var _a, _b;
                        try {
                            let isRejected = false;
                            const requestId = yield this.engine.client.sendUpdateLocalMetadata((_a = metadata !== null && metadata !== void 0 ? metadata : this.metadata) !== null && _a !== void 0 ? _a : '', (_b = name !== null && name !== void 0 ? name : this.name) !== null && _b !== void 0 ? _b : '', attributes);
                            const startTime = performance.now();
                            this.pendingSignalRequests.set(requestId, {
                                resolve: resolve,
                                reject: (error)=>{
                                    reject(error);
                                    isRejected = true;
                                },
                                values: {
                                    name: name,
                                    metadata: metadata,
                                    attributes: attributes
                                }
                            });
                            while(performance.now() - startTime < 5000 && !isRejected){
                                if ((!name || this.name === name) && (!metadata || this.metadata === metadata) && (!attributes || Object.entries(attributes).every((_ref2)=>{
                                    let [key, value] = _ref2;
                                    return this.attributes[key] === value || value === '' && !this.attributes[key];
                                }))) {
                                    this.pendingSignalRequests.delete(requestId);
                                    resolve();
                                    return;
                                }
                                yield $2d7d9af7a5367cf4$var$sleep(50);
                            }
                            reject(new $2d7d9af7a5367cf4$export$cb33ebbc4df8a708('Request to update local metadata timed out', 'TimeoutError'));
                        } catch (e) {
                            if (e instanceof Error) reject(e);
                        }
                    }));
            }();
        });
    }
    /**
   * Enable or disable a participant's camera track.
   *
   * If a track has already published, it'll mute or unmute the track.
   * Resolves with a `LocalTrackPublication` instance if successful and `undefined` otherwise
   */ setCameraEnabled(enabled, options, publishOptions) {
        return this.setTrackEnabled($2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Camera, enabled, options, publishOptions);
    }
    /**
   * Enable or disable a participant's microphone track.
   *
   * If a track has already published, it'll mute or unmute the track.
   * Resolves with a `LocalTrackPublication` instance if successful and `undefined` otherwise
   */ setMicrophoneEnabled(enabled, options, publishOptions) {
        return this.setTrackEnabled($2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Microphone, enabled, options, publishOptions);
    }
    /**
   * Start or stop sharing a participant's screen
   * Resolves with a `LocalTrackPublication` instance if successful and `undefined` otherwise
   */ setScreenShareEnabled(enabled, options, publishOptions) {
        return this.setTrackEnabled($2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShare, enabled, options, publishOptions);
    }
    /** @internal */ setPermissions(permissions) {
        const prevPermissions = this.permissions;
        const changed = super.setPermissions(permissions);
        if (changed && prevPermissions) this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ParticipantPermissionsChanged, prevPermissions);
        return changed;
    }
    /** @internal */ setE2EEEnabled(enabled) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            this.encryptionType = enabled ? $2d7d9af7a5367cf4$var$Encryption_Type.GCM : $2d7d9af7a5367cf4$var$Encryption_Type.NONE;
            yield this.republishAllTracks(undefined, false);
        });
    }
    setTrackEnabled(source, enabled, options, publishOptions) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            this.log.debug('setTrackEnabled', Object.assign(Object.assign({}, this.logContext), {
                source: source,
                enabled: enabled
            }));
            if (this.republishPromise) yield this.republishPromise;
            let track = this.getTrackPublication(source);
            if (enabled) {
                if (track) yield track.unmute();
                else {
                    let localTracks;
                    if (this.pendingPublishing.has(source)) {
                        const pendingTrack = yield this.waitForPendingPublicationOfSource(source);
                        if (!pendingTrack) this.log.info('waiting for pending publication promise timed out', Object.assign(Object.assign({}, this.logContext), {
                            source: source
                        }));
                        yield pendingTrack === null || pendingTrack === void 0 ? void 0 : pendingTrack.unmute();
                        return pendingTrack;
                    }
                    this.pendingPublishing.add(source);
                    try {
                        switch(source){
                            case $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Camera:
                                localTracks = yield this.createTracks({
                                    video: (_a = options) !== null && _a !== void 0 ? _a : true
                                });
                                break;
                            case $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Microphone:
                                localTracks = yield this.createTracks({
                                    audio: (_b = options) !== null && _b !== void 0 ? _b : true
                                });
                                break;
                            case $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShare:
                                localTracks = yield this.createScreenTracks(Object.assign({}, options));
                                break;
                            default:
                                throw new $2d7d9af7a5367cf4$export$4fbb9423b5747257(source);
                        }
                        const publishPromises = [];
                        for (const localTrack of localTracks){
                            this.log.info('publishing track', Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(localTrack)));
                            publishPromises.push(this.publishTrack(localTrack, publishOptions));
                        }
                        const publishedTracks = yield Promise.all(publishPromises);
                        // for screen share publications including audio, this will only return the screen share publication, not the screen share audio one
                        // revisit if we want to return an array of tracks instead for v2
                        [track] = publishedTracks;
                    } catch (e) {
                        localTracks === null || localTracks === void 0 || localTracks.forEach((tr)=>{
                            tr.stop();
                        });
                        if (e instanceof Error && !(e instanceof $2d7d9af7a5367cf4$export$4fbb9423b5747257)) this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.MediaDevicesError, e);
                        throw e;
                    } finally{
                        this.pendingPublishing.delete(source);
                    }
                }
            } else {
                if (!(track === null || track === void 0 ? void 0 : track.track) && this.pendingPublishing.has(source)) {
                    // if there's no track available yet first wait for pending publishing promises of that source to see if it becomes available
                    track = yield this.waitForPendingPublicationOfSource(source);
                    if (!track) this.log.info('waiting for pending publication promise timed out', Object.assign(Object.assign({}, this.logContext), {
                        source: source
                    }));
                }
                if (track && track.track) {
                    // screenshare cannot be muted, unpublish instead
                    if (source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShare) {
                        track = yield this.unpublishTrack(track.track);
                        const screenAudioTrack = this.getTrackPublication($2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShareAudio);
                        if (screenAudioTrack && screenAudioTrack.track) this.unpublishTrack(screenAudioTrack.track);
                    } else yield track.mute();
                }
            }
            return track;
        });
    }
    /**
   * Publish both camera and microphone at the same time. This is useful for
   * displaying a single Permission Dialog box to the end user.
   */ enableCameraAndMicrophone() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (this.pendingPublishing.has($2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Camera) || this.pendingPublishing.has($2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Microphone)) // no-op it's already been requested
            return;
            this.pendingPublishing.add($2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Camera);
            this.pendingPublishing.add($2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Microphone);
            try {
                const tracks = yield this.createTracks({
                    audio: true,
                    video: true
                });
                yield Promise.all(tracks.map((track)=>this.publishTrack(track)));
            } finally{
                this.pendingPublishing.delete($2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Camera);
                this.pendingPublishing.delete($2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Microphone);
            }
        });
    }
    /**
   * Create local camera and/or microphone tracks
   * @param options
   * @returns
   */ createTracks(options) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            options !== null && options !== void 0 ? options : options = {};
            const { audioProcessor: audioProcessor, videoProcessor: videoProcessor, optionsWithoutProcessor: optionsWithoutProcessor } = $2d7d9af7a5367cf4$var$extractProcessorsFromOptions(options);
            const mergedOptions = $2d7d9af7a5367cf4$var$mergeDefaultOptions(optionsWithoutProcessor, (_a = this.roomOptions) === null || _a === void 0 ? void 0 : _a.audioCaptureDefaults, (_b = this.roomOptions) === null || _b === void 0 ? void 0 : _b.videoCaptureDefaults);
            const constraints = $2d7d9af7a5367cf4$var$constraintsForOptions(mergedOptions);
            let stream;
            try {
                stream = yield navigator.mediaDevices.getUserMedia(constraints);
            } catch (err) {
                if (err instanceof Error) {
                    if (constraints.audio) this.microphoneError = err;
                    if (constraints.video) this.cameraError = err;
                }
                throw err;
            }
            if (constraints.audio) {
                this.microphoneError = undefined;
                this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.AudioStreamAcquired);
            }
            if (constraints.video) this.cameraError = undefined;
            return Promise.all(stream.getTracks().map((mediaStreamTrack)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                    const isAudio = mediaStreamTrack.kind === 'audio';
                    isAudio ? mergedOptions.audio : mergedOptions.video;
                    let trackConstraints;
                    const conOrBool = isAudio ? constraints.audio : constraints.video;
                    if (typeof conOrBool !== 'boolean') trackConstraints = conOrBool;
                    const track = $2d7d9af7a5367cf4$var$mediaTrackToLocalTrack(mediaStreamTrack, trackConstraints, {
                        loggerName: this.roomOptions.loggerName,
                        loggerContextCb: ()=>this.logContext
                    });
                    if (track.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video) track.source = $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Camera;
                    else if (track.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Audio) {
                        track.source = $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Microphone;
                        track.setAudioContext(this.audioContext);
                    }
                    track.mediaStream = stream;
                    if (track instanceof $2d7d9af7a5367cf4$export$b287427b771ca237 && audioProcessor) yield track.setProcessor(audioProcessor);
                    else if (track instanceof $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc && videoProcessor) yield track.setProcessor(videoProcessor);
                    return track;
                })));
        });
    }
    /**
   * Creates a screen capture tracks with getDisplayMedia().
   * A LocalVideoTrack is always created and returned.
   * If { audio: true }, and the browser supports audio capture, a LocalAudioTrack is also created.
   */ createScreenTracks(options) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (options === undefined) options = {};
            if (navigator.mediaDevices.getDisplayMedia === undefined) throw new $2d7d9af7a5367cf4$export$38c5ac268e2fa84('getDisplayMedia not supported');
            if (options.resolution === undefined && !$2d7d9af7a5367cf4$var$isSafari17()) // we need to constrain the dimensions, otherwise it could lead to low bitrate
            // due to encoding a huge video. Encoding such large surfaces is really expensive
            // unfortunately Safari 17 has a but and cannot be constrained by default
            options.resolution = $2d7d9af7a5367cf4$export$a6cdf9dcd3d32f2d.h1080fps30.resolution;
            const constraints = $2d7d9af7a5367cf4$var$screenCaptureToDisplayMediaStreamOptions(options);
            const stream = yield navigator.mediaDevices.getDisplayMedia(constraints);
            const tracks = stream.getVideoTracks();
            if (tracks.length === 0) throw new $2d7d9af7a5367cf4$export$4fbb9423b5747257('no video track found');
            const screenVideo = new $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc(tracks[0], undefined, false, {
                loggerName: this.roomOptions.loggerName,
                loggerContextCb: ()=>this.logContext
            });
            screenVideo.source = $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShare;
            if (options.contentHint) screenVideo.mediaStreamTrack.contentHint = options.contentHint;
            const localTracks = [
                screenVideo
            ];
            if (stream.getAudioTracks().length > 0) {
                this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.AudioStreamAcquired);
                const screenAudio = new $2d7d9af7a5367cf4$export$b287427b771ca237(stream.getAudioTracks()[0], undefined, false, this.audioContext, {
                    loggerName: this.roomOptions.loggerName,
                    loggerContextCb: ()=>this.logContext
                });
                screenAudio.source = $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShareAudio;
                localTracks.push(screenAudio);
            }
            return localTracks;
        });
    }
    /**
   * Publish a new track to the room
   * @param track
   * @param options
   */ publishTrack(track, options) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            return this.publishOrRepublishTrack(track, options);
        });
    }
    publishOrRepublishTrack(track_1, options_1) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function(track, options) {
            var _this2 = this;
            let isRepublish = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            return function*() {
                var _a, _b, _c, _d;
                if (track instanceof $2d7d9af7a5367cf4$export$b287427b771ca237) track.setAudioContext(_this2.audioContext);
                yield (_a = _this2.reconnectFuture) === null || _a === void 0 ? void 0 : _a.promise;
                if (_this2.republishPromise && !isRepublish) yield _this2.republishPromise;
                if (track instanceof $2d7d9af7a5367cf4$export$3e041ce3f33f04dd && _this2.pendingPublishPromises.has(track)) yield _this2.pendingPublishPromises.get(track);
                let defaultConstraints;
                if (track instanceof MediaStreamTrack) defaultConstraints = track.getConstraints();
                else {
                    // we want to access constraints directly as `track.mediaStreamTrack`
                    // might be pointing to a non-device track (e.g. processed track) already
                    defaultConstraints = track.constraints;
                    let deviceKind = undefined;
                    switch(track.source){
                        case $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Microphone:
                            deviceKind = 'audioinput';
                            break;
                        case $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Camera:
                            deviceKind = 'videoinput';
                    }
                    if (deviceKind && _this2.activeDeviceMap.has(deviceKind)) defaultConstraints = Object.assign(Object.assign({}, defaultConstraints), {
                        deviceId: _this2.activeDeviceMap.get(deviceKind)
                    });
                }
                // convert raw media track into audio or video track
                if (track instanceof MediaStreamTrack) switch(track.kind){
                    case 'audio':
                        track = new $2d7d9af7a5367cf4$export$b287427b771ca237(track, defaultConstraints, true, _this2.audioContext, {
                            loggerName: _this2.roomOptions.loggerName,
                            loggerContextCb: ()=>_this2.logContext
                        });
                        break;
                    case 'video':
                        track = new $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc(track, defaultConstraints, true, {
                            loggerName: _this2.roomOptions.loggerName,
                            loggerContextCb: ()=>_this2.logContext
                        });
                        break;
                    default:
                        throw new $2d7d9af7a5367cf4$export$4fbb9423b5747257("unsupported MediaStreamTrack kind ".concat(track.kind));
                }
                else track.updateLoggerOptions({
                    loggerName: _this2.roomOptions.loggerName,
                    loggerContextCb: ()=>_this2.logContext
                });
                // is it already published? if so skip
                let existingPublication;
                _this2.trackPublications.forEach((publication)=>{
                    if (!publication.track) return;
                    if (publication.track === track) existingPublication = publication;
                });
                if (existingPublication) {
                    _this2.log.warn('track has already been published, skipping', Object.assign(Object.assign({}, _this2.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(existingPublication)));
                    return existingPublication;
                }
                const isStereoInput = 'channelCount' in track.mediaStreamTrack.getSettings() && // @ts-ignore `channelCount` on getSettings() is currently only available for Safari, but is generally the best way to determine a stereo track https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackSettings/channelCount
                track.mediaStreamTrack.getSettings().channelCount === 2 || track.mediaStreamTrack.getConstraints().channelCount === 2;
                const isStereo = (_b = options === null || options === void 0 ? void 0 : options.forceStereo) !== null && _b !== void 0 ? _b : isStereoInput;
                // disable dtx for stereo track if not enabled explicitly
                if (isStereo) {
                    if (!options) options = {};
                    if (options.dtx === undefined) _this2.log.info("Opus DTX will be disabled for stereo tracks by default. Enable them explicitly to make it work.", Object.assign(Object.assign({}, _this2.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(track)));
                    if (options.red === undefined) _this2.log.info("Opus RED will be disabled for stereo tracks by default. Enable them explicitly to make it work.");
                    (_c = options.dtx) !== null && _c !== void 0 ? _c : options.dtx = false;
                    (_d = options.red) !== null && _d !== void 0 ? _d : options.red = false;
                }
                const opts = Object.assign(Object.assign({}, _this2.roomOptions.publishDefaults), options);
                if (!$2d7d9af7a5367cf4$var$isE2EESimulcastSupported() && _this2.roomOptions.e2ee) {
                    _this2.log.info("End-to-end encryption is set up, simulcast publishing will be disabled on Safari versions and iOS browsers running iOS < v17.2", Object.assign({}, _this2.logContext));
                    opts.simulcast = false;
                }
                if (opts.source) track.source = opts.source;
                const publishPromise = _this2.publish(track, opts, isStereo);
                _this2.pendingPublishPromises.set(track, publishPromise);
                try {
                    const publication = yield publishPromise;
                    return publication;
                } catch (e) {
                    throw e;
                } finally{
                    _this2.pendingPublishPromises.delete(track);
                }
            }();
        });
    }
    publish(track, opts, isStereo) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            const existingTrackOfSource = Array.from(this.trackPublications.values()).find((publishedTrack)=>track instanceof $2d7d9af7a5367cf4$export$3e041ce3f33f04dd && publishedTrack.source === track.source);
            if (existingTrackOfSource && track.source !== $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Unknown) this.log.info("publishing a second track with the same source: ".concat(track.source), Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(track)));
            if (opts.stopMicTrackOnMute && track instanceof $2d7d9af7a5367cf4$export$b287427b771ca237) track.stopOnMute = true;
            if (track.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShare && $2d7d9af7a5367cf4$var$isFireFox()) // Firefox does not work well with simulcasted screen share
            // we frequently get no data on layer 0 when enabled
            opts.simulcast = false;
            // require full AV1/VP9 SVC support prior to using it
            if (opts.videoCodec === 'av1' && !$2d7d9af7a5367cf4$export$f157b33fe3596be1()) opts.videoCodec = undefined;
            if (opts.videoCodec === 'vp9' && !$2d7d9af7a5367cf4$export$7c4c0f8271043129()) opts.videoCodec = undefined;
            if (opts.videoCodec === undefined) opts.videoCodec = $2d7d9af7a5367cf4$var$defaultVideoCodec;
            if (this.enabledPublishVideoCodecs.length > 0) // fallback to a supported codec if it is not supported
            {
                if (!this.enabledPublishVideoCodecs.some((c)=>opts.videoCodec === $2d7d9af7a5367cf4$var$mimeTypeToVideoCodecString(c.mime))) opts.videoCodec = $2d7d9af7a5367cf4$var$mimeTypeToVideoCodecString(this.enabledPublishVideoCodecs[0].mime);
            }
            const videoCodec = opts.videoCodec;
            // handle track actions
            track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.Muted, this.onTrackMuted);
            track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.Unmuted, this.onTrackUnmuted);
            track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.Ended, this.handleTrackEnded);
            track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.UpstreamPaused, this.onTrackUpstreamPaused);
            track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.UpstreamResumed, this.onTrackUpstreamResumed);
            track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.AudioTrackFeatureUpdate, this.onTrackFeatureUpdate);
            // create track publication from track
            const req = new $2d7d9af7a5367cf4$var$AddTrackRequest({
                // get local track id for use during publishing
                cid: track.mediaStreamTrack.id,
                name: opts.name,
                type: $2d7d9af7a5367cf4$export$13921ac0cc260818.kindToProto(track.kind),
                muted: track.isMuted,
                source: $2d7d9af7a5367cf4$export$13921ac0cc260818.sourceToProto(track.source),
                disableDtx: !((_a = opts.dtx) !== null && _a !== void 0 ? _a : true),
                encryption: this.encryptionType,
                stereo: isStereo,
                disableRed: this.isE2EEEnabled || !((_b = opts.red) !== null && _b !== void 0 ? _b : true),
                stream: opts === null || opts === void 0 ? void 0 : opts.stream
            });
            // compute encodings and layers for video
            let encodings;
            if (track.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video) {
                let dims = {
                    width: 0,
                    height: 0
                };
                try {
                    dims = yield track.waitForDimensions();
                } catch (e) {
                    // use defaults, it's quite painful for congestion control without simulcast
                    // so using default dims according to publish settings
                    const defaultRes = (_d = (_c = this.roomOptions.videoCaptureDefaults) === null || _c === void 0 ? void 0 : _c.resolution) !== null && _d !== void 0 ? _d : $2d7d9af7a5367cf4$export$79d56065dad1674c.h720.resolution;
                    dims = {
                        width: defaultRes.width,
                        height: defaultRes.height
                    };
                    // log failure
                    this.log.error('could not determine track dimensions, using defaults', Object.assign(Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(track)), {
                        dims: dims
                    }));
                }
                // width and height should be defined for video
                req.width = dims.width;
                req.height = dims.height;
                // for svc codecs, disable simulcast and use vp8 for backup codec
                if (track instanceof $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc) {
                    if ($2d7d9af7a5367cf4$var$isSVCCodec(videoCodec)) {
                        if (track.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShare) {
                            // vp9 svc with screenshare cannot encode multiple spatial layers
                            // doing so reduces publish resolution to minimal resolution
                            opts.scalabilityMode = 'L1T3';
                            // Chrome does not allow more than 5 fps with L1T3, and it has encoding bugs with L3T3
                            // It has a different path for screenshare handling and it seems to be untested/buggy
                            // As a workaround, we are setting contentHint to force it to go through the same
                            // path as regular camera video. While this is not optimal, it delivers the performance
                            // that we need
                            if ('contentHint' in track.mediaStreamTrack) {
                                track.mediaStreamTrack.contentHint = 'motion';
                                this.log.info('forcing contentHint to motion for screenshare with SVC codecs', Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(track)));
                            }
                        }
                        // set scalabilityMode to 'L3T3_KEY' by default
                        opts.scalabilityMode = (_e = opts.scalabilityMode) !== null && _e !== void 0 ? _e : 'L3T3_KEY';
                    }
                    req.simulcastCodecs = [
                        new $2d7d9af7a5367cf4$var$SimulcastCodec({
                            codec: videoCodec,
                            cid: track.mediaStreamTrack.id
                        })
                    ];
                    // set up backup
                    if (opts.backupCodec === true) opts.backupCodec = {
                        codec: $2d7d9af7a5367cf4$var$defaultVideoCodec
                    };
                    if (opts.backupCodec && videoCodec !== opts.backupCodec.codec && // TODO remove this once e2ee is supported for backup codecs
                    req.encryption === $2d7d9af7a5367cf4$var$Encryption_Type.NONE) {
                        // multi-codec simulcast requires dynacast
                        if (!this.roomOptions.dynacast) this.roomOptions.dynacast = true;
                        req.simulcastCodecs.push(new $2d7d9af7a5367cf4$var$SimulcastCodec({
                            codec: opts.backupCodec.codec,
                            cid: ''
                        }));
                    }
                }
                encodings = $2d7d9af7a5367cf4$var$computeVideoEncodings(track.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShare, req.width, req.height, opts);
                req.layers = $2d7d9af7a5367cf4$var$videoLayersFromEncodings(req.width, req.height, encodings, $2d7d9af7a5367cf4$var$isSVCCodec(opts.videoCodec));
            } else if (track.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Audio) encodings = [
                {
                    maxBitrate: (_f = opts.audioPreset) === null || _f === void 0 ? void 0 : _f.maxBitrate,
                    priority: (_h = (_g = opts.audioPreset) === null || _g === void 0 ? void 0 : _g.priority) !== null && _h !== void 0 ? _h : 'high',
                    networkPriority: (_k = (_j = opts.audioPreset) === null || _j === void 0 ? void 0 : _j.priority) !== null && _k !== void 0 ? _k : 'high'
                }
            ];
            if (!this.engine || this.engine.isClosed) throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('cannot publish track when not connected');
            const negotiate = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c;
                    if (!this.engine.pcManager) throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('pcManager is not ready');
                    track.sender = yield this.engine.createSender(track, opts, encodings);
                    if (track instanceof $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc) {
                        (_a = opts.degradationPreference) !== null && _a !== void 0 ? _a : opts.degradationPreference = $2d7d9af7a5367cf4$var$getDefaultDegradationPreference(track);
                        track.setDegradationPreference(opts.degradationPreference);
                    }
                    if (encodings) {
                        if ($2d7d9af7a5367cf4$var$isFireFox() && track.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Audio) {
                            /* Refer to RFC https://datatracker.ietf.org/doc/html/rfc7587#section-6.1,
               livekit-server uses maxaveragebitrate=510000 in the answer sdp to permit client to
               publish high quality audio track. But firefox always uses this value as the actual
               bitrates, causing the audio bitrates to rise to 510Kbps in any stereo case unexpectedly.
               So the client need to modify maxaverragebitrates in answer sdp to user provided value to
               fix the issue.
             */ let trackTransceiver = undefined;
                            for (const transceiver of this.engine.pcManager.publisher.getTransceivers())if (transceiver.sender === track.sender) {
                                trackTransceiver = transceiver;
                                break;
                            }
                            if (trackTransceiver) this.engine.pcManager.publisher.setTrackCodecBitrate({
                                transceiver: trackTransceiver,
                                codec: 'opus',
                                maxbr: ((_b = encodings[0]) === null || _b === void 0 ? void 0 : _b.maxBitrate) ? encodings[0].maxBitrate / 1000 : 0
                            });
                        } else if (track.codec && $2d7d9af7a5367cf4$var$isSVCCodec(track.codec) && ((_c = encodings[0]) === null || _c === void 0 ? void 0 : _c.maxBitrate)) this.engine.pcManager.publisher.setTrackCodecBitrate({
                            cid: req.cid,
                            codec: track.codec,
                            maxbr: encodings[0].maxBitrate / 1000
                        });
                    }
                    yield this.engine.negotiate();
                });
            let ti;
            if (this.enabledPublishVideoCodecs.length > 0) {
                const rets = yield Promise.all([
                    this.engine.addTrack(req),
                    negotiate()
                ]);
                ti = rets[0];
            } else {
                ti = yield this.engine.addTrack(req);
                // server might not support the codec the client has requested, in that case, fallback
                // to a supported codec
                let primaryCodecMime;
                ti.codecs.forEach((codec)=>{
                    if (primaryCodecMime === undefined) primaryCodecMime = codec.mimeType;
                });
                if (primaryCodecMime && track.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video) {
                    const updatedCodec = $2d7d9af7a5367cf4$var$mimeTypeToVideoCodecString(primaryCodecMime);
                    if (updatedCodec !== videoCodec) {
                        this.log.debug('falling back to server selected codec', Object.assign(Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(track)), {
                            codec: updatedCodec
                        }));
                        opts.videoCodec = updatedCodec;
                        // recompute encodings since bitrates/etc could have changed
                        encodings = $2d7d9af7a5367cf4$var$computeVideoEncodings(track.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShare, req.width, req.height, opts);
                    }
                }
                yield negotiate();
            }
            const publication = new $2d7d9af7a5367cf4$export$885a52c769210b3f(track.kind, ti, track, {
                loggerName: this.roomOptions.loggerName,
                loggerContextCb: ()=>this.logContext
            });
            // save options for when it needs to be republished again
            publication.options = opts;
            track.sid = ti.sid;
            this.log.debug("publishing ".concat(track.kind, " with encodings"), Object.assign(Object.assign({}, this.logContext), {
                encodings: encodings,
                trackInfo: ti
            }));
            if (track instanceof $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc) track.startMonitor(this.engine.client);
            else if (track instanceof $2d7d9af7a5367cf4$export$b287427b771ca237) track.startMonitor();
            this.addTrackPublication(publication);
            // send event for publication
            this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.LocalTrackPublished, publication);
            return publication;
        });
    }
    get isLocal() {
        return true;
    }
    /** @internal
   * publish additional codec to existing track
   */ publishAdditionalCodecForTrack(track, videoCodec, options) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            // TODO remove once e2ee is supported for backup tracks
            if (this.encryptionType !== $2d7d9af7a5367cf4$var$Encryption_Type.NONE) return;
            // is it not published? if so skip
            let existingPublication;
            this.trackPublications.forEach((publication)=>{
                if (!publication.track) return;
                if (publication.track === track) existingPublication = publication;
            });
            if (!existingPublication) throw new $2d7d9af7a5367cf4$export$4fbb9423b5747257('track is not published');
            if (!(track instanceof $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc)) throw new $2d7d9af7a5367cf4$export$4fbb9423b5747257('track is not a video track');
            const opts = Object.assign(Object.assign({}, (_a = this.roomOptions) === null || _a === void 0 ? void 0 : _a.publishDefaults), options);
            const encodings = $2d7d9af7a5367cf4$var$computeTrackBackupEncodings(track, videoCodec, opts);
            if (!encodings) {
                this.log.info("backup codec has been disabled, ignoring request to add additional codec for track", Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(track)));
                return;
            }
            const simulcastTrack = track.addSimulcastTrack(videoCodec, encodings);
            if (!simulcastTrack) return;
            const req = new $2d7d9af7a5367cf4$var$AddTrackRequest({
                cid: simulcastTrack.mediaStreamTrack.id,
                type: $2d7d9af7a5367cf4$export$13921ac0cc260818.kindToProto(track.kind),
                muted: track.isMuted,
                source: $2d7d9af7a5367cf4$export$13921ac0cc260818.sourceToProto(track.source),
                sid: track.sid,
                simulcastCodecs: [
                    {
                        codec: opts.videoCodec,
                        cid: simulcastTrack.mediaStreamTrack.id
                    }
                ]
            });
            req.layers = $2d7d9af7a5367cf4$var$videoLayersFromEncodings(req.width, req.height, encodings);
            if (!this.engine || this.engine.isClosed) throw new $2d7d9af7a5367cf4$export$1f388e244efbf70b('cannot publish track when not connected');
            const negotiate = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                    yield this.engine.createSimulcastSender(track, simulcastTrack, opts, encodings);
                    yield this.engine.negotiate();
                });
            const rets = yield Promise.all([
                this.engine.addTrack(req),
                negotiate()
            ]);
            const ti = rets[0];
            this.log.debug("published ".concat(videoCodec, " for track ").concat(track.sid), Object.assign(Object.assign({}, this.logContext), {
                encodings: encodings,
                trackInfo: ti
            }));
        });
    }
    unpublishTrack(track, stopOnUnpublish) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (track instanceof $2d7d9af7a5367cf4$export$3e041ce3f33f04dd) {
                const publishPromise = this.pendingPublishPromises.get(track);
                if (publishPromise) {
                    this.log.info('awaiting publish promise before attempting to unpublish', Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(track)));
                    yield publishPromise;
                }
            }
            // look through all published tracks to find the right ones
            const publication = this.getPublicationForTrack(track);
            const pubLogContext = publication ? $2d7d9af7a5367cf4$var$getLogContextFromTrack(publication) : undefined;
            this.log.debug('unpublishing track', Object.assign(Object.assign({}, this.logContext), pubLogContext));
            if (!publication || !publication.track) {
                this.log.warn('track was not unpublished because no publication was found', Object.assign(Object.assign({}, this.logContext), pubLogContext));
                return undefined;
            }
            track = publication.track;
            track.off($2d7d9af7a5367cf4$export$2c8510d737cc09da.Muted, this.onTrackMuted);
            track.off($2d7d9af7a5367cf4$export$2c8510d737cc09da.Unmuted, this.onTrackUnmuted);
            track.off($2d7d9af7a5367cf4$export$2c8510d737cc09da.Ended, this.handleTrackEnded);
            track.off($2d7d9af7a5367cf4$export$2c8510d737cc09da.UpstreamPaused, this.onTrackUpstreamPaused);
            track.off($2d7d9af7a5367cf4$export$2c8510d737cc09da.UpstreamResumed, this.onTrackUpstreamResumed);
            track.off($2d7d9af7a5367cf4$export$2c8510d737cc09da.AudioTrackFeatureUpdate, this.onTrackFeatureUpdate);
            if (stopOnUnpublish === undefined) stopOnUnpublish = (_b = (_a = this.roomOptions) === null || _a === void 0 ? void 0 : _a.stopLocalTrackOnUnpublish) !== null && _b !== void 0 ? _b : true;
            if (stopOnUnpublish) track.stop();
            else track.stopMonitor();
            let negotiationNeeded = false;
            const trackSender = track.sender;
            track.sender = undefined;
            if (this.engine.pcManager && this.engine.pcManager.currentState < $2d7d9af7a5367cf4$var$PCTransportState.FAILED && trackSender) try {
                for (const transceiver of this.engine.pcManager.publisher.getTransceivers())// if sender is not currently sending (after replaceTrack(null))
                // removeTrack would have no effect.
                // to ensure we end up successfully removing the track, manually set
                // the transceiver to inactive
                if (transceiver.sender === trackSender) {
                    transceiver.direction = 'inactive';
                    negotiationNeeded = true;
                }
                if (this.engine.removeTrack(trackSender)) negotiationNeeded = true;
                if (track instanceof $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc) {
                    for (const [, trackInfo] of track.simulcastCodecs)if (trackInfo.sender) {
                        if (this.engine.removeTrack(trackInfo.sender)) negotiationNeeded = true;
                        trackInfo.sender = undefined;
                    }
                    track.simulcastCodecs.clear();
                }
            } catch (e) {
                this.log.warn('failed to unpublish track', Object.assign(Object.assign(Object.assign({}, this.logContext), pubLogContext), {
                    error: e
                }));
            }
            // remove from our maps
            this.trackPublications.delete(publication.trackSid);
            switch(publication.kind){
                case $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Audio:
                    this.audioTrackPublications.delete(publication.trackSid);
                    break;
                case $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video:
                    this.videoTrackPublications.delete(publication.trackSid);
                    break;
            }
            this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.LocalTrackUnpublished, publication);
            publication.setTrack(undefined);
            if (negotiationNeeded) yield this.engine.negotiate();
            return publication;
        });
    }
    unpublishTracks(tracks) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const results = yield Promise.all(tracks.map((track)=>this.unpublishTrack(track)));
            return results.filter((track)=>track instanceof $2d7d9af7a5367cf4$export$885a52c769210b3f);
        });
    }
    republishAllTracks(options_1) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function(options) {
            var _this3 = this;
            let restartTracks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return function*() {
                if (_this3.republishPromise) yield _this3.republishPromise;
                _this3.republishPromise = new Promise((resolve, reject)=>$2d7d9af7a5367cf4$var$__awaiter(_this3, void 0, void 0, function*() {
                        try {
                            const localPubs = [];
                            this.trackPublications.forEach((pub)=>{
                                if (pub.track) {
                                    if (options) pub.options = Object.assign(Object.assign({}, pub.options), options);
                                    localPubs.push(pub);
                                }
                            });
                            yield Promise.all(localPubs.map((pub)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                                    const track = pub.track;
                                    yield this.unpublishTrack(track, false);
                                    if (restartTracks && !track.isMuted && track.source !== $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShare && track.source !== $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShareAudio && (track instanceof $2d7d9af7a5367cf4$export$b287427b771ca237 || track instanceof $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc) && !track.isUserProvided) {
                                        // generally we need to restart the track before publishing, often a full reconnect
                                        // is necessary because computer had gone to sleep.
                                        this.log.debug('restarting existing track', Object.assign(Object.assign({}, this.logContext), {
                                            track: pub.trackSid
                                        }));
                                        yield track.restartTrack();
                                    }
                                    yield this.publishOrRepublishTrack(track, pub.options, true);
                                })));
                            resolve();
                        } catch (error) {
                            reject(error);
                        } finally{
                            this.republishPromise = undefined;
                        }
                    }));
                yield _this3.republishPromise;
            }();
        });
    }
    /**
   * Publish a new data payload to the room. Data will be forwarded to each
   * participant in the room if the destination field in publishOptions is empty
   *
   * @param data Uint8Array of the payload. To send string data, use TextEncoder.encode
   * @param options optionally specify a `reliable`, `topic` and `destination`
   */ publishData(data_1) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function(data) {
            var _this4 = this;
            let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return function*() {
                const kind = options.reliable ? $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE : $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.LOSSY;
                const destinationIdentities = options.destinationIdentities;
                const topic = options.topic;
                const packet = new $2d7d9af7a5367cf4$var$DataPacket({
                    kind: kind,
                    value: {
                        case: 'user',
                        value: new $2d7d9af7a5367cf4$var$UserPacket({
                            participantIdentity: _this4.identity,
                            payload: data,
                            destinationIdentities: destinationIdentities,
                            topic: topic
                        })
                    }
                });
                yield _this4.engine.sendDataPacket(packet, kind);
            }();
        });
    }
    /**
   * Publish SIP DTMF message to the room.
   *
   * @param code DTMF code
   * @param digit DTMF digit
   */ publishDtmf(code, digit) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const packet = new $2d7d9af7a5367cf4$var$DataPacket({
                kind: $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE,
                value: {
                    case: 'sipDtmf',
                    value: new $2d7d9af7a5367cf4$var$SipDTMF({
                        code: code,
                        digit: digit
                    })
                }
            });
            yield this.engine.sendDataPacket(packet, $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE);
        });
    }
    sendChatMessage(text) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const msg = {
                id: crypto.randomUUID(),
                message: text,
                timestamp: Date.now()
            };
            const packet = new $2d7d9af7a5367cf4$var$DataPacket({
                value: {
                    case: 'chatMessage',
                    value: new $2d7d9af7a5367cf4$var$ChatMessage(Object.assign(Object.assign({}, msg), {
                        timestamp: $2d7d9af7a5367cf4$var$protoInt64.parse(msg.timestamp)
                    }))
                }
            });
            yield this.engine.sendDataPacket(packet, $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE);
            this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ChatMessage, msg);
            return msg;
        });
    }
    editChatMessage(editText, originalMessage) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const msg = Object.assign(Object.assign({}, originalMessage), {
                message: editText,
                editTimestamp: Date.now()
            });
            const packet = new $2d7d9af7a5367cf4$var$DataPacket({
                value: {
                    case: 'chatMessage',
                    value: new $2d7d9af7a5367cf4$var$ChatMessage(Object.assign(Object.assign({}, msg), {
                        timestamp: $2d7d9af7a5367cf4$var$protoInt64.parse(msg.timestamp),
                        editTimestamp: $2d7d9af7a5367cf4$var$protoInt64.parse(msg.editTimestamp)
                    }))
                }
            });
            yield this.engine.sendDataPacket(packet, $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE);
            this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ChatMessage, msg);
            return msg;
        });
    }
    /**
   * Initiate an RPC call to a remote participant
   * @param params - Parameters for initiating the RPC call, see {@link PerformRpcParams}
   * @returns A promise that resolves with the response payload or rejects with an error.
   * @throws Error on failure. Details in `message`.
   */ performRpc(_a) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function(_ref3) {
            var _this5 = this;
            let { destinationIdentity: destinationIdentity, method: method, payload: payload, responseTimeout: responseTimeout = 10000 } = _ref3;
            return function*() {
                const maxRoundTripLatency = 2000;
                return new Promise((resolve, reject)=>$2d7d9af7a5367cf4$var$__awaiter(_this5, void 0, void 0, function*() {
                        var _a, _b, _c, _d;
                        if ($2d7d9af7a5367cf4$var$byteLength(payload) > $2d7d9af7a5367cf4$var$MAX_PAYLOAD_BYTES) {
                            reject($2d7d9af7a5367cf4$export$5460eff990f31920.builtIn('REQUEST_PAYLOAD_TOO_LARGE'));
                            return;
                        }
                        if (((_b = (_a = this.engine.latestJoinResponse) === null || _a === void 0 ? void 0 : _a.serverInfo) === null || _b === void 0 ? void 0 : _b.version) && $2d7d9af7a5367cf4$export$66e1c0999abad646((_d = (_c = this.engine.latestJoinResponse) === null || _c === void 0 ? void 0 : _c.serverInfo) === null || _d === void 0 ? void 0 : _d.version, '1.8.0') < 0) {
                            reject($2d7d9af7a5367cf4$export$5460eff990f31920.builtIn('UNSUPPORTED_SERVER'));
                            return;
                        }
                        const id = crypto.randomUUID();
                        yield this.publishRpcRequest(destinationIdentity, id, method, payload, responseTimeout - maxRoundTripLatency);
                        const ackTimeoutId = setTimeout(()=>{
                            this.pendingAcks.delete(id);
                            reject($2d7d9af7a5367cf4$export$5460eff990f31920.builtIn('CONNECTION_TIMEOUT'));
                            this.pendingResponses.delete(id);
                            clearTimeout(responseTimeoutId);
                        }, maxRoundTripLatency);
                        this.pendingAcks.set(id, {
                            resolve: ()=>{
                                clearTimeout(ackTimeoutId);
                            },
                            participantIdentity: destinationIdentity
                        });
                        const responseTimeoutId = setTimeout(()=>{
                            this.pendingResponses.delete(id);
                            reject($2d7d9af7a5367cf4$export$5460eff990f31920.builtIn('RESPONSE_TIMEOUT'));
                        }, responseTimeout);
                        this.pendingResponses.set(id, {
                            resolve: (responsePayload, responseError)=>{
                                clearTimeout(responseTimeoutId);
                                if (this.pendingAcks.has(id)) {
                                    console.warn('RPC response received before ack', id);
                                    this.pendingAcks.delete(id);
                                    clearTimeout(ackTimeoutId);
                                }
                                if (responseError) reject(responseError);
                                else resolve(responsePayload !== null && responsePayload !== void 0 ? responsePayload : '');
                            },
                            participantIdentity: destinationIdentity
                        });
                    }));
            }();
        });
    }
    /**
   * Establishes the participant as a receiver for calls of the specified RPC method.
   * Will overwrite any existing callback for the same method.
   *
   * @param method - The name of the indicated RPC method
   * @param handler - Will be invoked when an RPC request for this method is received
   * @returns A promise that resolves when the method is successfully registered
   *
   * @example
   * ```typescript
   * room.localParticipant?.registerRpcMethod(
   *   'greet',
   *   async (data: RpcInvocationData) => {
   *     console.log(`Received greeting from ${data.callerIdentity}: ${data.payload}`);
   *     return `Hello, ${data.callerIdentity}!`;
   *   }
   * );
   * ```
   *
   * The handler should return a Promise that resolves to a string.
   * If unable to respond within `responseTimeout`, the request will result in an error on the caller's side.
   *
   * You may throw errors of type `RpcError` with a string `message` in the handler,
   * and they will be received on the caller's side with the message intact.
   * Other errors thrown in your handler will not be transmitted as-is, and will instead arrive to the caller as `1500` ("Application Error").
   */ registerRpcMethod(method, handler) {
        this.rpcHandlers.set(method, handler);
    }
    /**
   * Unregisters a previously registered RPC method.
   *
   * @param method - The name of the RPC method to unregister
   */ unregisterRpcMethod(method) {
        this.rpcHandlers.delete(method);
    }
    /**
   * Control who can subscribe to LocalParticipant's published tracks.
   *
   * By default, all participants can subscribe. This allows fine-grained control over
   * who is able to subscribe at a participant and track level.
   *
   * Note: if access is given at a track-level (i.e. both [allParticipantsAllowed] and
   * [ParticipantTrackPermission.allTracksAllowed] are false), any newer published tracks
   * will not grant permissions to any participants and will require a subsequent
   * permissions update to allow subscription.
   *
   * @param allParticipantsAllowed Allows all participants to subscribe all tracks.
   *  Takes precedence over [[participantTrackPermissions]] if set to true.
   *  By default this is set to true.
   * @param participantTrackPermissions Full list of individual permissions per
   *  participant/track. Any omitted participants will not receive any permissions.
   */ setTrackSubscriptionPermissions(allParticipantsAllowed) {
        let participantTrackPermissions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        this.participantTrackPermissions = participantTrackPermissions;
        this.allParticipantsAllowedToSubscribe = allParticipantsAllowed;
        if (!this.engine.client.isDisconnected) this.updateTrackSubscriptionPermissions();
    }
    handleIncomingRpcAck(requestId) {
        const handler = this.pendingAcks.get(requestId);
        if (handler) {
            handler.resolve();
            this.pendingAcks.delete(requestId);
        } else console.error('Ack received for unexpected RPC request', requestId);
    }
    handleIncomingRpcResponse(requestId, payload, error) {
        const handler = this.pendingResponses.get(requestId);
        if (handler) {
            handler.resolve(payload, error);
            this.pendingResponses.delete(requestId);
        } else console.error('Response received for unexpected RPC request', requestId);
    }
    handleIncomingRpcRequest(callerIdentity, requestId, method, payload, responseTimeout, version) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            yield this.publishRpcAck(callerIdentity, requestId);
            if (version !== 1) {
                yield this.publishRpcResponse(callerIdentity, requestId, null, $2d7d9af7a5367cf4$export$5460eff990f31920.builtIn('UNSUPPORTED_VERSION'));
                return;
            }
            const handler = this.rpcHandlers.get(method);
            if (!handler) {
                yield this.publishRpcResponse(callerIdentity, requestId, null, $2d7d9af7a5367cf4$export$5460eff990f31920.builtIn('UNSUPPORTED_METHOD'));
                return;
            }
            let responseError = null;
            let responsePayload = null;
            try {
                const response = yield handler({
                    requestId: requestId,
                    callerIdentity: callerIdentity,
                    payload: payload,
                    responseTimeout: responseTimeout
                });
                if ($2d7d9af7a5367cf4$var$byteLength(response) > $2d7d9af7a5367cf4$var$MAX_PAYLOAD_BYTES) {
                    responseError = $2d7d9af7a5367cf4$export$5460eff990f31920.builtIn('RESPONSE_PAYLOAD_TOO_LARGE');
                    console.warn("RPC Response payload too large for ".concat(method));
                } else responsePayload = response;
            } catch (error) {
                if (error instanceof $2d7d9af7a5367cf4$export$5460eff990f31920) responseError = error;
                else {
                    console.warn("Uncaught error returned by RPC handler for ".concat(method, ". Returning APPLICATION_ERROR instead."), error);
                    responseError = $2d7d9af7a5367cf4$export$5460eff990f31920.builtIn('APPLICATION_ERROR');
                }
            }
            yield this.publishRpcResponse(callerIdentity, requestId, responsePayload, responseError);
        });
    }
    /** @internal */ publishRpcRequest(destinationIdentity, requestId, method, payload, responseTimeout) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const packet = new $2d7d9af7a5367cf4$var$DataPacket({
                destinationIdentities: [
                    destinationIdentity
                ],
                kind: $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE,
                value: {
                    case: 'rpcRequest',
                    value: new $2d7d9af7a5367cf4$var$RpcRequest({
                        id: requestId,
                        method: method,
                        payload: payload,
                        responseTimeoutMs: responseTimeout,
                        version: 1
                    })
                }
            });
            yield this.engine.sendDataPacket(packet, $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE);
        });
    }
    /** @internal */ publishRpcResponse(destinationIdentity, requestId, payload, error) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const packet = new $2d7d9af7a5367cf4$var$DataPacket({
                destinationIdentities: [
                    destinationIdentity
                ],
                kind: $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE,
                value: {
                    case: 'rpcResponse',
                    value: new $2d7d9af7a5367cf4$var$RpcResponse({
                        requestId: requestId,
                        value: error ? {
                            case: 'error',
                            value: error.toProto()
                        } : {
                            case: 'payload',
                            value: payload !== null && payload !== void 0 ? payload : ''
                        }
                    })
                }
            });
            yield this.engine.sendDataPacket(packet, $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE);
        });
    }
    /** @internal */ publishRpcAck(destinationIdentity, requestId) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const packet = new $2d7d9af7a5367cf4$var$DataPacket({
                destinationIdentities: [
                    destinationIdentity
                ],
                kind: $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE,
                value: {
                    case: 'rpcAck',
                    value: new $2d7d9af7a5367cf4$var$RpcAck({
                        requestId: requestId
                    })
                }
            });
            yield this.engine.sendDataPacket(packet, $2d7d9af7a5367cf4$export$629a0ea4ceb9e4a6.RELIABLE);
        });
    }
    /** @internal */ handleParticipantDisconnected(participantIdentity) {
        for (const [id, { participantIdentity: pendingIdentity }] of this.pendingAcks)if (pendingIdentity === participantIdentity) this.pendingAcks.delete(id);
        for (const [id, { participantIdentity: pendingIdentity, resolve: resolve }] of this.pendingResponses)if (pendingIdentity === participantIdentity) {
            resolve(null, $2d7d9af7a5367cf4$export$5460eff990f31920.builtIn('RECIPIENT_DISCONNECTED'));
            this.pendingResponses.delete(id);
        }
    }
    /** @internal */ setEnabledPublishCodecs(codecs) {
        this.enabledPublishVideoCodecs = codecs.filter((c)=>c.mime.split('/')[0].toLowerCase() === 'video');
    }
    /** @internal */ updateInfo(info) {
        if (info.sid !== this.sid) // drop updates that specify a wrong sid.
        // the sid for local participant is only explicitly set on join and full reconnect
        return false;
        if (!super.updateInfo(info)) return false;
        // reconcile track mute status.
        // if server's track mute status doesn't match actual, we'll have to update
        // the server's copy
        info.tracks.forEach((ti)=>{
            var _a, _b;
            const pub = this.trackPublications.get(ti.sid);
            if (pub) {
                const mutedOnServer = pub.isMuted || ((_b = (_a = pub.track) === null || _a === void 0 ? void 0 : _a.isUpstreamPaused) !== null && _b !== void 0 ? _b : false);
                if (mutedOnServer !== ti.muted) {
                    this.log.debug('updating server mute state after reconcile', Object.assign(Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(pub)), {
                        mutedOnServer: mutedOnServer
                    }));
                    this.engine.client.sendMuteTrack(ti.sid, mutedOnServer);
                }
            }
        });
        return true;
    }
    getPublicationForTrack(track) {
        let publication;
        this.trackPublications.forEach((pub)=>{
            const localTrack = pub.track;
            if (!localTrack) return;
            // this looks overly complicated due to this object tree
            if (track instanceof MediaStreamTrack) {
                if (localTrack instanceof $2d7d9af7a5367cf4$export$b287427b771ca237 || localTrack instanceof $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc) {
                    if (localTrack.mediaStreamTrack === track) publication = pub;
                }
            } else if (track === localTrack) publication = pub;
        });
        return publication;
    }
    waitForPendingPublicationOfSource(source) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const waitForPendingTimeout = 10000;
            const startTime = Date.now();
            while(Date.now() < startTime + waitForPendingTimeout){
                const publishPromiseEntry = Array.from(this.pendingPublishPromises.entries()).find((_ref4)=>{
                    let [pendingTrack] = _ref4;
                    return pendingTrack.source === source;
                });
                if (publishPromiseEntry) return publishPromiseEntry[1];
                yield $2d7d9af7a5367cf4$var$sleep(20);
            }
        });
    }
}
class $2d7d9af7a5367cf4$export$c89ab28402142c29 extends $2d7d9af7a5367cf4$export$7c531331788c3797 {
    constructor(kind, ti, autoSubscribe, loggerOptions){
        super(kind, ti.sid, ti.name, loggerOptions);
        this.track = undefined;
        /** @internal */ this.allowed = true;
        this.disabled = false;
        this.currentVideoQuality = $2d7d9af7a5367cf4$export$a8f593954e806155.HIGH;
        this.handleEnded = (track)=>{
            this.setTrack(undefined);
            this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.Ended, track);
        };
        this.handleVisibilityChange = (visible)=>{
            this.log.debug("adaptivestream video visibility ".concat(this.trackSid, ", visible=").concat(visible), this.logContext);
            this.disabled = !visible;
            this.emitTrackUpdate();
        };
        this.handleVideoDimensionsChange = (dimensions)=>{
            this.log.debug("adaptivestream video dimensions ".concat(dimensions.width, "x").concat(dimensions.height), this.logContext);
            this.videoDimensions = dimensions;
            this.emitTrackUpdate();
        };
        this.subscribed = autoSubscribe;
        this.updateInfo(ti);
    }
    /**
   * Subscribe or unsubscribe to this remote track
   * @param subscribed true to subscribe to a track, false to unsubscribe
   */ setSubscribed(subscribed) {
        const prevStatus = this.subscriptionStatus;
        const prevPermission = this.permissionStatus;
        this.subscribed = subscribed;
        // reset allowed status when desired subscription state changes
        // server will notify client via signal message if it's not allowed
        if (subscribed) this.allowed = true;
        const sub = new $2d7d9af7a5367cf4$var$UpdateSubscription({
            trackSids: [
                this.trackSid
            ],
            subscribe: this.subscribed,
            participantTracks: [
                new $2d7d9af7a5367cf4$var$ParticipantTracks({
                    // sending an empty participant id since TrackPublication doesn't keep it
                    // this is filled in by the participant that receives this message
                    participantSid: '',
                    trackSids: [
                        this.trackSid
                    ]
                })
            ]
        });
        this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.UpdateSubscription, sub);
        this.emitSubscriptionUpdateIfChanged(prevStatus);
        this.emitPermissionUpdateIfChanged(prevPermission);
    }
    get subscriptionStatus() {
        if (this.subscribed === false) return $2d7d9af7a5367cf4$export$7c531331788c3797.SubscriptionStatus.Unsubscribed;
        if (!super.isSubscribed) return $2d7d9af7a5367cf4$export$7c531331788c3797.SubscriptionStatus.Desired;
        return $2d7d9af7a5367cf4$export$7c531331788c3797.SubscriptionStatus.Subscribed;
    }
    get permissionStatus() {
        return this.allowed ? $2d7d9af7a5367cf4$export$7c531331788c3797.PermissionStatus.Allowed : $2d7d9af7a5367cf4$export$7c531331788c3797.PermissionStatus.NotAllowed;
    }
    /**
   * Returns true if track is subscribed, and ready for playback
   */ get isSubscribed() {
        if (this.subscribed === false) return false;
        return super.isSubscribed;
    }
    // returns client's desire to subscribe to a track, also true if autoSubscribe is enabled
    get isDesired() {
        return this.subscribed !== false;
    }
    get isEnabled() {
        return !this.disabled;
    }
    /**
   * disable server from sending down data for this track. this is useful when
   * the participant is off screen, you may disable streaming down their video
   * to reduce bandwidth requirements
   * @param enabled
   */ setEnabled(enabled) {
        if (!this.isManualOperationAllowed() || this.disabled === !enabled) return;
        this.disabled = !enabled;
        this.emitTrackUpdate();
    }
    /**
   * for tracks that support simulcasting, adjust subscribed quality
   *
   * This indicates the highest quality the client can accept. if network
   * bandwidth does not allow, server will automatically reduce quality to
   * optimize for uninterrupted video
   */ setVideoQuality(quality) {
        if (!this.isManualOperationAllowed() || this.currentVideoQuality === quality) return;
        this.currentVideoQuality = quality;
        this.videoDimensions = undefined;
        this.emitTrackUpdate();
    }
    setVideoDimensions(dimensions) {
        var _a, _b;
        if (!this.isManualOperationAllowed()) return;
        if (((_a = this.videoDimensions) === null || _a === void 0 ? void 0 : _a.width) === dimensions.width && ((_b = this.videoDimensions) === null || _b === void 0 ? void 0 : _b.height) === dimensions.height) return;
        if (this.track instanceof $2d7d9af7a5367cf4$export$1db0c0ebd3ae1523) this.videoDimensions = dimensions;
        this.currentVideoQuality = undefined;
        this.emitTrackUpdate();
    }
    setVideoFPS(fps) {
        if (!this.isManualOperationAllowed()) return;
        if (!(this.track instanceof $2d7d9af7a5367cf4$export$1db0c0ebd3ae1523)) return;
        if (this.fps === fps) return;
        this.fps = fps;
        this.emitTrackUpdate();
    }
    get videoQuality() {
        return this.currentVideoQuality;
    }
    /** @internal */ setTrack(track) {
        const prevStatus = this.subscriptionStatus;
        const prevPermission = this.permissionStatus;
        const prevTrack = this.track;
        if (prevTrack === track) return;
        if (prevTrack) {
            // unregister listener
            prevTrack.off($2d7d9af7a5367cf4$export$2c8510d737cc09da.VideoDimensionsChanged, this.handleVideoDimensionsChange);
            prevTrack.off($2d7d9af7a5367cf4$export$2c8510d737cc09da.VisibilityChanged, this.handleVisibilityChange);
            prevTrack.off($2d7d9af7a5367cf4$export$2c8510d737cc09da.Ended, this.handleEnded);
            prevTrack.detach();
            prevTrack.stopMonitor();
            this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.Unsubscribed, prevTrack);
        }
        super.setTrack(track);
        if (track) {
            track.sid = this.trackSid;
            track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.VideoDimensionsChanged, this.handleVideoDimensionsChange);
            track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.VisibilityChanged, this.handleVisibilityChange);
            track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.Ended, this.handleEnded);
            this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.Subscribed, track);
        }
        this.emitPermissionUpdateIfChanged(prevPermission);
        this.emitSubscriptionUpdateIfChanged(prevStatus);
    }
    /** @internal */ setAllowed(allowed) {
        const prevStatus = this.subscriptionStatus;
        const prevPermission = this.permissionStatus;
        this.allowed = allowed;
        this.emitPermissionUpdateIfChanged(prevPermission);
        this.emitSubscriptionUpdateIfChanged(prevStatus);
    }
    /** @internal */ setSubscriptionError(error) {
        this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.SubscriptionFailed, error);
    }
    /** @internal */ updateInfo(info) {
        super.updateInfo(info);
        const prevMetadataMuted = this.metadataMuted;
        this.metadataMuted = info.muted;
        if (this.track) this.track.setMuted(info.muted);
        else if (prevMetadataMuted !== info.muted) this.emit(info.muted ? $2d7d9af7a5367cf4$export$2c8510d737cc09da.Muted : $2d7d9af7a5367cf4$export$2c8510d737cc09da.Unmuted);
    }
    emitSubscriptionUpdateIfChanged(previousStatus) {
        const currentStatus = this.subscriptionStatus;
        if (previousStatus === currentStatus) return;
        this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.SubscriptionStatusChanged, currentStatus, previousStatus);
    }
    emitPermissionUpdateIfChanged(previousPermissionStatus) {
        const currentPermissionStatus = this.permissionStatus;
        if (currentPermissionStatus !== previousPermissionStatus) this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.SubscriptionPermissionChanged, this.permissionStatus, previousPermissionStatus);
    }
    isManualOperationAllowed() {
        if (this.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video && this.isAdaptiveStream) {
            this.log.warn('adaptive stream is enabled, cannot change video track settings', this.logContext);
            return false;
        }
        if (!this.isDesired) {
            this.log.warn('cannot update track settings when not subscribed', this.logContext);
            return false;
        }
        return true;
    }
    get isAdaptiveStream() {
        return this.track instanceof $2d7d9af7a5367cf4$export$1db0c0ebd3ae1523 && this.track.isAdaptiveStream;
    }
    /* @internal */ emitTrackUpdate() {
        const settings = new $2d7d9af7a5367cf4$var$UpdateTrackSettings({
            trackSids: [
                this.trackSid
            ],
            disabled: this.disabled,
            fps: this.fps
        });
        if (this.videoDimensions) {
            settings.width = Math.ceil(this.videoDimensions.width);
            settings.height = Math.ceil(this.videoDimensions.height);
        } else if (this.currentVideoQuality !== undefined) settings.quality = this.currentVideoQuality;
        else // defaults to high quality
        settings.quality = $2d7d9af7a5367cf4$export$a8f593954e806155.HIGH;
        this.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.UpdateSettings, settings);
    }
}
class $2d7d9af7a5367cf4$export$bf85b9e4f33346fe extends $2d7d9af7a5367cf4$export$aada361ed1a6c65 {
    /** @internal */ static fromParticipantInfo(signalClient, pi, loggerOptions) {
        return new $2d7d9af7a5367cf4$export$bf85b9e4f33346fe(signalClient, pi.sid, pi.identity, pi.name, pi.metadata, pi.attributes, loggerOptions, pi.kind);
    }
    get logContext() {
        return Object.assign(Object.assign({}, super.logContext), {
            rpID: this.sid,
            remoteParticipant: this.identity
        });
    }
    /** @internal */ constructor(signalClient, sid, identity, name, metadata, attributes, loggerOptions){
        let kind = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : $2d7d9af7a5367cf4$export$2079c0e1523aec29.STANDARD;
        super(sid, identity || '', name, metadata, attributes, loggerOptions, kind);
        this.signalClient = signalClient;
        this.trackPublications = new Map();
        this.audioTrackPublications = new Map();
        this.videoTrackPublications = new Map();
        this.volumeMap = new Map();
    }
    addTrackPublication(publication) {
        super.addTrackPublication(publication);
        // register action events
        publication.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.UpdateSettings, (settings)=>{
            this.log.debug('send update settings', Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(publication)));
            this.signalClient.sendUpdateTrackSettings(settings);
        });
        publication.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.UpdateSubscription, (sub)=>{
            sub.participantTracks.forEach((pt)=>{
                pt.participantSid = this.sid;
            });
            this.signalClient.sendUpdateSubscription(sub);
        });
        publication.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.SubscriptionPermissionChanged, (status)=>{
            this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackSubscriptionPermissionChanged, publication, status);
        });
        publication.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.SubscriptionStatusChanged, (status)=>{
            this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackSubscriptionStatusChanged, publication, status);
        });
        publication.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.Subscribed, (track)=>{
            this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackSubscribed, track, publication);
        });
        publication.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.Unsubscribed, (previousTrack)=>{
            this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackUnsubscribed, previousTrack, publication);
        });
        publication.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.SubscriptionFailed, (error)=>{
            this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackSubscriptionFailed, publication.trackSid, error);
        });
    }
    getTrackPublication(source) {
        const track = super.getTrackPublication(source);
        if (track) return track;
    }
    getTrackPublicationByName(name) {
        const track = super.getTrackPublicationByName(name);
        if (track) return track;
    }
    /**
   * sets the volume on the participant's audio track
   * by default, this affects the microphone publication
   * a different source can be passed in as a second argument
   * if no track exists the volume will be applied when the microphone track is added
   */ setVolume(volume) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Microphone;
        this.volumeMap.set(source, volume);
        const audioPublication = this.getTrackPublication(source);
        if (audioPublication && audioPublication.track) audioPublication.track.setVolume(volume);
    }
    /**
   * gets the volume on the participant's microphone track
   */ getVolume() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Microphone;
        const audioPublication = this.getTrackPublication(source);
        if (audioPublication && audioPublication.track) return audioPublication.track.getVolume();
        return this.volumeMap.get(source);
    }
    /** @internal */ addSubscribedMediaTrack(mediaTrack, sid, mediaStream, receiver, adaptiveStreamSettings, triesLeft) {
        // find the track publication
        // it's possible for the media track to arrive before participant info
        let publication = this.getTrackPublicationBySid(sid);
        // it's also possible that the browser didn't honor our original track id
        // FireFox would use its own local uuid instead of server track id
        if (!publication) {
            if (!sid.startsWith('TR')) // find the first track that matches type
            this.trackPublications.forEach((p)=>{
                if (!publication && mediaTrack.kind === p.kind.toString()) publication = p;
            });
        }
        // when we couldn't locate the track, it's possible that the metadata hasn't
        // yet arrived. Wait a bit longer for it to arrive, or fire an error
        if (!publication) {
            if (triesLeft === 0) {
                this.log.error('could not find published track', Object.assign(Object.assign({}, this.logContext), {
                    trackSid: sid
                }));
                this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackSubscriptionFailed, sid);
                return;
            }
            if (triesLeft === undefined) triesLeft = 20;
            setTimeout(()=>{
                this.addSubscribedMediaTrack(mediaTrack, sid, mediaStream, receiver, adaptiveStreamSettings, triesLeft - 1);
            }, 150);
            return;
        }
        if (mediaTrack.readyState === 'ended') {
            this.log.error('unable to subscribe because MediaStreamTrack is ended. Do not call MediaStreamTrack.stop()', Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(publication)));
            this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackSubscriptionFailed, sid);
            return;
        }
        const isVideo = mediaTrack.kind === 'video';
        let track;
        if (isVideo) track = new $2d7d9af7a5367cf4$export$1db0c0ebd3ae1523(mediaTrack, sid, receiver, adaptiveStreamSettings);
        else track = new $2d7d9af7a5367cf4$export$fd37b116bd840ced(mediaTrack, sid, receiver, this.audioContext, this.audioOutput);
        // set track info
        track.source = publication.source;
        // keep publication's muted status
        track.isMuted = publication.isMuted;
        track.setMediaStream(mediaStream);
        track.start();
        publication.setTrack(track);
        // set participant volumes on new audio tracks
        if (this.volumeMap.has(publication.source) && track instanceof $2d7d9af7a5367cf4$export$fd37b116bd840ced) track.setVolume(this.volumeMap.get(publication.source));
        return publication;
    }
    /** @internal */ get hasMetadata() {
        return !!this.participantInfo;
    }
    /**
   * @internal
   */ getTrackPublicationBySid(sid) {
        return this.trackPublications.get(sid);
    }
    /** @internal */ updateInfo(info) {
        if (!super.updateInfo(info)) return false;
        // we are getting a list of all available tracks, reconcile in here
        // and send out events for changes
        // reconcile track publications, publish events only if metadata is already there
        // i.e. changes since the local participant has joined
        const validTracks = new Map();
        const newTracks = new Map();
        info.tracks.forEach((ti)=>{
            var _a, _b;
            let publication = this.getTrackPublicationBySid(ti.sid);
            if (!publication) {
                // new publication
                const kind = $2d7d9af7a5367cf4$export$13921ac0cc260818.kindFromProto(ti.type);
                if (!kind) return;
                publication = new $2d7d9af7a5367cf4$export$c89ab28402142c29(kind, ti, (_a = this.signalClient.connectOptions) === null || _a === void 0 ? void 0 : _a.autoSubscribe, {
                    loggerContextCb: ()=>this.logContext,
                    loggerName: (_b = this.loggerOptions) === null || _b === void 0 ? void 0 : _b.loggerName
                });
                publication.updateInfo(ti);
                newTracks.set(ti.sid, publication);
                const existingTrackOfSource = Array.from(this.trackPublications.values()).find((publishedTrack)=>publishedTrack.source === (publication === null || publication === void 0 ? void 0 : publication.source));
                if (existingTrackOfSource && publication.source !== $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Unknown) this.log.debug("received a second track publication for ".concat(this.identity, " with the same source: ").concat(publication.source), Object.assign(Object.assign({}, this.logContext), {
                    oldTrack: $2d7d9af7a5367cf4$var$getLogContextFromTrack(existingTrackOfSource),
                    newTrack: $2d7d9af7a5367cf4$var$getLogContextFromTrack(publication)
                }));
                this.addTrackPublication(publication);
            } else publication.updateInfo(ti);
            validTracks.set(ti.sid, publication);
        });
        // detect removed tracks
        this.trackPublications.forEach((publication)=>{
            if (!validTracks.has(publication.trackSid)) {
                this.log.trace('detected removed track on remote participant, unpublishing', Object.assign(Object.assign({}, this.logContext), $2d7d9af7a5367cf4$var$getLogContextFromTrack(publication)));
                this.unpublishTrack(publication.trackSid, true);
            }
        });
        // always emit events for new publications, Room will not forward them unless it's ready
        newTracks.forEach((publication)=>{
            this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackPublished, publication);
        });
        return true;
    }
    /** @internal */ unpublishTrack(sid, sendUnpublish) {
        const publication = this.trackPublications.get(sid);
        if (!publication) return;
        // also send unsubscribe, if track is actively subscribed
        const { track: track } = publication;
        if (track) {
            track.stop();
            publication.setTrack(undefined);
        }
        // remove track from maps only after unsubscribed has been fired
        this.trackPublications.delete(sid);
        // remove from the right type map
        switch(publication.kind){
            case $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Audio:
                this.audioTrackPublications.delete(sid);
                break;
            case $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video:
                this.videoTrackPublications.delete(sid);
                break;
        }
        if (sendUnpublish) this.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackUnpublished, publication);
    }
    /**
   * @internal
   */ setAudioOutput(output) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            this.audioOutput = output;
            const promises = [];
            this.audioTrackPublications.forEach((pub)=>{
                var _a;
                if (pub.track instanceof $2d7d9af7a5367cf4$export$fd37b116bd840ced) promises.push(pub.track.setSinkId((_a = output.deviceId) !== null && _a !== void 0 ? _a : 'default'));
            });
            yield Promise.all(promises);
        });
    }
    /** @internal */ emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        this.log.trace('participant event', Object.assign(Object.assign({}, this.logContext), {
            event: event,
            args: args
        }));
        return super.emit(event, ...args);
    }
}
var $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9;
(function(ConnectionState) {
    ConnectionState["Disconnected"] = "disconnected";
    ConnectionState["Connecting"] = "connecting";
    ConnectionState["Connected"] = "connected";
    ConnectionState["Reconnecting"] = "reconnecting";
    ConnectionState["SignalReconnecting"] = "signalReconnecting";
})($2d7d9af7a5367cf4$export$cd9c3c6bf535afc9 || ($2d7d9af7a5367cf4$export$cd9c3c6bf535afc9 = {}));
const $2d7d9af7a5367cf4$var$connectionReconcileFrequency = 4000;
/**
 * In LiveKit, a room is the logical grouping for a list of participants.
 * Participants in a room can publish tracks, and subscribe to others' tracks.
 *
 * a Room fires [[RoomEvent | RoomEvents]].
 *
 * @noInheritDoc
 */ class $2d7d9af7a5367cf4$export$525628e68e798fb4 extends $2d7d9af7a5367cf4$var$eventsExports.EventEmitter {
    /**
   * Creates a new Room, the primary construct for a LiveKit session.
   * @param options
   */ constructor(options){
        var _this;
        var _a, _b;
        super();
        _this = this;
        this.state = $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Disconnected;
        /**
     * list of participants that are actively speaking. when this changes
     * a [[RoomEvent.ActiveSpeakersChanged]] event is fired
     */ this.activeSpeakers = [];
        /** reflects the sender encryption status of the local participant */ this.isE2EEEnabled = false;
        this.audioEnabled = true;
        this.isVideoPlaybackBlocked = false;
        this.log = $2d7d9af7a5367cf4$var$livekitLogger;
        this.bufferedEvents = [];
        this.isResuming = false;
        this.connect = (url, token, opts)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                var _a;
                if (!$2d7d9af7a5367cf4$export$3fe402ec04821f17()) {
                    if ($2d7d9af7a5367cf4$var$isReactNative()) throw Error("WebRTC isn't detected, have you called registerGlobals?");
                    else throw Error("LiveKit doesn't seem to be supported on this browser. Try to update your browser and make sure no browser extensions are disabling webRTC.");
                }
                // In case a disconnect called happened right before the connect call, make sure the disconnect is completed first by awaiting its lock
                const unlockDisconnect = yield this.disconnectLock.lock();
                if (this.state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Connected) {
                    // when the state is reconnecting or connected, this function returns immediately
                    this.log.info("already connected to room ".concat(this.name), this.logContext);
                    unlockDisconnect();
                    return Promise.resolve();
                }
                if (this.connectFuture) {
                    unlockDisconnect();
                    return this.connectFuture.promise;
                }
                this.setAndEmitConnectionState($2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Connecting);
                if (((_a = this.regionUrlProvider) === null || _a === void 0 ? void 0 : _a.getServerUrl().toString()) !== url) {
                    this.regionUrl = undefined;
                    this.regionUrlProvider = undefined;
                }
                if ($2d7d9af7a5367cf4$var$isCloud(new URL(url))) {
                    if (this.regionUrlProvider === undefined) this.regionUrlProvider = new $2d7d9af7a5367cf4$var$RegionUrlProvider(url, token);
                    else this.regionUrlProvider.updateToken(token);
                    // trigger the first fetch without waiting for a response
                    // if initial connection fails, this will speed up picking regional url
                    // on subsequent runs
                    this.regionUrlProvider.fetchRegionSettings().then((settings)=>{
                        var _a;
                        (_a = this.regionUrlProvider) === null || _a === void 0 || _a.setServerReportedRegions(settings);
                    }).catch((e)=>{
                        this.log.warn('could not fetch region settings', Object.assign(Object.assign({}, this.logContext), {
                            error: e
                        }));
                    });
                }
                const connectFn = (resolve, reject, regionUrl)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                        var _a, _b;
                        if (this.abortController) this.abortController.abort();
                        // explicit creation as local var needed to satisfy TS compiler when passing it to `attemptConnection` further down
                        const abortController = new AbortController();
                        this.abortController = abortController;
                        // at this point the intention to connect has been signalled so we can allow cancelling of the connection via disconnect() again
                        unlockDisconnect === null || unlockDisconnect === void 0 || unlockDisconnect();
                        try {
                            yield this.attemptConnection(regionUrl !== null && regionUrl !== void 0 ? regionUrl : url, token, opts, abortController);
                            this.abortController = undefined;
                            resolve();
                        } catch (e) {
                            if (this.regionUrlProvider && e instanceof $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb && e.reason !== $2d7d9af7a5367cf4$export$61182a0b21436b65.Cancelled && e.reason !== $2d7d9af7a5367cf4$export$61182a0b21436b65.NotAllowed) {
                                let nextUrl = null;
                                try {
                                    nextUrl = yield this.regionUrlProvider.getNextBestRegionUrl((_a = this.abortController) === null || _a === void 0 ? void 0 : _a.signal);
                                } catch (error) {
                                    if (error instanceof $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb && (error.status === 401 || error.reason === $2d7d9af7a5367cf4$export$61182a0b21436b65.Cancelled)) {
                                        this.handleDisconnect(this.options.stopLocalTrackOnUnpublish);
                                        reject(error);
                                        return;
                                    }
                                }
                                if (nextUrl && !((_b = this.abortController) === null || _b === void 0 ? void 0 : _b.signal.aborted)) {
                                    this.log.info("Initial connection failed with ConnectionError: ".concat(e.message, ". Retrying with another region: ").concat(nextUrl), this.logContext);
                                    this.recreateEngine();
                                    yield connectFn(resolve, reject, nextUrl);
                                } else {
                                    this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, $2d7d9af7a5367cf4$var$getDisconnectReasonFromConnectionError(e));
                                    reject(e);
                                }
                            } else {
                                let disconnectReason = $2d7d9af7a5367cf4$export$258d16488300d83f.UNKNOWN_REASON;
                                if (e instanceof $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb) disconnectReason = $2d7d9af7a5367cf4$var$getDisconnectReasonFromConnectionError(e);
                                this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, disconnectReason);
                                reject(e);
                            }
                        }
                    });
                const regionUrl = this.regionUrl;
                this.regionUrl = undefined;
                this.connectFuture = new $2d7d9af7a5367cf4$var$Future((resolve, reject)=>{
                    connectFn(resolve, reject, regionUrl);
                }, ()=>{
                    this.clearConnectionFutures();
                });
                return this.connectFuture.promise;
            });
        this.connectSignal = (url, token, engine, connectOptions, roomOptions, abortController)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b, _c;
                const joinResponse = yield engine.join(url, token, {
                    autoSubscribe: connectOptions.autoSubscribe,
                    adaptiveStream: typeof roomOptions.adaptiveStream === 'object' ? true : roomOptions.adaptiveStream,
                    maxRetries: connectOptions.maxRetries,
                    e2eeEnabled: !!this.e2eeManager,
                    websocketTimeout: connectOptions.websocketTimeout
                }, abortController.signal);
                let serverInfo = joinResponse.serverInfo;
                if (!serverInfo) serverInfo = {
                    version: joinResponse.serverVersion,
                    region: joinResponse.serverRegion
                };
                this.serverInfo = serverInfo;
                this.log.debug("connected to Livekit Server ".concat(Object.entries(serverInfo).map((_ref)=>{
                    let [key, value] = _ref;
                    return "".concat(key, ": ").concat(value);
                }).join(', ')), {
                    room: (_a = joinResponse.room) === null || _a === void 0 ? void 0 : _a.name,
                    roomSid: (_b = joinResponse.room) === null || _b === void 0 ? void 0 : _b.sid,
                    identity: (_c = joinResponse.participant) === null || _c === void 0 ? void 0 : _c.identity
                });
                if (!serverInfo.version) throw new $2d7d9af7a5367cf4$export$4d307571a351c50c('unknown server version');
                if (serverInfo.version === '0.15.1' && this.options.dynacast) {
                    this.log.debug('disabling dynacast due to server version', this.logContext);
                    // dynacast has a bug in 0.15.1, so we cannot use it then
                    roomOptions.dynacast = false;
                }
                return joinResponse;
            });
        this.applyJoinResponse = (joinResponse)=>{
            const pi = joinResponse.participant;
            this.localParticipant.sid = pi.sid;
            this.localParticipant.identity = pi.identity;
            this.localParticipant.setEnabledPublishCodecs(joinResponse.enabledPublishCodecs);
            if (this.options.e2ee && this.e2eeManager) try {
                this.e2eeManager.setSifTrailer(joinResponse.sifTrailer);
            } catch (e) {
                this.log.error(e instanceof Error ? e.message : 'Could not set SifTrailer', Object.assign(Object.assign({}, this.logContext), {
                    error: e
                }));
            }
            // populate remote participants, these should not trigger new events
            this.handleParticipantUpdates([
                pi,
                ...joinResponse.otherParticipants
            ]);
            if (joinResponse.room) this.handleRoomUpdate(joinResponse.room);
        };
        this.attemptConnection = (url, token, opts, abortController)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b, _c;
                if (this.state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Reconnecting || this.isResuming || ((_a = this.engine) === null || _a === void 0 ? void 0 : _a.pendingReconnect)) {
                    this.log.info('Reconnection attempt replaced by new connection attempt', this.logContext);
                    // make sure we close and recreate the existing engine in order to get rid of any potentially ongoing reconnection attempts
                    this.recreateEngine();
                } else // create engine if previously disconnected
                this.maybeCreateEngine();
                if ((_b = this.regionUrlProvider) === null || _b === void 0 ? void 0 : _b.isCloud()) this.engine.setRegionUrlProvider(this.regionUrlProvider);
                this.acquireAudioContext();
                this.connOptions = Object.assign(Object.assign({}, $2d7d9af7a5367cf4$var$roomConnectOptionDefaults), opts);
                if (this.connOptions.rtcConfig) this.engine.rtcConfig = this.connOptions.rtcConfig;
                if (this.connOptions.peerConnectionTimeout) this.engine.peerConnectionTimeout = this.connOptions.peerConnectionTimeout;
                try {
                    const joinResponse = yield this.connectSignal(url, token, this.engine, this.connOptions, this.options, abortController);
                    this.applyJoinResponse(joinResponse);
                    // forward metadata changed for the local participant
                    this.setupLocalParticipantEvents();
                    this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.SignalConnected);
                } catch (err) {
                    yield this.engine.close();
                    this.recreateEngine();
                    const resultingError = new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb("could not establish signal connection", $2d7d9af7a5367cf4$export$61182a0b21436b65.ServerUnreachable);
                    if (err instanceof Error) resultingError.message = "".concat(resultingError.message, ": ").concat(err.message);
                    if (err instanceof $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb) {
                        resultingError.reason = err.reason;
                        resultingError.status = err.status;
                    }
                    this.log.debug("error trying to establish signal connection", Object.assign(Object.assign({}, this.logContext), {
                        error: err
                    }));
                    throw resultingError;
                }
                if (abortController.signal.aborted) {
                    yield this.engine.close();
                    this.recreateEngine();
                    throw new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb("Connection attempt aborted", $2d7d9af7a5367cf4$export$61182a0b21436b65.Cancelled);
                }
                try {
                    yield this.engine.waitForPCInitialConnection(this.connOptions.peerConnectionTimeout, abortController);
                } catch (e) {
                    yield this.engine.close();
                    this.recreateEngine();
                    throw e;
                }
                // also hook unload event
                if ($2d7d9af7a5367cf4$var$isWeb() && this.options.disconnectOnPageLeave) {
                    // capturing both 'pagehide' and 'beforeunload' to capture broadest set of browser behaviors
                    window.addEventListener('pagehide', this.onPageLeave);
                    window.addEventListener('beforeunload', this.onPageLeave);
                }
                if ($2d7d9af7a5367cf4$var$isWeb()) {
                    document.addEventListener('freeze', this.onPageLeave);
                    (_c = navigator.mediaDevices) === null || _c === void 0 || _c.addEventListener('devicechange', this.handleDeviceChange);
                }
                this.setAndEmitConnectionState($2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Connected);
                this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.Connected);
                this.registerConnectionReconcile();
            });
        /**
     * disconnects the room, emits [[RoomEvent.Disconnected]]
     */ this.disconnect = function() {
            for(var _len = arguments.length, args_1 = new Array(_len), _key = 0; _key < _len; _key++)args_1[_key] = arguments[_key];
            return $2d7d9af7a5367cf4$var$__awaiter(_this, [
                ...args_1
            ], void 0, function() {
                var _this2 = this;
                let stopTracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                return function*() {
                    var _a, _b, _c, _d;
                    const unlock = yield _this2.disconnectLock.lock();
                    try {
                        if (_this2.state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Disconnected) {
                            _this2.log.debug('already disconnected', _this2.logContext);
                            return;
                        }
                        _this2.log.info('disconnect from room', Object.assign({}, _this2.logContext));
                        if (_this2.state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Connecting || _this2.state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Reconnecting || _this2.isResuming) {
                            // try aborting pending connection attempt
                            _this2.log.warn('abort connection attempt', _this2.logContext);
                            (_a = _this2.abortController) === null || _a === void 0 || _a.abort();
                            // in case the abort controller didn't manage to cancel the connection attempt, reject the connect promise explicitly
                            (_c = (_b = _this2.connectFuture) === null || _b === void 0 ? void 0 : _b.reject) === null || _c === void 0 || _c.call(_b, new $2d7d9af7a5367cf4$export$a3747c6e46c7a8eb('Client initiated disconnect', $2d7d9af7a5367cf4$export$61182a0b21436b65.Cancelled));
                            _this2.connectFuture = undefined;
                        }
                        // send leave
                        if (!((_d = _this2.engine) === null || _d === void 0 ? void 0 : _d.client.isDisconnected)) yield _this2.engine.client.sendLeave();
                        // close engine (also closes client)
                        if (_this2.engine) yield _this2.engine.close();
                        _this2.handleDisconnect(stopTracks, $2d7d9af7a5367cf4$export$258d16488300d83f.CLIENT_INITIATED);
                        /* @ts-ignore */ _this2.engine = undefined;
                    } finally{
                        unlock();
                    }
                }();
            });
        };
        this.onPageLeave = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                this.log.info('Page leave detected, disconnecting', this.logContext);
                yield this.disconnect();
            });
        /**
     * Browsers have different policies regarding audio playback. Most requiring
     * some form of user interaction (click/tap/etc).
     * In those cases, audio will be silent until a click/tap triggering one of the following
     * - `startAudio`
     * - `getUserMedia`
     */ this.startAudio = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                const elements = [];
                const browser = $2d7d9af7a5367cf4$export$89e15fc796a4a429();
                if (browser && browser.os === 'iOS') {
                    /**
         * iOS blocks audio element playback if
         * - user is not publishing audio themselves and
         * - no other audio source is playing
         *
         * as a workaround, we create an audio element with an empty track, so that
         * silent audio is always playing
         */ const audioId = 'livekit-dummy-audio-el';
                    let dummyAudioEl = document.getElementById(audioId);
                    if (!dummyAudioEl) {
                        dummyAudioEl = document.createElement('audio');
                        dummyAudioEl.id = audioId;
                        dummyAudioEl.autoplay = true;
                        dummyAudioEl.hidden = true;
                        const track = $2d7d9af7a5367cf4$export$59e276d6841f735c();
                        track.enabled = true;
                        const stream = new MediaStream([
                            track
                        ]);
                        dummyAudioEl.srcObject = stream;
                        document.addEventListener('visibilitychange', ()=>{
                            if (!dummyAudioEl) return;
                            // set the srcObject to null on page hide in order to prevent lock screen controls to show up for it
                            dummyAudioEl.srcObject = document.hidden ? null : stream;
                            if (!document.hidden) {
                                this.log.debug('page visible again, triggering startAudio to resume playback and update playback status', this.logContext);
                                this.startAudio();
                            }
                        });
                        document.body.append(dummyAudioEl);
                        this.once($2d7d9af7a5367cf4$export$3159c672e3b2293a.Disconnected, ()=>{
                            dummyAudioEl === null || dummyAudioEl === void 0 || dummyAudioEl.remove();
                            dummyAudioEl = null;
                        });
                    }
                    elements.push(dummyAudioEl);
                }
                this.remoteParticipants.forEach((p)=>{
                    p.audioTrackPublications.forEach((t)=>{
                        if (t.track) t.track.attachedElements.forEach((e)=>{
                            elements.push(e);
                        });
                    });
                });
                try {
                    yield Promise.all([
                        this.acquireAudioContext(),
                        ...elements.map((e)=>{
                            e.muted = false;
                            return e.play();
                        })
                    ]);
                    this.handleAudioPlaybackStarted();
                } catch (err) {
                    this.handleAudioPlaybackFailed(err);
                    throw err;
                }
            });
        this.startVideo = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                const elements = [];
                for (const p of this.remoteParticipants.values())p.videoTrackPublications.forEach((tr)=>{
                    var _a;
                    (_a = tr.track) === null || _a === void 0 || _a.attachedElements.forEach((el)=>{
                        if (!elements.includes(el)) elements.push(el);
                    });
                });
                yield Promise.all(elements.map((el)=>el.play())).then(()=>{
                    this.handleVideoPlaybackStarted();
                }).catch((e)=>{
                    if (e.name === 'NotAllowedError') this.handleVideoPlaybackFailed();
                    else this.log.warn('Resuming video playback failed, make sure you call `startVideo` directly in a user gesture handler', this.logContext);
                });
            });
        this.handleRestarting = ()=>{
            this.clearConnectionReconcile();
            // in case we went from resuming to full-reconnect, make sure to reflect it on the isResuming flag
            this.isResuming = false;
            // also unwind existing participants & existing subscriptions
            for (const p of this.remoteParticipants.values())this.handleParticipantDisconnected(p.identity, p);
            if (this.setAndEmitConnectionState($2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Reconnecting)) this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.Reconnecting);
        };
        this.handleSignalRestarted = (joinResponse)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                this.log.debug("signal reconnected to server, region ".concat(joinResponse.serverRegion), Object.assign(Object.assign({}, this.logContext), {
                    region: joinResponse.serverRegion
                }));
                this.bufferedEvents = [];
                this.applyJoinResponse(joinResponse);
                try {
                    // unpublish & republish tracks
                    yield this.localParticipant.republishAllTracks(undefined, true);
                } catch (error) {
                    this.log.error('error trying to re-publish tracks after reconnection', Object.assign(Object.assign({}, this.logContext), {
                        error: error
                    }));
                }
                try {
                    yield this.engine.waitForRestarted();
                    this.log.debug("fully reconnected to server", Object.assign(Object.assign({}, this.logContext), {
                        region: joinResponse.serverRegion
                    }));
                } catch (_a) {
                    // reconnection failed, handleDisconnect is being invoked already, just return here
                    return;
                }
                this.setAndEmitConnectionState($2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Connected);
                this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.Reconnected);
                this.registerConnectionReconcile();
                this.emitBufferedEvents();
            });
        this.handleParticipantUpdates = (participantInfos)=>{
            // handle changes to participant state, and send events
            participantInfos.forEach((info)=>{
                var _a;
                if (info.identity === this.localParticipant.identity) {
                    this.localParticipant.updateInfo(info);
                    return;
                }
                // LiveKit server doesn't send identity info prior to version 1.5.2 in disconnect updates
                // so we try to map an empty identity to an already known sID manually
                if (info.identity === '') info.identity = (_a = this.sidToIdentity.get(info.sid)) !== null && _a !== void 0 ? _a : '';
                let remoteParticipant = this.remoteParticipants.get(info.identity);
                // when it's disconnected, send updates
                if (info.state === $2d7d9af7a5367cf4$var$ParticipantInfo_State.DISCONNECTED) this.handleParticipantDisconnected(info.identity, remoteParticipant);
                else // create participant if doesn't exist
                remoteParticipant = this.getOrCreateParticipant(info.identity, info);
            });
        };
        // updates are sent only when there's a change to speaker ordering
        this.handleActiveSpeakersUpdate = (speakers)=>{
            const activeSpeakers = [];
            const seenSids = {};
            speakers.forEach((speaker)=>{
                seenSids[speaker.sid] = true;
                if (speaker.sid === this.localParticipant.sid) {
                    this.localParticipant.audioLevel = speaker.level;
                    this.localParticipant.setIsSpeaking(true);
                    activeSpeakers.push(this.localParticipant);
                } else {
                    const p = this.getRemoteParticipantBySid(speaker.sid);
                    if (p) {
                        p.audioLevel = speaker.level;
                        p.setIsSpeaking(true);
                        activeSpeakers.push(p);
                    }
                }
            });
            if (!seenSids[this.localParticipant.sid]) {
                this.localParticipant.audioLevel = 0;
                this.localParticipant.setIsSpeaking(false);
            }
            this.remoteParticipants.forEach((p)=>{
                if (!seenSids[p.sid]) {
                    p.audioLevel = 0;
                    p.setIsSpeaking(false);
                }
            });
            this.activeSpeakers = activeSpeakers;
            this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.ActiveSpeakersChanged, activeSpeakers);
        };
        // process list of changed speakers
        this.handleSpeakersChanged = (speakerUpdates)=>{
            const lastSpeakers = new Map();
            this.activeSpeakers.forEach((p)=>{
                const remoteParticipant = this.remoteParticipants.get(p.identity);
                if (remoteParticipant && remoteParticipant.sid !== p.sid) return;
                lastSpeakers.set(p.sid, p);
            });
            speakerUpdates.forEach((speaker)=>{
                let p = this.getRemoteParticipantBySid(speaker.sid);
                if (speaker.sid === this.localParticipant.sid) p = this.localParticipant;
                if (!p) return;
                p.audioLevel = speaker.level;
                p.setIsSpeaking(speaker.active);
                if (speaker.active) lastSpeakers.set(speaker.sid, p);
                else lastSpeakers.delete(speaker.sid);
            });
            const activeSpeakers = Array.from(lastSpeakers.values());
            activeSpeakers.sort((a, b)=>b.audioLevel - a.audioLevel);
            this.activeSpeakers = activeSpeakers;
            this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.ActiveSpeakersChanged, activeSpeakers);
        };
        this.handleStreamStateUpdate = (streamStateUpdate)=>{
            streamStateUpdate.streamStates.forEach((streamState)=>{
                const participant = this.getRemoteParticipantBySid(streamState.participantSid);
                if (!participant) return;
                const pub = participant.getTrackPublicationBySid(streamState.trackSid);
                if (!pub || !pub.track) return;
                const newStreamState = $2d7d9af7a5367cf4$export$13921ac0cc260818.streamStateFromProto(streamState.state);
                if (newStreamState !== pub.track.streamState) {
                    pub.track.streamState = newStreamState;
                    participant.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackStreamStateChanged, pub, pub.track.streamState);
                    this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackStreamStateChanged, pub, pub.track.streamState, participant);
                }
            });
        };
        this.handleSubscriptionPermissionUpdate = (update)=>{
            const participant = this.getRemoteParticipantBySid(update.participantSid);
            if (!participant) return;
            const pub = participant.getTrackPublicationBySid(update.trackSid);
            if (!pub) return;
            pub.setAllowed(update.allowed);
        };
        this.handleSubscriptionError = (update)=>{
            const participant = Array.from(this.remoteParticipants.values()).find((p)=>p.trackPublications.has(update.trackSid));
            if (!participant) return;
            const pub = participant.getTrackPublicationBySid(update.trackSid);
            if (!pub) return;
            pub.setSubscriptionError(update.err);
        };
        this.handleDataPacket = (packet)=>{
            // find the participant
            const participant = this.remoteParticipants.get(packet.participantIdentity);
            if (packet.value.case === 'user') this.handleUserPacket(participant, packet.value.value, packet.kind);
            else if (packet.value.case === 'transcription') this.handleTranscription(participant, packet.value.value);
            else if (packet.value.case === 'sipDtmf') this.handleSipDtmf(participant, packet.value.value);
            else if (packet.value.case === 'chatMessage') this.handleChatMessage(participant, packet.value.value);
            else if (packet.value.case === 'metrics') this.handleMetrics(packet.value.value, participant);
        };
        this.handleUserPacket = (participant, userPacket, kind)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.DataReceived, userPacket.payload, participant, kind, userPacket.topic);
            // also emit on the participant
            participant === null || participant === void 0 || participant.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.DataReceived, userPacket.payload, kind);
        };
        this.handleSipDtmf = (participant, dtmf)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.SipDTMFReceived, dtmf, participant);
            // also emit on the participant
            participant === null || participant === void 0 || participant.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.SipDTMFReceived, dtmf);
        };
        this.bufferedSegments = new Map();
        this.handleTranscription = (_remoteParticipant, transcription)=>{
            // find the participant
            const participant = transcription.transcribedParticipantIdentity === this.localParticipant.identity ? this.localParticipant : this.getParticipantByIdentity(transcription.transcribedParticipantIdentity);
            const publication = participant === null || participant === void 0 ? void 0 : participant.trackPublications.get(transcription.trackId);
            const segments = $2d7d9af7a5367cf4$var$extractTranscriptionSegments(transcription, this.transcriptionReceivedTimes);
            publication === null || publication === void 0 || publication.emit($2d7d9af7a5367cf4$export$2c8510d737cc09da.TranscriptionReceived, segments);
            participant === null || participant === void 0 || participant.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TranscriptionReceived, segments, publication);
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.TranscriptionReceived, segments, participant, publication);
        };
        this.handleChatMessage = (participant, chatMessage)=>{
            const msg = $2d7d9af7a5367cf4$var$extractChatMessage(chatMessage);
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.ChatMessage, msg, participant);
        };
        this.handleMetrics = (metrics, participant)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.MetricsReceived, metrics, participant);
        };
        this.handleAudioPlaybackStarted = ()=>{
            if (this.canPlaybackAudio) return;
            this.audioEnabled = true;
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.AudioPlaybackStatusChanged, true);
        };
        this.handleAudioPlaybackFailed = (e)=>{
            this.log.warn('could not playback audio', Object.assign(Object.assign({}, this.logContext), {
                error: e
            }));
            if (!this.canPlaybackAudio) return;
            this.audioEnabled = false;
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.AudioPlaybackStatusChanged, false);
        };
        this.handleVideoPlaybackStarted = ()=>{
            if (this.isVideoPlaybackBlocked) {
                this.isVideoPlaybackBlocked = false;
                this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.VideoPlaybackStatusChanged, true);
            }
        };
        this.handleVideoPlaybackFailed = ()=>{
            if (!this.isVideoPlaybackBlocked) {
                this.isVideoPlaybackBlocked = true;
                this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.VideoPlaybackStatusChanged, false);
            }
        };
        this.handleDeviceChange = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                // check for available devices, but don't request permissions in order to avoid prompts for kinds that haven't been used before
                const availableDevices = yield $2d7d9af7a5367cf4$var$DeviceManager.getInstance().getDevices(undefined, false);
                // inputs are automatically handled via TrackEvent.Ended causing a TrackEvent.Restarted. Here we only need to worry about audiooutputs changing
                const kinds = [
                    'audiooutput'
                ];
                for (let kind of kinds){
                    // switch to first available device if previously active device is not available any more
                    const devicesOfKind = availableDevices.filter((d)=>d.kind === kind);
                    if (devicesOfKind.length > 0 && !devicesOfKind.find((deviceInfo)=>deviceInfo.deviceId === this.getActiveDevice(kind))) yield this.switchActiveDevice(kind, devicesOfKind[0].deviceId);
                }
                this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.MediaDevicesChanged);
            });
        this.handleRoomUpdate = (room)=>{
            const oldRoom = this.roomInfo;
            this.roomInfo = room;
            if (oldRoom && oldRoom.metadata !== room.metadata) this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.RoomMetadataChanged, room.metadata);
            if ((oldRoom === null || oldRoom === void 0 ? void 0 : oldRoom.activeRecording) !== room.activeRecording) this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.RecordingStatusChanged, room.activeRecording);
        };
        this.handleConnectionQualityUpdate = (update)=>{
            update.updates.forEach((info)=>{
                if (info.participantSid === this.localParticipant.sid) {
                    this.localParticipant.setConnectionQuality(info.quality);
                    return;
                }
                const participant = this.getRemoteParticipantBySid(info.participantSid);
                if (participant) participant.setConnectionQuality(info.quality);
            });
        };
        this.onLocalParticipantMetadataChanged = (metadata)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.ParticipantMetadataChanged, metadata, this.localParticipant);
        };
        this.onLocalParticipantNameChanged = (name)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.ParticipantNameChanged, name, this.localParticipant);
        };
        this.onLocalAttributesChanged = (changedAttributes)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.ParticipantAttributesChanged, changedAttributes, this.localParticipant);
        };
        this.onLocalTrackMuted = (pub)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackMuted, pub, this.localParticipant);
        };
        this.onLocalTrackUnmuted = (pub)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackUnmuted, pub, this.localParticipant);
        };
        this.onTrackProcessorUpdate = (processor)=>{
            var _a;
            (_a = processor === null || processor === void 0 ? void 0 : processor.onPublish) === null || _a === void 0 || _a.call(processor, this);
        };
        this.onLocalTrackPublished = (pub)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b, _c, _d, _e, _f;
                (_a = pub.track) === null || _a === void 0 || _a.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.TrackProcessorUpdate, this.onTrackProcessorUpdate);
                (_b = pub.track) === null || _b === void 0 || _b.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.Restarted, this.onLocalTrackRestarted);
                (_e = (_d = (_c = pub.track) === null || _c === void 0 ? void 0 : _c.getProcessor()) === null || _d === void 0 ? void 0 : _d.onPublish) === null || _e === void 0 || _e.call(_d, this);
                this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.LocalTrackPublished, pub, this.localParticipant);
                if (pub.track instanceof $2d7d9af7a5367cf4$export$b287427b771ca237) {
                    const trackIsSilent = yield pub.track.checkForSilence();
                    if (trackIsSilent) this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.LocalAudioSilenceDetected, pub);
                }
                const deviceId = yield (_f = pub.track) === null || _f === void 0 ? void 0 : _f.getDeviceId();
                const deviceKind = $2d7d9af7a5367cf4$var$sourceToKind(pub.source);
                if (deviceKind && deviceId && deviceId !== this.localParticipant.activeDeviceMap.get(deviceKind)) {
                    this.localParticipant.activeDeviceMap.set(deviceKind, deviceId);
                    this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.ActiveDeviceChanged, deviceKind, deviceId);
                }
            });
        this.onLocalTrackUnpublished = (pub)=>{
            var _a, _b;
            (_a = pub.track) === null || _a === void 0 || _a.off($2d7d9af7a5367cf4$export$2c8510d737cc09da.TrackProcessorUpdate, this.onTrackProcessorUpdate);
            (_b = pub.track) === null || _b === void 0 || _b.off($2d7d9af7a5367cf4$export$2c8510d737cc09da.Restarted, this.onLocalTrackRestarted);
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.LocalTrackUnpublished, pub, this.localParticipant);
        };
        this.onLocalTrackRestarted = (track)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                const deviceId = yield track.getDeviceId(false);
                const deviceKind = $2d7d9af7a5367cf4$var$sourceToKind(track.source);
                if (deviceKind && deviceId && deviceId !== this.localParticipant.activeDeviceMap.get(deviceKind)) {
                    this.log.debug("local track restarted, setting ".concat(deviceKind, " ").concat(deviceId, " active"), this.logContext);
                    this.localParticipant.activeDeviceMap.set(deviceKind, deviceId);
                    this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.ActiveDeviceChanged, deviceKind, deviceId);
                }
            });
        this.onLocalConnectionQualityChanged = (quality)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.ConnectionQualityChanged, quality, this.localParticipant);
        };
        this.onMediaDevicesError = (e)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.MediaDevicesError, e);
        };
        this.onLocalParticipantPermissionsChanged = (prevPermissions)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.ParticipantPermissionsChanged, prevPermissions, this.localParticipant);
        };
        this.onLocalChatMessageSent = (msg)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.ChatMessage, msg, this.localParticipant);
        };
        this.setMaxListeners(100);
        this.remoteParticipants = new Map();
        this.sidToIdentity = new Map();
        this.options = Object.assign(Object.assign({}, $2d7d9af7a5367cf4$var$roomOptionDefaults), options);
        this.log = $2d7d9af7a5367cf4$export$2b1d391cd05230fd((_a = this.options.loggerName) !== null && _a !== void 0 ? _a : $2d7d9af7a5367cf4$export$69ba24dd79f4da21.Room);
        this.transcriptionReceivedTimes = new Map();
        this.options.audioCaptureDefaults = Object.assign(Object.assign({}, $2d7d9af7a5367cf4$var$audioDefaults), options === null || options === void 0 ? void 0 : options.audioCaptureDefaults);
        this.options.videoCaptureDefaults = Object.assign(Object.assign({}, $2d7d9af7a5367cf4$var$videoDefaults), options === null || options === void 0 ? void 0 : options.videoCaptureDefaults);
        this.options.publishDefaults = Object.assign(Object.assign({}, $2d7d9af7a5367cf4$var$publishDefaults), options === null || options === void 0 ? void 0 : options.publishDefaults);
        this.maybeCreateEngine();
        this.disconnectLock = new $2d7d9af7a5367cf4$export$ca12f2943758ef55();
        this.localParticipant = new $2d7d9af7a5367cf4$export$ed007fa30041dd89('', '', this.engine, this.options);
        if (this.options.videoCaptureDefaults.deviceId) this.localParticipant.activeDeviceMap.set('videoinput', $2d7d9af7a5367cf4$var$unwrapConstraint(this.options.videoCaptureDefaults.deviceId));
        if (this.options.audioCaptureDefaults.deviceId) this.localParticipant.activeDeviceMap.set('audioinput', $2d7d9af7a5367cf4$var$unwrapConstraint(this.options.audioCaptureDefaults.deviceId));
        if ((_b = this.options.audioOutput) === null || _b === void 0 ? void 0 : _b.deviceId) this.switchActiveDevice('audiooutput', $2d7d9af7a5367cf4$var$unwrapConstraint(this.options.audioOutput.deviceId)).catch((e)=>this.log.warn("Could not set audio output: ".concat(e.message), this.logContext));
        if (this.options.e2ee) this.setupE2EE();
    }
    /**
   * @experimental
   */ setE2EEEnabled(enabled) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (this.e2eeManager) {
                yield Promise.all([
                    this.localParticipant.setE2EEEnabled(enabled)
                ]);
                if (this.localParticipant.identity !== '') this.e2eeManager.setParticipantCryptorEnabled(enabled, this.localParticipant.identity);
            } else throw Error('e2ee not configured, please set e2ee settings within the room options');
        });
    }
    setupE2EE() {
        var _a;
        if (this.options.e2ee) {
            if ('e2eeManager' in this.options.e2ee) this.e2eeManager = this.options.e2ee.e2eeManager;
            else this.e2eeManager = new $2d7d9af7a5367cf4$var$E2EEManager(this.options.e2ee);
            this.e2eeManager.on($2d7d9af7a5367cf4$export$36ec54aef832f50f.ParticipantEncryptionStatusChanged, (enabled, participant)=>{
                if (participant instanceof $2d7d9af7a5367cf4$export$ed007fa30041dd89) this.isE2EEEnabled = enabled;
                this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.ParticipantEncryptionStatusChanged, enabled, participant);
            });
            this.e2eeManager.on($2d7d9af7a5367cf4$export$36ec54aef832f50f.EncryptionError, (error)=>this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.EncryptionError, error));
            (_a = this.e2eeManager) === null || _a === void 0 || _a.setup(this);
        }
    }
    get logContext() {
        var _a;
        return {
            room: this.name,
            roomID: (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.sid,
            participant: this.localParticipant.identity,
            pID: this.localParticipant.sid
        };
    }
    /**
   * if the current room has a participant with `recorder: true` in its JWT grant
   **/ get isRecording() {
        var _a, _b;
        return (_b = (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.activeRecording) !== null && _b !== void 0 ? _b : false;
    }
    /**
   * server assigned unique room id.
   * returns once a sid has been issued by the server.
   */ getSid() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (this.state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Disconnected) return '';
            if (this.roomInfo && this.roomInfo.sid !== '') return this.roomInfo.sid;
            return new Promise((resolve, reject)=>{
                const handleRoomUpdate = (roomInfo)=>{
                    if (roomInfo.sid !== '') {
                        this.engine.off($2d7d9af7a5367cf4$export$c09e63b8572f869.RoomUpdate, handleRoomUpdate);
                        resolve(roomInfo.sid);
                    }
                };
                this.engine.on($2d7d9af7a5367cf4$export$c09e63b8572f869.RoomUpdate, handleRoomUpdate);
                this.once($2d7d9af7a5367cf4$export$3159c672e3b2293a.Disconnected, ()=>{
                    this.engine.off($2d7d9af7a5367cf4$export$c09e63b8572f869.RoomUpdate, handleRoomUpdate);
                    reject('Room disconnected before room server id was available');
                });
            });
        });
    }
    /** user assigned name, derived from JWT token */ get name() {
        var _a, _b;
        return (_b = (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
    }
    /** room metadata */ get metadata() {
        var _a;
        return (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.metadata;
    }
    get numParticipants() {
        var _a, _b;
        return (_b = (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.numParticipants) !== null && _b !== void 0 ? _b : 0;
    }
    get numPublishers() {
        var _a, _b;
        return (_b = (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.numPublishers) !== null && _b !== void 0 ? _b : 0;
    }
    maybeCreateEngine() {
        if (this.engine && !this.engine.isClosed) return;
        this.engine = new $2d7d9af7a5367cf4$var$RTCEngine(this.options);
        this.engine.on($2d7d9af7a5367cf4$export$c09e63b8572f869.ParticipantUpdate, this.handleParticipantUpdates).on($2d7d9af7a5367cf4$export$c09e63b8572f869.RoomUpdate, this.handleRoomUpdate).on($2d7d9af7a5367cf4$export$c09e63b8572f869.SpeakersChanged, this.handleSpeakersChanged).on($2d7d9af7a5367cf4$export$c09e63b8572f869.StreamStateChanged, this.handleStreamStateUpdate).on($2d7d9af7a5367cf4$export$c09e63b8572f869.ConnectionQualityUpdate, this.handleConnectionQualityUpdate).on($2d7d9af7a5367cf4$export$c09e63b8572f869.SubscriptionError, this.handleSubscriptionError).on($2d7d9af7a5367cf4$export$c09e63b8572f869.SubscriptionPermissionUpdate, this.handleSubscriptionPermissionUpdate).on($2d7d9af7a5367cf4$export$c09e63b8572f869.MediaTrackAdded, (mediaTrack, stream, receiver)=>{
            this.onTrackAdded(mediaTrack, stream, receiver);
        }).on($2d7d9af7a5367cf4$export$c09e63b8572f869.Disconnected, (reason)=>{
            this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, reason);
        }).on($2d7d9af7a5367cf4$export$c09e63b8572f869.ActiveSpeakersUpdate, this.handleActiveSpeakersUpdate).on($2d7d9af7a5367cf4$export$c09e63b8572f869.DataPacketReceived, this.handleDataPacket).on($2d7d9af7a5367cf4$export$c09e63b8572f869.Resuming, ()=>{
            this.clearConnectionReconcile();
            this.isResuming = true;
            this.log.info('Resuming signal connection', this.logContext);
            if (this.setAndEmitConnectionState($2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.SignalReconnecting)) this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.SignalReconnecting);
        }).on($2d7d9af7a5367cf4$export$c09e63b8572f869.Resumed, ()=>{
            this.registerConnectionReconcile();
            this.isResuming = false;
            this.log.info('Resumed signal connection', this.logContext);
            this.updateSubscriptions();
            this.emitBufferedEvents();
            if (this.setAndEmitConnectionState($2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Connected)) this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.Reconnected);
        }).on($2d7d9af7a5367cf4$export$c09e63b8572f869.SignalResumed, ()=>{
            this.bufferedEvents = [];
            if (this.state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Reconnecting || this.isResuming) this.sendSyncState();
        }).on($2d7d9af7a5367cf4$export$c09e63b8572f869.Restarting, this.handleRestarting).on($2d7d9af7a5367cf4$export$c09e63b8572f869.SignalRestarted, this.handleSignalRestarted).on($2d7d9af7a5367cf4$export$c09e63b8572f869.Offline, ()=>{
            if (this.setAndEmitConnectionState($2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Reconnecting)) this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.Reconnecting);
        }).on($2d7d9af7a5367cf4$export$c09e63b8572f869.DCBufferStatusChanged, (status, kind)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.DCBufferStatusChanged, status, kind);
        }).on($2d7d9af7a5367cf4$export$c09e63b8572f869.LocalTrackSubscribed, (subscribedSid)=>{
            const trackPublication = this.localParticipant.getTrackPublications().find((_ref2)=>{
                let { trackSid: trackSid } = _ref2;
                return trackSid === subscribedSid;
            });
            if (!trackPublication) {
                this.log.warn('could not find local track subscription for subscribed event', this.logContext);
                return;
            }
            this.localParticipant.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.LocalTrackSubscribed, trackPublication);
            this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.LocalTrackSubscribed, trackPublication, this.localParticipant);
        });
        if (this.localParticipant) this.localParticipant.setupEngine(this.engine);
        if (this.e2eeManager) this.e2eeManager.setupEngine(this.engine);
    }
    /**
   * getLocalDevices abstracts navigator.mediaDevices.enumerateDevices.
   * In particular, it requests device permissions by default if needed
   * and makes sure the returned device does not consist of dummy devices
   * @param kind
   * @returns a list of available local devices
   */ static getLocalDevices(kind) {
        let requestPermissions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return $2d7d9af7a5367cf4$var$DeviceManager.getInstance().getDevices(kind, requestPermissions);
    }
    /**
   * prepareConnection should be called as soon as the page is loaded, in order
   * to speed up the connection attempt. This function will
   * - perform DNS resolution and pre-warm the DNS cache
   * - establish TLS connection and cache TLS keys
   *
   * With LiveKit Cloud, it will also determine the best edge data center for
   * the current client to connect to if a token is provided.
   */ prepareConnection(url, token) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (this.state !== $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Disconnected) return;
            this.log.debug("prepareConnection to ".concat(url), this.logContext);
            try {
                if ($2d7d9af7a5367cf4$var$isCloud(new URL(url)) && token) {
                    this.regionUrlProvider = new $2d7d9af7a5367cf4$var$RegionUrlProvider(url, token);
                    const regionUrl = yield this.regionUrlProvider.getNextBestRegionUrl();
                    // we will not replace the regionUrl if an attempt had already started
                    // to avoid overriding regionUrl after a new connection attempt had started
                    if (regionUrl && this.state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Disconnected) {
                        this.regionUrl = regionUrl;
                        yield fetch($2d7d9af7a5367cf4$var$toHttpUrl(regionUrl), {
                            method: 'HEAD'
                        });
                        this.log.debug("prepared connection to ".concat(regionUrl), this.logContext);
                    }
                } else yield fetch($2d7d9af7a5367cf4$var$toHttpUrl(url), {
                    method: 'HEAD'
                });
            } catch (e) {
                this.log.warn('could not prepare connection', Object.assign(Object.assign({}, this.logContext), {
                    error: e
                }));
            }
        });
    }
    /**
   * retrieves a participant by identity
   * @param identity
   * @returns
   */ getParticipantByIdentity(identity) {
        if (this.localParticipant.identity === identity) return this.localParticipant;
        return this.remoteParticipants.get(identity);
    }
    clearConnectionFutures() {
        this.connectFuture = undefined;
    }
    /**
   * @internal for testing
   */ simulateScenario(scenario, arg) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            let postAction = ()=>{};
            let req;
            switch(scenario){
                case 'signal-reconnect':
                    // @ts-expect-error function is private
                    yield this.engine.client.handleOnClose('simulate disconnect');
                    break;
                case 'speaker':
                    req = new $2d7d9af7a5367cf4$var$SimulateScenario({
                        scenario: {
                            case: 'speakerUpdate',
                            value: 3
                        }
                    });
                    break;
                case 'node-failure':
                    req = new $2d7d9af7a5367cf4$var$SimulateScenario({
                        scenario: {
                            case: 'nodeFailure',
                            value: true
                        }
                    });
                    break;
                case 'server-leave':
                    req = new $2d7d9af7a5367cf4$var$SimulateScenario({
                        scenario: {
                            case: 'serverLeave',
                            value: true
                        }
                    });
                    break;
                case 'migration':
                    req = new $2d7d9af7a5367cf4$var$SimulateScenario({
                        scenario: {
                            case: 'migration',
                            value: true
                        }
                    });
                    break;
                case 'resume-reconnect':
                    this.engine.failNext();
                    // @ts-expect-error function is private
                    yield this.engine.client.handleOnClose('simulate resume-disconnect');
                    break;
                case 'disconnect-signal-on-resume':
                    postAction = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                            // @ts-expect-error function is private
                            yield this.engine.client.handleOnClose('simulate resume-disconnect');
                        });
                    req = new $2d7d9af7a5367cf4$var$SimulateScenario({
                        scenario: {
                            case: 'disconnectSignalOnResume',
                            value: true
                        }
                    });
                    break;
                case 'disconnect-signal-on-resume-no-messages':
                    postAction = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                            // @ts-expect-error function is private
                            yield this.engine.client.handleOnClose('simulate resume-disconnect');
                        });
                    req = new $2d7d9af7a5367cf4$var$SimulateScenario({
                        scenario: {
                            case: 'disconnectSignalOnResumeNoMessages',
                            value: true
                        }
                    });
                    break;
                case 'full-reconnect':
                    this.engine.fullReconnectOnNext = true;
                    // @ts-expect-error function is private
                    yield this.engine.client.handleOnClose('simulate full-reconnect');
                    break;
                case 'force-tcp':
                case 'force-tls':
                    req = new $2d7d9af7a5367cf4$var$SimulateScenario({
                        scenario: {
                            case: 'switchCandidateProtocol',
                            value: scenario === 'force-tls' ? 2 : 1
                        }
                    });
                    postAction = ()=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                            const onLeave = this.engine.client.onLeave;
                            if (onLeave) onLeave(new $2d7d9af7a5367cf4$var$LeaveRequest({
                                reason: $2d7d9af7a5367cf4$export$258d16488300d83f.CLIENT_INITIATED,
                                action: $2d7d9af7a5367cf4$var$LeaveRequest_Action.RECONNECT
                            }));
                        });
                    break;
                case 'subscriber-bandwidth':
                    if (arg === undefined || typeof arg !== 'number') throw new Error('subscriber-bandwidth requires a number as argument');
                    req = new $2d7d9af7a5367cf4$var$SimulateScenario({
                        scenario: {
                            case: 'subscriberBandwidth',
                            value: BigInt(arg)
                        }
                    });
                    break;
                case 'leave-full-reconnect':
                    req = new $2d7d9af7a5367cf4$var$SimulateScenario({
                        scenario: {
                            case: 'leaveRequestFullReconnect',
                            value: true
                        }
                    });
            }
            if (req) {
                yield this.engine.client.sendSimulateScenario(req);
                yield postAction();
            }
        });
    }
    /**
   * Returns true if audio playback is enabled
   */ get canPlaybackAudio() {
        return this.audioEnabled;
    }
    /**
   * Returns true if video playback is enabled
   */ get canPlaybackVideo() {
        return !this.isVideoPlaybackBlocked;
    }
    getActiveDevice(kind) {
        return this.localParticipant.activeDeviceMap.get(kind);
    }
    /**
   * Switches all active devices used in this room to the given device.
   *
   * Note: setting AudioOutput is not supported on some browsers. See [setSinkId](https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/setSinkId#browser_compatibility)
   *
   * @param kind use `videoinput` for camera track,
   *  `audioinput` for microphone track,
   *  `audiooutput` to set speaker for all incoming audio tracks
   * @param deviceId
   */ switchActiveDevice(kind_1, deviceId_1) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, arguments, void 0, function(kind, deviceId) {
            var _this3 = this;
            let exact = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            return function*() {
                var _a, _b, _c, _d, _e, _f;
                var _g;
                let deviceHasChanged = false;
                let success = true;
                const deviceConstraint = exact ? {
                    exact: deviceId
                } : deviceId;
                if (kind === 'audioinput') {
                    const prevDeviceId = (_a = _this3.getActiveDevice(kind)) !== null && _a !== void 0 ? _a : _this3.options.audioCaptureDefaults.deviceId;
                    _this3.options.audioCaptureDefaults.deviceId = deviceConstraint;
                    deviceHasChanged = prevDeviceId !== deviceConstraint;
                    const tracks = Array.from(_this3.localParticipant.audioTrackPublications.values()).filter((track)=>track.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Microphone);
                    try {
                        success = (yield Promise.all(tracks.map((t)=>{
                            var _a;
                            return (_a = t.audioTrack) === null || _a === void 0 ? void 0 : _a.setDeviceId(deviceConstraint);
                        }))).every((val)=>val === true);
                    } catch (e) {
                        _this3.options.audioCaptureDefaults.deviceId = prevDeviceId;
                        throw e;
                    }
                } else if (kind === 'videoinput') {
                    const prevDeviceId = (_b = _this3.getActiveDevice(kind)) !== null && _b !== void 0 ? _b : _this3.options.videoCaptureDefaults.deviceId;
                    _this3.options.videoCaptureDefaults.deviceId = deviceConstraint;
                    deviceHasChanged = prevDeviceId !== deviceConstraint;
                    const tracks = Array.from(_this3.localParticipant.videoTrackPublications.values()).filter((track)=>track.source === $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Camera);
                    try {
                        success = (yield Promise.all(tracks.map((t)=>{
                            var _a;
                            return (_a = t.videoTrack) === null || _a === void 0 ? void 0 : _a.setDeviceId(deviceConstraint);
                        }))).every((val)=>val === true);
                    } catch (e) {
                        _this3.options.videoCaptureDefaults.deviceId = prevDeviceId;
                        throw e;
                    }
                } else if (kind === 'audiooutput') {
                    if (!$2d7d9af7a5367cf4$var$supportsSetSinkId() && !_this3.options.webAudioMix || _this3.options.webAudioMix && _this3.audioContext && !('setSinkId' in _this3.audioContext)) throw new Error('cannot switch audio output, setSinkId not supported');
                    if (_this3.options.webAudioMix) // setting `default` for web audio output doesn't work, so we need to normalize the id before
                    deviceId = (_c = yield $2d7d9af7a5367cf4$var$DeviceManager.getInstance().normalizeDeviceId('audiooutput', deviceId)) !== null && _c !== void 0 ? _c : '';
                    (_d = (_g = _this3.options).audioOutput) !== null && _d !== void 0 ? _d : _g.audioOutput = {};
                    const prevDeviceId = (_e = _this3.getActiveDevice(kind)) !== null && _e !== void 0 ? _e : _this3.options.audioOutput.deviceId;
                    _this3.options.audioOutput.deviceId = deviceId;
                    deviceHasChanged = prevDeviceId !== deviceConstraint;
                    try {
                        if (_this3.options.webAudioMix) // @ts-expect-error setSinkId is not yet in the typescript type of AudioContext
                        (_f = _this3.audioContext) === null || _f === void 0 || _f.setSinkId(deviceId);
                        // also set audio output on all audio elements, even if webAudioMix is enabled in order to workaround echo cancellation not working on chrome with non-default output devices
                        // see https://issues.chromium.org/issues/40252911#comment7
                        yield Promise.all(Array.from(_this3.remoteParticipants.values()).map((p)=>p.setAudioOutput({
                                deviceId: deviceId
                            })));
                    } catch (e) {
                        _this3.options.audioOutput.deviceId = prevDeviceId;
                        throw e;
                    }
                }
                if (deviceHasChanged && success) {
                    _this3.localParticipant.activeDeviceMap.set(kind, deviceId);
                    _this3.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.ActiveDeviceChanged, kind, deviceId);
                }
                return success;
            }();
        });
    }
    setupLocalParticipantEvents() {
        this.localParticipant.on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ParticipantMetadataChanged, this.onLocalParticipantMetadataChanged).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ParticipantNameChanged, this.onLocalParticipantNameChanged).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.AttributesChanged, this.onLocalAttributesChanged).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackMuted, this.onLocalTrackMuted).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackUnmuted, this.onLocalTrackUnmuted).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.LocalTrackPublished, this.onLocalTrackPublished).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.LocalTrackUnpublished, this.onLocalTrackUnpublished).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ConnectionQualityChanged, this.onLocalConnectionQualityChanged).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.MediaDevicesError, this.onMediaDevicesError).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.AudioStreamAcquired, this.startAudio).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ChatMessage, this.onLocalChatMessageSent).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ParticipantPermissionsChanged, this.onLocalParticipantPermissionsChanged);
    }
    recreateEngine() {
        var _a;
        (_a = this.engine) === null || _a === void 0 || _a.close();
        /* @ts-ignore */ this.engine = undefined;
        this.isResuming = false;
        // clear out existing remote participants, since they may have attached
        // the old engine
        this.remoteParticipants.clear();
        this.sidToIdentity.clear();
        this.bufferedEvents = [];
        this.maybeCreateEngine();
    }
    onTrackAdded(mediaTrack, stream, receiver) {
        // don't fire onSubscribed when connecting
        // WebRTC fires onTrack as soon as setRemoteDescription is called on the offer
        // at that time, ICE connectivity has not been established so the track is not
        // technically subscribed.
        // We'll defer these events until when the room is connected or eventually disconnected.
        if (this.state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Connecting || this.state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Reconnecting) {
            const reconnectedHandler = ()=>{
                this.onTrackAdded(mediaTrack, stream, receiver);
                cleanup();
            };
            const cleanup = ()=>{
                this.off($2d7d9af7a5367cf4$export$3159c672e3b2293a.Reconnected, reconnectedHandler);
                this.off($2d7d9af7a5367cf4$export$3159c672e3b2293a.Connected, reconnectedHandler);
                this.off($2d7d9af7a5367cf4$export$3159c672e3b2293a.Disconnected, cleanup);
            };
            this.once($2d7d9af7a5367cf4$export$3159c672e3b2293a.Reconnected, reconnectedHandler);
            this.once($2d7d9af7a5367cf4$export$3159c672e3b2293a.Connected, reconnectedHandler);
            this.once($2d7d9af7a5367cf4$export$3159c672e3b2293a.Disconnected, cleanup);
            return;
        }
        if (this.state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Disconnected) {
            this.log.warn('skipping incoming track after Room disconnected', this.logContext);
            return;
        }
        const parts = $2d7d9af7a5367cf4$var$unpackStreamId(stream.id);
        const participantSid = parts[0];
        let streamId = parts[1];
        let trackId = mediaTrack.id;
        // firefox will get streamId (pID|trackId) instead of (pID|streamId) as it doesn't support sync tracks by stream
        // and generates its own track id instead of infer from sdp track id.
        if (streamId && streamId.startsWith('TR')) trackId = streamId;
        if (participantSid === this.localParticipant.sid) {
            this.log.warn('tried to create RemoteParticipant for local participant', this.logContext);
            return;
        }
        const participant = Array.from(this.remoteParticipants.values()).find((p)=>p.sid === participantSid);
        if (!participant) {
            this.log.error("Tried to add a track for a participant, that's not present. Sid: ".concat(participantSid), this.logContext);
            return;
        }
        let adaptiveStreamSettings;
        if (this.options.adaptiveStream) {
            if (typeof this.options.adaptiveStream === 'object') adaptiveStreamSettings = this.options.adaptiveStream;
            else adaptiveStreamSettings = {};
        }
        participant.addSubscribedMediaTrack(mediaTrack, trackId, stream, receiver, adaptiveStreamSettings);
    }
    handleDisconnect() {
        let shouldStopTracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        let reason = arguments.length > 1 ? arguments[1] : undefined;
        var _a;
        this.clearConnectionReconcile();
        this.isResuming = false;
        this.bufferedEvents = [];
        this.transcriptionReceivedTimes.clear();
        if (this.state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Disconnected) return;
        this.regionUrl = undefined;
        try {
            this.remoteParticipants.forEach((p)=>{
                p.trackPublications.forEach((pub)=>{
                    p.unpublishTrack(pub.trackSid);
                });
            });
            this.localParticipant.trackPublications.forEach((pub)=>{
                var _a, _b, _c;
                if (pub.track) this.localParticipant.unpublishTrack(pub.track, shouldStopTracks);
                if (shouldStopTracks) {
                    (_a = pub.track) === null || _a === void 0 || _a.detach();
                    (_b = pub.track) === null || _b === void 0 || _b.stop();
                } else (_c = pub.track) === null || _c === void 0 || _c.stopMonitor();
            });
            this.localParticipant.off($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ParticipantMetadataChanged, this.onLocalParticipantMetadataChanged).off($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ParticipantNameChanged, this.onLocalParticipantNameChanged).off($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.AttributesChanged, this.onLocalAttributesChanged).off($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackMuted, this.onLocalTrackMuted).off($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackUnmuted, this.onLocalTrackUnmuted).off($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.LocalTrackPublished, this.onLocalTrackPublished).off($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.LocalTrackUnpublished, this.onLocalTrackUnpublished).off($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ConnectionQualityChanged, this.onLocalConnectionQualityChanged).off($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.MediaDevicesError, this.onMediaDevicesError).off($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.AudioStreamAcquired, this.startAudio).off($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ChatMessage, this.onLocalChatMessageSent).off($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ParticipantPermissionsChanged, this.onLocalParticipantPermissionsChanged);
            this.localParticipant.trackPublications.clear();
            this.localParticipant.videoTrackPublications.clear();
            this.localParticipant.audioTrackPublications.clear();
            this.remoteParticipants.clear();
            this.sidToIdentity.clear();
            this.activeSpeakers = [];
            if (this.audioContext && typeof this.options.webAudioMix === 'boolean') {
                this.audioContext.close();
                this.audioContext = undefined;
            }
            if ($2d7d9af7a5367cf4$var$isWeb()) {
                window.removeEventListener('beforeunload', this.onPageLeave);
                window.removeEventListener('pagehide', this.onPageLeave);
                window.removeEventListener('freeze', this.onPageLeave);
                (_a = navigator.mediaDevices) === null || _a === void 0 || _a.removeEventListener('devicechange', this.handleDeviceChange);
            }
        } finally{
            this.setAndEmitConnectionState($2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Disconnected);
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.Disconnected, reason);
        }
    }
    handleParticipantDisconnected(identity, participant) {
        var _a;
        // remove and send event
        this.remoteParticipants.delete(identity);
        if (!participant) return;
        participant.trackPublications.forEach((publication)=>{
            participant.unpublishTrack(publication.trackSid, true);
        });
        this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.ParticipantDisconnected, participant);
        (_a = this.localParticipant) === null || _a === void 0 || _a.handleParticipantDisconnected(participant.identity);
    }
    acquireAudioContext() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (typeof this.options.webAudioMix !== 'boolean' && this.options.webAudioMix.audioContext) // override audio context with custom audio context if supplied by user
            this.audioContext = this.options.webAudioMix.audioContext;
            else if (!this.audioContext || this.audioContext.state === 'closed') // by using an AudioContext, it reduces lag on audio elements
            // https://stackoverflow.com/questions/9811429/html5-audio-tag-on-safari-has-a-delay/54119854#54119854
            this.audioContext = (_a = $2d7d9af7a5367cf4$var$getNewAudioContext()) !== null && _a !== void 0 ? _a : undefined;
            if (this.audioContext && this.audioContext.state === 'suspended') // for iOS a newly created AudioContext is always in `suspended` state.
            // we try our best to resume the context here, if that doesn't work, we just continue with regular processing
            try {
                yield this.audioContext.resume();
            } catch (e) {
                this.log.warn('Could not resume audio context', Object.assign(Object.assign({}, this.logContext), {
                    error: e
                }));
            }
            if (this.options.webAudioMix) this.remoteParticipants.forEach((participant)=>participant.setAudioContext(this.audioContext));
            this.localParticipant.setAudioContext(this.audioContext);
            const newContextIsRunning = ((_b = this.audioContext) === null || _b === void 0 ? void 0 : _b.state) === 'running';
            if (newContextIsRunning !== this.canPlaybackAudio) {
                this.audioEnabled = newContextIsRunning;
                this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.AudioPlaybackStatusChanged, newContextIsRunning);
            }
        });
    }
    createParticipant(identity, info) {
        var _a;
        let participant;
        if (info) participant = $2d7d9af7a5367cf4$export$bf85b9e4f33346fe.fromParticipantInfo(this.engine.client, info, {
            loggerContextCb: ()=>this.logContext,
            loggerName: this.options.loggerName
        });
        else participant = new $2d7d9af7a5367cf4$export$bf85b9e4f33346fe(this.engine.client, '', identity, undefined, undefined, undefined, {
            loggerContextCb: ()=>this.logContext,
            loggerName: this.options.loggerName
        });
        if (this.options.webAudioMix) participant.setAudioContext(this.audioContext);
        if ((_a = this.options.audioOutput) === null || _a === void 0 ? void 0 : _a.deviceId) participant.setAudioOutput(this.options.audioOutput).catch((e)=>this.log.warn("Could not set audio output: ".concat(e.message), this.logContext));
        return participant;
    }
    getOrCreateParticipant(identity, info) {
        if (this.remoteParticipants.has(identity)) {
            const existingParticipant = this.remoteParticipants.get(identity);
            if (info) {
                const wasUpdated = existingParticipant.updateInfo(info);
                if (wasUpdated) this.sidToIdentity.set(info.sid, info.identity);
            }
            return existingParticipant;
        }
        const participant = this.createParticipant(identity, info);
        this.remoteParticipants.set(identity, participant);
        this.sidToIdentity.set(info.sid, info.identity);
        // if we have valid info and the participant wasn't in the map before, we can assume the participant is new
        // firing here to make sure that `ParticipantConnected` fires before the initial track events
        this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.ParticipantConnected, participant);
        // also forward events
        // trackPublished is only fired for tracks added after both local participant
        // and remote participant joined the room
        participant.on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackPublished, (trackPublication)=>{
            this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackPublished, trackPublication, participant);
        }).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackSubscribed, (track, publication)=>{
            // monitor playback status
            if (track.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Audio) {
                track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.AudioPlaybackStarted, this.handleAudioPlaybackStarted);
                track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.AudioPlaybackFailed, this.handleAudioPlaybackFailed);
            } else if (track.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video) {
                track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.VideoPlaybackFailed, this.handleVideoPlaybackFailed);
                track.on($2d7d9af7a5367cf4$export$2c8510d737cc09da.VideoPlaybackStarted, this.handleVideoPlaybackStarted);
            }
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackSubscribed, track, publication, participant);
        }).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackUnpublished, (publication)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackUnpublished, publication, participant);
        }).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackUnsubscribed, (track, publication)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackUnsubscribed, track, publication, participant);
        }).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackSubscriptionFailed, (sid)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackSubscriptionFailed, sid, participant);
        }).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackMuted, (pub)=>{
            this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackMuted, pub, participant);
        }).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackUnmuted, (pub)=>{
            this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackUnmuted, pub, participant);
        }).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ParticipantMetadataChanged, (metadata)=>{
            this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.ParticipantMetadataChanged, metadata, participant);
        }).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ParticipantNameChanged, (name)=>{
            this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.ParticipantNameChanged, name, participant);
        }).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.AttributesChanged, (changedAttributes)=>{
            this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.ParticipantAttributesChanged, changedAttributes, participant);
        }).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ConnectionQualityChanged, (quality)=>{
            this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.ConnectionQualityChanged, quality, participant);
        }).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.ParticipantPermissionsChanged, (prevPermissions)=>{
            this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.ParticipantPermissionsChanged, prevPermissions, participant);
        }).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackSubscriptionStatusChanged, (pub, status)=>{
            this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackSubscriptionStatusChanged, pub, status, participant);
        }).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackSubscriptionFailed, (trackSid, error)=>{
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackSubscriptionFailed, trackSid, participant, error);
        }).on($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.TrackSubscriptionPermissionChanged, (pub, status)=>{
            this.emitWhenConnected($2d7d9af7a5367cf4$export$3159c672e3b2293a.TrackSubscriptionPermissionChanged, pub, status, participant);
        });
        // update info at the end after callbacks have been set up
        if (info) participant.updateInfo(info);
        return participant;
    }
    sendSyncState() {
        const remoteTracks = Array.from(this.remoteParticipants.values()).reduce((acc, participant)=>{
            acc.push(...participant.getTrackPublications()); // FIXME would be nice to have this return RemoteTrackPublications directly instead of the type cast
            return acc;
        }, []);
        const localTracks = this.localParticipant.getTrackPublications(); // FIXME would be nice to have this return LocalTrackPublications directly instead of the type cast
        this.engine.sendSyncState(remoteTracks, localTracks);
    }
    /**
   * After resuming, we'll need to notify the server of the current
   * subscription settings.
   */ updateSubscriptions() {
        for (const p of this.remoteParticipants.values()){
            for (const pub of p.videoTrackPublications.values())if (pub.isSubscribed && pub instanceof $2d7d9af7a5367cf4$export$c89ab28402142c29) pub.emitTrackUpdate();
        }
    }
    getRemoteParticipantBySid(sid) {
        const identity = this.sidToIdentity.get(sid);
        if (identity) return this.remoteParticipants.get(identity);
    }
    registerConnectionReconcile() {
        this.clearConnectionReconcile();
        let consecutiveFailures = 0;
        this.connectionReconcileInterval = $2d7d9af7a5367cf4$export$22e737276454df96.setInterval(()=>{
            if (// ensure we didn't tear it down
            !this.engine || // engine detected close, but Room missed it
            this.engine.isClosed || // transports failed without notifying engine
            !this.engine.verifyTransport()) {
                consecutiveFailures++;
                this.log.warn('detected connection state mismatch', Object.assign(Object.assign({}, this.logContext), {
                    numFailures: consecutiveFailures,
                    engine: this.engine ? {
                        closed: this.engine.isClosed,
                        transportsConnected: this.engine.verifyTransport()
                    } : undefined
                }));
                if (consecutiveFailures >= 3) {
                    this.recreateEngine();
                    this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, $2d7d9af7a5367cf4$export$258d16488300d83f.STATE_MISMATCH);
                }
            } else consecutiveFailures = 0;
        }, $2d7d9af7a5367cf4$var$connectionReconcileFrequency);
    }
    clearConnectionReconcile() {
        if (this.connectionReconcileInterval) $2d7d9af7a5367cf4$export$22e737276454df96.clearInterval(this.connectionReconcileInterval);
    }
    setAndEmitConnectionState(state) {
        if (state === this.state) // unchanged
        return false;
        this.state = state;
        this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.ConnectionStateChanged, this.state);
        return true;
    }
    emitBufferedEvents() {
        this.bufferedEvents.forEach((_ref3)=>{
            let [ev, args] = _ref3;
            this.emit(ev, ...args);
        });
        this.bufferedEvents = [];
    }
    emitWhenConnected(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        if (this.state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Reconnecting || this.isResuming || !this.engine || this.engine.pendingReconnect) // in case the room is reconnecting, buffer the events by firing them later after emitting RoomEvent.Reconnected
        this.bufferedEvents.push([
            event,
            args
        ]);
        else if (this.state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Connected) return this.emit(event, ...args);
        return false;
    }
    /**
   * Allows to populate a room with simulated participants.
   * No actual connection to a server will be established, all state is
   * @experimental
   */ simulateParticipants(options) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const publishOptions = Object.assign({
                audio: true,
                video: true,
                useRealTracks: false
            }, options.publish);
            const participantOptions = Object.assign({
                count: 9,
                audio: false,
                video: true,
                aspectRatios: [
                    1.66,
                    1.7,
                    1.3
                ]
            }, options.participants);
            this.handleDisconnect();
            this.roomInfo = new $2d7d9af7a5367cf4$var$Room$1({
                sid: 'RM_SIMULATED',
                name: 'simulated-room',
                emptyTimeout: 0,
                maxParticipants: 0,
                creationTime: $2d7d9af7a5367cf4$var$protoInt64.parse(new Date().getTime()),
                metadata: '',
                numParticipants: 1,
                numPublishers: 1,
                turnPassword: '',
                enabledCodecs: [],
                activeRecording: false
            });
            this.localParticipant.updateInfo(new $2d7d9af7a5367cf4$var$ParticipantInfo({
                identity: 'simulated-local',
                name: 'local-name'
            }));
            this.setupLocalParticipantEvents();
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.SignalConnected);
            this.emit($2d7d9af7a5367cf4$export$3159c672e3b2293a.Connected);
            this.setAndEmitConnectionState($2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Connected);
            if (publishOptions.video) {
                const camPub = new $2d7d9af7a5367cf4$export$885a52c769210b3f($2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video, new $2d7d9af7a5367cf4$var$TrackInfo({
                    source: $2d7d9af7a5367cf4$var$TrackSource.CAMERA,
                    sid: Math.floor(Math.random() * 10000).toString(),
                    type: $2d7d9af7a5367cf4$var$TrackType.AUDIO,
                    name: 'video-dummy'
                }), new $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc(publishOptions.useRealTracks ? (yield window.navigator.mediaDevices.getUserMedia({
                    video: true
                })).getVideoTracks()[0] : $2d7d9af7a5367cf4$var$createDummyVideoStreamTrack(160 * ((_a = participantOptions.aspectRatios[0]) !== null && _a !== void 0 ? _a : 1), 160, true, true), undefined, false, {
                    loggerName: this.options.loggerName,
                    loggerContextCb: ()=>this.logContext
                }), {
                    loggerName: this.options.loggerName,
                    loggerContextCb: ()=>this.logContext
                });
                // @ts-ignore
                this.localParticipant.addTrackPublication(camPub);
                this.localParticipant.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.LocalTrackPublished, camPub);
            }
            if (publishOptions.audio) {
                const audioPub = new $2d7d9af7a5367cf4$export$885a52c769210b3f($2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Audio, new $2d7d9af7a5367cf4$var$TrackInfo({
                    source: $2d7d9af7a5367cf4$var$TrackSource.MICROPHONE,
                    sid: Math.floor(Math.random() * 10000).toString(),
                    type: $2d7d9af7a5367cf4$var$TrackType.AUDIO
                }), new $2d7d9af7a5367cf4$export$b287427b771ca237(publishOptions.useRealTracks ? (yield navigator.mediaDevices.getUserMedia({
                    audio: true
                })).getAudioTracks()[0] : $2d7d9af7a5367cf4$export$59e276d6841f735c(), undefined, false, this.audioContext, {
                    loggerName: this.options.loggerName,
                    loggerContextCb: ()=>this.logContext
                }), {
                    loggerName: this.options.loggerName,
                    loggerContextCb: ()=>this.logContext
                });
                // @ts-ignore
                this.localParticipant.addTrackPublication(audioPub);
                this.localParticipant.emit($2d7d9af7a5367cf4$export$fcdfe2b7a6750691.LocalTrackPublished, audioPub);
            }
            for(let i = 0; i < participantOptions.count - 1; i += 1){
                let info = new $2d7d9af7a5367cf4$var$ParticipantInfo({
                    sid: Math.floor(Math.random() * 10000).toString(),
                    identity: "simulated-".concat(i),
                    state: $2d7d9af7a5367cf4$var$ParticipantInfo_State.ACTIVE,
                    tracks: [],
                    joinedAt: $2d7d9af7a5367cf4$var$protoInt64.parse(Date.now())
                });
                const p = this.getOrCreateParticipant(info.identity, info);
                if (participantOptions.video) {
                    const dummyVideo = $2d7d9af7a5367cf4$var$createDummyVideoStreamTrack(160 * ((_b = participantOptions.aspectRatios[i % participantOptions.aspectRatios.length]) !== null && _b !== void 0 ? _b : 1), 160, false, true);
                    const videoTrack = new $2d7d9af7a5367cf4$var$TrackInfo({
                        source: $2d7d9af7a5367cf4$var$TrackSource.CAMERA,
                        sid: Math.floor(Math.random() * 10000).toString(),
                        type: $2d7d9af7a5367cf4$var$TrackType.AUDIO
                    });
                    p.addSubscribedMediaTrack(dummyVideo, videoTrack.sid, new MediaStream([
                        dummyVideo
                    ]), new RTCRtpReceiver());
                    info.tracks = [
                        ...info.tracks,
                        videoTrack
                    ];
                }
                if (participantOptions.audio) {
                    const dummyTrack = $2d7d9af7a5367cf4$export$59e276d6841f735c();
                    const audioTrack = new $2d7d9af7a5367cf4$var$TrackInfo({
                        source: $2d7d9af7a5367cf4$var$TrackSource.MICROPHONE,
                        sid: Math.floor(Math.random() * 10000).toString(),
                        type: $2d7d9af7a5367cf4$var$TrackType.AUDIO
                    });
                    p.addSubscribedMediaTrack(dummyTrack, audioTrack.sid, new MediaStream([
                        dummyTrack
                    ]), new RTCRtpReceiver());
                    info.tracks = [
                        ...info.tracks,
                        audioTrack
                    ];
                }
                p.updateInfo(info);
            }
        });
    }
    // /** @internal */
    emit(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        // active speaker updates are too spammy
        if (event !== $2d7d9af7a5367cf4$export$3159c672e3b2293a.ActiveSpeakersChanged) {
            // only extract logContext from arguments in order to avoid logging the whole object tree
            const minimizedArgs = $2d7d9af7a5367cf4$var$mapArgs(args).filter((arg)=>arg !== undefined);
            this.log.debug("room event ".concat(event), Object.assign(Object.assign({}, this.logContext), {
                event: event,
                args: minimizedArgs
            }));
        }
        return super.emit(event, ...args);
    }
}
function $2d7d9af7a5367cf4$var$mapArgs(args) {
    return args.map((arg)=>{
        if (!arg) return;
        if (Array.isArray(arg)) return $2d7d9af7a5367cf4$var$mapArgs(arg);
        if (typeof arg === 'object') return 'logContext' in arg && arg.logContext;
        return arg;
    });
}
var $2d7d9af7a5367cf4$export$180e7b9f22912c82;
(function(CheckStatus) {
    CheckStatus[CheckStatus["IDLE"] = 0] = "IDLE";
    CheckStatus[CheckStatus["RUNNING"] = 1] = "RUNNING";
    CheckStatus[CheckStatus["SKIPPED"] = 2] = "SKIPPED";
    CheckStatus[CheckStatus["SUCCESS"] = 3] = "SUCCESS";
    CheckStatus[CheckStatus["FAILED"] = 4] = "FAILED";
})($2d7d9af7a5367cf4$export$180e7b9f22912c82 || ($2d7d9af7a5367cf4$export$180e7b9f22912c82 = {}));
class $2d7d9af7a5367cf4$export$8ecd240bc8faaeeb extends $2d7d9af7a5367cf4$var$eventsExports.EventEmitter {
    constructor(url, token){
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        super();
        this.status = $2d7d9af7a5367cf4$export$180e7b9f22912c82.IDLE;
        this.logs = [];
        this.errorsAsWarnings = false;
        this.url = url;
        this.token = token;
        this.name = this.constructor.name;
        this.room = new $2d7d9af7a5367cf4$export$525628e68e798fb4(options.roomOptions);
        this.connectOptions = options.connectOptions;
        if (options.errorsAsWarnings) this.errorsAsWarnings = options.errorsAsWarnings;
    }
    run(onComplete) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (this.status !== $2d7d9af7a5367cf4$export$180e7b9f22912c82.IDLE) throw Error('check is running already');
            this.setStatus($2d7d9af7a5367cf4$export$180e7b9f22912c82.RUNNING);
            try {
                yield this.perform();
            } catch (err) {
                if (err instanceof Error) {
                    if (this.errorsAsWarnings) this.appendWarning(err.message);
                    else this.appendError(err.message);
                }
            }
            yield this.disconnect();
            // sleep for a bit to ensure disconnect
            yield new Promise((resolve)=>setTimeout(resolve, 500));
            // @ts-ignore
            if (this.status !== $2d7d9af7a5367cf4$export$180e7b9f22912c82.SKIPPED) this.setStatus(this.isSuccess() ? $2d7d9af7a5367cf4$export$180e7b9f22912c82.SUCCESS : $2d7d9af7a5367cf4$export$180e7b9f22912c82.FAILED);
            if (onComplete) onComplete();
            return this.getInfo();
        });
    }
    isSuccess() {
        return !this.logs.some((l)=>l.level === 'error');
    }
    connect() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (this.room.state === $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Connected) return this.room;
            yield this.room.connect(this.url, this.token, this.connectOptions);
            return this.room;
        });
    }
    disconnect() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            if (this.room && this.room.state !== $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Disconnected) {
                yield this.room.disconnect();
                // wait for it to go through
                yield new Promise((resolve)=>setTimeout(resolve, 500));
            }
        });
    }
    skip() {
        this.setStatus($2d7d9af7a5367cf4$export$180e7b9f22912c82.SKIPPED);
    }
    appendMessage(message) {
        this.logs.push({
            level: 'info',
            message: message
        });
        this.emit('update', this.getInfo());
    }
    appendWarning(message) {
        this.logs.push({
            level: 'warning',
            message: message
        });
        this.emit('update', this.getInfo());
    }
    appendError(message) {
        this.logs.push({
            level: 'error',
            message: message
        });
        this.emit('update', this.getInfo());
    }
    setStatus(status) {
        this.status = status;
        this.emit('update', this.getInfo());
    }
    get engine() {
        var _a;
        return (_a = this.room) === null || _a === void 0 ? void 0 : _a.engine;
    }
    getInfo() {
        return {
            logs: this.logs,
            name: this.name,
            status: this.status,
            description: this.description
        };
    }
}
/**
 * Creates a local video and audio track at the same time. When acquiring both
 * audio and video tracks together, it'll display a single permission prompt to
 * the user instead of two separate ones.
 * @param options
 */ function $2d7d9af7a5367cf4$export$61cce20000b22feb(options) {
    return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
        var _a, _b;
        // set default options to true
        options !== null && options !== void 0 ? options : options = {};
        (_a = options.audio) !== null && _a !== void 0 ? _a : options.audio = true;
        (_b = options.video) !== null && _b !== void 0 ? _b : options.video = true;
        const { audioProcessor: audioProcessor, videoProcessor: videoProcessor } = $2d7d9af7a5367cf4$var$extractProcessorsFromOptions(options);
        const opts = $2d7d9af7a5367cf4$var$mergeDefaultOptions(options, $2d7d9af7a5367cf4$var$audioDefaults, $2d7d9af7a5367cf4$var$videoDefaults);
        const constraints = $2d7d9af7a5367cf4$var$constraintsForOptions(opts);
        // Keep a reference to the promise on DeviceManager and await it in getLocalDevices()
        // works around iOS Safari Bug https://bugs.webkit.org/show_bug.cgi?id=179363
        const mediaPromise = navigator.mediaDevices.getUserMedia(constraints);
        if (options.audio) {
            $2d7d9af7a5367cf4$var$DeviceManager.userMediaPromiseMap.set('audioinput', mediaPromise);
            mediaPromise.catch(()=>$2d7d9af7a5367cf4$var$DeviceManager.userMediaPromiseMap.delete('audioinput'));
        }
        if (options.video) {
            $2d7d9af7a5367cf4$var$DeviceManager.userMediaPromiseMap.set('videoinput', mediaPromise);
            mediaPromise.catch(()=>$2d7d9af7a5367cf4$var$DeviceManager.userMediaPromiseMap.delete('videoinput'));
        }
        const stream = yield mediaPromise;
        return Promise.all(stream.getTracks().map((mediaStreamTrack)=>$2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
                const isAudio = mediaStreamTrack.kind === 'audio';
                isAudio ? opts.audio : opts.video;
                let trackConstraints;
                const conOrBool = isAudio ? constraints.audio : constraints.video;
                if (typeof conOrBool !== 'boolean') trackConstraints = conOrBool;
                // update the constraints with the device id the user gave permissions to in the permission prompt
                // otherwise each track restart (e.g. mute - unmute) will try to initialize the device again -> causing additional permission prompts
                if (trackConstraints) trackConstraints.deviceId = mediaStreamTrack.getSettings().deviceId;
                else trackConstraints = {
                    deviceId: mediaStreamTrack.getSettings().deviceId
                };
                const track = $2d7d9af7a5367cf4$var$mediaTrackToLocalTrack(mediaStreamTrack, trackConstraints);
                if (track.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Video) track.source = $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Camera;
                else if (track.kind === $2d7d9af7a5367cf4$export$13921ac0cc260818.Kind.Audio) track.source = $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.Microphone;
                track.mediaStream = stream;
                if (track instanceof $2d7d9af7a5367cf4$export$b287427b771ca237 && audioProcessor) yield track.setProcessor(audioProcessor);
                else if (track instanceof $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc && videoProcessor) yield track.setProcessor(videoProcessor);
                return track;
            })));
    });
}
/**
 * Creates a [[LocalVideoTrack]] with getUserMedia()
 * @param options
 */ function $2d7d9af7a5367cf4$export$449d1fd97929ebe7(options) {
    return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
        const tracks = yield $2d7d9af7a5367cf4$export$61cce20000b22feb({
            audio: false,
            video: options
        });
        return tracks[0];
    });
}
function $2d7d9af7a5367cf4$export$6e84c4c7abc03d43(options) {
    return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
        const tracks = yield $2d7d9af7a5367cf4$export$61cce20000b22feb({
            audio: options,
            video: false
        });
        return tracks[0];
    });
}
/**
 * Creates a screen capture tracks with getDisplayMedia().
 * A LocalVideoTrack is always created and returned.
 * If { audio: true }, and the browser supports audio capture, a LocalAudioTrack is also created.
 */ function $2d7d9af7a5367cf4$export$39e3aa92383c771(options) {
    return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
        if (options === undefined) options = {};
        if (options.resolution === undefined && !$2d7d9af7a5367cf4$var$isSafari17()) options.resolution = $2d7d9af7a5367cf4$export$a6cdf9dcd3d32f2d.h1080fps30.resolution;
        if (navigator.mediaDevices.getDisplayMedia === undefined) throw new $2d7d9af7a5367cf4$export$38c5ac268e2fa84('getDisplayMedia not supported');
        const constraints = $2d7d9af7a5367cf4$var$screenCaptureToDisplayMediaStreamOptions(options);
        const stream = yield navigator.mediaDevices.getDisplayMedia(constraints);
        const tracks = stream.getVideoTracks();
        if (tracks.length === 0) throw new $2d7d9af7a5367cf4$export$4fbb9423b5747257('no video track found');
        const screenVideo = new $2d7d9af7a5367cf4$export$d5ffd2c62c538bdc(tracks[0], undefined, false);
        screenVideo.source = $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShare;
        const localTracks = [
            screenVideo
        ];
        if (stream.getAudioTracks().length > 0) {
            const screenAudio = new $2d7d9af7a5367cf4$export$b287427b771ca237(stream.getAudioTracks()[0], undefined, false);
            screenAudio.source = $2d7d9af7a5367cf4$export$13921ac0cc260818.Source.ScreenShareAudio;
            localTracks.push(screenAudio);
        }
        return localTracks;
    });
}
class $2d7d9af7a5367cf4$var$PublishAudioCheck extends $2d7d9af7a5367cf4$export$8ecd240bc8faaeeb {
    get description() {
        return 'Can publish audio';
    }
    perform() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const room = yield this.connect();
            const track = yield $2d7d9af7a5367cf4$export$6e84c4c7abc03d43();
            room.localParticipant.publishTrack(track);
            // wait for a few seconds to publish
            yield new Promise((resolve)=>setTimeout(resolve, 3000));
            // verify RTC stats that it's publishing
            const stats = yield (_a = track.sender) === null || _a === void 0 ? void 0 : _a.getStats();
            if (!stats) throw new Error('Could not get RTCStats');
            let numPackets = 0;
            stats.forEach((stat)=>{
                if (stat.type === 'outbound-rtp' && (stat.kind === 'audio' || !stat.kind && stat.mediaType === 'audio')) numPackets = stat.packetsSent;
            });
            if (numPackets === 0) throw new Error('Could not determine packets are sent');
            this.appendMessage("published ".concat(numPackets, " audio packets"));
        });
    }
}
class $2d7d9af7a5367cf4$var$PublishVideoCheck extends $2d7d9af7a5367cf4$export$8ecd240bc8faaeeb {
    get description() {
        return 'Can publish video';
    }
    perform() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const room = yield this.connect();
            const track = yield $2d7d9af7a5367cf4$export$449d1fd97929ebe7();
            room.localParticipant.publishTrack(track);
            // wait for a few seconds to publish
            yield new Promise((resolve)=>setTimeout(resolve, 5000));
            // verify RTC stats that it's publishing
            const stats = yield (_a = track.sender) === null || _a === void 0 ? void 0 : _a.getStats();
            if (!stats) throw new Error('Could not get RTCStats');
            let numPackets = 0;
            stats.forEach((stat)=>{
                if (stat.type === 'outbound-rtp' && (stat.kind === 'video' || !stat.kind && stat.mediaType === 'video')) numPackets += stat.packetsSent;
            });
            if (numPackets === 0) throw new Error('Could not determine packets are sent');
            this.appendMessage("published ".concat(numPackets, " video packets"));
        });
    }
}
class $2d7d9af7a5367cf4$var$ReconnectCheck extends $2d7d9af7a5367cf4$export$8ecd240bc8faaeeb {
    get description() {
        return 'Resuming connection after interruption';
    }
    perform() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const room = yield this.connect();
            let reconnectingTriggered = false;
            let reconnected = false;
            let reconnectResolver;
            const reconnectTimeout = new Promise((resolve)=>{
                setTimeout(resolve, 5000);
                reconnectResolver = resolve;
            });
            const handleReconnecting = ()=>{
                reconnectingTriggered = true;
            };
            room.on($2d7d9af7a5367cf4$export$3159c672e3b2293a.SignalReconnecting, handleReconnecting).on($2d7d9af7a5367cf4$export$3159c672e3b2293a.Reconnecting, handleReconnecting).on($2d7d9af7a5367cf4$export$3159c672e3b2293a.Reconnected, ()=>{
                reconnected = true;
                reconnectResolver(true);
            });
            (_a = room.engine.client.ws) === null || _a === void 0 || _a.close();
            const onClose = room.engine.client.onClose;
            if (onClose) onClose('');
            yield reconnectTimeout;
            if (!reconnectingTriggered) throw new Error('Did not attempt to reconnect');
            else if (!reconnected || room.state !== $2d7d9af7a5367cf4$export$cd9c3c6bf535afc9.Connected) {
                this.appendWarning('reconnection is only possible in Redis-based configurations');
                throw new Error('Not able to reconnect');
            }
        });
    }
}
class $2d7d9af7a5367cf4$var$TURNCheck extends $2d7d9af7a5367cf4$export$8ecd240bc8faaeeb {
    get description() {
        return 'Can connect via TURN';
    }
    perform() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const signalClient = new $2d7d9af7a5367cf4$var$SignalClient();
            const joinRes = yield signalClient.join(this.url, this.token, {
                autoSubscribe: true,
                maxRetries: 0,
                e2eeEnabled: false,
                websocketTimeout: 15000
            });
            let hasTLS = false;
            let hasTURN = false;
            let hasSTUN = false;
            for (let iceServer of joinRes.iceServers)for (let url of iceServer.urls){
                if (url.startsWith('turn:')) {
                    hasTURN = true;
                    hasSTUN = true;
                } else if (url.startsWith('turns:')) {
                    hasTURN = true;
                    hasSTUN = true;
                    hasTLS = true;
                }
                if (url.startsWith('stun:')) hasSTUN = true;
            }
            if (!hasSTUN) this.appendWarning('No STUN servers configured on server side.');
            else if (hasTURN && !hasTLS) this.appendWarning('TURN is configured server side, but TURN/TLS is unavailable.');
            yield signalClient.close();
            if (((_b = (_a = this.connectOptions) === null || _a === void 0 ? void 0 : _a.rtcConfig) === null || _b === void 0 ? void 0 : _b.iceServers) || hasTURN) yield this.room.connect(this.url, this.token, {
                rtcConfig: {
                    iceTransportPolicy: 'relay'
                }
            });
            else {
                this.appendWarning('No TURN servers configured.');
                this.skip();
                yield new Promise((resolve)=>setTimeout(resolve, 0));
            }
        });
    }
}
class $2d7d9af7a5367cf4$var$WebRTCCheck extends $2d7d9af7a5367cf4$export$8ecd240bc8faaeeb {
    get description() {
        return 'Establishing WebRTC connection';
    }
    perform() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            let hasTcp = false;
            let hasIpv4Udp = false;
            this.room.on($2d7d9af7a5367cf4$export$3159c672e3b2293a.SignalConnected, ()=>{
                const prevTrickle = this.room.engine.client.onTrickle;
                this.room.engine.client.onTrickle = (sd, target)=>{
                    if (sd.candidate) {
                        const candidate = new RTCIceCandidate(sd);
                        let str = "".concat(candidate.protocol, " ").concat(candidate.address, ":").concat(candidate.port, " ").concat(candidate.type);
                        if (candidate.address) {
                            if ($2d7d9af7a5367cf4$var$isIPPrivate(candidate.address)) str += ' (private)';
                            else {
                                if (candidate.protocol === 'tcp' && candidate.tcpType === 'passive') {
                                    hasTcp = true;
                                    str += ' (passive)';
                                } else if (candidate.protocol === 'udp') hasIpv4Udp = true;
                            }
                        }
                        this.appendMessage(str);
                    }
                    if (prevTrickle) prevTrickle(sd, target);
                };
                if (this.room.engine.pcManager) this.room.engine.pcManager.subscriber.onIceCandidateError = (ev)=>{
                    if (ev instanceof RTCPeerConnectionIceErrorEvent) this.appendWarning("error with ICE candidate: ".concat(ev.errorCode, " ").concat(ev.errorText, " ").concat(ev.url));
                };
            });
            try {
                yield this.connect();
                $2d7d9af7a5367cf4$var$livekitLogger.info('now the room is connected');
            } catch (err) {
                this.appendWarning('ports need to be open on firewall in order to connect.');
                throw err;
            }
            if (!hasTcp) this.appendWarning('Server is not configured for ICE/TCP');
            if (!hasIpv4Udp) this.appendWarning('No public IPv4 UDP candidates were found. Your server is likely not configured correctly');
        });
    }
}
function $2d7d9af7a5367cf4$var$isIPPrivate(address) {
    const parts = address.split('.');
    if (parts.length === 4) {
        if (parts[0] === '10') return true;
        else if (parts[0] === '192' && parts[1] === '168') return true;
        else if (parts[0] === '172') {
            const second = parseInt(parts[1], 10);
            if (second >= 16 && second <= 31) return true;
        }
    }
    return false;
}
class $2d7d9af7a5367cf4$var$WebSocketCheck extends $2d7d9af7a5367cf4$export$8ecd240bc8faaeeb {
    get description() {
        return 'Connecting to signal connection via WebSocket';
    }
    perform() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            if (this.url.startsWith('ws:') || this.url.startsWith('http:')) this.appendWarning('Server is insecure, clients may block connections to it');
            let signalClient = new $2d7d9af7a5367cf4$var$SignalClient();
            const joinRes = yield signalClient.join(this.url, this.token, {
                autoSubscribe: true,
                maxRetries: 0,
                e2eeEnabled: false,
                websocketTimeout: 15000
            });
            this.appendMessage("Connected to server, version ".concat(joinRes.serverVersion, "."));
            if (((_a = joinRes.serverInfo) === null || _a === void 0 ? void 0 : _a.edition) === $2d7d9af7a5367cf4$var$ServerInfo_Edition.Cloud && ((_b = joinRes.serverInfo) === null || _b === void 0 ? void 0 : _b.region)) this.appendMessage("LiveKit Cloud: ".concat((_c = joinRes.serverInfo) === null || _c === void 0 ? void 0 : _c.region));
            yield signalClient.close();
        });
    }
}
class $2d7d9af7a5367cf4$export$987f59e088b53559 extends $2d7d9af7a5367cf4$var$eventsExports.EventEmitter {
    constructor(url, token){
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        super();
        this.options = {};
        this.checkResults = new Map();
        this.url = url;
        this.token = token;
        this.options = options;
    }
    getNextCheckId() {
        const nextId = this.checkResults.size;
        this.checkResults.set(nextId, {
            logs: [],
            status: $2d7d9af7a5367cf4$export$180e7b9f22912c82.IDLE,
            name: '',
            description: ''
        });
        return nextId;
    }
    updateCheck(checkId, info) {
        this.checkResults.set(checkId, info);
        this.emit('checkUpdate', checkId, info);
    }
    isSuccess() {
        return Array.from(this.checkResults.values()).every((r)=>r.status !== $2d7d9af7a5367cf4$export$180e7b9f22912c82.FAILED);
    }
    getResults() {
        return Array.from(this.checkResults.values());
    }
    createAndRunCheck(check) {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            const checkId = this.getNextCheckId();
            const test = new check(this.url, this.token, this.options);
            const handleUpdate = (info)=>{
                this.updateCheck(checkId, info);
            };
            test.on('update', handleUpdate);
            const result = yield test.run();
            test.off('update', handleUpdate);
            return result;
        });
    }
    checkWebsocket() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($2d7d9af7a5367cf4$var$WebSocketCheck);
        });
    }
    checkWebRTC() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($2d7d9af7a5367cf4$var$WebRTCCheck);
        });
    }
    checkTURN() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($2d7d9af7a5367cf4$var$TURNCheck);
        });
    }
    checkReconnect() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($2d7d9af7a5367cf4$var$ReconnectCheck);
        });
    }
    checkPublishAudio() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($2d7d9af7a5367cf4$var$PublishAudioCheck);
        });
    }
    checkPublishVideo() {
        return $2d7d9af7a5367cf4$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($2d7d9af7a5367cf4$var$PublishVideoCheck);
        });
    }
}
/**
 * Try to analyze the local track to determine the facing mode of a track.
 *
 * @remarks
 * There is no property supported by all browsers to detect whether a video track originated from a user- or environment-facing camera device.
 * For this reason, we use the `facingMode` property when available, but will fall back on a string-based analysis of the device label to determine the facing mode.
 * If both methods fail, the default facing mode will be used.
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackConstraints/facingMode | MDN docs on facingMode}
 * @experimental
 */ function $2d7d9af7a5367cf4$export$87170f5cedaf6982(localTrack) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _a;
    const track = localTrack instanceof $2d7d9af7a5367cf4$export$3e041ce3f33f04dd ? localTrack.mediaStreamTrack : localTrack;
    const trackSettings = track.getSettings();
    let result = {
        facingMode: (_a = options.defaultFacingMode) !== null && _a !== void 0 ? _a : 'user',
        confidence: 'low'
    };
    // 1. Try to get facingMode from track settings.
    if ('facingMode' in trackSettings) {
        const rawFacingMode = trackSettings.facingMode;
        $2d7d9af7a5367cf4$var$livekitLogger.trace('rawFacingMode', {
            rawFacingMode: rawFacingMode
        });
        if (rawFacingMode && typeof rawFacingMode === 'string' && $2d7d9af7a5367cf4$var$isFacingModeValue(rawFacingMode)) result = {
            facingMode: rawFacingMode,
            confidence: 'high'
        };
    }
    // 2. If we don't have a high confidence we try to get the facing mode from the device label.
    if ([
        'low',
        'medium'
    ].includes(result.confidence)) {
        $2d7d9af7a5367cf4$var$livekitLogger.trace("Try to get facing mode from device label: (".concat(track.label, ")"));
        const labelAnalysisResult = $2d7d9af7a5367cf4$export$db3659edbf169d37(track.label);
        if (labelAnalysisResult !== undefined) result = labelAnalysisResult;
    }
    return result;
}
const $2d7d9af7a5367cf4$var$knownDeviceLabels = new Map([
    [
        'obs virtual camera',
        {
            facingMode: 'environment',
            confidence: 'medium'
        }
    ]
]);
const $2d7d9af7a5367cf4$var$knownDeviceLabelSections = new Map([
    [
        'iphone',
        {
            facingMode: 'environment',
            confidence: 'medium'
        }
    ],
    [
        'ipad',
        {
            facingMode: 'environment',
            confidence: 'medium'
        }
    ]
]);
/**
 * Attempt to analyze the device label to determine the facing mode.
 *
 * @experimental
 */ function $2d7d9af7a5367cf4$export$db3659edbf169d37(deviceLabel) {
    var _a;
    const label = deviceLabel.trim().toLowerCase();
    // Empty string is a valid device label but we can't infer anything from it.
    if (label === '') return undefined;
    // Can we match against widely known device labels.
    if ($2d7d9af7a5367cf4$var$knownDeviceLabels.has(label)) return $2d7d9af7a5367cf4$var$knownDeviceLabels.get(label);
    // Can we match against sections of the device label.
    return (_a = Array.from($2d7d9af7a5367cf4$var$knownDeviceLabelSections.entries()).find((_ref)=>{
        let [section] = _ref;
        return label.includes(section);
    })) === null || _a === void 0 ? void 0 : _a[1];
}
function $2d7d9af7a5367cf4$var$isFacingModeValue(item) {
    const allowedValues = [
        'user',
        'environment',
        'left',
        'right'
    ];
    return item === undefined || allowedValues.includes(item);
}


var $3dcd65725028159c$exports = {};
// full library entry point.
"use strict";

$3dcd65725028159c$exports = (parcelRequire("ddkAr"));


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $0fce50c6ae590ce1$var$extendStatics = function(d, b) {
    $0fce50c6ae590ce1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $0fce50c6ae590ce1$var$extendStatics(d, b);
};
function $0fce50c6ae590ce1$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $0fce50c6ae590ce1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function $0fce50c6ae590ce1$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $0fce50c6ae590ce1$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
typeof SuppressedError === "function" && SuppressedError;
function $0fce50c6ae590ce1$var$sleep(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}
function $0fce50c6ae590ce1$var$convertFloat32ToS16PCM(float32Array) {
    var int16Array = new Int16Array(float32Array.length);
    for(var i = 0; i < float32Array.length; i++){
        var clampedValue = Math.max(-1, Math.min(1, float32Array[i]));
        int16Array[i] = clampedValue < 0 ? clampedValue * 32768 : clampedValue * 32767;
    }
    return int16Array;
}
var $0fce50c6ae590ce1$var$options = {
    syntax: "proto3"
};
var $0fce50c6ae590ce1$var$nested = {
    pipecat: {
        nested: {
            TextFrame: {
                fields: {
                    id: {
                        type: "uint64",
                        id: 1
                    },
                    name: {
                        type: "string",
                        id: 2
                    },
                    text: {
                        type: "string",
                        id: 3
                    }
                }
            },
            AudioRawFrame: {
                fields: {
                    id: {
                        type: "uint64",
                        id: 1
                    },
                    name: {
                        type: "string",
                        id: 2
                    },
                    audio: {
                        type: "bytes",
                        id: 3
                    },
                    sampleRate: {
                        type: "uint32",
                        id: 4
                    },
                    numChannels: {
                        type: "uint32",
                        id: 5
                    }
                }
            },
            TranscriptionFrame: {
                fields: {
                    id: {
                        type: "uint64",
                        id: 1
                    },
                    name: {
                        type: "string",
                        id: 2
                    },
                    text: {
                        type: "string",
                        id: 3
                    },
                    userId: {
                        type: "string",
                        id: 4
                    },
                    timestamp: {
                        type: "string",
                        id: 5
                    }
                }
            },
            Frame: {
                oneofs: {
                    frame: {
                        oneof: [
                            "text",
                            "audio",
                            "transcription"
                        ]
                    }
                },
                fields: {
                    text: {
                        type: "TextFrame",
                        id: 1
                    },
                    audio: {
                        type: "AudioRawFrame",
                        id: 2
                    },
                    transcription: {
                        type: "TranscriptionFrame",
                        id: 3
                    }
                }
            }
        }
    }
};
var $0fce50c6ae590ce1$var$jsonDescriptor = {
    options: $0fce50c6ae590ce1$var$options,
    nested: $0fce50c6ae590ce1$var$nested
};
var $0fce50c6ae590ce1$export$f8e9e2a4a1e2cea5;
(function(AvatarQuality) {
    AvatarQuality["Low"] = "low";
    AvatarQuality["Medium"] = "medium";
    AvatarQuality["High"] = "high";
})($0fce50c6ae590ce1$export$f8e9e2a4a1e2cea5 || ($0fce50c6ae590ce1$export$f8e9e2a4a1e2cea5 = {}));
var $0fce50c6ae590ce1$export$d4bc09d32441564e;
(function(VoiceEmotion) {
    VoiceEmotion["EXCITED"] = "excited";
    VoiceEmotion["SERIOUS"] = "serious";
    VoiceEmotion["FRIENDLY"] = "friendly";
    VoiceEmotion["SOOTHING"] = "soothing";
    VoiceEmotion["BROADCASTER"] = "broadcaster";
})($0fce50c6ae590ce1$export$d4bc09d32441564e || ($0fce50c6ae590ce1$export$d4bc09d32441564e = {}));
var $0fce50c6ae590ce1$export$1f8b1cab05cab788;
(function(TaskType) {
    TaskType["TALK"] = "talk";
    TaskType["REPEAT"] = "repeat";
})($0fce50c6ae590ce1$export$1f8b1cab05cab788 || ($0fce50c6ae590ce1$export$1f8b1cab05cab788 = {}));
var $0fce50c6ae590ce1$export$b4af15ed7b5af758;
(function(TaskMode) {
    TaskMode["SYNC"] = "sync";
    TaskMode["ASYNC"] = "async";
})($0fce50c6ae590ce1$export$b4af15ed7b5af758 || ($0fce50c6ae590ce1$export$b4af15ed7b5af758 = {}));
// event types --------------------------------
var $0fce50c6ae590ce1$export$1a7aeeed4753a2c0;
(function(StreamingEvents) {
    StreamingEvents["AVATAR_START_TALKING"] = "avatar_start_talking";
    StreamingEvents["AVATAR_STOP_TALKING"] = "avatar_stop_talking";
    StreamingEvents["AVATAR_TALKING_MESSAGE"] = "avatar_talking_message";
    StreamingEvents["AVATAR_END_MESSAGE"] = "avatar_end_message";
    StreamingEvents["USER_TALKING_MESSAGE"] = "user_talking_message";
    StreamingEvents["USER_END_MESSAGE"] = "user_end_message";
    StreamingEvents["USER_START"] = "user_start";
    StreamingEvents["USER_STOP"] = "user_stop";
    StreamingEvents["USER_SILENCE"] = "user_silence";
    StreamingEvents["STREAM_READY"] = "stream_ready";
    StreamingEvents["STREAM_DISCONNECTED"] = "stream_disconnected";
})($0fce50c6ae590ce1$export$1a7aeeed4753a2c0 || ($0fce50c6ae590ce1$export$1a7aeeed4753a2c0 = {}));
var $0fce50c6ae590ce1$var$APIError = /** @class */ function(_super) {
    $0fce50c6ae590ce1$var$__extends(APIError, _super);
    function APIError(message, status, responseText) {
        var _this = _super.call(this, message) || this;
        _this.name = 'APIError';
        _this.status = status;
        _this.responseText = responseText;
        return _this;
    }
    return APIError;
}(Error);
var $0fce50c6ae590ce1$export$2e2bcd8739ae039 = /** @class */ function() {
    function StreamingAvatar(_a) {
        var token = _a.token, _b = _a.basePath, basePath = _b === void 0 ? "https://api.heygen.com" : _b;
        this.room = null;
        this.mediaStream = null;
        this.eventTarget = new EventTarget();
        this.audioContext = null;
        this.webSocket = null;
        this.scriptProcessor = null;
        this.mediaStreamAudioSource = null;
        this.mediaDevicesStream = null;
        this.sessionId = null;
        this.token = token;
        this.basePath = basePath;
    }
    StreamingAvatar.prototype.createStartAvatar = function(requestData) {
        return $0fce50c6ae590ce1$var$__awaiter(this, void 0, void 0, function() {
            var sessionInfo, room, mediaStream;
            var _this = this;
            return $0fce50c6ae590ce1$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.newSession(requestData)
                        ];
                    case 1:
                        sessionInfo = _a.sent();
                        this.sessionId = sessionInfo.session_id;
                        this.language = requestData.language;
                        room = new (0, $2d7d9af7a5367cf4$export$525628e68e798fb4)({
                            adaptiveStream: true,
                            dynacast: true,
                            videoCaptureDefaults: {
                                resolution: (0, $2d7d9af7a5367cf4$export$79d56065dad1674c).h720.resolution
                            }
                        });
                        this.room = room;
                        this.mediaStream = null;
                        room.on((0, $2d7d9af7a5367cf4$export$3159c672e3b2293a).DataReceived, function(roomMessage) {
                            var eventMsg = null;
                            try {
                                var messageString = new TextDecoder().decode(roomMessage);
                                eventMsg = JSON.parse(messageString);
                            } catch (e) {
                                console.error(e);
                            }
                            if (!eventMsg) return;
                            _this.emit(eventMsg.type, eventMsg);
                        });
                        mediaStream = new MediaStream();
                        room.on((0, $2d7d9af7a5367cf4$export$3159c672e3b2293a).TrackSubscribed, function(track) {
                            if (track.kind === "video" || track.kind === "audio") {
                                mediaStream.addTrack(track.mediaStreamTrack);
                                var hasVideoTrack = mediaStream.getVideoTracks().length > 0;
                                var hasAudioTrack = mediaStream.getAudioTracks().length > 0;
                                if (hasVideoTrack && hasAudioTrack && !_this.mediaStream) {
                                    _this.mediaStream = mediaStream;
                                    _this.emit($0fce50c6ae590ce1$export$1a7aeeed4753a2c0.STREAM_READY, _this.mediaStream);
                                }
                            }
                        });
                        room.on((0, $2d7d9af7a5367cf4$export$3159c672e3b2293a).TrackUnsubscribed, function(track) {
                            var mediaTrack = track.mediaStreamTrack;
                            if (mediaTrack) mediaStream.removeTrack(mediaTrack);
                        });
                        room.on((0, $2d7d9af7a5367cf4$export$3159c672e3b2293a).Disconnected, function(reason) {
                            _this.emit($0fce50c6ae590ce1$export$1a7aeeed4753a2c0.STREAM_DISCONNECTED, reason);
                        });
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            room.prepareConnection(sessionInfo.url, sessionInfo.access_token)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            this.startSession()
                        ];
                    case 6:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            room.connect(sessionInfo.url, sessionInfo.access_token)
                        ];
                    case 7:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            sessionInfo
                        ];
                }
            });
        });
    };
    StreamingAvatar.prototype.startVoiceChat = function() {
        return $0fce50c6ae590ce1$var$__awaiter(this, arguments, void 0, function(requestData) {
            var devicesStream, e_1;
            var _this = this;
            var _a, _b, _c;
            if (requestData === void 0) requestData = {};
            return $0fce50c6ae590ce1$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        requestData.useSilencePrompt = requestData.useSilencePrompt || false;
                        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return [
                            2 /*return*/ 
                        ];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.loadAudioRawFrame()
                        ];
                    case 2:
                        _d.sent();
                        return [
                            4 /*yield*/ ,
                            this.connectWebSocket({
                                useSilencePrompt: requestData.useSilencePrompt
                            })
                        ];
                    case 3:
                        _d.sent();
                        this.audioContext = new window.AudioContext({
                            latencyHint: 'interactive',
                            sampleRate: 16000
                        });
                        return [
                            4 /*yield*/ ,
                            navigator.mediaDevices.getUserMedia({
                                audio: {
                                    sampleRate: 16000,
                                    channelCount: 1,
                                    autoGainControl: true,
                                    echoCancellation: true,
                                    noiseSuppression: true
                                }
                            })
                        ];
                    case 4:
                        devicesStream = _d.sent();
                        this.mediaDevicesStream = devicesStream;
                        this.mediaStreamAudioSource = (_a = this.audioContext) === null || _a === void 0 ? void 0 : _a.createMediaStreamSource(devicesStream);
                        this.scriptProcessor = (_b = this.audioContext) === null || _b === void 0 ? void 0 : _b.createScriptProcessor(512, 1, 1);
                        this.mediaStreamAudioSource.connect(this.scriptProcessor);
                        this.scriptProcessor.connect((_c = this.audioContext) === null || _c === void 0 ? void 0 : _c.destination);
                        this.scriptProcessor.onaudioprocess = function(event) {
                            var _a, _b, _c;
                            if (!_this.webSocket) return;
                            var audioData = event.inputBuffer.getChannelData(0);
                            var pcmS16Array = $0fce50c6ae590ce1$var$convertFloat32ToS16PCM(audioData);
                            var pcmByteArray = new Uint8Array(pcmS16Array.buffer);
                            var frame = (_a = _this.audioRawFrame) === null || _a === void 0 ? void 0 : _a.create({
                                audio: {
                                    audio: Array.from(pcmByteArray),
                                    sampleRate: 16000,
                                    numChannels: 1
                                }
                            });
                            var encodedFrame = new Uint8Array((_b = _this.audioRawFrame) === null || _b === void 0 ? void 0 : _b.encode(frame).finish());
                            (_c = _this.webSocket) === null || _c === void 0 || _c.send(encodedFrame);
                        };
                        // though room has been connected, but the stream may not be ready.
                        return [
                            4 /*yield*/ ,
                            $0fce50c6ae590ce1$var$sleep(2000)
                        ];
                    case 5:
                        // though room has been connected, but the stream may not be ready.
                        _d.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_1 = _d.sent();
                        console.error(e_1);
                        throw e_1;
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    StreamingAvatar.prototype.closeVoiceChat = function() {
        var _a, _b;
        try {
            if (this.audioContext) this.audioContext = null;
            if (this.scriptProcessor) {
                this.scriptProcessor.disconnect();
                this.scriptProcessor = null;
            }
            if (this.mediaStreamAudioSource) {
                this.mediaStreamAudioSource.disconnect();
                this.mediaStreamAudioSource = null;
            }
            if (this.mediaDevicesStream) {
                (_b = (_a = this.mediaDevicesStream) === null || _a === void 0 ? void 0 : _a.getTracks()) === null || _b === void 0 || _b.forEach(function(track) {
                    return track.stop();
                });
                this.mediaDevicesStream = null;
            }
            if (this.webSocket) this.webSocket.close();
        } catch (e) {}
    };
    StreamingAvatar.prototype.newSession = function(requestData) {
        return $0fce50c6ae590ce1$var$__awaiter(this, void 0, void 0, function() {
            var _a, _b, _c;
            return $0fce50c6ae590ce1$var$__generator(this, function(_d) {
                return [
                    2 /*return*/ ,
                    this.request("/v1/streaming.new", {
                        avatar_name: requestData.avatarName,
                        quality: requestData.quality,
                        knowledge_base_id: requestData.knowledgeId,
                        knowledge_base: requestData.knowledgeBase,
                        voice: {
                            voice_id: (_a = requestData.voice) === null || _a === void 0 ? void 0 : _a.voiceId,
                            rate: (_b = requestData.voice) === null || _b === void 0 ? void 0 : _b.rate,
                            emotion: (_c = requestData.voice) === null || _c === void 0 ? void 0 : _c.emotion
                        },
                        language: requestData.language,
                        version: "v2",
                        video_encoding: "H264",
                        source: 'sdk',
                        disable_idle_timeout: requestData.disableIdleTimeout
                    })
                ];
            });
        });
    };
    StreamingAvatar.prototype.startSession = function() {
        return $0fce50c6ae590ce1$var$__awaiter(this, void 0, void 0, function() {
            return $0fce50c6ae590ce1$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.request("/v1/streaming.start", {
                        session_id: this.sessionId
                    })
                ];
            });
        });
    };
    StreamingAvatar.prototype.speak = function(requestData) {
        return $0fce50c6ae590ce1$var$__awaiter(this, void 0, void 0, function() {
            var frame, encodedFrame;
            var _a, _b, _c;
            return $0fce50c6ae590ce1$var$__generator(this, function(_d) {
                requestData.taskType = requestData.taskType || requestData.task_type || $0fce50c6ae590ce1$export$1f8b1cab05cab788.TALK;
                requestData.taskMode = requestData.taskMode || $0fce50c6ae590ce1$export$b4af15ed7b5af758.ASYNC;
                // try to use websocket first
                // only support talk task
                if (this.webSocket && this.audioRawFrame && requestData.task_type === $0fce50c6ae590ce1$export$1f8b1cab05cab788.TALK && requestData.taskMode !== $0fce50c6ae590ce1$export$b4af15ed7b5af758.SYNC) {
                    frame = (_a = this.audioRawFrame) === null || _a === void 0 ? void 0 : _a.create({
                        text: {
                            text: requestData.text
                        }
                    });
                    encodedFrame = new Uint8Array((_b = this.audioRawFrame) === null || _b === void 0 ? void 0 : _b.encode(frame).finish());
                    (_c = this.webSocket) === null || _c === void 0 || _c.send(encodedFrame);
                    return [
                        2 /*return*/ 
                    ];
                }
                return [
                    2 /*return*/ ,
                    this.request("/v1/streaming.task", {
                        text: requestData.text,
                        session_id: this.sessionId,
                        task_mode: requestData.taskMode,
                        task_type: requestData.taskType
                    })
                ];
            });
        });
    };
    StreamingAvatar.prototype.startListening = function() {
        return $0fce50c6ae590ce1$var$__awaiter(this, void 0, void 0, function() {
            return $0fce50c6ae590ce1$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.request("/v1/streaming.start_listening", {
                        session_id: this.sessionId
                    })
                ];
            });
        });
    };
    StreamingAvatar.prototype.stopListening = function() {
        return $0fce50c6ae590ce1$var$__awaiter(this, void 0, void 0, function() {
            return $0fce50c6ae590ce1$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.request("/v1/streaming.stop_listening", {
                        session_id: this.sessionId
                    })
                ];
            });
        });
    };
    StreamingAvatar.prototype.interrupt = function() {
        return $0fce50c6ae590ce1$var$__awaiter(this, void 0, void 0, function() {
            return $0fce50c6ae590ce1$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.request("/v1/streaming.interrupt", {
                        session_id: this.sessionId
                    })
                ];
            });
        });
    };
    StreamingAvatar.prototype.stopAvatar = function() {
        return $0fce50c6ae590ce1$var$__awaiter(this, void 0, void 0, function() {
            return $0fce50c6ae590ce1$var$__generator(this, function(_a) {
                // clear some resources
                this.closeVoiceChat();
                return [
                    2 /*return*/ ,
                    this.request("/v1/streaming.stop", {
                        session_id: this.sessionId
                    })
                ];
            });
        });
    };
    StreamingAvatar.prototype.on = function(eventType, listener) {
        this.eventTarget.addEventListener(eventType, listener);
        return this;
    };
    StreamingAvatar.prototype.off = function(eventType, listener) {
        this.eventTarget.removeEventListener(eventType, listener);
        return this;
    };
    StreamingAvatar.prototype.request = function(path, params, config) {
        return $0fce50c6ae590ce1$var$__awaiter(this, void 0, void 0, function() {
            var response, errorText, jsonData, error_2;
            return $0fce50c6ae590ce1$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            fetch(this.getRequestUrl(path), {
                                method: "POST",
                                headers: {
                                    Authorization: "Bearer ".concat(this.token),
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify(params)
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        if (!!response.ok) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 2:
                        errorText = _a.sent();
                        throw new $0fce50c6ae590ce1$var$APIError("API request failed with status ".concat(response.status), response.status, errorText);
                    case 3:
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 4:
                        jsonData = _a.sent();
                        return [
                            2 /*return*/ ,
                            jsonData.data
                        ];
                    case 5:
                        error_2 = _a.sent();
                        throw error_2;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    StreamingAvatar.prototype.emit = function(eventType, detail) {
        var event = new CustomEvent(eventType, {
            detail: detail
        });
        this.eventTarget.dispatchEvent(event);
    };
    StreamingAvatar.prototype.getRequestUrl = function(endpoint) {
        return "".concat(this.basePath).concat(endpoint);
    };
    StreamingAvatar.prototype.connectWebSocket = function(requestData) {
        return $0fce50c6ae590ce1$var$__awaiter(this, void 0, void 0, function() {
            var websocketUrl;
            var _this = this;
            return $0fce50c6ae590ce1$var$__generator(this, function(_a) {
                websocketUrl = "wss://".concat(new URL(this.basePath).hostname, "/v1/ws/streaming.chat?session_id=").concat(this.sessionId, "&session_token=").concat(this.token, "&silence_response=").concat(requestData.useSilencePrompt);
                if (this.language) websocketUrl += "&stt_language=".concat(this.language);
                this.webSocket = new WebSocket(websocketUrl);
                this.webSocket.addEventListener('message', function(event) {
                    var eventData = null;
                    try {
                        eventData = JSON.parse(event.data);
                    } catch (e) {
                        console.error(e);
                        return;
                    }
                    _this.emit(eventData.event_type, eventData);
                });
                this.webSocket.addEventListener('close', function(event) {
                    _this.webSocket = null;
                });
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var _a, _b;
                        (_a = _this.webSocket) === null || _a === void 0 || _a.addEventListener('error', function(event) {
                            _this.webSocket = null;
                            reject(event);
                        });
                        (_b = _this.webSocket) === null || _b === void 0 || _b.addEventListener('open', function() {
                            resolve(true);
                        });
                    })
                ];
            });
        });
    };
    StreamingAvatar.prototype.loadAudioRawFrame = function() {
        return $0fce50c6ae590ce1$var$__awaiter(this, void 0, void 0, function() {
            var root;
            return $0fce50c6ae590ce1$var$__generator(this, function(_a) {
                if (!this.audioRawFrame) {
                    root = (0, (/*@__PURE__*/$parcel$interopDefault($3dcd65725028159c$exports))).Root.fromJSON($0fce50c6ae590ce1$var$jsonDescriptor);
                    this.audioRawFrame = root === null || root === void 0 ? void 0 : root.lookupType('pipecat.Frame');
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return StreamingAvatar;
}();





var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $0b1323fcbd845168$var$SvgQuotes = (props)=>/*#__PURE__*/ (0, $bb3TF.jsx)("svg", {
        width: 23,
        height: 17,
        fill: "#181818",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
            d: "M0 6.328C0 2.832 2.757 0 6.16 0h.411c.91 0 1.643.754 1.643 1.688 0 .933-.734 1.687-1.643 1.687h-.41c-1.587 0-2.875 1.324-2.875 2.953v.422H6.57c1.813 0 3.286 1.513 3.286 3.375V13.5c0 1.861-1.473 3.375-3.286 3.375H3.286C1.473 16.875 0 15.361 0 13.5V6.328Zm13.143 0C13.143 2.832 15.9 0 19.303 0h.411c.909 0 1.643.754 1.643 1.688 0 .933-.734 1.687-1.643 1.687h-.41c-1.587 0-2.875 1.324-2.875 2.953v.422h3.285C21.527 6.75 23 8.263 23 10.125V13.5c0 1.861-1.473 3.375-3.286 3.375H16.43c-1.813 0-3.286-1.514-3.286-3.375V6.328Z"
        })
    });
var $0b1323fcbd845168$export$2e2bcd8739ae039 = $0b1323fcbd845168$var$SvgQuotes;



const $f442d9dc730cd5f3$var$defaultOptions = {};
const $f442d9dc730cd5f3$export$929dc183829ddaea = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query FindAllUsersInFirm($firmAccountId: String!, $searchWord: String) {
  findAllUsersInFirm(firmAccountId: $firmAccountId, searchWord: $searchWord) {
    id
    UserInformation {
      lastName
      firstName
    }
    UserFirmAccount {
      id
      userId
      firmAccountId
      Roles {
        description
      }
    }
    Entity {
      UserFirmAccount {
        id
        entityId
        firmAccountId
        Roles {
          description
        }
        Entity {
          id
          Users {
            id
          }
        }
      }
    }
  }
}
    `;
function $f442d9dc730cd5f3$export$c496e66d3109c100(baseOptions) {
    const options = {
        ...$f442d9dc730cd5f3$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($f442d9dc730cd5f3$export$929dc183829ddaea, options);
}
function $f442d9dc730cd5f3$export$bf308f30d6ee1425(baseOptions) {
    const options = {
        ...$f442d9dc730cd5f3$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($f442d9dc730cd5f3$export$929dc183829ddaea, options);
}
const $f442d9dc730cd5f3$export$bff3f5f4510ea8db = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query getUserChannels($searchWord: String, $take: Float, $skip: Float) {
  userChannels(searchWord: $searchWord, take: $take, skip: $skip) {
    id
    createAt
    updateAt
    description
    online
    Messages {
      id
      text
      userId
      createAt
      updateAt
      readDate
      channelId
      attachment
      isSms
      Users {
        id
        email
        createAt
        updateAt
        languageId
        UserInformation {
          id
          userId
          createAt
          updateAt
          birthday
          lastName
          firstName
        }
      }
    }
    ChannelMembers {
      id
      userId
      createAt
      channelId
      lastConnection
      Users {
        id
        email
        createAt
        updateAt
        languageId
        UserInformation {
          id
          userId
          createAt
          updateAt
          birthday
          lastName
          firstName
          Phones {
            id
            type
            value
            createAt
            updateAt
          }
        }
        FirmAccount {
          id
          name
          Interviews {
            id
            name
            TaxYearInterview {
              id
              taxYearId
              TaxYear {
                year
              }
            }
          }
        }
        Entity {
          id
        }
      }
    }
  }
}
    `;
function $f442d9dc730cd5f3$export$c29d00e152e3b23d(baseOptions) {
    const options = {
        ...$f442d9dc730cd5f3$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($f442d9dc730cd5f3$export$bff3f5f4510ea8db, options);
}
function $f442d9dc730cd5f3$export$16b3d246f02b0323(baseOptions) {
    const options = {
        ...$f442d9dc730cd5f3$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($f442d9dc730cd5f3$export$bff3f5f4510ea8db, options);
}
const $f442d9dc730cd5f3$export$73948290a30ffe18 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query AIMessageSuggestion($channelId: String!) {
  AIMessageSuggestion(channelId: $channelId) {
    id
    choices {
      index
      message {
        role
        content
      }
      finish_reason
    }
  }
}
    `;
function $f442d9dc730cd5f3$export$8e6cf7ebac3f432a(baseOptions) {
    const options = {
        ...$f442d9dc730cd5f3$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($f442d9dc730cd5f3$export$73948290a30ffe18, options);
}
function $f442d9dc730cd5f3$export$11efbe0520b78d5f(baseOptions) {
    const options = {
        ...$f442d9dc730cd5f3$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($f442d9dc730cd5f3$export$73948290a30ffe18, options);
}
const $f442d9dc730cd5f3$export$792f7d5c73629a17 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetChannelMessages($channelId: String!, $take: Float, $skip: Float) {
  getChannelMessages(channelId: $channelId, take: $take, skip: $skip) {
    id
    text
    userId
    createAt
    updateAt
    readDate
    channelId
    attachment
    isSms
    Users {
      id
      email
      createAt
      updateAt
      languageId
      UserInformation {
        id
        userId
        createAt
        updateAt
        birthday
        lastName
        firstName
      }
    }
  }
}
    `;
function $f442d9dc730cd5f3$export$63fa59bec2fa18f1(baseOptions) {
    const options = {
        ...$f442d9dc730cd5f3$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($f442d9dc730cd5f3$export$792f7d5c73629a17, options);
}
function $f442d9dc730cd5f3$export$1dd0ad8ddf0e0222(baseOptions) {
    const options = {
        ...$f442d9dc730cd5f3$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($f442d9dc730cd5f3$export$792f7d5c73629a17, options);
}
const $f442d9dc730cd5f3$export$ad65fcc6f7468098 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetAiAgentMessages($take: Int, $skip: Int) {
  getAiAgentMessages(take: $take, skip: $skip) {
    pagination {
      total
      skip
      take
    }
    data {
      id
      type
      text
      more
      createAt
    }
  }
}
    `;
function $f442d9dc730cd5f3$export$afecb3f2968966b5(baseOptions) {
    const options = {
        ...$f442d9dc730cd5f3$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($f442d9dc730cd5f3$export$ad65fcc6f7468098, options);
}
function $f442d9dc730cd5f3$export$47cb3c7e538d41ba(baseOptions) {
    const options = {
        ...$f442d9dc730cd5f3$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($f442d9dc730cd5f3$export$ad65fcc6f7468098, options);
}
const $f442d9dc730cd5f3$export$39ac829ab91f0716 = {
    Query: {
        FindAllUsersInFirm: 'FindAllUsersInFirm',
        getUserChannels: 'getUserChannels',
        AIMessageSuggestion: 'AIMessageSuggestion',
        GetChannelMessages: 'GetChannelMessages',
        GetAiAgentMessages: 'GetAiAgentMessages'
    }
};



const $4cdb1470f9874f96$var$defaultOptions = {};
const $4cdb1470f9874f96$export$7b2ae84d0cab029e = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateChannel($createChannelInput: CreateChannelInput!) {
  createChannel(createChannelInput: $createChannelInput) {
    id
    createAt
    updateAt
    description
    Messages {
      id
      text
      userId
      readDate
      createAt
      updateAt
      channelId
      attachment
      isSms
      Users {
        id
        email
        createAt
        updateAt
        languageId
        UserInformation {
          id
          userId
          createAt
          updateAt
          birthday
          lastName
          firstName
        }
      }
    }
    ChannelMembers {
      id
      userId
      createAt
      channelId
      lastConnection
      Users {
        id
        email
        createAt
        updateAt
        languageId
        UserInformation {
          id
          userId
          createAt
          updateAt
          birthday
          lastName
          firstName
          Phones {
            id
            type
            value
            createAt
            updateAt
          }
        }
      }
    }
  }
}
    `;
function $4cdb1470f9874f96$export$83907adc10805414(baseOptions) {
    const options = {
        ...$4cdb1470f9874f96$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($4cdb1470f9874f96$export$7b2ae84d0cab029e, options);
}
const $4cdb1470f9874f96$export$1375c7a4571a3959 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateMessage($updateMessageInput: UpdateMessageInput!) {
  updateMessage(updateMessageInput: $updateMessageInput) {
    id
    text
    userId
    readDate
    createAt
    updateAt
    channelId
    attachment
    isSms
    Users {
      id
      email
      createAt
      updateAt
      languageId
      UserInformation {
        id
        userId
        createAt
        updateAt
        birthday
        lastName
        firstName
      }
    }
  }
}
    `;
function $4cdb1470f9874f96$export$ae0ec3e4f3d8ee68(baseOptions) {
    const options = {
        ...$4cdb1470f9874f96$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($4cdb1470f9874f96$export$1375c7a4571a3959, options);
}
const $4cdb1470f9874f96$export$ccc2e8c2afd81fc3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateMessages($updateMessagesInput: [UpdateMessageInput!]!) {
  updateMessages(updateMessagesInput: $updateMessagesInput) {
    id
    text
    userId
    readDate
    createAt
    updateAt
    channelId
    attachment
    isSms
    Users {
      id
      email
      createAt
      updateAt
      languageId
      UserInformation {
        id
        userId
        createAt
        updateAt
        birthday
        lastName
        firstName
      }
    }
  }
}
    `;
function $4cdb1470f9874f96$export$596c9d4fd6befeaa(baseOptions) {
    const options = {
        ...$4cdb1470f9874f96$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($4cdb1470f9874f96$export$ccc2e8c2afd81fc3, options);
}
const $4cdb1470f9874f96$export$87f33fae7bf261c6 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateMessageWithFile($createMessageWithFileInput: CreateMessageWithFileInput!) {
  createMessageWithFile(createMessageWithFileInput: $createMessageWithFileInput) {
    id
    name
    size
    s3Key
    folder
    taxYearInterviewId
    deleteAt
    uploadedBy
    deletedBy
  }
}
    `;
function $4cdb1470f9874f96$export$bdde8083ea798cb8(baseOptions) {
    const options = {
        ...$4cdb1470f9874f96$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($4cdb1470f9874f96$export$87f33fae7bf261c6, options);
}
const $4cdb1470f9874f96$export$76f570049f286661 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation sendChatMessage($createMessageInput: CreateMessageInput!) {
  createMessage(createMessageInput: $createMessageInput) {
    id
    userId
    channelId
    text
    isSms
    createAt
    updateAt
  }
}
    `;
function $4cdb1470f9874f96$export$db0dd0b0b10ee214(baseOptions) {
    const options = {
        ...$4cdb1470f9874f96$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($4cdb1470f9874f96$export$76f570049f286661, options);
}
const $4cdb1470f9874f96$export$59fd33f0a3bf7120 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation createBulkMessage($createBulkMessage: CreateBulkMessageInput!) {
  createBulkMessage(createBulkMessage: $createBulkMessage) {
    message
  }
}
    `;
function $4cdb1470f9874f96$export$95b4eb0de63a5c3f(baseOptions) {
    const options = {
        ...$4cdb1470f9874f96$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($4cdb1470f9874f96$export$59fd33f0a3bf7120, options);
}
const $4cdb1470f9874f96$export$276ba4c9784e4e81 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation createAiAgentMessage($createAiAgentMessageInput: CreateAiAgentMessageInput!) {
  createAiAgentMessage(createAiAgentMessageInput: $createAiAgentMessageInput) {
    id
    type
    text
    more
    createAt
  }
}
    `;
function $4cdb1470f9874f96$export$cb4c7b6a946a397c(baseOptions) {
    const options = {
        ...$4cdb1470f9874f96$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($4cdb1470f9874f96$export$276ba4c9784e4e81, options);
}
const $4cdb1470f9874f96$export$39ac829ab91f0716 = {
    Mutation: {
        CreateChannel: 'CreateChannel',
        UpdateMessage: 'UpdateMessage',
        UpdateMessages: 'UpdateMessages',
        CreateMessageWithFile: 'CreateMessageWithFile',
        sendChatMessage: 'sendChatMessage',
        createBulkMessage: 'createBulkMessage',
        createAiAgentMessage: 'createAiAgentMessage'
    }
};




var $d2f51651a502d078$export$b04dff55fbc80794;
var $d2f51651a502d078$export$74c0bcca122bbad9;
var $d2f51651a502d078$export$9b3b10c602d92f4e;
var $d2f51651a502d078$export$7092d0c542c03178;
var $d2f51651a502d078$export$e46fdb5cfcab5136;
var $d2f51651a502d078$export$2ee732c275691f0b;
var $d2f51651a502d078$export$5ecfc8d07b04fe06;
var $d2f51651a502d078$export$68a8ae4a08e52409;
var $d2f51651a502d078$export$7fdf7b67141cb5b2;
var $d2f51651a502d078$export$3ca4e40e14d52210;
var $d2f51651a502d078$export$7c826917df538fc7;
var $d2f51651a502d078$export$2faf482a17a1cee2;
var $d2f51651a502d078$export$256e8e2c5d45fb6b;
var $d2f51651a502d078$export$bdc51e81d1b143c9;
var $d2f51651a502d078$export$534219b709288da9;
var $d2f51651a502d078$export$81dbf6606807a243;
var $d2f51651a502d078$export$30b7d84b1e5fdac2;
var $d2f51651a502d078$export$aa3e815946b80764;
var $d2f51651a502d078$export$8bdfa8a552435f64;
var $d2f51651a502d078$export$3d6e3b984efe848c;
var $d2f51651a502d078$export$82ce2fb058198cb4;
var $d2f51651a502d078$export$8360e631d277ea4d;
var $d2f51651a502d078$export$3b5b3034b0bcdb5e;
var $d2f51651a502d078$export$70ab27996b9a0666;
var $d2f51651a502d078$export$cc1adf6fb659c762;
var $d2f51651a502d078$export$47e9855eb3c1d229;
var $d2f51651a502d078$export$b0fb565b1d072434;
var $d2f51651a502d078$export$63db5107226e48e6;
var $d2f51651a502d078$export$11be9257a49e879d;
var $d2f51651a502d078$export$ad5aef161e04a1f6;
var $d2f51651a502d078$export$7297643efb7d58a8;
var $d2f51651a502d078$export$c347cf29b438cff;
var $d2f51651a502d078$export$f300abee67487310;
var $d2f51651a502d078$export$f43c995af6d00685;
var $d2f51651a502d078$export$4560b04a56651ee;
var $d2f51651a502d078$export$4ebea898d6ffa64e;
var $d2f51651a502d078$export$9887a453d8f3cfe6;
var $d2f51651a502d078$export$b7e3ae3d7c15e42e;
var $d2f51651a502d078$export$e9e7426c00a58c12;
var $d2f51651a502d078$export$2b977f46da89854c;
var $d2f51651a502d078$export$defe85febe8b728c;
var $d2f51651a502d078$export$b83a7e5538acc1e8;
var $d2f51651a502d078$export$272a67247384d768;
var $d2f51651a502d078$export$80979908550ef2e5;
var $d2f51651a502d078$export$7ab4c9105b8f5e6e;
var $d2f51651a502d078$export$3eda300cd928ec3a;
var $d2f51651a502d078$export$523fb6203cc70ed0;
var $d2f51651a502d078$export$f11273c1b5f874e0;
var $d2f51651a502d078$export$103602e8dd00d48f;
var $d2f51651a502d078$export$d65145d0a74feea4;
var $d2f51651a502d078$export$52f405b64a820001;
var $d2f51651a502d078$export$5bb77c042e78eef1;
var $d2f51651a502d078$export$a68257abb0862e7f;
var $d2f51651a502d078$export$fadbecb2c2f910ef;
var $d2f51651a502d078$export$96427d1536b00cf2;
var $d2f51651a502d078$export$8cc0924721e82658;
var $d2f51651a502d078$export$e49b69e2917041e0;
var $d2f51651a502d078$export$6c29c21b3c676455;
var $d2f51651a502d078$export$c2cac2cad83a37e3;
var $d2f51651a502d078$export$af5e71fe29d96ba7;
var $d2f51651a502d078$export$506f99aa8a669064;
var $d2f51651a502d078$export$70fd15e1af72753e;
var $d2f51651a502d078$export$68ba3f2d27e885ee;
var $d2f51651a502d078$export$e90649b65cb8b9d0;
var $d2f51651a502d078$export$53ecd21380ae7eca;
var $d2f51651a502d078$export$1f9d3905751c630e;
var $d2f51651a502d078$export$57297741b37603f1;
var $d2f51651a502d078$export$e6d1e98eb8e73288;
var $d2f51651a502d078$export$d8bbfaecd0f57bdf;
var $d2f51651a502d078$export$4e38e526f9377acb;
var $d2f51651a502d078$export$c862890313ea649b;
var $d2f51651a502d078$export$d00e075fafbe9ae5;
var $d2f51651a502d078$export$1730555d143970d5;
var $d2f51651a502d078$export$15c87ed36e0c76b7;
var $d2f51651a502d078$export$6be8e3d3a41077a9;
var $d2f51651a502d078$export$d9acbd164c97ebb1;
var $d2f51651a502d078$export$13c0b0addd9030c8;
var $d2f51651a502d078$export$59786590dc3cfd09;
var $d2f51651a502d078$export$ab93278bfa59f297;
var $d2f51651a502d078$export$204adef05326175b;
var $d2f51651a502d078$export$ccc4f9f9a42f7b77;
var $d2f51651a502d078$export$36a781f6e8472d8;
var $d2f51651a502d078$export$d8e28e9bae5656c4;
var $d2f51651a502d078$export$4b51f83d667101f4;
var $d2f51651a502d078$export$740b0382e45ae751;
var $d2f51651a502d078$export$885d91d9d78b6eab;
var $d2f51651a502d078$export$696b0975d17cc695;
var $d2f51651a502d078$export$bedddbe6384ecea0;
var $d2f51651a502d078$export$8821ea1545299efc;
var $d2f51651a502d078$export$f43044498c8a2821;
var $d2f51651a502d078$export$1dd3a692e0000769;
var $d2f51651a502d078$export$66fb4e136dc8616c;
var $d2f51651a502d078$export$d1c5ac9cbb14e5ef;
var $d2f51651a502d078$export$d3aa43e27d236292;
var $d2f51651a502d078$export$9bb0ad579cedd7ce;
var $d2f51651a502d078$export$d29aac9c25b00cab;
$d2f51651a502d078$export$b04dff55fbc80794 = `fL6FCG_aiSwitch`;
$d2f51651a502d078$export$74c0bcca122bbad9 = `fL6FCG_aiSwitchIcon`;
$d2f51651a502d078$export$9b3b10c602d92f4e = `fL6FCG_avatarAfterBtnText`;
$d2f51651a502d078$export$7092d0c542c03178 = `fL6FCG_avatarBeforeBtnText`;
$d2f51651a502d078$export$e46fdb5cfcab5136 = `fL6FCG_avatarBtn`;
$d2f51651a502d078$export$2ee732c275691f0b = `fL6FCG_avatarMicBtn`;
$d2f51651a502d078$export$5ecfc8d07b04fe06 = `fL6FCG_avatarMicBtnRed`;
$d2f51651a502d078$export$68a8ae4a08e52409 = `fL6FCG_avatarStartConversationBtn`;
$d2f51651a502d078$export$7fdf7b67141cb5b2 = `fL6FCG_avatarStartConversationBtnCenter`;
$d2f51651a502d078$export$3ca4e40e14d52210 = `fL6FCG_avatarTextCenter`;
$d2f51651a502d078$export$7c826917df538fc7 = `fL6FCG_avatarTopText`;
$d2f51651a502d078$export$2faf482a17a1cee2 = `fL6FCG_avatarTrilaText`;
$d2f51651a502d078$export$256e8e2c5d45fb6b = `fL6FCG_blueText`;
$d2f51651a502d078$export$bdc51e81d1b143c9 = `fL6FCG_blured`;
$d2f51651a502d078$export$534219b709288da9 = `fL6FCG_btn`;
$d2f51651a502d078$export$81dbf6606807a243 = `fL6FCG_btnCollapsed`;
$d2f51651a502d078$export$30b7d84b1e5fdac2 = `fL6FCG_btnText`;
$d2f51651a502d078$export$aa3e815946b80764 = `fL6FCG_card`;
$d2f51651a502d078$export$8bdfa8a552435f64 = `fL6FCG_cardCollapsed`;
$d2f51651a502d078$export$3d6e3b984efe848c = `fL6FCG_cardMobile`;
$d2f51651a502d078$export$82ce2fb058198cb4 = `fL6FCG_cardMobileWithHeygen`;
$d2f51651a502d078$export$8360e631d277ea4d = `fL6FCG_close`;
$d2f51651a502d078$export$3b5b3034b0bcdb5e = `fL6FCG_collapseBtnIcon`;
$d2f51651a502d078$export$70ab27996b9a0666 = `fL6FCG_connectingText`;
$d2f51651a502d078$export$cc1adf6fb659c762 = `fL6FCG_controls`;
$d2f51651a502d078$export$47e9855eb3c1d229 = `fL6FCG_countDown`;
$d2f51651a502d078$export$b0fb565b1d072434 = `fL6FCG_dotty`;
$d2f51651a502d078$export$b0fb565b1d072434;
$d2f51651a502d078$export$63db5107226e48e6 = `fL6FCG_expandBtn`;
$d2f51651a502d078$export$11be9257a49e879d = `fL6FCG_expandBtnIcon`;
$d2f51651a502d078$export$ad5aef161e04a1f6 = `fL6FCG_expirationCard`;
$d2f51651a502d078$export$7297643efb7d58a8 = `fL6FCG_expirationCardDescription`;
$d2f51651a502d078$export$c347cf29b438cff = `fL6FCG_expirationCardIcon`;
$d2f51651a502d078$export$f300abee67487310 = `fL6FCG_expirationCardLink`;
$d2f51651a502d078$export$f43c995af6d00685 = `fL6FCG_heygenContainer`;
$d2f51651a502d078$export$4560b04a56651ee = `fL6FCG_heygenContainerCollapsed`;
$d2f51651a502d078$export$4ebea898d6ffa64e = `fL6FCG_heygenMobile`;
$d2f51651a502d078$export$9887a453d8f3cfe6 = `fL6FCG_heygenMobileFullScreen`;
$d2f51651a502d078$export$b7e3ae3d7c15e42e = `fL6FCG_input`;
$d2f51651a502d078$export$e9e7426c00a58c12 = `fL6FCG_interruptBtn`;
$d2f51651a502d078$export$2b977f46da89854c = `fL6FCG_interruptBtnTxt`;
$d2f51651a502d078$export$defe85febe8b728c = `fL6FCG_messages`;
$d2f51651a502d078$export$b83a7e5538acc1e8 = `fL6FCG_messagesMobile`;
$d2f51651a502d078$export$272a67247384d768 = `fL6FCG_messagesMobileWithHeygen`;
$d2f51651a502d078$export$80979908550ef2e5 = `fL6FCG_micBtn`;
$d2f51651a502d078$export$7ab4c9105b8f5e6e = `fL6FCG_micBtnAvatar`;
$d2f51651a502d078$export$3eda300cd928ec3a = `fL6FCG_micDef`;
$d2f51651a502d078$export$523fb6203cc70ed0 = `fL6FCG_micDefAvatar`;
$d2f51651a502d078$export$f11273c1b5f874e0 = `fL6FCG_micRec`;
$d2f51651a502d078$export$103602e8dd00d48f = `fL6FCG_micRecAvatar`;
$d2f51651a502d078$export$d65145d0a74feea4 = `fL6FCG_modalCard`;
$d2f51651a502d078$export$52f405b64a820001 = `fL6FCG_modalCardButton`;
$d2f51651a502d078$export$5bb77c042e78eef1 = `fL6FCG_modalCardCheckout`;
$d2f51651a502d078$export$a68257abb0862e7f = `fL6FCG_modalCardCheckoutPrimary`;
$d2f51651a502d078$export$fadbecb2c2f910ef = `fL6FCG_modalCardFeatures`;
$d2f51651a502d078$export$96427d1536b00cf2 = `fL6FCG_modalCardFeaturesBasicCheck`;
$d2f51651a502d078$export$8cc0924721e82658 = `fL6FCG_modalCardFeaturesLine`;
$d2f51651a502d078$export$e49b69e2917041e0 = `fL6FCG_modalCardFeaturesPremiumCheck`;
$d2f51651a502d078$export$6c29c21b3c676455 = `fL6FCG_modalCardFeaturesPremiumCheckDark`;
$d2f51651a502d078$export$c2cac2cad83a37e3 = `fL6FCG_modalCardPrimary`;
$d2f51651a502d078$export$af5e71fe29d96ba7 = `fL6FCG_modalCardTitle`;
$d2f51651a502d078$export$506f99aa8a669064 = `fL6FCG_modalCheckoutContent`;
$d2f51651a502d078$export$70fd15e1af72753e = `fL6FCG_modalCheckoutFeaturesBasicCheck`;
$d2f51651a502d078$export$68ba3f2d27e885ee = `fL6FCG_modalCheckoutFeaturesContent`;
$d2f51651a502d078$export$e90649b65cb8b9d0 = `fL6FCG_modalCheckoutFeaturesLine`;
$d2f51651a502d078$export$53ecd21380ae7eca = `fL6FCG_modalCheckoutFeaturesPremiumCheckDark`;
$d2f51651a502d078$export$1f9d3905751c630e = `fL6FCG_modalCheckoutFeaturesTitle`;
$d2f51651a502d078$export$57297741b37603f1 = `fL6FCG_modalNavDefault`;
$d2f51651a502d078$export$e6d1e98eb8e73288 = `fL6FCG_modalNavPrimary`;
$d2f51651a502d078$export$d8bbfaecd0f57bdf = `fL6FCG_msg`;
$d2f51651a502d078$export$4e38e526f9377acb = `fL6FCG_msgAssistant`;
$d2f51651a502d078$export$c862890313ea649b = `fL6FCG_msgCopy`;
$d2f51651a502d078$export$d00e075fafbe9ae5 = `fL6FCG_msgCopyIcon`;
$d2f51651a502d078$export$1730555d143970d5 = `fL6FCG_msgSpecial`;
$d2f51651a502d078$export$15c87ed36e0c76b7 = `fL6FCG_msgText`;
$d2f51651a502d078$export$6be8e3d3a41077a9 = `fL6FCG_msgTime`;
$d2f51651a502d078$export$d9acbd164c97ebb1 = `fL6FCG_msgUser`;
$d2f51651a502d078$export$13c0b0addd9030c8 = `fL6FCG_poweredBy`;
$d2f51651a502d078$export$59786590dc3cfd09 = `fL6FCG_poweredByCompanyName`;
$d2f51651a502d078$export$ab93278bfa59f297 = `fL6FCG_poweredByCompanyNameWhite`;
$d2f51651a502d078$export$204adef05326175b = `fL6FCG_poweredByIcon`;
$d2f51651a502d078$export$ccc4f9f9a42f7b77 = `fL6FCG_poweredByIconWhite`;
$d2f51651a502d078$export$36a781f6e8472d8 = `fL6FCG_poweredByModal`;
$d2f51651a502d078$export$d8e28e9bae5656c4 = `fL6FCG_poweredByWhite`;
$d2f51651a502d078$export$4b51f83d667101f4 = `fL6FCG_promptIdeasCard`;
$d2f51651a502d078$export$740b0382e45ae751 = `fL6FCG_promptIdeasIcon`;
$d2f51651a502d078$export$885d91d9d78b6eab = `fL6FCG_promptIdeasRow`;
$d2f51651a502d078$export$696b0975d17cc695 = `fL6FCG_quoteIcon`;
$d2f51651a502d078$export$bedddbe6384ecea0 = `fL6FCG_sendBtn`;
$d2f51651a502d078$export$8821ea1545299efc = `fL6FCG_sendIcon`;
$d2f51651a502d078$export$f43044498c8a2821 = `fL6FCG_titleIconContainer`;
$d2f51651a502d078$export$1dd3a692e0000769 = `fL6FCG_videoContainer`;
$d2f51651a502d078$export$66fb4e136dc8616c = `fL6FCG_videoContainerMobile`;
$d2f51651a502d078$export$d1c5ac9cbb14e5ef = `fL6FCG_volumeControl`;
$d2f51651a502d078$export$d3aa43e27d236292 = `fL6FCG_volumeControlIcon`;
$d2f51651a502d078$export$9bb0ad579cedd7ce = `fL6FCG_volumeControlSlider`;
$d2f51651a502d078$export$d29aac9c25b00cab = `fL6FCG_whiteText`;



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c62b475e31b1e858$export$a143d493d941bafc;
var $c62b475e31b1e858$export$e4cf37d7f6fb9e0a;
var $c62b475e31b1e858$export$f99ded8fe4b79145;
var $c62b475e31b1e858$export$599f31c3813fae4d;
'use strict';
var $e1b48b12c9564061$export$a48f0734ac7c2329;
var $e1b48b12c9564061$export$d622b2ad8d90c771;
var $e1b48b12c9564061$export$6100ba28696e12de;
'use strict';
$e1b48b12c9564061$export$a48f0734ac7c2329 = $e1b48b12c9564061$var$byteLength;
$e1b48b12c9564061$export$d622b2ad8d90c771 = $e1b48b12c9564061$var$toByteArray;
$e1b48b12c9564061$export$6100ba28696e12de = $e1b48b12c9564061$var$fromByteArray;
var $e1b48b12c9564061$var$lookup = [];
var $e1b48b12c9564061$var$revLookup = [];
var $e1b48b12c9564061$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $e1b48b12c9564061$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $e1b48b12c9564061$var$i = 0, $e1b48b12c9564061$var$len = $e1b48b12c9564061$var$code.length; $e1b48b12c9564061$var$i < $e1b48b12c9564061$var$len; ++$e1b48b12c9564061$var$i){
    $e1b48b12c9564061$var$lookup[$e1b48b12c9564061$var$i] = $e1b48b12c9564061$var$code[$e1b48b12c9564061$var$i];
    $e1b48b12c9564061$var$revLookup[$e1b48b12c9564061$var$code.charCodeAt($e1b48b12c9564061$var$i)] = $e1b48b12c9564061$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$e1b48b12c9564061$var$revLookup['-'.charCodeAt(0)] = 62;
$e1b48b12c9564061$var$revLookup['_'.charCodeAt(0)] = 63;
function $e1b48b12c9564061$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $e1b48b12c9564061$var$byteLength(b64) {
    var lens = $e1b48b12c9564061$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e1b48b12c9564061$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e1b48b12c9564061$var$toByteArray(b64) {
    var tmp;
    var lens = $e1b48b12c9564061$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $e1b48b12c9564061$var$Arr($e1b48b12c9564061$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $e1b48b12c9564061$var$revLookup[b64.charCodeAt(i)] << 18 | $e1b48b12c9564061$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $e1b48b12c9564061$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $e1b48b12c9564061$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $e1b48b12c9564061$var$revLookup[b64.charCodeAt(i)] << 2 | $e1b48b12c9564061$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $e1b48b12c9564061$var$revLookup[b64.charCodeAt(i)] << 10 | $e1b48b12c9564061$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $e1b48b12c9564061$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $e1b48b12c9564061$var$tripletToBase64(num) {
    return $e1b48b12c9564061$var$lookup[num >> 18 & 0x3F] + $e1b48b12c9564061$var$lookup[num >> 12 & 0x3F] + $e1b48b12c9564061$var$lookup[num >> 6 & 0x3F] + $e1b48b12c9564061$var$lookup[num & 0x3F];
}
function $e1b48b12c9564061$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($e1b48b12c9564061$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $e1b48b12c9564061$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($e1b48b12c9564061$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($e1b48b12c9564061$var$lookup[tmp >> 2] + $e1b48b12c9564061$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($e1b48b12c9564061$var$lookup[tmp >> 10] + $e1b48b12c9564061$var$lookup[tmp >> 4 & 0x3F] + $e1b48b12c9564061$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $b5ced64c37f0a05b$export$aafa59e2e03f2942;
var $b5ced64c37f0a05b$export$68d8715fc104d294;
$b5ced64c37f0a05b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$b5ced64c37f0a05b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $c62b475e31b1e858$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$c62b475e31b1e858$export$a143d493d941bafc = $c62b475e31b1e858$var$Buffer;
$c62b475e31b1e858$export$e4cf37d7f6fb9e0a = $c62b475e31b1e858$var$SlowBuffer;
$c62b475e31b1e858$export$f99ded8fe4b79145 = 50;
const $c62b475e31b1e858$var$K_MAX_LENGTH = 0x7fffffff;
$c62b475e31b1e858$export$599f31c3813fae4d = $c62b475e31b1e858$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c62b475e31b1e858$var$Buffer.TYPED_ARRAY_SUPPORT = $c62b475e31b1e858$var$typedArraySupport();
if (!$c62b475e31b1e858$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c62b475e31b1e858$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c62b475e31b1e858$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$c62b475e31b1e858$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c62b475e31b1e858$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$c62b475e31b1e858$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c62b475e31b1e858$var$createBuffer(length) {
    if (length > $c62b475e31b1e858$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c62b475e31b1e858$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c62b475e31b1e858$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c62b475e31b1e858$var$allocUnsafe(arg);
    }
    return $c62b475e31b1e858$var$from(arg, encodingOrOffset, length);
}
$c62b475e31b1e858$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c62b475e31b1e858$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $c62b475e31b1e858$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c62b475e31b1e858$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c62b475e31b1e858$var$isInstance(value, ArrayBuffer) || value && $c62b475e31b1e858$var$isInstance(value.buffer, ArrayBuffer)) return $c62b475e31b1e858$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($c62b475e31b1e858$var$isInstance(value, SharedArrayBuffer) || value && $c62b475e31b1e858$var$isInstance(value.buffer, SharedArrayBuffer))) return $c62b475e31b1e858$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c62b475e31b1e858$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $c62b475e31b1e858$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $c62b475e31b1e858$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c62b475e31b1e858$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c62b475e31b1e858$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c62b475e31b1e858$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c62b475e31b1e858$var$Buffer, Uint8Array);
function $c62b475e31b1e858$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c62b475e31b1e858$var$alloc(size, fill, encoding) {
    $c62b475e31b1e858$var$assertSize(size);
    if (size <= 0) return $c62b475e31b1e858$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $c62b475e31b1e858$var$createBuffer(size).fill(fill, encoding) : $c62b475e31b1e858$var$createBuffer(size).fill(fill);
    return $c62b475e31b1e858$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c62b475e31b1e858$var$Buffer.alloc = function(size, fill, encoding) {
    return $c62b475e31b1e858$var$alloc(size, fill, encoding);
};
function $c62b475e31b1e858$var$allocUnsafe(size) {
    $c62b475e31b1e858$var$assertSize(size);
    return $c62b475e31b1e858$var$createBuffer(size < 0 ? 0 : $c62b475e31b1e858$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c62b475e31b1e858$var$Buffer.allocUnsafe = function(size) {
    return $c62b475e31b1e858$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c62b475e31b1e858$var$Buffer.allocUnsafeSlow = function(size) {
    return $c62b475e31b1e858$var$allocUnsafe(size);
};
function $c62b475e31b1e858$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$c62b475e31b1e858$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $c62b475e31b1e858$var$byteLength(string, encoding) | 0;
    let buf = $c62b475e31b1e858$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c62b475e31b1e858$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $c62b475e31b1e858$var$checked(array.length) | 0;
    const buf = $c62b475e31b1e858$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c62b475e31b1e858$var$fromArrayView(arrayView) {
    if ($c62b475e31b1e858$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $c62b475e31b1e858$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c62b475e31b1e858$var$fromArrayLike(arrayView);
}
function $c62b475e31b1e858$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c62b475e31b1e858$var$Buffer.prototype);
    return buf;
}
function $c62b475e31b1e858$var$fromObject(obj) {
    if ($c62b475e31b1e858$var$Buffer.isBuffer(obj)) {
        const len = $c62b475e31b1e858$var$checked(obj.length) | 0;
        const buf = $c62b475e31b1e858$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $c62b475e31b1e858$var$numberIsNaN(obj.length)) return $c62b475e31b1e858$var$createBuffer(0);
        return $c62b475e31b1e858$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $c62b475e31b1e858$var$fromArrayLike(obj.data);
}
function $c62b475e31b1e858$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c62b475e31b1e858$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c62b475e31b1e858$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $c62b475e31b1e858$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c62b475e31b1e858$var$Buffer.alloc(+length);
}
$c62b475e31b1e858$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c62b475e31b1e858$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c62b475e31b1e858$var$Buffer.compare = function compare(a, b) {
    if ($c62b475e31b1e858$var$isInstance(a, Uint8Array)) a = $c62b475e31b1e858$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c62b475e31b1e858$var$isInstance(b, Uint8Array)) b = $c62b475e31b1e858$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c62b475e31b1e858$var$Buffer.isBuffer(a) || !$c62b475e31b1e858$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c62b475e31b1e858$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$c62b475e31b1e858$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c62b475e31b1e858$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $c62b475e31b1e858$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($c62b475e31b1e858$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$c62b475e31b1e858$var$Buffer.isBuffer(buf)) buf = $c62b475e31b1e858$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c62b475e31b1e858$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c62b475e31b1e858$var$byteLength(string, encoding) {
    if ($c62b475e31b1e858$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c62b475e31b1e858$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $c62b475e31b1e858$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $c62b475e31b1e858$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c62b475e31b1e858$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c62b475e31b1e858$var$Buffer.byteLength = $c62b475e31b1e858$var$byteLength;
function $c62b475e31b1e858$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $c62b475e31b1e858$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $c62b475e31b1e858$var$utf8Slice(this, start, end);
        case 'ascii':
            return $c62b475e31b1e858$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $c62b475e31b1e858$var$latin1Slice(this, start, end);
        case 'base64':
            return $c62b475e31b1e858$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c62b475e31b1e858$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c62b475e31b1e858$var$Buffer.prototype._isBuffer = true;
function $c62b475e31b1e858$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c62b475e31b1e858$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$c62b475e31b1e858$var$swap(this, i, i + 1);
    return this;
};
$c62b475e31b1e858$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $c62b475e31b1e858$var$swap(this, i, i + 3);
        $c62b475e31b1e858$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c62b475e31b1e858$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $c62b475e31b1e858$var$swap(this, i, i + 7);
        $c62b475e31b1e858$var$swap(this, i + 1, i + 6);
        $c62b475e31b1e858$var$swap(this, i + 2, i + 5);
        $c62b475e31b1e858$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c62b475e31b1e858$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $c62b475e31b1e858$var$utf8Slice(this, 0, length);
    return $c62b475e31b1e858$var$slowToString.apply(this, arguments);
};
$c62b475e31b1e858$var$Buffer.prototype.toLocaleString = $c62b475e31b1e858$var$Buffer.prototype.toString;
$c62b475e31b1e858$var$Buffer.prototype.equals = function equals(b) {
    if (!$c62b475e31b1e858$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $c62b475e31b1e858$var$Buffer.compare(this, b) === 0;
};
$c62b475e31b1e858$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $c62b475e31b1e858$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($c62b475e31b1e858$var$customInspectSymbol) $c62b475e31b1e858$var$Buffer.prototype[$c62b475e31b1e858$var$customInspectSymbol] = $c62b475e31b1e858$var$Buffer.prototype.inspect;
$c62b475e31b1e858$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c62b475e31b1e858$var$isInstance(target, Uint8Array)) target = $c62b475e31b1e858$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c62b475e31b1e858$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c62b475e31b1e858$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c62b475e31b1e858$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $c62b475e31b1e858$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c62b475e31b1e858$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c62b475e31b1e858$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c62b475e31b1e858$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $c62b475e31b1e858$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c62b475e31b1e858$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c62b475e31b1e858$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c62b475e31b1e858$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c62b475e31b1e858$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c62b475e31b1e858$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c62b475e31b1e858$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c62b475e31b1e858$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c62b475e31b1e858$var$utf8Write(buf, string, offset, length) {
    return $c62b475e31b1e858$var$blitBuffer($c62b475e31b1e858$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c62b475e31b1e858$var$asciiWrite(buf, string, offset, length) {
    return $c62b475e31b1e858$var$blitBuffer($c62b475e31b1e858$var$asciiToBytes(string), buf, offset, length);
}
function $c62b475e31b1e858$var$base64Write(buf, string, offset, length) {
    return $c62b475e31b1e858$var$blitBuffer($c62b475e31b1e858$var$base64ToBytes(string), buf, offset, length);
}
function $c62b475e31b1e858$var$ucs2Write(buf, string, offset, length) {
    return $c62b475e31b1e858$var$blitBuffer($c62b475e31b1e858$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c62b475e31b1e858$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $c62b475e31b1e858$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $c62b475e31b1e858$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $c62b475e31b1e858$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $c62b475e31b1e858$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c62b475e31b1e858$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c62b475e31b1e858$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c62b475e31b1e858$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $e1b48b12c9564061$export$6100ba28696e12de(buf);
    else return $e1b48b12c9564061$export$6100ba28696e12de(buf.slice(start, end));
}
function $c62b475e31b1e858$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c62b475e31b1e858$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $c62b475e31b1e858$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c62b475e31b1e858$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $c62b475e31b1e858$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c62b475e31b1e858$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c62b475e31b1e858$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c62b475e31b1e858$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c62b475e31b1e858$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $c62b475e31b1e858$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c62b475e31b1e858$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c62b475e31b1e858$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c62b475e31b1e858$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c62b475e31b1e858$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$c62b475e31b1e858$var$Buffer.prototype.readUintLE = $c62b475e31b1e858$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c62b475e31b1e858$var$Buffer.prototype.readUintBE = $c62b475e31b1e858$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c62b475e31b1e858$var$Buffer.prototype.readUint8 = $c62b475e31b1e858$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c62b475e31b1e858$var$Buffer.prototype.readUint16LE = $c62b475e31b1e858$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c62b475e31b1e858$var$Buffer.prototype.readUint16BE = $c62b475e31b1e858$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c62b475e31b1e858$var$Buffer.prototype.readUint32LE = $c62b475e31b1e858$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c62b475e31b1e858$var$Buffer.prototype.readUint32BE = $c62b475e31b1e858$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c62b475e31b1e858$var$Buffer.prototype.readBigUInt64LE = $c62b475e31b1e858$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $c62b475e31b1e858$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c62b475e31b1e858$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$c62b475e31b1e858$var$Buffer.prototype.readBigUInt64BE = $c62b475e31b1e858$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $c62b475e31b1e858$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c62b475e31b1e858$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$c62b475e31b1e858$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c62b475e31b1e858$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c62b475e31b1e858$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c62b475e31b1e858$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c62b475e31b1e858$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c62b475e31b1e858$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c62b475e31b1e858$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c62b475e31b1e858$var$Buffer.prototype.readBigInt64LE = $c62b475e31b1e858$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $c62b475e31b1e858$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c62b475e31b1e858$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$c62b475e31b1e858$var$Buffer.prototype.readBigInt64BE = $c62b475e31b1e858$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $c62b475e31b1e858$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c62b475e31b1e858$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$c62b475e31b1e858$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, 4, this.length);
    return $b5ced64c37f0a05b$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$c62b475e31b1e858$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, 4, this.length);
    return $b5ced64c37f0a05b$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$c62b475e31b1e858$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, 8, this.length);
    return $b5ced64c37f0a05b$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$c62b475e31b1e858$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkOffset(offset, 8, this.length);
    return $b5ced64c37f0a05b$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $c62b475e31b1e858$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c62b475e31b1e858$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$c62b475e31b1e858$var$Buffer.prototype.writeUintLE = $c62b475e31b1e858$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c62b475e31b1e858$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c62b475e31b1e858$var$Buffer.prototype.writeUintBE = $c62b475e31b1e858$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c62b475e31b1e858$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c62b475e31b1e858$var$Buffer.prototype.writeUint8 = $c62b475e31b1e858$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c62b475e31b1e858$var$Buffer.prototype.writeUint16LE = $c62b475e31b1e858$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c62b475e31b1e858$var$Buffer.prototype.writeUint16BE = $c62b475e31b1e858$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c62b475e31b1e858$var$Buffer.prototype.writeUint32LE = $c62b475e31b1e858$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c62b475e31b1e858$var$Buffer.prototype.writeUint32BE = $c62b475e31b1e858$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c62b475e31b1e858$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $c62b475e31b1e858$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $c62b475e31b1e858$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $c62b475e31b1e858$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$c62b475e31b1e858$var$Buffer.prototype.writeBigUInt64LE = $c62b475e31b1e858$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $c62b475e31b1e858$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$c62b475e31b1e858$var$Buffer.prototype.writeBigUInt64BE = $c62b475e31b1e858$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $c62b475e31b1e858$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$c62b475e31b1e858$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c62b475e31b1e858$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c62b475e31b1e858$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c62b475e31b1e858$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c62b475e31b1e858$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c62b475e31b1e858$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c62b475e31b1e858$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c62b475e31b1e858$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c62b475e31b1e858$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c62b475e31b1e858$var$Buffer.prototype.writeBigInt64LE = $c62b475e31b1e858$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $c62b475e31b1e858$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$c62b475e31b1e858$var$Buffer.prototype.writeBigInt64BE = $c62b475e31b1e858$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $c62b475e31b1e858$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $c62b475e31b1e858$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $c62b475e31b1e858$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $b5ced64c37f0a05b$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c62b475e31b1e858$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c62b475e31b1e858$var$writeFloat(this, value, offset, true, noAssert);
};
$c62b475e31b1e858$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c62b475e31b1e858$var$writeFloat(this, value, offset, false, noAssert);
};
function $c62b475e31b1e858$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c62b475e31b1e858$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $b5ced64c37f0a05b$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c62b475e31b1e858$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c62b475e31b1e858$var$writeDouble(this, value, offset, true, noAssert);
};
$c62b475e31b1e858$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c62b475e31b1e858$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c62b475e31b1e858$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c62b475e31b1e858$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c62b475e31b1e858$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$c62b475e31b1e858$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $c62b475e31b1e858$var$Buffer.isBuffer(val) ? val : $c62b475e31b1e858$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $c62b475e31b1e858$var$errors = {};
function $c62b475e31b1e858$var$E(sym, getMessage, Base) {
    $c62b475e31b1e858$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$c62b475e31b1e858$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$c62b475e31b1e858$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$c62b475e31b1e858$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $c62b475e31b1e858$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $c62b475e31b1e858$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $c62b475e31b1e858$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $c62b475e31b1e858$var$checkBounds(buf, offset, byteLength) {
    $c62b475e31b1e858$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $c62b475e31b1e858$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $c62b475e31b1e858$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $c62b475e31b1e858$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $c62b475e31b1e858$var$checkBounds(buf, offset, byteLength);
}
function $c62b475e31b1e858$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $c62b475e31b1e858$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $c62b475e31b1e858$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $c62b475e31b1e858$var$validateNumber(value, type);
        throw new $c62b475e31b1e858$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $c62b475e31b1e858$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $c62b475e31b1e858$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $c62b475e31b1e858$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c62b475e31b1e858$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c62b475e31b1e858$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $c62b475e31b1e858$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $c62b475e31b1e858$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c62b475e31b1e858$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c62b475e31b1e858$var$base64ToBytes(str) {
    return $e1b48b12c9564061$export$d622b2ad8d90c771($c62b475e31b1e858$var$base64clean(str));
}
function $c62b475e31b1e858$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c62b475e31b1e858$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c62b475e31b1e858$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $c62b475e31b1e858$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $c62b475e31b1e858$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $c62b475e31b1e858$var$BufferBigIntNotDefined : fn;
}
function $c62b475e31b1e858$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $956da5db9c582e0d$require$Buffer = $c62b475e31b1e858$export$a143d493d941bafc;
const $956da5db9c582e0d$var$BUFFER_SIZE = 4800;
const $956da5db9c582e0d$export$64304a959a419066 = 'data:image/jpeg;base64,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';
const $956da5db9c582e0d$export$86ec516c1fbe5c5a = 'data:image/jpeg;base64,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';
// https://github.com/parcel-bundler/parcel/issues/1093
const $956da5db9c582e0d$export$c7b96970ddc28cad = `
  const MIN_INT16 = -0x8000;
  const MAX_INT16 = 0x7fff;
  class PCMAudioProcessor extends AudioWorkletProcessor {
    constructor() {
      super();
    }

    process(inputs, outputs, parameters) {
      const input = inputs[0];
      if (input.length > 0) {
        const float32Buffer = input[0];
        const int16Buffer = this.float32ToInt16(float32Buffer);
        this.port.postMessage(int16Buffer);
      }
      return true;
    }

    float32ToInt16(float32Array) {
      const int16Array = new Int16Array(float32Array.length);
      for (let i = 0; i < float32Array.length; i++) {
        let val = Math.floor(float32Array[i] * MAX_INT16);
        val = Math.max(MIN_INT16, Math.min(MAX_INT16, val));
        int16Array[i] = val;
      }
      return int16Array;
    }
  }
  registerProcessor("audio-processor-worklet", PCMAudioProcessor);
`;
const $956da5db9c582e0d$export$f8367b7c5d4d854f = (accessToken, connectionReady, connectionError, tanscriptionReceived, isProcessing, onHeygenStart, onHeygenStop, onError, onClose)=>{
    const ws = new WebSocket((0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).agentApiUrl, [
        accessToken
    ]);
    ws.onopen = ()=>{
        console.log('ws connected');
    };
    ws.onmessage = (msg)=>{
        // console.log('ws message', msg);
        const message = JSON.parse(msg.data);
        if (message?.event === 'connection_established') connectionReady(message.data);
        else if (message?.event === 'connection_error') connectionError();
        else if (message?.event === 'transcription') tanscriptionReceived(message.data);
        else if (message?.event === 'processing') isProcessing(message.data);
        else if (message?.event === 'heygen_start') {
            const { token: token, avatarId: avatarId, voiceId: voiceId, secondsLeft: secondsLeft } = message.data;
            onHeygenStart(token, avatarId, voiceId, secondsLeft);
        } else if (message?.event === 'heygen_stop') onHeygenStop();
        else if (message?.event === 'error') onError(message.data);
    };
    ws.onclose = ()=>{
        console.log('ws disconnected');
        onClose();
    };
    ws.onerror = (error)=>{
        console.error('ws error:', error);
        connectionError();
    };
    return ws;
};
const $956da5db9c582e0d$export$7fc7650fb852f56e = (buffer, data, ws)=>{
    const newData = new Uint8Array(data);
    const buff = new Uint8Array(buffer.length + newData.length);
    buff.set(buffer);
    buff.set(newData, buffer.length);
    if (buff.length >= $956da5db9c582e0d$var$BUFFER_SIZE && ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify({
            event: 'audio',
            data: $956da5db9c582e0d$require$Buffer.from(buff.slice(0, $956da5db9c582e0d$var$BUFFER_SIZE)).toString('base64')
        }));
        return buff.slice($956da5db9c582e0d$var$BUFFER_SIZE);
    }
    return buff;
};



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $cfbe79ca3d88a2b9$var$SvgVolume = (props)=>/*#__PURE__*/ (0, $bb3TF.jsx)("svg", {
        width: 15,
        height: 13,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
            d: "M12.506.825C14.027 2.163 15 4.21 15 6.5s-.973 4.334-2.494 5.675a.534.534 0 0 1-.792-.089.645.645 0 0 1 .082-.858c1.27-1.117 2.079-2.818 2.079-4.728 0-1.91-.809-3.61-2.079-4.73a.647.647 0 0 1-.082-.858c.195-.262.55-.3.792-.09v.003Zm-1.418 1.892c1.013.894 1.662 2.257 1.662 3.783 0 1.526-.65 2.89-1.662 3.783a.534.534 0 0 1-.792-.088.644.644 0 0 1 .082-.859c.762-.67 1.247-1.69 1.247-2.836 0-1.145-.485-2.166-1.247-2.838a.647.647 0 0 1-.082-.859c.195-.261.55-.3.792-.089v.003ZM9.67 4.609c.504.446.83 1.127.83 1.891s-.326 1.445-.83 1.892a.534.534 0 0 1-.792-.09.645.645 0 0 1 .082-.857c.253-.224.415-.564.415-.945 0-.38-.162-.72-.415-.947a.647.647 0 0 1-.082-.858c.195-.262.55-.3.792-.089v.003ZM7.057.884a.82.82 0 0 1 .443.741v9.75a.82.82 0 0 1-.443.742.704.704 0 0 1-.806-.135L3.089 8.938H1.5c-.827 0-1.5-.729-1.5-1.625V5.688c0-.897.673-1.625 1.5-1.625h1.59l3.16-3.045a.708.708 0 0 1 .807-.134Z",
            fill: "#F8F8F8"
        })
    });
var $cfbe79ca3d88a2b9$export$2e2bcd8739ae039 = $cfbe79ca3d88a2b9$var$SvgVolume;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $0dd5d02c96029bc1$var$SvgExpand = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        width: 17,
        height: 17,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M8.5 2.125H3.542a1.417 1.417 0 0 0-1.417 1.417v9.916a1.417 1.417 0 0 0 1.417 1.417h9.916a1.417 1.417 0 0 0 1.417-1.417V8.5",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M9.917 10.625H6.375V7.083M11.332 2.125h3.542v3.542M14.875 2.125l-8.5 8.5",
                stroke: "#fff",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $0dd5d02c96029bc1$export$2e2bcd8739ae039 = $0dd5d02c96029bc1$var$SvgExpand;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $9930258c6346eaf1$var$SvgCollapse = (props)=>/*#__PURE__*/ (0, $bb3TF.jsx)("svg", {
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
            d: "M13.333 5v5A3.333 3.333 0 0 1 10 13.333H5M35.001 13.333h-5A3.333 3.333 0 0 1 26.668 10V5M5 26.667h5A3.333 3.333 0 0 1 13.333 30v5M26.668 35v-5a3.333 3.333 0 0 1 3.333-3.333h5",
            stroke: "#fff",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $9930258c6346eaf1$export$2e2bcd8739ae039 = $9930258c6346eaf1$var$SvgCollapse;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $3c5d28b869b30cc8$var$SvgWorkforce = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        width: 24,
        height: 24,
        fill: "#111",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 9.231,
                cy: 9.231,
                r: 1.846
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 14.769,
                cy: 9.231,
                r: 1.846
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 14.769,
                cy: 14.768,
                r: 1.846
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 9.231,
                cy: 14.768,
                r: 1.846
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 4.308,
                cy: 14.77,
                r: 1.231
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 4.308,
                cy: 9.231,
                r: 1.231
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 4.308,
                cy: 4.307,
                r: 1.231
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 19.693,
                cy: 4.309,
                r: 1.231
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 19.693,
                cy: 19.692,
                r: 1.231
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 4.308,
                cy: 19.692,
                r: 1.231
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 9.231,
                cy: 4.307,
                r: 1.231
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 14.769,
                cy: 4.309,
                r: 1.231
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 19.693,
                cy: 9.231,
                r: 1.231
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 19.693,
                cy: 14.77,
                r: 1.231
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 14.769,
                cy: 19.692,
                r: 1.231
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 9.231,
                cy: 19.692,
                r: 1.231
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 9.231,
                cy: 23.385,
                r: 0.615
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 14.77,
                cy: 23.385,
                r: 0.615
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 23.385,
                cy: 14.77,
                r: 0.615
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 23.385,
                cy: 9.231,
                r: 0.615
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 14.77,
                cy: 0.615,
                r: 0.615
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 9.231,
                cy: 0.615,
                r: 0.615
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 0.615,
                cy: 9.231,
                r: 0.615
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                cx: 0.615,
                cy: 14.77,
                r: 0.615
            })
        ]
    });
var $3c5d28b869b30cc8$export$2e2bcd8739ae039 = $3c5d28b869b30cc8$var$SvgWorkforce;






const { Text: $ae1f3cf505f9c39c$var$Text, Link: $ae1f3cf505f9c39c$var$Link } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $ae1f3cf505f9c39c$var$HeygenAvatar = ({ token: token, avatarId: avatarId, voiceId: voiceId, secondsLeft: secondsLeft, setSteamingAvatar: setSteamingAvatar, heygenStreamStart: heygenStreamStart, setFullscreenAvatar: setFullscreenAvatar, isTrialUsageLimitExceeded: isTrialUsageLimitExceeded, isHeygenUsageLimitExceeded: isHeygenUsageLimitExceeded, isHeygenLoading: isHeygenLoading, planType: planType, isRecording: isRecording, isRecordingLoading: isRecordingLoading, toggleRecording: toggleRecording })=>{
    const [isLoadingSession, setIsLoadingSession] = (0, $6fFrj.useState)(false);
    const [isFullScreen, setIsFullScreen] = (0, $6fFrj.useState)(false);
    const [sessionId, setSessionId] = (0, $6fFrj.useState)();
    const [stream, setStream] = (0, $6fFrj.useState)();
    const [volume, setVolume] = (0, $6fFrj.useState)(100);
    const [secondsRemaining, setSecondsRemaining] = (0, $6fFrj.useState)(secondsLeft);
    const videoElementRef = (0, $6fFrj.useRef)();
    const avatar = (0, $6fFrj.useRef)();
    let countDownInt = 0;
    const secondsToTime = (seconds)=>{
        const h = Math.floor(seconds / 3600).toString().padStart(2, '0');
        const m = Math.floor(seconds % 3600 / 60).toString().padStart(2, '0');
        const s = Math.floor(seconds % 60).toString().padStart(2, '0');
        return `${h}:${m}:${s}`;
    };
    const startSession = async ()=>{
        try {
            // console.log('Starting session with token:', token);
            setIsLoadingSession(true);
            avatar.current = new (0, $0fce50c6ae590ce1$export$2e2bcd8739ae039)({
                token: token
            });
            avatar.current?.on((0, $0fce50c6ae590ce1$export$1a7aeeed4753a2c0).STREAM_READY, (event)=>{
                setStream(event.detail);
                videoElementRef.current?.classList.remove($d2f51651a502d078$export$bdc51e81d1b143c9);
                clearInterval(countDownInt);
                countDownInt = window.setInterval(()=>setSecondsRemaining((sec)=>sec - 1), 1000);
            });
            avatar.current?.on((0, $0fce50c6ae590ce1$export$1a7aeeed4753a2c0).STREAM_DISCONNECTED, ()=>{
                videoElementRef.current?.classList.add($d2f51651a502d078$export$bdc51e81d1b143c9);
                setStream(undefined);
                avatar.current = null;
                clearInterval(countDownInt);
            });
            const { session_id: currentSessionId } = await avatar.current.createStartAvatar({
                quality: (0, $0fce50c6ae590ce1$export$f8e9e2a4a1e2cea5).Medium,
                avatarName: avatarId,
                voice: {
                    voiceId: voiceId
                },
                language: 'en'
            });
            setSessionId(currentSessionId);
            setIsLoadingSession(false);
        } catch (error) {
            setIsLoadingSession(false);
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message, 10);
        }
    };
    (0, $6fFrj.useEffect)(()=>{
        if (token) startSession();
        else clearInterval(countDownInt);
        return ()=>{
            avatar.current = null;
            setStream(undefined);
            setSessionId(undefined);
        };
    }, [
        token
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (stream && videoElementRef.current) {
            videoElementRef.current.srcObject = stream;
            videoElementRef.current.onloadedmetadata = ()=>{
                videoElementRef.current.play();
            };
        }
    }, [
        videoElementRef,
        stream
    ]);
    (0, $6fFrj.useEffect)(()=>{
        setSecondsRemaining(secondsLeft);
    }, [
        secondsLeft
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (sessionId) setSteamingAvatar(avatar.current, sessionId);
    }, [
        sessionId
    ]);
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)("video", {
                className: (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? $d2f51651a502d078$export$66fb4e136dc8616c : $d2f51651a502d078$export$1dd3a692e0000769,
                ref: videoElementRef,
                playsInline: true,
                poster: (0, $956da5db9c582e0d$export$86ec516c1fbe5c5a),
                onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).err(err),
                children: (0, $bb3TF.jsx)("track", {
                    kind: "captions",
                    label: "English",
                    default: true
                })
            }),
            stream && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                children: [
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: [
                            $d2f51651a502d078$export$e46fdb5cfcab5136,
                            $d2f51651a502d078$export$d1c5ac9cbb14e5ef
                        ],
                        justify: "center",
                        children: [
                            (0, $bb3TF.jsx)((0, $cfbe79ca3d88a2b9$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$d3aa43e27d236292
                            }),
                            (0, $bb3TF.jsx)((0, $57c08ab8caa428cc$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$9bb0ad579cedd7ce,
                                vertical: true,
                                step: 10,
                                value: volume,
                                onChange: (val)=>{
                                    setVolume(val);
                                    if (videoElementRef.current) videoElementRef.current.volume = val / 100;
                                },
                                handleStyle: {
                                    width: '11px',
                                    height: '11px',
                                    backgroundColor: '#fff',
                                    border: '1px solid #fff'
                                },
                                trackStyle: {
                                    background: '#fff',
                                    width: '1px'
                                },
                                railStyle: {
                                    background: '#999',
                                    width: '1px'
                                }
                            })
                        ]
                    }),
                    (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        type: "default",
                        shape: "round",
                        onClick: ()=>avatar.current?.interrupt(),
                        className: [
                            $d2f51651a502d078$export$e46fdb5cfcab5136,
                            $d2f51651a502d078$export$e9e7426c00a58c12
                        ],
                        children: (0, $bb3TF.jsx)($ae1f3cf505f9c39c$var$Text, {
                            className: $d2f51651a502d078$export$2b977f46da89854c,
                            children: "Interrupt"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        shape: "circle",
                        className: isRecording ? [
                            $d2f51651a502d078$export$7ab4c9105b8f5e6e,
                            $d2f51651a502d078$export$e46fdb5cfcab5136,
                            $d2f51651a502d078$export$5ecfc8d07b04fe06
                        ] : [
                            $d2f51651a502d078$export$7ab4c9105b8f5e6e,
                            $d2f51651a502d078$export$e46fdb5cfcab5136,
                            $d2f51651a502d078$export$2ee732c275691f0b
                        ],
                        loading: isRecordingLoading,
                        onClick: ()=>toggleRecording(),
                        disabled: isTrialUsageLimitExceeded,
                        children: !isRecordingLoading && (0, $bb3TF.jsx)((0, $3206031044c2820c$export$2e2bcd8739ae039), {
                            className: isRecording ? $d2f51651a502d078$export$103602e8dd00d48f : $d2f51651a502d078$export$523fb6203cc70ed0
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: [
                            $d2f51651a502d078$export$e46fdb5cfcab5136,
                            $d2f51651a502d078$export$47e9855eb3c1d229
                        ],
                        children: secondsToTime(secondsRemaining)
                    })
                ]
            }),
            !stream && !isTrialUsageLimitExceeded && !isHeygenUsageLimitExceeded && !isLoadingSession && !isHeygenLoading && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$7c826917df538fc7,
                        children: (0, $bb3TF.jsx)($ae1f3cf505f9c39c$var$Text, {
                            className: $d2f51651a502d078$export$d29aac9c25b00cab,
                            children: "Taxaroo AI can hear and talk"
                        })
                    }),
                    planType === 'trial' && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$7092d0c542c03178,
                        children: (0, $bb3TF.jsx)($ae1f3cf505f9c39c$var$Text, {
                            className: $d2f51651a502d078$export$d29aac9c25b00cab,
                            children: "Ask him tax questions, get help with operations and have him do tasks for you"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        type: "primary",
                        shape: "round",
                        onClick: ()=>heygenStreamStart(),
                        className: planType === 'trial' ? $d2f51651a502d078$export$68a8ae4a08e52409 : $d2f51651a502d078$export$7fdf7b67141cb5b2,
                        children: "Start Conversation"
                    }),
                    planType === 'trial' && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$9b3b10c602d92f4e,
                        children: "You have 5 minutes free"
                    })
                ]
            }),
            (isLoadingSession || isHeygenLoading) && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$7c826917df538fc7,
                        children: (0, $bb3TF.jsx)($ae1f3cf505f9c39c$var$Text, {
                            className: $d2f51651a502d078$export$d29aac9c25b00cab,
                            children: "Taxaroo AI can hear and talk"
                        })
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$3ca4e40e14d52210,
                        justify: "center",
                        children: [
                            (0, $bb3TF.jsx)($ae1f3cf505f9c39c$var$Text, {
                                className: $d2f51651a502d078$export$d29aac9c25b00cab,
                                children: "Connecting"
                            }),
                            (0, $bb3TF.jsx)($ae1f3cf505f9c39c$var$Text, {
                                className: $d2f51651a502d078$export$70ab27996b9a0666,
                                children: "\u00A0"
                            })
                        ]
                    })
                ]
            }),
            isHeygenUsageLimitExceeded && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$7c826917df538fc7,
                        children: (0, $bb3TF.jsx)($ae1f3cf505f9c39c$var$Text, {
                            className: $d2f51651a502d078$export$d29aac9c25b00cab,
                            children: "Taxaroo AI can hear and talk"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$3ca4e40e14d52210,
                        children: (0, $bb3TF.jsxs)($ae1f3cf505f9c39c$var$Text, {
                            className: $d2f51651a502d078$export$d29aac9c25b00cab,
                            children: [
                                "Hey you've hit the plan limits. To manage your subscription click\u00A0",
                                (0, $bb3TF.jsx)($ae1f3cf505f9c39c$var$Link, {
                                    href: "/settings/ai",
                                    children: "here"
                                })
                            ]
                        })
                    })
                ]
            }),
            isTrialUsageLimitExceeded && (0, $bb3TF.jsxs)("div", {
                className: $d2f51651a502d078$export$2faf482a17a1cee2,
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        style: {
                            paddingBottom: '17px',
                            fontSize: '17px'
                        },
                        children: "Unlock the Full Power of Taxaroo AI"
                    }),
                    (0, $bb3TF.jsxs)("ul", {
                        children: [
                            (0, $bb3TF.jsx)("li", {
                                style: {
                                    paddingBottom: '17px'
                                },
                                children: "Talk to your Agent like you talk to your friends."
                            }),
                            (0, $bb3TF.jsx)("li", {
                                style: {
                                    paddingBottom: '17px'
                                },
                                children: "Complete tax forms, send emails, and tackle administrative tasks in seconds, freeing up hours of your day."
                            }),
                            (0, $bb3TF.jsx)("li", {
                                style: {
                                    paddingBottom: '17px'
                                },
                                children: "Expert-level insights and ensure every tax-related decision aligns with current regulations."
                            }),
                            (0, $bb3TF.jsx)("li", {
                                children: "Your AI tax assistant is available whenever you need help\u2014no waiting, no appointments."
                            })
                        ]
                    })
                ]
            }),
            (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() && stream && (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                type: "default",
                shape: "circle",
                onClick: ()=>{
                    setFullscreenAvatar(!isFullScreen);
                    setIsFullScreen(!isFullScreen);
                },
                className: [
                    $d2f51651a502d078$export$e46fdb5cfcab5136,
                    $d2f51651a502d078$export$63db5107226e48e6
                ],
                children: isFullScreen ? (0, $bb3TF.jsx)((0, $9930258c6346eaf1$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$3b5b3034b0bcdb5e
                }) : (0, $bb3TF.jsx)((0, $0dd5d02c96029bc1$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$11be9257a49e879d
                })
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                className: stream ? $d2f51651a502d078$export$13c0b0addd9030c8 : $d2f51651a502d078$export$d8e28e9bae5656c4,
                children: [
                    "Powered by \u00A0\u00A0",
                    (0, $bb3TF.jsx)((0, $3c5d28b869b30cc8$export$2e2bcd8739ae039), {
                        className: stream ? $d2f51651a502d078$export$204adef05326175b : $d2f51651a502d078$export$ccc4f9f9a42f7b77
                    }),
                    "\u00A0",
                    (0, $bb3TF.jsx)($ae1f3cf505f9c39c$var$Text, {
                        className: stream ? $d2f51651a502d078$export$59786590dc3cfd09 : $d2f51651a502d078$export$ab93278bfa59f297,
                        children: "Workforce AI"
                    })
                ]
            })
        ]
    });
};
var $ae1f3cf505f9c39c$export$2e2bcd8739ae039 = $ae1f3cf505f9c39c$var$HeygenAvatar;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $bb3TF = parcelRequire("bb3TF");


var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $6b2f9db68b803801$var$SvgCheckmark = (props)=>/*#__PURE__*/ (0, $bb3TF.jsx)("svg", {
        width: 13,
        height: 13,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
            d: "M6.5 12.823a6.546 6.546 0 0 0 4.596-1.878A6.368 6.368 0 0 0 13 6.412c0-1.7-.685-3.332-1.904-4.534A6.546 6.546 0 0 0 6.5 0a6.546 6.546 0 0 0-4.596 1.878A6.368 6.368 0 0 0 0 6.412c0 1.7.685 3.33 1.904 4.533A6.546 6.546 0 0 0 6.5 12.823Zm2.87-7.589L6.12 8.44a.613.613 0 0 1-.862 0L3.633 6.837a.593.593 0 0 1 0-.849.615.615 0 0 1 .861 0l1.194 1.177 2.818-2.782a.613.613 0 0 1 .86 0 .595.595 0 0 1 0 .849l.003.002Z",
            fill: "#181818"
        })
    });
var $6b2f9db68b803801$export$2e2bcd8739ae039 = $6b2f9db68b803801$var$SvgCheckmark;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $8763a4b4bf191692$var$SvgXmark = (props)=>/*#__PURE__*/ (0, $bb3TF.jsx)("svg", {
        width: 13,
        height: 13,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
            d: "M6.5 13a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13ZM4.443 4.443a.607.607 0 0 1 .861 0l1.193 1.194 1.194-1.194a.61.61 0 0 1 .86.86L7.359 6.498l1.194 1.194a.61.61 0 0 1-.86.86L6.496 7.359 5.304 8.552a.61.61 0 0 1-.86-.86l1.193-1.195-1.194-1.193a.607.607 0 0 1 0-.86Z",
            fill: "#181818"
        })
    });
var $8763a4b4bf191692$export$2e2bcd8739ae039 = $8763a4b4bf191692$var$SvgXmark;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $a826df584121480a$var$SvgMagicWand = (props)=>/*#__PURE__*/ (0, $bb3TF.jsx)("svg", {
        width: 10,
        height: 9,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
            d: "m4.314.73-.693.24a.132.132 0 0 0-.092.124c0 .055.037.104.092.123l.693.241.26.644c.02.052.073.086.132.086a.141.141 0 0 0 .132-.086l.26-.644.692-.241a.132.132 0 0 0 .092-.123A.132.132 0 0 0 5.79.97L5.097.73 4.838.085A.141.141 0 0 0 4.706 0a.141.141 0 0 0-.132.085l-.26.645ZM.847 6.758a.782.782 0 0 0 0 1.16l.636.592c.344.32.903.32 1.249 0L9.74 1.991a.782.782 0 0 0 0-1.16L9.105.24a.932.932 0 0 0-1.248 0L.847 6.758Zm8.061-5.346-1.93 1.795-.428-.399 1.93-1.794.428.398Zm-8.77.591A.199.199 0 0 0 0 2.188c0 .082.055.155.138.184l1.038.363.39.965c.031.077.11.129.199.129a.213.213 0 0 0 .198-.129l.39-.965 1.039-.363a.199.199 0 0 0 .137-.184.199.199 0 0 0-.137-.185l-1.04-.362-.389-.966a.213.213 0 0 0-.198-.128.213.213 0 0 0-.199.128l-.39.966-1.038.362Zm6.47 4.376a.199.199 0 0 0-.137.184c0 .083.055.156.137.185l1.04.362.389.966c.031.077.11.128.198.128a.213.213 0 0 0 .199-.128l.39-.966 1.038-.362A.199.199 0 0 0 10 6.563a.199.199 0 0 0-.138-.184l-1.038-.362-.39-.966a.213.213 0 0 0-.199-.128.213.213 0 0 0-.198.128l-.39.966-1.039.362Z",
            fill: "#3d80f3"
        })
    });
var $a826df584121480a$export$2e2bcd8739ae039 = $a826df584121480a$var$SvgMagicWand;




const { Text: $0c6372d8fe437835$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $0c6372d8fe437835$var$taxarooAiVideoSrc = 'https://taxaroo-public1.s3.us-east-1.amazonaws.com/video/taxaroo_ai.mp4';
const $0c6372d8fe437835$export$50fb3dda3f03d0c7 = (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
    style: {
        fontSize: '36px'
    },
    children: "Proceed to checkout AI Video Plan?"
});
const $0c6372d8fe437835$export$8558b2eb300cb309 = (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
    style: {
        fontSize: '36px'
    },
    children: [
        "Proceed to checkout\u00A0",
        (0, $bb3TF.jsx)($0c6372d8fe437835$var$Text, {
            className: $d2f51651a502d078$export$256e8e2c5d45fb6b,
            children: "AI VideoPro Plan"
        }),
        "?"
    ]
});
const $0c6372d8fe437835$export$8adf8e798c3fb2b2 = (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
    style: {
        fontSize: '36px'
    },
    children: "Proceed to checkout AI Chat Plan?"
});
const $0c6372d8fe437835$export$6a55a48f1cc55697 = (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
    children: [
        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            style: {
                fontSize: '36px',
                padding: '10px 0'
            },
            children: "Upgrade Your Firm Efficiency with Taxaroo AI."
        }),
        (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            style: {
                fontSize: '36px'
            },
            children: [
                (0, $bb3TF.jsx)($0c6372d8fe437835$var$Text, {
                    className: $d2f51651a502d078$export$256e8e2c5d45fb6b,
                    children: "24/7"
                }),
                (0, $bb3TF.jsx)($0c6372d8fe437835$var$Text, {
                    children: "\u00A0work & support."
                })
            ]
        })
    ]
});
const $0c6372d8fe437835$export$26e6773928052806 = (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
    style: {
        fontSize: '20px'
    },
    children: "Confirm your purchase"
});
const $0c6372d8fe437835$export$622581669967b171 = (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
    style: {
        fontSize: '20px'
    },
    children: "Confirm your purchase"
});
const $0c6372d8fe437835$export$a53fbe170328d2f2 = (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
    style: {
        fontSize: '20px'
    },
    children: "Confirm your purchase"
});
const $0c6372d8fe437835$export$ac573d853cd59ba0 = (defaultPaymentMethod, handleUpdatePaymentMethod)=>defaultPaymentMethod ? (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                style: {
                    fontSize: '20px'
                },
                children: "Get AI support that helps you with tax questions and automates tasks for you."
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                style: {
                    fontSize: '20px'
                },
                children: "Upgrade your Taxaroo experience with Taxaroo AI."
            })
        ]
    }) : (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        style: {
            fontSize: '20px'
        },
        children: [
            "You are currently on a trial plan.\u00A0",
            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                type: "link",
                onClick: ()=>handleUpdatePaymentMethod(),
                style: {
                    padding: 0,
                    fontSize: '20px'
                },
                children: (0, $bb3TF.jsx)($0c6372d8fe437835$var$Text, {
                    style: {
                        textTransform: 'capitalize',
                        color: '#3d80f3'
                    },
                    children: "Click here"
                })
            }),
            "\u00A0to add a payment method to experience Taxaroo AI."
        ]
    });
const $0c6372d8fe437835$export$46d82d89960397f4 = (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
    gutter: [
        30,
        50
    ],
    className: $d2f51651a502d078$export$506f99aa8a669064,
    children: [
        (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
            xs: 24,
            md: 8,
            style: {
                marginRight: {
                    xs: 0,
                    md: '40px'
                },
                marginBottom: {
                    xs: '20px',
                    md: 0
                }
            },
            children: [
                (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$5bb77c042e78eef1,
                    bodyStyle: {
                        padding: '10px 20px'
                    },
                    children: [
                        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            className: $d2f51651a502d078$export$af5e71fe29d96ba7,
                            children: "AI Chat Plan"
                        }),
                        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            style: {
                                fontSize: '14px'
                            },
                            children: "Focused purely on chat, simple and efficient"
                        })
                    ]
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$af5e71fe29d96ba7,
                    style: {
                        padding: '40px 0 0 20px'
                    },
                    children: "Price"
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: [
                        $d2f51651a502d078$export$af5e71fe29d96ba7,
                        $d2f51651a502d078$export$256e8e2c5d45fb6b
                    ],
                    style: {
                        paddingLeft: '20px'
                    },
                    children: "$49 per month"
                })
            ]
        }),
        (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
            xs: 24,
            md: 14,
            children: [
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$1f9d3905751c630e,
                    children: "Features and benefits"
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$68ba3f2d27e885ee,
                    children: "Get unlimited access to Taxaroo AI's chat for instant, secure task assistance and insights \u2014 no video needed. Perfect for quick, text-based solutions."
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    style: {
                        padding: '10px 0'
                    },
                    children: (0, $bb3TF.jsxs)("video", {
                        controls: true,
                        width: "100%",
                        style: {
                            maxWidth: '600px'
                        },
                        controlsList: "nodownload",
                        poster: (0, $956da5db9c582e0d$export$64304a959a419066),
                        preload: "metadata",
                        children: [
                            (0, $bb3TF.jsx)("source", {
                                src: $0c6372d8fe437835$var$taxarooAiVideoSrc,
                                type: "video/mp4"
                            }),
                            "Your browser does not support the video tag.",
                            (0, $bb3TF.jsx)("track", {
                                kind: "captions",
                                label: "English",
                                default: true
                            })
                        ]
                    })
                }),
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    align: "top",
                    children: [
                        (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            flex: "350px",
                            children: [
                                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                    children: [
                                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                            className: $d2f51651a502d078$export$70fd15e1af72753e
                                        }),
                                        "AI-powered chat for instant tax answers"
                                    ]
                                }),
                                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                    children: [
                                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                            className: $d2f51651a502d078$export$70fd15e1af72753e
                                        }),
                                        "Unlimited text-based queries"
                                    ]
                                }),
                                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                    children: [
                                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                            className: $d2f51651a502d078$export$70fd15e1af72753e
                                        }),
                                        "Quick task completion via chat interaction"
                                    ]
                                }),
                                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                    children: [
                                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                            className: $d2f51651a502d078$export$70fd15e1af72753e
                                        }),
                                        "Available from your Firm Dashboard"
                                    ]
                                })
                            ]
                        }),
                        (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            flex: "auto",
                            children: [
                                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                    style: {
                                        opacity: 0.4
                                    },
                                    children: [
                                        (0, $bb3TF.jsx)((0, $8763a4b4bf191692$export$2e2bcd8739ae039), {
                                            className: $d2f51651a502d078$export$70fd15e1af72753e
                                        }),
                                        "Not available for Client Portal"
                                    ]
                                }),
                                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                    style: {
                                        opacity: 0.4
                                    },
                                    children: [
                                        (0, $bb3TF.jsx)((0, $8763a4b4bf191692$export$2e2bcd8739ae039), {
                                            className: $d2f51651a502d078$export$70fd15e1af72753e
                                        }),
                                        "AI Video not available"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    ]
});
const $0c6372d8fe437835$export$ea9d37b2ed1befd4 = (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
    justify: "start",
    gutter: [
        30,
        50
    ],
    className: $d2f51651a502d078$export$506f99aa8a669064,
    children: [
        (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
            xs: 24,
            md: 8,
            style: {
                marginRight: {
                    xs: 0,
                    md: '40px'
                },
                marginBottom: {
                    xs: '20px',
                    md: 0
                }
            },
            children: [
                (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$5bb77c042e78eef1,
                    bodyStyle: {
                        padding: '10px 20px'
                    },
                    children: [
                        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            className: $d2f51651a502d078$export$af5e71fe29d96ba7,
                            children: "AI Video Plan"
                        }),
                        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            style: {
                                fontSize: '14px'
                            },
                            children: "Includes 1-hour video sessions daily"
                        })
                    ]
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$af5e71fe29d96ba7,
                    style: {
                        padding: '40px 0 0 20px'
                    },
                    children: "Price"
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: [
                        $d2f51651a502d078$export$af5e71fe29d96ba7,
                        $d2f51651a502d078$export$256e8e2c5d45fb6b
                    ],
                    style: {
                        paddingLeft: '20px'
                    },
                    children: "$299 per month"
                })
            ]
        }),
        (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
            xs: 24,
            md: 14,
            children: [
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$1f9d3905751c630e,
                    children: "Features and benefits"
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$68ba3f2d27e885ee,
                    children: "The perfect starting point for firms looking to dip their toes into AI-powered efficiency. Gain the confidence to navigate your tax tasks with 1 daily session of cutting-edge support. Available exclusively on the firm page, it\u2019s the ideal introduction to a smarter way of working."
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    style: {
                        padding: '10px 0'
                    },
                    children: (0, $bb3TF.jsxs)("video", {
                        controls: true,
                        width: "100%",
                        style: {
                            maxWidth: '600px'
                        },
                        controlsList: "nodownload",
                        poster: (0, $956da5db9c582e0d$export$64304a959a419066),
                        preload: "metadata",
                        children: [
                            (0, $bb3TF.jsx)("source", {
                                src: $0c6372d8fe437835$var$taxarooAiVideoSrc,
                                type: "video/mp4"
                            }),
                            "Your browser does not support the video tag.",
                            (0, $bb3TF.jsx)("track", {
                                kind: "captions",
                                label: "English",
                                default: true
                            })
                        ]
                    })
                }),
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    align: "top",
                    children: [
                        (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            flex: "350px",
                            children: [
                                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                    children: [
                                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                            className: $d2f51651a502d078$export$70fd15e1af72753e
                                        }),
                                        "Includes 1-hour daily video session"
                                    ]
                                }),
                                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                    children: [
                                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                            className: $d2f51651a502d078$export$70fd15e1af72753e
                                        }),
                                        "Speak conversationally with your AI agent"
                                    ]
                                }),
                                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                    children: [
                                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                            className: $d2f51651a502d078$export$70fd15e1af72753e
                                        }),
                                        "Quick task completion via video interaction"
                                    ]
                                }),
                                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                    children: [
                                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                            className: $d2f51651a502d078$export$70fd15e1af72753e
                                        }),
                                        "Available from your Firm Dashboard"
                                    ]
                                })
                            ]
                        }),
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            flex: "auto",
                            children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                style: {
                                    opacity: 0.4
                                },
                                children: [
                                    (0, $bb3TF.jsx)((0, $8763a4b4bf191692$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$70fd15e1af72753e
                                    }),
                                    "Not available for Client Portal"
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    ]
});
const $0c6372d8fe437835$export$23f1d40115b271f6 = (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
    justify: "start",
    gutter: [
        30,
        50
    ],
    className: $d2f51651a502d078$export$506f99aa8a669064,
    children: [
        (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
            xs: 24,
            md: 8,
            style: {
                marginRight: {
                    xs: 0,
                    md: '40px'
                },
                marginBottom: {
                    xs: '20px',
                    md: 0
                }
            },
            children: [
                (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$a68257abb0862e7f,
                    bodyStyle: {
                        padding: '10px 20px'
                    },
                    children: [
                        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            className: [
                                $d2f51651a502d078$export$af5e71fe29d96ba7,
                                $d2f51651a502d078$export$256e8e2c5d45fb6b
                            ],
                            children: "AI VideoPro Plan"
                        }),
                        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            style: {
                                fontSize: '14px'
                            },
                            children: "Includes 2-hour video sessions daily"
                        })
                    ]
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$af5e71fe29d96ba7,
                    style: {
                        padding: '40px 0 0 20px'
                    },
                    children: "Price"
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: [
                        $d2f51651a502d078$export$af5e71fe29d96ba7,
                        $d2f51651a502d078$export$256e8e2c5d45fb6b
                    ],
                    style: {
                        paddingLeft: '20px'
                    },
                    children: "$699 per month"
                })
            ]
        }),
        (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
            xs: 24,
            md: 14,
            children: [
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$1f9d3905751c630e,
                    children: "Features and benefits"
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$68ba3f2d27e885ee,
                    children: "This is your gateway to longer sessions, firm-wide and client-facing power, and comprehensive message history. With extended transcription storage and unrestricted access, this is the ultimate tool to future-proof your tax operations."
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    style: {
                        padding: '10px 0'
                    },
                    children: (0, $bb3TF.jsxs)("video", {
                        controls: true,
                        width: "100%",
                        style: {
                            maxWidth: '600px'
                        },
                        controlsList: "nodownload",
                        poster: (0, $956da5db9c582e0d$export$64304a959a419066),
                        preload: "metadata",
                        children: [
                            (0, $bb3TF.jsx)("source", {
                                src: $0c6372d8fe437835$var$taxarooAiVideoSrc,
                                type: "video/mp4"
                            }),
                            "Your browser does not support the video tag.",
                            (0, $bb3TF.jsx)("track", {
                                kind: "captions",
                                label: "English",
                                default: true
                            })
                        ]
                    })
                }),
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    align: "top",
                    children: [
                        (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            flex: "350px",
                            children: [
                                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                    children: [
                                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                            className: $d2f51651a502d078$export$70fd15e1af72753e
                                        }),
                                        "Enjoy 2-hour daily video sessions"
                                    ]
                                }),
                                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                    children: [
                                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                            className: $d2f51651a502d078$export$70fd15e1af72753e
                                        }),
                                        "Speak conversationally with your AI agent"
                                    ]
                                }),
                                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                    children: [
                                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                            className: $d2f51651a502d078$export$70fd15e1af72753e
                                        }),
                                        "High-priority queue for urgent tasks"
                                    ]
                                }),
                                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                    children: [
                                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                            className: $d2f51651a502d078$export$70fd15e1af72753e
                                        }),
                                        "Available from your Firm Dashboard"
                                    ]
                                })
                            ]
                        }),
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            flex: "auto",
                            children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$e90649b65cb8b9d0,
                                children: [
                                    (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$53ecd21380ae7eca
                                    }),
                                    (0, $bb3TF.jsx)($0c6372d8fe437835$var$Text, {
                                        style: {
                                            backgroundImage: 'linear-gradient(to right, #0057A5, #0A8CED)',
                                            color: 'transparent',
                                            backgroundClip: 'text',
                                            fontWeight: 'bold'
                                        },
                                        children: "Available for your clients too"
                                    }),
                                    "\u00A0\u00A0",
                                    (0, $bb3TF.jsx)((0, $a826df584121480a$export$2e2bcd8739ae039), {
                                        style: {
                                            marginTop: '5px'
                                        }
                                    }),
                                    (0, $bb3TF.jsxs)($0c6372d8fe437835$var$Text, {
                                        style: {
                                            backgroundImage: 'linear-gradient(to right, #0057A5, #0A8CED)',
                                            color: 'transparent',
                                            backgroundClip: 'text',
                                            marginLeft: '8px',
                                            lineHeight: '14px',
                                            textAlign: 'center',
                                            fontWeight: 'bold'
                                        },
                                        children: [
                                            "Coming",
                                            (0, $bb3TF.jsx)("br", {}),
                                            "Soon"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    ]
});
const $0c6372d8fe437835$export$d3449a24c9b3a227 = (defaultPaymentMethod, setPlan, planStatus, price, plan)=>{
    if (planStatus === 'active') return (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
        type: "danger",
        disabled: !defaultPaymentMethod,
        onClick: ()=>setPlan(plan),
        children: "Cancel subscription"
    });
    return (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
        type: "primary",
        disabled: !defaultPaymentMethod,
        onClick: ()=>defaultPaymentMethod ? setPlan(plan) : undefined,
        style: plan !== 'AI VideoPro' ? {
            background: '#000',
            color: '#fff',
            borderColor: '#000'
        } : {},
        children: defaultPaymentMethod ? `${planStatus === 'cancelsAtEndOfBillingCycle' ? 'Renew' : 'Get'} for ${price} per month` : 'Subscribe to Taxaroo first'
    });
};
const $0c6372d8fe437835$export$a11eba76c3b9638e = (defaultPaymentMethod, setPlan, planStatuses)=>(0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        align: "center",
        children: [
            (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                className: $d2f51651a502d078$export$d65145d0a74feea4,
                bodyStyle: {
                    padding: '10px 20px'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$af5e71fe29d96ba7,
                        children: "AI Chat Plan"
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        style: {
                            fontSize: '14px'
                        },
                        children: "Focused purely on chat, simple and efficient."
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$fadbecb2c2f910ef,
                        children: [
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$8cc0924721e82658,
                                children: [
                                    (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$96427d1536b00cf2
                                    }),
                                    "AI-powered chat for instant tax answers"
                                ]
                            }),
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$8cc0924721e82658,
                                children: [
                                    (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$96427d1536b00cf2
                                    }),
                                    "Unlimited text-based queries"
                                ]
                            }),
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$8cc0924721e82658,
                                children: [
                                    (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$96427d1536b00cf2
                                    }),
                                    "Quick task completion via chat interaction"
                                ]
                            }),
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$8cc0924721e82658,
                                children: [
                                    (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$96427d1536b00cf2
                                    }),
                                    "Available from your Firm Dashboard"
                                ]
                            })
                        ]
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$52f405b64a820001,
                        children: $0c6372d8fe437835$export$d3449a24c9b3a227(defaultPaymentMethod, setPlan, planStatuses?.['AI Chat'], '$49', 'AI Chat')
                    })
                ]
            }),
            (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                className: $d2f51651a502d078$export$d65145d0a74feea4,
                bodyStyle: {
                    padding: '10px 20px'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$af5e71fe29d96ba7,
                        children: "AI VideoPlus Plan"
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        style: {
                            fontSize: '14px',
                            marginBottom: '26px'
                        },
                        children: "Includes 1-hour video sessions daily."
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$fadbecb2c2f910ef,
                        children: [
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$8cc0924721e82658,
                                children: [
                                    (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$96427d1536b00cf2
                                    }),
                                    "Includes 1-hour daily video session"
                                ]
                            }),
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$8cc0924721e82658,
                                children: [
                                    (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$96427d1536b00cf2
                                    }),
                                    "Speak conversationally with your AI agent"
                                ]
                            }),
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$8cc0924721e82658,
                                children: [
                                    (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$96427d1536b00cf2
                                    }),
                                    "Quick task completion via video interaction"
                                ]
                            }),
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$8cc0924721e82658,
                                children: [
                                    (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$96427d1536b00cf2
                                    }),
                                    "Available from your Firm Dashboard"
                                ]
                            })
                        ]
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$52f405b64a820001,
                        children: $0c6372d8fe437835$export$d3449a24c9b3a227(defaultPaymentMethod, setPlan, planStatuses?.['AI VideoPlus'], '$299', 'AI VideoPlus')
                    })
                ]
            }),
            (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                className: $d2f51651a502d078$export$c2cac2cad83a37e3,
                bodyStyle: {
                    padding: '10px 20px'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: [
                            $d2f51651a502d078$export$af5e71fe29d96ba7,
                            $d2f51651a502d078$export$256e8e2c5d45fb6b
                        ],
                        children: "AI VideoPro Plan"
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        style: {
                            fontSize: '14px',
                            marginBottom: '26px'
                        },
                        children: "Includes 2-hour video sessions daily."
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$fadbecb2c2f910ef,
                        children: [
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$8cc0924721e82658,
                                children: [
                                    (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$96427d1536b00cf2
                                    }),
                                    "Enjoy 2-hour daily video sessions"
                                ]
                            }),
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$8cc0924721e82658,
                                children: [
                                    (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$96427d1536b00cf2
                                    }),
                                    "Speak conversationally with your AI agent"
                                ]
                            }),
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$8cc0924721e82658,
                                children: [
                                    (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$96427d1536b00cf2
                                    }),
                                    "High-priority queue for urgent tasks"
                                ]
                            }),
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$8cc0924721e82658,
                                children: [
                                    (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$96427d1536b00cf2
                                    }),
                                    "Available from your Firm Dashboard"
                                ]
                            }),
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: $d2f51651a502d078$export$8cc0924721e82658,
                                children: [
                                    (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$6c29c21b3c676455
                                    }),
                                    (0, $bb3TF.jsx)($0c6372d8fe437835$var$Text, {
                                        style: {
                                            backgroundImage: 'linear-gradient(to right, #0057A5, #0A8CED)',
                                            color: 'transparent',
                                            backgroundClip: 'text',
                                            fontWeight: 'bold'
                                        },
                                        children: "Available for your clients too"
                                    }),
                                    "\u00A0\u00A0",
                                    (0, $bb3TF.jsx)((0, $a826df584121480a$export$2e2bcd8739ae039), {
                                        style: {
                                            marginTop: '5px'
                                        }
                                    }),
                                    (0, $bb3TF.jsxs)($0c6372d8fe437835$var$Text, {
                                        style: {
                                            backgroundImage: 'linear-gradient(to right, #0057A5, #0A8CED)',
                                            color: 'transparent',
                                            backgroundClip: 'text',
                                            marginLeft: '8px',
                                            lineHeight: '14px',
                                            textAlign: 'center',
                                            fontWeight: 'bold'
                                        },
                                        children: [
                                            "Coming",
                                            (0, $bb3TF.jsx)("br", {}),
                                            "Soon"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$52f405b64a820001,
                        children: $0c6372d8fe437835$export$d3449a24c9b3a227(defaultPaymentMethod, setPlan, planStatuses?.['AI VideoPro'], '$699', 'AI VideoPro')
                    })
                ]
            })
        ]
    });



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");





const $221e091746ae1298$var$defaultOptions = {};
const $221e091746ae1298$export$5c2d8bef841603df = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation createFirmAccountAddOn($input: CreateFirmAccountAddOnInput!) {
  createFirmAccountAddOn(input: $input) {
    id
    firmAccountId
    addOnId
    subscriptionId
    subscriptionStatus
    subscriptionCancelAtPeriodEnd
    createAt
    updateAt
  }
}
    `;
function $221e091746ae1298$export$4f5328fad2e44fbb(baseOptions) {
    const options = {
        ...$221e091746ae1298$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($221e091746ae1298$export$5c2d8bef841603df, options);
}
const $221e091746ae1298$export$39ac829ab91f0716 = {
    Mutation: {
        createFirmAccountAddOn: 'createFirmAccountAddOn'
    }
};




const $141d022d397c6782$var$defaultOptions = {};
const $141d022d397c6782$export$5aa57a0bedbd2cd7 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetFirmAccountAddOnByName($name: String!) {
  firmAccountAddOnByName(name: $name) {
    id
    subscriptionStatus
    subscriptionCancelAtPeriodEnd
  }
}
    `;
function $141d022d397c6782$export$a63090a6696b4950(baseOptions) {
    const options = {
        ...$141d022d397c6782$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($141d022d397c6782$export$5aa57a0bedbd2cd7, options);
}
function $141d022d397c6782$export$3280e9750b559c42(baseOptions) {
    const options = {
        ...$141d022d397c6782$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($141d022d397c6782$export$5aa57a0bedbd2cd7, options);
}
const $141d022d397c6782$export$39ac829ab91f0716 = {
    Query: {
        GetFirmAccountAddOnByName: 'GetFirmAccountAddOnByName'
    }
};




const $ea96e4d458d42f5e$var$defaultOptions = {};
const $ea96e4d458d42f5e$export$5c2d8bef841603df = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateFirmAccountAddOn($input: CreateFirmAccountAddOnInput!) {
  createFirmAccountAddOn(input: $input) {
    id
    subscriptionStatus
    subscriptionCancelAtPeriodEnd
  }
}
    `;
function $ea96e4d458d42f5e$export$4f5328fad2e44fbb(baseOptions) {
    const options = {
        ...$ea96e4d458d42f5e$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($ea96e4d458d42f5e$export$5c2d8bef841603df, options);
}
const $ea96e4d458d42f5e$export$504589b07cc3b213 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateFirmAccountAddOn($input: UpdateFirmAccountAddOnInput!) {
  updateFirmAccountAddOn(input: $input) {
    id
    subscriptionStatus
    subscriptionCancelAtPeriodEnd
  }
}
    `;
function $ea96e4d458d42f5e$export$6bd4d482a4fae6a8(baseOptions) {
    const options = {
        ...$ea96e4d458d42f5e$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($ea96e4d458d42f5e$export$504589b07cc3b213, options);
}
const $ea96e4d458d42f5e$export$67c2f427c47a0840 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation DeleteFirmAccountAddOn($id: String!) {
  deleteFirmAccountAddOn(id: $id)
}
    `;
function $ea96e4d458d42f5e$export$9ce88e775709f81f(baseOptions) {
    const options = {
        ...$ea96e4d458d42f5e$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($ea96e4d458d42f5e$export$67c2f427c47a0840, options);
}
const $ea96e4d458d42f5e$export$39ac829ab91f0716 = {
    Mutation: {
        CreateFirmAccountAddOn: 'CreateFirmAccountAddOn',
        UpdateFirmAccountAddOn: 'UpdateFirmAccountAddOn',
        DeleteFirmAccountAddOn: 'DeleteFirmAccountAddOn'
    }
};




const { Text: $a200d37e26ccfc3d$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $a200d37e26ccfc3d$var$AddonsModalContent = ({ subscriptionCreated: subscriptionCreated, subscriptionCancelled: subscriptionCancelled, plan: plan, setPlan: setPlan })=>{
    const [modalHeader, setModalHeader] = (0, $6fFrj.useState)();
    const [modalContent, setModalContent] = (0, $6fFrj.useState)();
    const [planStatuses, setPlanStatuses] = (0, $6fFrj.useState)({
        'AI Chat': 'none',
        'AI VideoPlus': 'none',
        'AI VideoPro': 'none'
    });
    const { data: currentStripeInformation, loading: loadingCustomer } = (0, $732264f53056e08f$export$9f382c5aef9c5d4d)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message)
    });
    const { customerId: customerId } = currentStripeInformation?.CurrentStripeInformation || {};
    const [createBillingPortalSession] = (0, $99ead93e2ec80d4e$export$1940481f2be3ddf2)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message)
    });
    // Add this function to reset the component state
    const resetComponent = ()=>{
        setPlan(undefined);
    };
    const [createAddon, { loading: loadingCreateAddon }] = (0, $221e091746ae1298$export$4f5328fad2e44fbb)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message),
        onCompleted: ()=>{
            subscriptionCreated(plan);
            resetComponent(); // Reset after subscription is created
        },
        refetchQueries: [
            'GetFirmAccountAddOnByName'
        ]
    });
    const [updateFirmAccountAddOn, { loading: loadingUpdateFirmAccountAddOn }] = (0, $ea96e4d458d42f5e$export$6bd4d482a4fae6a8)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message),
        onCompleted: ()=>{
            subscriptionCancelled();
            resetComponent();
        }
    });
    const { data: customerData, loading: loadingStripeCustomer } = (0, $fa3f5c8f35890bd3$export$eeb3a77a20e59876)({
        variables: {
            getStripeCustomerInput: {
                customerId: customerId
            }
        },
        skip: !customerId
    });
    const customer = customerData?.getStripeCustomer;
    const defaultPaymentMethod = customer?.invoice_settings?.default_payment_method || customer?.default_source;
    const { data: firmAccountChatOnlyAddOn } = (0, $141d022d397c6782$export$a63090a6696b4950)({
        variables: {
            name: 'taxaroo-ai-chat-only-plan'
        }
    });
    const { data: firmAccountBasicAddOn } = (0, $141d022d397c6782$export$a63090a6696b4950)({
        variables: {
            name: 'taxaroo-ai-basic-plan'
        }
    });
    const { data: firmAccountPremiumAddOn } = (0, $141d022d397c6782$export$a63090a6696b4950)({
        variables: {
            name: 'taxaroo-ai-premium-plan'
        }
    });
    const getPlanStatus = (addOn)=>{
        if (!addOn?.firmAccountAddOnByName?.id) return 'none';
        if (addOn?.firmAccountAddOnByName?.subscriptionCancelAtPeriodEnd) return 'cancelsAtEndOfBillingCycle';
        if (addOn?.firmAccountAddOnByName?.subscriptionStatus === (0, $8f7fe33a44836803$export$a19dca1ceabeb485).Active) return 'active';
        return 'none';
    };
    const updatePlanStatuses = ()=>{
        setPlanStatuses({
            'AI Chat': getPlanStatus(firmAccountChatOnlyAddOn),
            'AI VideoPlus': getPlanStatus(firmAccountBasicAddOn),
            'AI VideoPro': getPlanStatus(firmAccountPremiumAddOn)
        });
    };
    // useEffect to update plan statuses
    (0, $6fFrj.useEffect)(()=>{
        updatePlanStatuses();
    }, [
        firmAccountBasicAddOn?.firmAccountAddOnByName?.subscriptionStatus,
        firmAccountBasicAddOn?.firmAccountAddOnByName?.subscriptionCancelAtPeriodEnd,
        firmAccountPremiumAddOn?.firmAccountAddOnByName?.subscriptionStatus,
        firmAccountPremiumAddOn?.firmAccountAddOnByName?.subscriptionCancelAtPeriodEnd,
        firmAccountChatOnlyAddOn?.firmAccountAddOnByName?.subscriptionStatus,
        firmAccountChatOnlyAddOn?.firmAccountAddOnByName?.subscriptionCancelAtPeriodEnd
    ]);
    const handleUpdatePaymentMethod = async ()=>{
        const { data: data } = await createBillingPortalSession({
            variables: {
                createBillingPortalInput: {
                    customer: customerId,
                    return_url: window.location.href,
                    flow_data: {
                        type: 'payment_method_update'
                    }
                }
            }
        });
        window.location.href = data.createBillingPortalSession;
    };
    const getAddonIdByName = (addOnName)=>{
        switch(addOnName){
            case 'AI VideoPlus':
                return 'b84fe2cc-a288-4513-870f-46be84a8b9ad';
            case 'AI VideoPro':
                return '7b8571cc-9a10-4db3-88d1-06693c1de18b';
            case 'AI Chat':
                return 'ff305e16-4603-4d3f-89bf-3566bdcdd91f';
            default:
                return null;
        }
    };
    const getFirmAccountAddOnIdByName = (addOnName)=>{
        switch(addOnName){
            case 'AI VideoPlus':
                return firmAccountBasicAddOn?.firmAccountAddOnByName?.id;
            case 'AI VideoPro':
                return firmAccountPremiumAddOn?.firmAccountAddOnByName?.id;
            case 'AI Chat':
                return firmAccountChatOnlyAddOn?.firmAccountAddOnByName?.id;
            default:
                return null;
        }
    };
    (0, $6fFrj.useEffect)(()=>{
        if (plan === 'AI VideoPlus') {
            setModalHeader((0, $0c6372d8fe437835$export$26e6773928052806));
            setModalContent((0, $0c6372d8fe437835$export$ea9d37b2ed1befd4));
        } else if (plan === 'AI VideoPro') {
            setModalHeader((0, $0c6372d8fe437835$export$622581669967b171));
            setModalContent((0, $0c6372d8fe437835$export$23f1d40115b271f6));
        } else if (plan === 'AI Chat') {
            setModalHeader((0, $0c6372d8fe437835$export$a53fbe170328d2f2));
            setModalContent((0, $0c6372d8fe437835$export$46d82d89960397f4));
        } else {
            setModalHeader((0, $0c6372d8fe437835$export$ac573d853cd59ba0)(defaultPaymentMethod, handleUpdatePaymentMethod));
            setModalContent((0, $0c6372d8fe437835$export$a11eba76c3b9638e)(defaultPaymentMethod, setPlan, planStatuses));
        }
    }, [
        plan,
        currentStripeInformation,
        defaultPaymentMethod,
        planStatuses?.['AI Chat'],
        planStatuses?.['AI VideoPlus'],
        planStatuses?.['AI VideoPro']
    ]);
    return (0, $bb3TF.jsx)("div", {
        children: loadingStripeCustomer || loadingCustomer ? (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            align: "middle",
            justify: "center",
            style: {
                height: '600px'
            },
            children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                size: "large"
            })
        }) : (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
            children: [
                modalHeader,
                modalContent,
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "space-between",
                    align: "middle",
                    style: {
                        width: `${22 / 24 * 100}%`
                    },
                    children: [
                        (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            xs: 24,
                            md: 12,
                            className: $d2f51651a502d078$export$36a781f6e8472d8,
                            children: [
                                "Powered by \u00A0\u00A0",
                                (0, $bb3TF.jsx)((0, $3c5d28b869b30cc8$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$204adef05326175b
                                }),
                                "\u00A0",
                                (0, $bb3TF.jsx)($a200d37e26ccfc3d$var$Text, {
                                    className: $d2f51651a502d078$export$59786590dc3cfd09,
                                    children: "Workforce AI"
                                })
                            ]
                        }),
                        Boolean(plan) && (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            xs: 24,
                            md: 12,
                            style: {
                                display: 'flex',
                                justifyContent: 'flex-end'
                            },
                            children: [
                                (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                    type: "default",
                                    onClick: ()=>setPlan(undefined),
                                    className: $d2f51651a502d078$export$57297741b37603f1,
                                    children: "Go Back"
                                }),
                                planStatuses?.[plan] === 'active' ? (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                    type: "danger",
                                    className: $d2f51651a502d078$export$e6d1e98eb8e73288,
                                    loading: loadingUpdateFirmAccountAddOn,
                                    onClick: async ()=>{
                                        await updateFirmAccountAddOn({
                                            variables: {
                                                input: {
                                                    id: getFirmAccountAddOnIdByName(plan),
                                                    active: false
                                                }
                                            }
                                        });
                                    },
                                    children: "Cancel"
                                }) : (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    className: $d2f51651a502d078$export$e6d1e98eb8e73288,
                                    loading: loadingCreateAddon,
                                    onClick: async ()=>{
                                        await createAddon({
                                            variables: {
                                                input: {
                                                    addOnId: getAddonIdByName(plan)
                                                }
                                            }
                                        });
                                    },
                                    children: "Pay"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $a200d37e26ccfc3d$export$2e2bcd8739ae039 = $a200d37e26ccfc3d$var$AddonsModalContent;


const $a85f0f461805abf8$var$AddonsModal = ({ isModalVisible: isModalVisible, closeModal: closeModal, subscriptionCreated: subscriptionCreated, subscriptionCancelled: subscriptionCancelled })=>{
    const [modalTitle, setModalTitle] = (0, $6fFrj.useState)();
    const [plan, setPlan] = (0, $6fFrj.useState)();
    (0, $6fFrj.useEffect)(()=>{
        if (plan === 'AI VideoPlus') setModalTitle((0, $0c6372d8fe437835$export$50fb3dda3f03d0c7));
        else if (plan === 'AI VideoPro') setModalTitle((0, $0c6372d8fe437835$export$8558b2eb300cb309));
        else if (plan === 'AI Chat') setModalTitle((0, $0c6372d8fe437835$export$8adf8e798c3fb2b2));
        else setModalTitle((0, $0c6372d8fe437835$export$6a55a48f1cc55697));
    }, [
        plan
    ]);
    return (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        title: modalTitle,
        onCancel: ()=>closeModal(),
        visible: isModalVisible,
        width: 1020,
        closable: true,
        centered: true,
        footer: null,
        bodyStyle: {
            padding: '10px 20px',
            margin: 0
        },
        children: (0, $bb3TF.jsx)((0, $a200d37e26ccfc3d$export$2e2bcd8739ae039), {
            subscriptionCreated: subscriptionCreated,
            subscriptionCancelled: subscriptionCancelled,
            plan: plan,
            setPlan: setPlan
        })
    });
};
var $a85f0f461805abf8$export$2e2bcd8739ae039 = $a85f0f461805abf8$var$AddonsModal;



var $bb3TF = parcelRequire("bb3TF");


var $6Sgv0 = parcelRequire("6Sgv0");

var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $53b6ac5015a140b2$var$SvgCopy = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        width: 17,
        height: 17,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M14.168 5.667H7.085c-.783 0-1.417.634-1.417 1.416v7.083c0 .783.634 1.417 1.417 1.417h7.083c.782 0 1.417-.634 1.417-1.417V7.083c0-.782-.635-1.417-1.417-1.417Z",
                stroke: "#B3B3B3",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M2.835 11.333a1.42 1.42 0 0 1-1.417-1.417V2.833c0-.779.637-1.417 1.417-1.417h7.083c.78 0 1.417.638 1.417 1.417",
                stroke: "#B3B3B3",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $53b6ac5015a140b2$export$2e2bcd8739ae039 = $53b6ac5015a140b2$var$SvgCopy;





const { Text: $20d50b5d2220167a$var$Text, Link: $20d50b5d2220167a$var$Link } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $20d50b5d2220167a$var$SpecialMessages = {
    terms: (0, $bb3TF.jsx)("div", {
        children: (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            justify: "space-between",
            className: $d2f51651a502d078$export$d8bbfaecd0f57bdf,
            children: (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                className: [
                    $d2f51651a502d078$export$15c87ed36e0c76b7,
                    $d2f51651a502d078$export$1730555d143970d5
                ],
                children: (0, $bb3TF.jsxs)($20d50b5d2220167a$var$Text, {
                    children: [
                        "Welcome to Taxaroo AI!",
                        '\n\n',
                        "You can chat here or talk to Taxaroo AI with your microphone to get your questions answered and complete your tasks.",
                        '\n\n',
                        "By using Taxaroo AI, you are agreeing to the following\u00A0",
                        (0, $bb3TF.jsx)($20d50b5d2220167a$var$Link, {
                            href: "https://taxaroo.com/terms-of-use",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "Terms"
                        }),
                        "."
                    ]
                })
            })
        })
    }, "terms")
};
const $20d50b5d2220167a$var$AiMessageList = ({ messages: messages, aiAgentMessagesLoading: aiAgentMessagesLoading, hasMore: hasMore, loadMore: loadMore })=>{
    if (aiAgentMessagesLoading) return (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        justify: "center",
        align: "middle",
        children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {})
    });
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            hasMore && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                justify: "center",
                align: "middle",
                style: {
                    paddingBottom: '20px'
                },
                children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    type: "default",
                    onClick: ()=>loadMore(),
                    children: "Load More Messages"
                })
            }),
            messages.map((msg, index)=>{
                if (msg.type === (0, $8f7fe33a44836803$export$614f97abc1364581).Assistant) return (0, $bb3TF.jsxs)("div", {
                    children: [
                        (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            justify: "space-between",
                            className: $d2f51651a502d078$export$d8bbfaecd0f57bdf,
                            children: [
                                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: [
                                        $d2f51651a502d078$export$15c87ed36e0c76b7,
                                        $d2f51651a502d078$export$4e38e526f9377acb
                                    ],
                                    children: msg.text
                                }),
                                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$c862890313ea649b,
                                    align: "middle",
                                    children: (0, $bb3TF.jsx)((0, $53b6ac5015a140b2$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$d00e075fafbe9ae5,
                                        onClick: ()=>navigator.clipboard.writeText(msg.text)
                                    })
                                })
                            ]
                        }),
                        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            justify: "start",
                            className: $d2f51651a502d078$export$6be8e3d3a41077a9,
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(msg.createAt).format('LT')
                        })
                    ]
                }, index);
                if (msg.type === (0, $8f7fe33a44836803$export$614f97abc1364581).User) return (0, $bb3TF.jsxs)("div", {
                    children: [
                        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            justify: "end",
                            className: $d2f51651a502d078$export$d8bbfaecd0f57bdf,
                            children: (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                className: [
                                    $d2f51651a502d078$export$15c87ed36e0c76b7,
                                    $d2f51651a502d078$export$d9acbd164c97ebb1
                                ],
                                children: msg.text
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            justify: "end",
                            className: $d2f51651a502d078$export$6be8e3d3a41077a9,
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(msg.createAt).format('LT')
                        })
                    ]
                }, index);
                if (msg.type === (0, $8f7fe33a44836803$export$614f97abc1364581).System) return (0, $bb3TF.jsx)("div", {
                    children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        align: "bottom",
                        style: {
                            padding: '10px 0'
                        },
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                children: (0, $bb3TF.jsx)((0, $50c2677d39bbc7c0$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$c347cf29b438cff
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                style: {
                                    paddingLeft: '10px'
                                },
                                children: (0, $bb3TF.jsx)($20d50b5d2220167a$var$Text, {
                                    strong: true,
                                    className: $d2f51651a502d078$export$256e8e2c5d45fb6b,
                                    children: msg.text
                                })
                            })
                        ]
                    })
                }, index);
                if (msg.type === (0, $8f7fe33a44836803$export$614f97abc1364581).Special) return $20d50b5d2220167a$var$SpecialMessages[msg.more];
                return null;
            }).filter((val)=>val)
        ]
    });
};
var $20d50b5d2220167a$export$2e2bcd8739ae039 = $20d50b5d2220167a$var$AiMessageList;


const { Text: $884b6ddcdd689371$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
let $884b6ddcdd689371$var$ws;
let $884b6ddcdd689371$var$mediaStream;
let $884b6ddcdd689371$var$audioContext;
let $884b6ddcdd689371$var$buffer = new Uint8Array();
const $884b6ddcdd689371$var$AiAssistant = ({ isLeftSideMenuCollapsed: isLeftSideMenuCollapsed })=>{
    const { accessToken: accessToken } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const { heygenStateOpen: heygenStateOpen, isGreetingsDone: isGreetingsDone } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.aiMessages);
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const [getAiAgentMessages, { data: aiAgentMessages, loading: aiAgentMessagesLoading }] = (0, $f442d9dc730cd5f3$export$47cb3c7e538d41ba)();
    const [createAiAgentMessage] = (0, $4cdb1470f9874f96$export$cb4c7b6a946a397c)({
        refetchQueries: [
            (0, $f442d9dc730cd5f3$export$ad65fcc6f7468098)
        ],
        awaitRefetchQueries: true,
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message)
    });
    const [isOpen, setIsOpen] = (0, $6fFrj.useState)(false);
    const [isRecording, setIsRecording] = (0, $6fFrj.useState)(false);
    const [isRecordingLoading, setIsRecordingLoading] = (0, $6fFrj.useState)(false);
    const [isWsConnected, setIsWsConnected] = (0, $6fFrj.useState)(false);
    const [inputValue, setInputValue] = (0, $6fFrj.useState)('');
    const [messages, setMessages] = (0, $6fFrj.useState)([]);
    const [isHeygenOpen, setIsHeygenOpen] = (0, $6fFrj.useState)(heygenStateOpen);
    const [aiProcessing, setAiProcessing] = (0, $6fFrj.useState)(false);
    const [isHeygenLoading, setIsHeygenLoading] = (0, $6fFrj.useState)(false);
    const [heygenParams, setHeygenParams] = (0, $6fFrj.useState)();
    const [heygenSessionId, setHeygenSessionId] = (0, $6fFrj.useState)();
    const [isFullScreenAvatar, setIsFullScreenAvatar] = (0, $6fFrj.useState)(false);
    const [isTrialUsageLimitExceeded, setIsTrialUsageLimitExceeded] = (0, $6fFrj.useState)(false);
    const [isHeygenUsageLimitExceeded, setIsHeygenUsageLimitExceeded] = (0, $6fFrj.useState)(false);
    const [isModalVisible, setIsModalVisible] = (0, $6fFrj.useState)(false);
    const [currentPlan, setCurrentPlan] = (0, $6fFrj.useState)('trial');
    const [isPromptsVisible, setIsPromptsVisible] = (0, $6fFrj.useState)(false);
    const messagesEndRef = (0, $6fFrj.useRef)();
    const avatar = (0, $6fFrj.useRef)();
    const isAvatarSpeaking = (0, $6fFrj.useRef)(false);
    const promptIdeas = [
        'Show me what you can do.',
        'Can you help me fill out Form 1040?',
        'Draft an email to my accountant asking for missing documents.',
        'What are the tax implications of selling my house?'
    ];
    const closeHeygen = (sessionId)=>{
        if ($884b6ddcdd689371$var$ws?.readyState === WebSocket.OPEN && sessionId) $884b6ddcdd689371$var$ws?.send(JSON.stringify({
            event: 'heygen_stop',
            data: sessionId
        }));
        setIsHeygenLoading(false);
        setHeygenParams({
            token: undefined,
            avatarId: undefined,
            voiceId: undefined,
            secondsLeft: 0
        });
        setHeygenSessionId(undefined);
        setIsFullScreenAvatar(false);
        isAvatarSpeaking.current = false;
        avatar.current = null;
    };
    const setSteamingAvatar = (val, sessionId)=>{
        avatar.current = val;
        setHeygenSessionId(sessionId);
        (0, $dfc6a33c14790f87$export$eae5917686cce945)();
        (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).HEYGEN_SESSION_ID, {
            sessionId: sessionId,
            url: window.location.href
        });
        $884b6ddcdd689371$var$ws?.send(JSON.stringify({
            event: 'heygen_session_id',
            data: sessionId
        }));
        if (!isGreetingsDone) {
            avatar.current?.speak({
                text: `
          Welcome to Taxaroo AI!
          You can chat here or talk to Taxaroo AI with your microphone
          to get your questions answered and complete your tasks.
          How can I assist you today?
        `,
                task_type: (0, $0fce50c6ae590ce1$export$1f8b1cab05cab788).REPEAT,
                taskMode: (0, $0fce50c6ae590ce1$export$b4af15ed7b5af758).SYNC
            });
            dispatch((0, $9f2fcb8c18c74f4f$export$1a5760e25fa92c7f)({
                isGreetingsDone: true
            }));
        }
        avatar.current?.on((0, $0fce50c6ae590ce1$export$1a7aeeed4753a2c0).STREAM_DISCONNECTED, ()=>closeHeygen(sessionId));
        avatar.current?.on((0, $0fce50c6ae590ce1$export$1a7aeeed4753a2c0).AVATAR_START_TALKING, ()=>{
            isAvatarSpeaking.current = true;
        });
        avatar.current?.on((0, $0fce50c6ae590ce1$export$1a7aeeed4753a2c0).AVATAR_STOP_TALKING, ()=>{
            isAvatarSpeaking.current = false;
        });
    };
    const stopRecording = async ()=>{
        if ($884b6ddcdd689371$var$audioContext?.state === 'running') await $884b6ddcdd689371$var$audioContext.close();
        $884b6ddcdd689371$var$mediaStream?.getTracks().forEach((track)=>track.stop());
        setIsRecording(false);
        setIsRecordingLoading(false);
    };
    const heygenStreamStart = ()=>{
        setIsHeygenLoading(true);
        $884b6ddcdd689371$var$ws?.send(JSON.stringify({
            event: 'heygen_start'
        }));
    };
    const scrollToBottom = ()=>{
        setTimeout(()=>messagesEndRef?.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'end'
            }), 200);
    };
    const onConnectionReady = (planType)=>{
        if (typeof isHeygenOpen === 'undefined') setIsHeygenOpen(true);
        setCurrentPlan(planType);
        setIsWsConnected(true);
        scrollToBottom();
    };
    const onConnectionError = async ()=>{
        await stopRecording();
        closeHeygen(heygenSessionId);
        setIsWsConnected(false);
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Connection error. Please try again later.', 10);
        $884b6ddcdd689371$var$ws?.close();
    };
    const onMessage = async (msg)=>{
        setMessages((msgs)=>[
                ...msgs,
                msg
            ]);
        scrollToBottom();
        // console.log('onMessage', msg, avatar.current);
        if (msg.type === (0, $8f7fe33a44836803$export$614f97abc1364581).Assistant && avatar.current && !isAvatarSpeaking.current) await avatar.current.speak({
            text: msg.text,
            task_type: (0, $0fce50c6ae590ce1$export$1f8b1cab05cab788).REPEAT,
            taskMode: (0, $0fce50c6ae590ce1$export$b4af15ed7b5af758).SYNC
        });
        // console.log('onMessage', msg.type, isAvatarSpeaking.current);
        if (msg.type === (0, $8f7fe33a44836803$export$614f97abc1364581).User && isAvatarSpeaking.current) await avatar.current?.interrupt();
    };
    const onProcessing = (isProcessing)=>{
        setAiProcessing(isProcessing);
        scrollToBottom();
    };
    const onHeygenStart = (token, avatarId, voiceId, secondsLeft)=>{
        setHeygenParams({
            token: token,
            avatarId: avatarId,
            voiceId: voiceId,
            secondsLeft: secondsLeft
        });
        setIsHeygenLoading(false);
    };
    const onHeygenStop = ()=>{
        setIsHeygenLoading(false);
    };
    const onError = async (msg)=>{
        if (msg === 'AI trial usage limit exceeded') {
            await avatar.current?.stopAvatar();
            setIsTrialUsageLimitExceeded(true);
            setIsHeygenLoading(false);
        } else if (msg === 'Video avatar usage limit exceeded') {
            await avatar.current?.stopAvatar();
            setIsHeygenUsageLimitExceeded(true);
            setIsHeygenLoading(false);
        } else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(msg, 10);
    };
    const toggleRecording = async ()=>{
        try {
            if (isRecording) await stopRecording();
            else {
                setIsRecordingLoading(true);
                // Request Microphone Access
                $884b6ddcdd689371$var$mediaStream = await navigator.mediaDevices.getUserMedia({
                    audio: true
                });
                $884b6ddcdd689371$var$audioContext = new AudioContext({
                    sampleRate: 24000
                });
                await $884b6ddcdd689371$var$audioContext.audioWorklet.addModule(URL.createObjectURL(new Blob([
                    (0, $956da5db9c582e0d$export$c7b96970ddc28cad)
                ], {
                    type: 'application/javascript'
                })));
                const mediaStreamSource = $884b6ddcdd689371$var$audioContext.createMediaStreamSource($884b6ddcdd689371$var$mediaStream);
                const workletNode = new AudioWorkletNode($884b6ddcdd689371$var$audioContext, 'audio-processor-worklet');
                workletNode.port.onmessage = (event)=>{
                    $884b6ddcdd689371$var$buffer = (0, $956da5db9c582e0d$export$7fc7650fb852f56e)($884b6ddcdd689371$var$buffer, event.data.buffer, $884b6ddcdd689371$var$ws);
                };
                mediaStreamSource.connect(workletNode);
                setIsRecording(true);
                setIsRecordingLoading(false);
            }
        } catch (err) {
            setIsRecordingLoading(false);
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message, 10);
        }
    };
    const sendUserMessage = (text = '')=>{
        const val = text || inputValue.trim();
        if (!val) return;
        if ($884b6ddcdd689371$var$ws.readyState !== WebSocket.OPEN) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Connection to server was closed. Please close and then open Taxaroo AI.', 10);
            return;
        }
        if (!text) setInputValue('');
        $884b6ddcdd689371$var$ws.send(JSON.stringify({
            event: 'text',
            data: val
        }));
    };
    const getElementCssClass = (name)=>{
        if (name === 'card') {
            if ((0, $0316ae7d1654226a$export$7d9f9b4046392aed)()) return isHeygenOpen ? $d2f51651a502d078$export$82ce2fb058198cb4 : $d2f51651a502d078$export$3d6e3b984efe848c;
            return isLeftSideMenuCollapsed ? $d2f51651a502d078$export$8bdfa8a552435f64 : $d2f51651a502d078$export$aa3e815946b80764;
        }
        if (name === 'avatar') {
            if ((0, $0316ae7d1654226a$export$7d9f9b4046392aed)()) return isFullScreenAvatar ? $d2f51651a502d078$export$9887a453d8f3cfe6 : $d2f51651a502d078$export$4ebea898d6ffa64e;
            return isLeftSideMenuCollapsed ? $d2f51651a502d078$export$4560b04a56651ee : $d2f51651a502d078$export$f43c995af6d00685;
        }
        if (name === 'msg') {
            if ((0, $0316ae7d1654226a$export$7d9f9b4046392aed)()) return isHeygenOpen ? $d2f51651a502d078$export$272a67247384d768 : $d2f51651a502d078$export$b83a7e5538acc1e8;
            return $d2f51651a502d078$export$defe85febe8b728c;
        }
        return '';
    };
    const connect = ()=>{
        $884b6ddcdd689371$var$ws = (0, $956da5db9c582e0d$export$f8367b7c5d4d854f)(accessToken, (planType)=>onConnectionReady(planType), ()=>onConnectionError(), async (msg)=>onMessage(msg), (isProcessing)=>onProcessing(isProcessing), (token, avatarId, voiceId, secondsLeft)=>onHeygenStart(token, avatarId, voiceId, secondsLeft), ()=>onHeygenStop(), (msg)=>onError(msg), ()=>{
            setIsWsConnected(false);
            closeHeygen(heygenSessionId);
        });
    };
    const subscriptionCreated = async (plan)=>{
        setIsTrialUsageLimitExceeded(false);
        setIsHeygenUsageLimitExceeded(false);
        setIsModalVisible(false);
        await createAiAgentMessage({
            variables: {
                createAiAgentMessageInput: {
                    type: (0, $8f7fe33a44836803$export$614f97abc1364581).System,
                    text: `Welcome back! '${plan}' plan unlocked`
                }
            }
        });
        connect();
    };
    const subscriptionCancelled = ()=>{
        setIsModalVisible(false);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (isOpen) connect();
        else {
            stopRecording();
            setAiProcessing(false);
            setIsTrialUsageLimitExceeded(false);
            setIsHeygenUsageLimitExceeded(false);
            setIsPromptsVisible(false);
            $884b6ddcdd689371$var$ws?.close();
            if (isHeygenOpen) setIsHeygenOpen(undefined);
        }
    }, [
        isOpen
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (!aiAgentMessagesLoading && aiAgentMessages?.getAiAgentMessages?.data) {
            const allMessages = messages.slice().filter((msg)=>msg.type !== (0, $8f7fe33a44836803$export$614f97abc1364581).Special);
            aiAgentMessages?.getAiAgentMessages?.data?.forEach((msg)=>{
                if (!messages.some((savedMsg)=>savedMsg.id === msg.id)) allMessages.push(msg);
            });
            allMessages.sort((a, b)=>a.createAt < b.createAt ? -1 : 1);
            setMessages([
                {
                    type: (0, $8f7fe33a44836803$export$614f97abc1364581).Special,
                    more: 'terms'
                },
                ...allMessages
            ]);
        }
    }, [
        aiAgentMessages,
        aiAgentMessagesLoading
    ]);
    (0, $6fFrj.useEffect)(()=>{
        getAiAgentMessages();
    }, []);
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                className: getElementCssClass('card'),
                title: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "space-between",
                    children: [
                        (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            justify: "start",
                            align: "middle",
                            children: [
                                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$f43044498c8a2821,
                                    children: (0, $bb3TF.jsx)((0, $50c2677d39bbc7c0$export$2e2bcd8739ae039), {})
                                }),
                                (0, $bb3TF.jsx)($884b6ddcdd689371$var$Text, {
                                    children: "Taxaroo AI"
                                })
                            ]
                        }),
                        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            justify: "start",
                            align: "middle",
                            children: !(0, $0316ae7d1654226a$export$7d9f9b4046392aed)() && (0, $bb3TF.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f5330f80cb38fce7$exports))), {
                                className: $d2f51651a502d078$export$b04dff55fbc80794,
                                offColor: "#d9d9d9",
                                onColor: "#3d80f3",
                                height: 32,
                                onChange: (val)=>{
                                    setIsHeygenOpen(val);
                                    dispatch((0, $9f2fcb8c18c74f4f$export$499f69d44b807de0)({
                                        heygenStateOpen: val
                                    }));
                                    if (!val) closeHeygen(heygenSessionId);
                                },
                                checked: isHeygenOpen || false,
                                uncheckedHandleIcon: (0, $bb3TF.jsx)((0, $7a51db8b8288e80f$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$74c0bcca122bbad9
                                }),
                                checkedHandleIcon: (0, $bb3TF.jsx)((0, $7a51db8b8288e80f$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$74c0bcca122bbad9
                                }),
                                checkedIcon: false,
                                uncheckedIcon: false
                            })
                        })
                    ]
                }),
                extra: (0, $bb3TF.jsx)($884b6ddcdd689371$var$Text, {
                    className: $d2f51651a502d078$export$8360e631d277ea4d,
                    onClick: ()=>setIsOpen(!isOpen),
                    children: "\u2715"
                }),
                style: isOpen ? {
                    display: 'block'
                } : {
                    display: 'none'
                },
                headStyle: {
                    borderBottom: '1px solid #eee'
                },
                bodyStyle: {
                    padding: 0
                },
                children: isWsConnected || isTrialUsageLimitExceeded ? (0, $bb3TF.jsxs)("div", {
                    style: {
                        position: 'relative'
                    },
                    children: [
                        (0, $bb3TF.jsxs)("div", {
                            className: getElementCssClass('msg'),
                            style: {
                                filter: isTrialUsageLimitExceeded ? 'blur(3px)' : 'none'
                            },
                            children: [
                                (0, $bb3TF.jsx)((0, $20d50b5d2220167a$export$2e2bcd8739ae039), {
                                    messages: messages,
                                    aiAgentMessagesLoading: aiAgentMessagesLoading,
                                    hasMore: aiAgentMessages?.getAiAgentMessages?.pagination?.total > messages.length - 1,
                                    loadMore: async ()=>{
                                        if (aiAgentMessages?.getAiAgentMessages?.pagination?.skip >= 0) await getAiAgentMessages({
                                            variables: {
                                                skip: aiAgentMessages.getAiAgentMessages.pagination.skip + 10
                                            }
                                        });
                                    }
                                }),
                                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    justify: "center",
                                    align: "middle",
                                    children: aiProcessing && (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {})
                                }),
                                (0, $bb3TF.jsx)("div", {
                                    ref: messagesEndRef
                                })
                            ]
                        }),
                        (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            justify: "space-between",
                            align: "middle",
                            className: $d2f51651a502d078$export$cc1adf6fb659c762,
                            children: [
                                (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                    value: inputValue,
                                    placeholder: "Send Message...",
                                    className: $d2f51651a502d078$export$b7e3ae3d7c15e42e,
                                    onChange: (evt)=>setInputValue(evt.target.value),
                                    onPressEnter: ()=>sendUserMessage(),
                                    disabled: isTrialUsageLimitExceeded,
                                    suffix: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                        type: "link",
                                        block: true,
                                        className: $d2f51651a502d078$export$80979908550ef2e5,
                                        loading: isRecordingLoading,
                                        onClick: ()=>toggleRecording(),
                                        disabled: isTrialUsageLimitExceeded,
                                        children: !isRecordingLoading && (0, $bb3TF.jsx)((0, $3206031044c2820c$export$2e2bcd8739ae039), {
                                            className: isRecording ? $d2f51651a502d078$export$f11273c1b5f874e0 : $d2f51651a502d078$export$3eda300cd928ec3a
                                        })
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
                                    placement: "topRight",
                                    trigger: [
                                        'click'
                                    ],
                                    disabled: isTrialUsageLimitExceeded,
                                    visible: isPromptsVisible,
                                    overlay: (0, $bb3TF.jsx)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                                        title: "Prompts ideas",
                                        className: $d2f51651a502d078$export$4b51f83d667101f4,
                                        headStyle: {
                                            padding: '0 20px'
                                        },
                                        bodyStyle: {
                                            padding: 0
                                        },
                                        extra: (0, $bb3TF.jsx)($884b6ddcdd689371$var$Text, {
                                            className: $d2f51651a502d078$export$8360e631d277ea4d,
                                            onClick: ()=>setIsPromptsVisible(false),
                                            children: "\u2715"
                                        }),
                                        children: promptIdeas.map((text, i)=>(0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                                className: $d2f51651a502d078$export$885d91d9d78b6eab,
                                                align: "middle",
                                                onClick: ()=>{
                                                    setIsPromptsVisible(false);
                                                    sendUserMessage(text);
                                                },
                                                children: [
                                                    (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                                        span: 22,
                                                        children: [
                                                            "\"",
                                                            text,
                                                            "\""
                                                        ]
                                                    }),
                                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                                        span: 2,
                                                        children: (0, $bb3TF.jsx)((0, $e31c9ce8f7532a60$export$2e2bcd8739ae039), {
                                                            className: $d2f51651a502d078$export$740b0382e45ae751
                                                        })
                                                    })
                                                ]
                                            }, i))
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $0b1323fcbd845168$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$696b0975d17cc695,
                                        onClick: ()=>setIsPromptsVisible(!isPromptsVisible)
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                    className: $d2f51651a502d078$export$bedddbe6384ecea0,
                                    type: "primary",
                                    shape: "circle",
                                    onClick: ()=>sendUserMessage(),
                                    disabled: isTrialUsageLimitExceeded,
                                    children: (0, $bb3TF.jsx)((0, $e31c9ce8f7532a60$export$2e2bcd8739ae039), {
                                        className: $d2f51651a502d078$export$8821ea1545299efc
                                    })
                                })
                            ]
                        }),
                        isTrialUsageLimitExceeded && (0, $bb3TF.jsx)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                            className: $d2f51651a502d078$export$ad5aef161e04a1f6,
                            bodyStyle: {
                                padding: '10px'
                            },
                            onClick: ()=>setIsModalVisible(!isModalVisible),
                            children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                justify: "middle",
                                children: [
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        span: 2,
                                        type: "flex",
                                        align: "middle",
                                        children: (0, $bb3TF.jsx)((0, $50c2677d39bbc7c0$export$2e2bcd8739ae039), {
                                            className: $d2f51651a502d078$export$c347cf29b438cff
                                        })
                                    }),
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        span: 16,
                                        style: {
                                            paddingLeft: '20px'
                                        },
                                        children: (0, $bb3TF.jsx)($884b6ddcdd689371$var$Text, {
                                            className: $d2f51651a502d078$export$7297643efb7d58a8,
                                            children: "Free trial has ended. Want to keep using Taxaroo AI"
                                        })
                                    }),
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        span: 6,
                                        type: "flex",
                                        align: "middle",
                                        style: {
                                            paddingLeft: '20px'
                                        },
                                        children: (0, $bb3TF.jsx)($884b6ddcdd689371$var$Text, {
                                            className: $d2f51651a502d078$export$f300abee67487310,
                                            children: "Get it now"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }) : (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    align: "middle",
                    justify: "center",
                    style: {
                        height: '470px'
                    },
                    children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                        size: "large"
                    })
                })
            }),
            isHeygenOpen && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                className: getElementCssClass('avatar'),
                align: "middle",
                justify: "center",
                children: (0, $bb3TF.jsx)((0, $ae1f3cf505f9c39c$export$2e2bcd8739ae039), {
                    ...heygenParams,
                    setSteamingAvatar: setSteamingAvatar,
                    heygenStreamStart: heygenStreamStart,
                    setFullscreenAvatar: (val)=>setIsFullScreenAvatar(val),
                    isTrialUsageLimitExceeded: isTrialUsageLimitExceeded,
                    isHeygenUsageLimitExceeded: isHeygenUsageLimitExceeded,
                    isHeygenLoading: isHeygenLoading,
                    planType: currentPlan,
                    isRecording: isRecording,
                    isRecordingLoading: isRecordingLoading,
                    toggleRecording: toggleRecording
                })
            }),
            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                className: isLeftSideMenuCollapsed ? $d2f51651a502d078$export$81dbf6606807a243 : $d2f51651a502d078$export$534219b709288da9,
                type: "default",
                shape: "round",
                onClick: ()=>setIsOpen(!isOpen),
                children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "space-between",
                    align: "middle",
                    children: [
                        (0, $bb3TF.jsx)((0, $50c2677d39bbc7c0$export$2e2bcd8739ae039), {}),
                        !isLeftSideMenuCollapsed && (0, $bb3TF.jsx)($884b6ddcdd689371$var$Text, {
                            className: $d2f51651a502d078$export$30b7d84b1e5fdac2,
                            children: "Taxaroo AI"
                        })
                    ]
                })
            }),
            (0, $bb3TF.jsx)((0, $a85f0f461805abf8$export$2e2bcd8739ae039), {
                isModalVisible: isModalVisible,
                closeModal: ()=>setIsModalVisible(false),
                subscriptionCreated: subscriptionCreated,
                subscriptionCancelled: subscriptionCancelled
            })
        ]
    });
};
var $884b6ddcdd689371$export$2e2bcd8739ae039 = $884b6ddcdd689371$var$AiAssistant;


const { useBreakpoint: $fc1c88b8ee8a4c96$var$useBreakpoint } = (0, $89d88a41b53d163f$export$2e2bcd8739ae039);
const { Content: $fc1c88b8ee8a4c96$var$Content } = (0, $0102c485edc5bdcf$export$2e2bcd8739ae039);
const $fc1c88b8ee8a4c96$var$PrivateRoute = ({ children: children })=>{
    const { accessToken: accessToken, firmCreatedAt: firmCreatedAt, email: email, firstName: firstName, lastName: lastName, userId: userId } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const screens = $fc1c88b8ee8a4c96$var$useBreakpoint();
    const location = (0, $990f835fb2356f36$export$45d76561a5302f2b)();
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const clientState = (0, $58073eff19365823$export$a7347740d65f620b)((0, $59a61dbb6cd2676b$export$6ff67ccf1d823f06));
    const [searchParams, setSearchParams] = (0, $a6e470ffbc8d2470$export$f1a78c17382fe22a)();
    const navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    const userIdParam = searchParams.get('userId');
    const tokenParam = searchParams.get('token');
    const firmIdParam = searchParams.get('firmId');
    const { data: isActiveFirm, loading: isActiveFirmLoading } = (0, $732264f53056e08f$export$a4138ee1626213b6)();
    const { data: currentStripeInformation } = (0, $732264f53056e08f$export$9f382c5aef9c5d4d)();
    const { customerId: customerId, finishedOnboarding: finishedOnboarding } = currentStripeInformation?.CurrentStripeInformation ?? {};
    const { showModal: showModal, accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    const [isLeftMenuCollapsed, setIsLeftMenuCollapsed] = (0, $6fFrj.useState)(false);
    let isLeftSideMenuCollapsed = isLeftMenuCollapsed;
    const setIsLeftSideMenuCollapsed = (val)=>{
        isLeftSideMenuCollapsed = val;
    };
    const [loginAsFirm] = (0, $7e016fc573eed7c4$export$affaa2272344e1c5)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`Login as Firm error: ${err.message}`, 5)
    });
    const handleLoginAsFirm = async ()=>{
        const result = await loginAsFirm({
            variables: {
                token: tokenParam,
                userId: userIdParam,
                firmId: firmIdParam
            }
        });
        if (result.data?.LoginAsFirm?.accessToken) {
            const { accessToken: accessTokenLoginAs, UserFirmAccount: UserFirmAccount } = result.data.LoginAsFirm;
            (0, $bc55ebad68166096$export$4001836ab2b836f2)(dispatch, accessTokenLoginAs, UserFirmAccount);
            dispatch((0, $e3b9937a336ce5aa$export$940f9a34d01c641a)({
                accessToken: accessToken
            }));
            navigate('/', {
                replace: true
            });
        }
    };
    (0, $6fFrj.useEffect)(()=>{
        (0, $d2dcc1acacbd89bc$export$c16848faee2ad07b)(false);
    }, [
        location.key
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (Object.values(clientState).some((val)=>val) && location.pathname !== '/clients/details') dispatch((0, $59a61dbb6cd2676b$export$b7c209536cc73fdf)({
            id: undefined,
            email: undefined,
            lastName: undefined,
            entityId: undefined,
            firstName: undefined,
            phoneNumber: undefined,
            jobs: [],
            job: undefined
        }));
    }, [
        location.pathname
    ]);
    // login as firm
    (0, $6fFrj.useEffect)(()=>{
        if (tokenParam && userIdParam) handleLoginAsFirm();
    }, []);
    // load upvoty
    (0, $6fFrj.useEffect)(()=>{
        const script = document.createElement('script');
        script.src = 'https://taxaroo.upvoty.com/javascript/upvoty.embed.js';
        script.async = true;
        script.onload = ()=>{
            // eslint-disable-next-line
            if (typeof window.upvoty !== 'undefined') window.upvoty.init('identify', {
                user: {
                    id: userId,
                    name: `${firstName} ${lastName}`,
                    email: email
                },
                baseUrl: 'taxaroo.upvoty.com',
                publicKey: '4d2a655bc7f2672b0b731a56a8f2a2ca'
            });
        };
        document.head.appendChild(script);
        // Cleanup: remove the script when the component unmounts
        return ()=>{
            document.head.removeChild(script);
        };
    }, []);
    // load Stunning
    (0, $6fFrj.useEffect)(()=>{
        const loadStunning = ()=>{
            // Check if script is already loaded to prevent duplicates
            if (document.getElementById('stunning-bar')) return;
            const script = document.createElement('script');
            script.id = 'stunning-bar';
            script.src = 'https://d1gqkepxkcxgvm.cloudfront.net/stunning-bar.js';
            script.defer = true;
            script.setAttribute('data-app-ckey', '4461kfruqgwcvoyjpsninppsp');
            script.setAttribute('data-stripe-id', customerId);
            const s = document.getElementsByTagName('script')[0];
            s.parentNode?.insertBefore(script, s);
        };
        loadStunning();
        (0, $dfc6a33c14790f87$export$3d6a71dac8f63b0b)(finishedOnboarding);
        // Cleanup: remove the script when the component unmounts or accessToken changes
        return ()=>{
            const script = document.getElementById('stunning-bar');
            if (script) script.parentNode?.removeChild(script);
        };
    }, [
        accessToken
    ]);
    if (!accessToken) {
        navigate('/login', {
            state: {
                from: location
            }
        });
        return null;
    }
    if (isActiveFirmLoading) return (0, $bb3TF.jsx)("div", {
        style: {
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        children: (0, $bb3TF.jsx)("div", {
            style: {
                height: '100px',
                width: '100px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                size: "large"
            })
        })
    });
    if (!isActiveFirmLoading && !isActiveFirm.isActiveFirm) return (0, $bb3TF.jsx)((0, $4a88a2e17dcaaf5e$export$2e2bcd8739ae039), {
        customerId: customerId
    });
    return (0, $bb3TF.jsxs)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
        children: [
            customerId && (0, $bb3TF.jsx)((0, $c6fb91589b91dceb$export$2e2bcd8739ae039), {
                customerId: customerId
            }),
            (0, $bb3TF.jsx)((0, $88deb7406c310004$export$2e2bcd8739ae039), {}),
            (0, $bb3TF.jsxs)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
                style: {
                    minHeight: 'calc(100vh - 100px)'
                },
                children: [
                    screens.md ? (0, $bb3TF.jsx)((0, $1f5c1bf3677eafd4$export$2e2bcd8739ae039), {
                        stateChanged: (isCollapsed)=>setIsLeftMenuCollapsed(isCollapsed)
                    }) : setIsLeftSideMenuCollapsed(true),
                    (0, $bb3TF.jsx)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
                        style: {
                            padding: 0
                        },
                        children: (0, $bb3TF.jsx)($fc1c88b8ee8a4c96$var$Content, {
                            style: {
                                background: '#fff',
                                margin: 0,
                                minHeight: 280,
                                padding: (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? 16 : 24
                            },
                            children: (0, $bb3TF.jsx)((0, $6fFrj.Suspense), {
                                fallback: (0, $bb3TF.jsx)("div", {
                                    style: {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignContent: 'flex-start'
                                    },
                                    children: (0, $bb3TF.jsx)((0, $53a209758b3184a9$export$2e2bcd8739ae039), {
                                        size: "calc(100vh - 100px)",
                                        type: "full",
                                        id: "loading_jobs"
                                    })
                                }),
                                children: children
                            })
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)("a", {
                href: "https://taxaroo.upvoty.com/b/feature-requests/",
                target: "_blank",
                rel: "noreferrer",
                style: {
                    position: 'fixed',
                    bottom: 22,
                    right: 6,
                    zIndex: 999,
                    color: 'gray',
                    fontSize: 14
                },
                children: "Feature request?"
            }),
            (0, $bb3TF.jsx)((0, $b12c3bef87fed051$export$2e2bcd8739ae039), {}),
            Boolean(accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).aiResearch]) && (0, $bb3TF.jsx)((0, $884b6ddcdd689371$export$2e2bcd8739ae039), {
                isLeftSideMenuCollapsed: isLeftSideMenuCollapsed
            })
        ]
    });
};
var $fc1c88b8ee8a4c96$export$2e2bcd8739ae039 = $fc1c88b8ee8a4c96$var$PrivateRoute;


var $8179f22897d97d36$export$2e2bcd8739ae039 = (0, $fc1c88b8ee8a4c96$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


const $b72a40106d659ce4$export$693ba5b7fe7beabd = ({ children: children })=>{
    const location = (0, $990f835fb2356f36$export$45d76561a5302f2b)();
    (0, $6fFrj.useEffect)(()=>{
        (0, $dfc6a33c14790f87$export$92ab14d0aa42e41e)();
    }, [
        location.pathname
    ]);
    return(// eslint-disable-next-line react/jsx-no-useless-fragment
    (0, $bb3TF.jsx)((0, $bb3TF.Fragment), {
        children: children
    }));
};



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



var $d39389d1772dfafb$exports = {};
$d39389d1772dfafb$exports = JSON.parse("{\"v\":\"5.7.7\",\"fr\":30,\"ip\":0,\"op\":122,\"w\":500,\"h\":500,\"nm\":\"404\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Chat\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":60,\"s\":[-10]},{\"t\":120,\"s\":[0]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[142.881,243.744,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[36.293,35.738,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-0.335,1.357],[-0.473,-3.38],[0.474,-3.38],[0.336,1.357]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0.345],[-0.335,0],[0,-0.355],[0.355,0]],\"o\":[[0,-0.355],[0.355,0],[0,0.345],[-0.346,0]],\"v\":[[-0.582,2.769],[0,2.156],[0.582,2.769],[0,3.38]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[29.586,17.252],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-0.435,0],[0,0.396],[0.642,0.237],[0,0.573],[-1.026,0],[-0.266,-0.158],[0,0],[0.445,0],[0,-0.355],[-0.621,-0.237],[0,-0.711],[1.135,0],[0.336,0.196]],\"o\":[[0.256,0.167],[0.631,0],[0,-0.414],[-0.859,-0.305],[0,-0.769],[0.484,0],[0,0],[-0.187,-0.118],[-0.512,0],[0,0.394],[0.829,0.316],[0,0.839],[-0.523,0],[0,0]],\"v\":[[-1.347,1.505],[-0.202,1.851],[0.725,1.139],[-0.163,0.261],[-1.426,-1.091],[0.222,-2.492],[1.396,-2.196],[1.179,-1.565],[0.202,-1.841],[-0.597,-1.189],[0.311,-0.38],[1.564,1.061],[-0.222,2.492],[-1.564,2.167]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[26.49,18.131],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-0.02,-0.108],[-0.621,0],[0,1.095],[0.918,0],[0.167,-0.651],[0,-0.118]],\"o\":[[0,0.127],[0.158,0.602],[0.918,0],[0,-0.957],[-0.592,0],[-0.03,0.109],[0,0]],\"v\":[[-1.382,-0.479],[-1.342,-0.124],[-0.04,0.893],[1.411,-0.953],[-0.01,-2.729],[-1.322,-1.654],[-1.382,-1.298]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0.02,0.454],[0,0],[0,0],[0,0],[-0.781,0],[0,-1.45],[1.126,0],[0.286,0.474],[0,0],[0,0],[0,0]],\"o\":[[0,-0.611],[0,0],[0,0],[0,0],[0.355,-0.582],[1.154,0],[0,1.718],[-0.632,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-2.24,-1.753],[-2.279,-3.311],[-1.499,-3.311],[-1.46,-2.492],[-1.441,-2.492],[0.257,-3.419],[2.279,-0.992],[0.108,1.573],[-1.361,0.823],[-1.382,0.823],[-1.382,3.419],[-2.24,3.419]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[21.883,19.059],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-0.908],[-0.848,0],[0,1.075],[1.026,0]],\"o\":[[0,1.046],[0.83,0],[0,-0.809],[-1.028,0]],\"v\":[[-1.456,0.009],[-0.006,1.846],[1.445,-0.01],[0.015,-1.846]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-1.461],[1.155,0],[0,1.51],[-1.323,0]],\"o\":[[0,1.766],[-1.293,0],[0,-1.598],[1.371,0]],\"v\":[[2.334,-0.04],[-0.045,2.497],[-2.334,0.04],[0.034,-2.497]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[16.21,18.136],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":4,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-1.46],[-1.352,0],[0,1.509],[1.431,0]],\"o\":[[0,1.421],[1.362,0],[0,-1.322],[-1.421,0]],\"v\":[[-2.121,0.039],[0.001,2.733],[2.132,-0.029],[0.01,-2.733]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,-1.974],[1.699,0],[0,2.013],[-1.776,0]],\"o\":[[0,2.29],[-1.756,0],[0,-2.112],[1.816,0]],\"v\":[[3.04,-0.069],[-0.049,3.435],[-3.04,0.06],[0.049,-3.435]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[10.053,17.198],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":5,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,2.998],[9.799,0],[0,-9.799],[-9.8,0],[-3.216,3.25]],\"o\":[[0,0],[1.314,-2.477],[0,-9.799],[-9.8,0],[0,9.799],[4.933,0],[0,0]],\"v\":[[18.021,12.994],[15.401,8.296],[17.465,0],[-0.278,-17.744],[-18.021,0],[-0.278,17.744],[12.331,12.477]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.067422320796,0.535545558555,0.76966827991,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[18.271,17.994],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 6\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":6,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"Sun\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[126.446,153.563,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[26.705,26.705,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[14.51,0.118],[0,-9.253],[14.61,0],[0.073,0],[-5.357,0],[0,14.61]],\"o\":[[7.195,4.728],[0,14.61],[-0.073,0],[4.166,2.738],[14.611,0],[0,-14.538]],\"v\":[[-5.757,-26.452],[6.193,-4.332],[-20.262,22.122],[-20.48,22.117],[-5.975,26.452],[20.48,-0.002]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.643597830978,0.349760466931,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[32.679,26.707],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,14.61],[14.611,0],[0,-14.611],[-14.61,0]],\"o\":[[0,-14.611],[-14.61,0],[0,14.61],[14.611,0]],\"v\":[[26.455,0],[0,-26.455],[-26.455,0],[0,26.455]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.762087115119,0.33839934106,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[26.705,26.705],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"Cloud 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":0,\"s\":[275.655,133.258,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":60.5,\"s\":[265.655,133.258,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":121,\"s\":[275.655,133.258,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":181.5,\"s\":[265.655,133.258,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":242,\"s\":[275.655,133.258,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[38.693,16.315,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[11.022,0.536],[0.305,0],[1.778,-0.571],[9.406,0],[1.221,-9.28],[2.698,0],[1.395,-0.36],[-9.963,0]],\"o\":[[11.035,0],[-0.301,-0.014],[-1.968,0],[-1.474,-8.989],[-9.614,0],[-2.28,-1.093],[-1.508,0],[-9.649,2.484],[0,0]],\"v\":[[26.638,16.065],[27.262,-1.078],[26.354,-1.1],[20.714,-0.217],[2.033,-16.065],[-16.736,0.38],[-24.27,-1.326],[-28.635,-0.775],[-26.296,16.065]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.851184740254,0.944075879864,0.977253693225,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[38.534,16.315],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"Cloud 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":-6,\"s\":[408.205,215.102,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":54.5,\"s\":[418.205,215.102,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":115,\"s\":[408.205,215.102,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":175.5,\"s\":[418.205,215.102,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":236,\"s\":[408.205,215.102,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[38.705,16.32,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[11.025,0.535],[0.305,0],[1.779,-0.571],[9.409,0],[1.221,-9.283],[2.699,0],[1.395,-0.359],[-9.966,0]],\"o\":[[11.038,0],[-0.301,-0.015],[-1.968,0],[-1.475,-8.991],[-9.616,0],[-2.282,-1.094],[-1.508,0],[-9.652,2.486],[0,0]],\"v\":[[26.647,16.07],[27.271,-1.077],[26.362,-1.099],[20.72,-0.217],[2.034,-16.07],[-16.741,0.381],[-24.277,-1.326],[-28.643,-0.776],[-26.303,16.07]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.851184740254,0.944075879864,0.977253693225,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[38.546,16.32],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":4,\"nm\":\"Cloud 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":-12,\"s\":[75.447,202.51,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":48.5,\"s\":[85.447,202.51,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":109,\"s\":[75.447,202.51,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":169.5,\"s\":[85.447,202.51,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":230,\"s\":[75.447,202.51,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[33.722,17.949,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-0.472,3.462],[0,0.644],[7.709,0],[0.311,-0.021],[7.767,0],[0,-8.189],[-0.026,-0.357],[2.881,-0.132],[0.527,-7.437],[0.003,-0.059],[-4.052,0]],\"o\":[[3.495,0],[0.084,-0.621],[0,-7.709],[-0.317,0],[-0.637,-7.602],[-8.19,0],[0,0.363],[-2.324,-1.298],[-7.449,0.341],[-0.004,0.059],[-0.24,4.045],[0,0]],\"v\":[[26.225,17.698],[33.23,11.698],[33.358,9.799],[19.4,-4.159],[18.459,-4.125],[3.687,-17.698],[-11.141,-2.871],[-11.098,-1.792],[-19.011,-3.651],[-33.107,10.085],[-33.118,10.262],[-26.036,17.698]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.851184740254,0.944075879864,0.977253693225,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[33.608,17.949],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":4,\"nm\":\"Stop 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[375.98,365.662,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[27.035,28.547,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[4.747,3.494],[4.747,3.504],[-1.869,3.504],[-1.869,3.494],[-4.747,-3.504],[1.869,-3.504]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.431284317316,0.580090092678,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[38.859,32.314],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[4.747,3.499],[-1.87,3.499],[-4.747,-3.499],[1.869,-3.499]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.431284317316,0.580090092678,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[33.633,19.634],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[16.233,3.494],[16.233,3.504],[-16.233,3.504],[-16.233,3.494],[-13.354,-3.504],[13.354,-3.504]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.067422320796,0.535545558555,0.76966827991,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[27.373,32.314],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[11.006,3.499],[-11.006,3.499],[-8.128,-3.499],[8.129,-3.499]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.067422320796,0.535545558555,0.76966827991,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[27.373,19.634],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":4,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.92,-2.231],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.92,-2.231],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[12.425,23.95],[5.809,23.95],[0.494,11.06],[0.494,11.051],[-2.384,4.053],[-3.176,2.135],[-4.468,-0.987],[-4.732,-1.624],[-7.609,-8.622],[-8.138,-9.895],[-12.425,-20.318],[-11.622,-22.276],[-6.621,-22.276],[-1.522,-9.895],[-0.993,-8.622],[1.884,-1.624],[2.149,-0.987],[3.441,2.135],[4.233,4.053],[7.111,11.051],[7.111,11.06]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.977253693225,0.576305494121,0.212304268631,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[36.495,24.761],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":5,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-5.787,3.786],[5.787,3.786],[5.787,-3.786],[-5.787,-3.786]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.323235066732,0.721325324563,0.84739373899,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[48.033,52.5],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 6\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":6,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[26.785,-3.786],[-26.785,-3.786],[-26.785,3.786],[26.785,3.786]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.502362539254,0.799053237017,0.914689307119,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[27.035,52.5],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 7\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":7,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-20.324,-3.718],[-23.388,3.718],[23.388,3.718],[20.323,-3.718]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.977253693225,0.576305494121,0.212304268631,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[27.377,49.441],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 8\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":8,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.92,-2.231],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0.92,-2.231],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[23.387,26.455],[-23.387,26.455],[-16.233,9.112],[-16.233,9.102],[-13.355,2.104],[-12.562,0.185],[-11.27,-2.937],[-11.007,-3.572],[-8.129,-10.57],[-7.6,-11.843],[-2.501,-24.224],[2.5,-24.224],[7.599,-11.843],[8.128,-10.57],[11.005,-3.572],[11.27,-2.937],[12.562,0.185],[13.354,2.104],[16.232,9.102],[16.232,9.112]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.762087115119,0.33839934106,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[27.374,26.705],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 9\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":9,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":4,\"nm\":\"Stop\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[250,250,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[53.048,-52.122,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,2.311],[2.311,0],[0,-2.31],[-2.31,0]],\"o\":[[0,-2.31],[-2.31,0],[0,2.311],[2.311,0]],\"v\":[[4.183,-0.001],[-0.001,-4.184],[-4.183,-0.001],[-0.001,4.184]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.067422320796,0.535545558555,0.76966827991,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[124.399,9.48],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,5.099],[5.098,0],[0,-5.098],[-5.098,0]],\"o\":[[0,-5.098],[-5.098,0],[0,5.099],[5.098,0]],\"v\":[[9.231,-0.001],[0.001,-9.23],[-9.231,-0.001],[0.001,9.23]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.762087115119,0.33839934106,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[124.399,9.48],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,2.311],[2.311,0],[0,-2.31],[-2.31,0]],\"o\":[[0,-2.31],[-2.31,0],[0,2.311],[2.311,0]],\"v\":[[4.184,-0.001],[-0.001,-4.184],[-4.184,-0.001],[-0.001,4.184]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.067422320796,0.535545558555,0.76966827991,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[23.438,9.48],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,5.099],[5.098,0],[0,-5.098],[-5.098,0]],\"o\":[[0,-5.098],[-5.098,0],[0,5.099],[5.098,0]],\"v\":[[9.231,-0.001],[-0.001,-9.23],[-9.231,-0.001],[-0.001,9.23]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.762087115119,0.33839934106,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[23.439,9.48],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":4,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-250,250],[250,250],[250,-250],[-250,-250]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-250,-250],[250,-250],[250,250],[-250,250]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":2,\"ty\":\"sh\",\"ix\":3,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-48.705,100.602],[91.534,100.602],[91.534,85.666],[-48.705,85.666]],\"c\":true},\"ix\":2},\"nm\":\"Path 3\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":3,\"ty\":\"sh\",\"ix\":4,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[91.534,85.666],[-48.705,85.666],[-48.705,100.602],[91.534,100.602]],\"c\":true},\"ix\":2},\"nm\":\"Path 4\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.5,0.5,0.5,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[53.048,-52.122],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":6,\"cix\":2,\"bm\":0,\"ix\":5,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[8.445,-3.424],[4.945,3.626],[-8.445,3.626],[-4.852,-3.626]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.431284317316,0.580090092678,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[138.669,24.251],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 6\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":6,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[8.495,-3.626],[4.902,3.626],[-8.495,3.626],[-4.902,-3.626]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.431284317316,0.580090092678,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[108.52,24.251],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 7\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":7,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[8.499,-3.626],[4.905,3.626],[-8.499,3.626],[-4.906,-3.626]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.431284317316,0.580090092678,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[78.324,24.251],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 8\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":8,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[8.499,-3.626],[4.906,3.626],[-8.499,3.626],[-4.906,-3.626]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.431284317316,0.580090092678,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[48.125,24.251],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 9\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":9,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[8.502,-3.626],[4.909,3.626],[-8.502,3.626],[-4.902,-3.626]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.431284317316,0.580090092678,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[17.922,24.251],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 10\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":10,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[0.758,-14.93],[-14.054,14.93],[-0.656,14.93],[14.054,-14.728]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.067422320796,0.535545558555,0.76966827991,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[133.059,35.556],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 11\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":11,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[14.104,-14.93],[-0.7,14.93],[-14.104,14.93],[0.707,-14.93]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.067422320796,0.535545558555,0.76966827991,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[102.911,35.556],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 12\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":12,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[14.108,-14.93],[-0.704,14.93],[-14.108,14.93],[0.703,-14.93]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.067422320796,0.535545558555,0.76966827991,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[72.715,35.556],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 13\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":13,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[0.704,-14.93],[-14.107,14.93],[-0.704,14.93],[14.107,-14.93]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.067422320796,0.535545558555,0.76966827991,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[42.515,35.556],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 14\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":14,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[13.087,-14.93],[-1.724,14.93],[-13.087,14.93],[-13.087,10.811],[-0.317,-14.93]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.067422320796,0.535545558555,0.76966827991,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[13.337,35.556],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 15\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":15,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-5.176,0.292],[5.176,0.292],[5.176,-0.292],[-5.176,-0.292]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.323235066732,0.721325324563,0.84739373899,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[124.46,20.308],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 16\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":16,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-5.176,0.292],[5.176,0.292],[5.176,-0.292],[-5.176,-0.292]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.323235066732,0.721325324563,0.84739373899,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[23.708,20.308],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 17\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":17,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[1.531,2.318],[-1.531,2.318],[-1.531,-2.318],[1.531,-2.318]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.323235066732,0.721325324563,0.84739373899,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[128.106,18.278],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 18\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":18,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[5.176,2.318],[-5.176,2.318],[-5.176,-2.318],[5.176,-2.318]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.502362539254,0.799053237017,0.914689307119,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[124.46,18.278],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 19\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":19,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[1.176,2.318],[-1.176,2.318],[-1.176,-2.318],[1.176,-2.318]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.323235066732,0.721325324563,0.84739373899,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[27.709,18.278],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 20\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":20,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[5.176,2.318],[-5.176,2.318],[-5.176,-2.318],[5.176,-2.318]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.502362539254,0.799053237017,0.914689307119,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[23.709,18.278],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 21\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":21,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[5.176,-2.571],[-5.176,-2.571],[-5.176,2.571],[5.176,2.571]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.323235066732,0.721325324563,0.84739373899,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[124.46,53.027],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 22\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":22,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[5.176,-2.571],[-5.176,-2.571],[-5.176,2.571],[5.176,2.571]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.323235066732,0.721325324563,0.84739373899,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[23.709,53.027],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 23\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":23,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[1.531,-20.414],[-1.531,-20.414],[-1.531,20.414],[1.531,20.414]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.323235066732,0.721325324563,0.84739373899,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[128.106,70.902],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 24\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":24,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[5.176,-20.414],[-5.176,-20.414],[-5.176,20.414],[5.176,20.414]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.502362539254,0.799053237017,0.914689307119,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[124.46,70.902],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 25\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":25,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[1.176,-20.414],[-1.176,-20.414],[-1.176,20.414],[1.176,20.414]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.323235066732,0.721325324563,0.84739373899,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[27.709,70.902],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 26\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":26,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[5.176,-20.414],[-5.176,-20.414],[-5.176,20.414],[5.176,20.414]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.502362539254,0.799053237017,0.914689307119,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[23.709,70.902],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 27\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":27,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[8.445,-3.626],[8.445,-3.423],[4.945,3.626],[-8.445,3.626],[-4.852,-3.626]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.970616718367,0.520378322227,0.218980901382,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[138.669,24.251],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 28\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":28,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-4.902,-3.626],[8.495,-3.626],[4.903,3.626],[-8.495,3.626]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.970616718367,0.520378322227,0.218980901382,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[108.519,24.251],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 29\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":29,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-4.905,-3.626],[8.499,-3.626],[4.906,3.626],[-8.499,3.626]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.970616718367,0.520378322227,0.218980901382,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[78.324,24.251],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 30\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":30,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-4.906,-3.626],[8.499,-3.626],[4.907,3.626],[-8.499,3.626]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.970616718367,0.520378322227,0.218980901382,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[48.124,24.251],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 31\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":31,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-4.902,-3.626],[8.502,-3.626],[4.91,3.626],[-8.502,3.626]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.970616718367,0.520378322227,0.218980901382,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[17.922,24.251],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 32\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":32,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-250,250],[250,250],[250,-250],[-250,-250]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-250,-250],[250,-250],[250,250],[-250,250]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":2,\"ty\":\"sh\",\"ix\":3,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-52.798,79.995],[94.065,79.995],[94.065,72.747],[-52.798,72.747]],\"c\":true},\"ix\":2},\"nm\":\"Path 3\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.977253693225,0.576305494121,0.212304268631,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[53.048,-52.122],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 33\",\"np\":5,\"cix\":2,\"bm\":0,\"ix\":33,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[73.432,14.93],[-73.432,14.93],[-73.432,-14.93],[73.432,-14.93]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.762087115119,0.33839934106,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[73.682,35.555],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 34\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":34,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":4,\"nm\":\"Bucket\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[103.69,379.763,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[16.498,13.983,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[1.864,0],[0,0],[-0.292,1.84],[0,0]],\"o\":[[0,0],[-0.293,1.84],[0,0],[1.863,0],[0,0],[0,0]],\"v\":[[-0.135,-13.732],[-3.994,10.538],[-7.738,13.732],[0.135,13.732],[3.878,10.538],[7.738,-13.732]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.643597830978,0.349760466931,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[25.007,13.983],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[15.609,2.008],[16.247,-2.008],[-16.247,-2.008],[-15.609,2.008]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.643597830978,0.349760466931,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[16.498,2.257],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[-1.864,0],[0,0],[-0.293,1.84]],\"o\":[[0,0],[0,0],[0.293,1.84],[0,0],[1.864,0],[0,0]],\"v\":[[16.247,-13.733],[-16.247,-13.733],[-12.389,10.537],[-8.645,13.733],[8.645,13.733],[12.389,10.537]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.762087115119,0.33839934106,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[16.497,13.983],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":4,\"nm\":\"Leaf 4\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":60.5,\"s\":[10]},{\"t\":121,\"s\":[0]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[106.472,369.556,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0.229,23.156,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[6.724,-3.362],[0.562,-2.324],[0,0],[0.545,-0.815]],\"o\":[[-3.807,1.903],[19.062,-6.13],[-0.076,0.356],[-1.869,3.275]],\"v\":[[-4.068,4.264],[-10.02,11.053],[10.02,-11.053],[9.051,-9.232]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.323235066732,0.721325324563,0.84739373899,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[12.688,11.303],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[21.41,-5.497],[-6.213,1.255],[-0.386,1.801]],\"o\":[[0,0],[6.213,-1.255],[0,0]],\"v\":[[-11.229,11.406],[-2.504,0.831],[11.229,-11.406]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.502362539254,0.799053237017,0.914689307119,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[11.479,11.656],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":10,\"ty\":4,\"nm\":\"Leaf 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":60.5,\"s\":[-10]},{\"t\":121,\"s\":[0]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[95.516,369.617,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[24.169,50.869,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0.062,-0.099],[0,0]],\"o\":[[0.122,-0.153],[-0.069,0.058]],\"v\":[[-0.098,0.121],[0.098,-0.121]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.323235066732,0.721325324563,0.84739373899,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[10.871,0.372],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[1.55,-2.455],[-11.767,-7.216],[0,0],[0,0],[0.27,2.259],[6.071,6.569],[-1.673,2.675]],\"o\":[[-3.542,9.593],[8.664,5.313],[0,0],[0.125,-1.885],[-0.744,-6.22],[-3.012,-3.26],[-0.491,0.618]],\"v\":[[-8.489,-19.959],[3.367,8.469],[9.272,24.829],[10.687,20.471],[10.556,14.133],[-2.756,-2.156],[-5.061,-24.829]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.323235066732,0.721325324563,0.84739373899,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[15.834,25.321],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0.744,6.218],[6.071,6.57],[-1.937,1.661],[-1.653,-9.51],[-1.618,-4.596],[0,0]],\"o\":[[0,0],[-0.743,-6.22],[-3.123,-3.379],[0,0],[1.653,9.511],[1.619,4.594],[0,0]],\"v\":[[12.044,25.564],[12.698,13.585],[-0.614,-2.705],[-2.724,-25.62],[-11.789,-3.121],[8.967,17.167],[10.452,25.62]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.502362539254,0.799053237017,0.914689307119,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[13.692,25.869],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":11,\"ty\":4,\"nm\":\"Leaf 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":60.5,\"s\":[5]},{\"t\":121,\"s\":[0]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[104.319,369.383,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[4.676,46.304,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[10.719,-7.802],[-1.663,-4.168],[-0.324,-0.106],[-9.491,6.359],[0,0]],\"o\":[[-10.719,7.802],[0.13,0.324],[-1.437,-9.564],[9.613,-6.44],[0,0]],\"v\":[[-1.762,1.516],[-11.694,22.473],[-10.996,23.101],[3.744,6.09],[10.322,-23.101]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.323235066732,0.721325324563,0.84739373899,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[16.744,23.351],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-7.385,9.421],[-0.235,4.792],[9.613,-6.44],[-1.666,-9.908]],\"o\":[[0,0],[7.385,-9.42],[0,0],[-9.613,6.439],[0,0]],\"v\":[[-10.569,23.304],[-7.541,3.003],[11.89,-23.304],[5.313,5.887],[-9.375,23.263]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.502362539254,0.799053237017,0.914689307119,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[15.176,23.554],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":12,\"ty\":4,\"nm\":\"Leaf 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":60.5,\"s\":[-5]},{\"t\":121,\"s\":[0]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[99.717,370.267,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[17.034,68.17,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0.892,-3.579],[-1.425,-2.148],[-0.239,0.371],[-0.821,4.335],[1.891,8.706],[0.049,1.46],[-7.527,-12.587]],\"o\":[[-0.892,3.58],[0.133,0.201],[-0.435,-1.483],[1.52,-8.024],[-1.892,-8.705],[0,0],[5.39,9.012]],\"v\":[[3.298,17.823],[3.293,32.526],[3.856,32.242],[3.957,23.823],[7.442,-0.613],[-9.333,-32.727],[0.429,-1.852]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.323235066732,0.721325324563,0.84739373899,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[14.159,34.435],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-1.52,8.025],[1.891,8.705],[0.05,1.459],[-7.671,-10.633],[0.341,-5.592],[-0.841,-1.3]],\"o\":[[0,0],[1.52,-8.024],[-1.892,-8.705],[-0.05,-1.459],[7.67,10.634],[-0.341,5.592],[0,0]],\"v\":[[6.99,33.678],[6.245,23.539],[9.73,-0.896],[-7.045,-33.01],[-3.95,3.158],[4.303,23.074],[5.223,34.469]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.502362539254,0.799053237017,0.914689307119,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[11.871,34.719],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":13,\"ty\":4,\"nm\":\"wrist\",\"parent\":15,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[5]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":30.752,\"s\":[-5]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":61,\"s\":[5]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":91.752,\"s\":[-5]},{\"t\":122,\"s\":[5]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[33.75,8.04,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[33.497,12.944,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0.722,0.538],[0,0],[0,0],[-3.492,-2.424],[-2.246,2.526]],\"o\":[[-8.277,-6.134],[0,0],[0,0],[0.589,0.409],[0.59,-0.669]],\"v\":[[15.957,3.141],[-14.927,-7.898],[-16.79,-4.503],[1.724,3.743],[16.2,5.372]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.762087115119,0.33839934106,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[17.04,8.147],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":14,\"ty\":4,\"nm\":\"Finger\",\"parent\":13,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[1.165,1.724,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[4.595,3.288,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0.507,-1.297],[-1.159,-0.739],[0,0],[-0.179,-0.144],[-1.641,-0.057]],\"o\":[[0,0],[-0.333,0.849],[0,0],[-0.227,0.037],[0.285,0.23],[0,0]],\"v\":[[2.591,-0.62],[-2.258,-1.052],[-0.587,1.267],[-1.609,1.435],[-1.739,1.907],[0.974,2.349]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.977253693225,0.576305494121,0.278676081639,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[2.84,2.599],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":15,\"ty\":4,\"nm\":\"Sholder\",\"parent\":16,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[45.261,7.588,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[10.109,20.512,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[14.542,-10.56],[0,0],[-2.246,2.526],[0.721,0.538]],\"o\":[[-1.398,1.016],[13.144,-10.406],[0.589,-0.67],[0,0]],\"v\":[[-12.184,10.288],[-8.672,11.598],[12.993,-9.367],[12.75,-11.598]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.669192445044,0.260652519675,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[20.501,17.982],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0.722,0.538],[1.355,-1.185],[3.395,-1.546],[-2.576,-5.85],[0,0],[-2.246,2.526]],\"o\":[[-8.277,-6.134],[-0.795,0.7],[-0.154,0.07],[3.233,7.338],[13.144,-10.405],[0.59,-0.669]],\"v\":[[16.084,-9.381],[2.505,-7.886],[-11.715,-1.045],[-14.341,8.177],[-5.338,13.815],[16.327,-7.15]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.762087115119,0.33839934106,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[17.166,15.765],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":16,\"ty\":4,\"nm\":\"Body\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[150.404,278.204,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[23.811,27.793,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-0.272,-6.48],[1.201,-3.262],[0.486,6.451],[0.471,6.48],[-1.201,4.028]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.669192445044,0.260652519675,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[16.546,46.391],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0.831,-1.249],[0.346,-5.632],[-0.416,-5.262],[-1.675,0.356],[0,0],[0,0]],\"o\":[[-1.398,1.016],[-0.578,9.431],[2.13,-0.141],[0,0],[0,0],[0.39,-1.113]],\"v\":[[-0.686,-18.63],[-2.076,-2.975],[-2.801,19.879],[2.988,19.152],[3.217,19.1],[2.827,-17.32]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.669192445044,0.260652519675,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[44.155,33.977],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-6.064,15.567],[-7.537,12.349],[-12.228,2.098],[-4.444,-6.62],[-5.843,12.511]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[3.395,-1.546],[0.81,0.014],[0,0],[5.898,-6.776],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.949,-0.088],[-8.232,1.745],[0,0],[0,0]],\"o\":[[-0.729,0.331],[0,0],[0,0],[-5.273,6.067],[0,0],[0,0],[0,0],[0,0],[0,0],[4.853,0.45],[0,0],[0,0],[0.319,-10.567]],\"v\":[[16.793,-25.766],[14.459,-25.287],[4.068,-25.346],[-9.326,-19.462],[-23.561,0.655],[-8.465,22.857],[-6.793,25.309],[-6.778,25.28],[-6.793,25.486],[-5.306,25.633],[23.332,25.567],[23.561,25.515],[23.17,-10.906]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.762087115119,0.33839934106,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[23.811,27.562],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":17,\"ty\":4,\"nm\":\"Head\",\"parent\":16,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[33.157,2.414,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[15.033,25.386,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-1.346,-0.561],[-0.037,-0.784],[0,0],[0,0],[2.972,1.694]],\"o\":[[0.829,0.346],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0.575,0.298],[1.296,1.95],[2.501,1.95],[2.501,-0.901],[-2.501,-1.95]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.932703354779,0.468252383961,0.15259216907,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[16.993,23.436],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[3.92,-0.356],[1.07,-1.425],[-1.782,-0.178],[3.563,0.178],[0,0],[0,0],[0,0],[0.179,4.276],[0,0]],\"o\":[[0,0],[-1.068,1.426],[0,0],[0,0],[0,0],[0,0],[0,0],[-0.178,-4.276],[0,0]],\"v\":[[-1.604,-4.722],[-4.099,-4.722],[-2.673,0.089],[-6.771,4.544],[-6.771,8.285],[1.604,8.285],[1.604,5.434],[6.592,-0.98],[5.167,-8.285]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.977253693225,0.576305494121,0.278676081639,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[17.89,17.101],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[1.115,0.144],[0,0],[2.673,-2.317],[-10.869,-4.454],[-0.892,2.082],[-1.7,3.537],[0,0],[-2.179,-0.317]],\"o\":[[-4.241,-0.547],[0,0],[-1.831,1.587],[5.109,2.094],[-10.312,2.9],[1.728,-3.593],[1.621,-4.082],[-0.397,-0.567]],\"v\":[[9.947,-11.197],[3.961,-10.481],[-3.596,-8.702],[-1.279,9.65],[6.918,8.251],[-2.812,-4.814],[3.063,-6.749],[12.148,-10.071]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.067422320796,0.367762995701,0.456868459664,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[12.398,11.994],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[5.524,0.713],[0,0],[2.672,-2.317],[-10.869,-4.454],[0,0]],\"o\":[[0,0],[-4.241,-0.547],[0,0],[-1.832,1.586],[10.869,4.454],[0,0]],\"v\":[[8.998,-4.359],[8.285,-12.377],[2.299,-11.661],[-5.256,-9.882],[-2.94,8.47],[5.612,1.521]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.431284317316,0.580090092678,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[14.059,13.174],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":4,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":18,\"ty\":4,\"nm\":\"Leg Right\",\"parent\":16,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[41.569,94.332,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[18.732,48.946,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0.662,0.441],[3.046,0.419]],\"o\":[[0,0],[0,0],[0.794,0],[-2.045,-1.362],[0,0]],\"v\":[[-7.546,-2.564],[-7.546,2.564],[6.441,2.564],[6.885,1.094],[-1.484,-2.564]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.067422320796,0.535545558555,0.76966827991,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[29.97,95.077],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0.507,3.721],[1.108,10.997],[0,0],[-0.507,-20.724],[0,0]],\"o\":[[-0.366,-2.685],[0,0],[0,0],[0,0],[0,0]],\"v\":[[3.467,-8.518],[-0.046,-42.319],[-5.327,-41.737],[2.884,42.319],[5.327,42.319]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.431284317316,0.580090092678,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[23.845,50.206],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-2.876,-9.133],[0,0],[0,0],[0.507,3.72],[0,0]],\"o\":[[0,0],[2.875,9.133],[0,0],[0,0],[-0.508,-3.721],[0,0]],\"v\":[[-14.461,-46.137],[-9.894,-24.15],[7.113,46.137],[14.461,46.137],[12.601,-4.699],[8.372,-45.629]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.067422320796,0.535545558555,0.76966827991,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[14.711,46.387],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":19,\"ty\":4,\"nm\":\"Leg Left\",\"parent\":16,\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[27.495,94.586,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[12.175,48.691,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0.661,0.441],[3.046,0.419]],\"o\":[[0,0],[0,0],[0.794,0],[-2.046,-1.362],[0,0]],\"v\":[[-7.546,-2.564],[-7.546,2.564],[6.441,2.564],[6.885,1.094],[-1.484,-2.564]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.067422320796,0.535545558555,0.76966827991,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[8.171,94.569],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-0.376,-10.224],[0,0],[0,0],[-0.391,3.721],[0,0]],\"o\":[[0,0],[0.336,9.151],[0,0],[0,0],[0.39,-3.72],[0,0]],\"v\":[[-9.294,-43.647],[-11.174,-23.426],[-11.926,45.883],[-4.577,45.883],[6.274,-4.954],[11.926,-45.883]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0,0.431284317316,0.580090092678,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[12.175,46.133],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":20,\"ty\":4,\"nm\":\"404\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.5],\"y\":[1]},\"o\":{\"x\":[0.5],\"y\":[0]},\"t\":0,\"s\":[-5]},{\"i\":{\"x\":[0.5],\"y\":[1]},\"o\":{\"x\":[0.5],\"y\":[0]},\"t\":60.5,\"s\":[5]},{\"t\":121,\"s\":[-5]}],\"ix\":10},\"p\":{\"a\":0,\"k\":[249.562,0,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[103.705,0.25,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0.224,-1.917],[1.918,0.224],[-0.224,1.918],[-1.918,-0.224]],\"o\":[[-0.224,1.917],[-1.917,-0.223],[0.223,-1.917],[1.917,0.224]],\"v\":[[3.472,0.405],[-0.406,3.471],[-3.472,-0.405],[0.406,-3.471]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,0.762087115119,0.33839934106,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[62.624,177.038],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0.224,-1.917],[1.917,0.224],[-0.223,1.917],[-1.918,-0.224]],\"o\":[[-0.224,1.917],[-1.917,-0.224],[0.224,-1.918],[1.917,0.224]],\"v\":[[3.472,0.405],[-0.406,3.472],[-3.473,-0.405],[0.406,-3.472]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.502362539254,0.799053237017,0.914689307119,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[45.265,175.012],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0.224,-1.917],[1.918,0.224],[-0.224,1.917],[-1.918,-0.224]],\"o\":[[-0.224,1.917],[-1.917,-0.224],[0.223,-1.918],[1.917,0.224]],\"v\":[[3.472,0.405],[-0.406,3.472],[-3.472,-0.405],[0.406,-3.472]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[28.519,173.057],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 3\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-3.293,-0.385],[-0.55,4.705],[0,0],[3.293,0.385],[0.55,-4.705]],\"o\":[[-0.549,4.705],[3.294,0.385],[0,0],[0.549,-4.705],[-3.294,-0.384],[0,0]],\"v\":[[-7.439,17.157],[-2.834,24.276],[3.288,18.409],[7.439,-17.158],[2.834,-24.276],[-3.288,-18.41]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-10.163,-1.186],[1.229,-10.539],[0,0],[10.162,1.186],[-1.23,10.539]],\"o\":[[1.231,-10.538],[10.162,1.186],[0,0],[-1.231,10.539],[-10.162,-1.186],[0,0]],\"v\":[[-13.715,-18.96],[3.932,-33.685],[17.713,-15.29],[13.715,18.958],[-3.932,33.685],[-17.712,15.29]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.502362539254,0.799053237017,0.914689307119,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[104.445,242.353],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 4\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":4,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-0.041,0.343],[0,0],[0.081,-0.143],[0,0],[-0.444,-0.053],[0,0]],\"o\":[[0,0],[0.02,-0.162],[0,0],[-0.22,0.39],[0,0],[0.342,0.04]],\"v\":[[2.972,10.454],[5.701,-12.935],[5.422,-13.026],[-7.081,9.036],[-6.609,9.966],[2.278,11.004]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-0.405,0.714],[0,0],[-2.728,-0.319],[0.438,-3.75],[0,0],[0,0],[0.303,-2.599],[2.598,0.304],[0,0],[0,0],[2.806,0.328],[-0.328,2.807],[0,0],[0,0],[-0.304,2.604],[0,0]],\"o\":[[0,0],[1.356,-2.388],[3.75,0.437],[0,0],[0,0],[2.598,0.304],[-0.303,2.599],[0,0],[0,0],[-0.327,2.806],[-2.806,-0.327],[0,0],[0,0],[-2.604,-0.305],[0,0],[0.095,-0.815]],\"v\":[[-16.435,7.666],[4.727,-29.621],[11.465,-33.036],[17.463,-25.454],[13.061,12.263],[13.249,12.284],[17.405,17.538],[12.151,21.693],[11.962,21.672],[11.16,28.541],[5.487,33.028],[0.999,27.354],[1.801,20.486],[-13.434,18.708],[-17.597,13.444],[-17.193,9.983]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.502362539254,0.799053237017,0.914689307119,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[149.152,248.565],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 5\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":5,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-0.04,0.343],[0,0],[0.08,-0.142],[0,0],[-0.444,-0.052],[0,0]],\"o\":[[0,0],[0.019,-0.162],[0,0],[-0.221,0.389],[0,0],[0.343,0.04]],\"v\":[[2.972,10.454],[5.702,-12.936],[5.423,-13.027],[-7.08,9.036],[-6.609,9.966],[2.278,11.003]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[-0.405,0.714],[0,0],[-2.728,-0.319],[0.438,-3.75],[0,0],[0,0],[0.303,-2.598],[2.598,0.303],[0,0],[0,0],[2.806,0.328],[-0.327,2.806],[0,0],[0,0],[-0.304,2.603],[0,0]],\"o\":[[0,0],[1.355,-2.389],[3.75,0.438],[0,0],[0,0],[2.599,0.303],[-0.303,2.599],[0,0],[0,0],[-0.328,2.806],[-2.806,-0.327],[0,0],[0,0],[-2.603,-0.303],[0,0],[0.095,-0.816]],\"v\":[[-16.435,7.665],[4.728,-29.621],[11.466,-33.037],[17.463,-25.454],[13.061,12.262],[13.249,12.284],[17.405,17.537],[12.151,21.693],[11.963,21.671],[11.161,28.54],[5.487,33.028],[0.999,27.354],[1.801,20.485],[-13.434,18.706],[-17.597,13.444],[-17.193,9.983]],\"c\":true},\"ix\":2},\"nm\":\"Path 2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"mm\",\"mm\":1,\"nm\":\"Merge Paths 1\",\"mn\":\"ADBE Vector Filter - Merge\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.502362539254,0.799053237017,0.914689307119,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[55.755,237.664],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 6\",\"np\":4,\"cix\":2,\"bm\":0,\"ix\":6,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[7.135,0.832],[0,0],[0.833,-7.134],[0,0]],\"o\":[[0,0],[0.833,-7.134],[0,0],[-7.135,-0.833],[0,0],[0,0]],\"v\":[[95.359,22.656],[96.592,12.089],[85.181,-2.337],[-81.765,-21.823],[-96.191,-10.413],[-97.425,0.154]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.067422320796,0.535545558555,0.76966827991,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[109.735,180.534],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 7\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":7,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[7.135,0.833],[0,0],[0.833,-7.134],[0,0],[-7.135,-0.833],[0,0],[-0.832,7.134],[0,0]],\"o\":[[0,0],[-7.135,-0.833],[0,0],[-0.833,7.134],[0,0],[7.135,0.832],[0,0],[0.833,-7.134]],\"v\":[[91.211,-56.553],[-75.735,-76.038],[-90.162,-64.628],[-102.622,42.127],[-91.211,56.553],[75.735,76.039],[90.161,64.628],[102.622,-42.126]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.851184740254,0.944075879864,0.977253693225,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[103.705,234.749],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 8\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":8,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[108.705,234.749],\"ix\":2},\"a\":{\"a\":0,\"k\":[103.705,234.749],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":-6,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 11\",\"np\":8,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-1.256,116.73],[0.989,116.73],[1.448,-134.729],[-0.797,-134.729]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.502362539254,0.799053237017,0.914689307119,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[187.009,94.73],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 9\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-1.311,102.555],[0.934,102.555],[1.461,-118.648],[-0.784,-118.648]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.502362539254,0.799053237017,0.914689307119,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[33.036,82.15],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 10\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":3,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":21,\"ty\":4,\"nm\":\"BG\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[250,287.61,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[217.657,111.976,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[65.245,14.133],[142.194,-6.062],[12.832,-8.116],[-4.89,0.208],[-52.798,-11.437],[0.565,-34.616],[0,0],[-0.107,6.951]],\"o\":[[-52.799,-11.437],[-24.278,1.036],[4.322,-0.566],[142.194,-6.063],[64.55,13.982],[0,0],[6.953,0],[0.532,-34.645]],\"v\":[[77.834,-6.458],[-85.854,-105.664],[-139.923,-90.851],[-126.122,-92.024],[37.566,7.181],[99.507,105.945],[127.024,105.945],[139.756,93.421]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.587682806277,0.818008662205,0.873935415231,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[293.691,111.976],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[-0.106,6.951],[65.245,14.132],[142.194,-6.062],[79.365,-7.165],[-2.029,-30.603],[-6.709,0]],\"o\":[[6.952,0],[0.533,-34.645],[-52.799,-11.437],[-102.073,4.352],[-52.81,4.768],[0.444,6.695],[0,0]],\"v\":[[202.205,108.836],[214.936,96.312],[153.015,-3.568],[-10.674,-102.773],[-164.994,-5.222],[-216.231,96.941],[-203.525,108.836]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.725116265989,0.881516759536,0.922272506415,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[218.51,109.086],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 2\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":2,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":22,\"ty\":4,\"nm\":\"BACKGROUND\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[250,250,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[250.25,250.25,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-250,250],[250,250],[250,-250],[-250,-250]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[250.25,250.25],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":300,\"st\":0,\"bm\":0}],\"markers\":[]}");


const $bfc8b1bc7583e745$var$NotFound = ()=>{
    (0, $6fFrj.useEffect)(()=>{
        const Elem = document.querySelector('#notFoundAnimation');
        if (Elem) (0, (/*@__PURE__*/$parcel$interopDefault($c8ea7419494febdf$exports))).loadAnimation({
            container: Elem,
            animationData: (0, (/*@__PURE__*/$parcel$interopDefault($d39389d1772dfafb$exports)))
        });
    }, []);
    return (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        justify: "center",
        children: [
            (0, $bb3TF.jsx)("div", {
                id: "notFoundAnimation",
                style: {
                    width: '100%',
                    height: '80vh',
                    marginBottom: '-12vh'
                }
            }),
            (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                to: "/",
                children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    type: "primary",
                    size: "large",
                    children: "Back To Home"
                })
            })
        ]
    });
};
var $bfc8b1bc7583e745$export$2e2bcd8739ae039 = $bfc8b1bc7583e745$var$NotFound;


var $83c6dec095052af7$export$2e2bcd8739ae039 = (0, $bfc8b1bc7583e745$export$2e2bcd8739ae039);




var $bb3TF = parcelRequire("bb3TF");


var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


const $c730d221adccc259$var$defaultOptions = {};
const $c730d221adccc259$export$fe3b48dad283ba92 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetAllEntityDataByEntityId($id: String!) {
  GetAllEntityDataByEntityId(id: $id) {
    id
    Users {
      id
      email
      has2Fa
      Languages {
        id
        description
      }
      Files {
        id
      }
      UserInformation {
        id
        firstName
        lastName
        birthday
        notes
        Phones {
          id
          value
          type
          createAt
          updateAt
          userInformationId
        }
        Address {
          lineOne
          lineTwo
          city
          state
          zip
          type
        }
      }
    }
    TaxYear {
      id
      year
      TaxYearInterview {
        id
        notes
        progressStatusId
        completedAt
        JobTracking {
          id
          expectedCompletion
          paymentsCompletedAt
          approvalsCompletedAt
          interviewCompletedAt
          filesCompletedAt
        }
        Interviews {
          id
          name
        }
        ProgressStatuses {
          id
          status
          underlyingStatus
          index
        }
        Tasks {
          id
          taskType
          completedAt
        }
      }
    }
    UserFirmAccount {
      id
      deleteAt
    }
  }
}
    `;
function $c730d221adccc259$export$db027801ed7d9251(baseOptions) {
    const options = {
        ...$c730d221adccc259$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($c730d221adccc259$export$fe3b48dad283ba92, options);
}
function $c730d221adccc259$export$1f91edd048124d01(baseOptions) {
    const options = {
        ...$c730d221adccc259$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($c730d221adccc259$export$fe3b48dad283ba92, options);
}
const $c730d221adccc259$export$39ac829ab91f0716 = {
    Query: {
        GetAllEntityDataByEntityId: 'GetAllEntityDataByEntityId'
    }
};





const $c1ea95f1cc108fcb$var$getPrimaryPhone = (phones)=>{
    if (!phones) return undefined;
    // prioritize Mobile phones
    const personalPhones = phones.filter((phone)=>phone.type === (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Mobile);
    if (personalPhones.length > 0) return personalPhones[0];
    // then Work phones
    const homePhones = phones.filter((phone)=>phone.type === (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Work);
    if (homePhones.length > 0) return homePhones[0];
    // then Landline phones
    const officePhones = phones.filter((phone)=>phone.type === (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Landline);
    if (officePhones.length > 0) return officePhones[0];
    return undefined;
};
var $c1ea95f1cc108fcb$export$2e2bcd8739ae039 = $c1ea95f1cc108fcb$var$getPrimaryPhone;


const { createContext: $9f8459ba594d5b47$var$createContext } = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj)));
const $9f8459ba594d5b47$export$7fd9bd9faa7887cb = $9f8459ba594d5b47$var$createContext(null);
const $9f8459ba594d5b47$var$initialTaxpayer = {
    loading: true,
    urlTaxYearInterviewId: undefined,
    entityId: undefined,
    ownerId: undefined,
    userInformationId: undefined,
    firstName: undefined,
    lastName: undefined,
    name: undefined,
    birthday: undefined,
    notes: undefined,
    phone: undefined,
    phones: undefined,
    languageId: undefined,
    languageDescription: undefined,
    email: undefined,
    events: [],
    jobs: [],
    deleteAt: undefined,
    allFilesChanged: false,
    clientFilesChanged: false,
    firmFilesChanged: false,
    secretOTP: undefined
};
function $9f8459ba594d5b47$var$reducer(state, action) {
    switch(action.type){
        case 'CREATE':
            return {
                ...action.payload
            };
        case 'UPDATE':
            return {
                ...state,
                ...action.payload
            };
        default:
            throw new Error();
    }
}
function $9f8459ba594d5b47$export$8624ff1b6d3ea6ae({ children: children }) {
    const [state, dispatch] = (0, $6fFrj.useReducer)($9f8459ba594d5b47$var$reducer, $9f8459ba594d5b47$var$initialTaxpayer);
    const dispatchClientState = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const valueProvider = (0, $6fFrj.useMemo)(()=>({
            ...state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    // get data from this entity
    const { search: search } = (0, $990f835fb2356f36$export$45d76561a5302f2b)();
    const queryParams = new URLSearchParams(search);
    const entityId = queryParams.get('entityId');
    const taxYearInterviewId = queryParams.get('taxYearInterviewId') ?? ''; // use this to open the correct taxYearInterview by default
    const { data: entityData, loading: loadingEntityData } = (0, $c730d221adccc259$export$db027801ed7d9251)({
        variables: {
            id: entityId
        }
    });
    const entity = entityData?.GetAllEntityDataByEntityId ?? null;
    const jobs = entity?.TaxYear?.flatMap((taxYear)=>taxYear.TaxYearInterview.map((taxYearInterview)=>({
                ...taxYearInterview,
                TaxYear: taxYear
            }))) ?? [];
    (0, $6fFrj.useEffect)(()=>{
        if (!loadingEntityData) {
            const { GetAllEntityDataByEntityId: GetAllEntityDataByEntityId } = entityData || {};
            const { TaxYear: TaxYear, Users: Users, UserFirmAccount: UserFirmAccount } = GetAllEntityDataByEntityId || {};
            dispatchClientState((0, $59a61dbb6cd2676b$export$b7c209536cc73fdf)({
                email: Users?.email,
                entityId: entityId,
                name: `${Users?.UserInformation?.firstName} ${Users?.UserInformation?.lastName}`,
                languageId: Users?.Languages?.id,
                id: Users?.id,
                workNumber: Users?.UserInformation?.Phones?.filter((item)=>item.type === 'WORK')?.[0],
                landlineNumber: Users?.UserInformation?.Phones?.filter((item)=>item.type === 'LANDLINE')?.[0],
                userInformationId: Users?.UserInformation?.id,
                phoneNumber: (0, $c1ea95f1cc108fcb$export$2e2bcd8739ae039)(Users?.UserInformation?.Phones),
                job: jobs.filter((item)=>item.id === taxYearInterviewId)?.[0] ?? undefined
            }));
            dispatch({
                type: 'UPDATE',
                payload: {
                    loading: false,
                    urlTaxYearInterviewId: taxYearInterviewId,
                    userInformationId: Users?.UserInformation?.id,
                    userId: Users?.id,
                    firstName: Users?.UserInformation?.firstName,
                    lastName: Users?.UserInformation?.lastName,
                    name: `${Users?.UserInformation?.firstName} ${Users?.UserInformation?.lastName}`,
                    birthday: Users?.UserInformation?.birthday?.split('T')[0],
                    notes: Users?.UserInformation?.notes,
                    phone: (0, $c1ea95f1cc108fcb$export$2e2bcd8739ae039)(Users?.UserInformation?.Phones),
                    phones: Users?.UserInformation?.Phones,
                    languageId: Users?.Languages?.id,
                    languageDescription: Users?.Languages?.description,
                    taxYears: TaxYear,
                    email: Users?.email,
                    events: [],
                    lastConnection: undefined,
                    clientData: undefined,
                    entityId: entityId,
                    ownerId: Users?.id,
                    jobs: jobs,
                    deleteAt: UserFirmAccount?.[0]?.deleteAt,
                    secretOTP: Users?.has2Fa
                }
            });
        }
    }, [
        loadingEntityData,
        entityData
    ]);
    return (0, $bb3TF.jsx)($9f8459ba594d5b47$export$7fd9bd9faa7887cb.Provider, {
        value: valueProvider,
        children: children
    });
}



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $6Sgv0 = parcelRequire("6Sgv0");




var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


const $9867a6971c7f0e8f$var$defaultOptions = {};
const $9867a6971c7f0e8f$export$20ba0eba8fc9d3c7 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetJobsAndPaymentsByTaxYearStatus($progressStatusIds: [String!]!, $startDate: DateTime, $endDate: DateTime, $dateFilterKey: String) {
  JobsAndPaymentsByTaxYearStatus(
    progressStatusIds: $progressStatusIds
    startDate: $startDate
    endDate: $endDate
    dateFilterKey: $dateFilterKey
  ) {
    id
    progressStatusId
    completedAt
    assignedAt
    preparedId
    Payments {
      id
      totalDollarAmount
    }
  }
}
    `;
function $9867a6971c7f0e8f$export$49565307c2df5b5d(baseOptions) {
    const options = {
        ...$9867a6971c7f0e8f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($9867a6971c7f0e8f$export$20ba0eba8fc9d3c7, options);
}
function $9867a6971c7f0e8f$export$4525defeffbd5d68(baseOptions) {
    const options = {
        ...$9867a6971c7f0e8f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($9867a6971c7f0e8f$export$20ba0eba8fc9d3c7, options);
}
const $9867a6971c7f0e8f$export$fa40e1ad05bb2731 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query getFirmReviewsFiltered($startDate: DateTime, $endDate: DateTime, $sort: String, $preparerId: String) {
  FirmReviewsFiltered(
    startDate: $startDate
    endDate: $endDate
    sort: $sort
    preparerId: $preparerId
  ) {
    id
    reviewValue
    reviewContent
    createAt
    TaxYearInterview {
      id
      TaxYear {
        id
        year
        Entity {
          Users {
            UserInformation {
              firstName
              lastName
            }
          }
        }
      }
      Interviews {
        id
        name
      }
      PreparedUser {
        id
        UserInformation {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;
function $9867a6971c7f0e8f$export$5d43bcc4a985703b(baseOptions) {
    const options = {
        ...$9867a6971c7f0e8f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($9867a6971c7f0e8f$export$fa40e1ad05bb2731, options);
}
function $9867a6971c7f0e8f$export$3ba63a179f705657(baseOptions) {
    const options = {
        ...$9867a6971c7f0e8f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($9867a6971c7f0e8f$export$fa40e1ad05bb2731, options);
}
const $9867a6971c7f0e8f$export$efc6028ef5574235 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetFirmsAverageRating {
  firmsAverageRating
}
    `;
function $9867a6971c7f0e8f$export$82d824945c8cadba(baseOptions) {
    const options = {
        ...$9867a6971c7f0e8f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($9867a6971c7f0e8f$export$efc6028ef5574235, options);
}
function $9867a6971c7f0e8f$export$dcd753f7121c344b(baseOptions) {
    const options = {
        ...$9867a6971c7f0e8f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($9867a6971c7f0e8f$export$efc6028ef5574235, options);
}
const $9867a6971c7f0e8f$export$cffa9e53b1262856 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetPreparerAverageRating($preparerId: String!) {
  preparerAverageRating(preparerId: $preparerId) {
    id
    preparerName
    numberOfReviews
    avgRating
  }
}
    `;
function $9867a6971c7f0e8f$export$30d425c49cf80008(baseOptions) {
    const options = {
        ...$9867a6971c7f0e8f$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($9867a6971c7f0e8f$export$cffa9e53b1262856, options);
}
function $9867a6971c7f0e8f$export$8a4cdd2e9621219(baseOptions) {
    const options = {
        ...$9867a6971c7f0e8f$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($9867a6971c7f0e8f$export$cffa9e53b1262856, options);
}
const $9867a6971c7f0e8f$export$39ac829ab91f0716 = {
    Query: {
        GetJobsAndPaymentsByTaxYearStatus: 'GetJobsAndPaymentsByTaxYearStatus',
        getFirmReviewsFiltered: 'getFirmReviewsFiltered',
        GetFirmsAverageRating: 'GetFirmsAverageRating',
        GetPreparerAverageRating: 'GetPreparerAverageRating'
    }
};


const { Title: $4d468f5dc8bbb1c2$var$Title, Text: $4d468f5dc8bbb1c2$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { InfoCircleTwoTone: $4d468f5dc8bbb1c2$var$InfoCircleTwoTone } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $4d468f5dc8bbb1c2$var$JobsByTeamMember = ({ startDate: startDate, endDate: endDate, preparers: preparers, progressStatusIds: progressStatusIds, dateFilterKey: dateFilterKey, title: title, tooltip: tooltip })=>{
    const [loadingAllJobs, setLoadingAllJobs] = (0, $6fFrj.useState)(false);
    const [jobsByPreparer, setJobsByPreparer] = (0, $6fFrj.useState)({});
    // graphql queries
    const [getJobsAndPayments] = (0, $9867a6971c7f0e8f$export$4525defeffbd5d68)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    const fetchJobsAndPayments = async ()=>{
        setLoadingAllJobs(true);
        const { data: data } = await getJobsAndPayments({
            variables: {
                progressStatusIds: progressStatusIds,
                startDate: startDate,
                endDate: endDate,
                dateFilterKey: dateFilterKey
            }
        });
        const byPreparer = {};
        data?.JobsAndPaymentsByTaxYearStatus.forEach((taxYearInterview)=>{
            if (taxYearInterview?.preparedId) {
                if (byPreparer[taxYearInterview?.preparedId]) byPreparer[taxYearInterview?.preparedId].push(taxYearInterview);
                else byPreparer[taxYearInterview?.preparedId] = [
                    {
                        ...taxYearInterview
                    }
                ];
            }
        });
        setJobsByPreparer(byPreparer);
        setLoadingAllJobs(false);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (!startDate || !endDate) return;
        fetchJobsAndPayments();
    }, [
        getJobsAndPayments,
        progressStatusIds,
        startDate,
        endDate
    ]);
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: [
                    (0, $bb3TF.jsxs)($4d468f5dc8bbb1c2$var$Title, {
                        level: 4,
                        children: [
                            title,
                            tooltip && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                                children: [
                                    "\u00A0",
                                    (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
                                        placement: "top",
                                        content: tooltip,
                                        trigger: "hover",
                                        children: (0, $bb3TF.jsx)($4d468f5dc8bbb1c2$var$InfoCircleTwoTone, {
                                            style: {
                                                fontSize: 14
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    loadingAllJobs && (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                        size: "small",
                        style: {
                            marginLeft: 10,
                            marginTop: 3
                        }
                    })
                ]
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                style: {
                    marginTop: 40,
                    marginBottom: 40
                },
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: preparers.map((preparer)=>(0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: '18px',
                                    whiteSpace: 'nowrap'
                                },
                                children: (0, $bb3TF.jsxs)($4d468f5dc8bbb1c2$var$Text, {
                                    children: [
                                        (0, $bb3TF.jsxs)($4d468f5dc8bbb1c2$var$Text, {
                                            strong: true,
                                            children: [
                                                preparer?.name,
                                                ":",
                                                ' '
                                            ]
                                        }),
                                        (0, $bb3TF.jsx)($4d468f5dc8bbb1c2$var$Text, {
                                            children: jobsByPreparer[preparer?.id]?.length || 0
                                        })
                                    ]
                                })
                            }, preparer.id))
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
// default props
$4d468f5dc8bbb1c2$var$JobsByTeamMember.defaultProps = {
    tooltip: ''
};
var $4d468f5dc8bbb1c2$export$2e2bcd8739ae039 = $4d468f5dc8bbb1c2$var$JobsByTeamMember;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


const { Title: $0111cf81f11c9c9c$var$Title, Text: $0111cf81f11c9c9c$var$Text, Paragraph: $0111cf81f11c9c9c$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
function $0111cf81f11c9c9c$var$AllReviews({ startDate: startDate, endDate: endDate, preparers: preparers }) {
    const [sort, setSort] = (0, $6fFrj.useState)('date-new-old');
    const [preparerId, setPreparerId] = (0, $6fFrj.useState)(null);
    const onSortChange = (value)=>{
        setSort(value);
    };
    const onMemberChange = (value)=>{
        console.log(`selected ${value}`);
        if (value === 'All') setPreparerId(null);
        else setPreparerId(value);
    };
    const onSearchPreparer = (val)=>{
        console.log('search:', val);
    };
    // graphql queries
    // get all reviews
    const { data: reviewsData, loading: loadingReviews } = (0, $9867a6971c7f0e8f$export$5d43bcc4a985703b)({
        variables: {
            startDate: startDate,
            endDate: endDate,
            sort: sort,
            preparerId: preparerId
        }
    });
    const reviews = reviewsData?.FirmReviewsFiltered;
    if (loadingReviews) return (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        justify: "center",
        align: "middle",
        style: {
            height: 150
        },
        children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
            size: "large"
        })
    });
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    25,
                    0
                ],
                style: {
                    margin: '30px 0px'
                },
                children: [
                    (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: [
                            (0, $bb3TF.jsx)($0111cf81f11c9c9c$var$Text, {
                                children: "Show Reviews for: "
                            }),
                            (0, $bb3TF.jsxs)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                showSearch: true,
                                style: {
                                    width: 200
                                },
                                optionFilterProp: "children",
                                onChange: onMemberChange,
                                onSearch: onSearchPreparer,
                                filterOption: (input, option)=>{
                                    if (option) return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                    return false;
                                },
                                defaultValue: "All",
                                value: preparerId || 'All',
                                children: [
                                    (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039).Option, {
                                        value: "All",
                                        children: "All Team Members"
                                    }),
                                    preparers && preparers.map((preparer)=>(0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039).Option, {
                                            value: preparer.id,
                                            children: preparer.name
                                        }, preparer.id))
                                ]
                            })
                        ]
                    }),
                    (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: [
                            (0, $bb3TF.jsx)($0111cf81f11c9c9c$var$Text, {
                                children: "Sort By: "
                            }),
                            (0, $bb3TF.jsxs)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                style: {
                                    width: 230
                                },
                                onChange: onSortChange,
                                defaultValue: "date-new-old",
                                children: [
                                    (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039).Option, {
                                        value: "date-new-old",
                                        children: "Date: Newest to Oldest"
                                    }),
                                    (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039).Option, {
                                        value: "date-old-new",
                                        children: "Date: Oldest to Newest"
                                    }),
                                    (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039).Option, {
                                        value: "rating-high-low",
                                        children: "Rating: Highest to Lowest"
                                    }),
                                    (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039).Option, {
                                        value: "rating-low-high",
                                        children: "Rating: Lowest to Highest"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $550318ddff00815a$export$2e2bcd8739ae039), {
                itemLayout: "horizontal",
                dataSource: reviews,
                locale: {
                    emptyText: ' No Reviews Yet'
                },
                renderItem: (item)=>(0, $bb3TF.jsx)((0, $550318ddff00815a$export$2e2bcd8739ae039).Item, {
                        children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            gutter: [
                                50,
                                15
                            ],
                            children: [
                                (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                    children: [
                                        (0, $bb3TF.jsxs)($0111cf81f11c9c9c$var$Paragraph, {
                                            style: {
                                                fontWeight: 'bold',
                                                marginBottom: 0
                                            },
                                            children: [
                                                item?.TaxYearInterview?.TaxYear?.Entity?.Users?.UserInformation?.firstName,
                                                ' ',
                                                item?.TaxYearInterview?.TaxYear?.Entity?.Users?.UserInformation?.lastName
                                            ]
                                        }),
                                        (0, $bb3TF.jsxs)($0111cf81f11c9c9c$var$Text, {
                                            children: [
                                                item?.TaxYearInterview?.TaxYear?.year,
                                                ' ',
                                                "-",
                                                ' ',
                                                item?.TaxYearInterview?.Interviews?.name
                                            ]
                                        })
                                    ]
                                }),
                                (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                    style: {
                                        marginTop: '-2px'
                                    },
                                    children: [
                                        (0, $bb3TF.jsxs)("span", {
                                            children: [
                                                item?.reviewValue !== null && (0, $bb3TF.jsx)((0, $2577bd2133f02183$export$2e2bcd8739ae039), {
                                                    disabled: true,
                                                    defaultValue: item?.reviewValue,
                                                    style: {
                                                        marginRight: 8
                                                    }
                                                }),
                                                (0, $bb3TF.jsx)("span", {
                                                    style: {
                                                        color: 'gray'
                                                    },
                                                    children: new Date(item?.createAt).toLocaleDateString('en-US')
                                                })
                                            ]
                                        }),
                                        item?.TaxYearInterview?.PreparedUser?.UserInformation?.firstName && (0, $bb3TF.jsxs)($0111cf81f11c9c9c$var$Title, {
                                            level: 5,
                                            style: {
                                                fontSize: 17,
                                                fontWeight: 'bold'
                                            },
                                            children: [
                                                "Review of",
                                                ' ',
                                                ' ',
                                                item?.TaxYearInterview?.PreparedUser?.UserInformation?.firstName
                                            ]
                                        }),
                                        (0, $bb3TF.jsx)($0111cf81f11c9c9c$var$Paragraph, {
                                            children: item?.reviewContent
                                        })
                                    ]
                                })
                            ]
                        })
                    })
            })
        ]
    });
}
var $0111cf81f11c9c9c$export$2e2bcd8739ae039 = $0111cf81f11c9c9c$var$AllReviews;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


const { Title: $477359c846b1cab5$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
function $477359c846b1cab5$var$FirmCompiledReviewsSection({ preparers: preparers }) {
    const [preparerRatings, setPreparerRatings] = (0, $6fFrj.useState)([]);
    // graphql queries
    // get firm avg review
    const { data: avgRatingData, loading: loadingAvgRating } = (0, $9867a6971c7f0e8f$export$82d824945c8cadba)();
    const avgRating = avgRatingData?.firmsAverageRating;
    // get a preparer's avg review
    const [getPreparerAvgRating] = (0, $9867a6971c7f0e8f$export$8a4cdd2e9621219)();
    (0, $6fFrj.useEffect)(()=>{
        // fetch avg rating for each preparer
        const promises = preparers.map((preparer)=>getPreparerAvgRating({
                variables: {
                    preparerId: preparer.id
                }
            }));
        Promise.all(promises).then((results)=>{
            const avgRatings = [];
            results.forEach((result)=>{
                avgRatings.push({
                    avgRating: result.data?.preparerAverageRating?.avgRating,
                    preparerName: result.data?.preparerAverageRating?.preparerName,
                    numberOfReviews: result.data?.preparerAverageRating?.numberOfReviews
                });
            });
            setPreparerRatings(avgRatings);
        });
    }, [
        preparers,
        setPreparerRatings,
        getPreparerAvgRating
    ]);
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            !loadingAvgRating ? (0, $bb3TF.jsx)($477359c846b1cab5$var$Title, {
                level: 4,
                style: {
                    marginTop: -5,
                    marginBottom: 20
                },
                children: avgRating !== 'NaN' ? `${avgRating} average star rating` : 'No reviews yet'
            }) : (0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039), {
                active: true,
                paragraph: {
                    rows: 0
                }
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 12,
                        children: preparerRatings.map((preparerRating, index)=>(0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                children: (0, $bb3TF.jsxs)("span", {
                                    children: [
                                        (0, $bb3TF.jsx)((0, $2577bd2133f02183$export$2e2bcd8739ae039), {
                                            allowHalf: true,
                                            disabled: true,
                                            defaultValue: parseFloat(preparerRating?.avgRating)
                                        }),
                                        ' ',
                                        preparerRating?.preparerName,
                                        ' ',
                                        "|",
                                        ' ',
                                        preparerRating?.numberOfReviews,
                                        ' ',
                                        "reviews"
                                    ]
                                })
                            }, `compiled-review-section-${index}`))
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 12
                    })
                ]
            })
        ]
    });
}
var $477359c846b1cab5$export$2e2bcd8739ae039 = $477359c846b1cab5$var$FirmCompiledReviewsSection;



var $bb3TF = parcelRequire("bb3TF");


var $6fFrj = parcelRequire("6fFrj");

const { Title: $8f3023a8ffab89f5$var$Title, Text: $8f3023a8ffab89f5$var$Text, Paragraph: $8f3023a8ffab89f5$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { InfoCircleTwoTone: $8f3023a8ffab89f5$var$InfoCircleTwoTone } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $8f3023a8ffab89f5$var$LineChartSection({ title: title, dollarSubtitle: dollarSubtitle, numberSubtitle: numberSubtitle, progressStatusIds: progressStatusIds, startDate: startDate, endDate: endDate, dateFilterKey: dateFilterKey, tooltip: tooltip }) {
    const [allJobs, setAllJobs] = (0, $6fFrj.useState)(null);
    const [loadingAllJobs, setLoadingAllJobs] = (0, $6fFrj.useState)(false);
    const [totalPayments, setTotalPayments] = (0, $6fFrj.useState)(null);
    // graphql queries
    const [getJobsAndPayments] = (0, $9867a6971c7f0e8f$export$4525defeffbd5d68)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    const fetchJobsAndPayments = async ()=>{
        setLoadingAllJobs(true);
        const { data: data } = await getJobsAndPayments({
            variables: {
                progressStatusIds: progressStatusIds,
                startDate: startDate,
                endDate: endDate,
                dateFilterKey: dateFilterKey
            }
        });
        let totalPaymentsAmount = 0;
        data?.JobsAndPaymentsByTaxYearStatus.forEach((taxYearInterview)=>{
            taxYearInterview?.Payments.forEach((payment)=>{
                totalPaymentsAmount += Number(payment?.totalDollarAmount) || 0;
            });
        });
        setAllJobs(data?.JobsAndPaymentsByTaxYearStatus);
        setTotalPayments(totalPaymentsAmount);
        setLoadingAllJobs(false);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (!startDate || !endDate) return;
        fetchJobsAndPayments();
    }, [
        getJobsAndPayments,
        progressStatusIds,
        startDate,
        endDate
    ]);
    const options = {
        title: {
            text: 'Total Work in Progress Over Time'
        },
        yAxis: [
            {
                title: {
                    text: 'Job Count'
                },
                allowDecimals: false
            },
            {
                title: {
                    text: 'Dollars (s)'
                },
                // labels: {
                //   format: '${value}',
                // },
                opposite: true
            }
        ],
        xAxis: {
            title: {
                text: 'Time'
            }
        },
        legend: {
            verticalAlign: 'top'
        },
        series: [
            {
                type: 'line',
                name: 'Job Count In Progress',
                data: [
                    1,
                    2,
                    3
                ],
                yAxis: 0
            },
            {
                type: 'line',
                name: 'Dollars In Progress',
                data: [
                    100,
                    200,
                    300
                ],
                yAxis: 1
            }
        ]
    };
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: [
                    (0, $bb3TF.jsxs)($8f3023a8ffab89f5$var$Title, {
                        level: 4,
                        children: [
                            title,
                            tooltip && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                                children: [
                                    "\u00A0",
                                    (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
                                        placement: "top",
                                        content: tooltip,
                                        trigger: "hover",
                                        children: (0, $bb3TF.jsx)($8f3023a8ffab89f5$var$InfoCircleTwoTone, {
                                            style: {
                                                fontSize: 14
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    loadingAllJobs && (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                        size: "small",
                        style: {
                            marginLeft: 10,
                            marginTop: 3
                        }
                    })
                ]
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                style: {
                    marginTop: 40,
                    marginBottom: 40
                },
                children: [
                    (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: [
                            (0, $bb3TF.jsx)($8f3023a8ffab89f5$var$Text, {
                                style: {
                                    color: 'green',
                                    fontSize: '32px'
                                },
                                children: Number(totalPayments).toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD'
                                })
                            }),
                            (0, $bb3TF.jsx)($8f3023a8ffab89f5$var$Paragraph, {
                                children: dollarSubtitle
                            }),
                            (0, $bb3TF.jsx)("div", {
                                style: {
                                    height: '15px'
                                }
                            }),
                            (0, $bb3TF.jsx)($8f3023a8ffab89f5$var$Text, {
                                style: {
                                    color: 'blue',
                                    fontSize: '32px'
                                },
                                children: allJobs?.length
                            }),
                            (0, $bb3TF.jsx)($8f3023a8ffab89f5$var$Paragraph, {
                                children: numberSubtitle
                            })
                        ]
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}
// default props
$8f3023a8ffab89f5$var$LineChartSection.defaultProps = {
    tooltip: ''
};
var $8f3023a8ffab89f5$export$2e2bcd8739ae039 = $8f3023a8ffab89f5$var$LineChartSection;


// import * as styles from './style.module.css';
const { RangePicker: $0ed549787c3d719b$var$RangePicker } = (0, $e07b4718354cbfe5$export$2e2bcd8739ae039);
const { Title: $0ed549787c3d719b$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
// interface AnalyticsProps {}
function $0ed549787c3d719b$var$Analytics() {
    const [timeFrame, setTimeFrame] = (0, $6fFrj.useState)('1 wk');
    const [startDate, setStartDate] = (0, $6fFrj.useState)((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().subtract(1, 'week'));
    const [endDate, setEndDate] = (0, $6fFrj.useState)((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))());
    // graphql queries
    // get all progress statuses
    const { data: progressStatusesData, loading: loadingProgressStatuses } = (0, $732264f53056e08f$export$9ca2f42b9d2b732f)();
    const progressStatuses = progressStatusesData?.ProgressStatuses;
    // get all preparers
    const { data: preparersData, loading: loadingPreparers } = (0, $3198fe3853f3bce8$export$351bee9728151e39)();
    const preparers = preparersData?.FirmTaxPreparers;
    const handleTimeFrameChange = (e)=>{
        setTimeFrame(e.target.value);
        switch(e.target.value){
            case '1 wk':
                setStartDate((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().subtract(1, 'week'));
                setEndDate((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))());
                break;
            case '4 wk':
                setStartDate((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().subtract(4, 'week'));
                setEndDate((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))());
                break;
            case '1 yr':
                setStartDate((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().subtract(1, 'year'));
                setEndDate((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))());
                break;
            case 'MTD':
                setStartDate((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().startOf('month'));
                setEndDate((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))());
                break;
            case 'YTD':
                setStartDate((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().startOf('year'));
                setEndDate((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))());
                break;
            default:
                break;
        }
    };
    const onCalendarChange = (dates)=>{
        setStartDate(dates[0]);
        setEndDate(dates[1]);
        setTimeFrame(null);
    };
    if (loadingProgressStatuses) return (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        justify: "center",
        align: "middle",
        style: {
            height: 'calc(90% - 60px)'
        },
        children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
            size: "large"
        })
    });
    return (0, $bb3TF.jsxs)("div", {
        children: [
            (0, $bb3TF.jsx)($0ed549787c3d719b$var$Title, {
                level: 3,
                style: {
                    margin: 0
                },
                children: "Your Firm Analytics"
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                justify: "end",
                gutter: [
                    15,
                    0
                ],
                style: {
                    paddingTop: '10px',
                    position: 'sticky',
                    top: 45,
                    zIndex: 1,
                    background: 'white'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsxs)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Group, {
                            value: timeFrame,
                            onChange: handleTimeFrameChange,
                            children: [
                                (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Button, {
                                    value: "1 wk",
                                    children: "1 wk"
                                }),
                                (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Button, {
                                    value: "4 wk",
                                    children: "4 wk"
                                }),
                                (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Button, {
                                    value: "1 yr",
                                    children: "1 yr"
                                }),
                                (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Button, {
                                    value: "MTD",
                                    children: "MTD"
                                }),
                                (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Button, {
                                    value: "YTD",
                                    children: "YTD"
                                })
                            ]
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($0ed549787c3d719b$var$RangePicker, {
                            onCalendarChange: onCalendarChange,
                            value: [
                                startDate,
                                endDate
                            ]
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                style: {
                    marginTop: '2em'
                },
                children: (0, $bb3TF.jsx)($0ed549787c3d719b$var$Title, {
                    level: 3,
                    children: "Firm Statistics"
                })
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 12,
                        children: (0, $bb3TF.jsx)((0, $8f3023a8ffab89f5$export$2e2bcd8739ae039), {
                            title: "Jobs In Progress",
                            tooltip: "In Progress jobs include our default In Progress status and all your custom statuses.",
                            dollarSubtitle: "In progress during selected period",
                            numberSubtitle: "Jobs in progress during selected period",
                            progressStatusIds: progressStatuses?.filter((status)=>status.underlyingStatus === (0, $8f7fe33a44836803$export$f493388d2527ca1f).InProgress || status.underlyingStatus === (0, $8f7fe33a44836803$export$f493388d2527ca1f).Custom) // filter by underlyingStatus
                            .map((status)=>status.id) // return just the ids
                            ,
                            startDate: startDate,
                            endDate: endDate,
                            dateFilterKey: "assignedAt"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 12,
                        children: (0, $bb3TF.jsx)((0, $8f3023a8ffab89f5$export$2e2bcd8739ae039), {
                            title: "Jobs Completed",
                            dollarSubtitle: "Completed during selected period",
                            numberSubtitle: "Jobs completed during selected period",
                            progressStatusIds: progressStatuses?.filter((status)=>status.underlyingStatus === (0, $8f7fe33a44836803$export$f493388d2527ca1f).Completed) // filter by underlyingStatus
                            .map((status)=>status.id) // return just the ids
                            ,
                            startDate: startDate,
                            endDate: endDate,
                            dateFilterKey: "completedAt"
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {}),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 12,
                        children: (0, $bb3TF.jsx)((0, $4d468f5dc8bbb1c2$export$2e2bcd8739ae039), {
                            title: "Jobs In Progress by Team Member",
                            tooltip: "In Progress jobs include our default In Progress status and all your custom statuses.",
                            preparers: preparers || [],
                            progressStatusIds: progressStatuses?.filter((status)=>status.underlyingStatus === (0, $8f7fe33a44836803$export$f493388d2527ca1f).InProgress) // filter by underlyingStatus
                            .map((status)=>status.id) // return just the ids
                            ,
                            startDate: startDate,
                            endDate: endDate,
                            dateFilterKey: "assignedAt"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 12,
                        children: (0, $bb3TF.jsx)((0, $4d468f5dc8bbb1c2$export$2e2bcd8739ae039), {
                            title: "Jobs Completed by Team Member",
                            preparers: preparers || [],
                            progressStatusIds: progressStatuses?.filter((status)=>status.underlyingStatus === (0, $8f7fe33a44836803$export$f493388d2527ca1f).Completed) // filter by underlyingStatus
                            .map((status)=>status.id) // return just the ids
                            ,
                            startDate: startDate,
                            endDate: endDate,
                            dateFilterKey: "completedAt"
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {}),
            (0, $bb3TF.jsx)($0ed549787c3d719b$var$Title, {
                level: 3,
                children: "All Firm Reviews"
            }),
            (0, $bb3TF.jsx)((0, $477359c846b1cab5$export$2e2bcd8739ae039), {
                preparers: preparers || []
            }),
            (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {}),
            (0, $bb3TF.jsxs)($0ed549787c3d719b$var$Title, {
                level: 3,
                children: [
                    "Reviews",
                    (0, $bb3TF.jsxs)("span", {
                        style: {
                            fontWeight: 'lighter',
                            fontSize: 16,
                            marginLeft: 15
                        },
                        children: [
                            "(",
                            ' ',
                            startDate?.format('MMM Do, YYYY'),
                            ' ',
                            "-",
                            ' ',
                            endDate?.format('MMM Do, YYYY'),
                            ' ',
                            ")"
                        ]
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $0111cf81f11c9c9c$export$2e2bcd8739ae039), {
                startDate: startDate,
                endDate: endDate,
                preparers: preparers || []
            })
        ]
    });
}
var $0ed549787c3d719b$export$2e2bcd8739ae039 = $0ed549787c3d719b$var$Analytics;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


const $a86ee2eea1b8cff6$var$defaultOptions = {};
const $a86ee2eea1b8cff6$export$dbc764ab0aa4a1d7 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation createEventType($input: CreateEventTypeInput!) {
  createEventType(createEventTypeInput: $input) {
    id
    userId
    name
    description
    color
    duration
    maxEvents
    minNotice
    beforeBuffer
    afterBuffer
    timezone
    active
    createAt
    updateAt
    EventTypeAvailability {
      id
      day
      EventTypeAvailabilityBracket {
        id
        startHour
        startMinute
        endHour
        endMinute
      }
    }
  }
}
    `;
function $a86ee2eea1b8cff6$export$105ce66260a3f2ce(baseOptions) {
    const options = {
        ...$a86ee2eea1b8cff6$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($a86ee2eea1b8cff6$export$dbc764ab0aa4a1d7, options);
}
const $a86ee2eea1b8cff6$export$7cb6c710e768e0b9 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation removeEventType($id: String!) {
  removeEventType(id: $id) {
    id
    userId
    name
    description
    color
    duration
    maxEvents
    minNotice
    beforeBuffer
    afterBuffer
    timezone
    active
    createAt
    updateAt
    EventTypeAvailability {
      id
      day
      EventTypeAvailabilityBracket {
        id
        startHour
        startMinute
        endHour
        endMinute
      }
    }
  }
}
    `;
function $a86ee2eea1b8cff6$export$67ed0afb0d26fd88(baseOptions) {
    const options = {
        ...$a86ee2eea1b8cff6$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($a86ee2eea1b8cff6$export$7cb6c710e768e0b9, options);
}
const $a86ee2eea1b8cff6$export$4cf1401951f853ff = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation updateEventType($input: UpdateEventTypeInput!) {
  updateEventType(updateEventTypeInput: $input) {
    id
    userId
    name
    description
    color
    duration
    maxEvents
    minNotice
    beforeBuffer
    afterBuffer
    timezone
    active
    createAt
    updateAt
    EventTypeAvailability {
      day
      EventTypeAvailabilityBracket {
        startHour
        startMinute
        endHour
        endMinute
      }
    }
  }
}
    `;
function $a86ee2eea1b8cff6$export$c3c94773abc40b0f(baseOptions) {
    const options = {
        ...$a86ee2eea1b8cff6$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($a86ee2eea1b8cff6$export$4cf1401951f853ff, options);
}
const $a86ee2eea1b8cff6$export$7e3a176b19b130d = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation createEvent($input: CreateEventInput!) {
  createEvent(createEventInput: $input) {
    id
    eventTypeId
    organizerId
    meetingId
    status
    startDate
    endDate
    title
    notes
    type
    createAt
    updateAt
    Meetings {
      id
      channelId
      createAt
      updateAt
      MeetingAttendees {
        id
        userId
        unregisteredUserId
        firstName
        lastName
        createAt
        updateAt
      }
    }
    EventTypes {
      id
      userId
      name
      description
      color
      duration
      maxEvents
      minNotice
      beforeBuffer
      afterBuffer
      timezone
      active
      createAt
      updateAt
    }
  }
}
    `;
function $a86ee2eea1b8cff6$export$c78810c1254c21c8(baseOptions) {
    const options = {
        ...$a86ee2eea1b8cff6$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($a86ee2eea1b8cff6$export$7e3a176b19b130d, options);
}
const $a86ee2eea1b8cff6$export$aa1aba463399622d = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation getNylasCalendarEvents($input: FetchNylasEventsDto!) {
  getNylasCalendarEvents(fetchNylasEventsDto: $input) {
    id
    organizerId
    status
    startDate
    endDate
    title
    notes
    type
    color
    duration
    iCalUID
    attendees {
      name
      email
      status
    }
  }
}
    `;
function $a86ee2eea1b8cff6$export$b960f151b5a7d556(baseOptions) {
    const options = {
        ...$a86ee2eea1b8cff6$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($a86ee2eea1b8cff6$export$aa1aba463399622d, options);
}
const $a86ee2eea1b8cff6$export$92647190e4b790c = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation cancelEvent($id: String!) {
  cancelEvent(id: $id) {
    id
    eventTypeId
    organizerId
    meetingId
    status
    startDate
    endDate
    title
    notes
    type
  }
}
    `;
function $a86ee2eea1b8cff6$export$5480be2de31586b(baseOptions) {
    const options = {
        ...$a86ee2eea1b8cff6$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($a86ee2eea1b8cff6$export$92647190e4b790c, options);
}
const $a86ee2eea1b8cff6$export$fa5f9583c3b91953 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation PreparerAvailability($input: PreparerAvailabilityInput!) {
  PreparerAvailability(preparerAvailabilityInput: $input) {
    eventsInDay
    brackets {
      id
      startHour
      startMinute
      endHour
      endMinute
    }
  }
}
    `;
function $a86ee2eea1b8cff6$export$b027a4e78e4dda82(baseOptions) {
    const options = {
        ...$a86ee2eea1b8cff6$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($a86ee2eea1b8cff6$export$fa5f9583c3b91953, options);
}
const $a86ee2eea1b8cff6$export$65ffdf76a95ab745 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateEventTypeTimezone($timezone: String!) {
  UpdateEventTypeTimezone(timezone: $timezone)
}
    `;
function $a86ee2eea1b8cff6$export$8c277d92037582e3(baseOptions) {
    const options = {
        ...$a86ee2eea1b8cff6$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($a86ee2eea1b8cff6$export$65ffdf76a95ab745, options);
}
const $a86ee2eea1b8cff6$export$629c7ca71c17ab3d = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation updateEvent($input: UpdateEventInput!) {
  updateEvent(updateEventInput: $input) {
    id
    eventTypeId
    organizerId
    meetingId
    status
    startDate
    endDate
    title
    notes
    type
    createAt
    updateAt
    Meetings {
      id
      channelId
      createAt
      updateAt
      MeetingAttendees {
        id
        userId
        unregisteredUserId
        firstName
        lastName
        createAt
        updateAt
      }
    }
    EventTypes {
      id
      userId
      name
      description
      color
      duration
      maxEvents
      minNotice
      beforeBuffer
      afterBuffer
      timezone
      active
      createAt
      updateAt
    }
  }
}
    `;
function $a86ee2eea1b8cff6$export$d624085c29681b0a(baseOptions) {
    const options = {
        ...$a86ee2eea1b8cff6$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($a86ee2eea1b8cff6$export$629c7ca71c17ab3d, options);
}
const $a86ee2eea1b8cff6$export$dce6502dffe2ec1d = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation removeEvent($id: String!) {
  removeEvent(id: $id) {
    id
    eventTypeId
    organizerId
    meetingId
    status
    startDate
    endDate
    title
    notes
    type
    createAt
    updateAt
  }
}
    `;
function $a86ee2eea1b8cff6$export$4f852e08102b5702(baseOptions) {
    const options = {
        ...$a86ee2eea1b8cff6$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($a86ee2eea1b8cff6$export$dce6502dffe2ec1d, options);
}
const $a86ee2eea1b8cff6$export$1903e426257af165 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation connectExternalCalendar($provider: String!, $code: String!, $state: String!) {
  connectExternalCalendar(provider: $provider, code: $code, state: $state) {
    id
  }
}
    `;
function $a86ee2eea1b8cff6$export$633280c0c1c517b(baseOptions) {
    const options = {
        ...$a86ee2eea1b8cff6$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($a86ee2eea1b8cff6$export$1903e426257af165, options);
}
const $a86ee2eea1b8cff6$export$39ac829ab91f0716 = {
    Mutation: {
        createEventType: 'createEventType',
        removeEventType: 'removeEventType',
        updateEventType: 'updateEventType',
        createEvent: 'createEvent',
        getNylasCalendarEvents: 'getNylasCalendarEvents',
        cancelEvent: 'cancelEvent',
        PreparerAvailability: 'PreparerAvailability',
        UpdateEventTypeTimezone: 'UpdateEventTypeTimezone',
        updateEvent: 'updateEvent',
        removeEvent: 'removeEvent',
        connectExternalCalendar: 'connectExternalCalendar'
    }
};



const $cfef3f1bede5cb90$var$defaultOptions = {};
const $cfef3f1bede5cb90$export$e81e1ebd88764b74 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query MyEventTypes($timezone: String!) {
  MyEventTypes(timezone: $timezone) {
    id
    userId
    name
    description
    color
    duration
    maxEvents
    minNotice
    beforeBuffer
    afterBuffer
    timezone
    active
    EventTypeAvailability {
      id
      day
      EventTypeAvailabilityBracket {
        id
        startHour
        startMinute
        endHour
        endMinute
      }
    }
  }
}
    `;
function $cfef3f1bede5cb90$export$10d6da411e25606d(baseOptions) {
    const options = {
        ...$cfef3f1bede5cb90$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($cfef3f1bede5cb90$export$e81e1ebd88764b74, options);
}
function $cfef3f1bede5cb90$export$a7c707bc0783a79c(baseOptions) {
    const options = {
        ...$cfef3f1bede5cb90$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($cfef3f1bede5cb90$export$e81e1ebd88764b74, options);
}
const $cfef3f1bede5cb90$export$7a3b4904b0a97d55 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query MyEvents {
  MyEvents {
    id
    eventTypeId
    organizerId
    meetingId
    status
    startDate
    endDate
    title
    notes
    type
    createAt
    Meetings {
      id
      channelId
      MeetingAttendees {
        id
        userId
        unregisteredUserId
        firstName
        lastName
      }
    }
    EventTypes {
      id
      userId
      name
      description
      color
      duration
      maxEvents
      minNotice
      beforeBuffer
      afterBuffer
      timezone
      active
    }
  }
}
    `;
function $cfef3f1bede5cb90$export$b6cccab7e21ecbba(baseOptions) {
    const options = {
        ...$cfef3f1bede5cb90$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($cfef3f1bede5cb90$export$7a3b4904b0a97d55, options);
}
function $cfef3f1bede5cb90$export$e886cdbd95c955f6(baseOptions) {
    const options = {
        ...$cfef3f1bede5cb90$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($cfef3f1bede5cb90$export$7a3b4904b0a97d55, options);
}
const $cfef3f1bede5cb90$export$914055cc0ada8608 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query getCalendarOauthUrl($provider: String!) {
  getCalendarOauthUrl(provider: $provider)
}
    `;
function $cfef3f1bede5cb90$export$b327f5d98853b8db(baseOptions) {
    const options = {
        ...$cfef3f1bede5cb90$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($cfef3f1bede5cb90$export$914055cc0ada8608, options);
}
function $cfef3f1bede5cb90$export$e17d833f6fc5a980(baseOptions) {
    const options = {
        ...$cfef3f1bede5cb90$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($cfef3f1bede5cb90$export$914055cc0ada8608, options);
}
const $cfef3f1bede5cb90$export$5343f8ea1723738b = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query getExternalCalendarEvents($filters: ExternalCalendarFilterDto!) {
  getExternalEvents(filters: $filters) {
    id
    organizerId
    status
    startDate
    endDate
    title
    notes
    type
    color
    duration
    iCalUID
    attendees {
      name
      email
      status
    }
  }
}
    `;
function $cfef3f1bede5cb90$export$8f7ffaa4db8fbf74(baseOptions) {
    const options = {
        ...$cfef3f1bede5cb90$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($cfef3f1bede5cb90$export$5343f8ea1723738b, options);
}
function $cfef3f1bede5cb90$export$3ae5539c66ab4a4e(baseOptions) {
    const options = {
        ...$cfef3f1bede5cb90$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($cfef3f1bede5cb90$export$5343f8ea1723738b, options);
}
const $cfef3f1bede5cb90$export$39ac829ab91f0716 = {
    Query: {
        MyEventTypes: 'MyEventTypes',
        MyEvents: 'MyEvents',
        getCalendarOauthUrl: 'getCalendarOauthUrl',
        getExternalCalendarEvents: 'getExternalCalendarEvents'
    }
};





var $6Sgv0 = parcelRequire("6Sgv0");
var $7b899c8e5076dc5b$exports = {};

var $7b899c8e5076dc5b$var$moment = $7b899c8e5076dc5b$exports = (parcelRequire("1hWVY"));

$7b899c8e5076dc5b$var$moment.tz.load((parcelRequire("5zyFs")));


const $5bafd68f69b44f55$export$d22e79b7850fc6d8 = 60000;
/**
 * @function
 * @param {string} format12Hrs - Hour in format 12hrs (1:15pm)
 */ const $5bafd68f69b44f55$export$cf9f2a11807110eb = (format12Hrs)=>{
    const pm = format12Hrs.toUpperCase().includes('PM');
    const cleanHrs = format12Hrs.toUpperCase().replace('AM', '').replace('PM', '');
    const horMin = cleanHrs.split(':');
    const hrInt = parseInt(horMin[0], 10);
    const hr = (hrInt === 12 ? 0 : hrInt) + (pm ? 12 : 0);
    const min = horMin[1];
    return {
        format12Hrs: format12Hrs,
        format24Hrs: `${hr}:${min}`,
        hours: hr,
        minutes: parseInt(min, 10)
    };
};
/**
 * @function
 * @param  {string | undefined} hours - Range hours (9:00am - 1:15pm)
 * @param  {string} separator - Range separator Default('-')
 */ const $5bafd68f69b44f55$export$442c0f5af3870293 = (hours, separator = '-')=>{
    const hoursArray = hours.split(separator);
    const startHour = $5bafd68f69b44f55$export$cf9f2a11807110eb(hoursArray[0].trim());
    const endHour = $5bafd68f69b44f55$export$cf9f2a11807110eb(hoursArray[1].trim());
    return {
        startHour: startHour,
        endHour: endHour
    };
};
/**
 * @function
 * @param {any} day - day
 * @param {int} hours - hours
 * @param {int} minutes - minutes
 */ const $5bafd68f69b44f55$export$e029667a62135fd0 = (day, hours, minutes)=>(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(day.format()).set({
        hours: hours,
        minutes: minutes
    }).format();
const $5bafd68f69b44f55$export$c3133dbc11f66777 = (time)=>{
    const date = time ? (0, (/*@__PURE__*/$parcel$interopDefault($7b899c8e5076dc5b$exports)))(new Date(time)) : (0, (/*@__PURE__*/$parcel$interopDefault($7b899c8e5076dc5b$exports)))(new Date());
    let timeZone = (0, (/*@__PURE__*/$parcel$interopDefault($7b899c8e5076dc5b$exports))).tz.guess();
    if (!timeZone) timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timeZoneAbreviation = date.tz(timeZone).format('z');
    return {
        large: timeZone,
        short: timeZoneAbreviation
    };
};
const $5bafd68f69b44f55$export$35884f1dee4bd16e = (from, to, duration)=>{
    const fromArray = `${from}`.split(':');
    const toArray = `${to}`.split(':');
    const toTime = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().set({
        hour: Number(toArray[0]),
        minute: Number(toArray[1])
    });
    const start = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().set({
        hour: Number(fromArray[0]),
        minute: Number(fromArray[1])
    });
    const end = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(start).add(duration, 'm');
    const times = [];
    do {
        times.push({
            startHour: start.hour(),
            startMinute: start.minute(),
            endHour: end.hour(),
            endMinute: end.minute()
        });
        start.add(duration, 'm');
        end.add(duration, 'm');
    }while (start.isBefore(toTime));
    return times;
};
const $5bafd68f69b44f55$export$db731c12fd4796f8 = (duration, init)=>{
    const time = `${init}`.split(':');
    const start = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().set(init ? {
        hour: Number(time[0]),
        minute: Number(time[1])
    } : {
        hour: 0,
        minute: 0
    });
    const end = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().set(init ? {
        hour: 24,
        minute: 0
    } : {
        hour: 23,
        minute: 59
    });
    const times = [];
    do {
        times.push({
            value: start.format('HH:mm'),
            label: start.format('hh:mm A')
        });
        start.add(duration, 'm');
    }while (start.isSameOrBefore(end));
    return times;
};
const $5bafd68f69b44f55$export$1428f42a7de81803 = (hour, minute)=>(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().set({
        hour: hour,
        minute: minute
    });
const $5bafd68f69b44f55$export$d784918a83e8de76 = (ms)=>{
    const days = ms / 86400000;
    if (days < 1) {
        const minutes = Math.floor(ms / 60000);
        if (minutes < 60) {
            if (minutes === 0) return 'A few seconds';
            return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
        }
        return `${Math.floor(minutes / 60)} ${Math.floor(minutes / 60) === 1 ? 'hour' : 'hours'}`;
    }
    if (days < 30) return `${Math.floor(days)} ${Math.floor(days) === 1 ? 'day' : 'days'}`;
    return `${Math.floor(days / 30)} ${Math.floor(days / 30) === 1 ? 'month' : 'months'}`;
};




var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");






var $bb3TF = parcelRequire("bb3TF");



const { confirm: $4073d6158b26fbcb$var$confirm } = (0, $6db0040c215ed6e9$export$341c47594849c7de);
const { CalendarOutlined: $4073d6158b26fbcb$var$CalendarOutlined, ClockCircleOutlined: $4073d6158b26fbcb$var$ClockCircleOutlined, DeleteOutlined: $4073d6158b26fbcb$var$DeleteOutlined, ExclamationCircleOutlined: $4073d6158b26fbcb$var$ExclamationCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $4073d6158b26fbcb$var$EventType = ({ eventType: eventType, onClick: onClick, isLoading: isLoading, handleOnError: handleOnError })=>{
    const { name: name, duration: duration, EventTypeAvailability: EventTypeAvailability, active: eventTypeActive } = eventType;
    const [removeEventTypeMutation, { loading: removeEventTypeLoading }] = (0, $a86ee2eea1b8cff6$export$67ed0afb0d26fd88)({
        onError: handleOnError,
        refetchQueries: [
            (0, $cfef3f1bede5cb90$export$e81e1ebd88764b74)
        ],
        awaitRefetchQueries: true
    });
    const [updateEventTypeMutation, { loading: updateEventTypeLoading }] = (0, $a86ee2eea1b8cff6$export$c3c94773abc40b0f)({
        onError: handleOnError,
        refetchQueries: [
            (0, $cfef3f1bede5cb90$export$e81e1ebd88764b74)
        ],
        awaitRefetchQueries: true
    });
    const daysAvailable = EventTypeAvailability.map((avail, index, array)=>{
        if (index === array.length - 1) return avail?.day.substring(0, 3).toLowerCase();
        return `${avail?.day.substring(0, 3).toLowerCase()}, `;
    });
    const updateActive = async ()=>{
        const updateInput = {
            ...eventType,
            active: !eventTypeActive,
            EventTypeAvailability: undefined,
            __typename: undefined,
            userId: undefined
        };
        await updateEventTypeMutation({
            variables: {
                input: updateInput
            }
        });
    };
    const showConfirm = ()=>{
        $4073d6158b26fbcb$var$confirm({
            title: 'Are you sure you want to delete this event type?',
            icon: (0, $bb3TF.jsx)($4073d6158b26fbcb$var$ExclamationCircleOutlined, {}),
            onOk: async ()=>{
                await removeEventTypeMutation({
                    variables: {
                        id: eventType.id
                    }
                });
            }
        });
    };
    return (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
        loading: isLoading || removeEventTypeLoading || updateEventTypeLoading,
        title: (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
            onClick: ()=>onClick(eventType),
            type: "link",
            children: name.length > 14 ? `${name.substring(0, 12)}...` : name
        }),
        extra: (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
            danger: true,
            type: "link",
            onClick: ()=>showConfirm(),
            icon: (0, $bb3TF.jsx)($4073d6158b26fbcb$var$DeleteOutlined, {})
        }),
        style: {
            width: '220px',
            height: '240px'
        },
        children: [
            (0, $bb3TF.jsxs)((0, $3c2758025c182ca4$export$2e2bcd8739ae039), {
                color: "default",
                style: {
                    display: 'flex',
                    width: '170px',
                    height: '80px',
                    flexDirection: 'column',
                    justifyContent: 'center'
                },
                children: [
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        align: "middle",
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                style: {
                                    width: '25%',
                                    textAlign: 'center'
                                },
                                children: (0, $bb3TF.jsx)($4073d6158b26fbcb$var$CalendarOutlined, {})
                            }),
                            (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                style: {
                                    textTransform: 'capitalize',
                                    whiteSpace: 'break-spaces',
                                    width: '75%'
                                },
                                children: [
                                    "Days:",
                                    ' ',
                                    daysAvailable
                                ]
                            })
                        ]
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        align: "middle",
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                style: {
                                    width: '25%',
                                    textAlign: 'center'
                                },
                                children: (0, $bb3TF.jsx)($4073d6158b26fbcb$var$ClockCircleOutlined, {})
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                style: {
                                    width: '75%'
                                },
                                children: `Duration: ${duration} min`
                            })
                        ]
                    })
                ]
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                align: "middle",
                justify: "end",
                style: {
                    paddingTop: '20px'
                },
                gutter: 15,
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: eventTypeActive ? 'Active' : 'Inactive'
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $4fd303306a27e42e$export$2e2bcd8739ae039), {
                            onChange: updateActive,
                            checked: eventTypeActive
                        })
                    })
                ]
            })
        ]
    });
};
var $4073d6158b26fbcb$export$2e2bcd8739ae039 = $4073d6158b26fbcb$var$EventType;


var $1b66c700c98e8cab$export$2e2bcd8739ae039 = (0, $4073d6158b26fbcb$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");
var $bd96d54b29ffe643$exports = {};
'use strict';
Object.defineProperty($bd96d54b29ffe643$exports, "__esModule", {
    value: true
});
$bd96d54b29ffe643$exports.ReactCSS = $bd96d54b29ffe643$exports.loop = $bd96d54b29ffe643$exports.handleActive = $bd96d54b29ffe643$exports.handleHover = $bd96d54b29ffe643$exports.hover = undefined;
var $b91d555af77cd109$exports = {};
'use strict';
Object.defineProperty($b91d555af77cd109$exports, "__esModule", {
    value: true
});
$b91d555af77cd109$exports.flattenNames = undefined;
var $4e150879de90cf4b$exports = {};



/** `Object#toString` result references. */ var $4e150879de90cf4b$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $4e150879de90cf4b$var$isString(value) {
    return typeof value == 'string' || !$2a0fbf166027c360$exports(value) && $2491d5b87f6f34f9$exports(value) && $b35c5a96e6a9987b$exports(value) == $4e150879de90cf4b$var$stringTag;
}
$4e150879de90cf4b$exports = $4e150879de90cf4b$var$isString;


var $b91d555af77cd109$var$_isString3 = $b91d555af77cd109$var$_interopRequireDefault($4e150879de90cf4b$exports);
var $d50176d51d9a4d06$exports = {};

var $f9eab356e790158b$exports = {};

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $f9eab356e790158b$var$castFunction(value) {
    return typeof value == 'function' ? value : $1b0ac323385ce009$exports;
}
$f9eab356e790158b$exports = $f9eab356e790158b$var$castFunction;


/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $d50176d51d9a4d06$var$forOwn(object, iteratee) {
    return object && $edb97d32e8dcec56$exports(object, $f9eab356e790158b$exports(iteratee));
}
$d50176d51d9a4d06$exports = $d50176d51d9a4d06$var$forOwn;


var $b91d555af77cd109$var$_forOwn3 = $b91d555af77cd109$var$_interopRequireDefault($d50176d51d9a4d06$exports);
var $bec0b515b3cebbb9$exports = {};

var $676249d4e5840414$exports = {};

/** Built-in value references. */ var $676249d4e5840414$var$getPrototype = $ceb759ab72d88965$exports(Object.getPrototypeOf, Object);
$676249d4e5840414$exports = $676249d4e5840414$var$getPrototype;



/** `Object#toString` result references. */ var $bec0b515b3cebbb9$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $bec0b515b3cebbb9$var$funcProto = Function.prototype, $bec0b515b3cebbb9$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $bec0b515b3cebbb9$var$funcToString = $bec0b515b3cebbb9$var$funcProto.toString;
/** Used to check objects for own properties. */ var $bec0b515b3cebbb9$var$hasOwnProperty = $bec0b515b3cebbb9$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $bec0b515b3cebbb9$var$objectCtorString = $bec0b515b3cebbb9$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $bec0b515b3cebbb9$var$isPlainObject(value) {
    if (!$2491d5b87f6f34f9$exports(value) || $b35c5a96e6a9987b$exports(value) != $bec0b515b3cebbb9$var$objectTag) return false;
    var proto = $676249d4e5840414$exports(value);
    if (proto === null) return true;
    var Ctor = $bec0b515b3cebbb9$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $bec0b515b3cebbb9$var$funcToString.call(Ctor) == $bec0b515b3cebbb9$var$objectCtorString;
}
$bec0b515b3cebbb9$exports = $bec0b515b3cebbb9$var$isPlainObject;


var $b91d555af77cd109$var$_isPlainObject3 = $b91d555af77cd109$var$_interopRequireDefault($bec0b515b3cebbb9$exports);
var $a1e0f50e3237fdfc$exports = {};


var $5420a7b4d112f335$exports = {};
var $18a66ea0f1ec0968$exports = {};

var $c6ed7e102aa4be8e$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $c6ed7e102aa4be8e$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$a50a26323cccf7ad$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$c6ed7e102aa4be8e$exports = $c6ed7e102aa4be8e$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $18a66ea0f1ec0968$var$baseEach = $c6ed7e102aa4be8e$exports($edb97d32e8dcec56$exports);
$18a66ea0f1ec0968$exports = $18a66ea0f1ec0968$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $5420a7b4d112f335$var$baseMap(collection, iteratee) {
    var index = -1, result = $a50a26323cccf7ad$exports(collection) ? Array(collection.length) : [];
    $18a66ea0f1ec0968$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$5420a7b4d112f335$exports = $5420a7b4d112f335$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $a1e0f50e3237fdfc$var$map(collection, iteratee) {
    var func = $2a0fbf166027c360$exports(collection) ? $f66d194dd2fd382e$exports : $5420a7b4d112f335$exports;
    return func(collection, $30aaebbdaff8808f$exports(iteratee, 3));
}
$a1e0f50e3237fdfc$exports = $a1e0f50e3237fdfc$var$map;


var $b91d555af77cd109$var$_map3 = $b91d555af77cd109$var$_interopRequireDefault($a1e0f50e3237fdfc$exports);
function $b91d555af77cd109$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b91d555af77cd109$var$flattenNames = $b91d555af77cd109$exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, $b91d555af77cd109$var$_map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, $b91d555af77cd109$var$_isPlainObject3.default)(thing)) (0, $b91d555af77cd109$var$_forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + '-' + value);
        });
        else if ((0, $b91d555af77cd109$var$_isString3.default)(thing)) names.push(thing);
    });
    return names;
};
$b91d555af77cd109$exports.default = $b91d555af77cd109$var$flattenNames;


var $bd96d54b29ffe643$var$_flattenNames2 = $bd96d54b29ffe643$var$_interopRequireDefault($b91d555af77cd109$exports);
var $89fb96c9e830ad9a$exports = {};
'use strict';
Object.defineProperty($89fb96c9e830ad9a$exports, "__esModule", {
    value: true
});
$89fb96c9e830ad9a$exports.mergeClasses = undefined;

var $89fb96c9e830ad9a$var$_forOwn3 = $89fb96c9e830ad9a$var$_interopRequireDefault($d50176d51d9a4d06$exports);
var $b5eeade30bd01e2d$exports = {};
var $02e558f91db50a45$exports = {};

var $7ddd63d9de8c1f47$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $7ddd63d9de8c1f47$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$7ddd63d9de8c1f47$exports = $7ddd63d9de8c1f47$var$arrayEach;


var $6b2caa2604ae6d5a$exports = {};


/** Used for built-in method references. */ var $6b2caa2604ae6d5a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6b2caa2604ae6d5a$var$hasOwnProperty = $6b2caa2604ae6d5a$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $6b2caa2604ae6d5a$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($6b2caa2604ae6d5a$var$hasOwnProperty.call(object, key) && $bb5d7160ba902670$exports(objValue, value)) || value === undefined && !(key in object)) $f50513f2ca42f446$exports(object, key, value);
}
$6b2caa2604ae6d5a$exports = $6b2caa2604ae6d5a$var$assignValue;


var $a25efe62fefe22a6$exports = {};
var $61982f36cf88650b$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $61982f36cf88650b$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $f50513f2ca42f446$exports(object, key, newValue);
        else $6b2caa2604ae6d5a$exports(object, key, newValue);
    }
    return object;
}
$61982f36cf88650b$exports = $61982f36cf88650b$var$copyObject;



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $a25efe62fefe22a6$var$baseAssign(object, source) {
    return object && $61982f36cf88650b$exports(source, $9a87f3ff62ea94fb$exports(source), object);
}
$a25efe62fefe22a6$exports = $a25efe62fefe22a6$var$baseAssign;


var $b086471e51432f28$exports = {};

var $c8c81b5d53370d54$exports = {};

var $dcdb6a59c462cd0f$exports = {};


var $207a58e43964c7a9$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $207a58e43964c7a9$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$207a58e43964c7a9$exports = $207a58e43964c7a9$var$nativeKeysIn;


/** Used for built-in method references. */ var $dcdb6a59c462cd0f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dcdb6a59c462cd0f$var$hasOwnProperty = $dcdb6a59c462cd0f$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $dcdb6a59c462cd0f$var$baseKeysIn(object) {
    if (!$de338c730ce7636d$exports(object)) return $207a58e43964c7a9$exports(object);
    var isProto = $b27431a634574c41$exports(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$dcdb6a59c462cd0f$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$dcdb6a59c462cd0f$exports = $dcdb6a59c462cd0f$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $c8c81b5d53370d54$var$keysIn(object) {
    return $a50a26323cccf7ad$exports(object) ? $e0a95b40dee71b57$exports(object, true) : $dcdb6a59c462cd0f$exports(object);
}
$c8c81b5d53370d54$exports = $c8c81b5d53370d54$var$keysIn;


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $b086471e51432f28$var$baseAssignIn(object, source) {
    return object && $61982f36cf88650b$exports(source, $c8c81b5d53370d54$exports(source), object);
}
$b086471e51432f28$exports = $b086471e51432f28$var$baseAssignIn;



var $lDAPC = parcelRequire("lDAPC");
var $f3279acc4f07a120$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $f3279acc4f07a120$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$f3279acc4f07a120$exports = $f3279acc4f07a120$var$copyArray;


var $df1e997a06d2775d$exports = {};


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $df1e997a06d2775d$var$copySymbols(source, object) {
    return $61982f36cf88650b$exports(source, $c59b9f4107bbf907$exports(source), object);
}
$df1e997a06d2775d$exports = $df1e997a06d2775d$var$copySymbols;


var $9751fa5cc4e85e95$exports = {};

var $d5d5b5a3cb56114c$exports = {};




/* Built-in method references for those with the same name as other `lodash` methods. */ var $d5d5b5a3cb56114c$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $d5d5b5a3cb56114c$var$getSymbolsIn = !$d5d5b5a3cb56114c$var$nativeGetSymbols ? $0d5a99df1493d0e9$exports : function(object) {
    var result = [];
    while(object){
        $b29d179f784da4ca$exports(result, $c59b9f4107bbf907$exports(object));
        object = $676249d4e5840414$exports(object);
    }
    return result;
};
$d5d5b5a3cb56114c$exports = $d5d5b5a3cb56114c$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $9751fa5cc4e85e95$var$copySymbolsIn(source, object) {
    return $61982f36cf88650b$exports(source, $d5d5b5a3cb56114c$exports(source), object);
}
$9751fa5cc4e85e95$exports = $9751fa5cc4e85e95$var$copySymbolsIn;



var $5890cda13c6dd6d5$exports = {};



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5890cda13c6dd6d5$var$getAllKeysIn(object) {
    return $c48a2981800f40c6$exports(object, $c8c81b5d53370d54$exports, $d5d5b5a3cb56114c$exports);
}
$5890cda13c6dd6d5$exports = $5890cda13c6dd6d5$var$getAllKeysIn;



var $4cebe0d09c7e1dcc$exports = {};
/** Used for built-in method references. */ var $4cebe0d09c7e1dcc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4cebe0d09c7e1dcc$var$hasOwnProperty = $4cebe0d09c7e1dcc$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $4cebe0d09c7e1dcc$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $4cebe0d09c7e1dcc$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$4cebe0d09c7e1dcc$exports = $4cebe0d09c7e1dcc$var$initCloneArray;


var $5c7dbbecd4413baf$exports = {};
var $52f38d04b749e5a6$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $52f38d04b749e5a6$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $e5099552f7860df1$exports(result).set(new $e5099552f7860df1$exports(arrayBuffer));
    return result;
}
$52f38d04b749e5a6$exports = $52f38d04b749e5a6$var$cloneArrayBuffer;


var $f3e7e88da9740ab6$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $f3e7e88da9740ab6$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $52f38d04b749e5a6$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$f3e7e88da9740ab6$exports = $f3e7e88da9740ab6$var$cloneDataView;


var $088a7c28bce7cd76$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $088a7c28bce7cd76$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $088a7c28bce7cd76$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $088a7c28bce7cd76$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$088a7c28bce7cd76$exports = $088a7c28bce7cd76$var$cloneRegExp;


var $a9d9d56f35bbd3c1$exports = {};

/** Used to convert symbols to primitives and strings. */ var $a9d9d56f35bbd3c1$var$symbolProto = $57507d7d7570b777$exports ? $57507d7d7570b777$exports.prototype : undefined, $a9d9d56f35bbd3c1$var$symbolValueOf = $a9d9d56f35bbd3c1$var$symbolProto ? $a9d9d56f35bbd3c1$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $a9d9d56f35bbd3c1$var$cloneSymbol(symbol) {
    return $a9d9d56f35bbd3c1$var$symbolValueOf ? Object($a9d9d56f35bbd3c1$var$symbolValueOf.call(symbol)) : {};
}
$a9d9d56f35bbd3c1$exports = $a9d9d56f35bbd3c1$var$cloneSymbol;


var $46fbfbd2fae6572f$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $46fbfbd2fae6572f$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $52f38d04b749e5a6$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$46fbfbd2fae6572f$exports = $46fbfbd2fae6572f$var$cloneTypedArray;


/** `Object#toString` result references. */ var $5c7dbbecd4413baf$var$boolTag = '[object Boolean]', $5c7dbbecd4413baf$var$dateTag = '[object Date]', $5c7dbbecd4413baf$var$mapTag = '[object Map]', $5c7dbbecd4413baf$var$numberTag = '[object Number]', $5c7dbbecd4413baf$var$regexpTag = '[object RegExp]', $5c7dbbecd4413baf$var$setTag = '[object Set]', $5c7dbbecd4413baf$var$stringTag = '[object String]', $5c7dbbecd4413baf$var$symbolTag = '[object Symbol]';
var $5c7dbbecd4413baf$var$arrayBufferTag = '[object ArrayBuffer]', $5c7dbbecd4413baf$var$dataViewTag = '[object DataView]', $5c7dbbecd4413baf$var$float32Tag = '[object Float32Array]', $5c7dbbecd4413baf$var$float64Tag = '[object Float64Array]', $5c7dbbecd4413baf$var$int8Tag = '[object Int8Array]', $5c7dbbecd4413baf$var$int16Tag = '[object Int16Array]', $5c7dbbecd4413baf$var$int32Tag = '[object Int32Array]', $5c7dbbecd4413baf$var$uint8Tag = '[object Uint8Array]', $5c7dbbecd4413baf$var$uint8ClampedTag = '[object Uint8ClampedArray]', $5c7dbbecd4413baf$var$uint16Tag = '[object Uint16Array]', $5c7dbbecd4413baf$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $5c7dbbecd4413baf$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $5c7dbbecd4413baf$var$arrayBufferTag:
            return $52f38d04b749e5a6$exports(object);
        case $5c7dbbecd4413baf$var$boolTag:
        case $5c7dbbecd4413baf$var$dateTag:
            return new Ctor(+object);
        case $5c7dbbecd4413baf$var$dataViewTag:
            return $f3e7e88da9740ab6$exports(object, isDeep);
        case $5c7dbbecd4413baf$var$float32Tag:
        case $5c7dbbecd4413baf$var$float64Tag:
        case $5c7dbbecd4413baf$var$int8Tag:
        case $5c7dbbecd4413baf$var$int16Tag:
        case $5c7dbbecd4413baf$var$int32Tag:
        case $5c7dbbecd4413baf$var$uint8Tag:
        case $5c7dbbecd4413baf$var$uint8ClampedTag:
        case $5c7dbbecd4413baf$var$uint16Tag:
        case $5c7dbbecd4413baf$var$uint32Tag:
            return $46fbfbd2fae6572f$exports(object, isDeep);
        case $5c7dbbecd4413baf$var$mapTag:
            return new Ctor;
        case $5c7dbbecd4413baf$var$numberTag:
        case $5c7dbbecd4413baf$var$stringTag:
            return new Ctor(object);
        case $5c7dbbecd4413baf$var$regexpTag:
            return $088a7c28bce7cd76$exports(object);
        case $5c7dbbecd4413baf$var$setTag:
            return new Ctor;
        case $5c7dbbecd4413baf$var$symbolTag:
            return $a9d9d56f35bbd3c1$exports(object);
    }
}
$5c7dbbecd4413baf$exports = $5c7dbbecd4413baf$var$initCloneByTag;


var $a42547d72f9c870c$exports = {};
var $155332720be4dcd6$exports = {};

/** Built-in value references. */ var $155332720be4dcd6$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $155332720be4dcd6$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$de338c730ce7636d$exports(proto)) return {};
        if ($155332720be4dcd6$var$objectCreate) return $155332720be4dcd6$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$155332720be4dcd6$exports = $155332720be4dcd6$var$baseCreate;




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $a42547d72f9c870c$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$b27431a634574c41$exports(object) ? $155332720be4dcd6$exports($676249d4e5840414$exports(object)) : {};
}
$a42547d72f9c870c$exports = $a42547d72f9c870c$var$initCloneObject;




var $a1BUX = parcelRequire("a1BUX");
var $4e1f4dd9b4e57884$exports = {};
var $476b4dd6f18fb870$exports = {};


/** `Object#toString` result references. */ var $476b4dd6f18fb870$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $476b4dd6f18fb870$var$baseIsMap(value) {
    return $2491d5b87f6f34f9$exports(value) && $fd96f3e23fe5aefe$exports(value) == $476b4dd6f18fb870$var$mapTag;
}
$476b4dd6f18fb870$exports = $476b4dd6f18fb870$var$baseIsMap;




var $Etj01 = parcelRequire("Etj01");
/* Node.js helper references. */ var $4e1f4dd9b4e57884$var$nodeIsMap = $Etj01 && $Etj01.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $4e1f4dd9b4e57884$var$isMap = $4e1f4dd9b4e57884$var$nodeIsMap ? $db45b4386c3091ab$exports($4e1f4dd9b4e57884$var$nodeIsMap) : $476b4dd6f18fb870$exports;
$4e1f4dd9b4e57884$exports = $4e1f4dd9b4e57884$var$isMap;



var $380491f6385d9525$exports = {};
var $ceee204fde860242$exports = {};


/** `Object#toString` result references. */ var $ceee204fde860242$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $ceee204fde860242$var$baseIsSet(value) {
    return $2491d5b87f6f34f9$exports(value) && $fd96f3e23fe5aefe$exports(value) == $ceee204fde860242$var$setTag;
}
$ceee204fde860242$exports = $ceee204fde860242$var$baseIsSet;




var $Etj01 = parcelRequire("Etj01");
/* Node.js helper references. */ var $380491f6385d9525$var$nodeIsSet = $Etj01 && $Etj01.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $380491f6385d9525$var$isSet = $380491f6385d9525$var$nodeIsSet ? $db45b4386c3091ab$exports($380491f6385d9525$var$nodeIsSet) : $ceee204fde860242$exports;
$380491f6385d9525$exports = $380491f6385d9525$var$isSet;




/** Used to compose bitmasks for cloning. */ var $02e558f91db50a45$var$CLONE_DEEP_FLAG = 1, $02e558f91db50a45$var$CLONE_FLAT_FLAG = 2, $02e558f91db50a45$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $02e558f91db50a45$var$argsTag = '[object Arguments]', $02e558f91db50a45$var$arrayTag = '[object Array]', $02e558f91db50a45$var$boolTag = '[object Boolean]', $02e558f91db50a45$var$dateTag = '[object Date]', $02e558f91db50a45$var$errorTag = '[object Error]', $02e558f91db50a45$var$funcTag = '[object Function]', $02e558f91db50a45$var$genTag = '[object GeneratorFunction]', $02e558f91db50a45$var$mapTag = '[object Map]', $02e558f91db50a45$var$numberTag = '[object Number]', $02e558f91db50a45$var$objectTag = '[object Object]', $02e558f91db50a45$var$regexpTag = '[object RegExp]', $02e558f91db50a45$var$setTag = '[object Set]', $02e558f91db50a45$var$stringTag = '[object String]', $02e558f91db50a45$var$symbolTag = '[object Symbol]', $02e558f91db50a45$var$weakMapTag = '[object WeakMap]';
var $02e558f91db50a45$var$arrayBufferTag = '[object ArrayBuffer]', $02e558f91db50a45$var$dataViewTag = '[object DataView]', $02e558f91db50a45$var$float32Tag = '[object Float32Array]', $02e558f91db50a45$var$float64Tag = '[object Float64Array]', $02e558f91db50a45$var$int8Tag = '[object Int8Array]', $02e558f91db50a45$var$int16Tag = '[object Int16Array]', $02e558f91db50a45$var$int32Tag = '[object Int32Array]', $02e558f91db50a45$var$uint8Tag = '[object Uint8Array]', $02e558f91db50a45$var$uint8ClampedTag = '[object Uint8ClampedArray]', $02e558f91db50a45$var$uint16Tag = '[object Uint16Array]', $02e558f91db50a45$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $02e558f91db50a45$var$cloneableTags = {};
$02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$argsTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$arrayTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$arrayBufferTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$dataViewTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$boolTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$dateTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$float32Tag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$float64Tag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$int8Tag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$int16Tag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$int32Tag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$mapTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$numberTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$objectTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$regexpTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$setTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$stringTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$symbolTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$uint8Tag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$uint8ClampedTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$uint16Tag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$uint32Tag] = true;
$02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$errorTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$funcTag] = $02e558f91db50a45$var$cloneableTags[$02e558f91db50a45$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $02e558f91db50a45$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $02e558f91db50a45$var$CLONE_DEEP_FLAG, isFlat = bitmask & $02e558f91db50a45$var$CLONE_FLAT_FLAG, isFull = bitmask & $02e558f91db50a45$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$de338c730ce7636d$exports(value)) return value;
    var isArr = $2a0fbf166027c360$exports(value);
    if (isArr) {
        result = $4cebe0d09c7e1dcc$exports(value);
        if (!isDeep) return $f3279acc4f07a120$exports(value, result);
    } else {
        var tag = $fd96f3e23fe5aefe$exports(value), isFunc = tag == $02e558f91db50a45$var$funcTag || tag == $02e558f91db50a45$var$genTag;
        if ($a1BUX(value)) return $lDAPC(value, isDeep);
        if (tag == $02e558f91db50a45$var$objectTag || tag == $02e558f91db50a45$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $a42547d72f9c870c$exports(value);
            if (!isDeep) return isFlat ? $9751fa5cc4e85e95$exports(value, $b086471e51432f28$exports(result, value)) : $df1e997a06d2775d$exports(value, $a25efe62fefe22a6$exports(result, value));
        } else {
            if (!$02e558f91db50a45$var$cloneableTags[tag]) return object ? value : {};
            result = $5c7dbbecd4413baf$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $458be4e30e44f6b5$exports);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($380491f6385d9525$exports(value)) value.forEach(function(subValue) {
        result.add($02e558f91db50a45$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($4e1f4dd9b4e57884$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $02e558f91db50a45$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $5890cda13c6dd6d5$exports : $ad88cc8579f89995$exports : isFlat ? $c8c81b5d53370d54$exports : $9a87f3ff62ea94fb$exports;
    var props = isArr ? undefined : keysFunc(value);
    $7ddd63d9de8c1f47$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $6b2caa2604ae6d5a$exports(result, key, $02e558f91db50a45$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$02e558f91db50a45$exports = $02e558f91db50a45$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $b5eeade30bd01e2d$var$CLONE_DEEP_FLAG = 1, $b5eeade30bd01e2d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $b5eeade30bd01e2d$var$cloneDeep(value) {
    return $02e558f91db50a45$exports(value, $b5eeade30bd01e2d$var$CLONE_DEEP_FLAG | $b5eeade30bd01e2d$var$CLONE_SYMBOLS_FLAG);
}
$b5eeade30bd01e2d$exports = $b5eeade30bd01e2d$var$cloneDeep;


var $89fb96c9e830ad9a$var$_cloneDeep3 = $89fb96c9e830ad9a$var$_interopRequireDefault($b5eeade30bd01e2d$exports);
var $89fb96c9e830ad9a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $89fb96c9e830ad9a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $89fb96c9e830ad9a$var$mergeClasses = $89fb96c9e830ad9a$exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, $89fb96c9e830ad9a$var$_cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, $89fb96c9e830ad9a$var$_forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = $89fb96c9e830ad9a$var$_extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
$89fb96c9e830ad9a$exports.default = $89fb96c9e830ad9a$var$mergeClasses;


var $bd96d54b29ffe643$var$_mergeClasses2 = $bd96d54b29ffe643$var$_interopRequireDefault($89fb96c9e830ad9a$exports);
var $9db4b568187d3dd2$exports = {};
'use strict';
Object.defineProperty($9db4b568187d3dd2$exports, "__esModule", {
    value: true
});
$9db4b568187d3dd2$exports.autoprefix = undefined;

var $9db4b568187d3dd2$var$_forOwn3 = $9db4b568187d3dd2$var$_interopRequireDefault($d50176d51d9a4d06$exports);
var $9db4b568187d3dd2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $9db4b568187d3dd2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9db4b568187d3dd2$var$transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(' ');
        return {
            position: 'absolute',
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            'extend': name
        };
    }
};
var $9db4b568187d3dd2$var$autoprefix = $9db4b568187d3dd2$exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, $9db4b568187d3dd2$var$_forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, $9db4b568187d3dd2$var$_forOwn3.default)(styles, function(value, key) {
            var transform = $9db4b568187d3dd2$var$transforms[key];
            if (transform) expanded = $9db4b568187d3dd2$var$_extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
$9db4b568187d3dd2$exports.default = $9db4b568187d3dd2$var$autoprefix;


var $bd96d54b29ffe643$var$_autoprefix2 = $bd96d54b29ffe643$var$_interopRequireDefault($9db4b568187d3dd2$exports);
var $372ce80979a4d44b$exports = {};
'use strict';
Object.defineProperty($372ce80979a4d44b$exports, "__esModule", {
    value: true
});
$372ce80979a4d44b$exports.hover = undefined;
var $372ce80979a4d44b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $6fFrj = parcelRequire("6fFrj");
var $372ce80979a4d44b$var$_react2 = $372ce80979a4d44b$var$_interopRequireDefault($6fFrj);
function $372ce80979a4d44b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $372ce80979a4d44b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $372ce80979a4d44b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $372ce80979a4d44b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $372ce80979a4d44b$var$hover = $372ce80979a4d44b$exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        $372ce80979a4d44b$var$_inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            $372ce80979a4d44b$var$_classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $372ce80979a4d44b$var$_possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return $372ce80979a4d44b$var$_react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, $372ce80979a4d44b$var$_react2.default.createElement(Component, $372ce80979a4d44b$var$_extends({}, _this.props, _this.state)));
            }, _temp), $372ce80979a4d44b$var$_possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }($372ce80979a4d44b$var$_react2.default.Component);
};
$372ce80979a4d44b$exports.default = $372ce80979a4d44b$var$hover;


var $bd96d54b29ffe643$var$_hover3 = $bd96d54b29ffe643$var$_interopRequireDefault($372ce80979a4d44b$exports);
var $462b2dad82b394e1$exports = {};
'use strict';
Object.defineProperty($462b2dad82b394e1$exports, "__esModule", {
    value: true
});
$462b2dad82b394e1$exports.active = undefined;
var $462b2dad82b394e1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $6fFrj = parcelRequire("6fFrj");
var $462b2dad82b394e1$var$_react2 = $462b2dad82b394e1$var$_interopRequireDefault($6fFrj);
function $462b2dad82b394e1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $462b2dad82b394e1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $462b2dad82b394e1$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $462b2dad82b394e1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $462b2dad82b394e1$var$active = $462b2dad82b394e1$exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        $462b2dad82b394e1$var$_inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            $462b2dad82b394e1$var$_classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $462b2dad82b394e1$var$_possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return $462b2dad82b394e1$var$_react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, $462b2dad82b394e1$var$_react2.default.createElement(Component, $462b2dad82b394e1$var$_extends({}, _this.props, _this.state)));
            }, _temp), $462b2dad82b394e1$var$_possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }($462b2dad82b394e1$var$_react2.default.Component);
};
$462b2dad82b394e1$exports.default = $462b2dad82b394e1$var$active;


var $bd96d54b29ffe643$var$_active2 = $bd96d54b29ffe643$var$_interopRequireDefault($462b2dad82b394e1$exports);
var $62df814167c6dba7$exports = {};
'use strict';
Object.defineProperty($62df814167c6dba7$exports, "__esModule", {
    value: true
});
var $62df814167c6dba7$var$loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp('first-child');
    i === length - 1 && setProp('last-child');
    (i === 0 || i % 2 === 0) && setProp('even');
    Math.abs(i % 2) === 1 && setProp('odd');
    setProp('nth-child', i);
    return props;
};
$62df814167c6dba7$exports.default = $62df814167c6dba7$var$loopable;


var $bd96d54b29ffe643$var$_loop3 = $bd96d54b29ffe643$var$_interopRequireDefault($62df814167c6dba7$exports);
function $bd96d54b29ffe643$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$bd96d54b29ffe643$exports.hover = $bd96d54b29ffe643$var$_hover3.default;
$bd96d54b29ffe643$exports.handleHover = $bd96d54b29ffe643$var$_hover3.default;
$bd96d54b29ffe643$exports.handleActive = $bd96d54b29ffe643$var$_active2.default;
$bd96d54b29ffe643$exports.loop = $bd96d54b29ffe643$var$_loop3.default;
var $bd96d54b29ffe643$var$ReactCSS = $bd96d54b29ffe643$exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, $bd96d54b29ffe643$var$_flattenNames2.default)(activations);
    var merged = (0, $bd96d54b29ffe643$var$_mergeClasses2.default)(classes, activeNames);
    return (0, $bd96d54b29ffe643$var$_autoprefix2.default)(merged);
};
$bd96d54b29ffe643$exports.default = $bd96d54b29ffe643$var$ReactCSS;



var $6fFrj = parcelRequire("6fFrj");

var $797a78c57792610b$export$a056a977bf6a9a3c = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: 'rgb'
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: 'rgb'
        };
    }
    return null;
};



var $6fFrj = parcelRequire("6fFrj");

var $175f3f6dcacdc86a$var$checkboardCache = {};
var $175f3f6dcacdc86a$export$b3890eb0ae9dca99 = function render(c1, c2, size, serverCanvas) {
    if (typeof document === 'undefined' && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var $175f3f6dcacdc86a$export$3988ae62b71be9a3 = function get(c1, c2, size, serverCanvas) {
    var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
    if ($175f3f6dcacdc86a$var$checkboardCache[key]) return $175f3f6dcacdc86a$var$checkboardCache[key];
    var checkboard = $175f3f6dcacdc86a$export$b3890eb0ae9dca99(c1, c2, size, serverCanvas);
    $175f3f6dcacdc86a$var$checkboardCache[key] = checkboard;
    return checkboard;
};


var $b588c516c7a68973$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $b588c516c7a68973$export$457ff74489f64b4a = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: '0px 0px 0px 0px',
                background: 'url(' + $175f3f6dcacdc86a$export$3988ae62b71be9a3(white, grey, size, renderers.canvas) + ') center left'
            }
        }
    });
    return (0, $6fFrj.isValidElement)(children) ? (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).cloneElement(children, $b588c516c7a68973$var$_extends({}, children.props, {
        style: $b588c516c7a68973$var$_extends({}, children.props.style, styles.grid)
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.grid
    });
};
$b588c516c7a68973$export$457ff74489f64b4a.defaultProps = {
    size: 8,
    white: 'transparent',
    grey: 'rgba(0,0,0,.08)',
    renderers: {}
};
var $b588c516c7a68973$export$2e2bcd8739ae039 = $b588c516c7a68973$export$457ff74489f64b4a;


var $a9f7c72741cda63e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a9f7c72741cda63e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $a9f7c72741cda63e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a9f7c72741cda63e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a9f7c72741cda63e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a9f7c72741cda63e$export$b3d0ceb706f8af43 = function(_ref) {
    $a9f7c72741cda63e$var$_inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        $a9f7c72741cda63e$var$_classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $a9f7c72741cda63e$var$_possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $797a78c57792610b$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleChange);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        }, _temp), $a9f7c72741cda63e$var$_possibleConstructorReturn(_this, _ret);
    }
    $a9f7c72741cda63e$var$_createClass(Alpha, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
                    'default': {
                        alpha: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: '0px 0px 0px 0px',
                            overflow: 'hidden',
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: '0px 0px 0px 0px',
                            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: 'relative',
                            height: '100%',
                            margin: '0 3px'
                        },
                        pointer: {
                            position: 'absolute',
                            left: rgb.a * 100 + '%'
                        },
                        slider: {
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            marginTop: '1px',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        gradient: {
                            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + '%'
                        }
                    },
                    'overwrite': $a9f7c72741cda63e$var$_extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === 'vertical',
                    overwrite: true
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.checkboard
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b588c516c7a68973$export$2e2bcd8739ae039), {
                    renderers: this.props.renderers
                })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.gradient
                }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}((0, $6fFrj.PureComponent) || (0, $6fFrj.Component));
var $a9f7c72741cda63e$export$2e2bcd8739ae039 = $a9f7c72741cda63e$export$b3d0ceb706f8af43;




var $6fFrj = parcelRequire("6fFrj");

var $a1e416e6199622f7$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $a1e416e6199622f7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a1e416e6199622f7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a1e416e6199622f7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a1e416e6199622f7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a1e416e6199622f7$var$DEFAULT_ARROW_OFFSET = 1;
var $a1e416e6199622f7$var$UP_KEY_CODE = 38;
var $a1e416e6199622f7$var$DOWN_KEY_CODE = 40;
var $a1e416e6199622f7$var$VALID_KEY_CODES = [
    $a1e416e6199622f7$var$UP_KEY_CODE,
    $a1e416e6199622f7$var$DOWN_KEY_CODE
];
var $a1e416e6199622f7$var$isValidKeyCode = function isValidKeyCode(keyCode) {
    return $a1e416e6199622f7$var$VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var $a1e416e6199622f7$var$getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ''));
};
var $a1e416e6199622f7$var$idCounter = 1;
var $a1e416e6199622f7$export$bfb3cbb78d3c298 = function(_ref) {
    $a1e416e6199622f7$var$_inherits(EditableInput, _ref);
    function EditableInput(props) {
        $a1e416e6199622f7$var$_classCallCheck(this, EditableInput);
        var _this = $a1e416e6199622f7$var$_possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = $a1e416e6199622f7$var$getNumberValue(e.target.value);
            if (!isNaN(value) && $a1e416e6199622f7$var$isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === $a1e416e6199622f7$var$UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener('mousemove', _this.handleDrag);
                window.addEventListener('mouseup', _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleDrag);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = 'rc-editable-input-' + $a1e416e6199622f7$var$idCounter++;
        return _this;
    }
    $a1e416e6199622f7$var$_createClass(EditableInput, [
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'getValueObjectWithLabel',
            value: function getValueObjectWithLabel(value) {
                return $a1e416e6199622f7$var$_defineProperty({}, this.props.label, value);
            }
        },
        {
            key: 'getArrowOffset',
            value: function getArrowOffset() {
                return this.props.arrowOffset || $a1e416e6199622f7$var$DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: 'setUpdatedValue',
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
                    'default': {
                        wrap: {
                            position: 'relative'
                        }
                    },
                    'user-override': {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    'dragLabel-true': {
                        label: {
                            cursor: 'ew-resize'
                        }
                    }
                }, {
                    'user-override': true
                }, this.props);
                return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.wrap
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('input', {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: 'false'
                }), this.props.label && !this.props.hideLabel ? (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('label', {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}((0, $6fFrj.PureComponent) || (0, $6fFrj.Component));
var $a1e416e6199622f7$export$2e2bcd8739ae039 = $a1e416e6199622f7$export$bfb3cbb78d3c298;



var $6fFrj = parcelRequire("6fFrj");

var $bd01c7cbf9a71165$export$a056a977bf6a9a3c = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    }
    return null;
};


var $eb389715f5ad7937$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $eb389715f5ad7937$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $eb389715f5ad7937$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $eb389715f5ad7937$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $eb389715f5ad7937$export$3e22a96a58989a47 = function(_ref) {
    $eb389715f5ad7937$var$_inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        $eb389715f5ad7937$var$_classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $eb389715f5ad7937$var$_possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $bd01c7cbf9a71165$export$a056a977bf6a9a3c(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), $eb389715f5ad7937$var$_possibleConstructorReturn(_this, _ret);
    }
    $eb389715f5ad7937$var$_createClass(Hue, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                window.removeEventListener('mousemove', this.handleChange);
                window.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? 'horizontal' : _props$direction;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
                    'default': {
                        hue: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: '0 2px',
                            position: 'relative',
                            height: '100%',
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            left: this.props.hsl.h * 100 / 360 + '%'
                        },
                        slider: {
                            marginTop: '1px',
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        pointer: {
                            left: '0px',
                            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
                        }
                    }
                }, {
                    vertical: direction === 'vertical'
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    className: 'hue-' + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('style', null, '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}((0, $6fFrj.PureComponent) || (0, $6fFrj.Component));
var $eb389715f5ad7937$export$2e2bcd8739ae039 = $eb389715f5ad7937$export$3e22a96a58989a47;



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");


var $1quOP = parcelRequire("1quOP");

var $cuezR = parcelRequire("cuezR");

var $gWKGw = parcelRequire("gWKGw");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $09448fea1fecdcd2$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $gWKGw.default)(object[key], value) || value === undefined && !(key in object)) (0, $cuezR.default)(object, key, value);
}
var $09448fea1fecdcd2$export$2e2bcd8739ae039 = $09448fea1fecdcd2$var$assignMergeValue;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b860a098723f2719$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $b860a098723f2719$export$2e2bcd8739ae039 = $b860a098723f2719$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $2fc8ac35b6171cbd$var$baseFor = (0, $b860a098723f2719$export$2e2bcd8739ae039)();
var $2fc8ac35b6171cbd$export$2e2bcd8739ae039 = $2fc8ac35b6171cbd$var$baseFor;




var $7Ohy1 = parcelRequire("7Ohy1");

var $com4m = parcelRequire("com4m");

var $7542D = parcelRequire("7542D");

var $4STpn = parcelRequire("4STpn");

var $3YFGP = parcelRequire("3YFGP");

var $kT11y = parcelRequire("kT11y");

var $97lta = parcelRequire("97lta");

var $1g8Rw = parcelRequire("1g8Rw");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $8a4f3967cca4508a$var$isArrayLikeObject(value) {
    return (0, $1g8Rw.default)(value) && (0, $97lta.default)(value);
}
var $8a4f3967cca4508a$export$2e2bcd8739ae039 = $8a4f3967cca4508a$var$isArrayLikeObject;



var $bGao0 = parcelRequire("bGao0");

var $2u3CM = parcelRequire("2u3CM");

var $cRjGZ = parcelRequire("cRjGZ");

var $h8EF0 = parcelRequire("h8EF0");

var $lFgL3 = parcelRequire("lFgL3");
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $7d69d9ded2168df9$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
var $7d69d9ded2168df9$export$2e2bcd8739ae039 = $7d69d9ded2168df9$var$safeGet;



var $lb2CG = parcelRequire("lb2CG");

var $e1dAa = parcelRequire("e1dAa");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $9ef5723035e864a5$var$toPlainObject(value) {
    return (0, $lb2CG.default)(value, (0, $e1dAa.default)(value));
}
var $9ef5723035e864a5$export$2e2bcd8739ae039 = $9ef5723035e864a5$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $6b42e56892d7b4f9$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $7d69d9ded2168df9$export$2e2bcd8739ae039)(object, key), srcValue = (0, $7d69d9ded2168df9$export$2e2bcd8739ae039)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $09448fea1fecdcd2$export$2e2bcd8739ae039)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $kT11y.default)(srcValue), isBuff = !isArr && (0, $bGao0.default)(srcValue), isTyped = !isArr && !isBuff && (0, $lFgL3.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $kT11y.default)(objValue)) newValue = objValue;
            else if ((0, $8a4f3967cca4508a$export$2e2bcd8739ae039)(objValue)) newValue = (0, $7542D.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $7Ohy1.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $com4m.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, $h8EF0.default)(srcValue) || (0, $3YFGP.default)(srcValue)) {
            newValue = objValue;
            if ((0, $3YFGP.default)(objValue)) newValue = (0, $9ef5723035e864a5$export$2e2bcd8739ae039)(objValue);
            else if (!(0, $cRjGZ.default)(objValue) || (0, $2u3CM.default)(objValue)) newValue = (0, $4STpn.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, $09448fea1fecdcd2$export$2e2bcd8739ae039)(object, key, newValue);
}
var $6b42e56892d7b4f9$export$2e2bcd8739ae039 = $6b42e56892d7b4f9$var$baseMergeDeep;



var $cRjGZ = parcelRequire("cRjGZ");

var $e1dAa = parcelRequire("e1dAa");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $15c6666ecacff322$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $2fc8ac35b6171cbd$export$2e2bcd8739ae039)(source, function(srcValue, key) {
        stack || (stack = new (0, $1quOP.default));
        if ((0, $cRjGZ.default)(srcValue)) (0, $6b42e56892d7b4f9$export$2e2bcd8739ae039)(object, source, key, srcIndex, $15c6666ecacff322$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $7d69d9ded2168df9$export$2e2bcd8739ae039)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $09448fea1fecdcd2$export$2e2bcd8739ae039)(object, key, newValue);
        }
    }, (0, $e1dAa.default));
}
var $15c6666ecacff322$export$2e2bcd8739ae039 = $15c6666ecacff322$var$baseMerge;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $3ff2fe33fd507b47$var$identity(value) {
    return value;
}
var $3ff2fe33fd507b47$export$2e2bcd8739ae039 = $3ff2fe33fd507b47$var$identity;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $01235334217cf073$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $01235334217cf073$export$2e2bcd8739ae039 = $01235334217cf073$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $6c2f35209d2c663c$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $6c2f35209d2c663c$var$overRest(func, start, transform) {
    start = $6c2f35209d2c663c$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $6c2f35209d2c663c$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $01235334217cf073$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $6c2f35209d2c663c$export$2e2bcd8739ae039 = $6c2f35209d2c663c$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $20f4df149480befc$var$constant(value) {
    return function() {
        return value;
    };
}
var $20f4df149480befc$export$2e2bcd8739ae039 = $20f4df149480befc$var$constant;



var $67l52 = parcelRequire("67l52");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $72cfc1eb2e3c4524$var$baseSetToString = !(0, $67l52.default) ? (0, $3ff2fe33fd507b47$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $67l52.default)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $20f4df149480befc$export$2e2bcd8739ae039)(string),
        'writable': true
    });
};
var $72cfc1eb2e3c4524$export$2e2bcd8739ae039 = $72cfc1eb2e3c4524$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $caec275a2a37ea46$var$HOT_COUNT = 800, $caec275a2a37ea46$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $caec275a2a37ea46$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $caec275a2a37ea46$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $caec275a2a37ea46$var$nativeNow(), remaining = $caec275a2a37ea46$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $caec275a2a37ea46$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $caec275a2a37ea46$export$2e2bcd8739ae039 = $caec275a2a37ea46$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $b0609eec2e4e4523$var$setToString = (0, $caec275a2a37ea46$export$2e2bcd8739ae039)((0, $72cfc1eb2e3c4524$export$2e2bcd8739ae039));
var $b0609eec2e4e4523$export$2e2bcd8739ae039 = $b0609eec2e4e4523$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $d3a1ecd30e34d299$var$baseRest(func, start) {
    return (0, $b0609eec2e4e4523$export$2e2bcd8739ae039)((0, $6c2f35209d2c663c$export$2e2bcd8739ae039)(func, start, (0, $3ff2fe33fd507b47$export$2e2bcd8739ae039)), func + '');
}
var $d3a1ecd30e34d299$export$2e2bcd8739ae039 = $d3a1ecd30e34d299$var$baseRest;



var $gWKGw = parcelRequire("gWKGw");

var $97lta = parcelRequire("97lta");

var $3JT4K = parcelRequire("3JT4K");

var $cRjGZ = parcelRequire("cRjGZ");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $b6104ac0178f9577$var$isIterateeCall(value, index, object) {
    if (!(0, $cRjGZ.default)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $97lta.default)(object) && (0, $3JT4K.default)(index, object.length) : type == 'string' && index in object) return (0, $gWKGw.default)(object[index], value);
    return false;
}
var $b6104ac0178f9577$export$2e2bcd8739ae039 = $b6104ac0178f9577$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $16b1ec110681e977$var$createAssigner(assigner) {
    return (0, $d3a1ecd30e34d299$export$2e2bcd8739ae039)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, $b6104ac0178f9577$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $16b1ec110681e977$export$2e2bcd8739ae039 = $16b1ec110681e977$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $5b09bd7873e0414d$var$merge = (0, $16b1ec110681e977$export$2e2bcd8739ae039)(function(object, source, srcIndex) {
    (0, $15c6666ecacff322$export$2e2bcd8739ae039)(object, source, srcIndex);
});
var $5b09bd7873e0414d$export$2e2bcd8739ae039 = $5b09bd7873e0414d$var$merge;


var $c8044453b0372755$export$5eec0980ed568dae = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))((0, $5b09bd7873e0414d$export$2e2bcd8739ae039)({
        'default': {
            wrap: {
                position: 'relative',
                display: 'inline-block'
            },
            content: {
                position: 'relative'
            },
            bg: {
                absolute: '0px 0px 0px 0px',
                boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
                borderRadius: radius,
                background: background
            }
        },
        'zDepth-0': {
            bg: {
                boxShadow: 'none'
            }
        },
        'zDepth-1': {
            bg: {
                boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
            }
        },
        'zDepth-2': {
            bg: {
                boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
            }
        },
        'zDepth-3': {
            bg: {
                boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
            }
        },
        'zDepth-4': {
            bg: {
                boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
            }
        },
        'zDepth-5': {
            bg: {
                boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
            }
        },
        'square': {
            bg: {
                borderRadius: '0'
            }
        },
        'circle': {
            bg: {
                borderRadius: '50%'
            }
        }
    }, passedStyles), {
        'zDepth-1': zDepth === 1
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.wrap
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.bg
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.content
    }, children));
};
$c8044453b0372755$export$5eec0980ed568dae.propTypes = {
    background: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    zDepth: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
};
$c8044453b0372755$export$5eec0980ed568dae.defaultProps = {
    background: '#fff',
    zDepth: 1,
    radius: 2,
    styles: {}
};
var $c8044453b0372755$export$2e2bcd8739ae039 = $c8044453b0372755$export$5eec0980ed568dae;



var $6fFrj = parcelRequire("6fFrj");


var $cRjGZ = parcelRequire("cRjGZ");

var $8CDLW = parcelRequire("8CDLW");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $638b6c99dd0427b4$var$now = function() {
    return (0, $8CDLW.default).Date.now();
};
var $638b6c99dd0427b4$export$2e2bcd8739ae039 = $638b6c99dd0427b4$var$now;


/** Used to match a single whitespace character. */ var $ed1cecc2eb5145a4$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ed1cecc2eb5145a4$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ed1cecc2eb5145a4$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $ed1cecc2eb5145a4$export$2e2bcd8739ae039 = $ed1cecc2eb5145a4$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $ee13dec1e965e9df$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $ee13dec1e965e9df$var$baseTrim(string) {
    return string ? string.slice(0, (0, $ed1cecc2eb5145a4$export$2e2bcd8739ae039)(string) + 1).replace($ee13dec1e965e9df$var$reTrimStart, '') : string;
}
var $ee13dec1e965e9df$export$2e2bcd8739ae039 = $ee13dec1e965e9df$var$baseTrim;



var $cRjGZ = parcelRequire("cRjGZ");

var $cHJLm = parcelRequire("cHJLm");
/** Used as references for various `Number` constants. */ var $0c4f437be7d02c8a$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $0c4f437be7d02c8a$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $0c4f437be7d02c8a$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $0c4f437be7d02c8a$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $0c4f437be7d02c8a$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $0c4f437be7d02c8a$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ((0, $cHJLm.default)(value)) return $0c4f437be7d02c8a$var$NAN;
    if ((0, $cRjGZ.default)(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = (0, $cRjGZ.default)(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = (0, $ee13dec1e965e9df$export$2e2bcd8739ae039)(value);
    var isBinary = $0c4f437be7d02c8a$var$reIsBinary.test(value);
    return isBinary || $0c4f437be7d02c8a$var$reIsOctal.test(value) ? $0c4f437be7d02c8a$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $0c4f437be7d02c8a$var$reIsBadHex.test(value) ? $0c4f437be7d02c8a$var$NAN : +value;
}
var $0c4f437be7d02c8a$export$2e2bcd8739ae039 = $0c4f437be7d02c8a$var$toNumber;


/** Error message constants. */ var $6aa14205e09f7f38$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6aa14205e09f7f38$var$nativeMax = Math.max, $6aa14205e09f7f38$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $6aa14205e09f7f38$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($6aa14205e09f7f38$var$FUNC_ERROR_TEXT);
    wait = (0, $0c4f437be7d02c8a$export$2e2bcd8739ae039)(wait) || 0;
    if ((0, $cRjGZ.default)(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $6aa14205e09f7f38$var$nativeMax((0, $0c4f437be7d02c8a$export$2e2bcd8739ae039)(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $6aa14205e09f7f38$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $638b6c99dd0427b4$export$2e2bcd8739ae039)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $638b6c99dd0427b4$export$2e2bcd8739ae039)());
    }
    function debounced() {
        var time = (0, $638b6c99dd0427b4$export$2e2bcd8739ae039)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $6aa14205e09f7f38$export$2e2bcd8739ae039 = $6aa14205e09f7f38$var$debounce;



var $cRjGZ = parcelRequire("cRjGZ");
/** Error message constants. */ var $f5c95f3b7dcb1401$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $f5c95f3b7dcb1401$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($f5c95f3b7dcb1401$var$FUNC_ERROR_TEXT);
    if ((0, $cRjGZ.default)(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return (0, $6aa14205e09f7f38$export$2e2bcd8739ae039)(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
var $f5c95f3b7dcb1401$export$2e2bcd8739ae039 = $f5c95f3b7dcb1401$var$throttle;


var $121dba1ac1f3c6bc$export$a056a977bf6a9a3c = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: 'hsv'
    };
};


var $49832aed7d90d628$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $49832aed7d90d628$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $49832aed7d90d628$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $49832aed7d90d628$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $49832aed7d90d628$export$c4dbe12ffaee3c8e = function(_ref) {
    $49832aed7d90d628$var$_inherits(Saturation, _ref);
    function Saturation(props) {
        $49832aed7d90d628$var$_classCallCheck(this, Saturation);
        var _this = $49832aed7d90d628$var$_possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, $121dba1ac1f3c6bc$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener('mousemove', _this.handleChange);
            renderWindow.addEventListener('mouseup', _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, $f5c95f3b7dcb1401$export$2e2bcd8739ae039)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    $49832aed7d90d628$var$_createClass(Saturation, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: 'getContainerRenderWindow',
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener('mousemove', this.handleChange);
                renderWindow.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
                    'default': {
                        color: {
                            absolute: '0px 0px 0px 0px',
                            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: '0px 0px 0px 0px',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            top: -(this.props.hsv.v * 100) + 100 + '%',
                            left: this.props.hsv.s * 100 + '%',
                            cursor: 'default'
                        },
                        circle: {
                            width: '4px',
                            height: '4px',
                            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
                            borderRadius: '50%',
                            cursor: 'hand',
                            transform: 'translate(-2px, -2px)'
                        }
                    },
                    'custom': {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    'custom': !!this.props.style
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('style', null, '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.white,
                    className: 'saturation-white'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.black,
                    className: 'saturation-black'
                }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}((0, $6fFrj.PureComponent) || (0, $6fFrj.Component));
var $49832aed7d90d628$export$2e2bcd8739ae039 = $49832aed7d90d628$export$c4dbe12ffaee3c8e;



var $6fFrj = parcelRequire("6fFrj");


var $75VIz = parcelRequire("75VIz");


var $aZPAT = parcelRequire("aZPAT");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $8e73f2c5ccd1c151$var$baseForOwn(object, iteratee) {
    return object && (0, $2fc8ac35b6171cbd$export$2e2bcd8739ae039)(object, iteratee, (0, $aZPAT.default));
}
var $8e73f2c5ccd1c151$export$2e2bcd8739ae039 = $8e73f2c5ccd1c151$var$baseForOwn;



var $97lta = parcelRequire("97lta");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $4119206841514393$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $97lta.default)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $4119206841514393$export$2e2bcd8739ae039 = $4119206841514393$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $e9e67ac9104b68f7$var$baseEach = (0, $4119206841514393$export$2e2bcd8739ae039)((0, $8e73f2c5ccd1c151$export$2e2bcd8739ae039));
var $e9e67ac9104b68f7$export$2e2bcd8739ae039 = $e9e67ac9104b68f7$var$baseEach;



/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $86c6862200d43b88$var$castFunction(value) {
    return typeof value == 'function' ? value : (0, $3ff2fe33fd507b47$export$2e2bcd8739ae039);
}
var $86c6862200d43b88$export$2e2bcd8739ae039 = $86c6862200d43b88$var$castFunction;



var $kT11y = parcelRequire("kT11y");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $1d002a719392163d$var$forEach(collection, iteratee) {
    var func = (0, $kT11y.default)(collection) ? (0, $75VIz.default) : (0, $e9e67ac9104b68f7$export$2e2bcd8739ae039);
    return func(collection, (0, $86c6862200d43b88$export$2e2bcd8739ae039)(iteratee));
}
var $1d002a719392163d$export$2e2bcd8739ae039 = $1d002a719392163d$var$forEach;



var $3e6623331a03b061$export$4837207a530c7f21 = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        'r',
        'g',
        'b',
        'a',
        'h',
        's',
        'l',
        'v'
    ];
    var checked = 0;
    var passed = 0;
    (0, $1d002a719392163d$export$2e2bcd8739ae039)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === 's' || letter === 'l') {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var $3e6623331a03b061$export$6bed283375899438 = function toState(data, oldHue) {
    var color = data.hex ? (0, (/*@__PURE__*/$parcel$interopDefault($e5d97db34ea1eaf8$exports)))(data.hex) : (0, (/*@__PURE__*/$parcel$interopDefault($e5d97db34ea1eaf8$exports)))(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === '000000' && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? 'transparent' : '#' + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var $3e6623331a03b061$export$944f75ec5697b362 = function isValidHex(hex) {
    if (hex === 'transparent') return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === '#' ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, (/*@__PURE__*/$parcel$interopDefault($e5d97db34ea1eaf8$exports)))(hex).isValid();
};
var $3e6623331a03b061$export$3609eb1d7e55dec = function getContrastingColor(data) {
    if (!data) return '#fff';
    var col = $3e6623331a03b061$export$6bed283375899438(data);
    if (col.hex === 'transparent') return 'rgba(0,0,0,0.4)';
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
};
var $3e6623331a03b061$export$a90204d1394caf30 = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: '#ff0000',
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var $3e6623331a03b061$export$e76ec4c5b3cadd73 = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", '');
    return (0, (/*@__PURE__*/$parcel$interopDefault($e5d97db34ea1eaf8$exports)))(type + ' (' + stringWithoutDegree + ')')._ok;
};


var $682238ac99fddc24$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $682238ac99fddc24$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $682238ac99fddc24$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $682238ac99fddc24$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $682238ac99fddc24$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $682238ac99fddc24$export$68265aef2e61bec7 = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        $682238ac99fddc24$var$_inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            $682238ac99fddc24$var$_classCallCheck(this, ColorPicker);
            var _this = $682238ac99fddc24$var$_possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = $3e6623331a03b061$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $3e6623331a03b061$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = $3e6623331a03b061$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $3e6623331a03b061$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = $682238ac99fddc24$var$_extends({}, $3e6623331a03b061$export$6bed283375899438(props.color, 0));
            _this.debounce = (0, $6aa14205e09f7f38$export$2e2bcd8739ae039)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        $682238ac99fddc24$var$_createClass(ColorPicker, [
            {
                key: 'render',
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Picker, $682238ac99fddc24$var$_extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: 'getDerivedStateFromProps',
                value: function getDerivedStateFromProps(nextProps, state) {
                    return $682238ac99fddc24$var$_extends({}, $3e6623331a03b061$export$6bed283375899438(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }((0, $6fFrj.PureComponent) || (0, $6fFrj.Component));
    ColorPicker.propTypes = $682238ac99fddc24$var$_extends({}, Picker.propTypes);
    ColorPicker.defaultProps = $682238ac99fddc24$var$_extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
var $682238ac99fddc24$export$2e2bcd8739ae039 = $682238ac99fddc24$export$68265aef2e61bec7;



var $6fFrj = parcelRequire("6fFrj");


var $4kRfe = parcelRequire("4kRfe");

var $b47f117f16e434a4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $b47f117f16e434a4$var$ENTER = 13;
var $b47f117f16e434a4$export$c463048d6131b309 = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === 'transparent';
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        default: {
            swatch: $b47f117f16e434a4$var$_extends({
                background: color,
                height: '100%',
                width: '100%',
                cursor: 'pointer',
                position: 'relative',
                outline: 'none'
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === $b47f117f16e434a4$var$ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', $b47f117f16e434a4$var$_extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b588c516c7a68973$export$2e2bcd8739ae039), {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    }));
};
var $b47f117f16e434a4$export$2e2bcd8739ae039 = (0, $4kRfe.handleFocus)($b47f117f16e434a4$export$c463048d6131b309);





var $6fFrj = parcelRequire("6fFrj");

var $2f490cc0972a09c6$export$5bbd8091d1d0e224 = function AlphaPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            picker: {
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                transform: 'translate(-9px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        },
        'vertical': {
            picker: {
                transform: 'translate(-3px, -9px)'
            }
        }
    }, {
        vertical: direction === 'vertical'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.picker
    });
};
var $2f490cc0972a09c6$export$2e2bcd8739ae039 = $2f490cc0972a09c6$export$5bbd8091d1d0e224;


var $c4a3655058f4e50e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $c4a3655058f4e50e$export$421d2c1bdabf8a68 = function AlphaPicker(_ref) {
    var rgb = _ref.rgb, hsl = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            picker: {
                position: 'relative',
                width: width,
                height: height
            },
            alpha: {
                radius: '2px',
                style: style
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.picker,
        className: 'alpha-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a9f7c72741cda63e$export$2e2bcd8739ae039), $c4a3655058f4e50e$var$_extends({}, styles.alpha, {
        rgb: rgb,
        hsl: hsl,
        pointer: pointer,
        renderers: renderers,
        onChange: onChange,
        direction: direction
    })));
};
$c4a3655058f4e50e$export$421d2c1bdabf8a68.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: (0, $2f490cc0972a09c6$export$2e2bcd8739ae039)
};
var $c4a3655058f4e50e$export$2e2bcd8739ae039 = (0, $682238ac99fddc24$export$2e2bcd8739ae039)($c4a3655058f4e50e$export$421d2c1bdabf8a68);



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");





var $6fFrj = parcelRequire("6fFrj");


var $8w4ic = parcelRequire("8w4ic");

var $1quOP = parcelRequire("1quOP");

var $1quOP = parcelRequire("1quOP");

var $6CBG7 = parcelRequire("6CBG7");
/** Used to stand-in for `undefined` hash values. */ var $573abf522bcde1ab$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $573abf522bcde1ab$var$setCacheAdd(value) {
    this.__data__.set(value, $573abf522bcde1ab$var$HASH_UNDEFINED);
    return this;
}
var $573abf522bcde1ab$export$2e2bcd8739ae039 = $573abf522bcde1ab$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $3ba9bed958d8aee6$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $3ba9bed958d8aee6$export$2e2bcd8739ae039 = $3ba9bed958d8aee6$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $1722539ed0758526$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $6CBG7.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$1722539ed0758526$var$SetCache.prototype.add = $1722539ed0758526$var$SetCache.prototype.push = (0, $573abf522bcde1ab$export$2e2bcd8739ae039);
$1722539ed0758526$var$SetCache.prototype.has = (0, $3ba9bed958d8aee6$export$2e2bcd8739ae039);
var $1722539ed0758526$export$2e2bcd8739ae039 = $1722539ed0758526$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $8ad73b9095a156dc$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $8ad73b9095a156dc$export$2e2bcd8739ae039 = $8ad73b9095a156dc$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fef309f4fd535531$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $fef309f4fd535531$export$2e2bcd8739ae039 = $fef309f4fd535531$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $cef448c3b68c9def$var$COMPARE_PARTIAL_FLAG = 1, $cef448c3b68c9def$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $cef448c3b68c9def$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $cef448c3b68c9def$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $cef448c3b68c9def$var$COMPARE_UNORDERED_FLAG ? new (0, $1722539ed0758526$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $8ad73b9095a156dc$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $fef309f4fd535531$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $cef448c3b68c9def$export$2e2bcd8739ae039 = $cef448c3b68c9def$var$equalArrays;



var $2u0qg = parcelRequire("2u0qg");

var $1LCnu = parcelRequire("1LCnu");

var $gWKGw = parcelRequire("gWKGw");

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $097adcbb7063f8d6$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $097adcbb7063f8d6$export$2e2bcd8739ae039 = $097adcbb7063f8d6$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $732173f4055e469b$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $732173f4055e469b$export$2e2bcd8739ae039 = $732173f4055e469b$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $1263de3a593b1dc1$var$COMPARE_PARTIAL_FLAG = 1, $1263de3a593b1dc1$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $1263de3a593b1dc1$var$boolTag = '[object Boolean]', $1263de3a593b1dc1$var$dateTag = '[object Date]', $1263de3a593b1dc1$var$errorTag = '[object Error]', $1263de3a593b1dc1$var$mapTag = '[object Map]', $1263de3a593b1dc1$var$numberTag = '[object Number]', $1263de3a593b1dc1$var$regexpTag = '[object RegExp]', $1263de3a593b1dc1$var$setTag = '[object Set]', $1263de3a593b1dc1$var$stringTag = '[object String]', $1263de3a593b1dc1$var$symbolTag = '[object Symbol]';
var $1263de3a593b1dc1$var$arrayBufferTag = '[object ArrayBuffer]', $1263de3a593b1dc1$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $1263de3a593b1dc1$var$symbolProto = (0, $2u0qg.default) ? (0, $2u0qg.default).prototype : undefined, $1263de3a593b1dc1$var$symbolValueOf = $1263de3a593b1dc1$var$symbolProto ? $1263de3a593b1dc1$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $1263de3a593b1dc1$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $1263de3a593b1dc1$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $1263de3a593b1dc1$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $1LCnu.default)(object), new (0, $1LCnu.default)(other))) return false;
            return true;
        case $1263de3a593b1dc1$var$boolTag:
        case $1263de3a593b1dc1$var$dateTag:
        case $1263de3a593b1dc1$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $gWKGw.default)(+object, +other);
        case $1263de3a593b1dc1$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $1263de3a593b1dc1$var$regexpTag:
        case $1263de3a593b1dc1$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $1263de3a593b1dc1$var$mapTag:
            var convert = (0, $097adcbb7063f8d6$export$2e2bcd8739ae039);
        case $1263de3a593b1dc1$var$setTag:
            var isPartial = bitmask & $1263de3a593b1dc1$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $732173f4055e469b$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $1263de3a593b1dc1$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $cef448c3b68c9def$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $1263de3a593b1dc1$var$symbolTag:
            if ($1263de3a593b1dc1$var$symbolValueOf) return $1263de3a593b1dc1$var$symbolValueOf.call(object) == $1263de3a593b1dc1$var$symbolValueOf.call(other);
    }
    return false;
}
var $1263de3a593b1dc1$export$2e2bcd8739ae039 = $1263de3a593b1dc1$var$equalByTag;



var $1T43p = parcelRequire("1T43p");
/** Used to compose bitmasks for value comparisons. */ var $9369e9a5690e0a03$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $9369e9a5690e0a03$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9369e9a5690e0a03$var$hasOwnProperty = $9369e9a5690e0a03$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $9369e9a5690e0a03$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $9369e9a5690e0a03$var$COMPARE_PARTIAL_FLAG, objProps = (0, $1T43p.default)(object), objLength = objProps.length, othProps = (0, $1T43p.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $9369e9a5690e0a03$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $9369e9a5690e0a03$export$2e2bcd8739ae039 = $9369e9a5690e0a03$var$equalObjects;



var $bly3Q = parcelRequire("bly3Q");

var $kT11y = parcelRequire("kT11y");

var $bGao0 = parcelRequire("bGao0");

var $lFgL3 = parcelRequire("lFgL3");
/** Used to compose bitmasks for value comparisons. */ var $46ccb6c11c342cdb$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $46ccb6c11c342cdb$var$argsTag = '[object Arguments]', $46ccb6c11c342cdb$var$arrayTag = '[object Array]', $46ccb6c11c342cdb$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $46ccb6c11c342cdb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $46ccb6c11c342cdb$var$hasOwnProperty = $46ccb6c11c342cdb$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $46ccb6c11c342cdb$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $kT11y.default)(object), othIsArr = (0, $kT11y.default)(other), objTag = objIsArr ? $46ccb6c11c342cdb$var$arrayTag : (0, $bly3Q.default)(object), othTag = othIsArr ? $46ccb6c11c342cdb$var$arrayTag : (0, $bly3Q.default)(other);
    objTag = objTag == $46ccb6c11c342cdb$var$argsTag ? $46ccb6c11c342cdb$var$objectTag : objTag;
    othTag = othTag == $46ccb6c11c342cdb$var$argsTag ? $46ccb6c11c342cdb$var$objectTag : othTag;
    var objIsObj = objTag == $46ccb6c11c342cdb$var$objectTag, othIsObj = othTag == $46ccb6c11c342cdb$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $bGao0.default)(object)) {
        if (!(0, $bGao0.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $1quOP.default));
        return objIsArr || (0, $lFgL3.default)(object) ? (0, $cef448c3b68c9def$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $1263de3a593b1dc1$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $46ccb6c11c342cdb$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $46ccb6c11c342cdb$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $46ccb6c11c342cdb$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $1quOP.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $1quOP.default));
    return (0, $9369e9a5690e0a03$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $46ccb6c11c342cdb$export$2e2bcd8739ae039 = $46ccb6c11c342cdb$var$baseIsEqualDeep;



var $1g8Rw = parcelRequire("1g8Rw");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $455ffdba5a6adec0$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $1g8Rw.default)(value) && !(0, $1g8Rw.default)(other)) return value !== value && other !== other;
    return (0, $46ccb6c11c342cdb$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $455ffdba5a6adec0$var$baseIsEqual, stack);
}
var $455ffdba5a6adec0$export$2e2bcd8739ae039 = $455ffdba5a6adec0$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $7f9e4f1dd1cbb9ee$var$COMPARE_PARTIAL_FLAG = 1, $7f9e4f1dd1cbb9ee$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $7f9e4f1dd1cbb9ee$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $1quOP.default);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $455ffdba5a6adec0$export$2e2bcd8739ae039)(srcValue, objValue, $7f9e4f1dd1cbb9ee$var$COMPARE_PARTIAL_FLAG | $7f9e4f1dd1cbb9ee$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $7f9e4f1dd1cbb9ee$export$2e2bcd8739ae039 = $7f9e4f1dd1cbb9ee$var$baseIsMatch;



var $cRjGZ = parcelRequire("cRjGZ");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $6ee3435ba0f0c607$var$isStrictComparable(value) {
    return value === value && !(0, $cRjGZ.default)(value);
}
var $6ee3435ba0f0c607$export$2e2bcd8739ae039 = $6ee3435ba0f0c607$var$isStrictComparable;



var $aZPAT = parcelRequire("aZPAT");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $588178948df34d3a$var$getMatchData(object) {
    var result = (0, $aZPAT.default)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $6ee3435ba0f0c607$export$2e2bcd8739ae039)(value)
        ];
    }
    return result;
}
var $588178948df34d3a$export$2e2bcd8739ae039 = $588178948df34d3a$var$getMatchData;


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $37171d16cc46a323$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $37171d16cc46a323$export$2e2bcd8739ae039 = $37171d16cc46a323$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $04aacc597b6e1ba7$var$baseMatches(source) {
    var matchData = (0, $588178948df34d3a$export$2e2bcd8739ae039)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $37171d16cc46a323$export$2e2bcd8739ae039)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $7f9e4f1dd1cbb9ee$export$2e2bcd8739ae039)(object, source, matchData);
    };
}
var $04aacc597b6e1ba7$export$2e2bcd8739ae039 = $04aacc597b6e1ba7$var$baseMatches;




var $kT11y = parcelRequire("kT11y");

var $kT11y = parcelRequire("kT11y");

var $cHJLm = parcelRequire("cHJLm");
/** Used to match property names within property paths. */ var $84825456865648a9$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $84825456865648a9$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $84825456865648a9$var$isKey(value, object) {
    if ((0, $kT11y.default)(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, $cHJLm.default)(value)) return true;
    return $84825456865648a9$var$reIsPlainProp.test(value) || !$84825456865648a9$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $84825456865648a9$export$2e2bcd8739ae039 = $84825456865648a9$var$isKey;



var $ksRJm = parcelRequire("ksRJm");

var $8T2Sb = parcelRequire("8T2Sb");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $9444da7ef5fe2568$var$castPath(value, object) {
    if ((0, $kT11y.default)(value)) return value;
    return (0, $84825456865648a9$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $ksRJm.default)((0, $8T2Sb.default)(value));
}
var $9444da7ef5fe2568$export$2e2bcd8739ae039 = $9444da7ef5fe2568$var$castPath;



var $cdqUH = parcelRequire("cdqUH");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $81c7e1f7fa125026$var$baseGet(object, path) {
    path = (0, $9444da7ef5fe2568$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $cdqUH.default)(path[index++])];
    return index && index == length ? object : undefined;
}
var $81c7e1f7fa125026$export$2e2bcd8739ae039 = $81c7e1f7fa125026$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $77c5bdf0548fab77$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $81c7e1f7fa125026$export$2e2bcd8739ae039)(object, path);
    return result === undefined ? defaultValue : result;
}
var $77c5bdf0548fab77$export$2e2bcd8739ae039 = $77c5bdf0548fab77$var$get;


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $ce861c8d34d6ec09$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $ce861c8d34d6ec09$export$2e2bcd8739ae039 = $ce861c8d34d6ec09$var$baseHasIn;




var $3YFGP = parcelRequire("3YFGP");

var $kT11y = parcelRequire("kT11y");

var $3JT4K = parcelRequire("3JT4K");

var $j4U5V = parcelRequire("j4U5V");

var $cdqUH = parcelRequire("cdqUH");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $b08b86bbaf110f9f$var$hasPath(object, path, hasFunc) {
    path = (0, $9444da7ef5fe2568$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $cdqUH.default)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $j4U5V.default)(length) && (0, $3JT4K.default)(key, length) && ((0, $kT11y.default)(object) || (0, $3YFGP.default)(object));
}
var $b08b86bbaf110f9f$export$2e2bcd8739ae039 = $b08b86bbaf110f9f$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $18665c84320ffe9e$var$hasIn(object, path) {
    return object != null && (0, $b08b86bbaf110f9f$export$2e2bcd8739ae039)(object, path, (0, $ce861c8d34d6ec09$export$2e2bcd8739ae039));
}
var $18665c84320ffe9e$export$2e2bcd8739ae039 = $18665c84320ffe9e$var$hasIn;






var $cdqUH = parcelRequire("cdqUH");
/** Used to compose bitmasks for value comparisons. */ var $afd9887c1710fd31$var$COMPARE_PARTIAL_FLAG = 1, $afd9887c1710fd31$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $afd9887c1710fd31$var$baseMatchesProperty(path, srcValue) {
    if ((0, $84825456865648a9$export$2e2bcd8739ae039)(path) && (0, $6ee3435ba0f0c607$export$2e2bcd8739ae039)(srcValue)) return (0, $37171d16cc46a323$export$2e2bcd8739ae039)((0, $cdqUH.default)(path), srcValue);
    return function(object) {
        var objValue = (0, $77c5bdf0548fab77$export$2e2bcd8739ae039)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $18665c84320ffe9e$export$2e2bcd8739ae039)(object, path) : (0, $455ffdba5a6adec0$export$2e2bcd8739ae039)(srcValue, objValue, $afd9887c1710fd31$var$COMPARE_PARTIAL_FLAG | $afd9887c1710fd31$var$COMPARE_UNORDERED_FLAG);
    };
}
var $afd9887c1710fd31$export$2e2bcd8739ae039 = $afd9887c1710fd31$var$baseMatchesProperty;




var $kT11y = parcelRequire("kT11y");
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $45ea42bd06af243f$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $45ea42bd06af243f$export$2e2bcd8739ae039 = $45ea42bd06af243f$var$baseProperty;



/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $144dc4eb3945fdea$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $81c7e1f7fa125026$export$2e2bcd8739ae039)(object, path);
    };
}
var $144dc4eb3945fdea$export$2e2bcd8739ae039 = $144dc4eb3945fdea$var$basePropertyDeep;




var $cdqUH = parcelRequire("cdqUH");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $ff3552fa85fad895$var$property(path) {
    return (0, $84825456865648a9$export$2e2bcd8739ae039)(path) ? (0, $45ea42bd06af243f$export$2e2bcd8739ae039)((0, $cdqUH.default)(path)) : (0, $144dc4eb3945fdea$export$2e2bcd8739ae039)(path);
}
var $ff3552fa85fad895$export$2e2bcd8739ae039 = $ff3552fa85fad895$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $f5a9b0d134bf473a$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return 0, $3ff2fe33fd507b47$export$2e2bcd8739ae039;
    if (typeof value == 'object') return (0, $kT11y.default)(value) ? (0, $afd9887c1710fd31$export$2e2bcd8739ae039)(value[0], value[1]) : (0, $04aacc597b6e1ba7$export$2e2bcd8739ae039)(value);
    return (0, $ff3552fa85fad895$export$2e2bcd8739ae039)(value);
}
var $f5a9b0d134bf473a$export$2e2bcd8739ae039 = $f5a9b0d134bf473a$var$baseIteratee;




var $97lta = parcelRequire("97lta");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $4159a3e8b4ac1df2$var$baseMap(collection, iteratee) {
    var index = -1, result = (0, $97lta.default)(collection) ? Array(collection.length) : [];
    (0, $e9e67ac9104b68f7$export$2e2bcd8739ae039)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var $4159a3e8b4ac1df2$export$2e2bcd8739ae039 = $4159a3e8b4ac1df2$var$baseMap;



var $kT11y = parcelRequire("kT11y");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $1d23685c3fa78b12$var$map(collection, iteratee) {
    var func = (0, $kT11y.default)(collection) ? (0, $8w4ic.default) : (0, $4159a3e8b4ac1df2$export$2e2bcd8739ae039);
    return func(collection, (0, $f5a9b0d134bf473a$export$2e2bcd8739ae039)(iteratee, 3));
}
var $1d23685c3fa78b12$export$2e2bcd8739ae039 = $1d23685c3fa78b12$var$map;



var $a86485837e25d372$export$2ce88c5250e54734 = function BlockSwatches(_ref) {
    var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            swatches: {
                marginRight: '-10px'
            },
            swatch: {
                width: '22px',
                height: '22px',
                float: 'left',
                marginRight: '10px',
                marginBottom: '10px',
                borderRadius: '4px'
            },
            clear: {
                clear: 'both'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.swatches
    }, (0, $1d23685c3fa78b12$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b47f117f16e434a4$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            style: styles.swatch,
            onClick: onClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: '0 0 4px ' + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.clear
    }));
};
var $a86485837e25d372$export$2e2bcd8739ae039 = $a86485837e25d372$export$2ce88c5250e54734;


var $dcbae8534cd3514b$export$d96a8827a60d6b69 = function Block(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var transparent = hex === 'transparent';
    var handleChange = function handleChange(hexCode, e) {
        $3e6623331a03b061$export$944f75ec5697b362(hexCode) && onChange({
            hex: hexCode,
            source: 'hex'
        }, e);
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))((0, $5b09bd7873e0414d$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                boxShadow: '0 1px rgba(0,0,0,.1)',
                borderRadius: '6px',
                position: 'relative'
            },
            head: {
                height: '110px',
                background: hex,
                borderRadius: '6px 6px 0 0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative'
            },
            body: {
                padding: '10px'
            },
            label: {
                fontSize: '18px',
                color: $3e6623331a03b061$export$3609eb1d7e55dec(hex),
                position: 'relative'
            },
            triangle: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 10px 10px 10px',
                borderColor: 'transparent transparent ' + hex + ' transparent',
                position: 'absolute',
                top: '-10px',
                left: '50%',
                marginLeft: '-10px'
            },
            input: {
                width: '100%',
                fontSize: '12px',
                color: '#666',
                border: '0px',
                outline: 'none',
                height: '22px',
                boxShadow: 'inset 0 0 0 1px #ddd',
                borderRadius: '4px',
                padding: '0 7px',
                boxSizing: 'border-box'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.card,
        className: 'block-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.head
    }, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b588c516c7a68973$export$2e2bcd8739ae039), {
        borderRadius: '6px 6px 0 0'
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.label
    }, hex)), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a86485837e25d372$export$2e2bcd8739ae039), {
        colors: colors,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            input: styles.input
        },
        value: hex,
        onChange: handleChange
    })));
};
$dcbae8534cd3514b$export$d96a8827a60d6b69.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf([
        'top',
        'hide'
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
};
$dcbae8534cd3514b$export$d96a8827a60d6b69.defaultProps = {
    width: 170,
    colors: [
        '#D9E3F0',
        '#F47373',
        '#697689',
        '#37D67A',
        '#2CCCE4',
        '#555555',
        '#dce775',
        '#ff8a65',
        '#ba68c8'
    ],
    triangle: 'top',
    styles: {}
};
var $dcbae8534cd3514b$export$2e2bcd8739ae039 = (0, $682238ac99fddc24$export$2e2bcd8739ae039)($dcbae8534cd3514b$export$d96a8827a60d6b69);



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");



var $ddd18194abc40eaa$export$a90204d1394caf30 = {
    "50": "#ffebee",
    "100": "#ffcdd2",
    "200": "#ef9a9a",
    "300": "#e57373",
    "400": "#ef5350",
    "500": "#f44336",
    "600": "#e53935",
    "700": "#d32f2f",
    "800": "#c62828",
    "900": "#b71c1c",
    "a100": "#ff8a80",
    "a200": "#ff5252",
    "a400": "#ff1744",
    "a700": "#d50000"
};
var $ddd18194abc40eaa$export$47853bc718611763 = {
    "50": "#fce4ec",
    "100": "#f8bbd0",
    "200": "#f48fb1",
    "300": "#f06292",
    "400": "#ec407a",
    "500": "#e91e63",
    "600": "#d81b60",
    "700": "#c2185b",
    "800": "#ad1457",
    "900": "#880e4f",
    "a100": "#ff80ab",
    "a200": "#ff4081",
    "a400": "#f50057",
    "a700": "#c51162"
};
var $ddd18194abc40eaa$export$e13cce2a2d16a9d4 = {
    "50": "#f3e5f5",
    "100": "#e1bee7",
    "200": "#ce93d8",
    "300": "#ba68c8",
    "400": "#ab47bc",
    "500": "#9c27b0",
    "600": "#8e24aa",
    "700": "#7b1fa2",
    "800": "#6a1b9a",
    "900": "#4a148c",
    "a100": "#ea80fc",
    "a200": "#e040fb",
    "a400": "#d500f9",
    "a700": "#aa00ff"
};
var $ddd18194abc40eaa$export$51ef95b19086af57 = {
    "50": "#ede7f6",
    "100": "#d1c4e9",
    "200": "#b39ddb",
    "300": "#9575cd",
    "400": "#7e57c2",
    "500": "#673ab7",
    "600": "#5e35b1",
    "700": "#512da8",
    "800": "#4527a0",
    "900": "#311b92",
    "a100": "#b388ff",
    "a200": "#7c4dff",
    "a400": "#651fff",
    "a700": "#6200ea"
};
var $ddd18194abc40eaa$export$3e6ccc7b8562d453 = {
    "50": "#e8eaf6",
    "100": "#c5cae9",
    "200": "#9fa8da",
    "300": "#7986cb",
    "400": "#5c6bc0",
    "500": "#3f51b5",
    "600": "#3949ab",
    "700": "#303f9f",
    "800": "#283593",
    "900": "#1a237e",
    "a100": "#8c9eff",
    "a200": "#536dfe",
    "a400": "#3d5afe",
    "a700": "#304ffe"
};
var $ddd18194abc40eaa$export$2aa0182783e7e9de = {
    "50": "#e3f2fd",
    "100": "#bbdefb",
    "200": "#90caf9",
    "300": "#64b5f6",
    "400": "#42a5f5",
    "500": "#2196f3",
    "600": "#1e88e5",
    "700": "#1976d2",
    "800": "#1565c0",
    "900": "#0d47a1",
    "a100": "#82b1ff",
    "a200": "#448aff",
    "a400": "#2979ff",
    "a700": "#2962ff"
};
var $ddd18194abc40eaa$export$7b0d29b70b435c21 = {
    "50": "#e1f5fe",
    "100": "#b3e5fc",
    "200": "#81d4fa",
    "300": "#4fc3f7",
    "400": "#29b6f6",
    "500": "#03a9f4",
    "600": "#039be5",
    "700": "#0288d1",
    "800": "#0277bd",
    "900": "#01579b",
    "a100": "#80d8ff",
    "a200": "#40c4ff",
    "a400": "#00b0ff",
    "a700": "#0091ea"
};
var $ddd18194abc40eaa$export$7474046f446842ee = {
    "50": "#e0f7fa",
    "100": "#b2ebf2",
    "200": "#80deea",
    "300": "#4dd0e1",
    "400": "#26c6da",
    "500": "#00bcd4",
    "600": "#00acc1",
    "700": "#0097a7",
    "800": "#00838f",
    "900": "#006064",
    "a100": "#84ffff",
    "a200": "#18ffff",
    "a400": "#00e5ff",
    "a700": "#00b8d4"
};
var $ddd18194abc40eaa$export$8bf7dff220b82b4a = {
    "50": "#e0f2f1",
    "100": "#b2dfdb",
    "200": "#80cbc4",
    "300": "#4db6ac",
    "400": "#26a69a",
    "500": "#009688",
    "600": "#00897b",
    "700": "#00796b",
    "800": "#00695c",
    "900": "#004d40",
    "a100": "#a7ffeb",
    "a200": "#64ffda",
    "a400": "#1de9b6",
    "a700": "#00bfa5"
};
var $ddd18194abc40eaa$export$955a2ebd2fb142ae = {
    "50": "#e8f5e9",
    "100": "#c8e6c9",
    "200": "#a5d6a7",
    "300": "#81c784",
    "400": "#66bb6a",
    "500": "#4caf50",
    "600": "#43a047",
    "700": "#388e3c",
    "800": "#2e7d32",
    "900": "#1b5e20",
    "a100": "#b9f6ca",
    "a200": "#69f0ae",
    "a400": "#00e676",
    "a700": "#00c853"
};
var $ddd18194abc40eaa$export$559a8c00376dc936 = {
    "50": "#f1f8e9",
    "100": "#dcedc8",
    "200": "#c5e1a5",
    "300": "#aed581",
    "400": "#9ccc65",
    "500": "#8bc34a",
    "600": "#7cb342",
    "700": "#689f38",
    "800": "#558b2f",
    "900": "#33691e",
    "a100": "#ccff90",
    "a200": "#b2ff59",
    "a400": "#76ff03",
    "a700": "#64dd17"
};
var $ddd18194abc40eaa$export$221d31baf2636aad = {
    "50": "#f9fbe7",
    "100": "#f0f4c3",
    "200": "#e6ee9c",
    "300": "#dce775",
    "400": "#d4e157",
    "500": "#cddc39",
    "600": "#c0ca33",
    "700": "#afb42b",
    "800": "#9e9d24",
    "900": "#827717",
    "a100": "#f4ff81",
    "a200": "#eeff41",
    "a400": "#c6ff00",
    "a700": "#aeea00"
};
var $ddd18194abc40eaa$export$594c5a8758200c32 = {
    "50": "#fffde7",
    "100": "#fff9c4",
    "200": "#fff59d",
    "300": "#fff176",
    "400": "#ffee58",
    "500": "#ffeb3b",
    "600": "#fdd835",
    "700": "#fbc02d",
    "800": "#f9a825",
    "900": "#f57f17",
    "a100": "#ffff8d",
    "a200": "#ffff00",
    "a400": "#ffea00",
    "a700": "#ffd600"
};
var $ddd18194abc40eaa$export$7c1ecc66643fdbd6 = {
    "50": "#fff8e1",
    "100": "#ffecb3",
    "200": "#ffe082",
    "300": "#ffd54f",
    "400": "#ffca28",
    "500": "#ffc107",
    "600": "#ffb300",
    "700": "#ffa000",
    "800": "#ff8f00",
    "900": "#ff6f00",
    "a100": "#ffe57f",
    "a200": "#ffd740",
    "a400": "#ffc400",
    "a700": "#ffab00"
};
var $ddd18194abc40eaa$export$ad766f34ace1cafd = {
    "50": "#fff3e0",
    "100": "#ffe0b2",
    "200": "#ffcc80",
    "300": "#ffb74d",
    "400": "#ffa726",
    "500": "#ff9800",
    "600": "#fb8c00",
    "700": "#f57c00",
    "800": "#ef6c00",
    "900": "#e65100",
    "a100": "#ffd180",
    "a200": "#ffab40",
    "a400": "#ff9100",
    "a700": "#ff6d00"
};
var $ddd18194abc40eaa$export$1ceed3dd9ec11704 = {
    "50": "#fbe9e7",
    "100": "#ffccbc",
    "200": "#ffab91",
    "300": "#ff8a65",
    "400": "#ff7043",
    "500": "#ff5722",
    "600": "#f4511e",
    "700": "#e64a19",
    "800": "#d84315",
    "900": "#bf360c",
    "a100": "#ff9e80",
    "a200": "#ff6e40",
    "a400": "#ff3d00",
    "a700": "#dd2c00"
};
var $ddd18194abc40eaa$export$b6e6178d3f565007 = {
    "50": "#efebe9",
    "100": "#d7ccc8",
    "200": "#bcaaa4",
    "300": "#a1887f",
    "400": "#8d6e63",
    "500": "#795548",
    "600": "#6d4c41",
    "700": "#5d4037",
    "800": "#4e342e",
    "900": "#3e2723"
};
var $ddd18194abc40eaa$export$e4c89085febbc618 = {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121"
};
var $ddd18194abc40eaa$export$7c2da42d08c019c9 = {
    "50": "#eceff1",
    "100": "#cfd8dc",
    "200": "#b0bec5",
    "300": "#90a4ae",
    "400": "#78909c",
    "500": "#607d8b",
    "600": "#546e7a",
    "700": "#455a64",
    "800": "#37474f",
    "900": "#263238"
};
var $ddd18194abc40eaa$export$b413907788b50267 = {
    "primary": "rgba(0, 0, 0, 0.87)",
    "secondary": "rgba(0, 0, 0, 0.54)",
    "disabled": "rgba(0, 0, 0, 0.38)",
    "dividers": "rgba(0, 0, 0, 0.12)"
};
var $ddd18194abc40eaa$export$c962f8177a273028 = {
    "primary": "rgba(255, 255, 255, 1)",
    "secondary": "rgba(255, 255, 255, 0.7)",
    "disabled": "rgba(255, 255, 255, 0.5)",
    "dividers": "rgba(255, 255, 255, 0.12)"
};
var $ddd18194abc40eaa$export$969f6c634341b5cf = {
    "active": "rgba(0, 0, 0, 0.54)",
    "inactive": "rgba(0, 0, 0, 0.38)"
};
var $ddd18194abc40eaa$export$6b4a43519c60f4b1 = {
    "active": "rgba(255, 255, 255, 1)",
    "inactive": "rgba(255, 255, 255, 0.5)"
};
var $ddd18194abc40eaa$export$8fa4e5556fd77a60 = "#ffffff";
var $ddd18194abc40eaa$export$c073df10e766abfa = "#000000";
var $ddd18194abc40eaa$export$2e2bcd8739ae039 = {
    red: $ddd18194abc40eaa$export$a90204d1394caf30,
    pink: $ddd18194abc40eaa$export$47853bc718611763,
    purple: $ddd18194abc40eaa$export$e13cce2a2d16a9d4,
    deepPurple: $ddd18194abc40eaa$export$51ef95b19086af57,
    indigo: $ddd18194abc40eaa$export$3e6ccc7b8562d453,
    blue: $ddd18194abc40eaa$export$2aa0182783e7e9de,
    lightBlue: $ddd18194abc40eaa$export$7b0d29b70b435c21,
    cyan: $ddd18194abc40eaa$export$7474046f446842ee,
    teal: $ddd18194abc40eaa$export$8bf7dff220b82b4a,
    green: $ddd18194abc40eaa$export$955a2ebd2fb142ae,
    lightGreen: $ddd18194abc40eaa$export$559a8c00376dc936,
    lime: $ddd18194abc40eaa$export$221d31baf2636aad,
    yellow: $ddd18194abc40eaa$export$594c5a8758200c32,
    amber: $ddd18194abc40eaa$export$7c1ecc66643fdbd6,
    orange: $ddd18194abc40eaa$export$ad766f34ace1cafd,
    deepOrange: $ddd18194abc40eaa$export$1ceed3dd9ec11704,
    brown: $ddd18194abc40eaa$export$b6e6178d3f565007,
    grey: $ddd18194abc40eaa$export$e4c89085febbc618,
    blueGrey: $ddd18194abc40eaa$export$7c2da42d08c019c9,
    darkText: $ddd18194abc40eaa$export$b413907788b50267,
    lightText: $ddd18194abc40eaa$export$c962f8177a273028,
    darkIcons: $ddd18194abc40eaa$export$969f6c634341b5cf,
    lightIcons: $ddd18194abc40eaa$export$6b4a43519c60f4b1,
    white: $ddd18194abc40eaa$export$8fa4e5556fd77a60,
    black: $ddd18194abc40eaa$export$c073df10e766abfa
};




var $6fFrj = parcelRequire("6fFrj");


var $4e20830d2782a486$export$945d5c8ebb42b0ff = function CircleSwatch(_ref) {
    var color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover = _ref.hover, active = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            swatch: {
                width: circleSize,
                height: circleSize,
                marginRight: circleSpacing,
                marginBottom: circleSpacing,
                transform: 'scale(1)',
                transition: '100ms transform ease'
            },
            Swatch: {
                borderRadius: '50%',
                background: 'transparent',
                boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
                transition: '100ms box-shadow ease'
            }
        },
        'hover': {
            swatch: {
                transform: 'scale(1.2)'
            }
        },
        'active': {
            Swatch: {
                boxShadow: 'inset 0 0 0 3px ' + color
            }
        }
    }, {
        hover: hover,
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b47f117f16e434a4$export$2e2bcd8739ae039), {
        style: styles.Swatch,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color
        }
    }));
};
$4e20830d2782a486$export$945d5c8ebb42b0ff.defaultProps = {
    circleSize: 28,
    circleSpacing: 14
};
var $4e20830d2782a486$export$2e2bcd8739ae039 = (0, $bd96d54b29ffe643$exports.handleHover)($4e20830d2782a486$export$945d5c8ebb42b0ff);


var $72fd7733944951d9$export$c89a927ffc67e6fa = function Circle(_ref) {
    var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))((0, $5b09bd7873e0414d$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                display: 'flex',
                flexWrap: 'wrap',
                marginRight: -circleSpacing,
                marginBottom: -circleSpacing
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(hexCode, e) {
        return onChange({
            hex: hexCode,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.card,
        className: 'circle-picker ' + className
    }, (0, $1d23685c3fa78b12$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $4e20830d2782a486$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover,
            active: hex === c.toLowerCase(),
            circleSize: circleSize,
            circleSpacing: circleSpacing
        });
    }));
};
$72fd7733944951d9$export$c89a927ffc67e6fa.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    ]),
    circleSize: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    circleSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
};
$72fd7733944951d9$export$c89a927ffc67e6fa.defaultProps = {
    width: 252,
    circleSize: 28,
    circleSpacing: 14,
    colors: [
        $ddd18194abc40eaa$export$a90204d1394caf30['500'],
        $ddd18194abc40eaa$export$47853bc718611763['500'],
        $ddd18194abc40eaa$export$e13cce2a2d16a9d4['500'],
        $ddd18194abc40eaa$export$51ef95b19086af57['500'],
        $ddd18194abc40eaa$export$3e6ccc7b8562d453['500'],
        $ddd18194abc40eaa$export$2aa0182783e7e9de['500'],
        $ddd18194abc40eaa$export$7b0d29b70b435c21['500'],
        $ddd18194abc40eaa$export$7474046f446842ee['500'],
        $ddd18194abc40eaa$export$8bf7dff220b82b4a['500'],
        $ddd18194abc40eaa$export$955a2ebd2fb142ae['500'],
        $ddd18194abc40eaa$export$559a8c00376dc936['500'],
        $ddd18194abc40eaa$export$221d31baf2636aad['500'],
        $ddd18194abc40eaa$export$594c5a8758200c32['500'],
        $ddd18194abc40eaa$export$7c1ecc66643fdbd6['500'],
        $ddd18194abc40eaa$export$ad766f34ace1cafd['500'],
        $ddd18194abc40eaa$export$1ceed3dd9ec11704['500'],
        $ddd18194abc40eaa$export$b6e6178d3f565007['500'],
        $ddd18194abc40eaa$export$7c2da42d08c019c9['500']
    ],
    styles: {}
};
var $72fd7733944951d9$export$2e2bcd8739ae039 = (0, $682238ac99fddc24$export$2e2bcd8739ae039)($72fd7733944951d9$export$c89a927ffc67e6fa);



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");




var $6fFrj = parcelRequire("6fFrj");


/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $703e5f36dc162d32$var$isUndefined(value) {
    return value === undefined;
}
var $703e5f36dc162d32$export$2e2bcd8739ae039 = $703e5f36dc162d32$var$isUndefined;



var $474c5ed3166ab296$exports = {};
'use strict';
Object.defineProperty($474c5ed3166ab296$exports, "__esModule", {
    value: true
});
var $474c5ed3166ab296$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $6fFrj = parcelRequire("6fFrj");
var $474c5ed3166ab296$var$_react2 = $474c5ed3166ab296$var$_interopRequireDefault($6fFrj);
function $474c5ed3166ab296$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $474c5ed3166ab296$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $474c5ed3166ab296$var$DEFAULT_SIZE = 24;
$474c5ed3166ab296$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? 'currentColor' : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $474c5ed3166ab296$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $474c5ed3166ab296$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $474c5ed3166ab296$var$_objectWithoutProperties(_ref, [
        'fill',
        'width',
        'height',
        'style'
    ]);
    return $474c5ed3166ab296$var$_react2.default.createElement('svg', $474c5ed3166ab296$var$_extends({
        viewBox: '0 0 ' + $474c5ed3166ab296$var$DEFAULT_SIZE + ' ' + $474c5ed3166ab296$var$DEFAULT_SIZE,
        style: $474c5ed3166ab296$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $474c5ed3166ab296$var$_react2.default.createElement('path', {
        d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
    }));
};


var $1b412b01fb52ca68$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $1b412b01fb52ca68$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1b412b01fb52ca68$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1b412b01fb52ca68$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $1b412b01fb52ca68$export$71685d48a2432635 = function(_React$Component) {
    $1b412b01fb52ca68$var$_inherits(ChromeFields, _React$Component);
    function ChromeFields(props) {
        $1b412b01fb52ca68$var$_classCallCheck(this, ChromeFields);
        var _this = $1b412b01fb52ca68$var$_possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
        _this.toggleViews = function() {
            if (_this.state.view === 'hex') _this.setState({
                view: 'rgb'
            });
            else if (_this.state.view === 'rgb') _this.setState({
                view: 'hsl'
            });
            else if (_this.state.view === 'hsl') {
                if (_this.props.hsl.a === 1) _this.setState({
                    view: 'hex'
                });
                else _this.setState({
                    view: 'rgb'
                });
            }
        };
        _this.handleChange = function(data, e) {
            if (data.hex) $3e6623331a03b061$export$944f75ec5697b362(data.hex) && _this.props.onChange({
                hex: data.hex,
                source: 'hex'
            }, e);
            else if (data.r || data.g || data.b) _this.props.onChange({
                r: data.r || _this.props.rgb.r,
                g: data.g || _this.props.rgb.g,
                b: data.b || _this.props.rgb.b,
                source: 'rgb'
            }, e);
            else if (data.a) {
                if (data.a < 0) data.a = 0;
                else if (data.a > 1) data.a = 1;
                _this.props.onChange({
                    h: _this.props.hsl.h,
                    s: _this.props.hsl.s,
                    l: _this.props.hsl.l,
                    a: Math.round(data.a * 100) / 100,
                    source: 'rgb'
                }, e);
            } else if (data.h || data.s || data.l) {
                // Remove any occurances of '%'.
                if (typeof data.s === 'string' && data.s.includes('%')) data.s = data.s.replace('%', '');
                if (typeof data.l === 'string' && data.l.includes('%')) data.l = data.l.replace('%', '');
                // We store HSL as a unit interval so we need to override the 1 input to 0.01
                if (data.s == 1) data.s = 0.01;
                else if (data.l == 1) data.l = 0.01;
                _this.props.onChange({
                    h: data.h || _this.props.hsl.h,
                    s: Number(!(0, $703e5f36dc162d32$export$2e2bcd8739ae039)(data.s) ? data.s : _this.props.hsl.s),
                    l: Number(!(0, $703e5f36dc162d32$export$2e2bcd8739ae039)(data.l) ? data.l : _this.props.hsl.l),
                    source: 'hsl'
                }, e);
            }
        };
        _this.showHighlight = function(e) {
            e.currentTarget.style.background = '#eee';
        };
        _this.hideHighlight = function(e) {
            e.currentTarget.style.background = 'transparent';
        };
        if (props.hsl.a !== 1 && props.view === "hex") _this.state = {
            view: "rgb"
        };
        else _this.state = {
            view: props.view
        };
        return _this;
    }
    $1b412b01fb52ca68$var$_createClass(ChromeFields, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
                    'default': {
                        wrap: {
                            paddingTop: '16px',
                            display: 'flex'
                        },
                        fields: {
                            flex: '1',
                            display: 'flex',
                            marginLeft: '-6px'
                        },
                        field: {
                            paddingLeft: '6px',
                            width: '100%'
                        },
                        alpha: {
                            paddingLeft: '6px',
                            width: '100%'
                        },
                        toggle: {
                            width: '32px',
                            textAlign: 'right',
                            position: 'relative'
                        },
                        icon: {
                            marginRight: '-4px',
                            marginTop: '12px',
                            cursor: 'pointer',
                            position: 'relative'
                        },
                        iconHighlight: {
                            position: 'absolute',
                            width: '24px',
                            height: '28px',
                            background: '#eee',
                            borderRadius: '4px',
                            top: '10px',
                            left: '12px',
                            display: 'none'
                        },
                        input: {
                            fontSize: '11px',
                            color: '#333',
                            width: '100%',
                            borderRadius: '2px',
                            border: 'none',
                            boxShadow: 'inset 0 0 0 1px #dadada',
                            height: '21px',
                            textAlign: 'center'
                        },
                        label: {
                            textTransform: 'uppercase',
                            fontSize: '11px',
                            lineHeight: '11px',
                            color: '#969696',
                            textAlign: 'center',
                            display: 'block',
                            marginTop: '12px'
                        },
                        svg: {
                            fill: '#333',
                            width: '24px',
                            height: '24px',
                            border: '1px transparent solid',
                            borderRadius: '5px'
                        }
                    },
                    'disableAlpha': {
                        alpha: {
                            display: 'none'
                        }
                    }
                }, this.props, this.state);
                var fields = void 0;
                if (this.state.view === 'hex') fields = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'hex',
                    value: this.props.hex,
                    onChange: this.handleChange
                })));
                else if (this.state.view === 'rgb') fields = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'r',
                    value: this.props.rgb.r,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'g',
                    value: this.props.rgb.g,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'b',
                    value: this.props.rgb.b,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'a',
                    value: this.props.rgb.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                else if (this.state.view === 'hsl') fields = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'h',
                    value: Math.round(this.props.hsl.h),
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 's',
                    value: Math.round(this.props.hsl.s * 100) + '%',
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'l',
                    value: Math.round(this.props.hsl.l * 100) + '%',
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'a',
                    value: this.props.hsl.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.wrap,
                    className: 'flexbox-fix'
                }, fields, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.toggle
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.icon,
                    onClick: this.toggleViews,
                    ref: function ref(icon) {
                        return _this2.icon = icon;
                    }
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($474c5ed3166ab296$exports))), {
                    style: styles.svg,
                    onMouseOver: this.showHighlight,
                    onMouseEnter: this.showHighlight,
                    onMouseOut: this.hideHighlight
                }))));
            }
        }
    ], [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps, state) {
                if (nextProps.hsl.a !== 1 && state.view === 'hex') return {
                    view: 'rgb'
                };
                return null;
            }
        }
    ]);
    return ChromeFields;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
$1b412b01fb52ca68$export$71685d48a2432635.defaultProps = {
    view: "hex"
};
var $1b412b01fb52ca68$export$2e2bcd8739ae039 = $1b412b01fb52ca68$export$71685d48a2432635;



var $6fFrj = parcelRequire("6fFrj");

var $b62637c561ef22fd$export$a632586f9a957100 = function ChromePointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                transform: 'translate(-6px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.picker
    });
};
var $b62637c561ef22fd$export$2e2bcd8739ae039 = $b62637c561ef22fd$export$a632586f9a957100;



var $6fFrj = parcelRequire("6fFrj");

var $34725f80f65e3ebb$export$190c1afe887f7ef7 = function ChromePointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                boxShadow: 'inset 0 0 0 1px #fff',
                transform: 'translate(-6px, -6px)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.picker
    });
};
var $34725f80f65e3ebb$export$2e2bcd8739ae039 = $34725f80f65e3ebb$export$190c1afe887f7ef7;


var $763c021b21b78dc4$export$31a305e9779b48b4 = function Chrome(_ref) {
    var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className, defaultView = _ref.defaultView;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))((0, $5b09bd7873e0414d$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                width: width,
                background: '#fff',
                borderRadius: '2px',
                boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
                boxSizing: 'initial',
                fontFamily: 'Menlo'
            },
            saturation: {
                width: '100%',
                paddingBottom: '55%',
                position: 'relative',
                borderRadius: '2px 2px 0 0',
                overflow: 'hidden'
            },
            Saturation: {
                radius: '2px 2px 0 0'
            },
            body: {
                padding: '16px 16px 12px'
            },
            controls: {
                display: 'flex'
            },
            color: {
                width: '32px'
            },
            swatch: {
                marginTop: '6px',
                width: '16px',
                height: '16px',
                borderRadius: '8px',
                position: 'relative',
                overflow: 'hidden'
            },
            active: {
                absolute: '0px 0px 0px 0px',
                borderRadius: '8px',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
                background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
                zIndex: '2'
            },
            toggles: {
                flex: '1'
            },
            hue: {
                height: '10px',
                position: 'relative',
                marginBottom: '8px'
            },
            Hue: {
                radius: '2px'
            },
            alpha: {
                height: '10px',
                position: 'relative'
            },
            Alpha: {
                radius: '2px'
            }
        },
        'disableAlpha': {
            color: {
                width: '22px'
            },
            alpha: {
                display: 'none'
            },
            hue: {
                marginBottom: '0px'
            },
            swatch: {
                width: '10px',
                height: '10px',
                marginTop: '0px'
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.picker,
        className: 'chrome-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $49832aed7d90d628$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $34725f80f65e3ebb$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b588c516c7a68973$export$2e2bcd8739ae039), {
        renderers: renderers
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.toggles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $eb389715f5ad7937$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: (0, $b62637c561ef22fd$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a9f7c72741cda63e$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        pointer: (0, $b62637c561ef22fd$export$2e2bcd8739ae039),
        renderers: renderers,
        onChange: onChange
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $1b412b01fb52ca68$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
    })));
};
$763c021b21b78dc4$export$31a305e9779b48b4.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    ]),
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object,
    defaultView: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf([
        "hex",
        "rgb",
        "hsl"
    ])
};
$763c021b21b78dc4$export$31a305e9779b48b4.defaultProps = {
    width: 225,
    disableAlpha: false,
    styles: {}
};
var $763c021b21b78dc4$export$2e2bcd8739ae039 = (0, $682238ac99fddc24$export$2e2bcd8739ae039)($763c021b21b78dc4$export$31a305e9779b48b4);



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");






var $6fFrj = parcelRequire("6fFrj");



var $057f6e8ba3a15c0f$export$df654652e5203306 = function CompactColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            color: {
                background: color,
                width: '15px',
                height: '15px',
                float: 'left',
                marginRight: '5px',
                marginBottom: '5px',
                position: 'relative',
                cursor: 'pointer'
            },
            dot: {
                absolute: '5px 5px 5px 5px',
                background: $3e6623331a03b061$export$3609eb1d7e55dec(color),
                borderRadius: '50%',
                opacity: '0'
            }
        },
        'active': {
            dot: {
                opacity: '1'
            }
        },
        'color-#FFFFFF': {
            color: {
                boxShadow: 'inset 0 0 0 1px #ddd'
            },
            dot: {
                background: '#000'
            }
        },
        'transparent': {
            dot: {
                background: '#000'
            }
        }
    }, {
        active: active,
        'color-#FFFFFF': color === '#FFFFFF',
        'transparent': color === 'transparent'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b47f117f16e434a4$export$2e2bcd8739ae039), {
        style: styles.color,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: '0 0 4px ' + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.dot
    }));
};
var $057f6e8ba3a15c0f$export$2e2bcd8739ae039 = $057f6e8ba3a15c0f$export$df654652e5203306;



var $6fFrj = parcelRequire("6fFrj");


var $a55c43193cf4b478$export$11cdb14a03223d9c = function CompactFields(_ref) {
    var hex = _ref.hex, rgb = _ref.rgb, onChange = _ref.onChange;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            fields: {
                display: 'flex',
                paddingBottom: '6px',
                paddingRight: '5px',
                position: 'relative'
            },
            active: {
                position: 'absolute',
                top: '6px',
                left: '5px',
                height: '9px',
                width: '9px',
                background: hex
            },
            HEXwrap: {
                flex: '6',
                position: 'relative'
            },
            HEXinput: {
                width: '80%',
                padding: '0px',
                paddingLeft: '20%',
                border: 'none',
                outline: 'none',
                background: 'none',
                fontSize: '12px',
                color: '#333',
                height: '16px'
            },
            HEXlabel: {
                display: 'none'
            },
            RGBwrap: {
                flex: '3',
                position: 'relative'
            },
            RGBinput: {
                width: '70%',
                padding: '0px',
                paddingLeft: '30%',
                border: 'none',
                outline: 'none',
                background: 'none',
                fontSize: '12px',
                color: '#333',
                height: '16px'
            },
            RGBlabel: {
                position: 'absolute',
                top: '3px',
                left: '0px',
                lineHeight: '16px',
                textTransform: 'uppercase',
                fontSize: '12px',
                color: '#999'
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
        else onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.fields,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    }));
};
var $a55c43193cf4b478$export$2e2bcd8739ae039 = $a55c43193cf4b478$export$11cdb14a03223d9c;


var $5f55558c182b1cb6$export$6479582a9c9e50ce = function Compact(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))((0, $5b09bd7873e0414d$export$2e2bcd8739ae039)({
        'default': {
            Compact: {
                background: '#f6f6f6',
                radius: '4px'
            },
            compact: {
                paddingTop: '5px',
                paddingLeft: '5px',
                boxSizing: 'initial',
                width: '240px'
            },
            clear: {
                clear: 'both'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $3e6623331a03b061$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else onChange(data, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $c8044453b0372755$export$2e2bcd8739ae039), {
        style: styles.Compact,
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.compact,
        className: 'compact-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', null, (0, $1d23685c3fa78b12$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $057f6e8ba3a15c0f$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.clear
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a55c43193cf4b478$export$2e2bcd8739ae039), {
        hex: hex,
        rgb: rgb,
        onChange: handleChange
    })));
};
$5f55558c182b1cb6$export$6479582a9c9e50ce.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
};
$5f55558c182b1cb6$export$6479582a9c9e50ce.defaultProps = {
    colors: [
        '#4D4D4D',
        '#999999',
        '#FFFFFF',
        '#F44E3B',
        '#FE9200',
        '#FCDC00',
        '#DBDF00',
        '#A4DD00',
        '#68CCCA',
        '#73D8FF',
        '#AEA1FF',
        '#FDA1FF',
        '#333333',
        '#808080',
        '#cccccc',
        '#D33115',
        '#E27300',
        '#FCC400',
        '#B0BC00',
        '#68BC00',
        '#16A5A5',
        '#009CE0',
        '#7B64FF',
        '#FA28FF',
        '#000000',
        '#666666',
        '#B3B3B3',
        '#9F0500',
        '#C45100',
        '#FB9E00',
        '#808900',
        '#194D33',
        '#0C797D',
        '#0062B1',
        '#653294',
        '#AB149E'
    ],
    styles: {}
};
var $5f55558c182b1cb6$export$2e2bcd8739ae039 = (0, $682238ac99fddc24$export$2e2bcd8739ae039)($5f55558c182b1cb6$export$6479582a9c9e50ce);



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");





var $6fFrj = parcelRequire("6fFrj");


var $48b5bdea3a42b2a8$export$d653c538b92bb84f = function GithubSwatch(_ref) {
    var hover = _ref.hover, color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var hoverSwatch = {
        position: 'relative',
        zIndex: '2',
        outline: '2px solid #fff',
        boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            swatch: {
                width: '25px',
                height: '25px',
                fontSize: '0'
            }
        },
        'hover': {
            swatch: hoverSwatch
        }
    }, {
        hover: hover
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b47f117f16e434a4$export$2e2bcd8739ae039), {
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: hoverSwatch
    }));
};
var $48b5bdea3a42b2a8$export$2e2bcd8739ae039 = (0, $bd96d54b29ffe643$exports.handleHover)($48b5bdea3a42b2a8$export$d653c538b92bb84f);


var $d26f164835901f1d$export$61d478c2aba5d9a5 = function Github(_ref) {
    var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))((0, $5b09bd7873e0414d$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                border: '1px solid rgba(0,0,0,0.2)',
                boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                borderRadius: '4px',
                position: 'relative',
                padding: '5px',
                display: 'flex',
                flexWrap: 'wrap'
            },
            triangle: {
                position: 'absolute',
                border: '7px solid transparent',
                borderBottomColor: '#fff'
            },
            triangleShadow: {
                position: 'absolute',
                border: '8px solid transparent',
                borderBottomColor: 'rgba(0,0,0,0.15)'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            },
            triangleShadow: {
                display: 'none'
            }
        },
        'top-left-triangle': {
            triangle: {
                top: '-14px',
                left: '10px'
            },
            triangleShadow: {
                top: '-16px',
                left: '9px'
            }
        },
        'top-right-triangle': {
            triangle: {
                top: '-14px',
                right: '10px'
            },
            triangleShadow: {
                top: '-16px',
                right: '9px'
            }
        },
        'bottom-left-triangle': {
            triangle: {
                top: '35px',
                left: '10px',
                transform: 'rotate(180deg)'
            },
            triangleShadow: {
                top: '37px',
                left: '9px',
                transform: 'rotate(180deg)'
            }
        },
        'bottom-right-triangle': {
            triangle: {
                top: '35px',
                right: '10px',
                transform: 'rotate(180deg)'
            },
            triangleShadow: {
                top: '37px',
                right: '9px',
                transform: 'rotate(180deg)'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide',
        'top-left-triangle': triangle === 'top-left',
        'top-right-triangle': triangle === 'top-right',
        'bottom-left-triangle': triangle === 'bottom-left',
        'bottom-right-triangle': triangle === 'bottom-right'
    });
    var handleChange = function handleChange(hex, e) {
        return onChange({
            hex: hex,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.card,
        className: 'github-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.triangle
    }), (0, $1d23685c3fa78b12$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $48b5bdea3a42b2a8$export$2e2bcd8739ae039), {
            color: c,
            key: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }));
};
$d26f164835901f1d$export$61d478c2aba5d9a5.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf([
        'hide',
        'top-left',
        'top-right',
        'bottom-left',
        'bottom-right'
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
};
$d26f164835901f1d$export$61d478c2aba5d9a5.defaultProps = {
    width: 200,
    colors: [
        '#B80000',
        '#DB3E00',
        '#FCCB00',
        '#008B02',
        '#006B76',
        '#1273DE',
        '#004DCF',
        '#5300EB',
        '#EB9694',
        '#FAD0C3',
        '#FEF3BD',
        '#C1E1C5',
        '#BEDADC',
        '#C4DEF6',
        '#BED3F3',
        '#D4C4FB'
    ],
    triangle: 'top-left',
    styles: {}
};
var $d26f164835901f1d$export$2e2bcd8739ae039 = (0, $682238ac99fddc24$export$2e2bcd8739ae039)($d26f164835901f1d$export$61d478c2aba5d9a5);



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");




var $6fFrj = parcelRequire("6fFrj");

var $b89442d00b888666$export$9c10b52c64965f67 = function SliderPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            picker: {
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                transform: 'translate(-9px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        },
        'vertical': {
            picker: {
                transform: 'translate(-3px, -9px)'
            }
        }
    }, {
        vertical: direction === 'vertical'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.picker
    });
};
var $b89442d00b888666$export$2e2bcd8739ae039 = $b89442d00b888666$export$9c10b52c64965f67;


var $5d63125666245451$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5d63125666245451$export$f176087feb20230e = function HuePicker(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl = _ref.hsl, direction = _ref.direction, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))((0, $5b09bd7873e0414d$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                position: 'relative',
                width: width,
                height: height
            },
            hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    // Overwrite to provide pure hue color
    var handleChange = function handleChange(data) {
        return onChange({
            a: 1,
            h: data.h,
            l: 0.5,
            s: 1
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.picker,
        className: 'hue-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $eb389715f5ad7937$export$2e2bcd8739ae039), $5d63125666245451$var$_extends({}, styles.hue, {
        hsl: hsl,
        pointer: pointer,
        onChange: handleChange,
        direction: direction
    })));
};
$5d63125666245451$export$f176087feb20230e.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
};
$5d63125666245451$export$f176087feb20230e.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: (0, $b89442d00b888666$export$2e2bcd8739ae039),
    styles: {}
};
var $5d63125666245451$export$2e2bcd8739ae039 = (0, $682238ac99fddc24$export$2e2bcd8739ae039)($5d63125666245451$export$f176087feb20230e);



var $6fFrj = parcelRequire("6fFrj");




var $4f82f8d6146f0cff$export$a2d8b23205c25948 = function Material(_ref) {
    var onChange = _ref.onChange, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))((0, $5b09bd7873e0414d$export$2e2bcd8739ae039)({
        'default': {
            material: {
                width: '98px',
                height: '98px',
                padding: '16px',
                fontFamily: 'Roboto'
            },
            HEXwrap: {
                position: 'relative'
            },
            HEXinput: {
                width: '100%',
                marginTop: '12px',
                fontSize: '15px',
                color: '#333',
                padding: '0px',
                border: '0px',
                borderBottom: '2px solid ' + hex,
                outline: 'none',
                height: '30px'
            },
            HEXlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                fontSize: '11px',
                color: '#999999',
                textTransform: 'capitalize'
            },
            Hex: {
                style: {}
            },
            RGBwrap: {
                position: 'relative'
            },
            RGBinput: {
                width: '100%',
                marginTop: '12px',
                fontSize: '15px',
                color: '#333',
                padding: '0px',
                border: '0px',
                borderBottom: '1px solid #eee',
                outline: 'none',
                height: '30px'
            },
            RGBlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                fontSize: '11px',
                color: '#999999',
                textTransform: 'capitalize'
            },
            split: {
                display: 'flex',
                marginRight: '-10px',
                paddingTop: '11px'
            },
            third: {
                flex: '1',
                paddingRight: '10px'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $3e6623331a03b061$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $c8044453b0372755$export$2e2bcd8739ae039), {
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.material,
        className: 'material-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.split,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    })))));
};
var $4f82f8d6146f0cff$export$2e2bcd8739ae039 = (0, $682238ac99fddc24$export$2e2bcd8739ae039)($4f82f8d6146f0cff$export$a2d8b23205c25948);



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");




var $6fFrj = parcelRequire("6fFrj");



var $4b84c18dde9798e1$export$b1808ee9bfa8f4d0 = function PhotoshopPicker(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsv = _ref.hsv, hex = _ref.hex;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            fields: {
                paddingTop: '5px',
                paddingBottom: '9px',
                width: '80px',
                position: 'relative'
            },
            divider: {
                height: '5px'
            },
            RGBwrap: {
                position: 'relative'
            },
            RGBinput: {
                marginLeft: '40%',
                width: '40%',
                height: '18px',
                border: '1px solid #888888',
                boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
                marginBottom: '5px',
                fontSize: '13px',
                paddingLeft: '3px',
                marginRight: '10px'
            },
            RGBlabel: {
                left: '0px',
                top: '0px',
                width: '34px',
                textTransform: 'uppercase',
                fontSize: '13px',
                height: '18px',
                lineHeight: '22px',
                position: 'absolute'
            },
            HEXwrap: {
                position: 'relative'
            },
            HEXinput: {
                marginLeft: '20%',
                width: '80%',
                height: '18px',
                border: '1px solid #888888',
                boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
                marginBottom: '6px',
                fontSize: '13px',
                paddingLeft: '3px'
            },
            HEXlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '14px',
                textTransform: 'uppercase',
                fontSize: '13px',
                height: '18px',
                lineHeight: '22px'
            },
            fieldSymbols: {
                position: 'absolute',
                top: '5px',
                right: '-7px',
                fontSize: '13px'
            },
            symbol: {
                height: '20px',
                lineHeight: '22px',
                paddingBottom: '7px'
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data['#']) $3e6623331a03b061$export$944f75ec5697b362(data['#']) && onChange({
            hex: data['#'],
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
        else if (data.h || data.s || data.v) onChange({
            h: data.h || hsv.h,
            s: data.s || hsv.s,
            v: data.v || hsv.v,
            source: 'hsv'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'h',
        value: Math.round(hsv.h),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 's',
        value: Math.round(hsv.s * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'v',
        value: Math.round(hsv.v * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: '#',
        value: hex.replace('#', ''),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.fieldSymbols
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.symbol
    }, '\xB0'), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.symbol
    }, '%'), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.symbol
    }, '%')));
};
var $4b84c18dde9798e1$export$2e2bcd8739ae039 = $4b84c18dde9798e1$export$b1808ee9bfa8f4d0;



var $6fFrj = parcelRequire("6fFrj");

var $c5a48691949bb8c2$export$123b96ff8455915 = function PhotoshopPointerCircle(_ref) {
    var hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                boxShadow: 'inset 0 0 0 1px #fff',
                transform: 'translate(-6px, -6px)'
            }
        },
        'black-outline': {
            picker: {
                boxShadow: 'inset 0 0 0 1px #000'
            }
        }
    }, {
        'black-outline': hsl.l > 0.5
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.picker
    });
};
var $c5a48691949bb8c2$export$2e2bcd8739ae039 = $c5a48691949bb8c2$export$123b96ff8455915;



var $6fFrj = parcelRequire("6fFrj");

var $0d0b15d3a0f4d961$export$123b96ff8455915 = function PhotoshopPointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            triangle: {
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '4px 0 4px 6px',
                borderColor: 'transparent transparent transparent #fff',
                position: 'absolute',
                top: '1px',
                left: '1px'
            },
            triangleBorder: {
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '5px 0 5px 8px',
                borderColor: 'transparent transparent transparent #555'
            },
            left: {
                Extend: 'triangleBorder',
                transform: 'translate(-13px, -4px)'
            },
            leftInside: {
                Extend: 'triangle',
                transform: 'translate(-8px, -5px)'
            },
            right: {
                Extend: 'triangleBorder',
                transform: 'translate(20px, -14px) rotate(180deg)'
            },
            rightInside: {
                Extend: 'triangle',
                transform: 'translate(-8px, -5px)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.pointer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.left
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.leftInside
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.right
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.rightInside
    })));
};
var $0d0b15d3a0f4d961$export$2e2bcd8739ae039 = $0d0b15d3a0f4d961$export$123b96ff8455915;



var $6fFrj = parcelRequire("6fFrj");

var $1b3097866e0ea79d$export$f7d38a0bd3b98717 = function PhotoshopButton(_ref) {
    var onClick = _ref.onClick, label = _ref.label, children = _ref.children, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            button: {
                backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
                border: '1px solid #878787',
                borderRadius: '2px',
                height: '20px',
                boxShadow: '0 1px 0 0 #EAEAEA',
                fontSize: '14px',
                color: '#000',
                lineHeight: '20px',
                textAlign: 'center',
                marginBottom: '10px',
                cursor: 'pointer'
            }
        },
        'active': {
            button: {
                boxShadow: '0 0 0 1px #878787'
            }
        }
    }, {
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.button,
        onClick: onClick
    }, label || children);
};
var $1b3097866e0ea79d$export$2e2bcd8739ae039 = $1b3097866e0ea79d$export$f7d38a0bd3b98717;



var $6fFrj = parcelRequire("6fFrj");

var $7279223390dfc751$export$ce0d7acd66f46f2b = function PhotoshopPreviews(_ref) {
    var rgb = _ref.rgb, currentColor = _ref.currentColor;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            swatches: {
                border: '1px solid #B3B3B3',
                borderBottom: '1px solid #F0F0F0',
                marginBottom: '2px',
                marginTop: '1px'
            },
            new: {
                height: '34px',
                background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
                boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
            },
            current: {
                height: '34px',
                background: currentColor,
                boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
            },
            label: {
                fontSize: '14px',
                color: '#000',
                textAlign: 'center'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', null, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.label
    }, 'new'), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.new
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.current
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.label
    }, 'current'));
};
var $7279223390dfc751$export$2e2bcd8739ae039 = $7279223390dfc751$export$ce0d7acd66f46f2b;


var $db178325c21ce8ba$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $db178325c21ce8ba$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $db178325c21ce8ba$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $db178325c21ce8ba$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $db178325c21ce8ba$export$4ed116dea8ad5956 = function(_React$Component) {
    $db178325c21ce8ba$var$_inherits(Photoshop, _React$Component);
    function Photoshop(props) {
        $db178325c21ce8ba$var$_classCallCheck(this, Photoshop);
        var _this = $db178325c21ce8ba$var$_possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
        _this.state = {
            currentColor: props.hex
        };
        return _this;
    }
    $db178325c21ce8ba$var$_createClass(Photoshop, [
        {
            key: 'render',
            value: function render() {
                var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === undefined ? {} : _props$styles, _props$className = _props.className, className = _props$className === undefined ? '' : _props$className;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))((0, $5b09bd7873e0414d$export$2e2bcd8739ae039)({
                    'default': {
                        picker: {
                            background: '#DCDCDC',
                            borderRadius: '4px',
                            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
                            boxSizing: 'initial',
                            width: '513px'
                        },
                        head: {
                            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
                            borderBottom: '1px solid #B1B1B1',
                            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
                            height: '23px',
                            lineHeight: '24px',
                            borderRadius: '4px 4px 0 0',
                            fontSize: '13px',
                            color: '#4D4D4D',
                            textAlign: 'center'
                        },
                        body: {
                            padding: '15px 15px 0',
                            display: 'flex'
                        },
                        saturation: {
                            width: '256px',
                            height: '256px',
                            position: 'relative',
                            border: '2px solid #B3B3B3',
                            borderBottom: '2px solid #F0F0F0',
                            overflow: 'hidden'
                        },
                        hue: {
                            position: 'relative',
                            height: '256px',
                            width: '19px',
                            marginLeft: '10px',
                            border: '2px solid #B3B3B3',
                            borderBottom: '2px solid #F0F0F0'
                        },
                        controls: {
                            width: '180px',
                            marginLeft: '10px'
                        },
                        top: {
                            display: 'flex'
                        },
                        previews: {
                            width: '60px'
                        },
                        actions: {
                            flex: '1',
                            marginLeft: '20px'
                        }
                    }
                }, passedStyles));
                return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.picker,
                    className: 'photoshop-picker ' + className
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.head
                }, this.props.header), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.body,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.saturation
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $49832aed7d90d628$export$2e2bcd8739ae039), {
                    hsl: this.props.hsl,
                    hsv: this.props.hsv,
                    pointer: (0, $c5a48691949bb8c2$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $eb389715f5ad7937$export$2e2bcd8739ae039), {
                    direction: 'vertical',
                    hsl: this.props.hsl,
                    pointer: (0, $0d0b15d3a0f4d961$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.controls
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.top,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.previews
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $7279223390dfc751$export$2e2bcd8739ae039), {
                    rgb: this.props.rgb,
                    currentColor: this.state.currentColor
                })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
                    style: styles.actions
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $1b3097866e0ea79d$export$2e2bcd8739ae039), {
                    label: 'OK',
                    onClick: this.props.onAccept,
                    active: true
                }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $1b3097866e0ea79d$export$2e2bcd8739ae039), {
                    label: 'Cancel',
                    onClick: this.props.onCancel
                }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $4b84c18dde9798e1$export$2e2bcd8739ae039), {
                    onChange: this.props.onChange,
                    rgb: this.props.rgb,
                    hsv: this.props.hsv,
                    hex: this.props.hex
                }))))));
            }
        }
    ]);
    return Photoshop;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
$db178325c21ce8ba$export$4ed116dea8ad5956.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
};
$db178325c21ce8ba$export$4ed116dea8ad5956.defaultProps = {
    header: 'Color Picker',
    styles: {}
};
var $db178325c21ce8ba$export$2e2bcd8739ae039 = (0, $682238ac99fddc24$export$2e2bcd8739ae039)($db178325c21ce8ba$export$4ed116dea8ad5956);



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");



/* eslint-disable no-param-reassign */ 
var $6fFrj = parcelRequire("6fFrj");



var $39a75b66150ae729$export$a9bdb1170868e062 = function SketchFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            fields: {
                display: 'flex',
                paddingTop: '4px'
            },
            single: {
                flex: '1',
                paddingLeft: '6px'
            },
            alpha: {
                flex: '1',
                paddingLeft: '6px'
            },
            double: {
                flex: '2'
            },
            input: {
                width: '80%',
                padding: '4px 10% 3px',
                border: 'none',
                boxShadow: 'inset 0 0 0 1px #ccc',
                fontSize: '11px'
            },
            label: {
                display: 'block',
                textAlign: 'center',
                fontSize: '11px',
                color: '#222',
                paddingTop: '3px',
                paddingBottom: '4px',
                textTransform: 'capitalize'
            }
        },
        'disableAlpha': {
            alpha: {
                display: 'none'
            }
        }
    }, {
        disableAlpha: disableAlpha
    });
    var handleChange = function handleChange(data, e) {
        if (data.hex) $3e6623331a03b061$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            a: rgb.a,
            source: 'rgb'
        }, e);
        else if (data.a) {
            if (data.a < 0) data.a = 0;
            else if (data.a > 100) data.a = 100;
            data.a /= 100;
            onChange({
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: data.a,
                source: 'rgb'
            }, e);
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.fields,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
    })));
};
var $39a75b66150ae729$export$2e2bcd8739ae039 = $39a75b66150ae729$export$a9bdb1170868e062;



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");


var $81415b269d4aba37$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $81415b269d4aba37$export$cc78acae6744db3b = function SketchPresetColors(_ref) {
    var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            colors: {
                margin: '0 -10px',
                padding: '10px 0 0 10px',
                borderTop: '1px solid #eee',
                display: 'flex',
                flexWrap: 'wrap',
                position: 'relative'
            },
            swatchWrap: {
                width: '16px',
                height: '16px',
                margin: '0 10px 10px 0'
            },
            swatch: {
                borderRadius: '3px',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
            }
        },
        'no-presets': {
            colors: {
                display: 'none'
            }
        }
    }, {
        'no-presets': !colors || !colors.length
    });
    var handleClick = function handleClick(hex, e) {
        onClick({
            hex: hex,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.colors,
        className: 'flexbox-fix'
    }, colors.map(function(colorObjOrString) {
        var c = typeof colorObjOrString === 'string' ? {
            color: colorObjOrString
        } : colorObjOrString;
        var key = '' + c.color + (c.title || '');
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
            key: key,
            style: styles.swatchWrap
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b47f117f16e434a4$export$2e2bcd8739ae039), $81415b269d4aba37$var$_extends({}, c, {
            style: styles.swatch,
            onClick: handleClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
            }
        })));
    }));
};
$81415b269d4aba37$export$cc78acae6744db3b.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).shape({
            color: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
            title: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string
        })
    ])).isRequired
};
var $81415b269d4aba37$export$2e2bcd8739ae039 = $81415b269d4aba37$export$cc78acae6744db3b;


var $66d6c416ee068f43$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $66d6c416ee068f43$export$361fce2090be193f = function Sketch(_ref) {
    var width = _ref.width, rgb = _ref.rgb, hex = _ref.hex, hsv = _ref.hsv, hsl = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))((0, $5b09bd7873e0414d$export$2e2bcd8739ae039)({
        'default': $66d6c416ee068f43$var$_extends({
            picker: {
                width: width,
                padding: '10px 10px 0',
                boxSizing: 'initial',
                background: '#fff',
                borderRadius: '4px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
            },
            saturation: {
                width: '100%',
                paddingBottom: '75%',
                position: 'relative',
                overflow: 'hidden'
            },
            Saturation: {
                radius: '3px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            controls: {
                display: 'flex'
            },
            sliders: {
                padding: '4px 0',
                flex: '1'
            },
            color: {
                width: '24px',
                height: '24px',
                position: 'relative',
                marginTop: '4px',
                marginLeft: '4px',
                borderRadius: '3px'
            },
            activeColor: {
                absolute: '0px 0px 0px 0px',
                borderRadius: '2px',
                background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            hue: {
                position: 'relative',
                height: '10px',
                overflow: 'hidden'
            },
            Hue: {
                radius: '2px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            alpha: {
                position: 'relative',
                height: '10px',
                marginTop: '4px',
                overflow: 'hidden'
            },
            Alpha: {
                radius: '2px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            }
        }, passedStyles),
        'disableAlpha': {
            color: {
                height: '10px'
            },
            hue: {
                height: '10px'
            },
            alpha: {
                display: 'none'
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.picker,
        className: 'sketch-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $49832aed7d90d628$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.sliders
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $eb389715f5ad7937$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a9f7c72741cda63e$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        renderers: renderers,
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b588c516c7a68973$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.activeColor
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $39a75b66150ae729$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $81415b269d4aba37$export$2e2bcd8739ae039), {
        colors: presetColors,
        onClick: onChange,
        onSwatchHover: onSwatchHover
    }));
};
$66d6c416ee068f43$export$361fce2090be193f.propTypes = {
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
};
$66d6c416ee068f43$export$361fce2090be193f.defaultProps = {
    disableAlpha: false,
    width: 200,
    styles: {},
    presetColors: [
        '#D0021B',
        '#F5A623',
        '#F8E71C',
        '#8B572A',
        '#7ED321',
        '#417505',
        '#BD10E0',
        '#9013FE',
        '#4A90E2',
        '#50E3C2',
        '#B8E986',
        '#000000',
        '#4A4A4A',
        '#9B9B9B',
        '#FFFFFF'
    ]
};
var $66d6c416ee068f43$export$2e2bcd8739ae039 = (0, $682238ac99fddc24$export$2e2bcd8739ae039)($66d6c416ee068f43$export$361fce2090be193f);



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");




var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");

var $24539f083c41c9b0$export$5c11afa672411de4 = function SliderSwatch(_ref) {
    var hsl = _ref.hsl, offset = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, active = _ref.active, first = _ref.first, last = _ref.last;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            swatch: {
                height: '12px',
                background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
                cursor: 'pointer'
            }
        },
        'first': {
            swatch: {
                borderRadius: '2px 0 0 2px'
            }
        },
        'last': {
            swatch: {
                borderRadius: '0 2px 2px 0'
            }
        },
        'active': {
            swatch: {
                transform: 'scaleY(1.8)',
                borderRadius: '3.6px/2px'
            }
        }
    }, {
        active: active,
        first: first,
        last: last
    });
    var handleClick = function handleClick(e) {
        return onClick({
            h: hsl.h,
            s: 0.5,
            l: offset,
            source: 'hsl'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.swatch,
        onClick: handleClick
    });
};
var $24539f083c41c9b0$export$2e2bcd8739ae039 = $24539f083c41c9b0$export$5c11afa672411de4;


var $7c95d21a99277fcd$export$48f49e32c66cdd61 = function SliderSwatches(_ref) {
    var onClick = _ref.onClick, hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            swatches: {
                marginTop: '20px'
            },
            swatch: {
                boxSizing: 'border-box',
                width: '20%',
                paddingRight: '1px',
                float: 'left'
            },
            clear: {
                clear: 'both'
            }
        }
    });
    // Acceptible difference in floating point equality
    var epsilon = 0.1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $24539f083c41c9b0$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.80',
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $24539f083c41c9b0$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.65',
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $24539f083c41c9b0$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.50',
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $24539f083c41c9b0$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.35',
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $24539f083c41c9b0$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.20',
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.clear
    }));
};
var $7c95d21a99277fcd$export$2e2bcd8739ae039 = $7c95d21a99277fcd$export$48f49e32c66cdd61;



var $6fFrj = parcelRequire("6fFrj");

var $fe6446ec603d2085$export$9c10b52c64965f67 = function SliderPointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            picker: {
                width: '14px',
                height: '14px',
                borderRadius: '6px',
                transform: 'translate(-7px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.picker
    });
};
var $fe6446ec603d2085$export$2e2bcd8739ae039 = $fe6446ec603d2085$export$9c10b52c64965f67;


var $c07f79a99532dd77$export$472062a354075cee = function Slider(_ref) {
    var hsl = _ref.hsl, onChange = _ref.onChange, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))((0, $5b09bd7873e0414d$export$2e2bcd8739ae039)({
        'default': {
            hue: {
                height: '12px',
                position: 'relative'
            },
            Hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.wrap || {},
        className: 'slider-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $eb389715f5ad7937$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $7c95d21a99277fcd$export$2e2bcd8739ae039), {
        hsl: hsl,
        onClick: onChange
    })));
};
$c07f79a99532dd77$export$472062a354075cee.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
};
$c07f79a99532dd77$export$472062a354075cee.defaultProps = {
    pointer: (0, $fe6446ec603d2085$export$2e2bcd8739ae039),
    styles: {}
};
var $c07f79a99532dd77$export$2e2bcd8739ae039 = (0, $682238ac99fddc24$export$2e2bcd8739ae039)($c07f79a99532dd77$export$472062a354075cee);



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");






var $6fFrj = parcelRequire("6fFrj");



var $6fFrj = parcelRequire("6fFrj");



var $b92d3ccea71fbdc8$exports = {};
'use strict';
Object.defineProperty($b92d3ccea71fbdc8$exports, "__esModule", {
    value: true
});
var $b92d3ccea71fbdc8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $6fFrj = parcelRequire("6fFrj");
var $b92d3ccea71fbdc8$var$_react2 = $b92d3ccea71fbdc8$var$_interopRequireDefault($6fFrj);
function $b92d3ccea71fbdc8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b92d3ccea71fbdc8$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $b92d3ccea71fbdc8$var$DEFAULT_SIZE = 24;
$b92d3ccea71fbdc8$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? 'currentColor' : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $b92d3ccea71fbdc8$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $b92d3ccea71fbdc8$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $b92d3ccea71fbdc8$var$_objectWithoutProperties(_ref, [
        'fill',
        'width',
        'height',
        'style'
    ]);
    return $b92d3ccea71fbdc8$var$_react2.default.createElement('svg', $b92d3ccea71fbdc8$var$_extends({
        viewBox: '0 0 ' + $b92d3ccea71fbdc8$var$DEFAULT_SIZE + ' ' + $b92d3ccea71fbdc8$var$DEFAULT_SIZE,
        style: $b92d3ccea71fbdc8$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $b92d3ccea71fbdc8$var$_react2.default.createElement('path', {
        d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z'
    }));
};


var $7e4432817a6d5949$export$af5303fde6798b43 = function SwatchesColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            color: {
                width: '40px',
                height: '24px',
                cursor: 'pointer',
                background: color,
                marginBottom: '1px'
            },
            check: {
                color: $3e6623331a03b061$export$3609eb1d7e55dec(color),
                marginLeft: '8px',
                display: 'none'
            }
        },
        'first': {
            color: {
                overflow: 'hidden',
                borderRadius: '2px 2px 0 0'
            }
        },
        'last': {
            color: {
                overflow: 'hidden',
                borderRadius: '0 0 2px 2px'
            }
        },
        'active': {
            check: {
                display: 'block'
            }
        },
        'color-#FFFFFF': {
            color: {
                boxShadow: 'inset 0 0 0 1px #ddd'
            },
            check: {
                color: '#333'
            }
        },
        'transparent': {
            check: {
                color: '#333'
            }
        }
    }, {
        first: first,
        last: last,
        active: active,
        'color-#FFFFFF': color === '#FFFFFF',
        'transparent': color === 'transparent'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b47f117f16e434a4$export$2e2bcd8739ae039), {
        color: color,
        style: styles.color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: '0 0 4px ' + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.check
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b92d3ccea71fbdc8$exports))), null)));
};
var $7e4432817a6d5949$export$2e2bcd8739ae039 = $7e4432817a6d5949$export$af5303fde6798b43;


var $f1c2ad5a50e570d0$export$354a0399ec1ad469 = function SwatchesGroup(_ref) {
    var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group = _ref.group, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            group: {
                paddingBottom: '10px',
                width: '40px',
                float: 'left',
                marginRight: '10px'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.group
    }, (0, $1d23685c3fa78b12$export$2e2bcd8739ae039)(group, function(color, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $7e4432817a6d5949$export$2e2bcd8739ae039), {
            key: color,
            color: color,
            active: color.toLowerCase() === active,
            first: i === 0,
            last: i === group.length - 1,
            onClick: onClick,
            onSwatchHover: onSwatchHover
        });
    }));
};
var $f1c2ad5a50e570d0$export$2e2bcd8739ae039 = $f1c2ad5a50e570d0$export$354a0399ec1ad469;


var $cff690a204e3c089$export$81ebbfd13e06b049 = function Swatches(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))((0, $5b09bd7873e0414d$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                width: width,
                height: height
            },
            overflow: {
                height: height,
                overflowY: 'scroll'
            },
            body: {
                padding: '16px 0 6px 16px'
            },
            clear: {
                clear: 'both'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        return onChange({
            hex: data,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.picker,
        className: 'swatches-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $c8044453b0372755$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.overflow
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.body
    }, (0, $1d23685c3fa78b12$export$2e2bcd8739ae039)(colors, function(group) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $f1c2ad5a50e570d0$export$2e2bcd8739ae039), {
            key: group.toString(),
            group: group,
            active: hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.clear
    })))));
};
$cff690a204e3c089$export$81ebbfd13e06b049.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string)),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
};
$cff690a204e3c089$export$81ebbfd13e06b049.defaultProps = {
    width: 320,
    height: 240,
    colors: [
        [
            $ddd18194abc40eaa$export$a90204d1394caf30['900'],
            $ddd18194abc40eaa$export$a90204d1394caf30['700'],
            $ddd18194abc40eaa$export$a90204d1394caf30['500'],
            $ddd18194abc40eaa$export$a90204d1394caf30['300'],
            $ddd18194abc40eaa$export$a90204d1394caf30['100']
        ],
        [
            $ddd18194abc40eaa$export$47853bc718611763['900'],
            $ddd18194abc40eaa$export$47853bc718611763['700'],
            $ddd18194abc40eaa$export$47853bc718611763['500'],
            $ddd18194abc40eaa$export$47853bc718611763['300'],
            $ddd18194abc40eaa$export$47853bc718611763['100']
        ],
        [
            $ddd18194abc40eaa$export$e13cce2a2d16a9d4['900'],
            $ddd18194abc40eaa$export$e13cce2a2d16a9d4['700'],
            $ddd18194abc40eaa$export$e13cce2a2d16a9d4['500'],
            $ddd18194abc40eaa$export$e13cce2a2d16a9d4['300'],
            $ddd18194abc40eaa$export$e13cce2a2d16a9d4['100']
        ],
        [
            $ddd18194abc40eaa$export$51ef95b19086af57['900'],
            $ddd18194abc40eaa$export$51ef95b19086af57['700'],
            $ddd18194abc40eaa$export$51ef95b19086af57['500'],
            $ddd18194abc40eaa$export$51ef95b19086af57['300'],
            $ddd18194abc40eaa$export$51ef95b19086af57['100']
        ],
        [
            $ddd18194abc40eaa$export$3e6ccc7b8562d453['900'],
            $ddd18194abc40eaa$export$3e6ccc7b8562d453['700'],
            $ddd18194abc40eaa$export$3e6ccc7b8562d453['500'],
            $ddd18194abc40eaa$export$3e6ccc7b8562d453['300'],
            $ddd18194abc40eaa$export$3e6ccc7b8562d453['100']
        ],
        [
            $ddd18194abc40eaa$export$2aa0182783e7e9de['900'],
            $ddd18194abc40eaa$export$2aa0182783e7e9de['700'],
            $ddd18194abc40eaa$export$2aa0182783e7e9de['500'],
            $ddd18194abc40eaa$export$2aa0182783e7e9de['300'],
            $ddd18194abc40eaa$export$2aa0182783e7e9de['100']
        ],
        [
            $ddd18194abc40eaa$export$7b0d29b70b435c21['900'],
            $ddd18194abc40eaa$export$7b0d29b70b435c21['700'],
            $ddd18194abc40eaa$export$7b0d29b70b435c21['500'],
            $ddd18194abc40eaa$export$7b0d29b70b435c21['300'],
            $ddd18194abc40eaa$export$7b0d29b70b435c21['100']
        ],
        [
            $ddd18194abc40eaa$export$7474046f446842ee['900'],
            $ddd18194abc40eaa$export$7474046f446842ee['700'],
            $ddd18194abc40eaa$export$7474046f446842ee['500'],
            $ddd18194abc40eaa$export$7474046f446842ee['300'],
            $ddd18194abc40eaa$export$7474046f446842ee['100']
        ],
        [
            $ddd18194abc40eaa$export$8bf7dff220b82b4a['900'],
            $ddd18194abc40eaa$export$8bf7dff220b82b4a['700'],
            $ddd18194abc40eaa$export$8bf7dff220b82b4a['500'],
            $ddd18194abc40eaa$export$8bf7dff220b82b4a['300'],
            $ddd18194abc40eaa$export$8bf7dff220b82b4a['100']
        ],
        [
            '#194D33',
            $ddd18194abc40eaa$export$955a2ebd2fb142ae['700'],
            $ddd18194abc40eaa$export$955a2ebd2fb142ae['500'],
            $ddd18194abc40eaa$export$955a2ebd2fb142ae['300'],
            $ddd18194abc40eaa$export$955a2ebd2fb142ae['100']
        ],
        [
            $ddd18194abc40eaa$export$559a8c00376dc936['900'],
            $ddd18194abc40eaa$export$559a8c00376dc936['700'],
            $ddd18194abc40eaa$export$559a8c00376dc936['500'],
            $ddd18194abc40eaa$export$559a8c00376dc936['300'],
            $ddd18194abc40eaa$export$559a8c00376dc936['100']
        ],
        [
            $ddd18194abc40eaa$export$221d31baf2636aad['900'],
            $ddd18194abc40eaa$export$221d31baf2636aad['700'],
            $ddd18194abc40eaa$export$221d31baf2636aad['500'],
            $ddd18194abc40eaa$export$221d31baf2636aad['300'],
            $ddd18194abc40eaa$export$221d31baf2636aad['100']
        ],
        [
            $ddd18194abc40eaa$export$594c5a8758200c32['900'],
            $ddd18194abc40eaa$export$594c5a8758200c32['700'],
            $ddd18194abc40eaa$export$594c5a8758200c32['500'],
            $ddd18194abc40eaa$export$594c5a8758200c32['300'],
            $ddd18194abc40eaa$export$594c5a8758200c32['100']
        ],
        [
            $ddd18194abc40eaa$export$7c1ecc66643fdbd6['900'],
            $ddd18194abc40eaa$export$7c1ecc66643fdbd6['700'],
            $ddd18194abc40eaa$export$7c1ecc66643fdbd6['500'],
            $ddd18194abc40eaa$export$7c1ecc66643fdbd6['300'],
            $ddd18194abc40eaa$export$7c1ecc66643fdbd6['100']
        ],
        [
            $ddd18194abc40eaa$export$ad766f34ace1cafd['900'],
            $ddd18194abc40eaa$export$ad766f34ace1cafd['700'],
            $ddd18194abc40eaa$export$ad766f34ace1cafd['500'],
            $ddd18194abc40eaa$export$ad766f34ace1cafd['300'],
            $ddd18194abc40eaa$export$ad766f34ace1cafd['100']
        ],
        [
            $ddd18194abc40eaa$export$1ceed3dd9ec11704['900'],
            $ddd18194abc40eaa$export$1ceed3dd9ec11704['700'],
            $ddd18194abc40eaa$export$1ceed3dd9ec11704['500'],
            $ddd18194abc40eaa$export$1ceed3dd9ec11704['300'],
            $ddd18194abc40eaa$export$1ceed3dd9ec11704['100']
        ],
        [
            $ddd18194abc40eaa$export$b6e6178d3f565007['900'],
            $ddd18194abc40eaa$export$b6e6178d3f565007['700'],
            $ddd18194abc40eaa$export$b6e6178d3f565007['500'],
            $ddd18194abc40eaa$export$b6e6178d3f565007['300'],
            $ddd18194abc40eaa$export$b6e6178d3f565007['100']
        ],
        [
            $ddd18194abc40eaa$export$7c2da42d08c019c9['900'],
            $ddd18194abc40eaa$export$7c2da42d08c019c9['700'],
            $ddd18194abc40eaa$export$7c2da42d08c019c9['500'],
            $ddd18194abc40eaa$export$7c2da42d08c019c9['300'],
            $ddd18194abc40eaa$export$7c2da42d08c019c9['100']
        ],
        [
            '#000000',
            '#525252',
            '#969696',
            '#D9D9D9',
            '#FFFFFF'
        ]
    ],
    styles: {}
};
var $cff690a204e3c089$export$2e2bcd8739ae039 = (0, $682238ac99fddc24$export$2e2bcd8739ae039)($cff690a204e3c089$export$81ebbfd13e06b049);



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");





var $0a4545e4b6d3c674$export$9e389cdad32a5b7a = function Twitter(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))((0, $5b09bd7873e0414d$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                border: '0 solid rgba(0,0,0,0.25)',
                boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
                borderRadius: '4px',
                position: 'relative'
            },
            body: {
                padding: '15px 9px 9px 15px'
            },
            label: {
                fontSize: '18px',
                color: '#fff'
            },
            triangle: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 9px 10px 9px',
                borderColor: 'transparent transparent #fff transparent',
                position: 'absolute'
            },
            triangleShadow: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 9px 10px 9px',
                borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
                position: 'absolute'
            },
            hash: {
                background: '#F0F0F0',
                height: '30px',
                width: '30px',
                borderRadius: '4px 0 0 4px',
                float: 'left',
                color: '#98A1A4',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            input: {
                width: '100px',
                fontSize: '14px',
                color: '#666',
                border: '0px',
                outline: 'none',
                height: '28px',
                boxShadow: 'inset 0 0 0 1px #F0F0F0',
                boxSizing: 'content-box',
                borderRadius: '0 4px 4px 0',
                float: 'left',
                paddingLeft: '8px'
            },
            swatch: {
                width: '30px',
                height: '30px',
                float: 'left',
                borderRadius: '4px',
                margin: '0 6px 6px 0'
            },
            clear: {
                clear: 'both'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            },
            triangleShadow: {
                display: 'none'
            }
        },
        'top-left-triangle': {
            triangle: {
                top: '-10px',
                left: '12px'
            },
            triangleShadow: {
                top: '-11px',
                left: '12px'
            }
        },
        'top-right-triangle': {
            triangle: {
                top: '-10px',
                right: '12px'
            },
            triangleShadow: {
                top: '-11px',
                right: '12px'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide',
        'top-left-triangle': triangle === 'top-left',
        'top-right-triangle': triangle === 'top-right'
    });
    var handleChange = function handleChange(hexcode, e) {
        $3e6623331a03b061$export$944f75ec5697b362(hexcode) && onChange({
            hex: hexcode,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.card,
        className: 'twitter-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.body
    }, (0, $1d23685c3fa78b12$export$2e2bcd8739ae039)(colors, function(c, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b47f117f16e434a4$export$2e2bcd8739ae039), {
            key: i,
            color: c,
            hex: c,
            style: styles.swatch,
            onClick: handleChange,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: '0 0 4px ' + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.hash
    }, '#'), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        label: null,
        style: {
            input: styles.input
        },
        value: hex.replace('#', ''),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.clear
    })));
};
$0a4545e4b6d3c674$export$9e389cdad32a5b7a.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    ]),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf([
        'hide',
        'top-left',
        'top-right'
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
};
$0a4545e4b6d3c674$export$9e389cdad32a5b7a.defaultProps = {
    width: 276,
    colors: [
        '#FF6900',
        '#FCB900',
        '#7BDCB5',
        '#00D084',
        '#8ED1FC',
        '#0693E3',
        '#ABB8C3',
        '#EB144C',
        '#F78DA7',
        '#9900EF'
    ],
    triangle: 'top-left',
    styles: {}
};
var $0a4545e4b6d3c674$export$2e2bcd8739ae039 = (0, $682238ac99fddc24$export$2e2bcd8739ae039)($0a4545e4b6d3c674$export$9e389cdad32a5b7a);



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");




var $6fFrj = parcelRequire("6fFrj");


var $cgjHV = parcelRequire("cgjHV");
var $ad41ba5bcae251cd$export$a928e0fe8b70765d = function GooglePointerCircle(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            picker: {
                width: '20px',
                height: '20px',
                borderRadius: '22px',
                border: '2px #fff solid',
                transform: 'translate(-12px, -13px)',
                background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.picker
    });
};
$ad41ba5bcae251cd$export$a928e0fe8b70765d.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    })
};
$ad41ba5bcae251cd$export$a928e0fe8b70765d.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $ad41ba5bcae251cd$export$2e2bcd8739ae039 = $ad41ba5bcae251cd$export$a928e0fe8b70765d;



var $6fFrj = parcelRequire("6fFrj");


var $cgjHV = parcelRequire("cgjHV");
var $47d8ac7cb80dae5e$export$9de61b9626feed9a = function GooglePointer(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            picker: {
                width: '20px',
                height: '20px',
                borderRadius: '22px',
                transform: 'translate(-10px, -7px)',
                background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
                border: '2px white solid'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.picker
    });
};
$47d8ac7cb80dae5e$export$9de61b9626feed9a.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    })
};
$47d8ac7cb80dae5e$export$9de61b9626feed9a.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $47d8ac7cb80dae5e$export$2e2bcd8739ae039 = $47d8ac7cb80dae5e$export$9de61b9626feed9a;



var $6fFrj = parcelRequire("6fFrj");



var $1756fbfc65c168e2$export$e50902ed332e5599 = function GoogleFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, hsv = _ref.hsv;
    var handleChange = function handleChange(data, e) {
        if (data.hex) $3e6623331a03b061$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.rgb) {
            var values = data.rgb.split(',');
            $3e6623331a03b061$export$e76ec4c5b3cadd73(data.rgb, 'rgb') && onChange({
                r: values[0],
                g: values[1],
                b: values[2],
                a: 1,
                source: 'rgb'
            }, e);
        } else if (data.hsv) {
            var _values = data.hsv.split(',');
            if ($3e6623331a03b061$export$e76ec4c5b3cadd73(data.hsv, 'hsv')) {
                _values[2] = _values[2].replace('%', '');
                _values[1] = _values[1].replace('%', '');
                _values[0] = _values[0].replace("\xb0", '');
                if (_values[1] == 1) _values[1] = 0.01;
                else if (_values[2] == 1) _values[2] = 0.01;
                onChange({
                    h: Number(_values[0]),
                    s: Number(_values[1]),
                    v: Number(_values[2]),
                    source: 'hsv'
                }, e);
            }
        } else if (data.hsl) {
            var _values2 = data.hsl.split(',');
            if ($3e6623331a03b061$export$e76ec4c5b3cadd73(data.hsl, 'hsl')) {
                _values2[2] = _values2[2].replace('%', '');
                _values2[1] = _values2[1].replace('%', '');
                _values2[0] = _values2[0].replace("\xb0", '');
                if (hsvValue[1] == 1) hsvValue[1] = 0.01;
                else if (hsvValue[2] == 1) hsvValue[2] = 0.01;
                onChange({
                    h: Number(_values2[0]),
                    s: Number(_values2[1]),
                    v: Number(_values2[2]),
                    source: 'hsl'
                }, e);
            }
        }
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))({
        'default': {
            wrap: {
                display: 'flex',
                height: '100px',
                marginTop: '4px'
            },
            fields: {
                width: '100%'
            },
            column: {
                paddingTop: '10px',
                display: 'flex',
                justifyContent: 'space-between'
            },
            double: {
                padding: '0px 4.4px',
                boxSizing: 'border-box'
            },
            input: {
                width: '100%',
                height: '38px',
                boxSizing: 'border-box',
                padding: '4px 10% 3px',
                textAlign: 'center',
                border: '1px solid #dadce0',
                fontSize: '11px',
                textTransform: 'lowercase',
                borderRadius: '5px',
                outline: 'none',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            input2: {
                height: '38px',
                width: '100%',
                border: '1px solid #dadce0',
                boxSizing: 'border-box',
                fontSize: '11px',
                textTransform: 'lowercase',
                borderRadius: '5px',
                outline: 'none',
                paddingLeft: '10px',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            label: {
                textAlign: 'center',
                fontSize: '12px',
                background: '#fff',
                position: 'absolute',
                textTransform: 'uppercase',
                color: '#3c4043',
                width: '35px',
                top: '-6px',
                left: '0',
                right: '0',
                marginLeft: 'auto',
                marginRight: 'auto',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            label2: {
                left: '10px',
                textAlign: 'center',
                fontSize: '12px',
                background: '#fff',
                position: 'absolute',
                textTransform: 'uppercase',
                color: '#3c4043',
                width: '32px',
                top: '-6px',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            single: {
                flexGrow: '1',
                margin: '0px 4.4px'
            }
        }
    });
    var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
    var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
    var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.wrap,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.column
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'rgb',
        value: rgbValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'hsv',
        value: hsvValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a1e416e6199622f7$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'hsl',
        value: hslValue,
        onChange: handleChange
    })))));
};
var $1756fbfc65c168e2$export$2e2bcd8739ae039 = $1756fbfc65c168e2$export$e50902ed332e5599;


var $91273bf92d1ece57$export$347eee6e8bf67997 = function Google(_ref) {
    var width = _ref.width, onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bd96d54b29ffe643$exports)))((0, $5b09bd7873e0414d$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                width: width,
                background: '#fff',
                border: '1px solid #dfe1e5',
                boxSizing: 'initial',
                display: 'flex',
                flexWrap: 'wrap',
                borderRadius: '8px 8px 0px 0px'
            },
            head: {
                height: '57px',
                width: '100%',
                paddingTop: '16px',
                paddingBottom: '16px',
                paddingLeft: '16px',
                fontSize: '20px',
                boxSizing: 'border-box',
                fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
            },
            saturation: {
                width: '70%',
                padding: '0px',
                position: 'relative',
                overflow: 'hidden'
            },
            swatch: {
                width: '30%',
                height: '228px',
                padding: '0px',
                background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
                position: 'relative',
                overflow: 'hidden'
            },
            body: {
                margin: 'auto',
                width: '95%'
            },
            controls: {
                display: 'flex',
                boxSizing: 'border-box',
                height: '52px',
                paddingTop: '22px'
            },
            color: {
                width: '32px'
            },
            hue: {
                height: '8px',
                position: 'relative',
                margin: '0px 16px 0px 16px',
                width: '100%'
            },
            Hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.picker,
        className: 'google-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.head
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.swatch
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $49832aed7d90d628$export$2e2bcd8739ae039), {
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $ad41ba5bcae251cd$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $eb389715f5ad7937$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        radius: '4px',
        pointer: (0, $47d8ac7cb80dae5e$export$2e2bcd8739ae039),
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $1756fbfc65c168e2$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
    })));
};
$91273bf92d1ece57$export$347eee6e8bf67997.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string
};
$91273bf92d1ece57$export$347eee6e8bf67997.defaultProps = {
    width: 652,
    styles: {},
    header: 'Color picker'
};
var $91273bf92d1ece57$export$2e2bcd8739ae039 = (0, $682238ac99fddc24$export$2e2bcd8739ae039)($91273bf92d1ece57$export$347eee6e8bf67997);





const $0a85c5a5bac8f0b3$export$a5a6e0b888b2c992 = {
    active: true,
    afterBuffer: null,
    beforeBuffer: null,
    color: '#03a9f4',
    description: '',
    duration: 30,
    maxEvents: null,
    minNotice: null,
    name: '',
    timezone: null
};
const $0a85c5a5bac8f0b3$export$b5bc26e198ce73d0 = [
    {
        value: 5,
        label: '5 min'
    },
    {
        value: 15,
        label: '15 min'
    },
    {
        value: 30,
        label: '30 min'
    },
    {
        value: 35,
        label: '35 min'
    },
    {
        value: 60,
        label: '1 hour'
    },
    {
        value: 90,
        label: '1 hours 30 min'
    },
    {
        value: 120,
        label: '2 hours'
    },
    {
        value: 150,
        label: '2 hours 30 min'
    },
    {
        value: 180,
        label: '3 hours'
    }
];
const $0a85c5a5bac8f0b3$export$548958c4e5e3deae = {
    lapse: 60,
    calendar: [
        {
            value: {
                hour: 0,
                minutes: 0
            },
            label: '0:00'
        },
        {
            value: {
                hour: 1,
                minutes: 0
            },
            label: '1:00'
        },
        {
            value: {
                hour: 2,
                minutes: 0
            },
            label: '2:00'
        },
        {
            value: {
                hour: 3,
                minutes: 0
            },
            label: '3:00'
        },
        {
            value: {
                hour: 4,
                minutes: 0
            },
            label: '4:00'
        },
        {
            value: {
                hour: 5,
                minutes: 0
            },
            label: '5:00'
        },
        {
            value: {
                hour: 6,
                minutes: 0
            },
            label: '6:00'
        },
        {
            value: {
                hour: 7,
                minutes: 0
            },
            label: '7:00'
        },
        {
            value: {
                hour: 8,
                minutes: 0
            },
            label: '8:00'
        },
        {
            value: {
                hour: 9,
                minutes: 0
            },
            label: '9:00'
        },
        {
            value: {
                hour: 10,
                minutes: 0
            },
            label: '10:00'
        },
        {
            value: {
                hour: 11,
                minutes: 0
            },
            label: '11:00'
        },
        {
            value: {
                hour: 12,
                minutes: 0
            },
            label: '12:00'
        },
        {
            value: {
                hour: 13,
                minutes: 0
            },
            label: '13:00'
        },
        {
            value: {
                hour: 14,
                minutes: 0
            },
            label: '14:00'
        },
        {
            value: {
                hour: 15,
                minutes: 0
            },
            label: '15:00'
        },
        {
            value: {
                hour: 16,
                minutes: 0
            },
            label: '16:00'
        },
        {
            value: {
                hour: 17,
                minutes: 0
            },
            label: '17:00'
        },
        {
            value: {
                hour: 18,
                minutes: 0
            },
            label: '18:00'
        },
        {
            value: {
                hour: 19,
                minutes: 0
            },
            label: '19:00'
        },
        {
            value: {
                hour: 20,
                minutes: 0
            },
            label: '20:00'
        },
        {
            value: {
                hour: 21,
                minutes: 0
            },
            label: '21:00'
        },
        {
            value: {
                hour: 22,
                minutes: 0
            },
            label: '22:00'
        },
        {
            value: {
                hour: 23,
                minutes: 0
            },
            label: '23:00'
        }
    ]
};
const $0a85c5a5bac8f0b3$export$8f45430ccf837300 = [
    '#f44336',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#2196f3',
    '#03a9f4',
    '#00bcd4',
    '#009688',
    '#4caf50',
    '#8bc34a',
    '#cddc39',
    '#ffeb3b',
    '#ffc107',
    '#ff9800',
    '#ff5722',
    '#795548',
    '#607d8b'
];
const $0a85c5a5bac8f0b3$export$3cf5dda4201cc0f2 = [
    {
        value: 'SUNDAY',
        label: 'Sunday'
    },
    {
        value: 'MONDAY',
        label: 'Monday'
    },
    {
        value: 'TUESDAY',
        label: 'Tuesday'
    },
    {
        value: 'WEDNESDAY',
        label: 'Wednesday'
    },
    {
        value: 'THURSDAY',
        label: 'Thursday'
    },
    {
        value: 'FRIDAY',
        label: 'Friday'
    },
    {
        value: 'SATURDAY',
        label: 'Saturday'
    }
];


var $6fe7c737f0e4330f$export$34e0f9847d4c02dd;
var $6fe7c737f0e4330f$export$a3bc9b8ed74fc;
var $6fe7c737f0e4330f$export$f0245a1bd6566a44;
var $6fe7c737f0e4330f$export$b7e3ae3d7c15e42e;
var $6fe7c737f0e4330f$export$fb184b623420d9be;
$6fe7c737f0e4330f$export$34e0f9847d4c02dd = `X_t_aa_container`;
$6fe7c737f0e4330f$export$a3bc9b8ed74fc = `X_t_aa_error`;
$6fe7c737f0e4330f$export$f0245a1bd6566a44 = `X_t_aa_errorLabel`;
$6fe7c737f0e4330f$export$b7e3ae3d7c15e42e = `X_t_aa_input`;
$6fe7c737f0e4330f$export$fb184b623420d9be = `X_t_aa_title`;



const { TextArea: $4cd66e74fa775f7f$var$TextArea } = (0, $1fb834916a156dcf$export$2e2bcd8739ae039);
const $4cd66e74fa775f7f$var$EventTypeSettingsDescription = ({ data: data, itsOK: itsOK, setItsOK: setItsOK, updateSettings: updateSettings })=>{
    const handleChange = ({ target: { name: name, value: value } })=>updateSettings(name, value);
    const { name: name, description: description, color: color } = data;
    const { showErrors: showErrors } = itsOK;
    (0, $6fFrj.useEffect)(()=>{
        if (name.trim() !== '' && color.trim() !== '') setItsOK({
            ...itsOK,
            descriptionTab: true,
            showErrors: false
        });
        else setItsOK({
            ...itsOK,
            descriptionTab: false
        });
    }, [
        name,
        description,
        color
    ]);
    return (0, $bb3TF.jsxs)("div", {
        className: $6fe7c737f0e4330f$export$34e0f9847d4c02dd,
        children: [
            (0, $bb3TF.jsx)("p", {
                className: $6fe7c737f0e4330f$export$fb184b623420d9be,
                children: "Appointment Type Name*"
            }),
            (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                className: `${$6fe7c737f0e4330f$export$b7e3ae3d7c15e42e} ${showErrors && name.trim() === '' && $6fe7c737f0e4330f$export$a3bc9b8ed74fc}`,
                name: "name",
                placeholder: "",
                value: name,
                onChange: handleChange
            }),
            showErrors && name.trim() === '' && (0, $bb3TF.jsx)("p", {
                className: $6fe7c737f0e4330f$export$f0245a1bd6566a44,
                children: "Field needed to continue"
            }),
            (0, $bb3TF.jsx)("p", {
                className: $6fe7c737f0e4330f$export$fb184b623420d9be,
                children: "Description"
            }),
            (0, $bb3TF.jsx)($4cd66e74fa775f7f$var$TextArea, {
                placeholder: "",
                name: "description",
                className: `${$6fe7c737f0e4330f$export$b7e3ae3d7c15e42e}`,
                autoSize: {
                    minRows: 5,
                    maxRows: 8
                },
                value: description,
                onChange: handleChange
            }),
            (0, $bb3TF.jsx)("p", {
                className: $6fe7c737f0e4330f$export$fb184b623420d9be,
                children: "Color*"
            }),
            (0, $bb3TF.jsx)((0, $72fd7733944951d9$export$2e2bcd8739ae039), {
                width: "100%",
                circleSize: 20,
                color: color,
                onChange: (col)=>{
                    updateSettings('color', col.hex);
                },
                colors: (0, $0a85c5a5bac8f0b3$export$8f45430ccf837300)
            }),
            showErrors && color.trim() === '' && (0, $bb3TF.jsx)("p", {
                style: {
                    marginTop: 20
                },
                className: $6fe7c737f0e4330f$export$f0245a1bd6566a44,
                children: "Field needed to continue"
            })
        ]
    });
};
var $4cd66e74fa775f7f$export$2e2bcd8739ae039 = $4cd66e74fa775f7f$var$EventTypeSettingsDescription;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $6Sgv0 = parcelRequire("6Sgv0");


function $7a2c209832ffd573$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $368fc019dd8ff8b8$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $6g7hW = parcelRequire("6g7hW");

var $9VR4w = parcelRequire("9VR4w");

var $8HiBB = parcelRequire("8HiBB");

var $2tFMC = parcelRequire("2tFMC");

var $d60oy = parcelRequire("d60oy");
function $b56aff013c54f5f9$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b56aff013c54f5f9$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



var $hEAnx = parcelRequire("hEAnx");
function $5d4b78f32a0ca363$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $b56aff013c54f5f9$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $d60oy.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $d60oy.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $hEAnx.default)(this, result);
    };
}



var $6fFrj = parcelRequire("6fFrj");



var $6fFrj = parcelRequire("6fFrj");
var $d787f36c95e388b1$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $d787f36c95e388b1$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$d787f36c95e388b1$exports = $d787f36c95e388b1$var$invariant;


var $0ea07de5bc64a4a2$var$noop = function noop() {};
function $0ea07de5bc64a4a2$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $0ea07de5bc64a4a2$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $0ea07de5bc64a4a2$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$0ea07de5bc64a4a2$export$26cbf8c37e721e67(prop)] = $0ea07de5bc64a4a2$var$noop;
        var handler;
    });
    return propTypes;
}
function $0ea07de5bc64a4a2$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $0ea07de5bc64a4a2$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $0ea07de5bc64a4a2$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $c3df6cecfbbb93ca$var$_toPropertyKey(arg) {
    var key = $c3df6cecfbbb93ca$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $c3df6cecfbbb93ca$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c3df6cecfbbb93ca$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $6fFrj.useRef)(propValue !== undefined);
    var _useState = (0, $6fFrj.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $6fFrj.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $c3df6cecfbbb93ca$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$0ea07de5bc64a4a2$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $368fc019dd8ff8b8$export$2e2bcd8739ae039)(_ref, [
            $0ea07de5bc64a4a2$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($c3df6cecfbbb93ca$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $c3df6cecfbbb93ca$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}





var $jEgcK = parcelRequire("jEgcK");
function $9363c3d8c054ab93$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $jEgcK.default)(subClass, superClass);
}



var $6fFrj = parcelRequire("6fFrj");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $32ab9f5888e8f60e$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $32ab9f5888e8f60e$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $32ab9f5888e8f60e$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$32ab9f5888e8f60e$var$componentWillMount.__suppressDeprecationWarning = true;
$32ab9f5888e8f60e$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$32ab9f5888e8f60e$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $32ab9f5888e8f60e$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $32ab9f5888e8f60e$var$componentWillMount;
        prototype.componentWillReceiveProps = $32ab9f5888e8f60e$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $32ab9f5888e8f60e$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $779df5be45af0d78$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $779df5be45af0d78$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $0ea07de5bc64a4a2$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($0ea07de5bc64a4a2$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($d787f36c95e388b1$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $9363c3d8c054ab93$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $876165ca1d22d290$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$0ea07de5bc64a4a2$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $876165ca1d22d290$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$0ea07de5bc64a4a2$export$12ae2baa35bd9b8b(props, key) && $0ea07de5bc64a4a2$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$0ea07de5bc64a4a2$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $368fc019dd8ff8b8$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Component, (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
    (0, $32ab9f5888e8f60e$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $876165ca1d22d290$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $0ea07de5bc64a4a2$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(UncontrolledComponent, (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $779df5be45af0d78$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $779df5be45af0d78$export$2e2bcd8739ae039(newComponent, (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}




function $946ef30d2f9a32f9$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $946ef30d2f9a32f9$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $946ef30d2f9a32f9$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $946ef30d2f9a32f9$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $946ef30d2f9a32f9$export$2e2bcd8739ae039 = $946ef30d2f9a32f9$export$4f5d2d50c9deca37;



var $cgjHV = parcelRequire("cgjHV");

var $7cdbb81bd69b4527$var$MILI = 'milliseconds', $7cdbb81bd69b4527$var$SECONDS = 'seconds', $7cdbb81bd69b4527$var$MINUTES = 'minutes', $7cdbb81bd69b4527$var$HOURS = 'hours', $7cdbb81bd69b4527$var$DAY = 'day', $7cdbb81bd69b4527$var$WEEK = 'week', $7cdbb81bd69b4527$var$MONTH = 'month', $7cdbb81bd69b4527$var$YEAR = 'year', $7cdbb81bd69b4527$var$DECADE = 'decade', $7cdbb81bd69b4527$var$CENTURY = 'century';
var $7cdbb81bd69b4527$var$multiplierMilli = {
    'milliseconds': 1,
    'seconds': 1000,
    'minutes': 60000,
    'hours': 3600000,
    'day': 86400000,
    'week': 604800000
};
var $7cdbb81bd69b4527$var$multiplierMonth = {
    'month': 1,
    'year': 12,
    'decade': 120,
    'century': 1200
};
function $7cdbb81bd69b4527$var$daysOf(year) {
    return [
        31,
        $7cdbb81bd69b4527$var$daysInFeb(year),
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
}
function $7cdbb81bd69b4527$var$daysInFeb(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0 ? 29 : 28;
}
function $7cdbb81bd69b4527$export$e16d8520af44a096(d, num, unit) {
    d = new Date(d);
    switch(unit){
        case $7cdbb81bd69b4527$var$MILI:
        case $7cdbb81bd69b4527$var$SECONDS:
        case $7cdbb81bd69b4527$var$MINUTES:
        case $7cdbb81bd69b4527$var$HOURS:
        case $7cdbb81bd69b4527$var$DAY:
        case $7cdbb81bd69b4527$var$WEEK:
            return $7cdbb81bd69b4527$var$addMillis(d, num * $7cdbb81bd69b4527$var$multiplierMilli[unit]);
        case $7cdbb81bd69b4527$var$MONTH:
        case $7cdbb81bd69b4527$var$YEAR:
        case $7cdbb81bd69b4527$var$DECADE:
        case $7cdbb81bd69b4527$var$CENTURY:
            return $7cdbb81bd69b4527$var$addMonths(d, num * $7cdbb81bd69b4527$var$multiplierMonth[unit]);
    }
    throw new TypeError('Invalid units: "' + unit + '"');
}
function $7cdbb81bd69b4527$var$addMillis(d, num) {
    var nextDate = new Date(+d + num);
    return $7cdbb81bd69b4527$var$solveDST(d, nextDate);
}
function $7cdbb81bd69b4527$var$addMonths(d, num) {
    var year = d.getFullYear(), month = d.getMonth(), day = d.getDate(), totalMonths = year * 12 + month + num, nextYear = Math.trunc(totalMonths / 12), nextMonth = totalMonths % 12, nextDay = Math.min(day, $7cdbb81bd69b4527$var$daysOf(nextYear)[nextMonth]);
    var nextDate = new Date(d);
    nextDate.setFullYear(nextYear);
    // To avoid a bug when sets the Feb month
    // with a date > 28 or date > 29 (leap year)
    nextDate.setDate(1);
    nextDate.setMonth(nextMonth);
    nextDate.setDate(nextDay);
    return nextDate;
}
function $7cdbb81bd69b4527$var$solveDST(currentDate, nextDate) {
    var currentOffset = currentDate.getTimezoneOffset(), nextOffset = nextDate.getTimezoneOffset();
    // if is DST, add the difference in minutes
    // else the difference is zero
    var diffMinutes = nextOffset - currentOffset;
    return new Date(+nextDate + diffMinutes * $7cdbb81bd69b4527$var$multiplierMilli['minutes']);
}
function $7cdbb81bd69b4527$export$4e2d2ead65e5f7e3(d, num, unit) {
    return $7cdbb81bd69b4527$export$e16d8520af44a096(d, -num, unit);
}
function $7cdbb81bd69b4527$export$38d7278c783c77a7(d, unit, firstOfWeek) {
    d = new Date(d);
    switch(unit){
        case $7cdbb81bd69b4527$var$CENTURY:
        case $7cdbb81bd69b4527$var$DECADE:
        case $7cdbb81bd69b4527$var$YEAR:
            d = $7cdbb81bd69b4527$export$af5de1609f06c8e6(d, 0);
        case $7cdbb81bd69b4527$var$MONTH:
            d = $7cdbb81bd69b4527$export$324d90190a8b822a(d, 1);
        case $7cdbb81bd69b4527$var$WEEK:
        case $7cdbb81bd69b4527$var$DAY:
            d = $7cdbb81bd69b4527$export$8d468796d69cdad1(d, 0);
        case $7cdbb81bd69b4527$var$HOURS:
            d = $7cdbb81bd69b4527$export$666252b437cce0c7(d, 0);
        case $7cdbb81bd69b4527$var$MINUTES:
            d = $7cdbb81bd69b4527$export$4792e48abc550fa1(d, 0);
        case $7cdbb81bd69b4527$var$SECONDS:
            d = $7cdbb81bd69b4527$export$9a27fac83d67afd3(d, 0);
    }
    if (unit === $7cdbb81bd69b4527$var$DECADE) d = $7cdbb81bd69b4527$export$4e2d2ead65e5f7e3(d, $7cdbb81bd69b4527$export$31803937850fb2da(d) % 10, 'year');
    if (unit === $7cdbb81bd69b4527$var$CENTURY) d = $7cdbb81bd69b4527$export$4e2d2ead65e5f7e3(d, $7cdbb81bd69b4527$export$31803937850fb2da(d) % 100, 'year');
    if (unit === $7cdbb81bd69b4527$var$WEEK) d = $7cdbb81bd69b4527$export$b7f7efbe9ab39b25(d, 0, firstOfWeek);
    return d;
}
function $7cdbb81bd69b4527$export$2d3c3037220ab47a(d, unit, firstOfWeek) {
    d = new Date(d);
    d = $7cdbb81bd69b4527$export$38d7278c783c77a7(d, unit, firstOfWeek);
    switch(unit){
        case $7cdbb81bd69b4527$var$CENTURY:
        case $7cdbb81bd69b4527$var$DECADE:
        case $7cdbb81bd69b4527$var$YEAR:
        case $7cdbb81bd69b4527$var$MONTH:
        case $7cdbb81bd69b4527$var$WEEK:
            d = $7cdbb81bd69b4527$export$e16d8520af44a096(d, 1, unit);
            d = $7cdbb81bd69b4527$export$4e2d2ead65e5f7e3(d, 1, $7cdbb81bd69b4527$var$DAY);
            d.setHours(23, 59, 59, 999);
            break;
        case $7cdbb81bd69b4527$var$DAY:
            d.setHours(23, 59, 59, 999);
            break;
        case $7cdbb81bd69b4527$var$HOURS:
        case $7cdbb81bd69b4527$var$MINUTES:
        case $7cdbb81bd69b4527$var$SECONDS:
            d = $7cdbb81bd69b4527$export$e16d8520af44a096(d, 1, unit);
            d = $7cdbb81bd69b4527$export$4e2d2ead65e5f7e3(d, 1, $7cdbb81bd69b4527$var$MILI);
    }
    return d;
}
var $7cdbb81bd69b4527$export$9663ddc1cf085b32 = $7cdbb81bd69b4527$var$createComparer(function(a, b) {
    return a === b;
});
var $7cdbb81bd69b4527$export$9bc858421bf255d1 = $7cdbb81bd69b4527$var$createComparer(function(a, b) {
    return a !== b;
});
var $7cdbb81bd69b4527$export$dafeacbfe3530cd9 = $7cdbb81bd69b4527$var$createComparer(function(a, b) {
    return a > b;
});
var $7cdbb81bd69b4527$export$aac79e834d1b4aed = $7cdbb81bd69b4527$var$createComparer(function(a, b) {
    return a >= b;
});
var $7cdbb81bd69b4527$export$b961576059b7aeb6 = $7cdbb81bd69b4527$var$createComparer(function(a, b) {
    return a < b;
});
var $7cdbb81bd69b4527$export$489c007ed603c05d = $7cdbb81bd69b4527$var$createComparer(function(a, b) {
    return a <= b;
});
function $7cdbb81bd69b4527$export$96ec731ed4dcb222() {
    return new Date(Math.min.apply(Math, arguments));
}
function $7cdbb81bd69b4527$export$8960430cfd85939f() {
    return new Date(Math.max.apply(Math, arguments));
}
function $7cdbb81bd69b4527$export$ddf89a9c5af38f94(day, min, max, unit) {
    unit = unit || 'day';
    return (!min || $7cdbb81bd69b4527$export$aac79e834d1b4aed(day, min, unit)) && (!max || $7cdbb81bd69b4527$export$489c007ed603c05d(day, max, unit));
}
var $7cdbb81bd69b4527$export$9a27fac83d67afd3 = $7cdbb81bd69b4527$var$createAccessor('Milliseconds');
var $7cdbb81bd69b4527$export$4792e48abc550fa1 = $7cdbb81bd69b4527$var$createAccessor('Seconds');
var $7cdbb81bd69b4527$export$666252b437cce0c7 = $7cdbb81bd69b4527$var$createAccessor('Minutes');
var $7cdbb81bd69b4527$export$8d468796d69cdad1 = $7cdbb81bd69b4527$var$createAccessor('Hours');
var $7cdbb81bd69b4527$export$d2d39d1adcc883a2 = $7cdbb81bd69b4527$var$createAccessor('Day');
var $7cdbb81bd69b4527$export$324d90190a8b822a = $7cdbb81bd69b4527$var$createAccessor('Date');
var $7cdbb81bd69b4527$export$af5de1609f06c8e6 = $7cdbb81bd69b4527$var$createAccessor('Month');
var $7cdbb81bd69b4527$export$31803937850fb2da = $7cdbb81bd69b4527$var$createAccessor('FullYear');
function $7cdbb81bd69b4527$export$5b86ea63a640289f(d, val) {
    return val === undefined ? $7cdbb81bd69b4527$export$31803937850fb2da($7cdbb81bd69b4527$export$38d7278c783c77a7(d, $7cdbb81bd69b4527$var$DECADE)) : $7cdbb81bd69b4527$export$e16d8520af44a096(d, val + 10, $7cdbb81bd69b4527$var$YEAR);
}
function $7cdbb81bd69b4527$export$2c6a90a816708bc5(d, val) {
    return val === undefined ? $7cdbb81bd69b4527$export$31803937850fb2da($7cdbb81bd69b4527$export$38d7278c783c77a7(d, $7cdbb81bd69b4527$var$CENTURY)) : $7cdbb81bd69b4527$export$e16d8520af44a096(d, val + 100, $7cdbb81bd69b4527$var$YEAR);
}
function $7cdbb81bd69b4527$export$b7f7efbe9ab39b25(d, val, firstDay) {
    var w = ($7cdbb81bd69b4527$export$d2d39d1adcc883a2(d) + 7 - (firstDay || 0)) % 7;
    return val === undefined ? w : $7cdbb81bd69b4527$export$e16d8520af44a096(d, val - w, $7cdbb81bd69b4527$var$DAY);
}
function $7cdbb81bd69b4527$export$a37e3c603d7117e5(date1, date2, unit, asFloat) {
    var dividend, divisor, result;
    switch(unit){
        case $7cdbb81bd69b4527$var$MILI:
        case $7cdbb81bd69b4527$var$SECONDS:
        case $7cdbb81bd69b4527$var$MINUTES:
        case $7cdbb81bd69b4527$var$HOURS:
        case $7cdbb81bd69b4527$var$DAY:
        case $7cdbb81bd69b4527$var$WEEK:
            dividend = date2.getTime() - date1.getTime();
            break;
        case $7cdbb81bd69b4527$var$MONTH:
        case $7cdbb81bd69b4527$var$YEAR:
        case $7cdbb81bd69b4527$var$DECADE:
        case $7cdbb81bd69b4527$var$CENTURY:
            dividend = ($7cdbb81bd69b4527$export$31803937850fb2da(date2) - $7cdbb81bd69b4527$export$31803937850fb2da(date1)) * 12 + $7cdbb81bd69b4527$export$af5de1609f06c8e6(date2) - $7cdbb81bd69b4527$export$af5de1609f06c8e6(date1);
            break;
        default:
            throw new TypeError('Invalid units: "' + unit + '"');
    }
    switch(unit){
        case $7cdbb81bd69b4527$var$MILI:
            divisor = 1;
            break;
        case $7cdbb81bd69b4527$var$SECONDS:
            divisor = 1000;
            break;
        case $7cdbb81bd69b4527$var$MINUTES:
            divisor = 60000;
            break;
        case $7cdbb81bd69b4527$var$HOURS:
            divisor = 3600000;
            break;
        case $7cdbb81bd69b4527$var$DAY:
            divisor = 86400000;
            break;
        case $7cdbb81bd69b4527$var$WEEK:
            divisor = 604800000;
            break;
        case $7cdbb81bd69b4527$var$MONTH:
            divisor = 1;
            break;
        case $7cdbb81bd69b4527$var$YEAR:
            divisor = 12;
            break;
        case $7cdbb81bd69b4527$var$DECADE:
            divisor = 120;
            break;
        case $7cdbb81bd69b4527$var$CENTURY:
            divisor = 1200;
            break;
        default:
            throw new TypeError('Invalid units: "' + unit + '"');
    }
    result = dividend / divisor;
    return asFloat ? result : Math.round(result);
}
function $7cdbb81bd69b4527$var$createAccessor(method) {
    var hourLength = function(method) {
        switch(method){
            case 'Milliseconds':
                return 3600000;
            case 'Seconds':
                return 3600;
            case 'Minutes':
                return 60;
            case 'Hours':
                return 1;
            default:
                return null;
        }
    }(method);
    return function(d, val) {
        if (val === undefined) return d['get' + method]();
        var dateOut = new Date(d);
        dateOut['set' + method](val);
        if (hourLength && dateOut['get' + method]() != val && (method === 'Hours' || val >= hourLength && dateOut.getHours() - d.getHours() < Math.floor(val / hourLength))) //Skip DST hour, if it occurs
        dateOut['set' + method](val + hourLength);
        return dateOut;
    };
}
function $7cdbb81bd69b4527$var$createComparer(operator) {
    return function(a, b, unit) {
        return operator(+$7cdbb81bd69b4527$export$38d7278c783c77a7(a, unit), +$7cdbb81bd69b4527$export$38d7278c783c77a7(b, unit));
    };
}



var $5fApW = parcelRequire("5fApW");

var $kmhzA = parcelRequire("kmhzA");
function $e8c6f5ed675d4628$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $kmhzA.default)(arr);
}



var $3yua1 = parcelRequire("3yua1");

var $ltlk5 = parcelRequire("ltlk5");
function $e23e34317a62e061$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $ade8cf5a4b72a7ba$export$2e2bcd8739ae039(arr) {
    return (0, $e8c6f5ed675d4628$export$2e2bcd8739ae039)(arr) || (0, $3yua1.default)(arr) || (0, $ltlk5.default)(arr) || (0, $e23e34317a62e061$export$2e2bcd8739ae039)();
}


/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $9e0b2b8fb9d5ade6$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
var $9e0b2b8fb9d5ade6$export$2e2bcd8739ae039 = $9e0b2b8fb9d5ade6$var$baseSlice;




/** Used as references for various `Number` constants. */ var $5ac7195a64b098e3$var$INFINITY = 1 / 0, $5ac7195a64b098e3$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $5ac7195a64b098e3$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = (0, $0c4f437be7d02c8a$export$2e2bcd8739ae039)(value);
    if (value === $5ac7195a64b098e3$var$INFINITY || value === -$5ac7195a64b098e3$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $5ac7195a64b098e3$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
var $5ac7195a64b098e3$export$2e2bcd8739ae039 = $5ac7195a64b098e3$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $5eaf922578b4c93c$var$toInteger(value) {
    var result = (0, $5ac7195a64b098e3$export$2e2bcd8739ae039)(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
var $5eaf922578b4c93c$export$2e2bcd8739ae039 = $5eaf922578b4c93c$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $f2440465854da155$var$nativeCeil = Math.ceil, $f2440465854da155$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $f2440465854da155$var$chunk(array, size, guard) {
    if (guard ? (0, $b6104ac0178f9577$export$2e2bcd8739ae039)(array, size, guard) : size === undefined) size = 1;
    else size = $f2440465854da155$var$nativeMax((0, $5eaf922578b4c93c$export$2e2bcd8739ae039)(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($f2440465854da155$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = (0, $9e0b2b8fb9d5ade6$export$2e2bcd8739ae039)(array, index, index += size);
    return result;
}
var $f2440465854da155$export$2e2bcd8739ae039 = $f2440465854da155$var$chunk;



/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $c1106bf076c10094$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $d43af82709b3ee4c$export$2e2bcd8739ae039(node) {
    var doc = (0, $c1106bf076c10094$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $cd15543910747426$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $d43af82709b3ee4c$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $7a121c9cf7d4eba8$var$rUpper = /([A-Z])/g;
function $7a121c9cf7d4eba8$export$2e2bcd8739ae039(string) {
    return string.replace($7a121c9cf7d4eba8$var$rUpper, '-$1').toLowerCase();
}


var $29d068578ec51a38$var$msPattern = /^ms-/;
function $29d068578ec51a38$export$2e2bcd8739ae039(string) {
    return (0, $7a121c9cf7d4eba8$export$2e2bcd8739ae039)(string).replace($29d068578ec51a38$var$msPattern, '-ms-');
}


var $9f22bd6ee3c6f021$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $9f22bd6ee3c6f021$export$2e2bcd8739ae039(value) {
    return !!(value && $9f22bd6ee3c6f021$var$supportedTransforms.test(value));
}


function $42d2323787e39668$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $29d068578ec51a38$export$2e2bcd8739ae039)(property)) || (0, $cd15543910747426$export$2e2bcd8739ae039)(node).getPropertyValue((0, $29d068578ec51a38$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $29d068578ec51a38$export$2e2bcd8739ae039)(key));
        else if ((0, $9f22bd6ee3c6f021$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $29d068578ec51a38$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $42d2323787e39668$export$2e2bcd8739ae039 = $42d2323787e39668$var$style;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $436ea1d5df77ecaa$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}



function $4c29b6022a760b41$export$2e2bcd8739ae039(element) {
    return 'nodeType' in element && element.nodeType === document.DOCUMENT_NODE;
}


function $512aab2f80d3201c$export$2e2bcd8739ae039(node) {
    if ('window' in node && node.window === node) return node;
    if ((0, $4c29b6022a760b41$export$2e2bcd8739ae039)(node)) return node.defaultView || false;
    return false;
}


function $b326b981664d3c6a$export$2e2bcd8739ae039(offset) {
    var prop = offset === 'pageXOffset' ? 'scrollLeft' : 'scrollTop';
    function scrollAccessor(node, val) {
        var win = (0, $512aab2f80d3201c$export$2e2bcd8739ae039)(node);
        if (val === undefined) return win ? win[offset] : node[prop];
        if (win) win.scrollTo(win[offset], val);
        else node[prop] = val;
    }
    return scrollAccessor;
}


var /**
 * Gets or sets the scroll left position of a given element.
 * 
 * @param node the element
 * @param val the position to set
 */ $144fd98e34753716$export$2e2bcd8739ae039 = (0, $b326b981664d3c6a$export$2e2bcd8739ae039)('pageXOffset');



var /**
 * Gets or sets the scroll top position of a given element.
 * 
 * @param node the element
 * @param val the position to set
 */ $fa4e102bf4cc8816$export$2e2bcd8739ae039 = (0, $b326b981664d3c6a$export$2e2bcd8739ae039)('pageYOffset');


function $dab096c73737ab95$export$2e2bcd8739ae039(node) {
    var doc = (0, $c1106bf076c10094$export$2e2bcd8739ae039)(node);
    var box = {
        top: 0,
        left: 0,
        height: 0,
        width: 0
    };
    var docElem = doc && doc.documentElement; // Make sure it's not a disconnected DOM node
    if (!docElem || !(0, $436ea1d5df77ecaa$export$2e2bcd8739ae039)(docElem, node)) return box;
    if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
    box = {
        top: box.top + (0, $fa4e102bf4cc8816$export$2e2bcd8739ae039)(docElem) - (docElem.clientTop || 0),
        left: box.left + (0, $144fd98e34753716$export$2e2bcd8739ae039)(docElem) - (docElem.clientLeft || 0),
        width: box.width,
        height: box.height
    };
    return box;
}




var $94d624e72e52b958$var$isHTMLElement = function isHTMLElement(e) {
    return !!e && 'offsetParent' in e;
};
function $94d624e72e52b958$export$2e2bcd8739ae039(node) {
    var doc = (0, $c1106bf076c10094$export$2e2bcd8739ae039)(node);
    var parent = node && node.offsetParent;
    while($94d624e72e52b958$var$isHTMLElement(parent) && parent.nodeName !== 'HTML' && (0, $42d2323787e39668$export$2e2bcd8739ae039)(parent, 'position') === 'static')parent = parent.offsetParent;
    return parent || doc.documentElement;
}




var $e663dc897e07c278$var$nodeName = function nodeName(node) {
    return node.nodeName && node.nodeName.toLowerCase();
};
function $e663dc897e07c278$export$2e2bcd8739ae039(node, offsetParent) {
    var parentOffset = {
        top: 0,
        left: 0
    };
    var offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
    // because it is its only offset parent
    if ((0, $42d2323787e39668$export$2e2bcd8739ae039)(node, 'position') === 'fixed') offset = node.getBoundingClientRect();
    else {
        var parent = offsetParent || (0, $94d624e72e52b958$export$2e2bcd8739ae039)(node);
        offset = (0, $dab096c73737ab95$export$2e2bcd8739ae039)(node);
        if ($e663dc897e07c278$var$nodeName(parent) !== 'html') parentOffset = (0, $dab096c73737ab95$export$2e2bcd8739ae039)(parent);
        var borderTop = String((0, $42d2323787e39668$export$2e2bcd8739ae039)(parent, 'borderTopWidth') || 0);
        parentOffset.top += parseInt(borderTop, 10) - (0, $fa4e102bf4cc8816$export$2e2bcd8739ae039)(parent) || 0;
        var borderLeft = String((0, $42d2323787e39668$export$2e2bcd8739ae039)(parent, 'borderLeftWidth') || 0);
        parentOffset.left += parseInt(borderLeft, 10) - (0, $144fd98e34753716$export$2e2bcd8739ae039)(parent) || 0;
    }
    var marginTop = String((0, $42d2323787e39668$export$2e2bcd8739ae039)(node, 'marginTop') || 0);
    var marginLeft = String((0, $42d2323787e39668$export$2e2bcd8739ae039)(node, 'marginLeft') || 0); // Subtract parent offsets and node margins
    return (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, offset, {
        top: offset.top - parentOffset.top - (parseInt(marginTop, 10) || 0),
        left: offset.left - parentOffset.left - (parseInt(marginLeft, 10) || 0)
    });
}


var $3a9b450088ef7fe2$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


/* https://github.com/component/raf */ var $c70f3c10ca880f8d$var$prev = new Date().getTime();
function $c70f3c10ca880f8d$var$fallback(fn) {
    var curr = new Date().getTime();
    var ms = Math.max(0, 16 - (curr - $c70f3c10ca880f8d$var$prev));
    var handle = setTimeout(fn, ms);
    $c70f3c10ca880f8d$var$prev = curr;
    return handle;
}
var $c70f3c10ca880f8d$var$vendors = [
    '',
    'webkit',
    'moz',
    'o',
    'ms'
];
var $c70f3c10ca880f8d$var$cancelMethod = 'clearTimeout';
var $c70f3c10ca880f8d$var$rafImpl = $c70f3c10ca880f8d$var$fallback; // eslint-disable-next-line import/no-mutable-exports
var $c70f3c10ca880f8d$var$getKey = function getKey(vendor, k) {
    return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + "AnimationFrame";
};
if (0, $3a9b450088ef7fe2$export$2e2bcd8739ae039) $c70f3c10ca880f8d$var$vendors.some(function(vendor) {
    var rafMethod = $c70f3c10ca880f8d$var$getKey(vendor, 'request');
    if (rafMethod in window) {
        $c70f3c10ca880f8d$var$cancelMethod = $c70f3c10ca880f8d$var$getKey(vendor, 'cancel'); // @ts-ignore
        $c70f3c10ca880f8d$var$rafImpl = function rafImpl(cb) {
            return window[rafMethod](cb);
        };
    }
    return !!$c70f3c10ca880f8d$var$rafImpl;
});
var $c70f3c10ca880f8d$export$70b61ad426ddbe54 = function cancel(id) {
    // @ts-ignore
    if (typeof window[$c70f3c10ca880f8d$var$cancelMethod] === 'function') window[$c70f3c10ca880f8d$var$cancelMethod](id);
};
var $c70f3c10ca880f8d$export$b5fe3f66a567bec0 = $c70f3c10ca880f8d$var$rafImpl;





var $cgjHV = parcelRequire("cgjHV");

var $6fFrj = parcelRequire("6fFrj");

var $8CZEB = parcelRequire("8CZEB");

var $6fFrj = parcelRequire("6fFrj");
function $61c92d8495841d1d$export$2e2bcd8739ae039() {
    return (0, $6fFrj.useState)(null);
}



var $6fFrj = parcelRequire("6fFrj");
var $ba4d3f8fab9d7e75$var$toFnRef = function toFnRef(ref) {
    return !ref || typeof ref === 'function' ? ref : function(value) {
        ref.current = value;
    };
};
function $ba4d3f8fab9d7e75$export$c9058316764c140e(refA, refB) {
    var a = $ba4d3f8fab9d7e75$var$toFnRef(refA);
    var b = $ba4d3f8fab9d7e75$var$toFnRef(refB);
    return function(value) {
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $ba4d3f8fab9d7e75$var$useMergedRefs(refA, refB) {
    return (0, $6fFrj.useMemo)(function() {
        return $ba4d3f8fab9d7e75$export$c9058316764c140e(refA, refB);
    }, [
        refA,
        refB
    ]);
}
var $ba4d3f8fab9d7e75$export$2e2bcd8739ae039 = $ba4d3f8fab9d7e75$var$useMergedRefs;


var $f632220179fef402$export$1e95b668f3b82d = 'top';
var $f632220179fef402$export$40e543e69a8b3fbb = 'bottom';
var $f632220179fef402$export$79ffe56a765070d2 = 'right';
var $f632220179fef402$export$eabcd2c8791e7bf4 = 'left';
var $f632220179fef402$export$dfb5619354ba860 = 'auto';
var $f632220179fef402$export$aec2ce47c367b8c3 = [
    $f632220179fef402$export$1e95b668f3b82d,
    $f632220179fef402$export$40e543e69a8b3fbb,
    $f632220179fef402$export$79ffe56a765070d2,
    $f632220179fef402$export$eabcd2c8791e7bf4
];
var $f632220179fef402$export$b3571188c770cc5a = 'start';
var $f632220179fef402$export$bd5df0f255a350f8 = 'end';
var $f632220179fef402$export$390fd549c5303b4d = 'clippingParents';
var $f632220179fef402$export$d7b7311ec04a3e8f = 'viewport';
var $f632220179fef402$export$ae5ab1c730825774 = 'popper';
var $f632220179fef402$export$ca50aac9f3ba507f = 'reference';
var $f632220179fef402$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f632220179fef402$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f632220179fef402$export$b3571188c770cc5a,
        placement + "-" + $f632220179fef402$export$bd5df0f255a350f8
    ]);
}, []);
var $f632220179fef402$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f632220179fef402$export$aec2ce47c367b8c3, [
    $f632220179fef402$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f632220179fef402$export$b3571188c770cc5a,
        placement + "-" + $f632220179fef402$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f632220179fef402$export$421679a7c3d56e = 'beforeRead';
var $f632220179fef402$export$aafa59e2e03f2942 = 'read';
var $f632220179fef402$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $f632220179fef402$export$c65e99957a05207c = 'beforeMain';
var $f632220179fef402$export$f22da7240b7add18 = 'main';
var $f632220179fef402$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f632220179fef402$export$8d4d2d70e7d46032 = 'beforeWrite';
var $f632220179fef402$export$68d8715fc104d294 = 'write';
var $f632220179fef402$export$70a6e5159acce2e6 = 'afterWrite';
var $f632220179fef402$export$d087d3878fdf71d5 = [
    $f632220179fef402$export$421679a7c3d56e,
    $f632220179fef402$export$aafa59e2e03f2942,
    $f632220179fef402$export$6964f6c886723980,
    $f632220179fef402$export$c65e99957a05207c,
    $f632220179fef402$export$f22da7240b7add18,
    $f632220179fef402$export$bab79516f2d662fe,
    $f632220179fef402$export$8d4d2d70e7d46032,
    $f632220179fef402$export$68d8715fc104d294,
    $f632220179fef402$export$70a6e5159acce2e6
];





var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");
function $e1e617456d6401aa$export$2e2bcd8739ae039() {
    var mounted = (0, $6fFrj.useRef)(true);
    var isMounted = (0, $6fFrj.useRef)(function() {
        return mounted.current;
    });
    (0, $6fFrj.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


function $02d425a6751c76f7$var$useSafeState(state) {
    var isMounted = (0, $e1e617456d6401aa$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $6fFrj.useCallback)(function(nextState) {
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $02d425a6751c76f7$export$2e2bcd8739ae039 = $02d425a6751c76f7$var$useSafeState;



function $16d8bbb87123b976$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $b14e9c6ceaf595bf$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $58d6ce30f968a837$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $b14e9c6ceaf595bf$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $58d6ce30f968a837$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $b14e9c6ceaf595bf$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $58d6ce30f968a837$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $b14e9c6ceaf595bf$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $c96d7486dba4028f$export$8960430cfd85939f = Math.max;
var $c96d7486dba4028f$export$96ec731ed4dcb222 = Math.min;
var $c96d7486dba4028f$export$2077e0241d6afd3c = Math.round;



function $f3ffdfc739665e15$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $e85fafc44f486e4b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $f3ffdfc739665e15$export$2e2bcd8739ae039)());
}


function $676fcf1c09d6d2a8$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $58d6ce30f968a837$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $c96d7486dba4028f$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $c96d7486dba4028f$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $58d6ce30f968a837$export$45a5e7f76e0caa8d)(element) ? (0, $b14e9c6ceaf595bf$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $e85fafc44f486e4b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $ae54a7b2ced97e47$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $676fcf1c09d6d2a8$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $b239a408feee77ca$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $58d6ce30f968a837$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $dce251096cfce732$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $20ba7fe07c40430c$export$2e2bcd8739ae039(element) {
    return (0, $b14e9c6ceaf595bf$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $230d130fa549a9fc$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $dce251096cfce732$export$2e2bcd8739ae039)(element)) >= 0;
}




function $b064e6cfb978fe84$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $58d6ce30f968a837$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $612dae5a2abfc22c$export$2e2bcd8739ae039(element) {
    if ((0, $dce251096cfce732$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $58d6ce30f968a837$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $b064e6cfb978fe84$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $5693799680062b78$var$getTrueOffsetParent(element) {
    if (!(0, $58d6ce30f968a837$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $20ba7fe07c40430c$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $5693799680062b78$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $f3ffdfc739665e15$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $f3ffdfc739665e15$export$2e2bcd8739ae039)());
    if (isIE && (0, $58d6ce30f968a837$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $20ba7fe07c40430c$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $612dae5a2abfc22c$export$2e2bcd8739ae039)(element);
    if ((0, $58d6ce30f968a837$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $58d6ce30f968a837$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $dce251096cfce732$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $20ba7fe07c40430c$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $5693799680062b78$export$2e2bcd8739ae039(element) {
    var window = (0, $b14e9c6ceaf595bf$export$2e2bcd8739ae039)(element);
    var offsetParent = $5693799680062b78$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $230d130fa549a9fc$export$2e2bcd8739ae039)(offsetParent) && (0, $20ba7fe07c40430c$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $5693799680062b78$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $dce251096cfce732$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $dce251096cfce732$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $20ba7fe07c40430c$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $5693799680062b78$var$getContainingBlock(element) || window;
}


function $3a1cb8e3f23870ed$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $d87e3a92715a8cb6$export$f28d906d67a997f3(min, value, max) {
    return (0, $c96d7486dba4028f$export$8960430cfd85939f)(min, (0, $c96d7486dba4028f$export$96ec731ed4dcb222)(value, max));
}
function $d87e3a92715a8cb6$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $d87e3a92715a8cb6$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $7aaf8bc06aca9f19$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $4dacbc32af980724$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $7aaf8bc06aca9f19$export$2e2bcd8739ae039)(), paddingObject);
}


function $8890d7353ec0c05d$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}




var $94801206638fee5d$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $4dacbc32af980724$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $8890d7353ec0c05d$export$2e2bcd8739ae039)(padding, (0, $f632220179fef402$export$aec2ce47c367b8c3)));
};
function $94801206638fee5d$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $16d8bbb87123b976$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $3a1cb8e3f23870ed$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $f632220179fef402$export$eabcd2c8791e7bf4),
        (0, $f632220179fef402$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $94801206638fee5d$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $ae54a7b2ced97e47$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $f632220179fef402$export$1e95b668f3b82d) : (0, $f632220179fef402$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $f632220179fef402$export$40e543e69a8b3fbb) : (0, $f632220179fef402$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5693799680062b78$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $d87e3a92715a8cb6$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $94801206638fee5d$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $b239a408feee77ca$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $94801206638fee5d$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $94801206638fee5d$var$arrow,
    effect: $94801206638fee5d$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $850e6412143bf1e2$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $37ad3e1a5ffcc1d4$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $37ad3e1a5ffcc1d4$var$roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $c96d7486dba4028f$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $c96d7486dba4028f$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $37ad3e1a5ffcc1d4$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $f632220179fef402$export$eabcd2c8791e7bf4);
    var sideY = (0, $f632220179fef402$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5693799680062b78$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $b14e9c6ceaf595bf$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $b064e6cfb978fe84$export$2e2bcd8739ae039)(popper);
            if ((0, $20ba7fe07c40430c$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $f632220179fef402$export$1e95b668f3b82d) || (placement === (0, $f632220179fef402$export$eabcd2c8791e7bf4) || placement === (0, $f632220179fef402$export$79ffe56a765070d2)) && variation === (0, $f632220179fef402$export$bd5df0f255a350f8)) {
            sideY = (0, $f632220179fef402$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $f632220179fef402$export$eabcd2c8791e7bf4) || (placement === (0, $f632220179fef402$export$1e95b668f3b82d) || placement === (0, $f632220179fef402$export$40e543e69a8b3fbb)) && variation === (0, $f632220179fef402$export$bd5df0f255a350f8)) {
            sideX = (0, $f632220179fef402$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $37ad3e1a5ffcc1d4$var$unsetSides);
    var _ref4 = roundOffsets === true ? $37ad3e1a5ffcc1d4$var$roundOffsetsByDPR({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $37ad3e1a5ffcc1d4$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $16d8bbb87123b976$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $850e6412143bf1e2$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $37ad3e1a5ffcc1d4$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $37ad3e1a5ffcc1d4$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $37ad3e1a5ffcc1d4$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $37ad3e1a5ffcc1d4$var$computeStyles,
    data: {}
};



var $59486d76da8b7d43$var$passive = {
    passive: true
};
function $59486d76da8b7d43$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $b14e9c6ceaf595bf$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $59486d76da8b7d43$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $59486d76da8b7d43$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $59486d76da8b7d43$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $59486d76da8b7d43$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $59486d76da8b7d43$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $59486d76da8b7d43$var$effect,
    data: {}
};


var $161c9a282458dd84$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $161c9a282458dd84$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $161c9a282458dd84$var$hash[matched];
    });
}



var $091fbe4f36788609$var$hash = {
    start: 'end',
    end: 'start'
};
function $091fbe4f36788609$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $091fbe4f36788609$var$hash[matched];
    });
}








function $17becd08022948aa$export$2e2bcd8739ae039(node) {
    var win = (0, $b14e9c6ceaf595bf$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $6a6ea3746d281911$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $676fcf1c09d6d2a8$export$2e2bcd8739ae039)((0, $b064e6cfb978fe84$export$2e2bcd8739ae039)(element)).left + (0, $17becd08022948aa$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $bc62564fef9813a3$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $b14e9c6ceaf595bf$export$2e2bcd8739ae039)(element);
    var html = (0, $b064e6cfb978fe84$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $e85fafc44f486e4b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $6a6ea3746d281911$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $479ef377da60f781$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $b064e6cfb978fe84$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $17becd08022948aa$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $c96d7486dba4028f$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $c96d7486dba4028f$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $6a6ea3746d281911$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $20ba7fe07c40430c$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $c96d7486dba4028f$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $654b31d5c61df05d$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $20ba7fe07c40430c$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $6095862279bf5197$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $dce251096cfce732$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $58d6ce30f968a837$export$1b3bfaa9684536aa)(node) && (0, $654b31d5c61df05d$export$2e2bcd8739ae039)(node)) return node;
    return $6095862279bf5197$export$2e2bcd8739ae039((0, $612dae5a2abfc22c$export$2e2bcd8739ae039)(node));
}





function $67ee19bc4804c9c0$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $6095862279bf5197$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $b14e9c6ceaf595bf$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $654b31d5c61df05d$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($67ee19bc4804c9c0$export$2e2bcd8739ae039((0, $612dae5a2abfc22c$export$2e2bcd8739ae039)(target)));
}










function $3ca88c6cf58aa309$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $b494ab10ea8df355$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $676fcf1c09d6d2a8$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $b494ab10ea8df355$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $f632220179fef402$export$d7b7311ec04a3e8f) ? (0, $3ca88c6cf58aa309$export$2e2bcd8739ae039)((0, $bc62564fef9813a3$export$2e2bcd8739ae039)(element, strategy)) : (0, $58d6ce30f968a837$export$45a5e7f76e0caa8d)(clippingParent) ? $b494ab10ea8df355$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $3ca88c6cf58aa309$export$2e2bcd8739ae039)((0, $479ef377da60f781$export$2e2bcd8739ae039)((0, $b064e6cfb978fe84$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $b494ab10ea8df355$var$getClippingParents(element) {
    var clippingParents = (0, $67ee19bc4804c9c0$export$2e2bcd8739ae039)((0, $612dae5a2abfc22c$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $20ba7fe07c40430c$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $58d6ce30f968a837$export$1b3bfaa9684536aa)(element) ? (0, $5693799680062b78$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $58d6ce30f968a837$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $58d6ce30f968a837$export$45a5e7f76e0caa8d)(clippingParent) && (0, $b239a408feee77ca$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $dce251096cfce732$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $b494ab10ea8df355$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $b494ab10ea8df355$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $b494ab10ea8df355$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $c96d7486dba4028f$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $c96d7486dba4028f$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $c96d7486dba4028f$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $c96d7486dba4028f$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $b494ab10ea8df355$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $3f4424447685a724$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $16d8bbb87123b976$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $850e6412143bf1e2$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $f632220179fef402$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $f632220179fef402$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $f632220179fef402$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $f632220179fef402$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $3a1cb8e3f23870ed$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $f632220179fef402$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $f632220179fef402$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $60de8cc3f4269688$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $f632220179fef402$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $f632220179fef402$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $f632220179fef402$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $4dacbc32af980724$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $8890d7353ec0c05d$export$2e2bcd8739ae039)(padding, (0, $f632220179fef402$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $f632220179fef402$export$ae5ab1c730825774) ? (0, $f632220179fef402$export$ca50aac9f3ba507f) : (0, $f632220179fef402$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $b494ab10ea8df355$export$2e2bcd8739ae039)((0, $58d6ce30f968a837$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $b064e6cfb978fe84$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $676fcf1c09d6d2a8$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $3f4424447685a724$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $3ca88c6cf58aa309$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $f632220179fef402$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $f632220179fef402$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $f632220179fef402$export$79ffe56a765070d2),
                (0, $f632220179fef402$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $f632220179fef402$export$1e95b668f3b82d),
                (0, $f632220179fef402$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $3b52645608855a99$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $f632220179fef402$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $850e6412143bf1e2$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $f632220179fef402$export$368f9a87e87fa4e1) : (0, $f632220179fef402$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $850e6412143bf1e2$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $f632220179fef402$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $60de8cc3f4269688$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $16d8bbb87123b976$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $f0d36f385e6928f8$var$getExpandedFallbackPlacements(placement) {
    if ((0, $16d8bbb87123b976$export$2e2bcd8739ae039)(placement) === (0, $f632220179fef402$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $161c9a282458dd84$export$2e2bcd8739ae039)(placement);
    return [
        (0, $091fbe4f36788609$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $091fbe4f36788609$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $f0d36f385e6928f8$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $16d8bbb87123b976$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $161c9a282458dd84$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $f0d36f385e6928f8$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $16d8bbb87123b976$export$2e2bcd8739ae039)(placement) === (0, $f632220179fef402$export$dfb5619354ba860) ? (0, $3b52645608855a99$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $16d8bbb87123b976$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $850e6412143bf1e2$export$2e2bcd8739ae039)(placement) === (0, $f632220179fef402$export$b3571188c770cc5a);
        var isVertical = [
            (0, $f632220179fef402$export$1e95b668f3b82d),
            (0, $f632220179fef402$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $60de8cc3f4269688$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $f632220179fef402$export$79ffe56a765070d2) : (0, $f632220179fef402$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $f632220179fef402$export$40e543e69a8b3fbb) : (0, $f632220179fef402$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $161c9a282458dd84$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $161c9a282458dd84$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $f0d36f385e6928f8$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $f0d36f385e6928f8$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $ea315ac36d16cabc$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $ea315ac36d16cabc$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $f632220179fef402$export$1e95b668f3b82d),
        (0, $f632220179fef402$export$79ffe56a765070d2),
        (0, $f632220179fef402$export$40e543e69a8b3fbb),
        (0, $f632220179fef402$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $ea315ac36d16cabc$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $60de8cc3f4269688$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $60de8cc3f4269688$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $ea315ac36d16cabc$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $ea315ac36d16cabc$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $ea315ac36d16cabc$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $ea315ac36d16cabc$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $ea315ac36d16cabc$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $ea315ac36d16cabc$var$hide
};




function $1053b0a2a1578b34$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $16d8bbb87123b976$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $f632220179fef402$export$eabcd2c8791e7bf4),
        (0, $f632220179fef402$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $f632220179fef402$export$eabcd2c8791e7bf4),
        (0, $f632220179fef402$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $1053b0a2a1578b34$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $f632220179fef402$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $1053b0a2a1578b34$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $1053b0a2a1578b34$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $1053b0a2a1578b34$var$offset
};



function $cb96e57ebc5fc9a6$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $3f4424447685a724$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $cb96e57ebc5fc9a6$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $cb96e57ebc5fc9a6$var$popperOffsets,
    data: {}
};





function $9aaf2a3a6c2b41a3$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $4e09eab67ae2717b$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $60de8cc3f4269688$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $16d8bbb87123b976$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $850e6412143bf1e2$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $3a1cb8e3f23870ed$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $9aaf2a3a6c2b41a3$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $f632220179fef402$export$1e95b668f3b82d) : (0, $f632220179fef402$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $f632220179fef402$export$40e543e69a8b3fbb) : (0, $f632220179fef402$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $f632220179fef402$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $f632220179fef402$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $ae54a7b2ced97e47$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $7aaf8bc06aca9f19$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $d87e3a92715a8cb6$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5693799680062b78$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $d87e3a92715a8cb6$export$f28d906d67a997f3)(tether ? (0, $c96d7486dba4028f$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $c96d7486dba4028f$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $f632220179fef402$export$1e95b668f3b82d) : (0, $f632220179fef402$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $f632220179fef402$export$40e543e69a8b3fbb) : (0, $f632220179fef402$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $f632220179fef402$export$1e95b668f3b82d),
            (0, $f632220179fef402$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $d87e3a92715a8cb6$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $d87e3a92715a8cb6$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4e09eab67ae2717b$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $4e09eab67ae2717b$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $c5ddd3e62588598e$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $c4b3b696327d3b9f$export$2e2bcd8739ae039(node) {
    if (node === (0, $b14e9c6ceaf595bf$export$2e2bcd8739ae039)(node) || !(0, $58d6ce30f968a837$export$1b3bfaa9684536aa)(node)) return (0, $17becd08022948aa$export$2e2bcd8739ae039)(node);
    else return (0, $c5ddd3e62588598e$export$2e2bcd8739ae039)(node);
}








function $ef7d210b7564176e$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $c96d7486dba4028f$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $c96d7486dba4028f$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $ef7d210b7564176e$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $58d6ce30f968a837$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $58d6ce30f968a837$export$1b3bfaa9684536aa)(offsetParent) && $ef7d210b7564176e$var$isElementScaled(offsetParent);
    var documentElement = (0, $b064e6cfb978fe84$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $676fcf1c09d6d2a8$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $dce251096cfce732$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $654b31d5c61df05d$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $c4b3b696327d3b9f$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $58d6ce30f968a837$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $676fcf1c09d6d2a8$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $6a6ea3746d281911$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}







function $3c94eb28205d6bc6$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $3c94eb28205d6bc6$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $3c94eb28205d6bc6$var$order(modifiers); // order based on phase
    return (0, $f632220179fef402$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $a1754266e45b34ea$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}





function $52adac607a71ea62$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}





var $4ca7b4b47a7b88cf$var$INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var $4ca7b4b47a7b88cf$var$INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var $4ca7b4b47a7b88cf$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $4ca7b4b47a7b88cf$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $4ca7b4b47a7b88cf$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $4ca7b4b47a7b88cf$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $4ca7b4b47a7b88cf$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $58d6ce30f968a837$export$45a5e7f76e0caa8d)(reference) ? (0, $67ee19bc4804c9c0$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $67ee19bc4804c9c0$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $67ee19bc4804c9c0$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $3c94eb28205d6bc6$export$2e2bcd8739ae039)((0, $52adac607a71ea62$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$4ca7b4b47a7b88cf$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $ef7d210b7564176e$export$2e2bcd8739ae039)(reference, (0, $5693799680062b78$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $ae54a7b2ced97e47$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $a1754266e45b34ea$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$4ca7b4b47a7b88cf$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $4ca7b4b47a7b88cf$export$8f7491d57c8f97a9 = /*#__PURE__*/ $4ca7b4b47a7b88cf$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


var $8f632b8f308d7d41$export$8f7491d57c8f97a9 = (0, $4ca7b4b47a7b88cf$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $ea315ac36d16cabc$export$2e2bcd8739ae039),
        (0, $cb96e57ebc5fc9a6$export$2e2bcd8739ae039),
        (0, $37ad3e1a5ffcc1d4$export$2e2bcd8739ae039),
        (0, $59486d76da8b7d43$export$2e2bcd8739ae039),
        (0, $1053b0a2a1578b34$export$2e2bcd8739ae039),
        (0, $f0d36f385e6928f8$export$2e2bcd8739ae039),
        (0, $4e09eab67ae2717b$export$2e2bcd8739ae039),
        (0, $94801206638fee5d$export$2e2bcd8739ae039)
    ]
});


var $61c90bcde7447435$var$initialPopperStyles = function initialPopperStyles(position) {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
};
var $61c90bcde7447435$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false
}; // In order to satisfy the current usage of options, including undefined
var $61c90bcde7447435$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: function effect(_ref) {
        var state = _ref.state;
        return function() {
            var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
            if ('removeAttribute' in reference) {
                var ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(function(id) {
                    return id.trim() !== popper.id;
                });
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        };
    },
    fn: function fn(_ref2) {
        var _popper$getAttribute;
        var state = _ref2.state;
        var _state$elements2 = state.elements, popper = _state$elements2.popper, reference = _state$elements2.reference;
        var role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            var ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? ids + "," + popper.id : popper.id);
        }
    }
};
var $61c90bcde7447435$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {boolean=}    options.eventsEnabled have Popper listen on window resize events to reposition the element
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $61c90bcde7447435$var$usePopper(referenceElement, popperElement, _temp) {
    var _ref3 = _temp === void 0 ? {} : _temp, _ref3$enabled = _ref3.enabled, enabled = _ref3$enabled === void 0 ? true : _ref3$enabled, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? 'bottom' : _ref3$placement, _ref3$strategy = _ref3.strategy, strategy = _ref3$strategy === void 0 ? 'absolute' : _ref3$strategy, _ref3$modifiers = _ref3.modifiers, modifiers = _ref3$modifiers === void 0 ? $61c90bcde7447435$var$EMPTY_MODIFIERS : _ref3$modifiers, config = (0, $368fc019dd8ff8b8$export$2e2bcd8739ae039)(_ref3, [
        "enabled",
        "placement",
        "strategy",
        "modifiers"
    ]);
    var popperInstanceRef = (0, $6fFrj.useRef)();
    var update = (0, $6fFrj.useCallback)(function() {
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    var forceUpdate = (0, $6fFrj.useCallback)(function() {
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    var _useSafeState = (0, $02d425a6751c76f7$export$2e2bcd8739ae039)((0, $6fFrj.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: $61c90bcde7447435$var$initialPopperStyles(strategy),
            arrow: {}
        }
    })), popperState = _useSafeState[0], setState = _useSafeState[1];
    var updateModifier = (0, $6fFrj.useMemo)(function() {
        return {
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref4) {
                var state = _ref4.state;
                var styles = {};
                var attributes = {};
                Object.keys(state.elements).forEach(function(element) {
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        };
    }, [
        update,
        forceUpdate,
        setState
    ]);
    (0, $6fFrj.useEffect)(function() {
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                updateModifier,
                $61c90bcde7447435$var$disabledApplyStylesModifier
            ])
        }); // intentionally NOT re-running on new modifiers
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        strategy,
        placement,
        updateModifier,
        enabled
    ]);
    (0, $6fFrj.useEffect)(function() {
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $8f632b8f308d7d41$export$8f7491d57c8f97a9)(referenceElement, popperElement, (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                $61c90bcde7447435$var$ariaDescribedByModifier,
                updateModifier
            ])
        }));
        return function() {
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState(function(s) {
                    return (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, s, {
                        attributes: {},
                        styles: {
                            popper: $61c90bcde7447435$var$initialPopperStyles(strategy)
                        }
                    });
                });
            }
        }; // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $61c90bcde7447435$export$2e2bcd8739ae039 = $61c90bcde7447435$var$usePopper;



/* eslint-disable no-return-assign */ 
var $cee125045f9be793$export$63fefd044b2bc624 = false;
var $cee125045f9be793$export$a614c6b395900f69 = false;
try {
    var $cee125045f9be793$var$options = {
        get passive () {
            return $cee125045f9be793$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $cee125045f9be793$export$a614c6b395900f69 = $cee125045f9be793$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $3a9b450088ef7fe2$export$2e2bcd8739ae039) {
        window.addEventListener('test', $cee125045f9be793$var$options, $cee125045f9be793$var$options);
        window.removeEventListener('test', $cee125045f9be793$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $cee125045f9be793$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$cee125045f9be793$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$cee125045f9be793$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $cee125045f9be793$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $cee125045f9be793$export$2e2bcd8739ae039 = $cee125045f9be793$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $bb39a6f84c7c355a$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $bb39a6f84c7c355a$export$2e2bcd8739ae039 = $bb39a6f84c7c355a$var$removeEventListener;


function $25161fa21ce574ca$var$listen(node, eventName, handler, options) {
    (0, $cee125045f9be793$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $bb39a6f84c7c355a$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $25161fa21ce574ca$export$2e2bcd8739ae039 = $25161fa21ce574ca$var$listen;



var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $01b1818656239294$var$useCommittedRef(value) {
    var ref = (0, $6fFrj.useRef)(value);
    (0, $6fFrj.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $01b1818656239294$export$2e2bcd8739ae039 = $01b1818656239294$var$useCommittedRef;


function $88039803405c307d$export$2e2bcd8739ae039(fn) {
    var ref = (0, $01b1818656239294$export$2e2bcd8739ae039)(fn);
    return (0, $6fFrj.useCallback)(function() {
        return ref.current && ref.current.apply(ref, arguments);
    }, [
        ref
    ]);
}


var $4333bcd0e5f1fa22$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $4333bcd0e5f1fa22$var$__DEV__ = false;
var $4333bcd0e5f1fa22$var$warning = function() {};
if ($4333bcd0e5f1fa22$var$__DEV__) {
    var $4333bcd0e5f1fa22$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $4333bcd0e5f1fa22$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $4333bcd0e5f1fa22$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$4333bcd0e5f1fa22$exports = $4333bcd0e5f1fa22$var$warning;




var $8CZEB = parcelRequire("8CZEB");
function $1db4fc1d5ca42b87$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($8CZEB))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}


var $e3a841f3e8f29792$export$2e2bcd8739ae039 = function(componentOrElement) {
    return (0, $c1106bf076c10094$export$2e2bcd8739ae039)((0, $1db4fc1d5ca42b87$export$2e2bcd8739ae039)(componentOrElement));
};


var $b194403eb89ba491$var$escapeKeyCode = 27;
var $b194403eb89ba491$var$noop = function noop() {};
function $b194403eb89ba491$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $b194403eb89ba491$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $b194403eb89ba491$var$getRefTarget = function getRefTarget(ref) {
    return ref && ('current' in ref ? ref.current : ref);
};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $b194403eb89ba491$var$useRootClose(ref, onRootClose, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, disabled = _ref.disabled, _ref$clickTrigger = _ref.clickTrigger, clickTrigger = _ref$clickTrigger === void 0 ? 'click' : _ref$clickTrigger;
    var preventMouseRootCloseRef = (0, $6fFrj.useRef)(false);
    var onClose = onRootClose || $b194403eb89ba491$var$noop;
    var handleMouseCapture = (0, $6fFrj.useCallback)(function(e) {
        var _e$composedPath$;
        var currentTarget = $b194403eb89ba491$var$getRefTarget(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(!!currentTarget, "RootClose captured a close event but does not have a ref to compare it to. useRootClose(), should be passed a ref that resolves to a DOM node");
        preventMouseRootCloseRef.current = !currentTarget || $b194403eb89ba491$var$isModifiedEvent(e) || !$b194403eb89ba491$var$isLeftClickEvent(e) || !!(0, $436ea1d5df77ecaa$export$2e2bcd8739ae039)(currentTarget, (_e$composedPath$ = e.composedPath == null ? void 0 : e.composedPath()[0]) != null ? _e$composedPath$ : e.target);
    }, [
        ref
    ]);
    var handleMouse = (0, $88039803405c307d$export$2e2bcd8739ae039)(function(e) {
        if (!preventMouseRootCloseRef.current) onClose(e);
    });
    var handleKeyUp = (0, $88039803405c307d$export$2e2bcd8739ae039)(function(e) {
        if (e.keyCode === $b194403eb89ba491$var$escapeKeyCode) onClose(e);
    });
    (0, $6fFrj.useEffect)(function() {
        if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        var currentEvent = window.event;
        var doc = (0, $e3a841f3e8f29792$export$2e2bcd8739ae039)($b194403eb89ba491$var$getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        var removeMouseCaptureListener = (0, $25161fa21ce574ca$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        var removeMouseListener = (0, $25161fa21ce574ca$export$2e2bcd8739ae039)(doc, clickTrigger, function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        var removeKeyupListener = (0, $25161fa21ce574ca$export$2e2bcd8739ae039)(doc, 'keyup', function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        var mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map(function(el) {
            return (0, $25161fa21ce574ca$export$2e2bcd8739ae039)(el, 'mousemove', $b194403eb89ba491$var$noop);
        });
        return function() {
            removeMouseCaptureListener();
            removeMouseListener();
            removeKeyupListener();
            mobileSafariHackListeners.forEach(function(remove) {
                return remove();
            });
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleMouse,
        handleKeyUp
    ]);
}
var $b194403eb89ba491$export$2e2bcd8739ae039 = $b194403eb89ba491$var$useRootClose;




var $6fFrj = parcelRequire("6fFrj");
var $73f0973eab89f8ad$export$c91fd81e6d65f84a = function resolveContainerRef(ref) {
    var _ref;
    if (typeof document === 'undefined') return null;
    if (ref == null) return (0, $c1106bf076c10094$export$2e2bcd8739ae039)().body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if ((_ref = ref) != null && _ref.nodeType) return ref || null;
    return null;
};
function $73f0973eab89f8ad$export$2e2bcd8739ae039(ref, onResolved) {
    var _useState = (0, $6fFrj.useState)(function() {
        return $73f0973eab89f8ad$export$c91fd81e6d65f84a(ref);
    }), resolvedRef = _useState[0], setRef = _useState[1];
    if (!resolvedRef) {
        var earlyRef = $73f0973eab89f8ad$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $6fFrj.useEffect)(function() {
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $6fFrj.useEffect)(function() {
        var nextRef = $73f0973eab89f8ad$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}



function $7abbd7df4e1cad38$export$ba6dad097c8f5c38(modifiers) {
    var result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
     // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach(function(m) {
        result[m.name] = m;
    });
    return result;
}
function $7abbd7df4e1cad38$export$af3a999d4a134c86(map) {
    if (map === void 0) map = {};
    if (Array.isArray(map)) return map;
    return Object.keys(map).map(function(k) {
        map[k].name = k;
        return map[k];
    });
}
function $7abbd7df4e1cad38$export$2e2bcd8739ae039(_ref) {
    var _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    var enabled = _ref.enabled, enableEvents = _ref.enableEvents, placement = _ref.placement, flip = _ref.flip, offset = _ref.offset, fixed = _ref.fixed, containerPadding = _ref.containerPadding, arrowElement = _ref.arrowElement, _ref$popperConfig = _ref.popperConfig, popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig;
    var modifiers = $7abbd7df4e1cad38$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $7abbd7df4e1cad38$export$af3a999d4a134c86((0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, modifiers, {
            eventListeners: {
                enabled: enableEvents
            },
            preventOverflow: (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, modifiers.preventOverflow, {
                options: containerPadding ? (0, $876165ca1d22d290$export$2e2bcd8739ae039)({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: (0, $876165ca1d22d290$export$2e2bcd8739ae039)({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: (0, $876165ca1d22d290$export$2e2bcd8739ae039)({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}


/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ var $2a66f2b0fbdb02a3$var$Overlay = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef(function(props, outerRef) {
    var flip = props.flip, offset = props.offset, placement = props.placement, _props$containerPaddi = props.containerPadding, containerPadding = _props$containerPaddi === void 0 ? 5 : _props$containerPaddi, _props$popperConfig = props.popperConfig, popperConfig = _props$popperConfig === void 0 ? {} : _props$popperConfig, Transition = props.transition;
    var _useCallbackRef = (0, $61c92d8495841d1d$export$2e2bcd8739ae039)(), rootElement = _useCallbackRef[0], attachRef = _useCallbackRef[1];
    var _useCallbackRef2 = (0, $61c92d8495841d1d$export$2e2bcd8739ae039)(), arrowElement = _useCallbackRef2[0], attachArrowRef = _useCallbackRef2[1];
    var mergedRef = (0, $ba4d3f8fab9d7e75$export$2e2bcd8739ae039)(attachRef, outerRef);
    var container = (0, $73f0973eab89f8ad$export$2e2bcd8739ae039)(props.container);
    var target = (0, $73f0973eab89f8ad$export$2e2bcd8739ae039)(props.target);
    var _useState = (0, $6fFrj.useState)(!props.show), exited = _useState[0], setExited = _useState[1];
    var _usePopper = (0, $61c90bcde7447435$export$2e2bcd8739ae039)(target, rootElement, (0, $7abbd7df4e1cad38$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    })), styles = _usePopper.styles, attributes = _usePopper.attributes, popper = (0, $368fc019dd8ff8b8$export$2e2bcd8739ae039)(_usePopper, [
        "styles",
        "attributes"
    ]);
    if (props.show) {
        if (exited) setExited(false);
    } else if (!props.transition && !exited) setExited(true);
    var handleHidden = function handleHidden() {
        setExited(true);
        if (props.onExited) props.onExited.apply(props, arguments);
    }; // Don't un-render the overlay while it's transitioning out.
    var mountOverlay = props.show || Transition && !exited;
    (0, $b194403eb89ba491$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    var child = props.children((0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, popper, {
        show: !!props.show,
        props: (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, attributes.popper, {
            style: styles.popper,
            ref: mergedRef
        }),
        arrowProps: (0, $876165ca1d22d290$export$2e2bcd8739ae039)({}, attributes.arrow, {
            style: styles.arrow,
            ref: attachArrowRef
        })
    }));
    if (Transition) {
        var onExit = props.onExit, onExiting = props.onExiting, onEnter = props.onEnter, onEntering = props.onEntering, onEntered = props.onEntered;
        child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Transition, {
            "in": props.show,
            appear: true,
            onExit: onExit,
            onExiting: onExiting,
            onExited: handleHidden,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered
        }, child);
    }
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8CZEB))).createPortal(child, container) : null;
});
$2a66f2b0fbdb02a3$var$Overlay.displayName = 'Overlay';
$2a66f2b0fbdb02a3$var$Overlay.propTypes = {
    /**
   * Set the visibility of the Overlay
   */ show: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    /** Specify where the overlay element is positioned in relation to the target element */ placement: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf((0, $f632220179fef402$export$803cd8101b6c182b)),
    /**
   * A DOM Element, Ref to an element, or function that returns either. The `target` element is where
   * the overlay is positioned relative to.
   */ target: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).any,
    /**
   * A DOM Element, Ref to an element, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).any,
    /**
   * Enables the Popper.js `flip` modifier, allowing the Overlay to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    /**
   * A render prop that returns an element to overlay and position. See
   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
   *
   * @type {Function ({
   *   show: boolean,
   *   placement: Placement,
   *   update: () => void,
   *   forceUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *     [string]: string | number,
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     [string]: string | number,
   *   },
   * }) => React.Element}
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired,
    /**
   * Control how much space there is between the edge of the boundary element and overlay.
   * A convenience shortcut to setting `popperConfig.modfiers.preventOverflow.padding`
   */ containerPadding: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */ popperConfig: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object,
    /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */ rootClose: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    /**
   * Specify event for toggling overlay
   */ rootCloseEvent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf([
        'click',
        'mousedown'
    ]),
    /**
   * Specify disabled for disable RootCloseWrapper
   */ rootCloseDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */ onHide: function onHide(props) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (props.rootClose) {
            var _PropTypes$func;
            return (_PropTypes$func = (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func).isRequired.apply(_PropTypes$func, [
                props
            ].concat(args));
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.apply((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))), [
            props
        ].concat(args));
    },
    /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */ // @ts-ignore
    transition: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).elementType,
    /**
   * Callback fired before the Overlay transitions in
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    /**
   * Callback fired as the Overlay begins to transition in
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    /**
   * Callback fired after the Overlay finishes transitioning in
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    /**
   * Callback fired right before the Overlay transitions out
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    /**
   * Callback fired as the Overlay begins to transition out
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    /**
   * Callback fired after the Overlay finishes transitioning out
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func
};
var $2a66f2b0fbdb02a3$export$2e2bcd8739ae039 = $2a66f2b0fbdb02a3$var$Overlay;




/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $dd617d4ba77198f5$var$isEqual(value, other) {
    return (0, $455ffdba5a6adec0$export$2e2bcd8739ae039)(value, other);
}
var $dd617d4ba77198f5$export$2e2bcd8739ae039 = $dd617d4ba77198f5$var$isEqual;




function $b6a772619fed3ed4$export$2e2bcd8739ae039(node, client) {
    var win = (0, $512aab2f80d3201c$export$2e2bcd8739ae039)(node);
    return win ? win.innerHeight : client ? node.clientHeight : (0, $dab096c73737ab95$export$2e2bcd8739ae039)(node).height;
}


var $107d78630d914c9d$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $107d78630d914c9d$export$2e2bcd8739ae039(element, selector) {
    return $107d78630d914c9d$var$toArray(element.querySelectorAll(selector));
}



var $e9bfa5e733d54489$var$matchesImpl;
function $e9bfa5e733d54489$export$2e2bcd8739ae039(node, selector) {
    if (!$e9bfa5e733d54489$var$matchesImpl) {
        var body = document.body;
        var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;
        $e9bfa5e733d54489$var$matchesImpl = function matchesImpl(n, s) {
            return nativeMatch.call(n, s);
        };
    }
    return $e9bfa5e733d54489$var$matchesImpl(node, selector);
}


function $0a2edc8ddb1d37ab$export$2e2bcd8739ae039(node, selector, stopAt) {
    if (node.closest && !stopAt) node.closest(selector);
    var nextNode = node;
    do {
        if ((0, $e9bfa5e733d54489$export$2e2bcd8739ae039)(nextNode, selector)) return nextNode;
        nextNode = nextNode.parentElement;
    }while (nextNode && nextNode !== stopAt && nextNode.nodeType === document.ELEMENT_NODE);
    return null;
}



/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $695c8209ed424ffb$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
var $695c8209ed424ffb$export$2e2bcd8739ae039 = $695c8209ed424ffb$var$baseFindIndex;




/* Built-in method references for those with the same name as other `lodash` methods. */ var $bf9524e4a68a67b0$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $bf9524e4a68a67b0$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : (0, $5eaf922578b4c93c$export$2e2bcd8739ae039)(fromIndex);
    if (index < 0) index = $bf9524e4a68a67b0$var$nativeMax(length + index, 0);
    return (0, $695c8209ed424ffb$export$2e2bcd8739ae039)(array, (0, $f5a9b0d134bf473a$export$2e2bcd8739ae039)(predicate, 3), index);
}
var $bf9524e4a68a67b0$export$2e2bcd8739ae039 = $bf9524e4a68a67b0$var$findIndex;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $608554ad5a0f28d0$var$nativeCeil = Math.ceil, $608554ad5a0f28d0$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $608554ad5a0f28d0$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $608554ad5a0f28d0$var$nativeMax($608554ad5a0f28d0$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
var $608554ad5a0f28d0$export$2e2bcd8739ae039 = $608554ad5a0f28d0$var$baseRange;




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $9954e2ed97b410b9$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && (0, $b6104ac0178f9577$export$2e2bcd8739ae039)(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = (0, $5ac7195a64b098e3$export$2e2bcd8739ae039)(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = (0, $5ac7195a64b098e3$export$2e2bcd8739ae039)(end);
        step = step === undefined ? start < end ? 1 : -1 : (0, $5ac7195a64b098e3$export$2e2bcd8739ae039)(step);
        return (0, $608554ad5a0f28d0$export$2e2bcd8739ae039)(start, end, step, fromRight);
    };
}
var $9954e2ed97b410b9$export$2e2bcd8739ae039 = $9954e2ed97b410b9$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $3abb78436f324b3d$var$range = (0, $9954e2ed97b410b9$export$2e2bcd8739ae039)();
var $3abb78436f324b3d$export$2e2bcd8739ae039 = $3abb78436f324b3d$var$range;


var $e3e5797910a02537$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $e3e5797910a02537$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e3e5797910a02537$var$safeIsNaN(first) && $e3e5797910a02537$var$safeIsNaN(second)) return true;
    return false;
}
function $e3e5797910a02537$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e3e5797910a02537$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e3e5797910a02537$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e3e5797910a02537$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



var $aHC7s = parcelRequire("aHC7s");
function $c621be7c46450840$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



var $ltlk5 = parcelRequire("ltlk5");

var $ltWw4 = parcelRequire("ltWw4");
function $951471461146a3e9$export$2e2bcd8739ae039(arr, i) {
    return (0, $aHC7s.default)(arr) || (0, $c621be7c46450840$export$2e2bcd8739ae039)(arr, i) || (0, $ltlk5.default)(arr, i) || (0, $ltWw4.default)();
}



var $4TaHZ = parcelRequire("4TaHZ");

var $82uFZ = parcelRequire("82uFZ");

var $2u0qg = parcelRequire("2u0qg");

var $3YFGP = parcelRequire("3YFGP");

var $kT11y = parcelRequire("kT11y");
/** Built-in value references. */ var $151d4b0f507e4555$var$spreadableSymbol = (0, $2u0qg.default) ? (0, $2u0qg.default).isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $151d4b0f507e4555$var$isFlattenable(value) {
    return (0, $kT11y.default)(value) || (0, $3YFGP.default)(value) || !!($151d4b0f507e4555$var$spreadableSymbol && value && value[$151d4b0f507e4555$var$spreadableSymbol]);
}
var $151d4b0f507e4555$export$2e2bcd8739ae039 = $151d4b0f507e4555$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $6db6094187be99c7$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = (0, $151d4b0f507e4555$export$2e2bcd8739ae039));
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $6db6094187be99c7$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else (0, $82uFZ.default)(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
var $6db6094187be99c7$export$2e2bcd8739ae039 = $6db6094187be99c7$var$baseFlatten;



var $8w4ic = parcelRequire("8w4ic");



/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $737d615e4d53cf8f$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
var $737d615e4d53cf8f$export$2e2bcd8739ae039 = $737d615e4d53cf8f$var$baseSortBy;



var $1UOdp = parcelRequire("1UOdp");

var $cHJLm = parcelRequire("cHJLm");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $58f975010d9b7a21$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = (0, $cHJLm.default)(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = (0, $cHJLm.default)(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
var $58f975010d9b7a21$export$2e2bcd8739ae039 = $58f975010d9b7a21$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $15838f62797351f8$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = (0, $58f975010d9b7a21$export$2e2bcd8739ae039)(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
var $15838f62797351f8$export$2e2bcd8739ae039 = $15838f62797351f8$var$compareMultiple;




var $kT11y = parcelRequire("kT11y");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $b1546fc7156d0363$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = (0, $8w4ic.default)(iteratees, function(iteratee) {
        if ((0, $kT11y.default)(iteratee)) return function(value) {
            return (0, $81c7e1f7fa125026$export$2e2bcd8739ae039)(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        (0, $3ff2fe33fd507b47$export$2e2bcd8739ae039)
    ];
    var index = -1;
    iteratees = (0, $8w4ic.default)(iteratees, (0, $1UOdp.default)((0, $f5a9b0d134bf473a$export$2e2bcd8739ae039)));
    var result = (0, $4159a3e8b4ac1df2$export$2e2bcd8739ae039)(collection, function(value, key, collection) {
        var criteria = (0, $8w4ic.default)(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return (0, $737d615e4d53cf8f$export$2e2bcd8739ae039)(result, function(object, other) {
        return (0, $15838f62797351f8$export$2e2bcd8739ae039)(object, other, orders);
    });
}
var $b1546fc7156d0363$export$2e2bcd8739ae039 = $b1546fc7156d0363$var$baseOrderBy;




/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $957ff2622234d571$var$sortBy = (0, $d3a1ecd30e34d299$export$2e2bcd8739ae039)(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && (0, $b6104ac0178f9577$export$2e2bcd8739ae039)(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && (0, $b6104ac0178f9577$export$2e2bcd8739ae039)(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return (0, $b1546fc7156d0363$export$2e2bcd8739ae039)(collection, (0, $6db6094187be99c7$export$2e2bcd8739ae039)(iteratees, 1), []);
});
var $957ff2622234d571$export$2e2bcd8739ae039 = $957ff2622234d571$var$sortBy;




function $adfea2f106a3212d$export$2e2bcd8739ae039(node, client) {
    var win = (0, $512aab2f80d3201c$export$2e2bcd8739ae039)(node);
    return win ? win.innerWidth : client ? node.clientWidth : (0, $dab096c73737ab95$export$2e2bcd8739ae039)(node).width;
}



var $0902d8bc01e222ae$var$size;
function $0902d8bc01e222ae$export$2e2bcd8739ae039(recalc) {
    if (!$0902d8bc01e222ae$var$size && $0902d8bc01e222ae$var$size !== 0 || recalc) {
        if (0, $3a9b450088ef7fe2$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $0902d8bc01e222ae$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $0902d8bc01e222ae$var$size;
}



var $fxpTi = parcelRequire("fxpTi");
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $f5c6f10c71422dc6$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $d07ae03f7f70a2fd$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $f5c6f10c71422dc6$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $c71dc5a2753a7ab8$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $c71dc5a2753a7ab8$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $c71dc5a2753a7ab8$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $c71dc5a2753a7ab8$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $8w4ic = parcelRequire("8w4ic");

var $3m59F = parcelRequire("3m59F");

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $e5b527ae710a095b$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
var $e5b527ae710a095b$export$2e2bcd8739ae039 = $e5b527ae710a095b$var$last;




/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $621e849aea188b96$var$parent(object, path) {
    return path.length < 2 ? object : (0, $81c7e1f7fa125026$export$2e2bcd8739ae039)(object, (0, $9e0b2b8fb9d5ade6$export$2e2bcd8739ae039)(path, 0, -1));
}
var $621e849aea188b96$export$2e2bcd8739ae039 = $621e849aea188b96$var$parent;



var $cdqUH = parcelRequire("cdqUH");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $0b1d1d862c9555a3$var$baseUnset(object, path) {
    path = (0, $9444da7ef5fe2568$export$2e2bcd8739ae039)(path, object);
    object = (0, $621e849aea188b96$export$2e2bcd8739ae039)(object, path);
    return object == null || delete object[(0, $cdqUH.default)((0, $e5b527ae710a095b$export$2e2bcd8739ae039)(path))];
}
var $0b1d1d862c9555a3$export$2e2bcd8739ae039 = $0b1d1d862c9555a3$var$baseUnset;




var $lb2CG = parcelRequire("lb2CG");

var $h8EF0 = parcelRequire("h8EF0");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $e2d052914ab8f5c3$var$customOmitClone(value) {
    return (0, $h8EF0.default)(value) ? undefined : value;
}
var $e2d052914ab8f5c3$export$2e2bcd8739ae039 = $e2d052914ab8f5c3$var$customOmitClone;



/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $31c5b717169e77c4$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? (0, $6db6094187be99c7$export$2e2bcd8739ae039)(array, 1) : [];
}
var $31c5b717169e77c4$export$2e2bcd8739ae039 = $31c5b717169e77c4$var$flatten;




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $124981dc091a7899$var$flatRest(func) {
    return (0, $b0609eec2e4e4523$export$2e2bcd8739ae039)((0, $6c2f35209d2c663c$export$2e2bcd8739ae039)(func, undefined, (0, $31c5b717169e77c4$export$2e2bcd8739ae039)), func + '');
}
var $124981dc091a7899$export$2e2bcd8739ae039 = $124981dc091a7899$var$flatRest;



var $kNHgh = parcelRequire("kNHgh");
/** Used to compose bitmasks for cloning. */ var $0ebf216ff8bb14c6$var$CLONE_DEEP_FLAG = 1, $0ebf216ff8bb14c6$var$CLONE_FLAT_FLAG = 2, $0ebf216ff8bb14c6$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $0ebf216ff8bb14c6$var$omit = (0, $124981dc091a7899$export$2e2bcd8739ae039)(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = (0, $8w4ic.default)(paths, function(path) {
        path = (0, $9444da7ef5fe2568$export$2e2bcd8739ae039)(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    (0, $lb2CG.default)(object, (0, $kNHgh.default)(object), result);
    if (isDeep) result = (0, $3m59F.default)(result, $0ebf216ff8bb14c6$var$CLONE_DEEP_FLAG | $0ebf216ff8bb14c6$var$CLONE_FLAT_FLAG | $0ebf216ff8bb14c6$var$CLONE_SYMBOLS_FLAG, (0, $e2d052914ab8f5c3$export$2e2bcd8739ae039));
    var length = paths.length;
    while(length--)(0, $0b1d1d862c9555a3$export$2e2bcd8739ae039)(result, paths[length]);
    return result;
});
var $0ebf216ff8bb14c6$export$2e2bcd8739ae039 = $0ebf216ff8bb14c6$var$omit;




var $gWKGw = parcelRequire("gWKGw");


var $e1dAa = parcelRequire("e1dAa");
/** Used for built-in method references. */ var $7ca1670ad2be7672$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7ca1670ad2be7672$var$hasOwnProperty = $7ca1670ad2be7672$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $7ca1670ad2be7672$var$defaults = (0, $d3a1ecd30e34d299$export$2e2bcd8739ae039)(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && (0, $b6104ac0178f9577$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = (0, $e1dAa.default)(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || (0, $gWKGw.default)(value, $7ca1670ad2be7672$var$objectProto[key]) && !$7ca1670ad2be7672$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
var $7ca1670ad2be7672$export$2e2bcd8739ae039 = $7ca1670ad2be7672$var$defaults;



var $75VIz = parcelRequire("75VIz");

var $5SKhw = parcelRequire("5SKhw");



var $daOsy = parcelRequire("daOsy");

var $kT11y = parcelRequire("kT11y");

var $bGao0 = parcelRequire("bGao0");

var $2u3CM = parcelRequire("2u3CM");

var $cRjGZ = parcelRequire("cRjGZ");

var $lFgL3 = parcelRequire("lFgL3");
/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */ function $8daa841c663c8fbf$var$transform(object, iteratee, accumulator) {
    var isArr = (0, $kT11y.default)(object), isArrLike = isArr || (0, $bGao0.default)(object) || (0, $lFgL3.default)(object);
    iteratee = (0, $f5a9b0d134bf473a$export$2e2bcd8739ae039)(iteratee, 4);
    if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) accumulator = isArr ? new Ctor : [];
        else if ((0, $cRjGZ.default)(object)) accumulator = (0, $2u3CM.default)(Ctor) ? (0, $5SKhw.default)((0, $daOsy.default)(object)) : {};
        else accumulator = {};
    }
    (isArrLike ? (0, $75VIz.default) : (0, $8e73f2c5ccd1c151$export$2e2bcd8739ae039))(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
    });
    return accumulator;
}
var $8daa841c663c8fbf$export$2e2bcd8739ae039 = $8daa841c663c8fbf$var$transform;



var $cuezR = parcelRequire("cuezR");


/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $6ad4a5806d722bb1$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = (0, $f5a9b0d134bf473a$export$2e2bcd8739ae039)(iteratee, 3);
    (0, $8e73f2c5ccd1c151$export$2e2bcd8739ae039)(object, function(value, key, object) {
        (0, $cuezR.default)(result, key, iteratee(value, key, object));
    });
    return result;
}
var $6ad4a5806d722bb1$export$2e2bcd8739ae039 = $6ad4a5806d722bb1$var$mapValues;


function $a4fe492ece4426a3$var$NoopWrapper(props) {
    return props.children;
}
var $a4fe492ece4426a3$export$444b3ab0cb9aec40 = {
    PREVIOUS: 'PREV',
    NEXT: 'NEXT',
    TODAY: 'TODAY',
    DATE: 'DATE'
};
var $a4fe492ece4426a3$export$5cb791131c501f6a = {
    MONTH: 'month',
    WEEK: 'week',
    WORK_WEEK: 'work_week',
    DAY: 'day',
    AGENDA: 'agenda'
};
var $a4fe492ece4426a3$var$viewNames$1 = Object.keys($a4fe492ece4426a3$export$5cb791131c501f6a).map(function(k) {
    return $a4fe492ece4426a3$export$5cb791131c501f6a[k];
});
(0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func
]);
(0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).any;
(0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func;
/**
 * accepts either an array of builtin view names:
 *
 * ```
 * views={['month', 'day', 'agenda']}
 * ```
 *
 * or an object hash of the view name and the component (or boolean for builtin)
 *
 * ```
 * views={{
 *   month: true,
 *   week: false,
 *   workweek: WorkWeekViewComponent,
 * }}
 * ```
 */ (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf($a4fe492ece4426a3$var$viewNames$1)),
    (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).objectOf(function(prop, key) {
        var isBuiltinView = $a4fe492ece4426a3$var$viewNames$1.indexOf(key) !== -1 && typeof prop[key] === 'boolean';
        if (isBuiltinView) return null;
        else {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
            return (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).elementType.apply((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))), [
                prop,
                key
            ].concat(args));
        }
    })
]);
(0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf([
        'overlap',
        'no-overlap'
    ]),
    (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func
]);
function $a4fe492ece4426a3$var$notify(handler, args) {
    handler && handler.apply(null, [].concat(args));
}
/* eslint no-fallthrough: off */ var $a4fe492ece4426a3$var$MILLI = {
    seconds: 1000,
    minutes: 60000,
    hours: 3600000,
    day: 86400000
};
function $a4fe492ece4426a3$var$firstVisibleDay(date, localizer) {
    var firstOfMonth = $7cdbb81bd69b4527$export$38d7278c783c77a7(date, 'month');
    return $7cdbb81bd69b4527$export$38d7278c783c77a7(firstOfMonth, 'week', localizer.startOfWeek());
}
function $a4fe492ece4426a3$var$lastVisibleDay(date, localizer) {
    var endOfMonth = $7cdbb81bd69b4527$export$2d3c3037220ab47a(date, 'month');
    return $7cdbb81bd69b4527$export$2d3c3037220ab47a(endOfMonth, 'week', localizer.startOfWeek());
}
function $a4fe492ece4426a3$var$visibleDays(date, localizer) {
    var current = $a4fe492ece4426a3$var$firstVisibleDay(date, localizer), last = $a4fe492ece4426a3$var$lastVisibleDay(date, localizer), days = [];
    while($7cdbb81bd69b4527$export$489c007ed603c05d(current, last, 'day')){
        days.push(current);
        current = $7cdbb81bd69b4527$export$e16d8520af44a096(current, 1, 'day');
    }
    return days;
}
function $a4fe492ece4426a3$var$ceil(date, unit) {
    var floor = $7cdbb81bd69b4527$export$38d7278c783c77a7(date, unit);
    return $7cdbb81bd69b4527$export$9663ddc1cf085b32(floor, date) ? floor : $7cdbb81bd69b4527$export$e16d8520af44a096(floor, 1, unit);
}
function $a4fe492ece4426a3$var$range(start, end) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
    var current = start, days = [];
    while($7cdbb81bd69b4527$export$489c007ed603c05d(current, end, unit)){
        days.push(current);
        current = $7cdbb81bd69b4527$export$e16d8520af44a096(current, 1, unit);
    }
    return days;
}
function $a4fe492ece4426a3$var$merge(date, time) {
    if (time == null && date == null) return null;
    if (time == null) time = new Date();
    if (date == null) date = new Date();
    date = $7cdbb81bd69b4527$export$38d7278c783c77a7(date, 'day');
    date = $7cdbb81bd69b4527$export$8d468796d69cdad1(date, $7cdbb81bd69b4527$export$8d468796d69cdad1(time));
    date = $7cdbb81bd69b4527$export$666252b437cce0c7(date, $7cdbb81bd69b4527$export$666252b437cce0c7(time));
    date = $7cdbb81bd69b4527$export$4792e48abc550fa1(date, $7cdbb81bd69b4527$export$4792e48abc550fa1(time));
    return $7cdbb81bd69b4527$export$9a27fac83d67afd3(date, $7cdbb81bd69b4527$export$9a27fac83d67afd3(time));
}
function $a4fe492ece4426a3$var$isJustDate(date) {
    return $7cdbb81bd69b4527$export$8d468796d69cdad1(date) === 0 && $7cdbb81bd69b4527$export$666252b437cce0c7(date) === 0 && $7cdbb81bd69b4527$export$4792e48abc550fa1(date) === 0 && $7cdbb81bd69b4527$export$9a27fac83d67afd3(date) === 0;
}
function $a4fe492ece4426a3$var$diff(dateA, dateB, unit) {
    if (!unit || unit === 'milliseconds') return Math.abs(+dateA - +dateB); // the .round() handles an edge case
    // with DST where the total won't be exact
    // since one day in the range may be shorter/longer by an hour
    return Math.round(Math.abs(+$7cdbb81bd69b4527$export$38d7278c783c77a7(dateA, unit) / $a4fe492ece4426a3$var$MILLI[unit] - +$7cdbb81bd69b4527$export$38d7278c783c77a7(dateB, unit) / $a4fe492ece4426a3$var$MILLI[unit]));
}
var $a4fe492ece4426a3$var$localePropType = (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func
]);
function $a4fe492ece4426a3$var$_format(localizer, formatter, value, format, culture) {
    var result = typeof format === 'function' ? format(value, culture, localizer) : formatter.call(localizer, value, format, culture);
    (0, (/*@__PURE__*/$parcel$interopDefault($d787f36c95e388b1$exports)))(result == null || typeof result === 'string', '`localizer format(..)` must return a string, null, or undefined');
    return result;
}
/**
 * This date conversion was moved out of TimeSlots.js, to
 * allow for localizer override
 * @param {Date} dt - The date to start from
 * @param {Number} minutesFromMidnight
 * @param {Number} offset
 * @returns {Date}
 */ function $a4fe492ece4426a3$var$getSlotDate(dt, minutesFromMidnight, offset) {
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, minutesFromMidnight + offset, 0, 0);
}
function $a4fe492ece4426a3$var$getDstOffset(start, end) {
    return start.getTimezoneOffset() - end.getTimezoneOffset();
} // if the start is on a DST-changing day but *after* the moment of DST
// transition we need to add those extra minutes to our minutesFromMidnight
function $a4fe492ece4426a3$var$getTotalMin(start, end) {
    return $a4fe492ece4426a3$var$diff(start, end, 'minutes') + $a4fe492ece4426a3$var$getDstOffset(start, end);
}
function $a4fe492ece4426a3$var$getMinutesFromMidnight(start) {
    var daystart = (0, $7cdbb81bd69b4527$export$38d7278c783c77a7)(start, 'day');
    return $a4fe492ece4426a3$var$diff(daystart, start, 'minutes') + $a4fe492ece4426a3$var$getDstOffset(daystart, start);
} // These two are used by DateSlotMetrics
function $a4fe492ece4426a3$var$continuesPrior(start, first) {
    return (0, $7cdbb81bd69b4527$export$b961576059b7aeb6)(start, first, 'day');
}
function $a4fe492ece4426a3$var$continuesAfter(start, end, last) {
    var singleDayDuration = (0, $7cdbb81bd69b4527$export$9663ddc1cf085b32)(start, end, 'minutes');
    return singleDayDuration ? (0, $7cdbb81bd69b4527$export$aac79e834d1b4aed)(end, last, 'minutes') : (0, $7cdbb81bd69b4527$export$dafeacbfe3530cd9)(end, last, 'minutes');
} // These two are used by eventLevels
function $a4fe492ece4426a3$var$sortEvents$1(_ref) {
    var _ref$evtA = _ref.evtA, aStart = _ref$evtA.start, aEnd = _ref$evtA.end, aAllDay = _ref$evtA.allDay, _ref$evtB = _ref.evtB, bStart = _ref$evtB.start, bEnd = _ref$evtB.end, bAllDay = _ref$evtB.allDay;
    var startSort = +(0, $7cdbb81bd69b4527$export$38d7278c783c77a7)(aStart, 'day') - +(0, $7cdbb81bd69b4527$export$38d7278c783c77a7)(bStart, 'day');
    var durA = $a4fe492ece4426a3$var$diff(aStart, $a4fe492ece4426a3$var$ceil(aEnd, 'day'), 'day');
    var durB = $a4fe492ece4426a3$var$diff(bStart, $a4fe492ece4426a3$var$ceil(bEnd, 'day'), 'day');
    return startSort || // sort by start Day first
    Math.max(durB, 1) - Math.max(durA, 1) || // events spanning multiple days go first
    !!bAllDay - !!aAllDay || // then allDay single day events
    +aStart - +bStart || // then sort by start time
    +aEnd - +bEnd // then sort by end time
    ;
}
function $a4fe492ece4426a3$var$inEventRange(_ref2) {
    var _ref2$event = _ref2.event, start = _ref2$event.start, end = _ref2$event.end, _ref2$range = _ref2.range, rangeStart = _ref2$range.start, rangeEnd = _ref2$range.end;
    var eStart = (0, $7cdbb81bd69b4527$export$38d7278c783c77a7)(start, 'day');
    var startsBeforeEnd = (0, $7cdbb81bd69b4527$export$489c007ed603c05d)(eStart, rangeEnd, 'day'); // when the event is zero duration we need to handle a bit differently
    var sameMin = (0, $7cdbb81bd69b4527$export$9bc858421bf255d1)(eStart, end, 'minutes');
    var endsAfterStart = sameMin ? (0, $7cdbb81bd69b4527$export$dafeacbfe3530cd9)(end, rangeStart, 'minutes') : (0, $7cdbb81bd69b4527$export$aac79e834d1b4aed)(end, rangeStart, 'minutes');
    return startsBeforeEnd && endsAfterStart;
} // other localizers treats 'day' and 'date' equality very differently, so we
// abstract the change the 'localizer.eq(date1, date2, 'day') into this
// new method, where they can be treated correctly by the localizer overrides
function $a4fe492ece4426a3$var$isSameDate(date1, date2) {
    return (0, $7cdbb81bd69b4527$export$9663ddc1cf085b32)(date1, date2, 'day');
}
function $a4fe492ece4426a3$var$startAndEndAreDateOnly(start, end) {
    return $a4fe492ece4426a3$var$isJustDate(start) && $a4fe492ece4426a3$var$isJustDate(end);
}
var $a4fe492ece4426a3$export$193ddab16544ff5b = /*#__PURE__*/ (0, $8HiBB.default)(function DateLocalizer(spec) {
    var _this = this;
    (0, $9VR4w.default)(this, DateLocalizer);
    (0, (/*@__PURE__*/$parcel$interopDefault($d787f36c95e388b1$exports)))(typeof spec.format === 'function', 'date localizer `format(..)` must be a function');
    (0, (/*@__PURE__*/$parcel$interopDefault($d787f36c95e388b1$exports)))(typeof spec.firstOfWeek === 'function', 'date localizer `firstOfWeek(..)` must be a function');
    this.propType = spec.propType || $a4fe492ece4426a3$var$localePropType;
    this.formats = spec.formats;
    this.format = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return $a4fe492ece4426a3$var$_format.apply(void 0, [
            _this,
            spec.format
        ].concat(args));
    }; // These date arithmetic methods can be overriden by the localizer
    this.startOfWeek = spec.firstOfWeek;
    this.merge = spec.merge || $a4fe492ece4426a3$var$merge;
    this.inRange = spec.inRange || (0, $7cdbb81bd69b4527$export$ddf89a9c5af38f94);
    this.lt = spec.lt || (0, $7cdbb81bd69b4527$export$b961576059b7aeb6);
    this.lte = spec.lte || (0, $7cdbb81bd69b4527$export$489c007ed603c05d);
    this.gt = spec.gt || (0, $7cdbb81bd69b4527$export$dafeacbfe3530cd9);
    this.gte = spec.gte || (0, $7cdbb81bd69b4527$export$aac79e834d1b4aed);
    this.eq = spec.eq || (0, $7cdbb81bd69b4527$export$9663ddc1cf085b32);
    this.neq = spec.neq || (0, $7cdbb81bd69b4527$export$9bc858421bf255d1);
    this.startOf = spec.startOf || (0, $7cdbb81bd69b4527$export$38d7278c783c77a7);
    this.endOf = spec.endOf || (0, $7cdbb81bd69b4527$export$2d3c3037220ab47a);
    this.add = spec.add || (0, $7cdbb81bd69b4527$export$e16d8520af44a096);
    this.range = spec.range || $a4fe492ece4426a3$var$range;
    this.diff = spec.diff || $a4fe492ece4426a3$var$diff;
    this.ceil = spec.ceil || $a4fe492ece4426a3$var$ceil;
    this.min = spec.min || (0, $7cdbb81bd69b4527$export$96ec731ed4dcb222);
    this.max = spec.max || (0, $7cdbb81bd69b4527$export$8960430cfd85939f);
    this.minutes = spec.minutes || (0, $7cdbb81bd69b4527$export$666252b437cce0c7);
    this.firstVisibleDay = spec.firstVisibleDay || $a4fe492ece4426a3$var$firstVisibleDay;
    this.lastVisibleDay = spec.lastVisibleDay || $a4fe492ece4426a3$var$lastVisibleDay;
    this.visibleDays = spec.visibleDays || $a4fe492ece4426a3$var$visibleDays;
    this.getSlotDate = spec.getSlotDate || $a4fe492ece4426a3$var$getSlotDate;
    this.getTimezoneOffset = spec.getTimezoneOffset || function(value) {
        return value.getTimezoneOffset();
    };
    this.getDstOffset = spec.getDstOffset || $a4fe492ece4426a3$var$getDstOffset;
    this.getTotalMin = spec.getTotalMin || $a4fe492ece4426a3$var$getTotalMin;
    this.getMinutesFromMidnight = spec.getMinutesFromMidnight || $a4fe492ece4426a3$var$getMinutesFromMidnight;
    this.continuesPrior = spec.continuesPrior || $a4fe492ece4426a3$var$continuesPrior;
    this.continuesAfter = spec.continuesAfter || $a4fe492ece4426a3$var$continuesAfter;
    this.sortEvents = spec.sortEvents || $a4fe492ece4426a3$var$sortEvents$1;
    this.inEventRange = spec.inEventRange || $a4fe492ece4426a3$var$inEventRange;
    this.isSameDate = spec.isSameDate || $a4fe492ece4426a3$var$isSameDate;
    this.startAndEndAreDateOnly = spec.startAndEndAreDateOnly || $a4fe492ece4426a3$var$startAndEndAreDateOnly;
    this.segmentOffset = spec.browserTZOffset ? spec.browserTZOffset() : 0;
});
function $a4fe492ece4426a3$var$mergeWithDefaults(localizer, culture, formatOverrides, messages) {
    var formats = (0, $cdb445c333a43100$export$2e2bcd8739ae039)((0, $cdb445c333a43100$export$2e2bcd8739ae039)({}, localizer.formats), formatOverrides);
    return (0, $cdb445c333a43100$export$2e2bcd8739ae039)((0, $cdb445c333a43100$export$2e2bcd8739ae039)({}, localizer), {}, {
        messages: messages,
        startOfWeek: function startOfWeek() {
            return localizer.startOfWeek(culture);
        },
        format: function format(value, _format2) {
            return localizer.format(value, formats[_format2] || _format2, culture);
        }
    });
}
var $a4fe492ece4426a3$var$defaultMessages = {
    date: 'Date',
    time: 'Time',
    event: 'Event',
    allDay: 'All Day',
    week: 'Week',
    work_week: 'Work Week',
    day: 'Day',
    month: 'Month',
    previous: 'Back',
    next: 'Next',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    today: 'Today',
    agenda: 'Agenda',
    noEventsInRange: 'There are no events in this range.',
    showMore: function showMore(total) {
        return "+".concat(total, " more");
    }
};
function $a4fe492ece4426a3$var$messages(msgs) {
    return (0, $cdb445c333a43100$export$2e2bcd8739ae039)((0, $cdb445c333a43100$export$2e2bcd8739ae039)({}, $a4fe492ece4426a3$var$defaultMessages), msgs);
}
function $a4fe492ece4426a3$var$useClickOutside(_ref) {
    var ref = _ref.ref, callback = _ref.callback;
    (0, $6fFrj.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(e) {
            if (ref.current && !ref.current.contains(e.target)) callback();
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function() {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref,
        callback
    ]);
}
var $a4fe492ece4426a3$var$_excluded$7 = [
    "style",
    "className",
    "event",
    "selected",
    "isAllDay",
    "onSelect",
    "onDoubleClick",
    "onKeyPress",
    "localizer",
    "continuesPrior",
    "continuesAfter",
    "accessors",
    "getters",
    "children",
    "components",
    "slotStart",
    "slotEnd"
];
var $a4fe492ece4426a3$var$EventCell = /*#__PURE__*/ function(_React$Component) {
    (0, $2tFMC.default)(EventCell, _React$Component);
    var _super = (0, $5d4b78f32a0ca363$export$2e2bcd8739ae039)(EventCell);
    function EventCell() {
        (0, $9VR4w.default)(this, EventCell);
        return _super.apply(this, arguments);
    }
    (0, $8HiBB.default)(EventCell, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, style = _this$props.style, className = _this$props.className, event = _this$props.event, selected = _this$props.selected, isAllDay = _this$props.isAllDay, onSelect = _this$props.onSelect, _onDoubleClick = _this$props.onDoubleClick, _onKeyPress = _this$props.onKeyPress, localizer = _this$props.localizer, continuesPrior = _this$props.continuesPrior, continuesAfter = _this$props.continuesAfter, accessors = _this$props.accessors, getters = _this$props.getters, children = _this$props.children, _this$props$component = _this$props.components, Event = _this$props$component.event, EventWrapper = _this$props$component.eventWrapper, slotStart = _this$props.slotStart, slotEnd = _this$props.slotEnd, props = (0, $7a2c209832ffd573$export$2e2bcd8739ae039)(_this$props, $a4fe492ece4426a3$var$_excluded$7);
                delete props.resizable;
                var title = accessors.title(event);
                var tooltip = accessors.tooltip(event);
                var end = accessors.end(event);
                var start = accessors.start(event);
                var allDay = accessors.allDay(event);
                var showAsAllDay = isAllDay || allDay || localizer.diff(start, localizer.ceil(end, 'day'), 'day') > 1;
                var userProps = getters.eventProp(event, start, end, selected);
                var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "rbc-event-content",
                    title: tooltip || undefined
                }, Event ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Event, {
                    event: event,
                    continuesPrior: continuesPrior,
                    continuesAfter: continuesAfter,
                    title: title,
                    isAllDay: allDay,
                    localizer: localizer,
                    slotStart: slotStart,
                    slotEnd: slotEnd
                }) : title);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(EventWrapper, Object.assign({}, this.props, {
                    type: "date"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", Object.assign({}, props, {
                    tabIndex: 0,
                    style: (0, $cdb445c333a43100$export$2e2bcd8739ae039)((0, $cdb445c333a43100$export$2e2bcd8739ae039)({}, userProps.style), style),
                    className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)('rbc-event', className, userProps.className, {
                        'rbc-selected': selected,
                        'rbc-event-allday': showAsAllDay,
                        'rbc-event-continues-prior': continuesPrior,
                        'rbc-event-continues-after': continuesAfter
                    }),
                    onClick: function onClick(e) {
                        return onSelect && onSelect(event, e);
                    },
                    onDoubleClick: function onDoubleClick(e) {
                        return _onDoubleClick && _onDoubleClick(event, e);
                    },
                    onKeyPress: function onKeyPress(e) {
                        return _onKeyPress && _onKeyPress(event, e);
                    }
                }), typeof children === 'function' ? children(content) : content));
            }
        }
    ]);
    return EventCell;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
function $a4fe492ece4426a3$var$isSelected(event, selected) {
    if (!event || selected == null) return false;
    return (0, $dd617d4ba77198f5$export$2e2bcd8739ae039)(event, selected);
}
function $a4fe492ece4426a3$var$slotWidth(rowBox, slots) {
    var rowWidth = rowBox.right - rowBox.left;
    var cellWidth = rowWidth / slots;
    return cellWidth;
}
function $a4fe492ece4426a3$var$getSlotAtX(rowBox, x, rtl, slots) {
    var cellWidth = $a4fe492ece4426a3$var$slotWidth(rowBox, slots);
    return rtl ? slots - 1 - Math.floor((x - rowBox.left) / cellWidth) : Math.floor((x - rowBox.left) / cellWidth);
}
function $a4fe492ece4426a3$var$pointInBox(box, _ref) {
    var x = _ref.x, y = _ref.y;
    return y >= box.top && y <= box.bottom && x >= box.left && x <= box.right;
}
function $a4fe492ece4426a3$var$dateCellSelection(start, rowBox, box, slots, rtl) {
    var startIdx = -1;
    var endIdx = -1;
    var lastSlotIdx = slots - 1;
    var cellWidth = $a4fe492ece4426a3$var$slotWidth(rowBox, slots); // cell under the mouse
    var currentSlot = $a4fe492ece4426a3$var$getSlotAtX(rowBox, box.x, rtl, slots); // Identify row as either the initial row
    // or the row under the current mouse point
    var isCurrentRow = rowBox.top < box.y && rowBox.bottom > box.y;
    var isStartRow = rowBox.top < start.y && rowBox.bottom > start.y; // this row's position relative to the start point
    var isAboveStart = start.y > rowBox.bottom;
    var isBelowStart = rowBox.top > start.y;
    var isBetween = box.top < rowBox.top && box.bottom > rowBox.bottom; // this row is between the current and start rows, so entirely selected
    if (isBetween) {
        startIdx = 0;
        endIdx = lastSlotIdx;
    }
    if (isCurrentRow) {
        if (isBelowStart) {
            startIdx = 0;
            endIdx = currentSlot;
        } else if (isAboveStart) {
            startIdx = currentSlot;
            endIdx = lastSlotIdx;
        }
    }
    if (isStartRow) {
        // select the cell under the initial point
        startIdx = endIdx = rtl ? lastSlotIdx - Math.floor((start.x - rowBox.left) / cellWidth) : Math.floor((start.x - rowBox.left) / cellWidth);
        if (isCurrentRow) {
            if (currentSlot < startIdx) startIdx = currentSlot;
            else endIdx = currentSlot; //select current range
        } else if (start.y < box.y) // the current row is below start row
        // select cells to the right of the start cell
        endIdx = lastSlotIdx;
        else // select cells to the left of the start cell
        startIdx = 0;
    }
    return {
        startIdx: startIdx,
        endIdx: endIdx
    };
}
/**
 * Changes to react-overlays cause issue with auto positioning,
 * so we need to manually calculate the position of the popper,
 * and constrain it to the Month container.
 */ function $a4fe492ece4426a3$var$getPosition(_ref) {
    var target = _ref.target, offset = _ref.offset, container = _ref.container, box = _ref.box;
    var _getOffset = (0, $dab096c73737ab95$export$2e2bcd8739ae039)(target), top = _getOffset.top, left = _getOffset.left, width = _getOffset.width, height = _getOffset.height;
    var _getOffset2 = (0, $dab096c73737ab95$export$2e2bcd8739ae039)(container), cTop = _getOffset2.top, cLeft = _getOffset2.left, cWidth = _getOffset2.width, cHeight = _getOffset2.height;
    var _getOffset3 = (0, $dab096c73737ab95$export$2e2bcd8739ae039)(box), bWidth = _getOffset3.width, bHeight = _getOffset3.height;
    var viewBottom = cTop + cHeight;
    var viewRight = cLeft + cWidth;
    var bottom = top + bHeight;
    var right = left + bWidth;
    var x = offset.x, y = offset.y;
    var topOffset = bottom > viewBottom ? top - bHeight - y : top + y + height;
    var leftOffset = right > viewRight ? left + x - bWidth + width : left + x;
    return {
        topOffset: topOffset,
        leftOffset: leftOffset
    };
}
function $a4fe492ece4426a3$var$Pop(_ref2) {
    var containerRef = _ref2.containerRef, accessors = _ref2.accessors, getters = _ref2.getters, selected = _ref2.selected, components = _ref2.components, localizer = _ref2.localizer, position = _ref2.position, show = _ref2.show, events = _ref2.events, slotStart = _ref2.slotStart, slotEnd = _ref2.slotEnd, onSelect = _ref2.onSelect, onDoubleClick = _ref2.onDoubleClick, onKeyPress = _ref2.onKeyPress, handleDragStart = _ref2.handleDragStart, popperRef = _ref2.popperRef, target = _ref2.target, offset = _ref2.offset;
    $a4fe492ece4426a3$var$useClickOutside({
        ref: popperRef,
        callback: show
    });
    (0, $6fFrj.useLayoutEffect)(function() {
        var _getPosition = $a4fe492ece4426a3$var$getPosition({
            target: target,
            offset: offset,
            container: containerRef.current,
            box: popperRef.current
        }), topOffset = _getPosition.topOffset, leftOffset = _getPosition.leftOffset;
        popperRef.current.style.top = "".concat(topOffset, "px");
        popperRef.current.style.left = "".concat(leftOffset, "px");
    }, [
        offset.x,
        offset.y,
        target
    ]);
    var width = position.width;
    var style = {
        minWidth: width + width / 2
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        style: style,
        className: "rbc-overlay",
        ref: popperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "rbc-overlay-header"
    }, localizer.format(slotStart, 'dayHeaderFormat')), events.map(function(event, idx) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$EventCell, {
            key: idx,
            type: "popup",
            localizer: localizer,
            event: event,
            getters: getters,
            onSelect: onSelect,
            accessors: accessors,
            components: components,
            onDoubleClick: onDoubleClick,
            onKeyPress: onKeyPress,
            continuesPrior: localizer.lt(accessors.end(event), slotStart, 'day'),
            continuesAfter: localizer.gte(accessors.start(event), slotEnd, 'day'),
            slotStart: slotStart,
            slotEnd: slotEnd,
            selected: $a4fe492ece4426a3$var$isSelected(event, selected),
            draggable: true,
            onDragStart: function onDragStart() {
                return handleDragStart(event);
            },
            onDragEnd: function onDragEnd() {
                return show();
            }
        });
    }));
}
var $a4fe492ece4426a3$var$Popup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$Pop, Object.assign({}, props, {
        popperRef: ref
    }));
});
$a4fe492ece4426a3$var$Popup.propTypes = {
    accessors: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
    getters: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
    localizer: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
    position: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
    show: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired,
    events: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).array.isRequired,
    slotStart: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date).isRequired,
    slotEnd: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date),
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onKeyPress: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    handleDragStart: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object,
    offset: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    })
};
function $a4fe492ece4426a3$var$CalOverlay(_ref) {
    var containerRef = _ref.containerRef, _ref$popupOffset = _ref.popupOffset, popupOffset = _ref$popupOffset === void 0 ? 5 : _ref$popupOffset, overlay = _ref.overlay, accessors = _ref.accessors, localizer = _ref.localizer, components = _ref.components, getters = _ref.getters, selected = _ref.selected, handleSelectEvent = _ref.handleSelectEvent, handleDoubleClickEvent = _ref.handleDoubleClickEvent, handleKeyPressEvent = _ref.handleKeyPressEvent, handleDragStart = _ref.handleDragStart, onHide = _ref.onHide, overlayDisplay = _ref.overlayDisplay;
    var popperRef = (0, $6fFrj.useRef)(null);
    if (!overlay.position) return null;
    var offset = popupOffset;
    if (!isNaN(popupOffset)) offset = {
        x: popupOffset,
        y: popupOffset
    };
    var position = overlay.position, events = overlay.events, date = overlay.date, end = overlay.end;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $2a66f2b0fbdb02a3$export$2e2bcd8739ae039), {
        rootClose: true,
        flip: true,
        show: true,
        placement: "bottom",
        onHide: onHide,
        target: overlay.target
    }, function(_ref2) {
        var props = _ref2.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$Popup, Object.assign({}, props, {
            containerRef: containerRef,
            ref: popperRef,
            target: overlay.target,
            offset: offset,
            accessors: accessors,
            getters: getters,
            selected: selected,
            components: components,
            localizer: localizer,
            position: position,
            show: overlayDisplay,
            events: events,
            slotStart: date,
            slotEnd: end,
            onSelect: handleSelectEvent,
            onDoubleClick: handleDoubleClickEvent,
            onKeyPress: handleKeyPressEvent,
            handleDragStart: handleDragStart
        }));
    });
}
var $a4fe492ece4426a3$var$PopOverlay = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$CalOverlay, Object.assign({}, props, {
        containerRef: ref
    }));
});
$a4fe492ece4426a3$var$PopOverlay.propTypes = {
    popupOffset: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).shape({
            x: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
            y: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
        })
    ]),
    overlay: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).shape({
        position: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object,
        events: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).array,
        date: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date),
        end: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date)
    }),
    accessors: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
    localizer: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
    getters: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object,
    handleSelectEvent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    handleDoubleClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    handleKeyPressEvent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    handleDragStart: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onHide: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    overlayDisplay: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func
};
function $a4fe492ece4426a3$var$addEventListener(type, handler) {
    var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
    return (0, $25161fa21ce574ca$export$2e2bcd8739ae039)(target, type, handler, {
        passive: false
    });
}
function $a4fe492ece4426a3$var$isOverContainer(container, x, y) {
    return !container || (0, $436ea1d5df77ecaa$export$2e2bcd8739ae039)(container, document.elementFromPoint(x, y));
}
function $a4fe492ece4426a3$var$getEventNodeFromPoint(node, _ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    var target = document.elementFromPoint(clientX, clientY);
    return (0, $0a2edc8ddb1d37ab$export$2e2bcd8739ae039)(target, '.rbc-event', node);
}
function $a4fe492ece4426a3$var$isEvent(node, bounds) {
    return !!$a4fe492ece4426a3$var$getEventNodeFromPoint(node, bounds);
}
function $a4fe492ece4426a3$var$getEventCoordinates(e) {
    var target = e;
    if (e.touches && e.touches.length) target = e.touches[0];
    return {
        clientX: target.clientX,
        clientY: target.clientY,
        pageX: target.pageX,
        pageY: target.pageY
    };
}
var $a4fe492ece4426a3$var$clickTolerance = 5;
var $a4fe492ece4426a3$var$clickInterval = 250;
var $a4fe492ece4426a3$var$Selection = /*#__PURE__*/ function() {
    function Selection(node) {
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$global = _ref2.global, global = _ref2$global === void 0 ? false : _ref2$global, _ref2$longPressThresh = _ref2.longPressThreshold, longPressThreshold = _ref2$longPressThresh === void 0 ? 250 : _ref2$longPressThresh, _ref2$validContainers = _ref2.validContainers, validContainers = _ref2$validContainers === void 0 ? [] : _ref2$validContainers;
        (0, $9VR4w.default)(this, Selection);
        this.isDetached = false;
        this.container = node;
        this.globalMouse = !node || global;
        this.longPressThreshold = longPressThreshold;
        this.validContainers = validContainers;
        this._listeners = Object.create(null);
        this._handleInitialEvent = this._handleInitialEvent.bind(this);
        this._handleMoveEvent = this._handleMoveEvent.bind(this);
        this._handleTerminatingEvent = this._handleTerminatingEvent.bind(this);
        this._keyListener = this._keyListener.bind(this);
        this._dropFromOutsideListener = this._dropFromOutsideListener.bind(this);
        this._dragOverFromOutsideListener = this._dragOverFromOutsideListener.bind(this); // Fixes an iOS 10 bug where scrolling could not be prevented on the window.
        // https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356
        this._removeTouchMoveWindowListener = $a4fe492ece4426a3$var$addEventListener('touchmove', function() {}, window);
        this._removeKeyDownListener = $a4fe492ece4426a3$var$addEventListener('keydown', this._keyListener);
        this._removeKeyUpListener = $a4fe492ece4426a3$var$addEventListener('keyup', this._keyListener);
        this._removeDropFromOutsideListener = $a4fe492ece4426a3$var$addEventListener('drop', this._dropFromOutsideListener);
        this._removeDragOverFromOutsideListener = $a4fe492ece4426a3$var$addEventListener('dragover', this._dragOverFromOutsideListener);
        this._addInitialEventListener();
    }
    (0, $8HiBB.default)(Selection, [
        {
            key: "on",
            value: function on(type, handler) {
                var handlers = this._listeners[type] || (this._listeners[type] = []);
                handlers.push(handler);
                return {
                    remove: function remove() {
                        var idx = handlers.indexOf(handler);
                        if (idx !== -1) handlers.splice(idx, 1);
                    }
                };
            }
        },
        {
            key: "emit",
            value: function emit(type) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                var result;
                var handlers = this._listeners[type] || [];
                handlers.forEach(function(fn) {
                    if (result === undefined) result = fn.apply(void 0, args);
                });
                return result;
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                this.isDetached = true;
                this._listeners = Object.create(null);
                this._removeTouchMoveWindowListener && this._removeTouchMoveWindowListener();
                this._removeInitialEventListener && this._removeInitialEventListener();
                this._removeEndListener && this._removeEndListener();
                this._onEscListener && this._onEscListener();
                this._removeMoveListener && this._removeMoveListener();
                this._removeKeyUpListener && this._removeKeyUpListener();
                this._removeKeyDownListener && this._removeKeyDownListener();
                this._removeDropFromOutsideListener && this._removeDropFromOutsideListener();
                this._removeDragOverFromOutsideListener && this._removeDragOverFromOutsideListener();
            }
        },
        {
            key: "isSelected",
            value: function isSelected(node) {
                var box = this._selectRect;
                if (!box || !this.selecting) return false;
                return $a4fe492ece4426a3$var$objectsCollide(box, $a4fe492ece4426a3$var$getBoundsForNode(node));
            }
        },
        {
            key: "filter",
            value: function filter(items) {
                var box = this._selectRect; //not selecting
                if (!box || !this.selecting) return [];
                return items.filter(this.isSelected, this);
            } // Adds a listener that will call the handler only after the user has pressed on the screen
        },
        {
            key: "_addLongPressListener",
            value: function _addLongPressListener(handler, initialEvent) {
                var _this = this;
                var timer = null;
                var removeTouchMoveListener = null;
                var removeTouchEndListener = null;
                var handleTouchStart = function handleTouchStart(initialEvent) {
                    timer = setTimeout(function() {
                        cleanup();
                        handler(initialEvent);
                    }, _this.longPressThreshold);
                    removeTouchMoveListener = $a4fe492ece4426a3$var$addEventListener('touchmove', function() {
                        return cleanup();
                    });
                    removeTouchEndListener = $a4fe492ece4426a3$var$addEventListener('touchend', function() {
                        return cleanup();
                    });
                };
                var removeTouchStartListener = $a4fe492ece4426a3$var$addEventListener('touchstart', handleTouchStart);
                var cleanup = function cleanup() {
                    if (timer) clearTimeout(timer);
                    if (removeTouchMoveListener) removeTouchMoveListener();
                    if (removeTouchEndListener) removeTouchEndListener();
                    timer = null;
                    removeTouchMoveListener = null;
                    removeTouchEndListener = null;
                };
                if (initialEvent) handleTouchStart(initialEvent);
                return function() {
                    cleanup();
                    removeTouchStartListener();
                };
            } // Listen for mousedown and touchstart events. When one is received, disable the other and setup
        },
        {
            key: "_addInitialEventListener",
            value: function _addInitialEventListener() {
                var _this2 = this;
                var removeMouseDownListener = $a4fe492ece4426a3$var$addEventListener('mousedown', function(e) {
                    _this2._removeInitialEventListener();
                    _this2._handleInitialEvent(e);
                    _this2._removeInitialEventListener = $a4fe492ece4426a3$var$addEventListener('mousedown', _this2._handleInitialEvent);
                });
                var removeTouchStartListener = $a4fe492ece4426a3$var$addEventListener('touchstart', function(e) {
                    _this2._removeInitialEventListener();
                    _this2._removeInitialEventListener = _this2._addLongPressListener(_this2._handleInitialEvent, e);
                });
                this._removeInitialEventListener = function() {
                    removeMouseDownListener();
                    removeTouchStartListener();
                };
            }
        },
        {
            key: "_dropFromOutsideListener",
            value: function _dropFromOutsideListener(e) {
                var _getEventCoordinates = $a4fe492ece4426a3$var$getEventCoordinates(e), pageX = _getEventCoordinates.pageX, pageY = _getEventCoordinates.pageY, clientX = _getEventCoordinates.clientX, clientY = _getEventCoordinates.clientY;
                this.emit('dropFromOutside', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                e.preventDefault();
            }
        },
        {
            key: "_dragOverFromOutsideListener",
            value: function _dragOverFromOutsideListener(e) {
                var _getEventCoordinates2 = $a4fe492ece4426a3$var$getEventCoordinates(e), pageX = _getEventCoordinates2.pageX, pageY = _getEventCoordinates2.pageY, clientX = _getEventCoordinates2.clientX, clientY = _getEventCoordinates2.clientY;
                this.emit('dragOverFromOutside', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                e.preventDefault();
            }
        },
        {
            key: "_handleInitialEvent",
            value: function _handleInitialEvent(e) {
                if (this.isDetached) return;
                var _getEventCoordinates3 = $a4fe492ece4426a3$var$getEventCoordinates(e), clientX = _getEventCoordinates3.clientX, clientY = _getEventCoordinates3.clientY, pageX = _getEventCoordinates3.pageX, pageY = _getEventCoordinates3.pageY;
                var node = this.container(), collides, offsetData; // Right clicks
                if (e.which === 3 || e.button === 2 || !$a4fe492ece4426a3$var$isOverContainer(node, clientX, clientY)) return;
                if (!this.globalMouse && node && !(0, $436ea1d5df77ecaa$export$2e2bcd8739ae039)(node, e.target)) {
                    var _normalizeDistance = $a4fe492ece4426a3$var$normalizeDistance(0), top = _normalizeDistance.top, left = _normalizeDistance.left, bottom = _normalizeDistance.bottom, right = _normalizeDistance.right;
                    offsetData = $a4fe492ece4426a3$var$getBoundsForNode(node);
                    collides = $a4fe492ece4426a3$var$objectsCollide({
                        top: offsetData.top - top,
                        left: offsetData.left - left,
                        bottom: offsetData.bottom + bottom,
                        right: offsetData.right + right
                    }, {
                        top: pageY,
                        left: pageX
                    });
                    if (!collides) return;
                }
                var result = this.emit('beforeSelect', this._initialEventData = {
                    isTouch: /^touch/.test(e.type),
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
                if (result === false) return;
                switch(e.type){
                    case 'mousedown':
                        this._removeEndListener = $a4fe492ece4426a3$var$addEventListener('mouseup', this._handleTerminatingEvent);
                        this._onEscListener = $a4fe492ece4426a3$var$addEventListener('keydown', this._handleTerminatingEvent);
                        this._removeMoveListener = $a4fe492ece4426a3$var$addEventListener('mousemove', this._handleMoveEvent);
                        break;
                    case 'touchstart':
                        this._handleMoveEvent(e);
                        this._removeEndListener = $a4fe492ece4426a3$var$addEventListener('touchend', this._handleTerminatingEvent);
                        this._removeMoveListener = $a4fe492ece4426a3$var$addEventListener('touchmove', this._handleMoveEvent);
                        break;
                }
            } // Check whether provided event target element
        },
        {
            key: "_isWithinValidContainer",
            value: function _isWithinValidContainer(e) {
                var eventTarget = e.target;
                var containers = this.validContainers;
                if (!containers || !containers.length || !eventTarget) return true;
                return containers.some(function(target) {
                    return !!eventTarget.closest(target);
                });
            }
        },
        {
            key: "_handleTerminatingEvent",
            value: function _handleTerminatingEvent(e) {
                var _getEventCoordinates4 = $a4fe492ece4426a3$var$getEventCoordinates(e), pageX = _getEventCoordinates4.pageX, pageY = _getEventCoordinates4.pageY;
                this.selecting = false;
                this._removeEndListener && this._removeEndListener();
                this._removeMoveListener && this._removeMoveListener();
                if (!this._initialEventData) return;
                var inRoot = !this.container || (0, $436ea1d5df77ecaa$export$2e2bcd8739ae039)(this.container(), e.target);
                var isWithinValidContainer = this._isWithinValidContainer(e);
                var bounds = this._selectRect;
                var click = this.isClick(pageX, pageY);
                this._initialEventData = null;
                if (e.key === 'Escape' || !isWithinValidContainer) return this.emit('reset');
                if (click && inRoot) return this._handleClickEvent(e);
                 // User drag-clicked in the Selectable area
                if (!click) return this.emit('select', bounds);
                return this.emit('reset');
            }
        },
        {
            key: "_handleClickEvent",
            value: function _handleClickEvent(e) {
                var _getEventCoordinates5 = $a4fe492ece4426a3$var$getEventCoordinates(e), pageX = _getEventCoordinates5.pageX, pageY = _getEventCoordinates5.pageY, clientX = _getEventCoordinates5.clientX, clientY = _getEventCoordinates5.clientY;
                var now = new Date().getTime();
                if (this._lastClickData && now - this._lastClickData.timestamp < $a4fe492ece4426a3$var$clickInterval) {
                    // Double click event
                    this._lastClickData = null;
                    return this.emit('doubleClick', {
                        x: pageX,
                        y: pageY,
                        clientX: clientX,
                        clientY: clientY
                    });
                } // Click event
                this._lastClickData = {
                    timestamp: now
                };
                return this.emit('click', {
                    x: pageX,
                    y: pageY,
                    clientX: clientX,
                    clientY: clientY
                });
            }
        },
        {
            key: "_handleMoveEvent",
            value: function _handleMoveEvent(e) {
                if (this._initialEventData === null || this.isDetached) return;
                var _this$_initialEventDa = this._initialEventData, x = _this$_initialEventDa.x, y = _this$_initialEventDa.y;
                var _getEventCoordinates6 = $a4fe492ece4426a3$var$getEventCoordinates(e), pageX = _getEventCoordinates6.pageX, pageY = _getEventCoordinates6.pageY;
                var w = Math.abs(x - pageX);
                var h = Math.abs(y - pageY);
                var left = Math.min(pageX, x), top = Math.min(pageY, y), old = this.selecting; // Prevent emitting selectStart event until mouse is moved.
                // in Chrome on Windows, mouseMove event may be fired just after mouseDown event.
                if (this.isClick(pageX, pageY) && !old && !(w || h)) return;
                this.selecting = true;
                this._selectRect = {
                    top: top,
                    left: left,
                    x: pageX,
                    y: pageY,
                    right: left + w,
                    bottom: top + h
                };
                if (!old) this.emit('selectStart', this._initialEventData);
                if (!this.isClick(pageX, pageY)) this.emit('selecting', this._selectRect);
                e.preventDefault();
            }
        },
        {
            key: "_keyListener",
            value: function _keyListener(e) {
                this.ctrl = e.metaKey || e.ctrlKey;
            }
        },
        {
            key: "isClick",
            value: function isClick(pageX, pageY) {
                var _this$_initialEventDa2 = this._initialEventData, x = _this$_initialEventDa2.x, y = _this$_initialEventDa2.y, isTouch = _this$_initialEventDa2.isTouch;
                return !isTouch && Math.abs(pageX - x) <= $a4fe492ece4426a3$var$clickTolerance && Math.abs(pageY - y) <= $a4fe492ece4426a3$var$clickTolerance;
            }
        }
    ]);
    return Selection;
}();
/**
 * Resolve the disance prop from either an Int or an Object
 * @return {Object}
 */ function $a4fe492ece4426a3$var$normalizeDistance() {
    var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if ((0, $6g7hW.default)(distance) !== 'object') distance = {
        top: distance,
        left: distance,
        right: distance,
        bottom: distance
    };
    return distance;
}
/**
 * Given two objects containing "top", "left", "offsetWidth" and "offsetHeight"
 * properties, determine if they collide.
 * @param  {Object|HTMLElement} a
 * @param  {Object|HTMLElement} b
 * @return {bool}
 */ function $a4fe492ece4426a3$var$objectsCollide(nodeA, nodeB) {
    var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var _getBoundsForNode = $a4fe492ece4426a3$var$getBoundsForNode(nodeA), aTop = _getBoundsForNode.top, aLeft = _getBoundsForNode.left, _getBoundsForNode$rig = _getBoundsForNode.right, aRight = _getBoundsForNode$rig === void 0 ? aLeft : _getBoundsForNode$rig, _getBoundsForNode$bot = _getBoundsForNode.bottom, aBottom = _getBoundsForNode$bot === void 0 ? aTop : _getBoundsForNode$bot;
    var _getBoundsForNode2 = $a4fe492ece4426a3$var$getBoundsForNode(nodeB), bTop = _getBoundsForNode2.top, bLeft = _getBoundsForNode2.left, _getBoundsForNode2$ri = _getBoundsForNode2.right, bRight = _getBoundsForNode2$ri === void 0 ? bLeft : _getBoundsForNode2$ri, _getBoundsForNode2$bo = _getBoundsForNode2.bottom, bBottom = _getBoundsForNode2$bo === void 0 ? bTop : _getBoundsForNode2$bo;
    return !(aBottom - tolerance < bTop || // 'a' top doesn't touch 'b' bottom
    aTop + tolerance > bBottom || // 'a' right doesn't touch 'b' left
    aRight - tolerance < bLeft || // 'a' left doesn't touch 'b' right
    aLeft + tolerance > bRight);
}
/**
 * Given a node, get everything needed to calculate its boundaries
 * @param  {HTMLElement} node
 * @return {Object}
 */ function $a4fe492ece4426a3$var$getBoundsForNode(node) {
    if (!node.getBoundingClientRect) return node;
    var rect = node.getBoundingClientRect(), left = rect.left + $a4fe492ece4426a3$var$pageOffset('left'), top = rect.top + $a4fe492ece4426a3$var$pageOffset('top');
    return {
        top: top,
        left: left,
        right: (node.offsetWidth || 0) + left,
        bottom: (node.offsetHeight || 0) + top
    };
}
function $a4fe492ece4426a3$var$pageOffset(dir) {
    if (dir === 'left') return window.pageXOffset || document.body.scrollLeft || 0;
    if (dir === 'top') return window.pageYOffset || document.body.scrollTop || 0;
}
var $a4fe492ece4426a3$var$BackgroundCells = /*#__PURE__*/ function(_React$Component) {
    (0, $2tFMC.default)(BackgroundCells, _React$Component);
    var _super = (0, $5d4b78f32a0ca363$export$2e2bcd8739ae039)(BackgroundCells);
    function BackgroundCells(props, context) {
        var _this;
        (0, $9VR4w.default)(this, BackgroundCells);
        _this = _super.call(this, props, context);
        _this.state = {
            selecting: false
        };
        _this.containerRef = /*#__PURE__*/ (0, $6fFrj.createRef)();
        return _this;
    }
    (0, $8HiBB.default)(BackgroundCells, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.selectable && this._selectable();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._teardownSelectable();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (!prevProps.selectable && this.props.selectable) this._selectable();
                if (prevProps.selectable && !this.props.selectable) this._teardownSelectable();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, range = _this$props.range, getNow = _this$props.getNow, getters = _this$props.getters, currentDate = _this$props.date, Wrapper = _this$props.components.dateCellWrapper, localizer = _this$props.localizer;
                var _this$state = this.state, selecting = _this$state.selecting, startIdx = _this$state.startIdx, endIdx = _this$state.endIdx;
                var current = getNow();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "rbc-row-bg",
                    ref: this.containerRef
                }, range.map(function(date, index) {
                    var selected = selecting && index >= startIdx && index <= endIdx;
                    var _getters$dayProp = getters.dayProp(date), className = _getters$dayProp.className, style = _getters$dayProp.style;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Wrapper, {
                        key: index,
                        value: date,
                        range: range
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                        style: style,
                        className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)('rbc-day-bg', className, selected && 'rbc-selected-cell', localizer.isSameDate(date, current) && 'rbc-today', currentDate && localizer.neq(currentDate, date, 'month') && 'rbc-off-range-bg')
                    }));
                }));
            }
        },
        {
            key: "_selectable",
            value: function _selectable() {
                var _this2 = this;
                var node = this.containerRef.current;
                var selector = this._selector = new $a4fe492ece4426a3$var$Selection(this.props.container, {
                    longPressThreshold: this.props.longPressThreshold
                });
                var selectorClicksHandler = function selectorClicksHandler(point, actionType) {
                    if (!$a4fe492ece4426a3$var$isEvent(node, point)) {
                        var rowBox = $a4fe492ece4426a3$var$getBoundsForNode(node);
                        var _this2$props = _this2.props, range = _this2$props.range, rtl = _this2$props.rtl;
                        if ($a4fe492ece4426a3$var$pointInBox(rowBox, point)) {
                            var currentCell = $a4fe492ece4426a3$var$getSlotAtX(rowBox, point.x, rtl, range.length);
                            _this2._selectSlot({
                                startIdx: currentCell,
                                endIdx: currentCell,
                                action: actionType,
                                box: point
                            });
                        }
                    }
                    _this2._initial = {};
                    _this2.setState({
                        selecting: false
                    });
                };
                selector.on('selecting', function(box) {
                    var _this2$props2 = _this2.props, range = _this2$props2.range, rtl = _this2$props2.rtl;
                    var startIdx = -1;
                    var endIdx = -1;
                    if (!_this2.state.selecting) {
                        $a4fe492ece4426a3$var$notify(_this2.props.onSelectStart, [
                            box
                        ]);
                        _this2._initial = {
                            x: box.x,
                            y: box.y
                        };
                    }
                    if (selector.isSelected(node)) {
                        var nodeBox = $a4fe492ece4426a3$var$getBoundsForNode(node);
                        var _dateCellSelection = $a4fe492ece4426a3$var$dateCellSelection(_this2._initial, nodeBox, box, range.length, rtl);
                        startIdx = _dateCellSelection.startIdx;
                        endIdx = _dateCellSelection.endIdx;
                    }
                    _this2.setState({
                        selecting: true,
                        startIdx: startIdx,
                        endIdx: endIdx
                    });
                });
                selector.on('beforeSelect', function(box) {
                    if (_this2.props.selectable !== 'ignoreEvents') return;
                    return !$a4fe492ece4426a3$var$isEvent(_this2.containerRef.current, box);
                });
                selector.on('click', function(point) {
                    return selectorClicksHandler(point, 'click');
                });
                selector.on('doubleClick', function(point) {
                    return selectorClicksHandler(point, 'doubleClick');
                });
                selector.on('select', function(bounds) {
                    _this2._selectSlot((0, $cdb445c333a43100$export$2e2bcd8739ae039)((0, $cdb445c333a43100$export$2e2bcd8739ae039)({}, _this2.state), {}, {
                        action: 'select',
                        bounds: bounds
                    }));
                    _this2._initial = {};
                    _this2.setState({
                        selecting: false
                    });
                    $a4fe492ece4426a3$var$notify(_this2.props.onSelectEnd, [
                        _this2.state
                    ]);
                });
            }
        },
        {
            key: "_teardownSelectable",
            value: function _teardownSelectable() {
                if (!this._selector) return;
                this._selector.teardown();
                this._selector = null;
            }
        },
        {
            key: "_selectSlot",
            value: function _selectSlot(_ref) {
                var endIdx = _ref.endIdx, startIdx = _ref.startIdx, action = _ref.action, bounds = _ref.bounds, box = _ref.box;
                if (endIdx !== -1 && startIdx !== -1) this.props.onSelectSlot && this.props.onSelectSlot({
                    start: startIdx,
                    end: endIdx,
                    action: action,
                    bounds: bounds,
                    box: box,
                    resourceId: this.props.resourceId
                });
            }
        }
    ]);
    return BackgroundCells;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
/* eslint-disable react/prop-types */ var $a4fe492ece4426a3$var$EventRowMixin = {
    propTypes: {
        slotMetrics: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object,
        isAllDay: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
        accessors: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
        localizer: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
        components: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
        getters: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
        onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
        onDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
        onKeyPress: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func
    },
    defaultProps: {
        segments: [],
        selected: {}
    },
    renderEvent: function renderEvent(props, event) {
        var selected = props.selected;
        props.isAllDay;
        var accessors = props.accessors, getters = props.getters, onSelect = props.onSelect, onDoubleClick = props.onDoubleClick, onKeyPress = props.onKeyPress, localizer = props.localizer, slotMetrics = props.slotMetrics, components = props.components, resizable = props.resizable;
        var continuesPrior = slotMetrics.continuesPrior(event);
        var continuesAfter = slotMetrics.continuesAfter(event);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$EventCell, {
            event: event,
            getters: getters,
            localizer: localizer,
            accessors: accessors,
            components: components,
            onSelect: onSelect,
            onDoubleClick: onDoubleClick,
            onKeyPress: onKeyPress,
            continuesPrior: continuesPrior,
            continuesAfter: continuesAfter,
            slotStart: slotMetrics.first,
            slotEnd: slotMetrics.last,
            selected: $a4fe492ece4426a3$var$isSelected(event, selected),
            resizable: resizable
        });
    },
    renderSpan: function renderSpan(slots, len, key) {
        var content = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
        var per = Math.abs(len) / slots * 100 + '%';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
            key: key,
            className: "rbc-row-segment" // IE10/11 need max-width. flex-basis doesn't respect box-sizing
            ,
            style: {
                WebkitFlexBasis: per,
                flexBasis: per,
                maxWidth: per
            }
        }, content);
    }
};
var $a4fe492ece4426a3$var$EventRow = /*#__PURE__*/ function(_React$Component) {
    (0, $2tFMC.default)(EventRow, _React$Component);
    var _super = (0, $5d4b78f32a0ca363$export$2e2bcd8739ae039)(EventRow);
    function EventRow() {
        (0, $9VR4w.default)(this, EventRow);
        return _super.apply(this, arguments);
    }
    (0, $8HiBB.default)(EventRow, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, segments = _this$props.segments, slots = _this$props.slotMetrics.slots, className = _this$props.className;
                var lastEnd = 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)(className, 'rbc-row')
                }, segments.reduce(function(row, _ref, li) {
                    var event = _ref.event, left = _ref.left, right = _ref.right, span = _ref.span;
                    var key = '_lvl_' + li;
                    var gap = left - lastEnd;
                    var content = $a4fe492ece4426a3$var$EventRowMixin.renderEvent(_this.props, event);
                    if (gap) row.push($a4fe492ece4426a3$var$EventRowMixin.renderSpan(slots, gap, "".concat(key, "_gap")));
                    row.push($a4fe492ece4426a3$var$EventRowMixin.renderSpan(slots, span, key, content));
                    lastEnd = right + 1;
                    return row;
                }, []));
            }
        }
    ]);
    return EventRow;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
$a4fe492ece4426a3$var$EventRow.defaultProps = (0, $cdb445c333a43100$export$2e2bcd8739ae039)({}, $a4fe492ece4426a3$var$EventRowMixin.defaultProps);
function $a4fe492ece4426a3$var$endOfRange(_ref) {
    var dateRange = _ref.dateRange, _ref$unit = _ref.unit, unit = _ref$unit === void 0 ? 'day' : _ref$unit, localizer = _ref.localizer;
    return {
        first: dateRange[0],
        last: localizer.add(dateRange[dateRange.length - 1], 1, unit)
    };
} // properly calculating segments requires working with dates in
// the timezone we're working with, so we use the localizer
function $a4fe492ece4426a3$var$eventSegments(event, range, accessors, localizer) {
    var _endOfRange = $a4fe492ece4426a3$var$endOfRange({
        dateRange: range,
        localizer: localizer
    }), first = _endOfRange.first, last = _endOfRange.last;
    var slots = localizer.diff(first, last, 'day');
    var start = localizer.max(localizer.startOf(accessors.start(event), 'day'), first);
    var end = localizer.min(localizer.ceil(accessors.end(event), 'day'), last);
    var padding = (0, $bf9524e4a68a67b0$export$2e2bcd8739ae039)(range, function(x) {
        return localizer.isSameDate(x, start);
    });
    var span = localizer.diff(start, end, 'day');
    span = Math.min(span, slots); // The segmentOffset is necessary when adjusting for timezones
    // ahead of the browser timezone
    span = Math.max(span - localizer.segmentOffset, 1);
    return {
        event: event,
        span: span,
        left: padding + 1,
        right: Math.max(padding + span, 1)
    };
}
function $a4fe492ece4426a3$var$eventLevels(rowSegments) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
    var i, j, seg, levels = [], extra = [];
    for(i = 0; i < rowSegments.length; i++){
        seg = rowSegments[i];
        for(j = 0; j < levels.length; j++){
            if (!$a4fe492ece4426a3$var$segsOverlap(seg, levels[j])) break;
        }
        if (j >= limit) extra.push(seg);
        else (levels[j] || (levels[j] = [])).push(seg);
    }
    for(i = 0; i < levels.length; i++)levels[i].sort(function(a, b) {
        return a.left - b.left;
    }); //eslint-disable-line
    return {
        levels: levels,
        extra: extra
    };
}
function $a4fe492ece4426a3$var$inRange(e, start, end, accessors, localizer) {
    var event = {
        start: accessors.start(e),
        end: accessors.end(e)
    };
    var range = {
        start: start,
        end: end
    };
    return localizer.inEventRange({
        event: event,
        range: range
    });
}
function $a4fe492ece4426a3$var$segsOverlap(seg, otherSegs) {
    return otherSegs.some(function(otherSeg) {
        return otherSeg.left <= seg.right && otherSeg.right >= seg.left;
    });
}
function $a4fe492ece4426a3$var$sortEvents(eventA, eventB, accessors, localizer) {
    var evtA = {
        start: accessors.start(eventA),
        end: accessors.end(eventA),
        allDay: accessors.allDay(eventA)
    };
    var evtB = {
        start: accessors.start(eventB),
        end: accessors.end(eventB),
        allDay: accessors.allDay(eventB)
    };
    return localizer.sortEvents({
        evtA: evtA,
        evtB: evtB
    });
}
var $a4fe492ece4426a3$var$isSegmentInSlot$1 = function isSegmentInSlot(seg, slot) {
    return seg.left <= slot && seg.right >= slot;
};
var $a4fe492ece4426a3$var$eventsInSlot = function eventsInSlot(segments, slot) {
    return segments.filter(function(seg) {
        return $a4fe492ece4426a3$var$isSegmentInSlot$1(seg, slot);
    }).length;
};
var $a4fe492ece4426a3$var$EventEndingRow = /*#__PURE__*/ function(_React$Component) {
    (0, $2tFMC.default)(EventEndingRow, _React$Component);
    var _super = (0, $5d4b78f32a0ca363$export$2e2bcd8739ae039)(EventEndingRow);
    function EventEndingRow() {
        (0, $9VR4w.default)(this, EventEndingRow);
        return _super.apply(this, arguments);
    }
    (0, $8HiBB.default)(EventEndingRow, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, segments = _this$props.segments, slots = _this$props.slotMetrics.slots;
                var rowSegments = $a4fe492ece4426a3$var$eventLevels(segments).levels[0];
                var current = 1, lastEnd = 1, row = [];
                while(current <= slots){
                    var key = '_lvl_' + current;
                    var _ref = rowSegments.filter(function(seg) {
                        return $a4fe492ece4426a3$var$isSegmentInSlot$1(seg, current);
                    })[0] || {}, event = _ref.event, left = _ref.left, right = _ref.right, span = _ref.span; //eslint-disable-line
                    if (!event) {
                        current++;
                        continue;
                    }
                    var gap = Math.max(0, left - lastEnd);
                    if (this.canRenderSlotEvent(left, span)) {
                        var content = $a4fe492ece4426a3$var$EventRowMixin.renderEvent(this.props, event);
                        if (gap) row.push($a4fe492ece4426a3$var$EventRowMixin.renderSpan(slots, gap, key + '_gap'));
                        row.push($a4fe492ece4426a3$var$EventRowMixin.renderSpan(slots, span, key, content));
                        lastEnd = current = right + 1;
                    } else {
                        if (gap) row.push($a4fe492ece4426a3$var$EventRowMixin.renderSpan(slots, gap, key + '_gap'));
                        row.push($a4fe492ece4426a3$var$EventRowMixin.renderSpan(slots, 1, key, this.renderShowMore(segments, current)));
                        lastEnd = current = current + 1;
                    }
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "rbc-row"
                }, row);
            }
        },
        {
            key: "canRenderSlotEvent",
            value: function canRenderSlotEvent(slot, span) {
                var segments = this.props.segments;
                return (0, $3abb78436f324b3d$export$2e2bcd8739ae039)(slot, slot + span).every(function(s) {
                    var count = $a4fe492ece4426a3$var$eventsInSlot(segments, s);
                    return count === 1;
                });
            }
        },
        {
            key: "renderShowMore",
            value: function renderShowMore(segments, slot) {
                var _this = this;
                var localizer = this.props.localizer;
                var count = $a4fe492ece4426a3$var$eventsInSlot(segments, slot);
                return count ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
                    type: "button",
                    key: 'sm_' + slot,
                    className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)('rbc-button-link', 'rbc-show-more'),
                    onClick: function onClick(e) {
                        return _this.showMore(slot, e);
                    }
                }, localizer.messages.showMore(count)) : false;
            }
        },
        {
            key: "showMore",
            value: function showMore(slot, e) {
                e.preventDefault();
                e.stopPropagation();
                this.props.onShowMore(slot, e.target);
            }
        }
    ]);
    return EventEndingRow;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
$a4fe492ece4426a3$var$EventEndingRow.defaultProps = (0, $cdb445c333a43100$export$2e2bcd8739ae039)({}, $a4fe492ece4426a3$var$EventRowMixin.defaultProps);
var $a4fe492ece4426a3$var$ScrollableWeekWrapper = function ScrollableWeekWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "rbc-row-content-scroll-container"
    }, children);
};
var $a4fe492ece4426a3$var$isSegmentInSlot = function isSegmentInSlot(seg, slot) {
    return seg.left <= slot && seg.right >= slot;
};
var $a4fe492ece4426a3$var$isEqual = function isEqual(a, b) {
    return a[0].range === b[0].range && a[0].events === b[0].events;
};
function $a4fe492ece4426a3$var$getSlotMetrics$1() {
    return (0, $e3e5797910a02537$export$2e2bcd8739ae039)(function(options) {
        var range = options.range, events = options.events, maxRows = options.maxRows, minRows = options.minRows, accessors = options.accessors, localizer = options.localizer;
        var _endOfRange = $a4fe492ece4426a3$var$endOfRange({
            dateRange: range,
            localizer: localizer
        }), first = _endOfRange.first, last = _endOfRange.last;
        var segments = events.map(function(evt) {
            return $a4fe492ece4426a3$var$eventSegments(evt, range, accessors, localizer);
        });
        var _eventLevels = $a4fe492ece4426a3$var$eventLevels(segments, Math.max(maxRows - 1, 1)), levels = _eventLevels.levels, extra = _eventLevels.extra;
        while(levels.length < minRows)levels.push([]);
        return {
            first: first,
            last: last,
            levels: levels,
            extra: extra,
            range: range,
            slots: range.length,
            clone: function clone(args) {
                var metrics = $a4fe492ece4426a3$var$getSlotMetrics$1();
                return metrics((0, $cdb445c333a43100$export$2e2bcd8739ae039)((0, $cdb445c333a43100$export$2e2bcd8739ae039)({}, options), args));
            },
            getDateForSlot: function getDateForSlot(slotNumber) {
                return range[slotNumber];
            },
            getSlotForDate: function getSlotForDate(date) {
                return range.find(function(r) {
                    return localizer.isSameDate(r, date);
                });
            },
            getEventsForSlot: function getEventsForSlot(slot) {
                return segments.filter(function(seg) {
                    return $a4fe492ece4426a3$var$isSegmentInSlot(seg, slot);
                }).map(function(seg) {
                    return seg.event;
                });
            },
            continuesPrior: function continuesPrior(event) {
                return localizer.continuesPrior(accessors.start(event), first);
            },
            continuesAfter: function continuesAfter(event) {
                var start = accessors.start(event);
                var end = accessors.end(event);
                return localizer.continuesAfter(start, end, last);
            }
        };
    }, $a4fe492ece4426a3$var$isEqual);
}
var $a4fe492ece4426a3$var$DateContentRow = /*#__PURE__*/ function(_React$Component) {
    (0, $2tFMC.default)(DateContentRow, _React$Component);
    var _super = (0, $5d4b78f32a0ca363$export$2e2bcd8739ae039)(DateContentRow);
    function DateContentRow() {
        var _this;
        (0, $9VR4w.default)(this, DateContentRow);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.handleSelectSlot = function(slot) {
            var _this$props = _this.props, range = _this$props.range, onSelectSlot = _this$props.onSelectSlot;
            onSelectSlot(range.slice(slot.start, slot.end + 1), slot);
        };
        _this.handleShowMore = function(slot, target) {
            var _this$props2 = _this.props, range = _this$props2.range, onShowMore = _this$props2.onShowMore;
            var metrics = _this.slotMetrics(_this.props);
            var row = (0, $107d78630d914c9d$export$2e2bcd8739ae039)(_this.containerRef.current, '.rbc-row-bg')[0];
            var cell;
            if (row) cell = row.children[slot - 1];
            var events = metrics.getEventsForSlot(slot);
            onShowMore(events, range[slot - 1], cell, slot, target);
        };
        _this.getContainer = function() {
            var container = _this.props.container;
            return container ? container() : _this.containerRef.current;
        };
        _this.renderHeadingCell = function(date, index) {
            var _this$props3 = _this.props, renderHeader = _this$props3.renderHeader, getNow = _this$props3.getNow, localizer = _this$props3.localizer;
            return renderHeader({
                date: date,
                key: "header_".concat(index),
                className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)('rbc-date-cell', localizer.isSameDate(date, getNow()) && 'rbc-now')
            });
        };
        _this.renderDummy = function() {
            var _this$props4 = _this.props, className = _this$props4.className, range = _this$props4.range, renderHeader = _this$props4.renderHeader, showAllEvents = _this$props4.showAllEvents;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                className: className,
                ref: _this.containerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)('rbc-row-content', showAllEvents && 'rbc-row-content-scrollable')
            }, renderHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                className: "rbc-row",
                ref: _this.headingRowRef
            }, range.map(_this.renderHeadingCell)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                className: "rbc-row",
                ref: _this.eventRowRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                className: "rbc-row-segment"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                className: "rbc-event"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                className: "rbc-event-content"
            }, "\xA0"))))));
        };
        _this.containerRef = /*#__PURE__*/ (0, $6fFrj.createRef)();
        _this.headingRowRef = /*#__PURE__*/ (0, $6fFrj.createRef)();
        _this.eventRowRef = /*#__PURE__*/ (0, $6fFrj.createRef)();
        _this.slotMetrics = $a4fe492ece4426a3$var$getSlotMetrics$1();
        return _this;
    }
    (0, $8HiBB.default)(DateContentRow, [
        {
            key: "getRowLimit",
            value: function getRowLimit() {
                var _this$headingRowRef;
                /* Guessing this only gets called on the dummyRow */ var eventHeight = (0, $b6a772619fed3ed4$export$2e2bcd8739ae039)(this.eventRowRef.current);
                var headingHeight = (_this$headingRowRef = this.headingRowRef) !== null && _this$headingRowRef !== void 0 && _this$headingRowRef.current ? (0, $b6a772619fed3ed4$export$2e2bcd8739ae039)(this.headingRowRef.current) : 0;
                var eventSpace = (0, $b6a772619fed3ed4$export$2e2bcd8739ae039)(this.containerRef.current) - headingHeight;
                return Math.max(Math.floor(eventSpace / eventHeight), 1);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, date = _this$props5.date, rtl = _this$props5.rtl, range = _this$props5.range, className = _this$props5.className, selected = _this$props5.selected, selectable = _this$props5.selectable, renderForMeasure = _this$props5.renderForMeasure, accessors = _this$props5.accessors, getters = _this$props5.getters, components = _this$props5.components, getNow = _this$props5.getNow, renderHeader = _this$props5.renderHeader, onSelect = _this$props5.onSelect, localizer = _this$props5.localizer, onSelectStart = _this$props5.onSelectStart, onSelectEnd = _this$props5.onSelectEnd, onDoubleClick = _this$props5.onDoubleClick, onKeyPress = _this$props5.onKeyPress, resourceId = _this$props5.resourceId, longPressThreshold = _this$props5.longPressThreshold, isAllDay = _this$props5.isAllDay, resizable = _this$props5.resizable, showAllEvents = _this$props5.showAllEvents;
                if (renderForMeasure) return this.renderDummy();
                var metrics = this.slotMetrics(this.props);
                var levels = metrics.levels, extra = metrics.extra;
                var ScrollableWeekComponent = showAllEvents ? $a4fe492ece4426a3$var$ScrollableWeekWrapper : $a4fe492ece4426a3$var$NoopWrapper;
                var WeekWrapper = components.weekWrapper;
                var eventRowProps = {
                    selected: selected,
                    accessors: accessors,
                    getters: getters,
                    localizer: localizer,
                    components: components,
                    onSelect: onSelect,
                    onDoubleClick: onDoubleClick,
                    onKeyPress: onKeyPress,
                    resourceId: resourceId,
                    slotMetrics: metrics,
                    resizable: resizable
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: className,
                    role: "rowgroup",
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$BackgroundCells, {
                    localizer: localizer,
                    date: date,
                    getNow: getNow,
                    rtl: rtl,
                    range: range,
                    selectable: selectable,
                    container: this.getContainer,
                    getters: getters,
                    onSelectStart: onSelectStart,
                    onSelectEnd: onSelectEnd,
                    onSelectSlot: this.handleSelectSlot,
                    components: components,
                    longPressThreshold: longPressThreshold,
                    resourceId: resourceId
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)('rbc-row-content', showAllEvents && 'rbc-row-content-scrollable'),
                    role: "row"
                }, renderHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "rbc-row ",
                    ref: this.headingRowRef
                }, range.map(this.renderHeadingCell)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(ScrollableWeekComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(WeekWrapper, Object.assign({
                    isAllDay: isAllDay
                }, eventRowProps), levels.map(function(segs, idx) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$EventRow, Object.assign({
                        key: idx,
                        segments: segs
                    }, eventRowProps));
                }), !!extra.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$EventEndingRow, Object.assign({
                    segments: extra,
                    onShowMore: this.handleShowMore
                }, eventRowProps))))));
            }
        }
    ]);
    return DateContentRow;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
$a4fe492ece4426a3$var$DateContentRow.defaultProps = {
    minRows: 0,
    maxRows: Infinity
};
var $a4fe492ece4426a3$var$Header = function Header(_ref) {
    var label = _ref.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
        role: "columnheader",
        "aria-sort": "none"
    }, label);
};
var $a4fe492ece4426a3$var$DateHeader = function DateHeader(_ref) {
    var label = _ref.label, drilldownView = _ref.drilldownView, onDrillDown = _ref.onDrillDown;
    if (!drilldownView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", null, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
        type: "button",
        className: "rbc-button-link",
        onClick: onDrillDown,
        role: "cell"
    }, label);
};
var $a4fe492ece4426a3$var$_excluded$6 = [
    "date",
    "className"
];
var $a4fe492ece4426a3$var$eventsForWeek = function eventsForWeek(evts, start, end, accessors, localizer) {
    return evts.filter(function(e) {
        return $a4fe492ece4426a3$var$inRange(e, start, end, accessors, localizer);
    });
};
var $a4fe492ece4426a3$var$MonthView = /*#__PURE__*/ function(_React$Component) {
    (0, $2tFMC.default)(MonthView, _React$Component);
    var _super = (0, $5d4b78f32a0ca363$export$2e2bcd8739ae039)(MonthView);
    function MonthView() {
        var _this;
        (0, $9VR4w.default)(this, MonthView);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(_args));
        _this.getContainer = function() {
            return _this.containerRef.current;
        };
        _this.renderWeek = function(week, weekIdx) {
            var _this$props = _this.props, events = _this$props.events, components = _this$props.components, selectable = _this$props.selectable, getNow = _this$props.getNow, selected = _this$props.selected, date = _this$props.date, localizer = _this$props.localizer, longPressThreshold = _this$props.longPressThreshold, accessors = _this$props.accessors, getters = _this$props.getters, showAllEvents = _this$props.showAllEvents;
            var _this$state = _this.state, needLimitMeasure = _this$state.needLimitMeasure, rowLimit = _this$state.rowLimit; // let's not mutate props
            var weeksEvents = $a4fe492ece4426a3$var$eventsForWeek((0, $ade8cf5a4b72a7ba$export$2e2bcd8739ae039)(events), week[0], week[week.length - 1], accessors, localizer);
            weeksEvents.sort(function(a, b) {
                return $a4fe492ece4426a3$var$sortEvents(a, b, accessors, localizer);
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$DateContentRow, {
                key: weekIdx,
                ref: weekIdx === 0 ? _this.slotRowRef : undefined,
                container: _this.getContainer,
                className: "rbc-month-row",
                getNow: getNow,
                date: date,
                range: week,
                events: weeksEvents,
                maxRows: showAllEvents ? Infinity : rowLimit,
                selected: selected,
                selectable: selectable,
                components: components,
                accessors: accessors,
                getters: getters,
                localizer: localizer,
                renderHeader: _this.readerDateHeading,
                renderForMeasure: needLimitMeasure,
                onShowMore: _this.handleShowMore,
                onSelect: _this.handleSelectEvent,
                onDoubleClick: _this.handleDoubleClickEvent,
                onKeyPress: _this.handleKeyPressEvent,
                onSelectSlot: _this.handleSelectSlot,
                longPressThreshold: longPressThreshold,
                rtl: _this.props.rtl,
                resizable: _this.props.resizable,
                showAllEvents: showAllEvents
            });
        };
        _this.readerDateHeading = function(_ref) {
            var date = _ref.date, className = _ref.className, props = (0, $7a2c209832ffd573$export$2e2bcd8739ae039)(_ref, $a4fe492ece4426a3$var$_excluded$6);
            var _this$props2 = _this.props, currentDate = _this$props2.date, getDrilldownView = _this$props2.getDrilldownView, localizer = _this$props2.localizer;
            var isOffRange = localizer.neq(date, currentDate, 'month');
            var isCurrent = localizer.isSameDate(date, currentDate);
            var drilldownView = getDrilldownView(date);
            var label = localizer.format(date, 'dateFormat');
            var DateHeaderComponent = _this.props.components.dateHeader || $a4fe492ece4426a3$var$DateHeader;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", Object.assign({}, props, {
                className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)(className, isOffRange && 'rbc-off-range', isCurrent && 'rbc-current'),
                role: "cell"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(DateHeaderComponent, {
                label: label,
                date: date,
                drilldownView: drilldownView,
                isOffRange: isOffRange,
                onDrillDown: function onDrillDown(e) {
                    return _this.handleHeadingClick(date, drilldownView, e);
                }
            }));
        };
        _this.handleSelectSlot = function(range, slotInfo) {
            _this._pendingSelection = _this._pendingSelection.concat(range);
            clearTimeout(_this._selectTimer);
            _this._selectTimer = setTimeout(function() {
                return _this.selectDates(slotInfo);
            });
        };
        _this.handleHeadingClick = function(date, view, e) {
            e.preventDefault();
            _this.clearSelection();
            $a4fe492ece4426a3$var$notify(_this.props.onDrillDown, [
                date,
                view
            ]);
        };
        _this.handleSelectEvent = function() {
            _this.clearSelection();
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $a4fe492ece4426a3$var$notify(_this.props.onSelectEvent, args);
        };
        _this.handleDoubleClickEvent = function() {
            _this.clearSelection();
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            $a4fe492ece4426a3$var$notify(_this.props.onDoubleClickEvent, args);
        };
        _this.handleKeyPressEvent = function() {
            _this.clearSelection();
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            $a4fe492ece4426a3$var$notify(_this.props.onKeyPressEvent, args);
        };
        _this.handleShowMore = function(events, date, cell, slot, target) {
            var _this$props3 = _this.props, popup = _this$props3.popup, onDrillDown = _this$props3.onDrillDown, onShowMore = _this$props3.onShowMore, getDrilldownView = _this$props3.getDrilldownView, doShowMoreDrillDown = _this$props3.doShowMoreDrillDown; //cancel any pending selections so only the event click goes through.
            _this.clearSelection();
            if (popup) {
                var position = (0, $e663dc897e07c278$export$2e2bcd8739ae039)(cell, _this.containerRef.current);
                _this.setState({
                    overlay: {
                        date: date,
                        events: events,
                        position: position,
                        target: target
                    }
                });
            } else if (doShowMoreDrillDown) $a4fe492ece4426a3$var$notify(onDrillDown, [
                date,
                getDrilldownView(date) || $a4fe492ece4426a3$export$5cb791131c501f6a.DAY
            ]);
            $a4fe492ece4426a3$var$notify(onShowMore, [
                events,
                date,
                slot
            ]);
        };
        _this.overlayDisplay = function() {
            _this.setState({
                overlay: null
            });
        };
        _this.state = {
            rowLimit: 5,
            needLimitMeasure: true,
            date: null
        };
        _this.containerRef = /*#__PURE__*/ (0, $6fFrj.createRef)();
        _this.slotRowRef = /*#__PURE__*/ (0, $6fFrj.createRef)();
        _this._bgRows = [];
        _this._pendingSelection = [];
        return _this;
    }
    (0, $8HiBB.default)(MonthView, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var running;
                if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
                window.addEventListener('resize', this._resizeListener = function() {
                    if (!running) $c70f3c10ca880f8d$export$b5fe3f66a567bec0(function() {
                        running = false;
                        _this2.setState({
                            needLimitMeasure: true
                        }); //eslint-disable-line
                    });
                }, false);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener('resize', this._resizeListener, false);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, date = _this$props4.date, localizer = _this$props4.localizer, className = _this$props4.className, month = localizer.visibleDays(date, localizer), weeks = (0, $f2440465854da155$export$2e2bcd8739ae039)(month, 7);
                this._weekCount = weeks.length;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)('rbc-month-view', className),
                    role: "table",
                    "aria-label": "Month View",
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "rbc-row rbc-month-header",
                    role: "row"
                }, this.renderHeaders(weeks[0])), weeks.map(this.renderWeek), this.props.popup && this.renderOverlay());
            }
        },
        {
            key: "renderHeaders",
            value: function renderHeaders(row) {
                var _this$props5 = this.props, localizer = _this$props5.localizer, components = _this$props5.components;
                var first = row[0];
                var last = row[row.length - 1];
                var HeaderComponent = components.header || $a4fe492ece4426a3$var$Header;
                return localizer.range(first, last, 'day').map(function(day, idx) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                        key: 'header_' + idx,
                        className: "rbc-header"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(HeaderComponent, {
                        date: day,
                        localizer: localizer,
                        label: localizer.format(day, 'weekdayFormat')
                    }));
                });
            }
        },
        {
            key: "renderOverlay",
            value: function renderOverlay() {
                var _this$state$overlay, _this$state2, _this3 = this;
                var overlay = (_this$state$overlay = (_this$state2 = this.state) === null || _this$state2 === void 0 ? void 0 : _this$state2.overlay) !== null && _this$state$overlay !== void 0 ? _this$state$overlay : {};
                var _this$props6 = this.props, accessors = _this$props6.accessors, localizer = _this$props6.localizer, components = _this$props6.components, getters = _this$props6.getters, selected = _this$props6.selected, popupOffset = _this$props6.popupOffset, handleDragStart = _this$props6.handleDragStart;
                var onHide = function onHide() {
                    return _this3.setState({
                        overlay: null
                    });
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$PopOverlay, {
                    overlay: overlay,
                    accessors: accessors,
                    localizer: localizer,
                    components: components,
                    getters: getters,
                    selected: selected,
                    popupOffset: popupOffset,
                    ref: this.containerRef,
                    handleKeyPressEvent: this.handleKeyPressEvent,
                    handleSelectEvent: this.handleSelectEvent,
                    handleDoubleClickEvent: this.handleDoubleClickEvent,
                    handleDragStart: handleDragStart,
                    show: !!overlay.position,
                    overlayDisplay: this.overlayDisplay,
                    onHide: onHide
                });
            /* return (
        <Overlay
          rootClose
          placement="bottom"
          show={!!overlay.position}
          onHide={() => this.setState({ overlay: null })}
          target={() => overlay.target}
        >
          {({ props }) => (
            <Popup
              {...props}
              popupOffset={popupOffset}
              accessors={accessors}
              getters={getters}
              selected={selected}
              components={components}
              localizer={localizer}
              position={overlay.position}
              show={this.overlayDisplay}
              events={overlay.events}
              slotStart={overlay.date}
              slotEnd={overlay.end}
              onSelect={this.handleSelectEvent}
              onDoubleClick={this.handleDoubleClickEvent}
              onKeyPress={this.handleKeyPressEvent}
              handleDragStart={this.props.handleDragStart}
            />
          )}
        </Overlay>
      ) */ }
        },
        {
            key: "measureRowLimit",
            value: function measureRowLimit() {
                this.setState({
                    needLimitMeasure: false,
                    rowLimit: this.slotRowRef.current.getRowLimit()
                });
            }
        },
        {
            key: "selectDates",
            value: function selectDates(slotInfo) {
                var slots = this._pendingSelection.slice();
                this._pendingSelection = [];
                slots.sort(function(a, b) {
                    return +a - +b;
                });
                var start = new Date(slots[0]);
                var end = new Date(slots[slots.length - 1]);
                end.setDate(slots[slots.length - 1].getDate() + 1);
                $a4fe492ece4426a3$var$notify(this.props.onSelectSlot, {
                    slots: slots,
                    start: start,
                    end: end,
                    action: slotInfo.action,
                    bounds: slotInfo.bounds,
                    box: slotInfo.box
                });
            }
        },
        {
            key: "clearSelection",
            value: function clearSelection() {
                clearTimeout(this._selectTimer);
                this._pendingSelection = [];
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(_ref2, state) {
                var date = _ref2.date, localizer = _ref2.localizer;
                return {
                    date: date,
                    needLimitMeasure: localizer.neq(date, state.date, 'month')
                };
            }
        }
    ]);
    return MonthView;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
$a4fe492ece4426a3$var$MonthView.range = function(date, _ref3) {
    var localizer = _ref3.localizer;
    var start = localizer.firstVisibleDay(date, localizer);
    var end = localizer.lastVisibleDay(date, localizer);
    return {
        start: start,
        end: end
    };
};
$a4fe492ece4426a3$var$MonthView.navigate = function(date, action, _ref4) {
    var localizer = _ref4.localizer;
    switch(action){
        case $a4fe492ece4426a3$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -1, 'month');
        case $a4fe492ece4426a3$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, 1, 'month');
        default:
            return date;
    }
};
$a4fe492ece4426a3$var$MonthView.title = function(date, _ref5) {
    var localizer = _ref5.localizer;
    return localizer.format(date, 'monthHeaderFormat');
};
var $a4fe492ece4426a3$var$getKey = function getKey(_ref) {
    var min = _ref.min, max = _ref.max, step = _ref.step, slots = _ref.slots, localizer = _ref.localizer;
    return "".concat(+localizer.startOf(min, 'minutes')) + "".concat(+localizer.startOf(max, 'minutes')) + "".concat(step, "-").concat(slots);
};
function $a4fe492ece4426a3$var$getSlotMetrics(_ref2) {
    var start = _ref2.min, end = _ref2.max, step = _ref2.step, timeslots = _ref2.timeslots, localizer = _ref2.localizer;
    var key = $a4fe492ece4426a3$var$getKey({
        start: start,
        end: end,
        step: step,
        timeslots: timeslots,
        localizer: localizer
    }); // DST differences are handled inside the localizer
    var totalMin = 1 + localizer.getTotalMin(start, end);
    var minutesFromMidnight = localizer.getMinutesFromMidnight(start);
    var numGroups = Math.ceil((totalMin - 1) / (step * timeslots));
    var numSlots = numGroups * timeslots;
    var groups = new Array(numGroups);
    var slots = new Array(numSlots); // Each slot date is created from "zero", instead of adding `step` to
    // the previous one, in order to avoid DST oddities
    for(var grp = 0; grp < numGroups; grp++){
        groups[grp] = new Array(timeslots);
        for(var slot = 0; slot < timeslots; slot++){
            var slotIdx = grp * timeslots + slot;
            var minFromStart = slotIdx * step; // A date with total minutes calculated from the start of the day
            slots[slotIdx] = groups[grp][slot] = localizer.getSlotDate(start, minutesFromMidnight, minFromStart);
        }
    } // Necessary to be able to select up until the last timeslot in a day
    var lastSlotMinFromStart = slots.length * step;
    slots.push(localizer.getSlotDate(start, minutesFromMidnight, lastSlotMinFromStart));
    function positionFromDate(date) {
        var diff = localizer.diff(start, date, 'minutes') + localizer.getDstOffset(start, date);
        return Math.min(diff, totalMin);
    }
    return {
        groups: groups,
        update: function update(args) {
            if ($a4fe492ece4426a3$var$getKey(args) !== key) return $a4fe492ece4426a3$var$getSlotMetrics(args);
            return this;
        },
        dateIsInGroup: function dateIsInGroup(date, groupIndex) {
            var nextGroup = groups[groupIndex + 1];
            return localizer.inRange(date, groups[groupIndex][0], nextGroup ? nextGroup[0] : end, 'minutes');
        },
        nextSlot: function nextSlot(slot) {
            var next = slots[Math.min(slots.indexOf(slot) + 1, slots.length - 1)]; // in the case of the last slot we won't a long enough range so manually get it
            if (next === slot) next = localizer.add(slot, step, 'minutes');
            return next;
        },
        closestSlotToPosition: function closestSlotToPosition(percent) {
            var slot = Math.min(slots.length - 1, Math.max(0, Math.floor(percent * numSlots)));
            return slots[slot];
        },
        closestSlotFromPoint: function closestSlotFromPoint(point, boundaryRect) {
            var range = Math.abs(boundaryRect.top - boundaryRect.bottom);
            return this.closestSlotToPosition((point.y - boundaryRect.top) / range);
        },
        closestSlotFromDate: function closestSlotFromDate(date) {
            var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            if (localizer.lt(date, start, 'minutes')) return slots[0];
            if (localizer.gt(date, end, 'minutes')) return slots[slots.length - 1];
            var diffMins = localizer.diff(start, date, 'minutes');
            return slots[(diffMins - diffMins % step) / step + offset];
        },
        startsBeforeDay: function startsBeforeDay(date) {
            return localizer.lt(date, start, 'day');
        },
        startsAfterDay: function startsAfterDay(date) {
            return localizer.gt(date, end, 'day');
        },
        startsBefore: function startsBefore(date) {
            return localizer.lt(localizer.merge(start, date), start, 'minutes');
        },
        startsAfter: function startsAfter(date) {
            return localizer.gt(localizer.merge(end, date), end, 'minutes');
        },
        getRange: function getRange(rangeStart, rangeEnd, ignoreMin, ignoreMax) {
            if (!ignoreMin) rangeStart = localizer.min(end, localizer.max(start, rangeStart));
            if (!ignoreMax) rangeEnd = localizer.min(end, localizer.max(start, rangeEnd));
            var rangeStartMin = positionFromDate(rangeStart);
            var rangeEndMin = positionFromDate(rangeEnd);
            var top = rangeEndMin > step * numSlots && !localizer.eq(end, rangeEnd) ? (rangeStartMin - step) / (step * numSlots) * 100 : rangeStartMin / (step * numSlots) * 100;
            return {
                top: top,
                height: rangeEndMin / (step * numSlots) * 100 - top,
                start: positionFromDate(rangeStart),
                startDate: rangeStart,
                end: positionFromDate(rangeEnd),
                endDate: rangeEnd
            };
        },
        getCurrentTimePosition: function getCurrentTimePosition(rangeStart) {
            var rangeStartMin = positionFromDate(rangeStart);
            var top = rangeStartMin / (step * numSlots) * 100;
            return top;
        }
    };
}
var $a4fe492ece4426a3$var$Event = /*#__PURE__*/ function() {
    function Event(data, _ref) {
        var accessors = _ref.accessors, slotMetrics = _ref.slotMetrics;
        (0, $9VR4w.default)(this, Event);
        var _slotMetrics$getRange = slotMetrics.getRange(accessors.start(data), accessors.end(data)), start = _slotMetrics$getRange.start, startDate = _slotMetrics$getRange.startDate, end = _slotMetrics$getRange.end, endDate = _slotMetrics$getRange.endDate, top = _slotMetrics$getRange.top, height = _slotMetrics$getRange.height;
        this.start = start;
        this.end = end;
        this.startMs = +startDate;
        this.endMs = +endDate;
        this.top = top;
        this.height = height;
        this.data = data;
    }
    /**
   * The event's width without any overlap.
   */ (0, $8HiBB.default)(Event, [
        {
            key: "_width",
            get: function get() {
                // The container event's width is determined by the maximum number of
                // events in any of its rows.
                if (this.rows) {
                    var columns = this.rows.reduce(function(max, row) {
                        return Math.max(max, row.leaves.length + 1);
                    }, 0) + 1; // add the container
                    return 100 / columns;
                }
                var availableWidth = 100 - this.container._width; // The row event's width is the space left by the container, divided
                // among itself and its leaves.
                if (this.leaves) return availableWidth / (this.leaves.length + 1);
                 // The leaf event's width is determined by its row's width
                return this.row._width;
            }
        },
        {
            key: "width",
            get: function get() {
                var noOverlap = this._width;
                var overlap = Math.min(100, this._width * 1.7); // Containers can always grow.
                if (this.rows) return overlap;
                 // Rows can grow if they have leaves.
                if (this.leaves) return this.leaves.length > 0 ? overlap : noOverlap;
                 // Leaves can grow unless they're the last item in a row.
                var leaves = this.row.leaves;
                var index = leaves.indexOf(this);
                return index === leaves.length - 1 ? noOverlap : overlap;
            }
        },
        {
            key: "xOffset",
            get: function get() {
                // Containers have no offset.
                if (this.rows) return 0; // Rows always start where their container ends.
                if (this.leaves) return this.container._width; // Leaves are spread out evenly on the space left by its row.
                var _this$row = this.row, leaves = _this$row.leaves, xOffset = _this$row.xOffset, _width = _this$row._width;
                var index = leaves.indexOf(this) + 1;
                return xOffset + index * _width;
            }
        }
    ]);
    return Event;
}();
/**
 * Return true if event a and b is considered to be on the same row.
 */ function $a4fe492ece4426a3$var$onSameRow(a, b, minimumStartDifference) {
    return Math.abs(b.start - a.start) < minimumStartDifference || // A's start slot overlaps with b's end slot.
    b.start > a.start && b.start < a.end;
}
function $a4fe492ece4426a3$var$sortByRender(events) {
    var sortedByTime = (0, $957ff2622234d571$export$2e2bcd8739ae039)(events, [
        'startMs',
        function(e) {
            return -e.endMs;
        }
    ]);
    var sorted = [];
    while(sortedByTime.length > 0){
        var event = sortedByTime.shift();
        sorted.push(event);
        for(var i = 0; i < sortedByTime.length; i++){
            var test = sortedByTime[i]; // Still inside this event, look for next.
            if (event.endMs > test.startMs) continue; // We've found the first event of the next event group.
            // If that event is not right next to our current event, we have to
            // move it here.
            if (i > 0) {
                var _event = sortedByTime.splice(i, 1)[0];
                sorted.push(_event);
            } // We've already found the next event group, so stop looking.
            break;
        }
    }
    return sorted;
}
function $a4fe492ece4426a3$var$getStyledEvents$1(_ref2) {
    var events = _ref2.events, minimumStartDifference = _ref2.minimumStartDifference, slotMetrics = _ref2.slotMetrics, accessors = _ref2.accessors;
    // Create proxy events and order them so that we don't have
    // to fiddle with z-indexes.
    var proxies = events.map(function(event) {
        return new $a4fe492ece4426a3$var$Event(event, {
            slotMetrics: slotMetrics,
            accessors: accessors
        });
    });
    var eventsInRenderOrder = $a4fe492ece4426a3$var$sortByRender(proxies); // Group overlapping events, while keeping order.
    // Every event is always one of: container, row or leaf.
    // Containers can contain rows, and rows can contain leaves.
    var containerEvents = [];
    var _loop = function _loop(i) {
        var event = eventsInRenderOrder[i]; // Check if this event can go into a container event.
        var container = containerEvents.find(function(c) {
            return c.end > event.start || Math.abs(event.start - c.start) < minimumStartDifference;
        }); // Couldn't find a container — that means this event is a container.
        if (!container) {
            event.rows = [];
            containerEvents.push(event);
            return "continue";
        } // Found a container for the event.
        event.container = container; // Check if the event can be placed in an existing row.
        // Start looking from behind.
        var row = null;
        for(var j = container.rows.length - 1; !row && j >= 0; j--)if ($a4fe492ece4426a3$var$onSameRow(container.rows[j], event, minimumStartDifference)) row = container.rows[j];
        if (row) {
            // Found a row, so add it.
            row.leaves.push(event);
            event.row = row;
        } else {
            // Couldn't find a row – that means this event is a row.
            event.leaves = [];
            container.rows.push(event);
        }
    };
    for(var i = 0; i < eventsInRenderOrder.length; i++){
        var _ret = _loop(i);
        if (_ret === "continue") continue;
    } // Return the original events, along with their styles.
    return eventsInRenderOrder.map(function(event) {
        return {
            event: event.data,
            style: {
                top: event.top,
                height: event.height,
                width: event.width,
                xOffset: Math.max(0, event.xOffset)
            }
        };
    });
}
function $a4fe492ece4426a3$var$getMaxIdxDFS(node, maxIdx, visited) {
    for(var i = 0; i < node.friends.length; ++i){
        if (visited.indexOf(node.friends[i]) > -1) continue;
        maxIdx = maxIdx > node.friends[i].idx ? maxIdx : node.friends[i].idx; // TODO : trace it by not object but kinda index or something for performance
        visited.push(node.friends[i]);
        var newIdx = $a4fe492ece4426a3$var$getMaxIdxDFS(node.friends[i], maxIdx, visited);
        maxIdx = maxIdx > newIdx ? maxIdx : newIdx;
    }
    return maxIdx;
}
function $a4fe492ece4426a3$var$noOverlap(_ref) {
    var events = _ref.events, minimumStartDifference = _ref.minimumStartDifference, slotMetrics = _ref.slotMetrics, accessors = _ref.accessors;
    var styledEvents = $a4fe492ece4426a3$var$getStyledEvents$1({
        events: events,
        minimumStartDifference: minimumStartDifference,
        slotMetrics: slotMetrics,
        accessors: accessors
    });
    styledEvents.sort(function(a, b) {
        a = a.style;
        b = b.style;
        if (a.top !== b.top) return a.top > b.top ? 1 : -1;
        else return a.top + a.height < b.top + b.height ? 1 : -1;
    });
    for(var i = 0; i < styledEvents.length; ++i){
        styledEvents[i].friends = [];
        delete styledEvents[i].style.left;
        delete styledEvents[i].style.left;
        delete styledEvents[i].idx;
        delete styledEvents[i].size;
    }
    for(var _i = 0; _i < styledEvents.length - 1; ++_i){
        var se1 = styledEvents[_i];
        var y1 = se1.style.top;
        var y2 = se1.style.top + se1.style.height;
        for(var j = _i + 1; j < styledEvents.length; ++j){
            var se2 = styledEvents[j];
            var y3 = se2.style.top;
            var y4 = se2.style.top + se2.style.height; // be friends when overlapped
            if (y3 <= y1 && y1 <= y4 || y1 <= y3 && y3 <= y2) {
                // TODO : hashmap would be effective for performance
                se1.friends.push(se2);
                se2.friends.push(se1);
            }
        }
    }
    for(var _i2 = 0; _i2 < styledEvents.length; ++_i2){
        var se = styledEvents[_i2];
        var bitmap = [];
        for(var _j = 0; _j < 100; ++_j)bitmap.push(1);
         // 1 means available
        for(var _j2 = 0; _j2 < se.friends.length; ++_j2)if (se.friends[_j2].idx !== undefined) bitmap[se.friends[_j2].idx] = 0;
         // 0 means reserved
        se.idx = bitmap.indexOf(1);
    }
    for(var _i3 = 0; _i3 < styledEvents.length; ++_i3){
        var size = 0;
        if (styledEvents[_i3].size) continue;
        var allFriends = [];
        var maxIdx = $a4fe492ece4426a3$var$getMaxIdxDFS(styledEvents[_i3], 0, allFriends);
        size = 100 / (maxIdx + 1);
        styledEvents[_i3].size = size;
        for(var _j3 = 0; _j3 < allFriends.length; ++_j3)allFriends[_j3].size = size;
    }
    for(var _i4 = 0; _i4 < styledEvents.length; ++_i4){
        var e = styledEvents[_i4];
        e.style.left = e.idx * e.size; // stretch to maximum
        var _maxIdx = 0;
        for(var _j4 = 0; _j4 < e.friends.length; ++_j4){
            var idx = e.friends[_j4].idx;
            _maxIdx = _maxIdx > idx ? _maxIdx : idx;
        }
        if (_maxIdx <= e.idx) e.size = 100 - e.idx * e.size; // padding between events
        // for this feature, `width` is not percentage based unit anymore
        // it will be used with calc()
        var padding = e.idx === 0 ? 0 : 3;
        e.style.width = "calc(".concat(e.size, "% - ").concat(padding, "px)");
        e.style.height = "calc(".concat(e.style.height, "% - 2px)");
        e.style.xOffset = "calc(".concat(e.style.left, "% + ").concat(padding, "px)");
    }
    return styledEvents;
}
/*eslint no-unused-vars: "off"*/ var $a4fe492ece4426a3$var$DefaultAlgorithms = {
    overlap: $a4fe492ece4426a3$var$getStyledEvents$1,
    'no-overlap': $a4fe492ece4426a3$var$noOverlap
};
function $a4fe492ece4426a3$var$isFunction(a) {
    return !!(a && a.constructor && a.call && a.apply);
} //
function $a4fe492ece4426a3$var$getStyledEvents(_ref) {
    _ref.events;
    _ref.minimumStartDifference;
    _ref.slotMetrics;
    _ref.accessors;
    var dayLayoutAlgorithm = _ref.dayLayoutAlgorithm;
    var algorithm = dayLayoutAlgorithm;
    if (dayLayoutAlgorithm in $a4fe492ece4426a3$var$DefaultAlgorithms) algorithm = $a4fe492ece4426a3$var$DefaultAlgorithms[dayLayoutAlgorithm];
    if (!$a4fe492ece4426a3$var$isFunction(algorithm)) // invalid algorithm
    return [];
    return algorithm.apply(this, arguments);
}
var $a4fe492ece4426a3$var$TimeSlotGroup = /*#__PURE__*/ function(_Component) {
    (0, $2tFMC.default)(TimeSlotGroup, _Component);
    var _super = (0, $5d4b78f32a0ca363$export$2e2bcd8739ae039)(TimeSlotGroup);
    function TimeSlotGroup() {
        (0, $9VR4w.default)(this, TimeSlotGroup);
        return _super.apply(this, arguments);
    }
    (0, $8HiBB.default)(TimeSlotGroup, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, renderSlot = _this$props.renderSlot, resource = _this$props.resource, group = _this$props.group, getters = _this$props.getters, _this$props$component = _this$props.components;
                _this$props$component = _this$props$component === void 0 ? {} : _this$props$component;
                var _this$props$component2 = _this$props$component.timeSlotWrapper, Wrapper = _this$props$component2 === void 0 ? $a4fe492ece4426a3$var$NoopWrapper : _this$props$component2;
                var groupProps = getters ? getters.slotGroupProp() : {};
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", Object.assign({
                    className: "rbc-timeslot-group"
                }, groupProps), group.map(function(value, idx) {
                    var slotProps = getters ? getters.slotProp(value, resource) : {};
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Wrapper, {
                        key: idx,
                        value: value,
                        resource: resource
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", Object.assign({}, slotProps, {
                        className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)('rbc-time-slot', slotProps.className)
                    }), renderSlot && renderSlot(value, idx)));
                }));
            }
        }
    ]);
    return TimeSlotGroup;
}((0, $6fFrj.Component));
function $a4fe492ece4426a3$var$stringifyPercent(v) {
    return typeof v === 'string' ? v : v + '%';
}
/* eslint-disable react/prop-types */ function $a4fe492ece4426a3$var$TimeGridEvent(props) {
    var style = props.style, className = props.className, event = props.event, accessors = props.accessors, rtl = props.rtl, selected = props.selected, label = props.label, continuesPrior = props.continuesPrior, continuesAfter = props.continuesAfter, getters = props.getters, onClick = props.onClick, onDoubleClick = props.onDoubleClick, isBackgroundEvent = props.isBackgroundEvent, onKeyPress = props.onKeyPress, _props$components = props.components, Event = _props$components.event, EventWrapper = _props$components.eventWrapper;
    var title = accessors.title(event);
    var tooltip = accessors.tooltip(event);
    var end = accessors.end(event);
    var start = accessors.start(event);
    var userProps = getters.eventProp(event, start, end, selected);
    var height = style.height, top = style.top, width = style.width, xOffset = style.xOffset;
    var inner = [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
            key: "1",
            className: "rbc-event-label"
        }, label),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
            key: "2",
            className: "rbc-event-content"
        }, Event ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Event, {
            event: event,
            title: title
        }) : title)
    ];
    var eventStyle = isBackgroundEvent ? (0, $cdb445c333a43100$export$2e2bcd8739ae039)((0, $cdb445c333a43100$export$2e2bcd8739ae039)({}, userProps.style), {}, (0, $5fApW.default)({
        top: $a4fe492ece4426a3$var$stringifyPercent(top),
        height: $a4fe492ece4426a3$var$stringifyPercent(height),
        // Adding 10px to take events container right margin into account
        width: "calc(".concat(width, " + 10px)")
    }, rtl ? 'right' : 'left', $a4fe492ece4426a3$var$stringifyPercent(Math.max(0, xOffset)))) : (0, $cdb445c333a43100$export$2e2bcd8739ae039)((0, $cdb445c333a43100$export$2e2bcd8739ae039)({}, userProps.style), {}, (0, $5fApW.default)({
        top: $a4fe492ece4426a3$var$stringifyPercent(top),
        width: $a4fe492ece4426a3$var$stringifyPercent(width),
        height: $a4fe492ece4426a3$var$stringifyPercent(height)
    }, rtl ? 'right' : 'left', $a4fe492ece4426a3$var$stringifyPercent(xOffset)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(EventWrapper, Object.assign({
        type: "time"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        onClick: onClick,
        onDoubleClick: onDoubleClick,
        style: eventStyle,
        onKeyPress: onKeyPress,
        title: tooltip ? (typeof label === 'string' ? label + ': ' : '') + tooltip : undefined,
        className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)(isBackgroundEvent ? 'rbc-background-event' : 'rbc-event', className, userProps.className, {
            'rbc-selected': selected,
            'rbc-event-continues-earlier': continuesPrior,
            'rbc-event-continues-later': continuesAfter
        })
    }, inner));
}
var $a4fe492ece4426a3$var$DayColumnWrapper = function DayColumnWrapper(_ref) {
    var children = _ref.children, className = _ref.className, style = _ref.style, innerRef = _ref.innerRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: className,
        style: style,
        ref: innerRef
    }, children);
};
var $a4fe492ece4426a3$var$DayColumnWrapper$1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$DayColumnWrapper, Object.assign({}, props, {
        innerRef: ref
    }));
});
var $a4fe492ece4426a3$var$_excluded$5 = [
    "dayProp"
], $a4fe492ece4426a3$var$_excluded2$1 = [
    "eventContainerWrapper"
];
var $a4fe492ece4426a3$var$DayColumn = /*#__PURE__*/ function(_React$Component) {
    (0, $2tFMC.default)(DayColumn, _React$Component);
    var _super = (0, $5d4b78f32a0ca363$export$2e2bcd8739ae039)(DayColumn);
    function DayColumn() {
        var _this;
        (0, $9VR4w.default)(this, DayColumn);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(_args));
        _this.state = {
            selecting: false,
            timeIndicatorPosition: null
        };
        _this.intervalTriggered = false;
        _this.renderEvents = function(_ref) {
            var events = _ref.events, isBackgroundEvent = _ref.isBackgroundEvent;
            var _this$props = _this.props, rtl = _this$props.rtl, selected = _this$props.selected, accessors = _this$props.accessors, localizer = _this$props.localizer, getters = _this$props.getters, components = _this$props.components, step = _this$props.step, timeslots = _this$props.timeslots, dayLayoutAlgorithm = _this$props.dayLayoutAlgorithm, resizable = _this$props.resizable;
            var _assertThisInitialize = (0, $4TaHZ.default)(_this), slotMetrics = _assertThisInitialize.slotMetrics;
            var messages = localizer.messages;
            var styledEvents = $a4fe492ece4426a3$var$getStyledEvents({
                events: events,
                accessors: accessors,
                slotMetrics: slotMetrics,
                minimumStartDifference: Math.ceil(step * timeslots / 2),
                dayLayoutAlgorithm: dayLayoutAlgorithm
            });
            return styledEvents.map(function(_ref2, idx) {
                var event = _ref2.event, style = _ref2.style;
                var end = accessors.end(event);
                var start = accessors.start(event);
                var format = 'eventTimeRangeFormat';
                var label;
                var startsBeforeDay = slotMetrics.startsBeforeDay(start);
                var startsAfterDay = slotMetrics.startsAfterDay(end);
                if (startsBeforeDay) format = 'eventTimeRangeEndFormat';
                else if (startsAfterDay) format = 'eventTimeRangeStartFormat';
                if (startsBeforeDay && startsAfterDay) label = messages.allDay;
                else label = localizer.format({
                    start: start,
                    end: end
                }, format);
                var continuesPrior = startsBeforeDay || slotMetrics.startsBefore(start);
                var continuesAfter = startsAfterDay || slotMetrics.startsAfter(end);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$TimeGridEvent, {
                    style: style,
                    event: event,
                    label: label,
                    key: 'evt_' + idx,
                    getters: getters,
                    rtl: rtl,
                    components: components,
                    continuesPrior: continuesPrior,
                    continuesAfter: continuesAfter,
                    accessors: accessors,
                    selected: $a4fe492ece4426a3$var$isSelected(event, selected),
                    onClick: function onClick(e) {
                        return _this._select(event, e);
                    },
                    onDoubleClick: function onDoubleClick(e) {
                        return _this._doubleClick(event, e);
                    },
                    isBackgroundEvent: isBackgroundEvent,
                    onKeyPress: function onKeyPress(e) {
                        return _this._keyPress(event, e);
                    },
                    resizable: resizable
                });
            });
        };
        _this._selectable = function() {
            var node = _this.containerRef.current;
            var _this$props2 = _this.props, longPressThreshold = _this$props2.longPressThreshold, localizer = _this$props2.localizer;
            var selector = _this._selector = new $a4fe492ece4426a3$var$Selection(function() {
                return node;
            }, {
                longPressThreshold: longPressThreshold
            });
            var maybeSelect = function maybeSelect(box) {
                var onSelecting = _this.props.onSelecting;
                var current = _this.state || {};
                var state = selectionState(box);
                var start = state.startDate, end = state.endDate;
                if (onSelecting) {
                    if (localizer.eq(current.startDate, start, 'minutes') && localizer.eq(current.endDate, end, 'minutes') || onSelecting({
                        start: start,
                        end: end,
                        resourceId: _this.props.resource
                    }) === false) return;
                }
                if (_this.state.start !== state.start || _this.state.end !== state.end || _this.state.selecting !== state.selecting) _this.setState(state);
            };
            var selectionState = function selectionState(point) {
                var currentSlot = _this.slotMetrics.closestSlotFromPoint(point, $a4fe492ece4426a3$var$getBoundsForNode(node));
                if (!_this.state.selecting) _this._initialSlot = currentSlot;
                var initialSlot = _this._initialSlot;
                if (localizer.lte(initialSlot, currentSlot)) currentSlot = _this.slotMetrics.nextSlot(currentSlot);
                else if (localizer.gt(initialSlot, currentSlot)) initialSlot = _this.slotMetrics.nextSlot(initialSlot);
                var selectRange = _this.slotMetrics.getRange(localizer.min(initialSlot, currentSlot), localizer.max(initialSlot, currentSlot));
                return (0, $cdb445c333a43100$export$2e2bcd8739ae039)((0, $cdb445c333a43100$export$2e2bcd8739ae039)({}, selectRange), {}, {
                    selecting: true,
                    top: "".concat(selectRange.top, "%"),
                    height: "".concat(selectRange.height, "%")
                });
            };
            var selectorClicksHandler = function selectorClicksHandler(box, actionType) {
                if (!$a4fe492ece4426a3$var$isEvent(_this.containerRef.current, box)) {
                    var _selectionState = selectionState(box), startDate = _selectionState.startDate, endDate = _selectionState.endDate;
                    _this._selectSlot({
                        startDate: startDate,
                        endDate: endDate,
                        action: actionType,
                        box: box
                    });
                }
                _this.setState({
                    selecting: false
                });
            };
            selector.on('selecting', maybeSelect);
            selector.on('selectStart', maybeSelect);
            selector.on('beforeSelect', function(box) {
                if (_this.props.selectable !== 'ignoreEvents') return;
                return !$a4fe492ece4426a3$var$isEvent(_this.containerRef.current, box);
            });
            selector.on('click', function(box) {
                return selectorClicksHandler(box, 'click');
            });
            selector.on('doubleClick', function(box) {
                return selectorClicksHandler(box, 'doubleClick');
            });
            selector.on('select', function(bounds) {
                if (_this.state.selecting) {
                    _this._selectSlot((0, $cdb445c333a43100$export$2e2bcd8739ae039)((0, $cdb445c333a43100$export$2e2bcd8739ae039)({}, _this.state), {}, {
                        action: 'select',
                        bounds: bounds
                    }));
                    _this.setState({
                        selecting: false
                    });
                }
            });
            selector.on('reset', function() {
                if (_this.state.selecting) _this.setState({
                    selecting: false
                });
            });
        };
        _this._teardownSelectable = function() {
            if (!_this._selector) return;
            _this._selector.teardown();
            _this._selector = null;
        };
        _this._selectSlot = function(_ref3) {
            var startDate = _ref3.startDate, endDate = _ref3.endDate, action = _ref3.action, bounds = _ref3.bounds, box = _ref3.box;
            var current = startDate, slots = [];
            while(_this.props.localizer.lte(current, endDate)){
                slots.push(current);
                current = new Date(+current + _this.props.step * 60000); // using Date ensures not to create an endless loop the day DST begins
            }
            $a4fe492ece4426a3$var$notify(_this.props.onSelectSlot, {
                slots: slots,
                start: startDate,
                end: endDate,
                resourceId: _this.props.resource,
                action: action,
                bounds: bounds,
                box: box
            });
        };
        _this._select = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $a4fe492ece4426a3$var$notify(_this.props.onSelectEvent, args);
        };
        _this._doubleClick = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            $a4fe492ece4426a3$var$notify(_this.props.onDoubleClickEvent, args);
        };
        _this._keyPress = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            $a4fe492ece4426a3$var$notify(_this.props.onKeyPressEvent, args);
        };
        _this.slotMetrics = $a4fe492ece4426a3$var$getSlotMetrics(_this.props);
        _this.containerRef = /*#__PURE__*/ (0, $6fFrj.createRef)();
        return _this;
    }
    (0, $8HiBB.default)(DayColumn, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.selectable && this._selectable();
                if (this.props.isNow) this.setTimeIndicatorPositionUpdateInterval();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._teardownSelectable();
                this.clearTimeIndicatorInterval();
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (nextProps.selectable && !this.props.selectable) this._selectable();
                if (!nextProps.selectable && this.props.selectable) this._teardownSelectable();
                this.slotMetrics = this.slotMetrics.update(nextProps);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this$props3 = this.props, getNow = _this$props3.getNow, isNow = _this$props3.isNow, localizer = _this$props3.localizer, date = _this$props3.date, min = _this$props3.min, max = _this$props3.max;
                var getNowChanged = localizer.neq(prevProps.getNow(), getNow(), 'minutes');
                if (prevProps.isNow !== isNow || getNowChanged) {
                    this.clearTimeIndicatorInterval();
                    if (isNow) {
                        var tail = !getNowChanged && localizer.eq(prevProps.date, date, 'minutes') && prevState.timeIndicatorPosition === this.state.timeIndicatorPosition;
                        this.setTimeIndicatorPositionUpdateInterval(tail);
                    }
                } else if (isNow && (localizer.neq(prevProps.min, min, 'minutes') || localizer.neq(prevProps.max, max, 'minutes'))) this.positionTimeIndicator();
            }
        },
        {
            key: "setTimeIndicatorPositionUpdateInterval",
            value: function setTimeIndicatorPositionUpdateInterval() {
                var _this2 = this;
                var tail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                if (!this.intervalTriggered && !tail) this.positionTimeIndicator();
                this._timeIndicatorTimeout = window.setTimeout(function() {
                    _this2.intervalTriggered = true;
                    _this2.positionTimeIndicator();
                    _this2.setTimeIndicatorPositionUpdateInterval();
                }, 60000);
            }
        },
        {
            key: "clearTimeIndicatorInterval",
            value: function clearTimeIndicatorInterval() {
                this.intervalTriggered = false;
                window.clearTimeout(this._timeIndicatorTimeout);
            }
        },
        {
            key: "positionTimeIndicator",
            value: function positionTimeIndicator() {
                var _this$props4 = this.props, min = _this$props4.min, max = _this$props4.max, getNow = _this$props4.getNow;
                var current = getNow();
                if (current >= min && current <= max) {
                    var top = this.slotMetrics.getCurrentTimePosition(current);
                    this.intervalTriggered = true;
                    this.setState({
                        timeIndicatorPosition: top
                    });
                } else this.clearTimeIndicatorInterval();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, date = _this$props5.date, max = _this$props5.max, rtl = _this$props5.rtl, isNow = _this$props5.isNow, resource = _this$props5.resource, accessors = _this$props5.accessors, localizer = _this$props5.localizer, _this$props5$getters = _this$props5.getters, dayProp = _this$props5$getters.dayProp, getters = (0, $7a2c209832ffd573$export$2e2bcd8739ae039)(_this$props5$getters, $a4fe492ece4426a3$var$_excluded$5), _this$props5$componen = _this$props5.components, EventContainer = _this$props5$componen.eventContainerWrapper, components = (0, $7a2c209832ffd573$export$2e2bcd8739ae039)(_this$props5$componen, $a4fe492ece4426a3$var$_excluded2$1);
                var slotMetrics = this.slotMetrics;
                var _this$state = this.state, selecting = _this$state.selecting, top = _this$state.top, height = _this$state.height, startDate = _this$state.startDate, endDate = _this$state.endDate;
                var selectDates = {
                    start: startDate,
                    end: endDate
                };
                var _dayProp = dayProp(max), className = _dayProp.className, style = _dayProp.style;
                var DayColumnWrapperComponent = components.dayColumnWrapper || $a4fe492ece4426a3$var$DayColumnWrapper$1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(DayColumnWrapperComponent, {
                    ref: this.containerRef,
                    date: date,
                    style: style,
                    className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)(className, 'rbc-day-slot', 'rbc-time-column', isNow && 'rbc-now', isNow && 'rbc-today', selecting && 'rbc-slot-selecting'),
                    slotMetrics: slotMetrics
                }, slotMetrics.groups.map(function(grp, idx) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$TimeSlotGroup, {
                        key: idx,
                        group: grp,
                        resource: resource,
                        getters: getters,
                        components: components
                    });
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(EventContainer, {
                    localizer: localizer,
                    resource: resource,
                    accessors: accessors,
                    getters: getters,
                    components: components,
                    slotMetrics: slotMetrics
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)('rbc-events-container', rtl && 'rtl')
                }, this.renderEvents({
                    events: this.props.backgroundEvents,
                    isBackgroundEvent: true
                }), this.renderEvents({
                    events: this.props.events
                }))), selecting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "rbc-slot-selection",
                    style: {
                        top: top,
                        height: height
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", null, localizer.format(selectDates, 'selectRangeFormat'))), isNow && this.intervalTriggered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "rbc-current-time-indicator",
                    style: {
                        top: "".concat(this.state.timeIndicatorPosition, "%")
                    }
                }));
            }
        }
    ]);
    return DayColumn;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
$a4fe492ece4426a3$var$DayColumn.defaultProps = {
    dragThroughEvents: true,
    timeslots: 2
};
/**
 * Since the TimeGutter only displays the 'times' of slots in a day, and is separate
 * from the Day Columns themselves, we check to see if the range contains an offset difference
 * and, if so, change the beginning and end 'date' by a day to properly display the slots times
 * used.
 */ function $a4fe492ece4426a3$var$adjustForDST(_ref) {
    var min = _ref.min, max = _ref.max, localizer = _ref.localizer;
    if (localizer.getTimezoneOffset(min) !== localizer.getTimezoneOffset(max)) return {
        start: localizer.add(min, -1, 'day'),
        end: localizer.add(max, -1, 'day')
    };
    return {
        start: min,
        end: max
    };
}
var $a4fe492ece4426a3$var$TimeGutter = function TimeGutter(_ref2) {
    var min = _ref2.min, max = _ref2.max, timeslots = _ref2.timeslots, step = _ref2.step, localizer = _ref2.localizer, getNow = _ref2.getNow, resource = _ref2.resource, components = _ref2.components, getters = _ref2.getters, gutterRef = _ref2.gutterRef;
    var TimeGutterWrapper = components.timeGutterWrapper;
    var _useMemo = (0, $6fFrj.useMemo)(function() {
        return $a4fe492ece4426a3$var$adjustForDST({
            min: min,
            max: max,
            localizer: localizer
        });
    }, [
        min === null || min === void 0 ? void 0 : min.toISOString(),
        max === null || max === void 0 ? void 0 : max.toISOString(),
        localizer
    ]), start = _useMemo.start, end = _useMemo.end;
    var _useState = (0, $6fFrj.useState)($a4fe492ece4426a3$var$getSlotMetrics({
        min: start,
        max: end,
        timeslots: timeslots,
        step: step,
        localizer: localizer
    })), _useState2 = (0, $951471461146a3e9$export$2e2bcd8739ae039)(_useState, 2), slotMetrics = _useState2[0], setSlotMetrics = _useState2[1];
    (0, $6fFrj.useEffect)(function() {
        if (slotMetrics) setSlotMetrics(slotMetrics.update({
            min: start,
            max: end,
            timeslots: timeslots,
            step: step,
            localizer: localizer
        }));
    /**
     * We don't want this to fire when slotMetrics is updated as it would recursively bomb
     */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        start === null || start === void 0 ? void 0 : start.toISOString(),
        end === null || end === void 0 ? void 0 : end.toISOString(),
        timeslots,
        step
    ]);
    var renderSlot = (0, $6fFrj.useCallback)(function(value, idx) {
        if (idx) return null; // don't return the first (0) idx
        var isNow = slotMetrics.dateIsInGroup(getNow(), idx);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
            className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)('rbc-label', isNow && 'rbc-now')
        }, localizer.format(value, 'timeGutterFormat'));
    }, [
        slotMetrics,
        localizer,
        getNow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(TimeGutterWrapper, {
        slotMetrics: slotMetrics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "rbc-time-gutter rbc-time-column",
        ref: gutterRef
    }, slotMetrics.groups.map(function(grp, idx) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$TimeSlotGroup, {
            key: idx,
            group: grp,
            resource: resource,
            components: components,
            renderSlot: renderSlot,
            getters: getters
        });
    })));
};
var $a4fe492ece4426a3$var$TimeGutter$1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$TimeGutter, Object.assign({
        gutterRef: ref
    }, props));
});
var $a4fe492ece4426a3$var$ResourceHeader = function ResourceHeader(_ref) {
    var label = _ref.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Fragment, null, label);
};
var $a4fe492ece4426a3$var$TimeGridHeader = /*#__PURE__*/ function(_React$Component) {
    (0, $2tFMC.default)(TimeGridHeader, _React$Component);
    var _super = (0, $5d4b78f32a0ca363$export$2e2bcd8739ae039)(TimeGridHeader);
    function TimeGridHeader() {
        var _this;
        (0, $9VR4w.default)(this, TimeGridHeader);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.handleHeaderClick = function(date, view, e) {
            e.preventDefault();
            $a4fe492ece4426a3$var$notify(_this.props.onDrillDown, [
                date,
                view
            ]);
        };
        _this.renderRow = function(resource) {
            var _this$props = _this.props, events = _this$props.events, rtl = _this$props.rtl, selectable = _this$props.selectable, getNow = _this$props.getNow, range = _this$props.range, getters = _this$props.getters, localizer = _this$props.localizer, accessors = _this$props.accessors, components = _this$props.components, resizable = _this$props.resizable;
            var resourceId = accessors.resourceId(resource);
            var eventsToDisplay = resource ? events.filter(function(event) {
                return accessors.resource(event) === resourceId;
            }) : events;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$DateContentRow, {
                isAllDay: true,
                rtl: rtl,
                getNow: getNow,
                minRows: 2,
                range: range,
                events: eventsToDisplay,
                resourceId: resourceId,
                className: "rbc-allday-cell",
                selectable: selectable,
                selected: _this.props.selected,
                components: components,
                accessors: accessors,
                getters: getters,
                localizer: localizer,
                onSelect: _this.props.onSelectEvent,
                onDoubleClick: _this.props.onDoubleClickEvent,
                onKeyPress: _this.props.onKeyPressEvent,
                onSelectSlot: _this.props.onSelectSlot,
                longPressThreshold: _this.props.longPressThreshold,
                resizable: resizable
            });
        };
        return _this;
    }
    (0, $8HiBB.default)(TimeGridHeader, [
        {
            key: "renderHeaderCells",
            value: function renderHeaderCells(range) {
                var _this2 = this;
                var _this$props2 = this.props, localizer = _this$props2.localizer, getDrilldownView = _this$props2.getDrilldownView, getNow = _this$props2.getNow, dayProp = _this$props2.getters.dayProp, _this$props2$componen = _this$props2.components.header, HeaderComponent = _this$props2$componen === void 0 ? $a4fe492ece4426a3$var$Header : _this$props2$componen;
                var today = getNow();
                return range.map(function(date, i) {
                    var drilldownView = getDrilldownView(date);
                    var label = localizer.format(date, 'dayFormat');
                    var _dayProp = dayProp(date), className = _dayProp.className, style = _dayProp.style;
                    var header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(HeaderComponent, {
                        date: date,
                        label: label,
                        localizer: localizer
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                        key: i,
                        style: style,
                        className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)('rbc-header', className, localizer.isSameDate(date, today) && 'rbc-today')
                    }, drilldownView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
                        type: "button",
                        className: "rbc-button-link",
                        onClick: function onClick(e) {
                            return _this2.handleHeaderClick(date, drilldownView, e);
                        }
                    }, header) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", null, header));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props3 = this.props, width = _this$props3.width, rtl = _this$props3.rtl, resources = _this$props3.resources, range = _this$props3.range, events = _this$props3.events, getNow = _this$props3.getNow, accessors = _this$props3.accessors, selectable = _this$props3.selectable, components = _this$props3.components, getters = _this$props3.getters, scrollRef = _this$props3.scrollRef, localizer = _this$props3.localizer, isOverflowing = _this$props3.isOverflowing, _this$props3$componen = _this$props3.components, TimeGutterHeader = _this$props3$componen.timeGutterHeader, _this$props3$componen2 = _this$props3$componen.resourceHeader, ResourceHeaderComponent = _this$props3$componen2 === void 0 ? $a4fe492ece4426a3$var$ResourceHeader : _this$props3$componen2, resizable = _this$props3.resizable;
                var style = {};
                if (isOverflowing) style[rtl ? 'marginLeft' : 'marginRight'] = "".concat((0, $0902d8bc01e222ae$export$2e2bcd8739ae039)(), "px");
                var groupedEvents = resources.groupEvents(events);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    style: style,
                    ref: scrollRef,
                    className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)('rbc-time-header', isOverflowing && 'rbc-overflowing')
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "rbc-label rbc-time-header-gutter",
                    style: {
                        width: width,
                        minWidth: width,
                        maxWidth: width
                    }
                }, TimeGutterHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(TimeGutterHeader, null)), resources.map(function(_ref, idx) {
                    var _ref2 = (0, $951471461146a3e9$export$2e2bcd8739ae039)(_ref, 2), id = _ref2[0], resource = _ref2[1];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                        className: "rbc-time-header-content",
                        key: id || idx
                    }, resource && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                        className: "rbc-row rbc-row-resource",
                        key: "resource_".concat(idx)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                        className: "rbc-header"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(ResourceHeaderComponent, {
                        index: idx,
                        label: accessors.resourceTitle(resource),
                        resource: resource
                    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                        className: "rbc-row rbc-time-header-cell".concat(range.length <= 1 ? ' rbc-time-header-cell-single-day' : '')
                    }, _this3.renderHeaderCells(range)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$DateContentRow, {
                        isAllDay: true,
                        rtl: rtl,
                        getNow: getNow,
                        minRows: 2,
                        range: range,
                        events: groupedEvents.get(id) || [],
                        resourceId: resource && id,
                        className: "rbc-allday-cell",
                        selectable: selectable,
                        selected: _this3.props.selected,
                        components: components,
                        accessors: accessors,
                        getters: getters,
                        localizer: localizer,
                        onSelect: _this3.props.onSelectEvent,
                        onDoubleClick: _this3.props.onDoubleClickEvent,
                        onKeyPress: _this3.props.onKeyPressEvent,
                        onSelectSlot: _this3.props.onSelectSlot,
                        longPressThreshold: _this3.props.longPressThreshold,
                        resizable: resizable
                    }));
                }));
            }
        }
    ]);
    return TimeGridHeader;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
var $a4fe492ece4426a3$var$NONE = {};
function $a4fe492ece4426a3$var$Resources(resources, accessors) {
    return {
        map: function map(fn) {
            if (!resources) return [
                fn([
                    $a4fe492ece4426a3$var$NONE,
                    null
                ], 0)
            ];
            return resources.map(function(resource, idx) {
                return fn([
                    accessors.resourceId(resource),
                    resource
                ], idx);
            });
        },
        groupEvents: function groupEvents(events) {
            var eventsByResource = new Map();
            if (!resources) {
                // Return all events if resources are not provided
                eventsByResource.set($a4fe492ece4426a3$var$NONE, events);
                return eventsByResource;
            }
            events.forEach(function(event) {
                var id = accessors.resource(event) || $a4fe492ece4426a3$var$NONE;
                var resourceEvents = eventsByResource.get(id) || [];
                resourceEvents.push(event);
                eventsByResource.set(id, resourceEvents);
            });
            return eventsByResource;
        }
    };
}
var $a4fe492ece4426a3$var$TimeGrid = /*#__PURE__*/ function(_Component) {
    (0, $2tFMC.default)(TimeGrid, _Component);
    var _super = (0, $5d4b78f32a0ca363$export$2e2bcd8739ae039)(TimeGrid);
    function TimeGrid(props) {
        var _this;
        (0, $9VR4w.default)(this, TimeGrid);
        _this = _super.call(this, props);
        _this.handleScroll = function(e) {
            if (_this.scrollRef.current) _this.scrollRef.current.scrollLeft = e.target.scrollLeft;
        };
        _this.handleResize = function() {
            $c70f3c10ca880f8d$export$70b61ad426ddbe54(_this.rafHandle);
            _this.rafHandle = $c70f3c10ca880f8d$export$b5fe3f66a567bec0(_this.checkOverflow);
        };
        _this.handleSelectAlldayEvent = function() {
            //cancel any pending selections so only the event click goes through.
            _this.clearSelection();
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            $a4fe492ece4426a3$var$notify(_this.props.onSelectEvent, args);
        };
        _this.handleSelectAllDaySlot = function(slots, slotInfo) {
            var onSelectSlot = _this.props.onSelectSlot;
            var start = new Date(slots[0]);
            var end = new Date(slots[slots.length - 1]);
            end.setDate(slots[slots.length - 1].getDate() + 1);
            $a4fe492ece4426a3$var$notify(onSelectSlot, {
                slots: slots,
                start: start,
                end: end,
                action: slotInfo.action,
                resourceId: slotInfo.resourceId
            });
        };
        _this.checkOverflow = function() {
            if (_this._updatingOverflow) return;
            var content = _this.contentRef.current;
            var isOverflowing = content.scrollHeight > content.clientHeight;
            if (_this.state.isOverflowing !== isOverflowing) {
                _this._updatingOverflow = true;
                _this.setState({
                    isOverflowing: isOverflowing
                }, function() {
                    _this._updatingOverflow = false;
                });
            }
        };
        _this.memoizedResources = (0, $e3e5797910a02537$export$2e2bcd8739ae039)(function(resources, accessors) {
            return $a4fe492ece4426a3$var$Resources(resources, accessors);
        });
        _this.state = {
            gutterWidth: undefined,
            isOverflowing: null
        };
        _this.scrollRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createRef();
        _this.contentRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createRef();
        _this._scrollRatio = null;
        _this.gutterRef = /*#__PURE__*/ (0, $6fFrj.createRef)();
        return _this;
    }
    (0, $8HiBB.default)(TimeGrid, [
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate() {
                this.checkOverflow();
                return null;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.width == null) this.measureGutter();
                this.calculateScroll();
                this.applyScroll();
                window.addEventListener('resize', this.handleResize);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener('resize', this.handleResize);
                $c70f3c10ca880f8d$export$70b61ad426ddbe54(this.rafHandle);
                if (this.measureGutterAnimationFrameRequest) window.cancelAnimationFrame(this.measureGutterAnimationFrameRequest);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.applyScroll();
            }
        },
        {
            key: "renderEvents",
            value: function renderEvents(range, events, backgroundEvents, now) {
                var _this2 = this;
                var _this$props = this.props, min = _this$props.min, max = _this$props.max, components = _this$props.components, accessors = _this$props.accessors, localizer = _this$props.localizer, dayLayoutAlgorithm = _this$props.dayLayoutAlgorithm;
                var resources = this.memoizedResources(this.props.resources, accessors);
                var groupedEvents = resources.groupEvents(events);
                var groupedBackgroundEvents = resources.groupEvents(backgroundEvents);
                return resources.map(function(_ref, i) {
                    var _ref2 = (0, $951471461146a3e9$export$2e2bcd8739ae039)(_ref, 2), id = _ref2[0], resource = _ref2[1];
                    return range.map(function(date, jj) {
                        var daysEvents = (groupedEvents.get(id) || []).filter(function(event) {
                            return localizer.inRange(date, accessors.start(event), accessors.end(event), 'day');
                        });
                        var daysBackgroundEvents = (groupedBackgroundEvents.get(id) || []).filter(function(event) {
                            return localizer.inRange(date, accessors.start(event), accessors.end(event), 'day');
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$DayColumn, Object.assign({}, _this2.props, {
                            localizer: localizer,
                            min: localizer.merge(date, min),
                            max: localizer.merge(date, max),
                            resource: resource && id,
                            components: components,
                            isNow: localizer.isSameDate(date, now),
                            key: i + '-' + jj,
                            date: date,
                            events: daysEvents,
                            backgroundEvents: daysBackgroundEvents,
                            dayLayoutAlgorithm: dayLayoutAlgorithm
                        }));
                    });
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, events = _this$props2.events, backgroundEvents = _this$props2.backgroundEvents, range = _this$props2.range, width = _this$props2.width, rtl = _this$props2.rtl, selected = _this$props2.selected, getNow = _this$props2.getNow, resources = _this$props2.resources, components = _this$props2.components, accessors = _this$props2.accessors, getters = _this$props2.getters, localizer = _this$props2.localizer, min = _this$props2.min, max = _this$props2.max, showMultiDayTimes = _this$props2.showMultiDayTimes, longPressThreshold = _this$props2.longPressThreshold, resizable = _this$props2.resizable;
                width = width || this.state.gutterWidth;
                var start = range[0], end = range[range.length - 1];
                this.slots = range.length;
                var allDayEvents = [], rangeEvents = [], rangeBackgroundEvents = [];
                events.forEach(function(event) {
                    if ($a4fe492ece4426a3$var$inRange(event, start, end, accessors, localizer)) {
                        var eStart = accessors.start(event), eEnd = accessors.end(event);
                        if (accessors.allDay(event) || localizer.startAndEndAreDateOnly(eStart, eEnd) || !showMultiDayTimes && !localizer.isSameDate(eStart, eEnd)) allDayEvents.push(event);
                        else rangeEvents.push(event);
                    }
                });
                backgroundEvents.forEach(function(event) {
                    if ($a4fe492ece4426a3$var$inRange(event, start, end, accessors, localizer)) rangeBackgroundEvents.push(event);
                });
                allDayEvents.sort(function(a, b) {
                    return $a4fe492ece4426a3$var$sortEvents(a, b, accessors, localizer);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)('rbc-time-view', resources && 'rbc-time-view-resources')
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$TimeGridHeader, {
                    range: range,
                    events: allDayEvents,
                    width: width,
                    rtl: rtl,
                    getNow: getNow,
                    localizer: localizer,
                    selected: selected,
                    resources: this.memoizedResources(resources, accessors),
                    selectable: this.props.selectable,
                    accessors: accessors,
                    getters: getters,
                    components: components,
                    scrollRef: this.scrollRef,
                    isOverflowing: this.state.isOverflowing,
                    longPressThreshold: longPressThreshold,
                    onSelectSlot: this.handleSelectAllDaySlot,
                    onSelectEvent: this.handleSelectAlldayEvent,
                    onDoubleClickEvent: this.props.onDoubleClickEvent,
                    onKeyPressEvent: this.props.onKeyPressEvent,
                    onDrillDown: this.props.onDrillDown,
                    getDrilldownView: this.props.getDrilldownView,
                    resizable: resizable
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    ref: this.contentRef,
                    className: "rbc-time-content",
                    onScroll: this.handleScroll
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$TimeGutter$1, {
                    date: start,
                    ref: this.gutterRef,
                    localizer: localizer,
                    min: localizer.merge(start, min),
                    max: localizer.merge(start, max),
                    step: this.props.step,
                    getNow: this.props.getNow,
                    timeslots: this.props.timeslots,
                    components: components,
                    className: "rbc-time-gutter",
                    getters: getters
                }), this.renderEvents(range, rangeEvents, rangeBackgroundEvents, getNow())));
            }
        },
        {
            key: "clearSelection",
            value: function clearSelection() {
                clearTimeout(this._selectTimer);
                this._pendingSelection = [];
            }
        },
        {
            key: "measureGutter",
            value: function measureGutter() {
                var _this3 = this;
                if (this.measureGutterAnimationFrameRequest) window.cancelAnimationFrame(this.measureGutterAnimationFrameRequest);
                this.measureGutterAnimationFrameRequest = window.requestAnimationFrame(function() {
                    var _this3$gutterRef;
                    var width = (_this3$gutterRef = _this3.gutterRef) !== null && _this3$gutterRef !== void 0 && _this3$gutterRef.current ? (0, $adfea2f106a3212d$export$2e2bcd8739ae039)(_this3.gutterRef.current) : undefined;
                    if (width && _this3.state.gutterWidth !== width) _this3.setState({
                        gutterWidth: width
                    });
                });
            }
        },
        {
            key: "applyScroll",
            value: function applyScroll() {
                // If auto-scroll is disabled, we don't actually apply the scroll
                if (this._scrollRatio != null && this.props.enableAutoScroll === true) {
                    var content = this.contentRef.current;
                    content.scrollTop = content.scrollHeight * this._scrollRatio; // Only do this once
                    this._scrollRatio = null;
                }
            }
        },
        {
            key: "calculateScroll",
            value: function calculateScroll() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var min = props.min, max = props.max, scrollToTime = props.scrollToTime, localizer = props.localizer;
                var diffMillis = scrollToTime - localizer.startOf(scrollToTime, 'day');
                var totalMillis = localizer.diff(min, max, 'milliseconds');
                this._scrollRatio = diffMillis / totalMillis;
            }
        }
    ]);
    return TimeGrid;
}((0, $6fFrj.Component));
$a4fe492ece4426a3$var$TimeGrid.defaultProps = {
    step: 30,
    timeslots: 2
};
var $a4fe492ece4426a3$var$_excluded$4 = [
    "date",
    "localizer",
    "min",
    "max",
    "scrollToTime",
    "enableAutoScroll"
];
var $a4fe492ece4426a3$var$Day = /*#__PURE__*/ function(_React$Component) {
    (0, $2tFMC.default)(Day, _React$Component);
    var _super = (0, $5d4b78f32a0ca363$export$2e2bcd8739ae039)(Day);
    function Day() {
        (0, $9VR4w.default)(this, Day);
        return _super.apply(this, arguments);
    }
    (0, $8HiBB.default)(Day, [
        {
            key: "render",
            value: function render() {
                /**
       * This allows us to default min, max, and scrollToTime
       * using our localizer. This is necessary until such time
       * as TimeGrid is converted to a functional component.
       */ var _this$props = this.props, date = _this$props.date, localizer = _this$props.localizer, _this$props$min = _this$props.min, min = _this$props$min === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$min, _this$props$max = _this$props.max, max = _this$props$max === void 0 ? localizer.endOf(new Date(), 'day') : _this$props$max, _this$props$scrollToT = _this$props.scrollToTime, scrollToTime = _this$props$scrollToT === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$scrollToT, _this$props$enableAut = _this$props.enableAutoScroll, enableAutoScroll = _this$props$enableAut === void 0 ? true : _this$props$enableAut, props = (0, $7a2c209832ffd573$export$2e2bcd8739ae039)(_this$props, $a4fe492ece4426a3$var$_excluded$4);
                var range = Day.range(date, {
                    localizer: localizer
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$TimeGrid, Object.assign({}, props, {
                    range: range,
                    eventOffset: 10,
                    localizer: localizer,
                    min: min,
                    max: max,
                    scrollToTime: scrollToTime,
                    enableAutoScroll: enableAutoScroll
                }));
            }
        }
    ]);
    return Day;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
$a4fe492ece4426a3$var$Day.range = function(date, _ref) {
    var localizer = _ref.localizer;
    return [
        localizer.startOf(date, 'day')
    ];
};
$a4fe492ece4426a3$var$Day.navigate = function(date, action, _ref2) {
    var localizer = _ref2.localizer;
    switch(action){
        case $a4fe492ece4426a3$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -1, 'day');
        case $a4fe492ece4426a3$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, 1, 'day');
        default:
            return date;
    }
};
$a4fe492ece4426a3$var$Day.title = function(date, _ref3) {
    var localizer = _ref3.localizer;
    return localizer.format(date, 'dayHeaderFormat');
};
var $a4fe492ece4426a3$var$_excluded$3 = [
    "date",
    "localizer",
    "min",
    "max",
    "scrollToTime",
    "enableAutoScroll"
];
var $a4fe492ece4426a3$var$Week = /*#__PURE__*/ function(_React$Component) {
    (0, $2tFMC.default)(Week, _React$Component);
    var _super = (0, $5d4b78f32a0ca363$export$2e2bcd8739ae039)(Week);
    function Week() {
        (0, $9VR4w.default)(this, Week);
        return _super.apply(this, arguments);
    }
    (0, $8HiBB.default)(Week, [
        {
            key: "render",
            value: function render() {
                /**
       * This allows us to default min, max, and scrollToTime
       * using our localizer. This is necessary until such time
       * as TimeGrid is converted to a functional component.
       */ var _this$props = this.props, date = _this$props.date, localizer = _this$props.localizer, _this$props$min = _this$props.min, min = _this$props$min === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$min, _this$props$max = _this$props.max, max = _this$props$max === void 0 ? localizer.endOf(new Date(), 'day') : _this$props$max, _this$props$scrollToT = _this$props.scrollToTime, scrollToTime = _this$props$scrollToT === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$scrollToT, _this$props$enableAut = _this$props.enableAutoScroll, enableAutoScroll = _this$props$enableAut === void 0 ? true : _this$props$enableAut, props = (0, $7a2c209832ffd573$export$2e2bcd8739ae039)(_this$props, $a4fe492ece4426a3$var$_excluded$3);
                var range = Week.range(date, this.props);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$TimeGrid, Object.assign({}, props, {
                    range: range,
                    eventOffset: 15,
                    localizer: localizer,
                    min: min,
                    max: max,
                    scrollToTime: scrollToTime,
                    enableAutoScroll: enableAutoScroll
                }));
            }
        }
    ]);
    return Week;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
$a4fe492ece4426a3$var$Week.defaultProps = $a4fe492ece4426a3$var$TimeGrid.defaultProps;
$a4fe492ece4426a3$var$Week.navigate = function(date, action, _ref) {
    var localizer = _ref.localizer;
    switch(action){
        case $a4fe492ece4426a3$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -1, 'week');
        case $a4fe492ece4426a3$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, 1, 'week');
        default:
            return date;
    }
};
$a4fe492ece4426a3$var$Week.range = function(date, _ref2) {
    var localizer = _ref2.localizer;
    var firstOfWeek = localizer.startOfWeek();
    var start = localizer.startOf(date, 'week', firstOfWeek);
    var end = localizer.endOf(date, 'week', firstOfWeek);
    return localizer.range(start, end);
};
$a4fe492ece4426a3$var$Week.title = function(date, _ref3) {
    var localizer = _ref3.localizer;
    var _Week$range = $a4fe492ece4426a3$var$Week.range(date, {
        localizer: localizer
    }), _Week$range2 = (0, $fxpTi.default)(_Week$range), start = _Week$range2[0], rest = _Week$range2.slice(1);
    return localizer.format({
        start: start,
        end: rest.pop()
    }, 'dayRangeHeaderFormat');
};
var $a4fe492ece4426a3$var$_excluded$2 = [
    "date",
    "localizer",
    "min",
    "max",
    "scrollToTime",
    "enableAutoScroll"
];
function $a4fe492ece4426a3$var$workWeekRange(date, options) {
    return $a4fe492ece4426a3$var$Week.range(date, options).filter(function(d) {
        return [
            6,
            0
        ].indexOf(d.getDay()) === -1;
    });
}
var $a4fe492ece4426a3$var$WorkWeek = /*#__PURE__*/ function(_React$Component) {
    (0, $2tFMC.default)(WorkWeek, _React$Component);
    var _super = (0, $5d4b78f32a0ca363$export$2e2bcd8739ae039)(WorkWeek);
    function WorkWeek() {
        (0, $9VR4w.default)(this, WorkWeek);
        return _super.apply(this, arguments);
    }
    (0, $8HiBB.default)(WorkWeek, [
        {
            key: "render",
            value: function render() {
                /**
       * This allows us to default min, max, and scrollToTime
       * using our localizer. This is necessary until such time
       * as TimeGrid is converted to a functional component.
       */ var _this$props = this.props, date = _this$props.date, localizer = _this$props.localizer, _this$props$min = _this$props.min, min = _this$props$min === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$min, _this$props$max = _this$props.max, max = _this$props$max === void 0 ? localizer.endOf(new Date(), 'day') : _this$props$max, _this$props$scrollToT = _this$props.scrollToTime, scrollToTime = _this$props$scrollToT === void 0 ? localizer.startOf(new Date(), 'day') : _this$props$scrollToT, _this$props$enableAut = _this$props.enableAutoScroll, enableAutoScroll = _this$props$enableAut === void 0 ? true : _this$props$enableAut, props = (0, $7a2c209832ffd573$export$2e2bcd8739ae039)(_this$props, $a4fe492ece4426a3$var$_excluded$2);
                var range = $a4fe492ece4426a3$var$workWeekRange(date, this.props);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($a4fe492ece4426a3$var$TimeGrid, Object.assign({}, props, {
                    range: range,
                    eventOffset: 15,
                    localizer: localizer,
                    min: min,
                    max: max,
                    scrollToTime: scrollToTime,
                    enableAutoScroll: enableAutoScroll
                }));
            }
        }
    ]);
    return WorkWeek;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
$a4fe492ece4426a3$var$WorkWeek.defaultProps = $a4fe492ece4426a3$var$TimeGrid.defaultProps;
$a4fe492ece4426a3$var$WorkWeek.range = $a4fe492ece4426a3$var$workWeekRange;
$a4fe492ece4426a3$var$WorkWeek.navigate = $a4fe492ece4426a3$var$Week.navigate;
$a4fe492ece4426a3$var$WorkWeek.title = function(date, _ref) {
    var localizer = _ref.localizer;
    var _workWeekRange = $a4fe492ece4426a3$var$workWeekRange(date, {
        localizer: localizer
    }), _workWeekRange2 = (0, $fxpTi.default)(_workWeekRange), start = _workWeekRange2[0], rest = _workWeekRange2.slice(1);
    return localizer.format({
        start: start,
        end: rest.pop()
    }, 'dayRangeHeaderFormat');
};
function $a4fe492ece4426a3$var$Agenda(_ref) {
    var accessors = _ref.accessors, components = _ref.components, date = _ref.date, events = _ref.events, getters = _ref.getters, length = _ref.length, localizer = _ref.localizer, onDoubleClickEvent = _ref.onDoubleClickEvent, onSelectEvent = _ref.onSelectEvent, selected = _ref.selected;
    var headerRef = (0, $6fFrj.useRef)(null);
    var dateColRef = (0, $6fFrj.useRef)(null);
    var timeColRef = (0, $6fFrj.useRef)(null);
    var contentRef = (0, $6fFrj.useRef)(null);
    var tbodyRef = (0, $6fFrj.useRef)(null);
    (0, $6fFrj.useEffect)(function() {
        _adjustHeader();
    });
    var renderDay = function renderDay(day, events, dayKey) {
        var Event = components.event, AgendaDate = components.date;
        events = events.filter(function(e) {
            return $a4fe492ece4426a3$var$inRange(e, localizer.startOf(day, 'day'), localizer.endOf(day, 'day'), accessors, localizer);
        });
        return events.map(function(event, idx) {
            var title = accessors.title(event);
            var end = accessors.end(event);
            var start = accessors.start(event);
            var userProps = getters.eventProp(event, start, end, $a4fe492ece4426a3$var$isSelected(event, selected));
            var dateLabel = idx === 0 && localizer.format(day, 'agendaDateFormat');
            var first = idx === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("td", {
                rowSpan: events.length,
                className: "rbc-agenda-date-cell"
            }, AgendaDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(AgendaDate, {
                day: day,
                label: dateLabel
            }) : dateLabel) : false;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("tr", {
                key: dayKey + '_' + idx,
                className: userProps.className,
                style: userProps.style
            }, first, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("td", {
                className: "rbc-agenda-time-cell"
            }, timeRangeLabel(day, event)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("td", {
                className: "rbc-agenda-event-cell",
                onClick: function onClick(e) {
                    return onSelectEvent && onSelectEvent(event, e);
                },
                onDoubleClick: function onDoubleClick(e) {
                    return onDoubleClickEvent && onDoubleClickEvent(event, e);
                }
            }, Event ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Event, {
                event: event,
                title: title
            }) : title));
        }, []);
    };
    var timeRangeLabel = function timeRangeLabel(day, event) {
        var labelClass = '', TimeComponent = components.time, label = localizer.messages.allDay;
        var end = accessors.end(event);
        var start = accessors.start(event);
        if (!accessors.allDay(event)) {
            if (localizer.eq(start, end)) label = localizer.format(start, 'agendaTimeFormat');
            else if (localizer.isSameDate(start, end)) label = localizer.format({
                start: start,
                end: end
            }, 'agendaTimeRangeFormat');
            else if (localizer.isSameDate(day, start)) label = localizer.format(start, 'agendaTimeFormat');
            else if (localizer.isSameDate(day, end)) label = localizer.format(end, 'agendaTimeFormat');
        }
        if (localizer.gt(day, start, 'day')) labelClass = 'rbc-continues-prior';
        if (localizer.lt(day, end, 'day')) labelClass += ' rbc-continues-after';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
            className: labelClass.trim()
        }, TimeComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(TimeComponent, {
            event: event,
            day: day,
            label: label
        }) : label);
    };
    var _adjustHeader = function _adjustHeader() {
        if (!tbodyRef.current) return;
        var header = headerRef.current;
        var firstRow = tbodyRef.current.firstChild;
        if (!firstRow) return;
        var isOverflowing = contentRef.current.scrollHeight > contentRef.current.clientHeight;
        var _widths = [];
        var widths = _widths;
        _widths = [
            (0, $adfea2f106a3212d$export$2e2bcd8739ae039)(firstRow.children[0]),
            (0, $adfea2f106a3212d$export$2e2bcd8739ae039)(firstRow.children[1])
        ];
        if (widths[0] !== _widths[0] || widths[1] !== _widths[1]) {
            dateColRef.current.style.width = _widths[0] + 'px';
            timeColRef.current.style.width = _widths[1] + 'px';
        }
        if (isOverflowing) {
            (0, $d07ae03f7f70a2fd$export$2e2bcd8739ae039)(header, 'rbc-header-overflowing');
            header.style.marginRight = (0, $0902d8bc01e222ae$export$2e2bcd8739ae039)() + 'px';
        } else (0, $c71dc5a2753a7ab8$export$2e2bcd8739ae039)(header, 'rbc-header-overflowing');
    };
    var messages = localizer.messages;
    var end = localizer.add(date, length, 'day');
    var range = localizer.range(date, end, 'day');
    events = events.filter(function(event) {
        return $a4fe492ece4426a3$var$inRange(event, localizer.startOf(date, 'day'), localizer.endOf(end, 'day'), accessors, localizer);
    });
    events.sort(function(a, b) {
        return +accessors.start(a) - +accessors.start(b);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "rbc-agenda-view"
    }, events.length !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("table", {
        ref: headerRef,
        className: "rbc-agenda-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("th", {
        className: "rbc-header",
        ref: dateColRef
    }, messages.date), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("th", {
        className: "rbc-header",
        ref: timeColRef
    }, messages.time), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("th", {
        className: "rbc-header"
    }, messages.event)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "rbc-agenda-content",
        ref: contentRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("table", {
        className: "rbc-agenda-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("tbody", {
        ref: tbodyRef
    }, range.map(function(day, idx) {
        return renderDay(day, events, idx);
    }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
        className: "rbc-agenda-empty"
    }, messages.noEventsInRange));
}
$a4fe492ece4426a3$var$Agenda.defaultProps = {
    length: 30
};
$a4fe492ece4426a3$var$Agenda.range = function(start, _ref2) {
    var _ref2$length = _ref2.length, length = _ref2$length === void 0 ? $a4fe492ece4426a3$var$Agenda.defaultProps.length : _ref2$length, localizer = _ref2.localizer;
    var end = localizer.add(start, length, 'day');
    return {
        start: start,
        end: end
    };
};
$a4fe492ece4426a3$var$Agenda.navigate = function(date, action, _ref3) {
    var _ref3$length = _ref3.length, length = _ref3$length === void 0 ? $a4fe492ece4426a3$var$Agenda.defaultProps.length : _ref3$length, localizer = _ref3.localizer;
    switch(action){
        case $a4fe492ece4426a3$export$444b3ab0cb9aec40.PREVIOUS:
            return localizer.add(date, -length, 'day');
        case $a4fe492ece4426a3$export$444b3ab0cb9aec40.NEXT:
            return localizer.add(date, length, 'day');
        default:
            return date;
    }
};
$a4fe492ece4426a3$var$Agenda.title = function(start, _ref4) {
    var _ref4$length = _ref4.length, length = _ref4$length === void 0 ? $a4fe492ece4426a3$var$Agenda.defaultProps.length : _ref4$length, localizer = _ref4.localizer;
    var end = localizer.add(start, length, 'day');
    return localizer.format({
        start: start,
        end: end
    }, 'agendaHeaderFormat');
};
var $a4fe492ece4426a3$var$_VIEWS;
var $a4fe492ece4426a3$var$VIEWS = ($a4fe492ece4426a3$var$_VIEWS = {}, (0, $5fApW.default)($a4fe492ece4426a3$var$_VIEWS, $a4fe492ece4426a3$export$5cb791131c501f6a.MONTH, $a4fe492ece4426a3$var$MonthView), (0, $5fApW.default)($a4fe492ece4426a3$var$_VIEWS, $a4fe492ece4426a3$export$5cb791131c501f6a.WEEK, $a4fe492ece4426a3$var$Week), (0, $5fApW.default)($a4fe492ece4426a3$var$_VIEWS, $a4fe492ece4426a3$export$5cb791131c501f6a.WORK_WEEK, $a4fe492ece4426a3$var$WorkWeek), (0, $5fApW.default)($a4fe492ece4426a3$var$_VIEWS, $a4fe492ece4426a3$export$5cb791131c501f6a.DAY, $a4fe492ece4426a3$var$Day), (0, $5fApW.default)($a4fe492ece4426a3$var$_VIEWS, $a4fe492ece4426a3$export$5cb791131c501f6a.AGENDA, $a4fe492ece4426a3$var$Agenda), $a4fe492ece4426a3$var$_VIEWS);
var $a4fe492ece4426a3$var$_excluded$1 = [
    "action",
    "date",
    "today"
];
function $a4fe492ece4426a3$export$d947e5f4f4c48d48(View, _ref) {
    var action = _ref.action, date = _ref.date, today = _ref.today, props = (0, $7a2c209832ffd573$export$2e2bcd8739ae039)(_ref, $a4fe492ece4426a3$var$_excluded$1);
    View = typeof View === 'string' ? $a4fe492ece4426a3$var$VIEWS[View] : View;
    switch(action){
        case $a4fe492ece4426a3$export$444b3ab0cb9aec40.TODAY:
            date = today || new Date();
            break;
        case $a4fe492ece4426a3$export$444b3ab0cb9aec40.DATE:
            break;
        default:
            (0, (/*@__PURE__*/$parcel$interopDefault($d787f36c95e388b1$exports)))(View && typeof View.navigate === 'function', 'Calendar View components must implement a static `.navigate(date, action)` method.s');
            date = View.navigate(date, action, props);
    }
    return date;
}
var $a4fe492ece4426a3$var$Toolbar = /*#__PURE__*/ function(_React$Component) {
    (0, $2tFMC.default)(Toolbar, _React$Component);
    var _super = (0, $5d4b78f32a0ca363$export$2e2bcd8739ae039)(Toolbar);
    function Toolbar() {
        var _this;
        (0, $9VR4w.default)(this, Toolbar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.navigate = function(action) {
            _this.props.onNavigate(action);
        };
        _this.view = function(view) {
            _this.props.onView(view);
        };
        return _this;
    }
    (0, $8HiBB.default)(Toolbar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, messages = _this$props.localizer.messages, label = _this$props.label;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "rbc-toolbar"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
                    className: "rbc-btn-group"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
                    type: "button",
                    onClick: this.navigate.bind(null, $a4fe492ece4426a3$export$444b3ab0cb9aec40.TODAY)
                }, messages.today), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
                    type: "button",
                    onClick: this.navigate.bind(null, $a4fe492ece4426a3$export$444b3ab0cb9aec40.PREVIOUS)
                }, messages.previous), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
                    type: "button",
                    onClick: this.navigate.bind(null, $a4fe492ece4426a3$export$444b3ab0cb9aec40.NEXT)
                }, messages.next)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
                    className: "rbc-toolbar-label"
                }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
                    className: "rbc-btn-group"
                }, this.viewNamesGroup(messages)));
            }
        },
        {
            key: "viewNamesGroup",
            value: function viewNamesGroup(messages) {
                var _this2 = this;
                var viewNames = this.props.views;
                var view = this.props.view;
                if (viewNames.length > 1) return viewNames.map(function(name) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
                        type: "button",
                        key: name,
                        className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)({
                            'rbc-active': view === name
                        }),
                        onClick: _this2.view.bind(null, name)
                    }, messages[name]);
                });
            }
        }
    ]);
    return Toolbar;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
/**
 * Retrieve via an accessor-like property
 *
 *    accessor(obj, 'name')   // => retrieves obj['name']
 *    accessor(data, func)    // => retrieves func(data)
 *    ... otherwise null
 */ function $a4fe492ece4426a3$var$accessor(data, field) {
    var value = null;
    if (typeof field === 'function') value = field(data);
    else if (typeof field === 'string' && (0, $6g7hW.default)(data) === 'object' && data != null && field in data) value = data[field];
    return value;
}
var $a4fe492ece4426a3$var$wrapAccessor = function wrapAccessor(acc) {
    return function(data) {
        return $a4fe492ece4426a3$var$accessor(data, acc);
    };
};
var $a4fe492ece4426a3$var$_excluded = [
    "view",
    "date",
    "getNow",
    "onNavigate"
], $a4fe492ece4426a3$var$_excluded2 = [
    "view",
    "toolbar",
    "events",
    "backgroundEvents",
    "style",
    "className",
    "elementProps",
    "date",
    "getNow",
    "length",
    "showMultiDayTimes",
    "onShowMore",
    "doShowMoreDrillDown",
    "components",
    "formats",
    "messages",
    "culture"
];
function $a4fe492ece4426a3$var$viewNames(_views) {
    return !Array.isArray(_views) ? Object.keys(_views) : _views;
}
function $a4fe492ece4426a3$var$isValidView(view, _ref) {
    var _views = _ref.views;
    var names = $a4fe492ece4426a3$var$viewNames(_views);
    return names.indexOf(view) !== -1;
}
var $a4fe492ece4426a3$var$Calendar = /*#__PURE__*/ function(_React$Component) {
    (0, $2tFMC.default)(Calendar, _React$Component);
    var _super = (0, $5d4b78f32a0ca363$export$2e2bcd8739ae039)(Calendar);
    function Calendar() {
        var _this;
        (0, $9VR4w.default)(this, Calendar);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(_args));
        _this.getViews = function() {
            var views = _this.props.views;
            if (Array.isArray(views)) return (0, $8daa841c663c8fbf$export$2e2bcd8739ae039)(views, function(obj, name) {
                return obj[name] = $a4fe492ece4426a3$var$VIEWS[name];
            }, {});
            if ((0, $6g7hW.default)(views) === 'object') return (0, $6ad4a5806d722bb1$export$2e2bcd8739ae039)(views, function(value, key) {
                if (value === true) return $a4fe492ece4426a3$var$VIEWS[key];
                return value;
            });
            return $a4fe492ece4426a3$var$VIEWS;
        };
        _this.getView = function() {
            var views = _this.getViews();
            return views[_this.props.view];
        };
        _this.getDrilldownView = function(date) {
            var _this$props = _this.props, view = _this$props.view, drilldownView = _this$props.drilldownView, getDrilldownView = _this$props.getDrilldownView;
            if (!getDrilldownView) return drilldownView;
            return getDrilldownView(date, view, Object.keys(_this.getViews()));
        };
        _this.handleRangeChange = function(date, viewComponent, view) {
            var _this$props2 = _this.props, onRangeChange = _this$props2.onRangeChange, localizer = _this$props2.localizer;
            if (onRangeChange) {
                if (viewComponent.range) onRangeChange(viewComponent.range(date, {
                    localizer: localizer
                }), view);
            }
        };
        _this.handleNavigate = function(action, newDate) {
            var _this$props3 = _this.props, view = _this$props3.view, date = _this$props3.date, getNow = _this$props3.getNow, onNavigate = _this$props3.onNavigate, props = (0, $7a2c209832ffd573$export$2e2bcd8739ae039)(_this$props3, $a4fe492ece4426a3$var$_excluded);
            var ViewComponent = _this.getView();
            var today = getNow();
            date = $a4fe492ece4426a3$export$d947e5f4f4c48d48(ViewComponent, (0, $cdb445c333a43100$export$2e2bcd8739ae039)((0, $cdb445c333a43100$export$2e2bcd8739ae039)({}, props), {}, {
                action: action,
                date: newDate || date || today,
                today: today
            }));
            onNavigate(date, view, action);
            _this.handleRangeChange(date, ViewComponent);
        };
        _this.handleViewChange = function(view) {
            if (view !== _this.props.view && $a4fe492ece4426a3$var$isValidView(view, _this.props)) _this.props.onView(view);
            var views = _this.getViews();
            _this.handleRangeChange(_this.props.date || _this.props.getNow(), views[view], view);
        };
        _this.handleSelectEvent = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $a4fe492ece4426a3$var$notify(_this.props.onSelectEvent, args);
        };
        _this.handleDoubleClickEvent = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            $a4fe492ece4426a3$var$notify(_this.props.onDoubleClickEvent, args);
        };
        _this.handleKeyPressEvent = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            $a4fe492ece4426a3$var$notify(_this.props.onKeyPressEvent, args);
        };
        _this.handleSelectSlot = function(slotInfo) {
            $a4fe492ece4426a3$var$notify(_this.props.onSelectSlot, slotInfo);
        };
        _this.handleDrillDown = function(date, view) {
            var onDrillDown = _this.props.onDrillDown;
            if (onDrillDown) {
                onDrillDown(date, view, _this.drilldownView);
                return;
            }
            if (view) _this.handleViewChange(view);
            _this.handleNavigate($a4fe492ece4426a3$export$444b3ab0cb9aec40.DATE, date);
        };
        _this.state = {
            context: Calendar.getContext(_this.props)
        };
        return _this;
    }
    (0, $8HiBB.default)(Calendar, [
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, view = _this$props4.view, toolbar = _this$props4.toolbar, events = _this$props4.events, backgroundEvents = _this$props4.backgroundEvents, style = _this$props4.style, className = _this$props4.className, elementProps = _this$props4.elementProps, current = _this$props4.date, getNow = _this$props4.getNow, length = _this$props4.length, showMultiDayTimes = _this$props4.showMultiDayTimes, onShowMore = _this$props4.onShowMore, doShowMoreDrillDown = _this$props4.doShowMoreDrillDown;
                _this$props4.components;
                _this$props4.formats;
                _this$props4.messages;
                _this$props4.culture;
                var props = (0, $7a2c209832ffd573$export$2e2bcd8739ae039)(_this$props4, $a4fe492ece4426a3$var$_excluded2);
                current = current || getNow();
                var View = this.getView();
                var _this$state$context = this.state.context, accessors = _this$state$context.accessors, components = _this$state$context.components, getters = _this$state$context.getters, localizer = _this$state$context.localizer, viewNames = _this$state$context.viewNames;
                var CalToolbar = components.toolbar || $a4fe492ece4426a3$var$Toolbar;
                var label = View.title(current, {
                    localizer: localizer,
                    length: length
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", Object.assign({}, elementProps, {
                    className: (0, $946ef30d2f9a32f9$export$2e2bcd8739ae039)(className, 'rbc-calendar', props.rtl && 'rbc-rtl'),
                    style: style
                }), toolbar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(CalToolbar, {
                    date: current,
                    view: view,
                    views: viewNames,
                    label: label,
                    onView: this.handleViewChange,
                    onNavigate: this.handleNavigate,
                    localizer: localizer
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(View, Object.assign({}, props, {
                    events: events,
                    backgroundEvents: backgroundEvents,
                    date: current,
                    getNow: getNow,
                    length: length,
                    localizer: localizer,
                    getters: getters,
                    components: components,
                    accessors: accessors,
                    showMultiDayTimes: showMultiDayTimes,
                    getDrilldownView: this.getDrilldownView,
                    onNavigate: this.handleNavigate,
                    onDrillDown: this.handleDrillDown,
                    onSelectEvent: this.handleSelectEvent,
                    onDoubleClickEvent: this.handleDoubleClickEvent,
                    onKeyPressEvent: this.handleKeyPressEvent,
                    onSelectSlot: this.handleSelectSlot,
                    onShowMore: onShowMore,
                    doShowMoreDrillDown: doShowMoreDrillDown
                })));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps) {
                return {
                    context: Calendar.getContext(nextProps)
                };
            }
        },
        {
            key: "getContext",
            value: function getContext(_ref2) {
                var startAccessor = _ref2.startAccessor, endAccessor = _ref2.endAccessor, allDayAccessor = _ref2.allDayAccessor, tooltipAccessor = _ref2.tooltipAccessor, titleAccessor = _ref2.titleAccessor, resourceAccessor = _ref2.resourceAccessor, resourceIdAccessor = _ref2.resourceIdAccessor, resourceTitleAccessor = _ref2.resourceTitleAccessor, eventPropGetter = _ref2.eventPropGetter, backgroundEventPropGetter = _ref2.backgroundEventPropGetter, slotPropGetter = _ref2.slotPropGetter, slotGroupPropGetter = _ref2.slotGroupPropGetter, dayPropGetter = _ref2.dayPropGetter, view = _ref2.view, views = _ref2.views, localizer = _ref2.localizer, culture = _ref2.culture, _ref2$messages = _ref2.messages, messages$1 = _ref2$messages === void 0 ? {} : _ref2$messages, _ref2$components = _ref2.components, components = _ref2$components === void 0 ? {} : _ref2$components, _ref2$formats = _ref2.formats, formats = _ref2$formats === void 0 ? {} : _ref2$formats;
                var names = $a4fe492ece4426a3$var$viewNames(views);
                var msgs = $a4fe492ece4426a3$var$messages(messages$1);
                return {
                    viewNames: names,
                    localizer: $a4fe492ece4426a3$var$mergeWithDefaults(localizer, culture, formats, msgs),
                    getters: {
                        eventProp: function eventProp() {
                            return eventPropGetter && eventPropGetter.apply(void 0, arguments) || {};
                        },
                        backgroundEventProp: function backgroundEventProp() {
                            return backgroundEventPropGetter && backgroundEventPropGetter.apply(void 0, arguments) || {};
                        },
                        slotProp: function slotProp() {
                            return slotPropGetter && slotPropGetter.apply(void 0, arguments) || {};
                        },
                        slotGroupProp: function slotGroupProp() {
                            return slotGroupPropGetter && slotGroupPropGetter.apply(void 0, arguments) || {};
                        },
                        dayProp: function dayProp() {
                            return dayPropGetter && dayPropGetter.apply(void 0, arguments) || {};
                        }
                    },
                    components: (0, $7ca1670ad2be7672$export$2e2bcd8739ae039)(components[view] || {}, (0, $0ebf216ff8bb14c6$export$2e2bcd8739ae039)(components, names), {
                        eventWrapper: $a4fe492ece4426a3$var$NoopWrapper,
                        backgroundEventWrapper: $a4fe492ece4426a3$var$NoopWrapper,
                        eventContainerWrapper: $a4fe492ece4426a3$var$NoopWrapper,
                        dateCellWrapper: $a4fe492ece4426a3$var$NoopWrapper,
                        weekWrapper: $a4fe492ece4426a3$var$NoopWrapper,
                        timeSlotWrapper: $a4fe492ece4426a3$var$NoopWrapper,
                        timeGutterWrapper: $a4fe492ece4426a3$var$NoopWrapper
                    }),
                    accessors: {
                        start: $a4fe492ece4426a3$var$wrapAccessor(startAccessor),
                        end: $a4fe492ece4426a3$var$wrapAccessor(endAccessor),
                        allDay: $a4fe492ece4426a3$var$wrapAccessor(allDayAccessor),
                        tooltip: $a4fe492ece4426a3$var$wrapAccessor(tooltipAccessor),
                        title: $a4fe492ece4426a3$var$wrapAccessor(titleAccessor),
                        resource: $a4fe492ece4426a3$var$wrapAccessor(resourceAccessor),
                        resourceId: $a4fe492ece4426a3$var$wrapAccessor(resourceIdAccessor),
                        resourceTitle: $a4fe492ece4426a3$var$wrapAccessor(resourceTitleAccessor)
                    }
                };
            }
        }
    ]);
    return Calendar;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
$a4fe492ece4426a3$var$Calendar.defaultProps = {
    events: [],
    backgroundEvents: [],
    elementProps: {},
    popup: false,
    toolbar: true,
    view: $a4fe492ece4426a3$export$5cb791131c501f6a.MONTH,
    views: [
        $a4fe492ece4426a3$export$5cb791131c501f6a.MONTH,
        $a4fe492ece4426a3$export$5cb791131c501f6a.WEEK,
        $a4fe492ece4426a3$export$5cb791131c501f6a.DAY,
        $a4fe492ece4426a3$export$5cb791131c501f6a.AGENDA
    ],
    step: 30,
    length: 30,
    doShowMoreDrillDown: true,
    drilldownView: $a4fe492ece4426a3$export$5cb791131c501f6a.DAY,
    titleAccessor: 'title',
    tooltipAccessor: 'title',
    allDayAccessor: 'allDay',
    startAccessor: 'start',
    endAccessor: 'end',
    resourceAccessor: 'resourceId',
    resourceIdAccessor: 'id',
    resourceTitleAccessor: 'title',
    longPressThreshold: 250,
    getNow: function getNow() {
        return new Date();
    },
    dayLayoutAlgorithm: 'overlap'
};
var $a4fe492ece4426a3$export$e1aef45b828286de = (0, $779df5be45af0d78$export$2e2bcd8739ae039)($a4fe492ece4426a3$var$Calendar, {
    view: 'onView',
    date: 'onNavigate',
    selected: 'onSelectEvent'
});
var $a4fe492ece4426a3$var$weekRangeFormat$4 = function weekRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, 'MMMM DD', culture) + " \u2013 " + // updated to use this localizer 'eq()' method
    local.format(end, local.eq(start, end, 'month') ? 'DD' : 'MMMM DD', culture);
};
var $a4fe492ece4426a3$var$dateRangeFormat$4 = function dateRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, 'L', culture) + " \u2013 " + local.format(end, 'L', culture);
};
var $a4fe492ece4426a3$var$timeRangeFormat$4 = function timeRangeFormat(_ref3, culture, local) {
    var start = _ref3.start, end = _ref3.end;
    return local.format(start, 'LT', culture) + " \u2013 " + local.format(end, 'LT', culture);
};
var $a4fe492ece4426a3$var$timeRangeStartFormat$4 = function timeRangeStartFormat(_ref4, culture, local) {
    var start = _ref4.start;
    return local.format(start, 'LT', culture) + " \u2013 ";
};
var $a4fe492ece4426a3$var$timeRangeEndFormat$4 = function timeRangeEndFormat(_ref5, culture, local) {
    var end = _ref5.end;
    return " \u2013 " + local.format(end, 'LT', culture);
};
var $a4fe492ece4426a3$var$formats$4 = {
    dateFormat: 'DD',
    dayFormat: 'DD ddd',
    weekdayFormat: 'ddd',
    selectRangeFormat: $a4fe492ece4426a3$var$timeRangeFormat$4,
    eventTimeRangeFormat: $a4fe492ece4426a3$var$timeRangeFormat$4,
    eventTimeRangeStartFormat: $a4fe492ece4426a3$var$timeRangeStartFormat$4,
    eventTimeRangeEndFormat: $a4fe492ece4426a3$var$timeRangeEndFormat$4,
    timeGutterFormat: 'LT',
    monthHeaderFormat: 'MMMM YYYY',
    dayHeaderFormat: 'dddd MMM DD',
    dayRangeHeaderFormat: $a4fe492ece4426a3$var$weekRangeFormat$4,
    agendaHeaderFormat: $a4fe492ece4426a3$var$dateRangeFormat$4,
    agendaDateFormat: 'ddd MMM DD',
    agendaTimeFormat: 'LT',
    agendaTimeRangeFormat: $a4fe492ece4426a3$var$timeRangeFormat$4
};
function $a4fe492ece4426a3$var$fixUnit$1(unit) {
    var datePart = unit ? unit.toLowerCase() : unit;
    if (datePart === 'FullYear') datePart = 'year';
    else if (!datePart) datePart = undefined;
    return datePart;
}
function $a4fe492ece4426a3$export$29814e003152ab50(moment) {
    var locale = function locale(m, c) {
        return c ? m.locale(c) : m;
    };
    function getTimezoneOffset(date) {
        // ensures this gets cast to timezone
        return moment(date).toDate().getTimezoneOffset();
    }
    function getDstOffset(start, end) {
        var _st$_z$name, _st$_z;
        // convert to moment, in case
        var st = moment(start);
        var ed = moment(end); // if not using moment timezone
        if (!moment.tz) return st.toDate().getTimezoneOffset() - ed.toDate().getTimezoneOffset();
        /**
     * If using moment-timezone, and a timezone has been applied, then
     * use this to get the proper timezone offset, otherwise default
     * the timezone to the browser local
     */ var tzName = (_st$_z$name = st === null || st === void 0 ? void 0 : (_st$_z = st._z) === null || _st$_z === void 0 ? void 0 : _st$_z.name) !== null && _st$_z$name !== void 0 ? _st$_z$name : moment.tz.guess();
        var startOffset = moment.tz.zone(tzName).utcOffset(+st);
        var endOffset = moment.tz.zone(tzName).utcOffset(+ed);
        return startOffset - endOffset;
    }
    function getDayStartDstOffset(start) {
        var dayStart = moment(start).startOf('day');
        return getDstOffset(dayStart, start);
    }
    /*** BEGIN localized date arithmetic methods with moment ***/ function defineComparators(a, b, unit) {
        var datePart = $a4fe492ece4426a3$var$fixUnit$1(unit);
        var dtA = datePart ? moment(a).startOf(datePart) : moment(a);
        var dtB = datePart ? moment(b).startOf(datePart) : moment(b);
        return [
            dtA,
            dtB,
            datePart
        ];
    }
    function startOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $a4fe492ece4426a3$var$fixUnit$1(unit);
        if (datePart) return moment(date).startOf(datePart).toDate();
        return moment(date).toDate();
    }
    function endOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $a4fe492ece4426a3$var$fixUnit$1(unit);
        if (datePart) return moment(date).endOf(datePart).toDate();
        return moment(date).toDate();
    } // moment comparison operations *always* convert both sides to moment objects
    // prior to running the comparisons
    function eq(a, b, unit) {
        var _defineComparators = defineComparators(a, b, unit), _defineComparators2 = (0, $951471461146a3e9$export$2e2bcd8739ae039)(_defineComparators, 3), dtA = _defineComparators2[0], dtB = _defineComparators2[1], datePart = _defineComparators2[2];
        return dtA.isSame(dtB, datePart);
    }
    function neq(a, b, unit) {
        return !eq(a, b, unit);
    }
    function gt(a, b, unit) {
        var _defineComparators3 = defineComparators(a, b, unit), _defineComparators4 = (0, $951471461146a3e9$export$2e2bcd8739ae039)(_defineComparators3, 3), dtA = _defineComparators4[0], dtB = _defineComparators4[1], datePart = _defineComparators4[2];
        return dtA.isAfter(dtB, datePart);
    }
    function lt(a, b, unit) {
        var _defineComparators5 = defineComparators(a, b, unit), _defineComparators6 = (0, $951471461146a3e9$export$2e2bcd8739ae039)(_defineComparators5, 3), dtA = _defineComparators6[0], dtB = _defineComparators6[1], datePart = _defineComparators6[2];
        return dtA.isBefore(dtB, datePart);
    }
    function gte(a, b, unit) {
        var _defineComparators7 = defineComparators(a, b, unit), _defineComparators8 = (0, $951471461146a3e9$export$2e2bcd8739ae039)(_defineComparators7, 3), dtA = _defineComparators8[0], dtB = _defineComparators8[1], datePart = _defineComparators8[2];
        return dtA.isSameOrBefore(dtB, datePart);
    }
    function lte(a, b, unit) {
        var _defineComparators9 = defineComparators(a, b, unit), _defineComparators10 = (0, $951471461146a3e9$export$2e2bcd8739ae039)(_defineComparators9, 3), dtA = _defineComparators10[0], dtB = _defineComparators10[1], datePart = _defineComparators10[2];
        return dtA.isSameOrBefore(dtB, datePart);
    }
    function inRange(day, min, max) {
        var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'day';
        var datePart = $a4fe492ece4426a3$var$fixUnit$1(unit);
        var mDay = moment(day);
        var mMin = moment(min);
        var mMax = moment(max);
        return mDay.isBetween(mMin, mMax, datePart, '[]');
    }
    function min(dateA, dateB) {
        var dtA = moment(dateA);
        var dtB = moment(dateB);
        var minDt = moment.min(dtA, dtB);
        return minDt.toDate();
    }
    function max(dateA, dateB) {
        var dtA = moment(dateA);
        var dtB = moment(dateB);
        var maxDt = moment.max(dtA, dtB);
        return maxDt.toDate();
    }
    function merge(date, time) {
        if (!date && !time) return null;
        var tm = moment(time).format('HH:mm:ss');
        var dt = moment(date).startOf('day').format('MM/DD/YYYY'); // We do it this way to avoid issues when timezone switching
        return moment("".concat(dt, " ").concat(tm), 'MM/DD/YYYY HH:mm:ss').toDate();
    }
    function add(date, adder, unit) {
        var datePart = $a4fe492ece4426a3$var$fixUnit$1(unit);
        return moment(date).add(adder, datePart).toDate();
    }
    function range(start, end) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $a4fe492ece4426a3$var$fixUnit$1(unit); // because the add method will put these in tz, we have to start that way
        var current = moment(start).toDate();
        var days = [];
        while(lte(current, end)){
            days.push(current);
            current = add(current, 1, datePart);
        }
        return days;
    }
    function ceil(date, unit) {
        var datePart = $a4fe492ece4426a3$var$fixUnit$1(unit);
        var floor = startOf(date, datePart);
        return eq(floor, date) ? floor : add(floor, 1, datePart);
    }
    function diff(a, b) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $a4fe492ece4426a3$var$fixUnit$1(unit); // don't use 'defineComparators' here, as we don't want to mutate the values
        var dtA = moment(a);
        var dtB = moment(b);
        return dtB.diff(dtA, datePart);
    }
    function minutes(date) {
        var dt = moment(date);
        return dt.minutes();
    }
    function firstOfWeek(culture) {
        var data = culture ? moment.localeData(culture) : moment.localeData();
        return data ? data.firstDayOfWeek() : 0;
    }
    function firstVisibleDay(date) {
        return moment(date).startOf('month').startOf('week').toDate();
    }
    function lastVisibleDay(date) {
        return moment(date).endOf('month').endOf('week').toDate();
    }
    function visibleDays(date) {
        var current = firstVisibleDay(date);
        var last = lastVisibleDay(date);
        var days = [];
        while(lte(current, last)){
            days.push(current);
            current = add(current, 1, 'd');
        }
        return days;
    }
    /*** END localized date arithmetic methods with moment ***/ /**
   * Moved from TimeSlots.js, this method overrides the method of the same name
   * in the localizer.js, using moment to construct the js Date
   * @param {Date} dt - date to start with
   * @param {Number} minutesFromMidnight
   * @param {Number} offset
   * @returns {Date}
   */ function getSlotDate(dt, minutesFromMidnight, offset) {
        return moment(dt).startOf('day').minute(minutesFromMidnight + offset).toDate();
    } // moment will automatically handle DST differences in it's calculations
    function getTotalMin(start, end) {
        return diff(start, end, 'minutes');
    }
    function getMinutesFromMidnight(start) {
        var dayStart = moment(start).startOf('day');
        var day = moment(start);
        return day.diff(dayStart, 'minutes') + getDayStartDstOffset(start);
    } // These two are used by DateSlotMetrics
    function continuesPrior(start, first) {
        var mStart = moment(start);
        var mFirst = moment(first);
        return mStart.isBefore(mFirst, 'day');
    }
    function continuesAfter(start, end, last) {
        var mEnd = moment(end);
        var mLast = moment(last);
        return mEnd.isSameOrAfter(mLast, 'minutes');
    } // These two are used by eventLevels
    function sortEvents(_ref6) {
        var _ref6$evtA = _ref6.evtA, aStart = _ref6$evtA.start, aEnd = _ref6$evtA.end, aAllDay = _ref6$evtA.allDay, _ref6$evtB = _ref6.evtB, bStart = _ref6$evtB.start, bEnd = _ref6$evtB.end, bAllDay = _ref6$evtB.allDay;
        var startSort = +startOf(aStart, 'day') - +startOf(bStart, 'day');
        var durA = diff(aStart, ceil(aEnd, 'day'), 'day');
        var durB = diff(bStart, ceil(bEnd, 'day'), 'day');
        return startSort || // sort by start Day first
        Math.max(durB, 1) - Math.max(durA, 1) || // events spanning multiple days go first
        !!bAllDay - !!aAllDay || // then allDay single day events
        +aStart - +bStart || // then sort by start time *don't need moment conversion here
        +aEnd - +bEnd // then sort by end time *don't need moment conversion here either
        ;
    }
    function inEventRange(_ref7) {
        var _ref7$event = _ref7.event, start = _ref7$event.start, end = _ref7$event.end, _ref7$range = _ref7.range, rangeStart = _ref7$range.start, rangeEnd = _ref7$range.end;
        var startOfDay = moment(start).startOf('day');
        var eEnd = moment(end);
        var rStart = moment(rangeStart);
        var rEnd = moment(rangeEnd);
        var startsBeforeEnd = startOfDay.isSameOrBefore(rEnd, 'day'); // when the event is zero duration we need to handle a bit differently
        var sameMin = !startOfDay.isSame(eEnd, 'minutes');
        var endsAfterStart = sameMin ? eEnd.isAfter(rStart, 'minutes') : eEnd.isSameOrAfter(rStart, 'minutes');
        return startsBeforeEnd && endsAfterStart;
    } // moment treats 'day' and 'date' equality very different
    // moment(date1).isSame(date2, 'day') would test that they were both the same day of the week
    // moment(date1).isSame(date2, 'date') would test that they were both the same date of the month of the year
    function isSameDate(date1, date2) {
        var dt = moment(date1);
        var dt2 = moment(date2);
        return dt.isSame(dt2, 'date');
    }
    /**
   * This method, called once in the localizer constructor, is used by eventLevels
   * 'eventSegments()' to assist in determining the 'span' of the event in the display,
   * specifically when using a timezone that is greater than the browser native timezone.
   * @returns number
   */ function browserTZOffset() {
        /**
     * Date.prototype.getTimezoneOffset horrifically flips the positive/negative from
     * what you see in it's string, so we have to jump through some hoops to get a value
     * we can actually compare.
     */ var dt = new Date();
        var neg = /-/.test(dt.toString()) ? '-' : '';
        var dtOffset = dt.getTimezoneOffset();
        var comparator = Number("".concat(neg).concat(Math.abs(dtOffset))); // moment correctly provides positive/negative offset, as expected
        var mtOffset = moment().utcOffset();
        return mtOffset > comparator ? 1 : 0;
    }
    return new $a4fe492ece4426a3$export$193ddab16544ff5b({
        formats: $a4fe492ece4426a3$var$formats$4,
        firstOfWeek: firstOfWeek,
        firstVisibleDay: firstVisibleDay,
        lastVisibleDay: lastVisibleDay,
        visibleDays: visibleDays,
        format: function format(value, _format, culture) {
            return locale(moment(value), culture).format(_format);
        },
        lt: lt,
        lte: lte,
        gt: gt,
        gte: gte,
        eq: eq,
        neq: neq,
        merge: merge,
        inRange: inRange,
        startOf: startOf,
        endOf: endOf,
        range: range,
        add: add,
        diff: diff,
        ceil: ceil,
        min: min,
        max: max,
        minutes: minutes,
        getSlotDate: getSlotDate,
        getTimezoneOffset: getTimezoneOffset,
        getDstOffset: getDstOffset,
        getTotalMin: getTotalMin,
        getMinutesFromMidnight: getMinutesFromMidnight,
        continuesPrior: continuesPrior,
        continuesAfter: continuesAfter,
        sortEvents: sortEvents,
        inEventRange: inEventRange,
        isSameDate: isSameDate,
        browserTZOffset: browserTZOffset
    });
}
function $a4fe492ece4426a3$var$pluralizeUnit(unit) {
    return /s$/.test(unit) ? unit : unit + 's';
}
var $a4fe492ece4426a3$var$weekRangeFormat$3 = function weekRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, 'MMMM dd', culture) + " \u2013 " + // updated to use this localizer 'eq()' method
    local.format(end, local.eq(start, end, 'month') ? 'dd' : 'MMMM dd', culture);
};
var $a4fe492ece4426a3$var$dateRangeFormat$3 = function dateRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, 'D', culture) + " \u2013 " + local.format(end, 'D', culture);
};
var $a4fe492ece4426a3$var$timeRangeFormat$3 = function timeRangeFormat(_ref3, culture, local) {
    var start = _ref3.start, end = _ref3.end;
    return local.format(start, 't', culture) + " \u2013 " + local.format(end, 't', culture);
};
var $a4fe492ece4426a3$var$timeRangeStartFormat$3 = function timeRangeStartFormat(_ref4, culture, local) {
    var start = _ref4.start;
    return local.format(start, 't', culture) + " \u2013 ";
};
var $a4fe492ece4426a3$var$timeRangeEndFormat$3 = function timeRangeEndFormat(_ref5, culture, local) {
    var end = _ref5.end;
    return " \u2013 " + local.format(end, 't', culture);
};
var $a4fe492ece4426a3$var$formats$3 = {
    dateFormat: 'dd',
    dayFormat: 'dd EEE',
    weekdayFormat: 'EEE',
    selectRangeFormat: $a4fe492ece4426a3$var$timeRangeFormat$3,
    eventTimeRangeFormat: $a4fe492ece4426a3$var$timeRangeFormat$3,
    eventTimeRangeStartFormat: $a4fe492ece4426a3$var$timeRangeStartFormat$3,
    eventTimeRangeEndFormat: $a4fe492ece4426a3$var$timeRangeEndFormat$3,
    timeGutterFormat: 't',
    monthHeaderFormat: 'MMMM yyyy',
    dayHeaderFormat: 'EEEE MMM dd',
    dayRangeHeaderFormat: $a4fe492ece4426a3$var$weekRangeFormat$3,
    agendaHeaderFormat: $a4fe492ece4426a3$var$dateRangeFormat$3,
    agendaDateFormat: 'EEE MMM dd',
    agendaTimeFormat: 't',
    agendaTimeRangeFormat: $a4fe492ece4426a3$var$timeRangeFormat$3
};
function $a4fe492ece4426a3$var$fixUnit(unit) {
    var datePart = unit ? $a4fe492ece4426a3$var$pluralizeUnit(unit.toLowerCase()) : unit;
    if (datePart === 'FullYear') datePart = 'year';
    else if (!datePart) datePart = undefined;
    return datePart;
} // Luxon does not currently have weekInfo by culture
// Luxon uses 1 based values for month and weekday
// So we default to Sunday (7)
function $a4fe492ece4426a3$export$d65cc979272e65c7(DateTime) {
    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref6$firstDayOfWeek = _ref6.firstDayOfWeek, firstDayOfWeek = _ref6$firstDayOfWeek === void 0 ? 7 : _ref6$firstDayOfWeek;
    function formatDate(value, format) {
        return DateTime.fromJSDate(value).toFormat(format);
    }
    function formatDateWithCulture(value, culture, format) {
        return DateTime.fromJSDate(value).setLocale(culture).toFormat(format);
    }
    /*** BEGIN localized date arithmetic methods with Luxon ***/ function defineComparators(a, b, unit) {
        var datePart = $a4fe492ece4426a3$var$fixUnit(unit);
        var dtA = datePart ? DateTime.fromJSDate(a).startOf(datePart) : DateTime.fromJSDate(a);
        var dtB = datePart ? DateTime.fromJSDate(b).startOf(datePart) : DateTime.fromJSDate(b);
        return [
            dtA,
            dtB,
            datePart
        ];
    } // Since Luxon (and current Intl API) has no support
    // for culture based weekInfo, we need to handle
    // the start of the week differently
    // depending on locale, the firstDayOfWeek could also be Saturday, Sunday or Monday
    function startOfDTWeek(dtObj) {
        var weekday = dtObj.weekday;
        if (weekday === firstDayOfWeek) return dtObj.startOf('day'); // already beginning of week
        else if (firstDayOfWeek === 1) return dtObj.startOf('week'); // fow is Monday, which is Luxon default
        var diff = firstDayOfWeek === 7 ? weekday : weekday + (7 - firstDayOfWeek);
        return dtObj.minus({
            day: diff
        }).startOf('day');
    }
    function endOfDTWeek(dtObj) {
        var weekday = dtObj.weekday;
        var eow = firstDayOfWeek === 1 ? 7 : firstDayOfWeek - 1;
        if (weekday === eow) return dtObj.endOf('day'); // already last day of the week
        else if (firstDayOfWeek === 1) return dtObj.endOf('week'); // use Luxon default (Sunday)
        var fromDate = firstDayOfWeek > eow ? dtObj.plus({
            day: firstDayOfWeek - eow
        }) : dtObj;
        return fromDate.set({
            weekday: eow
        }).endOf('day');
    } // This returns a DateTime instance
    function startOfDT() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $a4fe492ece4426a3$var$fixUnit(unit);
        if (datePart) {
            var dt = DateTime.fromJSDate(date);
            return datePart.includes('week') ? startOfDTWeek(dt) : dt.startOf(datePart);
        }
        return DateTime.fromJSDate(date);
    }
    function firstOfWeek() {
        return firstDayOfWeek;
    } // This returns a JS Date from a DateTime instance
    function startOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        return startOfDT(date, unit).toJSDate();
    } // This returns a DateTime instance
    function endOfDT() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        var datePart = $a4fe492ece4426a3$var$fixUnit(unit);
        if (datePart) {
            var dt = DateTime.fromJSDate(date);
            return datePart.includes('week') ? endOfDTWeek(dt) : dt.endOf(datePart);
        }
        return DateTime.fromJSDate(date);
    }
    function endOf() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var unit = arguments.length > 1 ? arguments[1] : undefined;
        return endOfDT(date, unit).toJSDate();
    }
    function eq(a, b, unit) {
        var _defineComparators = defineComparators(a, b, unit), _defineComparators2 = (0, $951471461146a3e9$export$2e2bcd8739ae039)(_defineComparators, 2), dtA = _defineComparators2[0], dtB = _defineComparators2[1];
        return +dtA == +dtB;
    }
    function neq(a, b, unit) {
        return !eq(a, b, unit);
    }
    function gt(a, b, unit) {
        var _defineComparators3 = defineComparators(a, b, unit), _defineComparators4 = (0, $951471461146a3e9$export$2e2bcd8739ae039)(_defineComparators3, 2), dtA = _defineComparators4[0], dtB = _defineComparators4[1];
        return +dtA > +dtB;
    }
    function lt(a, b, unit) {
        var _defineComparators5 = defineComparators(a, b, unit), _defineComparators6 = (0, $951471461146a3e9$export$2e2bcd8739ae039)(_defineComparators5, 2), dtA = _defineComparators6[0], dtB = _defineComparators6[1];
        return +dtA < +dtB;
    }
    function gte(a, b, unit) {
        var _defineComparators7 = defineComparators(a, b, unit), _defineComparators8 = (0, $951471461146a3e9$export$2e2bcd8739ae039)(_defineComparators7, 2), dtA = _defineComparators8[0], dtB = _defineComparators8[1];
        return +dtA >= +dtB;
    }
    function lte(a, b, unit) {
        var _defineComparators9 = defineComparators(a, b, unit), _defineComparators10 = (0, $951471461146a3e9$export$2e2bcd8739ae039)(_defineComparators9, 2), dtA = _defineComparators10[0], dtB = _defineComparators10[1];
        return +dtA <= +dtB;
    }
    function inRange(day, min, max) {
        var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'day';
        var datePart = $a4fe492ece4426a3$var$fixUnit(unit);
        var mDay = startOfDT(day, datePart);
        var mMin = startOfDT(min, datePart);
        var mMax = startOfDT(max, datePart);
        return +mDay >= +mMin && +mDay <= +mMax;
    }
    function min(dateA, dateB) {
        var dtA = DateTime.fromJSDate(dateA);
        var dtB = DateTime.fromJSDate(dateB);
        var minDt = DateTime.min(dtA, dtB);
        return minDt.toJSDate();
    }
    function max(dateA, dateB) {
        var dtA = DateTime.fromJSDate(dateA);
        var dtB = DateTime.fromJSDate(dateB);
        var maxDt = DateTime.max(dtA, dtB);
        return maxDt.toJSDate();
    }
    function merge(date, time) {
        if (!date && !time) return null;
        var tm = DateTime.fromJSDate(time);
        var dt = startOfDT(date, 'day');
        return dt.set({
            hour: tm.hour,
            minute: tm.minute,
            second: tm.second,
            millisecond: tm.millisecond
        }).toJSDate();
    }
    function add(date, adder, unit) {
        var datePart = $a4fe492ece4426a3$var$fixUnit(unit);
        return DateTime.fromJSDate(date).plus((0, $5fApW.default)({}, datePart, adder)).toJSDate();
    }
    function range(start, end) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $a4fe492ece4426a3$var$fixUnit(unit);
        var current = DateTime.fromJSDate(start).toJSDate(); // this is to get it to tz
        var days = [];
        while(lte(current, end)){
            days.push(current);
            current = add(current, 1, datePart);
        }
        return days;
    }
    function ceil(date, unit) {
        var datePart = $a4fe492ece4426a3$var$fixUnit(unit);
        var floor = startOf(date, datePart);
        return eq(floor, date) ? floor : add(floor, 1, datePart);
    }
    function diff(a, b) {
        var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';
        var datePart = $a4fe492ece4426a3$var$fixUnit(unit); // don't use 'defineComparators' here, as we don't want to mutate the values
        var dtA = DateTime.fromJSDate(a);
        var dtB = DateTime.fromJSDate(b);
        return Math.round(dtB.diff(dtA, datePart, {
            conversionAccuracy: 'longterm'
        }).toObject()[datePart]);
    }
    function firstVisibleDay(date) {
        var startOfMonth = startOfDT(date, 'month');
        return startOfDTWeek(startOfMonth).toJSDate();
    }
    function lastVisibleDay(date) {
        var endOfMonth = endOfDT(date, 'month');
        return endOfDTWeek(endOfMonth).toJSDate();
    }
    function visibleDays(date) {
        var current = firstVisibleDay(date);
        var last = lastVisibleDay(date);
        var days = [];
        while(lte(current, last)){
            days.push(current);
            current = add(current, 1, 'day');
        }
        return days;
    }
    /*** END localized date arithmetic methods with moment ***/ /**
   * Moved from TimeSlots.js, this method overrides the method of the same name
   * in the localizer.js, using moment to construct the js Date
   * @param {Date} dt - date to start with
   * @param {Number} minutesFromMidnight
   * @param {Number} offset
   * @returns {Date}
   */ function getSlotDate(dt, minutesFromMidnight, offset) {
        return startOfDT(dt, 'day').set({
            minutes: minutesFromMidnight + offset
        }).toJSDate();
    } // Luxon will automatically handle DST differences in it's calculations
    function getTotalMin(start, end) {
        return diff(start, end, 'minutes');
    }
    function getMinutesFromMidnight(start) {
        var dayStart = startOfDT(start, 'day');
        var day = DateTime.fromJSDate(start);
        return Math.round(day.diff(dayStart, 'minutes', {
            conversionAccuracy: 'longterm'
        }).toObject().minutes);
    } // These two are used by DateSlotMetrics
    function continuesPrior(start, first) {
        return lt(start, first);
    }
    function continuesAfter(start, end, last) {
        return gte(end, last);
    } // These two are used by eventLevels
    function sortEvents(_ref7) {
        var _ref7$evtA = _ref7.evtA, aStart = _ref7$evtA.start, aEnd = _ref7$evtA.end, aAllDay = _ref7$evtA.allDay, _ref7$evtB = _ref7.evtB, bStart = _ref7$evtB.start, bEnd = _ref7$evtB.end, bAllDay = _ref7$evtB.allDay;
        var startSort = +startOf(aStart, 'day') - +startOf(bStart, 'day');
        var durA = diff(aStart, ceil(aEnd, 'day'), 'day');
        var durB = diff(bStart, ceil(bEnd, 'day'), 'day');
        return startSort || // sort by start Day first
        Math.max(durB, 1) - Math.max(durA, 1) || // events spanning multiple days go first
        !!bAllDay - !!aAllDay || // then allDay single day events
        +aStart - +bStart || // then sort by start time *don't need moment conversion here
        +aEnd - +bEnd // then sort by end time *don't need moment conversion here either
        ;
    }
    function inEventRange(_ref8) {
        var _ref8$event = _ref8.event, start = _ref8$event.start, end = _ref8$event.end, _ref8$range = _ref8.range, rangeStart = _ref8$range.start, rangeEnd = _ref8$range.end;
        var eStart = startOf(start, 'day');
        var startsBeforeEnd = lte(eStart, rangeEnd, 'day'); // when the event is zero duration we need to handle a bit differently
        var sameMin = neq(eStart, end, 'minutes');
        var endsAfterStart = sameMin ? gt(end, rangeStart, 'minutes') : gte(end, rangeStart, 'minutes');
        return startsBeforeEnd && endsAfterStart;
    } // moment treats 'day' and 'date' equality very different
    // moment(date1).isSame(date2, 'day') would test that they were both the same day of the week
    // moment(date1).isSame(date2, 'date') would test that they were both the same date of the month of the year
    function isSameDate(date1, date2) {
        var dt = DateTime.fromJSDate(date1);
        var dt2 = DateTime.fromJSDate(date2);
        return dt.hasSame(dt2, 'day');
    }
    /**
   * This method, called once in the localizer constructor, is used by eventLevels
   * 'eventSegments()' to assist in determining the 'span' of the event in the display,
   * specifically when using a timezone that is greater than the browser native timezone.
   * @returns number
   */ function browserTZOffset() {
        /**
     * Date.prototype.getTimezoneOffset horrifically flips the positive/negative from
     * what you see in it's string, so we have to jump through some hoops to get a value
     * we can actually compare.
     */ var dt = new Date();
        var neg = /-/.test(dt.toString()) ? '-' : '';
        var dtOffset = dt.getTimezoneOffset();
        var comparator = Number("".concat(neg).concat(Math.abs(dtOffset))); // moment correctly provides positive/negative offset, as expected
        var mtOffset = DateTime.local().offset;
        return mtOffset > comparator ? 1 : 0;
    }
    return new $a4fe492ece4426a3$export$193ddab16544ff5b({
        format: function format(value, _format, culture) {
            if (culture) return formatDateWithCulture(value, culture, _format);
            return formatDate(value, _format);
        },
        formats: $a4fe492ece4426a3$var$formats$3,
        firstOfWeek: firstOfWeek,
        firstVisibleDay: firstVisibleDay,
        lastVisibleDay: lastVisibleDay,
        visibleDays: visibleDays,
        lt: lt,
        lte: lte,
        gt: gt,
        gte: gte,
        eq: eq,
        neq: neq,
        merge: merge,
        inRange: inRange,
        startOf: startOf,
        endOf: endOf,
        range: range,
        add: add,
        diff: diff,
        ceil: ceil,
        min: min,
        max: max,
        getSlotDate: getSlotDate,
        getTotalMin: getTotalMin,
        getMinutesFromMidnight: getMinutesFromMidnight,
        continuesPrior: continuesPrior,
        continuesAfter: continuesAfter,
        sortEvents: sortEvents,
        inEventRange: inEventRange,
        isSameDate: isSameDate,
        browserTZOffset: browserTZOffset
    });
}
var $a4fe492ece4426a3$var$dateRangeFormat$2 = function dateRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, 'd', culture) + " \u2013 " + local.format(end, 'd', culture);
};
var $a4fe492ece4426a3$var$timeRangeFormat$2 = function timeRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, 't', culture) + " \u2013 " + local.format(end, 't', culture);
};
var $a4fe492ece4426a3$var$timeRangeStartFormat$2 = function timeRangeStartFormat(_ref3, culture, local) {
    var start = _ref3.start;
    return local.format(start, 't', culture) + " \u2013 ";
};
var $a4fe492ece4426a3$var$timeRangeEndFormat$2 = function timeRangeEndFormat(_ref4, culture, local) {
    var end = _ref4.end;
    return " \u2013 " + local.format(end, 't', culture);
};
var $a4fe492ece4426a3$var$weekRangeFormat$2 = function weekRangeFormat(_ref5, culture, local) {
    var start = _ref5.start, end = _ref5.end;
    return local.format(start, 'MMM dd', culture) + " \u2013 " + local.format(end, (0, $7cdbb81bd69b4527$export$9663ddc1cf085b32)(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};
var $a4fe492ece4426a3$var$formats$2 = {
    dateFormat: 'dd',
    dayFormat: 'ddd dd/MM',
    weekdayFormat: 'ddd',
    selectRangeFormat: $a4fe492ece4426a3$var$timeRangeFormat$2,
    eventTimeRangeFormat: $a4fe492ece4426a3$var$timeRangeFormat$2,
    eventTimeRangeStartFormat: $a4fe492ece4426a3$var$timeRangeStartFormat$2,
    eventTimeRangeEndFormat: $a4fe492ece4426a3$var$timeRangeEndFormat$2,
    timeGutterFormat: 't',
    monthHeaderFormat: 'Y',
    dayHeaderFormat: 'dddd MMM dd',
    dayRangeHeaderFormat: $a4fe492ece4426a3$var$weekRangeFormat$2,
    agendaHeaderFormat: $a4fe492ece4426a3$var$dateRangeFormat$2,
    agendaDateFormat: 'ddd MMM dd',
    agendaTimeFormat: 't',
    agendaTimeRangeFormat: $a4fe492ece4426a3$var$timeRangeFormat$2
};
function $a4fe492ece4426a3$var$oldGlobalize(globalize) {
    function getCulture(culture) {
        return culture ? globalize.findClosestCulture(culture) : globalize.culture();
    }
    function firstOfWeek(culture) {
        culture = getCulture(culture);
        return culture && culture.calendar.firstDay || 0;
    }
    return new $a4fe492ece4426a3$export$193ddab16544ff5b({
        firstOfWeek: firstOfWeek,
        formats: $a4fe492ece4426a3$var$formats$2,
        format: function format(value, _format, culture) {
            return globalize.format(value, _format, culture);
        }
    });
}
var $a4fe492ece4426a3$var$dateRangeFormat$1 = function dateRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return local.format(start, {
        date: 'short'
    }, culture) + " \u2013 " + local.format(end, {
        date: 'short'
    }, culture);
};
var $a4fe492ece4426a3$var$timeRangeFormat$1 = function timeRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return local.format(start, {
        time: 'short'
    }, culture) + " \u2013 " + local.format(end, {
        time: 'short'
    }, culture);
};
var $a4fe492ece4426a3$var$timeRangeStartFormat$1 = function timeRangeStartFormat(_ref3, culture, local) {
    var start = _ref3.start;
    return local.format(start, {
        time: 'short'
    }, culture) + " \u2013 ";
};
var $a4fe492ece4426a3$var$timeRangeEndFormat$1 = function timeRangeEndFormat(_ref4, culture, local) {
    var end = _ref4.end;
    return " \u2013 " + local.format(end, {
        time: 'short'
    }, culture);
};
var $a4fe492ece4426a3$var$weekRangeFormat$1 = function weekRangeFormat(_ref5, culture, local) {
    var start = _ref5.start, end = _ref5.end;
    return local.format(start, 'MMM dd', culture) + " \u2013 " + local.format(end, (0, $7cdbb81bd69b4527$export$9663ddc1cf085b32)(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};
var $a4fe492ece4426a3$var$formats$1 = {
    dateFormat: 'dd',
    dayFormat: 'eee dd/MM',
    weekdayFormat: 'eee',
    selectRangeFormat: $a4fe492ece4426a3$var$timeRangeFormat$1,
    eventTimeRangeFormat: $a4fe492ece4426a3$var$timeRangeFormat$1,
    eventTimeRangeStartFormat: $a4fe492ece4426a3$var$timeRangeStartFormat$1,
    eventTimeRangeEndFormat: $a4fe492ece4426a3$var$timeRangeEndFormat$1,
    timeGutterFormat: {
        time: 'short'
    },
    monthHeaderFormat: 'MMMM yyyy',
    dayHeaderFormat: 'eeee MMM dd',
    dayRangeHeaderFormat: $a4fe492ece4426a3$var$weekRangeFormat$1,
    agendaHeaderFormat: $a4fe492ece4426a3$var$dateRangeFormat$1,
    agendaDateFormat: 'eee MMM dd',
    agendaTimeFormat: {
        time: 'short'
    },
    agendaTimeRangeFormat: $a4fe492ece4426a3$var$timeRangeFormat$1
};
function $a4fe492ece4426a3$export$d670461b50de9b9d(globalize) {
    var locale = function locale(culture) {
        return culture ? globalize(culture) : globalize;
    }; // return the first day of the week from the locale data. Defaults to 'world'
    // territory if no territory is derivable from CLDR.
    // Failing to use CLDR supplemental (not loaded?), revert to the original
    // method of getting first day of week.
    function firstOfWeek(culture) {
        try {
            var days = [
                'sun',
                'mon',
                'tue',
                'wed',
                'thu',
                'fri',
                'sat'
            ];
            var cldr = locale(culture).cldr;
            var territory = cldr.attributes.territory;
            var weekData = cldr.get('supplemental').weekData;
            var firstDay = weekData.firstDay[territory || '001'];
            return days.indexOf(firstDay);
        } catch (e) {
            var date = new Date(); //cldr-data doesn't seem to be zero based
            var localeDay = Math.max(parseInt(locale(culture).formatDate(date, {
                raw: 'e'
            }), 10) - 1, 0);
            return Math.abs(date.getDay() - localeDay);
        }
    }
    if (!globalize.load) return $a4fe492ece4426a3$var$oldGlobalize(globalize);
    return new $a4fe492ece4426a3$export$193ddab16544ff5b({
        firstOfWeek: firstOfWeek,
        formats: $a4fe492ece4426a3$var$formats$1,
        format: function format(value, _format, culture) {
            _format = typeof _format === 'string' ? {
                raw: _format
            } : _format;
            return locale(culture).formatDate(value, _format);
        }
    });
}
var $a4fe492ece4426a3$var$dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
    var start = _ref.start, end = _ref.end;
    return "".concat(local.format(start, 'P', culture), " \u2013 ").concat(local.format(end, 'P', culture));
};
var $a4fe492ece4426a3$var$timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
    var start = _ref2.start, end = _ref2.end;
    return "".concat(local.format(start, 'p', culture), " \u2013 ").concat(local.format(end, 'p', culture));
};
var $a4fe492ece4426a3$var$timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
    var start = _ref3.start;
    return "".concat(local.format(start, 'h:mma', culture), " \u2013 ");
};
var $a4fe492ece4426a3$var$timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
    var end = _ref4.end;
    return " \u2013 ".concat(local.format(end, 'h:mma', culture));
};
var $a4fe492ece4426a3$var$weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
    var start = _ref5.start, end = _ref5.end;
    return "".concat(local.format(start, 'MMMM dd', culture), " \u2013 ").concat(local.format(end, (0, $7cdbb81bd69b4527$export$9663ddc1cf085b32)(start, end, 'month') ? 'dd' : 'MMMM dd', culture));
};
var $a4fe492ece4426a3$var$formats = {
    dateFormat: 'dd',
    dayFormat: 'dd eee',
    weekdayFormat: 'cccc',
    selectRangeFormat: $a4fe492ece4426a3$var$timeRangeFormat,
    eventTimeRangeFormat: $a4fe492ece4426a3$var$timeRangeFormat,
    eventTimeRangeStartFormat: $a4fe492ece4426a3$var$timeRangeStartFormat,
    eventTimeRangeEndFormat: $a4fe492ece4426a3$var$timeRangeEndFormat,
    timeGutterFormat: 'p',
    monthHeaderFormat: 'MMMM yyyy',
    dayHeaderFormat: 'cccc MMM dd',
    dayRangeHeaderFormat: $a4fe492ece4426a3$var$weekRangeFormat,
    agendaHeaderFormat: $a4fe492ece4426a3$var$dateRangeFormat,
    agendaDateFormat: 'ccc MMM dd',
    agendaTimeFormat: 'p',
    agendaTimeRangeFormat: $a4fe492ece4426a3$var$timeRangeFormat
};
var $a4fe492ece4426a3$export$3fa2fdf84427788c = function dateFnsLocalizer(_ref6) {
    var startOfWeek = _ref6.startOfWeek, getDay = _ref6.getDay, _format = _ref6.format, locales = _ref6.locales;
    return new $a4fe492ece4426a3$export$193ddab16544ff5b({
        formats: $a4fe492ece4426a3$var$formats,
        firstOfWeek: function firstOfWeek(culture) {
            return getDay(startOfWeek(new Date(), {
                locale: locales[culture]
            }));
        },
        format: function format(value, formatString, culture) {
            return _format(new Date(value), formatString, {
                locale: locales[culture]
            });
        }
    });
};
var $a4fe492ece4426a3$export$9b5ac10f59f76296 = {
    eventWrapper: $a4fe492ece4426a3$var$NoopWrapper,
    timeSlotWrapper: $a4fe492ece4426a3$var$NoopWrapper,
    dateCellWrapper: $a4fe492ece4426a3$var$NoopWrapper
};




var $bb3TF = parcelRequire("bb3TF");

var $6Sgv0 = parcelRequire("6Sgv0");


var $bb3TF = parcelRequire("bb3TF");

var $7fb0891b6eb4265a$export$5b5be35630ee4885;
var $7fb0891b6eb4265a$export$56176ca1b4453b1;
var $7fb0891b6eb4265a$export$c96745152eb2740f;
var $7fb0891b6eb4265a$export$6f093cfa640b7166;
$7fb0891b6eb4265a$export$5b5be35630ee4885 = `hisTzG_divisor`;
$7fb0891b6eb4265a$export$56176ca1b4453b1 = `hisTzG_participant`;
$7fb0891b6eb4265a$export$c96745152eb2740f = `hisTzG_subtitle`;
$7fb0891b6eb4265a$export$6f093cfa640b7166 = `hisTzG_text`;


const $97445a6deb41b902$var$AvailabilityModal = ({ startHour: startHour, endHour: endHour, del: del })=>(0, $bb3TF.jsxs)("div", {
        style: {
            width: '100%'
        },
        children: [
            (0, $bb3TF.jsx)("p", {
                className: $7fb0891b6eb4265a$export$6f093cfa640b7166,
                children: `Start Hour: ${startHour}`
            }),
            (0, $bb3TF.jsx)("p", {
                className: $7fb0891b6eb4265a$export$6f093cfa640b7166,
                children: `End Hour: ${endHour}`
            }),
            (0, $bb3TF.jsx)("div", {
                className: $7fb0891b6eb4265a$export$5b5be35630ee4885
            }),
            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                style: {
                    width: '100%'
                },
                type: "link",
                danger: true,
                onClick: del,
                children: "Delete"
            })
        ]
    });
var $97445a6deb41b902$export$2e2bcd8739ae039 = $97445a6deb41b902$var$AvailabilityModal;


var $c227897f1ecec710$export$34e0f9847d4c02dd;
$c227897f1ecec710$export$34e0f9847d4c02dd = `TztdyW_container`;


const $efe6c7ac550df7bd$var$Availability = ({ event: { day: day, end: end, start: start, bracket: bracket }, color: color, deleteBracket: deleteBracket })=>{
    const capitalize = (string)=>string.charAt(0).toUpperCase() + string.slice(1);
    return (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
        placement: "right",
        title: capitalize(day.toLowerCase()),
        content: (0, $bb3TF.jsx)((0, $97445a6deb41b902$export$2e2bcd8739ae039), {
            startHour: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(start).format('HH:mm'),
            endHour: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(end).format('HH:mm'),
            del: ()=>deleteBracket(day, bracket)
        }),
        children: (0, $bb3TF.jsx)("div", {
            className: $c227897f1ecec710$export$34e0f9847d4c02dd,
            style: {
                backgroundColor: color
            }
        })
    });
};
var $efe6c7ac550df7bd$export$2e2bcd8739ae039 = $efe6c7ac550df7bd$var$Availability;



const $471362df37e7d2c4$var$localizer = (0, $a4fe492ece4426a3$export$29814e003152ab50)((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0))));
const { Text: $471362df37e7d2c4$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $471362df37e7d2c4$var$AvailabilityBrackets = ({ availabilities: availabilities, color: color, deleteBracket: deleteBracket })=>{
    const [currentView, setCurrentView] = (0, $6fFrj.useState)('week');
    const getBrackets = ()=>{
        const brackets = [];
        availabilities.forEach((availaby)=>{
            const date = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().day(availaby.day);
            availaby.EventTypeAvailabilityBracket.forEach((bracket)=>{
                const { startHour: startHour, startMinute: startMinute, endHour: endHour, endMinute: endMinute } = bracket;
                const start = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(date).set({
                    hour: startHour,
                    minute: startMinute
                });
                const end = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(date).set({
                    hour: endHour,
                    minute: endMinute
                });
                brackets.push({
                    start: start.toDate(),
                    end: end.toDate(),
                    day: availaby.day,
                    bracket: bracket
                });
            });
        });
        return brackets;
    };
    return (0, $bb3TF.jsx)("div", {
        className: "brackets-container",
        children: (0, $bb3TF.jsx)((0, $a4fe492ece4426a3$export$e1aef45b828286de), {
            localizer: $471362df37e7d2c4$var$localizer,
            events: getBrackets(),
            defaultView: currentView,
            view: currentView,
            startAccessor: "start",
            endAccessor: "end",
            toolbar: false,
            components: {
                event: ({ event: event })=>(0, $bb3TF.jsx)((0, $efe6c7ac550df7bd$export$2e2bcd8739ae039), {
                        event: event,
                        color: color,
                        deleteBracket: deleteBracket
                    }),
                header: ({ date: date, localizer: l })=>(0, $bb3TF.jsx)($471362df37e7d2c4$var$Text, {
                        children: l.format(date, 'dddd')
                    }),
                timeGutterHeader: ()=>{
                    if (currentView === 'day') return (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                        type: "link",
                        onClick: ()=>setCurrentView('week'),
                        children: "Back"
                    });
                    return null;
                }
            },
            onView: (view)=>setCurrentView(view),
            className: "brackets-container"
        })
    });
};
var $471362df37e7d2c4$export$2e2bcd8739ae039 = $471362df37e7d2c4$var$AvailabilityBrackets;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

var $f9e381edb26c3958$export$16ecf14bad1ea326;
var $f9e381edb26c3958$export$2f5f180525f32d9d;
var $f9e381edb26c3958$export$34e0f9847d4c02dd;
var $f9e381edb26c3958$export$a3bc9b8ed74fc;
var $f9e381edb26c3958$export$f0245a1bd6566a44;
var $f9e381edb26c3958$export$b7e3ae3d7c15e42e;
var $f9e381edb26c3958$export$1237798dc640739a;
var $f9e381edb26c3958$export$a92e4c44d367d0af;
$f9e381edb26c3958$export$16ecf14bad1ea326 = `cix9na_btncancel`;
$f9e381edb26c3958$export$2f5f180525f32d9d = `cix9na_btnok`;
$f9e381edb26c3958$export$34e0f9847d4c02dd = `cix9na_container`;
$f9e381edb26c3958$export$a3bc9b8ed74fc = `cix9na_error`;
$f9e381edb26c3958$export$f0245a1bd6566a44 = `cix9na_errorLabel`;
$f9e381edb26c3958$export$b7e3ae3d7c15e42e = `cix9na_input`;
$f9e381edb26c3958$export$1237798dc640739a = `cix9na_label`;
$f9e381edb26c3958$export$a92e4c44d367d0af = `cix9na_note`;




var $bb3TF = parcelRequire("bb3TF");

const { Option: $e19596a12ff9a33f$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const { success: $e19596a12ff9a33f$var$success, error: $e19596a12ff9a33f$var$error, warning: $e19596a12ff9a33f$var$warning, info: $e19596a12ff9a33f$var$info } = (0, $55c6005cab9be059$export$2e2bcd8739ae039);
const $e19596a12ff9a33f$export$d2312e68e1f5ad00 = (array)=>array.map(({ value: value, label: label })=>(0, $bb3TF.jsx)($e19596a12ff9a33f$var$Option, {
            value: `${value}`,
            children: label
        }, value));
const $e19596a12ff9a33f$export$f69c19e57285b83a = (content, type)=>{
    const style = {
        marginTop: '5vh'
    };
    switch(type){
        case 'success':
            return $e19596a12ff9a33f$var$success({
                content: content,
                style: style
            });
        case 'error':
            return $e19596a12ff9a33f$var$error({
                content: content,
                style: style
            });
        case 'warning':
            return $e19596a12ff9a33f$var$warning({
                content: content,
                style: style
            });
        default:
            return $e19596a12ff9a33f$var$info({
                content: content,
                style: style
            });
    }
};



const { InfoCircleOutlined: $ce65f3c7842d9379$var$InfoCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $ce65f3c7842d9379$var$TimeAvailabilitySettingsModal = ({ visible: visible, handleCancel: handleCancel, duration: duration, addAvailabilities: addAvailabilities })=>{
    const [timesTo, setTimesTo] = (0, $6fFrj.useState)([]);
    const [timesFrom, setTimesFrom] = (0, $6fFrj.useState)([]);
    const [errors, setErrors] = (0, $6fFrj.useState)({
        day: false,
        from: false,
        to: false
    });
    const [bracket, setBracket] = (0, $6fFrj.useState)({
        day: '',
        from: '',
        to: ''
    });
    (0, $6fFrj.useEffect)(()=>{
        if (!visible) setBracket({
            day: '',
            from: '',
            to: ''
        });
    }, [
        visible
    ]);
    const updateBracket = (value, name)=>{
        let toUpdate = {
            [name]: value
        };
        if (name === 'day') setTimesFrom((0, $5bafd68f69b44f55$export$db731c12fd4796f8)(duration));
        else if (name === 'from') {
            const time = value.split(':');
            const momentTime = (0, $5bafd68f69b44f55$export$1428f42a7de81803)(time[0], time[1]);
            setTimesTo((0, $5bafd68f69b44f55$export$db731c12fd4796f8)(duration, momentTime.add(duration, 'm').format('HH:mm')));
            toUpdate = {
                ...toUpdate,
                to: ''
            };
        }
        setBracket({
            ...bracket,
            ...toUpdate
        });
    };
    const handleOk = ()=>{
        const validationErrors = {};
        Object.keys(bracket).forEach((field)=>{
            if (bracket[field].trim() === '') validationErrors[field] = true;
        });
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        addAvailabilities(bracket);
    };
    const { day: day, from: from, to: to } = bracket;
    return (0, $bb3TF.jsxs)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        title: (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
            children: [
                "New Time Availability",
                (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                    title: "Add sections of time, one day at a time or multiple times per day.",
                    children: (0, $bb3TF.jsx)($ce65f3c7842d9379$var$InfoCircleOutlined, {
                        style: {
                            fontSize: 14,
                            position: 'relative',
                            top: '-0.5em',
                            left: '0.5em',
                            cursor: 'pointer'
                        }
                    })
                })
            ]
        }),
        visible: visible,
        onOk: handleOk,
        onCancel: handleCancel,
        okButtonProps: {
            className: $f9e381edb26c3958$export$2f5f180525f32d9d
        },
        cancelButtonProps: {
            className: $f9e381edb26c3958$export$16ecf14bad1ea326
        },
        okText: "Save",
        children: [
            (0, $bb3TF.jsx)("p", {
                className: $f9e381edb26c3958$export$a92e4c44d367d0af,
                children: "All times are set on your timezone based on your computer system time and under Time Availability* on appointment type."
            }),
            (0, $bb3TF.jsxs)("div", {
                className: $f9e381edb26c3958$export$34e0f9847d4c02dd,
                children: [
                    (0, $bb3TF.jsx)("p", {
                        className: $f9e381edb26c3958$export$1237798dc640739a,
                        children: "Day*"
                    }),
                    (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                        className: `${$f9e381edb26c3958$export$b7e3ae3d7c15e42e} ${errors.day && $f9e381edb26c3958$export$a3bc9b8ed74fc}`,
                        placeholder: "Day",
                        onSelect: (value)=>updateBracket(value, 'day'),
                        value: day,
                        children: (0, $e19596a12ff9a33f$export$d2312e68e1f5ad00)((0, $0a85c5a5bac8f0b3$export$3cf5dda4201cc0f2))
                    }),
                    errors.day && (0, $bb3TF.jsx)("p", {
                        className: $f9e381edb26c3958$export$f0245a1bd6566a44,
                        children: "Field needed to continue"
                    }),
                    (0, $bb3TF.jsx)("p", {
                        className: $f9e381edb26c3958$export$1237798dc640739a,
                        children: "Availability start time*"
                    }),
                    (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                        disabled: !day,
                        className: `${$f9e381edb26c3958$export$b7e3ae3d7c15e42e} ${errors.from && $f9e381edb26c3958$export$a3bc9b8ed74fc}`,
                        placeholder: "From",
                        onSelect: (value)=>updateBracket(value, 'from'),
                        value: from,
                        children: (0, $e19596a12ff9a33f$export$d2312e68e1f5ad00)(timesFrom)
                    }),
                    errors.from && (0, $bb3TF.jsx)("p", {
                        className: $f9e381edb26c3958$export$f0245a1bd6566a44,
                        children: "Field needed to continue"
                    }),
                    (0, $bb3TF.jsx)("p", {
                        className: $f9e381edb26c3958$export$1237798dc640739a,
                        children: "Availability end time*"
                    }),
                    (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                        disabled: !day && !from,
                        className: `${$f9e381edb26c3958$export$b7e3ae3d7c15e42e} ${errors.to && $f9e381edb26c3958$export$a3bc9b8ed74fc}`,
                        placeholder: "To",
                        onSelect: (value)=>updateBracket(value, 'to'),
                        value: to,
                        children: (0, $e19596a12ff9a33f$export$d2312e68e1f5ad00)(timesTo)
                    }),
                    errors.to && (0, $bb3TF.jsx)("p", {
                        className: $f9e381edb26c3958$export$f0245a1bd6566a44,
                        children: "Field needed to continue"
                    })
                ]
            })
        ]
    });
};
var $ce65f3c7842d9379$export$2e2bcd8739ae039 = $ce65f3c7842d9379$var$TimeAvailabilitySettingsModal;





var $a5ba8efd754fb20f$export$534219b709288da9;
var $a5ba8efd754fb20f$export$16ecf14bad1ea326;
var $a5ba8efd754fb20f$export$2f5f180525f32d9d;
var $a5ba8efd754fb20f$export$10eb6dc47bf009dc;
var $a5ba8efd754fb20f$export$c63614ccda656f82;
var $a5ba8efd754fb20f$export$34e0f9847d4c02dd;
var $a5ba8efd754fb20f$export$8847b4be2cf2fe60;
var $a5ba8efd754fb20f$export$3941fef8710f843e;
var $a5ba8efd754fb20f$export$51987bb50e1f6752;
var $a5ba8efd754fb20f$export$a3bc9b8ed74fc;
var $a5ba8efd754fb20f$export$fcc987631b73b72;
var $a5ba8efd754fb20f$export$b7e3ae3d7c15e42e;
var $a5ba8efd754fb20f$export$ddaebf4d91638d23;
var $a5ba8efd754fb20f$export$fb184b623420d9be;
$a5ba8efd754fb20f$export$534219b709288da9 = `_5xtFnq_btn`;
$a5ba8efd754fb20f$export$16ecf14bad1ea326 = `_5xtFnq_btncancel`;
$a5ba8efd754fb20f$export$2f5f180525f32d9d = `_5xtFnq_btnok`;
$a5ba8efd754fb20f$export$10eb6dc47bf009dc = `_5xtFnq_cont`;
$a5ba8efd754fb20f$export$c63614ccda656f82 = `_5xtFnq_contTitleTime`;
$a5ba8efd754fb20f$export$34e0f9847d4c02dd = `_5xtFnq_container`;
$a5ba8efd754fb20f$export$8847b4be2cf2fe60 = `_5xtFnq_containerAvailabilities`;
$a5ba8efd754fb20f$export$3941fef8710f843e = `_5xtFnq_continputs`;
$a5ba8efd754fb20f$export$51987bb50e1f6752 = `_5xtFnq_desc`;
$a5ba8efd754fb20f$export$a3bc9b8ed74fc = `_5xtFnq_error`;
$a5ba8efd754fb20f$export$fcc987631b73b72 = `_5xtFnq_error-label`;
$a5ba8efd754fb20f$export$b7e3ae3d7c15e42e = `_5xtFnq_input`;
$a5ba8efd754fb20f$export$ddaebf4d91638d23 = `_5xtFnq_inputTop`;
$a5ba8efd754fb20f$export$fb184b623420d9be = `_5xtFnq_title`;



const { confirm: $d54563dae8dadfb0$var$confirm } = (0, $6db0040c215ed6e9$export$341c47594849c7de);
const { ExclamationCircleOutlined: $d54563dae8dadfb0$var$ExclamationCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $d54563dae8dadfb0$var$EventTypeSettingsMenu = ({ settings: settings, updateSettings: updateSettings, availability: availability, setAvailability: setAvailability })=>{
    const [modal, setModal] = (0, $6fFrj.useState)(false);
    const radioButtons = (0, $6fFrj.useRef)(null);
    const { duration: duration, afterBuffer: afterBuffer, beforeBuffer: beforeBuffer, maxEvents: maxEvents, minNotice: minNotice, color: color } = settings;
    const addAvailabilities = (paramsBrackets)=>{
        const { from: from, to: to, day: day } = paramsBrackets;
        let updateBrackets = null;
        const brackets = (0, $5bafd68f69b44f55$export$35884f1dee4bd16e)(from, to, duration);
        const dayIndex = availability.findIndex((ava)=>ava.day === day);
        const updateAvailability = [
            ...availability
        ];
        if (dayIndex !== -1) {
            const merge = [
                ...updateAvailability[dayIndex].EventTypeAvailabilityBracket,
                ...brackets
            ];
            updateBrackets = merge.filter(({ startHour: startHour, startMinute: startMinute, endHour: endHour, endMinute: endMinute }, index)=>merge.findIndex((bracket)=>bracket.startHour === startHour && bracket.startMinute === startMinute && bracket.endHour === endHour && bracket.endMinute === endMinute) === index);
            updateAvailability.splice(dayIndex, 1);
        }
        updateAvailability.push({
            day: day,
            EventTypeAvailabilityBracket: updateBrackets ? [
                ...updateBrackets
            ] : brackets
        });
        setAvailability([
            ...updateAvailability
        ]);
        setModal(false);
    };
    const deleteBracket = (day, bracket)=>{
        const { startHour: startHour, startMinute: startMinute, endHour: endHour, endMinute: endMinute } = bracket;
        const updateAvailability = [
            ...availability
        ];
        const dayIndex = updateAvailability.findIndex((ava)=>ava.day === day);
        const brackets = [
            ...updateAvailability[dayIndex].EventTypeAvailabilityBracket
        ];
        const filterBrackets = brackets.filter((bra)=>!(bra.startHour === startHour && bra.startMinute === startMinute && bra.endHour === endHour && bra.endMinute === endMinute));
        updateAvailability.splice(dayIndex, 1);
        updateAvailability.push({
            day: day,
            EventTypeAvailabilityBracket: filterBrackets
        });
        setAvailability([
            ...updateAvailability
        ]);
    };
    const showConfirm = ({ target: { name: name, value: value } })=>{
        const valueNum = value === '' ? 0 : parseInt(value, 10);
        if (availability.length > 0) $d54563dae8dadfb0$var$confirm({
            title: 'Changes on the Appointment Duration field may alter or delete time brackets',
            icon: (0, $bb3TF.jsx)($d54563dae8dadfb0$var$ExclamationCircleOutlined, {}),
            content: 'Are you sure you want to change this Appointment Type duration?',
            okButtonProps: {
                className: $a5ba8efd754fb20f$export$2f5f180525f32d9d
            },
            cancelButtonProps: {
                className: $a5ba8efd754fb20f$export$16ecf14bad1ea326
            },
            onOk () {
                setAvailability([]);
                updateSettings(name, valueNum);
            },
            onCancel () {
                setTimeout(()=>{
                    radioButtons?.current?.focus();
                }, 100);
            }
        });
        else updateSettings(name, valueNum);
    };
    const customValue = ()=>{
        switch(duration){
            case 15:
            case 30:
            case 45:
            case 60:
                return '';
            default:
                return duration;
        }
    };
    return (0, $bb3TF.jsxs)("div", {
        className: $a5ba8efd754fb20f$export$34e0f9847d4c02dd,
        children: [
            (0, $bb3TF.jsx)((0, $ce65f3c7842d9379$export$2e2bcd8739ae039), {
                visible: modal,
                duration: duration,
                handleCancel: ()=>setModal(false),
                addAvailabilities: addAvailabilities
            }),
            (0, $bb3TF.jsx)("p", {
                className: $a5ba8efd754fb20f$export$fb184b623420d9be,
                children: "Appointment Duration*"
            }),
            (0, $bb3TF.jsxs)("div", {
                className: $a5ba8efd754fb20f$export$3941fef8710f843e,
                children: [
                    (0, $bb3TF.jsxs)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Group, {
                        name: "duration",
                        value: duration,
                        onChange: showConfirm,
                        className: "grid-struct",
                        children: [
                            (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Button, {
                                value: 15,
                                children: "15 min"
                            }),
                            (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Button, {
                                ref: radioButtons,
                                value: 30,
                                children: "30 min"
                            }),
                            (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Button, {
                                value: 45,
                                children: "45 min"
                            }),
                            (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Button, {
                                value: 60,
                                children: "60 min"
                            })
                        ]
                    }),
                    (0, $bb3TF.jsxs)("div", {
                        className: "custom-input ant-input-wrapper ant-input-group",
                        children: [
                            (0, $bb3TF.jsx)((0, $4d58e046767e1c41$export$2e2bcd8739ae039), {
                                min: 1,
                                max: 160,
                                name: "duration",
                                value: customValue(),
                                placeholder: "Custom",
                                onClick: showConfirm,
                                onChange: (value)=>updateSettings('duration', !value || value === '' ? 0 : value)
                            }),
                            customValue() !== '' && (0, $bb3TF.jsx)("span", {
                                className: "ant-input-group-addon",
                                children: "Min."
                            })
                        ]
                    })
                ]
            }),
            (0, $bb3TF.jsxs)("div", {
                className: $a5ba8efd754fb20f$export$c63614ccda656f82,
                children: [
                    (0, $bb3TF.jsx)("p", {
                        className: $a5ba8efd754fb20f$export$fb184b623420d9be,
                        children: "Time Availability*"
                    }),
                    (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                        title: "Click on the button to add time slots that your clients can book appointments for.",
                        children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            className: $a5ba8efd754fb20f$export$534219b709288da9,
                            type: "link",
                            onClick: ()=>duration > 0 && setModal(true),
                            children: "Add New Time Availability"
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)("div", {
                id: "container",
                className: $a5ba8efd754fb20f$export$8847b4be2cf2fe60,
                children: (0, $bb3TF.jsx)((0, $471362df37e7d2c4$export$2e2bcd8739ae039), {
                    availabilities: availability,
                    deleteBracket: deleteBracket,
                    color: color
                })
            }),
            (0, $bb3TF.jsx)("p", {
                className: $a5ba8efd754fb20f$export$fb184b623420d9be,
                children: "Appointment Max per Day (Optional)"
            }),
            (0, $bb3TF.jsx)("p", {
                className: $a5ba8efd754fb20f$export$51987bb50e1f6752,
                children: "Use this to limit the number of appointments that can be scheduled in a day."
            }),
            (0, $bb3TF.jsx)((0, $4d58e046767e1c41$export$2e2bcd8739ae039), {
                className: $a5ba8efd754fb20f$export$ddaebf4d91638d23,
                min: 1,
                max: 160,
                value: maxEvents,
                onChange: (value)=>updateSettings('maxEvents', value),
                placeholder: "Max number of Appointments"
            }),
            (0, $bb3TF.jsx)("p", {
                className: $a5ba8efd754fb20f$export$fb184b623420d9be,
                children: "Minimum Schedule Notice (Optional)"
            }),
            (0, $bb3TF.jsx)("p", {
                className: $a5ba8efd754fb20f$export$51987bb50e1f6752,
                children: "Use this to prevent last minute appointments."
            }),
            (0, $bb3TF.jsx)((0, $4d58e046767e1c41$export$2e2bcd8739ae039), {
                className: $a5ba8efd754fb20f$export$ddaebf4d91638d23,
                min: 1,
                max: 160,
                value: minNotice,
                onChange: (value)=>updateSettings('minNotice', value),
                placeholder: "Minimum number of Hours Notice for New Appointments"
            }),
            (0, $bb3TF.jsx)("p", {
                className: $a5ba8efd754fb20f$export$fb184b623420d9be,
                children: "Appointment Buffers"
            }),
            (0, $bb3TF.jsx)("p", {
                className: $a5ba8efd754fb20f$export$51987bb50e1f6752,
                children: "Use this to set aside preparation, rest or travel time before or after appointments. For example, if you define a 5 minute buffer before your appointments we will make sure you have 5 minutes of free time before your scheduled appointments."
            }),
            (0, $bb3TF.jsx)("p", {
                className: $a5ba8efd754fb20f$export$fb184b623420d9be,
                children: "Buffer Before Appointment (Optional)"
            }),
            (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                allowClear: true,
                className: $a5ba8efd754fb20f$export$b7e3ae3d7c15e42e,
                placeholder: "Time",
                value: beforeBuffer,
                onChange: (value)=>updateSettings('beforeBuffer', value),
                children: (0, $e19596a12ff9a33f$export$d2312e68e1f5ad00)((0, $0a85c5a5bac8f0b3$export$b5bc26e198ce73d0))
            }),
            (0, $bb3TF.jsx)("p", {
                className: $a5ba8efd754fb20f$export$fb184b623420d9be,
                children: "Buffer After Appointment (Optional)"
            }),
            (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                allowClear: true,
                className: $a5ba8efd754fb20f$export$b7e3ae3d7c15e42e,
                placeholder: "Time",
                value: afterBuffer,
                onChange: (value)=>updateSettings('afterBuffer', value),
                children: (0, $e19596a12ff9a33f$export$d2312e68e1f5ad00)((0, $0a85c5a5bac8f0b3$export$b5bc26e198ce73d0))
            })
        ]
    });
};
var $d54563dae8dadfb0$export$2e2bcd8739ae039 = $d54563dae8dadfb0$var$EventTypeSettingsMenu;



const { Title: $81a897fdbb4aaae0$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { InfoCircleOutlined: $81a897fdbb4aaae0$var$InfoCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $81a897fdbb4aaae0$var$EventTypeSettings = ({ eventType: eventType, visible: visible, handleCancel: handleCancel, handleSave: handleSave, isLoading: isLoading })=>{
    const [settings, setSettings] = (0, $6fFrj.useState)({
        ...(0, $0a85c5a5bac8f0b3$export$a5a6e0b888b2c992)
    });
    const [availability, setAvailability] = (0, $6fFrj.useState)([]);
    const [itsOK, setItsOK] = (0, $6fFrj.useState)({
        descriptionTab: false,
        settingsTab: false,
        showErrors: false
    });
    const updateSettings = (name, value)=>{
        setSettings({
            ...settings,
            [name]: value
        });
    };
    (0, $6fFrj.useEffect)(()=>{
        if (eventType) {
            setAvailability([
                ...eventType.EventTypeAvailability
            ]);
            setSettings({
                ...eventType,
                EventTypeAvailability: undefined
            });
            setItsOK({
                descriptionTab: true,
                settingsTab: true,
                showErrors: false
            });
        } else {
            setAvailability([]);
            setSettings({
                ...(0, $0a85c5a5bac8f0b3$export$a5a6e0b888b2c992)
            });
        }
    }, [
        eventType
    ]);
    (0, $6fFrj.useEffect)(()=>{
        setItsOK({
            ...itsOK,
            settingsTab: availability.length > 0
        });
    }, [
        availability
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (!visible) {
            setItsOK({
                descriptionTab: false,
                settingsTab: false,
                showErrors: false
            });
            setSettings({
                ...(0, $0a85c5a5bac8f0b3$export$a5a6e0b888b2c992)
            });
            setAvailability([]);
        }
    }, [
        visible
    ]);
    return (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        visible: visible,
        okButtonProps: {
            loading: isLoading,
            disabled: !itsOK.descriptionTab || !itsOK.settingsTab
        },
        okText: "Save",
        onOk: ()=>{
            const updateAvailability = availability.map((ava)=>{
                if (ava.EventTypeAvailabilityBracket.length === 0) return undefined;
                return {
                    ...ava,
                    id: undefined,
                    __typename: undefined,
                    EventTypeAvailabilityBracket: ava.EventTypeAvailabilityBracket.map((ab)=>({
                            ...ab,
                            id: undefined,
                            __typename: undefined
                        }))
                };
            }).filter((avail)=>avail);
            const createUpdateEventType = {
                ...settings,
                __typename: undefined,
                userId: undefined,
                beforeBuffer: Number(settings.beforeBuffer) || null,
                afterBuffer: Number(settings.afterBuffer) || null,
                EventTypeAvailability: updateAvailability
            };
            handleSave(createUpdateEventType);
        },
        onCancel: handleCancel,
        width: "75%",
        children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            children: [
                (0, $bb3TF.jsx)($81a897fdbb4aaae0$var$Title, {
                    level: 3,
                    children: settings.name !== '' ? settings.name : 'New Appointment Type'
                }),
                (0, $bb3TF.jsx)("a", {
                    href: "https://help.taxaroo.com/article/82-create-appointment-type",
                    target: "_blank",
                    rel: "noreferrer",
                    children: (0, $bb3TF.jsx)($81a897fdbb4aaae0$var$InfoCircleOutlined, {
                        style: {
                            fontSize: '16px',
                            position: 'relative',
                            top: '-0.3em',
                            left: '0.5em'
                        }
                    })
                }),
                (0, $bb3TF.jsx)((0, $4cd66e74fa775f7f$export$2e2bcd8739ae039), {
                    itsOK: itsOK,
                    setItsOK: setItsOK,
                    data: settings,
                    updateSettings: updateSettings
                }),
                (0, $bb3TF.jsx)((0, $d54563dae8dadfb0$export$2e2bcd8739ae039), {
                    settings: settings,
                    updateSettings: updateSettings,
                    availability: availability,
                    setAvailability: setAvailability
                })
            ]
        })
    });
};
var $81a897fdbb4aaae0$export$2e2bcd8739ae039 = $81a897fdbb4aaae0$var$EventTypeSettings;


var $d25f4aee62d57a06$export$2e2bcd8739ae039 = (0, $81a897fdbb4aaae0$export$2e2bcd8739ae039);


const { Link: $0cb16fb44343d924$var$Link, Title: $0cb16fb44343d924$var$Title, Text: $0cb16fb44343d924$var$Text, Paragraph: $0cb16fb44343d924$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { SaveOutlined: $0cb16fb44343d924$var$SaveOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $0cb16fb44343d924$var$EventTypes = ({ eventTypes: eventTypes, loadingEventTypes: loadingEventTypes, createEventTypeMutation: createEventTypeMutation, createEventTypeLoading: createEventTypeLoading, handleOnError: handleOnError, updateEventTypeMutation: updateEventTypeMutation, updateEventTypeLoading: updateEventTypeLoading })=>{
    const [eventType, setEventType] = (0, $6fFrj.useState)(undefined);
    const [modalVisible, setModalVisible] = (0, $6fFrj.useState)(false);
    const [defaultTimezone, setDefaultTimezone] = (0, $6fFrj.useState)(eventTypes?.MyEventTypes?.[0].timezone);
    const [timezone, setTimezone] = (0, $6fFrj.useState)(undefined);
    const [updateEventTypeTzMutation, { loading: updateEventTypeTzLoading }] = (0, $a86ee2eea1b8cff6$export$8c277d92037582e3)({
        onError: handleOnError,
        refetchQueries: [
            (0, $cfef3f1bede5cb90$export$e81e1ebd88764b74)
        ],
        awaitRefetchQueries: true
    });
    const selectEventType = (data)=>{
        setEventType(data);
        setModalVisible(true);
    };
    const handleCancel = ()=>{
        setEventType(undefined);
        setModalVisible(false);
    };
    const handleSave = async (data)=>{
        if (Object.keys(data).some((prop)=>prop === 'id')) {
            const result = await updateEventTypeMutation({
                variables: {
                    input: data
                }
            });
            if (result.data?.updateEventType.id) setModalVisible(false);
        } else {
            const result = await createEventTypeMutation({
                variables: {
                    input: data
                }
            });
            if (result.data?.createEventType.id) setModalVisible(false);
        }
    };
    const handleTimezoneSave = async ()=>{
        const result = await updateEventTypeTzMutation({
            variables: {
                timezone: timezone
            }
        });
        if (result.data.UpdateEventTypeTimezone) (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Timezone successfuly updated');
    };
    (0, $6fFrj.useEffect)(()=>{
        if (eventTypes?.MyEventTypes?.[0].timezone) {
            setDefaultTimezone(eventTypes.MyEventTypes[0].timezone);
            setTimezone(eventTypes.MyEventTypes[0].timezone);
        }
    }, [
        eventTypes?.MyEventTypes
    ]);
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                justify: "space-between",
                style: {
                    paddingTop: '20px'
                },
                children: [
                    (0, $bb3TF.jsx)($0cb16fb44343d924$var$Title, {
                        level: 3,
                        children: "Appointment Types"
                    }),
                    (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                        type: "primary",
                        onClick: ()=>{
                            setModalVisible(true);
                            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).MODAL_SHOW, {
                                'Modal Title': 'New Appointment Type',
                                Source: 'Click on button',
                                url: window.location.href
                            });
                        },
                        children: (0, $bb3TF.jsx)($0cb16fb44343d924$var$Text, {
                            style: {
                                color: '#fff'
                            },
                            children: "New Appointment Type"
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 15,
                children: eventTypes?.MyEventTypes.length ? eventTypes?.MyEventTypes.map((event)=>(0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        style: {
                            margin: '10px'
                        },
                        children: (0, $bb3TF.jsx)((0, $1b66c700c98e8cab$export$2e2bcd8739ae039), {
                            onClick: selectEventType,
                            eventType: event,
                            isLoading: loadingEventTypes || updateEventTypeLoading,
                            handleOnError: handleOnError
                        })
                    }, event.id)) : (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    children: "Appointment types list is empty."
                })
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                style: {
                    padding: '25px 0 0 10px'
                },
                children: (0, $bb3TF.jsx)($0cb16fb44343d924$var$Paragraph, {
                    children: "Your Appointments Timezone: (only affects your Appointment Type availability times)"
                })
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                style: {
                    padding: '0 0 0 10px'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                        defaultValue: defaultTimezone,
                        style: {
                            width: '240px'
                        },
                        optionFilterProp: "children",
                        showSearch: true,
                        placeholder: "Select Timezone",
                        onChange: (val)=>setTimezone(val),
                        value: timezone,
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($7b899c8e5076dc5b$exports))).tz.names().map((name, index)=>(0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039).Option, {
                                value: name,
                                children: name
                            }, index))
                    }),
                    (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                        type: "link",
                        icon: (0, $bb3TF.jsx)($0cb16fb44343d924$var$SaveOutlined, {}),
                        title: "Save timezone",
                        disabled: defaultTimezone === timezone,
                        loading: updateEventTypeTzLoading,
                        onClick: handleTimezoneSave,
                        style: {
                            marginLeft: '12px'
                        }
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                style: {
                    paddingTop: '35px'
                },
                children: (0, $bb3TF.jsx)($0cb16fb44343d924$var$Link, {
                    href: `${window.location.origin}/settings/calendars`,
                    children: "Connect your Google or Outlook calendar here"
                })
            }),
            (0, $bb3TF.jsx)((0, $d25f4aee62d57a06$export$2e2bcd8739ae039), {
                visible: modalVisible,
                eventType: eventType,
                handleCancel: handleCancel,
                handleSave: handleSave,
                isLoading: createEventTypeLoading || updateEventTypeLoading
            })
        ]
    });
};
var $0cb16fb44343d924$export$2e2bcd8739ae039 = $0cb16fb44343d924$var$EventTypes;


var $94114d1655f3579a$export$2e2bcd8739ae039 = (0, $0cb16fb44343d924$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



var $6Sgv0 = parcelRequire("6Sgv0");









var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

const { Title: $cb4940684e1fa37b$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { Group: $cb4940684e1fa37b$var$Group, Button: $cb4940684e1fa37b$var$Button } = (0, $d2c10fe172769914$export$2e2bcd8739ae039);
const $cb4940684e1fa37b$var$CustomCalendarToolbar = (toolbar)=>{
    const { view: toolbarView, onView: onView, onNavigate: onNavigate, label: label } = toolbar;
    const [view, setView] = (0, $6fFrj.useState)(toolbarView);
    (0, $6fFrj.useEffect)(()=>{
        onView(view);
    }, [
        view
    ]);
    (0, $6fFrj.useEffect)(()=>{
        setView(toolbarView);
    }, [
        toolbarView
    ]);
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                justify: "start",
                children: (0, $bb3TF.jsxs)($cb4940684e1fa37b$var$Group, {
                    value: view,
                    onChange: (e)=>setView(e.target.value),
                    children: [
                        (0, $bb3TF.jsx)($cb4940684e1fa37b$var$Button, {
                            value: "month",
                            children: "Month"
                        }),
                        (0, $bb3TF.jsx)($cb4940684e1fa37b$var$Button, {
                            value: "week",
                            children: "Week"
                        }),
                        (0, $bb3TF.jsx)($cb4940684e1fa37b$var$Button, {
                            value: "day",
                            children: "Day"
                        }),
                        (0, $bb3TF.jsx)($cb4940684e1fa37b$var$Button, {
                            value: "agenda",
                            children: "Agenda"
                        })
                    ]
                })
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                justify: "space-between",
                style: {
                    paddingTop: '20px'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                        type: "link",
                        onClick: ()=>onNavigate('PREV'),
                        children: "Back"
                    }),
                    (0, $bb3TF.jsx)($cb4940684e1fa37b$var$Title, {
                        level: 5,
                        children: label
                    }),
                    (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                        type: "link",
                        onClick: ()=>onNavigate('NEXT'),
                        children: "Next"
                    })
                ]
            })
        ]
    });
};
var $cb4940684e1fa37b$export$2e2bcd8739ae039 = $cb4940684e1fa37b$var$CustomCalendarToolbar;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");
function $14aaff2c69643bbd$export$2e2bcd8739ae039() {
    return Array.prototype.slice.call(arguments).reduce(function(classList, arg) {
        return classList.concat(arg);
    }, []).filter(function(arg) {
        return typeof arg === 'string';
    }).join(' ');
}



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");
var $b0a13afd06fd15cf$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $b0a13afd06fd15cf$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var $b0a13afd06fd15cf$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** `Object#toString` result references. */ var $b0a13afd06fd15cf$var$funcTag = '[object Function]', $b0a13afd06fd15cf$var$genTag = '[object GeneratorFunction]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $b0a13afd06fd15cf$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $b0a13afd06fd15cf$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $b0a13afd06fd15cf$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $b0a13afd06fd15cf$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b0a13afd06fd15cf$var$root = $b0a13afd06fd15cf$var$freeGlobal || $b0a13afd06fd15cf$var$freeSelf || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $b0a13afd06fd15cf$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $b0a13afd06fd15cf$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $b0a13afd06fd15cf$var$arrayProto = Array.prototype, $b0a13afd06fd15cf$var$funcProto = Function.prototype, $b0a13afd06fd15cf$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $b0a13afd06fd15cf$var$coreJsData = $b0a13afd06fd15cf$var$root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var $b0a13afd06fd15cf$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($b0a13afd06fd15cf$var$coreJsData && $b0a13afd06fd15cf$var$coreJsData.keys && $b0a13afd06fd15cf$var$coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var $b0a13afd06fd15cf$var$funcToString = $b0a13afd06fd15cf$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b0a13afd06fd15cf$var$hasOwnProperty = $b0a13afd06fd15cf$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b0a13afd06fd15cf$var$objectToString = $b0a13afd06fd15cf$var$objectProto.toString;
/** Used to detect if a method is native. */ var $b0a13afd06fd15cf$var$reIsNative = RegExp('^' + $b0a13afd06fd15cf$var$funcToString.call($b0a13afd06fd15cf$var$hasOwnProperty).replace($b0a13afd06fd15cf$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var $b0a13afd06fd15cf$var$splice = $b0a13afd06fd15cf$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $b0a13afd06fd15cf$var$Map = $b0a13afd06fd15cf$var$getNative($b0a13afd06fd15cf$var$root, 'Map'), $b0a13afd06fd15cf$var$nativeCreate = $b0a13afd06fd15cf$var$getNative(Object, 'create');
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b0a13afd06fd15cf$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $b0a13afd06fd15cf$var$hashClear() {
    this.__data__ = $b0a13afd06fd15cf$var$nativeCreate ? $b0a13afd06fd15cf$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b0a13afd06fd15cf$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b0a13afd06fd15cf$var$hashGet(key) {
    var data = this.__data__;
    if ($b0a13afd06fd15cf$var$nativeCreate) {
        var result = data[key];
        return result === $b0a13afd06fd15cf$var$HASH_UNDEFINED ? undefined : result;
    }
    return $b0a13afd06fd15cf$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b0a13afd06fd15cf$var$hashHas(key) {
    var data = this.__data__;
    return $b0a13afd06fd15cf$var$nativeCreate ? data[key] !== undefined : $b0a13afd06fd15cf$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $b0a13afd06fd15cf$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $b0a13afd06fd15cf$var$nativeCreate && value === undefined ? $b0a13afd06fd15cf$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$b0a13afd06fd15cf$var$Hash.prototype.clear = $b0a13afd06fd15cf$var$hashClear;
$b0a13afd06fd15cf$var$Hash.prototype['delete'] = $b0a13afd06fd15cf$var$hashDelete;
$b0a13afd06fd15cf$var$Hash.prototype.get = $b0a13afd06fd15cf$var$hashGet;
$b0a13afd06fd15cf$var$Hash.prototype.has = $b0a13afd06fd15cf$var$hashHas;
$b0a13afd06fd15cf$var$Hash.prototype.set = $b0a13afd06fd15cf$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b0a13afd06fd15cf$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $b0a13afd06fd15cf$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b0a13afd06fd15cf$var$listCacheDelete(key) {
    var data = this.__data__, index = $b0a13afd06fd15cf$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $b0a13afd06fd15cf$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b0a13afd06fd15cf$var$listCacheGet(key) {
    var data = this.__data__, index = $b0a13afd06fd15cf$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b0a13afd06fd15cf$var$listCacheHas(key) {
    return $b0a13afd06fd15cf$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $b0a13afd06fd15cf$var$listCacheSet(key, value) {
    var data = this.__data__, index = $b0a13afd06fd15cf$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$b0a13afd06fd15cf$var$ListCache.prototype.clear = $b0a13afd06fd15cf$var$listCacheClear;
$b0a13afd06fd15cf$var$ListCache.prototype['delete'] = $b0a13afd06fd15cf$var$listCacheDelete;
$b0a13afd06fd15cf$var$ListCache.prototype.get = $b0a13afd06fd15cf$var$listCacheGet;
$b0a13afd06fd15cf$var$ListCache.prototype.has = $b0a13afd06fd15cf$var$listCacheHas;
$b0a13afd06fd15cf$var$ListCache.prototype.set = $b0a13afd06fd15cf$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b0a13afd06fd15cf$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $b0a13afd06fd15cf$var$mapCacheClear() {
    this.__data__ = {
        'hash': new $b0a13afd06fd15cf$var$Hash,
        'map': new ($b0a13afd06fd15cf$var$Map || $b0a13afd06fd15cf$var$ListCache),
        'string': new $b0a13afd06fd15cf$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b0a13afd06fd15cf$var$mapCacheDelete(key) {
    return $b0a13afd06fd15cf$var$getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b0a13afd06fd15cf$var$mapCacheGet(key) {
    return $b0a13afd06fd15cf$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b0a13afd06fd15cf$var$mapCacheHas(key) {
    return $b0a13afd06fd15cf$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $b0a13afd06fd15cf$var$mapCacheSet(key, value) {
    $b0a13afd06fd15cf$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$b0a13afd06fd15cf$var$MapCache.prototype.clear = $b0a13afd06fd15cf$var$mapCacheClear;
$b0a13afd06fd15cf$var$MapCache.prototype['delete'] = $b0a13afd06fd15cf$var$mapCacheDelete;
$b0a13afd06fd15cf$var$MapCache.prototype.get = $b0a13afd06fd15cf$var$mapCacheGet;
$b0a13afd06fd15cf$var$MapCache.prototype.has = $b0a13afd06fd15cf$var$mapCacheHas;
$b0a13afd06fd15cf$var$MapCache.prototype.set = $b0a13afd06fd15cf$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $b0a13afd06fd15cf$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($b0a13afd06fd15cf$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $b0a13afd06fd15cf$var$baseIsNative(value) {
    if (!$b0a13afd06fd15cf$var$isObject(value) || $b0a13afd06fd15cf$var$isMasked(value)) return false;
    var pattern = $b0a13afd06fd15cf$var$isFunction(value) || $b0a13afd06fd15cf$var$isHostObject(value) ? $b0a13afd06fd15cf$var$reIsNative : $b0a13afd06fd15cf$var$reIsHostCtor;
    return pattern.test($b0a13afd06fd15cf$var$toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $b0a13afd06fd15cf$var$getMapData(map, key) {
    var data = map.__data__;
    return $b0a13afd06fd15cf$var$isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $b0a13afd06fd15cf$var$getNative(object, key) {
    var value = $b0a13afd06fd15cf$var$getValue(object, key);
    return $b0a13afd06fd15cf$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $b0a13afd06fd15cf$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b0a13afd06fd15cf$var$isMasked(func) {
    return !!$b0a13afd06fd15cf$var$maskSrcKey && $b0a13afd06fd15cf$var$maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $b0a13afd06fd15cf$var$toSource(func) {
    if (func != null) {
        try {
            return $b0a13afd06fd15cf$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $b0a13afd06fd15cf$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError($b0a13afd06fd15cf$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($b0a13afd06fd15cf$var$memoize.Cache || $b0a13afd06fd15cf$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$b0a13afd06fd15cf$var$memoize.Cache = $b0a13afd06fd15cf$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $b0a13afd06fd15cf$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $b0a13afd06fd15cf$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $b0a13afd06fd15cf$var$isObject(value) ? $b0a13afd06fd15cf$var$objectToString.call(value) : '';
    return tag == $b0a13afd06fd15cf$var$funcTag || tag == $b0a13afd06fd15cf$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b0a13afd06fd15cf$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
$b0a13afd06fd15cf$exports = $b0a13afd06fd15cf$var$memoize;


function $fc124556cf35cc2c$var$resolver(options) {
    return JSON.stringify(options);
}
function $fc124556cf35cc2c$var$uniqDefined(arr) {
    return arr.filter(function(el, index) {
        return el && arr.indexOf(el) === index;
    });
}
function $fc124556cf35cc2c$var$normalizeLocales(arr) {
    return arr.map(function(el) {
        if (!el || el.indexOf('-') === -1 || el.toLowerCase() !== el) return el;
        var splitEl = el.split('-');
        return splitEl[0] + "-" + splitEl[1].toUpperCase();
    });
}
function $fc124556cf35cc2c$var$getUserLocalesInternal(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$useFallbackLocal = _ref.useFallbackLocale, useFallbackLocale = _ref$useFallbackLocal === void 0 ? true : _ref$useFallbackLocal, _ref$fallbackLocale = _ref.fallbackLocale, fallbackLocale = _ref$fallbackLocale === void 0 ? 'en-US' : _ref$fallbackLocale;
    var languageList = [];
    if (typeof window !== 'undefined') {
        var _window = window, navigator = _window.navigator;
        languageList = languageList.concat(navigator.languages, navigator.language, navigator.userLanguage, navigator.browserLanguage, navigator.systemLanguage);
    }
    if (useFallbackLocale) languageList.push(fallbackLocale);
    return $fc124556cf35cc2c$var$normalizeLocales($fc124556cf35cc2c$var$uniqDefined(languageList));
}
var $fc124556cf35cc2c$export$2709d88c05bbce73 = (0, (/*@__PURE__*/$parcel$interopDefault($b0a13afd06fd15cf$exports)))($fc124556cf35cc2c$var$getUserLocalesInternal, $fc124556cf35cc2c$var$resolver);
function $fc124556cf35cc2c$var$getUserLocaleInternal(options) {
    return $fc124556cf35cc2c$export$2709d88c05bbce73(options)[0] || null;
}
var $fc124556cf35cc2c$export$a6ea185b366483aa = (0, (/*@__PURE__*/$parcel$interopDefault($b0a13afd06fd15cf$exports)))($fc124556cf35cc2c$var$getUserLocaleInternal, $fc124556cf35cc2c$var$resolver);
var $fc124556cf35cc2c$export$2e2bcd8739ae039 = $fc124556cf35cc2c$export$a6ea185b366483aa;


/**
 * Utils
 */ function $cbfccba74d72a46d$var$makeGetEdgeOfNeighbor(getPeriod, getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborInternal(date) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset;
        var previousPeriod = getPeriod(date) + offset;
        return getEdgeOfPeriod(previousPeriod);
    };
}
function $cbfccba74d72a46d$var$makeGetEnd(getBeginOfNextPeriod) {
    return function makeGetEndInternal(date) {
        return new Date(getBeginOfNextPeriod(date).getTime() - 1);
    };
}
function $cbfccba74d72a46d$var$makeGetRange(functions) {
    return function makeGetRangeInternal(date) {
        return functions.map(function(fn) {
            return fn(date);
        });
    };
}
function $cbfccba74d72a46d$export$5846dc2d57a5c860(date) {
    if (date instanceof Date) return date.getFullYear();
    if (typeof date === 'number') return date;
    var year = parseInt(date, 10);
    if (typeof date === 'string' && !isNaN(year)) return year;
    throw new Error("Failed to get year from date: ".concat(date, "."));
}
function $cbfccba74d72a46d$export$6ce1b5acc29cb53b(date) {
    if (date instanceof Date) return date.getMonth();
    throw new Error("Failed to get month from date: ".concat(date, "."));
}
function $cbfccba74d72a46d$export$a8575fd59bc333e3(date) {
    if (date instanceof Date) return date.getMonth() + 1;
    throw new Error("Failed to get human-readable month from date: ".concat(date, "."));
}
function $cbfccba74d72a46d$export$aa350b96d91cd94(date) {
    if (date instanceof Date) return date.getDate();
    throw new Error("Failed to get year from date: ".concat(date, "."));
}
function $cbfccba74d72a46d$export$257b40f71c07d58f(date) {
    if (date instanceof Date) return date.getHours();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var hoursString = datePieces[0];
            var hours = parseInt(hoursString, 10);
            if (!isNaN(hours)) return hours;
        }
    }
    throw new Error("Failed to get hours from date: ".concat(date, "."));
}
function $cbfccba74d72a46d$export$b7f1bc3ea3ac4145(date) {
    if (date instanceof Date) return date.getMinutes();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var minutesString = datePieces[1] || 0;
            var minutes = parseInt(minutesString, 10);
            if (!isNaN(minutes)) return minutes;
        }
    }
    throw new Error("Failed to get minutes from date: ".concat(date, "."));
}
function $cbfccba74d72a46d$export$5e9417507ff28427(date) {
    if (date instanceof Date) return date.getSeconds();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var secondsString = datePieces[2] || 0;
            var seconds = parseInt(secondsString, 10);
            if (!isNaN(seconds)) return seconds;
        }
    }
    throw new Error("Failed to get seconds from date: ".concat(date, "."));
}
function $cbfccba74d72a46d$export$34dd42d02ca37c6b(date) {
    var year = $cbfccba74d72a46d$export$5846dc2d57a5c860(date);
    var centuryStartYear = year + (-year + 1) % 100;
    var centuryStartDate = new Date();
    centuryStartDate.setFullYear(centuryStartYear, 0, 1);
    centuryStartDate.setHours(0, 0, 0, 0);
    return centuryStartDate;
}
var $cbfccba74d72a46d$export$e65b64b0f80e225a = $cbfccba74d72a46d$var$makeGetEdgeOfNeighbor($cbfccba74d72a46d$export$5846dc2d57a5c860, $cbfccba74d72a46d$export$34dd42d02ca37c6b, -100);
var $cbfccba74d72a46d$export$3e300bd96d747c8a = $cbfccba74d72a46d$var$makeGetEdgeOfNeighbor($cbfccba74d72a46d$export$5846dc2d57a5c860, $cbfccba74d72a46d$export$34dd42d02ca37c6b, 100);
var $cbfccba74d72a46d$export$43c2109e18ca667b = $cbfccba74d72a46d$var$makeGetEnd($cbfccba74d72a46d$export$3e300bd96d747c8a);
var $cbfccba74d72a46d$export$4d124431cf7f00b5 = $cbfccba74d72a46d$var$makeGetEdgeOfNeighbor($cbfccba74d72a46d$export$5846dc2d57a5c860, $cbfccba74d72a46d$export$43c2109e18ca667b, -100);
var $cbfccba74d72a46d$export$2663e0ade48d35a9 = $cbfccba74d72a46d$var$makeGetEdgeOfNeighbor($cbfccba74d72a46d$export$5846dc2d57a5c860, $cbfccba74d72a46d$export$43c2109e18ca667b, 100);
var $cbfccba74d72a46d$export$a4332dc3f9de051f = $cbfccba74d72a46d$var$makeGetRange([
    $cbfccba74d72a46d$export$34dd42d02ca37c6b,
    $cbfccba74d72a46d$export$43c2109e18ca667b
]);
function $cbfccba74d72a46d$export$8bb35b885d308e78(date) {
    var year = $cbfccba74d72a46d$export$5846dc2d57a5c860(date);
    var decadeStartYear = year + (-year + 1) % 10;
    var decadeStartDate = new Date();
    decadeStartDate.setFullYear(decadeStartYear, 0, 1);
    decadeStartDate.setHours(0, 0, 0, 0);
    return decadeStartDate;
}
var $cbfccba74d72a46d$export$e43f83f55f1766fa = $cbfccba74d72a46d$var$makeGetEdgeOfNeighbor($cbfccba74d72a46d$export$5846dc2d57a5c860, $cbfccba74d72a46d$export$8bb35b885d308e78, -10);
var $cbfccba74d72a46d$export$8266d1a140c33d17 = $cbfccba74d72a46d$var$makeGetEdgeOfNeighbor($cbfccba74d72a46d$export$5846dc2d57a5c860, $cbfccba74d72a46d$export$8bb35b885d308e78, 10);
var $cbfccba74d72a46d$export$aa0bfba5bfc33956 = $cbfccba74d72a46d$var$makeGetEnd($cbfccba74d72a46d$export$8266d1a140c33d17);
var $cbfccba74d72a46d$export$93edec1b41903921 = $cbfccba74d72a46d$var$makeGetEdgeOfNeighbor($cbfccba74d72a46d$export$5846dc2d57a5c860, $cbfccba74d72a46d$export$aa0bfba5bfc33956, -10);
var $cbfccba74d72a46d$export$112141384c9d3d6b = $cbfccba74d72a46d$var$makeGetEdgeOfNeighbor($cbfccba74d72a46d$export$5846dc2d57a5c860, $cbfccba74d72a46d$export$aa0bfba5bfc33956, 10);
var $cbfccba74d72a46d$export$35cef0a1278b17e1 = $cbfccba74d72a46d$var$makeGetRange([
    $cbfccba74d72a46d$export$8bb35b885d308e78,
    $cbfccba74d72a46d$export$aa0bfba5bfc33956
]);
function $cbfccba74d72a46d$export$bbcf6a6951bb3c3a(date) {
    var year = $cbfccba74d72a46d$export$5846dc2d57a5c860(date);
    var yearStartDate = new Date();
    yearStartDate.setFullYear(year, 0, 1);
    yearStartDate.setHours(0, 0, 0, 0);
    return yearStartDate;
}
var $cbfccba74d72a46d$export$97fe927b771a6825 = $cbfccba74d72a46d$var$makeGetEdgeOfNeighbor($cbfccba74d72a46d$export$5846dc2d57a5c860, $cbfccba74d72a46d$export$bbcf6a6951bb3c3a, -1);
var $cbfccba74d72a46d$export$fed82860795beff7 = $cbfccba74d72a46d$var$makeGetEdgeOfNeighbor($cbfccba74d72a46d$export$5846dc2d57a5c860, $cbfccba74d72a46d$export$bbcf6a6951bb3c3a, 1);
var $cbfccba74d72a46d$export$248ddd7fb95e4a56 = $cbfccba74d72a46d$var$makeGetEnd($cbfccba74d72a46d$export$fed82860795beff7);
var $cbfccba74d72a46d$export$639fe5fbfbb704d0 = $cbfccba74d72a46d$var$makeGetEdgeOfNeighbor($cbfccba74d72a46d$export$5846dc2d57a5c860, $cbfccba74d72a46d$export$248ddd7fb95e4a56, -1);
var $cbfccba74d72a46d$export$952396487caf69e5 = $cbfccba74d72a46d$var$makeGetEdgeOfNeighbor($cbfccba74d72a46d$export$5846dc2d57a5c860, $cbfccba74d72a46d$export$248ddd7fb95e4a56, 1);
var $cbfccba74d72a46d$export$17e213d8c10b7032 = $cbfccba74d72a46d$var$makeGetRange([
    $cbfccba74d72a46d$export$bbcf6a6951bb3c3a,
    $cbfccba74d72a46d$export$248ddd7fb95e4a56
]);
/**
 * Month
 */ function $cbfccba74d72a46d$var$makeGetEdgeOfNeighborMonth(getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborMonthInternal(date) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset;
        var year = $cbfccba74d72a46d$export$5846dc2d57a5c860(date);
        var month = $cbfccba74d72a46d$export$6ce1b5acc29cb53b(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, 1);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
    };
}
function $cbfccba74d72a46d$export$c7002b157c9b9e95(date) {
    var year = $cbfccba74d72a46d$export$5846dc2d57a5c860(date);
    var month = $cbfccba74d72a46d$export$6ce1b5acc29cb53b(date);
    var monthStartDate = new Date();
    monthStartDate.setFullYear(year, month, 1);
    monthStartDate.setHours(0, 0, 0, 0);
    return monthStartDate;
}
var $cbfccba74d72a46d$export$e1815383d4029267 = $cbfccba74d72a46d$var$makeGetEdgeOfNeighborMonth($cbfccba74d72a46d$export$c7002b157c9b9e95, -1);
var $cbfccba74d72a46d$export$21b7c773284d5b43 = $cbfccba74d72a46d$var$makeGetEdgeOfNeighborMonth($cbfccba74d72a46d$export$c7002b157c9b9e95, 1);
var $cbfccba74d72a46d$export$6f306f93ccbcd612 = $cbfccba74d72a46d$var$makeGetEnd($cbfccba74d72a46d$export$21b7c773284d5b43);
var $cbfccba74d72a46d$export$b4b5df1ab9a8303b = $cbfccba74d72a46d$var$makeGetEdgeOfNeighborMonth($cbfccba74d72a46d$export$6f306f93ccbcd612, -1);
var $cbfccba74d72a46d$export$98f1c9e60dc0189 = $cbfccba74d72a46d$var$makeGetEdgeOfNeighborMonth($cbfccba74d72a46d$export$6f306f93ccbcd612, 1);
var $cbfccba74d72a46d$export$c59fdbf3ad20e694 = $cbfccba74d72a46d$var$makeGetRange([
    $cbfccba74d72a46d$export$c7002b157c9b9e95,
    $cbfccba74d72a46d$export$6f306f93ccbcd612
]);
/**
 * Day
 */ function $cbfccba74d72a46d$var$makeGetEdgeOfNeighborDay(getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborDayInternal(date) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset;
        var year = $cbfccba74d72a46d$export$5846dc2d57a5c860(date);
        var month = $cbfccba74d72a46d$export$6ce1b5acc29cb53b(date);
        var day = $cbfccba74d72a46d$export$aa350b96d91cd94(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, day);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
    };
}
function $cbfccba74d72a46d$export$ef6b506418c2b397(date) {
    var year = $cbfccba74d72a46d$export$5846dc2d57a5c860(date);
    var month = $cbfccba74d72a46d$export$6ce1b5acc29cb53b(date);
    var day = $cbfccba74d72a46d$export$aa350b96d91cd94(date);
    var dayStartDate = new Date();
    dayStartDate.setFullYear(year, month, day);
    dayStartDate.setHours(0, 0, 0, 0);
    return dayStartDate;
}
var $cbfccba74d72a46d$export$4f27323eaab2ccfd = $cbfccba74d72a46d$var$makeGetEdgeOfNeighborDay($cbfccba74d72a46d$export$ef6b506418c2b397, -1);
var $cbfccba74d72a46d$export$78c5682078b46db4 = $cbfccba74d72a46d$var$makeGetEdgeOfNeighborDay($cbfccba74d72a46d$export$ef6b506418c2b397, 1);
var $cbfccba74d72a46d$export$7b798396f3e38cd7 = $cbfccba74d72a46d$var$makeGetEnd($cbfccba74d72a46d$export$78c5682078b46db4);
var $cbfccba74d72a46d$export$fde0c09caefdfd4a = $cbfccba74d72a46d$var$makeGetEdgeOfNeighborDay($cbfccba74d72a46d$export$7b798396f3e38cd7, -1);
var $cbfccba74d72a46d$export$f991202e82da93a1 = $cbfccba74d72a46d$var$makeGetEdgeOfNeighborDay($cbfccba74d72a46d$export$7b798396f3e38cd7, 1);
var $cbfccba74d72a46d$export$adb5aef569605e64 = $cbfccba74d72a46d$var$makeGetRange([
    $cbfccba74d72a46d$export$ef6b506418c2b397,
    $cbfccba74d72a46d$export$7b798396f3e38cd7
]);
function $cbfccba74d72a46d$export$f645ddd439eb259d(date) {
    return $cbfccba74d72a46d$export$aa350b96d91cd94($cbfccba74d72a46d$export$6f306f93ccbcd612(date));
}
function $cbfccba74d72a46d$var$padStart(num) {
    var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var numStr = "".concat(num);
    if (numStr.length >= val) return num;
    return "0000".concat(numStr).slice(-val);
}
function $cbfccba74d72a46d$export$aefe158a7bd76d23(date) {
    var hours = $cbfccba74d72a46d$var$padStart($cbfccba74d72a46d$export$257b40f71c07d58f(date));
    var minutes = $cbfccba74d72a46d$var$padStart($cbfccba74d72a46d$export$b7f1bc3ea3ac4145(date));
    return "".concat(hours, ":").concat(minutes);
}
function $cbfccba74d72a46d$export$52113457154e5fc(date) {
    var hours = $cbfccba74d72a46d$var$padStart($cbfccba74d72a46d$export$257b40f71c07d58f(date));
    var minutes = $cbfccba74d72a46d$var$padStart($cbfccba74d72a46d$export$b7f1bc3ea3ac4145(date));
    var seconds = $cbfccba74d72a46d$var$padStart($cbfccba74d72a46d$export$5e9417507ff28427(date));
    return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
}
function $cbfccba74d72a46d$export$6f885d58ae224c35(date) {
    var year = $cbfccba74d72a46d$var$padStart($cbfccba74d72a46d$export$5846dc2d57a5c860(date), 4);
    var month = $cbfccba74d72a46d$var$padStart($cbfccba74d72a46d$export$a8575fd59bc333e3(date));
    return "".concat(year, "-").concat(month);
}
function $cbfccba74d72a46d$export$ce780a31b7197841(date) {
    var year = $cbfccba74d72a46d$var$padStart($cbfccba74d72a46d$export$5846dc2d57a5c860(date), 4);
    var month = $cbfccba74d72a46d$var$padStart($cbfccba74d72a46d$export$a8575fd59bc333e3(date));
    var day = $cbfccba74d72a46d$var$padStart($cbfccba74d72a46d$export$aa350b96d91cd94(date));
    return "".concat(year, "-").concat(month, "-").concat(day);
}
function $cbfccba74d72a46d$export$98f36b76519fd86(date) {
    return "".concat($cbfccba74d72a46d$export$ce780a31b7197841(date), "T").concat($cbfccba74d72a46d$export$52113457154e5fc(date));
}


var $79ec8da139d2de05$var$_CALENDAR_TYPE_LOCALE;
function $79ec8da139d2de05$var$_toConsumableArray(arr) {
    return $79ec8da139d2de05$var$_arrayWithoutHoles(arr) || $79ec8da139d2de05$var$_iterableToArray(arr) || $79ec8da139d2de05$var$_unsupportedIterableToArray(arr) || $79ec8da139d2de05$var$_nonIterableSpread();
}
function $79ec8da139d2de05$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $79ec8da139d2de05$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $79ec8da139d2de05$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $79ec8da139d2de05$var$_arrayLikeToArray(o, minLen);
}
function $79ec8da139d2de05$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $79ec8da139d2de05$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $79ec8da139d2de05$var$_arrayLikeToArray(arr);
}
function $79ec8da139d2de05$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $79ec8da139d2de05$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $79ec8da139d2de05$export$26fa441040070c35 = {
    ARABIC: 'Arabic',
    HEBREW: 'Hebrew',
    ISO_8601: 'ISO 8601',
    US: 'US'
};
var $79ec8da139d2de05$export$e4e5576db5b8e30f = ($79ec8da139d2de05$var$_CALENDAR_TYPE_LOCALE = {}, $79ec8da139d2de05$var$_defineProperty($79ec8da139d2de05$var$_CALENDAR_TYPE_LOCALE, $79ec8da139d2de05$export$26fa441040070c35.US, [
    'en-CA',
    'en-US',
    'es-AR',
    'es-BO',
    'es-CL',
    'es-CO',
    'es-CR',
    'es-DO',
    'es-EC',
    'es-GT',
    'es-HN',
    'es-MX',
    'es-NI',
    'es-PA',
    'es-PE',
    'es-PR',
    'es-SV',
    'es-VE',
    'pt-BR'
]), $79ec8da139d2de05$var$_defineProperty($79ec8da139d2de05$var$_CALENDAR_TYPE_LOCALE, $79ec8da139d2de05$export$26fa441040070c35.ARABIC, [
    'ar',
    'ar-AE',
    'ar-BH',
    'ar-DZ',
    'ar-EG',
    'ar-IQ',
    'ar-JO',
    'ar-KW',
    'ar-LY',
    'ar-OM',
    'ar-QA',
    'ar-SA',
    'ar-SD',
    'ar-SY',
    'ar-YE',
    'dv',
    'dv-MV',
    'ps',
    'ps-AR'
]), $79ec8da139d2de05$var$_defineProperty($79ec8da139d2de05$var$_CALENDAR_TYPE_LOCALE, $79ec8da139d2de05$export$26fa441040070c35.HEBREW, [
    'he',
    'he-IL'
]), $79ec8da139d2de05$var$_CALENDAR_TYPE_LOCALE);
var $79ec8da139d2de05$export$ecc24ef5795d74f8 = $79ec8da139d2de05$var$_toConsumableArray(Array(7)).map(function(el, index) {
    return index;
});



var $72b7d85dc285c450$var$formatterCache = new Map();
function $72b7d85dc285c450$var$getFormatter(options) {
    return function(locale, date) {
        var localeWithDefault = locale || (0, $fc124556cf35cc2c$export$2e2bcd8739ae039)();
        if (!$72b7d85dc285c450$var$formatterCache.has(localeWithDefault)) $72b7d85dc285c450$var$formatterCache.set(localeWithDefault, new Map());
        var formatterCacheLocale = $72b7d85dc285c450$var$formatterCache.get(localeWithDefault);
        if (!formatterCacheLocale.has(options)) formatterCacheLocale.set(options, new Intl.DateTimeFormat(localeWithDefault, options).format);
        return formatterCacheLocale.get(options)(date);
    };
}
/**
 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
 * Workaround for bug in WebKit and Firefox with historical dates.
 * For more details, see:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
 *
 * @param {Date} date Date.
 */ function $72b7d85dc285c450$var$toSafeHour(date) {
    var safeDate = new Date(date);
    return new Date(safeDate.setHours(12));
}
function $72b7d85dc285c450$var$getSafeFormatter(options) {
    return function(locale, date) {
        return $72b7d85dc285c450$var$getFormatter(options)(locale, $72b7d85dc285c450$var$toSafeHour(date));
    };
}
var $72b7d85dc285c450$var$formatDateOptions = {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
};
var $72b7d85dc285c450$var$formatDayOptions = {
    day: 'numeric'
};
var $72b7d85dc285c450$var$formatLongDateOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
};
var $72b7d85dc285c450$var$formatMonthOptions = {
    month: 'long'
};
var $72b7d85dc285c450$var$formatMonthYearOptions = {
    month: 'long',
    year: 'numeric'
};
var $72b7d85dc285c450$var$formatShortWeekdayOptions = {
    weekday: 'short'
};
var $72b7d85dc285c450$var$formatWeekdayOptions = {
    weekday: 'long'
};
var $72b7d85dc285c450$var$formatYearOptions = {
    year: 'numeric'
};
var $72b7d85dc285c450$export$3ae94a2503e890a1 = $72b7d85dc285c450$var$getSafeFormatter($72b7d85dc285c450$var$formatDateOptions);
var $72b7d85dc285c450$export$a7f242eff11c1345 = $72b7d85dc285c450$var$getSafeFormatter($72b7d85dc285c450$var$formatDayOptions);
var $72b7d85dc285c450$export$322b36d80aef60ca = $72b7d85dc285c450$var$getSafeFormatter($72b7d85dc285c450$var$formatLongDateOptions);
var $72b7d85dc285c450$export$d0536c8e7f45796e = $72b7d85dc285c450$var$getSafeFormatter($72b7d85dc285c450$var$formatMonthOptions);
var $72b7d85dc285c450$export$18f8ccbe37e54acd = $72b7d85dc285c450$var$getSafeFormatter($72b7d85dc285c450$var$formatMonthYearOptions);
var $72b7d85dc285c450$export$7ebe25e42481bc02 = $72b7d85dc285c450$var$getSafeFormatter($72b7d85dc285c450$var$formatShortWeekdayOptions);
var $72b7d85dc285c450$export$407180b957f39d7e = $72b7d85dc285c450$var$getSafeFormatter($72b7d85dc285c450$var$formatWeekdayOptions);
var $72b7d85dc285c450$export$2979e79cc7cbf15b = $72b7d85dc285c450$var$getSafeFormatter($72b7d85dc285c450$var$formatYearOptions);


var $ded2abbebbe06892$var$SUNDAY = (0, $79ec8da139d2de05$export$ecc24ef5795d74f8)[0];
var $ded2abbebbe06892$var$FRIDAY = (0, $79ec8da139d2de05$export$ecc24ef5795d74f8)[5];
var $ded2abbebbe06892$var$SATURDAY = (0, $79ec8da139d2de05$export$ecc24ef5795d74f8)[6];
function $ded2abbebbe06892$export$2061056d06d7cdf7(date) {
    var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $79ec8da139d2de05$export$26fa441040070c35).ISO_8601;
    var weekday = date.getDay();
    switch(calendarType){
        case (0, $79ec8da139d2de05$export$26fa441040070c35).ISO_8601:
            // Shifts days of the week so that Monday is 0, Sunday is 6
            return (weekday + 6) % 7;
        case (0, $79ec8da139d2de05$export$26fa441040070c35).ARABIC:
            return (weekday + 1) % 7;
        case (0, $79ec8da139d2de05$export$26fa441040070c35).HEBREW:
        case (0, $79ec8da139d2de05$export$26fa441040070c35).US:
            return weekday;
        default:
            throw new Error('Unsupported calendar type.');
    }
}
function $ded2abbebbe06892$export$5fc0cc931278f768(date) {
    var beginOfCentury = (0, $cbfccba74d72a46d$export$34dd42d02ca37c6b)(date);
    return (0, $cbfccba74d72a46d$export$5846dc2d57a5c860)(beginOfCentury);
}
function $ded2abbebbe06892$export$59fb6e4ffa904295(date) {
    var beginOfDecade = (0, $cbfccba74d72a46d$export$8bb35b885d308e78)(date);
    return (0, $cbfccba74d72a46d$export$5846dc2d57a5c860)(beginOfDecade);
}
function $ded2abbebbe06892$export$84e707e5f485f282(date) {
    var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $79ec8da139d2de05$export$26fa441040070c35).ISO_8601;
    var year = (0, $cbfccba74d72a46d$export$5846dc2d57a5c860)(date);
    var monthIndex = (0, $cbfccba74d72a46d$export$6ce1b5acc29cb53b)(date);
    var day = date.getDate() - $ded2abbebbe06892$export$2061056d06d7cdf7(date, calendarType);
    return new Date(year, monthIndex, day);
}
function $ded2abbebbe06892$export$b59889984706b7a7(date) {
    var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $79ec8da139d2de05$export$26fa441040070c35).ISO_8601;
    var calendarTypeForWeekNumber = calendarType === (0, $79ec8da139d2de05$export$26fa441040070c35).US ? (0, $79ec8da139d2de05$export$26fa441040070c35).US : (0, $79ec8da139d2de05$export$26fa441040070c35).ISO_8601;
    var beginOfWeek = $ded2abbebbe06892$export$84e707e5f485f282(date, calendarType);
    var year = (0, $cbfccba74d72a46d$export$5846dc2d57a5c860)(date) + 1;
    var dayInWeekOne;
    var beginOfFirstWeek; // Look for the first week one that does not come after a given date
    do {
        dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === (0, $79ec8da139d2de05$export$26fa441040070c35).ISO_8601 ? 4 : 1);
        beginOfFirstWeek = $ded2abbebbe06892$export$84e707e5f485f282(dayInWeekOne, calendarType);
        year -= 1;
    }while (date < beginOfFirstWeek);
    return Math.round((beginOfWeek - beginOfFirstWeek) / (8.64e7 * 7)) + 1;
}
function $ded2abbebbe06892$export$700a64ae37cbc741(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $cbfccba74d72a46d$export$34dd42d02ca37c6b)(date);
        case 'decade':
            return (0, $cbfccba74d72a46d$export$8bb35b885d308e78)(date);
        case 'year':
            return (0, $cbfccba74d72a46d$export$bbcf6a6951bb3c3a)(date);
        case 'month':
            return (0, $cbfccba74d72a46d$export$c7002b157c9b9e95)(date);
        case 'day':
            return (0, $cbfccba74d72a46d$export$ef6b506418c2b397)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $ded2abbebbe06892$export$fac7f4c8b12617ff(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $cbfccba74d72a46d$export$e65b64b0f80e225a)(date);
        case 'decade':
            return (0, $cbfccba74d72a46d$export$e43f83f55f1766fa)(date);
        case 'year':
            return (0, $cbfccba74d72a46d$export$97fe927b771a6825)(date);
        case 'month':
            return (0, $cbfccba74d72a46d$export$e1815383d4029267)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $ded2abbebbe06892$export$19193c1f2d841d47(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $cbfccba74d72a46d$export$3e300bd96d747c8a)(date);
        case 'decade':
            return (0, $cbfccba74d72a46d$export$8266d1a140c33d17)(date);
        case 'year':
            return (0, $cbfccba74d72a46d$export$fed82860795beff7)(date);
        case 'month':
            return (0, $cbfccba74d72a46d$export$21b7c773284d5b43)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
var $ded2abbebbe06892$export$b514bf5935bed2bf = function getBeginPrevious2(rangeType, date) {
    switch(rangeType){
        case 'decade':
            return (0, $cbfccba74d72a46d$export$e43f83f55f1766fa)(date, -100);
        case 'year':
            return (0, $cbfccba74d72a46d$export$97fe927b771a6825)(date, -10);
        case 'month':
            return (0, $cbfccba74d72a46d$export$e1815383d4029267)(date, -12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
};
var $ded2abbebbe06892$export$2805b7ce8402b644 = function getBeginNext2(rangeType, date) {
    switch(rangeType){
        case 'decade':
            return (0, $cbfccba74d72a46d$export$8266d1a140c33d17)(date, 100);
        case 'year':
            return (0, $cbfccba74d72a46d$export$fed82860795beff7)(date, 10);
        case 'month':
            return (0, $cbfccba74d72a46d$export$21b7c773284d5b43)(date, 12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
};
function $ded2abbebbe06892$export$946298ccd438a697(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $cbfccba74d72a46d$export$43c2109e18ca667b)(date);
        case 'decade':
            return (0, $cbfccba74d72a46d$export$aa0bfba5bfc33956)(date);
        case 'year':
            return (0, $cbfccba74d72a46d$export$248ddd7fb95e4a56)(date);
        case 'month':
            return (0, $cbfccba74d72a46d$export$6f306f93ccbcd612)(date);
        case 'day':
            return (0, $cbfccba74d72a46d$export$7b798396f3e38cd7)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $ded2abbebbe06892$export$3030eb755e02a078(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $cbfccba74d72a46d$export$4d124431cf7f00b5)(date);
        case 'decade':
            return (0, $cbfccba74d72a46d$export$93edec1b41903921)(date);
        case 'year':
            return (0, $cbfccba74d72a46d$export$639fe5fbfbb704d0)(date);
        case 'month':
            return (0, $cbfccba74d72a46d$export$b4b5df1ab9a8303b)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
var $ded2abbebbe06892$export$d34b1dc45bd5f1d3 = function getEndPrevious2(rangeType, date) {
    switch(rangeType){
        case 'decade':
            return (0, $cbfccba74d72a46d$export$93edec1b41903921)(date, -100);
        case 'year':
            return (0, $cbfccba74d72a46d$export$639fe5fbfbb704d0)(date, -10);
        case 'month':
            return (0, $cbfccba74d72a46d$export$b4b5df1ab9a8303b)(date, -12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
};
function $ded2abbebbe06892$export$fef151b94550e9f5(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $cbfccba74d72a46d$export$a4332dc3f9de051f)(date);
        case 'decade':
            return (0, $cbfccba74d72a46d$export$35cef0a1278b17e1)(date);
        case 'year':
            return (0, $cbfccba74d72a46d$export$17e213d8c10b7032)(date);
        case 'month':
            return (0, $cbfccba74d72a46d$export$c59fdbf3ad20e694)(date);
        case 'day':
            return (0, $cbfccba74d72a46d$export$adb5aef569605e64)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $ded2abbebbe06892$export$3a3e6dbcaf74641d(rangeType, date1, date2) {
    var rawNextValue = [
        date1,
        date2
    ].sort(function(a, b) {
        return a - b;
    });
    return [
        $ded2abbebbe06892$export$700a64ae37cbc741(rangeType, rawNextValue[0]),
        $ded2abbebbe06892$export$946298ccd438a697(rangeType, rawNextValue[1])
    ];
}
function $ded2abbebbe06892$var$toYearLabel(locale) {
    var formatYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $72b7d85dc285c450$export$2979e79cc7cbf15b);
    var dates = arguments.length > 2 ? arguments[2] : undefined;
    return dates.map(function(date) {
        return formatYear(locale, date);
    }).join(" \u2013 ");
}
function $ded2abbebbe06892$export$a05bb87f2c518835(locale, formatYear, date) {
    return $ded2abbebbe06892$var$toYearLabel(locale, formatYear, (0, $cbfccba74d72a46d$export$a4332dc3f9de051f)(date));
}
function $ded2abbebbe06892$export$2e69ef6076209750(locale, formatYear, date) {
    return $ded2abbebbe06892$var$toYearLabel(locale, formatYear, (0, $cbfccba74d72a46d$export$35cef0a1278b17e1)(date));
}
function $ded2abbebbe06892$export$618d60ea299da42(date) {
    var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $79ec8da139d2de05$export$26fa441040070c35).ISO_8601;
    var weekday = date.getDay();
    switch(calendarType){
        case (0, $79ec8da139d2de05$export$26fa441040070c35).ARABIC:
        case (0, $79ec8da139d2de05$export$26fa441040070c35).HEBREW:
            return weekday === $ded2abbebbe06892$var$FRIDAY || weekday === $ded2abbebbe06892$var$SATURDAY;
        case (0, $79ec8da139d2de05$export$26fa441040070c35).ISO_8601:
        case (0, $79ec8da139d2de05$export$26fa441040070c35).US:
            return weekday === $ded2abbebbe06892$var$SATURDAY || weekday === $ded2abbebbe06892$var$SUNDAY;
        default:
            throw new Error('Unsupported calendar type.');
    }
}




var $cgjHV = parcelRequire("cgjHV");

function $625de5bfb15f3967$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $625de5bfb15f3967$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $625de5bfb15f3967$var$_typeof(obj);
}
var $625de5bfb15f3967$var$calendarTypes = Object.values((0, $79ec8da139d2de05$export$26fa441040070c35));
var $625de5bfb15f3967$var$allViews = [
    'century',
    'decade',
    'year',
    'month'
];
var $625de5bfb15f3967$export$9780328ce60eac34 = (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf($625de5bfb15f3967$var$calendarTypes);
var $625de5bfb15f3967$export$d53f3db2f43345df = (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string)
]);
var $625de5bfb15f3967$export$283839a53860a2f5 = function isMinDate(props, propName, componentName) {
    var minDate = props[propName];
    if (!minDate) return null;
    if (!(minDate instanceof Date)) return new Error("Invalid prop `".concat(propName, "` of type `").concat($625de5bfb15f3967$var$_typeof(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    var maxDate = props.maxDate;
    if (maxDate && minDate > maxDate) return new Error("Invalid prop `".concat(propName, "` of type `").concat($625de5bfb15f3967$var$_typeof(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
    return null;
};
var $625de5bfb15f3967$export$20075fd45e42d41c = function isMaxDate(props, propName, componentName) {
    var maxDate = props[propName];
    if (!maxDate) return null;
    if (!(maxDate instanceof Date)) return new Error("Invalid prop `".concat(propName, "` of type `").concat($625de5bfb15f3967$var$_typeof(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    var minDate = props.minDate;
    if (minDate && maxDate < minDate) return new Error("Invalid prop `".concat(propName, "` of type `").concat($625de5bfb15f3967$var$_typeof(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
    return null;
};
var $625de5bfb15f3967$export$4f9f5282de18fc69 = (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).any
    })
]);
var $625de5bfb15f3967$export$2fb7a00a48619649 = (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date),
    (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date))
]);
var $625de5bfb15f3967$export$bf6a8a97c2633c68 = (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf($625de5bfb15f3967$var$allViews));
var $625de5bfb15f3967$export$7c1393839656cd16 = function isView(props, propName, componentName) {
    var view = props[propName];
    var views = props.views;
    var allowedViews = views || $625de5bfb15f3967$var$allViews;
    if (view !== undefined && allowedViews.indexOf(view) === -1) return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat(allowedViews.map(function(a) {
        return "\"".concat(a, "\"");
    }).join(', '), "]."));
     // Everything is fine
    return null;
};
$625de5bfb15f3967$export$7c1393839656cd16.isRequired = function(props, propName, componentName) {
    var view = props[propName];
    if (!view) return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
    return $625de5bfb15f3967$export$7c1393839656cd16(props, propName, componentName);
};
var $625de5bfb15f3967$export$61cce6a131f71246 = {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date).isRequired,
    hover: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date),
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    maxDate: $625de5bfb15f3967$export$20075fd45e42d41c,
    minDate: $625de5bfb15f3967$export$283839a53860a2f5,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    tileClassName: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
        $625de5bfb15f3967$export$d53f3db2f43345df
    ]),
    tileContent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).node
    ]),
    value: $625de5bfb15f3967$export$2fb7a00a48619649,
    valueType: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string
};
var $625de5bfb15f3967$export$8571f7299c7936ad = {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date).isRequired,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string).isRequired,
    date: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date).isRequired,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    maxDate: $625de5bfb15f3967$export$20075fd45e42d41c,
    minDate: $625de5bfb15f3967$export$283839a53860a2f5,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    ])),
    tileClassName: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
        $625de5bfb15f3967$export$d53f3db2f43345df
    ]),
    tileContent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).node
    ]),
    tileDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func
};


var $0db3d114a96932fd$var$className = 'react-calendar__navigation';
function $0db3d114a96932fd$export$2e2bcd8739ae039(_ref) {
    var activeStartDate = _ref.activeStartDate, drillUp = _ref.drillUp, _ref$formatMonthYear = _ref.formatMonthYear, formatMonthYear = _ref$formatMonthYear === void 0 ? (0, $72b7d85dc285c450$export$18f8ccbe37e54acd) : _ref$formatMonthYear, _ref$formatYear = _ref.formatYear, formatYear = _ref$formatYear === void 0 ? (0, $72b7d85dc285c450$export$2979e79cc7cbf15b) : _ref$formatYear, locale = _ref.locale, maxDate = _ref.maxDate, minDate = _ref.minDate, _ref$navigationAriaLa = _ref.navigationAriaLabel, navigationAriaLabel = _ref$navigationAriaLa === void 0 ? '' : _ref$navigationAriaLa, navigationAriaLive = _ref.navigationAriaLive, navigationLabel = _ref.navigationLabel, _ref$next2AriaLabel = _ref.next2AriaLabel, next2AriaLabel = _ref$next2AriaLabel === void 0 ? '' : _ref$next2AriaLabel, _ref$next2Label = _ref.next2Label, next2Label = _ref$next2Label === void 0 ? "\xbb" : _ref$next2Label, _ref$nextAriaLabel = _ref.nextAriaLabel, nextAriaLabel = _ref$nextAriaLabel === void 0 ? '' : _ref$nextAriaLabel, _ref$nextLabel = _ref.nextLabel, nextLabel = _ref$nextLabel === void 0 ? "\u203A" : _ref$nextLabel, _ref$prev2AriaLabel = _ref.prev2AriaLabel, prev2AriaLabel = _ref$prev2AriaLabel === void 0 ? '' : _ref$prev2AriaLabel, _ref$prev2Label = _ref.prev2Label, prev2Label = _ref$prev2Label === void 0 ? "\xab" : _ref$prev2Label, _ref$prevAriaLabel = _ref.prevAriaLabel, prevAriaLabel = _ref$prevAriaLabel === void 0 ? '' : _ref$prevAriaLabel, _ref$prevLabel = _ref.prevLabel, prevLabel = _ref$prevLabel === void 0 ? "\u2039" : _ref$prevLabel, setActiveStartDate = _ref.setActiveStartDate, showDoubleView = _ref.showDoubleView, view = _ref.view, views = _ref.views;
    var drillUpAvailable = views.indexOf(view) > 0;
    var shouldShowPrevNext2Buttons = view !== 'century';
    var previousActiveStartDate = (0, $ded2abbebbe06892$export$fac7f4c8b12617ff)(view, activeStartDate);
    var previousActiveStartDate2 = shouldShowPrevNext2Buttons && (0, $ded2abbebbe06892$export$b514bf5935bed2bf)(view, activeStartDate);
    var nextActiveStartDate = (0, $ded2abbebbe06892$export$19193c1f2d841d47)(view, activeStartDate);
    var nextActiveStartDate2 = shouldShowPrevNext2Buttons && (0, $ded2abbebbe06892$export$2805b7ce8402b644)(view, activeStartDate);
    var prevButtonDisabled = function() {
        if (previousActiveStartDate.getFullYear() < 0) return true;
        var previousActiveEndDate = (0, $ded2abbebbe06892$export$3030eb755e02a078)(view, activeStartDate);
        return minDate && minDate >= previousActiveEndDate;
    }();
    var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function() {
        if (previousActiveStartDate2.getFullYear() < 0) return true;
        var previousActiveEndDate = (0, $ded2abbebbe06892$export$d34b1dc45bd5f1d3)(view, activeStartDate);
        return minDate && minDate >= previousActiveEndDate;
    }();
    var nextButtonDisabled = maxDate && maxDate < nextActiveStartDate;
    var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate < nextActiveStartDate2;
    function onClickPrevious() {
        setActiveStartDate(previousActiveStartDate, 'prev');
    }
    function onClickPrevious2() {
        setActiveStartDate(previousActiveStartDate2, 'prev2');
    }
    function onClickNext() {
        setActiveStartDate(nextActiveStartDate, 'next');
    }
    function onClickNext2() {
        setActiveStartDate(nextActiveStartDate2, 'next2');
    }
    function renderLabel(date) {
        var label = function() {
            switch(view){
                case 'century':
                    return (0, $ded2abbebbe06892$export$a05bb87f2c518835)(locale, formatYear, date);
                case 'decade':
                    return (0, $ded2abbebbe06892$export$2e69ef6076209750)(locale, formatYear, date);
                case 'year':
                    return formatYear(locale, date);
                case 'month':
                    return formatMonthYear(locale, date);
                default:
                    throw new Error("Invalid view: ".concat(view, "."));
            }
        }();
        return navigationLabel ? navigationLabel({
            date: date,
            label: label,
            locale: locale || (0, $fc124556cf35cc2c$export$a6ea185b366483aa)(),
            view: view
        }) : label;
    }
    function renderButton() {
        var labelClassName = "".concat($0db3d114a96932fd$var$className, "__label");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
            "aria-label": navigationAriaLabel,
            "aria-live": navigationAriaLive,
            className: labelClassName,
            disabled: !drillUpAvailable,
            onClick: drillUp,
            style: {
                flexGrow: 1
            },
            type: "button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
            className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--from")
        }, renderLabel(activeStartDate)), showDoubleView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
            className: "".concat(labelClassName, "__divider")
        }, " \u2013 "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
            className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--to")
        }, renderLabel(nextActiveStartDate))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: $0db3d114a96932fd$var$className
    }, prev2Label !== null && shouldShowPrevNext2Buttons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
        "aria-label": prev2AriaLabel,
        className: "".concat($0db3d114a96932fd$var$className, "__arrow ").concat($0db3d114a96932fd$var$className, "__prev2-button"),
        disabled: prev2ButtonDisabled,
        onClick: onClickPrevious2,
        type: "button"
    }, prev2Label), prevLabel !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
        "aria-label": prevAriaLabel,
        className: "".concat($0db3d114a96932fd$var$className, "__arrow ").concat($0db3d114a96932fd$var$className, "__prev-button"),
        disabled: prevButtonDisabled,
        onClick: onClickPrevious,
        type: "button"
    }, prevLabel), renderButton(), nextLabel !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
        "aria-label": nextAriaLabel,
        className: "".concat($0db3d114a96932fd$var$className, "__arrow ").concat($0db3d114a96932fd$var$className, "__next-button"),
        disabled: nextButtonDisabled,
        onClick: onClickNext,
        type: "button"
    }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
        "aria-label": next2AriaLabel,
        className: "".concat($0db3d114a96932fd$var$className, "__arrow ").concat($0db3d114a96932fd$var$className, "__next2-button"),
        disabled: next2ButtonDisabled,
        onClick: onClickNext2,
        type: "button"
    }, next2Label));
}
$0db3d114a96932fd$export$2e2bcd8739ae039.propTypes = {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date).isRequired,
    drillUp: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired,
    formatMonthYear: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    formatYear: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date),
    minDate: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date),
    navigationAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    navigationAriaLive: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    navigationLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    next2AriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    next2Label: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).node,
    nextAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    nextLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).node,
    prev2AriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    prev2Label: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).node,
    prevAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    prevLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).node,
    setActiveStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired,
    showDoubleView: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    view: (0, $625de5bfb15f3967$export$7c1393839656cd16).isRequired,
    views: (0, $625de5bfb15f3967$export$bf6a8a97c2633c68).isRequired
};



var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");

var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");
var $b044efcf2d247834$var$_excluded = [
    "children",
    "className",
    "direction",
    "count",
    "offset",
    "style",
    "wrap"
];
function $b044efcf2d247834$var$_extends() {
    $b044efcf2d247834$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b044efcf2d247834$var$_extends.apply(this, arguments);
}
function $b044efcf2d247834$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b044efcf2d247834$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b044efcf2d247834$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b044efcf2d247834$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b044efcf2d247834$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b044efcf2d247834$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b044efcf2d247834$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b044efcf2d247834$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b044efcf2d247834$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b044efcf2d247834$var$toPercent(num) {
    return "".concat(num, "%");
}
function $b044efcf2d247834$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, className = _ref.className, direction = _ref.direction, count = _ref.count, offset = _ref.offset, style = _ref.style, wrap = _ref.wrap, otherProps = $b044efcf2d247834$var$_objectWithoutProperties(_ref, $b044efcf2d247834$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", $b044efcf2d247834$var$_extends({
        className: className,
        style: $b044efcf2d247834$var$_objectSpread({
            display: 'flex',
            flexDirection: direction,
            flexWrap: wrap ? 'wrap' : 'no-wrap'
        }, style)
    }, otherProps), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Children.map(children, function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).cloneElement(child, $b044efcf2d247834$var$_objectSpread($b044efcf2d247834$var$_objectSpread({}, child.props), {}, {
            style: {
                flexBasis: $b044efcf2d247834$var$toPercent(100 / count),
                flexShrink: 0,
                flexGrow: 0,
                overflow: 'hidden',
                marginLeft: offset && index === 0 ? $b044efcf2d247834$var$toPercent(100 * offset / count) : null
            }
        }));
    }));
}
$b044efcf2d247834$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    count: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number.isRequired,
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    offset: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    ])),
    wrap: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool
};



function $67b7c5a325acd35f$var$_toConsumableArray(arr) {
    return $67b7c5a325acd35f$var$_arrayWithoutHoles(arr) || $67b7c5a325acd35f$var$_iterableToArray(arr) || $67b7c5a325acd35f$var$_unsupportedIterableToArray(arr) || $67b7c5a325acd35f$var$_nonIterableSpread();
}
function $67b7c5a325acd35f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $67b7c5a325acd35f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $67b7c5a325acd35f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $67b7c5a325acd35f$var$_arrayLikeToArray(o, minLen);
}
function $67b7c5a325acd35f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $67b7c5a325acd35f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $67b7c5a325acd35f$var$_arrayLikeToArray(arr);
}
function $67b7c5a325acd35f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $67b7c5a325acd35f$export$cf95c51b03f10bae(value, min, max) {
    if (min && min > value) return min;
    if (max && max < value) return max;
    return value;
}
function $67b7c5a325acd35f$export$7c4e06fee2f75722(value, range) {
    return range[0] <= value && range[1] >= value;
}
function $67b7c5a325acd35f$export$eecb2aa703319c46(greaterRange, smallerRange) {
    return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
}
function $67b7c5a325acd35f$export$2e215bb7f5401ba1(range1, range2) {
    return $67b7c5a325acd35f$export$7c4e06fee2f75722(range1[0], range2) || $67b7c5a325acd35f$export$7c4e06fee2f75722(range1[1], range2);
}
function $67b7c5a325acd35f$var$getRangeClassNames(valueRange, dateRange, baseClassName) {
    var isRange = $67b7c5a325acd35f$export$2e215bb7f5401ba1(dateRange, valueRange);
    var classes = [];
    if (isRange) {
        classes.push(baseClassName);
        var isRangeStart = $67b7c5a325acd35f$export$7c4e06fee2f75722(valueRange[0], dateRange);
        var isRangeEnd = $67b7c5a325acd35f$export$7c4e06fee2f75722(valueRange[1], dateRange);
        if (isRangeStart) classes.push("".concat(baseClassName, "Start"));
        if (isRangeEnd) classes.push("".concat(baseClassName, "End"));
        if (isRangeStart && isRangeEnd) classes.push("".concat(baseClassName, "BothEnds"));
    }
    return classes;
}
function $67b7c5a325acd35f$export$8b25b190354ee282() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, value = _ref.value, valueType = _ref.valueType, date = _ref.date, dateType = _ref.dateType, hover = _ref.hover;
    var className = 'react-calendar__tile';
    var classes = [
        className
    ];
    if (!date) return classes;
    if (!Array.isArray(date) && !dateType) throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
    var now = new Date();
    var dateRange = Array.isArray(date) ? date : (0, $ded2abbebbe06892$export$fef151b94550e9f5)(dateType, date);
    if ($67b7c5a325acd35f$export$7c4e06fee2f75722(now, dateRange)) classes.push("".concat(className, "--now"));
    if (!value) return classes;
    if (!Array.isArray(value) && !valueType) throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
    var valueRange = Array.isArray(value) ? value : (0, $ded2abbebbe06892$export$fef151b94550e9f5)(valueType, value);
    if ($67b7c5a325acd35f$export$eecb2aa703319c46(valueRange, dateRange)) classes.push("".concat(className, "--active"));
    else if ($67b7c5a325acd35f$export$2e215bb7f5401ba1(valueRange, dateRange)) classes.push("".concat(className, "--hasActive"));
    var valueRangeClassNames = $67b7c5a325acd35f$var$getRangeClassNames(valueRange, dateRange, "".concat(className, "--range"));
    classes.push.apply(classes, $67b7c5a325acd35f$var$_toConsumableArray(valueRangeClassNames));
    var valueArray = [].concat(value);
    if (hover && valueArray.length === 1) {
        var hoverRange = hover > valueRange[0] ? [
            valueRange[0],
            hover
        ] : [
            hover,
            valueRange[0]
        ];
        var hoverRangeClassNames = $67b7c5a325acd35f$var$getRangeClassNames(hoverRange, dateRange, "".concat(className, "--hover"));
        classes.push.apply(classes, $67b7c5a325acd35f$var$_toConsumableArray(hoverRangeClassNames));
    }
    return classes;
}



var $d802199f46e8b495$var$_excluded = [
    "className",
    "count",
    "dateTransform",
    "dateType",
    "end",
    "hover",
    "offset",
    "start",
    "step",
    "tile",
    "value",
    "valueType"
];
function $d802199f46e8b495$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d802199f46e8b495$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d802199f46e8b495$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d802199f46e8b495$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d802199f46e8b495$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d802199f46e8b495$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d802199f46e8b495$var$_extends() {
    $d802199f46e8b495$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d802199f46e8b495$var$_extends.apply(this, arguments);
}
function $d802199f46e8b495$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d802199f46e8b495$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d802199f46e8b495$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d802199f46e8b495$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, _ref$count = _ref.count, count = _ref$count === void 0 ? 3 : _ref$count, dateTransform = _ref.dateTransform, dateType = _ref.dateType, end = _ref.end, hover = _ref.hover, offset = _ref.offset, start = _ref.start, _ref$step = _ref.step, step = _ref$step === void 0 ? 1 : _ref$step, Tile = _ref.tile, value = _ref.value, valueType = _ref.valueType, tileProps = $d802199f46e8b495$var$_objectWithoutProperties(_ref, $d802199f46e8b495$var$_excluded);
    var tiles = [];
    for(var point = start; point <= end; point += step){
        var date = dateTransform(point);
        tiles.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Tile, $d802199f46e8b495$var$_extends({
            key: date.getTime(),
            classes: (0, $67b7c5a325acd35f$export$8b25b190354ee282)({
                value: value,
                valueType: valueType,
                date: date,
                dateType: dateType,
                hover: hover
            }),
            date: date,
            point: point
        }, tileProps)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b044efcf2d247834$export$2e2bcd8739ae039), {
        className: className,
        count: count,
        offset: offset,
        wrap: true
    }, tiles);
}
$d802199f46e8b495$export$2e2bcd8739ae039.propTypes = $d802199f46e8b495$var$_objectSpread($d802199f46e8b495$var$_objectSpread({}, (0, $625de5bfb15f3967$export$61cce6a131f71246)), {}, {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date),
    count: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    dateTransform: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired,
    dateType: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    offset: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    step: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    tile: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired
});



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");


var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");


function $466f83473b18bf9e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $466f83473b18bf9e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $466f83473b18bf9e$var$_typeof(obj);
}
function $466f83473b18bf9e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $466f83473b18bf9e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $466f83473b18bf9e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $466f83473b18bf9e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $466f83473b18bf9e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $466f83473b18bf9e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $466f83473b18bf9e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $466f83473b18bf9e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $466f83473b18bf9e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $466f83473b18bf9e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $466f83473b18bf9e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $466f83473b18bf9e$var$_setPrototypeOf(subClass, superClass);
}
function $466f83473b18bf9e$var$_setPrototypeOf(o, p) {
    $466f83473b18bf9e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $466f83473b18bf9e$var$_setPrototypeOf(o, p);
}
function $466f83473b18bf9e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $466f83473b18bf9e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $466f83473b18bf9e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $466f83473b18bf9e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $466f83473b18bf9e$var$_possibleConstructorReturn(this, result);
    };
}
function $466f83473b18bf9e$var$_possibleConstructorReturn(self, call) {
    if (call && ($466f83473b18bf9e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $466f83473b18bf9e$var$_assertThisInitialized(self);
}
function $466f83473b18bf9e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $466f83473b18bf9e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $466f83473b18bf9e$var$_getPrototypeOf(o) {
    $466f83473b18bf9e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $466f83473b18bf9e$var$_getPrototypeOf(o);
}
function $466f83473b18bf9e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $466f83473b18bf9e$var$datesAreDifferent(date1, date2) {
    return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
}
function $466f83473b18bf9e$var$getValue(nextProps, prop) {
    var activeStartDate = nextProps.activeStartDate, date = nextProps.date, view = nextProps.view;
    return typeof prop === 'function' ? prop({
        activeStartDate: activeStartDate,
        date: date,
        view: view
    }) : prop;
}
var $466f83473b18bf9e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    $466f83473b18bf9e$var$_inherits(Tile, _Component);
    var _super = $466f83473b18bf9e$var$_createSuper(Tile);
    function Tile() {
        var _this;
        $466f83473b18bf9e$var$_classCallCheck(this, Tile);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $466f83473b18bf9e$var$_defineProperty($466f83473b18bf9e$var$_assertThisInitialized(_this), "state", {});
        return _this;
    }
    $466f83473b18bf9e$var$_createClass(Tile, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, activeStartDate = _this$props.activeStartDate, children = _this$props.children, classes = _this$props.classes, date = _this$props.date, formatAbbr = _this$props.formatAbbr, locale = _this$props.locale, maxDate = _this$props.maxDate, maxDateTransform = _this$props.maxDateTransform, minDate = _this$props.minDate, minDateTransform = _this$props.minDateTransform, onClick = _this$props.onClick, onMouseOver = _this$props.onMouseOver, style = _this$props.style, tileDisabled = _this$props.tileDisabled, view = _this$props.view;
                var _this$state = this.state, tileClassName = _this$state.tileClassName, tileContent = _this$state.tileContent;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
                    className: (0, $14aaff2c69643bbd$export$2e2bcd8739ae039)(classes, tileClassName),
                    disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
                        activeStartDate: activeStartDate,
                        date: date,
                        view: view
                    }),
                    onClick: onClick && function(event) {
                        return onClick(date, event);
                    },
                    onFocus: onMouseOver && function() {
                        return onMouseOver(date);
                    },
                    onMouseOver: onMouseOver && function() {
                        return onMouseOver(date);
                    },
                    style: style,
                    type: "button"
                }, formatAbbr ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("abbr", {
                    "aria-label": formatAbbr(locale, date)
                }, children) : children, tileContent);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var activeStartDate = nextProps.activeStartDate, tileClassName = nextProps.tileClassName, tileContent = nextProps.tileContent;
                var nextState = {};
                if (tileClassName !== prevState.tileClassNameProps || $466f83473b18bf9e$var$datesAreDifferent(activeStartDate, prevState.activeStartDateProps)) {
                    nextState.tileClassName = $466f83473b18bf9e$var$getValue(nextProps, tileClassName);
                    nextState.tileClassNameProps = tileClassName;
                }
                if (tileContent !== prevState.tileContentProps || $466f83473b18bf9e$var$datesAreDifferent(activeStartDate, prevState.activeStartDateProps)) {
                    nextState.tileContent = $466f83473b18bf9e$var$getValue(nextProps, tileContent);
                    nextState.tileContentProps = tileContent;
                }
                nextState.activeStartDateProps = activeStartDate;
                return nextState;
            }
        }
    ]);
    return Tile;
}((0, $6fFrj.Component));
$466f83473b18bf9e$export$2e2bcd8739ae039.propTypes = $466f83473b18bf9e$var$_objectSpread($466f83473b18bf9e$var$_objectSpread({}, (0, $625de5bfb15f3967$export$8571f7299c7936ad)), {}, {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).node.isRequired,
    formatAbbr: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    maxDateTransform: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired,
    minDateTransform: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired
});





var $310abdbeeb691c54$var$_excluded = [
    "classes",
    "formatYear"
];
function $310abdbeeb691c54$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $310abdbeeb691c54$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $310abdbeeb691c54$var$ownKeys(Object(source), !0).forEach(function(key) {
            $310abdbeeb691c54$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $310abdbeeb691c54$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $310abdbeeb691c54$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $310abdbeeb691c54$var$_extends() {
    $310abdbeeb691c54$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $310abdbeeb691c54$var$_extends.apply(this, arguments);
}
function $310abdbeeb691c54$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $310abdbeeb691c54$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $310abdbeeb691c54$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $310abdbeeb691c54$var$className = 'react-calendar__century-view__decades__decade';
function $310abdbeeb691c54$export$2e2bcd8739ae039(_ref) {
    var classes = _ref.classes, _ref$formatYear = _ref.formatYear, formatYear = _ref$formatYear === void 0 ? (0, $72b7d85dc285c450$export$2979e79cc7cbf15b) : _ref$formatYear, otherProps = $310abdbeeb691c54$var$_objectWithoutProperties(_ref, $310abdbeeb691c54$var$_excluded);
    var date = otherProps.date, locale = otherProps.locale;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $466f83473b18bf9e$export$2e2bcd8739ae039), $310abdbeeb691c54$var$_extends({}, otherProps, {
        classes: [].concat(classes, $310abdbeeb691c54$var$className),
        maxDateTransform: (0, $cbfccba74d72a46d$export$aa0bfba5bfc33956),
        minDateTransform: (0, $cbfccba74d72a46d$export$8bb35b885d308e78),
        view: "century"
    }), (0, $ded2abbebbe06892$export$2e69ef6076209750)(locale, formatYear, date));
}
$310abdbeeb691c54$export$2e2bcd8739ae039.propTypes = $310abdbeeb691c54$var$_objectSpread($310abdbeeb691c54$var$_objectSpread({}, (0, $625de5bfb15f3967$export$8571f7299c7936ad)), {}, {
    formatYear: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func
});




function $93f1c31030e71afe$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $93f1c31030e71afe$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $93f1c31030e71afe$var$ownKeys(Object(source), !0).forEach(function(key) {
            $93f1c31030e71afe$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $93f1c31030e71afe$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $93f1c31030e71afe$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $93f1c31030e71afe$var$_extends() {
    $93f1c31030e71afe$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $93f1c31030e71afe$var$_extends.apply(this, arguments);
}
function $93f1c31030e71afe$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate;
    var start = (0, $ded2abbebbe06892$export$5fc0cc931278f768)(activeStartDate);
    var end = start + 99;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $d802199f46e8b495$export$2e2bcd8739ae039), $93f1c31030e71afe$var$_extends({}, props, {
        className: "react-calendar__century-view__decades",
        dateTransform: (0, $cbfccba74d72a46d$export$8bb35b885d308e78),
        dateType: "decade",
        end: end,
        start: start,
        step: 10,
        tile: (0, $310abdbeeb691c54$export$2e2bcd8739ae039)
    }));
}
$93f1c31030e71afe$export$2e2bcd8739ae039.propTypes = $93f1c31030e71afe$var$_objectSpread({}, (0, $625de5bfb15f3967$export$61cce6a131f71246));


function $62076a7432b4881d$export$2e2bcd8739ae039(props) {
    function renderDecades() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $93f1c31030e71afe$export$2e2bcd8739ae039), props);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "react-calendar__century-view"
    }, renderDecades());
}



var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");




var $e23dc9e9c774b02d$var$_excluded = [
    "classes",
    "formatYear"
];
function $e23dc9e9c774b02d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e23dc9e9c774b02d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e23dc9e9c774b02d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e23dc9e9c774b02d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e23dc9e9c774b02d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e23dc9e9c774b02d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e23dc9e9c774b02d$var$_extends() {
    $e23dc9e9c774b02d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e23dc9e9c774b02d$var$_extends.apply(this, arguments);
}
function $e23dc9e9c774b02d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e23dc9e9c774b02d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e23dc9e9c774b02d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e23dc9e9c774b02d$var$className = 'react-calendar__decade-view__years__year';
function $e23dc9e9c774b02d$export$2e2bcd8739ae039(_ref) {
    var classes = _ref.classes, _ref$formatYear = _ref.formatYear, formatYear = _ref$formatYear === void 0 ? (0, $72b7d85dc285c450$export$2979e79cc7cbf15b) : _ref$formatYear, otherProps = $e23dc9e9c774b02d$var$_objectWithoutProperties(_ref, $e23dc9e9c774b02d$var$_excluded);
    var date = otherProps.date, locale = otherProps.locale;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $466f83473b18bf9e$export$2e2bcd8739ae039), $e23dc9e9c774b02d$var$_extends({}, otherProps, {
        classes: [].concat(classes, $e23dc9e9c774b02d$var$className),
        maxDateTransform: (0, $cbfccba74d72a46d$export$248ddd7fb95e4a56),
        minDateTransform: (0, $cbfccba74d72a46d$export$bbcf6a6951bb3c3a),
        view: "decade"
    }), formatYear(locale, date));
}
$e23dc9e9c774b02d$export$2e2bcd8739ae039.propTypes = $e23dc9e9c774b02d$var$_objectSpread($e23dc9e9c774b02d$var$_objectSpread({}, (0, $625de5bfb15f3967$export$8571f7299c7936ad)), {}, {
    formatYear: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func
});




function $f88058eaf0900104$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f88058eaf0900104$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f88058eaf0900104$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f88058eaf0900104$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f88058eaf0900104$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f88058eaf0900104$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f88058eaf0900104$var$_extends() {
    $f88058eaf0900104$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f88058eaf0900104$var$_extends.apply(this, arguments);
}
function $f88058eaf0900104$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate;
    var start = (0, $ded2abbebbe06892$export$59fb6e4ffa904295)(activeStartDate);
    var end = start + 9;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $d802199f46e8b495$export$2e2bcd8739ae039), $f88058eaf0900104$var$_extends({}, props, {
        className: "react-calendar__decade-view__years",
        dateTransform: function dateTransform(year) {
            var date = new Date();
            date.setFullYear(year, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        },
        dateType: "year",
        end: end,
        start: start,
        tile: (0, $e23dc9e9c774b02d$export$2e2bcd8739ae039)
    }));
}
$f88058eaf0900104$export$2e2bcd8739ae039.propTypes = $f88058eaf0900104$var$_objectSpread({}, (0, $625de5bfb15f3967$export$61cce6a131f71246));


function $1740ca3c602d9428$export$2e2bcd8739ae039(props) {
    function renderYears() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $f88058eaf0900104$export$2e2bcd8739ae039), props);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "react-calendar__decade-view"
    }, renderYears());
}



var $6fFrj = parcelRequire("6fFrj");

var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");




var $a50f940dd1bac466$var$_excluded = [
    "classes",
    "formatMonth",
    "formatMonthYear"
];
function $a50f940dd1bac466$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a50f940dd1bac466$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a50f940dd1bac466$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a50f940dd1bac466$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a50f940dd1bac466$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a50f940dd1bac466$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a50f940dd1bac466$var$_extends() {
    $a50f940dd1bac466$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a50f940dd1bac466$var$_extends.apply(this, arguments);
}
function $a50f940dd1bac466$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a50f940dd1bac466$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a50f940dd1bac466$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a50f940dd1bac466$var$className = 'react-calendar__year-view__months__month';
function $a50f940dd1bac466$export$2e2bcd8739ae039(_ref) {
    var classes = _ref.classes, _ref$formatMonth = _ref.formatMonth, formatMonth = _ref$formatMonth === void 0 ? (0, $72b7d85dc285c450$export$d0536c8e7f45796e) : _ref$formatMonth, _ref$formatMonthYear = _ref.formatMonthYear, formatMonthYear = _ref$formatMonthYear === void 0 ? (0, $72b7d85dc285c450$export$18f8ccbe37e54acd) : _ref$formatMonthYear, otherProps = $a50f940dd1bac466$var$_objectWithoutProperties(_ref, $a50f940dd1bac466$var$_excluded);
    var date = otherProps.date, locale = otherProps.locale;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $466f83473b18bf9e$export$2e2bcd8739ae039), $a50f940dd1bac466$var$_extends({}, otherProps, {
        classes: [].concat(classes, $a50f940dd1bac466$var$className),
        formatAbbr: formatMonthYear,
        maxDateTransform: (0, $cbfccba74d72a46d$export$6f306f93ccbcd612),
        minDateTransform: (0, $cbfccba74d72a46d$export$c7002b157c9b9e95),
        view: "year"
    }), formatMonth(locale, date));
}
$a50f940dd1bac466$export$2e2bcd8739ae039.propTypes = $a50f940dd1bac466$var$_objectSpread($a50f940dd1bac466$var$_objectSpread({}, (0, $625de5bfb15f3967$export$8571f7299c7936ad)), {}, {
    formatMonth: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    formatMonthYear: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func
});



function $cc931ad96b2c9a1f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cc931ad96b2c9a1f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cc931ad96b2c9a1f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $cc931ad96b2c9a1f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cc931ad96b2c9a1f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cc931ad96b2c9a1f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cc931ad96b2c9a1f$var$_extends() {
    $cc931ad96b2c9a1f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cc931ad96b2c9a1f$var$_extends.apply(this, arguments);
}
function $cc931ad96b2c9a1f$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate;
    var start = 0;
    var end = 11;
    var year = (0, $cbfccba74d72a46d$export$5846dc2d57a5c860)(activeStartDate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $d802199f46e8b495$export$2e2bcd8739ae039), $cc931ad96b2c9a1f$var$_extends({}, props, {
        className: "react-calendar__year-view__months",
        dateTransform: function dateTransform(monthIndex) {
            var date = new Date();
            date.setFullYear(year, monthIndex, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        },
        dateType: "month",
        end: end,
        start: start,
        tile: (0, $a50f940dd1bac466$export$2e2bcd8739ae039)
    }));
}
$cc931ad96b2c9a1f$export$2e2bcd8739ae039.propTypes = $cc931ad96b2c9a1f$var$_objectSpread($cc931ad96b2c9a1f$var$_objectSpread({}, (0, $625de5bfb15f3967$export$61cce6a131f71246)), {}, {
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string
});


function $95216f192b562a60$export$2e2bcd8739ae039(props) {
    function renderMonths() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $cc931ad96b2c9a1f$export$2e2bcd8739ae039), props);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: "react-calendar__year-view"
    }, renderMonths());
}



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");


var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");





var $0030e475760a9306$var$_excluded = [
    "formatDay",
    "formatLongDate",
    "calendarType",
    "classes",
    "currentMonthIndex"
];
function $0030e475760a9306$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0030e475760a9306$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0030e475760a9306$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0030e475760a9306$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0030e475760a9306$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0030e475760a9306$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0030e475760a9306$var$_extends() {
    $0030e475760a9306$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0030e475760a9306$var$_extends.apply(this, arguments);
}
function $0030e475760a9306$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0030e475760a9306$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0030e475760a9306$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0030e475760a9306$var$className = 'react-calendar__month-view__days__day';
function $0030e475760a9306$export$2e2bcd8739ae039(_ref) {
    var _ref$formatDay = _ref.formatDay, formatDay = _ref$formatDay === void 0 ? (0, $72b7d85dc285c450$export$a7f242eff11c1345) : _ref$formatDay, _ref$formatLongDate = _ref.formatLongDate, formatLongDate = _ref$formatLongDate === void 0 ? (0, $72b7d85dc285c450$export$322b36d80aef60ca) : _ref$formatLongDate, calendarType = _ref.calendarType, classes = _ref.classes, currentMonthIndex = _ref.currentMonthIndex, otherProps = $0030e475760a9306$var$_objectWithoutProperties(_ref, $0030e475760a9306$var$_excluded);
    var date = otherProps.date, locale = otherProps.locale;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $466f83473b18bf9e$export$2e2bcd8739ae039), $0030e475760a9306$var$_extends({}, otherProps, {
        classes: [].concat(classes, $0030e475760a9306$var$className, (0, $ded2abbebbe06892$export$618d60ea299da42)(date, calendarType) ? "".concat($0030e475760a9306$var$className, "--weekend") : null, date.getMonth() !== currentMonthIndex ? "".concat($0030e475760a9306$var$className, "--neighboringMonth") : null),
        formatAbbr: formatLongDate,
        maxDateTransform: (0, $cbfccba74d72a46d$export$7b798396f3e38cd7),
        minDateTransform: (0, $cbfccba74d72a46d$export$ef6b506418c2b397),
        view: "month"
    }), formatDay(locale, date));
}
$0030e475760a9306$export$2e2bcd8739ae039.propTypes = $0030e475760a9306$var$_objectSpread($0030e475760a9306$var$_objectSpread({}, (0, $625de5bfb15f3967$export$8571f7299c7936ad)), {}, {
    currentMonthIndex: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number.isRequired,
    formatDay: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    formatLongDate: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func
});




var $4546f8e757cf23d0$var$_excluded = [
    "showFixedNumberOfWeeks",
    "showNeighboringMonth"
];
function $4546f8e757cf23d0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4546f8e757cf23d0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4546f8e757cf23d0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4546f8e757cf23d0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4546f8e757cf23d0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4546f8e757cf23d0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4546f8e757cf23d0$var$_extends() {
    $4546f8e757cf23d0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4546f8e757cf23d0$var$_extends.apply(this, arguments);
}
function $4546f8e757cf23d0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4546f8e757cf23d0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4546f8e757cf23d0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4546f8e757cf23d0$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, calendarType = props.calendarType;
    var showFixedNumberOfWeeks = props.showFixedNumberOfWeeks, showNeighboringMonth = props.showNeighboringMonth, otherProps = $4546f8e757cf23d0$var$_objectWithoutProperties(props, $4546f8e757cf23d0$var$_excluded);
    var year = (0, $cbfccba74d72a46d$export$5846dc2d57a5c860)(activeStartDate);
    var monthIndex = (0, $cbfccba74d72a46d$export$6ce1b5acc29cb53b)(activeStartDate);
    var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
    var dayOfWeek = (0, $ded2abbebbe06892$export$2061056d06d7cdf7)(activeStartDate, calendarType);
    var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
    /**
   * Defines on which day of the month the grid shall start. If we simply show current
   * month, we obviously start on day one, but if showNeighboringMonth is set to
   * true, we need to find the beginning of the week the first day of the month is in.
   */ var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
    /**
   * Defines on which day of the month the grid shall end. If we simply show current
   * month, we need to stop on the last day of the month, but if showNeighboringMonth
   * is set to true, we need to find the end of the week the last day of the month is in.
   */ var end = function() {
        if (showFixedNumberOfWeeks) // Always show 6 weeks
        return start + 42 - 1;
        var daysInMonth = (0, $cbfccba74d72a46d$export$f645ddd439eb259d)(activeStartDate);
        if (showNeighboringMonth) {
            var activeEndDate = new Date();
            activeEndDate.setFullYear(year, monthIndex, daysInMonth);
            activeEndDate.setHours(0, 0, 0, 0);
            var daysUntilEndOfTheWeek = 7 - (0, $ded2abbebbe06892$export$2061056d06d7cdf7)(activeEndDate, calendarType) - 1;
            return daysInMonth + daysUntilEndOfTheWeek;
        }
        return daysInMonth;
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $d802199f46e8b495$export$2e2bcd8739ae039), $4546f8e757cf23d0$var$_extends({}, otherProps, {
        className: "react-calendar__month-view__days",
        count: 7,
        currentMonthIndex: monthIndex,
        dateTransform: function dateTransform(day) {
            var date = new Date();
            date.setFullYear(year, monthIndex, day);
            date.setHours(0, 0, 0, 0);
            return date;
        },
        dateType: "day",
        end: end,
        offset: offset,
        start: start,
        tile: (0, $0030e475760a9306$export$2e2bcd8739ae039)
    }));
}
$4546f8e757cf23d0$export$2e2bcd8739ae039.propTypes = $4546f8e757cf23d0$var$_objectSpread({
    calendarType: (0, $625de5bfb15f3967$export$9780328ce60eac34).isRequired,
    showFixedNumberOfWeeks: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    showNeighboringMonth: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool
}, (0, $625de5bfb15f3967$export$61cce6a131f71246));



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");






var $a668fef735e8c855$var$className = 'react-calendar__month-view__weekdays';
var $a668fef735e8c855$var$weekdayClassName = "".concat($a668fef735e8c855$var$className, "__weekday");
function $a668fef735e8c855$export$2e2bcd8739ae039(props) {
    var calendarType = props.calendarType, _props$formatShortWee = props.formatShortWeekday, formatShortWeekday = _props$formatShortWee === void 0 ? (0, $72b7d85dc285c450$export$7ebe25e42481bc02) : _props$formatShortWee, _props$formatWeekday = props.formatWeekday, formatWeekday = _props$formatWeekday === void 0 ? (0, $72b7d85dc285c450$export$407180b957f39d7e) : _props$formatWeekday, locale = props.locale, onMouseLeave = props.onMouseLeave;
    var anyDate = new Date();
    var beginOfMonth = (0, $cbfccba74d72a46d$export$c7002b157c9b9e95)(anyDate);
    var year = (0, $cbfccba74d72a46d$export$5846dc2d57a5c860)(beginOfMonth);
    var monthIndex = (0, $cbfccba74d72a46d$export$6ce1b5acc29cb53b)(beginOfMonth);
    var weekdays = [];
    for(var weekday = 1; weekday <= 7; weekday += 1){
        var weekdayDate = new Date(year, monthIndex, weekday - (0, $ded2abbebbe06892$export$2061056d06d7cdf7)(beginOfMonth, calendarType));
        var abbr = formatWeekday(locale, weekdayDate);
        weekdays.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
            key: weekday,
            className: (0, $14aaff2c69643bbd$export$2e2bcd8739ae039)($a668fef735e8c855$var$weekdayClassName, (0, $ded2abbebbe06892$export$618d60ea299da42)(weekdayDate, calendarType) && "".concat($a668fef735e8c855$var$weekdayClassName, "--weekend"))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("abbr", {
            "aria-label": abbr,
            title: abbr
        }, formatShortWeekday(locale, weekdayDate).replace('.', ''))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b044efcf2d247834$export$2e2bcd8739ae039), {
        className: $a668fef735e8c855$var$className,
        count: 7,
        onFocus: onMouseLeave,
        onMouseOver: onMouseLeave
    }, weekdays);
}
$a668fef735e8c855$export$2e2bcd8739ae039.propTypes = {
    calendarType: (0, $625de5bfb15f3967$export$9780328ce60eac34).isRequired,
    formatShortWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    formatWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func
};



var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");


var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");
var $597ca7d1ed310d81$var$_excluded = [
    "date",
    "onClickWeekNumber",
    "weekNumber"
];
function $597ca7d1ed310d81$var$_extends() {
    $597ca7d1ed310d81$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $597ca7d1ed310d81$var$_extends.apply(this, arguments);
}
function $597ca7d1ed310d81$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $597ca7d1ed310d81$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $597ca7d1ed310d81$var$ownKeys(Object(source), !0).forEach(function(key) {
            $597ca7d1ed310d81$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $597ca7d1ed310d81$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $597ca7d1ed310d81$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $597ca7d1ed310d81$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $597ca7d1ed310d81$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $597ca7d1ed310d81$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $597ca7d1ed310d81$var$className = 'react-calendar__tile';
function $597ca7d1ed310d81$export$2e2bcd8739ae039(_ref) {
    var date = _ref.date, onClickWeekNumber = _ref.onClickWeekNumber, weekNumber = _ref.weekNumber, otherProps = $597ca7d1ed310d81$var$_objectWithoutProperties(_ref, $597ca7d1ed310d81$var$_excluded);
    var props = $597ca7d1ed310d81$var$_objectSpread({
        className: $597ca7d1ed310d81$var$className
    }, otherProps);
    var children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", null, weekNumber);
    return onClickWeekNumber ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", $597ca7d1ed310d81$var$_extends({}, props, {
        onClick: function onClick(event) {
            return onClickWeekNumber(weekNumber, date, event);
        },
        type: "button"
    }), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", props, children);
}
$597ca7d1ed310d81$export$2e2bcd8739ae039.propTypes = {
    date: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date).isRequired,
    onClickWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    weekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).node.isRequired
};





function $f72200daafc4dbe8$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, calendarType = props.calendarType, onClickWeekNumber = props.onClickWeekNumber, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
    var numberOfWeeks = function() {
        if (showFixedNumberOfWeeks) return 6;
        var numberOfDays = (0, $cbfccba74d72a46d$export$f645ddd439eb259d)(activeStartDate);
        var startWeekday = (0, $ded2abbebbe06892$export$2061056d06d7cdf7)(activeStartDate, calendarType);
        var days = numberOfDays - (7 - startWeekday);
        return 1 + Math.ceil(days / 7);
    }();
    var dates = function() {
        var year = (0, $cbfccba74d72a46d$export$5846dc2d57a5c860)(activeStartDate);
        var monthIndex = (0, $cbfccba74d72a46d$export$6ce1b5acc29cb53b)(activeStartDate);
        var day = (0, $cbfccba74d72a46d$export$aa350b96d91cd94)(activeStartDate);
        var result = [];
        for(var index = 0; index < numberOfWeeks; index += 1)result.push((0, $ded2abbebbe06892$export$84e707e5f485f282)(new Date(year, monthIndex, day + index * 7), calendarType));
        return result;
    }();
    var weekNumbers = dates.map(function(date) {
        return (0, $ded2abbebbe06892$export$b59889984706b7a7)(date, calendarType);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $b044efcf2d247834$export$2e2bcd8739ae039), {
        className: "react-calendar__month-view__weekNumbers",
        count: numberOfWeeks,
        direction: "column",
        onFocus: onMouseLeave,
        onMouseOver: onMouseLeave,
        style: {
            flexBasis: 'calc(100% * (1 / 8)',
            flexShrink: 0
        }
    }, weekNumbers.map(function(weekNumber, weekIndex) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $597ca7d1ed310d81$export$2e2bcd8739ae039), {
            key: weekNumber,
            date: dates[weekIndex],
            onClickWeekNumber: onClickWeekNumber,
            weekNumber: weekNumber
        });
    }));
}
$f72200daafc4dbe8$export$2e2bcd8739ae039.propTypes = {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date).isRequired,
    calendarType: (0, $625de5bfb15f3967$export$9780328ce60eac34).isRequired,
    onClickWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    showFixedNumberOfWeeks: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool
};




var $d3a00f6745dc959c$var$_excluded = [
    "calendarType",
    "formatShortWeekday",
    "formatWeekday",
    "onClickWeekNumber",
    "showWeekNumbers"
];
function $d3a00f6745dc959c$var$_extends() {
    $d3a00f6745dc959c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d3a00f6745dc959c$var$_extends.apply(this, arguments);
}
function $d3a00f6745dc959c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d3a00f6745dc959c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d3a00f6745dc959c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d3a00f6745dc959c$var$getCalendarTypeFromLocale(locale) {
    return Object.keys((0, $79ec8da139d2de05$export$e4e5576db5b8e30f)).find(function(calendarType) {
        return (0, $79ec8da139d2de05$export$e4e5576db5b8e30f)[calendarType].includes(locale);
    }) || (0, $79ec8da139d2de05$export$26fa441040070c35).ISO_8601;
}
function $d3a00f6745dc959c$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, locale = props.locale, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
    var _props$calendarType = props.calendarType, calendarType = _props$calendarType === void 0 ? $d3a00f6745dc959c$var$getCalendarTypeFromLocale(locale) : _props$calendarType, formatShortWeekday = props.formatShortWeekday, formatWeekday = props.formatWeekday, onClickWeekNumber = props.onClickWeekNumber, showWeekNumbers = props.showWeekNumbers, childProps = $d3a00f6745dc959c$var$_objectWithoutProperties(props, $d3a00f6745dc959c$var$_excluded);
    function renderWeekdays() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a668fef735e8c855$export$2e2bcd8739ae039), {
            calendarType: calendarType,
            formatShortWeekday: formatShortWeekday,
            formatWeekday: formatWeekday,
            locale: locale,
            onMouseLeave: onMouseLeave
        });
    }
    function renderWeekNumbers() {
        if (!showWeekNumbers) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $f72200daafc4dbe8$export$2e2bcd8739ae039), {
            activeStartDate: activeStartDate,
            calendarType: calendarType,
            onClickWeekNumber: onClickWeekNumber,
            onMouseLeave: onMouseLeave,
            showFixedNumberOfWeeks: showFixedNumberOfWeeks
        });
    }
    function renderDays() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $4546f8e757cf23d0$export$2e2bcd8739ae039), $d3a00f6745dc959c$var$_extends({
            calendarType: calendarType
        }, childProps));
    }
    var className = 'react-calendar__month-view';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        className: (0, $14aaff2c69643bbd$export$2e2bcd8739ae039)(className, showWeekNumbers ? "".concat(className, "--weekNumbers") : '')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-end'
        }
    }, renderWeekNumbers(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
        style: {
            flexGrow: 1,
            width: '100%'
        }
    }, renderWeekdays(), renderDays())));
}
$d3a00f6745dc959c$export$2e2bcd8739ae039.propTypes = {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date).isRequired,
    calendarType: (0, $625de5bfb15f3967$export$9780328ce60eac34),
    formatShortWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    formatWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    onClickWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    showFixedNumberOfWeeks: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    showWeekNumbers: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool
};





var $4501d5a5fa34ee3b$var$_excluded = [
    "activeStartDate",
    "defaultActiveStartDate",
    "defaultValue",
    "defaultView",
    "maxDetail",
    "minDetail",
    "value",
    "view"
];
function $4501d5a5fa34ee3b$var$_extends() {
    $4501d5a5fa34ee3b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4501d5a5fa34ee3b$var$_extends.apply(this, arguments);
}
function $4501d5a5fa34ee3b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4501d5a5fa34ee3b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4501d5a5fa34ee3b$var$_typeof(obj);
}
function $4501d5a5fa34ee3b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4501d5a5fa34ee3b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4501d5a5fa34ee3b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4501d5a5fa34ee3b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4501d5a5fa34ee3b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4501d5a5fa34ee3b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $4501d5a5fa34ee3b$var$_setPrototypeOf(subClass, superClass);
}
function $4501d5a5fa34ee3b$var$_setPrototypeOf(o, p) {
    $4501d5a5fa34ee3b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4501d5a5fa34ee3b$var$_setPrototypeOf(o, p);
}
function $4501d5a5fa34ee3b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4501d5a5fa34ee3b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $4501d5a5fa34ee3b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $4501d5a5fa34ee3b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4501d5a5fa34ee3b$var$_possibleConstructorReturn(this, result);
    };
}
function $4501d5a5fa34ee3b$var$_possibleConstructorReturn(self, call) {
    if (call && ($4501d5a5fa34ee3b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4501d5a5fa34ee3b$var$_assertThisInitialized(self);
}
function $4501d5a5fa34ee3b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4501d5a5fa34ee3b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4501d5a5fa34ee3b$var$_getPrototypeOf(o) {
    $4501d5a5fa34ee3b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4501d5a5fa34ee3b$var$_getPrototypeOf(o);
}
function $4501d5a5fa34ee3b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4501d5a5fa34ee3b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4501d5a5fa34ee3b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4501d5a5fa34ee3b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4501d5a5fa34ee3b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4501d5a5fa34ee3b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4501d5a5fa34ee3b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4501d5a5fa34ee3b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4501d5a5fa34ee3b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4501d5a5fa34ee3b$var$_toConsumableArray(arr) {
    return $4501d5a5fa34ee3b$var$_arrayWithoutHoles(arr) || $4501d5a5fa34ee3b$var$_iterableToArray(arr) || $4501d5a5fa34ee3b$var$_unsupportedIterableToArray(arr) || $4501d5a5fa34ee3b$var$_nonIterableSpread();
}
function $4501d5a5fa34ee3b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4501d5a5fa34ee3b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4501d5a5fa34ee3b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4501d5a5fa34ee3b$var$_arrayLikeToArray(o, minLen);
}
function $4501d5a5fa34ee3b$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $4501d5a5fa34ee3b$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4501d5a5fa34ee3b$var$_arrayLikeToArray(arr);
}
function $4501d5a5fa34ee3b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $4501d5a5fa34ee3b$var$defaultMinDate = new Date();
$4501d5a5fa34ee3b$var$defaultMinDate.setFullYear(1, 0, 1);
$4501d5a5fa34ee3b$var$defaultMinDate.setHours(0, 0, 0, 0);
var $4501d5a5fa34ee3b$var$defaultMaxDate = new Date(8.64e15);
var $4501d5a5fa34ee3b$var$baseClassName = 'react-calendar';
var $4501d5a5fa34ee3b$var$allViews = [
    'century',
    'decade',
    'year',
    'month'
];
var $4501d5a5fa34ee3b$var$allValueTypes = [].concat($4501d5a5fa34ee3b$var$_toConsumableArray($4501d5a5fa34ee3b$var$allViews.slice(1)), [
    'day'
]);
function $4501d5a5fa34ee3b$var$toDate(value) {
    if (value instanceof Date) return value;
    return new Date(value);
}
/**
 * Returns views array with disallowed values cut off.
 */ function $4501d5a5fa34ee3b$var$getLimitedViews(minDetail, maxDetail) {
    return $4501d5a5fa34ee3b$var$allViews.slice($4501d5a5fa34ee3b$var$allViews.indexOf(minDetail), $4501d5a5fa34ee3b$var$allViews.indexOf(maxDetail) + 1);
}
/**
 * Determines whether a given view is allowed with currently applied settings.
 */ function $4501d5a5fa34ee3b$var$isViewAllowed(view, minDetail, maxDetail) {
    var views = $4501d5a5fa34ee3b$var$getLimitedViews(minDetail, maxDetail);
    return views.indexOf(view) !== -1;
}
/**
 * Gets either provided view if allowed by minDetail and maxDetail, or gets
 * the default view if not allowed.
 */ function $4501d5a5fa34ee3b$var$getView(view, minDetail, maxDetail) {
    if ($4501d5a5fa34ee3b$var$isViewAllowed(view, minDetail, maxDetail)) return view;
    return maxDetail;
}
/**
 * Returns value type that can be returned with currently applied settings.
 */ function $4501d5a5fa34ee3b$var$getValueType(maxDetail) {
    return $4501d5a5fa34ee3b$var$allValueTypes[$4501d5a5fa34ee3b$var$allViews.indexOf(maxDetail)];
}
function $4501d5a5fa34ee3b$var$getValue(value, index) {
    if (!value) return null;
    var rawValue = Array.isArray(value) && value.length === 2 ? value[index] : value;
    if (!rawValue) return null;
    var valueDate = $4501d5a5fa34ee3b$var$toDate(rawValue);
    if (isNaN(valueDate.getTime())) throw new Error("Invalid date: ".concat(value));
    return valueDate;
}
function $4501d5a5fa34ee3b$var$getDetailValue(_ref, index) {
    var value = _ref.value, minDate = _ref.minDate, maxDate = _ref.maxDate, maxDetail = _ref.maxDetail;
    var valuePiece = $4501d5a5fa34ee3b$var$getValue(value, index);
    if (!valuePiece) return null;
    var valueType = $4501d5a5fa34ee3b$var$getValueType(maxDetail);
    var detailValueFrom = [
        (0, $ded2abbebbe06892$export$700a64ae37cbc741),
        (0, $ded2abbebbe06892$export$946298ccd438a697)
    ][index](valueType, valuePiece);
    return (0, $67b7c5a325acd35f$export$cf95c51b03f10bae)(detailValueFrom, minDate, maxDate);
}
var $4501d5a5fa34ee3b$var$getDetailValueFrom = function getDetailValueFrom(args) {
    return $4501d5a5fa34ee3b$var$getDetailValue(args, 0);
};
var $4501d5a5fa34ee3b$var$getDetailValueTo = function getDetailValueTo(args) {
    return $4501d5a5fa34ee3b$var$getDetailValue(args, 1);
};
var $4501d5a5fa34ee3b$var$getDetailValueArray = function getDetailValueArray(args) {
    var value = args.value;
    if (Array.isArray(value)) return value;
    return [
        $4501d5a5fa34ee3b$var$getDetailValueFrom,
        $4501d5a5fa34ee3b$var$getDetailValueTo
    ].map(function(fn) {
        return fn(args);
    });
};
function $4501d5a5fa34ee3b$var$getActiveStartDate(props) {
    var maxDate = props.maxDate, maxDetail = props.maxDetail, minDate = props.minDate, minDetail = props.minDetail, value = props.value, view = props.view;
    var rangeType = $4501d5a5fa34ee3b$var$getView(view, minDetail, maxDetail);
    var valueFrom = $4501d5a5fa34ee3b$var$getDetailValueFrom({
        value: value,
        minDate: minDate,
        maxDate: maxDate,
        maxDetail: maxDetail
    }) || new Date();
    return (0, $ded2abbebbe06892$export$700a64ae37cbc741)(rangeType, valueFrom);
}
function $4501d5a5fa34ee3b$var$getInitialActiveStartDate(props) {
    var activeStartDate = props.activeStartDate, defaultActiveStartDate = props.defaultActiveStartDate, defaultValue = props.defaultValue, defaultView = props.defaultView, maxDetail = props.maxDetail, minDetail = props.minDetail, value = props.value, view = props.view, otherProps = $4501d5a5fa34ee3b$var$_objectWithoutProperties(props, $4501d5a5fa34ee3b$var$_excluded);
    var rangeType = $4501d5a5fa34ee3b$var$getView(view, minDetail, maxDetail);
    var valueFrom = activeStartDate || defaultActiveStartDate;
    if (valueFrom) return (0, $ded2abbebbe06892$export$700a64ae37cbc741)(rangeType, valueFrom);
    return $4501d5a5fa34ee3b$var$getActiveStartDate($4501d5a5fa34ee3b$var$_objectSpread({
        maxDetail: maxDetail,
        minDetail: minDetail,
        value: value || defaultValue,
        view: view || defaultView
    }, otherProps));
}
var $4501d5a5fa34ee3b$var$getIsSingleValue = function getIsSingleValue(value) {
    return value && [].concat(value).length === 1;
};
var $4501d5a5fa34ee3b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    $4501d5a5fa34ee3b$var$_inherits(Calendar, _Component);
    var _super = $4501d5a5fa34ee3b$var$_createSuper(Calendar);
    function Calendar() {
        var _this;
        $4501d5a5fa34ee3b$var$_classCallCheck(this, Calendar);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(_args));
        $4501d5a5fa34ee3b$var$_defineProperty($4501d5a5fa34ee3b$var$_assertThisInitialized(_this), "state", {
            activeStartDate: _this.props.defaultActiveStartDate,
            value: _this.props.defaultValue,
            view: _this.props.defaultView
        });
        $4501d5a5fa34ee3b$var$_defineProperty($4501d5a5fa34ee3b$var$_assertThisInitialized(_this), "setStateAndCallCallbacks", function(nextState, event, callback) {
            var _assertThisInitialize = $4501d5a5fa34ee3b$var$_assertThisInitialized(_this), previousActiveStartDate = _assertThisInitialize.activeStartDate, previousView = _assertThisInitialize.view;
            var _this$props = _this.props, allowPartialRange = _this$props.allowPartialRange, onActiveStartDateChange = _this$props.onActiveStartDateChange, onChange = _this$props.onChange, onViewChange = _this$props.onViewChange, selectRange = _this$props.selectRange;
            var prevArgs = {
                activeStartDate: previousActiveStartDate,
                view: previousView
            };
            _this.setState(nextState, function() {
                var args = {
                    action: nextState.action,
                    activeStartDate: nextState.activeStartDate || _this.activeStartDate,
                    value: nextState.value || _this.value,
                    view: nextState.view || _this.view
                };
                function shouldUpdate(key) {
                    return key in nextState && ($4501d5a5fa34ee3b$var$_typeof(nextState[key]) !== $4501d5a5fa34ee3b$var$_typeof(prevArgs[key]) || (nextState[key] instanceof Date ? nextState[key].getTime() !== prevArgs[key].getTime() : nextState[key] !== prevArgs[key]));
                }
                if (shouldUpdate('activeStartDate')) {
                    if (onActiveStartDateChange) onActiveStartDateChange(args);
                }
                if (shouldUpdate('view')) {
                    if (onViewChange) onViewChange(args);
                }
                if (shouldUpdate('value')) {
                    if (onChange) {
                        if (selectRange) {
                            var isSingleValue = $4501d5a5fa34ee3b$var$getIsSingleValue(nextState.value);
                            if (!isSingleValue) onChange(nextState.value, event);
                            else if (allowPartialRange) onChange([
                                nextState.value
                            ], event);
                        } else onChange(nextState.value, event);
                    }
                }
                if (callback) callback(args);
            });
        });
        $4501d5a5fa34ee3b$var$_defineProperty($4501d5a5fa34ee3b$var$_assertThisInitialized(_this), "setActiveStartDate", function(nextActiveStartDate, action) {
            _this.setStateAndCallCallbacks({
                action: action,
                activeStartDate: nextActiveStartDate
            });
        });
        $4501d5a5fa34ee3b$var$_defineProperty($4501d5a5fa34ee3b$var$_assertThisInitialized(_this), "drillDown", function(nextActiveStartDate, event) {
            if (!_this.drillDownAvailable) return;
            _this.onClickTile(nextActiveStartDate, event);
            var _assertThisInitialize2 = $4501d5a5fa34ee3b$var$_assertThisInitialized(_this), view = _assertThisInitialize2.view, views = _assertThisInitialize2.views;
            var onDrillDown = _this.props.onDrillDown;
            var nextView = views[views.indexOf(view) + 1];
            _this.setStateAndCallCallbacks({
                action: 'drillDown',
                activeStartDate: nextActiveStartDate,
                view: nextView
            }, undefined, onDrillDown);
        });
        $4501d5a5fa34ee3b$var$_defineProperty($4501d5a5fa34ee3b$var$_assertThisInitialized(_this), "drillUp", function() {
            if (!_this.drillUpAvailable) return;
            var _assertThisInitialize3 = $4501d5a5fa34ee3b$var$_assertThisInitialized(_this), activeStartDate = _assertThisInitialize3.activeStartDate, view = _assertThisInitialize3.view, views = _assertThisInitialize3.views;
            var onDrillUp = _this.props.onDrillUp;
            var nextView = views[views.indexOf(view) - 1];
            var nextActiveStartDate = (0, $ded2abbebbe06892$export$700a64ae37cbc741)(nextView, activeStartDate);
            _this.setStateAndCallCallbacks({
                action: 'drillUp',
                activeStartDate: nextActiveStartDate,
                view: nextView
            }, undefined, onDrillUp);
        });
        $4501d5a5fa34ee3b$var$_defineProperty($4501d5a5fa34ee3b$var$_assertThisInitialized(_this), "onChange", function(value, event) {
            var _assertThisInitialize4 = $4501d5a5fa34ee3b$var$_assertThisInitialized(_this), previousValue = _assertThisInitialize4.value;
            var _this$props2 = _this.props, goToRangeStartOnSelect = _this$props2.goToRangeStartOnSelect, selectRange = _this$props2.selectRange;
            _this.onClickTile(value, event);
            var isFirstValueInRange = selectRange && !$4501d5a5fa34ee3b$var$getIsSingleValue(previousValue);
            var nextValue;
            if (selectRange) {
                // Range selection turned on
                var _assertThisInitialize5 = $4501d5a5fa34ee3b$var$_assertThisInitialized(_this), valueType = _assertThisInitialize5.valueType;
                if (isFirstValueInRange) // Value has 0 or 2 elements - either way we're starting a new array
                // First value
                nextValue = (0, $ded2abbebbe06892$export$700a64ae37cbc741)(valueType, value);
                else // Second value
                nextValue = (0, $ded2abbebbe06892$export$3a3e6dbcaf74641d)(valueType, previousValue, value);
            } else // Range selection turned off
            nextValue = _this.getProcessedValue(value);
            var nextActiveStartDate = !selectRange || // Range selection turned on, first value
            isFirstValueInRange || // Range selection turned on, second value, goToRangeStartOnSelect toggled on
            goToRangeStartOnSelect ? $4501d5a5fa34ee3b$var$getActiveStartDate($4501d5a5fa34ee3b$var$_objectSpread($4501d5a5fa34ee3b$var$_objectSpread({}, _this.props), {}, {
                value: nextValue
            })) : null;
            event.persist();
            _this.setStateAndCallCallbacks({
                action: 'onChange',
                activeStartDate: nextActiveStartDate,
                value: nextValue
            }, event);
        });
        $4501d5a5fa34ee3b$var$_defineProperty($4501d5a5fa34ee3b$var$_assertThisInitialized(_this), "onClickTile", function(value, event) {
            var _assertThisInitialize6 = $4501d5a5fa34ee3b$var$_assertThisInitialized(_this), view = _assertThisInitialize6.view;
            var _this$props3 = _this.props, onClickDay = _this$props3.onClickDay, onClickDecade = _this$props3.onClickDecade, onClickMonth = _this$props3.onClickMonth, onClickYear = _this$props3.onClickYear;
            var callback = function() {
                switch(view){
                    case 'century':
                        return onClickDecade;
                    case 'decade':
                        return onClickYear;
                    case 'year':
                        return onClickMonth;
                    case 'month':
                        return onClickDay;
                    default:
                        throw new Error("Invalid view: ".concat(view, "."));
                }
            }();
            if (callback) callback(value, event);
        });
        $4501d5a5fa34ee3b$var$_defineProperty($4501d5a5fa34ee3b$var$_assertThisInitialized(_this), "onMouseOver", function(value) {
            _this.setState(function(prevState) {
                if (prevState.hover && prevState.hover.getTime() === value.getTime()) return null;
                return {
                    hover: value
                };
            });
        });
        $4501d5a5fa34ee3b$var$_defineProperty($4501d5a5fa34ee3b$var$_assertThisInitialized(_this), "onMouseLeave", function() {
            _this.setState({
                hover: null
            });
        });
        return _this;
    }
    $4501d5a5fa34ee3b$var$_createClass(Calendar, [
        {
            key: "activeStartDate",
            get: function get() {
                var activeStartDateProps = this.props.activeStartDate;
                var activeStartDateState = this.state.activeStartDate;
                return activeStartDateProps || activeStartDateState || $4501d5a5fa34ee3b$var$getInitialActiveStartDate(this.props);
            }
        },
        {
            key: "value",
            get: function get() {
                var _this$props4 = this.props, selectRange = _this$props4.selectRange, valueProps = _this$props4.value;
                var valueState = this.state.value; // In the middle of range selection, use value from state
                if (selectRange && $4501d5a5fa34ee3b$var$getIsSingleValue(valueState)) return valueState;
                return valueProps !== undefined ? valueProps : valueState;
            }
        },
        {
            key: "valueType",
            get: function get() {
                var maxDetail = this.props.maxDetail;
                return $4501d5a5fa34ee3b$var$getValueType(maxDetail);
            }
        },
        {
            key: "view",
            get: function get() {
                var _this$props5 = this.props, minDetail = _this$props5.minDetail, maxDetail = _this$props5.maxDetail, viewProps = _this$props5.view;
                var viewState = this.state.view;
                return $4501d5a5fa34ee3b$var$getView(viewProps || viewState, minDetail, maxDetail);
            }
        },
        {
            key: "views",
            get: function get() {
                var _this$props6 = this.props, minDetail = _this$props6.minDetail, maxDetail = _this$props6.maxDetail;
                return $4501d5a5fa34ee3b$var$getLimitedViews(minDetail, maxDetail);
            }
        },
        {
            key: "hover",
            get: function get() {
                var selectRange = this.props.selectRange;
                var hover = this.state.hover;
                return selectRange ? hover : null;
            }
        },
        {
            key: "drillDownAvailable",
            get: function get() {
                var view = this.view, views = this.views;
                return views.indexOf(view) < views.length - 1;
            }
        },
        {
            key: "drillUpAvailable",
            get: function get() {
                var view = this.view, views = this.views;
                return views.indexOf(view) > 0;
            }
        },
        {
            key: "getProcessedValue",
            value: function getProcessedValue(value) {
                var _this$props7 = this.props, minDate = _this$props7.minDate, maxDate = _this$props7.maxDate, maxDetail = _this$props7.maxDetail, returnValue = _this$props7.returnValue;
                var processFunction = function() {
                    switch(returnValue){
                        case 'start':
                            return $4501d5a5fa34ee3b$var$getDetailValueFrom;
                        case 'end':
                            return $4501d5a5fa34ee3b$var$getDetailValueTo;
                        case 'range':
                            return $4501d5a5fa34ee3b$var$getDetailValueArray;
                        default:
                            throw new Error('Invalid returnValue.');
                    }
                }();
                return processFunction({
                    value: value,
                    minDate: minDate,
                    maxDate: maxDate,
                    maxDetail: maxDetail
                });
            }
        },
        {
            key: "renderContent",
            value: function renderContent(next) {
                var currentActiveStartDate = this.activeStartDate, onMouseOver = this.onMouseOver, valueType = this.valueType, value = this.value, view = this.view;
                var _this$props8 = this.props, calendarType = _this$props8.calendarType, locale = _this$props8.locale, maxDate = _this$props8.maxDate, minDate = _this$props8.minDate, selectRange = _this$props8.selectRange, tileClassName = _this$props8.tileClassName, tileContent = _this$props8.tileContent, tileDisabled = _this$props8.tileDisabled;
                var hover = this.hover;
                var activeStartDate = next ? (0, $ded2abbebbe06892$export$19193c1f2d841d47)(view, currentActiveStartDate) : (0, $ded2abbebbe06892$export$700a64ae37cbc741)(view, currentActiveStartDate);
                var onClick = this.drillDownAvailable ? this.drillDown : this.onChange;
                var commonProps = {
                    activeStartDate: activeStartDate,
                    hover: hover,
                    locale: locale,
                    maxDate: maxDate,
                    minDate: minDate,
                    onClick: onClick,
                    onMouseOver: selectRange ? onMouseOver : null,
                    tileClassName: tileClassName,
                    tileContent: tileContent,
                    tileDisabled: tileDisabled,
                    value: value,
                    valueType: valueType
                };
                switch(view){
                    case 'century':
                        var formatYear = this.props.formatYear;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $62076a7432b4881d$export$2e2bcd8739ae039), $4501d5a5fa34ee3b$var$_extends({
                            formatYear: formatYear
                        }, commonProps));
                    case 'decade':
                        var _formatYear = this.props.formatYear;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $1740ca3c602d9428$export$2e2bcd8739ae039), $4501d5a5fa34ee3b$var$_extends({
                            formatYear: _formatYear
                        }, commonProps));
                    case 'year':
                        var _this$props9 = this.props, formatMonth = _this$props9.formatMonth, formatMonthYear = _this$props9.formatMonthYear;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $95216f192b562a60$export$2e2bcd8739ae039), $4501d5a5fa34ee3b$var$_extends({
                            formatMonth: formatMonth,
                            formatMonthYear: formatMonthYear
                        }, commonProps));
                    case 'month':
                        var _this$props10 = this.props, formatDay = _this$props10.formatDay, formatLongDate = _this$props10.formatLongDate, formatShortWeekday = _this$props10.formatShortWeekday, formatWeekday = _this$props10.formatWeekday, onClickWeekNumber = _this$props10.onClickWeekNumber, showDoubleView = _this$props10.showDoubleView, showFixedNumberOfWeeks = _this$props10.showFixedNumberOfWeeks, showNeighboringMonth = _this$props10.showNeighboringMonth, showWeekNumbers = _this$props10.showWeekNumbers;
                        var onMouseLeave = this.onMouseLeave;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $d3a00f6745dc959c$export$2e2bcd8739ae039), $4501d5a5fa34ee3b$var$_extends({
                            calendarType: calendarType,
                            formatDay: formatDay,
                            formatLongDate: formatLongDate,
                            formatShortWeekday: formatShortWeekday,
                            formatWeekday: formatWeekday,
                            onClickWeekNumber: onClickWeekNumber,
                            onMouseLeave: selectRange ? onMouseLeave : null,
                            showFixedNumberOfWeeks: typeof showFixedNumberOfWeeks !== 'undefined' ? showFixedNumberOfWeeks : showDoubleView,
                            showNeighboringMonth: showNeighboringMonth,
                            showWeekNumbers: showWeekNumbers
                        }, commonProps));
                    default:
                        throw new Error("Invalid view: ".concat(view, "."));
                }
            }
        },
        {
            key: "renderNavigation",
            value: function renderNavigation() {
                var showNavigation = this.props.showNavigation;
                if (!showNavigation) return null;
                var activeStartDate = this.activeStartDate, view = this.view, views = this.views;
                var _this$props11 = this.props, formatMonthYear = _this$props11.formatMonthYear, formatYear = _this$props11.formatYear, locale = _this$props11.locale, maxDate = _this$props11.maxDate, minDate = _this$props11.minDate, navigationAriaLabel = _this$props11.navigationAriaLabel, navigationAriaLive = _this$props11.navigationAriaLive, navigationLabel = _this$props11.navigationLabel, next2AriaLabel = _this$props11.next2AriaLabel, next2Label = _this$props11.next2Label, nextAriaLabel = _this$props11.nextAriaLabel, nextLabel = _this$props11.nextLabel, prev2AriaLabel = _this$props11.prev2AriaLabel, prev2Label = _this$props11.prev2Label, prevAriaLabel = _this$props11.prevAriaLabel, prevLabel = _this$props11.prevLabel, showDoubleView = _this$props11.showDoubleView;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $0db3d114a96932fd$export$2e2bcd8739ae039), {
                    activeStartDate: activeStartDate,
                    drillUp: this.drillUp,
                    formatMonthYear: formatMonthYear,
                    formatYear: formatYear,
                    locale: locale,
                    maxDate: maxDate,
                    minDate: minDate,
                    navigationAriaLabel: navigationAriaLabel,
                    navigationAriaLive: navigationAriaLive,
                    navigationLabel: navigationLabel,
                    next2AriaLabel: next2AriaLabel,
                    next2Label: next2Label,
                    nextAriaLabel: nextAriaLabel,
                    nextLabel: nextLabel,
                    prev2AriaLabel: prev2AriaLabel,
                    prev2Label: prev2Label,
                    prevAriaLabel: prevAriaLabel,
                    prevLabel: prevLabel,
                    setActiveStartDate: this.setActiveStartDate,
                    showDoubleView: showDoubleView,
                    view: view,
                    views: views
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props12 = this.props, className = _this$props12.className, inputRef = _this$props12.inputRef, selectRange = _this$props12.selectRange, showDoubleView = _this$props12.showDoubleView;
                var onMouseLeave = this.onMouseLeave, value = this.value;
                var valueArray = [].concat(value);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: (0, $14aaff2c69643bbd$export$2e2bcd8739ae039)($4501d5a5fa34ee3b$var$baseClassName, selectRange && valueArray.length === 1 && "".concat($4501d5a5fa34ee3b$var$baseClassName, "--selectRange"), showDoubleView && "".concat($4501d5a5fa34ee3b$var$baseClassName, "--doubleView"), className),
                    ref: inputRef
                }, this.renderNavigation(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "".concat($4501d5a5fa34ee3b$var$baseClassName, "__viewContainer"),
                    onBlur: selectRange ? onMouseLeave : null,
                    onMouseLeave: selectRange ? onMouseLeave : null
                }, this.renderContent(), showDoubleView && this.renderContent(true)));
            }
        }
    ]);
    return Calendar;
}((0, $6fFrj.Component));
$4501d5a5fa34ee3b$export$2e2bcd8739ae039.defaultProps = {
    goToRangeStartOnSelect: true,
    maxDate: $4501d5a5fa34ee3b$var$defaultMaxDate,
    maxDetail: 'month',
    minDate: $4501d5a5fa34ee3b$var$defaultMinDate,
    minDetail: 'century',
    returnValue: 'start',
    showNavigation: true,
    showNeighboringMonth: true
};
var $4501d5a5fa34ee3b$var$isActiveStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(Date);
var $4501d5a5fa34ee3b$var$isLooseValue = (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    (0, $625de5bfb15f3967$export$2fb7a00a48619649)
]);
$4501d5a5fa34ee3b$export$2e2bcd8739ae039.propTypes = {
    activeStartDate: $4501d5a5fa34ee3b$var$isActiveStartDate,
    allowPartialRange: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    calendarType: (0, $625de5bfb15f3967$export$9780328ce60eac34),
    className: (0, $625de5bfb15f3967$export$d53f3db2f43345df),
    defaultActiveStartDate: $4501d5a5fa34ee3b$var$isActiveStartDate,
    defaultValue: $4501d5a5fa34ee3b$var$isLooseValue,
    defaultView: (0, $625de5bfb15f3967$export$7c1393839656cd16),
    formatDay: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    formatLongDate: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    formatMonth: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    formatMonthYear: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    formatShortWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    formatWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    formatYear: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    goToRangeStartOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    inputRef: (0, $625de5bfb15f3967$export$4f9f5282de18fc69),
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    maxDate: (0, $625de5bfb15f3967$export$20075fd45e42d41c),
    maxDetail: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf($4501d5a5fa34ee3b$var$allViews),
    minDate: (0, $625de5bfb15f3967$export$283839a53860a2f5),
    minDetail: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf($4501d5a5fa34ee3b$var$allViews),
    navigationAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    navigationAriaLive: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf([
        'off',
        'polite',
        'assertive'
    ]),
    navigationLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    next2AriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    next2Label: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).node,
    nextAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    nextLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).node,
    onActiveStartDateChange: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onClickDay: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onClickDecade: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onClickMonth: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onClickWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onClickYear: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onDrillDown: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onDrillUp: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    prev2AriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    prev2Label: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).node,
    prevAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    prevLabel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).node,
    returnValue: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf([
        'start',
        'end',
        'range'
    ]),
    selectRange: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    showDoubleView: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    showFixedNumberOfWeeks: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    showNavigation: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    showNeighboringMonth: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    showWeekNumbers: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    tileClassName: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
        (0, $625de5bfb15f3967$export$d53f3db2f43345df)
    ]),
    tileContent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).node
    ]),
    tileDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    value: $4501d5a5fa34ee3b$var$isLooseValue,
    view: (0, $625de5bfb15f3967$export$7c1393839656cd16)
};







var $c226c3d0d65e59f9$export$2e2bcd8739ae039 = (0, $4501d5a5fa34ee3b$export$2e2bcd8739ae039);



var $6Sgv0 = parcelRequire("6Sgv0");







const { Option: $08dfb6c3976c0728$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const { TextArea: $08dfb6c3976c0728$var$TextArea } = (0, $1fb834916a156dcf$export$2e2bcd8739ae039);
const $08dfb6c3976c0728$var$NewAppointmentModal = ({ visible: visible, handleCancel: handleCancel, clients: clients, isTaxPayersLoading: isTaxPayersLoading, eventTypes: eventTypes, loadingEventTypes: loadingEventTypes, newAppointmentForm: newAppointmentForm, selectedDate: selectedDate, events: events, appointment2Update: appointment2Update, reloadEvents: reloadEvents })=>{
    const eventTypeId = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useWatch('eventType', newAppointmentForm);
    const eventType = eventTypeId ? eventTypes.find((et)=>et.id === eventTypeId) : eventTypes[0];
    const client = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useWatch('client', newAppointmentForm);
    const day = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useWatch('day', newAppointmentForm);
    const time = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useWatch('time', newAppointmentForm);
    const [brackets, setBrackets] = (0, $6fFrj.useState)([]);
    const [selectedDay, setSelectedDay] = (0, $6fFrj.useState)(undefined);
    const [selectDayDropdownOpened, setSelectDayDropdownOpened] = (0, $6fFrj.useState)(false);
    const [createEventMutation, { loading: createEventLoading }] = (0, $a86ee2eea1b8cff6$export$c78810c1254c21c8)({
        onError: (err)=>{
            if (err.message === 'Email notification was not sent. Client email is not set.') reloadEvents();
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message, 10);
        },
        refetchQueries: [
            (0, $cfef3f1bede5cb90$export$7a3b4904b0a97d55)
        ],
        awaitRefetchQueries: true
    });
    const [updateEventMutation, { loading: updateEventLoading }] = (0, $a86ee2eea1b8cff6$export$d624085c29681b0a)({
        onError: (err)=>{
            if (err.message === 'Email notification was not sent. Client email is not set.') reloadEvents();
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message, 10);
        },
        refetchQueries: [
            (0, $cfef3f1bede5cb90$export$7a3b4904b0a97d55)
        ],
        awaitRefetchQueries: true
    });
    const initialformValues = {
        client: undefined,
        meetingType: 'VIDEO',
        eventType: eventTypes[0]?.id || undefined,
        day: undefined,
        time: undefined,
        notes: ''
    };
    const getDate = (theBrackets)=>{
        const start = new Date().setHours(theBrackets.startHour, theBrackets.startMinute);
        const end = new Date().setHours(theBrackets.endHour, theBrackets.endMinute);
        return `${(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(start).format('LT')} - ${(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(end).format('LT')}`;
    };
    const filterOption = (input, option)=>option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    const disabledDate = ({ date: date })=>{
        const actualDate = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().format();
        const currentDate = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(date);
        if (currentDate.isBefore(actualDate) && !currentDate.isSame(actualDate, 'day')) return true;
        return eventType.EventTypeAvailability.findIndex((ETAvailability)=>ETAvailability.day === currentDate.format('dddd').toUpperCase() && ETAvailability.EventTypeAvailabilityBracket.length > 0) < 0;
    };
    const selectDay = async (value, updatedEventTypeId)=>{
        const momentDay = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(value);
        setSelectedDay(momentDay);
        newAppointmentForm.setFieldsValue({
            day: momentDay.format('ddd MMM DD, YYYY')
        });
        setSelectDayDropdownOpened(false);
        const eventTypeSelected = updatedEventTypeId ? eventTypes.find((et)=>et.id === updatedEventTypeId) : eventType;
        const availability = eventTypeSelected?.EventTypeAvailability.find((ETA)=>ETA.day === momentDay.format('dddd').toUpperCase());
        const selectedDayEvents = events.filter((event)=>momentDay.isSame(event.start, 'day'));
        const filteredBrackets = availability?.EventTypeAvailabilityBracket.filter((bracket)=>{
            const bracketStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(momentDay).set({
                hours: bracket.startHour,
                minutes: bracket.startMinute
            });
            const bracketEndDate = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(momentDay).set({
                hours: bracket.endHour,
                minutes: bracket.endMinute
            });
            const isEventFound = selectedDayEvents.some((evt)=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(evt.start).isBetween(bracketStartDate, bracketEndDate, undefined, '[)') || (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(evt.end).isBetween(bracketStartDate, bracketEndDate, undefined, '(]') || bracketStartDate.isBetween(evt.start, evt.end, undefined, '[)') || bracketEndDate.isBetween(evt.start, evt.end, undefined, '(]')) return true;
                return false;
            });
            // to preselect updated event time frame
            const event2Update = selectedDayEvents.find((evt)=>evt.id === appointment2Update?.id);
            if (event2Update && bracketStartDate.isSame(appointment2Update.start) && bracketEndDate.isSame(appointment2Update.end)) return true;
            if (bracketStartDate.isBefore() || isEventFound) return false;
            return true;
        }).sort((a, b)=>{
            const aName = Number(`${a.startHour}${a.startMinute === 0 ? '00' : a.startMinute}`);
            const bName = Number(`${b.startHour}${b.startMinute === 0 ? '00' : b.startMinute}`);
            if (aName > bName) return 1;
            if (aName < bName) return -1;
            return 0;
        }) || [];
        if (filteredBrackets.length > 0 && (!eventType.maxEvents || eventType.maxEvents > selectedDayEvents.length)) {
            setBrackets(filteredBrackets);
            const startHour = momentDay.hours();
            const startMinute = momentDay.minutes();
            const bracketFound = filteredBrackets.find((bracket)=>bracket.startHour === startHour && bracket.startMinute === startMinute);
            if (bracketFound) newAppointmentForm.setFieldsValue({
                time: getDate(bracketFound)
            });
            else newAppointmentForm.setFieldsValue({
                time: undefined
            });
        } else {
            setBrackets([]);
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('There are no more appointments available for this day. You can change availability in Appointment Types.');
        }
    };
    (0, $6fFrj.useEffect)(()=>{
        if (selectedDate && selectedDate >= (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().startOf('date').toDate()) selectDay(selectedDate);
    }, [
        selectedDate
    ]);
    const handleSave = async ()=>{
        const values = newAppointmentForm.getFieldsValue(true);
        const hoursDetails = (0, $5bafd68f69b44f55$export$442c0f5af3870293)(values.time);
        const { startHour: startHour, endHour: endHour } = hoursDetails;
        const startDate = selectedDay.set({
            hours: startHour.hours,
            minutes: startHour.minutes
        }).format();
        const endDate = selectedDay.set({
            hours: endHour.hours,
            minutes: endHour.minutes
        }).format();
        const theClient = clients.find((c)=>c.Entity.Users.id === values.client);
        if (appointment2Update?.id) {
            await updateEventMutation({
                variables: {
                    input: {
                        id: appointment2Update?.id,
                        title: `${theClient.Entity.Users.UserInformation?.firstName} ${theClient.Entity.Users.UserInformation?.lastName}`,
                        type: values.meetingType,
                        eventTypeId: values.eventType,
                        clientId: values.client,
                        startDate: startDate,
                        endDate: endDate,
                        notes: values.notes
                    }
                }
            });
            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
                Title: 'Update an appointment',
                Source: 'Button click',
                url: window.location.href
            });
        } else {
            await createEventMutation({
                variables: {
                    input: {
                        title: `${theClient.Entity.Users.UserInformation?.firstName} ${theClient.Entity.Users.UserInformation?.lastName}`,
                        type: values.meetingType,
                        eventTypeId: values.eventType,
                        clientId: values.client,
                        startDate: startDate,
                        endDate: endDate,
                        notes: values.notes
                    }
                }
            });
            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
                Title: 'Create an appointment',
                Source: 'Button click',
                url: window.location.href
            });
        }
        handleCancel();
    };
    // set values according to selected appointment (update appointment)
    (0, $6fFrj.useEffect)(()=>{
        if (appointment2Update?.id) {
            newAppointmentForm.setFieldsValue({
                client: appointment2Update.clientId,
                meetingType: appointment2Update.meetingType,
                eventType: appointment2Update.eventTypeId,
                notes: appointment2Update.notes
            });
            selectDay(appointment2Update.start, appointment2Update.eventTypeId);
        }
    }, [
        appointment2Update
    ]);
    return (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        title: (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
            children: [
                appointment2Update?.clientId ? 'Update an Appointment' : 'Schedule an Appointment',
                (0, $bb3TF.jsx)("a", {
                    href: "https://help.taxaroo.com/article/79-how-to-schedule-appointment",
                    target: "_blank",
                    rel: "noreferrer",
                    children: (0, $bb3TF.jsx)((0, $60bea5c3f0793107$export$2e2bcd8739ae039), {
                        style: {
                            fontSize: '16px',
                            position: 'relative',
                            top: '-0.5em',
                            left: '0.5em'
                        }
                    })
                })
            ]
        }),
        visible: visible,
        onOk: handleSave,
        onCancel: handleCancel,
        okButtonProps: {
            disabled: !client || !time || !day,
            loading: createEventLoading || updateEventLoading
        },
        okText: appointment2Update?.id ? 'Update' : 'Save',
        keyboard: false,
        children: (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
            layout: "vertical",
            form: newAppointmentForm,
            // eslint-disable-next-line no-template-curly-in-string
            validateMessages: {
                required: '${label} is required'
            },
            initialValues: initialformValues,
            children: [
                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "client",
                    label: "Client",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                        showSearch: true,
                        placeholder: "Type the client name here to select",
                        optionFilterProp: "children",
                        filterOption: filterOption,
                        loading: isTaxPayersLoading,
                        children: clients.map((c)=>(0, $bb3TF.jsx)($08dfb6c3976c0728$var$Option, {
                                value: c.Entity.Users.id,
                                children: `${c.Entity.Users.UserInformation?.firstName} ${c.Entity.Users.UserInformation?.lastName}`
                            }, c.Entity.Users.id))
                    })
                }),
                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "meetingType",
                    label: "Meeting Type",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: (0, $bb3TF.jsxs)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                        children: [
                            (0, $bb3TF.jsx)($08dfb6c3976c0728$var$Option, {
                                value: "VIDEO",
                                children: "Video"
                            }, "1"),
                            (0, $bb3TF.jsx)($08dfb6c3976c0728$var$Option, {
                                value: "CALL",
                                children: "Phone Call"
                            }, "2"),
                            (0, $bb3TF.jsx)($08dfb6c3976c0728$var$Option, {
                                value: "HOME",
                                children: "Home"
                            }, "3"),
                            (0, $bb3TF.jsx)($08dfb6c3976c0728$var$Option, {
                                value: "OFFICE",
                                children: "Office"
                            }, "4"),
                            (0, $bb3TF.jsx)($08dfb6c3976c0728$var$Option, {
                                value: "OTHER",
                                children: "Other place of service"
                            }, "5")
                        ]
                    })
                }),
                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "eventType",
                    label: "Type",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                        showSearch: true,
                        placeholder: "Type",
                        optionFilterProp: "children",
                        filterOption: filterOption,
                        notFoundContent: "Please define Appointment Types in Appointment Types tab",
                        loading: loadingEventTypes,
                        onChange: ()=>{
                            newAppointmentForm.setFieldsValue({
                                day: undefined,
                                time: undefined
                            });
                            setSelectedDay(undefined);
                        },
                        children: eventTypes.map((type)=>(0, $bb3TF.jsx)($08dfb6c3976c0728$var$Option, {
                                value: type.id,
                                children: type.name
                            }, type.id))
                    })
                }),
                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "day",
                    label: "Date",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                        open: selectDayDropdownOpened,
                        onDropdownVisibleChange: (value)=>setSelectDayDropdownOpened(value),
                        // eslint-disable-next-line react/no-unstable-nested-components
                        dropdownRender: ()=>(0, $bb3TF.jsx)((0, $c226c3d0d65e59f9$export$2e2bcd8739ae039), {
                                value: appointment2Update?.start || new Date(),
                                onChange: (val)=>selectDay(val),
                                tileDisabled: disabledDate,
                                className: "react-calendar-dropdown"
                            })
                    })
                }),
                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "time",
                    label: "Local Time",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                        showSearch: true,
                        placeholder: "Time",
                        optionFilterProp: "children",
                        filterOption: filterOption,
                        disabled: !day,
                        children: brackets.map((t, index)=>(0, $bb3TF.jsx)($08dfb6c3976c0728$var$Option, {
                                value: getDate(t),
                                children: getDate(t)
                            }, index))
                    })
                }),
                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "notes",
                    label: "Notes",
                    children: (0, $bb3TF.jsx)($08dfb6c3976c0728$var$TextArea, {
                        placeholder: "Notes",
                        autoSize: {
                            minRows: 3,
                            maxRows: 5
                        }
                    })
                })
            ]
        })
    });
};
$08dfb6c3976c0728$var$NewAppointmentModal.defaultProps = {
    appointment2Update: {
        id: '',
        clientId: '',
        meetingType: '',
        eventTypeId: '',
        start: undefined,
        end: undefined,
        notes: ''
    }
};
var $08dfb6c3976c0728$export$2e2bcd8739ae039 = $08dfb6c3976c0728$var$NewAppointmentModal;


var $61cd47ffc08acebb$export$2e2bcd8739ae039 = (0, $08dfb6c3976c0728$export$2e2bcd8739ae039);




var $bb3TF = parcelRequire("bb3TF");

const $b49ec763ee1f30e3$export$8f45430ccf837300 = [
    '#f44336',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#2196f3'
];
const $b49ec763ee1f30e3$export$6b5388d74f5e0c9d = [
    '#f44336',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#2196f3',
    '#03a9f4',
    '#00bcd4',
    '#009688',
    '#4caf50',
    '#8bc34a',
    '#cddc39',
    '#ffeb3b',
    '#ffc107',
    '#ff9800',
    '#ff5722',
    '#795548',
    '#607d8b'
];
const $b49ec763ee1f30e3$export$f700b9e65054ed20 = [
    '#cddc39',
    '#ffeb3b',
    '#ffc107',
    '#eeeeee'
];




var $bb3TF = parcelRequire("bb3TF");

var $6Sgv0 = parcelRequire("6Sgv0");






const { Text: $df5780102f30f96b$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { CalendarOutlined: $df5780102f30f96b$var$CalendarOutlined, ClockCircleOutlined: $df5780102f30f96b$var$ClockCircleOutlined, HourglassOutlined: $df5780102f30f96b$var$HourglassOutlined, LinkOutlined: $df5780102f30f96b$var$LinkOutlined, PushpinOutlined: $df5780102f30f96b$var$PushpinOutlined, TeamOutlined: $df5780102f30f96b$var$TeamOutlined, PhoneOutlined: $df5780102f30f96b$var$PhoneOutlined, HomeOutlined: $df5780102f30f96b$var$HomeOutlined, DesktopOutlined: $df5780102f30f96b$var$DesktopOutlined, CoffeeOutlined: $df5780102f30f96b$var$CoffeeOutlined, UsergroupDeleteOutlined: $df5780102f30f96b$var$UsergroupDeleteOutlined, EditOutlined: $df5780102f30f96b$var$EditOutlined, DeleteOutlined: $df5780102f30f96b$var$DeleteOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $df5780102f30f96b$var$getIcon = (type)=>{
    switch(type){
        case 'VIDEO':
            return (0, $bb3TF.jsx)($df5780102f30f96b$var$DesktopOutlined, {});
        case 'CALL':
            return (0, $bb3TF.jsx)($df5780102f30f96b$var$PhoneOutlined, {});
        case 'HOME':
            return (0, $bb3TF.jsx)($df5780102f30f96b$var$HomeOutlined, {});
        case 'OFFICE':
            return (0, $bb3TF.jsx)($df5780102f30f96b$var$CoffeeOutlined, {});
        default:
            return null;
    }
};
const $df5780102f30f96b$var$AppointmentModal = ({ id: id, date: date, duration: duration, participants: participants, start: start, end: end, meeting: meeting, status: status, type: type, isExternal: isExternal, timezone: timezone, clientId: clientId, eventTypeId: eventTypeId, notes: notes, handleUpdateEvent: handleUpdateEvent, reloadEvents: reloadEvents, participantIds: participantIds })=>{
    const { userId: userId } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const [cancelEventMutation, { loading: loadingCancelEvent }] = (0, $a86ee2eea1b8cff6$export$5480be2de31586b)({
        onError: (err)=>{
            if (err.message === 'Email notification was not sent. Client email is not set.') reloadEvents();
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message, 10);
        },
        onCompleted: ()=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Appointment Cancelled'),
        refetchQueries: [
            (0, $cfef3f1bede5cb90$export$7a3b4904b0a97d55)
        ],
        awaitRefetchQueries: true
    });
    const [encryptMyToken, { loading: loadingEncryptMyToken }] = (0, $edf372aa0dea9531$export$e667747ad459634e)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message)
    });
    const [removeEventMutation, { loading: loadingRemoveEvent }] = (0, $a86ee2eea1b8cff6$export$4f852e08102b5702)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message),
        onCompleted: ()=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Appointment Removed'),
        refetchQueries: [
            (0, $cfef3f1bede5cb90$export$7a3b4904b0a97d55)
        ],
        awaitRefetchQueries: true
    });
    const cancelAppointment = async ()=>{
        await cancelEventMutation({
            variables: {
                id: id
            }
        });
    };
    const joinVideoCallProc = async ()=>{
        const result = await encryptMyToken();
        const url = `${result.data?.EncryptMyToken.headToURL}/videocall/${meeting}`;
        const token = encodeURIComponent(result.data?.EncryptMyToken.accessToken);
        window.open(`${url}?token=${token}&userId=${userId}`, '_blank', 'noreferrer');
    };
    const editAppointmentProc = ()=>{
        const initialUpdateValues = {
            id: id,
            clientId: clientId,
            meetingType: type,
            eventTypeId: eventTypeId,
            start: start,
            end: end,
            notes: notes
        };
        handleUpdateEvent(initialUpdateValues);
    };
    const removeAppointment = async ()=>{
        await removeEventMutation({
            variables: {
                id: id
            }
        });
    };
    const tz = (0, (/*@__PURE__*/$parcel$interopDefault($7b899c8e5076dc5b$exports)))().tz(timezone).format('z');
    const resultTimeZone = tz.indexOf('+') === 0 ? `UTC${tz}` : tz;
    const userInvited = participantIds ? participantIds.includes(userId) : true;
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 15,
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($df5780102f30f96b$var$CalendarOutlined, {})
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($df5780102f30f96b$var$Text, {
                            children: date
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 15,
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($df5780102f30f96b$var$ClockCircleOutlined, {})
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($df5780102f30f96b$var$Text, {
                            children: duration === 0 ? 'Whole day event' : `${duration} Minutes`
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 15,
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($df5780102f30f96b$var$HourglassOutlined, {})
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        style: {
                            whiteSpace: 'nowrap',
                            width: '85%'
                        },
                        children: (0, $bb3TF.jsx)($df5780102f30f96b$var$Text, {
                            children: `${(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(start).format('LT')} - ${(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(end).format('LT')} ${resultTimeZone}`
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 15,
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($df5780102f30f96b$var$PushpinOutlined, {})
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        style: {
                            textTransform: 'capitalize'
                        },
                        children: (0, $bb3TF.jsx)($df5780102f30f96b$var$Text, {
                            children: status.toLowerCase()
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 15,
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: $df5780102f30f96b$var$getIcon(type)
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        style: {
                            textTransform: 'capitalize'
                        },
                        children: (0, $bb3TF.jsx)($df5780102f30f96b$var$Text, {
                            children: type.toLowerCase()
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 15,
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($df5780102f30f96b$var$TeamOutlined, {})
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($df5780102f30f96b$var$Text, {
                            children: "Participants:"
                        })
                    })
                ]
            }),
            participants.map((element, index)=>(0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    children: ` - ${element}`
                }, index)),
            type === 'VIDEO' && status !== 'CANCELED' && userInvited && (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                align: "middle",
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($df5780102f30f96b$var$LinkOutlined, {})
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                            type: "link",
                            onClick: joinVideoCallProc,
                            loading: loadingEncryptMyToken,
                            children: "Join Video Call"
                        })
                    })
                ]
            }),
            !isExternal && status !== 'CANCELED' && !loadingCancelEvent && !loadingRemoveEvent && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                children: [
                    (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {
                        style: {
                            margin: '5px',
                            padding: 0
                        }
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        align: "middle",
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                children: (0, $bb3TF.jsx)($df5780102f30f96b$var$EditOutlined, {})
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                children: (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                                    type: "link",
                                    onClick: editAppointmentProc,
                                    children: "Edit Appointment"
                                })
                            })
                        ]
                    })
                ]
            }),
            !isExternal && (loadingCancelEvent || loadingRemoveEvent) && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                align: "middle",
                justify: "center",
                children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                    size: "small"
                })
            }),
            !isExternal && status !== 'CANCELED' && !loadingCancelEvent && !loadingRemoveEvent && (0, $bb3TF.jsx)((0, $a361442371f1d4e9$export$2e2bcd8739ae039), {
                placement: "left",
                title: "Are you sure you want to cancel the Appointment?",
                okText: "Yes",
                cancelText: "No",
                onConfirm: cancelAppointment,
                children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    align: "middle",
                    children: [
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsx)($df5780102f30f96b$var$UsergroupDeleteOutlined, {})
                        }),
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                                type: "link",
                                children: "Cancel Appointment"
                            })
                        })
                    ]
                })
            }),
            !isExternal && status === 'CANCELED' && !loadingRemoveEvent && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                children: [
                    (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {
                        style: {
                            margin: '5px',
                            padding: 0
                        }
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        align: "middle",
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                children: (0, $bb3TF.jsx)($df5780102f30f96b$var$DeleteOutlined, {})
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                children: (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                                    type: "link",
                                    onClick: removeAppointment,
                                    children: "Remove Appointment"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$df5780102f30f96b$var$AppointmentModal.defaultProps = {
    clientId: '',
    eventTypeId: '',
    notes: '',
    participantIds: []
};
var $df5780102f30f96b$export$2e2bcd8739ae039 = $df5780102f30f96b$var$AppointmentModal;


var $9b385f9263d2489b$export$2e2bcd8739ae039 = (0, $df5780102f30f96b$export$2e2bcd8739ae039);


const { Text: $5aaadd5ad0201541$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $5aaadd5ad0201541$var$Appointment = ({ id: id, color: color, date: date, title: title, participants: participants, duration: duration, meetingId: meetingId, status: status, startDate: startDate, endDate: endDate, position: position, type: type, isExternal: isExternal, timezone: timezone, clientId: clientId, eventTypeId: eventTypeId, notes: notes, handleUpdateEvent: handleUpdateEvent, reloadEvents: reloadEvents, participantIds: participantIds })=>{
    const backgroundColor = status !== (0, $8f7fe33a44836803$export$1493eeed8bebfae9).Canceled ? color : '#eeeeee';
    return (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
        placement: position,
        title: title,
        content: (0, $bb3TF.jsx)((0, $9b385f9263d2489b$export$2e2bcd8739ae039), {
            id: id,
            date: date,
            duration: duration,
            participants: participants,
            start: new Date(startDate),
            end: new Date(endDate),
            meeting: meetingId,
            status: status,
            type: type,
            isExternal: isExternal,
            timezone: timezone,
            clientId: clientId,
            eventTypeId: eventTypeId,
            notes: notes,
            handleUpdateEvent: handleUpdateEvent,
            reloadEvents: reloadEvents,
            participantIds: participantIds
        }),
        trigger: "click",
        children: (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            style: {
                backgroundColor: backgroundColor,
                width: '100%',
                height: '100%',
                borderRadius: '5px'
            },
            align: "middle",
            children: (0, $bb3TF.jsx)($5aaadd5ad0201541$var$Text, {
                style: {
                    color: (0, $b49ec763ee1f30e3$export$f700b9e65054ed20).includes(backgroundColor) ? '#565656' : 'azure'
                },
                children: title
            })
        })
    });
};
$5aaadd5ad0201541$var$Appointment.defaultProps = {
    type: 'VIDEO',
    clientId: '',
    eventTypeId: '',
    notes: '',
    participantIds: []
};
var $5aaadd5ad0201541$export$2e2bcd8739ae039 = $5aaadd5ad0201541$var$Appointment;


var $c97c9309778c6207$export$2e2bcd8739ae039 = (0, $5aaadd5ad0201541$export$2e2bcd8739ae039);


const $2a78c89d7cfa6ac1$var$localizer = (0, $a4fe492ece4426a3$export$29814e003152ab50)((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0))));
const { Text: $2a78c89d7cfa6ac1$var$Text, Title: $2a78c89d7cfa6ac1$var$Title, Link: $2a78c89d7cfa6ac1$var$Link } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { ReloadOutlined: $2a78c89d7cfa6ac1$var$ReloadOutlined, ExclamationCircleOutlined: $2a78c89d7cfa6ac1$var$ExclamationCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $2a78c89d7cfa6ac1$var$formatEvents = (events, userId)=>events.map((event)=>{
        const starDate = new Date(event.startDate).getTime();
        const endDate = new Date(event.endDate).getTime();
        const afterBuffer = event.EventTypes.afterBuffer || 0;
        const beforeBuffer = event.EventTypes.beforeBuffer || 0;
        const clientId = event.Meetings.MeetingAttendees.find((attendee)=>attendee.userId !== userId)?.userId;
        return {
            id: event.id,
            title: event.title,
            date: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(event.startDate).format('ddd MMM DD, YYYY'),
            duration: (endDate - starDate) / 1e3 / 60,
            participants: event.Meetings.MeetingAttendees.map((attendee)=>`${attendee.firstName} ${attendee.lastName}`),
            start: new Date(starDate - beforeBuffer * (0, $5bafd68f69b44f55$export$d22e79b7850fc6d8)),
            end: new Date(endDate + afterBuffer * (0, $5bafd68f69b44f55$export$d22e79b7850fc6d8)),
            startDate: event.startDate,
            endDate: event.endDate,
            meetingId: event.Meetings.id,
            status: event.status,
            color: event.EventTypes.color,
            afterBuffer: afterBuffer,
            beforeBuffer: beforeBuffer,
            type: event.type,
            isExternal: false,
            clientId: clientId,
            eventTypeId: event.eventTypeId,
            notes: event.notes,
            participantIds: event.Meetings.MeetingAttendees.map((attendee)=>attendee.userId)
        };
    });
const $2a78c89d7cfa6ac1$var$formatNylasEvents = (events)=>events.map((event)=>({
            id: event.id,
            title: event.title,
            date: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(event.startDate).format('ddd MMM DD, YYYY'),
            duration: event.duration,
            participants: event.attendees.map((attendee)=>attendee.name && attendee.name !== attendee.email ? `${attendee.name} ${attendee.email}` : attendee.email),
            start: new Date(event.startDate),
            end: new Date(event.endDate),
            startDate: event.startDate,
            endDate: event.endDate,
            meetingId: null,
            status: event.status,
            color: event.color,
            afterBuffer: 0,
            beforeBuffer: 0,
            type: event.type,
            isExternal: true
        }));
const $2a78c89d7cfa6ac1$var$mergeCalendarEvents = (events, nylasEvents)=>{
    const filteredNylasEvents = nylasEvents.filter((nylasEvt)=>!events.some((evt)=>evt.startDate === nylasEvt.startDate && evt.endDate === nylasEvt.endDate));
    return events.concat($2a78c89d7cfa6ac1$var$formatNylasEvents(filteredNylasEvents));
};
const $2a78c89d7cfa6ac1$var$AppointmentsTable = ({ appointments: appointments, loadingAppointments: loadingAppointments, taxPayers: taxPayers, isTaxPayersLoading: isTaxPayersLoading, eventTypes: eventTypes, loadingEventTypes: loadingEventTypes, handleOnError: handleOnError })=>{
    const { userId: userId } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const [newAppointmentModalVisible, setNewAppointmentModalVisible] = (0, $6fFrj.useState)(false);
    const [newAppointmentForm] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    const [selectedDate, setSelectedDate] = (0, $6fFrj.useState)(undefined);
    const [isEventsReloading, setIsEventsReloading] = (0, $6fFrj.useState)(false);
    const [formattedEvents, setFormattedEvents] = (0, $6fFrj.useState)([]);
    const [searchParams, setSearchParams] = (0, $a6e470ffbc8d2470$export$f1a78c17382fe22a)();
    const [appointment2Update, setAppointment2Update] = (0, $6fFrj.useState)(undefined);
    const [getExternalEvents, { loading: loadingExternalEvents }] = (0, $cfef3f1bede5cb90$export$3ae5539c66ab4a4e)({
        onError: handleOnError
    });
    const handleOnSelectSlot = (selected)=>{
        setSelectedDate(new Date(selected.start));
        setNewAppointmentModalVisible(true);
        (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).MODAL_SHOW, {
            'Modal Title': 'Schedule an Appointment',
            Source: 'Click on the calendar',
            url: window.location.href
        });
    };
    const { data: firmSettingsData } = (0, $732264f53056e08f$export$1757fc42814f776a)({
        variables: {
            name: 'disable-taxaroo-calendar'
        }
    });
    const [disableTaxarooCalendarValue, setDisableTaxarooCalendarValue] = (0, $6fFrj.useState)(false);
    (0, $6fFrj.useEffect)(()=>{
        if (firmSettingsData?.getFirmSetting?.name) // eslint-disable-next-line no-underscore-dangle
        {
            if (firmSettingsData.getFirmSetting.value.__typename === 'BooleanValue') setDisableTaxarooCalendarValue(firmSettingsData.getFirmSetting.value.boolValue);
        }
    }, [
        firmSettingsData?.getFirmSetting
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (loadingAppointments === false) getExternalEvents({
            variables: {
                filters: {
                    from: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().subtract(1, 'month').startOf('day'),
                    to: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().add(1, 'month').startOf('day')
                }
            }
        }).then((events)=>{
            setFormattedEvents($2a78c89d7cfa6ac1$var$mergeCalendarEvents($2a78c89d7cfa6ac1$var$formatEvents(appointments?.MyEvents || [], userId), events.data.getExternalEvents));
        });
    }, [
        appointments
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (window.location.hash.includes('#scheduleAppointment')) setNewAppointmentModalVisible(true);
        const messageString = searchParams.get('message');
        if (messageString) (0, $55c6005cab9be059$export$2e2bcd8739ae039).success(messageString);
    }, []);
    const handleCancelModal = ()=>{
        newAppointmentForm.setFieldsValue({
            client: undefined,
            day: undefined,
            time: undefined,
            notes: undefined
        });
        setAppointment2Update(undefined);
        setNewAppointmentModalVisible(false);
    };
    const reloadEvents = async ()=>{
        setIsEventsReloading(true);
        const events = await (0, $d9c9d80f653581ac$export$2e2bcd8739ae039).refetchQueries({
            include: [
                (0, $cfef3f1bede5cb90$export$7a3b4904b0a97d55)
            ]
        });
        setFormattedEvents($2a78c89d7cfa6ac1$var$formatEvents(events[0]?.data?.MyEvents || [], userId));
        setIsEventsReloading(false);
        const externalEvents = await getExternalEvents({
            variables: {
                filters: {
                    from: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().subtract(1, 'month').startOf('day'),
                    to: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().add(1, 'month').startOf('day')
                }
            }
        });
        setFormattedEvents($2a78c89d7cfa6ac1$var$mergeCalendarEvents($2a78c89d7cfa6ac1$var$formatEvents(events[0]?.data?.MyEvents || [], userId), externalEvents?.data?.getExternalEvents));
    };
    const handleUpdateEvent = (initialUpdateValues)=>{
        setAppointment2Update(initialUpdateValues);
        setNewAppointmentModalVisible(true);
    };
    const timezone = eventTypes?.MyEventTypes?.[0].timezone || 'UTC';
    const tz = (0, $5bafd68f69b44f55$export$c3133dbc11f66777)().short;
    const resultTimeZone = tz.indexOf('+') === 0 ? `UTC${tz}` : tz;
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            disableTaxarooCalendarValue && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                style: {
                    padding: '10px 0'
                },
                children: (0, $bb3TF.jsxs)($2a78c89d7cfa6ac1$var$Text, {
                    children: [
                        (0, $bb3TF.jsx)($2a78c89d7cfa6ac1$var$ExclamationCircleOutlined, {
                            style: {
                                padding: '0 10px 0 0'
                            }
                        }),
                        "Your clients are not currently able to book appointments with you. Please",
                        ' ',
                        (0, $bb3TF.jsx)($2a78c89d7cfa6ac1$var$Link, {
                            href: "/settings/calendars",
                            children: "click here"
                        }),
                        ' ',
                        "to turn on appointments."
                    ]
                })
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                justify: "space-between",
                align: "middle",
                children: [
                    (0, $bb3TF.jsxs)($2a78c89d7cfa6ac1$var$Title, {
                        level: 3,
                        style: {
                            margin: 0
                        },
                        children: [
                            "Appointments",
                            ' ',
                            (0, $bb3TF.jsxs)($2a78c89d7cfa6ac1$var$Text, {
                                small: true,
                                children: [
                                    "(all appointments shown in\u00A0",
                                    resultTimeZone,
                                    ")"
                                ]
                            }),
                            (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                                type: "link",
                                title: "Reload Appointments",
                                size: "large",
                                onClick: reloadEvents,
                                children: (0, $bb3TF.jsx)($2a78c89d7cfa6ac1$var$ReloadOutlined, {})
                            })
                        ]
                    }),
                    (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                        type: "primary",
                        onClick: ()=>{
                            setNewAppointmentModalVisible(true);
                            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).MODAL_SHOW, {
                                'Modal Title': 'Schedule an Appointment',
                                Source: 'Click on button',
                                url: window.location.href
                            });
                        },
                        children: (0, $bb3TF.jsx)($2a78c89d7cfa6ac1$var$Text, {
                            style: {
                                color: '#fff'
                            },
                            children: "Schedule Appointment"
                        })
                    })
                ]
            }),
            loadingExternalEvents && (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: [
                    "Connected calendar events are still loading...\u00A0\u00A0\u00A0",
                    (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                        size: "small"
                    })
                ]
            }),
            loadingAppointments || isEventsReloading ? (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                align: "middle",
                justify: "center",
                children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                    size: "large"
                })
            }) : (0, $bb3TF.jsx)((0, $a4fe492ece4426a3$export$e1aef45b828286de), {
                selectable: true,
                events: formattedEvents,
                localizer: $2a78c89d7cfa6ac1$var$localizer,
                defaultDate: searchParams.get('date') || new Date(),
                defaultView: (0, $a4fe492ece4426a3$export$5cb791131c501f6a).WEEK,
                onSelectSlot: handleOnSelectSlot,
                components: {
                    event: ({ event: event })=>(0, $bb3TF.jsx)((0, $c97c9309778c6207$export$2e2bcd8739ae039), {
                            ...event,
                            timezone: timezone,
                            handleUpdateEvent: handleUpdateEvent,
                            position: "right",
                            reloadEvents: reloadEvents
                        }),
                    day: {
                        event: ({ event: event })=>(0, $bb3TF.jsx)((0, $c97c9309778c6207$export$2e2bcd8739ae039), {
                                ...event,
                                timezone: timezone,
                                handleUpdateEvent: handleUpdateEvent,
                                position: "bottom",
                                reloadEvents: reloadEvents
                            })
                    },
                    agenda: {
                        event: ({ event: event })=>(0, $bb3TF.jsx)((0, $c97c9309778c6207$export$2e2bcd8739ae039), {
                                ...event,
                                timezone: timezone,
                                handleUpdateEvent: handleUpdateEvent,
                                position: "bottom",
                                reloadEvents: reloadEvents
                            })
                    },
                    toolbar: (0, $cb4940684e1fa37b$export$2e2bcd8739ae039)
                },
                style: {
                    width: '100%',
                    marginTop: 25,
                    minHeight: '100vh'
                },
                className: "appointments-calendar"
            }),
            (0, $bb3TF.jsx)((0, $61cd47ffc08acebb$export$2e2bcd8739ae039), {
                visible: newAppointmentModalVisible,
                clients: taxPayers?.getClientsBasicInfo?.slice().sort((a, b)=>{
                    const aName = `${a.Entity.Users.UserInformation?.firstName} ${a.Entity.Users.UserInformation?.lastName}`;
                    const bName = `${b.Entity.Users.UserInformation?.firstName} ${b.Entity.Users.UserInformation?.lastName}`;
                    if (aName > bName) return 1;
                    if (aName < bName) return -1;
                    return 0;
                }) || [],
                handleCancel: handleCancelModal,
                isTaxPayersLoading: isTaxPayersLoading,
                eventTypes: eventTypes?.MyEventTypes.filter((et)=>et.active) || [],
                loadingEventTypes: loadingEventTypes,
                newAppointmentForm: newAppointmentForm,
                selectedDate: selectedDate,
                events: formattedEvents,
                appointment2Update: appointment2Update,
                reloadEvents: reloadEvents
            })
        ]
    });
};
var $2a78c89d7cfa6ac1$export$2e2bcd8739ae039 = $2a78c89d7cfa6ac1$var$AppointmentsTable;


var $48572c464b894d03$export$2e2bcd8739ae039 = (0, $2a78c89d7cfa6ac1$export$2e2bcd8739ae039);


const { Text: $9a9b2fddb65d4826$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { CalendarOutlined: $9a9b2fddb65d4826$var$CalendarOutlined, CalendarFilled: $9a9b2fddb65d4826$var$CalendarFilled } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { TabPane: $9a9b2fddb65d4826$var$TabPane } = (0, $5024ed5b7bb39672$export$2e2bcd8739ae039);
const $9a9b2fddb65d4826$var$Appointments = ()=>{
    const handleOnError = (error)=>{
        if (error.graphQLErrors) {
            const graphQLError = error.graphQLErrors[0];
            if (graphQLError.message.indexOf('Foreign key constraint failed') !== -1) return (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('This appointment type has been used by active appointments. You cannot delete this appointment type but you can deactivate it on the page.');
        }
        return (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`An error has occurred: ${error.message}.`);
    };
    const { data: events, loading: loadingEvents, error: myEventsError } = (0, $cfef3f1bede5cb90$export$b6cccab7e21ecbba)();
    const { data: eventTypes, loading: loadingEventTypes, error: myEventTypesError } = (0, $cfef3f1bede5cb90$export$10d6da411e25606d)({
        variables: {
            timezone: (0, $5bafd68f69b44f55$export$c3133dbc11f66777)().large
        }
    });
    const { data: clientsData, loading: clientsDataLoading, error: clientsDataLoadingError } = (0, $732264f53056e08f$export$e12e433ec87b87e7)();
    const [createEventTypeMutation, { loading: createEventTypeLoading }] = (0, $a86ee2eea1b8cff6$export$105ce66260a3f2ce)({
        onError: handleOnError,
        refetchQueries: [
            (0, $cfef3f1bede5cb90$export$e81e1ebd88764b74)
        ],
        awaitRefetchQueries: true
    });
    const [updateEventTypeMutation, { loading: updateEventTypeLoading }] = (0, $a86ee2eea1b8cff6$export$c3c94773abc40b0f)({
        onError: handleOnError,
        refetchQueries: [
            (0, $cfef3f1bede5cb90$export$e81e1ebd88764b74)
        ],
        awaitRefetchQueries: true
    });
    (0, $6fFrj.useEffect)(()=>{
        if (myEventTypesError) return handleOnError(myEventTypesError);
        if (clientsDataLoadingError) return handleOnError(clientsDataLoadingError);
        if (myEventsError) return handleOnError(myEventsError);
        return null;
    }, [
        myEventTypesError,
        clientsDataLoadingError,
        myEventsError
    ]);
    const handleClickTab = (key)=>{
        (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).TAB_SELECT, {
            'Tab Description': 'Appointments',
            'Tab Selected': key === '1' ? 'Appointments' : 'Appointment Types',
            url: window.location.href
        });
    };
    const { showModal: showModal, hideModal: hideModal, accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    if (accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).appointments] === false) showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).appointments, false);
    else hideModal();
    return (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
            span: 24,
            children: (0, $bb3TF.jsxs)((0, $5024ed5b7bb39672$export$2e2bcd8739ae039), {
                type: "card",
                onTabClick: handleClickTab,
                children: [
                    (0, $bb3TF.jsx)($9a9b2fddb65d4826$var$TabPane, {
                        tab: (0, $bb3TF.jsxs)($9a9b2fddb65d4826$var$Text, {
                            children: [
                                (0, $bb3TF.jsx)($9a9b2fddb65d4826$var$CalendarFilled, {}),
                                "Appointments"
                            ]
                        }),
                        children: (0, $bb3TF.jsx)((0, $48572c464b894d03$export$2e2bcd8739ae039), {
                            appointments: events,
                            loadingAppointments: loadingEvents,
                            taxPayers: clientsData,
                            isTaxPayersLoading: clientsDataLoading,
                            eventTypes: eventTypes,
                            loadingEventTypes: loadingEventTypes,
                            handleOnError: handleOnError
                        })
                    }, "1"),
                    (0, $bb3TF.jsx)($9a9b2fddb65d4826$var$TabPane, {
                        tab: (0, $bb3TF.jsxs)($9a9b2fddb65d4826$var$Text, {
                            children: [
                                (0, $bb3TF.jsx)($9a9b2fddb65d4826$var$CalendarOutlined, {}),
                                "Appointment Types"
                            ]
                        }),
                        children: (0, $bb3TF.jsx)((0, $94114d1655f3579a$export$2e2bcd8739ae039), {
                            eventTypes: eventTypes,
                            loadingEventTypes: loadingEventTypes,
                            createEventTypeMutation: createEventTypeMutation,
                            createEventTypeLoading: createEventTypeLoading,
                            handleOnError: handleOnError,
                            updateEventTypeMutation: updateEventTypeMutation,
                            updateEventTypeLoading: updateEventTypeLoading
                        })
                    }, "2")
                ]
            })
        })
    });
};
var $9a9b2fddb65d4826$export$2e2bcd8739ae039 = $9a9b2fddb65d4826$var$Appointments;


var $70e52ac512f25943$export$2e2bcd8739ae039 = (0, $9a9b2fddb65d4826$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");

var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

var $bb3TF = parcelRequire("bb3TF");


var $6fFrj = parcelRequire("6fFrj");



var $56338cf109ce68e7$exports = {};
var $09c9bfdf7fdbe0c5$exports = {};
function $09c9bfdf7fdbe0c5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$09c9bfdf7fdbe0c5$exports = $09c9bfdf7fdbe0c5$var$_arrayWithHoles, $09c9bfdf7fdbe0c5$exports.__esModule = true, $09c9bfdf7fdbe0c5$exports["default"] = $09c9bfdf7fdbe0c5$exports;


var $27223ea02a6fe03d$exports = {};
function $27223ea02a6fe03d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$27223ea02a6fe03d$exports = $27223ea02a6fe03d$var$_iterableToArrayLimit, $27223ea02a6fe03d$exports.__esModule = true, $27223ea02a6fe03d$exports["default"] = $27223ea02a6fe03d$exports;


var $9b64261711023eff$exports = {};
var $603486f87d815783$exports = {};
function $603486f87d815783$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$603486f87d815783$exports = $603486f87d815783$var$_arrayLikeToArray, $603486f87d815783$exports.__esModule = true, $603486f87d815783$exports["default"] = $603486f87d815783$exports;


function $9b64261711023eff$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $603486f87d815783$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $603486f87d815783$exports(o, minLen);
}
$9b64261711023eff$exports = $9b64261711023eff$var$_unsupportedIterableToArray, $9b64261711023eff$exports.__esModule = true, $9b64261711023eff$exports["default"] = $9b64261711023eff$exports;


var $aa80c2062c86d238$exports = {};
function $aa80c2062c86d238$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$aa80c2062c86d238$exports = $aa80c2062c86d238$var$_nonIterableRest, $aa80c2062c86d238$exports.__esModule = true, $aa80c2062c86d238$exports["default"] = $aa80c2062c86d238$exports;


function $56338cf109ce68e7$var$_slicedToArray(arr, i) {
    return $09c9bfdf7fdbe0c5$exports(arr) || $27223ea02a6fe03d$exports(arr, i) || $9b64261711023eff$exports(arr, i) || $aa80c2062c86d238$exports();
}
$56338cf109ce68e7$exports = $56338cf109ce68e7$var$_slicedToArray, $56338cf109ce68e7$exports.__esModule = true, $56338cf109ce68e7$exports["default"] = $56338cf109ce68e7$exports;



var $fWb4i = parcelRequire("fWb4i");

var $6fFrj = parcelRequire("6fFrj");
var $dcaf774d05a9aa7c$exports = {};
function $dcaf774d05a9aa7c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$dcaf774d05a9aa7c$exports = $dcaf774d05a9aa7c$var$_classCallCheck, $dcaf774d05a9aa7c$exports.__esModule = true, $dcaf774d05a9aa7c$exports["default"] = $dcaf774d05a9aa7c$exports;


var $32463816393cb059$exports = {};

var $32V8e = parcelRequire("32V8e");
function $32463816393cb059$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $32V8e(descriptor.key), descriptor);
    }
}
function $32463816393cb059$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $32463816393cb059$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $32463816393cb059$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$32463816393cb059$exports = $32463816393cb059$var$_createClass, $32463816393cb059$exports.__esModule = true, $32463816393cb059$exports["default"] = $32463816393cb059$exports;



var $fWb4i = parcelRequire("fWb4i");

var $6fFrj = parcelRequire("6fFrj");
var $f3b14ec0db9d4064$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $f3b14ec0db9d4064$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
var $f3b14ec0db9d4064$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $f3b14ec0db9d4064$var$htmlEntities[m];
};
var $f3b14ec0db9d4064$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($f3b14ec0db9d4064$var$matchHtmlEntity, $f3b14ec0db9d4064$var$unescapeHtmlEntity);
};


function $3b1a0d944fd02b49$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3b1a0d944fd02b49$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $3b1a0d944fd02b49$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fWb4i)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $3b1a0d944fd02b49$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $3b1a0d944fd02b49$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: (0, $f3b14ec0db9d4064$export$e8bacd2802a88316)
};
var $3b1a0d944fd02b49$var$i18nInstance;
var $3b1a0d944fd02b49$export$5603ab5ced17ce64 = (0, $6fFrj.createContext)();
function $3b1a0d944fd02b49$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $3b1a0d944fd02b49$var$defaultOptions = $3b1a0d944fd02b49$var$_objectSpread($3b1a0d944fd02b49$var$_objectSpread({}, $3b1a0d944fd02b49$var$defaultOptions), options);
}
function $3b1a0d944fd02b49$export$212bb2fc580a90a8() {
    return $3b1a0d944fd02b49$var$defaultOptions;
}
var $3b1a0d944fd02b49$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dcaf774d05a9aa7c$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($32463816393cb059$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $3b1a0d944fd02b49$export$a039134f2fc7e0(instance) {
    $3b1a0d944fd02b49$var$i18nInstance = instance;
}
function $3b1a0d944fd02b49$export$64af334f494c2f47() {
    return $3b1a0d944fd02b49$var$i18nInstance;
}
var $3b1a0d944fd02b49$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init: function init(instance) {
        $3b1a0d944fd02b49$export$2e2366488d12e20d(instance.options.react);
        $3b1a0d944fd02b49$export$a039134f2fc7e0(instance);
    }
};
function $3b1a0d944fd02b49$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $3b1a0d944fd02b49$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($3b1a0d944fd02b49$var$_objectSpread($3b1a0d944fd02b49$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $3b1a0d944fd02b49$export$704200e5d0b9e8f() {
    var i18n = $3b1a0d944fd02b49$export$64af334f494c2f47();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $9b0092c782b447fd$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $9b0092c782b447fd$var$alreadyWarned = {};
function $9b0092c782b447fd$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === 'string' && $9b0092c782b447fd$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === 'string') $9b0092c782b447fd$var$alreadyWarned[args[0]] = new Date();
    $9b0092c782b447fd$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $9b0092c782b447fd$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    });
}
function $9b0092c782b447fd$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $9b0092c782b447fd$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $9b0092c782b447fd$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $9b0092c782b447fd$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $9b0092c782b447fd$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}


function $e3ea6dd032e45947$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e3ea6dd032e45947$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e3ea6dd032e45947$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fWb4i)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e3ea6dd032e45947$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $e3ea6dd032e45947$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $6fFrj.useRef)();
    (0, $6fFrj.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $e3ea6dd032e45947$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $6fFrj.useContext)((0, $3b1a0d944fd02b49$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $3b1a0d944fd02b49$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $3b1a0d944fd02b49$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $9b0092c782b447fd$export$5b28268982f175ba)('You will need to pass in an i18next instance by using initReactI18next');
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $9b0092c782b447fd$export$5b28268982f175ba)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    var i18nOptions = $e3ea6dd032e45947$var$_objectSpread($e3ea6dd032e45947$var$_objectSpread($e3ea6dd032e45947$var$_objectSpread({}, (0, $3b1a0d944fd02b49$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $9b0092c782b447fd$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $6fFrj.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($56338cf109ce68e7$exports)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    var previousJoinedNS = $e3ea6dd032e45947$var$usePrevious(joinedNS);
    var isMounted = (0, $6fFrj.useRef)(true);
    (0, $6fFrj.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $9b0092c782b447fd$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $6fFrj.useRef)(true);
    (0, $6fFrj.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $9b0092c782b447fd$export$83be934b53fff43b)(i18n, namespaces, function() {
            resolve();
        });
    });
}




var $6fFrj = parcelRequire("6fFrj");






/* eslint-disable */ 
const $004ffcb7bb39d082$var$notify = (title, body)=>{
    const img = (parcelRequire("fk9rV"));
    // Let's check if the browser supports notifications
    if (!('Notification' in window)) console.log('This browser does not support desktop notification');
    else if (Notification.permission === 'granted') // If it's okay let's create a notification
    new Notification(title, {
        body: body,
        icon: img
    });
    else if (Notification.permission !== 'denied') Notification.requestPermission().then((permission)=>{
        // If the user accepts, let's create a notification
        if (permission === 'granted') new Notification(title, {
            body: body,
            icon: img
        });
    });
};
var $004ffcb7bb39d082$export$2e2bcd8739ae039 = $004ffcb7bb39d082$var$notify;



const $0dff5878e5b80cbb$var$UseChannels = (fetchChannels)=>{
    // * REDUX DATA
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const currentChannels = (0, $58073eff19365823$export$a7347740d65f620b)((0, $66a7cecdd31d321f$export$2656785094d54bbd)).filter((channel)=>channel.ChannelMembers.length > 1); // * Remove channels with only one member
    const currentChannel = (0, $58073eff19365823$export$a7347740d65f620b)((0, $66a7cecdd31d321f$export$64113a45e478f19d));
    const messages = (0, $58073eff19365823$export$a7347740d65f620b)((0, $66a7cecdd31d321f$export$3230350281d85b62));
    const { accessToken: token, userId: userId } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$ca779d385d6ad982));
    // * LOCAL STATE DATA
    const pusher = new (0, $8e6a5083674a4148$export$beef90f2411195d8)(token);
    const [getChannels, { loading: loadingChannels, fetchMore: fetchMoreChannels }] = (0, $f442d9dc730cd5f3$export$16b3d246f02b0323)();
    const currentChannelRef = (0, $6fFrj.useRef)(currentChannel);
    const [updateMessage] = (0, $4cdb1470f9874f96$export$ae0ec3e4f3d8ee68)();
    const currentChannelsRef = (0, $6fFrj.useRef)(currentChannels);
    const messagesRef = (0, $6fFrj.useRef)(messages);
    const [loadingMoreMessages, setLoadingMoreMessages] = (0, $6fFrj.useState)(false);
    const [getChannelMessages] = (0, $f442d9dc730cd5f3$export$1dd0ad8ddf0e0222)();
    const getMoreMessages = async (channelId, take, skip)=>{
        setLoadingMoreMessages(true);
        const { data: data } = await getChannelMessages({
            fetchPolicy: 'network-only',
            variables: {
                channelId: channelId,
                take: take || 10,
                skip: skip || messagesRef.current[channelId]?.length || 0
            },
            onError: (err)=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message);
            }
        });
        const fetchedMessages = data?.getChannelMessages;
        dispatch((0, $66a7cecdd31d321f$export$e8c6a0d7313851e)({
            channelId: channelId,
            messages: fetchedMessages
        }));
        setLoadingMoreMessages(false);
    };
    const addMessage = async (message)=>{
        if (currentChannelRef.current && currentChannelRef.current.id === message.channelId) {
            let newMessageData = {
                ...message
            };
            if (message.userId !== userId) {
                const updatedMessage = (await updateMessage({
                    variables: {
                        updateMessageInput: {
                            id: message.id,
                            readDate: new Date()
                        }
                    }
                })).data?.updateMessage;
                newMessageData = {
                    ...updatedMessage
                };
            }
            dispatch((0, $66a7cecdd31d321f$export$e8c6a0d7313851e)({
                channelId: message.channelId,
                messages: [
                    newMessageData
                ]
            }));
        } else {
            const channelTarget = currentChannelsRef.current.find(({ id: id })=>id === message.channelId);
            if (channelTarget) dispatch((0, $66a7cecdd31d321f$export$e8c6a0d7313851e)({
                channelId: message.channelId,
                messages: [
                    message
                ]
            }));
        }
    };
    const onMessage = (message)=>{
        // console.log("onMessage", message);
        addMessage(message);
    };
    // const onStatusChange = async (id: string, newStatus: boolean, memberUserId: string) => {
    //   const channelTarget = currentChannelsRef.current?.find(({ id: currentId }) => currentId === id);
    //   if (channelTarget) {
    //     if (currentChannelRef.current && channelTarget.id === currentChannelRef.current.id) {
    //       dispatch(setSelectedChannel({
    //         ...currentChannelRef.current,
    //         status: newStatus,
    //       }));
    //     }
    //     const updatedChannel = {
    //       ...channelTarget,
    //       status: newStatus,
    //     };
    //     dispatch(setChannels(currentChannelsRef.current.map((channel) => {
    //       if (channel.id === updatedChannel.id) {
    //         return updatedChannel;
    //       }
    //       return channel;
    //     })));
    //   }
    // };
    const addChannel = (newChannel, setSelected = false)=>{
        if (!currentChannelsRef.current.find(({ id: id })=>id === newChannel.id)) dispatch((0, $66a7cecdd31d321f$export$a142660abc388412)([
            newChannel,
            ...currentChannelsRef.current
        ]));
        if (setSelected) dispatch((0, $66a7cecdd31d321f$export$705c7bcc3db528a6)({
            ...newChannel,
            online: false
        }));
    };
    // const attachToChannelsPusher = async (channels: ChannelEntity[]) => {
    //   const wait = 10000;
    //   // eslint-disable-next-line no-restricted-syntax
    //   for (const ch of channels) {
    //     addChannel(ch);
    //     // eslint-disable-next-line
    //     await new Promise((resolve) => setTimeout(resolve, wait));
    //   }
    // };
    (0, $6fFrj.useEffect)(()=>{
        currentChannelsRef.current = currentChannels;
    }, [
        currentChannels
    ]);
    (0, $6fFrj.useEffect)(()=>{
        currentChannelRef.current = currentChannel;
    }, [
        currentChannel
    ]);
    (0, $6fFrj.useEffect)(()=>{
        messagesRef.current = messages;
    }, [
        messages
    ]);
    (0, $6fFrj.useEffect)(()=>{
        // * Subscribe to corresponding channel
        let channel = pusher.channel(`presence-${userId}`);
        if (!channel) {
            // const onMemberAddedHandler = (member: { id: string, info: { email: string } }) => {
            //   // onStatusChange(newChannel.id, true, member.id);
            // };
            // const onMemberRemovedHandler = (member: { id: string, info: { email: string } }) => {
            //   // onStatusChange(newChannel.id, false, member.id);
            // };
            channel = pusher.subscribe(`presence-${userId}`);
            channel.bind('chat', (message)=>{
                const { text: text, Users: Users, userId: messageUserId } = message;
                const { firstName: firstName, lastName: lastName } = Users.UserInformation;
                if (messageUserId !== userId) (0, $004ffcb7bb39d082$export$2e2bcd8739ae039)(`${firstName} ${lastName}`, text);
                onMessage(message);
            });
            // channel.bind('pusher:member_added', onMemberAddedHandler);
            // channel.bind('pusher:member_removed', onMemberRemovedHandler);
            // channel.bind('pusher:subscription_succeeded', (member: { id: string, info: { email: string } }) => {
            //   // if (channel.members.count > 1) {
            //   //   onStatusChange(newChannel.id, true, member.id);
            //   // }
            // });
            channel.bind('pusher:subscription_error', (error)=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to connect the chat');
                // eslint-disable-next-line no-console
                console.log({
                    error: error
                });
            });
        }
        window.addEventListener('beforeunload', ()=>{
            if (pusher.connection.state === 'connected') pusher.disconnect();
        });
        if (pusher.connection.state === 'disconnected') pusher.connect();
        if (fetchChannels && currentChannels.length === 0) getChannels({
            variables: {
                searchWord: '',
                take: 10,
                skip: 0
            }
        }).then(({ data: data })=>{
            dispatch((0, $66a7cecdd31d321f$export$a142660abc388412)(data.userChannels));
            // attachToChannelsPusher(data.userChannels);
            // eslint-disable-next-line no-restricted-syntax
            for (const chnl of data.userChannels)// if there are no currently fetched messages in the messages store, store any messages fetched with the getChannels query (usually 1 message)
            if (!messagesRef?.current?.[chnl.id] || messagesRef?.current?.[chnl.id]?.length === 0) dispatch((0, $66a7cecdd31d321f$export$e8c6a0d7313851e)({
                channelId: chnl.id,
                messages: chnl.Messages
            }));
        }).catch((err)=>console.log('Fetch user channels error', err));
    }, []);
    const getMoreChannels = async ()=>{
        const { data: data } = await fetchMoreChannels({
            variables: {
                skip: Object.keys(currentChannelsRef.current).length ?? 0
            }
        });
        const fetchedChannels = data?.userChannels;
        if (fetchedChannels && fetchedChannels.length > 0) dispatch((0, $66a7cecdd31d321f$export$49eea2bdf1db9fe4)(fetchedChannels));
    };
    return {
        addChannel: addChannel,
        getMoreMessages: getMoreMessages,
        loadingMoreMessages: loadingMoreMessages,
        currentChannel: currentChannel,
        loadingChannels: loadingChannels,
        channels: currentChannels,
        messages: messages,
        getMoreChannels: getMoreChannels
    };
};
var $0dff5878e5b80cbb$export$2e2bcd8739ae039 = $0dff5878e5b80cbb$var$UseChannels;




var $bb3TF = parcelRequire("bb3TF");
var $65cc38728230d7d0$exports = {};

$65cc38728230d7d0$exports = (parcelRequire("jN93C")).getBundleURL('a0IFD') + "empty.e5bcf0dc.png";


var $3a07ccafc12000cd$export$2393dc7659ef7e02;
var $3a07ccafc12000cd$export$56b540b46a5d7097;
var $3a07ccafc12000cd$export$3c17b0e969a90510;
var $3a07ccafc12000cd$export$fb184b623420d9be;
$3a07ccafc12000cd$export$2393dc7659ef7e02 = `ZdR3vW_emptyChatContainer`;
$3a07ccafc12000cd$export$56b540b46a5d7097 = `ZdR3vW_emptyChatContent`;
$3a07ccafc12000cd$export$3c17b0e969a90510 = `ZdR3vW_small`;
$3a07ccafc12000cd$export$fb184b623420d9be = `ZdR3vW_title`;


function $e6674a76e6c92256$var$EmptyState() {
    return (0, $bb3TF.jsx)("div", {
        className: $3a07ccafc12000cd$export$2393dc7659ef7e02,
        children: (0, $bb3TF.jsxs)("div", {
            className: $3a07ccafc12000cd$export$56b540b46a5d7097,
            children: [
                (0, $bb3TF.jsx)("img", {
                    alt: "No Conversations Yet",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($65cc38728230d7d0$exports)))
                }),
                (0, $bb3TF.jsx)("p", {
                    className: $3a07ccafc12000cd$export$fb184b623420d9be,
                    children: "No Conversations Yet"
                })
            ]
        })
    });
}
var $e6674a76e6c92256$export$2e2bcd8739ae039 = $e6674a76e6c92256$var$EmptyState;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



var $f38df6b76ce15393$exports = {};
$f38df6b76ce15393$exports = JSON.parse('{"compressed":true,"categories":[{"id":"people","name":"Smileys & People","emojis":["grinning","smiley","smile","grin","laughing","sweat_smile","rolling_on_the_floor_laughing","joy","slightly_smiling_face","upside_down_face","wink","blush","innocent","smiling_face_with_3_hearts","heart_eyes","star-struck","kissing_heart","kissing","relaxed","kissing_closed_eyes","kissing_smiling_eyes","yum","stuck_out_tongue","stuck_out_tongue_winking_eye","zany_face","stuck_out_tongue_closed_eyes","money_mouth_face","hugging_face","face_with_hand_over_mouth","shushing_face","thinking_face","zipper_mouth_face","face_with_raised_eyebrow","neutral_face","expressionless","no_mouth","smirk","unamused","face_with_rolling_eyes","grimacing","lying_face","relieved","pensive","sleepy","drooling_face","sleeping","mask","face_with_thermometer","face_with_head_bandage","nauseated_face","face_vomiting","sneezing_face","hot_face","cold_face","woozy_face","dizzy_face","exploding_head","face_with_cowboy_hat","partying_face","sunglasses","nerd_face","face_with_monocle","confused","worried","slightly_frowning_face","white_frowning_face","open_mouth","hushed","astonished","flushed","pleading_face","frowning","anguished","fearful","cold_sweat","disappointed_relieved","cry","sob","scream","confounded","persevere","disappointed","sweat","weary","tired_face","yawning_face","triumph","rage","angry","face_with_symbols_on_mouth","smiling_imp","imp","skull","skull_and_crossbones","hankey","clown_face","japanese_ogre","japanese_goblin","ghost","alien","space_invader","robot_face","smiley_cat","smile_cat","joy_cat","heart_eyes_cat","smirk_cat","kissing_cat","scream_cat","crying_cat_face","pouting_cat","see_no_evil","hear_no_evil","speak_no_evil","wave","raised_back_of_hand","raised_hand_with_fingers_splayed","hand","spock-hand","ok_hand","pinching_hand","v","crossed_fingers","i_love_you_hand_sign","the_horns","call_me_hand","point_left","point_right","point_up_2","middle_finger","point_down","point_up","+1","-1","fist","facepunch","left-facing_fist","right-facing_fist","clap","raised_hands","open_hands","palms_up_together","handshake","pray","writing_hand","nail_care","selfie","muscle","mechanical_arm","mechanical_leg","leg","foot","ear","ear_with_hearing_aid","nose","brain","tooth","bone","eyes","eye","tongue","lips","baby","child","boy","girl","adult","person_with_blond_hair","man","bearded_person","red_haired_man","curly_haired_man","white_haired_man","bald_man","woman","red_haired_woman","red_haired_person","curly_haired_woman","curly_haired_person","white_haired_woman","white_haired_person","bald_woman","bald_person","blond-haired-woman","blond-haired-man","older_adult","older_man","older_woman","person_frowning","man-frowning","woman-frowning","person_with_pouting_face","man-pouting","woman-pouting","no_good","man-gesturing-no","woman-gesturing-no","ok_woman","man-gesturing-ok","woman-gesturing-ok","information_desk_person","man-tipping-hand","woman-tipping-hand","raising_hand","man-raising-hand","woman-raising-hand","deaf_person","deaf_man","deaf_woman","bow","man-bowing","woman-bowing","face_palm","man-facepalming","woman-facepalming","shrug","man-shrugging","woman-shrugging","health_worker","male-doctor","female-doctor","student","male-student","female-student","teacher","male-teacher","female-teacher","judge","male-judge","female-judge","farmer","male-farmer","female-farmer","cook","male-cook","female-cook","mechanic","male-mechanic","female-mechanic","factory_worker","male-factory-worker","female-factory-worker","office_worker","male-office-worker","female-office-worker","scientist","male-scientist","female-scientist","technologist","male-technologist","female-technologist","singer","male-singer","female-singer","artist","male-artist","female-artist","pilot","male-pilot","female-pilot","astronaut","male-astronaut","female-astronaut","firefighter","male-firefighter","female-firefighter","cop","male-police-officer","female-police-officer","sleuth_or_spy","male-detective","female-detective","guardsman","male-guard","female-guard","construction_worker","male-construction-worker","female-construction-worker","prince","princess","man_with_turban","man-wearing-turban","woman-wearing-turban","man_with_gua_pi_mao","person_with_headscarf","man_in_tuxedo","bride_with_veil","pregnant_woman","breast-feeding","angel","santa","mrs_claus","superhero","male_superhero","female_superhero","supervillain","male_supervillain","female_supervillain","mage","male_mage","female_mage","fairy","male_fairy","female_fairy","vampire","male_vampire","female_vampire","merperson","merman","mermaid","elf","male_elf","female_elf","genie","male_genie","female_genie","zombie","male_zombie","female_zombie","massage","man-getting-massage","woman-getting-massage","haircut","man-getting-haircut","woman-getting-haircut","walking","man-walking","woman-walking","standing_person","man_standing","woman_standing","kneeling_person","man_kneeling","woman_kneeling","person_with_probing_cane","man_with_probing_cane","woman_with_probing_cane","person_in_motorized_wheelchair","man_in_motorized_wheelchair","woman_in_motorized_wheelchair","person_in_manual_wheelchair","man_in_manual_wheelchair","woman_in_manual_wheelchair","runner","man-running","woman-running","dancer","man_dancing","man_in_business_suit_levitating","dancers","man-with-bunny-ears-partying","woman-with-bunny-ears-partying","person_in_steamy_room","man_in_steamy_room","woman_in_steamy_room","person_climbing","man_climbing","woman_climbing","fencer","horse_racing","skier","snowboarder","golfer","man-golfing","woman-golfing","surfer","man-surfing","woman-surfing","rowboat","man-rowing-boat","woman-rowing-boat","swimmer","man-swimming","woman-swimming","person_with_ball","man-bouncing-ball","woman-bouncing-ball","weight_lifter","man-lifting-weights","woman-lifting-weights","bicyclist","man-biking","woman-biking","mountain_bicyclist","man-mountain-biking","woman-mountain-biking","person_doing_cartwheel","man-cartwheeling","woman-cartwheeling","wrestlers","man-wrestling","woman-wrestling","water_polo","man-playing-water-polo","woman-playing-water-polo","handball","man-playing-handball","woman-playing-handball","juggling","man-juggling","woman-juggling","person_in_lotus_position","man_in_lotus_position","woman_in_lotus_position","bath","sleeping_accommodation","people_holding_hands","two_women_holding_hands","couple","two_men_holding_hands","couplekiss","woman-kiss-man","man-kiss-man","woman-kiss-woman","couple_with_heart","woman-heart-man","man-heart-man","woman-heart-woman","family","man-woman-boy","man-woman-girl","man-woman-girl-boy","man-woman-boy-boy","man-woman-girl-girl","man-man-boy","man-man-girl","man-man-girl-boy","man-man-boy-boy","man-man-girl-girl","woman-woman-boy","woman-woman-girl","woman-woman-girl-boy","woman-woman-boy-boy","woman-woman-girl-girl","man-boy","man-boy-boy","man-girl","man-girl-boy","man-girl-girl","woman-boy","woman-boy-boy","woman-girl","woman-girl-boy","woman-girl-girl","speaking_head_in_silhouette","bust_in_silhouette","busts_in_silhouette","footprints","kiss","love_letter","cupid","gift_heart","sparkling_heart","heartpulse","heartbeat","revolving_hearts","two_hearts","heart_decoration","heavy_heart_exclamation_mark_ornament","broken_heart","heart","orange_heart","yellow_heart","green_heart","blue_heart","purple_heart","brown_heart","black_heart","white_heart","100","anger","boom","dizzy","sweat_drops","dash","hole","bomb","speech_balloon","eye-in-speech-bubble","left_speech_bubble","right_anger_bubble","thought_balloon","zzz"]},{"id":"nature","name":"Animals & Nature","emojis":["monkey_face","monkey","gorilla","orangutan","dog","dog2","guide_dog","service_dog","poodle","wolf","fox_face","raccoon","cat","cat2","lion_face","tiger","tiger2","leopard","horse","racehorse","unicorn_face","zebra_face","deer","cow","ox","water_buffalo","cow2","pig","pig2","boar","pig_nose","ram","sheep","goat","dromedary_camel","camel","llama","giraffe_face","elephant","rhinoceros","hippopotamus","mouse","mouse2","rat","hamster","rabbit","rabbit2","chipmunk","hedgehog","bat","bear","koala","panda_face","sloth","otter","skunk","kangaroo","badger","feet","turkey","chicken","rooster","hatching_chick","baby_chick","hatched_chick","bird","penguin","dove_of_peace","eagle","duck","swan","owl","flamingo","peacock","parrot","frog","crocodile","turtle","lizard","snake","dragon_face","dragon","sauropod","t-rex","whale","whale2","dolphin","fish","tropical_fish","blowfish","shark","octopus","shell","snail","butterfly","bug","ant","bee","beetle","cricket","spider","spider_web","scorpion","mosquito","microbe","bouquet","cherry_blossom","white_flower","rosette","rose","wilted_flower","hibiscus","sunflower","blossom","tulip","seedling","evergreen_tree","deciduous_tree","palm_tree","cactus","ear_of_rice","herb","shamrock","four_leaf_clover","maple_leaf","fallen_leaf","leaves"]},{"id":"foods","name":"Food & Drink","emojis":["grapes","melon","watermelon","tangerine","lemon","banana","pineapple","mango","apple","green_apple","pear","peach","cherries","strawberry","kiwifruit","tomato","coconut","avocado","eggplant","potato","carrot","corn","hot_pepper","cucumber","leafy_green","broccoli","garlic","onion","mushroom","peanuts","chestnut","bread","croissant","baguette_bread","pretzel","bagel","pancakes","waffle","cheese_wedge","meat_on_bone","poultry_leg","cut_of_meat","bacon","hamburger","fries","pizza","hotdog","sandwich","taco","burrito","stuffed_flatbread","falafel","egg","fried_egg","shallow_pan_of_food","stew","bowl_with_spoon","green_salad","popcorn","butter","salt","canned_food","bento","rice_cracker","rice_ball","rice","curry","ramen","spaghetti","sweet_potato","oden","sushi","fried_shrimp","fish_cake","moon_cake","dango","dumpling","fortune_cookie","takeout_box","crab","lobster","shrimp","squid","oyster","icecream","shaved_ice","ice_cream","doughnut","cookie","birthday","cake","cupcake","pie","chocolate_bar","candy","lollipop","custard","honey_pot","baby_bottle","glass_of_milk","coffee","tea","sake","champagne","wine_glass","cocktail","tropical_drink","beer","beers","clinking_glasses","tumbler_glass","cup_with_straw","beverage_box","mate_drink","ice_cube","chopsticks","knife_fork_plate","fork_and_knife","spoon","hocho","amphora"]},{"id":"activity","name":"Activities","emojis":["jack_o_lantern","christmas_tree","fireworks","sparkler","firecracker","sparkles","balloon","tada","confetti_ball","tanabata_tree","bamboo","dolls","flags","wind_chime","rice_scene","red_envelope","ribbon","gift","reminder_ribbon","admission_tickets","ticket","medal","trophy","sports_medal","first_place_medal","second_place_medal","third_place_medal","soccer","baseball","softball","basketball","volleyball","football","rugby_football","tennis","flying_disc","bowling","cricket_bat_and_ball","field_hockey_stick_and_ball","ice_hockey_stick_and_puck","lacrosse","table_tennis_paddle_and_ball","badminton_racquet_and_shuttlecock","boxing_glove","martial_arts_uniform","goal_net","golf","ice_skate","fishing_pole_and_fish","diving_mask","running_shirt_with_sash","ski","sled","curling_stone","dart","yo-yo","kite","8ball","crystal_ball","nazar_amulet","video_game","joystick","slot_machine","game_die","jigsaw","teddy_bear","spades","hearts","diamonds","clubs","chess_pawn","black_joker","mahjong","flower_playing_cards","performing_arts","frame_with_picture","art","thread","yarn"]},{"id":"places","name":"Travel & Places","emojis":["earth_africa","earth_americas","earth_asia","globe_with_meridians","world_map","japan","compass","snow_capped_mountain","mountain","volcano","mount_fuji","camping","beach_with_umbrella","desert","desert_island","national_park","stadium","classical_building","building_construction","bricks","house_buildings","derelict_house_building","house","house_with_garden","office","post_office","european_post_office","hospital","bank","hotel","love_hotel","convenience_store","school","department_store","factory","japanese_castle","european_castle","wedding","tokyo_tower","statue_of_liberty","church","mosque","hindu_temple","synagogue","shinto_shrine","kaaba","fountain","tent","foggy","night_with_stars","cityscape","sunrise_over_mountains","sunrise","city_sunset","city_sunrise","bridge_at_night","hotsprings","carousel_horse","ferris_wheel","roller_coaster","barber","circus_tent","steam_locomotive","railway_car","bullettrain_side","bullettrain_front","train2","metro","light_rail","station","tram","monorail","mountain_railway","train","bus","oncoming_bus","trolleybus","minibus","ambulance","fire_engine","police_car","oncoming_police_car","taxi","oncoming_taxi","car","oncoming_automobile","blue_car","truck","articulated_lorry","tractor","racing_car","racing_motorcycle","motor_scooter","manual_wheelchair","motorized_wheelchair","auto_rickshaw","bike","scooter","skateboard","busstop","motorway","railway_track","oil_drum","fuelpump","rotating_light","traffic_light","vertical_traffic_light","octagonal_sign","construction","anchor","boat","canoe","speedboat","passenger_ship","ferry","motor_boat","ship","airplane","small_airplane","airplane_departure","airplane_arriving","parachute","seat","helicopter","suspension_railway","mountain_cableway","aerial_tramway","satellite","rocket","flying_saucer","bellhop_bell","luggage","hourglass","hourglass_flowing_sand","watch","alarm_clock","stopwatch","timer_clock","mantelpiece_clock","clock12","clock1230","clock1","clock130","clock2","clock230","clock3","clock330","clock4","clock430","clock5","clock530","clock6","clock630","clock7","clock730","clock8","clock830","clock9","clock930","clock10","clock1030","clock11","clock1130","new_moon","waxing_crescent_moon","first_quarter_moon","moon","full_moon","waning_gibbous_moon","last_quarter_moon","waning_crescent_moon","crescent_moon","new_moon_with_face","first_quarter_moon_with_face","last_quarter_moon_with_face","thermometer","sunny","full_moon_with_face","sun_with_face","ringed_planet","star","star2","stars","milky_way","cloud","partly_sunny","thunder_cloud_and_rain","mostly_sunny","barely_sunny","partly_sunny_rain","rain_cloud","snow_cloud","lightning","tornado","fog","wind_blowing_face","cyclone","rainbow","closed_umbrella","umbrella","umbrella_with_rain_drops","umbrella_on_ground","zap","snowflake","snowman","snowman_without_snow","comet","fire","droplet","ocean"]},{"id":"objects","name":"Objects","emojis":["eyeglasses","dark_sunglasses","goggles","lab_coat","safety_vest","necktie","shirt","jeans","scarf","gloves","coat","socks","dress","kimono","sari","one-piece_swimsuit","briefs","shorts","bikini","womans_clothes","purse","handbag","pouch","shopping_bags","school_satchel","mans_shoe","athletic_shoe","hiking_boot","womans_flat_shoe","high_heel","sandal","ballet_shoes","boot","crown","womans_hat","tophat","mortar_board","billed_cap","helmet_with_white_cross","prayer_beads","lipstick","ring","gem","mute","speaker","sound","loud_sound","loudspeaker","mega","postal_horn","bell","no_bell","musical_score","musical_note","notes","studio_microphone","level_slider","control_knobs","microphone","headphones","radio","saxophone","guitar","musical_keyboard","trumpet","violin","banjo","drum_with_drumsticks","iphone","calling","phone","telephone_receiver","pager","fax","battery","electric_plug","computer","desktop_computer","printer","keyboard","three_button_mouse","trackball","minidisc","floppy_disk","cd","dvd","abacus","movie_camera","film_frames","film_projector","clapper","tv","camera","camera_with_flash","video_camera","vhs","mag","mag_right","candle","bulb","flashlight","izakaya_lantern","diya_lamp","notebook_with_decorative_cover","closed_book","book","green_book","blue_book","orange_book","books","notebook","ledger","page_with_curl","scroll","page_facing_up","newspaper","rolled_up_newspaper","bookmark_tabs","bookmark","label","moneybag","yen","dollar","euro","pound","money_with_wings","credit_card","receipt","chart","currency_exchange","heavy_dollar_sign","email","e-mail","incoming_envelope","envelope_with_arrow","outbox_tray","inbox_tray","package","mailbox","mailbox_closed","mailbox_with_mail","mailbox_with_no_mail","postbox","ballot_box_with_ballot","pencil2","black_nib","lower_left_fountain_pen","lower_left_ballpoint_pen","lower_left_paintbrush","lower_left_crayon","memo","briefcase","file_folder","open_file_folder","card_index_dividers","date","calendar","spiral_note_pad","spiral_calendar_pad","card_index","chart_with_upwards_trend","chart_with_downwards_trend","bar_chart","clipboard","pushpin","round_pushpin","paperclip","linked_paperclips","straight_ruler","triangular_ruler","scissors","card_file_box","file_cabinet","wastebasket","lock","unlock","lock_with_ink_pen","closed_lock_with_key","key","old_key","hammer","axe","pick","hammer_and_pick","hammer_and_wrench","dagger_knife","crossed_swords","gun","bow_and_arrow","shield","wrench","nut_and_bolt","gear","compression","scales","probing_cane","link","chains","toolbox","magnet","alembic","test_tube","petri_dish","dna","microscope","telescope","satellite_antenna","syringe","drop_of_blood","pill","adhesive_bandage","stethoscope","door","bed","couch_and_lamp","chair","toilet","shower","bathtub","razor","lotion_bottle","safety_pin","broom","basket","roll_of_paper","soap","sponge","fire_extinguisher","shopping_trolley","smoking","coffin","funeral_urn","moyai"]},{"id":"symbols","name":"Symbols","emojis":["atm","put_litter_in_its_place","potable_water","wheelchair","mens","womens","restroom","baby_symbol","wc","passport_control","customs","baggage_claim","left_luggage","warning","children_crossing","no_entry","no_entry_sign","no_bicycles","no_smoking","do_not_litter","non-potable_water","no_pedestrians","no_mobile_phones","underage","radioactive_sign","biohazard_sign","arrow_up","arrow_upper_right","arrow_right","arrow_lower_right","arrow_down","arrow_lower_left","arrow_left","arrow_upper_left","arrow_up_down","left_right_arrow","leftwards_arrow_with_hook","arrow_right_hook","arrow_heading_up","arrow_heading_down","arrows_clockwise","arrows_counterclockwise","back","end","on","soon","top","place_of_worship","atom_symbol","om_symbol","star_of_david","wheel_of_dharma","yin_yang","latin_cross","orthodox_cross","star_and_crescent","peace_symbol","menorah_with_nine_branches","six_pointed_star","aries","taurus","gemini","cancer","leo","virgo","libra","scorpius","sagittarius","capricorn","aquarius","pisces","ophiuchus","twisted_rightwards_arrows","repeat","repeat_one","arrow_forward","fast_forward","black_right_pointing_double_triangle_with_vertical_bar","black_right_pointing_triangle_with_double_vertical_bar","arrow_backward","rewind","black_left_pointing_double_triangle_with_vertical_bar","arrow_up_small","arrow_double_up","arrow_down_small","arrow_double_down","double_vertical_bar","black_square_for_stop","black_circle_for_record","eject","cinema","low_brightness","high_brightness","signal_strength","vibration_mode","mobile_phone_off","female_sign","male_sign","medical_symbol","infinity","recycle","fleur_de_lis","trident","name_badge","beginner","o","white_check_mark","ballot_box_with_check","heavy_check_mark","heavy_multiplication_x","x","negative_squared_cross_mark","heavy_plus_sign","heavy_minus_sign","heavy_division_sign","curly_loop","loop","part_alternation_mark","eight_spoked_asterisk","eight_pointed_black_star","sparkle","bangbang","interrobang","question","grey_question","grey_exclamation","exclamation","wavy_dash","copyright","registered","tm","hash","keycap_star","zero","one","two","three","four","five","six","seven","eight","nine","keycap_ten","capital_abcd","abcd","1234","symbols","abc","a","ab","b","cl","cool","free","information_source","id","m","new","ng","o2","ok","parking","sos","up","vs","koko","sa","u6708","u6709","u6307","ideograph_advantage","u5272","u7121","u7981","accept","u7533","u5408","u7a7a","congratulations","secret","u55b6","u6e80","red_circle","large_orange_circle","large_yellow_circle","large_green_circle","large_blue_circle","large_purple_circle","large_brown_circle","black_circle","white_circle","large_red_square","large_orange_square","large_yellow_square","large_green_square","large_blue_square","large_purple_square","large_brown_square","black_large_square","white_large_square","black_medium_square","white_medium_square","black_medium_small_square","white_medium_small_square","black_small_square","white_small_square","large_orange_diamond","large_blue_diamond","small_orange_diamond","small_blue_diamond","small_red_triangle","small_red_triangle_down","diamond_shape_with_a_dot_inside","radio_button","white_square_button","black_square_button"]},{"id":"flags","name":"Flags","emojis":["checkered_flag","cn","crossed_flags","de","es","flag-ac","flag-ad","flag-ae","flag-af","flag-ag","flag-ai","flag-al","flag-am","flag-ao","flag-aq","flag-ar","flag-as","flag-at","flag-au","flag-aw","flag-ax","flag-az","flag-ba","flag-bb","flag-bd","flag-be","flag-bf","flag-bg","flag-bh","flag-bi","flag-bj","flag-bl","flag-bm","flag-bn","flag-bo","flag-bq","flag-br","flag-bs","flag-bt","flag-bv","flag-bw","flag-by","flag-bz","flag-ca","flag-cc","flag-cd","flag-cf","flag-cg","flag-ch","flag-ci","flag-ck","flag-cl","flag-cm","flag-co","flag-cp","flag-cr","flag-cu","flag-cv","flag-cw","flag-cx","flag-cy","flag-cz","flag-dg","flag-dj","flag-dk","flag-dm","flag-do","flag-dz","flag-ea","flag-ec","flag-ee","flag-eg","flag-eh","flag-england","flag-er","flag-et","flag-eu","flag-fi","flag-fj","flag-fk","flag-fm","flag-fo","flag-ga","flag-gd","flag-ge","flag-gf","flag-gg","flag-gh","flag-gi","flag-gl","flag-gm","flag-gn","flag-gp","flag-gq","flag-gr","flag-gs","flag-gt","flag-gu","flag-gw","flag-gy","flag-hk","flag-hm","flag-hn","flag-hr","flag-ht","flag-hu","flag-ic","flag-id","flag-ie","flag-il","flag-im","flag-in","flag-io","flag-iq","flag-ir","flag-is","flag-je","flag-jm","flag-jo","flag-ke","flag-kg","flag-kh","flag-ki","flag-km","flag-kn","flag-kp","flag-kw","flag-ky","flag-kz","flag-la","flag-lb","flag-lc","flag-li","flag-lk","flag-lr","flag-ls","flag-lt","flag-lu","flag-lv","flag-ly","flag-ma","flag-mc","flag-md","flag-me","flag-mf","flag-mg","flag-mh","flag-mk","flag-ml","flag-mm","flag-mn","flag-mo","flag-mp","flag-mq","flag-mr","flag-ms","flag-mt","flag-mu","flag-mv","flag-mw","flag-mx","flag-my","flag-mz","flag-na","flag-nc","flag-ne","flag-nf","flag-ng","flag-ni","flag-nl","flag-no","flag-np","flag-nr","flag-nu","flag-nz","flag-om","flag-pa","flag-pe","flag-pf","flag-pg","flag-ph","flag-pk","flag-pl","flag-pm","flag-pn","flag-pr","flag-ps","flag-pt","flag-pw","flag-py","flag-qa","flag-re","flag-ro","flag-rs","flag-rw","flag-sa","flag-sb","flag-sc","flag-scotland","flag-sd","flag-se","flag-sg","flag-sh","flag-si","flag-sj","flag-sk","flag-sl","flag-sm","flag-sn","flag-so","flag-sr","flag-ss","flag-st","flag-sv","flag-sx","flag-sy","flag-sz","flag-ta","flag-tc","flag-td","flag-tf","flag-tg","flag-th","flag-tj","flag-tk","flag-tl","flag-tm","flag-tn","flag-to","flag-tr","flag-tt","flag-tv","flag-tw","flag-tz","flag-ua","flag-ug","flag-um","flag-uy","flag-uz","flag-va","flag-vc","flag-ve","flag-vg","flag-vi","flag-vn","flag-vu","flag-wales","flag-wf","flag-ws","flag-xk","flag-ye","flag-yt","flag-za","flag-zm","flag-zw","fr","gb","it","jp","kr","pirate_flag","rainbow-flag","ru","triangular_flag_on_post","us","waving_black_flag","waving_white_flag"]}],"emojis":{"100":{"a":"Hundred Points Symbol","b":"1F4AF","d":true,"e":true,"f":true,"h":true,"j":["score","perfect","numbers","century","exam","quiz","test","pass","hundred"],"k":[26,5],"o":2},"1234":{"a":"Input Symbol for Numbers","b":"1F522","d":true,"e":true,"f":true,"h":true,"j":["numbers","blue-square"],"k":[28,5],"o":2},"grinning":{"a":"Grinning Face","b":"1F600","d":true,"e":true,"f":true,"h":true,"j":["face","smile","happy","joy",":D","grin"],"k":[30,35],"m":":D","o":2},"monkey_face":{"a":"Monkey Face","b":"1F435","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","circus"],"k":[12,25],"l":[":o)"],"o":2},"grapes":{"a":"Grapes","b":"1F347","d":true,"e":true,"f":true,"h":true,"j":["fruit","food","wine"],"k":[6,31],"o":2},"eyeglasses":{"a":"Eyeglasses","b":"1F453","d":true,"e":true,"f":true,"h":true,"j":["fashion","accessories","eyesight","nerdy","dork","geek"],"k":[14,7],"o":2},"checkered_flag":{"a":"Chequered Flag","b":"1F3C1","d":true,"e":true,"f":true,"h":true,"j":["contest","finishline","race","gokart"],"k":[8,39],"o":2},"jack_o_lantern":{"a":"Jack-O-Lantern","b":"1F383","d":true,"e":true,"f":true,"h":true,"j":["halloween","light","pumpkin","creepy","fall"],"k":[7,34],"o":2},"wave":{"skin_variations":{"1F3FB":{"unified":"1F44B-1F3FB","non_qualified":null,"image":"1f44b-1f3fb.png","sheet_x":13,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44B-1F3FC","non_qualified":null,"image":"1f44b-1f3fc.png","sheet_x":13,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44B-1F3FD","non_qualified":null,"image":"1f44b-1f3fd.png","sheet_x":13,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44B-1F3FE","non_qualified":null,"image":"1f44b-1f3fe.png","sheet_x":13,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44B-1F3FF","non_qualified":null,"image":"1f44b-1f3ff.png","sheet_x":13,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Waving Hand Sign","b":"1F44B","d":true,"e":true,"f":true,"h":true,"j":["hands","gesture","goodbye","solong","farewell","hello","hi","palm"],"k":[13,26],"o":2},"earth_africa":{"a":"Earth Globe Europe-Africa","b":"1F30D","d":true,"e":true,"f":true,"h":true,"j":["globe","world","international"],"k":[5,32],"o":2},"atm":{"a":"Automated Teller Machine","b":"1F3E7","d":true,"e":true,"f":true,"h":true,"j":["money","sales","cash","blue-square","payment","bank"],"k":[11,1],"o":2},"melon":{"a":"Melon","b":"1F348","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature","food"],"k":[6,32],"o":2},"triangular_flag_on_post":{"a":"Triangular Flag on Post","b":"1F6A9","d":true,"e":true,"f":true,"h":true,"j":["mark","milestone","place"],"k":[35,0],"o":2},"put_litter_in_its_place":{"a":"Put Litter in Its Place Symbol","b":"1F6AE","d":true,"e":true,"f":true,"h":true,"j":["blue-square","sign","human","info"],"k":[35,5],"o":2},"christmas_tree":{"a":"Christmas Tree","b":"1F384","d":true,"e":true,"f":true,"h":true,"j":["festival","vacation","december","xmas","celebration"],"k":[7,35],"o":2},"monkey":{"a":"Monkey","b":"1F412","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","banana","circus"],"k":[11,46],"o":2},"earth_americas":{"a":"Earth Globe Americas","b":"1F30E","d":true,"e":true,"f":true,"h":true,"j":["globe","world","USA","international"],"k":[5,33],"o":2},"dark_sunglasses":{"a":"Dark Sunglasses","b":"1F576-FE0F","c":"1F576","d":true,"e":true,"f":true,"h":true,"j":["face","cool","accessories"],"k":[29,33],"o":2},"raised_back_of_hand":{"skin_variations":{"1F3FB":{"unified":"1F91A-1F3FB","non_qualified":null,"image":"1f91a-1f3fb.png","sheet_x":37,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F91A-1F3FC","non_qualified":null,"image":"1f91a-1f3fc.png","sheet_x":37,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F91A-1F3FD","non_qualified":null,"image":"1f91a-1f3fd.png","sheet_x":37,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F91A-1F3FE","non_qualified":null,"image":"1f91a-1f3fe.png","sheet_x":37,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F91A-1F3FF","non_qualified":null,"image":"1f91a-1f3ff.png","sheet_x":37,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Raised Back of Hand","b":"1F91A","d":true,"e":true,"f":true,"h":true,"j":["fingers","raised","backhand"],"k":[37,43],"o":4},"smiley":{"a":"Smiling Face with Open Mouth","b":"1F603","d":true,"e":true,"f":true,"h":true,"j":["face","happy","joy","haha",":D",":)","smile","funny"],"k":[30,38],"l":["=)","=-)"],"m":":)","o":2},"earth_asia":{"a":"Earth Globe Asia-Australia","b":"1F30F","d":true,"e":true,"f":true,"h":true,"j":["globe","world","east","international"],"k":[5,34],"o":2},"crossed_flags":{"a":"Crossed Flags","b":"1F38C","d":true,"e":true,"f":true,"h":true,"j":["japanese","nation","country","border"],"k":[7,48],"o":2},"watermelon":{"a":"Watermelon","b":"1F349","d":true,"e":true,"f":true,"h":true,"j":["fruit","food","picnic","summer"],"k":[6,33],"o":2},"goggles":{"a":"Goggles","b":"1F97D","d":true,"e":true,"f":true,"h":true,"k":[42,15],"o":11},"raised_hand_with_fingers_splayed":{"skin_variations":{"1F3FB":{"unified":"1F590-1F3FB","non_qualified":null,"image":"1f590-1f3fb.png","sheet_x":29,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F590-1F3FC","non_qualified":null,"image":"1f590-1f3fc.png","sheet_x":29,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F590-1F3FD","non_qualified":null,"image":"1f590-1f3fd.png","sheet_x":29,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F590-1F3FE","non_qualified":null,"image":"1f590-1f3fe.png","sheet_x":29,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F590-1F3FF","non_qualified":null,"image":"1f590-1f3ff.png","sheet_x":29,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Raised Hand with Fingers Splayed","b":"1F590-FE0F","c":"1F590","d":true,"e":true,"f":true,"h":true,"j":["hand","fingers","palm"],"k":[29,48],"o":2},"smile":{"a":"Smiling Face with Open Mouth and Smiling Eyes","b":"1F604","d":true,"e":true,"f":true,"h":true,"j":["face","happy","joy","funny","haha","laugh","like",":D",":)"],"k":[30,39],"l":["C:","c:",":D",":-D"],"m":":)","o":2},"potable_water":{"a":"Potable Water Symbol","b":"1F6B0","d":true,"e":true,"f":true,"h":true,"j":["blue-square","liquid","restroom","cleaning","faucet"],"k":[35,7],"o":2},"fireworks":{"a":"Fireworks","b":"1F386","d":true,"e":true,"f":true,"h":true,"j":["photo","festival","carnival","congratulations"],"k":[7,42],"o":2},"gorilla":{"a":"Gorilla","b":"1F98D","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","circus"],"k":[42,31],"o":4},"lab_coat":{"a":"Lab Coat","b":"1F97C","d":true,"e":true,"f":true,"h":true,"k":[42,14],"o":11},"tangerine":{"a":"Tangerine","b":"1F34A","d":true,"e":true,"f":true,"h":true,"j":["food","fruit","nature","orange"],"k":[6,34],"o":2},"wheelchair":{"a":"Wheelchair Symbol","b":"267F","d":true,"e":true,"f":true,"h":true,"j":["blue-square","disabled","a11y","accessibility"],"k":[53,40],"o":2},"waving_black_flag":{"a":"Waving Black Flag","b":"1F3F4","d":true,"e":true,"f":true,"h":true,"k":[11,17],"o":2},"orangutan":{"a":"Orangutan","b":"1F9A7","d":true,"e":true,"f":true,"h":true,"k":[42,55],"o":12},"sparkler":{"a":"Firework Sparkler","b":"1F387","d":true,"e":true,"f":true,"h":true,"j":["stars","night","shine"],"k":[7,43],"o":2},"globe_with_meridians":{"a":"Globe with Meridians","b":"1F310","d":true,"e":true,"f":true,"h":true,"j":["earth","international","world","internet","interweb","i18n"],"k":[5,35],"o":2},"grin":{"a":"Grinning Face with Smiling Eyes","b":"1F601","d":true,"e":true,"f":true,"h":true,"j":["face","happy","smile","joy","kawaii"],"k":[30,36],"o":2},"hand":{"skin_variations":{"1F3FB":{"unified":"270B-1F3FB","non_qualified":null,"image":"270b-1f3fb.png","sheet_x":54,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"270B-1F3FC","non_qualified":null,"image":"270b-1f3fc.png","sheet_x":54,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"270B-1F3FD","non_qualified":null,"image":"270b-1f3fd.png","sheet_x":54,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"270B-1F3FE","non_qualified":null,"image":"270b-1f3fe.png","sheet_x":54,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"270B-1F3FF","non_qualified":null,"image":"270b-1f3ff.png","sheet_x":54,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Raised Hand","b":"270B","d":true,"e":true,"f":true,"h":true,"k":[54,49],"n":["raised_hand"],"o":2},"firecracker":{"a":"Firecracker","b":"1F9E8","d":true,"e":true,"f":true,"h":true,"k":[51,27],"o":11},"lemon":{"a":"Lemon","b":"1F34B","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature"],"k":[6,35],"o":2},"dog":{"a":"Dog Face","b":"1F436","d":true,"e":true,"f":true,"h":true,"j":["animal","friend","nature","woof","puppy","pet","faithful"],"k":[12,26],"o":2},"mens":{"a":"Mens Symbol","b":"1F6B9","d":true,"e":true,"f":true,"h":true,"j":["toilet","restroom","wc","blue-square","gender","male"],"k":[36,10],"o":2},"spock-hand":{"skin_variations":{"1F3FB":{"unified":"1F596-1F3FB","non_qualified":null,"image":"1f596-1f3fb.png","sheet_x":30,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F596-1F3FC","non_qualified":null,"image":"1f596-1f3fc.png","sheet_x":30,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F596-1F3FD","non_qualified":null,"image":"1f596-1f3fd.png","sheet_x":30,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F596-1F3FE","non_qualified":null,"image":"1f596-1f3fe.png","sheet_x":30,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F596-1F3FF","non_qualified":null,"image":"1f596-1f3ff.png","sheet_x":30,"sheet_y":8,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Raised Hand with Part Between Middle and Ring Fingers","b":"1F596","d":true,"e":true,"f":true,"h":true,"k":[30,3],"o":2},"world_map":{"a":"World Map","b":"1F5FA-FE0F","c":"1F5FA","d":true,"e":true,"f":true,"h":true,"j":["location","direction"],"k":[30,29],"o":2},"laughing":{"a":"Smiling Face with Open Mouth and Tightly-Closed Eyes","b":"1F606","d":true,"e":true,"f":true,"h":true,"j":["happy","joy","lol","satisfied","haha","face","glad","XD","laugh"],"k":[30,41],"l":[":>",":->"],"n":["satisfied"],"o":2},"waving_white_flag":{"a":"Waving White Flag","b":"1F3F3-FE0F","c":"1F3F3","d":true,"e":true,"f":true,"h":true,"k":[11,12],"o":2},"safety_vest":{"a":"Safety Vest","b":"1F9BA","d":true,"e":true,"f":true,"h":true,"k":[43,54],"o":12},"sweat_smile":{"a":"Smiling Face with Open Mouth and Cold Sweat","b":"1F605","d":true,"e":true,"f":true,"h":true,"j":["face","hot","happy","laugh","sweat","smile","relief"],"k":[30,40],"o":2},"sparkles":{"a":"Sparkles","b":"2728","d":true,"e":true,"f":true,"h":true,"j":["stars","shine","shiny","cool","awesome","good","magic"],"k":[55,16],"o":2},"banana":{"a":"Banana","b":"1F34C","d":true,"e":true,"f":true,"h":true,"j":["fruit","food","monkey"],"k":[6,36],"o":2},"rainbow-flag":{"a":"Rainbow Flag","b":"1F3F3-FE0F-200D-1F308","c":"1F3F3-200D-1F308","d":true,"e":true,"f":true,"h":true,"k":[11,11],"o":4},"ok_hand":{"skin_variations":{"1F3FB":{"unified":"1F44C-1F3FB","non_qualified":null,"image":"1f44c-1f3fb.png","sheet_x":13,"sheet_y":33,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44C-1F3FC","non_qualified":null,"image":"1f44c-1f3fc.png","sheet_x":13,"sheet_y":34,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44C-1F3FD","non_qualified":null,"image":"1f44c-1f3fd.png","sheet_x":13,"sheet_y":35,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44C-1F3FE","non_qualified":null,"image":"1f44c-1f3fe.png","sheet_x":13,"sheet_y":36,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44C-1F3FF","non_qualified":null,"image":"1f44c-1f3ff.png","sheet_x":13,"sheet_y":37,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Ok Hand Sign","b":"1F44C","d":true,"e":true,"f":true,"h":true,"j":["fingers","limbs","perfect","ok","okay"],"k":[13,32],"o":2},"japan":{"a":"Silhouette of Japan","b":"1F5FE","d":true,"e":true,"f":true,"h":true,"j":["nation","country","japanese","asia"],"k":[30,33],"o":2},"dog2":{"a":"Dog","b":"1F415","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","friend","doge","pet","faithful"],"k":[11,50],"o":2},"womens":{"a":"Womens Symbol","b":"1F6BA","d":true,"e":true,"f":true,"h":true,"j":["purple-square","woman","female","toilet","loo","restroom","gender"],"k":[36,11],"o":2},"necktie":{"a":"Necktie","b":"1F454","d":true,"e":true,"f":true,"h":true,"j":["shirt","suitup","formal","fashion","cloth","business"],"k":[14,8],"o":2},"pirate_flag":{"a":"Pirate Flag","b":"1F3F4-200D-2620-FE0F","c":"1F3F4-200D-2620","d":true,"e":true,"f":true,"h":true,"k":[11,13],"o":11},"guide_dog":{"a":"Guide Dog","b":"1F9AE","d":true,"e":true,"f":true,"h":true,"k":[43,2],"o":12},"restroom":{"a":"Restroom","b":"1F6BB","d":true,"e":true,"f":true,"h":true,"j":["blue-square","toilet","refresh","wc","gender"],"k":[36,12],"o":2},"compass":{"a":"Compass","b":"1F9ED","d":true,"e":true,"f":true,"h":true,"k":[51,32],"o":11},"rolling_on_the_floor_laughing":{"a":"Rolling on the Floor Laughing","b":"1F923","d":true,"e":true,"f":true,"h":true,"k":[38,20],"o":4},"balloon":{"a":"Balloon","b":"1F388","d":true,"e":true,"f":true,"h":true,"j":["party","celebration","birthday","circus"],"k":[7,44],"o":2},"pinching_hand":{"skin_variations":{"1F3FB":{"unified":"1F90F-1F3FB","non_qualified":null,"image":"1f90f-1f3fb.png","sheet_x":37,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F90F-1F3FC","non_qualified":null,"image":"1f90f-1f3fc.png","sheet_x":37,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F90F-1F3FD","non_qualified":null,"image":"1f90f-1f3fd.png","sheet_x":37,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F90F-1F3FE","non_qualified":null,"image":"1f90f-1f3fe.png","sheet_x":37,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F90F-1F3FF","non_qualified":null,"image":"1f90f-1f3ff.png","sheet_x":37,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Pinching Hand","b":"1F90F","d":true,"e":true,"f":true,"h":true,"k":[37,17],"o":12},"pineapple":{"a":"Pineapple","b":"1F34D","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature","food"],"k":[6,37],"o":2},"shirt":{"a":"T-Shirt","b":"1F455","d":true,"e":true,"f":true,"h":true,"k":[14,9],"n":["tshirt"],"o":2},"service_dog":{"a":"Service Dog","b":"1F415-200D-1F9BA","d":true,"e":true,"f":true,"h":true,"k":[11,49],"o":12},"baby_symbol":{"a":"Baby Symbol","b":"1F6BC","d":true,"e":true,"f":true,"h":true,"j":["orange-square","child"],"k":[36,13],"o":2},"joy":{"a":"Face with Tears of Joy","b":"1F602","d":true,"e":true,"f":true,"h":true,"j":["face","cry","tears","weep","happy","happytears","haha"],"k":[30,37],"o":2},"tada":{"a":"Party Popper","b":"1F389","d":true,"e":true,"f":true,"h":true,"j":["party","congratulations","birthday","magic","circus","celebration"],"k":[7,45],"o":2},"mango":{"a":"Mango","b":"1F96D","d":true,"e":true,"f":true,"h":true,"k":[42,3],"o":11},"v":{"skin_variations":{"1F3FB":{"unified":"270C-1F3FB","non_qualified":null,"image":"270c-1f3fb.png","sheet_x":54,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"270C-1F3FC","non_qualified":null,"image":"270c-1f3fc.png","sheet_x":55,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"270C-1F3FD","non_qualified":null,"image":"270c-1f3fd.png","sheet_x":55,"sheet_y":1,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"270C-1F3FE","non_qualified":null,"image":"270c-1f3fe.png","sheet_x":55,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"270C-1F3FF","non_qualified":null,"image":"270c-1f3ff.png","sheet_x":55,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Victory Hand","b":"270C-FE0F","c":"270C","d":true,"e":true,"f":true,"h":true,"j":["fingers","ohyeah","hand","peace","victory","two"],"k":[54,55],"o":2},"snow_capped_mountain":{"a":"Snow Capped Mountain","b":"1F3D4-FE0F","c":"1F3D4","d":true,"e":true,"f":true,"h":true,"k":[10,39],"o":2},"flag-ac":{"a":"Ascension Island Flag","b":"1F1E6-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[0,31],"o":2},"jeans":{"a":"Jeans","b":"1F456","d":true,"e":true,"f":true,"h":true,"j":["fashion","shopping"],"k":[14,10],"o":2},"poodle":{"a":"Poodle","b":"1F429","d":true,"e":true,"f":true,"h":true,"j":["dog","animal","101","nature","pet"],"k":[12,13],"o":2},"crossed_fingers":{"skin_variations":{"1F3FB":{"unified":"1F91E-1F3FB","non_qualified":null,"image":"1f91e-1f3fb.png","sheet_x":38,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F91E-1F3FC","non_qualified":null,"image":"1f91e-1f3fc.png","sheet_x":38,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F91E-1F3FD","non_qualified":null,"image":"1f91e-1f3fd.png","sheet_x":38,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F91E-1F3FE","non_qualified":null,"image":"1f91e-1f3fe.png","sheet_x":38,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F91E-1F3FF","non_qualified":null,"image":"1f91e-1f3ff.png","sheet_x":38,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Hand with Index and Middle Fingers Crossed","b":"1F91E","d":true,"e":true,"f":true,"h":true,"j":["good","lucky"],"k":[38,5],"n":["hand_with_index_and_middle_fingers_crossed"],"o":4},"flag-ad":{"a":"Andorra Flag","b":"1F1E6-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[0,32],"o":2},"slightly_smiling_face":{"a":"Slightly Smiling Face","b":"1F642","d":true,"e":true,"f":true,"h":true,"j":["face","smile"],"k":[31,44],"l":[":)","(:",":-)"],"o":2},"apple":{"a":"Red Apple","b":"1F34E","d":true,"e":true,"f":true,"h":true,"j":["fruit","mac","school"],"k":[6,38],"o":2},"wc":{"a":"Water Closet","b":"1F6BE","d":true,"e":true,"f":true,"h":true,"j":["toilet","restroom","blue-square"],"k":[36,15],"o":2},"scarf":{"a":"Scarf","b":"1F9E3","d":true,"e":true,"f":true,"h":true,"k":[51,22],"o":5},"mountain":{"a":"Mountain","b":"26F0-FE0F","c":"26F0","d":true,"e":true,"f":true,"h":true,"j":["photo","nature","environment"],"k":[54,11],"o":2},"confetti_ball":{"a":"Confetti Ball","b":"1F38A","d":true,"e":true,"f":true,"h":true,"j":["festival","party","birthday","circus"],"k":[7,46],"o":2},"i_love_you_hand_sign":{"skin_variations":{"1F3FB":{"unified":"1F91F-1F3FB","non_qualified":null,"image":"1f91f-1f3fb.png","sheet_x":38,"sheet_y":12,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F91F-1F3FC","non_qualified":null,"image":"1f91f-1f3fc.png","sheet_x":38,"sheet_y":13,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F91F-1F3FD","non_qualified":null,"image":"1f91f-1f3fd.png","sheet_x":38,"sheet_y":14,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F91F-1F3FE","non_qualified":null,"image":"1f91f-1f3fe.png","sheet_x":38,"sheet_y":15,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F91F-1F3FF","non_qualified":null,"image":"1f91f-1f3ff.png","sheet_x":38,"sheet_y":16,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"I Love You Hand Sign","b":"1F91F","d":true,"e":true,"f":true,"h":true,"k":[38,11],"o":5},"wolf":{"a":"Wolf Face","b":"1F43A","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","wild"],"k":[12,30],"o":2},"gloves":{"a":"Gloves","b":"1F9E4","d":true,"e":true,"f":true,"h":true,"k":[51,23],"o":5},"flag-ae":{"a":"United Arab Emirates Flag","b":"1F1E6-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[0,33],"o":2},"upside_down_face":{"a":"Upside-Down Face","b":"1F643","d":true,"e":true,"f":true,"h":true,"j":["face","flipped","silly","smile"],"k":[31,45],"o":2},"green_apple":{"a":"Green Apple","b":"1F34F","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature"],"k":[6,39],"o":2},"passport_control":{"a":"Passport Control","b":"1F6C2","d":true,"e":true,"f":true,"h":true,"j":["custom","blue-square"],"k":[36,24],"o":2},"volcano":{"a":"Volcano","b":"1F30B","d":true,"e":true,"f":true,"h":true,"j":["photo","nature","disaster"],"k":[5,30],"o":2},"tanabata_tree":{"a":"Tanabata Tree","b":"1F38B","d":true,"e":true,"f":true,"h":true,"j":["plant","nature","branch","summer"],"k":[7,47],"o":2},"customs":{"a":"Customs","b":"1F6C3","d":true,"e":true,"f":true,"h":true,"j":["passport","border","blue-square"],"k":[36,25],"o":2},"coat":{"a":"Coat","b":"1F9E5","d":true,"e":true,"f":true,"h":true,"k":[51,24],"o":5},"wink":{"a":"Winking Face","b":"1F609","d":true,"e":true,"f":true,"h":true,"j":["face","happy","mischievous","secret",";)","smile","eye"],"k":[30,44],"l":[";)",";-)"],"m":";)","o":2},"bamboo":{"a":"Pine Decoration","b":"1F38D","d":true,"e":true,"f":true,"h":true,"j":["plant","nature","vegetable","panda","pine_decoration"],"k":[7,49],"o":2},"flag-af":{"a":"Afghanistan Flag","b":"1F1E6-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[0,34],"o":2},"fox_face":{"a":"Fox Face","b":"1F98A","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","face"],"k":[42,28],"o":4},"pear":{"a":"Pear","b":"1F350","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature","food"],"k":[6,40],"o":2},"mount_fuji":{"a":"Mount Fuji","b":"1F5FB","d":true,"e":true,"f":true,"h":true,"j":["photo","mountain","nature","japanese"],"k":[30,30],"o":2},"the_horns":{"skin_variations":{"1F3FB":{"unified":"1F918-1F3FB","non_qualified":null,"image":"1f918-1f3fb.png","sheet_x":37,"sheet_y":32,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F918-1F3FC","non_qualified":null,"image":"1f918-1f3fc.png","sheet_x":37,"sheet_y":33,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F918-1F3FD","non_qualified":null,"image":"1f918-1f3fd.png","sheet_x":37,"sheet_y":34,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F918-1F3FE","non_qualified":null,"image":"1f918-1f3fe.png","sheet_x":37,"sheet_y":35,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F918-1F3FF","non_qualified":null,"image":"1f918-1f3ff.png","sheet_x":37,"sheet_y":36,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Sign of the Horns","b":"1F918","d":true,"e":true,"f":true,"h":true,"k":[37,31],"n":["sign_of_the_horns"],"o":2},"call_me_hand":{"skin_variations":{"1F3FB":{"unified":"1F919-1F3FB","non_qualified":null,"image":"1f919-1f3fb.png","sheet_x":37,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F919-1F3FC","non_qualified":null,"image":"1f919-1f3fc.png","sheet_x":37,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F919-1F3FD","non_qualified":null,"image":"1f919-1f3fd.png","sheet_x":37,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F919-1F3FE","non_qualified":null,"image":"1f919-1f3fe.png","sheet_x":37,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F919-1F3FF","non_qualified":null,"image":"1f919-1f3ff.png","sheet_x":37,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Call Me Hand","b":"1F919","d":true,"e":true,"f":true,"h":true,"j":["hands","gesture"],"k":[37,37],"o":4},"flag-ag":{"a":"Antigua & Barbuda Flag","b":"1F1E6-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[0,35],"o":2},"raccoon":{"a":"Raccoon","b":"1F99D","d":true,"e":true,"f":true,"h":true,"k":[42,47],"o":11},"dolls":{"a":"Japanese Dolls","b":"1F38E","d":true,"e":true,"f":true,"h":true,"j":["japanese","toy","kimono"],"k":[7,50],"o":2},"blush":{"a":"Smiling Face with Smiling Eyes","b":"1F60A","d":true,"e":true,"f":true,"h":true,"j":["face","smile","happy","flushed","crush","embarrassed","shy","joy"],"k":[30,45],"m":":)","o":2},"peach":{"a":"Peach","b":"1F351","d":true,"e":true,"f":true,"h":true,"j":["fruit","nature","food"],"k":[6,41],"o":2},"baggage_claim":{"a":"Baggage Claim","b":"1F6C4","d":true,"e":true,"f":true,"h":true,"j":["blue-square","airport","transport"],"k":[36,26],"o":2},"socks":{"a":"Socks","b":"1F9E6","d":true,"e":true,"f":true,"h":true,"k":[51,25],"o":5},"camping":{"a":"Camping","b":"1F3D5-FE0F","c":"1F3D5","d":true,"e":true,"f":true,"h":true,"j":["photo","outdoors","tent"],"k":[10,40],"o":2},"dress":{"a":"Dress","b":"1F457","d":true,"e":true,"f":true,"h":true,"j":["clothes","fashion","shopping"],"k":[14,11],"o":2},"beach_with_umbrella":{"a":"Beach with Umbrella","b":"1F3D6-FE0F","c":"1F3D6","d":true,"e":true,"f":true,"h":true,"k":[10,41],"o":2},"cherries":{"a":"Cherries","b":"1F352","d":true,"e":true,"f":true,"h":true,"j":["food","fruit"],"k":[6,42],"o":2},"cat":{"a":"Cat Face","b":"1F431","d":true,"e":true,"f":true,"h":true,"j":["animal","meow","nature","pet","kitten"],"k":[12,21],"o":2},"point_left":{"skin_variations":{"1F3FB":{"unified":"1F448-1F3FB","non_qualified":null,"image":"1f448-1f3fb.png","sheet_x":13,"sheet_y":9,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F448-1F3FC","non_qualified":null,"image":"1f448-1f3fc.png","sheet_x":13,"sheet_y":10,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F448-1F3FD","non_qualified":null,"image":"1f448-1f3fd.png","sheet_x":13,"sheet_y":11,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F448-1F3FE","non_qualified":null,"image":"1f448-1f3fe.png","sheet_x":13,"sheet_y":12,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F448-1F3FF","non_qualified":null,"image":"1f448-1f3ff.png","sheet_x":13,"sheet_y":13,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Left Pointing Backhand Index","b":"1F448","d":true,"e":true,"f":true,"h":true,"j":["direction","fingers","hand","left"],"k":[13,8],"o":2},"left_luggage":{"a":"Left Luggage","b":"1F6C5","d":true,"e":true,"f":true,"h":true,"j":["blue-square","travel"],"k":[36,27],"o":2},"flag-ai":{"a":"Anguilla Flag","b":"1F1E6-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[0,36],"o":2},"innocent":{"a":"Smiling Face with Halo","b":"1F607","d":true,"e":true,"f":true,"h":true,"j":["face","angel","heaven","halo"],"k":[30,42],"o":2},"flags":{"a":"Carp Streamer","b":"1F38F","d":true,"e":true,"f":true,"h":true,"j":["fish","japanese","koinobori","carp","banner"],"k":[7,51],"o":2},"warning":{"a":"Warning Sign","b":"26A0-FE0F","c":"26A0","d":true,"e":true,"f":true,"h":true,"j":["exclamation","wip","alert","error","problem","issue"],"k":[53,50],"o":2},"strawberry":{"a":"Strawberry","b":"1F353","d":true,"e":true,"f":true,"h":true,"j":["fruit","food","nature"],"k":[6,43],"o":2},"point_right":{"skin_variations":{"1F3FB":{"unified":"1F449-1F3FB","non_qualified":null,"image":"1f449-1f3fb.png","sheet_x":13,"sheet_y":15,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F449-1F3FC","non_qualified":null,"image":"1f449-1f3fc.png","sheet_x":13,"sheet_y":16,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F449-1F3FD","non_qualified":null,"image":"1f449-1f3fd.png","sheet_x":13,"sheet_y":17,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F449-1F3FE","non_qualified":null,"image":"1f449-1f3fe.png","sheet_x":13,"sheet_y":18,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F449-1F3FF","non_qualified":null,"image":"1f449-1f3ff.png","sheet_x":13,"sheet_y":19,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Right Pointing Backhand Index","b":"1F449","d":true,"e":true,"f":true,"h":true,"j":["fingers","hand","direction","right"],"k":[13,14],"o":2},"desert":{"a":"Desert","b":"1F3DC-FE0F","c":"1F3DC","d":true,"e":true,"f":true,"h":true,"j":["photo","warm","saharah"],"k":[10,47],"o":2},"kimono":{"a":"Kimono","b":"1F458","d":true,"e":true,"f":true,"h":true,"j":["dress","fashion","women","female","japanese"],"k":[14,12],"o":2},"flag-al":{"a":"Albania Flag","b":"1F1E6-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[0,37],"o":2},"wind_chime":{"a":"Wind Chime","b":"1F390","d":true,"e":true,"f":true,"h":true,"j":["nature","ding","spring","bell"],"k":[7,52],"o":2},"smiling_face_with_3_hearts":{"a":"Smiling Face with Smiling Eyes and Three Hearts","b":"1F970","d":true,"e":true,"f":true,"h":true,"k":[42,6],"o":11},"cat2":{"a":"Cat","b":"1F408","d":true,"e":true,"f":true,"h":true,"j":["animal","meow","pet","cats"],"k":[11,36],"o":2},"rice_scene":{"a":"Moon Viewing Ceremony","b":"1F391","d":true,"e":true,"f":true,"h":true,"j":["photo","japan","asia","tsukimi"],"k":[7,53],"o":2},"heart_eyes":{"a":"Smiling Face with Heart-Shaped Eyes","b":"1F60D","d":true,"e":true,"f":true,"h":true,"j":["face","love","like","affection","valentines","infatuation","crush","heart"],"k":[30,48],"o":2},"sari":{"a":"Sari","b":"1F97B","d":true,"e":true,"f":true,"h":true,"k":[42,13],"o":12},"flag-am":{"a":"Armenia Flag","b":"1F1E6-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[0,38],"o":2},"lion_face":{"a":"Lion Face","b":"1F981","d":true,"e":true,"f":true,"h":true,"k":[42,19],"o":2},"desert_island":{"a":"Desert Island","b":"1F3DD-FE0F","c":"1F3DD","d":true,"e":true,"f":true,"h":true,"j":["photo","tropical","mojito"],"k":[10,48],"o":2},"point_up_2":{"skin_variations":{"1F3FB":{"unified":"1F446-1F3FB","non_qualified":null,"image":"1f446-1f3fb.png","sheet_x":12,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F446-1F3FC","non_qualified":null,"image":"1f446-1f3fc.png","sheet_x":12,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F446-1F3FD","non_qualified":null,"image":"1f446-1f3fd.png","sheet_x":12,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F446-1F3FE","non_qualified":null,"image":"1f446-1f3fe.png","sheet_x":13,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F446-1F3FF","non_qualified":null,"image":"1f446-1f3ff.png","sheet_x":13,"sheet_y":1,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Up Pointing Backhand Index","b":"1F446","d":true,"e":true,"f":true,"h":true,"j":["fingers","hand","direction","up"],"k":[12,53],"o":2},"kiwifruit":{"a":"Kiwifruit","b":"1F95D","d":true,"e":true,"f":true,"h":true,"k":[41,44],"o":4},"children_crossing":{"a":"Children Crossing","b":"1F6B8","d":true,"e":true,"f":true,"h":true,"j":["school","warning","danger","sign","driving","yellow-diamond"],"k":[36,9],"o":2},"national_park":{"a":"National Park","b":"1F3DE-FE0F","c":"1F3DE","d":true,"e":true,"f":true,"h":true,"j":["photo","environment","nature"],"k":[10,49],"o":2},"no_entry":{"a":"No Entry","b":"26D4","d":true,"e":true,"f":true,"h":true,"j":["limit","security","privacy","bad","denied","stop","circle"],"k":[54,8],"o":2},"one-piece_swimsuit":{"a":"One-Piece Swimsuit","b":"1FA71","d":true,"e":true,"f":true,"h":true,"k":[51,52],"o":12},"tiger":{"a":"Tiger Face","b":"1F42F","d":true,"e":true,"f":true,"h":true,"j":["animal","cat","danger","wild","nature","roar"],"k":[12,19],"o":2},"red_envelope":{"a":"Red Gift Envelope","b":"1F9E7","d":true,"e":true,"f":true,"h":true,"k":[51,26],"o":11},"star-struck":{"a":"Grinning Face with Star Eyes","b":"1F929","d":true,"e":true,"f":true,"h":true,"k":[38,43],"n":["grinning_face_with_star_eyes"],"o":5},"middle_finger":{"skin_variations":{"1F3FB":{"unified":"1F595-1F3FB","non_qualified":null,"image":"1f595-1f3fb.png","sheet_x":29,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F595-1F3FC","non_qualified":null,"image":"1f595-1f3fc.png","sheet_x":29,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F595-1F3FD","non_qualified":null,"image":"1f595-1f3fd.png","sheet_x":30,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F595-1F3FE","non_qualified":null,"image":"1f595-1f3fe.png","sheet_x":30,"sheet_y":1,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F595-1F3FF","non_qualified":null,"image":"1f595-1f3ff.png","sheet_x":30,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Reversed Hand with Middle Finger Extended","b":"1F595","d":true,"e":true,"f":true,"h":true,"k":[29,54],"n":["reversed_hand_with_middle_finger_extended"],"o":2},"flag-ao":{"a":"Angola Flag","b":"1F1E6-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[0,39],"o":2},"tomato":{"a":"Tomato","b":"1F345","d":true,"e":true,"f":true,"h":true,"j":["fruit","vegetable","nature","food"],"k":[6,29],"o":2},"coconut":{"a":"Coconut","b":"1F965","d":true,"e":true,"f":true,"h":true,"k":[41,52],"o":5},"ribbon":{"a":"Ribbon","b":"1F380","d":true,"e":true,"f":true,"h":true,"j":["decoration","pink","girl","bowtie"],"k":[7,31],"o":2},"no_entry_sign":{"a":"No Entry Sign","b":"1F6AB","d":true,"e":true,"f":true,"h":true,"j":["forbid","stop","limit","denied","disallow","circle"],"k":[35,2],"o":2},"point_down":{"skin_variations":{"1F3FB":{"unified":"1F447-1F3FB","non_qualified":null,"image":"1f447-1f3fb.png","sheet_x":13,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F447-1F3FC","non_qualified":null,"image":"1f447-1f3fc.png","sheet_x":13,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F447-1F3FD","non_qualified":null,"image":"1f447-1f3fd.png","sheet_x":13,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F447-1F3FE","non_qualified":null,"image":"1f447-1f3fe.png","sheet_x":13,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F447-1F3FF","non_qualified":null,"image":"1f447-1f3ff.png","sheet_x":13,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Down Pointing Backhand Index","b":"1F447","d":true,"e":true,"f":true,"h":true,"j":["fingers","hand","direction","down"],"k":[13,2],"o":2},"flag-aq":{"a":"Antarctica Flag","b":"1F1E6-1F1F6","d":true,"e":true,"f":true,"h":true,"k":[0,40],"o":2},"briefs":{"a":"Briefs","b":"1FA72","d":true,"e":true,"f":true,"h":true,"k":[51,53],"o":12},"kissing_heart":{"a":"Face Throwing a Kiss","b":"1F618","d":true,"e":true,"f":true,"h":true,"j":["face","love","like","affection","valentines","infatuation","kiss"],"k":[31,2],"l":[":*",":-*"],"o":2},"tiger2":{"a":"Tiger","b":"1F405","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","roar"],"k":[11,33],"o":2},"stadium":{"a":"Stadium","b":"1F3DF-FE0F","c":"1F3DF","d":true,"e":true,"f":true,"h":true,"j":["photo","place","sports","concert","venue"],"k":[10,50],"o":2},"leopard":{"a":"Leopard","b":"1F406","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[11,34],"o":2},"no_bicycles":{"a":"No Bicycles","b":"1F6B3","d":true,"e":true,"f":true,"h":true,"j":["cyclist","prohibited","circle"],"k":[35,10],"o":2},"kissing":{"a":"Kissing Face","b":"1F617","d":true,"e":true,"f":true,"h":true,"j":["love","like","face","3","valentines","infatuation","kiss"],"k":[31,1],"o":2},"flag-ar":{"a":"Argentina Flag","b":"1F1E6-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[0,41],"o":2},"avocado":{"a":"Avocado","b":"1F951","d":true,"e":true,"f":true,"h":true,"j":["fruit","food"],"k":[41,32],"o":4},"point_up":{"skin_variations":{"1F3FB":{"unified":"261D-1F3FB","non_qualified":null,"image":"261d-1f3fb.png","sheet_x":53,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"261D-1F3FC","non_qualified":null,"image":"261d-1f3fc.png","sheet_x":53,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"261D-1F3FD","non_qualified":null,"image":"261d-1f3fd.png","sheet_x":53,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"261D-1F3FE","non_qualified":null,"image":"261d-1f3fe.png","sheet_x":53,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"261D-1F3FF","non_qualified":null,"image":"261d-1f3ff.png","sheet_x":53,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Up Pointing Index","b":"261D-FE0F","c":"261D","d":true,"e":true,"f":true,"h":true,"j":["hand","fingers","direction","up"],"k":[53,2],"o":2},"gift":{"a":"Wrapped Present","b":"1F381","d":true,"e":true,"f":true,"h":true,"j":["present","birthday","christmas","xmas"],"k":[7,32],"o":2},"classical_building":{"a":"Classical Building","b":"1F3DB-FE0F","c":"1F3DB","d":true,"e":true,"f":true,"h":true,"j":["art","culture","history"],"k":[10,46],"o":2},"shorts":{"a":"Shorts","b":"1FA73","d":true,"e":true,"f":true,"h":true,"k":[51,54],"o":12},"+1":{"skin_variations":{"1F3FB":{"unified":"1F44D-1F3FB","non_qualified":null,"image":"1f44d-1f3fb.png","sheet_x":13,"sheet_y":39,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44D-1F3FC","non_qualified":null,"image":"1f44d-1f3fc.png","sheet_x":13,"sheet_y":40,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44D-1F3FD","non_qualified":null,"image":"1f44d-1f3fd.png","sheet_x":13,"sheet_y":41,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44D-1F3FE","non_qualified":null,"image":"1f44d-1f3fe.png","sheet_x":13,"sheet_y":42,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44D-1F3FF","non_qualified":null,"image":"1f44d-1f3ff.png","sheet_x":13,"sheet_y":43,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Thumbs Up Sign","b":"1F44D","d":true,"e":true,"f":true,"h":true,"j":["thumbsup","yes","awesome","good","agree","accept","cool","hand","like"],"k":[13,38],"n":["thumbsup"],"o":2},"horse":{"a":"Horse Face","b":"1F434","d":true,"e":true,"f":true,"h":true,"j":["animal","brown","nature"],"k":[12,24],"o":2},"bikini":{"a":"Bikini","b":"1F459","d":true,"e":true,"f":true,"h":true,"j":["swimming","female","woman","girl","fashion","beach","summer"],"k":[14,13],"o":2},"no_smoking":{"a":"No Smoking Symbol","b":"1F6AD","d":true,"e":true,"f":true,"h":true,"j":["cigarette","blue-square","smell","smoke"],"k":[35,4],"o":2},"eggplant":{"a":"Aubergine","b":"1F346","d":true,"e":true,"f":true,"h":true,"j":["vegetable","nature","food","aubergine"],"k":[6,30],"o":2},"flag-as":{"a":"American Samoa Flag","b":"1F1E6-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[0,42],"o":2},"reminder_ribbon":{"a":"Reminder Ribbon","b":"1F397-FE0F","c":"1F397","d":true,"e":true,"f":true,"h":true,"j":["sports","cause","support","awareness"],"k":[8,0],"o":2},"building_construction":{"a":"Building Construction","b":"1F3D7-FE0F","c":"1F3D7","d":true,"e":true,"f":true,"h":true,"j":["wip","working","progress"],"k":[10,42],"o":2},"relaxed":{"a":"White Smiling Face","b":"263A-FE0F","c":"263A","d":true,"e":true,"f":true,"h":true,"j":["face","blush","massage","happiness"],"k":[53,17],"o":2},"kissing_closed_eyes":{"a":"Kissing Face with Closed Eyes","b":"1F61A","d":true,"e":true,"f":true,"h":true,"j":["face","love","like","affection","valentines","infatuation","kiss"],"k":[31,4],"o":2},"-1":{"skin_variations":{"1F3FB":{"unified":"1F44E-1F3FB","non_qualified":null,"image":"1f44e-1f3fb.png","sheet_x":13,"sheet_y":45,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44E-1F3FC","non_qualified":null,"image":"1f44e-1f3fc.png","sheet_x":13,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44E-1F3FD","non_qualified":null,"image":"1f44e-1f3fd.png","sheet_x":13,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44E-1F3FE","non_qualified":null,"image":"1f44e-1f3fe.png","sheet_x":13,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44E-1F3FF","non_qualified":null,"image":"1f44e-1f3ff.png","sheet_x":13,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Thumbs Down Sign","b":"1F44E","d":true,"e":true,"f":true,"h":true,"j":["thumbsdown","no","dislike","hand"],"k":[13,44],"n":["thumbsdown"],"o":2},"admission_tickets":{"a":"Admission Tickets","b":"1F39F-FE0F","c":"1F39F","d":true,"e":true,"f":true,"h":true,"k":[8,5],"o":2},"flag-at":{"a":"Austria Flag","b":"1F1E6-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[0,43],"o":2},"womans_clothes":{"a":"Womans Clothes","b":"1F45A","d":true,"e":true,"f":true,"h":true,"j":["fashion","shopping_bags","female"],"k":[14,14],"o":2},"do_not_litter":{"a":"Do Not Litter Symbol","b":"1F6AF","d":true,"e":true,"f":true,"h":true,"j":["trash","bin","garbage","circle"],"k":[35,6],"o":2},"potato":{"a":"Potato","b":"1F954","d":true,"e":true,"f":true,"h":true,"j":["food","tuber","vegatable","starch"],"k":[41,35],"o":4},"racehorse":{"a":"Horse","b":"1F40E","d":true,"e":true,"f":true,"h":true,"j":["animal","gamble","luck"],"k":[11,42],"o":2},"bricks":{"a":"Brick","b":"1F9F1","d":true,"e":true,"f":true,"h":true,"k":[51,36],"o":11},"fist":{"skin_variations":{"1F3FB":{"unified":"270A-1F3FB","non_qualified":null,"image":"270a-1f3fb.png","sheet_x":54,"sheet_y":44,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"270A-1F3FC","non_qualified":null,"image":"270a-1f3fc.png","sheet_x":54,"sheet_y":45,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"270A-1F3FD","non_qualified":null,"image":"270a-1f3fd.png","sheet_x":54,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"270A-1F3FE","non_qualified":null,"image":"270a-1f3fe.png","sheet_x":54,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"270A-1F3FF","non_qualified":null,"image":"270a-1f3ff.png","sheet_x":54,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Raised Fist","b":"270A","d":true,"e":true,"f":true,"h":true,"j":["fingers","hand","grasp"],"k":[54,43],"o":2},"house_buildings":{"a":"House Buildings","b":"1F3D8-FE0F","c":"1F3D8","d":true,"e":true,"f":true,"h":true,"k":[10,43],"o":2},"carrot":{"a":"Carrot","b":"1F955","d":true,"e":true,"f":true,"h":true,"j":["vegetable","food","orange"],"k":[41,36],"o":4},"ticket":{"a":"Ticket","b":"1F3AB","d":true,"e":true,"f":true,"h":true,"j":["event","concert","pass"],"k":[8,17],"o":2},"flag-au":{"a":"Australia Flag","b":"1F1E6-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[0,44],"o":2},"non-potable_water":{"a":"Non-Potable Water Symbol","b":"1F6B1","d":true,"e":true,"f":true,"h":true,"j":["drink","faucet","tap","circle"],"k":[35,8],"o":2},"purse":{"a":"Purse","b":"1F45B","d":true,"e":true,"f":true,"h":true,"j":["fashion","accessories","money","sales","shopping"],"k":[14,15],"o":2},"unicorn_face":{"a":"Unicorn Face","b":"1F984","d":true,"e":true,"f":true,"h":true,"k":[42,22],"o":2},"kissing_smiling_eyes":{"a":"Kissing Face with Smiling Eyes","b":"1F619","d":true,"e":true,"f":true,"h":true,"j":["face","affection","valentines","infatuation","kiss"],"k":[31,3],"o":2},"facepunch":{"skin_variations":{"1F3FB":{"unified":"1F44A-1F3FB","non_qualified":null,"image":"1f44a-1f3fb.png","sheet_x":13,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44A-1F3FC","non_qualified":null,"image":"1f44a-1f3fc.png","sheet_x":13,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44A-1F3FD","non_qualified":null,"image":"1f44a-1f3fd.png","sheet_x":13,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44A-1F3FE","non_qualified":null,"image":"1f44a-1f3fe.png","sheet_x":13,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44A-1F3FF","non_qualified":null,"image":"1f44a-1f3ff.png","sheet_x":13,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Fisted Hand Sign","b":"1F44A","d":true,"e":true,"f":true,"h":true,"j":["angry","violence","fist","hit","attack","hand"],"k":[13,20],"n":["punch"],"o":2},"medal":{"a":"Medal","b":"1F396-FE0F","c":"1F396","d":true,"e":true,"f":true,"h":true,"k":[7,56],"o":2},"zebra_face":{"a":"Zebra Face","b":"1F993","d":true,"e":true,"f":true,"h":true,"k":[42,37],"o":5},"handbag":{"a":"Handbag","b":"1F45C","d":true,"e":true,"f":true,"h":true,"j":["fashion","accessory","accessories","shopping"],"k":[14,16],"o":2},"derelict_house_building":{"a":"Derelict House Building","b":"1F3DA-FE0F","c":"1F3DA","d":true,"e":true,"f":true,"h":true,"k":[10,45],"o":2},"yum":{"a":"Face Savouring Delicious Food","b":"1F60B","d":true,"e":true,"f":true,"h":true,"j":["happy","joy","tongue","smile","face","silly","yummy","nom","delicious","savouring"],"k":[30,46],"o":2},"corn":{"a":"Ear of Maize","b":"1F33D","d":true,"e":true,"f":true,"h":true,"j":["food","vegetable","plant"],"k":[6,21],"o":2},"flag-aw":{"a":"Aruba Flag","b":"1F1E6-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[0,45],"o":2},"no_pedestrians":{"a":"No Pedestrians","b":"1F6B7","d":true,"e":true,"f":true,"h":true,"j":["rules","crossing","walking","circle"],"k":[36,8],"o":2},"house":{"a":"House Building","b":"1F3E0","d":true,"e":true,"f":true,"h":true,"j":["building","home"],"k":[10,51],"o":2},"hot_pepper":{"a":"Hot Pepper","b":"1F336-FE0F","c":"1F336","d":true,"e":true,"f":true,"h":true,"j":["food","spicy","chilli","chili"],"k":[6,14],"o":2},"flag-ax":{"a":"\xc5land Islands Flag","b":"1F1E6-1F1FD","d":true,"e":true,"f":true,"h":true,"k":[0,46],"o":2},"trophy":{"a":"Trophy","b":"1F3C6","d":true,"e":true,"f":true,"h":true,"j":["win","award","contest","place","ftw","ceremony"],"k":[9,26],"o":2},"deer":{"a":"Deer","b":"1F98C","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","horns","venison"],"k":[42,30],"o":4},"left-facing_fist":{"skin_variations":{"1F3FB":{"unified":"1F91B-1F3FB","non_qualified":null,"image":"1f91b-1f3fb.png","sheet_x":37,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F91B-1F3FC","non_qualified":null,"image":"1f91b-1f3fc.png","sheet_x":37,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F91B-1F3FD","non_qualified":null,"image":"1f91b-1f3fd.png","sheet_x":37,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F91B-1F3FE","non_qualified":null,"image":"1f91b-1f3fe.png","sheet_x":37,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F91B-1F3FF","non_qualified":null,"image":"1f91b-1f3ff.png","sheet_x":37,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Left-Facing Fist","b":"1F91B","d":true,"e":true,"f":true,"h":true,"k":[37,49],"o":4},"stuck_out_tongue":{"a":"Face with Stuck-out Tongue","b":"1F61B","d":true,"e":true,"f":true,"h":true,"j":["face","prank","childish","playful","mischievous","smile","tongue"],"k":[31,5],"l":[":p",":-p",":P",":-P",":b",":-b"],"m":":p","o":2},"pouch":{"a":"Pouch","b":"1F45D","d":true,"e":true,"f":true,"h":true,"j":["bag","accessories","shopping"],"k":[14,17],"o":2},"no_mobile_phones":{"a":"No Mobile Phones","b":"1F4F5","d":true,"e":true,"f":true,"h":true,"j":["iphone","mute","circle"],"k":[27,18],"o":2},"stuck_out_tongue_winking_eye":{"a":"Face with Stuck-out Tongue and Winking Eye","b":"1F61C","d":true,"e":true,"f":true,"h":true,"j":["face","prank","childish","playful","mischievous","smile","wink","tongue"],"k":[31,6],"l":[";p",";-p",";b",";-b",";P",";-P"],"m":";p","o":2},"sports_medal":{"a":"Sports Medal","b":"1F3C5","d":true,"e":true,"f":true,"h":true,"k":[9,25],"o":2},"cucumber":{"a":"Cucumber","b":"1F952","d":true,"e":true,"f":true,"h":true,"j":["fruit","food","pickle"],"k":[41,33],"o":4},"cow":{"a":"Cow Face","b":"1F42E","d":true,"e":true,"f":true,"h":true,"j":["beef","ox","animal","nature","moo","milk"],"k":[12,18],"o":2},"underage":{"a":"No One Under Eighteen Symbol","b":"1F51E","d":true,"e":true,"f":true,"h":true,"j":["18","drink","pub","night","minor","circle"],"k":[28,1],"o":2},"flag-az":{"a":"Azerbaijan Flag","b":"1F1E6-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[0,47],"o":2},"shopping_bags":{"a":"Shopping Bags","b":"1F6CD-FE0F","c":"1F6CD","d":true,"e":true,"f":true,"h":true,"k":[36,35],"o":2},"right-facing_fist":{"skin_variations":{"1F3FB":{"unified":"1F91C-1F3FB","non_qualified":null,"image":"1f91c-1f3fb.png","sheet_x":37,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F91C-1F3FC","non_qualified":null,"image":"1f91c-1f3fc.png","sheet_x":38,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F91C-1F3FD","non_qualified":null,"image":"1f91c-1f3fd.png","sheet_x":38,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F91C-1F3FE","non_qualified":null,"image":"1f91c-1f3fe.png","sheet_x":38,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F91C-1F3FF","non_qualified":null,"image":"1f91c-1f3ff.png","sheet_x":38,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Right-Facing Fist","b":"1F91C","d":true,"e":true,"f":true,"h":true,"k":[37,55],"o":4},"house_with_garden":{"a":"House with Garden","b":"1F3E1","d":true,"e":true,"f":true,"h":true,"j":["home","plant","nature"],"k":[10,52],"o":2},"clap":{"skin_variations":{"1F3FB":{"unified":"1F44F-1F3FB","non_qualified":null,"image":"1f44f-1f3fb.png","sheet_x":13,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F44F-1F3FC","non_qualified":null,"image":"1f44f-1f3fc.png","sheet_x":13,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F44F-1F3FD","non_qualified":null,"image":"1f44f-1f3fd.png","sheet_x":13,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F44F-1F3FE","non_qualified":null,"image":"1f44f-1f3fe.png","sheet_x":13,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F44F-1F3FF","non_qualified":null,"image":"1f44f-1f3ff.png","sheet_x":13,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Clapping Hands Sign","b":"1F44F","d":true,"e":true,"f":true,"h":true,"j":["hands","praise","applause","congrats","yay"],"k":[13,50],"o":2},"leafy_green":{"a":"Leafy Green","b":"1F96C","d":true,"e":true,"f":true,"h":true,"k":[42,2],"o":11},"office":{"a":"Office Building","b":"1F3E2","d":true,"e":true,"f":true,"h":true,"j":["building","bureau","work"],"k":[10,53],"o":2},"flag-ba":{"a":"Bosnia & Herzegovina Flag","b":"1F1E7-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[0,48],"o":2},"zany_face":{"a":"Grinning Face with One Large and One Small Eye","b":"1F92A","d":true,"e":true,"f":true,"h":true,"k":[38,44],"n":["grinning_face_with_one_large_and_one_small_eye"],"o":5},"first_place_medal":{"a":"First Place Medal","b":"1F947","d":true,"e":true,"f":true,"h":true,"k":[41,22],"o":4},"ox":{"a":"Ox","b":"1F402","d":true,"e":true,"f":true,"h":true,"j":["animal","cow","beef"],"k":[11,30],"o":2},"school_satchel":{"a":"School Satchel","b":"1F392","d":true,"e":true,"f":true,"h":true,"j":["student","education","bag","backpack"],"k":[7,54],"o":2},"radioactive_sign":{"a":"Radioactive Sign","b":"2622-FE0F","c":"2622","d":true,"e":true,"f":true,"h":true,"k":[53,9],"o":2},"second_place_medal":{"a":"Second Place Medal","b":"1F948","d":true,"e":true,"f":true,"h":true,"k":[41,23],"o":4},"stuck_out_tongue_closed_eyes":{"a":"Face with Stuck-out Tongue and Tightly-Closed Eyes","b":"1F61D","d":true,"e":true,"f":true,"h":true,"j":["face","prank","playful","mischievous","smile","tongue"],"k":[31,7],"o":2},"broccoli":{"a":"Broccoli","b":"1F966","d":true,"e":true,"f":true,"h":true,"k":[41,53],"o":5},"biohazard_sign":{"a":"Biohazard Sign","b":"2623-FE0F","c":"2623","d":true,"e":true,"f":true,"h":true,"k":[53,10],"o":2},"mans_shoe":{"a":"Mans Shoe","b":"1F45E","d":true,"e":true,"f":true,"h":true,"j":["fashion","male"],"k":[14,18],"n":["shoe"],"o":2},"raised_hands":{"skin_variations":{"1F3FB":{"unified":"1F64C-1F3FB","non_qualified":null,"image":"1f64c-1f3fb.png","sheet_x":33,"sheet_y":9,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64C-1F3FC","non_qualified":null,"image":"1f64c-1f3fc.png","sheet_x":33,"sheet_y":10,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64C-1F3FD","non_qualified":null,"image":"1f64c-1f3fd.png","sheet_x":33,"sheet_y":11,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64C-1F3FE","non_qualified":null,"image":"1f64c-1f3fe.png","sheet_x":33,"sheet_y":12,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64C-1F3FF","non_qualified":null,"image":"1f64c-1f3ff.png","sheet_x":33,"sheet_y":13,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Person Raising Both Hands in Celebration","b":"1F64C","d":true,"e":true,"f":true,"h":true,"j":["gesture","hooray","yea","celebration","hands"],"k":[33,8],"o":2},"post_office":{"a":"Japanese Post Office","b":"1F3E3","d":true,"e":true,"f":true,"h":true,"j":["building","envelope","communication"],"k":[10,54],"o":2},"flag-bb":{"a":"Barbados Flag","b":"1F1E7-1F1E7","d":true,"e":true,"f":true,"h":true,"k":[0,49],"o":2},"water_buffalo":{"a":"Water Buffalo","b":"1F403","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","ox","cow"],"k":[11,31],"o":2},"third_place_medal":{"a":"Third Place Medal","b":"1F949","d":true,"e":true,"f":true,"h":true,"k":[41,24],"o":4},"european_post_office":{"a":"European Post Office","b":"1F3E4","d":true,"e":true,"f":true,"h":true,"j":["building","email"],"k":[10,55],"o":2},"athletic_shoe":{"a":"Athletic Shoe","b":"1F45F","d":true,"e":true,"f":true,"h":true,"j":["shoes","sports","sneakers"],"k":[14,19],"o":2},"arrow_up":{"a":"Upwards Black Arrow","b":"2B06-FE0F","c":"2B06","d":true,"e":true,"f":true,"h":true,"j":["blue-square","continue","top","direction"],"k":[55,38],"o":2},"cow2":{"a":"Cow","b":"1F404","d":true,"e":true,"f":true,"h":true,"j":["beef","ox","animal","nature","moo","milk"],"k":[11,32],"o":2},"open_hands":{"skin_variations":{"1F3FB":{"unified":"1F450-1F3FB","non_qualified":null,"image":"1f450-1f3fb.png","sheet_x":14,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F450-1F3FC","non_qualified":null,"image":"1f450-1f3fc.png","sheet_x":14,"sheet_y":1,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F450-1F3FD","non_qualified":null,"image":"1f450-1f3fd.png","sheet_x":14,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F450-1F3FE","non_qualified":null,"image":"1f450-1f3fe.png","sheet_x":14,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F450-1F3FF","non_qualified":null,"image":"1f450-1f3ff.png","sheet_x":14,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Open Hands Sign","b":"1F450","d":true,"e":true,"f":true,"h":true,"j":["fingers","butterfly","hands","open"],"k":[13,56],"o":2},"garlic":{"a":"Garlic","b":"1F9C4","d":true,"e":true,"f":true,"h":true,"k":[44,12],"o":12},"money_mouth_face":{"a":"Money-Mouth Face","b":"1F911","d":true,"e":true,"f":true,"h":true,"j":["face","rich","dollar","money"],"k":[37,24],"o":2},"flag-bd":{"a":"Bangladesh Flag","b":"1F1E7-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[0,50],"o":2},"soccer":{"a":"Soccer Ball","b":"26BD","d":true,"e":true,"f":true,"h":true,"j":["sports","football"],"k":[53,56],"o":2},"hugging_face":{"a":"Hugging Face","b":"1F917","d":true,"e":true,"f":true,"h":true,"k":[37,30],"o":2},"onion":{"a":"Onion","b":"1F9C5","d":true,"e":true,"f":true,"h":true,"k":[44,13],"o":12},"arrow_upper_right":{"a":"North East Arrow","b":"2197-FE0F","c":"2197","d":true,"e":true,"f":true,"h":true,"j":["blue-square","point","direction","diagonal","northeast"],"k":[52,17],"o":2},"palms_up_together":{"skin_variations":{"1F3FB":{"unified":"1F932-1F3FB","non_qualified":null,"image":"1f932-1f3fb.png","sheet_x":39,"sheet_y":6,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F932-1F3FC","non_qualified":null,"image":"1f932-1f3fc.png","sheet_x":39,"sheet_y":7,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F932-1F3FD","non_qualified":null,"image":"1f932-1f3fd.png","sheet_x":39,"sheet_y":8,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F932-1F3FE","non_qualified":null,"image":"1f932-1f3fe.png","sheet_x":39,"sheet_y":9,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F932-1F3FF","non_qualified":null,"image":"1f932-1f3ff.png","sheet_x":39,"sheet_y":10,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Palms Up Together","b":"1F932","d":true,"e":true,"f":true,"h":true,"k":[39,5],"o":5},"pig":{"a":"Pig Face","b":"1F437","d":true,"e":true,"f":true,"h":true,"j":["animal","oink","nature"],"k":[12,27],"o":2},"hospital":{"a":"Hospital","b":"1F3E5","d":true,"e":true,"f":true,"h":true,"j":["building","health","surgery","doctor"],"k":[10,56],"o":2},"hiking_boot":{"a":"Hiking Boot","b":"1F97E","d":true,"e":true,"f":true,"h":true,"k":[42,16],"o":11},"flag-be":{"a":"Belgium Flag","b":"1F1E7-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[0,51],"o":2},"flag-bf":{"a":"Burkina Faso Flag","b":"1F1E7-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[0,52],"o":2},"mushroom":{"a":"Mushroom","b":"1F344","d":true,"e":true,"f":true,"h":true,"j":["plant","vegetable"],"k":[6,28],"o":2},"pig2":{"a":"Pig","b":"1F416","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[11,51],"o":2},"baseball":{"a":"Baseball","b":"26BE","d":true,"e":true,"f":true,"h":true,"j":["sports","balls"],"k":[54,0],"o":2},"face_with_hand_over_mouth":{"a":"Smiling Face with Smiling Eyes and Hand Covering Mouth","b":"1F92D","d":true,"e":true,"f":true,"h":true,"k":[38,47],"n":["smiling_face_with_smiling_eyes_and_hand_covering_mouth"],"o":5},"handshake":{"a":"Handshake","b":"1F91D","d":true,"e":true,"f":true,"h":true,"j":["agreement","shake"],"k":[38,4],"o":4},"womans_flat_shoe":{"a":"Flat Shoe","b":"1F97F","d":true,"e":true,"f":true,"h":true,"k":[42,17],"o":11},"bank":{"a":"Bank","b":"1F3E6","d":true,"e":true,"f":true,"h":true,"j":["building","money","sales","cash","business","enterprise"],"k":[11,0],"o":2},"arrow_right":{"a":"Black Rightwards Arrow","b":"27A1-FE0F","c":"27A1","d":true,"e":true,"f":true,"h":true,"j":["blue-square","next"],"k":[55,32],"o":2},"peanuts":{"a":"Peanuts","b":"1F95C","d":true,"e":true,"f":true,"h":true,"j":["food","nut"],"k":[41,43],"o":4},"shushing_face":{"a":"Face with Finger Covering Closed Lips","b":"1F92B","d":true,"e":true,"f":true,"h":true,"k":[38,45],"n":["face_with_finger_covering_closed_lips"],"o":5},"pray":{"skin_variations":{"1F3FB":{"unified":"1F64F-1F3FB","non_qualified":null,"image":"1f64f-1f3fb.png","sheet_x":33,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64F-1F3FC","non_qualified":null,"image":"1f64f-1f3fc.png","sheet_x":33,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64F-1F3FD","non_qualified":null,"image":"1f64f-1f3fd.png","sheet_x":33,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64F-1F3FE","non_qualified":null,"image":"1f64f-1f3fe.png","sheet_x":33,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64F-1F3FF","non_qualified":null,"image":"1f64f-1f3ff.png","sheet_x":33,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Person with Folded Hands","b":"1F64F","d":true,"e":true,"f":true,"h":true,"j":["please","hope","wish","namaste","highfive"],"k":[33,50],"o":2},"softball":{"a":"Softball","b":"1F94E","d":true,"e":true,"f":true,"h":true,"k":[41,29],"o":11},"high_heel":{"a":"High-Heeled Shoe","b":"1F460","d":true,"e":true,"f":true,"h":true,"j":["fashion","shoes","female","pumps","stiletto"],"k":[14,20],"o":2},"flag-bg":{"a":"Bulgaria Flag","b":"1F1E7-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[0,53],"o":2},"arrow_lower_right":{"a":"South East Arrow","b":"2198-FE0F","c":"2198","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","diagonal","southeast"],"k":[52,18],"o":2},"hotel":{"a":"Hotel","b":"1F3E8","d":true,"e":true,"f":true,"h":true,"j":["building","accomodation","checkin"],"k":[11,2],"o":2},"boar":{"a":"Boar","b":"1F417","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[11,52],"o":2},"sandal":{"a":"Womans Sandal","b":"1F461","d":true,"e":true,"f":true,"h":true,"j":["shoes","fashion","flip flops"],"k":[14,21],"o":2},"flag-bh":{"a":"Bahrain Flag","b":"1F1E7-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[0,54],"o":2},"arrow_down":{"a":"Downwards Black Arrow","b":"2B07-FE0F","c":"2B07","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","bottom"],"k":[55,39],"o":2},"thinking_face":{"a":"Thinking Face","b":"1F914","d":true,"e":true,"f":true,"h":true,"k":[37,27],"o":2},"writing_hand":{"skin_variations":{"1F3FB":{"unified":"270D-1F3FB","non_qualified":null,"image":"270d-1f3fb.png","sheet_x":55,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"270D-1F3FC","non_qualified":null,"image":"270d-1f3fc.png","sheet_x":55,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"270D-1F3FD","non_qualified":null,"image":"270d-1f3fd.png","sheet_x":55,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"270D-1F3FE","non_qualified":null,"image":"270d-1f3fe.png","sheet_x":55,"sheet_y":8,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"270D-1F3FF","non_qualified":null,"image":"270d-1f3ff.png","sheet_x":55,"sheet_y":9,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Writing Hand","b":"270D-FE0F","c":"270D","d":true,"e":true,"f":true,"h":true,"j":["lower_left_ballpoint_pen","stationery","write","compose"],"k":[55,4],"o":2},"chestnut":{"a":"Chestnut","b":"1F330","d":true,"e":true,"f":true,"h":true,"j":["food","squirrel"],"k":[6,8],"o":2},"basketball":{"a":"Basketball and Hoop","b":"1F3C0","d":true,"e":true,"f":true,"h":true,"j":["sports","balls","NBA"],"k":[8,38],"o":2},"pig_nose":{"a":"Pig Nose","b":"1F43D","d":true,"e":true,"f":true,"h":true,"j":["animal","oink"],"k":[12,33],"o":2},"love_hotel":{"a":"Love Hotel","b":"1F3E9","d":true,"e":true,"f":true,"h":true,"j":["like","affection","dating"],"k":[11,3],"o":2},"nail_care":{"skin_variations":{"1F3FB":{"unified":"1F485-1F3FB","non_qualified":null,"image":"1f485-1f3fb.png","sheet_x":24,"sheet_y":34,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F485-1F3FC","non_qualified":null,"image":"1f485-1f3fc.png","sheet_x":24,"sheet_y":35,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F485-1F3FD","non_qualified":null,"image":"1f485-1f3fd.png","sheet_x":24,"sheet_y":36,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F485-1F3FE","non_qualified":null,"image":"1f485-1f3fe.png","sheet_x":24,"sheet_y":37,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F485-1F3FF","non_qualified":null,"image":"1f485-1f3ff.png","sheet_x":24,"sheet_y":38,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Nail Polish","b":"1F485","d":true,"e":true,"f":true,"h":true,"j":["beauty","manicure","finger","fashion","nail"],"k":[24,33],"o":2},"volleyball":{"a":"Volleyball","b":"1F3D0","d":true,"e":true,"f":true,"h":true,"j":["sports","balls"],"k":[10,35],"o":2},"flag-bi":{"a":"Burundi Flag","b":"1F1E7-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[0,55],"o":2},"arrow_lower_left":{"a":"South West Arrow","b":"2199-FE0F","c":"2199","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","diagonal","southwest"],"k":[52,19],"o":2},"ram":{"a":"Ram","b":"1F40F","d":true,"e":true,"f":true,"h":true,"j":["animal","sheep","nature"],"k":[11,43],"o":2},"ballet_shoes":{"a":"Ballet Shoes","b":"1FA70","d":true,"e":true,"f":true,"h":true,"k":[51,51],"o":12},"zipper_mouth_face":{"a":"Zipper-Mouth Face","b":"1F910","d":true,"e":true,"f":true,"h":true,"j":["face","sealed","zipper","secret"],"k":[37,23],"o":2},"bread":{"a":"Bread","b":"1F35E","d":true,"e":true,"f":true,"h":true,"j":["food","wheat","breakfast","toast"],"k":[6,54],"o":2},"convenience_store":{"a":"Convenience Store","b":"1F3EA","d":true,"e":true,"f":true,"h":true,"j":["building","shopping","groceries"],"k":[11,4],"o":2},"boot":{"a":"Womans Boots","b":"1F462","d":true,"e":true,"f":true,"h":true,"j":["shoes","fashion"],"k":[14,22],"o":2},"sheep":{"a":"Sheep","b":"1F411","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","wool","shipit"],"k":[11,45],"o":2},"face_with_raised_eyebrow":{"a":"Face with One Eyebrow Raised","b":"1F928","d":true,"e":true,"f":true,"h":true,"k":[38,42],"n":["face_with_one_eyebrow_raised"],"o":5},"flag-bj":{"a":"Benin Flag","b":"1F1E7-1F1EF","d":true,"e":true,"f":true,"h":true,"k":[0,56],"o":2},"arrow_left":{"a":"Leftwards Black Arrow","b":"2B05-FE0F","c":"2B05","d":true,"e":true,"f":true,"h":true,"j":["blue-square","previous","back"],"k":[55,37],"o":2},"selfie":{"skin_variations":{"1F3FB":{"unified":"1F933-1F3FB","non_qualified":null,"image":"1f933-1f3fb.png","sheet_x":39,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F933-1F3FC","non_qualified":null,"image":"1f933-1f3fc.png","sheet_x":39,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F933-1F3FD","non_qualified":null,"image":"1f933-1f3fd.png","sheet_x":39,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F933-1F3FE","non_qualified":null,"image":"1f933-1f3fe.png","sheet_x":39,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F933-1F3FF","non_qualified":null,"image":"1f933-1f3ff.png","sheet_x":39,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Selfie","b":"1F933","d":true,"e":true,"f":true,"h":true,"j":["camera","phone"],"k":[39,11],"o":4},"croissant":{"a":"Croissant","b":"1F950","d":true,"e":true,"f":true,"h":true,"j":["food","bread","french"],"k":[41,31],"o":4},"school":{"a":"School","b":"1F3EB","d":true,"e":true,"f":true,"h":true,"j":["building","student","education","learn","teach"],"k":[11,5],"o":2},"football":{"a":"American Football","b":"1F3C8","d":true,"e":true,"f":true,"h":true,"j":["sports","balls","NFL"],"k":[9,33],"o":2},"goat":{"a":"Goat","b":"1F410","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[11,44],"o":2},"department_store":{"a":"Department Store","b":"1F3EC","d":true,"e":true,"f":true,"h":true,"j":["building","shopping","mall"],"k":[11,6],"o":2},"flag-bl":{"a":"St. Barth\xe9lemy Flag","b":"1F1E7-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[1,0],"o":2},"crown":{"a":"Crown","b":"1F451","d":true,"e":true,"f":true,"h":true,"j":["king","kod","leader","royalty","lord"],"k":[14,5],"o":2},"arrow_upper_left":{"a":"North West Arrow","b":"2196-FE0F","c":"2196","d":true,"e":true,"f":true,"h":true,"j":["blue-square","point","direction","diagonal","northwest"],"k":[52,16],"o":2},"neutral_face":{"a":"Neutral Face","b":"1F610","d":true,"e":true,"f":true,"h":true,"j":["indifference","meh",":|","neutral"],"k":[30,51],"l":[":|",":-|"],"o":2},"rugby_football":{"a":"Rugby Football","b":"1F3C9","d":true,"e":true,"f":true,"h":true,"j":["sports","team"],"k":[9,34],"o":2},"muscle":{"skin_variations":{"1F3FB":{"unified":"1F4AA-1F3FB","non_qualified":null,"image":"1f4aa-1f3fb.png","sheet_x":25,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F4AA-1F3FC","non_qualified":null,"image":"1f4aa-1f3fc.png","sheet_x":25,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F4AA-1F3FD","non_qualified":null,"image":"1f4aa-1f3fd.png","sheet_x":25,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F4AA-1F3FE","non_qualified":null,"image":"1f4aa-1f3fe.png","sheet_x":25,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F4AA-1F3FF","non_qualified":null,"image":"1f4aa-1f3ff.png","sheet_x":26,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Flexed Biceps","b":"1F4AA","d":true,"e":true,"f":true,"h":true,"j":["arm","flex","hand","summer","strong","biceps"],"k":[25,52],"o":2},"baguette_bread":{"a":"Baguette Bread","b":"1F956","d":true,"e":true,"f":true,"h":true,"j":["food","bread","french"],"k":[41,37],"o":4},"expressionless":{"a":"Expressionless Face","b":"1F611","d":true,"e":true,"f":true,"h":true,"j":["face","indifferent","-_-","meh","deadpan"],"k":[30,52],"o":2},"womans_hat":{"a":"Womans Hat","b":"1F452","d":true,"e":true,"f":true,"h":true,"j":["fashion","accessories","female","lady","spring"],"k":[14,6],"o":2},"pretzel":{"a":"Pretzel","b":"1F968","d":true,"e":true,"f":true,"h":true,"k":[41,55],"o":5},"mechanical_arm":{"a":"Mechanical Arm","b":"1F9BE","d":true,"e":true,"f":true,"h":true,"k":[44,6],"o":12},"arrow_up_down":{"a":"Up Down Arrow","b":"2195-FE0F","c":"2195","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","way","vertical"],"k":[52,15],"o":2},"dromedary_camel":{"a":"Dromedary Camel","b":"1F42A","d":true,"e":true,"f":true,"h":true,"j":["animal","hot","desert","hump"],"k":[12,14],"o":2},"tennis":{"a":"Tennis Racquet and Ball","b":"1F3BE","d":true,"e":true,"f":true,"h":true,"j":["sports","balls","green"],"k":[8,36],"o":2},"flag-bm":{"a":"Bermuda Flag","b":"1F1E7-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[1,1],"o":2},"factory":{"a":"Factory","b":"1F3ED","d":true,"e":true,"f":true,"h":true,"j":["building","industry","pollution","smoke"],"k":[11,7],"o":2},"japanese_castle":{"a":"Japanese Castle","b":"1F3EF","d":true,"e":true,"f":true,"h":true,"j":["photo","building"],"k":[11,9],"o":2},"no_mouth":{"a":"Face Without Mouth","b":"1F636","d":true,"e":true,"f":true,"h":true,"j":["face","hellokitty"],"k":[31,32],"o":2},"mechanical_leg":{"a":"Mechanical Leg","b":"1F9BF","d":true,"e":true,"f":true,"h":true,"k":[44,7],"o":12},"bagel":{"a":"Bagel","b":"1F96F","d":true,"e":true,"f":true,"h":true,"k":[42,5],"o":11},"camel":{"a":"Bactrian Camel","b":"1F42B","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","hot","desert","hump"],"k":[12,15],"o":2},"tophat":{"a":"Top Hat","b":"1F3A9","d":true,"e":true,"f":true,"h":true,"j":["magic","gentleman","classy","circus"],"k":[8,15],"o":2},"left_right_arrow":{"a":"Left Right Arrow","b":"2194-FE0F","c":"2194","d":true,"e":true,"f":true,"h":true,"j":["shape","direction","horizontal","sideways"],"k":[52,14],"o":2},"flag-bn":{"a":"Brunei Flag","b":"1F1E7-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[1,2],"o":2},"flying_disc":{"a":"Flying Disc","b":"1F94F","d":true,"e":true,"f":true,"h":true,"k":[41,30],"o":11},"smirk":{"a":"Smirking Face","b":"1F60F","d":true,"e":true,"f":true,"h":true,"j":["face","smile","mean","prank","smug","sarcasm"],"k":[30,50],"o":2},"mortar_board":{"a":"Graduation Cap","b":"1F393","d":true,"e":true,"f":true,"h":true,"j":["school","college","degree","university","graduation","cap","hat","legal","learn","education"],"k":[7,55],"o":2},"european_castle":{"a":"European Castle","b":"1F3F0","d":true,"e":true,"f":true,"h":true,"j":["building","royalty","history"],"k":[11,10],"o":2},"leg":{"skin_variations":{"1F3FB":{"unified":"1F9B5-1F3FB","non_qualified":null,"image":"1f9b5-1f3fb.png","sheet_x":43,"sheet_y":6,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B5-1F3FC","non_qualified":null,"image":"1f9b5-1f3fc.png","sheet_x":43,"sheet_y":7,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B5-1F3FD","non_qualified":null,"image":"1f9b5-1f3fd.png","sheet_x":43,"sheet_y":8,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B5-1F3FE","non_qualified":null,"image":"1f9b5-1f3fe.png","sheet_x":43,"sheet_y":9,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B5-1F3FF","non_qualified":null,"image":"1f9b5-1f3ff.png","sheet_x":43,"sheet_y":10,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Leg","b":"1F9B5","d":true,"e":true,"f":true,"h":true,"k":[43,5],"o":11},"pancakes":{"a":"Pancakes","b":"1F95E","d":true,"e":true,"f":true,"h":true,"j":["food","breakfast","flapjacks","hotcakes"],"k":[41,45],"o":4},"leftwards_arrow_with_hook":{"a":"Leftwards Arrow with Hook","b":"21A9-FE0F","c":"21A9","d":true,"e":true,"f":true,"h":true,"j":["back","return","blue-square","undo","enter"],"k":[52,20],"o":2},"flag-bo":{"a":"Bolivia Flag","b":"1F1E7-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[1,3],"o":2},"bowling":{"a":"Bowling","b":"1F3B3","d":true,"e":true,"f":true,"h":true,"j":["sports","fun","play"],"k":[8,25],"o":2},"llama":{"a":"Llama","b":"1F999","d":true,"e":true,"f":true,"h":true,"k":[42,43],"o":11},"arrow_right_hook":{"a":"Rightwards Arrow with Hook","b":"21AA-FE0F","c":"21AA","d":true,"e":true,"f":true,"h":true,"j":["blue-square","return","rotate","direction"],"k":[52,21],"o":2},"wedding":{"a":"Wedding","b":"1F492","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","couple","marriage","bride","groom"],"k":[25,28],"o":2},"flag-bq":{"a":"Caribbean Netherlands Flag","b":"1F1E7-1F1F6","d":true,"e":true,"f":true,"h":true,"k":[1,4],"o":2},"foot":{"skin_variations":{"1F3FB":{"unified":"1F9B6-1F3FB","non_qualified":null,"image":"1f9b6-1f3fb.png","sheet_x":43,"sheet_y":12,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B6-1F3FC","non_qualified":null,"image":"1f9b6-1f3fc.png","sheet_x":43,"sheet_y":13,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B6-1F3FD","non_qualified":null,"image":"1f9b6-1f3fd.png","sheet_x":43,"sheet_y":14,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B6-1F3FE","non_qualified":null,"image":"1f9b6-1f3fe.png","sheet_x":43,"sheet_y":15,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B6-1F3FF","non_qualified":null,"image":"1f9b6-1f3ff.png","sheet_x":43,"sheet_y":16,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Foot","b":"1F9B6","d":true,"e":true,"f":true,"h":true,"k":[43,11],"o":11},"giraffe_face":{"a":"Giraffe Face","b":"1F992","d":true,"e":true,"f":true,"h":true,"k":[42,36],"o":5},"unamused":{"a":"Unamused Face","b":"1F612","d":true,"e":true,"f":true,"h":true,"j":["indifference","bored","straight face","serious","sarcasm"],"k":[30,53],"m":":(","o":2},"billed_cap":{"a":"Billed Cap","b":"1F9E2","d":true,"e":true,"f":true,"h":true,"k":[51,21],"o":5},"waffle":{"a":"Waffle","b":"1F9C7","d":true,"e":true,"f":true,"h":true,"k":[44,15],"o":12},"cricket_bat_and_ball":{"a":"Cricket Bat and Ball","b":"1F3CF","d":true,"e":true,"f":true,"h":true,"k":[10,34],"o":2},"helmet_with_white_cross":{"a":"Helmet with White Cross","b":"26D1-FE0F","c":"26D1","d":true,"e":true,"f":true,"h":true,"k":[54,6],"o":2},"ear":{"skin_variations":{"1F3FB":{"unified":"1F442-1F3FB","non_qualified":null,"image":"1f442-1f3fb.png","sheet_x":12,"sheet_y":40,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F442-1F3FC","non_qualified":null,"image":"1f442-1f3fc.png","sheet_x":12,"sheet_y":41,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F442-1F3FD","non_qualified":null,"image":"1f442-1f3fd.png","sheet_x":12,"sheet_y":42,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F442-1F3FE","non_qualified":null,"image":"1f442-1f3fe.png","sheet_x":12,"sheet_y":43,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F442-1F3FF","non_qualified":null,"image":"1f442-1f3ff.png","sheet_x":12,"sheet_y":44,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Ear","b":"1F442","d":true,"e":true,"f":true,"h":true,"j":["face","hear","sound","listen"],"k":[12,39],"o":2},"elephant":{"a":"Elephant","b":"1F418","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","nose","th","circus"],"k":[11,53],"o":2},"cheese_wedge":{"a":"Cheese Wedge","b":"1F9C0","d":true,"e":true,"f":true,"h":true,"k":[44,8],"o":2},"tokyo_tower":{"a":"Tokyo Tower","b":"1F5FC","d":true,"e":true,"f":true,"h":true,"j":["photo","japanese"],"k":[30,31],"o":2},"arrow_heading_up":{"a":"Arrow Pointing Rightwards Then Curving Upwards","b":"2934-FE0F","c":"2934","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","top"],"k":[55,35],"o":2},"field_hockey_stick_and_ball":{"a":"Field Hockey Stick and Ball","b":"1F3D1","d":true,"e":true,"f":true,"h":true,"k":[10,36],"o":2},"flag-br":{"a":"Brazil Flag","b":"1F1E7-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[1,5],"o":2},"face_with_rolling_eyes":{"a":"Face with Rolling Eyes","b":"1F644","d":true,"e":true,"f":true,"h":true,"k":[31,46],"o":2},"ear_with_hearing_aid":{"skin_variations":{"1F3FB":{"unified":"1F9BB-1F3FB","non_qualified":null,"image":"1f9bb-1f3fb.png","sheet_x":43,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9BB-1F3FC","non_qualified":null,"image":"1f9bb-1f3fc.png","sheet_x":44,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9BB-1F3FD","non_qualified":null,"image":"1f9bb-1f3fd.png","sheet_x":44,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9BB-1F3FE","non_qualified":null,"image":"1f9bb-1f3fe.png","sheet_x":44,"sheet_y":2,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9BB-1F3FF","non_qualified":null,"image":"1f9bb-1f3ff.png","sheet_x":44,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Ear with Hearing Aid","b":"1F9BB","d":true,"e":true,"f":true,"h":true,"k":[43,55],"o":12},"arrow_heading_down":{"a":"Arrow Pointing Rightwards Then Curving Downwards","b":"2935-FE0F","c":"2935","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","bottom"],"k":[55,36],"o":2},"ice_hockey_stick_and_puck":{"a":"Ice Hockey Stick and Puck","b":"1F3D2","d":true,"e":true,"f":true,"h":true,"k":[10,37],"o":2},"meat_on_bone":{"a":"Meat on Bone","b":"1F356","d":true,"e":true,"f":true,"h":true,"j":["good","food","drumstick"],"k":[6,46],"o":2},"prayer_beads":{"a":"Prayer Beads","b":"1F4FF","d":true,"e":true,"f":true,"h":true,"j":["dhikr","religious"],"k":[27,27],"o":2},"statue_of_liberty":{"a":"Statue of Liberty","b":"1F5FD","d":true,"e":true,"f":true,"h":true,"j":["american","newyork"],"k":[30,32],"o":2},"grimacing":{"a":"Grimacing Face","b":"1F62C","d":true,"e":true,"f":true,"h":true,"j":["face","grimace","teeth"],"k":[31,22],"o":2},"flag-bs":{"a":"Bahamas Flag","b":"1F1E7-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[1,6],"o":2},"rhinoceros":{"a":"Rhinoceros","b":"1F98F","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","horn"],"k":[42,33],"o":4},"lacrosse":{"a":"Lacrosse Stick and Ball","b":"1F94D","d":true,"e":true,"f":true,"h":true,"k":[41,28],"o":11},"poultry_leg":{"a":"Poultry Leg","b":"1F357","d":true,"e":true,"f":true,"h":true,"j":["food","meat","drumstick","bird","chicken","turkey"],"k":[6,47],"o":2},"hippopotamus":{"a":"Hippopotamus","b":"1F99B","d":true,"e":true,"f":true,"h":true,"k":[42,45],"o":11},"nose":{"skin_variations":{"1F3FB":{"unified":"1F443-1F3FB","non_qualified":null,"image":"1f443-1f3fb.png","sheet_x":12,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F443-1F3FC","non_qualified":null,"image":"1f443-1f3fc.png","sheet_x":12,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F443-1F3FD","non_qualified":null,"image":"1f443-1f3fd.png","sheet_x":12,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F443-1F3FE","non_qualified":null,"image":"1f443-1f3fe.png","sheet_x":12,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F443-1F3FF","non_qualified":null,"image":"1f443-1f3ff.png","sheet_x":12,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Nose","b":"1F443","d":true,"e":true,"f":true,"h":true,"j":["smell","sniff"],"k":[12,45],"o":2},"arrows_clockwise":{"a":"Clockwise Downwards and Upwards Open Circle Arrows","b":"1F503","d":true,"e":true,"f":true,"h":true,"j":["sync","cycle","round","repeat"],"k":[27,31],"o":2},"flag-bt":{"a":"Bhutan Flag","b":"1F1E7-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[1,7],"o":2},"church":{"a":"Church","b":"26EA","d":true,"e":true,"f":true,"h":true,"j":["building","religion","christ"],"k":[54,10],"o":2},"lipstick":{"a":"Lipstick","b":"1F484","d":true,"e":true,"f":true,"h":true,"j":["female","girl","fashion","woman"],"k":[24,32],"o":2},"lying_face":{"a":"Lying Face","b":"1F925","d":true,"e":true,"f":true,"h":true,"j":["face","lie","pinocchio"],"k":[38,22],"o":4},"arrows_counterclockwise":{"a":"Anticlockwise Downwards and Upwards Open Circle Arrows","b":"1F504","d":true,"e":true,"f":true,"h":true,"j":["blue-square","sync","cycle"],"k":[27,32],"o":2},"flag-bv":{"a":"Bouvet Island Flag","b":"1F1E7-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[1,8],"o":2},"cut_of_meat":{"a":"Cut of Meat","b":"1F969","d":true,"e":true,"f":true,"h":true,"k":[41,56],"o":5},"mosque":{"a":"Mosque","b":"1F54C","d":true,"e":true,"f":true,"h":true,"j":["islam","worship","minaret"],"k":[28,36],"o":2},"ring":{"a":"Ring","b":"1F48D","d":true,"e":true,"f":true,"h":true,"j":["wedding","propose","marriage","valentines","diamond","fashion","jewelry","gem","engagement"],"k":[25,23],"o":2},"brain":{"a":"Brain","b":"1F9E0","d":true,"e":true,"f":true,"h":true,"k":[51,19],"o":5},"table_tennis_paddle_and_ball":{"a":"Table Tennis Paddle and Ball","b":"1F3D3","d":true,"e":true,"f":true,"h":true,"k":[10,38],"o":2},"relieved":{"a":"Relieved Face","b":"1F60C","d":true,"e":true,"f":true,"h":true,"j":["face","relaxed","phew","massage","happiness"],"k":[30,47],"o":2},"mouse":{"a":"Mouse Face","b":"1F42D","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","cheese_wedge","rodent"],"k":[12,17],"o":2},"hindu_temple":{"a":"Hindu Temple","b":"1F6D5","d":true,"e":true,"f":true,"h":true,"k":[36,41],"o":12},"back":{"a":"Back with Leftwards Arrow Above","b":"1F519","d":true,"e":true,"f":true,"h":true,"j":["arrow","words","return"],"k":[27,53],"o":2},"gem":{"a":"Gem Stone","b":"1F48E","d":true,"e":true,"f":true,"h":true,"j":["blue","ruby","diamond","jewelry"],"k":[25,24],"o":2},"pensive":{"a":"Pensive Face","b":"1F614","d":true,"e":true,"f":true,"h":true,"j":["face","sad","depressed","upset"],"k":[30,55],"o":2},"flag-bw":{"a":"Botswana Flag","b":"1F1E7-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[1,9],"o":2},"mouse2":{"a":"Mouse","b":"1F401","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","rodent"],"k":[11,29],"o":2},"bacon":{"a":"Bacon","b":"1F953","d":true,"e":true,"f":true,"h":true,"j":["food","breakfast","pork","pig","meat"],"k":[41,34],"o":4},"tooth":{"a":"Tooth","b":"1F9B7","d":true,"e":true,"f":true,"h":true,"k":[43,17],"o":11},"badminton_racquet_and_shuttlecock":{"a":"Badminton Racquet and Shuttlecock","b":"1F3F8","d":true,"e":true,"f":true,"h":true,"k":[11,20],"o":2},"rat":{"a":"Rat","b":"1F400","d":true,"e":true,"f":true,"h":true,"j":["animal","mouse","rodent"],"k":[11,28],"o":2},"synagogue":{"a":"Synagogue","b":"1F54D","d":true,"e":true,"f":true,"h":true,"j":["judaism","worship","temple","jewish"],"k":[28,37],"o":2},"end":{"a":"End with Leftwards Arrow Above","b":"1F51A","d":true,"e":true,"f":true,"h":true,"j":["words","arrow"],"k":[27,54],"o":2},"bone":{"a":"Bone","b":"1F9B4","d":true,"e":true,"f":true,"h":true,"k":[43,4],"o":11},"boxing_glove":{"a":"Boxing Glove","b":"1F94A","d":true,"e":true,"f":true,"h":true,"j":["sports","fighting"],"k":[41,25],"o":4},"mute":{"a":"Speaker with Cancellation Stroke","b":"1F507","d":true,"e":true,"f":true,"h":true,"j":["sound","volume","silence","quiet"],"k":[27,35],"o":2},"hamburger":{"a":"Hamburger","b":"1F354","d":true,"e":true,"f":true,"h":true,"j":["meat","fast food","beef","cheeseburger","mcdonalds","burger king"],"k":[6,44],"o":2},"flag-by":{"a":"Belarus Flag","b":"1F1E7-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[1,10],"o":2},"sleepy":{"a":"Sleepy Face","b":"1F62A","d":true,"e":true,"f":true,"h":true,"j":["face","tired","rest","nap"],"k":[31,20],"o":2},"on":{"a":"On with Exclamation Mark with Left Right Arrow Above","b":"1F51B","d":true,"e":true,"f":true,"h":true,"j":["arrow","words"],"k":[27,55],"o":2},"martial_arts_uniform":{"a":"Martial Arts Uniform","b":"1F94B","d":true,"e":true,"f":true,"h":true,"j":["judo","karate","taekwondo"],"k":[41,26],"o":4},"speaker":{"a":"Speaker","b":"1F508","d":true,"e":true,"f":true,"h":true,"j":["sound","volume","silence","broadcast"],"k":[27,36],"o":2},"drooling_face":{"a":"Drooling Face","b":"1F924","d":true,"e":true,"f":true,"h":true,"j":["face"],"k":[38,21],"o":4},"eyes":{"a":"Eyes","b":"1F440","d":true,"e":true,"f":true,"h":true,"j":["look","watch","stalk","peek","see"],"k":[12,36],"o":2},"flag-bz":{"a":"Belize Flag","b":"1F1E7-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[1,11],"o":2},"hamster":{"a":"Hamster Face","b":"1F439","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[12,29],"o":2},"shinto_shrine":{"a":"Shinto Shrine","b":"26E9-FE0F","c":"26E9","d":true,"e":true,"f":true,"h":true,"j":["temple","japan","kyoto"],"k":[54,9],"o":2},"fries":{"a":"French Fries","b":"1F35F","d":true,"e":true,"f":true,"h":true,"j":["chips","snack","fast food"],"k":[6,55],"o":2},"goal_net":{"a":"Goal Net","b":"1F945","d":true,"e":true,"f":true,"h":true,"j":["sports"],"k":[41,21],"o":4},"kaaba":{"a":"Kaaba","b":"1F54B","d":true,"e":true,"f":true,"h":true,"j":["mecca","mosque","islam"],"k":[28,35],"o":2},"soon":{"a":"Soon with Rightwards Arrow Above","b":"1F51C","d":true,"e":true,"f":true,"h":true,"j":["arrow","words"],"k":[27,56],"o":2},"flag-ca":{"a":"Canada Flag","b":"1F1E8-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[1,12],"o":2},"rabbit":{"a":"Rabbit Face","b":"1F430","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","pet","spring","magic","bunny"],"k":[12,20],"o":2},"eye":{"a":"Eye","b":"1F441-FE0F","c":"1F441","d":true,"e":true,"f":true,"h":true,"j":["face","look","see","watch","stare"],"k":[12,38],"o":2},"sleeping":{"a":"Sleeping Face","b":"1F634","d":true,"e":true,"f":true,"h":true,"j":["face","tired","sleepy","night","zzz"],"k":[31,30],"o":2},"pizza":{"a":"Slice of Pizza","b":"1F355","d":true,"e":true,"f":true,"h":true,"j":["food","party"],"k":[6,45],"o":2},"sound":{"a":"Speaker with One Sound Wave","b":"1F509","d":true,"e":true,"f":true,"h":true,"j":["volume","speaker","broadcast"],"k":[27,37],"o":2},"rabbit2":{"a":"Rabbit","b":"1F407","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","pet","magic","spring"],"k":[11,35],"o":2},"fountain":{"a":"Fountain","b":"26F2","d":true,"e":true,"f":true,"h":true,"j":["photo","summer","water","fresh"],"k":[54,13],"o":2},"golf":{"a":"Flag in Hole","b":"26F3","d":true,"e":true,"f":true,"h":true,"j":["sports","business","flag","hole","summer"],"k":[54,14],"o":2},"top":{"a":"Top with Upwards Arrow Above","b":"1F51D","d":true,"e":true,"f":true,"h":true,"j":["words","blue-square"],"k":[28,0],"o":2},"mask":{"a":"Face with Medical Mask","b":"1F637","d":true,"e":true,"f":true,"h":true,"j":["face","sick","ill","disease"],"k":[31,33],"o":2},"flag-cc":{"a":"Cocos (keeling) Islands Flag","b":"1F1E8-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[1,13],"o":2},"hotdog":{"a":"Hot Dog","b":"1F32D","d":true,"e":true,"f":true,"h":true,"j":["food","frankfurter"],"k":[6,5],"o":2},"loud_sound":{"a":"Speaker with Three Sound Waves","b":"1F50A","d":true,"e":true,"f":true,"h":true,"j":["volume","noise","noisy","speaker","broadcast"],"k":[27,38],"o":2},"tongue":{"a":"Tongue","b":"1F445","d":true,"e":true,"f":true,"h":true,"j":["mouth","playful"],"k":[12,52],"o":2},"place_of_worship":{"a":"Place of Worship","b":"1F6D0","d":true,"e":true,"f":true,"h":true,"j":["religion","church","temple","prayer"],"k":[36,38],"o":2},"ice_skate":{"a":"Ice Skate","b":"26F8-FE0F","c":"26F8","d":true,"e":true,"f":true,"h":true,"j":["sports"],"k":[54,18],"o":2},"sandwich":{"a":"Sandwich","b":"1F96A","d":true,"e":true,"f":true,"h":true,"k":[42,0],"o":5},"chipmunk":{"a":"Chipmunk","b":"1F43F-FE0F","c":"1F43F","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","rodent","squirrel"],"k":[12,35],"o":2},"loudspeaker":{"a":"Public Address Loudspeaker","b":"1F4E2","d":true,"e":true,"f":true,"h":true,"j":["volume","sound"],"k":[26,56],"o":2},"lips":{"a":"Mouth","b":"1F444","d":true,"e":true,"f":true,"h":true,"j":["mouth","kiss"],"k":[12,51],"o":2},"flag-cd":{"a":"Congo - Kinshasa Flag","b":"1F1E8-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[1,14],"o":2},"tent":{"a":"Tent","b":"26FA","d":true,"e":true,"f":true,"h":true,"j":["photo","camping","outdoors"],"k":[54,37],"o":2},"face_with_thermometer":{"a":"Face with Thermometer","b":"1F912","d":true,"e":true,"f":true,"h":true,"j":["sick","temperature","thermometer","cold","fever"],"k":[37,25],"o":2},"taco":{"a":"Taco","b":"1F32E","d":true,"e":true,"f":true,"h":true,"j":["food","mexican"],"k":[6,6],"o":2},"foggy":{"a":"Foggy","b":"1F301","d":true,"e":true,"f":true,"h":true,"j":["photo","mountain"],"k":[5,20],"o":2},"flag-cf":{"a":"Central African Republic Flag","b":"1F1E8-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[1,15],"o":2},"baby":{"skin_variations":{"1F3FB":{"unified":"1F476-1F3FB","non_qualified":null,"image":"1f476-1f3fb.png","sheet_x":23,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F476-1F3FC","non_qualified":null,"image":"1f476-1f3fc.png","sheet_x":23,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F476-1F3FD","non_qualified":null,"image":"1f476-1f3fd.png","sheet_x":23,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F476-1F3FE","non_qualified":null,"image":"1f476-1f3fe.png","sheet_x":23,"sheet_y":8,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F476-1F3FF","non_qualified":null,"image":"1f476-1f3ff.png","sheet_x":23,"sheet_y":9,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Baby","b":"1F476","d":true,"e":true,"f":true,"h":true,"j":["child","boy","girl","toddler"],"k":[23,4],"o":2},"atom_symbol":{"a":"Atom Symbol","b":"269B-FE0F","c":"269B","d":true,"e":true,"f":true,"h":true,"j":["science","physics","chemistry"],"k":[53,48],"o":2},"fishing_pole_and_fish":{"a":"Fishing Pole and Fish","b":"1F3A3","d":true,"e":true,"f":true,"h":true,"j":["food","hobby","summer"],"k":[8,9],"o":2},"hedgehog":{"a":"Hedgehog","b":"1F994","d":true,"e":true,"f":true,"h":true,"k":[42,38],"o":5},"face_with_head_bandage":{"a":"Face with Head-Bandage","b":"1F915","d":true,"e":true,"f":true,"h":true,"j":["injured","clumsy","bandage","hurt"],"k":[37,28],"o":2},"mega":{"a":"Cheering Megaphone","b":"1F4E3","d":true,"e":true,"f":true,"h":true,"j":["sound","speaker","volume"],"k":[27,0],"o":2},"nauseated_face":{"a":"Nauseated Face","b":"1F922","d":true,"e":true,"f":true,"h":true,"j":["face","vomit","gross","green","sick","throw up","ill"],"k":[38,19],"o":4},"child":{"skin_variations":{"1F3FB":{"unified":"1F9D2-1F3FB","non_qualified":null,"image":"1f9d2-1f3fb.png","sheet_x":48,"sheet_y":17,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D2-1F3FC","non_qualified":null,"image":"1f9d2-1f3fc.png","sheet_x":48,"sheet_y":18,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D2-1F3FD","non_qualified":null,"image":"1f9d2-1f3fd.png","sheet_x":48,"sheet_y":19,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D2-1F3FE","non_qualified":null,"image":"1f9d2-1f3fe.png","sheet_x":48,"sheet_y":20,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D2-1F3FF","non_qualified":null,"image":"1f9d2-1f3ff.png","sheet_x":48,"sheet_y":21,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Child","b":"1F9D2","d":true,"e":true,"f":true,"h":true,"k":[48,16],"o":5},"flag-cg":{"a":"Congo - Brazzaville Flag","b":"1F1E8-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[1,16],"o":2},"bat":{"a":"Bat","b":"1F987","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","blind","vampire"],"k":[42,25],"o":4},"diving_mask":{"a":"Diving Mask","b":"1F93F","d":true,"e":true,"f":true,"h":true,"k":[41,15],"o":12},"burrito":{"a":"Burrito","b":"1F32F","d":true,"e":true,"f":true,"h":true,"j":["food","mexican"],"k":[6,7],"o":2},"postal_horn":{"a":"Postal Horn","b":"1F4EF","d":true,"e":true,"f":true,"h":true,"j":["instrument","music"],"k":[27,12],"o":2},"night_with_stars":{"a":"Night with Stars","b":"1F303","d":true,"e":true,"f":true,"h":true,"j":["evening","city","downtown"],"k":[5,22],"o":2},"om_symbol":{"a":"Om Symbol","b":"1F549-FE0F","c":"1F549","d":true,"e":true,"f":true,"h":true,"k":[28,33],"o":2},"star_of_david":{"a":"Star of David","b":"2721-FE0F","c":"2721","d":true,"e":true,"f":true,"h":true,"j":["judaism"],"k":[55,15],"o":2},"boy":{"skin_variations":{"1F3FB":{"unified":"1F466-1F3FB","non_qualified":null,"image":"1f466-1f3fb.png","sheet_x":14,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F466-1F3FC","non_qualified":null,"image":"1f466-1f3fc.png","sheet_x":14,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F466-1F3FD","non_qualified":null,"image":"1f466-1f3fd.png","sheet_x":14,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F466-1F3FE","non_qualified":null,"image":"1f466-1f3fe.png","sheet_x":14,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F466-1F3FF","non_qualified":null,"image":"1f466-1f3ff.png","sheet_x":14,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Boy","b":"1F466","d":true,"e":true,"f":true,"h":true,"j":["man","male","guy","teenager"],"k":[14,26],"o":2},"bell":{"a":"Bell","b":"1F514","d":true,"e":true,"f":true,"h":true,"j":["sound","notification","christmas","xmas","chime"],"k":[27,48],"o":2},"flag-ch":{"a":"Switzerland Flag","b":"1F1E8-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[1,17],"o":2},"running_shirt_with_sash":{"a":"Running Shirt with Sash","b":"1F3BD","d":true,"e":true,"f":true,"h":true,"j":["play","pageant"],"k":[8,35],"o":2},"stuffed_flatbread":{"a":"Stuffed Flatbread","b":"1F959","d":true,"e":true,"f":true,"h":true,"j":["food","flatbread","stuffed","gyro"],"k":[41,40],"o":4},"bear":{"a":"Bear Face","b":"1F43B","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","wild"],"k":[12,31],"o":2},"cityscape":{"a":"Cityscape","b":"1F3D9-FE0F","c":"1F3D9","d":true,"e":true,"f":true,"h":true,"j":["photo","night life","urban"],"k":[10,44],"o":2},"face_vomiting":{"a":"Face with Open Mouth Vomiting","b":"1F92E","d":true,"e":true,"f":true,"h":true,"k":[38,48],"n":["face_with_open_mouth_vomiting"],"o":5},"wheel_of_dharma":{"a":"Wheel of Dharma","b":"2638-FE0F","c":"2638","d":true,"e":true,"f":true,"h":true,"j":["hinduism","buddhism","sikhism","jainism"],"k":[53,15],"o":2},"ski":{"a":"Ski and Ski Boot","b":"1F3BF","d":true,"e":true,"f":true,"h":true,"j":["sports","winter","cold","snow"],"k":[8,37],"o":2},"girl":{"skin_variations":{"1F3FB":{"unified":"1F467-1F3FB","non_qualified":null,"image":"1f467-1f3fb.png","sheet_x":14,"sheet_y":33,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F467-1F3FC","non_qualified":null,"image":"1f467-1f3fc.png","sheet_x":14,"sheet_y":34,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F467-1F3FD","non_qualified":null,"image":"1f467-1f3fd.png","sheet_x":14,"sheet_y":35,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F467-1F3FE","non_qualified":null,"image":"1f467-1f3fe.png","sheet_x":14,"sheet_y":36,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F467-1F3FF","non_qualified":null,"image":"1f467-1f3ff.png","sheet_x":14,"sheet_y":37,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Girl","b":"1F467","d":true,"e":true,"f":true,"h":true,"j":["female","woman","teenager"],"k":[14,32],"o":2},"falafel":{"a":"Falafel","b":"1F9C6","d":true,"e":true,"f":true,"h":true,"k":[44,14],"o":12},"sneezing_face":{"a":"Sneezing Face","b":"1F927","d":true,"e":true,"f":true,"h":true,"j":["face","gesundheit","sneeze","sick","allergy"],"k":[38,41],"o":4},"no_bell":{"a":"Bell with Cancellation Stroke","b":"1F515","d":true,"e":true,"f":true,"h":true,"j":["sound","volume","mute","quiet","silent"],"k":[27,49],"o":2},"koala":{"a":"Koala","b":"1F428","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[12,12],"o":2},"sunrise_over_mountains":{"a":"Sunrise over Mountains","b":"1F304","d":true,"e":true,"f":true,"h":true,"j":["view","vacation","photo"],"k":[5,23],"o":2},"flag-ci":{"a":"C\xf4te D\u2019ivoire Flag","b":"1F1E8-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[1,18],"o":2},"sunrise":{"a":"Sunrise","b":"1F305","d":true,"e":true,"f":true,"h":true,"j":["morning","view","vacation","photo"],"k":[5,24],"o":2},"yin_yang":{"a":"Yin Yang","b":"262F-FE0F","c":"262F","d":true,"e":true,"f":true,"h":true,"j":["balance"],"k":[53,14],"o":2},"adult":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fb.png","sheet_x":48,"sheet_y":11,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fc.png","sheet_x":48,"sheet_y":12,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fd.png","sheet_x":48,"sheet_y":13,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fe.png","sheet_x":48,"sheet_y":14,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3ff.png","sheet_x":48,"sheet_y":15,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Adult","b":"1F9D1","d":true,"e":true,"f":true,"h":true,"k":[48,10],"o":5},"hot_face":{"a":"Overheated Face","b":"1F975","d":true,"e":true,"f":true,"h":true,"k":[42,10],"o":11},"musical_score":{"a":"Musical Score","b":"1F3BC","d":true,"e":true,"f":true,"h":true,"j":["treble","clef","compose"],"k":[8,34],"o":2},"sled":{"a":"Sled","b":"1F6F7","d":true,"e":true,"f":true,"h":true,"k":[36,56],"o":5},"egg":{"a":"Egg","b":"1F95A","d":true,"e":true,"f":true,"h":true,"j":["food","chicken","breakfast"],"k":[41,41],"o":4},"panda_face":{"a":"Panda Face","b":"1F43C","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","panda"],"k":[12,32],"o":2},"flag-ck":{"a":"Cook Islands Flag","b":"1F1E8-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[1,19],"o":2},"flag-cl":{"a":"Chile Flag","b":"1F1E8-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[1,20],"o":2},"person_with_blond_hair":{"skin_variations":{"1F3FB":{"unified":"1F471-1F3FB","non_qualified":null,"image":"1f471-1f3fb.png","sheet_x":22,"sheet_y":20,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F471-1F3FC","non_qualified":null,"image":"1f471-1f3fc.png","sheet_x":22,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F471-1F3FD","non_qualified":null,"image":"1f471-1f3fd.png","sheet_x":22,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F471-1F3FE","non_qualified":null,"image":"1f471-1f3fe.png","sheet_x":22,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F471-1F3FF","non_qualified":null,"image":"1f471-1f3ff.png","sheet_x":22,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F471-200D-2642-FE0F","a":"Person with Blond Hair","b":"1F471","d":true,"e":true,"f":true,"h":false,"k":[22,19],"o":2},"sloth":{"a":"Sloth","b":"1F9A5","d":true,"e":true,"f":true,"h":true,"k":[42,53],"o":12},"latin_cross":{"a":"Latin Cross","b":"271D-FE0F","c":"271D","d":true,"e":true,"f":true,"h":true,"j":["christianity"],"k":[55,14],"o":2},"curling_stone":{"a":"Curling Stone","b":"1F94C","d":true,"e":true,"f":true,"h":true,"k":[41,27],"o":5},"cold_face":{"a":"Freezing Face","b":"1F976","d":true,"e":true,"f":true,"h":true,"k":[42,11],"o":11},"fried_egg":{"a":"Cooking","b":"1F373","d":true,"e":true,"f":true,"h":true,"j":["food","breakfast","kitchen","egg"],"k":[7,18],"n":["cooking"],"o":2},"city_sunset":{"a":"Cityscape at Dusk","b":"1F306","d":true,"e":true,"f":true,"h":true,"j":["photo","evening","sky","buildings"],"k":[5,25],"o":2},"musical_note":{"a":"Musical Note","b":"1F3B5","d":true,"e":true,"f":true,"h":true,"j":["score","tone","sound"],"k":[8,27],"o":2},"flag-cm":{"a":"Cameroon Flag","b":"1F1E8-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[1,21],"o":2},"notes":{"a":"Multiple Musical Notes","b":"1F3B6","d":true,"e":true,"f":true,"h":true,"j":["music","score"],"k":[8,28],"o":2},"woozy_face":{"a":"Face with Uneven Eyes and Wavy Mouth","b":"1F974","d":true,"e":true,"f":true,"h":true,"k":[42,9],"o":11},"dart":{"a":"Direct Hit","b":"1F3AF","d":true,"e":true,"f":true,"h":true,"j":["game","play","bar"],"k":[8,21],"o":2},"orthodox_cross":{"a":"Orthodox Cross","b":"2626-FE0F","c":"2626","d":true,"e":true,"f":true,"h":true,"j":["suppedaneum","religion"],"k":[53,11],"o":2},"shallow_pan_of_food":{"a":"Shallow Pan of Food","b":"1F958","d":true,"e":true,"f":true,"h":true,"j":["food","cooking","casserole","paella"],"k":[41,39],"o":4},"otter":{"a":"Otter","b":"1F9A6","d":true,"e":true,"f":true,"h":true,"k":[42,54],"o":12},"man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB","non_qualified":null,"image":"1f468-1f3fb.png","sheet_x":17,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC","non_qualified":null,"image":"1f468-1f3fc.png","sheet_x":17,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD","non_qualified":null,"image":"1f468-1f3fd.png","sheet_x":17,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE","non_qualified":null,"image":"1f468-1f3fe.png","sheet_x":17,"sheet_y":26,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF","non_qualified":null,"image":"1f468-1f3ff.png","sheet_x":17,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man","b":"1F468","d":true,"e":true,"f":true,"h":true,"j":["mustache","father","dad","guy","classy","sir","moustache"],"k":[17,22],"o":2},"city_sunrise":{"a":"Sunset over Buildings","b":"1F307","d":true,"e":true,"f":true,"h":true,"j":["photo","good morning","dawn"],"k":[5,26],"o":2},"bearded_person":{"skin_variations":{"1F3FB":{"unified":"1F9D4-1F3FB","non_qualified":null,"image":"1f9d4-1f3fb.png","sheet_x":48,"sheet_y":29,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D4-1F3FC","non_qualified":null,"image":"1f9d4-1f3fc.png","sheet_x":48,"sheet_y":30,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D4-1F3FD","non_qualified":null,"image":"1f9d4-1f3fd.png","sheet_x":48,"sheet_y":31,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D4-1F3FE","non_qualified":null,"image":"1f9d4-1f3fe.png","sheet_x":48,"sheet_y":32,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D4-1F3FF","non_qualified":null,"image":"1f9d4-1f3ff.png","sheet_x":48,"sheet_y":33,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Bearded Person","b":"1F9D4","d":true,"e":true,"f":true,"h":true,"k":[48,28],"o":5},"skunk":{"a":"Skunk","b":"1F9A8","d":true,"e":true,"f":true,"h":true,"k":[42,56],"o":12},"stew":{"a":"Pot of Food","b":"1F372","d":true,"e":true,"f":true,"h":true,"j":["food","meat","soup"],"k":[7,17],"o":2},"cn":{"a":"China Flag","b":"1F1E8-1F1F3","d":true,"e":true,"f":true,"h":true,"j":["china","chinese","prc","flag","country","nation","banner"],"k":[1,22],"n":["flag-cn"],"o":2},"studio_microphone":{"a":"Studio Microphone","b":"1F399-FE0F","c":"1F399","d":true,"e":true,"f":true,"h":true,"j":["sing","recording","artist","talkshow"],"k":[8,1],"o":2},"star_and_crescent":{"a":"Star and Crescent","b":"262A-FE0F","c":"262A","d":true,"e":true,"f":true,"h":true,"j":["islam"],"k":[53,12],"o":2},"yo-yo":{"a":"Yo-Yo","b":"1FA80","d":true,"e":true,"f":true,"h":true,"k":[52,1],"o":12},"bridge_at_night":{"a":"Bridge at Night","b":"1F309","d":true,"e":true,"f":true,"h":true,"j":["photo","sanfrancisco"],"k":[5,28],"o":2},"dizzy_face":{"a":"Dizzy Face","b":"1F635","d":true,"e":true,"f":true,"h":true,"j":["spent","unconscious","xox","dizzy"],"k":[31,31],"o":2},"red_haired_man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9B0","non_qualified":null,"image":"1f468-1f3fb-200d-1f9b0.png","sheet_x":16,"sheet_y":24,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9B0","non_qualified":null,"image":"1f468-1f3fc-200d-1f9b0.png","sheet_x":16,"sheet_y":25,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9B0","non_qualified":null,"image":"1f468-1f3fd-200d-1f9b0.png","sheet_x":16,"sheet_y":26,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9B0","non_qualified":null,"image":"1f468-1f3fe-200d-1f9b0.png","sheet_x":16,"sheet_y":27,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9B0","non_qualified":null,"image":"1f468-1f3ff-200d-1f9b0.png","sheet_x":16,"sheet_y":28,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Red Haired Man","b":"1F468-200D-1F9B0","d":true,"e":true,"f":true,"h":true,"k":[16,23],"o":11},"kite":{"a":"Kite","b":"1FA81","d":true,"e":true,"f":true,"h":true,"k":[52,2],"o":12},"bowl_with_spoon":{"a":"Bowl with Spoon","b":"1F963","d":true,"e":true,"f":true,"h":true,"k":[41,50],"o":5},"flag-co":{"a":"Colombia Flag","b":"1F1E8-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[1,23],"o":2},"peace_symbol":{"a":"Peace Symbol","b":"262E-FE0F","c":"262E","d":true,"e":true,"f":true,"h":true,"j":["hippie"],"k":[53,13],"o":2},"kangaroo":{"a":"Kangaroo","b":"1F998","d":true,"e":true,"f":true,"h":true,"k":[42,42],"o":11},"hotsprings":{"a":"Hot Springs","b":"2668-FE0F","c":"2668","d":true,"e":true,"f":true,"h":true,"j":["bath","warm","relax"],"k":[53,37],"o":2},"exploding_head":{"a":"Shocked Face with Exploding Head","b":"1F92F","d":true,"e":true,"f":true,"h":true,"k":[38,49],"n":["shocked_face_with_exploding_head"],"o":5},"level_slider":{"a":"Level Slider","b":"1F39A-FE0F","c":"1F39A","d":true,"e":true,"f":true,"h":true,"j":["scale"],"k":[8,2],"o":2},"badger":{"a":"Badger","b":"1F9A1","d":true,"e":true,"f":true,"h":true,"k":[42,51],"o":11},"8ball":{"a":"Billiards","b":"1F3B1","d":true,"e":true,"f":true,"h":true,"j":["pool","hobby","game","luck","magic"],"k":[8,23],"o":2},"curly_haired_man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9B1","non_qualified":null,"image":"1f468-1f3fb-200d-1f9b1.png","sheet_x":16,"sheet_y":30,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9B1","non_qualified":null,"image":"1f468-1f3fc-200d-1f9b1.png","sheet_x":16,"sheet_y":31,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9B1","non_qualified":null,"image":"1f468-1f3fd-200d-1f9b1.png","sheet_x":16,"sheet_y":32,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9B1","non_qualified":null,"image":"1f468-1f3fe-200d-1f9b1.png","sheet_x":16,"sheet_y":33,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9B1","non_qualified":null,"image":"1f468-1f3ff-200d-1f9b1.png","sheet_x":16,"sheet_y":34,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Curly Haired Man","b":"1F468-200D-1F9B1","d":true,"e":true,"f":true,"h":true,"k":[16,29],"o":11},"flag-cp":{"a":"Clipperton Island Flag","b":"1F1E8-1F1F5","d":true,"e":true,"f":true,"h":true,"k":[1,24],"o":2},"carousel_horse":{"a":"Carousel Horse","b":"1F3A0","d":true,"e":true,"f":true,"h":true,"j":["photo","carnival"],"k":[8,6],"o":2},"face_with_cowboy_hat":{"a":"Face with Cowboy Hat","b":"1F920","d":true,"e":true,"f":true,"h":true,"k":[38,17],"o":4},"menorah_with_nine_branches":{"a":"Menorah with Nine Branches","b":"1F54E","d":true,"e":true,"f":true,"h":true,"k":[28,38],"o":2},"green_salad":{"a":"Green Salad","b":"1F957","d":true,"e":true,"f":true,"h":true,"j":["food","healthy","lettuce"],"k":[41,38],"o":4},"control_knobs":{"a":"Control Knobs","b":"1F39B-FE0F","c":"1F39B","d":true,"e":true,"f":true,"h":true,"j":["dial"],"k":[8,3],"o":2},"popcorn":{"a":"Popcorn","b":"1F37F","d":true,"e":true,"f":true,"h":true,"j":["food","movie theater","films","snack"],"k":[7,30],"o":2},"six_pointed_star":{"a":"Six Pointed Star with Middle Dot","b":"1F52F","d":true,"e":true,"f":true,"h":true,"j":["purple-square","religion","jewish","hexagram"],"k":[28,18],"o":2},"feet":{"a":"Paw Prints","b":"1F43E","d":true,"e":true,"f":true,"h":true,"k":[12,34],"n":["paw_prints"],"o":2},"ferris_wheel":{"a":"Ferris Wheel","b":"1F3A1","d":true,"e":true,"f":true,"h":true,"j":["photo","carnival","londoneye"],"k":[8,7],"o":2},"microphone":{"a":"Microphone","b":"1F3A4","d":true,"e":true,"f":true,"h":true,"j":["sound","music","PA","sing","talkshow"],"k":[8,10],"o":2},"crystal_ball":{"a":"Crystal Ball","b":"1F52E","d":true,"e":true,"f":true,"h":true,"j":["disco","party","magic","circus","fortune_teller"],"k":[28,17],"o":2},"partying_face":{"a":"Face with Party Horn and Party Hat","b":"1F973","d":true,"e":true,"f":true,"h":true,"k":[42,8],"o":11},"flag-cr":{"a":"Costa Rica Flag","b":"1F1E8-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[1,25],"o":2},"white_haired_man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9B3","non_qualified":null,"image":"1f468-1f3fb-200d-1f9b3.png","sheet_x":16,"sheet_y":42,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9B3","non_qualified":null,"image":"1f468-1f3fc-200d-1f9b3.png","sheet_x":16,"sheet_y":43,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9B3","non_qualified":null,"image":"1f468-1f3fd-200d-1f9b3.png","sheet_x":16,"sheet_y":44,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9B3","non_qualified":null,"image":"1f468-1f3fe-200d-1f9b3.png","sheet_x":16,"sheet_y":45,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9B3","non_qualified":null,"image":"1f468-1f3ff-200d-1f9b3.png","sheet_x":16,"sheet_y":46,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Haired Man","b":"1F468-200D-1F9B3","d":true,"e":true,"f":true,"h":true,"k":[16,41],"o":11},"headphones":{"a":"Headphone","b":"1F3A7","d":true,"e":true,"f":true,"h":true,"j":["music","score","gadgets"],"k":[8,13],"o":2},"bald_man":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9B2","non_qualified":null,"image":"1f468-1f3fb-200d-1f9b2.png","sheet_x":16,"sheet_y":36,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9B2","non_qualified":null,"image":"1f468-1f3fc-200d-1f9b2.png","sheet_x":16,"sheet_y":37,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9B2","non_qualified":null,"image":"1f468-1f3fd-200d-1f9b2.png","sheet_x":16,"sheet_y":38,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9B2","non_qualified":null,"image":"1f468-1f3fe-200d-1f9b2.png","sheet_x":16,"sheet_y":39,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9B2","non_qualified":null,"image":"1f468-1f3ff-200d-1f9b2.png","sheet_x":16,"sheet_y":40,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Bald Man","b":"1F468-200D-1F9B2","d":true,"e":true,"f":true,"h":true,"k":[16,35],"o":11},"sunglasses":{"a":"Smiling Face with Sunglasses","b":"1F60E","d":true,"e":true,"f":true,"h":true,"j":["face","cool","smile","summer","beach","sunglass"],"k":[30,49],"l":["8)"],"o":2},"butter":{"a":"Butter","b":"1F9C8","d":true,"e":true,"f":true,"h":true,"k":[44,16],"o":12},"roller_coaster":{"a":"Roller Coaster","b":"1F3A2","d":true,"e":true,"f":true,"h":true,"j":["carnival","playground","photo","fun"],"k":[8,8],"o":2},"turkey":{"a":"Turkey","b":"1F983","d":true,"e":true,"f":true,"h":true,"j":["animal","bird"],"k":[42,21],"o":2},"nazar_amulet":{"a":"Nazar Amulet","b":"1F9FF","d":true,"e":true,"f":true,"h":true,"k":[51,50],"o":11},"flag-cu":{"a":"Cuba Flag","b":"1F1E8-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[1,26],"o":2},"aries":{"a":"Aries","b":"2648","d":true,"e":true,"f":true,"h":true,"j":["sign","purple-square","zodiac","astrology"],"k":[53,20],"o":2},"flag-cv":{"a":"Cape Verde Flag","b":"1F1E8-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[1,27],"o":2},"barber":{"a":"Barber Pole","b":"1F488","d":true,"e":true,"f":true,"h":true,"j":["hair","salon","style"],"k":[25,18],"o":2},"taurus":{"a":"Taurus","b":"2649","d":true,"e":true,"f":true,"h":true,"j":["purple-square","sign","zodiac","astrology"],"k":[53,21],"o":2},"salt":{"a":"Salt Shaker","b":"1F9C2","d":true,"e":true,"f":true,"h":true,"k":[44,10],"o":11},"woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB","non_qualified":null,"image":"1f469-1f3fb.png","sheet_x":20,"sheet_y":10,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC","non_qualified":null,"image":"1f469-1f3fc.png","sheet_x":20,"sheet_y":11,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD","non_qualified":null,"image":"1f469-1f3fd.png","sheet_x":20,"sheet_y":12,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE","non_qualified":null,"image":"1f469-1f3fe.png","sheet_x":20,"sheet_y":13,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF","non_qualified":null,"image":"1f469-1f3ff.png","sheet_x":20,"sheet_y":14,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman","b":"1F469","d":true,"e":true,"f":true,"h":true,"j":["female","girls","lady"],"k":[20,9],"o":2},"video_game":{"a":"Video Game","b":"1F3AE","d":true,"e":true,"f":true,"h":true,"j":["play","console","PS4","controller"],"k":[8,20],"o":2},"chicken":{"a":"Chicken","b":"1F414","d":true,"e":true,"f":true,"h":true,"j":["animal","cluck","nature","bird"],"k":[11,48],"o":2},"radio":{"a":"Radio","b":"1F4FB","d":true,"e":true,"f":true,"h":true,"j":["communication","music","podcast","program"],"k":[27,24],"o":2},"nerd_face":{"a":"Nerd Face","b":"1F913","d":true,"e":true,"f":true,"h":true,"j":["face","nerdy","geek","dork"],"k":[37,26],"o":2},"red_haired_woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9B0","non_qualified":null,"image":"1f469-1f3fb-200d-1f9b0.png","sheet_x":19,"sheet_y":9,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9B0","non_qualified":null,"image":"1f469-1f3fc-200d-1f9b0.png","sheet_x":19,"sheet_y":10,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9B0","non_qualified":null,"image":"1f469-1f3fd-200d-1f9b0.png","sheet_x":19,"sheet_y":11,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9B0","non_qualified":null,"image":"1f469-1f3fe-200d-1f9b0.png","sheet_x":19,"sheet_y":12,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9B0","non_qualified":null,"image":"1f469-1f3ff-200d-1f9b0.png","sheet_x":19,"sheet_y":13,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Red Haired Woman","b":"1F469-200D-1F9B0","d":true,"e":true,"f":true,"h":true,"k":[19,8],"o":11},"circus_tent":{"a":"Circus Tent","b":"1F3AA","d":true,"e":true,"f":true,"h":true,"j":["festival","carnival","party"],"k":[8,16],"o":2},"face_with_monocle":{"a":"Face with Monocle","b":"1F9D0","d":true,"e":true,"f":true,"h":true,"k":[45,16],"o":5},"canned_food":{"a":"Canned Food","b":"1F96B","d":true,"e":true,"f":true,"h":true,"k":[42,1],"o":5},"flag-cw":{"a":"Cura\xe7ao Flag","b":"1F1E8-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[1,28],"o":2},"gemini":{"a":"Gemini","b":"264A","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology"],"k":[53,22],"o":2},"saxophone":{"a":"Saxophone","b":"1F3B7","d":true,"e":true,"f":true,"h":true,"j":["music","instrument","jazz","blues"],"k":[8,29],"o":2},"rooster":{"a":"Rooster","b":"1F413","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","chicken"],"k":[11,47],"o":2},"joystick":{"a":"Joystick","b":"1F579-FE0F","c":"1F579","d":true,"e":true,"f":true,"h":true,"j":["game","play"],"k":[29,36],"o":2},"guitar":{"a":"Guitar","b":"1F3B8","d":true,"e":true,"f":true,"h":true,"j":["music","instrument"],"k":[8,30],"o":2},"slot_machine":{"a":"Slot Machine","b":"1F3B0","d":true,"e":true,"f":true,"h":true,"j":["bet","gamble","vegas","fruit machine","luck","casino"],"k":[8,22],"o":2},"bento":{"a":"Bento Box","b":"1F371","d":true,"e":true,"f":true,"h":true,"j":["food","japanese","box"],"k":[7,16],"o":2},"steam_locomotive":{"a":"Steam Locomotive","b":"1F682","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","train"],"k":[34,1],"o":2},"confused":{"a":"Confused Face","b":"1F615","d":true,"e":true,"f":true,"h":true,"j":["face","indifference","huh","weird","hmmm",":/"],"k":[30,56],"l":[":\\\\",":-\\\\",":/",":-/"],"o":2},"flag-cx":{"a":"Christmas Island Flag","b":"1F1E8-1F1FD","d":true,"e":true,"f":true,"h":true,"k":[1,29],"o":2},"hatching_chick":{"a":"Hatching Chick","b":"1F423","d":true,"e":true,"f":true,"h":true,"j":["animal","chicken","egg","born","baby","bird"],"k":[12,7],"o":2},"cancer":{"a":"Cancer","b":"264B","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology"],"k":[53,23],"o":2},"red_haired_person":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9B0","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9b0.png","sheet_x":47,"sheet_y":14,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9B0","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9b0.png","sheet_x":47,"sheet_y":15,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9B0","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9b0.png","sheet_x":47,"sheet_y":16,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9B0","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9b0.png","sheet_x":47,"sheet_y":17,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9B0","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9b0.png","sheet_x":47,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Red Haired Person","b":"1F9D1-200D-1F9B0","d":true,"e":false,"f":false,"h":false,"k":[47,13],"o":12},"flag-cy":{"a":"Cyprus Flag","b":"1F1E8-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[1,30],"o":2},"worried":{"a":"Worried Face","b":"1F61F","d":true,"e":true,"f":true,"h":true,"j":["face","concern","nervous",":("],"k":[31,9],"o":2},"railway_car":{"a":"Railway Car","b":"1F683","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,2],"o":2},"leo":{"a":"Leo","b":"264C","d":true,"e":true,"f":true,"h":true,"j":["sign","purple-square","zodiac","astrology"],"k":[53,24],"o":2},"curly_haired_woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9B1","non_qualified":null,"image":"1f469-1f3fb-200d-1f9b1.png","sheet_x":19,"sheet_y":15,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9B1","non_qualified":null,"image":"1f469-1f3fc-200d-1f9b1.png","sheet_x":19,"sheet_y":16,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9B1","non_qualified":null,"image":"1f469-1f3fd-200d-1f9b1.png","sheet_x":19,"sheet_y":17,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9B1","non_qualified":null,"image":"1f469-1f3fe-200d-1f9b1.png","sheet_x":19,"sheet_y":18,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9B1","non_qualified":null,"image":"1f469-1f3ff-200d-1f9b1.png","sheet_x":19,"sheet_y":19,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Curly Haired Woman","b":"1F469-200D-1F9B1","d":true,"e":true,"f":true,"h":true,"k":[19,14],"o":11},"baby_chick":{"a":"Baby Chick","b":"1F424","d":true,"e":true,"f":true,"h":true,"j":["animal","chicken","bird"],"k":[12,8],"o":2},"musical_keyboard":{"a":"Musical Keyboard","b":"1F3B9","d":true,"e":true,"f":true,"h":true,"j":["piano","instrument","compose"],"k":[8,31],"o":2},"game_die":{"a":"Game Die","b":"1F3B2","d":true,"e":true,"f":true,"h":true,"j":["dice","random","tabletop","play","luck"],"k":[8,24],"o":2},"rice_cracker":{"a":"Rice Cracker","b":"1F358","d":true,"e":true,"f":true,"h":true,"j":["food","japanese"],"k":[6,48],"o":2},"virgo":{"a":"Virgo","b":"264D","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology"],"k":[53,25],"o":2},"flag-cz":{"a":"Czechia Flag","b":"1F1E8-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[1,31],"o":2},"curly_haired_person":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9B1","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9b1.png","sheet_x":47,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9B1","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9b1.png","sheet_x":47,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9B1","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9b1.png","sheet_x":47,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9B1","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9b1.png","sheet_x":47,"sheet_y":23,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9B1","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9b1.png","sheet_x":47,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Curly Haired Person","b":"1F9D1-200D-1F9B1","d":true,"e":false,"f":false,"h":false,"k":[47,19],"o":12},"rice_ball":{"a":"Rice Ball","b":"1F359","d":true,"e":true,"f":true,"h":true,"j":["food","japanese"],"k":[6,49],"o":2},"hatched_chick":{"a":"Front-Facing Baby Chick","b":"1F425","d":true,"e":true,"f":true,"h":true,"j":["animal","chicken","baby","bird"],"k":[12,9],"o":2},"jigsaw":{"a":"Jigsaw Puzzle Piece","b":"1F9E9","d":true,"e":true,"f":true,"h":true,"k":[51,28],"o":11},"trumpet":{"a":"Trumpet","b":"1F3BA","d":true,"e":true,"f":true,"h":true,"j":["music","brass"],"k":[8,32],"o":2},"slightly_frowning_face":{"a":"Slightly Frowning Face","b":"1F641","d":true,"e":true,"f":true,"h":true,"j":["face","frowning","disappointed","sad","upset"],"k":[31,43],"o":2},"bullettrain_side":{"a":"High-Speed Train","b":"1F684","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,3],"o":2},"libra":{"a":"Libra","b":"264E","d":true,"e":true,"f":true,"h":true,"j":["sign","purple-square","zodiac","astrology"],"k":[53,26],"o":2},"de":{"a":"Germany Flag","b":"1F1E9-1F1EA","d":true,"e":true,"f":true,"h":true,"j":["german","nation","flag","country","banner"],"k":[1,32],"n":["flag-de"],"o":2},"rice":{"a":"Cooked Rice","b":"1F35A","d":true,"e":true,"f":true,"h":true,"j":["food","china","asian"],"k":[6,50],"o":2},"violin":{"a":"Violin","b":"1F3BB","d":true,"e":true,"f":true,"h":true,"j":["music","instrument","orchestra","symphony"],"k":[8,33],"o":2},"white_haired_woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9B3","non_qualified":null,"image":"1f469-1f3fb-200d-1f9b3.png","sheet_x":19,"sheet_y":27,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9B3","non_qualified":null,"image":"1f469-1f3fc-200d-1f9b3.png","sheet_x":19,"sheet_y":28,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9B3","non_qualified":null,"image":"1f469-1f3fd-200d-1f9b3.png","sheet_x":19,"sheet_y":29,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9B3","non_qualified":null,"image":"1f469-1f3fe-200d-1f9b3.png","sheet_x":19,"sheet_y":30,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9B3","non_qualified":null,"image":"1f469-1f3ff-200d-1f9b3.png","sheet_x":19,"sheet_y":31,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"White Haired Woman","b":"1F469-200D-1F9B3","d":true,"e":true,"f":true,"h":true,"k":[19,26],"o":11},"bird":{"a":"Bird","b":"1F426","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","fly","tweet","spring"],"k":[12,10],"o":2},"white_frowning_face":{"a":"White Frowning Face","b":"2639-FE0F","c":"2639","d":true,"e":true,"f":true,"h":true,"k":[53,16],"o":2},"bullettrain_front":{"a":"High-Speed Train with Bullet Nose","b":"1F685","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","speed","fast","public","travel"],"k":[34,4],"o":2},"teddy_bear":{"a":"Teddy Bear","b":"1F9F8","d":true,"e":true,"f":true,"h":true,"k":[51,43],"o":11},"white_haired_person":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9B3","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9b3.png","sheet_x":47,"sheet_y":32,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9B3","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9b3.png","sheet_x":47,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9B3","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9b3.png","sheet_x":47,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9B3","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9b3.png","sheet_x":47,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9B3","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9b3.png","sheet_x":47,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"White Haired Person","b":"1F9D1-200D-1F9B3","d":true,"e":false,"f":false,"h":false,"k":[47,31],"o":12},"spades":{"a":"Black Spade Suit","b":"2660-FE0F","c":"2660","d":true,"e":true,"f":true,"h":true,"j":["poker","cards","suits","magic"],"k":[53,33],"o":2},"banjo":{"a":"Banjo","b":"1FA95","d":true,"e":true,"f":true,"h":true,"k":[52,9],"o":12},"train2":{"a":"Train","b":"1F686","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,5],"o":2},"scorpius":{"a":"Scorpius","b":"264F","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology","scorpio"],"k":[53,27],"o":2},"curry":{"a":"Curry and Rice","b":"1F35B","d":true,"e":true,"f":true,"h":true,"j":["food","spicy","hot","indian"],"k":[6,51],"o":2},"open_mouth":{"a":"Face with Open Mouth","b":"1F62E","d":true,"e":true,"f":true,"h":true,"j":["face","surprise","impressed","wow","whoa",":O"],"k":[31,24],"l":[":o",":-o",":O",":-O"],"o":2},"flag-dg":{"a":"Diego Garcia Flag","b":"1F1E9-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[1,33],"o":2},"penguin":{"a":"Penguin","b":"1F427","d":true,"e":true,"f":true,"h":true,"j":["animal","nature"],"k":[12,11],"o":2},"hearts":{"a":"Black Heart Suit","b":"2665-FE0F","c":"2665","d":true,"e":true,"f":true,"h":true,"j":["poker","cards","magic","suits"],"k":[53,35],"o":2},"ramen":{"a":"Steaming Bowl","b":"1F35C","d":true,"e":true,"f":true,"h":true,"j":["food","japanese","noodle","chopsticks"],"k":[6,52],"o":2},"sagittarius":{"a":"Sagittarius","b":"2650","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology"],"k":[53,28],"o":2},"bald_woman":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9B2","non_qualified":null,"image":"1f469-1f3fb-200d-1f9b2.png","sheet_x":19,"sheet_y":21,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9B2","non_qualified":null,"image":"1f469-1f3fc-200d-1f9b2.png","sheet_x":19,"sheet_y":22,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9B2","non_qualified":null,"image":"1f469-1f3fd-200d-1f9b2.png","sheet_x":19,"sheet_y":23,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9B2","non_qualified":null,"image":"1f469-1f3fe-200d-1f9b2.png","sheet_x":19,"sheet_y":24,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9B2","non_qualified":null,"image":"1f469-1f3ff-200d-1f9b2.png","sheet_x":19,"sheet_y":25,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Bald Woman","b":"1F469-200D-1F9B2","d":true,"e":true,"f":true,"h":true,"k":[19,20],"o":11},"dove_of_peace":{"a":"Dove of Peace","b":"1F54A-FE0F","c":"1F54A","d":true,"e":true,"f":true,"h":true,"k":[28,34],"o":2},"hushed":{"a":"Hushed Face","b":"1F62F","d":true,"e":true,"f":true,"h":true,"j":["face","woo","shh"],"k":[31,25],"o":2},"metro":{"a":"Metro","b":"1F687","d":true,"e":true,"f":true,"h":true,"j":["transportation","blue-square","mrt","underground","tube"],"k":[34,6],"o":2},"flag-dj":{"a":"Djibouti Flag","b":"1F1E9-1F1EF","d":true,"e":true,"f":true,"h":true,"k":[1,34],"o":2},"drum_with_drumsticks":{"a":"Drum with Drumsticks","b":"1F941","d":true,"e":true,"f":true,"h":true,"k":[41,17],"o":4},"spaghetti":{"a":"Spaghetti","b":"1F35D","d":true,"e":true,"f":true,"h":true,"j":["food","italian","noodle"],"k":[6,53],"o":2},"eagle":{"a":"Eagle","b":"1F985","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","bird"],"k":[42,23],"o":4},"astonished":{"a":"Astonished Face","b":"1F632","d":true,"e":true,"f":true,"h":true,"j":["face","xox","surprised","poisoned"],"k":[31,28],"o":2},"capricorn":{"a":"Capricorn","b":"2651","d":true,"e":true,"f":true,"h":true,"j":["sign","zodiac","purple-square","astrology"],"k":[53,29],"o":2},"light_rail":{"a":"Light Rail","b":"1F688","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,7],"o":2},"flag-dk":{"a":"Denmark Flag","b":"1F1E9-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[1,35],"o":2},"iphone":{"a":"Mobile Phone","b":"1F4F1","d":true,"e":true,"f":true,"h":true,"j":["technology","apple","gadgets","dial"],"k":[27,14],"o":2},"bald_person":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9B2","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9b2.png","sheet_x":47,"sheet_y":26,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9B2","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9b2.png","sheet_x":47,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9B2","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9b2.png","sheet_x":47,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9B2","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9b2.png","sheet_x":47,"sheet_y":29,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9B2","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9b2.png","sheet_x":47,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Bald Person","b":"1F9D1-200D-1F9B2","d":true,"e":false,"f":false,"h":false,"k":[47,25],"o":12},"diamonds":{"a":"Black Diamond Suit","b":"2666-FE0F","c":"2666","d":true,"e":true,"f":true,"h":true,"j":["poker","cards","magic","suits"],"k":[53,36],"o":2},"clubs":{"a":"Black Club Suit","b":"2663-FE0F","c":"2663","d":true,"e":true,"f":true,"h":true,"j":["poker","cards","magic","suits"],"k":[53,34],"o":2},"aquarius":{"a":"Aquarius","b":"2652","d":true,"e":true,"f":true,"h":true,"j":["sign","purple-square","zodiac","astrology"],"k":[53,30],"o":2},"sweet_potato":{"a":"Roasted Sweet Potato","b":"1F360","d":true,"e":true,"f":true,"h":true,"j":["food","nature"],"k":[6,56],"o":2},"flag-dm":{"a":"Dominica Flag","b":"1F1E9-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[1,36],"o":2},"duck":{"a":"Duck","b":"1F986","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","bird","mallard"],"k":[42,24],"o":4},"calling":{"a":"Mobile Phone with Rightwards Arrow at Left","b":"1F4F2","d":true,"e":true,"f":true,"h":true,"j":["iphone","incoming"],"k":[27,15],"o":2},"station":{"a":"Station","b":"1F689","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","public"],"k":[34,8],"o":2},"blond-haired-woman":{"skin_variations":{"1F3FB":{"unified":"1F471-1F3FB-200D-2640-FE0F","non_qualified":"1F471-1F3FB-200D-2640","image":"1f471-1f3fb-200d-2640-fe0f.png","sheet_x":22,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F471-1F3FC-200D-2640-FE0F","non_qualified":"1F471-1F3FC-200D-2640","image":"1f471-1f3fc-200d-2640-fe0f.png","sheet_x":22,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F471-1F3FD-200D-2640-FE0F","non_qualified":"1F471-1F3FD-200D-2640","image":"1f471-1f3fd-200d-2640-fe0f.png","sheet_x":22,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F471-1F3FE-200D-2640-FE0F","non_qualified":"1F471-1F3FE-200D-2640","image":"1f471-1f3fe-200d-2640-fe0f.png","sheet_x":22,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F471-1F3FF-200D-2640-FE0F","non_qualified":"1F471-1F3FF-200D-2640","image":"1f471-1f3ff-200d-2640-fe0f.png","sheet_x":22,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Blond Haired Woman","b":"1F471-200D-2640-FE0F","c":"1F471-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[22,7],"o":4},"flushed":{"a":"Flushed Face","b":"1F633","d":true,"e":true,"f":true,"h":true,"j":["face","blush","shy","flattered"],"k":[31,29],"o":2},"pisces":{"a":"Pisces","b":"2653","d":true,"e":true,"f":true,"h":true,"j":["purple-square","sign","zodiac","astrology"],"k":[53,31],"o":2},"chess_pawn":{"a":"Chess Pawn","b":"265F-FE0F","c":"265F","d":true,"e":true,"f":true,"h":true,"k":[53,32],"o":11},"blond-haired-man":{"skin_variations":{"1F3FB":{"unified":"1F471-1F3FB-200D-2642-FE0F","non_qualified":"1F471-1F3FB-200D-2642","image":"1f471-1f3fb-200d-2642-fe0f.png","sheet_x":22,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F471-1F3FC-200D-2642-FE0F","non_qualified":"1F471-1F3FC-200D-2642","image":"1f471-1f3fc-200d-2642-fe0f.png","sheet_x":22,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F471-1F3FD-200D-2642-FE0F","non_qualified":"1F471-1F3FD-200D-2642","image":"1f471-1f3fd-200d-2642-fe0f.png","sheet_x":22,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F471-1F3FE-200D-2642-FE0F","non_qualified":"1F471-1F3FE-200D-2642","image":"1f471-1f3fe-200d-2642-fe0f.png","sheet_x":22,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F471-1F3FF-200D-2642-FE0F","non_qualified":"1F471-1F3FF-200D-2642","image":"1f471-1f3ff-200d-2642-fe0f.png","sheet_x":22,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F471","a":"Blond Haired Man","b":"1F471-200D-2642-FE0F","c":"1F471-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[22,13],"o":4},"phone":{"a":"Black Telephone","b":"260E-FE0F","c":"260E","d":true,"e":true,"f":true,"h":true,"j":["technology","communication","dial","telephone"],"k":[52,54],"n":["telephone"],"o":2},"oden":{"a":"Oden","b":"1F362","d":true,"e":true,"f":true,"h":true,"j":["food","japanese"],"k":[7,1],"o":2},"flag-do":{"a":"Dominican Republic Flag","b":"1F1E9-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[1,37],"o":2},"tram":{"a":"Tram","b":"1F68A","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,9],"o":2},"swan":{"a":"Swan","b":"1F9A2","d":true,"e":true,"f":true,"h":true,"k":[42,52],"o":11},"pleading_face":{"a":"Face with Pleading Eyes","b":"1F97A","d":true,"e":true,"f":true,"h":true,"k":[42,12],"o":11},"flag-dz":{"a":"Algeria Flag","b":"1F1E9-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[1,38],"o":2},"monorail":{"a":"Monorail","b":"1F69D","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,28],"o":2},"owl":{"a":"Owl","b":"1F989","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","bird","hoot"],"k":[42,27],"o":4},"sushi":{"a":"Sushi","b":"1F363","d":true,"e":true,"f":true,"h":true,"j":["food","fish","japanese","rice"],"k":[7,2],"o":2},"telephone_receiver":{"a":"Telephone Receiver","b":"1F4DE","d":true,"e":true,"f":true,"h":true,"j":["technology","communication","dial"],"k":[26,52],"o":2},"black_joker":{"a":"Playing Card Black Joker","b":"1F0CF","d":true,"e":true,"f":true,"h":true,"j":["poker","cards","game","play","magic"],"k":[0,15],"o":2},"ophiuchus":{"a":"Ophiuchus","b":"26CE","d":true,"e":true,"f":true,"h":true,"j":["sign","purple-square","constellation","astrology"],"k":[54,4],"o":2},"frowning":{"a":"Frowning Face with Open Mouth","b":"1F626","d":true,"e":true,"f":true,"h":true,"j":["face","aw","what"],"k":[31,16],"o":2},"older_adult":{"skin_variations":{"1F3FB":{"unified":"1F9D3-1F3FB","non_qualified":null,"image":"1f9d3-1f3fb.png","sheet_x":48,"sheet_y":23,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D3-1F3FC","non_qualified":null,"image":"1f9d3-1f3fc.png","sheet_x":48,"sheet_y":24,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D3-1F3FD","non_qualified":null,"image":"1f9d3-1f3fd.png","sheet_x":48,"sheet_y":25,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D3-1F3FE","non_qualified":null,"image":"1f9d3-1f3fe.png","sheet_x":48,"sheet_y":26,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D3-1F3FF","non_qualified":null,"image":"1f9d3-1f3ff.png","sheet_x":48,"sheet_y":27,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Older Adult","b":"1F9D3","d":true,"e":true,"f":true,"h":true,"k":[48,22],"o":5},"flag-ea":{"a":"Ceuta & Melilla Flag","b":"1F1EA-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[1,39],"o":2},"flamingo":{"a":"Flamingo","b":"1F9A9","d":true,"e":true,"f":true,"h":true,"k":[43,0],"o":12},"pager":{"a":"Pager","b":"1F4DF","d":true,"e":true,"f":true,"h":true,"j":["bbcall","oldschool","90s"],"k":[26,53],"o":2},"mountain_railway":{"a":"Mountain Railway","b":"1F69E","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,29],"o":2},"mahjong":{"a":"Mahjong Tile Red Dragon","b":"1F004","d":true,"e":true,"f":true,"h":true,"j":["game","play","chinese","kanji"],"k":[0,14],"o":2},"older_man":{"skin_variations":{"1F3FB":{"unified":"1F474-1F3FB","non_qualified":null,"image":"1f474-1f3fb.png","sheet_x":22,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F474-1F3FC","non_qualified":null,"image":"1f474-1f3fc.png","sheet_x":22,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F474-1F3FD","non_qualified":null,"image":"1f474-1f3fd.png","sheet_x":22,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F474-1F3FE","non_qualified":null,"image":"1f474-1f3fe.png","sheet_x":22,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F474-1F3FF","non_qualified":null,"image":"1f474-1f3ff.png","sheet_x":22,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Older Man","b":"1F474","d":true,"e":true,"f":true,"h":true,"j":["human","male","men","old","elder","senior"],"k":[22,49],"o":2},"twisted_rightwards_arrows":{"a":"Twisted Rightwards Arrows","b":"1F500","d":true,"e":true,"f":true,"h":true,"j":["blue-square","shuffle","music","random"],"k":[27,28],"o":2},"fried_shrimp":{"a":"Fried Shrimp","b":"1F364","d":true,"e":true,"f":true,"h":true,"j":["food","animal","appetizer","summer"],"k":[7,3],"o":2},"anguished":{"a":"Anguished Face","b":"1F627","d":true,"e":true,"f":true,"h":true,"j":["face","stunned","nervous"],"k":[31,17],"l":["D:"],"o":2},"repeat":{"a":"Clockwise Rightwards and Leftwards Open Circle Arrows","b":"1F501","d":true,"e":true,"f":true,"h":true,"j":["loop","record"],"k":[27,29],"o":2},"fish_cake":{"a":"Fish Cake with Swirl Design","b":"1F365","d":true,"e":true,"f":true,"h":true,"j":["food","japan","sea","beach","narutomaki","pink","swirl","kamaboko","surimi","ramen"],"k":[7,4],"o":2},"fax":{"a":"Fax Machine","b":"1F4E0","d":true,"e":true,"f":true,"h":true,"j":["communication","technology"],"k":[26,54],"o":2},"older_woman":{"skin_variations":{"1F3FB":{"unified":"1F475-1F3FB","non_qualified":null,"image":"1f475-1f3fb.png","sheet_x":22,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F475-1F3FC","non_qualified":null,"image":"1f475-1f3fc.png","sheet_x":23,"sheet_y":0,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F475-1F3FD","non_qualified":null,"image":"1f475-1f3fd.png","sheet_x":23,"sheet_y":1,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F475-1F3FE","non_qualified":null,"image":"1f475-1f3fe.png","sheet_x":23,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F475-1F3FF","non_qualified":null,"image":"1f475-1f3ff.png","sheet_x":23,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Older Woman","b":"1F475","d":true,"e":true,"f":true,"h":true,"j":["human","female","women","lady","old","elder","senior"],"k":[22,55],"o":2},"flag-ec":{"a":"Ecuador Flag","b":"1F1EA-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[1,40],"o":2},"peacock":{"a":"Peacock","b":"1F99A","d":true,"e":true,"f":true,"h":true,"k":[42,44],"o":11},"fearful":{"a":"Fearful Face","b":"1F628","d":true,"e":true,"f":true,"h":true,"j":["face","scared","terrified","nervous","oops","huh"],"k":[31,18],"o":2},"train":{"a":"Tram Car","b":"1F68B","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","carriage","public","travel"],"k":[34,10],"o":2},"flower_playing_cards":{"a":"Flower Playing Cards","b":"1F3B4","d":true,"e":true,"f":true,"h":true,"j":["game","sunset","red"],"k":[8,26],"o":2},"repeat_one":{"a":"Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay","b":"1F502","d":true,"e":true,"f":true,"h":true,"j":["blue-square","loop"],"k":[27,30],"o":2},"moon_cake":{"a":"Moon Cake","b":"1F96E","d":true,"e":true,"f":true,"h":true,"k":[42,4],"o":11},"performing_arts":{"a":"Performing Arts","b":"1F3AD","d":true,"e":true,"f":true,"h":true,"j":["acting","theater","drama"],"k":[8,19],"o":2},"cold_sweat":{"a":"Face with Open Mouth and Cold Sweat","b":"1F630","d":true,"e":true,"f":true,"h":true,"j":["face","nervous","sweat"],"k":[31,26],"o":2},"person_frowning":{"skin_variations":{"1F3FB":{"unified":"1F64D-1F3FB","non_qualified":null,"image":"1f64d-1f3fb.png","sheet_x":33,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F64D-1F3FC","non_qualified":null,"image":"1f64d-1f3fc.png","sheet_x":33,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F64D-1F3FD","non_qualified":null,"image":"1f64d-1f3fd.png","sheet_x":33,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F64D-1F3FE","non_qualified":null,"image":"1f64d-1f3fe.png","sheet_x":33,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F64D-1F3FF","non_qualified":null,"image":"1f64d-1f3ff.png","sheet_x":33,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F64D-200D-2640-FE0F","a":"Person Frowning","b":"1F64D","d":true,"e":true,"f":true,"h":false,"k":[33,26],"o":2},"flag-ee":{"a":"Estonia Flag","b":"1F1EA-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[1,41],"o":2},"battery":{"a":"Battery","b":"1F50B","d":true,"e":true,"f":true,"h":true,"j":["power","energy","sustain"],"k":[27,39],"o":2},"parrot":{"a":"Parrot","b":"1F99C","d":true,"e":true,"f":true,"h":true,"k":[42,46],"o":11},"bus":{"a":"Bus","b":"1F68C","d":true,"e":true,"f":true,"h":true,"j":["car","vehicle","transportation"],"k":[34,11],"o":2},"flag-eg":{"a":"Egypt Flag","b":"1F1EA-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[1,42],"o":2},"arrow_forward":{"a":"Black Right-Pointing Triangle","b":"25B6-FE0F","c":"25B6","d":true,"e":true,"f":true,"h":true,"j":["blue-square","right","direction","play"],"k":[52,43],"o":2},"man-frowning":{"skin_variations":{"1F3FB":{"unified":"1F64D-1F3FB-200D-2642-FE0F","non_qualified":"1F64D-1F3FB-200D-2642","image":"1f64d-1f3fb-200d-2642-fe0f.png","sheet_x":33,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64D-1F3FC-200D-2642-FE0F","non_qualified":"1F64D-1F3FC-200D-2642","image":"1f64d-1f3fc-200d-2642-fe0f.png","sheet_x":33,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64D-1F3FD-200D-2642-FE0F","non_qualified":"1F64D-1F3FD-200D-2642","image":"1f64d-1f3fd-200d-2642-fe0f.png","sheet_x":33,"sheet_y":23,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64D-1F3FE-200D-2642-FE0F","non_qualified":"1F64D-1F3FE-200D-2642","image":"1f64d-1f3fe-200d-2642-fe0f.png","sheet_x":33,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64D-1F3FF-200D-2642-FE0F","non_qualified":"1F64D-1F3FF-200D-2642","image":"1f64d-1f3ff-200d-2642-fe0f.png","sheet_x":33,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Frowning","b":"1F64D-200D-2642-FE0F","c":"1F64D-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[33,20],"o":4},"disappointed_relieved":{"a":"Disappointed but Relieved Face","b":"1F625","d":true,"e":true,"f":true,"h":true,"j":["face","phew","sweat","nervous"],"k":[31,15],"o":2},"electric_plug":{"a":"Electric Plug","b":"1F50C","d":true,"e":true,"f":true,"h":true,"j":["charger","power"],"k":[27,40],"o":2},"frame_with_picture":{"a":"Frame with Picture","b":"1F5BC-FE0F","c":"1F5BC","d":true,"e":true,"f":true,"h":true,"k":[30,14],"o":2},"oncoming_bus":{"a":"Oncoming Bus","b":"1F68D","d":true,"e":true,"f":true,"h":true,"j":["vehicle","transportation"],"k":[34,12],"o":2},"dango":{"a":"Dango","b":"1F361","d":true,"e":true,"f":true,"h":true,"j":["food","dessert","sweet","japanese","barbecue","meat"],"k":[7,0],"o":2},"frog":{"a":"Frog Face","b":"1F438","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","croak","toad"],"k":[12,28],"o":2},"computer":{"a":"Personal Computer","b":"1F4BB","d":true,"e":true,"f":true,"h":true,"j":["technology","laptop","screen","display","monitor"],"k":[26,17],"o":2},"art":{"a":"Artist Palette","b":"1F3A8","d":true,"e":true,"f":true,"h":true,"j":["design","paint","draw","colors"],"k":[8,14],"o":2},"flag-eh":{"a":"Western Sahara Flag","b":"1F1EA-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[1,43],"o":2},"fast_forward":{"a":"Black Right-Pointing Double Triangle","b":"23E9","d":true,"e":true,"f":true,"h":true,"j":["blue-square","play","speed","continue"],"k":[52,26],"o":2},"cry":{"a":"Crying Face","b":"1F622","d":true,"e":true,"f":true,"h":true,"j":["face","tears","sad","depressed","upset",":\'("],"k":[31,12],"l":[":\'("],"m":":\'(","o":2},"woman-frowning":{"skin_variations":{"1F3FB":{"unified":"1F64D-1F3FB-200D-2640-FE0F","non_qualified":"1F64D-1F3FB-200D-2640","image":"1f64d-1f3fb-200d-2640-fe0f.png","sheet_x":33,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64D-1F3FC-200D-2640-FE0F","non_qualified":"1F64D-1F3FC-200D-2640","image":"1f64d-1f3fc-200d-2640-fe0f.png","sheet_x":33,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64D-1F3FD-200D-2640-FE0F","non_qualified":"1F64D-1F3FD-200D-2640","image":"1f64d-1f3fd-200d-2640-fe0f.png","sheet_x":33,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64D-1F3FE-200D-2640-FE0F","non_qualified":"1F64D-1F3FE-200D-2640","image":"1f64d-1f3fe-200d-2640-fe0f.png","sheet_x":33,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64D-1F3FF-200D-2640-FE0F","non_qualified":"1F64D-1F3FF-200D-2640","image":"1f64d-1f3ff-200d-2640-fe0f.png","sheet_x":33,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F64D","a":"Woman Frowning","b":"1F64D-200D-2640-FE0F","c":"1F64D-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[33,14],"o":4},"trolleybus":{"a":"Trolleybus","b":"1F68E","d":true,"e":true,"f":true,"h":true,"j":["bart","transportation","vehicle"],"k":[34,13],"o":2},"crocodile":{"a":"Crocodile","b":"1F40A","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","reptile","lizard","alligator"],"k":[11,38],"o":2},"dumpling":{"a":"Dumpling","b":"1F95F","d":true,"e":true,"f":true,"h":true,"k":[41,46],"o":5},"black_right_pointing_double_triangle_with_vertical_bar":{"a":"Black Right Pointing Double Triangle with Vertical Bar","b":"23ED-FE0F","c":"23ED","d":true,"e":true,"f":true,"h":true,"k":[52,30],"o":2},"desktop_computer":{"a":"Desktop Computer","b":"1F5A5-FE0F","c":"1F5A5","d":true,"e":true,"f":true,"h":true,"j":["technology","computing","screen"],"k":[30,10],"o":2},"person_with_pouting_face":{"skin_variations":{"1F3FB":{"unified":"1F64E-1F3FB","non_qualified":null,"image":"1f64e-1f3fb.png","sheet_x":33,"sheet_y":45,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F64E-1F3FC","non_qualified":null,"image":"1f64e-1f3fc.png","sheet_x":33,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F64E-1F3FD","non_qualified":null,"image":"1f64e-1f3fd.png","sheet_x":33,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F64E-1F3FE","non_qualified":null,"image":"1f64e-1f3fe.png","sheet_x":33,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F64E-1F3FF","non_qualified":null,"image":"1f64e-1f3ff.png","sheet_x":33,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F64E-200D-2640-FE0F","a":"Person with Pouting Face","b":"1F64E","d":true,"e":true,"f":true,"h":false,"k":[33,44],"o":2},"turtle":{"a":"Turtle","b":"1F422","d":true,"e":true,"f":true,"h":true,"j":["animal","slow","nature","tortoise"],"k":[12,6],"o":2},"sob":{"a":"Loudly Crying Face","b":"1F62D","d":true,"e":true,"f":true,"h":true,"j":["face","cry","tears","sad","upset","depressed"],"k":[31,23],"m":":\'(","o":2},"flag-er":{"a":"Eritrea Flag","b":"1F1EA-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[1,44],"o":2},"thread":{"a":"Spool of Thread","b":"1F9F5","d":true,"e":true,"f":true,"h":true,"k":[51,40],"o":11},"minibus":{"a":"Minibus","b":"1F690","d":true,"e":true,"f":true,"h":true,"j":["vehicle","car","transportation"],"k":[34,15],"o":2},"fortune_cookie":{"a":"Fortune Cookie","b":"1F960","d":true,"e":true,"f":true,"h":true,"k":[41,47],"o":5},"yarn":{"a":"Ball of Yarn","b":"1F9F6","d":true,"e":true,"f":true,"h":true,"k":[51,41],"o":11},"takeout_box":{"a":"Takeout Box","b":"1F961","d":true,"e":true,"f":true,"h":true,"k":[41,48],"o":5},"man-pouting":{"skin_variations":{"1F3FB":{"unified":"1F64E-1F3FB-200D-2642-FE0F","non_qualified":"1F64E-1F3FB-200D-2642","image":"1f64e-1f3fb-200d-2642-fe0f.png","sheet_x":33,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64E-1F3FC-200D-2642-FE0F","non_qualified":"1F64E-1F3FC-200D-2642","image":"1f64e-1f3fc-200d-2642-fe0f.png","sheet_x":33,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64E-1F3FD-200D-2642-FE0F","non_qualified":"1F64E-1F3FD-200D-2642","image":"1f64e-1f3fd-200d-2642-fe0f.png","sheet_x":33,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64E-1F3FE-200D-2642-FE0F","non_qualified":"1F64E-1F3FE-200D-2642","image":"1f64e-1f3fe-200d-2642-fe0f.png","sheet_x":33,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64E-1F3FF-200D-2642-FE0F","non_qualified":"1F64E-1F3FF-200D-2642","image":"1f64e-1f3ff-200d-2642-fe0f.png","sheet_x":33,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Pouting","b":"1F64E-200D-2642-FE0F","c":"1F64E-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[33,38],"o":4},"printer":{"a":"Printer","b":"1F5A8-FE0F","c":"1F5A8","d":true,"e":true,"f":true,"h":true,"j":["paper","ink"],"k":[30,11],"o":2},"scream":{"a":"Face Screaming in Fear","b":"1F631","d":true,"e":true,"f":true,"h":true,"j":["face","munch","scared","omg"],"k":[31,27],"o":2},"es":{"a":"Spain Flag","b":"1F1EA-1F1F8","d":true,"e":true,"f":true,"h":true,"j":["spain","flag","nation","country","banner"],"k":[1,45],"n":["flag-es"],"o":2},"ambulance":{"a":"Ambulance","b":"1F691","d":true,"e":true,"f":true,"h":true,"j":["health","911","hospital"],"k":[34,16],"o":2},"black_right_pointing_triangle_with_double_vertical_bar":{"a":"Black Right Pointing Triangle with Double Vertical Bar","b":"23EF-FE0F","c":"23EF","d":true,"e":true,"f":true,"h":true,"k":[52,32],"o":2},"lizard":{"a":"Lizard","b":"1F98E","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","reptile"],"k":[42,32],"o":4},"flag-et":{"a":"Ethiopia Flag","b":"1F1EA-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[1,46],"o":2},"keyboard":{"a":"Keyboard","b":"2328-FE0F","c":"2328","d":true,"e":true,"f":true,"h":true,"j":["technology","computer","type","input","text"],"k":[52,24],"o":2},"crab":{"a":"Crab","b":"1F980","d":true,"e":true,"f":true,"h":true,"j":["animal","crustacean"],"k":[42,18],"o":2},"confounded":{"a":"Confounded Face","b":"1F616","d":true,"e":true,"f":true,"h":true,"j":["face","confused","sick","unwell","oops",":S"],"k":[31,0],"o":2},"snake":{"a":"Snake","b":"1F40D","d":true,"e":true,"f":true,"h":true,"j":["animal","evil","nature","hiss","python"],"k":[11,41],"o":2},"woman-pouting":{"skin_variations":{"1F3FB":{"unified":"1F64E-1F3FB-200D-2640-FE0F","non_qualified":"1F64E-1F3FB-200D-2640","image":"1f64e-1f3fb-200d-2640-fe0f.png","sheet_x":33,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64E-1F3FC-200D-2640-FE0F","non_qualified":"1F64E-1F3FC-200D-2640","image":"1f64e-1f3fc-200d-2640-fe0f.png","sheet_x":33,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64E-1F3FD-200D-2640-FE0F","non_qualified":"1F64E-1F3FD-200D-2640","image":"1f64e-1f3fd-200d-2640-fe0f.png","sheet_x":33,"sheet_y":35,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64E-1F3FE-200D-2640-FE0F","non_qualified":"1F64E-1F3FE-200D-2640","image":"1f64e-1f3fe-200d-2640-fe0f.png","sheet_x":33,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64E-1F3FF-200D-2640-FE0F","non_qualified":"1F64E-1F3FF-200D-2640","image":"1f64e-1f3ff-200d-2640-fe0f.png","sheet_x":33,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F64E","a":"Woman Pouting","b":"1F64E-200D-2640-FE0F","c":"1F64E-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[33,32],"o":4},"arrow_backward":{"a":"Black Left-Pointing Triangle","b":"25C0-FE0F","c":"25C0","d":true,"e":true,"f":true,"h":true,"j":["blue-square","left","direction"],"k":[52,44],"o":2},"fire_engine":{"a":"Fire Engine","b":"1F692","d":true,"e":true,"f":true,"h":true,"j":["transportation","cars","vehicle"],"k":[34,17],"o":2},"rewind":{"a":"Black Left-Pointing Double Triangle","b":"23EA","d":true,"e":true,"f":true,"h":true,"j":["play","blue-square"],"k":[52,27],"o":2},"three_button_mouse":{"a":"Three Button Mouse","b":"1F5B1-FE0F","c":"1F5B1","d":true,"e":true,"f":true,"h":true,"k":[30,12],"o":2},"no_good":{"skin_variations":{"1F3FB":{"unified":"1F645-1F3FB","non_qualified":null,"image":"1f645-1f3fb.png","sheet_x":32,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F645-1F3FC","non_qualified":null,"image":"1f645-1f3fc.png","sheet_x":32,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F645-1F3FD","non_qualified":null,"image":"1f645-1f3fd.png","sheet_x":32,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F645-1F3FE","non_qualified":null,"image":"1f645-1f3fe.png","sheet_x":32,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F645-1F3FF","non_qualified":null,"image":"1f645-1f3ff.png","sheet_x":32,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F645-200D-2640-FE0F","a":"Face with No Good Gesture","b":"1F645","d":true,"e":true,"f":true,"h":false,"k":[32,2],"o":2},"police_car":{"a":"Police Car","b":"1F693","d":true,"e":true,"f":true,"h":true,"j":["vehicle","cars","transportation","law","legal","enforcement"],"k":[34,18],"o":2},"dragon_face":{"a":"Dragon Face","b":"1F432","d":true,"e":true,"f":true,"h":true,"j":["animal","myth","nature","chinese","green"],"k":[12,22],"o":2},"persevere":{"a":"Persevering Face","b":"1F623","d":true,"e":true,"f":true,"h":true,"j":["face","sick","no","upset","oops"],"k":[31,13],"o":2},"lobster":{"a":"Lobster","b":"1F99E","d":true,"e":true,"f":true,"h":true,"k":[42,48],"o":11},"flag-eu":{"a":"European Union Flag","b":"1F1EA-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[1,47],"o":2},"disappointed":{"a":"Disappointed Face","b":"1F61E","d":true,"e":true,"f":true,"h":true,"j":["face","sad","upset","depressed",":("],"k":[31,8],"l":["):",":(",":-("],"m":":(","o":2},"shrimp":{"a":"Shrimp","b":"1F990","d":true,"e":true,"f":true,"h":true,"j":["animal","ocean","nature","seafood"],"k":[42,34],"o":4},"dragon":{"a":"Dragon","b":"1F409","d":true,"e":true,"f":true,"h":true,"j":["animal","myth","nature","chinese","green"],"k":[11,37],"o":2},"man-gesturing-no":{"skin_variations":{"1F3FB":{"unified":"1F645-1F3FB-200D-2642-FE0F","non_qualified":"1F645-1F3FB-200D-2642","image":"1f645-1f3fb-200d-2642-fe0f.png","sheet_x":31,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F645-1F3FC-200D-2642-FE0F","non_qualified":"1F645-1F3FC-200D-2642","image":"1f645-1f3fc-200d-2642-fe0f.png","sheet_x":31,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F645-1F3FD-200D-2642-FE0F","non_qualified":"1F645-1F3FD-200D-2642","image":"1f645-1f3fd-200d-2642-fe0f.png","sheet_x":31,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F645-1F3FE-200D-2642-FE0F","non_qualified":"1F645-1F3FE-200D-2642","image":"1f645-1f3fe-200d-2642-fe0f.png","sheet_x":32,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F645-1F3FF-200D-2642-FE0F","non_qualified":"1F645-1F3FF-200D-2642","image":"1f645-1f3ff-200d-2642-fe0f.png","sheet_x":32,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Gesturing No","b":"1F645-200D-2642-FE0F","c":"1F645-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[31,53],"o":4},"flag-fi":{"a":"Finland Flag","b":"1F1EB-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[1,48],"o":2},"trackball":{"a":"Trackball","b":"1F5B2-FE0F","c":"1F5B2","d":true,"e":true,"f":true,"h":true,"j":["technology","trackpad"],"k":[30,13],"o":2},"black_left_pointing_double_triangle_with_vertical_bar":{"a":"Black Left Pointing Double Triangle with Vertical Bar","b":"23EE-FE0F","c":"23EE","d":true,"e":true,"f":true,"h":true,"k":[52,31],"o":2},"oncoming_police_car":{"a":"Oncoming Police Car","b":"1F694","d":true,"e":true,"f":true,"h":true,"j":["vehicle","law","legal","enforcement","911"],"k":[34,19],"o":2},"minidisc":{"a":"Minidisc","b":"1F4BD","d":true,"e":true,"f":true,"h":true,"j":["technology","record","data","disk","90s"],"k":[26,19],"o":2},"sweat":{"a":"Face with Cold Sweat","b":"1F613","d":true,"e":true,"f":true,"h":true,"j":["face","hot","sad","tired","exercise"],"k":[30,54],"o":2},"squid":{"a":"Squid","b":"1F991","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","ocean","sea"],"k":[42,35],"o":4},"sauropod":{"a":"Sauropod","b":"1F995","d":true,"e":true,"f":true,"h":true,"k":[42,39],"o":5},"arrow_up_small":{"a":"Up-Pointing Small Red Triangle","b":"1F53C","d":true,"e":true,"f":true,"h":true,"j":["blue-square","triangle","direction","point","forward","top"],"k":[28,31],"o":2},"flag-fj":{"a":"Fiji Flag","b":"1F1EB-1F1EF","d":true,"e":true,"f":true,"h":true,"k":[1,49],"o":2},"woman-gesturing-no":{"skin_variations":{"1F3FB":{"unified":"1F645-1F3FB-200D-2640-FE0F","non_qualified":"1F645-1F3FB-200D-2640","image":"1f645-1f3fb-200d-2640-fe0f.png","sheet_x":31,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F645-1F3FC-200D-2640-FE0F","non_qualified":"1F645-1F3FC-200D-2640","image":"1f645-1f3fc-200d-2640-fe0f.png","sheet_x":31,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F645-1F3FD-200D-2640-FE0F","non_qualified":"1F645-1F3FD-200D-2640","image":"1f645-1f3fd-200d-2640-fe0f.png","sheet_x":31,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F645-1F3FE-200D-2640-FE0F","non_qualified":"1F645-1F3FE-200D-2640","image":"1f645-1f3fe-200d-2640-fe0f.png","sheet_x":31,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F645-1F3FF-200D-2640-FE0F","non_qualified":"1F645-1F3FF-200D-2640","image":"1f645-1f3ff-200d-2640-fe0f.png","sheet_x":31,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F645","a":"Woman Gesturing No","b":"1F645-200D-2640-FE0F","c":"1F645-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[31,47],"o":4},"taxi":{"a":"Taxi","b":"1F695","d":true,"e":true,"f":true,"h":true,"j":["uber","vehicle","cars","transportation"],"k":[34,20],"o":2},"flag-fk":{"a":"Falkland Islands Flag","b":"1F1EB-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[1,50],"o":2},"floppy_disk":{"a":"Floppy Disk","b":"1F4BE","d":true,"e":true,"f":true,"h":true,"j":["oldschool","technology","save","90s","80s"],"k":[26,20],"o":2},"t-rex":{"a":"T-Rex","b":"1F996","d":true,"e":true,"f":true,"h":true,"k":[42,40],"o":5},"oyster":{"a":"Oyster","b":"1F9AA","d":true,"e":true,"f":true,"h":true,"k":[43,1],"o":12},"arrow_double_up":{"a":"Black Up-Pointing Double Triangle","b":"23EB","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","top"],"k":[52,28],"o":2},"oncoming_taxi":{"a":"Oncoming Taxi","b":"1F696","d":true,"e":true,"f":true,"h":true,"j":["vehicle","cars","uber"],"k":[34,21],"o":2},"ok_woman":{"skin_variations":{"1F3FB":{"unified":"1F646-1F3FB","non_qualified":null,"image":"1f646-1f3fb.png","sheet_x":32,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F646-1F3FC","non_qualified":null,"image":"1f646-1f3fc.png","sheet_x":32,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F646-1F3FD","non_qualified":null,"image":"1f646-1f3fd.png","sheet_x":32,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F646-1F3FE","non_qualified":null,"image":"1f646-1f3fe.png","sheet_x":32,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F646-1F3FF","non_qualified":null,"image":"1f646-1f3ff.png","sheet_x":32,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F646-200D-2640-FE0F","a":"Face with Ok Gesture","b":"1F646","d":true,"e":true,"f":true,"h":false,"j":["women","girl","female","pink","human","woman"],"k":[32,20],"o":2},"weary":{"a":"Weary Face","b":"1F629","d":true,"e":true,"f":true,"h":true,"j":["face","tired","sleepy","sad","frustrated","upset"],"k":[31,19],"o":2},"man-gesturing-ok":{"skin_variations":{"1F3FB":{"unified":"1F646-1F3FB-200D-2642-FE0F","non_qualified":"1F646-1F3FB-200D-2642","image":"1f646-1f3fb-200d-2642-fe0f.png","sheet_x":32,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F646-1F3FC-200D-2642-FE0F","non_qualified":"1F646-1F3FC-200D-2642","image":"1f646-1f3fc-200d-2642-fe0f.png","sheet_x":32,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F646-1F3FD-200D-2642-FE0F","non_qualified":"1F646-1F3FD-200D-2642","image":"1f646-1f3fd-200d-2642-fe0f.png","sheet_x":32,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F646-1F3FE-200D-2642-FE0F","non_qualified":"1F646-1F3FE-200D-2642","image":"1f646-1f3fe-200d-2642-fe0f.png","sheet_x":32,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F646-1F3FF-200D-2642-FE0F","non_qualified":"1F646-1F3FF-200D-2642","image":"1f646-1f3ff-200d-2642-fe0f.png","sheet_x":32,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Gesturing Ok","b":"1F646-200D-2642-FE0F","c":"1F646-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[32,14],"o":4},"arrow_down_small":{"a":"Down-Pointing Small Red Triangle","b":"1F53D","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","bottom"],"k":[28,32],"o":2},"tired_face":{"a":"Tired Face","b":"1F62B","d":true,"e":true,"f":true,"h":true,"j":["sick","whine","upset","frustrated"],"k":[31,21],"o":2},"car":{"a":"Automobile","b":"1F697","d":true,"e":true,"f":true,"h":true,"k":[34,22],"n":["red_car"],"o":2},"icecream":{"a":"Soft Ice Cream","b":"1F366","d":true,"e":true,"f":true,"h":true,"j":["food","hot","dessert","summer"],"k":[7,5],"o":2},"cd":{"a":"Optical Disc","b":"1F4BF","d":true,"e":true,"f":true,"h":true,"j":["technology","dvd","disk","disc","90s"],"k":[26,21],"o":2},"whale":{"a":"Spouting Whale","b":"1F433","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","sea","ocean"],"k":[12,23],"o":2},"flag-fm":{"a":"Micronesia Flag","b":"1F1EB-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[1,51],"o":2},"oncoming_automobile":{"a":"Oncoming Automobile","b":"1F698","d":true,"e":true,"f":true,"h":true,"j":["car","vehicle","transportation"],"k":[34,23],"o":2},"arrow_double_down":{"a":"Black Down-Pointing Double Triangle","b":"23EC","d":true,"e":true,"f":true,"h":true,"j":["blue-square","direction","bottom"],"k":[52,29],"o":2},"woman-gesturing-ok":{"skin_variations":{"1F3FB":{"unified":"1F646-1F3FB-200D-2640-FE0F","non_qualified":"1F646-1F3FB-200D-2640","image":"1f646-1f3fb-200d-2640-fe0f.png","sheet_x":32,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F646-1F3FC-200D-2640-FE0F","non_qualified":"1F646-1F3FC-200D-2640","image":"1f646-1f3fc-200d-2640-fe0f.png","sheet_x":32,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F646-1F3FD-200D-2640-FE0F","non_qualified":"1F646-1F3FD-200D-2640","image":"1f646-1f3fd-200d-2640-fe0f.png","sheet_x":32,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F646-1F3FE-200D-2640-FE0F","non_qualified":"1F646-1F3FE-200D-2640","image":"1f646-1f3fe-200d-2640-fe0f.png","sheet_x":32,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F646-1F3FF-200D-2640-FE0F","non_qualified":"1F646-1F3FF-200D-2640","image":"1f646-1f3ff-200d-2640-fe0f.png","sheet_x":32,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F646","a":"Woman Gesturing Ok","b":"1F646-200D-2640-FE0F","c":"1F646-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[32,8],"o":4},"yawning_face":{"a":"Yawning Face","b":"1F971","d":true,"e":true,"f":true,"h":true,"k":[42,7],"o":12},"dvd":{"a":"Dvd","b":"1F4C0","d":true,"e":true,"f":true,"h":true,"j":["cd","disk","disc"],"k":[26,22],"o":2},"whale2":{"a":"Whale","b":"1F40B","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","sea","ocean"],"k":[11,39],"o":2},"flag-fo":{"a":"Faroe Islands Flag","b":"1F1EB-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[1,52],"o":2},"shaved_ice":{"a":"Shaved Ice","b":"1F367","d":true,"e":true,"f":true,"h":true,"j":["hot","dessert","summer"],"k":[7,6],"o":2},"double_vertical_bar":{"a":"Double Vertical Bar","b":"23F8-FE0F","c":"23F8","d":true,"e":true,"f":true,"h":true,"k":[52,37],"o":2},"information_desk_person":{"skin_variations":{"1F3FB":{"unified":"1F481-1F3FB","non_qualified":null,"image":"1f481-1f3fb.png","sheet_x":24,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F481-1F3FC","non_qualified":null,"image":"1f481-1f3fc.png","sheet_x":24,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F481-1F3FD","non_qualified":null,"image":"1f481-1f3fd.png","sheet_x":24,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F481-1F3FE","non_qualified":null,"image":"1f481-1f3fe.png","sheet_x":24,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F481-1F3FF","non_qualified":null,"image":"1f481-1f3ff.png","sheet_x":24,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F481-200D-2640-FE0F","a":"Information Desk Person","b":"1F481","d":true,"e":true,"f":true,"h":false,"k":[24,2],"o":2},"dolphin":{"a":"Dolphin","b":"1F42C","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","fish","sea","ocean","flipper","fins","beach"],"k":[12,16],"n":["flipper"],"o":2},"blue_car":{"a":"Recreational Vehicle","b":"1F699","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle"],"k":[34,24],"o":2},"ice_cream":{"a":"Ice Cream","b":"1F368","d":true,"e":true,"f":true,"h":true,"j":["food","hot","dessert"],"k":[7,7],"o":2},"fr":{"a":"France Flag","b":"1F1EB-1F1F7","d":true,"e":true,"f":true,"h":true,"j":["banner","flag","nation","france","french","country"],"k":[1,53],"n":["flag-fr"],"o":2},"triumph":{"a":"Face with Look of Triumph","b":"1F624","d":true,"e":true,"f":true,"h":true,"j":["face","gas","phew","proud","pride"],"k":[31,14],"o":2},"abacus":{"a":"Abacus","b":"1F9EE","d":true,"e":true,"f":true,"h":true,"k":[51,33],"o":11},"man-tipping-hand":{"skin_variations":{"1F3FB":{"unified":"1F481-1F3FB-200D-2642-FE0F","non_qualified":"1F481-1F3FB-200D-2642","image":"1f481-1f3fb-200d-2642-fe0f.png","sheet_x":23,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F481-1F3FC-200D-2642-FE0F","non_qualified":"1F481-1F3FC-200D-2642","image":"1f481-1f3fc-200d-2642-fe0f.png","sheet_x":23,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F481-1F3FD-200D-2642-FE0F","non_qualified":"1F481-1F3FD-200D-2642","image":"1f481-1f3fd-200d-2642-fe0f.png","sheet_x":23,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F481-1F3FE-200D-2642-FE0F","non_qualified":"1F481-1F3FE-200D-2642","image":"1f481-1f3fe-200d-2642-fe0f.png","sheet_x":24,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F481-1F3FF-200D-2642-FE0F","non_qualified":"1F481-1F3FF-200D-2642","image":"1f481-1f3ff-200d-2642-fe0f.png","sheet_x":24,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Tipping Hand","b":"1F481-200D-2642-FE0F","c":"1F481-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[23,53],"o":4},"doughnut":{"a":"Doughnut","b":"1F369","d":true,"e":true,"f":true,"h":true,"j":["food","dessert","snack","sweet","donut"],"k":[7,8],"o":2},"fish":{"a":"Fish","b":"1F41F","d":true,"e":true,"f":true,"h":true,"j":["animal","food","nature"],"k":[12,3],"o":2},"truck":{"a":"Delivery Truck","b":"1F69A","d":true,"e":true,"f":true,"h":true,"j":["cars","transportation"],"k":[34,25],"o":2},"movie_camera":{"a":"Movie Camera","b":"1F3A5","d":true,"e":true,"f":true,"h":true,"j":["film","record"],"k":[8,11],"o":2},"flag-ga":{"a":"Gabon Flag","b":"1F1EC-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[1,54],"o":2},"rage":{"a":"Pouting Face","b":"1F621","d":true,"e":true,"f":true,"h":true,"j":["angry","mad","hate","despise"],"k":[31,11],"o":2},"black_square_for_stop":{"a":"Black Square for Stop","b":"23F9-FE0F","c":"23F9","d":true,"e":true,"f":true,"h":true,"k":[52,38],"o":2},"articulated_lorry":{"a":"Articulated Lorry","b":"1F69B","d":true,"e":true,"f":true,"h":true,"j":["vehicle","cars","transportation","express"],"k":[34,26],"o":2},"angry":{"a":"Angry Face","b":"1F620","d":true,"e":true,"f":true,"h":true,"j":["mad","face","annoyed","frustrated"],"k":[31,10],"l":[">:(",">:-("],"o":2},"cookie":{"a":"Cookie","b":"1F36A","d":true,"e":true,"f":true,"h":true,"j":["food","snack","oreo","chocolate","sweet","dessert"],"k":[7,9],"o":2},"gb":{"a":"United Kingdom Flag","b":"1F1EC-1F1E7","d":true,"e":true,"f":true,"h":true,"k":[1,55],"n":["uk","flag-gb"],"o":2},"tropical_fish":{"a":"Tropical Fish","b":"1F420","d":true,"e":true,"f":true,"h":true,"j":["animal","swim","ocean","beach","nemo"],"k":[12,4],"o":2},"woman-tipping-hand":{"skin_variations":{"1F3FB":{"unified":"1F481-1F3FB-200D-2640-FE0F","non_qualified":"1F481-1F3FB-200D-2640","image":"1f481-1f3fb-200d-2640-fe0f.png","sheet_x":23,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F481-1F3FC-200D-2640-FE0F","non_qualified":"1F481-1F3FC-200D-2640","image":"1f481-1f3fc-200d-2640-fe0f.png","sheet_x":23,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F481-1F3FD-200D-2640-FE0F","non_qualified":"1F481-1F3FD-200D-2640","image":"1f481-1f3fd-200d-2640-fe0f.png","sheet_x":23,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F481-1F3FE-200D-2640-FE0F","non_qualified":"1F481-1F3FE-200D-2640","image":"1f481-1f3fe-200d-2640-fe0f.png","sheet_x":23,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F481-1F3FF-200D-2640-FE0F","non_qualified":"1F481-1F3FF-200D-2640","image":"1f481-1f3ff-200d-2640-fe0f.png","sheet_x":23,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F481","a":"Woman Tipping Hand","b":"1F481-200D-2640-FE0F","c":"1F481-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[23,47],"o":4},"black_circle_for_record":{"a":"Black Circle for Record","b":"23FA-FE0F","c":"23FA","d":true,"e":true,"f":true,"h":true,"k":[52,39],"o":2},"film_frames":{"a":"Film Frames","b":"1F39E-FE0F","c":"1F39E","d":true,"e":true,"f":true,"h":true,"k":[8,4],"o":2},"film_projector":{"a":"Film Projector","b":"1F4FD-FE0F","c":"1F4FD","d":true,"e":true,"f":true,"h":true,"j":["video","tape","record","movie"],"k":[27,26],"o":2},"flag-gd":{"a":"Grenada Flag","b":"1F1EC-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[1,56],"o":2},"blowfish":{"a":"Blowfish","b":"1F421","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","food","sea","ocean"],"k":[12,5],"o":2},"face_with_symbols_on_mouth":{"a":"Serious Face with Symbols Covering Mouth","b":"1F92C","d":true,"e":true,"f":true,"h":true,"k":[38,46],"n":["serious_face_with_symbols_covering_mouth"],"o":5},"birthday":{"a":"Birthday Cake","b":"1F382","d":true,"e":true,"f":true,"h":true,"j":["food","dessert","cake"],"k":[7,33],"o":2},"eject":{"a":"Eject","b":"23CF-FE0F","c":"23CF","d":true,"e":true,"f":true,"h":true,"k":[52,25],"o":2},"raising_hand":{"skin_variations":{"1F3FB":{"unified":"1F64B-1F3FB","non_qualified":null,"image":"1f64b-1f3fb.png","sheet_x":33,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F64B-1F3FC","non_qualified":null,"image":"1f64b-1f3fc.png","sheet_x":33,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F64B-1F3FD","non_qualified":null,"image":"1f64b-1f3fd.png","sheet_x":33,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F64B-1F3FE","non_qualified":null,"image":"1f64b-1f3fe.png","sheet_x":33,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F64B-1F3FF","non_qualified":null,"image":"1f64b-1f3ff.png","sheet_x":33,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F64B-200D-2640-FE0F","a":"Happy Person Raising One Hand","b":"1F64B","d":true,"e":true,"f":true,"h":false,"k":[33,2],"o":2},"tractor":{"a":"Tractor","b":"1F69C","d":true,"e":true,"f":true,"h":true,"j":["vehicle","car","farming","agriculture"],"k":[34,27],"o":2},"flag-ge":{"a":"Georgia Flag","b":"1F1EC-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[2,0],"o":2},"smiling_imp":{"a":"Smiling Face with Horns","b":"1F608","d":true,"e":true,"f":true,"h":true,"j":["devil","horns"],"k":[30,43],"o":2},"racing_car":{"a":"Racing Car","b":"1F3CE-FE0F","c":"1F3CE","d":true,"e":true,"f":true,"h":true,"j":["sports","race","fast","formula","f1"],"k":[10,33],"o":2},"cinema":{"a":"Cinema","b":"1F3A6","d":true,"e":true,"f":true,"h":true,"j":["blue-square","record","film","movie","curtain","stage","theater"],"k":[8,12],"o":2},"clapper":{"a":"Clapper Board","b":"1F3AC","d":true,"e":true,"f":true,"h":true,"j":["movie","film","record"],"k":[8,18],"o":2},"shark":{"a":"Shark","b":"1F988","d":true,"e":true,"f":true,"h":true,"j":["animal","nature","fish","sea","ocean","jaws","fins","beach"],"k":[42,26],"o":4},"cake":{"a":"Shortcake","b":"1F370","d":true,"e":true,"f":true,"h":true,"j":["food","dessert"],"k":[7,15],"o":2},"man-raising-hand":{"skin_variations":{"1F3FB":{"unified":"1F64B-1F3FB-200D-2642-FE0F","non_qualified":"1F64B-1F3FB-200D-2642","image":"1f64b-1f3fb-200d-2642-fe0f.png","sheet_x":32,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64B-1F3FC-200D-2642-FE0F","non_qualified":"1F64B-1F3FC-200D-2642","image":"1f64b-1f3fc-200d-2642-fe0f.png","sheet_x":32,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64B-1F3FD-200D-2642-FE0F","non_qualified":"1F64B-1F3FD-200D-2642","image":"1f64b-1f3fd-200d-2642-fe0f.png","sheet_x":32,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64B-1F3FE-200D-2642-FE0F","non_qualified":"1F64B-1F3FE-200D-2642","image":"1f64b-1f3fe-200d-2642-fe0f.png","sheet_x":33,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64B-1F3FF-200D-2642-FE0F","non_qualified":"1F64B-1F3FF-200D-2642","image":"1f64b-1f3ff-200d-2642-fe0f.png","sheet_x":33,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Raising Hand","b":"1F64B-200D-2642-FE0F","c":"1F64B-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[32,53],"o":4},"octopus":{"a":"Octopus","b":"1F419","d":true,"e":true,"f":true,"h":true,"j":["animal","creature","ocean","sea","nature","beach"],"k":[11,54],"o":2},"woman-raising-hand":{"skin_variations":{"1F3FB":{"unified":"1F64B-1F3FB-200D-2640-FE0F","non_qualified":"1F64B-1F3FB-200D-2640","image":"1f64b-1f3fb-200d-2640-fe0f.png","sheet_x":32,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F64B-1F3FC-200D-2640-FE0F","non_qualified":"1F64B-1F3FC-200D-2640","image":"1f64b-1f3fc-200d-2640-fe0f.png","sheet_x":32,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F64B-1F3FD-200D-2640-FE0F","non_qualified":"1F64B-1F3FD-200D-2640","image":"1f64b-1f3fd-200d-2640-fe0f.png","sheet_x":32,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F64B-1F3FE-200D-2640-FE0F","non_qualified":"1F64B-1F3FE-200D-2640","image":"1f64b-1f3fe-200d-2640-fe0f.png","sheet_x":32,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F64B-1F3FF-200D-2640-FE0F","non_qualified":"1F64B-1F3FF-200D-2640","image":"1f64b-1f3ff-200d-2640-fe0f.png","sheet_x":32,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F64B","a":"Woman Raising Hand","b":"1F64B-200D-2640-FE0F","c":"1F64B-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[32,47],"o":4},"flag-gf":{"a":"French Guiana Flag","b":"1F1EC-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[2,1],"o":2},"tv":{"a":"Television","b":"1F4FA","d":true,"e":true,"f":true,"h":true,"j":["technology","program","oldschool","show","television"],"k":[27,23],"o":2},"imp":{"a":"Imp","b":"1F47F","d":true,"e":true,"f":true,"h":true,"j":["devil","angry","horns"],"k":[23,45],"o":2},"cupcake":{"a":"Cupcake","b":"1F9C1","d":true,"e":true,"f":true,"h":true,"k":[44,9],"o":11},"racing_motorcycle":{"a":"Racing Motorcycle","b":"1F3CD-FE0F","c":"1F3CD","d":true,"e":true,"f":true,"h":true,"k":[10,32],"o":2},"low_brightness":{"a":"Low Brightness Symbol","b":"1F505","d":true,"e":true,"f":true,"h":true,"j":["sun","afternoon","warm","summer"],"k":[27,33],"o":2},"shell":{"a":"Spiral Shell","b":"1F41A","d":true,"e":true,"f":true,"h":true,"j":["nature","sea","beach"],"k":[11,55],"o":2},"flag-gg":{"a":"Guernsey Flag","b":"1F1EC-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[2,2],"o":2},"high_brightness":{"a":"High Brightness Symbol","b":"1F506","d":true,"e":true,"f":true,"h":true,"j":["sun","light"],"k":[27,34],"o":2},"deaf_person":{"skin_variations":{"1F3FB":{"unified":"1F9CF-1F3FB","non_qualified":null,"image":"1f9cf-1f3fb.png","sheet_x":45,"sheet_y":11,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CF-1F3FC","non_qualified":null,"image":"1f9cf-1f3fc.png","sheet_x":45,"sheet_y":12,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CF-1F3FD","non_qualified":null,"image":"1f9cf-1f3fd.png","sheet_x":45,"sheet_y":13,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CF-1F3FE","non_qualified":null,"image":"1f9cf-1f3fe.png","sheet_x":45,"sheet_y":14,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CF-1F3FF","non_qualified":null,"image":"1f9cf-1f3ff.png","sheet_x":45,"sheet_y":15,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Deaf Person","b":"1F9CF","d":true,"e":true,"f":true,"h":true,"k":[45,10],"o":12},"skull":{"a":"Skull","b":"1F480","d":true,"e":true,"f":true,"h":true,"j":["dead","skeleton","creepy","death"],"k":[23,46],"o":2},"motor_scooter":{"a":"Motor Scooter","b":"1F6F5","d":true,"e":true,"f":true,"h":true,"j":["vehicle","vespa","sasha"],"k":[36,54],"o":4},"camera":{"a":"Camera","b":"1F4F7","d":true,"e":true,"f":true,"h":true,"j":["gadgets","photography"],"k":[27,20],"o":2},"pie":{"a":"Pie","b":"1F967","d":true,"e":true,"f":true,"h":true,"k":[41,54],"o":5},"flag-gh":{"a":"Ghana Flag","b":"1F1EC-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[2,3],"o":2},"deaf_man":{"skin_variations":{"1F3FB":{"unified":"1F9CF-1F3FB-200D-2642-FE0F","non_qualified":"1F9CF-1F3FB-200D-2642","image":"1f9cf-1f3fb-200d-2642-fe0f.png","sheet_x":45,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CF-1F3FC-200D-2642-FE0F","non_qualified":"1F9CF-1F3FC-200D-2642","image":"1f9cf-1f3fc-200d-2642-fe0f.png","sheet_x":45,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CF-1F3FD-200D-2642-FE0F","non_qualified":"1F9CF-1F3FD-200D-2642","image":"1f9cf-1f3fd-200d-2642-fe0f.png","sheet_x":45,"sheet_y":7,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CF-1F3FE-200D-2642-FE0F","non_qualified":"1F9CF-1F3FE-200D-2642","image":"1f9cf-1f3fe-200d-2642-fe0f.png","sheet_x":45,"sheet_y":8,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CF-1F3FF-200D-2642-FE0F","non_qualified":"1F9CF-1F3FF-200D-2642","image":"1f9cf-1f3ff-200d-2642-fe0f.png","sheet_x":45,"sheet_y":9,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Deaf Man","b":"1F9CF-200D-2642-FE0F","c":"1F9CF-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[45,4],"o":12},"skull_and_crossbones":{"a":"Skull and Crossbones","b":"2620-FE0F","c":"2620","d":true,"e":true,"f":true,"h":true,"j":["poison","danger","deadly","scary","death","pirate","evil"],"k":[53,8],"o":2},"camera_with_flash":{"a":"Camera with Flash","b":"1F4F8","d":true,"e":true,"f":true,"h":true,"k":[27,21],"o":2},"signal_strength":{"a":"Antenna with Bars","b":"1F4F6","d":true,"e":true,"f":true,"h":true,"j":["blue-square","reception","phone","internet","connection","wifi","bluetooth","bars"],"k":[27,19],"o":2},"chocolate_bar":{"a":"Chocolate Bar","b":"1F36B","d":true,"e":true,"f":true,"h":true,"j":["food","snack","dessert","sweet"],"k":[7,10],"o":2},"manual_wheelchair":{"a":"Manual Wheelchair","b":"1F9BD","d":true,"e":true,"f":true,"h":true,"k":[44,5],"o":12},"snail":{"a":"Snail","b":"1F40C","d":true,"e":true,"f":true,"h":true,"j":["slow","animal","shell"],"k":[11,40],"o":2},"motorized_wheelchair":{"a":"Motorized Wheelchair","b":"1F9BC","d":true,"e":true,"f":true,"h":true,"k":[44,4],"o":12},"flag-gi":{"a":"Gibraltar Flag","b":"1F1EC-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[2,4],"o":2},"hankey":{"a":"Pile of Poo","b":"1F4A9","d":true,"e":true,"f":true,"h":true,"k":[25,51],"n":["poop","shit"],"o":2},"vibration_mode":{"a":"Vibration Mode","b":"1F4F3","d":true,"e":true,"f":true,"h":true,"j":["orange-square","phone"],"k":[27,16],"o":2},"deaf_woman":{"skin_variations":{"1F3FB":{"unified":"1F9CF-1F3FB-200D-2640-FE0F","non_qualified":"1F9CF-1F3FB-200D-2640","image":"1f9cf-1f3fb-200d-2640-fe0f.png","sheet_x":44,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CF-1F3FC-200D-2640-FE0F","non_qualified":"1F9CF-1F3FC-200D-2640","image":"1f9cf-1f3fc-200d-2640-fe0f.png","sheet_x":45,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CF-1F3FD-200D-2640-FE0F","non_qualified":"1F9CF-1F3FD-200D-2640","image":"1f9cf-1f3fd-200d-2640-fe0f.png","sheet_x":45,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CF-1F3FE-200D-2640-FE0F","non_qualified":"1F9CF-1F3FE-200D-2640","image":"1f9cf-1f3fe-200d-2640-fe0f.png","sheet_x":45,"sheet_y":2,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CF-1F3FF-200D-2640-FE0F","non_qualified":"1F9CF-1F3FF-200D-2640","image":"1f9cf-1f3ff-200d-2640-fe0f.png","sheet_x":45,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Deaf Woman","b":"1F9CF-200D-2640-FE0F","c":"1F9CF-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[44,55],"o":12},"butterfly":{"a":"Butterfly","b":"1F98B","d":true,"e":true,"f":true,"h":true,"j":["animal","insect","nature","caterpillar"],"k":[42,29],"o":4},"video_camera":{"a":"Video Camera","b":"1F4F9","d":true,"e":true,"f":true,"h":true,"j":["film","record"],"k":[27,22],"o":2},"candy":{"a":"Candy","b":"1F36C","d":true,"e":true,"f":true,"h":true,"j":["snack","dessert","sweet","lolly"],"k":[7,11],"o":2},"auto_rickshaw":{"a":"Auto Rickshaw","b":"1F6FA","d":true,"e":true,"f":true,"h":true,"k":[37,2],"o":12},"bow":{"skin_variations":{"1F3FB":{"unified":"1F647-1F3FB","non_qualified":null,"image":"1f647-1f3fb.png","sheet_x":32,"sheet_y":39,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F647-1F3FC","non_qualified":null,"image":"1f647-1f3fc.png","sheet_x":32,"sheet_y":40,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F647-1F3FD","non_qualified":null,"image":"1f647-1f3fd.png","sheet_x":32,"sheet_y":41,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F647-1F3FE","non_qualified":null,"image":"1f647-1f3fe.png","sheet_x":32,"sheet_y":42,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F647-1F3FF","non_qualified":null,"image":"1f647-1f3ff.png","sheet_x":32,"sheet_y":43,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F647-200D-2642-FE0F","a":"Person Bowing Deeply","b":"1F647","d":true,"e":true,"f":true,"h":false,"k":[32,38],"o":2},"mobile_phone_off":{"a":"Mobile Phone off","b":"1F4F4","d":true,"e":true,"f":true,"h":true,"j":["mute","orange-square","silence","quiet"],"k":[27,17],"o":2},"clown_face":{"a":"Clown Face","b":"1F921","d":true,"e":true,"f":true,"h":true,"j":["face"],"k":[38,18],"o":4},"lollipop":{"a":"Lollipop","b":"1F36D","d":true,"e":true,"f":true,"h":true,"j":["food","snack","candy","sweet"],"k":[7,12],"o":2},"flag-gl":{"a":"Greenland Flag","b":"1F1EC-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[2,5],"o":2},"vhs":{"a":"Videocassette","b":"1F4FC","d":true,"e":true,"f":true,"h":true,"j":["record","video","oldschool","90s","80s"],"k":[27,25],"o":2},"bug":{"a":"Bug","b":"1F41B","d":true,"e":true,"f":true,"h":true,"j":["animal","insect","nature","worm"],"k":[11,56],"o":2},"bike":{"a":"Bicycle","b":"1F6B2","d":true,"e":true,"f":true,"h":true,"j":["sports","bicycle","exercise","hipster"],"k":[35,9],"o":2},"man-bowing":{"skin_variations":{"1F3FB":{"unified":"1F647-1F3FB-200D-2642-FE0F","non_qualified":"1F647-1F3FB-200D-2642","image":"1f647-1f3fb-200d-2642-fe0f.png","sheet_x":32,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F647-1F3FC-200D-2642-FE0F","non_qualified":"1F647-1F3FC-200D-2642","image":"1f647-1f3fc-200d-2642-fe0f.png","sheet_x":32,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F647-1F3FD-200D-2642-FE0F","non_qualified":"1F647-1F3FD-200D-2642","image":"1f647-1f3fd-200d-2642-fe0f.png","sheet_x":32,"sheet_y":35,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F647-1F3FE-200D-2642-FE0F","non_qualified":"1F647-1F3FE-200D-2642","image":"1f647-1f3fe-200d-2642-fe0f.png","sheet_x":32,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F647-1F3FF-200D-2642-FE0F","non_qualified":"1F647-1F3FF-200D-2642","image":"1f647-1f3ff-200d-2642-fe0f.png","sheet_x":32,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F647","a":"Man Bowing","b":"1F647-200D-2642-FE0F","c":"1F647-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[32,32],"o":4},"female_sign":{"a":"Female Sign","b":"2640-FE0F","c":"2640","d":false,"e":true,"f":true,"h":true,"k":[53,18],"o":4},"japanese_ogre":{"a":"Japanese Ogre","b":"1F479","d":true,"e":true,"f":true,"h":true,"j":["monster","red","mask","halloween","scary","creepy","devil","demon","japanese","ogre"],"k":[23,34],"o":2},"custard":{"a":"Custard","b":"1F36E","d":true,"e":true,"f":true,"h":true,"j":["dessert","food"],"k":[7,13],"o":2},"ant":{"a":"Ant","b":"1F41C","d":true,"e":true,"f":true,"h":true,"j":["animal","insect","nature","bug"],"k":[12,0],"o":2},"mag":{"a":"Left-Pointing Magnifying Glass","b":"1F50D","d":true,"e":true,"f":true,"h":true,"j":["search","zoom","find","detective"],"k":[27,41],"o":2},"flag-gm":{"a":"Gambia Flag","b":"1F1EC-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[2,6],"o":2},"honey_pot":{"a":"Honey Pot","b":"1F36F","d":true,"e":true,"f":true,"h":true,"j":["bees","sweet","kitchen"],"k":[7,14],"o":2},"woman-bowing":{"skin_variations":{"1F3FB":{"unified":"1F647-1F3FB-200D-2640-FE0F","non_qualified":"1F647-1F3FB-200D-2640","image":"1f647-1f3fb-200d-2640-fe0f.png","sheet_x":32,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F647-1F3FC-200D-2640-FE0F","non_qualified":"1F647-1F3FC-200D-2640","image":"1f647-1f3fc-200d-2640-fe0f.png","sheet_x":32,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F647-1F3FD-200D-2640-FE0F","non_qualified":"1F647-1F3FD-200D-2640","image":"1f647-1f3fd-200d-2640-fe0f.png","sheet_x":32,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F647-1F3FE-200D-2640-FE0F","non_qualified":"1F647-1F3FE-200D-2640","image":"1f647-1f3fe-200d-2640-fe0f.png","sheet_x":32,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F647-1F3FF-200D-2640-FE0F","non_qualified":"1F647-1F3FF-200D-2640","image":"1f647-1f3ff-200d-2640-fe0f.png","sheet_x":32,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Bowing","b":"1F647-200D-2640-FE0F","c":"1F647-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[32,26],"o":4},"male_sign":{"a":"Male Sign","b":"2642-FE0F","c":"2642","d":false,"e":true,"f":true,"h":true,"k":[53,19],"o":4},"mag_right":{"a":"Right-Pointing Magnifying Glass","b":"1F50E","d":true,"e":true,"f":true,"h":true,"j":["search","zoom","find","detective"],"k":[27,42],"o":2},"japanese_goblin":{"a":"Japanese Goblin","b":"1F47A","d":true,"e":true,"f":true,"h":true,"j":["red","evil","mask","monster","scary","creepy","japanese","goblin"],"k":[23,35],"o":2},"scooter":{"a":"Scooter","b":"1F6F4","d":true,"e":true,"f":true,"h":true,"k":[36,53],"o":4},"bee":{"a":"Honeybee","b":"1F41D","d":true,"e":true,"f":true,"h":true,"k":[12,1],"n":["honeybee"],"o":2},"flag-gn":{"a":"Guinea Flag","b":"1F1EC-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[2,7],"o":2},"candle":{"a":"Candle","b":"1F56F-FE0F","c":"1F56F","d":true,"e":true,"f":true,"h":true,"j":["fire","wax"],"k":[29,6],"o":2},"skateboard":{"a":"Skateboard","b":"1F6F9","d":true,"e":true,"f":true,"h":true,"k":[37,1],"o":11},"medical_symbol":{"a":"Medical Symbol","b":"2695-FE0F","c":"2695","d":false,"e":true,"f":true,"h":true,"k":[53,44],"n":["staff_of_aesculapius"],"o":4},"ghost":{"a":"Ghost","b":"1F47B","d":true,"e":true,"f":true,"h":true,"j":["halloween","spooky","scary"],"k":[23,36],"o":2},"beetle":{"a":"Lady Beetle","b":"1F41E","d":true,"e":true,"f":true,"h":true,"j":["animal","insect","nature","ladybug"],"k":[12,2],"o":2},"face_palm":{"skin_variations":{"1F3FB":{"unified":"1F926-1F3FB","non_qualified":null,"image":"1f926-1f3fb.png","sheet_x":38,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F926-1F3FC","non_qualified":null,"image":"1f926-1f3fc.png","sheet_x":38,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F926-1F3FD","non_qualified":null,"image":"1f926-1f3fd.png","sheet_x":38,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F926-1F3FE","non_qualified":null,"image":"1f926-1f3fe.png","sheet_x":38,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F926-1F3FF","non_qualified":null,"image":"1f926-1f3ff.png","sheet_x":38,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Face Palm","b":"1F926","d":true,"e":true,"f":true,"h":false,"k":[38,35],"o":4},"flag-gp":{"a":"Guadeloupe Flag","b":"1F1EC-1F1F5","d":true,"e":true,"f":true,"h":true,"k":[2,8],"o":2},"baby_bottle":{"a":"Baby Bottle","b":"1F37C","d":true,"e":true,"f":true,"h":true,"j":["food","container","milk"],"k":[7,27],"o":2},"infinity":{"a":"Infinity","b":"267E-FE0F","c":"267E","d":true,"e":true,"f":true,"h":true,"k":[53,39],"o":11},"glass_of_milk":{"a":"Glass of Milk","b":"1F95B","d":true,"e":true,"f":true,"h":true,"k":[41,42],"o":4},"man-facepalming":{"skin_variations":{"1F3FB":{"unified":"1F926-1F3FB-200D-2642-FE0F","non_qualified":"1F926-1F3FB-200D-2642","image":"1f926-1f3fb-200d-2642-fe0f.png","sheet_x":38,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F926-1F3FC-200D-2642-FE0F","non_qualified":"1F926-1F3FC-200D-2642","image":"1f926-1f3fc-200d-2642-fe0f.png","sheet_x":38,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F926-1F3FD-200D-2642-FE0F","non_qualified":"1F926-1F3FD-200D-2642","image":"1f926-1f3fd-200d-2642-fe0f.png","sheet_x":38,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F926-1F3FE-200D-2642-FE0F","non_qualified":"1F926-1F3FE-200D-2642","image":"1f926-1f3fe-200d-2642-fe0f.png","sheet_x":38,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F926-1F3FF-200D-2642-FE0F","non_qualified":"1F926-1F3FF-200D-2642","image":"1f926-1f3ff-200d-2642-fe0f.png","sheet_x":38,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Facepalming","b":"1F926-200D-2642-FE0F","c":"1F926-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[38,29],"o":4},"cricket":{"a":"Cricket","b":"1F997","d":true,"e":true,"f":true,"h":true,"j":["sports"],"k":[42,41],"o":5},"busstop":{"a":"Bus Stop","b":"1F68F","d":true,"e":true,"f":true,"h":true,"j":["transportation","wait"],"k":[34,14],"o":2},"flag-gq":{"a":"Equatorial Guinea Flag","b":"1F1EC-1F1F6","d":true,"e":true,"f":true,"h":true,"k":[2,9],"o":2},"alien":{"a":"Extraterrestrial Alien","b":"1F47D","d":true,"e":true,"f":true,"h":true,"j":["UFO","paul","weird","outer_space"],"k":[23,43],"o":2},"bulb":{"a":"Electric Light Bulb","b":"1F4A1","d":true,"e":true,"f":true,"h":true,"j":["light","electricity","idea"],"k":[25,43],"o":2},"woman-facepalming":{"skin_variations":{"1F3FB":{"unified":"1F926-1F3FB-200D-2640-FE0F","non_qualified":"1F926-1F3FB-200D-2640","image":"1f926-1f3fb-200d-2640-fe0f.png","sheet_x":38,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F926-1F3FC-200D-2640-FE0F","non_qualified":"1F926-1F3FC-200D-2640","image":"1f926-1f3fc-200d-2640-fe0f.png","sheet_x":38,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F926-1F3FD-200D-2640-FE0F","non_qualified":"1F926-1F3FD-200D-2640","image":"1f926-1f3fd-200d-2640-fe0f.png","sheet_x":38,"sheet_y":26,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F926-1F3FE-200D-2640-FE0F","non_qualified":"1F926-1F3FE-200D-2640","image":"1f926-1f3fe-200d-2640-fe0f.png","sheet_x":38,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F926-1F3FF-200D-2640-FE0F","non_qualified":"1F926-1F3FF-200D-2640","image":"1f926-1f3ff-200d-2640-fe0f.png","sheet_x":38,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Facepalming","b":"1F926-200D-2640-FE0F","c":"1F926-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[38,23],"o":4},"spider":{"a":"Spider","b":"1F577-FE0F","c":"1F577","d":true,"e":true,"f":true,"h":true,"j":["animal","arachnid"],"k":[29,34],"o":2},"space_invader":{"a":"Alien Monster","b":"1F47E","d":true,"e":true,"f":true,"h":true,"j":["game","arcade","play"],"k":[23,44],"o":2},"motorway":{"a":"Motorway","b":"1F6E3-FE0F","c":"1F6E3","d":true,"e":true,"f":true,"h":true,"j":["road","cupertino","interstate","highway"],"k":[36,45],"o":2},"flag-gr":{"a":"Greece Flag","b":"1F1EC-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[2,10],"o":2},"recycle":{"a":"Black Universal Recycling Symbol","b":"267B-FE0F","c":"267B","d":true,"e":true,"f":true,"h":true,"j":["arrow","environment","garbage","trash"],"k":[53,38],"o":2},"coffee":{"a":"Hot Beverage","b":"2615","d":true,"e":true,"f":true,"h":true,"j":["beverage","caffeine","latte","espresso"],"k":[53,0],"o":2},"flashlight":{"a":"Electric Torch","b":"1F526","d":true,"e":true,"f":true,"h":true,"j":["dark","camping","sight","night"],"k":[28,9],"o":2},"spider_web":{"a":"Spider Web","b":"1F578-FE0F","c":"1F578","d":true,"e":true,"f":true,"h":true,"j":["animal","insect","arachnid","silk"],"k":[29,35],"o":2},"izakaya_lantern":{"a":"Izakaya Lantern","b":"1F3EE","d":true,"e":true,"f":true,"h":true,"j":["light","paper","halloween","spooky"],"k":[11,8],"n":["lantern"],"o":2},"flag-gs":{"a":"South Georgia & South Sandwich Islands Flag","b":"1F1EC-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[2,11],"o":2},"shrug":{"skin_variations":{"1F3FB":{"unified":"1F937-1F3FB","non_qualified":null,"image":"1f937-1f3fb.png","sheet_x":39,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F937-1F3FC","non_qualified":null,"image":"1f937-1f3fc.png","sheet_x":39,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F937-1F3FD","non_qualified":null,"image":"1f937-1f3fd.png","sheet_x":39,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F937-1F3FE","non_qualified":null,"image":"1f937-1f3fe.png","sheet_x":39,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F937-1F3FF","non_qualified":null,"image":"1f937-1f3ff.png","sheet_x":39,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Shrug","b":"1F937","d":true,"e":true,"f":true,"h":false,"k":[39,47],"o":4},"fleur_de_lis":{"a":"Fleur De Lis","b":"269C-FE0F","c":"269C","d":true,"e":true,"f":true,"h":true,"j":["decorative","scout"],"k":[53,49],"o":2},"robot_face":{"a":"Robot Face","b":"1F916","d":true,"e":true,"f":true,"h":true,"k":[37,29],"o":2},"railway_track":{"a":"Railway Track","b":"1F6E4-FE0F","c":"1F6E4","d":true,"e":true,"f":true,"h":true,"j":["train","transportation"],"k":[36,46],"o":2},"tea":{"a":"Teacup Without Handle","b":"1F375","d":true,"e":true,"f":true,"h":true,"j":["drink","bowl","breakfast","green","british"],"k":[7,20],"o":2},"flag-gt":{"a":"Guatemala Flag","b":"1F1EC-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[2,12],"o":2},"oil_drum":{"a":"Oil Drum","b":"1F6E2-FE0F","c":"1F6E2","d":true,"e":true,"f":true,"h":true,"j":["barrell"],"k":[36,44],"o":2},"diya_lamp":{"a":"Diya Lamp","b":"1FA94","d":true,"e":true,"f":true,"h":true,"k":[52,8],"o":12},"sake":{"a":"Sake Bottle and Cup","b":"1F376","d":true,"e":true,"f":true,"h":true,"j":["wine","drink","drunk","beverage","japanese","alcohol","booze"],"k":[7,21],"o":2},"trident":{"a":"Trident Emblem","b":"1F531","d":true,"e":true,"f":true,"h":true,"j":["weapon","spear"],"k":[28,20],"o":2},"man-shrugging":{"skin_variations":{"1F3FB":{"unified":"1F937-1F3FB-200D-2642-FE0F","non_qualified":"1F937-1F3FB-200D-2642","image":"1f937-1f3fb-200d-2642-fe0f.png","sheet_x":39,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F937-1F3FC-200D-2642-FE0F","non_qualified":"1F937-1F3FC-200D-2642","image":"1f937-1f3fc-200d-2642-fe0f.png","sheet_x":39,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F937-1F3FD-200D-2642-FE0F","non_qualified":"1F937-1F3FD-200D-2642","image":"1f937-1f3fd-200d-2642-fe0f.png","sheet_x":39,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F937-1F3FE-200D-2642-FE0F","non_qualified":"1F937-1F3FE-200D-2642","image":"1f937-1f3fe-200d-2642-fe0f.png","sheet_x":39,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F937-1F3FF-200D-2642-FE0F","non_qualified":"1F937-1F3FF-200D-2642","image":"1f937-1f3ff-200d-2642-fe0f.png","sheet_x":39,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Shrugging","b":"1F937-200D-2642-FE0F","c":"1F937-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[39,41],"o":4},"smiley_cat":{"a":"Smiling Cat Face with Open Mouth","b":"1F63A","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","happy","smile"],"k":[31,36],"o":2},"scorpion":{"a":"Scorpion","b":"1F982","d":true,"e":true,"f":true,"h":true,"j":["animal","arachnid"],"k":[42,20],"o":2},"woman-shrugging":{"skin_variations":{"1F3FB":{"unified":"1F937-1F3FB-200D-2640-FE0F","non_qualified":"1F937-1F3FB-200D-2640","image":"1f937-1f3fb-200d-2640-fe0f.png","sheet_x":39,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F937-1F3FC-200D-2640-FE0F","non_qualified":"1F937-1F3FC-200D-2640","image":"1f937-1f3fc-200d-2640-fe0f.png","sheet_x":39,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F937-1F3FD-200D-2640-FE0F","non_qualified":"1F937-1F3FD-200D-2640","image":"1f937-1f3fd-200d-2640-fe0f.png","sheet_x":39,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F937-1F3FE-200D-2640-FE0F","non_qualified":"1F937-1F3FE-200D-2640","image":"1f937-1f3fe-200d-2640-fe0f.png","sheet_x":39,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F937-1F3FF-200D-2640-FE0F","non_qualified":"1F937-1F3FF-200D-2640","image":"1f937-1f3ff-200d-2640-fe0f.png","sheet_x":39,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Shrugging","b":"1F937-200D-2640-FE0F","c":"1F937-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[39,35],"o":4},"notebook_with_decorative_cover":{"a":"Notebook with Decorative Cover","b":"1F4D4","d":true,"e":true,"f":true,"h":true,"j":["classroom","notes","record","paper","study"],"k":[26,42],"o":2},"fuelpump":{"a":"Fuel Pump","b":"26FD","d":true,"e":true,"f":true,"h":true,"j":["gas station","petroleum"],"k":[54,38],"o":2},"name_badge":{"a":"Name Badge","b":"1F4DB","d":true,"e":true,"f":true,"h":true,"j":["fire","forbid"],"k":[26,49],"o":2},"mosquito":{"a":"Mosquito","b":"1F99F","d":true,"e":true,"f":true,"h":true,"k":[42,49],"o":11},"flag-gu":{"a":"Guam Flag","b":"1F1EC-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[2,13],"o":2},"smile_cat":{"a":"Grinning Cat Face with Smiling Eyes","b":"1F638","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","smile"],"k":[31,34],"o":2},"champagne":{"a":"Bottle with Popping Cork","b":"1F37E","d":true,"e":true,"f":true,"h":true,"j":["drink","wine","bottle","celebration"],"k":[7,29],"o":2},"joy_cat":{"a":"Cat Face with Tears of Joy","b":"1F639","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","haha","happy","tears"],"k":[31,35],"o":2},"closed_book":{"a":"Closed Book","b":"1F4D5","d":true,"e":true,"f":true,"h":true,"j":["read","library","knowledge","textbook","learn"],"k":[26,43],"o":2},"health_worker":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-2695-FE0F","non_qualified":"1F9D1-1F3FB-200D-2695","image":"1f9d1-1f3fb-200d-2695-fe0f.png","sheet_x":47,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-2695-FE0F","non_qualified":"1F9D1-1F3FC-200D-2695","image":"1f9d1-1f3fc-200d-2695-fe0f.png","sheet_x":47,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-2695-FE0F","non_qualified":"1F9D1-1F3FD-200D-2695","image":"1f9d1-1f3fd-200d-2695-fe0f.png","sheet_x":47,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-2695-FE0F","non_qualified":"1F9D1-1F3FE-200D-2695","image":"1f9d1-1f3fe-200d-2695-fe0f.png","sheet_x":47,"sheet_y":53,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-2695-FE0F","non_qualified":"1F9D1-1F3FF-200D-2695","image":"1f9d1-1f3ff-200d-2695-fe0f.png","sheet_x":47,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Health Worker","b":"1F9D1-200D-2695-FE0F","c":"1F9D1-200D-2695","d":true,"e":false,"f":false,"h":false,"k":[47,49],"o":12},"rotating_light":{"a":"Police Cars Revolving Light","b":"1F6A8","d":true,"e":true,"f":true,"h":true,"j":["police","ambulance","911","emergency","alert","error","pinged","law","legal"],"k":[34,56],"o":2},"microbe":{"a":"Microbe","b":"1F9A0","d":true,"e":true,"f":true,"h":true,"k":[42,50],"o":11},"flag-gw":{"a":"Guinea-Bissau Flag","b":"1F1EC-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[2,14],"o":2},"wine_glass":{"a":"Wine Glass","b":"1F377","d":true,"e":true,"f":true,"h":true,"j":["drink","beverage","drunk","alcohol","booze"],"k":[7,22],"o":2},"beginner":{"a":"Japanese Symbol for Beginner","b":"1F530","d":true,"e":true,"f":true,"h":true,"j":["badge","shield"],"k":[28,19],"o":2},"bouquet":{"a":"Bouquet","b":"1F490","d":true,"e":true,"f":true,"h":true,"j":["flowers","nature","spring"],"k":[25,26],"o":2},"heart_eyes_cat":{"a":"Smiling Cat Face with Heart-Shaped Eyes","b":"1F63B","d":true,"e":true,"f":true,"h":true,"j":["animal","love","like","affection","cats","valentines","heart"],"k":[31,37],"o":2},"male-doctor":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-2695-FE0F","non_qualified":"1F468-1F3FB-200D-2695","image":"1f468-1f3fb-200d-2695-fe0f.png","sheet_x":17,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-2695-FE0F","non_qualified":"1F468-1F3FC-200D-2695","image":"1f468-1f3fc-200d-2695-fe0f.png","sheet_x":17,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-2695-FE0F","non_qualified":"1F468-1F3FD-200D-2695","image":"1f468-1f3fd-200d-2695-fe0f.png","sheet_x":17,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-2695-FE0F","non_qualified":"1F468-1F3FE-200D-2695","image":"1f468-1f3fe-200d-2695-fe0f.png","sheet_x":17,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-2695-FE0F","non_qualified":"1F468-1F3FF-200D-2695","image":"1f468-1f3ff-200d-2695-fe0f.png","sheet_x":17,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Doctor","b":"1F468-200D-2695-FE0F","c":"1F468-200D-2695","d":true,"e":true,"f":true,"h":true,"k":[17,2],"o":4},"book":{"a":"Open Book","b":"1F4D6","d":true,"e":true,"f":true,"h":true,"k":[26,44],"n":["open_book"],"o":2},"traffic_light":{"a":"Horizontal Traffic Light","b":"1F6A5","d":true,"e":true,"f":true,"h":true,"j":["transportation","signal"],"k":[34,53],"o":2},"cocktail":{"a":"Cocktail Glass","b":"1F378","d":true,"e":true,"f":true,"h":true,"j":["drink","drunk","alcohol","beverage","booze","mojito"],"k":[7,23],"o":2},"o":{"a":"Heavy Large Circle","b":"2B55","d":true,"e":true,"f":true,"h":true,"j":["circle","round"],"k":[55,43],"o":2},"flag-gy":{"a":"Guyana Flag","b":"1F1EC-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[2,15],"o":2},"female-doctor":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-2695-FE0F","non_qualified":"1F469-1F3FB-200D-2695","image":"1f469-1f3fb-200d-2695-fe0f.png","sheet_x":19,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-2695-FE0F","non_qualified":"1F469-1F3FC-200D-2695","image":"1f469-1f3fc-200d-2695-fe0f.png","sheet_x":19,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-2695-FE0F","non_qualified":"1F469-1F3FD-200D-2695","image":"1f469-1f3fd-200d-2695-fe0f.png","sheet_x":19,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-2695-FE0F","non_qualified":"1F469-1F3FE-200D-2695","image":"1f469-1f3fe-200d-2695-fe0f.png","sheet_x":19,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-2695-FE0F","non_qualified":"1F469-1F3FF-200D-2695","image":"1f469-1f3ff-200d-2695-fe0f.png","sheet_x":19,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Doctor","b":"1F469-200D-2695-FE0F","c":"1F469-200D-2695","d":true,"e":true,"f":true,"h":true,"k":[19,44],"o":4},"smirk_cat":{"a":"Cat Face with Wry Smile","b":"1F63C","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","smirk"],"k":[31,38],"o":2},"green_book":{"a":"Green Book","b":"1F4D7","d":true,"e":true,"f":true,"h":true,"j":["read","library","knowledge","study"],"k":[26,45],"o":2},"cherry_blossom":{"a":"Cherry Blossom","b":"1F338","d":true,"e":true,"f":true,"h":true,"j":["nature","plant","spring","flower"],"k":[6,16],"o":2},"flag-hk":{"a":"Hong Kong Sar China Flag","b":"1F1ED-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[2,16],"o":2},"vertical_traffic_light":{"a":"Vertical Traffic Light","b":"1F6A6","d":true,"e":true,"f":true,"h":true,"j":["transportation","driving"],"k":[34,54],"o":2},"white_check_mark":{"a":"White Heavy Check Mark","b":"2705","d":true,"e":true,"f":true,"h":true,"j":["green-square","ok","agree","vote","election","answer","tick"],"k":[54,40],"o":2},"tropical_drink":{"a":"Tropical Drink","b":"1F379","d":true,"e":true,"f":true,"h":true,"j":["beverage","cocktail","summer","beach","alcohol","booze","mojito"],"k":[7,24],"o":2},"kissing_cat":{"a":"Kissing Cat Face with Closed Eyes","b":"1F63D","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","kiss"],"k":[31,39],"o":2},"flag-hm":{"a":"Heard & Mcdonald Islands Flag","b":"1F1ED-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[2,17],"o":2},"octagonal_sign":{"a":"Octagonal Sign","b":"1F6D1","d":true,"e":true,"f":true,"h":true,"k":[36,39],"o":4},"white_flower":{"a":"White Flower","b":"1F4AE","d":true,"e":true,"f":true,"h":true,"j":["japanese","spring"],"k":[26,4],"o":2},"ballot_box_with_check":{"a":"Ballot Box with Check","b":"2611-FE0F","c":"2611","d":true,"e":true,"f":true,"h":true,"j":["ok","agree","confirm","black-square","vote","election","yes","tick"],"k":[52,55],"o":2},"student":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F393","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f393.png","sheet_x":45,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F393","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f393.png","sheet_x":45,"sheet_y":31,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F393","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f393.png","sheet_x":45,"sheet_y":32,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F393","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f393.png","sheet_x":45,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F393","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f393.png","sheet_x":45,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Student","b":"1F9D1-200D-1F393","d":true,"e":false,"f":false,"h":false,"k":[45,29],"o":12},"blue_book":{"a":"Blue Book","b":"1F4D8","d":true,"e":true,"f":true,"h":true,"j":["read","library","knowledge","learn","study"],"k":[26,46],"o":2},"beer":{"a":"Beer Mug","b":"1F37A","d":true,"e":true,"f":true,"h":true,"j":["relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],"k":[7,25],"o":2},"construction":{"a":"Construction Sign","b":"1F6A7","d":true,"e":true,"f":true,"h":true,"j":["wip","progress","caution","warning"],"k":[34,55],"o":2},"rosette":{"a":"Rosette","b":"1F3F5-FE0F","c":"1F3F5","d":true,"e":true,"f":true,"h":true,"j":["flower","decoration","military"],"k":[11,18],"o":2},"heavy_check_mark":{"a":"Heavy Check Mark","b":"2714-FE0F","c":"2714","d":true,"e":true,"f":true,"h":true,"j":["ok","nike","answer","yes","tick"],"k":[55,12],"o":2},"scream_cat":{"a":"Weary Cat Face","b":"1F640","d":true,"e":true,"f":true,"h":true,"j":["animal","cats","munch","scared","scream"],"k":[31,42],"o":2},"orange_book":{"a":"Orange Book","b":"1F4D9","d":true,"e":true,"f":true,"h":true,"j":["read","library","knowledge","textbook","study"],"k":[26,47],"o":2},"beers":{"a":"Clinking Beer Mugs","b":"1F37B","d":true,"e":true,"f":true,"h":true,"j":["relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],"k":[7,26],"o":2},"male-student":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F393","non_qualified":null,"image":"1f468-1f3fb-200d-1f393.png","sheet_x":14,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F393","non_qualified":null,"image":"1f468-1f3fc-200d-1f393.png","sheet_x":14,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F393","non_qualified":null,"image":"1f468-1f3fd-200d-1f393.png","sheet_x":14,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F393","non_qualified":null,"image":"1f468-1f3fe-200d-1f393.png","sheet_x":14,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F393","non_qualified":null,"image":"1f468-1f3ff-200d-1f393.png","sheet_x":14,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Student","b":"1F468-200D-1F393","d":true,"e":true,"f":true,"h":true,"k":[14,50],"o":4},"flag-hn":{"a":"Honduras Flag","b":"1F1ED-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[2,18],"o":2},"crying_cat_face":{"a":"Crying Cat Face","b":"1F63F","d":true,"e":true,"f":true,"h":true,"j":["animal","tears","weep","sad","cats","upset","cry"],"k":[31,41],"o":2},"anchor":{"a":"Anchor","b":"2693","d":true,"e":true,"f":true,"h":true,"j":["ship","ferry","sea","boat"],"k":[53,42],"o":2},"flag-hr":{"a":"Croatia Flag","b":"1F1ED-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[2,19],"o":2},"heavy_multiplication_x":{"a":"Heavy Multiplication X","b":"2716-FE0F","c":"2716","d":true,"e":true,"f":true,"h":true,"j":["math","calculation"],"k":[55,13],"o":2},"female-student":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F393","non_qualified":null,"image":"1f469-1f3fb-200d-1f393.png","sheet_x":17,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F393","non_qualified":null,"image":"1f469-1f3fc-200d-1f393.png","sheet_x":17,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F393","non_qualified":null,"image":"1f469-1f3fd-200d-1f393.png","sheet_x":17,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F393","non_qualified":null,"image":"1f469-1f3fe-200d-1f393.png","sheet_x":17,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F393","non_qualified":null,"image":"1f469-1f3ff-200d-1f393.png","sheet_x":17,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Student","b":"1F469-200D-1F393","d":true,"e":true,"f":true,"h":true,"k":[17,40],"o":4},"rose":{"a":"Rose","b":"1F339","d":true,"e":true,"f":true,"h":true,"j":["flowers","valentines","love","spring"],"k":[6,17],"o":2},"books":{"a":"Books","b":"1F4DA","d":true,"e":true,"f":true,"h":true,"j":["literature","library","study"],"k":[26,48],"o":2},"clinking_glasses":{"a":"Clinking Glasses","b":"1F942","d":true,"e":true,"f":true,"h":true,"j":["beverage","drink","party","alcohol","celebrate","cheers"],"k":[41,18],"o":4},"teacher":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F3EB","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f3eb.png","sheet_x":45,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F3EB","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f3eb.png","sheet_x":45,"sheet_y":49,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F3EB","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f3eb.png","sheet_x":45,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F3EB","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f3eb.png","sheet_x":45,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F3EB","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f3eb.png","sheet_x":45,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Teacher","b":"1F9D1-200D-1F3EB","d":true,"e":false,"f":false,"h":false,"k":[45,47],"o":12},"x":{"a":"Cross Mark","b":"274C","d":true,"e":true,"f":true,"h":true,"j":["no","delete","remove","cancel"],"k":[55,21],"o":2},"pouting_cat":{"a":"Pouting Cat Face","b":"1F63E","d":true,"e":true,"f":true,"h":true,"j":["animal","cats"],"k":[31,40],"o":2},"wilted_flower":{"a":"Wilted Flower","b":"1F940","d":true,"e":true,"f":true,"h":true,"j":["plant","nature","flower"],"k":[41,16],"o":4},"boat":{"a":"Sailboat","b":"26F5","d":true,"e":true,"f":true,"h":true,"k":[54,16],"n":["sailboat"],"o":2},"flag-ht":{"a":"Haiti Flag","b":"1F1ED-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[2,20],"o":2},"tumbler_glass":{"a":"Tumbler Glass","b":"1F943","d":true,"e":true,"f":true,"h":true,"j":["drink","beverage","drunk","alcohol","liquor","booze","bourbon","scotch","whisky","glass","shot"],"k":[41,19],"o":4},"notebook":{"a":"Notebook","b":"1F4D3","d":true,"e":true,"f":true,"h":true,"j":["stationery","record","notes","paper","study"],"k":[26,41],"o":2},"male-teacher":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fb-200d-1f3eb.png","sheet_x":15,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fc-200d-1f3eb.png","sheet_x":15,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fd-200d-1f3eb.png","sheet_x":15,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3EB","non_qualified":null,"image":"1f468-1f3fe-200d-1f3eb.png","sheet_x":15,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3EB","non_qualified":null,"image":"1f468-1f3ff-200d-1f3eb.png","sheet_x":15,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Teacher","b":"1F468-200D-1F3EB","d":true,"e":true,"f":true,"h":true,"k":[15,11],"o":4},"ledger":{"a":"Ledger","b":"1F4D2","d":true,"e":true,"f":true,"h":true,"j":["notes","paper"],"k":[26,40],"o":2},"flag-hu":{"a":"Hungary Flag","b":"1F1ED-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[2,21],"o":2},"cup_with_straw":{"a":"Cup with Straw","b":"1F964","d":true,"e":true,"f":true,"h":true,"k":[41,51],"o":5},"hibiscus":{"a":"Hibiscus","b":"1F33A","d":true,"e":true,"f":true,"h":true,"j":["plant","vegetable","flowers","beach"],"k":[6,18],"o":2},"see_no_evil":{"a":"See-No-Evil Monkey","b":"1F648","d":true,"e":true,"f":true,"h":true,"j":["monkey","animal","nature","haha"],"k":[32,44],"o":2},"canoe":{"a":"Canoe","b":"1F6F6","d":true,"e":true,"f":true,"h":true,"j":["boat","paddle","water","ship"],"k":[36,55],"o":4},"negative_squared_cross_mark":{"a":"Negative Squared Cross Mark","b":"274E","d":true,"e":true,"f":true,"h":true,"j":["x","green-square","no","deny"],"k":[55,22],"o":2},"flag-ic":{"a":"Canary Islands Flag","b":"1F1EE-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[2,22],"o":2},"beverage_box":{"a":"Beverage Box","b":"1F9C3","d":true,"e":true,"f":true,"h":true,"k":[44,11],"o":12},"speedboat":{"a":"Speedboat","b":"1F6A4","d":true,"e":true,"f":true,"h":true,"j":["ship","transportation","vehicle","summer"],"k":[34,52],"o":2},"heavy_plus_sign":{"a":"Heavy Plus Sign","b":"2795","d":true,"e":true,"f":true,"h":true,"j":["math","calculation","addition","more","increase"],"k":[55,29],"o":2},"sunflower":{"a":"Sunflower","b":"1F33B","d":true,"e":true,"f":true,"h":true,"j":["nature","plant","fall"],"k":[6,19],"o":2},"page_with_curl":{"a":"Page with Curl","b":"1F4C3","d":true,"e":true,"f":true,"h":true,"j":["documents","office","paper"],"k":[26,25],"o":2},"female-teacher":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fb-200d-1f3eb.png","sheet_x":18,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fc-200d-1f3eb.png","sheet_x":18,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fd-200d-1f3eb.png","sheet_x":18,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3EB","non_qualified":null,"image":"1f469-1f3fe-200d-1f3eb.png","sheet_x":18,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3EB","non_qualified":null,"image":"1f469-1f3ff-200d-1f3eb.png","sheet_x":18,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Teacher","b":"1F469-200D-1F3EB","d":true,"e":true,"f":true,"h":true,"k":[18,1],"o":4},"hear_no_evil":{"a":"Hear-No-Evil Monkey","b":"1F649","d":true,"e":true,"f":true,"h":true,"j":["animal","monkey","nature"],"k":[32,45],"o":2},"mate_drink":{"a":"Mate Drink","b":"1F9C9","d":true,"e":true,"f":true,"h":true,"k":[44,17],"o":12},"passenger_ship":{"a":"Passenger Ship","b":"1F6F3-FE0F","c":"1F6F3","d":true,"e":true,"f":true,"h":true,"j":["yacht","cruise","ferry"],"k":[36,52],"o":2},"judge":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-2696-FE0F","non_qualified":"1F9D1-1F3FB-200D-2696","image":"1f9d1-1f3fb-200d-2696-fe0f.png","sheet_x":47,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-2696-FE0F","non_qualified":"1F9D1-1F3FC-200D-2696","image":"1f9d1-1f3fc-200d-2696-fe0f.png","sheet_x":48,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-2696-FE0F","non_qualified":"1F9D1-1F3FD-200D-2696","image":"1f9d1-1f3fd-200d-2696-fe0f.png","sheet_x":48,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-2696-FE0F","non_qualified":"1F9D1-1F3FE-200D-2696","image":"1f9d1-1f3fe-200d-2696-fe0f.png","sheet_x":48,"sheet_y":2,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-2696-FE0F","non_qualified":"1F9D1-1F3FF-200D-2696","image":"1f9d1-1f3ff-200d-2696-fe0f.png","sheet_x":48,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Judge","b":"1F9D1-200D-2696-FE0F","c":"1F9D1-200D-2696","d":true,"e":false,"f":false,"h":false,"k":[47,55],"o":12},"scroll":{"a":"Scroll","b":"1F4DC","d":true,"e":true,"f":true,"h":true,"j":["documents","ancient","history","paper"],"k":[26,50],"o":2},"blossom":{"a":"Blossom","b":"1F33C","d":true,"e":true,"f":true,"h":true,"j":["nature","flowers","yellow"],"k":[6,20],"o":2},"flag-id":{"a":"Indonesia Flag","b":"1F1EE-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[2,23],"o":2},"speak_no_evil":{"a":"Speak-No-Evil Monkey","b":"1F64A","d":true,"e":true,"f":true,"h":true,"j":["monkey","animal","nature","omg"],"k":[32,46],"o":2},"heavy_minus_sign":{"a":"Heavy Minus Sign","b":"2796","d":true,"e":true,"f":true,"h":true,"j":["math","calculation","subtract","less"],"k":[55,30],"o":2},"flag-ie":{"a":"Ireland Flag","b":"1F1EE-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[2,24],"o":2},"ice_cube":{"a":"Ice Cube","b":"1F9CA","d":true,"e":true,"f":true,"h":true,"k":[44,18],"o":12},"page_facing_up":{"a":"Page Facing Up","b":"1F4C4","d":true,"e":true,"f":true,"h":true,"j":["documents","office","paper","information"],"k":[26,26],"o":2},"male-judge":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-2696-FE0F","non_qualified":"1F468-1F3FB-200D-2696","image":"1f468-1f3fb-200d-2696-fe0f.png","sheet_x":17,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-2696-FE0F","non_qualified":"1F468-1F3FC-200D-2696","image":"1f468-1f3fc-200d-2696-fe0f.png","sheet_x":17,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-2696-FE0F","non_qualified":"1F468-1F3FD-200D-2696","image":"1f468-1f3fd-200d-2696-fe0f.png","sheet_x":17,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-2696-FE0F","non_qualified":"1F468-1F3FE-200D-2696","image":"1f468-1f3fe-200d-2696-fe0f.png","sheet_x":17,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-2696-FE0F","non_qualified":"1F468-1F3FF-200D-2696","image":"1f468-1f3ff-200d-2696-fe0f.png","sheet_x":17,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Judge","b":"1F468-200D-2696-FE0F","c":"1F468-200D-2696","d":true,"e":true,"f":true,"h":true,"k":[17,8],"o":4},"tulip":{"a":"Tulip","b":"1F337","d":true,"e":true,"f":true,"h":true,"j":["flowers","plant","nature","summer","spring"],"k":[6,15],"o":2},"ferry":{"a":"Ferry","b":"26F4-FE0F","c":"26F4","d":true,"e":true,"f":true,"h":true,"j":["boat","ship","yacht"],"k":[54,15],"o":2},"kiss":{"a":"Kiss Mark","b":"1F48B","d":true,"e":true,"f":true,"h":true,"j":["face","lips","love","like","affection","valentines"],"k":[25,21],"o":2},"heavy_division_sign":{"a":"Heavy Division Sign","b":"2797","d":true,"e":true,"f":true,"h":true,"j":["divide","math","calculation"],"k":[55,31],"o":2},"newspaper":{"a":"Newspaper","b":"1F4F0","d":true,"e":true,"f":true,"h":true,"j":["press","headline"],"k":[27,13],"o":2},"female-judge":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-2696-FE0F","non_qualified":"1F469-1F3FB-200D-2696","image":"1f469-1f3fb-200d-2696-fe0f.png","sheet_x":19,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-2696-FE0F","non_qualified":"1F469-1F3FC-200D-2696","image":"1f469-1f3fc-200d-2696-fe0f.png","sheet_x":19,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-2696-FE0F","non_qualified":"1F469-1F3FD-200D-2696","image":"1f469-1f3fd-200d-2696-fe0f.png","sheet_x":19,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-2696-FE0F","non_qualified":"1F469-1F3FE-200D-2696","image":"1f469-1f3fe-200d-2696-fe0f.png","sheet_x":19,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-2696-FE0F","non_qualified":"1F469-1F3FF-200D-2696","image":"1f469-1f3ff-200d-2696-fe0f.png","sheet_x":19,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Judge","b":"1F469-200D-2696-FE0F","c":"1F469-200D-2696","d":true,"e":true,"f":true,"h":true,"k":[19,50],"o":4},"seedling":{"a":"Seedling","b":"1F331","d":true,"e":true,"f":true,"h":true,"j":["plant","nature","grass","lawn","spring"],"k":[6,9],"o":2},"love_letter":{"a":"Love Letter","b":"1F48C","d":true,"e":true,"f":true,"h":true,"j":["email","like","affection","envelope","valentines"],"k":[25,22],"o":2},"chopsticks":{"a":"Chopsticks","b":"1F962","d":true,"e":true,"f":true,"h":true,"k":[41,49],"o":5},"motor_boat":{"a":"Motor Boat","b":"1F6E5-FE0F","c":"1F6E5","d":true,"e":true,"f":true,"h":true,"j":["ship"],"k":[36,47],"o":2},"flag-il":{"a":"Israel Flag","b":"1F1EE-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[2,25],"o":2},"curly_loop":{"a":"Curly Loop","b":"27B0","d":true,"e":true,"f":true,"h":true,"j":["scribble","draw","shape","squiggle"],"k":[55,33],"o":2},"flag-im":{"a":"Isle of Man Flag","b":"1F1EE-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[2,26],"o":2},"evergreen_tree":{"a":"Evergreen Tree","b":"1F332","d":true,"e":true,"f":true,"h":true,"j":["plant","nature"],"k":[6,10],"o":2},"cupid":{"a":"Heart with Arrow","b":"1F498","d":true,"e":true,"f":true,"h":true,"j":["love","like","heart","affection","valentines"],"k":[25,34],"o":2},"loop":{"a":"Double Curly Loop","b":"27BF","d":true,"e":true,"f":true,"h":true,"j":["tape","cassette"],"k":[55,34],"o":2},"ship":{"a":"Ship","b":"1F6A2","d":true,"e":true,"f":true,"h":true,"j":["transportation","titanic","deploy"],"k":[34,33],"o":2},"farmer":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F33E","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f33e.png","sheet_x":45,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F33E","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f33e.png","sheet_x":45,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F33E","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f33e.png","sheet_x":45,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F33E","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f33e.png","sheet_x":45,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F33E","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f33e.png","sheet_x":45,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Farmer","b":"1F9D1-200D-1F33E","d":true,"e":false,"f":false,"h":false,"k":[45,17],"o":12},"rolled_up_newspaper":{"a":"Rolled Up Newspaper","b":"1F5DE-FE0F","c":"1F5DE","d":true,"e":true,"f":true,"h":true,"k":[30,23],"o":2},"knife_fork_plate":{"a":"Knife Fork Plate","b":"1F37D-FE0F","c":"1F37D","d":true,"e":true,"f":true,"h":true,"k":[7,28],"o":2},"fork_and_knife":{"a":"Fork and Knife","b":"1F374","d":true,"e":true,"f":true,"h":true,"j":["cutlery","kitchen"],"k":[7,19],"o":2},"male-farmer":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F33E","non_qualified":null,"image":"1f468-1f3fb-200d-1f33e.png","sheet_x":14,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F33E","non_qualified":null,"image":"1f468-1f3fc-200d-1f33e.png","sheet_x":14,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F33E","non_qualified":null,"image":"1f468-1f3fd-200d-1f33e.png","sheet_x":14,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F33E","non_qualified":null,"image":"1f468-1f3fe-200d-1f33e.png","sheet_x":14,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F33E","non_qualified":null,"image":"1f468-1f3ff-200d-1f33e.png","sheet_x":14,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Farmer","b":"1F468-200D-1F33E","d":true,"e":true,"f":true,"h":true,"k":[14,38],"o":4},"bookmark_tabs":{"a":"Bookmark Tabs","b":"1F4D1","d":true,"e":true,"f":true,"h":true,"j":["favorite","save","order","tidy"],"k":[26,39],"o":2},"part_alternation_mark":{"a":"Part Alternation Mark","b":"303D-FE0F","c":"303D","d":true,"e":true,"f":true,"h":true,"j":["graph","presentation","stats","business","economics","bad"],"k":[55,45],"o":2},"flag-in":{"a":"India Flag","b":"1F1EE-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[2,27],"o":2},"gift_heart":{"a":"Heart with Ribbon","b":"1F49D","d":true,"e":true,"f":true,"h":true,"j":["love","valentines"],"k":[25,39],"o":2},"airplane":{"a":"Airplane","b":"2708-FE0F","c":"2708","d":true,"e":true,"f":true,"h":true,"j":["vehicle","transportation","flight","fly"],"k":[54,41],"o":2},"deciduous_tree":{"a":"Deciduous Tree","b":"1F333","d":true,"e":true,"f":true,"h":true,"j":["plant","nature"],"k":[6,11],"o":2},"spoon":{"a":"Spoon","b":"1F944","d":true,"e":true,"f":true,"h":true,"j":["cutlery","kitchen","tableware"],"k":[41,20],"o":4},"flag-io":{"a":"British Indian Ocean Territory Flag","b":"1F1EE-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[2,28],"o":2},"palm_tree":{"a":"Palm Tree","b":"1F334","d":true,"e":true,"f":true,"h":true,"j":["plant","vegetable","nature","summer","beach","mojito","tropical"],"k":[6,12],"o":2},"sparkling_heart":{"a":"Sparkling Heart","b":"1F496","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,32],"o":2},"female-farmer":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F33E","non_qualified":null,"image":"1f469-1f3fb-200d-1f33e.png","sheet_x":17,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F33E","non_qualified":null,"image":"1f469-1f3fc-200d-1f33e.png","sheet_x":17,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F33E","non_qualified":null,"image":"1f469-1f3fd-200d-1f33e.png","sheet_x":17,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F33E","non_qualified":null,"image":"1f469-1f3fe-200d-1f33e.png","sheet_x":17,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F33E","non_qualified":null,"image":"1f469-1f3ff-200d-1f33e.png","sheet_x":17,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Farmer","b":"1F469-200D-1F33E","d":true,"e":true,"f":true,"h":true,"k":[17,28],"o":4},"eight_spoked_asterisk":{"a":"Eight Spoked Asterisk","b":"2733-FE0F","c":"2733","d":true,"e":true,"f":true,"h":true,"j":["star","sparkle","green-square"],"k":[55,17],"o":2},"small_airplane":{"a":"Small Airplane","b":"1F6E9-FE0F","c":"1F6E9","d":true,"e":true,"f":true,"h":true,"j":["flight","transportation","fly","vehicle"],"k":[36,48],"o":2},"bookmark":{"a":"Bookmark","b":"1F516","d":true,"e":true,"f":true,"h":true,"j":["favorite","label","save"],"k":[27,50],"o":2},"cook":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F373","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f373.png","sheet_x":45,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F373","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f373.png","sheet_x":45,"sheet_y":25,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F373","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f373.png","sheet_x":45,"sheet_y":26,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F373","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f373.png","sheet_x":45,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F373","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f373.png","sheet_x":45,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Cook","b":"1F9D1-200D-1F373","d":true,"e":false,"f":false,"h":false,"k":[45,23],"o":12},"eight_pointed_black_star":{"a":"Eight Pointed Black Star","b":"2734-FE0F","c":"2734","d":true,"e":true,"f":true,"h":true,"j":["orange-square","shape","polygon"],"k":[55,18],"o":2},"heartpulse":{"a":"Growing Heart","b":"1F497","d":true,"e":true,"f":true,"h":true,"j":["like","love","affection","valentines","pink"],"k":[25,33],"o":2},"label":{"a":"Label","b":"1F3F7-FE0F","c":"1F3F7","d":true,"e":true,"f":true,"h":true,"j":["sale","tag"],"k":[11,19],"o":2},"flag-iq":{"a":"Iraq Flag","b":"1F1EE-1F1F6","d":true,"e":true,"f":true,"h":true,"k":[2,29],"o":2},"hocho":{"a":"Hocho","b":"1F52A","d":true,"e":true,"f":true,"h":true,"j":["knife","blade","cutlery","kitchen","weapon"],"k":[28,13],"n":["knife"],"o":2},"cactus":{"a":"Cactus","b":"1F335","d":true,"e":true,"f":true,"h":true,"j":["vegetable","plant","nature"],"k":[6,13],"o":2},"airplane_departure":{"a":"Airplane Departure","b":"1F6EB","d":true,"e":true,"f":true,"h":true,"k":[36,49],"o":2},"airplane_arriving":{"a":"Airplane Arriving","b":"1F6EC","d":true,"e":true,"f":true,"h":true,"k":[36,50],"o":2},"ear_of_rice":{"a":"Ear of Rice","b":"1F33E","d":true,"e":true,"f":true,"h":true,"j":["nature","plant"],"k":[6,22],"o":2},"flag-ir":{"a":"Iran Flag","b":"1F1EE-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[2,30],"o":2},"moneybag":{"a":"Money Bag","b":"1F4B0","d":true,"e":true,"f":true,"h":true,"j":["dollar","payment","coins","sale"],"k":[26,6],"o":2},"male-cook":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F373","non_qualified":null,"image":"1f468-1f3fb-200d-1f373.png","sheet_x":14,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F373","non_qualified":null,"image":"1f468-1f3fc-200d-1f373.png","sheet_x":14,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F373","non_qualified":null,"image":"1f468-1f3fd-200d-1f373.png","sheet_x":14,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F373","non_qualified":null,"image":"1f468-1f3fe-200d-1f373.png","sheet_x":14,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F373","non_qualified":null,"image":"1f468-1f3ff-200d-1f373.png","sheet_x":14,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Cook","b":"1F468-200D-1F373","d":true,"e":true,"f":true,"h":true,"k":[14,44],"o":4},"heartbeat":{"a":"Beating Heart","b":"1F493","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines","pink","heart"],"k":[25,29],"o":2},"sparkle":{"a":"Sparkle","b":"2747-FE0F","c":"2747","d":true,"e":true,"f":true,"h":true,"j":["stars","green-square","awesome","good","fireworks"],"k":[55,20],"o":2},"amphora":{"a":"Amphora","b":"1F3FA","d":true,"e":true,"f":true,"h":true,"j":["vase","jar"],"k":[11,22],"o":2},"yen":{"a":"Banknote with Yen Sign","b":"1F4B4","d":true,"e":true,"f":true,"h":true,"j":["money","sales","japanese","dollar","currency"],"k":[26,10],"o":2},"revolving_hearts":{"a":"Revolving Hearts","b":"1F49E","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,40],"o":2},"bangbang":{"a":"Double Exclamation Mark","b":"203C-FE0F","c":"203C","d":true,"e":true,"f":true,"h":true,"j":["exclamation","surprise"],"k":[52,10],"o":2},"parachute":{"a":"Parachute","b":"1FA82","d":true,"e":true,"f":true,"h":true,"k":[52,3],"o":12},"herb":{"a":"Herb","b":"1F33F","d":true,"e":true,"f":true,"h":true,"j":["vegetable","plant","medicine","weed","grass","lawn"],"k":[6,23],"o":2},"flag-is":{"a":"Iceland Flag","b":"1F1EE-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[2,31],"o":2},"female-cook":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F373","non_qualified":null,"image":"1f469-1f3fb-200d-1f373.png","sheet_x":17,"sheet_y":35,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F373","non_qualified":null,"image":"1f469-1f3fc-200d-1f373.png","sheet_x":17,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F373","non_qualified":null,"image":"1f469-1f3fd-200d-1f373.png","sheet_x":17,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F373","non_qualified":null,"image":"1f469-1f3fe-200d-1f373.png","sheet_x":17,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F373","non_qualified":null,"image":"1f469-1f3ff-200d-1f373.png","sheet_x":17,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Cook","b":"1F469-200D-1F373","d":true,"e":true,"f":true,"h":true,"k":[17,34],"o":4},"mechanic":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F527","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f527.png","sheet_x":46,"sheet_y":15,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F527","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f527.png","sheet_x":46,"sheet_y":16,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F527","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f527.png","sheet_x":46,"sheet_y":17,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F527","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f527.png","sheet_x":46,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F527","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f527.png","sheet_x":46,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Mechanic","b":"1F9D1-200D-1F527","d":true,"e":false,"f":false,"h":false,"k":[46,14],"o":12},"interrobang":{"a":"Exclamation Question Mark","b":"2049-FE0F","c":"2049","d":true,"e":true,"f":true,"h":true,"j":["wat","punctuation","surprise"],"k":[52,11],"o":2},"seat":{"a":"Seat","b":"1F4BA","d":true,"e":true,"f":true,"h":true,"j":["sit","airplane","transport","bus","flight","fly"],"k":[26,16],"o":2},"dollar":{"a":"Banknote with Dollar Sign","b":"1F4B5","d":true,"e":true,"f":true,"h":true,"j":["money","sales","bill","currency"],"k":[26,11],"o":2},"two_hearts":{"a":"Two Hearts","b":"1F495","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines","heart"],"k":[25,31],"o":2},"it":{"a":"Italy Flag","b":"1F1EE-1F1F9","d":true,"e":true,"f":true,"h":true,"j":["italy","flag","nation","country","banner"],"k":[2,32],"n":["flag-it"],"o":2},"shamrock":{"a":"Shamrock","b":"2618-FE0F","c":"2618","d":true,"e":true,"f":true,"h":true,"j":["vegetable","plant","nature","irish","clover"],"k":[53,1],"o":2},"four_leaf_clover":{"a":"Four Leaf Clover","b":"1F340","d":true,"e":true,"f":true,"h":true,"j":["vegetable","plant","nature","lucky","irish"],"k":[6,24],"o":2},"euro":{"a":"Banknote with Euro Sign","b":"1F4B6","d":true,"e":true,"f":true,"h":true,"j":["money","sales","dollar","currency"],"k":[26,12],"o":2},"question":{"a":"Black Question Mark Ornament","b":"2753","d":true,"e":true,"f":true,"h":true,"j":["doubt","confused"],"k":[55,23],"o":2},"helicopter":{"a":"Helicopter","b":"1F681","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","fly"],"k":[34,0],"o":2},"heart_decoration":{"a":"Heart Decoration","b":"1F49F","d":true,"e":true,"f":true,"h":true,"j":["purple-square","love","like"],"k":[25,41],"o":2},"flag-je":{"a":"Jersey Flag","b":"1F1EF-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[2,33],"o":2},"male-mechanic":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F527","non_qualified":null,"image":"1f468-1f3fb-200d-1f527.png","sheet_x":15,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F527","non_qualified":null,"image":"1f468-1f3fc-200d-1f527.png","sheet_x":15,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F527","non_qualified":null,"image":"1f468-1f3fd-200d-1f527.png","sheet_x":15,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F527","non_qualified":null,"image":"1f468-1f3fe-200d-1f527.png","sheet_x":15,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F527","non_qualified":null,"image":"1f468-1f3ff-200d-1f527.png","sheet_x":15,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Mechanic","b":"1F468-200D-1F527","d":true,"e":true,"f":true,"h":true,"k":[15,50],"o":4},"suspension_railway":{"a":"Suspension Railway","b":"1F69F","d":true,"e":true,"f":true,"h":true,"j":["vehicle","transportation"],"k":[34,30],"o":2},"heavy_heart_exclamation_mark_ornament":{"a":"Heavy Heart Exclamation Mark Ornament","b":"2763-FE0F","c":"2763","d":true,"e":true,"f":true,"h":true,"k":[55,27],"o":2},"female-mechanic":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F527","non_qualified":null,"image":"1f469-1f3fb-200d-1f527.png","sheet_x":18,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F527","non_qualified":null,"image":"1f469-1f3fc-200d-1f527.png","sheet_x":18,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F527","non_qualified":null,"image":"1f469-1f3fd-200d-1f527.png","sheet_x":18,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F527","non_qualified":null,"image":"1f469-1f3fe-200d-1f527.png","sheet_x":18,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F527","non_qualified":null,"image":"1f469-1f3ff-200d-1f527.png","sheet_x":18,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Mechanic","b":"1F469-200D-1F527","d":true,"e":true,"f":true,"h":true,"k":[18,35],"o":4},"flag-jm":{"a":"Jamaica Flag","b":"1F1EF-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[2,34],"o":2},"grey_question":{"a":"White Question Mark Ornament","b":"2754","d":true,"e":true,"f":true,"h":true,"j":["doubts","gray","huh","confused"],"k":[55,24],"o":2},"maple_leaf":{"a":"Maple Leaf","b":"1F341","d":true,"e":true,"f":true,"h":true,"j":["nature","plant","vegetable","ca","fall"],"k":[6,25],"o":2},"pound":{"a":"Banknote with Pound Sign","b":"1F4B7","d":true,"e":true,"f":true,"h":true,"j":["british","sterling","money","sales","bills","uk","england","currency"],"k":[26,13],"o":2},"money_with_wings":{"a":"Money with Wings","b":"1F4B8","d":true,"e":true,"f":true,"h":true,"j":["dollar","bills","payment","sale"],"k":[26,14],"o":2},"flag-jo":{"a":"Jordan Flag","b":"1F1EF-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[2,35],"o":2},"fallen_leaf":{"a":"Fallen Leaf","b":"1F342","d":true,"e":true,"f":true,"h":true,"j":["nature","plant","vegetable","leaves"],"k":[6,26],"o":2},"factory_worker":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F3ED","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f3ed.png","sheet_x":45,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F3ED","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f3ed.png","sheet_x":45,"sheet_y":55,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F3ED","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f3ed.png","sheet_x":45,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F3ED","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f3ed.png","sheet_x":46,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F3ED","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f3ed.png","sheet_x":46,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Factory Worker","b":"1F9D1-200D-1F3ED","d":true,"e":false,"f":false,"h":false,"k":[45,53],"o":12},"broken_heart":{"a":"Broken Heart","b":"1F494","d":true,"e":true,"f":true,"h":true,"j":["sad","sorry","break","heart","heartbreak"],"k":[25,30],"l":["</3"],"m":"</3","o":2},"grey_exclamation":{"a":"White Exclamation Mark Ornament","b":"2755","d":true,"e":true,"f":true,"h":true,"j":["surprise","punctuation","gray","wow","warning"],"k":[55,25],"o":2},"mountain_cableway":{"a":"Mountain Cableway","b":"1F6A0","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","ski"],"k":[34,31],"o":2},"exclamation":{"a":"Heavy Exclamation Mark Symbol","b":"2757","d":true,"e":true,"f":true,"h":true,"j":["heavy_exclamation_mark","danger","surprise","punctuation","wow","warning"],"k":[55,26],"n":["heavy_exclamation_mark"],"o":2},"leaves":{"a":"Leaf Fluttering in Wind","b":"1F343","d":true,"e":true,"f":true,"h":true,"j":["nature","plant","tree","vegetable","grass","lawn","spring"],"k":[6,27],"o":2},"heart":{"a":"Heavy Black Heart","b":"2764-FE0F","c":"2764","d":true,"e":true,"f":true,"h":true,"j":["love","like","valentines"],"k":[55,28],"l":["<3"],"m":"<3","o":2},"jp":{"a":"Japan Flag","b":"1F1EF-1F1F5","d":true,"e":true,"f":true,"h":true,"j":["japanese","nation","flag","country","banner"],"k":[2,36],"n":["flag-jp"],"o":2},"male-factory-worker":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fb-200d-1f3ed.png","sheet_x":15,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fc-200d-1f3ed.png","sheet_x":15,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fd-200d-1f3ed.png","sheet_x":15,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3ED","non_qualified":null,"image":"1f468-1f3fe-200d-1f3ed.png","sheet_x":15,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3ED","non_qualified":null,"image":"1f468-1f3ff-200d-1f3ed.png","sheet_x":15,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Factory Worker","b":"1F468-200D-1F3ED","d":true,"e":true,"f":true,"h":true,"k":[15,17],"o":4},"credit_card":{"a":"Credit Card","b":"1F4B3","d":true,"e":true,"f":true,"h":true,"j":["money","sales","dollar","bill","payment","shopping"],"k":[26,9],"o":2},"aerial_tramway":{"a":"Aerial Tramway","b":"1F6A1","d":true,"e":true,"f":true,"h":true,"j":["transportation","vehicle","ski"],"k":[34,32],"o":2},"female-factory-worker":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fb-200d-1f3ed.png","sheet_x":18,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fc-200d-1f3ed.png","sheet_x":18,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fd-200d-1f3ed.png","sheet_x":18,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3ED","non_qualified":null,"image":"1f469-1f3fe-200d-1f3ed.png","sheet_x":18,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3ED","non_qualified":null,"image":"1f469-1f3ff-200d-1f3ed.png","sheet_x":18,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Factory Worker","b":"1F469-200D-1F3ED","d":true,"e":true,"f":true,"h":true,"k":[18,7],"o":4},"receipt":{"a":"Receipt","b":"1F9FE","d":true,"e":true,"f":true,"h":true,"k":[51,49],"o":11},"wavy_dash":{"a":"Wavy Dash","b":"3030-FE0F","c":"3030","d":true,"e":true,"f":true,"h":true,"j":["draw","line","moustache","mustache","squiggle","scribble"],"k":[55,44],"o":2},"flag-ke":{"a":"Kenya Flag","b":"1F1F0-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[2,37],"o":2},"satellite":{"a":"Satellite","b":"1F6F0-FE0F","c":"1F6F0","d":true,"e":true,"f":true,"h":true,"j":["communication","future","radio","space"],"k":[36,51],"o":2},"orange_heart":{"a":"Orange Heart","b":"1F9E1","d":true,"e":true,"f":true,"h":true,"k":[51,20],"o":5},"yellow_heart":{"a":"Yellow Heart","b":"1F49B","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,37],"m":"<3","o":2},"copyright":{"a":"Copyright Sign","b":"00A9-FE0F","c":"00A9","d":true,"e":true,"f":true,"h":false,"j":["ip","license","circle","law","legal"],"k":[0,12],"o":2},"rocket":{"a":"Rocket","b":"1F680","d":true,"e":true,"f":true,"h":true,"j":["launch","ship","staffmode","NASA","outer space","outer_space","fly"],"k":[33,56],"o":2},"chart":{"a":"Chart with Upwards Trend and Yen Sign","b":"1F4B9","d":true,"e":true,"f":true,"h":true,"j":["green-square","graph","presentation","stats"],"k":[26,15],"o":2},"flag-kg":{"a":"Kyrgyzstan Flag","b":"1F1F0-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[2,38],"o":2},"office_worker":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F4BC","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f4bc.png","sheet_x":46,"sheet_y":9,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F4BC","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f4bc.png","sheet_x":46,"sheet_y":10,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F4BC","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f4bc.png","sheet_x":46,"sheet_y":11,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F4BC","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f4bc.png","sheet_x":46,"sheet_y":12,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F4BC","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f4bc.png","sheet_x":46,"sheet_y":13,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Office Worker","b":"1F9D1-200D-1F4BC","d":true,"e":false,"f":false,"h":false,"k":[46,8],"o":12},"currency_exchange":{"a":"Currency Exchange","b":"1F4B1","d":true,"e":true,"f":true,"h":true,"j":["money","sales","dollar","travel"],"k":[26,7],"o":2},"registered":{"a":"Registered Sign","b":"00AE-FE0F","c":"00AE","d":true,"e":true,"f":true,"h":false,"j":["alphabet","circle"],"k":[0,13],"o":2},"green_heart":{"a":"Green Heart","b":"1F49A","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,36],"m":"<3","o":2},"flying_saucer":{"a":"Flying Saucer","b":"1F6F8","d":true,"e":true,"f":true,"h":true,"k":[37,0],"o":5},"flag-kh":{"a":"Cambodia Flag","b":"1F1F0-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[2,39],"o":2},"male-office-worker":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fb-200d-1f4bc.png","sheet_x":15,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fc-200d-1f4bc.png","sheet_x":15,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fd-200d-1f4bc.png","sheet_x":15,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F4BC","non_qualified":null,"image":"1f468-1f3fe-200d-1f4bc.png","sheet_x":15,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F4BC","non_qualified":null,"image":"1f468-1f3ff-200d-1f4bc.png","sheet_x":15,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Office Worker","b":"1F468-200D-1F4BC","d":true,"e":true,"f":true,"h":true,"k":[15,44],"o":4},"tm":{"a":"Trade Mark Sign","b":"2122-FE0F","c":"2122","d":true,"e":true,"f":true,"h":true,"j":["trademark","brand","law","legal"],"k":[52,12],"o":2},"bellhop_bell":{"a":"Bellhop Bell","b":"1F6CE-FE0F","c":"1F6CE","d":true,"e":true,"f":true,"h":true,"j":["service"],"k":[36,36],"o":2},"blue_heart":{"a":"Blue Heart","b":"1F499","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,35],"m":"<3","o":2},"flag-ki":{"a":"Kiribati Flag","b":"1F1F0-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[2,40],"o":2},"heavy_dollar_sign":{"a":"Heavy Dollar Sign","b":"1F4B2","d":true,"e":true,"f":true,"h":true,"j":["money","sales","payment","currency","buck"],"k":[26,8],"o":2},"female-office-worker":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fb-200d-1f4bc.png","sheet_x":18,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fc-200d-1f4bc.png","sheet_x":18,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fd-200d-1f4bc.png","sheet_x":18,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F4BC","non_qualified":null,"image":"1f469-1f3fe-200d-1f4bc.png","sheet_x":18,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F4BC","non_qualified":null,"image":"1f469-1f3ff-200d-1f4bc.png","sheet_x":18,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Office Worker","b":"1F469-200D-1F4BC","d":true,"e":true,"f":true,"h":true,"k":[18,29],"o":4},"purple_heart":{"a":"Purple Heart","b":"1F49C","d":true,"e":true,"f":true,"h":true,"j":["love","like","affection","valentines"],"k":[25,38],"m":"<3","o":2},"scientist":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F52C","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f52c.png","sheet_x":46,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F52C","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f52c.png","sheet_x":46,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F52C","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f52c.png","sheet_x":46,"sheet_y":23,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F52C","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f52c.png","sheet_x":46,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F52C","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f52c.png","sheet_x":46,"sheet_y":25,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Scientist","b":"1F9D1-200D-1F52C","d":true,"e":false,"f":false,"h":false,"k":[46,20],"o":12},"luggage":{"a":"Luggage","b":"1F9F3","d":true,"e":true,"f":true,"h":true,"k":[51,38],"o":11},"hash":{"a":"Hash Key","b":"0023-FE0F-20E3","c":"0023-20E3","d":true,"e":true,"f":true,"h":false,"j":["symbol","blue-square","twitter"],"k":[0,0],"o":0},"flag-km":{"a":"Comoros Flag","b":"1F1F0-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[2,41],"o":2},"email":{"a":"Envelope","b":"2709-FE0F","c":"2709","d":true,"e":true,"f":true,"h":true,"j":["letter","postal","inbox","communication"],"k":[54,42],"n":["envelope"],"o":2},"e-mail":{"a":"E-Mail Symbol","b":"1F4E7","d":true,"e":true,"f":true,"h":true,"j":["communication","inbox"],"k":[27,4],"o":2},"keycap_star":{"a":"Keycap Star","b":"002A-FE0F-20E3","c":"002A-20E3","d":true,"e":true,"f":true,"h":false,"k":[0,1],"o":0},"flag-kn":{"a":"St. Kitts & Nevis Flag","b":"1F1F0-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[2,42],"o":2},"hourglass":{"a":"Hourglass","b":"231B","d":true,"e":true,"f":true,"h":true,"j":["time","clock","oldschool","limit","exam","quiz","test"],"k":[52,23],"o":2},"brown_heart":{"a":"Brown Heart","b":"1F90E","d":true,"e":true,"f":true,"h":true,"k":[37,16],"o":12},"male-scientist":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F52C","non_qualified":null,"image":"1f468-1f3fb-200d-1f52c.png","sheet_x":16,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F52C","non_qualified":null,"image":"1f468-1f3fc-200d-1f52c.png","sheet_x":16,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F52C","non_qualified":null,"image":"1f468-1f3fd-200d-1f52c.png","sheet_x":16,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F52C","non_qualified":null,"image":"1f468-1f3fe-200d-1f52c.png","sheet_x":16,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F52C","non_qualified":null,"image":"1f468-1f3ff-200d-1f52c.png","sheet_x":16,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Scientist","b":"1F468-200D-1F52C","d":true,"e":true,"f":true,"h":true,"k":[15,56],"o":4},"hourglass_flowing_sand":{"a":"Hourglass with Flowing Sand","b":"23F3","d":true,"e":true,"f":true,"h":true,"j":["oldschool","time","countdown"],"k":[52,36],"o":2},"black_heart":{"a":"Black Heart","b":"1F5A4","d":true,"e":true,"f":true,"h":true,"j":["evil"],"k":[30,9],"o":4},"zero":{"a":"Keycap 0","b":"0030-FE0F-20E3","c":"0030-20E3","d":true,"e":true,"f":true,"h":false,"j":["0","numbers","blue-square","null"],"k":[0,2],"o":0},"incoming_envelope":{"a":"Incoming Envelope","b":"1F4E8","d":true,"e":true,"f":true,"h":true,"j":["email","inbox"],"k":[27,5],"o":2},"flag-kp":{"a":"North Korea Flag","b":"1F1F0-1F1F5","d":true,"e":true,"f":true,"h":true,"k":[2,43],"o":2},"female-scientist":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F52C","non_qualified":null,"image":"1f469-1f3fb-200d-1f52c.png","sheet_x":18,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F52C","non_qualified":null,"image":"1f469-1f3fc-200d-1f52c.png","sheet_x":18,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F52C","non_qualified":null,"image":"1f469-1f3fd-200d-1f52c.png","sheet_x":18,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F52C","non_qualified":null,"image":"1f469-1f3fe-200d-1f52c.png","sheet_x":18,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F52C","non_qualified":null,"image":"1f469-1f3ff-200d-1f52c.png","sheet_x":18,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Scientist","b":"1F469-200D-1F52C","d":true,"e":true,"f":true,"h":true,"k":[18,41],"o":4},"watch":{"a":"Watch","b":"231A","d":true,"e":true,"f":true,"h":true,"j":["time","accessories"],"k":[52,22],"o":2},"white_heart":{"a":"White Heart","b":"1F90D","d":true,"e":true,"f":true,"h":true,"k":[37,15],"o":12},"one":{"a":"Keycap 1","b":"0031-FE0F-20E3","c":"0031-20E3","d":true,"e":true,"f":true,"h":false,"j":["blue-square","numbers","1"],"k":[0,3],"o":0},"kr":{"a":"South Korea Flag","b":"1F1F0-1F1F7","d":true,"e":true,"f":true,"h":true,"j":["south","korea","nation","flag","country","banner"],"k":[2,44],"n":["flag-kr"],"o":2},"envelope_with_arrow":{"a":"Envelope with Downwards Arrow Above","b":"1F4E9","d":true,"e":true,"f":true,"h":true,"j":["email","communication"],"k":[27,6],"o":2},"technologist":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F4BB","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f4bb.png","sheet_x":46,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F4BB","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f4bb.png","sheet_x":46,"sheet_y":4,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F4BB","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f4bb.png","sheet_x":46,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F4BB","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f4bb.png","sheet_x":46,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F4BB","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f4bb.png","sheet_x":46,"sheet_y":7,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Technologist","b":"1F9D1-200D-1F4BB","d":true,"e":false,"f":false,"h":false,"k":[46,2],"o":12},"outbox_tray":{"a":"Outbox Tray","b":"1F4E4","d":true,"e":true,"f":true,"h":true,"j":["inbox","email"],"k":[27,1],"o":2},"male-technologist":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fb-200d-1f4bb.png","sheet_x":15,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fc-200d-1f4bb.png","sheet_x":15,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fd-200d-1f4bb.png","sheet_x":15,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F4BB","non_qualified":null,"image":"1f468-1f3fe-200d-1f4bb.png","sheet_x":15,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F4BB","non_qualified":null,"image":"1f468-1f3ff-200d-1f4bb.png","sheet_x":15,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Technologist","b":"1F468-200D-1F4BB","d":true,"e":true,"f":true,"h":true,"k":[15,38],"o":4},"alarm_clock":{"a":"Alarm Clock","b":"23F0","d":true,"e":true,"f":true,"h":true,"j":["time","wake"],"k":[52,33],"o":2},"flag-kw":{"a":"Kuwait Flag","b":"1F1F0-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[2,45],"o":2},"two":{"a":"Keycap 2","b":"0032-FE0F-20E3","c":"0032-20E3","d":true,"e":true,"f":true,"h":false,"j":["numbers","2","prime","blue-square"],"k":[0,4],"o":0},"anger":{"a":"Anger Symbol","b":"1F4A2","d":true,"e":true,"f":true,"h":true,"j":["angry","mad"],"k":[25,44],"o":2},"inbox_tray":{"a":"Inbox Tray","b":"1F4E5","d":true,"e":true,"f":true,"h":true,"j":["email","documents"],"k":[27,2],"o":2},"three":{"a":"Keycap 3","b":"0033-FE0F-20E3","c":"0033-20E3","d":true,"e":true,"f":true,"h":false,"j":["3","numbers","prime","blue-square"],"k":[0,5],"o":0},"flag-ky":{"a":"Cayman Islands Flag","b":"1F1F0-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[2,46],"o":2},"stopwatch":{"a":"Stopwatch","b":"23F1-FE0F","c":"23F1","d":true,"e":true,"f":true,"h":true,"j":["time","deadline"],"k":[52,34],"o":2},"female-technologist":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fb-200d-1f4bb.png","sheet_x":18,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fc-200d-1f4bb.png","sheet_x":18,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fd-200d-1f4bb.png","sheet_x":18,"sheet_y":26,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F4BB","non_qualified":null,"image":"1f469-1f3fe-200d-1f4bb.png","sheet_x":18,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F4BB","non_qualified":null,"image":"1f469-1f3ff-200d-1f4bb.png","sheet_x":18,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Technologist","b":"1F469-200D-1F4BB","d":true,"e":true,"f":true,"h":true,"k":[18,23],"o":4},"boom":{"a":"Collision Symbol","b":"1F4A5","d":true,"e":true,"f":true,"h":true,"j":["bomb","explode","explosion","collision","blown"],"k":[25,47],"n":["collision"],"o":2},"flag-kz":{"a":"Kazakhstan Flag","b":"1F1F0-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[2,47],"o":2},"four":{"a":"Keycap 4","b":"0034-FE0F-20E3","c":"0034-20E3","d":true,"e":true,"f":true,"h":false,"j":["4","numbers","blue-square"],"k":[0,6],"o":0},"timer_clock":{"a":"Timer Clock","b":"23F2-FE0F","c":"23F2","d":true,"e":true,"f":true,"h":true,"j":["alarm"],"k":[52,35],"o":2},"singer":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F3A4","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f3a4.png","sheet_x":45,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F3A4","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f3a4.png","sheet_x":45,"sheet_y":37,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F3A4","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f3a4.png","sheet_x":45,"sheet_y":38,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F3A4","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f3a4.png","sheet_x":45,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F3A4","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f3a4.png","sheet_x":45,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Singer","b":"1F9D1-200D-1F3A4","d":true,"e":false,"f":false,"h":false,"k":[45,35],"o":12},"package":{"a":"Package","b":"1F4E6","d":true,"e":true,"f":true,"h":true,"j":["mail","gift","cardboard","box","moving"],"k":[27,3],"o":2},"mailbox":{"a":"Closed Mailbox with Raised Flag","b":"1F4EB","d":true,"e":true,"f":true,"h":true,"j":["email","inbox","communication"],"k":[27,8],"o":2},"flag-la":{"a":"Laos Flag","b":"1F1F1-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[2,48],"o":2},"dizzy":{"a":"Dizzy Symbol","b":"1F4AB","d":true,"e":true,"f":true,"h":true,"j":["star","sparkle","shoot","magic"],"k":[26,1],"o":2},"five":{"a":"Keycap 5","b":"0035-FE0F-20E3","c":"0035-20E3","d":true,"e":true,"f":true,"h":false,"j":["5","numbers","blue-square","prime"],"k":[0,7],"o":0},"male-singer":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fb-200d-1f3a4.png","sheet_x":15,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fc-200d-1f3a4.png","sheet_x":15,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fd-200d-1f3a4.png","sheet_x":15,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3A4","non_qualified":null,"image":"1f468-1f3fe-200d-1f3a4.png","sheet_x":15,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3A4","non_qualified":null,"image":"1f468-1f3ff-200d-1f3a4.png","sheet_x":15,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Singer","b":"1F468-200D-1F3A4","d":true,"e":true,"f":true,"h":true,"k":[14,56],"o":4},"mantelpiece_clock":{"a":"Mantelpiece Clock","b":"1F570-FE0F","c":"1F570","d":true,"e":true,"f":true,"h":true,"j":["time"],"k":[29,7],"o":2},"female-singer":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fb-200d-1f3a4.png","sheet_x":17,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fc-200d-1f3a4.png","sheet_x":17,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fd-200d-1f3a4.png","sheet_x":17,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3A4","non_qualified":null,"image":"1f469-1f3fe-200d-1f3a4.png","sheet_x":17,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3A4","non_qualified":null,"image":"1f469-1f3ff-200d-1f3a4.png","sheet_x":17,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Singer","b":"1F469-200D-1F3A4","d":true,"e":true,"f":true,"h":true,"k":[17,46],"o":4},"flag-lb":{"a":"Lebanon Flag","b":"1F1F1-1F1E7","d":true,"e":true,"f":true,"h":true,"k":[2,49],"o":2},"six":{"a":"Keycap 6","b":"0036-FE0F-20E3","c":"0036-20E3","d":true,"e":true,"f":true,"h":false,"j":["6","numbers","blue-square"],"k":[0,8],"o":0},"mailbox_closed":{"a":"Closed Mailbox with Lowered Flag","b":"1F4EA","d":true,"e":true,"f":true,"h":true,"j":["email","communication","inbox"],"k":[27,7],"o":2},"sweat_drops":{"a":"Splashing Sweat Symbol","b":"1F4A6","d":true,"e":true,"f":true,"h":true,"j":["water","drip","oops"],"k":[25,48],"o":2},"clock12":{"a":"Clock Face Twelve Oclock","b":"1F55B","d":true,"e":true,"f":true,"h":true,"j":["time","noon","midnight","midday","late","early","schedule"],"k":[28,50],"o":2},"seven":{"a":"Keycap 7","b":"0037-FE0F-20E3","c":"0037-20E3","d":true,"e":true,"f":true,"h":false,"j":["7","numbers","blue-square","prime"],"k":[0,9],"o":0},"mailbox_with_mail":{"a":"Open Mailbox with Raised Flag","b":"1F4EC","d":true,"e":true,"f":true,"h":true,"j":["email","inbox","communication"],"k":[27,9],"o":2},"clock1230":{"a":"Clock Face Twelve-Thirty","b":"1F567","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,5],"o":2},"dash":{"a":"Dash Symbol","b":"1F4A8","d":true,"e":true,"f":true,"h":true,"j":["wind","air","fast","shoo","fart","smoke","puff"],"k":[25,50],"o":2},"artist":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F3A8","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f3a8.png","sheet_x":45,"sheet_y":42,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F3A8","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f3a8.png","sheet_x":45,"sheet_y":43,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F3A8","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f3a8.png","sheet_x":45,"sheet_y":44,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F3A8","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f3a8.png","sheet_x":45,"sheet_y":45,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F3A8","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f3a8.png","sheet_x":45,"sheet_y":46,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Artist","b":"1F9D1-200D-1F3A8","d":true,"e":false,"f":false,"h":false,"k":[45,41],"o":12},"flag-lc":{"a":"St. Lucia Flag","b":"1F1F1-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[2,50],"o":2},"hole":{"a":"Hole","b":"1F573-FE0F","c":"1F573","d":true,"e":true,"f":true,"h":true,"j":["embarrassing"],"k":[29,8],"o":2},"male-artist":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fb-200d-1f3a8.png","sheet_x":15,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fc-200d-1f3a8.png","sheet_x":15,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fd-200d-1f3a8.png","sheet_x":15,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F3A8","non_qualified":null,"image":"1f468-1f3fe-200d-1f3a8.png","sheet_x":15,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F3A8","non_qualified":null,"image":"1f468-1f3ff-200d-1f3a8.png","sheet_x":15,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Artist","b":"1F468-200D-1F3A8","d":true,"e":true,"f":true,"h":true,"k":[15,5],"o":4},"clock1":{"a":"Clock Face One Oclock","b":"1F550","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,39],"o":2},"eight":{"a":"Keycap 8","b":"0038-FE0F-20E3","c":"0038-20E3","d":true,"e":true,"f":true,"h":false,"j":["8","blue-square","numbers"],"k":[0,10],"o":0},"mailbox_with_no_mail":{"a":"Open Mailbox with Lowered Flag","b":"1F4ED","d":true,"e":true,"f":true,"h":true,"j":["email","inbox"],"k":[27,10],"o":2},"flag-li":{"a":"Liechtenstein Flag","b":"1F1F1-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[2,51],"o":2},"bomb":{"a":"Bomb","b":"1F4A3","d":true,"e":true,"f":true,"h":true,"j":["boom","explode","explosion","terrorism"],"k":[25,45],"o":2},"nine":{"a":"Keycap 9","b":"0039-FE0F-20E3","c":"0039-20E3","d":true,"e":true,"f":true,"h":false,"j":["blue-square","numbers","9"],"k":[0,11],"o":0},"postbox":{"a":"Postbox","b":"1F4EE","d":true,"e":true,"f":true,"h":true,"j":["email","letter","envelope"],"k":[27,11],"o":2},"female-artist":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fb-200d-1f3a8.png","sheet_x":17,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fc-200d-1f3a8.png","sheet_x":17,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fd-200d-1f3a8.png","sheet_x":17,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F3A8","non_qualified":null,"image":"1f469-1f3fe-200d-1f3a8.png","sheet_x":17,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F3A8","non_qualified":null,"image":"1f469-1f3ff-200d-1f3a8.png","sheet_x":18,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Artist","b":"1F469-200D-1F3A8","d":true,"e":true,"f":true,"h":true,"k":[17,52],"o":4},"clock130":{"a":"Clock Face One-Thirty","b":"1F55C","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,51],"o":2},"flag-lk":{"a":"Sri Lanka Flag","b":"1F1F1-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[2,52],"o":2},"ballot_box_with_ballot":{"a":"Ballot Box with Ballot","b":"1F5F3-FE0F","c":"1F5F3","d":true,"e":true,"f":true,"h":true,"k":[30,28],"o":2},"pilot":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-2708-FE0F","non_qualified":"1F9D1-1F3FB-200D-2708","image":"1f9d1-1f3fb-200d-2708-fe0f.png","sheet_x":48,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-2708-FE0F","non_qualified":"1F9D1-1F3FC-200D-2708","image":"1f9d1-1f3fc-200d-2708-fe0f.png","sheet_x":48,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-2708-FE0F","non_qualified":"1F9D1-1F3FD-200D-2708","image":"1f9d1-1f3fd-200d-2708-fe0f.png","sheet_x":48,"sheet_y":7,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-2708-FE0F","non_qualified":"1F9D1-1F3FE-200D-2708","image":"1f9d1-1f3fe-200d-2708-fe0f.png","sheet_x":48,"sheet_y":8,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-2708-FE0F","non_qualified":"1F9D1-1F3FF-200D-2708","image":"1f9d1-1f3ff-200d-2708-fe0f.png","sheet_x":48,"sheet_y":9,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Pilot","b":"1F9D1-200D-2708-FE0F","c":"1F9D1-200D-2708","d":true,"e":false,"f":false,"h":false,"k":[48,4],"o":12},"keycap_ten":{"a":"Keycap Ten","b":"1F51F","d":true,"e":true,"f":true,"h":true,"j":["numbers","10","blue-square"],"k":[28,2],"o":2},"clock2":{"a":"Clock Face Two Oclock","b":"1F551","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,40],"o":2},"flag-lr":{"a":"Liberia Flag","b":"1F1F1-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[2,53],"o":2},"speech_balloon":{"a":"Speech Balloon","b":"1F4AC","d":true,"e":true,"f":true,"h":true,"j":["bubble","words","message","talk","chatting"],"k":[26,2],"o":2},"eye-in-speech-bubble":{"a":"Eye in Speech Bubble","b":"1F441-FE0F-200D-1F5E8-FE0F","d":true,"e":true,"f":false,"h":false,"k":[12,37],"o":2},"flag-ls":{"a":"Lesotho Flag","b":"1F1F1-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[2,54],"o":2},"clock230":{"a":"Clock Face Two-Thirty","b":"1F55D","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,52],"o":2},"male-pilot":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-2708-FE0F","non_qualified":"1F468-1F3FB-200D-2708","image":"1f468-1f3fb-200d-2708-fe0f.png","sheet_x":17,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-2708-FE0F","non_qualified":"1F468-1F3FC-200D-2708","image":"1f468-1f3fc-200d-2708-fe0f.png","sheet_x":17,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-2708-FE0F","non_qualified":"1F468-1F3FD-200D-2708","image":"1f468-1f3fd-200d-2708-fe0f.png","sheet_x":17,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-2708-FE0F","non_qualified":"1F468-1F3FE-200D-2708","image":"1f468-1f3fe-200d-2708-fe0f.png","sheet_x":17,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-2708-FE0F","non_qualified":"1F468-1F3FF-200D-2708","image":"1f468-1f3ff-200d-2708-fe0f.png","sheet_x":17,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Pilot","b":"1F468-200D-2708-FE0F","c":"1F468-200D-2708","d":true,"e":true,"f":true,"h":true,"k":[17,14],"o":4},"capital_abcd":{"a":"Input Symbol for Latin Capital Letters","b":"1F520","d":true,"e":true,"f":true,"h":true,"j":["alphabet","words","blue-square"],"k":[28,3],"o":2},"pencil2":{"a":"Pencil","b":"270F-FE0F","c":"270F","d":true,"e":true,"f":true,"h":true,"j":["stationery","write","paper","writing","school","study"],"k":[55,10],"o":2},"female-pilot":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-2708-FE0F","non_qualified":"1F469-1F3FB-200D-2708","image":"1f469-1f3fb-200d-2708-fe0f.png","sheet_x":20,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-2708-FE0F","non_qualified":"1F469-1F3FC-200D-2708","image":"1f469-1f3fc-200d-2708-fe0f.png","sheet_x":20,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-2708-FE0F","non_qualified":"1F469-1F3FD-200D-2708","image":"1f469-1f3fd-200d-2708-fe0f.png","sheet_x":20,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-2708-FE0F","non_qualified":"1F469-1F3FE-200D-2708","image":"1f469-1f3fe-200d-2708-fe0f.png","sheet_x":20,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-2708-FE0F","non_qualified":"1F469-1F3FF-200D-2708","image":"1f469-1f3ff-200d-2708-fe0f.png","sheet_x":20,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Pilot","b":"1F469-200D-2708-FE0F","c":"1F469-200D-2708","d":true,"e":true,"f":true,"h":true,"k":[19,56],"o":4},"black_nib":{"a":"Black Nib","b":"2712-FE0F","c":"2712","d":true,"e":true,"f":true,"h":true,"j":["pen","stationery","writing","write"],"k":[55,11],"o":2},"left_speech_bubble":{"a":"Left Speech Bubble","b":"1F5E8-FE0F","c":"1F5E8","d":true,"e":true,"f":true,"h":true,"j":["words","message","talk","chatting"],"k":[30,26],"o":2},"clock3":{"a":"Clock Face Three Oclock","b":"1F552","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,41],"o":2},"abcd":{"a":"Input Symbol for Latin Small Letters","b":"1F521","d":true,"e":true,"f":true,"h":true,"j":["blue-square","alphabet"],"k":[28,4],"o":2},"flag-lt":{"a":"Lithuania Flag","b":"1F1F1-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[2,55],"o":2},"clock330":{"a":"Clock Face Three-Thirty","b":"1F55E","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,53],"o":2},"astronaut":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F680","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f680.png","sheet_x":46,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F680","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f680.png","sheet_x":46,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F680","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f680.png","sheet_x":46,"sheet_y":29,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F680","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f680.png","sheet_x":46,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F680","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f680.png","sheet_x":46,"sheet_y":31,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Astronaut","b":"1F9D1-200D-1F680","d":true,"e":false,"f":false,"h":false,"k":[46,26],"o":12},"flag-lu":{"a":"Luxembourg Flag","b":"1F1F1-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[2,56],"o":2},"right_anger_bubble":{"a":"Right Anger Bubble","b":"1F5EF-FE0F","c":"1F5EF","d":true,"e":true,"f":true,"h":true,"j":["caption","speech","thinking","mad"],"k":[30,27],"o":2},"lower_left_fountain_pen":{"a":"Lower Left Fountain Pen","b":"1F58B-FE0F","c":"1F58B","d":true,"e":true,"f":true,"h":true,"k":[29,45],"o":2},"male-astronaut":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F680","non_qualified":null,"image":"1f468-1f3fb-200d-1f680.png","sheet_x":16,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F680","non_qualified":null,"image":"1f468-1f3fc-200d-1f680.png","sheet_x":16,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F680","non_qualified":null,"image":"1f468-1f3fd-200d-1f680.png","sheet_x":16,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F680","non_qualified":null,"image":"1f468-1f3fe-200d-1f680.png","sheet_x":16,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F680","non_qualified":null,"image":"1f468-1f3ff-200d-1f680.png","sheet_x":16,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Astronaut","b":"1F468-200D-1F680","d":true,"e":true,"f":true,"h":true,"k":[16,5],"o":4},"thought_balloon":{"a":"Thought Balloon","b":"1F4AD","d":true,"e":true,"f":true,"h":true,"j":["bubble","cloud","speech","thinking","dream"],"k":[26,3],"o":2},"symbols":{"a":"Input Symbol for Symbols","b":"1F523","d":true,"e":true,"f":true,"h":true,"j":["blue-square","music","note","ampersand","percent","glyphs","characters"],"k":[28,6],"o":2},"clock4":{"a":"Clock Face Four Oclock","b":"1F553","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,42],"o":2},"flag-lv":{"a":"Latvia Flag","b":"1F1F1-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[3,0],"o":2},"lower_left_ballpoint_pen":{"a":"Lower Left Ballpoint Pen","b":"1F58A-FE0F","c":"1F58A","d":true,"e":true,"f":true,"h":true,"k":[29,44],"o":2},"abc":{"a":"Input Symbol for Latin Letters","b":"1F524","d":true,"e":true,"f":true,"h":true,"j":["blue-square","alphabet"],"k":[28,7],"o":2},"zzz":{"a":"Sleeping Symbol","b":"1F4A4","d":true,"e":true,"f":true,"h":true,"j":["sleepy","tired","dream"],"k":[25,46],"o":2},"lower_left_paintbrush":{"a":"Lower Left Paintbrush","b":"1F58C-FE0F","c":"1F58C","d":true,"e":true,"f":true,"h":true,"k":[29,46],"o":2},"female-astronaut":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F680","non_qualified":null,"image":"1f469-1f3fb-200d-1f680.png","sheet_x":18,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F680","non_qualified":null,"image":"1f469-1f3fc-200d-1f680.png","sheet_x":18,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F680","non_qualified":null,"image":"1f469-1f3fd-200d-1f680.png","sheet_x":18,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F680","non_qualified":null,"image":"1f469-1f3fe-200d-1f680.png","sheet_x":18,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F680","non_qualified":null,"image":"1f469-1f3ff-200d-1f680.png","sheet_x":18,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Astronaut","b":"1F469-200D-1F680","d":true,"e":true,"f":true,"h":true,"k":[18,47],"o":4},"flag-ly":{"a":"Libya Flag","b":"1F1F1-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[3,1],"o":2},"clock430":{"a":"Clock Face Four-Thirty","b":"1F55F","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,54],"o":2},"flag-ma":{"a":"Morocco Flag","b":"1F1F2-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[3,2],"o":2},"a":{"a":"Negative Squared Latin Capital Letter a","b":"1F170-FE0F","c":"1F170","d":true,"e":true,"f":true,"h":true,"j":["red-square","alphabet","letter"],"k":[0,16],"o":2},"clock5":{"a":"Clock Face Five Oclock","b":"1F554","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,43],"o":2},"lower_left_crayon":{"a":"Lower Left Crayon","b":"1F58D-FE0F","c":"1F58D","d":true,"e":true,"f":true,"h":true,"k":[29,47],"o":2},"firefighter":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F692","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f692.png","sheet_x":46,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F692","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f692.png","sheet_x":46,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F692","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f692.png","sheet_x":46,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F692","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f692.png","sheet_x":46,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F692","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f692.png","sheet_x":46,"sheet_y":37,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Firefighter","b":"1F9D1-200D-1F692","d":true,"e":false,"f":false,"h":false,"k":[46,32],"o":12},"male-firefighter":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F692","non_qualified":null,"image":"1f468-1f3fb-200d-1f692.png","sheet_x":16,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F692","non_qualified":null,"image":"1f468-1f3fc-200d-1f692.png","sheet_x":16,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F692","non_qualified":null,"image":"1f468-1f3fd-200d-1f692.png","sheet_x":16,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F692","non_qualified":null,"image":"1f468-1f3fe-200d-1f692.png","sheet_x":16,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F692","non_qualified":null,"image":"1f468-1f3ff-200d-1f692.png","sheet_x":16,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Firefighter","b":"1F468-200D-1F692","d":true,"e":true,"f":true,"h":true,"k":[16,11],"o":4},"memo":{"a":"Memo","b":"1F4DD","d":true,"e":true,"f":true,"h":true,"j":["write","documents","stationery","pencil","paper","writing","legal","exam","quiz","test","study","compose"],"k":[26,51],"n":["pencil"],"o":2},"ab":{"a":"Negative Squared Ab","b":"1F18E","d":true,"e":true,"f":true,"h":true,"j":["red-square","alphabet"],"k":[0,20],"o":2},"flag-mc":{"a":"Monaco Flag","b":"1F1F2-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[3,3],"o":2},"clock530":{"a":"Clock Face Five-Thirty","b":"1F560","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,55],"o":2},"briefcase":{"a":"Briefcase","b":"1F4BC","d":true,"e":true,"f":true,"h":true,"j":["business","documents","work","law","legal","job","career"],"k":[26,18],"o":2},"female-firefighter":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F692","non_qualified":null,"image":"1f469-1f3fb-200d-1f692.png","sheet_x":18,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F692","non_qualified":null,"image":"1f469-1f3fc-200d-1f692.png","sheet_x":18,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F692","non_qualified":null,"image":"1f469-1f3fd-200d-1f692.png","sheet_x":18,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F692","non_qualified":null,"image":"1f469-1f3fe-200d-1f692.png","sheet_x":19,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F692","non_qualified":null,"image":"1f469-1f3ff-200d-1f692.png","sheet_x":19,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Firefighter","b":"1F469-200D-1F692","d":true,"e":true,"f":true,"h":true,"k":[18,53],"o":4},"clock6":{"a":"Clock Face Six Oclock","b":"1F555","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule","dawn","dusk"],"k":[28,44],"o":2},"b":{"a":"Negative Squared Latin Capital Letter B","b":"1F171-FE0F","c":"1F171","d":true,"e":true,"f":true,"h":true,"j":["red-square","alphabet","letter"],"k":[0,17],"o":2},"flag-md":{"a":"Moldova Flag","b":"1F1F2-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[3,4],"o":2},"clock630":{"a":"Clock Face Six-Thirty","b":"1F561","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,56],"o":2},"cl":{"a":"Squared Cl","b":"1F191","d":true,"e":true,"f":true,"h":true,"j":["alphabet","words","red-square"],"k":[0,21],"o":2},"flag-me":{"a":"Montenegro Flag","b":"1F1F2-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[3,5],"o":2},"file_folder":{"a":"File Folder","b":"1F4C1","d":true,"e":true,"f":true,"h":true,"j":["documents","business","office"],"k":[26,23],"o":2},"cop":{"skin_variations":{"1F3FB":{"unified":"1F46E-1F3FB","non_qualified":null,"image":"1f46e-1f3fb.png","sheet_x":21,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F46E-1F3FC","non_qualified":null,"image":"1f46e-1f3fc.png","sheet_x":21,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F46E-1F3FD","non_qualified":null,"image":"1f46e-1f3fd.png","sheet_x":21,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F46E-1F3FE","non_qualified":null,"image":"1f46e-1f3fe.png","sheet_x":21,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F46E-1F3FF","non_qualified":null,"image":"1f46e-1f3ff.png","sheet_x":21,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F46E-200D-2642-FE0F","a":"Police Officer","b":"1F46E","d":true,"e":true,"f":true,"h":false,"k":[21,49],"o":2},"male-police-officer":{"skin_variations":{"1F3FB":{"unified":"1F46E-1F3FB-200D-2642-FE0F","non_qualified":"1F46E-1F3FB-200D-2642","image":"1f46e-1f3fb-200d-2642-fe0f.png","sheet_x":21,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F46E-1F3FC-200D-2642-FE0F","non_qualified":"1F46E-1F3FC-200D-2642","image":"1f46e-1f3fc-200d-2642-fe0f.png","sheet_x":21,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F46E-1F3FD-200D-2642-FE0F","non_qualified":"1F46E-1F3FD-200D-2642","image":"1f46e-1f3fd-200d-2642-fe0f.png","sheet_x":21,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F46E-1F3FE-200D-2642-FE0F","non_qualified":"1F46E-1F3FE-200D-2642","image":"1f46e-1f3fe-200d-2642-fe0f.png","sheet_x":21,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F46E-1F3FF-200D-2642-FE0F","non_qualified":"1F46E-1F3FF-200D-2642","image":"1f46e-1f3ff-200d-2642-fe0f.png","sheet_x":21,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F46E","a":"Male Police Officer","b":"1F46E-200D-2642-FE0F","c":"1F46E-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[21,43],"o":4},"cool":{"a":"Squared Cool","b":"1F192","d":true,"e":true,"f":true,"h":true,"j":["words","blue-square"],"k":[0,22],"o":2},"clock7":{"a":"Clock Face Seven Oclock","b":"1F556","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,45],"o":2},"flag-mf":{"a":"St. Martin Flag","b":"1F1F2-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[3,6],"o":2},"open_file_folder":{"a":"Open File Folder","b":"1F4C2","d":true,"e":true,"f":true,"h":true,"j":["documents","load"],"k":[26,24],"o":2},"card_index_dividers":{"a":"Card Index Dividers","b":"1F5C2-FE0F","c":"1F5C2","d":true,"e":true,"f":true,"h":true,"j":["organizing","business","stationery"],"k":[30,15],"o":2},"flag-mg":{"a":"Madagascar Flag","b":"1F1F2-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[3,7],"o":2},"free":{"a":"Squared Free","b":"1F193","d":true,"e":true,"f":true,"h":true,"j":["blue-square","words"],"k":[0,23],"o":2},"female-police-officer":{"skin_variations":{"1F3FB":{"unified":"1F46E-1F3FB-200D-2640-FE0F","non_qualified":"1F46E-1F3FB-200D-2640","image":"1f46e-1f3fb-200d-2640-fe0f.png","sheet_x":21,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F46E-1F3FC-200D-2640-FE0F","non_qualified":"1F46E-1F3FC-200D-2640","image":"1f46e-1f3fc-200d-2640-fe0f.png","sheet_x":21,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F46E-1F3FD-200D-2640-FE0F","non_qualified":"1F46E-1F3FD-200D-2640","image":"1f46e-1f3fd-200d-2640-fe0f.png","sheet_x":21,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F46E-1F3FE-200D-2640-FE0F","non_qualified":"1F46E-1F3FE-200D-2640","image":"1f46e-1f3fe-200d-2640-fe0f.png","sheet_x":21,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F46E-1F3FF-200D-2640-FE0F","non_qualified":"1F46E-1F3FF-200D-2640","image":"1f46e-1f3ff-200d-2640-fe0f.png","sheet_x":21,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Police Officer","b":"1F46E-200D-2640-FE0F","c":"1F46E-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[21,37],"o":4},"clock730":{"a":"Clock Face Seven-Thirty","b":"1F562","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,0],"o":2},"date":{"a":"Calendar","b":"1F4C5","d":true,"e":true,"f":true,"h":true,"j":["calendar","schedule"],"k":[26,27],"o":2},"clock8":{"a":"Clock Face Eight Oclock","b":"1F557","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,46],"o":2},"information_source":{"a":"Information Source","b":"2139-FE0F","c":"2139","d":true,"e":true,"f":true,"h":true,"j":["blue-square","alphabet","letter"],"k":[52,13],"o":2},"sleuth_or_spy":{"skin_variations":{"1F3FB":{"unified":"1F575-1F3FB","non_qualified":null,"image":"1f575-1f3fb.png","sheet_x":29,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F575-1F3FC","non_qualified":null,"image":"1f575-1f3fc.png","sheet_x":29,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F575-1F3FD","non_qualified":null,"image":"1f575-1f3fd.png","sheet_x":29,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F575-1F3FE","non_qualified":null,"image":"1f575-1f3fe.png","sheet_x":29,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F575-1F3FF","non_qualified":null,"image":"1f575-1f3ff.png","sheet_x":29,"sheet_y":32,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F575-FE0F-200D-2642-FE0F","a":"Sleuth or Spy","b":"1F575-FE0F","c":"1F575","d":true,"e":true,"f":true,"h":false,"k":[29,27],"o":2},"flag-mh":{"a":"Marshall Islands Flag","b":"1F1F2-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[3,8],"o":2},"clock830":{"a":"Clock Face Eight-Thirty","b":"1F563","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,1],"o":2},"calendar":{"a":"Tear-off Calendar","b":"1F4C6","d":true,"e":true,"f":true,"h":true,"j":["schedule","date","planning"],"k":[26,28],"o":2},"male-detective":{"skin_variations":{"1F3FB":{"unified":"1F575-1F3FB-200D-2642-FE0F","non_qualified":"1F575-1F3FB-200D-2642","image":"1f575-1f3fb-200d-2642-fe0f.png","sheet_x":29,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F575-1F3FC-200D-2642-FE0F","non_qualified":"1F575-1F3FC-200D-2642","image":"1f575-1f3fc-200d-2642-fe0f.png","sheet_x":29,"sheet_y":23,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F575-1F3FD-200D-2642-FE0F","non_qualified":"1F575-1F3FD-200D-2642","image":"1f575-1f3fd-200d-2642-fe0f.png","sheet_x":29,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F575-1F3FE-200D-2642-FE0F","non_qualified":"1F575-1F3FE-200D-2642","image":"1f575-1f3fe-200d-2642-fe0f.png","sheet_x":29,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F575-1F3FF-200D-2642-FE0F","non_qualified":"1F575-1F3FF-200D-2642","image":"1f575-1f3ff-200d-2642-fe0f.png","sheet_x":29,"sheet_y":26,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F575-FE0F","a":"Male Detective","b":"1F575-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"h":false,"k":[29,21],"o":4},"flag-mk":{"a":"North Macedonia Flag","b":"1F1F2-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[3,9],"o":2},"id":{"a":"Squared Id","b":"1F194","d":true,"e":true,"f":true,"h":true,"j":["purple-square","words"],"k":[0,24],"o":2},"spiral_note_pad":{"a":"Spiral Note Pad","b":"1F5D2-FE0F","c":"1F5D2","d":true,"e":true,"f":true,"h":true,"k":[30,19],"o":2},"female-detective":{"skin_variations":{"1F3FB":{"unified":"1F575-1F3FB-200D-2640-FE0F","non_qualified":"1F575-1F3FB-200D-2640","image":"1f575-1f3fb-200d-2640-fe0f.png","sheet_x":29,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F575-1F3FC-200D-2640-FE0F","non_qualified":"1F575-1F3FC-200D-2640","image":"1f575-1f3fc-200d-2640-fe0f.png","sheet_x":29,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F575-1F3FD-200D-2640-FE0F","non_qualified":"1F575-1F3FD-200D-2640","image":"1f575-1f3fd-200d-2640-fe0f.png","sheet_x":29,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F575-1F3FE-200D-2640-FE0F","non_qualified":"1F575-1F3FE-200D-2640","image":"1f575-1f3fe-200d-2640-fe0f.png","sheet_x":29,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F575-1F3FF-200D-2640-FE0F","non_qualified":"1F575-1F3FF-200D-2640","image":"1f575-1f3ff-200d-2640-fe0f.png","sheet_x":29,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Detective","b":"1F575-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"h":false,"k":[29,15],"o":4},"clock9":{"a":"Clock Face Nine Oclock","b":"1F558","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,47],"o":2},"flag-ml":{"a":"Mali Flag","b":"1F1F2-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[3,10],"o":2},"m":{"a":"Circled Latin Capital Letter M","b":"24C2-FE0F","c":"24C2","d":true,"e":true,"f":true,"h":true,"j":["alphabet","blue-circle","letter"],"k":[52,40],"o":2},"flag-mm":{"a":"Myanmar (burma) Flag","b":"1F1F2-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[3,11],"o":2},"clock930":{"a":"Clock Face Nine-Thirty","b":"1F564","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,2],"o":2},"guardsman":{"skin_variations":{"1F3FB":{"unified":"1F482-1F3FB","non_qualified":null,"image":"1f482-1f3fb.png","sheet_x":24,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F482-1F3FC","non_qualified":null,"image":"1f482-1f3fc.png","sheet_x":24,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F482-1F3FD","non_qualified":null,"image":"1f482-1f3fd.png","sheet_x":24,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F482-1F3FE","non_qualified":null,"image":"1f482-1f3fe.png","sheet_x":24,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F482-1F3FF","non_qualified":null,"image":"1f482-1f3ff.png","sheet_x":24,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F482-200D-2642-FE0F","a":"Guardsman","b":"1F482","d":true,"e":true,"f":true,"h":false,"j":["uk","gb","british","male","guy","royal"],"k":[24,20],"o":2},"new":{"a":"Squared New","b":"1F195","d":true,"e":true,"f":true,"h":true,"j":["blue-square","words","start"],"k":[0,25],"o":2},"spiral_calendar_pad":{"a":"Spiral Calendar Pad","b":"1F5D3-FE0F","c":"1F5D3","d":true,"e":true,"f":true,"h":true,"k":[30,20],"o":2},"ng":{"a":"Squared Ng","b":"1F196","d":true,"e":true,"f":true,"h":true,"j":["blue-square","words","shape","icon"],"k":[0,26],"o":2},"card_index":{"a":"Card Index","b":"1F4C7","d":true,"e":true,"f":true,"h":true,"j":["business","stationery"],"k":[26,29],"o":2},"clock10":{"a":"Clock Face Ten Oclock","b":"1F559","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,48],"o":2},"flag-mn":{"a":"Mongolia Flag","b":"1F1F2-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[3,12],"o":2},"male-guard":{"skin_variations":{"1F3FB":{"unified":"1F482-1F3FB-200D-2642-FE0F","non_qualified":"1F482-1F3FB-200D-2642","image":"1f482-1f3fb-200d-2642-fe0f.png","sheet_x":24,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F482-1F3FC-200D-2642-FE0F","non_qualified":"1F482-1F3FC-200D-2642","image":"1f482-1f3fc-200d-2642-fe0f.png","sheet_x":24,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F482-1F3FD-200D-2642-FE0F","non_qualified":"1F482-1F3FD-200D-2642","image":"1f482-1f3fd-200d-2642-fe0f.png","sheet_x":24,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F482-1F3FE-200D-2642-FE0F","non_qualified":"1F482-1F3FE-200D-2642","image":"1f482-1f3fe-200d-2642-fe0f.png","sheet_x":24,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F482-1F3FF-200D-2642-FE0F","non_qualified":"1F482-1F3FF-200D-2642","image":"1f482-1f3ff-200d-2642-fe0f.png","sheet_x":24,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F482","a":"Male Guard","b":"1F482-200D-2642-FE0F","c":"1F482-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[24,14],"o":4},"flag-mo":{"a":"Macao Sar China Flag","b":"1F1F2-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[3,13],"o":2},"clock1030":{"a":"Clock Face Ten-Thirty","b":"1F565","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,3],"o":2},"chart_with_upwards_trend":{"a":"Chart with Upwards Trend","b":"1F4C8","d":true,"e":true,"f":true,"h":true,"j":["graph","presentation","stats","recovery","business","economics","money","sales","good","success"],"k":[26,30],"o":2},"o2":{"a":"Negative Squared Latin Capital Letter O","b":"1F17E-FE0F","c":"1F17E","d":true,"e":true,"f":true,"h":true,"j":["alphabet","red-square","letter"],"k":[0,18],"o":2},"female-guard":{"skin_variations":{"1F3FB":{"unified":"1F482-1F3FB-200D-2640-FE0F","non_qualified":"1F482-1F3FB-200D-2640","image":"1f482-1f3fb-200d-2640-fe0f.png","sheet_x":24,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F482-1F3FC-200D-2640-FE0F","non_qualified":"1F482-1F3FC-200D-2640","image":"1f482-1f3fc-200d-2640-fe0f.png","sheet_x":24,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F482-1F3FD-200D-2640-FE0F","non_qualified":"1F482-1F3FD-200D-2640","image":"1f482-1f3fd-200d-2640-fe0f.png","sheet_x":24,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F482-1F3FE-200D-2640-FE0F","non_qualified":"1F482-1F3FE-200D-2640","image":"1f482-1f3fe-200d-2640-fe0f.png","sheet_x":24,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F482-1F3FF-200D-2640-FE0F","non_qualified":"1F482-1F3FF-200D-2640","image":"1f482-1f3ff-200d-2640-fe0f.png","sheet_x":24,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Guard","b":"1F482-200D-2640-FE0F","c":"1F482-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[24,8],"o":4},"chart_with_downwards_trend":{"a":"Chart with Downwards Trend","b":"1F4C9","d":true,"e":true,"f":true,"h":true,"j":["graph","presentation","stats","recession","business","economics","money","sales","bad","failure"],"k":[26,31],"o":2},"flag-mp":{"a":"Northern Mariana Islands Flag","b":"1F1F2-1F1F5","d":true,"e":true,"f":true,"h":true,"k":[3,14],"o":2},"ok":{"a":"Squared Ok","b":"1F197","d":true,"e":true,"f":true,"h":true,"j":["good","agree","yes","blue-square"],"k":[0,27],"o":2},"clock11":{"a":"Clock Face Eleven Oclock","b":"1F55A","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[28,49],"o":2},"construction_worker":{"skin_variations":{"1F3FB":{"unified":"1F477-1F3FB","non_qualified":null,"image":"1f477-1f3fb.png","sheet_x":23,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F477-1F3FC","non_qualified":null,"image":"1f477-1f3fc.png","sheet_x":23,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F477-1F3FD","non_qualified":null,"image":"1f477-1f3fd.png","sheet_x":23,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F477-1F3FE","non_qualified":null,"image":"1f477-1f3fe.png","sheet_x":23,"sheet_y":26,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F477-1F3FF","non_qualified":null,"image":"1f477-1f3ff.png","sheet_x":23,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F477-200D-2642-FE0F","a":"Construction Worker","b":"1F477","d":true,"e":true,"f":true,"h":false,"k":[23,22],"o":2},"male-construction-worker":{"skin_variations":{"1F3FB":{"unified":"1F477-1F3FB-200D-2642-FE0F","non_qualified":"1F477-1F3FB-200D-2642","image":"1f477-1f3fb-200d-2642-fe0f.png","sheet_x":23,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F477-1F3FC-200D-2642-FE0F","non_qualified":"1F477-1F3FC-200D-2642","image":"1f477-1f3fc-200d-2642-fe0f.png","sheet_x":23,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F477-1F3FD-200D-2642-FE0F","non_qualified":"1F477-1F3FD-200D-2642","image":"1f477-1f3fd-200d-2642-fe0f.png","sheet_x":23,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F477-1F3FE-200D-2642-FE0F","non_qualified":"1F477-1F3FE-200D-2642","image":"1f477-1f3fe-200d-2642-fe0f.png","sheet_x":23,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F477-1F3FF-200D-2642-FE0F","non_qualified":"1F477-1F3FF-200D-2642","image":"1f477-1f3ff-200d-2642-fe0f.png","sheet_x":23,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F477","a":"Male Construction Worker","b":"1F477-200D-2642-FE0F","c":"1F477-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[23,16],"o":4},"clock1130":{"a":"Clock Face Eleven-Thirty","b":"1F566","d":true,"e":true,"f":true,"h":true,"j":["time","late","early","schedule"],"k":[29,4],"o":2},"flag-mq":{"a":"Martinique Flag","b":"1F1F2-1F1F6","d":true,"e":true,"f":true,"h":true,"k":[3,15],"o":2},"bar_chart":{"a":"Bar Chart","b":"1F4CA","d":true,"e":true,"f":true,"h":true,"j":["graph","presentation","stats"],"k":[26,32],"o":2},"parking":{"a":"Negative Squared Latin Capital Letter P","b":"1F17F-FE0F","c":"1F17F","d":true,"e":true,"f":true,"h":true,"j":["cars","blue-square","alphabet","letter"],"k":[0,19],"o":2},"new_moon":{"a":"New Moon Symbol","b":"1F311","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,36],"o":2},"female-construction-worker":{"skin_variations":{"1F3FB":{"unified":"1F477-1F3FB-200D-2640-FE0F","non_qualified":"1F477-1F3FB-200D-2640","image":"1f477-1f3fb-200d-2640-fe0f.png","sheet_x":23,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F477-1F3FC-200D-2640-FE0F","non_qualified":"1F477-1F3FC-200D-2640","image":"1f477-1f3fc-200d-2640-fe0f.png","sheet_x":23,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F477-1F3FD-200D-2640-FE0F","non_qualified":"1F477-1F3FD-200D-2640","image":"1f477-1f3fd-200d-2640-fe0f.png","sheet_x":23,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F477-1F3FE-200D-2640-FE0F","non_qualified":"1F477-1F3FE-200D-2640","image":"1f477-1f3fe-200d-2640-fe0f.png","sheet_x":23,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F477-1F3FF-200D-2640-FE0F","non_qualified":"1F477-1F3FF-200D-2640","image":"1f477-1f3ff-200d-2640-fe0f.png","sheet_x":23,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Construction Worker","b":"1F477-200D-2640-FE0F","c":"1F477-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[23,10],"o":4},"sos":{"a":"Squared Sos","b":"1F198","d":true,"e":true,"f":true,"h":true,"j":["help","red-square","words","emergency","911"],"k":[0,28],"o":2},"clipboard":{"a":"Clipboard","b":"1F4CB","d":true,"e":true,"f":true,"h":true,"j":["stationery","documents"],"k":[26,33],"o":2},"flag-mr":{"a":"Mauritania Flag","b":"1F1F2-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[3,16],"o":2},"prince":{"skin_variations":{"1F3FB":{"unified":"1F934-1F3FB","non_qualified":null,"image":"1f934-1f3fb.png","sheet_x":39,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F934-1F3FC","non_qualified":null,"image":"1f934-1f3fc.png","sheet_x":39,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F934-1F3FD","non_qualified":null,"image":"1f934-1f3fd.png","sheet_x":39,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F934-1F3FE","non_qualified":null,"image":"1f934-1f3fe.png","sheet_x":39,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F934-1F3FF","non_qualified":null,"image":"1f934-1f3ff.png","sheet_x":39,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Prince","b":"1F934","d":true,"e":true,"f":true,"h":true,"j":["boy","man","male","crown","royal","king"],"k":[39,17],"o":4},"waxing_crescent_moon":{"a":"Waxing Crescent Moon Symbol","b":"1F312","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,37],"o":2},"flag-ms":{"a":"Montserrat Flag","b":"1F1F2-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[3,17],"o":2},"pushpin":{"a":"Pushpin","b":"1F4CC","d":true,"e":true,"f":true,"h":true,"j":["stationery","mark","here"],"k":[26,34],"o":2},"up":{"a":"Squared Up with Exclamation Mark","b":"1F199","d":true,"e":true,"f":true,"h":true,"j":["blue-square","above","high"],"k":[0,29],"o":2},"flag-mt":{"a":"Malta Flag","b":"1F1F2-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[3,18],"o":2},"princess":{"skin_variations":{"1F3FB":{"unified":"1F478-1F3FB","non_qualified":null,"image":"1f478-1f3fb.png","sheet_x":23,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F478-1F3FC","non_qualified":null,"image":"1f478-1f3fc.png","sheet_x":23,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F478-1F3FD","non_qualified":null,"image":"1f478-1f3fd.png","sheet_x":23,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F478-1F3FE","non_qualified":null,"image":"1f478-1f3fe.png","sheet_x":23,"sheet_y":32,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F478-1F3FF","non_qualified":null,"image":"1f478-1f3ff.png","sheet_x":23,"sheet_y":33,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Princess","b":"1F478","d":true,"e":true,"f":true,"h":true,"j":["girl","woman","female","blond","crown","royal","queen"],"k":[23,28],"o":2},"round_pushpin":{"a":"Round Pushpin","b":"1F4CD","d":true,"e":true,"f":true,"h":true,"j":["stationery","location","map","here"],"k":[26,35],"o":2},"first_quarter_moon":{"a":"First Quarter Moon Symbol","b":"1F313","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,38],"o":2},"vs":{"a":"Squared Vs","b":"1F19A","d":true,"e":true,"f":true,"h":true,"j":["words","orange-square"],"k":[0,30],"o":2},"flag-mu":{"a":"Mauritius Flag","b":"1F1F2-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[3,19],"o":2},"koko":{"a":"Squared Katakana Koko","b":"1F201","d":true,"e":true,"f":true,"h":true,"j":["blue-square","here","katakana","japanese","destination"],"k":[5,4],"o":2},"man_with_turban":{"skin_variations":{"1F3FB":{"unified":"1F473-1F3FB","non_qualified":null,"image":"1f473-1f3fb.png","sheet_x":22,"sheet_y":44,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F473-1F3FC","non_qualified":null,"image":"1f473-1f3fc.png","sheet_x":22,"sheet_y":45,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F473-1F3FD","non_qualified":null,"image":"1f473-1f3fd.png","sheet_x":22,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F473-1F3FE","non_qualified":null,"image":"1f473-1f3fe.png","sheet_x":22,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F473-1F3FF","non_qualified":null,"image":"1f473-1f3ff.png","sheet_x":22,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F473-200D-2642-FE0F","a":"Man with Turban","b":"1F473","d":true,"e":true,"f":true,"h":false,"j":["male","indian","hinduism","arabs"],"k":[22,43],"o":2},"moon":{"a":"Waxing Gibbous Moon Symbol","b":"1F314","d":true,"e":true,"f":true,"h":true,"k":[5,39],"n":["waxing_gibbous_moon"],"o":2},"paperclip":{"a":"Paperclip","b":"1F4CE","d":true,"e":true,"f":true,"h":true,"j":["documents","stationery"],"k":[26,36],"o":2},"linked_paperclips":{"a":"Linked Paperclips","b":"1F587-FE0F","c":"1F587","d":true,"e":true,"f":true,"h":true,"k":[29,43],"o":2},"man-wearing-turban":{"skin_variations":{"1F3FB":{"unified":"1F473-1F3FB-200D-2642-FE0F","non_qualified":"1F473-1F3FB-200D-2642","image":"1f473-1f3fb-200d-2642-fe0f.png","sheet_x":22,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F473-1F3FC-200D-2642-FE0F","non_qualified":"1F473-1F3FC-200D-2642","image":"1f473-1f3fc-200d-2642-fe0f.png","sheet_x":22,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F473-1F3FD-200D-2642-FE0F","non_qualified":"1F473-1F3FD-200D-2642","image":"1f473-1f3fd-200d-2642-fe0f.png","sheet_x":22,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F473-1F3FE-200D-2642-FE0F","non_qualified":"1F473-1F3FE-200D-2642","image":"1f473-1f3fe-200d-2642-fe0f.png","sheet_x":22,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F473-1F3FF-200D-2642-FE0F","non_qualified":"1F473-1F3FF-200D-2642","image":"1f473-1f3ff-200d-2642-fe0f.png","sheet_x":22,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F473","a":"Man Wearing Turban","b":"1F473-200D-2642-FE0F","c":"1F473-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[22,37],"o":4},"sa":{"a":"Squared Katakana Sa","b":"1F202-FE0F","c":"1F202","d":true,"e":true,"f":true,"h":true,"j":["japanese","blue-square","katakana"],"k":[5,5],"o":2},"full_moon":{"a":"Full Moon Symbol","b":"1F315","d":true,"e":true,"f":true,"h":true,"j":["nature","yellow","twilight","planet","space","night","evening","sleep"],"k":[5,40],"o":2},"flag-mv":{"a":"Maldives Flag","b":"1F1F2-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[3,20],"o":2},"flag-mw":{"a":"Malawi Flag","b":"1F1F2-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[3,21],"o":2},"waning_gibbous_moon":{"a":"Waning Gibbous Moon Symbol","b":"1F316","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep","waxing_gibbous_moon"],"k":[5,41],"o":2},"woman-wearing-turban":{"skin_variations":{"1F3FB":{"unified":"1F473-1F3FB-200D-2640-FE0F","non_qualified":"1F473-1F3FB-200D-2640","image":"1f473-1f3fb-200d-2640-fe0f.png","sheet_x":22,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F473-1F3FC-200D-2640-FE0F","non_qualified":"1F473-1F3FC-200D-2640","image":"1f473-1f3fc-200d-2640-fe0f.png","sheet_x":22,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F473-1F3FD-200D-2640-FE0F","non_qualified":"1F473-1F3FD-200D-2640","image":"1f473-1f3fd-200d-2640-fe0f.png","sheet_x":22,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F473-1F3FE-200D-2640-FE0F","non_qualified":"1F473-1F3FE-200D-2640","image":"1f473-1f3fe-200d-2640-fe0f.png","sheet_x":22,"sheet_y":35,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F473-1F3FF-200D-2640-FE0F","non_qualified":"1F473-1F3FF-200D-2640","image":"1f473-1f3ff-200d-2640-fe0f.png","sheet_x":22,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Wearing Turban","b":"1F473-200D-2640-FE0F","c":"1F473-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[22,31],"o":4},"u6708":{"a":"Squared Cjk Unified Ideograph-6708","b":"1F237-FE0F","c":"1F237","d":true,"e":true,"f":true,"h":true,"j":["chinese","month","moon","japanese","orange-square","kanji"],"k":[5,13],"o":2},"straight_ruler":{"a":"Straight Ruler","b":"1F4CF","d":true,"e":true,"f":true,"h":true,"j":["stationery","calculate","length","math","school","drawing","architect","sketch"],"k":[26,37],"o":2},"u6709":{"a":"Squared Cjk Unified Ideograph-6709","b":"1F236","d":true,"e":true,"f":true,"h":true,"j":["orange-square","chinese","have","kanji"],"k":[5,12],"o":2},"triangular_ruler":{"a":"Triangular Ruler","b":"1F4D0","d":true,"e":true,"f":true,"h":true,"j":["stationery","math","architect","sketch"],"k":[26,38],"o":2},"man_with_gua_pi_mao":{"skin_variations":{"1F3FB":{"unified":"1F472-1F3FB","non_qualified":null,"image":"1f472-1f3fb.png","sheet_x":22,"sheet_y":26,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F472-1F3FC","non_qualified":null,"image":"1f472-1f3fc.png","sheet_x":22,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F472-1F3FD","non_qualified":null,"image":"1f472-1f3fd.png","sheet_x":22,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F472-1F3FE","non_qualified":null,"image":"1f472-1f3fe.png","sheet_x":22,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F472-1F3FF","non_qualified":null,"image":"1f472-1f3ff.png","sheet_x":22,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man with Gua Pi Mao","b":"1F472","d":true,"e":true,"f":true,"h":true,"j":["male","boy","chinese"],"k":[22,25],"o":2},"flag-mx":{"a":"Mexico Flag","b":"1F1F2-1F1FD","d":true,"e":true,"f":true,"h":true,"k":[3,22],"o":2},"last_quarter_moon":{"a":"Last Quarter Moon Symbol","b":"1F317","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,42],"o":2},"person_with_headscarf":{"skin_variations":{"1F3FB":{"unified":"1F9D5-1F3FB","non_qualified":null,"image":"1f9d5-1f3fb.png","sheet_x":48,"sheet_y":35,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D5-1F3FC","non_qualified":null,"image":"1f9d5-1f3fc.png","sheet_x":48,"sheet_y":36,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D5-1F3FD","non_qualified":null,"image":"1f9d5-1f3fd.png","sheet_x":48,"sheet_y":37,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D5-1F3FE","non_qualified":null,"image":"1f9d5-1f3fe.png","sheet_x":48,"sheet_y":38,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D5-1F3FF","non_qualified":null,"image":"1f9d5-1f3ff.png","sheet_x":48,"sheet_y":39,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Person with Headscarf","b":"1F9D5","d":true,"e":true,"f":true,"h":true,"k":[48,34],"o":5},"waning_crescent_moon":{"a":"Waning Crescent Moon Symbol","b":"1F318","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,43],"o":2},"u6307":{"a":"Squared Cjk Unified Ideograph-6307","b":"1F22F","d":true,"e":true,"f":true,"h":true,"j":["chinese","point","green-square","kanji"],"k":[5,7],"o":2},"scissors":{"a":"Black Scissors","b":"2702-FE0F","c":"2702","d":true,"e":true,"f":true,"h":true,"j":["stationery","cut"],"k":[54,39],"o":2},"flag-my":{"a":"Malaysia Flag","b":"1F1F2-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[3,23],"o":2},"ideograph_advantage":{"a":"Circled Ideograph Advantage","b":"1F250","d":true,"e":true,"f":true,"h":true,"j":["chinese","kanji","obtain","get","circle"],"k":[5,17],"o":2},"man_in_tuxedo":{"skin_variations":{"1F3FB":{"unified":"1F935-1F3FB","non_qualified":null,"image":"1f935-1f3fb.png","sheet_x":39,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F935-1F3FC","non_qualified":null,"image":"1f935-1f3fc.png","sheet_x":39,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F935-1F3FD","non_qualified":null,"image":"1f935-1f3fd.png","sheet_x":39,"sheet_y":26,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F935-1F3FE","non_qualified":null,"image":"1f935-1f3fe.png","sheet_x":39,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F935-1F3FF","non_qualified":null,"image":"1f935-1f3ff.png","sheet_x":39,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man in Tuxedo","b":"1F935","d":true,"e":true,"f":true,"h":true,"j":["couple","marriage","wedding","groom"],"k":[39,23],"o":4},"flag-mz":{"a":"Mozambique Flag","b":"1F1F2-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[3,24],"o":2},"card_file_box":{"a":"Card File Box","b":"1F5C3-FE0F","c":"1F5C3","d":true,"e":true,"f":true,"h":true,"j":["business","stationery"],"k":[30,16],"o":2},"crescent_moon":{"a":"Crescent Moon","b":"1F319","d":true,"e":true,"f":true,"h":true,"j":["night","sleep","sky","evening","magic"],"k":[5,44],"o":2},"flag-na":{"a":"Namibia Flag","b":"1F1F3-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[3,25],"o":2},"bride_with_veil":{"skin_variations":{"1F3FB":{"unified":"1F470-1F3FB","non_qualified":null,"image":"1f470-1f3fb.png","sheet_x":22,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F470-1F3FC","non_qualified":null,"image":"1f470-1f3fc.png","sheet_x":22,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F470-1F3FD","non_qualified":null,"image":"1f470-1f3fd.png","sheet_x":22,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F470-1F3FE","non_qualified":null,"image":"1f470-1f3fe.png","sheet_x":22,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F470-1F3FF","non_qualified":null,"image":"1f470-1f3ff.png","sheet_x":22,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Bride with Veil","b":"1F470","d":true,"e":true,"f":true,"h":true,"j":["couple","marriage","wedding","woman","bride"],"k":[22,1],"o":2},"new_moon_with_face":{"a":"New Moon with Face","b":"1F31A","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,45],"o":2},"file_cabinet":{"a":"File Cabinet","b":"1F5C4-FE0F","c":"1F5C4","d":true,"e":true,"f":true,"h":true,"j":["filing","organizing"],"k":[30,17],"o":2},"u5272":{"a":"Squared Cjk Unified Ideograph-5272","b":"1F239","d":true,"e":true,"f":true,"h":true,"j":["cut","divide","chinese","kanji","pink-square"],"k":[5,15],"o":2},"wastebasket":{"a":"Wastebasket","b":"1F5D1-FE0F","c":"1F5D1","d":true,"e":true,"f":true,"h":true,"j":["bin","trash","rubbish","garbage","toss"],"k":[30,18],"o":2},"pregnant_woman":{"skin_variations":{"1F3FB":{"unified":"1F930-1F3FB","non_qualified":null,"image":"1f930-1f3fb.png","sheet_x":38,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F930-1F3FC","non_qualified":null,"image":"1f930-1f3fc.png","sheet_x":38,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F930-1F3FD","non_qualified":null,"image":"1f930-1f3fd.png","sheet_x":38,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F930-1F3FE","non_qualified":null,"image":"1f930-1f3fe.png","sheet_x":38,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F930-1F3FF","non_qualified":null,"image":"1f930-1f3ff.png","sheet_x":38,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Pregnant Woman","b":"1F930","d":true,"e":true,"f":true,"h":true,"j":["baby"],"k":[38,50],"o":4},"first_quarter_moon_with_face":{"a":"First Quarter Moon with Face","b":"1F31B","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,46],"o":2},"flag-nc":{"a":"New Caledonia Flag","b":"1F1F3-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[3,26],"o":2},"u7121":{"a":"Squared Cjk Unified Ideograph-7121","b":"1F21A","d":true,"e":true,"f":true,"h":true,"j":["nothing","chinese","kanji","japanese","orange-square"],"k":[5,6],"o":2},"lock":{"a":"Lock","b":"1F512","d":true,"e":true,"f":true,"h":true,"j":["security","password","padlock"],"k":[27,46],"o":2},"flag-ne":{"a":"Niger Flag","b":"1F1F3-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[3,27],"o":2},"last_quarter_moon_with_face":{"a":"Last Quarter Moon with Face","b":"1F31C","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,47],"o":2},"breast-feeding":{"skin_variations":{"1F3FB":{"unified":"1F931-1F3FB","non_qualified":null,"image":"1f931-1f3fb.png","sheet_x":39,"sheet_y":0,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F931-1F3FC","non_qualified":null,"image":"1f931-1f3fc.png","sheet_x":39,"sheet_y":1,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F931-1F3FD","non_qualified":null,"image":"1f931-1f3fd.png","sheet_x":39,"sheet_y":2,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F931-1F3FE","non_qualified":null,"image":"1f931-1f3fe.png","sheet_x":39,"sheet_y":3,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F931-1F3FF","non_qualified":null,"image":"1f931-1f3ff.png","sheet_x":39,"sheet_y":4,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Breast-Feeding","b":"1F931","d":true,"e":true,"f":true,"h":true,"k":[38,56],"o":5},"u7981":{"a":"Squared Cjk Unified Ideograph-7981","b":"1F232","d":true,"e":true,"f":true,"h":true,"j":["kanji","japanese","chinese","forbidden","limit","restricted","red-square"],"k":[5,8],"o":2},"accept":{"a":"Circled Ideograph Accept","b":"1F251","d":true,"e":true,"f":true,"h":true,"j":["ok","good","chinese","kanji","agree","yes","orange-circle"],"k":[5,18],"o":2},"angel":{"skin_variations":{"1F3FB":{"unified":"1F47C-1F3FB","non_qualified":null,"image":"1f47c-1f3fb.png","sheet_x":23,"sheet_y":38,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F47C-1F3FC","non_qualified":null,"image":"1f47c-1f3fc.png","sheet_x":23,"sheet_y":39,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F47C-1F3FD","non_qualified":null,"image":"1f47c-1f3fd.png","sheet_x":23,"sheet_y":40,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F47C-1F3FE","non_qualified":null,"image":"1f47c-1f3fe.png","sheet_x":23,"sheet_y":41,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F47C-1F3FF","non_qualified":null,"image":"1f47c-1f3ff.png","sheet_x":23,"sheet_y":42,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Baby Angel","b":"1F47C","d":true,"e":true,"f":true,"h":true,"j":["heaven","wings","halo"],"k":[23,37],"o":2},"unlock":{"a":"Open Lock","b":"1F513","d":true,"e":true,"f":true,"h":true,"j":["privacy","security"],"k":[27,47],"o":2},"flag-nf":{"a":"Norfolk Island Flag","b":"1F1F3-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[3,28],"o":2},"thermometer":{"a":"Thermometer","b":"1F321-FE0F","c":"1F321","d":true,"e":true,"f":true,"h":true,"j":["weather","temperature","hot","cold"],"k":[5,52],"o":2},"flag-ng":{"a":"Nigeria Flag","b":"1F1F3-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[3,29],"o":2},"u7533":{"a":"Squared Cjk Unified Ideograph-7533","b":"1F238","d":true,"e":true,"f":true,"h":true,"j":["chinese","japanese","kanji","orange-square"],"k":[5,14],"o":2},"sunny":{"a":"Black Sun with Rays","b":"2600-FE0F","c":"2600","d":true,"e":true,"f":true,"h":true,"j":["weather","nature","brightness","summer","beach","spring"],"k":[52,49],"o":2},"lock_with_ink_pen":{"a":"Lock with Ink Pen","b":"1F50F","d":true,"e":true,"f":true,"h":true,"j":["security","secret"],"k":[27,43],"o":2},"santa":{"skin_variations":{"1F3FB":{"unified":"1F385-1F3FB","non_qualified":null,"image":"1f385-1f3fb.png","sheet_x":7,"sheet_y":37,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F385-1F3FC","non_qualified":null,"image":"1f385-1f3fc.png","sheet_x":7,"sheet_y":38,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F385-1F3FD","non_qualified":null,"image":"1f385-1f3fd.png","sheet_x":7,"sheet_y":39,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F385-1F3FE","non_qualified":null,"image":"1f385-1f3fe.png","sheet_x":7,"sheet_y":40,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F385-1F3FF","non_qualified":null,"image":"1f385-1f3ff.png","sheet_x":7,"sheet_y":41,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Father Christmas","b":"1F385","d":true,"e":true,"f":true,"h":true,"j":["festival","man","male","xmas","father christmas"],"k":[7,36],"o":2},"closed_lock_with_key":{"a":"Closed Lock with Key","b":"1F510","d":true,"e":true,"f":true,"h":true,"j":["security","privacy"],"k":[27,44],"o":2},"u5408":{"a":"Squared Cjk Unified Ideograph-5408","b":"1F234","d":true,"e":true,"f":true,"h":true,"j":["japanese","chinese","join","kanji","red-square"],"k":[5,10],"o":2},"flag-ni":{"a":"Nicaragua Flag","b":"1F1F3-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[3,30],"o":2},"mrs_claus":{"skin_variations":{"1F3FB":{"unified":"1F936-1F3FB","non_qualified":null,"image":"1f936-1f3fb.png","sheet_x":39,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F936-1F3FC","non_qualified":null,"image":"1f936-1f3fc.png","sheet_x":39,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F936-1F3FD","non_qualified":null,"image":"1f936-1f3fd.png","sheet_x":39,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F936-1F3FE","non_qualified":null,"image":"1f936-1f3fe.png","sheet_x":39,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F936-1F3FF","non_qualified":null,"image":"1f936-1f3ff.png","sheet_x":39,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Mother Christmas","b":"1F936","d":true,"e":true,"f":true,"h":true,"j":["woman","female","xmas","mother christmas"],"k":[39,29],"n":["mother_christmas"],"o":4},"full_moon_with_face":{"a":"Full Moon with Face","b":"1F31D","d":true,"e":true,"f":true,"h":true,"j":["nature","twilight","planet","space","night","evening","sleep"],"k":[5,48],"o":2},"key":{"a":"Key","b":"1F511","d":true,"e":true,"f":true,"h":true,"j":["lock","door","password"],"k":[27,45],"o":2},"superhero":{"skin_variations":{"1F3FB":{"unified":"1F9B8-1F3FB","non_qualified":null,"image":"1f9b8-1f3fb.png","sheet_x":43,"sheet_y":31,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B8-1F3FC","non_qualified":null,"image":"1f9b8-1f3fc.png","sheet_x":43,"sheet_y":32,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B8-1F3FD","non_qualified":null,"image":"1f9b8-1f3fd.png","sheet_x":43,"sheet_y":33,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B8-1F3FE","non_qualified":null,"image":"1f9b8-1f3fe.png","sheet_x":43,"sheet_y":34,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B8-1F3FF","non_qualified":null,"image":"1f9b8-1f3ff.png","sheet_x":43,"sheet_y":35,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Superhero","b":"1F9B8","d":true,"e":true,"f":true,"h":true,"k":[43,30],"o":11},"flag-nl":{"a":"Netherlands Flag","b":"1F1F3-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[3,31],"o":2},"u7a7a":{"a":"Squared Cjk Unified Ideograph-7a7a","b":"1F233","d":true,"e":true,"f":true,"h":true,"j":["kanji","japanese","chinese","empty","sky","blue-square"],"k":[5,9],"o":2},"sun_with_face":{"a":"Sun with Face","b":"1F31E","d":true,"e":true,"f":true,"h":true,"j":["nature","morning","sky"],"k":[5,49],"o":2},"male_superhero":{"skin_variations":{"1F3FB":{"unified":"1F9B8-1F3FB-200D-2642-FE0F","non_qualified":"1F9B8-1F3FB-200D-2642","image":"1f9b8-1f3fb-200d-2642-fe0f.png","sheet_x":43,"sheet_y":25,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B8-1F3FC-200D-2642-FE0F","non_qualified":"1F9B8-1F3FC-200D-2642","image":"1f9b8-1f3fc-200d-2642-fe0f.png","sheet_x":43,"sheet_y":26,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B8-1F3FD-200D-2642-FE0F","non_qualified":"1F9B8-1F3FD-200D-2642","image":"1f9b8-1f3fd-200d-2642-fe0f.png","sheet_x":43,"sheet_y":27,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B8-1F3FE-200D-2642-FE0F","non_qualified":"1F9B8-1F3FE-200D-2642","image":"1f9b8-1f3fe-200d-2642-fe0f.png","sheet_x":43,"sheet_y":28,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B8-1F3FF-200D-2642-FE0F","non_qualified":"1F9B8-1F3FF-200D-2642","image":"1f9b8-1f3ff-200d-2642-fe0f.png","sheet_x":43,"sheet_y":29,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Superhero","b":"1F9B8-200D-2642-FE0F","c":"1F9B8-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[43,24],"o":11},"ringed_planet":{"a":"Ringed Planet","b":"1FA90","d":true,"e":true,"f":true,"h":true,"k":[52,4],"o":12},"old_key":{"a":"Old Key","b":"1F5DD-FE0F","c":"1F5DD","d":true,"e":true,"f":true,"h":true,"j":["lock","door","password"],"k":[30,22],"o":2},"congratulations":{"a":"Circled Ideograph Congratulation","b":"3297-FE0F","c":"3297","d":true,"e":true,"f":true,"h":true,"j":["chinese","kanji","japanese","red-circle"],"k":[55,46],"o":2},"flag-no":{"a":"Norway Flag","b":"1F1F3-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[3,32],"o":2},"star":{"a":"White Medium Star","b":"2B50","d":true,"e":true,"f":true,"h":true,"j":["night","yellow"],"k":[55,42],"o":2},"secret":{"a":"Circled Ideograph Secret","b":"3299-FE0F","c":"3299","d":true,"e":true,"f":true,"h":true,"j":["privacy","chinese","sshh","kanji","red-circle"],"k":[55,47],"o":2},"flag-np":{"a":"Nepal Flag","b":"1F1F3-1F1F5","d":true,"e":true,"f":true,"h":true,"k":[3,33],"o":2},"female_superhero":{"skin_variations":{"1F3FB":{"unified":"1F9B8-1F3FB-200D-2640-FE0F","non_qualified":"1F9B8-1F3FB-200D-2640","image":"1f9b8-1f3fb-200d-2640-fe0f.png","sheet_x":43,"sheet_y":19,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B8-1F3FC-200D-2640-FE0F","non_qualified":"1F9B8-1F3FC-200D-2640","image":"1f9b8-1f3fc-200d-2640-fe0f.png","sheet_x":43,"sheet_y":20,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B8-1F3FD-200D-2640-FE0F","non_qualified":"1F9B8-1F3FD-200D-2640","image":"1f9b8-1f3fd-200d-2640-fe0f.png","sheet_x":43,"sheet_y":21,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B8-1F3FE-200D-2640-FE0F","non_qualified":"1F9B8-1F3FE-200D-2640","image":"1f9b8-1f3fe-200d-2640-fe0f.png","sheet_x":43,"sheet_y":22,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B8-1F3FF-200D-2640-FE0F","non_qualified":"1F9B8-1F3FF-200D-2640","image":"1f9b8-1f3ff-200d-2640-fe0f.png","sheet_x":43,"sheet_y":23,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Superhero","b":"1F9B8-200D-2640-FE0F","c":"1F9B8-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[43,18],"o":11},"hammer":{"a":"Hammer","b":"1F528","d":true,"e":true,"f":true,"h":true,"j":["tools","build","create"],"k":[28,11],"o":2},"star2":{"a":"Glowing Star","b":"1F31F","d":true,"e":true,"f":true,"h":true,"j":["night","sparkle","awesome","good","magic"],"k":[5,50],"o":2},"flag-nr":{"a":"Nauru Flag","b":"1F1F3-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[3,34],"o":2},"axe":{"a":"Axe","b":"1FA93","d":true,"e":true,"f":true,"h":true,"k":[52,7],"o":12},"u55b6":{"a":"Squared Cjk Unified Ideograph-55b6","b":"1F23A","d":true,"e":true,"f":true,"h":true,"j":["japanese","opening hours","orange-square"],"k":[5,16],"o":2},"supervillain":{"skin_variations":{"1F3FB":{"unified":"1F9B9-1F3FB","non_qualified":null,"image":"1f9b9-1f3fb.png","sheet_x":43,"sheet_y":49,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B9-1F3FC","non_qualified":null,"image":"1f9b9-1f3fc.png","sheet_x":43,"sheet_y":50,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B9-1F3FD","non_qualified":null,"image":"1f9b9-1f3fd.png","sheet_x":43,"sheet_y":51,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B9-1F3FE","non_qualified":null,"image":"1f9b9-1f3fe.png","sheet_x":43,"sheet_y":52,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B9-1F3FF","non_qualified":null,"image":"1f9b9-1f3ff.png","sheet_x":43,"sheet_y":53,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Supervillain","b":"1F9B9","d":true,"e":true,"f":true,"h":true,"k":[43,48],"o":11},"stars":{"a":"Shooting Star","b":"1F320","d":true,"e":true,"f":true,"h":true,"j":["night","photo"],"k":[5,51],"o":2},"u6e80":{"a":"Squared Cjk Unified Ideograph-6e80","b":"1F235","d":true,"e":true,"f":true,"h":true,"j":["full","chinese","japanese","red-square","kanji"],"k":[5,11],"o":2},"flag-nu":{"a":"Niue Flag","b":"1F1F3-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[3,35],"o":2},"pick":{"a":"Pick","b":"26CF-FE0F","c":"26CF","d":true,"e":true,"f":true,"h":true,"j":["tools","dig"],"k":[54,5],"o":2},"male_supervillain":{"skin_variations":{"1F3FB":{"unified":"1F9B9-1F3FB-200D-2642-FE0F","non_qualified":"1F9B9-1F3FB-200D-2642","image":"1f9b9-1f3fb-200d-2642-fe0f.png","sheet_x":43,"sheet_y":43,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B9-1F3FC-200D-2642-FE0F","non_qualified":"1F9B9-1F3FC-200D-2642","image":"1f9b9-1f3fc-200d-2642-fe0f.png","sheet_x":43,"sheet_y":44,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B9-1F3FD-200D-2642-FE0F","non_qualified":"1F9B9-1F3FD-200D-2642","image":"1f9b9-1f3fd-200d-2642-fe0f.png","sheet_x":43,"sheet_y":45,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B9-1F3FE-200D-2642-FE0F","non_qualified":"1F9B9-1F3FE-200D-2642","image":"1f9b9-1f3fe-200d-2642-fe0f.png","sheet_x":43,"sheet_y":46,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B9-1F3FF-200D-2642-FE0F","non_qualified":"1F9B9-1F3FF-200D-2642","image":"1f9b9-1f3ff-200d-2642-fe0f.png","sheet_x":43,"sheet_y":47,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Supervillain","b":"1F9B9-200D-2642-FE0F","c":"1F9B9-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[43,42],"o":11},"female_supervillain":{"skin_variations":{"1F3FB":{"unified":"1F9B9-1F3FB-200D-2640-FE0F","non_qualified":"1F9B9-1F3FB-200D-2640","image":"1f9b9-1f3fb-200d-2640-fe0f.png","sheet_x":43,"sheet_y":37,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9B9-1F3FC-200D-2640-FE0F","non_qualified":"1F9B9-1F3FC-200D-2640","image":"1f9b9-1f3fc-200d-2640-fe0f.png","sheet_x":43,"sheet_y":38,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9B9-1F3FD-200D-2640-FE0F","non_qualified":"1F9B9-1F3FD-200D-2640","image":"1f9b9-1f3fd-200d-2640-fe0f.png","sheet_x":43,"sheet_y":39,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9B9-1F3FE-200D-2640-FE0F","non_qualified":"1F9B9-1F3FE-200D-2640","image":"1f9b9-1f3fe-200d-2640-fe0f.png","sheet_x":43,"sheet_y":40,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9B9-1F3FF-200D-2640-FE0F","non_qualified":"1F9B9-1F3FF-200D-2640","image":"1f9b9-1f3ff-200d-2640-fe0f.png","sheet_x":43,"sheet_y":41,"added_in":"11.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Supervillain","b":"1F9B9-200D-2640-FE0F","c":"1F9B9-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[43,36],"o":11},"hammer_and_pick":{"a":"Hammer and Pick","b":"2692-FE0F","c":"2692","d":true,"e":true,"f":true,"h":true,"j":["tools","build","create"],"k":[53,41],"o":2},"milky_way":{"a":"Milky Way","b":"1F30C","d":true,"e":true,"f":true,"h":true,"j":["photo","space","stars"],"k":[5,31],"o":2},"red_circle":{"a":"Large Red Circle","b":"1F534","d":true,"e":true,"f":true,"h":true,"j":["shape","error","danger"],"k":[28,23],"o":2},"flag-nz":{"a":"New Zealand Flag","b":"1F1F3-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[3,36],"o":2},"large_orange_circle":{"a":"Large Orange Circle","b":"1F7E0","d":true,"e":true,"f":true,"h":true,"k":[37,3],"o":12},"hammer_and_wrench":{"a":"Hammer and Wrench","b":"1F6E0-FE0F","c":"1F6E0","d":true,"e":true,"f":true,"h":true,"j":["tools","build","create"],"k":[36,42],"o":2},"flag-om":{"a":"Oman Flag","b":"1F1F4-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[3,37],"o":2},"cloud":{"a":"Cloud","b":"2601-FE0F","c":"2601","d":true,"e":true,"f":true,"h":true,"j":["weather","sky"],"k":[52,50],"o":2},"mage":{"skin_variations":{"1F3FB":{"unified":"1F9D9-1F3FB","non_qualified":null,"image":"1f9d9-1f3fb.png","sheet_x":49,"sheet_y":50,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D9-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9D9-1F3FC","non_qualified":null,"image":"1f9d9-1f3fc.png","sheet_x":49,"sheet_y":51,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D9-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9D9-1F3FD","non_qualified":null,"image":"1f9d9-1f3fd.png","sheet_x":49,"sheet_y":52,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D9-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9D9-1F3FE","non_qualified":null,"image":"1f9d9-1f3fe.png","sheet_x":49,"sheet_y":53,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D9-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9D9-1F3FF","non_qualified":null,"image":"1f9d9-1f3ff.png","sheet_x":49,"sheet_y":54,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D9-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9D9-200D-2640-FE0F","a":"Mage","b":"1F9D9","d":true,"e":true,"f":true,"h":true,"k":[49,49],"o":5},"dagger_knife":{"a":"Dagger Knife","b":"1F5E1-FE0F","c":"1F5E1","d":true,"e":true,"f":true,"h":true,"k":[30,24],"o":2},"partly_sunny":{"a":"Sun Behind Cloud","b":"26C5","d":true,"e":true,"f":true,"h":true,"j":["weather","nature","cloudy","morning","fall","spring"],"k":[54,2],"o":2},"large_yellow_circle":{"a":"Large Yellow Circle","b":"1F7E1","d":true,"e":true,"f":true,"h":true,"k":[37,4],"o":12},"male_mage":{"skin_variations":{"1F3FB":{"unified":"1F9D9-1F3FB-200D-2642-FE0F","non_qualified":"1F9D9-1F3FB-200D-2642","image":"1f9d9-1f3fb-200d-2642-fe0f.png","sheet_x":49,"sheet_y":44,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D9-1F3FC-200D-2642-FE0F","non_qualified":"1F9D9-1F3FC-200D-2642","image":"1f9d9-1f3fc-200d-2642-fe0f.png","sheet_x":49,"sheet_y":45,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D9-1F3FD-200D-2642-FE0F","non_qualified":"1F9D9-1F3FD-200D-2642","image":"1f9d9-1f3fd-200d-2642-fe0f.png","sheet_x":49,"sheet_y":46,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D9-1F3FE-200D-2642-FE0F","non_qualified":"1F9D9-1F3FE-200D-2642","image":"1f9d9-1f3fe-200d-2642-fe0f.png","sheet_x":49,"sheet_y":47,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D9-1F3FF-200D-2642-FE0F","non_qualified":"1F9D9-1F3FF-200D-2642","image":"1f9d9-1f3ff-200d-2642-fe0f.png","sheet_x":49,"sheet_y":48,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Mage","b":"1F9D9-200D-2642-FE0F","c":"1F9D9-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[49,43],"o":5},"flag-pa":{"a":"Panama Flag","b":"1F1F5-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[3,38],"o":2},"thunder_cloud_and_rain":{"a":"Thunder Cloud and Rain","b":"26C8-FE0F","c":"26C8","d":true,"e":true,"f":true,"h":true,"k":[54,3],"o":2},"large_green_circle":{"a":"Large Green Circle","b":"1F7E2","d":true,"e":true,"f":true,"h":true,"k":[37,5],"o":12},"female_mage":{"skin_variations":{"1F3FB":{"unified":"1F9D9-1F3FB-200D-2640-FE0F","non_qualified":"1F9D9-1F3FB-200D-2640","image":"1f9d9-1f3fb-200d-2640-fe0f.png","sheet_x":49,"sheet_y":38,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D9-1F3FB"},"1F3FC":{"unified":"1F9D9-1F3FC-200D-2640-FE0F","non_qualified":"1F9D9-1F3FC-200D-2640","image":"1f9d9-1f3fc-200d-2640-fe0f.png","sheet_x":49,"sheet_y":39,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D9-1F3FC"},"1F3FD":{"unified":"1F9D9-1F3FD-200D-2640-FE0F","non_qualified":"1F9D9-1F3FD-200D-2640","image":"1f9d9-1f3fd-200d-2640-fe0f.png","sheet_x":49,"sheet_y":40,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D9-1F3FD"},"1F3FE":{"unified":"1F9D9-1F3FE-200D-2640-FE0F","non_qualified":"1F9D9-1F3FE-200D-2640","image":"1f9d9-1f3fe-200d-2640-fe0f.png","sheet_x":49,"sheet_y":41,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D9-1F3FE"},"1F3FF":{"unified":"1F9D9-1F3FF-200D-2640-FE0F","non_qualified":"1F9D9-1F3FF-200D-2640","image":"1f9d9-1f3ff-200d-2640-fe0f.png","sheet_x":49,"sheet_y":42,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D9-1F3FF"}},"obsoletes":"1F9D9","a":"Female Mage","b":"1F9D9-200D-2640-FE0F","c":"1F9D9-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[49,37],"o":5},"crossed_swords":{"a":"Crossed Swords","b":"2694-FE0F","c":"2694","d":true,"e":true,"f":true,"h":true,"j":["weapon"],"k":[53,43],"o":2},"flag-pe":{"a":"Peru Flag","b":"1F1F5-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[3,39],"o":2},"gun":{"a":"Pistol","b":"1F52B","d":true,"e":true,"f":true,"h":true,"j":["violence","weapon","pistol","revolver"],"k":[28,14],"o":2},"mostly_sunny":{"a":"Mostly Sunny","b":"1F324-FE0F","c":"1F324","d":true,"e":true,"f":true,"h":true,"k":[5,53],"n":["sun_small_cloud"],"o":2},"fairy":{"skin_variations":{"1F3FB":{"unified":"1F9DA-1F3FB","non_qualified":null,"image":"1f9da-1f3fb.png","sheet_x":50,"sheet_y":11,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoleted_by":"1F9DA-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9DA-1F3FC","non_qualified":null,"image":"1f9da-1f3fc.png","sheet_x":50,"sheet_y":12,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoleted_by":"1F9DA-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9DA-1F3FD","non_qualified":null,"image":"1f9da-1f3fd.png","sheet_x":50,"sheet_y":13,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoleted_by":"1F9DA-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9DA-1F3FE","non_qualified":null,"image":"1f9da-1f3fe.png","sheet_x":50,"sheet_y":14,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoleted_by":"1F9DA-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9DA-1F3FF","non_qualified":null,"image":"1f9da-1f3ff.png","sheet_x":50,"sheet_y":15,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoleted_by":"1F9DA-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9DA-200D-2640-FE0F","a":"Fairy","b":"1F9DA","d":true,"e":true,"f":true,"h":true,"k":[50,10],"o":5},"flag-pf":{"a":"French Polynesia Flag","b":"1F1F5-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[3,40],"o":2},"large_blue_circle":{"a":"Large Blue Circle","b":"1F535","d":true,"e":true,"f":true,"h":true,"j":["shape","icon","button"],"k":[28,24],"o":2},"large_purple_circle":{"a":"Large Purple Circle","b":"1F7E3","d":true,"e":true,"f":true,"h":true,"k":[37,6],"o":12},"bow_and_arrow":{"a":"Bow and Arrow","b":"1F3F9","d":true,"e":true,"f":true,"h":true,"j":["sports"],"k":[11,21],"o":2},"male_fairy":{"skin_variations":{"1F3FB":{"unified":"1F9DA-1F3FB-200D-2642-FE0F","non_qualified":"1F9DA-1F3FB-200D-2642","image":"1f9da-1f3fb-200d-2642-fe0f.png","sheet_x":50,"sheet_y":5,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F9DA-1F3FC-200D-2642-FE0F","non_qualified":"1F9DA-1F3FC-200D-2642","image":"1f9da-1f3fc-200d-2642-fe0f.png","sheet_x":50,"sheet_y":6,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F9DA-1F3FD-200D-2642-FE0F","non_qualified":"1F9DA-1F3FD-200D-2642","image":"1f9da-1f3fd-200d-2642-fe0f.png","sheet_x":50,"sheet_y":7,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F9DA-1F3FE-200D-2642-FE0F","non_qualified":"1F9DA-1F3FE-200D-2642","image":"1f9da-1f3fe-200d-2642-fe0f.png","sheet_x":50,"sheet_y":8,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F9DA-1F3FF-200D-2642-FE0F","non_qualified":"1F9DA-1F3FF-200D-2642","image":"1f9da-1f3ff-200d-2642-fe0f.png","sheet_x":50,"sheet_y":9,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Male Fairy","b":"1F9DA-200D-2642-FE0F","c":"1F9DA-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[50,4],"o":5},"barely_sunny":{"a":"Barely Sunny","b":"1F325-FE0F","c":"1F325","d":true,"e":true,"f":true,"h":true,"k":[5,54],"n":["sun_behind_cloud"],"o":2},"flag-pg":{"a":"Papua New Guinea Flag","b":"1F1F5-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[3,41],"o":2},"shield":{"a":"Shield","b":"1F6E1-FE0F","c":"1F6E1","d":true,"e":true,"f":true,"h":true,"j":["protection","security"],"k":[36,43],"o":2},"partly_sunny_rain":{"a":"Partly Sunny Rain","b":"1F326-FE0F","c":"1F326","d":true,"e":true,"f":true,"h":true,"k":[5,55],"n":["sun_behind_rain_cloud"],"o":2},"large_brown_circle":{"a":"Large Brown Circle","b":"1F7E4","d":true,"e":true,"f":true,"h":true,"k":[37,7],"o":12},"female_fairy":{"skin_variations":{"1F3FB":{"unified":"1F9DA-1F3FB-200D-2640-FE0F","non_qualified":"1F9DA-1F3FB-200D-2640","image":"1f9da-1f3fb-200d-2640-fe0f.png","sheet_x":49,"sheet_y":56,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoletes":"1F9DA-1F3FB"},"1F3FC":{"unified":"1F9DA-1F3FC-200D-2640-FE0F","non_qualified":"1F9DA-1F3FC-200D-2640","image":"1f9da-1f3fc-200d-2640-fe0f.png","sheet_x":50,"sheet_y":0,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoletes":"1F9DA-1F3FC"},"1F3FD":{"unified":"1F9DA-1F3FD-200D-2640-FE0F","non_qualified":"1F9DA-1F3FD-200D-2640","image":"1f9da-1f3fd-200d-2640-fe0f.png","sheet_x":50,"sheet_y":1,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoletes":"1F9DA-1F3FD"},"1F3FE":{"unified":"1F9DA-1F3FE-200D-2640-FE0F","non_qualified":"1F9DA-1F3FE-200D-2640","image":"1f9da-1f3fe-200d-2640-fe0f.png","sheet_x":50,"sheet_y":2,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoletes":"1F9DA-1F3FE"},"1F3FF":{"unified":"1F9DA-1F3FF-200D-2640-FE0F","non_qualified":"1F9DA-1F3FF-200D-2640","image":"1f9da-1f3ff-200d-2640-fe0f.png","sheet_x":50,"sheet_y":3,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false,"obsoletes":"1F9DA-1F3FF"}},"obsoletes":"1F9DA","a":"Female Fairy","b":"1F9DA-200D-2640-FE0F","c":"1F9DA-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[49,55],"o":5},"flag-ph":{"a":"Philippines Flag","b":"1F1F5-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[3,42],"o":2},"flag-pk":{"a":"Pakistan Flag","b":"1F1F5-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[3,43],"o":2},"black_circle":{"a":"Medium Black Circle","b":"26AB","d":true,"e":true,"f":true,"h":true,"j":["shape","button","round"],"k":[53,53],"o":2},"wrench":{"a":"Wrench","b":"1F527","d":true,"e":true,"f":true,"h":true,"j":["tools","diy","ikea","fix","maintainer"],"k":[28,10],"o":2},"vampire":{"skin_variations":{"1F3FB":{"unified":"1F9DB-1F3FB","non_qualified":null,"image":"1f9db-1f3fb.png","sheet_x":50,"sheet_y":29,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DB-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9DB-1F3FC","non_qualified":null,"image":"1f9db-1f3fc.png","sheet_x":50,"sheet_y":30,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DB-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9DB-1F3FD","non_qualified":null,"image":"1f9db-1f3fd.png","sheet_x":50,"sheet_y":31,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DB-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9DB-1F3FE","non_qualified":null,"image":"1f9db-1f3fe.png","sheet_x":50,"sheet_y":32,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DB-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9DB-1F3FF","non_qualified":null,"image":"1f9db-1f3ff.png","sheet_x":50,"sheet_y":33,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DB-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9DB-200D-2640-FE0F","a":"Vampire","b":"1F9DB","d":true,"e":true,"f":true,"h":true,"k":[50,28],"o":5},"rain_cloud":{"a":"Rain Cloud","b":"1F327-FE0F","c":"1F327","d":true,"e":true,"f":true,"h":true,"k":[5,56],"o":2},"snow_cloud":{"a":"Snow Cloud","b":"1F328-FE0F","c":"1F328","d":true,"e":true,"f":true,"h":true,"k":[6,0],"o":2},"flag-pl":{"a":"Poland Flag","b":"1F1F5-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[3,44],"o":2},"male_vampire":{"skin_variations":{"1F3FB":{"unified":"1F9DB-1F3FB-200D-2642-FE0F","non_qualified":"1F9DB-1F3FB-200D-2642","image":"1f9db-1f3fb-200d-2642-fe0f.png","sheet_x":50,"sheet_y":23,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9DB-1F3FC-200D-2642-FE0F","non_qualified":"1F9DB-1F3FC-200D-2642","image":"1f9db-1f3fc-200d-2642-fe0f.png","sheet_x":50,"sheet_y":24,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9DB-1F3FD-200D-2642-FE0F","non_qualified":"1F9DB-1F3FD-200D-2642","image":"1f9db-1f3fd-200d-2642-fe0f.png","sheet_x":50,"sheet_y":25,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9DB-1F3FE-200D-2642-FE0F","non_qualified":"1F9DB-1F3FE-200D-2642","image":"1f9db-1f3fe-200d-2642-fe0f.png","sheet_x":50,"sheet_y":26,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9DB-1F3FF-200D-2642-FE0F","non_qualified":"1F9DB-1F3FF-200D-2642","image":"1f9db-1f3ff-200d-2642-fe0f.png","sheet_x":50,"sheet_y":27,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Male Vampire","b":"1F9DB-200D-2642-FE0F","c":"1F9DB-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[50,22],"o":5},"nut_and_bolt":{"a":"Nut and Bolt","b":"1F529","d":true,"e":true,"f":true,"h":true,"j":["handy","tools","fix"],"k":[28,12],"o":2},"white_circle":{"a":"Medium White Circle","b":"26AA","d":true,"e":true,"f":true,"h":true,"j":["shape","round"],"k":[53,52],"o":2},"female_vampire":{"skin_variations":{"1F3FB":{"unified":"1F9DB-1F3FB-200D-2640-FE0F","non_qualified":"1F9DB-1F3FB-200D-2640","image":"1f9db-1f3fb-200d-2640-fe0f.png","sheet_x":50,"sheet_y":17,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DB-1F3FB"},"1F3FC":{"unified":"1F9DB-1F3FC-200D-2640-FE0F","non_qualified":"1F9DB-1F3FC-200D-2640","image":"1f9db-1f3fc-200d-2640-fe0f.png","sheet_x":50,"sheet_y":18,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DB-1F3FC"},"1F3FD":{"unified":"1F9DB-1F3FD-200D-2640-FE0F","non_qualified":"1F9DB-1F3FD-200D-2640","image":"1f9db-1f3fd-200d-2640-fe0f.png","sheet_x":50,"sheet_y":19,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DB-1F3FD"},"1F3FE":{"unified":"1F9DB-1F3FE-200D-2640-FE0F","non_qualified":"1F9DB-1F3FE-200D-2640","image":"1f9db-1f3fe-200d-2640-fe0f.png","sheet_x":50,"sheet_y":20,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DB-1F3FE"},"1F3FF":{"unified":"1F9DB-1F3FF-200D-2640-FE0F","non_qualified":"1F9DB-1F3FF-200D-2640","image":"1f9db-1f3ff-200d-2640-fe0f.png","sheet_x":50,"sheet_y":21,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DB-1F3FF"}},"obsoletes":"1F9DB","a":"Female Vampire","b":"1F9DB-200D-2640-FE0F","c":"1F9DB-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[50,16],"o":5},"flag-pm":{"a":"St. Pierre & Miquelon Flag","b":"1F1F5-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[3,45],"o":2},"large_red_square":{"a":"Large Red Square","b":"1F7E5","d":true,"e":true,"f":true,"h":true,"k":[37,8],"o":12},"lightning":{"a":"Lightning","b":"1F329-FE0F","c":"1F329","d":true,"e":true,"f":true,"h":true,"k":[6,1],"n":["lightning_cloud"],"o":2},"gear":{"a":"Gear","b":"2699-FE0F","c":"2699","d":true,"e":true,"f":true,"h":true,"j":["cog"],"k":[53,47],"o":2},"merperson":{"skin_variations":{"1F3FB":{"unified":"1F9DC-1F3FB","non_qualified":null,"image":"1f9dc-1f3fb.png","sheet_x":50,"sheet_y":47,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DC-1F3FB-200D-2642-FE0F"},"1F3FC":{"unified":"1F9DC-1F3FC","non_qualified":null,"image":"1f9dc-1f3fc.png","sheet_x":50,"sheet_y":48,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DC-1F3FC-200D-2642-FE0F"},"1F3FD":{"unified":"1F9DC-1F3FD","non_qualified":null,"image":"1f9dc-1f3fd.png","sheet_x":50,"sheet_y":49,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DC-1F3FD-200D-2642-FE0F"},"1F3FE":{"unified":"1F9DC-1F3FE","non_qualified":null,"image":"1f9dc-1f3fe.png","sheet_x":50,"sheet_y":50,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DC-1F3FE-200D-2642-FE0F"},"1F3FF":{"unified":"1F9DC-1F3FF","non_qualified":null,"image":"1f9dc-1f3ff.png","sheet_x":50,"sheet_y":51,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DC-1F3FF-200D-2642-FE0F"}},"obsoleted_by":"1F9DC-200D-2642-FE0F","a":"Merperson","b":"1F9DC","d":true,"e":true,"f":true,"h":true,"k":[50,46],"o":5},"tornado":{"a":"Tornado","b":"1F32A-FE0F","c":"1F32A","d":true,"e":true,"f":true,"h":true,"j":["weather","cyclone","twister"],"k":[6,2],"n":["tornado_cloud"],"o":2},"large_orange_square":{"a":"Large Orange Square","b":"1F7E7","d":true,"e":true,"f":true,"h":true,"k":[37,10],"o":12},"flag-pn":{"a":"Pitcairn Islands Flag","b":"1F1F5-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[3,46],"o":2},"compression":{"a":"Compression","b":"1F5DC-FE0F","c":"1F5DC","d":true,"e":true,"f":true,"h":true,"k":[30,21],"o":2},"merman":{"skin_variations":{"1F3FB":{"unified":"1F9DC-1F3FB-200D-2642-FE0F","non_qualified":"1F9DC-1F3FB-200D-2642","image":"1f9dc-1f3fb-200d-2642-fe0f.png","sheet_x":50,"sheet_y":41,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DC-1F3FB"},"1F3FC":{"unified":"1F9DC-1F3FC-200D-2642-FE0F","non_qualified":"1F9DC-1F3FC-200D-2642","image":"1f9dc-1f3fc-200d-2642-fe0f.png","sheet_x":50,"sheet_y":42,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DC-1F3FC"},"1F3FD":{"unified":"1F9DC-1F3FD-200D-2642-FE0F","non_qualified":"1F9DC-1F3FD-200D-2642","image":"1f9dc-1f3fd-200d-2642-fe0f.png","sheet_x":50,"sheet_y":43,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DC-1F3FD"},"1F3FE":{"unified":"1F9DC-1F3FE-200D-2642-FE0F","non_qualified":"1F9DC-1F3FE-200D-2642","image":"1f9dc-1f3fe-200d-2642-fe0f.png","sheet_x":50,"sheet_y":44,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DC-1F3FE"},"1F3FF":{"unified":"1F9DC-1F3FF-200D-2642-FE0F","non_qualified":"1F9DC-1F3FF-200D-2642","image":"1f9dc-1f3ff-200d-2642-fe0f.png","sheet_x":50,"sheet_y":45,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DC-1F3FF"}},"obsoletes":"1F9DC","a":"Merman","b":"1F9DC-200D-2642-FE0F","c":"1F9DC-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[50,40],"o":5},"large_yellow_square":{"a":"Large Yellow Square","b":"1F7E8","d":true,"e":true,"f":true,"h":true,"k":[37,11],"o":12},"fog":{"a":"Fog","b":"1F32B-FE0F","c":"1F32B","d":true,"e":true,"f":true,"h":true,"j":["weather"],"k":[6,3],"o":2},"scales":{"a":"Scales","b":"2696-FE0F","c":"2696","d":true,"e":true,"f":true,"h":true,"k":[53,45],"o":2},"flag-pr":{"a":"Puerto Rico Flag","b":"1F1F5-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[3,47],"o":2},"wind_blowing_face":{"a":"Wind Blowing Face","b":"1F32C-FE0F","c":"1F32C","d":true,"e":true,"f":true,"h":true,"k":[6,4],"o":2},"flag-ps":{"a":"Palestinian Territories Flag","b":"1F1F5-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[3,48],"o":2},"mermaid":{"skin_variations":{"1F3FB":{"unified":"1F9DC-1F3FB-200D-2640-FE0F","non_qualified":"1F9DC-1F3FB-200D-2640","image":"1f9dc-1f3fb-200d-2640-fe0f.png","sheet_x":50,"sheet_y":35,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9DC-1F3FC-200D-2640-FE0F","non_qualified":"1F9DC-1F3FC-200D-2640","image":"1f9dc-1f3fc-200d-2640-fe0f.png","sheet_x":50,"sheet_y":36,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9DC-1F3FD-200D-2640-FE0F","non_qualified":"1F9DC-1F3FD-200D-2640","image":"1f9dc-1f3fd-200d-2640-fe0f.png","sheet_x":50,"sheet_y":37,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9DC-1F3FE-200D-2640-FE0F","non_qualified":"1F9DC-1F3FE-200D-2640","image":"1f9dc-1f3fe-200d-2640-fe0f.png","sheet_x":50,"sheet_y":38,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9DC-1F3FF-200D-2640-FE0F","non_qualified":"1F9DC-1F3FF-200D-2640","image":"1f9dc-1f3ff-200d-2640-fe0f.png","sheet_x":50,"sheet_y":39,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Mermaid","b":"1F9DC-200D-2640-FE0F","c":"1F9DC-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[50,34],"o":5},"probing_cane":{"a":"Probing Cane","b":"1F9AF","d":true,"e":true,"f":true,"h":true,"k":[43,3],"o":12},"large_green_square":{"a":"Large Green Square","b":"1F7E9","d":true,"e":true,"f":true,"h":true,"k":[37,12],"o":12},"flag-pt":{"a":"Portugal Flag","b":"1F1F5-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[3,49],"o":2},"link":{"a":"Link Symbol","b":"1F517","d":true,"e":true,"f":true,"h":true,"j":["rings","url"],"k":[27,51],"o":2},"large_blue_square":{"a":"Large Blue Square","b":"1F7E6","d":true,"e":true,"f":true,"h":true,"k":[37,9],"o":12},"elf":{"skin_variations":{"1F3FB":{"unified":"1F9DD-1F3FB","non_qualified":null,"image":"1f9dd-1f3fb.png","sheet_x":51,"sheet_y":8,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DD-1F3FB-200D-2642-FE0F"},"1F3FC":{"unified":"1F9DD-1F3FC","non_qualified":null,"image":"1f9dd-1f3fc.png","sheet_x":51,"sheet_y":9,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DD-1F3FC-200D-2642-FE0F"},"1F3FD":{"unified":"1F9DD-1F3FD","non_qualified":null,"image":"1f9dd-1f3fd.png","sheet_x":51,"sheet_y":10,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DD-1F3FD-200D-2642-FE0F"},"1F3FE":{"unified":"1F9DD-1F3FE","non_qualified":null,"image":"1f9dd-1f3fe.png","sheet_x":51,"sheet_y":11,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DD-1F3FE-200D-2642-FE0F"},"1F3FF":{"unified":"1F9DD-1F3FF","non_qualified":null,"image":"1f9dd-1f3ff.png","sheet_x":51,"sheet_y":12,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9DD-1F3FF-200D-2642-FE0F"}},"obsoleted_by":"1F9DD-200D-2642-FE0F","a":"Elf","b":"1F9DD","d":true,"e":true,"f":true,"h":true,"k":[51,7],"o":5},"cyclone":{"a":"Cyclone","b":"1F300","d":true,"e":true,"f":true,"h":true,"j":["weather","swirl","blue","cloud","vortex","spiral","whirlpool","spin","tornado","hurricane","typhoon"],"k":[5,19],"o":2},"rainbow":{"a":"Rainbow","b":"1F308","d":true,"e":true,"f":true,"h":true,"j":["nature","happy","unicorn_face","photo","sky","spring"],"k":[5,27],"o":2},"male_elf":{"skin_variations":{"1F3FB":{"unified":"1F9DD-1F3FB-200D-2642-FE0F","non_qualified":"1F9DD-1F3FB-200D-2642","image":"1f9dd-1f3fb-200d-2642-fe0f.png","sheet_x":51,"sheet_y":2,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DD-1F3FB"},"1F3FC":{"unified":"1F9DD-1F3FC-200D-2642-FE0F","non_qualified":"1F9DD-1F3FC-200D-2642","image":"1f9dd-1f3fc-200d-2642-fe0f.png","sheet_x":51,"sheet_y":3,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DD-1F3FC"},"1F3FD":{"unified":"1F9DD-1F3FD-200D-2642-FE0F","non_qualified":"1F9DD-1F3FD-200D-2642","image":"1f9dd-1f3fd-200d-2642-fe0f.png","sheet_x":51,"sheet_y":4,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DD-1F3FD"},"1F3FE":{"unified":"1F9DD-1F3FE-200D-2642-FE0F","non_qualified":"1F9DD-1F3FE-200D-2642","image":"1f9dd-1f3fe-200d-2642-fe0f.png","sheet_x":51,"sheet_y":5,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DD-1F3FE"},"1F3FF":{"unified":"1F9DD-1F3FF-200D-2642-FE0F","non_qualified":"1F9DD-1F3FF-200D-2642","image":"1f9dd-1f3ff-200d-2642-fe0f.png","sheet_x":51,"sheet_y":6,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9DD-1F3FF"}},"obsoletes":"1F9DD","a":"Male Elf","b":"1F9DD-200D-2642-FE0F","c":"1F9DD-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[51,1],"o":5},"flag-pw":{"a":"Palau Flag","b":"1F1F5-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[3,50],"o":2},"chains":{"a":"Chains","b":"26D3-FE0F","c":"26D3","d":true,"e":true,"f":true,"h":true,"j":["lock","arrest"],"k":[54,7],"o":2},"large_purple_square":{"a":"Large Purple Square","b":"1F7EA","d":true,"e":true,"f":true,"h":true,"k":[37,13],"o":12},"female_elf":{"skin_variations":{"1F3FB":{"unified":"1F9DD-1F3FB-200D-2640-FE0F","non_qualified":"1F9DD-1F3FB-200D-2640","image":"1f9dd-1f3fb-200d-2640-fe0f.png","sheet_x":50,"sheet_y":53,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9DD-1F3FC-200D-2640-FE0F","non_qualified":"1F9DD-1F3FC-200D-2640","image":"1f9dd-1f3fc-200d-2640-fe0f.png","sheet_x":50,"sheet_y":54,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9DD-1F3FD-200D-2640-FE0F","non_qualified":"1F9DD-1F3FD-200D-2640","image":"1f9dd-1f3fd-200d-2640-fe0f.png","sheet_x":50,"sheet_y":55,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9DD-1F3FE-200D-2640-FE0F","non_qualified":"1F9DD-1F3FE-200D-2640","image":"1f9dd-1f3fe-200d-2640-fe0f.png","sheet_x":50,"sheet_y":56,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9DD-1F3FF-200D-2640-FE0F","non_qualified":"1F9DD-1F3FF-200D-2640","image":"1f9dd-1f3ff-200d-2640-fe0f.png","sheet_x":51,"sheet_y":0,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Female Elf","b":"1F9DD-200D-2640-FE0F","c":"1F9DD-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[50,52],"o":5},"flag-py":{"a":"Paraguay Flag","b":"1F1F5-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[3,51],"o":2},"closed_umbrella":{"a":"Closed Umbrella","b":"1F302","d":true,"e":true,"f":true,"h":true,"j":["weather","rain","drizzle"],"k":[5,21],"o":2},"toolbox":{"a":"Toolbox","b":"1F9F0","d":true,"e":true,"f":true,"h":true,"k":[51,35],"o":11},"large_brown_square":{"a":"Large Brown Square","b":"1F7EB","d":true,"e":true,"f":true,"h":true,"k":[37,14],"o":12},"magnet":{"a":"Magnet","b":"1F9F2","d":true,"e":true,"f":true,"h":true,"k":[51,37],"o":11},"genie":{"obsoleted_by":"1F9DE-200D-2642-FE0F","a":"Genie","b":"1F9DE","d":true,"e":true,"f":true,"h":true,"k":[51,15],"o":5},"flag-qa":{"a":"Qatar Flag","b":"1F1F6-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[3,52],"o":2},"umbrella":{"a":"Umbrella","b":"2602-FE0F","c":"2602","d":true,"e":true,"f":true,"h":true,"j":["rainy","weather","spring"],"k":[52,51],"o":2},"black_large_square":{"a":"Black Large Square","b":"2B1B","d":true,"e":true,"f":true,"h":true,"j":["shape","icon","button"],"k":[55,40],"o":2},"male_genie":{"obsoletes":"1F9DE","a":"Male Genie","b":"1F9DE-200D-2642-FE0F","c":"1F9DE-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[51,14],"o":5},"umbrella_with_rain_drops":{"a":"Umbrella with Rain Drops","b":"2614","d":true,"e":true,"f":true,"h":true,"k":[52,56],"o":2},"flag-re":{"a":"R\xe9union Flag","b":"1F1F7-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[3,53],"o":2},"white_large_square":{"a":"White Large Square","b":"2B1C","d":true,"e":true,"f":true,"h":true,"j":["shape","icon","stone","button"],"k":[55,41],"o":2},"alembic":{"a":"Alembic","b":"2697-FE0F","c":"2697","d":true,"e":true,"f":true,"h":true,"j":["distilling","science","experiment","chemistry"],"k":[53,46],"o":2},"black_medium_square":{"a":"Black Medium Square","b":"25FC-FE0F","c":"25FC","d":true,"e":true,"f":true,"h":true,"j":["shape","button","icon"],"k":[52,46],"o":2},"test_tube":{"a":"Test Tube","b":"1F9EA","d":true,"e":true,"f":true,"h":true,"k":[51,29],"o":11},"flag-ro":{"a":"Romania Flag","b":"1F1F7-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[3,54],"o":2},"female_genie":{"a":"Female Genie","b":"1F9DE-200D-2640-FE0F","c":"1F9DE-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[51,13],"o":5},"umbrella_on_ground":{"a":"Umbrella on Ground","b":"26F1-FE0F","c":"26F1","d":true,"e":true,"f":true,"h":true,"k":[54,12],"o":2},"zombie":{"obsoleted_by":"1F9DF-200D-2642-FE0F","a":"Zombie","b":"1F9DF","d":true,"e":true,"f":true,"h":true,"k":[51,18],"o":5},"zap":{"a":"High Voltage Sign","b":"26A1","d":true,"e":true,"f":true,"h":true,"j":["thunder","weather","lightning bolt","fast"],"k":[53,51],"o":2},"white_medium_square":{"a":"White Medium Square","b":"25FB-FE0F","c":"25FB","d":true,"e":true,"f":true,"h":true,"j":["shape","stone","icon"],"k":[52,45],"o":2},"flag-rs":{"a":"Serbia Flag","b":"1F1F7-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[3,55],"o":2},"petri_dish":{"a":"Petri Dish","b":"1F9EB","d":true,"e":true,"f":true,"h":true,"k":[51,30],"o":11},"snowflake":{"a":"Snowflake","b":"2744-FE0F","c":"2744","d":true,"e":true,"f":true,"h":true,"j":["winter","season","cold","weather","christmas","xmas"],"k":[55,19],"o":2},"dna":{"a":"Dna Double Helix","b":"1F9EC","d":true,"e":true,"f":true,"h":true,"k":[51,31],"o":11},"male_zombie":{"obsoletes":"1F9DF","a":"Male Zombie","b":"1F9DF-200D-2642-FE0F","c":"1F9DF-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[51,17],"o":5},"black_medium_small_square":{"a":"Black Medium Small Square","b":"25FE","d":true,"e":true,"f":true,"h":true,"j":["icon","shape","button"],"k":[52,48],"o":2},"ru":{"a":"Russia Flag","b":"1F1F7-1F1FA","d":true,"e":true,"f":true,"h":true,"j":["russian","federation","flag","nation","country","banner"],"k":[3,56],"n":["flag-ru"],"o":2},"female_zombie":{"a":"Female Zombie","b":"1F9DF-200D-2640-FE0F","c":"1F9DF-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[51,16],"o":5},"flag-rw":{"a":"Rwanda Flag","b":"1F1F7-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[4,0],"o":2},"snowman":{"a":"Snowman","b":"2603-FE0F","c":"2603","d":true,"e":true,"f":true,"h":true,"j":["winter","season","cold","weather","christmas","xmas","frozen","without_snow"],"k":[52,52],"o":2},"white_medium_small_square":{"a":"White Medium Small Square","b":"25FD","d":true,"e":true,"f":true,"h":true,"j":["shape","stone","icon","button"],"k":[52,47],"o":2},"microscope":{"a":"Microscope","b":"1F52C","d":true,"e":true,"f":true,"h":true,"j":["laboratory","experiment","zoomin","science","study"],"k":[28,15],"o":2},"snowman_without_snow":{"a":"Snowman Without Snow","b":"26C4","d":true,"e":true,"f":true,"h":true,"k":[54,1],"o":2},"telescope":{"a":"Telescope","b":"1F52D","d":true,"e":true,"f":true,"h":true,"j":["stars","space","zoom","science","astronomy"],"k":[28,16],"o":2},"massage":{"skin_variations":{"1F3FB":{"unified":"1F486-1F3FB","non_qualified":null,"image":"1f486-1f3fb.png","sheet_x":24,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F486-1F3FC","non_qualified":null,"image":"1f486-1f3fc.png","sheet_x":24,"sheet_y":53,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F486-1F3FD","non_qualified":null,"image":"1f486-1f3fd.png","sheet_x":24,"sheet_y":54,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F486-1F3FE","non_qualified":null,"image":"1f486-1f3fe.png","sheet_x":24,"sheet_y":55,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F486-1F3FF","non_qualified":null,"image":"1f486-1f3ff.png","sheet_x":24,"sheet_y":56,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F486-200D-2640-FE0F","a":"Face Massage","b":"1F486","d":true,"e":true,"f":true,"h":false,"k":[24,51],"o":2},"black_small_square":{"a":"Black Small Square","b":"25AA-FE0F","c":"25AA","d":true,"e":true,"f":true,"h":true,"j":["shape","icon"],"k":[52,41],"o":2},"flag-sa":{"a":"Saudi Arabia Flag","b":"1F1F8-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[4,1],"o":2},"man-getting-massage":{"skin_variations":{"1F3FB":{"unified":"1F486-1F3FB-200D-2642-FE0F","non_qualified":"1F486-1F3FB-200D-2642","image":"1f486-1f3fb-200d-2642-fe0f.png","sheet_x":24,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F486-1F3FC-200D-2642-FE0F","non_qualified":"1F486-1F3FC-200D-2642","image":"1f486-1f3fc-200d-2642-fe0f.png","sheet_x":24,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F486-1F3FD-200D-2642-FE0F","non_qualified":"1F486-1F3FD-200D-2642","image":"1f486-1f3fd-200d-2642-fe0f.png","sheet_x":24,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F486-1F3FE-200D-2642-FE0F","non_qualified":"1F486-1F3FE-200D-2642","image":"1f486-1f3fe-200d-2642-fe0f.png","sheet_x":24,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F486-1F3FF-200D-2642-FE0F","non_qualified":"1F486-1F3FF-200D-2642","image":"1f486-1f3ff-200d-2642-fe0f.png","sheet_x":24,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Getting Massage","b":"1F486-200D-2642-FE0F","c":"1F486-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[24,45],"o":4},"comet":{"a":"Comet","b":"2604-FE0F","c":"2604","d":true,"e":true,"f":true,"h":true,"j":["space"],"k":[52,53],"o":2},"white_small_square":{"a":"White Small Square","b":"25AB-FE0F","c":"25AB","d":true,"e":true,"f":true,"h":true,"j":["shape","icon"],"k":[52,42],"o":2},"flag-sb":{"a":"Solomon Islands Flag","b":"1F1F8-1F1E7","d":true,"e":true,"f":true,"h":true,"k":[4,2],"o":2},"satellite_antenna":{"a":"Satellite Antenna","b":"1F4E1","d":true,"e":true,"f":true,"h":true,"k":[26,55],"o":2},"large_orange_diamond":{"a":"Large Orange Diamond","b":"1F536","d":true,"e":true,"f":true,"h":true,"j":["shape","jewel","gem"],"k":[28,25],"o":2},"woman-getting-massage":{"skin_variations":{"1F3FB":{"unified":"1F486-1F3FB-200D-2640-FE0F","non_qualified":"1F486-1F3FB-200D-2640","image":"1f486-1f3fb-200d-2640-fe0f.png","sheet_x":24,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F486-1F3FC-200D-2640-FE0F","non_qualified":"1F486-1F3FC-200D-2640","image":"1f486-1f3fc-200d-2640-fe0f.png","sheet_x":24,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F486-1F3FD-200D-2640-FE0F","non_qualified":"1F486-1F3FD-200D-2640","image":"1f486-1f3fd-200d-2640-fe0f.png","sheet_x":24,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F486-1F3FE-200D-2640-FE0F","non_qualified":"1F486-1F3FE-200D-2640","image":"1f486-1f3fe-200d-2640-fe0f.png","sheet_x":24,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F486-1F3FF-200D-2640-FE0F","non_qualified":"1F486-1F3FF-200D-2640","image":"1f486-1f3ff-200d-2640-fe0f.png","sheet_x":24,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F486","a":"Woman Getting Massage","b":"1F486-200D-2640-FE0F","c":"1F486-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[24,39],"o":4},"fire":{"a":"Fire","b":"1F525","d":true,"e":true,"f":true,"h":true,"j":["hot","cook","flame"],"k":[28,8],"o":2},"syringe":{"a":"Syringe","b":"1F489","d":true,"e":true,"f":true,"h":true,"j":["health","hospital","drugs","blood","medicine","needle","doctor","nurse"],"k":[25,19],"o":2},"flag-sc":{"a":"Seychelles Flag","b":"1F1F8-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[4,3],"o":2},"large_blue_diamond":{"a":"Large Blue Diamond","b":"1F537","d":true,"e":true,"f":true,"h":true,"j":["shape","jewel","gem"],"k":[28,26],"o":2},"flag-sd":{"a":"Sudan Flag","b":"1F1F8-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[4,4],"o":2},"droplet":{"a":"Droplet","b":"1F4A7","d":true,"e":true,"f":true,"h":true,"j":["water","drip","faucet","spring"],"k":[25,49],"o":2},"drop_of_blood":{"a":"Drop of Blood","b":"1FA78","d":true,"e":true,"f":true,"h":true,"k":[51,55],"o":12},"haircut":{"skin_variations":{"1F3FB":{"unified":"1F487-1F3FB","non_qualified":null,"image":"1f487-1f3fb.png","sheet_x":25,"sheet_y":13,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F487-1F3FC","non_qualified":null,"image":"1f487-1f3fc.png","sheet_x":25,"sheet_y":14,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F487-1F3FD","non_qualified":null,"image":"1f487-1f3fd.png","sheet_x":25,"sheet_y":15,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F487-1F3FE","non_qualified":null,"image":"1f487-1f3fe.png","sheet_x":25,"sheet_y":16,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F487-1F3FF","non_qualified":null,"image":"1f487-1f3ff.png","sheet_x":25,"sheet_y":17,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F487-200D-2640-FE0F","a":"Haircut","b":"1F487","d":true,"e":true,"f":true,"h":false,"k":[25,12],"o":2},"ocean":{"a":"Water Wave","b":"1F30A","d":true,"e":true,"f":true,"h":true,"j":["sea","water","wave","nature","tsunami","disaster"],"k":[5,29],"o":2},"flag-se":{"a":"Sweden Flag","b":"1F1F8-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[4,5],"o":2},"man-getting-haircut":{"skin_variations":{"1F3FB":{"unified":"1F487-1F3FB-200D-2642-FE0F","non_qualified":"1F487-1F3FB-200D-2642","image":"1f487-1f3fb-200d-2642-fe0f.png","sheet_x":25,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F487-1F3FC-200D-2642-FE0F","non_qualified":"1F487-1F3FC-200D-2642","image":"1f487-1f3fc-200d-2642-fe0f.png","sheet_x":25,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F487-1F3FD-200D-2642-FE0F","non_qualified":"1F487-1F3FD-200D-2642","image":"1f487-1f3fd-200d-2642-fe0f.png","sheet_x":25,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F487-1F3FE-200D-2642-FE0F","non_qualified":"1F487-1F3FE-200D-2642","image":"1f487-1f3fe-200d-2642-fe0f.png","sheet_x":25,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F487-1F3FF-200D-2642-FE0F","non_qualified":"1F487-1F3FF-200D-2642","image":"1f487-1f3ff-200d-2642-fe0f.png","sheet_x":25,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Getting Haircut","b":"1F487-200D-2642-FE0F","c":"1F487-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[25,6],"o":4},"small_orange_diamond":{"a":"Small Orange Diamond","b":"1F538","d":true,"e":true,"f":true,"h":true,"j":["shape","jewel","gem"],"k":[28,27],"o":2},"pill":{"a":"Pill","b":"1F48A","d":true,"e":true,"f":true,"h":true,"j":["health","medicine","doctor","pharmacy","drug"],"k":[25,20],"o":2},"woman-getting-haircut":{"skin_variations":{"1F3FB":{"unified":"1F487-1F3FB-200D-2640-FE0F","non_qualified":"1F487-1F3FB-200D-2640","image":"1f487-1f3fb-200d-2640-fe0f.png","sheet_x":25,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F487-1F3FC-200D-2640-FE0F","non_qualified":"1F487-1F3FC-200D-2640","image":"1f487-1f3fc-200d-2640-fe0f.png","sheet_x":25,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F487-1F3FD-200D-2640-FE0F","non_qualified":"1F487-1F3FD-200D-2640","image":"1f487-1f3fd-200d-2640-fe0f.png","sheet_x":25,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F487-1F3FE-200D-2640-FE0F","non_qualified":"1F487-1F3FE-200D-2640","image":"1f487-1f3fe-200d-2640-fe0f.png","sheet_x":25,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F487-1F3FF-200D-2640-FE0F","non_qualified":"1F487-1F3FF-200D-2640","image":"1f487-1f3ff-200d-2640-fe0f.png","sheet_x":25,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F487","a":"Woman Getting Haircut","b":"1F487-200D-2640-FE0F","c":"1F487-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[25,0],"o":4},"small_blue_diamond":{"a":"Small Blue Diamond","b":"1F539","d":true,"e":true,"f":true,"h":true,"j":["shape","jewel","gem"],"k":[28,28],"o":2},"flag-sg":{"a":"Singapore Flag","b":"1F1F8-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[4,6],"o":2},"adhesive_bandage":{"a":"Adhesive Bandage","b":"1FA79","d":true,"e":true,"f":true,"h":true,"k":[51,56],"o":12},"walking":{"skin_variations":{"1F3FB":{"unified":"1F6B6-1F3FB","non_qualified":null,"image":"1f6b6-1f3fb.png","sheet_x":36,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F6B6-1F3FC","non_qualified":null,"image":"1f6b6-1f3fc.png","sheet_x":36,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F6B6-1F3FD","non_qualified":null,"image":"1f6b6-1f3fd.png","sheet_x":36,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F6B6-1F3FE","non_qualified":null,"image":"1f6b6-1f3fe.png","sheet_x":36,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F6B6-1F3FF","non_qualified":null,"image":"1f6b6-1f3ff.png","sheet_x":36,"sheet_y":7,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F6B6-200D-2642-FE0F","a":"Pedestrian","b":"1F6B6","d":true,"e":true,"f":true,"h":false,"k":[36,2],"o":2},"small_red_triangle":{"a":"Up-Pointing Red Triangle","b":"1F53A","d":true,"e":true,"f":true,"h":true,"j":["shape","direction","up","top"],"k":[28,29],"o":2},"flag-sh":{"a":"St. Helena Flag","b":"1F1F8-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[4,7],"o":2},"stethoscope":{"a":"Stethoscope","b":"1FA7A","d":true,"e":true,"f":true,"h":true,"k":[52,0],"o":12},"man-walking":{"skin_variations":{"1F3FB":{"unified":"1F6B6-1F3FB-200D-2642-FE0F","non_qualified":"1F6B6-1F3FB-200D-2642","image":"1f6b6-1f3fb-200d-2642-fe0f.png","sheet_x":35,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B6-1F3FC-200D-2642-FE0F","non_qualified":"1F6B6-1F3FC-200D-2642","image":"1f6b6-1f3fc-200d-2642-fe0f.png","sheet_x":35,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B6-1F3FD-200D-2642-FE0F","non_qualified":"1F6B6-1F3FD-200D-2642","image":"1f6b6-1f3fd-200d-2642-fe0f.png","sheet_x":35,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B6-1F3FE-200D-2642-FE0F","non_qualified":"1F6B6-1F3FE-200D-2642","image":"1f6b6-1f3fe-200d-2642-fe0f.png","sheet_x":36,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B6-1F3FF-200D-2642-FE0F","non_qualified":"1F6B6-1F3FF-200D-2642","image":"1f6b6-1f3ff-200d-2642-fe0f.png","sheet_x":36,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F6B6","a":"Man Walking","b":"1F6B6-200D-2642-FE0F","c":"1F6B6-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[35,53],"o":4},"flag-si":{"a":"Slovenia Flag","b":"1F1F8-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[4,8],"o":2},"door":{"a":"Door","b":"1F6AA","d":true,"e":true,"f":true,"h":true,"j":["house","entry","exit"],"k":[35,1],"o":2},"small_red_triangle_down":{"a":"Down-Pointing Red Triangle","b":"1F53B","d":true,"e":true,"f":true,"h":true,"j":["shape","direction","bottom"],"k":[28,30],"o":2},"flag-sj":{"a":"Svalbard & Jan Mayen Flag","b":"1F1F8-1F1EF","d":true,"e":true,"f":true,"h":true,"k":[4,9],"o":2},"diamond_shape_with_a_dot_inside":{"a":"Diamond Shape with a Dot Inside","b":"1F4A0","d":true,"e":true,"f":true,"h":true,"j":["jewel","blue","gem","crystal","fancy"],"k":[25,42],"o":2},"woman-walking":{"skin_variations":{"1F3FB":{"unified":"1F6B6-1F3FB-200D-2640-FE0F","non_qualified":"1F6B6-1F3FB-200D-2640","image":"1f6b6-1f3fb-200d-2640-fe0f.png","sheet_x":35,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B6-1F3FC-200D-2640-FE0F","non_qualified":"1F6B6-1F3FC-200D-2640","image":"1f6b6-1f3fc-200d-2640-fe0f.png","sheet_x":35,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B6-1F3FD-200D-2640-FE0F","non_qualified":"1F6B6-1F3FD-200D-2640","image":"1f6b6-1f3fd-200d-2640-fe0f.png","sheet_x":35,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B6-1F3FE-200D-2640-FE0F","non_qualified":"1F6B6-1F3FE-200D-2640","image":"1f6b6-1f3fe-200d-2640-fe0f.png","sheet_x":35,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B6-1F3FF-200D-2640-FE0F","non_qualified":"1F6B6-1F3FF-200D-2640","image":"1f6b6-1f3ff-200d-2640-fe0f.png","sheet_x":35,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Walking","b":"1F6B6-200D-2640-FE0F","c":"1F6B6-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[35,47],"o":4},"bed":{"a":"Bed","b":"1F6CF-FE0F","c":"1F6CF","d":true,"e":true,"f":true,"h":true,"j":["sleep","rest"],"k":[36,37],"o":2},"radio_button":{"a":"Radio Button","b":"1F518","d":true,"e":true,"f":true,"h":true,"j":["input","old","music","circle"],"k":[27,52],"o":2},"flag-sk":{"a":"Slovakia Flag","b":"1F1F8-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[4,10],"o":2},"standing_person":{"skin_variations":{"1F3FB":{"unified":"1F9CD-1F3FB","non_qualified":null,"image":"1f9cd-1f3fb.png","sheet_x":44,"sheet_y":32,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CD-1F3FC","non_qualified":null,"image":"1f9cd-1f3fc.png","sheet_x":44,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CD-1F3FD","non_qualified":null,"image":"1f9cd-1f3fd.png","sheet_x":44,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CD-1F3FE","non_qualified":null,"image":"1f9cd-1f3fe.png","sheet_x":44,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CD-1F3FF","non_qualified":null,"image":"1f9cd-1f3ff.png","sheet_x":44,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Standing Person","b":"1F9CD","d":true,"e":true,"f":true,"h":true,"k":[44,31],"o":12},"couch_and_lamp":{"a":"Couch and Lamp","b":"1F6CB-FE0F","c":"1F6CB","d":true,"e":true,"f":true,"h":true,"j":["read","chill"],"k":[36,28],"o":2},"man_standing":{"skin_variations":{"1F3FB":{"unified":"1F9CD-1F3FB-200D-2642-FE0F","non_qualified":"1F9CD-1F3FB-200D-2642","image":"1f9cd-1f3fb-200d-2642-fe0f.png","sheet_x":44,"sheet_y":26,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CD-1F3FC-200D-2642-FE0F","non_qualified":"1F9CD-1F3FC-200D-2642","image":"1f9cd-1f3fc-200d-2642-fe0f.png","sheet_x":44,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CD-1F3FD-200D-2642-FE0F","non_qualified":"1F9CD-1F3FD-200D-2642","image":"1f9cd-1f3fd-200d-2642-fe0f.png","sheet_x":44,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CD-1F3FE-200D-2642-FE0F","non_qualified":"1F9CD-1F3FE-200D-2642","image":"1f9cd-1f3fe-200d-2642-fe0f.png","sheet_x":44,"sheet_y":29,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CD-1F3FF-200D-2642-FE0F","non_qualified":"1F9CD-1F3FF-200D-2642","image":"1f9cd-1f3ff-200d-2642-fe0f.png","sheet_x":44,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Standing","b":"1F9CD-200D-2642-FE0F","c":"1F9CD-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[44,25],"o":12},"white_square_button":{"a":"White Square Button","b":"1F533","d":true,"e":true,"f":true,"h":true,"j":["shape","input"],"k":[28,22],"o":2},"flag-sl":{"a":"Sierra Leone Flag","b":"1F1F8-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[4,11],"o":2},"chair":{"a":"Chair","b":"1FA91","d":true,"e":true,"f":true,"h":true,"k":[52,5],"o":12},"toilet":{"a":"Toilet","b":"1F6BD","d":true,"e":true,"f":true,"h":true,"j":["restroom","wc","washroom","bathroom","potty"],"k":[36,14],"o":2},"black_square_button":{"a":"Black Square Button","b":"1F532","d":true,"e":true,"f":true,"h":true,"j":["shape","input","frame"],"k":[28,21],"o":2},"flag-sm":{"a":"San Marino Flag","b":"1F1F8-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[4,12],"o":2},"woman_standing":{"skin_variations":{"1F3FB":{"unified":"1F9CD-1F3FB-200D-2640-FE0F","non_qualified":"1F9CD-1F3FB-200D-2640","image":"1f9cd-1f3fb-200d-2640-fe0f.png","sheet_x":44,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CD-1F3FC-200D-2640-FE0F","non_qualified":"1F9CD-1F3FC-200D-2640","image":"1f9cd-1f3fc-200d-2640-fe0f.png","sheet_x":44,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CD-1F3FD-200D-2640-FE0F","non_qualified":"1F9CD-1F3FD-200D-2640","image":"1f9cd-1f3fd-200d-2640-fe0f.png","sheet_x":44,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CD-1F3FE-200D-2640-FE0F","non_qualified":"1F9CD-1F3FE-200D-2640","image":"1f9cd-1f3fe-200d-2640-fe0f.png","sheet_x":44,"sheet_y":23,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CD-1F3FF-200D-2640-FE0F","non_qualified":"1F9CD-1F3FF-200D-2640","image":"1f9cd-1f3ff-200d-2640-fe0f.png","sheet_x":44,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Standing","b":"1F9CD-200D-2640-FE0F","c":"1F9CD-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[44,19],"o":12},"kneeling_person":{"skin_variations":{"1F3FB":{"unified":"1F9CE-1F3FB","non_qualified":null,"image":"1f9ce-1f3fb.png","sheet_x":44,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CE-1F3FC","non_qualified":null,"image":"1f9ce-1f3fc.png","sheet_x":44,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CE-1F3FD","non_qualified":null,"image":"1f9ce-1f3fd.png","sheet_x":44,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CE-1F3FE","non_qualified":null,"image":"1f9ce-1f3fe.png","sheet_x":44,"sheet_y":53,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CE-1F3FF","non_qualified":null,"image":"1f9ce-1f3ff.png","sheet_x":44,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Kneeling Person","b":"1F9CE","d":true,"e":true,"f":true,"h":true,"k":[44,49],"o":12},"shower":{"a":"Shower","b":"1F6BF","d":true,"e":true,"f":true,"h":true,"j":["clean","water","bathroom"],"k":[36,16],"o":2},"flag-sn":{"a":"Senegal Flag","b":"1F1F8-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[4,13],"o":2},"bathtub":{"a":"Bathtub","b":"1F6C1","d":true,"e":true,"f":true,"h":true,"j":["clean","shower","bathroom"],"k":[36,23],"o":2},"flag-so":{"a":"Somalia Flag","b":"1F1F8-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[4,14],"o":2},"man_kneeling":{"skin_variations":{"1F3FB":{"unified":"1F9CE-1F3FB-200D-2642-FE0F","non_qualified":"1F9CE-1F3FB-200D-2642","image":"1f9ce-1f3fb-200d-2642-fe0f.png","sheet_x":44,"sheet_y":44,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CE-1F3FC-200D-2642-FE0F","non_qualified":"1F9CE-1F3FC-200D-2642","image":"1f9ce-1f3fc-200d-2642-fe0f.png","sheet_x":44,"sheet_y":45,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CE-1F3FD-200D-2642-FE0F","non_qualified":"1F9CE-1F3FD-200D-2642","image":"1f9ce-1f3fd-200d-2642-fe0f.png","sheet_x":44,"sheet_y":46,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CE-1F3FE-200D-2642-FE0F","non_qualified":"1F9CE-1F3FE-200D-2642","image":"1f9ce-1f3fe-200d-2642-fe0f.png","sheet_x":44,"sheet_y":47,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CE-1F3FF-200D-2642-FE0F","non_qualified":"1F9CE-1F3FF-200D-2642","image":"1f9ce-1f3ff-200d-2642-fe0f.png","sheet_x":44,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Kneeling","b":"1F9CE-200D-2642-FE0F","c":"1F9CE-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[44,43],"o":12},"flag-sr":{"a":"Suriname Flag","b":"1F1F8-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[4,15],"o":2},"woman_kneeling":{"skin_variations":{"1F3FB":{"unified":"1F9CE-1F3FB-200D-2640-FE0F","non_qualified":"1F9CE-1F3FB-200D-2640","image":"1f9ce-1f3fb-200d-2640-fe0f.png","sheet_x":44,"sheet_y":38,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9CE-1F3FC-200D-2640-FE0F","non_qualified":"1F9CE-1F3FC-200D-2640","image":"1f9ce-1f3fc-200d-2640-fe0f.png","sheet_x":44,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9CE-1F3FD-200D-2640-FE0F","non_qualified":"1F9CE-1F3FD-200D-2640","image":"1f9ce-1f3fd-200d-2640-fe0f.png","sheet_x":44,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9CE-1F3FE-200D-2640-FE0F","non_qualified":"1F9CE-1F3FE-200D-2640","image":"1f9ce-1f3fe-200d-2640-fe0f.png","sheet_x":44,"sheet_y":41,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9CE-1F3FF-200D-2640-FE0F","non_qualified":"1F9CE-1F3FF-200D-2640","image":"1f9ce-1f3ff-200d-2640-fe0f.png","sheet_x":44,"sheet_y":42,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Kneeling","b":"1F9CE-200D-2640-FE0F","c":"1F9CE-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[44,37],"o":12},"razor":{"a":"Razor","b":"1FA92","d":true,"e":true,"f":true,"h":true,"k":[52,6],"o":12},"person_with_probing_cane":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9AF","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9af.png","sheet_x":47,"sheet_y":8,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9AF","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9af.png","sheet_x":47,"sheet_y":9,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9AF","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9af.png","sheet_x":47,"sheet_y":10,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9AF","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9af.png","sheet_x":47,"sheet_y":11,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9AF","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9af.png","sheet_x":47,"sheet_y":12,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Person with Probing Cane","b":"1F9D1-200D-1F9AF","d":true,"e":false,"f":false,"h":false,"k":[47,7],"o":12},"flag-ss":{"a":"South Sudan Flag","b":"1F1F8-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[4,16],"o":2},"lotion_bottle":{"a":"Lotion Bottle","b":"1F9F4","d":true,"e":true,"f":true,"h":true,"k":[51,39],"o":11},"flag-st":{"a":"S\xe3o Tom\xe9 & Pr\xedncipe Flag","b":"1F1F8-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[4,17],"o":2},"safety_pin":{"a":"Safety Pin","b":"1F9F7","d":true,"e":true,"f":true,"h":true,"k":[51,42],"o":11},"man_with_probing_cane":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9AF","non_qualified":null,"image":"1f468-1f3fb-200d-1f9af.png","sheet_x":16,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9AF","non_qualified":null,"image":"1f468-1f3fc-200d-1f9af.png","sheet_x":16,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9AF","non_qualified":null,"image":"1f468-1f3fd-200d-1f9af.png","sheet_x":16,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9AF","non_qualified":null,"image":"1f468-1f3fe-200d-1f9af.png","sheet_x":16,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9AF","non_qualified":null,"image":"1f468-1f3ff-200d-1f9af.png","sheet_x":16,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man with Probing Cane","b":"1F468-200D-1F9AF","d":true,"e":true,"f":true,"h":true,"k":[16,17],"o":12},"broom":{"a":"Broom","b":"1F9F9","d":true,"e":true,"f":true,"h":true,"k":[51,44],"o":11},"woman_with_probing_cane":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9AF","non_qualified":null,"image":"1f469-1f3fb-200d-1f9af.png","sheet_x":19,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9AF","non_qualified":null,"image":"1f469-1f3fc-200d-1f9af.png","sheet_x":19,"sheet_y":4,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9AF","non_qualified":null,"image":"1f469-1f3fd-200d-1f9af.png","sheet_x":19,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9AF","non_qualified":null,"image":"1f469-1f3fe-200d-1f9af.png","sheet_x":19,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9AF","non_qualified":null,"image":"1f469-1f3ff-200d-1f9af.png","sheet_x":19,"sheet_y":7,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman with Probing Cane","b":"1F469-200D-1F9AF","d":true,"e":true,"f":true,"h":true,"k":[19,2],"o":12},"flag-sv":{"a":"El Salvador Flag","b":"1F1F8-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[4,18],"o":2},"flag-sx":{"a":"Sint Maarten Flag","b":"1F1F8-1F1FD","d":true,"e":true,"f":true,"h":true,"k":[4,19],"o":2},"basket":{"a":"Basket","b":"1F9FA","d":true,"e":true,"f":true,"h":true,"k":[51,45],"o":11},"person_in_motorized_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9BC","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9bc.png","sheet_x":47,"sheet_y":38,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9BC","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9bc.png","sheet_x":47,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9BC","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9bc.png","sheet_x":47,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9BC","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9bc.png","sheet_x":47,"sheet_y":41,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9BC","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9bc.png","sheet_x":47,"sheet_y":42,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Person in Motorized Wheelchair","b":"1F9D1-200D-1F9BC","d":true,"e":false,"f":false,"h":false,"k":[47,37],"o":12},"man_in_motorized_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9BC","non_qualified":null,"image":"1f468-1f3fb-200d-1f9bc.png","sheet_x":16,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9BC","non_qualified":null,"image":"1f468-1f3fc-200d-1f9bc.png","sheet_x":16,"sheet_y":49,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9BC","non_qualified":null,"image":"1f468-1f3fd-200d-1f9bc.png","sheet_x":16,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9BC","non_qualified":null,"image":"1f468-1f3fe-200d-1f9bc.png","sheet_x":16,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9BC","non_qualified":null,"image":"1f468-1f3ff-200d-1f9bc.png","sheet_x":16,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man in Motorized Wheelchair","b":"1F468-200D-1F9BC","d":true,"e":true,"f":true,"h":true,"k":[16,47],"o":12},"flag-sy":{"a":"Syria Flag","b":"1F1F8-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[4,20],"o":2},"roll_of_paper":{"a":"Roll of Paper","b":"1F9FB","d":true,"e":true,"f":true,"h":true,"k":[51,46],"o":11},"woman_in_motorized_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9BC","non_qualified":null,"image":"1f469-1f3fb-200d-1f9bc.png","sheet_x":19,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9BC","non_qualified":null,"image":"1f469-1f3fc-200d-1f9bc.png","sheet_x":19,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9BC","non_qualified":null,"image":"1f469-1f3fd-200d-1f9bc.png","sheet_x":19,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9BC","non_qualified":null,"image":"1f469-1f3fe-200d-1f9bc.png","sheet_x":19,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9BC","non_qualified":null,"image":"1f469-1f3ff-200d-1f9bc.png","sheet_x":19,"sheet_y":37,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman in Motorized Wheelchair","b":"1F469-200D-1F9BC","d":true,"e":true,"f":true,"h":true,"k":[19,32],"o":12},"flag-sz":{"a":"Eswatini Flag","b":"1F1F8-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[4,21],"o":2},"soap":{"a":"Bar of Soap","b":"1F9FC","d":true,"e":true,"f":true,"h":true,"k":[51,47],"o":11},"flag-ta":{"a":"Tristan Da Cunha Flag","b":"1F1F9-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[4,22],"o":2},"sponge":{"a":"Sponge","b":"1F9FD","d":true,"e":true,"f":true,"h":true,"k":[51,48],"o":11},"person_in_manual_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F9D1-1F3FB-200D-1F9BD","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f9bd.png","sheet_x":47,"sheet_y":44,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FC":{"unified":"1F9D1-1F3FC-200D-1F9BD","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f9bd.png","sheet_x":47,"sheet_y":45,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FD":{"unified":"1F9D1-1F3FD-200D-1F9BD","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f9bd.png","sheet_x":47,"sheet_y":46,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FE":{"unified":"1F9D1-1F3FE-200D-1F9BD","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f9bd.png","sheet_x":47,"sheet_y":47,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false},"1F3FF":{"unified":"1F9D1-1F3FF-200D-1F9BD","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f9bd.png","sheet_x":47,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":false,"has_img_facebook":false}},"a":"Person in Manual Wheelchair","b":"1F9D1-200D-1F9BD","d":true,"e":false,"f":false,"h":false,"k":[47,43],"o":12},"fire_extinguisher":{"a":"Fire Extinguisher","b":"1F9EF","d":true,"e":true,"f":true,"h":true,"k":[51,34],"o":11},"man_in_manual_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F468-1F3FB-200D-1F9BD","non_qualified":null,"image":"1f468-1f3fb-200d-1f9bd.png","sheet_x":16,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F468-1F3FC-200D-1F9BD","non_qualified":null,"image":"1f468-1f3fc-200d-1f9bd.png","sheet_x":16,"sheet_y":55,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F468-1F3FD-200D-1F9BD","non_qualified":null,"image":"1f468-1f3fd-200d-1f9bd.png","sheet_x":16,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F468-1F3FE-200D-1F9BD","non_qualified":null,"image":"1f468-1f3fe-200d-1f9bd.png","sheet_x":17,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F468-1F3FF-200D-1F9BD","non_qualified":null,"image":"1f468-1f3ff-200d-1f9bd.png","sheet_x":17,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man in Manual Wheelchair","b":"1F468-200D-1F9BD","d":true,"e":true,"f":true,"h":true,"k":[16,53],"o":12},"flag-tc":{"a":"Turks & Caicos Islands Flag","b":"1F1F9-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[4,23],"o":2},"woman_in_manual_wheelchair":{"skin_variations":{"1F3FB":{"unified":"1F469-1F3FB-200D-1F9BD","non_qualified":null,"image":"1f469-1f3fb-200d-1f9bd.png","sheet_x":19,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F469-1F3FC-200D-1F9BD","non_qualified":null,"image":"1f469-1f3fc-200d-1f9bd.png","sheet_x":19,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F469-1F3FD-200D-1F9BD","non_qualified":null,"image":"1f469-1f3fd-200d-1f9bd.png","sheet_x":19,"sheet_y":41,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F469-1F3FE-200D-1F9BD","non_qualified":null,"image":"1f469-1f3fe-200d-1f9bd.png","sheet_x":19,"sheet_y":42,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F469-1F3FF-200D-1F9BD","non_qualified":null,"image":"1f469-1f3ff-200d-1f9bd.png","sheet_x":19,"sheet_y":43,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman in Manual Wheelchair","b":"1F469-200D-1F9BD","d":true,"e":true,"f":true,"h":true,"k":[19,38],"o":12},"flag-td":{"a":"Chad Flag","b":"1F1F9-1F1E9","d":true,"e":true,"f":true,"h":true,"k":[4,24],"o":2},"shopping_trolley":{"a":"Shopping Trolley","b":"1F6D2","d":true,"e":true,"f":true,"h":true,"k":[36,40],"o":4},"runner":{"skin_variations":{"1F3FB":{"unified":"1F3C3-1F3FB","non_qualified":null,"image":"1f3c3-1f3fb.png","sheet_x":9,"sheet_y":2,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F3C3-1F3FC","non_qualified":null,"image":"1f3c3-1f3fc.png","sheet_x":9,"sheet_y":3,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F3C3-1F3FD","non_qualified":null,"image":"1f3c3-1f3fd.png","sheet_x":9,"sheet_y":4,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F3C3-1F3FE","non_qualified":null,"image":"1f3c3-1f3fe.png","sheet_x":9,"sheet_y":5,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F3C3-1F3FF","non_qualified":null,"image":"1f3c3-1f3ff.png","sheet_x":9,"sheet_y":6,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F3C3-200D-2642-FE0F","a":"Runner","b":"1F3C3","d":true,"e":true,"f":true,"h":false,"k":[9,1],"n":["running"],"o":2},"flag-tf":{"a":"French Southern Territories Flag","b":"1F1F9-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[4,25],"o":2},"smoking":{"a":"Smoking Symbol","b":"1F6AC","d":true,"e":true,"f":true,"h":true,"j":["kills","tobacco","cigarette","joint","smoke"],"k":[35,3],"o":2},"coffin":{"a":"Coffin","b":"26B0-FE0F","c":"26B0","d":true,"e":true,"f":true,"h":true,"j":["vampire","dead","die","death","rip","graveyard","cemetery","casket","funeral","box"],"k":[53,54],"o":2},"man-running":{"skin_variations":{"1F3FB":{"unified":"1F3C3-1F3FB-200D-2642-FE0F","non_qualified":"1F3C3-1F3FB-200D-2642","image":"1f3c3-1f3fb-200d-2642-fe0f.png","sheet_x":8,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C3-1F3FC-200D-2642-FE0F","non_qualified":"1F3C3-1F3FC-200D-2642","image":"1f3c3-1f3fc-200d-2642-fe0f.png","sheet_x":8,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C3-1F3FD-200D-2642-FE0F","non_qualified":"1F3C3-1F3FD-200D-2642","image":"1f3c3-1f3fd-200d-2642-fe0f.png","sheet_x":8,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C3-1F3FE-200D-2642-FE0F","non_qualified":"1F3C3-1F3FE-200D-2642","image":"1f3c3-1f3fe-200d-2642-fe0f.png","sheet_x":8,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C3-1F3FF-200D-2642-FE0F","non_qualified":"1F3C3-1F3FF-200D-2642","image":"1f3c3-1f3ff-200d-2642-fe0f.png","sheet_x":9,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F3C3","a":"Man Running","b":"1F3C3-200D-2642-FE0F","c":"1F3C3-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[8,52],"o":4},"flag-tg":{"a":"Togo Flag","b":"1F1F9-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[4,26],"o":2},"woman-running":{"skin_variations":{"1F3FB":{"unified":"1F3C3-1F3FB-200D-2640-FE0F","non_qualified":"1F3C3-1F3FB-200D-2640","image":"1f3c3-1f3fb-200d-2640-fe0f.png","sheet_x":8,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C3-1F3FC-200D-2640-FE0F","non_qualified":"1F3C3-1F3FC-200D-2640","image":"1f3c3-1f3fc-200d-2640-fe0f.png","sheet_x":8,"sheet_y":48,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C3-1F3FD-200D-2640-FE0F","non_qualified":"1F3C3-1F3FD-200D-2640","image":"1f3c3-1f3fd-200d-2640-fe0f.png","sheet_x":8,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C3-1F3FE-200D-2640-FE0F","non_qualified":"1F3C3-1F3FE-200D-2640","image":"1f3c3-1f3fe-200d-2640-fe0f.png","sheet_x":8,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C3-1F3FF-200D-2640-FE0F","non_qualified":"1F3C3-1F3FF-200D-2640","image":"1f3c3-1f3ff-200d-2640-fe0f.png","sheet_x":8,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Running","b":"1F3C3-200D-2640-FE0F","c":"1F3C3-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[8,46],"o":4},"funeral_urn":{"a":"Funeral Urn","b":"26B1-FE0F","c":"26B1","d":true,"e":true,"f":true,"h":true,"j":["dead","die","death","rip","ashes"],"k":[53,55],"o":2},"flag-th":{"a":"Thailand Flag","b":"1F1F9-1F1ED","d":true,"e":true,"f":true,"h":true,"k":[4,27],"o":2},"moyai":{"a":"Moyai","b":"1F5FF","d":true,"e":true,"f":true,"h":true,"j":["rock","easter island","moai"],"k":[30,34],"o":2},"flag-tj":{"a":"Tajikistan Flag","b":"1F1F9-1F1EF","d":true,"e":true,"f":true,"h":true,"k":[4,28],"o":2},"dancer":{"skin_variations":{"1F3FB":{"unified":"1F483-1F3FB","non_qualified":null,"image":"1f483-1f3fb.png","sheet_x":24,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F483-1F3FC","non_qualified":null,"image":"1f483-1f3fc.png","sheet_x":24,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F483-1F3FD","non_qualified":null,"image":"1f483-1f3fd.png","sheet_x":24,"sheet_y":29,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F483-1F3FE","non_qualified":null,"image":"1f483-1f3fe.png","sheet_x":24,"sheet_y":30,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F483-1F3FF","non_qualified":null,"image":"1f483-1f3ff.png","sheet_x":24,"sheet_y":31,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Dancer","b":"1F483","d":true,"e":true,"f":true,"h":true,"j":["female","girl","woman","fun"],"k":[24,26],"o":2},"flag-tk":{"a":"Tokelau Flag","b":"1F1F9-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[4,29],"o":2},"man_dancing":{"skin_variations":{"1F3FB":{"unified":"1F57A-1F3FB","non_qualified":null,"image":"1f57a-1f3fb.png","sheet_x":29,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F57A-1F3FC","non_qualified":null,"image":"1f57a-1f3fc.png","sheet_x":29,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F57A-1F3FD","non_qualified":null,"image":"1f57a-1f3fd.png","sheet_x":29,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F57A-1F3FE","non_qualified":null,"image":"1f57a-1f3fe.png","sheet_x":29,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F57A-1F3FF","non_qualified":null,"image":"1f57a-1f3ff.png","sheet_x":29,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Dancing","b":"1F57A","d":true,"e":true,"f":true,"h":true,"j":["male","boy","fun","dancer"],"k":[29,37],"o":4},"flag-tl":{"a":"Timor-Leste Flag","b":"1F1F9-1F1F1","d":true,"e":true,"f":true,"h":true,"k":[4,30],"o":2},"man_in_business_suit_levitating":{"skin_variations":{"1F3FB":{"unified":"1F574-1F3FB","non_qualified":null,"image":"1f574-1f3fb.png","sheet_x":29,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F574-1F3FC","non_qualified":null,"image":"1f574-1f3fc.png","sheet_x":29,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F574-1F3FD","non_qualified":null,"image":"1f574-1f3fd.png","sheet_x":29,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F574-1F3FE","non_qualified":null,"image":"1f574-1f3fe.png","sheet_x":29,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F574-1F3FF","non_qualified":null,"image":"1f574-1f3ff.png","sheet_x":29,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man in Business Suit Levitating","b":"1F574-FE0F","c":"1F574","d":true,"e":true,"f":true,"h":true,"k":[29,9],"o":2},"flag-tm":{"a":"Turkmenistan Flag","b":"1F1F9-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[4,31],"o":2},"dancers":{"obsoleted_by":"1F46F-200D-2640-FE0F","a":"Woman with Bunny Ears","b":"1F46F","d":true,"e":true,"f":true,"h":true,"k":[22,0],"o":2},"man-with-bunny-ears-partying":{"a":"Man with Bunny Ears Partying","b":"1F46F-200D-2642-FE0F","c":"1F46F-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[21,56],"o":4},"flag-tn":{"a":"Tunisia Flag","b":"1F1F9-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[4,32],"o":2},"flag-to":{"a":"Tonga Flag","b":"1F1F9-1F1F4","d":true,"e":true,"f":true,"h":true,"k":[4,33],"o":2},"woman-with-bunny-ears-partying":{"obsoletes":"1F46F","a":"Woman with Bunny Ears Partying","b":"1F46F-200D-2640-FE0F","c":"1F46F-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[21,55],"o":4},"flag-tr":{"a":"Turkey Flag","b":"1F1F9-1F1F7","d":true,"e":true,"f":true,"h":true,"k":[4,34],"o":2},"person_in_steamy_room":{"skin_variations":{"1F3FB":{"unified":"1F9D6-1F3FB","non_qualified":null,"image":"1f9d6-1f3fb.png","sheet_x":48,"sheet_y":53,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D6-1F3FB-200D-2642-FE0F"},"1F3FC":{"unified":"1F9D6-1F3FC","non_qualified":null,"image":"1f9d6-1f3fc.png","sheet_x":48,"sheet_y":54,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D6-1F3FC-200D-2642-FE0F"},"1F3FD":{"unified":"1F9D6-1F3FD","non_qualified":null,"image":"1f9d6-1f3fd.png","sheet_x":48,"sheet_y":55,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D6-1F3FD-200D-2642-FE0F"},"1F3FE":{"unified":"1F9D6-1F3FE","non_qualified":null,"image":"1f9d6-1f3fe.png","sheet_x":48,"sheet_y":56,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D6-1F3FE-200D-2642-FE0F"},"1F3FF":{"unified":"1F9D6-1F3FF","non_qualified":null,"image":"1f9d6-1f3ff.png","sheet_x":49,"sheet_y":0,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D6-1F3FF-200D-2642-FE0F"}},"obsoleted_by":"1F9D6-200D-2642-FE0F","a":"Person in Steamy Room","b":"1F9D6","d":true,"e":true,"f":true,"h":true,"k":[48,52],"o":5},"man_in_steamy_room":{"skin_variations":{"1F3FB":{"unified":"1F9D6-1F3FB-200D-2642-FE0F","non_qualified":"1F9D6-1F3FB-200D-2642","image":"1f9d6-1f3fb-200d-2642-fe0f.png","sheet_x":48,"sheet_y":47,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D6-1F3FB"},"1F3FC":{"unified":"1F9D6-1F3FC-200D-2642-FE0F","non_qualified":"1F9D6-1F3FC-200D-2642","image":"1f9d6-1f3fc-200d-2642-fe0f.png","sheet_x":48,"sheet_y":48,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D6-1F3FC"},"1F3FD":{"unified":"1F9D6-1F3FD-200D-2642-FE0F","non_qualified":"1F9D6-1F3FD-200D-2642","image":"1f9d6-1f3fd-200d-2642-fe0f.png","sheet_x":48,"sheet_y":49,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D6-1F3FD"},"1F3FE":{"unified":"1F9D6-1F3FE-200D-2642-FE0F","non_qualified":"1F9D6-1F3FE-200D-2642","image":"1f9d6-1f3fe-200d-2642-fe0f.png","sheet_x":48,"sheet_y":50,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D6-1F3FE"},"1F3FF":{"unified":"1F9D6-1F3FF-200D-2642-FE0F","non_qualified":"1F9D6-1F3FF-200D-2642","image":"1f9d6-1f3ff-200d-2642-fe0f.png","sheet_x":48,"sheet_y":51,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D6-1F3FF"}},"obsoletes":"1F9D6","a":"Man in Steamy Room","b":"1F9D6-200D-2642-FE0F","c":"1F9D6-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[48,46],"o":5},"flag-tt":{"a":"Trinidad & Tobago Flag","b":"1F1F9-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[4,35],"o":2},"woman_in_steamy_room":{"skin_variations":{"1F3FB":{"unified":"1F9D6-1F3FB-200D-2640-FE0F","non_qualified":"1F9D6-1F3FB-200D-2640","image":"1f9d6-1f3fb-200d-2640-fe0f.png","sheet_x":48,"sheet_y":41,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D6-1F3FC-200D-2640-FE0F","non_qualified":"1F9D6-1F3FC-200D-2640","image":"1f9d6-1f3fc-200d-2640-fe0f.png","sheet_x":48,"sheet_y":42,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D6-1F3FD-200D-2640-FE0F","non_qualified":"1F9D6-1F3FD-200D-2640","image":"1f9d6-1f3fd-200d-2640-fe0f.png","sheet_x":48,"sheet_y":43,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D6-1F3FE-200D-2640-FE0F","non_qualified":"1F9D6-1F3FE-200D-2640","image":"1f9d6-1f3fe-200d-2640-fe0f.png","sheet_x":48,"sheet_y":44,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D6-1F3FF-200D-2640-FE0F","non_qualified":"1F9D6-1F3FF-200D-2640","image":"1f9d6-1f3ff-200d-2640-fe0f.png","sheet_x":48,"sheet_y":45,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman in Steamy Room","b":"1F9D6-200D-2640-FE0F","c":"1F9D6-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[48,40],"o":5},"flag-tv":{"a":"Tuvalu Flag","b":"1F1F9-1F1FB","d":true,"e":true,"f":true,"h":true,"k":[4,36],"o":2},"flag-tw":{"a":"Taiwan Flag","b":"1F1F9-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[4,37],"o":2},"person_climbing":{"skin_variations":{"1F3FB":{"unified":"1F9D7-1F3FB","non_qualified":null,"image":"1f9d7-1f3fb.png","sheet_x":49,"sheet_y":14,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D7-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9D7-1F3FC","non_qualified":null,"image":"1f9d7-1f3fc.png","sheet_x":49,"sheet_y":15,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D7-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9D7-1F3FD","non_qualified":null,"image":"1f9d7-1f3fd.png","sheet_x":49,"sheet_y":16,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D7-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9D7-1F3FE","non_qualified":null,"image":"1f9d7-1f3fe.png","sheet_x":49,"sheet_y":17,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D7-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9D7-1F3FF","non_qualified":null,"image":"1f9d7-1f3ff.png","sheet_x":49,"sheet_y":18,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D7-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9D7-200D-2640-FE0F","a":"Person Climbing","b":"1F9D7","d":true,"e":true,"f":true,"h":true,"k":[49,13],"o":5},"man_climbing":{"skin_variations":{"1F3FB":{"unified":"1F9D7-1F3FB-200D-2642-FE0F","non_qualified":"1F9D7-1F3FB-200D-2642","image":"1f9d7-1f3fb-200d-2642-fe0f.png","sheet_x":49,"sheet_y":8,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D7-1F3FC-200D-2642-FE0F","non_qualified":"1F9D7-1F3FC-200D-2642","image":"1f9d7-1f3fc-200d-2642-fe0f.png","sheet_x":49,"sheet_y":9,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D7-1F3FD-200D-2642-FE0F","non_qualified":"1F9D7-1F3FD-200D-2642","image":"1f9d7-1f3fd-200d-2642-fe0f.png","sheet_x":49,"sheet_y":10,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D7-1F3FE-200D-2642-FE0F","non_qualified":"1F9D7-1F3FE-200D-2642","image":"1f9d7-1f3fe-200d-2642-fe0f.png","sheet_x":49,"sheet_y":11,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D7-1F3FF-200D-2642-FE0F","non_qualified":"1F9D7-1F3FF-200D-2642","image":"1f9d7-1f3ff-200d-2642-fe0f.png","sheet_x":49,"sheet_y":12,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Climbing","b":"1F9D7-200D-2642-FE0F","c":"1F9D7-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[49,7],"o":5},"flag-tz":{"a":"Tanzania Flag","b":"1F1F9-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[4,38],"o":2},"flag-ua":{"a":"Ukraine Flag","b":"1F1FA-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[4,39],"o":2},"woman_climbing":{"skin_variations":{"1F3FB":{"unified":"1F9D7-1F3FB-200D-2640-FE0F","non_qualified":"1F9D7-1F3FB-200D-2640","image":"1f9d7-1f3fb-200d-2640-fe0f.png","sheet_x":49,"sheet_y":2,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D7-1F3FB"},"1F3FC":{"unified":"1F9D7-1F3FC-200D-2640-FE0F","non_qualified":"1F9D7-1F3FC-200D-2640","image":"1f9d7-1f3fc-200d-2640-fe0f.png","sheet_x":49,"sheet_y":3,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D7-1F3FC"},"1F3FD":{"unified":"1F9D7-1F3FD-200D-2640-FE0F","non_qualified":"1F9D7-1F3FD-200D-2640","image":"1f9d7-1f3fd-200d-2640-fe0f.png","sheet_x":49,"sheet_y":4,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D7-1F3FD"},"1F3FE":{"unified":"1F9D7-1F3FE-200D-2640-FE0F","non_qualified":"1F9D7-1F3FE-200D-2640","image":"1f9d7-1f3fe-200d-2640-fe0f.png","sheet_x":49,"sheet_y":5,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D7-1F3FE"},"1F3FF":{"unified":"1F9D7-1F3FF-200D-2640-FE0F","non_qualified":"1F9D7-1F3FF-200D-2640","image":"1f9d7-1f3ff-200d-2640-fe0f.png","sheet_x":49,"sheet_y":6,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D7-1F3FF"}},"obsoletes":"1F9D7","a":"Woman Climbing","b":"1F9D7-200D-2640-FE0F","c":"1F9D7-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[49,1],"o":5},"flag-ug":{"a":"Uganda Flag","b":"1F1FA-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[4,40],"o":2},"fencer":{"a":"Fencer","b":"1F93A","d":true,"e":true,"f":true,"h":true,"k":[40,32],"o":4},"flag-um":{"a":"U.s. Outlying Islands Flag","b":"1F1FA-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[4,41],"o":2},"horse_racing":{"skin_variations":{"1F3FB":{"unified":"1F3C7-1F3FB","non_qualified":null,"image":"1f3c7-1f3fb.png","sheet_x":9,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C7-1F3FC","non_qualified":null,"image":"1f3c7-1f3fc.png","sheet_x":9,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C7-1F3FD","non_qualified":null,"image":"1f3c7-1f3fd.png","sheet_x":9,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C7-1F3FE","non_qualified":null,"image":"1f3c7-1f3fe.png","sheet_x":9,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C7-1F3FF","non_qualified":null,"image":"1f3c7-1f3ff.png","sheet_x":9,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Horse Racing","b":"1F3C7","d":true,"e":true,"f":true,"h":true,"j":["animal","betting","competition","gambling","luck"],"k":[9,27],"o":2},"skier":{"a":"Skier","b":"26F7-FE0F","c":"26F7","d":true,"e":true,"f":true,"h":true,"j":["sports","winter","snow"],"k":[54,17],"o":2},"flag-un":{"a":"United Nations Flag","b":"1F1FA-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[4,42],"o":4},"us":{"a":"United States Flag","b":"1F1FA-1F1F8","d":true,"e":true,"f":true,"h":true,"j":["united","states","america","flag","nation","country","banner"],"k":[4,43],"n":["flag-us"],"o":2},"snowboarder":{"skin_variations":{"1F3FB":{"unified":"1F3C2-1F3FB","non_qualified":null,"image":"1f3c2-1f3fb.png","sheet_x":8,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C2-1F3FC","non_qualified":null,"image":"1f3c2-1f3fc.png","sheet_x":8,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C2-1F3FD","non_qualified":null,"image":"1f3c2-1f3fd.png","sheet_x":8,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C2-1F3FE","non_qualified":null,"image":"1f3c2-1f3fe.png","sheet_x":8,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C2-1F3FF","non_qualified":null,"image":"1f3c2-1f3ff.png","sheet_x":8,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Snowboarder","b":"1F3C2","d":true,"e":true,"f":true,"h":true,"j":["sports","winter"],"k":[8,40],"o":2},"golfer":{"skin_variations":{"1F3FB":{"unified":"1F3CC-1F3FB","non_qualified":null,"image":"1f3cc-1f3fb.png","sheet_x":10,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F3CC-1F3FC","non_qualified":null,"image":"1f3cc-1f3fc.png","sheet_x":10,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F3CC-1F3FD","non_qualified":null,"image":"1f3cc-1f3fd.png","sheet_x":10,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F3CC-1F3FE","non_qualified":null,"image":"1f3cc-1f3fe.png","sheet_x":10,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F3CC-1F3FF","non_qualified":null,"image":"1f3cc-1f3ff.png","sheet_x":10,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F3CC-FE0F-200D-2642-FE0F","a":"Golfer","b":"1F3CC-FE0F","c":"1F3CC","d":true,"e":true,"f":true,"h":false,"k":[10,26],"o":2},"flag-uy":{"a":"Uruguay Flag","b":"1F1FA-1F1FE","d":true,"e":true,"f":true,"h":true,"k":[4,44],"o":2},"flag-uz":{"a":"Uzbekistan Flag","b":"1F1FA-1F1FF","d":true,"e":true,"f":true,"h":true,"k":[4,45],"o":2},"man-golfing":{"skin_variations":{"1F3FB":{"unified":"1F3CC-1F3FB-200D-2642-FE0F","non_qualified":"1F3CC-1F3FB-200D-2642","image":"1f3cc-1f3fb-200d-2642-fe0f.png","sheet_x":10,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CC-1F3FC-200D-2642-FE0F","non_qualified":"1F3CC-1F3FC-200D-2642","image":"1f3cc-1f3fc-200d-2642-fe0f.png","sheet_x":10,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CC-1F3FD-200D-2642-FE0F","non_qualified":"1F3CC-1F3FD-200D-2642","image":"1f3cc-1f3fd-200d-2642-fe0f.png","sheet_x":10,"sheet_y":23,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CC-1F3FE-200D-2642-FE0F","non_qualified":"1F3CC-1F3FE-200D-2642","image":"1f3cc-1f3fe-200d-2642-fe0f.png","sheet_x":10,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CC-1F3FF-200D-2642-FE0F","non_qualified":"1F3CC-1F3FF-200D-2642","image":"1f3cc-1f3ff-200d-2642-fe0f.png","sheet_x":10,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F3CC-FE0F","a":"Man Golfing","b":"1F3CC-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"h":false,"k":[10,20],"o":4},"flag-va":{"a":"Vatican City Flag","b":"1F1FB-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[4,46],"o":2},"woman-golfing":{"skin_variations":{"1F3FB":{"unified":"1F3CC-1F3FB-200D-2640-FE0F","non_qualified":"1F3CC-1F3FB-200D-2640","image":"1f3cc-1f3fb-200d-2640-fe0f.png","sheet_x":10,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CC-1F3FC-200D-2640-FE0F","non_qualified":"1F3CC-1F3FC-200D-2640","image":"1f3cc-1f3fc-200d-2640-fe0f.png","sheet_x":10,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CC-1F3FD-200D-2640-FE0F","non_qualified":"1F3CC-1F3FD-200D-2640","image":"1f3cc-1f3fd-200d-2640-fe0f.png","sheet_x":10,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CC-1F3FE-200D-2640-FE0F","non_qualified":"1F3CC-1F3FE-200D-2640","image":"1f3cc-1f3fe-200d-2640-fe0f.png","sheet_x":10,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CC-1F3FF-200D-2640-FE0F","non_qualified":"1F3CC-1F3FF-200D-2640","image":"1f3cc-1f3ff-200d-2640-fe0f.png","sheet_x":10,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Golfing","b":"1F3CC-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"h":false,"k":[10,14],"o":4},"flag-vc":{"a":"St. Vincent & Grenadines Flag","b":"1F1FB-1F1E8","d":true,"e":true,"f":true,"h":true,"k":[4,47],"o":2},"surfer":{"skin_variations":{"1F3FB":{"unified":"1F3C4-1F3FB","non_qualified":null,"image":"1f3c4-1f3fb.png","sheet_x":9,"sheet_y":20,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F3C4-1F3FC","non_qualified":null,"image":"1f3c4-1f3fc.png","sheet_x":9,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F3C4-1F3FD","non_qualified":null,"image":"1f3c4-1f3fd.png","sheet_x":9,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F3C4-1F3FE","non_qualified":null,"image":"1f3c4-1f3fe.png","sheet_x":9,"sheet_y":23,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F3C4-1F3FF","non_qualified":null,"image":"1f3c4-1f3ff.png","sheet_x":9,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F3C4-200D-2642-FE0F","a":"Surfer","b":"1F3C4","d":true,"e":true,"f":true,"h":false,"k":[9,19],"o":2},"man-surfing":{"skin_variations":{"1F3FB":{"unified":"1F3C4-1F3FB-200D-2642-FE0F","non_qualified":"1F3C4-1F3FB-200D-2642","image":"1f3c4-1f3fb-200d-2642-fe0f.png","sheet_x":9,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C4-1F3FC-200D-2642-FE0F","non_qualified":"1F3C4-1F3FC-200D-2642","image":"1f3c4-1f3fc-200d-2642-fe0f.png","sheet_x":9,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C4-1F3FD-200D-2642-FE0F","non_qualified":"1F3C4-1F3FD-200D-2642","image":"1f3c4-1f3fd-200d-2642-fe0f.png","sheet_x":9,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C4-1F3FE-200D-2642-FE0F","non_qualified":"1F3C4-1F3FE-200D-2642","image":"1f3c4-1f3fe-200d-2642-fe0f.png","sheet_x":9,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C4-1F3FF-200D-2642-FE0F","non_qualified":"1F3C4-1F3FF-200D-2642","image":"1f3c4-1f3ff-200d-2642-fe0f.png","sheet_x":9,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F3C4","a":"Man Surfing","b":"1F3C4-200D-2642-FE0F","c":"1F3C4-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[9,13],"o":4},"flag-ve":{"a":"Venezuela Flag","b":"1F1FB-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[4,48],"o":2},"flag-vg":{"a":"British Virgin Islands Flag","b":"1F1FB-1F1EC","d":true,"e":true,"f":true,"h":true,"k":[4,49],"o":2},"woman-surfing":{"skin_variations":{"1F3FB":{"unified":"1F3C4-1F3FB-200D-2640-FE0F","non_qualified":"1F3C4-1F3FB-200D-2640","image":"1f3c4-1f3fb-200d-2640-fe0f.png","sheet_x":9,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3C4-1F3FC-200D-2640-FE0F","non_qualified":"1F3C4-1F3FC-200D-2640","image":"1f3c4-1f3fc-200d-2640-fe0f.png","sheet_x":9,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3C4-1F3FD-200D-2640-FE0F","non_qualified":"1F3C4-1F3FD-200D-2640","image":"1f3c4-1f3fd-200d-2640-fe0f.png","sheet_x":9,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3C4-1F3FE-200D-2640-FE0F","non_qualified":"1F3C4-1F3FE-200D-2640","image":"1f3c4-1f3fe-200d-2640-fe0f.png","sheet_x":9,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3C4-1F3FF-200D-2640-FE0F","non_qualified":"1F3C4-1F3FF-200D-2640","image":"1f3c4-1f3ff-200d-2640-fe0f.png","sheet_x":9,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Surfing","b":"1F3C4-200D-2640-FE0F","c":"1F3C4-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[9,7],"o":4},"rowboat":{"skin_variations":{"1F3FB":{"unified":"1F6A3-1F3FB","non_qualified":null,"image":"1f6a3-1f3fb.png","sheet_x":34,"sheet_y":47,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F6A3-1F3FC","non_qualified":null,"image":"1f6a3-1f3fc.png","sheet_x":34,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F6A3-1F3FD","non_qualified":null,"image":"1f6a3-1f3fd.png","sheet_x":34,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F6A3-1F3FE","non_qualified":null,"image":"1f6a3-1f3fe.png","sheet_x":34,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F6A3-1F3FF","non_qualified":null,"image":"1f6a3-1f3ff.png","sheet_x":34,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F6A3-200D-2642-FE0F","a":"Rowboat","b":"1F6A3","d":true,"e":true,"f":true,"h":false,"k":[34,46],"o":2},"flag-vi":{"a":"U.s. Virgin Islands Flag","b":"1F1FB-1F1EE","d":true,"e":true,"f":true,"h":true,"k":[4,50],"o":2},"man-rowing-boat":{"skin_variations":{"1F3FB":{"unified":"1F6A3-1F3FB-200D-2642-FE0F","non_qualified":"1F6A3-1F3FB-200D-2642","image":"1f6a3-1f3fb-200d-2642-fe0f.png","sheet_x":34,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6A3-1F3FC-200D-2642-FE0F","non_qualified":"1F6A3-1F3FC-200D-2642","image":"1f6a3-1f3fc-200d-2642-fe0f.png","sheet_x":34,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6A3-1F3FD-200D-2642-FE0F","non_qualified":"1F6A3-1F3FD-200D-2642","image":"1f6a3-1f3fd-200d-2642-fe0f.png","sheet_x":34,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6A3-1F3FE-200D-2642-FE0F","non_qualified":"1F6A3-1F3FE-200D-2642","image":"1f6a3-1f3fe-200d-2642-fe0f.png","sheet_x":34,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6A3-1F3FF-200D-2642-FE0F","non_qualified":"1F6A3-1F3FF-200D-2642","image":"1f6a3-1f3ff-200d-2642-fe0f.png","sheet_x":34,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F6A3","a":"Man Rowing Boat","b":"1F6A3-200D-2642-FE0F","c":"1F6A3-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[34,40],"o":4},"flag-vn":{"a":"Vietnam Flag","b":"1F1FB-1F1F3","d":true,"e":true,"f":true,"h":true,"k":[4,51],"o":2},"flag-vu":{"a":"Vanuatu Flag","b":"1F1FB-1F1FA","d":true,"e":true,"f":true,"h":true,"k":[4,52],"o":2},"woman-rowing-boat":{"skin_variations":{"1F3FB":{"unified":"1F6A3-1F3FB-200D-2640-FE0F","non_qualified":"1F6A3-1F3FB-200D-2640","image":"1f6a3-1f3fb-200d-2640-fe0f.png","sheet_x":34,"sheet_y":35,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6A3-1F3FC-200D-2640-FE0F","non_qualified":"1F6A3-1F3FC-200D-2640","image":"1f6a3-1f3fc-200d-2640-fe0f.png","sheet_x":34,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6A3-1F3FD-200D-2640-FE0F","non_qualified":"1F6A3-1F3FD-200D-2640","image":"1f6a3-1f3fd-200d-2640-fe0f.png","sheet_x":34,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6A3-1F3FE-200D-2640-FE0F","non_qualified":"1F6A3-1F3FE-200D-2640","image":"1f6a3-1f3fe-200d-2640-fe0f.png","sheet_x":34,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6A3-1F3FF-200D-2640-FE0F","non_qualified":"1F6A3-1F3FF-200D-2640","image":"1f6a3-1f3ff-200d-2640-fe0f.png","sheet_x":34,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Rowing Boat","b":"1F6A3-200D-2640-FE0F","c":"1F6A3-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[34,34],"o":4},"swimmer":{"skin_variations":{"1F3FB":{"unified":"1F3CA-1F3FB","non_qualified":null,"image":"1f3ca-1f3fb.png","sheet_x":9,"sheet_y":48,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F3CA-1F3FC","non_qualified":null,"image":"1f3ca-1f3fc.png","sheet_x":9,"sheet_y":49,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F3CA-1F3FD","non_qualified":null,"image":"1f3ca-1f3fd.png","sheet_x":9,"sheet_y":50,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F3CA-1F3FE","non_qualified":null,"image":"1f3ca-1f3fe.png","sheet_x":9,"sheet_y":51,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F3CA-1F3FF","non_qualified":null,"image":"1f3ca-1f3ff.png","sheet_x":9,"sheet_y":52,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F3CA-200D-2642-FE0F","a":"Swimmer","b":"1F3CA","d":true,"e":true,"f":true,"h":false,"k":[9,47],"o":2},"flag-wf":{"a":"Wallis & Futuna Flag","b":"1F1FC-1F1EB","d":true,"e":true,"f":true,"h":true,"k":[4,53],"o":2},"man-swimming":{"skin_variations":{"1F3FB":{"unified":"1F3CA-1F3FB-200D-2642-FE0F","non_qualified":"1F3CA-1F3FB-200D-2642","image":"1f3ca-1f3fb-200d-2642-fe0f.png","sheet_x":9,"sheet_y":42,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CA-1F3FC-200D-2642-FE0F","non_qualified":"1F3CA-1F3FC-200D-2642","image":"1f3ca-1f3fc-200d-2642-fe0f.png","sheet_x":9,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CA-1F3FD-200D-2642-FE0F","non_qualified":"1F3CA-1F3FD-200D-2642","image":"1f3ca-1f3fd-200d-2642-fe0f.png","sheet_x":9,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CA-1F3FE-200D-2642-FE0F","non_qualified":"1F3CA-1F3FE-200D-2642","image":"1f3ca-1f3fe-200d-2642-fe0f.png","sheet_x":9,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CA-1F3FF-200D-2642-FE0F","non_qualified":"1F3CA-1F3FF-200D-2642","image":"1f3ca-1f3ff-200d-2642-fe0f.png","sheet_x":9,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F3CA","a":"Man Swimming","b":"1F3CA-200D-2642-FE0F","c":"1F3CA-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[9,41],"o":4},"flag-ws":{"a":"Samoa Flag","b":"1F1FC-1F1F8","d":true,"e":true,"f":true,"h":true,"k":[4,54],"o":2},"woman-swimming":{"skin_variations":{"1F3FB":{"unified":"1F3CA-1F3FB-200D-2640-FE0F","non_qualified":"1F3CA-1F3FB-200D-2640","image":"1f3ca-1f3fb-200d-2640-fe0f.png","sheet_x":9,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CA-1F3FC-200D-2640-FE0F","non_qualified":"1F3CA-1F3FC-200D-2640","image":"1f3ca-1f3fc-200d-2640-fe0f.png","sheet_x":9,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CA-1F3FD-200D-2640-FE0F","non_qualified":"1F3CA-1F3FD-200D-2640","image":"1f3ca-1f3fd-200d-2640-fe0f.png","sheet_x":9,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CA-1F3FE-200D-2640-FE0F","non_qualified":"1F3CA-1F3FE-200D-2640","image":"1f3ca-1f3fe-200d-2640-fe0f.png","sheet_x":9,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CA-1F3FF-200D-2640-FE0F","non_qualified":"1F3CA-1F3FF-200D-2640","image":"1f3ca-1f3ff-200d-2640-fe0f.png","sheet_x":9,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Swimming","b":"1F3CA-200D-2640-FE0F","c":"1F3CA-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[9,35],"o":4},"flag-xk":{"a":"Kosovo Flag","b":"1F1FD-1F1F0","d":true,"e":true,"f":true,"h":true,"k":[4,55],"o":2},"person_with_ball":{"skin_variations":{"1F3FB":{"unified":"26F9-1F3FB","non_qualified":null,"image":"26f9-1f3fb.png","sheet_x":54,"sheet_y":32,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"26F9-1F3FC","non_qualified":null,"image":"26f9-1f3fc.png","sheet_x":54,"sheet_y":33,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"26F9-1F3FD","non_qualified":null,"image":"26f9-1f3fd.png","sheet_x":54,"sheet_y":34,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"26F9-1F3FE","non_qualified":null,"image":"26f9-1f3fe.png","sheet_x":54,"sheet_y":35,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"26F9-1F3FF","non_qualified":null,"image":"26f9-1f3ff.png","sheet_x":54,"sheet_y":36,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"26F9-FE0F-200D-2642-FE0F","a":"Person with Ball","b":"26F9-FE0F","c":"26F9","d":true,"e":true,"f":true,"h":false,"k":[54,31],"o":2},"flag-ye":{"a":"Yemen Flag","b":"1F1FE-1F1EA","d":true,"e":true,"f":true,"h":true,"k":[4,56],"o":2},"man-bouncing-ball":{"skin_variations":{"1F3FB":{"unified":"26F9-1F3FB-200D-2642-FE0F","non_qualified":"26F9-1F3FB-200D-2642","image":"26f9-1f3fb-200d-2642-fe0f.png","sheet_x":54,"sheet_y":26,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"26F9-1F3FC-200D-2642-FE0F","non_qualified":"26F9-1F3FC-200D-2642","image":"26f9-1f3fc-200d-2642-fe0f.png","sheet_x":54,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"26F9-1F3FD-200D-2642-FE0F","non_qualified":"26F9-1F3FD-200D-2642","image":"26f9-1f3fd-200d-2642-fe0f.png","sheet_x":54,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"26F9-1F3FE-200D-2642-FE0F","non_qualified":"26F9-1F3FE-200D-2642","image":"26f9-1f3fe-200d-2642-fe0f.png","sheet_x":54,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"26F9-1F3FF-200D-2642-FE0F","non_qualified":"26F9-1F3FF-200D-2642","image":"26f9-1f3ff-200d-2642-fe0f.png","sheet_x":54,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"26F9-FE0F","a":"Man Bouncing Ball","b":"26F9-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"h":false,"k":[54,25],"o":4},"flag-yt":{"a":"Mayotte Flag","b":"1F1FE-1F1F9","d":true,"e":true,"f":true,"h":true,"k":[5,0],"o":2},"woman-bouncing-ball":{"skin_variations":{"1F3FB":{"unified":"26F9-1F3FB-200D-2640-FE0F","non_qualified":"26F9-1F3FB-200D-2640","image":"26f9-1f3fb-200d-2640-fe0f.png","sheet_x":54,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"26F9-1F3FC-200D-2640-FE0F","non_qualified":"26F9-1F3FC-200D-2640","image":"26f9-1f3fc-200d-2640-fe0f.png","sheet_x":54,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"26F9-1F3FD-200D-2640-FE0F","non_qualified":"26F9-1F3FD-200D-2640","image":"26f9-1f3fd-200d-2640-fe0f.png","sheet_x":54,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"26F9-1F3FE-200D-2640-FE0F","non_qualified":"26F9-1F3FE-200D-2640","image":"26f9-1f3fe-200d-2640-fe0f.png","sheet_x":54,"sheet_y":23,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"26F9-1F3FF-200D-2640-FE0F","non_qualified":"26F9-1F3FF-200D-2640","image":"26f9-1f3ff-200d-2640-fe0f.png","sheet_x":54,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Bouncing Ball","b":"26F9-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"h":false,"k":[54,19],"o":4},"flag-za":{"a":"South Africa Flag","b":"1F1FF-1F1E6","d":true,"e":true,"f":true,"h":true,"k":[5,1],"o":2},"flag-zm":{"a":"Zambia Flag","b":"1F1FF-1F1F2","d":true,"e":true,"f":true,"h":true,"k":[5,2],"o":2},"weight_lifter":{"skin_variations":{"1F3FB":{"unified":"1F3CB-1F3FB","non_qualified":null,"image":"1f3cb-1f3fb.png","sheet_x":10,"sheet_y":9,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F3CB-1F3FC","non_qualified":null,"image":"1f3cb-1f3fc.png","sheet_x":10,"sheet_y":10,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F3CB-1F3FD","non_qualified":null,"image":"1f3cb-1f3fd.png","sheet_x":10,"sheet_y":11,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F3CB-1F3FE","non_qualified":null,"image":"1f3cb-1f3fe.png","sheet_x":10,"sheet_y":12,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F3CB-1F3FF","non_qualified":null,"image":"1f3cb-1f3ff.png","sheet_x":10,"sheet_y":13,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F3CB-FE0F-200D-2642-FE0F","a":"Weight Lifter","b":"1F3CB-FE0F","c":"1F3CB","d":true,"e":true,"f":true,"h":false,"k":[10,8],"o":2},"man-lifting-weights":{"skin_variations":{"1F3FB":{"unified":"1F3CB-1F3FB-200D-2642-FE0F","non_qualified":"1F3CB-1F3FB-200D-2642","image":"1f3cb-1f3fb-200d-2642-fe0f.png","sheet_x":10,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CB-1F3FC-200D-2642-FE0F","non_qualified":"1F3CB-1F3FC-200D-2642","image":"1f3cb-1f3fc-200d-2642-fe0f.png","sheet_x":10,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CB-1F3FD-200D-2642-FE0F","non_qualified":"1F3CB-1F3FD-200D-2642","image":"1f3cb-1f3fd-200d-2642-fe0f.png","sheet_x":10,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CB-1F3FE-200D-2642-FE0F","non_qualified":"1F3CB-1F3FE-200D-2642","image":"1f3cb-1f3fe-200d-2642-fe0f.png","sheet_x":10,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CB-1F3FF-200D-2642-FE0F","non_qualified":"1F3CB-1F3FF-200D-2642","image":"1f3cb-1f3ff-200d-2642-fe0f.png","sheet_x":10,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F3CB-FE0F","a":"Man Lifting Weights","b":"1F3CB-FE0F-200D-2642-FE0F","d":true,"e":true,"f":true,"h":false,"k":[10,2],"o":4},"flag-zw":{"a":"Zimbabwe Flag","b":"1F1FF-1F1FC","d":true,"e":true,"f":true,"h":true,"k":[5,3],"o":2},"woman-lifting-weights":{"skin_variations":{"1F3FB":{"unified":"1F3CB-1F3FB-200D-2640-FE0F","non_qualified":"1F3CB-1F3FB-200D-2640","image":"1f3cb-1f3fb-200d-2640-fe0f.png","sheet_x":9,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F3CB-1F3FC-200D-2640-FE0F","non_qualified":"1F3CB-1F3FC-200D-2640","image":"1f3cb-1f3fc-200d-2640-fe0f.png","sheet_x":9,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F3CB-1F3FD-200D-2640-FE0F","non_qualified":"1F3CB-1F3FD-200D-2640","image":"1f3cb-1f3fd-200d-2640-fe0f.png","sheet_x":9,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F3CB-1F3FE-200D-2640-FE0F","non_qualified":"1F3CB-1F3FE-200D-2640","image":"1f3cb-1f3fe-200d-2640-fe0f.png","sheet_x":10,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F3CB-1F3FF-200D-2640-FE0F","non_qualified":"1F3CB-1F3FF-200D-2640","image":"1f3cb-1f3ff-200d-2640-fe0f.png","sheet_x":10,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Lifting Weights","b":"1F3CB-FE0F-200D-2640-FE0F","d":true,"e":true,"f":true,"h":false,"k":[9,53],"o":4},"flag-england":{"a":"England Flag","b":"1F3F4-E0067-E0062-E0065-E006E-E0067-E007F","d":true,"e":true,"f":true,"h":true,"k":[11,14],"o":5},"bicyclist":{"skin_variations":{"1F3FB":{"unified":"1F6B4-1F3FB","non_qualified":null,"image":"1f6b4-1f3fb.png","sheet_x":35,"sheet_y":24,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F6B4-1F3FC","non_qualified":null,"image":"1f6b4-1f3fc.png","sheet_x":35,"sheet_y":25,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F6B4-1F3FD","non_qualified":null,"image":"1f6b4-1f3fd.png","sheet_x":35,"sheet_y":26,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F6B4-1F3FE","non_qualified":null,"image":"1f6b4-1f3fe.png","sheet_x":35,"sheet_y":27,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F6B4-1F3FF","non_qualified":null,"image":"1f6b4-1f3ff.png","sheet_x":35,"sheet_y":28,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F6B4-200D-2642-FE0F","a":"Bicyclist","b":"1F6B4","d":true,"e":true,"f":true,"h":false,"k":[35,23],"o":2},"flag-scotland":{"a":"Scotland Flag","b":"1F3F4-E0067-E0062-E0073-E0063-E0074-E007F","d":true,"e":true,"f":true,"h":true,"k":[11,15],"o":5},"flag-wales":{"a":"Wales Flag","b":"1F3F4-E0067-E0062-E0077-E006C-E0073-E007F","d":true,"e":true,"f":true,"h":true,"k":[11,16],"o":5},"man-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B4-1F3FB-200D-2642-FE0F","non_qualified":"1F6B4-1F3FB-200D-2642","image":"1f6b4-1f3fb-200d-2642-fe0f.png","sheet_x":35,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B4-1F3FC-200D-2642-FE0F","non_qualified":"1F6B4-1F3FC-200D-2642","image":"1f6b4-1f3fc-200d-2642-fe0f.png","sheet_x":35,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B4-1F3FD-200D-2642-FE0F","non_qualified":"1F6B4-1F3FD-200D-2642","image":"1f6b4-1f3fd-200d-2642-fe0f.png","sheet_x":35,"sheet_y":20,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B4-1F3FE-200D-2642-FE0F","non_qualified":"1F6B4-1F3FE-200D-2642","image":"1f6b4-1f3fe-200d-2642-fe0f.png","sheet_x":35,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B4-1F3FF-200D-2642-FE0F","non_qualified":"1F6B4-1F3FF-200D-2642","image":"1f6b4-1f3ff-200d-2642-fe0f.png","sheet_x":35,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F6B4","a":"Man Biking","b":"1F6B4-200D-2642-FE0F","c":"1F6B4-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[35,17],"o":4},"woman-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B4-1F3FB-200D-2640-FE0F","non_qualified":"1F6B4-1F3FB-200D-2640","image":"1f6b4-1f3fb-200d-2640-fe0f.png","sheet_x":35,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B4-1F3FC-200D-2640-FE0F","non_qualified":"1F6B4-1F3FC-200D-2640","image":"1f6b4-1f3fc-200d-2640-fe0f.png","sheet_x":35,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B4-1F3FD-200D-2640-FE0F","non_qualified":"1F6B4-1F3FD-200D-2640","image":"1f6b4-1f3fd-200d-2640-fe0f.png","sheet_x":35,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B4-1F3FE-200D-2640-FE0F","non_qualified":"1F6B4-1F3FE-200D-2640","image":"1f6b4-1f3fe-200d-2640-fe0f.png","sheet_x":35,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B4-1F3FF-200D-2640-FE0F","non_qualified":"1F6B4-1F3FF-200D-2640","image":"1f6b4-1f3ff-200d-2640-fe0f.png","sheet_x":35,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Biking","b":"1F6B4-200D-2640-FE0F","c":"1F6B4-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[35,11],"o":4},"mountain_bicyclist":{"skin_variations":{"1F3FB":{"unified":"1F6B5-1F3FB","non_qualified":null,"image":"1f6b5-1f3fb.png","sheet_x":35,"sheet_y":42,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F6B5-1F3FC","non_qualified":null,"image":"1f6b5-1f3fc.png","sheet_x":35,"sheet_y":43,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F6B5-1F3FD","non_qualified":null,"image":"1f6b5-1f3fd.png","sheet_x":35,"sheet_y":44,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F6B5-1F3FE","non_qualified":null,"image":"1f6b5-1f3fe.png","sheet_x":35,"sheet_y":45,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F6B5-1F3FF","non_qualified":null,"image":"1f6b5-1f3ff.png","sheet_x":35,"sheet_y":46,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"obsoleted_by":"1F6B5-200D-2642-FE0F","a":"Mountain Bicyclist","b":"1F6B5","d":true,"e":true,"f":true,"h":false,"k":[35,41],"o":2},"man-mountain-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B5-1F3FB-200D-2642-FE0F","non_qualified":"1F6B5-1F3FB-200D-2642","image":"1f6b5-1f3fb-200d-2642-fe0f.png","sheet_x":35,"sheet_y":36,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B5-1F3FC-200D-2642-FE0F","non_qualified":"1F6B5-1F3FC-200D-2642","image":"1f6b5-1f3fc-200d-2642-fe0f.png","sheet_x":35,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B5-1F3FD-200D-2642-FE0F","non_qualified":"1F6B5-1F3FD-200D-2642","image":"1f6b5-1f3fd-200d-2642-fe0f.png","sheet_x":35,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B5-1F3FE-200D-2642-FE0F","non_qualified":"1F6B5-1F3FE-200D-2642","image":"1f6b5-1f3fe-200d-2642-fe0f.png","sheet_x":35,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B5-1F3FF-200D-2642-FE0F","non_qualified":"1F6B5-1F3FF-200D-2642","image":"1f6b5-1f3ff-200d-2642-fe0f.png","sheet_x":35,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"obsoletes":"1F6B5","a":"Man Mountain Biking","b":"1F6B5-200D-2642-FE0F","c":"1F6B5-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[35,35],"o":4},"woman-mountain-biking":{"skin_variations":{"1F3FB":{"unified":"1F6B5-1F3FB-200D-2640-FE0F","non_qualified":"1F6B5-1F3FB-200D-2640","image":"1f6b5-1f3fb-200d-2640-fe0f.png","sheet_x":35,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6B5-1F3FC-200D-2640-FE0F","non_qualified":"1F6B5-1F3FC-200D-2640","image":"1f6b5-1f3fc-200d-2640-fe0f.png","sheet_x":35,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6B5-1F3FD-200D-2640-FE0F","non_qualified":"1F6B5-1F3FD-200D-2640","image":"1f6b5-1f3fd-200d-2640-fe0f.png","sheet_x":35,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6B5-1F3FE-200D-2640-FE0F","non_qualified":"1F6B5-1F3FE-200D-2640","image":"1f6b5-1f3fe-200d-2640-fe0f.png","sheet_x":35,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6B5-1F3FF-200D-2640-FE0F","non_qualified":"1F6B5-1F3FF-200D-2640","image":"1f6b5-1f3ff-200d-2640-fe0f.png","sheet_x":35,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Mountain Biking","b":"1F6B5-200D-2640-FE0F","c":"1F6B5-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[35,29],"o":4},"person_doing_cartwheel":{"skin_variations":{"1F3FB":{"unified":"1F938-1F3FB","non_qualified":null,"image":"1f938-1f3fb.png","sheet_x":40,"sheet_y":9,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F938-1F3FC","non_qualified":null,"image":"1f938-1f3fc.png","sheet_x":40,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F938-1F3FD","non_qualified":null,"image":"1f938-1f3fd.png","sheet_x":40,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F938-1F3FE","non_qualified":null,"image":"1f938-1f3fe.png","sheet_x":40,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F938-1F3FF","non_qualified":null,"image":"1f938-1f3ff.png","sheet_x":40,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Person Doing Cartwheel","b":"1F938","d":true,"e":true,"f":true,"h":false,"k":[40,8],"o":4},"man-cartwheeling":{"skin_variations":{"1F3FB":{"unified":"1F938-1F3FB-200D-2642-FE0F","non_qualified":"1F938-1F3FB-200D-2642","image":"1f938-1f3fb-200d-2642-fe0f.png","sheet_x":40,"sheet_y":3,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F938-1F3FC-200D-2642-FE0F","non_qualified":"1F938-1F3FC-200D-2642","image":"1f938-1f3fc-200d-2642-fe0f.png","sheet_x":40,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F938-1F3FD-200D-2642-FE0F","non_qualified":"1F938-1F3FD-200D-2642","image":"1f938-1f3fd-200d-2642-fe0f.png","sheet_x":40,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F938-1F3FE-200D-2642-FE0F","non_qualified":"1F938-1F3FE-200D-2642","image":"1f938-1f3fe-200d-2642-fe0f.png","sheet_x":40,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F938-1F3FF-200D-2642-FE0F","non_qualified":"1F938-1F3FF-200D-2642","image":"1f938-1f3ff-200d-2642-fe0f.png","sheet_x":40,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Cartwheeling","b":"1F938-200D-2642-FE0F","c":"1F938-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[40,2],"o":4},"woman-cartwheeling":{"skin_variations":{"1F3FB":{"unified":"1F938-1F3FB-200D-2640-FE0F","non_qualified":"1F938-1F3FB-200D-2640","image":"1f938-1f3fb-200d-2640-fe0f.png","sheet_x":39,"sheet_y":54,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F938-1F3FC-200D-2640-FE0F","non_qualified":"1F938-1F3FC-200D-2640","image":"1f938-1f3fc-200d-2640-fe0f.png","sheet_x":39,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F938-1F3FD-200D-2640-FE0F","non_qualified":"1F938-1F3FD-200D-2640","image":"1f938-1f3fd-200d-2640-fe0f.png","sheet_x":39,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F938-1F3FE-200D-2640-FE0F","non_qualified":"1F938-1F3FE-200D-2640","image":"1f938-1f3fe-200d-2640-fe0f.png","sheet_x":40,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F938-1F3FF-200D-2640-FE0F","non_qualified":"1F938-1F3FF-200D-2640","image":"1f938-1f3ff-200d-2640-fe0f.png","sheet_x":40,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Cartwheeling","b":"1F938-200D-2640-FE0F","c":"1F938-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[39,53],"o":4},"wrestlers":{"a":"Wrestlers","b":"1F93C","d":true,"e":true,"f":true,"h":true,"k":[40,35],"o":4},"man-wrestling":{"a":"Man Wrestling","b":"1F93C-200D-2642-FE0F","c":"1F93C-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[40,34],"o":4},"woman-wrestling":{"a":"Woman Wrestling","b":"1F93C-200D-2640-FE0F","c":"1F93C-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[40,33],"o":4},"water_polo":{"skin_variations":{"1F3FB":{"unified":"1F93D-1F3FB","non_qualified":null,"image":"1f93d-1f3fb.png","sheet_x":40,"sheet_y":49,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F93D-1F3FC","non_qualified":null,"image":"1f93d-1f3fc.png","sheet_x":40,"sheet_y":50,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F93D-1F3FD","non_qualified":null,"image":"1f93d-1f3fd.png","sheet_x":40,"sheet_y":51,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F93D-1F3FE","non_qualified":null,"image":"1f93d-1f3fe.png","sheet_x":40,"sheet_y":52,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F93D-1F3FF","non_qualified":null,"image":"1f93d-1f3ff.png","sheet_x":40,"sheet_y":53,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Water Polo","b":"1F93D","d":true,"e":true,"f":true,"h":false,"k":[40,48],"o":4},"man-playing-water-polo":{"skin_variations":{"1F3FB":{"unified":"1F93D-1F3FB-200D-2642-FE0F","non_qualified":"1F93D-1F3FB-200D-2642","image":"1f93d-1f3fb-200d-2642-fe0f.png","sheet_x":40,"sheet_y":43,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F93D-1F3FC-200D-2642-FE0F","non_qualified":"1F93D-1F3FC-200D-2642","image":"1f93d-1f3fc-200d-2642-fe0f.png","sheet_x":40,"sheet_y":44,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F93D-1F3FD-200D-2642-FE0F","non_qualified":"1F93D-1F3FD-200D-2642","image":"1f93d-1f3fd-200d-2642-fe0f.png","sheet_x":40,"sheet_y":45,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F93D-1F3FE-200D-2642-FE0F","non_qualified":"1F93D-1F3FE-200D-2642","image":"1f93d-1f3fe-200d-2642-fe0f.png","sheet_x":40,"sheet_y":46,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F93D-1F3FF-200D-2642-FE0F","non_qualified":"1F93D-1F3FF-200D-2642","image":"1f93d-1f3ff-200d-2642-fe0f.png","sheet_x":40,"sheet_y":47,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Playing Water Polo","b":"1F93D-200D-2642-FE0F","c":"1F93D-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[40,42],"o":4},"woman-playing-water-polo":{"skin_variations":{"1F3FB":{"unified":"1F93D-1F3FB-200D-2640-FE0F","non_qualified":"1F93D-1F3FB-200D-2640","image":"1f93d-1f3fb-200d-2640-fe0f.png","sheet_x":40,"sheet_y":37,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F93D-1F3FC-200D-2640-FE0F","non_qualified":"1F93D-1F3FC-200D-2640","image":"1f93d-1f3fc-200d-2640-fe0f.png","sheet_x":40,"sheet_y":38,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F93D-1F3FD-200D-2640-FE0F","non_qualified":"1F93D-1F3FD-200D-2640","image":"1f93d-1f3fd-200d-2640-fe0f.png","sheet_x":40,"sheet_y":39,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F93D-1F3FE-200D-2640-FE0F","non_qualified":"1F93D-1F3FE-200D-2640","image":"1f93d-1f3fe-200d-2640-fe0f.png","sheet_x":40,"sheet_y":40,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F93D-1F3FF-200D-2640-FE0F","non_qualified":"1F93D-1F3FF-200D-2640","image":"1f93d-1f3ff-200d-2640-fe0f.png","sheet_x":40,"sheet_y":41,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Playing Water Polo","b":"1F93D-200D-2640-FE0F","c":"1F93D-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[40,36],"o":4},"handball":{"skin_variations":{"1F3FB":{"unified":"1F93E-1F3FB","non_qualified":null,"image":"1f93e-1f3fb.png","sheet_x":41,"sheet_y":10,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FC":{"unified":"1F93E-1F3FC","non_qualified":null,"image":"1f93e-1f3fc.png","sheet_x":41,"sheet_y":11,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FD":{"unified":"1F93E-1F3FD","non_qualified":null,"image":"1f93e-1f3fd.png","sheet_x":41,"sheet_y":12,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FE":{"unified":"1F93E-1F3FE","non_qualified":null,"image":"1f93e-1f3fe.png","sheet_x":41,"sheet_y":13,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false},"1F3FF":{"unified":"1F93E-1F3FF","non_qualified":null,"image":"1f93e-1f3ff.png","sheet_x":41,"sheet_y":14,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":false}},"a":"Handball","b":"1F93E","d":true,"e":true,"f":true,"h":false,"k":[41,9],"o":4},"man-playing-handball":{"skin_variations":{"1F3FB":{"unified":"1F93E-1F3FB-200D-2642-FE0F","non_qualified":"1F93E-1F3FB-200D-2642","image":"1f93e-1f3fb-200d-2642-fe0f.png","sheet_x":41,"sheet_y":4,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F93E-1F3FC-200D-2642-FE0F","non_qualified":"1F93E-1F3FC-200D-2642","image":"1f93e-1f3fc-200d-2642-fe0f.png","sheet_x":41,"sheet_y":5,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F93E-1F3FD-200D-2642-FE0F","non_qualified":"1F93E-1F3FD-200D-2642","image":"1f93e-1f3fd-200d-2642-fe0f.png","sheet_x":41,"sheet_y":6,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F93E-1F3FE-200D-2642-FE0F","non_qualified":"1F93E-1F3FE-200D-2642","image":"1f93e-1f3fe-200d-2642-fe0f.png","sheet_x":41,"sheet_y":7,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F93E-1F3FF-200D-2642-FE0F","non_qualified":"1F93E-1F3FF-200D-2642","image":"1f93e-1f3ff-200d-2642-fe0f.png","sheet_x":41,"sheet_y":8,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Playing Handball","b":"1F93E-200D-2642-FE0F","c":"1F93E-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[41,3],"o":4},"woman-playing-handball":{"skin_variations":{"1F3FB":{"unified":"1F93E-1F3FB-200D-2640-FE0F","non_qualified":"1F93E-1F3FB-200D-2640","image":"1f93e-1f3fb-200d-2640-fe0f.png","sheet_x":40,"sheet_y":55,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F93E-1F3FC-200D-2640-FE0F","non_qualified":"1F93E-1F3FC-200D-2640","image":"1f93e-1f3fc-200d-2640-fe0f.png","sheet_x":40,"sheet_y":56,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F93E-1F3FD-200D-2640-FE0F","non_qualified":"1F93E-1F3FD-200D-2640","image":"1f93e-1f3fd-200d-2640-fe0f.png","sheet_x":41,"sheet_y":0,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F93E-1F3FE-200D-2640-FE0F","non_qualified":"1F93E-1F3FE-200D-2640","image":"1f93e-1f3fe-200d-2640-fe0f.png","sheet_x":41,"sheet_y":1,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F93E-1F3FF-200D-2640-FE0F","non_qualified":"1F93E-1F3FF-200D-2640","image":"1f93e-1f3ff-200d-2640-fe0f.png","sheet_x":41,"sheet_y":2,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Playing Handball","b":"1F93E-200D-2640-FE0F","c":"1F93E-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[40,54],"o":4},"juggling":{"skin_variations":{"1F3FB":{"unified":"1F939-1F3FB","non_qualified":null,"image":"1f939-1f3fb.png","sheet_x":40,"sheet_y":27,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F939-1F3FC","non_qualified":null,"image":"1f939-1f3fc.png","sheet_x":40,"sheet_y":28,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F939-1F3FD","non_qualified":null,"image":"1f939-1f3fd.png","sheet_x":40,"sheet_y":29,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F939-1F3FE","non_qualified":null,"image":"1f939-1f3fe.png","sheet_x":40,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F939-1F3FF","non_qualified":null,"image":"1f939-1f3ff.png","sheet_x":40,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Juggling","b":"1F939","d":true,"e":true,"f":true,"h":true,"k":[40,26],"o":4},"man-juggling":{"skin_variations":{"1F3FB":{"unified":"1F939-1F3FB-200D-2642-FE0F","non_qualified":"1F939-1F3FB-200D-2642","image":"1f939-1f3fb-200d-2642-fe0f.png","sheet_x":40,"sheet_y":21,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F939-1F3FC-200D-2642-FE0F","non_qualified":"1F939-1F3FC-200D-2642","image":"1f939-1f3fc-200d-2642-fe0f.png","sheet_x":40,"sheet_y":22,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F939-1F3FD-200D-2642-FE0F","non_qualified":"1F939-1F3FD-200D-2642","image":"1f939-1f3fd-200d-2642-fe0f.png","sheet_x":40,"sheet_y":23,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F939-1F3FE-200D-2642-FE0F","non_qualified":"1F939-1F3FE-200D-2642","image":"1f939-1f3fe-200d-2642-fe0f.png","sheet_x":40,"sheet_y":24,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F939-1F3FF-200D-2642-FE0F","non_qualified":"1F939-1F3FF-200D-2642","image":"1f939-1f3ff-200d-2642-fe0f.png","sheet_x":40,"sheet_y":25,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man Juggling","b":"1F939-200D-2642-FE0F","c":"1F939-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[40,20],"o":4},"woman-juggling":{"skin_variations":{"1F3FB":{"unified":"1F939-1F3FB-200D-2640-FE0F","non_qualified":"1F939-1F3FB-200D-2640","image":"1f939-1f3fb-200d-2640-fe0f.png","sheet_x":40,"sheet_y":15,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F939-1F3FC-200D-2640-FE0F","non_qualified":"1F939-1F3FC-200D-2640","image":"1f939-1f3fc-200d-2640-fe0f.png","sheet_x":40,"sheet_y":16,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F939-1F3FD-200D-2640-FE0F","non_qualified":"1F939-1F3FD-200D-2640","image":"1f939-1f3fd-200d-2640-fe0f.png","sheet_x":40,"sheet_y":17,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F939-1F3FE-200D-2640-FE0F","non_qualified":"1F939-1F3FE-200D-2640","image":"1f939-1f3fe-200d-2640-fe0f.png","sheet_x":40,"sheet_y":18,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F939-1F3FF-200D-2640-FE0F","non_qualified":"1F939-1F3FF-200D-2640","image":"1f939-1f3ff-200d-2640-fe0f.png","sheet_x":40,"sheet_y":19,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Woman Juggling","b":"1F939-200D-2640-FE0F","c":"1F939-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[40,14],"o":4},"person_in_lotus_position":{"skin_variations":{"1F3FB":{"unified":"1F9D8-1F3FB","non_qualified":null,"image":"1f9d8-1f3fb.png","sheet_x":49,"sheet_y":32,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D8-1F3FB-200D-2640-FE0F"},"1F3FC":{"unified":"1F9D8-1F3FC","non_qualified":null,"image":"1f9d8-1f3fc.png","sheet_x":49,"sheet_y":33,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D8-1F3FC-200D-2640-FE0F"},"1F3FD":{"unified":"1F9D8-1F3FD","non_qualified":null,"image":"1f9d8-1f3fd.png","sheet_x":49,"sheet_y":34,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D8-1F3FD-200D-2640-FE0F"},"1F3FE":{"unified":"1F9D8-1F3FE","non_qualified":null,"image":"1f9d8-1f3fe.png","sheet_x":49,"sheet_y":35,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D8-1F3FE-200D-2640-FE0F"},"1F3FF":{"unified":"1F9D8-1F3FF","non_qualified":null,"image":"1f9d8-1f3ff.png","sheet_x":49,"sheet_y":36,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoleted_by":"1F9D8-1F3FF-200D-2640-FE0F"}},"obsoleted_by":"1F9D8-200D-2640-FE0F","a":"Person in Lotus Position","b":"1F9D8","d":true,"e":true,"f":true,"h":true,"k":[49,31],"o":5},"man_in_lotus_position":{"skin_variations":{"1F3FB":{"unified":"1F9D8-1F3FB-200D-2642-FE0F","non_qualified":"1F9D8-1F3FB-200D-2642","image":"1f9d8-1f3fb-200d-2642-fe0f.png","sheet_x":49,"sheet_y":26,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F9D8-1F3FC-200D-2642-FE0F","non_qualified":"1F9D8-1F3FC-200D-2642","image":"1f9d8-1f3fc-200d-2642-fe0f.png","sheet_x":49,"sheet_y":27,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F9D8-1F3FD-200D-2642-FE0F","non_qualified":"1F9D8-1F3FD-200D-2642","image":"1f9d8-1f3fd-200d-2642-fe0f.png","sheet_x":49,"sheet_y":28,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F9D8-1F3FE-200D-2642-FE0F","non_qualified":"1F9D8-1F3FE-200D-2642","image":"1f9d8-1f3fe-200d-2642-fe0f.png","sheet_x":49,"sheet_y":29,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F9D8-1F3FF-200D-2642-FE0F","non_qualified":"1F9D8-1F3FF-200D-2642","image":"1f9d8-1f3ff-200d-2642-fe0f.png","sheet_x":49,"sheet_y":30,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man in Lotus Position","b":"1F9D8-200D-2642-FE0F","c":"1F9D8-200D-2642","d":true,"e":true,"f":true,"h":true,"k":[49,25],"o":5},"woman_in_lotus_position":{"skin_variations":{"1F3FB":{"unified":"1F9D8-1F3FB-200D-2640-FE0F","non_qualified":"1F9D8-1F3FB-200D-2640","image":"1f9d8-1f3fb-200d-2640-fe0f.png","sheet_x":49,"sheet_y":20,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D8-1F3FB"},"1F3FC":{"unified":"1F9D8-1F3FC-200D-2640-FE0F","non_qualified":"1F9D8-1F3FC-200D-2640","image":"1f9d8-1f3fc-200d-2640-fe0f.png","sheet_x":49,"sheet_y":21,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D8-1F3FC"},"1F3FD":{"unified":"1F9D8-1F3FD-200D-2640-FE0F","non_qualified":"1F9D8-1F3FD-200D-2640","image":"1f9d8-1f3fd-200d-2640-fe0f.png","sheet_x":49,"sheet_y":22,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D8-1F3FD"},"1F3FE":{"unified":"1F9D8-1F3FE-200D-2640-FE0F","non_qualified":"1F9D8-1F3FE-200D-2640","image":"1f9d8-1f3fe-200d-2640-fe0f.png","sheet_x":49,"sheet_y":23,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D8-1F3FE"},"1F3FF":{"unified":"1F9D8-1F3FF-200D-2640-FE0F","non_qualified":"1F9D8-1F3FF-200D-2640","image":"1f9d8-1f3ff-200d-2640-fe0f.png","sheet_x":49,"sheet_y":24,"added_in":"5.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true,"obsoletes":"1F9D8-1F3FF"}},"obsoletes":"1F9D8","a":"Woman in Lotus Position","b":"1F9D8-200D-2640-FE0F","c":"1F9D8-200D-2640","d":true,"e":true,"f":true,"h":true,"k":[49,19],"o":5},"bath":{"skin_variations":{"1F3FB":{"unified":"1F6C0-1F3FB","non_qualified":null,"image":"1f6c0-1f3fb.png","sheet_x":36,"sheet_y":18,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6C0-1F3FC","non_qualified":null,"image":"1f6c0-1f3fc.png","sheet_x":36,"sheet_y":19,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6C0-1F3FD","non_qualified":null,"image":"1f6c0-1f3fd.png","sheet_x":36,"sheet_y":20,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6C0-1F3FE","non_qualified":null,"image":"1f6c0-1f3fe.png","sheet_x":36,"sheet_y":21,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6C0-1F3FF","non_qualified":null,"image":"1f6c0-1f3ff.png","sheet_x":36,"sheet_y":22,"added_in":"2.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Bath","b":"1F6C0","d":true,"e":true,"f":true,"h":true,"j":["clean","shower","bathroom"],"k":[36,17],"o":2},"sleeping_accommodation":{"skin_variations":{"1F3FB":{"unified":"1F6CC-1F3FB","non_qualified":null,"image":"1f6cc-1f3fb.png","sheet_x":36,"sheet_y":30,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F6CC-1F3FC","non_qualified":null,"image":"1f6cc-1f3fc.png","sheet_x":36,"sheet_y":31,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F6CC-1F3FD","non_qualified":null,"image":"1f6cc-1f3fd.png","sheet_x":36,"sheet_y":32,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F6CC-1F3FE","non_qualified":null,"image":"1f6cc-1f3fe.png","sheet_x":36,"sheet_y":33,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F6CC-1F3FF","non_qualified":null,"image":"1f6cc-1f3ff.png","sheet_x":36,"sheet_y":34,"added_in":"4.0","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Sleeping Accommodation","b":"1F6CC","d":true,"e":true,"f":true,"h":true,"k":[36,29],"o":2},"people_holding_hands":{"skin_variations":{"1F3FB-1F3FB":{"unified":"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb.png","sheet_x":46,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FC":{"unified":"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc.png","sheet_x":46,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FD":{"unified":"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd.png","sheet_x":46,"sheet_y":41,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FE":{"unified":"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe.png","sheet_x":46,"sheet_y":42,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FF":{"unified":"1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff.png","sheet_x":46,"sheet_y":43,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FB":{"unified":"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb.png","sheet_x":46,"sheet_y":44,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FC":{"unified":"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc.png","sheet_x":46,"sheet_y":45,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FD":{"unified":"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd.png","sheet_x":46,"sheet_y":46,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FE":{"unified":"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe.png","sheet_x":46,"sheet_y":47,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FF":{"unified":"1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff.png","sheet_x":46,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FB":{"unified":"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb.png","sheet_x":46,"sheet_y":49,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FC":{"unified":"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc.png","sheet_x":46,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FD":{"unified":"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd.png","sheet_x":46,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FE":{"unified":"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe.png","sheet_x":46,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FF":{"unified":"1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff.png","sheet_x":46,"sheet_y":53,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FE-1F3FB":{"unified":"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb.png","sheet_x":46,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FC":{"unified":"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc.png","sheet_x":46,"sheet_y":55,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FD":{"unified":"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd.png","sheet_x":46,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FE":{"unified":"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe.png","sheet_x":47,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FF":{"unified":"1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff.png","sheet_x":47,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FF-1F3FB":{"unified":"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FB","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb.png","sheet_x":47,"sheet_y":2,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FC":{"unified":"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FC","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc.png","sheet_x":47,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FD":{"unified":"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FD","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd.png","sheet_x":47,"sheet_y":4,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FE":{"unified":"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FE","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe.png","sheet_x":47,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FF":{"unified":"1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FF","non_qualified":null,"image":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff.png","sheet_x":47,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"People Holding Hands","b":"1F9D1-200D-1F91D-200D-1F9D1","d":true,"e":true,"f":true,"h":true,"k":[46,38],"o":12},"two_women_holding_hands":{"skin_variations":{"1F3FB":{"unified":"1F46D-1F3FB","non_qualified":null,"image":"1f46d-1f3fb.png","sheet_x":21,"sheet_y":12,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F46D-1F3FC","non_qualified":null,"image":"1f46d-1f3fc.png","sheet_x":21,"sheet_y":13,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F46D-1F3FD","non_qualified":null,"image":"1f46d-1f3fd.png","sheet_x":21,"sheet_y":14,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F46D-1F3FE","non_qualified":null,"image":"1f46d-1f3fe.png","sheet_x":21,"sheet_y":15,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F46D-1F3FF","non_qualified":null,"image":"1f46d-1f3ff.png","sheet_x":21,"sheet_y":16,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FC":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FC","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc.png","sheet_x":21,"sheet_y":17,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FD":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FD","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd.png","sheet_x":21,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FE":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FE","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe.png","sheet_x":21,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FF":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F469-1F3FF","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff.png","sheet_x":21,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FB":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FB","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb.png","sheet_x":21,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FD":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FD","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd.png","sheet_x":21,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FE":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FE","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe.png","sheet_x":21,"sheet_y":23,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FF":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F469-1F3FF","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff.png","sheet_x":21,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FB":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FB","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb.png","sheet_x":21,"sheet_y":25,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FC":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FC","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc.png","sheet_x":21,"sheet_y":26,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FE":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FE","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe.png","sheet_x":21,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FF":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F469-1F3FF","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff.png","sheet_x":21,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FE-1F3FB":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FB","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb.png","sheet_x":21,"sheet_y":29,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FC":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FC","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc.png","sheet_x":21,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FD":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FD","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd.png","sheet_x":21,"sheet_y":31,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FF":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F469-1F3FF","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff.png","sheet_x":21,"sheet_y":32,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FF-1F3FB":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FB","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb.png","sheet_x":21,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FC":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FC","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc.png","sheet_x":21,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FD":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FD","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd.png","sheet_x":21,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FE":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F469-1F3FE","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe.png","sheet_x":21,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Two Women Holding Hands","b":"1F46D","d":true,"e":true,"f":true,"h":true,"j":["pair","friendship","couple","love","like","female","people","human"],"k":[21,11],"n":["women_holding_hands"],"o":2},"couple":{"skin_variations":{"1F3FB":{"unified":"1F46B-1F3FB","non_qualified":null,"image":"1f46b-1f3fb.png","sheet_x":20,"sheet_y":17,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F46B-1F3FC","non_qualified":null,"image":"1f46b-1f3fc.png","sheet_x":20,"sheet_y":18,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F46B-1F3FD","non_qualified":null,"image":"1f46b-1f3fd.png","sheet_x":20,"sheet_y":19,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F46B-1F3FE","non_qualified":null,"image":"1f46b-1f3fe.png","sheet_x":20,"sheet_y":20,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F46B-1F3FF","non_qualified":null,"image":"1f46b-1f3ff.png","sheet_x":20,"sheet_y":21,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FC":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":20,"sheet_y":22,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FD":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":23,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FE":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":24,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FF":{"unified":"1F469-1F3FB-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":25,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FB":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":26,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FD":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":27,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FE":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":28,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FF":{"unified":"1F469-1F3FC-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":29,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FB":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":30,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FC":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":20,"sheet_y":31,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FE":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":32,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FF":{"unified":"1F469-1F3FD-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":33,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FB":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":34,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FC":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":20,"sheet_y":35,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FD":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":36,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FF":{"unified":"1F469-1F3FE-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":37,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FB":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":38,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FC":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":20,"sheet_y":39,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FD":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":40,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FE":{"unified":"1F469-1F3FF-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":41,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Man and Woman Holding Hands","b":"1F46B","d":true,"e":true,"f":true,"h":true,"j":["pair","people","human","love","date","dating","like","affection","valentines","marriage"],"k":[20,16],"n":["man_and_woman_holding_hands","woman_and_man_holding_hands"],"o":2},"two_men_holding_hands":{"skin_variations":{"1F3FB":{"unified":"1F46C-1F3FB","non_qualified":null,"image":"1f46c-1f3fb.png","sheet_x":20,"sheet_y":43,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC":{"unified":"1F46C-1F3FC","non_qualified":null,"image":"1f46c-1f3fc.png","sheet_x":20,"sheet_y":44,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD":{"unified":"1F46C-1F3FD","non_qualified":null,"image":"1f46c-1f3fd.png","sheet_x":20,"sheet_y":45,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE":{"unified":"1F46C-1F3FE","non_qualified":null,"image":"1f46c-1f3fe.png","sheet_x":20,"sheet_y":46,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF":{"unified":"1F46C-1F3FF","non_qualified":null,"image":"1f46c-1f3ff.png","sheet_x":20,"sheet_y":47,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FB-1F3FC":{"unified":"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":20,"sheet_y":48,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FD":{"unified":"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":49,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FE":{"unified":"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":50,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FB-1F3FF":{"unified":"1F468-1F3FB-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":51,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FB":{"unified":"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":52,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FC-1F3FD":{"unified":"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":20,"sheet_y":53,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FE":{"unified":"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":20,"sheet_y":54,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FC-1F3FF":{"unified":"1F468-1F3FC-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":20,"sheet_y":55,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FB":{"unified":"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":20,"sheet_y":56,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FC":{"unified":"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":21,"sheet_y":0,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FD-1F3FE":{"unified":"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":21,"sheet_y":1,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FD-1F3FF":{"unified":"1F468-1F3FD-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":21,"sheet_y":2,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FE-1F3FB":{"unified":"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":21,"sheet_y":3,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FC":{"unified":"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":21,"sheet_y":4,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FD":{"unified":"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":21,"sheet_y":5,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FE-1F3FF":{"unified":"1F468-1F3FE-200D-1F91D-200D-1F468-1F3FF","non_qualified":null,"image":"1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff.png","sheet_x":21,"sheet_y":6,"added_in":"12.1","has_img_apple":true,"has_img_google":false,"has_img_twitter":true,"has_img_facebook":false},"1F3FF-1F3FB":{"unified":"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FB","non_qualified":null,"image":"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb.png","sheet_x":21,"sheet_y":7,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FC":{"unified":"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FC","non_qualified":null,"image":"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc.png","sheet_x":21,"sheet_y":8,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FD":{"unified":"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FD","non_qualified":null,"image":"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd.png","sheet_x":21,"sheet_y":9,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true},"1F3FF-1F3FE":{"unified":"1F468-1F3FF-200D-1F91D-200D-1F468-1F3FE","non_qualified":null,"image":"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe.png","sheet_x":21,"sheet_y":10,"added_in":"12.1","has_img_apple":true,"has_img_google":true,"has_img_twitter":true,"has_img_facebook":true}},"a":"Two Men Holding Hands","b":"1F46C","d":true,"e":true,"f":true,"h":true,"j":["pair","couple","love","like","bromance","friendship","people","human"],"k":[20,42],"n":["men_holding_hands"],"o":2},"couplekiss":{"obsoleted_by":"1F469-200D-2764-FE0F-200D-1F48B-200D-1F468","a":"Kiss","b":"1F48F","d":true,"e":true,"f":true,"h":true,"k":[25,25],"o":2},"woman-kiss-man":{"obsoletes":"1F48F","a":"Woman Kiss Man","b":"1F469-200D-2764-FE0F-200D-1F48B-200D-1F468","c":"1F469-200D-2764-200D-1F48B-200D-1F468","d":true,"e":true,"f":true,"h":true,"k":[20,7],"o":2},"man-kiss-man":{"a":"Man Kiss Man","b":"1F468-200D-2764-FE0F-200D-1F48B-200D-1F468","c":"1F468-200D-2764-200D-1F48B-200D-1F468","d":true,"e":true,"f":true,"h":true,"k":[17,21],"o":2},"woman-kiss-woman":{"a":"Woman Kiss Woman","b":"1F469-200D-2764-FE0F-200D-1F48B-200D-1F469","c":"1F469-200D-2764-200D-1F48B-200D-1F469","d":true,"e":true,"f":true,"h":true,"k":[20,8],"o":2},"couple_with_heart":{"obsoleted_by":"1F469-200D-2764-FE0F-200D-1F468","a":"Couple with Heart","b":"1F491","d":true,"e":true,"f":true,"h":true,"k":[25,27],"o":2},"woman-heart-man":{"obsoletes":"1F491","a":"Woman Heart Man","b":"1F469-200D-2764-FE0F-200D-1F468","c":"1F469-200D-2764-200D-1F468","d":true,"e":true,"f":true,"h":true,"k":[20,5],"o":2},"man-heart-man":{"a":"Man Heart Man","b":"1F468-200D-2764-FE0F-200D-1F468","c":"1F468-200D-2764-200D-1F468","d":true,"e":true,"f":true,"h":true,"k":[17,20],"o":2},"woman-heart-woman":{"a":"Woman Heart Woman","b":"1F469-200D-2764-FE0F-200D-1F469","c":"1F469-200D-2764-200D-1F469","d":true,"e":true,"f":true,"h":true,"k":[20,6],"o":2},"family":{"obsoleted_by":"1F468-200D-1F469-200D-1F466","a":"Family","b":"1F46A","d":true,"e":true,"f":true,"h":true,"k":[20,15],"n":["man-woman-boy"],"o":2},"man-woman-boy":{"obsoletes":"1F46A","a":"Man Woman Boy","b":"1F468-200D-1F469-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,33],"n":["family"],"o":2},"man-woman-girl":{"a":"Man Woman Girl","b":"1F468-200D-1F469-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,35],"o":2},"man-woman-girl-boy":{"a":"Man Woman Girl Boy","b":"1F468-200D-1F469-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,36],"o":2},"man-woman-boy-boy":{"a":"Man Woman Boy Boy","b":"1F468-200D-1F469-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,34],"o":2},"man-woman-girl-girl":{"a":"Man Woman Girl Girl","b":"1F468-200D-1F469-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,37],"o":2},"man-man-boy":{"a":"Man Man Boy","b":"1F468-200D-1F468-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,28],"o":2},"man-man-girl":{"a":"Man Man Girl","b":"1F468-200D-1F468-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,30],"o":2},"man-man-girl-boy":{"a":"Man Man Girl Boy","b":"1F468-200D-1F468-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,31],"o":2},"man-man-boy-boy":{"a":"Man Man Boy Boy","b":"1F468-200D-1F468-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,29],"o":2},"man-man-girl-girl":{"a":"Man Man Girl Girl","b":"1F468-200D-1F468-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,32],"o":2},"woman-woman-boy":{"a":"Woman Woman Boy","b":"1F469-200D-1F469-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,18],"o":2},"woman-woman-girl":{"a":"Woman Woman Girl","b":"1F469-200D-1F469-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[18,20],"o":2},"woman-woman-girl-boy":{"a":"Woman Woman Girl Boy","b":"1F469-200D-1F469-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,21],"o":2},"woman-woman-boy-boy":{"a":"Woman Woman Boy Boy","b":"1F469-200D-1F469-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,19],"o":2},"woman-woman-girl-girl":{"a":"Woman Woman Girl Girl","b":"1F469-200D-1F469-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[18,22],"o":2},"man-boy":{"a":"Man Boy","b":"1F468-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,24],"o":4},"man-boy-boy":{"a":"Man Boy Boy","b":"1F468-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,23],"o":4},"man-girl":{"a":"Man Girl","b":"1F468-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,27],"o":4},"man-girl-boy":{"a":"Man Girl Boy","b":"1F468-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[15,25],"o":4},"man-girl-girl":{"a":"Man Girl Girl","b":"1F468-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[15,26],"o":4},"woman-boy":{"a":"Woman Boy","b":"1F469-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,14],"o":4},"woman-boy-boy":{"a":"Woman Boy Boy","b":"1F469-200D-1F466-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,13],"o":4},"woman-girl":{"a":"Woman Girl","b":"1F469-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[18,17],"o":4},"woman-girl-boy":{"a":"Woman Girl Boy","b":"1F469-200D-1F467-200D-1F466","d":true,"e":true,"f":true,"h":true,"k":[18,15],"o":4},"woman-girl-girl":{"a":"Woman Girl Girl","b":"1F469-200D-1F467-200D-1F467","d":true,"e":true,"f":true,"h":true,"k":[18,16],"o":4},"speaking_head_in_silhouette":{"a":"Speaking Head in Silhouette","b":"1F5E3-FE0F","c":"1F5E3","d":true,"e":true,"f":true,"h":true,"k":[30,25],"o":2},"bust_in_silhouette":{"a":"Bust in Silhouette","b":"1F464","d":true,"e":true,"f":true,"h":true,"j":["user","person","human"],"k":[14,24],"o":2},"busts_in_silhouette":{"a":"Busts in Silhouette","b":"1F465","d":true,"e":true,"f":true,"h":true,"j":["user","person","human","group","team"],"k":[14,25],"o":2},"footprints":{"a":"Footprints","b":"1F463","d":true,"e":true,"f":true,"h":true,"j":["feet","tracking","walking","beach"],"k":[14,23],"o":2}},"aliases":{"raised_hand":"hand","satisfied":"laughing","tshirt":"shirt","hand_with_index_and_middle_fingers_crossed":"crossed_fingers","sign_of_the_horns":"the_horns","grinning_face_with_star_eyes":"star-struck","reversed_hand_with_middle_finger_extended":"middle_finger","thumbsup":"+1","thumbsdown":"-1","punch":"facepunch","grinning_face_with_one_large_and_one_small_eye":"zany_face","shoe":"mans_shoe","smiling_face_with_smiling_eyes_and_hand_covering_mouth":"face_with_hand_over_mouth","face_with_finger_covering_closed_lips":"shushing_face","face_with_one_eyebrow_raised":"face_with_raised_eyebrow","face_with_open_mouth_vomiting":"face_vomiting","cooking":"fried_egg","flag-cn":"cn","shocked_face_with_exploding_head":"exploding_head","paw_prints":"feet","flag-de":"de","telephone":"phone","flag-es":"es","red_car":"car","flipper":"dolphin","flag-fr":"fr","uk":"gb","flag-gb":"gb","serious_face_with_symbols_covering_mouth":"face_with_symbols_on_mouth","poop":"hankey","shit":"hankey","honeybee":"bee","staff_of_aesculapius":"medical_symbol","lantern":"izakaya_lantern","open_book":"book","sailboat":"boat","knife":"hocho","flag-it":"it","heavy_exclamation_mark":"exclamation","flag-jp":"jp","envelope":"email","flag-kr":"kr","collision":"boom","pencil":"memo","waxing_gibbous_moon":"moon","mother_christmas":"mrs_claus","sun_small_cloud":"mostly_sunny","sun_behind_cloud":"barely_sunny","sun_behind_rain_cloud":"partly_sunny_rain","lightning_cloud":"lightning","tornado_cloud":"tornado","flag-ru":"ru","running":"runner","flag-us":"us","women_holding_hands":"two_women_holding_hands","man_and_woman_holding_hands":"couple","woman_and_man_holding_hands":"couple","men_holding_hands":"two_men_holding_hands","man-woman-boy":"family","family":"man-woman-boy"}}');





var $tywpZ = parcelRequire("tywpZ");
var $830cae75b13dfa31$var$mapping = {
    name: 'a',
    unified: 'b',
    non_qualified: 'c',
    has_img_apple: 'd',
    has_img_google: 'e',
    has_img_twitter: 'f',
    has_img_facebook: 'h',
    keywords: 'j',
    sheet: 'k',
    emoticons: 'l',
    text: 'm',
    short_names: 'n',
    added_in: 'o'
};
var $830cae75b13dfa31$export$767cbc91845890d3 = function buildSearch(emoji) {
    var search = [];
    var addToSearch = function addToSearch(strings, split) {
        if (!strings) return;
        (Array.isArray(strings) ? strings : [
            strings
        ]).forEach(function(string) {
            (split ? string.split(/[-|_|\s]+/) : [
                string
            ]).forEach(function(s) {
                s = s.toLowerCase();
                if (search.indexOf(s) == -1) search.push(s);
            });
        });
    };
    addToSearch(emoji.short_names, true);
    addToSearch(emoji.name, true);
    addToSearch(emoji.keywords, false);
    addToSearch(emoji.emoticons, false);
    return search.join(',');
};
var $830cae75b13dfa31$export$80908c17a05abbe5 = function compress(emoji) {
    emoji.short_names = emoji.short_names.filter(function(short_name) {
        return short_name !== emoji.short_name;
    });
    delete emoji.short_name;
    emoji.sheet = [
        emoji.sheet_x,
        emoji.sheet_y
    ];
    delete emoji.sheet_x;
    delete emoji.sheet_y;
    emoji.added_in = parseInt(emoji.added_in);
    if (emoji.added_in === 6) delete emoji.added_in;
    for(var key in $830cae75b13dfa31$var$mapping){
        emoji[$830cae75b13dfa31$var$mapping[key]] = emoji[key];
        delete emoji[key];
    }
    for(var _key in emoji){
        var value = emoji[_key];
        if (Array.isArray(value) && !value.length) delete emoji[_key];
        else if (typeof value === 'string' && !value.length) delete emoji[_key];
        else if (value === null) delete emoji[_key];
    }
};
var $830cae75b13dfa31$export$4766cff981d64eb2 = function uncompress(data) {
    data.compressed = false;
    for(var id in data.emojis){
        var emoji = data.emojis[id];
        for(var key in $830cae75b13dfa31$var$mapping){
            emoji[key] = emoji[$830cae75b13dfa31$var$mapping[key]];
            delete emoji[$830cae75b13dfa31$var$mapping[key]];
        }
        if (!emoji.short_names) emoji.short_names = [];
        emoji.short_names.unshift(id);
        emoji.sheet_x = emoji.sheet[0];
        emoji.sheet_y = emoji.sheet[1];
        delete emoji.sheet;
        if (!emoji.text) emoji.text = '';
        if (!emoji.added_in) emoji.added_in = 6;
        emoji.added_in = emoji.added_in.toFixed(1);
        emoji.search = $830cae75b13dfa31$export$767cbc91845890d3(emoji);
    }
};


var $80da83e2817eac18$var$_String = String;
var $80da83e2817eac18$export$2e2bcd8739ae039 = $80da83e2817eac18$var$_String.fromCodePoint || function stringFromCodePoint() {
    var MAX_SIZE = 0x4000;
    var codeUnits = [];
    var highSurrogate;
    var lowSurrogate;
    var index = -1;
    var length = arguments.length;
    if (!length) return '';
    var result = '';
    while(++index < length){
        var codePoint = Number(arguments[index]);
        if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
        codePoint < 0 || // not a valid Unicode code point
        codePoint > 0x10ffff || // not a valid Unicode code point
        Math.floor(codePoint) != codePoint // not an integer
        ) throw RangeError('Invalid code point: ' + codePoint);
        if (codePoint <= 0xffff) // BMP code point
        codeUnits.push(codePoint);
        else {
            // Astral code point; split in surrogate halves
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            codePoint -= 0x10000;
            highSurrogate = (codePoint >> 10) + 0xd800;
            lowSurrogate = codePoint % 0x400 + 0xdc00;
            codeUnits.push(highSurrogate, lowSurrogate);
        }
        if (index + 1 === length || codeUnits.length > MAX_SIZE) {
            result += String.fromCharCode.apply(null, codeUnits);
            codeUnits.length = 0;
        }
    }
    return result;
};


var $80e1b209c9176fcd$var$COLONS_REGEX = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
var $80e1b209c9176fcd$var$SKINS = [
    '1F3FA',
    '1F3FB',
    '1F3FC',
    '1F3FD',
    '1F3FE',
    '1F3FF'
];
function $80e1b209c9176fcd$export$847d071486fee30d(unified) {
    var unicodes = unified.split('-'), codePoints = unicodes.map(function(u) {
        return "0x".concat(u);
    });
    return (0, $80da83e2817eac18$export$2e2bcd8739ae039).apply(null, codePoints);
}
function $80e1b209c9176fcd$var$sanitize(emoji) {
    var name = emoji.name, short_names = emoji.short_names, skin_tone = emoji.skin_tone, skin_variations = emoji.skin_variations, emoticons = emoji.emoticons, unified = emoji.unified, custom = emoji.custom, customCategory = emoji.customCategory, imageUrl = emoji.imageUrl, id = emoji.id || short_names[0], colons = ":".concat(id, ":");
    if (custom) return {
        id: id,
        name: name,
        short_names: short_names,
        colons: colons,
        emoticons: emoticons,
        custom: custom,
        customCategory: customCategory,
        imageUrl: imageUrl
    };
    if (skin_tone) colons += ":skin-tone-".concat(skin_tone, ":");
    return {
        id: id,
        name: name,
        short_names: short_names,
        colons: colons,
        emoticons: emoticons,
        unified: unified.toLowerCase(),
        skin: skin_tone || (skin_variations ? 1 : null),
        "native": $80e1b209c9176fcd$export$847d071486fee30d(unified)
    };
}
function $80e1b209c9176fcd$export$b57a2d1f0ad365d6() {
    return $80e1b209c9176fcd$var$sanitize($80e1b209c9176fcd$export$7a171f172be0782e.apply(void 0, arguments));
}
function $80e1b209c9176fcd$export$7a171f172be0782e(emoji, skin, set, data) {
    var emojiData = {};
    if (typeof emoji == 'string') {
        var matches = emoji.match($80e1b209c9176fcd$var$COLONS_REGEX);
        if (matches) {
            emoji = matches[1];
            if (matches[2]) skin = parseInt(matches[2], 10);
        }
        if (data.aliases.hasOwnProperty(emoji)) emoji = data.aliases[emoji];
        if (data.emojis.hasOwnProperty(emoji)) emojiData = data.emojis[emoji];
        else return null;
    } else if (emoji.id) {
        if (data.aliases.hasOwnProperty(emoji.id)) emoji.id = data.aliases[emoji.id];
        if (data.emojis.hasOwnProperty(emoji.id)) {
            emojiData = data.emojis[emoji.id];
            skin || (skin = emoji.skin);
        }
    }
    if (!Object.keys(emojiData).length) {
        emojiData = emoji;
        emojiData.custom = true;
        if (!emojiData.search) emojiData.search = (0, $830cae75b13dfa31$export$767cbc91845890d3)(emoji);
    }
    emojiData.emoticons || (emojiData.emoticons = []);
    emojiData.variations || (emojiData.variations = []);
    if (emojiData.skin_variations && skin > 1) {
        emojiData = JSON.parse(JSON.stringify(emojiData));
        var skinKey = $80e1b209c9176fcd$var$SKINS[skin - 1], variationData = emojiData.skin_variations[skinKey];
        if (variationData) {
            if (!variationData.variations && emojiData.variations) delete emojiData.variations;
            if (set && (variationData["has_img_".concat(set)] == undefined || variationData["has_img_".concat(set)]) || !set) {
                emojiData.skin_tone = skin;
                for(var k in variationData){
                    var v = variationData[k];
                    emojiData[k] = v;
                }
            }
        }
    }
    if (emojiData.variations && emojiData.variations.length) {
        emojiData = JSON.parse(JSON.stringify(emojiData));
        emojiData.unified = emojiData.variations.shift();
    }
    return emojiData;
}
function $80e1b209c9176fcd$export$5ef5574deca44bc0(nativeString, set, data) {
    if (data.compressed) (0, $830cae75b13dfa31$export$4766cff981d64eb2)(data);
    var skinTones = [
        "\uD83C\uDFFB",
        "\uD83C\uDFFC",
        "\uD83C\uDFFD",
        "\uD83C\uDFFE",
        "\uD83C\uDFFF"
    ];
    var skinCodes = [
        '1F3FB',
        '1F3FC',
        '1F3FD',
        '1F3FE',
        '1F3FF'
    ];
    var skin;
    var skinCode;
    var baseNativeString = nativeString;
    skinTones.forEach(function(skinTone, skinToneIndex) {
        if (nativeString.indexOf(skinTone) > 0) {
            skin = skinToneIndex + 2;
            skinCode = skinCodes[skinToneIndex];
        }
    });
    var emojiData;
    for(var id in data.emojis){
        var emoji = data.emojis[id];
        var emojiUnified = emoji.unified;
        if (emoji.variations && emoji.variations.length) emojiUnified = emoji.variations.shift();
        if (skin && emoji.skin_variations && emoji.skin_variations[skinCode]) emojiUnified = emoji.skin_variations[skinCode].unified;
        if ($80e1b209c9176fcd$export$847d071486fee30d(emojiUnified) === baseNativeString) emojiData = emoji;
    }
    if (!emojiData) return null;
    emojiData.id = emojiData.short_names[0];
    return $80e1b209c9176fcd$export$b57a2d1f0ad365d6(emojiData, skin, set, data);
}
function $80e1b209c9176fcd$export$f70730c3d1fc524e(arr) {
    return arr.reduce(function(acc, item) {
        if (acc.indexOf(item) === -1) acc.push(item);
        return acc;
    }, []);
}
function $80e1b209c9176fcd$export$1f4807a235930d45(a, b) {
    var uniqA = $80e1b209c9176fcd$export$f70730c3d1fc524e(a);
    var uniqB = $80e1b209c9176fcd$export$f70730c3d1fc524e(b);
    return uniqA.filter(function(item) {
        return uniqB.indexOf(item) >= 0;
    });
}
function $80e1b209c9176fcd$export$6969335ea1e4e77c(a, b) {
    var o = {};
    for(var key in a){
        var originalValue = a[key], value = originalValue;
        if (b.hasOwnProperty(key)) value = b[key];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(value) === 'object') value = $80e1b209c9176fcd$export$6969335ea1e4e77c(originalValue, value);
        o[key] = value;
    }
    return o;
} // https://github.com/sonicdoe/measure-scrollbar
function $80e1b209c9176fcd$export$f5ad9ce4fa1f02f() {
    if (typeof document == 'undefined') return 0;
    var div = document.createElement('div');
    div.style.width = '100px';
    div.style.height = '100px';
    div.style.overflow = 'scroll';
    div.style.position = 'absolute';
    div.style.top = '-9999px';
    document.body.appendChild(div);
    var scrollbarWidth = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
    return scrollbarWidth;
} // Use requestIdleCallback() if available, else fall back to setTimeout().
// Throttle so as not to run too frequently.
function $80e1b209c9176fcd$export$8e45a4eca628910b(func) {
    var doIdleTask = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;
    var running = false;
    return function throttled() {
        if (running) return;
        running = true;
        doIdleTask(function() {
            running = false;
            func();
        });
    };
}



var $2ad6c8ff1724a4ba$var$NAMESPACE = 'emoji-mart';
var $2ad6c8ff1724a4ba$var$isLocalStorageSupported = typeof window !== 'undefined' && 'localStorage' in window;
var $2ad6c8ff1724a4ba$var$getter;
var $2ad6c8ff1724a4ba$var$setter;
function $2ad6c8ff1724a4ba$var$setHandlers(handlers) {
    handlers || (handlers = {});
    $2ad6c8ff1724a4ba$var$getter = handlers.getter;
    $2ad6c8ff1724a4ba$var$setter = handlers.setter;
}
function $2ad6c8ff1724a4ba$var$setNamespace(namespace) {
    $2ad6c8ff1724a4ba$var$NAMESPACE = namespace;
}
function $2ad6c8ff1724a4ba$var$update(state) {
    for(var key in state){
        var value = state[key];
        $2ad6c8ff1724a4ba$var$set(key, value);
    }
}
function $2ad6c8ff1724a4ba$var$set(key, value) {
    if ($2ad6c8ff1724a4ba$var$setter) $2ad6c8ff1724a4ba$var$setter(key, value);
    else {
        if (!$2ad6c8ff1724a4ba$var$isLocalStorageSupported) return;
        try {
            window.localStorage["".concat($2ad6c8ff1724a4ba$var$NAMESPACE, ".").concat(key)] = JSON.stringify(value);
        } catch (e) {}
    }
}
function $2ad6c8ff1724a4ba$var$get(key) {
    if ($2ad6c8ff1724a4ba$var$getter) return $2ad6c8ff1724a4ba$var$getter(key);
    else {
        if (!$2ad6c8ff1724a4ba$var$isLocalStorageSupported) return;
        try {
            var value = window.localStorage["".concat($2ad6c8ff1724a4ba$var$NAMESPACE, ".").concat(key)];
            if (value) return JSON.parse(value);
        } catch (e) {
            return;
        }
    }
}
var $2ad6c8ff1724a4ba$export$2e2bcd8739ae039 = {
    update: $2ad6c8ff1724a4ba$var$update,
    set: $2ad6c8ff1724a4ba$var$set,
    get: $2ad6c8ff1724a4ba$var$get,
    setNamespace: $2ad6c8ff1724a4ba$var$setNamespace,
    setHandlers: $2ad6c8ff1724a4ba$var$setHandlers
};


var $628006758d42fcd6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function NimbleEmojiIndex(data, set) {
        (0, (/*@__PURE__*/$parcel$interopDefault($dcaf774d05a9aa7c$exports)))(this, NimbleEmojiIndex);
        if (data.compressed) (0, $830cae75b13dfa31$export$4766cff981d64eb2)(data);
        this.data = data || {};
        this.set = set || null;
        this.originalPool = {};
        this.index = {};
        this.emojis = {};
        this.emoticons = {};
        this.customEmojisList = [];
        this.buildIndex();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($32463816393cb059$exports)))(NimbleEmojiIndex, [
        {
            key: "buildIndex",
            value: function buildIndex() {
                var _this = this;
                var _loop = function _loop(emoji) {
                    var emojiData = _this.data.emojis[emoji], short_names = emojiData.short_names, emoticons = emojiData.emoticons, skin_variations = emojiData.skin_variations, id = short_names[0];
                    if (emoticons) emoticons.forEach(function(emoticon) {
                        if (_this.emoticons[emoticon]) return;
                        _this.emoticons[emoticon] = id;
                    });
                     // If skin variations include them
                    if (skin_variations) {
                        _this.emojis[id] = {};
                        for(var skinTone = 1; skinTone <= 6; skinTone++)_this.emojis[id][skinTone] = (0, $80e1b209c9176fcd$export$b57a2d1f0ad365d6)({
                            id: id,
                            skin: skinTone
                        }, skinTone, _this.set, _this.data);
                    } else _this.emojis[id] = (0, $80e1b209c9176fcd$export$b57a2d1f0ad365d6)(id, null, _this.set, _this.data);
                    _this.originalPool[id] = emojiData;
                };
                for(var emoji in this.data.emojis)_loop(emoji);
            }
        },
        {
            key: "clearCustomEmojis",
            value: function clearCustomEmojis(pool) {
                var _this2 = this;
                this.customEmojisList.forEach(function(emoji) {
                    var emojiId = emoji.id || emoji.short_names[0];
                    delete pool[emojiId];
                    delete _this2.emojis[emojiId];
                });
            }
        },
        {
            key: "addCustomToPool",
            value: function addCustomToPool(custom, pool) {
                var _this3 = this;
                if (this.customEmojisList.length) this.clearCustomEmojis(pool);
                custom.forEach(function(emoji) {
                    var emojiId = emoji.id || emoji.short_names[0];
                    if (emojiId && !pool[emojiId]) {
                        pool[emojiId] = (0, $80e1b209c9176fcd$export$7a171f172be0782e)(emoji, null, null, _this3.data);
                        _this3.emojis[emojiId] = (0, $80e1b209c9176fcd$export$b57a2d1f0ad365d6)(emoji, null, null, _this3.data);
                    }
                });
                this.customEmojisList = custom;
                this.index = {};
            }
        },
        {
            key: "search",
            value: function search(value) {
                var _this4 = this;
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, emojisToShowFilter = _ref.emojisToShowFilter, maxResults = _ref.maxResults, include = _ref.include, exclude = _ref.exclude, _ref$custom = _ref.custom, custom = _ref$custom === void 0 ? [] : _ref$custom;
                if (this.customEmojisList != custom) this.addCustomToPool(custom, this.originalPool);
                var skinTone = (0, $2ad6c8ff1724a4ba$export$2e2bcd8739ae039).get('skin') || 1;
                maxResults || (maxResults = 75);
                include || (include = []);
                exclude || (exclude = []);
                var results = null, pool = this.originalPool;
                if (value.length) {
                    if (value == '-' || value == '-1') return [
                        this.emojis['-1'][skinTone]
                    ];
                    var values = value.toLowerCase().split(/[\s|,|\-|_]+/), allResults = [];
                    if (values.length > 2) values = [
                        values[0],
                        values[1]
                    ];
                    if (include.length || exclude.length) {
                        pool = {};
                        this.data.categories.forEach(function(category) {
                            var isIncluded = include && include.length ? include.indexOf(category.id) > -1 : true;
                            var isExcluded = exclude && exclude.length ? exclude.indexOf(category.id) > -1 : false;
                            if (!isIncluded || isExcluded) return;
                            category.emojis.forEach(function(emojiId) {
                                return pool[emojiId] = _this4.data.emojis[emojiId];
                            });
                        });
                        if (custom.length) {
                            var customIsIncluded = include && include.length ? include.indexOf('custom') > -1 : true;
                            var customIsExcluded = exclude && exclude.length ? exclude.indexOf('custom') > -1 : false;
                            if (customIsIncluded && !customIsExcluded) this.addCustomToPool(custom, pool);
                        }
                    }
                    allResults = values.map(function(value) {
                        var aPool = pool, aIndex = _this4.index, length = 0;
                        for(var charIndex = 0; charIndex < value.length; charIndex++){
                            var _char = value[charIndex];
                            length++;
                            aIndex[_char] || (aIndex[_char] = {});
                            aIndex = aIndex[_char];
                            if (!aIndex.results) (function() {
                                var scores = {};
                                aIndex.results = [];
                                aIndex.pool = {};
                                for(var id in aPool){
                                    var emoji = aPool[id], search = emoji.search, sub = value.substr(0, length), subIndex = search.indexOf(sub);
                                    if (subIndex != -1) {
                                        var score = subIndex + 1;
                                        if (sub == id) score = 0;
                                        if (_this4.emojis[id] && _this4.emojis[id][skinTone]) aIndex.results.push(_this4.emojis[id][skinTone]);
                                        else aIndex.results.push(_this4.emojis[id]);
                                        aIndex.pool[id] = emoji;
                                        scores[id] = score;
                                    }
                                }
                                aIndex.results.sort(function(a, b) {
                                    var aScore = scores[a.id], bScore = scores[b.id];
                                    if (aScore == bScore) return a.id.localeCompare(b.id);
                                    else return aScore - bScore;
                                });
                            })();
                            aPool = aIndex.pool;
                        }
                        return aIndex.results;
                    }).filter(function(a) {
                        return a;
                    });
                    if (allResults.length > 1) results = (0, $80e1b209c9176fcd$export$1f4807a235930d45).apply(null, allResults);
                    else if (allResults.length) results = allResults[0];
                    else results = [];
                }
                if (results) {
                    if (emojisToShowFilter) results = results.filter(function(result) {
                        return emojisToShowFilter(pool[result.id]);
                    });
                    if (results && results.length > maxResults) results = results.slice(0, maxResults);
                }
                return results;
            }
        }
    ]);
    return NimbleEmojiIndex;
}();


var $e958db097117f9c2$var$emojiIndex = new (0, $628006758d42fcd6$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($f38df6b76ce15393$exports))));
var $e958db097117f9c2$var$emojis = $e958db097117f9c2$var$emojiIndex.emojis, $e958db097117f9c2$var$emoticons = $e958db097117f9c2$var$emojiIndex.emoticons;
function $e958db097117f9c2$var$search() {
    return $e958db097117f9c2$var$emojiIndex.search.apply($e958db097117f9c2$var$emojiIndex, arguments);
}
var $e958db097117f9c2$export$2e2bcd8739ae039 = {
    search: $e958db097117f9c2$var$search,
    emojis: $e958db097117f9c2$var$emojis,
    emoticons: $e958db097117f9c2$var$emoticons
};





var $a3916ab1464f03aa$var$DEFAULTS = [
    '+1',
    'grinning',
    'kissing_heart',
    'heart_eyes',
    'laughing',
    'stuck_out_tongue_winking_eye',
    'sweat_smile',
    'joy',
    'scream',
    'disappointed',
    'unamused',
    'weary',
    'sob',
    'sunglasses',
    'heart',
    'poop'
];
var $a3916ab1464f03aa$var$frequently, $a3916ab1464f03aa$var$initialized;
var $a3916ab1464f03aa$var$defaults = {};
function $a3916ab1464f03aa$var$init() {
    $a3916ab1464f03aa$var$initialized = true;
    $a3916ab1464f03aa$var$frequently = (0, $2ad6c8ff1724a4ba$export$2e2bcd8739ae039).get('frequently');
}
function $a3916ab1464f03aa$var$add(emoji) {
    if (!$a3916ab1464f03aa$var$initialized) $a3916ab1464f03aa$var$init();
    var id = emoji.id;
    $a3916ab1464f03aa$var$frequently || ($a3916ab1464f03aa$var$frequently = $a3916ab1464f03aa$var$defaults);
    $a3916ab1464f03aa$var$frequently[id] || ($a3916ab1464f03aa$var$frequently[id] = 0);
    $a3916ab1464f03aa$var$frequently[id] += 1;
    (0, $2ad6c8ff1724a4ba$export$2e2bcd8739ae039).set('last', id);
    (0, $2ad6c8ff1724a4ba$export$2e2bcd8739ae039).set('frequently', $a3916ab1464f03aa$var$frequently);
}
function $a3916ab1464f03aa$var$get(perLine) {
    if (!$a3916ab1464f03aa$var$initialized) $a3916ab1464f03aa$var$init();
    if (!$a3916ab1464f03aa$var$frequently) {
        $a3916ab1464f03aa$var$defaults = {};
        var result = [];
        for(var i = 0; i < perLine; i++){
            $a3916ab1464f03aa$var$defaults[$a3916ab1464f03aa$var$DEFAULTS[i]] = perLine - i;
            result.push($a3916ab1464f03aa$var$DEFAULTS[i]);
        }
        return result;
    }
    var quantity = perLine * 4;
    var frequentlyKeys = [];
    for(var key in $a3916ab1464f03aa$var$frequently)if ($a3916ab1464f03aa$var$frequently.hasOwnProperty(key)) frequentlyKeys.push(key);
    var sorted = frequentlyKeys.sort(function(a, b) {
        return $a3916ab1464f03aa$var$frequently[a] - $a3916ab1464f03aa$var$frequently[b];
    }).reverse();
    var sliced = sorted.slice(0, quantity);
    var last = (0, $2ad6c8ff1724a4ba$export$2e2bcd8739ae039).get('last');
    if (last && sliced.indexOf(last) == -1) {
        sliced.pop();
        sliced.push(last);
    }
    return sliced;
}
var $a3916ab1464f03aa$export$2e2bcd8739ae039 = {
    add: $a3916ab1464f03aa$var$add,
    get: $a3916ab1464f03aa$var$get
};




var $fWb4i = parcelRequire("fWb4i");
var $3d838c0241a6eaae$exports = {};
function $3d838c0241a6eaae$var$_extends() {
    $3d838c0241a6eaae$exports = $3d838c0241a6eaae$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $3d838c0241a6eaae$exports.__esModule = true, $3d838c0241a6eaae$exports["default"] = $3d838c0241a6eaae$exports;
    return $3d838c0241a6eaae$var$_extends.apply(this, arguments);
}
$3d838c0241a6eaae$exports = $3d838c0241a6eaae$var$_extends, $3d838c0241a6eaae$exports.__esModule = true, $3d838c0241a6eaae$exports["default"] = $3d838c0241a6eaae$exports;




var $91acba9e7e731445$exports = {};

var $tywpZ = parcelRequire("tywpZ");
var $91acba9e7e731445$var$_typeof = $tywpZ.default;
var $fb31538619d00be8$exports = {};
function $fb31538619d00be8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$fb31538619d00be8$exports = $fb31538619d00be8$var$_assertThisInitialized, $fb31538619d00be8$exports.__esModule = true, $fb31538619d00be8$exports["default"] = $fb31538619d00be8$exports;


function $91acba9e7e731445$var$_possibleConstructorReturn(self, call) {
    if (call && ($91acba9e7e731445$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $fb31538619d00be8$exports(self);
}
$91acba9e7e731445$exports = $91acba9e7e731445$var$_possibleConstructorReturn, $91acba9e7e731445$exports.__esModule = true, $91acba9e7e731445$exports["default"] = $91acba9e7e731445$exports;


var $b3bcf25de6df0a59$exports = {};
function $b3bcf25de6df0a59$var$_getPrototypeOf(o) {
    $b3bcf25de6df0a59$exports = $b3bcf25de6df0a59$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, $b3bcf25de6df0a59$exports.__esModule = true, $b3bcf25de6df0a59$exports["default"] = $b3bcf25de6df0a59$exports;
    return $b3bcf25de6df0a59$var$_getPrototypeOf(o);
}
$b3bcf25de6df0a59$exports = $b3bcf25de6df0a59$var$_getPrototypeOf, $b3bcf25de6df0a59$exports.__esModule = true, $b3bcf25de6df0a59$exports["default"] = $b3bcf25de6df0a59$exports;


var $ba81ef946c36ecb1$exports = {};
var $d5c7ae7922a0aeaf$exports = {};
function $d5c7ae7922a0aeaf$var$_setPrototypeOf(o, p) {
    $d5c7ae7922a0aeaf$exports = $d5c7ae7922a0aeaf$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, $d5c7ae7922a0aeaf$exports.__esModule = true, $d5c7ae7922a0aeaf$exports["default"] = $d5c7ae7922a0aeaf$exports;
    return $d5c7ae7922a0aeaf$var$_setPrototypeOf(o, p);
}
$d5c7ae7922a0aeaf$exports = $d5c7ae7922a0aeaf$var$_setPrototypeOf, $d5c7ae7922a0aeaf$exports.__esModule = true, $d5c7ae7922a0aeaf$exports["default"] = $d5c7ae7922a0aeaf$exports;


function $ba81ef946c36ecb1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d5c7ae7922a0aeaf$exports(subClass, superClass);
}
$ba81ef946c36ecb1$exports = $ba81ef946c36ecb1$var$_inherits, $ba81ef946c36ecb1$exports.__esModule = true, $ba81ef946c36ecb1$exports["default"] = $ba81ef946c36ecb1$exports;



var $6fFrj = parcelRequire("6fFrj");


var $fWb4i = parcelRequire("fWb4i");







var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");
var $10ec67454dcd9a10$exports = {};

$parcel$export($10ec67454dcd9a10$exports, "categories", function () { return $10ec67454dcd9a10$export$2c76aca27257bcfa; });
$parcel$export($10ec67454dcd9a10$exports, "search", function () { return $10ec67454dcd9a10$export$d76128d007d19019; });

var $6fFrj = parcelRequire("6fFrj");
var $10ec67454dcd9a10$export$2c76aca27257bcfa = {
    activity: function activity() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
        }));
    },
    custom: function custom() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("g", {
            transform: "translate(2.000000, 1.000000)"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("rect", {
            id: "Rectangle",
            x: "8",
            y: "0",
            width: "3",
            height: "21",
            rx: "1.5"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("rect", {
            id: "Rectangle",
            transform: "translate(9.843, 10.549) rotate(60) translate(-9.843, -10.549) ",
            x: "8.343",
            y: "0.049",
            width: "3",
            height: "21",
            rx: "1.5"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("rect", {
            id: "Rectangle",
            transform: "translate(9.843, 10.549) rotate(-60) translate(-9.843, -10.549) ",
            x: "8.343",
            y: "0.049",
            width: "3",
            height: "21",
            rx: "1.5"
        })));
    },
    flags: function flags() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
        }));
    },
    foods: function foods() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
        }));
    },
    nature: function nature() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
        }));
    },
    objects: function objects() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
        }));
    },
    people: function people() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
        }));
    },
    places: function places() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
        }));
    },
    recent: function recent() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
        }));
    },
    symbols: function symbols() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
        }));
    }
};
var $10ec67454dcd9a10$export$d76128d007d19019 = {
    search: function search() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "13",
            height: "13",
            viewBox: "0 0 20 20",
            opacity: "0.5"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
        }));
    },
    "delete": function _delete() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "13",
            height: "13",
            viewBox: "0 0 20 20",
            opacity: "0.5"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("path", {
            d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
        }));
    }
};







var $cgjHV = parcelRequire("cgjHV");
var $9c0a9e8920452cae$export$1fcb9d5d71ab22f7 = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
    onOver: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    fallback: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    backgroundImageFn: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    "native": (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    forceSize: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    useButton: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    skin: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf([
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    sheetSize: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf([
        16,
        20,
        32,
        64
    ]),
    sheetColumns: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    sheetRows: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    set: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf([
        'apple',
        'google',
        'twitter',
        'facebook'
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number.isRequired,
    emoji: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
    ]).isRequired
};
var $9c0a9e8920452cae$export$8673a3795efdab32 = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onSkinChange: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    perLine: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    emojiSize: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    i18n: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    emoji: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    set: $9c0a9e8920452cae$export$1fcb9d5d71ab22f7.set,
    skin: $9c0a9e8920452cae$export$1fcb9d5d71ab22f7.skin,
    "native": (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    backgroundImageFn: $9c0a9e8920452cae$export$1fcb9d5d71ab22f7.backgroundImageFn,
    sheetSize: $9c0a9e8920452cae$export$1fcb9d5d71ab22f7.sheetSize,
    emojisToShowFilter: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    showPreview: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    showSkinTones: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    emojiTooltip: $9c0a9e8920452cae$export$1fcb9d5d71ab22f7.tooltip,
    useButton: $9c0a9e8920452cae$export$1fcb9d5d71ab22f7.useButton,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf([
        'auto',
        'light',
        'dark'
    ]),
    include: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string),
    exclude: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string),
    recent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string),
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    enableFrequentEmojiSort: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    custom: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired,
        short_names: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string).isRequired,
        emoticons: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string),
        keywords: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        spriteUrl: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        sheet_x: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
        sheet_y: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
        size: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
        sheetColumns: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
        sheetRows: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number
    })),
    skinEmoji: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    notFound: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    notFoundEmoji: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    icons: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
};









var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");
var $7c32239f0bbde921$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($ba81ef946c36ecb1$exports)))(Anchors, _React$PureComponent);
    function Anchors(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dcaf774d05a9aa7c$exports)))(this, Anchors);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($91acba9e7e731445$exports)))(this, (0, (/*@__PURE__*/$parcel$interopDefault($b3bcf25de6df0a59$exports)))(Anchors).call(this, props));
        var defaultCategory = props.categories.filter(function(category) {
            return category.first;
        })[0];
        _this.state = {
            selected: defaultCategory.name
        };
        _this.handleClick = _this.handleClick.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($32463816393cb059$exports)))(Anchors, [
        {
            key: "handleClick",
            value: function handleClick(e) {
                var index = e.currentTarget.getAttribute('data-index');
                var _this$props = this.props, categories = _this$props.categories, onAnchorClick = _this$props.onAnchorClick;
                onAnchorClick(categories[index], index);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, categories = _this$props2.categories, color = _this$props2.color, i18n = _this$props2.i18n, icons = _this$props2.icons, selected = this.state.selected;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("nav", {
                    className: "emoji-mart-anchors",
                    "aria-label": i18n.categorieslabel
                }, categories.map(function(category, i) {
                    var id = category.id, name = category.name, anchor = category.anchor, isSelected = name == selected;
                    if (anchor === false) return null;
                    var iconId = id.startsWith('custom-') ? 'custom' : id;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
                        key: id,
                        "aria-label": i18n.categories[iconId],
                        title: i18n.categories[iconId],
                        "data-index": i,
                        type: 'button',
                        onClick: _this2.handleClick,
                        className: "emoji-mart-anchor ".concat(isSelected ? 'emoji-mart-anchor-selected' : ''),
                        style: {
                            color: isSelected ? color : null
                        }
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                        className: "emoji-mart-anchor-icon"
                    }, icons.categories[iconId]()), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
                        className: "emoji-mart-anchor-bar",
                        style: {
                            backgroundColor: color
                        }
                    }));
                }));
            }
        }
    ]);
    return Anchors;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).PureComponent);
$7c32239f0bbde921$export$2e2bcd8739ae039.propTypes = {
    categories: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).array,
    onAnchorClick: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    icons: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
};
$7c32239f0bbde921$export$2e2bcd8739ae039.defaultProps = {
    categories: [],
    onAnchorClick: function onAnchorClick() {},
    icons: {}
};



var $fWb4i = parcelRequire("fWb4i");







var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");




var $fWb4i = parcelRequire("fWb4i");

var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");



var $76e1ebbd65e6a9d9$export$a2cd0decb2235f50 = {
    skin: 1,
    set: 'apple',
    sheetSize: 64,
    sheetColumns: 57,
    sheetRows: 57,
    "native": false,
    forceSize: false,
    tooltip: false,
    useButton: true,
    backgroundImageFn: function backgroundImageFn(set, sheetSize) {
        return "https://unpkg.com/emoji-datasource-".concat(set, "@").concat("5.0.1", "/img/").concat(set, "/sheets-256/").concat(sheetSize, ".png");
    }
};
var $76e1ebbd65e6a9d9$export$f719a773a9b3cddd = {
    onClick: function onClick() {},
    onSelect: function onSelect() {},
    onSkinChange: function onSkinChange() {},
    emojiSize: 24,
    perLine: 9,
    i18n: {},
    style: {},
    title: "Emoji Mart\u2122",
    emoji: 'department_store',
    color: '#ae65c5',
    set: $76e1ebbd65e6a9d9$export$a2cd0decb2235f50.set,
    theme: 'light',
    skin: null,
    defaultSkin: $76e1ebbd65e6a9d9$export$a2cd0decb2235f50.skin,
    "native": $76e1ebbd65e6a9d9$export$a2cd0decb2235f50["native"],
    sheetSize: $76e1ebbd65e6a9d9$export$a2cd0decb2235f50.sheetSize,
    backgroundImageFn: $76e1ebbd65e6a9d9$export$a2cd0decb2235f50.backgroundImageFn,
    emojisToShowFilter: null,
    showPreview: true,
    showSkinTones: true,
    emojiTooltip: $76e1ebbd65e6a9d9$export$a2cd0decb2235f50.tooltip,
    useButton: $76e1ebbd65e6a9d9$export$a2cd0decb2235f50.useButton,
    autoFocus: false,
    enableFrequentEmojiSort: false,
    custom: [],
    skinEmoji: '',
    notFound: function notFound() {},
    notFoundEmoji: 'sleuth_or_spy',
    icons: {}
};


function $a810d847f8b45082$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a810d847f8b45082$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a810d847f8b45082$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fWb4i)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a810d847f8b45082$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $a810d847f8b45082$var$_getData = function _getData(props) {
    var emoji = props.emoji, skin = props.skin, set = props.set, data = props.data;
    return (0, $80e1b209c9176fcd$export$7a171f172be0782e)(emoji, skin, set, data);
};
var $a810d847f8b45082$var$_getPosition = function _getPosition(props) {
    var _getData2 = $a810d847f8b45082$var$_getData(props), sheet_x = _getData2.sheet_x, sheet_y = _getData2.sheet_y, multiplyX = 100 / (props.sheetColumns - 1), multiplyY = 100 / (props.sheetRows - 1);
    return "".concat(multiplyX * sheet_x, "% ").concat(multiplyY * sheet_y, "%");
};
var $a810d847f8b45082$var$_getSanitizedData = function _getSanitizedData(props) {
    var emoji = props.emoji, skin = props.skin, set = props.set, data = props.data;
    return (0, $80e1b209c9176fcd$export$b57a2d1f0ad365d6)(emoji, skin, set, data);
};
var $a810d847f8b45082$var$_handleClick = function _handleClick(e, props) {
    if (!props.onClick) return;
    var onClick = props.onClick, emoji = $a810d847f8b45082$var$_getSanitizedData(props);
    onClick(emoji, e);
};
var $a810d847f8b45082$var$_handleOver = function _handleOver(e, props) {
    if (!props.onOver) return;
    var onOver = props.onOver, emoji = $a810d847f8b45082$var$_getSanitizedData(props);
    onOver(emoji, e);
};
var $a810d847f8b45082$var$_handleLeave = function _handleLeave(e, props) {
    if (!props.onLeave) return;
    var onLeave = props.onLeave, emoji = $a810d847f8b45082$var$_getSanitizedData(props);
    onLeave(emoji, e);
};
var $a810d847f8b45082$var$_isNumeric = function _isNumeric(value) {
    return !isNaN(value - parseFloat(value));
};
var $a810d847f8b45082$var$_convertStyleToCSS = function _convertStyleToCSS(style) {
    var div = document.createElement('div');
    for(var key in style){
        var value = style[key];
        if ($a810d847f8b45082$var$_isNumeric(value)) value += 'px';
        div.style[key] = value;
    }
    return div.getAttribute('style');
};
var $a810d847f8b45082$var$NimbleEmoji = function NimbleEmoji(props) {
    if (props.data.compressed) (0, $830cae75b13dfa31$export$4766cff981d64eb2)(props.data);
    for(var k in NimbleEmoji.defaultProps)if (props[k] == undefined && NimbleEmoji.defaultProps[k] != undefined) props[k] = NimbleEmoji.defaultProps[k];
    var data = $a810d847f8b45082$var$_getData(props);
    if (!data) {
        if (props.fallback) return props.fallback(null, props);
        else return null;
    }
    var unified = data.unified, custom = data.custom, short_names = data.short_names, imageUrl = data.imageUrl, style = {}, children = props.children, className = 'emoji-mart-emoji', nativeEmoji = unified && (0, $80e1b209c9176fcd$export$847d071486fee30d)(unified), label = [
        nativeEmoji
    ].concat(short_names).filter(Boolean).join(', '), title = null;
    if (!unified && !custom) {
        if (props.fallback) return props.fallback(data, props);
        else return null;
    }
    if (props.tooltip) title = short_names[0];
    if (props["native"] && unified) {
        className += ' emoji-mart-emoji-native';
        style = {
            fontSize: props.size
        };
        children = nativeEmoji;
        if (props.forceSize) {
            style.display = 'inline-block';
            style.width = props.size;
            style.height = props.size;
            style.wordBreak = 'keep-all';
        }
    } else if (custom) {
        className += ' emoji-mart-emoji-custom';
        style = {
            width: props.size,
            height: props.size,
            display: 'inline-block'
        };
        if (data.spriteUrl) style = $a810d847f8b45082$var$_objectSpread({}, style, {
            backgroundImage: "url(".concat(data.spriteUrl, ")"),
            backgroundSize: "".concat(100 * props.sheetColumns, "% ").concat(100 * props.sheetRows, "%"),
            backgroundPosition: $a810d847f8b45082$var$_getPosition(props)
        });
        else style = $a810d847f8b45082$var$_objectSpread({}, style, {
            backgroundImage: "url(".concat(imageUrl, ")"),
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
        });
    } else {
        var setHasEmoji = data["has_img_".concat(props.set)] == undefined || data["has_img_".concat(props.set)];
        if (!setHasEmoji) {
            if (props.fallback) return props.fallback(data, props);
            else return null;
        } else style = {
            width: props.size,
            height: props.size,
            display: 'inline-block',
            backgroundImage: "url(".concat(props.backgroundImageFn(props.set, props.sheetSize), ")"),
            backgroundSize: "".concat(100 * props.sheetColumns, "% ").concat(100 * props.sheetRows, "%"),
            backgroundPosition: $a810d847f8b45082$var$_getPosition(props)
        };
    }
    var Tag = {
        name: 'span',
        props: {}
    };
    if (props.onClick && props.useButton) {
        Tag.name = 'button';
        Tag.props = {
            type: 'button'
        };
    }
    if (props.html) {
        style = $a810d847f8b45082$var$_convertStyleToCSS(style);
        return "<".concat(Tag.name, " style='").concat(style, "' aria-label='").concat(label, "' ").concat(title ? "title='".concat(title, "'") : '', " class='").concat(className, "'>").concat(children || '', "</").concat(Tag.name, ">");
    } else return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(Tag.name, (0, (/*@__PURE__*/$parcel$interopDefault($3d838c0241a6eaae$exports)))({
        onClick: function onClick(e) {
            return $a810d847f8b45082$var$_handleClick(e, props);
        },
        onMouseEnter: function onMouseEnter(e) {
            return $a810d847f8b45082$var$_handleOver(e, props);
        },
        onMouseLeave: function onMouseLeave(e) {
            return $a810d847f8b45082$var$_handleLeave(e, props);
        },
        "aria-label": label,
        title: title,
        className: className
    }, Tag.props), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
        style: style
    }, children));
};
$a810d847f8b45082$var$NimbleEmoji.propTypes = $a810d847f8b45082$var$_objectSpread({}, (0, $9c0a9e8920452cae$export$1fcb9d5d71ab22f7), {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired
});
$a810d847f8b45082$var$NimbleEmoji.defaultProps = (0, $76e1ebbd65e6a9d9$export$a2cd0decb2235f50);
var $a810d847f8b45082$export$2e2bcd8739ae039 = $a810d847f8b45082$var$NimbleEmoji;



var $fWb4i = parcelRequire("fWb4i");






var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");

function $ece874b63d41d32f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ece874b63d41d32f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ece874b63d41d32f$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fWb4i)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ece874b63d41d32f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $ece874b63d41d32f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($ba81ef946c36ecb1$exports)))(NotFound, _React$PureComponent);
    function NotFound() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dcaf774d05a9aa7c$exports)))(this, NotFound);
        return (0, (/*@__PURE__*/$parcel$interopDefault($91acba9e7e731445$exports)))(this, (0, (/*@__PURE__*/$parcel$interopDefault($b3bcf25de6df0a59$exports)))(NotFound).apply(this, arguments));
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($32463816393cb059$exports)))(NotFound, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, data = _this$props.data, emojiProps = _this$props.emojiProps, i18n = _this$props.i18n, notFound = _this$props.notFound, notFoundEmoji = _this$props.notFoundEmoji;
                var component = notFound && notFound() || (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "emoji-mart-no-results"
                }, (0, $a810d847f8b45082$export$2e2bcd8739ae039)($ece874b63d41d32f$var$_objectSpread({
                    data: data
                }, emojiProps, {
                    size: 38,
                    emoji: notFoundEmoji,
                    onOver: null,
                    onLeave: null,
                    onClick: null
                })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "emoji-mart-no-results-label"
                }, i18n.notfound));
                return component;
            }
        }
    ]);
    return NotFound;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).PureComponent);
$ece874b63d41d32f$export$2e2bcd8739ae039.propTypes = {
    notFound: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func.isRequired,
    emojiProps: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired
};


function $6306c91159367f6a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6306c91159367f6a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $6306c91159367f6a$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fWb4i)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $6306c91159367f6a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $6306c91159367f6a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($ba81ef946c36ecb1$exports)))(Category, _React$Component);
    function Category(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dcaf774d05a9aa7c$exports)))(this, Category);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($91acba9e7e731445$exports)))(this, (0, (/*@__PURE__*/$parcel$interopDefault($b3bcf25de6df0a59$exports)))(Category).call(this, props));
        _this.data = props.data;
        _this.setContainerRef = _this.setContainerRef.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.setLabelRef = _this.setLabelRef.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($32463816393cb059$exports)))(Category, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.margin = 0;
                this.minMargin = 0;
                this.memoizeSize();
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                var _this$props = this.props, name = _this$props.name, perLine = _this$props.perLine, _native = _this$props["native"], hasStickyPosition = _this$props.hasStickyPosition, emojis = _this$props.emojis, emojiProps = _this$props.emojiProps, skin = emojiProps.skin, size = emojiProps.size, set = emojiProps.set, nextPerLine = nextProps.perLine, nextNative = nextProps["native"], nextHasStickyPosition = nextProps.hasStickyPosition, nextEmojis = nextProps.emojis, nextEmojiProps = nextProps.emojiProps, nextSkin = nextEmojiProps.skin, nextSize = nextEmojiProps.size, nextSet = nextEmojiProps.set, shouldUpdate = false;
                if (name == 'Recent' && perLine != nextPerLine) shouldUpdate = true;
                if (name == 'Search') shouldUpdate = !(emojis == nextEmojis);
                if (skin != nextSkin || size != nextSize || _native != nextNative || set != nextSet || hasStickyPosition != nextHasStickyPosition) shouldUpdate = true;
                return shouldUpdate;
            }
        },
        {
            key: "memoizeSize",
            value: function memoizeSize() {
                if (!this.container) {
                    // probably this is a test environment, e.g. jest
                    this.top = 0;
                    this.maxMargin = 0;
                    return;
                }
                var parent = this.container.parentElement;
                var _this$container$getBo = this.container.getBoundingClientRect(), top = _this$container$getBo.top, height = _this$container$getBo.height;
                var _parent$getBoundingCl = parent.getBoundingClientRect(), parentTop = _parent$getBoundingCl.top;
                var _this$label$getBoundi = this.label.getBoundingClientRect(), labelHeight = _this$label$getBoundi.height;
                this.top = top - parentTop + parent.scrollTop;
                if (height == 0) this.maxMargin = 0;
                else this.maxMargin = height - labelHeight;
            }
        },
        {
            key: "handleScroll",
            value: function handleScroll(scrollTop) {
                var margin = scrollTop - this.top;
                margin = margin < this.minMargin ? this.minMargin : margin;
                margin = margin > this.maxMargin ? this.maxMargin : margin;
                if (margin == this.margin) return;
                if (!this.props.hasStickyPosition) this.label.style.top = "".concat(margin, "px");
                this.margin = margin;
                return true;
            }
        },
        {
            key: "getEmojis",
            value: function getEmojis() {
                var _this2 = this;
                var _this$props2 = this.props, name = _this$props2.name, emojis = _this$props2.emojis, recent = _this$props2.recent, perLine = _this$props2.perLine;
                if (name == 'Recent') {
                    var custom = this.props.custom;
                    var frequentlyUsed = recent || (0, $a3916ab1464f03aa$export$2e2bcd8739ae039).get(perLine);
                    if (frequentlyUsed.length) emojis = frequentlyUsed.map(function(id) {
                        var emoji = custom.filter(function(e) {
                            return e.id === id;
                        })[0];
                        if (emoji) return emoji;
                        return id;
                    }).filter(function(id) {
                        return !!(0, $80e1b209c9176fcd$export$7a171f172be0782e)(id, null, null, _this2.data);
                    });
                    if (emojis.length === 0 && frequentlyUsed.length > 0) return null;
                }
                if (emojis) emojis = emojis.slice(0);
                return emojis;
            }
        },
        {
            key: "updateDisplay",
            value: function updateDisplay(display) {
                var emojis = this.getEmojis();
                if (!emojis || !this.container) return;
                this.container.style.display = display;
            }
        },
        {
            key: "setContainerRef",
            value: function setContainerRef(c) {
                this.container = c;
            }
        },
        {
            key: "setLabelRef",
            value: function setLabelRef(c) {
                this.label = c;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props3 = this.props, id = _this$props3.id, name = _this$props3.name, hasStickyPosition = _this$props3.hasStickyPosition, emojiProps = _this$props3.emojiProps, i18n = _this$props3.i18n, notFound = _this$props3.notFound, notFoundEmoji = _this$props3.notFoundEmoji, emojis = this.getEmojis(), labelStyles = {}, labelSpanStyles = {}, containerStyles = {};
                if (!emojis) containerStyles = {
                    display: 'none'
                };
                if (!hasStickyPosition) {
                    labelStyles = {
                        height: 28
                    };
                    labelSpanStyles = {
                        position: 'absolute'
                    };
                }
                var label = i18n.categories[id] || name;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("section", {
                    ref: this.setContainerRef,
                    className: "emoji-mart-category",
                    "aria-label": label,
                    style: containerStyles
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    style: labelStyles,
                    "data-name": name,
                    className: "emoji-mart-category-label"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
                    style: labelSpanStyles,
                    ref: this.setLabelRef,
                    "aria-hidden": true
                }, label)), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("ul", {
                    className: "emoji-mart-category-list"
                }, emojis && emojis.map(function(emoji) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("li", {
                        key: emoji.short_names && emoji.short_names.join('_') || emoji
                    }, (0, $a810d847f8b45082$export$2e2bcd8739ae039)($6306c91159367f6a$var$_objectSpread({
                        emoji: emoji,
                        data: _this3.data
                    }, emojiProps)));
                })), emojis && !emojis.length && (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $ece874b63d41d32f$export$2e2bcd8739ae039), {
                    i18n: i18n,
                    notFound: notFound,
                    notFoundEmoji: notFoundEmoji,
                    data: this.data,
                    emojiProps: emojiProps
                }));
            }
        }
    ]);
    return Category;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component);
$6306c91159367f6a$export$2e2bcd8739ae039.propTypes = {
    emojis: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).array,
    hasStickyPosition: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired,
    "native": (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool.isRequired,
    perLine: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number.isRequired,
    emojiProps: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
    recent: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string),
    notFound: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    notFoundEmoji: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired
};
$6306c91159367f6a$export$2e2bcd8739ae039.defaultProps = {
    emojis: [],
    hasStickyPosition: true
};



var $fWb4i = parcelRequire("fWb4i");






var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");









var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");







var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");
var $d4a6088b8d904522$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($ba81ef946c36ecb1$exports)))(Skins, _React$PureComponent);
    function Skins(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dcaf774d05a9aa7c$exports)))(this, Skins);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($91acba9e7e731445$exports)))(this, (0, (/*@__PURE__*/$parcel$interopDefault($b3bcf25de6df0a59$exports)))(Skins).call(this, props));
        _this.state = {
            opened: false
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($32463816393cb059$exports)))(Skins, [
        {
            key: "handleClick",
            value: function handleClick(e) {
                var skin = parseInt(e.currentTarget.getAttribute('data-skin'));
                var onChange = this.props.onChange;
                if (!this.state.opened) this.setState({
                    opened: true
                });
                else {
                    this.setState({
                        opened: false
                    });
                    if (skin != this.props.skin) onChange(skin);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return Skins;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).PureComponent);
$d4a6088b8d904522$export$2e2bcd8739ae039.propTypes = {
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    skin: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number.isRequired
};
$d4a6088b8d904522$export$2e2bcd8739ae039.defaultProps = {
    onChange: function onChange() {}
};


var $d4c3f0e84db5dc64$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Skins) {
    (0, (/*@__PURE__*/$parcel$interopDefault($ba81ef946c36ecb1$exports)))(SkinsEmoji, _Skins);
    function SkinsEmoji(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dcaf774d05a9aa7c$exports)))(this, SkinsEmoji);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($91acba9e7e731445$exports)))(this, (0, (/*@__PURE__*/$parcel$interopDefault($b3bcf25de6df0a59$exports)))(SkinsEmoji).call(this, props));
        _this.handleClick = _this.handleClick.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($32463816393cb059$exports)))(SkinsEmoji, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, skin = _this$props.skin, emojiProps = _this$props.emojiProps, data = _this$props.data, skinEmoji = _this$props.skinEmoji, i18n = _this$props.i18n;
                var opened = this.state.opened;
                var skinToneNodes = [];
                for(var skinTone = 1; skinTone <= 6; skinTone++){
                    var selected = skinTone === skin;
                    skinToneNodes.push((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
                        key: "skin-tone-".concat(skinTone),
                        className: "emoji-mart-skin-swatch custom".concat(selected ? ' selected' : '')
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
                        onClick: this.handleClick,
                        "data-skin": skinTone,
                        className: "emoji-mart-skin-tone-".concat(skinTone)
                    }, (0, $a810d847f8b45082$export$2e2bcd8739ae039)({
                        emoji: skinEmoji,
                        data: data,
                        skin: skinTone,
                        backgroundImageFn: emojiProps.backgroundImageFn,
                        "native": emojiProps["native"],
                        set: emojiProps.set,
                        sheetSize: emojiProps.sheetSize,
                        size: 23
                    }))));
                }
                return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "emoji-mart-skin-swatches custom".concat(opened ? ' opened' : '')
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "emoji-mart-skin-text".concat(opened ? ' opened' : '')
                }, i18n.skintext), skinToneNodes);
            }
        }
    ]);
    return SkinsEmoji;
}((0, $d4a6088b8d904522$export$2e2bcd8739ae039));
$d4c3f0e84db5dc64$export$2e2bcd8739ae039.propTypes = {
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    skin: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number.isRequired,
    emojiProps: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
    skinTone: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    skinEmoji: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired,
    i18n: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
};
$d4c3f0e84db5dc64$export$2e2bcd8739ae039.defaultProps = {
    onChange: function onChange() {},
    skinTone: null
};










var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");

var $86f1a77fad080a5e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Skins) {
    (0, (/*@__PURE__*/$parcel$interopDefault($ba81ef946c36ecb1$exports)))(SkinsDot, _Skins);
    function SkinsDot(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dcaf774d05a9aa7c$exports)))(this, SkinsDot);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($91acba9e7e731445$exports)))(this, (0, (/*@__PURE__*/$parcel$interopDefault($b3bcf25de6df0a59$exports)))(SkinsDot).call(this, props));
        _this.handleClick = _this.handleClick.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.handleKeyDown = _this.handleKeyDown.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($32463816393cb059$exports)))(SkinsDot, [
        {
            key: "handleKeyDown",
            value: function handleKeyDown(event) {
                // if either enter or space is pressed, then execute
                if (event.keyCode === 13 || event.keyCode === 32) {
                    event.preventDefault();
                    this.handleClick(event);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, skin = _this$props.skin, i18n = _this$props.i18n;
                var opened = this.state.opened;
                var skinToneNodes = [];
                for(var skinTone = 1; skinTone <= 6; skinTone++){
                    var selected = skinTone === skin;
                    var visible = opened || selected;
                    skinToneNodes.push((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($3d838c0241a6eaae$exports)))({
                        key: "skin-tone-".concat(skinTone),
                        className: "emoji-mart-skin-swatch".concat(selected ? ' selected' : ''),
                        "aria-label": i18n.skintones[skinTone],
                        "aria-hidden": !visible
                    }, opened ? {
                        role: 'menuitem'
                    } : {}), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($3d838c0241a6eaae$exports)))({
                        onClick: this.handleClick,
                        onKeyDown: this.handleKeyDown,
                        role: "button"
                    }, selected ? {
                        'aria-haspopup': true,
                        'aria-expanded': !!opened
                    } : {}, opened ? {
                        'aria-pressed': !!selected
                    } : {}, {
                        tabIndex: visible ? '0' : '',
                        "aria-label": i18n.skintones[skinTone],
                        title: i18n.skintones[skinTone],
                        "data-skin": skinTone,
                        className: "emoji-mart-skin emoji-mart-skin-tone-".concat(skinTone)
                    }))));
                }
                return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("section", {
                    className: "emoji-mart-skin-swatches".concat(opened ? ' opened' : ''),
                    "aria-label": i18n.skintext
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", opened ? {
                    role: 'menubar'
                } : {}, skinToneNodes));
            }
        }
    ]);
    return SkinsDot;
}((0, $d4a6088b8d904522$export$2e2bcd8739ae039));
$86f1a77fad080a5e$export$2e2bcd8739ae039.propTypes = {
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    skin: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number.isRequired,
    i18n: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object
};
$86f1a77fad080a5e$export$2e2bcd8739ae039.defaultProps = {
    onChange: function onChange() {}
};


function $a171fd421cd39e97$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a171fd421cd39e97$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a171fd421cd39e97$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fWb4i)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a171fd421cd39e97$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $a171fd421cd39e97$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($ba81ef946c36ecb1$exports)))(Preview, _React$PureComponent);
    function Preview(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dcaf774d05a9aa7c$exports)))(this, Preview);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($91acba9e7e731445$exports)))(this, (0, (/*@__PURE__*/$parcel$interopDefault($b3bcf25de6df0a59$exports)))(Preview).call(this, props));
        _this.data = props.data;
        _this.state = {
            emoji: null
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($32463816393cb059$exports)))(Preview, [
        {
            key: "render",
            value: function render() {
                var emoji = this.state.emoji, _this$props = this.props, emojiProps = _this$props.emojiProps, skinsProps = _this$props.skinsProps, showSkinTones = _this$props.showSkinTones, title = _this$props.title, idleEmoji = _this$props.emoji, i18n = _this$props.i18n, showPreview = _this$props.showPreview;
                if (emoji && showPreview) {
                    var emojiData = (0, $80e1b209c9176fcd$export$7a171f172be0782e)(emoji, null, null, this.data), _emojiData$emoticons = emojiData.emoticons, emoticons = _emojiData$emoticons === void 0 ? [] : _emojiData$emoticons, knownEmoticons = [], listedEmoticons = [];
                    emoticons.forEach(function(emoticon) {
                        if (knownEmoticons.indexOf(emoticon.toLowerCase()) >= 0) return;
                        knownEmoticons.push(emoticon.toLowerCase());
                        listedEmoticons.push(emoticon);
                    });
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                        className: "emoji-mart-preview"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                        className: "emoji-mart-preview-emoji",
                        "aria-hidden": "true"
                    }, (0, $a810d847f8b45082$export$2e2bcd8739ae039)($a171fd421cd39e97$var$_objectSpread({
                        key: emoji.id,
                        emoji: emoji,
                        data: this.data
                    }, emojiProps))), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                        className: "emoji-mart-preview-data",
                        "aria-hidden": "true"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                        className: "emoji-mart-preview-name"
                    }, emoji.name), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                        className: "emoji-mart-preview-shortnames"
                    }, emojiData.short_names.map(function(short_name) {
                        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
                            key: short_name,
                            className: "emoji-mart-preview-shortname"
                        }, ":", short_name, ":");
                    })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                        className: "emoji-mart-preview-emoticons"
                    }, listedEmoticons.map(function(emoticon) {
                        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
                            key: emoticon,
                            className: "emoji-mart-preview-emoticon"
                        }, emoticon);
                    }))));
                } else return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "emoji-mart-preview"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "emoji-mart-preview-emoji",
                    "aria-hidden": "true"
                }, idleEmoji && idleEmoji.length && (0, $a810d847f8b45082$export$2e2bcd8739ae039)($a171fd421cd39e97$var$_objectSpread({
                    emoji: idleEmoji,
                    data: this.data
                }, emojiProps))), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "emoji-mart-preview-data",
                    "aria-hidden": "true"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("span", {
                    className: "emoji-mart-title-label"
                }, title)), showSkinTones && (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "emoji-mart-preview-skins".concat(skinsProps.skinEmoji ? ' custom' : '')
                }, skinsProps.skinEmoji ? (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $d4c3f0e84db5dc64$export$2e2bcd8739ae039), {
                    skin: skinsProps.skin,
                    emojiProps: emojiProps,
                    data: this.data,
                    skinEmoji: skinsProps.skinEmoji,
                    i18n: i18n,
                    onChange: skinsProps.onChange
                }) : (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $86f1a77fad080a5e$export$2e2bcd8739ae039), {
                    skin: skinsProps.skin,
                    i18n: i18n,
                    onChange: skinsProps.onChange
                })));
            }
        }
    ]);
    return Preview;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).PureComponent);
$a171fd421cd39e97$export$2e2bcd8739ae039.propTypes = {
    showSkinTones: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired,
    emoji: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string.isRequired,
    emojiProps: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired,
    skinsProps: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired
};
$a171fd421cd39e97$export$2e2bcd8739ae039.defaultProps = {
    showSkinTones: true,
    onChange: function onChange() {}
};









var $6fFrj = parcelRequire("6fFrj");

var $cgjHV = parcelRequire("cgjHV");



var $ccc79a460f8f4922$var$id = 0;
var $ccc79a460f8f4922$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($ba81ef946c36ecb1$exports)))(Search, _React$PureComponent);
    function Search(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dcaf774d05a9aa7c$exports)))(this, Search);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($91acba9e7e731445$exports)))(this, (0, (/*@__PURE__*/$parcel$interopDefault($b3bcf25de6df0a59$exports)))(Search).call(this, props));
        _this.state = {
            icon: (0, $10ec67454dcd9a10$export$d76128d007d19019).search,
            isSearching: false,
            id: ++$ccc79a460f8f4922$var$id
        };
        _this.data = props.data;
        _this.emojiIndex = new (0, $628006758d42fcd6$export$2e2bcd8739ae039)(_this.data);
        _this.setRef = _this.setRef.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.clear = _this.clear.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.handleKeyUp = _this.handleKeyUp.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this)); // throttle keyboard input so that typing isn't delayed
        _this.handleChange = (0, $80e1b209c9176fcd$export$8e45a4eca628910b)(_this.handleChange.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this)));
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($32463816393cb059$exports)))(Search, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // in some cases (e.g. preact) the input may already be pre-populated
                // this.input is undefined in Jest tests
                if (this.input && this.input.value) this.search(this.input.value);
            }
        },
        {
            key: "search",
            value: function search(value) {
                if (value == '') this.setState({
                    icon: (0, $10ec67454dcd9a10$export$d76128d007d19019).search,
                    isSearching: false
                });
                else this.setState({
                    icon: (0, $10ec67454dcd9a10$export$d76128d007d19019)["delete"],
                    isSearching: true
                });
                this.props.onSearch(this.emojiIndex.search(value, {
                    emojisToShowFilter: this.props.emojisToShowFilter,
                    maxResults: this.props.maxResults,
                    include: this.props.include,
                    exclude: this.props.exclude,
                    custom: this.props.custom
                }));
            }
        },
        {
            key: "clear",
            value: function clear() {
                if (this.input.value == '') return;
                this.input.value = '';
                this.input.focus();
                this.search('');
            }
        },
        {
            key: "handleChange",
            value: function handleChange() {
                if (this.input) this.search(this.input.value);
            }
        },
        {
            key: "handleKeyUp",
            value: function handleKeyUp(e) {
                if (e.keyCode === 13) this.clear();
            }
        },
        {
            key: "setRef",
            value: function setRef(c) {
                this.input = c;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, i18n = _this$props.i18n, autoFocus = _this$props.autoFocus;
                var _this$state = this.state, icon = _this$state.icon, isSearching = _this$state.isSearching, id = _this$state.id;
                var inputId = "emoji-mart-search-".concat(id);
                return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("section", {
                    className: "emoji-mart-search",
                    "aria-label": i18n.search
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("input", {
                    id: inputId,
                    ref: this.setRef,
                    type: "search",
                    onChange: this.handleChange,
                    placeholder: i18n.search,
                    autoFocus: autoFocus
                }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("label", {
                    className: "emoji-mart-sr-only",
                    htmlFor: inputId
                }, i18n.search), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("button", {
                    className: "emoji-mart-search-icon",
                    onClick: this.clear,
                    onKeyUp: this.handleKeyUp,
                    "aria-label": i18n.clear,
                    disabled: !isSearching
                }, icon()));
            }
        }
    ]);
    return Search;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).PureComponent);
$ccc79a460f8f4922$export$2e2bcd8739ae039.propTypes = {
    onSearch: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    maxResults: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    emojisToShowFilter: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool
};
$ccc79a460f8f4922$export$2e2bcd8739ae039.defaultProps = {
    onSearch: function onSearch() {},
    maxResults: 75,
    emojisToShowFilter: null,
    autoFocus: false
};



function $3c857cc77f0fb5e8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3c857cc77f0fb5e8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $3c857cc77f0fb5e8$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fWb4i)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $3c857cc77f0fb5e8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $3c857cc77f0fb5e8$var$I18N = {
    search: 'Search',
    clear: 'Clear',
    // Accessible label on "clear" button
    notfound: 'No Emoji Found',
    skintext: 'Choose your default skin tone',
    categories: {
        search: 'Search Results',
        recent: 'Frequently Used',
        people: 'Smileys & People',
        nature: 'Animals & Nature',
        foods: 'Food & Drink',
        activity: 'Activity',
        places: 'Travel & Places',
        objects: 'Objects',
        symbols: 'Symbols',
        flags: 'Flags',
        custom: 'Custom'
    },
    categorieslabel: 'Emoji categories',
    // Accessible title for the list of categories
    skintones: {
        1: 'Default Skin Tone',
        2: 'Light Skin Tone',
        3: 'Medium-Light Skin Tone',
        4: 'Medium Skin Tone',
        5: 'Medium-Dark Skin Tone',
        6: 'Dark Skin Tone'
    }
};
var $3c857cc77f0fb5e8$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($ba81ef946c36ecb1$exports)))(NimblePicker, _React$PureComponent);
    function NimblePicker(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($dcaf774d05a9aa7c$exports)))(this, NimblePicker);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($91acba9e7e731445$exports)))(this, (0, (/*@__PURE__*/$parcel$interopDefault($b3bcf25de6df0a59$exports)))(NimblePicker).call(this, props));
        _this.CUSTOM = [];
        _this.RECENT_CATEGORY = {
            id: 'recent',
            name: 'Recent',
            emojis: null
        };
        _this.SEARCH_CATEGORY = {
            id: 'search',
            name: 'Search',
            emojis: null,
            anchor: false
        };
        if (props.data.compressed) (0, $830cae75b13dfa31$export$4766cff981d64eb2)(props.data);
        _this.data = props.data;
        _this.i18n = (0, $80e1b209c9176fcd$export$6969335ea1e4e77c)($3c857cc77f0fb5e8$var$I18N, props.i18n);
        _this.icons = (0, $80e1b209c9176fcd$export$6969335ea1e4e77c)($10ec67454dcd9a10$exports, props.icons);
        _this.state = {
            firstRender: true
        };
        _this.categories = [];
        var allCategories = [].concat(_this.data.categories);
        if (props.custom.length > 0) {
            var customCategories = {};
            var customCategoriesCreated = 0;
            props.custom.forEach(function(emoji) {
                if (!customCategories[emoji.customCategory]) {
                    customCategories[emoji.customCategory] = {
                        id: emoji.customCategory ? "custom-".concat(emoji.customCategory) : 'custom',
                        name: emoji.customCategory || 'Custom',
                        emojis: [],
                        anchor: customCategoriesCreated === 0
                    };
                    customCategoriesCreated++;
                }
                var category = customCategories[emoji.customCategory];
                var customEmoji = $3c857cc77f0fb5e8$var$_objectSpread({}, emoji, {
                    // `<Category />` expects emoji to have an `id`.
                    id: emoji.short_names[0],
                    custom: true
                });
                category.emojis.push(customEmoji);
                _this.CUSTOM.push(customEmoji);
            });
            allCategories = allCategories.concat(Object.keys(customCategories).map(function(key) {
                return customCategories[key];
            }));
        }
        _this.hideRecent = true;
        if (props.include != undefined) allCategories.sort(function(a, b) {
            if (props.include.indexOf(a.id) > props.include.indexOf(b.id)) return 1;
            return -1;
        });
        for(var categoryIndex = 0; categoryIndex < allCategories.length; categoryIndex++){
            var category = allCategories[categoryIndex];
            var isIncluded = props.include && props.include.length ? props.include.indexOf(category.id) > -1 : true;
            var isExcluded = props.exclude && props.exclude.length ? props.exclude.indexOf(category.id) > -1 : false;
            if (!isIncluded || isExcluded) continue;
            if (props.emojisToShowFilter) {
                var newEmojis = [];
                var emojis = category.emojis;
                for(var emojiIndex = 0; emojiIndex < emojis.length; emojiIndex++){
                    var emoji = emojis[emojiIndex];
                    if (props.emojisToShowFilter(_this.data.emojis[emoji] || emoji)) newEmojis.push(emoji);
                }
                if (newEmojis.length) {
                    var newCategory = {
                        emojis: newEmojis,
                        name: category.name,
                        id: category.id
                    };
                    _this.categories.push(newCategory);
                }
            } else _this.categories.push(category);
        }
        var includeRecent = props.include && props.include.length ? props.include.indexOf(_this.RECENT_CATEGORY.id) > -1 : true;
        var excludeRecent = props.exclude && props.exclude.length ? props.exclude.indexOf(_this.RECENT_CATEGORY.id) > -1 : false;
        if (includeRecent && !excludeRecent) {
            _this.hideRecent = false;
            _this.categories.unshift(_this.RECENT_CATEGORY);
        }
        if (_this.categories[0]) _this.categories[0].first = true;
        _this.categories.unshift(_this.SEARCH_CATEGORY);
        _this.setAnchorsRef = _this.setAnchorsRef.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.handleAnchorClick = _this.handleAnchorClick.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.setSearchRef = _this.setSearchRef.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.handleSearch = _this.handleSearch.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.setScrollRef = _this.setScrollRef.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.handleScroll = _this.handleScroll.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.handleScrollPaint = _this.handleScrollPaint.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.handleEmojiOver = _this.handleEmojiOver.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.handleEmojiLeave = _this.handleEmojiLeave.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.handleEmojiClick = _this.handleEmojiClick.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.handleEmojiSelect = _this.handleEmojiSelect.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.setPreviewRef = _this.setPreviewRef.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.handleSkinChange = _this.handleSkinChange.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.handleKeyDown = _this.handleKeyDown.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        _this.handleDarkMatchMediaChange = _this.handleDarkMatchMediaChange.bind((0, (/*@__PURE__*/$parcel$interopDefault($fb31538619d00be8$exports)))(_this));
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($32463816393cb059$exports)))(NimblePicker, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                if (this.state.firstRender) {
                    this.testStickyPosition();
                    this.firstRenderTimeout = setTimeout(function() {
                        _this2.setState({
                            firstRender: false
                        });
                    }, 60);
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateCategoriesSize();
                this.handleScroll();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.SEARCH_CATEGORY.emojis = null;
                clearTimeout(this.leaveTimeout);
                clearTimeout(this.firstRenderTimeout);
                if (this.darkMatchMedia) this.darkMatchMedia.removeListener(this.handleDarkMatchMediaChange);
            }
        },
        {
            key: "testStickyPosition",
            value: function testStickyPosition() {
                var stickyTestElement = document.createElement('div');
                var prefixes = [
                    '',
                    '-webkit-',
                    '-ms-',
                    '-moz-',
                    '-o-'
                ];
                prefixes.forEach(function(prefix) {
                    return stickyTestElement.style.position = "".concat(prefix, "sticky");
                });
                this.hasStickyPosition = !!stickyTestElement.style.position.length;
            }
        },
        {
            key: "getPreferredTheme",
            value: function getPreferredTheme() {
                if (this.props.theme != 'auto') return this.props.theme;
                if (this.state.theme) return this.state.theme;
                if (typeof matchMedia !== 'function') return (0, $76e1ebbd65e6a9d9$export$f719a773a9b3cddd).theme;
                if (!this.darkMatchMedia) {
                    this.darkMatchMedia = matchMedia('(prefers-color-scheme: dark)');
                    this.darkMatchMedia.addListener(this.handleDarkMatchMediaChange);
                }
                if (this.darkMatchMedia.media.match(/^not/)) return (0, $76e1ebbd65e6a9d9$export$f719a773a9b3cddd).theme;
                return this.darkMatchMedia.matches ? 'dark' : 'light';
            }
        },
        {
            key: "handleDarkMatchMediaChange",
            value: function handleDarkMatchMediaChange() {
                this.setState({
                    theme: this.darkMatchMedia.matches ? 'dark' : 'light'
                });
            }
        },
        {
            key: "handleEmojiOver",
            value: function handleEmojiOver(emoji) {
                var preview = this.preview;
                if (!preview) return;
                 // Use Array.prototype.find() when it is more widely supported.
                var emojiData = this.CUSTOM.filter(function(customEmoji) {
                    return customEmoji.id === emoji.id;
                })[0];
                for(var key in emojiData)if (emojiData.hasOwnProperty(key)) emoji[key] = emojiData[key];
                preview.setState({
                    emoji: emoji
                });
                clearTimeout(this.leaveTimeout);
            }
        },
        {
            key: "handleEmojiLeave",
            value: function handleEmojiLeave(emoji) {
                var preview = this.preview;
                if (!preview) return;
                this.leaveTimeout = setTimeout(function() {
                    preview.setState({
                        emoji: null
                    });
                }, 16);
            }
        },
        {
            key: "handleEmojiClick",
            value: function handleEmojiClick(emoji, e) {
                this.props.onClick(emoji, e);
                this.handleEmojiSelect(emoji);
            }
        },
        {
            key: "handleEmojiSelect",
            value: function handleEmojiSelect(emoji) {
                var _this3 = this;
                this.props.onSelect(emoji);
                if (!this.hideRecent && !this.props.recent) (0, $a3916ab1464f03aa$export$2e2bcd8739ae039).add(emoji);
                var component = this.categoryRefs['category-1'];
                if (component) {
                    var maxMargin = component.maxMargin;
                    if (this.props.enableFrequentEmojiSort) component.forceUpdate();
                    requestAnimationFrame(function() {
                        if (!_this3.scroll) return;
                        component.memoizeSize();
                        if (maxMargin == component.maxMargin) return;
                        _this3.updateCategoriesSize();
                        _this3.handleScrollPaint();
                        if (_this3.SEARCH_CATEGORY.emojis) component.updateDisplay('none');
                    });
                }
            }
        },
        {
            key: "handleScroll",
            value: function handleScroll() {
                if (!this.waitingForPaint) {
                    this.waitingForPaint = true;
                    requestAnimationFrame(this.handleScrollPaint);
                }
            }
        },
        {
            key: "handleScrollPaint",
            value: function handleScrollPaint() {
                this.waitingForPaint = false;
                if (!this.scroll) return;
                var activeCategory = null;
                if (this.SEARCH_CATEGORY.emojis) activeCategory = this.SEARCH_CATEGORY;
                else {
                    var target = this.scroll, scrollTop = target.scrollTop, scrollingDown = scrollTop > (this.scrollTop || 0), minTop = 0;
                    for(var i = 0, l = this.categories.length; i < l; i++){
                        var ii = scrollingDown ? this.categories.length - 1 - i : i, category = this.categories[ii], component = this.categoryRefs["category-".concat(ii)];
                        if (component) {
                            var active = component.handleScroll(scrollTop);
                            if (!minTop || component.top < minTop) {
                                if (component.top > 0) minTop = component.top;
                            }
                            if (active && !activeCategory) activeCategory = category;
                        }
                    }
                    if (scrollTop < minTop) activeCategory = this.categories.filter(function(category) {
                        return !(category.anchor === false);
                    })[0];
                    else if (scrollTop + this.clientHeight >= this.scrollHeight) activeCategory = this.categories[this.categories.length - 1];
                }
                if (activeCategory) {
                    var anchors = this.anchors, _activeCategory = activeCategory, categoryName = _activeCategory.name;
                    if (anchors.state.selected != categoryName) anchors.setState({
                        selected: categoryName
                    });
                }
                this.scrollTop = scrollTop;
            }
        },
        {
            key: "handleSearch",
            value: function handleSearch(emojis) {
                this.SEARCH_CATEGORY.emojis = emojis;
                for(var i = 0, l = this.categories.length; i < l; i++){
                    var component = this.categoryRefs["category-".concat(i)];
                    if (component && component.props.name != 'Search') {
                        var display = emojis ? 'none' : 'inherit';
                        component.updateDisplay(display);
                    }
                }
                this.forceUpdate();
                if (this.scroll) this.scroll.scrollTop = 0;
                this.handleScroll();
            }
        },
        {
            key: "handleAnchorClick",
            value: function handleAnchorClick(category, i) {
                var component = this.categoryRefs["category-".concat(i)], scroll = this.scroll, anchors = this.anchors, scrollToComponent = null;
                scrollToComponent = function scrollToComponent() {
                    if (component) {
                        var top = component.top;
                        if (category.first) top = 0;
                        else top += 1;
                        scroll.scrollTop = top;
                    }
                };
                if (this.SEARCH_CATEGORY.emojis) {
                    this.handleSearch(null);
                    this.search.clear();
                    requestAnimationFrame(scrollToComponent);
                } else scrollToComponent();
            }
        },
        {
            key: "handleSkinChange",
            value: function handleSkinChange(skin) {
                var newState = {
                    skin: skin
                }, onSkinChange = this.props.onSkinChange;
                this.setState(newState);
                (0, $2ad6c8ff1724a4ba$export$2e2bcd8739ae039).update(newState);
                onSkinChange(skin);
            }
        },
        {
            key: "handleKeyDown",
            value: function handleKeyDown(e) {
                var handled = false;
                switch(e.keyCode){
                    case 13:
                        var emoji;
                        if (this.SEARCH_CATEGORY.emojis && this.SEARCH_CATEGORY.emojis.length && (emoji = (0, $80e1b209c9176fcd$export$b57a2d1f0ad365d6)(this.SEARCH_CATEGORY.emojis[0], this.state.skin, this.props.set, this.props.data))) {
                            this.handleEmojiSelect(emoji);
                            handled = true;
                        }
                        break;
                }
                if (handled) e.preventDefault();
            }
        },
        {
            key: "updateCategoriesSize",
            value: function updateCategoriesSize() {
                for(var i = 0, l = this.categories.length; i < l; i++){
                    var component = this.categoryRefs["category-".concat(i)];
                    if (component) component.memoizeSize();
                }
                if (this.scroll) {
                    var target = this.scroll;
                    this.scrollHeight = target.scrollHeight;
                    this.clientHeight = target.clientHeight;
                }
            }
        },
        {
            key: "getCategories",
            value: function getCategories() {
                return this.state.firstRender ? this.categories.slice(0, 3) : this.categories;
            }
        },
        {
            key: "setAnchorsRef",
            value: function setAnchorsRef(c) {
                this.anchors = c;
            }
        },
        {
            key: "setSearchRef",
            value: function setSearchRef(c) {
                this.search = c;
            }
        },
        {
            key: "setPreviewRef",
            value: function setPreviewRef(c) {
                this.preview = c;
            }
        },
        {
            key: "setScrollRef",
            value: function setScrollRef(c) {
                this.scroll = c;
            }
        },
        {
            key: "setCategoryRef",
            value: function setCategoryRef(name, c) {
                if (!this.categoryRefs) this.categoryRefs = {};
                this.categoryRefs[name] = c;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var _this$props = this.props, perLine = _this$props.perLine, emojiSize = _this$props.emojiSize, set = _this$props.set, sheetSize = _this$props.sheetSize, sheetColumns = _this$props.sheetColumns, sheetRows = _this$props.sheetRows, style = _this$props.style, title = _this$props.title, emoji = _this$props.emoji, color = _this$props.color, _native = _this$props["native"], backgroundImageFn = _this$props.backgroundImageFn, emojisToShowFilter = _this$props.emojisToShowFilter, showPreview = _this$props.showPreview, showSkinTones = _this$props.showSkinTones, emojiTooltip = _this$props.emojiTooltip, useButton = _this$props.useButton, include = _this$props.include, exclude = _this$props.exclude, recent = _this$props.recent, autoFocus = _this$props.autoFocus, skinEmoji = _this$props.skinEmoji, notFound = _this$props.notFound, notFoundEmoji = _this$props.notFoundEmoji;
                var width = perLine * (emojiSize + 12) + 12 + 2 + (0, $80e1b209c9176fcd$export$f5ad9ce4fa1f02f)();
                var theme = this.getPreferredTheme();
                var skin = this.props.skin || this.state.skin || (0, $2ad6c8ff1724a4ba$export$2e2bcd8739ae039).get('skin') || this.props.defaultSkin;
                return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("section", {
                    style: $3c857cc77f0fb5e8$var$_objectSpread({
                        width: width
                    }, style),
                    className: "emoji-mart emoji-mart-".concat(theme),
                    "aria-label": title,
                    onKeyDown: this.handleKeyDown
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "emoji-mart-bar"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $7c32239f0bbde921$export$2e2bcd8739ae039), {
                    ref: this.setAnchorsRef,
                    data: this.data,
                    i18n: this.i18n,
                    color: color,
                    categories: this.categories,
                    onAnchorClick: this.handleAnchorClick,
                    icons: this.icons
                })), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $ccc79a460f8f4922$export$2e2bcd8739ae039), {
                    ref: this.setSearchRef,
                    onSearch: this.handleSearch,
                    data: this.data,
                    i18n: this.i18n,
                    emojisToShowFilter: emojisToShowFilter,
                    include: include,
                    exclude: exclude,
                    custom: this.CUSTOM,
                    autoFocus: autoFocus
                }), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    ref: this.setScrollRef,
                    className: "emoji-mart-scroll",
                    onScroll: this.handleScroll
                }, this.getCategories().map(function(category, i) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $6306c91159367f6a$export$2e2bcd8739ae039), {
                        ref: _this4.setCategoryRef.bind(_this4, "category-".concat(i)),
                        key: category.name,
                        id: category.id,
                        name: category.name,
                        emojis: category.emojis,
                        perLine: perLine,
                        "native": _native,
                        hasStickyPosition: _this4.hasStickyPosition,
                        data: _this4.data,
                        i18n: _this4.i18n,
                        recent: category.id == _this4.RECENT_CATEGORY.id ? recent : undefined,
                        custom: category.id == _this4.RECENT_CATEGORY.id ? _this4.CUSTOM : undefined,
                        emojiProps: {
                            "native": _native,
                            skin: skin,
                            size: emojiSize,
                            set: set,
                            sheetSize: sheetSize,
                            sheetColumns: sheetColumns,
                            sheetRows: sheetRows,
                            forceSize: _native,
                            tooltip: emojiTooltip,
                            backgroundImageFn: backgroundImageFn,
                            useButton: useButton,
                            onOver: _this4.handleEmojiOver,
                            onLeave: _this4.handleEmojiLeave,
                            onClick: _this4.handleEmojiClick
                        },
                        notFound: notFound,
                        notFoundEmoji: notFoundEmoji
                    });
                })), (showPreview || showSkinTones) && (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("div", {
                    className: "emoji-mart-bar"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $a171fd421cd39e97$export$2e2bcd8739ae039), {
                    ref: this.setPreviewRef,
                    data: this.data,
                    title: title,
                    emoji: emoji,
                    showSkinTones: showSkinTones,
                    showPreview: showPreview,
                    emojiProps: {
                        "native": _native,
                        size: 38,
                        skin: skin,
                        set: set,
                        sheetSize: sheetSize,
                        sheetColumns: sheetColumns,
                        sheetRows: sheetRows,
                        backgroundImageFn: backgroundImageFn
                    },
                    skinsProps: {
                        skin: skin,
                        onChange: this.handleSkinChange,
                        skinEmoji: skinEmoji
                    },
                    i18n: this.i18n
                })));
            }
        }
    ]);
    return NimblePicker;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).PureComponent);
$3c857cc77f0fb5e8$export$2e2bcd8739ae039.propTypes = $3c857cc77f0fb5e8$var$_objectSpread({}, (0, $9c0a9e8920452cae$export$8673a3795efdab32), {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).object.isRequired
});
$3c857cc77f0fb5e8$export$2e2bcd8739ae039.defaultProps = $3c857cc77f0fb5e8$var$_objectSpread({}, (0, $76e1ebbd65e6a9d9$export$f719a773a9b3cddd));




function $cc096be5655404ec$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cc096be5655404ec$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $cc096be5655404ec$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fWb4i)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $cc096be5655404ec$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $cc096be5655404ec$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($ba81ef946c36ecb1$exports)))(Picker, _React$PureComponent);
    function Picker() {
        (0, (/*@__PURE__*/$parcel$interopDefault($dcaf774d05a9aa7c$exports)))(this, Picker);
        return (0, (/*@__PURE__*/$parcel$interopDefault($91acba9e7e731445$exports)))(this, (0, (/*@__PURE__*/$parcel$interopDefault($b3bcf25de6df0a59$exports)))(Picker).apply(this, arguments));
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($32463816393cb059$exports)))(Picker, [
        {
            key: "render",
            value: function render() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement((0, $3c857cc77f0fb5e8$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($3d838c0241a6eaae$exports)))({}, this.props, this.state));
            }
        }
    ]);
    return Picker;
}((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).PureComponent);
$cc096be5655404ec$export$2e2bcd8739ae039.propTypes = (0, $9c0a9e8920452cae$export$8673a3795efdab32);
$cc096be5655404ec$export$2e2bcd8739ae039.defaultProps = $cc096be5655404ec$var$_objectSpread({}, (0, $76e1ebbd65e6a9d9$export$f719a773a9b3cddd), {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($f38df6b76ce15393$exports)))
});




var $fWb4i = parcelRequire("fWb4i");
parcelRequire("6fFrj");




function $ece8c3d956f0f5fc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ece8c3d956f0f5fc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ece8c3d956f0f5fc$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fWb4i)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ece8c3d956f0f5fc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $ece8c3d956f0f5fc$var$Emoji = function Emoji(props) {
    for(var k in Emoji.defaultProps)if (props[k] == undefined && Emoji.defaultProps[k] != undefined) props[k] = Emoji.defaultProps[k];
    return (0, $a810d847f8b45082$export$2e2bcd8739ae039)($ece8c3d956f0f5fc$var$_objectSpread({}, props));
};
$ece8c3d956f0f5fc$var$Emoji.propTypes = (0, $9c0a9e8920452cae$export$1fcb9d5d71ab22f7);
$ece8c3d956f0f5fc$var$Emoji.defaultProps = $ece8c3d956f0f5fc$var$_objectSpread({}, (0, $76e1ebbd65e6a9d9$export$a2cd0decb2235f50), {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($f38df6b76ce15393$exports)))
});
var $ece8c3d956f0f5fc$export$2e2bcd8739ae039 = $ece8c3d956f0f5fc$var$Emoji;












const $2d09ce9c73e1e422$var$defaultOptions = {};
const $2d09ce9c73e1e422$export$ade180e399224fc8 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetTaxYearInterviewForChannel($channelUserId: String!) {
  GetTaxYearInterviewForChannel(channelUserId: $channelUserId) {
    id
    taxYearId
    interviewId
    TaxYear {
      id
      year
    }
    Interviews {
      id
      name
    }
  }
}
    `;
function $2d09ce9c73e1e422$export$953735348d2a4933(baseOptions) {
    const options = {
        ...$2d09ce9c73e1e422$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($2d09ce9c73e1e422$export$ade180e399224fc8, options);
}
function $2d09ce9c73e1e422$export$4b7999ea1bdfd682(baseOptions) {
    const options = {
        ...$2d09ce9c73e1e422$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($2d09ce9c73e1e422$export$ade180e399224fc8, options);
}
const $2d09ce9c73e1e422$export$d2e4c87ef62d9c65 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetTaxYearInterviewIncludeInterviews($id: String!) {
  GetTaxYearInterviewIncludeInterviews(id: $id) {
    id
    Answers {
      id
      updateAt
      createAt
      requestAt
      questionId
      description
      completedAt
      taxYearInterviewId
      isPrePopulated
    }
    Interviews {
      id
      firmAccountId
      name
      isTemplate
      isLive
      drakePackage
      createAt
      updateAt
      Sections {
        ...Sections
      }
    }
    LegacyTaxYearInterviewAnswers {
      id
      taxYearInterviewId
      interviewForm
      createAt
      updateAt
    }
  }
}
    ${(0, $774cc9a1c383b6aa$export$833749530f15953b)}`;
function $2d09ce9c73e1e422$export$b5e05cf0bcf238e6(baseOptions) {
    const options = {
        ...$2d09ce9c73e1e422$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($2d09ce9c73e1e422$export$d2e4c87ef62d9c65, options);
}
function $2d09ce9c73e1e422$export$714b336e4bb764ad(baseOptions) {
    const options = {
        ...$2d09ce9c73e1e422$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($2d09ce9c73e1e422$export$d2e4c87ef62d9c65, options);
}
const $2d09ce9c73e1e422$export$63eedda6f3ca0b7c = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetTaxYearInterviewDrakeFile($taxYearInterviewId: String!) {
  taxYearInterviewDrakeFile(taxYearInterviewId: $taxYearInterviewId) {
    fileName
    fileContent
  }
}
    `;
function $2d09ce9c73e1e422$export$6a46fad1160dd99e(baseOptions) {
    const options = {
        ...$2d09ce9c73e1e422$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($2d09ce9c73e1e422$export$63eedda6f3ca0b7c, options);
}
function $2d09ce9c73e1e422$export$79feeea77603ece9(baseOptions) {
    const options = {
        ...$2d09ce9c73e1e422$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($2d09ce9c73e1e422$export$63eedda6f3ca0b7c, options);
}
const $2d09ce9c73e1e422$export$39ac829ab91f0716 = {
    Query: {
        GetTaxYearInterviewForChannel: 'GetTaxYearInterviewForChannel',
        GetTaxYearInterviewIncludeInterviews: 'GetTaxYearInterviewIncludeInterviews',
        GetTaxYearInterviewDrakeFile: 'GetTaxYearInterviewDrakeFile'
    }
};





var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");
function $b1100874f2245c31$var$useOutsideAlerter(ref, onOutside) {
    (0, $6fFrj.useEffect)(()=>{
        /**
             * Alert if clicked on outside of element
             */ function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) onOutside();
        }
        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref
    ]);
}
/**
 * Component that alerts if you click outside of it
 */ const $b1100874f2245c31$var$OutsideAlerter = ({ onOutside: onOutside, children: children })=>{
    const wrapperRef = (0, $6fFrj.useRef)(null);
    $b1100874f2245c31$var$useOutsideAlerter(wrapperRef, onOutside);
    return (0, $bb3TF.jsx)("div", {
        ref: wrapperRef,
        children: children
    });
};
var $b1100874f2245c31$export$2e2bcd8739ae039 = $b1100874f2245c31$var$OutsideAlerter;


var $c5be3ecb7f10b7f5$export$343c388294a7ac9a;
var $c5be3ecb7f10b7f5$export$e0b576e7a74416cd;
var $c5be3ecb7f10b7f5$export$e4d5a197ae42dad2;
var $c5be3ecb7f10b7f5$export$7f5ec31544baddfa;
var $c5be3ecb7f10b7f5$export$9296115df4c2ec24;
var $c5be3ecb7f10b7f5$export$89dd0878f80bbda7;
var $c5be3ecb7f10b7f5$export$632402c9bbba22b4;
var $c5be3ecb7f10b7f5$export$b7e3ae3d7c15e42e;
var $c5be3ecb7f10b7f5$export$89db4734f6c919c4;
var $c5be3ecb7f10b7f5$export$7472b0d4ff79ef04;
$c5be3ecb7f10b7f5$export$343c388294a7ac9a = `_5A38Ra_chatInputContainer`;
$c5be3ecb7f10b7f5$export$e0b576e7a74416cd = `_5A38Ra_clip`;
$c5be3ecb7f10b7f5$export$e4d5a197ae42dad2 = `_5A38Ra_clipsms`;
$c5be3ecb7f10b7f5$export$7f5ec31544baddfa = `_5A38Ra_containerInput`;
$c5be3ecb7f10b7f5$export$9296115df4c2ec24 = `_5A38Ra_dropbtn`;
$c5be3ecb7f10b7f5$export$89dd0878f80bbda7 = `_5A38Ra_dropup`;
$c5be3ecb7f10b7f5$export$632402c9bbba22b4 = `_5A38Ra_dropupcontent`;
$c5be3ecb7f10b7f5$export$b7e3ae3d7c15e42e = `_5A38Ra_input`;
$c5be3ecb7f10b7f5$export$89db4734f6c919c4 = `_5A38Ra_send`;
$c5be3ecb7f10b7f5$export$7472b0d4ff79ef04 = `_5A38Ra_uploader`;



var $2489f4ddccd93bd7$require$Buffer = $c62b475e31b1e858$export$a143d493d941bafc;
const { PaperClipOutlined: $2489f4ddccd93bd7$var$PaperClipOutlined, SendOutlined: $2489f4ddccd93bd7$var$SendOutlined, SmileOutlined: $2489f4ddccd93bd7$var$SmileOutlined, WechatOutlined: $2489f4ddccd93bd7$var$WechatOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $2489f4ddccd93bd7$var$MAX_ATTACHMENT_SIZE_MB = 5;
const $2489f4ddccd93bd7$var$MAX_ATTACHMENT_SIZE_B = $2489f4ddccd93bd7$var$MAX_ATTACHMENT_SIZE_MB * 1048576;
const $2489f4ddccd93bd7$var$ChatInputAdmin = ({ onSendMessage: onSendMessage, clientData: clientData, loadingSendMessage: loadingSendMessage })=>{
    const [val, setValue] = (0, $6fFrj.useState)('');
    const [uploadingStatus, setUploadingStatus] = (0, $6fFrj.useState)(false);
    const [emojiVisible, setEmojiVisible] = (0, $6fFrj.useState)(false);
    const [message, setMessage] = (0, $6fFrj.useState)('');
    const [phone, setPhone] = (0, $6fFrj.useState)('');
    const [openchat, setOpenchat] = (0, $6fFrj.useState)(true);
    const [projects, setProjects] = (0, $6fFrj.useState)([]);
    const { userId: userId } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$ca779d385d6ad982));
    const { ChannelMembers: ChannelMembers, id: channelId } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $66a7cecdd31d321f$export$64113a45e478f19d));
    const channelUser = ChannelMembers.find((channel)=>channel.userId !== userId);
    const [getTaxYearInterview, { loading: loadingTaxYearInterview }] = (0, $2d09ce9c73e1e422$export$4b7999ea1bdfd682)({
        variables: {
            channelUserId: channelUser.userId
        }
    });
    const [uploadPercent, setUploadPercent] = (0, $6fFrj.useState)(0);
    const { t: translation, i18n: i18n } = (0, $e3ea6dd032e45947$export$9fc83ad70ead8663)();
    const [getPresignedUrl] = (0, $edf372aa0dea9531$export$ea7e982b7f736995)({
        onError: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Error getting presigned URL');
        }
    });
    const callProjects = async ()=>{
        const data = await getTaxYearInterview();
        setProjects(data.data.GetTaxYearInterviewForChannel);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (clientData) {
            callProjects();
            setPhone(clientData.Phones[0]?.value || null);
        }
    }, [
        clientData
    ]);
    // const uploadPros = {
    //   name: 'file',
    //   onChange(data: any) {
    //     const info = data;
    //     if (info.file.status === 'uploading') {
    //       if (!uploadingStatus) {
    //         setUploadingStatus(true);
    //       }
    //       if (info.event) {
    //         setUploadPercent(info.event.percent);
    //       }
    //     }
    //     if (info.file.status === 'done') {
    //       setUploadingStatus(false);
    //       setUploadPercent(0);
    //       info.file.s3key = info.file.originFileObj.s3key;
    //       onSendMessage({ text: undefined, phone: undefined, attachment: JSON.stringify(info.file) });
    //       antdMessage.success({
    //         content: `${info.file.name} ${translation('chat.chatInput.fileUploaded')}`,
    //         duration: 3,
    //         className: 'custom-alert-message-success',
    //         style: {
    //           marginTop: '38px',
    //           textAlign: 'center',
    //           left: '50%',
    //           position: 'absolute',
    //           transform: 'translateX(-35%)',
    //         },
    //       });
    //     } else if (info.file.status === 'error') {
    //       antdMessage.error(`${info.file.name} ${translation('chat.chatInput.fileNotUploaded')}`);
    //     }
    //   },
    // };
    const sendMessage = async ()=>{
        if (openchat) {
            onSendMessage({
                text: val,
                phone: undefined,
                attachment: undefined
            });
            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
                Title: 'Send chat message (text)',
                Source: 'Button click',
                url: window.location.href
            });
        } else {
            onSendMessage({
                text: message,
                phone: phone,
                attachment: undefined
            });
            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
                Title: 'Send chat message (SMS)',
                Source: 'Button click',
                url: window.location.href
            });
        }
        setValue('');
    };
    const uploadFile = async (options, projectId)=>{
        if (options.file.size > $2489f4ddccd93bd7$var$MAX_ATTACHMENT_SIZE_B) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`
        The size of the uploaded file exceeds the maximum size of ${$2489f4ddccd93bd7$var$MAX_ATTACHMENT_SIZE_MB}MB.
        Please try uploading a different file.
      `);
            setUploadingStatus(false);
            return;
        }
        setUploadingStatus(true);
        const presignedUrlResult = await getPresignedUrl({
            variables: {
                fileName: `${channelUser.Users.Entity.id}/${projectId}/clientfiles/${options.file.name}`,
                fileType: options.file.type
            }
        });
        if (!presignedUrlResult) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Error getting presigned URL');
            setUploadingStatus(false);
            return;
        }
        const { data: { generatePreSignedPutUrl: { signedUrl: signedUrl, url: url } } } = presignedUrlResult;
        const buffer = $2489f4ddccd93bd7$require$Buffer.from(await options.file.arrayBuffer());
        const fileUrl = new URL(signedUrl);
        await (0, (/*@__PURE__*/$parcel$interopDefault($18ae57eea10fd4c8$exports))).put(fileUrl.toString(), buffer, {
            headers: {
                'Content-Type': 'application/pdf'
            }
        });
        const attachment = {
            size: options.file.size,
            lastModified: options.file.lastModifiedDate,
            name: options.file.name,
            type: options.file.type,
            s3key: `${url.split('.com/')[1]}`
        };
        onSendMessage({
            text: undefined,
            phone: undefined,
            attachment: JSON.stringify(attachment)
        });
        setUploadingStatus(false);
    };
    const sendMessageSms = async ()=>{
        setValue(message);
        sendMessage();
        setMessage('');
    };
    // const { name, onChange } = uploadPros;
    const beforeUpload = (file)=>{
        const { size: size } = file;
        const maxSize = 26214400; // 25MB
        if (size > maxSize) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('File size exceeds 25MB');
            return false;
        }
        return true;
    };
    const projectsMenu = ()=>(0, $bb3TF.jsxs)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
            children: [
                (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
                    style: {
                        fontWeight: 'bolder'
                    },
                    disabled: true,
                    children: translation('chat.chatInput.selectProject')
                }, 0),
                projects.map((p)=>(0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
                        children: (0, $bb3TF.jsx)((0, $09e7a312b8c0b52f$export$2e2bcd8739ae039), {
                            // name={name}
                            // onChange={onChange}
                            showUploadList: false,
                            disabled: uploadingStatus,
                            multiple: false,
                            beforeUpload: beforeUpload,
                            customRequest: (options)=>uploadFile(options, p.id),
                            children: `${p.TaxYear.year} ${p.Interviews.name}`
                        })
                    }, p.id))
            ]
        });
    return (0, $bb3TF.jsxs)("div", {
        className: $c5be3ecb7f10b7f5$export$343c388294a7ac9a,
        children: [
            emojiVisible && (0, $bb3TF.jsx)((0, $b1100874f2245c31$export$2e2bcd8739ae039), {
                onOutside: ()=>setEmojiVisible(false),
                children: (0, $bb3TF.jsx)((0, $cc096be5655404ec$export$2e2bcd8739ae039), {
                    set: "apple",
                    showPreview: false,
                    showSkinTones: false,
                    style: {
                        width: '100%',
                        maxHeight: '288px',
                        overflowY: 'auto',
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none'
                    },
                    sheetSize: 32,
                    onSelect: (emoji)=>{
                        if (openchat) {
                            setValue(`${val} ${emoji.native} `);
                            setMessage(`${message} `);
                        } else {
                            setValue(`${val} `);
                            setMessage(`${message} ${emoji.native} `);
                        }
                    },
                    i18n: i18n.getDataByLanguage(i18n.language).emojiMart
                })
            }),
            (0, $bb3TF.jsxs)("div", {
                className: $c5be3ecb7f10b7f5$export$7f5ec31544baddfa,
                children: [
                    openchat ? (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
                        overlay: projectsMenu(),
                        trigger: [
                            'click'
                        ],
                        placement: "topLeft",
                        children: (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                            className: `${$c5be3ecb7f10b7f5$export$e0b576e7a74416cd} ant-dropdown-link`,
                            type: "default",
                            shape: "circle",
                            size: "middle",
                            onClick: (e)=>e.preventDefault(),
                            children: !uploadingStatus && !loadingTaxYearInterview ? (0, $bb3TF.jsx)($2489f4ddccd93bd7$var$PaperClipOutlined, {}) : (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                                size: "small",
                                style: {
                                    marginRight: 8
                                }
                            })
                        })
                    }) : (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
                        overlay: projectsMenu(),
                        trigger: [],
                        placement: "topLeft",
                        children: (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                            className: `${$c5be3ecb7f10b7f5$export$e4d5a197ae42dad2} ant-dropdown-link`,
                            type: "default",
                            shape: "circle",
                            size: "middle",
                            onClick: (e)=>e.preventDefault(),
                            children: !uploadingStatus && !loadingTaxYearInterview ? (0, $bb3TF.jsx)($2489f4ddccd93bd7$var$PaperClipOutlined, {}) : (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                                size: "small",
                                style: {
                                    marginRight: 8
                                }
                            })
                        })
                    }),
                    Boolean(phone) && (0, $bb3TF.jsxs)("div", {
                        className: $c5be3ecb7f10b7f5$export$89dd0878f80bbda7,
                        children: [
                            (0, $bb3TF.jsx)($2489f4ddccd93bd7$var$WechatOutlined, {
                                className: $c5be3ecb7f10b7f5$export$9296115df4c2ec24
                            }),
                            (0, $bb3TF.jsxs)("div", {
                                className: $c5be3ecb7f10b7f5$export$632402c9bbba22b4,
                                children: [
                                    (0, $bb3TF.jsx)("p", {
                                        onClick: ()=>{
                                            setOpenchat(false);
                                        },
                                        children: "SMS"
                                    }),
                                    (0, $bb3TF.jsx)("p", {
                                        onClick: ()=>{
                                            setOpenchat(true);
                                        },
                                        children: "Email"
                                    })
                                ]
                            })
                        ]
                    }),
                    openchat ? (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039).TextArea, {
                        className: $c5be3ecb7f10b7f5$export$b7e3ae3d7c15e42e,
                        placeholder: "Send Message via Email / Chat",
                        value: val,
                        // onPressEnter={sendMessage}
                        onChange: (e)=>setValue(e.target.value),
                        autoComplete: "off",
                        autoSize: {
                            minRows: 1,
                            maxRows: 6
                        }
                    }) : (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039).TextArea, {
                        className: $c5be3ecb7f10b7f5$export$b7e3ae3d7c15e42e,
                        placeholder: "Send Message via SMS",
                        value: message,
                        // onPressEnter={sendMessageSms}
                        onChange: (e)=>setMessage(e.target.value),
                        autoComplete: "off",
                        autoSize: {
                            minRows: 1,
                            maxRows: 6
                        }
                    }),
                    (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                        className: $c5be3ecb7f10b7f5$export$e0b576e7a74416cd,
                        type: "default",
                        shape: "circle",
                        icon: (0, $bb3TF.jsx)($2489f4ddccd93bd7$var$SmileOutlined, {}),
                        size: "middle",
                        onClick: ()=>setEmojiVisible(!emojiVisible)
                    }),
                    openchat ? (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                        className: $c5be3ecb7f10b7f5$export$89db4734f6c919c4,
                        type: "default",
                        shape: "circle",
                        icon: (0, $bb3TF.jsx)($2489f4ddccd93bd7$var$SendOutlined, {}),
                        size: "middle",
                        onClick: ()=>sendMessage(),
                        loading: loadingSendMessage
                    }) : (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                        className: $c5be3ecb7f10b7f5$export$89db4734f6c919c4,
                        type: "default",
                        shape: "circle",
                        icon: (0, $bb3TF.jsx)($2489f4ddccd93bd7$var$SendOutlined, {}),
                        size: "middle",
                        onClick: ()=>sendMessageSms(),
                        loading: loadingSendMessage
                    })
                ]
            })
        ]
    });
};
var $2489f4ddccd93bd7$export$2e2bcd8739ae039 = $2489f4ddccd93bd7$var$ChatInputAdmin;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

// src/components/ReactPullToRefresh.tsx

var $6fFrj = parcelRequire("6fFrj");
var $128f5577ab58eb6c$exports = {};
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */ (function(window1, document1, exportName, undefined) {
    'use strict';
    var VENDOR_PREFIXES = [
        '',
        'webkit',
        'Moz',
        'MS',
        'ms',
        'o'
    ];
    var TEST_ELEMENT = document1.createElement('div');
    var TYPE_FUNCTION = 'function';
    var round = Math.round;
    var abs = Math.abs;
    var now = Date.now;
    /**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */ function setTimeoutContext(fn, timeout, context) {
        return setTimeout(bindFn(fn, context), timeout);
    }
    /**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */ function invokeArrayArg(arg, fn, context) {
        if (Array.isArray(arg)) {
            each(arg, context[fn], context);
            return true;
        }
        return false;
    }
    /**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */ function each(obj, iterator, context) {
        var i;
        if (!obj) return;
        if (obj.forEach) obj.forEach(iterator, context);
        else if (obj.length !== undefined) {
            i = 0;
            while(i < obj.length){
                iterator.call(context, obj[i], i, obj);
                i++;
            }
        } else for(i in obj)obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
    }
    /**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */ function deprecate(method, name, message) {
        var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
        return function() {
            var e = new Error('get-stack-trace');
            var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '').replace(/^\s+at\s+/gm, '').replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
            var log = window1.console && (window1.console.warn || window1.console.log);
            if (log) log.call(window1.console, deprecationMessage, stack);
            return method.apply(this, arguments);
        };
    }
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */ var assign;
    if (typeof Object.assign !== 'function') assign = function assign(target) {
        if (target === undefined || target === null) throw new TypeError('Cannot convert undefined or null to object');
        var output = Object(target);
        for(var index = 1; index < arguments.length; index++){
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for(var nextKey in source)if (source.hasOwnProperty(nextKey)) output[nextKey] = source[nextKey];
            }
        }
        return output;
    };
    else assign = Object.assign;
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */ var extend = deprecate(function extend(dest, src, merge) {
        var keys = Object.keys(src);
        var i = 0;
        while(i < keys.length){
            if (!merge || merge && dest[keys[i]] === undefined) dest[keys[i]] = src[keys[i]];
            i++;
        }
        return dest;
    }, 'extend', 'Use `assign`.');
    /**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */ var merge = deprecate(function merge(dest, src) {
        return extend(dest, src, true);
    }, 'merge', 'Use `assign`.');
    /**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */ function inherit(child, base, properties) {
        var baseP = base.prototype, childP;
        childP = child.prototype = Object.create(baseP);
        childP.constructor = child;
        childP._super = baseP;
        if (properties) assign(childP, properties);
    }
    /**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */ function bindFn(fn, context) {
        return function boundFn() {
            return fn.apply(context, arguments);
        };
    }
    /**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */ function boolOrFn(val, args) {
        if (typeof val == TYPE_FUNCTION) return val.apply(args ? args[0] || undefined : undefined, args);
        return val;
    }
    /**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */ function ifUndefined(val1, val2) {
        return val1 === undefined ? val2 : val1;
    }
    /**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function addEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.addEventListener(type, handler, false);
        });
    }
    /**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function removeEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.removeEventListener(type, handler, false);
        });
    }
    /**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */ function hasParent(node, parent) {
        while(node){
            if (node == parent) return true;
            node = node.parentNode;
        }
        return false;
    }
    /**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */ function inStr(str, find) {
        return str.indexOf(find) > -1;
    }
    /**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */ function splitStr(str) {
        return str.trim().split(/\s+/g);
    }
    /**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */ function inArray(src, find, findByKey) {
        if (src.indexOf && !findByKey) return src.indexOf(find);
        else {
            var i = 0;
            while(i < src.length){
                if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) return i;
                i++;
            }
            return -1;
        }
    }
    /**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */ function toArray(obj) {
        return Array.prototype.slice.call(obj, 0);
    }
    /**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */ function uniqueArray(src, key, sort) {
        var results = [];
        var values = [];
        var i = 0;
        while(i < src.length){
            var val = key ? src[i][key] : src[i];
            if (inArray(values, val) < 0) results.push(src[i]);
            values[i] = val;
            i++;
        }
        if (sort) {
            if (!key) results = results.sort();
            else results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
        return results;
    }
    /**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */ function prefixed(obj, property) {
        var prefix, prop;
        var camelProp = property[0].toUpperCase() + property.slice(1);
        var i = 0;
        while(i < VENDOR_PREFIXES.length){
            prefix = VENDOR_PREFIXES[i];
            prop = prefix ? prefix + camelProp : property;
            if (prop in obj) return prop;
            i++;
        }
        return undefined;
    }
    /**
 * get a unique id
 * @returns {number} uniqueId
 */ var _uniqueId = 1;
    function uniqueId() {
        return _uniqueId++;
    }
    /**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */ function getWindowForElement(element) {
        var doc = element.ownerDocument || element;
        return doc.defaultView || doc.parentWindow || window1;
    }
    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = 'ontouchstart' in window1;
    var SUPPORT_POINTER_EVENTS = prefixed(window1, 'PointerEvent') !== undefined;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = 'touch';
    var INPUT_TYPE_PEN = 'pen';
    var INPUT_TYPE_MOUSE = 'mouse';
    var INPUT_TYPE_KINECT = 'kinect';
    var COMPUTE_INTERVAL = 25;
    var INPUT_START = 1;
    var INPUT_MOVE = 2;
    var INPUT_END = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = [
        'x',
        'y'
    ];
    var PROPS_CLIENT_XY = [
        'clientX',
        'clientY'
    ];
    /**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */ function Input(manager, callback) {
        var self1 = this;
        this.manager = manager;
        this.callback = callback;
        this.element = manager.element;
        this.target = manager.options.inputTarget;
        // smaller wrapper around the handler, for the scope and the enabled state of the manager,
        // so when disabled the input events are completely bypassed.
        this.domHandler = function(ev) {
            if (boolOrFn(manager.options.enable, [
                manager
            ])) self1.handler(ev);
        };
        this.init();
    }
    Input.prototype = {
        /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */ handler: function() {},
        /**
     * bind the events
     */ init: function() {
            this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        },
        /**
     * unbind the events
     */ destroy: function() {
            this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        }
    };
    /**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */ function createInputInstance(manager) {
        var Type;
        var inputClass = manager.options.inputClass;
        if (inputClass) Type = inputClass;
        else if (SUPPORT_POINTER_EVENTS) Type = PointerEventInput;
        else if (SUPPORT_ONLY_TOUCH) Type = TouchInput;
        else if (!SUPPORT_TOUCH) Type = MouseInput;
        else Type = TouchMouseInput;
        return new Type(manager, inputHandler);
    }
    /**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */ function inputHandler(manager, eventType, input) {
        var pointersLen = input.pointers.length;
        var changedPointersLen = input.changedPointers.length;
        var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
        var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
        input.isFirst = !!isFirst;
        input.isFinal = !!isFinal;
        if (isFirst) manager.session = {};
        // source event is the normalized value of the domEvents
        // like 'touchstart, mouseup, pointerdown'
        input.eventType = eventType;
        // compute scale, rotation etc
        computeInputData(manager, input);
        // emit secret event
        manager.emit('hammer.input', input);
        manager.recognize(input);
        manager.session.prevInput = input;
    }
    /**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */ function computeInputData(manager, input) {
        var session = manager.session;
        var pointers = input.pointers;
        var pointersLength = pointers.length;
        // store the first input to calculate the distance and direction
        if (!session.firstInput) session.firstInput = simpleCloneInputData(input);
        // to compute scale and rotation we need to store the multiple touches
        if (pointersLength > 1 && !session.firstMultiple) session.firstMultiple = simpleCloneInputData(input);
        else if (pointersLength === 1) session.firstMultiple = false;
        var firstInput = session.firstInput;
        var firstMultiple = session.firstMultiple;
        var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
        var center = input.center = getCenter(pointers);
        input.timeStamp = now();
        input.deltaTime = input.timeStamp - firstInput.timeStamp;
        input.angle = getAngle(offsetCenter, center);
        input.distance = getDistance(offsetCenter, center);
        computeDeltaXY(session, input);
        input.offsetDirection = getDirection(input.deltaX, input.deltaY);
        var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
        input.overallVelocityX = overallVelocity.x;
        input.overallVelocityY = overallVelocity.y;
        input.overallVelocity = abs(overallVelocity.x) > abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
        input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
        input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
        input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
        computeIntervalInputData(session, input);
        // find the correct target
        var target = manager.element;
        if (hasParent(input.srcEvent.target, target)) target = input.srcEvent.target;
        input.target = target;
    }
    function computeDeltaXY(session, input) {
        var center = input.center;
        var offset = session.offsetDelta || {};
        var prevDelta = session.prevDelta || {};
        var prevInput = session.prevInput || {};
        if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
            prevDelta = session.prevDelta = {
                x: prevInput.deltaX || 0,
                y: prevInput.deltaY || 0
            };
            offset = session.offsetDelta = {
                x: center.x,
                y: center.y
            };
        }
        input.deltaX = prevDelta.x + (center.x - offset.x);
        input.deltaY = prevDelta.y + (center.y - offset.y);
    }
    /**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */ function computeIntervalInputData(session, input) {
        var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity, velocityX, velocityY, direction;
        if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
            var deltaX = input.deltaX - last.deltaX;
            var deltaY = input.deltaY - last.deltaY;
            var v = getVelocity(deltaTime, deltaX, deltaY);
            velocityX = v.x;
            velocityY = v.y;
            velocity = abs(v.x) > abs(v.y) ? v.x : v.y;
            direction = getDirection(deltaX, deltaY);
            session.lastInterval = input;
        } else {
            // use latest velocity info if it doesn't overtake a minimum period
            velocity = last.velocity;
            velocityX = last.velocityX;
            velocityY = last.velocityY;
            direction = last.direction;
        }
        input.velocity = velocity;
        input.velocityX = velocityX;
        input.velocityY = velocityY;
        input.direction = direction;
    }
    /**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */ function simpleCloneInputData(input) {
        // make a simple copy of the pointers because we will get a reference if we don't
        // we only need clientXY for the calculations
        var pointers = [];
        var i = 0;
        while(i < input.pointers.length){
            pointers[i] = {
                clientX: round(input.pointers[i].clientX),
                clientY: round(input.pointers[i].clientY)
            };
            i++;
        }
        return {
            timeStamp: now(),
            pointers: pointers,
            center: getCenter(pointers),
            deltaX: input.deltaX,
            deltaY: input.deltaY
        };
    }
    /**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */ function getCenter(pointers) {
        var pointersLength = pointers.length;
        // no need to loop when only one touch
        if (pointersLength === 1) return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
        var x = 0, y = 0, i = 0;
        while(i < pointersLength){
            x += pointers[i].clientX;
            y += pointers[i].clientY;
            i++;
        }
        return {
            x: round(x / pointersLength),
            y: round(y / pointersLength)
        };
    }
    /**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */ function getVelocity(deltaTime, x, y) {
        return {
            x: x / deltaTime || 0,
            y: y / deltaTime || 0
        };
    }
    /**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */ function getDirection(x, y) {
        if (x === y) return DIRECTION_NONE;
        if (abs(x) >= abs(y)) return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
        return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }
    /**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */ function getDistance(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.sqrt(x * x + y * y);
    }
    /**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */ function getAngle(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.atan2(y, x) * 180 / Math.PI;
    }
    /**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */ function getRotation(start, end) {
        return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
    }
    /**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */ function getScale(start, end) {
        return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
    }
    var MOUSE_INPUT_MAP = {
        mousedown: INPUT_START,
        mousemove: INPUT_MOVE,
        mouseup: INPUT_END
    };
    var MOUSE_ELEMENT_EVENTS = 'mousedown';
    var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
    /**
 * Mouse events input
 * @constructor
 * @extends Input
 */ function MouseInput() {
        this.evEl = MOUSE_ELEMENT_EVENTS;
        this.evWin = MOUSE_WINDOW_EVENTS;
        this.pressed = false; // mousedown state
        Input.apply(this, arguments);
    }
    inherit(MouseInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function MEhandler(ev) {
            var eventType = MOUSE_INPUT_MAP[ev.type];
            // on start we want to have the left mouse button down
            if (eventType & INPUT_START && ev.button === 0) this.pressed = true;
            if (eventType & INPUT_MOVE && ev.which !== 1) eventType = INPUT_END;
            // mouse must be down
            if (!this.pressed) return;
            if (eventType & INPUT_END) this.pressed = false;
            this.callback(this.manager, eventType, {
                pointers: [
                    ev
                ],
                changedPointers: [
                    ev
                ],
                pointerType: INPUT_TYPE_MOUSE,
                srcEvent: ev
            });
        }
    });
    var POINTER_INPUT_MAP = {
        pointerdown: INPUT_START,
        pointermove: INPUT_MOVE,
        pointerup: INPUT_END,
        pointercancel: INPUT_CANCEL,
        pointerout: INPUT_CANCEL
    };
    // in IE10 the pointer types is defined as an enum
    var IE10_POINTER_TYPE_ENUM = {
        2: INPUT_TYPE_TOUCH,
        3: INPUT_TYPE_PEN,
        4: INPUT_TYPE_MOUSE,
        5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
    };
    var POINTER_ELEMENT_EVENTS = 'pointerdown';
    var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
    // IE10 has prefixed support, and case-sensitive
    if (window1.MSPointerEvent && !window1.PointerEvent) {
        POINTER_ELEMENT_EVENTS = 'MSPointerDown';
        POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
    }
    /**
 * Pointer events input
 * @constructor
 * @extends Input
 */ function PointerEventInput() {
        this.evEl = POINTER_ELEMENT_EVENTS;
        this.evWin = POINTER_WINDOW_EVENTS;
        Input.apply(this, arguments);
        this.store = this.manager.session.pointerEvents = [];
    }
    inherit(PointerEventInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function PEhandler(ev) {
            var store = this.store;
            var removePointer = false;
            var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
            var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
            var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
            var isTouch = pointerType == INPUT_TYPE_TOUCH;
            // get index of the event in the store
            var storeIndex = inArray(store, ev.pointerId, 'pointerId');
            // start and mouse must be down
            if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
                if (storeIndex < 0) {
                    store.push(ev);
                    storeIndex = store.length - 1;
                }
            } else if (eventType & (INPUT_END | INPUT_CANCEL)) removePointer = true;
            // it not found, so the pointer hasn't been down (so it's probably a hover)
            if (storeIndex < 0) return;
            // update the event in the store
            store[storeIndex] = ev;
            this.callback(this.manager, eventType, {
                pointers: store,
                changedPointers: [
                    ev
                ],
                pointerType: pointerType,
                srcEvent: ev
            });
            if (removePointer) // remove from the store
            store.splice(storeIndex, 1);
        }
    });
    var SINGLE_TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
    var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
 * Touch events input
 * @constructor
 * @extends Input
 */ function SingleTouchInput() {
        this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
        this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
        this.started = false;
        Input.apply(this, arguments);
    }
    inherit(SingleTouchInput, Input, {
        handler: function TEhandler(ev) {
            var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
            // should we handle the touch events?
            if (type === INPUT_START) this.started = true;
            if (!this.started) return;
            var touches = normalizeSingleTouches.call(this, ev, type);
            // when done, reset the started state
            if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) this.started = false;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function normalizeSingleTouches(ev, type) {
        var all = toArray(ev.touches);
        var changed = toArray(ev.changedTouches);
        if (type & (INPUT_END | INPUT_CANCEL)) all = uniqueArray(all.concat(changed), 'identifier', true);
        return [
            all,
            changed
        ];
    }
    var TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */ function TouchInput() {
        this.evTarget = TOUCH_TARGET_EVENTS;
        this.targetIds = {};
        Input.apply(this, arguments);
    }
    inherit(TouchInput, Input, {
        handler: function MTEhandler(ev) {
            var type = TOUCH_INPUT_MAP[ev.type];
            var touches = getTouches.call(this, ev, type);
            if (!touches) return;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function getTouches(ev, type) {
        var allTouches = toArray(ev.touches);
        var targetIds = this.targetIds;
        // when there is only one touch, the process can be simplified
        if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
            targetIds[allTouches[0].identifier] = true;
            return [
                allTouches,
                allTouches
            ];
        }
        var i, targetTouches, changedTouches = toArray(ev.changedTouches), changedTargetTouches = [], target = this.target;
        // get target touches from touches
        targetTouches = allTouches.filter(function(touch) {
            return hasParent(touch.target, target);
        });
        // collect touches
        if (type === INPUT_START) {
            i = 0;
            while(i < targetTouches.length){
                targetIds[targetTouches[i].identifier] = true;
                i++;
            }
        }
        // filter changed touches to only contain touches that exist in the collected target ids
        i = 0;
        while(i < changedTouches.length){
            if (targetIds[changedTouches[i].identifier]) changedTargetTouches.push(changedTouches[i]);
            // cleanup removed touches
            if (type & (INPUT_END | INPUT_CANCEL)) delete targetIds[changedTouches[i].identifier];
            i++;
        }
        if (!changedTargetTouches.length) return;
        return [
            // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
            uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
            changedTargetTouches
        ];
    }
    /**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */ var DEDUP_TIMEOUT = 2500;
    var DEDUP_DISTANCE = 25;
    function TouchMouseInput() {
        Input.apply(this, arguments);
        var handler = bindFn(this.handler, this);
        this.touch = new TouchInput(this.manager, handler);
        this.mouse = new MouseInput(this.manager, handler);
        this.primaryTouch = null;
        this.lastTouches = [];
    }
    inherit(TouchMouseInput, Input, {
        /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */ handler: function TMEhandler(manager, inputEvent, inputData) {
            var isTouch = inputData.pointerType == INPUT_TYPE_TOUCH, isMouse = inputData.pointerType == INPUT_TYPE_MOUSE;
            if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) return;
            // when we're in a touch event, record touches to  de-dupe synthetic mouse event
            if (isTouch) recordTouches.call(this, inputEvent, inputData);
            else if (isMouse && isSyntheticEvent.call(this, inputData)) return;
            this.callback(manager, inputEvent, inputData);
        },
        /**
     * remove the event listeners
     */ destroy: function destroy() {
            this.touch.destroy();
            this.mouse.destroy();
        }
    });
    function recordTouches(eventType, eventData) {
        if (eventType & INPUT_START) {
            this.primaryTouch = eventData.changedPointers[0].identifier;
            setLastTouch.call(this, eventData);
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) setLastTouch.call(this, eventData);
    }
    function setLastTouch(eventData) {
        var touch = eventData.changedPointers[0];
        if (touch.identifier === this.primaryTouch) {
            var lastTouch = {
                x: touch.clientX,
                y: touch.clientY
            };
            this.lastTouches.push(lastTouch);
            var lts = this.lastTouches;
            var removeLastTouch = function() {
                var i = lts.indexOf(lastTouch);
                if (i > -1) lts.splice(i, 1);
            };
            setTimeout(removeLastTouch, DEDUP_TIMEOUT);
        }
    }
    function isSyntheticEvent(eventData) {
        var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
        for(var i = 0; i < this.lastTouches.length; i++){
            var t = this.lastTouches[i];
            var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
            if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) return true;
        }
        return false;
    }
    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
    // magical touchAction value
    var TOUCH_ACTION_COMPUTE = 'compute';
    var TOUCH_ACTION_AUTO = 'auto';
    var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
    var TOUCH_ACTION_NONE = 'none';
    var TOUCH_ACTION_PAN_X = 'pan-x';
    var TOUCH_ACTION_PAN_Y = 'pan-y';
    var TOUCH_ACTION_MAP = getTouchActionProps();
    /**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */ function TouchAction(manager, value) {
        this.manager = manager;
        this.set(value);
    }
    TouchAction.prototype = {
        /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */ set: function(value) {
            // find out the touch-action by the event handlers
            if (value == TOUCH_ACTION_COMPUTE) value = this.compute();
            if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
            this.actions = value.toLowerCase().trim();
        },
        /**
     * just re-set the touchAction value
     */ update: function() {
            this.set(this.manager.options.touchAction);
        },
        /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */ compute: function() {
            var actions = [];
            each(this.manager.recognizers, function(recognizer) {
                if (boolOrFn(recognizer.options.enable, [
                    recognizer
                ])) actions = actions.concat(recognizer.getTouchAction());
            });
            return cleanTouchActions(actions.join(' '));
        },
        /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */ preventDefaults: function(input) {
            var srcEvent = input.srcEvent;
            var direction = input.offsetDirection;
            // if the touch action did prevented once this session
            if (this.manager.session.prevented) {
                srcEvent.preventDefault();
                return;
            }
            var actions = this.actions;
            var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
            var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
            var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
            if (hasNone) {
                //do not prevent defaults if this is a tap gesture
                var isTapPointer = input.pointers.length === 1;
                var isTapMovement = input.distance < 2;
                var isTapTouchTime = input.deltaTime < 250;
                if (isTapPointer && isTapMovement && isTapTouchTime) return;
            }
            if (hasPanX && hasPanY) // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
            if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) return this.preventSrc(srcEvent);
        },
        /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */ preventSrc: function(srcEvent) {
            this.manager.session.prevented = true;
            srcEvent.preventDefault();
        }
    };
    /**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */ function cleanTouchActions(actions) {
        // none
        if (inStr(actions, TOUCH_ACTION_NONE)) return TOUCH_ACTION_NONE;
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
        // if both pan-x and pan-y are set (different recognizers
        // for different directions, e.g. horizontal pan but vertical swipe?)
        // we need none (as otherwise with pan-x pan-y combined none of these
        // recognizers will work, since the browser would handle all panning
        if (hasPanX && hasPanY) return TOUCH_ACTION_NONE;
        // pan-x OR pan-y
        if (hasPanX || hasPanY) return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
        // manipulation
        if (inStr(actions, TOUCH_ACTION_MANIPULATION)) return TOUCH_ACTION_MANIPULATION;
        return TOUCH_ACTION_AUTO;
    }
    function getTouchActionProps() {
        if (!NATIVE_TOUCH_ACTION) return false;
        var touchMap = {};
        var cssSupports = window1.CSS && window1.CSS.supports;
        [
            'auto',
            'manipulation',
            'pan-y',
            'pan-x',
            'pan-x pan-y',
            'none'
        ].forEach(function(val) {
            // If css.supports is not supported but there is native touch-action assume it supports
            // all values. This is the case for IE 10 and 11.
            touchMap[val] = cssSupports ? window1.CSS.supports('touch-action', val) : true;
        });
        return touchMap;
    }
    /**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */ var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    /**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */ function Recognizer(options) {
        this.options = assign({}, this.defaults, options || {});
        this.id = uniqueId();
        this.manager = null;
        // default is enable true
        this.options.enable = ifUndefined(this.options.enable, true);
        this.state = STATE_POSSIBLE;
        this.simultaneous = {};
        this.requireFail = [];
    }
    Recognizer.prototype = {
        /**
     * @virtual
     * @type {Object}
     */ defaults: {},
        /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */ set: function(options) {
            assign(this.options, options);
            // also update the touchAction, in case something changed about the directions/enabled state
            this.manager && this.manager.touchAction.update();
            return this;
        },
        /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ recognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) return this;
            var simultaneous = this.simultaneous;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (!simultaneous[otherRecognizer.id]) {
                simultaneous[otherRecognizer.id] = otherRecognizer;
                otherRecognizer.recognizeWith(this);
            }
            return this;
        },
        /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRecognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            delete this.simultaneous[otherRecognizer.id];
            return this;
        },
        /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ requireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) return this;
            var requireFail = this.requireFail;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (inArray(requireFail, otherRecognizer) === -1) {
                requireFail.push(otherRecognizer);
                otherRecognizer.requireFailure(this);
            }
            return this;
        },
        /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRequireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            var index = inArray(this.requireFail, otherRecognizer);
            if (index > -1) this.requireFail.splice(index, 1);
            return this;
        },
        /**
     * has require failures boolean
     * @returns {boolean}
     */ hasRequireFailures: function() {
            return this.requireFail.length > 0;
        },
        /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */ canRecognizeWith: function(otherRecognizer) {
            return !!this.simultaneous[otherRecognizer.id];
        },
        /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */ emit: function(input) {
            var self1 = this;
            var state = this.state;
            function emit(event) {
                self1.manager.emit(event, input);
            }
            // 'panstart' and 'panmove'
            if (state < STATE_ENDED) emit(self1.options.event + stateStr(state));
            emit(self1.options.event); // simple 'eventName' events
            if (input.additionalEvent) emit(input.additionalEvent);
            // panend and pancancel
            if (state >= STATE_ENDED) emit(self1.options.event + stateStr(state));
        },
        /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */ tryEmit: function(input) {
            if (this.canEmit()) return this.emit(input);
            // it's failing anyway
            this.state = STATE_FAILED;
        },
        /**
     * can we emit?
     * @returns {boolean}
     */ canEmit: function() {
            var i = 0;
            while(i < this.requireFail.length){
                if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) return false;
                i++;
            }
            return true;
        },
        /**
     * update the recognizer
     * @param {Object} inputData
     */ recognize: function(inputData) {
            // make a new copy of the inputData
            // so we can change the inputData without messing up the other recognizers
            var inputDataClone = assign({}, inputData);
            // is is enabled and allow recognizing?
            if (!boolOrFn(this.options.enable, [
                this,
                inputDataClone
            ])) {
                this.reset();
                this.state = STATE_FAILED;
                return;
            }
            // reset when we've reached the end
            if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) this.state = STATE_POSSIBLE;
            this.state = this.process(inputDataClone);
            // the recognizer has recognized a gesture
            // so trigger an event
            if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) this.tryEmit(inputDataClone);
        },
        /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */ process: function(inputData) {},
        /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */ getTouchAction: function() {},
        /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */ reset: function() {}
    };
    /**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */ function stateStr(state) {
        if (state & STATE_CANCELLED) return 'cancel';
        else if (state & STATE_ENDED) return 'end';
        else if (state & STATE_CHANGED) return 'move';
        else if (state & STATE_BEGAN) return 'start';
        return '';
    }
    /**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */ function directionStr(direction) {
        if (direction == DIRECTION_DOWN) return 'down';
        else if (direction == DIRECTION_UP) return 'up';
        else if (direction == DIRECTION_LEFT) return 'left';
        else if (direction == DIRECTION_RIGHT) return 'right';
        return '';
    }
    /**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */ function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
        var manager = recognizer.manager;
        if (manager) return manager.get(otherRecognizer);
        return otherRecognizer;
    }
    /**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */ function AttrRecognizer() {
        Recognizer.apply(this, arguments);
    }
    inherit(AttrRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof AttrRecognizer
     */ defaults: {
            /**
         * @type {Number}
         * @default 1
         */ pointers: 1
        },
        /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */ attrTest: function(input) {
            var optionPointers = this.options.pointers;
            return optionPointers === 0 || input.pointers.length === optionPointers;
        },
        /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */ process: function(input) {
            var state = this.state;
            var eventType = input.eventType;
            var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
            var isValid = this.attrTest(input);
            // on cancel input and we've recognized before, return STATE_CANCELLED
            if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) return state | STATE_CANCELLED;
            else if (isRecognized || isValid) {
                if (eventType & INPUT_END) return state | STATE_ENDED;
                else if (!(state & STATE_BEGAN)) return STATE_BEGAN;
                return state | STATE_CHANGED;
            }
            return STATE_FAILED;
        }
    });
    /**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function PanRecognizer() {
        AttrRecognizer.apply(this, arguments);
        this.pX = null;
        this.pY = null;
    }
    inherit(PanRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PanRecognizer
     */ defaults: {
            event: 'pan',
            threshold: 10,
            pointers: 1,
            direction: DIRECTION_ALL
        },
        getTouchAction: function() {
            var direction = this.options.direction;
            var actions = [];
            if (direction & DIRECTION_HORIZONTAL) actions.push(TOUCH_ACTION_PAN_Y);
            if (direction & DIRECTION_VERTICAL) actions.push(TOUCH_ACTION_PAN_X);
            return actions;
        },
        directionTest: function(input) {
            var options = this.options;
            var hasMoved = true;
            var distance = input.distance;
            var direction = input.direction;
            var x = input.deltaX;
            var y = input.deltaY;
            // lock to axis?
            if (!(direction & options.direction)) {
                if (options.direction & DIRECTION_HORIZONTAL) {
                    direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
                    hasMoved = x != this.pX;
                    distance = Math.abs(input.deltaX);
                } else {
                    direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
                    hasMoved = y != this.pY;
                    distance = Math.abs(input.deltaY);
                }
            }
            input.direction = direction;
            return hasMoved && distance > options.threshold && direction & options.direction;
        },
        attrTest: function(input) {
            return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
        },
        emit: function(input) {
            this.pX = input.deltaX;
            this.pY = input.deltaY;
            var direction = directionStr(input.direction);
            if (direction) input.additionalEvent = this.options.event + direction;
            this._super.emit.call(this, input);
        }
    });
    /**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */ function PinchRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(PinchRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: 'pinch',
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
        },
        emit: function(input) {
            if (input.scale !== 1) {
                var inOut = input.scale < 1 ? 'in' : 'out';
                input.additionalEvent = this.options.event + inOut;
            }
            this._super.emit.call(this, input);
        }
    });
    /**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */ function PressRecognizer() {
        Recognizer.apply(this, arguments);
        this._timer = null;
        this._input = null;
    }
    inherit(PressRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PressRecognizer
     */ defaults: {
            event: 'press',
            pointers: 1,
            time: 251,
            threshold: 9 // a minimal movement is ok, but keep it low
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_AUTO
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTime = input.deltaTime > options.time;
            this._input = input;
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) this.reset();
            else if (input.eventType & INPUT_START) {
                this.reset();
                this._timer = setTimeoutContext(function() {
                    this.state = STATE_RECOGNIZED;
                    this.tryEmit();
                }, options.time, this);
            } else if (input.eventType & INPUT_END) return STATE_RECOGNIZED;
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function(input) {
            if (this.state !== STATE_RECOGNIZED) return;
            if (input && input.eventType & INPUT_END) this.manager.emit(this.options.event + 'up', input);
            else {
                this._input.timeStamp = now();
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */ function RotateRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(RotateRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof RotateRecognizer
     */ defaults: {
            event: 'rotate',
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
        }
    });
    /**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function SwipeRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(SwipeRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof SwipeRecognizer
     */ defaults: {
            event: 'swipe',
            threshold: 10,
            velocity: 0.3,
            direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
            pointers: 1
        },
        getTouchAction: function() {
            return PanRecognizer.prototype.getTouchAction.call(this);
        },
        attrTest: function(input) {
            var direction = this.options.direction;
            var velocity;
            if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) velocity = input.overallVelocity;
            else if (direction & DIRECTION_HORIZONTAL) velocity = input.overallVelocityX;
            else if (direction & DIRECTION_VERTICAL) velocity = input.overallVelocityY;
            return this._super.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers == this.options.pointers && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
        },
        emit: function(input) {
            var direction = directionStr(input.offsetDirection);
            if (direction) this.manager.emit(this.options.event + direction, input);
            this.manager.emit(this.options.event, input);
        }
    });
    /**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */ function TapRecognizer() {
        Recognizer.apply(this, arguments);
        // previous time and center,
        // used for tap counting
        this.pTime = false;
        this.pCenter = false;
        this._timer = null;
        this._input = null;
        this.count = 0;
    }
    inherit(TapRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: 'tap',
            pointers: 1,
            taps: 1,
            interval: 300,
            time: 250,
            threshold: 9,
            posThreshold: 10 // a multi-tap can be a bit off the initial position
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_MANIPULATION
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTouchTime = input.deltaTime < options.time;
            this.reset();
            if (input.eventType & INPUT_START && this.count === 0) return this.failTimeout();
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (validMovement && validTouchTime && validPointers) {
                if (input.eventType != INPUT_END) return this.failTimeout();
                var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
                var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
                this.pTime = input.timeStamp;
                this.pCenter = input.center;
                if (!validMultiTap || !validInterval) this.count = 1;
                else this.count += 1;
                this._input = input;
                // if tap count matches we have recognized it,
                // else it has began recognizing...
                var tapCount = this.count % options.taps;
                if (tapCount === 0) {
                    // no failing requirements, immediately trigger the tap event
                    // or wait as long as the multitap interval to trigger
                    if (!this.hasRequireFailures()) return STATE_RECOGNIZED;
                    else {
                        this._timer = setTimeoutContext(function() {
                            this.state = STATE_RECOGNIZED;
                            this.tryEmit();
                        }, options.interval, this);
                        return STATE_BEGAN;
                    }
                }
            }
            return STATE_FAILED;
        },
        failTimeout: function() {
            this._timer = setTimeoutContext(function() {
                this.state = STATE_FAILED;
            }, this.options.interval, this);
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function() {
            if (this.state == STATE_RECOGNIZED) {
                this._input.tapCount = this.count;
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Hammer(element, options) {
        options = options || {};
        options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
        return new Manager(element, options);
    }
    /**
 * @const {string}
 */ Hammer.VERSION = '2.0.7';
    /**
 * default settings
 * @namespace
 */ Hammer.defaults = {
        /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */ domEvents: false,
        /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */ touchAction: TOUCH_ACTION_COMPUTE,
        /**
     * @type {Boolean}
     * @default true
     */ enable: true,
        /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */ inputTarget: null,
        /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */ inputClass: null,
        /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */ preset: [
            // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
            [
                RotateRecognizer,
                {
                    enable: false
                }
            ],
            [
                PinchRecognizer,
                {
                    enable: false
                },
                [
                    'rotate'
                ]
            ],
            [
                SwipeRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                }
            ],
            [
                PanRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                },
                [
                    'swipe'
                ]
            ],
            [
                TapRecognizer
            ],
            [
                TapRecognizer,
                {
                    event: 'doubletap',
                    taps: 2
                },
                [
                    'tap'
                ]
            ],
            [
                PressRecognizer
            ]
        ],
        /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */ cssProps: {
            /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userSelect: 'none',
            /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */ touchSelect: 'none',
            /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */ touchCallout: 'none',
            /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */ contentZooming: 'none',
            /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userDrag: 'none',
            /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */ tapHighlightColor: 'rgba(0,0,0,0)'
        }
    };
    var STOP = 1;
    var FORCED_STOP = 2;
    /**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Manager(element, options) {
        this.options = assign({}, Hammer.defaults, options || {});
        this.options.inputTarget = this.options.inputTarget || element;
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.oldCssProps = {};
        this.element = element;
        this.input = createInputInstance(this);
        this.touchAction = new TouchAction(this, this.options.touchAction);
        toggleCssProps(this, true);
        each(this.options.recognizers, function(item) {
            var recognizer = this.add(new item[0](item[1]));
            item[2] && recognizer.recognizeWith(item[2]);
            item[3] && recognizer.requireFailure(item[3]);
        }, this);
    }
    Manager.prototype = {
        /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */ set: function(options) {
            assign(this.options, options);
            // Options that need a little more setup
            if (options.touchAction) this.touchAction.update();
            if (options.inputTarget) {
                // Clean up existing event listeners and reinitialize
                this.input.destroy();
                this.input.target = options.inputTarget;
                this.input.init();
            }
            return this;
        },
        /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */ stop: function(force) {
            this.session.stopped = force ? FORCED_STOP : STOP;
        },
        /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */ recognize: function(inputData) {
            var session = this.session;
            if (session.stopped) return;
            // run the touch-action polyfill
            this.touchAction.preventDefaults(inputData);
            var recognizer;
            var recognizers = this.recognizers;
            // this holds the recognizer that is being recognized.
            // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
            // if no recognizer is detecting a thing, it is set to `null`
            var curRecognizer = session.curRecognizer;
            // reset when the last recognizer is recognized
            // or when we're in a new session
            if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) curRecognizer = session.curRecognizer = null;
            var i = 0;
            while(i < recognizers.length){
                recognizer = recognizers[i];
                // find out if we are allowed try to recognize the input for this one.
                // 1.   allow if the session is NOT forced stopped (see the .stop() method)
                // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
                //      that is being recognized.
                // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
                //      this can be setup with the `recognizeWith()` method on the recognizer.
                if (session.stopped !== FORCED_STOP && (!curRecognizer || recognizer == curRecognizer || // 2
                recognizer.canRecognizeWith(curRecognizer))) recognizer.recognize(inputData);
                else recognizer.reset();
                // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
                // current active recognizer. but only if we don't already have an active recognizer
                if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) curRecognizer = session.curRecognizer = recognizer;
                i++;
            }
        },
        /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */ get: function(recognizer) {
            if (recognizer instanceof Recognizer) return recognizer;
            var recognizers = this.recognizers;
            for(var i = 0; i < recognizers.length; i++){
                if (recognizers[i].options.event == recognizer) return recognizers[i];
            }
            return null;
        },
        /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */ add: function(recognizer) {
            if (invokeArrayArg(recognizer, 'add', this)) return this;
            // remove existing
            var existing = this.get(recognizer.options.event);
            if (existing) this.remove(existing);
            this.recognizers.push(recognizer);
            recognizer.manager = this;
            this.touchAction.update();
            return recognizer;
        },
        /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */ remove: function(recognizer) {
            if (invokeArrayArg(recognizer, 'remove', this)) return this;
            recognizer = this.get(recognizer);
            // let's make sure this recognizer exists
            if (recognizer) {
                var recognizers = this.recognizers;
                var index = inArray(recognizers, recognizer);
                if (index !== -1) {
                    recognizers.splice(index, 1);
                    this.touchAction.update();
                }
            }
            return this;
        },
        /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */ on: function(events, handler) {
            if (events === undefined) return;
            if (handler === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                handlers[event] = handlers[event] || [];
                handlers[event].push(handler);
            });
            return this;
        },
        /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */ off: function(events, handler) {
            if (events === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                if (!handler) delete handlers[event];
                else handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            });
            return this;
        },
        /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */ emit: function(event, data) {
            // we also want to trigger dom events
            if (this.options.domEvents) triggerDomEvent(event, data);
            // no handlers, so skip it all
            var handlers = this.handlers[event] && this.handlers[event].slice();
            if (!handlers || !handlers.length) return;
            data.type = event;
            data.preventDefault = function() {
                data.srcEvent.preventDefault();
            };
            var i = 0;
            while(i < handlers.length){
                handlers[i](data);
                i++;
            }
        },
        /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */ destroy: function() {
            this.element && toggleCssProps(this, false);
            this.handlers = {};
            this.session = {};
            this.input.destroy();
            this.element = null;
        }
    };
    /**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */ function toggleCssProps(manager, add) {
        var element = manager.element;
        if (!element.style) return;
        var prop;
        each(manager.options.cssProps, function(value, name) {
            prop = prefixed(element.style, name);
            if (add) {
                manager.oldCssProps[prop] = element.style[prop];
                element.style[prop] = value;
            } else element.style[prop] = manager.oldCssProps[prop] || '';
        });
        if (!add) manager.oldCssProps = {};
    }
    /**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */ function triggerDomEvent(event, data) {
        var gestureEvent = document1.createEvent('Event');
        gestureEvent.initEvent(event, true, true);
        gestureEvent.gesture = data;
        data.target.dispatchEvent(gestureEvent);
    }
    assign(Hammer, {
        INPUT_START: INPUT_START,
        INPUT_MOVE: INPUT_MOVE,
        INPUT_END: INPUT_END,
        INPUT_CANCEL: INPUT_CANCEL,
        STATE_POSSIBLE: STATE_POSSIBLE,
        STATE_BEGAN: STATE_BEGAN,
        STATE_CHANGED: STATE_CHANGED,
        STATE_ENDED: STATE_ENDED,
        STATE_RECOGNIZED: STATE_RECOGNIZED,
        STATE_CANCELLED: STATE_CANCELLED,
        STATE_FAILED: STATE_FAILED,
        DIRECTION_NONE: DIRECTION_NONE,
        DIRECTION_LEFT: DIRECTION_LEFT,
        DIRECTION_RIGHT: DIRECTION_RIGHT,
        DIRECTION_UP: DIRECTION_UP,
        DIRECTION_DOWN: DIRECTION_DOWN,
        DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
        DIRECTION_VERTICAL: DIRECTION_VERTICAL,
        DIRECTION_ALL: DIRECTION_ALL,
        Manager: Manager,
        Input: Input,
        TouchAction: TouchAction,
        TouchInput: TouchInput,
        MouseInput: MouseInput,
        PointerEventInput: PointerEventInput,
        TouchMouseInput: TouchMouseInput,
        SingleTouchInput: SingleTouchInput,
        Recognizer: Recognizer,
        AttrRecognizer: AttrRecognizer,
        Tap: TapRecognizer,
        Pan: PanRecognizer,
        Swipe: SwipeRecognizer,
        Pinch: PinchRecognizer,
        Rotate: RotateRecognizer,
        Press: PressRecognizer,
        on: addEventListeners,
        off: removeEventListeners,
        each: each,
        merge: merge,
        extend: extend,
        assign: assign,
        inherit: inherit,
        bindFn: bindFn,
        prefixed: prefixed
    });
    // this prevents errors when Hammer is loaded in the presence of an AMD
    //  style loader but by script tag, not by the loader.
    var freeGlobal = typeof window1 !== 'undefined' ? window1 : typeof self !== 'undefined' ? self : {}; // jshint ignore:line
    freeGlobal.Hammer = Hammer;
    if (typeof define === 'function' && define.amd) define(function() {
        return Hammer;
    });
    else if (0, $128f5577ab58eb6c$exports) $128f5577ab58eb6c$exports = Hammer;
    else window1[exportName] = Hammer;
})(window, document, 'Hammer');



var $bb3TF = parcelRequire("bb3TF");
function $eb1cb0d7e7f7ccad$var$webPullToRefresh() {
    const defaults = {
        contentEl: "content",
        ptrEl: "ptr",
        bodyEl: document.body,
        distanceToRefresh: 70,
        loadingFunction: false,
        resistance: 2.5
    };
    let options = {};
    const pan = {
        enabled: false,
        distance: 0,
        startingPositionY: 0
    };
    let bodyClass = defaults.bodyEl.classList;
    const init = (params)=>{
        var _a;
        options = {
            contentEl: params.contentEl ?? document.getElementById(defaults.contentEl),
            ptrEl: params.ptrEl || document.getElementById(defaults.ptrEl),
            bodyEl: params.bodyEl || defaults.bodyEl,
            distanceToRefresh: params.distanceToRefresh || defaults.distanceToRefresh,
            loadingFunction: params.loadingFunction || defaults.loadingFunction,
            resistance: params.resistance || defaults.resistance,
            hammerOptions: params.hammerOptions ?? {}
        };
        if (!options.contentEl || !options.ptrEl) return false;
        bodyClass = (_a = options.bodyEl) == null ? void 0 : _a.classList;
        const h = new (0, (/*@__PURE__*/$parcel$interopDefault($128f5577ab58eb6c$exports)))(options.contentEl, options.hammerOptions);
        h.get("pan").set({
            direction: (0, (/*@__PURE__*/$parcel$interopDefault($128f5577ab58eb6c$exports))).DIRECTION_VERTICAL
        });
        h.on("panstart", _panStart);
        h.on("pandown", _panDown);
        h.on("panup", _panUp);
        h.on("panend", _panEnd);
    };
    const _panStart = ()=>{
        pan.startingPositionY = options.bodyEl.scrollTop;
        if (pan.startingPositionY === 0) pan.enabled = true;
    };
    const _panDown = (e)=>{
        if (!pan.enabled) return;
        e.preventDefault();
        pan.distance = e.distance / options.resistance;
        _setContentPan();
        _setBodyClass();
    };
    const _panUp = (e)=>{
        if (!pan.enabled || pan.distance === 0) return;
        e.preventDefault();
        if (pan.distance < e.distance / options.resistance) pan.distance = 0;
        else pan.distance = e.distance / options.resistance;
        _setContentPan();
        _setBodyClass();
    };
    const _setContentPan = ()=>{
        if (options.contentEl) options.contentEl.style.transform = `translate3d( 0, ${pan.distance}px, 0 )`;
        options.ptrEl.style.transform = `translate3d( 0, ${pan.distance - options.ptrEl.offsetHeight}px, 0 )`;
    };
    const _setBodyClass = ()=>{
        if (pan.distance > options.distanceToRefresh) bodyClass.add("ptr-refresh");
        else bodyClass.remove("ptr-refresh");
    };
    const _panEnd = (e)=>{
        if (!pan.enabled) return;
        e.preventDefault();
        if (options.contentEl) options.contentEl.style.transform = "";
        options.ptrEl.style.transform = "";
        if (options.bodyEl.classList.contains("ptr-refresh")) _doLoading();
        else _doReset();
        pan.distance = 0;
        pan.enabled = false;
    };
    const _doLoading = ()=>{
        bodyClass.add("ptr-loading");
        if (!options.loadingFunction) return _doReset();
        const loadingPromise = options.loadingFunction();
        setTimeout(()=>{
            loadingPromise.then(_doReset);
        }, 1e3);
    };
    const _doReset = ()=>{
        bodyClass.remove("ptr-loading");
        bodyClass.remove("ptr-refresh");
        bodyClass.add("ptr-reset");
        const bodyClassRemove = ()=>{
            bodyClass.remove("ptr-reset");
            options.bodyEl.removeEventListener("transitionend", bodyClassRemove, false);
        };
        options.bodyEl.addEventListener("transitionend", bodyClassRemove, false);
    };
    return {
        init: init
    };
}
function $eb1cb0d7e7f7ccad$var$ReactPullToRefresh(props) {
    const { onRefresh: onRefresh, disabled: disabled, distanceToRefresh: distanceToRefresh, resistance: resistance, hammerOptions: hammerOptions, children: children, icon: icon, loading: loading, ...rest } = props;
    async function handleRefresh() {
        await onRefresh();
    }
    const hasBeenInit = (0, $6fFrj.useRef)(null);
    const refreshRef = (0, $6fFrj.useRef)(null);
    const ptrRef = (0, $6fFrj.useRef)(null);
    const bodyRef = (0, $6fFrj.useRef)(null);
    (0, $6fFrj.useEffect)(()=>{
        if (!disabled) {
            if (hasBeenInit.current) return;
            $eb1cb0d7e7f7ccad$var$webPullToRefresh().init({
                contentEl: refreshRef.current,
                ptrEl: ptrRef.current,
                bodyEl: document.body,
                distanceToRefresh: distanceToRefresh,
                loadingFunction: handleRefresh,
                resistance: resistance,
                hammerOptions: hammerOptions
            });
            hasBeenInit.current = true;
        }
    }, [
        disabled
    ]);
    if (disabled) return /* @__PURE__ */ (0, $bb3TF.jsx)("div", {
        ...rest,
        children: children
    });
    return /* @__PURE__ */ (0, $bb3TF.jsxs)("div", {
        ref: bodyRef,
        ...rest,
        children: [
            /* @__PURE__ */ (0, $bb3TF.jsxs)("div", {
                className: "ptr-element",
                ref: ptrRef,
                children: [
                    icon ?? /* @__PURE__ */ (0, $bb3TF.jsx)("span", {
                        className: "genericon genericon-next"
                    }),
                    loading ?? /* @__PURE__ */ (0, $bb3TF.jsxs)("div", {
                        className: "loading",
                        children: [
                            /* @__PURE__ */ (0, $bb3TF.jsx)("span", {
                                className: "loading-ptr-1"
                            }),
                            /* @__PURE__ */ (0, $bb3TF.jsx)("span", {
                                className: "loading-ptr-2"
                            }),
                            /* @__PURE__ */ (0, $bb3TF.jsx)("span", {
                                className: "loading-ptr-3"
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0, $bb3TF.jsx)("div", {
                className: "refresh-view",
                ref: refreshRef,
                children: children
            })
        ]
    });
}
var $eb1cb0d7e7f7ccad$var$ReactPullToRefresh_default = $eb1cb0d7e7f7ccad$var$ReactPullToRefresh;
// src/index.ts
var $eb1cb0d7e7f7ccad$export$2e2bcd8739ae039 = $eb1cb0d7e7f7ccad$var$ReactPullToRefresh_default;






var $212dc5c137dc8449$export$34e0f9847d4c02dd;
var $212dc5c137dc8449$export$507a268628c86c47;
var $212dc5c137dc8449$export$f74d2570f0450935;
$212dc5c137dc8449$export$34e0f9847d4c02dd = `Kd8uta_container`;
$212dc5c137dc8449$export$507a268628c86c47 = `Kd8uta_loadMoreMessagesBanner`;
$212dc5c137dc8449$export$f74d2570f0450935 = `Kd8uta_messagesListContainer`;



var $bb3TF = parcelRequire("bb3TF");

var $6Sgv0 = parcelRequire("6Sgv0");

var $6fFrj = parcelRequire("6fFrj");



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

var $446481821ff0fa70$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($446481821ff0fa70$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $446481821ff0fa70$exports = g;
});




const { DownloadOutlined: $696fc3e59cc4a5eb$var$DownloadOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $696fc3e59cc4a5eb$var$DownloadFile = ({ getUrl: getUrl, url: url, name: name })=>{
    const { t: translation } = (0, $e3ea6dd032e45947$export$9fc83ad70ead8663)();
    const [downloadState, setDownloadState] = (0, $6fFrj.useState)(false);
    const [percentState, setPercentState] = (0, $6fFrj.useState)(0);
    const [error, setError] = (0, $6fFrj.useState)(null);
    const download = async ()=>{
        const uri = url || await getUrl();
        setDownloadState(true);
        (0, (/*@__PURE__*/$parcel$interopDefault($18ae57eea10fd4c8$exports))).get(uri, {
            responseType: 'blob',
            onDownloadProgress (e) {
                setPercentState(Math.ceil(e.loaded / e.total * 100));
            }
        }).then((response)=>{
            const file = new File([
                response.data
            ], name);
            (0, $446481821ff0fa70$exports.saveAs)(file, name);
            setDownloadState(false);
            setPercentState(0);
            setError(null);
        }).catch((err)=>{
            if (err) setError(translation('chat.downloadFile.error'));
        });
    };
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            downloadState && !error && (0, $bb3TF.jsx)("div", {
                children: (0, $bb3TF.jsx)((0, $35ec803a48e00dda$export$2e2bcd8739ae039), {
                    percent: percentState,
                    size: "small"
                })
            }),
            !downloadState && !error && (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                type: "default",
                icon: (0, $bb3TF.jsx)($696fc3e59cc4a5eb$var$DownloadOutlined, {
                    style: {
                        marginLeft: 0
                    }
                }),
                size: "middle",
                onClick: download
            }),
            error && (0, $bb3TF.jsx)("p", {
                children: error
            })
        ]
    });
};
$696fc3e59cc4a5eb$var$DownloadFile.defaultProps = {
    getUrl: null,
    url: null
};
var $696fc3e59cc4a5eb$export$2e2bcd8739ae039 = $696fc3e59cc4a5eb$var$DownloadFile;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


const $f0a6eeada53c0a3a$var$status = {
    CANCELED: 'Canceled',
    COMPLETE: 'Complete',
    CONFIRMED: 'Confirmed',
    INCOMPLETE: 'Incomplete',
    RESCHEDULED: 'Rescheduled',
    SCHEDULED: 'Scheduled'
};
var $f0a6eeada53c0a3a$export$2e2bcd8739ae039 = $f0a6eeada53c0a3a$var$status;


/* eslint-disable */ 
var $6Sgv0 = parcelRequire("6Sgv0");
const $6b36d107d464791b$var$getLang = ()=>localStorage.getItem('lang') || 'en';
const $6b36d107d464791b$var$getMomentLocaleTime = (lang, time, utc = false)=>{
    const momentLocale = utc ? (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0))).utc(time) : (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(time);
    if (lang !== 'en') // const momentLang = require('moment/locale/es');
    // momentLocale.locale(lang, [momentLang]);
    momentLocale.locale(lang);
    let timeWithLocale = momentLocale.format('MMMM DD, YYYY h:mm a');
    // reset moment because makes a conflict with react-calendar
    (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0))).locale('en');
    if (lang === 'es') timeWithLocale = timeWithLocale.charAt(0).toUpperCase() + timeWithLocale.slice(1);
    return timeWithLocale;
};
const $6b36d107d464791b$export$5885c3efad9bd0aa = (time, utc = true)=>{
    const lang = $6b36d107d464791b$var$getLang();
    const timeFormat = $6b36d107d464791b$var$getMomentLocaleTime(lang, time, utc);
    if (time) return timeFormat;
    return '-';
};



var $53ce146fdd06569e$export$34e0f9847d4c02dd;
var $53ce146fdd06569e$export$f7e2c8231c57a8bd;
var $53ce146fdd06569e$export$df61b30b684217c0;
var $53ce146fdd06569e$export$cb60387f891ba74f;
var $53ce146fdd06569e$export$2ab9a8f9f1186f14;
$53ce146fdd06569e$export$34e0f9847d4c02dd = `Gh610q_container`;
$53ce146fdd06569e$export$f7e2c8231c57a8bd = `Gh610q_join`;
$53ce146fdd06569e$export$df61b30b684217c0 = `Gh610q_key`;
$53ce146fdd06569e$export$cb60387f891ba74f = `Gh610q_keyTitle`;
$53ce146fdd06569e$export$2ab9a8f9f1186f14 = `Gh610q_value`;


const $5e892c1027c718a8$var$Meeting = ({ meetingId: meetingId })=>{
    const [event, setEvent] = (0, $6fFrj.useState)();
    (0, $6fFrj.useEffect)(()=>{
        const getMeeting = async ()=>{
            const getEvent = await (0, (/*@__PURE__*/$parcel$interopDefault($18ae57eea10fd4c8$exports)))({
                method: 'GET',
                url: `${(0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).serverUrl}/events/meeting/${meetingId}`,
                headers: {
                    Authorization: 'Bearer '
                }
            });
            const appointment = getEvent.data && getEvent.data.length ? getEvent.data[0] : '';
            setEvent(appointment);
        };
        if (!event) getMeeting();
    }, [
        event,
        meetingId
    ]);
    if (!event) return null;
    return (0, $bb3TF.jsx)("div", {
        className: $53ce146fdd06569e$export$34e0f9847d4c02dd,
        children: !!event && (0, $bb3TF.jsxs)("div", {
            children: [
                event.title && (0, $bb3TF.jsx)("h3", {
                    children: event.title
                }),
                (0, $bb3TF.jsxs)("p", {
                    className: $53ce146fdd06569e$export$df61b30b684217c0,
                    children: [
                        (0, $bb3TF.jsx)("span", {
                            className: $53ce146fdd06569e$export$cb60387f891ba74f,
                            children: 'Status: '
                        }),
                        (0, $bb3TF.jsx)("span", {
                            className: $53ce146fdd06569e$export$2ab9a8f9f1186f14,
                            children: (0, $f0a6eeada53c0a3a$export$2e2bcd8739ae039)[event.status]
                        })
                    ]
                }),
                event.type && (0, $bb3TF.jsxs)("p", {
                    className: $53ce146fdd06569e$export$df61b30b684217c0,
                    children: [
                        (0, $bb3TF.jsx)("span", {
                            className: $53ce146fdd06569e$export$cb60387f891ba74f,
                            children: 'Type: '
                        }),
                        (0, $bb3TF.jsx)("span", {
                            className: $53ce146fdd06569e$export$2ab9a8f9f1186f14,
                            style: {
                                textTransform: 'capitalize'
                            },
                            children: event.type.toLowerCase()
                        })
                    ]
                }),
                (0, $bb3TF.jsxs)("p", {
                    className: $53ce146fdd06569e$export$df61b30b684217c0,
                    children: [
                        (0, $bb3TF.jsx)("span", {
                            className: $53ce146fdd06569e$export$cb60387f891ba74f,
                            children: 'Starts: '
                        }),
                        (0, $bb3TF.jsxs)("span", {
                            className: $53ce146fdd06569e$export$2ab9a8f9f1186f14,
                            children: [
                                (0, $6b36d107d464791b$export$5885c3efad9bd0aa)(event.startDate, false),
                                ' ',
                                "(",
                                (0, $5bafd68f69b44f55$export$c3133dbc11f66777)(event.startDate).short,
                                ")"
                            ]
                        })
                    ]
                }),
                (0, $bb3TF.jsxs)("p", {
                    className: $53ce146fdd06569e$export$df61b30b684217c0,
                    children: [
                        (0, $bb3TF.jsx)("span", {
                            className: $53ce146fdd06569e$export$cb60387f891ba74f,
                            children: 'Ends: '
                        }),
                        (0, $bb3TF.jsxs)("span", {
                            className: $53ce146fdd06569e$export$2ab9a8f9f1186f14,
                            children: [
                                (0, $6b36d107d464791b$export$5885c3efad9bd0aa)(event.endDate, false),
                                ' ',
                                "(",
                                (0, $5bafd68f69b44f55$export$c3133dbc11f66777)(event.endDate).short,
                                ")"
                            ]
                        })
                    ]
                }),
                event.notes && (0, $bb3TF.jsxs)("p", {
                    className: $53ce146fdd06569e$export$df61b30b684217c0,
                    children: [
                        (0, $bb3TF.jsx)("span", {
                            className: $53ce146fdd06569e$export$cb60387f891ba74f,
                            children: 'Notes: '
                        }),
                        (0, $bb3TF.jsx)("span", {
                            className: $53ce146fdd06569e$export$2ab9a8f9f1186f14,
                            children: event.notes
                        })
                    ]
                }),
                (!event.type || event.type === 'VIDEO') && (0, $bb3TF.jsx)("a", {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: $53ce146fdd06569e$export$f7e2c8231c57a8bd,
                    href: `${(0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).clientUrl}/videocall/${event.Meetings.name}?token=""`,
                    children: "Join"
                })
            ]
        }, event.id)
    });
};
var $5e892c1027c718a8$export$2e2bcd8739ae039 = $5e892c1027c718a8$var$Meeting;


var $26b66ffdd720f52c$export$2bffbc4d4541de20;
var $26b66ffdd720f52c$export$63c5fb9341bcae5;
var $26b66ffdd720f52c$export$2c3955e5feb750b0;
var $26b66ffdd720f52c$export$a8ecead220dd38a6;
var $26b66ffdd720f52c$export$1412f20dbe0dee69;
var $26b66ffdd720f52c$export$5e1486cbcd342ae1;
var $26b66ffdd720f52c$export$defe85febe8b728c;
var $26b66ffdd720f52c$export$d380c85d745fc35c;
var $26b66ffdd720f52c$export$673a9da4c135e0b2;
var $26b66ffdd720f52c$export$6f093cfa640b7166;
var $26b66ffdd720f52c$export$228a56732285e980;
var $26b66ffdd720f52c$export$fbb02878cfa2996d;
var $26b66ffdd720f52c$export$94e4009ecfbf7408;
var $26b66ffdd720f52c$export$63f9a1d01477b97;
$26b66ffdd720f52c$export$2bffbc4d4541de20 = `kreF3G_containerNext`;
$26b66ffdd720f52c$export$63c5fb9341bcae5 = `kreF3G_fromName`;
$26b66ffdd720f52c$export$2c3955e5feb750b0 = `kreF3G_loadingFile`;
$26b66ffdd720f52c$export$a8ecead220dd38a6 = `kreF3G_message`;
$26b66ffdd720f52c$export$1412f20dbe0dee69 = `kreF3G_messageDate`;
$26b66ffdd720f52c$export$5e1486cbcd342ae1 = `kreF3G_messageMine`;
$26b66ffdd720f52c$export$defe85febe8b728c = `kreF3G_messages`;
$26b66ffdd720f52c$export$d380c85d745fc35c = `kreF3G_nameFile`;
$26b66ffdd720f52c$export$673a9da4c135e0b2 = `kreF3G_nameMine`;
$26b66ffdd720f52c$export$6f093cfa640b7166 = `kreF3G_text`;
$26b66ffdd720f52c$export$228a56732285e980 = `kreF3G_textMine`;
$26b66ffdd720f52c$export$fbb02878cfa2996d = `kreF3G_textsms`;
$26b66ffdd720f52c$export$94e4009ecfbf7408 = `kreF3G_userInfo`;
$26b66ffdd720f52c$export$63f9a1d01477b97 = `kreF3G_userInfoMine`;


const { FileOutlined: $81d5b66e9494594f$var$FileOutlined, UserOutlined: $81d5b66e9494594f$var$UserOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $81d5b66e9494594f$var$Message = ({ message: message, attachment: attachment, last: last, mine: mine, name: name, createdAt: createdAt, readDate: readDate, isSms: isSms, id: id })=>{
    const attach = attachment ? JSON.parse(attachment) : null;
    const newMessage = message ? message.trimEnd() : '';
    const [urlS3File] = (0, $edf372aa0dea9531$export$4747d4e17950f93f)();
    const [loading, setLoading] = (0, $6fFrj.useState)(false);
    const getLinkFile = async (s3key)=>{
        setLoading(true);
        const { data: data } = await urlS3File({
            variables: {
                s3Key: s3key,
                messageId: id
            }
        });
        setLoading(false);
        return data.downloadFile.signedUrl;
    };
    const openFile = async (s3key)=>{
        const url = await getLinkFile(s3key);
        window.open(url, '_blank');
    };
    return (0, $bb3TF.jsx)("div", {
        className: $26b66ffdd720f52c$export$defe85febe8b728c,
        children: (0, $bb3TF.jsxs)("div", {
            className: `${$26b66ffdd720f52c$export$a8ecead220dd38a6} ${mine ? $26b66ffdd720f52c$export$5e1486cbcd342ae1 : ''}`,
            children: [
                (0, $bb3TF.jsxs)("div", {
                    className: `${$26b66ffdd720f52c$export$94e4009ecfbf7408}`,
                    children: [
                        !mine && (0, $bb3TF.jsx)((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                            size: 25,
                            icon: (0, $bb3TF.jsx)($81d5b66e9494594f$var$UserOutlined, {})
                        }),
                        (0, $bb3TF.jsx)("p", {
                            className: `${$26b66ffdd720f52c$export$63c5fb9341bcae5} ${mine ? $26b66ffdd720f52c$export$673a9da4c135e0b2 : ''}`,
                            children: name
                        }),
                        mine && (0, $bb3TF.jsx)((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                            size: 25,
                            icon: (0, $bb3TF.jsx)($81d5b66e9494594f$var$UserOutlined, {})
                        })
                    ]
                }),
                attach && (0, $bb3TF.jsxs)("div", {
                    className: `${$26b66ffdd720f52c$export$6f093cfa640b7166} ${mine ? $26b66ffdd720f52c$export$228a56732285e980 : ''}`,
                    children: [
                        (0, $bb3TF.jsxs)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                            type: "link",
                            size: "middle",
                            target: "_blank",
                            style: {
                                width: '100%'
                            },
                            onClick: ()=>openFile(attach.s3key),
                            children: [
                                (0, $bb3TF.jsx)($81d5b66e9494594f$var$FileOutlined, {}),
                                (0, $bb3TF.jsx)("span", {
                                    className: $26b66ffdd720f52c$export$d380c85d745fc35c,
                                    children: attach.name.length > 30 ? `${attach.name.substring(0, 27)}...` : attach.name
                                })
                            ]
                        }),
                        (0, $bb3TF.jsx)("br", {}),
                        (0, $bb3TF.jsx)((0, $696fc3e59cc4a5eb$export$2e2bcd8739ae039), {
                            getUrl: async ()=>getLinkFile(attach.s3key),
                            name: attach.name
                        }),
                        loading && (0, $bb3TF.jsx)("div", {
                            className: $26b66ffdd720f52c$export$2c3955e5feb750b0,
                            children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                                size: "small"
                            })
                        })
                    ]
                }),
                !attach && // eslint-disable-next-line no-nested-ternary
                (newMessage.includes('#{meetingId}=') ? (0, $bb3TF.jsx)((0, $5e892c1027c718a8$export$2e2bcd8739ae039), {
                    meetingId: Number(newMessage.split('=')[1])
                }) : isSms ? (0, $bb3TF.jsx)("p", {
                    className: $26b66ffdd720f52c$export$fbb02878cfa2996d,
                    children: newMessage
                }) : (0, $bb3TF.jsx)("p", {
                    className: $26b66ffdd720f52c$export$6f093cfa640b7166,
                    children: newMessage
                })),
                !isSms ? (0, $bb3TF.jsxs)("p", {
                    className: $26b66ffdd720f52c$export$1412f20dbe0dee69,
                    children: [
                        (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(createdAt).format('MMM Do, YYYY, h:mma'),
                        ' ',
                        "Email / Chat"
                    ]
                }) : (0, $bb3TF.jsxs)("p", {
                    className: $26b66ffdd720f52c$export$1412f20dbe0dee69,
                    children: [
                        (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(createdAt).format('MMM Do, YYYY, h:mma'),
                        ' ',
                        "SMS"
                    ]
                })
            ]
        })
    });
};
$81d5b66e9494594f$var$Message.defaultProps = {
    readDate: null
};
var $81d5b66e9494594f$export$2e2bcd8739ae039 = $81d5b66e9494594f$var$Message;



const $280103257f12a09e$var$LoadingIndicator = ()=>(0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        justify: "center",
        children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {})
    });
const $280103257f12a09e$var$MessagesList = ({ channelId: channelId, data: data })=>{
    const { userId: userId } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$ca779d385d6ad982));
    const { t: translation } = (0, $e3ea6dd032e45947$export$9fc83ad70ead8663)();
    const messagesListContainerRef = (0, $6fFrj.useRef)(null);
    const messagesEndRef = (0, $6fFrj.useRef)(null);
    const { getMoreMessages: getMoreMessages, loadingMoreMessages: loadingMoreMessages, currentChannel: currentChannel } = (0, $0dff5878e5b80cbb$export$2e2bcd8739ae039)(false);
    const [lastMessage, setLastMessage] = (0, $6fFrj.useState)(null);
    const scrollToBottom = ()=>{
        setTimeout(()=>{
            messagesEndRef?.current?.scrollIntoView({
                behavior: 'smooth'
            });
        }, 200);
    };
    const loadMoreData = async ()=>{
        if (loadingMoreMessages) return;
        // Record the current scroll position and the height of the messages container before loading new messages
        const currentScrollPosition = messagesListContainerRef.current?.scrollTop ?? 0;
        const currentContainerHeight = messagesListContainerRef.current?.scrollHeight ?? 0;
        await getMoreMessages(channelId, 10);
        // After new messages have been loaded and rendered, adjust the scroll position
        requestAnimationFrame(()=>{
            const newContainerHeight = messagesListContainerRef.current?.scrollHeight ?? 0;
            const heightDifference = newContainerHeight - currentContainerHeight;
            if (messagesListContainerRef.current) messagesListContainerRef.current.scrollTop = currentScrollPosition + heightDifference;
        });
    };
    const getInitialMessagesAndScroll = async ()=>{
        await loadMoreData();
        scrollToBottom();
    };
    (0, $6fFrj.useEffect)(()=>{
        scrollToBottom();
        if (!data || data.length < 10) getInitialMessagesAndScroll();
    }, [
        currentChannel.id
    ]);
    // if data increments up by one, scroll to bottom (most likly a new message came in or a message was sent)
    (0, $6fFrj.useEffect)(()=>{
        if (data && data?.length > 0) {
            // if the previous last message is now the second to last message, scroll to bottom
            if (data[data.length - 2]?.id === lastMessage?.id) scrollToBottom();
            setLastMessage(data[data.length - 1]);
        }
    }, [
        data?.length
    ]);
    return (0, $bb3TF.jsx)("div", {
        className: $212dc5c137dc8449$export$f74d2570f0450935,
        ref: messagesListContainerRef,
        children: (0, $bb3TF.jsxs)((0, $eb1cb0d7e7f7ccad$export$2e2bcd8739ae039), {
            loading: loadingMoreMessages,
            onRefresh: loadMoreData,
            style: {
                textAlign: 'center'
            },
            icon: (0, $bb3TF.jsx)($280103257f12a09e$var$LoadingIndicator, {}),
            children: [
                loadingMoreMessages ? (0, $bb3TF.jsx)($280103257f12a09e$var$LoadingIndicator, {}) : (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    className: $212dc5c137dc8449$export$507a268628c86c47,
                    onClick: loadMoreData,
                    children: (0, $bb3TF.jsx)("span", {
                        children: "Load more messages"
                    })
                }),
                data?.map((item, index)=>{
                    const { firstName: firstName, lastName: lastName } = item.Users?.UserInformation ?? {
                        firstName: '',
                        lastName: ''
                    };
                    return (0, $bb3TF.jsx)((0, $81d5b66e9494594f$export$2e2bcd8739ae039), {
                        message: item.text,
                        readDate: item.readDate,
                        attachment: item.attachment,
                        mine: userId === item.userId,
                        last: data.length === index + 1,
                        name: `${firstName} ${lastName}`,
                        createdAt: new Date(item.createAt),
                        isSms: item.isSms,
                        id: item.id
                    }, `message-${item.id}`);
                }),
                (0, $bb3TF.jsx)("div", {
                    ref: messagesEndRef
                })
            ]
        })
    });
};
var $280103257f12a09e$export$2e2bcd8739ae039 = $280103257f12a09e$var$MessagesList;


var $600639792fbf5169$export$89da14300d534261;
var $600639792fbf5169$export$87bfb40f4cb4c134;
var $600639792fbf5169$export$6df35b2c8a3a5c37;
var $600639792fbf5169$export$f227e1d996b5c192;
var $600639792fbf5169$export$414d047e665c7112;
var $600639792fbf5169$export$3cc0745d3805c612;
var $600639792fbf5169$export$c8ec86fb9e1c0123;
var $600639792fbf5169$export$a8ff84c12d48cfa6;
var $600639792fbf5169$export$737bb88445849921;
$600639792fbf5169$export$89da14300d534261 = `gzKdQW_active`;
$600639792fbf5169$export$87bfb40f4cb4c134 = `gzKdQW_chatAdminBadge`;
$600639792fbf5169$export$6df35b2c8a3a5c37 = `gzKdQW_chatAdminContainer`;
$600639792fbf5169$export$f227e1d996b5c192 = `gzKdQW_chatAdminHeader`;
$600639792fbf5169$export$414d047e665c7112 = `gzKdQW_contact`;
$600639792fbf5169$export$3cc0745d3805c612 = `gzKdQW_infocont`;
$600639792fbf5169$export$c8ec86fb9e1c0123 = `gzKdQW_infotextcont`;
$600639792fbf5169$export$a8ff84c12d48cfa6 = `gzKdQW_name`;
$600639792fbf5169$export$737bb88445849921 = `gzKdQW_organization`;


const { MailOutlined: $5d32962ef7d56830$var$MailOutlined, MobileTwoTone: $5d32962ef7d56830$var$MobileTwoTone } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Link: $5d32962ef7d56830$var$Link } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $5d32962ef7d56830$var$getAcronim = (str)=>{
    if (!str || str === '') return '';
    const matches = str.match(/\b(\w)/g);
    const acronym = matches?.join('');
    return acronym?.substring(0, 2).toUpperCase();
};
const $5d32962ef7d56830$var$Chat = ({ channelInfo: channelInfo })=>{
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const { userId: currentUserId, accessToken: token } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$ca779d385d6ad982));
    const currentChannels = (0, $58073eff19365823$export$a7347740d65f620b)((0, $66a7cecdd31d321f$export$2656785094d54bbd));
    const { t: translation } = (0, $e3ea6dd032e45947$export$9fc83ad70ead8663)();
    const [updateMessages] = (0, $4cdb1470f9874f96$export$596c9d4fd6befeaa)();
    console.log('changed channel info', channelInfo);
    const { addChannel: addChannel, messages: messages } = (0, $0dff5878e5b80cbb$export$2e2bcd8739ae039)(false);
    (0, $6fFrj.useEffect)(()=>{
        addChannel(channelInfo);
    }, [
        channelInfo
    ]);
    const [sendChatMesage, { loading: loadingSendMessage }] = (0, $4cdb1470f9874f96$export$db0dd0b0b10ee214)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message, 10)
    });
    const onSendMessage = async (sendMessageObj)=>{
        // const val = sendMessageObj.text?.trim();
        if (sendMessageObj?.text || sendMessageObj.attachment) {
            const messageRes = await sendChatMesage({
                variables: {
                    createMessageInput: {
                        channelId: channelInfo.id,
                        text: sendMessageObj?.text,
                        attachment: sendMessageObj.attachment,
                        phone: sendMessageObj.phone
                    }
                }
            });
        // console.log("onSendMessage", messageRes);
        }
    };
    if (!channelInfo) return null;
    const numberRender = ()=>{
        const channelMember = channelInfo.ChannelMembers?.find(({ userId: userId })=>userId !== currentUserId);
        let phone = '';
        let email = '';
        if (channelMember) {
            const { email: userEmail } = channelMember.Users;
            const { Phones: Phones } = channelMember.Users.UserInformation;
            phone = Phones?.find((p)=>p.type === (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Mobile)?.value || Phones?.[0]?.value || '';
            email = userEmail;
        }
        return (0, $bb3TF.jsxs)("p", {
            className: $600639792fbf5169$export$414d047e665c7112,
            children: [
                Boolean(phone) && (0, $bb3TF.jsxs)("a", {
                    href: `tel:${phone}`,
                    children: [
                        (0, $bb3TF.jsx)($5d32962ef7d56830$var$MobileTwoTone, {
                            style: {
                                margin: '5px'
                            }
                        }),
                        phone
                    ]
                }),
                Boolean(email) && (0, $bb3TF.jsxs)("a", {
                    href: `mailto:${email}`,
                    target: "_blank",
                    rel: "noreferrer",
                    children: [
                        (0, $bb3TF.jsx)($5d32962ef7d56830$var$MailOutlined, {
                            style: {
                                margin: '5px'
                            }
                        }),
                        email
                    ]
                })
            ]
        });
    };
    const getChatName = ()=>{
        const otherMember = channelInfo.ChannelMembers?.find(({ userId: userId })=>userId !== currentUserId);
        if (otherMember) {
            const { firstName: firstName, lastName: lastName } = otherMember.Users.UserInformation || {};
            if (`${firstName} ${lastName}` !== channelInfo.description) return `${firstName} ${lastName}`;
            return channelInfo.description;
        }
        return '';
    };
    const getUserEntityId = ()=>{
        const otherMember = channelInfo.ChannelMembers?.find(({ userId: userId })=>userId !== currentUserId);
        if (otherMember) return otherMember.Users.Entity?.id;
        return null;
    };
    const getUserDetailTopCenter = ()=>{
        const channelMember = channelInfo.ChannelMembers?.find(({ userId: userId })=>userId !== currentUserId);
        return (0, $bb3TF.jsxs)("div", {
            className: $600639792fbf5169$export$f227e1d996b5c192,
            children: [
                (0, $bb3TF.jsx)("span", {
                    children: (0, $bb3TF.jsx)((0, $0e541b76c0e3ec69$export$2e2bcd8739ae039), {
                        dot: true,
                        className: $600639792fbf5169$export$87bfb40f4cb4c134,
                        color: channelInfo.status ? 'green' : 'gray',
                        children: (0, $bb3TF.jsx)((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                            style: {
                                backgroundColor: '#22A7E7'
                            },
                            size: 50,
                            children: $5d32962ef7d56830$var$getAcronim(getChatName())
                        })
                    })
                }),
                (0, $bb3TF.jsxs)("div", {
                    className: $600639792fbf5169$export$c8ec86fb9e1c0123,
                    children: [
                        (0, $bb3TF.jsx)($5d32962ef7d56830$var$Link, {
                            className: $600639792fbf5169$export$a8ff84c12d48cfa6,
                            href: `/clients/details?entityId=${getUserEntityId()}`,
                            children: getChatName()
                        }),
                        numberRender(),
                        (0, $bb3TF.jsx)("p", {
                            className: $600639792fbf5169$export$89da14300d534261
                        })
                    ]
                })
            ]
        });
    };
    (0, $6fFrj.useEffect)(()=>{
        const updateMessagesInput = [
            ...channelInfo.Messages ?? []
        ].filter(({ userId: userId, readDate: readDate })=>userId !== currentUserId && !readDate).map(({ id: id })=>({
                id: id,
                readDate: new Date()
            }));
        if (updateMessagesInput.length) updateMessages({
            variables: {
                updateMessagesInput: updateMessagesInput
            }
        }).then(({ data: data })=>{
            dispatch((0, $66a7cecdd31d321f$export$a142660abc388412)(currentChannels.map((channel)=>{
                if (channel.id === channelInfo?.id) return {
                    ...channel,
                    Messages: channelInfo.Messages.map((m)=>{
                        const currentMessage = data.updateMessages.find(({ id: currentId })=>m.id === currentId);
                        if (currentMessage) return currentMessage;
                        return currentMessage;
                    })
                };
                return channel;
            })));
        }).catch((error)=>console.log({
                error: error
            }));
    }, []);
    return (0, $bb3TF.jsxs)("div", {
        className: $600639792fbf5169$export$6df35b2c8a3a5c37,
        children: [
            getUserDetailTopCenter(),
            messages[channelInfo.id]?.length === 0 ? (0, $bb3TF.jsx)((0, $e6674a76e6c92256$export$2e2bcd8739ae039), {}) : (0, $bb3TF.jsx)((0, $280103257f12a09e$export$2e2bcd8739ae039), {
                data: messages[channelInfo.id],
                channelId: channelInfo.id
            }),
            (0, $bb3TF.jsx)((0, $2489f4ddccd93bd7$export$2e2bcd8739ae039), {
                // channelId={channelInfo.id}
                onSendMessage: onSendMessage,
                clientData: channelInfo.ChannelMembers?.find(({ userId: userId })=>userId !== currentUserId)?.Users.UserInformation,
                loadingSendMessage: loadingSendMessage
            })
        ]
    });
};
var $5d32962ef7d56830$export$2e2bcd8739ae039 = $5d32962ef7d56830$var$Chat;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");






var $c63e1ae15bac0909$export$2df4967279ed66b1;
$c63e1ae15bac0909$export$2df4967279ed66b1 = `Orfp8G_chatListContainer`;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




var $6fFrj = parcelRequire("6fFrj");
const $ad3306746e490c84$var$useDebouncedEffect = (effect, delay, deps)=>{
    (0, $6fFrj.useEffect)(()=>{
        const handler = setTimeout(()=>effect(), delay);
        return ()=>clearTimeout(handler);
    }, [
        ...deps ?? [],
        delay
    ]);
};
var $ad3306746e490c84$export$2e2bcd8739ae039 = $ad3306746e490c84$var$useDebouncedEffect;







var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");

var $7e4c8476b9178f53$export$4aebd143f31d0c0d;
var $7e4c8476b9178f53$export$45180eb484e58521;
var $7e4c8476b9178f53$export$227caaa358a78e36;
var $7e4c8476b9178f53$export$2008dcf65cdc1746;
var $7e4c8476b9178f53$export$5a2461f390a177a4;
var $7e4c8476b9178f53$export$85b9a36db797e02b;
var $7e4c8476b9178f53$export$324d90190a8b822a;
var $7e4c8476b9178f53$export$a8ecead220dd38a6;
var $7e4c8476b9178f53$export$a8ff84c12d48cfa6;
$7e4c8476b9178f53$export$4aebd143f31d0c0d = `Z6HQyG_badge`;
$7e4c8476b9178f53$export$45180eb484e58521 = `Z6HQyG_channelChatContainer`;
$7e4c8476b9178f53$export$227caaa358a78e36 = `Z6HQyG_containeLastSeen`;
$7e4c8476b9178f53$export$2008dcf65cdc1746 = `Z6HQyG_containerData`;
$7e4c8476b9178f53$export$5a2461f390a177a4 = `Z6HQyG_containerSelect`;
$7e4c8476b9178f53$export$85b9a36db797e02b = `Z6HQyG_count`;
$7e4c8476b9178f53$export$324d90190a8b822a = `Z6HQyG_date`;
$7e4c8476b9178f53$export$a8ecead220dd38a6 = `Z6HQyG_message`;
$7e4c8476b9178f53$export$a8ff84c12d48cfa6 = `Z6HQyG_name`;


const { Text: $b1dd6ef5a89a597b$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $b1dd6ef5a89a597b$var$getAcronim = (str)=>{
    const matches = str.match(/\b(\w)/g);
    const acronym = matches?.join('');
    return acronym?.substring(0, 2).toUpperCase();
};
const $b1dd6ef5a89a597b$var$ChatChannel = ({ data: data, onSelect: onSelect, isSelected: isSelected })=>{
    const { id: id, Entity: Entity, UserInformation: UserInformation, UserFirmAccount: UserFirmAccount } = data;
    const { firstName: firstName, lastName: lastName } = UserInformation ?? {
        firstName: '',
        lastName: ''
    };
    const { Roles: Roles } = (!Entity.UserFirmAccount.length ? UserFirmAccount.find(({ userId: userId })=>userId === id) : Entity.UserFirmAccount.find(({ Entity: firmEntity })=>firmEntity.Users.id === id)) ?? {
        Roles: {
            description: ''
        }
    };
    // eslint-disable-next-line max-len
    // TODO when the integration of sending messages is ready set this variable since this component is used in ChatList component
    // Messages.length > 0 ? moment(Messages[Messages.length - 1].updatedAt).fromNow() :
    const lastMessage = '';
    // ClientInterviews[0] && ClientInterviews[0].interviewForm
    // ? ClientInterviews[0].interviewForm.taxpayer_occupation
    // :
    // eslint-disable-next-line max-len
    // TODO: When integrating the change of "occupation" in the UserInformation table adjust the value of this variable
    const occupation = Roles?.description ?? '';
    const selectConversation = ()=>{
        onSelect(id);
    };
    // selectedConversation ? styles.containerSelect :
    return (0, $bb3TF.jsxs)("div", {
        className: isSelected ? $7e4c8476b9178f53$export$5a2461f390a177a4 : $7e4c8476b9178f53$export$45180eb484e58521,
        onClick: selectConversation,
        onKeyDown: selectConversation,
        role: "button",
        tabIndex: 0,
        children: [
            (0, $bb3TF.jsx)((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                style: {
                    backgroundColor: '#22A7E7'
                },
                size: 40,
                children: $b1dd6ef5a89a597b$var$getAcronim(`${firstName} ${lastName}`)
            }),
            (0, $bb3TF.jsxs)("div", {
                className: $7e4c8476b9178f53$export$2008dcf65cdc1746,
                children: [
                    (0, $bb3TF.jsx)($b1dd6ef5a89a597b$var$Text, {
                        className: $7e4c8476b9178f53$export$a8ff84c12d48cfa6,
                        children: `${firstName} ${lastName}`
                    }),
                    (0, $bb3TF.jsx)($b1dd6ef5a89a597b$var$Text, {
                        className: $7e4c8476b9178f53$export$a8ecead220dd38a6,
                        children: occupation
                    })
                ]
            }),
            lastMessage !== '' && (0, $bb3TF.jsxs)("div", {
                className: $7e4c8476b9178f53$export$227caaa358a78e36,
                children: [
                    (0, $bb3TF.jsx)($b1dd6ef5a89a597b$var$Text, {
                        className: $7e4c8476b9178f53$export$a8ff84c12d48cfa6,
                        children: "Last Seen"
                    }),
                    (0, $bb3TF.jsx)($b1dd6ef5a89a597b$var$Text, {
                        className: $7e4c8476b9178f53$export$a8ecead220dd38a6,
                        children: lastMessage
                    })
                ]
            })
        ]
    });
};
var $b1dd6ef5a89a597b$export$2e2bcd8739ae039 = $b1dd6ef5a89a597b$var$ChatChannel;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



var $26f8b9b37806d391$export$34e0f9847d4c02dd;
var $26f8b9b37806d391$export$1b8c99008cf8383b;
$26f8b9b37806d391$export$34e0f9847d4c02dd = `xy4itW_container`;
$26f8b9b37806d391$export$1b8c99008cf8383b = `xy4itW_noClientsContainer`;


var $06d00ff880045d32$exports = {};

$06d00ff880045d32$exports = (parcelRequire("jN93C")).getBundleURL('a0IFD') + "empty.a99e273d.png";


const { UserAddOutlined: $3e7cfef4d25fa8ac$var$UserAddOutlined, CloudUploadOutlined: $3e7cfef4d25fa8ac$var$CloudUploadOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $3e7cfef4d25fa8ac$var$EmptyState() {
    const [isAddClientModalVisible, setIsAddClientModalVisible] = (0, $6fFrj.useState)(false);
    const [isImportClientsModalVisible, setIsImportClientsModalVisible] = (0, $6fFrj.useState)(false);
    return (0, $bb3TF.jsxs)("div", {
        className: $26f8b9b37806d391$export$1b8c99008cf8383b,
        children: [
            (0, $bb3TF.jsx)("img", {
                alt: "Add Client",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($06d00ff880045d32$exports)))
            }),
            (0, $bb3TF.jsx)("p", {
                children: "You don't have any clients in Taxaroo yet"
            }),
            (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                children: [
                    (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        icon: (0, $bb3TF.jsx)($3e7cfef4d25fa8ac$var$UserAddOutlined, {}),
                        onClick: ()=>{
                            setIsAddClientModalVisible(true);
                        },
                        children: "Add Client"
                    }),
                    (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        icon: (0, $bb3TF.jsx)($3e7cfef4d25fa8ac$var$CloudUploadOutlined, {}),
                        onClick: ()=>{
                            setIsImportClientsModalVisible(true);
                        },
                        children: "Import Clients"
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $2d52d8d286e39b3a$export$2e2bcd8739ae039), {
                isModalVisible: isAddClientModalVisible,
                setIsModalVisible: setIsAddClientModalVisible
            }),
            (0, $bb3TF.jsx)((0, $618d19b065f8dace$export$2e2bcd8739ae039), {
                isModalVisible: isImportClientsModalVisible,
                setIsModalVisible: setIsImportClientsModalVisible
            })
        ]
    });
}
var $3e7cfef4d25fa8ac$export$2e2bcd8739ae039 = $3e7cfef4d25fa8ac$var$EmptyState;


var $178abc240b49d935$export$2f5f180525f32d9d;
var $178abc240b49d935$export$8837f4fc672e936d;
var $178abc240b49d935$export$3f0317fbdd1e5f23;
var $178abc240b49d935$export$254c4dbd519a3218;
var $178abc240b49d935$export$2e369703c743652b;
$178abc240b49d935$export$2f5f180525f32d9d = `_9UpStW_btnok`;
$178abc240b49d935$export$8837f4fc672e936d = `_9UpStW_list`;
$178abc240b49d935$export$3f0317fbdd1e5f23 = `_9UpStW_newConversationModal`;
$178abc240b49d935$export$254c4dbd519a3218 = `_9UpStW_searchUsersInput`;
$178abc240b49d935$export$2e369703c743652b = `_9UpStW_spinContainer`;


const { Search: $f4a8b1c8d23a1ea2$var$Search } = (0, $1fb834916a156dcf$export$2e2bcd8739ae039);
const $f4a8b1c8d23a1ea2$var$NewConversationModal = ({ visible: visible, handleCancel: handleCancel })=>{
    const firstRender = (0, $6fFrj.useRef)(true);
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const currentChannels = (0, $58073eff19365823$export$a7347740d65f620b)((0, $66a7cecdd31d321f$export$2656785094d54bbd));
    const { firmAccountId: firmAccountId, userId: userId } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$ca779d385d6ad982));
    const [selectedUserId, setSelectedUserId] = (0, $6fFrj.useState)('');
    const [channelSearch, setChannelSearch] = (0, $6fFrj.useState)('');
    const [createChannel, { loading: createChannelLoading }] = (0, $4cdb1470f9874f96$export$83907adc10805414)();
    const [findAllUsersInFirm, { data: usersInFirm, loading: usersInFirmLoading }] = (0, $f442d9dc730cd5f3$export$bf308f30d6ee1425)({
        fetchPolicy: 'no-cache'
    });
    const { addChannel: addChannel } = (0, $0dff5878e5b80cbb$export$2e2bcd8739ae039)(false);
    const onOk = async ()=>{
        try {
            const { firstName: firstName, lastName: lastName } = usersInFirm?.findAllUsersInFirm?.find(({ id: id })=>id === selectedUserId)?.UserInformation ?? {
                UserInformation: {
                    firstName: '',
                    lastName: ''
                }
            };
            const newChannel = (await createChannel({
                variables: {
                    createChannelInput: {
                        firmAccountId: firmAccountId,
                        currentUserId: userId,
                        userIdToConnect: selectedUserId,
                        description: `${firstName} ${lastName}`
                    }
                }
            })).data.createChannel;
            if (newChannel.id) {
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('The channel was created successfully!');
                addChannel(newChannel, true);
            }
            handleCancel();
            setSelectedUserId('');
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to create the channel');
        }
    };
    const handleSelectUser = (id)=>{
        setSelectedUserId((previousId)=>{
            if (previousId === id) return '';
            return id;
        });
    };
    (0, $6fFrj.useEffect)(()=>{
        const controller = new AbortController();
        findAllUsersInFirm({
            variables: {
                firmAccountId: firmAccountId
            }
        });
        return ()=>{
            controller.abort();
        };
    }, []);
    (0, $ad3306746e490c84$export$2e2bcd8739ae039)(()=>{
        const controller = new AbortController();
        if (firstRender.current) firstRender.current = false;
        else findAllUsersInFirm({
            variables: {
                firmAccountId: firmAccountId,
                searchWord: channelSearch
            }
        });
        return ()=>controller.abort();
    }, 500, [
        channelSearch
    ]);
    return (0, $bb3TF.jsxs)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        onOk: onOk,
        destroyOnClose: true,
        visible: visible,
        onCancel: handleCancel,
        title: "Start a conversation",
        okButtonProps: {
            className: $178abc240b49d935$export$2f5f180525f32d9d,
            disabled: !selectedUserId
        },
        wrappClassName: $178abc240b49d935$export$3f0317fbdd1e5f23,
        children: [
            (0, $bb3TF.jsx)($f4a8b1c8d23a1ea2$var$Search, {
                enterButton: null,
                value: channelSearch,
                className: $178abc240b49d935$export$254c4dbd519a3218,
                onChange: (value)=>{
                    setChannelSearch(value.currentTarget.value);
                },
                placeholder: "Search",
                onSearch: ()=>undefined,
                style: {
                    width: '100%',
                    marginBottom: 20
                }
            }),
            usersInFirmLoading || createChannelLoading ? (0, $bb3TF.jsx)("div", {
                className: $178abc240b49d935$export$2e369703c743652b,
                children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {})
            }) : (0, $bb3TF.jsx)("div", {
                children: !usersInFirm?.findAllUsersInFirm?.length ? (0, $bb3TF.jsx)((0, $3e7cfef4d25fa8ac$export$2e2bcd8739ae039), {}) : (0, $bb3TF.jsx)((0, $550318ddff00815a$export$2e2bcd8739ae039), {
                    // size="small"
                    header: (0, $bb3TF.jsx)("div", {}),
                    footer: (0, $bb3TF.jsx)("div", {}),
                    className: $178abc240b49d935$export$8837f4fc672e936d,
                    bordered: false,
                    dataSource: usersInFirm?.findAllUsersInFirm ?? [],
                    renderItem: (item)=>(0, $bb3TF.jsx)((0, $b1dd6ef5a89a597b$export$2e2bcd8739ae039), {
                            data: item,
                            onSelect: handleSelectUser,
                            isSelected: selectedUserId === item.id
                        })
                })
            })
        ]
    });
};
var $f4a8b1c8d23a1ea2$export$2e2bcd8739ae039 = $f4a8b1c8d23a1ea2$var$NewConversationModal;



var $bb3TF = parcelRequire("bb3TF");




var $6f9404b0f988b7cf$export$b29196939de3302d;
var $6f9404b0f988b7cf$export$629f6dbefe14c66e;
var $6f9404b0f988b7cf$export$34e0f9847d4c02dd;
var $6f9404b0f988b7cf$export$b346ae7c9d204e07;
$6f9404b0f988b7cf$export$b29196939de3302d = `_3KAP7G_channelListContainer`;
$6f9404b0f988b7cf$export$629f6dbefe14c66e = `_3KAP7G_channelsLoadingContainer`;
$6f9404b0f988b7cf$export$34e0f9847d4c02dd = `_3KAP7G_container`;
$6f9404b0f988b7cf$export$b346ae7c9d204e07 = `_3KAP7G_loadMore`;



var $bb3TF = parcelRequire("bb3TF");

var $6Sgv0 = parcelRequire("6Sgv0");




var $43301d73d2b96876$export$b0b2a8f70ed2a994;
var $43301d73d2b96876$export$daa4245067390e78;
var $43301d73d2b96876$export$aab32f7a8d7f6880;
var $43301d73d2b96876$export$2008dcf65cdc1746;
var $43301d73d2b96876$export$85b9a36db797e02b;
var $43301d73d2b96876$export$324d90190a8b822a;
var $43301d73d2b96876$export$4c7897fafd92b108;
var $43301d73d2b96876$export$3d3e8577dcfe091e;
var $43301d73d2b96876$export$a8ff84c12d48cfa6;
var $43301d73d2b96876$export$d90250155de6d7e7;
$43301d73d2b96876$export$b0b2a8f70ed2a994 = `PiY5fa_chatChannelBadge`;
$43301d73d2b96876$export$daa4245067390e78 = `PiY5fa_chatChannelContainer`;
$43301d73d2b96876$export$aab32f7a8d7f6880 = `PiY5fa_containerBadge`;
$43301d73d2b96876$export$2008dcf65cdc1746 = `PiY5fa_containerData`;
$43301d73d2b96876$export$85b9a36db797e02b = `PiY5fa_count`;
$43301d73d2b96876$export$324d90190a8b822a = `PiY5fa_date`;
$43301d73d2b96876$export$4c7897fafd92b108 = `PiY5fa_last`;
$43301d73d2b96876$export$3d3e8577dcfe091e = `PiY5fa_lastMessage`;
$43301d73d2b96876$export$a8ff84c12d48cfa6 = `PiY5fa_name`;
$43301d73d2b96876$export$d90250155de6d7e7 = `PiY5fa_selected`;


const { Text: $c87076e4791e8240$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $c87076e4791e8240$var$getAcronim = (str)=>{
    const matches = str.match(/\b(\w)/g);
    const acronym = matches?.join('');
    return acronym?.substring(0, 2).toUpperCase();
};
const $c87076e4791e8240$var$ChatChannel = ({ data: data, setChannel: setChannel, selected: selected })=>{
    const { userId: currentUserId } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$ca779d385d6ad982));
    const { ChannelMembers: ChannelMembers, online: online } = data;
    const { messages: messagesObj } = (0, $0dff5878e5b80cbb$export$2e2bcd8739ae039)(false);
    const messages = messagesObj[data.id] || [];
    const date = ()=>{
        if (messages.length <= 0) return '';
        if (!messages[messages.length - 1]) return '';
        const { createAt: createAt } = messages[messages.length - 1];
        const dateMoment = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(createAt);
        return dateMoment.fromNow();
    };
    const lastMessage = ()=>{
        if (messages.length <= 0) return '';
        if (!messages[messages.length - 1]) return '';
        const { text: text } = messages[messages.length - 1];
        if (text === null) return '';
        if (text.includes('#{meetingId}=')) return '#Incoming meeting';
        return text.split('~#*')[0];
    };
    const getStatusConnection = ()=>online ? 'green' : 'gray';
    const selectChannel = ()=>{
        setChannel(data.id);
    };
    const getChatName = ()=>{
        const otherMember = ChannelMembers.find(({ userId: userId })=>userId !== currentUserId);
        if (otherMember) {
            const { firstName: firstName, lastName: lastName } = otherMember.Users.UserInformation || {};
            if (`${firstName} ${lastName}` !== data.description) return `${firstName} ${lastName}`;
            return data.description;
        }
        return '';
    };
    return (0, $bb3TF.jsxs)("div", {
        className: `${$43301d73d2b96876$export$daa4245067390e78} ${selected && $43301d73d2b96876$export$d90250155de6d7e7}`,
        onClick: selectChannel,
        onKeyDown: selectChannel,
        role: "button",
        tabIndex: 0,
        children: [
            (0, $bb3TF.jsx)((0, $0e541b76c0e3ec69$export$2e2bcd8739ae039), {
                dot: true,
                className: $43301d73d2b96876$export$b0b2a8f70ed2a994,
                color: getStatusConnection(),
                children: (0, $bb3TF.jsx)((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                    style: {
                        backgroundColor: '#22A7E7'
                    },
                    size: 50,
                    children: $c87076e4791e8240$var$getAcronim(getChatName())
                })
            }),
            (0, $bb3TF.jsxs)("div", {
                className: $43301d73d2b96876$export$2008dcf65cdc1746,
                children: [
                    (0, $bb3TF.jsx)($c87076e4791e8240$var$Text, {
                        className: $43301d73d2b96876$export$a8ff84c12d48cfa6,
                        children: getChatName()
                    }),
                    (0, $bb3TF.jsx)("div", {
                        className: $43301d73d2b96876$export$4c7897fafd92b108,
                        children: (0, $bb3TF.jsx)($c87076e4791e8240$var$Text, {
                            ellipsis: true,
                            className: $43301d73d2b96876$export$3d3e8577dcfe091e,
                            style: {
                                ...messages[messages.length - 1]?.userId !== currentUserId && !messages[messages.length - 1]?.readDate ? {
                                    fontWeight: 'bold'
                                } : {}
                            },
                            children: lastMessage()
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)($c87076e4791e8240$var$Text, {
                className: $43301d73d2b96876$export$324d90190a8b822a,
                children: date()
            })
        ]
    });
};
var $c87076e4791e8240$export$2e2bcd8739ae039 = $c87076e4791e8240$var$ChatChannel;


const $7ec8a14e44c9c1e4$var$ChatChannelsList = ()=>{
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const { loadingChannels: loadingChannels, channels: currentChannels, currentChannel: currentSelectedChannel, messages: messages, getMoreChannels: getMoreChannels } = (0, $0dff5878e5b80cbb$export$2e2bcd8739ae039)(true);
    const selectChannelHandler = (channelId)=>{
        const selectedChannel = currentChannels.find(({ id: id })=>id === channelId);
        dispatch((0, $66a7cecdd31d321f$export$705c7bcc3db528a6)(selectedChannel));
    };
    const handleLoadMoreChannels = ()=>{
        getMoreChannels();
    };
    return (0, $bb3TF.jsx)("div", {
        className: $6f9404b0f988b7cf$export$b29196939de3302d,
        children: loadingChannels ? (0, $bb3TF.jsxs)("div", {
            className: $6f9404b0f988b7cf$export$629f6dbefe14c66e,
            children: [
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "center",
                    children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                        size: "large",
                        style: {
                            marginTop: 60
                        }
                    })
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "center",
                    style: {
                        marginTop: 40
                    },
                    children: "Taxaroo messages are loading."
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    style: {
                        maxWidth: '260px',
                        padding: '20px 10px 0 10px'
                    },
                    children: "Hang tight, this could take a couple of minutes the first time it loads in your session."
                })
            ]
        }) : (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
            children: [
                (0, $bb3TF.jsx)((0, $550318ddff00815a$export$2e2bcd8739ae039), {
                    size: "small",
                    header: (0, $bb3TF.jsx)("div", {}),
                    footer: (0, $bb3TF.jsx)("div", {}),
                    bordered: false,
                    dataSource: currentChannels?.filter((ch)=>messages[ch.id]?.length > 0 || ch.id === currentSelectedChannel?.id) ?? [],
                    loading: loadingChannels,
                    locale: {
                        emptyText: (0, $bb3TF.jsx)((0, $9150234f0969a884$export$2e2bcd8739ae039), {
                            description: "No conversations yet"
                        })
                    },
                    renderItem: (item)=>(0, $bb3TF.jsx)((0, $c87076e4791e8240$export$2e2bcd8739ae039), {
                            data: item,
                            setChannel: selectChannelHandler,
                            selected: currentSelectedChannel?.id === item.id
                        })
                }),
                currentChannels.length > 0 && (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    className: $6f9404b0f988b7cf$export$b346ae7c9d204e07,
                    onClick: handleLoadMoreChannels,
                    type: "link",
                    loading: loadingChannels,
                    children: "Load more"
                })
            ]
        })
    });
};
var $7ec8a14e44c9c1e4$export$2e2bcd8739ae039 = $7ec8a14e44c9c1e4$var$ChatChannelsList;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");





var $8e4ec893290b7e96$export$c3e41a94e138d914;
var $8e4ec893290b7e96$export$a3fd2b33dc412d3a;
var $8e4ec893290b7e96$export$717ad4d65f080d4d;
var $8e4ec893290b7e96$export$b7e3ae3d7c15e42e;
var $8e4ec893290b7e96$export$fb184b623420d9be;
$8e4ec893290b7e96$export$c3e41a94e138d914 = `NjG7wq_addbtn`;
$8e4ec893290b7e96$export$a3fd2b33dc412d3a = `NjG7wq_chatSelectorContainer`;
$8e4ec893290b7e96$export$717ad4d65f080d4d = `NjG7wq_containerTop`;
$8e4ec893290b7e96$export$b7e3ae3d7c15e42e = `NjG7wq_input`;
$8e4ec893290b7e96$export$fb184b623420d9be = `NjG7wq_title`;


const { Search: $37529603afae5c30$var$Search } = (0, $1fb834916a156dcf$export$2e2bcd8739ae039);
const $37529603afae5c30$var$ChatSelectorHeader = ({ showModal: showModal, setChannelSearch: setChannelSearch, channelSearch: channelSearch })=>{
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const firstRender = (0, $6fFrj.useRef)(true);
    const [getChannels, { loading: channelsLoading }] = (0, $f442d9dc730cd5f3$export$16b3d246f02b0323)({
        fetchPolicy: 'no-cache'
    });
    const handleNewConversationClick = ()=>{
        showModal();
    };
    (0, $ad3306746e490c84$export$2e2bcd8739ae039)(()=>{
        if (firstRender.current) firstRender.current = false;
        else getChannels({
            variables: {
                searchWord: channelSearch
            }
        }).then(({ data: data, error: error })=>{
            if (error) {
                console.warn('Error on getChannels.', error);
                return;
            }
            const { userChannels: userChannels } = data;
            dispatch((0, $66a7cecdd31d321f$export$705c7bcc3db528a6)(undefined));
            dispatch((0, $66a7cecdd31d321f$export$a142660abc388412)(userChannels));
        });
    }, 500, [
        channelSearch
    ]);
    return (0, $bb3TF.jsxs)("div", {
        className: $8e4ec893290b7e96$export$a3fd2b33dc412d3a,
        children: [
            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                style: {
                    fontSize: '12px'
                },
                className: $8e4ec893290b7e96$export$c3e41a94e138d914,
                onClick: handleNewConversationClick,
                type: "link",
                children: "+ New Conversation"
            }),
            (0, $bb3TF.jsx)($37529603afae5c30$var$Search, {
                value: channelSearch,
                className: $8e4ec893290b7e96$export$b7e3ae3d7c15e42e,
                placeholder: "Search",
                onChange: (value)=>{
                    setChannelSearch(value.currentTarget.value);
                },
                loading: channelsLoading,
                autoComplete: "off",
                type: "search"
            })
        ]
    });
};
var $37529603afae5c30$export$2e2bcd8739ae039 = $37529603afae5c30$var$ChatSelectorHeader;


const $96baf74e8cb9a0a4$var$ChatsList = ({ showModal: showModal, hideModal: hideModal, modalVisible: modalVisible })=>{
    const [channelSearch, setChannelSearch] = (0, $6fFrj.useState)('');
    const [createChannel, { loading: createChannelLoading }] = (0, $4cdb1470f9874f96$export$83907adc10805414)();
    const [searchParams, setSearchParams] = (0, $a6e470ffbc8d2470$export$f1a78c17382fe22a)();
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const { firmAccountId: firmAccountId, userId: userId } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$ca779d385d6ad982));
    const currentChannels = (0, $58073eff19365823$export$a7347740d65f620b)((0, $66a7cecdd31d321f$export$2656785094d54bbd));
    const { addChannel: addChannel } = (0, $0dff5878e5b80cbb$export$2e2bcd8739ae039)(false);
    const navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    const userToChatWith = searchParams.get('userToChatWith');
    const description = searchParams.get('description');
    const createChannelFromSearchParams = async (selectedUserId, channelDescription)=>{
        const newChannel = (await createChannel({
            variables: {
                createChannelInput: {
                    firmAccountId: firmAccountId,
                    currentUserId: userId,
                    userIdToConnect: selectedUserId,
                    description: channelDescription
                }
            }
        })).data.createChannel;
        if (newChannel.id) addChannel(newChannel, true);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (userToChatWith && description) {
            createChannelFromSearchParams(userToChatWith, description);
            navigate('/chat');
        }
    }, []);
    return (0, $bb3TF.jsxs)("div", {
        className: $c63e1ae15bac0909$export$2df4967279ed66b1,
        children: [
            modalVisible && (0, $bb3TF.jsx)((0, $f4a8b1c8d23a1ea2$export$2e2bcd8739ae039), {
                visible: modalVisible,
                handleCancel: hideModal
            }),
            (0, $bb3TF.jsx)((0, $37529603afae5c30$export$2e2bcd8739ae039), {
                showModal: showModal,
                channelSearch: channelSearch,
                setChannelSearch: setChannelSearch
            }),
            (0, $bb3TF.jsx)((0, $7ec8a14e44c9c1e4$export$2e2bcd8739ae039), {})
        ]
    });
};
var $96baf74e8cb9a0a4$export$2e2bcd8739ae039 = $96baf74e8cb9a0a4$var$ChatsList;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




var $6Sgv0 = parcelRequire("6Sgv0");

var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");








var $88fd7f32e1f6f03b$export$34e0f9847d4c02dd;
var $88fd7f32e1f6f03b$export$82c3bb3cf4f0e46;
$88fd7f32e1f6f03b$export$34e0f9847d4c02dd = `AZBJ1W_container`;
$88fd7f32e1f6f03b$export$82c3bb3cf4f0e46 = `AZBJ1W_copyButton`;


const { Title: $af105a04bd00a436$var$Title, Text: $af105a04bd00a436$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { TextArea: $af105a04bd00a436$var$TextArea } = (0, $1fb834916a156dcf$export$2e2bcd8739ae039);
const $af105a04bd00a436$var$LoadingMessages = ()=>{
    const [text, setText] = (0, $6fFrj.useState)("Roo is thinking\u2026");
    (0, $6fFrj.useEffect)(()=>{
        const timeout1 = setTimeout(()=>{
            setText("Roo is writing\u2026");
        }, 2000);
        const timeout2 = setTimeout(()=>{
            setText("Roo is sending\u2026");
        }, 3500);
        const timeout3 = setTimeout(()=>{
            setText("Here comes your response\u2026");
        }, 5000);
        return ()=>{
            clearTimeout(timeout1);
            clearTimeout(timeout2);
            clearTimeout(timeout3);
        };
    }, []);
    return (0, $bb3TF.jsx)($af105a04bd00a436$var$Text, {
        children: text
    });
};
const $af105a04bd00a436$var$AIMessagingSuggestion = ({ channelId: channelId, channelInfo: channelInfo })=>{
    const { userId: currentUserId } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$ca779d385d6ad982));
    const [value, setValue] = (0, $6fFrj.useState)('');
    const { messages: messages } = (0, $0dff5878e5b80cbb$export$2e2bcd8739ae039)(false);
    const { showModal: showModal, accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    const needsToUpgrade = !accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).aiMessaging];
    // graphql
    const [getAiMessageSuggestion, { loading: aiSuggestionLoading }] = (0, $f442d9dc730cd5f3$export$11efbe0520b78d5f)();
    (0, $6fFrj.useEffect)(()=>{
        // if channelInfo updated and the last message sent was not me, make a new request
        if (messages[channelInfo.id]?.length) {
            if (messages[channelInfo.id][0]?.userId !== currentUserId) getAiMessageSuggestion({
                variables: {
                    channelId: channelId
                },
                fetchPolicy: 'network-only'
            }).then(({ data: data })=>{
                const suggestion = data?.AIMessageSuggestion?.choices?.[0]?.message?.content || 'Waiting for next client message.';
                setValue(suggestion);
            }).catch(()=>{
                setValue('Waiting for next client message.');
            });
            else setValue('Waiting for next client message.');
        }
    }, [
        channelInfo,
        currentUserId,
        channelId
    ]);
    if (needsToUpgrade) {
        const modalType = (0, $a8c21a2ece310828$export$73f20a159a96bef5).includes((0, $a8c21a2ece310828$export$617d79dae526d2cf).aiMessaging) ? 'Lite' : 'Pro';
        return (0, $bb3TF.jsxs)("div", {
            className: $88fd7f32e1f6f03b$export$34e0f9847d4c02dd,
            children: [
                (0, $bb3TF.jsx)($af105a04bd00a436$var$Title, {
                    level: 4,
                    style: {
                        textAlign: 'center'
                    },
                    children: "Roo\u2122 AI Tax Advisor"
                }),
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "center",
                    style: {
                        marginTop: 30
                    },
                    children: [
                        (0, $bb3TF.jsx)($af105a04bd00a436$var$Text, {
                            style: {
                                textAlign: 'center'
                            },
                            children: `Access to Roo requires a ${modalType} Plan.`
                        }),
                        (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "primary",
                            onClick: ()=>showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).aiMessaging),
                            style: {
                                marginTop: 14
                            },
                            children: "Access Roo\u2122"
                        })
                    ]
                })
            ]
        });
    }
    return (0, $bb3TF.jsxs)("div", {
        className: $88fd7f32e1f6f03b$export$34e0f9847d4c02dd,
        children: [
            (0, $bb3TF.jsx)($af105a04bd00a436$var$Title, {
                level: 4,
                style: {
                    textAlign: 'center'
                },
                children: "Roo\u2122 AI Tax Advisor"
            }),
            (0, $bb3TF.jsx)($af105a04bd00a436$var$Text, {
                children: "Suggested Response:"
            }),
            aiSuggestionLoading ? (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                justify: "center",
                style: {
                    marginTop: 16
                },
                children: (0, $bb3TF.jsx)($af105a04bd00a436$var$LoadingMessages, {})
            }) : (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                children: [
                    (0, $bb3TF.jsx)($af105a04bd00a436$var$TextArea, {
                        autoSize: {
                            minRows: 5,
                            maxRows: 8
                        },
                        value: value,
                        style: {
                            resize: 'none'
                        },
                        onChange: (e)=>setValue(e.target.value),
                        onFocus: (e)=>e.target.select(),
                        className: "showScrollbar"
                    }),
                    (0, $bb3TF.jsx)("div", {
                        className: $88fd7f32e1f6f03b$export$82c3bb3cf4f0e46,
                        onClick: ()=>{
                            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
                                Title: 'AI tax advisor copy response',
                                Source: 'Button click',
                                url: window.location.href
                            });
                        },
                        "aria-hidden": "true",
                        children: (0, $bb3TF.jsx)((0, $19603d7a6afc475f$export$2e2bcd8739ae039), {
                            copyText: value
                        })
                    })
                ]
            })
        ]
    });
};
var $af105a04bd00a436$export$2e2bcd8739ae039 = $af105a04bd00a436$var$AIMessagingSuggestion;




var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

var $6Sgv0 = parcelRequire("6Sgv0");








var $6bf48108e8bfa9e2$export$8508c5c67a139572;
var $6bf48108e8bfa9e2$export$34e0f9847d4c02dd;
var $6bf48108e8bfa9e2$export$5773156769637446;
var $6bf48108e8bfa9e2$export$40155ba12bfe94ec;
var $6bf48108e8bfa9e2$export$d4268655decfcf66;
var $6bf48108e8bfa9e2$export$4f0ae61f55d5f81c;
var $6bf48108e8bfa9e2$export$a02841c00baf9294;
var $6bf48108e8bfa9e2$export$a3bc9b8ed74fc;
var $6bf48108e8bfa9e2$export$eabcd2c8791e7bf4;
var $6bf48108e8bfa9e2$export$79ffe56a765070d2;
var $6bf48108e8bfa9e2$export$955fc4a6c4be454d;
var $6bf48108e8bfa9e2$export$e18e06c96416705f;
var $6bf48108e8bfa9e2$export$fe7c49d056ea1d88;
var $6bf48108e8bfa9e2$export$fc2a1953677f8248;
var $6bf48108e8bfa9e2$export$d72b0b1d2d0e0735;
var $6bf48108e8bfa9e2$export$fb184b623420d9be;
$6bf48108e8bfa9e2$export$8508c5c67a139572 = `Kj_RpW_contLabel`;
$6bf48108e8bfa9e2$export$34e0f9847d4c02dd = `Kj_RpW_container`;
$6bf48108e8bfa9e2$export$5773156769637446 = `Kj_RpW_containerStep1`;
$6bf48108e8bfa9e2$export$40155ba12bfe94ec = `Kj_RpW_containerStep2`;
$6bf48108e8bfa9e2$export$d4268655decfcf66 = `Kj_RpW_containerStep3`;
$6bf48108e8bfa9e2$export$4f0ae61f55d5f81c = `Kj_RpW_containerStep4`;
$6bf48108e8bfa9e2$export$a02841c00baf9294 = `Kj_RpW_containerStep5`;
$6bf48108e8bfa9e2$export$a3bc9b8ed74fc = `Kj_RpW_error`;
$6bf48108e8bfa9e2$export$eabcd2c8791e7bf4 = `Kj_RpW_left`;
$6bf48108e8bfa9e2$export$79ffe56a765070d2 = `Kj_RpW_right`;
$6bf48108e8bfa9e2$export$955fc4a6c4be454d = `Kj_RpW_skip`;
$6bf48108e8bfa9e2$export$e18e06c96416705f = `Kj_RpW_skipDisabled`;
$6bf48108e8bfa9e2$export$fe7c49d056ea1d88 = `Kj_RpW_success`;
$6bf48108e8bfa9e2$export$fc2a1953677f8248 = `Kj_RpW_successtxt`;
$6bf48108e8bfa9e2$export$d72b0b1d2d0e0735 = `Kj_RpW_textArea`;
$6bf48108e8bfa9e2$export$fb184b623420d9be = `Kj_RpW_title`;



const { Option: $f419961ed2b5a1cc$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const { TextArea: $f419961ed2b5a1cc$var$TextArea } = (0, $1fb834916a156dcf$export$2e2bcd8739ae039);
const { CalendarOutlined: $f419961ed2b5a1cc$var$CalendarOutlined, CheckCircleOutlined: $f419961ed2b5a1cc$var$CheckCircleOutlined, ClockCircleOutlined: $f419961ed2b5a1cc$var$ClockCircleOutlined, CloseCircleOutlined: $f419961ed2b5a1cc$var$CloseCircleOutlined, CloseOutlined: $f419961ed2b5a1cc$var$CloseOutlined, HourglassOutlined: $f419961ed2b5a1cc$var$HourglassOutlined, LeftOutlined: $f419961ed2b5a1cc$var$LeftOutlined, LoadingOutlined: $f419961ed2b5a1cc$var$LoadingOutlined, PhoneOutlined: $f419961ed2b5a1cc$var$PhoneOutlined, HomeOutlined: $f419961ed2b5a1cc$var$HomeOutlined, DesktopOutlined: $f419961ed2b5a1cc$var$DesktopOutlined, CoffeeOutlined: $f419961ed2b5a1cc$var$CoffeeOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $f419961ed2b5a1cc$var$renderIcon = (saved)=>{
    if (saved === undefined) return (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$LoadingOutlined, {
        style: {
            fontSize: 60
        }
    });
    if (saved) return (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$CheckCircleOutlined, {
        className: $6bf48108e8bfa9e2$export$fe7c49d056ea1d88
    });
    return (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$CloseCircleOutlined, {
        className: $6bf48108e8bfa9e2$export$a3bc9b8ed74fc
    });
};
const $f419961ed2b5a1cc$var$getIcon = (type)=>{
    switch(type){
        case 'VIDEO':
            return (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$DesktopOutlined, {});
        case 'CALL':
            return (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$PhoneOutlined, {});
        case 'HOME':
            return (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$HomeOutlined, {});
        case 'OFFICE':
            return (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$CoffeeOutlined, {});
        default:
            return (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$DesktopOutlined, {});
    }
};
const $f419961ed2b5a1cc$var$ScheduleCall = ({ organizerId: organizerId, userId: userId, closeSchedule: closeSchedule, channelName: channelName })=>{
    const [step, setStep] = (0, $6fFrj.useState)(1);
    const [scheduled, setScheduled] = (0, $6fFrj.useState)(false);
    const [notes, setNotes] = (0, $6fFrj.useState)('');
    const [eventType, setEventType] = (0, $6fFrj.useState)();
    const [day, setDay] = (0, $6fFrj.useState)((0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))());
    const [brackets, setBrackets] = (0, $6fFrj.useState)([]);
    const [hours, setHours] = (0, $6fFrj.useState)('');
    const [saved, setSaved] = (0, $6fFrj.useState)();
    const [type, setType] = (0, $6fFrj.useState)();
    const { t: translation } = (0, $e3ea6dd032e45947$export$9fc83ad70ead8663)();
    const timezone = (0, $5bafd68f69b44f55$export$c3133dbc11f66777)();
    const updateNotes = ({ target: { value: value } })=>{
        setNotes(value);
    };
    const nextStep = ()=>{
        setStep(step + 1);
    };
    const prevStep = ()=>{
        setStep(step - 1);
    };
    const selectEventType = (et)=>{
        setEventType(et);
        nextStep();
    };
    const [preparerAvailability, { loading: loadingPreparerAvailability }] = (0, $a86ee2eea1b8cff6$export$b027a4e78e4dda82)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message)
    });
    const selectDay = async (value)=>{
        const momentDay = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(value);
        setDay(momentDay);
        nextStep();
        const availability = eventType.EventTypeAvailability.find((ETA)=>ETA.day === momentDay.format('dddd').toUpperCase());
        const availabilityResult = await preparerAvailability({
            variables: {
                input: {
                    availabilityBrackets: availability.EventTypeAvailabilityBracket.map((bracket)=>({
                            ...bracket,
                            __typename: undefined
                        })),
                    day: momentDay.format('YYYY-MM-DD'),
                    today: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().toDate(),
                    minNotice: eventType.minNotice,
                    beforeBuffer: eventType.beforeBuffer,
                    afterBuffer: eventType.afterBuffer,
                    timezone: (0, $5bafd68f69b44f55$export$c3133dbc11f66777)().large,
                    preparerId: organizerId
                }
            }
        });
        const Brackets = availabilityResult?.data.PreparerAvailability.brackets.sort((a, b)=>{
            const aName = Number(`${a.startHour}${a.startMinute === 0 ? '00' : a.startMinute}`);
            const bName = Number(`${b.startHour}${b.startMinute === 0 ? '00' : b.startMinute}`);
            if (aName > bName) return 1;
            if (aName < bName) return -1;
            return 0;
        });
        const EventsInDay = availabilityResult?.data.PreparerAvailability.eventsInDay;
        if (Brackets.length > 0 && (!eventType.maxEvents || eventType.maxEvents > EventsInDay)) setBrackets(Brackets);
        else {
            setStep((old)=>old - 1);
            (0, $e19596a12ff9a33f$export$f69c19e57285b83a)(translation('scheduleCall.error'), 'error');
        }
    };
    const selectHours = (value)=>{
        setHours(value);
        nextStep();
    };
    const selectType = (et)=>{
        setType(et);
        nextStep();
    };
    const getDate = (bracket)=>{
        const start = new Date().setHours(bracket.startHour, bracket.startMinute);
        const end = new Date().setHours(bracket.endHour, bracket.endMinute);
        return `${(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(start).format('LT')} - ${(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(end).format('LT')}`;
    };
    const disabledDate = ({ date: date })=>{
        const actualDate = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().format();
        const currentDate = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(date);
        if (currentDate.isBefore(actualDate) && !currentDate.isSame(actualDate, 'day')) return true;
        return eventType.EventTypeAvailability.findIndex((ETAvailability)=>ETAvailability.day === currentDate.format('dddd').toUpperCase() && ETAvailability.EventTypeAvailabilityBracket.length > 0) < 0;
    };
    const [createEventMutation] = (0, $a86ee2eea1b8cff6$export$c78810c1254c21c8)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message),
        refetchQueries: [
            {
                query: (0, $cfef3f1bede5cb90$export$7a3b4904b0a97d55)
            }
        ],
        awaitRefetchQueries: true
    });
    const returnEvent = async ()=>{
        const hoursDetails = (0, $5bafd68f69b44f55$export$442c0f5af3870293)(hours);
        const { startHour: startHour, endHour: endHour } = hoursDetails;
        const startDate = (0, $5bafd68f69b44f55$export$e029667a62135fd0)(day, startHour.hours, startHour.minutes);
        const endDate = (0, $5bafd68f69b44f55$export$e029667a62135fd0)(day, endHour.hours, endHour.minutes);
        setScheduled(true);
        const saveResult = await createEventMutation({
            variables: {
                input: {
                    title: channelName,
                    type: type,
                    eventTypeId: eventType.id,
                    clientId: userId,
                    startDate: startDate,
                    endDate: endDate,
                    notes: notes
                }
            }
        });
        if (saveResult.data) setSaved(true);
        else setSaved(false);
    };
    const { data: eventTypes, loading: loadingEventTypes, error: myEventTypesError } = (0, $cfef3f1bede5cb90$export$10d6da411e25606d)({
        variables: {
            timezone: (0, $5bafd68f69b44f55$export$c3133dbc11f66777)().large
        }
    });
    const renderStep = ()=>{
        switch(step){
            case 1:
                return (0, $bb3TF.jsxs)("div", {
                    className: $6bf48108e8bfa9e2$export$5773156769637446,
                    children: [
                        (0, $bb3TF.jsx)("p", {
                            className: $6bf48108e8bfa9e2$export$fb184b623420d9be,
                            children: translation('scheduleCall.scheduleCall')
                        }),
                        loadingEventTypes ? (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            align: "middle",
                            justify: "center",
                            children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                                size: "large"
                            })
                        }) : eventTypes?.MyEventTypes.map((et)=>(0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                onClick: ()=>selectEventType(et),
                                children: et.name
                            }, et.id))
                    ]
                });
            case 2:
                return (0, $bb3TF.jsxs)("div", {
                    className: $6bf48108e8bfa9e2$export$40155ba12bfe94ec,
                    children: [
                        (0, $bb3TF.jsx)("p", {
                            className: $6bf48108e8bfa9e2$export$fb184b623420d9be,
                            children: eventType.name
                        }),
                        (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$TextArea, {
                            onChange: updateNotes,
                            placeholder: translation('scheduleCall.notes'),
                            className: $6bf48108e8bfa9e2$export$d72b0b1d2d0e0735,
                            rows: 4
                        }),
                        (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            onClick: nextStep,
                            children: translation('scheduleCall.next')
                        })
                    ]
                });
            case 3:
                return (0, $bb3TF.jsxs)("div", {
                    className: $6bf48108e8bfa9e2$export$d4268655decfcf66,
                    children: [
                        (0, $bb3TF.jsx)("p", {
                            className: $6bf48108e8bfa9e2$export$fb184b623420d9be,
                            children: eventType.name
                        }),
                        (0, $bb3TF.jsx)((0, $c226c3d0d65e59f9$export$2e2bcd8739ae039), {
                            className: "schedule-inline-cal",
                            value: new Date(),
                            onChange: selectDay,
                            tileDisabled: disabledDate
                        })
                    ]
                });
            case 4:
                return (0, $bb3TF.jsxs)("div", {
                    className: $6bf48108e8bfa9e2$export$4f0ae61f55d5f81c,
                    children: [
                        (0, $bb3TF.jsx)("p", {
                            className: $6bf48108e8bfa9e2$export$fb184b623420d9be,
                            children: eventType.name
                        }),
                        (0, $bb3TF.jsxs)("div", {
                            children: [
                                (0, $bb3TF.jsxs)("div", {
                                    className: $6bf48108e8bfa9e2$export$8508c5c67a139572,
                                    children: [
                                        (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$CalendarOutlined, {}),
                                        (0, $bb3TF.jsx)("p", {
                                            children: `${translation('scheduleCall.date')}: ${day.format('ddd MMM DD, YYYY')}`
                                        })
                                    ]
                                }),
                                (0, $bb3TF.jsxs)("div", {
                                    className: $6bf48108e8bfa9e2$export$8508c5c67a139572,
                                    children: [
                                        (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$ClockCircleOutlined, {}),
                                        (0, $bb3TF.jsx)("p", {
                                            children: `${translation('scheduleCall.duration')}: ${eventType.duration} min`
                                        })
                                    ]
                                })
                            ]
                        }),
                        (0, $bb3TF.jsxs)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                            value: type,
                            placeholder: "Choose Type",
                            style: {
                                width: '85%',
                                marginTop: 10
                            },
                            onSelect: selectType,
                            children: [
                                (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$Option, {
                                    value: "VIDEO",
                                    children: "Video"
                                }),
                                (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$Option, {
                                    value: "CALL",
                                    children: "Phone Call"
                                }),
                                (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$Option, {
                                    value: "HOME",
                                    children: "Home"
                                }),
                                (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$Option, {
                                    value: "OFFICE",
                                    children: "Office"
                                }),
                                (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$Option, {
                                    value: "OTHER",
                                    children: "Other place of service"
                                })
                            ]
                        })
                    ]
                });
            case 5:
                return (0, $bb3TF.jsxs)("div", {
                    className: $6bf48108e8bfa9e2$export$4f0ae61f55d5f81c,
                    children: [
                        (0, $bb3TF.jsx)("p", {
                            className: $6bf48108e8bfa9e2$export$fb184b623420d9be,
                            children: eventType.name
                        }),
                        (0, $bb3TF.jsxs)("div", {
                            children: [
                                (0, $bb3TF.jsxs)("div", {
                                    className: $6bf48108e8bfa9e2$export$8508c5c67a139572,
                                    children: [
                                        (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$CalendarOutlined, {}),
                                        (0, $bb3TF.jsx)("p", {
                                            style: {
                                                paddingLeft: '10px'
                                            },
                                            children: `${translation('scheduleCall.date')}: ${day.format('ddd MMM DD, YYYY')}`
                                        })
                                    ]
                                }),
                                (0, $bb3TF.jsxs)("div", {
                                    className: $6bf48108e8bfa9e2$export$8508c5c67a139572,
                                    children: [
                                        (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$ClockCircleOutlined, {}),
                                        (0, $bb3TF.jsx)("p", {
                                            style: {
                                                paddingLeft: '10px'
                                            },
                                            children: `${translation('scheduleCall.duration')}: ${eventType.duration} min`
                                        })
                                    ]
                                }),
                                (0, $bb3TF.jsxs)("div", {
                                    className: $6bf48108e8bfa9e2$export$8508c5c67a139572,
                                    children: [
                                        $f419961ed2b5a1cc$var$getIcon(type),
                                        (0, $bb3TF.jsx)("p", {
                                            style: {
                                                textTransform: 'capitalize',
                                                paddingLeft: '10px'
                                            },
                                            children: type.toLocaleLowerCase()
                                        })
                                    ]
                                })
                            ]
                        }),
                        (0, $bb3TF.jsx)("div", {
                            style: {
                                width: '85%',
                                marginTop: 10
                            },
                            children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                placeholder: translation('scheduleCall.selectOption'),
                                optionFilterProp: "children",
                                style: {
                                    width: '100%'
                                },
                                onChange: selectHours,
                                showSearch: true,
                                children: brackets.map((opt, index)=>(0, $bb3TF.jsx)($f419961ed2b5a1cc$var$Option, {
                                        value: getDate(opt),
                                        children: `${getDate(opt)} ${timezone.short}`
                                    }, index))
                            })
                        })
                    ]
                });
            case 6:
                return (0, $bb3TF.jsxs)("div", {
                    className: $6bf48108e8bfa9e2$export$a02841c00baf9294,
                    children: [
                        (0, $bb3TF.jsx)("p", {
                            className: $6bf48108e8bfa9e2$export$fb184b623420d9be,
                            children: eventType.name
                        }),
                        (0, $bb3TF.jsxs)("div", {
                            children: [
                                (0, $bb3TF.jsxs)("div", {
                                    className: $6bf48108e8bfa9e2$export$8508c5c67a139572,
                                    children: [
                                        (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$CalendarOutlined, {}),
                                        (0, $bb3TF.jsx)("p", {
                                            style: {
                                                paddingLeft: '10px'
                                            },
                                            children: `${translation('scheduleCall.date')}: ${day.format('ddd MMM DD, YYYY')}`
                                        })
                                    ]
                                }),
                                (0, $bb3TF.jsxs)("div", {
                                    className: $6bf48108e8bfa9e2$export$8508c5c67a139572,
                                    children: [
                                        (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$ClockCircleOutlined, {}),
                                        (0, $bb3TF.jsx)("p", {
                                            style: {
                                                paddingLeft: '10px'
                                            },
                                            children: `${translation('scheduleCall.duration')}: ${eventType.duration} min`
                                        })
                                    ]
                                }),
                                (0, $bb3TF.jsxs)("div", {
                                    className: $6bf48108e8bfa9e2$export$8508c5c67a139572,
                                    children: [
                                        $f419961ed2b5a1cc$var$getIcon(type),
                                        (0, $bb3TF.jsx)("p", {
                                            style: {
                                                textTransform: 'capitalize',
                                                paddingLeft: '10px'
                                            },
                                            children: type.toLocaleLowerCase()
                                        })
                                    ]
                                }),
                                (0, $bb3TF.jsxs)("div", {
                                    className: $6bf48108e8bfa9e2$export$8508c5c67a139572,
                                    children: [
                                        (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$HourglassOutlined, {}),
                                        (0, $bb3TF.jsx)("p", {
                                            style: {
                                                paddingLeft: '10px'
                                            },
                                            children: `${hours} ${timezone.short}`
                                        })
                                    ]
                                })
                            ]
                        }),
                        !scheduled ? (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            onClick: returnEvent,
                            children: translation('scheduleCall.scheduleCall')
                        }) : (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                            children: [
                                $f419961ed2b5a1cc$var$renderIcon(saved),
                                (0, $bb3TF.jsx)("p", {
                                    className: $6bf48108e8bfa9e2$export$fc2a1953677f8248,
                                    children: translation('scheduleCall.callScheduled')
                                })
                            ]
                        })
                    ]
                });
            default:
                return null;
        }
    };
    return (0, $bb3TF.jsxs)("div", {
        className: $6bf48108e8bfa9e2$export$34e0f9847d4c02dd,
        children: [
            (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$LeftOutlined, {
                className: $6bf48108e8bfa9e2$export$eabcd2c8791e7bf4,
                onClick: ()=>step === 1 ? closeSchedule() : prevStep()
            }),
            (0, $bb3TF.jsx)($f419961ed2b5a1cc$var$CloseOutlined, {
                className: $6bf48108e8bfa9e2$export$79ffe56a765070d2,
                onClick: closeSchedule
            }),
            renderStep()
        ]
    });
};
var $f419961ed2b5a1cc$export$2e2bcd8739ae039 = $f419961ed2b5a1cc$var$ScheduleCall;



var $bb3TF = parcelRequire("bb3TF");

var $6Sgv0 = parcelRequire("6Sgv0");


var $6fFrj = parcelRequire("6fFrj");

var $d08d4febd503c882$export$89da14300d534261;
var $d08d4febd503c882$export$a2b4c73d11236577;
var $d08d4febd503c882$export$4672dd431739c171;
var $d08d4febd503c882$export$c96745152eb2740f;
$d08d4febd503c882$export$89da14300d534261 = `_1BHKVq_active`;
$d08d4febd503c882$export$a2b4c73d11236577 = `_1BHKVq_containerAppointment`;
$d08d4febd503c882$export$4672dd431739c171 = `_1BHKVq_itemAppointment`;
$d08d4febd503c882$export$c96745152eb2740f = `_1BHKVq_subtitle`;


const { Text: $cde95fe474bfac13$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { ClockCircleOutlined: $cde95fe474bfac13$var$ClockCircleOutlined, ScheduleOutlined: $cde95fe474bfac13$var$ScheduleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $cde95fe474bfac13$var$AppointmentsDetail() {
    const { ownerId: id } = (0, $6fFrj.useContext)((0, $9f8459ba594d5b47$export$7fd9bd9faa7887cb));
    const [next, setNext] = (0, $6fFrj.useState)();
    const [last, setLast] = (0, $6fFrj.useState)();
    const isAfter = (dateString)=>{
        const today = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().format('YYYY-MM-DD HH:mm');
        const date = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(dateString).format('YYYY-MM-DD HH:mm');
        return (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(date).isAfter(today);
    };
    (0, $6fFrj.useEffect)(()=>{
    // const getEvents = async () => {
    //   const events = await axios({
    //     method: 'get',
    //     url: `${config.serverUrl}/events`,
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //   });
    //   const nextAppointment = events.data.filter(
    //     (ap: any) => ap.status === 'SCHEDULED' && isAfter(ap.startDate),
    //   );
    //   if (nextAppointment.length > 0) {
    //     const { startDate, endDate } = nextAppointment[0];
    //     setNext({ startDate, endDate });
    //   } else setNext(undefined);
    //   const lastAppointment = events.data.filter((ap: any) => ap.status === 'COMPLETED');
    //   if (lastAppointment.length > 0) {
    //     const { startDate, endDate } = lastAppointment[lastAppointment.length - 1];
    //     setLast({ startDate, endDate });
    //   } else setLast(undefined);
    // };
    // getEvents();
    }, [
        id
    ]);
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            next && (0, $bb3TF.jsxs)("div", {
                className: $d08d4febd503c882$export$a2b4c73d11236577,
                children: [
                    (0, $bb3TF.jsx)($cde95fe474bfac13$var$Text, {
                        className: `${$d08d4febd503c882$export$c96745152eb2740f} ${$d08d4febd503c882$export$89da14300d534261}`,
                        children: "Next Appointment"
                    }),
                    (0, $bb3TF.jsxs)("div", {
                        className: $d08d4febd503c882$export$4672dd431739c171,
                        children: [
                            (0, $bb3TF.jsx)($cde95fe474bfac13$var$ScheduleOutlined, {}),
                            (0, $bb3TF.jsx)("p", {
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(next.startDate).format('MMM DD, YYYY')
                            })
                        ]
                    }),
                    (0, $bb3TF.jsxs)("div", {
                        className: $d08d4febd503c882$export$4672dd431739c171,
                        children: [
                            (0, $bb3TF.jsx)($cde95fe474bfac13$var$ClockCircleOutlined, {}),
                            (0, $bb3TF.jsx)("p", {
                                children: `${(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(next.startDate).format('LT')} - ${(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(next.endDate).format('LT')}`
                            })
                        ]
                    })
                ]
            }),
            last && (0, $bb3TF.jsxs)("div", {
                className: $d08d4febd503c882$export$a2b4c73d11236577,
                children: [
                    (0, $bb3TF.jsx)($cde95fe474bfac13$var$Text, {
                        className: $d08d4febd503c882$export$c96745152eb2740f,
                        children: "Last Appointment"
                    }),
                    (0, $bb3TF.jsxs)("div", {
                        className: $d08d4febd503c882$export$4672dd431739c171,
                        children: [
                            (0, $bb3TF.jsx)($cde95fe474bfac13$var$ScheduleOutlined, {}),
                            (0, $bb3TF.jsx)("p", {
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(last.startDate).format('MMM DD, YYYY')
                            })
                        ]
                    }),
                    (0, $bb3TF.jsxs)("div", {
                        className: $d08d4febd503c882$export$4672dd431739c171,
                        children: [
                            (0, $bb3TF.jsx)($cde95fe474bfac13$var$ClockCircleOutlined, {}),
                            (0, $bb3TF.jsx)("p", {
                                children: `${(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(last.startDate).format('LT')} - ${(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(last.endDate).format('LT')}`
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $cde95fe474bfac13$export$2e2bcd8739ae039 = $cde95fe474bfac13$var$AppointmentsDetail;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
var $f09fda689a8d242c$export$345c5736c8054f22;
var $f09fda689a8d242c$export$2ba01fb71ed41cb6;
var $f09fda689a8d242c$export$1277ab73b1aeadf0;
var $f09fda689a8d242c$export$120ff0929b202a6d;
var $f09fda689a8d242c$export$77a3c24dc5a041de;
var $f09fda689a8d242c$export$8a708799b03d5a87;
var $f09fda689a8d242c$export$fea765672a85d24e;
$f09fda689a8d242c$export$345c5736c8054f22 = `_7nJ7tq_avatar`;
$f09fda689a8d242c$export$2ba01fb71ed41cb6 = `_7nJ7tq_button`;
$f09fda689a8d242c$export$1277ab73b1aeadf0 = `_7nJ7tq_emptyUserSidebarContainer`;
$f09fda689a8d242c$export$120ff0929b202a6d = `_7nJ7tq_row`;
$f09fda689a8d242c$export$77a3c24dc5a041de = `_7nJ7tq_rowbuttons`;
$f09fda689a8d242c$export$8a708799b03d5a87 = `_7nJ7tq_rowmed`;
$f09fda689a8d242c$export$fea765672a85d24e = `_7nJ7tq_rowsmall`;


function $2f763d3be9c44b40$var$EmptyState() {
    return (0, $bb3TF.jsxs)("div", {
        className: $f09fda689a8d242c$export$1277ab73b1aeadf0,
        children: [
            (0, $bb3TF.jsx)("div", {
                className: $f09fda689a8d242c$export$345c5736c8054f22
            }),
            (0, $bb3TF.jsx)("br", {}),
            (0, $bb3TF.jsx)("div", {
                className: $f09fda689a8d242c$export$120ff0929b202a6d
            }),
            (0, $bb3TF.jsx)("div", {
                className: $f09fda689a8d242c$export$8a708799b03d5a87
            }),
            (0, $bb3TF.jsx)("div", {
                className: $f09fda689a8d242c$export$fea765672a85d24e
            }),
            (0, $bb3TF.jsx)("br", {}),
            (0, $bb3TF.jsxs)("div", {
                className: $f09fda689a8d242c$export$77a3c24dc5a041de,
                children: [
                    (0, $bb3TF.jsx)("div", {
                        className: $f09fda689a8d242c$export$2ba01fb71ed41cb6
                    }),
                    (0, $bb3TF.jsx)("div", {
                        className: $f09fda689a8d242c$export$2ba01fb71ed41cb6
                    }),
                    (0, $bb3TF.jsx)("div", {
                        className: $f09fda689a8d242c$export$2ba01fb71ed41cb6
                    })
                ]
            }),
            (0, $bb3TF.jsx)("br", {}),
            (0, $bb3TF.jsx)("div", {
                className: $f09fda689a8d242c$export$120ff0929b202a6d
            }),
            (0, $bb3TF.jsx)("div", {
                className: $f09fda689a8d242c$export$120ff0929b202a6d
            }),
            (0, $bb3TF.jsx)("div", {
                className: $f09fda689a8d242c$export$120ff0929b202a6d
            }),
            (0, $bb3TF.jsx)("br", {}),
            (0, $bb3TF.jsx)("div", {
                className: $f09fda689a8d242c$export$120ff0929b202a6d
            }),
            (0, $bb3TF.jsx)("div", {
                className: $f09fda689a8d242c$export$120ff0929b202a6d
            }),
            (0, $bb3TF.jsx)("div", {
                className: $f09fda689a8d242c$export$120ff0929b202a6d
            })
        ]
    });
}
var $2f763d3be9c44b40$export$2e2bcd8739ae039 = $2f763d3be9c44b40$var$EmptyState;


var $3b5666eb8c5b8de1$export$89da14300d534261;
var $3b5666eb8c5b8de1$export$cb6c30b631422a13;
var $3b5666eb8c5b8de1$export$44c1930ad21100a2;
var $3b5666eb8c5b8de1$export$6649650ed1c43b15;
var $3b5666eb8c5b8de1$export$d95e6ca0533ab20d;
var $3b5666eb8c5b8de1$export$5ab6af8be0a30e6a;
var $3b5666eb8c5b8de1$export$6615f450ec0b33f7;
var $3b5666eb8c5b8de1$export$a8ff84c12d48cfa6;
var $3b5666eb8c5b8de1$export$c96745152eb2740f;
var $3b5666eb8c5b8de1$export$a0bf4bf4fe7c70bc;
var $3b5666eb8c5b8de1$export$13166165aac314fc;
$3b5666eb8c5b8de1$export$89da14300d534261 = `qVaUaq_active`;
$3b5666eb8c5b8de1$export$cb6c30b631422a13 = `qVaUaq_btnContainer`;
$3b5666eb8c5b8de1$export$44c1930ad21100a2 = `qVaUaq_btnMedia`;
$3b5666eb8c5b8de1$export$6649650ed1c43b15 = `qVaUaq_btnSideBar`;
$3b5666eb8c5b8de1$export$d95e6ca0533ab20d = `qVaUaq_containerSchedulle`;
$3b5666eb8c5b8de1$export$5ab6af8be0a30e6a = `qVaUaq_displaySchedule`;
$3b5666eb8c5b8de1$export$6615f450ec0b33f7 = `qVaUaq_lastseen`;
$3b5666eb8c5b8de1$export$a8ff84c12d48cfa6 = `qVaUaq_name`;
$3b5666eb8c5b8de1$export$c96745152eb2740f = `qVaUaq_subtitle`;
$3b5666eb8c5b8de1$export$a0bf4bf4fe7c70bc = `qVaUaq_userSidebarBadge`;
$3b5666eb8c5b8de1$export$13166165aac314fc = `qVaUaq_userSidebarContainer`;


// import config from '../../helpers/config';
// import updateStep from '../../helpers/updateStep';
// import { TaxPayerContext } from '../../providers/taxpayer-provider';
// import VideoMuted from '../../../assets/image/camera-off.png';
// import Video from '../../../assets/image/camera-on.png';
const { Title: $19e248dd15a0fb19$var$Title, Text: $19e248dd15a0fb19$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { CalendarOutlined: $19e248dd15a0fb19$var$CalendarOutlined, MailOutlined: $19e248dd15a0fb19$var$MailOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $19e248dd15a0fb19$var$getAcronim = (str)=>{
    if (str === '' || !str) return '';
    const matches = str.match(/\b(\w)/g);
    const acronym = matches?.join('');
    return acronym?.substring(0, 2).toUpperCase();
};
const $19e248dd15a0fb19$var$UserSidebar = ({ channelInfo: channelInfo })=>{
    // const taxpayer = useContext(TaxPayerContext);
    const [displaySchedule, setDisplaySchedule] = (0, $6fFrj.useState)(false);
    // const taxpayerHref = `/account/clients/?clientId=${taxpayer?.ownerId}&taxYearInterviewId=${taxpayer?.urlTaxYearInterviewId}`;
    const { userId: currentUserId } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$ca779d385d6ad982));
    const clientInfo = channelInfo?.ChannelMembers.find(({ userId: memberUserId })=>memberUserId !== currentUserId);
    const { showModal: showModal, accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    const createCall = async ()=>{
    // const meeting = await axios({
    //   method: 'post',
    //   url: `${config.serverUrl}/meetings`,
    //   data: {
    //     userId: 0,
    //     channelName: '',
    //     attendees: [0, taxpayer.id],
    //   },
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //   },
    // });
    // const { name } = meeting.data.data;
    // updateStep(token, 6);
    // eslint-disable-next-line max-len
    // window.open(`${config.clientUrl}/videocall/${name}${token ? `?token=${token}` : ''}`, '_blank');
    };
    const callPhone = (phone)=>{
        const tab = window.open('about:blank');
        tab.location = `tel:${phone}`;
        tab.focus();
    // window.open(`tel:${phone}`, "_blank");
    };
    // const getPhoneCallView = () => {
    // eslint-disable-next-line max-len
    //   let phone = taxpayer.mobile ? taxpayer.mobile.replace(/[^\w\s]/gi, '').replace(' ', '') : null;
    //   phone = phone || (taxpayer.phone
    //     ? taxpayer.phone.replace(/[^\w\s]/gi, '').replace(' ', '')
    //     : null);
    //   phone = phone || (taxpayer.phoneWork
    //     ? taxpayer.phoneWork.replace(/[^\w\s]/gi, '').replace(' ', '')
    //     : null);
    // eslint-disable-next-line max-len
    //   const tooltipTitle = phone ? `Do you wish to call ${phone} ?` : 'Client\'s phone number is not available';
    //   const disabled = !phone;
    //   return (
    //     <Tooltip placement="left" title={tooltipTitle}>
    //       <TaxarooButton
    //         // href={`tel:${'8384884848'}`}
    //         disabled={disabled}
    //         shape="circle"
    //         className={`${styles.btnSideBar}`}
    //         onClick={() => callPhone(phone)}
    //         icon={<MobileOutlined />}
    //       />
    //     </Tooltip>
    //   );
    // };
    const getChatName = ()=>{
        const otherMember = channelInfo.ChannelMembers?.find(({ userId: userId })=>userId !== currentUserId);
        if (otherMember) {
            const { firstName: firstName, lastName: lastName } = otherMember.Users.UserInformation || {};
            if (`${firstName} ${lastName}` !== channelInfo.description) return `${firstName} ${lastName}`;
            return channelInfo.description;
        }
        return '';
    };
    const userEmail = channelInfo?.ChannelMembers.find(({ userId: memberUserId })=>memberUserId !== currentUserId)?.Users?.email || '';
    return(// eslint-disable-next-line react/jsx-no-useless-fragment
    (0, $bb3TF.jsx)((0, $bb3TF.Fragment), {
        children: channelInfo?.description ? (0, $bb3TF.jsxs)("div", {
            className: $3b5666eb8c5b8de1$export$13166165aac314fc,
            children: [
                (0, $bb3TF.jsx)((0, $0e541b76c0e3ec69$export$2e2bcd8739ae039), {
                    dot: true,
                    className: $3b5666eb8c5b8de1$export$a0bf4bf4fe7c70bc,
                    color: channelInfo.status ? 'green' : 'gray',
                    children: (0, $bb3TF.jsx)((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                        style: {
                            backgroundColor: '#22A7E7',
                            fontSize: 25
                        },
                        size: 80,
                        children: $19e248dd15a0fb19$var$getAcronim(getChatName())
                    })
                }),
                (0, $bb3TF.jsx)($19e248dd15a0fb19$var$Title, {
                    className: $3b5666eb8c5b8de1$export$a8ff84c12d48cfa6,
                    level: 4,
                    children: getChatName()
                }),
                channelInfo?.status ? (0, $bb3TF.jsx)($19e248dd15a0fb19$var$Text, {
                    className: $3b5666eb8c5b8de1$export$6615f450ec0b33f7,
                    children: "Active Now"
                }) : (0, $bb3TF.jsx)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    },
                    children: channelInfo.ChannelMembers.find(({ userId: memberUserId })=>memberUserId !== currentUserId)?.lastConnection && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                        children: [
                            (0, $bb3TF.jsx)($19e248dd15a0fb19$var$Text, {
                                className: $3b5666eb8c5b8de1$export$6615f450ec0b33f7,
                                children: "Last Seen:"
                            }),
                            (0, $bb3TF.jsx)($19e248dd15a0fb19$var$Text, {
                                className: $3b5666eb8c5b8de1$export$6615f450ec0b33f7,
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(channelInfo.ChannelMembers.find(({ userId: memberUserId })=>memberUserId !== currentUserId)?.lastConnection).fromNow()
                            })
                        ]
                    })
                }),
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "space-between",
                    gutter: 25,
                    children: [
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                placement: "left",
                                title: "Schedule a Meeting",
                                children: (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                                    shape: "circle",
                                    className: `${$3b5666eb8c5b8de1$export$6649650ed1c43b15}`,
                                    icon: (0, $bb3TF.jsx)($19e248dd15a0fb19$var$CalendarOutlined, {}),
                                    onClick: ()=>{
                                        // check if user has access to appointments
                                        if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).appointments]) {
                                            showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).appointments);
                                            return;
                                        }
                                        setDisplaySchedule(!displaySchedule);
                                    }
                                })
                            })
                        }),
                        Boolean(userEmail) && (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            style: {
                                paddingTop: '2px'
                            },
                            children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                placement: "left",
                                title: "Send Email",
                                children: (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                                    href: `mailto:${userEmail}`,
                                    className: $3b5666eb8c5b8de1$export$6649650ed1c43b15,
                                    shape: "circle",
                                    icon: (0, $bb3TF.jsx)($19e248dd15a0fb19$var$MailOutlined, {}),
                                    target: "_blank"
                                })
                            })
                        })
                    ]
                }),
                displaySchedule ? (0, $bb3TF.jsx)((0, $f419961ed2b5a1cc$export$2e2bcd8739ae039), {
                    channelName: channelInfo?.description,
                    organizerId: currentUserId,
                    userId: clientInfo?.userId,
                    closeSchedule: ()=>setDisplaySchedule(false)
                }) : (0, $bb3TF.jsx)((0, $cde95fe474bfac13$export$2e2bcd8739ae039), {}),
                !displaySchedule && channelInfo?.id && channelInfo?.Messages?.length > 0 && (0, $bb3TF.jsx)((0, $af105a04bd00a436$export$2e2bcd8739ae039), {
                    channelId: channelInfo?.id,
                    channelInfo: channelInfo
                })
            ]
        }) : (0, $bb3TF.jsx)((0, $2f763d3be9c44b40$export$2e2bcd8739ae039), {})
    }));
};
var $19e248dd15a0fb19$export$2e2bcd8739ae039 = $19e248dd15a0fb19$var$UserSidebar;





var $bb3TF = parcelRequire("bb3TF");

var $8fb04b86f47afa46$exports = {};

$8fb04b86f47afa46$exports = (parcelRequire("jN93C")).getBundleURL('a0IFD') + "empty.e5bcf0dc.png";


var $6066bcb0d9303a06$export$b856ccb2560e7129;
var $6066bcb0d9303a06$export$f1e544e8e1c4eecb;
var $6066bcb0d9303a06$export$3c17b0e969a90510;
$6066bcb0d9303a06$export$b856ccb2560e7129 = `_1QZbga_chatEmptyContainer`;
$6066bcb0d9303a06$export$f1e544e8e1c4eecb = `_1QZbga_emptyContent`;
$6066bcb0d9303a06$export$3c17b0e969a90510 = `_1QZbga_small`;


const $e52c90482f66e15b$var$EmptyState = ({ showModal: showModal })=>(0, $bb3TF.jsx)("div", {
        className: $6066bcb0d9303a06$export$b856ccb2560e7129,
        children: (0, $bb3TF.jsxs)("div", {
            className: $6066bcb0d9303a06$export$f1e544e8e1c4eecb,
            children: [
                (0, $bb3TF.jsx)("img", {
                    alt: "No Conversations Yet",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8fb04b86f47afa46$exports)))
                }),
                (0, $bb3TF.jsx)("p", {
                    className: $6066bcb0d9303a06$export$3c17b0e969a90510,
                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        onClick: showModal,
                        children: "Start New Conversation"
                    })
                })
            ]
        })
    });
var $e52c90482f66e15b$export$2e2bcd8739ae039 = $e52c90482f66e15b$var$EmptyState;


var $dafdf3a2b7134279$export$609e0b643fa92db9;
$dafdf3a2b7134279$export$609e0b643fa92db9 = `_4xS3RW_chatContainer`;


const $e28231b1f126e34d$var$ChatTemplate = ()=>{
    const currentSelectedChannel = (0, $58073eff19365823$export$a7347740d65f620b)((0, $66a7cecdd31d321f$export$64113a45e478f19d));
    const [newConversationModalVisible, setNewConversationModalVisible] = (0, $6fFrj.useState)(false);
    const handleNewConversationModalHide = ()=>{
        setNewConversationModalVisible(false);
    };
    const handleNewConversationModalShow = ()=>{
        setNewConversationModalVisible(true);
    };
    return (0, $bb3TF.jsxs)("div", {
        className: $dafdf3a2b7134279$export$609e0b643fa92db9,
        children: [
            (0, $bb3TF.jsx)((0, $96baf74e8cb9a0a4$export$2e2bcd8739ae039), {
                showModal: handleNewConversationModalShow,
                hideModal: handleNewConversationModalHide,
                modalVisible: newConversationModalVisible
            }),
            currentSelectedChannel ? (0, $bb3TF.jsx)((0, $5d32962ef7d56830$export$2e2bcd8739ae039), {
                channelInfo: currentSelectedChannel
            }) : (0, $bb3TF.jsx)((0, $e52c90482f66e15b$export$2e2bcd8739ae039), {
                showModal: handleNewConversationModalShow
            }),
            (0, $bb3TF.jsx)((0, $19e248dd15a0fb19$export$2e2bcd8739ae039), {
                channelInfo: currentSelectedChannel
            })
        ]
    });
};
var $e28231b1f126e34d$export$2e2bcd8739ae039 = $e28231b1f126e34d$var$ChatTemplate;


const $e56e6435f57fe71d$var$AdminChat = ()=>(0, $bb3TF.jsx)((0, $e28231b1f126e34d$export$2e2bcd8739ae039), {});
var $e56e6435f57fe71d$export$2e2bcd8739ae039 = $e56e6435f57fe71d$var$AdminChat;


var $5acb63e4e117216a$export$2e2bcd8739ae039 = (0, $e56e6435f57fe71d$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");

var $bb3TF = parcelRequire("bb3TF");

var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




const $e9d4d19cd26b2dae$var$defaultOptions = {};
const $e9d4d19cd26b2dae$export$92a1ff34579c5f7d = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetClientOnboardingData {
  ClientOnboardingData {
    ownerName
    email
    languageId
    UserInformation {
      id
      firstName
      lastName
      birthday
    }
    FirmAccount {
      id
      CustomLayout {
        id
        headerBackgroundColor
        headerFontColor
        logo
        pixelCode
        createAt
        updateAt
      }
    }
  }
}
    `;
function $e9d4d19cd26b2dae$export$6f1f2f8020ed6ecc(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($e9d4d19cd26b2dae$export$92a1ff34579c5f7d, options);
}
function $e9d4d19cd26b2dae$export$516eb4694483a826(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($e9d4d19cd26b2dae$export$92a1ff34579c5f7d, options);
}
const $e9d4d19cd26b2dae$export$2f00259356de00ac = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetLanguagesQuery {
  languages {
    id
    lang
    description
  }
}
    `;
function $e9d4d19cd26b2dae$export$f79bf1158a0f4b6a(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($e9d4d19cd26b2dae$export$2f00259356de00ac, options);
}
function $e9d4d19cd26b2dae$export$5d4e05e09dcdd3b7(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($e9d4d19cd26b2dae$export$2f00259356de00ac, options);
}
const $e9d4d19cd26b2dae$export$8e6eb477d54a4b5a = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetTaxYearInterview($id: String!) {
  taxYearInterview(id: $id) {
    id
    progressStatusId
    notes
    assignedAt
    completedAt
    preparerAcceptedAt
    reviewStatus
    createAt
    updateAt
    deletedAt
    Interviews {
      id
      name
      isTemplate
      isLive
      createAt
      updateAt
    }
    TaxYear {
      id
      year
    }
  }
}
    `;
function $e9d4d19cd26b2dae$export$16f3245a53ef98c7(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($e9d4d19cd26b2dae$export$8e6eb477d54a4b5a, options);
}
function $e9d4d19cd26b2dae$export$bec0123f0e58b85c(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($e9d4d19cd26b2dae$export$8e6eb477d54a4b5a, options);
}
const $e9d4d19cd26b2dae$export$6253ea43f7f964e6 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetClientFilesFromDb($userId: String!, $taxYearInterviewId: String!) {
  getClientFilesFromDb(userId: $userId, taxYearInterviewId: $taxYearInterviewId) {
    id
    userId
    firmAccountId
    taxYearInterviewId
    s3Key
    name
    size
    folder
    pages
    documentUsed
    documentReviewed
    createAt
    updateAt
  }
  ClientRequestedFiles(taxYearInterviewId: $taxYearInterviewId) {
    id
    taxYearInterviewId
    fileName
    notes
    createAt
  }
}
    `;
function $e9d4d19cd26b2dae$export$df1c69bb44a9e2c4(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($e9d4d19cd26b2dae$export$6253ea43f7f964e6, options);
}
function $e9d4d19cd26b2dae$export$d4b27e7088edbec6(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($e9d4d19cd26b2dae$export$6253ea43f7f964e6, options);
}
const $e9d4d19cd26b2dae$export$bced65fdea7baad1 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetFirmFilesFromDb($taxYearInterviewId: String!) {
  getFirmFilesFromDb(taxYearInterviewId: $taxYearInterviewId) {
    id
    userId
    firmAccountId
    taxYearInterviewId
    s3Key
    name
    size
    folder
    pages
    documentUsed
    createAt
    updateAt
  }
}
    `;
function $e9d4d19cd26b2dae$export$23217c152e2bfe09(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($e9d4d19cd26b2dae$export$bced65fdea7baad1, options);
}
function $e9d4d19cd26b2dae$export$44b97a3a9e026a24(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($e9d4d19cd26b2dae$export$bced65fdea7baad1, options);
}
const $e9d4d19cd26b2dae$export$8d96bb6ff728ee2f = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetAllFilesByClient($userId: String!) {
  getAllFilesByClient(userId: $userId) {
    id
    userId
    firmAccountId
    taxYearInterviewId
    s3Key
    name
    size
    folder
    pages
    documentUsed
    createAt
    updateAt
  }
}
    `;
function $e9d4d19cd26b2dae$export$9a70869855b17ddd(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($e9d4d19cd26b2dae$export$8d96bb6ff728ee2f, options);
}
function $e9d4d19cd26b2dae$export$984d3f3bb18f6f8f(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($e9d4d19cd26b2dae$export$8d96bb6ff728ee2f, options);
}
const $e9d4d19cd26b2dae$export$4bf53c44c890d336 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetAllFileRequestsFromInterview($taxYearInterviewId: String!) {
  getAllFileRequestsFromInterview(taxYearInterviewId: $taxYearInterviewId) {
    taskType
    completedAt
  }
}
    `;
function $e9d4d19cd26b2dae$export$d2053c96b2177980(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($e9d4d19cd26b2dae$export$4bf53c44c890d336, options);
}
function $e9d4d19cd26b2dae$export$f268c91716fd1881(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($e9d4d19cd26b2dae$export$4bf53c44c890d336, options);
}
const $e9d4d19cd26b2dae$export$ec8da54460ff37f3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetSignedFileByS3Key($s3Key: String!) {
  SignedFileByS3Key(s3Key: $s3Key)
}
    `;
function $e9d4d19cd26b2dae$export$35c0656033026d11(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($e9d4d19cd26b2dae$export$ec8da54460ff37f3, options);
}
function $e9d4d19cd26b2dae$export$a3da8d6004fc9f4a(baseOptions) {
    const options = {
        ...$e9d4d19cd26b2dae$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($e9d4d19cd26b2dae$export$ec8da54460ff37f3, options);
}
const $e9d4d19cd26b2dae$export$39ac829ab91f0716 = {
    Query: {
        GetClientOnboardingData: 'GetClientOnboardingData',
        GetLanguagesQuery: 'GetLanguagesQuery',
        GetTaxYearInterview: 'GetTaxYearInterview',
        GetClientFilesFromDb: 'GetClientFilesFromDb',
        GetFirmFilesFromDb: 'GetFirmFilesFromDb',
        GetAllFilesByClient: 'GetAllFilesByClient',
        GetAllFileRequestsFromInterview: 'GetAllFileRequestsFromInterview',
        GetSignedFileByS3Key: 'GetSignedFileByS3Key'
    }
};



var $bb3TF = parcelRequire("bb3TF");


var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



var $bb3TF = parcelRequire("bb3TF");


var $bb3TF = parcelRequire("bb3TF");



const $fc396e567fcf8ee4$export$e74e9b9e28a80d2c = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('File status updated');
};
const $fc396e567fcf8ee4$export$85b43ea59a8cb058 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error has ocurred while trying to update file status. Please try again');
};


const { Circle: $50648eb04e96a6dd$var$Circle, CheckCircleOutlined: $50648eb04e96a6dd$var$CheckCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
var $50648eb04e96a6dd$export$ed60983e9c7b3f30;
(function(ClientFileUsedUpdateType) {
    ClientFileUsedUpdateType[ClientFileUsedUpdateType["Used"] = 0] = "Used";
    ClientFileUsedUpdateType[ClientFileUsedUpdateType["Reviewed"] = 1] = "Reviewed";
})($50648eb04e96a6dd$export$ed60983e9c7b3f30 || ($50648eb04e96a6dd$export$ed60983e9c7b3f30 = {}));
const $50648eb04e96a6dd$var$ClientFileUsedUpdate = ({ type: type, id: id, used: used })=>{
    const [updateClientFile, { loading: loadingUpdateFile }] = (0, $edf372aa0dea9531$export$a44423915c3bd8dd)({
        variables: {
            updateFileInput: {
                id: id,
                documentUsed: type === $50648eb04e96a6dd$export$ed60983e9c7b3f30.Used ? !used : undefined,
                documentReviewed: type === $50648eb04e96a6dd$export$ed60983e9c7b3f30.Reviewed ? !used : undefined
            }
        },
        onCompleted: (0, $fc396e567fcf8ee4$export$e74e9b9e28a80d2c),
        onError: (0, $fc396e567fcf8ee4$export$85b43ea59a8cb058)
    });
    const handleUpdateClientFile = async ()=>{
        await updateClientFile();
    };
    // if (used) {
    //   return (
    //     <Switch
    //       tooltip="Change value"
    //       onClick={() => handleUpdateClientFile()}
    //       loading={loadingUpdateFile}
    //     >
    //       {/* <CheckCircleOutlined style={{ color: 'green' }} /> */}
    //     </Switch>
    //   );
    // }
    return (0, $bb3TF.jsx)((0, $4fd303306a27e42e$export$2e2bcd8739ae039), {
        tooltip: "Change value",
        onClick: ()=>handleUpdateClientFile(),
        loading: loadingUpdateFile,
        checked: used
    });
};
var $50648eb04e96a6dd$export$2e2bcd8739ae039 = $50648eb04e96a6dd$var$ClientFileUsedUpdate;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


const $92b07c154bbb4d14$var$defaultProps = {
    tooltipPosition: 'bottom',
    confirmAction: false,
    confirmLabel: '',
    children: null,
    loading: false,
    useLoading: true,
    buttonProps: {}
};
function $92b07c154bbb4d14$var$ActionButton({ tooltip: tooltip, tooltipPosition: tooltipPosition = 'bottom', confirmAction: confirmAction = false, confirmLabel: confirmLabel = '', onClick: onClick = ()=>undefined, children: children = null, loading: initLoad = false, useLoading: useLoading = true, buttonProps: buttonProps = {
    type: 'primary',
    disabled: false,
    danger: false
} }) {
    const [visible, setVisible] = (0, $6fFrj.useState)(false);
    const [loading, setLoading] = (0, $6fFrj.useState)(initLoad);
    const showPopconfirm = ()=>{
        setVisible(true);
    };
    const handleCancel = ()=>{
        setVisible(false);
    };
    const handleClick = ()=>{
        setLoading(true);
        onClick();
        setLoading(false);
        setVisible(false);
    };
    const handleConfirm = async ()=>{
        await handleClick();
    };
    (0, $6fFrj.useEffect)(()=>{
        setLoading(initLoad);
    }, [
        initLoad
    ]);
    return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        placement: tooltipPosition,
        title: tooltip,
        children: confirmAction ? (0, $bb3TF.jsx)((0, $a361442371f1d4e9$export$2e2bcd8739ae039), {
            title: confirmLabel,
            visible: visible,
            onConfirm: handleConfirm,
            okButtonProps: {
                loading: loading
            },
            onCancel: handleCancel,
            children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                onClick: showPopconfirm,
                loading: useLoading ? loading : false,
                ...buttonProps,
                className: `${buttonProps.className} popconfirmActionButton`,
                children: !loading && children
            })
        }) : (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
            onClick: handleClick,
            loading: useLoading ? loading : false,
            ...buttonProps,
            className: `${buttonProps.className} popconfirmActionButton`,
            children: !loading && children
        })
    });
}
$92b07c154bbb4d14$var$ActionButton.defaultProps = $92b07c154bbb4d14$var$defaultProps;
var $92b07c154bbb4d14$export$2e2bcd8739ae039 = $92b07c154bbb4d14$var$ActionButton;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");
const { createContext: $6d76742931538b46$var$createContext } = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj)));
const $6d76742931538b46$export$9534a7e06b098e29 = $6d76742931538b46$var$createContext(null);
const $6d76742931538b46$var$initialJob = {
    entityId: undefined,
    entityOwnerId: undefined,
    taxYearInterviewId: undefined,
    progressStatusId: undefined,
    notes: undefined,
    tasks: undefined,
    completedAt: undefined,
    filesCompletedAt: undefined,
    expectedCompletion: undefined,
    paymentsCompletedAt: undefined,
    approvalsCompletedAt: undefined,
    preparationStartedAt: undefined,
    interviewCompletedAt: undefined,
    clientFirstName: undefined,
    clientLastName: undefined,
    clientEmail: undefined,
    clientMobilePhone: undefined,
    clientBirthday: undefined
};
function $6d76742931538b46$var$reducer(state, action) {
    switch(action.type){
        case 'CREATE':
            return {
                ...action.payload
            };
        case 'UPDATE':
            return {
                ...state,
                ...action.payload
            };
        default:
            throw new Error();
    }
}
function $6d76742931538b46$export$f8feb14ab79a59cf({ children: children, entityId: entityId, entityOwnerId: entityOwnerId, taxYearInterviewId: taxYearInterviewId, progressStatusId: progressStatusId, notes: notes, tasks: tasks, completedAt: completedAt, filesCompletedAt: filesCompletedAt, expectedCompletion: expectedCompletion, paymentsCompletedAt: paymentsCompletedAt, approvalsCompletedAt: approvalsCompletedAt, interviewCompletedAt: interviewCompletedAt, preparationStartedAt: preparationStartedAt, clientFirstName: clientFirstName, clientLastName: clientLastName, clientEmail: clientEmail, clientMobilePhone: clientMobilePhone, clientBirthday: clientBirthday }) {
    const [state, dispatch] = (0, $6fFrj.useReducer)($6d76742931538b46$var$reducer, {
        ...$6d76742931538b46$var$initialJob,
        loading: false,
        entityId: entityId,
        entityOwnerId: entityOwnerId,
        taxYearInterviewId: taxYearInterviewId,
        progressStatusId: progressStatusId,
        notes: notes,
        tasks: tasks,
        completedAt: completedAt,
        filesCompletedAt: filesCompletedAt,
        expectedCompletion: expectedCompletion,
        paymentsCompletedAt: paymentsCompletedAt,
        approvalsCompletedAt: approvalsCompletedAt,
        interviewCompletedAt: interviewCompletedAt,
        clientFirstName: clientFirstName,
        clientLastName: clientLastName,
        clientEmail: clientEmail,
        clientMobilePhone: clientMobilePhone,
        clientBirthday: clientBirthday,
        preparationStartedAt: preparationStartedAt
    });
    const valueProvider = (0, $6fFrj.useMemo)(()=>({
            ...state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return (0, $bb3TF.jsx)($6d76742931538b46$export$9534a7e06b098e29.Provider, {
        value: valueProvider,
        children: children
    });
}
$6d76742931538b46$export$f8feb14ab79a59cf.defaultProps = {
    entityOwnerId: undefined,
    completedAt: undefined,
    filesCompletedAt: undefined,
    expectedCompletion: undefined,
    paymentsCompletedAt: undefined,
    approvalsCompletedAt: undefined,
    interviewCompletedAt: undefined,
    preparationStartedAt: undefined,
    children: undefined
};





const $d1af80c30871bea0$export$188d396885848ae9 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('File deleted');
};
const $d1af80c30871bea0$export$7ce91769e50eddca = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error has occurred while trying to delete the file. Please try again');
};


const { DeleteOutlined: $75ede8e5787a6991$var$DeleteOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $75ede8e5787a6991$var$DeleteClientFileButton = ({ s3Key: s3Key, taxYearInterviewIdFromParent: taxYearInterviewIdFromParent, userId: userId })=>{
    const jobContext = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const [deleteClientFile] = (0, $edf372aa0dea9531$export$fa2331e991764c0d)({
        variables: {
            s3Key: s3Key
        },
        refetchQueries: [
            {
                query: (0, $e9d4d19cd26b2dae$export$6253ea43f7f964e6),
                variables: {
                    taxYearInterviewId: taxYearInterviewIdFromParent || jobContext?.taxYearInterviewId,
                    userId: userId ?? jobContext?.entityOwnerId
                }
            },
            {
                query: (0, $e9d4d19cd26b2dae$export$8d96bb6ff728ee2f),
                variables: {
                    userId: userId ?? jobContext?.entityOwnerId
                }
            }
        ],
        awaitRefetchQueries: true,
        onCompleted: (0, $d1af80c30871bea0$export$188d396885848ae9),
        onError: (0, $d1af80c30871bea0$export$7ce91769e50eddca)
    });
    const handleDeleteFile = async ()=>{
        await deleteClientFile();
    };
    return (0, $bb3TF.jsx)((0, $92b07c154bbb4d14$export$2e2bcd8739ae039), {
        tooltip: "Delete file",
        confirmAction: true,
        confirmLabel: "Are you sure?",
        onClick: ()=>handleDeleteFile(),
        children: (0, $bb3TF.jsx)($75ede8e5787a6991$var$DeleteOutlined, {
            style: {
                color: 'red'
            }
        })
    });
};
var $75ede8e5787a6991$export$2e2bcd8739ae039 = $75ede8e5787a6991$var$DeleteClientFileButton;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");






const $76a4fdc32aefbea4$export$188d396885848ae9 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('File deleted');
};
const $76a4fdc32aefbea4$export$7ce91769e50eddca = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error has occurred while trying to delete the file. Please try again');
};


const { DeleteOutlined: $5dd9b4fff12dedaa$var$DeleteOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $5dd9b4fff12dedaa$var$DeleteFirmFileButton = ({ s3Key: s3Key, taxYearInterviewIdFromParent: taxYearInterviewIdFromParent, userId: userId })=>{
    const jobContext = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const [deleteFirmFile] = (0, $edf372aa0dea9531$export$fa2331e991764c0d)({
        variables: {
            s3Key: s3Key
        },
        refetchQueries: [
            {
                query: (0, $e9d4d19cd26b2dae$export$bced65fdea7baad1),
                variables: {
                    taxYearInterviewId: taxYearInterviewIdFromParent || jobContext?.taxYearInterviewId
                }
            },
            {
                query: (0, $e9d4d19cd26b2dae$export$8d96bb6ff728ee2f),
                variables: {
                    userId: userId ?? jobContext?.entityOwnerId
                }
            }
        ],
        awaitRefetchQueries: true,
        onCompleted: (0, $76a4fdc32aefbea4$export$188d396885848ae9),
        onError: (0, $76a4fdc32aefbea4$export$7ce91769e50eddca)
    });
    const handleDeletefile = async ()=>{
        await deleteFirmFile();
    };
    return (0, $bb3TF.jsx)((0, $92b07c154bbb4d14$export$2e2bcd8739ae039), {
        tooltip: "Delete file",
        confirmAction: true,
        confirmLabel: "Are you sure?",
        onClick: ()=>handleDeletefile(),
        children: (0, $bb3TF.jsx)($5dd9b4fff12dedaa$var$DeleteOutlined, {
            style: {
                color: 'red'
            }
        })
    });
};
var $5dd9b4fff12dedaa$export$2e2bcd8739ae039 = $5dd9b4fff12dedaa$var$DeleteFirmFileButton;




var $6Sgv0 = parcelRequire("6Sgv0");
const $66a8655a6d3a0aff$export$291541584f4e762f = (size)=>{
    if (size < 0) return 'Coming soon';
    if (size === 0) return '0 B';
    const i = Math.max(Math.floor(Math.log(size) / Math.log(1024)), 1);
    return `${(size / 1024 ** i).toFixed(2)} ${[
        'B',
        'kB',
        'MB',
        'GB',
        'TB'
    ][i]}`;
};
const $66a8655a6d3a0aff$export$a41d61df4ac70627 = (date)=>(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(date).format('MMM DD, YYYY hh:mm a');




var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");






const $e4acd689aac18fdb$export$188d396885848ae9 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Requested file deleted');
};
const $e4acd689aac18fdb$export$7ce91769e50eddca = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error has occurred while trying to delete the file. Please try again');
};


const { DeleteOutlined: $0fc3ecdb03dceabe$var$DeleteOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $0fc3ecdb03dceabe$var$DeleteClientRequestedFileButton = ({ id: id, taxYearInterviewId: taxYearInterviewId })=>{
    const jobContext = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const [deleteClientRequestedFile] = (0, $edf372aa0dea9531$export$5c97bcc38cdaaa9b)({
        variables: {
            id: id
        },
        refetchQueries: [
            {
                query: (0, $e9d4d19cd26b2dae$export$6253ea43f7f964e6),
                variables: {
                    taxYearInterviewId: taxYearInterviewId || jobContext?.taxYearInterviewId,
                    userId: jobContext?.entityOwnerId
                }
            },
            {
                query: (0, $e9d4d19cd26b2dae$export$8d96bb6ff728ee2f),
                variables: {
                    userId: jobContext?.entityOwnerId
                }
            }
        ],
        awaitRefetchQueries: true,
        onCompleted: (0, $e4acd689aac18fdb$export$188d396885848ae9),
        onError: (0, $e4acd689aac18fdb$export$7ce91769e50eddca)
    });
    const handleDeleteRequestedFile = async ()=>{
        await deleteClientRequestedFile();
    };
    return (0, $bb3TF.jsx)((0, $92b07c154bbb4d14$export$2e2bcd8739ae039), {
        tooltip: "Delete file request",
        confirmAction: true,
        confirmLabel: "Are you sure?",
        onClick: ()=>handleDeleteRequestedFile(),
        children: (0, $bb3TF.jsx)($0fc3ecdb03dceabe$var$DeleteOutlined, {
            style: {
                color: 'red'
            }
        })
    });
};
var $0fc3ecdb03dceabe$export$2e2bcd8739ae039 = $0fc3ecdb03dceabe$var$DeleteClientRequestedFileButton;



var $6fFrj = parcelRequire("6fFrj");
var $2c4b6e52dd599387$export$142270ff5033bc11;
(function(DocumentsTableType) {
    DocumentsTableType[DocumentsTableType["Client"] = 0] = "Client";
    DocumentsTableType[DocumentsTableType["Firm"] = 1] = "Firm";
    DocumentsTableType[DocumentsTableType["All"] = 2] = "All";
})($2c4b6e52dd599387$export$142270ff5033bc11 || ($2c4b6e52dd599387$export$142270ff5033bc11 = {}));
const $2c4b6e52dd599387$var$getColumns = (tableType)=>[
        {
            title: 'File Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b)=>a.name.localeCompare(b.name),
            render: (text, record)=>record.s3Key ? (0, $bb3TF.jsx)((0, $5b6e6a24a9f1162b$export$2e2bcd8739ae039), {
                    id: record.id,
                    name: record.name,
                    s3Key: record.s3Key,
                    source: tableType
                }) : (0, $bb3TF.jsx)("div", {
                    style: {
                        padding: '0 15px'
                    },
                    children: `Pending file request: ${record.name || 'first document'}`
                })
        },
        {
            title: 'Size',
            dataIndex: 'size',
            key: 'size',
            sorter: (a, b)=>{
                if (!a?.size || !b?.size) return 0;
                return parseInt(a.size, 10) - parseInt(b.size, 10);
            },
            render: (size, record)=>record.s3Key ? (0, $66a8655a6d3a0aff$export$291541584f4e762f)(size) : '',
            width: 120,
            align: 'right'
        },
        {
            title: tableType === $2c4b6e52dd599387$export$142270ff5033bc11.Firm ? 'Date Uploaded' : 'Date',
            dataIndex: 'createAt',
            key: 'createAt',
            sorter: (a, b)=>{
                const dateA = new Date(a.createAt);
                const dateB = new Date(b.createAt);
                if (!dateA || !dateB) return 0;
                return dateA.getTime() - dateB.getTime();
            },
            render: (date)=>(0, $66a8655a6d3a0aff$export$a41d61df4ac70627)(date),
            width: 140,
            align: 'right'
        },
        {
            title: 'Mark File Entered',
            dataIndex: 'documentUsed',
            key: 'documentUsed',
            render: (value, record)=>record.s3Key && (0, $bb3TF.jsx)((0, $50648eb04e96a6dd$export$2e2bcd8739ae039), {
                    type: (0, $50648eb04e96a6dd$export$ed60983e9c7b3f30).Used,
                    id: record.id,
                    used: value
                }),
            width: 70,
            align: 'center'
        },
        {
            title: 'Mark File Reviewed',
            dataIndex: 'documentReviewed',
            key: 'documentReviewed',
            render: (value, record)=>record.s3Key && (0, $bb3TF.jsx)((0, $50648eb04e96a6dd$export$2e2bcd8739ae039), {
                    type: (0, $50648eb04e96a6dd$export$ed60983e9c7b3f30).Reviewed,
                    id: record.id,
                    used: value
                }),
            width: 70,
            align: 'center'
        },
        {
            title: 'Delete',
            dataIndex: 'delete',
            key: 'delete',
            render: (_, record)=>{
                if (!record.s3Key) return (0, $bb3TF.jsx)((0, $0fc3ecdb03dceabe$export$2e2bcd8739ae039), {
                    id: record.id,
                    taxYearInterviewId: record.taxYearInterviewId
                });
                return record.s3Key.split('/').find((e)=>e.toLowerCase() === 'firmfiles') ? (0, $bb3TF.jsx)((0, $5dd9b4fff12dedaa$export$2e2bcd8739ae039), {
                    s3Key: record.s3Key,
                    taxYearInterviewIdFromParent: record.taxYearInterviewId
                }) : (0, $bb3TF.jsx)((0, $75ede8e5787a6991$export$2e2bcd8739ae039), {
                    s3Key: record.s3Key,
                    taxYearInterviewIdFromParent: record.taxYearInterviewId
                });
            },
            align: 'center',
            width: 50
        }
    ];
function $2c4b6e52dd599387$var$DocumentsTable({ tableType: tableType, tableData: tableData, loading: loading, selectedRowKeys: selectedRowKeys, setSelectedRowKeys: setSelectedRowKeys }) {
    const [tableParams, setTableParams] = (0, $6fFrj.useState)({
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: true
        }
    });
    const onSelectChange = (newSelectedRowKeys, selectedRows, info)=>{
        // unselect
        if (info.type === 'all' && tableData.length === selectedRowKeys.length) {
            setSelectedRowKeys([]);
            return;
        }
        // select all
        if (info.type === 'all' && newSelectedRowKeys.length > 0) {
            setSelectedRowKeys(tableData.map((x)=>x.id));
            return;
        }
        // otherwise
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        columnWidth: 55,
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps: (record)=>({
                disabled: !record.key
            })
    };
    const handleTableChange = (pagination, filters, sorter)=>{
        setTableParams({
            pagination: pagination
        });
    };
    return (0, $bb3TF.jsx)((0, $2eb2b7b37988b8f9$export$2e2bcd8739ae039), {
        dataSource: tableData,
        columns: $2c4b6e52dd599387$var$getColumns(tableType),
        loading: loading,
        scroll: {
            x: true
        },
        rowSelection: rowSelection,
        pagination: tableParams.pagination,
        onChange: handleTableChange
    });
}
var $2c4b6e52dd599387$export$2e2bcd8739ae039 = $2c4b6e52dd599387$var$DocumentsTable;




const $d62a09867fddedad$var$defaultOptions = {};
const $d62a09867fddedad$export$1256a069206f7e25 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation updateFileName($id: String!, $name: String!) {
  updateFileName(id: $id, name: $name) {
    id
    userId
    firmAccountId
    taxYearInterviewId
    s3Key
    name
    size
    folder
    pages
    documentUsed
    createAt
    updateAt
  }
}
    `;
function $d62a09867fddedad$export$cb470640b7c25464(baseOptions) {
    const options = {
        ...$d62a09867fddedad$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($d62a09867fddedad$export$1256a069206f7e25, options);
}
const $d62a09867fddedad$export$7fe0e0b6f3bdf6dd = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation updateCompiledFilePreSignedUrl($fileRequestId: String!, $compiledHash: String!, $fileSize: Float!) {
  updateCompiledFilePreSignedUrl(
    fileRequestId: $fileRequestId
    compiledHash: $compiledHash
    fileSize: $fileSize
  )
}
    `;
function $d62a09867fddedad$export$95dd438c05b280e2(baseOptions) {
    const options = {
        ...$d62a09867fddedad$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($d62a09867fddedad$export$7fe0e0b6f3bdf6dd, options);
}
const $d62a09867fddedad$export$93007410d1180a71 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation createFileTemplate($templateName: String!, $fileName: String!) {
  CreateFileTemplate(templateName: $templateName, fileName: $fileName)
}
    `;
function $d62a09867fddedad$export$f4dbcc234b01848(baseOptions) {
    const options = {
        ...$d62a09867fddedad$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($d62a09867fddedad$export$93007410d1180a71, options);
}
const $d62a09867fddedad$export$c0799d08c2841425 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateFileTemplate($id: String!, $templateName: String!) {
  UpdateFileTemplate(id: $id, templateName: $templateName) {
    id
    name
    fileName
  }
}
    `;
function $d62a09867fddedad$export$3e9148a9b1c73e06(baseOptions) {
    const options = {
        ...$d62a09867fddedad$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($d62a09867fddedad$export$c0799d08c2841425, options);
}
const $d62a09867fddedad$export$662219291c6dbaec = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation DeleteFileTemplate($id: String!) {
  DeleteFileTemplate(id: $id) {
    id
  }
}
    `;
function $d62a09867fddedad$export$8e6426240acf6a11(baseOptions) {
    const options = {
        ...$d62a09867fddedad$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($d62a09867fddedad$export$662219291c6dbaec, options);
}
const $d62a09867fddedad$export$ce4443171d936e51 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation DocumentApprovalUpload($documentApprovalUploadInput: DocumentApprovalUploadInput!) {
  DocumentApprovalUpload(
    documentApprovalUploadInput: $documentApprovalUploadInput
  )
}
    `;
function $d62a09867fddedad$export$ad78f728a994fc6e(baseOptions) {
    const options = {
        ...$d62a09867fddedad$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($d62a09867fddedad$export$ce4443171d936e51, options);
}
const $d62a09867fddedad$export$8adc0d698fe7b06c = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation DocumentSignatureUpload($documentSignatureUploadInput: DocumentSignatureUploadInput!) {
  DocumentSignatureUpload(
    documentSignatureUploadInput: $documentSignatureUploadInput
  )
}
    `;
function $d62a09867fddedad$export$2ff795a19cb0ef73(baseOptions) {
    const options = {
        ...$d62a09867fddedad$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($d62a09867fddedad$export$8adc0d698fe7b06c, options);
}
const $d62a09867fddedad$export$39ac829ab91f0716 = {
    Mutation: {
        updateFileName: 'updateFileName',
        updateCompiledFilePreSignedUrl: 'updateCompiledFilePreSignedUrl',
        createFileTemplate: 'createFileTemplate',
        UpdateFileTemplate: 'UpdateFileTemplate',
        DeleteFileTemplate: 'DeleteFileTemplate',
        DocumentApprovalUpload: 'DocumentApprovalUpload',
        DocumentSignatureUpload: 'DocumentSignatureUpload'
    }
};



const { EditOutlined: $5b6e6a24a9f1162b$var$EditOutlined, CloseOutlined: $5b6e6a24a9f1162b$var$CloseOutlined, CheckOutlined: $5b6e6a24a9f1162b$var$CheckOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $5b6e6a24a9f1162b$var$FileNameClickableOpen = ({ id: id, s3Key: s3Key, name: name, source: source })=>{
    const [isEdit, setIsEdit] = (0, $6fFrj.useState)(false);
    const [fileName, setFileName] = (0, $6fFrj.useState)(name);
    /*
      From Docs about useState: The value you want the state to be initially. It can be a value of any type,
      but there is a special behavior for functions. This argument is ignored after the initial render.
    */ (0, $6fFrj.useEffect)(()=>{
        setFileName(name);
    }, [
        name
    ]);
    const { dispatch: dispatch } = (0, $6fFrj.useContext)((0, $9f8459ba594d5b47$export$7fd9bd9faa7887cb));
    const [updateFileNameMutation, { loading: loading }] = (0, $d62a09867fddedad$export$cb470640b7c25464)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message, 10)
    });
    const [getSignedFile] = (0, $e9d4d19cd26b2dae$export$a3da8d6004fc9f4a)({
        fetchPolicy: 'no-cache'
    });
    const handleOpen = async ()=>{
        try {
            const result = await getSignedFile({
                variables: {
                    s3Key: s3Key
                }
            });
            const url = result?.data?.SignedFileByS3Key;
            window.open(url, '_blank');
        } catch (e) {
            console.log('caught error... ');
            console.warn(e);
        }
    };
    const updateFileName = async ()=>{
        const result = await updateFileNameMutation({
            variables: {
                id: id,
                name: fileName
            }
        });
        if (source === (0, $2c4b6e52dd599387$export$142270ff5033bc11).Client) dispatch({
            type: 'UPDATE',
            payload: {
                clientFilesChanged: true
            }
        });
        if (source === (0, $2c4b6e52dd599387$export$142270ff5033bc11).Firm) dispatch({
            type: 'UPDATE',
            payload: {
                firmFilesChanged: true
            }
        });
        if (source === (0, $2c4b6e52dd599387$export$142270ff5033bc11).All) dispatch({
            type: 'UPDATE',
            payload: {
                allFilesChanged: true
            }
        });
        setIsEdit(false);
        setFileName(result.data?.updateFileName?.name || name);
        if (result.data?.updateFileName?.name) (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('FIle name changed', 10);
    };
    return (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        children: [
            isEdit ? (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                value: fileName,
                disabled: loading,
                onChange: (e)=>setFileName(e.target.value),
                suffix: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    children: [
                        (0, $bb3TF.jsx)($5b6e6a24a9f1162b$var$CloseOutlined, {
                            style: {
                                color: (0, $d0cd9ea7d92244eb$export$d40014048739ecba).red
                            },
                            onClick: ()=>{
                                setIsEdit(false);
                                setFileName(name);
                            }
                        }),
                        (0, $bb3TF.jsx)($5b6e6a24a9f1162b$var$CheckOutlined, {
                            style: {
                                color: (0, $d0cd9ea7d92244eb$export$d40014048739ecba).green
                            },
                            onClick: ()=>{
                                updateFileName();
                            }
                        })
                    ]
                })
            }) : (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                type: "link",
                onClick: ()=>handleOpen(),
                children: fileName
            }),
            !isEdit && (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                type: "link",
                icon: (0, $bb3TF.jsx)($5b6e6a24a9f1162b$var$EditOutlined, {
                    style: {
                        fontSize: '16px'
                    }
                }),
                onClick: ()=>{
                    setIsEdit(true);
                },
                title: "Change file name"
            })
        ]
    });
};
var $5b6e6a24a9f1162b$export$2e2bcd8739ae039 = $5b6e6a24a9f1162b$var$FileNameClickableOpen;




const { Circle: $9eafed728426cd2a$var$Circle, CheckCircleOutlined: $9eafed728426cd2a$var$CheckCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $9eafed728426cd2a$var$MarkUsed({ used: used }) {
    if (used) return (0, $bb3TF.jsx)($9eafed728426cd2a$var$CheckCircleOutlined, {
        style: {
            color: 'green'
        }
    });
    return (0, $bb3TF.jsx)($9eafed728426cd2a$var$Circle, {});
}
const $9eafed728426cd2a$var$columns = [
    {
        title: 'File Name',
        dataIndex: 'fileName',
        key: 'fileName',
        sorter: (a, b)=>a.fileName.localeCompare(b.fileName),
        render: (text, record)=>(0, $bb3TF.jsx)((0, $5b6e6a24a9f1162b$export$2e2bcd8739ae039), {
                id: record.id,
                name: record.fileName,
                s3Key: record.s3Key,
                source: (0, $2c4b6e52dd599387$export$142270ff5033bc11).All
            }),
        width: '60%'
    },
    {
        title: 'Size',
        dataIndex: 'size',
        key: 'size',
        sorter: (a, b)=>a.size.localeCompare(b.size)
    },
    {
        title: 'Date Uploaded',
        dataIndex: 'createAt',
        key: 'createAt',
        sorter: (a, b)=>a.createAt.localeCompare(b.createAt)
    }
];
const $9eafed728426cd2a$var$AllFilesTable = ({ tableData: tableData, loading: loading })=>{
    const parseData = tableData.map((item)=>({
            id: item.id,
            key: item.id,
            fileName: item.name,
            size: (0, $66a8655a6d3a0aff$export$291541584f4e762f)(item.size),
            createAt: (0, $66a8655a6d3a0aff$export$a41d61df4ac70627)(item.createAt),
            documentUsed: item.documentUsed,
            delete: 'Delete',
            s3Key: item.s3Key,
            taxYearInterviewId: item.taxYearInterviewId,
            userId: item.userId
        }));
    if (tableData.length === 0) return (0, $bb3TF.jsx)((0, $9150234f0969a884$export$2e2bcd8739ae039), {
        description: "No documents yet"
    });
    return (0, $bb3TF.jsx)((0, $2eb2b7b37988b8f9$export$2e2bcd8739ae039), {
        dataSource: parseData,
        columns: $9eafed728426cd2a$var$columns,
        loading: loading,
        scroll: {
            x: true
        },
        noDataProps: {
            title: 'No Files Yet',
            extra: 'Please add files directly into specific jobs as Firm Files or Client Files.'
        }
    });
};
var $9eafed728426cd2a$export$2e2bcd8739ae039 = $9eafed728426cd2a$var$AllFilesTable;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




var $6Sgv0 = parcelRequire("6Sgv0");
const { Text: $3123f9ee3bd82b9f$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
function $3123f9ee3bd82b9f$var$Divider() {
    return (0, $bb3TF.jsx)("div", {
        style: {
            height: '15px'
        }
    });
}
const $3123f9ee3bd82b9f$var$getPhoneLabel = (phoneType)=>{
    switch(phoneType){
        case 'LANDLINE':
            return 'LANDLINE';
        case 'WORK':
            return 'WORK';
        case 'MOBILE':
            return 'MOBILE';
        default:
            return 'Other';
    }
};
const $3123f9ee3bd82b9f$var$ClientInfoPanel = ()=>{
    const taxPayerContext = (0, $6fFrj.useContext)((0, $9f8459ba594d5b47$export$7fd9bd9faa7887cb));
    const { loading: loading, firstName: firstName, lastName: lastName, phones: phones, email: email, birthday: birthday, languageDescription: languageDescription } = taxPayerContext;
    if (loading) return (0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039), {
        active: true,
        paragraph: {
            rows: 4
        }
    });
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    10,
                    10
                ],
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        lg: 5,
                        md: 8,
                        sm: 8,
                        xs: 10,
                        children: (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Text, {
                            strong: true,
                            children: "First Name:"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        lg: 19,
                        md: 16,
                        sm: 16,
                        xs: 14,
                        children: (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Text, {
                            children: firstName
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Divider, {}),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    10,
                    10
                ],
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        lg: 5,
                        md: 8,
                        sm: 8,
                        xs: 10,
                        children: (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Text, {
                            strong: true,
                            children: "Last Name:"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        lg: 19,
                        md: 16,
                        sm: 16,
                        xs: 14,
                        children: (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Text, {
                            children: lastName
                        })
                    })
                ]
            }),
            phones.map((phone, index)=>(0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                    children: [
                        (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Divider, {}),
                        (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            gutter: [
                                10,
                                10
                            ],
                            children: [
                                (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                    lg: 5,
                                    md: 8,
                                    sm: 8,
                                    xs: 10,
                                    children: (0, $bb3TF.jsxs)($3123f9ee3bd82b9f$var$Text, {
                                        strong: true,
                                        children: [
                                            "Phone",
                                            index + 1,
                                            ' ',
                                            "(",
                                            $3123f9ee3bd82b9f$var$getPhoneLabel(phone.type),
                                            "):"
                                        ]
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                    lg: 19,
                                    md: 16,
                                    sm: 16,
                                    xs: 14,
                                    children: (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Text, {
                                        children: (0, $8ffa95678d96c8dd$export$88012462592bc004)(phone.value)
                                    })
                                })
                            ]
                        })
                    ]
                })),
            (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Divider, {}),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    10,
                    10
                ],
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        lg: 5,
                        md: 8,
                        sm: 8,
                        xs: 10,
                        children: (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Text, {
                            strong: true,
                            children: "Email:"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        lg: 19,
                        md: 16,
                        sm: 16,
                        xs: 14,
                        children: (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Text, {
                            children: email
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Divider, {}),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    10,
                    10
                ],
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        lg: 5,
                        md: 8,
                        sm: 8,
                        xs: 10,
                        children: (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Text, {
                            strong: true,
                            children: "Birthday:"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        lg: 19,
                        md: 16,
                        sm: 16,
                        xs: 14,
                        children: (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Text, {
                            children: birthday ? (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0))).utc(birthday).format('MM/DD/YYYY') : ''
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Divider, {}),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    10,
                    10
                ],
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        lg: 5,
                        md: 8,
                        sm: 8,
                        xs: 10,
                        children: (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Text, {
                            strong: true,
                            children: "Language:"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        lg: 19,
                        md: 16,
                        sm: 16,
                        xs: 14,
                        children: (0, $bb3TF.jsx)($3123f9ee3bd82b9f$var$Text, {
                            children: languageDescription
                        })
                    })
                ]
            })
        ]
    });
};
var $3123f9ee3bd82b9f$export$2e2bcd8739ae039 = $3123f9ee3bd82b9f$var$ClientInfoPanel;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



var $6Sgv0 = parcelRequire("6Sgv0");




const $a7117cc31fbda114$var$defaultOptions = {};
const $a7117cc31fbda114$export$9b4e6215fff8e69 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation removeClient($entityId: String!) {
  removeClient(entityId: $entityId) {
    id
  }
}
    `;
function $a7117cc31fbda114$export$ceec8f61132c06d9(baseOptions) {
    const options = {
        ...$a7117cc31fbda114$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($a7117cc31fbda114$export$9b4e6215fff8e69, options);
}
const $a7117cc31fbda114$export$39ac829ab91f0716 = {
    Mutation: {
        removeClient: 'removeClient'
    }
};






const { DeleteOutlined: $157953ebf3be0a49$var$DeleteOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Text: $157953ebf3be0a49$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { Option: $157953ebf3be0a49$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const $157953ebf3be0a49$var$EditClientInfoPanel = ({ handleExitEditMode: handleExitEditMode })=>{
    const taxPayerContext = (0, $6fFrj.useContext)((0, $9f8459ba594d5b47$export$7fd9bd9faa7887cb));
    const { loading: loading, ownerId: ownerId, userInformationId: userInformationId, firstName: firstName, lastName: lastName, phones: phones, email: email, languageId: languageId, birthday: birthday, entityId: entityId, secretOTP: secretOTP } = taxPayerContext;
    const [form] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    const [deleteClientModalVisible, setDeleteClientModalVisible] = (0, $6fFrj.useState)(false);
    const [phoneInputs, setPhoneInputs] = (0, $6fFrj.useState)([]);
    const [updateUserInformation, { loading: loadingUpdateUserInfo }] = (0, $33beb5b1bfae180c$export$e3e115fc54c52e18)();
    const [updateUser, { loading: loadingUpdateUser }] = (0, $33beb5b1bfae180c$export$d51a7f6b32955917)();
    const [removeClient, { loading: loadingRemoveClient }] = (0, $a7117cc31fbda114$export$ceec8f61132c06d9)({
        onError: (error)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message),
        onCompleted: ()=>{
            handleExitEditMode();
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Client successfully deleted.');
            setTimeout(()=>{
                // redirect back to the dasboard
                window.location.href = '/';
            }, 700);
        }
    });
    const [removeClient2FA, { loading: loadingRemoveClient2FA }] = (0, $edf372aa0dea9531$export$c590036ed7747782)({
        onError: (error)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message),
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Two-Factor Authentication successfully turned off.');
        }
    });
    const { languages: languages, userRole: userRole } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$ca779d385d6ad982));
    const updatePhonesFormValues = (updatedPhones, deletedIndex = -1)=>{
        const formValues = form.getFieldsValue(true);
        const phonesUpdate = Object.assign({}, ...updatedPhones.map((_, index)=>({
                [`phones[${index}].type`]: deletedIndex > index ? formValues[`phones[${index}].type`] : formValues[`phones[${index + 1}].type`],
                [`phones[${index}].value`]: deletedIndex > index ? formValues[`phones[${index}].value`] : formValues[`phones[${index + 1}].value`]
            })));
        form.setFieldsValue(phonesUpdate);
    };
    (0, $6fFrj.useEffect)(()=>{
        setPhoneInputs(phones);
    }, [
        phones
    ]);
    const handleDeleteClient = async ()=>{
        await removeClient({
            variables: {
                entityId: entityId
            }
        });
        setDeleteClientModalVisible(false);
    };
    const addPhone = ()=>{
        const updatedValue = [
            ...phoneInputs,
            {
                type: (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Mobile,
                value: ''
            }
        ];
        setPhoneInputs(updatedValue);
        form.setFieldsValue({
            [`phones[${phoneInputs.length}].type`]: (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Mobile,
            [`phones[${phoneInputs.length}].value`]: ''
        });
    };
    const removePhone = (index)=>{
        const updatedValue = phoneInputs.filter((_, i)=>i !== index);
        form.setFieldsValue({
            [`phones[${index}].type`]: (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Mobile,
            [`phones[${index}].value`]: ''
        });
        setPhoneInputs(updatedValue);
        updatePhonesFormValues(updatedValue, index);
    };
    const handleTurnOff2FA = ()=>{
        removeClient2FA({
            variables: {
                userId: ownerId
            }
        });
    };
    const onSubmit = async (values)=>{
        // get phones into an array of PhonesEntity
        const submittedPhoneValues = [];
        phoneInputs.forEach((phone, index)=>{
            submittedPhoneValues.push({
                id: phone.id,
                type: values[`phones[${index}].type`],
                value: values[`phones[${index}].value`]
            });
        });
        // check if all submitted phone numbers are valid
        const allValid = submittedPhoneValues.every((phone)=>(0, $8ffa95678d96c8dd$export$e102acdf1aeb3167)(phone.value));
        if (!allValid) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Phone number is not valid');
            return;
        }
        // check to see if any inital phones were removed
        for(let i = 0; i < phones.length; i += 1)// if the phone is not in the submitted phone values, it was removed
        if (!submittedPhoneValues.find((phone)=>phone.id === phones[i].id)) submittedPhoneValues.push({
            id: phones[i].id,
            type: phones[i].type,
            value: phones[i].value,
            deleted: true
        });
        try {
            const promises = [];
            // first we update the user information
            promises.push(updateUserInformation({
                variables: {
                    updateUserInformationInput: {
                        id: userInformationId,
                        firstName: values.firstName,
                        lastName: values.lastName,
                        birthday: values.dob,
                        Phones: submittedPhoneValues
                    }
                },
                refetchQueries: [
                    'GetAllEntityDataByEntityId'
                ]
            }));
            // now we update the user
            promises.push(updateUser({
                variables: {
                    updateUserInput: {
                        id: ownerId,
                        languageId: values.language,
                        email: values.email
                    }
                },
                refetchQueries: [
                    'GetAllEntityDataByEntityId'
                ]
            }));
            await Promise.all(promises);
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Client Updated!');
            handleExitEditMode();
        } catch (error) {
            console.log('error:', error);
            if (error.message.includes('Unique constraint failed on the fields: (`email`)')) {
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Email is already being used. If this email does not already exist in your firm, you may contact customer support for further assistance.', 10);
                return;
            }
            if (error.message === 'Error code 1003') {
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Email is invalid.');
                return;
            }
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.toString());
        }
    }; // end onSubmit
    if (loading) return (0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039), {
        active: true,
        paragraph: {
            rows: 4
        }
    });
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                sm: 23,
                md: 20,
                lg: 14,
                children: [
                    (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                        layout: "vertical",
                        form: form,
                        onFinish: onSubmit,
                        // eslint-disable-next-line no-template-curly-in-string
                        validateMessages: {
                            required: '${label} is required'
                        },
                        children: [
                            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                name: "firstName",
                                label: "First Name",
                                rules: [
                                    {
                                        required: true
                                    }
                                ],
                                initialValue: firstName,
                                children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                    placeholder: "Taxpayer First Name"
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                name: "lastName",
                                label: "Last Name",
                                rules: [
                                    {
                                        required: true
                                    }
                                ],
                                initialValue: lastName,
                                children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                    placeholder: "Taxpayer Last Name"
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                name: "email",
                                label: "Email",
                                rules: [
                                    {
                                        required: true
                                    }
                                ],
                                initialValue: email,
                                children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {})
                            }),
                            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                name: "dob",
                                label: "Date of Birth",
                                rules: [
                                    {
                                        required: false
                                    }
                                ],
                                initialValue: birthday ? (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0))).utc(birthday) : null,
                                valuePropName: "date",
                                children: (0, $bb3TF.jsx)((0, $dd1293f125eb7a8a$export$2e2bcd8739ae039), {
                                    placeholder: "MM/DD/YYYY",
                                    format: "MM/DD/YYYY",
                                    style: {
                                        width: '100%'
                                    },
                                    defaultValue: birthday ? (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0))).utc(birthday) : null,
                                    onChange: (date)=>form.setFieldsValue({
                                            dob: date ? (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(date).startOf('day').utc() : null
                                        })
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {
                                dashed: true
                            }),
                            phoneInputs?.map((phone, index)=>(0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    gutter: 5,
                                    align: "middle",
                                    children: [
                                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                            span: 13,
                                            children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                                name: `phones[${index}].value`,
                                                label: `Phone number ${index + 1}`,
                                                rules: [
                                                    {
                                                        required: false
                                                    }
                                                ],
                                                initialValue: phone.value,
                                                children: (0, $bb3TF.jsx)((0, $5ba7d8eeafddcf67$export$2e2bcd8739ae039), {})
                                            }, `phone-value-${phone?.id}`)
                                        }),
                                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                            span: 10,
                                            children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                                name: `phones[${index}].type`,
                                                label: "Type",
                                                initialValue: phone.type,
                                                children: (0, $bb3TF.jsxs)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                                    children: [
                                                        (0, $bb3TF.jsx)($157953ebf3be0a49$var$Option, {
                                                            value: (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Landline,
                                                            children: "Landline"
                                                        }),
                                                        (0, $bb3TF.jsx)($157953ebf3be0a49$var$Option, {
                                                            value: (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Work,
                                                            children: "Work"
                                                        }),
                                                        (0, $bb3TF.jsx)($157953ebf3be0a49$var$Option, {
                                                            value: (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Mobile,
                                                            children: "Mobile"
                                                        })
                                                    ]
                                                })
                                            }, `phone-type-${phone?.id}`)
                                        }),
                                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                            span: 1,
                                            style: {
                                                marginTop: 5
                                            },
                                            children: (0, $bb3TF.jsx)($157953ebf3be0a49$var$DeleteOutlined, {
                                                style: {
                                                    color: 'red'
                                                },
                                                onClick: ()=>removePhone(index)
                                            })
                                        })
                                    ]
                                }, `phone-row-${phone?.id}`)),
                            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                type: "link",
                                onClick: ()=>addPhone(),
                                disabled: phoneInputs.length > 5,
                                children: "Add Phone"
                            }),
                            (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {
                                dashed: true
                            }),
                            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                name: "language",
                                label: "Language",
                                rules: [
                                    {
                                        required: false
                                    }
                                ],
                                initialValue: languageId,
                                children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                    placeholder: "Select language",
                                    onChange: (value)=>form.setFieldsValue({
                                            taxYear: value
                                        }),
                                    children: languages.map((language)=>(0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039).Option, {
                                            value: language.id,
                                            children: language.description
                                        }, language.id))
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    htmlType: "submit",
                                    loading: loadingUpdateUserInfo || loadingUpdateUser,
                                    children: "Save"
                                })
                            })
                        ]
                    }),
                    (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {}),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        gutter: 20,
                        style: {
                            marginBottom: '20px'
                        },
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                children: (0, $bb3TF.jsx)($157953ebf3be0a49$var$Text, {
                                    strong: true,
                                    children: "Two-Factor Authentication"
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                children: (0, $bb3TF.jsx)((0, $a361442371f1d4e9$export$2e2bcd8739ae039), {
                                    placement: "right",
                                    title: "Are you sure you want to turn off two-factor authentication for this client?",
                                    okText: "Yes",
                                    cancelText: "No",
                                    onConfirm: handleTurnOff2FA,
                                    disabled: !secretOTP,
                                    children: (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
                                        content: !secretOTP ? 'Client hasn\'t enabled Two-Factor Authentication yet' : 'Turn off yout client\'s two-factor authentication',
                                        placement: "top",
                                        children: (0, $bb3TF.jsx)((0, $4fd303306a27e42e$export$2e2bcd8739ae039), {
                                            disabled: !secretOTP,
                                            checked: Boolean(secretOTP),
                                            loading: loadingRemoveClient2FA
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    (userRole === 'TAX_PREPARER' || userRole === 'ADMIN') && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                        children: [
                            (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {}),
                            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                type: "default",
                                danger: true,
                                onClick: ()=>setDeleteClientModalVisible(true),
                                children: "Delete Client"
                            })
                        ]
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                sm: 1,
                md: 4,
                lg: 10
            }),
            (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
                visible: deleteClientModalVisible,
                title: "Are you sure?",
                onCancel: ()=>setDeleteClientModalVisible(false),
                onOk: handleDeleteClient,
                okText: "Delete Client",
                okType: "primary",
                okButtonProps: {
                    danger: true,
                    loading: loadingRemoveClient
                },
                children: (0, $bb3TF.jsx)($157953ebf3be0a49$var$Text, {
                    children: "You are about to permanently delete this client."
                })
            })
        ]
    });
};
var $157953ebf3be0a49$export$2e2bcd8739ae039 = $157953ebf3be0a49$var$EditClientInfoPanel;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

const { TextArea: $151752236f277880$var$TextArea } = (0, $1fb834916a156dcf$export$2e2bcd8739ae039);
const $151752236f277880$var$NotesPanel = ({ initialNotes: initialNotes, onSaveNotes: onSaveNotes, loading: loading })=>{
    const [savedNotes, setSavedNotes] = (0, $6fFrj.useState)(initialNotes);
    const [notes, setNotes] = (0, $6fFrj.useState)(initialNotes);
    const onSaveClick = ()=>{
        if (onSaveNotes) onSaveNotes(notes);
        setSavedNotes(notes);
    };
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)($151752236f277880$var$TextArea, {
                autoSize: {
                    minRows: 4,
                    maxRows: 25
                },
                placeholder: "Enter client notes here...",
                value: notes,
                onChange: (e)=>setNotes(e.target.value)
            }),
            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                style: {
                    marginTop: 10
                },
                type: "primary",
                size: "small",
                onClick: onSaveClick,
                disabled: notes === savedNotes,
                loading: loading,
                children: "Save"
            })
        ]
    });
};
$151752236f277880$var$NotesPanel.defaultProps = {
    initialNotes: null,
    onSaveNotes: null,
    loading: false
};
var $151752236f277880$export$2e2bcd8739ae039 = $151752236f277880$var$NotesPanel;


const { Title: $b82c4e45f6e5d15e$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { Panel: $b82c4e45f6e5d15e$var$Panel } = (0, $45def89f679453ce$export$2e2bcd8739ae039);
const { EditOutlined: $b82c4e45f6e5d15e$var$EditOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $b82c4e45f6e5d15e$var$ClientInfo = ({ initialActiveKeys: initialActiveKeys })=>{
    const [editingClientInfo, setEditingClientInfo] = (0, $6fFrj.useState)(false);
    const [activeKey, setActiveKey] = (0, $6fFrj.useState)(initialActiveKeys);
    const [clientFiles, setClientFiles] = (0, $6fFrj.useState)([]);
    const { userInformationId: userInformationId, notes: notes, ownerId: ownerId, urlTaxYearInterviewId: urlTaxYearInterviewId, clientFilesChanged: clientFilesChanged, firmFilesChanged: firmFilesChanged, dispatch: dispatch } = (0, $6fFrj.useContext)((0, $9f8459ba594d5b47$export$7fd9bd9faa7887cb));
    const [updateNotes, { loading: loading }] = (0, $edf372aa0dea9531$export$488d2ca0cc91d182)();
    const clientInfoExtra = ()=>(0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
            size: "small",
            type: "link",
            icon: (0, $bb3TF.jsx)($b82c4e45f6e5d15e$var$EditOutlined, {}),
            onClick: (event)=>{
                // If you don't want click extra trigger collapse, you can prevent this:
                if (activeKey.includes('client-info')) event.stopPropagation();
                setEditingClientInfo(!editingClientInfo);
            },
            children: editingClientInfo ? 'Cancel' : 'Edit'
        });
    const handleChange = (value)=>{
        setActiveKey(value);
    };
    const handleSaveNotes = (notesValue)=>{
        try {
            updateNotes({
                variables: {
                    userInformationId: userInformationId,
                    notes: notesValue
                },
                onCompleted: ()=>{
                    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('The client notes have been successfully saved.');
                }
            });
        } catch (err) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to update the client notes.');
        }
    };
    const [getAllFilesByClient, { loading: loadingFirmFilesData }] = (0, $e9d4d19cd26b2dae$export$984d3f3bb18f6f8f)();
    const getAllClientFiles = ()=>{
        getAllFilesByClient({
            variables: {
                userId: ownerId
            },
            fetchPolicy: 'cache-and-network',
            onCompleted: (data)=>{
                let files = data?.getAllFilesByClient;
                if (files) {
                    if (urlTaxYearInterviewId !== '') files = files.filter((file)=>file.taxYearInterviewId === urlTaxYearInterviewId);
                    setClientFiles(files);
                }
            },
            onError: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error ocurred while loading firm files');
            }
        });
    };
    (0, $6fFrj.useEffect)(()=>{
        if (ownerId) getAllClientFiles();
    }, [
        ownerId
    ]);
    (0, $6fFrj.useEffect)(()=>{
        setActiveKey(initialActiveKeys);
    }, [
        initialActiveKeys
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (clientFilesChanged || firmFilesChanged) {
            if (ownerId) getAllClientFiles();
            dispatch({
                type: 'UPDATE',
                payload: {
                    clientFilesChanged: false,
                    firmFilesChanged: false
                }
            });
        }
    }, [
        clientFilesChanged,
        firmFilesChanged
    ]);
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)($b82c4e45f6e5d15e$var$Title, {
                level: 3,
                children: "Permanent Client Information"
            }),
            (0, $bb3TF.jsxs)((0, $45def89f679453ce$export$2e2bcd8739ae039), {
                activeKey: activeKey,
                onChange: handleChange,
                children: [
                    (0, $bb3TF.jsx)($b82c4e45f6e5d15e$var$Panel, {
                        header: "Client Info",
                        extra: clientInfoExtra(),
                        children: editingClientInfo ? (0, $bb3TF.jsx)((0, $157953ebf3be0a49$export$2e2bcd8739ae039), {
                            handleExitEditMode: ()=>{
                                setEditingClientInfo(false);
                            }
                        }) : (0, $bb3TF.jsx)((0, $3123f9ee3bd82b9f$export$2e2bcd8739ae039), {})
                    }, "client-info"),
                    (0, $bb3TF.jsx)($b82c4e45f6e5d15e$var$Panel, {
                        header: "All Files",
                        className: "not-printable",
                        children: (0, $bb3TF.jsx)((0, $9eafed728426cd2a$export$2e2bcd8739ae039), {
                            loading: loadingFirmFilesData,
                            tableData: clientFiles
                        })
                    }, "all-documents"),
                    (0, $bb3TF.jsx)($b82c4e45f6e5d15e$var$Panel, {
                        header: "General Client Notes - Visible only to you and your team",
                        children: (0, $bb3TF.jsx)((0, $151752236f277880$export$2e2bcd8739ae039), {
                            initialNotes: notes,
                            onSaveNotes: handleSaveNotes,
                            loading: loading
                        })
                    }, "notes")
                ]
            })
        ]
    });
};
var $b82c4e45f6e5d15e$export$2e2bcd8739ae039 = $b82c4e45f6e5d15e$var$ClientInfo;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

var $fbba26b5140efba3$exports = {};
'use strict';

$fbba26b5140efba3$exports = (parcelRequire("10A66"));



var $6fFrj = parcelRequire("6fFrj");
var $f63e9a93fcb34f46$exports = {};
//
$f63e9a93fcb34f46$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $82387f792ceda3ae$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $82387f792ceda3ae$export$2e2bcd8739ae039 = $82387f792ceda3ae$var$stylis_min;


var $4c63b2ab421697da$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $4c63b2ab421697da$export$2e2bcd8739ae039 = $4c63b2ab421697da$var$unitlessKeys;


function $8c08c44b7865fb8f$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $8c08c44b7865fb8f$export$2e2bcd8739ae039 = $8c08c44b7865fb8f$var$memoize;


var $f9a39b80806b7300$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $f9a39b80806b7300$var$isPropValid = /* #__PURE__ */ (0, $8c08c44b7865fb8f$export$2e2bcd8739ae039)(function(prop) {
    return $f9a39b80806b7300$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $f9a39b80806b7300$export$2e2bcd8739ae039 = $f9a39b80806b7300$var$isPropValid;



var $7nfXW = parcelRequire("7nfXW");

var $8LKEK = parcelRequire("8LKEK");
function $7ae336b16849d71a$var$v() {
    return ($7ae336b16849d71a$var$v = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $7ae336b16849d71a$var$g = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $7ae336b16849d71a$var$S = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $fbba26b5140efba3$exports.typeOf)(t);
}, $7ae336b16849d71a$var$w = Object.freeze([]), $7ae336b16849d71a$var$E = Object.freeze({});
function $7ae336b16849d71a$var$b(e) {
    return "function" == typeof e;
}
function $7ae336b16849d71a$var$_(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $7ae336b16849d71a$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $7ae336b16849d71a$var$A = ("undefined" != typeof $8LKEK && undefined, "data-styled"), $7ae336b16849d71a$export$83d89fbfd8236492 = "5.3.6", $7ae336b16849d71a$var$I = "undefined" != typeof window && "HTMLElement" in window, $7ae336b16849d71a$var$P = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : (typeof $8LKEK, typeof $8LKEK, false)), $7ae336b16849d71a$var$O = {}, $7ae336b16849d71a$var$R = {};
function $7ae336b16849d71a$var$D() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $7ae336b16849d71a$var$j(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $7ae336b16849d71a$var$T = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $7ae336b16849d71a$var$j(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $7ae336b16849d71a$var$x = new Map, $7ae336b16849d71a$var$k = new Map, $7ae336b16849d71a$var$V = 1, $7ae336b16849d71a$var$B = function(e) {
    if ($7ae336b16849d71a$var$x.has(e)) return $7ae336b16849d71a$var$x.get(e);
    for(; $7ae336b16849d71a$var$k.has($7ae336b16849d71a$var$V);)$7ae336b16849d71a$var$V++;
    var t = $7ae336b16849d71a$var$V++;
    return $7ae336b16849d71a$var$x.set(e, t), $7ae336b16849d71a$var$k.set(t, e), t;
}, $7ae336b16849d71a$var$z = function(e) {
    return $7ae336b16849d71a$var$k.get(e);
}, $7ae336b16849d71a$var$M = function(e, t) {
    t >= $7ae336b16849d71a$var$V && ($7ae336b16849d71a$var$V = t + 1), $7ae336b16849d71a$var$x.set(e, t), $7ae336b16849d71a$var$k.set(t, e);
}, $7ae336b16849d71a$var$G = "style[" + $7ae336b16849d71a$var$A + '][data-styled-version="5.3.6"]', $7ae336b16849d71a$var$L = new RegExp("^" + $7ae336b16849d71a$var$A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $7ae336b16849d71a$var$F = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $7ae336b16849d71a$var$Y = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($7ae336b16849d71a$var$L);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($7ae336b16849d71a$var$M(u, c), $7ae336b16849d71a$var$F(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $7ae336b16849d71a$var$q = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $7ae336b16849d71a$var$H = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($7ae336b16849d71a$var$A)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($7ae336b16849d71a$var$A, "active"), r.setAttribute("data-styled-version", "5.3.6");
    var i = $7ae336b16849d71a$var$q();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $7ae336b16849d71a$var$$ = function() {
    function e(e) {
        var t = this.element = $7ae336b16849d71a$var$H(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $7ae336b16849d71a$var$j(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $7ae336b16849d71a$var$W = function() {
    function e(e) {
        var t = this.element = $7ae336b16849d71a$var$H(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $7ae336b16849d71a$var$U = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $7ae336b16849d71a$var$J = $7ae336b16849d71a$var$I, $7ae336b16849d71a$var$X = {
    isServer: !$7ae336b16849d71a$var$I,
    useCSSOMInjection: !$7ae336b16849d71a$var$P
}, $7ae336b16849d71a$var$Z = function() {
    function e(e, t, n) {
        void 0 === e && (e = $7ae336b16849d71a$var$E), void 0 === t && (t = {}), this.options = $7ae336b16849d71a$var$v({}, $7ae336b16849d71a$var$X, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $7ae336b16849d71a$var$I && $7ae336b16849d71a$var$J && ($7ae336b16849d71a$var$J = !1, function(e) {
            for(var t = document.querySelectorAll($7ae336b16849d71a$var$G), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($7ae336b16849d71a$var$A) && ($7ae336b16849d71a$var$Y(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $7ae336b16849d71a$var$B(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($7ae336b16849d71a$var$v({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $7ae336b16849d71a$var$U(o) : r ? new $7ae336b16849d71a$var$$(o) : new $7ae336b16849d71a$var$W(o), new $7ae336b16849d71a$var$T(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($7ae336b16849d71a$var$B(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($7ae336b16849d71a$var$B(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($7ae336b16849d71a$var$B(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $7ae336b16849d71a$var$z(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $7ae336b16849d71a$var$A + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $7ae336b16849d71a$var$K = /(a)(d)/gi, $7ae336b16849d71a$var$Q = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $7ae336b16849d71a$var$ee(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $7ae336b16849d71a$var$Q(t % 52) + n;
    return ($7ae336b16849d71a$var$Q(t % 52) + n).replace($7ae336b16849d71a$var$K, "$1-$2");
}
var $7ae336b16849d71a$var$te = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $7ae336b16849d71a$var$ne = function(e) {
    return $7ae336b16849d71a$var$te(5381, e);
};
function $7ae336b16849d71a$var$re(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($7ae336b16849d71a$var$b(n) && !$7ae336b16849d71a$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $7ae336b16849d71a$var$oe = $7ae336b16849d71a$var$ne("5.3.6"), $7ae336b16849d71a$var$se = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $7ae336b16849d71a$var$re(e), this.componentId = t, this.baseHash = $7ae336b16849d71a$var$te($7ae336b16849d71a$var$oe, t), this.baseStyle = n, $7ae336b16849d71a$var$Z.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $7ae336b16849d71a$var$Ne(this.rules, e, t, n).join(""), i = $7ae336b16849d71a$var$ee($7ae336b16849d71a$var$te(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $7ae336b16849d71a$var$te(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $7ae336b16849d71a$var$Ne(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $7ae336b16849d71a$var$te(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $7ae336b16849d71a$var$ee(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $7ae336b16849d71a$var$ie = /^\s*\/\/.*$/gm, $7ae336b16849d71a$var$ae = [
    ":",
    "[",
    ".",
    "#"
];
function $7ae336b16849d71a$var$ce(e) {
    var t, n, r, o, s = void 0 === e ? $7ae336b16849d71a$var$E : e, i = s.options, a = void 0 === i ? $7ae336b16849d71a$var$E : i, c = s.plugins, u = void 0 === c ? $7ae336b16849d71a$var$w : c, l = new (0, $82387f792ceda3ae$export$2e2bcd8739ae039)(a), d = [], h = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $7ae336b16849d71a$var$ae.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($7ae336b16849d71a$var$ie, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        h,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $7ae336b16849d71a$var$j(15), $7ae336b16849d71a$var$te(e, t.name);
    }, 5381).toString() : "", m;
}
var $7ae336b16849d71a$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createContext(), $7ae336b16849d71a$export$91317688fc694efa = $7ae336b16849d71a$export$8c190ef828af4c86.Consumer, $7ae336b16849d71a$var$de = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createContext(), $7ae336b16849d71a$var$he = ($7ae336b16849d71a$var$de.Consumer, new $7ae336b16849d71a$var$Z), $7ae336b16849d71a$var$pe = $7ae336b16849d71a$var$ce();
function $7ae336b16849d71a$var$fe() {
    return (0, $6fFrj.useContext)($7ae336b16849d71a$export$8c190ef828af4c86) || $7ae336b16849d71a$var$he;
}
function $7ae336b16849d71a$var$me() {
    return (0, $6fFrj.useContext)($7ae336b16849d71a$var$de) || $7ae336b16849d71a$var$pe;
}
function $7ae336b16849d71a$export$a473771da2f0ff7c(e) {
    var t = (0, $6fFrj.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $7ae336b16849d71a$var$fe(), u = (0, $6fFrj.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $6fFrj.useMemo)(function() {
        return $7ae336b16849d71a$var$ce({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $6fFrj.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($f63e9a93fcb34f46$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($7ae336b16849d71a$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($7ae336b16849d71a$var$de.Provider, {
        value: l
    }, (0, e.children)));
}
var $7ae336b16849d71a$var$ve = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $7ae336b16849d71a$var$pe);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $7ae336b16849d71a$var$j(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $7ae336b16849d71a$var$pe), this.name + e.hash;
    }, e;
}(), $7ae336b16849d71a$var$ge = /([A-Z])/, $7ae336b16849d71a$var$Se = /([A-Z])/g, $7ae336b16849d71a$var$we = /^ms-/, $7ae336b16849d71a$var$Ee = function(e) {
    return "-" + e.toLowerCase();
};
function $7ae336b16849d71a$var$be(e) {
    return $7ae336b16849d71a$var$ge.test(e) ? e.replace($7ae336b16849d71a$var$Se, $7ae336b16849d71a$var$Ee).replace($7ae336b16849d71a$var$we, "-ms-") : e;
}
var $7ae336b16849d71a$var$_e = function(e) {
    return null == e || !1 === e || "" === e;
};
function $7ae336b16849d71a$var$Ne(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $7ae336b16849d71a$var$Ne(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($7ae336b16849d71a$var$_e(e)) return "";
    if ($7ae336b16849d71a$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($7ae336b16849d71a$var$b(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $7ae336b16849d71a$var$Ne(u, n, r, o);
    }
    var l;
    return e instanceof $7ae336b16849d71a$var$ve ? r ? (e.inject(r, o), e.getName(o)) : e : $7ae336b16849d71a$var$S(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$7ae336b16849d71a$var$_e(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $7ae336b16849d71a$var$b(t[i]) ? s.push($7ae336b16849d71a$var$be(i) + ":", t[i], ";") : $7ae336b16849d71a$var$S(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($7ae336b16849d71a$var$be(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $4c63b2ab421697da$export$2e2bcd8739ae039) ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $7ae336b16849d71a$var$Ae = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $7ae336b16849d71a$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $7ae336b16849d71a$var$b(e) || $7ae336b16849d71a$var$S(e) ? $7ae336b16849d71a$var$Ae($7ae336b16849d71a$var$Ne($7ae336b16849d71a$var$g($7ae336b16849d71a$var$w, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $7ae336b16849d71a$var$Ae($7ae336b16849d71a$var$Ne($7ae336b16849d71a$var$g(e, n)));
}
var $7ae336b16849d71a$var$Ie = /invalid hook call/i, $7ae336b16849d71a$var$Pe = new Set, $7ae336b16849d71a$var$Oe = function(e, t) {
    var n, r, o, e1;
}, $7ae336b16849d71a$var$Re = function(e, t, n) {
    return void 0 === n && (n = $7ae336b16849d71a$var$E), e.theme !== n.theme && e.theme || t || n.theme;
}, $7ae336b16849d71a$var$De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $7ae336b16849d71a$var$je = /(^-|-$)/g;
function $7ae336b16849d71a$var$Te(e) {
    return e.replace($7ae336b16849d71a$var$De, "-").replace($7ae336b16849d71a$var$je, "");
}
var $7ae336b16849d71a$var$xe = function(e) {
    return $7ae336b16849d71a$var$ee($7ae336b16849d71a$var$ne(e) >>> 0);
};
function $7ae336b16849d71a$var$ke(e) {
    return "string" == typeof e && true;
}
var $7ae336b16849d71a$var$Ve = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $7ae336b16849d71a$var$Be = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $7ae336b16849d71a$var$ze(e, t, n) {
    var r = e[n];
    $7ae336b16849d71a$var$Ve(t) && $7ae336b16849d71a$var$Ve(r) ? $7ae336b16849d71a$var$Me(r, t) : e[n] = t;
}
function $7ae336b16849d71a$var$Me(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($7ae336b16849d71a$var$Ve(i)) for(var a in i)$7ae336b16849d71a$var$Be(a) && $7ae336b16849d71a$var$ze(e, i[a], a);
    }
    return e;
}
var $7ae336b16849d71a$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createContext(), $7ae336b16849d71a$export$b631efc24e9d5e2f = $7ae336b16849d71a$export$2c657da244d00bd6.Consumer;
function $7ae336b16849d71a$export$d8964aec282183a3(e) {
    var t = (0, $6fFrj.useContext)($7ae336b16849d71a$export$2c657da244d00bd6), n = (0, $6fFrj.useMemo)(function() {
        return function(e, t) {
            if (!e) return $7ae336b16849d71a$var$j(14);
            if ($7ae336b16849d71a$var$b(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $7ae336b16849d71a$var$j(8) : t ? $7ae336b16849d71a$var$v({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($7ae336b16849d71a$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $7ae336b16849d71a$var$Ye = {};
function $7ae336b16849d71a$var$qe(e, t, n) {
    var o = $7ae336b16849d71a$export$7ba318d8d2f06c76(e), i = !$7ae336b16849d71a$var$ke(e), a = t.attrs, c = void 0 === a ? $7ae336b16849d71a$var$w : a, d = t.componentId, h = void 0 === d ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $7ae336b16849d71a$var$Te(e);
        $7ae336b16849d71a$var$Ye[n] = ($7ae336b16849d71a$var$Ye[n] || 0) + 1;
        var r = n + "-" + $7ae336b16849d71a$var$xe("5.3.6" + n + $7ae336b16849d71a$var$Ye[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : d, p = t.displayName, f = void 0 === p ? function(e) {
        return $7ae336b16849d71a$var$ke(e) ? "styled." + e : "Styled(" + $7ae336b16849d71a$var$_(e) + ")";
    }(e) : p, g = t.displayName && t.componentId ? $7ae336b16849d71a$var$Te(t.displayName) + "-" + t.componentId : t.componentId || h, S = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, A = t.shouldForwardProp;
    o && e.shouldForwardProp && (A = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var C, I = new $7ae336b16849d71a$var$se(n, g, o ? e.componentStyle : void 0), P = I.isStatic && 0 === c.length, O = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, d = e.shouldForwardProp, h = e.styledComponentId, p = e.target;
            var f = function(e, t, n) {
                void 0 === e && (e = $7ae336b16849d71a$var$E);
                var r = $7ae336b16849d71a$var$v({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $7ae336b16849d71a$var$b(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($7ae336b16849d71a$var$Re(t, (0, $6fFrj.useContext)($7ae336b16849d71a$export$2c657da244d00bd6), a) || $7ae336b16849d71a$var$E, t, o), y = f[0], g = f[1], S = function(e, t, n, r) {
                var o = $7ae336b16849d71a$var$fe(), s = $7ae336b16849d71a$var$me(), i = t ? e.generateAndInjectStyles($7ae336b16849d71a$var$E, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, y, void 0), w = n, _ = g.$as || t.$as || g.as || t.as || p, N = $7ae336b16849d71a$var$ke(_), A = g !== t ? $7ae336b16849d71a$var$v({}, t, {}, g) : t, C = {};
            for(var I in A)"$" !== I[0] && "as" !== I && ("forwardedAs" === I ? C.as = A[I] : (d ? d(I, (0, $f9a39b80806b7300$export$2e2bcd8739ae039), _) : !N || (0, $f9a39b80806b7300$export$2e2bcd8739ae039)(I)) && (C[I] = A[I]));
            return t.style && g.style !== t.style && (C.style = $7ae336b16849d71a$var$v({}, t.style, {}, g.style)), C.className = Array.prototype.concat(c, h, S !== h ? S : null, t.className, g.className).filter(Boolean).join(" "), C.ref = w, (0, $6fFrj.createElement)(_, C);
        }(C, e, t, P);
    };
    return O.displayName = f, (C = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef(O)).attrs = S, C.componentStyle = I, C.displayName = f, C.shouldForwardProp = A, C.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $7ae336b16849d71a$var$w, C.styledComponentId = g, C.target = o ? e.target : e, C.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($7ae336b16849d71a$var$ke(e) ? e : $7ae336b16849d71a$var$Te($7ae336b16849d71a$var$_(e)));
        return $7ae336b16849d71a$var$qe(e, $7ae336b16849d71a$var$v({}, o, {
            attrs: S,
            componentId: s
        }), n);
    }, Object.defineProperty(C, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $7ae336b16849d71a$var$Me({}, e.defaultProps, t) : t;
        }
    }), C.toString = function() {
        return "." + C.styledComponentId;
    }, i && (0, (/*@__PURE__*/$parcel$interopDefault($7nfXW)))(C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), C;
}
var $7ae336b16849d71a$var$He = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $7ae336b16849d71a$var$E), !(0, $fbba26b5140efba3$exports.isValidElementType)(r)) return $7ae336b16849d71a$var$j(1, String(r));
        var s = function() {
            return t(r, o, $7ae336b16849d71a$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $7ae336b16849d71a$var$v({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $7ae336b16849d71a$var$v({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($7ae336b16849d71a$var$qe, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $7ae336b16849d71a$var$He[e] = $7ae336b16849d71a$var$He(e);
});
var $7ae336b16849d71a$var$$e = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $7ae336b16849d71a$var$re(e), $7ae336b16849d71a$var$Z.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($7ae336b16849d71a$var$Ne(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $7ae336b16849d71a$var$Z.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $7ae336b16849d71a$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $7ae336b16849d71a$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $7ae336b16849d71a$var$xe(JSON.stringify(i)), u = new $7ae336b16849d71a$var$$e(i, a);
    function l(e) {
        var t = $7ae336b16849d71a$var$fe(), n = $7ae336b16849d71a$var$me(), o = (0, $6fFrj.useContext)($7ae336b16849d71a$export$2c657da244d00bd6), l = (0, $6fFrj.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(l, e, t, o, n), (0, $6fFrj.useLayoutEffect)(function() {
            if (!t.server) return h(l, e, t, o, n), function() {
                return u.removeStyles(l, t);
            };
        }, [
            l,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $7ae336b16849d71a$var$O, n, o);
        else {
            var s = $7ae336b16849d71a$var$v({}, t, {
                theme: $7ae336b16849d71a$var$Re(t, r, l.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).memo(l);
}
function $7ae336b16849d71a$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $7ae336b16849d71a$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $7ae336b16849d71a$var$xe(o);
    return new $7ae336b16849d71a$var$ve(s, o);
}
var $7ae336b16849d71a$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $7ae336b16849d71a$var$q();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $7ae336b16849d71a$var$A + '="true"',
                'data-styled-version="5.3.6"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $7ae336b16849d71a$var$j(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $7ae336b16849d71a$var$j(2);
            var n = ((t = {})[$7ae336b16849d71a$var$A] = "", t["data-styled-version"] = "5.3.6", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $7ae336b16849d71a$var$q();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement("style", $7ae336b16849d71a$var$v({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $7ae336b16849d71a$var$Z({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $7ae336b16849d71a$var$j(2) : (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement($7ae336b16849d71a$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $7ae336b16849d71a$var$j(3);
    }, e;
}(), $7ae336b16849d71a$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).forwardRef(function(t, n) {
        var o = (0, $6fFrj.useContext)($7ae336b16849d71a$export$2c657da244d00bd6), i = e.defaultProps, a = $7ae336b16849d71a$var$Re(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).createElement(e, $7ae336b16849d71a$var$v({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($7nfXW)))(t, e), t.displayName = "WithTheme(" + $7ae336b16849d71a$var$_(e) + ")", t;
}, $7ae336b16849d71a$export$93d4e7f90805808f = function() {
    return (0, $6fFrj.useContext)($7ae336b16849d71a$export$2c657da244d00bd6);
}, $7ae336b16849d71a$export$5c87cfe6c475f500 = {
    StyleSheet: $7ae336b16849d71a$var$Z,
    masterSheet: $7ae336b16849d71a$var$he
};
var $7ae336b16849d71a$export$2e2bcd8739ae039 = $7ae336b16849d71a$var$He;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

var $ff22b7405cb76de7$exports = {};

$ff22b7405cb76de7$exports = (parcelRequire("ha77Z"));




var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




const { Option: $44f43cbb9ad321d8$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const $44f43cbb9ad321d8$var$UpdateTaxYearModal = ({ visible: visible, setChangeTaxYearModalVisible: setChangeTaxYearModalVisible, taxYear: taxYear, interviewId: interviewId })=>{
    const [newTaxYear, setNewTaxYear] = (0, $6fFrj.useState)(taxYear);
    // context
    const jobContext = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const { taxYearInterviewId: taxYearInterviewId, entityId: entityId } = jobContext;
    // graphql
    const [updateTaxYearInterview, { loading: loadingUpdateTaxYear }] = (0, $33beb5b1bfae180c$export$5ef9f018471fce4)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        },
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Tax year updated successfully.');
        }
    });
    const taxYears = (0, $6fFrj.useMemo)(()=>(0, $02555ecb9d643fe4$export$2e2bcd8739ae039)(10), []);
    const handleUpdateTaxYear = ()=>{
        try {
            updateTaxYearInterview({
                variables: {
                    updateTaxYearInterviewInput: {
                        id: taxYearInterviewId,
                        entityId: entityId,
                        interviewId: interviewId,
                        year: newTaxYear.toString(),
                        previousYear: taxYear.toString()
                    }
                },
                refetchQueries: [
                    'GetAllEntityDataByEntityId'
                ]
            });
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to update the tax year.');
        } finally{
            setChangeTaxYearModalVisible(false);
        }
    };
    const onSelectChangeHandler = (value)=>{
        setNewTaxYear(value);
    };
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    (0, $bb3TF.jsx)("div", {
        onClick: (event)=>{
            event.stopPropagation();
        },
        children: (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
            title: "Update Tax Year",
            visible: visible,
            onCancel: ()=>setChangeTaxYearModalVisible(false),
            okText: "Update",
            okButtonProps: {
                loading: loadingUpdateTaxYear,
                disabled: loadingUpdateTaxYear
            },
            onOk: handleUpdateTaxYear,
            destroyOnClose: true,
            children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                layout: "vertical",
                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "taxYear",
                    label: "Tax Year:",
                    children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                        defaultValue: taxYear,
                        value: newTaxYear,
                        style: {
                            width: '100%'
                        },
                        placeholder: "Select a tax year",
                        onChange: onSelectChangeHandler,
                        children: taxYears.map(({ label: label, value: value })=>(0, $bb3TF.jsxs)($44f43cbb9ad321d8$var$Option, {
                                value: value,
                                children: [
                                    label,
                                    ' '
                                ]
                            }, `taxYearKey-${value}`))
                    })
                })
            })
        })
    }));
};
var $44f43cbb9ad321d8$export$2e2bcd8739ae039 = $44f43cbb9ad321d8$var$UpdateTaxYearModal;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




const { Text: $b7c3fdcea7912336$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $b7c3fdcea7912336$var$DeleteJobModal = ({ visible: visible, setDeleteJobModalVisible: setDeleteJobModalVisible })=>{
    // context
    const jobContext = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const { taxYearInterviewId: taxYearInterviewId, progressStatusId: progressStatusId } = jobContext;
    // graphql
    const [deleteTaxYearInterview, { loading: loadingDeleteJob }] = (0, $33beb5b1bfae180c$export$92ffc46af4628615)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    const handleDeleteJob = async ()=>{
        try {
            deleteTaxYearInterview({
                variables: {
                    id: taxYearInterviewId
                },
                refetchQueries: [
                    'GetAllEntityDataByEntityId',
                    {
                        query: (0, $732264f53056e08f$export$d4e23f314f782a9d),
                        variables: {
                            progressStatusId: progressStatusId
                        }
                    }
                ]
            }).then((res)=>{
                if (res.data.DeleteJob.id) (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Job deleted.');
            });
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to delete the job.');
        } finally{
            setDeleteJobModalVisible(false);
        }
    };
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    (0, $bb3TF.jsx)("div", {
        onClick: (event)=>{
            event.stopPropagation();
        },
        children: (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
            visible: visible,
            title: "Are you sure?",
            onCancel: ()=>setDeleteJobModalVisible(false),
            onOk: handleDeleteJob,
            okText: "Delete Job",
            okType: "primary",
            okButtonProps: {
                danger: true,
                loading: loadingDeleteJob,
                disabled: loadingDeleteJob
            },
            children: (0, $bb3TF.jsx)($b7c3fdcea7912336$var$Text, {
                children: "You are about to permanently delete this job."
            })
        })
    }));
};
var $b7c3fdcea7912336$export$2e2bcd8739ae039 = $b7c3fdcea7912336$var$DeleteJobModal;







var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

const $48dfff27a418d97c$var$defaultProps = {
    dropDownProps: {},
    tooltipTitle: '',
    children: null
};
function $48dfff27a418d97c$var$SelectionDropdown({ onSelect: onSelect, options: options, keyText: keyText, buttonProps: buttonProps, dropDownProps: dropDownProps, tooltipTitle: tooltipTitle, children: children }) {
    const [tooltipVisible, setTooltipVisible] = (0, $6fFrj.useState)(false);
    const [dropdownVisible, setDropdownVisible] = (0, $6fFrj.useState)(false);
    if (!options.length) return null;
    const optionsMenu = ()=>(0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
            children: options.map((opt, i)=>(0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
                    icon: opt.icon,
                    onClick: ({ domEvent: domEvent })=>{
                        domEvent.stopPropagation();
                        onSelect(opt);
                        setDropdownVisible(false);
                    },
                    danger: opt.danger,
                    children: opt[keyText]
                }, `${opt.key}-${new Date().getUTCDate() * Math.random()}`))
        });
    const onTooltipVisibleChange = (visible)=>{
        if (visible && !dropdownVisible) setTooltipVisible(true);
        else setTooltipVisible(false);
    };
    const onDropdownVisibleChange = (visible)=>{
        setDropdownVisible(visible);
        if (visible) setTooltipVisible(false);
    };
    return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        title: tooltipTitle,
        visible: tooltipTitle ? tooltipVisible : false,
        onVisibleChange: onTooltipVisibleChange,
        trigger: [
            'hover'
        ],
        children: (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
            overlay: optionsMenu(),
            visible: dropdownVisible,
            onVisibleChange: onDropdownVisibleChange,
            trigger: [
                'click'
            ],
            placement: "topLeft",
            ...dropDownProps,
            children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                ...buttonProps,
                children: children
            })
        })
    });
}
$48dfff27a418d97c$var$SelectionDropdown.defaultProps = $48dfff27a418d97c$var$defaultProps;
var $48dfff27a418d97c$export$2e2bcd8739ae039 = $48dfff27a418d97c$var$SelectionDropdown;


const { Option: $7a42c79474d8eff4$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const { SettingOutlined: $7a42c79474d8eff4$var$SettingOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $7a42c79474d8eff4$var$JobExtra = ({ onChange: onChange, progressStatusId: progressStatusId, taxYear: taxYear, interviewId: interviewId, interviewName: interviewName, loading: loading })=>{
    const jobContext = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const [changeTaxYearModalVisible, setChangeTaxYearModalVisible] = (0, $6fFrj.useState)(false);
    const [deleteJobModalVisible, setDeleteJobModalVisible] = (0, $6fFrj.useState)(false);
    const [csvFileName, setCsvFileName] = (0, $6fFrj.useState)('');
    const [csvFileContent, setCsvFileContent] = (0, $6fFrj.useState)('');
    const { showModal: showModal, accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    // graphql
    // get all progress statuses
    const { data: progressStatusesData } = (0, $732264f53056e08f$export$9ca2f42b9d2b732f)();
    const progressStatuses = progressStatusesData?.ProgressStatuses || [];
    const csvLink = (0, $6fFrj.useRef)();
    const [getTaxYearInterviewDrakeFile] = (0, $2d09ce9c73e1e422$export$79feeea77603ece9)();
    const handleDropdownSelection = (option)=>{
        const { type: type } = option;
        if (type === 'delete_job') setDeleteJobModalVisible(true);
        else if (type === 'change_tax_year') setChangeTaxYearModalVisible(true);
        else if (type === 'drake_export') {
            // show upgrade modal if user doesn't have access
            if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).export]) {
                showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).export);
                return;
            }
            getTaxYearInterviewDrakeFile({
                variables: {
                    taxYearInterviewId: jobContext.taxYearInterviewId
                },
                onCompleted (data) {
                    setCsvFileName(data.taxYearInterviewDrakeFile.fileName);
                    setCsvFileContent(data.taxYearInterviewDrakeFile.fileContent);
                    if (csvLink?.current?.link) csvLink.current.link.click();
                    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Drake export complete');
                },
                onError (error) {
                    let text = 'Drake export error';
                    const apolloText = error?.graphQLErrors[0]?.message;
                    if (apolloText) text = `${text}: ${apolloText}`;
                    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(text);
                }
            });
        }
    };
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                style: {
                    width: (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? 150 : 200
                },
                onChange: onChange,
                value: progressStatusId,
                onClick: (event)=>{
                    // If you don't want click extra trigger collapse, you can prevent this:
                    event.stopPropagation();
                },
                loading: loading,
                children: progressStatuses.map((progressStatus)=>(0, $bb3TF.jsx)($7a42c79474d8eff4$var$Option, {
                        value: progressStatus.id,
                        children: progressStatus.status
                    }, progressStatus.id))
            }),
            (0, $bb3TF.jsx)((0, $48dfff27a418d97c$export$2e2bcd8739ae039), {
                buttonProps: {
                    style: {
                        marginLeft: 10,
                        padding: 0
                    },
                    icon: (0, $bb3TF.jsx)($7a42c79474d8eff4$var$SettingOutlined, {}),
                    // iconDirection: 'left',
                    type: 'link',
                    onClick: (event)=>{
                        // If you don't want click extra trigger collapse, you can prevent this:
                        event.stopPropagation();
                    }
                },
                dropDownProps: {
                    placement: 'bottomLeft'
                },
                onSelect: (option)=>handleDropdownSelection(option),
                options: [
                    {
                        type: 'change_tax_year',
                        title: 'Change Tax Year'
                    },
                    ...interviewName === 'Individual' ? [
                        {
                            type: 'drake_export',
                            title: 'Drake Export'
                        }
                    ] : [],
                    {
                        type: 'delete_job',
                        title: 'Delete Job',
                        danger: true
                    }
                ],
                keyText: "title"
            }),
            (0, $bb3TF.jsx)((0, $44f43cbb9ad321d8$export$2e2bcd8739ae039), {
                visible: changeTaxYearModalVisible,
                setChangeTaxYearModalVisible: setChangeTaxYearModalVisible,
                taxYear: taxYear,
                interviewId: interviewId
            }),
            (0, $bb3TF.jsx)((0, $b7c3fdcea7912336$export$2e2bcd8739ae039), {
                visible: deleteJobModalVisible,
                setDeleteJobModalVisible: setDeleteJobModalVisible
            }),
            (0, $bb3TF.jsx)((0, $ff22b7405cb76de7$exports.CSVLink), {
                data: csvFileContent,
                filename: csvFileName,
                className: "hidden",
                ref: csvLink,
                target: "_blank"
            })
        ]
    });
};
var $7a42c79474d8eff4$export$2e2bcd8739ae039 = $7a42c79474d8eff4$var$JobExtra;




const $d70a105713c5d11d$var$defaultOptions = {};
const $d70a105713c5d11d$export$a389c7f482d5a85 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateTaxYearInterviewProgressStatus($id: String!, $progressStatusId: String!) {
  updateTaxYearInterviewProgressStatus(
    id: $id
    progressStatusId: $progressStatusId
  ) {
    id
    Interviews {
      id
      name
    }
    ProgressStatuses {
      id
      status
      underlyingStatus
      index
    }
  }
}
    `;
function $d70a105713c5d11d$export$7ff6acaf391acb3d(baseOptions) {
    const options = {
        ...$d70a105713c5d11d$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($d70a105713c5d11d$export$a389c7f482d5a85, options);
}
const $d70a105713c5d11d$export$b5952c4203ffade0 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation addJob($addJobInput: AddJobInput!) {
  AddTaxYearInterviewJob(addJobInput: $addJobInput) {
    id
  }
}
    `;
function $d70a105713c5d11d$export$8af9dcddcc608749(baseOptions) {
    const options = {
        ...$d70a105713c5d11d$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($d70a105713c5d11d$export$b5952c4203ffade0, options);
}
const $d70a105713c5d11d$export$39ac829ab91f0716 = {
    Mutation: {
        UpdateTaxYearInterviewProgressStatus: 'UpdateTaxYearInterviewProgressStatus',
        addJob: 'addJob'
    }
};





var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");







var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");





var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




var $e07926d79f5e1133$exports = {};
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $e07926d79f5e1133$require$Buffer = $c62b475e31b1e858$export$a143d493d941bafc;

var $8LKEK = parcelRequire("8LKEK");
!function(e) {
    $e07926d79f5e1133$exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $e07926d79f5e1133$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($e07926d79f5e1133$require$Buffer.from && $e07926d79f5e1133$require$Buffer.from !== Uint8Array.from) return $e07926d79f5e1133$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $e07926d79f5e1133$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($e07926d79f5e1133$require$Buffer.alloc) return $e07926d79f5e1133$require$Buffer.alloc(e);
                        var t = new $e07926d79f5e1133$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $e07926d79f5e1133$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $e07926d79f5e1133$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $e07926d79f5e1133$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $8LKEK.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});




const $2463cf83e2d8595b$export$188d396885848ae9 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('File deleted');
};
const $2463cf83e2d8595b$export$9c34a3507099f63d = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error has occurred while trying to download all files. Please try again');
};


const { DownloadOutlined: $99e6dfd78ce510dc$var$DownloadOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $99e6dfd78ce510dc$var$DownloadAllFilesButton = ({ files: files, saveZipAs: saveZipAs, children: children })=>{
    const [isLoading, setIsLoading] = (0, $6fFrj.useState)(false);
    const [downloadAllFiles] = (0, $edf372aa0dea9531$export$b64d91815d7c1b44)({
        onError: (0, $2463cf83e2d8595b$export$9c34a3507099f63d)
    });
    const handleDownloadAllFiles = async ()=>{
        setIsLoading(true);
        const allS3Keys = files.map((file)=>file.s3Key);
        const download = await downloadAllFiles({
            variables: {
                s3Keys: allS3Keys
            }
        });
        const zip = new (0, (/*@__PURE__*/$parcel$interopDefault($e07926d79f5e1133$exports)))();
        const zipFilename = `${saveZipAs}.zip`;
        const downloadPromises = download.data.downloadAllFiles.signedUrlArray.map((signedUrl)=>(0, (/*@__PURE__*/$parcel$interopDefault($18ae57eea10fd4c8$exports))).get(signedUrl.url, {
                responseType: 'blob'
            }).then((response)=>{
                zip.file(signedUrl.name, response.data);
            }));
        // Wait for all files to be added to the zip
        await Promise.all(downloadPromises);
        // Generate zip file and trigger download
        zip.generateAsync({
            type: 'blob'
        }).then((content)=>{
            (0, $446481821ff0fa70$exports.saveAs)(content, zipFilename);
            setIsLoading(false); // End loading
        }).catch(()=>{
            setIsLoading(false); // Ensure loading is false in case of error
        });
    };
    return (0, $bb3TF.jsxs)((0, $92b07c154bbb4d14$export$2e2bcd8739ae039), {
        tooltip: "Download All Files selected in the table.",
        confirmAction: true,
        confirmLabel: "Download files?",
        onClick: ()=>handleDownloadAllFiles(),
        buttonProps: {
            disabled: files.length === 0,
            title: files.length === 0 ? 'Select the files you would like to download from the table.' : '',
            loading: isLoading
        },
        children: [
            (0, $bb3TF.jsx)($99e6dfd78ce510dc$var$DownloadOutlined, {}),
            children
        ]
    });
};
var $99e6dfd78ce510dc$export$2e2bcd8739ae039 = $99e6dfd78ce510dc$var$DownloadAllFilesButton;



function $2bd45c4ca422dc00$export$21f4b1dc927890d3(type) {
    return [
        'application/msword',
        'application/pdf',
        'application/rtf',
        'application/vnd.ms-excel',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/xml'
    ].includes(type) || [
        'image/',
        'text/'
    ].some((prefix)=>type.startsWith(prefix));
}




var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




const $d33ac3fed0656a99$var$defaultOptions = {};
const $d33ac3fed0656a99$export$6400ffd7ed1b67b3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation createRequestedFiles($createRequestedFilesInput: [CreateRequestedFilesInput!]!) {
  CreateManyRequestedFiles(createRequestedFilesInput: $createRequestedFilesInput)
}
    `;
function $d33ac3fed0656a99$export$d7c007a5103e719a(baseOptions) {
    const options = {
        ...$d33ac3fed0656a99$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($d33ac3fed0656a99$export$6400ffd7ed1b67b3, options);
}
const $d33ac3fed0656a99$export$39ac829ab91f0716 = {
    Mutation: {
        createRequestedFiles: 'createRequestedFiles'
    }
};



const { FileAddOutlined: $2cf25dec861a2f20$var$FileAddOutlined, PlusOutlined: $2cf25dec861a2f20$var$PlusOutlined, DeleteOutlined: $2cf25dec861a2f20$var$DeleteOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Text: $2cf25dec861a2f20$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
function $2cf25dec861a2f20$var$RequestFilesModal({ isModalVisible: isModalVisible, setIsModalVisible: setIsModalVisible }) {
    // state
    const [filesToRequest, setFilesToRequest] = (0, $6fFrj.useState)([
        ''
    ]);
    const [additionalInstructions, setAdditionalInstructions] = (0, $6fFrj.useState)('');
    const [wrongIndex, setWrongIndex] = (0, $6fFrj.useState)(0);
    const [tooltip, setTooltip] = (0, $6fFrj.useState)('');
    // context
    const jobContext = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const { taxYearInterviewId: taxYearInterviewId } = jobContext;
    // graphql
    const [requestFiles, { loading: loadingRequestedFiles }] = (0, $d33ac3fed0656a99$export$d7c007a5103e719a)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        },
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Successfully requested files.');
            setFilesToRequest([
                ''
            ]);
            setAdditionalInstructions('');
            setIsModalVisible(false);
        },
        refetchQueries: [
            {
                query: (0, $e9d4d19cd26b2dae$export$6253ea43f7f964e6),
                variables: {
                    taxYearInterviewId: jobContext?.taxYearInterviewId,
                    userId: jobContext?.entityOwnerId
                }
            }
        ]
    });
    const handleAddFile = ()=>{
        const tempFilesToRequest = filesToRequest;
        tempFilesToRequest.push('');
        setFilesToRequest([
            ...tempFilesToRequest
        ]);
    };
    const handleRemoveFileRequset = (index)=>{
        const tempFilesToRequest = filesToRequest;
        tempFilesToRequest.splice(index, 1);
        setFilesToRequest([
            ...tempFilesToRequest
        ]);
    };
    const handleSubmit = ()=>{
        setTooltip('');
        requestFiles({
            variables: {
                createRequestedFilesInput: [
                    ...filesToRequest.map((file)=>({
                            taxYearInterviewId: taxYearInterviewId,
                            fileName: file,
                            notes: additionalInstructions
                        }))
                ]
            }
        });
    };
    const handleType = (index, value)=>{
        const tempFilesToRequest = filesToRequest;
        tempFilesToRequest[index] = value;
        const files = [
            ...tempFilesToRequest
        ];
        setFilesToRequest(files);
    };
    (0, $6fFrj.useEffect)(()=>{
        // validate file names
        setWrongIndex(filesToRequest.findIndex((x)=>x.length === 0));
    }, [
        filesToRequest
    ]);
    (0, $6fFrj.useEffect)(()=>{
        setTooltip(isModalVisible && wrongIndex === -1 ? 'With Automated Follow-ups' : '');
    }, [
        isModalVisible,
        wrongIndex
    ]);
    return (0, $bb3TF.jsxs)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        visible: isModalVisible,
        title: "Request Files with Automated Follow-Ups",
        onCancel: ()=>setIsModalVisible(false),
        onOk: handleSubmit,
        footer: [
            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                onClick: ()=>setIsModalVisible(false),
                children: "Cancel"
            }),
            (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                title: tooltip,
                children: (0, $bb3TF.jsxs)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    type: "primary",
                    onClick: handleSubmit,
                    disabled: loadingRequestedFiles || wrongIndex !== -1,
                    loading: loadingRequestedFiles,
                    children: [
                        (0, $bb3TF.jsx)($2cf25dec861a2f20$var$FileAddOutlined, {}),
                        "Request Files"
                    ]
                })
            })
        ],
        children: [
            filesToRequest.map((item, index)=>(0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "fileName",
                    label: (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                        children: [
                            'File Name ',
                            (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                title: "For example: Your 2022 W2",
                                children: (0, $bb3TF.jsx)((0, $60bea5c3f0793107$export$2e2bcd8739ae039), {
                                    style: {
                                        fontSize: 12,
                                        position: 'relative',
                                        top: '-0.5em',
                                        cursor: 'pointer'
                                    }
                                })
                            })
                        ]
                    }),
                    children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        gutter: 4,
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: 22,
                                children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                    value: item,
                                    onChange: (e)=>handleType(index, e.target.value)
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center'
                                },
                                children: index > 0 && (0, $bb3TF.jsx)($2cf25dec861a2f20$var$DeleteOutlined, {
                                    style: {
                                        color: 'red'
                                    },
                                    onClick: ()=>handleRemoveFileRequset(index)
                                })
                            })
                        ]
                    })
                }, `request-files-${index}`)),
            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                icon: (0, $bb3TF.jsx)($2cf25dec861a2f20$var$PlusOutlined, {}),
                onClick: handleAddFile,
                children: "Add Another File"
            }),
            (0, $bb3TF.jsx)("div", {
                style: {
                    height: '1em'
                }
            }),
            (0, $bb3TF.jsx)($2cf25dec861a2f20$var$Text, {
                children: "Additional Instructions to Client (optional):"
            }),
            (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039).TextArea, {
                value: additionalInstructions,
                onChange: (e)=>setAdditionalInstructions(e.target.value)
            }),
            (0, $bb3TF.jsx)("div", {
                style: {
                    marginTop: '1em'
                },
                children: "Files will be requested according to cadence sent in Notifications Section of Settings."
            })
        ]
    });
}
var $2cf25dec861a2f20$export$2e2bcd8739ae039 = $2cf25dec861a2f20$var$RequestFilesModal;




const $b0edf9f13e354d28$export$e74e9b9e28a80d2c = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Success!');
};
const $b0edf9f13e354d28$export$d398067e426f204c = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('File uploaded');
};
const $b0edf9f13e354d28$export$85b43ea59a8cb058 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error has occurred');
};
const $b0edf9f13e354d28$export$98287ba72a7a09cb = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error ocurred while uploading to our DB');
};
const $b0edf9f13e354d28$export$a3dcaf4340e9564c = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error ocurred while loading client files');
};
const $b0edf9f13e354d28$export$b728c07d3fd30236 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error ocurred while trying to upload file to S3');
};
const $b0edf9f13e354d28$export$f5a7890bfa0f9b35 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('The document of this type is not allowed. You can upload PDFs, texts and images only.');
};
const $b0edf9f13e354d28$export$16dbc74f3d5490d5 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('File size exceeds 25MB');
};


const { CloudUploadOutlined: $014c01a6aee2960a$var$CloudUploadOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $014c01a6aee2960a$var$ClientFiles({ jobName: jobName }) {
    const jobContext = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const { taxYearInterviewId: taxYearInterviewId, entityId: entityId, entityOwnerId: entityOwnerId, clientFirstName: clientFirstName, clientLastName: clientLastName } = jobContext;
    const csvLink = (0, $6fFrj.useRef)();
    const [isFileUploading, setIsFileUploading] = (0, $6fFrj.useState)(false);
    const [isRequestFilesModalVisible, setIsRequestFilesModalVisible] = (0, $6fFrj.useState)(false);
    const [fileList, setFileList] = (0, $6fFrj.useState)();
    const [clientFilesDataOnDB, setClientFilesDataOnDB] = (0, $6fFrj.useState)([]);
    const [clientRequestedFilesDataOnDB, setClientRequestedFilesDataOnDB] = (0, $6fFrj.useState)([]);
    const [selectedRowKeys, setSelectedRowKeys] = (0, $6fFrj.useState)([]);
    const { allFilesChanged: allFilesChanged, dispatch: dispatch } = (0, $6fFrj.useContext)((0, $9f8459ba594d5b47$export$7fd9bd9faa7887cb));
    const [preSignedUrls, setPreSignedUrls] = (0, $6fFrj.useState)();
    const [getPresignedUrl, { data: uploadFileData }] = (0, $edf372aa0dea9531$export$ea7e982b7f736995)({
        onError: (0, $b0edf9f13e354d28$export$b728c07d3fd30236)
    });
    const [uploadFileToUserOnDB, { loading: loadingUploadFileOnDBData }] = (0, $edf372aa0dea9531$export$768a55502f95551d)({
        onCompleted: (0, $b0edf9f13e354d28$export$d398067e426f204c),
        onError: (0, $b0edf9f13e354d28$export$98287ba72a7a09cb),
        refetchQueries: [
            {
                query: (0, $e9d4d19cd26b2dae$export$6253ea43f7f964e6),
                variables: {
                    taxYearInterviewId: taxYearInterviewId,
                    userId: entityOwnerId
                }
            },
            {
                query: (0, $e9d4d19cd26b2dae$export$8d96bb6ff728ee2f),
                variables: {
                    userId: entityOwnerId
                }
            }
        ],
        awaitRefetchQueries: true
    });
    // Get client files
    const [getClientFilesFromDbQuery, { loading: loadingFilesData }] = (0, $e9d4d19cd26b2dae$export$d4b27e7088edbec6)();
    const getClientFilesFromDb = ()=>{
        getClientFilesFromDbQuery({
            variables: {
                taxYearInterviewId: taxYearInterviewId,
                userId: entityOwnerId
            },
            fetchPolicy: 'network-only',
            onCompleted: (data)=>{
                if (data?.getClientFilesFromDb) // map data to add key
                setClientFilesDataOnDB(data.getClientFilesFromDb.map((x)=>({
                        ...x,
                        key: x.id
                    })));
                if (data?.ClientRequestedFiles) setClientRequestedFilesDataOnDB(data.ClientRequestedFiles);
            },
            onError: (0, $b0edf9f13e354d28$export$a3dcaf4340e9564c)
        });
    };
    (0, $6fFrj.useEffect)(()=>{
        if (taxYearInterviewId && entityOwnerId) getClientFilesFromDb();
    }, [
        taxYearInterviewId,
        entityOwnerId
    ]);
    const handleRequestFiles = ()=>{
        setIsRequestFilesModalVisible(true);
    };
    const handleBeforeUpload = async ({ name: name, type: type, uid: uid, size: size })=>{
        const maxSize = 26214400; // 25MB
        if (size > maxSize) {
            (0, $b0edf9f13e354d28$export$16dbc74f3d5490d5)();
            return false;
        }
        if (!(0, $2bd45c4ca422dc00$export$21f4b1dc927890d3)(type)) {
            (0, $b0edf9f13e354d28$export$f5a7890bfa0f9b35)();
            return false;
        }
        // Fetches the Signed URL from S3 bucket
        // Prepend with the ID to make the file name unique
        const result = await getPresignedUrl({
            variables: {
                fileName: `${entityId}/${taxYearInterviewId}/clientfiles/${name}`,
                fileType: type
            }
        });
        setPreSignedUrls((prev)=>({
                ...prev ?? {},
                [uid]: result?.data?.generatePreSignedPutUrl
            }));
        return true;
    };
    const handleFileChanged = ({ file: file })=>{
        if (file.status === 'removed') setFileList([]);
        else if (file.status === 'uploading') setFileList((prev)=>[
                ...prev ?? [],
                file
            ]);
        else if (file.status === 'error') (0, $b0edf9f13e354d28$export$a3dcaf4340e9564c)();
        else if (file.status === 'done') {
            const { url: url } = preSignedUrls[file.uid];
            const newFile = {
                ...file,
                url: url
            };
            if ((0, $2bd45c4ca422dc00$export$21f4b1dc927890d3)(file.type)) setFileList([
                newFile
            ]);
        }
    };
    // Custom xhr upload method
    const handleUpload = async ({ onSuccess: onSuccess, onError: onError, file: file })=>{
        if ((0, $2bd45c4ca422dc00$export$21f4b1dc927890d3)(file.type)) setIsFileUploading(true);
        const xhr = new XMLHttpRequest();
        const { signedUrl: signedUrl, url: url } = preSignedUrls[file.uid];
        // S3 requires PUT method!
        xhr.open('PUT', signedUrl);
        xhr.setRequestHeader('Content-Disposition', 'inline');
        xhr.setRequestHeader('Content-Type', file.type);
        xhr.onreadystatechange = async ()=>{
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    onSuccess(null, file);
                    await uploadFileToUserOnDB({
                        variables: {
                            fileRoute: `${url.split('.com/')[1]}`,
                            size: file.size,
                            taxYearInterviewId: taxYearInterviewId,
                            userId: entityOwnerId
                        }
                    });
                    setIsFileUploading(false);
                } else {
                    onError(xhr.responseText, xhr.response, file);
                    setIsFileUploading(false);
                }
            }
        };
        xhr.send(file);
    };
    // SignedRequest from s3 needs to be set as the action. This is the glue.
    const action = uploadFileData?.generatePreSignedPutUrl?.signedUrl;
    const clientFilesTableData = [
        ...clientFilesDataOnDB,
        ...clientRequestedFilesDataOnDB.map((x)=>({
                id: x.id,
                name: x.fileName,
                taxYearInterviewId: x.taxYearInterviewId,
                createAt: x.createAt
            }))
    ];
    (0, $6fFrj.useEffect)(()=>{
        if (allFilesChanged) {
            if (taxYearInterviewId && entityOwnerId) getClientFilesFromDb();
            dispatch({
                type: 'UPDATE',
                payload: {
                    allFilesChanged: false
                }
            });
        }
    }, [
        allFilesChanged
    ]);
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)("div", {
                style: {
                    height: 10
                }
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                justify: "space-between",
                gutter: [
                    10,
                    10
                ],
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $99e6dfd78ce510dc$export$2e2bcd8739ae039), {
                            files: clientFilesDataOnDB.filter((x)=>selectedRowKeys.includes(x.id)),
                            saveZipAs: `${clientFirstName} ${clientLastName} - ${jobName} - Client Files`,
                            children: "Download Selected Files"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            gutter: [
                                10,
                                10
                            ],
                            children: [
                                (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                    children: (0, $bb3TF.jsx)((0, $09e7a312b8c0b52f$export$2e2bcd8739ae039), {
                                        action: action,
                                        fileList: fileList,
                                        showUploadList: isFileUploading,
                                        customRequest: (e)=>handleUpload(e),
                                        beforeUpload: (args)=>handleBeforeUpload(args),
                                        onChange: (e)=>handleFileChanged(e),
                                        disabled: isFileUploading,
                                        multiple: true,
                                        children: (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
                                            content: "Add files to your clients' uploaded documents",
                                            children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                type: "default",
                                                icon: (0, $bb3TF.jsx)($014c01a6aee2960a$var$CloudUploadOutlined, {}),
                                                iconDirection: "left",
                                                loading: isFileUploading,
                                                children: "Upload Files"
                                            })
                                        })
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                    children: (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
                                        content: "Request client files with automated follow-ups",
                                        children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                            type: "primary",
                                            icon: (0, $bb3TF.jsx)($014c01a6aee2960a$var$CloudUploadOutlined, {}),
                                            iconDirection: "left",
                                            onClick: handleRequestFiles,
                                            children: "Request Files"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)("div", {
                style: {
                    height: 10
                }
            }),
            clientFilesTableData?.length > 0 ? (0, $bb3TF.jsx)((0, $2c4b6e52dd599387$export$2e2bcd8739ae039), {
                tableType: (0, $2c4b6e52dd599387$export$142270ff5033bc11).Client,
                tableData: clientFilesTableData,
                loading: loadingUploadFileOnDBData || loadingFilesData,
                selectedRowKeys: selectedRowKeys,
                setSelectedRowKeys: setSelectedRowKeys
            }) : (0, $bb3TF.jsx)((0, $9150234f0969a884$export$2e2bcd8739ae039), {
                description: "No Data"
            }),
            (0, $bb3TF.jsx)((0, $ff22b7405cb76de7$exports.CSVLink), {
                data: clientFilesDataOnDB,
                filename: "table.csv",
                className: "hidden",
                ref: csvLink,
                target: "_blank"
            }),
            (0, $bb3TF.jsx)((0, $2cf25dec861a2f20$export$2e2bcd8739ae039), {
                isModalVisible: isRequestFilesModalVisible,
                setIsModalVisible: setIsRequestFilesModalVisible
            })
        ]
    });
}
var $014c01a6aee2960a$export$2e2bcd8739ae039 = $014c01a6aee2960a$var$ClientFiles;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");










const $c727fedb473fcebf$export$e74e9b9e28a80d2c = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Success!');
};
const $c727fedb473fcebf$export$d398067e426f204c = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('File uploaded');
};
const $c727fedb473fcebf$export$85b43ea59a8cb058 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error has occurred');
};
const $c727fedb473fcebf$export$98287ba72a7a09cb = (error)=>{
    console.log({
        error: error
    });
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error ocurred while uploading to our DB');
};
const $c727fedb473fcebf$export$5b47eb64a45163d7 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error ocurred while loading firm files');
};
const $c727fedb473fcebf$export$b728c07d3fd30236 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error while trying to upload file to S3');
};
const $c727fedb473fcebf$export$f5a7890bfa0f9b35 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('The document of this type is not allowed. You can upload PDFs, texts and images only.');
};



const { CloudUploadOutlined: $d4f06d030d275f03$var$CloudUploadOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $d4f06d030d275f03$var$FirmFiles({ jobName: jobName }) {
    const jobContext = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const { taxYearInterviewId: taxYearInterviewId, entityId: entityId, entityOwnerId: entityOwnerId, clientFirstName: clientFirstName, clientLastName: clientLastName } = jobContext;
    const csvLink = (0, $6fFrj.useRef)();
    const [isFileUploading, setIsFileUploading] = (0, $6fFrj.useState)(false);
    const [fileList, setFileList] = (0, $6fFrj.useState)();
    const [FirmFilesDataOnDB, setFirmFilesDataOnDB] = (0, $6fFrj.useState)([]);
    const [selectedRowKeys, setSelectedRowKeys] = (0, $6fFrj.useState)([]);
    const { allFilesChanged: allFilesChanged, dispatch: dispatch } = (0, $6fFrj.useContext)((0, $9f8459ba594d5b47$export$7fd9bd9faa7887cb));
    const [preSignedUrls, setPreSignedUrls] = (0, $6fFrj.useState)();
    const [getPresignedUrl, { data: uploadFileData }] = (0, $edf372aa0dea9531$export$ea7e982b7f736995)({
        onError: (0, $c727fedb473fcebf$export$b728c07d3fd30236)
    });
    const [uploadFileToUserOnDB, { loading: loadingUploadFileOnDBData }] = (0, $edf372aa0dea9531$export$c1a2b6ae89e60708)({
        onCompleted: (0, $c727fedb473fcebf$export$d398067e426f204c),
        onError: (0, $c727fedb473fcebf$export$98287ba72a7a09cb),
        refetchQueries: [
            {
                query: (0, $e9d4d19cd26b2dae$export$bced65fdea7baad1),
                variables: {
                    taxYearInterviewId: taxYearInterviewId
                }
            },
            {
                query: (0, $e9d4d19cd26b2dae$export$8d96bb6ff728ee2f),
                variables: {
                    userId: entityOwnerId
                }
            }
        ],
        awaitRefetchQueries: true
    });
    // Get client files
    const [getFirmFilesFromDb, { loading: loadingFirmFilesData }] = (0, $e9d4d19cd26b2dae$export$44b97a3a9e026a24)();
    const getFirmFilesByTaxYearId = ()=>{
        getFirmFilesFromDb({
            variables: {
                taxYearInterviewId: taxYearInterviewId
            },
            fetchPolicy: 'cache-and-network',
            onCompleted: (data)=>{
                if (data?.getFirmFilesFromDb) // map through the files and add a key
                setFirmFilesDataOnDB(data.getFirmFilesFromDb.map((file)=>({
                        ...file,
                        key: file.id
                    })));
            },
            onError: (0, $c727fedb473fcebf$export$5b47eb64a45163d7)
        });
    };
    (0, $6fFrj.useEffect)(()=>{
        if (taxYearInterviewId) getFirmFilesByTaxYearId();
    }, [
        taxYearInterviewId
    ]);
    const handleBeforeUpload = async ({ name: name, type: type, uid: uid, size: size })=>{
        const maxSize = 26214400; // 25MB
        if (size > maxSize) {
            (0, $b0edf9f13e354d28$export$16dbc74f3d5490d5)();
            return false;
        }
        if (!(0, $2bd45c4ca422dc00$export$21f4b1dc927890d3)(type)) {
            (0, $c727fedb473fcebf$export$f5a7890bfa0f9b35)();
            return false;
        }
        // Fetches the Signed URL from S3 bucket
        // Prepend with the ID to make the file name unique
        const result = await getPresignedUrl({
            variables: {
                fileName: `${entityId}/${taxYearInterviewId}/firmfiles/${name}`,
                fileType: type
            }
        });
        setPreSignedUrls((prev)=>({
                ...prev ?? {},
                [uid]: result?.data?.generatePreSignedPutUrl
            }));
        return true;
    };
    const handleFileChanged = ({ file: file })=>{
        if (file.status === 'removed') setFileList([]);
        else if (file.status === 'uploading') setFileList((prev)=>[
                ...prev ?? [],
                file
            ]);
        else if (file.status === 'error') (0, $c727fedb473fcebf$export$5b47eb64a45163d7)();
        else if (file.status === 'done') {
            const { url: url } = preSignedUrls[file.uid];
            const newFile = {
                ...file,
                url: url
            };
            if ((0, $2bd45c4ca422dc00$export$21f4b1dc927890d3)(file.type)) setFileList([
                newFile
            ]);
        }
    };
    // Custom xhr upload method
    const handleUpload = async ({ onSuccess: onSuccess, onError: onError, file: file })=>{
        if ((0, $2bd45c4ca422dc00$export$21f4b1dc927890d3)(file.type)) setIsFileUploading(true);
        const xhr = new XMLHttpRequest();
        const { signedUrl: signedUrl, url: url } = preSignedUrls[file.uid];
        // S3 requires PUT method!
        xhr.open('PUT', signedUrl);
        xhr.setRequestHeader('Content-Disposition', 'inline');
        xhr.setRequestHeader('Content-Type', file.type);
        xhr.onreadystatechange = async ()=>{
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    onSuccess(null, file);
                    await uploadFileToUserOnDB({
                        variables: {
                            fileRoute: `${url.split('.com/')[1]}`,
                            size: file.size,
                            taxYearInterviewId: taxYearInterviewId
                        }
                    });
                    setIsFileUploading(false);
                } else {
                    onError(xhr.responseText, xhr.response, file);
                    setIsFileUploading(false);
                }
            }
        };
        xhr.send(file);
    };
    // SignedRequest from s3 needs to be set as the action. This is the glue.
    const action = uploadFileData?.generatePreSignedPutUrl?.signedUrl;
    (0, $6fFrj.useEffect)(()=>{
        if (allFilesChanged) {
            if (taxYearInterviewId) getFirmFilesByTaxYearId();
            dispatch({
                type: 'UPDATE',
                payload: {
                    allFilesChanged: false
                }
            });
        }
    }, [
        allFilesChanged
    ]);
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)("div", {
                style: {
                    height: 10
                }
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                justify: "space-between",
                gutter: [
                    10,
                    10
                ],
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $99e6dfd78ce510dc$export$2e2bcd8739ae039), {
                            files: FirmFilesDataOnDB.filter((x)=>selectedRowKeys.includes(x.id)),
                            saveZipAs: `${clientFirstName} ${clientLastName} - ${jobName} - Firm Files`,
                            children: "Download Selected Files"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $09e7a312b8c0b52f$export$2e2bcd8739ae039), {
                            action: action,
                            fileList: fileList,
                            showUploadList: isFileUploading,
                            customRequest: (e)=>handleUpload(e),
                            beforeUpload: (args)=>handleBeforeUpload(args),
                            onChange: (e)=>handleFileChanged(e),
                            disabled: isFileUploading,
                            multiple: true,
                            children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                type: "default",
                                icon: (0, $bb3TF.jsx)($d4f06d030d275f03$var$CloudUploadOutlined, {}),
                                iconDirection: "left",
                                loading: isFileUploading,
                                children: "Upload Files"
                            })
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)("div", {
                style: {
                    height: 10
                }
            }),
            FirmFilesDataOnDB?.length > 0 ? (0, $bb3TF.jsx)((0, $2c4b6e52dd599387$export$2e2bcd8739ae039), {
                tableType: (0, $2c4b6e52dd599387$export$142270ff5033bc11).Firm,
                tableData: FirmFilesDataOnDB,
                loading: loadingUploadFileOnDBData || loadingFirmFilesData,
                selectedRowKeys: selectedRowKeys,
                setSelectedRowKeys: setSelectedRowKeys
            }) : (0, $bb3TF.jsx)((0, $9150234f0969a884$export$2e2bcd8739ae039), {
                description: "No Data"
            }),
            (0, $bb3TF.jsx)((0, $ff22b7405cb76de7$exports.CSVLink), {
                data: FirmFilesDataOnDB,
                filename: "table.csv",
                className: "hidden",
                ref: csvLink,
                target: "_blank"
            })
        ]
    });
}
var $d4f06d030d275f03$export$2e2bcd8739ae039 = $d4f06d030d275f03$var$FirmFiles;



var $6fFrj = parcelRequire("6fFrj");

var $bb3TF = parcelRequire("bb3TF");



var $6fFrj = parcelRequire("6fFrj");

var $bb3TF = parcelRequire("bb3TF");


var $6Sgv0 = parcelRequire("6Sgv0");





var $bb3TF = parcelRequire("bb3TF");

const { Text: $5ff185600f2abd5a$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $5ff185600f2abd5a$var$InterviewQuestion = ({ label: label, answer: answer, key: key })=>(0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        gutter: [
            10,
            10
        ],
        style: {
            paddingBottom: '10px'
        },
        children: [
            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                lg: 8,
                md: 8,
                sm: 8,
                xs: 12,
                children: (0, $bb3TF.jsxs)($5ff185600f2abd5a$var$Text, {
                    strong: true,
                    children: [
                        label,
                        ":"
                    ]
                })
            }),
            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                lg: 16,
                md: 16,
                sm: 16,
                xs: 12,
                children: (0, $bb3TF.jsx)($5ff185600f2abd5a$var$Text, {
                    children: answer
                })
            })
        ]
    }, key);
var $5ff185600f2abd5a$export$2e2bcd8739ae039 = $5ff185600f2abd5a$var$InterviewQuestion;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



const { Item: $10718147b01f98b9$var$Item } = (0, $6ee812964d9db826$export$2e2bcd8739ae039);
const { Option: $10718147b01f98b9$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const { TextArea: $10718147b01f98b9$var$TextArea } = (0, $1fb834916a156dcf$export$2e2bcd8739ae039);
const $10718147b01f98b9$var$EditInterviewQuestion = ({ type: type, options: options, required: required, questionName: questionName, onAnswerChange: onAnswerChange, currentValue: currentValue, questionId: questionId })=>{
    const onAnswerChangeHandler = (0, $6fFrj.useCallback)((event)=>{
        if (type === (0, $8f7fe33a44836803$export$51940fbbacba35d4).Ssn) {
            let ssn = event.target.value.replace(/[^0-9-]/g, '');
            if (ssn.startsWith('-')) ssn = ssn.slice(1);
            if (ssn.indexOf('--') !== -1) ssn = ssn.slice(0, ssn.indexOf('--')) + ssn.slice(ssn.indexOf('--') + 1);
            const onlyDashes = ssn.replace(/[0-9]/g, '');
            if (onlyDashes.length > 2) ssn = ssn.slice(0, ssn.lastIndexOf('-')) + ssn.slice(ssn.lastIndexOf('-') + 1);
            const onlyNums = ssn.replace(/-/g, '');
            if (onlyNums.length > 9 || onlyNums.length === 9 && ssn[ssn.length - 1] === '-') ssn = ssn.slice(0, -1);
            return onAnswerChange(questionName, ssn);
        }
        if (type === (0, $8f7fe33a44836803$export$51940fbbacba35d4).Float) {
            const value = event.target.value.replace(/[^0-9.]/g, '');
            return onAnswerChange(questionName, value);
        }
        return onAnswerChange(questionName, event.target.value);
    }, [
        questionName
    ]);
    const onAnswerChangeHandlerAntd = (0, $6fFrj.useCallback)((value)=>{
        onAnswerChange(questionName, value);
    }, [
        questionName
    ]);
    const getInputType = ()=>{
        switch(type){
            case (0, $8f7fe33a44836803$export$51940fbbacba35d4).Text:
                return (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                    onChange: onAnswerChangeHandler
                });
            case (0, $8f7fe33a44836803$export$51940fbbacba35d4).Dropdown:
                return (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                    onChange: onAnswerChangeHandlerAntd,
                    children: options.map(({ value: value, label: label })=>(0, $bb3TF.jsx)($10718147b01f98b9$var$Option, {
                            value: value,
                            children: label
                        }))
                });
            case (0, $8f7fe33a44836803$export$51940fbbacba35d4).Radio:
                return (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Group, {
                    onChange: onAnswerChangeHandler,
                    children: options.map(({ value: value, label: label })=>(0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039), {
                            value: value,
                            children: label
                        }))
                });
            case (0, $8f7fe33a44836803$export$51940fbbacba35d4).Date:
                return (0, $bb3TF.jsx)((0, $dd1293f125eb7a8a$export$2e2bcd8739ae039), {
                    style: {
                        width: '100%'
                    },
                    format: "MM/DD/YYYY",
                    placeholder: "MM/DD/YYYY",
                    onChange: onAnswerChangeHandlerAntd
                });
            case (0, $8f7fe33a44836803$export$51940fbbacba35d4).Phone:
                return (0, $bb3TF.jsx)((0, $5ba7d8eeafddcf67$export$2e2bcd8739ae039), {
                    onChange: (value)=>onAnswerChange(questionName, value),
                    phoneNumber: currentValue
                });
            case (0, $8f7fe33a44836803$export$51940fbbacba35d4).TextArea:
                return (0, $bb3TF.jsx)($10718147b01f98b9$var$TextArea, {
                    onChange: onAnswerChangeHandler
                });
            case (0, $8f7fe33a44836803$export$51940fbbacba35d4).Ssn:
                return (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                    type: "text",
                    maxLength: "11",
                    placeholder: "123-45-6789",
                    onChange: onAnswerChangeHandler
                });
            case (0, $8f7fe33a44836803$export$51940fbbacba35d4).Float:
                return (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                    onChange: onAnswerChangeHandler
                });
            case (0, $8f7fe33a44836803$export$51940fbbacba35d4).Email:
                return (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                    type: "email",
                    onChange: onAnswerChangeHandler
                });
            default:
                return (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                    onChange: onAnswerChangeHandler
                });
        }
    };
    return (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
        sm: 10,
        md: 6,
        lg: 20,
        children: (0, $bb3TF.jsx)($10718147b01f98b9$var$Item, {
            label: questionName,
            name: questionId,
            rules: [
                {
                    required: required
                }
            ],
            children: getInputType()
        })
    });
};
$10718147b01f98b9$var$EditInterviewQuestion.defaultProps = {
    currentValue: ''
};
var $10718147b01f98b9$export$2e2bcd8739ae039 = $10718147b01f98b9$var$EditInterviewQuestion;


const { Panel: $4cc2fddd71f3dfc6$var$Panel } = (0, $45def89f679453ce$export$2e2bcd8739ae039);
const { EditOutlined: $4cc2fddd71f3dfc6$var$EditOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $4cc2fddd71f3dfc6$var$InterviewSection = ({ id: id, SubSections: SubSections, Questions: Questions, jobId: jobId, Translations: sectionTranslations, Answers: Answers, interviewName: interviewName, refetchInterviews: refetchInterviews, expandInterviewSections: expandInterviewSections })=>{
    const [form] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    const [createAnswer] = (0, $edf372aa0dea9531$export$28026c59decaabef)();
    const [updateAnswer] = (0, $edf372aa0dea9531$export$40439c9bae1c027a)();
    const [updateUserInformation] = (0, $33beb5b1bfae180c$export$e3e115fc54c52e18)();
    const [isEditing, setIsEditing] = (0, $6fFrj.useState)(false);
    const { languageId: languageId, userInformationId: userInformationId } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $59a61dbb6cd2676b$export$6ff67ccf1d823f06));
    const [hasSubSections] = (0, $6fFrj.useState)(Boolean(SubSections && SubSections.length));
    const translateQuestion = (translations)=>translations.filter((item)=>item.languageId === languageId)[0]?.description ?? '';
    const getInitialAnswerValues = ()=>Questions?.reduce((acc, { id: currentQuestionId, type: type })=>{
            let answer = Answers.filter(({ questionId: questionId })=>questionId === currentQuestionId)[0]?.description ?? '';
            if (type === 'DATE') {
                const date = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(answer);
                answer = date.isValid() ? date : '';
            }
            const result = {
                ...acc,
                [currentQuestionId]: answer
            };
            return result;
        }, {});
    const saveAnswersHandler = (values, sectionId)=>{
        const arrayValues = Object.keys(values).map((key)=>({
                [key]: values[key]
            }));
        Promise.allSettled(arrayValues.map((item)=>{
            const question = Questions.filter(({ sectionId: questionSectionId })=>questionSectionId === sectionId).filter(({ Translations: Translations })=>Translations.filter(({ questionId: questionId })=>questionId === Object.keys(item)[0])[0]);
            const answer = Answers.filter(({ questionId: questionId })=>questionId === question[0].id)[0];
            // if updating birthday on individual tax return, also update the user's userInformation
            if (question[0]?.Translations?.filter(({ description: description })=>description === 'Taxpayer Date of Birth').length > 0 // if any of the translations are 'Taxpayer Date of Birth'
             && interviewName === 'Individual' // only if the interview is an individual tax return
            ) updateUserInformation({
                variables: {
                    updateUserInformationInput: {
                        id: userInformationId,
                        birthday: item[Object.keys(item)[0]]
                    }
                },
                refetchQueries: [
                    'GetAllEntityDataByEntityId'
                ]
            });
            if (!answer?.id) return createAnswer({
                variables: {
                    createAnswerInput: {
                        questionId: question[0].id,
                        taxYearInterviewId: jobId,
                        description: item[Object.keys(item)[0]]
                    }
                }
            });
            return updateAnswer({
                variables: {
                    updateAnswerInput: {
                        id: answer.id,
                        description: item[Object.keys(item)[0]]
                    }
                }
            });
        })).then((results)=>{
            results.forEach((item)=>{
                if (item.status === 'fulfilled') ;
                else if (item.status === 'rejected') {
                    const error = item.reason;
                    if (error.message?.includes('Error code 1002')) (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('The answer has already been registered previously');
                    else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`Something went wrong while trying to save the Answers: ${error?.message}`);
                }
            });
        }).catch((error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to save the Answers');
        }).finally(()=>{
            refetchInterviews();
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('The questions in this section have been successfully saved.');
            setIsEditing(false);
        });
    };
    const onAnswerChange = (questionId, answer)=>{
        form.setFieldsValue({
            [questionId]: answer
        });
    };
    const editInfoExtra = ()=>(0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
            children: [
                (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    size: "small",
                    type: "link",
                    icon: (0, $bb3TF.jsx)($4cc2fddd71f3dfc6$var$EditOutlined, {}),
                    onClick: (event)=>{
                        // If you don't want click extra trigger collapse, you can prevent this:
                        event.stopPropagation();
                        setIsEditing(!isEditing);
                    },
                    children: isEditing ? 'Cancel' : 'Edit'
                }),
                isEditing && (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    type: "primary",
                    style: {
                        marginLeft: 12
                    },
                    onClick: (e)=>{
                        e.stopPropagation();
                        form.submit();
                    },
                    children: "Save"
                })
            ]
        });
    const getAnswer = (currentQuestionId)=>{
        const { description: description } = Answers.filter(({ questionId: questionId })=>questionId === currentQuestionId)[0] ?? (0, $59a61dbb6cd2676b$export$f578f9573782f150);
        return description ?? '';
    };
    const activeKey = expandInterviewSections ? {
        activeKey: id
    } : {};
    return (0, $bb3TF.jsx)("div", {
        children: (0, $bb3TF.jsx)((0, $45def89f679453ce$export$2e2bcd8739ae039), {
            className: "interview-panel",
            ...activeKey,
            children: (0, $bb3TF.jsxs)($4cc2fddd71f3dfc6$var$Panel, {
                header: sectionTranslations.filter((item)=>item.languageId === languageId)[0]?.description ?? '',
                extra: editInfoExtra(),
                style: {
                    marginBottom: '20px'
                },
                children: [
                    !isEditing && Questions.map(({ id: currentQuestionId, type: type, Translations: Translations, Options: Options })=>{
                        const question = translateQuestion(Translations);
                        const description = getAnswer(currentQuestionId);
                        let answer = description ?? '';
                        if (type === 'RADIO' || type === 'DROPDOWN') answer = Options.filter(({ id: optionId })=>optionId === answer)[0]?.Translations?.filter((item)=>item.languageId === languageId)[0]?.description ?? '';
                        else if (type === 'DATE') answer = description ? (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(description).format('MM/DD/YYYY') : '';
                        return (0, $bb3TF.jsx)((0, $5ff185600f2abd5a$export$2e2bcd8739ae039), {
                            label: question,
                            answer: answer
                        }, currentQuestionId);
                    }),
                    isEditing && (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                        name: id,
                        form: form,
                        style: {
                            width: '100%'
                        },
                        layout: "vertical",
                        initialValues: getInitialAnswerValues(),
                        onFinish: (values)=>saveAnswersHandler(values, id),
                        children: [
                            Questions.map(({ required: required, Translations: Translations, type: type, Options: Options, id: currentQuestionId })=>{
                                const question = translateQuestion(Translations);
                                const options = type === 'DROPDOWN' || type === 'RADIO' ? Options?.map(({ id: optionId, Translations: optionTranslations })=>({
                                        value: optionId,
                                        label: translateQuestion(optionTranslations ?? [])
                                    })) : [];
                                let answer = '';
                                const description = getAnswer(currentQuestionId);
                                answer = description ?? '';
                                return (0, $bb3TF.jsx)((0, $10718147b01f98b9$export$2e2bcd8739ae039), {
                                    type: type,
                                    options: options,
                                    required: required,
                                    questionName: question,
                                    onAnswerChange: onAnswerChange,
                                    currentValue: answer,
                                    questionId: currentQuestionId
                                });
                            }),
                            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                justify: "start",
                                style: {
                                    margin: '0 0 20px 0'
                                },
                                children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        form.submit();
                                    },
                                    children: "Save"
                                })
                            })
                        ]
                    }),
                    hasSubSections && SubSections.map((sub)=>/*#__PURE__*/ (0, $6fFrj.createElement)($4cc2fddd71f3dfc6$var$InterviewSection, {
                            ...{
                                ...sub,
                                jobId: jobId,
                                Answers: Answers
                            },
                            key: sub.id,
                            refetchInterviews: refetchInterviews,
                            expandInterviewSections: expandInterviewSections
                        }))
                ]
            }, id)
        })
    });
};
$4cc2fddd71f3dfc6$var$InterviewSection.defaultProps = {
    interviewName: ''
};
var $4cc2fddd71f3dfc6$export$2e2bcd8739ae039 = $4cc2fddd71f3dfc6$var$InterviewSection;


const $187560d63dadb93e$var$Interview = ({ loading: loading, sections: sections, answers: answers, interview: interview, refetchInterviews: refetchInterviews, expandInterviewSections: expandInterviewSections })=>{
    const jobContext = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const { taxYearInterviewId: taxYearInterviewId } = jobContext;
    if (loading) return (0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039), {});
    return (0, $bb3TF.jsx)("div", {
        children: sections?.map((section)=>/*#__PURE__*/ (0, $6fFrj.createElement)((0, $4cc2fddd71f3dfc6$export$2e2bcd8739ae039), {
                ...{
                    jobId: taxYearInterviewId,
                    Answers: answers
                },
                ...section,
                interviewName: interview.name,
                refetchInterviews: refetchInterviews,
                key: section.id,
                expandInterviewSections: expandInterviewSections
            }))
    });
};
var $187560d63dadb93e$export$2e2bcd8739ae039 = $187560d63dadb93e$var$Interview;



var $bb3TF = parcelRequire("bb3TF");




var $6fFrj = parcelRequire("6fFrj");


var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



const $4066a7fc7221bcd4$var$defaultOptions = {};
const $4066a7fc7221bcd4$export$d6acf01222cedde7 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation upsertJobTrackingByTaxYearInterviewId($createJobTrackingInput: CreateJobTrackingInput!) {
  upsertJobTrackingByTaxYearInterviewId(
    createJobTrackingInput: $createJobTrackingInput
  ) {
    id
    taxYearInterviewId
    expectedCompletion
    paymentsCompletedAt
    approvalsCompletedAt
    interviewCompletedAt
    filesCompletedAt
  }
}
    `;
function $4066a7fc7221bcd4$export$5d2654c94a62b996(baseOptions) {
    const options = {
        ...$4066a7fc7221bcd4$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($4066a7fc7221bcd4$export$d6acf01222cedde7, options);
}
const $4066a7fc7221bcd4$export$39ac829ab91f0716 = {
    Mutation: {
        upsertJobTrackingByTaxYearInterviewId: 'upsertJobTrackingByTaxYearInterviewId'
    }
};




const { FileAddOutlined: $374b9ff2696ee2b0$var$FileAddOutlined, CheckCircleOutlined: $374b9ff2696ee2b0$var$CheckCircleOutlined, UndoOutlined: $374b9ff2696ee2b0$var$UndoOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Paragraph: $374b9ff2696ee2b0$var$Paragraph, Link: $374b9ff2696ee2b0$var$Link } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
function $374b9ff2696ee2b0$var$Files() {
    const { dispatch: dispatch, taxYearInterviewId: taxYearInterviewId, progressStatusId: progressStatusId, filesCompletedAt: filesCompletedAt } = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const [isRequestFilesModalVisible, setIsRequestFilesModalVisible] = (0, $6fFrj.useState)(false);
    // graphql
    const [upsertJobTracking, { loading: loadingUpsertJobTracking }] = (0, $4066a7fc7221bcd4$export$5d2654c94a62b996)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    const handleRequestFiles = ()=>{
        setIsRequestFilesModalVisible(true);
    };
    const handleAllFilesReceived = async ()=>{
        const today = new Date();
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    filesCompletedAt: today
                }
            },
            onCompleted: ()=>{
                dispatch({
                    type: 'UPDATE',
                    payload: {
                        filesCompletedAt: today
                    }
                });
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Files marked as complete.');
            },
            refetchQueries: [
                {
                    query: (0, $732264f53056e08f$export$a3bc4d02ba9c53fe)
                },
                {
                    query: (0, $732264f53056e08f$export$d4e23f314f782a9d),
                    variables: {
                        progressStatusId: progressStatusId
                    }
                }
            ]
        });
    };
    const handleAllFilesNotReceived = async ()=>{
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    filesCompletedAt: null
                }
            },
            onCompleted: ()=>{
                dispatch({
                    type: 'UPDATE',
                    payload: {
                        filesCompletedAt: null
                    }
                });
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Files marked as not complete.');
            }
        });
    };
    return (0, $bb3TF.jsxs)("div", {
        style: {
            marginLeft: 5
        },
        children: [
            (0, $bb3TF.jsx)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsxs)($374b9ff2696ee2b0$var$Paragraph, {
                    style: {
                        marginTop: 30
                    },
                    children: [
                        "Request files from your clients. Files will be visible in the\u00A0",
                        (0, $bb3TF.jsx)($374b9ff2696ee2b0$var$Link, {
                            href: `#account-client-interview-files-section-${taxYearInterviewId}`,
                            children: "Job Specific Client Files"
                        }),
                        ' ',
                        "section below."
                    ]
                })
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    20,
                    10
                ],
                style: {
                    marginTop: 10,
                    marginBottom: 15
                },
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "default",
                            icon: (0, $bb3TF.jsx)($374b9ff2696ee2b0$var$FileAddOutlined, {}),
                            iconDirection: "left",
                            onClick: handleRequestFiles,
                            children: "Request Files"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: !filesCompletedAt ? (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "primary",
                            icon: (0, $bb3TF.jsx)($374b9ff2696ee2b0$var$CheckCircleOutlined, {}),
                            iconDirection: "left",
                            onClick: handleAllFilesReceived,
                            loading: loadingUpsertJobTracking,
                            children: "Mark All Files Received"
                        }) : (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "default",
                            icon: (0, $bb3TF.jsx)($374b9ff2696ee2b0$var$UndoOutlined, {}),
                            iconDirection: "left",
                            onClick: handleAllFilesNotReceived,
                            loading: loadingUpsertJobTracking,
                            children: "Mark all Files Not Received"
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $2cf25dec861a2f20$export$2e2bcd8739ae039), {
                isModalVisible: isRequestFilesModalVisible,
                setIsModalVisible: setIsRequestFilesModalVisible
            })
        ]
    });
}
var $374b9ff2696ee2b0$export$2e2bcd8739ae039 = $374b9ff2696ee2b0$var$Files;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");





const $77affb39e34dc16b$var$defaultOptions = {};
const $77affb39e34dc16b$export$1be5670bf785260e = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment PaymentPhone on PhonesEntity {
  id
  value
  type
}
    `;
const $77affb39e34dc16b$export$1730992d983a6b2 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment PaymentAddress on AddressEntity {
  id
  lineOne
  lineTwo
  city
  state
  zip
  type
}
    `;
const $77affb39e34dc16b$export$b0c6acbe44f12fe8 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetPaymentsByTaxYearInterviewId($taxYearInterviewId: String!, $includeDeleted: Boolean) {
  paymentsByTaxYearInterviewId(
    taxYearInterviewId: $taxYearInterviewId
    includeDeleted: $includeDeleted
  ) {
    id
    referralFee
    preparerFee
    discountApplied
    totalDollarAmount
    paymentProcessorFee
    entityId
    taskId
    taxYearInterviewId
    paymentProcessorId
    paidOffline
    completedAt
    deletedAt
    status
    requestAt
    promisedAt
    paymentIntentId
    createAt
    updateAt
    Invoices {
      id
      description
      priceEach
      quantity
      paymentId
      createAt
      updateAt
    }
    FirmAccount {
      id
      name
      BusinessInformation {
        id
        Address {
          ...PaymentAddress
        }
        Phones {
          ...PaymentPhone
        }
      }
      Users {
        UserInformation {
          firstName
          lastName
          Address {
            ...PaymentAddress
          }
          Phones {
            ...PaymentPhone
          }
        }
      }
      CustomLayout {
        logo
      }
    }
    Entity {
      Users {
        UserInformation {
          firstName
          lastName
          Address {
            ...PaymentAddress
          }
          Phones {
            ...PaymentPhone
          }
        }
      }
    }
  }
}
    ${$77affb39e34dc16b$export$1730992d983a6b2}
${$77affb39e34dc16b$export$1be5670bf785260e}`;
function $77affb39e34dc16b$export$357cf8e54532943d(baseOptions) {
    const options = {
        ...$77affb39e34dc16b$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($77affb39e34dc16b$export$b0c6acbe44f12fe8, options);
}
function $77affb39e34dc16b$export$44763bff36412b1f(baseOptions) {
    const options = {
        ...$77affb39e34dc16b$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($77affb39e34dc16b$export$b0c6acbe44f12fe8, options);
}
const $77affb39e34dc16b$export$87629a9bd9a10558 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetFirmLogo($id: String!) {
  GetFirmLogo(id: $id) {
    base64
    width
    height
  }
}
    `;
function $77affb39e34dc16b$export$84cba9dc9b8351b4(baseOptions) {
    const options = {
        ...$77affb39e34dc16b$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($77affb39e34dc16b$export$87629a9bd9a10558, options);
}
function $77affb39e34dc16b$export$6a64aa919104efc3(baseOptions) {
    const options = {
        ...$77affb39e34dc16b$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($77affb39e34dc16b$export$87629a9bd9a10558, options);
}
const $77affb39e34dc16b$export$39ac829ab91f0716 = {
    Query: {
        GetPaymentsByTaxYearInterviewId: 'GetPaymentsByTaxYearInterviewId',
        GetFirmLogo: 'GetFirmLogo'
    },
    Fragment: {
        PaymentPhone: 'PaymentPhone',
        PaymentAddress: 'PaymentAddress'
    }
};



const $9d2c47b028219547$var$defaultOptions = {};
const $9d2c47b028219547$export$c2c79a3a501bf08b = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreatePayments($createPaymentsInput: CreatePaymentsInput!) {
  CreatePayments(createPaymentsInput: $createPaymentsInput) {
    id
  }
}
    `;
function $9d2c47b028219547$export$10d53614852a9cd3(baseOptions) {
    const options = {
        ...$9d2c47b028219547$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($9d2c47b028219547$export$c2c79a3a501bf08b, options);
}
const $9d2c47b028219547$export$72a4ec5afd8df0dc = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation SendInvoiceReminder($paymentId: String!) {
  SendInvoiceReminder(paymentId: $paymentId)
}
    `;
function $9d2c47b028219547$export$fd4e7d5c474241a0(baseOptions) {
    const options = {
        ...$9d2c47b028219547$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($9d2c47b028219547$export$72a4ec5afd8df0dc, options);
}
const $9d2c47b028219547$export$b8f20a0d42685f96 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdatePayment($updatePaymentsInput: UpdatePaymentsInput!) {
  updatePayments(updatePaymentsInput: $updatePaymentsInput) {
    id
    referralFee
    preparerFee
    discountApplied
    totalDollarAmount
    paymentProcessorFee
    entityId
    taskId
    taxYearInterviewId
    paymentProcessorId
    paidOffline
    completedAt
    deletedAt
    status
    requestAt
    promisedAt
    paymentIntentId
    createAt
    updateAt
    Invoices {
      id
      description
      priceEach
      quantity
      paymentId
      createAt
      updateAt
    }
    Entity {
      Users {
        UserInformation {
          firstName
          lastName
          Address {
            id
            lineOne
            lineTwo
            city
            state
            zip
            type
          }
          Phones {
            id
            value
            type
          }
        }
      }
    }
  }
}
    `;
function $9d2c47b028219547$export$c76120c8b4f78861(baseOptions) {
    const options = {
        ...$9d2c47b028219547$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($9d2c47b028219547$export$b8f20a0d42685f96, options);
}
const $9d2c47b028219547$export$39add399b5a14f66 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation createPaymentMethod($customerId: String!, $createStripePaymentMethodInput: CreateStripePaymentMethodInput!) {
  createPaymentMethod(
    customerId: $customerId
    createStripePaymentMethodInput: $createStripePaymentMethodInput
  ) {
    id
  }
}
    `;
function $9d2c47b028219547$export$8a9f86cd80018234(baseOptions) {
    const options = {
        ...$9d2c47b028219547$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($9d2c47b028219547$export$39add399b5a14f66, options);
}
const $9d2c47b028219547$export$6377090f76d2e95a = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation updatePaymentWithInvoices($updatePaymentsInput: UpdatePaymentWithInvoicesInput!) {
  updatePaymentWithInvoices(updatePaymentsInput: $updatePaymentsInput) {
    id
    referralFee
    preparerFee
    discountApplied
    totalDollarAmount
    paymentProcessorFee
    entityId
    taskId
    taxYearInterviewId
    paymentProcessorId
    paidOffline
    completedAt
    deletedAt
    status
    requestAt
    promisedAt
    paymentIntentId
    createAt
    updateAt
  }
}
    `;
function $9d2c47b028219547$export$439aa01c822f46be(baseOptions) {
    const options = {
        ...$9d2c47b028219547$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($9d2c47b028219547$export$6377090f76d2e95a, options);
}
const $9d2c47b028219547$export$9e18e8c7e94cbffc = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation deletePaymentWithInvoices($paymentId: String!) {
  removePayment(id: $paymentId)
}
    `;
function $9d2c47b028219547$export$3d988871ef9f7255(baseOptions) {
    const options = {
        ...$9d2c47b028219547$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($9d2c47b028219547$export$9e18e8c7e94cbffc, options);
}
const $9d2c47b028219547$export$39ac829ab91f0716 = {
    Mutation: {
        CreatePayments: 'CreatePayments',
        SendInvoiceReminder: 'SendInvoiceReminder',
        UpdatePayment: 'UpdatePayment',
        createPaymentMethod: 'createPaymentMethod',
        updatePaymentWithInvoices: 'updatePaymentWithInvoices',
        deletePaymentWithInvoices: 'deletePaymentWithInvoices'
    }
};







var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");








const { PlusOutlined: $7a6b63d135eabfc4$var$PlusOutlined, DeleteOutlined: $7a6b63d135eabfc4$var$DeleteOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Paragraph: $7a6b63d135eabfc4$var$Paragraph, Text: $7a6b63d135eabfc4$var$Text, Title: $7a6b63d135eabfc4$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $7a6b63d135eabfc4$var$faultTolerantImage = 'data:image/png;base64,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';
const $7a6b63d135eabfc4$var$CreateOrUpdateInvoiceModal = ({ isModalVisible: isModalVisible, setIsModalVisible: setIsModalVisible, paymentData: paymentData })=>{
    const isEditing = !!paymentData;
    const [form] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    const [companyInformationData, setCompanyInformationData] = (0, $6fFrj.useState)([]);
    const [keys, setKeys] = (0, $6fFrj.useState)([
        (Math.random() + 1).toString(36).substring(7)
    ]);
    const [descriptions, setDescriptions] = (0, $6fFrj.useState)([]);
    const [prices, setPrices] = (0, $6fFrj.useState)([]);
    const [quantities, setQuantities] = (0, $6fFrj.useState)([]);
    const [itemTotals, setItemTotals] = (0, $6fFrj.useState)([]);
    const [submitDisabled, setSubmitDisabled] = (0, $6fFrj.useState)(true);
    // Get user information from Redux store
    const { firmAccountId: firmAccountId } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const { entityId: entityId } = (0, $6fFrj.useContext)((0, $9f8459ba594d5b47$export$7fd9bd9faa7887cb));
    const { clientFirstName: clientFirstName, clientLastName: clientLastName, taxYearInterviewId: taxYearInterviewId } = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    // graphql
    // get logo
    const { data: customLayoutData } = (0, $732264f53056e08f$export$a9d926e7a1510ac6)();
    const customLayout = customLayoutData?.CustomLayout;
    // Get firm account info
    const { data: firmAccountInfoData } = (0, $732264f53056e08f$export$c65bb1005cf74961)();
    const resetFormValues = ()=>{
        setKeys([
            (Math.random() + 1).toString(36).substring(7)
        ]);
        setDescriptions([
            ''
        ]);
        setPrices([
            0
        ]);
        setQuantities([
            1
        ]);
        setItemTotals([
            0
        ]);
        form.setFieldsValue({
            'description-0': '',
            'priceEach-0': 0,
            'quantity-0': 1,
            'itemTotal-0': 0
        });
    };
    (0, $6fFrj.useEffect)(()=>{
        if (paymentData) {
            setKeys(paymentData.Invoices.map((i)=>i.id));
            setDescriptions(paymentData.Invoices.map((i)=>i.description));
            setPrices(paymentData.Invoices.map((i)=>i.priceEach));
            setQuantities(paymentData.Invoices.map((i)=>i.quantity));
            setItemTotals(paymentData.Invoices.map((i)=>i.quantity * i.priceEach));
            const valuesArray = paymentData.Invoices.map((i, index)=>({
                    [`description-${index}`]: i.description,
                    [`priceEach-${index}`]: i.priceEach,
                    [`quantity-${index}`]: i.quantity,
                    [`itemTotal-${index}`]: i.priceEach * i.quantity
                }));
            const fieldsValue = valuesArray.reduce((obj, item)=>({
                    ...obj,
                    ...item
                }), {});
            form.setFieldsValue(fieldsValue);
        } else resetFormValues();
    }, [
        paymentData,
        isModalVisible
    ]);
    // Mutation for creating a payment
    const [createPayment, { loading: loadingCreatePayment }] = (0, $9d2c47b028219547$export$10d53614852a9cd3)({
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Payment created successfully');
            setIsModalVisible(false);
            resetFormValues();
        },
        onError: (error)=>{
            if (error.message.indexOf('No valid payment method types for this Payment Intent.') === 0 || error.message === 'Not handled error') (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Stripe account is not connected. It can be connected in Setup Invoicing section.');
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        },
        refetchQueries: [
            (0, $77affb39e34dc16b$export$b0c6acbe44f12fe8)
        ],
        awaitRefetchQueries: true
    });
    // update payments
    const [updatePaymentWithInvoices, { loading: loadingUpdatePayment }] = (0, $9d2c47b028219547$export$439aa01c822f46be)({
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Payment updated successfully');
            setIsModalVisible(false);
            resetFormValues();
        },
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        },
        refetchQueries: [
            (0, $77affb39e34dc16b$export$b0c6acbe44f12fe8)
        ],
        awaitRefetchQueries: true
    });
    const deleteInvoiceRow = async (key)=>{
        const index = keys.indexOf(key);
        // descriptions
        const newDescriptions = [
            ...descriptions
        ];
        newDescriptions.splice(index, 1);
        setDescriptions(newDescriptions);
        const mappedDescriptions = newDescriptions.map((item, i)=>({
                [`description-${i}`]: item
            }));
        const descriptionsObject = Object.assign({}, ...mappedDescriptions);
        // prices
        const newPrices = [
            ...prices
        ];
        newPrices.splice(index, 1);
        setPrices(newPrices);
        const mappedPrices = newPrices.map((item, i)=>({
                [`priceEach-${i}`]: item
            }));
        const pricesObject = Object.assign({}, ...mappedPrices);
        // quantities
        const newQuantities = [
            ...quantities
        ];
        newQuantities.splice(index, 1);
        setQuantities(newQuantities);
        const mappedQuantities = newQuantities.map((item, i)=>({
                [`quantity-${i}`]: item
            }));
        const quantitiesObject = Object.assign({}, ...mappedQuantities);
        // totals
        const newTotals = [
            ...itemTotals
        ];
        newTotals.splice(index, 1);
        setItemTotals(newTotals);
        const mappedTotals = newTotals.map((item, i)=>({
                [`itemTotal-${i}`]: item
            }));
        const totalsObject = Object.assign({}, ...mappedTotals);
        // form
        form.setFieldsValue({
            ...descriptionsObject,
            ...pricesObject,
            ...quantitiesObject,
            ...totalsObject
        });
        setKeys((oldKeys)=>oldKeys.filter((k, keyIndex)=>keyIndex !== index));
    };
    const columns = [
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            render: (text, row, index)=>(0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: `description-${index}`,
                    style: {
                        margin: 0
                    },
                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                        placeholder: "Enter a description for this line item",
                        value: descriptions[index]
                    })
                })
        },
        {
            title: 'Price Each',
            dataIndex: 'priceEach',
            key: 'priceEach',
            render: (text, row, index)=>(0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: `priceEach-${index}`,
                    style: {
                        margin: 0
                    },
                    initialValue: 0,
                    children: (0, $bb3TF.jsx)((0, $4d58e046767e1c41$export$2e2bcd8739ae039), {
                        step: "0.01",
                        formatter: (value)=>`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                        value: prices[index],
                        min: 0
                    })
                })
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (text, row, index)=>(0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: `quantity-${index}`,
                    style: {
                        margin: 0
                    },
                    initialValue: 1,
                    children: (0, $bb3TF.jsx)((0, $4d58e046767e1c41$export$2e2bcd8739ae039), {
                        min: 1,
                        max: 99,
                        value: quantities[index]
                    })
                })
        },
        {
            title: 'Item Total',
            dataIndex: 'itemTotal',
            key: 'itemTotal',
            render: (text, row, index)=>(0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: `itemTotal-${index}`,
                    style: {
                        margin: 0
                    },
                    children: (0, $bb3TF.jsx)("span", {
                        children: itemTotals[index] ? `$ ${itemTotals[index].toFixed(2)}` : '$ 0.00'
                    })
                })
        },
        {
            title: 'Delete',
            dataIndex: 'delete',
            key: 'delete',
            render: (val, row)=>(0, $bb3TF.jsx)($7a6b63d135eabfc4$var$DeleteOutlined, {
                    onClick: ()=>{
                        deleteInvoiceRow(row);
                    },
                    style: {
                        cursor: 'pointer'
                    }
                })
        }
    ];
    const generateCompanyInformationData = (firmAccount)=>{
        const firmAddress = firmAccount?.Address?.[0]?.lineOne ? `${firmAccount?.Address?.[0]?.lineOne}, 
        ${firmAccount?.Address?.[0]?.lineTwo}, 
        ${firmAccount?.Address?.[0]?.city}, 
        ${firmAccount?.Address?.[0]?.state}, 
        ${firmAccount?.Address?.[0]?.zip}` : null;
        const data = [];
        if (firmAccount?.FirmAccount?.name) data.push({
            title: 'Firm Name',
            value: firmAccount?.FirmAccount?.name
        });
        if (firmAddress) data.push({
            title: 'Firm Address',
            value: firmAddress
        });
        if (firmAccount?.Phones?.[0]?.value) data.push({
            title: 'Firm Phone',
            value: firmAccount?.Phones?.[0]?.value
        });
        setCompanyInformationData(data);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (firmAccountInfoData) {
            const firmAccount = firmAccountInfoData?.BusinessInformation;
            generateCompanyInformationData(firmAccount);
        }
    }, [
        firmAccountInfoData
    ]);
    const cancelButtonOnClick = ()=>{
        setIsModalVisible(false);
    };
    const addLineItemOnClick = ()=>{
        setKeys((oldArray)=>[
                ...oldArray,
                (Math.random() + 1).toString(36).substring(7)
            ]);
        setDescriptions((oldArray)=>[
                ...oldArray,
                ''
            ]);
        setPrices((oldArray)=>[
                ...oldArray,
                0
            ]);
        setQuantities((oldArray)=>[
                ...oldArray,
                0
            ]);
        form.setFieldsValue({
            [`description-${keys.length}`]: '',
            [`priceEach-${keys.length}`]: 0,
            [`quantity-${keys.length}`]: 1
        });
        setSubmitDisabled(true);
    };
    const onFinish = (values)=>{
        // format into invoces
        const invoices = [];
        for(let i = 0; i < keys.length; i += 1){
            const invoice = {
                id: isEditing ? keys[i] : undefined,
                description: values[`description-${i}`],
                priceEach: values[`priceEach-${i}`],
                quantity: values[`quantity-${i}`]
            };
            invoices.push(invoice);
        }
        // check amount before payment
        const totalAmount = invoices.reduce((partialAmount, x)=>partialAmount + x.priceEach * x.quantity, 0);
        if (totalAmount <= 1) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Amount is not valid. Please enter total amount > $1');
            return;
        }
        if (isEditing) {
            const invoices2Create = invoices.filter((i)=>!paymentData.Invoices.some((invoice)=>invoice.id === i.id));
            const invoices2Update = invoices.filter((i)=>paymentData.Invoices.some((invoice)=>invoice.id === i.id));
            const invoices2Delete = paymentData.Invoices.filter((i)=>!invoices.some((invoice)=>invoice.id === i.id));
            // console.log('Update payment', { invoices2Create, invoices2Update, invoices2Delete });
            updatePaymentWithInvoices({
                variables: {
                    updatePaymentsInput: {
                        paymentId: paymentData.id,
                        invoices2Create: invoices2Create.map((invoice)=>({
                                ...invoice,
                                id: undefined,
                                __typename: undefined,
                                paymentId: undefined,
                                createAt: undefined,
                                updateAt: undefined
                            })),
                        invoices2Update: invoices2Update.map((invoice)=>({
                                ...invoice,
                                __typename: undefined,
                                paymentId: undefined,
                                createAt: undefined,
                                updateAt: undefined
                            })),
                        invoices2Delete: invoices2Delete.map((invoice)=>({
                                ...invoice,
                                __typename: undefined,
                                paymentId: undefined,
                                createAt: undefined,
                                updateAt: undefined
                            }))
                    }
                }
            });
            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
                Title: 'Update invoice request',
                Source: 'Button click',
                url: window.location.href
            });
        } else {
            // create the payment
            createPayment({
                variables: {
                    createPaymentsInput: {
                        firmAccountId: firmAccountId,
                        taxYearInterviewId: taxYearInterviewId,
                        entityId: entityId,
                        invoices: invoices
                    }
                }
            });
            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
                Title: 'Create invoice request',
                Source: 'Button click',
                url: window.location.href
            });
        }
    }; // end onFinish
    const onValuesChange = (changedValues, allValues)=>{
        const index = Object.keys(changedValues)[0].split('-')[1];
        setDescriptions((oldArray)=>{
            const newArray = [
                ...oldArray
            ];
            newArray[index] = allValues[`description-${index}`];
            return newArray;
        });
        setPrices((oldArray)=>{
            const newArray = [
                ...oldArray
            ];
            newArray[index] = allValues[`priceEach-${index}`];
            return newArray;
        });
        setQuantities((oldArray)=>{
            const newArray = [
                ...oldArray
            ];
            newArray[index] = allValues[`quantity-${index}`];
            return newArray;
        });
        setItemTotals((oldArray)=>{
            const newArray = [
                ...oldArray
            ];
            newArray[index] = allValues[`priceEach-${index}`] * allValues[`quantity-${index}`];
            return newArray;
        });
        form.setFieldsValue({
            [`description-${index}`]: allValues[`description-${index}`],
            [`priceEach-${index}`]: allValues[`priceEach-${index}`],
            [`quantity-${index}`]: allValues[`quantity-${index}`],
            [`itemTotal-${index}`]: allValues[`priceEach-${index}`] * allValues[`quantity-${index}`]
        });
    };
    (0, $6fFrj.useEffect)(()=>{
        const isValid = descriptions.every((x)=>!!x) && prices.every((x)=>!!x) && quantities.every((x)=>!!x) && descriptions.length > 0 && prices.length > 0 && quantities.length > 0;
        setSubmitDisabled(!isValid);
    }, [
        descriptions,
        prices,
        quantities
    ]);
    const modalTitle = (userName)=>(0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
            children: [
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    children: [
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            span: 20,
                            children: (0, $bb3TF.jsx)($7a6b63d135eabfc4$var$Title, {
                                level: 4,
                                children: isEditing ? 'Update Invoice' : 'Create Invoice'
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            span: 3,
                            children: (0, $bb3TF.jsx)((0, $290d39e90e1ee9b2$export$2e2bcd8739ae039), {
                                style: {
                                    position: 'absolute',
                                    top: '-1em'
                                },
                                width: 95,
                                src: customLayout?.logo,
                                fallback: $7a6b63d135eabfc4$var$faultTolerantImage
                            })
                        })
                    ]
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 12,
                        children: (0, $bb3TF.jsx)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                            direction: "horizontal",
                            children: (0, $bb3TF.jsx)($7a6b63d135eabfc4$var$Text, {
                                type: "secondary",
                                children: userName
                            })
                        })
                    })
                })
            ]
        });
    return (0, $bb3TF.jsxs)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        bodyStyle: {
            maxHeight: 450,
            overflowY: 'scroll'
        },
        title: modalTitle(`${clientFirstName} ${clientLastName}`),
        okText: isEditing ? 'Update Invoice' : 'Send Invoice',
        okButtonProps: {
            disabled: loadingCreatePayment || submitDisabled,
            loading: loadingCreatePayment || loadingUpdatePayment
        },
        centered: true,
        visible: isModalVisible,
        onOk: form.submit,
        onCancel: cancelButtonOnClick,
        width: 1000,
        children: [
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    span: 24,
                    children: Boolean(companyInformationData.length) && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($7a6b63d135eabfc4$var$Paragraph, {
                            strong: true,
                            style: {
                                textTransform: 'capitalize'
                            },
                            children: companyInformationData.map((el)=>el.value).join(', ')
                        })
                    })
                })
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    span: 24,
                    children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                        onFinish: onFinish,
                        form: form,
                        onValuesChange: onValuesChange,
                        style: {
                            width: '100%'
                        },
                        children: (0, $bb3TF.jsx)((0, $2eb2b7b37988b8f9$export$2e2bcd8739ae039), {
                            rowKey: (record)=>record,
                            columns: columns,
                            dataSource: [
                                ...keys
                            ],
                            // eslint-disable-next-line react/no-unstable-nested-components
                            footer: ()=>(0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    onClick: addLineItemOnClick,
                                    icon: (0, $bb3TF.jsx)($7a6b63d135eabfc4$var$PlusOutlined, {}),
                                    children: "Add Line Item"
                                }),
                            pagination: false
                        })
                    })
                })
            })
        ]
    });
};
var $7a6b63d135eabfc4$export$2e2bcd8739ae039 = $7a6b63d135eabfc4$var$CreateOrUpdateInvoiceModal;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.5.1 Built on 2022-01-28T15:37:57.791Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */ 
var $tywpZ = parcelRequire("tywpZ");
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Much of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// Many optimizations have been made, so the bundle size is ultimately smaller but performance is similar.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $3ae101cb5c0083b5$var$ch2 = {};
var $3ae101cb5c0083b5$var$wk = function(c, id, msg, transfer, cb) {
    var u = $3ae101cb5c0083b5$var$ch2[id] || ($3ae101cb5c0083b5$var$ch2[id] = URL.createObjectURL(new Blob([
        c
    ], {
        type: 'text/javascript'
    })));
    var w = new Worker(u);
    w.onerror = function(e) {
        return cb(e.error, null);
    };
    w.onmessage = function(e) {
        return cb(null, e.data);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $3ae101cb5c0083b5$var$u8 = Uint8Array, $3ae101cb5c0083b5$var$u16 = Uint16Array, $3ae101cb5c0083b5$var$u32 = Uint32Array;
// fixed length extra bits
var $3ae101cb5c0083b5$var$fleb = new $3ae101cb5c0083b5$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
// see fleb note
var $3ae101cb5c0083b5$var$fdeb = new $3ae101cb5c0083b5$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $3ae101cb5c0083b5$var$clim = new $3ae101cb5c0083b5$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $3ae101cb5c0083b5$var$freb = function(eb, start) {
    var b = new $3ae101cb5c0083b5$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $3ae101cb5c0083b5$var$u32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return [
        b,
        r
    ];
};
var $3ae101cb5c0083b5$var$_a = $3ae101cb5c0083b5$var$freb($3ae101cb5c0083b5$var$fleb, 2), $3ae101cb5c0083b5$var$fl = $3ae101cb5c0083b5$var$_a[0], $3ae101cb5c0083b5$var$revfl = $3ae101cb5c0083b5$var$_a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$3ae101cb5c0083b5$var$fl[28] = 258, $3ae101cb5c0083b5$var$revfl[258] = 28;
var $3ae101cb5c0083b5$var$_b = $3ae101cb5c0083b5$var$freb($3ae101cb5c0083b5$var$fdeb, 0), $3ae101cb5c0083b5$var$fd = $3ae101cb5c0083b5$var$_b[0], $3ae101cb5c0083b5$var$revfd = $3ae101cb5c0083b5$var$_b[1];
// map of value to reverse (assuming 16 bits)
var $3ae101cb5c0083b5$var$rev = new $3ae101cb5c0083b5$var$u16(32768);
for(var $3ae101cb5c0083b5$var$i = 0; $3ae101cb5c0083b5$var$i < 32768; ++$3ae101cb5c0083b5$var$i){
    // reverse table algorithm from SO
    var $3ae101cb5c0083b5$var$x = ($3ae101cb5c0083b5$var$i & 0xAAAA) >>> 1 | ($3ae101cb5c0083b5$var$i & 0x5555) << 1;
    $3ae101cb5c0083b5$var$x = ($3ae101cb5c0083b5$var$x & 0xCCCC) >>> 2 | ($3ae101cb5c0083b5$var$x & 0x3333) << 2;
    $3ae101cb5c0083b5$var$x = ($3ae101cb5c0083b5$var$x & 0xF0F0) >>> 4 | ($3ae101cb5c0083b5$var$x & 0x0F0F) << 4;
    $3ae101cb5c0083b5$var$rev[$3ae101cb5c0083b5$var$i] = (($3ae101cb5c0083b5$var$x & 0xFF00) >>> 8 | ($3ae101cb5c0083b5$var$x & 0x00FF) << 8) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $3ae101cb5c0083b5$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $3ae101cb5c0083b5$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $3ae101cb5c0083b5$var$u16(mb);
    for(i = 0; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $3ae101cb5c0083b5$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$3ae101cb5c0083b5$var$rev[v] >>> rvb] = sv;
        }
    } else {
        co = new $3ae101cb5c0083b5$var$u16(s);
        for(i = 0; i < s; ++i)co[i] = $3ae101cb5c0083b5$var$rev[le[cd[i] - 1]++] >>> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $3ae101cb5c0083b5$var$flt = new $3ae101cb5c0083b5$var$u8(288);
for(var $3ae101cb5c0083b5$var$i = 0; $3ae101cb5c0083b5$var$i < 144; ++$3ae101cb5c0083b5$var$i)$3ae101cb5c0083b5$var$flt[$3ae101cb5c0083b5$var$i] = 8;
for(var $3ae101cb5c0083b5$var$i = 144; $3ae101cb5c0083b5$var$i < 256; ++$3ae101cb5c0083b5$var$i)$3ae101cb5c0083b5$var$flt[$3ae101cb5c0083b5$var$i] = 9;
for(var $3ae101cb5c0083b5$var$i = 256; $3ae101cb5c0083b5$var$i < 280; ++$3ae101cb5c0083b5$var$i)$3ae101cb5c0083b5$var$flt[$3ae101cb5c0083b5$var$i] = 7;
for(var $3ae101cb5c0083b5$var$i = 280; $3ae101cb5c0083b5$var$i < 288; ++$3ae101cb5c0083b5$var$i)$3ae101cb5c0083b5$var$flt[$3ae101cb5c0083b5$var$i] = 8;
// fixed distance tree
var $3ae101cb5c0083b5$var$fdt = new $3ae101cb5c0083b5$var$u8(32);
for(var $3ae101cb5c0083b5$var$i = 0; $3ae101cb5c0083b5$var$i < 32; ++$3ae101cb5c0083b5$var$i)$3ae101cb5c0083b5$var$fdt[$3ae101cb5c0083b5$var$i] = 5;
// fixed length map
var $3ae101cb5c0083b5$var$flm = /*#__PURE__*/ $3ae101cb5c0083b5$var$hMap($3ae101cb5c0083b5$var$flt, 9, 0), $3ae101cb5c0083b5$var$flrm = /*#__PURE__*/ $3ae101cb5c0083b5$var$hMap($3ae101cb5c0083b5$var$flt, 9, 1);
// fixed distance map
var $3ae101cb5c0083b5$var$fdm = /*#__PURE__*/ $3ae101cb5c0083b5$var$hMap($3ae101cb5c0083b5$var$fdt, 5, 0), $3ae101cb5c0083b5$var$fdrm = /*#__PURE__*/ $3ae101cb5c0083b5$var$hMap($3ae101cb5c0083b5$var$fdt, 5, 1);
// find max of array
var $3ae101cb5c0083b5$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $3ae101cb5c0083b5$var$bits = function(d, p, m) {
    var o = p / 8 >> 0;
    return (d[o] | d[o + 1] << 8) >>> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $3ae101cb5c0083b5$var$bits16 = function(d, p) {
    var o = p / 8 >> 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >>> (p & 7);
};
// get end of byte
var $3ae101cb5c0083b5$var$shft = function(p) {
    return (p / 8 >> 0) + (p & 7 && 1);
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $3ae101cb5c0083b5$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v instanceof $3ae101cb5c0083b5$var$u16 ? $3ae101cb5c0083b5$var$u16 : v instanceof $3ae101cb5c0083b5$var$u32 ? $3ae101cb5c0083b5$var$u32 : $3ae101cb5c0083b5$var$u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
// expands raw DEFLATE data
var $3ae101cb5c0083b5$var$inflt = function(dat, buf, st) {
    // source length
    var sl = dat.length;
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st) st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf) buf = new $3ae101cb5c0083b5$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $3ae101cb5c0083b5$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            st.f = final = $3ae101cb5c0083b5$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $3ae101cb5c0083b5$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $3ae101cb5c0083b5$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) throw 'unexpected EOF';
                    break;
                }
                // ensure size
                if (noBuf) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8;
                continue;
            } else if (type == 1) lm = $3ae101cb5c0083b5$var$flrm, dm = $3ae101cb5c0083b5$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $3ae101cb5c0083b5$var$bits(dat, pos, 31) + 257, hcLen = $3ae101cb5c0083b5$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $3ae101cb5c0083b5$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $3ae101cb5c0083b5$var$u8(tl);
                // code length tree
                var clt = new $3ae101cb5c0083b5$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$3ae101cb5c0083b5$var$clim[i]] = $3ae101cb5c0083b5$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $3ae101cb5c0083b5$var$max(clt), clbmsk = (1 << clb) - 1;
                if (!noSt && pos + tl * (clb + 7) > tbts) break;
                // code lengths map
                var clm = $3ae101cb5c0083b5$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$3ae101cb5c0083b5$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $3ae101cb5c0083b5$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $3ae101cb5c0083b5$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $3ae101cb5c0083b5$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $3ae101cb5c0083b5$var$max(lt);
                // max dist bits
                dbt = $3ae101cb5c0083b5$var$max(dt);
                lm = $3ae101cb5c0083b5$var$hMap(lt, lbt, 1);
                dm = $3ae101cb5c0083b5$var$hMap(dt, dbt, 1);
            } else throw 'invalid block type';
            if (pos > tbts) throw 'unexpected EOF';
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var mxa = lbt + dbt + 18;
        while(noSt || pos + mxa < tbts){
            // bits read, code
            var c = lm[$3ae101cb5c0083b5$var$bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) throw 'unexpected EOF';
            if (!c) throw 'invalid length/literal';
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $3ae101cb5c0083b5$var$fleb[i];
                    add = $3ae101cb5c0083b5$var$bits(dat, pos, (1 << b) - 1) + $3ae101cb5c0083b5$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$3ae101cb5c0083b5$var$bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) throw 'invalid distance';
                pos += d & 15;
                var dt = $3ae101cb5c0083b5$var$fd[dsym];
                if (dsym > 3) {
                    var b = $3ae101cb5c0083b5$var$fdeb[dsym];
                    dt += $3ae101cb5c0083b5$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) throw 'unexpected EOF';
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = pos, st.b = bt;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    return bt == buf.length ? buf : $3ae101cb5c0083b5$var$slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $3ae101cb5c0083b5$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $3ae101cb5c0083b5$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var $3ae101cb5c0083b5$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return [
        new $3ae101cb5c0083b5$var$u8(0),
        0
    ];
    if (s == 1) {
        var v = new $3ae101cb5c0083b5$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [
            v,
            1
        ];
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $3ae101cb5c0083b5$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $3ae101cb5c0083b5$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [
        new $3ae101cb5c0083b5$var$u8(tr),
        mbt
    ];
};
// get the max length and assign length codes
var $3ae101cb5c0083b5$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($3ae101cb5c0083b5$var$ln(n.l, l, d + 1), $3ae101cb5c0083b5$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $3ae101cb5c0083b5$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $3ae101cb5c0083b5$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return [
        cl.subarray(0, cli),
        s
    ];
};
// calculate the length of output from tree, code lengths
var $3ae101cb5c0083b5$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $3ae101cb5c0083b5$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $3ae101cb5c0083b5$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $3ae101cb5c0083b5$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $3ae101cb5c0083b5$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $3ae101cb5c0083b5$var$hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = $3ae101cb5c0083b5$var$hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = $3ae101cb5c0083b5$var$lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = $3ae101cb5c0083b5$var$lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new $3ae101cb5c0083b5$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)lcfreq[lclt[i] & 31]++;
    for(var i = 0; i < lcdt.length; ++i)lcfreq[lcdt[i] & 31]++;
    var _e = $3ae101cb5c0083b5$var$hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$3ae101cb5c0083b5$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $3ae101cb5c0083b5$var$clen(lf, $3ae101cb5c0083b5$var$flt) + $3ae101cb5c0083b5$var$clen(df, $3ae101cb5c0083b5$var$fdt) + eb;
    var dtlen = $3ae101cb5c0083b5$var$clen(lf, dlt) + $3ae101cb5c0083b5$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $3ae101cb5c0083b5$var$clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen) return $3ae101cb5c0083b5$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $3ae101cb5c0083b5$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $3ae101cb5c0083b5$var$hMap(dlt, mlb, 0), ll = dlt, dm = $3ae101cb5c0083b5$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $3ae101cb5c0083b5$var$hMap(lct, mlcb, 0);
        $3ae101cb5c0083b5$var$wbits(out, p, nlc - 257);
        $3ae101cb5c0083b5$var$wbits(out, p + 5, ndc - 1);
        $3ae101cb5c0083b5$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$3ae101cb5c0083b5$var$wbits(out, p + 3 * i, lct[$3ae101cb5c0083b5$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $3ae101cb5c0083b5$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $3ae101cb5c0083b5$var$wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
            }
        }
    } else lm = $3ae101cb5c0083b5$var$flm, ll = $3ae101cb5c0083b5$var$flt, dm = $3ae101cb5c0083b5$var$fdm, dl = $3ae101cb5c0083b5$var$fdt;
    for(var i = 0; i < li; ++i)if (syms[i] > 255) {
        var len = syms[i] >>> 18 & 31;
        $3ae101cb5c0083b5$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
        if (len > 7) $3ae101cb5c0083b5$var$wbits(out, p, syms[i] >>> 23 & 31), p += $3ae101cb5c0083b5$var$fleb[len];
        var dst = syms[i] & 31;
        $3ae101cb5c0083b5$var$wbits16(out, p, dm[dst]), p += dl[dst];
        if (dst > 3) $3ae101cb5c0083b5$var$wbits16(out, p, syms[i] >>> 5 & 8191), p += $3ae101cb5c0083b5$var$fdeb[dst];
    } else $3ae101cb5c0083b5$var$wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
    $3ae101cb5c0083b5$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $3ae101cb5c0083b5$var$deo = /*#__PURE__*/ new $3ae101cb5c0083b5$var$u32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $3ae101cb5c0083b5$var$et = /*#__PURE__*/ new $3ae101cb5c0083b5$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $3ae101cb5c0083b5$var$dflt = function(dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new $3ae101cb5c0083b5$var$u8(pre + s + 5 * (1 + Math.floor(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) for(var i = 0; i <= s; i += 65535){
        // end
        var e = i + 65535;
        if (e < s) // write full block
        pos = $3ae101cb5c0083b5$var$wfblk(w, pos, dat.subarray(i, e));
        else {
            // write final block
            w[i] = lst;
            pos = $3ae101cb5c0083b5$var$wfblk(w, pos, dat.subarray(i, s));
        }
    }
    else {
        var opt = $3ae101cb5c0083b5$var$deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new $3ae101cb5c0083b5$var$u16(32768), head = new $3ae101cb5c0083b5$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $3ae101cb5c0083b5$var$u32(25000);
        // length/literal freq   distance freq
        var lf = new $3ae101cb5c0083b5$var$u16(288), df = new $3ae101cb5c0083b5$var$u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for(; i < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768
            var imod = i & 32767;
            // previous index with this value
            var pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = $3ae101cb5c0083b5$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j + 32768 & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti + 32768 & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod + 32768 & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $3ae101cb5c0083b5$var$revfl[l] << 18 | $3ae101cb5c0083b5$var$revfd[d];
                    var lin = $3ae101cb5c0083b5$var$revfl[l] & 31, din = $3ae101cb5c0083b5$var$revfd[d] & 31;
                    eb += $3ae101cb5c0083b5$var$fleb[lin] + $3ae101cb5c0083b5$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = $3ae101cb5c0083b5$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst) pos = $3ae101cb5c0083b5$var$wfblk(w, pos, $3ae101cb5c0083b5$var$et);
    }
    return $3ae101cb5c0083b5$var$slc(o, 0, pre + $3ae101cb5c0083b5$var$shft(pos) + post);
};
// CRC32 table
var $3ae101cb5c0083b5$var$crct = /*#__PURE__*/ function() {
    var t = new $3ae101cb5c0083b5$var$u32(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && 0xEDB88320) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $3ae101cb5c0083b5$var$crc = function() {
    var c = 0xFFFFFFFF;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $3ae101cb5c0083b5$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return c ^ 0xFFFFFFFF;
        }
    };
};
// Alder32
var $3ae101cb5c0083b5$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length;
            for(var i = 0; i != l;){
                var e = Math.min(i + 5552, l);
                for(; i < e; ++i)n += d[i], m += n;
                n %= 65521, m %= 65521;
            }
            a = n, b = m;
        },
        d: function() {
            return (a >>> 8 << 16 | (b & 255) << 8 | b >>> 8) + ((a & 255) << 23) * 2;
        }
    };
};
// deflate with opts
var $3ae101cb5c0083b5$var$dopt = function(dat, opt, pre, post, st) {
    return $3ae101cb5c0083b5$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st);
};
// Walmart object spread
var $3ae101cb5c0083b5$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $3ae101cb5c0083b5$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/ /g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return [
        fnStr,
        td
    ];
};
var $3ae101cb5c0083b5$var$ch = [];
// clone bufs
var $3ae101cb5c0083b5$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k] instanceof $3ae101cb5c0083b5$var$u8 || v[k] instanceof $3ae101cb5c0083b5$var$u16 || v[k] instanceof $3ae101cb5c0083b5$var$u32) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $3ae101cb5c0083b5$var$wrkr = function(fns, init, id, cb) {
    var _a;
    if (!$3ae101cb5c0083b5$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)_a = $3ae101cb5c0083b5$var$wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
        $3ae101cb5c0083b5$var$ch[id] = $3ae101cb5c0083b5$var$wcln(fns[m], fnStr, td_1);
    }
    var td = $3ae101cb5c0083b5$var$mrg({}, $3ae101cb5c0083b5$var$ch[id][1]);
    return $3ae101cb5c0083b5$var$wk($3ae101cb5c0083b5$var$ch[id][0] + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $3ae101cb5c0083b5$var$cbfs(td), cb);
};
// base async inflate fn
var $3ae101cb5c0083b5$var$bInflt = function() {
    return [
        $3ae101cb5c0083b5$var$u8,
        $3ae101cb5c0083b5$var$u16,
        $3ae101cb5c0083b5$var$u32,
        $3ae101cb5c0083b5$var$fleb,
        $3ae101cb5c0083b5$var$fdeb,
        $3ae101cb5c0083b5$var$clim,
        $3ae101cb5c0083b5$var$fl,
        $3ae101cb5c0083b5$var$fd,
        $3ae101cb5c0083b5$var$flrm,
        $3ae101cb5c0083b5$var$fdrm,
        $3ae101cb5c0083b5$var$rev,
        $3ae101cb5c0083b5$var$hMap,
        $3ae101cb5c0083b5$var$max,
        $3ae101cb5c0083b5$var$bits,
        $3ae101cb5c0083b5$var$bits16,
        $3ae101cb5c0083b5$var$shft,
        $3ae101cb5c0083b5$var$slc,
        $3ae101cb5c0083b5$var$inflt,
        $3ae101cb5c0083b5$export$90366d8b308ba94a,
        $3ae101cb5c0083b5$var$pbf,
        $3ae101cb5c0083b5$var$gu8
    ];
};
var $3ae101cb5c0083b5$var$bDflt = function() {
    return [
        $3ae101cb5c0083b5$var$u8,
        $3ae101cb5c0083b5$var$u16,
        $3ae101cb5c0083b5$var$u32,
        $3ae101cb5c0083b5$var$fleb,
        $3ae101cb5c0083b5$var$fdeb,
        $3ae101cb5c0083b5$var$clim,
        $3ae101cb5c0083b5$var$revfl,
        $3ae101cb5c0083b5$var$revfd,
        $3ae101cb5c0083b5$var$flm,
        $3ae101cb5c0083b5$var$flt,
        $3ae101cb5c0083b5$var$fdm,
        $3ae101cb5c0083b5$var$fdt,
        $3ae101cb5c0083b5$var$rev,
        $3ae101cb5c0083b5$var$deo,
        $3ae101cb5c0083b5$var$et,
        $3ae101cb5c0083b5$var$hMap,
        $3ae101cb5c0083b5$var$wbits,
        $3ae101cb5c0083b5$var$wbits16,
        $3ae101cb5c0083b5$var$hTree,
        $3ae101cb5c0083b5$var$ln,
        $3ae101cb5c0083b5$var$lc,
        $3ae101cb5c0083b5$var$clen,
        $3ae101cb5c0083b5$var$wfblk,
        $3ae101cb5c0083b5$var$wblk,
        $3ae101cb5c0083b5$var$shft,
        $3ae101cb5c0083b5$var$slc,
        $3ae101cb5c0083b5$var$dflt,
        $3ae101cb5c0083b5$var$dopt,
        $3ae101cb5c0083b5$export$21533ff51b8a0b4a,
        $3ae101cb5c0083b5$var$pbf
    ];
};
// gzip extra
var $3ae101cb5c0083b5$var$gze = function() {
    return [
        $3ae101cb5c0083b5$var$gzh,
        $3ae101cb5c0083b5$var$gzhl,
        $3ae101cb5c0083b5$var$wbytes,
        $3ae101cb5c0083b5$var$crc,
        $3ae101cb5c0083b5$var$crct
    ];
};
// gunzip extra
var $3ae101cb5c0083b5$var$guze = function() {
    return [
        $3ae101cb5c0083b5$var$gzs,
        $3ae101cb5c0083b5$var$gzl
    ];
};
// zlib extra
var $3ae101cb5c0083b5$var$zle = function() {
    return [
        $3ae101cb5c0083b5$var$zlh,
        $3ae101cb5c0083b5$var$wbytes,
        $3ae101cb5c0083b5$var$adler
    ];
};
// unzlib extra
var $3ae101cb5c0083b5$var$zule = function() {
    return [
        $3ae101cb5c0083b5$var$zlv
    ];
};
// post buf
var $3ae101cb5c0083b5$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get u8
var $3ae101cb5c0083b5$var$gu8 = function(o) {
    return o && o.size && new $3ae101cb5c0083b5$var$u8(o.size);
};
// async helper
var $3ae101cb5c0083b5$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $3ae101cb5c0083b5$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    if (!opts.consume) dat = new $3ae101cb5c0083b5$var$u8(dat);
    w.postMessage([
        dat,
        opts
    ], [
        dat.buffer
    ]);
    return function() {
        w.terminate();
    };
};
// auto stream
var $3ae101cb5c0083b5$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        return strm.push(ev.data[0], ev.data[1]);
    };
};
// async stream attach
var $3ae101cb5c0083b5$var$astrmify = function(fns, strm, opts, init, id) {
    var t;
    var w = $3ae101cb5c0083b5$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function(d, f) {
        if (t) throw 'stream finished';
        if (!strm.ondata) throw 'no stream handler';
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
};
// read 2 bytes
var $3ae101cb5c0083b5$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $3ae101cb5c0083b5$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16) + (d[b + 3] << 23) * 2;
};
// write bytes
var $3ae101cb5c0083b5$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $3ae101cb5c0083b5$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $3ae101cb5c0083b5$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $3ae101cb5c0083b5$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) throw 'invalid gzip data';
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += d[10] | (d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $3ae101cb5c0083b5$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16) + 2 * (d[l - 1] << 23);
};
// gzip header length
var $3ae101cb5c0083b5$var$gzhl = function(o) {
    return 10 + (o.filename && o.filename.length + 1 || 0);
};
// zlib header
var $3ae101cb5c0083b5$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (fl ? 32 - 2 * fl : 1);
};
// zlib valid
var $3ae101cb5c0083b5$var$zlv = function(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) throw 'invalid zlib data';
    if (d[1] & 32) throw 'invalid zlib data: preset dictionaries not supported';
};
function $3ae101cb5c0083b5$var$AsyncCmpStrm(opts, cb) {
    if (!cb && typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
// zlib footer: -4 to -0 is Adler32
/**
 * Streaming DEFLATE compression
 */ var $3ae101cb5c0083b5$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (!cb && typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($3ae101cb5c0083b5$var$dopt(c, this.o, 0, 0, !f), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (this.d) throw 'stream finished';
        if (!this.ondata) throw 'no stream handler';
        this.d = final;
        this.p(chunk, final || false);
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $3ae101cb5c0083b5$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $3ae101cb5c0083b5$var$astrmify([
            $3ae101cb5c0083b5$var$bDflt,
            function() {
                return [
                    $3ae101cb5c0083b5$var$astrm,
                    $3ae101cb5c0083b5$export$ae157b6234afe138
                ];
            }
        ], this, $3ae101cb5c0083b5$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $3ae101cb5c0083b5$export$ae157b6234afe138(ev.data);
            onmessage = $3ae101cb5c0083b5$var$astrm(strm);
        }, 6);
    }
    return AsyncDeflate;
}();
function $3ae101cb5c0083b5$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $3ae101cb5c0083b5$var$cbify(data, opts, [
        $3ae101cb5c0083b5$var$bDflt
    ], function(ev) {
        return $3ae101cb5c0083b5$var$pbf($3ae101cb5c0083b5$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $3ae101cb5c0083b5$export$21533ff51b8a0b4a(data, opts) {
    if (opts === void 0) opts = {};
    return $3ae101cb5c0083b5$var$dopt(data, opts, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $3ae101cb5c0083b5$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    /**
     * Creates an inflation stream
     * @param cb The callback to call whenever data is inflated
     */ function Inflate(cb) {
        this.s = {};
        this.p = new $3ae101cb5c0083b5$var$u8(0);
        this.ondata = cb;
    }
    Inflate.prototype.e = function(c) {
        if (this.d) throw 'stream finished';
        if (!this.ondata) throw 'no stream handler';
        var l = this.p.length;
        var n = new $3ae101cb5c0083b5$var$u8(l + c.length);
        n.set(this.p), n.set(c, l), this.p = n;
    };
    Inflate.prototype.c = function(final) {
        this.d = this.s.i = final || false;
        var bts = this.s.b;
        var dt = $3ae101cb5c0083b5$var$inflt(this.p, this.o, this.s);
        this.ondata($3ae101cb5c0083b5$var$slc(dt, bts, this.s.b), this.d);
        this.o = $3ae101cb5c0083b5$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $3ae101cb5c0083b5$var$slc(this.p, this.s.p / 8 >> 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $3ae101cb5c0083b5$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous inflation stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncInflate(cb) {
        this.ondata = cb;
        $3ae101cb5c0083b5$var$astrmify([
            $3ae101cb5c0083b5$var$bInflt,
            function() {
                return [
                    $3ae101cb5c0083b5$var$astrm,
                    $3ae101cb5c0083b5$export$d1de70a877d6e43c
                ];
            }
        ], this, 0, function() {
            var strm = new $3ae101cb5c0083b5$export$d1de70a877d6e43c();
            onmessage = $3ae101cb5c0083b5$var$astrm(strm);
        }, 7);
    }
    return AsyncInflate;
}();
function $3ae101cb5c0083b5$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $3ae101cb5c0083b5$var$cbify(data, opts, [
        $3ae101cb5c0083b5$var$bInflt
    ], function(ev) {
        return $3ae101cb5c0083b5$var$pbf($3ae101cb5c0083b5$export$90366d8b308ba94a(ev.data[0], $3ae101cb5c0083b5$var$gu8(ev.data[1])));
    }, 1, cb);
}
function $3ae101cb5c0083b5$export$90366d8b308ba94a(data, out) {
    return $3ae101cb5c0083b5$var$inflt(data, out);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $3ae101cb5c0083b5$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $3ae101cb5c0083b5$var$crc();
        this.l = 0;
        this.v = 1;
        $3ae101cb5c0083b5$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        $3ae101cb5c0083b5$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        this.c.p(c);
        this.l += c.length;
        var raw = $3ae101cb5c0083b5$var$dopt(c, this.o, this.v && $3ae101cb5c0083b5$var$gzhl(this.o), f && 8, !f);
        if (this.v) $3ae101cb5c0083b5$var$gzh(raw, this.o), this.v = 0;
        if (f) $3ae101cb5c0083b5$var$wbytes(raw, raw.length - 8, this.c.d()), $3ae101cb5c0083b5$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $3ae101cb5c0083b5$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $3ae101cb5c0083b5$var$astrmify([
            $3ae101cb5c0083b5$var$bDflt,
            $3ae101cb5c0083b5$var$gze,
            function() {
                return [
                    $3ae101cb5c0083b5$var$astrm,
                    $3ae101cb5c0083b5$export$ae157b6234afe138,
                    $3ae101cb5c0083b5$export$8e4b66d280bf8342
                ];
            }
        ], this, $3ae101cb5c0083b5$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $3ae101cb5c0083b5$export$8e4b66d280bf8342(ev.data);
            onmessage = $3ae101cb5c0083b5$var$astrm(strm);
        }, 8);
    }
    return AsyncGzip;
}();
function $3ae101cb5c0083b5$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $3ae101cb5c0083b5$var$cbify(data, opts, [
        $3ae101cb5c0083b5$var$bDflt,
        $3ae101cb5c0083b5$var$gze,
        function() {
            return [
                $3ae101cb5c0083b5$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $3ae101cb5c0083b5$var$pbf($3ae101cb5c0083b5$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $3ae101cb5c0083b5$export$3d616c3fb3e15483(data, opts) {
    if (opts === void 0) opts = {};
    var c = $3ae101cb5c0083b5$var$crc(), l = data.length;
    c.p(data);
    var d = $3ae101cb5c0083b5$var$dopt(data, opts, $3ae101cb5c0083b5$var$gzhl(opts), 8), s = d.length;
    return $3ae101cb5c0083b5$var$gzh(d, opts), $3ae101cb5c0083b5$var$wbytes(d, s - 8, c.d()), $3ae101cb5c0083b5$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming GZIP decompression
 */ var $3ae101cb5c0083b5$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    /**
     * Creates a GUNZIP stream
     * @param cb The callback to call whenever data is inflated
     */ function Gunzip(cb) {
        this.v = 1;
        $3ae101cb5c0083b5$export$d1de70a877d6e43c.call(this, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $3ae101cb5c0083b5$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            var s = $3ae101cb5c0083b5$var$gzs(this.p);
            if (s >= this.p.length && !final) return;
            this.p = this.p.subarray(s), this.v = 0;
        }
        if (final) {
            if (this.p.length < 8) throw 'invalid gzip stream';
            this.p = this.p.subarray(0, -8);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $3ae101cb5c0083b5$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming GZIP decompression
 */ var $3ae101cb5c0083b5$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous GUNZIP stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncGunzip(cb) {
        this.ondata = cb;
        $3ae101cb5c0083b5$var$astrmify([
            $3ae101cb5c0083b5$var$bInflt,
            $3ae101cb5c0083b5$var$guze,
            function() {
                return [
                    $3ae101cb5c0083b5$var$astrm,
                    $3ae101cb5c0083b5$export$d1de70a877d6e43c,
                    $3ae101cb5c0083b5$export$4cb607de6db70415
                ];
            }
        ], this, 0, function() {
            var strm = new $3ae101cb5c0083b5$export$4cb607de6db70415();
            onmessage = $3ae101cb5c0083b5$var$astrm(strm);
        }, 9);
    }
    return AsyncGunzip;
}();
function $3ae101cb5c0083b5$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $3ae101cb5c0083b5$var$cbify(data, opts, [
        $3ae101cb5c0083b5$var$bInflt,
        $3ae101cb5c0083b5$var$guze,
        function() {
            return [
                $3ae101cb5c0083b5$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $3ae101cb5c0083b5$var$pbf($3ae101cb5c0083b5$export$c80456f7aaba691c(ev.data[0]));
    }, 3, cb);
}
function $3ae101cb5c0083b5$export$c80456f7aaba691c(data, out) {
    return $3ae101cb5c0083b5$var$inflt(data.subarray($3ae101cb5c0083b5$var$gzs(data), -8), out || new $3ae101cb5c0083b5$var$u8($3ae101cb5c0083b5$var$gzl(data)));
}
/**
 * Streaming Zlib compression
 */ var $3ae101cb5c0083b5$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $3ae101cb5c0083b5$var$adler();
        this.v = 1;
        $3ae101cb5c0083b5$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        $3ae101cb5c0083b5$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        this.c.p(c);
        var raw = $3ae101cb5c0083b5$var$dopt(c, this.o, this.v && 2, f && 4, !f);
        if (this.v) $3ae101cb5c0083b5$var$zlh(raw, this.o), this.v = 0;
        if (f) $3ae101cb5c0083b5$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $3ae101cb5c0083b5$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $3ae101cb5c0083b5$var$astrmify([
            $3ae101cb5c0083b5$var$bDflt,
            $3ae101cb5c0083b5$var$zle,
            function() {
                return [
                    $3ae101cb5c0083b5$var$astrm,
                    $3ae101cb5c0083b5$export$ae157b6234afe138,
                    $3ae101cb5c0083b5$export$4187ccf2467013b9
                ];
            }
        ], this, $3ae101cb5c0083b5$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $3ae101cb5c0083b5$export$4187ccf2467013b9(ev.data);
            onmessage = $3ae101cb5c0083b5$var$astrm(strm);
        }, 10);
    }
    return AsyncZlib;
}();
function $3ae101cb5c0083b5$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $3ae101cb5c0083b5$var$cbify(data, opts, [
        $3ae101cb5c0083b5$var$bDflt,
        $3ae101cb5c0083b5$var$zle,
        function() {
            return [
                $3ae101cb5c0083b5$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $3ae101cb5c0083b5$var$pbf($3ae101cb5c0083b5$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $3ae101cb5c0083b5$export$f87121a6d50aff25(data, opts) {
    if (opts === void 0) opts = {};
    var a = $3ae101cb5c0083b5$var$adler();
    a.p(data);
    var d = $3ae101cb5c0083b5$var$dopt(data, opts, 2, 4);
    return $3ae101cb5c0083b5$var$zlh(d, opts), $3ae101cb5c0083b5$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $3ae101cb5c0083b5$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    /**
     * Creates a Zlib decompression stream
     * @param cb The callback to call whenever data is inflated
     */ function Unzlib(cb) {
        this.v = 1;
        $3ae101cb5c0083b5$export$d1de70a877d6e43c.call(this, cb);
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $3ae101cb5c0083b5$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 2 && !final) return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) throw 'invalid zlib stream';
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $3ae101cb5c0083b5$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $3ae101cb5c0083b5$export$cf6668790220dcad = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous Zlib decompression stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncUnzlib(cb) {
        this.ondata = cb;
        $3ae101cb5c0083b5$var$astrmify([
            $3ae101cb5c0083b5$var$bInflt,
            $3ae101cb5c0083b5$var$zule,
            function() {
                return [
                    $3ae101cb5c0083b5$var$astrm,
                    $3ae101cb5c0083b5$export$d1de70a877d6e43c,
                    $3ae101cb5c0083b5$export$af2424f875ff1b17
                ];
            }
        ], this, 0, function() {
            var strm = new $3ae101cb5c0083b5$export$af2424f875ff1b17();
            onmessage = $3ae101cb5c0083b5$var$astrm(strm);
        }, 11);
    }
    return AsyncUnzlib;
}();
function $3ae101cb5c0083b5$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $3ae101cb5c0083b5$var$cbify(data, opts, [
        $3ae101cb5c0083b5$var$bInflt,
        $3ae101cb5c0083b5$var$zule,
        function() {
            return [
                $3ae101cb5c0083b5$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $3ae101cb5c0083b5$var$pbf($3ae101cb5c0083b5$export$9ec8134f0f1b9fc6(ev.data[0], $3ae101cb5c0083b5$var$gu8(ev.data[1])));
    }, 5, cb);
}
function $3ae101cb5c0083b5$export$9ec8134f0f1b9fc6(data, out) {
    return $3ae101cb5c0083b5$var$inflt(($3ae101cb5c0083b5$var$zlv(data), data.subarray(2, -4)), out);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $3ae101cb5c0083b5$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    /**
     * Creates a decompression stream
     * @param cb The callback to call whenever data is decompressed
     */ function Decompress(cb) {
        this.G = $3ae101cb5c0083b5$export$4cb607de6db70415;
        this.I = $3ae101cb5c0083b5$export$d1de70a877d6e43c;
        this.Z = $3ae101cb5c0083b5$export$af2424f875ff1b17;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) throw 'no stream handler';
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $3ae101cb5c0083b5$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                var _this_1 = this;
                var cb = function() {
                    _this_1.ondata.apply(_this_1, arguments);
                };
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(cb) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(cb) : new this.Z(cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $3ae101cb5c0083b5$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    /**
   * Creates an asynchronous decompression stream
   * @param cb The callback to call whenever data is decompressed
   */ function AsyncDecompress(cb) {
        this.G = $3ae101cb5c0083b5$export$d5adcdd968132151;
        this.I = $3ae101cb5c0083b5$export$fff8358d6dbaa9cc;
        this.Z = $3ae101cb5c0083b5$export$cf6668790220dcad;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        $3ae101cb5c0083b5$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $3ae101cb5c0083b5$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $3ae101cb5c0083b5$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $3ae101cb5c0083b5$export$cae1ce83fe4a1782(data, opts, cb) : $3ae101cb5c0083b5$export$ca7cbb494e731274(data, opts, cb);
}
function $3ae101cb5c0083b5$export$c4bdbbbc9a4faabe(data, out) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $3ae101cb5c0083b5$export$c80456f7aaba691c(data, out) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $3ae101cb5c0083b5$export$90366d8b308ba94a(data, out) : $3ae101cb5c0083b5$export$9ec8134f0f1b9fc6(data, out);
}
// flatten a directory structure
var $3ae101cb5c0083b5$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k;
        if (val instanceof $3ae101cb5c0083b5$var$u8) t[n] = [
            val,
            o
        ];
        else if (Array.isArray(val)) t[n] = [
            val[0],
            $3ae101cb5c0083b5$var$mrg(o, val[1])
        ];
        else $3ae101cb5c0083b5$var$fltn(val, n + '/', t, o);
    }
};
function $3ae101cb5c0083b5$export$366b39a6daa8ed7a(str, latin1) {
    var l = str.length;
    if (!latin1 && typeof TextEncoder != 'undefined') return new TextEncoder().encode(str);
    var ar = new $3ae101cb5c0083b5$var$u8(str.length + (str.length >>> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $3ae101cb5c0083b5$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >>> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >>> 18), w(128 | c >>> 12 & 63), w(128 | c >>> 6 & 63), w(128 | c & 63);
        else w(224 | c >>> 12), w(128 | c >>> 6 & 63), w(128 | c & 63);
    }
    return $3ae101cb5c0083b5$var$slc(ar, 0, ai);
}
function $3ae101cb5c0083b5$export$adb211f8cb999894(dat, latin1) {
    var r = '';
    if (!latin1 && typeof TextDecoder != 'undefined') return new TextDecoder().decode(dat);
    for(var i = 0; i < dat.length;){
        var c = dat[i++];
        if (c < 128 || latin1) r += String.fromCharCode(c);
        else if (c < 224) r += String.fromCharCode((c & 31) << 6 | dat[i++] & 63);
        else if (c < 240) r += String.fromCharCode((c & 15) << 12 | (dat[i++] & 63) << 6 | dat[i++] & 63);
        else c = ((c & 15) << 18 | (dat[i++] & 63) << 12 | (dat[i++] & 63) << 6 | dat[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
    }
    return r;
}
// skip local zip header
var $3ae101cb5c0083b5$var$slzh = function(d, b) {
    return b + 30 + $3ae101cb5c0083b5$var$b2(d, b + 26) + $3ae101cb5c0083b5$var$b2(d, b + 28);
};
// read zip header
var $3ae101cb5c0083b5$var$zh = function(d, b, z) {
    var fnl = $3ae101cb5c0083b5$var$b2(d, b + 28), fn = $3ae101cb5c0083b5$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($3ae101cb5c0083b5$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl;
    var _a = z ? $3ae101cb5c0083b5$var$z64e(d, es) : [
        $3ae101cb5c0083b5$var$b4(d, b + 20),
        $3ae101cb5c0083b5$var$b4(d, b + 24),
        $3ae101cb5c0083b5$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $3ae101cb5c0083b5$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $3ae101cb5c0083b5$var$b2(d, b + 30) + $3ae101cb5c0083b5$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $3ae101cb5c0083b5$var$z64e = function(d, b) {
    for(; $3ae101cb5c0083b5$var$b2(d, b) != 1; b += 4 + $3ae101cb5c0083b5$var$b2(d, b + 2));
    return [
        $3ae101cb5c0083b5$var$b4(d, b + 12),
        $3ae101cb5c0083b5$var$b4(d, b + 4),
        $3ae101cb5c0083b5$var$b4(d, b + 20)
    ];
};
// write zip header
var $3ae101cb5c0083b5$var$wzh = function(d, b, c, cmp, su, fn, u, o, ce, t) {
    var fl = fn.length, l = cmp.length;
    $3ae101cb5c0083b5$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b] = 20, b += 2;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = t == 8 && (o.level == 1 ? 6 : o.level < 6 ? 4 : o.level == 9 ? 2 : 0), d[b++] = u && 8;
    d[b] = t, b += 2;
    var dt = new Date(o.mtime || Date.now()), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) throw 'date not in range 1980-2099';
    $3ae101cb5c0083b5$var$wbytes(d, b, (y << 24) * 2 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >>> 1);
    b += 4;
    $3ae101cb5c0083b5$var$wbytes(d, b, c);
    $3ae101cb5c0083b5$var$wbytes(d, b + 4, l);
    $3ae101cb5c0083b5$var$wbytes(d, b + 8, su);
    $3ae101cb5c0083b5$var$wbytes(d, b + 12, fl), b += 16; // skip extra field, comment
    if (ce != null) $3ae101cb5c0083b5$var$wbytes(d, b += 10, ce), b += 4;
    d.set(fn, b);
    b += fl;
    if (ce == null) d.set(cmp, b);
};
// write zip footer (end of central directory)
var $3ae101cb5c0083b5$var$wzf = function(o, b, c, d, e) {
    $3ae101cb5c0083b5$var$wbytes(o, b, 0x6054B50); // skip disk
    $3ae101cb5c0083b5$var$wbytes(o, b + 8, c);
    $3ae101cb5c0083b5$var$wbytes(o, b + 10, c);
    $3ae101cb5c0083b5$var$wbytes(o, b + 12, d);
    $3ae101cb5c0083b5$var$wbytes(o, b + 16, e);
};
function $3ae101cb5c0083b5$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    var r = {};
    $3ae101cb5c0083b5$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbf = function() {
        var out = new $3ae101cb5c0083b5$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                $3ae101cb5c0083b5$var$wzh(out, tot, f.c, f.d, f.m, f.n, f.u, f.p, null, f.t);
                $3ae101cb5c0083b5$var$wzh(out, o, f.c, f.d, f.m, f.n, f.u, f.p, tot, f.t), o += 46 + f.n.length, tot += 30 + f.n.length + f.d.length;
            } catch (e) {
                return cb(e, null);
            }
        }
        $3ae101cb5c0083b5$var$wzf(out, o, files.length, cdl, oe);
        cb(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $3ae101cb5c0083b5$var$crc(), m = file.length;
        c.p(file);
        var n = $3ae101cb5c0083b5$export$366b39a6daa8ed7a(fn), s = n.length;
        var t = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cb(e, null);
            } else {
                var l = d.length;
                files[i] = {
                    t: t,
                    d: d,
                    m: m,
                    c: c.d(),
                    u: fn.length != l,
                    n: n,
                    p: p
                };
                o += 30 + s + l;
                tot += 76 + 2 * s + l;
                if (!--lft) cbf();
            }
        };
        if (n.length > 65535) cbl('filename too long', null);
        if (!t) cbl(null, file);
        else if (m < 160000) try {
            cbl(null, $3ae101cb5c0083b5$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($3ae101cb5c0083b5$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $3ae101cb5c0083b5$export$eb1654f146d54eb3(data, opts) {
    if (opts === void 0) opts = {};
    var r = {};
    var files = [];
    $3ae101cb5c0083b5$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var t = p.level == 0 ? 0 : 8;
        var n = $3ae101cb5c0083b5$export$366b39a6daa8ed7a(fn), s = n.length;
        if (n.length > 65535) throw 'filename too long';
        var d = t ? $3ae101cb5c0083b5$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $3ae101cb5c0083b5$var$crc();
        c.p(file);
        files.push({
            t: t,
            d: d,
            m: file.length,
            c: c.d(),
            u: fn.length != s,
            n: n,
            o: o,
            p: p
        });
        o += 30 + s + l;
        tot += 76 + 2 * s + l;
    }
    var out = new $3ae101cb5c0083b5$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $3ae101cb5c0083b5$var$wzh(out, f.o, f.c, f.d, f.m, f.n, f.u, f.p, null, f.t);
        $3ae101cb5c0083b5$var$wzh(out, o, f.c, f.d, f.m, f.n, f.u, f.p, f.o, f.t), o += 46 + f.n.length;
    }
    $3ae101cb5c0083b5$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
function $3ae101cb5c0083b5$export$23c8d3f8757cab88(data, cb) {
    if (typeof cb != 'function') throw 'no callback';
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var e = data.length - 22;
    for(; $3ae101cb5c0083b5$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cb('invalid zip file', null);
        return;
    }
    var lft = $3ae101cb5c0083b5$var$b2(data, e + 8);
    if (!lft) cb(null, {});
    var c = lft;
    var o = $3ae101cb5c0083b5$var$b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = $3ae101cb5c0083b5$var$b4(data, e - 12);
        if ($3ae101cb5c0083b5$var$b4(data, e) != 0x6064B50) throw 'invalid zip file';
        c = lft = $3ae101cb5c0083b5$var$b4(data, e + 32);
        o = $3ae101cb5c0083b5$var$b4(data, e + 48);
    }
    var _loop_2 = function(i) {
        var _a = $3ae101cb5c0083b5$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $3ae101cb5c0083b5$var$slzh(data, off);
        o = no;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cb(e, null);
            } else {
                files[fn] = d;
                if (!--lft) cb(null, files);
            }
        };
        if (!c_1) cbl(null, $3ae101cb5c0083b5$var$slc(data, b, b + sc));
        else if (c_1 == 8) {
            var infl = data.subarray(b, b + sc);
            if (sc < 320000) try {
                cbl(null, $3ae101cb5c0083b5$export$90366d8b308ba94a(infl, new $3ae101cb5c0083b5$var$u8(su)));
            } catch (e) {
                cbl(e, null);
            }
            else term.push($3ae101cb5c0083b5$export$cae1ce83fe4a1782(infl, {
                size: su
            }, cbl));
        } else cbl('unknown compression type ' + c_1, null);
    };
    for(var i = 0; i < c; ++i)_loop_2(i);
    return tAll;
}
function $3ae101cb5c0083b5$export$c757709326bb5901(data) {
    var files = {};
    var e = data.length - 22;
    for(; $3ae101cb5c0083b5$var$b4(data, e) != 0x6054B50; --e){
        if (!e || data.length - e > 65558) throw 'invalid zip file';
    }
    var c = $3ae101cb5c0083b5$var$b2(data, e + 8);
    if (!c) return {};
    var o = $3ae101cb5c0083b5$var$b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = $3ae101cb5c0083b5$var$b4(data, e - 12);
        if ($3ae101cb5c0083b5$var$b4(data, e) != 0x6064B50) throw 'invalid zip file';
        c = $3ae101cb5c0083b5$var$b4(data, e + 32);
        o = $3ae101cb5c0083b5$var$b4(data, e + 48);
    }
    for(var i = 0; i < c; ++i){
        var _a = $3ae101cb5c0083b5$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $3ae101cb5c0083b5$var$slzh(data, off);
        o = no;
        if (!c_2) files[fn] = $3ae101cb5c0083b5$var$slc(data, b, b + sc);
        else if (c_2 == 8) files[fn] = $3ae101cb5c0083b5$export$90366d8b308ba94a(data.subarray(b, b + sc), new $3ae101cb5c0083b5$var$u8(su));
        else throw 'unknown compression type ' + c_2;
    }
    return files;
}


var $020d60e69294d716$var$n = function() {
    return "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : this;
}();
function $020d60e69294d716$var$i() {
    $020d60e69294d716$var$n.console && "function" == typeof $020d60e69294d716$var$n.console.log && $020d60e69294d716$var$n.console.log.apply($020d60e69294d716$var$n.console, arguments);
}
var $020d60e69294d716$var$a = {
    log: $020d60e69294d716$var$i,
    warn: function(t) {
        $020d60e69294d716$var$n.console && ("function" == typeof $020d60e69294d716$var$n.console.warn ? $020d60e69294d716$var$n.console.warn.apply($020d60e69294d716$var$n.console, arguments) : $020d60e69294d716$var$i.call(null, arguments));
    },
    error: function(t) {
        $020d60e69294d716$var$n.console && ("function" == typeof $020d60e69294d716$var$n.console.error ? $020d60e69294d716$var$n.console.error.apply($020d60e69294d716$var$n.console, arguments) : $020d60e69294d716$var$i(t));
    }
};
function $020d60e69294d716$var$o(t, e, r) {
    var n = new XMLHttpRequest;
    n.open("GET", t), n.responseType = "blob", n.onload = function() {
        $020d60e69294d716$var$l(n.response, e, r);
    }, n.onerror = function() {
        $020d60e69294d716$var$a.error("could not download file");
    }, n.send();
}
function $020d60e69294d716$var$s(t) {
    var e = new XMLHttpRequest;
    e.open("HEAD", t, !1);
    try {
        e.send();
    } catch (t) {}
    return e.status >= 200 && e.status <= 299;
}
function $020d60e69294d716$var$c(t) {
    try {
        t.dispatchEvent(new MouseEvent("click"));
    } catch (r) {
        var e = document.createEvent("MouseEvents");
        e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(e);
    }
}
var $020d60e69294d716$var$u, $020d60e69294d716$var$h, $020d60e69294d716$var$l = $020d60e69294d716$var$n.saveAs || ("object" !== ("undefined" == typeof window ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(window)) || window !== $020d60e69294d716$var$n ? function() {} : "undefined" != typeof HTMLAnchorElement && "download" in HTMLAnchorElement.prototype ? function(t, e, r) {
    var i = $020d60e69294d716$var$n.URL || $020d60e69294d716$var$n.webkitURL, a = document.createElement("a");
    e = e || t.name || "download", a.download = e, a.rel = "noopener", "string" == typeof t ? (a.href = t, a.origin !== location.origin ? $020d60e69294d716$var$s(a.href) ? $020d60e69294d716$var$o(t, e, r) : $020d60e69294d716$var$c(a, a.target = "_blank") : $020d60e69294d716$var$c(a)) : (a.href = i.createObjectURL(t), setTimeout(function() {
        i.revokeObjectURL(a.href);
    }, 4e4), setTimeout(function() {
        $020d60e69294d716$var$c(a);
    }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(e, r, n) {
    if (r = r || e.name || "download", "string" == typeof e) {
        if ($020d60e69294d716$var$s(e)) $020d60e69294d716$var$o(e, r, n);
        else {
            var i = document.createElement("a");
            i.href = e, i.target = "_blank", setTimeout(function() {
                $020d60e69294d716$var$c(i);
            });
        }
    } else navigator.msSaveOrOpenBlob(function(e, r) {
        return void 0 === r ? r = {
            autoBom: !1
        } : "object" !== (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(r) && ($020d60e69294d716$var$a.warn("Deprecated: Expected third argument to be a object"), r = {
            autoBom: !r
        }), r.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob([
            String.fromCharCode(65279),
            e
        ], {
            type: e.type
        }) : e;
    }(e, n), r);
} : function(e, r, i, a) {
    if ((a = a || open("", "_blank")) && (a.document.title = a.document.body.innerText = "downloading..."), "string" == typeof e) return $020d60e69294d716$var$o(e, r, i);
    var s = "application/octet-stream" === e.type, c = /constructor/i.test($020d60e69294d716$var$n.HTMLElement) || $020d60e69294d716$var$n.safari, u = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((u || s && c) && "object" === ("undefined" == typeof FileReader ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(FileReader))) {
        var h = new FileReader;
        h.onloadend = function() {
            var t = h.result;
            t = u ? t : t.replace(/^data:[^;]*;/, "data:attachment/file;"), a ? a.location.href = t : location = t, a = null;
        }, h.readAsDataURL(e);
    } else {
        var l = $020d60e69294d716$var$n.URL || $020d60e69294d716$var$n.webkitURL, f = l.createObjectURL(e);
        a ? a.location = f : location.href = f, a = null, setTimeout(function() {
            l.revokeObjectURL(f);
        }, 4e4);
    }
});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */ function $020d60e69294d716$var$f(t) {
    var e;
    t = t || "", this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6));
    t = ({
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "00ffff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000000",
        blanchedalmond: "ffebcd",
        blue: "0000ff",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "00ffff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dodgerblue: "1e90ff",
        feldspar: "d19275",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "ff00ff",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgrey: "d3d3d3",
        lightgreen: "90ee90",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslateblue: "8470ff",
        lightslategray: "778899",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "00ff00",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "ff00ff",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370d8",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "d87093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        red: "ff0000",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        violetred: "d02090",
        wheat: "f5deb3",
        white: "ffffff",
        whitesmoke: "f5f5f5",
        yellow: "ffff00",
        yellowgreen: "9acd32"
    })[t = (t = t.replace(/ /g, "")).toLowerCase()] || t;
    for(var r = [
        {
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            example: [
                "rgb(123, 234, 45)",
                "rgb(255,234,245)"
            ],
            process: function(t) {
                return [
                    parseInt(t[1]),
                    parseInt(t[2]),
                    parseInt(t[3])
                ];
            }
        },
        {
            re: /^(\w{2})(\w{2})(\w{2})$/,
            example: [
                "#00ff00",
                "336699"
            ],
            process: function(t) {
                return [
                    parseInt(t[1], 16),
                    parseInt(t[2], 16),
                    parseInt(t[3], 16)
                ];
            }
        },
        {
            re: /^(\w{1})(\w{1})(\w{1})$/,
            example: [
                "#fb0",
                "f0f"
            ],
            process: function(t) {
                return [
                    parseInt(t[1] + t[1], 16),
                    parseInt(t[2] + t[2], 16),
                    parseInt(t[3] + t[3], 16)
                ];
            }
        }
    ], n = 0; n < r.length; n++){
        var i = r[n].re, a = r[n].process, o = i.exec(t);
        o && (e = a(o), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
        return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toHex = function() {
        var t = this.r.toString(16), e = this.g.toString(16), r = this.b.toString(16);
        return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == r.length && (r = "0" + r), "#" + t + e + r;
    };
}
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */ function $020d60e69294d716$var$d(t, e) {
    var r = t[0], n = t[1], i = t[2], a = t[3];
    r = $020d60e69294d716$var$g(r, n, i, a, e[0], 7, -680876936), a = $020d60e69294d716$var$g(a, r, n, i, e[1], 12, -389564586), i = $020d60e69294d716$var$g(i, a, r, n, e[2], 17, 606105819), n = $020d60e69294d716$var$g(n, i, a, r, e[3], 22, -1044525330), r = $020d60e69294d716$var$g(r, n, i, a, e[4], 7, -176418897), a = $020d60e69294d716$var$g(a, r, n, i, e[5], 12, 1200080426), i = $020d60e69294d716$var$g(i, a, r, n, e[6], 17, -1473231341), n = $020d60e69294d716$var$g(n, i, a, r, e[7], 22, -45705983), r = $020d60e69294d716$var$g(r, n, i, a, e[8], 7, 1770035416), a = $020d60e69294d716$var$g(a, r, n, i, e[9], 12, -1958414417), i = $020d60e69294d716$var$g(i, a, r, n, e[10], 17, -42063), n = $020d60e69294d716$var$g(n, i, a, r, e[11], 22, -1990404162), r = $020d60e69294d716$var$g(r, n, i, a, e[12], 7, 1804603682), a = $020d60e69294d716$var$g(a, r, n, i, e[13], 12, -40341101), i = $020d60e69294d716$var$g(i, a, r, n, e[14], 17, -1502002290), r = $020d60e69294d716$var$m(r, n = $020d60e69294d716$var$g(n, i, a, r, e[15], 22, 1236535329), i, a, e[1], 5, -165796510), a = $020d60e69294d716$var$m(a, r, n, i, e[6], 9, -1069501632), i = $020d60e69294d716$var$m(i, a, r, n, e[11], 14, 643717713), n = $020d60e69294d716$var$m(n, i, a, r, e[0], 20, -373897302), r = $020d60e69294d716$var$m(r, n, i, a, e[5], 5, -701558691), a = $020d60e69294d716$var$m(a, r, n, i, e[10], 9, 38016083), i = $020d60e69294d716$var$m(i, a, r, n, e[15], 14, -660478335), n = $020d60e69294d716$var$m(n, i, a, r, e[4], 20, -405537848), r = $020d60e69294d716$var$m(r, n, i, a, e[9], 5, 568446438), a = $020d60e69294d716$var$m(a, r, n, i, e[14], 9, -1019803690), i = $020d60e69294d716$var$m(i, a, r, n, e[3], 14, -187363961), n = $020d60e69294d716$var$m(n, i, a, r, e[8], 20, 1163531501), r = $020d60e69294d716$var$m(r, n, i, a, e[13], 5, -1444681467), a = $020d60e69294d716$var$m(a, r, n, i, e[2], 9, -51403784), i = $020d60e69294d716$var$m(i, a, r, n, e[7], 14, 1735328473), r = $020d60e69294d716$var$v(r, n = $020d60e69294d716$var$m(n, i, a, r, e[12], 20, -1926607734), i, a, e[5], 4, -378558), a = $020d60e69294d716$var$v(a, r, n, i, e[8], 11, -2022574463), i = $020d60e69294d716$var$v(i, a, r, n, e[11], 16, 1839030562), n = $020d60e69294d716$var$v(n, i, a, r, e[14], 23, -35309556), r = $020d60e69294d716$var$v(r, n, i, a, e[1], 4, -1530992060), a = $020d60e69294d716$var$v(a, r, n, i, e[4], 11, 1272893353), i = $020d60e69294d716$var$v(i, a, r, n, e[7], 16, -155497632), n = $020d60e69294d716$var$v(n, i, a, r, e[10], 23, -1094730640), r = $020d60e69294d716$var$v(r, n, i, a, e[13], 4, 681279174), a = $020d60e69294d716$var$v(a, r, n, i, e[0], 11, -358537222), i = $020d60e69294d716$var$v(i, a, r, n, e[3], 16, -722521979), n = $020d60e69294d716$var$v(n, i, a, r, e[6], 23, 76029189), r = $020d60e69294d716$var$v(r, n, i, a, e[9], 4, -640364487), a = $020d60e69294d716$var$v(a, r, n, i, e[12], 11, -421815835), i = $020d60e69294d716$var$v(i, a, r, n, e[15], 16, 530742520), r = $020d60e69294d716$var$b(r, n = $020d60e69294d716$var$v(n, i, a, r, e[2], 23, -995338651), i, a, e[0], 6, -198630844), a = $020d60e69294d716$var$b(a, r, n, i, e[7], 10, 1126891415), i = $020d60e69294d716$var$b(i, a, r, n, e[14], 15, -1416354905), n = $020d60e69294d716$var$b(n, i, a, r, e[5], 21, -57434055), r = $020d60e69294d716$var$b(r, n, i, a, e[12], 6, 1700485571), a = $020d60e69294d716$var$b(a, r, n, i, e[3], 10, -1894986606), i = $020d60e69294d716$var$b(i, a, r, n, e[10], 15, -1051523), n = $020d60e69294d716$var$b(n, i, a, r, e[1], 21, -2054922799), r = $020d60e69294d716$var$b(r, n, i, a, e[8], 6, 1873313359), a = $020d60e69294d716$var$b(a, r, n, i, e[15], 10, -30611744), i = $020d60e69294d716$var$b(i, a, r, n, e[6], 15, -1560198380), n = $020d60e69294d716$var$b(n, i, a, r, e[13], 21, 1309151649), r = $020d60e69294d716$var$b(r, n, i, a, e[4], 6, -145523070), a = $020d60e69294d716$var$b(a, r, n, i, e[11], 10, -1120210379), i = $020d60e69294d716$var$b(i, a, r, n, e[2], 15, 718787259), n = $020d60e69294d716$var$b(n, i, a, r, e[9], 21, -343485551), t[0] = $020d60e69294d716$var$_(r, t[0]), t[1] = $020d60e69294d716$var$_(n, t[1]), t[2] = $020d60e69294d716$var$_(i, t[2]), t[3] = $020d60e69294d716$var$_(a, t[3]);
}
function $020d60e69294d716$var$p(t, e, r, n, i, a) {
    return e = $020d60e69294d716$var$_($020d60e69294d716$var$_(e, t), $020d60e69294d716$var$_(n, a)), $020d60e69294d716$var$_(e << i | e >>> 32 - i, r);
}
function $020d60e69294d716$var$g(t, e, r, n, i, a, o) {
    return $020d60e69294d716$var$p(e & r | ~e & n, t, e, i, a, o);
}
function $020d60e69294d716$var$m(t, e, r, n, i, a, o) {
    return $020d60e69294d716$var$p(e & n | r & ~n, t, e, i, a, o);
}
function $020d60e69294d716$var$v(t, e, r, n, i, a, o) {
    return $020d60e69294d716$var$p(e ^ r ^ n, t, e, i, a, o);
}
function $020d60e69294d716$var$b(t, e, r, n, i, a, o) {
    return $020d60e69294d716$var$p(r ^ (e | ~n), t, e, i, a, o);
}
function $020d60e69294d716$var$y(t) {
    var e, r = t.length, n = [
        1732584193,
        -271733879,
        -1732584194,
        271733878
    ];
    for(e = 64; e <= t.length; e += 64)$020d60e69294d716$var$d(n, $020d60e69294d716$var$w(t.substring(e - 64, e)));
    t = t.substring(e - 64);
    var i = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    for(e = 0; e < t.length; e++)i[e >> 2] |= t.charCodeAt(e) << (e % 4 << 3);
    if (i[e >> 2] |= 128 << (e % 4 << 3), e > 55) for($020d60e69294d716$var$d(n, i), e = 0; e < 16; e++)i[e] = 0;
    return i[14] = 8 * r, $020d60e69294d716$var$d(n, i), n;
}
function $020d60e69294d716$var$w(t) {
    var e, r = [];
    for(e = 0; e < 64; e += 4)r[e >> 2] = t.charCodeAt(e) + (t.charCodeAt(e + 1) << 8) + (t.charCodeAt(e + 2) << 16) + (t.charCodeAt(e + 3) << 24);
    return r;
}
$020d60e69294d716$var$u = $020d60e69294d716$var$n.atob.bind($020d60e69294d716$var$n), $020d60e69294d716$var$h = $020d60e69294d716$var$n.btoa.bind($020d60e69294d716$var$n);
var $020d60e69294d716$var$N = "0123456789abcdef".split("");
function $020d60e69294d716$var$L(t) {
    for(var e = "", r = 0; r < 4; r++)e += $020d60e69294d716$var$N[t >> 8 * r + 4 & 15] + $020d60e69294d716$var$N[t >> 8 * r & 15];
    return e;
}
function $020d60e69294d716$var$A(t) {
    return String.fromCharCode((255 & t) >> 0, (65280 & t) >> 8, (16711680 & t) >> 16, (4278190080 & t) >> 24);
}
function $020d60e69294d716$var$x(t) {
    return $020d60e69294d716$var$y(t).map($020d60e69294d716$var$A).join("");
}
var $020d60e69294d716$var$S = "5d41402abc4b2a76b9719d911017c592" != function(t) {
    for(var e = 0; e < t.length; e++)t[e] = $020d60e69294d716$var$L(t[e]);
    return t.join("");
}($020d60e69294d716$var$y("hello"));
function $020d60e69294d716$var$_(t, e) {
    if ($020d60e69294d716$var$S) {
        var r = (65535 & t) + (65535 & e);
        return (t >> 16) + (e >> 16) + (r >> 16) << 16 | 65535 & r;
    }
    return t + e & 4294967295;
}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */ function $020d60e69294d716$var$P(t, e) {
    var r, n, i, a;
    if (t !== r) {
        for(var o = (i = t, a = 1 + (256 / t.length >> 0), new Array(a + 1).join(i)), s = [], c = 0; c < 256; c++)s[c] = c;
        var u = 0;
        for(c = 0; c < 256; c++){
            var h = s[c];
            u = (u + h + o.charCodeAt(c)) % 256, s[c] = s[u], s[u] = h;
        }
        r = t, n = s;
    } else s = n;
    var l = e.length, f = 0, d = 0, p = "";
    for(c = 0; c < l; c++)d = (d + (h = s[f = (f + 1) % 256])) % 256, s[f] = s[d], s[d] = h, o = s[(s[f] + s[d]) % 256], p += String.fromCharCode(e.charCodeAt(c) ^ o);
    return p;
}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */ var $020d60e69294d716$var$k = {
    print: 4,
    modify: 8,
    copy: 16,
    "annot-forms": 32
};
function $020d60e69294d716$var$I(t, e, r, n) {
    this.v = 1, this.r = 2;
    var i = 192;
    t.forEach(function(t) {
        if (void 0 !== $020d60e69294d716$var$k.perm) throw new Error("Invalid permission: " + t);
        i += $020d60e69294d716$var$k[t];
    }), this.padding = "(\xbfN^Nu\x8aAd\0NV\xff\xfa\x01\b..\0\xb6\xd0h>\x80/\f\xa9\xfedSiz";
    var a = (e + this.padding).substr(0, 32), o = (r + this.padding).substr(0, 32);
    this.O = this.processOwnerPassword(a, o), this.P = -(1 + (255 ^ i)), this.encryptionKey = $020d60e69294d716$var$x(a + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(n)).substr(0, 5), this.U = $020d60e69294d716$var$P(this.encryptionKey, this.padding);
}
function $020d60e69294d716$var$F(t) {
    if (/[^\u0000-\u00ff]/.test(t)) throw new Error("Invalid PDF Name Object: " + t + ", Only accept ASCII characters.");
    for(var e = "", r = t.length, n = 0; n < r; n++){
        var i = t.charCodeAt(n);
        if (i < 33 || 35 === i || 37 === i || 40 === i || 41 === i || 47 === i || 60 === i || 62 === i || 91 === i || 93 === i || 123 === i || 125 === i || i > 126) e += "#" + ("0" + i.toString(16)).slice(-2);
        else e += t[n];
    }
    return e;
}
function $020d60e69294d716$var$C(e) {
    if ("object" !== (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(e)) throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
    var r = {};
    this.subscribe = function(t, e, n) {
        if (n = n || !1, "string" != typeof t || "function" != typeof e || "boolean" != typeof n) throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
        r.hasOwnProperty(t) || (r[t] = {});
        var i = Math.random().toString(35);
        return r[t][i] = [
            e,
            !!n
        ], i;
    }, this.unsubscribe = function(t) {
        for(var e in r)if (r[e][t]) return delete r[e][t], 0 === Object.keys(r[e]).length && delete r[e], !0;
        return !1;
    }, this.publish = function(t) {
        if (r.hasOwnProperty(t)) {
            var i = Array.prototype.slice.call(arguments, 1), o = [];
            for(var s in r[t]){
                var c = r[t][s];
                try {
                    c[0].apply(e, i);
                } catch (t) {
                    $020d60e69294d716$var$n.console && $020d60e69294d716$var$a.error("jsPDF PubSub Error", t.message, t);
                }
                c[1] && o.push(s);
            }
            o.length && o.forEach(this.unsubscribe);
        }
    }, this.getTopics = function() {
        return r;
    };
}
function $020d60e69294d716$export$1bc649ab427a02ba(t) {
    if (!(this instanceof $020d60e69294d716$export$1bc649ab427a02ba)) return new $020d60e69294d716$export$1bc649ab427a02ba(t);
    var e = "opacity,stroke-opacity".split(",");
    for(var r in t)t.hasOwnProperty(r) && e.indexOf(r) >= 0 && (this[r] = t[r]);
    this.id = "", this.objectNumber = -1;
}
function $020d60e69294d716$var$O(t, e) {
    this.gState = t, this.matrix = e, this.id = "", this.objectNumber = -1;
}
function $020d60e69294d716$export$7235f0ad083cb4c6(t, e, r, n, i) {
    if (!(this instanceof $020d60e69294d716$export$7235f0ad083cb4c6)) return new $020d60e69294d716$export$7235f0ad083cb4c6(t, e, r, n, i);
    this.type = "axial" === t ? 2 : 3, this.coords = e, this.colors = r, $020d60e69294d716$var$O.call(this, n, i);
}
function $020d60e69294d716$export$549f717800d2b57f(t, e, r, n, i) {
    if (!(this instanceof $020d60e69294d716$export$549f717800d2b57f)) return new $020d60e69294d716$export$549f717800d2b57f(t, e, r, n, i);
    this.boundingBox = t, this.xStep = e, this.yStep = r, this.stream = "", this.cloneIndex = 0, $020d60e69294d716$var$O.call(this, n, i);
}
function $020d60e69294d716$export$ba1e2ffc633a60f5(e) {
    var r, i = "string" == typeof arguments[0] ? arguments[0] : "p", o = arguments[1], s = arguments[2], c = arguments[3], u = [], d = 1, p = 16, g = "S", m = null;
    "object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(e = e || {}) && (i = e.orientation, o = e.unit || o, s = e.format || s, c = e.compress || e.compressPdf || c, null !== (m = e.encryption || null) && (m.userPassword = m.userPassword || "", m.ownerPassword = m.ownerPassword || "", m.userPermissions = m.userPermissions || []), d = "number" == typeof e.userUnit ? Math.abs(e.userUnit) : 1, void 0 !== e.precision && (r = e.precision), void 0 !== e.floatPrecision && (p = e.floatPrecision), g = e.defaultPathOperation || "S"), u = e.filters || (!0 === c ? [
        "FlateEncode"
    ] : u), o = o || "mm", i = ("" + (i || "P")).toLowerCase();
    var v = e.putOnlyUsedFonts || !1, b = {}, y = {
        internal: {},
        __private__: {}
    };
    y.__private__.PubSub = $020d60e69294d716$var$C;
    var w = "1.3", N = y.__private__.getPdfVersion = function() {
        return w;
    };
    y.__private__.setPdfVersion = function(t) {
        w = t;
    };
    var L = {
        a0: [
            2383.94,
            3370.39
        ],
        a1: [
            1683.78,
            2383.94
        ],
        a2: [
            1190.55,
            1683.78
        ],
        a3: [
            841.89,
            1190.55
        ],
        a4: [
            595.28,
            841.89
        ],
        a5: [
            419.53,
            595.28
        ],
        a6: [
            297.64,
            419.53
        ],
        a7: [
            209.76,
            297.64
        ],
        a8: [
            147.4,
            209.76
        ],
        a9: [
            104.88,
            147.4
        ],
        a10: [
            73.7,
            104.88
        ],
        b0: [
            2834.65,
            4008.19
        ],
        b1: [
            2004.09,
            2834.65
        ],
        b2: [
            1417.32,
            2004.09
        ],
        b3: [
            1000.63,
            1417.32
        ],
        b4: [
            708.66,
            1000.63
        ],
        b5: [
            498.9,
            708.66
        ],
        b6: [
            354.33,
            498.9
        ],
        b7: [
            249.45,
            354.33
        ],
        b8: [
            175.75,
            249.45
        ],
        b9: [
            124.72,
            175.75
        ],
        b10: [
            87.87,
            124.72
        ],
        c0: [
            2599.37,
            3676.54
        ],
        c1: [
            1836.85,
            2599.37
        ],
        c2: [
            1298.27,
            1836.85
        ],
        c3: [
            918.43,
            1298.27
        ],
        c4: [
            649.13,
            918.43
        ],
        c5: [
            459.21,
            649.13
        ],
        c6: [
            323.15,
            459.21
        ],
        c7: [
            229.61,
            323.15
        ],
        c8: [
            161.57,
            229.61
        ],
        c9: [
            113.39,
            161.57
        ],
        c10: [
            79.37,
            113.39
        ],
        dl: [
            311.81,
            623.62
        ],
        letter: [
            612,
            792
        ],
        "government-letter": [
            576,
            756
        ],
        legal: [
            612,
            1008
        ],
        "junior-legal": [
            576,
            360
        ],
        ledger: [
            1224,
            792
        ],
        tabloid: [
            792,
            1224
        ],
        "credit-card": [
            153,
            243
        ]
    };
    y.__private__.getPageFormats = function() {
        return L;
    };
    var A = y.__private__.getPageFormat = function(t) {
        return L[t];
    };
    s = s || "a4";
    var x = {
        COMPAT: "compat",
        ADVANCED: "advanced"
    }, S = x.COMPAT;
    function _() {
        this.saveGraphicsState(), lt(new Vt(_t, 0, 0, -_t, 0, Rr() * _t).toString() + " cm"), this.setFontSize(this.getFontSize() / _t), g = "n", S = x.ADVANCED;
    }
    function P() {
        this.restoreGraphicsState(), g = "S", S = x.COMPAT;
    }
    var k = y.__private__.combineFontStyleAndFontWeight = function(t, e) {
        if ("bold" == t && "normal" == e || "bold" == t && 400 == e || "normal" == t && "italic" == e || "bold" == t && "italic" == e) throw new Error("Invalid Combination of fontweight and fontstyle");
        return e && (t = 400 == e || "normal" === e ? "italic" === t ? "italic" : "normal" : 700 != e && "bold" !== e || "normal" !== t ? (700 == e ? "bold" : e) + "" + t : "bold"), t;
    };
    y.advancedAPI = function(t) {
        var e = S === x.COMPAT;
        return e && _.call(this), "function" != typeof t || (t(this), e && P.call(this)), this;
    }, y.compatAPI = function(t) {
        var e = S === x.ADVANCED;
        return e && P.call(this), "function" != typeof t || (t(this), e && _.call(this)), this;
    }, y.isAdvancedAPI = function() {
        return S === x.ADVANCED;
    };
    var O, q = function(t) {
        if (S !== x.ADVANCED) throw new Error(t + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
    }, D = y.roundToPrecision = y.__private__.roundToPrecision = function(t, e) {
        var n = r || e;
        if (isNaN(t) || isNaN(n)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
        return t.toFixed(n).replace(/0+$/, "");
    };
    O = y.hpf = y.__private__.hpf = "number" == typeof p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, p);
    } : "smart" === p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, t > -1 && t < 1 ? 16 : 5);
    } : function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, 16);
    };
    var R = y.f2 = y.__private__.f2 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
        return D(t, 2);
    }, T = y.__private__.f3 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f3");
        return D(t, 3);
    }, U = y.scale = y.__private__.scale = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.scale");
        return S === x.COMPAT ? t * _t : S === x.ADVANCED ? t : void 0;
    }, z = function(t) {
        return S === x.COMPAT ? Rr() - t : S === x.ADVANCED ? t : void 0;
    }, H = function(t) {
        return U(z(t));
    };
    y.__private__.setPrecision = y.setPrecision = function(t) {
        "number" == typeof parseInt(t, 10) && (r = parseInt(t, 10));
    };
    var W, V = "00000000000000000000000000000000", G = y.__private__.getFileId = function() {
        return V;
    }, Y = y.__private__.setFileId = function(t) {
        return V = void 0 !== t && /^[a-fA-F0-9]{32}$/.test(t) ? t.toUpperCase() : V.split("").map(function() {
            return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
        }).join(""), null !== m && (Ye = new $020d60e69294d716$var$I(m.userPermissions, m.userPassword, m.ownerPassword, V)), V;
    };
    y.setFileId = function(t) {
        return Y(t), this;
    }, y.getFileId = function() {
        return G();
    };
    var J = y.__private__.convertDateToPDFDate = function(t) {
        var e = t.getTimezoneOffset(), r = e < 0 ? "+" : "-", n = Math.floor(Math.abs(e / 60)), i = Math.abs(e % 60), a = [
            r,
            Q(n),
            "'",
            Q(i),
            "'"
        ].join("");
        return [
            "D:",
            t.getFullYear(),
            Q(t.getMonth() + 1),
            Q(t.getDate()),
            Q(t.getHours()),
            Q(t.getMinutes()),
            Q(t.getSeconds()),
            a
        ].join("");
    }, X = y.__private__.convertPDFDateToDate = function(t) {
        var e = parseInt(t.substr(2, 4), 10), r = parseInt(t.substr(6, 2), 10) - 1, n = parseInt(t.substr(8, 2), 10), i = parseInt(t.substr(10, 2), 10), a = parseInt(t.substr(12, 2), 10), o = parseInt(t.substr(14, 2), 10);
        return new Date(e, r, n, i, a, o, 0);
    }, K = y.__private__.setCreationDate = function(t) {
        var e;
        if (void 0 === t && (t = new Date), t instanceof Date) e = J(t);
        else {
            if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
            e = t;
        }
        return W = e;
    }, Z = y.__private__.getCreationDate = function(t) {
        var e = W;
        return "jsDate" === t && (e = X(W)), e;
    };
    y.setCreationDate = function(t) {
        return K(t), this;
    }, y.getCreationDate = function(t) {
        return Z(t);
    };
    var $, Q = y.__private__.padd2 = function(t) {
        return ("0" + parseInt(t)).slice(-2);
    }, tt = y.__private__.padd2Hex = function(t) {
        return ("00" + (t = t.toString())).substr(t.length);
    }, et = 0, rt = [], nt = [], it = 0, at = [], ot = [], st = !1, ct = nt, ut = function() {
        et = 0, it = 0, nt = [], rt = [], at = [], Qt = Kt(), te = Kt();
    };
    y.__private__.setCustomOutputDestination = function(t) {
        st = !0, ct = t;
    };
    var ht = function(t) {
        st || (ct = t);
    };
    y.__private__.resetCustomOutputDestination = function() {
        st = !1, ct = nt;
    };
    var lt = y.__private__.out = function(t) {
        return t = t.toString(), it += t.length + 1, ct.push(t), ct;
    }, ft = y.__private__.write = function(t) {
        return lt(1 === arguments.length ? t.toString() : Array.prototype.join.call(arguments, " "));
    }, dt = y.__private__.getArrayBuffer = function(t) {
        for(var e = t.length, r = new ArrayBuffer(e), n = new Uint8Array(r); e--;)n[e] = t.charCodeAt(e);
        return r;
    }, pt = [
        [
            "Helvetica",
            "helvetica",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Bold",
            "helvetica",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Oblique",
            "helvetica",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-BoldOblique",
            "helvetica",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Courier",
            "courier",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Bold",
            "courier",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Oblique",
            "courier",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Courier-BoldOblique",
            "courier",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Times-Roman",
            "times",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Times-Bold",
            "times",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Times-Italic",
            "times",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Times-BoldItalic",
            "times",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "ZapfDingbats",
            "zapfdingbats",
            "normal",
            null
        ],
        [
            "Symbol",
            "symbol",
            "normal",
            null
        ]
    ];
    y.__private__.getStandardFonts = function() {
        return pt;
    };
    var gt = e.fontSize || 16;
    y.__private__.setFontSize = y.setFontSize = function(t) {
        return gt = S === x.ADVANCED ? t / _t : t, this;
    };
    var mt, vt = y.__private__.getFontSize = y.getFontSize = function() {
        return S === x.COMPAT ? gt : gt * _t;
    }, bt = e.R2L || !1;
    y.__private__.setR2L = y.setR2L = function(t) {
        return bt = t, this;
    }, y.__private__.getR2L = y.getR2L = function() {
        return bt;
    };
    var yt, wt = y.__private__.setZoomMode = function(t) {
        var e = [
            void 0,
            null,
            "fullwidth",
            "fullheight",
            "fullpage",
            "original"
        ];
        if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t)) mt = t;
        else if (isNaN(t)) {
            if (-1 === e.indexOf(t)) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + t + '" is not recognized.');
            mt = t;
        } else mt = parseInt(t, 10);
    };
    y.__private__.getZoomMode = function() {
        return mt;
    };
    var Nt, Lt = y.__private__.setPageMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "UseNone",
            "UseOutlines",
            "UseThumbs",
            "FullScreen"
        ].indexOf(t)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + t + '" is not recognized.');
        yt = t;
    };
    y.__private__.getPageMode = function() {
        return yt;
    };
    var At = y.__private__.setLayoutMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "continuous",
            "single",
            "twoleft",
            "tworight",
            "two"
        ].indexOf(t)) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + t + '" is not recognized.');
        Nt = t;
    };
    y.__private__.getLayoutMode = function() {
        return Nt;
    }, y.__private__.setDisplayMode = y.setDisplayMode = function(t, e, r) {
        return wt(t), At(e), Lt(r), this;
    };
    var xt = {
        title: "",
        subject: "",
        author: "",
        keywords: "",
        creator: ""
    };
    y.__private__.getDocumentProperty = function(t) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
        return xt[t];
    }, y.__private__.getDocumentProperties = function() {
        return xt;
    }, y.__private__.setDocumentProperties = y.setProperties = y.setDocumentProperties = function(t) {
        for(var e in xt)xt.hasOwnProperty(e) && t[e] && (xt[e] = t[e]);
        return this;
    }, y.__private__.setDocumentProperty = function(t, e) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
        return xt[t] = e;
    };
    var St, _t, Pt, kt, It, Ft = {}, Ct = {}, jt = [], Ot = {}, Bt = {}, Mt = {}, Et = {}, qt = null, Dt = 0, Rt = [], Tt = new $020d60e69294d716$var$C(y), Ut = e.hotfixes || [], zt = {}, Ht = {}, Wt = [], Vt = function t(e, r, n, i, a, o) {
        if (!(this instanceof t)) return new t(e, r, n, i, a, o);
        isNaN(e) && (e = 1), isNaN(r) && (r = 0), isNaN(n) && (n = 0), isNaN(i) && (i = 1), isNaN(a) && (a = 0), isNaN(o) && (o = 0), this._matrix = [
            e,
            r,
            n,
            i,
            a,
            o
        ];
    };
    Object.defineProperty(Vt.prototype, "sx", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Vt.prototype, "shy", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Vt.prototype, "shx", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Vt.prototype, "sy", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Vt.prototype, "tx", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Vt.prototype, "ty", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Vt.prototype, "a", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Vt.prototype, "b", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Vt.prototype, "c", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Vt.prototype, "d", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Vt.prototype, "e", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Vt.prototype, "f", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Vt.prototype, "rotation", {
        get: function() {
            return Math.atan2(this.shx, this.sx);
        }
    }), Object.defineProperty(Vt.prototype, "scaleX", {
        get: function() {
            return this.decompose().scale.sx;
        }
    }), Object.defineProperty(Vt.prototype, "scaleY", {
        get: function() {
            return this.decompose().scale.sy;
        }
    }), Object.defineProperty(Vt.prototype, "isIdentity", {
        get: function() {
            return 1 === this.sx && 0 === this.shy && 0 === this.shx && 1 === this.sy && 0 === this.tx && 0 === this.ty;
        }
    }), Vt.prototype.join = function(t) {
        return [
            this.sx,
            this.shy,
            this.shx,
            this.sy,
            this.tx,
            this.ty
        ].map(O).join(t);
    }, Vt.prototype.multiply = function(t) {
        var e = t.sx * this.sx + t.shy * this.shx, r = t.sx * this.shy + t.shy * this.sy, n = t.shx * this.sx + t.sy * this.shx, i = t.shx * this.shy + t.sy * this.sy, a = t.tx * this.sx + t.ty * this.shx + this.tx, o = t.tx * this.shy + t.ty * this.sy + this.ty;
        return new Vt(e, r, n, i, a, o);
    }, Vt.prototype.decompose = function() {
        var t = this.sx, e = this.shy, r = this.shx, n = this.sy, i = this.tx, a = this.ty, o = Math.sqrt(t * t + e * e), s = (t /= o) * r + (e /= o) * n;
        r -= t * s, n -= e * s;
        var c = Math.sqrt(r * r + n * n);
        return s /= c, t * (n /= c) < e * (r /= c) && (t = -t, e = -e, s = -s, o = -o), {
            scale: new Vt(o, 0, 0, c, 0, 0),
            translate: new Vt(1, 0, 0, 1, i, a),
            rotate: new Vt(t, e, -e, t, 0, 0),
            skew: new Vt(1, 0, s, 1, 0, 0)
        };
    }, Vt.prototype.toString = function(t) {
        return this.join(" ");
    }, Vt.prototype.inversed = function() {
        var t = this.sx, e = this.shy, r = this.shx, n = this.sy, i = this.tx, a = this.ty, o = 1 / (t * n - e * r), s = n * o, c = -e * o, u = -r * o, h = t * o;
        return new Vt(s, c, u, h, -s * i - u * a, -c * i - h * a);
    }, Vt.prototype.applyToPoint = function(t) {
        var e = t.x * this.sx + t.y * this.shx + this.tx, r = t.x * this.shy + t.y * this.sy + this.ty;
        return new Cr(e, r);
    }, Vt.prototype.applyToRectangle = function(t) {
        var e = this.applyToPoint(t), r = this.applyToPoint(new Cr(t.x + t.w, t.y + t.h));
        return new jr(e.x, e.y, r.x - e.x, r.y - e.y);
    }, Vt.prototype.clone = function() {
        var t = this.sx, e = this.shy, r = this.shx, n = this.sy, i = this.tx, a = this.ty;
        return new Vt(t, e, r, n, i, a);
    }, y.Matrix = Vt;
    var Gt = y.matrixMult = function(t, e) {
        return e.multiply(t);
    }, Yt = new Vt(1, 0, 0, 1, 0, 0);
    y.unitMatrix = y.identityMatrix = Yt;
    var Jt = function(t, e) {
        if (!Bt[t]) {
            var r = (e instanceof $020d60e69294d716$export$7235f0ad083cb4c6 ? "Sh" : "P") + (Object.keys(Ot).length + 1).toString(10);
            e.id = r, Bt[t] = r, Ot[r] = e, Tt.publish("addPattern", e);
        }
    };
    y.ShadingPattern = $020d60e69294d716$export$7235f0ad083cb4c6, y.TilingPattern = $020d60e69294d716$export$549f717800d2b57f, y.addShadingPattern = function(t, e) {
        return q("addShadingPattern()"), Jt(t, e), this;
    }, y.beginTilingPattern = function(t) {
        q("beginTilingPattern()"), Br(t.boundingBox[0], t.boundingBox[1], t.boundingBox[2] - t.boundingBox[0], t.boundingBox[3] - t.boundingBox[1], t.matrix);
    }, y.endTilingPattern = function(t, e) {
        q("endTilingPattern()"), e.stream = ot[$].join("\n"), Jt(t, e), Tt.publish("endTilingPattern", e), Wt.pop().restore();
    };
    var Xt = y.__private__.newObject = function() {
        var t = Kt();
        return Zt(t, !0), t;
    }, Kt = y.__private__.newObjectDeferred = function() {
        return et++, rt[et] = function() {
            return it;
        }, et;
    }, Zt = function(t, e) {
        return e = "boolean" == typeof e && e, rt[t] = it, e && lt(t + " 0 obj"), t;
    }, $t = y.__private__.newAdditionalObject = function() {
        var t = {
            objId: Kt(),
            content: ""
        };
        return at.push(t), t;
    }, Qt = Kt(), te = Kt(), ee = y.__private__.decodeColorString = function(t) {
        var e = t.split(" ");
        if (2 !== e.length || "g" !== e[1] && "G" !== e[1]) {
            if (5 === e.length && ("k" === e[4] || "K" === e[4])) e = [
                (1 - e[0]) * (1 - e[3]),
                (1 - e[1]) * (1 - e[3]),
                (1 - e[2]) * (1 - e[3]),
                "r"
            ];
        } else {
            var r = parseFloat(e[0]);
            e = [
                r,
                r,
                r,
                "r"
            ];
        }
        for(var n = "#", i = 0; i < 3; i++)n += ("0" + Math.floor(255 * parseFloat(e[i])).toString(16)).slice(-2);
        return n;
    }, re = y.__private__.encodeColorString = function(e) {
        var r;
        "string" == typeof e && (e = {
            ch1: e
        });
        var n = e.ch1, i = e.ch2, a = e.ch3, o = e.ch4, s = "draw" === e.pdfColorType ? [
            "G",
            "RG",
            "K"
        ] : [
            "g",
            "rg",
            "k"
        ];
        if ("string" == typeof n && "#" !== n.charAt(0)) {
            var c = new $020d60e69294d716$var$f(n);
            if (c.ok) n = c.toHex();
            else if (!/^\d*\.?\d*$/.test(n)) throw new Error('Invalid color "' + n + '" passed to jsPDF.encodeColorString.');
        }
        if ("string" == typeof n && /^#[0-9A-Fa-f]{3}$/.test(n) && (n = "#" + n[1] + n[1] + n[2] + n[2] + n[3] + n[3]), "string" == typeof n && /^#[0-9A-Fa-f]{6}$/.test(n)) {
            var u = parseInt(n.substr(1), 16);
            n = u >> 16 & 255, i = u >> 8 & 255, a = 255 & u;
        }
        if (void 0 === i || void 0 === o && n === i && i === a) {
            if ("string" == typeof n) r = n + " " + s[0];
            else switch(e.precision){
                case 2:
                    r = R(n / 255) + " " + s[0];
                    break;
                case 3:
                default:
                    r = T(n / 255) + " " + s[0];
            }
        } else if (void 0 === o || "object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(o)) {
            if (o && !isNaN(o.a) && 0 === o.a) return r = [
                "1.",
                "1.",
                "1.",
                s[1]
            ].join(" ");
            if ("string" == typeof n) r = [
                n,
                i,
                a,
                s[1]
            ].join(" ");
            else switch(e.precision){
                case 2:
                    r = [
                        R(n / 255),
                        R(i / 255),
                        R(a / 255),
                        s[1]
                    ].join(" ");
                    break;
                default:
                case 3:
                    r = [
                        T(n / 255),
                        T(i / 255),
                        T(a / 255),
                        s[1]
                    ].join(" ");
            }
        } else if ("string" == typeof n) r = [
            n,
            i,
            a,
            o,
            s[2]
        ].join(" ");
        else switch(e.precision){
            case 2:
                r = [
                    R(n),
                    R(i),
                    R(a),
                    R(o),
                    s[2]
                ].join(" ");
                break;
            case 3:
            default:
                r = [
                    T(n),
                    T(i),
                    T(a),
                    T(o),
                    s[2]
                ].join(" ");
        }
        return r;
    }, ne = y.__private__.getFilters = function() {
        return u;
    }, ie = y.__private__.putStream = function(t) {
        var e = (t = t || {}).data || "", r = t.filters || ne(), n = t.alreadyAppliedFilters || [], i = t.addLength1 || !1, a = e.length, o = t.objectId, s = function(t) {
            return t;
        };
        if (null !== m && void 0 === o) throw new Error("ObjectId must be passed to putStream for file encryption");
        null !== m && (s = Ye.encryptor(o, 0));
        var c = {};
        !0 === r && (r = [
            "FlateEncode"
        ]);
        var u = t.additionalKeyValues || [], h = (c = void 0 !== $020d60e69294d716$export$ba1e2ffc633a60f5.API.processDataByFilters ? $020d60e69294d716$export$ba1e2ffc633a60f5.API.processDataByFilters(e, r) : {
            data: e,
            reverseChain: []
        }).reverseChain + (Array.isArray(n) ? n.join(" ") : n.toString());
        if (0 !== c.data.length && (u.push({
            key: "Length",
            value: c.data.length
        }), !0 === i && u.push({
            key: "Length1",
            value: a
        })), 0 != h.length) {
            if (h.split("/").length - 1 == 1) u.push({
                key: "Filter",
                value: h
            });
            else {
                u.push({
                    key: "Filter",
                    value: "[" + h + "]"
                });
                for(var l = 0; l < u.length; l += 1)if ("DecodeParms" === u[l].key) {
                    for(var f = [], d = 0; d < c.reverseChain.split("/").length - 1; d += 1)f.push("null");
                    f.push(u[l].value), u[l].value = "[" + f.join(" ") + "]";
                }
            }
        }
        lt("<<");
        for(var p = 0; p < u.length; p++)lt("/" + u[p].key + " " + u[p].value);
        lt(">>"), 0 !== c.data.length && (lt("stream"), lt(s(c.data)), lt("endstream"));
    }, ae = y.__private__.putPage = function(t) {
        var e = t.number, r = t.data, n = t.objId, i = t.contentsObjId;
        Zt(n, !0), lt("<</Type /Page"), lt("/Parent " + t.rootDictionaryObjId + " 0 R"), lt("/Resources " + t.resourceDictionaryObjId + " 0 R"), lt("/MediaBox [" + parseFloat(O(t.mediaBox.bottomLeftX)) + " " + parseFloat(O(t.mediaBox.bottomLeftY)) + " " + O(t.mediaBox.topRightX) + " " + O(t.mediaBox.topRightY) + "]"), null !== t.cropBox && lt("/CropBox [" + O(t.cropBox.bottomLeftX) + " " + O(t.cropBox.bottomLeftY) + " " + O(t.cropBox.topRightX) + " " + O(t.cropBox.topRightY) + "]"), null !== t.bleedBox && lt("/BleedBox [" + O(t.bleedBox.bottomLeftX) + " " + O(t.bleedBox.bottomLeftY) + " " + O(t.bleedBox.topRightX) + " " + O(t.bleedBox.topRightY) + "]"), null !== t.trimBox && lt("/TrimBox [" + O(t.trimBox.bottomLeftX) + " " + O(t.trimBox.bottomLeftY) + " " + O(t.trimBox.topRightX) + " " + O(t.trimBox.topRightY) + "]"), null !== t.artBox && lt("/ArtBox [" + O(t.artBox.bottomLeftX) + " " + O(t.artBox.bottomLeftY) + " " + O(t.artBox.topRightX) + " " + O(t.artBox.topRightY) + "]"), "number" == typeof t.userUnit && 1 !== t.userUnit && lt("/UserUnit " + t.userUnit), Tt.publish("putPage", {
            objId: n,
            pageContext: Rt[e],
            pageNumber: e,
            page: r
        }), lt("/Contents " + i + " 0 R"), lt(">>"), lt("endobj");
        var a = r.join("\n");
        return S === x.ADVANCED && (a += "\nQ"), Zt(i, !0), ie({
            data: a,
            filters: ne(),
            objectId: i
        }), lt("endobj"), n;
    }, oe = y.__private__.putPages = function() {
        var t, e, r = [];
        for(t = 1; t <= Dt; t++)Rt[t].objId = Kt(), Rt[t].contentsObjId = Kt();
        for(t = 1; t <= Dt; t++)r.push(ae({
            number: t,
            data: ot[t],
            objId: Rt[t].objId,
            contentsObjId: Rt[t].contentsObjId,
            mediaBox: Rt[t].mediaBox,
            cropBox: Rt[t].cropBox,
            bleedBox: Rt[t].bleedBox,
            trimBox: Rt[t].trimBox,
            artBox: Rt[t].artBox,
            userUnit: Rt[t].userUnit,
            rootDictionaryObjId: Qt,
            resourceDictionaryObjId: te
        }));
        Zt(Qt, !0), lt("<</Type /Pages");
        var n = "/Kids [";
        for(e = 0; e < Dt; e++)n += r[e] + " 0 R ";
        lt(n + "]"), lt("/Count " + Dt), lt(">>"), lt("endobj"), Tt.publish("postPutPages");
    }, se = function(t) {
        Tt.publish("putFont", {
            font: t,
            out: lt,
            newObject: Xt,
            putStream: ie
        }), !0 !== t.isAlreadyPutted && (t.objectNumber = Xt(), lt("<<"), lt("/Type /Font"), lt("/BaseFont /" + $020d60e69294d716$var$F(t.postScriptName)), lt("/Subtype /Type1"), "string" == typeof t.encoding && lt("/Encoding /" + t.encoding), lt("/FirstChar 32"), lt("/LastChar 255"), lt(">>"), lt("endobj"));
    }, ce = function() {
        for(var t in Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && se(Ft[t]);
    }, ue = function(t) {
        t.objectNumber = Xt();
        var e = [];
        e.push({
            key: "Type",
            value: "/XObject"
        }), e.push({
            key: "Subtype",
            value: "/Form"
        }), e.push({
            key: "BBox",
            value: "[" + [
                O(t.x),
                O(t.y),
                O(t.x + t.width),
                O(t.y + t.height)
            ].join(" ") + "]"
        }), e.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        });
        var r = t.pages[1].join("\n");
        ie({
            data: r,
            additionalKeyValues: e,
            objectId: t.objectNumber
        }), lt("endobj");
    }, he = function() {
        for(var t in zt)zt.hasOwnProperty(t) && ue(zt[t]);
    }, le = function(t, e) {
        var r, n = [], i = 1 / (e - 1);
        for(r = 0; r < 1; r += i)n.push(r);
        if (n.push(1), 0 != t[0].offset) {
            var a = {
                offset: 0,
                color: t[0].color
            };
            t.unshift(a);
        }
        if (1 != t[t.length - 1].offset) {
            var o = {
                offset: 1,
                color: t[t.length - 1].color
            };
            t.push(o);
        }
        for(var s = "", c = 0, u = 0; u < n.length; u++){
            for(r = n[u]; r > t[c + 1].offset;)c++;
            var h = t[c].offset, l = (r - h) / (t[c + 1].offset - h), f = t[c].color, d = t[c + 1].color;
            s += tt(Math.round((1 - l) * f[0] + l * d[0]).toString(16)) + tt(Math.round((1 - l) * f[1] + l * d[1]).toString(16)) + tt(Math.round((1 - l) * f[2] + l * d[2]).toString(16));
        }
        return s.trim();
    }, fe = function(t, e) {
        e || (e = 21);
        var r = Xt(), n = le(t.colors, e), i = [];
        i.push({
            key: "FunctionType",
            value: "0"
        }), i.push({
            key: "Domain",
            value: "[0.0 1.0]"
        }), i.push({
            key: "Size",
            value: "[" + e + "]"
        }), i.push({
            key: "BitsPerSample",
            value: "8"
        }), i.push({
            key: "Range",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), i.push({
            key: "Decode",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), ie({
            data: n,
            additionalKeyValues: i,
            alreadyAppliedFilters: [
                "/ASCIIHexDecode"
            ],
            objectId: r
        }), lt("endobj"), t.objectNumber = Xt(), lt("<< /ShadingType " + t.type), lt("/ColorSpace /DeviceRGB");
        var a = "/Coords [" + O(parseFloat(t.coords[0])) + " " + O(parseFloat(t.coords[1])) + " ";
        2 === t.type ? a += O(parseFloat(t.coords[2])) + " " + O(parseFloat(t.coords[3])) : a += O(parseFloat(t.coords[2])) + " " + O(parseFloat(t.coords[3])) + " " + O(parseFloat(t.coords[4])) + " " + O(parseFloat(t.coords[5])), lt(a += "]"), t.matrix && lt("/Matrix [" + t.matrix.toString() + "]"), lt("/Function " + r + " 0 R"), lt("/Extend [true true]"), lt(">>"), lt("endobj");
    }, de = function(t, e) {
        var r = Kt(), n = Xt();
        e.push({
            resourcesOid: r,
            objectOid: n
        }), t.objectNumber = n;
        var i = [];
        i.push({
            key: "Type",
            value: "/Pattern"
        }), i.push({
            key: "PatternType",
            value: "1"
        }), i.push({
            key: "PaintType",
            value: "1"
        }), i.push({
            key: "TilingType",
            value: "1"
        }), i.push({
            key: "BBox",
            value: "[" + t.boundingBox.map(O).join(" ") + "]"
        }), i.push({
            key: "XStep",
            value: O(t.xStep)
        }), i.push({
            key: "YStep",
            value: O(t.yStep)
        }), i.push({
            key: "Resources",
            value: r + " 0 R"
        }), t.matrix && i.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        }), ie({
            data: t.stream,
            additionalKeyValues: i,
            objectId: t.objectNumber
        }), lt("endobj");
    }, pe = function(t) {
        var e;
        for(e in Ot)Ot.hasOwnProperty(e) && (Ot[e] instanceof $020d60e69294d716$export$7235f0ad083cb4c6 ? fe(Ot[e]) : Ot[e] instanceof $020d60e69294d716$export$549f717800d2b57f && de(Ot[e], t));
    }, ge = function(t) {
        for(var e in t.objectNumber = Xt(), lt("<<"), t)switch(e){
            case "opacity":
                lt("/ca " + R(t[e]));
                break;
            case "stroke-opacity":
                lt("/CA " + R(t[e]));
        }
        lt(">>"), lt("endobj");
    }, me = function() {
        var t;
        for(t in Mt)Mt.hasOwnProperty(t) && ge(Mt[t]);
    }, ve = function() {
        for(var t in lt("/XObject <<"), zt)zt.hasOwnProperty(t) && zt[t].objectNumber >= 0 && lt("/" + t + " " + zt[t].objectNumber + " 0 R");
        Tt.publish("putXobjectDict"), lt(">>");
    }, be = function() {
        Ye.oid = Xt(), lt("<<"), lt("/Filter /Standard"), lt("/V " + Ye.v), lt("/R " + Ye.r), lt("/U <" + Ye.toHexString(Ye.U) + ">"), lt("/O <" + Ye.toHexString(Ye.O) + ">"), lt("/P " + Ye.P), lt(">>"), lt("endobj");
    }, ye = function() {
        for(var t in lt("/Font <<"), Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && lt("/" + t + " " + Ft[t].objectNumber + " 0 R");
        lt(">>");
    }, we = function() {
        if (Object.keys(Ot).length > 0) {
            for(var t in lt("/Shading <<"), Ot)Ot.hasOwnProperty(t) && Ot[t] instanceof $020d60e69294d716$export$7235f0ad083cb4c6 && Ot[t].objectNumber >= 0 && lt("/" + t + " " + Ot[t].objectNumber + " 0 R");
            Tt.publish("putShadingPatternDict"), lt(">>");
        }
    }, Ne = function(t) {
        if (Object.keys(Ot).length > 0) {
            for(var e in lt("/Pattern <<"), Ot)Ot.hasOwnProperty(e) && Ot[e] instanceof y.TilingPattern && Ot[e].objectNumber >= 0 && Ot[e].objectNumber < t && lt("/" + e + " " + Ot[e].objectNumber + " 0 R");
            Tt.publish("putTilingPatternDict"), lt(">>");
        }
    }, Le = function() {
        if (Object.keys(Mt).length > 0) {
            var t;
            for(t in lt("/ExtGState <<"), Mt)Mt.hasOwnProperty(t) && Mt[t].objectNumber >= 0 && lt("/" + t + " " + Mt[t].objectNumber + " 0 R");
            Tt.publish("putGStateDict"), lt(">>");
        }
    }, Ae = function(t) {
        Zt(t.resourcesOid, !0), lt("<<"), lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), ye(), we(), Ne(t.objectOid), Le(), ve(), lt(">>"), lt("endobj");
    }, xe = function() {
        var t = [];
        ce(), me(), he(), pe(t), Tt.publish("putResources"), t.forEach(Ae), Ae({
            resourcesOid: te,
            objectOid: Number.MAX_SAFE_INTEGER
        }), Tt.publish("postPutResources");
    }, Se = function() {
        Tt.publish("putAdditionalObjects");
        for(var t = 0; t < at.length; t++){
            var e = at[t];
            Zt(e.objId, !0), lt(e.content), lt("endobj");
        }
        Tt.publish("postPutAdditionalObjects");
    }, _e = function(t) {
        Ct[t.fontName] = Ct[t.fontName] || {}, Ct[t.fontName][t.fontStyle] = t.id;
    }, Pe = function(t, e, r, n, i) {
        var a = {
            id: "F" + (Object.keys(Ft).length + 1).toString(10),
            postScriptName: t,
            fontName: e,
            fontStyle: r,
            encoding: n,
            isStandardFont: i || !1,
            metadata: {}
        };
        return Tt.publish("addFont", {
            font: a,
            instance: this
        }), Ft[a.id] = a, _e(a), a.id;
    }, ke = function(t) {
        for(var e = 0, r = pt.length; e < r; e++){
            var n = Pe.call(this, t[e][0], t[e][1], t[e][2], pt[e][3], !0);
            !1 === v && (b[n] = !0);
            var i = t[e][0].split("-");
            _e({
                id: n,
                fontName: i[0],
                fontStyle: i[1] || ""
            });
        }
        Tt.publish("addFonts", {
            fonts: Ft,
            dictionary: Ct
        });
    }, Ie = function(t) {
        return t.foo = function() {
            try {
                return t.apply(this, arguments);
            } catch (t) {
                var e = t.stack || "";
                ~e.indexOf(" at ") && (e = e.split(" at ")[1]);
                var r = "Error in function " + e.split("\n")[0].split("<")[0] + ": " + t.message;
                if (!$020d60e69294d716$var$n.console) throw new Error(r);
                $020d60e69294d716$var$n.console.error(r, t), $020d60e69294d716$var$n.alert && alert(r);
            }
        }, t.foo.bar = t, t.foo;
    }, Fe = function(t, e) {
        var r, n, i, a, o, s, c, u, h;
        if (i = (e = e || {}).sourceEncoding || "Unicode", o = e.outputEncoding, (e.autoencode || o) && Ft[St].metadata && Ft[St].metadata[i] && Ft[St].metadata[i].encoding && (a = Ft[St].metadata[i].encoding, !o && Ft[St].encoding && (o = Ft[St].encoding), !o && a.codePages && (o = a.codePages[0]), "string" == typeof o && (o = a[o]), o)) {
            for(c = !1, s = [], r = 0, n = t.length; r < n; r++)(u = o[t.charCodeAt(r)]) ? s.push(String.fromCharCode(u)) : s.push(t[r]), s[r].charCodeAt(0) >> 8 && (c = !0);
            t = s.join("");
        }
        for(r = t.length; void 0 === c && 0 !== r;)t.charCodeAt(r - 1) >> 8 && (c = !0), r--;
        if (!c) return t;
        for(s = e.noBOM ? [] : [
            254,
            255
        ], r = 0, n = t.length; r < n; r++){
            if ((h = (u = t.charCodeAt(r)) >> 8) >> 8) throw new Error("Character at position " + r + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
            s.push(h), s.push(u - (h << 8));
        }
        return String.fromCharCode.apply(void 0, s);
    }, Ce = y.__private__.pdfEscape = y.pdfEscape = function(t, e) {
        return Fe(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
    }, je = y.__private__.beginPage = function(t) {
        ot[++Dt] = [], Rt[Dt] = {
            objId: 0,
            contentsObjId: 0,
            userUnit: Number(d),
            artBox: null,
            bleedBox: null,
            cropBox: null,
            trimBox: null,
            mediaBox: {
                bottomLeftX: 0,
                bottomLeftY: 0,
                topRightX: Number(t[0]),
                topRightY: Number(t[1])
            }
        }, Me(Dt), ht(ot[$]);
    }, Oe = function(t, e) {
        var r, n, o;
        switch(i = e || i, "string" == typeof t && (r = A(t.toLowerCase()), Array.isArray(r) && (n = r[0], o = r[1])), Array.isArray(t) && (n = t[0] * _t, o = t[1] * _t), isNaN(n) && (n = s[0], o = s[1]), (n > 14400 || o > 14400) && ($020d60e69294d716$var$a.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), n = Math.min(14400, n), o = Math.min(14400, o)), s = [
            n,
            o
        ], i.substr(0, 1)){
            case "l":
                o > n && (s = [
                    o,
                    n
                ]);
                break;
            case "p":
                n > o && (s = [
                    o,
                    n
                ]);
        }
        je(s), pr(fr), lt(Lr), 0 !== kr && lt(kr + " J"), 0 !== Ir && lt(Ir + " j"), Tt.publish("addPage", {
            pageNumber: Dt
        });
    }, Be = function(t) {
        t > 0 && t <= Dt && (ot.splice(t, 1), Rt.splice(t, 1), Dt--, $ > Dt && ($ = Dt), this.setPage($));
    }, Me = function(t) {
        t > 0 && t <= Dt && ($ = t);
    }, Ee = y.__private__.getNumberOfPages = y.getNumberOfPages = function() {
        return ot.length - 1;
    }, qe = function(t, e, r) {
        var n, i = void 0;
        return r = r || {}, t = void 0 !== t ? t : Ft[St].fontName, e = void 0 !== e ? e : Ft[St].fontStyle, n = t.toLowerCase(), void 0 !== Ct[n] && void 0 !== Ct[n][e] ? i = Ct[n][e] : void 0 !== Ct[t] && void 0 !== Ct[t][e] ? i = Ct[t][e] : !1 === r.disableWarning && $020d60e69294d716$var$a.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), i || r.noFallback || null == (i = Ct.times[e]) && (i = Ct.times.normal), i;
    }, De = y.__private__.putInfo = function() {
        var t = Xt(), e = function(t) {
            return t;
        };
        for(var r in null !== m && (e = Ye.encryptor(t, 0)), lt("<<"), lt("/Producer (" + Ce(e("jsPDF " + $020d60e69294d716$export$ba1e2ffc633a60f5.version)) + ")"), xt)xt.hasOwnProperty(r) && xt[r] && lt("/" + r.substr(0, 1).toUpperCase() + r.substr(1) + " (" + Ce(e(xt[r])) + ")");
        lt("/CreationDate (" + Ce(e(W)) + ")"), lt(">>"), lt("endobj");
    }, Re = y.__private__.putCatalog = function(t) {
        var e = (t = t || {}).rootDictionaryObjId || Qt;
        switch(Xt(), lt("<<"), lt("/Type /Catalog"), lt("/Pages " + e + " 0 R"), mt || (mt = "fullwidth"), mt){
            case "fullwidth":
                lt("/OpenAction [3 0 R /FitH null]");
                break;
            case "fullheight":
                lt("/OpenAction [3 0 R /FitV null]");
                break;
            case "fullpage":
                lt("/OpenAction [3 0 R /Fit]");
                break;
            case "original":
                lt("/OpenAction [3 0 R /XYZ null null 1]");
                break;
            default:
                var r = "" + mt;
                "%" === r.substr(r.length - 1) && (mt = parseInt(mt) / 100), "number" == typeof mt && lt("/OpenAction [3 0 R /XYZ null null " + R(mt) + "]");
        }
        switch(Nt || (Nt = "continuous"), Nt){
            case "continuous":
                lt("/PageLayout /OneColumn");
                break;
            case "single":
                lt("/PageLayout /SinglePage");
                break;
            case "two":
            case "twoleft":
                lt("/PageLayout /TwoColumnLeft");
                break;
            case "tworight":
                lt("/PageLayout /TwoColumnRight");
        }
        yt && lt("/PageMode /" + yt), Tt.publish("putCatalog"), lt(">>"), lt("endobj");
    }, Te = y.__private__.putTrailer = function() {
        lt("trailer"), lt("<<"), lt("/Size " + (et + 1)), lt("/Root " + et + " 0 R"), lt("/Info " + (et - 1) + " 0 R"), null !== m && lt("/Encrypt " + Ye.oid + " 0 R"), lt("/ID [ <" + V + "> <" + V + "> ]"), lt(">>");
    }, Ue = y.__private__.putHeader = function() {
        lt("%PDF-" + w), lt("%\xba\xdf\xac\xe0");
    }, ze = y.__private__.putXRef = function() {
        var t = "0000000000";
        lt("xref"), lt("0 " + (et + 1)), lt("0000000000 65535 f ");
        for(var e = 1; e <= et; e++)"function" == typeof rt[e] ? lt((t + rt[e]()).slice(-10) + " 00000 n ") : void 0 !== rt[e] ? lt((t + rt[e]).slice(-10) + " 00000 n ") : lt("0000000000 00000 n ");
    }, He = y.__private__.buildDocument = function() {
        ut(), ht(nt), Tt.publish("buildDocument"), Ue(), oe(), Se(), xe(), null !== m && be(), De(), Re();
        var t = it;
        return ze(), Te(), lt("startxref"), lt("" + t), lt("%%EOF"), ht(ot[$]), nt.join("\n");
    }, We = y.__private__.getBlob = function(t) {
        return new Blob([
            dt(t)
        ], {
            type: "application/pdf"
        });
    }, Ve = y.output = y.__private__.output = Ie(function(t, e) {
        switch("string" == typeof (e = e || {}) ? e = {
            filename: e
        } : e.filename = e.filename || "generated.pdf", t){
            case void 0:
                return He();
            case "save":
                y.save(e.filename);
                break;
            case "arraybuffer":
                return dt(He());
            case "blob":
                return We(He());
            case "bloburi":
            case "bloburl":
                if (void 0 !== $020d60e69294d716$var$n.URL && "function" == typeof $020d60e69294d716$var$n.URL.createObjectURL) return $020d60e69294d716$var$n.URL && $020d60e69294d716$var$n.URL.createObjectURL(We(He())) || void 0;
                $020d60e69294d716$var$a.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
                break;
            case "datauristring":
            case "dataurlstring":
                var r = "", i = He();
                try {
                    r = $020d60e69294d716$var$h(i);
                } catch (t) {
                    r = $020d60e69294d716$var$h(unescape(encodeURIComponent(i)));
                }
                return "data:application/pdf;filename=" + e.filename + ";base64," + r;
            case "pdfobjectnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($020d60e69294d716$var$n)) {
                    var o = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", s = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
                    e.pdfObjectUrl && (o = e.pdfObjectUrl, s = "");
                    var c = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + o + '"' + s + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(e) + ");<\/script></body></html>", u = $020d60e69294d716$var$n.open();
                    return null !== u && u.document.write(c), u;
                }
                throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
            case "pdfjsnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($020d60e69294d716$var$n)) {
                    var l = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (e.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + e.filename + '" width="500px" height="400px" /></body></html>', f = $020d60e69294d716$var$n.open();
                    if (null !== f) {
                        f.document.write(l);
                        var d = this;
                        f.document.documentElement.querySelector("#pdfViewer").onload = function() {
                            f.document.title = e.filename, f.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(d.output("bloburl"));
                        };
                    }
                    return f;
                }
                throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
            case "dataurlnewwindow":
                if ("[object Window]" !== Object.prototype.toString.call($020d60e69294d716$var$n)) throw new Error("The option dataurlnewwindow just works in a browser-environment.");
                var p = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", e) + '"></iframe></body></html>', g = $020d60e69294d716$var$n.open();
                if (null !== g && (g.document.write(p), g.document.title = e.filename), g || "undefined" == typeof safari) return g;
                break;
            case "datauri":
            case "dataurl":
                return $020d60e69294d716$var$n.document.location.href = this.output("datauristring", e);
            default:
                return null;
        }
    }), Ge = function(t) {
        return !0 === Array.isArray(Ut) && Ut.indexOf(t) > -1;
    };
    switch(o){
        case "pt":
            _t = 1;
            break;
        case "mm":
            _t = 72 / 25.4;
            break;
        case "cm":
            _t = 72 / 2.54;
            break;
        case "in":
            _t = 72;
            break;
        case "px":
            _t = 1 == Ge("px_scaling") ? .75 : 96 / 72;
            break;
        case "pc":
        case "em":
            _t = 12;
            break;
        case "ex":
            _t = 6;
            break;
        default:
            if ("number" != typeof o) throw new Error("Invalid unit: " + o);
            _t = o;
    }
    var Ye = null;
    K(), Y();
    var Je = function(t) {
        return null !== m ? Ye.encryptor(t, 0) : function(t) {
            return t;
        };
    }, Xe = y.__private__.getPageInfo = y.getPageInfo = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
        return {
            objId: Rt[t].objId,
            pageNumber: t,
            pageContext: Rt[t]
        };
    }, Ke = y.__private__.getPageInfoByObjId = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
        for(var e in Rt)if (Rt[e].objId === t) break;
        return Xe(e);
    }, Ze = y.__private__.getCurrentPageInfo = y.getCurrentPageInfo = function() {
        return {
            objId: Rt[$].objId,
            pageNumber: $,
            pageContext: Rt[$]
        };
    };
    y.addPage = function() {
        return Oe.apply(this, arguments), this;
    }, y.setPage = function() {
        return Me.apply(this, arguments), ht.call(this, ot[$]), this;
    }, y.insertPage = function(t) {
        return this.addPage(), this.movePage($, t), this;
    }, y.movePage = function(t, e) {
        var r, n;
        if (t > e) {
            r = ot[t], n = Rt[t];
            for(var i = t; i > e; i--)ot[i] = ot[i - 1], Rt[i] = Rt[i - 1];
            ot[e] = r, Rt[e] = n, this.setPage(e);
        } else if (t < e) {
            r = ot[t], n = Rt[t];
            for(var a = t; a < e; a++)ot[a] = ot[a + 1], Rt[a] = Rt[a + 1];
            ot[e] = r, Rt[e] = n, this.setPage(e);
        }
        return this;
    }, y.deletePage = function() {
        return Be.apply(this, arguments), this;
    }, y.__private__.text = y.text = function(e, r, n, i, a) {
        var o, s, c, u, h, l, f, d, p, g = (i = i || {}).scope || this;
        if ("number" == typeof e && "number" == typeof r && ("string" == typeof n || Array.isArray(n))) {
            var m = n;
            n = r, r = e, e = m;
        }
        if (arguments[3] instanceof Vt == !1 ? (c = arguments[4], u = arguments[5], "object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(f = arguments[3]) && null !== f || ("string" == typeof c && (u = c, c = null), "string" == typeof f && (u = f, f = null), "number" == typeof f && (c = f, f = null), i = {
            flags: f,
            angle: c,
            align: u
        })) : (q("The transform parameter of text() with a Matrix value"), p = a), isNaN(r) || isNaN(n) || null == e) throw new Error("Invalid arguments passed to jsPDF.text");
        if (0 === e.length) return g;
        var v = "", y = !1, w = "number" == typeof i.lineHeightFactor ? i.lineHeightFactor : lr, N = g.internal.scaleFactor;
        function L(t) {
            return t = t.split("\t").join(Array(i.TabLen || 9).join(" ")), Ce(t, f);
        }
        function A(t) {
            for(var e, r = t.concat(), n = [], i = r.length; i--;)"string" == typeof (e = r.shift()) ? n.push(e) : Array.isArray(t) && (1 === e.length || void 0 === e[1] && void 0 === e[2]) ? n.push(e[0]) : n.push([
                e[0],
                e[1],
                e[2]
            ]);
            return n;
        }
        function _(t, e) {
            var r;
            if ("string" == typeof t) r = e(t)[0];
            else if (Array.isArray(t)) {
                for(var n, i, a = t.concat(), o = [], s = a.length; s--;)"string" == typeof (n = a.shift()) ? o.push(e(n)[0]) : Array.isArray(n) && "string" == typeof n[0] && (i = e(n[0], n[1], n[2]), o.push([
                    i[0],
                    i[1],
                    i[2]
                ]));
                r = o;
            }
            return r;
        }
        var P = !1, k = !0;
        if ("string" == typeof e) P = !0;
        else if (Array.isArray(e)) {
            var I = e.concat();
            s = [];
            for(var F, C = I.length; C--;)("string" != typeof (F = I.shift()) || Array.isArray(F) && "string" != typeof F[0]) && (k = !1);
            P = k;
        }
        if (!1 === P) throw new Error('Type of text must be string or Array. "' + e + '" is not recognized.');
        "string" == typeof e && (e = e.match(/[\r?\n]/) ? e.split(/\r\n|\r|\n/g) : [
            e
        ]);
        var j = gt / g.internal.scaleFactor, B = j * (w - 1);
        switch(i.baseline){
            case "bottom":
                n -= B;
                break;
            case "top":
                n += j - B;
                break;
            case "hanging":
                n += j - 2 * B;
                break;
            case "middle":
                n += j / 2 - B;
        }
        if ((l = i.maxWidth || 0) > 0 && ("string" == typeof e ? e = g.splitTextToSize(e, l) : "[object Array]" === Object.prototype.toString.call(e) && (e = e.reduce(function(t, e) {
            return t.concat(g.splitTextToSize(e, l));
        }, []))), o = {
            text: e,
            x: r,
            y: n,
            options: i,
            mutex: {
                pdfEscape: Ce,
                activeFontKey: St,
                fonts: Ft,
                activeFontSize: gt
            }
        }, Tt.publish("preProcessText", o), e = o.text, c = (i = o.options).angle, p instanceof Vt == !1 && c && "number" == typeof c) {
            c *= Math.PI / 180, 0 === i.rotationDirection && (c = -c), S === x.ADVANCED && (c = -c);
            var M = Math.cos(c), E = Math.sin(c);
            p = new Vt(M, E, -E, M, 0, 0);
        } else c && c instanceof Vt && (p = c);
        S !== x.ADVANCED || p || (p = Yt), void 0 !== (h = i.charSpace || _r) && (v += O(U(h)) + " Tc\n", this.setCharSpace(this.getCharSpace() || 0)), void 0 !== (d = i.horizontalScale) && (v += O(100 * d) + " Tz\n");
        i.lang;
        var D = -1, R = void 0 !== i.renderingMode ? i.renderingMode : i.stroke, T = g.internal.getCurrentPageInfo().pageContext;
        switch(R){
            case 0:
            case !1:
            case "fill":
                D = 0;
                break;
            case 1:
            case !0:
            case "stroke":
                D = 1;
                break;
            case 2:
            case "fillThenStroke":
                D = 2;
                break;
            case 3:
            case "invisible":
                D = 3;
                break;
            case 4:
            case "fillAndAddForClipping":
                D = 4;
                break;
            case 5:
            case "strokeAndAddPathForClipping":
                D = 5;
                break;
            case 6:
            case "fillThenStrokeAndAddToPathForClipping":
                D = 6;
                break;
            case 7:
            case "addToPathForClipping":
                D = 7;
        }
        var z = void 0 !== T.usedRenderingMode ? T.usedRenderingMode : -1;
        -1 !== D ? v += D + " Tr\n" : -1 !== z && (v += "0 Tr\n"), -1 !== D && (T.usedRenderingMode = D), u = i.align || "left";
        var H, W = gt * w, V = g.internal.pageSize.getWidth(), G = Ft[St];
        h = i.charSpace || _r, l = i.maxWidth || 0, f = Object.assign({
            autoencode: !0,
            noBOM: !0
        }, i.flags);
        var Y = [];
        if ("[object Array]" === Object.prototype.toString.call(e)) {
            var J;
            s = A(e), "left" !== u && (H = s.map(function(t) {
                return g.getStringUnitWidth(t, {
                    font: G,
                    charSpace: h,
                    fontSize: gt,
                    doKerning: !1
                }) * gt / N;
            }));
            var X, K = 0;
            if ("right" === u) {
                r -= H[0], e = [], C = s.length;
                for(var Z = 0; Z < C; Z++)0 === Z ? (X = br(r), J = yr(n)) : (X = U(K - H[Z]), J = -W), e.push([
                    s[Z],
                    X,
                    J
                ]), K = H[Z];
            } else if ("center" === u) {
                r -= H[0] / 2, e = [], C = s.length;
                for(var $ = 0; $ < C; $++)0 === $ ? (X = br(r), J = yr(n)) : (X = U((K - H[$]) / 2), J = -W), e.push([
                    s[$],
                    X,
                    J
                ]), K = H[$];
            } else if ("left" === u) {
                e = [], C = s.length;
                for(var Q = 0; Q < C; Q++)e.push(s[Q]);
            } else {
                if ("justify" !== u) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                e = [], C = s.length, l = 0 !== l ? l : V;
                for(var tt = 0; tt < C; tt++)J = 0 === tt ? yr(n) : -W, X = 0 === tt ? br(r) : 0, tt < C - 1 ? Y.push(O(U((l - H[tt]) / (s[tt].split(" ").length - 1)))) : Y.push(0), e.push([
                    s[tt],
                    X,
                    J
                ]);
            }
        }
        var et = "boolean" == typeof i.R2L ? i.R2L : bt;
        !0 === et && (e = _(e, function(t, e, r) {
            return [
                t.split("").reverse().join(""),
                e,
                r
            ];
        })), o = {
            text: e,
            x: r,
            y: n,
            options: i,
            mutex: {
                pdfEscape: Ce,
                activeFontKey: St,
                fonts: Ft,
                activeFontSize: gt
            }
        }, Tt.publish("postProcessText", o), e = o.text, y = o.mutex.isHex || !1;
        var rt = Ft[St].encoding;
        "WinAnsiEncoding" !== rt && "StandardEncoding" !== rt || (e = _(e, function(t, e, r) {
            return [
                L(t),
                e,
                r
            ];
        })), s = A(e), e = [];
        for(var nt, it, at, ot = 0, st = 1, ct = Array.isArray(s[0]) ? st : ot, ut = "", ht = function(t, e, r) {
            var n = "";
            return r instanceof Vt ? (r = "number" == typeof i.angle ? Gt(r, new Vt(1, 0, 0, 1, t, e)) : Gt(new Vt(1, 0, 0, 1, t, e), r), S === x.ADVANCED && (r = Gt(new Vt(1, 0, 0, -1, 0, 0), r)), n = r.join(" ") + " Tm\n") : n = O(t) + " " + O(e) + " Td\n", n;
        }, ft = 0; ft < s.length; ft++){
            switch(ut = "", ct){
                case st:
                    at = (y ? "<" : "(") + s[ft][0] + (y ? ">" : ")"), nt = parseFloat(s[ft][1]), it = parseFloat(s[ft][2]);
                    break;
                case ot:
                    at = (y ? "<" : "(") + s[ft] + (y ? ">" : ")"), nt = br(r), it = yr(n);
            }
            void 0 !== Y && void 0 !== Y[ft] && (ut = Y[ft] + " Tw\n"), 0 === ft ? e.push(ut + ht(nt, it, p) + at) : ct === ot ? e.push(ut + at) : ct === st && e.push(ut + ht(nt, it, p) + at);
        }
        e = ct === ot ? e.join(" Tj\nT* ") : e.join(" Tj\n"), e += " Tj\n";
        var dt = "BT\n/";
        return dt += St + " " + gt + " Tf\n", dt += O(gt * w) + " TL\n", dt += xr + "\n", dt += v, dt += e, lt(dt += "ET"), b[St] = !0, g;
    };
    var $e = y.__private__.clip = y.clip = function(t) {
        return lt("evenodd" === t ? "W*" : "W"), this;
    };
    y.clipEvenOdd = function() {
        return $e("evenodd");
    }, y.__private__.discardPath = y.discardPath = function() {
        return lt("n"), this;
    };
    var Qe = y.__private__.isValidStyle = function(t) {
        var e = !1;
        return -1 !== [
            void 0,
            null,
            "S",
            "D",
            "F",
            "DF",
            "FD",
            "f",
            "f*",
            "B",
            "B*",
            "n"
        ].indexOf(t) && (e = !0), e;
    };
    y.__private__.setDefaultPathOperation = y.setDefaultPathOperation = function(t) {
        return Qe(t) && (g = t), this;
    };
    var tr = y.__private__.getStyle = y.getStyle = function(t) {
        var e = g;
        switch(t){
            case "D":
            case "S":
                e = "S";
                break;
            case "F":
                e = "f";
                break;
            case "FD":
            case "DF":
                e = "B";
                break;
            case "f":
            case "f*":
            case "B":
            case "B*":
                e = t;
        }
        return e;
    }, er = y.close = function() {
        return lt("h"), this;
    };
    y.stroke = function() {
        return lt("S"), this;
    }, y.fill = function(t) {
        return rr("f", t), this;
    }, y.fillEvenOdd = function(t) {
        return rr("f*", t), this;
    }, y.fillStroke = function(t) {
        return rr("B", t), this;
    }, y.fillStrokeEvenOdd = function(t) {
        return rr("B*", t), this;
    };
    var rr = function(e, r) {
        "object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(r) ? ar(r, e) : lt(e);
    }, nr = function(t) {
        null === t || S === x.ADVANCED && void 0 === t || (t = tr(t), lt(t));
    };
    function ir(t, e, r, n, i) {
        var a = new $020d60e69294d716$export$549f717800d2b57f(e || this.boundingBox, r || this.xStep, n || this.yStep, this.gState, i || this.matrix);
        a.stream = this.stream;
        var o = t + "$$" + this.cloneIndex++ + "$$";
        return Jt(o, a), a;
    }
    var ar = function(t, e) {
        var r = Bt[t.key], n = Ot[r];
        if (n instanceof $020d60e69294d716$export$7235f0ad083cb4c6) lt("q"), lt(or(e)), n.gState && y.setGState(n.gState), lt(t.matrix.toString() + " cm"), lt("/" + r + " sh"), lt("Q");
        else if (n instanceof $020d60e69294d716$export$549f717800d2b57f) {
            var i = new Vt(1, 0, 0, -1, 0, Rr());
            t.matrix && (i = i.multiply(t.matrix || Yt), r = ir.call(n, t.key, t.boundingBox, t.xStep, t.yStep, i).id), lt("q"), lt("/Pattern cs"), lt("/" + r + " scn"), n.gState && y.setGState(n.gState), lt(e), lt("Q");
        }
    }, or = function(t) {
        switch(t){
            case "f":
            case "F":
                return "W n";
            case "f*":
                return "W* n";
            case "B":
                return "W S";
            case "B*":
                return "W* S";
            case "S":
                return "W S";
            case "n":
                return "W n";
        }
    }, sr = y.moveTo = function(t, e) {
        return lt(O(U(t)) + " " + O(H(e)) + " m"), this;
    }, cr = y.lineTo = function(t, e) {
        return lt(O(U(t)) + " " + O(H(e)) + " l"), this;
    }, ur = y.curveTo = function(t, e, r, n, i, a) {
        return lt([
            O(U(t)),
            O(H(e)),
            O(U(r)),
            O(H(n)),
            O(U(i)),
            O(H(a)),
            "c"
        ].join(" ")), this;
    };
    y.__private__.line = y.line = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.line");
        return S === x.COMPAT ? this.lines([
            [
                r - t,
                n - e
            ]
        ], t, e, [
            1,
            1
        ], i || "S") : this.lines([
            [
                r - t,
                n - e
            ]
        ], t, e, [
            1,
            1
        ]).stroke();
    }, y.__private__.lines = y.lines = function(t, e, r, n, i, a) {
        var o, s, c, u, h, l, f, d, p, g, m, v;
        if ("number" == typeof t && (v = r, r = e, e = t, t = v), n = n || [
            1,
            1
        ], a = a || !1, isNaN(e) || isNaN(r) || !Array.isArray(t) || !Array.isArray(n) || !Qe(i) || "boolean" != typeof a) throw new Error("Invalid arguments passed to jsPDF.lines");
        for(sr(e, r), o = n[0], s = n[1], u = t.length, g = e, m = r, c = 0; c < u; c++)2 === (h = t[c]).length ? (g = h[0] * o + g, m = h[1] * s + m, cr(g, m)) : (l = h[0] * o + g, f = h[1] * s + m, d = h[2] * o + g, p = h[3] * s + m, g = h[4] * o + g, m = h[5] * s + m, ur(l, f, d, p, g, m));
        return a && er(), nr(i), this;
    }, y.path = function(t) {
        for(var e = 0; e < t.length; e++){
            var r = t[e], n = r.c;
            switch(r.op){
                case "m":
                    sr(n[0], n[1]);
                    break;
                case "l":
                    cr(n[0], n[1]);
                    break;
                case "c":
                    ur.apply(this, n);
                    break;
                case "h":
                    er();
            }
        }
        return this;
    }, y.__private__.rect = y.rect = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.rect");
        return S === x.COMPAT && (n = -n), lt([
            O(U(t)),
            O(H(e)),
            O(U(r)),
            O(U(n)),
            "re"
        ].join(" ")), nr(i), this;
    }, y.__private__.triangle = y.triangle = function(t, e, r, n, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(a) || !Qe(o)) throw new Error("Invalid arguments passed to jsPDF.triangle");
        return this.lines([
            [
                r - t,
                n - e
            ],
            [
                i - r,
                a - n
            ],
            [
                t - i,
                e - a
            ]
        ], t, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.roundedRect = y.roundedRect = function(t, e, r, n, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(a) || !Qe(o)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
        var s = 4 / 3 * (Math.SQRT2 - 1);
        return i = Math.min(i, .5 * r), a = Math.min(a, .5 * n), this.lines([
            [
                r - 2 * i,
                0
            ],
            [
                i * s,
                0,
                i,
                a - a * s,
                i,
                a
            ],
            [
                0,
                n - 2 * a
            ],
            [
                0,
                a * s,
                -i * s,
                a,
                -i,
                a
            ],
            [
                2 * i - r,
                0
            ],
            [
                -i * s,
                0,
                -i,
                -a * s,
                -i,
                -a
            ],
            [
                0,
                2 * a - n
            ],
            [
                0,
                -a * s,
                i * s,
                -a,
                i,
                -a
            ]
        ], t + i, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.ellipse = y.ellipse = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
        var a = 4 / 3 * (Math.SQRT2 - 1) * r, o = 4 / 3 * (Math.SQRT2 - 1) * n;
        return sr(t + r, e), ur(t + r, e - o, t + a, e - n, t, e - n), ur(t - a, e - n, t - r, e - o, t - r, e), ur(t - r, e + o, t - a, e + n, t, e + n), ur(t + a, e + n, t + r, e + o, t + r, e), nr(i), this;
    }, y.__private__.circle = y.circle = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || !Qe(n)) throw new Error("Invalid arguments passed to jsPDF.circle");
        return this.ellipse(t, e, r, r, n);
    }, y.setFont = function(t, e, r) {
        return r && (e = k(e, r)), St = qe(t, e, {
            disableWarning: !1
        }), this;
    };
    var hr = y.__private__.getFont = y.getFont = function() {
        return Ft[qe.apply(y, arguments)];
    };
    y.__private__.getFontList = y.getFontList = function() {
        var t, e, r = {};
        for(t in Ct)if (Ct.hasOwnProperty(t)) for(e in r[t] = [], Ct[t])Ct[t].hasOwnProperty(e) && r[t].push(e);
        return r;
    }, y.addFont = function(t, e, r, n, i) {
        var a = [
            "StandardEncoding",
            "MacRomanEncoding",
            "Identity-H",
            "WinAnsiEncoding"
        ];
        return arguments[3] && -1 !== a.indexOf(arguments[3]) ? i = arguments[3] : arguments[3] && -1 == a.indexOf(arguments[3]) && (r = k(r, n)), i = i || "Identity-H", Pe.call(this, t, e, r, i);
    };
    var lr, fr = e.lineWidth || .200025, dr = y.__private__.getLineWidth = y.getLineWidth = function() {
        return fr;
    }, pr = y.__private__.setLineWidth = y.setLineWidth = function(t) {
        return fr = t, lt(O(U(t)) + " w"), this;
    };
    y.__private__.setLineDash = $020d60e69294d716$export$ba1e2ffc633a60f5.API.setLineDash = $020d60e69294d716$export$ba1e2ffc633a60f5.API.setLineDashPattern = function(t, e) {
        if (t = t || [], e = e || 0, isNaN(e) || !Array.isArray(t)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
        return t = t.map(function(t) {
            return O(U(t));
        }).join(" "), e = O(U(e)), lt("[" + t + "] " + e + " d"), this;
    };
    var gr = y.__private__.getLineHeight = y.getLineHeight = function() {
        return gt * lr;
    };
    y.__private__.getLineHeight = y.getLineHeight = function() {
        return gt * lr;
    };
    var mr = y.__private__.setLineHeightFactor = y.setLineHeightFactor = function(t) {
        return "number" == typeof (t = t || 1.15) && (lr = t), this;
    }, vr = y.__private__.getLineHeightFactor = y.getLineHeightFactor = function() {
        return lr;
    };
    mr(e.lineHeight);
    var br = y.__private__.getHorizontalCoordinate = function(t) {
        return U(t);
    }, yr = y.__private__.getVerticalCoordinate = function(t) {
        return S === x.ADVANCED ? t : Rt[$].mediaBox.topRightY - Rt[$].mediaBox.bottomLeftY - U(t);
    }, wr = y.__private__.getHorizontalCoordinateString = y.getHorizontalCoordinateString = function(t) {
        return O(br(t));
    }, Nr = y.__private__.getVerticalCoordinateString = y.getVerticalCoordinateString = function(t) {
        return O(yr(t));
    }, Lr = e.strokeColor || "0 G";
    y.__private__.getStrokeColor = y.getDrawColor = function() {
        return ee(Lr);
    }, y.__private__.setStrokeColor = y.setDrawColor = function(t, e, r, n) {
        return Lr = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "draw",
            precision: 2
        }), lt(Lr), this;
    };
    var Ar = e.fillColor || "0 g";
    y.__private__.getFillColor = y.getFillColor = function() {
        return ee(Ar);
    }, y.__private__.setFillColor = y.setFillColor = function(t, e, r, n) {
        return Ar = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "fill",
            precision: 2
        }), lt(Ar), this;
    };
    var xr = e.textColor || "0 g", Sr = y.__private__.getTextColor = y.getTextColor = function() {
        return ee(xr);
    };
    y.__private__.setTextColor = y.setTextColor = function(t, e, r, n) {
        return xr = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "text",
            precision: 3
        }), this;
    };
    var _r = e.charSpace, Pr = y.__private__.getCharSpace = y.getCharSpace = function() {
        return parseFloat(_r || 0);
    };
    y.__private__.setCharSpace = y.setCharSpace = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
        return _r = t, this;
    };
    var kr = 0;
    y.CapJoinStyles = {
        0: 0,
        butt: 0,
        but: 0,
        miter: 0,
        1: 1,
        round: 1,
        rounded: 1,
        circle: 1,
        2: 2,
        projecting: 2,
        project: 2,
        square: 2,
        bevel: 2
    }, y.__private__.setLineCap = y.setLineCap = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return kr = e, lt(e + " J"), this;
    };
    var Ir = 0;
    y.__private__.setLineJoin = y.setLineJoin = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return Ir = e, lt(e + " j"), this;
    }, y.__private__.setLineMiterLimit = y.__private__.setMiterLimit = y.setLineMiterLimit = y.setMiterLimit = function(t) {
        if (t = t || 0, isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
        return lt(O(U(t)) + " M"), this;
    }, y.GState = $020d60e69294d716$export$1bc649ab427a02ba, y.setGState = function(t) {
        (t = "string" == typeof t ? Mt[Et[t]] : Fr(null, t)).equals(qt) || (lt("/" + t.id + " gs"), qt = t);
    };
    var Fr = function(t, e) {
        if (!t || !Et[t]) {
            var r = !1;
            for(var n in Mt)if (Mt.hasOwnProperty(n) && Mt[n].equals(e)) {
                r = !0;
                break;
            }
            if (r) e = Mt[n];
            else {
                var i = "GS" + (Object.keys(Mt).length + 1).toString(10);
                Mt[i] = e, e.id = i;
            }
            return t && (Et[t] = e.id), Tt.publish("addGState", e), e;
        }
    };
    y.addGState = function(t, e) {
        return Fr(t, e), this;
    }, y.saveGraphicsState = function() {
        return lt("q"), jt.push({
            key: St,
            size: gt,
            color: xr
        }), this;
    }, y.restoreGraphicsState = function() {
        lt("Q");
        var t = jt.pop();
        return St = t.key, gt = t.size, xr = t.color, qt = null, this;
    }, y.setCurrentTransformationMatrix = function(t) {
        return lt(t.toString() + " cm"), this;
    }, y.comment = function(t) {
        return lt("#" + t), this;
    };
    var Cr = function(t, e) {
        var r = t || 0;
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                isNaN(t) || (r = parseFloat(t));
            }
        });
        var n = e || 0;
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                isNaN(t) || (n = parseFloat(t));
            }
        });
        var i = "pt";
        return Object.defineProperty(this, "type", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t.toString();
            }
        }), this;
    }, jr = function(t, e, r, n) {
        Cr.call(this, t, e), this.type = "rect";
        var i = r || 0;
        Object.defineProperty(this, "w", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = parseFloat(t));
            }
        });
        var a = n || 0;
        return Object.defineProperty(this, "h", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = parseFloat(t));
            }
        }), this;
    }, Or = function() {
        this.page = Dt, this.currentPage = $, this.pages = ot.slice(0), this.pagesContext = Rt.slice(0), this.x = Pt, this.y = kt, this.matrix = It, this.width = qr($), this.height = Rr($), this.outputDestination = ct, this.id = "", this.objectNumber = -1;
    };
    Or.prototype.restore = function() {
        Dt = this.page, $ = this.currentPage, Rt = this.pagesContext, ot = this.pages, Pt = this.x, kt = this.y, It = this.matrix, Dr($, this.width), Tr($, this.height), ct = this.outputDestination;
    };
    var Br = function(t, e, r, n, i) {
        Wt.push(new Or), Dt = $ = 0, ot = [], Pt = t, kt = e, It = i, je([
            r,
            n
        ]);
    }, Mr = function(t) {
        if (Ht[t]) Wt.pop().restore();
        else {
            var e = new Or, r = "Xo" + (Object.keys(zt).length + 1).toString(10);
            e.id = r, Ht[t] = r, zt[r] = e, Tt.publish("addFormObject", e), Wt.pop().restore();
        }
    };
    for(var Er in y.beginFormObject = function(t, e, r, n, i) {
        return Br(t, e, r, n, i), this;
    }, y.endFormObject = function(t) {
        return Mr(t), this;
    }, y.doFormObject = function(t, e) {
        var r = zt[Ht[t]];
        return lt("q"), lt(e.toString() + " cm"), lt("/" + r.id + " Do"), lt("Q"), this;
    }, y.getFormObject = function(t) {
        var e = zt[Ht[t]];
        return {
            x: e.x,
            y: e.y,
            width: e.width,
            height: e.height,
            matrix: e.matrix
        };
    }, y.save = function(t, e) {
        return t = t || "generated.pdf", (e = e || {}).returnPromise = e.returnPromise || !1, !1 === e.returnPromise ? ($020d60e69294d716$var$l(We(He()), t), "function" == typeof $020d60e69294d716$var$l.unload && $020d60e69294d716$var$n.setTimeout && setTimeout($020d60e69294d716$var$l.unload, 911), this) : new Promise(function(e, r) {
            try {
                var i = $020d60e69294d716$var$l(We(He()), t);
                "function" == typeof $020d60e69294d716$var$l.unload && $020d60e69294d716$var$n.setTimeout && setTimeout($020d60e69294d716$var$l.unload, 911), e(i);
            } catch (t) {
                r(t.message);
            }
        });
    }, $020d60e69294d716$export$ba1e2ffc633a60f5.API)$020d60e69294d716$export$ba1e2ffc633a60f5.API.hasOwnProperty(Er) && ("events" === Er && $020d60e69294d716$export$ba1e2ffc633a60f5.API.events.length ? function(t, e) {
        var r, n, i;
        for(i = e.length - 1; -1 !== i; i--)r = e[i][0], n = e[i][1], t.subscribe.apply(t, [
            r
        ].concat("function" == typeof n ? [
            n
        ] : n));
    }(Tt, $020d60e69294d716$export$ba1e2ffc633a60f5.API.events) : y[Er] = $020d60e69294d716$export$ba1e2ffc633a60f5.API[Er]);
    var qr = y.getPageWidth = function(t) {
        return (Rt[t = t || $].mediaBox.topRightX - Rt[t].mediaBox.bottomLeftX) / _t;
    }, Dr = y.setPageWidth = function(t, e) {
        Rt[t].mediaBox.topRightX = e * _t + Rt[t].mediaBox.bottomLeftX;
    }, Rr = y.getPageHeight = function(t) {
        return (Rt[t = t || $].mediaBox.topRightY - Rt[t].mediaBox.bottomLeftY) / _t;
    }, Tr = y.setPageHeight = function(t, e) {
        Rt[t].mediaBox.topRightY = e * _t + Rt[t].mediaBox.bottomLeftY;
    };
    return y.internal = {
        pdfEscape: Ce,
        getStyle: tr,
        getFont: hr,
        getFontSize: vt,
        getCharSpace: Pr,
        getTextColor: Sr,
        getLineHeight: gr,
        getLineHeightFactor: vr,
        getLineWidth: dr,
        write: ft,
        getHorizontalCoordinate: br,
        getVerticalCoordinate: yr,
        getCoordinateString: wr,
        getVerticalCoordinateString: Nr,
        collections: {},
        newObject: Xt,
        newAdditionalObject: $t,
        newObjectDeferred: Kt,
        newObjectDeferredBegin: Zt,
        getFilters: ne,
        putStream: ie,
        events: Tt,
        scaleFactor: _t,
        pageSize: {
            getWidth: function() {
                return qr($);
            },
            setWidth: function(t) {
                Dr($, t);
            },
            getHeight: function() {
                return Rr($);
            },
            setHeight: function(t) {
                Tr($, t);
            }
        },
        encryptionOptions: m,
        encryption: Ye,
        getEncryptor: Je,
        output: Ve,
        getNumberOfPages: Ee,
        pages: ot,
        out: lt,
        f2: R,
        f3: T,
        getPageInfo: Xe,
        getPageInfoByObjId: Ke,
        getCurrentPageInfo: Ze,
        getPDFVersion: N,
        Point: Cr,
        Rectangle: jr,
        Matrix: Vt,
        hasHotfix: Ge
    }, Object.defineProperty(y.internal.pageSize, "width", {
        get: function() {
            return qr($);
        },
        set: function(t) {
            Dr($, t);
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(y.internal.pageSize, "height", {
        get: function() {
            return Rr($);
        },
        set: function(t) {
            Tr($, t);
        },
        enumerable: !0,
        configurable: !0
    }), ke.call(y, pt), St = "F1", Oe(s, i), Tt.publish("initialized"), y;
}
$020d60e69294d716$var$I.prototype.lsbFirstWord = function(t) {
    return String.fromCharCode(t >> 0 & 255, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255);
}, $020d60e69294d716$var$I.prototype.toHexString = function(t) {
    return t.split("").map(function(t) {
        return ("0" + (255 & t.charCodeAt(0)).toString(16)).slice(-2);
    }).join("");
}, $020d60e69294d716$var$I.prototype.hexToBytes = function(t) {
    for(var e = [], r = 0; r < t.length; r += 2)e.push(String.fromCharCode(parseInt(t.substr(r, 2), 16)));
    return e.join("");
}, $020d60e69294d716$var$I.prototype.processOwnerPassword = function(t, e) {
    return $020d60e69294d716$var$P($020d60e69294d716$var$x(e).substr(0, 5), t);
}, $020d60e69294d716$var$I.prototype.encryptor = function(t, e) {
    var r = $020d60e69294d716$var$x(this.encryptionKey + String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, 255 & e, e >> 8 & 255)).substr(0, 10);
    return function(t) {
        return $020d60e69294d716$var$P(r, t);
    };
}, $020d60e69294d716$export$1bc649ab427a02ba.prototype.equals = function(e) {
    var r, n = "id,objectNumber,equals";
    if (!e || (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(e) !== (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(this)) return !1;
    var i = 0;
    for(r in this)if (!(n.indexOf(r) >= 0)) {
        if (this.hasOwnProperty(r) && !e.hasOwnProperty(r)) return !1;
        if (this[r] !== e[r]) return !1;
        i++;
    }
    for(r in e)e.hasOwnProperty(r) && n.indexOf(r) < 0 && i--;
    return 0 === i;
}, $020d60e69294d716$export$ba1e2ffc633a60f5.API = {
    events: []
}, $020d60e69294d716$export$ba1e2ffc633a60f5.version = "2.5.1";
var $020d60e69294d716$var$q = $020d60e69294d716$export$ba1e2ffc633a60f5.API, $020d60e69294d716$var$D = 1, $020d60e69294d716$var$R = function(t) {
    return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, $020d60e69294d716$var$T = function(t) {
    return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, $020d60e69294d716$var$U = function(t) {
    return t.toFixed(2);
}, $020d60e69294d716$var$z = function(t) {
    return t.toFixed(5);
};
$020d60e69294d716$var$q.__acroform__ = {};
var $020d60e69294d716$var$H = function(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
}, $020d60e69294d716$var$W = function(t) {
    return t * $020d60e69294d716$var$D;
}, $020d60e69294d716$var$V = function(t) {
    var e = new $020d60e69294d716$var$ut, r = $020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t) || 0, n = $020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t) || 0;
    return e.BBox = [
        0,
        0,
        Number($020d60e69294d716$var$U(n)),
        Number($020d60e69294d716$var$U(r))
    ], e;
}, $020d60e69294d716$var$G = $020d60e69294d716$var$q.__acroform__.setBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
    return t |= 1 << e;
}, $020d60e69294d716$var$Y = $020d60e69294d716$var$q.__acroform__.clearBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
    return t &= ~(1 << e);
}, $020d60e69294d716$var$J = $020d60e69294d716$var$q.__acroform__.getBit = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
    return 0 == (t & 1 << e) ? 0 : 1;
}, $020d60e69294d716$var$X = $020d60e69294d716$var$q.__acroform__.getBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
    return $020d60e69294d716$var$J(t, e - 1);
}, $020d60e69294d716$var$K = $020d60e69294d716$var$q.__acroform__.setBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
    return $020d60e69294d716$var$G(t, e - 1);
}, $020d60e69294d716$var$Z = $020d60e69294d716$var$q.__acroform__.clearBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
    return $020d60e69294d716$var$Y(t, e - 1);
}, $020d60e69294d716$var$$ = $020d60e69294d716$var$q.__acroform__.calculateCoordinates = function(t, e) {
    var r = e.internal.getHorizontalCoordinate, n = e.internal.getVerticalCoordinate, i = t[0], a = t[1], o = t[2], s = t[3], c = {};
    return c.lowerLeft_X = r(i) || 0, c.lowerLeft_Y = n(a + s) || 0, c.upperRight_X = r(i + o) || 0, c.upperRight_Y = n(a) || 0, [
        Number($020d60e69294d716$var$U(c.lowerLeft_X)),
        Number($020d60e69294d716$var$U(c.lowerLeft_Y)),
        Number($020d60e69294d716$var$U(c.upperRight_X)),
        Number($020d60e69294d716$var$U(c.upperRight_Y))
    ];
}, $020d60e69294d716$var$Q = function(t) {
    if (t.appearanceStreamContent) return t.appearanceStreamContent;
    if (t.V || t.DV) {
        var e = [], r = t._V || t.DV, n = $020d60e69294d716$var$tt(t, r), i = t.scope.internal.getFont(t.fontName, t.fontStyle).id;
        e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(t.scope.__private__.encodeColorString(t.color)), e.push("/" + i + " " + $020d60e69294d716$var$U(n.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(n.text), e.push("ET"), e.push("Q"), e.push("EMC");
        var a = $020d60e69294d716$var$V(t);
        return a.scope = t.scope, a.stream = e.join("\n"), a;
    }
}, $020d60e69294d716$var$tt = function(t, e) {
    var r = 0 === t.fontSize ? t.maxFontSize : t.fontSize, n = {
        text: "",
        fontSize: ""
    }, i = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" ");
    i = t.multiline ? i.map(function(t) {
        return t.split("\n");
    }) : i.map(function(t) {
        return [
            t
        ];
    });
    var a = r, o = $020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t) || 0;
    o = o < 0 ? -o : o;
    var s = $020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t) || 0;
    s = s < 0 ? -s : s;
    var c = function(e, r, n) {
        if (e + 1 < i.length) {
            var a = r + " " + i[e + 1][0];
            return $020d60e69294d716$var$et(a, t, n).width <= s - 4;
        }
        return !1;
    };
    a++;
    t: for(; a > 0;){
        e = "", a--;
        var u, h, l = $020d60e69294d716$var$et("3", t, a).height, f = t.multiline ? o - a : (o - l) / 2, d = f += 2, p = 0, g = 0, m = 0;
        if (a <= 0) {
            e = "(...) Tj\n", e += "% Width of Text: " + $020d60e69294d716$var$et(e, t, a = 12).width + ", FieldWidth:" + s + "\n";
            break;
        }
        for(var v = "", b = 0, y = 0; y < i.length; y++)if (i.hasOwnProperty(y)) {
            var w = !1;
            if (1 !== i[y].length && m !== i[y].length - 1) {
                if ((l + 2) * (b + 2) + 2 > o) continue t;
                v += i[y][m], w = !0, g = y, y--;
            } else {
                v = " " == (v += i[y][m] + " ").substr(v.length - 1) ? v.substr(0, v.length - 1) : v;
                var N = parseInt(y), L = c(N, v, a), A = y >= i.length - 1;
                if (L && !A) {
                    v += " ", m = 0;
                    continue;
                }
                if (L || A) {
                    if (A) g = N;
                    else if (t.multiline && (l + 2) * (b + 2) + 2 > o) continue t;
                } else {
                    if (!t.multiline) continue t;
                    if ((l + 2) * (b + 2) + 2 > o) continue t;
                    g = N;
                }
            }
            for(var x = "", S = p; S <= g; S++){
                var _ = i[S];
                if (t.multiline) {
                    if (S === g) {
                        x += _[m] + " ", m = (m + 1) % _.length;
                        continue;
                    }
                    if (S === p) {
                        x += _[_.length - 1] + " ";
                        continue;
                    }
                }
                x += _[0] + " ";
            }
            switch(x = " " == x.substr(x.length - 1) ? x.substr(0, x.length - 1) : x, h = $020d60e69294d716$var$et(x, t, a).width, t.textAlign){
                case "right":
                    u = s - h - 2;
                    break;
                case "center":
                    u = (s - h) / 2;
                    break;
                case "left":
                default:
                    u = 2;
            }
            e += $020d60e69294d716$var$U(u) + " " + $020d60e69294d716$var$U(d) + " Td\n", e += "(" + $020d60e69294d716$var$R(x) + ") Tj\n", e += -$020d60e69294d716$var$U(u) + " 0 Td\n", d = -(a + 2), h = 0, p = w ? g : g + 1, b++, v = "";
        }
        break;
    }
    return n.text = e, n.fontSize = a, n;
}, $020d60e69294d716$var$et = function(t, e, r) {
    var n = e.scope.internal.getFont(e.fontName, e.fontStyle), i = e.scope.getStringUnitWidth(t, {
        font: n,
        fontSize: parseFloat(r),
        charSpace: 0
    }) * parseFloat(r);
    return {
        height: e.scope.getStringUnitWidth("3", {
            font: n,
            fontSize: parseFloat(r),
            charSpace: 0
        }) * parseFloat(r) * 1.5,
        width: i
    };
}, $020d60e69294d716$var$rt = {
    fields: [],
    xForms: [],
    acroFormDictionaryRoot: null,
    printedOut: !1,
    internal: null,
    isInitialized: !1
}, $020d60e69294d716$var$nt = function(t, e) {
    var r = {
        type: "reference",
        object: t
    };
    void 0 === e.internal.getPageInfo(t.page).pageContext.annotations.find(function(t) {
        return t.type === r.type && t.object === r.object;
    }) && e.internal.getPageInfo(t.page).pageContext.annotations.push(r);
}, $020d60e69294d716$var$it = function(e, r) {
    for(var n in e)if (e.hasOwnProperty(n)) {
        var i = n, a = e[n];
        r.internal.newObjectDeferredBegin(a.objId, !0), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(a) && "function" == typeof a.putStream && a.putStream(), delete e[i];
    }
}, $020d60e69294d716$var$at = function(e, r) {
    if (r.scope = e, void 0 !== e.internal && (void 0 === e.internal.acroformPlugin || !1 === e.internal.acroformPlugin.isInitialized)) {
        if ($020d60e69294d716$var$lt.FieldNum = 0, e.internal.acroformPlugin = JSON.parse(JSON.stringify($020d60e69294d716$var$rt)), e.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
        $020d60e69294d716$var$D = e.internal.scaleFactor, e.internal.acroformPlugin.acroFormDictionaryRoot = new $020d60e69294d716$var$ht, e.internal.acroformPlugin.acroFormDictionaryRoot.scope = e, e.internal.acroformPlugin.acroFormDictionaryRoot._eventID = e.internal.events.subscribe("postPutResources", function() {
            !function(t) {
                t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID, t.internal.acroformPlugin.printedOut = !0;
            }(e);
        }), e.internal.events.subscribe("buildDocument", function() {
            !function(t) {
                t.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
                var e = t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
                for(var r in e)if (e.hasOwnProperty(r)) {
                    var n = e[r];
                    n.objId = void 0, n.hasAnnotation && $020d60e69294d716$var$nt(n, t);
                }
            }(e);
        }), e.internal.events.subscribe("putCatalog", function() {
            !function(t) {
                if (void 0 === t.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("putCatalogCallback: Root missing.");
                t.internal.write("/AcroForm " + t.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
            }(e);
        }), e.internal.events.subscribe("postPutPages", function(r) {
            !function(e, r) {
                var n = !e;
                for(var i in e || (r.internal.newObjectDeferredBegin(r.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), r.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), e = e || r.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if (e.hasOwnProperty(i)) {
                    var a = e[i], o = [], s = a.Rect;
                    if (a.Rect && (a.Rect = $020d60e69294d716$var$$(a.Rect, r)), r.internal.newObjectDeferredBegin(a.objId, !0), a.DA = $020d60e69294d716$export$7d753ad993606f45.createDefaultAppearanceStream(a), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(a) && "function" == typeof a.getKeyValueListForStream && (o = a.getKeyValueListForStream()), a.Rect = s, a.hasAppearanceStream && !a.appearanceStreamContent) {
                        var c = $020d60e69294d716$var$Q(a);
                        o.push({
                            key: "AP",
                            value: "<</N " + c + ">>"
                        }), r.internal.acroformPlugin.xForms.push(c);
                    }
                    if (a.appearanceStreamContent) {
                        var u = "";
                        for(var h in a.appearanceStreamContent)if (a.appearanceStreamContent.hasOwnProperty(h)) {
                            var l = a.appearanceStreamContent[h];
                            if (u += "/" + h + " ", u += "<<", Object.keys(l).length >= 1 || Array.isArray(l)) {
                                for(var i in l)if (l.hasOwnProperty(i)) {
                                    var f = l[i];
                                    "function" == typeof f && (f = f.call(r, a)), u += "/" + i + " " + f + " ", r.internal.acroformPlugin.xForms.indexOf(f) >= 0 || r.internal.acroformPlugin.xForms.push(f);
                                }
                            } else "function" == typeof (f = l) && (f = f.call(r, a)), u += "/" + i + " " + f, r.internal.acroformPlugin.xForms.indexOf(f) >= 0 || r.internal.acroformPlugin.xForms.push(f);
                            u += ">>";
                        }
                        o.push({
                            key: "AP",
                            value: "<<\n" + u + ">>"
                        });
                    }
                    r.internal.putStream({
                        additionalKeyValues: o,
                        objectId: a.objId
                    }), r.internal.out("endobj");
                }
                n && $020d60e69294d716$var$it(r.internal.acroformPlugin.xForms, r);
            }(r, e);
        }), e.internal.acroformPlugin.isInitialized = !0;
    }
}, $020d60e69294d716$var$ot = $020d60e69294d716$var$q.__acroform__.arrayToPdfArray = function(e, r, n) {
    var i = function(t) {
        return t;
    };
    if (Array.isArray(e)) {
        for(var a = "[", o = 0; o < e.length; o++)switch(0 !== o && (a += " "), (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(e[o])){
            case "boolean":
            case "number":
            case "object":
                a += e[o].toString();
                break;
            case "string":
                "/" !== e[o].substr(0, 1) ? (void 0 !== r && n && (i = n.internal.getEncryptor(r)), a += "(" + $020d60e69294d716$var$R(i(e[o].toString())) + ")") : a += e[o].toString();
        }
        return a += "]";
    }
    throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
};
var $020d60e69294d716$var$st = function(t, e, r) {
    var n = function(t) {
        return t;
    };
    return void 0 !== e && r && (n = r.internal.getEncryptor(e)), (t = t || "").toString(), t = "(" + $020d60e69294d716$var$R(n(t)) + ")";
}, $020d60e69294d716$var$ct = function() {
    this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", {
        get: function() {
            if (void 0 === this._objId) {
                if (void 0 === this.scope) return;
                this._objId = this.scope.internal.newObjectDeferred();
            }
            return this._objId;
        },
        set: function(t) {
            this._objId = t;
        }
    }), Object.defineProperty(this, "scope", {
        value: this._scope,
        writable: !0
    });
};
$020d60e69294d716$var$ct.prototype.toString = function() {
    return this.objId + " 0 R";
}, $020d60e69294d716$var$ct.prototype.putStream = function() {
    var t = this.getKeyValueListForStream();
    this.scope.internal.putStream({
        data: this.stream,
        additionalKeyValues: t,
        objectId: this.objId
    }), this.scope.internal.out("endobj");
}, $020d60e69294d716$var$ct.prototype.getKeyValueListForStream = function() {
    var t = [], e = Object.getOwnPropertyNames(this).filter(function(t) {
        return "content" != t && "appearanceStreamContent" != t && "scope" != t && "objId" != t && "_" != t.substring(0, 1);
    });
    for(var r in e)if (!1 === Object.getOwnPropertyDescriptor(this, e[r]).configurable) {
        var n = e[r], i = this[n];
        i && (Array.isArray(i) ? t.push({
            key: n,
            value: $020d60e69294d716$var$ot(i, this.objId, this.scope)
        }) : i instanceof $020d60e69294d716$var$ct ? (i.scope = this.scope, t.push({
            key: n,
            value: i.objId + " 0 R"
        })) : "function" != typeof i && t.push({
            key: n,
            value: i
        }));
    }
    return t;
};
var $020d60e69294d716$var$ut = function() {
    $020d60e69294d716$var$ct.call(this), Object.defineProperty(this, "Type", {
        value: "/XObject",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "Subtype", {
        value: "/Form",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "FormType", {
        value: 1,
        configurable: !1,
        writable: !0
    });
    var t, e = [];
    Object.defineProperty(this, "BBox", {
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "Resources", {
        value: "2 0 R",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "stream", {
        enumerable: !1,
        configurable: !0,
        set: function(e) {
            t = e.trim();
        },
        get: function() {
            return t || null;
        }
    });
};
$020d60e69294d716$var$H($020d60e69294d716$var$ut, $020d60e69294d716$var$ct);
var $020d60e69294d716$var$ht = function() {
    $020d60e69294d716$var$ct.call(this);
    var t, e = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return e.length > 0 ? e : void 0;
        }
    }), Object.defineProperty(this, "Fields", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        }
    }), Object.defineProperty(this, "DA", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (t) {
                var e = function(t) {
                    return t;
                };
                return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + $020d60e69294d716$var$R(e(t)) + ")";
            }
        },
        set: function(e) {
            t = e;
        }
    });
};
$020d60e69294d716$var$H($020d60e69294d716$var$ht, $020d60e69294d716$var$ct);
var $020d60e69294d716$var$lt = function t() {
    $020d60e69294d716$var$ct.call(this);
    var e = 4;
    Object.defineProperty(this, "F", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute F supplied.');
            e = t;
        }
    }), Object.defineProperty(this, "showWhenPrinted", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(e, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.F = $020d60e69294d716$var$K(e, 3) : this.F = $020d60e69294d716$var$Z(e, 3);
        }
    });
    var r = 0;
    Object.defineProperty(this, "Ff", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return r;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute Ff supplied.');
            r = t;
        }
    });
    var n = [];
    Object.defineProperty(this, "Rect", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (0 !== n.length) return n;
        },
        set: function(t) {
            n = void 0 !== t ? t : [];
        }
    }), Object.defineProperty(this, "x", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[0]) ? 0 : n[0];
        },
        set: function(t) {
            n[0] = t;
        }
    }), Object.defineProperty(this, "y", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[1]) ? 0 : n[1];
        },
        set: function(t) {
            n[1] = t;
        }
    }), Object.defineProperty(this, "width", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[2]) ? 0 : n[2];
        },
        set: function(t) {
            n[2] = t;
        }
    }), Object.defineProperty(this, "height", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[3]) ? 0 : n[3];
        },
        set: function(t) {
            n[3] = t;
        }
    });
    var i = "";
    Object.defineProperty(this, "FT", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return i;
        },
        set: function(t) {
            switch(t){
                case "/Btn":
                case "/Tx":
                case "/Ch":
                case "/Sig":
                    i = t;
                    break;
                default:
                    throw new Error('Invalid value "' + t + '" for attribute FT supplied.');
            }
        }
    });
    var a = null;
    Object.defineProperty(this, "T", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!a || a.length < 1) {
                if (this instanceof $020d60e69294d716$var$yt) return;
                a = "FieldObject" + t.FieldNum++;
            }
            var e = function(t) {
                return t;
            };
            return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + $020d60e69294d716$var$R(e(a)) + ")";
        },
        set: function(t) {
            a = t.toString();
        }
    }), Object.defineProperty(this, "fieldName", {
        configurable: !0,
        enumerable: !0,
        get: function() {
            return a;
        },
        set: function(t) {
            a = t;
        }
    });
    var o = "helvetica";
    Object.defineProperty(this, "fontName", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return o;
        },
        set: function(t) {
            o = t;
        }
    });
    var s = "normal";
    Object.defineProperty(this, "fontStyle", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return s;
        },
        set: function(t) {
            s = t;
        }
    });
    var c = 0;
    Object.defineProperty(this, "fontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return c;
        },
        set: function(t) {
            c = t;
        }
    });
    var u = void 0;
    Object.defineProperty(this, "maxFontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return void 0 === u ? 50 / $020d60e69294d716$var$D : u;
        },
        set: function(t) {
            u = t;
        }
    });
    var h = "black";
    Object.defineProperty(this, "color", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return h;
        },
        set: function(t) {
            h = t;
        }
    });
    var l = "/F1 0 Tf 0 g";
    Object.defineProperty(this, "DA", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!(!l || this instanceof $020d60e69294d716$var$yt || this instanceof $020d60e69294d716$export$9d1b52e7fab50c84)) return $020d60e69294d716$var$st(l, this.objId, this.scope);
        },
        set: function(t) {
            t = t.toString(), l = t;
        }
    });
    var f = null;
    Object.defineProperty(this, "DV", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (f) return this instanceof $020d60e69294d716$export$6aae594af76bbb7b == !1 ? $020d60e69294d716$var$st(f, this.objId, this.scope) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof $020d60e69294d716$export$6aae594af76bbb7b == !1 ? "(" === t.substr(0, 1) ? $020d60e69294d716$var$T(t.substr(1, t.length - 2)) : $020d60e69294d716$var$T(t) : t;
        }
    }), Object.defineProperty(this, "defaultValue", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof $020d60e69294d716$export$6aae594af76bbb7b == !0 ? $020d60e69294d716$var$T(f.substr(1, f.length - 1)) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof $020d60e69294d716$export$6aae594af76bbb7b == !0 ? "/" + t : t;
        }
    });
    var d = null;
    Object.defineProperty(this, "_V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return d;
        },
        set: function(t) {
            this.V = t;
        }
    }), Object.defineProperty(this, "V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return this instanceof $020d60e69294d716$export$6aae594af76bbb7b == !1 ? $020d60e69294d716$var$st(d, this.objId, this.scope) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof $020d60e69294d716$export$6aae594af76bbb7b == !1 ? "(" === t.substr(0, 1) ? $020d60e69294d716$var$T(t.substr(1, t.length - 2)) : $020d60e69294d716$var$T(t) : t;
        }
    }), Object.defineProperty(this, "value", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof $020d60e69294d716$export$6aae594af76bbb7b == !0 ? $020d60e69294d716$var$T(d.substr(1, d.length - 1)) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof $020d60e69294d716$export$6aae594af76bbb7b == !0 ? "/" + t : t;
        }
    }), Object.defineProperty(this, "hasAnnotation", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.Rect;
        }
    }), Object.defineProperty(this, "Type", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Annot" : null;
        }
    }), Object.defineProperty(this, "Subtype", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Widget" : null;
        }
    });
    var p, g = !1;
    Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return g;
        },
        set: function(t) {
            t = Boolean(t), g = t;
        }
    }), Object.defineProperty(this, "page", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            if (p) return p;
        },
        set: function(t) {
            p = t;
        }
    }), Object.defineProperty(this, "readOnly", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 1));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 1) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 1);
        }
    }), Object.defineProperty(this, "required", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 2));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 2) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 2);
        }
    }), Object.defineProperty(this, "noExport", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 3) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 3);
        }
    });
    var m = null;
    Object.defineProperty(this, "Q", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (null !== m) return m;
        },
        set: function(t) {
            if (-1 === [
                0,
                1,
                2
            ].indexOf(t)) throw new Error('Invalid value "' + t + '" for attribute Q supplied.');
            m = t;
        }
    }), Object.defineProperty(this, "textAlign", {
        get: function() {
            var t;
            switch(m){
                case 0:
                default:
                    t = "left";
                    break;
                case 1:
                    t = "center";
                    break;
                case 2:
                    t = "right";
            }
            return t;
        },
        configurable: !0,
        enumerable: !0,
        set: function(t) {
            switch(t){
                case "right":
                case 2:
                    m = 2;
                    break;
                case "center":
                case 1:
                    m = 1;
                    break;
                case "left":
                case 0:
                default:
                    m = 0;
            }
        }
    });
};
$020d60e69294d716$var$H($020d60e69294d716$var$lt, $020d60e69294d716$var$ct);
var $020d60e69294d716$export$a47202eb3f827bb2 = function() {
    $020d60e69294d716$var$lt.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
    var t = 0;
    Object.defineProperty(this, "TI", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "topIndex", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    });
    var e = [];
    Object.defineProperty(this, "Opt", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return $020d60e69294d716$var$ot(e, this.objId, this.scope);
        },
        set: function(t) {
            var r, n;
            n = [], "string" == typeof (r = t) && (n = function(t, e, r) {
                r || (r = 1);
                for(var n, i = []; n = e.exec(t);)i.push(n[r]);
                return i;
            }(r, /\((.*?)\)/g)), e = n;
        }
    }), this.getOptions = function() {
        return e;
    }, this.setOptions = function(t) {
        e = t, this.sort && e.sort();
    }, this.addOption = function(t) {
        t = (t = t || "").toString(), e.push(t), this.sort && e.sort();
    }, this.removeOption = function(t, r) {
        for(r = r || !1, t = (t = t || "").toString(); -1 !== e.indexOf(t) && (e.splice(e.indexOf(t), 1), !1 !== r););
    }, Object.defineProperty(this, "combo", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 18));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 18) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 18);
        }
    }), Object.defineProperty(this, "edit", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 19));
        },
        set: function(t) {
            !0 === this.combo && (!0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 19) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 19));
        }
    }), Object.defineProperty(this, "sort", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 20));
        },
        set: function(t) {
            !0 === Boolean(t) ? (this.Ff = $020d60e69294d716$var$K(this.Ff, 20), e.sort()) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 20);
        }
    }), Object.defineProperty(this, "multiSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 22));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 22) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 22);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 23) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 23);
        }
    }), Object.defineProperty(this, "commitOnSelChange", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 27));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 27) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 27);
        }
    }), this.hasAppearanceStream = !1;
};
$020d60e69294d716$var$H($020d60e69294d716$export$a47202eb3f827bb2, $020d60e69294d716$var$lt);
var $020d60e69294d716$export$9e021dd9568dc486 = function() {
    $020d60e69294d716$export$a47202eb3f827bb2.call(this), this.fontName = "helvetica", this.combo = !1;
};
$020d60e69294d716$var$H($020d60e69294d716$export$9e021dd9568dc486, $020d60e69294d716$export$a47202eb3f827bb2);
var $020d60e69294d716$export$f2239d28df5f43bd = function() {
    $020d60e69294d716$export$9e021dd9568dc486.call(this), this.combo = !0;
};
$020d60e69294d716$var$H($020d60e69294d716$export$f2239d28df5f43bd, $020d60e69294d716$export$9e021dd9568dc486);
var $020d60e69294d716$export$4af052e7e598ad1a = function() {
    $020d60e69294d716$export$f2239d28df5f43bd.call(this), this.edit = !0;
};
$020d60e69294d716$var$H($020d60e69294d716$export$4af052e7e598ad1a, $020d60e69294d716$export$f2239d28df5f43bd);
var $020d60e69294d716$export$6aae594af76bbb7b = function() {
    $020d60e69294d716$var$lt.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 15));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 15) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 15);
        }
    }), Object.defineProperty(this, "radio", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 16));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 16) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 16);
        }
    }), Object.defineProperty(this, "pushButton", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 17));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 17) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 17);
        }
    }), Object.defineProperty(this, "radioIsUnison", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 26) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 26);
        }
    });
    var e, r = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            if (this.scope && (t = this.scope.internal.getEncryptor(this.objId)), 0 !== Object.keys(r).length) {
                var e, n = [];
                for(e in n.push("<<"), r)n.push("/" + e + " (" + $020d60e69294d716$var$R(t(r[e])) + ")");
                return n.push(">>"), n.join("\n");
            }
        },
        set: function(e) {
            "object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(e) && (r = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return r.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (r.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return e.substr(1, e.length - 1);
        },
        set: function(t) {
            e = "/" + t;
        }
    });
};
$020d60e69294d716$var$H($020d60e69294d716$export$6aae594af76bbb7b, $020d60e69294d716$var$lt);
var $020d60e69294d716$export$98b7c3ef37465410 = function() {
    $020d60e69294d716$export$6aae594af76bbb7b.call(this), this.pushButton = !0;
};
$020d60e69294d716$var$H($020d60e69294d716$export$98b7c3ef37465410, $020d60e69294d716$export$6aae594af76bbb7b);
var $020d60e69294d716$export$bc1318bc7e5f1315 = function() {
    $020d60e69294d716$export$6aae594af76bbb7b.call(this), this.radio = !0, this.pushButton = !1;
    var t = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = void 0 !== e ? e : [];
        }
    });
};
$020d60e69294d716$var$H($020d60e69294d716$export$bc1318bc7e5f1315, $020d60e69294d716$export$6aae594af76bbb7b);
var $020d60e69294d716$var$yt = function() {
    var e, r;
    $020d60e69294d716$var$lt.call(this), Object.defineProperty(this, "Parent", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "optionName", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return r;
        },
        set: function(t) {
            r = t;
        }
    });
    var n, i = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            this.scope && (t = this.scope.internal.getEncryptor(this.objId));
            var e, r = [];
            for(e in r.push("<<"), i)r.push("/" + e + " (" + $020d60e69294d716$var$R(t(i[e])) + ")");
            return r.push(">>"), r.join("\n");
        },
        set: function(e) {
            "object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(e) && (i = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return i.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (i.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return n;
        },
        set: function(t) {
            n = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return n.substr(1, n.length - 1);
        },
        set: function(t) {
            n = "/" + t;
        }
    }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = $020d60e69294d716$export$7d753ad993606f45.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
$020d60e69294d716$var$H($020d60e69294d716$var$yt, $020d60e69294d716$var$lt), $020d60e69294d716$export$bc1318bc7e5f1315.prototype.setAppearance = function(t) {
    if (!("createAppearanceStream" in t) || !("getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
    for(var e in this.Kids)if (this.Kids.hasOwnProperty(e)) {
        var r = this.Kids[e];
        r.appearanceStreamContent = t.createAppearanceStream(r.optionName), r.caption = t.getCA();
    }
}, $020d60e69294d716$export$bc1318bc7e5f1315.prototype.createOption = function(t) {
    var e = new $020d60e69294d716$var$yt;
    return e.Parent = this, e.optionName = t, this.Kids.push(e), $020d60e69294d716$var$xt.call(this.scope, e), e;
};
var $020d60e69294d716$export$5fd5db01c4615478 = function() {
    $020d60e69294d716$export$6aae594af76bbb7b.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = $020d60e69294d716$export$7d753ad993606f45.CheckBox.createAppearanceStream();
};
$020d60e69294d716$var$H($020d60e69294d716$export$5fd5db01c4615478, $020d60e69294d716$export$6aae594af76bbb7b);
var $020d60e69294d716$export$9d1b52e7fab50c84 = function() {
    $020d60e69294d716$var$lt.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 13));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 13) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 13);
        }
    }), Object.defineProperty(this, "fileSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 21));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 21) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 21);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 23) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 23);
        }
    }), Object.defineProperty(this, "doNotScroll", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 24));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 24) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 24);
        }
    }), Object.defineProperty(this, "comb", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 25));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 25) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 25);
        }
    }), Object.defineProperty(this, "richText", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 26) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 26);
        }
    });
    var t = null;
    Object.defineProperty(this, "MaxLen", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "maxLength", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            Number.isInteger(e) && (t = e);
        }
    }), Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.V || this.DV;
        }
    });
};
$020d60e69294d716$var$H($020d60e69294d716$export$9d1b52e7fab50c84, $020d60e69294d716$var$lt);
var $020d60e69294d716$export$c48d8668f8cea64d = function() {
    $020d60e69294d716$export$9d1b52e7fab50c84.call(this), Object.defineProperty(this, "password", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($020d60e69294d716$var$X(this.Ff, 14));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $020d60e69294d716$var$K(this.Ff, 14) : this.Ff = $020d60e69294d716$var$Z(this.Ff, 14);
        }
    }), this.password = !0;
};
$020d60e69294d716$var$H($020d60e69294d716$export$c48d8668f8cea64d, $020d60e69294d716$export$9d1b52e7fab50c84);
var $020d60e69294d716$export$7d753ad993606f45 = {
    CheckBox: {
        createAppearanceStream: function() {
            return {
                N: {
                    On: $020d60e69294d716$export$7d753ad993606f45.CheckBox.YesNormal
                },
                D: {
                    On: $020d60e69294d716$export$7d753ad993606f45.CheckBox.YesPushDown,
                    Off: $020d60e69294d716$export$7d753ad993606f45.CheckBox.OffPushDown
                }
            };
        },
        YesPushDown: function(t) {
            var e = $020d60e69294d716$var$V(t);
            e.scope = t.scope;
            var r = [], n = t.scope.internal.getFont(t.fontName, t.fontStyle).id, i = t.scope.__private__.encodeColorString(t.color), a = $020d60e69294d716$var$tt(t, t.caption);
            return r.push("0.749023 g"), r.push("0 0 " + $020d60e69294d716$var$U($020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t)) + " " + $020d60e69294d716$var$U($020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), r.push("BMC"), r.push("q"), r.push("0 0 1 rg"), r.push("/" + n + " " + $020d60e69294d716$var$U(a.fontSize) + " Tf " + i), r.push("BT"), r.push(a.text), r.push("ET"), r.push("Q"), r.push("EMC"), e.stream = r.join("\n"), e;
        },
        YesNormal: function(t) {
            var e = $020d60e69294d716$var$V(t);
            e.scope = t.scope;
            var r = t.scope.internal.getFont(t.fontName, t.fontStyle).id, n = t.scope.__private__.encodeColorString(t.color), i = [], a = $020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t), o = $020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t), s = $020d60e69294d716$var$tt(t, t.caption);
            return i.push("1 g"), i.push("0 0 " + $020d60e69294d716$var$U(o) + " " + $020d60e69294d716$var$U(a) + " re"), i.push("f"), i.push("q"), i.push("0 0 1 rg"), i.push("0 0 " + $020d60e69294d716$var$U(o - 1) + " " + $020d60e69294d716$var$U(a - 1) + " re"), i.push("W"), i.push("n"), i.push("0 g"), i.push("BT"), i.push("/" + r + " " + $020d60e69294d716$var$U(s.fontSize) + " Tf " + n), i.push(s.text), i.push("ET"), i.push("Q"), e.stream = i.join("\n"), e;
        },
        OffPushDown: function(t) {
            var e = $020d60e69294d716$var$V(t);
            e.scope = t.scope;
            var r = [];
            return r.push("0.749023 g"), r.push("0 0 " + $020d60e69294d716$var$U($020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t)) + " " + $020d60e69294d716$var$U($020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), e.stream = r.join("\n"), e;
        }
    },
    RadioButton: {
        Circle: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: $020d60e69294d716$export$7d753ad993606f45.RadioButton.Circle.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $020d60e69294d716$export$7d753ad993606f45.RadioButton.Circle.YesNormal, e.D[t] = $020d60e69294d716$export$7d753ad993606f45.RadioButton.Circle.YesPushDown, e;
            },
            getCA: function() {
                return "l";
            },
            YesNormal: function(t) {
                var e = $020d60e69294d716$var$V(t);
                e.scope = t.scope;
                var r = [], n = $020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t) <= $020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t) ? $020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t) / 4 : $020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var i = $020d60e69294d716$export$7d753ad993606f45.internal.Bezier_C, a = Number((n * i).toFixed(5));
                return r.push("q"), r.push("1 0 0 1 " + $020d60e69294d716$var$z($020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $020d60e69294d716$var$z($020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(n + " 0 m"), r.push(n + " " + a + " " + a + " " + n + " 0 " + n + " c"), r.push("-" + a + " " + n + " -" + n + " " + a + " -" + n + " 0 c"), r.push("-" + n + " -" + a + " -" + a + " -" + n + " 0 -" + n + " c"), r.push(a + " -" + n + " " + n + " -" + a + " " + n + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = $020d60e69294d716$var$V(t);
                e.scope = t.scope;
                var r = [], n = $020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t) <= $020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t) ? $020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t) / 4 : $020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var i = Number((2 * n).toFixed(5)), a = Number((i * $020d60e69294d716$export$7d753ad993606f45.internal.Bezier_C).toFixed(5)), o = Number((n * $020d60e69294d716$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return r.push("0.749023 g"), r.push("q"), r.push("1 0 0 1 " + $020d60e69294d716$var$z($020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $020d60e69294d716$var$z($020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(i + " 0 m"), r.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), r.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), r.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), r.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), r.push("f"), r.push("Q"), r.push("0 g"), r.push("q"), r.push("1 0 0 1 " + $020d60e69294d716$var$z($020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $020d60e69294d716$var$z($020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(n + " 0 m"), r.push(n + " " + o + " " + o + " " + n + " 0 " + n + " c"), r.push("-" + o + " " + n + " -" + n + " " + o + " -" + n + " 0 c"), r.push("-" + n + " -" + o + " -" + o + " -" + n + " 0 -" + n + " c"), r.push(o + " -" + n + " " + n + " -" + o + " " + n + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = $020d60e69294d716$var$V(t);
                e.scope = t.scope;
                var r = [], n = $020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t) <= $020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t) ? $020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t) / 4 : $020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var i = Number((2 * n).toFixed(5)), a = Number((i * $020d60e69294d716$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return r.push("0.749023 g"), r.push("q"), r.push("1 0 0 1 " + $020d60e69294d716$var$z($020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $020d60e69294d716$var$z($020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(i + " 0 m"), r.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), r.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), r.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), r.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            }
        },
        Cross: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: $020d60e69294d716$export$7d753ad993606f45.RadioButton.Cross.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $020d60e69294d716$export$7d753ad993606f45.RadioButton.Cross.YesNormal, e.D[t] = $020d60e69294d716$export$7d753ad993606f45.RadioButton.Cross.YesPushDown, e;
            },
            getCA: function() {
                return "8";
            },
            YesNormal: function(t) {
                var e = $020d60e69294d716$var$V(t);
                e.scope = t.scope;
                var r = [], n = $020d60e69294d716$export$7d753ad993606f45.internal.calculateCross(t);
                return r.push("q"), r.push("1 1 " + $020d60e69294d716$var$U($020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $020d60e69294d716$var$U($020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), r.push("W"), r.push("n"), r.push($020d60e69294d716$var$U(n.x1.x) + " " + $020d60e69294d716$var$U(n.x1.y) + " m"), r.push($020d60e69294d716$var$U(n.x2.x) + " " + $020d60e69294d716$var$U(n.x2.y) + " l"), r.push($020d60e69294d716$var$U(n.x4.x) + " " + $020d60e69294d716$var$U(n.x4.y) + " m"), r.push($020d60e69294d716$var$U(n.x3.x) + " " + $020d60e69294d716$var$U(n.x3.y) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = $020d60e69294d716$var$V(t);
                e.scope = t.scope;
                var r = $020d60e69294d716$export$7d753ad993606f45.internal.calculateCross(t), n = [];
                return n.push("0.749023 g"), n.push("0 0 " + $020d60e69294d716$var$U($020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t)) + " " + $020d60e69294d716$var$U($020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t)) + " re"), n.push("f"), n.push("q"), n.push("1 1 " + $020d60e69294d716$var$U($020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $020d60e69294d716$var$U($020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), n.push("W"), n.push("n"), n.push($020d60e69294d716$var$U(r.x1.x) + " " + $020d60e69294d716$var$U(r.x1.y) + " m"), n.push($020d60e69294d716$var$U(r.x2.x) + " " + $020d60e69294d716$var$U(r.x2.y) + " l"), n.push($020d60e69294d716$var$U(r.x4.x) + " " + $020d60e69294d716$var$U(r.x4.y) + " m"), n.push($020d60e69294d716$var$U(r.x3.x) + " " + $020d60e69294d716$var$U(r.x3.y) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = $020d60e69294d716$var$V(t);
                e.scope = t.scope;
                var r = [];
                return r.push("0.749023 g"), r.push("0 0 " + $020d60e69294d716$var$U($020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t)) + " " + $020d60e69294d716$var$U($020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), e.stream = r.join("\n"), e;
            }
        }
    },
    createDefaultAppearanceStream: function(t) {
        var e = t.scope.internal.getFont(t.fontName, t.fontStyle).id, r = t.scope.__private__.encodeColorString(t.color);
        return "/" + e + " " + t.fontSize + " Tf " + r;
    }
};
$020d60e69294d716$export$7d753ad993606f45.internal = {
    Bezier_C: .551915024494,
    calculateCross: function(t) {
        var e = $020d60e69294d716$export$7d753ad993606f45.internal.getWidth(t), r = $020d60e69294d716$export$7d753ad993606f45.internal.getHeight(t), n = Math.min(e, r);
        return {
            x1: {
                x: (e - n) / 2,
                y: (r - n) / 2 + n
            },
            x2: {
                x: (e - n) / 2 + n,
                y: (r - n) / 2
            },
            x3: {
                x: (e - n) / 2,
                y: (r - n) / 2
            },
            x4: {
                x: (e - n) / 2 + n,
                y: (r - n) / 2 + n
            }
        };
    }
}, $020d60e69294d716$export$7d753ad993606f45.internal.getWidth = function(e) {
    var r = 0;
    return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(e) && (r = $020d60e69294d716$var$W(e.Rect[2])), r;
}, $020d60e69294d716$export$7d753ad993606f45.internal.getHeight = function(e) {
    var r = 0;
    return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(e) && (r = $020d60e69294d716$var$W(e.Rect[3])), r;
};
var $020d60e69294d716$var$xt = $020d60e69294d716$var$q.addField = function(t) {
    if ($020d60e69294d716$var$at(this, t), !(t instanceof $020d60e69294d716$var$lt)) throw new Error("Invalid argument passed to jsPDF.addField.");
    var e;
    return (e = t).scope.internal.acroformPlugin.printedOut && (e.scope.internal.acroformPlugin.printedOut = !1, e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e), t.page = t.scope.internal.getCurrentPageInfo().pageNumber, this;
};
$020d60e69294d716$var$q.AcroFormChoiceField = $020d60e69294d716$export$a47202eb3f827bb2, $020d60e69294d716$var$q.AcroFormListBox = $020d60e69294d716$export$9e021dd9568dc486, $020d60e69294d716$var$q.AcroFormComboBox = $020d60e69294d716$export$f2239d28df5f43bd, $020d60e69294d716$var$q.AcroFormEditBox = $020d60e69294d716$export$4af052e7e598ad1a, $020d60e69294d716$var$q.AcroFormButton = $020d60e69294d716$export$6aae594af76bbb7b, $020d60e69294d716$var$q.AcroFormPushButton = $020d60e69294d716$export$98b7c3ef37465410, $020d60e69294d716$var$q.AcroFormRadioButton = $020d60e69294d716$export$bc1318bc7e5f1315, $020d60e69294d716$var$q.AcroFormCheckBox = $020d60e69294d716$export$5fd5db01c4615478, $020d60e69294d716$var$q.AcroFormTextField = $020d60e69294d716$export$9d1b52e7fab50c84, $020d60e69294d716$var$q.AcroFormPasswordField = $020d60e69294d716$export$c48d8668f8cea64d, $020d60e69294d716$var$q.AcroFormAppearance = $020d60e69294d716$export$7d753ad993606f45, $020d60e69294d716$var$q.AcroForm = {
    ChoiceField: $020d60e69294d716$export$a47202eb3f827bb2,
    ListBox: $020d60e69294d716$export$9e021dd9568dc486,
    ComboBox: $020d60e69294d716$export$f2239d28df5f43bd,
    EditBox: $020d60e69294d716$export$4af052e7e598ad1a,
    Button: $020d60e69294d716$export$6aae594af76bbb7b,
    PushButton: $020d60e69294d716$export$98b7c3ef37465410,
    RadioButton: $020d60e69294d716$export$bc1318bc7e5f1315,
    CheckBox: $020d60e69294d716$export$5fd5db01c4615478,
    TextField: $020d60e69294d716$export$9d1b52e7fab50c84,
    PasswordField: $020d60e69294d716$export$c48d8668f8cea64d,
    Appearance: $020d60e69294d716$export$7d753ad993606f45
}, $020d60e69294d716$export$ba1e2ffc633a60f5.AcroForm = {
    ChoiceField: $020d60e69294d716$export$a47202eb3f827bb2,
    ListBox: $020d60e69294d716$export$9e021dd9568dc486,
    ComboBox: $020d60e69294d716$export$f2239d28df5f43bd,
    EditBox: $020d60e69294d716$export$4af052e7e598ad1a,
    Button: $020d60e69294d716$export$6aae594af76bbb7b,
    PushButton: $020d60e69294d716$export$98b7c3ef37465410,
    RadioButton: $020d60e69294d716$export$bc1318bc7e5f1315,
    CheckBox: $020d60e69294d716$export$5fd5db01c4615478,
    TextField: $020d60e69294d716$export$9d1b52e7fab50c84,
    PasswordField: $020d60e69294d716$export$c48d8668f8cea64d,
    Appearance: $020d60e69294d716$export$7d753ad993606f45
};
var $020d60e69294d716$export$9cf40f67b77f45f4 = $020d60e69294d716$export$ba1e2ffc633a60f5.AcroForm;
function $020d60e69294d716$var$_t(t) {
    return t.reduce(function(t, e, r) {
        return t[e] = r, t;
    }, {});
}
!function(e) {
    e.__addimage__ = {};
    var r = "UNKNOWN", n = {
        PNG: [
            [
                137,
                80,
                78,
                71
            ]
        ],
        TIFF: [
            [
                77,
                77,
                0,
                42
            ],
            [
                73,
                73,
                42,
                0
            ]
        ],
        JPEG: [
            [
                255,
                216,
                255,
                224,
                void 0,
                void 0,
                74,
                70,
                73,
                70,
                0
            ],
            [
                255,
                216,
                255,
                225,
                void 0,
                void 0,
                69,
                120,
                105,
                102,
                0,
                0
            ],
            [
                255,
                216,
                255,
                219
            ],
            [
                255,
                216,
                255,
                238
            ]
        ],
        JPEG2000: [
            [
                0,
                0,
                0,
                12,
                106,
                80,
                32,
                32
            ]
        ],
        GIF87a: [
            [
                71,
                73,
                70,
                56,
                55,
                97
            ]
        ],
        GIF89a: [
            [
                71,
                73,
                70,
                56,
                57,
                97
            ]
        ],
        WEBP: [
            [
                82,
                73,
                70,
                70,
                void 0,
                void 0,
                void 0,
                void 0,
                87,
                69,
                66,
                80
            ]
        ],
        BMP: [
            [
                66,
                77
            ],
            [
                66,
                65
            ],
            [
                67,
                73
            ],
            [
                67,
                80
            ],
            [
                73,
                67
            ],
            [
                80,
                84
            ]
        ]
    }, i = e.__addimage__.getImageFileTypeByImageData = function(t, e) {
        var i, a, o, s, c, u = r;
        if ("RGBA" === (e = e || r) || void 0 !== t.data && t.data instanceof Uint8ClampedArray && "height" in t && "width" in t) return "RGBA";
        if (x(t)) for(c in n)for(o = n[c], i = 0; i < o.length; i += 1){
            for(s = !0, a = 0; a < o[i].length; a += 1)if (void 0 !== o[i][a] && o[i][a] !== t[a]) {
                s = !1;
                break;
            }
            if (!0 === s) {
                u = c;
                break;
            }
        }
        else for(c in n)for(o = n[c], i = 0; i < o.length; i += 1){
            for(s = !0, a = 0; a < o[i].length; a += 1)if (void 0 !== o[i][a] && o[i][a] !== t.charCodeAt(a)) {
                s = !1;
                break;
            }
            if (!0 === s) {
                u = c;
                break;
            }
        }
        return u === r && e !== r && (u = e), u;
    }, a = function t(e) {
        for(var r = this.internal.write, n = this.internal.putStream, i = (0, this.internal.getFilters)(); -1 !== i.indexOf("FlateEncode");)i.splice(i.indexOf("FlateEncode"), 1);
        e.objectId = this.internal.newObject();
        var a = [];
        if (a.push({
            key: "Type",
            value: "/XObject"
        }), a.push({
            key: "Subtype",
            value: "/Image"
        }), a.push({
            key: "Width",
            value: e.width
        }), a.push({
            key: "Height",
            value: e.height
        }), e.colorSpace === b.INDEXED ? a.push({
            key: "ColorSpace",
            value: "[/Indexed /DeviceRGB " + (e.palette.length / 3 - 1) + " " + ("sMask" in e && void 0 !== e.sMask ? e.objectId + 2 : e.objectId + 1) + " 0 R]"
        }) : (a.push({
            key: "ColorSpace",
            value: "/" + e.colorSpace
        }), e.colorSpace === b.DEVICE_CMYK && a.push({
            key: "Decode",
            value: "[1 0 1 0 1 0 1 0]"
        })), a.push({
            key: "BitsPerComponent",
            value: e.bitsPerComponent
        }), "decodeParameters" in e && void 0 !== e.decodeParameters && a.push({
            key: "DecodeParms",
            value: "<<" + e.decodeParameters + ">>"
        }), "transparency" in e && Array.isArray(e.transparency)) {
            for(var o = "", s = 0, c = e.transparency.length; s < c; s++)o += e.transparency[s] + " " + e.transparency[s] + " ";
            a.push({
                key: "Mask",
                value: "[" + o + "]"
            });
        }
        void 0 !== e.sMask && a.push({
            key: "SMask",
            value: e.objectId + 1 + " 0 R"
        });
        var u = void 0 !== e.filter ? [
            "/" + e.filter
        ] : void 0;
        if (n({
            data: e.data,
            additionalKeyValues: a,
            alreadyAppliedFilters: u,
            objectId: e.objectId
        }), r("endobj"), "sMask" in e && void 0 !== e.sMask) {
            var h = "/Predictor " + e.predictor + " /Colors 1 /BitsPerComponent " + e.bitsPerComponent + " /Columns " + e.width, l = {
                width: e.width,
                height: e.height,
                colorSpace: "DeviceGray",
                bitsPerComponent: e.bitsPerComponent,
                decodeParameters: h,
                data: e.sMask
            };
            "filter" in e && (l.filter = e.filter), t.call(this, l);
        }
        if (e.colorSpace === b.INDEXED) {
            var f = this.internal.newObject();
            n({
                data: _(new Uint8Array(e.palette)),
                objectId: f
            }), r("endobj");
        }
    }, o = function() {
        var t = this.internal.collections.addImage_images;
        for(var e in t)a.call(this, t[e]);
    }, s = function() {
        var t, e = this.internal.collections.addImage_images, r = this.internal.write;
        for(var n in e)r("/I" + (t = e[n]).index, t.objectId, "0", "R");
    }, c = function() {
        this.internal.collections.addImage_images || (this.internal.collections.addImage_images = {}, this.internal.events.subscribe("putResources", o), this.internal.events.subscribe("putXobjectDict", s));
    }, h = function() {
        var t = this.internal.collections.addImage_images;
        return c.call(this), t;
    }, l = function() {
        return Object.keys(this.internal.collections.addImage_images).length;
    }, f = function(t) {
        return "function" == typeof e["process" + t.toUpperCase()];
    }, d = function(e) {
        return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(e) && 1 === e.nodeType;
    }, p = function(t, r) {
        if ("IMG" === t.nodeName && t.hasAttribute("src")) {
            var n = "" + t.getAttribute("src");
            if (0 === n.indexOf("data:image/")) return $020d60e69294d716$var$u(unescape(n).split("base64,").pop());
            var i = e.loadFile(n, !0);
            if (void 0 !== i) return i;
        }
        if ("CANVAS" === t.nodeName) {
            if (0 === t.width || 0 === t.height) throw new Error("Given canvas must have data. Canvas width: " + t.width + ", height: " + t.height);
            var a;
            switch(r){
                case "PNG":
                    a = "image/png";
                    break;
                case "WEBP":
                    a = "image/webp";
                    break;
                case "JPEG":
                case "JPG":
                default:
                    a = "image/jpeg";
            }
            return $020d60e69294d716$var$u(t.toDataURL(a, 1).split("base64,").pop());
        }
    }, g = function(t) {
        var e = this.internal.collections.addImage_images;
        if (e) {
            for(var r in e)if (t === e[r].alias) return e[r];
        }
    }, m = function(t, e, r) {
        return t || e || (t = -96, e = -96), t < 0 && (t = -1 * r.width * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * r.height * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * r.width / r.height), 0 === e && (e = t * r.height / r.width), [
            t,
            e
        ];
    }, v = function(t, e, r, n, i, a) {
        var o = m.call(this, r, n, i), s = this.internal.getCoordinateString, c = this.internal.getVerticalCoordinateString, u = h.call(this);
        if (r = o[0], n = o[1], u[i.index] = i, a) {
            a *= Math.PI / 180;
            var l = Math.cos(a), f = Math.sin(a), d = function(t) {
                return t.toFixed(4);
            }, p = [
                d(l),
                d(f),
                d(-1 * f),
                d(l),
                0,
                0,
                "cm"
            ];
        }
        this.internal.write("q"), a ? (this.internal.write([
            1,
            "0",
            "0",
            1,
            s(t),
            c(e + n),
            "cm"
        ].join(" ")), this.internal.write(p.join(" ")), this.internal.write([
            s(r),
            "0",
            "0",
            s(n),
            "0",
            "0",
            "cm"
        ].join(" "))) : this.internal.write([
            s(r),
            "0",
            "0",
            s(n),
            s(t),
            c(e + n),
            "cm"
        ].join(" ")), this.isAdvancedAPI() && this.internal.write([
            1,
            0,
            0,
            -1,
            0,
            0,
            "cm"
        ].join(" ")), this.internal.write("/I" + i.index + " Do"), this.internal.write("Q");
    }, b = e.color_spaces = {
        DEVICE_RGB: "DeviceRGB",
        DEVICE_GRAY: "DeviceGray",
        DEVICE_CMYK: "DeviceCMYK",
        CAL_GREY: "CalGray",
        CAL_RGB: "CalRGB",
        LAB: "Lab",
        ICC_BASED: "ICCBased",
        INDEXED: "Indexed",
        PATTERN: "Pattern",
        SEPARATION: "Separation",
        DEVICE_N: "DeviceN"
    };
    e.decode = {
        DCT_DECODE: "DCTDecode",
        FLATE_DECODE: "FlateDecode",
        LZW_DECODE: "LZWDecode",
        JPX_DECODE: "JPXDecode",
        JBIG2_DECODE: "JBIG2Decode",
        ASCII85_DECODE: "ASCII85Decode",
        ASCII_HEX_DECODE: "ASCIIHexDecode",
        RUN_LENGTH_DECODE: "RunLengthDecode",
        CCITT_FAX_DECODE: "CCITTFaxDecode"
    };
    var y = e.image_compression = {
        NONE: "NONE",
        FAST: "FAST",
        MEDIUM: "MEDIUM",
        SLOW: "SLOW"
    }, w = e.__addimage__.sHashCode = function(t) {
        var e, r, n = 0;
        if ("string" == typeof t) for(r = t.length, e = 0; e < r; e++)n = (n << 5) - n + t.charCodeAt(e), n |= 0;
        else if (x(t)) for(r = t.byteLength / 2, e = 0; e < r; e++)n = (n << 5) - n + t[e], n |= 0;
        return n;
    }, N = e.__addimage__.validateStringAsBase64 = function(t) {
        (t = t || "").toString().trim();
        var e = !0;
        return 0 === t.length && (e = !1), t.length % 4 != 0 && (e = !1), !1 === /^[A-Za-z0-9+/]+$/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2)) && (e = !1), e;
    }, L = e.__addimage__.extractImageFromDataUrl = function(t) {
        var e = (t = t || "").split("base64,"), r = null;
        if (2 === e.length) {
            var n = /^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(e[0]);
            Array.isArray(n) && (r = {
                mimeType: n[1],
                charset: n[2],
                data: e[1]
            });
        }
        return r;
    }, A = e.__addimage__.supportsArrayBuffer = function() {
        return "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array;
    };
    e.__addimage__.isArrayBuffer = function(t) {
        return A() && t instanceof ArrayBuffer;
    };
    var x = e.__addimage__.isArrayBufferView = function(t) {
        return A() && "undefined" != typeof Uint32Array && (t instanceof Int8Array || t instanceof Uint8Array || "undefined" != typeof Uint8ClampedArray && t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array);
    }, S = e.__addimage__.binaryStringToUint8Array = function(t) {
        for(var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++)r[n] = t.charCodeAt(n);
        return r;
    }, _ = e.__addimage__.arrayBufferToBinaryString = function(t) {
        for(var e = "", r = x(t) ? t : new Uint8Array(t), n = 0; n < r.length; n += 8192)e += String.fromCharCode.apply(null, r.subarray(n, n + 8192));
        return e;
    };
    e.addImage = function() {
        var e, n, i, a, o, s, u, h, l;
        if ("number" == typeof arguments[1] ? (n = r, i = arguments[1], a = arguments[2], o = arguments[3], s = arguments[4], u = arguments[5], h = arguments[6], l = arguments[7]) : (n = arguments[1], i = arguments[2], a = arguments[3], o = arguments[4], s = arguments[5], u = arguments[6], h = arguments[7], l = arguments[8]), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(e = arguments[0]) && !d(e) && "imageData" in e) {
            var f = e;
            e = f.imageData, n = f.format || n || r, i = f.x || i || 0, a = f.y || a || 0, o = f.w || f.width || o, s = f.h || f.height || s, u = f.alias || u, h = f.compression || h, l = f.rotation || f.angle || l;
        }
        var p = this.internal.getFilters();
        if (void 0 === h && -1 !== p.indexOf("FlateEncode") && (h = "SLOW"), isNaN(i) || isNaN(a)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
        c.call(this);
        var g = P.call(this, e, n, u, h);
        return v.call(this, i, a, o, s, g, l), this;
    };
    var P = function(t, n, a, o) {
        var s, c, u;
        if ("string" == typeof t && i(t) === r) {
            t = unescape(t);
            var h = k(t, !1);
            ("" !== h || void 0 !== (h = e.loadFile(t, !0))) && (t = h);
        }
        if (d(t) && (t = p(t, n)), n = i(t, n), !f(n)) throw new Error("addImage does not support files of type '" + n + "', please ensure that a plugin for '" + n + "' support is added.");
        if ((null == (u = a) || 0 === u.length) && (a = function(t) {
            return "string" == typeof t || x(t) ? w(t) : x(t.data) ? w(t.data) : null;
        }(t)), (s = g.call(this, a)) || (A() && (t instanceof Uint8Array || "RGBA" === n || (c = t, t = S(t))), s = this["process" + n.toUpperCase()](t, l.call(this), a, function(t) {
            return t && "string" == typeof t && (t = t.toUpperCase()), t in e.image_compression ? t : y.NONE;
        }(o), c)), !s) throw new Error("An unknown error occurred whilst processing the image.");
        return s;
    }, k = e.__addimage__.convertBase64ToBinaryString = function(t, e) {
        var r;
        e = "boolean" != typeof e || e;
        var n, i = "";
        if ("string" == typeof t) {
            n = null !== (r = L(t)) ? r.data : t;
            try {
                i = $020d60e69294d716$var$u(n);
            } catch (t) {
                if (e) throw N(n) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + t.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
            }
        }
        return i;
    };
    e.getImageProperties = function(t) {
        var n, a, o = "";
        if (d(t) && (t = p(t)), "string" == typeof t && i(t) === r && ("" === (o = k(t, !1)) && (o = e.loadFile(t) || ""), t = o), a = i(t), !f(a)) throw new Error("addImage does not support files of type '" + a + "', please ensure that a plugin for '" + a + "' support is added.");
        if (!A() || t instanceof Uint8Array || (t = S(t)), !(n = this["process" + a.toUpperCase()](t))) throw new Error("An unknown error occurred whilst processing the image");
        return n.fileType = a, n;
    };
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        if (void 0 !== t && "" != t) return !0;
    };
    $020d60e69294d716$export$ba1e2ffc633a60f5.API.events.push([
        "addPage",
        function(t) {
            this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
        }
    ]), t.events.push([
        "putPage",
        function(t) {
            for(var r, n, i, a = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, s = this.internal.getPageInfoByObjId(t.objId), c = t.pageContext.annotations, u = !1, h = 0; h < c.length && !u; h++)switch((r = c[h]).type){
                case "link":
                    (e(r.options.url) || e(r.options.pageNumber)) && (u = !0);
                    break;
                case "reference":
                case "text":
                case "freetext":
                    u = !0;
            }
            if (0 != u) {
                this.internal.write("/Annots [");
                for(var l = 0; l < c.length; l++){
                    r = c[l];
                    var f = this.internal.pdfEscape, d = this.internal.getEncryptor(t.objId);
                    switch(r.type){
                        case "reference":
                            this.internal.write(" " + r.object.objId + " 0 R ");
                            break;
                        case "text":
                            var p = this.internal.newAdditionalObject(), g = this.internal.newAdditionalObject(), m = this.internal.getEncryptor(p.objId), v = r.title || "Note";
                            i = "<</Type /Annot /Subtype /Text " + (n = "/Rect [" + a(r.bounds.x) + " " + o(r.bounds.y + r.bounds.h) + " " + a(r.bounds.x + r.bounds.w) + " " + o(r.bounds.y) + "] ") + "/Contents (" + f(m(r.contents)) + ")", i += " /Popup " + g.objId + " 0 R", i += " /P " + s.objId + " 0 R", i += " /T (" + f(m(v)) + ") >>", p.content = i;
                            var b = p.objId + " 0 R";
                            i = "<</Type /Annot /Subtype /Popup " + (n = "/Rect [" + a(r.bounds.x + 30) + " " + o(r.bounds.y + r.bounds.h) + " " + a(r.bounds.x + r.bounds.w + 30) + " " + o(r.bounds.y) + "] ") + " /Parent " + b, r.open && (i += " /Open true"), i += " >>", g.content = i, this.internal.write(p.objId, "0 R", g.objId, "0 R");
                            break;
                        case "freetext":
                            n = "/Rect [" + a(r.bounds.x) + " " + o(r.bounds.y) + " " + a(r.bounds.x + r.bounds.w) + " " + o(r.bounds.y + r.bounds.h) + "] ";
                            var y = r.color || "#000000";
                            i = "<</Type /Annot /Subtype /FreeText " + n + "/Contents (" + f(d(r.contents)) + ")", i += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + y + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
                            break;
                        case "link":
                            if (r.options.name) {
                                var w = this.annotations._nameMap[r.options.name];
                                r.options.pageNumber = w.page, r.options.top = w.y;
                            } else r.options.top || (r.options.top = 0);
                            if (n = "/Rect [" + r.finalBounds.x + " " + r.finalBounds.y + " " + r.finalBounds.w + " " + r.finalBounds.h + "] ", i = "", r.options.url) i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /A <</S /URI /URI (" + f(d(r.options.url)) + ") >>";
                            else if (r.options.pageNumber) switch(i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(r.options.pageNumber).objId + " 0 R", r.options.magFactor = r.options.magFactor || "XYZ", r.options.magFactor){
                                case "Fit":
                                    i += " /Fit]";
                                    break;
                                case "FitH":
                                    i += " /FitH " + r.options.top + "]";
                                    break;
                                case "FitV":
                                    r.options.left = r.options.left || 0, i += " /FitV " + r.options.left + "]";
                                    break;
                                case "XYZ":
                                default:
                                    var N = o(r.options.top);
                                    r.options.left = r.options.left || 0, void 0 === r.options.zoom && (r.options.zoom = 0), i += " /XYZ " + r.options.left + " " + N + " " + r.options.zoom + "]";
                            }
                            "" != i && (i += " >>", this.internal.write(i));
                    }
                }
                this.internal.write("]");
            }
        }
    ]), t.createAnnotation = function(t) {
        var e = this.internal.getCurrentPageInfo();
        switch(t.type){
            case "link":
                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                break;
            case "text":
            case "freetext":
                e.pageContext.annotations.push(t);
        }
    }, t.link = function(t, e, r, n, i) {
        var a = this.internal.getCurrentPageInfo(), o = this.internal.getCoordinateString, s = this.internal.getVerticalCoordinateString;
        a.pageContext.annotations.push({
            finalBounds: {
                x: o(t),
                y: s(e),
                w: o(t + r),
                h: s(e + n)
            },
            options: i,
            type: "link"
        });
    }, t.textWithLink = function(t, e, r, n) {
        var i, a, o = this.getTextWidth(t), s = this.internal.getLineHeight() / this.internal.scaleFactor;
        if (void 0 !== n.maxWidth) {
            a = n.maxWidth;
            var c = this.splitTextToSize(t, a).length;
            i = Math.ceil(s * c);
        } else a = o, i = s;
        return this.text(t, e, r, n), r += .2 * s, "center" === n.align && (e -= o / 2), "right" === n.align && (e -= o), this.link(e, r - s, a, i, n), o;
    }, t.getTextWidth = function(t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    };
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = {
        1569: [
            65152
        ],
        1570: [
            65153,
            65154
        ],
        1571: [
            65155,
            65156
        ],
        1572: [
            65157,
            65158
        ],
        1573: [
            65159,
            65160
        ],
        1574: [
            65161,
            65162,
            65163,
            65164
        ],
        1575: [
            65165,
            65166
        ],
        1576: [
            65167,
            65168,
            65169,
            65170
        ],
        1577: [
            65171,
            65172
        ],
        1578: [
            65173,
            65174,
            65175,
            65176
        ],
        1579: [
            65177,
            65178,
            65179,
            65180
        ],
        1580: [
            65181,
            65182,
            65183,
            65184
        ],
        1581: [
            65185,
            65186,
            65187,
            65188
        ],
        1582: [
            65189,
            65190,
            65191,
            65192
        ],
        1583: [
            65193,
            65194
        ],
        1584: [
            65195,
            65196
        ],
        1585: [
            65197,
            65198
        ],
        1586: [
            65199,
            65200
        ],
        1587: [
            65201,
            65202,
            65203,
            65204
        ],
        1588: [
            65205,
            65206,
            65207,
            65208
        ],
        1589: [
            65209,
            65210,
            65211,
            65212
        ],
        1590: [
            65213,
            65214,
            65215,
            65216
        ],
        1591: [
            65217,
            65218,
            65219,
            65220
        ],
        1592: [
            65221,
            65222,
            65223,
            65224
        ],
        1593: [
            65225,
            65226,
            65227,
            65228
        ],
        1594: [
            65229,
            65230,
            65231,
            65232
        ],
        1601: [
            65233,
            65234,
            65235,
            65236
        ],
        1602: [
            65237,
            65238,
            65239,
            65240
        ],
        1603: [
            65241,
            65242,
            65243,
            65244
        ],
        1604: [
            65245,
            65246,
            65247,
            65248
        ],
        1605: [
            65249,
            65250,
            65251,
            65252
        ],
        1606: [
            65253,
            65254,
            65255,
            65256
        ],
        1607: [
            65257,
            65258,
            65259,
            65260
        ],
        1608: [
            65261,
            65262
        ],
        1609: [
            65263,
            65264,
            64488,
            64489
        ],
        1610: [
            65265,
            65266,
            65267,
            65268
        ],
        1649: [
            64336,
            64337
        ],
        1655: [
            64477
        ],
        1657: [
            64358,
            64359,
            64360,
            64361
        ],
        1658: [
            64350,
            64351,
            64352,
            64353
        ],
        1659: [
            64338,
            64339,
            64340,
            64341
        ],
        1662: [
            64342,
            64343,
            64344,
            64345
        ],
        1663: [
            64354,
            64355,
            64356,
            64357
        ],
        1664: [
            64346,
            64347,
            64348,
            64349
        ],
        1667: [
            64374,
            64375,
            64376,
            64377
        ],
        1668: [
            64370,
            64371,
            64372,
            64373
        ],
        1670: [
            64378,
            64379,
            64380,
            64381
        ],
        1671: [
            64382,
            64383,
            64384,
            64385
        ],
        1672: [
            64392,
            64393
        ],
        1676: [
            64388,
            64389
        ],
        1677: [
            64386,
            64387
        ],
        1678: [
            64390,
            64391
        ],
        1681: [
            64396,
            64397
        ],
        1688: [
            64394,
            64395
        ],
        1700: [
            64362,
            64363,
            64364,
            64365
        ],
        1702: [
            64366,
            64367,
            64368,
            64369
        ],
        1705: [
            64398,
            64399,
            64400,
            64401
        ],
        1709: [
            64467,
            64468,
            64469,
            64470
        ],
        1711: [
            64402,
            64403,
            64404,
            64405
        ],
        1713: [
            64410,
            64411,
            64412,
            64413
        ],
        1715: [
            64406,
            64407,
            64408,
            64409
        ],
        1722: [
            64414,
            64415
        ],
        1723: [
            64416,
            64417,
            64418,
            64419
        ],
        1726: [
            64426,
            64427,
            64428,
            64429
        ],
        1728: [
            64420,
            64421
        ],
        1729: [
            64422,
            64423,
            64424,
            64425
        ],
        1733: [
            64480,
            64481
        ],
        1734: [
            64473,
            64474
        ],
        1735: [
            64471,
            64472
        ],
        1736: [
            64475,
            64476
        ],
        1737: [
            64482,
            64483
        ],
        1739: [
            64478,
            64479
        ],
        1740: [
            64508,
            64509,
            64510,
            64511
        ],
        1744: [
            64484,
            64485,
            64486,
            64487
        ],
        1746: [
            64430,
            64431
        ],
        1747: [
            64432,
            64433
        ]
    }, r = {
        65247: {
            65154: 65269,
            65156: 65271,
            65160: 65273,
            65166: 65275
        },
        65248: {
            65154: 65270,
            65156: 65272,
            65160: 65274,
            65166: 65276
        },
        65165: {
            65247: {
                65248: {
                    65258: 65010
                }
            }
        },
        1617: {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
        }
    }, n = {
        1612: 64606,
        1613: 64607,
        1614: 64608,
        1615: 64609,
        1616: 64610
    }, i = [
        1570,
        1571,
        1573,
        1575
    ];
    t.__arabicParser__ = {};
    var a = t.__arabicParser__.isInArabicSubstitutionA = function(t) {
        return void 0 !== e[t.charCodeAt(0)];
    }, o = t.__arabicParser__.isArabicLetter = function(t) {
        return "string" == typeof t && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t);
    }, s = t.__arabicParser__.isArabicEndLetter = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length <= 2;
    }, c = t.__arabicParser__.isArabicAlfLetter = function(t) {
        return o(t) && i.indexOf(t.charCodeAt(0)) >= 0;
    };
    t.__arabicParser__.arabicLetterHasIsolatedForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 1;
    };
    var u = t.__arabicParser__.arabicLetterHasFinalForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 2;
    };
    t.__arabicParser__.arabicLetterHasInitialForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 3;
    };
    var h = t.__arabicParser__.arabicLetterHasMedialForm = function(t) {
        return o(t) && a(t) && 4 == e[t.charCodeAt(0)].length;
    }, l = t.__arabicParser__.resolveLigatures = function(t) {
        var e = 0, n = r, i = "", a = 0;
        for(e = 0; e < t.length; e += 1)void 0 !== n[t.charCodeAt(e)] ? (a++, "number" == typeof (n = n[t.charCodeAt(e)]) && (i += String.fromCharCode(n), n = r, a = 0), e === t.length - 1 && (n = r, i += t.charAt(e - (a - 1)), e -= a - 1, a = 0)) : (n = r, i += t.charAt(e - a), e -= a, a = 0);
        return i;
    };
    t.__arabicParser__.isArabicDiacritic = function(t) {
        return void 0 !== t && void 0 !== n[t.charCodeAt(0)];
    };
    var f = t.__arabicParser__.getCorrectForm = function(t, e, r) {
        return o(t) ? !1 === a(t) ? -1 : !u(t) || !o(e) && !o(r) || !o(r) && s(e) || s(t) && !o(e) || s(t) && c(e) || s(t) && s(e) ? 0 : h(t) && o(e) && !s(e) && o(r) && u(r) ? 3 : s(t) || !o(r) ? 1 : 2 : -1;
    }, d = function(t) {
        var r = 0, n = 0, i = 0, a = "", s = "", c = "", u = (t = t || "").split("\\s+"), h = [];
        for(r = 0; r < u.length; r += 1){
            for(h.push(""), n = 0; n < u[r].length; n += 1)a = u[r][n], s = u[r][n - 1], c = u[r][n + 1], o(a) ? (i = f(a, s, c), h[r] += -1 !== i ? String.fromCharCode(e[a.charCodeAt(0)][i]) : a) : h[r] += a;
            h[r] = l(h[r]);
        }
        return h.join(" ");
    }, p = t.__arabicParser__.processArabic = t.processArabic = function() {
        var t, e = "string" == typeof arguments[0] ? arguments[0] : arguments[0].text, r = [];
        if (Array.isArray(e)) {
            var n = 0;
            for(r = [], n = 0; n < e.length; n += 1)Array.isArray(e[n]) ? r.push([
                d(e[n][0]),
                e[n][1],
                e[n][2]
            ]) : r.push([
                d(e[n])
            ]);
            t = r;
        } else t = d(e);
        return "string" == typeof arguments[0] ? t : (arguments[0].text = t, arguments[0]);
    };
    t.events.push([
        "preProcessText",
        p
    ]);
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), $020d60e69294d716$export$ba1e2ffc633a60f5.API.autoPrint = function(t) {
    var e;
    switch((t = t || {}).variant = t.variant || "non-conform", t.variant){
        case "javascript":
            this.addJS("print({});");
            break;
        case "non-conform":
        default:
            this.internal.events.subscribe("postPutResources", function() {
                e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
            }), this.internal.events.subscribe("putCatalog", function() {
                this.internal.out("/OpenAction " + e + " 0 R");
            });
    }
    return this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        var t = void 0;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = 150;
        Object.defineProperty(this, "width", {
            get: function() {
                return e;
            },
            set: function(t) {
                e = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 150 : t, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = e + 1);
            }
        });
        var r = 300;
        Object.defineProperty(this, "height", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 300 : t, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = r + 1);
            }
        });
        var n = [];
        Object.defineProperty(this, "childNodes", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = t;
            }
        });
        var i = {};
        Object.defineProperty(this, "style", {
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        }), Object.defineProperty(this, "parentNode", {});
    };
    e.prototype.getContext = function(t, e) {
        var r;
        if ("2d" !== (t = t || "2d")) return null;
        for(r in e)this.pdf.context2d.hasOwnProperty(r) && (this.pdf.context2d[r] = e[r]);
        return this.pdf.context2d._canvas = this, this.pdf.context2d;
    }, e.prototype.toDataURL = function() {
        throw new Error("toDataURL is not implemented.");
    }, t.events.push([
        "initialized",
        function() {
            this.canvas = new e, this.canvas.pdf = this;
        }
    ]);
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), function(e) {
    var r = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
    }, n = !1, i = function() {
        void 0 === this.internal.__cell__ && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, r), this.internal.__cell__.margins.width = this.getPageWidth(), a.call(this));
    }, a = function() {
        this.internal.__cell__.lastCell = new o, this.internal.__cell__.pages = 1;
    }, o = function() {
        var t = arguments[0];
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = arguments[1];
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return e;
            },
            set: function(t) {
                e = t;
            }
        });
        var r = arguments[2];
        Object.defineProperty(this, "width", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                r = t;
            }
        });
        var n = arguments[3];
        Object.defineProperty(this, "height", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                n = t;
            }
        });
        var i = arguments[4];
        Object.defineProperty(this, "text", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        });
        var a = arguments[5];
        Object.defineProperty(this, "lineNumber", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                a = t;
            }
        });
        var o = arguments[6];
        return Object.defineProperty(this, "align", {
            enumerable: !0,
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        }), this;
    };
    o.prototype.clone = function() {
        return new o(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
    }, o.prototype.toArray = function() {
        return [
            this.x,
            this.y,
            this.width,
            this.height,
            this.text,
            this.lineNumber,
            this.align
        ];
    }, e.setHeaderFunction = function(t) {
        return i.call(this), this.internal.__cell__.headerFunction = "function" == typeof t ? t : void 0, this;
    }, e.getTextDimensions = function(t, e) {
        i.call(this);
        var r = (e = e || {}).fontSize || this.getFontSize(), n = e.font || this.getFont(), a = e.scaleFactor || this.internal.scaleFactor, o = 0, s = 0, c = 0, u = this;
        if (!Array.isArray(t) && "string" != typeof t) {
            if ("number" != typeof t) throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
            t = String(t);
        }
        var h = e.maxWidth;
        h > 0 ? "string" == typeof t ? t = this.splitTextToSize(t, h) : "[object Array]" === Object.prototype.toString.call(t) && (t = t.reduce(function(t, e) {
            return t.concat(u.splitTextToSize(e, h));
        }, [])) : t = Array.isArray(t) ? t : [
            t
        ];
        for(var l = 0; l < t.length; l++)o < (c = this.getStringUnitWidth(t[l], {
            font: n
        }) * r) && (o = c);
        return 0 !== o && (s = t.length), {
            w: o /= a,
            h: Math.max((s * r * this.getLineHeightFactor() - r * (this.getLineHeightFactor() - 1)) / a, 0)
        };
    }, e.cellAddPage = function() {
        i.call(this), this.addPage();
        var t = this.internal.__cell__.margins || r;
        return this.internal.__cell__.lastCell = new o(t.left, t.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
    };
    var s = e.cell = function() {
        var t;
        t = arguments[0] instanceof o ? arguments[0] : new o(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]), i.call(this);
        var e = this.internal.__cell__.lastCell, a = this.internal.__cell__.padding, s = this.internal.__cell__.margins || r, c = this.internal.__cell__.tableHeaderRow, u = this.internal.__cell__.printHeaders;
        return void 0 !== e.lineNumber && (e.lineNumber === t.lineNumber ? (t.x = (e.x || 0) + (e.width || 0), t.y = e.y || 0) : e.y + e.height + t.height + s.bottom > this.getPageHeight() ? (this.cellAddPage(), t.y = s.top, u && c && (this.printHeaderRow(t.lineNumber, !0), t.y += c[0].height)) : t.y = e.y + e.height || t.y), void 0 !== t.text[0] && (this.rect(t.x, t.y, t.width, t.height, !0 === n ? "FD" : void 0), "right" === t.align ? this.text(t.text, t.x + t.width - a, t.y + a, {
            align: "right",
            baseline: "top"
        }) : "center" === t.align ? this.text(t.text, t.x + t.width / 2, t.y + a, {
            align: "center",
            baseline: "top",
            maxWidth: t.width - a - a
        }) : this.text(t.text, t.x + a, t.y + a, {
            align: "left",
            baseline: "top",
            maxWidth: t.width - a - a
        })), this.internal.__cell__.lastCell = t, this;
    };
    e.table = function(e, n, u, h, l) {
        if (i.call(this), !u) throw new Error("No data for PDF table.");
        var f, d, p, g, m = [], v = [], b = [], y = {}, w = {}, N = [], L = [], A = (l = l || {}).autoSize || !1, x = !1 !== l.printHeaders, S = l.css && void 0 !== l.css["font-size"] ? 16 * l.css["font-size"] : l.fontSize || 12, _ = l.margins || Object.assign({
            width: this.getPageWidth()
        }, r), P = "number" == typeof l.padding ? l.padding : 3, k = l.headerBackgroundColor || "#c8c8c8", I = l.headerTextColor || "#000";
        if (a.call(this), this.internal.__cell__.printHeaders = x, this.internal.__cell__.margins = _, this.internal.__cell__.table_font_size = S, this.internal.__cell__.padding = P, this.internal.__cell__.headerBackgroundColor = k, this.internal.__cell__.headerTextColor = I, this.setFontSize(S), null == h) v = m = Object.keys(u[0]), b = m.map(function() {
            return "left";
        });
        else if (Array.isArray(h) && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(h[0])) for(m = h.map(function(t) {
            return t.name;
        }), v = h.map(function(t) {
            return t.prompt || t.name || "";
        }), b = h.map(function(t) {
            return t.align || "left";
        }), f = 0; f < h.length; f += 1)w[h[f].name] = h[f].width * (19.049976 / 25.4);
        else Array.isArray(h) && "string" == typeof h[0] && (v = m = h, b = m.map(function() {
            return "left";
        }));
        if (A || Array.isArray(h) && "string" == typeof h[0]) for(f = 0; f < m.length; f += 1){
            for(y[g = m[f]] = u.map(function(t) {
                return t[g];
            }), this.setFont(void 0, "bold"), N.push(this.getTextDimensions(v[f], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w), d = y[g], this.setFont(void 0, "normal"), p = 0; p < d.length; p += 1)N.push(this.getTextDimensions(d[p], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w);
            w[g] = Math.max.apply(null, N) + P + P, N = [];
        }
        if (x) {
            var F = {};
            for(f = 0; f < m.length; f += 1)F[m[f]] = {}, F[m[f]].text = v[f], F[m[f]].align = b[f];
            var C = c.call(this, F, w);
            L = m.map(function(t) {
                return new o(e, n, w[t], C, F[t].text, void 0, F[t].align);
            }), this.setTableHeaderRow(L), this.printHeaderRow(1, !1);
        }
        var j = h.reduce(function(t, e) {
            return t[e.name] = e.align, t;
        }, {});
        for(f = 0; f < u.length; f += 1){
            "rowStart" in l && l.rowStart instanceof Function && l.rowStart({
                row: f,
                data: u[f]
            }, this);
            var O = c.call(this, u[f], w);
            for(p = 0; p < m.length; p += 1){
                var B = u[f][m[p]];
                "cellStart" in l && l.cellStart instanceof Function && l.cellStart({
                    row: f,
                    col: p,
                    data: B
                }, this), s.call(this, new o(e, n, w[m[p]], O, B, f + 2, j[m[p]]));
            }
        }
        return this.internal.__cell__.table_x = e, this.internal.__cell__.table_y = n, this;
    };
    var c = function(t, e) {
        var r = this.internal.__cell__.padding, n = this.internal.__cell__.table_font_size, i = this.internal.scaleFactor;
        return Object.keys(t).map(function(n) {
            var i = t[n];
            return this.splitTextToSize(i.hasOwnProperty("text") ? i.text : i, e[n] - r - r);
        }, this).map(function(t) {
            return this.getLineHeightFactor() * t.length * n / i + r + r;
        }, this).reduce(function(t, e) {
            return Math.max(t, e);
        }, 0);
    };
    e.setTableHeaderRow = function(t) {
        i.call(this), this.internal.__cell__.tableHeaderRow = t;
    }, e.printHeaderRow = function(t, e) {
        if (i.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
        var r;
        if (n = !0, "function" == typeof this.internal.__cell__.headerFunction) {
            var a = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
            this.internal.__cell__.lastCell = new o(a[0], a[1], a[2], a[3], void 0, -1);
        }
        this.setFont(void 0, "bold");
        for(var c = [], u = 0; u < this.internal.__cell__.tableHeaderRow.length; u += 1){
            r = this.internal.__cell__.tableHeaderRow[u].clone(), e && (r.y = this.internal.__cell__.margins.top || 0, c.push(r)), r.lineNumber = t;
            var h = this.getTextColor();
            this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s.call(this, r), this.setTextColor(h);
        }
        c.length > 0 && this.setTableHeaderRow(c), this.setFont(void 0, "normal"), n = !1;
    };
}($020d60e69294d716$export$ba1e2ffc633a60f5.API);
var $020d60e69294d716$var$Pt = {
    italic: [
        "italic",
        "oblique",
        "normal"
    ],
    oblique: [
        "oblique",
        "italic",
        "normal"
    ],
    normal: [
        "normal",
        "oblique",
        "italic"
    ]
}, $020d60e69294d716$var$kt = [
    "ultra-condensed",
    "extra-condensed",
    "condensed",
    "semi-condensed",
    "normal",
    "semi-expanded",
    "expanded",
    "extra-expanded",
    "ultra-expanded"
], $020d60e69294d716$var$It = $020d60e69294d716$var$_t($020d60e69294d716$var$kt), $020d60e69294d716$var$Ft = [
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900
], $020d60e69294d716$var$Ct = $020d60e69294d716$var$_t($020d60e69294d716$var$Ft);
function $020d60e69294d716$var$jt(t) {
    var e = t.family.replace(/"|'/g, "").toLowerCase(), r = function(t) {
        return $020d60e69294d716$var$Pt[t = t || "normal"] ? t : "normal";
    }(t.style), n = function(t) {
        if (!t) return 400;
        if ("number" == typeof t) return t >= 100 && t <= 900 && t % 100 == 0 ? t : 400;
        if (/^\d00$/.test(t)) return parseInt(t);
        switch(t){
            case "bold":
                return 700;
            case "normal":
            default:
                return 400;
        }
    }(t.weight), i = function(t) {
        return "number" == typeof $020d60e69294d716$var$It[t = t || "normal"] ? t : "normal";
    }(t.stretch);
    return {
        family: e,
        style: r,
        weight: n,
        stretch: i,
        src: t.src || [],
        ref: t.ref || {
            name: e,
            style: [
                i,
                r,
                n
            ].join(" ")
        }
    };
}
function $020d60e69294d716$var$Ot(t, e, r, n) {
    var i;
    for(i = r; i >= 0 && i < e.length; i += n)if (t[e[i]]) return t[e[i]];
    for(i = r; i >= 0 && i < e.length; i -= n)if (t[e[i]]) return t[e[i]];
}
var $020d60e69294d716$var$Bt = {
    "sans-serif": "helvetica",
    fixed: "courier",
    monospace: "courier",
    terminal: "courier",
    cursive: "times",
    fantasy: "times",
    serif: "times"
}, $020d60e69294d716$var$Mt = {
    caption: "times",
    icon: "times",
    menu: "times",
    "message-box": "times",
    "small-caption": "times",
    "status-bar": "times"
};
function $020d60e69294d716$var$Et(t) {
    return [
        t.stretch,
        t.style,
        t.weight,
        t.family
    ].join(" ");
}
function $020d60e69294d716$var$qt(t, e, r) {
    for(var n = (r = r || {}).defaultFontFamily || "times", i = Object.assign({}, $020d60e69294d716$var$Bt, r.genericFontFamilies || {}), a = null, o = null, s = 0; s < e.length; ++s)if (i[(a = $020d60e69294d716$var$jt(e[s])).family] && (a.family = i[a.family]), t.hasOwnProperty(a.family)) {
        o = t[a.family];
        break;
    }
    if (!(o = o || t[n])) throw new Error("Could not find a font-family for the rule '" + $020d60e69294d716$var$Et(a) + "' and default family '" + n + "'.");
    if (o = function(t, e) {
        if (e[t]) return e[t];
        var r = $020d60e69294d716$var$It[t], n = r <= $020d60e69294d716$var$It.normal ? -1 : 1, i = $020d60e69294d716$var$Ot(e, $020d60e69294d716$var$kt, r, n);
        if (!i) throw new Error("Could not find a matching font-stretch value for " + t);
        return i;
    }(a.stretch, o), o = function(t, e) {
        if (e[t]) return e[t];
        for(var r = $020d60e69294d716$var$Pt[t], n = 0; n < r.length; ++n)if (e[r[n]]) return e[r[n]];
        throw new Error("Could not find a matching font-style for " + t);
    }(a.style, o), !(o = function(t, e) {
        if (e[t]) return e[t];
        if (400 === t && e[500]) return e[500];
        if (500 === t && e[400]) return e[400];
        var r = $020d60e69294d716$var$Ct[t], n = $020d60e69294d716$var$Ot(e, $020d60e69294d716$var$Ft, r, t < 400 ? -1 : 1);
        if (!n) throw new Error("Could not find a matching font-weight for value " + t);
        return n;
    }(a.weight, o))) throw new Error("Failed to resolve a font for the rule '" + $020d60e69294d716$var$Et(a) + "'.");
    return o;
}
function $020d60e69294d716$var$Dt(t) {
    return t.trimLeft();
}
function $020d60e69294d716$var$Rt(t, e) {
    for(var r = 0; r < t.length;){
        if (t.charAt(r) === e) return [
            t.substring(0, r),
            t.substring(r + 1)
        ];
        r += 1;
    }
    return null;
}
function $020d60e69294d716$var$Tt(t) {
    var e = t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
    return null === e ? null : [
        e[0],
        t.substring(e[0].length)
    ];
}
var $020d60e69294d716$var$Ut, $020d60e69294d716$var$zt, $020d60e69294d716$var$Ht, $020d60e69294d716$var$Wt = [
    "times"
];


!function(e) {
    var r, n, i, o, s, c, u, h, l, d = function(t) {
        return t = t || {}, this.isStrokeTransparent = t.isStrokeTransparent || !1, this.strokeOpacity = t.strokeOpacity || 1, this.strokeStyle = t.strokeStyle || "#000000", this.fillStyle = t.fillStyle || "#000000", this.isFillTransparent = t.isFillTransparent || !1, this.fillOpacity = t.fillOpacity || 1, this.font = t.font || "10px sans-serif", this.textBaseline = t.textBaseline || "alphabetic", this.textAlign = t.textAlign || "left", this.lineWidth = t.lineWidth || 1, this.lineJoin = t.lineJoin || "miter", this.lineCap = t.lineCap || "butt", this.path = t.path || [], this.transform = void 0 !== t.transform ? t.transform.clone() : new h, this.globalCompositeOperation = t.globalCompositeOperation || "normal", this.globalAlpha = t.globalAlpha || 1, this.clip_path = t.clip_path || [], this.currentPoint = t.currentPoint || new c, this.miterLimit = t.miterLimit || 10, this.lastPoint = t.lastPoint || new c, this.lineDashOffset = t.lineDashOffset || 0, this.lineDash = t.lineDash || [], this.margin = t.margin || [
            0,
            0,
            0,
            0
        ], this.prevPageLastElemOffset = t.prevPageLastElemOffset || 0, this.ignoreClearRect = "boolean" != typeof t.ignoreClearRect || t.ignoreClearRect, this;
    };
    e.events.push([
        "initialized",
        function() {
            this.context2d = new p(this), r = this.internal.f2, n = this.internal.getCoordinateString, i = this.internal.getVerticalCoordinateString, o = this.internal.getHorizontalCoordinate, s = this.internal.getVerticalCoordinate, c = this.internal.Point, u = this.internal.Rectangle, h = this.internal.Matrix, l = new d;
        }
    ]);
    var p = function(t) {
        Object.defineProperty(this, "canvas", {
            get: function() {
                return {
                    parentNode: !1,
                    style: !1
                };
            }
        });
        var e = t;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return e;
            }
        });
        var r = !1;
        Object.defineProperty(this, "pageWrapXEnabled", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = Boolean(t);
            }
        });
        var n = !1;
        Object.defineProperty(this, "pageWrapYEnabled", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = Boolean(t);
            }
        });
        var i = 0;
        Object.defineProperty(this, "posX", {
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = t);
            }
        });
        var a = 0;
        Object.defineProperty(this, "posY", {
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = t);
            }
        }), Object.defineProperty(this, "margin", {
            get: function() {
                return l.margin;
            },
            set: function(t) {
                var e;
                "number" == typeof t ? e = [
                    t,
                    t,
                    t,
                    t
                ] : ((e = new Array(4))[0] = t[0], e[1] = t.length >= 2 ? t[1] : e[0], e[2] = t.length >= 3 ? t[2] : e[0], e[3] = t.length >= 4 ? t[3] : e[1]), l.margin = e;
            }
        });
        var o = !1;
        Object.defineProperty(this, "autoPaging", {
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        });
        var s = 0;
        Object.defineProperty(this, "lastBreak", {
            get: function() {
                return s;
            },
            set: function(t) {
                s = t;
            }
        });
        var c = [];
        Object.defineProperty(this, "pageBreaks", {
            get: function() {
                return c;
            },
            set: function(t) {
                c = t;
            }
        }), Object.defineProperty(this, "ctx", {
            get: function() {
                return l;
            },
            set: function(t) {
                t instanceof d && (l = t);
            }
        }), Object.defineProperty(this, "path", {
            get: function() {
                return l.path;
            },
            set: function(t) {
                l.path = t;
            }
        });
        var u = [];
        Object.defineProperty(this, "ctxStack", {
            get: function() {
                return u;
            },
            set: function(t) {
                u = t;
            }
        }), Object.defineProperty(this, "fillStyle", {
            get: function() {
                return this.ctx.fillStyle;
            },
            set: function(t) {
                var e;
                e = g(t), this.ctx.fillStyle = e.style, this.ctx.isFillTransparent = 0 === e.a, this.ctx.fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                    a: e.a
                }), this.pdf.setTextColor(e.r, e.g, e.b, {
                    a: e.a
                });
            }
        }), Object.defineProperty(this, "strokeStyle", {
            get: function() {
                return this.ctx.strokeStyle;
            },
            set: function(t) {
                var e = g(t);
                this.ctx.strokeStyle = e.style, this.ctx.isStrokeTransparent = 0 === e.a, this.ctx.strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
            }
        }), Object.defineProperty(this, "lineCap", {
            get: function() {
                return this.ctx.lineCap;
            },
            set: function(t) {
                -1 !== [
                    "butt",
                    "round",
                    "square"
                ].indexOf(t) && (this.ctx.lineCap = t, this.pdf.setLineCap(t));
            }
        }), Object.defineProperty(this, "lineWidth", {
            get: function() {
                return this.ctx.lineWidth;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.lineWidth = t, this.pdf.setLineWidth(t));
            }
        }), Object.defineProperty(this, "lineJoin", {
            get: function() {
                return this.ctx.lineJoin;
            },
            set: function(t) {
                -1 !== [
                    "bevel",
                    "round",
                    "miter"
                ].indexOf(t) && (this.ctx.lineJoin = t, this.pdf.setLineJoin(t));
            }
        }), Object.defineProperty(this, "miterLimit", {
            get: function() {
                return this.ctx.miterLimit;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.miterLimit = t, this.pdf.setMiterLimit(t));
            }
        }), Object.defineProperty(this, "textBaseline", {
            get: function() {
                return this.ctx.textBaseline;
            },
            set: function(t) {
                this.ctx.textBaseline = t;
            }
        }), Object.defineProperty(this, "textAlign", {
            get: function() {
                return this.ctx.textAlign;
            },
            set: function(t) {
                -1 !== [
                    "right",
                    "end",
                    "center",
                    "left",
                    "start"
                ].indexOf(t) && (this.ctx.textAlign = t);
            }
        });
        var h = null;
        function f(t, e) {
            if (null === h) {
                var r = function(t) {
                    var e = [];
                    return Object.keys(t).forEach(function(r) {
                        t[r].forEach(function(t) {
                            var n = null;
                            switch(t){
                                case "bold":
                                    n = {
                                        family: r,
                                        weight: "bold"
                                    };
                                    break;
                                case "italic":
                                    n = {
                                        family: r,
                                        style: "italic"
                                    };
                                    break;
                                case "bolditalic":
                                    n = {
                                        family: r,
                                        weight: "bold",
                                        style: "italic"
                                    };
                                    break;
                                case "":
                                case "normal":
                                    n = {
                                        family: r
                                    };
                            }
                            null !== n && (n.ref = {
                                name: r,
                                style: t
                            }, e.push(n));
                        });
                    }), e;
                }(t.getFontList());
                h = function(t) {
                    for(var e = {}, r = 0; r < t.length; ++r){
                        var n = $020d60e69294d716$var$jt(t[r]), i = n.family, a = n.stretch, o = n.style, s = n.weight;
                        e[i] = e[i] || {}, e[i][a] = e[i][a] || {}, e[i][a][o] = e[i][a][o] || {}, e[i][a][o][s] = n;
                    }
                    return e;
                }(r.concat(e));
            }
            return h;
        }
        var p = null;
        Object.defineProperty(this, "fontFaces", {
            get: function() {
                return p;
            },
            set: function(t) {
                h = null, p = t;
            }
        }), Object.defineProperty(this, "font", {
            get: function() {
                return this.ctx.font;
            },
            set: function(t) {
                var e;
                if (this.ctx.font = t, null !== (e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))) {
                    var r = e[1], n = (e[2], e[3]), i = e[4], a = (e[5], e[6]), o = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];
                    i = "px" === o ? Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor) : "em" === o ? Math.floor(parseFloat(i) * this.pdf.getFontSize()) : Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(i);
                    var s = function(t) {
                        var e, r, n = [], i = t.trim();
                        if ("" === i) return $020d60e69294d716$var$Wt;
                        if (i in $020d60e69294d716$var$Mt) return [
                            $020d60e69294d716$var$Mt[i]
                        ];
                        for(; "" !== i;){
                            switch(r = null, e = (i = $020d60e69294d716$var$Dt(i)).charAt(0)){
                                case '"':
                                case "'":
                                    r = $020d60e69294d716$var$Rt(i.substring(1), e);
                                    break;
                                default:
                                    r = $020d60e69294d716$var$Tt(i);
                            }
                            if (null === r) return $020d60e69294d716$var$Wt;
                            if (n.push(r[0]), "" !== (i = $020d60e69294d716$var$Dt(r[1])) && "," !== i.charAt(0)) return $020d60e69294d716$var$Wt;
                            i = i.replace(/^,/, "");
                        }
                        return n;
                    }(a);
                    if (this.fontFaces) {
                        var c = $020d60e69294d716$var$qt(f(this.pdf, this.fontFaces), s.map(function(t) {
                            return {
                                family: t,
                                stretch: "normal",
                                weight: n,
                                style: r
                            };
                        }));
                        this.pdf.setFont(c.ref.name, c.ref.style);
                    } else {
                        var u = "";
                        ("bold" === n || parseInt(n, 10) >= 700 || "bold" === r) && (u = "bold"), "italic" === r && (u += "italic"), 0 === u.length && (u = "normal");
                        for(var h = "", l = {
                            arial: "Helvetica",
                            Arial: "Helvetica",
                            verdana: "Helvetica",
                            Verdana: "Helvetica",
                            helvetica: "Helvetica",
                            Helvetica: "Helvetica",
                            "sans-serif": "Helvetica",
                            fixed: "Courier",
                            monospace: "Courier",
                            terminal: "Courier",
                            cursive: "Times",
                            fantasy: "Times",
                            serif: "Times"
                        }, d = 0; d < s.length; d++){
                            if (void 0 !== this.pdf.internal.getFont(s[d], u, {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                h = s[d];
                                break;
                            }
                            if ("bolditalic" === u && void 0 !== this.pdf.internal.getFont(s[d], "bold", {
                                noFallback: !0,
                                disableWarning: !0
                            })) h = s[d], u = "bold";
                            else if (void 0 !== this.pdf.internal.getFont(s[d], "normal", {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                h = s[d], u = "normal";
                                break;
                            }
                        }
                        if ("" === h) {
                            for(var p = 0; p < s.length; p++)if (l[s[p]]) {
                                h = l[s[p]];
                                break;
                            }
                        }
                        h = "" === h ? "Times" : h, this.pdf.setFont(h, u);
                    }
                }
            }
        }), Object.defineProperty(this, "globalCompositeOperation", {
            get: function() {
                return this.ctx.globalCompositeOperation;
            },
            set: function(t) {
                this.ctx.globalCompositeOperation = t;
            }
        }), Object.defineProperty(this, "globalAlpha", {
            get: function() {
                return this.ctx.globalAlpha;
            },
            set: function(t) {
                this.ctx.globalAlpha = t;
            }
        }), Object.defineProperty(this, "lineDashOffset", {
            get: function() {
                return this.ctx.lineDashOffset;
            },
            set: function(t) {
                this.ctx.lineDashOffset = t, T.call(this);
            }
        }), Object.defineProperty(this, "lineDash", {
            get: function() {
                return this.ctx.lineDash;
            },
            set: function(t) {
                this.ctx.lineDash = t, T.call(this);
            }
        }), Object.defineProperty(this, "ignoreClearRect", {
            get: function() {
                return this.ctx.ignoreClearRect;
            },
            set: function(t) {
                this.ctx.ignoreClearRect = Boolean(t);
            }
        });
    };
    p.prototype.setLineDash = function(t) {
        this.lineDash = t;
    }, p.prototype.getLineDash = function() {
        return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
    }, p.prototype.fill = function() {
        A.call(this, "fill", !1);
    }, p.prototype.stroke = function() {
        A.call(this, "stroke", !1);
    }, p.prototype.beginPath = function() {
        this.path = [
            {
                type: "begin"
            }
        ];
    }, p.prototype.moveTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $020d60e69294d716$var$a.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
        var r = this.ctx.transform.applyToPoint(new c(t, e));
        this.path.push({
            type: "mt",
            x: r.x,
            y: r.y
        }), this.ctx.lastPoint = new c(t, e);
    }, p.prototype.closePath = function() {
        var e = new c(0, 0), r = 0;
        for(r = this.path.length - 1; -1 !== r; r--)if ("begin" === this.path[r].type && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(this.path[r + 1]) && "number" == typeof this.path[r + 1].x) {
            e = new c(this.path[r + 1].x, this.path[r + 1].y);
            break;
        }
        this.path.push({
            type: "close"
        }), this.ctx.lastPoint = new c(e.x, e.y);
    }, p.prototype.lineTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $020d60e69294d716$var$a.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
        var r = this.ctx.transform.applyToPoint(new c(t, e));
        this.path.push({
            type: "lt",
            x: r.x,
            y: r.y
        }), this.ctx.lastPoint = new c(r.x, r.y);
    }, p.prototype.clip = function() {
        this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), A.call(this, null, !0);
    }, p.prototype.quadraticCurveTo = function(t, e, r, n) {
        if (isNaN(r) || isNaN(n) || isNaN(t) || isNaN(e)) throw $020d60e69294d716$var$a.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
        var i = this.ctx.transform.applyToPoint(new c(r, n)), o = this.ctx.transform.applyToPoint(new c(t, e));
        this.path.push({
            type: "qct",
            x1: o.x,
            y1: o.y,
            x: i.x,
            y: i.y
        }), this.ctx.lastPoint = new c(i.x, i.y);
    }, p.prototype.bezierCurveTo = function(t, e, r, n, i, o) {
        if (isNaN(i) || isNaN(o) || isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $020d60e69294d716$var$a.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
        var s = this.ctx.transform.applyToPoint(new c(i, o)), u = this.ctx.transform.applyToPoint(new c(t, e)), h = this.ctx.transform.applyToPoint(new c(r, n));
        this.path.push({
            type: "bct",
            x1: u.x,
            y1: u.y,
            x2: h.x,
            y2: h.y,
            x: s.x,
            y: s.y
        }), this.ctx.lastPoint = new c(s.x, s.y);
    }, p.prototype.arc = function(t, e, r, n, i, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i)) throw $020d60e69294d716$var$a.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
        if (o = Boolean(o), !this.ctx.transform.isIdentity) {
            var s = this.ctx.transform.applyToPoint(new c(t, e));
            t = s.x, e = s.y;
            var u = this.ctx.transform.applyToPoint(new c(0, r)), h = this.ctx.transform.applyToPoint(new c(0, 0));
            r = Math.sqrt(Math.pow(u.x - h.x, 2) + Math.pow(u.y - h.y, 2));
        }
        Math.abs(i - n) >= 2 * Math.PI && (n = 0, i = 2 * Math.PI), this.path.push({
            type: "arc",
            x: t,
            y: e,
            radius: r,
            startAngle: n,
            endAngle: i,
            counterclockwise: o
        });
    }, p.prototype.arcTo = function(t, e, r, n, i) {
        throw new Error("arcTo not implemented.");
    }, p.prototype.rect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $020d60e69294d716$var$a.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
        this.moveTo(t, e), this.lineTo(t + r, e), this.lineTo(t + r, e + n), this.lineTo(t, e + n), this.lineTo(t, e), this.lineTo(t + r, e), this.lineTo(t, e);
    }, p.prototype.fillRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $020d60e69294d716$var$a.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
        if (!m.call(this)) {
            var i = {};
            "butt" !== this.lineCap && (i.lineCap = this.lineCap, this.lineCap = "butt"), "miter" !== this.lineJoin && (i.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(t, e, r, n), this.fill(), i.hasOwnProperty("lineCap") && (this.lineCap = i.lineCap), i.hasOwnProperty("lineJoin") && (this.lineJoin = i.lineJoin);
        }
    }, p.prototype.strokeRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $020d60e69294d716$var$a.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
        v.call(this) || (this.beginPath(), this.rect(t, e, r, n), this.stroke());
    }, p.prototype.clearRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $020d60e69294d716$var$a.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
        this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(t, e, r, n));
    }, p.prototype.save = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, r = 0; r < this.pdf.internal.getNumberOfPages(); r++)this.pdf.setPage(r + 1), this.pdf.internal.out("q");
        if (this.pdf.setPage(e), t) {
            this.ctx.fontSize = this.pdf.internal.getFontSize();
            var n = new d(this.ctx);
            this.ctxStack.push(this.ctx), this.ctx = n;
        }
    }, p.prototype.restore = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, r = 0; r < this.pdf.internal.getNumberOfPages(); r++)this.pdf.setPage(r + 1), this.pdf.internal.out("Q");
        this.pdf.setPage(e), t && 0 !== this.ctxStack.length && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
    }, p.prototype.toDataURL = function() {
        throw new Error("toDataUrl not implemented.");
    };
    var g = function(t) {
        var e, r, n, i;
        if (!0 === t.isCanvasGradient && (t = t.getColor()), !t) return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            style: t
        };
        if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t)) e = 0, r = 0, n = 0, i = 0;
        else {
            var a = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);
            if (null !== a) e = parseInt(a[1]), r = parseInt(a[2]), n = parseInt(a[3]), i = 1;
            else if (null !== (a = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t))) e = parseInt(a[1]), r = parseInt(a[2]), n = parseInt(a[3]), i = parseFloat(a[4]);
            else {
                if (i = 1, "string" == typeof t && "#" !== t.charAt(0)) {
                    var o = new $020d60e69294d716$var$f(t);
                    t = o.ok ? o.toHex() : "#000000";
                }
                4 === t.length ? (e = t.substring(1, 2), e += e, r = t.substring(2, 3), r += r, n = t.substring(3, 4), n += n) : (e = t.substring(1, 3), r = t.substring(3, 5), n = t.substring(5, 7)), e = parseInt(e, 16), r = parseInt(r, 16), n = parseInt(n, 16);
            }
        }
        return {
            r: e,
            g: r,
            b: n,
            a: i,
            style: t
        };
    }, m = function() {
        return this.ctx.isFillTransparent || 0 == this.globalAlpha;
    }, v = function() {
        return Boolean(this.ctx.isStrokeTransparent || 0 == this.globalAlpha);
    };
    p.prototype.fillText = function(t, e, r, n) {
        if (isNaN(e) || isNaN(r) || "string" != typeof t) throw $020d60e69294d716$var$a.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
        if (n = isNaN(n) ? void 0 : n, !m.call(this)) {
            var i = q(this.ctx.transform.rotation), o = this.ctx.transform.scaleX;
            C.call(this, {
                text: t,
                x: e,
                y: r,
                scale: o,
                angle: i,
                align: this.textAlign,
                maxWidth: n
            });
        }
    }, p.prototype.strokeText = function(t, e, r, n) {
        if (isNaN(e) || isNaN(r) || "string" != typeof t) throw $020d60e69294d716$var$a.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
        if (!v.call(this)) {
            n = isNaN(n) ? void 0 : n;
            var i = q(this.ctx.transform.rotation), o = this.ctx.transform.scaleX;
            C.call(this, {
                text: t,
                x: e,
                y: r,
                scale: o,
                renderingMode: "stroke",
                angle: i,
                align: this.textAlign,
                maxWidth: n
            });
        }
    }, p.prototype.measureText = function(t) {
        if ("string" != typeof t) throw $020d60e69294d716$var$a.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
        var e = this.pdf, r = this.pdf.internal.scaleFactor, n = e.internal.getFontSize(), i = e.getStringUnitWidth(t) * n / e.internal.scaleFactor, o = function(t) {
            var e = (t = t || {}).width || 0;
            return Object.defineProperty(this, "width", {
                get: function() {
                    return e;
                }
            }), this;
        };
        return new o({
            width: i *= Math.round(96 * r / 72 * 1e4) / 1e4
        });
    }, p.prototype.scale = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $020d60e69294d716$var$a.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
        var r = new h(t, 0, 0, e, 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(r);
    }, p.prototype.rotate = function(t) {
        if (isNaN(t)) throw $020d60e69294d716$var$a.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
        var e = new h(Math.cos(t), Math.sin(t), -Math.sin(t), Math.cos(t), 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(e);
    }, p.prototype.translate = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $020d60e69294d716$var$a.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
        var r = new h(1, 0, 0, 1, t, e);
        this.ctx.transform = this.ctx.transform.multiply(r);
    }, p.prototype.transform = function(t, e, r, n, i, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(o)) throw $020d60e69294d716$var$a.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
        var s = new h(t, e, r, n, i, o);
        this.ctx.transform = this.ctx.transform.multiply(s);
    }, p.prototype.setTransform = function(t, e, r, n, i, a) {
        t = isNaN(t) ? 1 : t, e = isNaN(e) ? 0 : e, r = isNaN(r) ? 0 : r, n = isNaN(n) ? 1 : n, i = isNaN(i) ? 0 : i, a = isNaN(a) ? 0 : a, this.ctx.transform = new h(t, e, r, n, i, a);
    };
    var b = function() {
        return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
    };
    p.prototype.drawImage = function(t, e, r, n, i, a, o, s, c) {
        var l = this.pdf.getImageProperties(t), f = 1, d = 1, p = 1, g = 1;
        void 0 !== n && void 0 !== s && (p = s / n, g = c / i, f = l.width / n * s / n, d = l.height / i * c / i), void 0 === a && (a = e, o = r, e = 0, r = 0), void 0 !== n && void 0 === s && (s = n, c = i), void 0 === n && void 0 === s && (s = l.width, c = l.height);
        for(var m, v = this.ctx.transform.decompose(), w = q(v.rotate.shx), A = new h, S = (A = (A = (A = A.multiply(v.translate)).multiply(v.skew)).multiply(v.scale)).applyToRectangle(new u(a - e * p, o - r * g, n * f, i * d)), _ = y.call(this, S), P = [], k = 0; k < _.length; k += 1)-1 === P.indexOf(_[k]) && P.push(_[k]);
        if (L(P), this.autoPaging) for(var I = P[0], F = P[P.length - 1], C = I; C < F + 1; C++){
            this.pdf.setPage(C);
            var j = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], O = 1 === C ? this.posY + this.margin[0] : this.margin[0], B = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], M = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], E = 1 === C ? 0 : B + (C - 2) * M;
            if (0 !== this.ctx.clip_path.length) {
                var D = this.path;
                m = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(m, this.posX + this.margin[3], -E + O + this.ctx.prevPageLastElemOffset), x.call(this, "fill", !0), this.path = D;
            }
            var R = JSON.parse(JSON.stringify(S));
            R = N([
                R
            ], this.posX + this.margin[3], -E + O + this.ctx.prevPageLastElemOffset)[0];
            var T = (C > I || C < F) && b.call(this);
            T && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], j, M, null).clip().discardPath()), this.pdf.addImage(t, "JPEG", R.x, R.y, R.w, R.h, null, null, w), T && this.pdf.restoreGraphicsState();
        }
        else this.pdf.addImage(t, "JPEG", S.x, S.y, S.w, S.h, null, null, w);
    };
    var y = function(t, e, r) {
        var n = [];
        e = e || this.pdf.internal.pageSize.width, r = r || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
        var i = this.posY + this.ctx.prevPageLastElemOffset;
        switch(t.type){
            default:
            case "mt":
            case "lt":
                n.push(Math.floor((t.y + i) / r) + 1);
                break;
            case "arc":
                n.push(Math.floor((t.y + i - t.radius) / r) + 1), n.push(Math.floor((t.y + i + t.radius) / r) + 1);
                break;
            case "qct":
                var a = D(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x, t.y);
                n.push(Math.floor((a.y + i) / r) + 1), n.push(Math.floor((a.y + a.h + i) / r) + 1);
                break;
            case "bct":
                var o = R(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x2, t.y2, t.x, t.y);
                n.push(Math.floor((o.y + i) / r) + 1), n.push(Math.floor((o.y + o.h + i) / r) + 1);
                break;
            case "rect":
                n.push(Math.floor((t.y + i) / r) + 1), n.push(Math.floor((t.y + t.h + i) / r) + 1);
        }
        for(var s = 0; s < n.length; s += 1)for(; this.pdf.internal.getNumberOfPages() < n[s];)w.call(this);
        return n;
    }, w = function() {
        var t = this.fillStyle, e = this.strokeStyle, r = this.font, n = this.lineCap, i = this.lineWidth, a = this.lineJoin;
        this.pdf.addPage(), this.fillStyle = t, this.strokeStyle = e, this.font = r, this.lineCap = n, this.lineWidth = i, this.lineJoin = a;
    }, N = function(t, e, r) {
        for(var n = 0; n < t.length; n++)switch(t[n].type){
            case "bct":
                t[n].x2 += e, t[n].y2 += r;
            case "qct":
                t[n].x1 += e, t[n].y1 += r;
            case "mt":
            case "lt":
            case "arc":
            default:
                t[n].x += e, t[n].y += r;
        }
        return t;
    }, L = function(t) {
        return t.sort(function(t, e) {
            return t - e;
        });
    }, A = function(t, e) {
        for(var r, n, i = this.fillStyle, a = this.strokeStyle, o = this.lineCap, s = this.lineWidth, c = Math.abs(s * this.ctx.transform.scaleX), u = this.lineJoin, h = JSON.parse(JSON.stringify(this.path)), l = JSON.parse(JSON.stringify(this.path)), f = [], d = 0; d < l.length; d++)if (void 0 !== l[d].x) for(var p = y.call(this, l[d]), g = 0; g < p.length; g += 1)-1 === f.indexOf(p[g]) && f.push(p[g]);
        for(var m = 0; m < f.length; m++)for(; this.pdf.internal.getNumberOfPages() < f[m];)w.call(this);
        if (L(f), this.autoPaging) for(var v = f[0], A = f[f.length - 1], S = v; S < A + 1; S++){
            this.pdf.setPage(S), this.fillStyle = i, this.strokeStyle = a, this.lineCap = o, this.lineWidth = c, this.lineJoin = u;
            var _ = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], P = 1 === S ? this.posY + this.margin[0] : this.margin[0], k = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], I = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], F = 1 === S ? 0 : k + (S - 2) * I;
            if (0 !== this.ctx.clip_path.length) {
                var C = this.path;
                r = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(r, this.posX + this.margin[3], -F + P + this.ctx.prevPageLastElemOffset), x.call(this, t, !0), this.path = C;
            }
            if (n = JSON.parse(JSON.stringify(h)), this.path = N(n, this.posX + this.margin[3], -F + P + this.ctx.prevPageLastElemOffset), !1 === e || 0 === S) {
                var j = (S > v || S < A) && b.call(this);
                j && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], _, I, null).clip().discardPath()), x.call(this, t, e), j && this.pdf.restoreGraphicsState();
            }
            this.lineWidth = s;
        }
        else this.lineWidth = c, x.call(this, t, e), this.lineWidth = s;
        this.path = h;
    }, x = function(t, e) {
        if (("stroke" !== t || e || !v.call(this)) && ("stroke" === t || e || !m.call(this))) {
            for(var r, n, i = [], a = this.path, o = 0; o < a.length; o++){
                var s = a[o];
                switch(s.type){
                    case "begin":
                        i.push({
                            begin: !0
                        });
                        break;
                    case "close":
                        i.push({
                            close: !0
                        });
                        break;
                    case "mt":
                        i.push({
                            start: s,
                            deltas: [],
                            abs: []
                        });
                        break;
                    case "lt":
                        var c = i.length;
                        if (a[o - 1] && !isNaN(a[o - 1].x) && (r = [
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], c > 0)) {
                            for(; c >= 0; c--)if (!0 !== i[c - 1].close && !0 !== i[c - 1].begin) {
                                i[c - 1].deltas.push(r), i[c - 1].abs.push(s);
                                break;
                            }
                        }
                        break;
                    case "bct":
                        r = [
                            s.x1 - a[o - 1].x,
                            s.y1 - a[o - 1].y,
                            s.x2 - a[o - 1].x,
                            s.y2 - a[o - 1].y,
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], i[i.length - 1].deltas.push(r);
                        break;
                    case "qct":
                        var u = a[o - 1].x + 2 / 3 * (s.x1 - a[o - 1].x), h = a[o - 1].y + 2 / 3 * (s.y1 - a[o - 1].y), l = s.x + 2 / 3 * (s.x1 - s.x), f = s.y + 2 / 3 * (s.y1 - s.y), d = s.x, p = s.y;
                        r = [
                            u - a[o - 1].x,
                            h - a[o - 1].y,
                            l - a[o - 1].x,
                            f - a[o - 1].y,
                            d - a[o - 1].x,
                            p - a[o - 1].y
                        ], i[i.length - 1].deltas.push(r);
                        break;
                    case "arc":
                        i.push({
                            deltas: [],
                            abs: [],
                            arc: !0
                        }), Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(s);
                }
            }
            n = e ? null : "stroke" === t ? "stroke" : "fill";
            for(var g = !1, b = 0; b < i.length; b++)if (i[b].arc) for(var y = i[b].abs, w = 0; w < y.length; w++){
                var N = y[w];
                "arc" === N.type ? P.call(this, N.x, N.y, N.radius, N.startAngle, N.endAngle, N.counterclockwise, void 0, e, !g) : j.call(this, N.x, N.y), g = !0;
            }
            else if (!0 === i[b].close) this.pdf.internal.out("h"), g = !1;
            else if (!0 !== i[b].begin) {
                var L = i[b].start.x, A = i[b].start.y;
                O.call(this, i[b].deltas, L, A), g = !0;
            }
            n && k.call(this, n), e && I.call(this);
        }
    }, S = function(t) {
        var e = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, r = e * (this.pdf.internal.getLineHeightFactor() - 1);
        switch(this.ctx.textBaseline){
            case "bottom":
                return t - r;
            case "top":
                return t + e - r;
            case "hanging":
                return t + e - 2 * r;
            case "middle":
                return t + e / 2 - r;
            case "ideographic":
                return t;
            case "alphabetic":
            default:
                return t;
        }
    }, _ = function(t) {
        return t + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
    };
    p.prototype.createLinearGradient = function() {
        var t = function() {};
        return t.colorStops = [], t.addColorStop = function(t, e) {
            this.colorStops.push([
                t,
                e
            ]);
        }, t.getColor = function() {
            return 0 === this.colorStops.length ? "#000000" : this.colorStops[0][1];
        }, t.isCanvasGradient = !0, t;
    }, p.prototype.createPattern = function() {
        return this.createLinearGradient();
    }, p.prototype.createRadialGradient = function() {
        return this.createLinearGradient();
    };
    var P = function(t, e, r, n, i, a, o, s, c) {
        for(var u = M.call(this, r, n, i, a), h = 0; h < u.length; h++){
            var l = u[h];
            0 === h && (c ? F.call(this, l.x1 + t, l.y1 + e) : j.call(this, l.x1 + t, l.y1 + e)), B.call(this, t, e, l.x2, l.y2, l.x3, l.y3, l.x4, l.y4);
        }
        s ? I.call(this) : k.call(this, o);
    }, k = function(t) {
        switch(t){
            case "stroke":
                this.pdf.internal.out("S");
                break;
            case "fill":
                this.pdf.internal.out("f");
        }
    }, I = function() {
        this.pdf.clip(), this.pdf.discardPath();
    }, F = function(t, e) {
        this.pdf.internal.out(n(t) + " " + i(e) + " m");
    }, C = function(t) {
        var e;
        switch(t.align){
            case "right":
            case "end":
                e = "right";
                break;
            case "center":
                e = "center";
                break;
            case "left":
            case "start":
            default:
                e = "left";
        }
        var r = this.pdf.getTextDimensions(t.text), n = S.call(this, t.y), i = _.call(this, n) - r.h, a = this.ctx.transform.applyToPoint(new c(t.x, n)), o = this.ctx.transform.decompose(), s = new h;
        s = (s = (s = s.multiply(o.translate)).multiply(o.skew)).multiply(o.scale);
        for(var l, f, d, p = this.ctx.transform.applyToRectangle(new u(t.x, n, r.w, r.h)), g = s.applyToRectangle(new u(t.x, i, r.w, r.h)), m = y.call(this, g), v = [], w = 0; w < m.length; w += 1)-1 === v.indexOf(m[w]) && v.push(m[w]);
        if (L(v), this.autoPaging) for(var A = v[0], P = v[v.length - 1], k = A; k < P + 1; k++){
            this.pdf.setPage(k);
            var I = 1 === k ? this.posY + this.margin[0] : this.margin[0], F = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], C = this.pdf.internal.pageSize.height - this.margin[2], j = C - this.margin[0], O = this.pdf.internal.pageSize.width - this.margin[1], B = O - this.margin[3], M = 1 === k ? 0 : F + (k - 2) * j;
            if (0 !== this.ctx.clip_path.length) {
                var E = this.path;
                l = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(l, this.posX + this.margin[3], -1 * M + I), x.call(this, "fill", !0), this.path = E;
            }
            var q = N([
                JSON.parse(JSON.stringify(g))
            ], this.posX + this.margin[3], -M + I + this.ctx.prevPageLastElemOffset)[0];
            t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale);
            var D = "text" !== this.autoPaging;
            if (D || q.y + q.h <= C) {
                if (D || q.y >= I && q.x <= O) {
                    var R = D ? t.text : this.pdf.splitTextToSize(t.text, t.maxWidth || O - q.x)[0], T = N([
                        JSON.parse(JSON.stringify(p))
                    ], this.posX + this.margin[3], -M + I + this.ctx.prevPageLastElemOffset)[0], U = D && (k > A || k < P) && b.call(this);
                    U && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], B, j, null).clip().discardPath()), this.pdf.text(R, T.x, T.y, {
                        angle: t.angle,
                        align: e,
                        renderingMode: t.renderingMode
                    }), U && this.pdf.restoreGraphicsState();
                }
            } else q.y < C && (this.ctx.prevPageLastElemOffset += C - q.y);
            t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
        }
        else t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale), this.pdf.text(t.text, a.x + this.posX, a.y + this.posY, {
            angle: t.angle,
            align: e,
            renderingMode: t.renderingMode,
            maxWidth: t.maxWidth
        }), t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
    }, j = function(t, e, r, a) {
        r = r || 0, a = a || 0, this.pdf.internal.out(n(t + r) + " " + i(e + a) + " l");
    }, O = function(t, e, r) {
        return this.pdf.lines(t, e, r, null, null);
    }, B = function(t, e, n, i, a, c, u, h) {
        this.pdf.internal.out([
            r(o(n + t)),
            r(s(i + e)),
            r(o(a + t)),
            r(s(c + e)),
            r(o(u + t)),
            r(s(h + e)),
            "c"
        ].join(" "));
    }, M = function(t, e, r, n) {
        for(var i = 2 * Math.PI, a = Math.PI / 2; e > r;)e -= i;
        var o = Math.abs(r - e);
        o < i && n && (o = i - o);
        for(var s = [], c = n ? -1 : 1, u = e; o > 1e-5;){
            var h = u + c * Math.min(o, a);
            s.push(E.call(this, t, u, h)), o -= Math.abs(h - u), u = h;
        }
        return s;
    }, E = function(t, e, r) {
        var n = (r - e) / 2, i = t * Math.cos(n), a = t * Math.sin(n), o = i, s = -a, c = o * o + s * s, u = c + o * i + s * a, h = 4 / 3 * (Math.sqrt(2 * c * u) - u) / (o * a - s * i), l = o - h * s, f = s + h * o, d = l, p = -f, g = n + e, m = Math.cos(g), v = Math.sin(g);
        return {
            x1: t * Math.cos(e),
            y1: t * Math.sin(e),
            x2: l * m - f * v,
            y2: l * v + f * m,
            x3: d * m - p * v,
            y3: d * v + p * m,
            x4: t * Math.cos(r),
            y4: t * Math.sin(r)
        };
    }, q = function(t) {
        return 180 * t / Math.PI;
    }, D = function(t, e, r, n, i, a) {
        var o = t + .5 * (r - t), s = e + .5 * (n - e), c = i + .5 * (r - i), h = a + .5 * (n - a), l = Math.min(t, i, o, c), f = Math.max(t, i, o, c), d = Math.min(e, a, s, h), p = Math.max(e, a, s, h);
        return new u(l, d, f - l, p - d);
    }, R = function(t, e, r, n, i, a, o, s) {
        var c, h, l, f, d, p, g, m, v, b, y, w, N, L, A = r - t, x = n - e, S = i - r, _ = a - n, P = o - i, k = s - a;
        for(h = 0; h < 41; h++)v = (g = (l = t + (c = h / 40) * A) + c * ((d = r + c * S) - l)) + c * (d + c * (i + c * P - d) - g), b = (m = (f = e + c * x) + c * ((p = n + c * _) - f)) + c * (p + c * (a + c * k - p) - m), 0 == h ? (y = v, w = b, N = v, L = b) : (y = Math.min(y, v), w = Math.min(w, b), N = Math.max(N, v), L = Math.max(L, b));
        return new u(Math.round(y), Math.round(w), Math.round(N - y), Math.round(L - w));
    }, T = function() {
        if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
            var t, e, r = (t = this.ctx.lineDash, e = this.ctx.lineDashOffset, JSON.stringify({
                lineDash: t,
                lineDashOffset: e
            }));
            this.prevLineDash !== r && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = r);
        }
    };
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var r = function(t) {
        var e, r, n, i, a, o, s, c, u, h;
        for(/[^\x00-\xFF]/.test(t), r = [], n = 0, i = (t += e = "\0\0\0\0".slice(t.length % 4 || 4)).length; i > n; n += 4)0 !== (a = (t.charCodeAt(n) << 24) + (t.charCodeAt(n + 1) << 16) + (t.charCodeAt(n + 2) << 8) + t.charCodeAt(n + 3)) ? (o = (a = ((a = ((a = ((a = (a - (h = a % 85)) / 85) - (u = a % 85)) / 85) - (c = a % 85)) / 85) - (s = a % 85)) / 85) % 85, r.push(o + 33, s + 33, c + 33, u + 33, h + 33)) : r.push(122);
        return function(t, e) {
            for(var r = e; r > 0; r--)t.pop();
        }(r, e.length), String.fromCharCode.apply(String, r) + "~>";
    }, n = function(t) {
        var e, r, n, i, a, o = String, s = "length", c = 255, u = "charCodeAt", h = "slice", l = "replace";
        for(t[h](-2), t = t[h](0, -2)[l](/\s/g, "")[l]("z", "!!!!!"), n = [], i = 0, a = (t += e = "uuuuu"[h](t[s] % 5 || 5))[s]; a > i; i += 5)r = 52200625 * (t[u](i) - 33) + 614125 * (t[u](i + 1) - 33) + 7225 * (t[u](i + 2) - 33) + 85 * (t[u](i + 3) - 33) + (t[u](i + 4) - 33), n.push(c & r >> 24, c & r >> 16, c & r >> 8, c & r);
        return function(t, e) {
            for(var r = e; r > 0; r--)t.pop();
        }(n, e[s]), o.fromCharCode.apply(o, n);
    }, i = function(t) {
        var e = new RegExp(/^([0-9A-Fa-f]{2})+$/);
        if (-1 !== (t = t.replace(/\s/g, "")).indexOf(">") && (t = t.substr(0, t.indexOf(">"))), t.length % 2 && (t += "0"), !1 === e.test(t)) return "";
        for(var r = "", n = 0; n < t.length; n += 2)r += String.fromCharCode("0x" + (t[n] + t[n + 1]));
        return r;
    }, a = function(t) {
        for(var r = new Uint8Array(t.length), n = t.length; n--;)r[n] = t.charCodeAt(n);
        return t = (r = (0, $3ae101cb5c0083b5$export$f87121a6d50aff25)(r)).reduce(function(t, e) {
            return t + String.fromCharCode(e);
        }, "");
    };
    t.processDataByFilters = function(t, e) {
        var o = 0, s = t || "", c = [];
        for("string" == typeof (e = e || []) && (e = [
            e
        ]), o = 0; o < e.length; o += 1)switch(e[o]){
            case "ASCII85Decode":
            case "/ASCII85Decode":
                s = n(s), c.push("/ASCII85Encode");
                break;
            case "ASCII85Encode":
            case "/ASCII85Encode":
                s = r(s), c.push("/ASCII85Decode");
                break;
            case "ASCIIHexDecode":
            case "/ASCIIHexDecode":
                s = i(s), c.push("/ASCIIHexEncode");
                break;
            case "ASCIIHexEncode":
            case "/ASCIIHexEncode":
                s = s.split("").map(function(t) {
                    return ("0" + t.charCodeAt().toString(16)).slice(-2);
                }).join("") + ">", c.push("/ASCIIHexDecode");
                break;
            case "FlateEncode":
            case "/FlateEncode":
                s = a(s), c.push("/FlateDecode");
                break;
            default:
                throw new Error('The filter: "' + e[o] + '" is not implemented');
        }
        return {
            data: s,
            reverseChain: c.reverse().join(" ")
        };
    };
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.loadFile = function(t, e, r) {
        return function(t, e, r) {
            e = !1 !== e, r = "function" == typeof r ? r : function() {};
            var n = void 0;
            try {
                n = function(t, e, r) {
                    var n = new XMLHttpRequest, i = 0, a = function(t) {
                        var e = t.length, r = [], n = String.fromCharCode;
                        for(i = 0; i < e; i += 1)r.push(n(255 & t.charCodeAt(i)));
                        return r.join("");
                    };
                    if (n.open("GET", t, !e), n.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (n.onload = function() {
                        200 === n.status ? r(a(this.responseText)) : r(void 0);
                    }), n.send(null), e && 200 === n.status) return a(n.responseText);
                }(t, e, r);
            } catch (t) {}
            return n;
        }(t, e, r);
    }, t.loadImageFile = t.loadFile;
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), function(e) {
    function r() {
        return ($020d60e69294d716$var$n.html2canvas ? Promise.resolve($020d60e69294d716$var$n.html2canvas) : (parcelRequire("gAYid"))).catch(function(t) {
            return Promise.reject(new Error("Could not load html2canvas: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    function i() {
        return ($020d60e69294d716$var$n.DOMPurify ? Promise.resolve($020d60e69294d716$var$n.DOMPurify) : (parcelRequire("bNcHL"))).catch(function(t) {
            return Promise.reject(new Error("Could not load dompurify: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    var a = function(e) {
        var r = (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(e);
        return "undefined" === r ? "undefined" : "string" === r || e instanceof String ? "string" : "number" === r || e instanceof Number ? "number" : "function" === r || e instanceof Function ? "function" : e && e.constructor === Array ? "array" : e && 1 === e.nodeType ? "element" : "object" === r ? "object" : "unknown";
    }, o = function(t, e) {
        var r = document.createElement(t);
        for(var n in e.className && (r.className = e.className), e.innerHTML && e.dompurify && (r.innerHTML = e.dompurify.sanitize(e.innerHTML)), e.style)r.style[n] = e.style[n];
        return r;
    }, s = function t(e) {
        var r = Object.assign(t.convert(Promise.resolve()), JSON.parse(JSON.stringify(t.template))), n = t.convert(Promise.resolve(), r);
        return n = (n = n.setProgress(1, t, 1, [
            t
        ])).set(e);
    };
    (s.prototype = Object.create(Promise.prototype)).constructor = s, s.convert = function(t, e) {
        return t.__proto__ = e || s.prototype, t;
    }, s.template = {
        prop: {
            src: null,
            container: null,
            overlay: null,
            canvas: null,
            img: null,
            pdf: null,
            pageSize: null,
            callback: function() {}
        },
        progress: {
            val: 0,
            state: null,
            n: 0,
            stack: []
        },
        opt: {
            filename: "file.pdf",
            margin: [
                0,
                0,
                0,
                0
            ],
            enableLinks: !0,
            x: 0,
            y: 0,
            html2canvas: {},
            jsPDF: {},
            backgroundColor: "transparent"
        }
    }, s.prototype.from = function(t, e) {
        return this.then(function() {
            switch(e = e || function(t) {
                switch(a(t)){
                    case "string":
                        return "string";
                    case "element":
                        return "canvas" === t.nodeName.toLowerCase() ? "canvas" : "element";
                    default:
                        return "unknown";
                }
            }(t)){
                case "string":
                    return this.then(i).then(function(e) {
                        return this.set({
                            src: o("div", {
                                innerHTML: t,
                                dompurify: e
                            })
                        });
                    });
                case "element":
                    return this.set({
                        src: t
                    });
                case "canvas":
                    return this.set({
                        canvas: t
                    });
                case "img":
                    return this.set({
                        img: t
                    });
                default:
                    return this.error("Unknown source type.");
            }
        });
    }, s.prototype.to = function(t) {
        switch(t){
            case "container":
                return this.toContainer();
            case "canvas":
                return this.toCanvas();
            case "img":
                return this.toImg();
            case "pdf":
                return this.toPdf();
            default:
                return this.error("Invalid target.");
        }
    }, s.prototype.toContainer = function() {
        return this.thenList([
            function() {
                return this.prop.src || this.error("Cannot duplicate - no source HTML.");
            },
            function() {
                return this.prop.pageSize || this.setPageSize();
            }
        ]).then(function() {
            var t = {
                position: "relative",
                display: "inline-block",
                width: ("number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px",
                left: 0,
                right: 0,
                top: 0,
                margin: "auto",
                backgroundColor: this.opt.backgroundColor
            }, e = function t(e, r) {
                for(var n = 3 === e.nodeType ? document.createTextNode(e.nodeValue) : e.cloneNode(!1), i = e.firstChild; i; i = i.nextSibling)!0 !== r && 1 === i.nodeType && "SCRIPT" === i.nodeName || n.appendChild(t(i, r));
                return 1 === e.nodeType && ("CANVAS" === e.nodeName ? (n.width = e.width, n.height = e.height, n.getContext("2d").drawImage(e, 0, 0)) : "TEXTAREA" !== e.nodeName && "SELECT" !== e.nodeName || (n.value = e.value), n.addEventListener("load", function() {
                    n.scrollTop = e.scrollTop, n.scrollLeft = e.scrollLeft;
                }, !0)), n;
            }(this.prop.src, this.opt.html2canvas.javascriptEnabled);
            "BODY" === e.tagName && (t.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = o("div", {
                className: "html2pdf__overlay",
                style: {
                    position: "fixed",
                    overflow: "hidden",
                    zIndex: 1e3,
                    left: "-100000px",
                    right: 0,
                    bottom: 0,
                    top: 0
                }
            }), this.prop.container = o("div", {
                className: "html2pdf__container",
                style: t
            }), this.prop.container.appendChild(e), this.prop.container.firstChild.appendChild(o("div", {
                style: {
                    clear: "both",
                    border: "0 none transparent",
                    margin: 0,
                    padding: 0,
                    height: 0
                }
            })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
        });
    }, s.prototype.toCanvas = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(r).then(function(t) {
            var e = Object.assign({}, this.opt.html2canvas);
            return delete e.onrendered, t(this.prop.container, e);
        }).then(function(t) {
            (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, s.prototype.toContext2d = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(r).then(function(t) {
            var e = this.opt.jsPDF, r = this.opt.fontFaces, n = "number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, i = Object.assign({
                async: !0,
                allowTaint: !0,
                scale: n,
                scrollX: this.opt.scrollX || 0,
                scrollY: this.opt.scrollY || 0,
                backgroundColor: "#ffffff",
                imageTimeout: 15e3,
                logging: !0,
                proxy: null,
                removeContainer: !0,
                foreignObjectRendering: !1,
                useCORS: !1
            }, this.opt.html2canvas);
            if (delete i.onrendered, e.context2d.autoPaging = void 0 === this.opt.autoPaging || this.opt.autoPaging, e.context2d.posX = this.opt.x, e.context2d.posY = this.opt.y, e.context2d.margin = this.opt.margin, e.context2d.fontFaces = r, r) for(var a = 0; a < r.length; ++a){
                var o = r[a], s = o.src.find(function(t) {
                    return "truetype" === t.format;
                });
                s && e.addFont(s.url, o.ref.name, o.ref.style);
            }
            return i.windowHeight = i.windowHeight || 0, i.windowHeight = 0 == i.windowHeight ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : i.windowHeight, e.context2d.save(!0), t(this.prop.container, i);
        }).then(function(t) {
            this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, s.prototype.toImg = function() {
        return this.thenList([
            function() {
                return this.prop.canvas || this.toCanvas();
            }
        ]).then(function() {
            var t = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
            this.prop.img = document.createElement("img"), this.prop.img.src = t;
        });
    }, s.prototype.toPdf = function() {
        return this.thenList([
            function() {
                return this.toContext2d();
            }
        ]).then(function() {
            this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
        });
    }, s.prototype.output = function(t, e, r) {
        return "img" === (r = r || "pdf").toLowerCase() || "image" === r.toLowerCase() ? this.outputImg(t, e) : this.outputPdf(t, e);
    }, s.prototype.outputPdf = function(t, e) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            return this.prop.pdf.output(t, e);
        });
    }, s.prototype.outputImg = function(t) {
        return this.thenList([
            function() {
                return this.prop.img || this.toImg();
            }
        ]).then(function() {
            switch(t){
                case void 0:
                case "img":
                    return this.prop.img;
                case "datauristring":
                case "dataurlstring":
                    return this.prop.img.src;
                case "datauri":
                case "dataurl":
                    return document.location.href = this.prop.img.src;
                default:
                    throw 'Image output type "' + t + '" is not supported.';
            }
        });
    }, s.prototype.save = function(t) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).set(t ? {
            filename: t
        } : null).then(function() {
            this.prop.pdf.save(this.opt.filename);
        });
    }, s.prototype.doCallback = function() {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            this.prop.callback(this.prop.pdf);
        });
    }, s.prototype.set = function(t) {
        if ("object" !== a(t)) return this;
        var e = Object.keys(t || {}).map(function(e) {
            if (e in s.template.prop) return function() {
                this.prop[e] = t[e];
            };
            switch(e){
                case "margin":
                    return this.setMargin.bind(this, t.margin);
                case "jsPDF":
                    return function() {
                        return this.opt.jsPDF = t.jsPDF, this.setPageSize();
                    };
                case "pageSize":
                    return this.setPageSize.bind(this, t.pageSize);
                default:
                    return function() {
                        this.opt[e] = t[e];
                    };
            }
        }, this);
        return this.then(function() {
            return this.thenList(e);
        });
    }, s.prototype.get = function(t, e) {
        return this.then(function() {
            var r = t in s.template.prop ? this.prop[t] : this.opt[t];
            return e ? e(r) : r;
        });
    }, s.prototype.setMargin = function(t) {
        return this.then(function() {
            switch(a(t)){
                case "number":
                    t = [
                        t,
                        t,
                        t,
                        t
                    ];
                case "array":
                    if (2 === t.length && (t = [
                        t[0],
                        t[1],
                        t[0],
                        t[1]
                    ]), 4 === t.length) break;
                default:
                    return this.error("Invalid margin array.");
            }
            this.opt.margin = t;
        }).then(this.setPageSize);
    }, s.prototype.setPageSize = function(t) {
        function e(t, e) {
            return Math.floor(t * e / 72 * 96);
        }
        return this.then(function() {
            (t = t || $020d60e69294d716$export$ba1e2ffc633a60f5.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (t.inner = {
                width: t.width - this.opt.margin[1] - this.opt.margin[3],
                height: t.height - this.opt.margin[0] - this.opt.margin[2]
            }, t.inner.px = {
                width: e(t.inner.width, t.k),
                height: e(t.inner.height, t.k)
            }, t.inner.ratio = t.inner.height / t.inner.width), this.prop.pageSize = t;
        });
    }, s.prototype.setProgress = function(t, e, r, n) {
        return null != t && (this.progress.val = t), null != e && (this.progress.state = e), null != r && (this.progress.n = r), null != n && (this.progress.stack = n), this.progress.ratio = this.progress.val / this.progress.state, this;
    }, s.prototype.updateProgress = function(t, e, r, n) {
        return this.setProgress(t ? this.progress.val + t : null, e || null, r ? this.progress.n + r : null, n ? this.progress.stack.concat(n) : null);
    }, s.prototype.then = function(t, e) {
        var r = this;
        return this.thenCore(t, e, function(t, e) {
            return r.updateProgress(null, null, 1, [
                t
            ]), Promise.prototype.then.call(this, function(e) {
                return r.updateProgress(null, t), e;
            }).then(t, e).then(function(t) {
                return r.updateProgress(1), t;
            });
        });
    }, s.prototype.thenCore = function(t, e, r) {
        r = r || Promise.prototype.then;
        t && (t = t.bind(this)), e && (e = e.bind(this));
        var n = -1 !== Promise.toString().indexOf("[native code]") && "Promise" === Promise.name ? this : s.convert(Object.assign({}, this), Promise.prototype), i = r.call(n, t, e);
        return s.convert(i, this.__proto__);
    }, s.prototype.thenExternal = function(t, e) {
        return Promise.prototype.then.call(this, t, e);
    }, s.prototype.thenList = function(t) {
        var e = this;
        return t.forEach(function(t) {
            e = e.thenCore(t);
        }), e;
    }, s.prototype.catch = function(t) {
        t && (t = t.bind(this));
        var e = Promise.prototype.catch.call(this, t);
        return s.convert(e, this);
    }, s.prototype.catchExternal = function(t) {
        return Promise.prototype.catch.call(this, t);
    }, s.prototype.error = function(t) {
        return this.then(function() {
            throw new Error(t);
        });
    }, s.prototype.using = s.prototype.set, s.prototype.saveAs = s.prototype.save, s.prototype.export = s.prototype.output, s.prototype.run = s.prototype.then, $020d60e69294d716$export$ba1e2ffc633a60f5.getPageSize = function(e, r, n) {
        if ("object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(e)) {
            var i = e;
            e = i.orientation, r = i.unit || r, n = i.format || n;
        }
        r = r || "mm", n = n || "a4", e = ("" + (e || "P")).toLowerCase();
        var a, o = ("" + n).toLowerCase(), s = {
            a0: [
                2383.94,
                3370.39
            ],
            a1: [
                1683.78,
                2383.94
            ],
            a2: [
                1190.55,
                1683.78
            ],
            a3: [
                841.89,
                1190.55
            ],
            a4: [
                595.28,
                841.89
            ],
            a5: [
                419.53,
                595.28
            ],
            a6: [
                297.64,
                419.53
            ],
            a7: [
                209.76,
                297.64
            ],
            a8: [
                147.4,
                209.76
            ],
            a9: [
                104.88,
                147.4
            ],
            a10: [
                73.7,
                104.88
            ],
            b0: [
                2834.65,
                4008.19
            ],
            b1: [
                2004.09,
                2834.65
            ],
            b2: [
                1417.32,
                2004.09
            ],
            b3: [
                1000.63,
                1417.32
            ],
            b4: [
                708.66,
                1000.63
            ],
            b5: [
                498.9,
                708.66
            ],
            b6: [
                354.33,
                498.9
            ],
            b7: [
                249.45,
                354.33
            ],
            b8: [
                175.75,
                249.45
            ],
            b9: [
                124.72,
                175.75
            ],
            b10: [
                87.87,
                124.72
            ],
            c0: [
                2599.37,
                3676.54
            ],
            c1: [
                1836.85,
                2599.37
            ],
            c2: [
                1298.27,
                1836.85
            ],
            c3: [
                918.43,
                1298.27
            ],
            c4: [
                649.13,
                918.43
            ],
            c5: [
                459.21,
                649.13
            ],
            c6: [
                323.15,
                459.21
            ],
            c7: [
                229.61,
                323.15
            ],
            c8: [
                161.57,
                229.61
            ],
            c9: [
                113.39,
                161.57
            ],
            c10: [
                79.37,
                113.39
            ],
            dl: [
                311.81,
                623.62
            ],
            letter: [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            legal: [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            ledger: [
                1224,
                792
            ],
            tabloid: [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        switch(r){
            case "pt":
                a = 1;
                break;
            case "mm":
                a = 72 / 25.4;
                break;
            case "cm":
                a = 72 / 2.54;
                break;
            case "in":
                a = 72;
                break;
            case "px":
                a = .75;
                break;
            case "pc":
            case "em":
                a = 12;
                break;
            case "ex":
                a = 6;
                break;
            default:
                throw "Invalid unit: " + r;
        }
        var c, u = 0, h = 0;
        if (s.hasOwnProperty(o)) u = s[o][1] / a, h = s[o][0] / a;
        else try {
            u = n[1], h = n[0];
        } catch (t) {
            throw new Error("Invalid format: " + n);
        }
        if ("p" === e || "portrait" === e) e = "p", h > u && (c = h, h = u, u = c);
        else {
            if ("l" !== e && "landscape" !== e) throw "Invalid orientation: " + e;
            e = "l", u > h && (c = h, h = u, u = c);
        }
        return {
            width: h,
            height: u,
            unit: r,
            k: a,
            orientation: e
        };
    }, e.html = function(t, e) {
        (e = e || {}).callback = e.callback || function() {}, e.html2canvas = e.html2canvas || {}, e.html2canvas.canvas = e.html2canvas.canvas || this.canvas, e.jsPDF = e.jsPDF || this, e.fontFaces = e.fontFaces ? e.fontFaces.map($020d60e69294d716$var$jt) : null;
        var r = new s(e);
        return e.worker ? r : r.from(t).doCallback();
    };
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), $020d60e69294d716$export$ba1e2ffc633a60f5.API.addJS = function(t) {
    return $020d60e69294d716$var$Ht = t, this.internal.events.subscribe("postPutResources", function() {
        $020d60e69294d716$var$Ut = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + ($020d60e69294d716$var$Ut + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), $020d60e69294d716$var$zt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + $020d60e69294d716$var$Ht + ")"), this.internal.out(">>"), this.internal.out("endobj");
    }), this.internal.events.subscribe("putCatalog", function() {
        void 0 !== $020d60e69294d716$var$Ut && void 0 !== $020d60e69294d716$var$zt && this.internal.out("/Names <</JavaScript " + $020d60e69294d716$var$Ut + " 0 R>>");
    }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e;
    t.events.push([
        "postPutResources",
        function() {
            var t = this, r = /^(\d+) 0 obj$/;
            if (this.outline.root.children.length > 0) for(var n = t.outline.render().split(/\r\n/), i = 0; i < n.length; i++){
                var a = n[i], o = r.exec(a);
                if (null != o) {
                    var s = o[1];
                    t.internal.newObjectDeferredBegin(s, !1);
                }
                t.internal.write(a);
            }
            if (this.outline.createNamedDestinations) {
                var c = this.internal.pages.length, u = [];
                for(i = 0; i < c; i++){
                    var h = t.internal.newObject();
                    u.push(h);
                    var l = t.internal.getPageInfo(i + 1);
                    t.internal.write("<< /D[" + l.objId + " 0 R /XYZ null null null]>> endobj");
                }
                var f = t.internal.newObject();
                t.internal.write("<< /Names [ ");
                for(i = 0; i < u.length; i++)t.internal.write("(page_" + (i + 1) + ")" + u[i] + " 0 R");
                t.internal.write(" ] >>", "endobj"), e = t.internal.newObject(), t.internal.write("<< /Dests " + f + " 0 R"), t.internal.write(">>", "endobj");
            }
        }
    ]), t.events.push([
        "putCatalog",
        function() {
            this.outline.root.children.length > 0 && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + e + " 0 R"));
        }
    ]), t.events.push([
        "initialized",
        function() {
            var t = this;
            t.outline = {
                createNamedDestinations: !1,
                root: {
                    children: []
                }
            }, t.outline.add = function(t, e, r) {
                var n = {
                    title: e,
                    options: r,
                    children: []
                };
                return null == t && (t = this.root), t.children.push(n), n;
            }, t.outline.render = function() {
                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
            }, t.outline.genIds_r = function(e) {
                e.id = t.internal.newObjectDeferred();
                for(var r = 0; r < e.children.length; r++)this.genIds_r(e.children[r]);
            }, t.outline.renderRoot = function(t) {
                this.objStart(t), this.line("/Type /Outlines"), t.children.length > 0 && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                    count: 0
                }, t)), this.objEnd();
            }, t.outline.renderItems = function(e) {
                for(var r = this.ctx.pdf.internal.getVerticalCoordinateString, n = 0; n < e.children.length; n++){
                    var i = e.children[n];
                    this.objStart(i), this.line("/Title " + this.makeString(i.title)), this.line("/Parent " + this.makeRef(e)), n > 0 && this.line("/Prev " + this.makeRef(e.children[n - 1])), n < e.children.length - 1 && this.line("/Next " + this.makeRef(e.children[n + 1])), i.children.length > 0 && (this.line("/First " + this.makeRef(i.children[0])), this.line("/Last " + this.makeRef(i.children[i.children.length - 1])));
                    var a = this.count = this.count_r({
                        count: 0
                    }, i);
                    if (a > 0 && this.line("/Count " + a), i.options && i.options.pageNumber) {
                        var o = t.internal.getPageInfo(i.options.pageNumber);
                        this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + r(0) + " 0]");
                    }
                    this.objEnd();
                }
                for(var s = 0; s < e.children.length; s++)this.renderItems(e.children[s]);
            }, t.outline.line = function(t) {
                this.ctx.val += t + "\r\n";
            }, t.outline.makeRef = function(t) {
                return t.id + " 0 R";
            }, t.outline.makeString = function(e) {
                return "(" + t.internal.pdfEscape(e) + ")";
            }, t.outline.objStart = function(t) {
                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
            }, t.outline.objEnd = function() {
                this.ctx.val += ">> \r\nendobj\r\n";
            }, t.outline.count_r = function(t, e) {
                for(var r = 0; r < e.children.length; r++)t.count++, this.count_r(t, e.children[r]);
                return t.count;
            };
        }
    ]);
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = [
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199
    ];
    t.processJPEG = function(t, r, n, i, a, o) {
        var s, c = this.decode.DCT_DECODE, u = null;
        if ("string" == typeof t || this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) {
            switch(t = a || t, t = this.__addimage__.isArrayBuffer(t) ? new Uint8Array(t) : t, (s = function(t) {
                for(var r, n = 256 * t.charCodeAt(4) + t.charCodeAt(5), i = t.length, a = {
                    width: 0,
                    height: 0,
                    numcomponents: 1
                }, o = 4; o < i; o += 2){
                    if (o += n, -1 !== e.indexOf(t.charCodeAt(o + 1))) {
                        r = 256 * t.charCodeAt(o + 5) + t.charCodeAt(o + 6), a = {
                            width: 256 * t.charCodeAt(o + 7) + t.charCodeAt(o + 8),
                            height: r,
                            numcomponents: t.charCodeAt(o + 9)
                        };
                        break;
                    }
                    n = 256 * t.charCodeAt(o + 2) + t.charCodeAt(o + 3);
                }
                return a;
            }(t = this.__addimage__.isArrayBufferView(t) ? this.__addimage__.arrayBufferToBinaryString(t) : t)).numcomponents){
                case 1:
                    o = this.color_spaces.DEVICE_GRAY;
                    break;
                case 4:
                    o = this.color_spaces.DEVICE_CMYK;
                    break;
                case 3:
                    o = this.color_spaces.DEVICE_RGB;
            }
            u = {
                data: t,
                width: s.width,
                height: s.height,
                colorSpace: o,
                bitsPerComponent: 8,
                filter: c,
                index: r,
                alias: n
            };
        }
        return u;
    };
}($020d60e69294d716$export$ba1e2ffc633a60f5.API);
var $020d60e69294d716$var$Vt, $020d60e69294d716$var$Gt, $020d60e69294d716$var$Yt, $020d60e69294d716$var$Jt, $020d60e69294d716$var$Xt, $020d60e69294d716$var$Kt = function() {
    var t, e, i;
    function a(t) {
        var e, r, n, i, a, o, s, c, u, h, l, f, d, p;
        for(this.data = t, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, o = null;;){
            switch(e = this.readUInt32(), u = (function() {
                var t, e;
                for(e = [], t = 0; t < 4; ++t)e.push(String.fromCharCode(this.data[this.pos++]));
                return e;
            }).call(this).join("")){
                case "IHDR":
                    this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
                    break;
                case "acTL":
                    this.animation = {
                        numFrames: this.readUInt32(),
                        numPlays: this.readUInt32() || 1 / 0,
                        frames: []
                    };
                    break;
                case "PLTE":
                    this.palette = this.read(e);
                    break;
                case "fcTL":
                    o && this.animation.frames.push(o), this.pos += 4, o = {
                        width: this.readUInt32(),
                        height: this.readUInt32(),
                        xOffset: this.readUInt32(),
                        yOffset: this.readUInt32()
                    }, a = this.readUInt16(), i = this.readUInt16() || 100, o.delay = 1e3 * a / i, o.disposeOp = this.data[this.pos++], o.blendOp = this.data[this.pos++], o.data = [];
                    break;
                case "IDAT":
                case "fdAT":
                    for("fdAT" === u && (this.pos += 4, e -= 4), t = (null != o ? o.data : void 0) || this.imgData, f = 0; 0 <= e ? f < e : f > e; 0 <= e ? ++f : --f)t.push(this.data[this.pos++]);
                    break;
                case "tRNS":
                    switch(this.transparency = {}, this.colorType){
                        case 3:
                            if (n = this.palette.length / 3, this.transparency.indexed = this.read(e), this.transparency.indexed.length > n) throw new Error("More transparent colors than palette size");
                            if ((h = n - this.transparency.indexed.length) > 0) for(d = 0; 0 <= h ? d < h : d > h; 0 <= h ? ++d : --d)this.transparency.indexed.push(255);
                            break;
                        case 0:
                            this.transparency.grayscale = this.read(e)[0];
                            break;
                        case 2:
                            this.transparency.rgb = this.read(e);
                    }
                    break;
                case "tEXt":
                    s = (l = this.read(e)).indexOf(0), c = String.fromCharCode.apply(String, l.slice(0, s)), this.text[c] = String.fromCharCode.apply(String, l.slice(s + 1));
                    break;
                case "IEND":
                    return o && this.animation.frames.push(o), this.colors = (function() {
                        switch(this.colorType){
                            case 0:
                            case 3:
                            case 4:
                                return 1;
                            case 2:
                            case 6:
                                return 3;
                        }
                    }).call(this), this.hasAlphaChannel = 4 === (p = this.colorType) || 6 === p, r = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * r, this.colorSpace = (function() {
                        switch(this.colors){
                            case 1:
                                return "DeviceGray";
                            case 3:
                                return "DeviceRGB";
                        }
                    }).call(this), void (this.imgData = new Uint8Array(this.imgData));
                default:
                    this.pos += e;
            }
            if (this.pos += 4, this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
        }
    }
    a.prototype.read = function(t) {
        var e, r;
        for(r = [], e = 0; 0 <= t ? e < t : e > t; 0 <= t ? ++e : --e)r.push(this.data[this.pos++]);
        return r;
    }, a.prototype.readUInt32 = function() {
        return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
    }, a.prototype.readUInt16 = function() {
        return this.data[this.pos++] << 8 | this.data[this.pos++];
    }, a.prototype.decodePixels = function(t) {
        var e = this.pixelBitlength / 8, n = new Uint8Array(this.width * this.height * e), i = 0, a = this;
        if (null == t && (t = this.imgData), 0 === t.length) return new Uint8Array(0);
        function o(r, o, s, c) {
            var u, h, l, f, d, p, g, m, v, b, y, w, N, L, A, x, S, _, P, k, I, F = Math.ceil((a.width - r) / s), C = Math.ceil((a.height - o) / c), j = a.width == F && a.height == C;
            for(L = e * F, w = j ? n : new Uint8Array(L * C), p = t.length, N = 0, h = 0; N < C && i < p;){
                switch(t[i++]){
                    case 0:
                        for(f = S = 0; S < L; f = S += 1)w[h++] = t[i++];
                        break;
                    case 1:
                        for(f = _ = 0; _ < L; f = _ += 1)u = t[i++], d = f < e ? 0 : w[h - e], w[h++] = (u + d) % 256;
                        break;
                    case 2:
                        for(f = P = 0; P < L; f = P += 1)u = t[i++], l = (f - f % e) / e, A = N && w[(N - 1) * L + l * e + f % e], w[h++] = (A + u) % 256;
                        break;
                    case 3:
                        for(f = k = 0; k < L; f = k += 1)u = t[i++], l = (f - f % e) / e, d = f < e ? 0 : w[h - e], A = N && w[(N - 1) * L + l * e + f % e], w[h++] = (u + Math.floor((d + A) / 2)) % 256;
                        break;
                    case 4:
                        for(f = I = 0; I < L; f = I += 1)u = t[i++], l = (f - f % e) / e, d = f < e ? 0 : w[h - e], 0 === N ? A = x = 0 : (A = w[(N - 1) * L + l * e + f % e], x = l && w[(N - 1) * L + (l - 1) * e + f % e]), g = d + A - x, m = Math.abs(g - d), b = Math.abs(g - A), y = Math.abs(g - x), v = m <= b && m <= y ? d : b <= y ? A : x, w[h++] = (u + v) % 256;
                        break;
                    default:
                        throw new Error("Invalid filter algorithm: " + t[i - 1]);
                }
                if (!j) {
                    var O = ((o + N * c) * a.width + r) * e, B = N * L;
                    for(f = 0; f < F; f += 1){
                        for(var M = 0; M < e; M += 1)n[O++] = w[B++];
                        O += (s - 1) * e;
                    }
                }
                N++;
            }
        }
        return t = (0, $3ae101cb5c0083b5$export$9ec8134f0f1b9fc6)(t), 1 == a.interlaceMethod ? (o(0, 0, 8, 8), o(4, 0, 8, 8), o(0, 4, 4, 8), o(2, 0, 4, 4), o(0, 2, 2, 4), o(1, 0, 2, 2), o(0, 1, 1, 2)) : o(0, 0, 1, 1), n;
    }, a.prototype.decodePalette = function() {
        var t, e, r, n, i, a, o, s, c;
        for(r = this.palette, a = this.transparency.indexed || [], i = new Uint8Array((a.length || 0) + r.length), n = 0, t = 0, e = o = 0, s = r.length; o < s; e = o += 3)i[n++] = r[e], i[n++] = r[e + 1], i[n++] = r[e + 2], i[n++] = null != (c = a[t++]) ? c : 255;
        return i;
    }, a.prototype.copyToImageData = function(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f;
        if (n = this.colors, h = null, r = this.hasAlphaChannel, this.palette.length && (h = null != (f = this._decodedPalette) ? f : this._decodedPalette = this.decodePalette(), n = 4, r = !0), u = (i = t.data || t).length, o = h || e, a = s = 0, 1 === n) for(; a < u;)c = h ? 4 * e[a / 4] : s, l = o[c++], i[a++] = l, i[a++] = l, i[a++] = l, i[a++] = r ? o[c++] : 255, s = c;
        else for(; a < u;)c = h ? 4 * e[a / 4] : s, i[a++] = o[c++], i[a++] = o[c++], i[a++] = o[c++], i[a++] = r ? o[c++] : 255, s = c;
    }, a.prototype.decode = function() {
        var t;
        return t = new Uint8Array(this.width * this.height * 4), this.copyToImageData(t, this.decodePixels()), t;
    };
    var o = function() {
        if ("[object Window]" === Object.prototype.toString.call($020d60e69294d716$var$n)) {
            try {
                e = $020d60e69294d716$var$n.document.createElement("canvas"), i = e.getContext("2d");
            } catch (t) {
                return !1;
            }
            return !0;
        }
        return !1;
    };
    return o(), t = function(t) {
        var r;
        if (!0 === o()) return i.width = t.width, i.height = t.height, i.clearRect(0, 0, t.width, t.height), i.putImageData(t, 0, 0), (r = new Image).src = e.toDataURL(), r;
        throw new Error("This method requires a Browser with Canvas-capability.");
    }, a.prototype.decodeFrames = function(e) {
        var r, n, i, a, o, s, c, u;
        if (this.animation) {
            for(u = [], n = o = 0, s = (c = this.animation.frames).length; o < s; n = ++o)r = c[n], i = e.createImageData(r.width, r.height), a = this.decodePixels(new Uint8Array(r.data)), this.copyToImageData(i, a), r.imageData = i, u.push(r.image = t(i));
            return u;
        }
    }, a.prototype.renderFrame = function(t, e) {
        var r, n, i;
        return r = (n = this.animation.frames)[e], i = n[e - 1], 0 === e && t.clearRect(0, 0, this.width, this.height), 1 === (null != i ? i.disposeOp : void 0) ? t.clearRect(i.xOffset, i.yOffset, i.width, i.height) : 2 === (null != i ? i.disposeOp : void 0) && t.putImageData(i.imageData, i.xOffset, i.yOffset), 0 === r.blendOp && t.clearRect(r.xOffset, r.yOffset, r.width, r.height), t.drawImage(r.image, r.xOffset, r.yOffset);
    }, a.prototype.animate = function(t) {
        var e, r, n, i, a, o, s = this;
        return r = 0, o = this.animation, i = o.numFrames, n = o.frames, a = o.numPlays, (e = function() {
            var o, c;
            if (o = r++ % i, c = n[o], s.renderFrame(t, o), i > 1 && r / i < a) return s.animation._timeout = setTimeout(e, c.delay);
        })();
    }, a.prototype.stopAnimation = function() {
        var t;
        return clearTimeout(null != (t = this.animation) ? t._timeout : void 0);
    }, a.prototype.render = function(t) {
        var e, r;
        return t._png && t._png.stopAnimation(), t._png = this, t.width = this.width, t.height = this.height, e = t.getContext("2d"), this.animation ? (this.decodeFrames(e), this.animate(e)) : (r = e.createImageData(this.width, this.height), this.copyToImageData(r, this.decodePixels()), e.putImageData(r, 0, 0));
    }, a;
}();
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ /**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */ function $020d60e69294d716$var$Zt(t) {
    var e = 0;
    if (71 !== t[e++] || 73 !== t[e++] || 70 !== t[e++] || 56 !== t[e++] || 56 != (t[e++] + 1 & 253) || 97 !== t[e++]) throw new Error("Invalid GIF 87a/89a header.");
    var r = t[e++] | t[e++] << 8, n = t[e++] | t[e++] << 8, i = t[e++], a = i >> 7, o = 1 << (7 & i) + 1;
    t[e++];
    t[e++];
    var s = null, c = null;
    a && (s = e, c = o, e += 3 * o);
    var u = !0, h = [], l = 0, f = null, d = 0, p = null;
    for(this.width = r, this.height = n; u && e < t.length;)switch(t[e++]){
        case 33:
            switch(t[e++]){
                case 255:
                    if (11 !== t[e] || 78 == t[e + 1] && 69 == t[e + 2] && 84 == t[e + 3] && 83 == t[e + 4] && 67 == t[e + 5] && 65 == t[e + 6] && 80 == t[e + 7] && 69 == t[e + 8] && 50 == t[e + 9] && 46 == t[e + 10] && 48 == t[e + 11] && 3 == t[e + 12] && 1 == t[e + 13] && 0 == t[e + 16]) e += 14, p = t[e++] | t[e++] << 8, e++;
                    else for(e += 12;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                case 249:
                    if (4 !== t[e++] || 0 !== t[e + 4]) throw new Error("Invalid graphics extension block.");
                    var g = t[e++];
                    l = t[e++] | t[e++] << 8, f = t[e++], 0 == (1 & g) && (f = null), d = g >> 2 & 7, e++;
                    break;
                case 254:
                    for(;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                default:
                    throw new Error("Unknown graphic control label: 0x" + t[e - 1].toString(16));
            }
            break;
        case 44:
            var m = t[e++] | t[e++] << 8, v = t[e++] | t[e++] << 8, b = t[e++] | t[e++] << 8, y = t[e++] | t[e++] << 8, w = t[e++], N = w >> 6 & 1, L = 1 << (7 & w) + 1, A = s, x = c, S = !1;
            if (w >> 7) {
                S = !0;
                A = e, x = L, e += 3 * L;
            }
            var _ = e;
            for(e++;;){
                var P;
                if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                if (0 === P) break;
                e += P;
            }
            h.push({
                x: m,
                y: v,
                width: b,
                height: y,
                has_local_palette: S,
                palette_offset: A,
                palette_size: x,
                data_offset: _,
                data_length: e - _,
                transparent_index: f,
                interlaced: !!N,
                delay: l,
                disposal: d
            });
            break;
        case 59:
            u = !1;
            break;
        default:
            throw new Error("Unknown gif block: 0x" + t[e - 1].toString(16));
    }
    this.numFrames = function() {
        return h.length;
    }, this.loopCount = function() {
        return p;
    }, this.frameInfo = function(t) {
        if (t < 0 || t >= h.length) throw new Error("Frame index out of range.");
        return h[t];
    }, this.decodeAndBlitFrameBGRA = function(e, n) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        $020d60e69294d716$var$$t(t, i.data_offset, o, a);
        var s = i.palette_offset, c = i.transparent_index;
        null === c && (c = 256);
        var u = i.width, h = r - u, l = u, f = 4 * (i.y * r + i.x), d = 4 * ((i.y + i.height) * r + i.x), p = f, g = 4 * h;
        !0 === i.interlaced && (g += 4 * r * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === l && (l = u, (p += g) >= d && (g = 4 * h + 4 * r * (m - 1), p = f + (u + h) * (m << 1), m >>= 1)), y === c) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                n[p++] = L, n[p++] = N, n[p++] = w, n[p++] = 255;
            }
            --l;
        }
    }, this.decodeAndBlitFrameRGBA = function(e, n) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        $020d60e69294d716$var$$t(t, i.data_offset, o, a);
        var s = i.palette_offset, c = i.transparent_index;
        null === c && (c = 256);
        var u = i.width, h = r - u, l = u, f = 4 * (i.y * r + i.x), d = 4 * ((i.y + i.height) * r + i.x), p = f, g = 4 * h;
        !0 === i.interlaced && (g += 4 * r * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === l && (l = u, (p += g) >= d && (g = 4 * h + 4 * r * (m - 1), p = f + (u + h) * (m << 1), m >>= 1)), y === c) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                n[p++] = w, n[p++] = N, n[p++] = L, n[p++] = 255;
            }
            --l;
        }
    };
}
function $020d60e69294d716$var$$t(t, e, r, n) {
    for(var i = t[e++], o = 1 << i, s = o + 1, c = s + 1, u = i + 1, h = (1 << u) - 1, l = 0, f = 0, d = 0, p = t[e++], g = new Int32Array(4096), m = null;;){
        for(; l < 16 && 0 !== p;)f |= t[e++] << l, l += 8, 1 === p ? p = t[e++] : --p;
        if (l < u) break;
        var v = f & h;
        if (f >>= u, l -= u, v !== o) {
            if (v === s) break;
            for(var b = v < c ? v : m, y = 0, w = b; w > o;)w = g[w] >> 8, ++y;
            var N = w;
            if (d + y + (b !== v ? 1 : 0) > n) return void $020d60e69294d716$var$a.log("Warning, gif stream longer than expected.");
            r[d++] = N;
            var L = d += y;
            for(b !== v && (r[d++] = N), w = b; y--;)w = g[w], r[--L] = 255 & w, w >>= 8;
            null !== m && c < 4096 && (g[c++] = m << 8 | N, c >= h + 1 && u < 12 && (++u, h = h << 1 | 1)), m = v;
        } else c = s + 1, h = (1 << (u = i + 1)) - 1, m = null;
    }
    return d !== n && $020d60e69294d716$var$a.log("Warning, gif stream shorter than expected."), r;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ function $020d60e69294d716$var$Qt(t) {
    var e, r, n, i, a, o = Math.floor, s = new Array(64), c = new Array(64), u = new Array(64), h = new Array(64), l = new Array(65535), f = new Array(65535), d = new Array(64), p = new Array(64), g = [], m = 0, v = 7, b = new Array(64), y = new Array(64), w = new Array(64), N = new Array(256), L = new Array(2048), A = [
        0,
        1,
        5,
        6,
        14,
        15,
        27,
        28,
        2,
        4,
        7,
        13,
        16,
        26,
        29,
        42,
        3,
        8,
        12,
        17,
        25,
        30,
        41,
        43,
        9,
        11,
        18,
        24,
        31,
        40,
        44,
        53,
        10,
        19,
        23,
        32,
        39,
        45,
        52,
        54,
        20,
        22,
        33,
        38,
        46,
        51,
        55,
        60,
        21,
        34,
        37,
        47,
        50,
        56,
        59,
        61,
        35,
        36,
        48,
        49,
        57,
        58,
        62,
        63
    ], x = [
        0,
        0,
        1,
        5,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], S = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], _ = [
        0,
        0,
        2,
        1,
        3,
        3,
        2,
        4,
        3,
        5,
        5,
        4,
        4,
        0,
        0,
        1,
        125
    ], P = [
        1,
        2,
        3,
        0,
        4,
        17,
        5,
        18,
        33,
        49,
        65,
        6,
        19,
        81,
        97,
        7,
        34,
        113,
        20,
        50,
        129,
        145,
        161,
        8,
        35,
        66,
        177,
        193,
        21,
        82,
        209,
        240,
        36,
        51,
        98,
        114,
        130,
        9,
        10,
        22,
        23,
        24,
        25,
        26,
        37,
        38,
        39,
        40,
        41,
        42,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ], k = [
        0,
        0,
        3,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0
    ], I = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], F = [
        0,
        0,
        2,
        1,
        2,
        4,
        4,
        3,
        4,
        7,
        5,
        4,
        4,
        0,
        1,
        2,
        119
    ], C = [
        0,
        1,
        2,
        3,
        17,
        4,
        5,
        33,
        49,
        6,
        18,
        65,
        81,
        7,
        97,
        113,
        19,
        34,
        50,
        129,
        8,
        20,
        66,
        145,
        161,
        177,
        193,
        9,
        35,
        51,
        82,
        240,
        21,
        98,
        114,
        209,
        10,
        22,
        36,
        52,
        225,
        37,
        241,
        23,
        24,
        25,
        26,
        38,
        39,
        40,
        41,
        42,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ];
    function j(t, e) {
        for(var r = 0, n = 0, i = new Array, a = 1; a <= 16; a++){
            for(var o = 1; o <= t[a]; o++)i[e[n]] = [], i[e[n]][0] = r, i[e[n]][1] = a, n++, r++;
            r *= 2;
        }
        return i;
    }
    function O(t) {
        for(var e = t[0], r = t[1] - 1; r >= 0;)e & 1 << r && (m |= 1 << v), r--, --v < 0 && (255 == m ? (B(255), B(0)) : B(m), v = 7, m = 0);
    }
    function B(t) {
        g.push(t);
    }
    function M(t) {
        B(t >> 8 & 255), B(255 & t);
    }
    function E(t, e, r, n, i) {
        for(var a, o = i[0], s = i[240], c = function(t, e) {
            var r, n, i, a, o, s, c, u, h, l, f = 0;
            for(h = 0; h < 8; ++h){
                r = t[f], n = t[f + 1], i = t[f + 2], a = t[f + 3], o = t[f + 4], s = t[f + 5], c = t[f + 6];
                var p = r + (u = t[f + 7]), g = r - u, m = n + c, v = n - c, b = i + s, y = i - s, w = a + o, N = a - o, L = p + w, A = p - w, x = m + b, S = m - b;
                t[f] = L + x, t[f + 4] = L - x;
                var _ = .707106781 * (S + A);
                t[f + 2] = A + _, t[f + 6] = A - _;
                var P = .382683433 * ((L = N + y) - (S = v + g)), k = .5411961 * L + P, I = 1.306562965 * S + P, F = .707106781 * (x = y + v), C = g + F, j = g - F;
                t[f + 5] = j + k, t[f + 3] = j - k, t[f + 1] = C + I, t[f + 7] = C - I, f += 8;
            }
            for(f = 0, h = 0; h < 8; ++h){
                r = t[f], n = t[f + 8], i = t[f + 16], a = t[f + 24], o = t[f + 32], s = t[f + 40], c = t[f + 48];
                var O = r + (u = t[f + 56]), B = r - u, M = n + c, E = n - c, q = i + s, D = i - s, R = a + o, T = a - o, U = O + R, z = O - R, H = M + q, W = M - q;
                t[f] = U + H, t[f + 32] = U - H;
                var V = .707106781 * (W + z);
                t[f + 16] = z + V, t[f + 48] = z - V;
                var G = .382683433 * ((U = T + D) - (W = E + B)), Y = .5411961 * U + G, J = 1.306562965 * W + G, X = .707106781 * (H = D + E), K = B + X, Z = B - X;
                t[f + 40] = Z + Y, t[f + 24] = Z - Y, t[f + 8] = K + J, t[f + 56] = K - J, f++;
            }
            for(h = 0; h < 64; ++h)l = t[h] * e[h], d[h] = l > 0 ? l + .5 | 0 : l - .5 | 0;
            return d;
        }(t, e), u = 0; u < 64; ++u)p[A[u]] = c[u];
        var h = p[0] - r;
        r = p[0], 0 == h ? O(n[0]) : (O(n[f[a = 32767 + h]]), O(l[a]));
        for(var g = 63; g > 0 && 0 == p[g];)g--;
        if (0 == g) return O(o), r;
        for(var m, v = 1; v <= g;){
            for(var b = v; 0 == p[v] && v <= g;)++v;
            var y = v - b;
            if (y >= 16) {
                m = y >> 4;
                for(var w = 1; w <= m; ++w)O(s);
                y &= 15;
            }
            a = 32767 + p[v], O(i[(y << 4) + f[a]]), O(l[a]), v++;
        }
        return 63 != g && O(o), r;
    }
    function q(t) {
        (t = Math.min(Math.max(t, 1), 100), a != t) && (!function(t) {
            for(var e = [
                16,
                11,
                10,
                16,
                24,
                40,
                51,
                61,
                12,
                12,
                14,
                19,
                26,
                58,
                60,
                55,
                14,
                13,
                16,
                24,
                40,
                57,
                69,
                56,
                14,
                17,
                22,
                29,
                51,
                87,
                80,
                62,
                18,
                22,
                37,
                56,
                68,
                109,
                103,
                77,
                24,
                35,
                55,
                64,
                81,
                104,
                113,
                92,
                49,
                64,
                78,
                87,
                103,
                121,
                120,
                101,
                72,
                92,
                95,
                98,
                112,
                100,
                103,
                99
            ], r = 0; r < 64; r++){
                var n = o((e[r] * t + 50) / 100);
                n = Math.min(Math.max(n, 1), 255), s[A[r]] = n;
            }
            for(var i = [
                17,
                18,
                24,
                47,
                99,
                99,
                99,
                99,
                18,
                21,
                26,
                66,
                99,
                99,
                99,
                99,
                24,
                26,
                56,
                99,
                99,
                99,
                99,
                99,
                47,
                66,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99
            ], a = 0; a < 64; a++){
                var l = o((i[a] * t + 50) / 100);
                l = Math.min(Math.max(l, 1), 255), c[A[a]] = l;
            }
            for(var f = [
                1,
                1.387039845,
                1.306562965,
                1.175875602,
                1,
                .785694958,
                .5411961,
                .275899379
            ], d = 0, p = 0; p < 8; p++)for(var g = 0; g < 8; g++)u[d] = 1 / (s[A[d]] * f[p] * f[g] * 8), h[d] = 1 / (c[A[d]] * f[p] * f[g] * 8), d++;
        }(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), a = t);
    }
    this.encode = function(t, a) {
        a && q(a), g = new Array, m = 0, v = 7, M(65496), M(65504), M(16), B(74), B(70), B(73), B(70), B(0), B(1), B(1), B(0), M(1), M(1), B(0), B(0), function() {
            M(65499), M(132), B(0);
            for(var t = 0; t < 64; t++)B(s[t]);
            B(1);
            for(var e = 0; e < 64; e++)B(c[e]);
        }(), function(t, e) {
            M(65472), M(17), B(8), M(e), M(t), B(3), B(1), B(17), B(0), B(2), B(17), B(1), B(3), B(17), B(1);
        }(t.width, t.height), function() {
            M(65476), M(418), B(0);
            for(var t = 0; t < 16; t++)B(x[t + 1]);
            for(var e = 0; e <= 11; e++)B(S[e]);
            B(16);
            for(var r = 0; r < 16; r++)B(_[r + 1]);
            for(var n = 0; n <= 161; n++)B(P[n]);
            B(1);
            for(var i = 0; i < 16; i++)B(k[i + 1]);
            for(var a = 0; a <= 11; a++)B(I[a]);
            B(17);
            for(var o = 0; o < 16; o++)B(F[o + 1]);
            for(var s = 0; s <= 161; s++)B(C[s]);
        }(), M(65498), M(12), B(3), B(1), B(0), B(2), B(17), B(3), B(17), B(0), B(63), B(0);
        var o = 0, l = 0, f = 0;
        m = 0, v = 7, this.encode.displayName = "_encode_";
        for(var d, p, N, A, j, D, R, T, U, z = t.data, H = t.width, W = t.height, V = 4 * H, G = 0; G < W;){
            for(d = 0; d < V;){
                for(j = V * G + d, R = -1, T = 0, U = 0; U < 64; U++)D = j + (T = U >> 3) * V + (R = 4 * (7 & U)), G + T >= W && (D -= V * (G + 1 + T - W)), d + R >= V && (D -= d + R - V + 4), p = z[D++], N = z[D++], A = z[D++], b[U] = (L[p] + L[N + 256 >> 0] + L[A + 512 >> 0] >> 16) - 128, y[U] = (L[p + 768 >> 0] + L[N + 1024 >> 0] + L[A + 1280 >> 0] >> 16) - 128, w[U] = (L[p + 1280 >> 0] + L[N + 1536 >> 0] + L[A + 1792 >> 0] >> 16) - 128;
                o = E(b, u, o, e, n), l = E(y, h, l, r, i), f = E(w, h, f, r, i), d += 32;
            }
            G += 8;
        }
        if (v >= 0) {
            var Y = [];
            Y[1] = v + 1, Y[0] = (1 << v + 1) - 1, O(Y);
        }
        return M(65497), new Uint8Array(g);
    }, t = t || 50, function() {
        for(var t = String.fromCharCode, e = 0; e < 256; e++)N[e] = t(e);
    }(), e = j(x, S), r = j(k, I), n = j(_, P), i = j(F, C), function() {
        for(var t = 1, e = 2, r = 1; r <= 15; r++){
            for(var n = t; n < e; n++)f[32767 + n] = r, l[32767 + n] = [], l[32767 + n][1] = r, l[32767 + n][0] = n;
            for(var i = -(e - 1); i <= -t; i++)f[32767 + i] = r, l[32767 + i] = [], l[32767 + i][1] = r, l[32767 + i][0] = e - 1 + i;
            t <<= 1, e <<= 1;
        }
    }(), function() {
        for(var t = 0; t < 256; t++)L[t] = 19595 * t, L[t + 256 >> 0] = 38470 * t, L[t + 512 >> 0] = 7471 * t + 32768, L[t + 768 >> 0] = -11059 * t, L[t + 1024 >> 0] = -21709 * t, L[t + 1280 >> 0] = 32768 * t + 8421375, L[t + 1536 >> 0] = -27439 * t, L[t + 1792 >> 0] = -5329 * t;
    }(), q(t);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function $020d60e69294d716$var$te(t, e) {
    if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
        "BM",
        "BA",
        "CI",
        "CP",
        "IC",
        "PT"
    ].indexOf(this.flag)) throw new Error("Invalid BMP File");
    this.parseHeader(), this.parseBGR();
}
function $020d60e69294d716$var$ee(t) {
    function e(t) {
        if (!t) throw Error("assert :P");
    }
    function r(t, e, r) {
        for(var n = 0; 4 > n; n++)if (t[e + n] != r.charCodeAt(n)) return !0;
        return !1;
    }
    function n(t, e, r, n, i) {
        for(var a = 0; a < i; a++)t[e + a] = r[n + a];
    }
    function i(t, e, r, n) {
        for(var i = 0; i < n; i++)t[e + i] = r;
    }
    function a(t) {
        return new Int32Array(t);
    }
    function o(t, e) {
        for(var r = [], n = 0; n < t; n++)r.push(new e);
        return r;
    }
    function s(t, e) {
        var r = [];
        return function t(r, n, i) {
            for(var a = i[n], o = 0; o < a && (r.push(i.length > n + 1 ? [] : new e), !(i.length < n + 1)); o++)t(r[o], n + 1, i);
        }(r, 0, t), r;
    }
    var c = function() {
        var t = this;
        function c(t, e) {
            for(var r = 1 << e - 1 >>> 0; t & r;)r >>>= 1;
            return r ? (t & r - 1) + r : t;
        }
        function u(t, r, n, i, a) {
            e(!(i % n));
            do t[r + (i -= n)] = a;
            while (0 < i);
        }
        function h(t, r, n, i, o) {
            if (e(2328 >= o), 512 >= o) var s = a(512);
            else if (null == (s = a(o))) return 0;
            return function(t, r, n, i, o, s) {
                var h, f, d = r, p = 1 << n, g = a(16), m = a(16);
                for(e(0 != o), e(null != i), e(null != t), e(0 < n), f = 0; f < o; ++f){
                    if (15 < i[f]) return 0;
                    ++g[i[f]];
                }
                if (g[0] == o) return 0;
                for(m[1] = 0, h = 1; 15 > h; ++h){
                    if (g[h] > 1 << h) return 0;
                    m[h + 1] = m[h] + g[h];
                }
                for(f = 0; f < o; ++f)h = i[f], 0 < i[f] && (s[m[h]++] = f);
                if (1 == m[15]) return (i = new l).g = 0, i.value = s[0], u(t, d, 1, p, i), p;
                var v, b = -1, y = p - 1, w = 0, N = 1, L = 1, A = 1 << n;
                for(f = 0, h = 1, o = 2; h <= n; ++h, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[h])) return 0;
                    for(; 0 < g[h]; --g[h])(i = new l).g = h, i.value = s[f++], u(t, d + w, o, A, i), w = c(w, h);
                }
                for(h = n + 1, o = 2; 15 >= h; ++h, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[h])) return 0;
                    for(; 0 < g[h]; --g[h]){
                        if (i = new l, (w & y) != b) {
                            for(d += A, v = 1 << (b = h) - n; 15 > b && !(0 >= (v -= g[b]));)++b, v <<= 1;
                            p += A = 1 << (v = b - n), t[r + (b = w & y)].g = v + n, t[r + b].value = d - r - b;
                        }
                        i.g = h - n, i.value = s[f++], u(t, d + (w >> n), o, A, i), w = c(w, h);
                    }
                }
                return N != 2 * m[15] - 1 ? 0 : p;
            }(t, r, n, i, o, s);
        }
        function l() {
            this.value = this.g = 0;
        }
        function f() {
            this.value = this.g = 0;
        }
        function d() {
            this.G = o(5, l), this.H = a(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o(Dr, f);
        }
        function p(t, r, n, i) {
            e(null != t), e(null != r), e(2147483648 > i), t.Ca = 254, t.I = 0, t.b = -8, t.Ka = 0, t.oa = r, t.pa = n, t.Jd = r, t.Yc = n + i, t.Zc = 4 <= i ? n + i - 4 + 1 : n, _(t);
        }
        function g(t, e) {
            for(var r = 0; 0 < e--;)r |= k(t, 128) << e;
            return r;
        }
        function m(t, e) {
            var r = g(t, e);
            return P(t) ? -r : r;
        }
        function v(t, r, n, i) {
            var a, o = 0;
            for(e(null != t), e(null != r), e(4294967288 > i), t.Sb = i, t.Ra = 0, t.u = 0, t.h = 0, 4 < i && (i = 4), a = 0; a < i; ++a)o += r[n + a] << 8 * a;
            t.Ra = o, t.bb = i, t.oa = r, t.pa = n;
        }
        function b(t) {
            for(; 8 <= t.u && t.bb < t.Sb;)t.Ra >>>= 8, t.Ra += t.oa[t.pa + t.bb] << Ur - 8 >>> 0, ++t.bb, t.u -= 8;
            A(t) && (t.h = 1, t.u = 0);
        }
        function y(t, r) {
            if (e(0 <= r), !t.h && r <= Tr) {
                var n = L(t) & Rr[r];
                return t.u += r, b(t), n;
            }
            return t.h = 1, t.u = 0;
        }
        function w() {
            this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
        }
        function N() {
            this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
        }
        function L(t) {
            return t.Ra >>> (t.u & Ur - 1) >>> 0;
        }
        function A(t) {
            return e(t.bb <= t.Sb), t.h || t.bb == t.Sb && t.u > Ur;
        }
        function x(t, e) {
            t.u = e, t.h = A(t);
        }
        function S(t) {
            t.u >= zr && (e(t.u >= zr), b(t));
        }
        function _(t) {
            e(null != t && null != t.oa), t.pa < t.Zc ? (t.I = (t.oa[t.pa++] | t.I << 8) >>> 0, t.b += 8) : (e(null != t && null != t.oa), t.pa < t.Yc ? (t.b += 8, t.I = t.oa[t.pa++] | t.I << 8) : t.Ka ? t.b = 0 : (t.I <<= 8, t.b += 8, t.Ka = 1));
        }
        function P(t) {
            return g(t, 1);
        }
        function k(t, e) {
            var r = t.Ca;
            0 > t.b && _(t);
            var n = t.b, i = r * e >>> 8, a = (t.I >>> n > i) + 0;
            for(a ? (r -= i, t.I -= i + 1 << n >>> 0) : r = i + 1, n = r, i = 0; 256 <= n;)i += 8, n >>= 8;
            return n = 7 ^ i + Hr[n], t.b -= n, t.Ca = (r << n) - 1, a;
        }
        function I(t, e, r) {
            t[e + 0] = r >> 24 & 255, t[e + 1] = r >> 16 & 255, t[e + 2] = r >> 8 & 255, t[e + 3] = r >> 0 & 255;
        }
        function F(t, e) {
            return t[e + 0] << 0 | t[e + 1] << 8;
        }
        function C(t, e) {
            return F(t, e) | t[e + 2] << 16;
        }
        function j(t, e) {
            return F(t, e) | F(t, e + 2) << 16;
        }
        function O(t, r) {
            var n = 1 << r;
            return e(null != t), e(0 < r), t.X = a(n), null == t.X ? 0 : (t.Mb = 32 - r, t.Xa = r, 1);
        }
        function B(t, r) {
            e(null != t), e(null != r), e(t.Xa == r.Xa), n(r.X, 0, t.X, 0, 1 << r.Xa);
        }
        function M() {
            this.X = [], this.Xa = this.Mb = 0;
        }
        function E(t, r, n, i) {
            e(null != n), e(null != i);
            var a = n[0], o = i[0];
            return 0 == a && (a = (t * o + r / 2) / r), 0 == o && (o = (r * a + t / 2) / t), 0 >= a || 0 >= o ? 0 : (n[0] = a, i[0] = o, 1);
        }
        function q(t, e) {
            return t + (1 << e) - 1 >>> e;
        }
        function D(t, e) {
            return ((4278255360 & t) + (4278255360 & e) >>> 0 & 4278255360) + ((16711935 & t) + (16711935 & e) >>> 0 & 16711935) >>> 0;
        }
        function R(e, r) {
            t[r] = function(r, n, i, a, o, s, c) {
                var u;
                for(u = 0; u < o; ++u){
                    var h = t[e](s[c + u - 1], i, a + u);
                    s[c + u] = D(r[n + u], h);
                }
            };
        }
        function T() {
            this.ud = this.hd = this.jd = 0;
        }
        function U(t, e) {
            return ((4278124286 & (t ^ e)) >>> 1) + (t & e) >>> 0;
        }
        function z(t) {
            return 0 <= t && 256 > t ? t : 0 > t ? 0 : 255 < t ? 255 : void 0;
        }
        function H(t, e) {
            return z(t + (t - e + .5 >> 1));
        }
        function W(t, e, r) {
            return Math.abs(e - r) - Math.abs(t - r);
        }
        function V(t, e, r, n, i, a, o) {
            for(n = a[o - 1], r = 0; r < i; ++r)a[o + r] = n = D(t[e + r], n);
        }
        function G(t, e, r, n, i) {
            var a;
            for(a = 0; a < r; ++a){
                var o = t[e + a], s = o >> 8 & 255, c = 16711935 & (c = (c = 16711935 & o) + ((s << 16) + s));
                n[i + a] = (4278255360 & o) + c >>> 0;
            }
        }
        function Y(t, e) {
            e.jd = t >> 0 & 255, e.hd = t >> 8 & 255, e.ud = t >> 16 & 255;
        }
        function J(t, e, r, n, i, a) {
            var o;
            for(o = 0; o < n; ++o){
                var s = e[r + o], c = s >>> 8, u = s, h = 255 & (h = (h = s >>> 16) + ((t.jd << 24 >> 24) * (c << 24 >> 24) >>> 5));
                u = 255 & (u = (u = u + ((t.hd << 24 >> 24) * (c << 24 >> 24) >>> 5)) + ((t.ud << 24 >> 24) * (h << 24 >> 24) >>> 5));
                i[a + o] = (4278255360 & s) + (h << 16) + u;
            }
        }
        function X(e, r, n, i, a) {
            t[r] = function(t, e, r, n, o, s, c, u, h) {
                for(n = c; n < u; ++n)for(c = 0; c < h; ++c)o[s++] = a(r[i(t[e++])]);
            }, t[e] = function(e, r, o, s, c, u, h) {
                var l = 8 >> e.b, f = e.Ea, d = e.K[0], p = e.w;
                if (8 > l) for(e = (1 << e.b) - 1, p = (1 << l) - 1; r < o; ++r){
                    var g, m = 0;
                    for(g = 0; g < f; ++g)g & e || (m = i(s[c++])), u[h++] = a(d[m & p]), m >>= l;
                }
                else t["VP8LMapColor" + n](s, c, d, p, u, h, r, o, f);
            };
        }
        function K(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 16 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 0 & 255;
            }
        }
        function Z(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 16 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 0 & 255, n[i++] = a >> 24 & 255;
            }
        }
        function $(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = (o = t[e++]) >> 16 & 240 | o >> 12 & 15, o = o >> 0 & 240 | o >> 28 & 15;
                n[i++] = a, n[i++] = o;
            }
        }
        function Q(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = (o = t[e++]) >> 16 & 248 | o >> 13 & 7, o = o >> 5 & 224 | o >> 3 & 31;
                n[i++] = a, n[i++] = o;
            }
        }
        function tt(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 0 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 16 & 255;
            }
        }
        function et(t, e, r, i, a, o) {
            if (0 == o) for(r = e + r; e < r;)I(i, ((o = t[e++])[0] >> 24 | o[1] >> 8 & 65280 | o[2] << 8 & 16711680 | o[3] << 24) >>> 0), a += 32;
            else n(i, a, t, e, r);
        }
        function rt(e, r) {
            t[r][0] = t[e + "0"], t[r][1] = t[e + "1"], t[r][2] = t[e + "2"], t[r][3] = t[e + "3"], t[r][4] = t[e + "4"], t[r][5] = t[e + "5"], t[r][6] = t[e + "6"], t[r][7] = t[e + "7"], t[r][8] = t[e + "8"], t[r][9] = t[e + "9"], t[r][10] = t[e + "10"], t[r][11] = t[e + "11"], t[r][12] = t[e + "12"], t[r][13] = t[e + "13"], t[r][14] = t[e + "0"], t[r][15] = t[e + "0"];
        }
        function nt(t) {
            return t == Hn || t == Wn || t == Vn || t == Gn;
        }
        function it() {
            this.eb = [], this.size = this.A = this.fb = 0;
        }
        function at() {
            this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
        }
        function ot() {
            this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new it, this.f.kb = new at, this.sd = null;
        }
        function st() {
            this.width = [
                0
            ], this.height = [
                0
            ], this.Pd = [
                0
            ], this.Qd = [
                0
            ], this.format = [
                0
            ];
        }
        function ct() {
            this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
        }
        function ut(t) {
            return alert("todo:WebPSamplerProcessPlane"), t.T;
        }
        function ht(t, e) {
            var r = t.T, i = e.ba.f.RGBA, a = i.eb, o = i.fb + t.ka * i.A, s = vi[e.ba.S], c = t.y, u = t.O, h = t.f, l = t.N, f = t.ea, d = t.W, p = e.cc, g = e.dc, m = e.Mc, v = e.Nc, b = t.ka, y = t.ka + t.T, w = t.U, N = w + 1 >> 1;
            for(0 == b ? s(c, u, null, null, h, l, f, d, h, l, f, d, a, o, null, null, w) : (s(e.ec, e.fc, c, u, p, g, m, v, h, l, f, d, a, o - i.A, a, o, w), ++r); b + 2 < y; b += 2)p = h, g = l, m = f, v = d, l += t.Rc, d += t.Rc, o += 2 * i.A, s(c, (u += 2 * t.fa) - t.fa, c, u, p, g, m, v, h, l, f, d, a, o - i.A, a, o, w);
            return u += t.fa, t.j + y < t.o ? (n(e.ec, e.fc, c, u, w), n(e.cc, e.dc, h, l, N), n(e.Mc, e.Nc, f, d, N), r--) : 1 & y || s(c, u, null, null, h, l, f, d, h, l, f, d, a, o + i.A, null, null, w), r;
        }
        function lt(t, r, n) {
            var i = t.F, a = [
                t.J
            ];
            if (null != i) {
                var o = t.U, s = r.ba.S, c = s == Tn || s == Vn;
                r = r.ba.f.RGBA;
                var u = [
                    0
                ], h = t.ka;
                u[0] = t.T, t.Kb && (0 == h ? --u[0] : (--h, a[0] -= t.width), t.j + t.ka + t.T == t.o && (u[0] = t.o - t.j - h));
                var l = r.eb;
                h = r.fb + h * r.A;
                t = Sn(i, a[0], t.width, o, u, l, h + (c ? 0 : 3), r.A), e(n == u), t && nt(s) && An(l, h, c, o, u, r.A);
            }
            return 0;
        }
        function ft(t) {
            var e = t.ma, r = e.ba.S, n = 11 > r, i = r == qn || r == Rn || r == Tn || r == Un || 12 == r || nt(r);
            if (e.memory = null, e.Ib = null, e.Jb = null, e.Nd = null, !Mr(e.Oa, t, i ? 11 : 12)) return 0;
            if (i && nt(r) && br(), t.da) alert("todo:use_scaling");
            else {
                if (n) {
                    if (e.Ib = ut, t.Kb) {
                        if (r = t.U + 1 >> 1, e.memory = a(t.U + 2 * r), null == e.memory) return 0;
                        e.ec = e.memory, e.fc = 0, e.cc = e.ec, e.dc = e.fc + t.U, e.Mc = e.cc, e.Nc = e.dc + r, e.Ib = ht, br();
                    }
                } else alert("todo:EmitYUV");
                i && (e.Jb = lt, n && mr());
            }
            if (n && !Ci) {
                for(t = 0; 256 > t; ++t)ji[t] = 89858 * (t - 128) + _i >> Si, Mi[t] = -22014 * (t - 128) + _i, Bi[t] = -45773 * (t - 128), Oi[t] = 113618 * (t - 128) + _i >> Si;
                for(t = Pi; t < ki; ++t)e = 76283 * (t - 16) + _i >> Si, Ei[t - Pi] = Vt(e, 255), qi[t - Pi] = Vt(e + 8 >> 4, 15);
                Ci = 1;
            }
            return 1;
        }
        function dt(t) {
            var r = t.ma, n = t.U, i = t.T;
            return e(!(1 & t.ka)), 0 >= n || 0 >= i ? 0 : (n = r.Ib(t, r), null != r.Jb && r.Jb(t, r, n), r.Dc += n, 1);
        }
        function pt(t) {
            t.ma.memory = null;
        }
        function gt(t, e, r, n) {
            return 47 != y(t, 8) ? 0 : (e[0] = y(t, 14) + 1, r[0] = y(t, 14) + 1, n[0] = y(t, 1), 0 != y(t, 3) ? 0 : !t.h);
        }
        function mt(t, e) {
            if (4 > t) return t + 1;
            var r = t - 2 >> 1;
            return (2 + (1 & t) << r) + y(e, r) + 1;
        }
        function vt(t, e) {
            var r;
            return 120 < e ? e - 120 : 1 <= (r = ((r = $n[e - 1]) >> 4) * t + (8 - (15 & r))) ? r : 1;
        }
        function bt(t, e, r) {
            var n = L(r), i = t[e += 255 & n].g - 8;
            return 0 < i && (x(r, r.u + 8), n = L(r), e += t[e].value, e += n & (1 << i) - 1), x(r, r.u + t[e].g), t[e].value;
        }
        function yt(t, r, n) {
            return n.g += t.g, n.value += t.value << r >>> 0, e(8 >= n.g), t.g;
        }
        function wt(t, r, n) {
            var i = t.xc;
            return e((r = 0 == i ? 0 : t.vc[t.md * (n >> i) + (r >> i)]) < t.Wb), t.Ya[r];
        }
        function Nt(t, r, i, a) {
            var o = t.ab, s = t.c * r, c = t.C;
            r = c + r;
            var u = i, h = a;
            for(a = t.Ta, i = t.Ua; 0 < o--;){
                var l = t.gc[o], f = c, d = r, p = u, g = h, m = (h = a, u = i, l.Ea);
                switch(e(f < d), e(d <= l.nc), l.hc){
                    case 2:
                        Gr(p, g, (d - f) * m, h, u);
                        break;
                    case 0:
                        var v = f, b = d, y = h, w = u, N = (_ = l).Ea;
                        0 == v && (Wr(p, g, null, null, 1, y, w), V(p, g + 1, 0, 0, N - 1, y, w + 1), g += N, w += N, ++v);
                        for(var L = 1 << _.b, A = L - 1, x = q(N, _.b), S = _.K, _ = _.w + (v >> _.b) * x; v < b;){
                            var P = S, k = _, I = 1;
                            for(Vr(p, g, y, w - N, 1, y, w); I < N;){
                                var F = (I & ~A) + L;
                                F > N && (F = N), (0, Zr[P[k++] >> 8 & 15])(p, g + +I, y, w + I - N, F - I, y, w + I), I = F;
                            }
                            g += N, w += N, ++v & A || (_ += x);
                        }
                        d != l.nc && n(h, u - m, h, u + (d - f - 1) * m, m);
                        break;
                    case 1:
                        for(m = p, b = g, N = (p = l.Ea) - (w = p & ~(y = (g = 1 << l.b) - 1)), v = q(p, l.b), L = l.K, l = l.w + (f >> l.b) * v; f < d;){
                            for(A = L, x = l, S = new T, _ = b + w, P = b + p; b < _;)Y(A[x++], S), $r(S, m, b, g, h, u), b += g, u += g;
                            b < P && (Y(A[x++], S), $r(S, m, b, N, h, u), b += N, u += N), ++f & y || (l += v);
                        }
                        break;
                    case 3:
                        if (p == h && g == u && 0 < l.b) {
                            for(b = h, p = m = u + (d - f) * m - (w = (d - f) * q(l.Ea, l.b)), g = h, y = u, v = [], w = (N = w) - 1; 0 <= w; --w)v[w] = g[y + w];
                            for(w = N - 1; 0 <= w; --w)b[p + w] = v[w];
                            Yr(l, f, d, h, m, h, u);
                        } else Yr(l, f, d, p, g, h, u);
                }
                u = a, h = i;
            }
            h != i && n(a, i, u, h, s);
        }
        function Lt(t, r) {
            var n = t.V, i = t.Ba + t.c * t.C, a = r - t.C;
            if (e(r <= t.l.o), e(16 >= a), 0 < a) {
                var o = t.l, s = t.Ta, c = t.Ua, u = o.width;
                if (Nt(t, a, n, i), a = c = [
                    c
                ], e((n = t.C) < (i = r)), e(o.v < o.va), i > o.o && (i = o.o), n < o.j) {
                    var h = o.j - n;
                    n = o.j;
                    a[0] += h * u;
                }
                if (n >= i ? n = 0 : (a[0] += 4 * o.v, o.ka = n - o.j, o.U = o.va - o.v, o.T = i - n, n = 1), n) {
                    if (c = c[0], 11 > (n = t.ca).S) {
                        var l = n.f.RGBA, f = (i = n.S, a = o.U, o = o.T, h = l.eb, l.A), d = o;
                        for(l = l.fb + t.Ma * l.A; 0 < d--;){
                            var p = s, g = c, m = a, v = h, b = l;
                            switch(i){
                                case En:
                                    Qr(p, g, m, v, b);
                                    break;
                                case qn:
                                    tn(p, g, m, v, b);
                                    break;
                                case Hn:
                                    tn(p, g, m, v, b), An(v, b, 0, m, 1, 0);
                                    break;
                                case Dn:
                                    nn(p, g, m, v, b);
                                    break;
                                case Rn:
                                    et(p, g, m, v, b, 1);
                                    break;
                                case Wn:
                                    et(p, g, m, v, b, 1), An(v, b, 0, m, 1, 0);
                                    break;
                                case Tn:
                                    et(p, g, m, v, b, 0);
                                    break;
                                case Vn:
                                    et(p, g, m, v, b, 0), An(v, b, 1, m, 1, 0);
                                    break;
                                case Un:
                                    en(p, g, m, v, b);
                                    break;
                                case Gn:
                                    en(p, g, m, v, b), xn(v, b, m, 1, 0);
                                    break;
                                case zn:
                                    rn(p, g, m, v, b);
                                    break;
                                default:
                                    e(0);
                            }
                            c += u, l += f;
                        }
                        t.Ma += o;
                    } else alert("todo:EmitRescaledRowsYUVA");
                    e(t.Ma <= n.height);
                }
            }
            t.C = r, e(t.C <= t.i);
        }
        function At(t) {
            var e;
            if (0 < t.ua) return 0;
            for(e = 0; e < t.Wb; ++e){
                var r = t.Ya[e].G, n = t.Ya[e].H;
                if (0 < r[1][n[1] + 0].g || 0 < r[2][n[2] + 0].g || 0 < r[3][n[3] + 0].g) return 0;
            }
            return 1;
        }
        function xt(t, r, n, i, a, o) {
            if (0 != t.Z) {
                var s = t.qd, c = t.rd;
                for(e(null != mi[t.Z]); r < n; ++r)mi[t.Z](s, c, i, a, i, a, o), s = i, c = a, a += o;
                t.qd = s, t.rd = c;
            }
        }
        function St(t, r) {
            var n = t.l.ma, i = 0 == n.Z || 1 == n.Z ? t.l.j : t.C;
            i = t.C < i ? i : t.C;
            if (e(r <= t.l.o), r > i) {
                var a = t.l.width, o = n.ca, s = n.tb + a * i, c = t.V, u = t.Ba + t.c * i, h = t.gc;
                e(1 == t.ab), e(3 == h[0].hc), Xr(h[0], i, r, c, u, o, s), xt(n, i, r, o, s, a);
            }
            t.C = t.Ma = r;
        }
        function _t(t, r, n, i, a, o, s) {
            var c = t.$ / i, u = t.$ % i, h = t.m, l = t.s, f = n + t.$, d = f;
            a = n + i * a;
            var p = n + i * o, g = 280 + l.ua, m = t.Pb ? c : 16777216, v = 0 < l.ua ? l.Wa : null, b = l.wc, y = f < p ? wt(l, u, c) : null;
            e(t.C < o), e(p <= a);
            var w = !1;
            t: for(;;){
                for(; w || f < p;){
                    var N = 0;
                    if (c >= m) {
                        var _ = f - n;
                        e((m = t).Pb), m.wd = m.m, m.xd = _, 0 < m.s.ua && B(m.s.Wa, m.s.vb), m = c + ti;
                    }
                    if (u & b || (y = wt(l, u, c)), e(null != y), y.Qb && (r[f] = y.qb, w = !0), !w) {
                        if (S(h), y.jc) {
                            N = h, _ = r;
                            var P = f, k = y.pd[L(N) & Dr - 1];
                            e(y.jc), 256 > k.g ? (x(N, N.u + k.g), _[P] = k.value, N = 0) : (x(N, N.u + k.g - 256), e(256 <= k.value), N = k.value), 0 == N && (w = !0);
                        } else N = bt(y.G[0], y.H[0], h);
                    }
                    if (h.h) break;
                    if (w || 256 > N) {
                        if (!w) {
                            if (y.nd) r[f] = (y.qb | N << 8) >>> 0;
                            else {
                                if (S(h), w = bt(y.G[1], y.H[1], h), S(h), _ = bt(y.G[2], y.H[2], h), P = bt(y.G[3], y.H[3], h), h.h) break;
                                r[f] = (P << 24 | w << 16 | N << 8 | _) >>> 0;
                            }
                        }
                        if (w = !1, ++f, ++u >= i && (u = 0, ++c, null != s && c <= o && !(c % 16) && s(t, c), null != v)) for(; d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else if (280 > N) {
                        if (N = mt(N - 256, h), _ = bt(y.G[4], y.H[4], h), S(h), _ = vt(i, _ = mt(_, h)), h.h) break;
                        if (f - n < _ || a - f < N) break t;
                        for(P = 0; P < N; ++P)r[f + P] = r[f + P - _];
                        for(f += N, u += N; u >= i;)u -= i, ++c, null != s && c <= o && !(c % 16) && s(t, c);
                        if (e(f <= a), u & b && (y = wt(l, u, c)), null != v) for(; d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else {
                        if (!(N < g)) break t;
                        for(w = N - 280, e(null != v); d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                        N = f, e(!(w >>> (_ = v).Xa)), r[N] = _.X[w], w = !0;
                    }
                    w || e(h.h == A(h));
                }
                if (t.Pb && h.h && f < a) e(t.m.h), t.a = 5, t.m = t.wd, t.$ = t.xd, 0 < t.s.ua && B(t.s.vb, t.s.Wa);
                else {
                    if (h.h) break t;
                    null != s && s(t, c > o ? o : c), t.a = 0, t.$ = f - n;
                }
                return 1;
            }
            return t.a = 3, 0;
        }
        function Pt(t) {
            e(null != t), t.vc = null, t.yc = null, t.Ya = null;
            var r = t.Wa;
            null != r && (r.X = null), t.vb = null, e(null != t);
        }
        function kt() {
            var e = new or;
            return null == e ? null : (e.a = 0, e.xb = gi, rt("Predictor", "VP8LPredictors"), rt("Predictor", "VP8LPredictors_C"), rt("PredictorAdd", "VP8LPredictorsAdd"), rt("PredictorAdd", "VP8LPredictorsAdd_C"), Gr = G, $r = J, Qr = K, tn = Z, en = $, rn = Q, nn = tt, t.VP8LMapColor32b = Jr, t.VP8LMapColor8b = Kr, e);
        }
        function It(t, r, n, s, c) {
            var u = 1, f = [
                t
            ], p = [
                r
            ], g = s.m, m = s.s, v = null, b = 0;
            t: for(;;){
                if (n) for(; u && y(g, 1);){
                    var w = f, N = p, A = s, _ = 1, P = A.m, k = A.gc[A.ab], I = y(P, 2);
                    if (A.Oc & 1 << I) u = 0;
                    else {
                        switch(A.Oc |= 1 << I, k.hc = I, k.Ea = w[0], k.nc = N[0], k.K = [
                            null
                        ], ++A.ab, e(4 >= A.ab), I){
                            case 0:
                            case 1:
                                k.b = y(P, 3) + 2, _ = It(q(k.Ea, k.b), q(k.nc, k.b), 0, A, k.K), k.K = k.K[0];
                                break;
                            case 3:
                                var F, C = y(P, 8) + 1, j = 16 < C ? 0 : 4 < C ? 1 : 2 < C ? 2 : 3;
                                if (w[0] = q(k.Ea, j), k.b = j, F = _ = It(C, 1, 0, A, k.K)) {
                                    var B, M = C, E = k, R = 1 << (8 >> E.b), T = a(R);
                                    if (null == T) F = 0;
                                    else {
                                        var U = E.K[0], z = E.w;
                                        for(T[0] = E.K[0][0], B = 1; B < 1 * M; ++B)T[B] = D(U[z + B], T[B - 1]);
                                        for(; B < 4 * R; ++B)T[B] = 0;
                                        E.K[0] = null, E.K[0] = T, F = 1;
                                    }
                                }
                                _ = F;
                                break;
                            case 2:
                                break;
                            default:
                                e(0);
                        }
                        u = _;
                    }
                }
                if (f = f[0], p = p[0], u && y(g, 1) && !(u = 1 <= (b = y(g, 4)) && 11 >= b)) {
                    s.a = 3;
                    break t;
                }
                var H;
                if (H = u) e: {
                    var W, V, G, Y = s, J = f, X = p, K = b, Z = n, $ = Y.m, Q = Y.s, tt = [
                        null
                    ], et = 1, rt = 0, nt = Qn[K];
                    r: for(;;){
                        if (Z && y($, 1)) {
                            var it = y($, 3) + 2, at = q(J, it), ot = q(X, it), st = at * ot;
                            if (!It(at, ot, 0, Y, tt)) break r;
                            for(tt = tt[0], Q.xc = it, W = 0; W < st; ++W){
                                var ct = tt[W] >> 8 & 65535;
                                tt[W] = ct, ct >= et && (et = ct + 1);
                            }
                        }
                        if ($.h) break r;
                        for(V = 0; 5 > V; ++V){
                            var ut = Xn[V];
                            !V && 0 < K && (ut += 1 << K), rt < ut && (rt = ut);
                        }
                        var ht = o(et * nt, l), lt = et, ft = o(lt, d);
                        if (null == ft) var dt = null;
                        else e(65536 >= lt), dt = ft;
                        var pt = a(rt);
                        if (null == dt || null == pt || null == ht) {
                            Y.a = 1;
                            break r;
                        }
                        var gt = ht;
                        for(W = G = 0; W < et; ++W){
                            var mt = dt[W], vt = mt.G, bt = mt.H, wt = 0, Nt = 1, Lt = 0;
                            for(V = 0; 5 > V; ++V){
                                ut = Xn[V], vt[V] = gt, bt[V] = G, !V && 0 < K && (ut += 1 << K);
                                n: {
                                    var At, xt = ut, St = Y, kt = pt, Ft = gt, Ct = G, jt = 0, Ot = St.m, Bt = y(Ot, 1);
                                    if (i(kt, 0, 0, xt), Bt) {
                                        var Mt = y(Ot, 1) + 1, Et = y(Ot, 1), qt = y(Ot, 0 == Et ? 1 : 8);
                                        kt[qt] = 1, 2 == Mt && (kt[qt = y(Ot, 8)] = 1);
                                        var Dt = 1;
                                    } else {
                                        var Rt = a(19), Tt = y(Ot, 4) + 4;
                                        if (19 < Tt) {
                                            St.a = 3;
                                            var Ut = 0;
                                            break n;
                                        }
                                        for(At = 0; At < Tt; ++At)Rt[Zn[At]] = y(Ot, 3);
                                        var zt = void 0, Ht = void 0, Wt = St, Vt = Rt, Gt = xt, Yt = kt, Jt = 0, Xt = Wt.m, Kt = 8, Zt = o(128, l);
                                        i: for(; h(Zt, 0, 7, Vt, 19);){
                                            if (y(Xt, 1)) {
                                                var $t = 2 + 2 * y(Xt, 3);
                                                if ((zt = 2 + y(Xt, $t)) > Gt) break i;
                                            } else zt = Gt;
                                            for(Ht = 0; Ht < Gt && zt--;){
                                                S(Xt);
                                                var Qt = Zt[0 + (127 & L(Xt))];
                                                x(Xt, Xt.u + Qt.g);
                                                var te = Qt.value;
                                                if (16 > te) Yt[Ht++] = te, 0 != te && (Kt = te);
                                                else {
                                                    var ee = 16 == te, re = te - 16, ne = Jn[re], ie = y(Xt, Yn[re]) + ne;
                                                    if (Ht + ie > Gt) break i;
                                                    for(var ae = ee ? Kt : 0; 0 < ie--;)Yt[Ht++] = ae;
                                                }
                                            }
                                            Jt = 1;
                                            break i;
                                        }
                                        Jt || (Wt.a = 3), Dt = Jt;
                                    }
                                    (Dt = Dt && !Ot.h) && (jt = h(Ft, Ct, 8, kt, xt)), Dt && 0 != jt ? Ut = jt : (St.a = 3, Ut = 0);
                                }
                                if (0 == Ut) break r;
                                if (Nt && 1 == Kn[V] && (Nt = 0 == gt[G].g), wt += gt[G].g, G += Ut, 3 >= V) {
                                    var oe, se = pt[0];
                                    for(oe = 1; oe < ut; ++oe)pt[oe] > se && (se = pt[oe]);
                                    Lt += se;
                                }
                            }
                            if (mt.nd = Nt, mt.Qb = 0, Nt && (mt.qb = (vt[3][bt[3] + 0].value << 24 | vt[1][bt[1] + 0].value << 16 | vt[2][bt[2] + 0].value) >>> 0, 0 == wt && 256 > vt[0][bt[0] + 0].value && (mt.Qb = 1, mt.qb += vt[0][bt[0] + 0].value << 8)), mt.jc = !mt.Qb && 6 > Lt, mt.jc) {
                                var ce, ue = mt;
                                for(ce = 0; ce < Dr; ++ce){
                                    var he = ce, le = ue.pd[he], fe = ue.G[0][ue.H[0] + he];
                                    256 <= fe.value ? (le.g = fe.g + 256, le.value = fe.value) : (le.g = 0, le.value = 0, he >>= yt(fe, 8, le), he >>= yt(ue.G[1][ue.H[1] + he], 16, le), he >>= yt(ue.G[2][ue.H[2] + he], 0, le), yt(ue.G[3][ue.H[3] + he], 24, le));
                                }
                            }
                        }
                        Q.vc = tt, Q.Wb = et, Q.Ya = dt, Q.yc = ht, H = 1;
                        break e;
                    }
                    H = 0;
                }
                if (!(u = H)) {
                    s.a = 3;
                    break t;
                }
                if (0 < b) {
                    if (m.ua = 1 << b, !O(m.Wa, b)) {
                        s.a = 1, u = 0;
                        break t;
                    }
                } else m.ua = 0;
                var de = s, pe = f, ge = p, me = de.s, ve = me.xc;
                if (de.c = pe, de.i = ge, me.md = q(pe, ve), me.wc = 0 == ve ? -1 : (1 << ve) - 1, n) {
                    s.xb = pi;
                    break t;
                }
                if (null == (v = a(f * p))) {
                    s.a = 1, u = 0;
                    break t;
                }
                u = (u = _t(s, v, 0, f, p, p, null)) && !g.h;
                break t;
            }
            return u ? (null != c ? c[0] = v : (e(null == v), e(n)), s.$ = 0, n || Pt(m)) : Pt(m), u;
        }
        function Ft(t, r) {
            var n = t.c * t.i, i = n + r + 16 * r;
            return e(t.c <= r), t.V = a(i), null == t.V ? (t.Ta = null, t.Ua = 0, t.a = 1, 0) : (t.Ta = t.V, t.Ua = t.Ba + n + r, 1);
        }
        function Ct(t, r) {
            var n = t.C, i = r - n, a = t.V, o = t.Ba + t.c * n;
            for(e(r <= t.l.o); 0 < i;){
                var s = 16 < i ? 16 : i, c = t.l.ma, u = t.l.width, h = u * s, l = c.ca, f = c.tb + u * n, d = t.Ta, p = t.Ua;
                Nt(t, s, a, o), _n(d, p, l, f, h), xt(c, n, n + s, l, f, u), i -= s, a += s * t.c, n += s;
            }
            e(n == r), t.C = t.Ma = r;
        }
        function jt() {
            this.ub = this.yd = this.td = this.Rb = 0;
        }
        function Ot() {
            this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
        }
        function Bt() {
            this.Fb = this.Bb = this.Cb = 0, this.Zb = a(4), this.Lb = a(4);
        }
        function Mt() {
            this.Yb = function() {
                var t = [];
                return function t(e, r, n) {
                    for(var i = n[r], a = 0; a < i && (e.push(n.length > r + 1 ? [] : 0), !(n.length < r + 1)); a++)t(e[a], r + 1, n);
                }(t, 0, [
                    3,
                    11
                ]), t;
            }();
        }
        function Et() {
            this.jb = a(3), this.Wc = s([
                4,
                8
            ], Mt), this.Xc = s([
                4,
                17
            ], Mt);
        }
        function qt() {
            this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new a(4), this.od = new a(4);
        }
        function Dt() {
            this.ld = this.La = this.dd = this.tc = 0;
        }
        function Rt() {
            this.Na = this.la = 0;
        }
        function Tt() {
            this.Sc = [
                0,
                0
            ], this.Eb = [
                0,
                0
            ], this.Qc = [
                0,
                0
            ], this.ia = this.lc = 0;
        }
        function Ut() {
            this.ad = a(384), this.Za = 0, this.Ob = a(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
        }
        function zt() {
            this.uc = this.M = this.Nb = 0, this.wa = Array(new Dt), this.Y = 0, this.ya = Array(new Ut), this.aa = 0, this.l = new Gt;
        }
        function Ht() {
            this.y = a(16), this.f = a(8), this.ea = a(8);
        }
        function Wt() {
            this.cb = this.a = 0, this.sc = "", this.m = new w, this.Od = new jt, this.Kc = new Ot, this.ed = new qt, this.Qa = new Bt, this.Ic = this.$c = this.Aa = 0, this.D = new zt, this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o(8, w), this.ia = 0, this.pb = o(4, Tt), this.Pa = new Et, this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [
                0,
                0,
                0,
                0
            ], this.Gd = Array(new Ht), this.Hd = 0, this.rb = Array(new Rt), this.sb = 0, this.wa = Array(new Dt), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new Ut), this.L = this.aa = 0, this.gd = s([
                4,
                2
            ], Dt), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Gt() {
            this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
        }
        function Yt() {
            var t = new Wt;
            return null != t && (t.a = 0, t.sc = "OK", t.cb = 0, t.Xb = 0, ni || (ni = Zt)), t;
        }
        function Jt(t, e, r) {
            return 0 == t.a && (t.a = e, t.sc = r, t.cb = 0), 0;
        }
        function Xt(t, e, r) {
            return 3 <= r && 157 == t[e + 0] && 1 == t[e + 1] && 42 == t[e + 2];
        }
        function Kt(t, r) {
            if (null == t) return 0;
            if (t.a = 0, t.sc = "OK", null == r) return Jt(t, 2, "null VP8Io passed to VP8GetHeaders()");
            var n = r.data, a = r.w, o = r.ha;
            if (4 > o) return Jt(t, 7, "Truncated header.");
            var s = n[a + 0] | n[a + 1] << 8 | n[a + 2] << 16, c = t.Od;
            if (c.Rb = !(1 & s), c.td = s >> 1 & 7, c.yd = s >> 4 & 1, c.ub = s >> 5, 3 < c.td) return Jt(t, 3, "Incorrect keyframe parameters.");
            if (!c.yd) return Jt(t, 4, "Frame not displayable.");
            a += 3, o -= 3;
            var u = t.Kc;
            if (c.Rb) {
                if (7 > o) return Jt(t, 7, "cannot parse picture header");
                if (!Xt(n, a, o)) return Jt(t, 3, "Bad code word");
                u.c = 16383 & (n[a + 4] << 8 | n[a + 3]), u.Td = n[a + 4] >> 6, u.i = 16383 & (n[a + 6] << 8 | n[a + 5]), u.Ud = n[a + 6] >> 6, a += 7, o -= 7, t.za = u.c + 15 >> 4, t.Ub = u.i + 15 >> 4, r.width = u.c, r.height = u.i, r.Da = 0, r.j = 0, r.v = 0, r.va = r.width, r.o = r.height, r.da = 0, r.ib = r.width, r.hb = r.height, r.U = r.width, r.T = r.height, i((s = t.Pa).jb, 0, 255, s.jb.length), e(null != (s = t.Qa)), s.Cb = 0, s.Bb = 0, s.Fb = 1, i(s.Zb, 0, 0, s.Zb.length), i(s.Lb, 0, 0, s.Lb);
            }
            if (c.ub > o) return Jt(t, 7, "bad partition length");
            p(s = t.m, n, a, c.ub), a += c.ub, o -= c.ub, c.Rb && (u.Ld = P(s), u.Kd = P(s)), u = t.Qa;
            var h, l = t.Pa;
            if (e(null != s), e(null != u), u.Cb = P(s), u.Cb) {
                if (u.Bb = P(s), P(s)) {
                    for(u.Fb = P(s), h = 0; 4 > h; ++h)u.Zb[h] = P(s) ? m(s, 7) : 0;
                    for(h = 0; 4 > h; ++h)u.Lb[h] = P(s) ? m(s, 6) : 0;
                }
                if (u.Bb) for(h = 0; 3 > h; ++h)l.jb[h] = P(s) ? g(s, 8) : 255;
            } else u.Bb = 0;
            if (s.Ka) return Jt(t, 3, "cannot parse segment header");
            if ((u = t.ed).zd = P(s), u.Tb = g(s, 6), u.wb = g(s, 3), u.Pc = P(s), u.Pc && P(s)) {
                for(l = 0; 4 > l; ++l)P(s) && (u.vd[l] = m(s, 6));
                for(l = 0; 4 > l; ++l)P(s) && (u.od[l] = m(s, 6));
            }
            if (t.L = 0 == u.Tb ? 0 : u.zd ? 1 : 2, s.Ka) return Jt(t, 3, "cannot parse filter header");
            var f = o;
            if (o = h = a, a = h + f, u = f, t.Xb = (1 << g(t.m, 2)) - 1, f < 3 * (l = t.Xb)) n = 7;
            else {
                for(h += 3 * l, u -= 3 * l, f = 0; f < l; ++f){
                    var d = n[o + 0] | n[o + 1] << 8 | n[o + 2] << 16;
                    d > u && (d = u), p(t.Jc[+f], n, h, d), h += d, u -= d, o += 3;
                }
                p(t.Jc[+l], n, h, u), n = h < a ? 0 : 5;
            }
            if (0 != n) return Jt(t, n, "cannot parse partitions");
            for(n = g(h = t.m, 7), o = P(h) ? m(h, 4) : 0, a = P(h) ? m(h, 4) : 0, u = P(h) ? m(h, 4) : 0, l = P(h) ? m(h, 4) : 0, h = P(h) ? m(h, 4) : 0, f = t.Qa, d = 0; 4 > d; ++d){
                if (f.Cb) {
                    var v = f.Zb[d];
                    f.Fb || (v += n);
                } else {
                    if (0 < d) {
                        t.pb[d] = t.pb[0];
                        continue;
                    }
                    v = n;
                }
                var b = t.pb[d];
                b.Sc[0] = ei[Vt(v + o, 127)], b.Sc[1] = ri[Vt(v + 0, 127)], b.Eb[0] = 2 * ei[Vt(v + a, 127)], b.Eb[1] = 101581 * ri[Vt(v + u, 127)] >> 16, 8 > b.Eb[1] && (b.Eb[1] = 8), b.Qc[0] = ei[Vt(v + l, 117)], b.Qc[1] = ri[Vt(v + h, 127)], b.lc = v + h;
            }
            if (!c.Rb) return Jt(t, 4, "Not a key frame.");
            for(P(s), c = t.Pa, n = 0; 4 > n; ++n){
                for(o = 0; 8 > o; ++o)for(a = 0; 3 > a; ++a)for(u = 0; 11 > u; ++u)l = k(s, ui[n][o][a][u]) ? g(s, 8) : si[n][o][a][u], c.Wc[n][o].Yb[a][u] = l;
                for(o = 0; 17 > o; ++o)c.Xc[n][o] = c.Wc[n][hi[o]];
            }
            return t.kc = P(s), t.kc && (t.Bd = g(s, 8)), t.cb = 1;
        }
        function Zt(t, e, r, n, i, a, o) {
            var s = e[i].Yb[r];
            for(r = 0; 16 > i; ++i){
                if (!k(t, s[r + 0])) return i;
                for(; !k(t, s[r + 1]);)if (s = e[++i].Yb[0], r = 0, 16 == i) return 16;
                var c = e[i + 1].Yb;
                if (k(t, s[r + 2])) {
                    var u = t, h = 0;
                    if (k(u, (f = s)[(l = r) + 3])) {
                        if (k(u, f[l + 6])) {
                            for(s = 0, l = 2 * (h = k(u, f[l + 8])) + (f = k(u, f[l + 9 + h])), h = 0, f = ii[l]; f[s]; ++s)h += h + k(u, f[s]);
                            h += 3 + (8 << l);
                        } else k(u, f[l + 7]) ? (h = 7 + 2 * k(u, 165), h += k(u, 145)) : h = 5 + k(u, 159);
                    } else h = k(u, f[l + 4]) ? 3 + k(u, f[l + 5]) : 2;
                    s = c[2];
                } else h = 1, s = c[1];
                c = o + ai[i], 0 > (u = t).b && _(u);
                var l, f = u.b, d = (l = u.Ca >> 1) - (u.I >> f) >> 31;
                --u.b, u.Ca += d, u.Ca |= 1, u.I -= (l + 1 & d) << f, a[c] = ((h ^ d) - d) * n[(0 < i) + 0];
            }
            return 16;
        }
        function $t(t) {
            var e = t.rb[t.sb - 1];
            e.la = 0, e.Na = 0, i(t.zc, 0, 0, t.zc.length), t.ja = 0;
        }
        function Qt(t, r) {
            if (null == t) return 0;
            if (null == r) return Jt(t, 2, "NULL VP8Io parameter in VP8Decode().");
            if (!t.cb && !Kt(t, r)) return 0;
            if (e(t.cb), null == r.ac || r.ac(r)) {
                r.ob && (t.L = 0);
                var s = Ri[t.L];
                if (2 == t.L ? (t.yb = 0, t.zb = 0) : (t.yb = r.v - s >> 4, t.zb = r.j - s >> 4, 0 > t.yb && (t.yb = 0), 0 > t.zb && (t.zb = 0)), t.Va = r.o + 15 + s >> 4, t.Hb = r.va + 15 + s >> 4, t.Hb > t.za && (t.Hb = t.za), t.Va > t.Ub && (t.Va = t.Ub), 0 < t.L) {
                    var c = t.ed;
                    for(s = 0; 4 > s; ++s){
                        var u;
                        if (t.Qa.Cb) {
                            var h = t.Qa.Lb[s];
                            t.Qa.Fb || (h += c.Tb);
                        } else h = c.Tb;
                        for(u = 0; 1 >= u; ++u){
                            var l = t.gd[s][u], f = h;
                            if (c.Pc && (f += c.vd[0], u && (f += c.od[0])), 0 < (f = 0 > f ? 0 : 63 < f ? 63 : f)) {
                                var d = f;
                                0 < c.wb && (d = 4 < c.wb ? d >> 2 : d >> 1) > 9 - c.wb && (d = 9 - c.wb), 1 > d && (d = 1), l.dd = d, l.tc = 2 * f + d, l.ld = 40 <= f ? 2 : 15 <= f ? 1 : 0;
                            } else l.tc = 0;
                            l.La = u;
                        }
                    }
                }
                s = 0;
            } else Jt(t, 6, "Frame setup failed"), s = t.a;
            if (s = 0 == s) {
                if (s) {
                    t.$c = 0, 0 < t.Aa || (t.Ic = Ui);
                    t: {
                        s = t.Ic;
                        c = 4 * (d = t.za);
                        var p = 32 * d, g = d + 1, m = 0 < t.L ? d * (0 < t.Aa ? 2 : 1) : 0, v = (2 == t.Aa ? 2 : 1) * d;
                        if ((l = c + 832 + (u = 3 * (16 * s + Ri[t.L]) / 2 * p) + (h = null != t.Fa && 0 < t.Fa.length ? t.Kc.c * t.Kc.i : 0)) != l) s = 0;
                        else {
                            if (l > t.Vb) {
                                if (t.Vb = 0, t.Ec = a(l), t.Fc = 0, null == t.Ec) {
                                    s = Jt(t, 1, "no memory during frame initialization.");
                                    break t;
                                }
                                t.Vb = l;
                            }
                            l = t.Ec, f = t.Fc, t.Ac = l, t.Bc = f, f += c, t.Gd = o(p, Ht), t.Hd = 0, t.rb = o(g + 1, Rt), t.sb = 1, t.wa = m ? o(m, Dt) : null, t.Y = 0, t.D.Nb = 0, t.D.wa = t.wa, t.D.Y = t.Y, 0 < t.Aa && (t.D.Y += d), e(!0), t.oc = l, t.pc = f, f += 832, t.ya = o(v, Ut), t.aa = 0, t.D.ya = t.ya, t.D.aa = t.aa, 2 == t.Aa && (t.D.aa += d), t.R = 16 * d, t.B = 8 * d, d = (p = Ri[t.L]) * t.R, p = p / 2 * t.B, t.sa = l, t.ta = f + d, t.qa = t.sa, t.ra = t.ta + 16 * s * t.R + p, t.Ha = t.qa, t.Ia = t.ra + 8 * s * t.B + p, t.$c = 0, f += u, t.mb = h ? l : null, t.nb = h ? f : null, e(f + h <= t.Fc + t.Vb), $t(t), i(t.Ac, t.Bc, 0, c), s = 1;
                        }
                    }
                    if (s) {
                        if (r.ka = 0, r.y = t.sa, r.O = t.ta, r.f = t.qa, r.N = t.ra, r.ea = t.Ha, r.Vd = t.Ia, r.fa = t.R, r.Rc = t.B, r.F = null, r.J = 0, !Cn) {
                            for(s = -255; 255 >= s; ++s)Pn[255 + s] = 0 > s ? -s : s;
                            for(s = -1020; 1020 >= s; ++s)kn[1020 + s] = -128 > s ? -128 : 127 < s ? 127 : s;
                            for(s = -112; 112 >= s; ++s)In[112 + s] = -16 > s ? -16 : 15 < s ? 15 : s;
                            for(s = -255; 510 >= s; ++s)Fn[255 + s] = 0 > s ? 0 : 255 < s ? 255 : s;
                            Cn = 1;
                        }
                        an = ue, on = ae, cn = oe, un = se, hn = ce, sn = ie, ln = Je, fn = Xe, dn = $e, pn = Qe, gn = Ke, mn = Ze, vn = tr, bn = er, yn = ze, wn = He, Nn = We, Ln = Ve, fi[0] = xe, fi[1] = le, fi[2] = Le, fi[3] = Ae, fi[4] = Se, fi[5] = Pe, fi[6] = _e, fi[7] = ke, fi[8] = Fe, fi[9] = Ie, li[0] = ve, li[1] = de, li[2] = pe, li[3] = ge, li[4] = be, li[5] = ye, li[6] = we, di[0] = Be, di[1] = fe, di[2] = Ce, di[3] = je, di[4] = Ee, di[5] = Me, di[6] = qe, s = 1;
                    } else s = 0;
                }
                s && (s = function(t, r) {
                    for(t.M = 0; t.M < t.Va; ++t.M){
                        var o, s = t.Jc[t.M & t.Xb], c = t.m, u = t;
                        for(o = 0; o < u.za; ++o){
                            var h = c, l = u, f = l.Ac, d = l.Bc + 4 * o, p = l.zc, g = l.ya[l.aa + o];
                            if (l.Qa.Bb ? g.$b = k(h, l.Pa.jb[0]) ? 2 + k(h, l.Pa.jb[2]) : k(h, l.Pa.jb[1]) : g.$b = 0, l.kc && (g.Ad = k(h, l.Bd)), g.Za = !k(h, 145) + 0, g.Za) {
                                var m = g.Ob, v = 0;
                                for(l = 0; 4 > l; ++l){
                                    var b, y = p[0 + l];
                                    for(b = 0; 4 > b; ++b){
                                        y = ci[f[d + b]][y];
                                        for(var w = oi[k(h, y[0])]; 0 < w;)w = oi[2 * w + k(h, y[w])];
                                        y = -w, f[d + b] = y;
                                    }
                                    n(m, v, f, d, 4), v += 4, p[0 + l] = y;
                                }
                            } else y = k(h, 156) ? k(h, 128) ? 1 : 3 : k(h, 163) ? 2 : 0, g.Ob[0] = y, i(f, d, y, 4), i(p, 0, y, 4);
                            g.Dd = k(h, 142) ? k(h, 114) ? k(h, 183) ? 1 : 3 : 2 : 0;
                        }
                        if (u.m.Ka) return Jt(t, 7, "Premature end-of-partition0 encountered.");
                        for(; t.ja < t.za; ++t.ja){
                            if (u = s, h = (c = t).rb[c.sb - 1], f = c.rb[c.sb + c.ja], o = c.ya[c.aa + c.ja], d = c.kc ? o.Ad : 0) h.la = f.la = 0, o.Za || (h.Na = f.Na = 0), o.Hc = 0, o.Gc = 0, o.ia = 0;
                            else {
                                var N, L;
                                h = f, f = u, d = c.Pa.Xc, p = c.ya[c.aa + c.ja], g = c.pb[p.$b];
                                if (l = p.ad, m = 0, v = c.rb[c.sb - 1], y = b = 0, i(l, m, 0, 384), p.Za) var A = 0, x = d[3];
                                else {
                                    w = a(16);
                                    var S = h.Na + v.Na;
                                    if (S = ni(f, d[1], S, g.Eb, 0, w, 0), h.Na = v.Na = (0 < S) + 0, 1 < S) an(w, 0, l, m);
                                    else {
                                        var _ = w[0] + 3 >> 3;
                                        for(w = 0; 256 > w; w += 16)l[m + w] = _;
                                    }
                                    A = 1, x = d[0];
                                }
                                var P = 15 & h.la, I = 15 & v.la;
                                for(w = 0; 4 > w; ++w){
                                    var F = 1 & I;
                                    for(_ = L = 0; 4 > _; ++_)P = P >> 1 | (F = (S = ni(f, x, S = F + (1 & P), g.Sc, A, l, m)) > A) << 7, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != l[m + 0]), m += 16;
                                    P >>= 4, I = I >> 1 | F << 7, b = (b << 8 | L) >>> 0;
                                }
                                for(x = P, A = I >> 4, N = 0; 4 > N; N += 2){
                                    for(L = 0, P = h.la >> 4 + N, I = v.la >> 4 + N, w = 0; 2 > w; ++w){
                                        for(F = 1 & I, _ = 0; 2 > _; ++_)S = F + (1 & P), P = P >> 1 | (F = 0 < (S = ni(f, d[2], S, g.Qc, 0, l, m))) << 3, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != l[m + 0]), m += 16;
                                        P >>= 2, I = I >> 1 | F << 5;
                                    }
                                    y |= L << 4 * N, x |= P << 4 << N, A |= (240 & I) << N;
                                }
                                h.la = x, v.la = A, p.Hc = b, p.Gc = y, p.ia = 43690 & y ? 0 : g.ia, d = !(b | y);
                            }
                            if (0 < c.L && (c.wa[c.Y + c.ja] = c.gd[o.$b][o.Za], c.wa[c.Y + c.ja].La |= !d), u.Ka) return Jt(t, 7, "Premature end-of-file encountered.");
                        }
                        if ($t(t), c = r, u = 1, o = (s = t).D, h = 0 < s.L && s.M >= s.zb && s.M <= s.Va, 0 == s.Aa) t: {
                            if (o.M = s.M, o.uc = h, Or(s, o), u = 1, o = (L = s.D).Nb, h = (y = Ri[s.L]) * s.R, f = y / 2 * s.B, w = 16 * o * s.R, _ = 8 * o * s.B, d = s.sa, p = s.ta - h + w, g = s.qa, l = s.ra - f + _, m = s.Ha, v = s.Ia - f + _, I = 0 == (P = L.M), b = P >= s.Va - 1, 2 == s.Aa && Or(s, L), L.uc) for(F = (S = s).D.M, e(S.D.uc), L = S.yb; L < S.Hb; ++L){
                                A = L, x = F;
                                var C = (j = (U = S).D).Nb;
                                N = U.R;
                                var j = j.wa[j.Y + A], O = U.sa, B = U.ta + 16 * C * N + 16 * A, M = j.dd, E = j.tc;
                                if (0 != E) {
                                    if (e(3 <= E), 1 == U.L) 0 < A && wn(O, B, N, E + 4), j.La && Ln(O, B, N, E), 0 < x && yn(O, B, N, E + 4), j.La && Nn(O, B, N, E);
                                    else {
                                        var q = U.B, D = U.qa, R = U.ra + 8 * C * q + 8 * A, T = U.Ha, U = U.Ia + 8 * C * q + 8 * A;
                                        C = j.ld;
                                        0 < A && (fn(O, B, N, E + 4, M, C), pn(D, R, T, U, q, E + 4, M, C)), j.La && (mn(O, B, N, E, M, C), bn(D, R, T, U, q, E, M, C)), 0 < x && (ln(O, B, N, E + 4, M, C), dn(D, R, T, U, q, E + 4, M, C)), j.La && (gn(O, B, N, E, M, C), vn(D, R, T, U, q, E, M, C));
                                    }
                                }
                            }
                            if (s.ia && alert("todo:DitherRow"), null != c.put) {
                                if (L = 16 * P, P = 16 * (P + 1), I ? (c.y = s.sa, c.O = s.ta + w, c.f = s.qa, c.N = s.ra + _, c.ea = s.Ha, c.W = s.Ia + _) : (L -= y, c.y = d, c.O = p, c.f = g, c.N = l, c.ea = m, c.W = v), b || (P -= y), P > c.o && (P = c.o), c.F = null, c.J = null, null != s.Fa && 0 < s.Fa.length && L < P && (c.J = lr(s, c, L, P - L), c.F = s.mb, null == c.F && 0 == c.F.length)) {
                                    u = Jt(s, 3, "Could not decode alpha data.");
                                    break t;
                                }
                                L < c.j && (y = c.j - L, L = c.j, e(!(1 & y)), c.O += s.R * y, c.N += s.B * (y >> 1), c.W += s.B * (y >> 1), null != c.F && (c.J += c.width * y)), L < P && (c.O += c.v, c.N += c.v >> 1, c.W += c.v >> 1, null != c.F && (c.J += c.v), c.ka = L - c.j, c.U = c.va - c.v, c.T = P - L, u = c.put(c));
                            }
                            o + 1 != s.Ic || b || (n(s.sa, s.ta - h, d, p + 16 * s.R, h), n(s.qa, s.ra - f, g, l + 8 * s.B, f), n(s.Ha, s.Ia - f, m, v + 8 * s.B, f));
                        }
                        if (!u) return Jt(t, 6, "Output aborted.");
                    }
                    return 1;
                }(t, r)), null != r.bc && r.bc(r), s &= 1;
            }
            return s ? (t.cb = 0, s) : 0;
        }
        function te(t, e, r, n, i) {
            i = t[e + r + 32 * n] + (i >> 3), t[e + r + 32 * n] = -256 & i ? 0 > i ? 0 : 255 : i;
        }
        function ee(t, e, r, n, i, a) {
            te(t, e, 0, r, n + i), te(t, e, 1, r, n + a), te(t, e, 2, r, n - a), te(t, e, 3, r, n - i);
        }
        function re(t) {
            return (20091 * t >> 16) + t;
        }
        function ne(t, e, r, n) {
            var i, o = 0, s = a(16);
            for(i = 0; 4 > i; ++i){
                var c = t[e + 0] + t[e + 8], u = t[e + 0] - t[e + 8], h = (35468 * t[e + 4] >> 16) - re(t[e + 12]), l = re(t[e + 4]) + (35468 * t[e + 12] >> 16);
                s[o + 0] = c + l, s[o + 1] = u + h, s[o + 2] = u - h, s[o + 3] = c - l, o += 4, e++;
            }
            for(i = o = 0; 4 > i; ++i)c = (t = s[o + 0] + 4) + s[o + 8], u = t - s[o + 8], h = (35468 * s[o + 4] >> 16) - re(s[o + 12]), te(r, n, 0, 0, c + (l = re(s[o + 4]) + (35468 * s[o + 12] >> 16))), te(r, n, 1, 0, u + h), te(r, n, 2, 0, u - h), te(r, n, 3, 0, c - l), o++, n += 32;
        }
        function ie(t, e, r, n) {
            var i = t[e + 0] + 4, a = 35468 * t[e + 4] >> 16, o = re(t[e + 4]), s = 35468 * t[e + 1] >> 16;
            ee(r, n, 0, i + o, t = re(t[e + 1]), s), ee(r, n, 1, i + a, t, s), ee(r, n, 2, i - a, t, s), ee(r, n, 3, i - o, t, s);
        }
        function ae(t, e, r, n, i) {
            ne(t, e, r, n), i && ne(t, e + 16, r, n + 4);
        }
        function oe(t, e, r, n) {
            on(t, e + 0, r, n, 1), on(t, e + 32, r, n + 128, 1);
        }
        function se(t, e, r, n) {
            var i;
            for(t = t[e + 0] + 4, i = 0; 4 > i; ++i)for(e = 0; 4 > e; ++e)te(r, n, e, i, t);
        }
        function ce(t, e, r, n) {
            t[e + 0] && un(t, e + 0, r, n), t[e + 16] && un(t, e + 16, r, n + 4), t[e + 32] && un(t, e + 32, r, n + 128), t[e + 48] && un(t, e + 48, r, n + 128 + 4);
        }
        function ue(t, e, r, n) {
            var i, o = a(16);
            for(i = 0; 4 > i; ++i){
                var s = t[e + 0 + i] + t[e + 12 + i], c = t[e + 4 + i] + t[e + 8 + i], u = t[e + 4 + i] - t[e + 8 + i], h = t[e + 0 + i] - t[e + 12 + i];
                o[0 + i] = s + c, o[8 + i] = s - c, o[4 + i] = h + u, o[12 + i] = h - u;
            }
            for(i = 0; 4 > i; ++i)s = (t = o[0 + 4 * i] + 3) + o[3 + 4 * i], c = o[1 + 4 * i] + o[2 + 4 * i], u = o[1 + 4 * i] - o[2 + 4 * i], h = t - o[3 + 4 * i], r[n + 0] = s + c >> 3, r[n + 16] = h + u >> 3, r[n + 32] = s - c >> 3, r[n + 48] = h - u >> 3, n += 64;
        }
        function he(t, e, r) {
            var n, i = e - 32, a = Bn, o = 255 - t[i - 1];
            for(n = 0; n < r; ++n){
                var s, c = a, u = o + t[e - 1];
                for(s = 0; s < r; ++s)t[e + s] = c[u + t[i + s]];
                e += 32;
            }
        }
        function le(t, e) {
            he(t, e, 4);
        }
        function fe(t, e) {
            he(t, e, 8);
        }
        function de(t, e) {
            he(t, e, 16);
        }
        function pe(t, e) {
            var r;
            for(r = 0; 16 > r; ++r)n(t, e + 32 * r, t, e - 32, 16);
        }
        function ge(t, e) {
            var r;
            for(r = 16; 0 < r; --r)i(t, e, t[e - 1], 16), e += 32;
        }
        function me(t, e, r) {
            var n;
            for(n = 0; 16 > n; ++n)i(e, r + 32 * n, t, 16);
        }
        function ve(t, e) {
            var r, n = 16;
            for(r = 0; 16 > r; ++r)n += t[e - 1 + 32 * r] + t[e + r - 32];
            me(n >> 5, t, e);
        }
        function be(t, e) {
            var r, n = 8;
            for(r = 0; 16 > r; ++r)n += t[e - 1 + 32 * r];
            me(n >> 4, t, e);
        }
        function ye(t, e) {
            var r, n = 8;
            for(r = 0; 16 > r; ++r)n += t[e + r - 32];
            me(n >> 4, t, e);
        }
        function we(t, e) {
            me(128, t, e);
        }
        function Ne(t, e, r) {
            return t + 2 * e + r + 2 >> 2;
        }
        function Le(t, e) {
            var r, i = e - 32;
            i = new Uint8Array([
                Ne(t[i - 1], t[i + 0], t[i + 1]),
                Ne(t[i + 0], t[i + 1], t[i + 2]),
                Ne(t[i + 1], t[i + 2], t[i + 3]),
                Ne(t[i + 2], t[i + 3], t[i + 4])
            ]);
            for(r = 0; 4 > r; ++r)n(t, e + 32 * r, i, 0, i.length);
        }
        function Ae(t, e) {
            var r = t[e - 1], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            I(t, e + 0, 16843009 * Ne(t[e - 1 - 32], r, n)), I(t, e + 32, 16843009 * Ne(r, n, i)), I(t, e + 64, 16843009 * Ne(n, i, a)), I(t, e + 96, 16843009 * Ne(i, a, a));
        }
        function xe(t, e) {
            var r, n = 4;
            for(r = 0; 4 > r; ++r)n += t[e + r - 32] + t[e - 1 + 32 * r];
            for(n >>= 3, r = 0; 4 > r; ++r)i(t, e + 32 * r, n, 4);
        }
        function Se(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], c = t[e + 2 - 32], u = t[e + 3 - 32];
            t[e + 0 + 96] = Ne(n, i, t[e - 1 + 96]), t[e + 1 + 96] = t[e + 0 + 64] = Ne(r, n, i), t[e + 2 + 96] = t[e + 1 + 64] = t[e + 0 + 32] = Ne(a, r, n), t[e + 3 + 96] = t[e + 2 + 64] = t[e + 1 + 32] = t[e + 0 + 0] = Ne(o, a, r), t[e + 3 + 64] = t[e + 2 + 32] = t[e + 1 + 0] = Ne(s, o, a), t[e + 3 + 32] = t[e + 2 + 0] = Ne(c, s, o), t[e + 3 + 0] = Ne(u, c, s);
        }
        function _e(t, e) {
            var r = t[e + 1 - 32], n = t[e + 2 - 32], i = t[e + 3 - 32], a = t[e + 4 - 32], o = t[e + 5 - 32], s = t[e + 6 - 32], c = t[e + 7 - 32];
            t[e + 0 + 0] = Ne(t[e + 0 - 32], r, n), t[e + 1 + 0] = t[e + 0 + 32] = Ne(r, n, i), t[e + 2 + 0] = t[e + 1 + 32] = t[e + 0 + 64] = Ne(n, i, a), t[e + 3 + 0] = t[e + 2 + 32] = t[e + 1 + 64] = t[e + 0 + 96] = Ne(i, a, o), t[e + 3 + 32] = t[e + 2 + 64] = t[e + 1 + 96] = Ne(a, o, s), t[e + 3 + 64] = t[e + 2 + 96] = Ne(o, s, c), t[e + 3 + 96] = Ne(s, c, c);
        }
        function Pe(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], c = t[e + 2 - 32], u = t[e + 3 - 32];
            t[e + 0 + 0] = t[e + 1 + 64] = a + o + 1 >> 1, t[e + 1 + 0] = t[e + 2 + 64] = o + s + 1 >> 1, t[e + 2 + 0] = t[e + 3 + 64] = s + c + 1 >> 1, t[e + 3 + 0] = c + u + 1 >> 1, t[e + 0 + 96] = Ne(i, n, r), t[e + 0 + 64] = Ne(n, r, a), t[e + 0 + 32] = t[e + 1 + 96] = Ne(r, a, o), t[e + 1 + 32] = t[e + 2 + 96] = Ne(a, o, s), t[e + 2 + 32] = t[e + 3 + 96] = Ne(o, s, c), t[e + 3 + 32] = Ne(s, c, u);
        }
        function ke(t, e) {
            var r = t[e + 0 - 32], n = t[e + 1 - 32], i = t[e + 2 - 32], a = t[e + 3 - 32], o = t[e + 4 - 32], s = t[e + 5 - 32], c = t[e + 6 - 32], u = t[e + 7 - 32];
            t[e + 0 + 0] = r + n + 1 >> 1, t[e + 1 + 0] = t[e + 0 + 64] = n + i + 1 >> 1, t[e + 2 + 0] = t[e + 1 + 64] = i + a + 1 >> 1, t[e + 3 + 0] = t[e + 2 + 64] = a + o + 1 >> 1, t[e + 0 + 32] = Ne(r, n, i), t[e + 1 + 32] = t[e + 0 + 96] = Ne(n, i, a), t[e + 2 + 32] = t[e + 1 + 96] = Ne(i, a, o), t[e + 3 + 32] = t[e + 2 + 96] = Ne(a, o, s), t[e + 3 + 64] = Ne(o, s, c), t[e + 3 + 96] = Ne(s, c, u);
        }
        function Ie(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            t[e + 0 + 0] = r + n + 1 >> 1, t[e + 2 + 0] = t[e + 0 + 32] = n + i + 1 >> 1, t[e + 2 + 32] = t[e + 0 + 64] = i + a + 1 >> 1, t[e + 1 + 0] = Ne(r, n, i), t[e + 3 + 0] = t[e + 1 + 32] = Ne(n, i, a), t[e + 3 + 32] = t[e + 1 + 64] = Ne(i, a, a), t[e + 3 + 64] = t[e + 2 + 64] = t[e + 0 + 96] = t[e + 1 + 96] = t[e + 2 + 96] = t[e + 3 + 96] = a;
        }
        function Fe(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96], o = t[e - 1 - 32], s = t[e + 0 - 32], c = t[e + 1 - 32], u = t[e + 2 - 32];
            t[e + 0 + 0] = t[e + 2 + 32] = r + o + 1 >> 1, t[e + 0 + 32] = t[e + 2 + 64] = n + r + 1 >> 1, t[e + 0 + 64] = t[e + 2 + 96] = i + n + 1 >> 1, t[e + 0 + 96] = a + i + 1 >> 1, t[e + 3 + 0] = Ne(s, c, u), t[e + 2 + 0] = Ne(o, s, c), t[e + 1 + 0] = t[e + 3 + 32] = Ne(r, o, s), t[e + 1 + 32] = t[e + 3 + 64] = Ne(n, r, o), t[e + 1 + 64] = t[e + 3 + 96] = Ne(i, n, r), t[e + 1 + 96] = Ne(a, i, n);
        }
        function Ce(t, e) {
            var r;
            for(r = 0; 8 > r; ++r)n(t, e + 32 * r, t, e - 32, 8);
        }
        function je(t, e) {
            var r;
            for(r = 0; 8 > r; ++r)i(t, e, t[e - 1], 8), e += 32;
        }
        function Oe(t, e, r) {
            var n;
            for(n = 0; 8 > n; ++n)i(e, r + 32 * n, t, 8);
        }
        function Be(t, e) {
            var r, n = 8;
            for(r = 0; 8 > r; ++r)n += t[e + r - 32] + t[e - 1 + 32 * r];
            Oe(n >> 4, t, e);
        }
        function Me(t, e) {
            var r, n = 4;
            for(r = 0; 8 > r; ++r)n += t[e + r - 32];
            Oe(n >> 3, t, e);
        }
        function Ee(t, e) {
            var r, n = 4;
            for(r = 0; 8 > r; ++r)n += t[e - 1 + 32 * r];
            Oe(n >> 3, t, e);
        }
        function qe(t, e) {
            Oe(128, t, e);
        }
        function De(t, e, r) {
            var n = t[e - r], i = t[e + 0], a = 3 * (i - n) + jn[1020 + t[e - 2 * r] - t[e + r]], o = On[112 + (a + 4 >> 3)];
            t[e - r] = Bn[255 + n + On[112 + (a + 3 >> 3)]], t[e + 0] = Bn[255 + i - o];
        }
        function Re(t, e, r, n) {
            var i = t[e + 0], a = t[e + r];
            return Mn[255 + t[e - 2 * r] - t[e - r]] > n || Mn[255 + a - i] > n;
        }
        function Te(t, e, r, n) {
            return 4 * Mn[255 + t[e - r] - t[e + 0]] + Mn[255 + t[e - 2 * r] - t[e + r]] <= n;
        }
        function Ue(t, e, r, n, i) {
            var a = t[e - 3 * r], o = t[e - 2 * r], s = t[e - r], c = t[e + 0], u = t[e + r], h = t[e + 2 * r], l = t[e + 3 * r];
            return 4 * Mn[255 + s - c] + Mn[255 + o - u] > n ? 0 : Mn[255 + t[e - 4 * r] - a] <= i && Mn[255 + a - o] <= i && Mn[255 + o - s] <= i && Mn[255 + l - h] <= i && Mn[255 + h - u] <= i && Mn[255 + u - c] <= i;
        }
        function ze(t, e, r, n) {
            var i = 2 * n + 1;
            for(n = 0; 16 > n; ++n)Te(t, e + n, r, i) && De(t, e + n, r);
        }
        function He(t, e, r, n) {
            var i = 2 * n + 1;
            for(n = 0; 16 > n; ++n)Te(t, e + n * r, 1, i) && De(t, e + n * r, 1);
        }
        function We(t, e, r, n) {
            var i;
            for(i = 3; 0 < i; --i)ze(t, e += 4 * r, r, n);
        }
        function Ve(t, e, r, n) {
            var i;
            for(i = 3; 0 < i; --i)He(t, e += 4, r, n);
        }
        function Ge(t, e, r, n, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Ue(t, e, r, a, o)) {
                    if (Re(t, e, r, s)) De(t, e, r);
                    else {
                        var c = t, u = e, h = r, l = c[u - 2 * h], f = c[u - h], d = c[u + 0], p = c[u + h], g = c[u + 2 * h], m = 27 * (b = jn[1020 + 3 * (d - f) + jn[1020 + l - p]]) + 63 >> 7, v = 18 * b + 63 >> 7, b = 9 * b + 63 >> 7;
                        c[u - 3 * h] = Bn[255 + c[u - 3 * h] + b], c[u - 2 * h] = Bn[255 + l + v], c[u - h] = Bn[255 + f + m], c[u + 0] = Bn[255 + d - m], c[u + h] = Bn[255 + p - v], c[u + 2 * h] = Bn[255 + g - b];
                    }
                }
                e += n;
            }
        }
        function Ye(t, e, r, n, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Ue(t, e, r, a, o)) {
                    if (Re(t, e, r, s)) De(t, e, r);
                    else {
                        var c = t, u = e, h = r, l = c[u - h], f = c[u + 0], d = c[u + h], p = On[112 + ((g = 3 * (f - l)) + 4 >> 3)], g = On[112 + (g + 3 >> 3)], m = p + 1 >> 1;
                        c[u - 2 * h] = Bn[255 + c[u - 2 * h] + m], c[u - h] = Bn[255 + l + g], c[u + 0] = Bn[255 + f - p], c[u + h] = Bn[255 + d - m];
                    }
                }
                e += n;
            }
        }
        function Je(t, e, r, n, i, a) {
            Ge(t, e, r, 1, 16, n, i, a);
        }
        function Xe(t, e, r, n, i, a) {
            Ge(t, e, 1, r, 16, n, i, a);
        }
        function Ke(t, e, r, n, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ye(t, e += 4 * r, r, 1, 16, n, i, a);
        }
        function Ze(t, e, r, n, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ye(t, e += 4, 1, r, 16, n, i, a);
        }
        function $e(t, e, r, n, i, a, o, s) {
            Ge(t, e, i, 1, 8, a, o, s), Ge(r, n, i, 1, 8, a, o, s);
        }
        function Qe(t, e, r, n, i, a, o, s) {
            Ge(t, e, 1, i, 8, a, o, s), Ge(r, n, 1, i, 8, a, o, s);
        }
        function tr(t, e, r, n, i, a, o, s) {
            Ye(t, e + 4 * i, i, 1, 8, a, o, s), Ye(r, n + 4 * i, i, 1, 8, a, o, s);
        }
        function er(t, e, r, n, i, a, o, s) {
            Ye(t, e + 4, 1, i, 8, a, o, s), Ye(r, n + 4, 1, i, 8, a, o, s);
        }
        function rr() {
            this.ba = new ot, this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new ct, this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
        }
        function nr() {
            this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
        }
        function ir() {
            this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
        }
        function ar() {
            this.ua = 0, this.Wa = new M, this.vb = new M, this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new d, this.yc = new l;
        }
        function or() {
            this.xb = this.a = 0, this.l = new Gt, this.ca = new ot, this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new N, this.Pb = 0, this.wd = new N, this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new ar, this.ab = 0, this.gc = o(4, ir), this.Oc = 0;
        }
        function sr() {
            this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Gt, this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
        }
        function cr(t, e, r, n, i, a, o) {
            for(t = null == t ? 0 : t[e + 0], e = 0; e < o; ++e)i[a + e] = t + r[n + e] & 255, t = i[a + e];
        }
        function ur(t, e, r, n, i, a, o) {
            var s;
            if (null == t) cr(null, null, r, n, i, a, o);
            else for(s = 0; s < o; ++s)i[a + s] = t[e + s] + r[n + s] & 255;
        }
        function hr(t, e, r, n, i, a, o) {
            if (null == t) cr(null, null, r, n, i, a, o);
            else {
                var s, c = t[e + 0], u = c, h = c;
                for(s = 0; s < o; ++s)u = h + (c = t[e + s]) - u, h = r[n + s] + (-256 & u ? 0 > u ? 0 : 255 : u) & 255, u = c, i[a + s] = h;
            }
        }
        function lr(t, r, i, o) {
            var s = r.width, c = r.o;
            if (e(null != t && null != r), 0 > i || 0 >= o || i + o > c) return null;
            if (!t.Cc) {
                if (null == t.ga) {
                    var u;
                    if (t.ga = new sr, (u = null == t.ga) || (u = r.width * r.o, e(0 == t.Gb.length), t.Gb = a(u), t.Uc = 0, null == t.Gb ? u = 0 : (t.mb = t.Gb, t.nb = t.Uc, t.rc = null, u = 1), u = !u), !u) {
                        u = t.ga;
                        var h = t.Fa, l = t.P, f = t.qc, d = t.mb, p = t.nb, g = l + 1, m = f - 1, b = u.l;
                        if (e(null != h && null != d && null != r), mi[0] = null, mi[1] = cr, mi[2] = ur, mi[3] = hr, u.ca = d, u.tb = p, u.c = r.width, u.i = r.height, e(0 < u.c && 0 < u.i), 1 >= f) r = 0;
                        else if (u.$a = h[l + 0] >> 0 & 3, u.Z = h[l + 0] >> 2 & 3, u.Lc = h[l + 0] >> 4 & 3, l = h[l + 0] >> 6 & 3, 0 > u.$a || 1 < u.$a || 4 <= u.Z || 1 < u.Lc || l) r = 0;
                        else if (b.put = dt, b.ac = ft, b.bc = pt, b.ma = u, b.width = r.width, b.height = r.height, b.Da = r.Da, b.v = r.v, b.va = r.va, b.j = r.j, b.o = r.o, u.$a) t: {
                            e(1 == u.$a), r = kt();
                            e: for(;;){
                                if (null == r) {
                                    r = 0;
                                    break t;
                                }
                                if (e(null != u), u.mc = r, r.c = u.c, r.i = u.i, r.l = u.l, r.l.ma = u, r.l.width = u.c, r.l.height = u.i, r.a = 0, v(r.m, h, g, m), !It(u.c, u.i, 1, r, null)) break e;
                                if (1 == r.ab && 3 == r.gc[0].hc && At(r.s) ? (u.ic = 1, h = r.c * r.i, r.Ta = null, r.Ua = 0, r.V = a(h), r.Ba = 0, null == r.V ? (r.a = 1, r = 0) : r = 1) : (u.ic = 0, r = Ft(r, u.c)), !r) break e;
                                r = 1;
                                break t;
                            }
                            u.mc = null, r = 0;
                        }
                        else r = m >= u.c * u.i;
                        u = !r;
                    }
                    if (u) return null;
                    1 != t.ga.Lc ? t.Ga = 0 : o = c - i;
                }
                e(null != t.ga), e(i + o <= c);
                t: {
                    if (r = (h = t.ga).c, c = h.l.o, 0 == h.$a) {
                        if (g = t.rc, m = t.Vc, b = t.Fa, l = t.P + 1 + i * r, f = t.mb, d = t.nb + i * r, e(l <= t.P + t.qc), 0 != h.Z) for(e(null != mi[h.Z]), u = 0; u < o; ++u)mi[h.Z](g, m, b, l, f, d, r), g = f, m = d, d += r, l += r;
                        else for(u = 0; u < o; ++u)n(f, d, b, l, r), g = f, m = d, d += r, l += r;
                        t.rc = g, t.Vc = m;
                    } else {
                        if (e(null != h.mc), r = i + o, e(null != (u = h.mc)), e(r <= u.i), u.C >= r) r = 1;
                        else if (h.ic || mr(), h.ic) {
                            h = u.V, g = u.Ba, m = u.c;
                            var y = u.i, w = (b = 1, l = u.$ / m, f = u.$ % m, d = u.m, p = u.s, u.$), N = m * y, L = m * r, x = p.wc, _ = w < L ? wt(p, f, l) : null;
                            e(w <= N), e(r <= y), e(At(p));
                            e: for(;;){
                                for(; !d.h && w < L;){
                                    if (f & x || (_ = wt(p, f, l)), e(null != _), S(d), 256 > (y = bt(_.G[0], _.H[0], d))) h[g + w] = y, ++w, ++f >= m && (f = 0, ++l <= r && !(l % 16) && St(u, l));
                                    else {
                                        if (!(280 > y)) {
                                            b = 0;
                                            break e;
                                        }
                                        y = mt(y - 256, d);
                                        var P, k = bt(_.G[4], _.H[4], d);
                                        if (S(d), !(w >= (k = vt(m, k = mt(k, d))) && N - w >= y)) {
                                            b = 0;
                                            break e;
                                        }
                                        for(P = 0; P < y; ++P)h[g + w + P] = h[g + w + P - k];
                                        for(w += y, f += y; f >= m;)f -= m, ++l <= r && !(l % 16) && St(u, l);
                                        w < L && f & x && (_ = wt(p, f, l));
                                    }
                                    e(d.h == A(d));
                                }
                                St(u, l > r ? r : l);
                                break e;
                            }
                            !b || d.h && w < N ? (b = 0, u.a = d.h ? 5 : 3) : u.$ = w, r = b;
                        } else r = _t(u, u.V, u.Ba, u.c, u.i, r, Ct);
                        if (!r) {
                            o = 0;
                            break t;
                        }
                    }
                    i + o >= c && (t.Cc = 1), o = 1;
                }
                if (!o) return null;
                if (t.Cc && (null != (o = t.ga) && (o.mc = null), t.ga = null, 0 < t.Ga)) return alert("todo:WebPDequantizeLevels"), null;
            }
            return t.nb + i * s;
        }
        function fr(t, e, r, n, i, a) {
            for(; 0 < i--;){
                var o, s = t, c = e + (r ? 1 : 0), u = t, h = e + (r ? 0 : 3);
                for(o = 0; o < n; ++o){
                    var l = u[h + 4 * o];
                    255 != l && (l *= 32897, s[c + 4 * o + 0] = s[c + 4 * o + 0] * l >> 23, s[c + 4 * o + 1] = s[c + 4 * o + 1] * l >> 23, s[c + 4 * o + 2] = s[c + 4 * o + 2] * l >> 23);
                }
                e += a;
            }
        }
        function dr(t, e, r, n, i) {
            for(; 0 < n--;){
                var a;
                for(a = 0; a < r; ++a){
                    var o = t[e + 2 * a + 0], s = 15 & (u = t[e + 2 * a + 1]), c = 4369 * s, u = (240 & u | u >> 4) * c >> 16;
                    t[e + 2 * a + 0] = (240 & o | o >> 4) * c >> 16 & 240 | (15 & o | o << 4) * c >> 16 >> 4 & 15, t[e + 2 * a + 1] = 240 & u | s;
                }
                e += i;
            }
        }
        function pr(t, e, r, n, i, a, o, s) {
            var c, u, h = 255;
            for(u = 0; u < i; ++u){
                for(c = 0; c < n; ++c){
                    var l = t[e + c];
                    a[o + 4 * c] = l, h &= l;
                }
                e += r, o += s;
            }
            return 255 != h;
        }
        function gr(t, e, r, n, i) {
            var a;
            for(a = 0; a < i; ++a)r[n + a] = t[e + a] >> 8;
        }
        function mr() {
            An = fr, xn = dr, Sn = pr, _n = gr;
        }
        function vr(r, n, i) {
            t[r] = function(t, r, a, o, s, c, u, h, l, f, d, p, g, m, v, b, y) {
                var w, N = y - 1 >> 1, L = s[c + 0] | u[h + 0] << 16, A = l[f + 0] | d[p + 0] << 16;
                e(null != t);
                var x = 3 * L + A + 131074 >> 2;
                for(n(t[r + 0], 255 & x, x >> 16, g, m), null != a && (x = 3 * A + L + 131074 >> 2, n(a[o + 0], 255 & x, x >> 16, v, b)), w = 1; w <= N; ++w){
                    var S = s[c + w] | u[h + w] << 16, _ = l[f + w] | d[p + w] << 16, P = L + S + A + _ + 524296, k = P + 2 * (S + A) >> 3;
                    x = k + L >> 1, L = (P = P + 2 * (L + _) >> 3) + S >> 1, n(t[r + 2 * w - 1], 255 & x, x >> 16, g, m + (2 * w - 1) * i), n(t[r + 2 * w - 0], 255 & L, L >> 16, g, m + (2 * w - 0) * i), null != a && (x = P + A >> 1, L = k + _ >> 1, n(a[o + 2 * w - 1], 255 & x, x >> 16, v, b + (2 * w - 1) * i), n(a[o + 2 * w + 0], 255 & L, L >> 16, v, b + (2 * w + 0) * i)), L = S, A = _;
                }
                1 & y || (x = 3 * L + A + 131074 >> 2, n(t[r + y - 1], 255 & x, x >> 16, g, m + (y - 1) * i), null != a && (x = 3 * A + L + 131074 >> 2, n(a[o + y - 1], 255 & x, x >> 16, v, b + (y - 1) * i)));
            };
        }
        function br() {
            vi[En] = bi, vi[qn] = wi, vi[Dn] = yi, vi[Rn] = Ni, vi[Tn] = Li, vi[Un] = Ai, vi[zn] = xi, vi[Hn] = wi, vi[Wn] = Ni, vi[Vn] = Li, vi[Gn] = Ai;
        }
        function yr(t) {
            return t & ~Fi ? 0 > t ? 0 : 255 : t >> Ii;
        }
        function wr(t, e) {
            return yr((19077 * t >> 8) + (26149 * e >> 8) - 14234);
        }
        function Nr(t, e, r) {
            return yr((19077 * t >> 8) - (6419 * e >> 8) - (13320 * r >> 8) + 8708);
        }
        function Lr(t, e) {
            return yr((19077 * t >> 8) + (33050 * e >> 8) - 17685);
        }
        function Ar(t, e, r, n, i) {
            n[i + 0] = wr(t, r), n[i + 1] = Nr(t, e, r), n[i + 2] = Lr(t, e);
        }
        function xr(t, e, r, n, i) {
            n[i + 0] = Lr(t, e), n[i + 1] = Nr(t, e, r), n[i + 2] = wr(t, r);
        }
        function Sr(t, e, r, n, i) {
            var a = Nr(t, e, r);
            e = a << 3 & 224 | Lr(t, e) >> 3, n[i + 0] = 248 & wr(t, r) | a >> 5, n[i + 1] = e;
        }
        function _r(t, e, r, n, i) {
            var a = 240 & Lr(t, e) | 15;
            n[i + 0] = 240 & wr(t, r) | Nr(t, e, r) >> 4, n[i + 1] = a;
        }
        function Pr(t, e, r, n, i) {
            n[i + 0] = 255, Ar(t, e, r, n, i + 1);
        }
        function kr(t, e, r, n, i) {
            xr(t, e, r, n, i), n[i + 3] = 255;
        }
        function Ir(t, e, r, n, i) {
            Ar(t, e, r, n, i), n[i + 3] = 255;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Fr(e, r, n) {
            t[e] = function(t, e, i, a, o, s, c, u, h) {
                for(var l = u + (-2 & h) * n; u != l;)r(t[e + 0], i[a + 0], o[s + 0], c, u), r(t[e + 1], i[a + 0], o[s + 0], c, u + n), e += 2, ++a, ++s, u += 2 * n;
                1 & h && r(t[e + 0], i[a + 0], o[s + 0], c, u);
            };
        }
        function Cr(t, e, r) {
            return 0 == r ? 0 == t ? 0 == e ? 6 : 5 : 0 == e ? 4 : 0 : r;
        }
        function jr(t, e, r, n, i) {
            switch(t >>> 30){
                case 3:
                    on(e, r, n, i, 0);
                    break;
                case 2:
                    sn(e, r, n, i);
                    break;
                case 1:
                    un(e, r, n, i);
            }
        }
        function Or(t, e) {
            var r, a, o = e.M, s = e.Nb, c = t.oc, u = t.pc + 40, h = t.oc, l = t.pc + 584, f = t.oc, d = t.pc + 600;
            for(r = 0; 16 > r; ++r)c[u + 32 * r - 1] = 129;
            for(r = 0; 8 > r; ++r)h[l + 32 * r - 1] = 129, f[d + 32 * r - 1] = 129;
            for(0 < o ? c[u - 1 - 32] = h[l - 1 - 32] = f[d - 1 - 32] = 129 : (i(c, u - 32 - 1, 127, 21), i(h, l - 32 - 1, 127, 9), i(f, d - 32 - 1, 127, 9)), a = 0; a < t.za; ++a){
                var p = e.ya[e.aa + a];
                if (0 < a) {
                    for(r = -1; 16 > r; ++r)n(c, u + 32 * r - 4, c, u + 32 * r + 12, 4);
                    for(r = -1; 8 > r; ++r)n(h, l + 32 * r - 4, h, l + 32 * r + 4, 4), n(f, d + 32 * r - 4, f, d + 32 * r + 4, 4);
                }
                var g = t.Gd, m = t.Hd + a, v = p.ad, b = p.Hc;
                if (0 < o && (n(c, u - 32, g[m].y, 0, 16), n(h, l - 32, g[m].f, 0, 8), n(f, d - 32, g[m].ea, 0, 8)), p.Za) {
                    var y = c, w = u - 32 + 16;
                    for(0 < o && (a >= t.za - 1 ? i(y, w, g[m].y[15], 4) : n(y, w, g[m + 1].y, 0, 4)), r = 0; 4 > r; r++)y[w + 128 + r] = y[w + 256 + r] = y[w + 384 + r] = y[w + 0 + r];
                    for(r = 0; 16 > r; ++r, b <<= 2)y = c, w = u + Di[r], fi[p.Ob[r]](y, w), jr(b, v, 16 * +r, y, w);
                } else if (y = Cr(a, o, p.Ob[0]), li[y](c, u), 0 != b) for(r = 0; 16 > r; ++r, b <<= 2)jr(b, v, 16 * +r, c, u + Di[r]);
                for(r = p.Gc, y = Cr(a, o, p.Dd), di[y](h, l), di[y](f, d), b = v, y = h, w = l, 255 & (p = r >> 0) && (170 & p ? cn(b, 256, y, w) : hn(b, 256, y, w)), p = f, b = d, 255 & (r >>= 8) && (170 & r ? cn(v, 320, p, b) : hn(v, 320, p, b)), o < t.Ub - 1 && (n(g[m].y, 0, c, u + 480, 16), n(g[m].f, 0, h, l + 224, 8), n(g[m].ea, 0, f, d + 224, 8)), r = 8 * s * t.B, g = t.sa, m = t.ta + 16 * a + 16 * s * t.R, v = t.qa, p = t.ra + 8 * a + r, b = t.Ha, y = t.Ia + 8 * a + r, r = 0; 16 > r; ++r)n(g, m + r * t.R, c, u + 32 * r, 16);
                for(r = 0; 8 > r; ++r)n(v, p + r * t.B, h, l + 32 * r, 8), n(b, y + r * t.B, f, d + 32 * r, 8);
            }
        }
        function Br(t, n, i, a, o, s, c, u, h) {
            var l = [
                0
            ], f = [
                0
            ], d = 0, p = null != h ? h.kd : 0, g = null != h ? h : new nr;
            if (null == t || 12 > i) return 7;
            g.data = t, g.w = n, g.ha = i, n = [
                n
            ], i = [
                i
            ], g.gb = [
                g.gb
            ];
            t: {
                var m = n, b = i, y = g.gb;
                if (e(null != t), e(null != b), e(null != y), y[0] = 0, 12 <= b[0] && !r(t, m[0], "RIFF")) {
                    if (r(t, m[0] + 8, "WEBP")) {
                        y = 3;
                        break t;
                    }
                    var w = j(t, m[0] + 4);
                    if (12 > w || 4294967286 < w) {
                        y = 3;
                        break t;
                    }
                    if (p && w > b[0] - 8) {
                        y = 7;
                        break t;
                    }
                    y[0] = w, m[0] += 12, b[0] -= 12;
                }
                y = 0;
            }
            if (0 != y) return y;
            for(w = 0 < g.gb[0], i = i[0];;){
                t: {
                    var L = t;
                    b = n, y = i;
                    var A = l, x = f, S = m = [
                        0
                    ];
                    if ((k = d = [
                        d
                    ])[0] = 0, 8 > y[0]) y = 7;
                    else {
                        if (!r(L, b[0], "VP8X")) {
                            if (10 != j(L, b[0] + 4)) {
                                y = 3;
                                break t;
                            }
                            if (18 > y[0]) {
                                y = 7;
                                break t;
                            }
                            var _ = j(L, b[0] + 8), P = 1 + C(L, b[0] + 12);
                            if (2147483648 <= P * (L = 1 + C(L, b[0] + 15))) {
                                y = 3;
                                break t;
                            }
                            null != S && (S[0] = _), null != A && (A[0] = P), null != x && (x[0] = L), b[0] += 18, y[0] -= 18, k[0] = 1;
                        }
                        y = 0;
                    }
                }
                if (d = d[0], m = m[0], 0 != y) return y;
                if (b = !!(2 & m), !w && d) return 3;
                if (null != s && (s[0] = !!(16 & m)), null != c && (c[0] = b), null != u && (u[0] = 0), c = l[0], m = f[0], d && b && null == h) {
                    y = 0;
                    break;
                }
                if (4 > i) {
                    y = 7;
                    break;
                }
                if (w && d || !w && !d && !r(t, n[0], "ALPH")) {
                    i = [
                        i
                    ], g.na = [
                        g.na
                    ], g.P = [
                        g.P
                    ], g.Sa = [
                        g.Sa
                    ];
                    t: {
                        _ = t, y = n, w = i;
                        var k = g.gb;
                        A = g.na, x = g.P, S = g.Sa;
                        P = 22, e(null != _), e(null != w), L = y[0];
                        var I = w[0];
                        for(e(null != A), e(null != S), A[0] = null, x[0] = null, S[0] = 0;;){
                            if (y[0] = L, w[0] = I, 8 > I) {
                                y = 7;
                                break t;
                            }
                            var F = j(_, L + 4);
                            if (4294967286 < F) {
                                y = 3;
                                break t;
                            }
                            var O = 8 + F + 1 & -2;
                            if (P += O, 0 < k && P > k) {
                                y = 3;
                                break t;
                            }
                            if (!r(_, L, "VP8 ") || !r(_, L, "VP8L")) {
                                y = 0;
                                break t;
                            }
                            if (I[0] < O) {
                                y = 7;
                                break t;
                            }
                            r(_, L, "ALPH") || (A[0] = _, x[0] = L + 8, S[0] = F), L += O, I -= O;
                        }
                    }
                    if (i = i[0], g.na = g.na[0], g.P = g.P[0], g.Sa = g.Sa[0], 0 != y) break;
                }
                i = [
                    i
                ], g.Ja = [
                    g.Ja
                ], g.xa = [
                    g.xa
                ];
                t: if (k = t, y = n, w = i, A = g.gb[0], x = g.Ja, S = g.xa, _ = y[0], L = !r(k, _, "VP8 "), P = !r(k, _, "VP8L"), e(null != k), e(null != w), e(null != x), e(null != S), 8 > w[0]) y = 7;
                else {
                    if (L || P) {
                        if (k = j(k, _ + 4), 12 <= A && k > A - 12) {
                            y = 3;
                            break t;
                        }
                        if (p && k > w[0] - 8) {
                            y = 7;
                            break t;
                        }
                        x[0] = k, y[0] += 8, w[0] -= 8, S[0] = P;
                    } else S[0] = 5 <= w[0] && 47 == k[_ + 0] && !(k[_ + 4] >> 5), x[0] = w[0];
                    y = 0;
                }
                if (i = i[0], g.Ja = g.Ja[0], g.xa = g.xa[0], n = n[0], 0 != y) break;
                if (4294967286 < g.Ja) return 3;
                if (null == u || b || (u[0] = g.xa ? 2 : 1), c = [
                    c
                ], m = [
                    m
                ], g.xa) {
                    if (5 > i) {
                        y = 7;
                        break;
                    }
                    u = c, p = m, b = s, null == t || 5 > i ? t = 0 : 5 <= i && 47 == t[n + 0] && !(t[n + 4] >> 5) ? (w = [
                        0
                    ], k = [
                        0
                    ], A = [
                        0
                    ], v(x = new N, t, n, i), gt(x, w, k, A) ? (null != u && (u[0] = w[0]), null != p && (p[0] = k[0]), null != b && (b[0] = A[0]), t = 1) : t = 0) : t = 0;
                } else {
                    if (10 > i) {
                        y = 7;
                        break;
                    }
                    u = m, null == t || 10 > i || !Xt(t, n + 3, i - 3) ? t = 0 : (p = t[n + 0] | t[n + 1] << 8 | t[n + 2] << 16, b = 16383 & (t[n + 7] << 8 | t[n + 6]), t = 16383 & (t[n + 9] << 8 | t[n + 8]), 1 & p || 3 < (p >> 1 & 7) || !(p >> 4 & 1) || p >> 5 >= g.Ja || !b || !t ? t = 0 : (c && (c[0] = b), u && (u[0] = t), t = 1));
                }
                if (!t) return 3;
                if (c = c[0], m = m[0], d && (l[0] != c || f[0] != m)) return 3;
                null != h && (h[0] = g, h.offset = n - h.w, e(4294967286 > n - h.w), e(h.offset == h.ha - i));
                break;
            }
            return 0 == y || 7 == y && d && null == h ? (null != s && (s[0] |= null != g.na && 0 < g.na.length), null != a && (a[0] = c), null != o && (o[0] = m), 0) : y;
        }
        function Mr(t, e, r) {
            var n = e.width, i = e.height, a = 0, o = 0, s = n, c = i;
            if (e.Da = null != t && 0 < t.Da, e.Da && (s = t.cd, c = t.bd, a = t.v, o = t.j, 11 > r || (a &= -2, o &= -2), 0 > a || 0 > o || 0 >= s || 0 >= c || a + s > n || o + c > i)) return 0;
            if (e.v = a, e.j = o, e.va = a + s, e.o = o + c, e.U = s, e.T = c, e.da = null != t && 0 < t.da, e.da) {
                if (!E(s, c, r = [
                    t.ib
                ], a = [
                    t.hb
                ])) return 0;
                e.ib = r[0], e.hb = a[0];
            }
            return e.ob = null != t && t.ob, e.Kb = null == t || !t.Sd, e.da && (e.ob = e.ib < 3 * n / 4 && e.hb < 3 * i / 4, e.Kb = 0), 1;
        }
        function Er(t) {
            if (null == t) return 2;
            if (11 > t.S) {
                var e = t.f.RGBA;
                e.fb += (t.height - 1) * e.A, e.A = -e.A;
            } else e = t.f.kb, t = t.height, e.O += (t - 1) * e.fa, e.fa = -e.fa, e.N += (t - 1 >> 1) * e.Ab, e.Ab = -e.Ab, e.W += (t - 1 >> 1) * e.Db, e.Db = -e.Db, null != e.F && (e.J += (t - 1) * e.lb, e.lb = -e.lb);
            return 0;
        }
        function qr(t, e, r, n) {
            if (null == n || 0 >= t || 0 >= e) return 2;
            if (null != r) {
                if (r.Da) {
                    var i = r.cd, o = r.bd, s = -2 & r.v, c = -2 & r.j;
                    if (0 > s || 0 > c || 0 >= i || 0 >= o || s + i > t || c + o > e) return 2;
                    t = i, e = o;
                }
                if (r.da) {
                    if (!E(t, e, i = [
                        r.ib
                    ], o = [
                        r.hb
                    ])) return 2;
                    t = i[0], e = o[0];
                }
            }
            n.width = t, n.height = e;
            t: {
                var u = n.width, h = n.height;
                if (t = n.S, 0 >= u || 0 >= h || !(t >= En && 13 > t)) t = 2;
                else {
                    if (0 >= n.Rd && null == n.sd) {
                        s = o = i = e = 0;
                        var l = (c = u * zi[t]) * h;
                        if (11 > t || (o = (h + 1) / 2 * (e = (u + 1) / 2), 12 == t && (s = (i = u) * h)), null == (h = a(l + 2 * o + s))) {
                            t = 1;
                            break t;
                        }
                        n.sd = h, 11 > t ? ((u = n.f.RGBA).eb = h, u.fb = 0, u.A = c, u.size = l) : ((u = n.f.kb).y = h, u.O = 0, u.fa = c, u.Fd = l, u.f = h, u.N = 0 + l, u.Ab = e, u.Cd = o, u.ea = h, u.W = 0 + l + o, u.Db = e, u.Ed = o, 12 == t && (u.F = h, u.J = 0 + l + 2 * o), u.Tc = s, u.lb = i);
                    }
                    if (e = 1, i = n.S, o = n.width, s = n.height, i >= En && 13 > i) {
                        if (11 > i) t = n.f.RGBA, e &= (c = Math.abs(t.A)) * (s - 1) + o <= t.size, e &= c >= o * zi[i], e &= null != t.eb;
                        else {
                            t = n.f.kb, c = (o + 1) / 2, l = (s + 1) / 2, u = Math.abs(t.fa);
                            h = Math.abs(t.Ab);
                            var f = Math.abs(t.Db), d = Math.abs(t.lb), p = d * (s - 1) + o;
                            e &= u * (s - 1) + o <= t.Fd, e &= h * (l - 1) + c <= t.Cd, e = (e &= f * (l - 1) + c <= t.Ed) & u >= o & h >= c & f >= c, e &= null != t.y, e &= null != t.f, e &= null != t.ea, 12 == i && (e &= d >= o, e &= p <= t.Tc, e &= null != t.F);
                        }
                    } else e = 0;
                    t = e ? 0 : 2;
                }
            }
            return 0 != t || null != r && r.fd && (t = Er(n)), t;
        }
        var Dr = 64, Rr = [
            0,
            1,
            3,
            7,
            15,
            31,
            63,
            127,
            255,
            511,
            1023,
            2047,
            4095,
            8191,
            16383,
            32767,
            65535,
            131071,
            262143,
            524287,
            1048575,
            2097151,
            4194303,
            8388607,
            16777215
        ], Tr = 24, Ur = 32, zr = 8, Hr = [
            0,
            0,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7
        ];
        R("Predictor0", "PredictorAdd0"), t.Predictor0 = function() {
            return 4278190080;
        }, t.Predictor1 = function(t) {
            return t;
        }, t.Predictor2 = function(t, e, r) {
            return e[r + 0];
        }, t.Predictor3 = function(t, e, r) {
            return e[r + 1];
        }, t.Predictor4 = function(t, e, r) {
            return e[r - 1];
        }, t.Predictor5 = function(t, e, r) {
            return U(U(t, e[r + 1]), e[r + 0]);
        }, t.Predictor6 = function(t, e, r) {
            return U(t, e[r - 1]);
        }, t.Predictor7 = function(t, e, r) {
            return U(t, e[r + 0]);
        }, t.Predictor8 = function(t, e, r) {
            return U(e[r - 1], e[r + 0]);
        }, t.Predictor9 = function(t, e, r) {
            return U(e[r + 0], e[r + 1]);
        }, t.Predictor10 = function(t, e, r) {
            return U(U(t, e[r - 1]), U(e[r + 0], e[r + 1]));
        }, t.Predictor11 = function(t, e, r) {
            var n = e[r + 0];
            return 0 >= W(n >> 24 & 255, t >> 24 & 255, (e = e[r - 1]) >> 24 & 255) + W(n >> 16 & 255, t >> 16 & 255, e >> 16 & 255) + W(n >> 8 & 255, t >> 8 & 255, e >> 8 & 255) + W(255 & n, 255 & t, 255 & e) ? n : t;
        }, t.Predictor12 = function(t, e, r) {
            var n = e[r + 0];
            return (z((t >> 24 & 255) + (n >> 24 & 255) - ((e = e[r - 1]) >> 24 & 255)) << 24 | z((t >> 16 & 255) + (n >> 16 & 255) - (e >> 16 & 255)) << 16 | z((t >> 8 & 255) + (n >> 8 & 255) - (e >> 8 & 255)) << 8 | z((255 & t) + (255 & n) - (255 & e))) >>> 0;
        }, t.Predictor13 = function(t, e, r) {
            var n = e[r - 1];
            return (H((t = U(t, e[r + 0])) >> 24 & 255, n >> 24 & 255) << 24 | H(t >> 16 & 255, n >> 16 & 255) << 16 | H(t >> 8 & 255, n >> 8 & 255) << 8 | H(t >> 0 & 255, n >> 0 & 255)) >>> 0;
        };
        var Wr = t.PredictorAdd0;
        t.PredictorAdd1 = V, R("Predictor2", "PredictorAdd2"), R("Predictor3", "PredictorAdd3"), R("Predictor4", "PredictorAdd4"), R("Predictor5", "PredictorAdd5"), R("Predictor6", "PredictorAdd6"), R("Predictor7", "PredictorAdd7"), R("Predictor8", "PredictorAdd8"), R("Predictor9", "PredictorAdd9"), R("Predictor10", "PredictorAdd10"), R("Predictor11", "PredictorAdd11"), R("Predictor12", "PredictorAdd12"), R("Predictor13", "PredictorAdd13");
        var Vr = t.PredictorAdd2;
        X("ColorIndexInverseTransform", "MapARGB", "32b", function(t) {
            return t >> 8 & 255;
        }, function(t) {
            return t;
        }), X("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(t) {
            return t;
        }, function(t) {
            return t >> 8 & 255;
        });
        var Gr, Yr = t.ColorIndexInverseTransform, Jr = t.MapARGB, Xr = t.VP8LColorIndexInverseTransformAlpha, Kr = t.MapAlpha, Zr = t.VP8LPredictorsAdd = [];
        Zr.length = 16, (t.VP8LPredictors = []).length = 16, (t.VP8LPredictorsAdd_C = []).length = 16, (t.VP8LPredictors_C = []).length = 16;
        var $r, Qr, tn, en, rn, nn, an, on, sn, cn, un, hn, ln, fn, dn, pn, gn, mn, vn, bn, yn, wn, Nn, Ln, An, xn, Sn, _n, Pn = a(511), kn = a(2041), In = a(225), Fn = a(767), Cn = 0, jn = kn, On = In, Bn = Fn, Mn = Pn, En = 0, qn = 1, Dn = 2, Rn = 3, Tn = 4, Un = 5, zn = 6, Hn = 7, Wn = 8, Vn = 9, Gn = 10, Yn = [
            2,
            3,
            7
        ], Jn = [
            3,
            3,
            11
        ], Xn = [
            280,
            256,
            256,
            256,
            40
        ], Kn = [
            0,
            1,
            1,
            1,
            0
        ], Zn = [
            17,
            18,
            0,
            1,
            2,
            3,
            4,
            5,
            16,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15
        ], $n = [
            24,
            7,
            23,
            25,
            40,
            6,
            39,
            41,
            22,
            26,
            38,
            42,
            56,
            5,
            55,
            57,
            21,
            27,
            54,
            58,
            37,
            43,
            72,
            4,
            71,
            73,
            20,
            28,
            53,
            59,
            70,
            74,
            36,
            44,
            88,
            69,
            75,
            52,
            60,
            3,
            87,
            89,
            19,
            29,
            86,
            90,
            35,
            45,
            68,
            76,
            85,
            91,
            51,
            61,
            104,
            2,
            103,
            105,
            18,
            30,
            102,
            106,
            34,
            46,
            84,
            92,
            67,
            77,
            101,
            107,
            50,
            62,
            120,
            1,
            119,
            121,
            83,
            93,
            17,
            31,
            100,
            108,
            66,
            78,
            118,
            122,
            33,
            47,
            117,
            123,
            49,
            63,
            99,
            109,
            82,
            94,
            0,
            116,
            124,
            65,
            79,
            16,
            32,
            98,
            110,
            48,
            115,
            125,
            81,
            95,
            64,
            114,
            126,
            97,
            111,
            80,
            113,
            127,
            96,
            112
        ], Qn = [
            2954,
            2956,
            2958,
            2962,
            2970,
            2986,
            3018,
            3082,
            3212,
            3468,
            3980,
            5004
        ], ti = 8, ei = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            17,
            18,
            19,
            20,
            20,
            21,
            21,
            22,
            22,
            23,
            23,
            24,
            25,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            91,
            93,
            95,
            96,
            98,
            100,
            101,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            118,
            122,
            124,
            126,
            128,
            130,
            132,
            134,
            136,
            138,
            140,
            143,
            145,
            148,
            151,
            154,
            157
        ], ri = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            60,
            62,
            64,
            66,
            68,
            70,
            72,
            74,
            76,
            78,
            80,
            82,
            84,
            86,
            88,
            90,
            92,
            94,
            96,
            98,
            100,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            119,
            122,
            125,
            128,
            131,
            134,
            137,
            140,
            143,
            146,
            149,
            152,
            155,
            158,
            161,
            164,
            167,
            170,
            173,
            177,
            181,
            185,
            189,
            193,
            197,
            201,
            205,
            209,
            213,
            217,
            221,
            225,
            229,
            234,
            239,
            245,
            249,
            254,
            259,
            264,
            269,
            274,
            279,
            284
        ], ni = null, ii = [
            [
                173,
                148,
                140,
                0
            ],
            [
                176,
                155,
                140,
                135,
                0
            ],
            [
                180,
                157,
                141,
                134,
                130,
                0
            ],
            [
                254,
                254,
                243,
                230,
                196,
                177,
                153,
                140,
                133,
                130,
                129,
                0
            ]
        ], ai = [
            0,
            1,
            4,
            8,
            5,
            2,
            3,
            6,
            9,
            12,
            13,
            10,
            7,
            11,
            14,
            15
        ], oi = [
            -0,
            1,
            -1,
            2,
            -2,
            3,
            4,
            6,
            -3,
            5,
            -4,
            -5,
            -6,
            7,
            -7,
            8,
            -8,
            -9
        ], si = [
            [
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        253,
                        136,
                        254,
                        255,
                        228,
                        219,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        189,
                        129,
                        242,
                        255,
                        227,
                        213,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        106,
                        126,
                        227,
                        252,
                        214,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        98,
                        248,
                        255,
                        236,
                        226,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        181,
                        133,
                        238,
                        254,
                        221,
                        234,
                        255,
                        154,
                        128,
                        128,
                        128
                    ],
                    [
                        78,
                        134,
                        202,
                        247,
                        198,
                        180,
                        255,
                        219,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        185,
                        249,
                        255,
                        243,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        150,
                        247,
                        255,
                        236,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        77,
                        110,
                        216,
                        255,
                        236,
                        230,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        101,
                        251,
                        255,
                        241,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        170,
                        139,
                        241,
                        252,
                        236,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        37,
                        116,
                        196,
                        243,
                        228,
                        255,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        204,
                        254,
                        255,
                        245,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        207,
                        160,
                        250,
                        255,
                        238,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        102,
                        103,
                        231,
                        255,
                        211,
                        171,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        152,
                        252,
                        255,
                        240,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        177,
                        135,
                        243,
                        255,
                        234,
                        225,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        80,
                        129,
                        211,
                        255,
                        194,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        246,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        198,
                        35,
                        237,
                        223,
                        193,
                        187,
                        162,
                        160,
                        145,
                        155,
                        62
                    ],
                    [
                        131,
                        45,
                        198,
                        221,
                        172,
                        176,
                        220,
                        157,
                        252,
                        221,
                        1
                    ],
                    [
                        68,
                        47,
                        146,
                        208,
                        149,
                        167,
                        221,
                        162,
                        255,
                        223,
                        128
                    ]
                ],
                [
                    [
                        1,
                        149,
                        241,
                        255,
                        221,
                        224,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        141,
                        234,
                        253,
                        222,
                        220,
                        255,
                        199,
                        128,
                        128,
                        128
                    ],
                    [
                        81,
                        99,
                        181,
                        242,
                        176,
                        190,
                        249,
                        202,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        129,
                        232,
                        253,
                        214,
                        197,
                        242,
                        196,
                        255,
                        255,
                        128
                    ],
                    [
                        99,
                        121,
                        210,
                        250,
                        201,
                        198,
                        255,
                        202,
                        128,
                        128,
                        128
                    ],
                    [
                        23,
                        91,
                        163,
                        242,
                        170,
                        187,
                        247,
                        210,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        200,
                        246,
                        255,
                        234,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        109,
                        178,
                        241,
                        255,
                        231,
                        245,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        44,
                        130,
                        201,
                        253,
                        205,
                        192,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        132,
                        239,
                        251,
                        219,
                        209,
                        255,
                        165,
                        128,
                        128,
                        128
                    ],
                    [
                        94,
                        136,
                        225,
                        251,
                        218,
                        190,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        22,
                        100,
                        174,
                        245,
                        186,
                        161,
                        255,
                        199,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        249,
                        255,
                        232,
                        235,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        124,
                        143,
                        241,
                        255,
                        227,
                        234,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        35,
                        77,
                        181,
                        251,
                        193,
                        211,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        157,
                        247,
                        255,
                        236,
                        231,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        121,
                        141,
                        235,
                        255,
                        225,
                        227,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        45,
                        99,
                        188,
                        251,
                        195,
                        217,
                        255,
                        224,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        251,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        203,
                        1,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        137,
                        1,
                        177,
                        255,
                        224,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        253,
                        9,
                        248,
                        251,
                        207,
                        208,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        175,
                        13,
                        224,
                        243,
                        193,
                        185,
                        249,
                        198,
                        255,
                        255,
                        128
                    ],
                    [
                        73,
                        17,
                        171,
                        221,
                        161,
                        179,
                        236,
                        167,
                        255,
                        234,
                        128
                    ]
                ],
                [
                    [
                        1,
                        95,
                        247,
                        253,
                        212,
                        183,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        239,
                        90,
                        244,
                        250,
                        211,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        155,
                        77,
                        195,
                        248,
                        188,
                        195,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        24,
                        239,
                        251,
                        218,
                        219,
                        255,
                        205,
                        128,
                        128,
                        128
                    ],
                    [
                        201,
                        51,
                        219,
                        255,
                        196,
                        186,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        69,
                        46,
                        190,
                        239,
                        201,
                        218,
                        255,
                        228,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        191,
                        251,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        223,
                        165,
                        249,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        124,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        16,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        190,
                        36,
                        230,
                        255,
                        236,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        226,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        247,
                        192,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        240,
                        128,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        134,
                        252,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        213,
                        62,
                        250,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        55,
                        93,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        202,
                        24,
                        213,
                        235,
                        186,
                        191,
                        220,
                        160,
                        240,
                        175,
                        255
                    ],
                    [
                        126,
                        38,
                        182,
                        232,
                        169,
                        184,
                        228,
                        174,
                        255,
                        187,
                        128
                    ],
                    [
                        61,
                        46,
                        138,
                        219,
                        151,
                        178,
                        240,
                        170,
                        255,
                        216,
                        128
                    ]
                ],
                [
                    [
                        1,
                        112,
                        230,
                        250,
                        199,
                        191,
                        247,
                        159,
                        255,
                        255,
                        128
                    ],
                    [
                        166,
                        109,
                        228,
                        252,
                        211,
                        215,
                        255,
                        174,
                        128,
                        128,
                        128
                    ],
                    [
                        39,
                        77,
                        162,
                        232,
                        172,
                        180,
                        245,
                        178,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        52,
                        220,
                        246,
                        198,
                        199,
                        249,
                        220,
                        255,
                        255,
                        128
                    ],
                    [
                        124,
                        74,
                        191,
                        243,
                        183,
                        193,
                        250,
                        221,
                        255,
                        255,
                        128
                    ],
                    [
                        24,
                        71,
                        130,
                        219,
                        154,
                        170,
                        243,
                        182,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        225,
                        249,
                        219,
                        240,
                        255,
                        224,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        150,
                        226,
                        252,
                        216,
                        205,
                        255,
                        171,
                        128,
                        128,
                        128
                    ],
                    [
                        28,
                        108,
                        170,
                        242,
                        183,
                        194,
                        254,
                        223,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        81,
                        230,
                        252,
                        204,
                        203,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        123,
                        102,
                        209,
                        247,
                        188,
                        196,
                        255,
                        233,
                        128,
                        128,
                        128
                    ],
                    [
                        20,
                        95,
                        153,
                        243,
                        164,
                        173,
                        255,
                        203,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        222,
                        248,
                        255,
                        216,
                        213,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        168,
                        175,
                        246,
                        252,
                        235,
                        205,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        47,
                        116,
                        215,
                        255,
                        211,
                        212,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        121,
                        236,
                        253,
                        212,
                        214,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        84,
                        213,
                        252,
                        201,
                        202,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        42,
                        80,
                        160,
                        240,
                        162,
                        185,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        244,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        238,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ]
        ], ci = [
            [
                [
                    231,
                    120,
                    48,
                    89,
                    115,
                    113,
                    120,
                    152,
                    112
                ],
                [
                    152,
                    179,
                    64,
                    126,
                    170,
                    118,
                    46,
                    70,
                    95
                ],
                [
                    175,
                    69,
                    143,
                    80,
                    85,
                    82,
                    72,
                    155,
                    103
                ],
                [
                    56,
                    58,
                    10,
                    171,
                    218,
                    189,
                    17,
                    13,
                    152
                ],
                [
                    114,
                    26,
                    17,
                    163,
                    44,
                    195,
                    21,
                    10,
                    173
                ],
                [
                    121,
                    24,
                    80,
                    195,
                    26,
                    62,
                    44,
                    64,
                    85
                ],
                [
                    144,
                    71,
                    10,
                    38,
                    171,
                    213,
                    144,
                    34,
                    26
                ],
                [
                    170,
                    46,
                    55,
                    19,
                    136,
                    160,
                    33,
                    206,
                    71
                ],
                [
                    63,
                    20,
                    8,
                    114,
                    114,
                    208,
                    12,
                    9,
                    226
                ],
                [
                    81,
                    40,
                    11,
                    96,
                    182,
                    84,
                    29,
                    16,
                    36
                ]
            ],
            [
                [
                    134,
                    183,
                    89,
                    137,
                    98,
                    101,
                    106,
                    165,
                    148
                ],
                [
                    72,
                    187,
                    100,
                    130,
                    157,
                    111,
                    32,
                    75,
                    80
                ],
                [
                    66,
                    102,
                    167,
                    99,
                    74,
                    62,
                    40,
                    234,
                    128
                ],
                [
                    41,
                    53,
                    9,
                    178,
                    241,
                    141,
                    26,
                    8,
                    107
                ],
                [
                    74,
                    43,
                    26,
                    146,
                    73,
                    166,
                    49,
                    23,
                    157
                ],
                [
                    65,
                    38,
                    105,
                    160,
                    51,
                    52,
                    31,
                    115,
                    128
                ],
                [
                    104,
                    79,
                    12,
                    27,
                    217,
                    255,
                    87,
                    17,
                    7
                ],
                [
                    87,
                    68,
                    71,
                    44,
                    114,
                    51,
                    15,
                    186,
                    23
                ],
                [
                    47,
                    41,
                    14,
                    110,
                    182,
                    183,
                    21,
                    17,
                    194
                ],
                [
                    66,
                    45,
                    25,
                    102,
                    197,
                    189,
                    23,
                    18,
                    22
                ]
            ],
            [
                [
                    88,
                    88,
                    147,
                    150,
                    42,
                    46,
                    45,
                    196,
                    205
                ],
                [
                    43,
                    97,
                    183,
                    117,
                    85,
                    38,
                    35,
                    179,
                    61
                ],
                [
                    39,
                    53,
                    200,
                    87,
                    26,
                    21,
                    43,
                    232,
                    171
                ],
                [
                    56,
                    34,
                    51,
                    104,
                    114,
                    102,
                    29,
                    93,
                    77
                ],
                [
                    39,
                    28,
                    85,
                    171,
                    58,
                    165,
                    90,
                    98,
                    64
                ],
                [
                    34,
                    22,
                    116,
                    206,
                    23,
                    34,
                    43,
                    166,
                    73
                ],
                [
                    107,
                    54,
                    32,
                    26,
                    51,
                    1,
                    81,
                    43,
                    31
                ],
                [
                    68,
                    25,
                    106,
                    22,
                    64,
                    171,
                    36,
                    225,
                    114
                ],
                [
                    34,
                    19,
                    21,
                    102,
                    132,
                    188,
                    16,
                    76,
                    124
                ],
                [
                    62,
                    18,
                    78,
                    95,
                    85,
                    57,
                    50,
                    48,
                    51
                ]
            ],
            [
                [
                    193,
                    101,
                    35,
                    159,
                    215,
                    111,
                    89,
                    46,
                    111
                ],
                [
                    60,
                    148,
                    31,
                    172,
                    219,
                    228,
                    21,
                    18,
                    111
                ],
                [
                    112,
                    113,
                    77,
                    85,
                    179,
                    255,
                    38,
                    120,
                    114
                ],
                [
                    40,
                    42,
                    1,
                    196,
                    245,
                    209,
                    10,
                    25,
                    109
                ],
                [
                    88,
                    43,
                    29,
                    140,
                    166,
                    213,
                    37,
                    43,
                    154
                ],
                [
                    61,
                    63,
                    30,
                    155,
                    67,
                    45,
                    68,
                    1,
                    209
                ],
                [
                    100,
                    80,
                    8,
                    43,
                    154,
                    1,
                    51,
                    26,
                    71
                ],
                [
                    142,
                    78,
                    78,
                    16,
                    255,
                    128,
                    34,
                    197,
                    171
                ],
                [
                    41,
                    40,
                    5,
                    102,
                    211,
                    183,
                    4,
                    1,
                    221
                ],
                [
                    51,
                    50,
                    17,
                    168,
                    209,
                    192,
                    23,
                    25,
                    82
                ]
            ],
            [
                [
                    138,
                    31,
                    36,
                    171,
                    27,
                    166,
                    38,
                    44,
                    229
                ],
                [
                    67,
                    87,
                    58,
                    169,
                    82,
                    115,
                    26,
                    59,
                    179
                ],
                [
                    63,
                    59,
                    90,
                    180,
                    59,
                    166,
                    93,
                    73,
                    154
                ],
                [
                    40,
                    40,
                    21,
                    116,
                    143,
                    209,
                    34,
                    39,
                    175
                ],
                [
                    47,
                    15,
                    16,
                    183,
                    34,
                    223,
                    49,
                    45,
                    183
                ],
                [
                    46,
                    17,
                    33,
                    183,
                    6,
                    98,
                    15,
                    32,
                    183
                ],
                [
                    57,
                    46,
                    22,
                    24,
                    128,
                    1,
                    54,
                    17,
                    37
                ],
                [
                    65,
                    32,
                    73,
                    115,
                    28,
                    128,
                    23,
                    128,
                    205
                ],
                [
                    40,
                    3,
                    9,
                    115,
                    51,
                    192,
                    18,
                    6,
                    223
                ],
                [
                    87,
                    37,
                    9,
                    115,
                    59,
                    77,
                    64,
                    21,
                    47
                ]
            ],
            [
                [
                    104,
                    55,
                    44,
                    218,
                    9,
                    54,
                    53,
                    130,
                    226
                ],
                [
                    64,
                    90,
                    70,
                    205,
                    40,
                    41,
                    23,
                    26,
                    57
                ],
                [
                    54,
                    57,
                    112,
                    184,
                    5,
                    41,
                    38,
                    166,
                    213
                ],
                [
                    30,
                    34,
                    26,
                    133,
                    152,
                    116,
                    10,
                    32,
                    134
                ],
                [
                    39,
                    19,
                    53,
                    221,
                    26,
                    114,
                    32,
                    73,
                    255
                ],
                [
                    31,
                    9,
                    65,
                    234,
                    2,
                    15,
                    1,
                    118,
                    73
                ],
                [
                    75,
                    32,
                    12,
                    51,
                    192,
                    255,
                    160,
                    43,
                    51
                ],
                [
                    88,
                    31,
                    35,
                    67,
                    102,
                    85,
                    55,
                    186,
                    85
                ],
                [
                    56,
                    21,
                    23,
                    111,
                    59,
                    205,
                    45,
                    37,
                    192
                ],
                [
                    55,
                    38,
                    70,
                    124,
                    73,
                    102,
                    1,
                    34,
                    98
                ]
            ],
            [
                [
                    125,
                    98,
                    42,
                    88,
                    104,
                    85,
                    117,
                    175,
                    82
                ],
                [
                    95,
                    84,
                    53,
                    89,
                    128,
                    100,
                    113,
                    101,
                    45
                ],
                [
                    75,
                    79,
                    123,
                    47,
                    51,
                    128,
                    81,
                    171,
                    1
                ],
                [
                    57,
                    17,
                    5,
                    71,
                    102,
                    57,
                    53,
                    41,
                    49
                ],
                [
                    38,
                    33,
                    13,
                    121,
                    57,
                    73,
                    26,
                    1,
                    85
                ],
                [
                    41,
                    10,
                    67,
                    138,
                    77,
                    110,
                    90,
                    47,
                    114
                ],
                [
                    115,
                    21,
                    2,
                    10,
                    102,
                    255,
                    166,
                    23,
                    6
                ],
                [
                    101,
                    29,
                    16,
                    10,
                    85,
                    128,
                    101,
                    196,
                    26
                ],
                [
                    57,
                    18,
                    10,
                    102,
                    102,
                    213,
                    34,
                    20,
                    43
                ],
                [
                    117,
                    20,
                    15,
                    36,
                    163,
                    128,
                    68,
                    1,
                    26
                ]
            ],
            [
                [
                    102,
                    61,
                    71,
                    37,
                    34,
                    53,
                    31,
                    243,
                    192
                ],
                [
                    69,
                    60,
                    71,
                    38,
                    73,
                    119,
                    28,
                    222,
                    37
                ],
                [
                    68,
                    45,
                    128,
                    34,
                    1,
                    47,
                    11,
                    245,
                    171
                ],
                [
                    62,
                    17,
                    19,
                    70,
                    146,
                    85,
                    55,
                    62,
                    70
                ],
                [
                    37,
                    43,
                    37,
                    154,
                    100,
                    163,
                    85,
                    160,
                    1
                ],
                [
                    63,
                    9,
                    92,
                    136,
                    28,
                    64,
                    32,
                    201,
                    85
                ],
                [
                    75,
                    15,
                    9,
                    9,
                    64,
                    255,
                    184,
                    119,
                    16
                ],
                [
                    86,
                    6,
                    28,
                    5,
                    64,
                    255,
                    25,
                    248,
                    1
                ],
                [
                    56,
                    8,
                    17,
                    132,
                    137,
                    255,
                    55,
                    116,
                    128
                ],
                [
                    58,
                    15,
                    20,
                    82,
                    135,
                    57,
                    26,
                    121,
                    40
                ]
            ],
            [
                [
                    164,
                    50,
                    31,
                    137,
                    154,
                    133,
                    25,
                    35,
                    218
                ],
                [
                    51,
                    103,
                    44,
                    131,
                    131,
                    123,
                    31,
                    6,
                    158
                ],
                [
                    86,
                    40,
                    64,
                    135,
                    148,
                    224,
                    45,
                    183,
                    128
                ],
                [
                    22,
                    26,
                    17,
                    131,
                    240,
                    154,
                    14,
                    1,
                    209
                ],
                [
                    45,
                    16,
                    21,
                    91,
                    64,
                    222,
                    7,
                    1,
                    197
                ],
                [
                    56,
                    21,
                    39,
                    155,
                    60,
                    138,
                    23,
                    102,
                    213
                ],
                [
                    83,
                    12,
                    13,
                    54,
                    192,
                    255,
                    68,
                    47,
                    28
                ],
                [
                    85,
                    26,
                    85,
                    85,
                    128,
                    128,
                    32,
                    146,
                    171
                ],
                [
                    18,
                    11,
                    7,
                    63,
                    144,
                    171,
                    4,
                    4,
                    246
                ],
                [
                    35,
                    27,
                    10,
                    146,
                    174,
                    171,
                    12,
                    26,
                    128
                ]
            ],
            [
                [
                    190,
                    80,
                    35,
                    99,
                    180,
                    80,
                    126,
                    54,
                    45
                ],
                [
                    85,
                    126,
                    47,
                    87,
                    176,
                    51,
                    41,
                    20,
                    32
                ],
                [
                    101,
                    75,
                    128,
                    139,
                    118,
                    146,
                    116,
                    128,
                    85
                ],
                [
                    56,
                    41,
                    15,
                    176,
                    236,
                    85,
                    37,
                    9,
                    62
                ],
                [
                    71,
                    30,
                    17,
                    119,
                    118,
                    255,
                    17,
                    18,
                    138
                ],
                [
                    101,
                    38,
                    60,
                    138,
                    55,
                    70,
                    43,
                    26,
                    142
                ],
                [
                    146,
                    36,
                    19,
                    30,
                    171,
                    255,
                    97,
                    27,
                    20
                ],
                [
                    138,
                    45,
                    61,
                    62,
                    219,
                    1,
                    81,
                    188,
                    64
                ],
                [
                    32,
                    41,
                    20,
                    117,
                    151,
                    142,
                    20,
                    21,
                    163
                ],
                [
                    112,
                    19,
                    12,
                    61,
                    195,
                    128,
                    48,
                    4,
                    24
                ]
            ]
        ], ui = [
            [
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        176,
                        246,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        241,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        244,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        246,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        239,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        217,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        225,
                        252,
                        241,
                        253,
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        250,
                        241,
                        250,
                        253,
                        255,
                        253,
                        254,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        238,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        247,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        186,
                        251,
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        251,
                        244,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        251,
                        243,
                        253,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        236,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        253,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        248,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        254,
                        252,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        249,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        246,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        254,
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        245,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ]
        ], hi = [
            0,
            1,
            2,
            3,
            6,
            4,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            0
        ], li = [], fi = [], di = [], pi = 1, gi = 2, mi = [], vi = [];
        vr("UpsampleRgbLinePair", Ar, 3), vr("UpsampleBgrLinePair", xr, 3), vr("UpsampleRgbaLinePair", Ir, 4), vr("UpsampleBgraLinePair", kr, 4), vr("UpsampleArgbLinePair", Pr, 4), vr("UpsampleRgba4444LinePair", _r, 2), vr("UpsampleRgb565LinePair", Sr, 2);
        var bi = t.UpsampleRgbLinePair, yi = t.UpsampleBgrLinePair, wi = t.UpsampleRgbaLinePair, Ni = t.UpsampleBgraLinePair, Li = t.UpsampleArgbLinePair, Ai = t.UpsampleRgba4444LinePair, xi = t.UpsampleRgb565LinePair, Si = 16, _i = 1 << Si - 1, Pi = -227, ki = 482, Ii = 6, Fi = (256 << Ii) - 1, Ci = 0, ji = a(256), Oi = a(256), Bi = a(256), Mi = a(256), Ei = a(ki - Pi), qi = a(ki - Pi);
        Fr("YuvToRgbRow", Ar, 3), Fr("YuvToBgrRow", xr, 3), Fr("YuvToRgbaRow", Ir, 4), Fr("YuvToBgraRow", kr, 4), Fr("YuvToArgbRow", Pr, 4), Fr("YuvToRgba4444Row", _r, 2), Fr("YuvToRgb565Row", Sr, 2);
        var Di = [
            0,
            4,
            8,
            12,
            128,
            132,
            136,
            140,
            256,
            260,
            264,
            268,
            384,
            388,
            392,
            396
        ], Ri = [
            0,
            2,
            8
        ], Ti = [
            8,
            7,
            6,
            4,
            4,
            2,
            2,
            2,
            1,
            1,
            1,
            1
        ], Ui = 1;
        this.WebPDecodeRGBA = function(t, r, n, i, a) {
            var o = qn, s = new rr, c = new ot;
            s.ba = c, c.S = o, c.width = [
                c.width
            ], c.height = [
                c.height
            ];
            var u = c.width, h = c.height, l = new st;
            if (null == l || null == t) var f = 2;
            else e(null != l), f = Br(t, r, n, l.width, l.height, l.Pd, l.Qd, l.format, null);
            if (0 != f ? u = 0 : (null != u && (u[0] = l.width[0]), null != h && (h[0] = l.height[0]), u = 1), u) {
                c.width = c.width[0], c.height = c.height[0], null != i && (i[0] = c.width), null != a && (a[0] = c.height);
                t: {
                    if (i = new Gt, (a = new nr).data = t, a.w = r, a.ha = n, a.kd = 1, r = [
                        0
                    ], e(null != a), (0 == (t = Br(a.data, a.w, a.ha, null, null, null, r, null, a)) || 7 == t) && r[0] && (t = 4), 0 == (r = t)) {
                        if (e(null != s), i.data = a.data, i.w = a.w + a.offset, i.ha = a.ha - a.offset, i.put = dt, i.ac = ft, i.bc = pt, i.ma = s, a.xa) {
                            if (null == (t = kt())) {
                                s = 1;
                                break t;
                            }
                            if (function(t, r) {
                                var n = [
                                    0
                                ], i = [
                                    0
                                ], a = [
                                    0
                                ];
                                e: for(;;){
                                    if (null == t) return 0;
                                    if (null == r) return t.a = 2, 0;
                                    if (t.l = r, t.a = 0, v(t.m, r.data, r.w, r.ha), !gt(t.m, n, i, a)) {
                                        t.a = 3;
                                        break e;
                                    }
                                    if (t.xb = gi, r.width = n[0], r.height = i[0], !It(n[0], i[0], 1, t, null)) break e;
                                    return 1;
                                }
                                return e(0 != t.a), 0;
                            }(t, i)) {
                                if (i = 0 == (r = qr(i.width, i.height, s.Oa, s.ba))) {
                                    e: {
                                        i = t;
                                        r: for(;;){
                                            if (null == i) {
                                                i = 0;
                                                break e;
                                            }
                                            if (e(null != i.s.yc), e(null != i.s.Ya), e(0 < i.s.Wb), e(null != (n = i.l)), e(null != (a = n.ma)), 0 != i.xb) {
                                                if (i.ca = a.ba, i.tb = a.tb, e(null != i.ca), !Mr(a.Oa, n, Rn)) {
                                                    i.a = 2;
                                                    break r;
                                                }
                                                if (!Ft(i, n.width)) break r;
                                                if (n.da) break r;
                                                if ((n.da || nt(i.ca.S)) && mr(), 11 > i.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), null != i.ca.f.kb.F && mr()), i.Pb && 0 < i.s.ua && null == i.s.vb.X && !O(i.s.vb, i.s.Wa.Xa)) {
                                                    i.a = 1;
                                                    break r;
                                                }
                                                i.xb = 0;
                                            }
                                            if (!_t(i, i.V, i.Ba, i.c, i.i, n.o, Lt)) break r;
                                            a.Dc = i.Ma, i = 1;
                                            break e;
                                        }
                                        e(0 != i.a), i = 0;
                                    }
                                    i = !i;
                                }
                                i && (r = t.a);
                            } else r = t.a;
                        } else {
                            t = new Yt;
                            if (t.Fa = a.na, t.P = a.P, t.qc = a.Sa, Kt(t, i)) {
                                if (0 == (r = qr(i.width, i.height, s.Oa, s.ba))) {
                                    if (t.Aa = 0, n = s.Oa, e(null != (a = t)), null != n) {
                                        if (0 < (u = 0 > (u = n.Md) ? 0 : 100 < u ? 255 : 255 * u / 100)) {
                                            for(h = l = 0; 4 > h; ++h)12 > (f = a.pb[h]).lc && (f.ia = u * Ti[0 > f.lc ? 0 : f.lc] >> 3), l |= f.ia;
                                            l && (alert("todo:VP8InitRandom"), a.ia = 1);
                                        }
                                        a.Ga = n.Id, 100 < a.Ga ? a.Ga = 100 : 0 > a.Ga && (a.Ga = 0);
                                    }
                                    Qt(t, i) || (r = t.a);
                                }
                            } else r = t.a;
                        }
                        0 == r && null != s.Oa && s.Oa.fd && (r = Er(s.ba));
                    }
                    s = r;
                }
                o = 0 != s ? null : 11 > o ? c.f.RGBA.eb : c.f.kb.y;
            } else o = null;
            return o;
        };
        var zi = [
            3,
            4,
            3,
            4,
            4,
            2,
            2,
            4,
            4,
            4,
            2,
            1,
            1
        ];
    };
    function u(t, e) {
        for(var r = "", n = 0; n < 4; n++)r += String.fromCharCode(t[e++]);
        return r;
    }
    function h(t, e) {
        return (t[e + 0] << 0 | t[e + 1] << 8 | t[e + 2] << 16) >>> 0;
    }
    function l(t, e) {
        return (t[e + 0] << 0 | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
    }
    new c;
    var f = [
        0
    ], d = [
        0
    ], p = [], g = new c, m = t, v = function(t, e) {
        var r = {}, n = 0, i = !1, a = 0, o = 0;
        if (r.frames = [], !/** @license
   * Copyright (c) 2017 Dominik Homberger
  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  https://webpjs.appspot.com
  WebPRiffParser dominikhlbg@gmail.com
  */ function(t, e, r, n) {
            for(var i = 0; i < n; i++)if (t[e + i] != r.charCodeAt(i)) return !0;
            return !1;
        }(t, e, "RIFF", 4)) {
            var s, c;
            l(t, e += 4);
            for(e += 8; e < t.length;){
                var f = u(t, e), d = l(t, e += 4);
                e += 4;
                var p = d + (1 & d);
                switch(f){
                    case "VP8 ":
                    case "VP8L":
                        void 0 === r.frames[n] && (r.frames[n] = {});
                        (v = r.frames[n]).src_off = i ? o : e - 8, v.src_size = a + d + 8, n++, i && (i = !1, a = 0, o = 0);
                        break;
                    case "VP8X":
                        (v = r.header = {}).feature_flags = t[e];
                        var g = e + 4;
                        v.canvas_width = 1 + h(t, g);
                        g += 3;
                        v.canvas_height = 1 + h(t, g);
                        g += 3;
                        break;
                    case "ALPH":
                        i = !0, a = p + 8, o = e - 8;
                        break;
                    case "ANIM":
                        (v = r.header).bgcolor = l(t, e);
                        g = e + 4;
                        v.loop_count = (s = t)[(c = g) + 0] << 0 | s[c + 1] << 8;
                        g += 2;
                        break;
                    case "ANMF":
                        var m, v;
                        (v = r.frames[n] = {}).offset_x = 2 * h(t, e), e += 3, v.offset_y = 2 * h(t, e), e += 3, v.width = 1 + h(t, e), e += 3, v.height = 1 + h(t, e), e += 3, v.duration = h(t, e), e += 3, m = t[e++], v.dispose = 1 & m, v.blend = m >> 1 & 1;
                }
                "ANMF" != f && (e += p);
            }
            return r;
        }
    }(m, 0);
    v.response = m, v.rgbaoutput = !0, v.dataurl = !1;
    var b = v.header ? v.header : null, y = v.frames ? v.frames : null;
    if (b) {
        b.loop_counter = b.loop_count, f = [
            b.canvas_height
        ], d = [
            b.canvas_width
        ];
        for(var w = 0; w < y.length && 0 != y[w].blend; w++);
    }
    var N = y[0], L = g.WebPDecodeRGBA(m, N.src_off, N.src_size, d, f);
    N.rgba = L, N.imgwidth = d[0], N.imgheight = f[0];
    for(var A = 0; A < d[0] * f[0] * 4; A++)p[A] = L[A];
    return this.width = d, this.height = f, this.data = p, this;
}

!function(t) {
    var r = function() {
        return "function" == typeof (0, $3ae101cb5c0083b5$export$f87121a6d50aff25);
    }, n = function(r, n, a, h) {
        var l = 4, f = s;
        switch(h){
            case t.image_compression.FAST:
                l = 1, f = o;
                break;
            case t.image_compression.MEDIUM:
                l = 6, f = c;
                break;
            case t.image_compression.SLOW:
                l = 9, f = u;
        }
        r = i(r, n, a, f);
        var d = (0, $3ae101cb5c0083b5$export$f87121a6d50aff25)(r, {
            level: l
        });
        return t.__addimage__.arrayBufferToBinaryString(d);
    }, i = function(t, e, r, n) {
        for(var i, a, o, s = t.length / e, c = new Uint8Array(t.length + s), u = l(), h = 0; h < s; h += 1){
            if (o = h * e, i = t.subarray(o, o + e), n) c.set(n(i, r, a), o + h);
            else {
                for(var d, p = u.length, g = []; d < p; d += 1)g[d] = u[d](i, r, a);
                var m = f(g.concat());
                c.set(g[m], o + h);
            }
            a = i;
        }
        return c;
    }, a = function(t) {
        var e = Array.apply([], t);
        return e.unshift(0), e;
    }, o = function(t, e) {
        var r, n = [], i = t.length;
        n[0] = 1;
        for(var a = 0; a < i; a += 1)r = t[a - e] || 0, n[a + 1] = t[a] - r + 256 & 255;
        return n;
    }, s = function(t, e, r) {
        var n, i = [], a = t.length;
        i[0] = 2;
        for(var o = 0; o < a; o += 1)n = r && r[o] || 0, i[o + 1] = t[o] - n + 256 & 255;
        return i;
    }, c = function(t, e, r) {
        var n, i, a = [], o = t.length;
        a[0] = 3;
        for(var s = 0; s < o; s += 1)n = t[s - e] || 0, i = r && r[s] || 0, a[s + 1] = t[s] + 256 - (n + i >>> 1) & 255;
        return a;
    }, u = function(t, e, r) {
        var n, i, a, o, s = [], c = t.length;
        s[0] = 4;
        for(var u = 0; u < c; u += 1)n = t[u - e] || 0, i = r && r[u] || 0, a = r && r[u - e] || 0, o = h(n, i, a), s[u + 1] = t[u] - o + 256 & 255;
        return s;
    }, h = function(t, e, r) {
        if (t === e && e === r) return t;
        var n = Math.abs(e - r), i = Math.abs(t - r), a = Math.abs(t + e - r - r);
        return n <= i && n <= a ? t : i <= a ? e : r;
    }, l = function() {
        return [
            a,
            o,
            s,
            c,
            u
        ];
    }, f = function(t) {
        var e = t.map(function(t) {
            return t.reduce(function(t, e) {
                return t + Math.abs(e);
            }, 0);
        });
        return e.indexOf(Math.min.apply(null, e));
    };
    t.processPNG = function(e, i, a, o) {
        var s, c, u, h, l, f, d, p, g, m, v, b, y, w, N, L = this.decode.FLATE_DECODE, A = "";
        if (this.__addimage__.isArrayBuffer(e) && (e = new Uint8Array(e)), this.__addimage__.isArrayBufferView(e)) {
            if (e = (u = new $020d60e69294d716$var$Kt(e)).imgData, c = u.bits, s = u.colorSpace, l = u.colors, -1 !== [
                4,
                6
            ].indexOf(u.colorType)) {
                if (8 === u.bits) {
                    g = (p = 32 == u.pixelBitlength ? new Uint32Array(u.decodePixels().buffer) : 16 == u.pixelBitlength ? new Uint16Array(u.decodePixels().buffer) : new Uint8Array(u.decodePixels().buffer)).length, v = new Uint8Array(g * u.colors), m = new Uint8Array(g);
                    var x, S = u.pixelBitlength - u.bits;
                    for(w = 0, N = 0; w < g; w++){
                        for(y = p[w], x = 0; x < S;)v[N++] = y >>> x & 255, x += u.bits;
                        m[w] = y >>> x & 255;
                    }
                }
                if (16 === u.bits) {
                    g = (p = new Uint32Array(u.decodePixels().buffer)).length, v = new Uint8Array(g * (32 / u.pixelBitlength) * u.colors), m = new Uint8Array(g * (32 / u.pixelBitlength)), b = u.colors > 1, w = 0, N = 0;
                    for(var _ = 0; w < g;)y = p[w++], v[N++] = y >>> 0 & 255, b && (v[N++] = y >>> 16 & 255, y = p[w++], v[N++] = y >>> 0 & 255), m[_++] = y >>> 16 & 255;
                    c = 8;
                }
                o !== t.image_compression.NONE && r() ? (e = n(v, u.width * u.colors, u.colors, o), d = n(m, u.width, 1, o)) : (e = v, d = m, L = void 0);
            }
            if (3 === u.colorType && (s = this.color_spaces.INDEXED, f = u.palette, u.transparency.indexed)) {
                var P = u.transparency.indexed, k = 0;
                for(w = 0, g = P.length; w < g; ++w)k += P[w];
                if ((k /= 255) === g - 1 && -1 !== P.indexOf(0)) h = [
                    P.indexOf(0)
                ];
                else if (k !== g) {
                    for(p = u.decodePixels(), m = new Uint8Array(p.length), w = 0, g = p.length; w < g; w++)m[w] = P[p[w]];
                    d = n(m, u.width, 1);
                }
            }
            var I = function(e) {
                var r;
                switch(e){
                    case t.image_compression.FAST:
                        r = 11;
                        break;
                    case t.image_compression.MEDIUM:
                        r = 13;
                        break;
                    case t.image_compression.SLOW:
                        r = 14;
                        break;
                    default:
                        r = 12;
                }
                return r;
            }(o);
            return L === this.decode.FLATE_DECODE && (A = "/Predictor " + I + " "), A += "/Colors " + l + " /BitsPerComponent " + c + " /Columns " + u.width, (this.__addimage__.isArrayBuffer(e) || this.__addimage__.isArrayBufferView(e)) && (e = this.__addimage__.arrayBufferToBinaryString(e)), (d && this.__addimage__.isArrayBuffer(d) || this.__addimage__.isArrayBufferView(d)) && (d = this.__addimage__.arrayBufferToBinaryString(d)), {
                alias: a,
                data: e,
                index: i,
                filter: L,
                decodeParameters: A,
                transparency: h,
                palette: f,
                sMask: d,
                predictor: I,
                width: u.width,
                height: u.height,
                bitsPerComponent: c,
                colorSpace: s
            };
        }
    };
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), function(t) {
    t.processGIF89A = function(e, r, n, i) {
        var a = new $020d60e69294d716$var$Zt(e), o = a.width, s = a.height, c = [];
        a.decodeAndBlitFrameRGBA(0, c);
        var u = {
            data: c,
            width: o,
            height: s
        }, h = new $020d60e69294d716$var$Qt(100).encode(u, 100);
        return t.processJPEG.call(this, h, r, n, i);
    }, t.processGIF87A = t.processGIF89A;
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), $020d60e69294d716$var$te.prototype.parseHeader = function() {
    if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
        var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
        this.palette = new Array(t);
        for(var e = 0; e < t; e++){
            var r = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0);
            this.palette[e] = {
                red: i,
                green: n,
                blue: r,
                quad: a
            };
        }
    }
    this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, $020d60e69294d716$var$te.prototype.parseBGR = function() {
    this.pos = this.offset;
    try {
        var t = "bit" + this.bitPP, e = this.width * this.height * 4;
        this.data = new Uint8Array(e), this[t]();
    } catch (t) {
        $020d60e69294d716$var$a.log("bit decode error:" + t);
    }
}, $020d60e69294d716$var$te.prototype.bit1 = function() {
    var t, e = Math.ceil(this.width / 8), r = e % 4;
    for(t = this.height - 1; t >= 0; t--){
        for(var n = this.bottom_up ? t : this.height - 1 - t, i = 0; i < e; i++)for(var a = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++){
            var c = this.palette[a >> 7 - s & 1];
            this.data[o + 4 * s] = c.blue, this.data[o + 4 * s + 1] = c.green, this.data[o + 4 * s + 2] = c.red, this.data[o + 4 * s + 3] = 255;
        }
        0 !== r && (this.pos += 4 - r);
    }
}, $020d60e69294d716$var$te.prototype.bit4 = function() {
    for(var t = Math.ceil(this.width / 2), e = t % 4, r = this.height - 1; r >= 0; r--){
        for(var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < t; i++){
            var a = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 2 * i * 4, s = a >> 4, c = 15 & a, u = this.palette[s];
            if (this.data[o] = u.blue, this.data[o + 1] = u.green, this.data[o + 2] = u.red, this.data[o + 3] = 255, 2 * i + 1 >= this.width) break;
            u = this.palette[c], this.data[o + 4] = u.blue, this.data[o + 4 + 1] = u.green, this.data[o + 4 + 2] = u.red, this.data[o + 4 + 3] = 255;
        }
        0 !== e && (this.pos += 4 - e);
    }
}, $020d60e69294d716$var$te.prototype.bit8 = function() {
    for(var t = this.width % 4, e = this.height - 1; e >= 0; e--){
        for(var r = this.bottom_up ? e : this.height - 1 - e, n = 0; n < this.width; n++){
            var i = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 4 * n;
            if (i < this.palette.length) {
                var o = this.palette[i];
                this.data[a] = o.red, this.data[a + 1] = o.green, this.data[a + 2] = o.blue, this.data[a + 3] = 255;
            } else this.data[a] = 255, this.data[a + 1] = 255, this.data[a + 2] = 255, this.data[a + 3] = 255;
        }
        0 !== t && (this.pos += 4 - t);
    }
}, $020d60e69294d716$var$te.prototype.bit15 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), r = this.height - 1; r >= 0; r--){
        for(var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < this.width; i++){
            var a = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var o = (a & e) / e * 255 | 0, s = (a >> 5 & e) / e * 255 | 0, c = (a >> 10 & e) / e * 255 | 0, u = a >> 15 ? 255 : 0, h = n * this.width * 4 + 4 * i;
            this.data[h] = c, this.data[h + 1] = s, this.data[h + 2] = o, this.data[h + 3] = u;
        }
        this.pos += t;
    }
}, $020d60e69294d716$var$te.prototype.bit16 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), r = parseInt("111111", 2), n = this.height - 1; n >= 0; n--){
        for(var i = this.bottom_up ? n : this.height - 1 - n, a = 0; a < this.width; a++){
            var o = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var s = (o & e) / e * 255 | 0, c = (o >> 5 & r) / r * 255 | 0, u = (o >> 11) / e * 255 | 0, h = i * this.width * 4 + 4 * a;
            this.data[h] = u, this.data[h + 1] = c, this.data[h + 2] = s, this.data[h + 3] = 255;
        }
        this.pos += t;
    }
}, $020d60e69294d716$var$te.prototype.bit24 = function() {
    for(var t = this.height - 1; t >= 0; t--){
        for(var e = this.bottom_up ? t : this.height - 1 - t, r = 0; r < this.width; r++){
            var n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = e * this.width * 4 + 4 * r;
            this.data[o] = a, this.data[o + 1] = i, this.data[o + 2] = n, this.data[o + 3] = 255;
        }
        this.pos += this.width % 4;
    }
}, $020d60e69294d716$var$te.prototype.bit32 = function() {
    for(var t = this.height - 1; t >= 0; t--)for(var e = this.bottom_up ? t : this.height - 1 - t, r = 0; r < this.width; r++){
        var n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * r;
        this.data[s] = a, this.data[s + 1] = i, this.data[s + 2] = n, this.data[s + 3] = o;
    }
}, $020d60e69294d716$var$te.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processBMP = function(e, r, n, i) {
        var a = new $020d60e69294d716$var$te(e, !1), o = a.width, s = a.height, c = {
            data: a.getData(),
            width: o,
            height: s
        }, u = new $020d60e69294d716$var$Qt(100).encode(c, 100);
        return t.processJPEG.call(this, u, r, n, i);
    };
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), $020d60e69294d716$var$ee.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processWEBP = function(e, r, n, i) {
        var a = new $020d60e69294d716$var$ee(e, !1), o = a.width, s = a.height, c = {
            data: a.getData(),
            width: o,
            height: s
        }, u = new $020d60e69294d716$var$Qt(100).encode(c, 100);
        return t.processJPEG.call(this, u, r, n, i);
    };
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), $020d60e69294d716$export$ba1e2ffc633a60f5.API.processRGBA = function(t, e, r) {
    for(var n = t.data, i = n.length, a = new Uint8Array(i / 4 * 3), o = new Uint8Array(i / 4), s = 0, c = 0, u = 0; u < i; u += 4){
        var h = n[u], l = n[u + 1], f = n[u + 2], d = n[u + 3];
        a[s++] = h, a[s++] = l, a[s++] = f, o[c++] = d;
    }
    var p = this.__addimage__.arrayBufferToBinaryString(a);
    return {
        alpha: this.__addimage__.arrayBufferToBinaryString(o),
        data: p,
        index: e,
        alias: r,
        colorSpace: "DeviceRGB",
        bitsPerComponent: 8,
        width: t.width,
        height: t.height
    };
}, $020d60e69294d716$export$ba1e2ffc633a60f5.API.setLanguage = function(t) {
    return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
        af: "Afrikaans",
        sq: "Albanian",
        ar: "Arabic (Standard)",
        "ar-DZ": "Arabic (Algeria)",
        "ar-BH": "Arabic (Bahrain)",
        "ar-EG": "Arabic (Egypt)",
        "ar-IQ": "Arabic (Iraq)",
        "ar-JO": "Arabic (Jordan)",
        "ar-KW": "Arabic (Kuwait)",
        "ar-LB": "Arabic (Lebanon)",
        "ar-LY": "Arabic (Libya)",
        "ar-MA": "Arabic (Morocco)",
        "ar-OM": "Arabic (Oman)",
        "ar-QA": "Arabic (Qatar)",
        "ar-SA": "Arabic (Saudi Arabia)",
        "ar-SY": "Arabic (Syria)",
        "ar-TN": "Arabic (Tunisia)",
        "ar-AE": "Arabic (U.A.E.)",
        "ar-YE": "Arabic (Yemen)",
        an: "Aragonese",
        hy: "Armenian",
        as: "Assamese",
        ast: "Asturian",
        az: "Azerbaijani",
        eu: "Basque",
        be: "Belarusian",
        bn: "Bengali",
        bs: "Bosnian",
        br: "Breton",
        bg: "Bulgarian",
        my: "Burmese",
        ca: "Catalan",
        ch: "Chamorro",
        ce: "Chechen",
        zh: "Chinese",
        "zh-HK": "Chinese (Hong Kong)",
        "zh-CN": "Chinese (PRC)",
        "zh-SG": "Chinese (Singapore)",
        "zh-TW": "Chinese (Taiwan)",
        cv: "Chuvash",
        co: "Corsican",
        cr: "Cree",
        hr: "Croatian",
        cs: "Czech",
        da: "Danish",
        nl: "Dutch (Standard)",
        "nl-BE": "Dutch (Belgian)",
        en: "English",
        "en-AU": "English (Australia)",
        "en-BZ": "English (Belize)",
        "en-CA": "English (Canada)",
        "en-IE": "English (Ireland)",
        "en-JM": "English (Jamaica)",
        "en-NZ": "English (New Zealand)",
        "en-PH": "English (Philippines)",
        "en-ZA": "English (South Africa)",
        "en-TT": "English (Trinidad & Tobago)",
        "en-GB": "English (United Kingdom)",
        "en-US": "English (United States)",
        "en-ZW": "English (Zimbabwe)",
        eo: "Esperanto",
        et: "Estonian",
        fo: "Faeroese",
        fj: "Fijian",
        fi: "Finnish",
        fr: "French (Standard)",
        "fr-BE": "French (Belgium)",
        "fr-CA": "French (Canada)",
        "fr-FR": "French (France)",
        "fr-LU": "French (Luxembourg)",
        "fr-MC": "French (Monaco)",
        "fr-CH": "French (Switzerland)",
        fy: "Frisian",
        fur: "Friulian",
        gd: "Gaelic (Scots)",
        "gd-IE": "Gaelic (Irish)",
        gl: "Galacian",
        ka: "Georgian",
        de: "German (Standard)",
        "de-AT": "German (Austria)",
        "de-DE": "German (Germany)",
        "de-LI": "German (Liechtenstein)",
        "de-LU": "German (Luxembourg)",
        "de-CH": "German (Switzerland)",
        el: "Greek",
        gu: "Gujurati",
        ht: "Haitian",
        he: "Hebrew",
        hi: "Hindi",
        hu: "Hungarian",
        is: "Icelandic",
        id: "Indonesian",
        iu: "Inuktitut",
        ga: "Irish",
        it: "Italian (Standard)",
        "it-CH": "Italian (Switzerland)",
        ja: "Japanese",
        kn: "Kannada",
        ks: "Kashmiri",
        kk: "Kazakh",
        km: "Khmer",
        ky: "Kirghiz",
        tlh: "Klingon",
        ko: "Korean",
        "ko-KP": "Korean (North Korea)",
        "ko-KR": "Korean (South Korea)",
        la: "Latin",
        lv: "Latvian",
        lt: "Lithuanian",
        lb: "Luxembourgish",
        mk: "North Macedonia",
        ms: "Malay",
        ml: "Malayalam",
        mt: "Maltese",
        mi: "Maori",
        mr: "Marathi",
        mo: "Moldavian",
        nv: "Navajo",
        ng: "Ndonga",
        ne: "Nepali",
        no: "Norwegian",
        nb: "Norwegian (Bokmal)",
        nn: "Norwegian (Nynorsk)",
        oc: "Occitan",
        or: "Oriya",
        om: "Oromo",
        fa: "Persian",
        "fa-IR": "Persian/Iran",
        pl: "Polish",
        pt: "Portuguese",
        "pt-BR": "Portuguese (Brazil)",
        pa: "Punjabi",
        "pa-IN": "Punjabi (India)",
        "pa-PK": "Punjabi (Pakistan)",
        qu: "Quechua",
        rm: "Rhaeto-Romanic",
        ro: "Romanian",
        "ro-MO": "Romanian (Moldavia)",
        ru: "Russian",
        "ru-MO": "Russian (Moldavia)",
        sz: "Sami (Lappish)",
        sg: "Sango",
        sa: "Sanskrit",
        sc: "Sardinian",
        sd: "Sindhi",
        si: "Singhalese",
        sr: "Serbian",
        sk: "Slovak",
        sl: "Slovenian",
        so: "Somani",
        sb: "Sorbian",
        es: "Spanish",
        "es-AR": "Spanish (Argentina)",
        "es-BO": "Spanish (Bolivia)",
        "es-CL": "Spanish (Chile)",
        "es-CO": "Spanish (Colombia)",
        "es-CR": "Spanish (Costa Rica)",
        "es-DO": "Spanish (Dominican Republic)",
        "es-EC": "Spanish (Ecuador)",
        "es-SV": "Spanish (El Salvador)",
        "es-GT": "Spanish (Guatemala)",
        "es-HN": "Spanish (Honduras)",
        "es-MX": "Spanish (Mexico)",
        "es-NI": "Spanish (Nicaragua)",
        "es-PA": "Spanish (Panama)",
        "es-PY": "Spanish (Paraguay)",
        "es-PE": "Spanish (Peru)",
        "es-PR": "Spanish (Puerto Rico)",
        "es-ES": "Spanish (Spain)",
        "es-UY": "Spanish (Uruguay)",
        "es-VE": "Spanish (Venezuela)",
        sx: "Sutu",
        sw: "Swahili",
        sv: "Swedish",
        "sv-FI": "Swedish (Finland)",
        "sv-SV": "Swedish (Sweden)",
        ta: "Tamil",
        tt: "Tatar",
        te: "Teluga",
        th: "Thai",
        tig: "Tigre",
        ts: "Tsonga",
        tn: "Tswana",
        tr: "Turkish",
        tk: "Turkmen",
        uk: "Ukrainian",
        hsb: "Upper Sorbian",
        ur: "Urdu",
        ve: "Venda",
        vi: "Vietnamese",
        vo: "Volapuk",
        wa: "Walloon",
        cy: "Welsh",
        xh: "Xhosa",
        ji: "Yiddish",
        zu: "Zulu"
    })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
    }), this.internal.languageSettings.isSubscribed = !0)), this;
}, $020d60e69294d716$var$Vt = $020d60e69294d716$export$ba1e2ffc633a60f5.API, $020d60e69294d716$var$Gt = $020d60e69294d716$var$Vt.getCharWidthsArray = function(e, r) {
    var n, i, a = (r = r || {}).font || this.internal.getFont(), o = r.fontSize || this.internal.getFontSize(), s = r.charSpace || this.internal.getCharSpace(), c = r.widths ? r.widths : a.metadata.Unicode.widths, u = c.fof ? c.fof : 1, h = r.kerning ? r.kerning : a.metadata.Unicode.kerning, l = h.fof ? h.fof : 1, f = !1 !== r.doKerning, d = 0, p = e.length, g = 0, m = c[0] || u, v = [];
    for(n = 0; n < p; n++)i = e.charCodeAt(n), "function" == typeof a.metadata.widthOfString ? v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(i)) + s * (1e3 / o) || 0) / 1e3) : (d = f && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(h[i]) && !isNaN(parseInt(h[i][g], 10)) ? h[i][g] / l : 0, v.push((c[i] || m) / u + d)), g = i;
    return v;
}, $020d60e69294d716$var$Yt = $020d60e69294d716$var$Vt.getStringUnitWidth = function(t, e) {
    var r = (e = e || {}).fontSize || this.internal.getFontSize(), n = e.font || this.internal.getFont(), i = e.charSpace || this.internal.getCharSpace();
    return $020d60e69294d716$var$Vt.processArabic && (t = $020d60e69294d716$var$Vt.processArabic(t)), "function" == typeof n.metadata.widthOfString ? n.metadata.widthOfString(t, r, i) / r : $020d60e69294d716$var$Gt.apply(this, arguments).reduce(function(t, e) {
        return t + e;
    }, 0);
}, $020d60e69294d716$var$Jt = function(t, e, r, n) {
    for(var i = [], a = 0, o = t.length, s = 0; a !== o && s + e[a] < r;)s += e[a], a++;
    i.push(t.slice(0, a));
    var c = a;
    for(s = 0; a !== o;)s + e[a] > n && (i.push(t.slice(c, a)), s = 0, c = a), s += e[a], a++;
    return c !== a && i.push(t.slice(c, a)), i;
}, $020d60e69294d716$var$Xt = function(t, e, r) {
    r || (r = {});
    var n, i, a, o, s, c, u, h = [], l = [
        h
    ], f = r.textIndent || 0, d = 0, p = 0, g = t.split(" "), m = $020d60e69294d716$var$Gt.apply(this, [
        " ",
        r
    ])[0];
    if (c = -1 === r.lineIndent ? g[0].length + 2 : r.lineIndent || 0) {
        var v = Array(c).join(" "), b = [];
        g.map(function(t) {
            (t = t.split(/\s*\n/)).length > 1 ? b = b.concat(t.map(function(t, e) {
                return (e && t.length ? "\n" : "") + t;
            })) : b.push(t[0]);
        }), g = b, c = $020d60e69294d716$var$Yt.apply(this, [
            v,
            r
        ]);
    }
    for(a = 0, o = g.length; a < o; a++){
        var y = 0;
        if (n = g[a], c && "\n" == n[0] && (n = n.substr(1), y = 1), f + d + (p = (i = $020d60e69294d716$var$Gt.apply(this, [
            n,
            r
        ])).reduce(function(t, e) {
            return t + e;
        }, 0)) > e || y) {
            if (p > e) {
                for(s = $020d60e69294d716$var$Jt.apply(this, [
                    n,
                    i,
                    e - (f + d),
                    e
                ]), h.push(s.shift()), h = [
                    s.pop()
                ]; s.length;)l.push([
                    s.shift()
                ]);
                p = i.slice(n.length - (h[0] ? h[0].length : 0)).reduce(function(t, e) {
                    return t + e;
                }, 0);
            } else h = [
                n
            ];
            l.push(h), f = p + c, d = m;
        } else h.push(n), f += d + p, d = m;
    }
    return u = c ? function(t, e) {
        return (e ? v : "") + t.join(" ");
    } : function(t) {
        return t.join(" ");
    }, l.map(u);
}, $020d60e69294d716$var$Vt.splitTextToSize = function(t, e, r) {
    var n, i = (r = r || {}).fontSize || this.internal.getFontSize(), a = (function(t) {
        if (t.widths && t.kerning) return {
            widths: t.widths,
            kerning: t.kerning
        };
        var e = this.internal.getFont(t.fontName, t.fontStyle);
        return e.metadata.Unicode ? {
            widths: e.metadata.Unicode.widths || {
                0: 1
            },
            kerning: e.metadata.Unicode.kerning || {}
        } : {
            font: e.metadata,
            fontSize: this.internal.getFontSize(),
            charSpace: this.internal.getCharSpace()
        };
    }).call(this, r);
    n = Array.isArray(t) ? t : String(t).split(/\r?\n/);
    var o = 1 * this.internal.scaleFactor * e / i;
    a.textIndent = r.textIndent ? 1 * r.textIndent * this.internal.scaleFactor / i : 0, a.lineIndent = r.lineIndent;
    var s, c, u = [];
    for(s = 0, c = n.length; s < c; s++)u = u.concat($020d60e69294d716$var$Xt.apply(this, [
        n[s],
        o,
        a
    ]));
    return u;
}, function(e) {
    e.__fontmetrics__ = e.__fontmetrics__ || {};
    for(var r = "klmnopqrstuvwxyz", n = {}, i = {}, a = 0; a < r.length; a++)n[r[a]] = "0123456789abcdef"[a], i["0123456789abcdef"[a]] = r[a];
    var o = function(t) {
        return "0x" + parseInt(t, 10).toString(16);
    }, s = e.__fontmetrics__.compress = function(e) {
        var r, n, a, c, u = [
            "{"
        ];
        for(var h in e){
            if (r = e[h], isNaN(parseInt(h, 10)) ? n = "'" + h + "'" : (h = parseInt(h, 10), n = (n = o(h).slice(2)).slice(0, -1) + i[n.slice(-1)]), "number" == typeof r) r < 0 ? (a = o(r).slice(3), c = "-") : (a = o(r).slice(2), c = ""), a = c + a.slice(0, -1) + i[a.slice(-1)];
            else {
                if ("object" !== (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(r)) throw new Error("Don't know what to do with value type " + (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(r) + ".");
                a = s(r);
            }
            u.push(n + a);
        }
        return u.push("}"), u.join("");
    }, c = e.__fontmetrics__.uncompress = function(t) {
        if ("string" != typeof t) throw new Error("Invalid argument passed to uncompress.");
        for(var e, r, i, a, o = {}, s = 1, c = o, u = [], h = "", l = "", f = t.length - 1, d = 1; d < f; d += 1)"'" == (a = t[d]) ? e ? (i = e.join(""), e = void 0) : e = [] : e ? e.push(a) : "{" == a ? (u.push([
            c,
            i
        ]), c = {}, i = void 0) : "}" == a ? ((r = u.pop())[0][r[1]] = c, i = void 0, c = r[0]) : "-" == a ? s = -1 : void 0 === i ? n.hasOwnProperty(a) ? (h += n[a], i = parseInt(h, 16) * s, s = 1, h = "") : h += a : n.hasOwnProperty(a) ? (l += n[a], c[i] = parseInt(l, 16) * s, s = 1, i = void 0, l = "") : l += a;
        return o;
    }, u = {
        codePages: [
            "WinAnsiEncoding"
        ],
        WinAnsiEncoding: c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
    }, h = {
        Unicode: {
            Courier: u,
            "Courier-Bold": u,
            "Courier-BoldOblique": u,
            "Courier-Oblique": u,
            Helvetica: u,
            "Helvetica-Bold": u,
            "Helvetica-BoldOblique": u,
            "Helvetica-Oblique": u,
            "Times-Roman": u,
            "Times-Bold": u,
            "Times-BoldItalic": u,
            "Times-Italic": u
        }
    }, l = {
        Unicode: {
            "Courier-Oblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-BoldItalic": c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
            "Helvetica-Bold": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            Courier: c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-BoldOblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Bold": c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
            Symbol: c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
            Helvetica: c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
            "Helvetica-BoldOblique": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            ZapfDingbats: c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-Bold": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Italic": c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
            "Times-Roman": c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
            "Helvetica-Oblique": c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
    };
    e.events.push([
        "addFont",
        function(t) {
            var e = t.font, r = l.Unicode[e.postScriptName];
            r && (e.metadata.Unicode = {}, e.metadata.Unicode.widths = r.widths, e.metadata.Unicode.kerning = r.kerning);
            var n = h.Unicode[e.postScriptName];
            n && (e.metadata.Unicode.encoding = n, e.encoding = n.codePages[0]);
        }
    ]);
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        for(var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++)r[n] = t.charCodeAt(n);
        return r;
    };
    t.API.events.push([
        "addFont",
        function(r) {
            var n = void 0, i = r.font, a = r.instance;
            if (!i.isStandardFont) {
                if (void 0 === a) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                if ("string" != typeof (n = !1 === a.existsFileInVFS(i.postScriptName) ? a.loadFile(i.postScriptName) : a.getFileFromVFS(i.postScriptName))) throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                !function(r, n) {
                    n = /^\x00\x01\x00\x00/.test(n) ? e(n) : e($020d60e69294d716$var$u(n)), r.metadata = t.API.TTFFont.open(n), r.metadata.Unicode = r.metadata.Unicode || {
                        encoding: {},
                        kerning: {},
                        widths: []
                    }, r.metadata.glyIdsUsed = [
                        0
                    ];
                }(i, n);
            }
        }
    ]);
}($020d60e69294d716$export$ba1e2ffc633a60f5), /** @license
 * Copyright (c) 2012 Willow Systems Corporation, https://github.com/willowsystems
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    function e() {
        return ($020d60e69294d716$var$n.canvg ? Promise.resolve($020d60e69294d716$var$n.canvg) : (parcelRequire("izS64"))).catch(function(t) {
            return Promise.reject(new Error("Could not load canvg: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    $020d60e69294d716$export$ba1e2ffc633a60f5.API.addSvgAsImage = function(t, r, n, i, o, s, c, u) {
        if (isNaN(r) || isNaN(n)) throw $020d60e69294d716$var$a.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
        if (isNaN(i) || isNaN(o)) throw $020d60e69294d716$var$a.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
        var h = document.createElement("canvas");
        h.width = i, h.height = o;
        var l = h.getContext("2d");
        l.fillStyle = "#fff", l.fillRect(0, 0, h.width, h.height);
        var f = {
            ignoreMouse: !0,
            ignoreAnimation: !0,
            ignoreDimensions: !0
        }, d = this;
        return e().then(function(e) {
            return e.fromString(l, t, f);
        }, function() {
            return Promise.reject(new Error("Could not load canvg."));
        }).then(function(t) {
            return t.render(f);
        }).then(function() {
            d.addImage(h.toDataURL("image/jpeg", 1), r, n, i, o, c, u);
        });
    };
}(), $020d60e69294d716$export$ba1e2ffc633a60f5.API.putTotalPages = function(t) {
    var e, r = 0;
    parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(t, "g"), r = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), r = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
    for(var n = 1; n <= this.internal.getNumberOfPages(); n++)for(var i = 0; i < this.internal.pages[n].length; i++)this.internal.pages[n][i] = this.internal.pages[n][i].replace(e, r);
    return this;
}, $020d60e69294d716$export$ba1e2ffc633a60f5.API.viewerPreferences = function(e, r) {
    var n;
    e = e || {}, r = r || !1;
    var i, a, o, s = {
        HideToolbar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideMenubar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideWindowUI: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        FitWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        CenterWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        DisplayDocTitle: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.4
        },
        NonFullScreenPageMode: {
            defaultValue: "UseNone",
            value: "UseNone",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "UseNone",
                "UseOutlines",
                "UseThumbs",
                "UseOC"
            ],
            pdfVersion: 1.3
        },
        Direction: {
            defaultValue: "L2R",
            value: "L2R",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "L2R",
                "R2L"
            ],
            pdfVersion: 1.3
        },
        ViewArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        ViewClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintScaling: {
            defaultValue: "AppDefault",
            value: "AppDefault",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "AppDefault",
                "None"
            ],
            pdfVersion: 1.6
        },
        Duplex: {
            defaultValue: "",
            value: "none",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "Simplex",
                "DuplexFlipShortEdge",
                "DuplexFlipLongEdge",
                "none"
            ],
            pdfVersion: 1.7
        },
        PickTrayByPDFSize: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.7
        },
        PrintPageRange: {
            defaultValue: "",
            value: "",
            type: "array",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        },
        NumCopies: {
            defaultValue: 1,
            value: 1,
            type: "integer",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        }
    }, c = Object.keys(s), u = [], h = 0, l = 0, f = 0;
    function d(t, e) {
        var r, n = !1;
        for(r = 0; r < t.length; r += 1)t[r] === e && (n = !0);
        return n;
    }
    if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, "reset" === e || !0 === r) {
        var p = c.length;
        for(f = 0; f < p; f += 1)n[c[f]].value = n[c[f]].defaultValue, n[c[f]].explicitSet = !1;
    }
    if ("object" === (0, (/*@__PURE__*/$parcel$interopDefault($tywpZ)))(e)) {
        for(a in e)if (o = e[a], d(c, a) && void 0 !== o) {
            if ("boolean" === n[a].type && "boolean" == typeof o) n[a].value = o;
            else if ("name" === n[a].type && d(n[a].valueSet, o)) n[a].value = o;
            else if ("integer" === n[a].type && Number.isInteger(o)) n[a].value = o;
            else if ("array" === n[a].type) {
                for(h = 0; h < o.length; h += 1)if (i = !0, 1 === o[h].length && "number" == typeof o[h][0]) u.push(String(o[h] - 1));
                else if (o[h].length > 1) {
                    for(l = 0; l < o[h].length; l += 1)"number" != typeof o[h][l] && (i = !1);
                    !0 === i && u.push([
                        o[h][0] - 1,
                        o[h][1] - 1
                    ].join(" "));
                }
                n[a].value = "[" + u.join(" ") + "]";
            } else n[a].value = n[a].defaultValue;
            n[a].explicitSet = !0;
        }
    }
    return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        var t, e = [];
        for(t in n)!0 === n[t].explicitSet && ("name" === n[t].type ? e.push("/" + t + " /" + n[t].value) : e.push("/" + t + " " + n[t].value));
        0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
    }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    var e = function() {
        var t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), r = unescape(encodeURIComponent(t)), n = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), a = unescape(encodeURIComponent("</x:xmpmeta>")), o = r.length + n.length + i.length + e.length + a.length;
        this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + o + " >>"), this.internal.write("stream"), this.internal.write(e + r + n + i + a), this.internal.write("endstream"), this.internal.write("endobj");
    }, r = function() {
        this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
    };
    t.addMetadata = function(t, n) {
        return void 0 === this.internal.__metadata__ && (this.internal.__metadata__ = {
            metadata: t,
            namespaceuri: n || "http://jspdf.default.namespaceuri/"
        }, this.internal.events.subscribe("putCatalog", r), this.internal.events.subscribe("postPutResources", e)), this;
    };
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), function(t) {
    var e = t.API, r = e.pdfEscape16 = function(t, e) {
        for(var r, n = e.metadata.Unicode.widths, i = [
            "",
            "0",
            "00",
            "000",
            "0000"
        ], a = [
            ""
        ], o = 0, s = t.length; o < s; ++o){
            if (r = e.metadata.characterToGlyph(t.charCodeAt(o)), e.metadata.glyIdsUsed.push(r), e.metadata.toUnicode[r] = t.charCodeAt(o), -1 == n.indexOf(r) && (n.push(r), n.push([
                parseInt(e.metadata.widthOfGlyph(r), 10)
            ])), "0" == r) return a.join("");
            r = r.toString(16), a.push(i[4 - r.length], r);
        }
        return a.join("");
    }, n = function(t) {
        var e, r, n, i, a, o, s;
        for(a = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", n = [], o = 0, s = (r = Object.keys(t).sort(function(t, e) {
            return t - e;
        })).length; o < s; o++)e = r[o], n.length >= 100 && (a += "\n" + n.length + " beginbfchar\n" + n.join("\n") + "\nendbfchar", n = []), void 0 !== t[e] && null !== t[e] && "function" == typeof t[e].toString && (i = ("0000" + t[e].toString(16)).slice(-4), e = ("0000" + (+e).toString(16)).slice(-4), n.push("<" + e + "><" + i + ">"));
        return n.length && (a += "\n" + n.length + " beginbfchar\n" + n.join("\n") + "\nendbfchar\n"), a += "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
    };
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var r = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (r.metadata instanceof t.API.TTFFont && "Identity-H" === r.encoding) {
                    for(var s = r.metadata.Unicode.widths, c = r.metadata.subset.encode(r.metadata.glyIdsUsed, 1), u = "", h = 0; h < c.length; h++)u += String.fromCharCode(c[h]);
                    var l = a();
                    o({
                        data: u,
                        addLength1: !0,
                        objectId: l
                    }), i("endobj");
                    var f = a();
                    o({
                        data: n(r.metadata.toUnicode),
                        addLength1: !0,
                        objectId: f
                    }), i("endobj");
                    var d = a();
                    i("<<"), i("/Type /FontDescriptor"), i("/FontName /" + $020d60e69294d716$var$F(r.fontName)), i("/FontFile2 " + l + " 0 R"), i("/FontBBox " + t.API.PDFObject.convert(r.metadata.bbox)), i("/Flags " + r.metadata.flags), i("/StemV " + r.metadata.stemV), i("/ItalicAngle " + r.metadata.italicAngle), i("/Ascent " + r.metadata.ascender), i("/Descent " + r.metadata.decender), i("/CapHeight " + r.metadata.capHeight), i(">>"), i("endobj");
                    var p = a();
                    i("<<"), i("/Type /Font"), i("/BaseFont /" + $020d60e69294d716$var$F(r.fontName)), i("/FontDescriptor " + d + " 0 R"), i("/W " + t.API.PDFObject.convert(s)), i("/CIDToGIDMap /Identity"), i("/DW 1000"), i("/Subtype /CIDFontType2"), i("/CIDSystemInfo"), i("<<"), i("/Supplement 0"), i("/Registry (Adobe)"), i("/Ordering (" + r.encoding + ")"), i(">>"), i(">>"), i("endobj"), r.objectNumber = a(), i("<<"), i("/Type /Font"), i("/Subtype /Type0"), i("/ToUnicode " + f + " 0 R"), i("/BaseFont /" + $020d60e69294d716$var$F(r.fontName)), i("/Encoding /" + r.encoding), i("/DescendantFonts [" + p + " 0 R]"), i(">>"), i("endobj"), r.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var r = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (r.metadata instanceof t.API.TTFFont && "WinAnsiEncoding" === r.encoding) {
                    for(var s = r.metadata.rawData, c = "", u = 0; u < s.length; u++)c += String.fromCharCode(s[u]);
                    var h = a();
                    o({
                        data: c,
                        addLength1: !0,
                        objectId: h
                    }), i("endobj");
                    var l = a();
                    o({
                        data: n(r.metadata.toUnicode),
                        addLength1: !0,
                        objectId: l
                    }), i("endobj");
                    var f = a();
                    i("<<"), i("/Descent " + r.metadata.decender), i("/CapHeight " + r.metadata.capHeight), i("/StemV " + r.metadata.stemV), i("/Type /FontDescriptor"), i("/FontFile2 " + h + " 0 R"), i("/Flags 96"), i("/FontBBox " + t.API.PDFObject.convert(r.metadata.bbox)), i("/FontName /" + $020d60e69294d716$var$F(r.fontName)), i("/ItalicAngle " + r.metadata.italicAngle), i("/Ascent " + r.metadata.ascender), i(">>"), i("endobj"), r.objectNumber = a();
                    for(var d = 0; d < r.metadata.hmtx.widths.length; d++)r.metadata.hmtx.widths[d] = parseInt(r.metadata.hmtx.widths[d] * (1e3 / r.metadata.head.unitsPerEm));
                    i("<</Subtype/TrueType/Type/Font/ToUnicode " + l + " 0 R/BaseFont/" + $020d60e69294d716$var$F(r.fontName) + "/FontDescriptor " + f + " 0 R/Encoding/" + r.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(r.metadata.hmtx.widths) + ">>"), i("endobj"), r.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    var i = function(t) {
        var e, n = t.text || "", i = t.x, a = t.y, o = t.options || {}, s = t.mutex || {}, c = s.pdfEscape, u = s.activeFontKey, h = s.fonts, l = u, f = "", d = 0, p = "", g = h[l].encoding;
        if ("Identity-H" !== h[l].encoding) return {
            text: n,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
        for(p = n, l = u, Array.isArray(n) && (p = n[0]), d = 0; d < p.length; d += 1)h[l].metadata.hasOwnProperty("cmap") && (e = h[l].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]), e || p[d].charCodeAt(0) < 256 && h[l].metadata.hasOwnProperty("Unicode") ? f += p[d] : f += "";
        var m = "";
        return parseInt(l.slice(1)) < 14 || "WinAnsiEncoding" === g ? m = c(f, l).split("").map(function(t) {
            return t.charCodeAt(0).toString(16);
        }).join("") : "Identity-H" === g && (m = r(f, h[l])), s.isHex = !0, {
            text: m,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
    };
    e.events.push([
        "postProcessText",
        function(t) {
            var e = t.text || "", r = [], n = {
                text: e,
                x: t.x,
                y: t.y,
                options: t.options,
                mutex: t.mutex
            };
            if (Array.isArray(e)) {
                var a = 0;
                for(a = 0; a < e.length; a += 1)Array.isArray(e[a]) && 3 === e[a].length ? r.push([
                    i(Object.assign({}, n, {
                        text: e[a][0]
                    })).text,
                    e[a][1],
                    e[a][2]
                ]) : r.push(i(Object.assign({}, n, {
                    text: e[a]
                })).text);
                t.text = r;
            } else t.text = i(Object.assign({}, n, {
                text: e
            })).text;
        }
    ]);
}($020d60e69294d716$export$ba1e2ffc633a60f5), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        return void 0 === this.internal.vFS && (this.internal.vFS = {}), !0;
    };
    t.existsFileInVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t];
    }, t.addFileToVFS = function(t, r) {
        return e.call(this), this.internal.vFS[t] = r, this;
    }, t.getFileFromVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t] ? this.internal.vFS[t] : null;
    };
}($020d60e69294d716$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */ function(t) {
    t.__bidiEngine__ = t.prototype.__bidiEngine__ = function(t) {
        var r, n, i, a, o, s, c, u = e, h = [
            [
                0,
                3,
                0,
                1,
                0,
                0,
                0
            ],
            [
                0,
                3,
                0,
                1,
                2,
                2,
                0
            ],
            [
                0,
                3,
                0,
                17,
                2,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                1,
                0
            ],
            [
                0,
                3,
                21,
                21,
                4,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                2,
                0
            ]
        ], l = [
            [
                2,
                0,
                1,
                1,
                0,
                1,
                0
            ],
            [
                2,
                0,
                1,
                1,
                0,
                2,
                0
            ],
            [
                2,
                0,
                2,
                1,
                3,
                2,
                0
            ],
            [
                2,
                0,
                2,
                33,
                3,
                1,
                1
            ]
        ], f = {
            L: 0,
            R: 1,
            EN: 2,
            AN: 3,
            N: 4,
            B: 5,
            S: 6
        }, d = {
            0: 0,
            5: 1,
            6: 2,
            7: 3,
            32: 4,
            251: 5,
            254: 6,
            255: 7
        }, p = [
            "(",
            ")",
            "(",
            "<",
            ">",
            "<",
            "[",
            "]",
            "[",
            "{",
            "}",
            "{",
            "\xab",
            "\xbb",
            "\xab",
            "\u2039",
            "\u203A",
            "\u2039",
            "\u2045",
            "\u2046",
            "\u2045",
            "\u207D",
            "\u207E",
            "\u207D",
            "\u208D",
            "\u208E",
            "\u208D",
            "\u2264",
            "\u2265",
            "\u2264",
            "\u2329",
            "\u232A",
            "\u2329",
            "\uFE59",
            "\uFE5A",
            "\uFE59",
            "\uFE5B",
            "\uFE5C",
            "\uFE5B",
            "\uFE5D",
            "\uFE5E",
            "\uFE5D",
            "\uFE64",
            "\uFE65",
            "\uFE64"
        ], g = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), m = !1, v = 0;
        this.__bidiEngine__ = {};
        var b = function(t) {
            var e = t.charCodeAt(), r = e >> 8, n = d[r];
            return void 0 !== n ? u[256 * n + (255 & e)] : 252 === r || 253 === r ? "AL" : g.test(r) ? "L" : 8 === r ? "R" : "N";
        }, y = function(t) {
            for(var e, r = 0; r < t.length; r++){
                if ("L" === (e = b(t.charAt(r)))) return !1;
                if ("R" === e) return !0;
            }
            return !1;
        }, w = function(t, e, o, s) {
            var c, u, h, l, f = e[s];
            switch(f){
                case "L":
                case "R":
                    m = !1;
                    break;
                case "N":
                case "AN":
                    break;
                case "EN":
                    m && (f = "AN");
                    break;
                case "AL":
                    m = !0, f = "R";
                    break;
                case "WS":
                    f = "N";
                    break;
                case "CS":
                    s < 1 || s + 1 >= e.length || "EN" !== (c = o[s - 1]) && "AN" !== c || "EN" !== (u = e[s + 1]) && "AN" !== u ? f = "N" : m && (u = "AN"), f = u === c ? u : "N";
                    break;
                case "ES":
                    f = "EN" === (c = s > 0 ? o[s - 1] : "B") && s + 1 < e.length && "EN" === e[s + 1] ? "EN" : "N";
                    break;
                case "ET":
                    if (s > 0 && "EN" === o[s - 1]) {
                        f = "EN";
                        break;
                    }
                    if (m) {
                        f = "N";
                        break;
                    }
                    for(h = s + 1, l = e.length; h < l && "ET" === e[h];)h++;
                    f = h < l && "EN" === e[h] ? "EN" : "N";
                    break;
                case "NSM":
                    if (i && !a) {
                        for(l = e.length, h = s + 1; h < l && "NSM" === e[h];)h++;
                        if (h < l) {
                            var d = t[s], p = d >= 1425 && d <= 2303 || 64286 === d;
                            if (c = e[h], p && ("R" === c || "AL" === c)) {
                                f = "R";
                                break;
                            }
                        }
                    }
                    f = s < 1 || "B" === (c = e[s - 1]) ? "N" : o[s - 1];
                    break;
                case "B":
                    m = !1, r = !0, f = v;
                    break;
                case "S":
                    n = !0, f = "N";
                    break;
                case "LRE":
                case "RLE":
                case "LRO":
                case "RLO":
                case "PDF":
                    m = !1;
                    break;
                case "BN":
                    f = "N";
            }
            return f;
        }, N = function(t, e, r) {
            var n = t.split("");
            return r && L(n, r, {
                hiLevel: v
            }), n.reverse(), e && e.reverse(), n.join("");
        }, L = function(t, e, i) {
            var a, o, s, c, u, d = -1, p = t.length, g = 0, y = [], N = v ? l : h, L = [];
            for(m = !1, r = !1, n = !1, o = 0; o < p; o++)L[o] = b(t[o]);
            for(s = 0; s < p; s++){
                if (u = g, y[s] = w(t, L, y, s), a = 240 & (g = N[u][f[y[s]]]), g &= 15, e[s] = c = N[g][5], a > 0) {
                    if (16 === a) {
                        for(o = d; o < s; o++)e[o] = 1;
                        d = -1;
                    } else d = -1;
                }
                if (N[g][6]) -1 === d && (d = s);
                else if (d > -1) {
                    for(o = d; o < s; o++)e[o] = c;
                    d = -1;
                }
                "B" === L[s] && (e[s] = 0), i.hiLevel |= c;
            }
            n && function(t, e, r) {
                for(var n = 0; n < r; n++)if ("S" === t[n]) {
                    e[n] = v;
                    for(var i = n - 1; i >= 0 && "WS" === t[i]; i--)e[i] = v;
                }
            }(L, e, p);
        }, A = function(t, e, n, i, a) {
            if (!(a.hiLevel < t)) {
                if (1 === t && 1 === v && !r) return e.reverse(), void (n && n.reverse());
                for(var o, s, c, u, h = e.length, l = 0; l < h;){
                    if (i[l] >= t) {
                        for(c = l + 1; c < h && i[c] >= t;)c++;
                        for(u = l, s = c - 1; u < s; u++, s--)o = e[u], e[u] = e[s], e[s] = o, n && (o = n[u], n[u] = n[s], n[s] = o);
                        l = c;
                    }
                    l++;
                }
            }
        }, x = function(t, e, r) {
            var n = t.split(""), i = {
                hiLevel: v
            };
            return r || (r = []), L(n, r, i), function(t, e, r) {
                if (0 !== r.hiLevel && c) for(var n, i = 0; i < t.length; i++)1 === e[i] && (n = p.indexOf(t[i])) >= 0 && (t[i] = p[n + 1]);
            }(n, r, i), A(2, n, e, r, i), A(1, n, e, r, i), n.join("");
        };
        return this.__bidiEngine__.doBidiReorder = function(t, e, r) {
            if (function(t, e) {
                if (e) for(var r = 0; r < t.length; r++)e[r] = r;
                void 0 === a && (a = y(t)), void 0 === s && (s = y(t));
            }(t, e), i || !o || s) {
                if (i && o && a ^ s) v = a ? 1 : 0, t = N(t, e, r);
                else if (!i && o && s) v = a ? 1 : 0, t = x(t, e, r), t = N(t, e);
                else if (!i || a || o || s) {
                    if (i && !o && a ^ s) t = N(t, e), a ? (v = 0, t = x(t, e, r)) : (v = 1, t = x(t, e, r), t = N(t, e));
                    else if (i && a && !o && s) v = 1, t = x(t, e, r), t = N(t, e);
                    else if (!i && !o && a ^ s) {
                        var n = c;
                        a ? (v = 1, t = x(t, e, r), v = 0, c = !1, t = x(t, e, r), c = n) : (v = 0, t = x(t, e, r), t = N(t, e), v = 1, c = !1, t = x(t, e, r), c = n, t = N(t, e));
                    }
                } else v = 0, t = x(t, e, r);
            } else v = a ? 1 : 0, t = x(t, e, r);
            return t;
        }, this.__bidiEngine__.setOptions = function(t) {
            t && (i = t.isInputVisual, o = t.isOutputVisual, a = t.isInputRtl, s = t.isOutputRtl, c = t.isSymmetricSwapping);
        }, this.__bidiEngine__.setOptions(t), this.__bidiEngine__;
    };
    var e = [
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "S",
        "B",
        "S",
        "WS",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "B",
        "B",
        "S",
        "WS",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "CS",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "L",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "ET",
        "ET",
        "EN",
        "EN",
        "N",
        "L",
        "N",
        "N",
        "N",
        "EN",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "N",
        "N",
        "AL",
        "ET",
        "ET",
        "AL",
        "CS",
        "AL",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "ET",
        "AN",
        "AN",
        "AL",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "BN",
        "BN",
        "BN",
        "L",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "B",
        "LRE",
        "RLE",
        "PDF",
        "LRO",
        "RLO",
        "CS",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "N",
        "LRI",
        "RLI",
        "FSI",
        "PDI",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "EN",
        "L",
        "N",
        "N",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "L",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "NSM",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "ES",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "CS",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "N",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N"
    ], r = new t.__bidiEngine__({
        isInputVisual: !0
    });
    t.API.events.push([
        "postProcessText",
        function(t) {
            var e = t.text, n = (t.x, t.y, t.options || {}), i = (t.mutex, n.lang, []);
            if (n.isInputVisual = "boolean" != typeof n.isInputVisual || n.isInputVisual, r.setOptions(n), "[object Array]" === Object.prototype.toString.call(e)) {
                var a = 0;
                for(i = [], a = 0; a < e.length; a += 1)"[object Array]" === Object.prototype.toString.call(e[a]) ? i.push([
                    r.doBidiReorder(e[a][0]),
                    e[a][1],
                    e[a][2]
                ]) : i.push([
                    r.doBidiReorder(e[a])
                ]);
                t.text = i;
            } else t.text = r.doBidiReorder(e);
            r.setOptions({
                isInputVisual: !0
            });
        }
    ]);
}($020d60e69294d716$export$ba1e2ffc633a60f5), $020d60e69294d716$export$ba1e2ffc633a60f5.API.TTFFont = function() {
    function t(t) {
        var e;
        if (this.rawData = t, e = this.contents = new $020d60e69294d716$var$ne(t), this.contents.pos = 4, "ttcf" === e.readString(4)) throw new Error("TTCF not supported.");
        e.pos = 0, this.parse(), this.subset = new $020d60e69294d716$var$Le(this), this.registerTTF();
    }
    return t.open = function(e) {
        return new t(e);
    }, t.prototype.parse = function() {
        return this.directory = new $020d60e69294d716$var$ie(this.contents), this.head = new $020d60e69294d716$var$se(this), this.name = new $020d60e69294d716$var$pe(this), this.cmap = new $020d60e69294d716$var$ue(this), this.toUnicode = {}, this.hhea = new $020d60e69294d716$var$he(this), this.maxp = new $020d60e69294d716$var$ge(this), this.hmtx = new $020d60e69294d716$var$me(this), this.post = new $020d60e69294d716$var$fe(this), this.os2 = new $020d60e69294d716$var$le(this), this.loca = new $020d60e69294d716$var$Ne(this), this.glyf = new $020d60e69294d716$var$be(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
            this.head.xMin,
            this.head.yMin,
            this.head.xMax,
            this.head.yMax
        ];
    }, t.prototype.registerTTF = function() {
        var t, e, r, n, i;
        if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
            var e, r, n, i;
            for(i = [], e = 0, r = (n = this.bbox).length; e < r; e++)t = n[e], i.push(Math.round(t * this.scaleFactor));
            return i;
        }).call(this), this.stemV = 0, this.post.exists ? (r = 255 & (n = this.post.italic_angle), 0 != (32768 & (e = n >> 16)) && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + r)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (i = this.familyClass) || 2 === i || 3 === i || 4 === i || 5 === i || 7 === i, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
    }, t.prototype.characterToGlyph = function(t) {
        var e;
        return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
    }, t.prototype.widthOfGlyph = function(t) {
        var e;
        return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
    }, t.prototype.widthOfString = function(t, e, r) {
        var n, i, a, o;
        for(a = 0, i = 0, o = (t = "" + t).length; 0 <= o ? i < o : i > o; i = 0 <= o ? ++i : --i)n = t.charCodeAt(i), a += this.widthOfGlyph(this.characterToGlyph(n)) + r * (1e3 / e) || 0;
        return a * (e / 1e3);
    }, t.prototype.lineHeight = function(t, e) {
        var r;
        return null == e && (e = !1), r = e ? this.lineGap : 0, (this.ascender + r - this.decender) / 1e3 * t;
    }, t;
}();
var $020d60e69294d716$var$re, $020d60e69294d716$var$ne = function() {
    function t(t) {
        this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
    }
    return t.prototype.readByte = function() {
        return this.data[this.pos++];
    }, t.prototype.writeByte = function(t) {
        return this.data[this.pos++] = t;
    }, t.prototype.readUInt32 = function() {
        return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
    }, t.prototype.writeUInt32 = function(t) {
        return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt32 = function() {
        var t;
        return (t = this.readUInt32()) >= 2147483648 ? t - 4294967296 : t;
    }, t.prototype.writeInt32 = function(t) {
        return t < 0 && (t += 4294967296), this.writeUInt32(t);
    }, t.prototype.readUInt16 = function() {
        return this.readByte() << 8 | this.readByte();
    }, t.prototype.writeUInt16 = function(t) {
        return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt16 = function() {
        var t;
        return (t = this.readUInt16()) >= 32768 ? t - 65536 : t;
    }, t.prototype.writeInt16 = function(t) {
        return t < 0 && (t += 65536), this.writeUInt16(t);
    }, t.prototype.readString = function(t) {
        var e, r;
        for(r = [], e = 0; 0 <= t ? e < t : e > t; e = 0 <= t ? ++e : --e)r[e] = String.fromCharCode(this.readByte());
        return r.join("");
    }, t.prototype.writeString = function(t) {
        var e, r, n;
        for(n = [], e = 0, r = t.length; 0 <= r ? e < r : e > r; e = 0 <= r ? ++e : --e)n.push(this.writeByte(t.charCodeAt(e)));
        return n;
    }, t.prototype.readShort = function() {
        return this.readInt16();
    }, t.prototype.writeShort = function(t) {
        return this.writeInt16(t);
    }, t.prototype.readLongLong = function() {
        var t, e, r, n, i, a, o, s;
        return t = this.readByte(), e = this.readByte(), r = this.readByte(), n = this.readByte(), i = this.readByte(), a = this.readByte(), o = this.readByte(), s = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ r) + 4294967296 * (255 ^ n) + 16777216 * (255 ^ i) + 65536 * (255 ^ a) + 256 * (255 ^ o) + (255 ^ s) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * r + 4294967296 * n + 16777216 * i + 65536 * a + 256 * o + s;
    }, t.prototype.writeLongLong = function(t) {
        var e, r;
        return e = Math.floor(t / 4294967296), r = 4294967295 & t, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(r >> 24 & 255), this.writeByte(r >> 16 & 255), this.writeByte(r >> 8 & 255), this.writeByte(255 & r);
    }, t.prototype.readInt = function() {
        return this.readInt32();
    }, t.prototype.writeInt = function(t) {
        return this.writeInt32(t);
    }, t.prototype.read = function(t) {
        var e, r;
        for(e = [], r = 0; 0 <= t ? r < t : r > t; r = 0 <= t ? ++r : --r)e.push(this.readByte());
        return e;
    }, t.prototype.write = function(t) {
        var e, r, n, i;
        for(i = [], r = 0, n = t.length; r < n; r++)e = t[r], i.push(this.writeByte(e));
        return i;
    }, t;
}(), $020d60e69294d716$var$ie = function() {
    var t;
    function e(t) {
        var e, r, n;
        for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, r = 0, n = this.tableCount; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r)e = {
            tag: t.readString(4),
            checksum: t.readInt(),
            offset: t.readInt(),
            length: t.readInt()
        }, this.tables[e.tag] = e;
    }
    return e.prototype.encode = function(e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p;
        for(p in f = Object.keys(e).length, s = Math.log(2), h = 16 * Math.floor(Math.log(f) / s), a = Math.floor(h / s), u = 16 * f - h, (n = new $020d60e69294d716$var$ne).writeInt(this.scalarType), n.writeShort(f), n.writeShort(h), n.writeShort(a), n.writeShort(u), i = 16 * f, c = n.pos + i, o = null, d = [], e)for(l = e[p], n.writeString(p), n.writeInt(t(l)), n.writeInt(c), n.writeInt(l.length), d = d.concat(l), "head" === p && (o = c), c += l.length; c % 4;)d.push(0), c++;
        return n.write(d), r = 2981146554 - t(n.data), n.pos = o + 8, n.writeUInt32(r), n.data;
    }, t = function(t) {
        var e, r, n, i;
        for(t = $020d60e69294d716$var$ve.call(t); t.length % 4;)t.push(0);
        for(n = new $020d60e69294d716$var$ne(t), r = 0, e = 0, i = t.length; e < i; e = e += 4)r += n.readUInt32();
        return 4294967295 & r;
    }, e;
}(), $020d60e69294d716$var$ae = {}.hasOwnProperty, $020d60e69294d716$var$oe = function(t, e) {
    for(var r in e)$020d60e69294d716$var$ae.call(e, r) && (t[r] = e[r]);
    function n() {
        this.constructor = t;
    }
    return n.prototype = e.prototype, t.prototype = new n, t.__super__ = e.prototype, t;
};
$020d60e69294d716$var$re = function() {
    function t(t) {
        var e;
        this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
    }
    return t.prototype.parse = function() {}, t.prototype.encode = function() {}, t.prototype.raw = function() {
        return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
    }, t;
}();
var $020d60e69294d716$var$se = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $020d60e69294d716$var$oe(e, $020d60e69294d716$var$re), e.prototype.tag = "head", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
    }, e.prototype.encode = function(t) {
        var e;
        return (e = new $020d60e69294d716$var$ne).writeInt(this.version), e.writeInt(this.revision), e.writeInt(this.checkSumAdjustment), e.writeInt(this.magicNumber), e.writeShort(this.flags), e.writeShort(this.unitsPerEm), e.writeLongLong(this.created), e.writeLongLong(this.modified), e.writeShort(this.xMin), e.writeShort(this.yMin), e.writeShort(this.xMax), e.writeShort(this.yMax), e.writeShort(this.macStyle), e.writeShort(this.lowestRecPPEM), e.writeShort(this.fontDirectionHint), e.writeShort(t), e.writeShort(this.glyphDataFormat), e.data;
    }, e;
}(), $020d60e69294d716$var$ce = function() {
    function t(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m, v, b;
        switch(this.platformID = t.readUInt16(), this.encodingID = t.readShort(), this.offset = e + t.readInt(), h = t.pos, t.pos = this.offset, this.format = t.readUInt16(), this.length = t.readUInt16(), this.language = t.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
            case 0:
                for(s = 0; s < 256; ++s)this.codeMap[s] = t.readByte();
                break;
            case 4:
                for(f = t.readUInt16(), l = f / 2, t.pos += 6, i = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), t.pos += 2, p = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), c = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), u = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), n = (this.length - t.pos + this.offset) / 2, o = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= n ? e < n : e > n; s = 0 <= n ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), s = m = 0, b = i.length; m < b; s = ++m)for(g = i[s], r = v = d = p[s]; d <= g ? v <= g : v >= g; r = d <= g ? ++v : --v)0 === u[s] ? a = r + c[s] : 0 !== (a = o[u[s] / 2 + (r - d) - (l - s)] || 0) && (a += c[s]), this.codeMap[r] = 65535 & a;
        }
        t.pos = h;
    }
    return t.encode = function(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m, v, b, y, w, N, L, A, x, S, _, P, k, I, F, C, j, O, B, M, E, q, D, R, T, U, z, H, W, V, G, Y;
        switch(I = new $020d60e69294d716$var$ne, a = Object.keys(t).sort(function(t, e) {
            return t - e;
        }), e){
            case "macroman":
                for(p = 0, g = function() {
                    var t = [];
                    for(d = 0; d < 256; ++d)t.push(0);
                    return t;
                }(), v = {
                    0: 0
                }, i = {}, F = 0, B = a.length; F < B; F++)null == v[W = t[n = a[F]]] && (v[W] = ++p), i[n] = {
                    old: t[n],
                    new: v[t[n]]
                }, g[n] = v[t[n]];
                return I.writeUInt16(1), I.writeUInt16(0), I.writeUInt32(12), I.writeUInt16(0), I.writeUInt16(262), I.writeUInt16(0), I.write(g), {
                    charMap: i,
                    subtable: I.data,
                    maxGlyphID: p + 1
                };
            case "unicode":
                for(P = [], h = [], b = 0, v = {}, r = {}, m = c = null, C = 0, M = a.length; C < M; C++)null == v[w = t[n = a[C]]] && (v[w] = ++b), r[n] = {
                    old: w,
                    new: v[w]
                }, o = v[w] - n, null != m && o === c || (m && h.push(m), P.push(n), c = o), m = n;
                for(m && h.push(m), h.push(65535), P.push(65535), S = 2 * (x = P.length), A = 2 * Math.pow(Math.log(x) / Math.LN2, 2), l = Math.log(A / 2) / Math.LN2, L = 2 * x - A, s = [], N = [], f = [], d = j = 0, E = P.length; j < E; d = ++j){
                    if (_ = P[d], u = h[d], 65535 === _) {
                        s.push(0), N.push(0);
                        break;
                    }
                    if (_ - (k = r[_].new) >= 32768) for(s.push(0), N.push(2 * (f.length + x - d)), n = O = _; _ <= u ? O <= u : O >= u; n = _ <= u ? ++O : --O)f.push(r[n].new);
                    else s.push(k - _), N.push(0);
                }
                for(I.writeUInt16(3), I.writeUInt16(1), I.writeUInt32(12), I.writeUInt16(4), I.writeUInt16(16 + 8 * x + 2 * f.length), I.writeUInt16(0), I.writeUInt16(S), I.writeUInt16(A), I.writeUInt16(l), I.writeUInt16(L), z = 0, q = h.length; z < q; z++)n = h[z], I.writeUInt16(n);
                for(I.writeUInt16(0), H = 0, D = P.length; H < D; H++)n = P[H], I.writeUInt16(n);
                for(V = 0, R = s.length; V < R; V++)o = s[V], I.writeUInt16(o);
                for(G = 0, T = N.length; G < T; G++)y = N[G], I.writeUInt16(y);
                for(Y = 0, U = f.length; Y < U; Y++)p = f[Y], I.writeUInt16(p);
                return {
                    charMap: r,
                    subtable: I.data,
                    maxGlyphID: b + 1
                };
        }
    }, t;
}(), $020d60e69294d716$var$ue = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $020d60e69294d716$var$oe(e, $020d60e69294d716$var$re), e.prototype.tag = "cmap", e.prototype.parse = function(t) {
        var e, r, n;
        for(t.pos = this.offset, this.version = t.readUInt16(), n = t.readUInt16(), this.tables = [], this.unicode = null, r = 0; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r)e = new $020d60e69294d716$var$ce(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
        return !0;
    }, e.encode = function(t, e) {
        var r, n;
        return null == e && (e = "macroman"), r = $020d60e69294d716$var$ce.encode(t, e), (n = new $020d60e69294d716$var$ne).writeUInt16(0), n.writeUInt16(1), r.table = n.data.concat(r.subtable), r;
    }, e;
}(), $020d60e69294d716$var$he = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $020d60e69294d716$var$oe(e, $020d60e69294d716$var$re), e.prototype.tag = "hhea", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
    }, e;
}(), $020d60e69294d716$var$le = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $020d60e69294d716$var$oe(e, $020d60e69294d716$var$re), e.prototype.tag = "OS/2", e.prototype.parse = function(t) {
        if (t.pos = this.offset, this.version = t.readUInt16(), this.averageCharWidth = t.readShort(), this.weightClass = t.readUInt16(), this.widthClass = t.readUInt16(), this.type = t.readShort(), this.ySubscriptXSize = t.readShort(), this.ySubscriptYSize = t.readShort(), this.ySubscriptXOffset = t.readShort(), this.ySubscriptYOffset = t.readShort(), this.ySuperscriptXSize = t.readShort(), this.ySuperscriptYSize = t.readShort(), this.ySuperscriptXOffset = t.readShort(), this.ySuperscriptYOffset = t.readShort(), this.yStrikeoutSize = t.readShort(), this.yStrikeoutPosition = t.readShort(), this.familyClass = t.readShort(), this.panose = function() {
            var e, r;
            for(r = [], e = 0; e < 10; ++e)r.push(t.readByte());
            return r;
        }(), this.charRange = function() {
            var e, r;
            for(r = [], e = 0; e < 4; ++e)r.push(t.readInt());
            return r;
        }(), this.vendorID = t.readString(4), this.selection = t.readShort(), this.firstCharIndex = t.readShort(), this.lastCharIndex = t.readShort(), this.version > 0 && (this.ascent = t.readShort(), this.descent = t.readShort(), this.lineGap = t.readShort(), this.winAscent = t.readShort(), this.winDescent = t.readShort(), this.codePageRange = function() {
            var e, r;
            for(r = [], e = 0; e < 2; e = ++e)r.push(t.readInt());
            return r;
        }(), this.version > 1)) return this.xHeight = t.readShort(), this.capHeight = t.readShort(), this.defaultChar = t.readShort(), this.breakChar = t.readShort(), this.maxContext = t.readShort();
    }, e;
}(), $020d60e69294d716$var$fe = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $020d60e69294d716$var$oe(e, $020d60e69294d716$var$re), e.prototype.tag = "post", e.prototype.parse = function(t) {
        var e, r, n;
        switch(t.pos = this.offset, this.format = t.readInt(), this.italicAngle = t.readInt(), this.underlinePosition = t.readShort(), this.underlineThickness = t.readShort(), this.isFixedPitch = t.readInt(), this.minMemType42 = t.readInt(), this.maxMemType42 = t.readInt(), this.minMemType1 = t.readInt(), this.maxMemType1 = t.readInt(), this.format){
            case 65536:
                break;
            case 131072:
                var i;
                for(r = t.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= r ? i < r : i > r; i = 0 <= r ? ++i : --i)this.glyphNameIndex.push(t.readUInt16());
                for(this.names = [], n = []; t.pos < this.offset + this.length;)e = t.readByte(), n.push(this.names.push(t.readString(e)));
                return n;
            case 151552:
                return r = t.readUInt16(), this.offsets = t.read(r);
            case 196608:
                break;
            case 262144:
                return this.map = (function() {
                    var e, r, n;
                    for(n = [], i = e = 0, r = this.file.maxp.numGlyphs; 0 <= r ? e < r : e > r; i = 0 <= r ? ++e : --e)n.push(t.readUInt32());
                    return n;
                }).call(this);
        }
    }, e;
}(), $020d60e69294d716$var$de = function(t, e) {
    this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
}, $020d60e69294d716$var$pe = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $020d60e69294d716$var$oe(e, $020d60e69294d716$var$re), e.prototype.tag = "name", e.prototype.parse = function(t) {
        var e, r, n, i, a, o, s, c, u, h, l;
        for(t.pos = this.offset, t.readShort(), e = t.readShort(), o = t.readShort(), r = [], i = 0; 0 <= e ? i < e : i > e; i = 0 <= e ? ++i : --i)r.push({
            platformID: t.readShort(),
            encodingID: t.readShort(),
            languageID: t.readShort(),
            nameID: t.readShort(),
            length: t.readShort(),
            offset: this.offset + o + t.readShort()
        });
        for(s = {}, i = u = 0, h = r.length; u < h; i = ++u)n = r[i], t.pos = n.offset, c = t.readString(n.length), a = new $020d60e69294d716$var$de(c, n), null == s[l = n.nameID] && (s[l] = []), s[n.nameID].push(a);
        this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5];
        try {
            this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        } catch (t) {
            this.postscriptName = s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        }
        return this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
    }, e;
}(), $020d60e69294d716$var$ge = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $020d60e69294d716$var$oe(e, $020d60e69294d716$var$re), e.prototype.tag = "maxp", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
    }, e;
}(), $020d60e69294d716$var$me = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $020d60e69294d716$var$oe(e, $020d60e69294d716$var$re), e.prototype.tag = "hmtx", e.prototype.parse = function(t) {
        var e, r, n, i, a, o, s;
        for(t.pos = this.offset, this.metrics = [], e = 0, o = this.file.hhea.numberOfMetrics; 0 <= o ? e < o : e > o; e = 0 <= o ? ++e : --e)this.metrics.push({
            advance: t.readUInt16(),
            lsb: t.readInt16()
        });
        for(n = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
            var r, i;
            for(i = [], e = r = 0; 0 <= n ? r < n : r > n; e = 0 <= n ? ++r : --r)i.push(t.readInt16());
            return i;
        }(), this.widths = (function() {
            var t, e, r, n;
            for(n = [], t = 0, e = (r = this.metrics).length; t < e; t++)i = r[t], n.push(i.advance);
            return n;
        }).call(this), r = this.widths[this.widths.length - 1], s = [], e = a = 0; 0 <= n ? a < n : a > n; e = 0 <= n ? ++a : --a)s.push(this.widths.push(r));
        return s;
    }, e.prototype.forGlyph = function(t) {
        return t in this.metrics ? this.metrics[t] : {
            advance: this.metrics[this.metrics.length - 1].advance,
            lsb: this.leftSideBearings[t - this.metrics.length]
        };
    }, e;
}(), $020d60e69294d716$var$ve = [].slice, $020d60e69294d716$var$be = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $020d60e69294d716$var$oe(e, $020d60e69294d716$var$re), e.prototype.tag = "glyf", e.prototype.parse = function() {
        return this.cache = {};
    }, e.prototype.glyphFor = function(t) {
        var e, r, n, i, a, o, s, c, u, h;
        return t in this.cache ? this.cache[t] : (i = this.file.loca, e = this.file.contents, r = i.indexOf(t), 0 === (n = i.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + r, a = (o = new $020d60e69294d716$var$ne(e.read(n))).readShort(), c = o.readShort(), h = o.readShort(), s = o.readShort(), u = o.readShort(), this.cache[t] = -1 === a ? new $020d60e69294d716$var$we(o, c, h, s, u) : new $020d60e69294d716$var$ye(o, a, c, h, s, u), this.cache[t]));
    }, e.prototype.encode = function(t, e, r) {
        var n, i, a, o, s;
        for(a = [], i = [], o = 0, s = e.length; o < s; o++)n = t[e[o]], i.push(a.length), n && (a = a.concat(n.encode(r)));
        return i.push(a.length), {
            table: a,
            offsets: i
        };
    }, e;
}(), $020d60e69294d716$var$ye = function() {
    function t(t, e, r, n, i, a) {
        this.raw = t, this.numberOfContours = e, this.xMin = r, this.yMin = n, this.xMax = i, this.yMax = a, this.compound = !1;
    }
    return t.prototype.encode = function() {
        return this.raw.data;
    }, t;
}(), $020d60e69294d716$var$we = function() {
    function t(t, e, r, n, i) {
        var a, o;
        for(this.raw = t, this.xMin = e, this.yMin = r, this.xMax = n, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], a = this.raw; o = a.readShort(), this.glyphOffsets.push(a.pos), this.glyphIDs.push(a.readUInt16()), 32 & o;)a.pos += 1 & o ? 4 : 2, 128 & o ? a.pos += 8 : 64 & o ? a.pos += 4 : 8 & o && (a.pos += 2);
    }
    return t.prototype.encode = function() {
        var t, e, r;
        for(e = new $020d60e69294d716$var$ne($020d60e69294d716$var$ve.call(this.raw.data)), t = 0, r = this.glyphIDs.length; t < r; ++t)e.pos = this.glyphOffsets[t];
        return e.data;
    }, t;
}(), $020d60e69294d716$var$Ne = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $020d60e69294d716$var$oe(e, $020d60e69294d716$var$re), e.prototype.tag = "loca", e.prototype.parse = function(t) {
        var e, r;
        return t.pos = this.offset, e = this.file.head.indexToLocFormat, this.offsets = 0 === e ? (function() {
            var e, n;
            for(n = [], r = 0, e = this.length; r < e; r += 2)n.push(2 * t.readUInt16());
            return n;
        }).call(this) : (function() {
            var e, n;
            for(n = [], r = 0, e = this.length; r < e; r += 4)n.push(t.readUInt32());
            return n;
        }).call(this);
    }, e.prototype.indexOf = function(t) {
        return this.offsets[t];
    }, e.prototype.lengthOf = function(t) {
        return this.offsets[t + 1] - this.offsets[t];
    }, e.prototype.encode = function(t, e) {
        for(var r = new Uint32Array(this.offsets.length), n = 0, i = 0, a = 0; a < r.length; ++a)if (r[a] = n, i < e.length && e[i] == a) {
            ++i, r[a] = n;
            var o = this.offsets[a], s = this.offsets[a + 1] - o;
            s > 0 && (n += s);
        }
        for(var c = new Array(4 * r.length), u = 0; u < r.length; ++u)c[4 * u + 3] = 255 & r[u], c[4 * u + 2] = (65280 & r[u]) >> 8, c[4 * u + 1] = (16711680 & r[u]) >> 16, c[4 * u] = (4278190080 & r[u]) >> 24;
        return c;
    }, e;
}(), $020d60e69294d716$var$Le = function() {
    function t(t) {
        this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
    }
    return t.prototype.generateCmap = function() {
        var t, e, r, n, i;
        for(e in n = this.font.cmap.tables[0].codeMap, t = {}, i = this.subset)r = i[e], t[e] = n[r];
        return t;
    }, t.prototype.glyphsFor = function(t) {
        var e, r, n, i, a, o, s;
        for(n = {}, a = 0, o = t.length; a < o; a++)n[i = t[a]] = this.font.glyf.glyphFor(i);
        for(i in e = [], n)(null != (r = n[i]) ? r.compound : void 0) && e.push.apply(e, r.glyphIDs);
        if (e.length > 0) for(i in s = this.glyphsFor(e))r = s[i], n[i] = r;
        return n;
    }, t.prototype.encode = function(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m;
        for(n in r = $020d60e69294d716$var$ue.encode(this.generateCmap(), "unicode"), a = this.glyphsFor(t), f = {
            0: 0
        }, m = r.charMap)f[(s = m[n]).old] = s.new;
        for(d in l = r.maxGlyphID, a)d in f || (f[d] = l++);
        return u = function(t) {
            var e, r;
            for(e in r = {}, t)r[t[e]] = e;
            return r;
        }(f), h = Object.keys(u).sort(function(t, e) {
            return t - e;
        }), p = function() {
            var t, e, r;
            for(r = [], t = 0, e = h.length; t < e; t++)o = h[t], r.push(u[o]);
            return r;
        }(), i = this.font.glyf.encode(a, p, f), c = this.font.loca.encode(i.offsets, p), g = {
            cmap: this.font.cmap.raw(),
            glyf: i.table,
            loca: c,
            hmtx: this.font.hmtx.raw(),
            hhea: this.font.hhea.raw(),
            maxp: this.font.maxp.raw(),
            post: this.font.post.raw(),
            name: this.font.name.raw(),
            head: this.font.head.encode(e)
        }, this.font.os2.exists && (g["OS/2"] = this.font.os2.raw()), this.font.directory.encode(g);
    }, t;
}();
$020d60e69294d716$export$ba1e2ffc633a60f5.API.PDFObject = function() {
    var t;
    function e() {}
    return t = function(t, e) {
        return (Array(e + 1).join("0") + t).slice(-e);
    }, e.convert = function(r) {
        var n, i, a, o;
        if (Array.isArray(r)) return "[" + (function() {
            var t, i, a;
            for(a = [], t = 0, i = r.length; t < i; t++)n = r[t], a.push(e.convert(n));
            return a;
        })().join(" ") + "]";
        if ("string" == typeof r) return "/" + r;
        if (null != r ? r.isString : void 0) return "(" + r + ")";
        if (r instanceof Date) return "(D:" + t(r.getUTCFullYear(), 4) + t(r.getUTCMonth(), 2) + t(r.getUTCDate(), 2) + t(r.getUTCHours(), 2) + t(r.getUTCMinutes(), 2) + t(r.getUTCSeconds(), 2) + "Z)";
        if ("[object Object]" === ({}).toString.call(r)) {
            for(i in a = [
                "<<"
            ], r)o = r[i], a.push("/" + i + " " + e.convert(o));
            return a.push(">>"), a.join("\n");
        }
        return "" + r;
    }, e;
}();
var $020d60e69294d716$export$2e2bcd8739ae039 = $020d60e69294d716$export$ba1e2ffc633a60f5;




class $a8b052cf8450e14d$export$2e2bcd8739ae039 {
    static getFirmName(firm) {
        if (firm.name) return firm.name;
        const userInfo = firm.Users?.UserInformation;
        if (userInfo) return `${userInfo.firstName} ${userInfo.lastName}`;
        return null;
    }
}


class $a4f6f7c5f30e5097$export$2e2bcd8739ae039 {
    static getUserName(user) {
        const userInfo = user?.UserInformation;
        return userInfo ? `${userInfo.firstName} ${userInfo.lastName}` : null;
    }
}




const { Paragraph: $7e6295d196895566$var$Paragraph, Text: $7e6295d196895566$var$Text, Title: $7e6295d196895566$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $7e6295d196895566$var$faultTolerantImage = 'data:image/png;base64,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';
const $7e6295d196895566$var$columns = [
    {
        title: 'Description',
        dataIndex: 'description',
        key: 'description'
    },
    {
        title: 'Price Each',
        dataIndex: 'priceEach',
        key: 'priceEach',
        render: (val, row)=>`$${val}`
    },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: 'quantity'
    },
    {
        title: 'Item Total',
        dataIndex: 'totalDallarAmount',
        key: 'totalDallarAmount',
        render: (val, row)=>`$${(row.quantity * row.priceEach).toFixed(2)}`
    }
];
function $7e6295d196895566$var$ViewInvoiceModal({ paymentData: paymentData, isModalVisible: isModalVisible, setIsModalVisible: setIsModalVisible }) {
    const [getFirmLogo] = (0, $77affb39e34dc16b$export$6a64aa919104efc3)();
    const [getTaxYearInterviewIncludeInterviews] = (0, $2d09ce9c73e1e422$export$714b336e4bb764ad)();
    const { clientFirstName: clientFirstName, clientLastName: clientLastName } = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const [companyInformationData, setCompanyInformationData] = (0, $6fFrj.useState)([]);
    const { data: customLayoutData } = (0, $732264f53056e08f$export$a9d926e7a1510ac6)();
    const customLayout = customLayoutData?.CustomLayout;
    const { data: firmAccountInfoData } = (0, $732264f53056e08f$export$c65bb1005cf74961)();
    const firmAccount = firmAccountInfoData?.BusinessInformation;
    const generateCompanyInformationData = ()=>{
        const firmAddress = firmAccount?.Address?.[0]?.lineOne ? `${firmAccount?.Address?.[0]?.lineOne}, 
        ${firmAccount?.Address?.[0]?.lineTwo}, 
        ${firmAccount?.Address?.[0]?.city}, 
        ${firmAccount?.Address?.[0]?.state}, 
        ${firmAccount?.Address?.[0]?.zip}` : null;
        const data = [];
        if (firmAccount?.FirmAccount?.name) data.push({
            title: 'Firm Name',
            value: firmAccount?.FirmAccount?.name
        });
        if (firmAddress) data.push({
            title: 'Firm Address',
            value: firmAddress
        });
        if (firmAccount?.Phones?.[0]?.value) data.push({
            title: 'Firm Phone',
            value: firmAccount?.Phones?.[0]?.value
        });
        setCompanyInformationData(data);
    };
    (0, $6fFrj.useEffect)(()=>{
        generateCompanyInformationData();
    }, [
        firmAccountInfoData
    ]);
    const getInterviewAnswer = (section, questionDescription, answers)=>{
        const question = section.Questions?.find((q)=>q.Translations?.some((t)=>t.description === questionDescription));
        const answer = question ? answers.find((a)=>a.questionId === question.id) : null;
        return answer?.description;
    };
    const extractClientAddressFromInterview = (interviewData)=>{
        const content = interviewData.GetTaxYearInterviewIncludeInterviews;
        const interview = content?.Interviews;
        const answers = content?.Answers;
        const clientSection = interview?.Sections?.find((s)=>s.Translations?.some((t)=>t.description === 'Basic Personal Information'));
        if (clientSection) {
            const lineOne = getInterviewAnswer(clientSection, 'Address Line 1', answers);
            const lineTwo = getInterviewAnswer(clientSection, 'Address Line 2', answers);
            const city = getInterviewAnswer(clientSection, 'City', answers);
            const state = getInterviewAnswer(clientSection, 'State/Province/Region', answers);
            const zip = getInterviewAnswer(clientSection, 'ZIP/Postal Code', answers);
            return {
                lineOne: lineOne,
                lineTwo: lineTwo,
                city: city,
                state: state,
                zip: zip
            };
        }
        const businessSection = interview?.Sections?.find((s)=>s.Translations?.some((t)=>t.description === 'Business Information'));
        if (businessSection) {
            const lineOne = getInterviewAnswer(businessSection, 'Address Line 1', answers);
            const lineTwo = getInterviewAnswer(businessSection, 'Address Line 2', answers);
            const city = getInterviewAnswer(businessSection, 'City', answers);
            const state = getInterviewAnswer(businessSection, 'State/Province/Region', answers);
            const zip = getInterviewAnswer(businessSection, 'ZIP/Postal Code', answers);
            return {
                lineOne: lineOne,
                lineTwo: lineTwo,
                city: city,
                state: state,
                zip: zip
            };
        }
        return null;
    };
    const combineLines = (line1, line2)=>`${line1 ?? ''}${line1 && line2 ? ', ' : ''}${line2 ?? ''}`;
    const combineAddress = (city, state, zip)=>`${city?.trim() ?? ''}${city && state ? ', ' : ''}${state?.trim() ?? ''}${(city || state) && zip ? ' ' : ''}${zip?.trim() ?? ''}`;
    const download = async (invoice)=>{
        const PDF_LOGO_WIDTH = 60;
        const PDF_LOGO_HEIGHT = 30;
        const firm = invoice?.FirmAccount;
        const { data: logoData } = await getFirmLogo({
            variables: {
                id: firm?.id
            }
        });
        const { data: interviewData } = await getTaxYearInterviewIncludeInterviews({
            variables: {
                id: invoice?.taxYearInterviewId
            }
        });
        const firmName = (0, $a8b052cf8450e14d$export$2e2bcd8739ae039).getFirmName(firm);
        const firmUserInfo = firm?.Users?.UserInformation;
        const firmAddress = firm?.BusinessInformation?.Address?.[0] ?? firmUserInfo?.Address?.[0];
        const firmAddressLine = combineLines(firmAddress?.lineOne, firmAddress?.lineTwo);
        const firmAddressTail = combineAddress(firmAddress?.city, firmAddress?.state, firmAddress?.zip);
        const firmPhone = firm?.BusinessInformation?.Phones?.[0]?.value ?? firm?.Users?.UserInformation?.Phones?.[0]?.value ?? '';
        const client = invoice?.Entity?.Users;
        const clientInformation = client?.UserInformation || {};
        const clientAddress = clientInformation?.Address?.[0] || extractClientAddressFromInterview(interviewData);
        const clientAddressLine = combineLines(clientAddress?.lineOne, clientAddress?.lineTwo);
        const clientAddressTail = combineAddress(clientAddress?.city, clientAddress?.state, clientAddress?.zip);
        const clientPhone = clientInformation?.Phones?.[0].value ?? '';
        const doc = new (0, $020d60e69294d716$export$ba1e2ffc633a60f5)();
        const firmLogo = logoData?.GetFirmLogo;
        if (firmLogo) {
            const logoWidth = firmLogo?.width;
            const logoHeight = firmLogo?.height;
            const ratio = Math.min(PDF_LOGO_WIDTH / logoWidth, PDF_LOGO_HEIGHT / logoHeight);
            doc.addImage(firmLogo?.base64, 10, 15, logoWidth * ratio, logoHeight * ratio);
        }
        const date = new Date(invoice?.requestAt);
        const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
        const prettyDate = `${month}-${day}-${date.getFullYear()}`;
        const dy = 10; // line height
        let y = 10;
        doc.text(`${firmName || ''}`, 200, y += dy, {
            align: 'right'
        });
        doc.text(firmAddressLine, 200, y += dy, {
            align: 'right'
        });
        doc.text(firmAddressTail, 200, y += dy, {
            align: 'right'
        });
        doc.text(firmPhone, 200, y += dy, {
            align: 'right'
        });
        y += dy;
        doc.line(10, y, 205, y);
        doc.text(`${(0, $a4f6f7c5f30e5097$export$2e2bcd8739ae039).getUserName(client)}`, 10, y += dy);
        doc.text(clientAddressLine, 10, y += dy);
        doc.text(clientAddressTail, 10, y += dy);
        doc.text(clientPhone, 10, y += dy);
        y += dy * 0.5;
        doc.line(10, y, 205, y);
        if (prettyDate && prettyDate !== 'NaN-NaN-NaN') doc.text(`Date: ${prettyDate}`, 10, y += dy);
        y += dy * 3.5;
        doc.text('Description', 10, y);
        doc.text('Price Each', 90, y);
        doc.text('Quantity', 140, y);
        doc.text('Item total', 180, y);
        y += dy * 0.2;
        doc.line(10, y, 70, y);
        doc.line(85, y, 118, y);
        doc.line(130, y, 161, y);
        doc.line(170, y, 203, y);
        y += dy * 0.8;
        invoice.Invoices.forEach((el)=>{
            doc.text(el.description, 10, y);
            doc.text(`$${el.priceEach}`, 118, y, {
                align: 'right'
            });
            doc.text(String(el.quantity), 161, y, {
                align: 'right'
            });
            doc.text(`$${el.priceEach * el.quantity}`, 203, y, {
                align: 'right'
            });
            y += dy;
        });
        doc.line(10, y, 205, y);
        y += dy * 0.8;
        doc.text('Total', 150, y);
        doc.text(`$${invoice?.totalDollarAmount?.toFixed(2)}`, 203, y, {
            align: 'right'
        });
        doc.autoPrint();
        // This is a key for printing
        doc.output('dataurlnewwindow');
    }; // end downlaod
    const exportToPDFButtonOnClick = ()=>{
        download(paymentData);
        setIsModalVisible(false);
    };
    const cancelButtonOnClick = ()=>{
        setIsModalVisible(false);
    };
    const getFirstCharacterCapitalized = (text)=>{
        if (!text) return '';
        return text[0].toUpperCase();
    };
    const modalTitle = (userName)=>(0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
            children: [
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    children: [
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            span: 20,
                            children: (0, $bb3TF.jsx)($7e6295d196895566$var$Title, {
                                level: 4,
                                children: "View Invoice"
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            span: 3,
                            children: (0, $bb3TF.jsx)((0, $290d39e90e1ee9b2$export$2e2bcd8739ae039), {
                                style: {
                                    position: 'absolute',
                                    top: '-1em'
                                },
                                width: 95,
                                // src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
                                src: customLayout?.logo,
                                fallback: $7e6295d196895566$var$faultTolerantImage
                            })
                        })
                    ]
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 12,
                        children: (0, $bb3TF.jsx)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                            direction: "horizontal",
                            children: (0, $bb3TF.jsx)($7e6295d196895566$var$Text, {
                                type: "secondary",
                                children: userName
                            })
                        })
                    })
                })
            ]
        });
    return (0, $bb3TF.jsxs)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        bodyStyle: {
            maxHeight: 450,
            overflowY: 'scroll'
        },
        title: modalTitle(`${clientFirstName} ${clientLastName}`),
        okText: "Export To PDF",
        cancelText: "Close",
        centered: true,
        visible: isModalVisible,
        onOk: exportToPDFButtonOnClick,
        onCancel: cancelButtonOnClick,
        width: 1000,
        children: [
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    span: 24,
                    children: Boolean(companyInformationData.length) && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($7e6295d196895566$var$Paragraph, {
                            strong: true,
                            style: {
                                textTransform: 'capitalize'
                            },
                            children: companyInformationData.map((el)=>el.value).join(', ')
                        })
                    })
                })
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    span: 24,
                    children: (0, $bb3TF.jsx)((0, $2eb2b7b37988b8f9$export$2e2bcd8739ae039), {
                        columns: $7e6295d196895566$var$columns,
                        dataSource: paymentData?.Invoices
                    })
                })
            }),
            paymentData?.paidOffline && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    span: 24,
                    children: (0, $bb3TF.jsx)((0, $66ef76fa6be8ca1a$export$2e2bcd8739ae039), {
                        disabled: true,
                        checked: true,
                        onChange: ()=>undefined,
                        children: (0, $bb3TF.jsx)("strong", {
                            children: "This invoice was already paid offline (do not request payment from client)"
                        })
                    })
                })
            }),
            (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {}),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 20
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 2,
                        children: (0, $bb3TF.jsx)($7e6295d196895566$var$Text, {
                            children: "Total:"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 2,
                        children: (0, $bb3TF.jsxs)($7e6295d196895566$var$Text, {
                            children: [
                                "$",
                                paymentData?.totalDollarAmount?.toFixed(2)
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $7e6295d196895566$export$2e2bcd8739ae039 = $7e6295d196895566$var$ViewInvoiceModal;


const { Paragraph: $b082f0c82a59db60$var$Paragraph, Link: $b082f0c82a59db60$var$Link } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { CheckCircleOutlined: $b082f0c82a59db60$var$CheckCircleOutlined, DollarOutlined: $b082f0c82a59db60$var$DollarOutlined, PlusOutlined: $b082f0c82a59db60$var$PlusOutlined, UndoOutlined: $b082f0c82a59db60$var$UndoOutlined, ArrowDownOutlined: $b082f0c82a59db60$var$ArrowDownOutlined, SendOutlined: $b082f0c82a59db60$var$SendOutlined, DeleteOutlined: $b082f0c82a59db60$var$DeleteOutlined, DownloadOutlined: $b082f0c82a59db60$var$DownloadOutlined, EyeOutlined: $b082f0c82a59db60$var$EyeOutlined, EditOutlined: $b082f0c82a59db60$var$EditOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $b082f0c82a59db60$var$InvoicesStatusTracking() {
    const [isModalVisible, setIsModalVisible] = (0, $6fFrj.useState)(false);
    const [isViewInvoiceModalVisible, setIsViewInvoiceModalVisible] = (0, $6fFrj.useState)(false);
    const [viewInvoiceData, setViewInvoiceData] = (0, $6fFrj.useState)(null);
    const [updateInvoiceData, setUpdateInvoiceData] = (0, $6fFrj.useState)(undefined);
    const { userRole: userRole } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    // context
    const { taxYearInterviewId: taxYearInterviewId, progressStatusId: progressStatusId, paymentsCompletedAt: paymentsCompletedAt, dispatch: dispatch } = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const { showModal: showModal, accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    // graphql
    // get stripe information
    const { data: currentStripeInformation, loading: loadingStripeInformation } = (0, $732264f53056e08f$export$9f382c5aef9c5d4d)({
        onError: (error)=>{
            console.log('error fetching stripe information:', error);
        }
    });
    const stripeInformation = currentStripeInformation?.CurrentStripeInformation;
    // get payments
    const { data: paymentsData, loading: loadingPayments } = (0, $77affb39e34dc16b$export$357cf8e54532943d)({
        variables: {
            taxYearInterviewId: taxYearInterviewId,
            includeDeleted: true
        }
    });
    const payments = paymentsData?.paymentsByTaxYearInterviewId;
    // send payment reminder
    const [sendInvoiceReminder, { loading: loadingSendPaymentReminder }] = (0, $9d2c47b028219547$export$fd4e7d5c474241a0)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        },
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Payment reminder sent');
        },
        refetchQueries: [
            'GetPaymentsByTaxYearInterviewId'
        ]
    });
    // update payments
    const [updatePayment, { loading: loadingCancelInvoice }] = (0, $9d2c47b028219547$export$c76120c8b4f78861)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        },
        refetchQueries: [
            {
                query: (0, $77affb39e34dc16b$export$b0c6acbe44f12fe8),
                variables: {
                    taxYearInterviewId: taxYearInterviewId
                }
            }
        ]
    });
    // delete payment
    const [deletePayment, { loading: loadingDeleteInvoice }] = (0, $9d2c47b028219547$export$3d988871ef9f7255)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        },
        refetchQueries: [
            'GetPaymentsByTaxYearInterviewId'
        ]
    });
    const [upsertJobTracking, { loading: loadingUpsertJobTracking }] = (0, $4066a7fc7221bcd4$export$5d2654c94a62b996)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    const createInvoiceButtonOnClick = ()=>{
        setUpdateInvoiceData(undefined);
        setIsModalVisible(true);
        (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).MODAL_SHOW, {
            'Modal Title': 'Create invoice',
            Source: 'Click on button',
            url: window.location.href
        });
    };
    const handlePaymentsComplete = ()=>{
        const today = new Date();
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    paymentsCompletedAt: today
                }
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Payments marked completed.');
                dispatch({
                    type: 'UPDATE',
                    payload: {
                        paymentsCompletedAt: today
                    }
                });
            }
        });
    };
    const handlePaymentsNotComplete = ()=>{
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    paymentsCompletedAt: null
                }
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Payments marked not complete.');
                dispatch({
                    type: 'UPDATE',
                    payload: {
                        paymentsCompletedAt: null
                    }
                });
            },
            refetchQueries: [
                {
                    query: (0, $732264f53056e08f$export$a3bc4d02ba9c53fe)
                },
                {
                    query: (0, $732264f53056e08f$export$d4e23f314f782a9d),
                    variables: {
                        progressStatusId: progressStatusId
                    }
                }
            ]
        });
    };
    const renderStatus = (row)=>{
        const { completedAt: completedAt, deletedAt: deletedAt, status: status } = row;
        // if it's marked deleted, then it's cancelled
        if (deletedAt) return (0, $bb3TF.jsx)((0, $0e541b76c0e3ec69$export$2e2bcd8739ae039), {
            status: "error",
            text: "Cancelled"
        });
        // I do processing first because ACH payments are marked complete while still in processing phase
        if (status === 'processing') return (0, $bb3TF.jsx)((0, $0e541b76c0e3ec69$export$2e2bcd8739ae039), {
            status: "processing",
            text: "Processing"
        });
        // if it's not processing and it it's marked complete, than it's completed and successful
        if (completedAt) return (0, $bb3TF.jsx)((0, $0e541b76c0e3ec69$export$2e2bcd8739ae039), {
            status: "success",
            text: "Completed"
        });
        return (0, $bb3TF.jsx)((0, $0e541b76c0e3ec69$export$2e2bcd8739ae039), {
            status: "default",
            text: "Requested"
        });
    };
    const menuItemOnClick = (menuItem, tableRow)=>{
        switch(menuItem.key){
            case '1':
                sendInvoiceReminder({
                    variables: {
                        paymentId: tableRow.id
                    }
                });
                break;
            case '2':
                // edit invoice
                setUpdateInvoiceData(tableRow);
                setIsModalVisible(true);
                (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).MODAL_SHOW, {
                    'Modal Title': 'Update invoice',
                    Source: 'Click on menu',
                    url: window.location.href
                });
                break;
            case '3':
                // mark as paid
                updatePayment({
                    variables: {
                        updatePaymentsInput: {
                            id: tableRow.id,
                            paidOffline: true,
                            completedAt: new Date().toISOString()
                        }
                    },
                    onCompleted: ()=>{
                        (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Invoice marked as paid.');
                    }
                });
                break;
            case '4':
                // cancel invoice
                updatePayment({
                    variables: {
                        updatePaymentsInput: {
                            id: tableRow.id,
                            deletedAt: new Date().toISOString()
                        }
                    },
                    onCompleted: ()=>{
                        (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Invoice cancelled.');
                    }
                });
                break;
            case '5':
                // delete invoice
                deletePayment({
                    variables: {
                        paymentId: tableRow.id
                    },
                    onCompleted: ()=>{
                        (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Invoice deleted.');
                    }
                });
                break;
            default:
                break;
        }
    };
    const getMenuItems = (payment)=>{
        const { deletedAt: deletedAt } = payment;
        return (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
            onClick: (menuItem)=>{
                menuItemOnClick(menuItem, payment);
            },
            children: deletedAt ? (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
                danger: true,
                children: (0, $bb3TF.jsx)("span", {
                    children: (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                        children: [
                            (0, $bb3TF.jsx)($b082f0c82a59db60$var$DeleteOutlined, {}),
                            "Delete Invoice"
                        ]
                    })
                })
            }, 5) : (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                children: [
                    (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
                        children: (0, $bb3TF.jsx)("span", {
                            children: (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $bb3TF.jsx)($b082f0c82a59db60$var$SendOutlined, {}),
                                    "Send Invoice reminder"
                                ]
                            })
                        })
                    }, 1),
                    (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
                        children: (0, $bb3TF.jsx)("span", {
                            children: (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $bb3TF.jsx)($b082f0c82a59db60$var$EditOutlined, {}),
                                    "Edit Invoice"
                                ]
                            })
                        })
                    }, 2),
                    (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
                        children: (0, $bb3TF.jsx)("span", {
                            children: (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $bb3TF.jsx)($b082f0c82a59db60$var$DownloadOutlined, {}),
                                    "Make as paid"
                                ]
                            })
                        })
                    }, 3),
                    (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
                        danger: true,
                        children: (0, $bb3TF.jsx)("span", {
                            children: (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $bb3TF.jsx)($b082f0c82a59db60$var$DeleteOutlined, {}),
                                    "Cancel Invoice"
                                ]
                            })
                        })
                    }, 4)
                ]
            })
        });
    };
    const getActionColumns = (payment)=>{
        const { completedAt: completedAt } = payment;
        if (completedAt || payment.deletedAt && userRole !== 'TAX_PREPARER') return (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
            size: "small",
            onClick: ()=>{
                setIsViewInvoiceModalVisible(true);
                setViewInvoiceData(payment);
            },
            icon: (0, $bb3TF.jsx)($b082f0c82a59db60$var$EyeOutlined, {}),
            children: "View"
        });
        return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039).Button, {
            icon: (0, $bb3TF.jsx)($b082f0c82a59db60$var$ArrowDownOutlined, {}),
            trigger: [
                'click'
            ],
            size: "small",
            onClick: ()=>{
                setIsViewInvoiceModalVisible(true);
                setViewInvoiceData(payment);
            },
            overlay: getMenuItems(payment),
            loading: loadingSendPaymentReminder,
            children: "View"
        });
    };
    const columns = [
        {
            title: 'Total',
            dataIndex: 'totalDollarAmount',
            key: 'totalDollarAmount',
            sorter: (a, b)=>a.totalDollarAmount - b.totalDollarAmount,
            render: (text, row)=>(0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    type: "dashed",
                    icon: (0, $bb3TF.jsx)($b082f0c82a59db60$var$DollarOutlined, {}),
                    children: (0, $bb3TF.jsx)("span", {
                        style: {
                            textDecoration: row.deletedAt ? 'line-through' : 'none'
                        },
                        children: text.toFixed(2)
                    })
                })
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            sorter: (a, b)=>{
                // Assign a sort order value based on the status
                const getStatusSortValue = (row)=>{
                    if (row.status === 'processing') return 2;
                    if (row.completedAt) return 3; // Assumes that completedAt being truthy means the status is 'Completed'
                    return 1; // Default case is 'Requested'
                };
                const statusA = getStatusSortValue(a);
                const statusB = getStatusSortValue(b);
                return statusA - statusB; // Sort by the assigned status order values
            },
            render: (text, row)=>(0, $bb3TF.jsx)("div", {
                    style: {
                        minWidth: 100
                    },
                    children: renderStatus(row)
                })
        },
        {
            title: 'Date Requested',
            dataIndex: 'requestAt',
            key: 'requestAt',
            sorter: (a, b)=>new Date(a.requestAt).getTime() - new Date(b.requestAt).getTime(),
            render: (text)=>(0, $bb3TF.jsx)("div", {
                    style: {
                        minWidth: 80
                    },
                    children: text ? new Date(text).toDateString() : ''
                })
        },
        {
            title: 'Paid On',
            dataIndex: 'completedAt',
            key: 'completedAt',
            sorter: (a, b)=>new Date(a.completedAt).getTime() - new Date(b.completedAt).getTime(),
            // render: (text: any) => text && new Date(text).toDateString(),
            render: (text)=>(0, $bb3TF.jsx)("div", {
                    style: {
                        minWidth: 80
                    },
                    children: text ? new Date(text).toDateString() : ''
                })
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, row)=>getActionColumns(row)
        }
    ];
    const data = [
        {
            key: 1,
            id: 1,
            amountPaid: '1.00',
            paidOn: 'January 25th 2021 at 8:20 am'
        },
        {
            key: 2,
            id: 2,
            amountPaid: '1.00',
            paidOn: 'January 25th 2021 at 8:20 am'
        },
        {
            key: 3,
            id: 3,
            amountPaid: '1.00',
            paidOn: 'January 25th 2021 at 8:20 am'
        },
        {
            key: 4,
            id: 4,
            amountPaid: '1.00',
            paidOn: 'January 25th 2021 at 8:20 am'
        },
        {
            key: 5,
            id: 5,
            amountPaid: '1.00',
            paidOn: 'January 25th 2021 at 8:20 am'
        },
        {
            key: 6,
            id: 6,
            amountPaid: '1.00',
            paidOn: 'January 25th 2021 at 8:20 am'
        }
    ];
    // eslint-disable-next-line react/no-unstable-nested-components
    function NoDataExtra() {
        if (stripeInformation?.connectAccountId) return (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            justify: "center",
            style: {
                marginTop: 25
            },
            children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                type: "primary",
                shape: "round",
                icon: (0, $bb3TF.jsx)($b082f0c82a59db60$var$PlusOutlined, {}),
                onClick: createInvoiceButtonOnClick,
                children: "Create your first invoice"
            })
        });
        return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "You must connect your Stripe account to create payments. See Client Invoicing in settings.",
            children: (0, $bb3TF.jsxs)("span", {
                children: [
                    ' ',
                    (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        style: {
                            pointerEvents: 'none'
                        },
                        type: "primary",
                        shape: "round",
                        onClick: createInvoiceButtonOnClick,
                        icon: (0, $bb3TF.jsx)($b082f0c82a59db60$var$PlusOutlined, {}),
                        iconDirection: "left",
                        disabled: true,
                        children: "Create your first invoice"
                    })
                ]
            })
        });
    }
    return (0, $bb3TF.jsxs)("div", {
        style: {
            marginLeft: 5
        },
        children: [
            (0, $bb3TF.jsx)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsxs)($b082f0c82a59db60$var$Paragraph, {
                    style: {
                        marginTop: 30
                    },
                    children: [
                        "Payment requets are sent to your client via email. Clients can pay securely through\u00A0",
                        (0, $bb3TF.jsx)($b082f0c82a59db60$var$Link, {
                            href: "http://www.stripe.com",
                            target: "_blank",
                            children: "Stripe"
                        }),
                        ", and funds typically arrive in your bank account within 3 business days after payment.",
                        !stripeInformation?.connectAccountId && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                            children: [
                                ' ',
                                "You can get set up with Stripe in",
                                ' ',
                                (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                                    to: "/settings/setup-invoicing",
                                    target: "_blank",
                                    children: "Client Invoicing"
                                }),
                                ' ',
                                "settings."
                            ]
                        })
                    ]
                })
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    20,
                    10
                ],
                style: {
                    marginTop: 10,
                    marginBottom: 15
                },
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: stripeInformation?.connectAccountId ? (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "default",
                            onClick: createInvoiceButtonOnClick,
                            icon: (0, $bb3TF.jsx)($b082f0c82a59db60$var$PlusOutlined, {}),
                            iconDirection: "left",
                            children: "Create Payment"
                        }) : (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                            title: "You must connect your Stripe account to create payments. See Client Invoicing in settings.",
                            children: (0, $bb3TF.jsxs)("span", {
                                children: [
                                    ' ',
                                    (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                        style: {
                                            pointerEvents: 'none'
                                        },
                                        type: "default",
                                        onClick: createInvoiceButtonOnClick,
                                        icon: (0, $bb3TF.jsx)($b082f0c82a59db60$var$PlusOutlined, {}),
                                        iconDirection: "left",
                                        disabled: true,
                                        children: "Create Payment"
                                    })
                                ]
                            })
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: !paymentsCompletedAt ? (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "primary",
                            icon: (0, $bb3TF.jsx)($b082f0c82a59db60$var$CheckCircleOutlined, {}),
                            iconDirection: "left",
                            onClick: handlePaymentsComplete,
                            loading: loadingUpsertJobTracking,
                            children: "Mark Payments Complete"
                        }) : (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "default",
                            icon: (0, $bb3TF.jsx)($b082f0c82a59db60$var$UndoOutlined, {}),
                            iconDirection: "left",
                            onClick: handlePaymentsNotComplete,
                            loading: loadingUpsertJobTracking,
                            children: "Mark Payments Not Complete"
                        })
                    })
                ]
            }),
            payments?.length > 0 ? (0, $bb3TF.jsx)((0, $2eb2b7b37988b8f9$export$2e2bcd8739ae039), {
                columns: columns,
                dataSource: payments,
                pagination: {
                    pageSize: 50
                },
                scroll: {
                    x: true,
                    y: 320
                },
                noDataProps: {
                    title: 'No payments yet',
                    extra: (0, $bb3TF.jsx)(NoDataExtra, {})
                },
                loading: loadingPayments || loadingCancelInvoice || loadingDeleteInvoice,
                rowKey: (row)=>row.id
            }) : (0, $bb3TF.jsx)((0, $9150234f0969a884$export$2e2bcd8739ae039), {
                description: "No payments yet"
            }),
            (0, $bb3TF.jsx)((0, $7e6295d196895566$export$2e2bcd8739ae039), {
                paymentData: viewInvoiceData,
                isModalVisible: isViewInvoiceModalVisible,
                setIsModalVisible: setIsViewInvoiceModalVisible
            }),
            (0, $bb3TF.jsx)((0, $7a6b63d135eabfc4$export$2e2bcd8739ae039), {
                isModalVisible: isModalVisible,
                setIsModalVisible: setIsModalVisible,
                paymentData: updateInvoiceData
            })
        ]
    });
}
var $b082f0c82a59db60$export$2e2bcd8739ae039 = $b082f0c82a59db60$var$InvoicesStatusTracking;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




const $a5a7edef5e85165a$var$defaultOptions = {};
const $a5a7edef5e85165a$export$f5bc3de639d968d7 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetFileRequestByTaxYearInterviewId($taxYearInterviewId: String!) {
  fileRequestsByTaxYearInterviewId(taxYearInterviewId: $taxYearInterviewId) {
    id
    userId
    notes
    title
    signatureRequest
    signatureComplete
    createAt
    updateAt
    taxYearInterviewId
    FileApproval {
      id
      expiresAt
      taskId
      completedAt
      createAt
      updateAt
      email
      name
      KBA {
        id
        numKbaFailedAttempts
        numKbaFailedAttempts
        numRequestedIdScans
        numFailedIdScans
        type
        isIdScanPassed
        isIdScanPending
        isValidated
        KBAFields {
          id
          description
          value
          type
        }
      }
      Tasks {
        id
        taskType
        completedAt
        createAt
        updateAt
        deletedAt
      }
      SignatureFields {
        id
        page
        fieldLeftPercentage
        fieldTopPercentage
        fieldWidthPercentage
        fieldHeightPercentage
        fieldType
        completedAt
        title
        description
        signatureImage
        fileApprovalId
      }
    }
    CompiledFile {
      id
      name
      s3Key
    }
    SignedFile {
      id
      name
      s3Key
    }
  }
}
    `;
function $a5a7edef5e85165a$export$3f2950564001f69b(baseOptions) {
    const options = {
        ...$a5a7edef5e85165a$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($a5a7edef5e85165a$export$f5bc3de639d968d7, options);
}
function $a5a7edef5e85165a$export$9a38f499783934c9(baseOptions) {
    const options = {
        ...$a5a7edef5e85165a$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($a5a7edef5e85165a$export$f5bc3de639d968d7, options);
}
const $a5a7edef5e85165a$export$39ac829ab91f0716 = {
    Query: {
        GetFileRequestByTaxYearInterviewId: 'GetFileRequestByTaxYearInterviewId'
    }
};



const $d4866daa2fbe65f8$var$defaultOptions = {};
const $d4866daa2fbe65f8$export$875aefbb9b338bc9 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation MarkFileApprovalsComplete($fileRequestId: String!) {
  MarkFileApprovalsComplete(fileRequestId: $fileRequestId) {
    id
    userId
    notes
    title
    signatureRequest
    signatureComplete
    createAt
    updateAt
    taxYearInterviewId
    FileApproval {
      id
      expiresAt
      taskId
      completedAt
      createAt
      updateAt
    }
    CompiledFile {
      s3Key
    }
    SignedFile {
      s3Key
    }
  }
}
    `;
function $d4866daa2fbe65f8$export$f2c979db84f65bcb(baseOptions) {
    const options = {
        ...$d4866daa2fbe65f8$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($d4866daa2fbe65f8$export$875aefbb9b338bc9, options);
}
const $d4866daa2fbe65f8$export$ca3f7f7f63643f38 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation ResendFileRequest($fileRequestId: String!) {
  ResendFileRequest(fileRequestId: $fileRequestId) {
    id
  }
}
    `;
function $d4866daa2fbe65f8$export$54155b93e50dd70b(baseOptions) {
    const options = {
        ...$d4866daa2fbe65f8$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($d4866daa2fbe65f8$export$ca3f7f7f63643f38, options);
}
const $d4866daa2fbe65f8$export$7efa9dbea5ed911a = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation RemoveFileRequest($id: String!) {
  RemoveFileRequest(id: $id) {
    id
  }
}
    `;
function $d4866daa2fbe65f8$export$2459b5b0c1676ef(baseOptions) {
    const options = {
        ...$d4866daa2fbe65f8$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($d4866daa2fbe65f8$export$7efa9dbea5ed911a, options);
}
const $d4866daa2fbe65f8$export$17a132f75e4143e1 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation updateApprovalSignatureRequest($input: UpdateApprovalSignatureRequestInput!) {
  updateApprovalSignatureRequest(input: $input) {
    id
    userId
    notes
    title
    signatureRequest
    signatureComplete
    createAt
    updateAt
    taxYearInterviewId
  }
}
    `;
function $d4866daa2fbe65f8$export$b2923732f6adc233(baseOptions) {
    const options = {
        ...$d4866daa2fbe65f8$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($d4866daa2fbe65f8$export$17a132f75e4143e1, options);
}
const $d4866daa2fbe65f8$export$39ac829ab91f0716 = {
    Mutation: {
        MarkFileApprovalsComplete: 'MarkFileApprovalsComplete',
        ResendFileRequest: 'ResendFileRequest',
        RemoveFileRequest: 'RemoveFileRequest',
        updateApprovalSignatureRequest: 'updateApprovalSignatureRequest'
    }
};








var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



var $bb3TF = parcelRequire("bb3TF");


var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ function $8aab30aa2c6b9d90$export$f5708dca728d7177(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
}


var $7bb064226b9ca3af$export$3fc3a33e48b33945 = 'dnd-core/INIT_COORDS';
var $7bb064226b9ca3af$export$98f9b4193e6b55e6 = 'dnd-core/BEGIN_DRAG';
var $7bb064226b9ca3af$export$22d1d88e2de0d0e0 = 'dnd-core/PUBLISH_DRAG_SOURCE';
var $7bb064226b9ca3af$export$9d358706ccac3727 = 'dnd-core/HOVER';
var $7bb064226b9ca3af$export$b4af72c40fd57063 = 'dnd-core/DROP';
var $7bb064226b9ca3af$export$d300627d16aeb9cc = 'dnd-core/END_DRAG';


function $c3344f736956c046$export$844048139dfc906d(clientOffset, sourceClientOffset) {
    return {
        type: (0, $7bb064226b9ca3af$export$3fc3a33e48b33945),
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}


function $6d423452009ed580$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6d423452009ed580$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6d423452009ed580$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6d423452009ed580$var$_typeof(obj);
}
function $6d423452009ed580$export$3988ae62b71be9a3(obj, path, defaultValue) {
    return path.split('.').reduce(function(a, c) {
        return a && a[c] ? a[c] : defaultValue || null;
    }, obj);
}
function $6d423452009ed580$export$5d14bf425b37f49e(items, item) {
    return items.filter(function(i) {
        return i !== item;
    });
}
function $6d423452009ed580$export$844ec244b1367d54(input) {
    return typeof input === 'string';
}
function $6d423452009ed580$export$a6cdc56e425d0d0a(input) {
    return $6d423452009ed580$var$_typeof(input) === 'object';
}
function $6d423452009ed580$export$6444ef5cd411280c(itemsA, itemsB) {
    var map = new Map();
    var insertItem = function insertItem(item) {
        map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    var result = [];
    map.forEach(function(count, key) {
        if (count === 1) result.push(key);
    });
    return result;
}
function $6d423452009ed580$export$bc86dfbf7795668c(itemsA, itemsB) {
    return itemsA.filter(function(t) {
        return itemsB.indexOf(t) > -1;
    });
}



var $f7ee1e170c0f2447$var$ResetCoordinatesAction = {
    type: (0, $7bb064226b9ca3af$export$3fc3a33e48b33945),
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function $f7ee1e170c0f2447$export$d6542eb0d76867d6(manager) {
    return function beginDrag() {
        var sourceIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            publishSource: true
        };
        var _options$publishSourc = options.publishSource, publishSource = _options$publishSourc === void 0 ? true : _options$publishSourc, clientOffset = options.clientOffset, getSourceClientOffset = options.getSourceClientOffset;
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry(); // Initialize the coordinates using the client offset
        manager.dispatch((0, $c3344f736956c046$export$844048139dfc906d)(clientOffset));
        $f7ee1e170c0f2447$var$verifyInvariants(sourceIds, monitor, registry); // Get the draggable source
        var sourceId = $f7ee1e170c0f2447$var$getDraggableSource(sourceIds, monitor);
        if (sourceId === null) {
            manager.dispatch($f7ee1e170c0f2447$var$ResetCoordinatesAction);
            return;
        } // Get the source client offset
        var sourceClientOffset = null;
        if (clientOffset) {
            if (!getSourceClientOffset) throw new Error('getSourceClientOffset must be defined');
            $f7ee1e170c0f2447$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        } // Initialize the full coordinates
        manager.dispatch((0, $c3344f736956c046$export$844048139dfc906d)(clientOffset, sourceClientOffset));
        var source = registry.getSource(sourceId);
        var item = source.beginDrag(monitor, sourceId); // If source.beginDrag returns null, this is an indicator to cancel the drag
        if (item == null) return undefined;
        $f7ee1e170c0f2447$var$verifyItemIsObject(item);
        registry.pinSource(sourceId);
        var itemType = registry.getSourceType(sourceId);
        return {
            type: (0, $7bb064226b9ca3af$export$98f9b4193e6b55e6),
            payload: {
                itemType: itemType,
                item: item,
                sourceId: sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function $f7ee1e170c0f2447$var$verifyInvariants(sourceIds, monitor, registry) {
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
    sourceIds.forEach(function(sourceId) {
        (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(registry.getSource(sourceId), 'Expected sourceIds to be registered.');
    });
}
function $f7ee1e170c0f2447$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
}
function $f7ee1e170c0f2447$var$verifyItemIsObject(item) {
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)((0, $6d423452009ed580$export$a6cdc56e425d0d0a)(item), 'Item must be an object.');
}
function $f7ee1e170c0f2447$var$getDraggableSource(sourceIds, monitor) {
    var sourceId = null;
    for(var i = sourceIds.length - 1; i >= 0; i--)if (monitor.canDragSource(sourceIds[i])) {
        sourceId = sourceIds[i];
        break;
    }
    return sourceId;
}



function $90aec3a69c1c35e7$export$1675a481db21e714(manager) {
    return function publishDragSource() {
        var monitor = manager.getMonitor();
        if (monitor.isDragging()) return {
            type: (0, $7bb064226b9ca3af$export$22d1d88e2de0d0e0)
        };
    };
}



function $6d448e8fa0b5ef01$export$2d6239ff106f142f(targetType, draggedItemType) {
    if (draggedItemType === null) return targetType === null;
    return Array.isArray(targetType) ? targetType.some(function(t) {
        return t === draggedItemType;
    }) : targetType === draggedItemType;
}



function $242f32391d8e9a74$export$2f85b44a1d72ad03(manager) {
    return function hover(targetIdsArg) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, clientOffset = _ref.clientOffset;
        $242f32391d8e9a74$var$verifyTargetIdsIsArray(targetIdsArg);
        var targetIds = targetIdsArg.slice(0);
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        $242f32391d8e9a74$var$checkInvariants(targetIds, monitor, registry);
        var draggedItemType = monitor.getItemType();
        $242f32391d8e9a74$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        $242f32391d8e9a74$var$hoverAllTargets(targetIds, monitor, registry);
        return {
            type: (0, $7bb064226b9ca3af$export$9d358706ccac3727),
            payload: {
                targetIds: targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function $242f32391d8e9a74$var$verifyTargetIdsIsArray(targetIdsArg) {
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
}
function $242f32391d8e9a74$var$checkInvariants(targetIds, monitor, registry) {
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(monitor.isDragging(), 'Cannot call hover while not dragging.');
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(!monitor.didDrop(), 'Cannot call hover after drop.');
    for(var i = 0; i < targetIds.length; i++){
        var targetId = targetIds[i];
        (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
        var target = registry.getTarget(targetId);
        (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(target, 'Expected targetIds to be registered.');
    }
}
function $242f32391d8e9a74$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(var i = targetIds.length - 1; i >= 0; i--){
        var targetId = targetIds[i];
        var targetType = registry.getTargetType(targetId);
        if (!(0, $6d448e8fa0b5ef01$export$2d6239ff106f142f)(targetType, draggedItemType)) targetIds.splice(i, 1);
    }
}
function $242f32391d8e9a74$var$hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        var target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}





function $d8a5a4a06ab8bc14$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d8a5a4a06ab8bc14$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d8a5a4a06ab8bc14$var$ownKeys(Object(source), true).forEach(function(key) {
            $d8a5a4a06ab8bc14$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d8a5a4a06ab8bc14$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d8a5a4a06ab8bc14$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d8a5a4a06ab8bc14$export$9f5cbae8d079dda0(manager) {
    return function drop() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        $d8a5a4a06ab8bc14$var$verifyInvariants(monitor);
        var targetIds = $d8a5a4a06ab8bc14$var$getDroppableTargets(monitor); // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach(function(targetId, index) {
            var dropResult = $d8a5a4a06ab8bc14$var$determineDropResult(targetId, index, registry, monitor);
            var action = {
                type: (0, $7bb064226b9ca3af$export$b4af72c40fd57063),
                payload: {
                    dropResult: $d8a5a4a06ab8bc14$var$_objectSpread($d8a5a4a06ab8bc14$var$_objectSpread({}, options), dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function $d8a5a4a06ab8bc14$var$verifyInvariants(monitor) {
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(monitor.isDragging(), 'Cannot call drop while not dragging.');
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
}
function $d8a5a4a06ab8bc14$var$determineDropResult(targetId, index, registry, monitor) {
    var target = registry.getTarget(targetId);
    var dropResult = target ? target.drop(monitor, targetId) : undefined;
    $d8a5a4a06ab8bc14$var$verifyDropResultType(dropResult);
    if (typeof dropResult === 'undefined') dropResult = index === 0 ? {} : monitor.getDropResult();
    return dropResult;
}
function $d8a5a4a06ab8bc14$var$verifyDropResultType(dropResult) {
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(typeof dropResult === 'undefined' || (0, $6d423452009ed580$export$a6cdc56e425d0d0a)(dropResult), 'Drop result must either be an object or undefined.');
}
function $d8a5a4a06ab8bc14$var$getDroppableTargets(monitor) {
    var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}




function $3c003b31c57f9955$export$2f5c7d4805260fdf(manager) {
    return function endDrag() {
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        $3c003b31c57f9955$var$verifyIsDragging(monitor);
        var sourceId = monitor.getSourceId();
        if (sourceId != null) {
            var source = registry.getSource(sourceId, true);
            source.endDrag(monitor, sourceId);
            registry.unpinSource();
        }
        return {
            type: (0, $7bb064226b9ca3af$export$d300627d16aeb9cc)
        };
    };
}
function $3c003b31c57f9955$var$verifyIsDragging(monitor) {
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
}



function $6d2dbcdb38ed4bd1$export$ac1b80e79f04247f(manager) {
    return {
        beginDrag: (0, $f7ee1e170c0f2447$export$d6542eb0d76867d6)(manager),
        publishDragSource: (0, $90aec3a69c1c35e7$export$1675a481db21e714)(manager),
        hover: (0, $242f32391d8e9a74$export$2f85b44a1d72ad03)(manager),
        drop: (0, $d8a5a4a06ab8bc14$export$9f5cbae8d079dda0)(manager),
        endDrag: (0, $3c003b31c57f9955$export$2f5c7d4805260fdf)(manager)
    };
}


function $58eddcd9916c9d26$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $58eddcd9916c9d26$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $58eddcd9916c9d26$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $58eddcd9916c9d26$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $58eddcd9916c9d26$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $58eddcd9916c9d26$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $58eddcd9916c9d26$export$1141bbf61324c55f = /*#__PURE__*/ function() {
    function DragDropManagerImpl(store, monitor) {
        var _this = this;
        $58eddcd9916c9d26$var$_classCallCheck(this, DragDropManagerImpl);
        $58eddcd9916c9d26$var$_defineProperty(this, "store", void 0);
        $58eddcd9916c9d26$var$_defineProperty(this, "monitor", void 0);
        $58eddcd9916c9d26$var$_defineProperty(this, "backend", void 0);
        $58eddcd9916c9d26$var$_defineProperty(this, "isSetUp", false);
        $58eddcd9916c9d26$var$_defineProperty(this, "handleRefCountChange", function() {
            var shouldSetUp = _this.store.getState().refCount > 0;
            if (_this.backend) {
                if (shouldSetUp && !_this.isSetUp) {
                    _this.backend.setup();
                    _this.isSetUp = true;
                } else if (!shouldSetUp && _this.isSetUp) {
                    _this.backend.teardown();
                    _this.isSetUp = false;
                }
            }
        });
        this.store = store;
        this.monitor = monitor;
        store.subscribe(this.handleRefCountChange);
    }
    $58eddcd9916c9d26$var$_createClass(DragDropManagerImpl, [
        {
            key: "receiveBackend",
            value: function receiveBackend(backend) {
                this.backend = backend;
            }
        },
        {
            key: "getMonitor",
            value: function getMonitor() {
                return this.monitor;
            }
        },
        {
            key: "getBackend",
            value: function getBackend() {
                return this.backend;
            }
        },
        {
            key: "getRegistry",
            value: function getRegistry() {
                return this.monitor.registry;
            }
        },
        {
            key: "getActions",
            value: function getActions() {
                /* eslint-disable-next-line @typescript-eslint/no-this-alias */ var manager = this;
                var dispatch = this.store.dispatch;
                function bindActionCreator(actionCreator) {
                    return function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        var action = actionCreator.apply(manager, args);
                        if (typeof action !== 'undefined') dispatch(action);
                    };
                }
                var actions = (0, $6d2dbcdb38ed4bd1$export$ac1b80e79f04247f)(this);
                return Object.keys(actions).reduce(function(boundActions, key) {
                    var action = actions[key];
                    boundActions[key] = bindActionCreator(action);
                    return boundActions;
                }, {});
            }
        },
        {
            key: "dispatch",
            value: function dispatch(action) {
                this.store.dispatch(action);
            }
        }
    ]);
    return DragDropManagerImpl;
}();




var $64d44dc6cec3ca85$export$2116cbe61f6a442a = function strictEquality(a, b) {
    return a === b;
};
function $64d44dc6cec3ca85$export$102b20725d4d2263(offsetA, offsetB) {
    if (!offsetA && !offsetB) return true;
    else if (!offsetA || !offsetB) return false;
    else return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
function $64d44dc6cec3ca85$export$94fd53d40f0652a(a, b) {
    var isEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $64d44dc6cec3ca85$export$2116cbe61f6a442a;
    if (a.length !== b.length) return false;
    for(var i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) return false;
    }
    return true;
}


function $2ee49eff91086b78$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2ee49eff91086b78$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2ee49eff91086b78$var$ownKeys(Object(source), true).forEach(function(key) {
            $2ee49eff91086b78$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2ee49eff91086b78$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2ee49eff91086b78$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $2ee49eff91086b78$var$initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function $2ee49eff91086b78$export$533b26079ad0b4b() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $2ee49eff91086b78$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var payload = action.payload;
    switch(action.type){
        case 0, $7bb064226b9ca3af$export$3fc3a33e48b33945:
        case 0, $7bb064226b9ca3af$export$98f9b4193e6b55e6:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case 0, $7bb064226b9ca3af$export$9d358706ccac3727:
            if ((0, $64d44dc6cec3ca85$export$102b20725d4d2263)(state.clientOffset, payload.clientOffset)) return state;
            return $2ee49eff91086b78$var$_objectSpread($2ee49eff91086b78$var$_objectSpread({}, state), {}, {
                clientOffset: payload.clientOffset
            });
        case 0, $7bb064226b9ca3af$export$d300627d16aeb9cc:
        case 0, $7bb064226b9ca3af$export$b4af72c40fd57063:
            return $2ee49eff91086b78$var$initialState;
        default:
            return state;
    }
}



var $0eb077a2dbafe62f$export$b36933c81fb1c092 = 'dnd-core/ADD_SOURCE';
var $0eb077a2dbafe62f$export$2c313542981556ae = 'dnd-core/ADD_TARGET';
var $0eb077a2dbafe62f$export$13332566b98b8783 = 'dnd-core/REMOVE_SOURCE';
var $0eb077a2dbafe62f$export$82ace346d17d8869 = 'dnd-core/REMOVE_TARGET';
function $0eb077a2dbafe62f$export$bc333c64f07a75c4(sourceId) {
    return {
        type: $0eb077a2dbafe62f$export$b36933c81fb1c092,
        payload: {
            sourceId: sourceId
        }
    };
}
function $0eb077a2dbafe62f$export$9dd68fe78f37278b(targetId) {
    return {
        type: $0eb077a2dbafe62f$export$2c313542981556ae,
        payload: {
            targetId: targetId
        }
    };
}
function $0eb077a2dbafe62f$export$c724aacd61334138(sourceId) {
    return {
        type: $0eb077a2dbafe62f$export$13332566b98b8783,
        payload: {
            sourceId: sourceId
        }
    };
}
function $0eb077a2dbafe62f$export$20ae7ec87f7f8696(targetId) {
    return {
        type: $0eb077a2dbafe62f$export$82ace346d17d8869,
        payload: {
            targetId: targetId
        }
    };
}



function $d9fd3b06cbc36f43$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d9fd3b06cbc36f43$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d9fd3b06cbc36f43$var$ownKeys(Object(source), true).forEach(function(key) {
            $d9fd3b06cbc36f43$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d9fd3b06cbc36f43$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d9fd3b06cbc36f43$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d9fd3b06cbc36f43$var$initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function $d9fd3b06cbc36f43$export$533b26079ad0b4b() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $d9fd3b06cbc36f43$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var payload = action.payload;
    switch(action.type){
        case 0, $7bb064226b9ca3af$export$98f9b4193e6b55e6:
            return $d9fd3b06cbc36f43$var$_objectSpread($d9fd3b06cbc36f43$var$_objectSpread({}, state), {}, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case 0, $7bb064226b9ca3af$export$22d1d88e2de0d0e0:
            return $d9fd3b06cbc36f43$var$_objectSpread($d9fd3b06cbc36f43$var$_objectSpread({}, state), {}, {
                isSourcePublic: true
            });
        case 0, $7bb064226b9ca3af$export$9d358706ccac3727:
            return $d9fd3b06cbc36f43$var$_objectSpread($d9fd3b06cbc36f43$var$_objectSpread({}, state), {}, {
                targetIds: payload.targetIds
            });
        case 0, $0eb077a2dbafe62f$export$82ace346d17d8869:
            if (state.targetIds.indexOf(payload.targetId) === -1) return state;
            return $d9fd3b06cbc36f43$var$_objectSpread($d9fd3b06cbc36f43$var$_objectSpread({}, state), {}, {
                targetIds: (0, $6d423452009ed580$export$5d14bf425b37f49e)(state.targetIds, payload.targetId)
            });
        case 0, $7bb064226b9ca3af$export$b4af72c40fd57063:
            return $d9fd3b06cbc36f43$var$_objectSpread($d9fd3b06cbc36f43$var$_objectSpread({}, state), {}, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case 0, $7bb064226b9ca3af$export$d300627d16aeb9cc:
            return $d9fd3b06cbc36f43$var$_objectSpread($d9fd3b06cbc36f43$var$_objectSpread({}, state), {}, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}



function $dfab1ba20747acc5$export$533b26079ad0b4b() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $0eb077a2dbafe62f$export$b36933c81fb1c092:
        case 0, $0eb077a2dbafe62f$export$2c313542981556ae:
            return state + 1;
        case 0, $0eb077a2dbafe62f$export$13332566b98b8783:
        case 0, $0eb077a2dbafe62f$export$82ace346d17d8869:
            return state - 1;
        default:
            return state;
    }
}






var $d8325997fe901481$export$c53d0f541b41b88e = [];
var $d8325997fe901481$export$61b49a5ae59d663 = [];
$d8325997fe901481$export$c53d0f541b41b88e.__IS_NONE__ = true;
$d8325997fe901481$export$61b49a5ae59d663.__IS_ALL__ = true;
function $d8325997fe901481$export$3347776eeed47180(dirtyIds, handlerIds) {
    if (dirtyIds === $d8325997fe901481$export$c53d0f541b41b88e) return false;
    if (dirtyIds === $d8325997fe901481$export$61b49a5ae59d663 || typeof handlerIds === 'undefined') return true;
    var commonIds = (0, $6d423452009ed580$export$bc86dfbf7795668c)(handlerIds, dirtyIds);
    return commonIds.length > 0;
}



function $44bafa8869c22912$export$533b26079ad0b4b() {
    var _state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $d8325997fe901481$export$c53d0f541b41b88e);
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $7bb064226b9ca3af$export$9d358706ccac3727:
            break;
        case 0, $0eb077a2dbafe62f$export$b36933c81fb1c092:
        case 0, $0eb077a2dbafe62f$export$2c313542981556ae:
        case 0, $0eb077a2dbafe62f$export$82ace346d17d8869:
        case 0, $0eb077a2dbafe62f$export$13332566b98b8783:
            return 0, $d8325997fe901481$export$c53d0f541b41b88e;
        case 0, $7bb064226b9ca3af$export$98f9b4193e6b55e6:
        case 0, $7bb064226b9ca3af$export$22d1d88e2de0d0e0:
        case 0, $7bb064226b9ca3af$export$d300627d16aeb9cc:
        case 0, $7bb064226b9ca3af$export$b4af72c40fd57063:
        default:
            return 0, $d8325997fe901481$export$61b49a5ae59d663;
    }
    var _action$payload = action.payload, _action$payload$targe = _action$payload.targetIds, targetIds = _action$payload$targe === void 0 ? [] : _action$payload$targe, _action$payload$prevT = _action$payload.prevTargetIds, prevTargetIds = _action$payload$prevT === void 0 ? [] : _action$payload$prevT;
    var result = (0, $6d423452009ed580$export$6444ef5cd411280c)(targetIds, prevTargetIds);
    var didChange = result.length > 0 || !(0, $64d44dc6cec3ca85$export$94fd53d40f0652a)(targetIds, prevTargetIds);
    if (!didChange) return 0, $d8325997fe901481$export$c53d0f541b41b88e;
     // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    var innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}


function $417bd7787cd883f6$export$533b26079ad0b4b() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return state + 1;
}



function $ed886b6f3fa6c9f4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ed886b6f3fa6c9f4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ed886b6f3fa6c9f4$var$ownKeys(Object(source), true).forEach(function(key) {
            $ed886b6f3fa6c9f4$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ed886b6f3fa6c9f4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ed886b6f3fa6c9f4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ed886b6f3fa6c9f4$export$533b26079ad0b4b() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    return {
        dirtyHandlerIds: (0, $44bafa8869c22912$export$533b26079ad0b4b)(state.dirtyHandlerIds, {
            type: action.type,
            payload: $ed886b6f3fa6c9f4$var$_objectSpread($ed886b6f3fa6c9f4$var$_objectSpread({}, action.payload), {}, {
                prevTargetIds: (0, $6d423452009ed580$export$3988ae62b71be9a3)(state, 'dragOperation.targetIds', [])
            })
        }),
        dragOffset: (0, $2ee49eff91086b78$export$533b26079ad0b4b)(state.dragOffset, action),
        refCount: (0, $dfab1ba20747acc5$export$533b26079ad0b4b)(state.refCount, action),
        dragOperation: (0, $d9fd3b06cbc36f43$export$533b26079ad0b4b)(state.dragOperation, action),
        stateId: (0, $417bd7787cd883f6$export$533b26079ad0b4b)(state.stateId)
    };
}




/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ function $628055f075b3289e$export$e16d8520af44a096(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
function $628055f075b3289e$export$4e2d2ead65e5f7e3(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $628055f075b3289e$export$b6a5970fca17c71e(state) {
    var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset, initialSourceClientOffset = state.initialSourceClientOffset;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return $628055f075b3289e$export$4e2d2ead65e5f7e3($628055f075b3289e$export$e16d8520af44a096(clientOffset, initialSourceClientOffset), initialClientOffset);
}
function $628055f075b3289e$export$b57ee1a41eb1620b(state) {
    var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset;
    if (!clientOffset || !initialClientOffset) return null;
    return $628055f075b3289e$export$4e2d2ead65e5f7e3(clientOffset, initialClientOffset);
}



function $bf8ddd5b31af44ab$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bf8ddd5b31af44ab$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bf8ddd5b31af44ab$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bf8ddd5b31af44ab$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bf8ddd5b31af44ab$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $bf8ddd5b31af44ab$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $bf8ddd5b31af44ab$export$e220263e518daaed = /*#__PURE__*/ function() {
    function DragDropMonitorImpl(store, registry) {
        $bf8ddd5b31af44ab$var$_classCallCheck(this, DragDropMonitorImpl);
        $bf8ddd5b31af44ab$var$_defineProperty(this, "store", void 0);
        $bf8ddd5b31af44ab$var$_defineProperty(this, "registry", void 0);
        this.store = store;
        this.registry = registry;
    }
    $bf8ddd5b31af44ab$var$_createClass(DragDropMonitorImpl, [
        {
            key: "subscribeToStateChange",
            value: function subscribeToStateChange(listener) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    handlerIds: undefined
                };
                var handlerIds = options.handlerIds;
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(typeof listener === 'function', 'listener must be a function.');
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
                var prevStateId = this.store.getState().stateId;
                var handleChange = function handleChange() {
                    var state = _this.store.getState();
                    var currentStateId = state.stateId;
                    try {
                        var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, $d8325997fe901481$export$3347776eeed47180)(state.dirtyHandlerIds, handlerIds);
                        if (!canSkipListener) listener();
                    } finally{
                        prevStateId = currentStateId;
                    }
                };
                return this.store.subscribe(handleChange);
            }
        },
        {
            key: "subscribeToOffsetChange",
            value: function subscribeToOffsetChange(listener) {
                var _this2 = this;
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(typeof listener === 'function', 'listener must be a function.');
                var previousState = this.store.getState().dragOffset;
                var handleChange = function handleChange() {
                    var nextState = _this2.store.getState().dragOffset;
                    if (nextState === previousState) return;
                    previousState = nextState;
                    listener();
                };
                return this.store.subscribe(handleChange);
            }
        },
        {
            key: "canDragSource",
            value: function canDragSource(sourceId) {
                if (!sourceId) return false;
                var source = this.registry.getSource(sourceId);
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(source, "Expected to find a valid source. sourceId=".concat(sourceId));
                if (this.isDragging()) return false;
                return source.canDrag(this, sourceId);
            }
        },
        {
            key: "canDropOnTarget",
            value: function canDropOnTarget(targetId) {
                // undefined on initial render
                if (!targetId) return false;
                var target = this.registry.getTarget(targetId);
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(target, "Expected to find a valid target. targetId=".concat(targetId));
                if (!this.isDragging() || this.didDrop()) return false;
                var targetType = this.registry.getTargetType(targetId);
                var draggedItemType = this.getItemType();
                return (0, $6d448e8fa0b5ef01$export$2d6239ff106f142f)(targetType, draggedItemType) && target.canDrop(this, targetId);
            }
        },
        {
            key: "isDragging",
            value: function isDragging() {
                return Boolean(this.getItemType());
            }
        },
        {
            key: "isDraggingSource",
            value: function isDraggingSource(sourceId) {
                // undefined on initial render
                if (!sourceId) return false;
                var source = this.registry.getSource(sourceId, true);
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(source, "Expected to find a valid source. sourceId=".concat(sourceId));
                if (!this.isDragging() || !this.isSourcePublic()) return false;
                var sourceType = this.registry.getSourceType(sourceId);
                var draggedItemType = this.getItemType();
                if (sourceType !== draggedItemType) return false;
                return source.isDragging(this, sourceId);
            }
        },
        {
            key: "isOverTarget",
            value: function isOverTarget(targetId) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    shallow: false
                };
                // undefined on initial render
                if (!targetId) return false;
                var shallow = options.shallow;
                if (!this.isDragging()) return false;
                var targetType = this.registry.getTargetType(targetId);
                var draggedItemType = this.getItemType();
                if (draggedItemType && !(0, $6d448e8fa0b5ef01$export$2d6239ff106f142f)(targetType, draggedItemType)) return false;
                var targetIds = this.getTargetIds();
                if (!targetIds.length) return false;
                var index = targetIds.indexOf(targetId);
                if (shallow) return index === targetIds.length - 1;
                else return index > -1;
            }
        },
        {
            key: "getItemType",
            value: function getItemType() {
                return this.store.getState().dragOperation.itemType;
            }
        },
        {
            key: "getItem",
            value: function getItem() {
                return this.store.getState().dragOperation.item;
            }
        },
        {
            key: "getSourceId",
            value: function getSourceId() {
                return this.store.getState().dragOperation.sourceId;
            }
        },
        {
            key: "getTargetIds",
            value: function getTargetIds() {
                return this.store.getState().dragOperation.targetIds;
            }
        },
        {
            key: "getDropResult",
            value: function getDropResult() {
                return this.store.getState().dragOperation.dropResult;
            }
        },
        {
            key: "didDrop",
            value: function didDrop() {
                return this.store.getState().dragOperation.didDrop;
            }
        },
        {
            key: "isSourcePublic",
            value: function isSourcePublic() {
                return Boolean(this.store.getState().dragOperation.isSourcePublic);
            }
        },
        {
            key: "getInitialClientOffset",
            value: function getInitialClientOffset() {
                return this.store.getState().dragOffset.initialClientOffset;
            }
        },
        {
            key: "getInitialSourceClientOffset",
            value: function getInitialSourceClientOffset() {
                return this.store.getState().dragOffset.initialSourceClientOffset;
            }
        },
        {
            key: "getClientOffset",
            value: function getClientOffset() {
                return this.store.getState().dragOffset.clientOffset;
            }
        },
        {
            key: "getSourceClientOffset",
            value: function getSourceClientOffset() {
                return (0, $628055f075b3289e$export$b6a5970fca17c71e)(this.store.getState().dragOffset);
            }
        },
        {
            key: "getDifferenceFromInitialOffset",
            value: function getDifferenceFromInitialOffset() {
                return (0, $628055f075b3289e$export$b57ee1a41eb1620b)(this.store.getState().dragOffset);
            }
        }
    ]);
    return DragDropMonitorImpl;
}();




var $ece36d76c09e0c5c$var$nextUniqueId = 0;
function $ece36d76c09e0c5c$export$dbfb29c8f2c7bb44() {
    return $ece36d76c09e0c5c$var$nextUniqueId++;
}


var $21562239b772dc63$export$bb8f0843d7d66cb0;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})($21562239b772dc63$export$bb8f0843d7d66cb0 || ($21562239b772dc63$export$bb8f0843d7d66cb0 = {}));



function $58b4e20a27ea3dfc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $58b4e20a27ea3dfc$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $58b4e20a27ea3dfc$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $58b4e20a27ea3dfc$var$_typeof(obj);
}
function $58b4e20a27ea3dfc$export$a7a13c013ce18993(source) {
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
function $58b4e20a27ea3dfc$export$77d3cd1340fdeb5a(target) {
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(typeof target.hover === 'function', 'Expected hover to be a function.');
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
function $58b4e20a27ea3dfc$export$831a593efd22380d(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach(function(t) {
            return $58b4e20a27ea3dfc$export$831a593efd22380d(t, false);
        });
        return;
    }
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(typeof type === 'string' || $58b4e20a27ea3dfc$var$_typeof(type) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}


var $1b6a3b213d723c1c$exports = {};
"use strict";
Object.defineProperty($1b6a3b213d723c1c$exports, "__esModule", {
    value: true
});
var $1b6a3b213d723c1c$var$_exportNames = {};

var $1b6a3b213d723c1c$var$_asapJs = $1b6a3b213d723c1c$var$_interopRequireWildcard((parcelRequire("f1EGP")));
Object.keys($1b6a3b213d723c1c$var$_asapJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1b6a3b213d723c1c$var$_exportNames, key)) return;
    if (key in $1b6a3b213d723c1c$exports && $1b6a3b213d723c1c$exports[key] === $1b6a3b213d723c1c$var$_asapJs[key]) return;
    Object.defineProperty($1b6a3b213d723c1c$exports, key, {
        enumerable: true,
        get: function() {
            return $1b6a3b213d723c1c$var$_asapJs[key];
        }
    });
});

var $1b6a3b213d723c1c$var$_typesJs = $1b6a3b213d723c1c$var$_interopRequireWildcard((parcelRequire("4W5kO")));
Object.keys($1b6a3b213d723c1c$var$_typesJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1b6a3b213d723c1c$var$_exportNames, key)) return;
    if (key in $1b6a3b213d723c1c$exports && $1b6a3b213d723c1c$exports[key] === $1b6a3b213d723c1c$var$_typesJs[key]) return;
    Object.defineProperty($1b6a3b213d723c1c$exports, key, {
        enumerable: true,
        get: function() {
            return $1b6a3b213d723c1c$var$_typesJs[key];
        }
    });
});

var $1b6a3b213d723c1c$var$_asapQueueJs = $1b6a3b213d723c1c$var$_interopRequireWildcard((parcelRequire("jQnu6")));
Object.keys($1b6a3b213d723c1c$var$_asapQueueJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1b6a3b213d723c1c$var$_exportNames, key)) return;
    if (key in $1b6a3b213d723c1c$exports && $1b6a3b213d723c1c$exports[key] === $1b6a3b213d723c1c$var$_asapQueueJs[key]) return;
    Object.defineProperty($1b6a3b213d723c1c$exports, key, {
        enumerable: true,
        get: function() {
            return $1b6a3b213d723c1c$var$_asapQueueJs[key];
        }
    });
});

var $1b6a3b213d723c1c$var$_taskFactoryJs = $1b6a3b213d723c1c$var$_interopRequireWildcard((parcelRequire("97DTJ")));
Object.keys($1b6a3b213d723c1c$var$_taskFactoryJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1b6a3b213d723c1c$var$_exportNames, key)) return;
    if (key in $1b6a3b213d723c1c$exports && $1b6a3b213d723c1c$exports[key] === $1b6a3b213d723c1c$var$_taskFactoryJs[key]) return;
    Object.defineProperty($1b6a3b213d723c1c$exports, key, {
        enumerable: true,
        get: function() {
            return $1b6a3b213d723c1c$var$_taskFactoryJs[key];
        }
    });
});
function $1b6a3b213d723c1c$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}


function $1a7ef15dc5a67a67$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1a7ef15dc5a67a67$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1a7ef15dc5a67a67$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1a7ef15dc5a67a67$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1a7ef15dc5a67a67$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1a7ef15dc5a67a67$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1a7ef15dc5a67a67$var$_slicedToArray(arr, i) {
    return $1a7ef15dc5a67a67$var$_arrayWithHoles(arr) || $1a7ef15dc5a67a67$var$_iterableToArrayLimit(arr, i) || $1a7ef15dc5a67a67$var$_unsupportedIterableToArray(arr, i) || $1a7ef15dc5a67a67$var$_nonIterableRest();
}
function $1a7ef15dc5a67a67$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1a7ef15dc5a67a67$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1a7ef15dc5a67a67$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1a7ef15dc5a67a67$var$_arrayLikeToArray(o, minLen);
}
function $1a7ef15dc5a67a67$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1a7ef15dc5a67a67$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1a7ef15dc5a67a67$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1a7ef15dc5a67a67$var$getNextHandlerId(role) {
    var id = (0, $ece36d76c09e0c5c$export$dbfb29c8f2c7bb44)().toString();
    switch(role){
        case (0, $21562239b772dc63$export$bb8f0843d7d66cb0).SOURCE:
            return "S".concat(id);
        case (0, $21562239b772dc63$export$bb8f0843d7d66cb0).TARGET:
            return "T".concat(id);
        default:
            throw new Error("Unknown Handler Role: ".concat(role));
    }
}
function $1a7ef15dc5a67a67$var$parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case 'S':
            return (0, $21562239b772dc63$export$bb8f0843d7d66cb0).SOURCE;
        case 'T':
            return (0, $21562239b772dc63$export$bb8f0843d7d66cb0).TARGET;
        default:
            (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(false, "Cannot parse handler ID: ".concat(handlerId));
    }
}
function $1a7ef15dc5a67a67$var$mapContainsValue(map, searchValue) {
    var entries = map.entries();
    var isDone = false;
    do {
        var _entries$next = entries.next(), done = _entries$next.done, _entries$next$value = $1a7ef15dc5a67a67$var$_slicedToArray(_entries$next.value, 2), value = _entries$next$value[1];
        if (value === searchValue) return true;
        isDone = !!done;
    }while (!isDone);
    return false;
}
var $1a7ef15dc5a67a67$export$60ceab237232d5db = /*#__PURE__*/ function() {
    function HandlerRegistryImpl(store) {
        $1a7ef15dc5a67a67$var$_classCallCheck(this, HandlerRegistryImpl);
        $1a7ef15dc5a67a67$var$_defineProperty(this, "types", new Map());
        $1a7ef15dc5a67a67$var$_defineProperty(this, "dragSources", new Map());
        $1a7ef15dc5a67a67$var$_defineProperty(this, "dropTargets", new Map());
        $1a7ef15dc5a67a67$var$_defineProperty(this, "pinnedSourceId", null);
        $1a7ef15dc5a67a67$var$_defineProperty(this, "pinnedSource", null);
        $1a7ef15dc5a67a67$var$_defineProperty(this, "store", void 0);
        this.store = store;
    }
    $1a7ef15dc5a67a67$var$_createClass(HandlerRegistryImpl, [
        {
            key: "addSource",
            value: function addSource(type, source) {
                (0, $58b4e20a27ea3dfc$export$831a593efd22380d)(type);
                (0, $58b4e20a27ea3dfc$export$a7a13c013ce18993)(source);
                var sourceId = this.addHandler((0, $21562239b772dc63$export$bb8f0843d7d66cb0).SOURCE, type, source);
                this.store.dispatch((0, $0eb077a2dbafe62f$export$bc333c64f07a75c4)(sourceId));
                return sourceId;
            }
        },
        {
            key: "addTarget",
            value: function addTarget(type, target) {
                (0, $58b4e20a27ea3dfc$export$831a593efd22380d)(type, true);
                (0, $58b4e20a27ea3dfc$export$77d3cd1340fdeb5a)(target);
                var targetId = this.addHandler((0, $21562239b772dc63$export$bb8f0843d7d66cb0).TARGET, type, target);
                this.store.dispatch((0, $0eb077a2dbafe62f$export$9dd68fe78f37278b)(targetId));
                return targetId;
            }
        },
        {
            key: "containsHandler",
            value: function containsHandler(handler) {
                return $1a7ef15dc5a67a67$var$mapContainsValue(this.dragSources, handler) || $1a7ef15dc5a67a67$var$mapContainsValue(this.dropTargets, handler);
            }
        },
        {
            key: "getSource",
            value: function getSource(sourceId) {
                var includePinned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(this.isSourceId(sourceId), 'Expected a valid source ID.');
                var isPinned = includePinned && sourceId === this.pinnedSourceId;
                var source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
                return source;
            }
        },
        {
            key: "getTarget",
            value: function getTarget(targetId) {
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(this.isTargetId(targetId), 'Expected a valid target ID.');
                return this.dropTargets.get(targetId);
            }
        },
        {
            key: "getSourceType",
            value: function getSourceType(sourceId) {
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(this.isSourceId(sourceId), 'Expected a valid source ID.');
                return this.types.get(sourceId);
            }
        },
        {
            key: "getTargetType",
            value: function getTargetType(targetId) {
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(this.isTargetId(targetId), 'Expected a valid target ID.');
                return this.types.get(targetId);
            }
        },
        {
            key: "isSourceId",
            value: function isSourceId(handlerId) {
                var role = $1a7ef15dc5a67a67$var$parseRoleFromHandlerId(handlerId);
                return role === (0, $21562239b772dc63$export$bb8f0843d7d66cb0).SOURCE;
            }
        },
        {
            key: "isTargetId",
            value: function isTargetId(handlerId) {
                var role = $1a7ef15dc5a67a67$var$parseRoleFromHandlerId(handlerId);
                return role === (0, $21562239b772dc63$export$bb8f0843d7d66cb0).TARGET;
            }
        },
        {
            key: "removeSource",
            value: function removeSource(sourceId) {
                var _this = this;
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(this.getSource(sourceId), 'Expected an existing source.');
                this.store.dispatch((0, $0eb077a2dbafe62f$export$c724aacd61334138)(sourceId));
                (0, $1b6a3b213d723c1c$exports.asap)(function() {
                    _this.dragSources.delete(sourceId);
                    _this.types.delete(sourceId);
                });
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(targetId) {
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(this.getTarget(targetId), 'Expected an existing target.');
                this.store.dispatch((0, $0eb077a2dbafe62f$export$20ae7ec87f7f8696)(targetId));
                this.dropTargets.delete(targetId);
                this.types.delete(targetId);
            }
        },
        {
            key: "pinSource",
            value: function pinSource(sourceId) {
                var source = this.getSource(sourceId);
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(source, 'Expected an existing source.');
                this.pinnedSourceId = sourceId;
                this.pinnedSource = source;
            }
        },
        {
            key: "unpinSource",
            value: function unpinSource() {
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(this.pinnedSource, 'No source is pinned at the time.');
                this.pinnedSourceId = null;
                this.pinnedSource = null;
            }
        },
        {
            key: "addHandler",
            value: function addHandler(role, type, handler) {
                var id = $1a7ef15dc5a67a67$var$getNextHandlerId(role);
                this.types.set(id, type);
                if (role === (0, $21562239b772dc63$export$bb8f0843d7d66cb0).SOURCE) this.dragSources.set(id, handler);
                else if (role === (0, $21562239b772dc63$export$bb8f0843d7d66cb0).TARGET) this.dropTargets.set(id, handler);
                return id;
            }
        }
    ]);
    return HandlerRegistryImpl;
}();


function $5c76515ff81d4412$export$ff47aa43d5fd3e5d(backendFactory) {
    var globalContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var backendOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var debugMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var store = $5c76515ff81d4412$var$makeStoreInstance(debugMode);
    var monitor = new (0, $bf8ddd5b31af44ab$export$e220263e518daaed)(store, new (0, $1a7ef15dc5a67a67$export$60ceab237232d5db)(store));
    var manager = new (0, $58eddcd9916c9d26$export$1141bbf61324c55f)(store, monitor);
    var backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}
function $5c76515ff81d4412$var$makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    var reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
    return (0, $e0db014f981f40cf$export$f51a9068ac82ea43)((0, $ed886b6f3fa6c9f4$export$533b26079ad0b4b), debugMode && reduxDevTools && reduxDevTools({
        name: 'dnd-core',
        instanceId: 'dnd-core'
    }));
}



var $6fFrj = parcelRequire("6fFrj");
var $296e86319c262fd8$export$2d5c5ceac203fc1e = (0, $6fFrj.createContext)({
    dragDropManager: undefined
});


var $0fe3e251a617b179$var$_excluded = [
    "children"
];
function $0fe3e251a617b179$var$_slicedToArray(arr, i) {
    return $0fe3e251a617b179$var$_arrayWithHoles(arr) || $0fe3e251a617b179$var$_iterableToArrayLimit(arr, i) || $0fe3e251a617b179$var$_unsupportedIterableToArray(arr, i) || $0fe3e251a617b179$var$_nonIterableRest();
}
function $0fe3e251a617b179$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0fe3e251a617b179$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0fe3e251a617b179$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0fe3e251a617b179$var$_arrayLikeToArray(o, minLen);
}
function $0fe3e251a617b179$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0fe3e251a617b179$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $0fe3e251a617b179$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0fe3e251a617b179$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0fe3e251a617b179$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0fe3e251a617b179$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0fe3e251a617b179$var$refCount = 0;
var $0fe3e251a617b179$var$INSTANCE_SYM = Symbol.for('__REACT_DND_CONTEXT_INSTANCE__');
var $0fe3e251a617b179$export$9861489d68213f9c = (0, $6fFrj.memo)(function DndProvider(_ref) {
    var children = _ref.children, props = $0fe3e251a617b179$var$_objectWithoutProperties(_ref, $0fe3e251a617b179$var$_excluded);
    var _getDndContextValue = $0fe3e251a617b179$var$getDndContextValue(props), _getDndContextValue2 = $0fe3e251a617b179$var$_slicedToArray(_getDndContextValue, 2), manager = _getDndContextValue2[0], isGlobalInstance = _getDndContextValue2[1]; // memoized from props
    /**
   * If the global context was used to store the DND context
   * then where theres no more references to it we should
   * clean it up to avoid memory leaks
   */ (0, $6fFrj.useEffect)(function() {
        if (isGlobalInstance) {
            var context = $0fe3e251a617b179$var$getGlobalContext();
            ++$0fe3e251a617b179$var$refCount;
            return function() {
                if (--$0fe3e251a617b179$var$refCount === 0) context[$0fe3e251a617b179$var$INSTANCE_SYM] = null;
            };
        }
    }, []);
    return (0, $bb3TF.jsx)((0, $296e86319c262fd8$export$2d5c5ceac203fc1e).Provider, Object.assign({
        value: manager
    }, {
        children: children
    }), void 0);
});
function $0fe3e251a617b179$var$getDndContextValue(props) {
    if ('manager' in props) {
        var _manager = {
            dragDropManager: props.manager
        };
        return [
            _manager,
            false
        ];
    }
    var manager = $0fe3e251a617b179$var$createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    var isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
function $0fe3e251a617b179$var$createSingletonDndContext(backend) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0fe3e251a617b179$var$getGlobalContext();
    var options = arguments.length > 2 ? arguments[2] : undefined;
    var debugMode = arguments.length > 3 ? arguments[3] : undefined;
    var ctx = context;
    if (!ctx[$0fe3e251a617b179$var$INSTANCE_SYM]) ctx[$0fe3e251a617b179$var$INSTANCE_SYM] = {
        dragDropManager: (0, $5c76515ff81d4412$export$ff47aa43d5fd3e5d)(backend, context, options, debugMode)
    };
    return ctx[$0fe3e251a617b179$var$INSTANCE_SYM];
}
function $0fe3e251a617b179$var$getGlobalContext() {
    return typeof $parcel$global !== 'undefined' ? $parcel$global : window;
}


// cheap lodash replacements
function $b58362bde7d84b4c$export$fc10aeed3a532e2a(fn) {
    var result = null;
    var memoized = function memoized() {
        if (result == null) result = fn();
        return result;
    };
    return memoized;
}
function $b58362bde7d84b4c$export$5d14bf425b37f49e(items, item) {
    return items.filter(function(i) {
        return i !== item;
    });
}
function $b58362bde7d84b4c$export$971dd5b0dfd021b6(itemsA, itemsB) {
    var set = new Set();
    var insertItem = function insertItem(item) {
        return set.add(item);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    var result = [];
    set.forEach(function(key) {
        return result.push(key);
    });
    return result;
}


function $6b6a33bc0421ede3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6b6a33bc0421ede3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6b6a33bc0421ede3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6b6a33bc0421ede3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6b6a33bc0421ede3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6b6a33bc0421ede3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6b6a33bc0421ede3$export$9ff3e6eb5c734d0d = /*#__PURE__*/ function() {
    function EnterLeaveCounter(isNodeInDocument) {
        $6b6a33bc0421ede3$var$_classCallCheck(this, EnterLeaveCounter);
        $6b6a33bc0421ede3$var$_defineProperty(this, "entered", []);
        $6b6a33bc0421ede3$var$_defineProperty(this, "isNodeInDocument", void 0);
        this.isNodeInDocument = isNodeInDocument;
    }
    $6b6a33bc0421ede3$var$_createClass(EnterLeaveCounter, [
        {
            key: "enter",
            value: function enter(enteringNode) {
                var _this = this;
                var previousLength = this.entered.length;
                var isNodeEntered = function isNodeEntered(node) {
                    return _this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
                };
                this.entered = (0, $b58362bde7d84b4c$export$971dd5b0dfd021b6)(this.entered.filter(isNodeEntered), [
                    enteringNode
                ]);
                return previousLength === 0 && this.entered.length > 0;
            }
        },
        {
            key: "leave",
            value: function leave(leavingNode) {
                var previousLength = this.entered.length;
                this.entered = (0, $b58362bde7d84b4c$export$5d14bf425b37f49e)(this.entered.filter(this.isNodeInDocument), leavingNode);
                return previousLength > 0 && this.entered.length === 0;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.entered = [];
            }
        }
    ]);
    return EnterLeaveCounter;
}();



var $aa424e6836d89f3c$export$b7d78993b74f766d = (0, $b58362bde7d84b4c$export$fc10aeed3a532e2a)(function() {
    return /firefox/i.test(navigator.userAgent);
});
var $aa424e6836d89f3c$export$95df08bae54cb4df = (0, $b58362bde7d84b4c$export$fc10aeed3a532e2a)(function() {
    return Boolean(window.safari);
});


function $8331e2c6b91c17dd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8331e2c6b91c17dd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8331e2c6b91c17dd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8331e2c6b91c17dd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8331e2c6b91c17dd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8331e2c6b91c17dd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $8331e2c6b91c17dd$export$6d87c156c5199b02 = /*#__PURE__*/ function() {
    function MonotonicInterpolant(xs, ys) {
        $8331e2c6b91c17dd$var$_classCallCheck(this, MonotonicInterpolant);
        $8331e2c6b91c17dd$var$_defineProperty(this, "xs", void 0);
        $8331e2c6b91c17dd$var$_defineProperty(this, "ys", void 0);
        $8331e2c6b91c17dd$var$_defineProperty(this, "c1s", void 0);
        $8331e2c6b91c17dd$var$_defineProperty(this, "c2s", void 0);
        $8331e2c6b91c17dd$var$_defineProperty(this, "c3s", void 0);
        var length = xs.length; // Rearrange xs and ys so that xs is sorted
        var indexes = [];
        for(var i = 0; i < length; i++)indexes.push(i);
        indexes.sort(function(a, b) {
            return xs[a] < xs[b] ? -1 : 1;
        }); // Get consecutive differences and slopes
        var dys = [];
        var dxs = [];
        var ms = [];
        var dx;
        var dy;
        for(var _i = 0; _i < length - 1; _i++){
            dx = xs[_i + 1] - xs[_i];
            dy = ys[_i + 1] - ys[_i];
            dxs.push(dx);
            dys.push(dy);
            ms.push(dy / dx);
        } // Get degree-1 coefficients
        var c1s = [
            ms[0]
        ];
        for(var _i2 = 0; _i2 < dxs.length - 1; _i2++){
            var m2 = ms[_i2];
            var mNext = ms[_i2 + 1];
            if (m2 * mNext <= 0) c1s.push(0);
            else {
                dx = dxs[_i2];
                var dxNext = dxs[_i2 + 1];
                var common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]); // Get degree-2 and degree-3 coefficients
        var c2s = [];
        var c3s = [];
        var m;
        for(var _i3 = 0; _i3 < c1s.length - 1; _i3++){
            m = ms[_i3];
            var c1 = c1s[_i3];
            var invDx = 1 / dxs[_i3];
            var _common = c1 + c1s[_i3 + 1] - m - m;
            c2s.push((m - c1 - _common) * invDx);
            c3s.push(_common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
    $8331e2c6b91c17dd$var$_createClass(MonotonicInterpolant, [
        {
            key: "interpolate",
            value: function interpolate(x) {
                var xs = this.xs, ys = this.ys, c1s = this.c1s, c2s = this.c2s, c3s = this.c3s; // The rightmost point in the dataset should give an exact result
                var i = xs.length - 1;
                if (x === xs[i]) return ys[i];
                 // Search for the interval x is in, returning the corresponding y if x is one of the original xs
                var low = 0;
                var high = c3s.length - 1;
                var mid;
                while(low <= high){
                    mid = Math.floor(0.5 * (low + high));
                    var xHere = xs[mid];
                    if (xHere < x) low = mid + 1;
                    else if (xHere > x) high = mid - 1;
                    else return ys[mid];
                }
                i = Math.max(0, high); // Interpolate
                var diff = x - xs[i];
                var diffSq = diff * diff;
                return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
            }
        }
    ]);
    return MonotonicInterpolant;
}();


var $0c53f1948fe564b9$var$ELEMENT_NODE = 1;
function $0c53f1948fe564b9$export$8419e8612027b1d8(node) {
    var el = node.nodeType === $0c53f1948fe564b9$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return null;
    var _el$getBoundingClient = el.getBoundingClientRect(), top = _el$getBoundingClient.top, left = _el$getBoundingClient.left;
    return {
        x: left,
        y: top
    };
}
function $0c53f1948fe564b9$export$710c829989c68339(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function $0c53f1948fe564b9$var$isImageNode(node) {
    var _document$documentEle;
    return node.nodeName === 'IMG' && ((0, $aa424e6836d89f3c$export$b7d78993b74f766d)() || !((_document$documentEle = document.documentElement) !== null && _document$documentEle !== void 0 && _document$documentEle.contains(node)));
}
function $0c53f1948fe564b9$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight; // Work around @2x coordinate discrepancies in browsers
    if ((0, $aa424e6836d89f3c$export$95df08bae54cb4df)() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth: dragPreviewWidth,
        dragPreviewHeight: dragPreviewHeight
    };
}
function $0c53f1948fe564b9$export$e99fdbb90efc75c5(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    var isImage = $0c53f1948fe564b9$var$isImageNode(dragPreview);
    var dragPreviewNode = isImage ? sourceNode : dragPreview;
    var dragPreviewNodeOffsetFromClient = $0c53f1948fe564b9$export$8419e8612027b1d8(dragPreviewNode);
    var offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    var sourceWidth = sourceNode.offsetWidth, sourceHeight = sourceNode.offsetHeight;
    var anchorX = anchorPoint.anchorX, anchorY = anchorPoint.anchorY;
    var _getDragPreviewSize = $0c53f1948fe564b9$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight), dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth, dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;
    var calculateYOffset = function calculateYOffset() {
        var interpolantY = new (0, $8331e2c6b91c17dd$export$6d87c156c5199b02)([
            0,
            0.5,
            1
        ], [
            offsetFromDragPreview.y,
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
        ]);
        var y = interpolantY.interpolate(anchorY); // Work around Safari 8 positioning bug
        if ((0, $aa424e6836d89f3c$export$95df08bae54cb4df)() && isImage) // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        return y;
    };
    var calculateXOffset = function calculateXOffset() {
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        var interpolantX = new (0, $8331e2c6b91c17dd$export$6d87c156c5199b02)([
            0,
            0.5,
            1
        ], [
            offsetFromDragPreview.x,
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
        ]);
        return interpolantX.interpolate(anchorX);
    }; // Force offsets if specified in the options.
    var offsetX = offsetPoint.offsetX, offsetY = offsetPoint.offsetY;
    var isManualOffsetX = offsetX === 0 || offsetX;
    var isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}


var $ca0a8214e775b54d$exports = {};

$parcel$export($ca0a8214e775b54d$exports, "FILE", function () { return $ca0a8214e775b54d$export$1802dbfd31b58482; });
$parcel$export($ca0a8214e775b54d$exports, "URL", function () { return $ca0a8214e775b54d$export$61abde59b50deb8e; });
$parcel$export($ca0a8214e775b54d$exports, "TEXT", function () { return $ca0a8214e775b54d$export$d597759d33be802e; });
$parcel$export($ca0a8214e775b54d$exports, "HTML", function () { return $ca0a8214e775b54d$export$9dcd2b1ca4768128; });
var $ca0a8214e775b54d$export$1802dbfd31b58482 = '__NATIVE_FILE__';
var $ca0a8214e775b54d$export$61abde59b50deb8e = '__NATIVE_URL__';
var $ca0a8214e775b54d$export$d597759d33be802e = '__NATIVE_TEXT__';
var $ca0a8214e775b54d$export$9dcd2b1ca4768128 = '__NATIVE_HTML__';


function $de7414063334e0e1$export$dc02f6a7b68f305f(dataTransfer, typesToTry, defaultValue) {
    var result = typesToTry.reduce(function(resultSoFar, typeToTry) {
        return resultSoFar || dataTransfer.getData(typeToTry);
    }, '');
    return result != null ? result : defaultValue;
}


var $c1687319a0a24a97$var$_nativeTypesConfig;
function $c1687319a0a24a97$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $c1687319a0a24a97$export$8cc89d9b8cb1bd88 = ($c1687319a0a24a97$var$_nativeTypesConfig = {}, $c1687319a0a24a97$var$_defineProperty($c1687319a0a24a97$var$_nativeTypesConfig, $ca0a8214e775b54d$export$1802dbfd31b58482, {
    exposeProperties: {
        files: function files(dataTransfer) {
            return Array.prototype.slice.call(dataTransfer.files);
        },
        items: function items(dataTransfer) {
            return dataTransfer.items;
        },
        dataTransfer: function dataTransfer(_dataTransfer) {
            return _dataTransfer;
        }
    },
    matchesTypes: [
        'Files'
    ]
}), $c1687319a0a24a97$var$_defineProperty($c1687319a0a24a97$var$_nativeTypesConfig, $ca0a8214e775b54d$export$9dcd2b1ca4768128, {
    exposeProperties: {
        html: function html(dataTransfer, matchesTypes) {
            return (0, $de7414063334e0e1$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, '');
        },
        dataTransfer: function dataTransfer(_dataTransfer2) {
            return _dataTransfer2;
        }
    },
    matchesTypes: [
        'Html',
        'text/html'
    ]
}), $c1687319a0a24a97$var$_defineProperty($c1687319a0a24a97$var$_nativeTypesConfig, $ca0a8214e775b54d$export$61abde59b50deb8e, {
    exposeProperties: {
        urls: function urls(dataTransfer, matchesTypes) {
            return (0, $de7414063334e0e1$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, '').split('\n');
        },
        dataTransfer: function dataTransfer(_dataTransfer3) {
            return _dataTransfer3;
        }
    },
    matchesTypes: [
        'Url',
        'text/uri-list'
    ]
}), $c1687319a0a24a97$var$_defineProperty($c1687319a0a24a97$var$_nativeTypesConfig, $ca0a8214e775b54d$export$d597759d33be802e, {
    exposeProperties: {
        text: function text(dataTransfer, matchesTypes) {
            return (0, $de7414063334e0e1$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, '');
        },
        dataTransfer: function dataTransfer(_dataTransfer4) {
            return _dataTransfer4;
        }
    },
    matchesTypes: [
        'Text',
        'text/plain'
    ]
}), $c1687319a0a24a97$var$_nativeTypesConfig);


function $56fddf94b20fdb76$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $56fddf94b20fdb76$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $56fddf94b20fdb76$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $56fddf94b20fdb76$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $56fddf94b20fdb76$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $56fddf94b20fdb76$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $56fddf94b20fdb76$export$f22384f077cf51c4 = /*#__PURE__*/ function() {
    function NativeDragSource(config) {
        $56fddf94b20fdb76$var$_classCallCheck(this, NativeDragSource);
        $56fddf94b20fdb76$var$_defineProperty(this, "item", void 0);
        $56fddf94b20fdb76$var$_defineProperty(this, "config", void 0);
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
    $56fddf94b20fdb76$var$_createClass(NativeDragSource, [
        {
            key: "initializeExposedProperties",
            value: function initializeExposedProperties() {
                var _this = this;
                Object.keys(this.config.exposeProperties).forEach(function(property) {
                    Object.defineProperty(_this.item, property, {
                        configurable: true,
                        enumerable: true,
                        get: function get() {
                            // eslint-disable-next-line no-console
                            console.warn("Browser doesn't allow reading \"".concat(property, "\" until the drop event."));
                            return null;
                        }
                    });
                });
            }
        },
        {
            key: "loadDataTransfer",
            value: function loadDataTransfer(dataTransfer) {
                var _this2 = this;
                if (dataTransfer) {
                    var newProperties = {};
                    Object.keys(this.config.exposeProperties).forEach(function(property) {
                        newProperties[property] = {
                            value: _this2.config.exposeProperties[property](dataTransfer, _this2.config.matchesTypes),
                            configurable: true,
                            enumerable: true
                        };
                    });
                    Object.defineProperties(this.item, newProperties);
                }
            }
        },
        {
            key: "canDrag",
            value: function canDrag() {
                return true;
            }
        },
        {
            key: "beginDrag",
            value: function beginDrag() {
                return this.item;
            }
        },
        {
            key: "isDragging",
            value: function isDragging(monitor, handle) {
                return handle === monitor.getSourceId();
            }
        },
        {
            key: "endDrag",
            value: function endDrag() {}
        }
    ]);
    return NativeDragSource;
}();


function $5e630065a59566e2$export$ada362c01636774d(type, dataTransfer) {
    var result = new (0, $56fddf94b20fdb76$export$f22384f077cf51c4)((0, $c1687319a0a24a97$export$8cc89d9b8cb1bd88)[type]);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function $5e630065a59566e2$export$11b547ed8c182c11(dataTransfer) {
    if (!dataTransfer) return null;
    var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys((0, $c1687319a0a24a97$export$8cc89d9b8cb1bd88)).filter(function(nativeItemType) {
        var matchesTypes = (0, $c1687319a0a24a97$export$8cc89d9b8cb1bd88)[nativeItemType].matchesTypes;
        return matchesTypes.some(function(t) {
            return dataTransferTypes.indexOf(t) > -1;
        });
    })[0] || null;
}



function $9416166f3a1d2ecb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9416166f3a1d2ecb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9416166f3a1d2ecb$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9416166f3a1d2ecb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9416166f3a1d2ecb$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $9416166f3a1d2ecb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $9416166f3a1d2ecb$export$2b3a268803e49e64 = /*#__PURE__*/ function() {
    function OptionsReader(globalContext, options) {
        $9416166f3a1d2ecb$var$_classCallCheck(this, OptionsReader);
        $9416166f3a1d2ecb$var$_defineProperty(this, "ownerDocument", null);
        $9416166f3a1d2ecb$var$_defineProperty(this, "globalContext", void 0);
        $9416166f3a1d2ecb$var$_defineProperty(this, "optionsArgs", void 0);
        this.globalContext = globalContext;
        this.optionsArgs = options;
    }
    $9416166f3a1d2ecb$var$_createClass(OptionsReader, [
        {
            key: "window",
            get: function get() {
                if (this.globalContext) return this.globalContext;
                else if (typeof window !== 'undefined') return window;
                return undefined;
            }
        },
        {
            key: "document",
            get: function get() {
                var _this$globalContext;
                if ((_this$globalContext = this.globalContext) !== null && _this$globalContext !== void 0 && _this$globalContext.document) return this.globalContext.document;
                else if (this.window) return this.window.document;
                else return undefined;
            }
        },
        {
            key: "rootElement",
            get: function get() {
                var _this$optionsArgs;
                return ((_this$optionsArgs = this.optionsArgs) === null || _this$optionsArgs === void 0 ? void 0 : _this$optionsArgs.rootElement) || this.window;
            }
        }
    ]);
    return OptionsReader;
}();


function $1aa3b508e4d2e3ca$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1aa3b508e4d2e3ca$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1aa3b508e4d2e3ca$var$ownKeys(Object(source), true).forEach(function(key) {
            $1aa3b508e4d2e3ca$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1aa3b508e4d2e3ca$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1aa3b508e4d2e3ca$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1aa3b508e4d2e3ca$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1aa3b508e4d2e3ca$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1aa3b508e4d2e3ca$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1aa3b508e4d2e3ca$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1aa3b508e4d2e3ca$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1aa3b508e4d2e3ca$export$3a01990c235a9281 = /*#__PURE__*/ function() {
    // React-Dnd Components
    // Internal State
    function HTML5BackendImpl(manager, globalContext, options) {
        var _this = this;
        $1aa3b508e4d2e3ca$var$_classCallCheck(this, HTML5BackendImpl);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "options", void 0);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "actions", void 0);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "monitor", void 0);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "registry", void 0);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "enterLeaveCounter", void 0);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "sourcePreviewNodes", new Map());
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "sourcePreviewNodeOptions", new Map());
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "sourceNodes", new Map());
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "sourceNodeOptions", new Map());
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "dragStartSourceIds", null);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "dropTargetIds", []);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "dragEnterTargetIds", []);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "currentNativeSource", null);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "currentNativeHandle", null);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "currentDragSourceNode", null);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "altKeyPressed", false);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "mouseMoveTimeoutTimer", null);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "asyncEndDragFrameId", null);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "dragOverTargetIds", null);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "lastClientOffset", null);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "hoverRafId", null);
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "getSourceClientOffset", function(sourceId) {
            var source = _this.sourceNodes.get(sourceId);
            return source && (0, $0c53f1948fe564b9$export$8419e8612027b1d8)(source) || null;
        });
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "endDragNativeItem", function() {
            if (!_this.isDraggingNativeItem()) return;
            _this.actions.endDrag();
            if (_this.currentNativeHandle) _this.registry.removeSource(_this.currentNativeHandle);
            _this.currentNativeHandle = null;
            _this.currentNativeSource = null;
        });
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "isNodeInDocument", function(node) {
            // Check the node either in the main document or in the current context
            return Boolean(node && _this.document && _this.document.body && _this.document.body.contains(node));
        });
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "endDragIfSourceWasRemovedFromDOM", function() {
            var node = _this.currentDragSourceNode;
            if (node == null || _this.isNodeInDocument(node)) return;
            if (_this.clearCurrentDragSourceNode() && _this.monitor.isDragging()) _this.actions.endDrag();
        });
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "handleTopDragStartCapture", function() {
            _this.clearCurrentDragSourceNode();
            _this.dragStartSourceIds = [];
        });
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "handleTopDragStart", function(e) {
            if (e.defaultPrevented) return;
            var dragStartSourceIds = _this.dragStartSourceIds;
            _this.dragStartSourceIds = null;
            var clientOffset = (0, $0c53f1948fe564b9$export$710c829989c68339)(e); // Avoid crashing if we missed a drop event or our previous drag died
            if (_this.monitor.isDragging()) _this.actions.endDrag();
             // Don't publish the source just yet (see why below)
            _this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: _this.getSourceClientOffset,
                clientOffset: clientOffset
            });
            var dataTransfer = e.dataTransfer;
            var nativeType = (0, $5e630065a59566e2$export$11b547ed8c182c11)(dataTransfer);
            if (_this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === 'function') {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    var sourceId = _this.monitor.getSourceId();
                    var sourceNode = _this.sourceNodes.get(sourceId);
                    var dragPreview = _this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        var _this$getCurrentSourc = _this.getCurrentSourcePreviewNodeOptions(), anchorX = _this$getCurrentSourc.anchorX, anchorY = _this$getCurrentSourc.anchorY, offsetX = _this$getCurrentSourc.offsetX, offsetY = _this$getCurrentSourc.offsetY;
                        var anchorPoint = {
                            anchorX: anchorX,
                            anchorY: anchorY
                        };
                        var offsetPoint = {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                        var dragPreviewOffset = (0, $0c53f1948fe564b9$export$e99fdbb90efc75c5)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer === null || dataTransfer === void 0 || dataTransfer.setData('application/json', {});
                } catch (err) {} // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                _this.setCurrentDragSourceNode(e.target); // Now we are ready to publish the drag source.. or are we not?
                var _this$getCurrentSourc2 = _this.getCurrentSourcePreviewNodeOptions(), captureDraggingState = _this$getCurrentSourc2.captureDraggingState;
                if (!captureDraggingState) // Usually we want to publish it in the next tick so that browser
                // is able to screenshot the current (not yet dragging) state.
                //
                // It also neatly avoids a situation where render() returns null
                // in the same tick for the source element, and browser freaks out.
                setTimeout(function() {
                    return _this.actions.publishDragSource();
                }, 0);
                else // In some cases the user may want to override this behavior, e.g.
                // to work around IE not supporting custom drag previews.
                //
                // When using a custom drag layer, the only way to prevent
                // the default drag preview from drawing in IE is to screenshot
                // the dragging state in which the node itself has zero opacity
                // and height. In this case, though, returning null from render()
                // will abruptly end the dragging, which is not obvious.
                //
                // This is the reason such behavior is strictly opt-in.
                _this.actions.publishDragSource();
            } else if (nativeType) // A native item (such as URL) dragged from inside the document
            _this.beginDragNativeItem(nativeType);
            else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute('draggable'))) // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
            // Just let it drag. It's a native type (URL or text) and will be picked up in
            // dragenter handler.
            return;
            else // If by this time no drag source reacted, tell browser not to drag.
            e.preventDefault();
        });
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "handleTopDragEndCapture", function() {
            if (_this.clearCurrentDragSourceNode() && _this.monitor.isDragging()) // Firefox can dispatch this event in an infinite loop
            // if dragend handler does something like showing an alert.
            // Only proceed if we have not handled it already.
            _this.actions.endDrag();
        });
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "handleTopDragEnterCapture", function(e) {
            _this.dragEnterTargetIds = [];
            var isFirstEnter = _this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || _this.monitor.isDragging()) return;
            var dataTransfer = e.dataTransfer;
            var nativeType = (0, $5e630065a59566e2$export$11b547ed8c182c11)(dataTransfer);
            if (nativeType) // A native item (such as file or URL) dragged from outside the document
            _this.beginDragNativeItem(nativeType, dataTransfer);
        });
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "handleTopDragEnter", function(e) {
            var dragEnterTargetIds = _this.dragEnterTargetIds;
            _this.dragEnterTargetIds = [];
            if (!_this.monitor.isDragging()) // This is probably a native item type we don't understand.
            return;
            _this.altKeyPressed = e.altKey; // If the target changes position as the result of `dragenter`, `dragover` might still
            // get dispatched despite target being no longer there. The easy solution is to check
            // whether there actually is a target before firing `hover`.
            if (dragEnterTargetIds.length > 0) _this.actions.hover(dragEnterTargetIds, {
                clientOffset: (0, $0c53f1948fe564b9$export$710c829989c68339)(e)
            });
            var canDrop = dragEnterTargetIds.some(function(targetId) {
                return _this.monitor.canDropOnTarget(targetId);
            });
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
            }
        });
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "handleTopDragOverCapture", function() {
            _this.dragOverTargetIds = [];
        });
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "handleTopDragOver", function(e) {
            var dragOverTargetIds = _this.dragOverTargetIds;
            _this.dragOverTargetIds = [];
            if (!_this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = 'none';
                return;
            }
            _this.altKeyPressed = e.altKey;
            _this.lastClientOffset = (0, $0c53f1948fe564b9$export$710c829989c68339)(e);
            if (_this.hoverRafId === null && typeof requestAnimationFrame !== 'undefined') _this.hoverRafId = requestAnimationFrame(function() {
                if (_this.monitor.isDragging()) _this.actions.hover(dragOverTargetIds || [], {
                    clientOffset: _this.lastClientOffset
                });
                _this.hoverRafId = null;
            });
            var canDrop = (dragOverTargetIds || []).some(function(targetId) {
                return _this.monitor.canDropOnTarget(targetId);
            });
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
            } else if (_this.isDraggingNativeItem()) // Don't show a nice cursor but still prevent default
            // "drop and blow away the whole document" action.
            e.preventDefault();
            else {
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = 'none';
            }
        });
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "handleTopDragLeaveCapture", function(e) {
            if (_this.isDraggingNativeItem()) e.preventDefault();
            var isLastLeave = _this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) return;
            if (_this.isDraggingNativeItem()) setTimeout(function() {
                return _this.endDragNativeItem();
            }, 0);
        });
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "handleTopDropCapture", function(e) {
            _this.dropTargetIds = [];
            if (_this.isDraggingNativeItem()) {
                var _this$currentNativeSo;
                e.preventDefault();
                (_this$currentNativeSo = _this.currentNativeSource) === null || _this$currentNativeSo === void 0 || _this$currentNativeSo.loadDataTransfer(e.dataTransfer);
            } else if ((0, $5e630065a59566e2$export$11b547ed8c182c11)(e.dataTransfer)) // Dragging some elements, like <a> and <img> may still behave like a native drag event,
            // even if the current drag event matches a user-defined type.
            // Stop the default behavior when we're not expecting a native item to be dropped.
            e.preventDefault();
            _this.enterLeaveCounter.reset();
        });
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "handleTopDrop", function(e) {
            var dropTargetIds = _this.dropTargetIds;
            _this.dropTargetIds = [];
            _this.actions.hover(dropTargetIds, {
                clientOffset: (0, $0c53f1948fe564b9$export$710c829989c68339)(e)
            });
            _this.actions.drop({
                dropEffect: _this.getCurrentDropEffect()
            });
            if (_this.isDraggingNativeItem()) _this.endDragNativeItem();
            else if (_this.monitor.isDragging()) _this.actions.endDrag();
        });
        $1aa3b508e4d2e3ca$var$_defineProperty(this, "handleSelectStart", function(e) {
            var target = e.target; // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== 'function') return;
             // Inputs and textareas should be selectable
            if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return;
             // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        });
        this.options = new (0, $9416166f3a1d2ecb$export$2b3a268803e49e64)(globalContext, options);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new (0, $6b6a33bc0421ede3$export$9ff3e6eb5c734d0d)(this.isNodeInDocument);
    }
    /**
   * Generate profiling statistics for the HTML5Backend.
   */ $1aa3b508e4d2e3ca$var$_createClass(HTML5BackendImpl, [
        {
            key: "profile",
            value: function profile() {
                var _this$dragStartSource, _this$dragOverTargetI;
                return {
                    sourcePreviewNodes: this.sourcePreviewNodes.size,
                    sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
                    sourceNodeOptions: this.sourceNodeOptions.size,
                    sourceNodes: this.sourceNodes.size,
                    dragStartSourceIds: ((_this$dragStartSource = this.dragStartSourceIds) === null || _this$dragStartSource === void 0 ? void 0 : _this$dragStartSource.length) || 0,
                    dropTargetIds: this.dropTargetIds.length,
                    dragEnterTargetIds: this.dragEnterTargetIds.length,
                    dragOverTargetIds: ((_this$dragOverTargetI = this.dragOverTargetIds) === null || _this$dragOverTargetI === void 0 ? void 0 : _this$dragOverTargetI.length) || 0
                };
            } // public for test
        },
        {
            key: "window",
            get: function get() {
                return this.options.window;
            }
        },
        {
            key: "document",
            get: function get() {
                return this.options.document;
            }
        },
        {
            key: "rootElement",
            get: function get() {
                return this.options.rootElement;
            }
        },
        {
            key: "setup",
            value: function setup() {
                var root = this.rootElement;
                if (root === undefined) return;
                if (root.__isReactDndBackendSetUp) throw new Error('Cannot have two HTML5 backends at the same time.');
                root.__isReactDndBackendSetUp = true;
                this.addEventListeners(root);
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                var root = this.rootElement;
                if (root === undefined) return;
                root.__isReactDndBackendSetUp = false;
                this.removeEventListeners(this.rootElement);
                this.clearCurrentDragSourceNode();
                if (this.asyncEndDragFrameId) {
                    var _this$window;
                    (_this$window = this.window) === null || _this$window === void 0 || _this$window.cancelAnimationFrame(this.asyncEndDragFrameId);
                }
            }
        },
        {
            key: "connectDragPreview",
            value: function connectDragPreview(sourceId, node, options) {
                var _this2 = this;
                this.sourcePreviewNodeOptions.set(sourceId, options);
                this.sourcePreviewNodes.set(sourceId, node);
                return function() {
                    _this2.sourcePreviewNodes.delete(sourceId);
                    _this2.sourcePreviewNodeOptions.delete(sourceId);
                };
            }
        },
        {
            key: "connectDragSource",
            value: function connectDragSource(sourceId, node, options) {
                var _this3 = this;
                this.sourceNodes.set(sourceId, node);
                this.sourceNodeOptions.set(sourceId, options);
                var handleDragStart = function handleDragStart(e) {
                    return _this3.handleDragStart(e, sourceId);
                };
                var handleSelectStart = function handleSelectStart(e) {
                    return _this3.handleSelectStart(e);
                };
                node.setAttribute('draggable', 'true');
                node.addEventListener('dragstart', handleDragStart);
                node.addEventListener('selectstart', handleSelectStart);
                return function() {
                    _this3.sourceNodes.delete(sourceId);
                    _this3.sourceNodeOptions.delete(sourceId);
                    node.removeEventListener('dragstart', handleDragStart);
                    node.removeEventListener('selectstart', handleSelectStart);
                    node.setAttribute('draggable', 'false');
                };
            }
        },
        {
            key: "connectDropTarget",
            value: function connectDropTarget(targetId, node) {
                var _this4 = this;
                var handleDragEnter = function handleDragEnter(e) {
                    return _this4.handleDragEnter(e, targetId);
                };
                var handleDragOver = function handleDragOver(e) {
                    return _this4.handleDragOver(e, targetId);
                };
                var handleDrop = function handleDrop(e) {
                    return _this4.handleDrop(e, targetId);
                };
                node.addEventListener('dragenter', handleDragEnter);
                node.addEventListener('dragover', handleDragOver);
                node.addEventListener('drop', handleDrop);
                return function() {
                    node.removeEventListener('dragenter', handleDragEnter);
                    node.removeEventListener('dragover', handleDragOver);
                    node.removeEventListener('drop', handleDrop);
                };
            }
        },
        {
            key: "addEventListeners",
            value: function addEventListeners(target) {
                // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
                if (!target.addEventListener) return;
                target.addEventListener('dragstart', this.handleTopDragStart);
                target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
                target.addEventListener('dragend', this.handleTopDragEndCapture, true);
                target.addEventListener('dragenter', this.handleTopDragEnter);
                target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
                target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
                target.addEventListener('dragover', this.handleTopDragOver);
                target.addEventListener('dragover', this.handleTopDragOverCapture, true);
                target.addEventListener('drop', this.handleTopDrop);
                target.addEventListener('drop', this.handleTopDropCapture, true);
            }
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners(target) {
                // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
                if (!target.removeEventListener) return;
                target.removeEventListener('dragstart', this.handleTopDragStart);
                target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
                target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
                target.removeEventListener('dragenter', this.handleTopDragEnter);
                target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
                target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
                target.removeEventListener('dragover', this.handleTopDragOver);
                target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
                target.removeEventListener('drop', this.handleTopDrop);
                target.removeEventListener('drop', this.handleTopDropCapture, true);
            }
        },
        {
            key: "getCurrentSourceNodeOptions",
            value: function getCurrentSourceNodeOptions() {
                var sourceId = this.monitor.getSourceId();
                var sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
                return $1aa3b508e4d2e3ca$var$_objectSpread({
                    dropEffect: this.altKeyPressed ? 'copy' : 'move'
                }, sourceNodeOptions || {});
            }
        },
        {
            key: "getCurrentDropEffect",
            value: function getCurrentDropEffect() {
                if (this.isDraggingNativeItem()) // It makes more sense to default to 'copy' for native resources
                return 'copy';
                return this.getCurrentSourceNodeOptions().dropEffect;
            }
        },
        {
            key: "getCurrentSourcePreviewNodeOptions",
            value: function getCurrentSourcePreviewNodeOptions() {
                var sourceId = this.monitor.getSourceId();
                var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
                return $1aa3b508e4d2e3ca$var$_objectSpread({
                    anchorX: 0.5,
                    anchorY: 0.5,
                    captureDraggingState: false
                }, sourcePreviewNodeOptions || {});
            }
        },
        {
            key: "isDraggingNativeItem",
            value: function isDraggingNativeItem() {
                var itemType = this.monitor.getItemType();
                return Object.keys($ca0a8214e775b54d$exports).some(function(key) {
                    return $ca0a8214e775b54d$exports[key] === itemType;
                });
            }
        },
        {
            key: "beginDragNativeItem",
            value: function beginDragNativeItem(type, dataTransfer) {
                this.clearCurrentDragSourceNode();
                this.currentNativeSource = (0, $5e630065a59566e2$export$ada362c01636774d)(type, dataTransfer);
                this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
                this.actions.beginDrag([
                    this.currentNativeHandle
                ]);
            }
        },
        {
            key: "setCurrentDragSourceNode",
            value: function setCurrentDragSourceNode(node) {
                var _this5 = this;
                this.clearCurrentDragSourceNode();
                this.currentDragSourceNode = node; // A timeout of > 0 is necessary to resolve Firefox issue referenced
                // See:
                //   * https://github.com/react-dnd/react-dnd/pull/928
                //   * https://github.com/react-dnd/react-dnd/issues/869
                var MOUSE_MOVE_TIMEOUT = 1000; // Receiving a mouse event in the middle of a dragging operation
                // means it has ended and the drag source node disappeared from DOM,
                // so the browser didn't dispatch the dragend event.
                //
                // We need to wait before we start listening for mousemove events.
                // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
                // immediately in some browsers.
                //
                // See:
                //   * https://github.com/react-dnd/react-dnd/pull/928
                //   * https://github.com/react-dnd/react-dnd/issues/869
                //
                this.mouseMoveTimeoutTimer = setTimeout(function() {
                    var _this5$rootElement;
                    return (_this5$rootElement = _this5.rootElement) === null || _this5$rootElement === void 0 ? void 0 : _this5$rootElement.addEventListener('mousemove', _this5.endDragIfSourceWasRemovedFromDOM, true);
                }, MOUSE_MOVE_TIMEOUT);
            }
        },
        {
            key: "clearCurrentDragSourceNode",
            value: function clearCurrentDragSourceNode() {
                if (this.currentDragSourceNode) {
                    this.currentDragSourceNode = null;
                    if (this.rootElement) {
                        var _this$window2;
                        (_this$window2 = this.window) === null || _this$window2 === void 0 || _this$window2.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                        this.rootElement.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
                    }
                    this.mouseMoveTimeoutTimer = null;
                    return true;
                }
                return false;
            }
        },
        {
            key: "handleDragStart",
            value: function handleDragStart(e, sourceId) {
                if (e.defaultPrevented) return;
                if (!this.dragStartSourceIds) this.dragStartSourceIds = [];
                this.dragStartSourceIds.unshift(sourceId);
            }
        },
        {
            key: "handleDragEnter",
            value: function handleDragEnter(e, targetId) {
                this.dragEnterTargetIds.unshift(targetId);
            }
        },
        {
            key: "handleDragOver",
            value: function handleDragOver(e, targetId) {
                if (this.dragOverTargetIds === null) this.dragOverTargetIds = [];
                this.dragOverTargetIds.unshift(targetId);
            }
        },
        {
            key: "handleDrop",
            value: function handleDrop(e, targetId) {
                this.dropTargetIds.unshift(targetId);
            }
        }
    ]);
    return HTML5BackendImpl;
}();




var $5091b83b199b6305$export$f4f61d779bb20744 = function createBackend(manager, context, options) {
    return new (0, $1aa3b508e4d2e3ca$export$3a01990c235a9281)(manager, context, options);
};




var $bb3TF = parcelRequire("bb3TF");

function $50e0cf5e1a578a2e$export$38b18180ae58b09b(type, target, manager) {
    var registry = manager.getRegistry();
    var targetId = registry.addTarget(type, target);
    return [
        targetId,
        function() {
            return registry.removeTarget(targetId);
        }
    ];
}
function $50e0cf5e1a578a2e$export$51c814b9e17958c(type, source, manager) {
    var registry = manager.getRegistry();
    var sourceId = registry.addSource(type, source);
    return [
        sourceId,
        function() {
            return registry.removeSource(sourceId);
        }
    ];
}



var $6fFrj = parcelRequire("6fFrj");
var $0931f87f7be2beed$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $6fFrj.useLayoutEffect) : (0, $6fFrj.useEffect);



var $6fFrj = parcelRequire("6fFrj");
function $44be3ce8aa967b53$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $44be3ce8aa967b53$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $44be3ce8aa967b53$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $44be3ce8aa967b53$var$_typeof(obj);
}
function $44be3ce8aa967b53$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $44be3ce8aa967b53$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $44be3ce8aa967b53$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $44be3ce8aa967b53$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $44be3ce8aa967b53$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $44be3ce8aa967b53$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $44be3ce8aa967b53$export$680f0a3c92f9d645 = /*#__PURE__*/ function() {
    function DragSourceImpl(spec, monitor, connector) {
        $44be3ce8aa967b53$var$_classCallCheck(this, DragSourceImpl);
        $44be3ce8aa967b53$var$_defineProperty(this, "spec", void 0);
        $44be3ce8aa967b53$var$_defineProperty(this, "monitor", void 0);
        $44be3ce8aa967b53$var$_defineProperty(this, "connector", void 0);
        this.spec = spec;
        this.monitor = monitor;
        this.connector = connector;
    }
    $44be3ce8aa967b53$var$_createClass(DragSourceImpl, [
        {
            key: "beginDrag",
            value: function beginDrag() {
                var _result;
                var spec = this.spec;
                var monitor = this.monitor;
                var result = null;
                if ($44be3ce8aa967b53$var$_typeof(spec.item) === 'object') result = spec.item;
                else if (typeof spec.item === 'function') result = spec.item(monitor);
                else result = {};
                return (_result = result) !== null && _result !== void 0 ? _result : null;
            }
        },
        {
            key: "canDrag",
            value: function canDrag() {
                var spec = this.spec;
                var monitor = this.monitor;
                if (typeof spec.canDrag === 'boolean') return spec.canDrag;
                else if (typeof spec.canDrag === 'function') return spec.canDrag(monitor);
                else return true;
            }
        },
        {
            key: "isDragging",
            value: function isDragging(globalMonitor, target) {
                var spec = this.spec;
                var monitor = this.monitor;
                var isDragging = spec.isDragging;
                return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
            }
        },
        {
            key: "endDrag",
            value: function endDrag() {
                var spec = this.spec;
                var monitor = this.monitor;
                var connector = this.connector;
                var end = spec.end;
                if (end) end(monitor.getItem(), monitor);
                connector.reconnect();
            }
        }
    ]);
    return DragSourceImpl;
}();


function $917badb05d7bb090$export$cdddb20adb7aad5c(spec, monitor, connector) {
    var handler = (0, $6fFrj.useMemo)(function() {
        return new (0, $44be3ce8aa967b53$export$680f0a3c92f9d645)(spec, monitor, connector);
    }, [
        monitor,
        connector
    ]);
    (0, $6fFrj.useEffect)(function() {
        handler.spec = spec;
    }, [
        spec
    ]);
    return handler;
}



var $6fFrj = parcelRequire("6fFrj");


function $90e871f0bd8ea2da$export$49db7e1a057ab0fa() {
    var _useContext = (0, $6fFrj.useContext)((0, $296e86319c262fd8$export$2d5c5ceac203fc1e)), dragDropManager = _useContext.dragDropManager;
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(dragDropManager != null, 'Expected drag drop context');
    return dragDropManager;
}




var $6fFrj = parcelRequire("6fFrj");
function $c8133fe30c8b1b1f$export$dec3a5d742510a3f(spec) {
    return (0, $6fFrj.useMemo)(function() {
        var result = spec.type;
        (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(result != null, 'spec.type must be defined');
        return result;
    }, [
        spec
    ]);
}


function $f9f4c7970d36cc05$var$_slicedToArray(arr, i) {
    return $f9f4c7970d36cc05$var$_arrayWithHoles(arr) || $f9f4c7970d36cc05$var$_iterableToArrayLimit(arr, i) || $f9f4c7970d36cc05$var$_unsupportedIterableToArray(arr, i) || $f9f4c7970d36cc05$var$_nonIterableRest();
}
function $f9f4c7970d36cc05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f9f4c7970d36cc05$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f9f4c7970d36cc05$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f9f4c7970d36cc05$var$_arrayLikeToArray(o, minLen);
}
function $f9f4c7970d36cc05$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f9f4c7970d36cc05$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $f9f4c7970d36cc05$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f9f4c7970d36cc05$export$1bdd19ff5ac2e03c(spec, monitor, connector) {
    var manager = (0, $90e871f0bd8ea2da$export$49db7e1a057ab0fa)();
    var handler = (0, $917badb05d7bb090$export$cdddb20adb7aad5c)(spec, monitor, connector);
    var itemType = (0, $c8133fe30c8b1b1f$export$dec3a5d742510a3f)(spec);
    (0, $0931f87f7be2beed$export$700979bc83e7db82)(function registerDragSource() {
        if (itemType != null) {
            var _registerSource = (0, $50e0cf5e1a578a2e$export$51c814b9e17958c)(itemType, handler, manager), _registerSource2 = $f9f4c7970d36cc05$var$_slicedToArray(_registerSource, 2), handlerId = _registerSource2[0], unregister = _registerSource2[1];
            monitor.receiveHandlerId(handlerId);
            connector.receiveHandlerId(handlerId);
            return unregister;
        }
    }, [
        manager,
        monitor,
        connector,
        handler,
        itemType
    ]);
}



var $6fFrj = parcelRequire("6fFrj");
function $aee552824b44e43a$var$_toConsumableArray(arr) {
    return $aee552824b44e43a$var$_arrayWithoutHoles(arr) || $aee552824b44e43a$var$_iterableToArray(arr) || $aee552824b44e43a$var$_unsupportedIterableToArray(arr) || $aee552824b44e43a$var$_nonIterableSpread();
}
function $aee552824b44e43a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aee552824b44e43a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aee552824b44e43a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aee552824b44e43a$var$_arrayLikeToArray(o, minLen);
}
function $aee552824b44e43a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $aee552824b44e43a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aee552824b44e43a$var$_arrayLikeToArray(arr);
}
function $aee552824b44e43a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $aee552824b44e43a$export$f16a07909151e918(arg, deps) {
    var memoDeps = $aee552824b44e43a$var$_toConsumableArray(deps || []);
    if (deps == null && typeof arg !== 'function') memoDeps.push(arg);
    return (0, $6fFrj.useMemo)(function() {
        return typeof arg === 'function' ? arg() : arg;
    }, memoDeps);
}



var $6fFrj = parcelRequire("6fFrj");

function $5e0c789ed4f32705$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5e0c789ed4f32705$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5e0c789ed4f32705$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5e0c789ed4f32705$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5e0c789ed4f32705$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5e0c789ed4f32705$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5e0c789ed4f32705$var$isCallingCanDrag = false;
var $5e0c789ed4f32705$var$isCallingIsDragging = false;
var $5e0c789ed4f32705$export$af934094fb48ddf = /*#__PURE__*/ function() {
    function DragSourceMonitorImpl(manager) {
        $5e0c789ed4f32705$var$_classCallCheck(this, DragSourceMonitorImpl);
        $5e0c789ed4f32705$var$_defineProperty(this, "internalMonitor", void 0);
        $5e0c789ed4f32705$var$_defineProperty(this, "sourceId", null);
        this.internalMonitor = manager.getMonitor();
    }
    $5e0c789ed4f32705$var$_createClass(DragSourceMonitorImpl, [
        {
            key: "receiveHandlerId",
            value: function receiveHandlerId(sourceId) {
                this.sourceId = sourceId;
            }
        },
        {
            key: "getHandlerId",
            value: function getHandlerId() {
                return this.sourceId;
            }
        },
        {
            key: "canDrag",
            value: function canDrag() {
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(!$5e0c789ed4f32705$var$isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
                try {
                    $5e0c789ed4f32705$var$isCallingCanDrag = true;
                    return this.internalMonitor.canDragSource(this.sourceId);
                } finally{
                    $5e0c789ed4f32705$var$isCallingCanDrag = false;
                }
            }
        },
        {
            key: "isDragging",
            value: function isDragging() {
                if (!this.sourceId) return false;
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(!$5e0c789ed4f32705$var$isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
                try {
                    $5e0c789ed4f32705$var$isCallingIsDragging = true;
                    return this.internalMonitor.isDraggingSource(this.sourceId);
                } finally{
                    $5e0c789ed4f32705$var$isCallingIsDragging = false;
                }
            }
        },
        {
            key: "subscribeToStateChange",
            value: function subscribeToStateChange(listener, options) {
                return this.internalMonitor.subscribeToStateChange(listener, options);
            }
        },
        {
            key: "isDraggingSource",
            value: function isDraggingSource(sourceId) {
                return this.internalMonitor.isDraggingSource(sourceId);
            }
        },
        {
            key: "isOverTarget",
            value: function isOverTarget(targetId, options) {
                return this.internalMonitor.isOverTarget(targetId, options);
            }
        },
        {
            key: "getTargetIds",
            value: function getTargetIds() {
                return this.internalMonitor.getTargetIds();
            }
        },
        {
            key: "isSourcePublic",
            value: function isSourcePublic() {
                return this.internalMonitor.isSourcePublic();
            }
        },
        {
            key: "getSourceId",
            value: function getSourceId() {
                return this.internalMonitor.getSourceId();
            }
        },
        {
            key: "subscribeToOffsetChange",
            value: function subscribeToOffsetChange(listener) {
                return this.internalMonitor.subscribeToOffsetChange(listener);
            }
        },
        {
            key: "canDragSource",
            value: function canDragSource(sourceId) {
                return this.internalMonitor.canDragSource(sourceId);
            }
        },
        {
            key: "canDropOnTarget",
            value: function canDropOnTarget(targetId) {
                return this.internalMonitor.canDropOnTarget(targetId);
            }
        },
        {
            key: "getItemType",
            value: function getItemType() {
                return this.internalMonitor.getItemType();
            }
        },
        {
            key: "getItem",
            value: function getItem() {
                return this.internalMonitor.getItem();
            }
        },
        {
            key: "getDropResult",
            value: function getDropResult() {
                return this.internalMonitor.getDropResult();
            }
        },
        {
            key: "didDrop",
            value: function didDrop() {
                return this.internalMonitor.didDrop();
            }
        },
        {
            key: "getInitialClientOffset",
            value: function getInitialClientOffset() {
                return this.internalMonitor.getInitialClientOffset();
            }
        },
        {
            key: "getInitialSourceClientOffset",
            value: function getInitialSourceClientOffset() {
                return this.internalMonitor.getInitialSourceClientOffset();
            }
        },
        {
            key: "getSourceClientOffset",
            value: function getSourceClientOffset() {
                return this.internalMonitor.getSourceClientOffset();
            }
        },
        {
            key: "getClientOffset",
            value: function getClientOffset() {
                return this.internalMonitor.getClientOffset();
            }
        },
        {
            key: "getDifferenceFromInitialOffset",
            value: function getDifferenceFromInitialOffset() {
                return this.internalMonitor.getDifferenceFromInitialOffset();
            }
        }
    ]);
    return DragSourceMonitorImpl;
}();



function $f18ffd1e61ca5f2a$export$82f95eab323fcd7a() {
    var manager = (0, $90e871f0bd8ea2da$export$49db7e1a057ab0fa)();
    return (0, $6fFrj.useMemo)(function() {
        return new (0, $5e0c789ed4f32705$export$af934094fb48ddf)(manager);
    }, [
        manager
    ]);
}



var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");
function $1e4be2c3df09d07c$var$throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === 'string') return;
    var displayName = element.type.displayName || element.type.name || 'the component';
    throw new Error('Only native element nodes can now be passed to React DnD connectors.' + "You can either wrap ".concat(displayName, " into a <div>, or turn it into a ") + 'drag source or a drop target itself.');
}
function $1e4be2c3df09d07c$var$wrapHookToRecognizeElement(hook) {
    return function() {
        var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        // When passed a node, call the hook straight away.
        if (!(0, $6fFrj.isValidElement)(elementOrNode)) {
            var node = elementOrNode;
            hook(node, options); // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        } // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        var element = elementOrNode;
        $1e4be2c3df09d07c$var$throwIfCompositeComponentElement(element); // When no options are passed, use the hook directly
        var ref = options ? function(node) {
            return hook(node, options);
        } : hook;
        return $1e4be2c3df09d07c$var$cloneWithRef(element, ref);
    };
}
function $1e4be2c3df09d07c$export$d8dcaf80ab4f6cb7(hooks) {
    var wrappedHooks = {};
    Object.keys(hooks).forEach(function(key) {
        var hook = hooks[key]; // ref objects should be passed straight through without wrapping
        if (key.endsWith('Ref')) wrappedHooks[key] = hooks[key];
        else {
            var wrappedHook = $1e4be2c3df09d07c$var$wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = function() {
                return wrappedHook;
            };
        }
    });
    return wrappedHooks;
}
function $1e4be2c3df09d07c$var$setRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else ref.current = node;
}
function $1e4be2c3df09d07c$var$cloneWithRef(element, newRef) {
    var previousRef = element.ref;
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(typeof previousRef !== 'string', "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs");
    if (!previousRef) // When there is no ref on the element, use the new ref directly
    return (0, $6fFrj.cloneElement)(element, {
        ref: newRef
    });
    else return (0, $6fFrj.cloneElement)(element, {
        ref: function ref(node) {
            $1e4be2c3df09d07c$var$setRef(previousRef, node);
            $1e4be2c3df09d07c$var$setRef(newRef, node);
        }
    });
}


function $06e669ce97b8041c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $06e669ce97b8041c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $06e669ce97b8041c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $06e669ce97b8041c$var$_typeof(obj);
}
function $06e669ce97b8041c$export$4f9f5282de18fc69(obj) {
    return obj !== null && $06e669ce97b8041c$var$_typeof(obj) === 'object' && Object.prototype.hasOwnProperty.call(obj, 'current');
}


function $22c32b046f4aed96$export$d36bdfa510afb180(objA, objB, compare, compareContext) {
    var compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) return !!compareResult;
    if (objA === objB) return true;
    if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB); // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) return false;
    }
    return true;
}


function $fe76d73067eb2230$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fe76d73067eb2230$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fe76d73067eb2230$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe76d73067eb2230$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe76d73067eb2230$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $fe76d73067eb2230$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $fe76d73067eb2230$export$9a7176fb37ab5028 = /*#__PURE__*/ function() {
    // The drop target may either be attached via ref or connect function
    // The drag preview may either be attached via ref or connect function
    function SourceConnector(backend) {
        var _this = this;
        $fe76d73067eb2230$var$_classCallCheck(this, SourceConnector);
        $fe76d73067eb2230$var$_defineProperty(this, "hooks", (0, $1e4be2c3df09d07c$export$d8dcaf80ab4f6cb7)({
            dragSource: function dragSource(node, options) {
                _this.clearDragSource();
                _this.dragSourceOptions = options || null;
                if ((0, $06e669ce97b8041c$export$4f9f5282de18fc69)(node)) _this.dragSourceRef = node;
                else _this.dragSourceNode = node;
                _this.reconnectDragSource();
            },
            dragPreview: function dragPreview(node, options) {
                _this.clearDragPreview();
                _this.dragPreviewOptions = options || null;
                if ((0, $06e669ce97b8041c$export$4f9f5282de18fc69)(node)) _this.dragPreviewRef = node;
                else _this.dragPreviewNode = node;
                _this.reconnectDragPreview();
            }
        }));
        $fe76d73067eb2230$var$_defineProperty(this, "handlerId", null);
        $fe76d73067eb2230$var$_defineProperty(this, "dragSourceRef", null);
        $fe76d73067eb2230$var$_defineProperty(this, "dragSourceNode", void 0);
        $fe76d73067eb2230$var$_defineProperty(this, "dragSourceOptionsInternal", null);
        $fe76d73067eb2230$var$_defineProperty(this, "dragSourceUnsubscribe", void 0);
        $fe76d73067eb2230$var$_defineProperty(this, "dragPreviewRef", null);
        $fe76d73067eb2230$var$_defineProperty(this, "dragPreviewNode", void 0);
        $fe76d73067eb2230$var$_defineProperty(this, "dragPreviewOptionsInternal", null);
        $fe76d73067eb2230$var$_defineProperty(this, "dragPreviewUnsubscribe", void 0);
        $fe76d73067eb2230$var$_defineProperty(this, "lastConnectedHandlerId", null);
        $fe76d73067eb2230$var$_defineProperty(this, "lastConnectedDragSource", null);
        $fe76d73067eb2230$var$_defineProperty(this, "lastConnectedDragSourceOptions", null);
        $fe76d73067eb2230$var$_defineProperty(this, "lastConnectedDragPreview", null);
        $fe76d73067eb2230$var$_defineProperty(this, "lastConnectedDragPreviewOptions", null);
        $fe76d73067eb2230$var$_defineProperty(this, "backend", void 0);
        this.backend = backend;
    }
    $fe76d73067eb2230$var$_createClass(SourceConnector, [
        {
            key: "receiveHandlerId",
            value: function receiveHandlerId(newHandlerId) {
                if (this.handlerId === newHandlerId) return;
                this.handlerId = newHandlerId;
                this.reconnect();
            }
        },
        {
            key: "connectTarget",
            get: function get() {
                return this.dragSource;
            }
        },
        {
            key: "dragSourceOptions",
            get: function get() {
                return this.dragSourceOptionsInternal;
            },
            set: function set(options) {
                this.dragSourceOptionsInternal = options;
            }
        },
        {
            key: "dragPreviewOptions",
            get: function get() {
                return this.dragPreviewOptionsInternal;
            },
            set: function set(options) {
                this.dragPreviewOptionsInternal = options;
            }
        },
        {
            key: "reconnect",
            value: function reconnect() {
                this.reconnectDragSource();
                this.reconnectDragPreview();
            }
        },
        {
            key: "reconnectDragSource",
            value: function reconnectDragSource() {
                var dragSource = this.dragSource; // if nothing has changed then don't resubscribe
                var didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
                if (didChange) this.disconnectDragSource();
                if (!this.handlerId) return;
                if (!dragSource) {
                    this.lastConnectedDragSource = dragSource;
                    return;
                }
                if (didChange) {
                    this.lastConnectedHandlerId = this.handlerId;
                    this.lastConnectedDragSource = dragSource;
                    this.lastConnectedDragSourceOptions = this.dragSourceOptions;
                    this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
                }
            }
        },
        {
            key: "reconnectDragPreview",
            value: function reconnectDragPreview() {
                var dragPreview = this.dragPreview; // if nothing has changed then don't resubscribe
                var didChange = this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
                if (didChange) this.disconnectDragPreview();
                if (!this.handlerId) return;
                if (!dragPreview) {
                    this.lastConnectedDragPreview = dragPreview;
                    return;
                }
                if (didChange) {
                    this.lastConnectedHandlerId = this.handlerId;
                    this.lastConnectedDragPreview = dragPreview;
                    this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
                    this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
                }
            }
        },
        {
            key: "didHandlerIdChange",
            value: function didHandlerIdChange() {
                return this.lastConnectedHandlerId !== this.handlerId;
            }
        },
        {
            key: "didConnectedDragSourceChange",
            value: function didConnectedDragSourceChange() {
                return this.lastConnectedDragSource !== this.dragSource;
            }
        },
        {
            key: "didConnectedDragPreviewChange",
            value: function didConnectedDragPreviewChange() {
                return this.lastConnectedDragPreview !== this.dragPreview;
            }
        },
        {
            key: "didDragSourceOptionsChange",
            value: function didDragSourceOptionsChange() {
                return !(0, $22c32b046f4aed96$export$d36bdfa510afb180)(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
            }
        },
        {
            key: "didDragPreviewOptionsChange",
            value: function didDragPreviewOptionsChange() {
                return !(0, $22c32b046f4aed96$export$d36bdfa510afb180)(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
            }
        },
        {
            key: "disconnectDragSource",
            value: function disconnectDragSource() {
                if (this.dragSourceUnsubscribe) {
                    this.dragSourceUnsubscribe();
                    this.dragSourceUnsubscribe = undefined;
                }
            }
        },
        {
            key: "disconnectDragPreview",
            value: function disconnectDragPreview() {
                if (this.dragPreviewUnsubscribe) {
                    this.dragPreviewUnsubscribe();
                    this.dragPreviewUnsubscribe = undefined;
                    this.dragPreviewNode = null;
                    this.dragPreviewRef = null;
                }
            }
        },
        {
            key: "dragSource",
            get: function get() {
                return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
            }
        },
        {
            key: "dragPreview",
            get: function get() {
                return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
            }
        },
        {
            key: "clearDragSource",
            value: function clearDragSource() {
                this.dragSourceNode = null;
                this.dragSourceRef = null;
            }
        },
        {
            key: "clearDragPreview",
            value: function clearDragPreview() {
                this.dragPreviewNode = null;
                this.dragPreviewRef = null;
            }
        }
    ]);
    return SourceConnector;
}();




function $c2add805ddf259cb$export$a5dfa024c6f78e86(dragSourceOptions, dragPreviewOptions) {
    var manager = (0, $90e871f0bd8ea2da$export$49db7e1a057ab0fa)();
    var connector = (0, $6fFrj.useMemo)(function() {
        return new (0, $fe76d73067eb2230$export$9a7176fb37ab5028)(manager.getBackend());
    }, [
        manager
    ]);
    (0, $0931f87f7be2beed$export$700979bc83e7db82)(function() {
        connector.dragSourceOptions = dragSourceOptions || null;
        connector.reconnect();
        return function() {
            return connector.disconnectDragSource();
        };
    }, [
        connector,
        dragSourceOptions
    ]);
    (0, $0931f87f7be2beed$export$700979bc83e7db82)(function() {
        connector.dragPreviewOptions = dragPreviewOptions || null;
        connector.reconnect();
        return function() {
            return connector.disconnectDragPreview();
        };
    }, [
        connector,
        dragPreviewOptions
    ]);
    return connector;
}



var $774d1ecdf9e9dfbc$exports = {};
'use strict';
// do not edit .js files directly - edit src/index.jst
$774d1ecdf9e9dfbc$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};



var $6fFrj = parcelRequire("6fFrj");

function $16674598e24d4bf3$var$_slicedToArray(arr, i) {
    return $16674598e24d4bf3$var$_arrayWithHoles(arr) || $16674598e24d4bf3$var$_iterableToArrayLimit(arr, i) || $16674598e24d4bf3$var$_unsupportedIterableToArray(arr, i) || $16674598e24d4bf3$var$_nonIterableRest();
}
function $16674598e24d4bf3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $16674598e24d4bf3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $16674598e24d4bf3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $16674598e24d4bf3$var$_arrayLikeToArray(o, minLen);
}
function $16674598e24d4bf3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $16674598e24d4bf3$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $16674598e24d4bf3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $16674598e24d4bf3$export$e32e64a4387f290a(monitor, collect, onUpdate) {
    var _useState = (0, $6fFrj.useState)(function() {
        return collect(monitor);
    }), _useState2 = $16674598e24d4bf3$var$_slicedToArray(_useState, 2), collected = _useState2[0], setCollected = _useState2[1];
    var updateCollected = (0, $6fFrj.useCallback)(function() {
        var nextValue = collect(monitor); // This needs to be a deep-equality check because some monitor-collected values
        // include XYCoord objects that may be equivalent, but do not have instance equality.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($774d1ecdf9e9dfbc$exports)))(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) onUpdate();
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]); // update the collected properties after react renders.
    // Note that the "Dustbin Stress Test" fails if this is not
    // done when the component updates
    (0, $0931f87f7be2beed$export$700979bc83e7db82)(updateCollected);
    return [
        collected,
        updateCollected
    ];
}


function $6893aa823872fcfd$var$_slicedToArray(arr, i) {
    return $6893aa823872fcfd$var$_arrayWithHoles(arr) || $6893aa823872fcfd$var$_iterableToArrayLimit(arr, i) || $6893aa823872fcfd$var$_unsupportedIterableToArray(arr, i) || $6893aa823872fcfd$var$_nonIterableRest();
}
function $6893aa823872fcfd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6893aa823872fcfd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6893aa823872fcfd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6893aa823872fcfd$var$_arrayLikeToArray(o, minLen);
}
function $6893aa823872fcfd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6893aa823872fcfd$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $6893aa823872fcfd$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6893aa823872fcfd$export$f34439a5e43bd79c(monitor, collect, onCollect) {
    var _useCollector = (0, $16674598e24d4bf3$export$e32e64a4387f290a)(monitor, collect, onCollect), _useCollector2 = $6893aa823872fcfd$var$_slicedToArray(_useCollector, 2), collected = _useCollector2[0], updateCollected = _useCollector2[1];
    (0, $0931f87f7be2beed$export$700979bc83e7db82)(function subscribeToMonitorStateChange() {
        var handlerId = monitor.getHandlerId();
        if (handlerId == null) return;
        return monitor.subscribeToStateChange(updateCollected, {
            handlerIds: [
                handlerId
            ]
        });
    }, [
        monitor,
        updateCollected
    ]);
    return collected;
}


function $c5e3ebb19bae25f0$export$a55a4e3c0acb6f15(collector, monitor, connector) {
    return (0, $6893aa823872fcfd$export$f34439a5e43bd79c)(monitor, collector || function() {
        return {};
    }, function() {
        return connector.reconnect();
    });
}



var $6fFrj = parcelRequire("6fFrj");
function $f1f9977580631ebd$export$90c397533e0cc6(connector) {
    return (0, $6fFrj.useMemo)(function() {
        return connector.hooks.dragSource();
    }, [
        connector
    ]);
}
function $f1f9977580631ebd$export$a66b3011bc8970d6(connector) {
    return (0, $6fFrj.useMemo)(function() {
        return connector.hooks.dragPreview();
    }, [
        connector
    ]);
}



function $da77e72f9345f56b$export$7941f8aafa4b6021(specArg, deps) {
    var spec = (0, $aee552824b44e43a$export$f16a07909151e918)(specArg, deps);
    (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(!spec.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
    var monitor = (0, $f18ffd1e61ca5f2a$export$82f95eab323fcd7a)();
    var connector = (0, $c2add805ddf259cb$export$a5dfa024c6f78e86)(spec.options, spec.previewOptions);
    (0, $f9f4c7970d36cc05$export$1bdd19ff5ac2e03c)(spec, monitor, connector);
    return [
        (0, $c5e3ebb19bae25f0$export$a55a4e3c0acb6f15)(spec.collect, monitor, connector),
        (0, $f1f9977580631ebd$export$90c397533e0cc6)(connector),
        (0, $f1f9977580631ebd$export$a66b3011bc8970d6)(connector)
    ];
}




var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $cbc5b365d3ac7b18$var$SvgSignature = (props)=>/*#__PURE__*/ (0, $bb3TF.jsx)("svg", {
        width: 800,
        height: 800,
        viewBox: "0 0 56 56",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
            d: "M1.188 43.487h12.505c-.245.943-.377 1.867-.377 2.716 0 3.037 1.698 5.206 5.263 5.206 4.338 0 7.846-3.056 10.11-7.922h26.123c.66 0 1.188-.51 1.188-1.17 0-.66-.528-1.15-1.188-1.15h-25.18c1.056-3.093 1.697-6.715 1.83-10.638a17.128 17.128 0 0 1 3.715-.396c.66 0 1.037.283 1.037.773 0 1.641-.886 2.924-.886 4.565 0 1.433 1.056 2.3 2.433 2.3 3.829 0 8.45-6.544 9.977-6.544 1.396 0-.339 5.885 4.414 5.885.774 0 1.773-.208 2.547-.698.452-.32.773-.773.773-1.358 0-.717-.453-1.302-1.207-1.302-.66 0-1.207.547-1.849.547-2.037 0-.094-6.262-3.847-6.262-3.282 0-8.413 6.375-9.714 6.375-.17 0-.302-.094-.302-.32 0-.68.849-2.207.849-3.735 0-1.886-1.566-3.093-4.018-3.093-1.339 0-2.66.132-3.923.377-.415-9.94-5.13-17.767-12.335-17.767-4.848 0-8.582 4.13-8.582 9.393 0 6.149 3.998 11.41 8.978 14.9-2.207 2.17-3.923 4.64-4.98 6.998H1.188c-.66 0-1.188.49-1.188 1.15 0 .66.528 1.17 1.188 1.17Zm12.223-24.218c0-3.678 2.49-6.526 5.715-6.526 5.658 0 9.317 7.035 9.487 15.674-2.603.905-4.98 2.282-7.035 3.923-3.924-2.716-8.167-7.205-8.167-13.071ZM.64 37.149c.49.49 1.226.472 1.736 0l2.357-2.357 2.358 2.358c.49.49 1.245.49 1.735 0s.49-1.245 0-1.736L6.47 33.075l2.357-2.357c.49-.49.49-1.226 0-1.717-.49-.509-1.245-.49-1.735 0l-2.358 2.34L2.377 29c-.51-.509-1.245-.509-1.736 0-.49.49-.49 1.245 0 1.717L3 33.075l-2.358 2.34c-.49.508-.49 1.244 0 1.735Zm22.993-.603c.245.113.471.17.697.17.774 0 1.32-.604 1.32-1.245 0-.472-.226-.924-.773-1.188a33.475 33.475 0 0 1-.81-.416 21.45 21.45 0 0 1 4.488-2.451c-.226 3.64-.924 6.997-1.999 9.751H17.58c.98-1.849 2.452-3.791 4.32-5.508.565.321 1.15.604 1.735.887Zm-7.375 9.11c0-.66.113-1.396.358-2.17h8.865c-1.698 3.132-3.98 5.056-6.583 5.056-1.81 0-2.64-1.188-2.64-2.886Z"
        })
    });
var $cbc5b365d3ac7b18$export$2e2bcd8739ae039 = $cbc5b365d3ac7b18$var$SvgSignature;


const { CalendarOutlined: $6c753d928d69d6c7$var$CalendarOutlined, EditOutlined: $6c753d928d69d6c7$var$EditOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Text: $6c753d928d69d6c7$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $6c753d928d69d6c7$var$style = {
    marginBottom: '1.5rem',
    cursor: 'move'
};
// this is for dragging on a new field
const $6c753d928d69d6c7$var$SignatureFieldDraggable = ({ name: name, fieldType: fieldType })=>{
    const [{ isDragging: isDragging }, drag] = (0, $da77e72f9345f56b$export$7941f8aafa4b6021)(()=>({
            type: 'SIGNATURE_FIELD',
            item: {
                name: name,
                fieldType: fieldType
            },
            end: (item, monitor)=>{
                const dropResult = monitor.getDropResult();
                if (item && dropResult) // alert(`You dropped ${item.name} into ${dropResult.name}!`)
                console.log('Dropped in ', item, ' Container: ', dropResult);
            },
            collect: (monitor)=>({
                    isDragging: monitor.isDragging(),
                    handlerId: monitor.getHandlerId()
                })
        }), [
        name,
        fieldType
    ]);
    const opacity = isDragging ? 0.4 : 1;
    return (0, $bb3TF.jsx)((0, $3c2758025c182ca4$export$2e2bcd8739ae039), {
        style: {
            ...$6c753d928d69d6c7$var$style,
            opacity: opacity,
            width: '100%'
        },
        ref: drag,
        color: "success",
        children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            style: {
                flexFlow: 'nowrap'
            },
            justify: "center",
            children: [
                fieldType === (0, $8f7fe33a44836803$export$ed12481c953b8653).Signature && (0, $bb3TF.jsx)((0, $cbc5b365d3ac7b18$export$2e2bcd8739ae039), {
                    style: {
                        height: '18px',
                        width: '18px',
                        minWidth: '18px',
                        marginRight: '5px',
                        fill: '#52c41a'
                    }
                }),
                fieldType === (0, $8f7fe33a44836803$export$ed12481c953b8653).Date && (0, $bb3TF.jsx)($6c753d928d69d6c7$var$CalendarOutlined, {
                    style: {
                        height: '14px',
                        width: '14px',
                        minWidth: '14px',
                        margin: '3px 5px 0 0'
                    }
                }),
                fieldType === (0, $8f7fe33a44836803$export$ed12481c953b8653).Text && (0, $bb3TF.jsx)($6c753d928d69d6c7$var$EditOutlined, {
                    style: {
                        height: '14px',
                        width: '14px',
                        minWidth: '14px',
                        margin: '3px 5px 0 0'
                    }
                }),
                (0, $bb3TF.jsx)($6c753d928d69d6c7$var$Text, {
                    style: {
                        color: '#52c41a'
                    },
                    children: name
                })
            ]
        })
    });
};
var $6c753d928d69d6c7$export$2e2bcd8739ae039 = $6c753d928d69d6c7$var$SignatureFieldDraggable;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");





var $6fFrj = parcelRequire("6fFrj");
function $70035ee5c67fc0b3$export$2a5cc7f0ac8651d0(spec) {
    var accept = spec.accept;
    return (0, $6fFrj.useMemo)(function() {
        (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(spec.accept != null, 'accept must be defined');
        return Array.isArray(accept) ? accept : [
            accept
        ];
    }, [
        accept
    ]);
}



var $6fFrj = parcelRequire("6fFrj");
function $99e072ab356634aa$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $99e072ab356634aa$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $99e072ab356634aa$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $99e072ab356634aa$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $99e072ab356634aa$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $99e072ab356634aa$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $99e072ab356634aa$export$f26a17703f5cb233 = /*#__PURE__*/ function() {
    function DropTargetImpl(spec, monitor) {
        $99e072ab356634aa$var$_classCallCheck(this, DropTargetImpl);
        $99e072ab356634aa$var$_defineProperty(this, "spec", void 0);
        $99e072ab356634aa$var$_defineProperty(this, "monitor", void 0);
        this.spec = spec;
        this.monitor = monitor;
    }
    $99e072ab356634aa$var$_createClass(DropTargetImpl, [
        {
            key: "canDrop",
            value: function canDrop() {
                var spec = this.spec;
                var monitor = this.monitor;
                return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
            }
        },
        {
            key: "hover",
            value: function hover() {
                var spec = this.spec;
                var monitor = this.monitor;
                if (spec.hover) spec.hover(monitor.getItem(), monitor);
            }
        },
        {
            key: "drop",
            value: function drop() {
                var spec = this.spec;
                var monitor = this.monitor;
                if (spec.drop) return spec.drop(monitor.getItem(), monitor);
            }
        }
    ]);
    return DropTargetImpl;
}();


function $2b99ceb412541fd8$export$5967d4bb72ce3c0(spec, monitor) {
    var dropTarget = (0, $6fFrj.useMemo)(function() {
        return new (0, $99e072ab356634aa$export$f26a17703f5cb233)(spec, monitor);
    }, [
        monitor
    ]);
    (0, $6fFrj.useEffect)(function() {
        dropTarget.spec = spec;
    }, [
        spec
    ]);
    return dropTarget;
}


function $855754081dacf24d$var$_slicedToArray(arr, i) {
    return $855754081dacf24d$var$_arrayWithHoles(arr) || $855754081dacf24d$var$_iterableToArrayLimit(arr, i) || $855754081dacf24d$var$_unsupportedIterableToArray(arr, i) || $855754081dacf24d$var$_nonIterableRest();
}
function $855754081dacf24d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $855754081dacf24d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $855754081dacf24d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $855754081dacf24d$var$_arrayLikeToArray(o, minLen);
}
function $855754081dacf24d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $855754081dacf24d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $855754081dacf24d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $855754081dacf24d$export$b31a008bfacf9de1(spec, monitor, connector) {
    var manager = (0, $90e871f0bd8ea2da$export$49db7e1a057ab0fa)();
    var dropTarget = (0, $2b99ceb412541fd8$export$5967d4bb72ce3c0)(spec, monitor);
    var accept = (0, $70035ee5c67fc0b3$export$2a5cc7f0ac8651d0)(spec);
    (0, $0931f87f7be2beed$export$700979bc83e7db82)(function registerDropTarget() {
        var _registerTarget = (0, $50e0cf5e1a578a2e$export$38b18180ae58b09b)(accept, dropTarget, manager), _registerTarget2 = $855754081dacf24d$var$_slicedToArray(_registerTarget, 2), handlerId = _registerTarget2[0], unregister = _registerTarget2[1];
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [
        manager,
        monitor,
        dropTarget,
        connector,
        accept.map(function(a) {
            return a.toString();
        }).join('|')
    ]);
}




var $6fFrj = parcelRequire("6fFrj");

function $c5524a144f09b95f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c5524a144f09b95f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c5524a144f09b95f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c5524a144f09b95f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c5524a144f09b95f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c5524a144f09b95f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $c5524a144f09b95f$var$isCallingCanDrop = false;
var $c5524a144f09b95f$export$9fe8834769ae8ddf = /*#__PURE__*/ function() {
    function DropTargetMonitorImpl(manager) {
        $c5524a144f09b95f$var$_classCallCheck(this, DropTargetMonitorImpl);
        $c5524a144f09b95f$var$_defineProperty(this, "internalMonitor", void 0);
        $c5524a144f09b95f$var$_defineProperty(this, "targetId", null);
        this.internalMonitor = manager.getMonitor();
    }
    $c5524a144f09b95f$var$_createClass(DropTargetMonitorImpl, [
        {
            key: "receiveHandlerId",
            value: function receiveHandlerId(targetId) {
                this.targetId = targetId;
            }
        },
        {
            key: "getHandlerId",
            value: function getHandlerId() {
                return this.targetId;
            }
        },
        {
            key: "subscribeToStateChange",
            value: function subscribeToStateChange(listener, options) {
                return this.internalMonitor.subscribeToStateChange(listener, options);
            }
        },
        {
            key: "canDrop",
            value: function canDrop() {
                // Cut out early if the target id has not been set. This should prevent errors
                // where the user has an older version of dnd-core like in
                // https://github.com/react-dnd/react-dnd/issues/1310
                if (!this.targetId) return false;
                (0, $8aab30aa2c6b9d90$export$f5708dca728d7177)(!$c5524a144f09b95f$var$isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
                try {
                    $c5524a144f09b95f$var$isCallingCanDrop = true;
                    return this.internalMonitor.canDropOnTarget(this.targetId);
                } finally{
                    $c5524a144f09b95f$var$isCallingCanDrop = false;
                }
            }
        },
        {
            key: "isOver",
            value: function isOver(options) {
                if (!this.targetId) return false;
                return this.internalMonitor.isOverTarget(this.targetId, options);
            }
        },
        {
            key: "getItemType",
            value: function getItemType() {
                return this.internalMonitor.getItemType();
            }
        },
        {
            key: "getItem",
            value: function getItem() {
                return this.internalMonitor.getItem();
            }
        },
        {
            key: "getDropResult",
            value: function getDropResult() {
                return this.internalMonitor.getDropResult();
            }
        },
        {
            key: "didDrop",
            value: function didDrop() {
                return this.internalMonitor.didDrop();
            }
        },
        {
            key: "getInitialClientOffset",
            value: function getInitialClientOffset() {
                return this.internalMonitor.getInitialClientOffset();
            }
        },
        {
            key: "getInitialSourceClientOffset",
            value: function getInitialSourceClientOffset() {
                return this.internalMonitor.getInitialSourceClientOffset();
            }
        },
        {
            key: "getSourceClientOffset",
            value: function getSourceClientOffset() {
                return this.internalMonitor.getSourceClientOffset();
            }
        },
        {
            key: "getClientOffset",
            value: function getClientOffset() {
                return this.internalMonitor.getClientOffset();
            }
        },
        {
            key: "getDifferenceFromInitialOffset",
            value: function getDifferenceFromInitialOffset() {
                return this.internalMonitor.getDifferenceFromInitialOffset();
            }
        }
    ]);
    return DropTargetMonitorImpl;
}();



function $25f453dc0a42930a$export$f0c0ad05844dec3b() {
    var manager = (0, $90e871f0bd8ea2da$export$49db7e1a057ab0fa)();
    return (0, $6fFrj.useMemo)(function() {
        return new (0, $c5524a144f09b95f$export$9fe8834769ae8ddf)(manager);
    }, [
        manager
    ]);
}



var $6fFrj = parcelRequire("6fFrj");



function $5f830daed4a36ca5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5f830daed4a36ca5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5f830daed4a36ca5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5f830daed4a36ca5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5f830daed4a36ca5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5f830daed4a36ca5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5f830daed4a36ca5$export$ed6d7b7bc55193cf = /*#__PURE__*/ function() {
    // The drop target may either be attached via ref or connect function
    function TargetConnector(backend) {
        var _this = this;
        $5f830daed4a36ca5$var$_classCallCheck(this, TargetConnector);
        $5f830daed4a36ca5$var$_defineProperty(this, "hooks", (0, $1e4be2c3df09d07c$export$d8dcaf80ab4f6cb7)({
            dropTarget: function dropTarget(node, options) {
                _this.clearDropTarget();
                _this.dropTargetOptions = options;
                if ((0, $06e669ce97b8041c$export$4f9f5282de18fc69)(node)) _this.dropTargetRef = node;
                else _this.dropTargetNode = node;
                _this.reconnect();
            }
        }));
        $5f830daed4a36ca5$var$_defineProperty(this, "handlerId", null);
        $5f830daed4a36ca5$var$_defineProperty(this, "dropTargetRef", null);
        $5f830daed4a36ca5$var$_defineProperty(this, "dropTargetNode", void 0);
        $5f830daed4a36ca5$var$_defineProperty(this, "dropTargetOptionsInternal", null);
        $5f830daed4a36ca5$var$_defineProperty(this, "unsubscribeDropTarget", void 0);
        $5f830daed4a36ca5$var$_defineProperty(this, "lastConnectedHandlerId", null);
        $5f830daed4a36ca5$var$_defineProperty(this, "lastConnectedDropTarget", null);
        $5f830daed4a36ca5$var$_defineProperty(this, "lastConnectedDropTargetOptions", null);
        $5f830daed4a36ca5$var$_defineProperty(this, "backend", void 0);
        this.backend = backend;
    }
    $5f830daed4a36ca5$var$_createClass(TargetConnector, [
        {
            key: "connectTarget",
            get: function get() {
                return this.dropTarget;
            }
        },
        {
            key: "reconnect",
            value: function reconnect() {
                // if nothing has changed then don't resubscribe
                var didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
                if (didChange) this.disconnectDropTarget();
                var dropTarget = this.dropTarget;
                if (!this.handlerId) return;
                if (!dropTarget) {
                    this.lastConnectedDropTarget = dropTarget;
                    return;
                }
                if (didChange) {
                    this.lastConnectedHandlerId = this.handlerId;
                    this.lastConnectedDropTarget = dropTarget;
                    this.lastConnectedDropTargetOptions = this.dropTargetOptions;
                    this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
                }
            }
        },
        {
            key: "receiveHandlerId",
            value: function receiveHandlerId(newHandlerId) {
                if (newHandlerId === this.handlerId) return;
                this.handlerId = newHandlerId;
                this.reconnect();
            }
        },
        {
            key: "dropTargetOptions",
            get: function get() {
                return this.dropTargetOptionsInternal;
            },
            set: function set(options) {
                this.dropTargetOptionsInternal = options;
            }
        },
        {
            key: "didHandlerIdChange",
            value: function didHandlerIdChange() {
                return this.lastConnectedHandlerId !== this.handlerId;
            }
        },
        {
            key: "didDropTargetChange",
            value: function didDropTargetChange() {
                return this.lastConnectedDropTarget !== this.dropTarget;
            }
        },
        {
            key: "didOptionsChange",
            value: function didOptionsChange() {
                return !(0, $22c32b046f4aed96$export$d36bdfa510afb180)(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
            }
        },
        {
            key: "disconnectDropTarget",
            value: function disconnectDropTarget() {
                if (this.unsubscribeDropTarget) {
                    this.unsubscribeDropTarget();
                    this.unsubscribeDropTarget = undefined;
                }
            }
        },
        {
            key: "dropTarget",
            get: function get() {
                return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
            }
        },
        {
            key: "clearDropTarget",
            value: function clearDropTarget() {
                this.dropTargetRef = null;
                this.dropTargetNode = null;
            }
        }
    ]);
    return TargetConnector;
}();




function $5a2f5bc664f7ae14$export$29242ded1aad6df7(options) {
    var manager = (0, $90e871f0bd8ea2da$export$49db7e1a057ab0fa)();
    var connector = (0, $6fFrj.useMemo)(function() {
        return new (0, $5f830daed4a36ca5$export$ed6d7b7bc55193cf)(manager.getBackend());
    }, [
        manager
    ]);
    (0, $0931f87f7be2beed$export$700979bc83e7db82)(function() {
        connector.dropTargetOptions = options || null;
        connector.reconnect();
        return function() {
            return connector.disconnectDropTarget();
        };
    }, [
        options
    ]);
    return connector;
}




var $6fFrj = parcelRequire("6fFrj");
function $3749dfce4b42140e$export$c914595a34b9504a(connector) {
    return (0, $6fFrj.useMemo)(function() {
        return connector.hooks.dropTarget();
    }, [
        connector
    ]);
}


function $985e950531ae07dc$export$ccdee5eaf73cf661(specArg, deps) {
    var spec = (0, $aee552824b44e43a$export$f16a07909151e918)(specArg, deps);
    var monitor = (0, $25f453dc0a42930a$export$f0c0ad05844dec3b)();
    var connector = (0, $5a2f5bc664f7ae14$export$29242ded1aad6df7)(spec.options);
    (0, $855754081dacf24d$export$b31a008bfacf9de1)(spec, monitor, connector);
    return [
        (0, $c5e3ebb19bae25f0$export$a55a4e3c0acb6f15)(spec.collect, monitor, connector),
        (0, $3749dfce4b42140e$export$c914595a34b9504a)(connector)
    ];
}



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");
var $a9af34f79898d35a$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $a9af34f79898d35a$export$84fe03429ed1b6d6 = [
    'onCopy',
    'onCut',
    'onPaste'
];
var $a9af34f79898d35a$export$dbc46161504615f7 = [
    'onCompositionEnd',
    'onCompositionStart',
    'onCompositionUpdate'
];
var $a9af34f79898d35a$export$fb6351c2666f0875 = [
    'onFocus',
    'onBlur'
];
var $a9af34f79898d35a$export$4e58c1a9761ed81a = [
    'onInput',
    'onInvalid',
    'onReset',
    'onSubmit'
];
var $a9af34f79898d35a$export$3bf7402f2a4eb3af = [
    'onLoad',
    'onError'
];
var $a9af34f79898d35a$export$409c4891d97f97cf = [
    'onKeyDown',
    'onKeyPress',
    'onKeyUp'
];
var $a9af34f79898d35a$export$6be5aa2386088264 = [
    'onAbort',
    'onCanPlay',
    'onCanPlayThrough',
    'onDurationChange',
    'onEmptied',
    'onEncrypted',
    'onEnded',
    'onError',
    'onLoadedData',
    'onLoadedMetadata',
    'onLoadStart',
    'onPause',
    'onPlay',
    'onPlaying',
    'onProgress',
    'onRateChange',
    'onSeeked',
    'onSeeking',
    'onStalled',
    'onSuspend',
    'onTimeUpdate',
    'onVolumeChange',
    'onWaiting'
];
var $a9af34f79898d35a$export$3a6e2b8954613992 = [
    'onClick',
    'onContextMenu',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp'
];
var $a9af34f79898d35a$export$6c96379d5b8a2df7 = [
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop'
];
var $a9af34f79898d35a$export$d93346aa7735a637 = [
    'onSelect'
];
var $a9af34f79898d35a$export$fa367689c659e65c = [
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart'
];
var $a9af34f79898d35a$export$c731eab7619e00a0 = [
    'onPointerDown',
    'onPointerMove',
    'onPointerUp',
    'onPointerCancel',
    'onGotPointerCapture',
    'onLostPointerCapture',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerOver',
    'onPointerOut'
];
var $a9af34f79898d35a$export$bac3087b5cb826f6 = [
    'onScroll'
];
var $a9af34f79898d35a$export$28298837799e00e8 = [
    'onWheel'
];
var $a9af34f79898d35a$export$6ff45424014e7407 = [
    'onAnimationStart',
    'onAnimationEnd',
    'onAnimationIteration'
];
var $a9af34f79898d35a$export$78878fc7bd50dc3e = [
    'onTransitionEnd'
];
var $a9af34f79898d35a$export$477a88c5b93a108d = [
    'onToggle'
];
var $a9af34f79898d35a$export$7212b61f9f58bd1 = [
    'onChange'
];
var $a9af34f79898d35a$export$59ef7197c4d7b9dc = $a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray($a9af34f79898d35a$var$__spreadArray([], $a9af34f79898d35a$export$84fe03429ed1b6d6, true), $a9af34f79898d35a$export$dbc46161504615f7, true), $a9af34f79898d35a$export$fb6351c2666f0875, true), $a9af34f79898d35a$export$4e58c1a9761ed81a, true), $a9af34f79898d35a$export$3bf7402f2a4eb3af, true), $a9af34f79898d35a$export$409c4891d97f97cf, true), $a9af34f79898d35a$export$6be5aa2386088264, true), $a9af34f79898d35a$export$3a6e2b8954613992, true), $a9af34f79898d35a$export$6c96379d5b8a2df7, true), $a9af34f79898d35a$export$d93346aa7735a637, true), $a9af34f79898d35a$export$fa367689c659e65c, true), $a9af34f79898d35a$export$c731eab7619e00a0, true), $a9af34f79898d35a$export$bac3087b5cb826f6, true), $a9af34f79898d35a$export$28298837799e00e8, true), $a9af34f79898d35a$export$6ff45424014e7407, true), $a9af34f79898d35a$export$78878fc7bd50dc3e, true), $a9af34f79898d35a$export$7212b61f9f58bd1, true), $a9af34f79898d35a$export$477a88c5b93a108d, true);
function $a9af34f79898d35a$export$2e2bcd8739ae039(props, getArgs) {
    var eventProps = {};
    $a9af34f79898d35a$export$59ef7197c4d7b9dc.forEach(function(eventName) {
        var eventHandler = props[eventName];
        if (!eventHandler) return;
        if (getArgs) eventProps[eventName] = function(event) {
            return eventHandler(event, getArgs(eventName));
        };
        else eventProps[eventName] = eventHandler;
    });
    return eventProps;
}


function $e6416ed4a1a78a14$export$2e2bcd8739ae039(promise) {
    var isCancelled = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(value) {
            return !isCancelled && resolve(value);
        }).catch(function(error) {
            return !isCancelled && reject(error);
        });
    });
    return {
        promise: wrappedPromise,
        cancel: function() {
            isCancelled = true;
        }
    };
}


function $47f64881d26a6a18$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $47f64881d26a6a18$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $47f64881d26a6a18$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $47f64881d26a6a18$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $47f64881d26a6a18$export$2e2bcd8739ae039 = $47f64881d26a6a18$export$4f5d2d50c9deca37;


var $60bcf762ed5a0ede$var$isProduction = true;
var $60bcf762ed5a0ede$var$prefix = 'Invariant failed';
function $60bcf762ed5a0ede$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($60bcf762ed5a0ede$var$isProduction) throw new Error($60bcf762ed5a0ede$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($60bcf762ed5a0ede$var$prefix, ": ").concat(provided) : $60bcf762ed5a0ede$var$prefix;
    throw new Error(value);
}



var $3b52b919fe9803ad$var$has = Object.prototype.hasOwnProperty;
function $3b52b919fe9803ad$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($3b52b919fe9803ad$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $3b52b919fe9803ad$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $3b52b919fe9803ad$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $3b52b919fe9803ad$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $3b52b919fe9803ad$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$3b52b919fe9803ad$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($3b52b919fe9803ad$var$has.call(foo, ctor) && ++len && !$3b52b919fe9803ad$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$3b52b919fe9803ad$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}


var $cca4aceb320d03d3$exports = {};

$parcel$export($cca4aceb320d03d3$exports, "AbortException", function () { return $cca4aceb320d03d3$export$d0e978393d193d1a; });
$parcel$export($cca4aceb320d03d3$exports, "AnnotationEditorLayer", function () { return $cca4aceb320d03d3$export$47948c9fe1adbf1b; });
$parcel$export($cca4aceb320d03d3$exports, "AnnotationEditorParamsType", function () { return $cca4aceb320d03d3$export$cf3df2a6ecc26692; });
$parcel$export($cca4aceb320d03d3$exports, "AnnotationEditorType", function () { return $cca4aceb320d03d3$export$72ea3bfdd9a725bf; });
$parcel$export($cca4aceb320d03d3$exports, "AnnotationEditorUIManager", function () { return $cca4aceb320d03d3$export$26cb16552a82cf63; });
$parcel$export($cca4aceb320d03d3$exports, "AnnotationLayer", function () { return $cca4aceb320d03d3$export$3e7f45c326d9366c; });
$parcel$export($cca4aceb320d03d3$exports, "AnnotationMode", function () { return $cca4aceb320d03d3$export$5a7af0c07e33392e; });
$parcel$export($cca4aceb320d03d3$exports, "CMapCompressionType", function () { return $cca4aceb320d03d3$export$7c23995f9a5b159; });
$parcel$export($cca4aceb320d03d3$exports, "ColorPicker", function () { return $cca4aceb320d03d3$export$9feb1bc2e5f1ccb3; });
$parcel$export($cca4aceb320d03d3$exports, "DOMSVGFactory", function () { return $cca4aceb320d03d3$export$425e69f00724e63a; });
$parcel$export($cca4aceb320d03d3$exports, "DrawLayer", function () { return $cca4aceb320d03d3$export$3eb4521511f02450; });
$parcel$export($cca4aceb320d03d3$exports, "FeatureTest", function () { return $cca4aceb320d03d3$export$5fb8891d35c36978; });
$parcel$export($cca4aceb320d03d3$exports, "GlobalWorkerOptions", function () { return $cca4aceb320d03d3$export$edf38ba293eb934; });
$parcel$export($cca4aceb320d03d3$exports, "ImageKind", function () { return $cca4aceb320d03d3$export$b890e9c15247e0b3; });
$parcel$export($cca4aceb320d03d3$exports, "InvalidPDFException", function () { return $cca4aceb320d03d3$export$e3d0f4ce5b91e9f1; });
$parcel$export($cca4aceb320d03d3$exports, "MissingPDFException", function () { return $cca4aceb320d03d3$export$33dda1a4114f3e73; });
$parcel$export($cca4aceb320d03d3$exports, "OPS", function () { return $cca4aceb320d03d3$export$3a0f7f7a8a0b306b; });
$parcel$export($cca4aceb320d03d3$exports, "Outliner", function () { return $cca4aceb320d03d3$export$8b4a90ba6f04789e; });
$parcel$export($cca4aceb320d03d3$exports, "PDFDataRangeTransport", function () { return $cca4aceb320d03d3$export$c06899d9d7bce9ab; });
$parcel$export($cca4aceb320d03d3$exports, "PDFDateString", function () { return $cca4aceb320d03d3$export$66cbc314498fffc; });
$parcel$export($cca4aceb320d03d3$exports, "PDFWorker", function () { return $cca4aceb320d03d3$export$84e2e9f37426b265; });
$parcel$export($cca4aceb320d03d3$exports, "PasswordResponses", function () { return $cca4aceb320d03d3$export$5e72215208e4d9ad; });
$parcel$export($cca4aceb320d03d3$exports, "PermissionFlag", function () { return $cca4aceb320d03d3$export$bb99a5b8411e07d8; });
$parcel$export($cca4aceb320d03d3$exports, "PixelsPerInch", function () { return $cca4aceb320d03d3$export$6ef3b6b69e65342c; });
$parcel$export($cca4aceb320d03d3$exports, "RenderingCancelledException", function () { return $cca4aceb320d03d3$export$245847d31c09154f; });
$parcel$export($cca4aceb320d03d3$exports, "TextLayer", function () { return $cca4aceb320d03d3$export$fdbdc423a78c5262; });
$parcel$export($cca4aceb320d03d3$exports, "UnexpectedResponseException", function () { return $cca4aceb320d03d3$export$bed32a6c95ee1622; });
$parcel$export($cca4aceb320d03d3$exports, "Util", function () { return $cca4aceb320d03d3$export$f8f26dd395d7e1bd; });
$parcel$export($cca4aceb320d03d3$exports, "VerbosityLevel", function () { return $cca4aceb320d03d3$export$b18df09d23c244c4; });
$parcel$export($cca4aceb320d03d3$exports, "XfaLayer", function () { return $cca4aceb320d03d3$export$f6af20c312d4b9a2; });
$parcel$export($cca4aceb320d03d3$exports, "build", function () { return $cca4aceb320d03d3$export$3f8fe6489e95757d; });
$parcel$export($cca4aceb320d03d3$exports, "createValidAbsoluteUrl", function () { return $cca4aceb320d03d3$export$e076b47f5805ca0b; });
$parcel$export($cca4aceb320d03d3$exports, "fetchData", function () { return $cca4aceb320d03d3$export$8134c072fddab6a5; });
$parcel$export($cca4aceb320d03d3$exports, "getDocument", function () { return $cca4aceb320d03d3$export$f65ca476c09acec0; });
$parcel$export($cca4aceb320d03d3$exports, "getFilenameFromUrl", function () { return $cca4aceb320d03d3$export$b1c11df0696253ae; });
$parcel$export($cca4aceb320d03d3$exports, "getPdfFilenameFromUrl", function () { return $cca4aceb320d03d3$export$9de51790aa4bc73a; });
$parcel$export($cca4aceb320d03d3$exports, "getXfaPageViewport", function () { return $cca4aceb320d03d3$export$dd5d6edf3fc80aae; });
$parcel$export($cca4aceb320d03d3$exports, "isDataScheme", function () { return $cca4aceb320d03d3$export$f67aae4532d8295b; });
$parcel$export($cca4aceb320d03d3$exports, "isPdfFile", function () { return $cca4aceb320d03d3$export$61b52d3570d24719; });
$parcel$export($cca4aceb320d03d3$exports, "noContextMenu", function () { return $cca4aceb320d03d3$export$455b7811f904cadc; });
$parcel$export($cca4aceb320d03d3$exports, "normalizeUnicode", function () { return $cca4aceb320d03d3$export$1fa1e6b1a06bd7fa; });
$parcel$export($cca4aceb320d03d3$exports, "renderTextLayer", function () { return $cca4aceb320d03d3$export$f5f25a69ba172b88; });
$parcel$export($cca4aceb320d03d3$exports, "setLayerDimensions", function () { return $cca4aceb320d03d3$export$af0a15a86e590226; });
$parcel$export($cca4aceb320d03d3$exports, "shadow", function () { return $cca4aceb320d03d3$export$b8972b998723d602; });
$parcel$export($cca4aceb320d03d3$exports, "updateTextLayer", function () { return $cca4aceb320d03d3$export$36a3594acc1522d8; });
$parcel$export($cca4aceb320d03d3$exports, "version", function () { return $cca4aceb320d03d3$export$83d89fbfd8236492; });
/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2023 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ /******/ // The require scope
/******/ 
var $8LKEK = parcelRequire("8LKEK");

var $cca4aceb320d03d3$require$Buffer = $c62b475e31b1e858$export$a143d493d941bafc;
var $cca4aceb320d03d3$var$__webpack_require__ = {};
/******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
    /******/ // define getter functions for harmony exports
    /******/ $cca4aceb320d03d3$var$__webpack_require__.d = (exports, definition)=>{
        /******/ for(var key in definition)/******/ if ($cca4aceb320d03d3$var$__webpack_require__.o(definition, key) && !$cca4aceb320d03d3$var$__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
        });
    /******/ };
/******/ })();
/******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
    /******/ $cca4aceb320d03d3$var$__webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
/******/ })();
/******/ /************************************************************************/ var $cca4aceb320d03d3$var$__webpack_exports__ = globalThis.pdfjsLib = {};
// EXPORTS
$cca4aceb320d03d3$var$__webpack_require__.d($cca4aceb320d03d3$var$__webpack_exports__, {
    AbortException: ()=>/* reexport */ $cca4aceb320d03d3$var$AbortException,
    AnnotationEditorLayer: ()=>/* reexport */ $cca4aceb320d03d3$var$AnnotationEditorLayer,
    AnnotationEditorParamsType: ()=>/* reexport */ $cca4aceb320d03d3$var$AnnotationEditorParamsType,
    AnnotationEditorType: ()=>/* reexport */ $cca4aceb320d03d3$var$AnnotationEditorType,
    AnnotationEditorUIManager: ()=>/* reexport */ $cca4aceb320d03d3$var$AnnotationEditorUIManager,
    AnnotationLayer: ()=>/* reexport */ $cca4aceb320d03d3$var$AnnotationLayer,
    AnnotationMode: ()=>/* reexport */ $cca4aceb320d03d3$var$AnnotationMode,
    CMapCompressionType: ()=>/* reexport */ $cca4aceb320d03d3$var$CMapCompressionType,
    ColorPicker: ()=>/* reexport */ $cca4aceb320d03d3$var$ColorPicker,
    DOMSVGFactory: ()=>/* reexport */ $cca4aceb320d03d3$var$DOMSVGFactory,
    DrawLayer: ()=>/* reexport */ $cca4aceb320d03d3$var$DrawLayer,
    FeatureTest: ()=>/* reexport */ $cca4aceb320d03d3$var$util_FeatureTest,
    GlobalWorkerOptions: ()=>/* reexport */ $cca4aceb320d03d3$var$GlobalWorkerOptions,
    ImageKind: ()=>/* reexport */ $cca4aceb320d03d3$var$util_ImageKind,
    InvalidPDFException: ()=>/* reexport */ $cca4aceb320d03d3$var$InvalidPDFException,
    MissingPDFException: ()=>/* reexport */ $cca4aceb320d03d3$var$MissingPDFException,
    OPS: ()=>/* reexport */ $cca4aceb320d03d3$var$OPS,
    Outliner: ()=>/* reexport */ $cca4aceb320d03d3$var$Outliner,
    PDFDataRangeTransport: ()=>/* reexport */ $cca4aceb320d03d3$var$PDFDataRangeTransport,
    PDFDateString: ()=>/* reexport */ $cca4aceb320d03d3$var$PDFDateString,
    PDFWorker: ()=>/* reexport */ $cca4aceb320d03d3$var$PDFWorker,
    PasswordResponses: ()=>/* reexport */ $cca4aceb320d03d3$var$PasswordResponses,
    PermissionFlag: ()=>/* reexport */ $cca4aceb320d03d3$var$PermissionFlag,
    PixelsPerInch: ()=>/* reexport */ $cca4aceb320d03d3$var$PixelsPerInch,
    RenderingCancelledException: ()=>/* reexport */ $cca4aceb320d03d3$var$RenderingCancelledException,
    TextLayer: ()=>/* reexport */ $cca4aceb320d03d3$var$TextLayer,
    UnexpectedResponseException: ()=>/* reexport */ $cca4aceb320d03d3$var$UnexpectedResponseException,
    Util: ()=>/* reexport */ $cca4aceb320d03d3$var$Util,
    VerbosityLevel: ()=>/* reexport */ $cca4aceb320d03d3$var$VerbosityLevel,
    XfaLayer: ()=>/* reexport */ $cca4aceb320d03d3$var$XfaLayer,
    build: ()=>/* reexport */ $cca4aceb320d03d3$var$build,
    createValidAbsoluteUrl: ()=>/* reexport */ $cca4aceb320d03d3$var$createValidAbsoluteUrl,
    fetchData: ()=>/* reexport */ $cca4aceb320d03d3$var$fetchData,
    getDocument: ()=>/* reexport */ $cca4aceb320d03d3$var$getDocument,
    getFilenameFromUrl: ()=>/* reexport */ $cca4aceb320d03d3$var$getFilenameFromUrl,
    getPdfFilenameFromUrl: ()=>/* reexport */ $cca4aceb320d03d3$var$getPdfFilenameFromUrl,
    getXfaPageViewport: ()=>/* reexport */ $cca4aceb320d03d3$var$getXfaPageViewport,
    isDataScheme: ()=>/* reexport */ $cca4aceb320d03d3$var$isDataScheme,
    isPdfFile: ()=>/* reexport */ $cca4aceb320d03d3$var$isPdfFile,
    noContextMenu: ()=>/* reexport */ $cca4aceb320d03d3$var$noContextMenu,
    normalizeUnicode: ()=>/* reexport */ $cca4aceb320d03d3$var$normalizeUnicode,
    renderTextLayer: ()=>/* reexport */ $cca4aceb320d03d3$var$renderTextLayer,
    setLayerDimensions: ()=>/* reexport */ $cca4aceb320d03d3$var$setLayerDimensions,
    shadow: ()=>/* reexport */ $cca4aceb320d03d3$var$shadow,
    updateTextLayer: ()=>/* reexport */ $cca4aceb320d03d3$var$updateTextLayer,
    version: ()=>/* reexport */ $cca4aceb320d03d3$var$version
});
const $cca4aceb320d03d3$var$isNodeJS = typeof $8LKEK === "object" && $8LKEK + "" === "[object process]" && !$8LKEK.versions.nw && !($8LKEK.versions.electron && $8LKEK.type && $8LKEK.type !== "browser");
const $cca4aceb320d03d3$var$IDENTITY_MATRIX = [
    1,
    0,
    0,
    1,
    0,
    0
];
const $cca4aceb320d03d3$var$FONT_IDENTITY_MATRIX = [
    0.001,
    0,
    0,
    0.001,
    0,
    0
];
const $cca4aceb320d03d3$var$MAX_IMAGE_SIZE_TO_CACHE = 10e6;
const $cca4aceb320d03d3$var$LINE_FACTOR = 1.35;
const $cca4aceb320d03d3$var$LINE_DESCENT_FACTOR = 0.35;
const $cca4aceb320d03d3$var$BASELINE_FACTOR = $cca4aceb320d03d3$var$LINE_DESCENT_FACTOR / $cca4aceb320d03d3$var$LINE_FACTOR;
const $cca4aceb320d03d3$var$RenderingIntentFlag = {
    ANY: 0x01,
    DISPLAY: 0x02,
    PRINT: 0x04,
    SAVE: 0x08,
    ANNOTATIONS_FORMS: 0x10,
    ANNOTATIONS_STORAGE: 0x20,
    ANNOTATIONS_DISABLE: 0x40,
    OPLIST: 0x100
};
const $cca4aceb320d03d3$var$AnnotationMode = {
    DISABLE: 0,
    ENABLE: 1,
    ENABLE_FORMS: 2,
    ENABLE_STORAGE: 3
};
const $cca4aceb320d03d3$var$AnnotationEditorPrefix = "pdfjs_internal_editor_";
const $cca4aceb320d03d3$var$AnnotationEditorType = {
    DISABLE: -1,
    NONE: 0,
    FREETEXT: 3,
    HIGHLIGHT: 9,
    STAMP: 13,
    INK: 15
};
const $cca4aceb320d03d3$var$AnnotationEditorParamsType = {
    RESIZE: 1,
    CREATE: 2,
    FREETEXT_SIZE: 11,
    FREETEXT_COLOR: 12,
    FREETEXT_OPACITY: 13,
    INK_COLOR: 21,
    INK_THICKNESS: 22,
    INK_OPACITY: 23,
    HIGHLIGHT_COLOR: 31,
    HIGHLIGHT_DEFAULT_COLOR: 32,
    HIGHLIGHT_THICKNESS: 33,
    HIGHLIGHT_FREE: 34,
    HIGHLIGHT_SHOW_ALL: 35
};
const $cca4aceb320d03d3$var$PermissionFlag = {
    PRINT: 0x04,
    MODIFY_CONTENTS: 0x08,
    COPY: 0x10,
    MODIFY_ANNOTATIONS: 0x20,
    FILL_INTERACTIVE_FORMS: 0x100,
    COPY_FOR_ACCESSIBILITY: 0x200,
    ASSEMBLE: 0x400,
    PRINT_HIGH_QUALITY: 0x800
};
const $cca4aceb320d03d3$var$TextRenderingMode = {
    FILL: 0,
    STROKE: 1,
    FILL_STROKE: 2,
    INVISIBLE: 3,
    FILL_ADD_TO_PATH: 4,
    STROKE_ADD_TO_PATH: 5,
    FILL_STROKE_ADD_TO_PATH: 6,
    ADD_TO_PATH: 7,
    FILL_STROKE_MASK: 3,
    ADD_TO_PATH_FLAG: 4
};
const $cca4aceb320d03d3$var$util_ImageKind = {
    GRAYSCALE_1BPP: 1,
    RGB_24BPP: 2,
    RGBA_32BPP: 3
};
const $cca4aceb320d03d3$var$AnnotationType = {
    TEXT: 1,
    LINK: 2,
    FREETEXT: 3,
    LINE: 4,
    SQUARE: 5,
    CIRCLE: 6,
    POLYGON: 7,
    POLYLINE: 8,
    HIGHLIGHT: 9,
    UNDERLINE: 10,
    SQUIGGLY: 11,
    STRIKEOUT: 12,
    STAMP: 13,
    CARET: 14,
    INK: 15,
    POPUP: 16,
    FILEATTACHMENT: 17,
    SOUND: 18,
    MOVIE: 19,
    WIDGET: 20,
    SCREEN: 21,
    PRINTERMARK: 22,
    TRAPNET: 23,
    WATERMARK: 24,
    THREED: 25,
    REDACT: 26
};
const $cca4aceb320d03d3$var$AnnotationReplyType = {
    GROUP: "Group",
    REPLY: "R"
};
const $cca4aceb320d03d3$var$AnnotationFlag = {
    INVISIBLE: 0x01,
    HIDDEN: 0x02,
    PRINT: 0x04,
    NOZOOM: 0x08,
    NOROTATE: 0x10,
    NOVIEW: 0x20,
    READONLY: 0x40,
    LOCKED: 0x80,
    TOGGLENOVIEW: 0x100,
    LOCKEDCONTENTS: 0x200
};
const $cca4aceb320d03d3$var$AnnotationFieldFlag = {
    READONLY: 0x0000001,
    REQUIRED: 0x0000002,
    NOEXPORT: 0x0000004,
    MULTILINE: 0x0001000,
    PASSWORD: 0x0002000,
    NOTOGGLETOOFF: 0x0004000,
    RADIO: 0x0008000,
    PUSHBUTTON: 0x0010000,
    COMBO: 0x0020000,
    EDIT: 0x0040000,
    SORT: 0x0080000,
    FILESELECT: 0x0100000,
    MULTISELECT: 0x0200000,
    DONOTSPELLCHECK: 0x0400000,
    DONOTSCROLL: 0x0800000,
    COMB: 0x1000000,
    RICHTEXT: 0x2000000,
    RADIOSINUNISON: 0x2000000,
    COMMITONSELCHANGE: 0x4000000
};
const $cca4aceb320d03d3$var$AnnotationBorderStyleType = {
    SOLID: 1,
    DASHED: 2,
    BEVELED: 3,
    INSET: 4,
    UNDERLINE: 5
};
const $cca4aceb320d03d3$var$AnnotationActionEventType = {
    E: "Mouse Enter",
    X: "Mouse Exit",
    D: "Mouse Down",
    U: "Mouse Up",
    Fo: "Focus",
    Bl: "Blur",
    PO: "PageOpen",
    PC: "PageClose",
    PV: "PageVisible",
    PI: "PageInvisible",
    K: "Keystroke",
    F: "Format",
    V: "Validate",
    C: "Calculate"
};
const $cca4aceb320d03d3$var$DocumentActionEventType = {
    WC: "WillClose",
    WS: "WillSave",
    DS: "DidSave",
    WP: "WillPrint",
    DP: "DidPrint"
};
const $cca4aceb320d03d3$var$PageActionEventType = {
    O: "PageOpen",
    C: "PageClose"
};
const $cca4aceb320d03d3$var$VerbosityLevel = {
    ERRORS: 0,
    WARNINGS: 1,
    INFOS: 5
};
const $cca4aceb320d03d3$var$CMapCompressionType = {
    NONE: 0,
    BINARY: 1
};
const $cca4aceb320d03d3$var$OPS = {
    dependency: 1,
    setLineWidth: 2,
    setLineCap: 3,
    setLineJoin: 4,
    setMiterLimit: 5,
    setDash: 6,
    setRenderingIntent: 7,
    setFlatness: 8,
    setGState: 9,
    save: 10,
    restore: 11,
    transform: 12,
    moveTo: 13,
    lineTo: 14,
    curveTo: 15,
    curveTo2: 16,
    curveTo3: 17,
    closePath: 18,
    rectangle: 19,
    stroke: 20,
    closeStroke: 21,
    fill: 22,
    eoFill: 23,
    fillStroke: 24,
    eoFillStroke: 25,
    closeFillStroke: 26,
    closeEOFillStroke: 27,
    endPath: 28,
    clip: 29,
    eoClip: 30,
    beginText: 31,
    endText: 32,
    setCharSpacing: 33,
    setWordSpacing: 34,
    setHScale: 35,
    setLeading: 36,
    setFont: 37,
    setTextRenderingMode: 38,
    setTextRise: 39,
    moveText: 40,
    setLeadingMoveText: 41,
    setTextMatrix: 42,
    nextLine: 43,
    showText: 44,
    showSpacedText: 45,
    nextLineShowText: 46,
    nextLineSetSpacingShowText: 47,
    setCharWidth: 48,
    setCharWidthAndBounds: 49,
    setStrokeColorSpace: 50,
    setFillColorSpace: 51,
    setStrokeColor: 52,
    setStrokeColorN: 53,
    setFillColor: 54,
    setFillColorN: 55,
    setStrokeGray: 56,
    setFillGray: 57,
    setStrokeRGBColor: 58,
    setFillRGBColor: 59,
    setStrokeCMYKColor: 60,
    setFillCMYKColor: 61,
    shadingFill: 62,
    beginInlineImage: 63,
    beginImageData: 64,
    endInlineImage: 65,
    paintXObject: 66,
    markPoint: 67,
    markPointProps: 68,
    beginMarkedContent: 69,
    beginMarkedContentProps: 70,
    endMarkedContent: 71,
    beginCompat: 72,
    endCompat: 73,
    paintFormXObjectBegin: 74,
    paintFormXObjectEnd: 75,
    beginGroup: 76,
    endGroup: 77,
    beginAnnotation: 80,
    endAnnotation: 81,
    paintImageMaskXObject: 83,
    paintImageMaskXObjectGroup: 84,
    paintImageXObject: 85,
    paintInlineImageXObject: 86,
    paintInlineImageXObjectGroup: 87,
    paintImageXObjectRepeat: 88,
    paintImageMaskXObjectRepeat: 89,
    paintSolidColorImageMask: 90,
    constructPath: 91
};
const $cca4aceb320d03d3$var$PasswordResponses = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
let $cca4aceb320d03d3$var$verbosity = $cca4aceb320d03d3$var$VerbosityLevel.WARNINGS;
function $cca4aceb320d03d3$var$setVerbosityLevel(level) {
    if (Number.isInteger(level)) $cca4aceb320d03d3$var$verbosity = level;
}
function $cca4aceb320d03d3$var$getVerbosityLevel() {
    return $cca4aceb320d03d3$var$verbosity;
}
function $cca4aceb320d03d3$var$info(msg) {
    if ($cca4aceb320d03d3$var$verbosity >= $cca4aceb320d03d3$var$VerbosityLevel.INFOS) console.log(`Info: ${msg}`);
}
function $cca4aceb320d03d3$var$warn(msg) {
    if ($cca4aceb320d03d3$var$verbosity >= $cca4aceb320d03d3$var$VerbosityLevel.WARNINGS) console.log(`Warning: ${msg}`);
}
function $cca4aceb320d03d3$var$unreachable(msg) {
    throw new Error(msg);
}
function $cca4aceb320d03d3$var$assert(cond, msg) {
    if (!cond) $cca4aceb320d03d3$var$unreachable(msg);
}
function $cca4aceb320d03d3$var$_isValidProtocol(url) {
    switch(url?.protocol){
        case "http:":
        case "https:":
        case "ftp:":
        case "mailto:":
        case "tel:":
            return true;
        default:
            return false;
    }
}
function $cca4aceb320d03d3$var$createValidAbsoluteUrl(url, baseUrl = null, options = null) {
    if (!url) return null;
    try {
        if (options && typeof url === "string") {
            if (options.addDefaultProtocol && url.startsWith("www.")) {
                const dots = url.match(/\./g);
                if (dots?.length >= 2) url = `http://${url}`;
            }
            if (options.tryConvertEncoding) try {
                url = $cca4aceb320d03d3$var$stringToUTF8String(url);
            } catch  {}
        }
        const absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
        if ($cca4aceb320d03d3$var$_isValidProtocol(absoluteUrl)) return absoluteUrl;
    } catch  {}
    return null;
}
function $cca4aceb320d03d3$var$shadow(obj, prop, value, nonSerializable = false) {
    Object.defineProperty(obj, prop, {
        value: value,
        enumerable: !nonSerializable,
        configurable: true,
        writable: false
    });
    return value;
}
const $cca4aceb320d03d3$var$BaseException = function BaseExceptionClosure() {
    function BaseException(message, name) {
        if (this.constructor === BaseException) $cca4aceb320d03d3$var$unreachable("Cannot initialize BaseException.");
        this.message = message;
        this.name = name;
    }
    BaseException.prototype = new Error();
    BaseException.constructor = BaseException;
    return BaseException;
}();
class $cca4aceb320d03d3$var$PasswordException extends $cca4aceb320d03d3$var$BaseException {
    constructor(msg, code){
        super(msg, "PasswordException");
        this.code = code;
    }
}
class $cca4aceb320d03d3$var$UnknownErrorException extends $cca4aceb320d03d3$var$BaseException {
    constructor(msg, details){
        super(msg, "UnknownErrorException");
        this.details = details;
    }
}
class $cca4aceb320d03d3$var$InvalidPDFException extends $cca4aceb320d03d3$var$BaseException {
    constructor(msg){
        super(msg, "InvalidPDFException");
    }
}
class $cca4aceb320d03d3$var$MissingPDFException extends $cca4aceb320d03d3$var$BaseException {
    constructor(msg){
        super(msg, "MissingPDFException");
    }
}
class $cca4aceb320d03d3$var$UnexpectedResponseException extends $cca4aceb320d03d3$var$BaseException {
    constructor(msg, status){
        super(msg, "UnexpectedResponseException");
        this.status = status;
    }
}
class $cca4aceb320d03d3$var$FormatError extends $cca4aceb320d03d3$var$BaseException {
    constructor(msg){
        super(msg, "FormatError");
    }
}
class $cca4aceb320d03d3$var$AbortException extends $cca4aceb320d03d3$var$BaseException {
    constructor(msg){
        super(msg, "AbortException");
    }
}
function $cca4aceb320d03d3$var$bytesToString(bytes) {
    if (typeof bytes !== "object" || bytes?.length === undefined) $cca4aceb320d03d3$var$unreachable("Invalid argument for bytesToString");
    const length = bytes.length;
    const MAX_ARGUMENT_COUNT = 8192;
    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
    const strBuf = [];
    for(let i = 0; i < length; i += MAX_ARGUMENT_COUNT){
        const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
        const chunk = bytes.subarray(i, chunkEnd);
        strBuf.push(String.fromCharCode.apply(null, chunk));
    }
    return strBuf.join("");
}
function $cca4aceb320d03d3$var$stringToBytes(str) {
    if (typeof str !== "string") $cca4aceb320d03d3$var$unreachable("Invalid argument for stringToBytes");
    const length = str.length;
    const bytes = new Uint8Array(length);
    for(let i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
    return bytes;
}
function $cca4aceb320d03d3$var$string32(value) {
    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
}
function $cca4aceb320d03d3$var$objectSize(obj) {
    return Object.keys(obj).length;
}
function $cca4aceb320d03d3$var$objectFromMap(map) {
    const obj = Object.create(null);
    for (const [key, value] of map)obj[key] = value;
    return obj;
}
function $cca4aceb320d03d3$var$isLittleEndian() {
    const buffer8 = new Uint8Array(4);
    buffer8[0] = 1;
    const view32 = new Uint32Array(buffer8.buffer, 0, 1);
    return view32[0] === 1;
}
function $cca4aceb320d03d3$var$isEvalSupported() {
    try {
        new Function("");
        return true;
    } catch  {
        return false;
    }
}
class $cca4aceb320d03d3$var$util_FeatureTest {
    static get isLittleEndian() {
        return $cca4aceb320d03d3$var$shadow(this, "isLittleEndian", $cca4aceb320d03d3$var$isLittleEndian());
    }
    static get isEvalSupported() {
        return $cca4aceb320d03d3$var$shadow(this, "isEvalSupported", $cca4aceb320d03d3$var$isEvalSupported());
    }
    static get isOffscreenCanvasSupported() {
        return $cca4aceb320d03d3$var$shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
    }
    static get platform() {
        if (typeof navigator !== "undefined" && typeof navigator?.platform === "string") return $cca4aceb320d03d3$var$shadow(this, "platform", {
            isMac: navigator.platform.includes("Mac")
        });
        return $cca4aceb320d03d3$var$shadow(this, "platform", {
            isMac: false
        });
    }
    static get isCSSRoundSupported() {
        return $cca4aceb320d03d3$var$shadow(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
    }
}
const $cca4aceb320d03d3$var$hexNumbers = Array.from(Array(256).keys(), (n)=>n.toString(16).padStart(2, "0"));
class $cca4aceb320d03d3$var$Util {
    static makeHexColor(r, g, b) {
        return `#${$cca4aceb320d03d3$var$hexNumbers[r]}${$cca4aceb320d03d3$var$hexNumbers[g]}${$cca4aceb320d03d3$var$hexNumbers[b]}`;
    }
    static scaleMinMax(transform, minMax) {
        let temp;
        if (transform[0]) {
            if (transform[0] < 0) {
                temp = minMax[0];
                minMax[0] = minMax[2];
                minMax[2] = temp;
            }
            minMax[0] *= transform[0];
            minMax[2] *= transform[0];
            if (transform[3] < 0) {
                temp = minMax[1];
                minMax[1] = minMax[3];
                minMax[3] = temp;
            }
            minMax[1] *= transform[3];
            minMax[3] *= transform[3];
        } else {
            temp = minMax[0];
            minMax[0] = minMax[1];
            minMax[1] = temp;
            temp = minMax[2];
            minMax[2] = minMax[3];
            minMax[3] = temp;
            if (transform[1] < 0) {
                temp = minMax[1];
                minMax[1] = minMax[3];
                minMax[3] = temp;
            }
            minMax[1] *= transform[1];
            minMax[3] *= transform[1];
            if (transform[2] < 0) {
                temp = minMax[0];
                minMax[0] = minMax[2];
                minMax[2] = temp;
            }
            minMax[0] *= transform[2];
            minMax[2] *= transform[2];
        }
        minMax[0] += transform[4];
        minMax[1] += transform[5];
        minMax[2] += transform[4];
        minMax[3] += transform[5];
    }
    static transform(m1, m2) {
        return [
            m1[0] * m2[0] + m1[2] * m2[1],
            m1[1] * m2[0] + m1[3] * m2[1],
            m1[0] * m2[2] + m1[2] * m2[3],
            m1[1] * m2[2] + m1[3] * m2[3],
            m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
            m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
        ];
    }
    static applyTransform(p, m) {
        const xt = p[0] * m[0] + p[1] * m[2] + m[4];
        const yt = p[0] * m[1] + p[1] * m[3] + m[5];
        return [
            xt,
            yt
        ];
    }
    static applyInverseTransform(p, m) {
        const d = m[0] * m[3] - m[1] * m[2];
        const xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
        const yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
        return [
            xt,
            yt
        ];
    }
    static getAxialAlignedBoundingBox(r, m) {
        const p1 = this.applyTransform(r, m);
        const p2 = this.applyTransform(r.slice(2, 4), m);
        const p3 = this.applyTransform([
            r[0],
            r[3]
        ], m);
        const p4 = this.applyTransform([
            r[2],
            r[1]
        ], m);
        return [
            Math.min(p1[0], p2[0], p3[0], p4[0]),
            Math.min(p1[1], p2[1], p3[1], p4[1]),
            Math.max(p1[0], p2[0], p3[0], p4[0]),
            Math.max(p1[1], p2[1], p3[1], p4[1])
        ];
    }
    static inverseTransform(m) {
        const d = m[0] * m[3] - m[1] * m[2];
        return [
            m[3] / d,
            -m[1] / d,
            -m[2] / d,
            m[0] / d,
            (m[2] * m[5] - m[4] * m[3]) / d,
            (m[4] * m[1] - m[5] * m[0]) / d
        ];
    }
    static singularValueDecompose2dScale(m) {
        const transpose = [
            m[0],
            m[2],
            m[1],
            m[3]
        ];
        const a = m[0] * transpose[0] + m[1] * transpose[2];
        const b = m[0] * transpose[1] + m[1] * transpose[3];
        const c = m[2] * transpose[0] + m[3] * transpose[2];
        const d = m[2] * transpose[1] + m[3] * transpose[3];
        const first = (a + d) / 2;
        const second = Math.sqrt((a + d) ** 2 - 4 * (a * d - c * b)) / 2;
        const sx = first + second || 1;
        const sy = first - second || 1;
        return [
            Math.sqrt(sx),
            Math.sqrt(sy)
        ];
    }
    static normalizeRect(rect) {
        const r = rect.slice(0);
        if (rect[0] > rect[2]) {
            r[0] = rect[2];
            r[2] = rect[0];
        }
        if (rect[1] > rect[3]) {
            r[1] = rect[3];
            r[3] = rect[1];
        }
        return r;
    }
    static intersect(rect1, rect2) {
        const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
        const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
        if (xLow > xHigh) return null;
        const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
        const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
        if (yLow > yHigh) return null;
        return [
            xLow,
            yLow,
            xHigh,
            yHigh
        ];
    }
    static #getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, t, minMax) {
        if (t <= 0 || t >= 1) return;
        const mt = 1 - t;
        const tt = t * t;
        const ttt = tt * t;
        const x = mt * (mt * (mt * x0 + 3 * t * x1) + 3 * tt * x2) + ttt * x3;
        const y = mt * (mt * (mt * y0 + 3 * t * y1) + 3 * tt * y2) + ttt * y3;
        minMax[0] = Math.min(minMax[0], x);
        minMax[1] = Math.min(minMax[1], y);
        minMax[2] = Math.max(minMax[2], x);
        minMax[3] = Math.max(minMax[3], y);
    }
    static #getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, a, b, c, minMax) {
        if (Math.abs(a) < 1e-12) {
            if (Math.abs(b) >= 1e-12) this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, -c / b, minMax);
            return;
        }
        const delta = b ** 2 - 4 * c * a;
        if (delta < 0) return;
        const sqrtDelta = Math.sqrt(delta);
        const a2 = 2 * a;
        this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, (-b + sqrtDelta) / a2, minMax);
        this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, (-b - sqrtDelta) / a2, minMax);
    }
    static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
        if (minMax) {
            minMax[0] = Math.min(minMax[0], x0, x3);
            minMax[1] = Math.min(minMax[1], y0, y3);
            minMax[2] = Math.max(minMax[2], x0, x3);
            minMax[3] = Math.max(minMax[3], y0, y3);
        } else minMax = [
            Math.min(x0, x3),
            Math.min(y0, y3),
            Math.max(x0, x3),
            Math.max(y0, y3)
        ];
        this.#getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-x0 + 3 * (x1 - x2) + x3), 6 * (x0 - 2 * x1 + x2), 3 * (x1 - x0), minMax);
        this.#getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-y0 + 3 * (y1 - y2) + y3), 6 * (y0 - 2 * y1 + y2), 3 * (y1 - y0), minMax);
        return minMax;
    }
}
const $cca4aceb320d03d3$var$PDFStringTranslateTable = /* unused pure expression or super */ null;
function $cca4aceb320d03d3$var$stringToPDFString(str) {
    if (str[0] >= "\xEF") {
        let encoding;
        if (str[0] === "\xFE" && str[1] === "\xFF") {
            encoding = "utf-16be";
            if (str.length % 2 === 1) str = str.slice(0, -1);
        } else if (str[0] === "\xFF" && str[1] === "\xFE") {
            encoding = "utf-16le";
            if (str.length % 2 === 1) str = str.slice(0, -1);
        } else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") encoding = "utf-8";
        if (encoding) try {
            const decoder = new TextDecoder(encoding, {
                fatal: true
            });
            const buffer = $cca4aceb320d03d3$var$stringToBytes(str);
            const decoded = decoder.decode(buffer);
            if (!decoded.includes("\x1b")) return decoded;
            return decoded.replaceAll(/\x1b[^\x1b]*(?:\x1b|$)/g, "");
        } catch (ex) {
            $cca4aceb320d03d3$var$warn(`stringToPDFString: "${ex}".`);
        }
    }
    const strBuf = [];
    for(let i = 0, ii = str.length; i < ii; i++){
        const charCode = str.charCodeAt(i);
        if (charCode === 0x1b) {
            while(++i < ii && str.charCodeAt(i) !== 0x1b);
            continue;
        }
        const code = $cca4aceb320d03d3$var$PDFStringTranslateTable[charCode];
        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
    }
    return strBuf.join("");
}
function $cca4aceb320d03d3$var$stringToUTF8String(str) {
    return decodeURIComponent(escape(str));
}
function $cca4aceb320d03d3$var$utf8StringToString(str) {
    return unescape(encodeURIComponent(str));
}
function $cca4aceb320d03d3$var$isArrayEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for(let i = 0, ii = arr1.length; i < ii; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $cca4aceb320d03d3$var$getModificationDate(date = new Date()) {
    const buffer = [
        date.getUTCFullYear().toString(),
        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
        date.getUTCDate().toString().padStart(2, "0"),
        date.getUTCHours().toString().padStart(2, "0"),
        date.getUTCMinutes().toString().padStart(2, "0"),
        date.getUTCSeconds().toString().padStart(2, "0")
    ];
    return buffer.join("");
}
let $cca4aceb320d03d3$var$NormalizeRegex = null;
let $cca4aceb320d03d3$var$NormalizationMap = null;
function $cca4aceb320d03d3$var$normalizeUnicode(str) {
    if (!$cca4aceb320d03d3$var$NormalizeRegex) {
        $cca4aceb320d03d3$var$NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
        $cca4aceb320d03d3$var$NormalizationMap = new Map([
            [
                "\uFB05",
                "\u017Ft"
            ]
        ]);
    }
    return str.replaceAll($cca4aceb320d03d3$var$NormalizeRegex, (_, p1, p2)=>p1 ? p1.normalize("NFKC") : $cca4aceb320d03d3$var$NormalizationMap.get(p2));
}
function $cca4aceb320d03d3$var$getUuid() {
    if (typeof crypto !== "undefined" && typeof crypto?.randomUUID === "function") return crypto.randomUUID();
    const buf = new Uint8Array(32);
    if (typeof crypto !== "undefined" && typeof crypto?.getRandomValues === "function") crypto.getRandomValues(buf);
    else for(let i = 0; i < 32; i++)buf[i] = Math.floor(Math.random() * 255);
    return $cca4aceb320d03d3$var$bytesToString(buf);
}
const $cca4aceb320d03d3$var$AnnotationPrefix = "pdfjs_internal_id_";
const $cca4aceb320d03d3$var$FontRenderOps = {
    BEZIER_CURVE_TO: 0,
    MOVE_TO: 1,
    LINE_TO: 2,
    QUADRATIC_CURVE_TO: 3,
    RESTORE: 4,
    SAVE: 5,
    SCALE: 6,
    TRANSFORM: 7,
    TRANSLATE: 8
};
class $cca4aceb320d03d3$var$BaseFilterFactory {
    constructor(){
        if (this.constructor === $cca4aceb320d03d3$var$BaseFilterFactory) $cca4aceb320d03d3$var$unreachable("Cannot initialize BaseFilterFactory.");
    }
    addFilter(maps) {
        return "none";
    }
    addHCMFilter(fgColor, bgColor) {
        return "none";
    }
    addAlphaFilter(map) {
        return "none";
    }
    addLuminosityFilter(map) {
        return "none";
    }
    addHighlightHCMFilter(filterName, fgColor, bgColor, newFgColor, newBgColor) {
        return "none";
    }
    destroy(keepHCM = false) {}
}
class $cca4aceb320d03d3$var$BaseCanvasFactory {
    #enableHWA = false;
    constructor({ enableHWA: enableHWA = false } = {}){
        if (this.constructor === $cca4aceb320d03d3$var$BaseCanvasFactory) $cca4aceb320d03d3$var$unreachable("Cannot initialize BaseCanvasFactory.");
        this.#enableHWA = enableHWA;
    }
    create(width, height) {
        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
        const canvas = this._createCanvas(width, height);
        return {
            canvas: canvas,
            context: canvas.getContext("2d", {
                willReadFrequently: !this.#enableHWA
            })
        };
    }
    reset(canvasAndContext, width, height) {
        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
        canvasAndContext.canvas.width = width;
        canvasAndContext.canvas.height = height;
    }
    destroy(canvasAndContext) {
        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
        canvasAndContext.canvas.width = 0;
        canvasAndContext.canvas.height = 0;
        canvasAndContext.canvas = null;
        canvasAndContext.context = null;
    }
    _createCanvas(width, height) {
        $cca4aceb320d03d3$var$unreachable("Abstract method `_createCanvas` called.");
    }
}
class $cca4aceb320d03d3$var$BaseCMapReaderFactory {
    constructor({ baseUrl: baseUrl = null, isCompressed: isCompressed = true }){
        if (this.constructor === $cca4aceb320d03d3$var$BaseCMapReaderFactory) $cca4aceb320d03d3$var$unreachable("Cannot initialize BaseCMapReaderFactory.");
        this.baseUrl = baseUrl;
        this.isCompressed = isCompressed;
    }
    async fetch({ name: name }) {
        if (!this.baseUrl) throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
        if (!name) throw new Error("CMap name must be specified.");
        const url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
        const compressionType = this.isCompressed ? $cca4aceb320d03d3$var$CMapCompressionType.BINARY : $cca4aceb320d03d3$var$CMapCompressionType.NONE;
        return this._fetchData(url, compressionType).catch((reason)=>{
            throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${url}`);
        });
    }
    _fetchData(url, compressionType) {
        $cca4aceb320d03d3$var$unreachable("Abstract method `_fetchData` called.");
    }
}
class $cca4aceb320d03d3$var$BaseStandardFontDataFactory {
    constructor({ baseUrl: baseUrl = null }){
        if (this.constructor === $cca4aceb320d03d3$var$BaseStandardFontDataFactory) $cca4aceb320d03d3$var$unreachable("Cannot initialize BaseStandardFontDataFactory.");
        this.baseUrl = baseUrl;
    }
    async fetch({ filename: filename }) {
        if (!this.baseUrl) throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
        if (!filename) throw new Error("Font filename must be specified.");
        const url = `${this.baseUrl}${filename}`;
        return this._fetchData(url).catch((reason)=>{
            throw new Error(`Unable to load font data at: ${url}`);
        });
    }
    _fetchData(url) {
        $cca4aceb320d03d3$var$unreachable("Abstract method `_fetchData` called.");
    }
}
class $cca4aceb320d03d3$var$BaseSVGFactory {
    constructor(){
        if (this.constructor === $cca4aceb320d03d3$var$BaseSVGFactory) $cca4aceb320d03d3$var$unreachable("Cannot initialize BaseSVGFactory.");
    }
    create(width, height, skipDimensions = false) {
        if (width <= 0 || height <= 0) throw new Error("Invalid SVG dimensions");
        const svg = this._createSVG("svg:svg");
        svg.setAttribute("version", "1.1");
        if (!skipDimensions) {
            svg.setAttribute("width", `${width}px`);
            svg.setAttribute("height", `${height}px`);
        }
        svg.setAttribute("preserveAspectRatio", "none");
        svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
        return svg;
    }
    createElement(type) {
        if (typeof type !== "string") throw new Error("Invalid SVG element type");
        return this._createSVG(type);
    }
    _createSVG(type) {
        $cca4aceb320d03d3$var$unreachable("Abstract method `_createSVG` called.");
    }
}
const $cca4aceb320d03d3$var$SVG_NS = "http://www.w3.org/2000/svg";
class $cca4aceb320d03d3$var$PixelsPerInch {
    static CSS = 96.0;
    static PDF = 72.0;
    static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
}
class $cca4aceb320d03d3$var$DOMFilterFactory extends $cca4aceb320d03d3$var$BaseFilterFactory {
    #_cache;
    #_defs;
    #docId;
    #document;
    #_hcmCache;
    #id = 0;
    constructor({ docId: docId, ownerDocument: ownerDocument = globalThis.document } = {}){
        super();
        this.#docId = docId;
        this.#document = ownerDocument;
    }
    get #cache() {
        return this.#_cache ||= new Map();
    }
    get #hcmCache() {
        return this.#_hcmCache ||= new Map();
    }
    get #defs() {
        if (!this.#_defs) {
            const div = this.#document.createElement("div");
            const { style: style } = div;
            style.visibility = "hidden";
            style.contain = "strict";
            style.width = style.height = 0;
            style.position = "absolute";
            style.top = style.left = 0;
            style.zIndex = -1;
            const svg = this.#document.createElementNS($cca4aceb320d03d3$var$SVG_NS, "svg");
            svg.setAttribute("width", 0);
            svg.setAttribute("height", 0);
            this.#_defs = this.#document.createElementNS($cca4aceb320d03d3$var$SVG_NS, "defs");
            div.append(svg);
            svg.append(this.#_defs);
            this.#document.body.append(div);
        }
        return this.#_defs;
    }
    #createTables(maps) {
        if (maps.length === 1) {
            const mapR = maps[0];
            const buffer = new Array(256);
            for(let i = 0; i < 256; i++)buffer[i] = mapR[i] / 255;
            const table = buffer.join(",");
            return [
                table,
                table,
                table
            ];
        }
        const [mapR, mapG, mapB] = maps;
        const bufferR = new Array(256);
        const bufferG = new Array(256);
        const bufferB = new Array(256);
        for(let i = 0; i < 256; i++){
            bufferR[i] = mapR[i] / 255;
            bufferG[i] = mapG[i] / 255;
            bufferB[i] = mapB[i] / 255;
        }
        return [
            bufferR.join(","),
            bufferG.join(","),
            bufferB.join(",")
        ];
    }
    addFilter(maps) {
        if (!maps) return "none";
        let value = this.#cache.get(maps);
        if (value) return value;
        const [tableR, tableG, tableB] = this.#createTables(maps);
        const key = maps.length === 1 ? tableR : `${tableR}${tableG}${tableB}`;
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(maps, value);
            return value;
        }
        const id = `g_${this.#docId}_transfer_map_${this.#id++}`;
        const url = `url(#${id})`;
        this.#cache.set(maps, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addTransferMapConversion(tableR, tableG, tableB, filter);
        return url;
    }
    addHCMFilter(fgColor, bgColor) {
        const key = `${fgColor}-${bgColor}`;
        const filterName = "base";
        let info = this.#hcmCache.get(filterName);
        if (info?.key === key) return info.url;
        if (info) {
            info.filter?.remove();
            info.key = key;
            info.url = "none";
            info.filter = null;
        } else {
            info = {
                key: key,
                url: "none",
                filter: null
            };
            this.#hcmCache.set(filterName, info);
        }
        if (!fgColor || !bgColor) return info.url;
        const fgRGB = this.#getRGB(fgColor);
        fgColor = $cca4aceb320d03d3$var$Util.makeHexColor(...fgRGB);
        const bgRGB = this.#getRGB(bgColor);
        bgColor = $cca4aceb320d03d3$var$Util.makeHexColor(...bgRGB);
        this.#defs.style.color = "";
        if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) return info.url;
        const map = new Array(256);
        for(let i = 0; i <= 255; i++){
            const x = i / 255;
            map[i] = x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
        }
        const table = map.join(",");
        const id = `g_${this.#docId}_hcm_filter`;
        const filter = info.filter = this.#createFilter(id);
        this.#addTransferMapConversion(table, table, table, filter);
        this.#addGrayConversion(filter);
        const getSteps = (c, n)=>{
            const start = fgRGB[c] / 255;
            const end = bgRGB[c] / 255;
            const arr = new Array(n + 1);
            for(let i = 0; i <= n; i++)arr[i] = start + i / n * (end - start);
            return arr.join(",");
        };
        this.#addTransferMapConversion(getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
        info.url = `url(#${id})`;
        return info.url;
    }
    addAlphaFilter(map) {
        let value = this.#cache.get(map);
        if (value) return value;
        const [tableA] = this.#createTables([
            map
        ]);
        const key = `alpha_${tableA}`;
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(map, value);
            return value;
        }
        const id = `g_${this.#docId}_alpha_map_${this.#id++}`;
        const url = `url(#${id})`;
        this.#cache.set(map, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addTransferMapAlphaConversion(tableA, filter);
        return url;
    }
    addLuminosityFilter(map) {
        let value = this.#cache.get(map || "luminosity");
        if (value) return value;
        let tableA, key;
        if (map) {
            [tableA] = this.#createTables([
                map
            ]);
            key = `luminosity_${tableA}`;
        } else key = "luminosity";
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(map, value);
            return value;
        }
        const id = `g_${this.#docId}_luminosity_map_${this.#id++}`;
        const url = `url(#${id})`;
        this.#cache.set(map, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addLuminosityConversion(filter);
        if (map) this.#addTransferMapAlphaConversion(tableA, filter);
        return url;
    }
    addHighlightHCMFilter(filterName, fgColor, bgColor, newFgColor, newBgColor) {
        const key = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
        let info = this.#hcmCache.get(filterName);
        if (info?.key === key) return info.url;
        if (info) {
            info.filter?.remove();
            info.key = key;
            info.url = "none";
            info.filter = null;
        } else {
            info = {
                key: key,
                url: "none",
                filter: null
            };
            this.#hcmCache.set(filterName, info);
        }
        if (!fgColor || !bgColor) return info.url;
        const [fgRGB, bgRGB] = [
            fgColor,
            bgColor
        ].map(this.#getRGB.bind(this));
        let fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
        let bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
        let [newFgRGB, newBgRGB] = [
            newFgColor,
            newBgColor
        ].map(this.#getRGB.bind(this));
        if (bgGray < fgGray) [fgGray, bgGray, newFgRGB, newBgRGB] = [
            bgGray,
            fgGray,
            newBgRGB,
            newFgRGB
        ];
        this.#defs.style.color = "";
        const getSteps = (fg, bg, n)=>{
            const arr = new Array(256);
            const step = (bgGray - fgGray) / n;
            const newStart = fg / 255;
            const newStep = (bg - fg) / (255 * n);
            let prev = 0;
            for(let i = 0; i <= n; i++){
                const k = Math.round(fgGray + i * step);
                const value = newStart + i * newStep;
                for(let j = prev; j <= k; j++)arr[j] = value;
                prev = k + 1;
            }
            for(let i = prev; i < 256; i++)arr[i] = arr[prev - 1];
            return arr.join(",");
        };
        const id = `g_${this.#docId}_hcm_${filterName}_filter`;
        const filter = info.filter = this.#createFilter(id);
        this.#addGrayConversion(filter);
        this.#addTransferMapConversion(getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
        info.url = `url(#${id})`;
        return info.url;
    }
    destroy(keepHCM = false) {
        if (keepHCM && this.#hcmCache.size !== 0) return;
        if (this.#_defs) {
            this.#_defs.parentNode.parentNode.remove();
            this.#_defs = null;
        }
        if (this.#_cache) {
            this.#_cache.clear();
            this.#_cache = null;
        }
        this.#id = 0;
    }
    #addLuminosityConversion(filter) {
        const feColorMatrix = this.#document.createElementNS($cca4aceb320d03d3$var$SVG_NS, "feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0.59 0.11 0 0");
        filter.append(feColorMatrix);
    }
    #addGrayConversion(filter) {
        const feColorMatrix = this.#document.createElementNS($cca4aceb320d03d3$var$SVG_NS, "feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
        filter.append(feColorMatrix);
    }
    #createFilter(id) {
        const filter = this.#document.createElementNS($cca4aceb320d03d3$var$SVG_NS, "filter");
        filter.setAttribute("color-interpolation-filters", "sRGB");
        filter.setAttribute("id", id);
        this.#defs.append(filter);
        return filter;
    }
    #appendFeFunc(feComponentTransfer, func, table) {
        const feFunc = this.#document.createElementNS($cca4aceb320d03d3$var$SVG_NS, func);
        feFunc.setAttribute("type", "discrete");
        feFunc.setAttribute("tableValues", table);
        feComponentTransfer.append(feFunc);
    }
    #addTransferMapConversion(rTable, gTable, bTable, filter) {
        const feComponentTransfer = this.#document.createElementNS($cca4aceb320d03d3$var$SVG_NS, "feComponentTransfer");
        filter.append(feComponentTransfer);
        this.#appendFeFunc(feComponentTransfer, "feFuncR", rTable);
        this.#appendFeFunc(feComponentTransfer, "feFuncG", gTable);
        this.#appendFeFunc(feComponentTransfer, "feFuncB", bTable);
    }
    #addTransferMapAlphaConversion(aTable, filter) {
        const feComponentTransfer = this.#document.createElementNS($cca4aceb320d03d3$var$SVG_NS, "feComponentTransfer");
        filter.append(feComponentTransfer);
        this.#appendFeFunc(feComponentTransfer, "feFuncA", aTable);
    }
    #getRGB(color) {
        this.#defs.style.color = color;
        return $cca4aceb320d03d3$var$getRGB(getComputedStyle(this.#defs).getPropertyValue("color"));
    }
}
class $cca4aceb320d03d3$var$DOMCanvasFactory extends $cca4aceb320d03d3$var$BaseCanvasFactory {
    constructor({ ownerDocument: ownerDocument = globalThis.document, enableHWA: enableHWA = false } = {}){
        super({
            enableHWA: enableHWA
        });
        this._document = ownerDocument;
    }
    _createCanvas(width, height) {
        const canvas = this._document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
}
async function $cca4aceb320d03d3$var$fetchData(url, type = "text") {
    if ($cca4aceb320d03d3$var$isValidFetchUrl(url, document.baseURI)) {
        const response = await fetch(url);
        if (!response.ok) throw new Error(response.statusText);
        switch(type){
            case "arraybuffer":
                return response.arrayBuffer();
            case "blob":
                return response.blob();
            case "json":
                return response.json();
        }
        return response.text();
    }
    return new Promise((resolve, reject)=>{
        const request = new XMLHttpRequest();
        request.open("GET", url, true);
        request.responseType = type;
        request.onreadystatechange = ()=>{
            if (request.readyState !== XMLHttpRequest.DONE) return;
            if (request.status === 200 || request.status === 0) {
                switch(type){
                    case "arraybuffer":
                    case "blob":
                    case "json":
                        resolve(request.response);
                        return;
                }
                resolve(request.responseText);
                return;
            }
            reject(new Error(request.statusText));
        };
        request.send(null);
    });
}
class $cca4aceb320d03d3$var$DOMCMapReaderFactory extends $cca4aceb320d03d3$var$BaseCMapReaderFactory {
    _fetchData(url, compressionType) {
        return $cca4aceb320d03d3$var$fetchData(url, this.isCompressed ? "arraybuffer" : "text").then((data)=>({
                cMapData: data instanceof ArrayBuffer ? new Uint8Array(data) : $cca4aceb320d03d3$var$stringToBytes(data),
                compressionType: compressionType
            }));
    }
}
class $cca4aceb320d03d3$var$DOMStandardFontDataFactory extends $cca4aceb320d03d3$var$BaseStandardFontDataFactory {
    _fetchData(url) {
        return $cca4aceb320d03d3$var$fetchData(url, "arraybuffer").then((data)=>new Uint8Array(data));
    }
}
class $cca4aceb320d03d3$var$DOMSVGFactory extends $cca4aceb320d03d3$var$BaseSVGFactory {
    _createSVG(type) {
        return document.createElementNS($cca4aceb320d03d3$var$SVG_NS, type);
    }
}
class $cca4aceb320d03d3$var$PageViewport {
    constructor({ viewBox: viewBox, scale: scale, rotation: rotation, offsetX: offsetX = 0, offsetY: offsetY = 0, dontFlip: dontFlip = false }){
        this.viewBox = viewBox;
        this.scale = scale;
        this.rotation = rotation;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        const centerX = (viewBox[2] + viewBox[0]) / 2;
        const centerY = (viewBox[3] + viewBox[1]) / 2;
        let rotateA, rotateB, rotateC, rotateD;
        rotation %= 360;
        if (rotation < 0) rotation += 360;
        switch(rotation){
            case 180:
                rotateA = -1;
                rotateB = 0;
                rotateC = 0;
                rotateD = 1;
                break;
            case 90:
                rotateA = 0;
                rotateB = 1;
                rotateC = 1;
                rotateD = 0;
                break;
            case 270:
                rotateA = 0;
                rotateB = -1;
                rotateC = -1;
                rotateD = 0;
                break;
            case 0:
                rotateA = 1;
                rotateB = 0;
                rotateC = 0;
                rotateD = -1;
                break;
            default:
                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
        }
        if (dontFlip) {
            rotateC = -rotateC;
            rotateD = -rotateD;
        }
        let offsetCanvasX, offsetCanvasY;
        let width, height;
        if (rotateA === 0) {
            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
            width = (viewBox[3] - viewBox[1]) * scale;
            height = (viewBox[2] - viewBox[0]) * scale;
        } else {
            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
            width = (viewBox[2] - viewBox[0]) * scale;
            height = (viewBox[3] - viewBox[1]) * scale;
        }
        this.transform = [
            rotateA * scale,
            rotateB * scale,
            rotateC * scale,
            rotateD * scale,
            offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
            offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY
        ];
        this.width = width;
        this.height = height;
    }
    get rawDims() {
        const { viewBox: viewBox } = this;
        return $cca4aceb320d03d3$var$shadow(this, "rawDims", {
            pageWidth: viewBox[2] - viewBox[0],
            pageHeight: viewBox[3] - viewBox[1],
            pageX: viewBox[0],
            pageY: viewBox[1]
        });
    }
    clone({ scale: scale = this.scale, rotation: rotation = this.rotation, offsetX: offsetX = this.offsetX, offsetY: offsetY = this.offsetY, dontFlip: dontFlip = false } = {}) {
        return new $cca4aceb320d03d3$var$PageViewport({
            viewBox: this.viewBox.slice(),
            scale: scale,
            rotation: rotation,
            offsetX: offsetX,
            offsetY: offsetY,
            dontFlip: dontFlip
        });
    }
    convertToViewportPoint(x, y) {
        return $cca4aceb320d03d3$var$Util.applyTransform([
            x,
            y
        ], this.transform);
    }
    convertToViewportRectangle(rect) {
        const topLeft = $cca4aceb320d03d3$var$Util.applyTransform([
            rect[0],
            rect[1]
        ], this.transform);
        const bottomRight = $cca4aceb320d03d3$var$Util.applyTransform([
            rect[2],
            rect[3]
        ], this.transform);
        return [
            topLeft[0],
            topLeft[1],
            bottomRight[0],
            bottomRight[1]
        ];
    }
    convertToPdfPoint(x, y) {
        return $cca4aceb320d03d3$var$Util.applyInverseTransform([
            x,
            y
        ], this.transform);
    }
}
class $cca4aceb320d03d3$var$RenderingCancelledException extends $cca4aceb320d03d3$var$BaseException {
    constructor(msg, extraDelay = 0){
        super(msg, "RenderingCancelledException");
        this.extraDelay = extraDelay;
    }
}
function $cca4aceb320d03d3$var$isDataScheme(url) {
    const ii = url.length;
    let i = 0;
    while(i < ii && url[i].trim() === "")i++;
    return url.substring(i, i + 5).toLowerCase() === "data:";
}
function $cca4aceb320d03d3$var$isPdfFile(filename) {
    return typeof filename === "string" && /\.pdf$/i.test(filename);
}
function $cca4aceb320d03d3$var$getFilenameFromUrl(url) {
    [url] = url.split(/[#?]/, 1);
    return url.substring(url.lastIndexOf("/") + 1);
}
function $cca4aceb320d03d3$var$getPdfFilenameFromUrl(url, defaultFilename = "document.pdf") {
    if (typeof url !== "string") return defaultFilename;
    if ($cca4aceb320d03d3$var$isDataScheme(url)) {
        $cca4aceb320d03d3$var$warn('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
        return defaultFilename;
    }
    const reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
    const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
    const splitURI = reURI.exec(url);
    let suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
    if (suggestedFilename) {
        suggestedFilename = suggestedFilename[0];
        if (suggestedFilename.includes("%")) try {
            suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
        } catch  {}
    }
    return suggestedFilename || defaultFilename;
}
class $cca4aceb320d03d3$var$StatTimer {
    started = Object.create(null);
    times = [];
    time(name) {
        if (name in this.started) $cca4aceb320d03d3$var$warn(`Timer is already running for ${name}`);
        this.started[name] = Date.now();
    }
    timeEnd(name) {
        if (!(name in this.started)) $cca4aceb320d03d3$var$warn(`Timer has not been started for ${name}`);
        this.times.push({
            name: name,
            start: this.started[name],
            end: Date.now()
        });
        delete this.started[name];
    }
    toString() {
        const outBuf = [];
        let longest = 0;
        for (const { name: name } of this.times)longest = Math.max(name.length, longest);
        for (const { name: name, start: start, end: end } of this.times)outBuf.push(`${name.padEnd(longest)} ${end - start}ms\n`);
        return outBuf.join("");
    }
}
function $cca4aceb320d03d3$var$isValidFetchUrl(url, baseUrl) {
    try {
        const { protocol: protocol } = baseUrl ? new URL(url, baseUrl) : new URL(url);
        return protocol === "http:" || protocol === "https:";
    } catch  {
        return false;
    }
}
function $cca4aceb320d03d3$var$noContextMenu(e) {
    e.preventDefault();
}
function $cca4aceb320d03d3$var$deprecated(details) {
    console.log("Deprecated API usage: " + details);
}
let $cca4aceb320d03d3$var$pdfDateStringRegex;
class $cca4aceb320d03d3$var$PDFDateString {
    static toDateObject(input) {
        if (!input || typeof input !== "string") return null;
        $cca4aceb320d03d3$var$pdfDateStringRegex ||= new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
        const matches = $cca4aceb320d03d3$var$pdfDateStringRegex.exec(input);
        if (!matches) return null;
        const year = parseInt(matches[1], 10);
        let month = parseInt(matches[2], 10);
        month = month >= 1 && month <= 12 ? month - 1 : 0;
        let day = parseInt(matches[3], 10);
        day = day >= 1 && day <= 31 ? day : 1;
        let hour = parseInt(matches[4], 10);
        hour = hour >= 0 && hour <= 23 ? hour : 0;
        let minute = parseInt(matches[5], 10);
        minute = minute >= 0 && minute <= 59 ? minute : 0;
        let second = parseInt(matches[6], 10);
        second = second >= 0 && second <= 59 ? second : 0;
        const universalTimeRelation = matches[7] || "Z";
        let offsetHour = parseInt(matches[8], 10);
        offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
        let offsetMinute = parseInt(matches[9], 10) || 0;
        offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
        if (universalTimeRelation === "-") {
            hour += offsetHour;
            minute += offsetMinute;
        } else if (universalTimeRelation === "+") {
            hour -= offsetHour;
            minute -= offsetMinute;
        }
        return new Date(Date.UTC(year, month, day, hour, minute, second));
    }
}
function $cca4aceb320d03d3$var$getXfaPageViewport(xfaPage, { scale: scale = 1, rotation: rotation = 0 }) {
    const { width: width, height: height } = xfaPage.attributes.style;
    const viewBox = [
        0,
        0,
        parseInt(width),
        parseInt(height)
    ];
    return new $cca4aceb320d03d3$var$PageViewport({
        viewBox: viewBox,
        scale: scale,
        rotation: rotation
    });
}
function $cca4aceb320d03d3$var$getRGB(color) {
    if (color.startsWith("#")) {
        const colorRGB = parseInt(color.slice(1), 16);
        return [
            (colorRGB & 0xff0000) >> 16,
            (colorRGB & 0x00ff00) >> 8,
            colorRGB & 0x0000ff
        ];
    }
    if (color.startsWith("rgb(")) return color.slice(4, -1).split(",").map((x)=>parseInt(x));
    if (color.startsWith("rgba(")) return color.slice(5, -1).split(",").map((x)=>parseInt(x)).slice(0, 3);
    $cca4aceb320d03d3$var$warn(`Not a valid color format: "${color}"`);
    return [
        0,
        0,
        0
    ];
}
function $cca4aceb320d03d3$var$getColorValues(colors) {
    const span = document.createElement("span");
    span.style.visibility = "hidden";
    document.body.append(span);
    for (const name of colors.keys()){
        span.style.color = name;
        const computedColor = window.getComputedStyle(span).color;
        colors.set(name, $cca4aceb320d03d3$var$getRGB(computedColor));
    }
    span.remove();
}
function $cca4aceb320d03d3$var$getCurrentTransform(ctx) {
    const { a: a, b: b, c: c, d: d, e: e, f: f } = ctx.getTransform();
    return [
        a,
        b,
        c,
        d,
        e,
        f
    ];
}
function $cca4aceb320d03d3$var$getCurrentTransformInverse(ctx) {
    const { a: a, b: b, c: c, d: d, e: e, f: f } = ctx.getTransform().invertSelf();
    return [
        a,
        b,
        c,
        d,
        e,
        f
    ];
}
function $cca4aceb320d03d3$var$setLayerDimensions(div, viewport, mustFlip = false, mustRotate = true) {
    if (viewport instanceof $cca4aceb320d03d3$var$PageViewport) {
        const { pageWidth: pageWidth, pageHeight: pageHeight } = viewport.rawDims;
        const { style: style } = div;
        const useRound = $cca4aceb320d03d3$var$util_FeatureTest.isCSSRoundSupported;
        const w = `var(--scale-factor) * ${pageWidth}px`, h = `var(--scale-factor) * ${pageHeight}px`;
        const widthStr = useRound ? `round(${w}, 1px)` : `calc(${w})`, heightStr = useRound ? `round(${h}, 1px)` : `calc(${h})`;
        if (!mustFlip || viewport.rotation % 180 === 0) {
            style.width = widthStr;
            style.height = heightStr;
        } else {
            style.width = heightStr;
            style.height = widthStr;
        }
    }
    if (mustRotate) div.setAttribute("data-main-rotation", viewport.rotation);
}
class $cca4aceb320d03d3$var$EditorToolbar {
    #toolbar = null;
    #colorPicker = null;
    #editor;
    #buttons = null;
    constructor(editor){
        this.#editor = editor;
    }
    render() {
        const editToolbar = this.#toolbar = document.createElement("div");
        editToolbar.className = "editToolbar";
        editToolbar.setAttribute("role", "toolbar");
        const signal = this.#editor._uiManager._signal;
        editToolbar.addEventListener("contextmenu", $cca4aceb320d03d3$var$noContextMenu, {
            signal: signal
        });
        editToolbar.addEventListener("pointerdown", $cca4aceb320d03d3$var$EditorToolbar.#pointerDown, {
            signal: signal
        });
        const buttons = this.#buttons = document.createElement("div");
        buttons.className = "buttons";
        editToolbar.append(buttons);
        const position = this.#editor.toolbarPosition;
        if (position) {
            const { style: style } = editToolbar;
            const x = this.#editor._uiManager.direction === "ltr" ? 1 - position[0] : position[0];
            style.insetInlineEnd = `${100 * x}%`;
            style.top = `calc(${100 * position[1]}% + var(--editor-toolbar-vert-offset))`;
        }
        this.#addDeleteButton();
        return editToolbar;
    }
    static #pointerDown(e) {
        e.stopPropagation();
    }
    #focusIn(e) {
        this.#editor._focusEventsAllowed = false;
        e.preventDefault();
        e.stopPropagation();
    }
    #focusOut(e) {
        this.#editor._focusEventsAllowed = true;
        e.preventDefault();
        e.stopPropagation();
    }
    #addListenersToElement(element) {
        const signal = this.#editor._uiManager._signal;
        element.addEventListener("focusin", this.#focusIn.bind(this), {
            capture: true,
            signal: signal
        });
        element.addEventListener("focusout", this.#focusOut.bind(this), {
            capture: true,
            signal: signal
        });
        element.addEventListener("contextmenu", $cca4aceb320d03d3$var$noContextMenu, {
            signal: signal
        });
    }
    hide() {
        this.#toolbar.classList.add("hidden");
        this.#colorPicker?.hideDropdown();
    }
    show() {
        this.#toolbar.classList.remove("hidden");
    }
    #addDeleteButton() {
        const button = document.createElement("button");
        button.className = "delete";
        button.tabIndex = 0;
        button.setAttribute("data-l10n-id", `pdfjs-editor-remove-${this.#editor.editorType}-button`);
        this.#addListenersToElement(button);
        button.addEventListener("click", (e)=>{
            this.#editor._uiManager.delete();
        }, {
            signal: this.#editor._uiManager._signal
        });
        this.#buttons.append(button);
    }
    get #divider() {
        const divider = document.createElement("div");
        divider.className = "divider";
        return divider;
    }
    addAltTextButton(button) {
        this.#addListenersToElement(button);
        this.#buttons.prepend(button, this.#divider);
    }
    addColorPicker(colorPicker) {
        this.#colorPicker = colorPicker;
        const button = colorPicker.renderButton();
        this.#addListenersToElement(button);
        this.#buttons.prepend(button, this.#divider);
    }
    remove() {
        this.#toolbar.remove();
        this.#colorPicker?.destroy();
        this.#colorPicker = null;
    }
}
class $cca4aceb320d03d3$var$HighlightToolbar {
    #buttons = null;
    #toolbar = null;
    #uiManager;
    constructor(uiManager){
        this.#uiManager = uiManager;
    }
    #render() {
        const editToolbar = this.#toolbar = document.createElement("div");
        editToolbar.className = "editToolbar";
        editToolbar.setAttribute("role", "toolbar");
        editToolbar.addEventListener("contextmenu", $cca4aceb320d03d3$var$noContextMenu, {
            signal: this.#uiManager._signal
        });
        const buttons = this.#buttons = document.createElement("div");
        buttons.className = "buttons";
        editToolbar.append(buttons);
        this.#addHighlightButton();
        return editToolbar;
    }
    #getLastPoint(boxes, isLTR) {
        let lastY = 0;
        let lastX = 0;
        for (const box of boxes){
            const y = box.y + box.height;
            if (y < lastY) continue;
            const x = box.x + (isLTR ? box.width : 0);
            if (y > lastY) {
                lastX = x;
                lastY = y;
                continue;
            }
            if (isLTR) {
                if (x > lastX) lastX = x;
            } else if (x < lastX) lastX = x;
        }
        return [
            isLTR ? 1 - lastX : lastX,
            lastY
        ];
    }
    show(parent, boxes, isLTR) {
        const [x, y] = this.#getLastPoint(boxes, isLTR);
        const { style: style } = this.#toolbar ||= this.#render();
        parent.append(this.#toolbar);
        style.insetInlineEnd = `${100 * x}%`;
        style.top = `calc(${100 * y}% + var(--editor-toolbar-vert-offset))`;
    }
    hide() {
        this.#toolbar.remove();
    }
    #addHighlightButton() {
        const button = document.createElement("button");
        button.className = "highlightButton";
        button.tabIndex = 0;
        button.setAttribute("data-l10n-id", `pdfjs-highlight-floating-button1`);
        const span = document.createElement("span");
        button.append(span);
        span.className = "visuallyHidden";
        span.setAttribute("data-l10n-id", "pdfjs-highlight-floating-button-label");
        const signal = this.#uiManager._signal;
        button.addEventListener("contextmenu", $cca4aceb320d03d3$var$noContextMenu, {
            signal: signal
        });
        button.addEventListener("click", ()=>{
            this.#uiManager.highlightSelection("floating_button");
        }, {
            signal: signal
        });
        this.#buttons.append(button);
    }
}
function $cca4aceb320d03d3$var$bindEvents(obj, element, names) {
    for (const name of names)element.addEventListener(name, obj[name].bind(obj));
}
function $cca4aceb320d03d3$var$opacityToHex(opacity) {
    return Math.round(Math.min(255, Math.max(1, 255 * opacity))).toString(16).padStart(2, "0");
}
class $cca4aceb320d03d3$var$IdManager {
    #id = 0;
    get id() {
        return `${$cca4aceb320d03d3$var$AnnotationEditorPrefix}${this.#id++}`;
    }
}
class $cca4aceb320d03d3$var$ImageManager {
    #baseId = $cca4aceb320d03d3$var$getUuid();
    #id = 0;
    #cache = null;
    static get _isSVGFittingCanvas() {
        const svg = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
        const canvas = new OffscreenCanvas(1, 3);
        const ctx = canvas.getContext("2d", {
            willReadFrequently: true
        });
        const image = new Image();
        image.src = svg;
        const promise = image.decode().then(()=>{
            ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
            return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
        });
        return $cca4aceb320d03d3$var$shadow(this, "_isSVGFittingCanvas", promise);
    }
    async #get(key, rawData) {
        this.#cache ||= new Map();
        let data = this.#cache.get(key);
        if (data === null) return null;
        if (data?.bitmap) {
            data.refCounter += 1;
            return data;
        }
        try {
            data ||= {
                bitmap: null,
                id: `image_${this.#baseId}_${this.#id++}`,
                refCounter: 0,
                isSvg: false
            };
            let image;
            if (typeof rawData === "string") {
                data.url = rawData;
                image = await $cca4aceb320d03d3$var$fetchData(rawData, "blob");
            } else image = data.file = rawData;
            if (image.type === "image/svg+xml") {
                const mustRemoveAspectRatioPromise = $cca4aceb320d03d3$var$ImageManager._isSVGFittingCanvas;
                const fileReader = new FileReader();
                const imageElement = new Image();
                const imagePromise = new Promise((resolve, reject)=>{
                    imageElement.onload = ()=>{
                        data.bitmap = imageElement;
                        data.isSvg = true;
                        resolve();
                    };
                    fileReader.onload = async ()=>{
                        const url = data.svgUrl = fileReader.result;
                        imageElement.src = await mustRemoveAspectRatioPromise ? `${url}#svgView(preserveAspectRatio(none))` : url;
                    };
                    imageElement.onerror = fileReader.onerror = reject;
                });
                fileReader.readAsDataURL(image);
                await imagePromise;
            } else data.bitmap = await createImageBitmap(image);
            data.refCounter = 1;
        } catch (e) {
            console.error(e);
            data = null;
        }
        this.#cache.set(key, data);
        if (data) this.#cache.set(data.id, data);
        return data;
    }
    async getFromFile(file) {
        const { lastModified: lastModified, name: name, size: size, type: type } = file;
        return this.#get(`${lastModified}_${name}_${size}_${type}`, file);
    }
    async getFromUrl(url) {
        return this.#get(url, url);
    }
    async getFromId(id) {
        this.#cache ||= new Map();
        const data = this.#cache.get(id);
        if (!data) return null;
        if (data.bitmap) {
            data.refCounter += 1;
            return data;
        }
        if (data.file) return this.getFromFile(data.file);
        return this.getFromUrl(data.url);
    }
    getSvgUrl(id) {
        const data = this.#cache.get(id);
        if (!data?.isSvg) return null;
        return data.svgUrl;
    }
    deleteId(id) {
        this.#cache ||= new Map();
        const data = this.#cache.get(id);
        if (!data) return;
        data.refCounter -= 1;
        if (data.refCounter !== 0) return;
        data.bitmap = null;
    }
    isValidId(id) {
        return id.startsWith(`image_${this.#baseId}_`);
    }
}
class $cca4aceb320d03d3$var$CommandManager {
    #commands = [];
    #locked = false;
    #maxSize;
    #position = -1;
    constructor(maxSize = 128){
        this.#maxSize = maxSize;
    }
    add({ cmd: cmd, undo: undo, post: post, mustExec: mustExec, type: type = NaN, overwriteIfSameType: overwriteIfSameType = false, keepUndo: keepUndo = false }) {
        if (mustExec) cmd();
        if (this.#locked) return;
        const save = {
            cmd: cmd,
            undo: undo,
            post: post,
            type: type
        };
        if (this.#position === -1) {
            if (this.#commands.length > 0) this.#commands.length = 0;
            this.#position = 0;
            this.#commands.push(save);
            return;
        }
        if (overwriteIfSameType && this.#commands[this.#position].type === type) {
            if (keepUndo) save.undo = this.#commands[this.#position].undo;
            this.#commands[this.#position] = save;
            return;
        }
        const next = this.#position + 1;
        if (next === this.#maxSize) this.#commands.splice(0, 1);
        else {
            this.#position = next;
            if (next < this.#commands.length) this.#commands.splice(next);
        }
        this.#commands.push(save);
    }
    undo() {
        if (this.#position === -1) return;
        this.#locked = true;
        const { undo: undo, post: post } = this.#commands[this.#position];
        undo();
        post?.();
        this.#locked = false;
        this.#position -= 1;
    }
    redo() {
        if (this.#position < this.#commands.length - 1) {
            this.#position += 1;
            this.#locked = true;
            const { cmd: cmd, post: post } = this.#commands[this.#position];
            cmd();
            post?.();
            this.#locked = false;
        }
    }
    hasSomethingToUndo() {
        return this.#position !== -1;
    }
    hasSomethingToRedo() {
        return this.#position < this.#commands.length - 1;
    }
    destroy() {
        this.#commands = null;
    }
}
class $cca4aceb320d03d3$var$KeyboardManager {
    constructor(callbacks){
        this.buffer = [];
        this.callbacks = new Map();
        this.allKeys = new Set();
        const { isMac: isMac } = $cca4aceb320d03d3$var$util_FeatureTest.platform;
        for (const [keys, callback, options = {}] of callbacks)for (const key of keys){
            const isMacKey = key.startsWith("mac+");
            if (isMac && isMacKey) {
                this.callbacks.set(key.slice(4), {
                    callback: callback,
                    options: options
                });
                this.allKeys.add(key.split("+").at(-1));
            } else if (!isMac && !isMacKey) {
                this.callbacks.set(key, {
                    callback: callback,
                    options: options
                });
                this.allKeys.add(key.split("+").at(-1));
            }
        }
    }
    #serialize(event) {
        if (event.altKey) this.buffer.push("alt");
        if (event.ctrlKey) this.buffer.push("ctrl");
        if (event.metaKey) this.buffer.push("meta");
        if (event.shiftKey) this.buffer.push("shift");
        this.buffer.push(event.key);
        const str = this.buffer.join("+");
        this.buffer.length = 0;
        return str;
    }
    exec(self, event) {
        if (!this.allKeys.has(event.key)) return;
        const info = this.callbacks.get(this.#serialize(event));
        if (!info) return;
        const { callback: callback, options: { bubbles: bubbles = false, args: args = [], checker: checker = null } } = info;
        if (checker && !checker(self, event)) return;
        callback.bind(self, ...args, event)();
        if (!bubbles) {
            event.stopPropagation();
            event.preventDefault();
        }
    }
}
class $cca4aceb320d03d3$var$ColorManager {
    static _colorsMapping = new Map([
        [
            "CanvasText",
            [
                0,
                0,
                0
            ]
        ],
        [
            "Canvas",
            [
                255,
                255,
                255
            ]
        ]
    ]);
    get _colors() {
        const colors = new Map([
            [
                "CanvasText",
                null
            ],
            [
                "Canvas",
                null
            ]
        ]);
        $cca4aceb320d03d3$var$getColorValues(colors);
        return $cca4aceb320d03d3$var$shadow(this, "_colors", colors);
    }
    convert(color) {
        const rgb = $cca4aceb320d03d3$var$getRGB(color);
        if (!window.matchMedia("(forced-colors: active)").matches) return rgb;
        for (const [name, RGB] of this._colors){
            if (RGB.every((x, i)=>x === rgb[i])) return $cca4aceb320d03d3$var$ColorManager._colorsMapping.get(name);
        }
        return rgb;
    }
    getHexCode(name) {
        const rgb = this._colors.get(name);
        if (!rgb) return name;
        return $cca4aceb320d03d3$var$Util.makeHexColor(...rgb);
    }
}
class $cca4aceb320d03d3$var$AnnotationEditorUIManager {
    #abortController = new AbortController();
    #activeEditor = null;
    #allEditors = new Map();
    #allLayers = new Map();
    #altTextManager = null;
    #annotationStorage = null;
    #changedExistingAnnotations = null;
    #commandManager = new $cca4aceb320d03d3$var$CommandManager();
    #currentPageIndex = 0;
    #deletedAnnotationsElementIds = new Set();
    #draggingEditors = null;
    #editorTypes = null;
    #editorsToRescale = new Set();
    #enableHighlightFloatingButton = false;
    #filterFactory = null;
    #focusMainContainerTimeoutId = null;
    #highlightColors = null;
    #highlightWhenShiftUp = false;
    #highlightToolbar = null;
    #idManager = new $cca4aceb320d03d3$var$IdManager();
    #isEnabled = false;
    #isWaiting = false;
    #lastActiveElement = null;
    #mainHighlightColorPicker = null;
    #mlManager = null;
    #mode = $cca4aceb320d03d3$var$AnnotationEditorType.NONE;
    #selectedEditors = new Set();
    #selectedTextNode = null;
    #pageColors = null;
    #showAllStates = null;
    #boundBlur = this.blur.bind(this);
    #boundFocus = this.focus.bind(this);
    #boundCopy = this.copy.bind(this);
    #boundCut = this.cut.bind(this);
    #boundPaste = this.paste.bind(this);
    #boundKeydown = this.keydown.bind(this);
    #boundKeyup = this.keyup.bind(this);
    #boundOnEditingAction = this.onEditingAction.bind(this);
    #boundOnPageChanging = this.onPageChanging.bind(this);
    #boundOnScaleChanging = this.onScaleChanging.bind(this);
    #boundOnRotationChanging = this.onRotationChanging.bind(this);
    #previousStates = {
        isEditing: false,
        isEmpty: true,
        hasSomethingToUndo: false,
        hasSomethingToRedo: false,
        hasSelectedEditor: false,
        hasSelectedText: false
    };
    #translation = [
        0,
        0
    ];
    #translationTimeoutId = null;
    #container = null;
    #viewer = null;
    static TRANSLATE_SMALL = 1;
    static TRANSLATE_BIG = 10;
    static get _keyboardManager() {
        const proto = $cca4aceb320d03d3$var$AnnotationEditorUIManager.prototype;
        const arrowChecker = (self)=>self.#container.contains(document.activeElement) && document.activeElement.tagName !== "BUTTON" && self.hasSomethingToControl();
        const textInputChecker = (_self, { target: el })=>{
            if (el instanceof HTMLInputElement) {
                const { type: type } = el;
                return type !== "text" && type !== "number";
            }
            return true;
        };
        const small = this.TRANSLATE_SMALL;
        const big = this.TRANSLATE_BIG;
        return $cca4aceb320d03d3$var$shadow(this, "_keyboardManager", new $cca4aceb320d03d3$var$KeyboardManager([
            [
                [
                    "ctrl+a",
                    "mac+meta+a"
                ],
                proto.selectAll,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "ctrl+z",
                    "mac+meta+z"
                ],
                proto.undo,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "ctrl+y",
                    "ctrl+shift+z",
                    "mac+meta+shift+z",
                    "ctrl+shift+Z",
                    "mac+meta+shift+Z"
                ],
                proto.redo,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "Backspace",
                    "alt+Backspace",
                    "ctrl+Backspace",
                    "shift+Backspace",
                    "mac+Backspace",
                    "mac+alt+Backspace",
                    "mac+ctrl+Backspace",
                    "Delete",
                    "ctrl+Delete",
                    "shift+Delete",
                    "mac+Delete"
                ],
                proto.delete,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "Enter",
                    "mac+Enter"
                ],
                proto.addNewEditorFromKeyboard,
                {
                    checker: (self, { target: el })=>!(el instanceof HTMLButtonElement) && self.#container.contains(el) && !self.isEnterHandled
                }
            ],
            [
                [
                    " ",
                    "mac+ "
                ],
                proto.addNewEditorFromKeyboard,
                {
                    checker: (self, { target: el })=>!(el instanceof HTMLButtonElement) && self.#container.contains(document.activeElement)
                }
            ],
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                proto.unselectAll
            ],
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        -small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        -big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        -small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        -big
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        big
                    ],
                    checker: arrowChecker
                }
            ]
        ]));
    }
    constructor(container, viewer, altTextManager, eventBus, pdfDocument, pageColors, highlightColors, enableHighlightFloatingButton, mlManager){
        this._signal = this.#abortController.signal;
        this.#container = container;
        this.#viewer = viewer;
        this.#altTextManager = altTextManager;
        this._eventBus = eventBus;
        this._eventBus._on("editingaction", this.#boundOnEditingAction);
        this._eventBus._on("pagechanging", this.#boundOnPageChanging);
        this._eventBus._on("scalechanging", this.#boundOnScaleChanging);
        this._eventBus._on("rotationchanging", this.#boundOnRotationChanging);
        this.#addSelectionListener();
        this.#addDragAndDropListeners();
        this.#addKeyboardManager();
        this.#annotationStorage = pdfDocument.annotationStorage;
        this.#filterFactory = pdfDocument.filterFactory;
        this.#pageColors = pageColors;
        this.#highlightColors = highlightColors || null;
        this.#enableHighlightFloatingButton = enableHighlightFloatingButton;
        this.#mlManager = mlManager || null;
        this.viewParameters = {
            realScale: $cca4aceb320d03d3$var$PixelsPerInch.PDF_TO_CSS_UNITS,
            rotation: 0
        };
        this.isShiftKeyDown = false;
    }
    destroy() {
        this.#abortController?.abort();
        this.#abortController = null;
        this._signal = null;
        this._eventBus._off("editingaction", this.#boundOnEditingAction);
        this._eventBus._off("pagechanging", this.#boundOnPageChanging);
        this._eventBus._off("scalechanging", this.#boundOnScaleChanging);
        this._eventBus._off("rotationchanging", this.#boundOnRotationChanging);
        for (const layer of this.#allLayers.values())layer.destroy();
        this.#allLayers.clear();
        this.#allEditors.clear();
        this.#editorsToRescale.clear();
        this.#activeEditor = null;
        this.#selectedEditors.clear();
        this.#commandManager.destroy();
        this.#altTextManager?.destroy();
        this.#highlightToolbar?.hide();
        this.#highlightToolbar = null;
        if (this.#focusMainContainerTimeoutId) {
            clearTimeout(this.#focusMainContainerTimeoutId);
            this.#focusMainContainerTimeoutId = null;
        }
        if (this.#translationTimeoutId) {
            clearTimeout(this.#translationTimeoutId);
            this.#translationTimeoutId = null;
        }
    }
    async mlGuess(data) {
        return this.#mlManager?.guess(data) || null;
    }
    get hasMLManager() {
        return !!this.#mlManager;
    }
    get hcmFilter() {
        return $cca4aceb320d03d3$var$shadow(this, "hcmFilter", this.#pageColors ? this.#filterFactory.addHCMFilter(this.#pageColors.foreground, this.#pageColors.background) : "none");
    }
    get direction() {
        return $cca4aceb320d03d3$var$shadow(this, "direction", getComputedStyle(this.#container).direction);
    }
    get highlightColors() {
        return $cca4aceb320d03d3$var$shadow(this, "highlightColors", this.#highlightColors ? new Map(this.#highlightColors.split(",").map((pair)=>pair.split("=").map((x)=>x.trim()))) : null);
    }
    get highlightColorNames() {
        return $cca4aceb320d03d3$var$shadow(this, "highlightColorNames", this.highlightColors ? new Map(Array.from(this.highlightColors, (e)=>e.reverse())) : null);
    }
    setMainHighlightColorPicker(colorPicker) {
        this.#mainHighlightColorPicker = colorPicker;
    }
    editAltText(editor) {
        this.#altTextManager?.editAltText(this, editor);
    }
    onPageChanging({ pageNumber: pageNumber }) {
        this.#currentPageIndex = pageNumber - 1;
    }
    focusMainContainer() {
        this.#container.focus();
    }
    findParent(x, y) {
        for (const layer of this.#allLayers.values()){
            const { x: layerX, y: layerY, width: width, height: height } = layer.div.getBoundingClientRect();
            if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) return layer;
        }
        return null;
    }
    disableUserSelect(value = false) {
        this.#viewer.classList.toggle("noUserSelect", value);
    }
    addShouldRescale(editor) {
        this.#editorsToRescale.add(editor);
    }
    removeShouldRescale(editor) {
        this.#editorsToRescale.delete(editor);
    }
    onScaleChanging({ scale: scale }) {
        this.commitOrRemove();
        this.viewParameters.realScale = scale * $cca4aceb320d03d3$var$PixelsPerInch.PDF_TO_CSS_UNITS;
        for (const editor of this.#editorsToRescale)editor.onScaleChanging();
    }
    onRotationChanging({ pagesRotation: pagesRotation }) {
        this.commitOrRemove();
        this.viewParameters.rotation = pagesRotation;
    }
    #getAnchorElementForSelection({ anchorNode: anchorNode }) {
        return anchorNode.nodeType === Node.TEXT_NODE ? anchorNode.parentElement : anchorNode;
    }
    highlightSelection(methodOfCreation = "") {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) return;
        const { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = selection;
        const text = selection.toString();
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        const boxes = this.getSelectionBoxes(textLayer);
        if (!boxes) return;
        selection.empty();
        if (this.#mode === $cca4aceb320d03d3$var$AnnotationEditorType.NONE) {
            this._eventBus.dispatch("showannotationeditorui", {
                source: this,
                mode: $cca4aceb320d03d3$var$AnnotationEditorType.HIGHLIGHT
            });
            this.showAllEditors("highlight", true, true);
        }
        for (const layer of this.#allLayers.values())if (layer.hasTextLayer(textLayer)) {
            layer.createAndAddNewEditor({
                x: 0,
                y: 0
            }, false, {
                methodOfCreation: methodOfCreation,
                boxes: boxes,
                anchorNode: anchorNode,
                anchorOffset: anchorOffset,
                focusNode: focusNode,
                focusOffset: focusOffset,
                text: text
            });
            break;
        }
    }
    #displayHighlightToolbar() {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) return;
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        const boxes = this.getSelectionBoxes(textLayer);
        if (!boxes) return;
        this.#highlightToolbar ||= new $cca4aceb320d03d3$var$HighlightToolbar(this);
        this.#highlightToolbar.show(textLayer, boxes, this.direction === "ltr");
    }
    addToAnnotationStorage(editor) {
        if (!editor.isEmpty() && this.#annotationStorage && !this.#annotationStorage.has(editor.id)) this.#annotationStorage.setValue(editor.id, editor);
    }
    #selectionChange() {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) {
            if (this.#selectedTextNode) {
                this.#highlightToolbar?.hide();
                this.#selectedTextNode = null;
                this.#dispatchUpdateStates({
                    hasSelectedText: false
                });
            }
            return;
        }
        const { anchorNode: anchorNode } = selection;
        if (anchorNode === this.#selectedTextNode) return;
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        if (!textLayer) {
            if (this.#selectedTextNode) {
                this.#highlightToolbar?.hide();
                this.#selectedTextNode = null;
                this.#dispatchUpdateStates({
                    hasSelectedText: false
                });
            }
            return;
        }
        this.#highlightToolbar?.hide();
        this.#selectedTextNode = anchorNode;
        this.#dispatchUpdateStates({
            hasSelectedText: true
        });
        if (this.#mode !== $cca4aceb320d03d3$var$AnnotationEditorType.HIGHLIGHT && this.#mode !== $cca4aceb320d03d3$var$AnnotationEditorType.NONE) return;
        if (this.#mode === $cca4aceb320d03d3$var$AnnotationEditorType.HIGHLIGHT) this.showAllEditors("highlight", true, true);
        this.#highlightWhenShiftUp = this.isShiftKeyDown;
        if (!this.isShiftKeyDown) {
            const signal = this._signal;
            const pointerup = (e)=>{
                if (e.type === "pointerup" && e.button !== 0) return;
                window.removeEventListener("pointerup", pointerup);
                window.removeEventListener("blur", pointerup);
                if (e.type === "pointerup") this.#onSelectEnd("main_toolbar");
            };
            window.addEventListener("pointerup", pointerup, {
                signal: signal
            });
            window.addEventListener("blur", pointerup, {
                signal: signal
            });
        }
    }
    #onSelectEnd(methodOfCreation = "") {
        if (this.#mode === $cca4aceb320d03d3$var$AnnotationEditorType.HIGHLIGHT) this.highlightSelection(methodOfCreation);
        else if (this.#enableHighlightFloatingButton) this.#displayHighlightToolbar();
    }
    #addSelectionListener() {
        document.addEventListener("selectionchange", this.#selectionChange.bind(this), {
            signal: this._signal
        });
    }
    #addFocusManager() {
        const signal = this._signal;
        window.addEventListener("focus", this.#boundFocus, {
            signal: signal
        });
        window.addEventListener("blur", this.#boundBlur, {
            signal: signal
        });
    }
    #removeFocusManager() {
        window.removeEventListener("focus", this.#boundFocus);
        window.removeEventListener("blur", this.#boundBlur);
    }
    blur() {
        this.isShiftKeyDown = false;
        if (this.#highlightWhenShiftUp) {
            this.#highlightWhenShiftUp = false;
            this.#onSelectEnd("main_toolbar");
        }
        if (!this.hasSelection) return;
        const { activeElement: activeElement } = document;
        for (const editor of this.#selectedEditors)if (editor.div.contains(activeElement)) {
            this.#lastActiveElement = [
                editor,
                activeElement
            ];
            editor._focusEventsAllowed = false;
            break;
        }
    }
    focus() {
        if (!this.#lastActiveElement) return;
        const [lastEditor, lastActiveElement] = this.#lastActiveElement;
        this.#lastActiveElement = null;
        lastActiveElement.addEventListener("focusin", ()=>{
            lastEditor._focusEventsAllowed = true;
        }, {
            once: true,
            signal: this._signal
        });
        lastActiveElement.focus();
    }
    #addKeyboardManager() {
        const signal = this._signal;
        window.addEventListener("keydown", this.#boundKeydown, {
            signal: signal
        });
        window.addEventListener("keyup", this.#boundKeyup, {
            signal: signal
        });
    }
    #removeKeyboardManager() {
        window.removeEventListener("keydown", this.#boundKeydown);
        window.removeEventListener("keyup", this.#boundKeyup);
    }
    #addCopyPasteListeners() {
        const signal = this._signal;
        document.addEventListener("copy", this.#boundCopy, {
            signal: signal
        });
        document.addEventListener("cut", this.#boundCut, {
            signal: signal
        });
        document.addEventListener("paste", this.#boundPaste, {
            signal: signal
        });
    }
    #removeCopyPasteListeners() {
        document.removeEventListener("copy", this.#boundCopy);
        document.removeEventListener("cut", this.#boundCut);
        document.removeEventListener("paste", this.#boundPaste);
    }
    #addDragAndDropListeners() {
        const signal = this._signal;
        document.addEventListener("dragover", this.dragOver.bind(this), {
            signal: signal
        });
        document.addEventListener("drop", this.drop.bind(this), {
            signal: signal
        });
    }
    addEditListeners() {
        this.#addKeyboardManager();
        this.#addCopyPasteListeners();
    }
    removeEditListeners() {
        this.#removeKeyboardManager();
        this.#removeCopyPasteListeners();
    }
    dragOver(event) {
        for (const { type: type } of event.dataTransfer.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(type)) {
                event.dataTransfer.dropEffect = "copy";
                event.preventDefault();
                return;
            }
        }
    }
    drop(event) {
        for (const item of event.dataTransfer.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                editorType.paste(item, this.currentLayer);
                event.preventDefault();
                return;
            }
        }
    }
    copy(event) {
        event.preventDefault();
        this.#activeEditor?.commitOrRemove();
        if (!this.hasSelection) return;
        const editors = [];
        for (const editor of this.#selectedEditors){
            const serialized = editor.serialize(true);
            if (serialized) editors.push(serialized);
        }
        if (editors.length === 0) return;
        event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
    }
    cut(event) {
        this.copy(event);
        this.delete();
    }
    paste(event) {
        event.preventDefault();
        const { clipboardData: clipboardData } = event;
        for (const item of clipboardData.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                editorType.paste(item, this.currentLayer);
                return;
            }
        }
        let data = clipboardData.getData("application/pdfjs");
        if (!data) return;
        try {
            data = JSON.parse(data);
        } catch (ex) {
            $cca4aceb320d03d3$var$warn(`paste: "${ex.message}".`);
            return;
        }
        if (!Array.isArray(data)) return;
        this.unselectAll();
        const layer = this.currentLayer;
        try {
            const newEditors = [];
            for (const editor of data){
                const deserializedEditor = layer.deserialize(editor);
                if (!deserializedEditor) return;
                newEditors.push(deserializedEditor);
            }
            const cmd = ()=>{
                for (const editor of newEditors)this.#addEditorToLayer(editor);
                this.#selectEditors(newEditors);
            };
            const undo = ()=>{
                for (const editor of newEditors)editor.remove();
            };
            this.addCommands({
                cmd: cmd,
                undo: undo,
                mustExec: true
            });
        } catch (ex) {
            $cca4aceb320d03d3$var$warn(`paste: "${ex.message}".`);
        }
    }
    keydown(event) {
        if (!this.isShiftKeyDown && event.key === "Shift") this.isShiftKeyDown = true;
        if (this.#mode !== $cca4aceb320d03d3$var$AnnotationEditorType.NONE && !this.isEditorHandlingKeyboard) $cca4aceb320d03d3$var$AnnotationEditorUIManager._keyboardManager.exec(this, event);
    }
    keyup(event) {
        if (this.isShiftKeyDown && event.key === "Shift") {
            this.isShiftKeyDown = false;
            if (this.#highlightWhenShiftUp) {
                this.#highlightWhenShiftUp = false;
                this.#onSelectEnd("main_toolbar");
            }
        }
    }
    onEditingAction({ name: name }) {
        switch(name){
            case "undo":
            case "redo":
            case "delete":
            case "selectAll":
                this[name]();
                break;
            case "highlightSelection":
                this.highlightSelection("context_menu");
                break;
        }
    }
    #dispatchUpdateStates(details) {
        const hasChanged = Object.entries(details).some(([key, value])=>this.#previousStates[key] !== value);
        if (hasChanged) {
            this._eventBus.dispatch("annotationeditorstateschanged", {
                source: this,
                details: Object.assign(this.#previousStates, details)
            });
            if (this.#mode === $cca4aceb320d03d3$var$AnnotationEditorType.HIGHLIGHT && details.hasSelectedEditor === false) this.#dispatchUpdateUI([
                [
                    $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_FREE,
                    true
                ]
            ]);
        }
    }
    #dispatchUpdateUI(details) {
        this._eventBus.dispatch("annotationeditorparamschanged", {
            source: this,
            details: details
        });
    }
    setEditingState(isEditing) {
        if (isEditing) {
            this.#addFocusManager();
            this.#addCopyPasteListeners();
            this.#dispatchUpdateStates({
                isEditing: this.#mode !== $cca4aceb320d03d3$var$AnnotationEditorType.NONE,
                isEmpty: this.#isEmpty(),
                hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                hasSelectedEditor: false
            });
        } else {
            this.#removeFocusManager();
            this.#removeCopyPasteListeners();
            this.#dispatchUpdateStates({
                isEditing: false
            });
            this.disableUserSelect(false);
        }
    }
    registerEditorTypes(types) {
        if (this.#editorTypes) return;
        this.#editorTypes = types;
        for (const editorType of this.#editorTypes)this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
    }
    getId() {
        return this.#idManager.id;
    }
    get currentLayer() {
        return this.#allLayers.get(this.#currentPageIndex);
    }
    getLayer(pageIndex) {
        return this.#allLayers.get(pageIndex);
    }
    get currentPageIndex() {
        return this.#currentPageIndex;
    }
    addLayer(layer) {
        this.#allLayers.set(layer.pageIndex, layer);
        if (this.#isEnabled) layer.enable();
        else layer.disable();
    }
    removeLayer(layer) {
        this.#allLayers.delete(layer.pageIndex);
    }
    updateMode(mode, editId = null, isFromKeyboard = false) {
        if (this.#mode === mode) return;
        this.#mode = mode;
        if (mode === $cca4aceb320d03d3$var$AnnotationEditorType.NONE) {
            this.setEditingState(false);
            this.#disableAll();
            return;
        }
        this.setEditingState(true);
        this.#enableAll();
        this.unselectAll();
        for (const layer of this.#allLayers.values())layer.updateMode(mode);
        if (!editId && isFromKeyboard) {
            this.addNewEditorFromKeyboard();
            return;
        }
        if (!editId) return;
        for (const editor of this.#allEditors.values())if (editor.annotationElementId === editId) {
            this.setSelected(editor);
            editor.enterInEditMode();
            break;
        }
    }
    addNewEditorFromKeyboard() {
        if (this.currentLayer.canCreateNewEmptyEditor()) this.currentLayer.addNewEditor();
    }
    updateToolbar(mode) {
        if (mode === this.#mode) return;
        this._eventBus.dispatch("switchannotationeditormode", {
            source: this,
            mode: mode
        });
    }
    updateParams(type, value) {
        if (!this.#editorTypes) return;
        switch(type){
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.CREATE:
                this.currentLayer.addNewEditor();
                return;
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR:
                this.#mainHighlightColorPicker?.updateColor(value);
                break;
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_SHOW_ALL:
                this._eventBus.dispatch("reporttelemetry", {
                    source: this,
                    details: {
                        type: "editing",
                        data: {
                            type: "highlight",
                            action: "toggle_visibility"
                        }
                    }
                });
                (this.#showAllStates ||= new Map()).set(type, value);
                this.showAllEditors("highlight", value);
                break;
        }
        for (const editor of this.#selectedEditors)editor.updateParams(type, value);
        for (const editorType of this.#editorTypes)editorType.updateDefaultParams(type, value);
    }
    showAllEditors(type, visible, updateButton = false) {
        for (const editor of this.#allEditors.values())if (editor.editorType === type) editor.show(visible);
        const state = this.#showAllStates?.get($cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_SHOW_ALL) ?? true;
        if (state !== visible) this.#dispatchUpdateUI([
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_SHOW_ALL,
                visible
            ]
        ]);
    }
    enableWaiting(mustWait = false) {
        if (this.#isWaiting === mustWait) return;
        this.#isWaiting = mustWait;
        for (const layer of this.#allLayers.values()){
            if (mustWait) layer.disableClick();
            else layer.enableClick();
            layer.div.classList.toggle("waiting", mustWait);
        }
    }
    #enableAll() {
        if (!this.#isEnabled) {
            this.#isEnabled = true;
            for (const layer of this.#allLayers.values())layer.enable();
            for (const editor of this.#allEditors.values())editor.enable();
        }
    }
    #disableAll() {
        this.unselectAll();
        if (this.#isEnabled) {
            this.#isEnabled = false;
            for (const layer of this.#allLayers.values())layer.disable();
            for (const editor of this.#allEditors.values())editor.disable();
        }
    }
    getEditors(pageIndex) {
        const editors = [];
        for (const editor of this.#allEditors.values())if (editor.pageIndex === pageIndex) editors.push(editor);
        return editors;
    }
    getEditor(id) {
        return this.#allEditors.get(id);
    }
    addEditor(editor) {
        this.#allEditors.set(editor.id, editor);
    }
    removeEditor(editor) {
        if (editor.div.contains(document.activeElement)) {
            if (this.#focusMainContainerTimeoutId) clearTimeout(this.#focusMainContainerTimeoutId);
            this.#focusMainContainerTimeoutId = setTimeout(()=>{
                this.focusMainContainer();
                this.#focusMainContainerTimeoutId = null;
            }, 0);
        }
        this.#allEditors.delete(editor.id);
        this.unselect(editor);
        if (!editor.annotationElementId || !this.#deletedAnnotationsElementIds.has(editor.annotationElementId)) this.#annotationStorage?.remove(editor.id);
    }
    addDeletedAnnotationElement(editor) {
        this.#deletedAnnotationsElementIds.add(editor.annotationElementId);
        this.addChangedExistingAnnotation(editor);
        editor.deleted = true;
    }
    isDeletedAnnotationElement(annotationElementId) {
        return this.#deletedAnnotationsElementIds.has(annotationElementId);
    }
    removeDeletedAnnotationElement(editor) {
        this.#deletedAnnotationsElementIds.delete(editor.annotationElementId);
        this.removeChangedExistingAnnotation(editor);
        editor.deleted = false;
    }
    #addEditorToLayer(editor) {
        const layer = this.#allLayers.get(editor.pageIndex);
        if (layer) layer.addOrRebuild(editor);
        else {
            this.addEditor(editor);
            this.addToAnnotationStorage(editor);
        }
    }
    setActiveEditor(editor) {
        if (this.#activeEditor === editor) return;
        this.#activeEditor = editor;
        if (editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
    }
    get #lastSelectedEditor() {
        let ed = null;
        for (ed of this.#selectedEditors);
        return ed;
    }
    updateUI(editor) {
        if (this.#lastSelectedEditor === editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
    }
    toggleSelected(editor) {
        if (this.#selectedEditors.has(editor)) {
            this.#selectedEditors.delete(editor);
            editor.unselect();
            this.#dispatchUpdateStates({
                hasSelectedEditor: this.hasSelection
            });
            return;
        }
        this.#selectedEditors.add(editor);
        editor.select();
        this.#dispatchUpdateUI(editor.propertiesToUpdate);
        this.#dispatchUpdateStates({
            hasSelectedEditor: true
        });
    }
    setSelected(editor) {
        for (const ed of this.#selectedEditors)if (ed !== editor) ed.unselect();
        this.#selectedEditors.clear();
        this.#selectedEditors.add(editor);
        editor.select();
        this.#dispatchUpdateUI(editor.propertiesToUpdate);
        this.#dispatchUpdateStates({
            hasSelectedEditor: true
        });
    }
    isSelected(editor) {
        return this.#selectedEditors.has(editor);
    }
    get firstSelectedEditor() {
        return this.#selectedEditors.values().next().value;
    }
    unselect(editor) {
        editor.unselect();
        this.#selectedEditors.delete(editor);
        this.#dispatchUpdateStates({
            hasSelectedEditor: this.hasSelection
        });
    }
    get hasSelection() {
        return this.#selectedEditors.size !== 0;
    }
    get isEnterHandled() {
        return this.#selectedEditors.size === 1 && this.firstSelectedEditor.isEnterHandled;
    }
    undo() {
        this.#commandManager.undo();
        this.#dispatchUpdateStates({
            hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
            hasSomethingToRedo: true,
            isEmpty: this.#isEmpty()
        });
    }
    redo() {
        this.#commandManager.redo();
        this.#dispatchUpdateStates({
            hasSomethingToUndo: true,
            hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
            isEmpty: this.#isEmpty()
        });
    }
    addCommands(params) {
        this.#commandManager.add(params);
        this.#dispatchUpdateStates({
            hasSomethingToUndo: true,
            hasSomethingToRedo: false,
            isEmpty: this.#isEmpty()
        });
    }
    #isEmpty() {
        if (this.#allEditors.size === 0) return true;
        if (this.#allEditors.size === 1) {
            for (const editor of this.#allEditors.values())return editor.isEmpty();
        }
        return false;
    }
    delete() {
        this.commitOrRemove();
        if (!this.hasSelection) return;
        const editors = [
            ...this.#selectedEditors
        ];
        const cmd = ()=>{
            for (const editor of editors)editor.remove();
        };
        const undo = ()=>{
            for (const editor of editors)this.#addEditorToLayer(editor);
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: true
        });
    }
    commitOrRemove() {
        this.#activeEditor?.commitOrRemove();
    }
    hasSomethingToControl() {
        return this.#activeEditor || this.hasSelection;
    }
    #selectEditors(editors) {
        for (const editor of this.#selectedEditors)editor.unselect();
        this.#selectedEditors.clear();
        for (const editor of editors){
            if (editor.isEmpty()) continue;
            this.#selectedEditors.add(editor);
            editor.select();
        }
        this.#dispatchUpdateStates({
            hasSelectedEditor: this.hasSelection
        });
    }
    selectAll() {
        for (const editor of this.#selectedEditors)editor.commit();
        this.#selectEditors(this.#allEditors.values());
    }
    unselectAll() {
        if (this.#activeEditor) {
            this.#activeEditor.commitOrRemove();
            if (this.#mode !== $cca4aceb320d03d3$var$AnnotationEditorType.NONE) return;
        }
        if (!this.hasSelection) return;
        for (const editor of this.#selectedEditors)editor.unselect();
        this.#selectedEditors.clear();
        this.#dispatchUpdateStates({
            hasSelectedEditor: false
        });
    }
    translateSelectedEditors(x, y, noCommit = false) {
        if (!noCommit) this.commitOrRemove();
        if (!this.hasSelection) return;
        this.#translation[0] += x;
        this.#translation[1] += y;
        const [totalX, totalY] = this.#translation;
        const editors = [
            ...this.#selectedEditors
        ];
        const TIME_TO_WAIT = 1000;
        if (this.#translationTimeoutId) clearTimeout(this.#translationTimeoutId);
        this.#translationTimeoutId = setTimeout(()=>{
            this.#translationTimeoutId = null;
            this.#translation[0] = this.#translation[1] = 0;
            this.addCommands({
                cmd: ()=>{
                    for (const editor of editors)if (this.#allEditors.has(editor.id)) editor.translateInPage(totalX, totalY);
                },
                undo: ()=>{
                    for (const editor of editors)if (this.#allEditors.has(editor.id)) editor.translateInPage(-totalX, -totalY);
                },
                mustExec: false
            });
        }, TIME_TO_WAIT);
        for (const editor of editors)editor.translateInPage(x, y);
    }
    setUpDragSession() {
        if (!this.hasSelection) return;
        this.disableUserSelect(true);
        this.#draggingEditors = new Map();
        for (const editor of this.#selectedEditors)this.#draggingEditors.set(editor, {
            savedX: editor.x,
            savedY: editor.y,
            savedPageIndex: editor.pageIndex,
            newX: 0,
            newY: 0,
            newPageIndex: -1
        });
    }
    endDragSession() {
        if (!this.#draggingEditors) return false;
        this.disableUserSelect(false);
        const map = this.#draggingEditors;
        this.#draggingEditors = null;
        let mustBeAddedInUndoStack = false;
        for (const [{ x: x, y: y, pageIndex: pageIndex }, value] of map){
            value.newX = x;
            value.newY = y;
            value.newPageIndex = pageIndex;
            mustBeAddedInUndoStack ||= x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex;
        }
        if (!mustBeAddedInUndoStack) return false;
        const move = (editor, x, y, pageIndex)=>{
            if (this.#allEditors.has(editor.id)) {
                const parent = this.#allLayers.get(pageIndex);
                if (parent) editor._setParentAndPosition(parent, x, y);
                else {
                    editor.pageIndex = pageIndex;
                    editor.x = x;
                    editor.y = y;
                }
            }
        };
        this.addCommands({
            cmd: ()=>{
                for (const [editor, { newX: newX, newY: newY, newPageIndex: newPageIndex }] of map)move(editor, newX, newY, newPageIndex);
            },
            undo: ()=>{
                for (const [editor, { savedX: savedX, savedY: savedY, savedPageIndex: savedPageIndex }] of map)move(editor, savedX, savedY, savedPageIndex);
            },
            mustExec: true
        });
        return true;
    }
    dragSelectedEditors(tx, ty) {
        if (!this.#draggingEditors) return;
        for (const editor of this.#draggingEditors.keys())editor.drag(tx, ty);
    }
    rebuild(editor) {
        if (editor.parent === null) {
            const parent = this.getLayer(editor.pageIndex);
            if (parent) {
                parent.changeParent(editor);
                parent.addOrRebuild(editor);
            } else {
                this.addEditor(editor);
                this.addToAnnotationStorage(editor);
                editor.rebuild();
            }
        } else editor.parent.addOrRebuild(editor);
    }
    get isEditorHandlingKeyboard() {
        return this.getActive()?.shouldGetKeyboardEvents() || this.#selectedEditors.size === 1 && this.firstSelectedEditor.shouldGetKeyboardEvents();
    }
    isActive(editor) {
        return this.#activeEditor === editor;
    }
    getActive() {
        return this.#activeEditor;
    }
    getMode() {
        return this.#mode;
    }
    get imageManager() {
        return $cca4aceb320d03d3$var$shadow(this, "imageManager", new $cca4aceb320d03d3$var$ImageManager());
    }
    getSelectionBoxes(textLayer) {
        if (!textLayer) return null;
        const selection = document.getSelection();
        for(let i = 0, ii = selection.rangeCount; i < ii; i++){
            if (!textLayer.contains(selection.getRangeAt(i).commonAncestorContainer)) return null;
        }
        const { x: layerX, y: layerY, width: parentWidth, height: parentHeight } = textLayer.getBoundingClientRect();
        let rotator;
        switch(textLayer.getAttribute("data-main-rotation")){
            case "90":
                rotator = (x, y, w, h)=>({
                        x: (y - layerY) / parentHeight,
                        y: 1 - (x + w - layerX) / parentWidth,
                        width: h / parentHeight,
                        height: w / parentWidth
                    });
                break;
            case "180":
                rotator = (x, y, w, h)=>({
                        x: 1 - (x + w - layerX) / parentWidth,
                        y: 1 - (y + h - layerY) / parentHeight,
                        width: w / parentWidth,
                        height: h / parentHeight
                    });
                break;
            case "270":
                rotator = (x, y, w, h)=>({
                        x: 1 - (y + h - layerY) / parentHeight,
                        y: (x - layerX) / parentWidth,
                        width: h / parentHeight,
                        height: w / parentWidth
                    });
                break;
            default:
                rotator = (x, y, w, h)=>({
                        x: (x - layerX) / parentWidth,
                        y: (y - layerY) / parentHeight,
                        width: w / parentWidth,
                        height: h / parentHeight
                    });
                break;
        }
        const boxes = [];
        for(let i = 0, ii = selection.rangeCount; i < ii; i++){
            const range = selection.getRangeAt(i);
            if (range.collapsed) continue;
            for (const { x: x, y: y, width: width, height: height } of range.getClientRects()){
                if (width === 0 || height === 0) continue;
                boxes.push(rotator(x, y, width, height));
            }
        }
        return boxes.length === 0 ? null : boxes;
    }
    addChangedExistingAnnotation({ annotationElementId: annotationElementId, id: id }) {
        (this.#changedExistingAnnotations ||= new Map()).set(annotationElementId, id);
    }
    removeChangedExistingAnnotation({ annotationElementId: annotationElementId }) {
        this.#changedExistingAnnotations?.delete(annotationElementId);
    }
    renderAnnotationElement(annotation) {
        const editorId = this.#changedExistingAnnotations?.get(annotation.data.id);
        if (!editorId) return;
        const editor = this.#annotationStorage.getRawValue(editorId);
        if (!editor) return;
        if (this.#mode === $cca4aceb320d03d3$var$AnnotationEditorType.NONE && !editor.hasBeenModified) return;
        editor.renderAnnotationElement(annotation);
    }
}
class $cca4aceb320d03d3$var$AltText {
    #altText = "";
    #altTextDecorative = false;
    #altTextButton = null;
    #altTextTooltip = null;
    #altTextTooltipTimeout = null;
    #altTextWasFromKeyBoard = false;
    #editor = null;
    static _l10nPromise = null;
    constructor(editor){
        this.#editor = editor;
    }
    static initialize(l10nPromise) {
        $cca4aceb320d03d3$var$AltText._l10nPromise ||= l10nPromise;
    }
    async render() {
        const altText = this.#altTextButton = document.createElement("button");
        altText.className = "altText";
        const msg = await $cca4aceb320d03d3$var$AltText._l10nPromise.get("pdfjs-editor-alt-text-button-label");
        altText.textContent = msg;
        altText.setAttribute("aria-label", msg);
        altText.tabIndex = "0";
        const signal = this.#editor._uiManager._signal;
        altText.addEventListener("contextmenu", $cca4aceb320d03d3$var$noContextMenu, {
            signal: signal
        });
        altText.addEventListener("pointerdown", (event)=>event.stopPropagation(), {
            signal: signal
        });
        const onClick = (event)=>{
            event.preventDefault();
            this.#editor._uiManager.editAltText(this.#editor);
        };
        altText.addEventListener("click", onClick, {
            capture: true,
            signal: signal
        });
        altText.addEventListener("keydown", (event)=>{
            if (event.target === altText && event.key === "Enter") {
                this.#altTextWasFromKeyBoard = true;
                onClick(event);
            }
        }, {
            signal: signal
        });
        await this.#setState();
        return altText;
    }
    finish() {
        if (!this.#altTextButton) return;
        this.#altTextButton.focus({
            focusVisible: this.#altTextWasFromKeyBoard
        });
        this.#altTextWasFromKeyBoard = false;
    }
    isEmpty() {
        return !this.#altText && !this.#altTextDecorative;
    }
    get data() {
        return {
            altText: this.#altText,
            decorative: this.#altTextDecorative
        };
    }
    set data({ altText: altText, decorative: decorative }) {
        if (this.#altText === altText && this.#altTextDecorative === decorative) return;
        this.#altText = altText;
        this.#altTextDecorative = decorative;
        this.#setState();
    }
    toggle(enabled = false) {
        if (!this.#altTextButton) return;
        if (!enabled && this.#altTextTooltipTimeout) {
            clearTimeout(this.#altTextTooltipTimeout);
            this.#altTextTooltipTimeout = null;
        }
        this.#altTextButton.disabled = !enabled;
    }
    destroy() {
        this.#altTextButton?.remove();
        this.#altTextButton = null;
        this.#altTextTooltip = null;
    }
    async #setState() {
        const button = this.#altTextButton;
        if (!button) return;
        if (!this.#altText && !this.#altTextDecorative) {
            button.classList.remove("done");
            this.#altTextTooltip?.remove();
            return;
        }
        button.classList.add("done");
        $cca4aceb320d03d3$var$AltText._l10nPromise.get("pdfjs-editor-alt-text-edit-button-label").then((msg)=>{
            button.setAttribute("aria-label", msg);
        });
        let tooltip = this.#altTextTooltip;
        if (!tooltip) {
            this.#altTextTooltip = tooltip = document.createElement("span");
            tooltip.className = "tooltip";
            tooltip.setAttribute("role", "tooltip");
            const id = tooltip.id = `alt-text-tooltip-${this.#editor.id}`;
            button.setAttribute("aria-describedby", id);
            const DELAY_TO_SHOW_TOOLTIP = 100;
            const signal = this.#editor._uiManager._signal;
            signal.addEventListener("abort", ()=>{
                clearTimeout(this.#altTextTooltipTimeout);
                this.#altTextTooltipTimeout = null;
            }, {
                once: true
            });
            button.addEventListener("mouseenter", ()=>{
                this.#altTextTooltipTimeout = setTimeout(()=>{
                    this.#altTextTooltipTimeout = null;
                    this.#altTextTooltip.classList.add("show");
                    this.#editor._reportTelemetry({
                        action: "alt_text_tooltip"
                    });
                }, DELAY_TO_SHOW_TOOLTIP);
            }, {
                signal: signal
            });
            button.addEventListener("mouseleave", ()=>{
                if (this.#altTextTooltipTimeout) {
                    clearTimeout(this.#altTextTooltipTimeout);
                    this.#altTextTooltipTimeout = null;
                }
                this.#altTextTooltip?.classList.remove("show");
            }, {
                signal: signal
            });
        }
        tooltip.innerText = this.#altTextDecorative ? await $cca4aceb320d03d3$var$AltText._l10nPromise.get("pdfjs-editor-alt-text-decorative-tooltip") : this.#altText;
        if (!tooltip.parentNode) button.append(tooltip);
        const element = this.#editor.getImageForAltText();
        element?.setAttribute("aria-describedby", tooltip.id);
    }
}
class $cca4aceb320d03d3$var$AnnotationEditor {
    #accessibilityData = null;
    #allResizerDivs = null;
    #altText = null;
    #disabled = false;
    #keepAspectRatio = false;
    #resizersDiv = null;
    #savedDimensions = null;
    #boundFocusin = this.focusin.bind(this);
    #boundFocusout = this.focusout.bind(this);
    #editToolbar = null;
    #focusedResizerName = "";
    #hasBeenClicked = false;
    #initialPosition = null;
    #isEditing = false;
    #isInEditMode = false;
    #isResizerEnabledForKeyboard = false;
    #moveInDOMTimeout = null;
    #prevDragX = 0;
    #prevDragY = 0;
    #telemetryTimeouts = null;
    _initialOptions = Object.create(null);
    _isVisible = true;
    _uiManager = null;
    _focusEventsAllowed = true;
    _l10nPromise = null;
    #isDraggable = false;
    #zIndex = $cca4aceb320d03d3$var$AnnotationEditor._zIndex++;
    static _borderLineWidth = -1;
    static _colorManager = new $cca4aceb320d03d3$var$ColorManager();
    static _zIndex = 1;
    static _telemetryTimeout = 1000;
    static get _resizerKeyboardManager() {
        const resize = $cca4aceb320d03d3$var$AnnotationEditor.prototype._resizeWithKeyboard;
        const small = $cca4aceb320d03d3$var$AnnotationEditorUIManager.TRANSLATE_SMALL;
        const big = $cca4aceb320d03d3$var$AnnotationEditorUIManager.TRANSLATE_BIG;
        return $cca4aceb320d03d3$var$shadow(this, "_resizerKeyboardManager", new $cca4aceb320d03d3$var$KeyboardManager([
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                resize,
                {
                    args: [
                        -small,
                        0
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                resize,
                {
                    args: [
                        -big,
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                resize,
                {
                    args: [
                        small,
                        0
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                resize,
                {
                    args: [
                        big,
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                resize,
                {
                    args: [
                        0,
                        -small
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                resize,
                {
                    args: [
                        0,
                        -big
                    ]
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                resize,
                {
                    args: [
                        0,
                        small
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                resize,
                {
                    args: [
                        0,
                        big
                    ]
                }
            ],
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                $cca4aceb320d03d3$var$AnnotationEditor.prototype._stopResizingWithKeyboard
            ]
        ]));
    }
    constructor(parameters){
        if (this.constructor === $cca4aceb320d03d3$var$AnnotationEditor) $cca4aceb320d03d3$var$unreachable("Cannot initialize AnnotationEditor.");
        this.parent = parameters.parent;
        this.id = parameters.id;
        this.width = this.height = null;
        this.pageIndex = parameters.parent.pageIndex;
        this.name = parameters.name;
        this.div = null;
        this._uiManager = parameters.uiManager;
        this.annotationElementId = null;
        this._willKeepAspectRatio = false;
        this._initialOptions.isCentered = parameters.isCentered;
        this._structTreeParentId = null;
        const { rotation: rotation, rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } = this.parent.viewport;
        this.rotation = rotation;
        this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
        this.pageDimensions = [
            pageWidth,
            pageHeight
        ];
        this.pageTranslation = [
            pageX,
            pageY
        ];
        const [width, height] = this.parentDimensions;
        this.x = parameters.x / width;
        this.y = parameters.y / height;
        this.isAttachedToDOM = false;
        this.deleted = false;
    }
    get editorType() {
        return Object.getPrototypeOf(this).constructor._type;
    }
    static get _defaultLineColor() {
        return $cca4aceb320d03d3$var$shadow(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
    }
    static deleteAnnotationElement(editor) {
        const fakeEditor = new $cca4aceb320d03d3$var$FakeEditor({
            id: editor.parent.getNextId(),
            parent: editor.parent,
            uiManager: editor._uiManager
        });
        fakeEditor.annotationElementId = editor.annotationElementId;
        fakeEditor.deleted = true;
        fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
    }
    static initialize(l10n, _uiManager, options) {
        $cca4aceb320d03d3$var$AnnotationEditor._l10nPromise ||= new Map([
            "pdfjs-editor-alt-text-button-label",
            "pdfjs-editor-alt-text-edit-button-label",
            "pdfjs-editor-alt-text-decorative-tooltip",
            "pdfjs-editor-resizer-label-topLeft",
            "pdfjs-editor-resizer-label-topMiddle",
            "pdfjs-editor-resizer-label-topRight",
            "pdfjs-editor-resizer-label-middleRight",
            "pdfjs-editor-resizer-label-bottomRight",
            "pdfjs-editor-resizer-label-bottomMiddle",
            "pdfjs-editor-resizer-label-bottomLeft",
            "pdfjs-editor-resizer-label-middleLeft"
        ].map((str)=>[
                str,
                l10n.get(str.replaceAll(/([A-Z])/g, (c)=>`-${c.toLowerCase()}`))
            ]));
        if (options?.strings) for (const str of options.strings)$cca4aceb320d03d3$var$AnnotationEditor._l10nPromise.set(str, l10n.get(str));
        if ($cca4aceb320d03d3$var$AnnotationEditor._borderLineWidth !== -1) return;
        const style = getComputedStyle(document.documentElement);
        $cca4aceb320d03d3$var$AnnotationEditor._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
    }
    static updateDefaultParams(_type, _value) {}
    static get defaultPropertiesToUpdate() {
        return [];
    }
    static isHandlingMimeForPasting(mime) {
        return false;
    }
    static paste(item, parent) {
        $cca4aceb320d03d3$var$unreachable("Not implemented");
    }
    get propertiesToUpdate() {
        return [];
    }
    get _isDraggable() {
        return this.#isDraggable;
    }
    set _isDraggable(value) {
        this.#isDraggable = value;
        this.div?.classList.toggle("draggable", value);
    }
    get isEnterHandled() {
        return true;
    }
    center() {
        const [pageWidth, pageHeight] = this.pageDimensions;
        switch(this.parentRotation){
            case 90:
                this.x -= this.height * pageHeight / (pageWidth * 2);
                this.y += this.width * pageWidth / (pageHeight * 2);
                break;
            case 180:
                this.x += this.width / 2;
                this.y += this.height / 2;
                break;
            case 270:
                this.x += this.height * pageHeight / (pageWidth * 2);
                this.y -= this.width * pageWidth / (pageHeight * 2);
                break;
            default:
                this.x -= this.width / 2;
                this.y -= this.height / 2;
                break;
        }
        this.fixAndSetPosition();
    }
    addCommands(params) {
        this._uiManager.addCommands(params);
    }
    get currentLayer() {
        return this._uiManager.currentLayer;
    }
    setInBackground() {
        this.div.style.zIndex = 0;
    }
    setInForeground() {
        this.div.style.zIndex = this.#zIndex;
    }
    setParent(parent) {
        if (parent !== null) {
            this.pageIndex = parent.pageIndex;
            this.pageDimensions = parent.pageDimensions;
        } else this.#stopResizing();
        this.parent = parent;
    }
    focusin(event) {
        if (!this._focusEventsAllowed) return;
        if (!this.#hasBeenClicked) this.parent.setSelected(this);
        else this.#hasBeenClicked = false;
    }
    focusout(event) {
        if (!this._focusEventsAllowed) return;
        if (!this.isAttachedToDOM) return;
        const target = event.relatedTarget;
        if (target?.closest(`#${this.id}`)) return;
        event.preventDefault();
        if (!this.parent?.isMultipleSelection) this.commitOrRemove();
    }
    commitOrRemove() {
        if (this.isEmpty()) this.remove();
        else this.commit();
    }
    commit() {
        this.addToAnnotationStorage();
    }
    addToAnnotationStorage() {
        this._uiManager.addToAnnotationStorage(this);
    }
    setAt(x, y, tx, ty) {
        const [width, height] = this.parentDimensions;
        [tx, ty] = this.screenToPageTranslation(tx, ty);
        this.x = (x + tx) / width;
        this.y = (y + ty) / height;
        this.fixAndSetPosition();
    }
    #translate([width, height], x, y) {
        [x, y] = this.screenToPageTranslation(x, y);
        this.x += x / width;
        this.y += y / height;
        this.fixAndSetPosition();
    }
    translate(x, y) {
        this.#translate(this.parentDimensions, x, y);
    }
    translateInPage(x, y) {
        this.#initialPosition ||= [
            this.x,
            this.y
        ];
        this.#translate(this.pageDimensions, x, y);
        this.div.scrollIntoView({
            block: "nearest"
        });
    }
    drag(tx, ty) {
        this.#initialPosition ||= [
            this.x,
            this.y
        ];
        const [parentWidth, parentHeight] = this.parentDimensions;
        this.x += tx / parentWidth;
        this.y += ty / parentHeight;
        if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
            const { x: x, y: y } = this.div.getBoundingClientRect();
            if (this.parent.findNewParent(this, x, y)) {
                this.x -= Math.floor(this.x);
                this.y -= Math.floor(this.y);
            }
        }
        let { x: x, y: y } = this;
        const [bx, by] = this.getBaseTranslation();
        x += bx;
        y += by;
        this.div.style.left = `${(100 * x).toFixed(2)}%`;
        this.div.style.top = `${(100 * y).toFixed(2)}%`;
        this.div.scrollIntoView({
            block: "nearest"
        });
    }
    get _hasBeenMoved() {
        return !!this.#initialPosition && (this.#initialPosition[0] !== this.x || this.#initialPosition[1] !== this.y);
    }
    getBaseTranslation() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const { _borderLineWidth: _borderLineWidth } = $cca4aceb320d03d3$var$AnnotationEditor;
        const x = _borderLineWidth / parentWidth;
        const y = _borderLineWidth / parentHeight;
        switch(this.rotation){
            case 90:
                return [
                    -x,
                    y
                ];
            case 180:
                return [
                    x,
                    y
                ];
            case 270:
                return [
                    x,
                    -y
                ];
            default:
                return [
                    -x,
                    -y
                ];
        }
    }
    get _mustFixPosition() {
        return true;
    }
    fixAndSetPosition(rotation = this.rotation) {
        const [pageWidth, pageHeight] = this.pageDimensions;
        let { x: x, y: y, width: width, height: height } = this;
        width *= pageWidth;
        height *= pageHeight;
        x *= pageWidth;
        y *= pageHeight;
        if (this._mustFixPosition) switch(rotation){
            case 0:
                x = Math.max(0, Math.min(pageWidth - width, x));
                y = Math.max(0, Math.min(pageHeight - height, y));
                break;
            case 90:
                x = Math.max(0, Math.min(pageWidth - height, x));
                y = Math.min(pageHeight, Math.max(width, y));
                break;
            case 180:
                x = Math.min(pageWidth, Math.max(width, x));
                y = Math.min(pageHeight, Math.max(height, y));
                break;
            case 270:
                x = Math.min(pageWidth, Math.max(height, x));
                y = Math.max(0, Math.min(pageHeight - width, y));
                break;
        }
        this.x = x /= pageWidth;
        this.y = y /= pageHeight;
        const [bx, by] = this.getBaseTranslation();
        x += bx;
        y += by;
        const { style: style } = this.div;
        style.left = `${(100 * x).toFixed(2)}%`;
        style.top = `${(100 * y).toFixed(2)}%`;
        this.moveInDOM();
    }
    static #rotatePoint(x, y, angle) {
        switch(angle){
            case 90:
                return [
                    y,
                    -x
                ];
            case 180:
                return [
                    -x,
                    -y
                ];
            case 270:
                return [
                    -y,
                    x
                ];
            default:
                return [
                    x,
                    y
                ];
        }
    }
    screenToPageTranslation(x, y) {
        return $cca4aceb320d03d3$var$AnnotationEditor.#rotatePoint(x, y, this.parentRotation);
    }
    pageTranslationToScreen(x, y) {
        return $cca4aceb320d03d3$var$AnnotationEditor.#rotatePoint(x, y, 360 - this.parentRotation);
    }
    #getRotationMatrix(rotation) {
        switch(rotation){
            case 90:
                {
                    const [pageWidth, pageHeight] = this.pageDimensions;
                    return [
                        0,
                        -pageWidth / pageHeight,
                        pageHeight / pageWidth,
                        0
                    ];
                }
            case 180:
                return [
                    -1,
                    0,
                    0,
                    -1
                ];
            case 270:
                {
                    const [pageWidth, pageHeight] = this.pageDimensions;
                    return [
                        0,
                        pageWidth / pageHeight,
                        -pageHeight / pageWidth,
                        0
                    ];
                }
            default:
                return [
                    1,
                    0,
                    0,
                    1
                ];
        }
    }
    get parentScale() {
        return this._uiManager.viewParameters.realScale;
    }
    get parentRotation() {
        return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
    }
    get parentDimensions() {
        const { parentScale: parentScale, pageDimensions: [pageWidth, pageHeight] } = this;
        const scaledWidth = pageWidth * parentScale;
        const scaledHeight = pageHeight * parentScale;
        return $cca4aceb320d03d3$var$util_FeatureTest.isCSSRoundSupported ? [
            Math.round(scaledWidth),
            Math.round(scaledHeight)
        ] : [
            scaledWidth,
            scaledHeight
        ];
    }
    setDims(width, height) {
        const [parentWidth, parentHeight] = this.parentDimensions;
        this.div.style.width = `${(100 * width / parentWidth).toFixed(2)}%`;
        if (!this.#keepAspectRatio) this.div.style.height = `${(100 * height / parentHeight).toFixed(2)}%`;
    }
    fixDims() {
        const { style: style } = this.div;
        const { height: height, width: width } = style;
        const widthPercent = width.endsWith("%");
        const heightPercent = !this.#keepAspectRatio && height.endsWith("%");
        if (widthPercent && heightPercent) return;
        const [parentWidth, parentHeight] = this.parentDimensions;
        if (!widthPercent) style.width = `${(100 * parseFloat(width) / parentWidth).toFixed(2)}%`;
        if (!this.#keepAspectRatio && !heightPercent) style.height = `${(100 * parseFloat(height) / parentHeight).toFixed(2)}%`;
    }
    getInitialTranslation() {
        return [
            0,
            0
        ];
    }
    #createResizers() {
        if (this.#resizersDiv) return;
        this.#resizersDiv = document.createElement("div");
        this.#resizersDiv.classList.add("resizers");
        const classes = this._willKeepAspectRatio ? [
            "topLeft",
            "topRight",
            "bottomRight",
            "bottomLeft"
        ] : [
            "topLeft",
            "topMiddle",
            "topRight",
            "middleRight",
            "bottomRight",
            "bottomMiddle",
            "bottomLeft",
            "middleLeft"
        ];
        const signal = this._uiManager._signal;
        for (const name of classes){
            const div = document.createElement("div");
            this.#resizersDiv.append(div);
            div.classList.add("resizer", name);
            div.setAttribute("data-resizer-name", name);
            div.addEventListener("pointerdown", this.#resizerPointerdown.bind(this, name), {
                signal: signal
            });
            div.addEventListener("contextmenu", $cca4aceb320d03d3$var$noContextMenu, {
                signal: signal
            });
            div.tabIndex = -1;
        }
        this.div.prepend(this.#resizersDiv);
    }
    #resizerPointerdown(name, event) {
        event.preventDefault();
        const { isMac: isMac } = $cca4aceb320d03d3$var$util_FeatureTest.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        this.#altText?.toggle(false);
        const boundResizerPointermove = this.#resizerPointermove.bind(this, name);
        const savedDraggable = this._isDraggable;
        this._isDraggable = false;
        const signal = this._uiManager._signal;
        const pointerMoveOptions = {
            passive: true,
            capture: true,
            signal: signal
        };
        this.parent.togglePointerEvents(false);
        window.addEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
        window.addEventListener("contextmenu", $cca4aceb320d03d3$var$noContextMenu, {
            signal: signal
        });
        const savedX = this.x;
        const savedY = this.y;
        const savedWidth = this.width;
        const savedHeight = this.height;
        const savedParentCursor = this.parent.div.style.cursor;
        const savedCursor = this.div.style.cursor;
        this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
        const pointerUpCallback = ()=>{
            this.parent.togglePointerEvents(true);
            this.#altText?.toggle(true);
            this._isDraggable = savedDraggable;
            window.removeEventListener("pointerup", pointerUpCallback);
            window.removeEventListener("blur", pointerUpCallback);
            window.removeEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
            window.removeEventListener("contextmenu", $cca4aceb320d03d3$var$noContextMenu);
            this.parent.div.style.cursor = savedParentCursor;
            this.div.style.cursor = savedCursor;
            this.#addResizeToUndoStack(savedX, savedY, savedWidth, savedHeight);
        };
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
    }
    #addResizeToUndoStack(savedX, savedY, savedWidth, savedHeight) {
        const newX = this.x;
        const newY = this.y;
        const newWidth = this.width;
        const newHeight = this.height;
        if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) return;
        this.addCommands({
            cmd: ()=>{
                this.width = newWidth;
                this.height = newHeight;
                this.x = newX;
                this.y = newY;
                const [parentWidth, parentHeight] = this.parentDimensions;
                this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                this.fixAndSetPosition();
            },
            undo: ()=>{
                this.width = savedWidth;
                this.height = savedHeight;
                this.x = savedX;
                this.y = savedY;
                const [parentWidth, parentHeight] = this.parentDimensions;
                this.setDims(parentWidth * savedWidth, parentHeight * savedHeight);
                this.fixAndSetPosition();
            },
            mustExec: true
        });
    }
    #resizerPointermove(name, event) {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const savedX = this.x;
        const savedY = this.y;
        const savedWidth = this.width;
        const savedHeight = this.height;
        const minWidth = $cca4aceb320d03d3$var$AnnotationEditor.MIN_SIZE / parentWidth;
        const minHeight = $cca4aceb320d03d3$var$AnnotationEditor.MIN_SIZE / parentHeight;
        const round = (x)=>Math.round(x * 10000) / 10000;
        const rotationMatrix = this.#getRotationMatrix(this.rotation);
        const transf = (x, y)=>[
                rotationMatrix[0] * x + rotationMatrix[2] * y,
                rotationMatrix[1] * x + rotationMatrix[3] * y
            ];
        const invRotationMatrix = this.#getRotationMatrix(360 - this.rotation);
        const invTransf = (x, y)=>[
                invRotationMatrix[0] * x + invRotationMatrix[2] * y,
                invRotationMatrix[1] * x + invRotationMatrix[3] * y
            ];
        let getPoint;
        let getOpposite;
        let isDiagonal = false;
        let isHorizontal = false;
        switch(name){
            case "topLeft":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        0,
                        0
                    ];
                getOpposite = (w, h)=>[
                        w,
                        h
                    ];
                break;
            case "topMiddle":
                getPoint = (w, h)=>[
                        w / 2,
                        0
                    ];
                getOpposite = (w, h)=>[
                        w / 2,
                        h
                    ];
                break;
            case "topRight":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        w,
                        0
                    ];
                getOpposite = (w, h)=>[
                        0,
                        h
                    ];
                break;
            case "middleRight":
                isHorizontal = true;
                getPoint = (w, h)=>[
                        w,
                        h / 2
                    ];
                getOpposite = (w, h)=>[
                        0,
                        h / 2
                    ];
                break;
            case "bottomRight":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        w,
                        h
                    ];
                getOpposite = (w, h)=>[
                        0,
                        0
                    ];
                break;
            case "bottomMiddle":
                getPoint = (w, h)=>[
                        w / 2,
                        h
                    ];
                getOpposite = (w, h)=>[
                        w / 2,
                        0
                    ];
                break;
            case "bottomLeft":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        0,
                        h
                    ];
                getOpposite = (w, h)=>[
                        w,
                        0
                    ];
                break;
            case "middleLeft":
                isHorizontal = true;
                getPoint = (w, h)=>[
                        0,
                        h / 2
                    ];
                getOpposite = (w, h)=>[
                        w,
                        h / 2
                    ];
                break;
        }
        const point = getPoint(savedWidth, savedHeight);
        const oppositePoint = getOpposite(savedWidth, savedHeight);
        let transfOppositePoint = transf(...oppositePoint);
        const oppositeX = round(savedX + transfOppositePoint[0]);
        const oppositeY = round(savedY + transfOppositePoint[1]);
        let ratioX = 1;
        let ratioY = 1;
        let [deltaX, deltaY] = this.screenToPageTranslation(event.movementX, event.movementY);
        [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
        if (isDiagonal) {
            const oldDiag = Math.hypot(savedWidth, savedHeight);
            ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
        } else if (isHorizontal) ratioX = Math.max(minWidth, Math.min(1, Math.abs(oppositePoint[0] - point[0] - deltaX))) / savedWidth;
        else ratioY = Math.max(minHeight, Math.min(1, Math.abs(oppositePoint[1] - point[1] - deltaY))) / savedHeight;
        const newWidth = round(savedWidth * ratioX);
        const newHeight = round(savedHeight * ratioY);
        transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
        const newX = oppositeX - transfOppositePoint[0];
        const newY = oppositeY - transfOppositePoint[1];
        this.width = newWidth;
        this.height = newHeight;
        this.x = newX;
        this.y = newY;
        this.setDims(parentWidth * newWidth, parentHeight * newHeight);
        this.fixAndSetPosition();
    }
    altTextFinish() {
        this.#altText?.finish();
    }
    async addEditToolbar() {
        if (this.#editToolbar || this.#isInEditMode) return this.#editToolbar;
        this.#editToolbar = new $cca4aceb320d03d3$var$EditorToolbar(this);
        this.div.append(this.#editToolbar.render());
        if (this.#altText) this.#editToolbar.addAltTextButton(await this.#altText.render());
        return this.#editToolbar;
    }
    removeEditToolbar() {
        if (!this.#editToolbar) return;
        this.#editToolbar.remove();
        this.#editToolbar = null;
        this.#altText?.destroy();
    }
    getClientDimensions() {
        return this.div.getBoundingClientRect();
    }
    async addAltTextButton() {
        if (this.#altText) return;
        $cca4aceb320d03d3$var$AltText.initialize($cca4aceb320d03d3$var$AnnotationEditor._l10nPromise);
        this.#altText = new $cca4aceb320d03d3$var$AltText(this);
        if (this.#accessibilityData) {
            this.#altText.data = this.#accessibilityData;
            this.#accessibilityData = null;
        }
        await this.addEditToolbar();
    }
    get altTextData() {
        return this.#altText?.data;
    }
    set altTextData(data) {
        if (!this.#altText) return;
        this.#altText.data = data;
    }
    hasAltText() {
        return !this.#altText?.isEmpty();
    }
    render() {
        this.div = document.createElement("div");
        this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
        this.div.className = this.name;
        this.div.setAttribute("id", this.id);
        this.div.tabIndex = this.#disabled ? -1 : 0;
        if (!this._isVisible) this.div.classList.add("hidden");
        this.setInForeground();
        const signal = this._uiManager._signal;
        this.div.addEventListener("focusin", this.#boundFocusin, {
            signal: signal
        });
        this.div.addEventListener("focusout", this.#boundFocusout, {
            signal: signal
        });
        const [parentWidth, parentHeight] = this.parentDimensions;
        if (this.parentRotation % 180 !== 0) {
            this.div.style.maxWidth = `${(100 * parentHeight / parentWidth).toFixed(2)}%`;
            this.div.style.maxHeight = `${(100 * parentWidth / parentHeight).toFixed(2)}%`;
        }
        const [tx, ty] = this.getInitialTranslation();
        this.translate(tx, ty);
        $cca4aceb320d03d3$var$bindEvents(this, this.div, [
            "pointerdown"
        ]);
        return this.div;
    }
    pointerdown(event) {
        const { isMac: isMac } = $cca4aceb320d03d3$var$util_FeatureTest.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) {
            event.preventDefault();
            return;
        }
        this.#hasBeenClicked = true;
        if (this._isDraggable) {
            this.#setUpDragSession(event);
            return;
        }
        this.#selectOnPointerEvent(event);
    }
    #selectOnPointerEvent(event) {
        const { isMac: isMac } = $cca4aceb320d03d3$var$util_FeatureTest.platform;
        if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) this.parent.toggleSelected(this);
        else this.parent.setSelected(this);
    }
    #setUpDragSession(event) {
        const isSelected = this._uiManager.isSelected(this);
        this._uiManager.setUpDragSession();
        let pointerMoveOptions, pointerMoveCallback;
        const signal = this._uiManager._signal;
        if (isSelected) {
            this.div.classList.add("moving");
            pointerMoveOptions = {
                passive: true,
                capture: true,
                signal: signal
            };
            this.#prevDragX = event.clientX;
            this.#prevDragY = event.clientY;
            pointerMoveCallback = (e)=>{
                const { clientX: x, clientY: y } = e;
                const [tx, ty] = this.screenToPageTranslation(x - this.#prevDragX, y - this.#prevDragY);
                this.#prevDragX = x;
                this.#prevDragY = y;
                this._uiManager.dragSelectedEditors(tx, ty);
            };
            window.addEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
        }
        const pointerUpCallback = ()=>{
            window.removeEventListener("pointerup", pointerUpCallback);
            window.removeEventListener("blur", pointerUpCallback);
            if (isSelected) {
                this.div.classList.remove("moving");
                window.removeEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
            }
            this.#hasBeenClicked = false;
            if (!this._uiManager.endDragSession()) this.#selectOnPointerEvent(event);
        };
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
    }
    moveInDOM() {
        if (this.#moveInDOMTimeout) clearTimeout(this.#moveInDOMTimeout);
        this.#moveInDOMTimeout = setTimeout(()=>{
            this.#moveInDOMTimeout = null;
            this.parent?.moveEditorInDOM(this);
        }, 0);
    }
    _setParentAndPosition(parent, x, y) {
        parent.changeParent(this);
        this.x = x;
        this.y = y;
        this.fixAndSetPosition();
    }
    getRect(tx, ty, rotation = this.rotation) {
        const scale = this.parentScale;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const [pageX, pageY] = this.pageTranslation;
        const shiftX = tx / scale;
        const shiftY = ty / scale;
        const x = this.x * pageWidth;
        const y = this.y * pageHeight;
        const width = this.width * pageWidth;
        const height = this.height * pageHeight;
        switch(rotation){
            case 0:
                return [
                    x + shiftX + pageX,
                    pageHeight - y - shiftY - height + pageY,
                    x + shiftX + width + pageX,
                    pageHeight - y - shiftY + pageY
                ];
            case 90:
                return [
                    x + shiftY + pageX,
                    pageHeight - y + shiftX + pageY,
                    x + shiftY + height + pageX,
                    pageHeight - y + shiftX + width + pageY
                ];
            case 180:
                return [
                    x - shiftX - width + pageX,
                    pageHeight - y + shiftY + pageY,
                    x - shiftX + pageX,
                    pageHeight - y + shiftY + height + pageY
                ];
            case 270:
                return [
                    x - shiftY - height + pageX,
                    pageHeight - y - shiftX - width + pageY,
                    x - shiftY + pageX,
                    pageHeight - y - shiftX + pageY
                ];
            default:
                throw new Error("Invalid rotation");
        }
    }
    getRectInCurrentCoords(rect, pageHeight) {
        const [x1, y1, x2, y2] = rect;
        const width = x2 - x1;
        const height = y2 - y1;
        switch(this.rotation){
            case 0:
                return [
                    x1,
                    pageHeight - y2,
                    width,
                    height
                ];
            case 90:
                return [
                    x1,
                    pageHeight - y1,
                    height,
                    width
                ];
            case 180:
                return [
                    x2,
                    pageHeight - y1,
                    width,
                    height
                ];
            case 270:
                return [
                    x2,
                    pageHeight - y2,
                    height,
                    width
                ];
            default:
                throw new Error("Invalid rotation");
        }
    }
    onceAdded() {}
    isEmpty() {
        return false;
    }
    enableEditMode() {
        this.#isInEditMode = true;
    }
    disableEditMode() {
        this.#isInEditMode = false;
    }
    isInEditMode() {
        return this.#isInEditMode;
    }
    shouldGetKeyboardEvents() {
        return this.#isResizerEnabledForKeyboard;
    }
    needsToBeRebuilt() {
        return this.div && !this.isAttachedToDOM;
    }
    rebuild() {
        const signal = this._uiManager._signal;
        this.div?.addEventListener("focusin", this.#boundFocusin, {
            signal: signal
        });
        this.div?.addEventListener("focusout", this.#boundFocusout, {
            signal: signal
        });
    }
    rotate(_angle) {}
    serialize(isForCopying = false, context = null) {
        $cca4aceb320d03d3$var$unreachable("An editor must be serializable");
    }
    static deserialize(data, parent, uiManager) {
        const editor = new this.prototype.constructor({
            parent: parent,
            id: parent.getNextId(),
            uiManager: uiManager
        });
        editor.rotation = data.rotation;
        editor.#accessibilityData = data.accessibilityData;
        const [pageWidth, pageHeight] = editor.pageDimensions;
        const [x, y, width, height] = editor.getRectInCurrentCoords(data.rect, pageHeight);
        editor.x = x / pageWidth;
        editor.y = y / pageHeight;
        editor.width = width / pageWidth;
        editor.height = height / pageHeight;
        return editor;
    }
    get hasBeenModified() {
        return !!this.annotationElementId && (this.deleted || this.serialize() !== null);
    }
    remove() {
        this.div.removeEventListener("focusin", this.#boundFocusin);
        this.div.removeEventListener("focusout", this.#boundFocusout);
        if (!this.isEmpty()) this.commit();
        if (this.parent) this.parent.remove(this);
        else this._uiManager.removeEditor(this);
        if (this.#moveInDOMTimeout) {
            clearTimeout(this.#moveInDOMTimeout);
            this.#moveInDOMTimeout = null;
        }
        this.#stopResizing();
        this.removeEditToolbar();
        if (this.#telemetryTimeouts) {
            for (const timeout of this.#telemetryTimeouts.values())clearTimeout(timeout);
            this.#telemetryTimeouts = null;
        }
        this.parent = null;
    }
    get isResizable() {
        return false;
    }
    makeResizable() {
        if (this.isResizable) {
            this.#createResizers();
            this.#resizersDiv.classList.remove("hidden");
            $cca4aceb320d03d3$var$bindEvents(this, this.div, [
                "keydown"
            ]);
        }
    }
    get toolbarPosition() {
        return null;
    }
    keydown(event) {
        if (!this.isResizable || event.target !== this.div || event.key !== "Enter") return;
        this._uiManager.setSelected(this);
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        const children = this.#resizersDiv.children;
        if (!this.#allResizerDivs) {
            this.#allResizerDivs = Array.from(children);
            const boundResizerKeydown = this.#resizerKeydown.bind(this);
            const boundResizerBlur = this.#resizerBlur.bind(this);
            const signal = this._uiManager._signal;
            for (const div of this.#allResizerDivs){
                const name = div.getAttribute("data-resizer-name");
                div.setAttribute("role", "spinbutton");
                div.addEventListener("keydown", boundResizerKeydown, {
                    signal: signal
                });
                div.addEventListener("blur", boundResizerBlur, {
                    signal: signal
                });
                div.addEventListener("focus", this.#resizerFocus.bind(this, name), {
                    signal: signal
                });
                $cca4aceb320d03d3$var$AnnotationEditor._l10nPromise.get(`pdfjs-editor-resizer-label-${name}`).then((msg)=>div.setAttribute("aria-label", msg));
            }
        }
        const first = this.#allResizerDivs[0];
        let firstPosition = 0;
        for (const div of children){
            if (div === first) break;
            firstPosition++;
        }
        const nextFirstPosition = (360 - this.rotation + this.parentRotation) % 360 / 90 * (this.#allResizerDivs.length / 4);
        if (nextFirstPosition !== firstPosition) {
            if (nextFirstPosition < firstPosition) for(let i = 0; i < firstPosition - nextFirstPosition; i++)this.#resizersDiv.append(this.#resizersDiv.firstChild);
            else if (nextFirstPosition > firstPosition) for(let i = 0; i < nextFirstPosition - firstPosition; i++)this.#resizersDiv.firstChild.before(this.#resizersDiv.lastChild);
            let i = 0;
            for (const child of children){
                const div = this.#allResizerDivs[i++];
                const name = div.getAttribute("data-resizer-name");
                $cca4aceb320d03d3$var$AnnotationEditor._l10nPromise.get(`pdfjs-editor-resizer-label-${name}`).then((msg)=>child.setAttribute("aria-label", msg));
            }
        }
        this.#setResizerTabIndex(0);
        this.#isResizerEnabledForKeyboard = true;
        this.#resizersDiv.firstChild.focus({
            focusVisible: true
        });
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    #resizerKeydown(event) {
        $cca4aceb320d03d3$var$AnnotationEditor._resizerKeyboardManager.exec(this, event);
    }
    #resizerBlur(event) {
        if (this.#isResizerEnabledForKeyboard && event.relatedTarget?.parentNode !== this.#resizersDiv) this.#stopResizing();
    }
    #resizerFocus(name) {
        this.#focusedResizerName = this.#isResizerEnabledForKeyboard ? name : "";
    }
    #setResizerTabIndex(value) {
        if (!this.#allResizerDivs) return;
        for (const div of this.#allResizerDivs)div.tabIndex = value;
    }
    _resizeWithKeyboard(x, y) {
        if (!this.#isResizerEnabledForKeyboard) return;
        this.#resizerPointermove(this.#focusedResizerName, {
            movementX: x,
            movementY: y
        });
    }
    #stopResizing() {
        this.#isResizerEnabledForKeyboard = false;
        this.#setResizerTabIndex(-1);
        if (this.#savedDimensions) {
            const { savedX: savedX, savedY: savedY, savedWidth: savedWidth, savedHeight: savedHeight } = this.#savedDimensions;
            this.#addResizeToUndoStack(savedX, savedY, savedWidth, savedHeight);
            this.#savedDimensions = null;
        }
    }
    _stopResizingWithKeyboard() {
        this.#stopResizing();
        this.div.focus();
    }
    select() {
        this.makeResizable();
        this.div?.classList.add("selectedEditor");
        if (!this.#editToolbar) {
            this.addEditToolbar().then(()=>{
                if (this.div?.classList.contains("selectedEditor")) this.#editToolbar?.show();
            });
            return;
        }
        this.#editToolbar?.show();
    }
    unselect() {
        this.#resizersDiv?.classList.add("hidden");
        this.div?.classList.remove("selectedEditor");
        if (this.div?.contains(document.activeElement)) this._uiManager.currentLayer.div.focus({
            preventScroll: true
        });
        this.#editToolbar?.hide();
    }
    updateParams(type, value) {}
    disableEditing() {}
    enableEditing() {}
    enterInEditMode() {}
    getImageForAltText() {
        return null;
    }
    get contentDiv() {
        return this.div;
    }
    get isEditing() {
        return this.#isEditing;
    }
    set isEditing(value) {
        this.#isEditing = value;
        if (!this.parent) return;
        if (value) {
            this.parent.setSelected(this);
            this.parent.setActiveEditor(this);
        } else this.parent.setActiveEditor(null);
    }
    setAspectRatio(width, height) {
        this.#keepAspectRatio = true;
        const aspectRatio = width / height;
        const { style: style } = this.div;
        style.aspectRatio = aspectRatio;
        style.height = "auto";
    }
    static get MIN_SIZE() {
        return 16;
    }
    static canCreateNewEmptyEditor() {
        return true;
    }
    get telemetryInitialData() {
        return {
            action: "added"
        };
    }
    get telemetryFinalData() {
        return null;
    }
    _reportTelemetry(data, mustWait = false) {
        if (mustWait) {
            this.#telemetryTimeouts ||= new Map();
            const { action: action } = data;
            let timeout = this.#telemetryTimeouts.get(action);
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(()=>{
                this._reportTelemetry(data);
                this.#telemetryTimeouts.delete(action);
                if (this.#telemetryTimeouts.size === 0) this.#telemetryTimeouts = null;
            }, $cca4aceb320d03d3$var$AnnotationEditor._telemetryTimeout);
            this.#telemetryTimeouts.set(action, timeout);
            return;
        }
        data.type ||= this.editorType;
        this._uiManager._eventBus.dispatch("reporttelemetry", {
            source: this,
            details: {
                type: "editing",
                data: data
            }
        });
    }
    show(visible = this._isVisible) {
        this.div.classList.toggle("hidden", !visible);
        this._isVisible = visible;
    }
    enable() {
        if (this.div) this.div.tabIndex = 0;
        this.#disabled = false;
    }
    disable() {
        if (this.div) this.div.tabIndex = -1;
        this.#disabled = true;
    }
    renderAnnotationElement(annotation) {
        let content = annotation.container.querySelector(".annotationContent");
        if (!content) {
            content = document.createElement("div");
            content.classList.add("annotationContent", this.editorType);
            annotation.container.prepend(content);
        } else if (content.nodeName === "CANVAS") {
            const canvas = content;
            content = document.createElement("div");
            content.classList.add("annotationContent", this.editorType);
            canvas.before(content);
        }
        return content;
    }
    resetAnnotationElement(annotation) {
        const { firstChild: firstChild } = annotation.container;
        if (firstChild.nodeName === "DIV" && firstChild.classList.contains("annotationContent")) firstChild.remove();
    }
}
class $cca4aceb320d03d3$var$FakeEditor extends $cca4aceb320d03d3$var$AnnotationEditor {
    constructor(params){
        super(params);
        this.annotationElementId = params.annotationElementId;
        this.deleted = true;
    }
    serialize() {
        return {
            id: this.annotationElementId,
            deleted: true,
            pageIndex: this.pageIndex
        };
    }
}
const $cca4aceb320d03d3$var$SEED = 0xc3d2e1f0;
const $cca4aceb320d03d3$var$MASK_HIGH = 0xffff0000;
const $cca4aceb320d03d3$var$MASK_LOW = 0xffff;
class $cca4aceb320d03d3$var$MurmurHash3_64 {
    constructor(seed){
        this.h1 = seed ? seed & 0xffffffff : $cca4aceb320d03d3$var$SEED;
        this.h2 = seed ? seed & 0xffffffff : $cca4aceb320d03d3$var$SEED;
    }
    update(input) {
        let data, length;
        if (typeof input === "string") {
            data = new Uint8Array(input.length * 2);
            length = 0;
            for(let i = 0, ii = input.length; i < ii; i++){
                const code = input.charCodeAt(i);
                if (code <= 0xff) data[length++] = code;
                else {
                    data[length++] = code >>> 8;
                    data[length++] = code & 0xff;
                }
            }
        } else if (ArrayBuffer.isView(input)) {
            data = input.slice();
            length = data.byteLength;
        } else throw new Error("Invalid data format, must be a string or TypedArray.");
        const blockCounts = length >> 2;
        const tailLength = length - blockCounts * 4;
        const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
        let k1 = 0, k2 = 0;
        let h1 = this.h1, h2 = this.h2;
        const C1 = 0xcc9e2d51, C2 = 0x1b873593;
        const C1_LOW = C1 & $cca4aceb320d03d3$var$MASK_LOW, C2_LOW = C2 & $cca4aceb320d03d3$var$MASK_LOW;
        for(let i = 0; i < blockCounts; i++)if (i & 1) {
            k1 = dataUint32[i];
            k1 = k1 * C1 & $cca4aceb320d03d3$var$MASK_HIGH | k1 * C1_LOW & $cca4aceb320d03d3$var$MASK_LOW;
            k1 = k1 << 15 | k1 >>> 17;
            k1 = k1 * C2 & $cca4aceb320d03d3$var$MASK_HIGH | k1 * C2_LOW & $cca4aceb320d03d3$var$MASK_LOW;
            h1 ^= k1;
            h1 = h1 << 13 | h1 >>> 19;
            h1 = h1 * 5 + 0xe6546b64;
        } else {
            k2 = dataUint32[i];
            k2 = k2 * C1 & $cca4aceb320d03d3$var$MASK_HIGH | k2 * C1_LOW & $cca4aceb320d03d3$var$MASK_LOW;
            k2 = k2 << 15 | k2 >>> 17;
            k2 = k2 * C2 & $cca4aceb320d03d3$var$MASK_HIGH | k2 * C2_LOW & $cca4aceb320d03d3$var$MASK_LOW;
            h2 ^= k2;
            h2 = h2 << 13 | h2 >>> 19;
            h2 = h2 * 5 + 0xe6546b64;
        }
        k1 = 0;
        switch(tailLength){
            case 3:
                k1 ^= data[blockCounts * 4 + 2] << 16;
            case 2:
                k1 ^= data[blockCounts * 4 + 1] << 8;
            case 1:
                k1 ^= data[blockCounts * 4];
                k1 = k1 * C1 & $cca4aceb320d03d3$var$MASK_HIGH | k1 * C1_LOW & $cca4aceb320d03d3$var$MASK_LOW;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = k1 * C2 & $cca4aceb320d03d3$var$MASK_HIGH | k1 * C2_LOW & $cca4aceb320d03d3$var$MASK_LOW;
                if (blockCounts & 1) h1 ^= k1;
                else h2 ^= k1;
        }
        this.h1 = h1;
        this.h2 = h2;
    }
    hexdigest() {
        let h1 = this.h1, h2 = this.h2;
        h1 ^= h2 >>> 1;
        h1 = h1 * 0xed558ccd & $cca4aceb320d03d3$var$MASK_HIGH | h1 * 0x8ccd & $cca4aceb320d03d3$var$MASK_LOW;
        h2 = h2 * 0xff51afd7 & $cca4aceb320d03d3$var$MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & $cca4aceb320d03d3$var$MASK_HIGH) >>> 16;
        h1 ^= h2 >>> 1;
        h1 = h1 * 0x1a85ec53 & $cca4aceb320d03d3$var$MASK_HIGH | h1 * 0xec53 & $cca4aceb320d03d3$var$MASK_LOW;
        h2 = h2 * 0xc4ceb9fe & $cca4aceb320d03d3$var$MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & $cca4aceb320d03d3$var$MASK_HIGH) >>> 16;
        h1 ^= h2 >>> 1;
        return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
    }
}
const $cca4aceb320d03d3$var$SerializableEmpty = Object.freeze({
    map: null,
    hash: "",
    transfer: undefined
});
class $cca4aceb320d03d3$var$AnnotationStorage {
    #modified = false;
    #storage = new Map();
    constructor(){
        this.onSetModified = null;
        this.onResetModified = null;
        this.onAnnotationEditor = null;
    }
    getValue(key, defaultValue) {
        const value = this.#storage.get(key);
        if (value === undefined) return defaultValue;
        return Object.assign(defaultValue, value);
    }
    getRawValue(key) {
        return this.#storage.get(key);
    }
    remove(key) {
        this.#storage.delete(key);
        if (this.#storage.size === 0) this.resetModified();
        if (typeof this.onAnnotationEditor === "function") {
            for (const value of this.#storage.values()){
                if (value instanceof $cca4aceb320d03d3$var$AnnotationEditor) return;
            }
            this.onAnnotationEditor(null);
        }
    }
    setValue(key, value) {
        const obj = this.#storage.get(key);
        let modified = false;
        if (obj !== undefined) {
            for (const [entry, val] of Object.entries(value))if (obj[entry] !== val) {
                modified = true;
                obj[entry] = val;
            }
        } else {
            modified = true;
            this.#storage.set(key, value);
        }
        if (modified) this.#setModified();
        if (value instanceof $cca4aceb320d03d3$var$AnnotationEditor && typeof this.onAnnotationEditor === "function") this.onAnnotationEditor(value.constructor._type);
    }
    has(key) {
        return this.#storage.has(key);
    }
    getAll() {
        return this.#storage.size > 0 ? $cca4aceb320d03d3$var$objectFromMap(this.#storage) : null;
    }
    setAll(obj) {
        for (const [key, val] of Object.entries(obj))this.setValue(key, val);
    }
    get size() {
        return this.#storage.size;
    }
    #setModified() {
        if (!this.#modified) {
            this.#modified = true;
            if (typeof this.onSetModified === "function") this.onSetModified();
        }
    }
    resetModified() {
        if (this.#modified) {
            this.#modified = false;
            if (typeof this.onResetModified === "function") this.onResetModified();
        }
    }
    get print() {
        return new $cca4aceb320d03d3$var$PrintAnnotationStorage(this);
    }
    get serializable() {
        if (this.#storage.size === 0) return $cca4aceb320d03d3$var$SerializableEmpty;
        const map = new Map(), hash = new $cca4aceb320d03d3$var$MurmurHash3_64(), transfer = [];
        const context = Object.create(null);
        let hasBitmap = false;
        for (const [key, val] of this.#storage){
            const serialized = val instanceof $cca4aceb320d03d3$var$AnnotationEditor ? val.serialize(false, context) : val;
            if (serialized) {
                map.set(key, serialized);
                hash.update(`${key}:${JSON.stringify(serialized)}`);
                hasBitmap ||= !!serialized.bitmap;
            }
        }
        if (hasBitmap) {
            for (const value of map.values())if (value.bitmap) transfer.push(value.bitmap);
        }
        return map.size > 0 ? {
            map: map,
            hash: hash.hexdigest(),
            transfer: transfer
        } : $cca4aceb320d03d3$var$SerializableEmpty;
    }
    get editorStats() {
        let stats = null;
        const typeToEditor = new Map();
        for (const value of this.#storage.values()){
            if (!(value instanceof $cca4aceb320d03d3$var$AnnotationEditor)) continue;
            const editorStats = value.telemetryFinalData;
            if (!editorStats) continue;
            const { type: type } = editorStats;
            if (!typeToEditor.has(type)) typeToEditor.set(type, Object.getPrototypeOf(value).constructor);
            stats ||= Object.create(null);
            const map = stats[type] ||= new Map();
            for (const [key, val] of Object.entries(editorStats)){
                if (key === "type") continue;
                let counters = map.get(key);
                if (!counters) {
                    counters = new Map();
                    map.set(key, counters);
                }
                const count = counters.get(val) ?? 0;
                counters.set(val, count + 1);
            }
        }
        for (const [type, editor] of typeToEditor)stats[type] = editor.computeTelemetryFinalData(stats[type]);
        return stats;
    }
}
class $cca4aceb320d03d3$var$PrintAnnotationStorage extends $cca4aceb320d03d3$var$AnnotationStorage {
    #serializable;
    constructor(parent){
        super();
        const { map: map, hash: hash, transfer: transfer } = parent.serializable;
        const clone = structuredClone(map, transfer ? {
            transfer: transfer
        } : null);
        this.#serializable = {
            map: clone,
            hash: hash,
            transfer: transfer
        };
    }
    get print() {
        $cca4aceb320d03d3$var$unreachable("Should not call PrintAnnotationStorage.print");
    }
    get serializable() {
        return this.#serializable;
    }
}
class $cca4aceb320d03d3$var$FontLoader {
    #systemFonts = new Set();
    constructor({ ownerDocument: ownerDocument = globalThis.document, styleElement: styleElement = null }){
        this._document = ownerDocument;
        this.nativeFontFaces = new Set();
        this.styleElement = null;
        this.loadingRequests = [];
        this.loadTestFontId = 0;
    }
    addNativeFontFace(nativeFontFace) {
        this.nativeFontFaces.add(nativeFontFace);
        this._document.fonts.add(nativeFontFace);
    }
    removeNativeFontFace(nativeFontFace) {
        this.nativeFontFaces.delete(nativeFontFace);
        this._document.fonts.delete(nativeFontFace);
    }
    insertRule(rule) {
        if (!this.styleElement) {
            this.styleElement = this._document.createElement("style");
            this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
        }
        const styleSheet = this.styleElement.sheet;
        styleSheet.insertRule(rule, styleSheet.cssRules.length);
    }
    clear() {
        for (const nativeFontFace of this.nativeFontFaces)this._document.fonts.delete(nativeFontFace);
        this.nativeFontFaces.clear();
        this.#systemFonts.clear();
        if (this.styleElement) {
            this.styleElement.remove();
            this.styleElement = null;
        }
    }
    async loadSystemFont({ systemFontInfo: info, _inspectFont: _inspectFont }) {
        if (!info || this.#systemFonts.has(info.loadedName)) return;
        $cca4aceb320d03d3$var$assert(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
        if (this.isFontLoadingAPISupported) {
            const { loadedName: loadedName, src: src, style: style } = info;
            const fontFace = new FontFace(loadedName, src, style);
            this.addNativeFontFace(fontFace);
            try {
                await fontFace.load();
                this.#systemFonts.add(loadedName);
                _inspectFont?.(info);
            } catch  {
                $cca4aceb320d03d3$var$warn(`Cannot load system font: ${info.baseFontName}, installing it could help to improve PDF rendering.`);
                this.removeNativeFontFace(fontFace);
            }
            return;
        }
        $cca4aceb320d03d3$var$unreachable("Not implemented: loadSystemFont without the Font Loading API.");
    }
    async bind(font) {
        if (font.attached || font.missingFile && !font.systemFontInfo) return;
        font.attached = true;
        if (font.systemFontInfo) {
            await this.loadSystemFont(font);
            return;
        }
        if (this.isFontLoadingAPISupported) {
            const nativeFontFace = font.createNativeFontFace();
            if (nativeFontFace) {
                this.addNativeFontFace(nativeFontFace);
                try {
                    await nativeFontFace.loaded;
                } catch (ex) {
                    $cca4aceb320d03d3$var$warn(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
                    font.disableFontFace = true;
                    throw ex;
                }
            }
            return;
        }
        const rule = font.createFontFaceRule();
        if (rule) {
            this.insertRule(rule);
            if (this.isSyncFontLoadingSupported) return;
            await new Promise((resolve)=>{
                const request = this._queueLoadingCallback(resolve);
                this._prepareFontLoadEvent(font, request);
            });
        }
    }
    get isFontLoadingAPISupported() {
        const hasFonts = !!this._document?.fonts;
        return $cca4aceb320d03d3$var$shadow(this, "isFontLoadingAPISupported", hasFonts);
    }
    get isSyncFontLoadingSupported() {
        let supported = false;
        if ($cca4aceb320d03d3$var$isNodeJS) supported = true;
        else if (typeof navigator !== "undefined" && typeof navigator?.userAgent === "string" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) supported = true;
        return $cca4aceb320d03d3$var$shadow(this, "isSyncFontLoadingSupported", supported);
    }
    _queueLoadingCallback(callback) {
        function completeRequest() {
            $cca4aceb320d03d3$var$assert(!request.done, "completeRequest() cannot be called twice.");
            request.done = true;
            while(loadingRequests.length > 0 && loadingRequests[0].done){
                const otherRequest = loadingRequests.shift();
                setTimeout(otherRequest.callback, 0);
            }
        }
        const { loadingRequests: loadingRequests } = this;
        const request = {
            done: false,
            complete: completeRequest,
            callback: callback
        };
        loadingRequests.push(request);
        return request;
    }
    get _loadTestFont() {
        const testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
        return $cca4aceb320d03d3$var$shadow(this, "_loadTestFont", testFont);
    }
    _prepareFontLoadEvent(font, request) {
        function int32(data, offset) {
            return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
        }
        function spliceString(s, offset, remove, insert) {
            const chunk1 = s.substring(0, offset);
            const chunk2 = s.substring(offset + remove);
            return chunk1 + insert + chunk2;
        }
        let i, ii;
        const canvas = this._document.createElement("canvas");
        canvas.width = 1;
        canvas.height = 1;
        const ctx = canvas.getContext("2d");
        let called = 0;
        function isFontReady(name, callback) {
            if (++called > 30) {
                $cca4aceb320d03d3$var$warn("Load test font never loaded.");
                callback();
                return;
            }
            ctx.font = "30px " + name;
            ctx.fillText(".", 0, 20);
            const imageData = ctx.getImageData(0, 0, 1, 1);
            if (imageData.data[3] > 0) {
                callback();
                return;
            }
            setTimeout(isFontReady.bind(null, name, callback));
        }
        const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
        let data = this._loadTestFont;
        const COMMENT_OFFSET = 976;
        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
        const CFF_CHECKSUM_OFFSET = 16;
        const XXXX_VALUE = 0x58585858;
        let checksum = int32(data, CFF_CHECKSUM_OFFSET);
        for(i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4)checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
        if (i < loadTestFontId.length) checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, $cca4aceb320d03d3$var$string32(checksum));
        const url = `url(data:font/opentype;base64,${btoa(data)});`;
        const rule = `@font-face {font-family:"${loadTestFontId}";src:${url}}`;
        this.insertRule(rule);
        const div = this._document.createElement("div");
        div.style.visibility = "hidden";
        div.style.width = div.style.height = "10px";
        div.style.position = "absolute";
        div.style.top = div.style.left = "0px";
        for (const name of [
            font.loadedName,
            loadTestFontId
        ]){
            const span = this._document.createElement("span");
            span.textContent = "Hi";
            span.style.fontFamily = name;
            div.append(span);
        }
        this._document.body.append(div);
        isFontReady(loadTestFontId, ()=>{
            div.remove();
            request.complete();
        });
    }
}
class $cca4aceb320d03d3$var$FontFaceObject {
    constructor(translatedData, { disableFontFace: disableFontFace = false, inspectFont: inspectFont = null }){
        this.compiledGlyphs = Object.create(null);
        for(const i in translatedData)this[i] = translatedData[i];
        this.disableFontFace = disableFontFace === true;
        this._inspectFont = inspectFont;
    }
    createNativeFontFace() {
        if (!this.data || this.disableFontFace) return null;
        let nativeFontFace;
        if (!this.cssFontInfo) nativeFontFace = new FontFace(this.loadedName, this.data, {});
        else {
            const css = {
                weight: this.cssFontInfo.fontWeight
            };
            if (this.cssFontInfo.italicAngle) css.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
            nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
        }
        this._inspectFont?.(this);
        return nativeFontFace;
    }
    createFontFaceRule() {
        if (!this.data || this.disableFontFace) return null;
        const data = $cca4aceb320d03d3$var$bytesToString(this.data);
        const url = `url(data:${this.mimetype};base64,${btoa(data)});`;
        let rule;
        if (!this.cssFontInfo) rule = `@font-face {font-family:"${this.loadedName}";src:${url}}`;
        else {
            let css = `font-weight: ${this.cssFontInfo.fontWeight};`;
            if (this.cssFontInfo.italicAngle) css += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
            rule = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css}src:${url}}`;
        }
        this._inspectFont?.(this, url);
        return rule;
    }
    getPathGenerator(objs, character) {
        if (this.compiledGlyphs[character] !== undefined) return this.compiledGlyphs[character];
        let cmds;
        try {
            cmds = objs.get(this.loadedName + "_path_" + character);
        } catch (ex) {
            $cca4aceb320d03d3$var$warn(`getPathGenerator - ignoring character: "${ex}".`);
        }
        if (!Array.isArray(cmds) || cmds.length === 0) return this.compiledGlyphs[character] = function(c, size) {};
        const commands = [];
        for(let i = 0, ii = cmds.length; i < ii;)switch(cmds[i++]){
            case $cca4aceb320d03d3$var$FontRenderOps.BEZIER_CURVE_TO:
                {
                    const [a, b, c, d, e, f] = cmds.slice(i, i + 6);
                    commands.push((ctx)=>ctx.bezierCurveTo(a, b, c, d, e, f));
                    i += 6;
                }
                break;
            case $cca4aceb320d03d3$var$FontRenderOps.MOVE_TO:
                {
                    const [a, b] = cmds.slice(i, i + 2);
                    commands.push((ctx)=>ctx.moveTo(a, b));
                    i += 2;
                }
                break;
            case $cca4aceb320d03d3$var$FontRenderOps.LINE_TO:
                {
                    const [a, b] = cmds.slice(i, i + 2);
                    commands.push((ctx)=>ctx.lineTo(a, b));
                    i += 2;
                }
                break;
            case $cca4aceb320d03d3$var$FontRenderOps.QUADRATIC_CURVE_TO:
                {
                    const [a, b, c, d] = cmds.slice(i, i + 4);
                    commands.push((ctx)=>ctx.quadraticCurveTo(a, b, c, d));
                    i += 4;
                }
                break;
            case $cca4aceb320d03d3$var$FontRenderOps.RESTORE:
                commands.push((ctx)=>ctx.restore());
                break;
            case $cca4aceb320d03d3$var$FontRenderOps.SAVE:
                commands.push((ctx)=>ctx.save());
                break;
            case $cca4aceb320d03d3$var$FontRenderOps.SCALE:
                $cca4aceb320d03d3$var$assert(commands.length === 2, "Scale command is only valid at the third position.");
                break;
            case $cca4aceb320d03d3$var$FontRenderOps.TRANSFORM:
                {
                    const [a, b, c, d, e, f] = cmds.slice(i, i + 6);
                    commands.push((ctx)=>ctx.transform(a, b, c, d, e, f));
                    i += 6;
                }
                break;
            case $cca4aceb320d03d3$var$FontRenderOps.TRANSLATE:
                {
                    const [a, b] = cmds.slice(i, i + 2);
                    commands.push((ctx)=>ctx.translate(a, b));
                    i += 2;
                }
                break;
        }
        return this.compiledGlyphs[character] = function glyphDrawer(ctx, size) {
            commands[0](ctx);
            commands[1](ctx);
            ctx.scale(size, -size);
            for(let i = 2, ii = commands.length; i < ii; i++)commands[i](ctx);
        };
    }
}




if ($cca4aceb320d03d3$var$isNodeJS) {
    var $cca4aceb320d03d3$var$packageCapability = Promise.withResolvers();
    var $cca4aceb320d03d3$var$packageMap = null;
    const loadPackages = async ()=>{
        const fs = await (parcelRequire("cp7mo")), http = await (parcelRequire("cp7mo")), https = await (parcelRequire("cp7mo")), url = await (parcelRequire("cp7mo"));
        let canvas, path2d;
        return new Map(Object.entries({
            fs: fs,
            http: http,
            https: https,
            url: url,
            canvas: canvas,
            path2d: path2d
        }));
    };
    loadPackages().then((map)=>{
        $cca4aceb320d03d3$var$packageMap = map;
        $cca4aceb320d03d3$var$packageCapability.resolve();
    }, (reason)=>{
        $cca4aceb320d03d3$var$warn(`loadPackages: ${reason}`);
        $cca4aceb320d03d3$var$packageMap = new Map();
        $cca4aceb320d03d3$var$packageCapability.resolve();
    });
}
class $cca4aceb320d03d3$var$NodePackages {
    static get promise() {
        return $cca4aceb320d03d3$var$packageCapability.promise;
    }
    static get(name) {
        return $cca4aceb320d03d3$var$packageMap?.get(name);
    }
}
const $cca4aceb320d03d3$var$node_utils_fetchData = function(url) {
    const fs = $cca4aceb320d03d3$var$NodePackages.get("fs");
    return fs.promises.readFile(url).then((data)=>new Uint8Array(data));
};
class $cca4aceb320d03d3$var$NodeFilterFactory extends $cca4aceb320d03d3$var$BaseFilterFactory {
}
class $cca4aceb320d03d3$var$NodeCanvasFactory extends $cca4aceb320d03d3$var$BaseCanvasFactory {
    _createCanvas(width, height) {
        const canvas = $cca4aceb320d03d3$var$NodePackages.get("canvas");
        return canvas.createCanvas(width, height);
    }
}
class $cca4aceb320d03d3$var$NodeCMapReaderFactory extends $cca4aceb320d03d3$var$BaseCMapReaderFactory {
    _fetchData(url, compressionType) {
        return $cca4aceb320d03d3$var$node_utils_fetchData(url).then((data)=>({
                cMapData: data,
                compressionType: compressionType
            }));
    }
}
class $cca4aceb320d03d3$var$NodeStandardFontDataFactory extends $cca4aceb320d03d3$var$BaseStandardFontDataFactory {
    _fetchData(url) {
        return $cca4aceb320d03d3$var$node_utils_fetchData(url);
    }
}
const $cca4aceb320d03d3$var$PathType = {
    FILL: "Fill",
    STROKE: "Stroke",
    SHADING: "Shading"
};
function $cca4aceb320d03d3$var$applyBoundingBox(ctx, bbox) {
    if (!bbox) return;
    const width = bbox[2] - bbox[0];
    const height = bbox[3] - bbox[1];
    const region = new Path2D();
    region.rect(bbox[0], bbox[1], width, height);
    ctx.clip(region);
}
class $cca4aceb320d03d3$var$BaseShadingPattern {
    constructor(){
        if (this.constructor === $cca4aceb320d03d3$var$BaseShadingPattern) $cca4aceb320d03d3$var$unreachable("Cannot initialize BaseShadingPattern.");
    }
    getPattern() {
        $cca4aceb320d03d3$var$unreachable("Abstract method `getPattern` called.");
    }
}
class $cca4aceb320d03d3$var$RadialAxialShadingPattern extends $cca4aceb320d03d3$var$BaseShadingPattern {
    constructor(IR){
        super();
        this._type = IR[1];
        this._bbox = IR[2];
        this._colorStops = IR[3];
        this._p0 = IR[4];
        this._p1 = IR[5];
        this._r0 = IR[6];
        this._r1 = IR[7];
        this.matrix = null;
    }
    _createGradient(ctx) {
        let grad;
        if (this._type === "axial") grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
        else if (this._type === "radial") grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
        for (const colorStop of this._colorStops)grad.addColorStop(colorStop[0], colorStop[1]);
        return grad;
    }
    getPattern(ctx, owner, inverse, pathType) {
        let pattern;
        if (pathType === $cca4aceb320d03d3$var$PathType.STROKE || pathType === $cca4aceb320d03d3$var$PathType.FILL) {
            const ownerBBox = owner.current.getClippedPathBoundingBox(pathType, $cca4aceb320d03d3$var$getCurrentTransform(ctx)) || [
                0,
                0,
                0,
                0
            ];
            const width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
            const height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
            const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height, true);
            const tmpCtx = tmpCanvas.context;
            tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
            tmpCtx.beginPath();
            tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
            tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
            inverse = $cca4aceb320d03d3$var$Util.transform(inverse, [
                1,
                0,
                0,
                1,
                ownerBBox[0],
                ownerBBox[1]
            ]);
            tmpCtx.transform(...owner.baseTransform);
            if (this.matrix) tmpCtx.transform(...this.matrix);
            $cca4aceb320d03d3$var$applyBoundingBox(tmpCtx, this._bbox);
            tmpCtx.fillStyle = this._createGradient(tmpCtx);
            tmpCtx.fill();
            pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
            const domMatrix = new DOMMatrix(inverse);
            pattern.setTransform(domMatrix);
        } else {
            $cca4aceb320d03d3$var$applyBoundingBox(ctx, this._bbox);
            pattern = this._createGradient(ctx);
        }
        return pattern;
    }
}
function $cca4aceb320d03d3$var$drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
    const coords = context.coords, colors = context.colors;
    const bytes = data.data, rowSize = data.width * 4;
    let tmp;
    if (coords[p1 + 1] > coords[p2 + 1]) {
        tmp = p1;
        p1 = p2;
        p2 = tmp;
        tmp = c1;
        c1 = c2;
        c2 = tmp;
    }
    if (coords[p2 + 1] > coords[p3 + 1]) {
        tmp = p2;
        p2 = p3;
        p3 = tmp;
        tmp = c2;
        c2 = c3;
        c3 = tmp;
    }
    if (coords[p1 + 1] > coords[p2 + 1]) {
        tmp = p1;
        p1 = p2;
        p2 = tmp;
        tmp = c1;
        c1 = c2;
        c2 = tmp;
    }
    const x1 = (coords[p1] + context.offsetX) * context.scaleX;
    const y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
    const x2 = (coords[p2] + context.offsetX) * context.scaleX;
    const y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
    const x3 = (coords[p3] + context.offsetX) * context.scaleX;
    const y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
    if (y1 >= y3) return;
    const c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
    const c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
    const c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
    const minY = Math.round(y1), maxY = Math.round(y3);
    let xa, car, cag, cab;
    let xb, cbr, cbg, cbb;
    for(let y = minY; y <= maxY; y++){
        if (y < y2) {
            const k = y < y1 ? 0 : (y1 - y) / (y1 - y2);
            xa = x1 - (x1 - x2) * k;
            car = c1r - (c1r - c2r) * k;
            cag = c1g - (c1g - c2g) * k;
            cab = c1b - (c1b - c2b) * k;
        } else {
            let k;
            if (y > y3) k = 1;
            else if (y2 === y3) k = 0;
            else k = (y2 - y) / (y2 - y3);
            xa = x2 - (x2 - x3) * k;
            car = c2r - (c2r - c3r) * k;
            cag = c2g - (c2g - c3g) * k;
            cab = c2b - (c2b - c3b) * k;
        }
        let k;
        if (y < y1) k = 0;
        else if (y > y3) k = 1;
        else k = (y1 - y) / (y1 - y3);
        xb = x1 - (x1 - x3) * k;
        cbr = c1r - (c1r - c3r) * k;
        cbg = c1g - (c1g - c3g) * k;
        cbb = c1b - (c1b - c3b) * k;
        const x1_ = Math.round(Math.min(xa, xb));
        const x2_ = Math.round(Math.max(xa, xb));
        let j = rowSize * y + x1_ * 4;
        for(let x = x1_; x <= x2_; x++){
            k = (xa - x) / (xa - xb);
            if (k < 0) k = 0;
            else if (k > 1) k = 1;
            bytes[j++] = car - (car - cbr) * k | 0;
            bytes[j++] = cag - (cag - cbg) * k | 0;
            bytes[j++] = cab - (cab - cbb) * k | 0;
            bytes[j++] = 255;
        }
    }
}
function $cca4aceb320d03d3$var$drawFigure(data, figure, context) {
    const ps = figure.coords;
    const cs = figure.colors;
    let i, ii;
    switch(figure.type){
        case "lattice":
            const verticesPerRow = figure.verticesPerRow;
            const rows = Math.floor(ps.length / verticesPerRow) - 1;
            const cols = verticesPerRow - 1;
            for(i = 0; i < rows; i++){
                let q = i * verticesPerRow;
                for(let j = 0; j < cols; j++, q++){
                    $cca4aceb320d03d3$var$drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                    $cca4aceb320d03d3$var$drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                }
            }
            break;
        case "triangles":
            for(i = 0, ii = ps.length; i < ii; i += 3)$cca4aceb320d03d3$var$drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
            break;
        default:
            throw new Error("illegal figure");
    }
}
class $cca4aceb320d03d3$var$MeshShadingPattern extends $cca4aceb320d03d3$var$BaseShadingPattern {
    constructor(IR){
        super();
        this._coords = IR[2];
        this._colors = IR[3];
        this._figures = IR[4];
        this._bounds = IR[5];
        this._bbox = IR[7];
        this._background = IR[8];
        this.matrix = null;
    }
    _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
        const EXPECTED_SCALE = 1.1;
        const MAX_PATTERN_SIZE = 3000;
        const BORDER_SIZE = 2;
        const offsetX = Math.floor(this._bounds[0]);
        const offsetY = Math.floor(this._bounds[1]);
        const boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
        const boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
        const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
        const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
        const scaleX = boundsWidth / width;
        const scaleY = boundsHeight / height;
        const context = {
            coords: this._coords,
            colors: this._colors,
            offsetX: -offsetX,
            offsetY: -offsetY,
            scaleX: 1 / scaleX,
            scaleY: 1 / scaleY
        };
        const paddedWidth = width + BORDER_SIZE * 2;
        const paddedHeight = height + BORDER_SIZE * 2;
        const tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
        const tmpCtx = tmpCanvas.context;
        const data = tmpCtx.createImageData(width, height);
        if (backgroundColor) {
            const bytes = data.data;
            for(let i = 0, ii = bytes.length; i < ii; i += 4){
                bytes[i] = backgroundColor[0];
                bytes[i + 1] = backgroundColor[1];
                bytes[i + 2] = backgroundColor[2];
                bytes[i + 3] = 255;
            }
        }
        for (const figure of this._figures)$cca4aceb320d03d3$var$drawFigure(data, figure, context);
        tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
        const canvas = tmpCanvas.canvas;
        return {
            canvas: canvas,
            offsetX: offsetX - BORDER_SIZE * scaleX,
            offsetY: offsetY - BORDER_SIZE * scaleY,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    getPattern(ctx, owner, inverse, pathType) {
        $cca4aceb320d03d3$var$applyBoundingBox(ctx, this._bbox);
        let scale;
        if (pathType === $cca4aceb320d03d3$var$PathType.SHADING) scale = $cca4aceb320d03d3$var$Util.singularValueDecompose2dScale($cca4aceb320d03d3$var$getCurrentTransform(ctx));
        else {
            scale = $cca4aceb320d03d3$var$Util.singularValueDecompose2dScale(owner.baseTransform);
            if (this.matrix) {
                const matrixScale = $cca4aceb320d03d3$var$Util.singularValueDecompose2dScale(this.matrix);
                scale = [
                    scale[0] * matrixScale[0],
                    scale[1] * matrixScale[1]
                ];
            }
        }
        const temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === $cca4aceb320d03d3$var$PathType.SHADING ? null : this._background, owner.cachedCanvases);
        if (pathType !== $cca4aceb320d03d3$var$PathType.SHADING) {
            ctx.setTransform(...owner.baseTransform);
            if (this.matrix) ctx.transform(...this.matrix);
        }
        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
        return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
    }
}
class $cca4aceb320d03d3$var$DummyShadingPattern extends $cca4aceb320d03d3$var$BaseShadingPattern {
    getPattern() {
        return "hotpink";
    }
}
function $cca4aceb320d03d3$var$getShadingPattern(IR) {
    switch(IR[0]){
        case "RadialAxial":
            return new $cca4aceb320d03d3$var$RadialAxialShadingPattern(IR);
        case "Mesh":
            return new $cca4aceb320d03d3$var$MeshShadingPattern(IR);
        case "Dummy":
            return new $cca4aceb320d03d3$var$DummyShadingPattern();
    }
    throw new Error(`Unknown IR type: ${IR[0]}`);
}
const $cca4aceb320d03d3$var$PaintType = {
    COLORED: 1,
    UNCOLORED: 2
};
class $cca4aceb320d03d3$var$TilingPattern {
    static MAX_PATTERN_SIZE = 3000;
    constructor(IR, color, ctx, canvasGraphicsFactory, baseTransform){
        this.operatorList = IR[2];
        this.matrix = IR[3];
        this.bbox = IR[4];
        this.xstep = IR[5];
        this.ystep = IR[6];
        this.paintType = IR[7];
        this.tilingType = IR[8];
        this.color = color;
        this.ctx = ctx;
        this.canvasGraphicsFactory = canvasGraphicsFactory;
        this.baseTransform = baseTransform;
    }
    createPatternCanvas(owner) {
        const operatorList = this.operatorList;
        const bbox = this.bbox;
        const xstep = this.xstep;
        const ystep = this.ystep;
        const paintType = this.paintType;
        const tilingType = this.tilingType;
        const color = this.color;
        const canvasGraphicsFactory = this.canvasGraphicsFactory;
        $cca4aceb320d03d3$var$info("TilingType: " + tilingType);
        const x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
        const matrixScale = $cca4aceb320d03d3$var$Util.singularValueDecompose2dScale(this.matrix);
        const curMatrixScale = $cca4aceb320d03d3$var$Util.singularValueDecompose2dScale(this.baseTransform);
        const combinedScale = [
            matrixScale[0] * curMatrixScale[0],
            matrixScale[1] * curMatrixScale[1]
        ];
        const dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
        const dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
        const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
        const tmpCtx = tmpCanvas.context;
        const graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
        graphics.groupLevel = owner.groupLevel;
        this.setFillAndStrokeStyleToContext(graphics, paintType, color);
        let adjustedX0 = x0;
        let adjustedY0 = y0;
        let adjustedX1 = x1;
        let adjustedY1 = y1;
        if (x0 < 0) {
            adjustedX0 = 0;
            adjustedX1 += Math.abs(x0);
        }
        if (y0 < 0) {
            adjustedY0 = 0;
            adjustedY1 += Math.abs(y0);
        }
        tmpCtx.translate(-(dimx.scale * adjustedX0), -(dimy.scale * adjustedY0));
        graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
        tmpCtx.save();
        this.clipBbox(graphics, adjustedX0, adjustedY0, adjustedX1, adjustedY1);
        graphics.baseTransform = $cca4aceb320d03d3$var$getCurrentTransform(graphics.ctx);
        graphics.executeOperatorList(operatorList);
        graphics.endDrawing();
        return {
            canvas: tmpCanvas.canvas,
            scaleX: dimx.scale,
            scaleY: dimy.scale,
            offsetX: adjustedX0,
            offsetY: adjustedY0
        };
    }
    getSizeAndScale(step, realOutputSize, scale) {
        step = Math.abs(step);
        const maxSize = Math.max($cca4aceb320d03d3$var$TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
        let size = Math.ceil(step * scale);
        if (size >= maxSize) size = maxSize;
        else scale = size / step;
        return {
            scale: scale,
            size: size
        };
    }
    clipBbox(graphics, x0, y0, x1, y1) {
        const bboxWidth = x1 - x0;
        const bboxHeight = y1 - y0;
        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
        graphics.current.updateRectMinMax($cca4aceb320d03d3$var$getCurrentTransform(graphics.ctx), [
            x0,
            y0,
            x1,
            y1
        ]);
        graphics.clip();
        graphics.endPath();
    }
    setFillAndStrokeStyleToContext(graphics, paintType, color) {
        const context = graphics.ctx, current = graphics.current;
        switch(paintType){
            case $cca4aceb320d03d3$var$PaintType.COLORED:
                const ctx = this.ctx;
                context.fillStyle = ctx.fillStyle;
                context.strokeStyle = ctx.strokeStyle;
                current.fillColor = ctx.fillStyle;
                current.strokeColor = ctx.strokeStyle;
                break;
            case $cca4aceb320d03d3$var$PaintType.UNCOLORED:
                const cssColor = $cca4aceb320d03d3$var$Util.makeHexColor(color[0], color[1], color[2]);
                context.fillStyle = cssColor;
                context.strokeStyle = cssColor;
                current.fillColor = cssColor;
                current.strokeColor = cssColor;
                break;
            default:
                throw new $cca4aceb320d03d3$var$FormatError(`Unsupported paint type: ${paintType}`);
        }
    }
    getPattern(ctx, owner, inverse, pathType) {
        let matrix = inverse;
        if (pathType !== $cca4aceb320d03d3$var$PathType.SHADING) {
            matrix = $cca4aceb320d03d3$var$Util.transform(matrix, owner.baseTransform);
            if (this.matrix) matrix = $cca4aceb320d03d3$var$Util.transform(matrix, this.matrix);
        }
        const temporaryPatternCanvas = this.createPatternCanvas(owner);
        let domMatrix = new DOMMatrix(matrix);
        domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
        const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
        pattern.setTransform(domMatrix);
        return pattern;
    }
}
function $cca4aceb320d03d3$var$convertToRGBA(params) {
    switch(params.kind){
        case ImageKind.GRAYSCALE_1BPP:
            return $cca4aceb320d03d3$var$convertBlackAndWhiteToRGBA(params);
        case ImageKind.RGB_24BPP:
            return $cca4aceb320d03d3$var$convertRGBToRGBA(params);
    }
    return null;
}
function $cca4aceb320d03d3$var$convertBlackAndWhiteToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, width: width, height: height, nonBlackColor: nonBlackColor = 0xffffffff, inverseDecode: inverseDecode = false }) {
    const black = $cca4aceb320d03d3$var$util_FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
    const [zeroMapping, oneMapping] = inverseDecode ? [
        nonBlackColor,
        black
    ] : [
        black,
        nonBlackColor
    ];
    const widthInSource = width >> 3;
    const widthRemainder = width & 7;
    const srcLength = src.length;
    dest = new Uint32Array(dest.buffer);
    let destPos = 0;
    for(let i = 0; i < height; i++){
        for(const max = srcPos + widthInSource; srcPos < max; srcPos++){
            const elem = srcPos < srcLength ? src[srcPos] : 255;
            dest[destPos++] = elem & 128 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 64 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 32 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 16 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 8 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 4 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 2 ? oneMapping : zeroMapping;
            dest[destPos++] = elem & 1 ? oneMapping : zeroMapping;
        }
        if (widthRemainder === 0) continue;
        const elem = srcPos < srcLength ? src[srcPos++] : 255;
        for(let j = 0; j < widthRemainder; j++)dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
    }
    return {
        srcPos: srcPos,
        destPos: destPos
    };
}
function $cca4aceb320d03d3$var$convertRGBToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, destPos: destPos = 0, width: width, height: height }) {
    let i = 0;
    const len32 = src.length >> 2;
    const src32 = new Uint32Array(src.buffer, srcPos, len32);
    if (FeatureTest.isLittleEndian) {
        for(; i < len32 - 2; i += 3, destPos += 4){
            const s1 = src32[i];
            const s2 = src32[i + 1];
            const s3 = src32[i + 2];
            dest[destPos] = s1 | 0xff000000;
            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 0xff000000;
            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 0xff000000;
            dest[destPos + 3] = s3 >>> 8 | 0xff000000;
        }
        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 0xff000000;
    } else {
        for(; i < len32 - 2; i += 3, destPos += 4){
            const s1 = src32[i];
            const s2 = src32[i + 1];
            const s3 = src32[i + 2];
            dest[destPos] = s1 | 0xff;
            dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 0xff;
            dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 0xff;
            dest[destPos + 3] = s3 << 8 | 0xff;
        }
        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | 0xff;
    }
    return {
        srcPos: srcPos,
        destPos: destPos
    };
}
function $cca4aceb320d03d3$var$grayToRGBA(src, dest) {
    if (FeatureTest.isLittleEndian) for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x10101 | 0xff000000;
    else for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x1010100 | 0x000000ff;
}
const $cca4aceb320d03d3$var$MIN_FONT_SIZE = 16;
const $cca4aceb320d03d3$var$MAX_FONT_SIZE = 100;
const $cca4aceb320d03d3$var$EXECUTION_TIME = 15;
const $cca4aceb320d03d3$var$EXECUTION_STEPS = 10;
const $cca4aceb320d03d3$var$MAX_SIZE_TO_COMPILE = 1000;
const $cca4aceb320d03d3$var$FULL_CHUNK_HEIGHT = 16;
function $cca4aceb320d03d3$var$mirrorContextOperations(ctx, destCtx) {
    if (ctx._removeMirroring) throw new Error("Context is already forwarding operations.");
    ctx.__originalSave = ctx.save;
    ctx.__originalRestore = ctx.restore;
    ctx.__originalRotate = ctx.rotate;
    ctx.__originalScale = ctx.scale;
    ctx.__originalTranslate = ctx.translate;
    ctx.__originalTransform = ctx.transform;
    ctx.__originalSetTransform = ctx.setTransform;
    ctx.__originalResetTransform = ctx.resetTransform;
    ctx.__originalClip = ctx.clip;
    ctx.__originalMoveTo = ctx.moveTo;
    ctx.__originalLineTo = ctx.lineTo;
    ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
    ctx.__originalRect = ctx.rect;
    ctx.__originalClosePath = ctx.closePath;
    ctx.__originalBeginPath = ctx.beginPath;
    ctx._removeMirroring = ()=>{
        ctx.save = ctx.__originalSave;
        ctx.restore = ctx.__originalRestore;
        ctx.rotate = ctx.__originalRotate;
        ctx.scale = ctx.__originalScale;
        ctx.translate = ctx.__originalTranslate;
        ctx.transform = ctx.__originalTransform;
        ctx.setTransform = ctx.__originalSetTransform;
        ctx.resetTransform = ctx.__originalResetTransform;
        ctx.clip = ctx.__originalClip;
        ctx.moveTo = ctx.__originalMoveTo;
        ctx.lineTo = ctx.__originalLineTo;
        ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
        ctx.rect = ctx.__originalRect;
        ctx.closePath = ctx.__originalClosePath;
        ctx.beginPath = ctx.__originalBeginPath;
        delete ctx._removeMirroring;
    };
    ctx.save = function ctxSave() {
        destCtx.save();
        this.__originalSave();
    };
    ctx.restore = function ctxRestore() {
        destCtx.restore();
        this.__originalRestore();
    };
    ctx.translate = function ctxTranslate(x, y) {
        destCtx.translate(x, y);
        this.__originalTranslate(x, y);
    };
    ctx.scale = function ctxScale(x, y) {
        destCtx.scale(x, y);
        this.__originalScale(x, y);
    };
    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
        destCtx.transform(a, b, c, d, e, f);
        this.__originalTransform(a, b, c, d, e, f);
    };
    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
        destCtx.setTransform(a, b, c, d, e, f);
        this.__originalSetTransform(a, b, c, d, e, f);
    };
    ctx.resetTransform = function ctxResetTransform() {
        destCtx.resetTransform();
        this.__originalResetTransform();
    };
    ctx.rotate = function ctxRotate(angle) {
        destCtx.rotate(angle);
        this.__originalRotate(angle);
    };
    ctx.clip = function ctxRotate(rule) {
        destCtx.clip(rule);
        this.__originalClip(rule);
    };
    ctx.moveTo = function(x, y) {
        destCtx.moveTo(x, y);
        this.__originalMoveTo(x, y);
    };
    ctx.lineTo = function(x, y) {
        destCtx.lineTo(x, y);
        this.__originalLineTo(x, y);
    };
    ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x, y) {
        destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
        this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
    };
    ctx.rect = function(x, y, width, height) {
        destCtx.rect(x, y, width, height);
        this.__originalRect(x, y, width, height);
    };
    ctx.closePath = function() {
        destCtx.closePath();
        this.__originalClosePath();
    };
    ctx.beginPath = function() {
        destCtx.beginPath();
        this.__originalBeginPath();
    };
}
class $cca4aceb320d03d3$var$CachedCanvases {
    constructor(canvasFactory){
        this.canvasFactory = canvasFactory;
        this.cache = Object.create(null);
    }
    getCanvas(id, width, height) {
        let canvasEntry;
        if (this.cache[id] !== undefined) {
            canvasEntry = this.cache[id];
            this.canvasFactory.reset(canvasEntry, width, height);
        } else {
            canvasEntry = this.canvasFactory.create(width, height);
            this.cache[id] = canvasEntry;
        }
        return canvasEntry;
    }
    delete(id) {
        delete this.cache[id];
    }
    clear() {
        for(const id in this.cache){
            const canvasEntry = this.cache[id];
            this.canvasFactory.destroy(canvasEntry);
            delete this.cache[id];
        }
    }
}
function $cca4aceb320d03d3$var$drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
    const [a, b, c, d, tx, ty] = $cca4aceb320d03d3$var$getCurrentTransform(ctx);
    if (b === 0 && c === 0) {
        const tlX = destX * a + tx;
        const rTlX = Math.round(tlX);
        const tlY = destY * d + ty;
        const rTlY = Math.round(tlY);
        const brX = (destX + destW) * a + tx;
        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
        const brY = (destY + destH) * d + ty;
        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
        ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
        ctx.setTransform(a, b, c, d, tx, ty);
        return [
            rWidth,
            rHeight
        ];
    }
    if (a === 0 && d === 0) {
        const tlX = destY * c + tx;
        const rTlX = Math.round(tlX);
        const tlY = destX * b + ty;
        const rTlY = Math.round(tlY);
        const brX = (destY + destH) * c + tx;
        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
        const brY = (destX + destW) * b + ty;
        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
        ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX, rTlY);
        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
        ctx.setTransform(a, b, c, d, tx, ty);
        return [
            rHeight,
            rWidth
        ];
    }
    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
    const scaleX = Math.hypot(a, b);
    const scaleY = Math.hypot(c, d);
    return [
        scaleX * destW,
        scaleY * destH
    ];
}
function $cca4aceb320d03d3$var$compileType3Glyph(imgData) {
    const { width: width, height: height } = imgData;
    if (width > $cca4aceb320d03d3$var$MAX_SIZE_TO_COMPILE || height > $cca4aceb320d03d3$var$MAX_SIZE_TO_COMPILE) return null;
    const POINT_TO_PROCESS_LIMIT = 1000;
    const POINT_TYPES = new Uint8Array([
        0,
        2,
        4,
        0,
        1,
        0,
        5,
        4,
        8,
        10,
        0,
        8,
        0,
        2,
        1,
        0
    ]);
    const width1 = width + 1;
    let points = new Uint8Array(width1 * (height + 1));
    let i, j, j0;
    const lineSize = width + 7 & -8;
    let data = new Uint8Array(lineSize * height), pos = 0;
    for (const elem of imgData.data){
        let mask = 128;
        while(mask > 0){
            data[pos++] = elem & mask ? 0 : 255;
            mask >>= 1;
        }
    }
    let count = 0;
    pos = 0;
    if (data[pos] !== 0) {
        points[0] = 1;
        ++count;
    }
    for(j = 1; j < width; j++){
        if (data[pos] !== data[pos + 1]) {
            points[j] = data[pos] ? 2 : 1;
            ++count;
        }
        pos++;
    }
    if (data[pos] !== 0) {
        points[j] = 2;
        ++count;
    }
    for(i = 1; i < height; i++){
        pos = i * lineSize;
        j0 = i * width1;
        if (data[pos - lineSize] !== data[pos]) {
            points[j0] = data[pos] ? 1 : 8;
            ++count;
        }
        let sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
        for(j = 1; j < width; j++){
            sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
            if (POINT_TYPES[sum]) {
                points[j0 + j] = POINT_TYPES[sum];
                ++count;
            }
            pos++;
        }
        if (data[pos - lineSize] !== data[pos]) {
            points[j0 + j] = data[pos] ? 2 : 4;
            ++count;
        }
        if (count > POINT_TO_PROCESS_LIMIT) return null;
    }
    pos = lineSize * (height - 1);
    j0 = i * width1;
    if (data[pos] !== 0) {
        points[j0] = 8;
        ++count;
    }
    for(j = 1; j < width; j++){
        if (data[pos] !== data[pos + 1]) {
            points[j0 + j] = data[pos] ? 4 : 8;
            ++count;
        }
        pos++;
    }
    if (data[pos] !== 0) {
        points[j0 + j] = 4;
        ++count;
    }
    if (count > POINT_TO_PROCESS_LIMIT) return null;
    const steps = new Int32Array([
        0,
        width1,
        -1,
        0,
        -width1,
        0,
        0,
        0,
        1
    ]);
    const path = new Path2D();
    for(i = 0; count && i <= height; i++){
        let p = i * width1;
        const end = p + width;
        while(p < end && !points[p])p++;
        if (p === end) continue;
        path.moveTo(p % width1, i);
        const p0 = p;
        let type = points[p];
        do {
            const step = steps[type];
            do p += step;
            while (!points[p]);
            const pp = points[p];
            if (pp !== 5 && pp !== 10) {
                type = pp;
                points[p] = 0;
            } else {
                type = pp & 0x33 * type >> 4;
                points[p] &= type >> 2 | type << 2;
            }
            path.lineTo(p % width1, p / width1 | 0);
            if (!points[p]) --count;
        }while (p0 !== p);
        --i;
    }
    data = null;
    points = null;
    const drawOutline = function(c) {
        c.save();
        c.scale(1 / width, -1 / height);
        c.translate(0, -height);
        c.fill(path);
        c.beginPath();
        c.restore();
    };
    return drawOutline;
}
class $cca4aceb320d03d3$var$CanvasExtraState {
    constructor(width, height){
        this.alphaIsShape = false;
        this.fontSize = 0;
        this.fontSizeScale = 1;
        this.textMatrix = $cca4aceb320d03d3$var$IDENTITY_MATRIX;
        this.textMatrixScale = 1;
        this.fontMatrix = $cca4aceb320d03d3$var$FONT_IDENTITY_MATRIX;
        this.leading = 0;
        this.x = 0;
        this.y = 0;
        this.lineX = 0;
        this.lineY = 0;
        this.charSpacing = 0;
        this.wordSpacing = 0;
        this.textHScale = 1;
        this.textRenderingMode = $cca4aceb320d03d3$var$TextRenderingMode.FILL;
        this.textRise = 0;
        this.fillColor = "#000000";
        this.strokeColor = "#000000";
        this.patternFill = false;
        this.fillAlpha = 1;
        this.strokeAlpha = 1;
        this.lineWidth = 1;
        this.activeSMask = null;
        this.transferMaps = "none";
        this.startNewPathAndClipBox([
            0,
            0,
            width,
            height
        ]);
    }
    clone() {
        const clone = Object.create(this);
        clone.clipBox = this.clipBox.slice();
        return clone;
    }
    setCurrentPoint(x, y) {
        this.x = x;
        this.y = y;
    }
    updatePathMinMax(transform, x, y) {
        [x, y] = $cca4aceb320d03d3$var$Util.applyTransform([
            x,
            y
        ], transform);
        this.minX = Math.min(this.minX, x);
        this.minY = Math.min(this.minY, y);
        this.maxX = Math.max(this.maxX, x);
        this.maxY = Math.max(this.maxY, y);
    }
    updateRectMinMax(transform, rect) {
        const p1 = $cca4aceb320d03d3$var$Util.applyTransform(rect, transform);
        const p2 = $cca4aceb320d03d3$var$Util.applyTransform(rect.slice(2), transform);
        const p3 = $cca4aceb320d03d3$var$Util.applyTransform([
            rect[0],
            rect[3]
        ], transform);
        const p4 = $cca4aceb320d03d3$var$Util.applyTransform([
            rect[2],
            rect[1]
        ], transform);
        this.minX = Math.min(this.minX, p1[0], p2[0], p3[0], p4[0]);
        this.minY = Math.min(this.minY, p1[1], p2[1], p3[1], p4[1]);
        this.maxX = Math.max(this.maxX, p1[0], p2[0], p3[0], p4[0]);
        this.maxY = Math.max(this.maxY, p1[1], p2[1], p3[1], p4[1]);
    }
    updateScalingPathMinMax(transform, minMax) {
        $cca4aceb320d03d3$var$Util.scaleMinMax(transform, minMax);
        this.minX = Math.min(this.minX, minMax[0]);
        this.minY = Math.min(this.minY, minMax[1]);
        this.maxX = Math.max(this.maxX, minMax[2]);
        this.maxY = Math.max(this.maxY, minMax[3]);
    }
    updateCurvePathMinMax(transform, x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
        const box = $cca4aceb320d03d3$var$Util.bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3, minMax);
        if (minMax) return;
        this.updateRectMinMax(transform, box);
    }
    getPathBoundingBox(pathType = $cca4aceb320d03d3$var$PathType.FILL, transform = null) {
        const box = [
            this.minX,
            this.minY,
            this.maxX,
            this.maxY
        ];
        if (pathType === $cca4aceb320d03d3$var$PathType.STROKE) {
            if (!transform) $cca4aceb320d03d3$var$unreachable("Stroke bounding box must include transform.");
            const scale = $cca4aceb320d03d3$var$Util.singularValueDecompose2dScale(transform);
            const xStrokePad = scale[0] * this.lineWidth / 2;
            const yStrokePad = scale[1] * this.lineWidth / 2;
            box[0] -= xStrokePad;
            box[1] -= yStrokePad;
            box[2] += xStrokePad;
            box[3] += yStrokePad;
        }
        return box;
    }
    updateClipFromPath() {
        const intersect = $cca4aceb320d03d3$var$Util.intersect(this.clipBox, this.getPathBoundingBox());
        this.startNewPathAndClipBox(intersect || [
            0,
            0,
            0,
            0
        ]);
    }
    isEmptyClip() {
        return this.minX === Infinity;
    }
    startNewPathAndClipBox(box) {
        this.clipBox = box;
        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = 0;
        this.maxY = 0;
    }
    getClippedPathBoundingBox(pathType = $cca4aceb320d03d3$var$PathType.FILL, transform = null) {
        return $cca4aceb320d03d3$var$Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
    }
}
function $cca4aceb320d03d3$var$putBinaryImageData(ctx, imgData) {
    if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
        ctx.putImageData(imgData, 0, 0);
        return;
    }
    const height = imgData.height, width = imgData.width;
    const partialChunkHeight = height % $cca4aceb320d03d3$var$FULL_CHUNK_HEIGHT;
    const fullChunks = (height - partialChunkHeight) / $cca4aceb320d03d3$var$FULL_CHUNK_HEIGHT;
    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    const chunkImgData = ctx.createImageData(width, $cca4aceb320d03d3$var$FULL_CHUNK_HEIGHT);
    let srcPos = 0, destPos;
    const src = imgData.data;
    const dest = chunkImgData.data;
    let i, j, thisChunkHeight, elemsInThisChunk;
    if (imgData.kind === $cca4aceb320d03d3$var$util_ImageKind.GRAYSCALE_1BPP) {
        const srcLength = src.byteLength;
        const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
        const dest32DataLength = dest32.length;
        const fullSrcDiff = width + 7 >> 3;
        const white = 0xffffffff;
        const black = $cca4aceb320d03d3$var$util_FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
        for(i = 0; i < totalChunks; i++){
            thisChunkHeight = i < fullChunks ? $cca4aceb320d03d3$var$FULL_CHUNK_HEIGHT : partialChunkHeight;
            destPos = 0;
            for(j = 0; j < thisChunkHeight; j++){
                const srcDiff = srcLength - srcPos;
                let k = 0;
                const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                const kEndUnrolled = kEnd & -8;
                let mask = 0;
                let srcByte = 0;
                for(; k < kEndUnrolled; k += 8){
                    srcByte = src[srcPos++];
                    dest32[destPos++] = srcByte & 128 ? white : black;
                    dest32[destPos++] = srcByte & 64 ? white : black;
                    dest32[destPos++] = srcByte & 32 ? white : black;
                    dest32[destPos++] = srcByte & 16 ? white : black;
                    dest32[destPos++] = srcByte & 8 ? white : black;
                    dest32[destPos++] = srcByte & 4 ? white : black;
                    dest32[destPos++] = srcByte & 2 ? white : black;
                    dest32[destPos++] = srcByte & 1 ? white : black;
                }
                for(; k < kEnd; k++){
                    if (mask === 0) {
                        srcByte = src[srcPos++];
                        mask = 128;
                    }
                    dest32[destPos++] = srcByte & mask ? white : black;
                    mask >>= 1;
                }
            }
            while(destPos < dest32DataLength)dest32[destPos++] = 0;
            ctx.putImageData(chunkImgData, 0, i * $cca4aceb320d03d3$var$FULL_CHUNK_HEIGHT);
        }
    } else if (imgData.kind === $cca4aceb320d03d3$var$util_ImageKind.RGBA_32BPP) {
        j = 0;
        elemsInThisChunk = width * $cca4aceb320d03d3$var$FULL_CHUNK_HEIGHT * 4;
        for(i = 0; i < fullChunks; i++){
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            srcPos += elemsInThisChunk;
            ctx.putImageData(chunkImgData, 0, j);
            j += $cca4aceb320d03d3$var$FULL_CHUNK_HEIGHT;
        }
        if (i < totalChunks) {
            elemsInThisChunk = width * partialChunkHeight * 4;
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            ctx.putImageData(chunkImgData, 0, j);
        }
    } else if (imgData.kind === $cca4aceb320d03d3$var$util_ImageKind.RGB_24BPP) {
        thisChunkHeight = $cca4aceb320d03d3$var$FULL_CHUNK_HEIGHT;
        elemsInThisChunk = width * thisChunkHeight;
        for(i = 0; i < totalChunks; i++){
            if (i >= fullChunks) {
                thisChunkHeight = partialChunkHeight;
                elemsInThisChunk = width * thisChunkHeight;
            }
            destPos = 0;
            for(j = elemsInThisChunk; j--;){
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = 255;
            }
            ctx.putImageData(chunkImgData, 0, i * $cca4aceb320d03d3$var$FULL_CHUNK_HEIGHT);
        }
    } else throw new Error(`bad image kind: ${imgData.kind}`);
}
function $cca4aceb320d03d3$var$putBinaryImageMask(ctx, imgData) {
    if (imgData.bitmap) {
        ctx.drawImage(imgData.bitmap, 0, 0);
        return;
    }
    const height = imgData.height, width = imgData.width;
    const partialChunkHeight = height % $cca4aceb320d03d3$var$FULL_CHUNK_HEIGHT;
    const fullChunks = (height - partialChunkHeight) / $cca4aceb320d03d3$var$FULL_CHUNK_HEIGHT;
    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    const chunkImgData = ctx.createImageData(width, $cca4aceb320d03d3$var$FULL_CHUNK_HEIGHT);
    let srcPos = 0;
    const src = imgData.data;
    const dest = chunkImgData.data;
    for(let i = 0; i < totalChunks; i++){
        const thisChunkHeight = i < fullChunks ? $cca4aceb320d03d3$var$FULL_CHUNK_HEIGHT : partialChunkHeight;
        ({ srcPos: srcPos } = $cca4aceb320d03d3$var$convertBlackAndWhiteToRGBA({
            src: src,
            srcPos: srcPos,
            dest: dest,
            width: width,
            height: thisChunkHeight,
            nonBlackColor: 0
        }));
        ctx.putImageData(chunkImgData, 0, i * $cca4aceb320d03d3$var$FULL_CHUNK_HEIGHT);
    }
}
function $cca4aceb320d03d3$var$copyCtxState(sourceCtx, destCtx) {
    const properties = [
        "strokeStyle",
        "fillStyle",
        "fillRule",
        "globalAlpha",
        "lineWidth",
        "lineCap",
        "lineJoin",
        "miterLimit",
        "globalCompositeOperation",
        "font",
        "filter"
    ];
    for (const property of properties)if (sourceCtx[property] !== undefined) destCtx[property] = sourceCtx[property];
    if (sourceCtx.setLineDash !== undefined) {
        destCtx.setLineDash(sourceCtx.getLineDash());
        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
    }
}
function $cca4aceb320d03d3$var$resetCtxToDefault(ctx) {
    ctx.strokeStyle = ctx.fillStyle = "#000000";
    ctx.fillRule = "nonzero";
    ctx.globalAlpha = 1;
    ctx.lineWidth = 1;
    ctx.lineCap = "butt";
    ctx.lineJoin = "miter";
    ctx.miterLimit = 10;
    ctx.globalCompositeOperation = "source-over";
    ctx.font = "10px sans-serif";
    if (ctx.setLineDash !== undefined) {
        ctx.setLineDash([]);
        ctx.lineDashOffset = 0;
    }
    if (!$cca4aceb320d03d3$var$isNodeJS) {
        const { filter: filter } = ctx;
        if (filter !== "none" && filter !== "") ctx.filter = "none";
    }
}
function $cca4aceb320d03d3$var$getImageSmoothingEnabled(transform, interpolate) {
    if (interpolate) return true;
    const scale = $cca4aceb320d03d3$var$Util.singularValueDecompose2dScale(transform);
    scale[0] = Math.fround(scale[0]);
    scale[1] = Math.fround(scale[1]);
    const actualScale = Math.fround((globalThis.devicePixelRatio || 1) * $cca4aceb320d03d3$var$PixelsPerInch.PDF_TO_CSS_UNITS);
    return scale[0] <= actualScale && scale[1] <= actualScale;
}
const $cca4aceb320d03d3$var$LINE_CAP_STYLES = [
    "butt",
    "round",
    "square"
];
const $cca4aceb320d03d3$var$LINE_JOIN_STYLES = [
    "miter",
    "round",
    "bevel"
];
const $cca4aceb320d03d3$var$NORMAL_CLIP = {};
const $cca4aceb320d03d3$var$EO_CLIP = {};
class $cca4aceb320d03d3$var$CanvasGraphics {
    constructor(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, { optionalContentConfig: optionalContentConfig, markedContentStack: markedContentStack = null }, annotationCanvasMap, pageColors){
        this.ctx = canvasCtx;
        this.current = new $cca4aceb320d03d3$var$CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
        this.stateStack = [];
        this.pendingClip = null;
        this.pendingEOFill = false;
        this.res = null;
        this.xobjs = null;
        this.commonObjs = commonObjs;
        this.objs = objs;
        this.canvasFactory = canvasFactory;
        this.filterFactory = filterFactory;
        this.groupStack = [];
        this.processingType3 = null;
        this.baseTransform = null;
        this.baseTransformStack = [];
        this.groupLevel = 0;
        this.smaskStack = [];
        this.smaskCounter = 0;
        this.tempSMask = null;
        this.suspendedCtx = null;
        this.contentVisible = true;
        this.markedContentStack = markedContentStack || [];
        this.optionalContentConfig = optionalContentConfig;
        this.cachedCanvases = new $cca4aceb320d03d3$var$CachedCanvases(this.canvasFactory);
        this.cachedPatterns = new Map();
        this.annotationCanvasMap = annotationCanvasMap;
        this.viewportScale = 1;
        this.outputScaleX = 1;
        this.outputScaleY = 1;
        this.pageColors = pageColors;
        this._cachedScaleForStroking = [
            -1,
            0
        ];
        this._cachedGetSinglePixelWidth = null;
        this._cachedBitmapsMap = new Map();
    }
    getObject(data, fallback = null) {
        if (typeof data === "string") return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
        return fallback;
    }
    beginDrawing({ transform: transform, viewport: viewport, transparency: transparency = false, background: background = null }) {
        const width = this.ctx.canvas.width;
        const height = this.ctx.canvas.height;
        const savedFillStyle = this.ctx.fillStyle;
        this.ctx.fillStyle = background || "#ffffff";
        this.ctx.fillRect(0, 0, width, height);
        this.ctx.fillStyle = savedFillStyle;
        if (transparency) {
            const transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
            this.compositeCtx = this.ctx;
            this.transparentCanvas = transparentCanvas.canvas;
            this.ctx = transparentCanvas.context;
            this.ctx.save();
            this.ctx.transform(...$cca4aceb320d03d3$var$getCurrentTransform(this.compositeCtx));
        }
        this.ctx.save();
        $cca4aceb320d03d3$var$resetCtxToDefault(this.ctx);
        if (transform) {
            this.ctx.transform(...transform);
            this.outputScaleX = transform[0];
            this.outputScaleY = transform[0];
        }
        this.ctx.transform(...viewport.transform);
        this.viewportScale = viewport.scale;
        this.baseTransform = $cca4aceb320d03d3$var$getCurrentTransform(this.ctx);
    }
    executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
        const argsArray = operatorList.argsArray;
        const fnArray = operatorList.fnArray;
        let i = executionStartIdx || 0;
        const argsArrayLen = argsArray.length;
        if (argsArrayLen === i) return i;
        const chunkOperations = argsArrayLen - i > $cca4aceb320d03d3$var$EXECUTION_STEPS && typeof continueCallback === "function";
        const endTime = chunkOperations ? Date.now() + $cca4aceb320d03d3$var$EXECUTION_TIME : 0;
        let steps = 0;
        const commonObjs = this.commonObjs;
        const objs = this.objs;
        let fnId;
        while(true){
            if (stepper !== undefined && i === stepper.nextBreakPoint) {
                stepper.breakIt(i, continueCallback);
                return i;
            }
            fnId = fnArray[i];
            if (fnId !== $cca4aceb320d03d3$var$OPS.dependency) this[fnId].apply(this, argsArray[i]);
            else for (const depObjId of argsArray[i]){
                const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                if (!objsPool.has(depObjId)) {
                    objsPool.get(depObjId, continueCallback);
                    return i;
                }
            }
            i++;
            if (i === argsArrayLen) return i;
            if (chunkOperations && ++steps > $cca4aceb320d03d3$var$EXECUTION_STEPS) {
                if (Date.now() > endTime) {
                    continueCallback();
                    return i;
                }
                steps = 0;
            }
        }
    }
    #restoreInitialState() {
        while(this.stateStack.length || this.inSMaskMode)this.restore();
        this.ctx.restore();
        if (this.transparentCanvas) {
            this.ctx = this.compositeCtx;
            this.ctx.save();
            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
            this.ctx.drawImage(this.transparentCanvas, 0, 0);
            this.ctx.restore();
            this.transparentCanvas = null;
        }
    }
    endDrawing() {
        this.#restoreInitialState();
        this.cachedCanvases.clear();
        this.cachedPatterns.clear();
        for (const cache of this._cachedBitmapsMap.values()){
            for (const canvas of cache.values())if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) canvas.width = canvas.height = 0;
            cache.clear();
        }
        this._cachedBitmapsMap.clear();
        this.#drawFilter();
    }
    #drawFilter() {
        if (this.pageColors) {
            const hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
            if (hcmFilterId !== "none") {
                const savedFilter = this.ctx.filter;
                this.ctx.filter = hcmFilterId;
                this.ctx.drawImage(this.ctx.canvas, 0, 0);
                this.ctx.filter = savedFilter;
            }
        }
    }
    _scaleImage(img, inverseTransform) {
        const width = img.width;
        const height = img.height;
        let widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
        let heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
        let paintWidth = width, paintHeight = height;
        let tmpCanvasId = "prescale1";
        let tmpCanvas, tmpCtx;
        while(widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1){
            let newWidth = paintWidth, newHeight = paintHeight;
            if (widthScale > 2 && paintWidth > 1) {
                newWidth = paintWidth >= 16384 ? Math.floor(paintWidth / 2) - 1 || 1 : Math.ceil(paintWidth / 2);
                widthScale /= paintWidth / newWidth;
            }
            if (heightScale > 2 && paintHeight > 1) {
                newHeight = paintHeight >= 16384 ? Math.floor(paintHeight / 2) - 1 || 1 : Math.ceil(paintHeight) / 2;
                heightScale /= paintHeight / newHeight;
            }
            tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
            tmpCtx = tmpCanvas.context;
            tmpCtx.clearRect(0, 0, newWidth, newHeight);
            tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
            img = tmpCanvas.canvas;
            paintWidth = newWidth;
            paintHeight = newHeight;
            tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
        }
        return {
            img: img,
            paintWidth: paintWidth,
            paintHeight: paintHeight
        };
    }
    _createMaskCanvas(img) {
        const ctx = this.ctx;
        const { width: width, height: height } = img;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        const currentTransform = $cca4aceb320d03d3$var$getCurrentTransform(ctx);
        let cache, cacheKey, scaled, maskCanvas;
        if ((img.bitmap || img.data) && img.count > 1) {
            const mainKey = img.bitmap || img.data.buffer;
            cacheKey = JSON.stringify(isPatternFill ? currentTransform : [
                currentTransform.slice(0, 4),
                fillColor
            ]);
            cache = this._cachedBitmapsMap.get(mainKey);
            if (!cache) {
                cache = new Map();
                this._cachedBitmapsMap.set(mainKey, cache);
            }
            const cachedImage = cache.get(cacheKey);
            if (cachedImage && !isPatternFill) {
                const offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                const offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                return {
                    canvas: cachedImage,
                    offsetX: offsetX,
                    offsetY: offsetY
                };
            }
            scaled = cachedImage;
        }
        if (!scaled) {
            maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
            $cca4aceb320d03d3$var$putBinaryImageMask(maskCanvas.context, img);
        }
        let maskToCanvas = $cca4aceb320d03d3$var$Util.transform(currentTransform, [
            1 / width,
            0,
            0,
            -1 / height,
            0,
            0
        ]);
        maskToCanvas = $cca4aceb320d03d3$var$Util.transform(maskToCanvas, [
            1,
            0,
            0,
            1,
            0,
            -height
        ]);
        const [minX, minY, maxX, maxY] = $cca4aceb320d03d3$var$Util.getAxialAlignedBoundingBox([
            0,
            0,
            width,
            height
        ], maskToCanvas);
        const drawnWidth = Math.round(maxX - minX) || 1;
        const drawnHeight = Math.round(maxY - minY) || 1;
        const fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
        const fillCtx = fillCanvas.context;
        const offsetX = minX;
        const offsetY = minY;
        fillCtx.translate(-offsetX, -offsetY);
        fillCtx.transform(...maskToCanvas);
        if (!scaled) {
            scaled = this._scaleImage(maskCanvas.canvas, $cca4aceb320d03d3$var$getCurrentTransformInverse(fillCtx));
            scaled = scaled.img;
            if (cache && isPatternFill) cache.set(cacheKey, scaled);
        }
        fillCtx.imageSmoothingEnabled = $cca4aceb320d03d3$var$getImageSmoothingEnabled($cca4aceb320d03d3$var$getCurrentTransform(fillCtx), img.interpolate);
        $cca4aceb320d03d3$var$drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
        fillCtx.globalCompositeOperation = "source-in";
        const inverse = $cca4aceb320d03d3$var$Util.transform($cca4aceb320d03d3$var$getCurrentTransformInverse(fillCtx), [
            1,
            0,
            0,
            1,
            -offsetX,
            -offsetY
        ]);
        fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, $cca4aceb320d03d3$var$PathType.FILL) : fillColor;
        fillCtx.fillRect(0, 0, width, height);
        if (cache && !isPatternFill) {
            this.cachedCanvases.delete("fillCanvas");
            cache.set(cacheKey, fillCanvas.canvas);
        }
        return {
            canvas: fillCanvas.canvas,
            offsetX: Math.round(offsetX),
            offsetY: Math.round(offsetY)
        };
    }
    setLineWidth(width) {
        if (width !== this.current.lineWidth) this._cachedScaleForStroking[0] = -1;
        this.current.lineWidth = width;
        this.ctx.lineWidth = width;
    }
    setLineCap(style) {
        this.ctx.lineCap = $cca4aceb320d03d3$var$LINE_CAP_STYLES[style];
    }
    setLineJoin(style) {
        this.ctx.lineJoin = $cca4aceb320d03d3$var$LINE_JOIN_STYLES[style];
    }
    setMiterLimit(limit) {
        this.ctx.miterLimit = limit;
    }
    setDash(dashArray, dashPhase) {
        const ctx = this.ctx;
        if (ctx.setLineDash !== undefined) {
            ctx.setLineDash(dashArray);
            ctx.lineDashOffset = dashPhase;
        }
    }
    setRenderingIntent(intent) {}
    setFlatness(flatness) {}
    setGState(states) {
        for (const [key, value] of states)switch(key){
            case "LW":
                this.setLineWidth(value);
                break;
            case "LC":
                this.setLineCap(value);
                break;
            case "LJ":
                this.setLineJoin(value);
                break;
            case "ML":
                this.setMiterLimit(value);
                break;
            case "D":
                this.setDash(value[0], value[1]);
                break;
            case "RI":
                this.setRenderingIntent(value);
                break;
            case "FL":
                this.setFlatness(value);
                break;
            case "Font":
                this.setFont(value[0], value[1]);
                break;
            case "CA":
                this.current.strokeAlpha = value;
                break;
            case "ca":
                this.current.fillAlpha = value;
                this.ctx.globalAlpha = value;
                break;
            case "BM":
                this.ctx.globalCompositeOperation = value;
                break;
            case "SMask":
                this.current.activeSMask = value ? this.tempSMask : null;
                this.tempSMask = null;
                this.checkSMaskState();
                break;
            case "TR":
                this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                break;
        }
    }
    get inSMaskMode() {
        return !!this.suspendedCtx;
    }
    checkSMaskState() {
        const inSMaskMode = this.inSMaskMode;
        if (this.current.activeSMask && !inSMaskMode) this.beginSMaskMode();
        else if (!this.current.activeSMask && inSMaskMode) this.endSMaskMode();
    }
    beginSMaskMode() {
        if (this.inSMaskMode) throw new Error("beginSMaskMode called while already in smask mode");
        const drawnWidth = this.ctx.canvas.width;
        const drawnHeight = this.ctx.canvas.height;
        const cacheId = "smaskGroupAt" + this.groupLevel;
        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
        this.suspendedCtx = this.ctx;
        this.ctx = scratchCanvas.context;
        const ctx = this.ctx;
        ctx.setTransform(...$cca4aceb320d03d3$var$getCurrentTransform(this.suspendedCtx));
        $cca4aceb320d03d3$var$copyCtxState(this.suspendedCtx, ctx);
        $cca4aceb320d03d3$var$mirrorContextOperations(ctx, this.suspendedCtx);
        this.setGState([
            [
                "BM",
                "source-over"
            ],
            [
                "ca",
                1
            ],
            [
                "CA",
                1
            ]
        ]);
    }
    endSMaskMode() {
        if (!this.inSMaskMode) throw new Error("endSMaskMode called while not in smask mode");
        this.ctx._removeMirroring();
        $cca4aceb320d03d3$var$copyCtxState(this.ctx, this.suspendedCtx);
        this.ctx = this.suspendedCtx;
        this.suspendedCtx = null;
    }
    compose(dirtyBox) {
        if (!this.current.activeSMask) return;
        if (!dirtyBox) dirtyBox = [
            0,
            0,
            this.ctx.canvas.width,
            this.ctx.canvas.height
        ];
        else {
            dirtyBox[0] = Math.floor(dirtyBox[0]);
            dirtyBox[1] = Math.floor(dirtyBox[1]);
            dirtyBox[2] = Math.ceil(dirtyBox[2]);
            dirtyBox[3] = Math.ceil(dirtyBox[3]);
        }
        const smask = this.current.activeSMask;
        const suspendedCtx = this.suspendedCtx;
        this.composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        this.ctx.restore();
    }
    composeSMask(ctx, smask, layerCtx, layerBox) {
        const layerOffsetX = layerBox[0];
        const layerOffsetY = layerBox[1];
        const layerWidth = layerBox[2] - layerOffsetX;
        const layerHeight = layerBox[3] - layerOffsetY;
        if (layerWidth === 0 || layerHeight === 0) return;
        this.genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
        ctx.save();
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = "source-over";
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(layerCtx.canvas, 0, 0);
        ctx.restore();
    }
    genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
        let maskCanvas = maskCtx.canvas;
        let maskX = layerOffsetX - maskOffsetX;
        let maskY = layerOffsetY - maskOffsetY;
        if (backdrop) {
            if (maskX < 0 || maskY < 0 || maskX + width > maskCanvas.width || maskY + height > maskCanvas.height) {
                const canvas = this.cachedCanvases.getCanvas("maskExtension", width, height);
                const ctx = canvas.context;
                ctx.drawImage(maskCanvas, -maskX, -maskY);
                if (backdrop.some((c)=>c !== 0)) {
                    ctx.globalCompositeOperation = "destination-atop";
                    ctx.fillStyle = $cca4aceb320d03d3$var$Util.makeHexColor(...backdrop);
                    ctx.fillRect(0, 0, width, height);
                    ctx.globalCompositeOperation = "source-over";
                }
                maskCanvas = canvas.canvas;
                maskX = maskY = 0;
            } else if (backdrop.some((c)=>c !== 0)) {
                maskCtx.save();
                maskCtx.globalAlpha = 1;
                maskCtx.setTransform(1, 0, 0, 1, 0, 0);
                const clip = new Path2D();
                clip.rect(maskX, maskY, width, height);
                maskCtx.clip(clip);
                maskCtx.globalCompositeOperation = "destination-atop";
                maskCtx.fillStyle = $cca4aceb320d03d3$var$Util.makeHexColor(...backdrop);
                maskCtx.fillRect(maskX, maskY, width, height);
                maskCtx.restore();
            }
        }
        layerCtx.save();
        layerCtx.globalAlpha = 1;
        layerCtx.setTransform(1, 0, 0, 1, 0, 0);
        if (subtype === "Alpha" && transferMap) layerCtx.filter = this.filterFactory.addAlphaFilter(transferMap);
        else if (subtype === "Luminosity") layerCtx.filter = this.filterFactory.addLuminosityFilter(transferMap);
        const clip = new Path2D();
        clip.rect(layerOffsetX, layerOffsetY, width, height);
        layerCtx.clip(clip);
        layerCtx.globalCompositeOperation = "destination-in";
        layerCtx.drawImage(maskCanvas, maskX, maskY, width, height, layerOffsetX, layerOffsetY, width, height);
        layerCtx.restore();
    }
    save() {
        if (this.inSMaskMode) {
            $cca4aceb320d03d3$var$copyCtxState(this.ctx, this.suspendedCtx);
            this.suspendedCtx.save();
        } else this.ctx.save();
        const old = this.current;
        this.stateStack.push(old);
        this.current = old.clone();
    }
    restore() {
        if (this.stateStack.length === 0 && this.inSMaskMode) this.endSMaskMode();
        if (this.stateStack.length !== 0) {
            this.current = this.stateStack.pop();
            if (this.inSMaskMode) {
                this.suspendedCtx.restore();
                $cca4aceb320d03d3$var$copyCtxState(this.suspendedCtx, this.ctx);
            } else this.ctx.restore();
            this.checkSMaskState();
            this.pendingClip = null;
            this._cachedScaleForStroking[0] = -1;
            this._cachedGetSinglePixelWidth = null;
        }
    }
    transform(a, b, c, d, e, f) {
        this.ctx.transform(a, b, c, d, e, f);
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
    }
    constructPath(ops, args, minMax) {
        const ctx = this.ctx;
        const current = this.current;
        let x = current.x, y = current.y;
        let startX, startY;
        const currentTransform = $cca4aceb320d03d3$var$getCurrentTransform(ctx);
        const isScalingMatrix = currentTransform[0] === 0 && currentTransform[3] === 0 || currentTransform[1] === 0 && currentTransform[2] === 0;
        const minMaxForBezier = isScalingMatrix ? minMax.slice(0) : null;
        for(let i = 0, j = 0, ii = ops.length; i < ii; i++)switch(ops[i] | 0){
            case $cca4aceb320d03d3$var$OPS.rectangle:
                x = args[j++];
                y = args[j++];
                const width = args[j++];
                const height = args[j++];
                const xw = x + width;
                const yh = y + height;
                ctx.moveTo(x, y);
                if (width === 0 || height === 0) ctx.lineTo(xw, yh);
                else {
                    ctx.lineTo(xw, y);
                    ctx.lineTo(xw, yh);
                    ctx.lineTo(x, yh);
                }
                if (!isScalingMatrix) current.updateRectMinMax(currentTransform, [
                    x,
                    y,
                    xw,
                    yh
                ]);
                ctx.closePath();
                break;
            case $cca4aceb320d03d3$var$OPS.moveTo:
                x = args[j++];
                y = args[j++];
                ctx.moveTo(x, y);
                if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                break;
            case $cca4aceb320d03d3$var$OPS.lineTo:
                x = args[j++];
                y = args[j++];
                ctx.lineTo(x, y);
                if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                break;
            case $cca4aceb320d03d3$var$OPS.curveTo:
                startX = x;
                startY = y;
                x = args[j + 4];
                y = args[j + 5];
                ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], args[j + 2], args[j + 3], x, y, minMaxForBezier);
                j += 6;
                break;
            case $cca4aceb320d03d3$var$OPS.curveTo2:
                startX = x;
                startY = y;
                ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                current.updateCurvePathMinMax(currentTransform, startX, startY, x, y, args[j], args[j + 1], args[j + 2], args[j + 3], minMaxForBezier);
                x = args[j + 2];
                y = args[j + 3];
                j += 4;
                break;
            case $cca4aceb320d03d3$var$OPS.curveTo3:
                startX = x;
                startY = y;
                x = args[j + 2];
                y = args[j + 3];
                ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
                current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], x, y, x, y, minMaxForBezier);
                j += 4;
                break;
            case $cca4aceb320d03d3$var$OPS.closePath:
                ctx.closePath();
                break;
        }
        if (isScalingMatrix) current.updateScalingPathMinMax(currentTransform, minMaxForBezier);
        current.setCurrentPoint(x, y);
    }
    closePath() {
        this.ctx.closePath();
    }
    stroke(consumePath = true) {
        const ctx = this.ctx;
        const strokeColor = this.current.strokeColor;
        ctx.globalAlpha = this.current.strokeAlpha;
        if (this.contentVisible) {
            if (typeof strokeColor === "object" && strokeColor?.getPattern) {
                ctx.save();
                ctx.strokeStyle = strokeColor.getPattern(ctx, this, $cca4aceb320d03d3$var$getCurrentTransformInverse(ctx), $cca4aceb320d03d3$var$PathType.STROKE);
                this.rescaleAndStroke(false);
                ctx.restore();
            } else this.rescaleAndStroke(true);
        }
        if (consumePath) this.consumePath(this.current.getClippedPathBoundingBox());
        ctx.globalAlpha = this.current.fillAlpha;
    }
    closeStroke() {
        this.closePath();
        this.stroke();
    }
    fill(consumePath = true) {
        const ctx = this.ctx;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        let needRestore = false;
        if (isPatternFill) {
            ctx.save();
            ctx.fillStyle = fillColor.getPattern(ctx, this, $cca4aceb320d03d3$var$getCurrentTransformInverse(ctx), $cca4aceb320d03d3$var$PathType.FILL);
            needRestore = true;
        }
        const intersect = this.current.getClippedPathBoundingBox();
        if (this.contentVisible && intersect !== null) {
            if (this.pendingEOFill) {
                ctx.fill("evenodd");
                this.pendingEOFill = false;
            } else ctx.fill();
        }
        if (needRestore) ctx.restore();
        if (consumePath) this.consumePath(intersect);
    }
    eoFill() {
        this.pendingEOFill = true;
        this.fill();
    }
    fillStroke() {
        this.fill(false);
        this.stroke(false);
        this.consumePath();
    }
    eoFillStroke() {
        this.pendingEOFill = true;
        this.fillStroke();
    }
    closeFillStroke() {
        this.closePath();
        this.fillStroke();
    }
    closeEOFillStroke() {
        this.pendingEOFill = true;
        this.closePath();
        this.fillStroke();
    }
    endPath() {
        this.consumePath();
    }
    clip() {
        this.pendingClip = $cca4aceb320d03d3$var$NORMAL_CLIP;
    }
    eoClip() {
        this.pendingClip = $cca4aceb320d03d3$var$EO_CLIP;
    }
    beginText() {
        this.current.textMatrix = $cca4aceb320d03d3$var$IDENTITY_MATRIX;
        this.current.textMatrixScale = 1;
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
    }
    endText() {
        const paths = this.pendingTextPaths;
        const ctx = this.ctx;
        if (paths === undefined) {
            ctx.beginPath();
            return;
        }
        ctx.save();
        ctx.beginPath();
        for (const path of paths){
            ctx.setTransform(...path.transform);
            ctx.translate(path.x, path.y);
            path.addToPath(ctx, path.fontSize);
        }
        ctx.restore();
        ctx.clip();
        ctx.beginPath();
        delete this.pendingTextPaths;
    }
    setCharSpacing(spacing) {
        this.current.charSpacing = spacing;
    }
    setWordSpacing(spacing) {
        this.current.wordSpacing = spacing;
    }
    setHScale(scale) {
        this.current.textHScale = scale / 100;
    }
    setLeading(leading) {
        this.current.leading = -leading;
    }
    setFont(fontRefName, size) {
        const fontObj = this.commonObjs.get(fontRefName);
        const current = this.current;
        if (!fontObj) throw new Error(`Can't find font for ${fontRefName}`);
        current.fontMatrix = fontObj.fontMatrix || $cca4aceb320d03d3$var$FONT_IDENTITY_MATRIX;
        if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) $cca4aceb320d03d3$var$warn("Invalid font matrix for font " + fontRefName);
        if (size < 0) {
            size = -size;
            current.fontDirection = -1;
        } else current.fontDirection = 1;
        this.current.font = fontObj;
        this.current.fontSize = size;
        if (fontObj.isType3Font) return;
        const name = fontObj.loadedName || "sans-serif";
        const typeface = fontObj.systemFontInfo?.css || `"${name}", ${fontObj.fallbackName}`;
        let bold = "normal";
        if (fontObj.black) bold = "900";
        else if (fontObj.bold) bold = "bold";
        const italic = fontObj.italic ? "italic" : "normal";
        let browserFontSize = size;
        if (size < $cca4aceb320d03d3$var$MIN_FONT_SIZE) browserFontSize = $cca4aceb320d03d3$var$MIN_FONT_SIZE;
        else if (size > $cca4aceb320d03d3$var$MAX_FONT_SIZE) browserFontSize = $cca4aceb320d03d3$var$MAX_FONT_SIZE;
        this.current.fontSizeScale = size / browserFontSize;
        this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
    }
    setTextRenderingMode(mode) {
        this.current.textRenderingMode = mode;
    }
    setTextRise(rise) {
        this.current.textRise = rise;
    }
    moveText(x, y) {
        this.current.x = this.current.lineX += x;
        this.current.y = this.current.lineY += y;
    }
    setLeadingMoveText(x, y) {
        this.setLeading(-y);
        this.moveText(x, y);
    }
    setTextMatrix(a, b, c, d, e, f) {
        this.current.textMatrix = [
            a,
            b,
            c,
            d,
            e,
            f
        ];
        this.current.textMatrixScale = Math.hypot(a, b);
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
    }
    nextLine() {
        this.moveText(0, this.current.leading);
    }
    paintChar(character, x, y, patternTransform) {
        const ctx = this.ctx;
        const current = this.current;
        const font = current.font;
        const textRenderingMode = current.textRenderingMode;
        const fontSize = current.fontSize / current.fontSizeScale;
        const fillStrokeMode = textRenderingMode & $cca4aceb320d03d3$var$TextRenderingMode.FILL_STROKE_MASK;
        const isAddToPathSet = !!(textRenderingMode & $cca4aceb320d03d3$var$TextRenderingMode.ADD_TO_PATH_FLAG);
        const patternFill = current.patternFill && !font.missingFile;
        let addToPath;
        if (font.disableFontFace || isAddToPathSet || patternFill) addToPath = font.getPathGenerator(this.commonObjs, character);
        if (font.disableFontFace || patternFill) {
            ctx.save();
            ctx.translate(x, y);
            ctx.beginPath();
            addToPath(ctx, fontSize);
            if (patternTransform) ctx.setTransform(...patternTransform);
            if (fillStrokeMode === $cca4aceb320d03d3$var$TextRenderingMode.FILL || fillStrokeMode === $cca4aceb320d03d3$var$TextRenderingMode.FILL_STROKE) ctx.fill();
            if (fillStrokeMode === $cca4aceb320d03d3$var$TextRenderingMode.STROKE || fillStrokeMode === $cca4aceb320d03d3$var$TextRenderingMode.FILL_STROKE) ctx.stroke();
            ctx.restore();
        } else {
            if (fillStrokeMode === $cca4aceb320d03d3$var$TextRenderingMode.FILL || fillStrokeMode === $cca4aceb320d03d3$var$TextRenderingMode.FILL_STROKE) ctx.fillText(character, x, y);
            if (fillStrokeMode === $cca4aceb320d03d3$var$TextRenderingMode.STROKE || fillStrokeMode === $cca4aceb320d03d3$var$TextRenderingMode.FILL_STROKE) ctx.strokeText(character, x, y);
        }
        if (isAddToPathSet) {
            const paths = this.pendingTextPaths ||= [];
            paths.push({
                transform: $cca4aceb320d03d3$var$getCurrentTransform(ctx),
                x: x,
                y: y,
                fontSize: fontSize,
                addToPath: addToPath
            });
        }
    }
    get isFontSubpixelAAEnabled() {
        const { context: ctx } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
        ctx.scale(1.5, 1);
        ctx.fillText("I", 0, 10);
        const data = ctx.getImageData(0, 0, 10, 10).data;
        let enabled = false;
        for(let i = 3; i < data.length; i += 4)if (data[i] > 0 && data[i] < 255) {
            enabled = true;
            break;
        }
        return $cca4aceb320d03d3$var$shadow(this, "isFontSubpixelAAEnabled", enabled);
    }
    showText(glyphs) {
        const current = this.current;
        const font = current.font;
        if (font.isType3Font) return this.showType3Text(glyphs);
        const fontSize = current.fontSize;
        if (fontSize === 0) return undefined;
        const ctx = this.ctx;
        const fontSizeScale = current.fontSizeScale;
        const charSpacing = current.charSpacing;
        const wordSpacing = current.wordSpacing;
        const fontDirection = current.fontDirection;
        const textHScale = current.textHScale * fontDirection;
        const glyphsLength = glyphs.length;
        const vertical = font.vertical;
        const spacingDir = vertical ? 1 : -1;
        const defaultVMetrics = font.defaultVMetrics;
        const widthAdvanceScale = fontSize * current.fontMatrix[0];
        const simpleFillText = current.textRenderingMode === $cca4aceb320d03d3$var$TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
        ctx.save();
        ctx.transform(...current.textMatrix);
        ctx.translate(current.x, current.y + current.textRise);
        if (fontDirection > 0) ctx.scale(textHScale, -1);
        else ctx.scale(textHScale, 1);
        let patternTransform;
        if (current.patternFill) {
            ctx.save();
            const pattern = current.fillColor.getPattern(ctx, this, $cca4aceb320d03d3$var$getCurrentTransformInverse(ctx), $cca4aceb320d03d3$var$PathType.FILL);
            patternTransform = $cca4aceb320d03d3$var$getCurrentTransform(ctx);
            ctx.restore();
            ctx.fillStyle = pattern;
        }
        let lineWidth = current.lineWidth;
        const scale = current.textMatrixScale;
        if (scale === 0 || lineWidth === 0) {
            const fillStrokeMode = current.textRenderingMode & $cca4aceb320d03d3$var$TextRenderingMode.FILL_STROKE_MASK;
            if (fillStrokeMode === $cca4aceb320d03d3$var$TextRenderingMode.STROKE || fillStrokeMode === $cca4aceb320d03d3$var$TextRenderingMode.FILL_STROKE) lineWidth = this.getSinglePixelWidth();
        } else lineWidth /= scale;
        if (fontSizeScale !== 1.0) {
            ctx.scale(fontSizeScale, fontSizeScale);
            lineWidth /= fontSizeScale;
        }
        ctx.lineWidth = lineWidth;
        if (font.isInvalidPDFjsFont) {
            const chars = [];
            let width = 0;
            for (const glyph of glyphs){
                chars.push(glyph.unicode);
                width += glyph.width;
            }
            ctx.fillText(chars.join(""), 0, 0);
            current.x += width * widthAdvanceScale * textHScale;
            ctx.restore();
            this.compose();
            return undefined;
        }
        let x = 0, i;
        for(i = 0; i < glyphsLength; ++i){
            const glyph = glyphs[i];
            if (typeof glyph === "number") {
                x += spacingDir * glyph * fontSize / 1000;
                continue;
            }
            let restoreNeeded = false;
            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            const character = glyph.fontChar;
            const accent = glyph.accent;
            let scaledX, scaledY;
            let width = glyph.width;
            if (vertical) {
                const vmetric = glyph.vmetric || defaultVMetrics;
                const vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                const vy = vmetric[2] * widthAdvanceScale;
                width = vmetric ? -vmetric[0] : width;
                scaledX = vx / fontSizeScale;
                scaledY = (x + vy) / fontSizeScale;
            } else {
                scaledX = x / fontSizeScale;
                scaledY = 0;
            }
            if (font.remeasure && width > 0) {
                const measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
                if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                    const characterScaleX = width / measuredWidth;
                    restoreNeeded = true;
                    ctx.save();
                    ctx.scale(characterScaleX, 1);
                    scaledX /= characterScaleX;
                } else if (width !== measuredWidth) scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
            }
            if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                if (simpleFillText && !accent) ctx.fillText(character, scaledX, scaledY);
                else {
                    this.paintChar(character, scaledX, scaledY, patternTransform);
                    if (accent) {
                        const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                        const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                        this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
                    }
                }
            }
            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
            x += charWidth;
            if (restoreNeeded) ctx.restore();
        }
        if (vertical) current.y -= x;
        else current.x += x * textHScale;
        ctx.restore();
        this.compose();
        return undefined;
    }
    showType3Text(glyphs) {
        const ctx = this.ctx;
        const current = this.current;
        const font = current.font;
        const fontSize = current.fontSize;
        const fontDirection = current.fontDirection;
        const spacingDir = font.vertical ? 1 : -1;
        const charSpacing = current.charSpacing;
        const wordSpacing = current.wordSpacing;
        const textHScale = current.textHScale * fontDirection;
        const fontMatrix = current.fontMatrix || $cca4aceb320d03d3$var$FONT_IDENTITY_MATRIX;
        const glyphsLength = glyphs.length;
        const isTextInvisible = current.textRenderingMode === $cca4aceb320d03d3$var$TextRenderingMode.INVISIBLE;
        let i, glyph, width, spacingLength;
        if (isTextInvisible || fontSize === 0) return;
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
        ctx.save();
        ctx.transform(...current.textMatrix);
        ctx.translate(current.x, current.y);
        ctx.scale(textHScale, fontDirection);
        for(i = 0; i < glyphsLength; ++i){
            glyph = glyphs[i];
            if (typeof glyph === "number") {
                spacingLength = spacingDir * glyph * fontSize / 1000;
                this.ctx.translate(spacingLength, 0);
                current.x += spacingLength * textHScale;
                continue;
            }
            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            const operatorList = font.charProcOperatorList[glyph.operatorListId];
            if (!operatorList) {
                $cca4aceb320d03d3$var$warn(`Type3 character "${glyph.operatorListId}" is not available.`);
                continue;
            }
            if (this.contentVisible) {
                this.processingType3 = glyph;
                this.save();
                ctx.scale(fontSize, fontSize);
                ctx.transform(...fontMatrix);
                this.executeOperatorList(operatorList);
                this.restore();
            }
            const transformed = $cca4aceb320d03d3$var$Util.applyTransform([
                glyph.width,
                0
            ], fontMatrix);
            width = transformed[0] * fontSize + spacing;
            ctx.translate(width, 0);
            current.x += width * textHScale;
        }
        ctx.restore();
        this.processingType3 = null;
    }
    setCharWidth(xWidth, yWidth) {}
    setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
        this.ctx.rect(llx, lly, urx - llx, ury - lly);
        this.ctx.clip();
        this.endPath();
    }
    getColorN_Pattern(IR) {
        let pattern;
        if (IR[0] === "TilingPattern") {
            const color = IR[1];
            const baseTransform = this.baseTransform || $cca4aceb320d03d3$var$getCurrentTransform(this.ctx);
            const canvasGraphicsFactory = {
                createCanvasGraphics: (ctx)=>new $cca4aceb320d03d3$var$CanvasGraphics(ctx, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                        optionalContentConfig: this.optionalContentConfig,
                        markedContentStack: this.markedContentStack
                    })
            };
            pattern = new $cca4aceb320d03d3$var$TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
        } else pattern = this._getPattern(IR[1], IR[2]);
        return pattern;
    }
    setStrokeColorN() {
        this.current.strokeColor = this.getColorN_Pattern(arguments);
    }
    setFillColorN() {
        this.current.fillColor = this.getColorN_Pattern(arguments);
        this.current.patternFill = true;
    }
    setStrokeRGBColor(r, g, b) {
        const color = $cca4aceb320d03d3$var$Util.makeHexColor(r, g, b);
        this.ctx.strokeStyle = color;
        this.current.strokeColor = color;
    }
    setFillRGBColor(r, g, b) {
        const color = $cca4aceb320d03d3$var$Util.makeHexColor(r, g, b);
        this.ctx.fillStyle = color;
        this.current.fillColor = color;
        this.current.patternFill = false;
    }
    _getPattern(objId, matrix = null) {
        let pattern;
        if (this.cachedPatterns.has(objId)) pattern = this.cachedPatterns.get(objId);
        else {
            pattern = $cca4aceb320d03d3$var$getShadingPattern(this.getObject(objId));
            this.cachedPatterns.set(objId, pattern);
        }
        if (matrix) pattern.matrix = matrix;
        return pattern;
    }
    shadingFill(objId) {
        if (!this.contentVisible) return;
        const ctx = this.ctx;
        this.save();
        const pattern = this._getPattern(objId);
        ctx.fillStyle = pattern.getPattern(ctx, this, $cca4aceb320d03d3$var$getCurrentTransformInverse(ctx), $cca4aceb320d03d3$var$PathType.SHADING);
        const inv = $cca4aceb320d03d3$var$getCurrentTransformInverse(ctx);
        if (inv) {
            const { width: width, height: height } = ctx.canvas;
            const [x0, y0, x1, y1] = $cca4aceb320d03d3$var$Util.getAxialAlignedBoundingBox([
                0,
                0,
                width,
                height
            ], inv);
            this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
        } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
        this.compose(this.current.getClippedPathBoundingBox());
        this.restore();
    }
    beginInlineImage() {
        $cca4aceb320d03d3$var$unreachable("Should not call beginInlineImage");
    }
    beginImageData() {
        $cca4aceb320d03d3$var$unreachable("Should not call beginImageData");
    }
    paintFormXObjectBegin(matrix, bbox) {
        if (!this.contentVisible) return;
        this.save();
        this.baseTransformStack.push(this.baseTransform);
        if (matrix) this.transform(...matrix);
        this.baseTransform = $cca4aceb320d03d3$var$getCurrentTransform(this.ctx);
        if (bbox) {
            const width = bbox[2] - bbox[0];
            const height = bbox[3] - bbox[1];
            this.ctx.rect(bbox[0], bbox[1], width, height);
            this.current.updateRectMinMax($cca4aceb320d03d3$var$getCurrentTransform(this.ctx), bbox);
            this.clip();
            this.endPath();
        }
    }
    paintFormXObjectEnd() {
        if (!this.contentVisible) return;
        this.restore();
        this.baseTransform = this.baseTransformStack.pop();
    }
    beginGroup(group) {
        if (!this.contentVisible) return;
        this.save();
        if (this.inSMaskMode) {
            this.endSMaskMode();
            this.current.activeSMask = null;
        }
        const currentCtx = this.ctx;
        if (!group.isolated) $cca4aceb320d03d3$var$info("TODO: Support non-isolated groups.");
        if (group.knockout) $cca4aceb320d03d3$var$warn("Knockout groups not supported.");
        const currentTransform = $cca4aceb320d03d3$var$getCurrentTransform(currentCtx);
        if (group.matrix) currentCtx.transform(...group.matrix);
        if (!group.bbox) throw new Error("Bounding box is required.");
        let bounds = $cca4aceb320d03d3$var$Util.getAxialAlignedBoundingBox(group.bbox, $cca4aceb320d03d3$var$getCurrentTransform(currentCtx));
        const canvasBounds = [
            0,
            0,
            currentCtx.canvas.width,
            currentCtx.canvas.height
        ];
        bounds = $cca4aceb320d03d3$var$Util.intersect(bounds, canvasBounds) || [
            0,
            0,
            0,
            0
        ];
        const offsetX = Math.floor(bounds[0]);
        const offsetY = Math.floor(bounds[1]);
        const drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
        const drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
        this.current.startNewPathAndClipBox([
            0,
            0,
            drawnWidth,
            drawnHeight
        ]);
        let cacheId = "groupAt" + this.groupLevel;
        if (group.smask) cacheId += "_smask_" + this.smaskCounter++ % 2;
        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
        const groupCtx = scratchCanvas.context;
        groupCtx.translate(-offsetX, -offsetY);
        groupCtx.transform(...currentTransform);
        if (group.smask) this.smaskStack.push({
            canvas: scratchCanvas.canvas,
            context: groupCtx,
            offsetX: offsetX,
            offsetY: offsetY,
            subtype: group.smask.subtype,
            backdrop: group.smask.backdrop,
            transferMap: group.smask.transferMap || null,
            startTransformInverse: null
        });
        else {
            currentCtx.setTransform(1, 0, 0, 1, 0, 0);
            currentCtx.translate(offsetX, offsetY);
            currentCtx.save();
        }
        $cca4aceb320d03d3$var$copyCtxState(currentCtx, groupCtx);
        this.ctx = groupCtx;
        this.setGState([
            [
                "BM",
                "source-over"
            ],
            [
                "ca",
                1
            ],
            [
                "CA",
                1
            ]
        ]);
        this.groupStack.push(currentCtx);
        this.groupLevel++;
    }
    endGroup(group) {
        if (!this.contentVisible) return;
        this.groupLevel--;
        const groupCtx = this.ctx;
        const ctx = this.groupStack.pop();
        this.ctx = ctx;
        this.ctx.imageSmoothingEnabled = false;
        if (group.smask) {
            this.tempSMask = this.smaskStack.pop();
            this.restore();
        } else {
            this.ctx.restore();
            const currentMtx = $cca4aceb320d03d3$var$getCurrentTransform(this.ctx);
            this.restore();
            this.ctx.save();
            this.ctx.setTransform(...currentMtx);
            const dirtyBox = $cca4aceb320d03d3$var$Util.getAxialAlignedBoundingBox([
                0,
                0,
                groupCtx.canvas.width,
                groupCtx.canvas.height
            ], currentMtx);
            this.ctx.drawImage(groupCtx.canvas, 0, 0);
            this.ctx.restore();
            this.compose(dirtyBox);
        }
    }
    beginAnnotation(id, rect, transform, matrix, hasOwnCanvas) {
        this.#restoreInitialState();
        $cca4aceb320d03d3$var$resetCtxToDefault(this.ctx);
        this.ctx.save();
        this.save();
        if (this.baseTransform) this.ctx.setTransform(...this.baseTransform);
        if (rect) {
            const width = rect[2] - rect[0];
            const height = rect[3] - rect[1];
            if (hasOwnCanvas && this.annotationCanvasMap) {
                transform = transform.slice();
                transform[4] -= rect[0];
                transform[5] -= rect[1];
                rect = rect.slice();
                rect[0] = rect[1] = 0;
                rect[2] = width;
                rect[3] = height;
                const [scaleX, scaleY] = $cca4aceb320d03d3$var$Util.singularValueDecompose2dScale($cca4aceb320d03d3$var$getCurrentTransform(this.ctx));
                const { viewportScale: viewportScale } = this;
                const canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                const canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                const { canvas: canvas, context: context } = this.annotationCanvas;
                this.annotationCanvasMap.set(id, canvas);
                this.annotationCanvas.savedCtx = this.ctx;
                this.ctx = context;
                this.ctx.save();
                this.ctx.setTransform(scaleX, 0, 0, -scaleY, 0, height * scaleY);
                $cca4aceb320d03d3$var$resetCtxToDefault(this.ctx);
            } else {
                $cca4aceb320d03d3$var$resetCtxToDefault(this.ctx);
                this.ctx.rect(rect[0], rect[1], width, height);
                this.ctx.clip();
                this.endPath();
            }
        }
        this.current = new $cca4aceb320d03d3$var$CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
        this.transform(...transform);
        this.transform(...matrix);
    }
    endAnnotation() {
        if (this.annotationCanvas) {
            this.ctx.restore();
            this.#drawFilter();
            this.ctx = this.annotationCanvas.savedCtx;
            delete this.annotationCanvas.savedCtx;
            delete this.annotationCanvas;
        }
    }
    paintImageMaskXObject(img) {
        if (!this.contentVisible) return;
        const count = img.count;
        img = this.getObject(img.data, img);
        img.count = count;
        const ctx = this.ctx;
        const glyph = this.processingType3;
        if (glyph) {
            if (glyph.compiled === undefined) glyph.compiled = $cca4aceb320d03d3$var$compileType3Glyph(img);
            if (glyph.compiled) {
                glyph.compiled(ctx);
                return;
            }
        }
        const mask = this._createMaskCanvas(img);
        const maskCanvas = mask.canvas;
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
        ctx.restore();
        this.compose();
    }
    paintImageMaskXObjectRepeat(img, scaleX, skewX = 0, skewY = 0, scaleY, positions) {
        if (!this.contentVisible) return;
        img = this.getObject(img.data, img);
        const ctx = this.ctx;
        ctx.save();
        const currentTransform = $cca4aceb320d03d3$var$getCurrentTransform(ctx);
        ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
        const mask = this._createMaskCanvas(img);
        ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
        for(let i = 0, ii = positions.length; i < ii; i += 2){
            const trans = $cca4aceb320d03d3$var$Util.transform(currentTransform, [
                scaleX,
                skewX,
                skewY,
                scaleY,
                positions[i],
                positions[i + 1]
            ]);
            const [x, y] = $cca4aceb320d03d3$var$Util.applyTransform([
                0,
                0
            ], trans);
            ctx.drawImage(mask.canvas, x, y);
        }
        ctx.restore();
        this.compose();
    }
    paintImageMaskXObjectGroup(images) {
        if (!this.contentVisible) return;
        const ctx = this.ctx;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        for (const image of images){
            const { data: data, width: width, height: height, transform: transform } = image;
            const maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
            const maskCtx = maskCanvas.context;
            maskCtx.save();
            const img = this.getObject(data, image);
            $cca4aceb320d03d3$var$putBinaryImageMask(maskCtx, img);
            maskCtx.globalCompositeOperation = "source-in";
            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, $cca4aceb320d03d3$var$getCurrentTransformInverse(ctx), $cca4aceb320d03d3$var$PathType.FILL) : fillColor;
            maskCtx.fillRect(0, 0, width, height);
            maskCtx.restore();
            ctx.save();
            ctx.transform(...transform);
            ctx.scale(1, -1);
            $cca4aceb320d03d3$var$drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
            ctx.restore();
        }
        this.compose();
    }
    paintImageXObject(objId) {
        if (!this.contentVisible) return;
        const imgData = this.getObject(objId);
        if (!imgData) {
            $cca4aceb320d03d3$var$warn("Dependent image isn't ready yet");
            return;
        }
        this.paintInlineImageXObject(imgData);
    }
    paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
        if (!this.contentVisible) return;
        const imgData = this.getObject(objId);
        if (!imgData) {
            $cca4aceb320d03d3$var$warn("Dependent image isn't ready yet");
            return;
        }
        const width = imgData.width;
        const height = imgData.height;
        const map = [];
        for(let i = 0, ii = positions.length; i < ii; i += 2)map.push({
            transform: [
                scaleX,
                0,
                0,
                scaleY,
                positions[i],
                positions[i + 1]
            ],
            x: 0,
            y: 0,
            w: width,
            h: height
        });
        this.paintInlineImageXObjectGroup(imgData, map);
    }
    applyTransferMapsToCanvas(ctx) {
        if (this.current.transferMaps !== "none") {
            ctx.filter = this.current.transferMaps;
            ctx.drawImage(ctx.canvas, 0, 0);
            ctx.filter = "none";
        }
        return ctx.canvas;
    }
    applyTransferMapsToBitmap(imgData) {
        if (this.current.transferMaps === "none") return imgData.bitmap;
        const { bitmap: bitmap, width: width, height: height } = imgData;
        const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
        const tmpCtx = tmpCanvas.context;
        tmpCtx.filter = this.current.transferMaps;
        tmpCtx.drawImage(bitmap, 0, 0);
        tmpCtx.filter = "none";
        return tmpCanvas.canvas;
    }
    paintInlineImageXObject(imgData) {
        if (!this.contentVisible) return;
        const width = imgData.width;
        const height = imgData.height;
        const ctx = this.ctx;
        this.save();
        if (!$cca4aceb320d03d3$var$isNodeJS) {
            const { filter: filter } = ctx;
            if (filter !== "none" && filter !== "") ctx.filter = "none";
        }
        ctx.scale(1 / width, -1 / height);
        let imgToPaint;
        if (imgData.bitmap) imgToPaint = this.applyTransferMapsToBitmap(imgData);
        else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) imgToPaint = imgData;
        else {
            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
            const tmpCtx = tmpCanvas.context;
            $cca4aceb320d03d3$var$putBinaryImageData(tmpCtx, imgData);
            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
        }
        const scaled = this._scaleImage(imgToPaint, $cca4aceb320d03d3$var$getCurrentTransformInverse(ctx));
        ctx.imageSmoothingEnabled = $cca4aceb320d03d3$var$getImageSmoothingEnabled($cca4aceb320d03d3$var$getCurrentTransform(ctx), imgData.interpolate);
        $cca4aceb320d03d3$var$drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
        this.compose();
        this.restore();
    }
    paintInlineImageXObjectGroup(imgData, map) {
        if (!this.contentVisible) return;
        const ctx = this.ctx;
        let imgToPaint;
        if (imgData.bitmap) imgToPaint = imgData.bitmap;
        else {
            const w = imgData.width;
            const h = imgData.height;
            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
            const tmpCtx = tmpCanvas.context;
            $cca4aceb320d03d3$var$putBinaryImageData(tmpCtx, imgData);
            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
        }
        for (const entry of map){
            ctx.save();
            ctx.transform(...entry.transform);
            ctx.scale(1, -1);
            $cca4aceb320d03d3$var$drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
            ctx.restore();
        }
        this.compose();
    }
    paintSolidColorImageMask() {
        if (!this.contentVisible) return;
        this.ctx.fillRect(0, 0, 1, 1);
        this.compose();
    }
    markPoint(tag) {}
    markPointProps(tag, properties) {}
    beginMarkedContent(tag) {
        this.markedContentStack.push({
            visible: true
        });
    }
    beginMarkedContentProps(tag, properties) {
        if (tag === "OC") this.markedContentStack.push({
            visible: this.optionalContentConfig.isVisible(properties)
        });
        else this.markedContentStack.push({
            visible: true
        });
        this.contentVisible = this.isContentVisible();
    }
    endMarkedContent() {
        this.markedContentStack.pop();
        this.contentVisible = this.isContentVisible();
    }
    beginCompat() {}
    endCompat() {}
    consumePath(clipBox) {
        const isEmpty = this.current.isEmptyClip();
        if (this.pendingClip) this.current.updateClipFromPath();
        if (!this.pendingClip) this.compose(clipBox);
        const ctx = this.ctx;
        if (this.pendingClip) {
            if (!isEmpty) {
                if (this.pendingClip === $cca4aceb320d03d3$var$EO_CLIP) ctx.clip("evenodd");
                else ctx.clip();
            }
            this.pendingClip = null;
        }
        this.current.startNewPathAndClipBox(this.current.clipBox);
        ctx.beginPath();
    }
    getSinglePixelWidth() {
        if (!this._cachedGetSinglePixelWidth) {
            const m = $cca4aceb320d03d3$var$getCurrentTransform(this.ctx);
            if (m[1] === 0 && m[2] === 0) this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
            else {
                const absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                const normX = Math.hypot(m[0], m[2]);
                const normY = Math.hypot(m[1], m[3]);
                this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
            }
        }
        return this._cachedGetSinglePixelWidth;
    }
    getScaleForStroking() {
        if (this._cachedScaleForStroking[0] === -1) {
            const { lineWidth: lineWidth } = this.current;
            const { a: a, b: b, c: c, d: d } = this.ctx.getTransform();
            let scaleX, scaleY;
            if (b === 0 && c === 0) {
                const normX = Math.abs(a);
                const normY = Math.abs(d);
                if (normX === normY) {
                    if (lineWidth === 0) scaleX = scaleY = 1 / normX;
                    else {
                        const scaledLineWidth = normX * lineWidth;
                        scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                    }
                } else if (lineWidth === 0) {
                    scaleX = 1 / normX;
                    scaleY = 1 / normY;
                } else {
                    const scaledXLineWidth = normX * lineWidth;
                    const scaledYLineWidth = normY * lineWidth;
                    scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                    scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                }
            } else {
                const absDet = Math.abs(a * d - b * c);
                const normX = Math.hypot(a, b);
                const normY = Math.hypot(c, d);
                if (lineWidth === 0) {
                    scaleX = normY / absDet;
                    scaleY = normX / absDet;
                } else {
                    const baseArea = lineWidth * absDet;
                    scaleX = normY > baseArea ? normY / baseArea : 1;
                    scaleY = normX > baseArea ? normX / baseArea : 1;
                }
            }
            this._cachedScaleForStroking[0] = scaleX;
            this._cachedScaleForStroking[1] = scaleY;
        }
        return this._cachedScaleForStroking;
    }
    rescaleAndStroke(saveRestore) {
        const { ctx: ctx } = this;
        const { lineWidth: lineWidth } = this.current;
        const [scaleX, scaleY] = this.getScaleForStroking();
        ctx.lineWidth = lineWidth || 1;
        if (scaleX === 1 && scaleY === 1) {
            ctx.stroke();
            return;
        }
        const dashes = ctx.getLineDash();
        if (saveRestore) ctx.save();
        ctx.scale(scaleX, scaleY);
        if (dashes.length > 0) {
            const scale = Math.max(scaleX, scaleY);
            ctx.setLineDash(dashes.map((x)=>x / scale));
            ctx.lineDashOffset /= scale;
        }
        ctx.stroke();
        if (saveRestore) ctx.restore();
    }
    isContentVisible() {
        for(let i = this.markedContentStack.length - 1; i >= 0; i--){
            if (!this.markedContentStack[i].visible) return false;
        }
        return true;
    }
}
for(const op in $cca4aceb320d03d3$var$OPS)if ($cca4aceb320d03d3$var$CanvasGraphics.prototype[op] !== undefined) $cca4aceb320d03d3$var$CanvasGraphics.prototype[$cca4aceb320d03d3$var$OPS[op]] = $cca4aceb320d03d3$var$CanvasGraphics.prototype[op];
class $cca4aceb320d03d3$var$GlobalWorkerOptions {
    static #port = null;
    static #src = "";
    static get workerPort() {
        return this.#port;
    }
    static set workerPort(val) {
        if (!(typeof Worker !== "undefined" && val instanceof Worker) && val !== null) throw new Error("Invalid `workerPort` type.");
        this.#port = val;
    }
    static get workerSrc() {
        return this.#src;
    }
    static set workerSrc(val) {
        if (typeof val !== "string") throw new Error("Invalid `workerSrc` type.");
        this.#src = val;
    }
}
const $cca4aceb320d03d3$var$CallbackKind = {
    UNKNOWN: 0,
    DATA: 1,
    ERROR: 2
};
const $cca4aceb320d03d3$var$StreamKind = {
    UNKNOWN: 0,
    CANCEL: 1,
    CANCEL_COMPLETE: 2,
    CLOSE: 3,
    ENQUEUE: 4,
    ERROR: 5,
    PULL: 6,
    PULL_COMPLETE: 7,
    START_COMPLETE: 8
};
function $cca4aceb320d03d3$var$wrapReason(reason) {
    if (!(reason instanceof Error || typeof reason === "object" && reason !== null)) $cca4aceb320d03d3$var$unreachable('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
    switch(reason.name){
        case "AbortException":
            return new $cca4aceb320d03d3$var$AbortException(reason.message);
        case "MissingPDFException":
            return new $cca4aceb320d03d3$var$MissingPDFException(reason.message);
        case "PasswordException":
            return new $cca4aceb320d03d3$var$PasswordException(reason.message, reason.code);
        case "UnexpectedResponseException":
            return new $cca4aceb320d03d3$var$UnexpectedResponseException(reason.message, reason.status);
        case "UnknownErrorException":
            return new $cca4aceb320d03d3$var$UnknownErrorException(reason.message, reason.details);
        default:
            return new $cca4aceb320d03d3$var$UnknownErrorException(reason.message, reason.toString());
    }
}
class $cca4aceb320d03d3$var$MessageHandler {
    constructor(sourceName, targetName, comObj){
        this.sourceName = sourceName;
        this.targetName = targetName;
        this.comObj = comObj;
        this.callbackId = 1;
        this.streamId = 1;
        this.streamSinks = Object.create(null);
        this.streamControllers = Object.create(null);
        this.callbackCapabilities = Object.create(null);
        this.actionHandler = Object.create(null);
        this._onComObjOnMessage = (event)=>{
            const data = event.data;
            if (data.targetName !== this.sourceName) return;
            if (data.stream) {
                this.#processStreamMessage(data);
                return;
            }
            if (data.callback) {
                const callbackId = data.callbackId;
                const capability = this.callbackCapabilities[callbackId];
                if (!capability) throw new Error(`Cannot resolve callback ${callbackId}`);
                delete this.callbackCapabilities[callbackId];
                if (data.callback === $cca4aceb320d03d3$var$CallbackKind.DATA) capability.resolve(data.data);
                else if (data.callback === $cca4aceb320d03d3$var$CallbackKind.ERROR) capability.reject($cca4aceb320d03d3$var$wrapReason(data.reason));
                else throw new Error("Unexpected callback case");
                return;
            }
            const action = this.actionHandler[data.action];
            if (!action) throw new Error(`Unknown action from worker: ${data.action}`);
            if (data.callbackId) {
                const cbSourceName = this.sourceName;
                const cbTargetName = data.sourceName;
                new Promise(function(resolve) {
                    resolve(action(data.data));
                }).then(function(result) {
                    comObj.postMessage({
                        sourceName: cbSourceName,
                        targetName: cbTargetName,
                        callback: $cca4aceb320d03d3$var$CallbackKind.DATA,
                        callbackId: data.callbackId,
                        data: result
                    });
                }, function(reason) {
                    comObj.postMessage({
                        sourceName: cbSourceName,
                        targetName: cbTargetName,
                        callback: $cca4aceb320d03d3$var$CallbackKind.ERROR,
                        callbackId: data.callbackId,
                        reason: $cca4aceb320d03d3$var$wrapReason(reason)
                    });
                });
                return;
            }
            if (data.streamId) {
                this.#createStreamSink(data);
                return;
            }
            action(data.data);
        };
        comObj.addEventListener("message", this._onComObjOnMessage);
    }
    on(actionName, handler) {
        const ah = this.actionHandler;
        if (ah[actionName]) throw new Error(`There is already an actionName called "${actionName}"`);
        ah[actionName] = handler;
    }
    send(actionName, data, transfers) {
        this.comObj.postMessage({
            sourceName: this.sourceName,
            targetName: this.targetName,
            action: actionName,
            data: data
        }, transfers);
    }
    sendWithPromise(actionName, data, transfers) {
        const callbackId = this.callbackId++;
        const capability = Promise.withResolvers();
        this.callbackCapabilities[callbackId] = capability;
        try {
            this.comObj.postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: actionName,
                callbackId: callbackId,
                data: data
            }, transfers);
        } catch (ex) {
            capability.reject(ex);
        }
        return capability.promise;
    }
    sendWithStream(actionName, data, queueingStrategy, transfers) {
        const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
        return new ReadableStream({
            start: (controller)=>{
                const startCapability = Promise.withResolvers();
                this.streamControllers[streamId] = {
                    controller: controller,
                    startCall: startCapability,
                    pullCall: null,
                    cancelCall: null,
                    isClosed: false
                };
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    action: actionName,
                    streamId: streamId,
                    data: data,
                    desiredSize: controller.desiredSize
                }, transfers);
                return startCapability.promise;
            },
            pull: (controller)=>{
                const pullCapability = Promise.withResolvers();
                this.streamControllers[streamId].pullCall = pullCapability;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $cca4aceb320d03d3$var$StreamKind.PULL,
                    streamId: streamId,
                    desiredSize: controller.desiredSize
                });
                return pullCapability.promise;
            },
            cancel: (reason)=>{
                $cca4aceb320d03d3$var$assert(reason instanceof Error, "cancel must have a valid reason");
                const cancelCapability = Promise.withResolvers();
                this.streamControllers[streamId].cancelCall = cancelCapability;
                this.streamControllers[streamId].isClosed = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $cca4aceb320d03d3$var$StreamKind.CANCEL,
                    streamId: streamId,
                    reason: $cca4aceb320d03d3$var$wrapReason(reason)
                });
                return cancelCapability.promise;
            }
        }, queueingStrategy);
    }
    #createStreamSink(data) {
        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
        const self = this, action = this.actionHandler[data.action];
        const streamSink = {
            enqueue (chunk, size = 1, transfers) {
                if (this.isCancelled) return;
                const lastDesiredSize = this.desiredSize;
                this.desiredSize -= size;
                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                    this.sinkCapability = Promise.withResolvers();
                    this.ready = this.sinkCapability.promise;
                }
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $cca4aceb320d03d3$var$StreamKind.ENQUEUE,
                    streamId: streamId,
                    chunk: chunk
                }, transfers);
            },
            close () {
                if (this.isCancelled) return;
                this.isCancelled = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $cca4aceb320d03d3$var$StreamKind.CLOSE,
                    streamId: streamId
                });
                delete self.streamSinks[streamId];
            },
            error (reason) {
                $cca4aceb320d03d3$var$assert(reason instanceof Error, "error must have a valid reason");
                if (this.isCancelled) return;
                this.isCancelled = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $cca4aceb320d03d3$var$StreamKind.ERROR,
                    streamId: streamId,
                    reason: $cca4aceb320d03d3$var$wrapReason(reason)
                });
            },
            sinkCapability: Promise.withResolvers(),
            onPull: null,
            onCancel: null,
            isCancelled: false,
            desiredSize: data.desiredSize,
            ready: null
        };
        streamSink.sinkCapability.resolve();
        streamSink.ready = streamSink.sinkCapability.promise;
        this.streamSinks[streamId] = streamSink;
        new Promise(function(resolve) {
            resolve(action(data.data, streamSink));
        }).then(function() {
            comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: $cca4aceb320d03d3$var$StreamKind.START_COMPLETE,
                streamId: streamId,
                success: true
            });
        }, function(reason) {
            comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: $cca4aceb320d03d3$var$StreamKind.START_COMPLETE,
                streamId: streamId,
                reason: $cca4aceb320d03d3$var$wrapReason(reason)
            });
        });
    }
    #processStreamMessage(data) {
        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
        const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
        switch(data.stream){
            case $cca4aceb320d03d3$var$StreamKind.START_COMPLETE:
                if (data.success) streamController.startCall.resolve();
                else streamController.startCall.reject($cca4aceb320d03d3$var$wrapReason(data.reason));
                break;
            case $cca4aceb320d03d3$var$StreamKind.PULL_COMPLETE:
                if (data.success) streamController.pullCall.resolve();
                else streamController.pullCall.reject($cca4aceb320d03d3$var$wrapReason(data.reason));
                break;
            case $cca4aceb320d03d3$var$StreamKind.PULL:
                if (!streamSink) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $cca4aceb320d03d3$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                    break;
                }
                if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                streamSink.desiredSize = data.desiredSize;
                new Promise(function(resolve) {
                    resolve(streamSink.onPull?.());
                }).then(function() {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $cca4aceb320d03d3$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                }, function(reason) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $cca4aceb320d03d3$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        reason: $cca4aceb320d03d3$var$wrapReason(reason)
                    });
                });
                break;
            case $cca4aceb320d03d3$var$StreamKind.ENQUEUE:
                $cca4aceb320d03d3$var$assert(streamController, "enqueue should have stream controller");
                if (streamController.isClosed) break;
                streamController.controller.enqueue(data.chunk);
                break;
            case $cca4aceb320d03d3$var$StreamKind.CLOSE:
                $cca4aceb320d03d3$var$assert(streamController, "close should have stream controller");
                if (streamController.isClosed) break;
                streamController.isClosed = true;
                streamController.controller.close();
                this.#deleteStreamController(streamController, streamId);
                break;
            case $cca4aceb320d03d3$var$StreamKind.ERROR:
                $cca4aceb320d03d3$var$assert(streamController, "error should have stream controller");
                streamController.controller.error($cca4aceb320d03d3$var$wrapReason(data.reason));
                this.#deleteStreamController(streamController, streamId);
                break;
            case $cca4aceb320d03d3$var$StreamKind.CANCEL_COMPLETE:
                if (data.success) streamController.cancelCall.resolve();
                else streamController.cancelCall.reject($cca4aceb320d03d3$var$wrapReason(data.reason));
                this.#deleteStreamController(streamController, streamId);
                break;
            case $cca4aceb320d03d3$var$StreamKind.CANCEL:
                if (!streamSink) break;
                new Promise(function(resolve) {
                    resolve(streamSink.onCancel?.($cca4aceb320d03d3$var$wrapReason(data.reason)));
                }).then(function() {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $cca4aceb320d03d3$var$StreamKind.CANCEL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                }, function(reason) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $cca4aceb320d03d3$var$StreamKind.CANCEL_COMPLETE,
                        streamId: streamId,
                        reason: $cca4aceb320d03d3$var$wrapReason(reason)
                    });
                });
                streamSink.sinkCapability.reject($cca4aceb320d03d3$var$wrapReason(data.reason));
                streamSink.isCancelled = true;
                delete this.streamSinks[streamId];
                break;
            default:
                throw new Error("Unexpected stream case");
        }
    }
    async #deleteStreamController(streamController, streamId) {
        await Promise.allSettled([
            streamController.startCall?.promise,
            streamController.pullCall?.promise,
            streamController.cancelCall?.promise
        ]);
        delete this.streamControllers[streamId];
    }
    destroy() {
        this.comObj.removeEventListener("message", this._onComObjOnMessage);
    }
}
class $cca4aceb320d03d3$var$Metadata {
    #metadataMap;
    #data;
    constructor({ parsedData: parsedData, rawData: rawData }){
        this.#metadataMap = parsedData;
        this.#data = rawData;
    }
    getRaw() {
        return this.#data;
    }
    get(name) {
        return this.#metadataMap.get(name) ?? null;
    }
    getAll() {
        return $cca4aceb320d03d3$var$objectFromMap(this.#metadataMap);
    }
    has(name) {
        return this.#metadataMap.has(name);
    }
}
const $cca4aceb320d03d3$var$INTERNAL = Symbol("INTERNAL");
class $cca4aceb320d03d3$var$OptionalContentGroup {
    #isDisplay = false;
    #isPrint = false;
    #userSet = false;
    #visible = true;
    constructor(renderingIntent, { name: name, intent: intent, usage: usage }){
        this.#isDisplay = !!(renderingIntent & $cca4aceb320d03d3$var$RenderingIntentFlag.DISPLAY);
        this.#isPrint = !!(renderingIntent & $cca4aceb320d03d3$var$RenderingIntentFlag.PRINT);
        this.name = name;
        this.intent = intent;
        this.usage = usage;
    }
    get visible() {
        if (this.#userSet) return this.#visible;
        if (!this.#visible) return false;
        const { print: print, view: view } = this.usage;
        if (this.#isDisplay) return view?.viewState !== "OFF";
        else if (this.#isPrint) return print?.printState !== "OFF";
        return true;
    }
    _setVisible(internal, visible, userSet = false) {
        if (internal !== $cca4aceb320d03d3$var$INTERNAL) $cca4aceb320d03d3$var$unreachable("Internal method `_setVisible` called.");
        this.#userSet = userSet;
        this.#visible = visible;
    }
}
class $cca4aceb320d03d3$var$OptionalContentConfig {
    #cachedGetHash = null;
    #groups = new Map();
    #initialHash = null;
    #order = null;
    constructor(data, renderingIntent = $cca4aceb320d03d3$var$RenderingIntentFlag.DISPLAY){
        this.renderingIntent = renderingIntent;
        this.name = null;
        this.creator = null;
        if (data === null) return;
        this.name = data.name;
        this.creator = data.creator;
        this.#order = data.order;
        for (const group of data.groups)this.#groups.set(group.id, new $cca4aceb320d03d3$var$OptionalContentGroup(renderingIntent, group));
        if (data.baseState === "OFF") for (const group of this.#groups.values())group._setVisible($cca4aceb320d03d3$var$INTERNAL, false);
        for (const on of data.on)this.#groups.get(on)._setVisible($cca4aceb320d03d3$var$INTERNAL, true);
        for (const off of data.off)this.#groups.get(off)._setVisible($cca4aceb320d03d3$var$INTERNAL, false);
        this.#initialHash = this.getHash();
    }
    #evaluateVisibilityExpression(array) {
        const length = array.length;
        if (length < 2) return true;
        const operator = array[0];
        for(let i = 1; i < length; i++){
            const element = array[i];
            let state;
            if (Array.isArray(element)) state = this.#evaluateVisibilityExpression(element);
            else if (this.#groups.has(element)) state = this.#groups.get(element).visible;
            else {
                $cca4aceb320d03d3$var$warn(`Optional content group not found: ${element}`);
                return true;
            }
            switch(operator){
                case "And":
                    if (!state) return false;
                    break;
                case "Or":
                    if (state) return true;
                    break;
                case "Not":
                    return !state;
                default:
                    return true;
            }
        }
        return operator === "And";
    }
    isVisible(group) {
        if (this.#groups.size === 0) return true;
        if (!group) {
            $cca4aceb320d03d3$var$info("Optional content group not defined.");
            return true;
        }
        if (group.type === "OCG") {
            if (!this.#groups.has(group.id)) {
                $cca4aceb320d03d3$var$warn(`Optional content group not found: ${group.id}`);
                return true;
            }
            return this.#groups.get(group.id).visible;
        } else if (group.type === "OCMD") {
            if (group.expression) return this.#evaluateVisibilityExpression(group.expression);
            if (!group.policy || group.policy === "AnyOn") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $cca4aceb320d03d3$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (this.#groups.get(id).visible) return true;
                }
                return false;
            } else if (group.policy === "AllOn") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $cca4aceb320d03d3$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (!this.#groups.get(id).visible) return false;
                }
                return true;
            } else if (group.policy === "AnyOff") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $cca4aceb320d03d3$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (!this.#groups.get(id).visible) return true;
                }
                return false;
            } else if (group.policy === "AllOff") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $cca4aceb320d03d3$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (this.#groups.get(id).visible) return false;
                }
                return true;
            }
            $cca4aceb320d03d3$var$warn(`Unknown optional content policy ${group.policy}.`);
            return true;
        }
        $cca4aceb320d03d3$var$warn(`Unknown group type ${group.type}.`);
        return true;
    }
    setVisibility(id, visible = true) {
        const group = this.#groups.get(id);
        if (!group) {
            $cca4aceb320d03d3$var$warn(`Optional content group not found: ${id}`);
            return;
        }
        group._setVisible($cca4aceb320d03d3$var$INTERNAL, !!visible, true);
        this.#cachedGetHash = null;
    }
    setOCGState({ state: state, preserveRB: preserveRB }) {
        let operator;
        for (const elem of state){
            switch(elem){
                case "ON":
                case "OFF":
                case "Toggle":
                    operator = elem;
                    continue;
            }
            const group = this.#groups.get(elem);
            if (!group) continue;
            switch(operator){
                case "ON":
                    group._setVisible($cca4aceb320d03d3$var$INTERNAL, true);
                    break;
                case "OFF":
                    group._setVisible($cca4aceb320d03d3$var$INTERNAL, false);
                    break;
                case "Toggle":
                    group._setVisible($cca4aceb320d03d3$var$INTERNAL, !group.visible);
                    break;
            }
        }
        this.#cachedGetHash = null;
    }
    get hasInitialVisibility() {
        return this.#initialHash === null || this.getHash() === this.#initialHash;
    }
    getOrder() {
        if (!this.#groups.size) return null;
        if (this.#order) return this.#order.slice();
        return [
            ...this.#groups.keys()
        ];
    }
    getGroups() {
        return this.#groups.size > 0 ? $cca4aceb320d03d3$var$objectFromMap(this.#groups) : null;
    }
    getGroup(id) {
        return this.#groups.get(id) || null;
    }
    getHash() {
        if (this.#cachedGetHash !== null) return this.#cachedGetHash;
        const hash = new $cca4aceb320d03d3$var$MurmurHash3_64();
        for (const [id, group] of this.#groups)hash.update(`${id}:${group.visible}`);
        return this.#cachedGetHash = hash.hexdigest();
    }
}
class $cca4aceb320d03d3$var$PDFDataTransportStream {
    constructor(pdfDataRangeTransport, { disableRange: disableRange = false, disableStream: disableStream = false }){
        $cca4aceb320d03d3$var$assert(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
        const { length: length, initialData: initialData, progressiveDone: progressiveDone, contentDispositionFilename: contentDispositionFilename } = pdfDataRangeTransport;
        this._queuedChunks = [];
        this._progressiveDone = progressiveDone;
        this._contentDispositionFilename = contentDispositionFilename;
        if (initialData?.length > 0) {
            const buffer = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
            this._queuedChunks.push(buffer);
        }
        this._pdfDataRangeTransport = pdfDataRangeTransport;
        this._isStreamingSupported = !disableStream;
        this._isRangeSupported = !disableRange;
        this._contentLength = length;
        this._fullRequestReader = null;
        this._rangeReaders = [];
        pdfDataRangeTransport.addRangeListener((begin, chunk)=>{
            this._onReceiveData({
                begin: begin,
                chunk: chunk
            });
        });
        pdfDataRangeTransport.addProgressListener((loaded, total)=>{
            this._onProgress({
                loaded: loaded,
                total: total
            });
        });
        pdfDataRangeTransport.addProgressiveReadListener((chunk)=>{
            this._onReceiveData({
                chunk: chunk
            });
        });
        pdfDataRangeTransport.addProgressiveDoneListener(()=>{
            this._onProgressiveDone();
        });
        pdfDataRangeTransport.transportReady();
    }
    _onReceiveData({ begin: begin, chunk: chunk }) {
        const buffer = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
        if (begin === undefined) {
            if (this._fullRequestReader) this._fullRequestReader._enqueue(buffer);
            else this._queuedChunks.push(buffer);
        } else {
            const found = this._rangeReaders.some(function(rangeReader) {
                if (rangeReader._begin !== begin) return false;
                rangeReader._enqueue(buffer);
                return true;
            });
            $cca4aceb320d03d3$var$assert(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
        }
    }
    get _progressiveDataLength() {
        return this._fullRequestReader?._loaded ?? 0;
    }
    _onProgress(evt) {
        if (evt.total === undefined) this._rangeReaders[0]?.onProgress?.({
            loaded: evt.loaded
        });
        else this._fullRequestReader?.onProgress?.({
            loaded: evt.loaded,
            total: evt.total
        });
    }
    _onProgressiveDone() {
        this._fullRequestReader?.progressiveDone();
        this._progressiveDone = true;
    }
    _removeRangeReader(reader) {
        const i = this._rangeReaders.indexOf(reader);
        if (i >= 0) this._rangeReaders.splice(i, 1);
    }
    getFullReader() {
        $cca4aceb320d03d3$var$assert(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
        const queuedChunks = this._queuedChunks;
        this._queuedChunks = null;
        return new $cca4aceb320d03d3$var$PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
    }
    getRangeReader(begin, end) {
        if (end <= this._progressiveDataLength) return null;
        const reader = new $cca4aceb320d03d3$var$PDFDataTransportStreamRangeReader(this, begin, end);
        this._pdfDataRangeTransport.requestDataRange(begin, end);
        this._rangeReaders.push(reader);
        return reader;
    }
    cancelAllRequests(reason) {
        this._fullRequestReader?.cancel(reason);
        for (const reader of this._rangeReaders.slice(0))reader.cancel(reason);
        this._pdfDataRangeTransport.abort();
    }
}
class $cca4aceb320d03d3$var$PDFDataTransportStreamReader {
    constructor(stream, queuedChunks, progressiveDone = false, contentDispositionFilename = null){
        this._stream = stream;
        this._done = progressiveDone || false;
        this._filename = $cca4aceb320d03d3$var$isPdfFile(contentDispositionFilename) ? contentDispositionFilename : null;
        this._queuedChunks = queuedChunks || [];
        this._loaded = 0;
        for (const chunk of this._queuedChunks)this._loaded += chunk.byteLength;
        this._requests = [];
        this._headersReady = Promise.resolve();
        stream._fullRequestReader = this;
        this.onProgress = null;
    }
    _enqueue(chunk) {
        if (this._done) return;
        if (this._requests.length > 0) {
            const requestCapability = this._requests.shift();
            requestCapability.resolve({
                value: chunk,
                done: false
            });
        } else this._queuedChunks.push(chunk);
        this._loaded += chunk.byteLength;
    }
    get headersReady() {
        return this._headersReady;
    }
    get filename() {
        return this._filename;
    }
    get isRangeSupported() {
        return this._stream._isRangeSupported;
    }
    get isStreamingSupported() {
        return this._stream._isStreamingSupported;
    }
    get contentLength() {
        return this._stream._contentLength;
    }
    async read() {
        if (this._queuedChunks.length > 0) {
            const chunk = this._queuedChunks.shift();
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const requestCapability = Promise.withResolvers();
        this._requests.push(requestCapability);
        return requestCapability.promise;
    }
    cancel(reason) {
        this._done = true;
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
    }
    progressiveDone() {
        if (this._done) return;
        this._done = true;
    }
}
class $cca4aceb320d03d3$var$PDFDataTransportStreamRangeReader {
    constructor(stream, begin, end){
        this._stream = stream;
        this._begin = begin;
        this._end = end;
        this._queuedChunk = null;
        this._requests = [];
        this._done = false;
        this.onProgress = null;
    }
    _enqueue(chunk) {
        if (this._done) return;
        if (this._requests.length === 0) this._queuedChunk = chunk;
        else {
            const requestsCapability = this._requests.shift();
            requestsCapability.resolve({
                value: chunk,
                done: false
            });
            for (const requestCapability of this._requests)requestCapability.resolve({
                value: undefined,
                done: true
            });
            this._requests.length = 0;
        }
        this._done = true;
        this._stream._removeRangeReader(this);
    }
    get isStreamingSupported() {
        return false;
    }
    async read() {
        if (this._queuedChunk) {
            const chunk = this._queuedChunk;
            this._queuedChunk = null;
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const requestCapability = Promise.withResolvers();
        this._requests.push(requestCapability);
        return requestCapability.promise;
    }
    cancel(reason) {
        this._done = true;
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
        this._stream._removeRangeReader(this);
    }
}
function $cca4aceb320d03d3$var$getFilenameFromContentDispositionHeader(contentDisposition) {
    let needsEncodingFixup = true;
    let tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
    if (tmp) {
        tmp = tmp[1];
        let filename = rfc2616unquote(tmp);
        filename = unescape(filename);
        filename = rfc5987decode(filename);
        filename = rfc2047decode(filename);
        return fixupEncoding(filename);
    }
    tmp = rfc2231getparam(contentDisposition);
    if (tmp) {
        const filename = rfc2047decode(tmp);
        return fixupEncoding(filename);
    }
    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
    if (tmp) {
        tmp = tmp[1];
        let filename = rfc2616unquote(tmp);
        filename = rfc2047decode(filename);
        return fixupEncoding(filename);
    }
    function toParamRegExp(attributePattern, flags) {
        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
    }
    function textdecode(encoding, value) {
        if (encoding) {
            if (!/^[\x00-\xFF]+$/.test(value)) return value;
            try {
                const decoder = new TextDecoder(encoding, {
                    fatal: true
                });
                const buffer = $cca4aceb320d03d3$var$stringToBytes(value);
                value = decoder.decode(buffer);
                needsEncodingFixup = false;
            } catch  {}
        }
        return value;
    }
    function fixupEncoding(value) {
        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
            value = textdecode("utf-8", value);
            if (needsEncodingFixup) value = textdecode("iso-8859-1", value);
        }
        return value;
    }
    function rfc2231getparam(contentDispositionStr) {
        const matches = [];
        let match;
        const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
        while((match = iter.exec(contentDispositionStr)) !== null){
            let [, n, quot, part] = match;
            n = parseInt(n, 10);
            if (n in matches) {
                if (n === 0) break;
                continue;
            }
            matches[n] = [
                quot,
                part
            ];
        }
        const parts = [];
        for(let n = 0; n < matches.length; ++n){
            if (!(n in matches)) break;
            let [quot, part] = matches[n];
            part = rfc2616unquote(part);
            if (quot) {
                part = unescape(part);
                if (n === 0) part = rfc5987decode(part);
            }
            parts.push(part);
        }
        return parts.join("");
    }
    function rfc2616unquote(value) {
        if (value.startsWith('"')) {
            const parts = value.slice(1).split('\\"');
            for(let i = 0; i < parts.length; ++i){
                const quotindex = parts[i].indexOf('"');
                if (quotindex !== -1) {
                    parts[i] = parts[i].slice(0, quotindex);
                    parts.length = i + 1;
                }
                parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
            }
            value = parts.join('"');
        }
        return value;
    }
    function rfc5987decode(extvalue) {
        const encodingend = extvalue.indexOf("'");
        if (encodingend === -1) return extvalue;
        const encoding = extvalue.slice(0, encodingend);
        const langvalue = extvalue.slice(encodingend + 1);
        const value = langvalue.replace(/^[^']*'/, "");
        return textdecode(encoding, value);
    }
    function rfc2047decode(value) {
        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) return value;
        return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
            if (encoding === "q" || encoding === "Q") {
                text = text.replaceAll("_", " ");
                text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function(match, hex) {
                    return String.fromCharCode(parseInt(hex, 16));
                });
                return textdecode(charset, text);
            }
            try {
                text = atob(text);
            } catch  {}
            return textdecode(charset, text);
        });
    }
    return "";
}
function $cca4aceb320d03d3$var$validateRangeRequestCapabilities({ getResponseHeader: getResponseHeader, isHttp: isHttp, rangeChunkSize: rangeChunkSize, disableRange: disableRange }) {
    const returnValues = {
        allowRangeRequests: false,
        suggestedLength: undefined
    };
    const length = parseInt(getResponseHeader("Content-Length"), 10);
    if (!Number.isInteger(length)) return returnValues;
    returnValues.suggestedLength = length;
    if (length <= 2 * rangeChunkSize) return returnValues;
    if (disableRange || !isHttp) return returnValues;
    if (getResponseHeader("Accept-Ranges") !== "bytes") return returnValues;
    const contentEncoding = getResponseHeader("Content-Encoding") || "identity";
    if (contentEncoding !== "identity") return returnValues;
    returnValues.allowRangeRequests = true;
    return returnValues;
}
function $cca4aceb320d03d3$var$extractFilenameFromHeader(getResponseHeader) {
    const contentDisposition = getResponseHeader("Content-Disposition");
    if (contentDisposition) {
        let filename = $cca4aceb320d03d3$var$getFilenameFromContentDispositionHeader(contentDisposition);
        if (filename.includes("%")) try {
            filename = decodeURIComponent(filename);
        } catch  {}
        if ($cca4aceb320d03d3$var$isPdfFile(filename)) return filename;
    }
    return null;
}
function $cca4aceb320d03d3$var$createResponseStatusError(status, url) {
    if (status === 404 || status === 0 && url.startsWith("file:")) return new $cca4aceb320d03d3$var$MissingPDFException('Missing PDF "' + url + '".');
    return new $cca4aceb320d03d3$var$UnexpectedResponseException(`Unexpected server response (${status}) while retrieving PDF "${url}".`, status);
}
function $cca4aceb320d03d3$var$validateResponseStatus(status) {
    return status === 200 || status === 206;
}
function $cca4aceb320d03d3$var$createFetchOptions(headers, withCredentials, abortController) {
    return {
        method: "GET",
        headers: headers,
        signal: abortController.signal,
        mode: "cors",
        credentials: withCredentials ? "include" : "same-origin",
        redirect: "follow"
    };
}
function $cca4aceb320d03d3$var$createHeaders(httpHeaders) {
    const headers = new Headers();
    for(const property in httpHeaders){
        const value = httpHeaders[property];
        if (value === undefined) continue;
        headers.append(property, value);
    }
    return headers;
}
function $cca4aceb320d03d3$var$getArrayBuffer(val) {
    if (val instanceof Uint8Array) return val.buffer;
    if (val instanceof ArrayBuffer) return val;
    $cca4aceb320d03d3$var$warn(`getArrayBuffer - unexpected data format: ${val}`);
    return new Uint8Array(val).buffer;
}
class $cca4aceb320d03d3$var$PDFFetchStream {
    constructor(source){
        this.source = source;
        this.isHttp = /^https?:/i.test(source.url);
        this.httpHeaders = this.isHttp && source.httpHeaders || {};
        this._fullRequestReader = null;
        this._rangeRequestReaders = [];
    }
    get _progressiveDataLength() {
        return this._fullRequestReader?._loaded ?? 0;
    }
    getFullReader() {
        $cca4aceb320d03d3$var$assert(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
        this._fullRequestReader = new $cca4aceb320d03d3$var$PDFFetchStreamReader(this);
        return this._fullRequestReader;
    }
    getRangeReader(begin, end) {
        if (end <= this._progressiveDataLength) return null;
        const reader = new $cca4aceb320d03d3$var$PDFFetchStreamRangeReader(this, begin, end);
        this._rangeRequestReaders.push(reader);
        return reader;
    }
    cancelAllRequests(reason) {
        this._fullRequestReader?.cancel(reason);
        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
    }
}
class $cca4aceb320d03d3$var$PDFFetchStreamReader {
    constructor(stream){
        this._stream = stream;
        this._reader = null;
        this._loaded = 0;
        this._filename = null;
        const source = stream.source;
        this._withCredentials = source.withCredentials || false;
        this._contentLength = source.length;
        this._headersCapability = Promise.withResolvers();
        this._disableRange = source.disableRange || false;
        this._rangeChunkSize = source.rangeChunkSize;
        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
        this._abortController = new AbortController();
        this._isStreamingSupported = !source.disableStream;
        this._isRangeSupported = !source.disableRange;
        this._headers = $cca4aceb320d03d3$var$createHeaders(this._stream.httpHeaders);
        const url = source.url;
        fetch(url, $cca4aceb320d03d3$var$createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response)=>{
            if (!$cca4aceb320d03d3$var$validateResponseStatus(response.status)) throw $cca4aceb320d03d3$var$createResponseStatusError(response.status, url);
            this._reader = response.body.getReader();
            this._headersCapability.resolve();
            const getResponseHeader = (name)=>response.headers.get(name);
            const { allowRangeRequests: allowRangeRequests, suggestedLength: suggestedLength } = $cca4aceb320d03d3$var$validateRangeRequestCapabilities({
                getResponseHeader: getResponseHeader,
                isHttp: this._stream.isHttp,
                rangeChunkSize: this._rangeChunkSize,
                disableRange: this._disableRange
            });
            this._isRangeSupported = allowRangeRequests;
            this._contentLength = suggestedLength || this._contentLength;
            this._filename = $cca4aceb320d03d3$var$extractFilenameFromHeader(getResponseHeader);
            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new $cca4aceb320d03d3$var$AbortException("Streaming is disabled."));
        }).catch(this._headersCapability.reject);
        this.onProgress = null;
    }
    get headersReady() {
        return this._headersCapability.promise;
    }
    get filename() {
        return this._filename;
    }
    get contentLength() {
        return this._contentLength;
    }
    get isRangeSupported() {
        return this._isRangeSupported;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    async read() {
        await this._headersCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        this._loaded += value.byteLength;
        this.onProgress?.({
            loaded: this._loaded,
            total: this._contentLength
        });
        return {
            value: $cca4aceb320d03d3$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
        this._abortController.abort();
    }
}
class $cca4aceb320d03d3$var$PDFFetchStreamRangeReader {
    constructor(stream, begin, end){
        this._stream = stream;
        this._reader = null;
        this._loaded = 0;
        const source = stream.source;
        this._withCredentials = source.withCredentials || false;
        this._readCapability = Promise.withResolvers();
        this._isStreamingSupported = !source.disableStream;
        this._abortController = new AbortController();
        this._headers = $cca4aceb320d03d3$var$createHeaders(this._stream.httpHeaders);
        this._headers.append("Range", `bytes=${begin}-${end - 1}`);
        const url = source.url;
        fetch(url, $cca4aceb320d03d3$var$createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response)=>{
            if (!$cca4aceb320d03d3$var$validateResponseStatus(response.status)) throw $cca4aceb320d03d3$var$createResponseStatusError(response.status, url);
            this._readCapability.resolve();
            this._reader = response.body.getReader();
        }).catch(this._readCapability.reject);
        this.onProgress = null;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    async read() {
        await this._readCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        this._loaded += value.byteLength;
        this.onProgress?.({
            loaded: this._loaded
        });
        return {
            value: $cca4aceb320d03d3$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
        this._abortController.abort();
    }
}
const $cca4aceb320d03d3$var$OK_RESPONSE = 200;
const $cca4aceb320d03d3$var$PARTIAL_CONTENT_RESPONSE = 206;
function $cca4aceb320d03d3$var$network_getArrayBuffer(xhr) {
    const data = xhr.response;
    if (typeof data !== "string") return data;
    return $cca4aceb320d03d3$var$stringToBytes(data).buffer;
}
class $cca4aceb320d03d3$var$NetworkManager {
    constructor(url, args = {}){
        this.url = url;
        this.isHttp = /^https?:/i.test(url);
        this.httpHeaders = this.isHttp && args.httpHeaders || Object.create(null);
        this.withCredentials = args.withCredentials || false;
        this.currXhrId = 0;
        this.pendingRequests = Object.create(null);
    }
    requestRange(begin, end, listeners) {
        const args = {
            begin: begin,
            end: end
        };
        for(const prop in listeners)args[prop] = listeners[prop];
        return this.request(args);
    }
    requestFull(listeners) {
        return this.request(listeners);
    }
    request(args) {
        const xhr = new XMLHttpRequest();
        const xhrId = this.currXhrId++;
        const pendingRequest = this.pendingRequests[xhrId] = {
            xhr: xhr
        };
        xhr.open("GET", this.url);
        xhr.withCredentials = this.withCredentials;
        for(const property in this.httpHeaders){
            const value = this.httpHeaders[property];
            if (value === undefined) continue;
            xhr.setRequestHeader(property, value);
        }
        if (this.isHttp && "begin" in args && "end" in args) {
            xhr.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
            pendingRequest.expectedStatus = $cca4aceb320d03d3$var$PARTIAL_CONTENT_RESPONSE;
        } else pendingRequest.expectedStatus = $cca4aceb320d03d3$var$OK_RESPONSE;
        xhr.responseType = "arraybuffer";
        if (args.onError) xhr.onerror = function(evt) {
            args.onError(xhr.status);
        };
        xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
        xhr.onprogress = this.onProgress.bind(this, xhrId);
        pendingRequest.onHeadersReceived = args.onHeadersReceived;
        pendingRequest.onDone = args.onDone;
        pendingRequest.onError = args.onError;
        pendingRequest.onProgress = args.onProgress;
        xhr.send(null);
        return xhrId;
    }
    onProgress(xhrId, evt) {
        const pendingRequest = this.pendingRequests[xhrId];
        if (!pendingRequest) return;
        pendingRequest.onProgress?.(evt);
    }
    onStateChange(xhrId, evt) {
        const pendingRequest = this.pendingRequests[xhrId];
        if (!pendingRequest) return;
        const xhr = pendingRequest.xhr;
        if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
            pendingRequest.onHeadersReceived();
            delete pendingRequest.onHeadersReceived;
        }
        if (xhr.readyState !== 4) return;
        if (!(xhrId in this.pendingRequests)) return;
        delete this.pendingRequests[xhrId];
        if (xhr.status === 0 && this.isHttp) {
            pendingRequest.onError?.(xhr.status);
            return;
        }
        const xhrStatus = xhr.status || $cca4aceb320d03d3$var$OK_RESPONSE;
        const ok_response_on_range_request = xhrStatus === $cca4aceb320d03d3$var$OK_RESPONSE && pendingRequest.expectedStatus === $cca4aceb320d03d3$var$PARTIAL_CONTENT_RESPONSE;
        if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
            pendingRequest.onError?.(xhr.status);
            return;
        }
        const chunk = $cca4aceb320d03d3$var$network_getArrayBuffer(xhr);
        if (xhrStatus === $cca4aceb320d03d3$var$PARTIAL_CONTENT_RESPONSE) {
            const rangeHeader = xhr.getResponseHeader("Content-Range");
            const matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
            pendingRequest.onDone({
                begin: parseInt(matches[1], 10),
                chunk: chunk
            });
        } else if (chunk) pendingRequest.onDone({
            begin: 0,
            chunk: chunk
        });
        else pendingRequest.onError?.(xhr.status);
    }
    getRequestXhr(xhrId) {
        return this.pendingRequests[xhrId].xhr;
    }
    isPendingRequest(xhrId) {
        return xhrId in this.pendingRequests;
    }
    abortRequest(xhrId) {
        const xhr = this.pendingRequests[xhrId].xhr;
        delete this.pendingRequests[xhrId];
        xhr.abort();
    }
}
class $cca4aceb320d03d3$var$PDFNetworkStream {
    constructor(source){
        this._source = source;
        this._manager = new $cca4aceb320d03d3$var$NetworkManager(source.url, {
            httpHeaders: source.httpHeaders,
            withCredentials: source.withCredentials
        });
        this._rangeChunkSize = source.rangeChunkSize;
        this._fullRequestReader = null;
        this._rangeRequestReaders = [];
    }
    _onRangeRequestReaderClosed(reader) {
        const i = this._rangeRequestReaders.indexOf(reader);
        if (i >= 0) this._rangeRequestReaders.splice(i, 1);
    }
    getFullReader() {
        $cca4aceb320d03d3$var$assert(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
        this._fullRequestReader = new $cca4aceb320d03d3$var$PDFNetworkStreamFullRequestReader(this._manager, this._source);
        return this._fullRequestReader;
    }
    getRangeReader(begin, end) {
        const reader = new $cca4aceb320d03d3$var$PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
        reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
        this._rangeRequestReaders.push(reader);
        return reader;
    }
    cancelAllRequests(reason) {
        this._fullRequestReader?.cancel(reason);
        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
    }
}
class $cca4aceb320d03d3$var$PDFNetworkStreamFullRequestReader {
    constructor(manager, source){
        this._manager = manager;
        const args = {
            onHeadersReceived: this._onHeadersReceived.bind(this),
            onDone: this._onDone.bind(this),
            onError: this._onError.bind(this),
            onProgress: this._onProgress.bind(this)
        };
        this._url = source.url;
        this._fullRequestId = manager.requestFull(args);
        this._headersReceivedCapability = Promise.withResolvers();
        this._disableRange = source.disableRange || false;
        this._contentLength = source.length;
        this._rangeChunkSize = source.rangeChunkSize;
        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
        this._isStreamingSupported = false;
        this._isRangeSupported = false;
        this._cachedChunks = [];
        this._requests = [];
        this._done = false;
        this._storedError = undefined;
        this._filename = null;
        this.onProgress = null;
    }
    _onHeadersReceived() {
        const fullRequestXhrId = this._fullRequestId;
        const fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
        const getResponseHeader = (name)=>fullRequestXhr.getResponseHeader(name);
        const { allowRangeRequests: allowRangeRequests, suggestedLength: suggestedLength } = $cca4aceb320d03d3$var$validateRangeRequestCapabilities({
            getResponseHeader: getResponseHeader,
            isHttp: this._manager.isHttp,
            rangeChunkSize: this._rangeChunkSize,
            disableRange: this._disableRange
        });
        if (allowRangeRequests) this._isRangeSupported = true;
        this._contentLength = suggestedLength || this._contentLength;
        this._filename = $cca4aceb320d03d3$var$extractFilenameFromHeader(getResponseHeader);
        if (this._isRangeSupported) this._manager.abortRequest(fullRequestXhrId);
        this._headersReceivedCapability.resolve();
    }
    _onDone(data) {
        if (data) {
            if (this._requests.length > 0) {
                const requestCapability = this._requests.shift();
                requestCapability.resolve({
                    value: data.chunk,
                    done: false
                });
            } else this._cachedChunks.push(data.chunk);
        }
        this._done = true;
        if (this._cachedChunks.length > 0) return;
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
    }
    _onError(status) {
        this._storedError = $cca4aceb320d03d3$var$createResponseStatusError(status, this._url);
        this._headersReceivedCapability.reject(this._storedError);
        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
        this._requests.length = 0;
        this._cachedChunks.length = 0;
    }
    _onProgress(evt) {
        this.onProgress?.({
            loaded: evt.loaded,
            total: evt.lengthComputable ? evt.total : this._contentLength
        });
    }
    get filename() {
        return this._filename;
    }
    get isRangeSupported() {
        return this._isRangeSupported;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    get contentLength() {
        return this._contentLength;
    }
    get headersReady() {
        return this._headersReceivedCapability.promise;
    }
    async read() {
        if (this._storedError) throw this._storedError;
        if (this._cachedChunks.length > 0) {
            const chunk = this._cachedChunks.shift();
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const requestCapability = Promise.withResolvers();
        this._requests.push(requestCapability);
        return requestCapability.promise;
    }
    cancel(reason) {
        this._done = true;
        this._headersReceivedCapability.reject(reason);
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
        if (this._manager.isPendingRequest(this._fullRequestId)) this._manager.abortRequest(this._fullRequestId);
        this._fullRequestReader = null;
    }
}
class $cca4aceb320d03d3$var$PDFNetworkStreamRangeRequestReader {
    constructor(manager, begin, end){
        this._manager = manager;
        const args = {
            onDone: this._onDone.bind(this),
            onError: this._onError.bind(this),
            onProgress: this._onProgress.bind(this)
        };
        this._url = manager.url;
        this._requestId = manager.requestRange(begin, end, args);
        this._requests = [];
        this._queuedChunk = null;
        this._done = false;
        this._storedError = undefined;
        this.onProgress = null;
        this.onClosed = null;
    }
    _close() {
        this.onClosed?.(this);
    }
    _onDone(data) {
        const chunk = data.chunk;
        if (this._requests.length > 0) {
            const requestCapability = this._requests.shift();
            requestCapability.resolve({
                value: chunk,
                done: false
            });
        } else this._queuedChunk = chunk;
        this._done = true;
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
        this._close();
    }
    _onError(status) {
        this._storedError = $cca4aceb320d03d3$var$createResponseStatusError(status, this._url);
        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
        this._requests.length = 0;
        this._queuedChunk = null;
    }
    _onProgress(evt) {
        if (!this.isStreamingSupported) this.onProgress?.({
            loaded: evt.loaded
        });
    }
    get isStreamingSupported() {
        return false;
    }
    async read() {
        if (this._storedError) throw this._storedError;
        if (this._queuedChunk !== null) {
            const chunk = this._queuedChunk;
            this._queuedChunk = null;
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const requestCapability = Promise.withResolvers();
        this._requests.push(requestCapability);
        return requestCapability.promise;
    }
    cancel(reason) {
        this._done = true;
        for (const requestCapability of this._requests)requestCapability.resolve({
            value: undefined,
            done: true
        });
        this._requests.length = 0;
        if (this._manager.isPendingRequest(this._requestId)) this._manager.abortRequest(this._requestId);
        this._close();
    }
}
const $cca4aceb320d03d3$var$fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
function $cca4aceb320d03d3$var$parseUrl(sourceUrl) {
    const url = $cca4aceb320d03d3$var$NodePackages.get("url");
    const parsedUrl = url.parse(sourceUrl);
    if (parsedUrl.protocol === "file:" || parsedUrl.host) return parsedUrl;
    if (/^[a-z]:[/\\]/i.test(sourceUrl)) return url.parse(`file:///${sourceUrl}`);
    if (!parsedUrl.host) parsedUrl.protocol = "file:";
    return parsedUrl;
}
class $cca4aceb320d03d3$var$PDFNodeStream {
    constructor(source){
        this.source = source;
        this.url = $cca4aceb320d03d3$var$parseUrl(source.url);
        this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
        this.isFsUrl = this.url.protocol === "file:";
        this.httpHeaders = this.isHttp && source.httpHeaders || {};
        this._fullRequestReader = null;
        this._rangeRequestReaders = [];
    }
    get _progressiveDataLength() {
        return this._fullRequestReader?._loaded ?? 0;
    }
    getFullReader() {
        $cca4aceb320d03d3$var$assert(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
        this._fullRequestReader = this.isFsUrl ? new $cca4aceb320d03d3$var$PDFNodeStreamFsFullReader(this) : new $cca4aceb320d03d3$var$PDFNodeStreamFullReader(this);
        return this._fullRequestReader;
    }
    getRangeReader(start, end) {
        if (end <= this._progressiveDataLength) return null;
        const rangeReader = this.isFsUrl ? new $cca4aceb320d03d3$var$PDFNodeStreamFsRangeReader(this, start, end) : new $cca4aceb320d03d3$var$PDFNodeStreamRangeReader(this, start, end);
        this._rangeRequestReaders.push(rangeReader);
        return rangeReader;
    }
    cancelAllRequests(reason) {
        this._fullRequestReader?.cancel(reason);
        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
    }
}
class $cca4aceb320d03d3$var$BaseFullReader {
    constructor(stream){
        this._url = stream.url;
        this._done = false;
        this._storedError = null;
        this.onProgress = null;
        const source = stream.source;
        this._contentLength = source.length;
        this._loaded = 0;
        this._filename = null;
        this._disableRange = source.disableRange || false;
        this._rangeChunkSize = source.rangeChunkSize;
        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
        this._isStreamingSupported = !source.disableStream;
        this._isRangeSupported = !source.disableRange;
        this._readableStream = null;
        this._readCapability = Promise.withResolvers();
        this._headersCapability = Promise.withResolvers();
    }
    get headersReady() {
        return this._headersCapability.promise;
    }
    get filename() {
        return this._filename;
    }
    get contentLength() {
        return this._contentLength;
    }
    get isRangeSupported() {
        return this._isRangeSupported;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    async read() {
        await this._readCapability.promise;
        if (this._done) return {
            value: undefined,
            done: true
        };
        if (this._storedError) throw this._storedError;
        const chunk = this._readableStream.read();
        if (chunk === null) {
            this._readCapability = Promise.withResolvers();
            return this.read();
        }
        this._loaded += chunk.length;
        this.onProgress?.({
            loaded: this._loaded,
            total: this._contentLength
        });
        const buffer = new Uint8Array(chunk).buffer;
        return {
            value: buffer,
            done: false
        };
    }
    cancel(reason) {
        if (!this._readableStream) {
            this._error(reason);
            return;
        }
        this._readableStream.destroy(reason);
    }
    _error(reason) {
        this._storedError = reason;
        this._readCapability.resolve();
    }
    _setReadableStream(readableStream) {
        this._readableStream = readableStream;
        readableStream.on("readable", ()=>{
            this._readCapability.resolve();
        });
        readableStream.on("end", ()=>{
            readableStream.destroy();
            this._done = true;
            this._readCapability.resolve();
        });
        readableStream.on("error", (reason)=>{
            this._error(reason);
        });
        if (!this._isStreamingSupported && this._isRangeSupported) this._error(new $cca4aceb320d03d3$var$AbortException("streaming is disabled"));
        if (this._storedError) this._readableStream.destroy(this._storedError);
    }
}
class $cca4aceb320d03d3$var$BaseRangeReader {
    constructor(stream){
        this._url = stream.url;
        this._done = false;
        this._storedError = null;
        this.onProgress = null;
        this._loaded = 0;
        this._readableStream = null;
        this._readCapability = Promise.withResolvers();
        const source = stream.source;
        this._isStreamingSupported = !source.disableStream;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    async read() {
        await this._readCapability.promise;
        if (this._done) return {
            value: undefined,
            done: true
        };
        if (this._storedError) throw this._storedError;
        const chunk = this._readableStream.read();
        if (chunk === null) {
            this._readCapability = Promise.withResolvers();
            return this.read();
        }
        this._loaded += chunk.length;
        this.onProgress?.({
            loaded: this._loaded
        });
        const buffer = new Uint8Array(chunk).buffer;
        return {
            value: buffer,
            done: false
        };
    }
    cancel(reason) {
        if (!this._readableStream) {
            this._error(reason);
            return;
        }
        this._readableStream.destroy(reason);
    }
    _error(reason) {
        this._storedError = reason;
        this._readCapability.resolve();
    }
    _setReadableStream(readableStream) {
        this._readableStream = readableStream;
        readableStream.on("readable", ()=>{
            this._readCapability.resolve();
        });
        readableStream.on("end", ()=>{
            readableStream.destroy();
            this._done = true;
            this._readCapability.resolve();
        });
        readableStream.on("error", (reason)=>{
            this._error(reason);
        });
        if (this._storedError) this._readableStream.destroy(this._storedError);
    }
}
function $cca4aceb320d03d3$var$createRequestOptions(parsedUrl, headers) {
    return {
        protocol: parsedUrl.protocol,
        auth: parsedUrl.auth,
        host: parsedUrl.hostname,
        port: parsedUrl.port,
        path: parsedUrl.path,
        method: "GET",
        headers: headers
    };
}
class $cca4aceb320d03d3$var$PDFNodeStreamFullReader extends $cca4aceb320d03d3$var$BaseFullReader {
    constructor(stream){
        super(stream);
        const handleResponse = (response)=>{
            if (response.statusCode === 404) {
                const error = new $cca4aceb320d03d3$var$MissingPDFException(`Missing PDF "${this._url}".`);
                this._storedError = error;
                this._headersCapability.reject(error);
                return;
            }
            this._headersCapability.resolve();
            this._setReadableStream(response);
            const getResponseHeader = (name)=>this._readableStream.headers[name.toLowerCase()];
            const { allowRangeRequests: allowRangeRequests, suggestedLength: suggestedLength } = $cca4aceb320d03d3$var$validateRangeRequestCapabilities({
                getResponseHeader: getResponseHeader,
                isHttp: stream.isHttp,
                rangeChunkSize: this._rangeChunkSize,
                disableRange: this._disableRange
            });
            this._isRangeSupported = allowRangeRequests;
            this._contentLength = suggestedLength || this._contentLength;
            this._filename = $cca4aceb320d03d3$var$extractFilenameFromHeader(getResponseHeader);
        };
        this._request = null;
        if (this._url.protocol === "http:") {
            const http = $cca4aceb320d03d3$var$NodePackages.get("http");
            this._request = http.request($cca4aceb320d03d3$var$createRequestOptions(this._url, stream.httpHeaders), handleResponse);
        } else {
            const https = $cca4aceb320d03d3$var$NodePackages.get("https");
            this._request = https.request($cca4aceb320d03d3$var$createRequestOptions(this._url, stream.httpHeaders), handleResponse);
        }
        this._request.on("error", (reason)=>{
            this._storedError = reason;
            this._headersCapability.reject(reason);
        });
        this._request.end();
    }
}
class $cca4aceb320d03d3$var$PDFNodeStreamRangeReader extends $cca4aceb320d03d3$var$BaseRangeReader {
    constructor(stream, start, end){
        super(stream);
        this._httpHeaders = {};
        for(const property in stream.httpHeaders){
            const value = stream.httpHeaders[property];
            if (value === undefined) continue;
            this._httpHeaders[property] = value;
        }
        this._httpHeaders.Range = `bytes=${start}-${end - 1}`;
        const handleResponse = (response)=>{
            if (response.statusCode === 404) {
                const error = new $cca4aceb320d03d3$var$MissingPDFException(`Missing PDF "${this._url}".`);
                this._storedError = error;
                return;
            }
            this._setReadableStream(response);
        };
        this._request = null;
        if (this._url.protocol === "http:") {
            const http = $cca4aceb320d03d3$var$NodePackages.get("http");
            this._request = http.request($cca4aceb320d03d3$var$createRequestOptions(this._url, this._httpHeaders), handleResponse);
        } else {
            const https = $cca4aceb320d03d3$var$NodePackages.get("https");
            this._request = https.request($cca4aceb320d03d3$var$createRequestOptions(this._url, this._httpHeaders), handleResponse);
        }
        this._request.on("error", (reason)=>{
            this._storedError = reason;
        });
        this._request.end();
    }
}
class $cca4aceb320d03d3$var$PDFNodeStreamFsFullReader extends $cca4aceb320d03d3$var$BaseFullReader {
    constructor(stream){
        super(stream);
        let path = decodeURIComponent(this._url.path);
        if ($cca4aceb320d03d3$var$fileUriRegex.test(this._url.href)) path = path.replace(/^\//, "");
        const fs = $cca4aceb320d03d3$var$NodePackages.get("fs");
        fs.promises.lstat(path).then((stat)=>{
            this._contentLength = stat.size;
            this._setReadableStream(fs.createReadStream(path));
            this._headersCapability.resolve();
        }, (error)=>{
            if (error.code === "ENOENT") error = new $cca4aceb320d03d3$var$MissingPDFException(`Missing PDF "${path}".`);
            this._storedError = error;
            this._headersCapability.reject(error);
        });
    }
}
class $cca4aceb320d03d3$var$PDFNodeStreamFsRangeReader extends $cca4aceb320d03d3$var$BaseRangeReader {
    constructor(stream, start, end){
        super(stream);
        let path = decodeURIComponent(this._url.path);
        if ($cca4aceb320d03d3$var$fileUriRegex.test(this._url.href)) path = path.replace(/^\//, "");
        const fs = $cca4aceb320d03d3$var$NodePackages.get("fs");
        this._setReadableStream(fs.createReadStream(path, {
            start: start,
            end: end - 1
        }));
    }
}
const $cca4aceb320d03d3$var$MAX_TEXT_DIVS_TO_RENDER = 100000;
const $cca4aceb320d03d3$var$DEFAULT_FONT_SIZE = 30;
const $cca4aceb320d03d3$var$DEFAULT_FONT_ASCENT = 0.8;
class $cca4aceb320d03d3$var$TextLayer {
    #capability = Promise.withResolvers();
    #container = null;
    #disableProcessItems = false;
    #fontInspectorEnabled = !!globalThis.FontInspector?.enabled;
    #lang = null;
    #layoutTextParams = null;
    #pageHeight = 0;
    #pageWidth = 0;
    #reader = null;
    #rootContainer = null;
    #rotation = 0;
    #scale = 0;
    #styleCache = Object.create(null);
    #textContentItemsStr = [];
    #textContentSource = null;
    #textDivs = [];
    #textDivProperties = new WeakMap();
    #transform = null;
    static #ascentCache = new Map();
    static #canvasContexts = new Map();
    static #minFontSize = null;
    static #pendingTextLayers = new Set();
    constructor({ textContentSource: textContentSource, container: container, viewport: viewport }){
        if (textContentSource instanceof ReadableStream) this.#textContentSource = textContentSource;
        else if (typeof textContentSource === "object") this.#textContentSource = new ReadableStream({
            start (controller) {
                controller.enqueue(textContentSource);
                controller.close();
            }
        });
        else throw new Error('No "textContentSource" parameter specified.');
        this.#container = this.#rootContainer = container;
        this.#scale = viewport.scale * (globalThis.devicePixelRatio || 1);
        this.#rotation = viewport.rotation;
        this.#layoutTextParams = {
            prevFontSize: null,
            prevFontFamily: null,
            div: null,
            properties: null,
            ctx: null
        };
        const { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } = viewport.rawDims;
        this.#transform = [
            1,
            0,
            0,
            -1,
            -pageX,
            pageY + pageHeight
        ];
        this.#pageWidth = pageWidth;
        this.#pageHeight = pageHeight;
        $cca4aceb320d03d3$var$TextLayer.#ensureMinFontSizeComputed();
        $cca4aceb320d03d3$var$setLayerDimensions(container, viewport);
        this.#capability.promise.catch(()=>{}).then(()=>{
            $cca4aceb320d03d3$var$TextLayer.#pendingTextLayers.delete(this);
            this.#layoutTextParams = null;
            this.#styleCache = null;
        });
    }
    render() {
        const pump = ()=>{
            this.#reader.read().then(({ value: value, done: done })=>{
                if (done) {
                    this.#capability.resolve();
                    return;
                }
                this.#lang ??= value.lang;
                Object.assign(this.#styleCache, value.styles);
                this.#processItems(value.items);
                pump();
            }, this.#capability.reject);
        };
        this.#reader = this.#textContentSource.getReader();
        $cca4aceb320d03d3$var$TextLayer.#pendingTextLayers.add(this);
        pump();
        return this.#capability.promise;
    }
    update({ viewport: viewport, onBefore: onBefore = null }) {
        const scale = viewport.scale * (globalThis.devicePixelRatio || 1);
        const rotation = viewport.rotation;
        if (rotation !== this.#rotation) {
            onBefore?.();
            this.#rotation = rotation;
            $cca4aceb320d03d3$var$setLayerDimensions(this.#rootContainer, {
                rotation: rotation
            });
        }
        if (scale !== this.#scale) {
            onBefore?.();
            this.#scale = scale;
            const params = {
                prevFontSize: null,
                prevFontFamily: null,
                div: null,
                properties: null,
                ctx: $cca4aceb320d03d3$var$TextLayer.#getCtx(this.#lang)
            };
            for (const div of this.#textDivs){
                params.properties = this.#textDivProperties.get(div);
                params.div = div;
                this.#layout(params);
            }
        }
    }
    cancel() {
        const abortEx = new $cca4aceb320d03d3$var$AbortException("TextLayer task cancelled.");
        this.#reader?.cancel(abortEx).catch(()=>{});
        this.#reader = null;
        this.#capability.reject(abortEx);
    }
    get textDivs() {
        return this.#textDivs;
    }
    get textContentItemsStr() {
        return this.#textContentItemsStr;
    }
    #processItems(items) {
        if (this.#disableProcessItems) return;
        this.#layoutTextParams.ctx ??= $cca4aceb320d03d3$var$TextLayer.#getCtx(this.#lang);
        const textDivs = this.#textDivs, textContentItemsStr = this.#textContentItemsStr;
        for (const item of items){
            if (textDivs.length > $cca4aceb320d03d3$var$MAX_TEXT_DIVS_TO_RENDER) {
                $cca4aceb320d03d3$var$warn("Ignoring additional textDivs for performance reasons.");
                this.#disableProcessItems = true;
                return;
            }
            if (item.str === undefined) {
                if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                    const parent = this.#container;
                    this.#container = document.createElement("span");
                    this.#container.classList.add("markedContent");
                    if (item.id !== null) this.#container.setAttribute("id", `${item.id}`);
                    parent.append(this.#container);
                } else if (item.type === "endMarkedContent") this.#container = this.#container.parentNode;
                continue;
            }
            textContentItemsStr.push(item.str);
            this.#appendText(item);
        }
    }
    #appendText(geom) {
        const textDiv = document.createElement("span");
        const textDivProperties = {
            angle: 0,
            canvasWidth: 0,
            hasText: geom.str !== "",
            hasEOL: geom.hasEOL,
            fontSize: 0
        };
        this.#textDivs.push(textDiv);
        const tx = $cca4aceb320d03d3$var$Util.transform(this.#transform, geom.transform);
        let angle = Math.atan2(tx[1], tx[0]);
        const style = this.#styleCache[geom.fontName];
        if (style.vertical) angle += Math.PI / 2;
        const fontFamily = this.#fontInspectorEnabled && style.fontSubstitution || style.fontFamily;
        const fontHeight = Math.hypot(tx[2], tx[3]);
        const fontAscent = fontHeight * $cca4aceb320d03d3$var$TextLayer.#getAscent(fontFamily, this.#lang);
        let left, top;
        if (angle === 0) {
            left = tx[4];
            top = tx[5] - fontAscent;
        } else {
            left = tx[4] + fontAscent * Math.sin(angle);
            top = tx[5] - fontAscent * Math.cos(angle);
        }
        const scaleFactorStr = "calc(var(--scale-factor)*";
        const divStyle = textDiv.style;
        if (this.#container === this.#rootContainer) {
            divStyle.left = `${(100 * left / this.#pageWidth).toFixed(2)}%`;
            divStyle.top = `${(100 * top / this.#pageHeight).toFixed(2)}%`;
        } else {
            divStyle.left = `${scaleFactorStr}${left.toFixed(2)}px)`;
            divStyle.top = `${scaleFactorStr}${top.toFixed(2)}px)`;
        }
        divStyle.fontSize = `${scaleFactorStr}${($cca4aceb320d03d3$var$TextLayer.#minFontSize * fontHeight).toFixed(2)}px)`;
        divStyle.fontFamily = fontFamily;
        textDivProperties.fontSize = fontHeight;
        textDiv.setAttribute("role", "presentation");
        textDiv.textContent = geom.str;
        textDiv.dir = geom.dir;
        if (this.#fontInspectorEnabled) textDiv.dataset.fontName = style.fontSubstitutionLoadedName || geom.fontName;
        if (angle !== 0) textDivProperties.angle = angle * (180 / Math.PI);
        let shouldScaleText = false;
        if (geom.str.length > 1) shouldScaleText = true;
        else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
            const absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
            if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) shouldScaleText = true;
        }
        if (shouldScaleText) textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
        this.#textDivProperties.set(textDiv, textDivProperties);
        this.#layoutTextParams.div = textDiv;
        this.#layoutTextParams.properties = textDivProperties;
        this.#layout(this.#layoutTextParams);
        if (textDivProperties.hasText) this.#container.append(textDiv);
        if (textDivProperties.hasEOL) {
            const br = document.createElement("br");
            br.setAttribute("role", "presentation");
            this.#container.append(br);
        }
    }
    #layout(params) {
        const { div: div, properties: properties, ctx: ctx, prevFontSize: prevFontSize, prevFontFamily: prevFontFamily } = params;
        const { style: style } = div;
        let transform = "";
        if ($cca4aceb320d03d3$var$TextLayer.#minFontSize > 1) transform = `scale(${1 / $cca4aceb320d03d3$var$TextLayer.#minFontSize})`;
        if (properties.canvasWidth !== 0 && properties.hasText) {
            const { fontFamily: fontFamily } = style;
            const { canvasWidth: canvasWidth, fontSize: fontSize } = properties;
            if (prevFontSize !== fontSize || prevFontFamily !== fontFamily) {
                ctx.font = `${fontSize * this.#scale}px ${fontFamily}`;
                params.prevFontSize = fontSize;
                params.prevFontFamily = fontFamily;
            }
            const { width: width } = ctx.measureText(div.textContent);
            if (width > 0) transform = `scaleX(${canvasWidth * this.#scale / width}) ${transform}`;
        }
        if (properties.angle !== 0) transform = `rotate(${properties.angle}deg) ${transform}`;
        if (transform.length > 0) style.transform = transform;
    }
    static cleanup() {
        if (this.#pendingTextLayers.size > 0) return;
        this.#ascentCache.clear();
        for (const { canvas: canvas } of this.#canvasContexts.values())canvas.remove();
        this.#canvasContexts.clear();
    }
    static #getCtx(lang = null) {
        let canvasContext = this.#canvasContexts.get(lang ||= "");
        if (!canvasContext) {
            const canvas = document.createElement("canvas");
            canvas.className = "hiddenCanvasElement";
            canvas.lang = lang;
            document.body.append(canvas);
            canvasContext = canvas.getContext("2d", {
                alpha: false,
                willReadFrequently: true
            });
            this.#canvasContexts.set(lang, canvasContext);
        }
        return canvasContext;
    }
    static #ensureMinFontSizeComputed() {
        if (this.#minFontSize !== null) return;
        const div = document.createElement("div");
        div.style.opacity = 0;
        div.style.lineHeight = 1;
        div.style.fontSize = "1px";
        div.textContent = "X";
        document.body.append(div);
        this.#minFontSize = div.getBoundingClientRect().height;
        div.remove();
    }
    static #getAscent(fontFamily, lang) {
        const cachedAscent = this.#ascentCache.get(fontFamily);
        if (cachedAscent) return cachedAscent;
        const ctx = this.#getCtx(lang);
        const savedFont = ctx.font;
        ctx.canvas.width = ctx.canvas.height = $cca4aceb320d03d3$var$DEFAULT_FONT_SIZE;
        ctx.font = `${$cca4aceb320d03d3$var$DEFAULT_FONT_SIZE}px ${fontFamily}`;
        const metrics = ctx.measureText("");
        let ascent = metrics.fontBoundingBoxAscent;
        let descent = Math.abs(metrics.fontBoundingBoxDescent);
        if (ascent) {
            const ratio = ascent / (ascent + descent);
            this.#ascentCache.set(fontFamily, ratio);
            ctx.canvas.width = ctx.canvas.height = 0;
            ctx.font = savedFont;
            return ratio;
        }
        ctx.strokeStyle = "red";
        ctx.clearRect(0, 0, $cca4aceb320d03d3$var$DEFAULT_FONT_SIZE, $cca4aceb320d03d3$var$DEFAULT_FONT_SIZE);
        ctx.strokeText("g", 0, 0);
        let pixels = ctx.getImageData(0, 0, $cca4aceb320d03d3$var$DEFAULT_FONT_SIZE, $cca4aceb320d03d3$var$DEFAULT_FONT_SIZE).data;
        descent = 0;
        for(let i = pixels.length - 1 - 3; i >= 0; i -= 4)if (pixels[i] > 0) {
            descent = Math.ceil(i / 4 / $cca4aceb320d03d3$var$DEFAULT_FONT_SIZE);
            break;
        }
        ctx.clearRect(0, 0, $cca4aceb320d03d3$var$DEFAULT_FONT_SIZE, $cca4aceb320d03d3$var$DEFAULT_FONT_SIZE);
        ctx.strokeText("A", 0, $cca4aceb320d03d3$var$DEFAULT_FONT_SIZE);
        pixels = ctx.getImageData(0, 0, $cca4aceb320d03d3$var$DEFAULT_FONT_SIZE, $cca4aceb320d03d3$var$DEFAULT_FONT_SIZE).data;
        ascent = 0;
        for(let i = 0, ii = pixels.length; i < ii; i += 4)if (pixels[i] > 0) {
            ascent = $cca4aceb320d03d3$var$DEFAULT_FONT_SIZE - Math.floor(i / 4 / $cca4aceb320d03d3$var$DEFAULT_FONT_SIZE);
            break;
        }
        ctx.canvas.width = ctx.canvas.height = 0;
        ctx.font = savedFont;
        const ratio = ascent ? ascent / (ascent + descent) : $cca4aceb320d03d3$var$DEFAULT_FONT_ASCENT;
        this.#ascentCache.set(fontFamily, ratio);
        return ratio;
    }
}
function $cca4aceb320d03d3$var$renderTextLayer() {
    $cca4aceb320d03d3$var$deprecated("`renderTextLayer`, please use `TextLayer` instead.");
    const { textContentSource: textContentSource, container: container, viewport: viewport, ...rest } = arguments[0];
    const restKeys = Object.keys(rest);
    if (restKeys.length > 0) $cca4aceb320d03d3$var$warn("Ignoring `renderTextLayer` parameters: " + restKeys.join(", "));
    const textLayer = new $cca4aceb320d03d3$var$TextLayer({
        textContentSource: textContentSource,
        container: container,
        viewport: viewport
    });
    const { textDivs: textDivs, textContentItemsStr: textContentItemsStr } = textLayer;
    const promise = textLayer.render();
    return {
        promise: promise,
        textDivs: textDivs,
        textContentItemsStr: textContentItemsStr
    };
}
function $cca4aceb320d03d3$var$updateTextLayer() {
    $cca4aceb320d03d3$var$deprecated("`updateTextLayer`, please use `TextLayer` instead.");
}
class $cca4aceb320d03d3$var$XfaText {
    static textContent(xfa) {
        const items = [];
        const output = {
            items: items,
            styles: Object.create(null)
        };
        function walk(node) {
            if (!node) return;
            let str = null;
            const name = node.name;
            if (name === "#text") str = node.value;
            else if (!$cca4aceb320d03d3$var$XfaText.shouldBuildText(name)) return;
            else if (node?.attributes?.textContent) str = node.attributes.textContent;
            else if (node.value) str = node.value;
            if (str !== null) items.push({
                str: str
            });
            if (!node.children) return;
            for (const child of node.children)walk(child);
        }
        walk(xfa);
        return output;
    }
    static shouldBuildText(name) {
        return !(name === "textarea" || name === "input" || name === "option" || name === "select");
    }
}
const $cca4aceb320d03d3$var$DEFAULT_RANGE_CHUNK_SIZE = 65536;
const $cca4aceb320d03d3$var$RENDERING_CANCELLED_TIMEOUT = 100;
const $cca4aceb320d03d3$var$DELAYED_CLEANUP_TIMEOUT = 5000;
const $cca4aceb320d03d3$var$DefaultCanvasFactory = $cca4aceb320d03d3$var$isNodeJS ? $cca4aceb320d03d3$var$NodeCanvasFactory : $cca4aceb320d03d3$var$DOMCanvasFactory;
const $cca4aceb320d03d3$var$DefaultCMapReaderFactory = $cca4aceb320d03d3$var$isNodeJS ? $cca4aceb320d03d3$var$NodeCMapReaderFactory : $cca4aceb320d03d3$var$DOMCMapReaderFactory;
const $cca4aceb320d03d3$var$DefaultFilterFactory = $cca4aceb320d03d3$var$isNodeJS ? $cca4aceb320d03d3$var$NodeFilterFactory : $cca4aceb320d03d3$var$DOMFilterFactory;
const $cca4aceb320d03d3$var$DefaultStandardFontDataFactory = $cca4aceb320d03d3$var$isNodeJS ? $cca4aceb320d03d3$var$NodeStandardFontDataFactory : $cca4aceb320d03d3$var$DOMStandardFontDataFactory;
function $cca4aceb320d03d3$var$getDocument(src = {}) {
    if (typeof src === "string" || src instanceof URL) src = {
        url: src
    };
    else if (src instanceof ArrayBuffer || ArrayBuffer.isView(src)) src = {
        data: src
    };
    const task = new $cca4aceb320d03d3$var$PDFDocumentLoadingTask();
    const { docId: docId } = task;
    const url = src.url ? $cca4aceb320d03d3$var$getUrlProp(src.url) : null;
    const data = src.data ? $cca4aceb320d03d3$var$getDataProp(src.data) : null;
    const httpHeaders = src.httpHeaders || null;
    const withCredentials = src.withCredentials === true;
    const password = src.password ?? null;
    const rangeTransport = src.range instanceof $cca4aceb320d03d3$var$PDFDataRangeTransport ? src.range : null;
    const rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : $cca4aceb320d03d3$var$DEFAULT_RANGE_CHUNK_SIZE;
    let worker = src.worker instanceof $cca4aceb320d03d3$var$PDFWorker ? src.worker : null;
    const verbosity = src.verbosity;
    const docBaseUrl = typeof src.docBaseUrl === "string" && !$cca4aceb320d03d3$var$isDataScheme(src.docBaseUrl) ? src.docBaseUrl : null;
    const cMapUrl = typeof src.cMapUrl === "string" ? src.cMapUrl : null;
    const cMapPacked = src.cMapPacked !== false;
    const CMapReaderFactory = src.CMapReaderFactory || $cca4aceb320d03d3$var$DefaultCMapReaderFactory;
    const standardFontDataUrl = typeof src.standardFontDataUrl === "string" ? src.standardFontDataUrl : null;
    const StandardFontDataFactory = src.StandardFontDataFactory || $cca4aceb320d03d3$var$DefaultStandardFontDataFactory;
    const ignoreErrors = src.stopAtErrors !== true;
    const maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
    const isEvalSupported = src.isEvalSupported !== false;
    const isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !$cca4aceb320d03d3$var$isNodeJS;
    const canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
    const disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : $cca4aceb320d03d3$var$isNodeJS;
    const fontExtraProperties = src.fontExtraProperties === true;
    const enableXfa = src.enableXfa === true;
    const ownerDocument = src.ownerDocument || globalThis.document;
    const disableRange = src.disableRange === true;
    const disableStream = src.disableStream === true;
    const disableAutoFetch = src.disableAutoFetch === true;
    const pdfBug = src.pdfBug === true;
    const enableHWA = src.enableHWA === true;
    const length = rangeTransport ? rangeTransport.length : src.length ?? NaN;
    const useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !$cca4aceb320d03d3$var$isNodeJS && !disableFontFace;
    const useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : CMapReaderFactory === $cca4aceb320d03d3$var$DOMCMapReaderFactory && StandardFontDataFactory === $cca4aceb320d03d3$var$DOMStandardFontDataFactory && cMapUrl && standardFontDataUrl && $cca4aceb320d03d3$var$isValidFetchUrl(cMapUrl, document.baseURI) && $cca4aceb320d03d3$var$isValidFetchUrl(standardFontDataUrl, document.baseURI);
    const canvasFactory = src.canvasFactory || new $cca4aceb320d03d3$var$DefaultCanvasFactory({
        ownerDocument: ownerDocument,
        enableHWA: enableHWA
    });
    const filterFactory = src.filterFactory || new $cca4aceb320d03d3$var$DefaultFilterFactory({
        docId: docId,
        ownerDocument: ownerDocument
    });
    const styleElement = null;
    $cca4aceb320d03d3$var$setVerbosityLevel(verbosity);
    const transportFactory = {
        canvasFactory: canvasFactory,
        filterFactory: filterFactory
    };
    if (!useWorkerFetch) {
        transportFactory.cMapReaderFactory = new CMapReaderFactory({
            baseUrl: cMapUrl,
            isCompressed: cMapPacked
        });
        transportFactory.standardFontDataFactory = new StandardFontDataFactory({
            baseUrl: standardFontDataUrl
        });
    }
    if (!worker) {
        const workerParams = {
            verbosity: verbosity,
            port: $cca4aceb320d03d3$var$GlobalWorkerOptions.workerPort
        };
        worker = workerParams.port ? $cca4aceb320d03d3$var$PDFWorker.fromPort(workerParams) : new $cca4aceb320d03d3$var$PDFWorker(workerParams);
        task._worker = worker;
    }
    const docParams = {
        docId: docId,
        apiVersion: "4.4.168",
        data: data,
        password: password,
        disableAutoFetch: disableAutoFetch,
        rangeChunkSize: rangeChunkSize,
        length: length,
        docBaseUrl: docBaseUrl,
        enableXfa: enableXfa,
        evaluatorOptions: {
            maxImageSize: maxImageSize,
            disableFontFace: disableFontFace,
            ignoreErrors: ignoreErrors,
            isEvalSupported: isEvalSupported,
            isOffscreenCanvasSupported: isOffscreenCanvasSupported,
            canvasMaxAreaInBytes: canvasMaxAreaInBytes,
            fontExtraProperties: fontExtraProperties,
            useSystemFonts: useSystemFonts,
            cMapUrl: useWorkerFetch ? cMapUrl : null,
            standardFontDataUrl: useWorkerFetch ? standardFontDataUrl : null
        }
    };
    const transportParams = {
        disableFontFace: disableFontFace,
        fontExtraProperties: fontExtraProperties,
        ownerDocument: ownerDocument,
        pdfBug: pdfBug,
        styleElement: styleElement,
        loadingParams: {
            disableAutoFetch: disableAutoFetch,
            enableXfa: enableXfa
        }
    };
    worker.promise.then(function() {
        if (task.destroyed) throw new Error("Loading aborted");
        if (worker.destroyed) throw new Error("Worker was destroyed");
        const workerIdPromise = worker.messageHandler.sendWithPromise("GetDocRequest", docParams, data ? [
            data.buffer
        ] : null);
        let networkStream;
        if (rangeTransport) networkStream = new $cca4aceb320d03d3$var$PDFDataTransportStream(rangeTransport, {
            disableRange: disableRange,
            disableStream: disableStream
        });
        else if (!data) {
            if (!url) throw new Error("getDocument - no `url` parameter provided.");
            const createPDFNetworkStream = (params)=>{
                if ($cca4aceb320d03d3$var$isNodeJS) {
                    const isFetchSupported = function() {
                        return typeof fetch !== "undefined" && typeof Response !== "undefined" && "body" in Response.prototype;
                    };
                    return isFetchSupported() && $cca4aceb320d03d3$var$isValidFetchUrl(params.url) ? new $cca4aceb320d03d3$var$PDFFetchStream(params) : new $cca4aceb320d03d3$var$PDFNodeStream(params);
                }
                return $cca4aceb320d03d3$var$isValidFetchUrl(params.url) ? new $cca4aceb320d03d3$var$PDFFetchStream(params) : new $cca4aceb320d03d3$var$PDFNetworkStream(params);
            };
            networkStream = createPDFNetworkStream({
                url: url,
                length: length,
                httpHeaders: httpHeaders,
                withCredentials: withCredentials,
                rangeChunkSize: rangeChunkSize,
                disableRange: disableRange,
                disableStream: disableStream
            });
        }
        return workerIdPromise.then((workerId)=>{
            if (task.destroyed) throw new Error("Loading aborted");
            if (worker.destroyed) throw new Error("Worker was destroyed");
            const messageHandler = new $cca4aceb320d03d3$var$MessageHandler(docId, workerId, worker.port);
            const transport = new $cca4aceb320d03d3$var$WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory);
            task._transport = transport;
            messageHandler.send("Ready", null);
        });
    }).catch(task._capability.reject);
    return task;
}
function $cca4aceb320d03d3$var$getUrlProp(val) {
    if (val instanceof URL) return val.href;
    try {
        return new URL(val, window.location).href;
    } catch  {
        if ($cca4aceb320d03d3$var$isNodeJS && typeof val === "string") return val;
    }
    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
}
function $cca4aceb320d03d3$var$getDataProp(val) {
    if ($cca4aceb320d03d3$var$isNodeJS && typeof $cca4aceb320d03d3$require$Buffer !== "undefined" && val instanceof $cca4aceb320d03d3$require$Buffer) throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
    if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) return val;
    if (typeof val === "string") return $cca4aceb320d03d3$var$stringToBytes(val);
    if (val instanceof ArrayBuffer || ArrayBuffer.isView(val) || typeof val === "object" && !isNaN(val?.length)) return new Uint8Array(val);
    throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
}
function $cca4aceb320d03d3$var$isRefProxy(ref) {
    return typeof ref === "object" && Number.isInteger(ref?.num) && ref.num >= 0 && Number.isInteger(ref?.gen) && ref.gen >= 0;
}
class $cca4aceb320d03d3$var$PDFDocumentLoadingTask {
    static #docId = 0;
    constructor(){
        this._capability = Promise.withResolvers();
        this._transport = null;
        this._worker = null;
        this.docId = `d${$cca4aceb320d03d3$var$PDFDocumentLoadingTask.#docId++}`;
        this.destroyed = false;
        this.onPassword = null;
        this.onProgress = null;
    }
    get promise() {
        return this._capability.promise;
    }
    async destroy() {
        this.destroyed = true;
        try {
            if (this._worker?.port) this._worker._pendingDestroy = true;
            await this._transport?.destroy();
        } catch (ex) {
            if (this._worker?.port) delete this._worker._pendingDestroy;
            throw ex;
        }
        this._transport = null;
        if (this._worker) {
            this._worker.destroy();
            this._worker = null;
        }
    }
}
class $cca4aceb320d03d3$var$PDFDataRangeTransport {
    constructor(length, initialData, progressiveDone = false, contentDispositionFilename = null){
        this.length = length;
        this.initialData = initialData;
        this.progressiveDone = progressiveDone;
        this.contentDispositionFilename = contentDispositionFilename;
        this._rangeListeners = [];
        this._progressListeners = [];
        this._progressiveReadListeners = [];
        this._progressiveDoneListeners = [];
        this._readyCapability = Promise.withResolvers();
    }
    addRangeListener(listener) {
        this._rangeListeners.push(listener);
    }
    addProgressListener(listener) {
        this._progressListeners.push(listener);
    }
    addProgressiveReadListener(listener) {
        this._progressiveReadListeners.push(listener);
    }
    addProgressiveDoneListener(listener) {
        this._progressiveDoneListeners.push(listener);
    }
    onDataRange(begin, chunk) {
        for (const listener of this._rangeListeners)listener(begin, chunk);
    }
    onDataProgress(loaded, total) {
        this._readyCapability.promise.then(()=>{
            for (const listener of this._progressListeners)listener(loaded, total);
        });
    }
    onDataProgressiveRead(chunk) {
        this._readyCapability.promise.then(()=>{
            for (const listener of this._progressiveReadListeners)listener(chunk);
        });
    }
    onDataProgressiveDone() {
        this._readyCapability.promise.then(()=>{
            for (const listener of this._progressiveDoneListeners)listener();
        });
    }
    transportReady() {
        this._readyCapability.resolve();
    }
    requestDataRange(begin, end) {
        $cca4aceb320d03d3$var$unreachable("Abstract method PDFDataRangeTransport.requestDataRange");
    }
    abort() {}
}
class $cca4aceb320d03d3$var$PDFDocumentProxy {
    constructor(pdfInfo, transport){
        this._pdfInfo = pdfInfo;
        this._transport = transport;
    }
    get annotationStorage() {
        return this._transport.annotationStorage;
    }
    get filterFactory() {
        return this._transport.filterFactory;
    }
    get numPages() {
        return this._pdfInfo.numPages;
    }
    get fingerprints() {
        return this._pdfInfo.fingerprints;
    }
    get isPureXfa() {
        return $cca4aceb320d03d3$var$shadow(this, "isPureXfa", !!this._transport._htmlForXfa);
    }
    get allXfaHtml() {
        return this._transport._htmlForXfa;
    }
    getPage(pageNumber) {
        return this._transport.getPage(pageNumber);
    }
    getPageIndex(ref) {
        return this._transport.getPageIndex(ref);
    }
    getDestinations() {
        return this._transport.getDestinations();
    }
    getDestination(id) {
        return this._transport.getDestination(id);
    }
    getPageLabels() {
        return this._transport.getPageLabels();
    }
    getPageLayout() {
        return this._transport.getPageLayout();
    }
    getPageMode() {
        return this._transport.getPageMode();
    }
    getViewerPreferences() {
        return this._transport.getViewerPreferences();
    }
    getOpenAction() {
        return this._transport.getOpenAction();
    }
    getAttachments() {
        return this._transport.getAttachments();
    }
    getJSActions() {
        return this._transport.getDocJSActions();
    }
    getOutline() {
        return this._transport.getOutline();
    }
    getOptionalContentConfig({ intent: intent = "display" } = {}) {
        const { renderingIntent: renderingIntent } = this._transport.getRenderingIntent(intent);
        return this._transport.getOptionalContentConfig(renderingIntent);
    }
    getPermissions() {
        return this._transport.getPermissions();
    }
    getMetadata() {
        return this._transport.getMetadata();
    }
    getMarkInfo() {
        return this._transport.getMarkInfo();
    }
    getData() {
        return this._transport.getData();
    }
    saveDocument() {
        return this._transport.saveDocument();
    }
    getDownloadInfo() {
        return this._transport.downloadInfoCapability.promise;
    }
    cleanup(keepLoadedFonts = false) {
        return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
    }
    destroy() {
        return this.loadingTask.destroy();
    }
    cachedPageNumber(ref) {
        return this._transport.cachedPageNumber(ref);
    }
    get loadingParams() {
        return this._transport.loadingParams;
    }
    get loadingTask() {
        return this._transport.loadingTask;
    }
    getFieldObjects() {
        return this._transport.getFieldObjects();
    }
    hasJSActions() {
        return this._transport.hasJSActions();
    }
    getCalculationOrderIds() {
        return this._transport.getCalculationOrderIds();
    }
}
class $cca4aceb320d03d3$var$PDFPageProxy {
    #delayedCleanupTimeout = null;
    #pendingCleanup = false;
    constructor(pageIndex, pageInfo, transport, pdfBug = false){
        this._pageIndex = pageIndex;
        this._pageInfo = pageInfo;
        this._transport = transport;
        this._stats = pdfBug ? new $cca4aceb320d03d3$var$StatTimer() : null;
        this._pdfBug = pdfBug;
        this.commonObjs = transport.commonObjs;
        this.objs = new $cca4aceb320d03d3$var$PDFObjects();
        this._maybeCleanupAfterRender = false;
        this._intentStates = new Map();
        this.destroyed = false;
    }
    get pageNumber() {
        return this._pageIndex + 1;
    }
    get rotate() {
        return this._pageInfo.rotate;
    }
    get ref() {
        return this._pageInfo.ref;
    }
    get userUnit() {
        return this._pageInfo.userUnit;
    }
    get view() {
        return this._pageInfo.view;
    }
    getViewport({ scale: scale, rotation: rotation = this.rotate, offsetX: offsetX = 0, offsetY: offsetY = 0, dontFlip: dontFlip = false } = {}) {
        return new $cca4aceb320d03d3$var$PageViewport({
            viewBox: this.view,
            scale: scale,
            rotation: rotation,
            offsetX: offsetX,
            offsetY: offsetY,
            dontFlip: dontFlip
        });
    }
    getAnnotations({ intent: intent = "display" } = {}) {
        const { renderingIntent: renderingIntent } = this._transport.getRenderingIntent(intent);
        return this._transport.getAnnotations(this._pageIndex, renderingIntent);
    }
    getJSActions() {
        return this._transport.getPageJSActions(this._pageIndex);
    }
    get filterFactory() {
        return this._transport.filterFactory;
    }
    get isPureXfa() {
        return $cca4aceb320d03d3$var$shadow(this, "isPureXfa", !!this._transport._htmlForXfa);
    }
    async getXfa() {
        return this._transport._htmlForXfa?.children[this._pageIndex] || null;
    }
    render({ canvasContext: canvasContext, viewport: viewport, intent: intent = "display", annotationMode: annotationMode = $cca4aceb320d03d3$var$AnnotationMode.ENABLE, transform: transform = null, background: background = null, optionalContentConfigPromise: optionalContentConfigPromise = null, annotationCanvasMap: annotationCanvasMap = null, pageColors: pageColors = null, printAnnotationStorage: printAnnotationStorage = null }) {
        this._stats?.time("Overall");
        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage);
        const { renderingIntent: renderingIntent, cacheKey: cacheKey } = intentArgs;
        this.#pendingCleanup = false;
        this.#abortDelayedCleanup();
        optionalContentConfigPromise ||= this._transport.getOptionalContentConfig(renderingIntent);
        let intentState = this._intentStates.get(cacheKey);
        if (!intentState) {
            intentState = Object.create(null);
            this._intentStates.set(cacheKey, intentState);
        }
        if (intentState.streamReaderCancelTimeout) {
            clearTimeout(intentState.streamReaderCancelTimeout);
            intentState.streamReaderCancelTimeout = null;
        }
        const intentPrint = !!(renderingIntent & $cca4aceb320d03d3$var$RenderingIntentFlag.PRINT);
        if (!intentState.displayReadyCapability) {
            intentState.displayReadyCapability = Promise.withResolvers();
            intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
            };
            this._stats?.time("Page Request");
            this._pumpOperatorList(intentArgs);
        }
        const complete = (error)=>{
            intentState.renderTasks.delete(internalRenderTask);
            if (this._maybeCleanupAfterRender || intentPrint) this.#pendingCleanup = true;
            this.#tryCleanup(!intentPrint);
            if (error) {
                internalRenderTask.capability.reject(error);
                this._abortOperatorList({
                    intentState: intentState,
                    reason: error instanceof Error ? error : new Error(error)
                });
            } else internalRenderTask.capability.resolve();
            if (this._stats) {
                this._stats.timeEnd("Rendering");
                this._stats.timeEnd("Overall");
                if (globalThis.Stats?.enabled) globalThis.Stats.add(this.pageNumber, this._stats);
            }
        };
        const internalRenderTask = new $cca4aceb320d03d3$var$InternalRenderTask({
            callback: complete,
            params: {
                canvasContext: canvasContext,
                viewport: viewport,
                transform: transform,
                background: background
            },
            objs: this.objs,
            commonObjs: this.commonObjs,
            annotationCanvasMap: annotationCanvasMap,
            operatorList: intentState.operatorList,
            pageIndex: this._pageIndex,
            canvasFactory: this._transport.canvasFactory,
            filterFactory: this._transport.filterFactory,
            useRequestAnimationFrame: !intentPrint,
            pdfBug: this._pdfBug,
            pageColors: pageColors
        });
        (intentState.renderTasks ||= new Set()).add(internalRenderTask);
        const renderTask = internalRenderTask.task;
        Promise.all([
            intentState.displayReadyCapability.promise,
            optionalContentConfigPromise
        ]).then(([transparency, optionalContentConfig])=>{
            if (this.destroyed) {
                complete();
                return;
            }
            this._stats?.time("Rendering");
            if (!(optionalContentConfig.renderingIntent & renderingIntent)) throw new Error("Must use the same `intent`-argument when calling the `PDFPageProxy.render` and `PDFDocumentProxy.getOptionalContentConfig` methods.");
            internalRenderTask.initializeGraphics({
                transparency: transparency,
                optionalContentConfig: optionalContentConfig
            });
            internalRenderTask.operatorListChanged();
        }).catch(complete);
        return renderTask;
    }
    getOperatorList({ intent: intent = "display", annotationMode: annotationMode = $cca4aceb320d03d3$var$AnnotationMode.ENABLE, printAnnotationStorage: printAnnotationStorage = null } = {}) {
        function operatorListChanged() {
            if (intentState.operatorList.lastChunk) {
                intentState.opListReadCapability.resolve(intentState.operatorList);
                intentState.renderTasks.delete(opListTask);
            }
        }
        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, true);
        let intentState = this._intentStates.get(intentArgs.cacheKey);
        if (!intentState) {
            intentState = Object.create(null);
            this._intentStates.set(intentArgs.cacheKey, intentState);
        }
        let opListTask;
        if (!intentState.opListReadCapability) {
            opListTask = Object.create(null);
            opListTask.operatorListChanged = operatorListChanged;
            intentState.opListReadCapability = Promise.withResolvers();
            (intentState.renderTasks ||= new Set()).add(opListTask);
            intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
            };
            this._stats?.time("Page Request");
            this._pumpOperatorList(intentArgs);
        }
        return intentState.opListReadCapability.promise;
    }
    streamTextContent({ includeMarkedContent: includeMarkedContent = false, disableNormalization: disableNormalization = false } = {}) {
        const TEXT_CONTENT_CHUNK_SIZE = 100;
        return this._transport.messageHandler.sendWithStream("GetTextContent", {
            pageIndex: this._pageIndex,
            includeMarkedContent: includeMarkedContent === true,
            disableNormalization: disableNormalization === true
        }, {
            highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
            size (textContent) {
                return textContent.items.length;
            }
        });
    }
    getTextContent(params = {}) {
        if (this._transport._htmlForXfa) return this.getXfa().then((xfa)=>$cca4aceb320d03d3$var$XfaText.textContent(xfa));
        const readableStream = this.streamTextContent(params);
        return new Promise(function(resolve, reject) {
            function pump() {
                reader.read().then(function({ value: value, done: done }) {
                    if (done) {
                        resolve(textContent);
                        return;
                    }
                    textContent.lang ??= value.lang;
                    Object.assign(textContent.styles, value.styles);
                    textContent.items.push(...value.items);
                    pump();
                }, reject);
            }
            const reader = readableStream.getReader();
            const textContent = {
                items: [],
                styles: Object.create(null),
                lang: null
            };
            pump();
        });
    }
    getStructTree() {
        return this._transport.getStructTree(this._pageIndex);
    }
    _destroy() {
        this.destroyed = true;
        const waitOn = [];
        for (const intentState of this._intentStates.values()){
            this._abortOperatorList({
                intentState: intentState,
                reason: new Error("Page was destroyed."),
                force: true
            });
            if (intentState.opListReadCapability) continue;
            for (const internalRenderTask of intentState.renderTasks){
                waitOn.push(internalRenderTask.completed);
                internalRenderTask.cancel();
            }
        }
        this.objs.clear();
        this.#pendingCleanup = false;
        this.#abortDelayedCleanup();
        return Promise.all(waitOn);
    }
    cleanup(resetStats = false) {
        this.#pendingCleanup = true;
        const success = this.#tryCleanup(false);
        if (resetStats && success) this._stats &&= new $cca4aceb320d03d3$var$StatTimer();
        return success;
    }
    #tryCleanup(delayed = false) {
        this.#abortDelayedCleanup();
        if (!this.#pendingCleanup || this.destroyed) return false;
        if (delayed) {
            this.#delayedCleanupTimeout = setTimeout(()=>{
                this.#delayedCleanupTimeout = null;
                this.#tryCleanup(false);
            }, $cca4aceb320d03d3$var$DELAYED_CLEANUP_TIMEOUT);
            return false;
        }
        for (const { renderTasks: renderTasks, operatorList: operatorList } of this._intentStates.values()){
            if (renderTasks.size > 0 || !operatorList.lastChunk) return false;
        }
        this._intentStates.clear();
        this.objs.clear();
        this.#pendingCleanup = false;
        return true;
    }
    #abortDelayedCleanup() {
        if (this.#delayedCleanupTimeout) {
            clearTimeout(this.#delayedCleanupTimeout);
            this.#delayedCleanupTimeout = null;
        }
    }
    _startRenderPage(transparency, cacheKey) {
        const intentState = this._intentStates.get(cacheKey);
        if (!intentState) return;
        this._stats?.timeEnd("Page Request");
        intentState.displayReadyCapability?.resolve(transparency);
    }
    _renderPageChunk(operatorListChunk, intentState) {
        for(let i = 0, ii = operatorListChunk.length; i < ii; i++){
            intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
            intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
        }
        intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
        intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
        for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
        if (operatorListChunk.lastChunk) this.#tryCleanup(true);
    }
    _pumpOperatorList({ renderingIntent: renderingIntent, cacheKey: cacheKey, annotationStorageSerializable: annotationStorageSerializable }) {
        const { map: map, transfer: transfer } = annotationStorageSerializable;
        const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
            pageIndex: this._pageIndex,
            intent: renderingIntent,
            cacheKey: cacheKey,
            annotationStorage: map
        }, transfer);
        const reader = readableStream.getReader();
        const intentState = this._intentStates.get(cacheKey);
        intentState.streamReader = reader;
        const pump = ()=>{
            reader.read().then(({ value: value, done: done })=>{
                if (done) {
                    intentState.streamReader = null;
                    return;
                }
                if (this._transport.destroyed) return;
                this._renderPageChunk(value, intentState);
                pump();
            }, (reason)=>{
                intentState.streamReader = null;
                if (this._transport.destroyed) return;
                if (intentState.operatorList) {
                    intentState.operatorList.lastChunk = true;
                    for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                    this.#tryCleanup(true);
                }
                if (intentState.displayReadyCapability) intentState.displayReadyCapability.reject(reason);
                else if (intentState.opListReadCapability) intentState.opListReadCapability.reject(reason);
                else throw reason;
            });
        };
        pump();
    }
    _abortOperatorList({ intentState: intentState, reason: reason, force: force = false }) {
        if (!intentState.streamReader) return;
        if (intentState.streamReaderCancelTimeout) {
            clearTimeout(intentState.streamReaderCancelTimeout);
            intentState.streamReaderCancelTimeout = null;
        }
        if (!force) {
            if (intentState.renderTasks.size > 0) return;
            if (reason instanceof $cca4aceb320d03d3$var$RenderingCancelledException) {
                let delay = $cca4aceb320d03d3$var$RENDERING_CANCELLED_TIMEOUT;
                if (reason.extraDelay > 0 && reason.extraDelay < 1000) delay += reason.extraDelay;
                intentState.streamReaderCancelTimeout = setTimeout(()=>{
                    intentState.streamReaderCancelTimeout = null;
                    this._abortOperatorList({
                        intentState: intentState,
                        reason: reason,
                        force: true
                    });
                }, delay);
                return;
            }
        }
        intentState.streamReader.cancel(new $cca4aceb320d03d3$var$AbortException(reason.message)).catch(()=>{});
        intentState.streamReader = null;
        if (this._transport.destroyed) return;
        for (const [curCacheKey, curIntentState] of this._intentStates)if (curIntentState === intentState) {
            this._intentStates.delete(curCacheKey);
            break;
        }
        this.cleanup();
    }
    get stats() {
        return this._stats;
    }
}
class $cca4aceb320d03d3$var$LoopbackPort {
    #listeners = new Set();
    #deferred = Promise.resolve();
    postMessage(obj, transfer) {
        const event = {
            data: structuredClone(obj, transfer ? {
                transfer: transfer
            } : null)
        };
        this.#deferred.then(()=>{
            for (const listener of this.#listeners)listener.call(this, event);
        });
    }
    addEventListener(name, listener) {
        this.#listeners.add(listener);
    }
    removeEventListener(name, listener) {
        this.#listeners.delete(listener);
    }
    terminate() {
        this.#listeners.clear();
    }
}
const $cca4aceb320d03d3$var$PDFWorkerUtil = {
    isWorkerDisabled: false,
    fakeWorkerId: 0
};
if ($cca4aceb320d03d3$var$isNodeJS) {
    $cca4aceb320d03d3$var$PDFWorkerUtil.isWorkerDisabled = true;
    $cca4aceb320d03d3$var$GlobalWorkerOptions.workerSrc ||= "./pdf.worker.mjs";
}
$cca4aceb320d03d3$var$PDFWorkerUtil.isSameOrigin = function(baseUrl, otherUrl) {
    let base;
    try {
        base = new URL(baseUrl);
        if (!base.origin || base.origin === "null") return false;
    } catch  {
        return false;
    }
    const other = new URL(otherUrl, base);
    return base.origin === other.origin;
};
$cca4aceb320d03d3$var$PDFWorkerUtil.createCDNWrapper = function(url) {
    const wrapper = `await import("${url}");`;
    return URL.createObjectURL(new Blob([
        wrapper
    ], {
        type: "text/javascript"
    }));
};
class $cca4aceb320d03d3$var$PDFWorker {
    static #workerPorts;
    constructor({ name: name = null, port: port = null, verbosity: verbosity = $cca4aceb320d03d3$var$getVerbosityLevel() } = {}){
        this.name = name;
        this.destroyed = false;
        this.verbosity = verbosity;
        this._readyCapability = Promise.withResolvers();
        this._port = null;
        this._webWorker = null;
        this._messageHandler = null;
        if (port) {
            if ($cca4aceb320d03d3$var$PDFWorker.#workerPorts?.has(port)) throw new Error("Cannot use more than one PDFWorker per port.");
            ($cca4aceb320d03d3$var$PDFWorker.#workerPorts ||= new WeakMap()).set(port, this);
            this._initializeFromPort(port);
            return;
        }
        this._initialize();
    }
    get promise() {
        if ($cca4aceb320d03d3$var$isNodeJS) return Promise.all([
            $cca4aceb320d03d3$var$NodePackages.promise,
            this._readyCapability.promise
        ]);
        return this._readyCapability.promise;
    }
    #resolve() {
        this._readyCapability.resolve();
        this._messageHandler.send("configure", {
            verbosity: this.verbosity
        });
    }
    get port() {
        return this._port;
    }
    get messageHandler() {
        return this._messageHandler;
    }
    _initializeFromPort(port) {
        this._port = port;
        this._messageHandler = new $cca4aceb320d03d3$var$MessageHandler("main", "worker", port);
        this._messageHandler.on("ready", function() {});
        this.#resolve();
    }
    _initialize() {
        if ($cca4aceb320d03d3$var$PDFWorkerUtil.isWorkerDisabled || $cca4aceb320d03d3$var$PDFWorker.#mainThreadWorkerMessageHandler) {
            this._setupFakeWorker();
            return;
        }
        let { workerSrc: workerSrc } = $cca4aceb320d03d3$var$PDFWorker;
        try {
            if (!$cca4aceb320d03d3$var$PDFWorkerUtil.isSameOrigin(window.location.href, workerSrc)) workerSrc = $cca4aceb320d03d3$var$PDFWorkerUtil.createCDNWrapper(new URL(workerSrc, window.location).href);
            const worker = new Worker(workerSrc, {
                type: "module"
            });
            const messageHandler = new $cca4aceb320d03d3$var$MessageHandler("main", "worker", worker);
            const terminateEarly = ()=>{
                ac.abort();
                messageHandler.destroy();
                worker.terminate();
                if (this.destroyed) this._readyCapability.reject(new Error("Worker was destroyed"));
                else this._setupFakeWorker();
            };
            const ac = new AbortController();
            worker.addEventListener("error", ()=>{
                if (!this._webWorker) terminateEarly();
            }, {
                signal: ac.signal
            });
            messageHandler.on("test", (data)=>{
                ac.abort();
                if (this.destroyed || !data) {
                    terminateEarly();
                    return;
                }
                this._messageHandler = messageHandler;
                this._port = worker;
                this._webWorker = worker;
                this.#resolve();
            });
            messageHandler.on("ready", (data)=>{
                ac.abort();
                if (this.destroyed) {
                    terminateEarly();
                    return;
                }
                try {
                    sendTest();
                } catch  {
                    this._setupFakeWorker();
                }
            });
            const sendTest = ()=>{
                const testObj = new Uint8Array();
                messageHandler.send("test", testObj, [
                    testObj.buffer
                ]);
            };
            sendTest();
            return;
        } catch  {
            $cca4aceb320d03d3$var$info("The worker has been disabled.");
        }
        this._setupFakeWorker();
    }
    _setupFakeWorker() {
        if (!$cca4aceb320d03d3$var$PDFWorkerUtil.isWorkerDisabled) {
            $cca4aceb320d03d3$var$warn("Setting up fake worker.");
            $cca4aceb320d03d3$var$PDFWorkerUtil.isWorkerDisabled = true;
        }
        $cca4aceb320d03d3$var$PDFWorker._setupFakeWorkerGlobal.then((WorkerMessageHandler)=>{
            if (this.destroyed) {
                this._readyCapability.reject(new Error("Worker was destroyed"));
                return;
            }
            const port = new $cca4aceb320d03d3$var$LoopbackPort();
            this._port = port;
            const id = `fake${$cca4aceb320d03d3$var$PDFWorkerUtil.fakeWorkerId++}`;
            const workerHandler = new $cca4aceb320d03d3$var$MessageHandler(id + "_worker", id, port);
            WorkerMessageHandler.setup(workerHandler, port);
            this._messageHandler = new $cca4aceb320d03d3$var$MessageHandler(id, id + "_worker", port);
            this.#resolve();
        }).catch((reason)=>{
            this._readyCapability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
        });
    }
    destroy() {
        this.destroyed = true;
        if (this._webWorker) {
            this._webWorker.terminate();
            this._webWorker = null;
        }
        $cca4aceb320d03d3$var$PDFWorker.#workerPorts?.delete(this._port);
        this._port = null;
        if (this._messageHandler) {
            this._messageHandler.destroy();
            this._messageHandler = null;
        }
    }
    static fromPort(params) {
        if (!params?.port) throw new Error("PDFWorker.fromPort - invalid method signature.");
        const cachedPort = this.#workerPorts?.get(params.port);
        if (cachedPort) {
            if (cachedPort._pendingDestroy) throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
            return cachedPort;
        }
        return new $cca4aceb320d03d3$var$PDFWorker(params);
    }
    static get workerSrc() {
        if ($cca4aceb320d03d3$var$GlobalWorkerOptions.workerSrc) return $cca4aceb320d03d3$var$GlobalWorkerOptions.workerSrc;
        throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
    }
    static get #mainThreadWorkerMessageHandler() {
        try {
            return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
        } catch  {
            return null;
        }
    }
    static get _setupFakeWorkerGlobal() {
        const loader = async ()=>{
            if (this.#mainThreadWorkerMessageHandler) return this.#mainThreadWorkerMessageHandler;
            const worker = await import(/*webpackIgnore: true*/ this.workerSrc);
            return worker.WorkerMessageHandler;
        };
        return $cca4aceb320d03d3$var$shadow(this, "_setupFakeWorkerGlobal", loader());
    }
}
class $cca4aceb320d03d3$var$WorkerTransport {
    #methodPromises = new Map();
    #pageCache = new Map();
    #pagePromises = new Map();
    #pageRefCache = new Map();
    #passwordCapability = null;
    constructor(messageHandler, loadingTask, networkStream, params, factory){
        this.messageHandler = messageHandler;
        this.loadingTask = loadingTask;
        this.commonObjs = new $cca4aceb320d03d3$var$PDFObjects();
        this.fontLoader = new $cca4aceb320d03d3$var$FontLoader({
            ownerDocument: params.ownerDocument,
            styleElement: params.styleElement
        });
        this.loadingParams = params.loadingParams;
        this._params = params;
        this.canvasFactory = factory.canvasFactory;
        this.filterFactory = factory.filterFactory;
        this.cMapReaderFactory = factory.cMapReaderFactory;
        this.standardFontDataFactory = factory.standardFontDataFactory;
        this.destroyed = false;
        this.destroyCapability = null;
        this._networkStream = networkStream;
        this._fullReader = null;
        this._lastProgress = null;
        this.downloadInfoCapability = Promise.withResolvers();
        this.setupMessageHandler();
    }
    #cacheSimpleMethod(name, data = null) {
        const cachedPromise = this.#methodPromises.get(name);
        if (cachedPromise) return cachedPromise;
        const promise = this.messageHandler.sendWithPromise(name, data);
        this.#methodPromises.set(name, promise);
        return promise;
    }
    get annotationStorage() {
        return $cca4aceb320d03d3$var$shadow(this, "annotationStorage", new $cca4aceb320d03d3$var$AnnotationStorage());
    }
    getRenderingIntent(intent, annotationMode = $cca4aceb320d03d3$var$AnnotationMode.ENABLE, printAnnotationStorage = null, isOpList = false) {
        let renderingIntent = $cca4aceb320d03d3$var$RenderingIntentFlag.DISPLAY;
        let annotationStorageSerializable = $cca4aceb320d03d3$var$SerializableEmpty;
        switch(intent){
            case "any":
                renderingIntent = $cca4aceb320d03d3$var$RenderingIntentFlag.ANY;
                break;
            case "display":
                break;
            case "print":
                renderingIntent = $cca4aceb320d03d3$var$RenderingIntentFlag.PRINT;
                break;
            default:
                $cca4aceb320d03d3$var$warn(`getRenderingIntent - invalid intent: ${intent}`);
        }
        switch(annotationMode){
            case $cca4aceb320d03d3$var$AnnotationMode.DISABLE:
                renderingIntent += $cca4aceb320d03d3$var$RenderingIntentFlag.ANNOTATIONS_DISABLE;
                break;
            case $cca4aceb320d03d3$var$AnnotationMode.ENABLE:
                break;
            case $cca4aceb320d03d3$var$AnnotationMode.ENABLE_FORMS:
                renderingIntent += $cca4aceb320d03d3$var$RenderingIntentFlag.ANNOTATIONS_FORMS;
                break;
            case $cca4aceb320d03d3$var$AnnotationMode.ENABLE_STORAGE:
                renderingIntent += $cca4aceb320d03d3$var$RenderingIntentFlag.ANNOTATIONS_STORAGE;
                const annotationStorage = renderingIntent & $cca4aceb320d03d3$var$RenderingIntentFlag.PRINT && printAnnotationStorage instanceof $cca4aceb320d03d3$var$PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
                annotationStorageSerializable = annotationStorage.serializable;
                break;
            default:
                $cca4aceb320d03d3$var$warn(`getRenderingIntent - invalid annotationMode: ${annotationMode}`);
        }
        if (isOpList) renderingIntent += $cca4aceb320d03d3$var$RenderingIntentFlag.OPLIST;
        return {
            renderingIntent: renderingIntent,
            cacheKey: `${renderingIntent}_${annotationStorageSerializable.hash}`,
            annotationStorageSerializable: annotationStorageSerializable
        };
    }
    destroy() {
        if (this.destroyCapability) return this.destroyCapability.promise;
        this.destroyed = true;
        this.destroyCapability = Promise.withResolvers();
        this.#passwordCapability?.reject(new Error("Worker was destroyed during onPassword callback"));
        const waitOn = [];
        for (const page of this.#pageCache.values())waitOn.push(page._destroy());
        this.#pageCache.clear();
        this.#pagePromises.clear();
        this.#pageRefCache.clear();
        if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
        const terminated = this.messageHandler.sendWithPromise("Terminate", null);
        waitOn.push(terminated);
        Promise.all(waitOn).then(()=>{
            this.commonObjs.clear();
            this.fontLoader.clear();
            this.#methodPromises.clear();
            this.filterFactory.destroy();
            $cca4aceb320d03d3$var$TextLayer.cleanup();
            this._networkStream?.cancelAllRequests(new $cca4aceb320d03d3$var$AbortException("Worker was terminated."));
            if (this.messageHandler) {
                this.messageHandler.destroy();
                this.messageHandler = null;
            }
            this.destroyCapability.resolve();
        }, this.destroyCapability.reject);
        return this.destroyCapability.promise;
    }
    setupMessageHandler() {
        const { messageHandler: messageHandler, loadingTask: loadingTask } = this;
        messageHandler.on("GetReader", (data, sink)=>{
            $cca4aceb320d03d3$var$assert(this._networkStream, "GetReader - no `IPDFStream` instance available.");
            this._fullReader = this._networkStream.getFullReader();
            this._fullReader.onProgress = (evt)=>{
                this._lastProgress = {
                    loaded: evt.loaded,
                    total: evt.total
                };
            };
            sink.onPull = ()=>{
                this._fullReader.read().then(function({ value: value, done: done }) {
                    if (done) {
                        sink.close();
                        return;
                    }
                    $cca4aceb320d03d3$var$assert(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [
                        value
                    ]);
                }).catch((reason)=>{
                    sink.error(reason);
                });
            };
            sink.onCancel = (reason)=>{
                this._fullReader.cancel(reason);
                sink.ready.catch((readyReason)=>{
                    if (this.destroyed) return;
                    throw readyReason;
                });
            };
        });
        messageHandler.on("ReaderHeadersReady", (data)=>{
            const headersCapability = Promise.withResolvers();
            const fullReader = this._fullReader;
            fullReader.headersReady.then(()=>{
                if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                    if (this._lastProgress) loadingTask.onProgress?.(this._lastProgress);
                    fullReader.onProgress = (evt)=>{
                        loadingTask.onProgress?.({
                            loaded: evt.loaded,
                            total: evt.total
                        });
                    };
                }
                headersCapability.resolve({
                    isStreamingSupported: fullReader.isStreamingSupported,
                    isRangeSupported: fullReader.isRangeSupported,
                    contentLength: fullReader.contentLength
                });
            }, headersCapability.reject);
            return headersCapability.promise;
        });
        messageHandler.on("GetRangeReader", (data, sink)=>{
            $cca4aceb320d03d3$var$assert(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
            const rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
            if (!rangeReader) {
                sink.close();
                return;
            }
            sink.onPull = ()=>{
                rangeReader.read().then(function({ value: value, done: done }) {
                    if (done) {
                        sink.close();
                        return;
                    }
                    $cca4aceb320d03d3$var$assert(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [
                        value
                    ]);
                }).catch((reason)=>{
                    sink.error(reason);
                });
            };
            sink.onCancel = (reason)=>{
                rangeReader.cancel(reason);
                sink.ready.catch((readyReason)=>{
                    if (this.destroyed) return;
                    throw readyReason;
                });
            };
        });
        messageHandler.on("GetDoc", ({ pdfInfo: pdfInfo })=>{
            this._numPages = pdfInfo.numPages;
            this._htmlForXfa = pdfInfo.htmlForXfa;
            delete pdfInfo.htmlForXfa;
            loadingTask._capability.resolve(new $cca4aceb320d03d3$var$PDFDocumentProxy(pdfInfo, this));
        });
        messageHandler.on("DocException", function(ex) {
            let reason;
            switch(ex.name){
                case "PasswordException":
                    reason = new $cca4aceb320d03d3$var$PasswordException(ex.message, ex.code);
                    break;
                case "InvalidPDFException":
                    reason = new $cca4aceb320d03d3$var$InvalidPDFException(ex.message);
                    break;
                case "MissingPDFException":
                    reason = new $cca4aceb320d03d3$var$MissingPDFException(ex.message);
                    break;
                case "UnexpectedResponseException":
                    reason = new $cca4aceb320d03d3$var$UnexpectedResponseException(ex.message, ex.status);
                    break;
                case "UnknownErrorException":
                    reason = new $cca4aceb320d03d3$var$UnknownErrorException(ex.message, ex.details);
                    break;
                default:
                    $cca4aceb320d03d3$var$unreachable("DocException - expected a valid Error.");
            }
            loadingTask._capability.reject(reason);
        });
        messageHandler.on("PasswordRequest", (exception)=>{
            this.#passwordCapability = Promise.withResolvers();
            if (loadingTask.onPassword) {
                const updatePassword = (password)=>{
                    if (password instanceof Error) this.#passwordCapability.reject(password);
                    else this.#passwordCapability.resolve({
                        password: password
                    });
                };
                try {
                    loadingTask.onPassword(updatePassword, exception.code);
                } catch (ex) {
                    this.#passwordCapability.reject(ex);
                }
            } else this.#passwordCapability.reject(new $cca4aceb320d03d3$var$PasswordException(exception.message, exception.code));
            return this.#passwordCapability.promise;
        });
        messageHandler.on("DataLoaded", (data)=>{
            loadingTask.onProgress?.({
                loaded: data.length,
                total: data.length
            });
            this.downloadInfoCapability.resolve(data);
        });
        messageHandler.on("StartRenderPage", (data)=>{
            if (this.destroyed) return;
            const page = this.#pageCache.get(data.pageIndex);
            page._startRenderPage(data.transparency, data.cacheKey);
        });
        messageHandler.on("commonobj", ([id, type, exportedData])=>{
            if (this.destroyed) return null;
            if (this.commonObjs.has(id)) return null;
            switch(type){
                case "Font":
                    const { disableFontFace: disableFontFace, fontExtraProperties: fontExtraProperties, pdfBug: pdfBug } = this._params;
                    if ("error" in exportedData) {
                        const exportedError = exportedData.error;
                        $cca4aceb320d03d3$var$warn(`Error during font loading: ${exportedError}`);
                        this.commonObjs.resolve(id, exportedError);
                        break;
                    }
                    const inspectFont = pdfBug && globalThis.FontInspector?.enabled ? (font, url)=>globalThis.FontInspector.fontAdded(font, url) : null;
                    const font = new $cca4aceb320d03d3$var$FontFaceObject(exportedData, {
                        disableFontFace: disableFontFace,
                        inspectFont: inspectFont
                    });
                    this.fontLoader.bind(font).catch(()=>messageHandler.sendWithPromise("FontFallback", {
                            id: id
                        })).finally(()=>{
                        if (!fontExtraProperties && font.data) font.data = null;
                        this.commonObjs.resolve(id, font);
                    });
                    break;
                case "CopyLocalImage":
                    const { imageRef: imageRef } = exportedData;
                    $cca4aceb320d03d3$var$assert(imageRef, "The imageRef must be defined.");
                    for (const pageProxy of this.#pageCache.values())for (const [, data] of pageProxy.objs){
                        if (data?.ref !== imageRef) continue;
                        if (!data.dataLen) return null;
                        this.commonObjs.resolve(id, structuredClone(data));
                        return data.dataLen;
                    }
                    break;
                case "FontPath":
                case "Image":
                case "Pattern":
                    this.commonObjs.resolve(id, exportedData);
                    break;
                default:
                    throw new Error(`Got unknown common object type ${type}`);
            }
            return null;
        });
        messageHandler.on("obj", ([id, pageIndex, type, imageData])=>{
            if (this.destroyed) return;
            const pageProxy = this.#pageCache.get(pageIndex);
            if (pageProxy.objs.has(id)) return;
            if (pageProxy._intentStates.size === 0) {
                imageData?.bitmap?.close();
                return;
            }
            switch(type){
                case "Image":
                    pageProxy.objs.resolve(id, imageData);
                    if (imageData?.dataLen > $cca4aceb320d03d3$var$MAX_IMAGE_SIZE_TO_CACHE) pageProxy._maybeCleanupAfterRender = true;
                    break;
                case "Pattern":
                    pageProxy.objs.resolve(id, imageData);
                    break;
                default:
                    throw new Error(`Got unknown object type ${type}`);
            }
        });
        messageHandler.on("DocProgress", (data)=>{
            if (this.destroyed) return;
            loadingTask.onProgress?.({
                loaded: data.loaded,
                total: data.total
            });
        });
        messageHandler.on("FetchBuiltInCMap", (data)=>{
            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
            if (!this.cMapReaderFactory) return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
            return this.cMapReaderFactory.fetch(data);
        });
        messageHandler.on("FetchStandardFontData", (data)=>{
            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
            if (!this.standardFontDataFactory) return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
            return this.standardFontDataFactory.fetch(data);
        });
    }
    getData() {
        return this.messageHandler.sendWithPromise("GetData", null);
    }
    saveDocument() {
        if (this.annotationStorage.size <= 0) $cca4aceb320d03d3$var$warn("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
        const { map: map, transfer: transfer } = this.annotationStorage.serializable;
        return this.messageHandler.sendWithPromise("SaveDocument", {
            isPureXfa: !!this._htmlForXfa,
            numPages: this._numPages,
            annotationStorage: map,
            filename: this._fullReader?.filename ?? null
        }, transfer).finally(()=>{
            this.annotationStorage.resetModified();
        });
    }
    getPage(pageNumber) {
        if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) return Promise.reject(new Error("Invalid page request."));
        const pageIndex = pageNumber - 1, cachedPromise = this.#pagePromises.get(pageIndex);
        if (cachedPromise) return cachedPromise;
        const promise = this.messageHandler.sendWithPromise("GetPage", {
            pageIndex: pageIndex
        }).then((pageInfo)=>{
            if (this.destroyed) throw new Error("Transport destroyed");
            if (pageInfo.refStr) this.#pageRefCache.set(pageInfo.refStr, pageNumber);
            const page = new $cca4aceb320d03d3$var$PDFPageProxy(pageIndex, pageInfo, this, this._params.pdfBug);
            this.#pageCache.set(pageIndex, page);
            return page;
        });
        this.#pagePromises.set(pageIndex, promise);
        return promise;
    }
    getPageIndex(ref) {
        if (!$cca4aceb320d03d3$var$isRefProxy(ref)) return Promise.reject(new Error("Invalid pageIndex request."));
        return this.messageHandler.sendWithPromise("GetPageIndex", {
            num: ref.num,
            gen: ref.gen
        });
    }
    getAnnotations(pageIndex, intent) {
        return this.messageHandler.sendWithPromise("GetAnnotations", {
            pageIndex: pageIndex,
            intent: intent
        });
    }
    getFieldObjects() {
        return this.#cacheSimpleMethod("GetFieldObjects");
    }
    hasJSActions() {
        return this.#cacheSimpleMethod("HasJSActions");
    }
    getCalculationOrderIds() {
        return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
    }
    getDestinations() {
        return this.messageHandler.sendWithPromise("GetDestinations", null);
    }
    getDestination(id) {
        if (typeof id !== "string") return Promise.reject(new Error("Invalid destination request."));
        return this.messageHandler.sendWithPromise("GetDestination", {
            id: id
        });
    }
    getPageLabels() {
        return this.messageHandler.sendWithPromise("GetPageLabels", null);
    }
    getPageLayout() {
        return this.messageHandler.sendWithPromise("GetPageLayout", null);
    }
    getPageMode() {
        return this.messageHandler.sendWithPromise("GetPageMode", null);
    }
    getViewerPreferences() {
        return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
    }
    getOpenAction() {
        return this.messageHandler.sendWithPromise("GetOpenAction", null);
    }
    getAttachments() {
        return this.messageHandler.sendWithPromise("GetAttachments", null);
    }
    getDocJSActions() {
        return this.#cacheSimpleMethod("GetDocJSActions");
    }
    getPageJSActions(pageIndex) {
        return this.messageHandler.sendWithPromise("GetPageJSActions", {
            pageIndex: pageIndex
        });
    }
    getStructTree(pageIndex) {
        return this.messageHandler.sendWithPromise("GetStructTree", {
            pageIndex: pageIndex
        });
    }
    getOutline() {
        return this.messageHandler.sendWithPromise("GetOutline", null);
    }
    getOptionalContentConfig(renderingIntent) {
        return this.#cacheSimpleMethod("GetOptionalContentConfig").then((data)=>new $cca4aceb320d03d3$var$OptionalContentConfig(data, renderingIntent));
    }
    getPermissions() {
        return this.messageHandler.sendWithPromise("GetPermissions", null);
    }
    getMetadata() {
        const name = "GetMetadata", cachedPromise = this.#methodPromises.get(name);
        if (cachedPromise) return cachedPromise;
        const promise = this.messageHandler.sendWithPromise(name, null).then((results)=>({
                info: results[0],
                metadata: results[1] ? new $cca4aceb320d03d3$var$Metadata(results[1]) : null,
                contentDispositionFilename: this._fullReader?.filename ?? null,
                contentLength: this._fullReader?.contentLength ?? null
            }));
        this.#methodPromises.set(name, promise);
        return promise;
    }
    getMarkInfo() {
        return this.messageHandler.sendWithPromise("GetMarkInfo", null);
    }
    async startCleanup(keepLoadedFonts = false) {
        if (this.destroyed) return;
        await this.messageHandler.sendWithPromise("Cleanup", null);
        for (const page of this.#pageCache.values()){
            const cleanupSuccessful = page.cleanup();
            if (!cleanupSuccessful) throw new Error(`startCleanup: Page ${page.pageNumber} is currently rendering.`);
        }
        this.commonObjs.clear();
        if (!keepLoadedFonts) this.fontLoader.clear();
        this.#methodPromises.clear();
        this.filterFactory.destroy(true);
        $cca4aceb320d03d3$var$TextLayer.cleanup();
    }
    cachedPageNumber(ref) {
        if (!$cca4aceb320d03d3$var$isRefProxy(ref)) return null;
        const refStr = ref.gen === 0 ? `${ref.num}R` : `${ref.num}R${ref.gen}`;
        return this.#pageRefCache.get(refStr) ?? null;
    }
}
const $cca4aceb320d03d3$var$INITIAL_DATA = Symbol("INITIAL_DATA");
class $cca4aceb320d03d3$var$PDFObjects {
    #objs = Object.create(null);
    #ensureObj(objId) {
        return this.#objs[objId] ||= {
            ...Promise.withResolvers(),
            data: $cca4aceb320d03d3$var$INITIAL_DATA
        };
    }
    get(objId, callback = null) {
        if (callback) {
            const obj = this.#ensureObj(objId);
            obj.promise.then(()=>callback(obj.data));
            return null;
        }
        const obj = this.#objs[objId];
        if (!obj || obj.data === $cca4aceb320d03d3$var$INITIAL_DATA) throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
        return obj.data;
    }
    has(objId) {
        const obj = this.#objs[objId];
        return !!obj && obj.data !== $cca4aceb320d03d3$var$INITIAL_DATA;
    }
    resolve(objId, data = null) {
        const obj = this.#ensureObj(objId);
        obj.data = data;
        obj.resolve();
    }
    clear() {
        for(const objId in this.#objs){
            const { data: data } = this.#objs[objId];
            data?.bitmap?.close();
        }
        this.#objs = Object.create(null);
    }
    *[Symbol.iterator]() {
        for(const objId in this.#objs){
            const { data: data } = this.#objs[objId];
            if (data === $cca4aceb320d03d3$var$INITIAL_DATA) continue;
            yield [
                objId,
                data
            ];
        }
    }
}
class $cca4aceb320d03d3$var$RenderTask {
    #internalRenderTask = null;
    constructor(internalRenderTask){
        this.#internalRenderTask = internalRenderTask;
        this.onContinue = null;
    }
    get promise() {
        return this.#internalRenderTask.capability.promise;
    }
    cancel(extraDelay = 0) {
        this.#internalRenderTask.cancel(null, extraDelay);
    }
    get separateAnnots() {
        const { separateAnnots: separateAnnots } = this.#internalRenderTask.operatorList;
        if (!separateAnnots) return false;
        const { annotationCanvasMap: annotationCanvasMap } = this.#internalRenderTask;
        return separateAnnots.form || separateAnnots.canvas && annotationCanvasMap?.size > 0;
    }
}
class $cca4aceb320d03d3$var$InternalRenderTask {
    #rAF = null;
    static #canvasInUse = new WeakSet();
    constructor({ callback: callback, params: params, objs: objs, commonObjs: commonObjs, annotationCanvasMap: annotationCanvasMap, operatorList: operatorList, pageIndex: pageIndex, canvasFactory: canvasFactory, filterFactory: filterFactory, useRequestAnimationFrame: useRequestAnimationFrame = false, pdfBug: pdfBug = false, pageColors: pageColors = null }){
        this.callback = callback;
        this.params = params;
        this.objs = objs;
        this.commonObjs = commonObjs;
        this.annotationCanvasMap = annotationCanvasMap;
        this.operatorListIdx = null;
        this.operatorList = operatorList;
        this._pageIndex = pageIndex;
        this.canvasFactory = canvasFactory;
        this.filterFactory = filterFactory;
        this._pdfBug = pdfBug;
        this.pageColors = pageColors;
        this.running = false;
        this.graphicsReadyCallback = null;
        this.graphicsReady = false;
        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
        this.cancelled = false;
        this.capability = Promise.withResolvers();
        this.task = new $cca4aceb320d03d3$var$RenderTask(this);
        this._cancelBound = this.cancel.bind(this);
        this._continueBound = this._continue.bind(this);
        this._scheduleNextBound = this._scheduleNext.bind(this);
        this._nextBound = this._next.bind(this);
        this._canvas = params.canvasContext.canvas;
    }
    get completed() {
        return this.capability.promise.catch(function() {});
    }
    initializeGraphics({ transparency: transparency = false, optionalContentConfig: optionalContentConfig }) {
        if (this.cancelled) return;
        if (this._canvas) {
            if ($cca4aceb320d03d3$var$InternalRenderTask.#canvasInUse.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
            $cca4aceb320d03d3$var$InternalRenderTask.#canvasInUse.add(this._canvas);
        }
        if (this._pdfBug && globalThis.StepperManager?.enabled) {
            this.stepper = globalThis.StepperManager.create(this._pageIndex);
            this.stepper.init(this.operatorList);
            this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
        }
        const { canvasContext: canvasContext, viewport: viewport, transform: transform, background: background } = this.params;
        this.gfx = new $cca4aceb320d03d3$var$CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
            optionalContentConfig: optionalContentConfig
        }, this.annotationCanvasMap, this.pageColors);
        this.gfx.beginDrawing({
            transform: transform,
            viewport: viewport,
            transparency: transparency,
            background: background
        });
        this.operatorListIdx = 0;
        this.graphicsReady = true;
        this.graphicsReadyCallback?.();
    }
    cancel(error = null, extraDelay = 0) {
        this.running = false;
        this.cancelled = true;
        this.gfx?.endDrawing();
        if (this.#rAF) {
            window.cancelAnimationFrame(this.#rAF);
            this.#rAF = null;
        }
        $cca4aceb320d03d3$var$InternalRenderTask.#canvasInUse.delete(this._canvas);
        this.callback(error || new $cca4aceb320d03d3$var$RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay));
    }
    operatorListChanged() {
        if (!this.graphicsReady) {
            this.graphicsReadyCallback ||= this._continueBound;
            return;
        }
        this.stepper?.updateOperatorList(this.operatorList);
        if (this.running) return;
        this._continue();
    }
    _continue() {
        this.running = true;
        if (this.cancelled) return;
        if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
        else this._scheduleNext();
    }
    _scheduleNext() {
        if (this._useRequestAnimationFrame) this.#rAF = window.requestAnimationFrame(()=>{
            this.#rAF = null;
            this._nextBound().catch(this._cancelBound);
        });
        else Promise.resolve().then(this._nextBound).catch(this._cancelBound);
    }
    async _next() {
        if (this.cancelled) return;
        this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
        if (this.operatorListIdx === this.operatorList.argsArray.length) {
            this.running = false;
            if (this.operatorList.lastChunk) {
                this.gfx.endDrawing();
                $cca4aceb320d03d3$var$InternalRenderTask.#canvasInUse.delete(this._canvas);
                this.callback();
            }
        }
    }
}
const $cca4aceb320d03d3$var$version = "4.4.168";
const $cca4aceb320d03d3$var$build = "19fbc8998";
function $cca4aceb320d03d3$var$makeColorComp(n) {
    return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
}
function $cca4aceb320d03d3$var$scaleAndClamp(x) {
    return Math.max(0, Math.min(255, 255 * x));
}
class $cca4aceb320d03d3$var$ColorConverters {
    static CMYK_G([c, y, m, k]) {
        return [
            "G",
            1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)
        ];
    }
    static G_CMYK([g]) {
        return [
            "CMYK",
            0,
            0,
            0,
            1 - g
        ];
    }
    static G_RGB([g]) {
        return [
            "RGB",
            g,
            g,
            g
        ];
    }
    static G_rgb([g]) {
        g = $cca4aceb320d03d3$var$scaleAndClamp(g);
        return [
            g,
            g,
            g
        ];
    }
    static G_HTML([g]) {
        const G = $cca4aceb320d03d3$var$makeColorComp(g);
        return `#${G}${G}${G}`;
    }
    static RGB_G([r, g, b]) {
        return [
            "G",
            0.3 * r + 0.59 * g + 0.11 * b
        ];
    }
    static RGB_rgb(color) {
        return color.map($cca4aceb320d03d3$var$scaleAndClamp);
    }
    static RGB_HTML(color) {
        return `#${color.map($cca4aceb320d03d3$var$makeColorComp).join("")}`;
    }
    static T_HTML() {
        return "#00000000";
    }
    static T_rgb() {
        return [
            null
        ];
    }
    static CMYK_RGB([c, y, m, k]) {
        return [
            "RGB",
            1 - Math.min(1, c + k),
            1 - Math.min(1, m + k),
            1 - Math.min(1, y + k)
        ];
    }
    static CMYK_rgb([c, y, m, k]) {
        return [
            $cca4aceb320d03d3$var$scaleAndClamp(1 - Math.min(1, c + k)),
            $cca4aceb320d03d3$var$scaleAndClamp(1 - Math.min(1, m + k)),
            $cca4aceb320d03d3$var$scaleAndClamp(1 - Math.min(1, y + k))
        ];
    }
    static CMYK_HTML(components) {
        const rgb = this.CMYK_RGB(components).slice(1);
        return this.RGB_HTML(rgb);
    }
    static RGB_CMYK([r, g, b]) {
        const c = 1 - r;
        const m = 1 - g;
        const y = 1 - b;
        const k = Math.min(c, m, y);
        return [
            "CMYK",
            c,
            m,
            y,
            k
        ];
    }
}
class $cca4aceb320d03d3$var$XfaLayer {
    static setupStorage(html, id, element, storage, intent) {
        const storedData = storage.getValue(id, {
            value: null
        });
        switch(element.name){
            case "textarea":
                if (storedData.value !== null) html.textContent = storedData.value;
                if (intent === "print") break;
                html.addEventListener("input", (event)=>{
                    storage.setValue(id, {
                        value: event.target.value
                    });
                });
                break;
            case "input":
                if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                    if (storedData.value === element.attributes.xfaOn) html.setAttribute("checked", true);
                    else if (storedData.value === element.attributes.xfaOff) html.removeAttribute("checked");
                    if (intent === "print") break;
                    html.addEventListener("change", (event)=>{
                        storage.setValue(id, {
                            value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                        });
                    });
                } else {
                    if (storedData.value !== null) html.setAttribute("value", storedData.value);
                    if (intent === "print") break;
                    html.addEventListener("input", (event)=>{
                        storage.setValue(id, {
                            value: event.target.value
                        });
                    });
                }
                break;
            case "select":
                if (storedData.value !== null) {
                    html.setAttribute("value", storedData.value);
                    for (const option of element.children){
                        if (option.attributes.value === storedData.value) option.attributes.selected = true;
                        else if (option.attributes.hasOwnProperty("selected")) delete option.attributes.selected;
                    }
                }
                html.addEventListener("input", (event)=>{
                    const options = event.target.options;
                    const value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                    storage.setValue(id, {
                        value: value
                    });
                });
                break;
        }
    }
    static setAttributes({ html: html, element: element, storage: storage = null, intent: intent, linkService: linkService }) {
        const { attributes: attributes } = element;
        const isHTMLAnchorElement = html instanceof HTMLAnchorElement;
        if (attributes.type === "radio") attributes.name = `${attributes.name}-${intent}`;
        for (const [key, value] of Object.entries(attributes)){
            if (value === null || value === undefined) continue;
            switch(key){
                case "class":
                    if (value.length) html.setAttribute(key, value.join(" "));
                    break;
                case "dataId":
                    break;
                case "id":
                    html.setAttribute("data-element-id", value);
                    break;
                case "style":
                    Object.assign(html.style, value);
                    break;
                case "textContent":
                    html.textContent = value;
                    break;
                default:
                    if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") html.setAttribute(key, value);
            }
        }
        if (isHTMLAnchorElement) linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
        if (storage && attributes.dataId) this.setupStorage(html, attributes.dataId, element, storage);
    }
    static render(parameters) {
        const storage = parameters.annotationStorage;
        const linkService = parameters.linkService;
        const root = parameters.xfaHtml;
        const intent = parameters.intent || "display";
        const rootHtml = document.createElement(root.name);
        if (root.attributes) this.setAttributes({
            html: rootHtml,
            element: root,
            intent: intent,
            linkService: linkService
        });
        const isNotForRichText = intent !== "richText";
        const rootDiv = parameters.div;
        rootDiv.append(rootHtml);
        if (parameters.viewport) {
            const transform = `matrix(${parameters.viewport.transform.join(",")})`;
            rootDiv.style.transform = transform;
        }
        if (isNotForRichText) rootDiv.setAttribute("class", "xfaLayer xfaFont");
        const textDivs = [];
        if (root.children.length === 0) {
            if (root.value) {
                const node = document.createTextNode(root.value);
                rootHtml.append(node);
                if (isNotForRichText && $cca4aceb320d03d3$var$XfaText.shouldBuildText(root.name)) textDivs.push(node);
            }
            return {
                textDivs: textDivs
            };
        }
        const stack = [
            [
                root,
                -1,
                rootHtml
            ]
        ];
        while(stack.length > 0){
            const [parent, i, html] = stack.at(-1);
            if (i + 1 === parent.children.length) {
                stack.pop();
                continue;
            }
            const child = parent.children[++stack.at(-1)[1]];
            if (child === null) continue;
            const { name: name } = child;
            if (name === "#text") {
                const node = document.createTextNode(child.value);
                textDivs.push(node);
                html.append(node);
                continue;
            }
            const childHtml = child?.attributes?.xmlns ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
            html.append(childHtml);
            if (child.attributes) this.setAttributes({
                html: childHtml,
                element: child,
                storage: storage,
                intent: intent,
                linkService: linkService
            });
            if (child.children?.length > 0) stack.push([
                child,
                -1,
                childHtml
            ]);
            else if (child.value) {
                const node = document.createTextNode(child.value);
                if (isNotForRichText && $cca4aceb320d03d3$var$XfaText.shouldBuildText(name)) textDivs.push(node);
                childHtml.append(node);
            }
        }
        for (const el of rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))el.setAttribute("readOnly", true);
        return {
            textDivs: textDivs
        };
    }
    static update(parameters) {
        const transform = `matrix(${parameters.viewport.transform.join(",")})`;
        parameters.div.style.transform = transform;
        parameters.div.hidden = false;
    }
}
const $cca4aceb320d03d3$var$DEFAULT_TAB_INDEX = 1000;
const $cca4aceb320d03d3$var$annotation_layer_DEFAULT_FONT_SIZE = 9;
const $cca4aceb320d03d3$var$GetElementsByNameSet = new WeakSet();
function $cca4aceb320d03d3$var$getRectDims(rect) {
    return {
        width: rect[2] - rect[0],
        height: rect[3] - rect[1]
    };
}
class $cca4aceb320d03d3$var$AnnotationElementFactory {
    static create(parameters) {
        const subtype = parameters.data.annotationType;
        switch(subtype){
            case $cca4aceb320d03d3$var$AnnotationType.LINK:
                return new $cca4aceb320d03d3$var$LinkAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.TEXT:
                return new $cca4aceb320d03d3$var$TextAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.WIDGET:
                const fieldType = parameters.data.fieldType;
                switch(fieldType){
                    case "Tx":
                        return new $cca4aceb320d03d3$var$TextWidgetAnnotationElement(parameters);
                    case "Btn":
                        if (parameters.data.radioButton) return new $cca4aceb320d03d3$var$RadioButtonWidgetAnnotationElement(parameters);
                        else if (parameters.data.checkBox) return new $cca4aceb320d03d3$var$CheckboxWidgetAnnotationElement(parameters);
                        return new $cca4aceb320d03d3$var$PushButtonWidgetAnnotationElement(parameters);
                    case "Ch":
                        return new $cca4aceb320d03d3$var$ChoiceWidgetAnnotationElement(parameters);
                    case "Sig":
                        return new $cca4aceb320d03d3$var$SignatureWidgetAnnotationElement(parameters);
                }
                return new $cca4aceb320d03d3$var$WidgetAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.POPUP:
                return new $cca4aceb320d03d3$var$PopupAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.FREETEXT:
                return new $cca4aceb320d03d3$var$FreeTextAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.LINE:
                return new $cca4aceb320d03d3$var$LineAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.SQUARE:
                return new $cca4aceb320d03d3$var$SquareAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.CIRCLE:
                return new $cca4aceb320d03d3$var$CircleAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.POLYLINE:
                return new $cca4aceb320d03d3$var$PolylineAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.CARET:
                return new $cca4aceb320d03d3$var$CaretAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.INK:
                return new $cca4aceb320d03d3$var$InkAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.POLYGON:
                return new $cca4aceb320d03d3$var$PolygonAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.HIGHLIGHT:
                return new $cca4aceb320d03d3$var$HighlightAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.UNDERLINE:
                return new $cca4aceb320d03d3$var$UnderlineAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.SQUIGGLY:
                return new $cca4aceb320d03d3$var$SquigglyAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.STRIKEOUT:
                return new $cca4aceb320d03d3$var$StrikeOutAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.STAMP:
                return new $cca4aceb320d03d3$var$StampAnnotationElement(parameters);
            case $cca4aceb320d03d3$var$AnnotationType.FILEATTACHMENT:
                return new $cca4aceb320d03d3$var$FileAttachmentAnnotationElement(parameters);
            default:
                return new $cca4aceb320d03d3$var$AnnotationElement(parameters);
        }
    }
}
class $cca4aceb320d03d3$var$AnnotationElement {
    #updates = null;
    #hasBorder = false;
    #popupElement = null;
    constructor(parameters, { isRenderable: isRenderable = false, ignoreBorder: ignoreBorder = false, createQuadrilaterals: createQuadrilaterals = false } = {}){
        this.isRenderable = isRenderable;
        this.data = parameters.data;
        this.layer = parameters.layer;
        this.linkService = parameters.linkService;
        this.downloadManager = parameters.downloadManager;
        this.imageResourcesPath = parameters.imageResourcesPath;
        this.renderForms = parameters.renderForms;
        this.svgFactory = parameters.svgFactory;
        this.annotationStorage = parameters.annotationStorage;
        this.enableScripting = parameters.enableScripting;
        this.hasJSActions = parameters.hasJSActions;
        this._fieldObjects = parameters.fieldObjects;
        this.parent = parameters.parent;
        if (isRenderable) this.container = this._createContainer(ignoreBorder);
        if (createQuadrilaterals) this._createQuadrilaterals();
    }
    static _hasPopupData({ titleObj: titleObj, contentsObj: contentsObj, richText: richText }) {
        return !!(titleObj?.str || contentsObj?.str || richText?.str);
    }
    get hasPopupData() {
        return $cca4aceb320d03d3$var$AnnotationElement._hasPopupData(this.data);
    }
    updateEdited(params) {
        if (!this.container) return;
        this.#updates ||= {
            rect: this.data.rect.slice(0)
        };
        const { rect: rect } = params;
        if (rect) this.#setRectEdited(rect);
        this.#popupElement?.popup.updateEdited(params);
    }
    resetEdited() {
        if (!this.#updates) return;
        this.#setRectEdited(this.#updates.rect);
        this.#popupElement?.popup.resetEdited();
        this.#updates = null;
    }
    #setRectEdited(rect) {
        const { container: { style: style }, data: { rect: currentRect, rotation: rotation }, parent: { viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } } = this;
        currentRect?.splice(0, 4, ...rect);
        const { width: width, height: height } = $cca4aceb320d03d3$var$getRectDims(rect);
        style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
        style.top = `${100 * (pageHeight - rect[3] + pageY) / pageHeight}%`;
        if (rotation === 0) {
            style.width = `${100 * width / pageWidth}%`;
            style.height = `${100 * height / pageHeight}%`;
        } else this.setRotation(rotation);
    }
    _createContainer(ignoreBorder) {
        const { data: data, parent: { page: page, viewport: viewport } } = this;
        const container = document.createElement("section");
        container.setAttribute("data-annotation-id", data.id);
        if (!(this instanceof $cca4aceb320d03d3$var$WidgetAnnotationElement)) container.tabIndex = $cca4aceb320d03d3$var$DEFAULT_TAB_INDEX;
        const { style: style } = container;
        style.zIndex = this.parent.zIndex++;
        if (data.popupRef) container.setAttribute("aria-haspopup", "dialog");
        if (data.alternativeText) container.title = data.alternativeText;
        if (data.noRotate) container.classList.add("norotate");
        if (!data.rect || this instanceof $cca4aceb320d03d3$var$PopupAnnotationElement) {
            const { rotation: rotation } = data;
            if (!data.hasOwnCanvas && rotation !== 0) this.setRotation(rotation, container);
            return container;
        }
        const { width: width, height: height } = $cca4aceb320d03d3$var$getRectDims(data.rect);
        if (!ignoreBorder && data.borderStyle.width > 0) {
            style.borderWidth = `${data.borderStyle.width}px`;
            const horizontalRadius = data.borderStyle.horizontalCornerRadius;
            const verticalRadius = data.borderStyle.verticalCornerRadius;
            if (horizontalRadius > 0 || verticalRadius > 0) {
                const radius = `calc(${horizontalRadius}px * var(--scale-factor)) / calc(${verticalRadius}px * var(--scale-factor))`;
                style.borderRadius = radius;
            } else if (this instanceof $cca4aceb320d03d3$var$RadioButtonWidgetAnnotationElement) {
                const radius = `calc(${width}px * var(--scale-factor)) / calc(${height}px * var(--scale-factor))`;
                style.borderRadius = radius;
            }
            switch(data.borderStyle.style){
                case $cca4aceb320d03d3$var$AnnotationBorderStyleType.SOLID:
                    style.borderStyle = "solid";
                    break;
                case $cca4aceb320d03d3$var$AnnotationBorderStyleType.DASHED:
                    style.borderStyle = "dashed";
                    break;
                case $cca4aceb320d03d3$var$AnnotationBorderStyleType.BEVELED:
                    $cca4aceb320d03d3$var$warn("Unimplemented border style: beveled");
                    break;
                case $cca4aceb320d03d3$var$AnnotationBorderStyleType.INSET:
                    $cca4aceb320d03d3$var$warn("Unimplemented border style: inset");
                    break;
                case $cca4aceb320d03d3$var$AnnotationBorderStyleType.UNDERLINE:
                    style.borderBottomStyle = "solid";
                    break;
                default:
                    break;
            }
            const borderColor = data.borderColor || null;
            if (borderColor) {
                this.#hasBorder = true;
                style.borderColor = $cca4aceb320d03d3$var$Util.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
            } else style.borderWidth = 0;
        }
        const rect = $cca4aceb320d03d3$var$Util.normalizeRect([
            data.rect[0],
            page.view[3] - data.rect[1] + page.view[1],
            data.rect[2],
            page.view[3] - data.rect[3] + page.view[1]
        ]);
        const { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } = viewport.rawDims;
        style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
        style.top = `${100 * (rect[1] - pageY) / pageHeight}%`;
        const { rotation: rotation } = data;
        if (data.hasOwnCanvas || rotation === 0) {
            style.width = `${100 * width / pageWidth}%`;
            style.height = `${100 * height / pageHeight}%`;
        } else this.setRotation(rotation, container);
        return container;
    }
    setRotation(angle, container = this.container) {
        if (!this.data.rect) return;
        const { pageWidth: pageWidth, pageHeight: pageHeight } = this.parent.viewport.rawDims;
        const { width: width, height: height } = $cca4aceb320d03d3$var$getRectDims(this.data.rect);
        let elementWidth, elementHeight;
        if (angle % 180 === 0) {
            elementWidth = 100 * width / pageWidth;
            elementHeight = 100 * height / pageHeight;
        } else {
            elementWidth = 100 * height / pageWidth;
            elementHeight = 100 * width / pageHeight;
        }
        container.style.width = `${elementWidth}%`;
        container.style.height = `${elementHeight}%`;
        container.setAttribute("data-main-rotation", (360 - angle) % 360);
    }
    get _commonActions() {
        const setColor = (jsName, styleName, event)=>{
            const color = event.detail[jsName];
            const colorType = color[0];
            const colorArray = color.slice(1);
            event.target.style[styleName] = $cca4aceb320d03d3$var$ColorConverters[`${colorType}_HTML`](colorArray);
            this.annotationStorage.setValue(this.data.id, {
                [styleName]: $cca4aceb320d03d3$var$ColorConverters[`${colorType}_rgb`](colorArray)
            });
        };
        return $cca4aceb320d03d3$var$shadow(this, "_commonActions", {
            display: (event)=>{
                const { display: display } = event.detail;
                const hidden = display % 2 === 1;
                this.container.style.visibility = hidden ? "hidden" : "visible";
                this.annotationStorage.setValue(this.data.id, {
                    noView: hidden,
                    noPrint: display === 1 || display === 2
                });
            },
            print: (event)=>{
                this.annotationStorage.setValue(this.data.id, {
                    noPrint: !event.detail.print
                });
            },
            hidden: (event)=>{
                const { hidden: hidden } = event.detail;
                this.container.style.visibility = hidden ? "hidden" : "visible";
                this.annotationStorage.setValue(this.data.id, {
                    noPrint: hidden,
                    noView: hidden
                });
            },
            focus: (event)=>{
                setTimeout(()=>event.target.focus({
                        preventScroll: false
                    }), 0);
            },
            userName: (event)=>{
                event.target.title = event.detail.userName;
            },
            readonly: (event)=>{
                event.target.disabled = event.detail.readonly;
            },
            required: (event)=>{
                this._setRequired(event.target, event.detail.required);
            },
            bgColor: (event)=>{
                setColor("bgColor", "backgroundColor", event);
            },
            fillColor: (event)=>{
                setColor("fillColor", "backgroundColor", event);
            },
            fgColor: (event)=>{
                setColor("fgColor", "color", event);
            },
            textColor: (event)=>{
                setColor("textColor", "color", event);
            },
            borderColor: (event)=>{
                setColor("borderColor", "borderColor", event);
            },
            strokeColor: (event)=>{
                setColor("strokeColor", "borderColor", event);
            },
            rotation: (event)=>{
                const angle = event.detail.rotation;
                this.setRotation(angle);
                this.annotationStorage.setValue(this.data.id, {
                    rotation: angle
                });
            }
        });
    }
    _dispatchEventFromSandbox(actions, jsEvent) {
        const commonActions = this._commonActions;
        for (const name of Object.keys(jsEvent.detail)){
            const action = actions[name] || commonActions[name];
            action?.(jsEvent);
        }
    }
    _setDefaultPropertiesFromJS(element) {
        if (!this.enableScripting) return;
        const storedData = this.annotationStorage.getRawValue(this.data.id);
        if (!storedData) return;
        const commonActions = this._commonActions;
        for (const [actionName, detail] of Object.entries(storedData)){
            const action = commonActions[actionName];
            if (action) {
                const eventProxy = {
                    detail: {
                        [actionName]: detail
                    },
                    target: element
                };
                action(eventProxy);
                delete storedData[actionName];
            }
        }
    }
    _createQuadrilaterals() {
        if (!this.container) return;
        const { quadPoints: quadPoints } = this.data;
        if (!quadPoints) return;
        const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect.map((x)=>Math.fround(x));
        if (quadPoints.length === 8) {
            const [trX, trY, blX, blY] = quadPoints.subarray(2, 6);
            if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) return;
        }
        const { style: style } = this.container;
        let svgBuffer;
        if (this.#hasBorder) {
            const { borderColor: borderColor, borderWidth: borderWidth } = style;
            style.borderWidth = 0;
            svgBuffer = [
                "url('data:image/svg+xml;utf8,",
                `<svg xmlns="http://www.w3.org/2000/svg"`,
                ` preserveAspectRatio="none" viewBox="0 0 1 1">`,
                `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth}">`
            ];
            this.container.classList.add("hasBorder");
        }
        const width = rectTrX - rectBlX;
        const height = rectTrY - rectBlY;
        const { svgFactory: svgFactory } = this;
        const svg = svgFactory.createElement("svg");
        svg.classList.add("quadrilateralsContainer");
        svg.setAttribute("width", 0);
        svg.setAttribute("height", 0);
        const defs = svgFactory.createElement("defs");
        svg.append(defs);
        const clipPath = svgFactory.createElement("clipPath");
        const id = `clippath_${this.data.id}`;
        clipPath.setAttribute("id", id);
        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
        defs.append(clipPath);
        for(let i = 2, ii = quadPoints.length; i < ii; i += 8){
            const trX = quadPoints[i];
            const trY = quadPoints[i + 1];
            const blX = quadPoints[i + 2];
            const blY = quadPoints[i + 3];
            const rect = svgFactory.createElement("rect");
            const x = (blX - rectBlX) / width;
            const y = (rectTrY - trY) / height;
            const rectWidth = (trX - blX) / width;
            const rectHeight = (trY - blY) / height;
            rect.setAttribute("x", x);
            rect.setAttribute("y", y);
            rect.setAttribute("width", rectWidth);
            rect.setAttribute("height", rectHeight);
            clipPath.append(rect);
            svgBuffer?.push(`<rect vector-effect="non-scaling-stroke" x="${x}" y="${y}" width="${rectWidth}" height="${rectHeight}"/>`);
        }
        if (this.#hasBorder) {
            svgBuffer.push(`</g></svg>')`);
            style.backgroundImage = svgBuffer.join("");
        }
        this.container.append(svg);
        this.container.style.clipPath = `url(#${id})`;
    }
    _createPopup() {
        const { container: container, data: data } = this;
        container.setAttribute("aria-haspopup", "dialog");
        const popup = this.#popupElement = new $cca4aceb320d03d3$var$PopupAnnotationElement({
            data: {
                color: data.color,
                titleObj: data.titleObj,
                modificationDate: data.modificationDate,
                contentsObj: data.contentsObj,
                richText: data.richText,
                parentRect: data.rect,
                borderStyle: 0,
                id: `popup_${data.id}`,
                rotation: data.rotation
            },
            parent: this.parent,
            elements: [
                this
            ]
        });
        this.parent.div.append(popup.render());
    }
    render() {
        $cca4aceb320d03d3$var$unreachable("Abstract method `AnnotationElement.render` called");
    }
    _getElementsByName(name, skipId = null) {
        const fields = [];
        if (this._fieldObjects) {
            const fieldObj = this._fieldObjects[name];
            if (fieldObj) for (const { page: page, id: id, exportValues: exportValues } of fieldObj){
                if (page === -1) continue;
                if (id === skipId) continue;
                const exportValue = typeof exportValues === "string" ? exportValues : null;
                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                if (domElement && !$cca4aceb320d03d3$var$GetElementsByNameSet.has(domElement)) {
                    $cca4aceb320d03d3$var$warn(`_getElementsByName - element not allowed: ${id}`);
                    continue;
                }
                fields.push({
                    id: id,
                    exportValue: exportValue,
                    domElement: domElement
                });
            }
            return fields;
        }
        for (const domElement of document.getElementsByName(name)){
            const { exportValue: exportValue } = domElement;
            const id = domElement.getAttribute("data-element-id");
            if (id === skipId) continue;
            if (!$cca4aceb320d03d3$var$GetElementsByNameSet.has(domElement)) continue;
            fields.push({
                id: id,
                exportValue: exportValue,
                domElement: domElement
            });
        }
        return fields;
    }
    show() {
        if (this.container) this.container.hidden = false;
        this.popup?.maybeShow();
    }
    hide() {
        if (this.container) this.container.hidden = true;
        this.popup?.forceHide();
    }
    getElementsToTriggerPopup() {
        return this.container;
    }
    addHighlightArea() {
        const triggers = this.getElementsToTriggerPopup();
        if (Array.isArray(triggers)) for (const element of triggers)element.classList.add("highlightArea");
        else triggers.classList.add("highlightArea");
    }
    get _isEditable() {
        return false;
    }
    _editOnDoubleClick() {
        if (!this._isEditable) return;
        const { annotationEditorType: mode, data: { id: editId } } = this;
        this.container.addEventListener("dblclick", ()=>{
            this.linkService.eventBus?.dispatch("switchannotationeditormode", {
                source: this,
                mode: mode,
                editId: editId
            });
        });
    }
}
class $cca4aceb320d03d3$var$LinkAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    constructor(parameters, options = null){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: !!options?.ignoreBorder,
            createQuadrilaterals: true
        });
        this.isTooltipOnly = parameters.data.isTooltipOnly;
    }
    render() {
        const { data: data, linkService: linkService } = this;
        const link = document.createElement("a");
        link.setAttribute("data-element-id", data.id);
        let isBound = false;
        if (data.url) {
            linkService.addLinkAttributes(link, data.url, data.newWindow);
            isBound = true;
        } else if (data.action) {
            this._bindNamedAction(link, data.action);
            isBound = true;
        } else if (data.attachment) {
            this.#bindAttachment(link, data.attachment, data.attachmentDest);
            isBound = true;
        } else if (data.setOCGState) {
            this.#bindSetOCGState(link, data.setOCGState);
            isBound = true;
        } else if (data.dest) {
            this._bindLink(link, data.dest);
            isBound = true;
        } else {
            if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                this._bindJSAction(link, data);
                isBound = true;
            }
            if (data.resetForm) {
                this._bindResetFormAction(link, data.resetForm);
                isBound = true;
            } else if (this.isTooltipOnly && !isBound) {
                this._bindLink(link, "");
                isBound = true;
            }
        }
        this.container.classList.add("linkAnnotation");
        if (isBound) this.container.append(link);
        return this.container;
    }
    #setInternalLink() {
        this.container.setAttribute("data-internal-link", "");
    }
    _bindLink(link, destination) {
        link.href = this.linkService.getDestinationHash(destination);
        link.onclick = ()=>{
            if (destination) this.linkService.goToDestination(destination);
            return false;
        };
        if (destination || destination === "") this.#setInternalLink();
    }
    _bindNamedAction(link, action) {
        link.href = this.linkService.getAnchorUrl("");
        link.onclick = ()=>{
            this.linkService.executeNamedAction(action);
            return false;
        };
        this.#setInternalLink();
    }
    #bindAttachment(link, attachment, dest = null) {
        link.href = this.linkService.getAnchorUrl("");
        if (attachment.description) link.title = attachment.description;
        link.onclick = ()=>{
            this.downloadManager?.openOrDownloadData(attachment.content, attachment.filename, dest);
            return false;
        };
        this.#setInternalLink();
    }
    #bindSetOCGState(link, action) {
        link.href = this.linkService.getAnchorUrl("");
        link.onclick = ()=>{
            this.linkService.executeSetOCGState(action);
            return false;
        };
        this.#setInternalLink();
    }
    _bindJSAction(link, data) {
        link.href = this.linkService.getAnchorUrl("");
        const map = new Map([
            [
                "Action",
                "onclick"
            ],
            [
                "Mouse Up",
                "onmouseup"
            ],
            [
                "Mouse Down",
                "onmousedown"
            ]
        ]);
        for (const name of Object.keys(data.actions)){
            const jsName = map.get(name);
            if (!jsName) continue;
            link[jsName] = ()=>{
                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                        id: data.id,
                        name: name
                    }
                });
                return false;
            };
        }
        if (!link.onclick) link.onclick = ()=>false;
        this.#setInternalLink();
    }
    _bindResetFormAction(link, resetForm) {
        const otherClickAction = link.onclick;
        if (!otherClickAction) link.href = this.linkService.getAnchorUrl("");
        this.#setInternalLink();
        if (!this._fieldObjects) {
            $cca4aceb320d03d3$var$warn(`_bindResetFormAction - "resetForm" action not supported, ` + "ensure that the `fieldObjects` parameter is provided.");
            if (!otherClickAction) link.onclick = ()=>false;
            return;
        }
        link.onclick = ()=>{
            otherClickAction?.();
            const { fields: resetFormFields, refs: resetFormRefs, include: include } = resetForm;
            const allFields = [];
            if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                const fieldIds = new Set(resetFormRefs);
                for (const fieldName of resetFormFields){
                    const fields = this._fieldObjects[fieldName] || [];
                    for (const { id: id } of fields)fieldIds.add(id);
                }
                for (const fields of Object.values(this._fieldObjects)){
                    for (const field of fields)if (fieldIds.has(field.id) === include) allFields.push(field);
                }
            } else for (const fields of Object.values(this._fieldObjects))allFields.push(...fields);
            const storage = this.annotationStorage;
            const allIds = [];
            for (const field of allFields){
                const { id: id } = field;
                allIds.push(id);
                switch(field.type){
                    case "text":
                        {
                            const value = field.defaultValue || "";
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    case "checkbox":
                    case "radiobutton":
                        {
                            const value = field.defaultValue === field.exportValues;
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    case "combobox":
                    case "listbox":
                        {
                            const value = field.defaultValue || "";
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    default:
                        continue;
                }
                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                if (!domElement) continue;
                else if (!$cca4aceb320d03d3$var$GetElementsByNameSet.has(domElement)) {
                    $cca4aceb320d03d3$var$warn(`_bindResetFormAction - element not allowed: ${id}`);
                    continue;
                }
                domElement.dispatchEvent(new Event("resetform"));
            }
            if (this.enableScripting) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: "app",
                    ids: allIds,
                    name: "ResetForm"
                }
            });
            return false;
        };
    }
}
class $cca4aceb320d03d3$var$TextAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true
        });
    }
    render() {
        this.container.classList.add("textAnnotation");
        const image = document.createElement("img");
        image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
        image.setAttribute("data-l10n-id", "pdfjs-text-annotation-type");
        image.setAttribute("data-l10n-args", JSON.stringify({
            type: this.data.name
        }));
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        this.container.append(image);
        return this.container;
    }
}
class $cca4aceb320d03d3$var$WidgetAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    render() {
        return this.container;
    }
    showElementAndHideCanvas(element) {
        if (this.data.hasOwnCanvas) {
            if (element.previousSibling?.nodeName === "CANVAS") element.previousSibling.hidden = true;
            element.hidden = false;
        }
    }
    _getKeyModifier(event) {
        return $cca4aceb320d03d3$var$util_FeatureTest.platform.isMac ? event.metaKey : event.ctrlKey;
    }
    _setEventListener(element, elementData, baseName, eventName, valueGetter) {
        if (baseName.includes("mouse")) element.addEventListener(baseName, (event)=>{
            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: this.data.id,
                    name: eventName,
                    value: valueGetter(event),
                    shift: event.shiftKey,
                    modifier: this._getKeyModifier(event)
                }
            });
        });
        else element.addEventListener(baseName, (event)=>{
            if (baseName === "blur") {
                if (!elementData.focused || !event.relatedTarget) return;
                elementData.focused = false;
            } else if (baseName === "focus") {
                if (elementData.focused) return;
                elementData.focused = true;
            }
            if (!valueGetter) return;
            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: this.data.id,
                    name: eventName,
                    value: valueGetter(event)
                }
            });
        });
    }
    _setEventListeners(element, elementData, names, getter) {
        for (const [baseName, eventName] of names)if (eventName === "Action" || this.data.actions?.[eventName]) {
            if (eventName === "Focus" || eventName === "Blur") elementData ||= {
                focused: false
            };
            this._setEventListener(element, elementData, baseName, eventName, getter);
            if (eventName === "Focus" && !this.data.actions?.Blur) this._setEventListener(element, elementData, "blur", "Blur", null);
            else if (eventName === "Blur" && !this.data.actions?.Focus) this._setEventListener(element, elementData, "focus", "Focus", null);
        }
    }
    _setBackgroundColor(element) {
        const color = this.data.backgroundColor || null;
        element.style.backgroundColor = color === null ? "transparent" : $cca4aceb320d03d3$var$Util.makeHexColor(color[0], color[1], color[2]);
    }
    _setTextStyle(element) {
        const TEXT_ALIGNMENT = [
            "left",
            "center",
            "right"
        ];
        const { fontColor: fontColor } = this.data.defaultAppearanceData;
        const fontSize = this.data.defaultAppearanceData.fontSize || $cca4aceb320d03d3$var$annotation_layer_DEFAULT_FONT_SIZE;
        const style = element.style;
        let computedFontSize;
        const BORDER_SIZE = 2;
        const roundToOneDecimal = (x)=>Math.round(10 * x) / 10;
        if (this.data.multiLine) {
            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
            const numberOfLines = Math.round(height / ($cca4aceb320d03d3$var$LINE_FACTOR * fontSize)) || 1;
            const lineHeight = height / numberOfLines;
            computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / $cca4aceb320d03d3$var$LINE_FACTOR));
        } else {
            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
            computedFontSize = Math.min(fontSize, roundToOneDecimal(height / $cca4aceb320d03d3$var$LINE_FACTOR));
        }
        style.fontSize = `calc(${computedFontSize}px * var(--scale-factor))`;
        style.color = $cca4aceb320d03d3$var$Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
        if (this.data.textAlignment !== null) style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
    }
    _setRequired(element, isRequired) {
        if (isRequired) element.setAttribute("required", true);
        else element.removeAttribute("required");
        element.setAttribute("aria-required", isRequired);
    }
}
class $cca4aceb320d03d3$var$TextWidgetAnnotationElement extends $cca4aceb320d03d3$var$WidgetAnnotationElement {
    constructor(parameters){
        const isRenderable = parameters.renderForms || parameters.data.hasOwnCanvas || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
        super(parameters, {
            isRenderable: isRenderable
        });
    }
    setPropertyOnSiblings(base, key, value, keyInStorage) {
        const storage = this.annotationStorage;
        for (const element of this._getElementsByName(base.name, base.id)){
            if (element.domElement) element.domElement[key] = value;
            storage.setValue(element.id, {
                [keyInStorage]: value
            });
        }
    }
    render() {
        const storage = this.annotationStorage;
        const id = this.data.id;
        this.container.classList.add("textWidgetAnnotation");
        let element = null;
        if (this.renderForms) {
            const storedData = storage.getValue(id, {
                value: this.data.fieldValue
            });
            let textContent = storedData.value || "";
            const maxLen = storage.getValue(id, {
                charLimit: this.data.maxLen
            }).charLimit;
            if (maxLen && textContent.length > maxLen) textContent = textContent.slice(0, maxLen);
            let fieldFormattedValues = storedData.formattedValue || this.data.textContent?.join("\n") || null;
            if (fieldFormattedValues && this.data.comb) fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
            const elementData = {
                userValue: textContent,
                formattedValue: fieldFormattedValues,
                lastCommittedValue: null,
                commitKey: 1,
                focused: false
            };
            if (this.data.multiLine) {
                element = document.createElement("textarea");
                element.textContent = fieldFormattedValues ?? textContent;
                if (this.data.doNotScroll) element.style.overflowY = "hidden";
            } else {
                element = document.createElement("input");
                element.type = "text";
                element.setAttribute("value", fieldFormattedValues ?? textContent);
                if (this.data.doNotScroll) element.style.overflowX = "hidden";
            }
            if (this.data.hasOwnCanvas) element.hidden = true;
            $cca4aceb320d03d3$var$GetElementsByNameSet.add(element);
            element.setAttribute("data-element-id", id);
            element.disabled = this.data.readOnly;
            element.name = this.data.fieldName;
            element.tabIndex = $cca4aceb320d03d3$var$DEFAULT_TAB_INDEX;
            this._setRequired(element, this.data.required);
            if (maxLen) element.maxLength = maxLen;
            element.addEventListener("input", (event)=>{
                storage.setValue(id, {
                    value: event.target.value
                });
                this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                elementData.formattedValue = null;
            });
            element.addEventListener("resetform", (event)=>{
                const defaultValue = this.data.defaultFieldValue ?? "";
                element.value = elementData.userValue = defaultValue;
                elementData.formattedValue = null;
            });
            let blurListener = (event)=>{
                const { formattedValue: formattedValue } = elementData;
                if (formattedValue !== null && formattedValue !== undefined) event.target.value = formattedValue;
                event.target.scrollLeft = 0;
            };
            if (this.enableScripting && this.hasJSActions) {
                element.addEventListener("focus", (event)=>{
                    if (elementData.focused) return;
                    const { target: target } = event;
                    if (elementData.userValue) target.value = elementData.userValue;
                    elementData.lastCommittedValue = target.value;
                    elementData.commitKey = 1;
                    if (!this.data.actions?.Focus) elementData.focused = true;
                });
                element.addEventListener("updatefromsandbox", (jsEvent)=>{
                    this.showElementAndHideCanvas(jsEvent.target);
                    const actions = {
                        value (event) {
                            elementData.userValue = event.detail.value ?? "";
                            storage.setValue(id, {
                                value: elementData.userValue.toString()
                            });
                            event.target.value = elementData.userValue;
                        },
                        formattedValue (event) {
                            const { formattedValue: formattedValue } = event.detail;
                            elementData.formattedValue = formattedValue;
                            if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) event.target.value = formattedValue;
                            storage.setValue(id, {
                                formattedValue: formattedValue
                            });
                        },
                        selRange (event) {
                            event.target.setSelectionRange(...event.detail.selRange);
                        },
                        charLimit: (event)=>{
                            const { charLimit: charLimit } = event.detail;
                            const { target: target } = event;
                            if (charLimit === 0) {
                                target.removeAttribute("maxLength");
                                return;
                            }
                            target.setAttribute("maxLength", charLimit);
                            let value = elementData.userValue;
                            if (!value || value.length <= charLimit) return;
                            value = value.slice(0, charLimit);
                            target.value = elementData.userValue = value;
                            storage.setValue(id, {
                                value: value
                            });
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: id,
                                    name: "Keystroke",
                                    value: value,
                                    willCommit: true,
                                    commitKey: 1,
                                    selStart: target.selectionStart,
                                    selEnd: target.selectionEnd
                                }
                            });
                        }
                    };
                    this._dispatchEventFromSandbox(actions, jsEvent);
                });
                element.addEventListener("keydown", (event)=>{
                    elementData.commitKey = 1;
                    let commitKey = -1;
                    if (event.key === "Escape") commitKey = 0;
                    else if (event.key === "Enter" && !this.data.multiLine) commitKey = 2;
                    else if (event.key === "Tab") elementData.commitKey = 3;
                    if (commitKey === -1) return;
                    const { value: value } = event.target;
                    if (elementData.lastCommittedValue === value) return;
                    elementData.lastCommittedValue = value;
                    elementData.userValue = value;
                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            willCommit: true,
                            commitKey: commitKey,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                        }
                    });
                });
                const _blurListener = blurListener;
                blurListener = null;
                element.addEventListener("blur", (event)=>{
                    if (!elementData.focused || !event.relatedTarget) return;
                    if (!this.data.actions?.Blur) elementData.focused = false;
                    const { value: value } = event.target;
                    elementData.userValue = value;
                    if (elementData.lastCommittedValue !== value) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            willCommit: true,
                            commitKey: elementData.commitKey,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                        }
                    });
                    _blurListener(event);
                });
                if (this.data.actions?.Keystroke) element.addEventListener("beforeinput", (event)=>{
                    elementData.lastCommittedValue = null;
                    const { data: data, target: target } = event;
                    const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = target;
                    let selStart = selectionStart, selEnd = selectionEnd;
                    switch(event.inputType){
                        case "deleteWordBackward":
                            {
                                const match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                                if (match) selStart -= match[0].length;
                                break;
                            }
                        case "deleteWordForward":
                            {
                                const match = value.substring(selectionStart).match(/^[^\w]*\w*/);
                                if (match) selEnd += match[0].length;
                                break;
                            }
                        case "deleteContentBackward":
                            if (selectionStart === selectionEnd) selStart -= 1;
                            break;
                        case "deleteContentForward":
                            if (selectionStart === selectionEnd) selEnd += 1;
                            break;
                    }
                    event.preventDefault();
                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            change: data || "",
                            willCommit: false,
                            selStart: selStart,
                            selEnd: selEnd
                        }
                    });
                });
                this._setEventListeners(element, elementData, [
                    [
                        "focus",
                        "Focus"
                    ],
                    [
                        "blur",
                        "Blur"
                    ],
                    [
                        "mousedown",
                        "Mouse Down"
                    ],
                    [
                        "mouseenter",
                        "Mouse Enter"
                    ],
                    [
                        "mouseleave",
                        "Mouse Exit"
                    ],
                    [
                        "mouseup",
                        "Mouse Up"
                    ]
                ], (event)=>event.target.value);
            }
            if (blurListener) element.addEventListener("blur", blurListener);
            if (this.data.comb) {
                const fieldWidth = this.data.rect[2] - this.data.rect[0];
                const combWidth = fieldWidth / maxLen;
                element.classList.add("comb");
                element.style.letterSpacing = `calc(${combWidth}px * var(--scale-factor) - 1ch)`;
            }
        } else {
            element = document.createElement("div");
            element.textContent = this.data.fieldValue;
            element.style.verticalAlign = "middle";
            element.style.display = "table-cell";
            if (this.data.hasOwnCanvas) element.hidden = true;
        }
        this._setTextStyle(element);
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $cca4aceb320d03d3$var$SignatureWidgetAnnotationElement extends $cca4aceb320d03d3$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: !!parameters.data.hasOwnCanvas
        });
    }
}
class $cca4aceb320d03d3$var$CheckboxWidgetAnnotationElement extends $cca4aceb320d03d3$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        const storage = this.annotationStorage;
        const data = this.data;
        const id = data.id;
        let value = storage.getValue(id, {
            value: data.exportValue === data.fieldValue
        }).value;
        if (typeof value === "string") {
            value = value !== "Off";
            storage.setValue(id, {
                value: value
            });
        }
        this.container.classList.add("buttonWidgetAnnotation", "checkBox");
        const element = document.createElement("input");
        $cca4aceb320d03d3$var$GetElementsByNameSet.add(element);
        element.setAttribute("data-element-id", id);
        element.disabled = data.readOnly;
        this._setRequired(element, this.data.required);
        element.type = "checkbox";
        element.name = data.fieldName;
        if (value) element.setAttribute("checked", true);
        element.setAttribute("exportValue", data.exportValue);
        element.tabIndex = $cca4aceb320d03d3$var$DEFAULT_TAB_INDEX;
        element.addEventListener("change", (event)=>{
            const { name: name, checked: checked } = event.target;
            for (const checkbox of this._getElementsByName(name, id)){
                const curChecked = checked && checkbox.exportValue === data.exportValue;
                if (checkbox.domElement) checkbox.domElement.checked = curChecked;
                storage.setValue(checkbox.id, {
                    value: curChecked
                });
            }
            storage.setValue(id, {
                value: checked
            });
        });
        element.addEventListener("resetform", (event)=>{
            const defaultValue = data.defaultFieldValue || "Off";
            event.target.checked = defaultValue === data.exportValue;
        });
        if (this.enableScripting && this.hasJSActions) {
            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value (event) {
                        event.target.checked = event.detail.value !== "Off";
                        storage.setValue(id, {
                            value: event.target.checked
                        });
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            this._setEventListeners(element, null, [
                [
                    "change",
                    "Validate"
                ],
                [
                    "change",
                    "Action"
                ],
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ]
            ], (event)=>event.target.checked);
        }
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $cca4aceb320d03d3$var$RadioButtonWidgetAnnotationElement extends $cca4aceb320d03d3$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        this.container.classList.add("buttonWidgetAnnotation", "radioButton");
        const storage = this.annotationStorage;
        const data = this.data;
        const id = data.id;
        let value = storage.getValue(id, {
            value: data.fieldValue === data.buttonValue
        }).value;
        if (typeof value === "string") {
            value = value !== data.buttonValue;
            storage.setValue(id, {
                value: value
            });
        }
        if (value) for (const radio of this._getElementsByName(data.fieldName, id))storage.setValue(radio.id, {
            value: false
        });
        const element = document.createElement("input");
        $cca4aceb320d03d3$var$GetElementsByNameSet.add(element);
        element.setAttribute("data-element-id", id);
        element.disabled = data.readOnly;
        this._setRequired(element, this.data.required);
        element.type = "radio";
        element.name = data.fieldName;
        if (value) element.setAttribute("checked", true);
        element.tabIndex = $cca4aceb320d03d3$var$DEFAULT_TAB_INDEX;
        element.addEventListener("change", (event)=>{
            const { name: name, checked: checked } = event.target;
            for (const radio of this._getElementsByName(name, id))storage.setValue(radio.id, {
                value: false
            });
            storage.setValue(id, {
                value: checked
            });
        });
        element.addEventListener("resetform", (event)=>{
            const defaultValue = data.defaultFieldValue;
            event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
        });
        if (this.enableScripting && this.hasJSActions) {
            const pdfButtonValue = data.buttonValue;
            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value: (event)=>{
                        const checked = pdfButtonValue === event.detail.value;
                        for (const radio of this._getElementsByName(event.target.name)){
                            const curChecked = checked && radio.id === id;
                            if (radio.domElement) radio.domElement.checked = curChecked;
                            storage.setValue(radio.id, {
                                value: curChecked
                            });
                        }
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            this._setEventListeners(element, null, [
                [
                    "change",
                    "Validate"
                ],
                [
                    "change",
                    "Action"
                ],
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ]
            ], (event)=>event.target.checked);
        }
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $cca4aceb320d03d3$var$PushButtonWidgetAnnotationElement extends $cca4aceb320d03d3$var$LinkAnnotationElement {
    constructor(parameters){
        super(parameters, {
            ignoreBorder: parameters.data.hasAppearance
        });
    }
    render() {
        const container = super.render();
        container.classList.add("buttonWidgetAnnotation", "pushButton");
        const linkElement = container.lastChild;
        if (this.enableScripting && this.hasJSActions && linkElement) {
            this._setDefaultPropertiesFromJS(linkElement);
            linkElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                this._dispatchEventFromSandbox({}, jsEvent);
            });
        }
        return container;
    }
}
class $cca4aceb320d03d3$var$ChoiceWidgetAnnotationElement extends $cca4aceb320d03d3$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        this.container.classList.add("choiceWidgetAnnotation");
        const storage = this.annotationStorage;
        const id = this.data.id;
        const storedData = storage.getValue(id, {
            value: this.data.fieldValue
        });
        const selectElement = document.createElement("select");
        $cca4aceb320d03d3$var$GetElementsByNameSet.add(selectElement);
        selectElement.setAttribute("data-element-id", id);
        selectElement.disabled = this.data.readOnly;
        this._setRequired(selectElement, this.data.required);
        selectElement.name = this.data.fieldName;
        selectElement.tabIndex = $cca4aceb320d03d3$var$DEFAULT_TAB_INDEX;
        let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
        if (!this.data.combo) {
            selectElement.size = this.data.options.length;
            if (this.data.multiSelect) selectElement.multiple = true;
        }
        selectElement.addEventListener("resetform", (event)=>{
            const defaultValue = this.data.defaultFieldValue;
            for (const option of selectElement.options)option.selected = option.value === defaultValue;
        });
        for (const option of this.data.options){
            const optionElement = document.createElement("option");
            optionElement.textContent = option.displayValue;
            optionElement.value = option.exportValue;
            if (storedData.value.includes(option.exportValue)) {
                optionElement.setAttribute("selected", true);
                addAnEmptyEntry = false;
            }
            selectElement.append(optionElement);
        }
        let removeEmptyEntry = null;
        if (addAnEmptyEntry) {
            const noneOptionElement = document.createElement("option");
            noneOptionElement.value = " ";
            noneOptionElement.setAttribute("hidden", true);
            noneOptionElement.setAttribute("selected", true);
            selectElement.prepend(noneOptionElement);
            removeEmptyEntry = ()=>{
                noneOptionElement.remove();
                selectElement.removeEventListener("input", removeEmptyEntry);
                removeEmptyEntry = null;
            };
            selectElement.addEventListener("input", removeEmptyEntry);
        }
        const getValue = (isExport)=>{
            const name = isExport ? "value" : "textContent";
            const { options: options, multiple: multiple } = selectElement;
            if (!multiple) return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
            return Array.prototype.filter.call(options, (option)=>option.selected).map((option)=>option[name]);
        };
        let selectedValues = getValue(false);
        const getItems = (event)=>{
            const options = event.target.options;
            return Array.prototype.map.call(options, (option)=>({
                    displayValue: option.textContent,
                    exportValue: option.value
                }));
        };
        if (this.enableScripting && this.hasJSActions) {
            selectElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value (event) {
                        removeEmptyEntry?.();
                        const value = event.detail.value;
                        const values = new Set(Array.isArray(value) ? value : [
                            value
                        ]);
                        for (const option of selectElement.options)option.selected = values.has(option.value);
                        storage.setValue(id, {
                            value: getValue(true)
                        });
                        selectedValues = getValue(false);
                    },
                    multipleSelection (event) {
                        selectElement.multiple = true;
                    },
                    remove (event) {
                        const options = selectElement.options;
                        const index = event.detail.remove;
                        options[index].selected = false;
                        selectElement.remove(index);
                        if (options.length > 0) {
                            const i = Array.prototype.findIndex.call(options, (option)=>option.selected);
                            if (i === -1) options[0].selected = true;
                        }
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    clear (event) {
                        while(selectElement.length !== 0)selectElement.remove(0);
                        storage.setValue(id, {
                            value: null,
                            items: []
                        });
                        selectedValues = getValue(false);
                    },
                    insert (event) {
                        const { index: index, displayValue: displayValue, exportValue: exportValue } = event.detail.insert;
                        const selectChild = selectElement.children[index];
                        const optionElement = document.createElement("option");
                        optionElement.textContent = displayValue;
                        optionElement.value = exportValue;
                        if (selectChild) selectChild.before(optionElement);
                        else selectElement.append(optionElement);
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    items (event) {
                        const { items: items } = event.detail;
                        while(selectElement.length !== 0)selectElement.remove(0);
                        for (const item of items){
                            const { displayValue: displayValue, exportValue: exportValue } = item;
                            const optionElement = document.createElement("option");
                            optionElement.textContent = displayValue;
                            optionElement.value = exportValue;
                            selectElement.append(optionElement);
                        }
                        if (selectElement.options.length > 0) selectElement.options[0].selected = true;
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    indices (event) {
                        const indices = new Set(event.detail.indices);
                        for (const option of event.target.options)option.selected = indices.has(option.index);
                        storage.setValue(id, {
                            value: getValue(true)
                        });
                        selectedValues = getValue(false);
                    },
                    editable (event) {
                        event.target.disabled = !event.detail.editable;
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            selectElement.addEventListener("input", (event)=>{
                const exportValue = getValue(true);
                const change = getValue(false);
                storage.setValue(id, {
                    value: exportValue
                });
                event.preventDefault();
                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                        id: id,
                        name: "Keystroke",
                        value: selectedValues,
                        change: change,
                        changeEx: exportValue,
                        willCommit: false,
                        commitKey: 1,
                        keyDown: false
                    }
                });
            });
            this._setEventListeners(selectElement, null, [
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ],
                [
                    "input",
                    "Action"
                ],
                [
                    "input",
                    "Validate"
                ]
            ], (event)=>event.target.value);
        } else selectElement.addEventListener("input", function(event) {
            storage.setValue(id, {
                value: getValue(true)
            });
        });
        if (this.data.combo) this._setTextStyle(selectElement);
        this._setBackgroundColor(selectElement);
        this._setDefaultPropertiesFromJS(selectElement);
        this.container.append(selectElement);
        return this.container;
    }
}
class $cca4aceb320d03d3$var$PopupAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    constructor(parameters){
        const { data: data, elements: elements } = parameters;
        super(parameters, {
            isRenderable: $cca4aceb320d03d3$var$AnnotationElement._hasPopupData(data)
        });
        this.elements = elements;
        this.popup = null;
    }
    render() {
        this.container.classList.add("popupAnnotation");
        const popup = this.popup = new $cca4aceb320d03d3$var$PopupElement({
            container: this.container,
            color: this.data.color,
            titleObj: this.data.titleObj,
            modificationDate: this.data.modificationDate,
            contentsObj: this.data.contentsObj,
            richText: this.data.richText,
            rect: this.data.rect,
            parentRect: this.data.parentRect || null,
            parent: this.parent,
            elements: this.elements,
            open: this.data.open
        });
        const elementIds = [];
        for (const element of this.elements){
            element.popup = popup;
            elementIds.push(element.data.id);
            element.addHighlightArea();
        }
        this.container.setAttribute("aria-controls", elementIds.map((id)=>`${$cca4aceb320d03d3$var$AnnotationPrefix}${id}`).join(","));
        return this.container;
    }
}
class $cca4aceb320d03d3$var$PopupElement {
    #boundKeyDown = this.#keyDown.bind(this);
    #boundHide = this.#hide.bind(this);
    #boundShow = this.#show.bind(this);
    #boundToggle = this.#toggle.bind(this);
    #color = null;
    #container = null;
    #contentsObj = null;
    #dateObj = null;
    #elements = null;
    #parent = null;
    #parentRect = null;
    #pinned = false;
    #popup = null;
    #position = null;
    #rect = null;
    #richText = null;
    #titleObj = null;
    #updates = null;
    #wasVisible = false;
    constructor({ container: container, color: color, elements: elements, titleObj: titleObj, modificationDate: modificationDate, contentsObj: contentsObj, richText: richText, parent: parent, rect: rect, parentRect: parentRect, open: open }){
        this.#container = container;
        this.#titleObj = titleObj;
        this.#contentsObj = contentsObj;
        this.#richText = richText;
        this.#parent = parent;
        this.#color = color;
        this.#rect = rect;
        this.#parentRect = parentRect;
        this.#elements = elements;
        this.#dateObj = $cca4aceb320d03d3$var$PDFDateString.toDateObject(modificationDate);
        this.trigger = elements.flatMap((e)=>e.getElementsToTriggerPopup());
        for (const element of this.trigger){
            element.addEventListener("click", this.#boundToggle);
            element.addEventListener("mouseenter", this.#boundShow);
            element.addEventListener("mouseleave", this.#boundHide);
            element.classList.add("popupTriggerArea");
        }
        for (const element of elements)element.container?.addEventListener("keydown", this.#boundKeyDown);
        this.#container.hidden = true;
        if (open) this.#toggle();
    }
    render() {
        if (this.#popup) return;
        const popup = this.#popup = document.createElement("div");
        popup.className = "popup";
        if (this.#color) {
            const baseColor = popup.style.outlineColor = $cca4aceb320d03d3$var$Util.makeHexColor(...this.#color);
            if (CSS.supports("background-color", "color-mix(in srgb, red 30%, white)")) popup.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
            else {
                const BACKGROUND_ENLIGHT = 0.7;
                popup.style.backgroundColor = $cca4aceb320d03d3$var$Util.makeHexColor(...this.#color.map((c)=>Math.floor(BACKGROUND_ENLIGHT * (255 - c) + c)));
            }
        }
        const header = document.createElement("span");
        header.className = "header";
        const title = document.createElement("h1");
        header.append(title);
        ({ dir: title.dir, str: title.textContent } = this.#titleObj);
        popup.append(header);
        if (this.#dateObj) {
            const modificationDate = document.createElement("span");
            modificationDate.classList.add("popupDate");
            modificationDate.setAttribute("data-l10n-id", "pdfjs-annotation-date-string");
            modificationDate.setAttribute("data-l10n-args", JSON.stringify({
                date: this.#dateObj.toLocaleDateString(),
                time: this.#dateObj.toLocaleTimeString()
            }));
            header.append(modificationDate);
        }
        const html = this.#html;
        if (html) {
            $cca4aceb320d03d3$var$XfaLayer.render({
                xfaHtml: html,
                intent: "richText",
                div: popup
            });
            popup.lastChild.classList.add("richText", "popupContent");
        } else {
            const contents = this._formatContents(this.#contentsObj);
            popup.append(contents);
        }
        this.#container.append(popup);
    }
    get #html() {
        const richText = this.#richText;
        const contentsObj = this.#contentsObj;
        if (richText?.str && (!contentsObj?.str || contentsObj.str === richText.str)) return this.#richText.html || null;
        return null;
    }
    get #fontSize() {
        return this.#html?.attributes?.style?.fontSize || 0;
    }
    get #fontColor() {
        return this.#html?.attributes?.style?.color || null;
    }
    #makePopupContent(text) {
        const popupLines = [];
        const popupContent = {
            str: text,
            html: {
                name: "div",
                attributes: {
                    dir: "auto"
                },
                children: [
                    {
                        name: "p",
                        children: popupLines
                    }
                ]
            }
        };
        const lineAttributes = {
            style: {
                color: this.#fontColor,
                fontSize: this.#fontSize ? `calc(${this.#fontSize}px * var(--scale-factor))` : ""
            }
        };
        for (const line of text.split("\n"))popupLines.push({
            name: "span",
            value: line,
            attributes: lineAttributes
        });
        return popupContent;
    }
    _formatContents({ str: str, dir: dir }) {
        const p = document.createElement("p");
        p.classList.add("popupContent");
        p.dir = dir;
        const lines = str.split(/(?:\r\n?|\n)/);
        for(let i = 0, ii = lines.length; i < ii; ++i){
            const line = lines[i];
            p.append(document.createTextNode(line));
            if (i < ii - 1) p.append(document.createElement("br"));
        }
        return p;
    }
    #keyDown(event) {
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        if (event.key === "Enter" || event.key === "Escape" && this.#pinned) this.#toggle();
    }
    updateEdited({ rect: rect, popupContent: popupContent }) {
        this.#updates ||= {
            contentsObj: this.#contentsObj,
            richText: this.#richText
        };
        if (rect) this.#position = null;
        if (popupContent) {
            this.#richText = this.#makePopupContent(popupContent);
            this.#contentsObj = null;
        }
        this.#popup?.remove();
        this.#popup = null;
    }
    resetEdited() {
        if (!this.#updates) return;
        ({ contentsObj: this.#contentsObj, richText: this.#richText } = this.#updates);
        this.#updates = null;
        this.#popup?.remove();
        this.#popup = null;
        this.#position = null;
    }
    #setPosition() {
        if (this.#position !== null) return;
        const { page: { view: view }, viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } = this.#parent;
        let useParentRect = !!this.#parentRect;
        let rect = useParentRect ? this.#parentRect : this.#rect;
        for (const element of this.#elements)if (!rect || $cca4aceb320d03d3$var$Util.intersect(element.data.rect, rect) !== null) {
            rect = element.data.rect;
            useParentRect = true;
            break;
        }
        const normalizedRect = $cca4aceb320d03d3$var$Util.normalizeRect([
            rect[0],
            view[3] - rect[1] + view[1],
            rect[2],
            view[3] - rect[3] + view[1]
        ]);
        const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
        const parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
        const popupLeft = normalizedRect[0] + parentWidth;
        const popupTop = normalizedRect[1];
        this.#position = [
            100 * (popupLeft - pageX) / pageWidth,
            100 * (popupTop - pageY) / pageHeight
        ];
        const { style: style } = this.#container;
        style.left = `${this.#position[0]}%`;
        style.top = `${this.#position[1]}%`;
    }
    #toggle() {
        this.#pinned = !this.#pinned;
        if (this.#pinned) {
            this.#show();
            this.#container.addEventListener("click", this.#boundToggle);
            this.#container.addEventListener("keydown", this.#boundKeyDown);
        } else {
            this.#hide();
            this.#container.removeEventListener("click", this.#boundToggle);
            this.#container.removeEventListener("keydown", this.#boundKeyDown);
        }
    }
    #show() {
        if (!this.#popup) this.render();
        if (!this.isVisible) {
            this.#setPosition();
            this.#container.hidden = false;
            this.#container.style.zIndex = parseInt(this.#container.style.zIndex) + 1000;
        } else if (this.#pinned) this.#container.classList.add("focused");
    }
    #hide() {
        this.#container.classList.remove("focused");
        if (this.#pinned || !this.isVisible) return;
        this.#container.hidden = true;
        this.#container.style.zIndex = parseInt(this.#container.style.zIndex) - 1000;
    }
    forceHide() {
        this.#wasVisible = this.isVisible;
        if (!this.#wasVisible) return;
        this.#container.hidden = true;
    }
    maybeShow() {
        if (!this.#wasVisible) return;
        if (!this.#popup) this.#show();
        this.#wasVisible = false;
        this.#container.hidden = false;
    }
    get isVisible() {
        return this.#container.hidden === false;
    }
}
class $cca4aceb320d03d3$var$FreeTextAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.textContent = parameters.data.textContent;
        this.textPosition = parameters.data.textPosition;
        this.annotationEditorType = $cca4aceb320d03d3$var$AnnotationEditorType.FREETEXT;
    }
    render() {
        this.container.classList.add("freeTextAnnotation");
        if (this.textContent) {
            const content = document.createElement("div");
            content.classList.add("annotationTextContent");
            content.setAttribute("role", "comment");
            for (const line of this.textContent){
                const lineSpan = document.createElement("span");
                lineSpan.textContent = line;
                content.append(lineSpan);
            }
            this.container.append(content);
        }
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        this._editOnDoubleClick();
        return this.container;
    }
    get _isEditable() {
        return this.data.hasOwnCanvas;
    }
}
class $cca4aceb320d03d3$var$LineAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    #line = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("lineAnnotation");
        const data = this.data;
        const { width: width, height: height } = $cca4aceb320d03d3$var$getRectDims(data.rect);
        const svg = this.svgFactory.create(width, height, true);
        const line = this.#line = this.svgFactory.createElement("svg:line");
        line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
        line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
        line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
        line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
        line.setAttribute("stroke-width", data.borderStyle.width || 1);
        line.setAttribute("stroke", "transparent");
        line.setAttribute("fill", "transparent");
        svg.append(line);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#line;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $cca4aceb320d03d3$var$SquareAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    #square = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("squareAnnotation");
        const data = this.data;
        const { width: width, height: height } = $cca4aceb320d03d3$var$getRectDims(data.rect);
        const svg = this.svgFactory.create(width, height, true);
        const borderWidth = data.borderStyle.width;
        const square = this.#square = this.svgFactory.createElement("svg:rect");
        square.setAttribute("x", borderWidth / 2);
        square.setAttribute("y", borderWidth / 2);
        square.setAttribute("width", width - borderWidth);
        square.setAttribute("height", height - borderWidth);
        square.setAttribute("stroke-width", borderWidth || 1);
        square.setAttribute("stroke", "transparent");
        square.setAttribute("fill", "transparent");
        svg.append(square);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#square;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $cca4aceb320d03d3$var$CircleAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    #circle = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("circleAnnotation");
        const data = this.data;
        const { width: width, height: height } = $cca4aceb320d03d3$var$getRectDims(data.rect);
        const svg = this.svgFactory.create(width, height, true);
        const borderWidth = data.borderStyle.width;
        const circle = this.#circle = this.svgFactory.createElement("svg:ellipse");
        circle.setAttribute("cx", width / 2);
        circle.setAttribute("cy", height / 2);
        circle.setAttribute("rx", width / 2 - borderWidth / 2);
        circle.setAttribute("ry", height / 2 - borderWidth / 2);
        circle.setAttribute("stroke-width", borderWidth || 1);
        circle.setAttribute("stroke", "transparent");
        circle.setAttribute("fill", "transparent");
        svg.append(circle);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#circle;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $cca4aceb320d03d3$var$PolylineAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    #polyline = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.containerClassName = "polylineAnnotation";
        this.svgElementName = "svg:polyline";
    }
    render() {
        this.container.classList.add(this.containerClassName);
        const { data: { rect: rect, vertices: vertices, borderStyle: borderStyle, popupRef: popupRef } } = this;
        if (!vertices) return this.container;
        const { width: width, height: height } = $cca4aceb320d03d3$var$getRectDims(rect);
        const svg = this.svgFactory.create(width, height, true);
        let points = [];
        for(let i = 0, ii = vertices.length; i < ii; i += 2){
            const x = vertices[i] - rect[0];
            const y = rect[3] - vertices[i + 1];
            points.push(`${x},${y}`);
        }
        points = points.join(" ");
        const polyline = this.#polyline = this.svgFactory.createElement(this.svgElementName);
        polyline.setAttribute("points", points);
        polyline.setAttribute("stroke-width", borderStyle.width || 1);
        polyline.setAttribute("stroke", "transparent");
        polyline.setAttribute("fill", "transparent");
        svg.append(polyline);
        this.container.append(svg);
        if (!popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#polyline;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $cca4aceb320d03d3$var$PolygonAnnotationElement extends $cca4aceb320d03d3$var$PolylineAnnotationElement {
    constructor(parameters){
        super(parameters);
        this.containerClassName = "polygonAnnotation";
        this.svgElementName = "svg:polygon";
    }
}
class $cca4aceb320d03d3$var$CaretAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("caretAnnotation");
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
}
class $cca4aceb320d03d3$var$InkAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    #polylines = [];
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.containerClassName = "inkAnnotation";
        this.svgElementName = "svg:polyline";
        this.annotationEditorType = $cca4aceb320d03d3$var$AnnotationEditorType.INK;
    }
    render() {
        this.container.classList.add(this.containerClassName);
        const { data: { rect: rect, inkLists: inkLists, borderStyle: borderStyle, popupRef: popupRef } } = this;
        const { width: width, height: height } = $cca4aceb320d03d3$var$getRectDims(rect);
        const svg = this.svgFactory.create(width, height, true);
        for (const inkList of inkLists){
            let points = [];
            for(let i = 0, ii = inkList.length; i < ii; i += 2){
                const x = inkList[i] - rect[0];
                const y = rect[3] - inkList[i + 1];
                points.push(`${x},${y}`);
            }
            points = points.join(" ");
            const polyline = this.svgFactory.createElement(this.svgElementName);
            this.#polylines.push(polyline);
            polyline.setAttribute("points", points);
            polyline.setAttribute("stroke-width", borderStyle.width || 1);
            polyline.setAttribute("stroke", "transparent");
            polyline.setAttribute("fill", "transparent");
            if (!popupRef && this.hasPopupData) this._createPopup();
            svg.append(polyline);
        }
        this.container.append(svg);
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#polylines;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $cca4aceb320d03d3$var$HighlightAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        this.container.classList.add("highlightAnnotation");
        return this.container;
    }
}
class $cca4aceb320d03d3$var$UnderlineAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        this.container.classList.add("underlineAnnotation");
        return this.container;
    }
}
class $cca4aceb320d03d3$var$SquigglyAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        this.container.classList.add("squigglyAnnotation");
        return this.container;
    }
}
class $cca4aceb320d03d3$var$StrikeOutAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        this.container.classList.add("strikeoutAnnotation");
        return this.container;
    }
}
class $cca4aceb320d03d3$var$StampAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("stampAnnotation");
        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
        return this.container;
    }
}
class $cca4aceb320d03d3$var$FileAttachmentAnnotationElement extends $cca4aceb320d03d3$var$AnnotationElement {
    #trigger = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true
        });
        const { file: file } = this.data;
        this.filename = file.filename;
        this.content = file.content;
        this.linkService.eventBus?.dispatch("fileattachmentannotation", {
            source: this,
            ...file
        });
    }
    render() {
        this.container.classList.add("fileAttachmentAnnotation");
        const { container: container, data: data } = this;
        let trigger;
        if (data.hasAppearance || data.fillAlpha === 0) trigger = document.createElement("div");
        else {
            trigger = document.createElement("img");
            trigger.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data.name) ? "paperclip" : "pushpin"}.svg`;
            if (data.fillAlpha && data.fillAlpha < 1) trigger.style = `filter: opacity(${Math.round(data.fillAlpha * 100)}%);`;
        }
        trigger.addEventListener("dblclick", this.#download.bind(this));
        this.#trigger = trigger;
        const { isMac: isMac } = $cca4aceb320d03d3$var$util_FeatureTest.platform;
        container.addEventListener("keydown", (evt)=>{
            if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) this.#download();
        });
        if (!data.popupRef && this.hasPopupData) this._createPopup();
        else trigger.classList.add("popupTriggerArea");
        container.append(trigger);
        return container;
    }
    getElementsToTriggerPopup() {
        return this.#trigger;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
    #download() {
        this.downloadManager?.openOrDownloadData(this.content, this.filename);
    }
}
class $cca4aceb320d03d3$var$AnnotationLayer {
    #accessibilityManager = null;
    #annotationCanvasMap = null;
    #editableAnnotations = new Map();
    constructor({ div: div, accessibilityManager: accessibilityManager, annotationCanvasMap: annotationCanvasMap, annotationEditorUIManager: annotationEditorUIManager, page: page, viewport: viewport }){
        this.div = div;
        this.#accessibilityManager = accessibilityManager;
        this.#annotationCanvasMap = annotationCanvasMap;
        this.page = page;
        this.viewport = viewport;
        this.zIndex = 0;
        this._annotationEditorUIManager = annotationEditorUIManager;
    }
    #appendElement(element, id) {
        const contentElement = element.firstChild || element;
        contentElement.id = `${$cca4aceb320d03d3$var$AnnotationPrefix}${id}`;
        this.div.append(element);
        this.#accessibilityManager?.moveElementInDOM(this.div, element, contentElement, false);
    }
    async render(params) {
        const { annotations: annotations } = params;
        const layer = this.div;
        $cca4aceb320d03d3$var$setLayerDimensions(layer, this.viewport);
        const popupToElements = new Map();
        const elementParams = {
            data: null,
            layer: layer,
            linkService: params.linkService,
            downloadManager: params.downloadManager,
            imageResourcesPath: params.imageResourcesPath || "",
            renderForms: params.renderForms !== false,
            svgFactory: new $cca4aceb320d03d3$var$DOMSVGFactory(),
            annotationStorage: params.annotationStorage || new $cca4aceb320d03d3$var$AnnotationStorage(),
            enableScripting: params.enableScripting === true,
            hasJSActions: params.hasJSActions,
            fieldObjects: params.fieldObjects,
            parent: this,
            elements: null
        };
        for (const data of annotations){
            if (data.noHTML) continue;
            const isPopupAnnotation = data.annotationType === $cca4aceb320d03d3$var$AnnotationType.POPUP;
            if (!isPopupAnnotation) {
                const { width: width, height: height } = $cca4aceb320d03d3$var$getRectDims(data.rect);
                if (width <= 0 || height <= 0) continue;
            } else {
                const elements = popupToElements.get(data.id);
                if (!elements) continue;
                elementParams.elements = elements;
            }
            elementParams.data = data;
            const element = $cca4aceb320d03d3$var$AnnotationElementFactory.create(elementParams);
            if (!element.isRenderable) continue;
            if (!isPopupAnnotation && data.popupRef) {
                const elements = popupToElements.get(data.popupRef);
                if (!elements) popupToElements.set(data.popupRef, [
                    element
                ]);
                else elements.push(element);
            }
            const rendered = element.render();
            if (data.hidden) rendered.style.visibility = "hidden";
            this.#appendElement(rendered, data.id);
            if (element.annotationEditorType > 0) {
                this.#editableAnnotations.set(element.data.id, element);
                this._annotationEditorUIManager?.renderAnnotationElement(element);
            }
        }
        this.#setAnnotationCanvasMap();
    }
    update({ viewport: viewport }) {
        const layer = this.div;
        this.viewport = viewport;
        $cca4aceb320d03d3$var$setLayerDimensions(layer, {
            rotation: viewport.rotation
        });
        this.#setAnnotationCanvasMap();
        layer.hidden = false;
    }
    #setAnnotationCanvasMap() {
        if (!this.#annotationCanvasMap) return;
        const layer = this.div;
        for (const [id, canvas] of this.#annotationCanvasMap){
            const element = layer.querySelector(`[data-annotation-id="${id}"]`);
            if (!element) continue;
            canvas.className = "annotationContent";
            const { firstChild: firstChild } = element;
            if (!firstChild) element.append(canvas);
            else if (firstChild.nodeName === "CANVAS") firstChild.replaceWith(canvas);
            else if (!firstChild.classList.contains("annotationContent")) firstChild.before(canvas);
            else firstChild.after(canvas);
        }
        this.#annotationCanvasMap.clear();
    }
    getEditableAnnotations() {
        return Array.from(this.#editableAnnotations.values());
    }
    getEditableAnnotation(id) {
        return this.#editableAnnotations.get(id);
    }
}
const $cca4aceb320d03d3$var$EOL_PATTERN = /\r\n?|\n/g;
class $cca4aceb320d03d3$var$FreeTextEditor extends $cca4aceb320d03d3$var$AnnotationEditor {
    #boundEditorDivBlur = this.editorDivBlur.bind(this);
    #boundEditorDivFocus = this.editorDivFocus.bind(this);
    #boundEditorDivInput = this.editorDivInput.bind(this);
    #boundEditorDivKeydown = this.editorDivKeydown.bind(this);
    #boundEditorDivPaste = this.editorDivPaste.bind(this);
    #color;
    #content = "";
    #editorDivId = `${this.id}-editor`;
    #fontSize;
    #initialData = null;
    static _freeTextDefaultContent = "";
    static _internalPadding = 0;
    static _defaultColor = null;
    static _defaultFontSize = 10;
    static get _keyboardManager() {
        const proto = $cca4aceb320d03d3$var$FreeTextEditor.prototype;
        const arrowChecker = (self)=>self.isEmpty();
        const small = $cca4aceb320d03d3$var$AnnotationEditorUIManager.TRANSLATE_SMALL;
        const big = $cca4aceb320d03d3$var$AnnotationEditorUIManager.TRANSLATE_BIG;
        return $cca4aceb320d03d3$var$shadow(this, "_keyboardManager", new $cca4aceb320d03d3$var$KeyboardManager([
            [
                [
                    "ctrl+s",
                    "mac+meta+s",
                    "ctrl+p",
                    "mac+meta+p"
                ],
                proto.commitOrRemove,
                {
                    bubbles: true
                }
            ],
            [
                [
                    "ctrl+Enter",
                    "mac+meta+Enter",
                    "Escape",
                    "mac+Escape"
                ],
                proto.commitOrRemove
            ],
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto._translateEmpty,
                {
                    args: [
                        -small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                proto._translateEmpty,
                {
                    args: [
                        -big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto._translateEmpty,
                {
                    args: [
                        small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                proto._translateEmpty,
                {
                    args: [
                        big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        -small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        -big
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        big
                    ],
                    checker: arrowChecker
                }
            ]
        ]));
    }
    static _type = "freetext";
    static _editorType = $cca4aceb320d03d3$var$AnnotationEditorType.FREETEXT;
    constructor(params){
        super({
            ...params,
            name: "freeTextEditor"
        });
        this.#color = params.color || $cca4aceb320d03d3$var$FreeTextEditor._defaultColor || $cca4aceb320d03d3$var$AnnotationEditor._defaultLineColor;
        this.#fontSize = params.fontSize || $cca4aceb320d03d3$var$FreeTextEditor._defaultFontSize;
    }
    static initialize(l10n, uiManager) {
        $cca4aceb320d03d3$var$AnnotationEditor.initialize(l10n, uiManager, {
            strings: [
                "pdfjs-free-text-default-content"
            ]
        });
        const style = getComputedStyle(document.documentElement);
        this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
    }
    static updateDefaultParams(type, value) {
        switch(type){
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.FREETEXT_SIZE:
                $cca4aceb320d03d3$var$FreeTextEditor._defaultFontSize = value;
                break;
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.FREETEXT_COLOR:
                $cca4aceb320d03d3$var$FreeTextEditor._defaultColor = value;
                break;
        }
    }
    updateParams(type, value) {
        switch(type){
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.FREETEXT_SIZE:
                this.#updateFontSize(value);
                break;
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.FREETEXT_COLOR:
                this.#updateColor(value);
                break;
        }
    }
    static get defaultPropertiesToUpdate() {
        return [
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.FREETEXT_SIZE,
                $cca4aceb320d03d3$var$FreeTextEditor._defaultFontSize
            ],
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.FREETEXT_COLOR,
                $cca4aceb320d03d3$var$FreeTextEditor._defaultColor || $cca4aceb320d03d3$var$AnnotationEditor._defaultLineColor
            ]
        ];
    }
    get propertiesToUpdate() {
        return [
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.FREETEXT_SIZE,
                this.#fontSize
            ],
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.FREETEXT_COLOR,
                this.#color
            ]
        ];
    }
    #updateFontSize(fontSize) {
        const setFontsize = (size)=>{
            this.editorDiv.style.fontSize = `calc(${size}px * var(--scale-factor))`;
            this.translate(0, -(size - this.#fontSize) * this.parentScale);
            this.#fontSize = size;
            this.#setEditorDimensions();
        };
        const savedFontsize = this.#fontSize;
        this.addCommands({
            cmd: setFontsize.bind(this, fontSize),
            undo: setFontsize.bind(this, savedFontsize),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $cca4aceb320d03d3$var$AnnotationEditorParamsType.FREETEXT_SIZE,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    #updateColor(color) {
        const setColor = (col)=>{
            this.#color = this.editorDiv.style.color = col;
        };
        const savedColor = this.#color;
        this.addCommands({
            cmd: setColor.bind(this, color),
            undo: setColor.bind(this, savedColor),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $cca4aceb320d03d3$var$AnnotationEditorParamsType.FREETEXT_COLOR,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    _translateEmpty(x, y) {
        this._uiManager.translateSelectedEditors(x, y, true);
    }
    getInitialTranslation() {
        const scale = this.parentScale;
        return [
            -$cca4aceb320d03d3$var$FreeTextEditor._internalPadding * scale,
            -($cca4aceb320d03d3$var$FreeTextEditor._internalPadding + this.#fontSize) * scale
        ];
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    enableEditMode() {
        if (this.isInEditMode()) return;
        this.parent.setEditingState(false);
        this.parent.updateToolbar($cca4aceb320d03d3$var$AnnotationEditorType.FREETEXT);
        super.enableEditMode();
        this.overlayDiv.classList.remove("enabled");
        this.editorDiv.contentEditable = true;
        this._isDraggable = false;
        this.div.removeAttribute("aria-activedescendant");
        const signal = this._uiManager._signal;
        this.editorDiv.addEventListener("keydown", this.#boundEditorDivKeydown, {
            signal: signal
        });
        this.editorDiv.addEventListener("focus", this.#boundEditorDivFocus, {
            signal: signal
        });
        this.editorDiv.addEventListener("blur", this.#boundEditorDivBlur, {
            signal: signal
        });
        this.editorDiv.addEventListener("input", this.#boundEditorDivInput, {
            signal: signal
        });
        this.editorDiv.addEventListener("paste", this.#boundEditorDivPaste, {
            signal: signal
        });
    }
    disableEditMode() {
        if (!this.isInEditMode()) return;
        this.parent.setEditingState(true);
        super.disableEditMode();
        this.overlayDiv.classList.add("enabled");
        this.editorDiv.contentEditable = false;
        this.div.setAttribute("aria-activedescendant", this.#editorDivId);
        this._isDraggable = true;
        this.editorDiv.removeEventListener("keydown", this.#boundEditorDivKeydown);
        this.editorDiv.removeEventListener("focus", this.#boundEditorDivFocus);
        this.editorDiv.removeEventListener("blur", this.#boundEditorDivBlur);
        this.editorDiv.removeEventListener("input", this.#boundEditorDivInput);
        this.editorDiv.removeEventListener("paste", this.#boundEditorDivPaste);
        this.div.focus({
            preventScroll: true
        });
        this.isEditing = false;
        this.parent.div.classList.add("freetextEditing");
    }
    focusin(event) {
        if (!this._focusEventsAllowed) return;
        super.focusin(event);
        if (event.target !== this.editorDiv) this.editorDiv.focus();
    }
    onceAdded() {
        if (this.width) return;
        this.enableEditMode();
        this.editorDiv.focus();
        if (this._initialOptions?.isCentered) this.center();
        this._initialOptions = null;
    }
    isEmpty() {
        return !this.editorDiv || this.editorDiv.innerText.trim() === "";
    }
    remove() {
        this.isEditing = false;
        if (this.parent) {
            this.parent.setEditingState(true);
            this.parent.div.classList.add("freetextEditing");
        }
        super.remove();
    }
    #extractText() {
        const buffer = [];
        this.editorDiv.normalize();
        for (const child of this.editorDiv.childNodes)buffer.push($cca4aceb320d03d3$var$FreeTextEditor.#getNodeContent(child));
        return buffer.join("\n");
    }
    #setEditorDimensions() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        let rect;
        if (this.isAttachedToDOM) rect = this.div.getBoundingClientRect();
        else {
            const { currentLayer: currentLayer, div: div } = this;
            const savedDisplay = div.style.display;
            const savedVisibility = div.classList.contains("hidden");
            div.classList.remove("hidden");
            div.style.display = "hidden";
            currentLayer.div.append(this.div);
            rect = div.getBoundingClientRect();
            div.remove();
            div.style.display = savedDisplay;
            div.classList.toggle("hidden", savedVisibility);
        }
        if (this.rotation % 180 === this.parentRotation % 180) {
            this.width = rect.width / parentWidth;
            this.height = rect.height / parentHeight;
        } else {
            this.width = rect.height / parentWidth;
            this.height = rect.width / parentHeight;
        }
        this.fixAndSetPosition();
    }
    commit() {
        if (!this.isInEditMode()) return;
        super.commit();
        this.disableEditMode();
        const savedText = this.#content;
        const newText = this.#content = this.#extractText().trimEnd();
        if (savedText === newText) return;
        const setText = (text)=>{
            this.#content = text;
            if (!text) {
                this.remove();
                return;
            }
            this.#setContent();
            this._uiManager.rebuild(this);
            this.#setEditorDimensions();
        };
        this.addCommands({
            cmd: ()=>{
                setText(newText);
            },
            undo: ()=>{
                setText(savedText);
            },
            mustExec: false
        });
        this.#setEditorDimensions();
    }
    shouldGetKeyboardEvents() {
        return this.isInEditMode();
    }
    enterInEditMode() {
        this.enableEditMode();
        this.editorDiv.focus();
    }
    dblclick(event) {
        this.enterInEditMode();
    }
    keydown(event) {
        if (event.target === this.div && event.key === "Enter") {
            this.enterInEditMode();
            event.preventDefault();
        }
    }
    editorDivKeydown(event) {
        $cca4aceb320d03d3$var$FreeTextEditor._keyboardManager.exec(this, event);
    }
    editorDivFocus(event) {
        this.isEditing = true;
    }
    editorDivBlur(event) {
        this.isEditing = false;
    }
    editorDivInput(event) {
        this.parent.div.classList.toggle("freetextEditing", this.isEmpty());
    }
    disableEditing() {
        this.editorDiv.setAttribute("role", "comment");
        this.editorDiv.removeAttribute("aria-multiline");
    }
    enableEditing() {
        this.editorDiv.setAttribute("role", "textbox");
        this.editorDiv.setAttribute("aria-multiline", true);
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this.width) {
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        this.editorDiv = document.createElement("div");
        this.editorDiv.className = "internal";
        this.editorDiv.setAttribute("id", this.#editorDivId);
        this.editorDiv.setAttribute("data-l10n-id", "pdfjs-free-text");
        this.enableEditing();
        $cca4aceb320d03d3$var$AnnotationEditor._l10nPromise.get("pdfjs-free-text-default-content").then((msg)=>this.editorDiv?.setAttribute("default-content", msg));
        this.editorDiv.contentEditable = true;
        const { style: style } = this.editorDiv;
        style.fontSize = `calc(${this.#fontSize}px * var(--scale-factor))`;
        style.color = this.#color;
        this.div.append(this.editorDiv);
        this.overlayDiv = document.createElement("div");
        this.overlayDiv.classList.add("overlay", "enabled");
        this.div.append(this.overlayDiv);
        $cca4aceb320d03d3$var$bindEvents(this, this.div, [
            "dblclick",
            "keydown"
        ]);
        if (this.width) {
            const [parentWidth, parentHeight] = this.parentDimensions;
            if (this.annotationElementId) {
                const { position: position } = this.#initialData;
                let [tx, ty] = this.getInitialTranslation();
                [tx, ty] = this.pageTranslationToScreen(tx, ty);
                const [pageWidth, pageHeight] = this.pageDimensions;
                const [pageX, pageY] = this.pageTranslation;
                let posX, posY;
                switch(this.rotation){
                    case 0:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                        break;
                    case 90:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        [tx, ty] = [
                            ty,
                            -tx
                        ];
                        break;
                    case 180:
                        posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        [tx, ty] = [
                            -tx,
                            -ty
                        ];
                        break;
                    case 270:
                        posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
                        posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
                        [tx, ty] = [
                            -ty,
                            tx
                        ];
                        break;
                }
                this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
            } else this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
            this.#setContent();
            this._isDraggable = true;
            this.editorDiv.contentEditable = false;
        } else {
            this._isDraggable = false;
            this.editorDiv.contentEditable = true;
        }
        return this.div;
    }
    static #getNodeContent(node) {
        return (node.nodeType === Node.TEXT_NODE ? node.nodeValue : node.innerText).replaceAll($cca4aceb320d03d3$var$EOL_PATTERN, "");
    }
    editorDivPaste(event) {
        const clipboardData = event.clipboardData || window.clipboardData;
        const { types: types } = clipboardData;
        if (types.length === 1 && types[0] === "text/plain") return;
        event.preventDefault();
        const paste = $cca4aceb320d03d3$var$FreeTextEditor.#deserializeContent(clipboardData.getData("text") || "").replaceAll($cca4aceb320d03d3$var$EOL_PATTERN, "\n");
        if (!paste) return;
        const selection = window.getSelection();
        if (!selection.rangeCount) return;
        this.editorDiv.normalize();
        selection.deleteFromDocument();
        const range = selection.getRangeAt(0);
        if (!paste.includes("\n")) {
            range.insertNode(document.createTextNode(paste));
            this.editorDiv.normalize();
            selection.collapseToStart();
            return;
        }
        const { startContainer: startContainer, startOffset: startOffset } = range;
        const bufferBefore = [];
        const bufferAfter = [];
        if (startContainer.nodeType === Node.TEXT_NODE) {
            const parent = startContainer.parentElement;
            bufferAfter.push(startContainer.nodeValue.slice(startOffset).replaceAll($cca4aceb320d03d3$var$EOL_PATTERN, ""));
            if (parent !== this.editorDiv) {
                let buffer = bufferBefore;
                for (const child of this.editorDiv.childNodes){
                    if (child === parent) {
                        buffer = bufferAfter;
                        continue;
                    }
                    buffer.push($cca4aceb320d03d3$var$FreeTextEditor.#getNodeContent(child));
                }
            }
            bufferBefore.push(startContainer.nodeValue.slice(0, startOffset).replaceAll($cca4aceb320d03d3$var$EOL_PATTERN, ""));
        } else if (startContainer === this.editorDiv) {
            let buffer = bufferBefore;
            let i = 0;
            for (const child of this.editorDiv.childNodes){
                if (i++ === startOffset) buffer = bufferAfter;
                buffer.push($cca4aceb320d03d3$var$FreeTextEditor.#getNodeContent(child));
            }
        }
        this.#content = `${bufferBefore.join("\n")}${paste}${bufferAfter.join("\n")}`;
        this.#setContent();
        const newRange = new Range();
        let beforeLength = bufferBefore.reduce((acc, line)=>acc + line.length, 0);
        for (const { firstChild: firstChild } of this.editorDiv.childNodes)if (firstChild.nodeType === Node.TEXT_NODE) {
            const length = firstChild.nodeValue.length;
            if (beforeLength <= length) {
                newRange.setStart(firstChild, beforeLength);
                newRange.setEnd(firstChild, beforeLength);
                break;
            }
            beforeLength -= length;
        }
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
    #setContent() {
        this.editorDiv.replaceChildren();
        if (!this.#content) return;
        for (const line of this.#content.split("\n")){
            const div = document.createElement("div");
            div.append(line ? document.createTextNode(line) : document.createElement("br"));
            this.editorDiv.append(div);
        }
    }
    #serializeContent() {
        return this.#content.replaceAll("\xa0", " ");
    }
    static #deserializeContent(content) {
        return content.replaceAll(" ", "\xa0");
    }
    get contentDiv() {
        return this.editorDiv;
    }
    static deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $cca4aceb320d03d3$var$FreeTextAnnotationElement) {
            const { data: { defaultAppearanceData: { fontSize: fontSize, fontColor: fontColor }, rect: rect, rotation: rotation, id: id }, textContent: textContent, textPosition: textPosition, parent: { page: { pageNumber: pageNumber } } } = data;
            if (!textContent || textContent.length === 0) return null;
            initialData = data = {
                annotationType: $cca4aceb320d03d3$var$AnnotationEditorType.FREETEXT,
                color: Array.from(fontColor),
                fontSize: fontSize,
                value: textContent.join("\n"),
                position: textPosition,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                id: id,
                deleted: false
            };
        }
        const editor = super.deserialize(data, parent, uiManager);
        editor.#fontSize = data.fontSize;
        editor.#color = $cca4aceb320d03d3$var$Util.makeHexColor(...data.color);
        editor.#content = $cca4aceb320d03d3$var$FreeTextEditor.#deserializeContent(data.value);
        editor.annotationElementId = data.id || null;
        editor.#initialData = initialData;
        return editor;
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        if (this.deleted) return {
            pageIndex: this.pageIndex,
            id: this.annotationElementId,
            deleted: true
        };
        const padding = $cca4aceb320d03d3$var$FreeTextEditor._internalPadding * this.parentScale;
        const rect = this.getRect(padding, padding);
        const color = $cca4aceb320d03d3$var$AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.#color);
        const serialized = {
            annotationType: $cca4aceb320d03d3$var$AnnotationEditorType.FREETEXT,
            color: color,
            fontSize: this.#fontSize,
            value: this.#serializeContent(),
            pageIndex: this.pageIndex,
            rect: rect,
            rotation: this.rotation,
            structTreeParentId: this._structTreeParentId
        };
        if (isForCopying) return serialized;
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { value: value, fontSize: fontSize, color: color, pageIndex: pageIndex } = this.#initialData;
        return this._hasBeenMoved || serialized.value !== value || serialized.fontSize !== fontSize || serialized.color.some((c, i)=>c !== color[i]) || serialized.pageIndex !== pageIndex;
    }
    renderAnnotationElement(annotation) {
        const content = super.renderAnnotationElement(annotation);
        if (this.deleted) return content;
        const { style: style } = content;
        style.fontSize = `calc(${this.#fontSize}px * var(--scale-factor))`;
        style.color = this.#color;
        content.replaceChildren();
        for (const line of this.#content.split("\n")){
            const div = document.createElement("div");
            div.append(line ? document.createTextNode(line) : document.createElement("br"));
            content.append(div);
        }
        const padding = $cca4aceb320d03d3$var$FreeTextEditor._internalPadding * this.parentScale;
        annotation.updateEdited({
            rect: this.getRect(padding, padding),
            popupContent: this.#content
        });
        return content;
    }
    resetAnnotationElement(annotation) {
        super.resetAnnotationElement(annotation);
        annotation.resetEdited();
    }
}
class $cca4aceb320d03d3$var$Outliner {
    #box;
    #verticalEdges = [];
    #intervals = [];
    constructor(boxes, borderWidth = 0, innerMargin = 0, isLTR = true){
        let minX = Infinity;
        let maxX = -Infinity;
        let minY = Infinity;
        let maxY = -Infinity;
        const NUMBER_OF_DIGITS = 4;
        const EPSILON = 10 ** -NUMBER_OF_DIGITS;
        for (const { x: x, y: y, width: width, height: height } of boxes){
            const x1 = Math.floor((x - borderWidth) / EPSILON) * EPSILON;
            const x2 = Math.ceil((x + width + borderWidth) / EPSILON) * EPSILON;
            const y1 = Math.floor((y - borderWidth) / EPSILON) * EPSILON;
            const y2 = Math.ceil((y + height + borderWidth) / EPSILON) * EPSILON;
            const left = [
                x1,
                y1,
                y2,
                true
            ];
            const right = [
                x2,
                y1,
                y2,
                false
            ];
            this.#verticalEdges.push(left, right);
            minX = Math.min(minX, x1);
            maxX = Math.max(maxX, x2);
            minY = Math.min(minY, y1);
            maxY = Math.max(maxY, y2);
        }
        const bboxWidth = maxX - minX + 2 * innerMargin;
        const bboxHeight = maxY - minY + 2 * innerMargin;
        const shiftedMinX = minX - innerMargin;
        const shiftedMinY = minY - innerMargin;
        const lastEdge = this.#verticalEdges.at(isLTR ? -1 : -2);
        const lastPoint = [
            lastEdge[0],
            lastEdge[2]
        ];
        for (const edge of this.#verticalEdges){
            const [x, y1, y2] = edge;
            edge[0] = (x - shiftedMinX) / bboxWidth;
            edge[1] = (y1 - shiftedMinY) / bboxHeight;
            edge[2] = (y2 - shiftedMinY) / bboxHeight;
        }
        this.#box = {
            x: shiftedMinX,
            y: shiftedMinY,
            width: bboxWidth,
            height: bboxHeight,
            lastPoint: lastPoint
        };
    }
    getOutlines() {
        this.#verticalEdges.sort((a, b)=>a[0] - b[0] || a[1] - b[1] || a[2] - b[2]);
        const outlineVerticalEdges = [];
        for (const edge of this.#verticalEdges)if (edge[3]) {
            outlineVerticalEdges.push(...this.#breakEdge(edge));
            this.#insert(edge);
        } else {
            this.#remove(edge);
            outlineVerticalEdges.push(...this.#breakEdge(edge));
        }
        return this.#getOutlines(outlineVerticalEdges);
    }
    #getOutlines(outlineVerticalEdges) {
        const edges = [];
        const allEdges = new Set();
        for (const edge of outlineVerticalEdges){
            const [x, y1, y2] = edge;
            edges.push([
                x,
                y1,
                edge
            ], [
                x,
                y2,
                edge
            ]);
        }
        edges.sort((a, b)=>a[1] - b[1] || a[0] - b[0]);
        for(let i = 0, ii = edges.length; i < ii; i += 2){
            const edge1 = edges[i][2];
            const edge2 = edges[i + 1][2];
            edge1.push(edge2);
            edge2.push(edge1);
            allEdges.add(edge1);
            allEdges.add(edge2);
        }
        const outlines = [];
        let outline;
        while(allEdges.size > 0){
            const edge = allEdges.values().next().value;
            let [x, y1, y2, edge1, edge2] = edge;
            allEdges.delete(edge);
            let lastPointX = x;
            let lastPointY = y1;
            outline = [
                x,
                y2
            ];
            outlines.push(outline);
            while(true){
                let e;
                if (allEdges.has(edge1)) e = edge1;
                else if (allEdges.has(edge2)) e = edge2;
                else break;
                allEdges.delete(e);
                [x, y1, y2, edge1, edge2] = e;
                if (lastPointX !== x) {
                    outline.push(lastPointX, lastPointY, x, lastPointY === y1 ? y1 : y2);
                    lastPointX = x;
                }
                lastPointY = lastPointY === y1 ? y2 : y1;
            }
            outline.push(lastPointX, lastPointY);
        }
        return new $cca4aceb320d03d3$var$HighlightOutline(outlines, this.#box);
    }
    #binarySearch(y) {
        const array = this.#intervals;
        let start = 0;
        let end = array.length - 1;
        while(start <= end){
            const middle = start + end >> 1;
            const y1 = array[middle][0];
            if (y1 === y) return middle;
            if (y1 < y) start = middle + 1;
            else end = middle - 1;
        }
        return end + 1;
    }
    #insert([, y1, y2]) {
        const index = this.#binarySearch(y1);
        this.#intervals.splice(index, 0, [
            y1,
            y2
        ]);
    }
    #remove([, y1, y2]) {
        const index = this.#binarySearch(y1);
        for(let i = index; i < this.#intervals.length; i++){
            const [start, end] = this.#intervals[i];
            if (start !== y1) break;
            if (start === y1 && end === y2) {
                this.#intervals.splice(i, 1);
                return;
            }
        }
        for(let i = index - 1; i >= 0; i--){
            const [start, end] = this.#intervals[i];
            if (start !== y1) break;
            if (start === y1 && end === y2) {
                this.#intervals.splice(i, 1);
                return;
            }
        }
    }
    #breakEdge(edge) {
        const [x, y1, y2] = edge;
        const results = [
            [
                x,
                y1,
                y2
            ]
        ];
        const index = this.#binarySearch(y2);
        for(let i = 0; i < index; i++){
            const [start, end] = this.#intervals[i];
            for(let j = 0, jj = results.length; j < jj; j++){
                const [, y3, y4] = results[j];
                if (end <= y3 || y4 <= start) continue;
                if (y3 >= start) {
                    if (y4 > end) results[j][1] = end;
                    else {
                        if (jj === 1) return [];
                        results.splice(j, 1);
                        j--;
                        jj--;
                    }
                    continue;
                }
                results[j][2] = start;
                if (y4 > end) results.push([
                    x,
                    end,
                    y4
                ]);
            }
        }
        return results;
    }
}
class $cca4aceb320d03d3$var$Outline {
    toSVGPath() {
        throw new Error("Abstract method `toSVGPath` must be implemented.");
    }
    get box() {
        throw new Error("Abstract getter `box` must be implemented.");
    }
    serialize(_bbox, _rotation) {
        throw new Error("Abstract method `serialize` must be implemented.");
    }
    get free() {
        return this instanceof $cca4aceb320d03d3$var$FreeHighlightOutline;
    }
}
class $cca4aceb320d03d3$var$HighlightOutline extends $cca4aceb320d03d3$var$Outline {
    #box;
    #outlines;
    constructor(outlines, box){
        super();
        this.#outlines = outlines;
        this.#box = box;
    }
    toSVGPath() {
        const buffer = [];
        for (const polygon of this.#outlines){
            let [prevX, prevY] = polygon;
            buffer.push(`M${prevX} ${prevY}`);
            for(let i = 2; i < polygon.length; i += 2){
                const x = polygon[i];
                const y = polygon[i + 1];
                if (x === prevX) {
                    buffer.push(`V${y}`);
                    prevY = y;
                } else if (y === prevY) {
                    buffer.push(`H${x}`);
                    prevX = x;
                }
            }
            buffer.push("Z");
        }
        return buffer.join(" ");
    }
    serialize([blX, blY, trX, trY], _rotation) {
        const outlines = [];
        const width = trX - blX;
        const height = trY - blY;
        for (const outline of this.#outlines){
            const points = new Array(outline.length);
            for(let i = 0; i < outline.length; i += 2){
                points[i] = blX + outline[i] * width;
                points[i + 1] = trY - outline[i + 1] * height;
            }
            outlines.push(points);
        }
        return outlines;
    }
    get box() {
        return this.#box;
    }
}
class $cca4aceb320d03d3$var$FreeOutliner {
    #box;
    #bottom = [];
    #innerMargin;
    #isLTR;
    #top = [];
    #last = new Float64Array(18);
    #lastX;
    #lastY;
    #min;
    #min_dist;
    #scaleFactor;
    #thickness;
    #points = [];
    static #MIN_DIST = 8;
    static #MIN_DIFF = 2;
    static #MIN = $cca4aceb320d03d3$var$FreeOutliner.#MIN_DIST + $cca4aceb320d03d3$var$FreeOutliner.#MIN_DIFF;
    constructor({ x: x, y: y }, box, scaleFactor, thickness, isLTR, innerMargin = 0){
        this.#box = box;
        this.#thickness = thickness * scaleFactor;
        this.#isLTR = isLTR;
        this.#last.set([
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ], 6);
        this.#innerMargin = innerMargin;
        this.#min_dist = $cca4aceb320d03d3$var$FreeOutliner.#MIN_DIST * scaleFactor;
        this.#min = $cca4aceb320d03d3$var$FreeOutliner.#MIN * scaleFactor;
        this.#scaleFactor = scaleFactor;
        this.#points.push(x, y);
    }
    get free() {
        return true;
    }
    isEmpty() {
        return isNaN(this.#last[8]);
    }
    #getLastCoords() {
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [x, y, width, height] = this.#box;
        return [
            (this.#lastX + (lastTop[0] - lastBottom[0]) / 2 - x) / width,
            (this.#lastY + (lastTop[1] - lastBottom[1]) / 2 - y) / height,
            (this.#lastX + (lastBottom[0] - lastTop[0]) / 2 - x) / width,
            (this.#lastY + (lastBottom[1] - lastTop[1]) / 2 - y) / height
        ];
    }
    add({ x: x, y: y }) {
        this.#lastX = x;
        this.#lastY = y;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        let [x1, y1, x2, y2] = this.#last.subarray(8, 12);
        const diffX = x - x2;
        const diffY = y - y2;
        const d = Math.hypot(diffX, diffY);
        if (d < this.#min) return false;
        const diffD = d - this.#min_dist;
        const K = diffD / d;
        const shiftX = K * diffX;
        const shiftY = K * diffY;
        let x0 = x1;
        let y0 = y1;
        x1 = x2;
        y1 = y2;
        x2 += shiftX;
        y2 += shiftY;
        this.#points?.push(x, y);
        const nX = -shiftY / diffD;
        const nY = shiftX / diffD;
        const thX = nX * this.#thickness;
        const thY = nY * this.#thickness;
        this.#last.set(this.#last.subarray(2, 8), 0);
        this.#last.set([
            x2 + thX,
            y2 + thY
        ], 4);
        this.#last.set(this.#last.subarray(14, 18), 12);
        this.#last.set([
            x2 - thX,
            y2 - thY
        ], 16);
        if (isNaN(this.#last[6])) {
            if (this.#top.length === 0) {
                this.#last.set([
                    x1 + thX,
                    y1 + thY
                ], 2);
                this.#top.push(NaN, NaN, NaN, NaN, (x1 + thX - layerX) / layerWidth, (y1 + thY - layerY) / layerHeight);
                this.#last.set([
                    x1 - thX,
                    y1 - thY
                ], 14);
                this.#bottom.push(NaN, NaN, NaN, NaN, (x1 - thX - layerX) / layerWidth, (y1 - thY - layerY) / layerHeight);
            }
            this.#last.set([
                x0,
                y0,
                x1,
                y1,
                x2,
                y2
            ], 6);
            return !this.isEmpty();
        }
        this.#last.set([
            x0,
            y0,
            x1,
            y1,
            x2,
            y2
        ], 6);
        const angle = Math.abs(Math.atan2(y0 - y1, x0 - x1) - Math.atan2(shiftY, shiftX));
        if (angle < Math.PI / 2) {
            [x1, y1, x2, y2] = this.#last.subarray(2, 6);
            this.#top.push(NaN, NaN, NaN, NaN, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
            [x1, y1, x0, y0] = this.#last.subarray(14, 18);
            this.#bottom.push(NaN, NaN, NaN, NaN, ((x0 + x1) / 2 - layerX) / layerWidth, ((y0 + y1) / 2 - layerY) / layerHeight);
            return true;
        }
        [x0, y0, x1, y1, x2, y2] = this.#last.subarray(0, 6);
        this.#top.push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
        [x2, y2, x1, y1, x0, y0] = this.#last.subarray(12, 18);
        this.#bottom.push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
        return true;
    }
    toSVGPath() {
        if (this.isEmpty()) return "";
        const top = this.#top;
        const bottom = this.#bottom;
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [x, y, width, height] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        if (isNaN(this.#last[6]) && !this.isEmpty()) return `M${(this.#last[2] - x) / width} ${(this.#last[3] - y) / height} L${(this.#last[4] - x) / width} ${(this.#last[5] - y) / height} L${lastTopX} ${lastTopY} L${lastBottomX} ${lastBottomY} L${(this.#last[16] - x) / width} ${(this.#last[17] - y) / height} L${(this.#last[14] - x) / width} ${(this.#last[15] - y) / height} Z`;
        const buffer = [];
        buffer.push(`M${top[4]} ${top[5]}`);
        for(let i = 6; i < top.length; i += 6)if (isNaN(top[i])) buffer.push(`L${top[i + 4]} ${top[i + 5]}`);
        else buffer.push(`C${top[i]} ${top[i + 1]} ${top[i + 2]} ${top[i + 3]} ${top[i + 4]} ${top[i + 5]}`);
        buffer.push(`L${(lastTop[0] - x) / width} ${(lastTop[1] - y) / height} L${lastTopX} ${lastTopY} L${lastBottomX} ${lastBottomY} L${(lastBottom[0] - x) / width} ${(lastBottom[1] - y) / height}`);
        for(let i = bottom.length - 6; i >= 6; i -= 6)if (isNaN(bottom[i])) buffer.push(`L${bottom[i + 4]} ${bottom[i + 5]}`);
        else buffer.push(`C${bottom[i]} ${bottom[i + 1]} ${bottom[i + 2]} ${bottom[i + 3]} ${bottom[i + 4]} ${bottom[i + 5]}`);
        buffer.push(`L${bottom[4]} ${bottom[5]} Z`);
        return buffer.join(" ");
    }
    getOutlines() {
        const top = this.#top;
        const bottom = this.#bottom;
        const last = this.#last;
        const lastTop = last.subarray(4, 6);
        const lastBottom = last.subarray(16, 18);
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const points = new Float64Array((this.#points?.length ?? 0) + 2);
        for(let i = 0, ii = points.length - 2; i < ii; i += 2){
            points[i] = (this.#points[i] - layerX) / layerWidth;
            points[i + 1] = (this.#points[i + 1] - layerY) / layerHeight;
        }
        points[points.length - 2] = (this.#lastX - layerX) / layerWidth;
        points[points.length - 1] = (this.#lastY - layerY) / layerHeight;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        if (isNaN(last[6]) && !this.isEmpty()) {
            const outline = new Float64Array(36);
            outline.set([
                NaN,
                NaN,
                NaN,
                NaN,
                (last[2] - layerX) / layerWidth,
                (last[3] - layerY) / layerHeight,
                NaN,
                NaN,
                NaN,
                NaN,
                (last[4] - layerX) / layerWidth,
                (last[5] - layerY) / layerHeight,
                NaN,
                NaN,
                NaN,
                NaN,
                lastTopX,
                lastTopY,
                NaN,
                NaN,
                NaN,
                NaN,
                lastBottomX,
                lastBottomY,
                NaN,
                NaN,
                NaN,
                NaN,
                (last[16] - layerX) / layerWidth,
                (last[17] - layerY) / layerHeight,
                NaN,
                NaN,
                NaN,
                NaN,
                (last[14] - layerX) / layerWidth,
                (last[15] - layerY) / layerHeight
            ], 0);
            return new $cca4aceb320d03d3$var$FreeHighlightOutline(outline, points, this.#box, this.#scaleFactor, this.#innerMargin, this.#isLTR);
        }
        const outline = new Float64Array(this.#top.length + 24 + this.#bottom.length);
        let N = top.length;
        for(let i = 0; i < N; i += 2){
            if (isNaN(top[i])) {
                outline[i] = outline[i + 1] = NaN;
                continue;
            }
            outline[i] = top[i];
            outline[i + 1] = top[i + 1];
        }
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            (lastTop[0] - layerX) / layerWidth,
            (lastTop[1] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            lastTopX,
            lastTopY,
            NaN,
            NaN,
            NaN,
            NaN,
            lastBottomX,
            lastBottomY,
            NaN,
            NaN,
            NaN,
            NaN,
            (lastBottom[0] - layerX) / layerWidth,
            (lastBottom[1] - layerY) / layerHeight
        ], N);
        N += 24;
        for(let i = bottom.length - 6; i >= 6; i -= 6)for(let j = 0; j < 6; j += 2){
            if (isNaN(bottom[i + j])) {
                outline[N] = outline[N + 1] = NaN;
                N += 2;
                continue;
            }
            outline[N] = bottom[i + j];
            outline[N + 1] = bottom[i + j + 1];
            N += 2;
        }
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            bottom[4],
            bottom[5]
        ], N);
        return new $cca4aceb320d03d3$var$FreeHighlightOutline(outline, points, this.#box, this.#scaleFactor, this.#innerMargin, this.#isLTR);
    }
}
class $cca4aceb320d03d3$var$FreeHighlightOutline extends $cca4aceb320d03d3$var$Outline {
    #box;
    #bbox = null;
    #innerMargin;
    #isLTR;
    #points;
    #scaleFactor;
    #outline;
    constructor(outline, points, box, scaleFactor, innerMargin, isLTR){
        super();
        this.#outline = outline;
        this.#points = points;
        this.#box = box;
        this.#scaleFactor = scaleFactor;
        this.#innerMargin = innerMargin;
        this.#isLTR = isLTR;
        this.#computeMinMax(isLTR);
        const { x: x, y: y, width: width, height: height } = this.#bbox;
        for(let i = 0, ii = outline.length; i < ii; i += 2){
            outline[i] = (outline[i] - x) / width;
            outline[i + 1] = (outline[i + 1] - y) / height;
        }
        for(let i = 0, ii = points.length; i < ii; i += 2){
            points[i] = (points[i] - x) / width;
            points[i + 1] = (points[i + 1] - y) / height;
        }
    }
    toSVGPath() {
        const buffer = [
            `M${this.#outline[4]} ${this.#outline[5]}`
        ];
        for(let i = 6, ii = this.#outline.length; i < ii; i += 6){
            if (isNaN(this.#outline[i])) {
                buffer.push(`L${this.#outline[i + 4]} ${this.#outline[i + 5]}`);
                continue;
            }
            buffer.push(`C${this.#outline[i]} ${this.#outline[i + 1]} ${this.#outline[i + 2]} ${this.#outline[i + 3]} ${this.#outline[i + 4]} ${this.#outline[i + 5]}`);
        }
        buffer.push("Z");
        return buffer.join(" ");
    }
    serialize([blX, blY, trX, trY], rotation) {
        const width = trX - blX;
        const height = trY - blY;
        let outline;
        let points;
        switch(rotation){
            case 0:
                outline = this.#rescale(this.#outline, blX, trY, width, -height);
                points = this.#rescale(this.#points, blX, trY, width, -height);
                break;
            case 90:
                outline = this.#rescaleAndSwap(this.#outline, blX, blY, width, height);
                points = this.#rescaleAndSwap(this.#points, blX, blY, width, height);
                break;
            case 180:
                outline = this.#rescale(this.#outline, trX, blY, -width, height);
                points = this.#rescale(this.#points, trX, blY, -width, height);
                break;
            case 270:
                outline = this.#rescaleAndSwap(this.#outline, trX, trY, -width, -height);
                points = this.#rescaleAndSwap(this.#points, trX, trY, -width, -height);
                break;
        }
        return {
            outline: Array.from(outline),
            points: [
                Array.from(points)
            ]
        };
    }
    #rescale(src, tx, ty, sx, sy) {
        const dest = new Float64Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i] * sx;
            dest[i + 1] = ty + src[i + 1] * sy;
        }
        return dest;
    }
    #rescaleAndSwap(src, tx, ty, sx, sy) {
        const dest = new Float64Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i + 1] * sx;
            dest[i + 1] = ty + src[i] * sy;
        }
        return dest;
    }
    #computeMinMax(isLTR) {
        const outline = this.#outline;
        let lastX = outline[4];
        let lastY = outline[5];
        let minX = lastX;
        let minY = lastY;
        let maxX = lastX;
        let maxY = lastY;
        let lastPointX = lastX;
        let lastPointY = lastY;
        const ltrCallback = isLTR ? Math.max : Math.min;
        for(let i = 6, ii = outline.length; i < ii; i += 6){
            if (isNaN(outline[i])) {
                minX = Math.min(minX, outline[i + 4]);
                minY = Math.min(minY, outline[i + 5]);
                maxX = Math.max(maxX, outline[i + 4]);
                maxY = Math.max(maxY, outline[i + 5]);
                if (lastPointY < outline[i + 5]) {
                    lastPointX = outline[i + 4];
                    lastPointY = outline[i + 5];
                } else if (lastPointY === outline[i + 5]) lastPointX = ltrCallback(lastPointX, outline[i + 4]);
            } else {
                const bbox = $cca4aceb320d03d3$var$Util.bezierBoundingBox(lastX, lastY, ...outline.slice(i, i + 6));
                minX = Math.min(minX, bbox[0]);
                minY = Math.min(minY, bbox[1]);
                maxX = Math.max(maxX, bbox[2]);
                maxY = Math.max(maxY, bbox[3]);
                if (lastPointY < bbox[3]) {
                    lastPointX = bbox[2];
                    lastPointY = bbox[3];
                } else if (lastPointY === bbox[3]) lastPointX = ltrCallback(lastPointX, bbox[2]);
            }
            lastX = outline[i + 4];
            lastY = outline[i + 5];
        }
        const x = minX - this.#innerMargin, y = minY - this.#innerMargin, width = maxX - minX + 2 * this.#innerMargin, height = maxY - minY + 2 * this.#innerMargin;
        this.#bbox = {
            x: x,
            y: y,
            width: width,
            height: height,
            lastPoint: [
                lastPointX,
                lastPointY
            ]
        };
    }
    get box() {
        return this.#bbox;
    }
    getNewOutline(thickness, innerMargin) {
        const { x: x, y: y, width: width, height: height } = this.#bbox;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const sx = width * layerWidth;
        const sy = height * layerHeight;
        const tx = x * layerWidth + layerX;
        const ty = y * layerHeight + layerY;
        const outliner = new $cca4aceb320d03d3$var$FreeOutliner({
            x: this.#points[0] * sx + tx,
            y: this.#points[1] * sy + ty
        }, this.#box, this.#scaleFactor, thickness, this.#isLTR, innerMargin ?? this.#innerMargin);
        for(let i = 2; i < this.#points.length; i += 2)outliner.add({
            x: this.#points[i] * sx + tx,
            y: this.#points[i + 1] * sy + ty
        });
        return outliner.getOutlines();
    }
}
class $cca4aceb320d03d3$var$ColorPicker {
    #boundKeyDown = this.#keyDown.bind(this);
    #boundPointerDown = this.#pointerDown.bind(this);
    #button = null;
    #buttonSwatch = null;
    #defaultColor;
    #dropdown = null;
    #dropdownWasFromKeyboard = false;
    #isMainColorPicker = false;
    #editor = null;
    #eventBus;
    #uiManager = null;
    #type;
    static get _keyboardManager() {
        return $cca4aceb320d03d3$var$shadow(this, "_keyboardManager", new $cca4aceb320d03d3$var$KeyboardManager([
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                $cca4aceb320d03d3$var$ColorPicker.prototype._hideDropdownFromKeyboard
            ],
            [
                [
                    " ",
                    "mac+ "
                ],
                $cca4aceb320d03d3$var$ColorPicker.prototype._colorSelectFromKeyboard
            ],
            [
                [
                    "ArrowDown",
                    "ArrowRight",
                    "mac+ArrowDown",
                    "mac+ArrowRight"
                ],
                $cca4aceb320d03d3$var$ColorPicker.prototype._moveToNext
            ],
            [
                [
                    "ArrowUp",
                    "ArrowLeft",
                    "mac+ArrowUp",
                    "mac+ArrowLeft"
                ],
                $cca4aceb320d03d3$var$ColorPicker.prototype._moveToPrevious
            ],
            [
                [
                    "Home",
                    "mac+Home"
                ],
                $cca4aceb320d03d3$var$ColorPicker.prototype._moveToBeginning
            ],
            [
                [
                    "End",
                    "mac+End"
                ],
                $cca4aceb320d03d3$var$ColorPicker.prototype._moveToEnd
            ]
        ]));
    }
    constructor({ editor: editor = null, uiManager: uiManager = null }){
        if (editor) {
            this.#isMainColorPicker = false;
            this.#type = $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_COLOR;
            this.#editor = editor;
        } else {
            this.#isMainColorPicker = true;
            this.#type = $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR;
        }
        this.#uiManager = editor?._uiManager || uiManager;
        this.#eventBus = this.#uiManager._eventBus;
        this.#defaultColor = editor?.color || this.#uiManager?.highlightColors.values().next().value || "#FFFF98";
    }
    renderButton() {
        const button = this.#button = document.createElement("button");
        button.className = "colorPicker";
        button.tabIndex = "0";
        button.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-button");
        button.setAttribute("aria-haspopup", true);
        const signal = this.#uiManager._signal;
        button.addEventListener("click", this.#openDropdown.bind(this), {
            signal: signal
        });
        button.addEventListener("keydown", this.#boundKeyDown, {
            signal: signal
        });
        const swatch = this.#buttonSwatch = document.createElement("span");
        swatch.className = "swatch";
        swatch.setAttribute("aria-hidden", true);
        swatch.style.backgroundColor = this.#defaultColor;
        button.append(swatch);
        return button;
    }
    renderMainDropdown() {
        const dropdown = this.#dropdown = this.#getDropdownRoot();
        dropdown.setAttribute("aria-orientation", "horizontal");
        dropdown.setAttribute("aria-labelledby", "highlightColorPickerLabel");
        return dropdown;
    }
    #getDropdownRoot() {
        const div = document.createElement("div");
        const signal = this.#uiManager._signal;
        div.addEventListener("contextmenu", $cca4aceb320d03d3$var$noContextMenu, {
            signal: signal
        });
        div.className = "dropdown";
        div.role = "listbox";
        div.setAttribute("aria-multiselectable", false);
        div.setAttribute("aria-orientation", "vertical");
        div.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-dropdown");
        for (const [name, color] of this.#uiManager.highlightColors){
            const button = document.createElement("button");
            button.tabIndex = "0";
            button.role = "option";
            button.setAttribute("data-color", color);
            button.title = name;
            button.setAttribute("data-l10n-id", `pdfjs-editor-colorpicker-${name}`);
            const swatch = document.createElement("span");
            button.append(swatch);
            swatch.className = "swatch";
            swatch.style.backgroundColor = color;
            button.setAttribute("aria-selected", color === this.#defaultColor);
            button.addEventListener("click", this.#colorSelect.bind(this, color), {
                signal: signal
            });
            div.append(button);
        }
        div.addEventListener("keydown", this.#boundKeyDown, {
            signal: signal
        });
        return div;
    }
    #colorSelect(color, event) {
        event.stopPropagation();
        this.#eventBus.dispatch("switchannotationeditorparams", {
            source: this,
            type: this.#type,
            value: color
        });
    }
    _colorSelectFromKeyboard(event) {
        if (event.target === this.#button) {
            this.#openDropdown(event);
            return;
        }
        const color = event.target.getAttribute("data-color");
        if (!color) return;
        this.#colorSelect(color, event);
    }
    _moveToNext(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        if (event.target === this.#button) {
            this.#dropdown.firstChild?.focus();
            return;
        }
        event.target.nextSibling?.focus();
    }
    _moveToPrevious(event) {
        if (event.target === this.#dropdown?.firstChild || event.target === this.#button) {
            if (this.#isDropdownVisible) this._hideDropdownFromKeyboard();
            return;
        }
        if (!this.#isDropdownVisible) this.#openDropdown(event);
        event.target.previousSibling?.focus();
    }
    _moveToBeginning(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        this.#dropdown.firstChild?.focus();
    }
    _moveToEnd(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        this.#dropdown.lastChild?.focus();
    }
    #keyDown(event) {
        $cca4aceb320d03d3$var$ColorPicker._keyboardManager.exec(this, event);
    }
    #openDropdown(event) {
        if (this.#isDropdownVisible) {
            this.hideDropdown();
            return;
        }
        this.#dropdownWasFromKeyboard = event.detail === 0;
        window.addEventListener("pointerdown", this.#boundPointerDown, {
            signal: this.#uiManager._signal
        });
        if (this.#dropdown) {
            this.#dropdown.classList.remove("hidden");
            return;
        }
        const root = this.#dropdown = this.#getDropdownRoot();
        this.#button.append(root);
    }
    #pointerDown(event) {
        if (this.#dropdown?.contains(event.target)) return;
        this.hideDropdown();
    }
    hideDropdown() {
        this.#dropdown?.classList.add("hidden");
        window.removeEventListener("pointerdown", this.#boundPointerDown);
    }
    get #isDropdownVisible() {
        return this.#dropdown && !this.#dropdown.classList.contains("hidden");
    }
    _hideDropdownFromKeyboard() {
        if (this.#isMainColorPicker) return;
        if (!this.#isDropdownVisible) {
            this.#editor?.unselect();
            return;
        }
        this.hideDropdown();
        this.#button.focus({
            preventScroll: true,
            focusVisible: this.#dropdownWasFromKeyboard
        });
    }
    updateColor(color) {
        if (this.#buttonSwatch) this.#buttonSwatch.style.backgroundColor = color;
        if (!this.#dropdown) return;
        const i = this.#uiManager.highlightColors.values();
        for (const child of this.#dropdown.children)child.setAttribute("aria-selected", i.next().value === color);
    }
    destroy() {
        this.#button?.remove();
        this.#button = null;
        this.#buttonSwatch = null;
        this.#dropdown?.remove();
        this.#dropdown = null;
    }
}
class $cca4aceb320d03d3$var$HighlightEditor extends $cca4aceb320d03d3$var$AnnotationEditor {
    #anchorNode = null;
    #anchorOffset = 0;
    #boxes;
    #clipPathId = null;
    #colorPicker = null;
    #focusOutlines = null;
    #focusNode = null;
    #focusOffset = 0;
    #highlightDiv = null;
    #highlightOutlines = null;
    #id = null;
    #isFreeHighlight = false;
    #boundKeydown = this.#keydown.bind(this);
    #lastPoint = null;
    #opacity;
    #outlineId = null;
    #text = "";
    #thickness;
    #methodOfCreation = "";
    static _defaultColor = null;
    static _defaultOpacity = 1;
    static _defaultThickness = 12;
    static _l10nPromise;
    static _type = "highlight";
    static _editorType = $cca4aceb320d03d3$var$AnnotationEditorType.HIGHLIGHT;
    static _freeHighlightId = -1;
    static _freeHighlight = null;
    static _freeHighlightClipId = "";
    static get _keyboardManager() {
        const proto = $cca4aceb320d03d3$var$HighlightEditor.prototype;
        return $cca4aceb320d03d3$var$shadow(this, "_keyboardManager", new $cca4aceb320d03d3$var$KeyboardManager([
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto._moveCaret,
                {
                    args: [
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto._moveCaret,
                {
                    args: [
                        1
                    ]
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto._moveCaret,
                {
                    args: [
                        2
                    ]
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto._moveCaret,
                {
                    args: [
                        3
                    ]
                }
            ]
        ]));
    }
    constructor(params){
        super({
            ...params,
            name: "highlightEditor"
        });
        this.color = params.color || $cca4aceb320d03d3$var$HighlightEditor._defaultColor;
        this.#thickness = params.thickness || $cca4aceb320d03d3$var$HighlightEditor._defaultThickness;
        this.#opacity = params.opacity || $cca4aceb320d03d3$var$HighlightEditor._defaultOpacity;
        this.#boxes = params.boxes || null;
        this.#methodOfCreation = params.methodOfCreation || "";
        this.#text = params.text || "";
        this._isDraggable = false;
        if (params.highlightId > -1) {
            this.#isFreeHighlight = true;
            this.#createFreeOutlines(params);
            this.#addToDrawLayer();
        } else {
            this.#anchorNode = params.anchorNode;
            this.#anchorOffset = params.anchorOffset;
            this.#focusNode = params.focusNode;
            this.#focusOffset = params.focusOffset;
            this.#createOutlines();
            this.#addToDrawLayer();
            this.rotate(this.rotation);
        }
    }
    get telemetryInitialData() {
        return {
            action: "added",
            type: this.#isFreeHighlight ? "free_highlight" : "highlight",
            color: this._uiManager.highlightColorNames.get(this.color),
            thickness: this.#thickness,
            methodOfCreation: this.#methodOfCreation
        };
    }
    get telemetryFinalData() {
        return {
            type: "highlight",
            color: this._uiManager.highlightColorNames.get(this.color)
        };
    }
    static computeTelemetryFinalData(data) {
        return {
            numberOfColors: data.get("color").size
        };
    }
    #createOutlines() {
        const outliner = new $cca4aceb320d03d3$var$Outliner(this.#boxes, 0.001);
        this.#highlightOutlines = outliner.getOutlines();
        ({ x: this.x, y: this.y, width: this.width, height: this.height } = this.#highlightOutlines.box);
        const outlinerForOutline = new $cca4aceb320d03d3$var$Outliner(this.#boxes, 0.0025, 0.001, this._uiManager.direction === "ltr");
        this.#focusOutlines = outlinerForOutline.getOutlines();
        const { lastPoint: lastPoint } = this.#focusOutlines.box;
        this.#lastPoint = [
            (lastPoint[0] - this.x) / this.width,
            (lastPoint[1] - this.y) / this.height
        ];
    }
    #createFreeOutlines({ highlightOutlines: highlightOutlines, highlightId: highlightId, clipPathId: clipPathId }) {
        this.#highlightOutlines = highlightOutlines;
        const extraThickness = 1.5;
        this.#focusOutlines = highlightOutlines.getNewOutline(this.#thickness / 2 + extraThickness, 0.0025);
        if (highlightId >= 0) {
            this.#id = highlightId;
            this.#clipPathId = clipPathId;
            this.parent.drawLayer.finalizeLine(highlightId, highlightOutlines);
            this.#outlineId = this.parent.drawLayer.highlightOutline(this.#focusOutlines);
        } else if (this.parent) {
            const angle = this.parent.viewport.rotation;
            this.parent.drawLayer.updateLine(this.#id, highlightOutlines);
            this.parent.drawLayer.updateBox(this.#id, $cca4aceb320d03d3$var$HighlightEditor.#rotateBbox(this.#highlightOutlines.box, (angle - this.rotation + 360) % 360));
            this.parent.drawLayer.updateLine(this.#outlineId, this.#focusOutlines);
            this.parent.drawLayer.updateBox(this.#outlineId, $cca4aceb320d03d3$var$HighlightEditor.#rotateBbox(this.#focusOutlines.box, angle));
        }
        const { x: x, y: y, width: width, height: height } = highlightOutlines.box;
        switch(this.rotation){
            case 0:
                this.x = x;
                this.y = y;
                this.width = width;
                this.height = height;
                break;
            case 90:
                {
                    const [pageWidth, pageHeight] = this.parentDimensions;
                    this.x = y;
                    this.y = 1 - x;
                    this.width = width * pageHeight / pageWidth;
                    this.height = height * pageWidth / pageHeight;
                    break;
                }
            case 180:
                this.x = 1 - x;
                this.y = 1 - y;
                this.width = width;
                this.height = height;
                break;
            case 270:
                {
                    const [pageWidth, pageHeight] = this.parentDimensions;
                    this.x = 1 - y;
                    this.y = x;
                    this.width = width * pageHeight / pageWidth;
                    this.height = height * pageWidth / pageHeight;
                    break;
                }
        }
        const { lastPoint: lastPoint } = this.#focusOutlines.box;
        this.#lastPoint = [
            (lastPoint[0] - x) / width,
            (lastPoint[1] - y) / height
        ];
    }
    static initialize(l10n, uiManager) {
        $cca4aceb320d03d3$var$AnnotationEditor.initialize(l10n, uiManager);
        $cca4aceb320d03d3$var$HighlightEditor._defaultColor ||= uiManager.highlightColors?.values().next().value || "#fff066";
    }
    static updateDefaultParams(type, value) {
        switch(type){
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR:
                $cca4aceb320d03d3$var$HighlightEditor._defaultColor = value;
                break;
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_THICKNESS:
                $cca4aceb320d03d3$var$HighlightEditor._defaultThickness = value;
                break;
        }
    }
    translateInPage(x, y) {}
    get toolbarPosition() {
        return this.#lastPoint;
    }
    updateParams(type, value) {
        switch(type){
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_COLOR:
                this.#updateColor(value);
                break;
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_THICKNESS:
                this.#updateThickness(value);
                break;
        }
    }
    static get defaultPropertiesToUpdate() {
        return [
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR,
                $cca4aceb320d03d3$var$HighlightEditor._defaultColor
            ],
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_THICKNESS,
                $cca4aceb320d03d3$var$HighlightEditor._defaultThickness
            ]
        ];
    }
    get propertiesToUpdate() {
        return [
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_COLOR,
                this.color || $cca4aceb320d03d3$var$HighlightEditor._defaultColor
            ],
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_THICKNESS,
                this.#thickness || $cca4aceb320d03d3$var$HighlightEditor._defaultThickness
            ],
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_FREE,
                this.#isFreeHighlight
            ]
        ];
    }
    #updateColor(color) {
        const setColor = (col)=>{
            this.color = col;
            this.parent?.drawLayer.changeColor(this.#id, col);
            this.#colorPicker?.updateColor(col);
        };
        const savedColor = this.color;
        this.addCommands({
            cmd: setColor.bind(this, color),
            undo: setColor.bind(this, savedColor),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $cca4aceb320d03d3$var$AnnotationEditorParamsType.HIGHLIGHT_COLOR,
            overwriteIfSameType: true,
            keepUndo: true
        });
        this._reportTelemetry({
            action: "color_changed",
            color: this._uiManager.highlightColorNames.get(color)
        }, true);
    }
    #updateThickness(thickness) {
        const savedThickness = this.#thickness;
        const setThickness = (th)=>{
            this.#thickness = th;
            this.#changeThickness(th);
        };
        this.addCommands({
            cmd: setThickness.bind(this, thickness),
            undo: setThickness.bind(this, savedThickness),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_THICKNESS,
            overwriteIfSameType: true,
            keepUndo: true
        });
        this._reportTelemetry({
            action: "thickness_changed",
            thickness: thickness
        }, true);
    }
    async addEditToolbar() {
        const toolbar = await super.addEditToolbar();
        if (!toolbar) return null;
        if (this._uiManager.highlightColors) {
            this.#colorPicker = new $cca4aceb320d03d3$var$ColorPicker({
                editor: this
            });
            toolbar.addColorPicker(this.#colorPicker);
        }
        return toolbar;
    }
    disableEditing() {
        super.disableEditing();
        this.div.classList.toggle("disabled", true);
    }
    enableEditing() {
        super.enableEditing();
        this.div.classList.toggle("disabled", false);
    }
    fixAndSetPosition() {
        return super.fixAndSetPosition(this.#getRotation());
    }
    getBaseTranslation() {
        return [
            0,
            0
        ];
    }
    getRect(tx, ty) {
        return super.getRect(tx, ty, this.#getRotation());
    }
    onceAdded() {
        this.parent.addUndoableEditor(this);
        this.div.focus();
    }
    remove() {
        this.#cleanDrawLayer();
        this._reportTelemetry({
            action: "deleted"
        });
        super.remove();
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        this.#addToDrawLayer();
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    setParent(parent) {
        let mustBeSelected = false;
        if (this.parent && !parent) this.#cleanDrawLayer();
        else if (parent) {
            this.#addToDrawLayer(parent);
            mustBeSelected = !this.parent && this.div?.classList.contains("selectedEditor");
        }
        super.setParent(parent);
        this.show(this._isVisible);
        if (mustBeSelected) this.select();
    }
    #changeThickness(thickness) {
        if (!this.#isFreeHighlight) return;
        this.#createFreeOutlines({
            highlightOutlines: this.#highlightOutlines.getNewOutline(thickness / 2)
        });
        this.fixAndSetPosition();
        const [parentWidth, parentHeight] = this.parentDimensions;
        this.setDims(this.width * parentWidth, this.height * parentHeight);
    }
    #cleanDrawLayer() {
        if (this.#id === null || !this.parent) return;
        this.parent.drawLayer.remove(this.#id);
        this.#id = null;
        this.parent.drawLayer.remove(this.#outlineId);
        this.#outlineId = null;
    }
    #addToDrawLayer(parent = this.parent) {
        if (this.#id !== null) return;
        ({ id: this.#id, clipPathId: this.#clipPathId } = parent.drawLayer.highlight(this.#highlightOutlines, this.color, this.#opacity));
        this.#outlineId = parent.drawLayer.highlightOutline(this.#focusOutlines);
        if (this.#highlightDiv) this.#highlightDiv.style.clipPath = this.#clipPathId;
    }
    static #rotateBbox({ x: x, y: y, width: width, height: height }, angle) {
        switch(angle){
            case 90:
                return {
                    x: 1 - y - height,
                    y: x,
                    width: height,
                    height: width
                };
            case 180:
                return {
                    x: 1 - x - width,
                    y: 1 - y - height,
                    width: width,
                    height: height
                };
            case 270:
                return {
                    x: y,
                    y: 1 - x - width,
                    width: height,
                    height: width
                };
        }
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    }
    rotate(angle) {
        const { drawLayer: drawLayer } = this.parent;
        let box;
        if (this.#isFreeHighlight) {
            angle = (angle - this.rotation + 360) % 360;
            box = $cca4aceb320d03d3$var$HighlightEditor.#rotateBbox(this.#highlightOutlines.box, angle);
        } else box = $cca4aceb320d03d3$var$HighlightEditor.#rotateBbox(this, angle);
        drawLayer.rotate(this.#id, angle);
        drawLayer.rotate(this.#outlineId, angle);
        drawLayer.updateBox(this.#id, box);
        drawLayer.updateBox(this.#outlineId, $cca4aceb320d03d3$var$HighlightEditor.#rotateBbox(this.#focusOutlines.box, angle));
    }
    render() {
        if (this.div) return this.div;
        const div = super.render();
        if (this.#text) {
            div.setAttribute("aria-label", this.#text);
            div.setAttribute("role", "mark");
        }
        if (this.#isFreeHighlight) div.classList.add("free");
        else this.div.addEventListener("keydown", this.#boundKeydown, {
            signal: this._uiManager._signal
        });
        const highlightDiv = this.#highlightDiv = document.createElement("div");
        div.append(highlightDiv);
        highlightDiv.setAttribute("aria-hidden", "true");
        highlightDiv.className = "internal";
        highlightDiv.style.clipPath = this.#clipPathId;
        const [parentWidth, parentHeight] = this.parentDimensions;
        this.setDims(this.width * parentWidth, this.height * parentHeight);
        $cca4aceb320d03d3$var$bindEvents(this, this.#highlightDiv, [
            "pointerover",
            "pointerleave"
        ]);
        this.enableEditing();
        return div;
    }
    pointerover() {
        this.parent.drawLayer.addClass(this.#outlineId, "hovered");
    }
    pointerleave() {
        this.parent.drawLayer.removeClass(this.#outlineId, "hovered");
    }
    #keydown(event) {
        $cca4aceb320d03d3$var$HighlightEditor._keyboardManager.exec(this, event);
    }
    _moveCaret(direction) {
        this.parent.unselect(this);
        switch(direction){
            case 0:
            case 2:
                this.#setCaret(true);
                break;
            case 1:
            case 3:
                this.#setCaret(false);
                break;
        }
    }
    #setCaret(start) {
        if (!this.#anchorNode) return;
        const selection = window.getSelection();
        if (start) selection.setPosition(this.#anchorNode, this.#anchorOffset);
        else selection.setPosition(this.#focusNode, this.#focusOffset);
    }
    select() {
        super.select();
        if (!this.#outlineId) return;
        this.parent?.drawLayer.removeClass(this.#outlineId, "hovered");
        this.parent?.drawLayer.addClass(this.#outlineId, "selected");
    }
    unselect() {
        super.unselect();
        if (!this.#outlineId) return;
        this.parent?.drawLayer.removeClass(this.#outlineId, "selected");
        if (!this.#isFreeHighlight) this.#setCaret(false);
    }
    get _mustFixPosition() {
        return !this.#isFreeHighlight;
    }
    show(visible = this._isVisible) {
        super.show(visible);
        if (this.parent) {
            this.parent.drawLayer.show(this.#id, visible);
            this.parent.drawLayer.show(this.#outlineId, visible);
        }
    }
    #getRotation() {
        return this.#isFreeHighlight ? this.rotation : 0;
    }
    #serializeBoxes() {
        if (this.#isFreeHighlight) return null;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const boxes = this.#boxes;
        const quadPoints = new Float32Array(boxes.length * 8);
        let i = 0;
        for (const { x: x, y: y, width: width, height: height } of boxes){
            const sx = x * pageWidth;
            const sy = (1 - y - height) * pageHeight;
            quadPoints[i] = quadPoints[i + 4] = sx;
            quadPoints[i + 1] = quadPoints[i + 3] = sy;
            quadPoints[i + 2] = quadPoints[i + 6] = sx + width * pageWidth;
            quadPoints[i + 5] = quadPoints[i + 7] = sy + height * pageHeight;
            i += 8;
        }
        return quadPoints;
    }
    #serializeOutlines(rect) {
        return this.#highlightOutlines.serialize(rect, this.#getRotation());
    }
    static startHighlighting(parent, isLTR, { target: textLayer, x: x, y: y }) {
        const { x: layerX, y: layerY, width: parentWidth, height: parentHeight } = textLayer.getBoundingClientRect();
        const pointerMove = (e)=>{
            this.#highlightMove(parent, e);
        };
        const signal = parent._signal;
        const pointerDownOptions = {
            capture: true,
            passive: false,
            signal: signal
        };
        const pointerDown = (e)=>{
            e.preventDefault();
            e.stopPropagation();
        };
        const pointerUpCallback = (e)=>{
            textLayer.removeEventListener("pointermove", pointerMove);
            window.removeEventListener("blur", pointerUpCallback);
            window.removeEventListener("pointerup", pointerUpCallback);
            window.removeEventListener("pointerdown", pointerDown, pointerDownOptions);
            window.removeEventListener("contextmenu", $cca4aceb320d03d3$var$noContextMenu);
            this.#endHighlight(parent, e);
        };
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("pointerdown", pointerDown, pointerDownOptions);
        window.addEventListener("contextmenu", $cca4aceb320d03d3$var$noContextMenu, {
            signal: signal
        });
        textLayer.addEventListener("pointermove", pointerMove, {
            signal: signal
        });
        this._freeHighlight = new $cca4aceb320d03d3$var$FreeOutliner({
            x: x,
            y: y
        }, [
            layerX,
            layerY,
            parentWidth,
            parentHeight
        ], parent.scale, this._defaultThickness / 2, isLTR, 0.001);
        ({ id: this._freeHighlightId, clipPathId: this._freeHighlightClipId } = parent.drawLayer.highlight(this._freeHighlight, this._defaultColor, this._defaultOpacity, true));
    }
    static #highlightMove(parent, event) {
        if (this._freeHighlight.add(event)) parent.drawLayer.updatePath(this._freeHighlightId, this._freeHighlight);
    }
    static #endHighlight(parent, event) {
        if (!this._freeHighlight.isEmpty()) parent.createAndAddNewEditor(event, false, {
            highlightId: this._freeHighlightId,
            highlightOutlines: this._freeHighlight.getOutlines(),
            clipPathId: this._freeHighlightClipId,
            methodOfCreation: "main_toolbar"
        });
        else parent.drawLayer.removeFreeHighlight(this._freeHighlightId);
        this._freeHighlightId = -1;
        this._freeHighlight = null;
        this._freeHighlightClipId = "";
    }
    static deserialize(data, parent, uiManager) {
        const editor = super.deserialize(data, parent, uiManager);
        const { rect: [blX, blY, trX, trY], color: color, quadPoints: quadPoints } = data;
        editor.color = $cca4aceb320d03d3$var$Util.makeHexColor(...color);
        editor.#opacity = data.opacity;
        const [pageWidth, pageHeight] = editor.pageDimensions;
        editor.width = (trX - blX) / pageWidth;
        editor.height = (trY - blY) / pageHeight;
        const boxes = editor.#boxes = [];
        for(let i = 0; i < quadPoints.length; i += 8)boxes.push({
            x: (quadPoints[4] - trX) / pageWidth,
            y: (trY - (1 - quadPoints[i + 5])) / pageHeight,
            width: (quadPoints[i + 2] - quadPoints[i]) / pageWidth,
            height: (quadPoints[i + 5] - quadPoints[i + 1]) / pageHeight
        });
        editor.#createOutlines();
        return editor;
    }
    serialize(isForCopying = false) {
        if (this.isEmpty() || isForCopying) return null;
        const rect = this.getRect(0, 0);
        const color = $cca4aceb320d03d3$var$AnnotationEditor._colorManager.convert(this.color);
        return {
            annotationType: $cca4aceb320d03d3$var$AnnotationEditorType.HIGHLIGHT,
            color: color,
            opacity: this.#opacity,
            thickness: this.#thickness,
            quadPoints: this.#serializeBoxes(),
            outlines: this.#serializeOutlines(rect),
            pageIndex: this.pageIndex,
            rect: rect,
            rotation: this.#getRotation(),
            structTreeParentId: this._structTreeParentId
        };
    }
    static canCreateNewEmptyEditor() {
        return false;
    }
}
class $cca4aceb320d03d3$var$InkEditor extends $cca4aceb320d03d3$var$AnnotationEditor {
    #baseHeight = 0;
    #baseWidth = 0;
    #boundCanvasPointermove = this.canvasPointermove.bind(this);
    #boundCanvasPointerleave = this.canvasPointerleave.bind(this);
    #boundCanvasPointerup = this.canvasPointerup.bind(this);
    #boundCanvasPointerdown = this.canvasPointerdown.bind(this);
    #canvasContextMenuTimeoutId = null;
    #currentPath2D = new Path2D();
    #disableEditing = false;
    #hasSomethingToDraw = false;
    #isCanvasInitialized = false;
    #observer = null;
    #realWidth = 0;
    #realHeight = 0;
    #requestFrameCallback = null;
    static _defaultColor = null;
    static _defaultOpacity = 1;
    static _defaultThickness = 1;
    static _type = "ink";
    static _editorType = $cca4aceb320d03d3$var$AnnotationEditorType.INK;
    constructor(params){
        super({
            ...params,
            name: "inkEditor"
        });
        this.color = params.color || null;
        this.thickness = params.thickness || null;
        this.opacity = params.opacity || null;
        this.paths = [];
        this.bezierPath2D = [];
        this.allRawPaths = [];
        this.currentPath = [];
        this.scaleFactor = 1;
        this.translationX = this.translationY = 0;
        this.x = 0;
        this.y = 0;
        this._willKeepAspectRatio = true;
    }
    static initialize(l10n, uiManager) {
        $cca4aceb320d03d3$var$AnnotationEditor.initialize(l10n, uiManager);
    }
    static updateDefaultParams(type, value) {
        switch(type){
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_THICKNESS:
                $cca4aceb320d03d3$var$InkEditor._defaultThickness = value;
                break;
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_COLOR:
                $cca4aceb320d03d3$var$InkEditor._defaultColor = value;
                break;
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_OPACITY:
                $cca4aceb320d03d3$var$InkEditor._defaultOpacity = value / 100;
                break;
        }
    }
    updateParams(type, value) {
        switch(type){
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_THICKNESS:
                this.#updateThickness(value);
                break;
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_COLOR:
                this.#updateColor(value);
                break;
            case $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_OPACITY:
                this.#updateOpacity(value);
                break;
        }
    }
    static get defaultPropertiesToUpdate() {
        return [
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_THICKNESS,
                $cca4aceb320d03d3$var$InkEditor._defaultThickness
            ],
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_COLOR,
                $cca4aceb320d03d3$var$InkEditor._defaultColor || $cca4aceb320d03d3$var$AnnotationEditor._defaultLineColor
            ],
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_OPACITY,
                Math.round($cca4aceb320d03d3$var$InkEditor._defaultOpacity * 100)
            ]
        ];
    }
    get propertiesToUpdate() {
        return [
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_THICKNESS,
                this.thickness || $cca4aceb320d03d3$var$InkEditor._defaultThickness
            ],
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_COLOR,
                this.color || $cca4aceb320d03d3$var$InkEditor._defaultColor || $cca4aceb320d03d3$var$AnnotationEditor._defaultLineColor
            ],
            [
                $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_OPACITY,
                Math.round(100 * (this.opacity ?? $cca4aceb320d03d3$var$InkEditor._defaultOpacity))
            ]
        ];
    }
    #updateThickness(thickness) {
        const setThickness = (th)=>{
            this.thickness = th;
            this.#fitToContent();
        };
        const savedThickness = this.thickness;
        this.addCommands({
            cmd: setThickness.bind(this, thickness),
            undo: setThickness.bind(this, savedThickness),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_THICKNESS,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    #updateColor(color) {
        const setColor = (col)=>{
            this.color = col;
            this.#redraw();
        };
        const savedColor = this.color;
        this.addCommands({
            cmd: setColor.bind(this, color),
            undo: setColor.bind(this, savedColor),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_COLOR,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    #updateOpacity(opacity) {
        const setOpacity = (op)=>{
            this.opacity = op;
            this.#redraw();
        };
        opacity /= 100;
        const savedOpacity = this.opacity;
        this.addCommands({
            cmd: setOpacity.bind(this, opacity),
            undo: setOpacity.bind(this, savedOpacity),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $cca4aceb320d03d3$var$AnnotationEditorParamsType.INK_OPACITY,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        if (!this.canvas) {
            this.#createCanvas();
            this.#createObserver();
        }
        if (!this.isAttachedToDOM) {
            this.parent.add(this);
            this.#setCanvasDims();
        }
        this.#fitToContent();
    }
    remove() {
        if (this.canvas === null) return;
        if (!this.isEmpty()) this.commit();
        this.canvas.width = this.canvas.height = 0;
        this.canvas.remove();
        this.canvas = null;
        if (this.#canvasContextMenuTimeoutId) {
            clearTimeout(this.#canvasContextMenuTimeoutId);
            this.#canvasContextMenuTimeoutId = null;
        }
        this.#observer?.disconnect();
        this.#observer = null;
        super.remove();
    }
    setParent(parent) {
        if (!this.parent && parent) this._uiManager.removeShouldRescale(this);
        else if (this.parent && parent === null) this._uiManager.addShouldRescale(this);
        super.setParent(parent);
    }
    onScaleChanging() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const width = this.width * parentWidth;
        const height = this.height * parentHeight;
        this.setDimensions(width, height);
    }
    enableEditMode() {
        if (this.#disableEditing || this.canvas === null) return;
        super.enableEditMode();
        this._isDraggable = false;
        this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown, {
            signal: this._uiManager._signal
        });
    }
    disableEditMode() {
        if (!this.isInEditMode() || this.canvas === null) return;
        super.disableEditMode();
        this._isDraggable = !this.isEmpty();
        this.div.classList.remove("editing");
        this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
    }
    onceAdded() {
        this._isDraggable = !this.isEmpty();
    }
    isEmpty() {
        return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
    }
    #getInitialBBox() {
        const { parentRotation: parentRotation, parentDimensions: [width, height] } = this;
        switch(parentRotation){
            case 90:
                return [
                    0,
                    height,
                    height,
                    width
                ];
            case 180:
                return [
                    width,
                    height,
                    width,
                    height
                ];
            case 270:
                return [
                    width,
                    0,
                    height,
                    width
                ];
            default:
                return [
                    0,
                    0,
                    width,
                    height
                ];
        }
    }
    #setStroke() {
        const { ctx: ctx, color: color, opacity: opacity, thickness: thickness, parentScale: parentScale, scaleFactor: scaleFactor } = this;
        ctx.lineWidth = thickness * parentScale / scaleFactor;
        ctx.lineCap = "round";
        ctx.lineJoin = "round";
        ctx.miterLimit = 10;
        ctx.strokeStyle = `${color}${$cca4aceb320d03d3$var$opacityToHex(opacity)}`;
    }
    #startDrawing(x, y) {
        const signal = this._uiManager._signal;
        this.canvas.addEventListener("contextmenu", $cca4aceb320d03d3$var$noContextMenu, {
            signal: signal
        });
        this.canvas.addEventListener("pointerleave", this.#boundCanvasPointerleave, {
            signal: signal
        });
        this.canvas.addEventListener("pointermove", this.#boundCanvasPointermove, {
            signal: signal
        });
        this.canvas.addEventListener("pointerup", this.#boundCanvasPointerup, {
            signal: signal
        });
        this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
        this.isEditing = true;
        if (!this.#isCanvasInitialized) {
            this.#isCanvasInitialized = true;
            this.#setCanvasDims();
            this.thickness ||= $cca4aceb320d03d3$var$InkEditor._defaultThickness;
            this.color ||= $cca4aceb320d03d3$var$InkEditor._defaultColor || $cca4aceb320d03d3$var$AnnotationEditor._defaultLineColor;
            this.opacity ??= $cca4aceb320d03d3$var$InkEditor._defaultOpacity;
        }
        this.currentPath.push([
            x,
            y
        ]);
        this.#hasSomethingToDraw = false;
        this.#setStroke();
        this.#requestFrameCallback = ()=>{
            this.#drawPoints();
            if (this.#requestFrameCallback) window.requestAnimationFrame(this.#requestFrameCallback);
        };
        window.requestAnimationFrame(this.#requestFrameCallback);
    }
    #draw(x, y) {
        const [lastX, lastY] = this.currentPath.at(-1);
        if (this.currentPath.length > 1 && x === lastX && y === lastY) return;
        const currentPath = this.currentPath;
        let path2D = this.#currentPath2D;
        currentPath.push([
            x,
            y
        ]);
        this.#hasSomethingToDraw = true;
        if (currentPath.length <= 2) {
            path2D.moveTo(...currentPath[0]);
            path2D.lineTo(x, y);
            return;
        }
        if (currentPath.length === 3) {
            this.#currentPath2D = path2D = new Path2D();
            path2D.moveTo(...currentPath[0]);
        }
        this.#makeBezierCurve(path2D, ...currentPath.at(-3), ...currentPath.at(-2), x, y);
    }
    #endPath() {
        if (this.currentPath.length === 0) return;
        const lastPoint = this.currentPath.at(-1);
        this.#currentPath2D.lineTo(...lastPoint);
    }
    #stopDrawing(x, y) {
        this.#requestFrameCallback = null;
        x = Math.min(Math.max(x, 0), this.canvas.width);
        y = Math.min(Math.max(y, 0), this.canvas.height);
        this.#draw(x, y);
        this.#endPath();
        let bezier;
        if (this.currentPath.length !== 1) bezier = this.#generateBezierPoints();
        else {
            const xy = [
                x,
                y
            ];
            bezier = [
                [
                    xy,
                    xy.slice(),
                    xy.slice(),
                    xy
                ]
            ];
        }
        const path2D = this.#currentPath2D;
        const currentPath = this.currentPath;
        this.currentPath = [];
        this.#currentPath2D = new Path2D();
        const cmd = ()=>{
            this.allRawPaths.push(currentPath);
            this.paths.push(bezier);
            this.bezierPath2D.push(path2D);
            this._uiManager.rebuild(this);
        };
        const undo = ()=>{
            this.allRawPaths.pop();
            this.paths.pop();
            this.bezierPath2D.pop();
            if (this.paths.length === 0) this.remove();
            else {
                if (!this.canvas) {
                    this.#createCanvas();
                    this.#createObserver();
                }
                this.#fitToContent();
            }
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: true
        });
    }
    #drawPoints() {
        if (!this.#hasSomethingToDraw) return;
        this.#hasSomethingToDraw = false;
        const thickness = Math.ceil(this.thickness * this.parentScale);
        const lastPoints = this.currentPath.slice(-3);
        const x = lastPoints.map((xy)=>xy[0]);
        const y = lastPoints.map((xy)=>xy[1]);
        const xMin = Math.min(...x) - thickness;
        const xMax = Math.max(...x) + thickness;
        const yMin = Math.min(...y) - thickness;
        const yMax = Math.max(...y) + thickness;
        const { ctx: ctx } = this;
        ctx.save();
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        for (const path of this.bezierPath2D)ctx.stroke(path);
        ctx.stroke(this.#currentPath2D);
        ctx.restore();
    }
    #makeBezierCurve(path2D, x0, y0, x1, y1, x2, y2) {
        const prevX = (x0 + x1) / 2;
        const prevY = (y0 + y1) / 2;
        const x3 = (x1 + x2) / 2;
        const y3 = (y1 + y2) / 2;
        path2D.bezierCurveTo(prevX + 2 * (x1 - prevX) / 3, prevY + 2 * (y1 - prevY) / 3, x3 + 2 * (x1 - x3) / 3, y3 + 2 * (y1 - y3) / 3, x3, y3);
    }
    #generateBezierPoints() {
        const path = this.currentPath;
        if (path.length <= 2) return [
            [
                path[0],
                path[0],
                path.at(-1),
                path.at(-1)
            ]
        ];
        const bezierPoints = [];
        let i;
        let [x0, y0] = path[0];
        for(i = 1; i < path.length - 2; i++){
            const [x1, y1] = path[i];
            const [x2, y2] = path[i + 1];
            const x3 = (x1 + x2) / 2;
            const y3 = (y1 + y2) / 2;
            const control1 = [
                x0 + 2 * (x1 - x0) / 3,
                y0 + 2 * (y1 - y0) / 3
            ];
            const control2 = [
                x3 + 2 * (x1 - x3) / 3,
                y3 + 2 * (y1 - y3) / 3
            ];
            bezierPoints.push([
                [
                    x0,
                    y0
                ],
                control1,
                control2,
                [
                    x3,
                    y3
                ]
            ]);
            [x0, y0] = [
                x3,
                y3
            ];
        }
        const [x1, y1] = path[i];
        const [x2, y2] = path[i + 1];
        const control1 = [
            x0 + 2 * (x1 - x0) / 3,
            y0 + 2 * (y1 - y0) / 3
        ];
        const control2 = [
            x2 + 2 * (x1 - x2) / 3,
            y2 + 2 * (y1 - y2) / 3
        ];
        bezierPoints.push([
            [
                x0,
                y0
            ],
            control1,
            control2,
            [
                x2,
                y2
            ]
        ]);
        return bezierPoints;
    }
    #redraw() {
        if (this.isEmpty()) {
            this.#updateTransform();
            return;
        }
        this.#setStroke();
        const { canvas: canvas, ctx: ctx } = this;
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        this.#updateTransform();
        for (const path of this.bezierPath2D)ctx.stroke(path);
    }
    commit() {
        if (this.#disableEditing) return;
        super.commit();
        this.isEditing = false;
        this.disableEditMode();
        this.setInForeground();
        this.#disableEditing = true;
        this.div.classList.add("disabled");
        this.#fitToContent(true);
        this.select();
        this.parent.addInkEditorIfNeeded(true);
        this.moveInDOM();
        this.div.focus({
            preventScroll: true
        });
    }
    focusin(event) {
        if (!this._focusEventsAllowed) return;
        super.focusin(event);
        this.enableEditMode();
    }
    canvasPointerdown(event) {
        if (event.button !== 0 || !this.isInEditMode() || this.#disableEditing) return;
        this.setInForeground();
        event.preventDefault();
        if (!this.div.contains(document.activeElement)) this.div.focus({
            preventScroll: true
        });
        this.#startDrawing(event.offsetX, event.offsetY);
    }
    canvasPointermove(event) {
        event.preventDefault();
        this.#draw(event.offsetX, event.offsetY);
    }
    canvasPointerup(event) {
        event.preventDefault();
        this.#endDrawing(event);
    }
    canvasPointerleave(event) {
        this.#endDrawing(event);
    }
    #endDrawing(event) {
        this.canvas.removeEventListener("pointerleave", this.#boundCanvasPointerleave);
        this.canvas.removeEventListener("pointermove", this.#boundCanvasPointermove);
        this.canvas.removeEventListener("pointerup", this.#boundCanvasPointerup);
        this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown, {
            signal: this._uiManager._signal
        });
        if (this.#canvasContextMenuTimeoutId) clearTimeout(this.#canvasContextMenuTimeoutId);
        this.#canvasContextMenuTimeoutId = setTimeout(()=>{
            this.#canvasContextMenuTimeoutId = null;
            this.canvas.removeEventListener("contextmenu", $cca4aceb320d03d3$var$noContextMenu);
        }, 10);
        this.#stopDrawing(event.offsetX, event.offsetY);
        this.addToAnnotationStorage();
        this.setInBackground();
    }
    #createCanvas() {
        this.canvas = document.createElement("canvas");
        this.canvas.width = this.canvas.height = 0;
        this.canvas.className = "inkEditorCanvas";
        this.canvas.setAttribute("data-l10n-id", "pdfjs-ink-canvas");
        this.div.append(this.canvas);
        this.ctx = this.canvas.getContext("2d");
    }
    #createObserver() {
        this.#observer = new ResizeObserver((entries)=>{
            const rect = entries[0].contentRect;
            if (rect.width && rect.height) this.setDimensions(rect.width, rect.height);
        });
        this.#observer.observe(this.div);
        this._uiManager._signal.addEventListener("abort", ()=>{
            this.#observer?.disconnect();
            this.#observer = null;
        }, {
            once: true
        });
    }
    get isResizable() {
        return !this.isEmpty() && this.#disableEditing;
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this.width) {
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        this.div.setAttribute("data-l10n-id", "pdfjs-ink");
        const [x, y, w, h] = this.#getInitialBBox();
        this.setAt(x, y, 0, 0);
        this.setDims(w, h);
        this.#createCanvas();
        if (this.width) {
            const [parentWidth, parentHeight] = this.parentDimensions;
            this.setAspectRatio(this.width * parentWidth, this.height * parentHeight);
            this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
            this.#isCanvasInitialized = true;
            this.#setCanvasDims();
            this.setDims(this.width * parentWidth, this.height * parentHeight);
            this.#redraw();
            this.div.classList.add("disabled");
        } else {
            this.div.classList.add("editing");
            this.enableEditMode();
        }
        this.#createObserver();
        return this.div;
    }
    #setCanvasDims() {
        if (!this.#isCanvasInitialized) return;
        const [parentWidth, parentHeight] = this.parentDimensions;
        this.canvas.width = Math.ceil(this.width * parentWidth);
        this.canvas.height = Math.ceil(this.height * parentHeight);
        this.#updateTransform();
    }
    setDimensions(width, height) {
        const roundedWidth = Math.round(width);
        const roundedHeight = Math.round(height);
        if (this.#realWidth === roundedWidth && this.#realHeight === roundedHeight) return;
        this.#realWidth = roundedWidth;
        this.#realHeight = roundedHeight;
        this.canvas.style.visibility = "hidden";
        const [parentWidth, parentHeight] = this.parentDimensions;
        this.width = width / parentWidth;
        this.height = height / parentHeight;
        this.fixAndSetPosition();
        if (this.#disableEditing) this.#setScaleFactor(width, height);
        this.#setCanvasDims();
        this.#redraw();
        this.canvas.style.visibility = "visible";
        this.fixDims();
    }
    #setScaleFactor(width, height) {
        const padding = this.#getPadding();
        const scaleFactorW = (width - padding) / this.#baseWidth;
        const scaleFactorH = (height - padding) / this.#baseHeight;
        this.scaleFactor = Math.min(scaleFactorW, scaleFactorH);
    }
    #updateTransform() {
        const padding = this.#getPadding() / 2;
        this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + padding, this.translationY * this.scaleFactor + padding);
    }
    static #buildPath2D(bezier) {
        const path2D = new Path2D();
        for(let i = 0, ii = bezier.length; i < ii; i++){
            const [first, control1, control2, second] = bezier[i];
            if (i === 0) path2D.moveTo(...first);
            path2D.bezierCurveTo(control1[0], control1[1], control2[0], control2[1], second[0], second[1]);
        }
        return path2D;
    }
    static #toPDFCoordinates(points, rect, rotation) {
        const [blX, blY, trX, trY] = rect;
        switch(rotation){
            case 0:
                for(let i = 0, ii = points.length; i < ii; i += 2){
                    points[i] += blX;
                    points[i + 1] = trY - points[i + 1];
                }
                break;
            case 90:
                for(let i = 0, ii = points.length; i < ii; i += 2){
                    const x = points[i];
                    points[i] = points[i + 1] + blX;
                    points[i + 1] = x + blY;
                }
                break;
            case 180:
                for(let i = 0, ii = points.length; i < ii; i += 2){
                    points[i] = trX - points[i];
                    points[i + 1] += blY;
                }
                break;
            case 270:
                for(let i = 0, ii = points.length; i < ii; i += 2){
                    const x = points[i];
                    points[i] = trX - points[i + 1];
                    points[i + 1] = trY - x;
                }
                break;
            default:
                throw new Error("Invalid rotation");
        }
        return points;
    }
    static #fromPDFCoordinates(points, rect, rotation) {
        const [blX, blY, trX, trY] = rect;
        switch(rotation){
            case 0:
                for(let i = 0, ii = points.length; i < ii; i += 2){
                    points[i] -= blX;
                    points[i + 1] = trY - points[i + 1];
                }
                break;
            case 90:
                for(let i = 0, ii = points.length; i < ii; i += 2){
                    const x = points[i];
                    points[i] = points[i + 1] - blY;
                    points[i + 1] = x - blX;
                }
                break;
            case 180:
                for(let i = 0, ii = points.length; i < ii; i += 2){
                    points[i] = trX - points[i];
                    points[i + 1] -= blY;
                }
                break;
            case 270:
                for(let i = 0, ii = points.length; i < ii; i += 2){
                    const x = points[i];
                    points[i] = trY - points[i + 1];
                    points[i + 1] = trX - x;
                }
                break;
            default:
                throw new Error("Invalid rotation");
        }
        return points;
    }
    #serializePaths(s, tx, ty, rect) {
        const paths = [];
        const padding = this.thickness / 2;
        const shiftX = s * tx + padding;
        const shiftY = s * ty + padding;
        for (const bezier of this.paths){
            const buffer = [];
            const points = [];
            for(let j = 0, jj = bezier.length; j < jj; j++){
                const [first, control1, control2, second] = bezier[j];
                if (first[0] === second[0] && first[1] === second[1] && jj === 1) {
                    const p0 = s * first[0] + shiftX;
                    const p1 = s * first[1] + shiftY;
                    buffer.push(p0, p1);
                    points.push(p0, p1);
                    break;
                }
                const p10 = s * first[0] + shiftX;
                const p11 = s * first[1] + shiftY;
                const p20 = s * control1[0] + shiftX;
                const p21 = s * control1[1] + shiftY;
                const p30 = s * control2[0] + shiftX;
                const p31 = s * control2[1] + shiftY;
                const p40 = s * second[0] + shiftX;
                const p41 = s * second[1] + shiftY;
                if (j === 0) {
                    buffer.push(p10, p11);
                    points.push(p10, p11);
                }
                buffer.push(p20, p21, p30, p31, p40, p41);
                points.push(p20, p21);
                if (j === jj - 1) points.push(p40, p41);
            }
            paths.push({
                bezier: $cca4aceb320d03d3$var$InkEditor.#toPDFCoordinates(buffer, rect, this.rotation),
                points: $cca4aceb320d03d3$var$InkEditor.#toPDFCoordinates(points, rect, this.rotation)
            });
        }
        return paths;
    }
    #getBbox() {
        let xMin = Infinity;
        let xMax = -Infinity;
        let yMin = Infinity;
        let yMax = -Infinity;
        for (const path of this.paths)for (const [first, control1, control2, second] of path){
            const bbox = $cca4aceb320d03d3$var$Util.bezierBoundingBox(...first, ...control1, ...control2, ...second);
            xMin = Math.min(xMin, bbox[0]);
            yMin = Math.min(yMin, bbox[1]);
            xMax = Math.max(xMax, bbox[2]);
            yMax = Math.max(yMax, bbox[3]);
        }
        return [
            xMin,
            yMin,
            xMax,
            yMax
        ];
    }
    #getPadding() {
        return this.#disableEditing ? Math.ceil(this.thickness * this.parentScale) : 0;
    }
    #fitToContent(firstTime = false) {
        if (this.isEmpty()) return;
        if (!this.#disableEditing) {
            this.#redraw();
            return;
        }
        const bbox = this.#getBbox();
        const padding = this.#getPadding();
        this.#baseWidth = Math.max($cca4aceb320d03d3$var$AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
        this.#baseHeight = Math.max($cca4aceb320d03d3$var$AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
        const width = Math.ceil(padding + this.#baseWidth * this.scaleFactor);
        const height = Math.ceil(padding + this.#baseHeight * this.scaleFactor);
        const [parentWidth, parentHeight] = this.parentDimensions;
        this.width = width / parentWidth;
        this.height = height / parentHeight;
        this.setAspectRatio(width, height);
        const prevTranslationX = this.translationX;
        const prevTranslationY = this.translationY;
        this.translationX = -bbox[0];
        this.translationY = -bbox[1];
        this.#setCanvasDims();
        this.#redraw();
        this.#realWidth = width;
        this.#realHeight = height;
        this.setDims(width, height);
        const unscaledPadding = firstTime ? padding / this.scaleFactor / 2 : 0;
        this.translate(prevTranslationX - this.translationX - unscaledPadding, prevTranslationY - this.translationY - unscaledPadding);
    }
    static deserialize(data, parent, uiManager) {
        if (data instanceof $cca4aceb320d03d3$var$InkAnnotationElement) return null;
        const editor = super.deserialize(data, parent, uiManager);
        editor.thickness = data.thickness;
        editor.color = $cca4aceb320d03d3$var$Util.makeHexColor(...data.color);
        editor.opacity = data.opacity;
        const [pageWidth, pageHeight] = editor.pageDimensions;
        const width = editor.width * pageWidth;
        const height = editor.height * pageHeight;
        const scaleFactor = editor.parentScale;
        const padding = data.thickness / 2;
        editor.#disableEditing = true;
        editor.#realWidth = Math.round(width);
        editor.#realHeight = Math.round(height);
        const { paths: paths, rect: rect, rotation: rotation } = data;
        for (let { bezier: bezier } of paths){
            bezier = $cca4aceb320d03d3$var$InkEditor.#fromPDFCoordinates(bezier, rect, rotation);
            const path = [];
            editor.paths.push(path);
            let p0 = scaleFactor * (bezier[0] - padding);
            let p1 = scaleFactor * (bezier[1] - padding);
            for(let i = 2, ii = bezier.length; i < ii; i += 6){
                const p10 = scaleFactor * (bezier[i] - padding);
                const p11 = scaleFactor * (bezier[i + 1] - padding);
                const p20 = scaleFactor * (bezier[i + 2] - padding);
                const p21 = scaleFactor * (bezier[i + 3] - padding);
                const p30 = scaleFactor * (bezier[i + 4] - padding);
                const p31 = scaleFactor * (bezier[i + 5] - padding);
                path.push([
                    [
                        p0,
                        p1
                    ],
                    [
                        p10,
                        p11
                    ],
                    [
                        p20,
                        p21
                    ],
                    [
                        p30,
                        p31
                    ]
                ]);
                p0 = p30;
                p1 = p31;
            }
            const path2D = this.#buildPath2D(path);
            editor.bezierPath2D.push(path2D);
        }
        const bbox = editor.#getBbox();
        editor.#baseWidth = Math.max($cca4aceb320d03d3$var$AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
        editor.#baseHeight = Math.max($cca4aceb320d03d3$var$AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
        editor.#setScaleFactor(width, height);
        return editor;
    }
    serialize() {
        if (this.isEmpty()) return null;
        const rect = this.getRect(0, 0);
        const color = $cca4aceb320d03d3$var$AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
        return {
            annotationType: $cca4aceb320d03d3$var$AnnotationEditorType.INK,
            color: color,
            thickness: this.thickness,
            opacity: this.opacity,
            paths: this.#serializePaths(this.scaleFactor / this.parentScale, this.translationX, this.translationY, rect),
            pageIndex: this.pageIndex,
            rect: rect,
            rotation: this.rotation,
            structTreeParentId: this._structTreeParentId
        };
    }
}
class $cca4aceb320d03d3$var$StampEditor extends $cca4aceb320d03d3$var$AnnotationEditor {
    #bitmap = null;
    #bitmapId = null;
    #bitmapPromise = null;
    #bitmapUrl = null;
    #bitmapFile = null;
    #bitmapFileName = "";
    #canvas = null;
    #observer = null;
    #resizeTimeoutId = null;
    #isSvg = false;
    #hasBeenAddedInUndoStack = false;
    static _type = "stamp";
    static _editorType = $cca4aceb320d03d3$var$AnnotationEditorType.STAMP;
    constructor(params){
        super({
            ...params,
            name: "stampEditor"
        });
        this.#bitmapUrl = params.bitmapUrl;
        this.#bitmapFile = params.bitmapFile;
    }
    static initialize(l10n, uiManager) {
        $cca4aceb320d03d3$var$AnnotationEditor.initialize(l10n, uiManager);
    }
    static get supportedTypes() {
        const types = [
            "apng",
            "avif",
            "bmp",
            "gif",
            "jpeg",
            "png",
            "svg+xml",
            "webp",
            "x-icon"
        ];
        return $cca4aceb320d03d3$var$shadow(this, "supportedTypes", types.map((type)=>`image/${type}`));
    }
    static get supportedTypesStr() {
        return $cca4aceb320d03d3$var$shadow(this, "supportedTypesStr", this.supportedTypes.join(","));
    }
    static isHandlingMimeForPasting(mime) {
        return this.supportedTypes.includes(mime);
    }
    static paste(item, parent) {
        parent.pasteEditor($cca4aceb320d03d3$var$AnnotationEditorType.STAMP, {
            bitmapFile: item.getAsFile()
        });
    }
    #getBitmapFetched(data, fromId = false) {
        if (!data) {
            this.remove();
            return;
        }
        this.#bitmap = data.bitmap;
        if (!fromId) {
            this.#bitmapId = data.id;
            this.#isSvg = data.isSvg;
        }
        if (data.file) this.#bitmapFileName = data.file.name;
        this.#createCanvas();
    }
    #getBitmapDone() {
        this.#bitmapPromise = null;
        this._uiManager.enableWaiting(false);
        if (this.#canvas) this.div.focus();
    }
    #getBitmap() {
        if (this.#bitmapId) {
            this._uiManager.enableWaiting(true);
            this._uiManager.imageManager.getFromId(this.#bitmapId).then((data)=>this.#getBitmapFetched(data, true)).finally(()=>this.#getBitmapDone());
            return;
        }
        if (this.#bitmapUrl) {
            const url = this.#bitmapUrl;
            this.#bitmapUrl = null;
            this._uiManager.enableWaiting(true);
            this.#bitmapPromise = this._uiManager.imageManager.getFromUrl(url).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
            return;
        }
        if (this.#bitmapFile) {
            const file = this.#bitmapFile;
            this.#bitmapFile = null;
            this._uiManager.enableWaiting(true);
            this.#bitmapPromise = this._uiManager.imageManager.getFromFile(file).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
            return;
        }
        const input = document.createElement("input");
        input.type = "file";
        input.accept = $cca4aceb320d03d3$var$StampEditor.supportedTypesStr;
        const signal = this._uiManager._signal;
        this.#bitmapPromise = new Promise((resolve)=>{
            input.addEventListener("change", async ()=>{
                if (!input.files || input.files.length === 0) this.remove();
                else {
                    this._uiManager.enableWaiting(true);
                    const data = await this._uiManager.imageManager.getFromFile(input.files[0]);
                    this.#getBitmapFetched(data);
                }
                resolve();
            }, {
                signal: signal
            });
            input.addEventListener("cancel", ()=>{
                this.remove();
                resolve();
            }, {
                signal: signal
            });
        }).finally(()=>this.#getBitmapDone());
        input.click();
    }
    remove() {
        if (this.#bitmapId) {
            this.#bitmap = null;
            this._uiManager.imageManager.deleteId(this.#bitmapId);
            this.#canvas?.remove();
            this.#canvas = null;
            this.#observer?.disconnect();
            this.#observer = null;
            if (this.#resizeTimeoutId) {
                clearTimeout(this.#resizeTimeoutId);
                this.#resizeTimeoutId = null;
            }
        }
        super.remove();
    }
    rebuild() {
        if (!this.parent) {
            if (this.#bitmapId) this.#getBitmap();
            return;
        }
        super.rebuild();
        if (this.div === null) return;
        if (this.#bitmapId && this.#canvas === null) this.#getBitmap();
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    onceAdded() {
        this._isDraggable = true;
        this.div.focus();
    }
    isEmpty() {
        return !(this.#bitmapPromise || this.#bitmap || this.#bitmapUrl || this.#bitmapFile || this.#bitmapId);
    }
    get isResizable() {
        return true;
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this.width) {
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        this.div.hidden = true;
        this.addAltTextButton();
        if (this.#bitmap) this.#createCanvas();
        else this.#getBitmap();
        if (this.width) {
            const [parentWidth, parentHeight] = this.parentDimensions;
            this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
        }
        return this.div;
    }
    #createCanvas() {
        const { div: div } = this;
        let { width: width, height: height } = this.#bitmap;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const MAX_RATIO = 0.75;
        if (this.width) {
            width = this.width * pageWidth;
            height = this.height * pageHeight;
        } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
            const factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
            width *= factor;
            height *= factor;
        }
        const [parentWidth, parentHeight] = this.parentDimensions;
        this.setDims(width * parentWidth / pageWidth, height * parentHeight / pageHeight);
        this._uiManager.enableWaiting(false);
        const canvas = this.#canvas = document.createElement("canvas");
        div.append(canvas);
        div.hidden = false;
        this.#drawBitmap(width, height);
        this.#createObserver();
        if (!this.#hasBeenAddedInUndoStack) {
            this.parent.addUndoableEditor(this);
            this.#hasBeenAddedInUndoStack = true;
        }
        this._reportTelemetry({
            action: "inserted_image"
        });
        if (this.#bitmapFileName) canvas.setAttribute("aria-label", this.#bitmapFileName);
    }
    #setDimensions(width, height) {
        const [parentWidth, parentHeight] = this.parentDimensions;
        this.width = width / parentWidth;
        this.height = height / parentHeight;
        this.setDims(width, height);
        if (this._initialOptions?.isCentered) this.center();
        else this.fixAndSetPosition();
        this._initialOptions = null;
        if (this.#resizeTimeoutId !== null) clearTimeout(this.#resizeTimeoutId);
        const TIME_TO_WAIT = 200;
        this.#resizeTimeoutId = setTimeout(()=>{
            this.#resizeTimeoutId = null;
            this.#drawBitmap(width, height);
        }, TIME_TO_WAIT);
    }
    #scaleBitmap(width, height) {
        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
        let newWidth = bitmapWidth;
        let newHeight = bitmapHeight;
        let bitmap = this.#bitmap;
        while(newWidth > 2 * width || newHeight > 2 * height){
            const prevWidth = newWidth;
            const prevHeight = newHeight;
            if (newWidth > 2 * width) newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
            if (newHeight > 2 * height) newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
            const offscreen = new OffscreenCanvas(newWidth, newHeight);
            const ctx = offscreen.getContext("2d");
            ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
            bitmap = offscreen.transferToImageBitmap();
        }
        return bitmap;
    }
    #drawBitmap(width, height) {
        width = Math.ceil(width);
        height = Math.ceil(height);
        const canvas = this.#canvas;
        if (!canvas || canvas.width === width && canvas.height === height) return;
        canvas.width = width;
        canvas.height = height;
        const bitmap = this.#isSvg ? this.#bitmap : this.#scaleBitmap(width, height);
        if (this._uiManager.hasMLManager && !this.hasAltText()) {
            const offscreen = new OffscreenCanvas(width, height);
            const ctx = offscreen.getContext("2d");
            ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, width, height);
            this._uiManager.mlGuess({
                service: "image-to-text",
                request: {
                    data: ctx.getImageData(0, 0, width, height).data,
                    width: width,
                    height: height,
                    channels: 4
                }
            }).then((response)=>{
                const altText = response?.output || "";
                if (this.parent && altText && !this.hasAltText()) this.altTextData = {
                    altText: altText,
                    decorative: false
                };
            });
        }
        const ctx = canvas.getContext("2d");
        ctx.filter = this._uiManager.hcmFilter;
        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, width, height);
    }
    getImageForAltText() {
        return this.#canvas;
    }
    #serializeBitmap(toUrl) {
        if (toUrl) {
            if (this.#isSvg) {
                const url = this._uiManager.imageManager.getSvgUrl(this.#bitmapId);
                if (url) return url;
            }
            const canvas = document.createElement("canvas");
            ({ width: canvas.width, height: canvas.height } = this.#bitmap);
            const ctx = canvas.getContext("2d");
            ctx.drawImage(this.#bitmap, 0, 0);
            return canvas.toDataURL();
        }
        if (this.#isSvg) {
            const [pageWidth, pageHeight] = this.pageDimensions;
            const width = Math.round(this.width * pageWidth * $cca4aceb320d03d3$var$PixelsPerInch.PDF_TO_CSS_UNITS);
            const height = Math.round(this.height * pageHeight * $cca4aceb320d03d3$var$PixelsPerInch.PDF_TO_CSS_UNITS);
            const offscreen = new OffscreenCanvas(width, height);
            const ctx = offscreen.getContext("2d");
            ctx.drawImage(this.#bitmap, 0, 0, this.#bitmap.width, this.#bitmap.height, 0, 0, width, height);
            return offscreen.transferToImageBitmap();
        }
        return structuredClone(this.#bitmap);
    }
    #createObserver() {
        if (!this._uiManager._signal) return;
        this.#observer = new ResizeObserver((entries)=>{
            const rect = entries[0].contentRect;
            if (rect.width && rect.height) this.#setDimensions(rect.width, rect.height);
        });
        this.#observer.observe(this.div);
        this._uiManager._signal.addEventListener("abort", ()=>{
            this.#observer?.disconnect();
            this.#observer = null;
        }, {
            once: true
        });
    }
    static deserialize(data, parent, uiManager) {
        if (data instanceof $cca4aceb320d03d3$var$StampAnnotationElement) return null;
        const editor = super.deserialize(data, parent, uiManager);
        const { rect: rect, bitmapUrl: bitmapUrl, bitmapId: bitmapId, isSvg: isSvg, accessibilityData: accessibilityData } = data;
        if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) editor.#bitmapId = bitmapId;
        else editor.#bitmapUrl = bitmapUrl;
        editor.#isSvg = isSvg;
        const [parentWidth, parentHeight] = editor.pageDimensions;
        editor.width = (rect[2] - rect[0]) / parentWidth;
        editor.height = (rect[3] - rect[1]) / parentHeight;
        if (accessibilityData) editor.altTextData = accessibilityData;
        return editor;
    }
    serialize(isForCopying = false, context = null) {
        if (this.isEmpty()) return null;
        const serialized = {
            annotationType: $cca4aceb320d03d3$var$AnnotationEditorType.STAMP,
            bitmapId: this.#bitmapId,
            pageIndex: this.pageIndex,
            rect: this.getRect(0, 0),
            rotation: this.rotation,
            isSvg: this.#isSvg,
            structTreeParentId: this._structTreeParentId
        };
        if (isForCopying) {
            serialized.bitmapUrl = this.#serializeBitmap(true);
            serialized.accessibilityData = this.altTextData;
            return serialized;
        }
        const { decorative: decorative, altText: altText } = this.altTextData;
        if (!decorative && altText) serialized.accessibilityData = {
            type: "Figure",
            alt: altText
        };
        if (context === null) return serialized;
        context.stamps ||= new Map();
        const area = this.#isSvg ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
        if (!context.stamps.has(this.#bitmapId)) {
            context.stamps.set(this.#bitmapId, {
                area: area,
                serialized: serialized
            });
            serialized.bitmap = this.#serializeBitmap(false);
        } else if (this.#isSvg) {
            const prevData = context.stamps.get(this.#bitmapId);
            if (area > prevData.area) {
                prevData.area = area;
                prevData.serialized.bitmap.close();
                prevData.serialized.bitmap = this.#serializeBitmap(false);
            }
        }
        return serialized;
    }
}
class $cca4aceb320d03d3$var$AnnotationEditorLayer {
    #accessibilityManager;
    #allowClick = false;
    #annotationLayer = null;
    #boundPointerup = null;
    #boundPointerdown = null;
    #boundTextLayerPointerDown = null;
    #editorFocusTimeoutId = null;
    #editors = new Map();
    #hadPointerDown = false;
    #isCleaningUp = false;
    #isDisabling = false;
    #textLayer = null;
    #uiManager;
    static _initialized = false;
    static #editorTypes = new Map([
        $cca4aceb320d03d3$var$FreeTextEditor,
        $cca4aceb320d03d3$var$InkEditor,
        $cca4aceb320d03d3$var$StampEditor,
        $cca4aceb320d03d3$var$HighlightEditor
    ].map((type)=>[
            type._editorType,
            type
        ]));
    constructor({ uiManager: uiManager, pageIndex: pageIndex, div: div, accessibilityManager: accessibilityManager, annotationLayer: annotationLayer, drawLayer: drawLayer, textLayer: textLayer, viewport: viewport, l10n: l10n }){
        const editorTypes = [
            ...$cca4aceb320d03d3$var$AnnotationEditorLayer.#editorTypes.values()
        ];
        if (!$cca4aceb320d03d3$var$AnnotationEditorLayer._initialized) {
            $cca4aceb320d03d3$var$AnnotationEditorLayer._initialized = true;
            for (const editorType of editorTypes)editorType.initialize(l10n, uiManager);
        }
        uiManager.registerEditorTypes(editorTypes);
        this.#uiManager = uiManager;
        this.pageIndex = pageIndex;
        this.div = div;
        this.#accessibilityManager = accessibilityManager;
        this.#annotationLayer = annotationLayer;
        this.viewport = viewport;
        this.#textLayer = textLayer;
        this.drawLayer = drawLayer;
        this.#uiManager.addLayer(this);
    }
    get isEmpty() {
        return this.#editors.size === 0;
    }
    get isInvisible() {
        return this.isEmpty && this.#uiManager.getMode() === $cca4aceb320d03d3$var$AnnotationEditorType.NONE;
    }
    updateToolbar(mode) {
        this.#uiManager.updateToolbar(mode);
    }
    updateMode(mode = this.#uiManager.getMode()) {
        this.#cleanup();
        switch(mode){
            case $cca4aceb320d03d3$var$AnnotationEditorType.NONE:
                this.disableTextSelection();
                this.togglePointerEvents(false);
                this.toggleAnnotationLayerPointerEvents(true);
                this.disableClick();
                return;
            case $cca4aceb320d03d3$var$AnnotationEditorType.INK:
                this.addInkEditorIfNeeded(false);
                this.disableTextSelection();
                this.togglePointerEvents(true);
                this.disableClick();
                break;
            case $cca4aceb320d03d3$var$AnnotationEditorType.HIGHLIGHT:
                this.enableTextSelection();
                this.togglePointerEvents(false);
                this.disableClick();
                break;
            default:
                this.disableTextSelection();
                this.togglePointerEvents(true);
                this.enableClick();
        }
        this.toggleAnnotationLayerPointerEvents(false);
        const { classList: classList } = this.div;
        for (const editorType of $cca4aceb320d03d3$var$AnnotationEditorLayer.#editorTypes.values())classList.toggle(`${editorType._type}Editing`, mode === editorType._editorType);
        this.div.hidden = false;
    }
    hasTextLayer(textLayer) {
        return textLayer === this.#textLayer?.div;
    }
    addInkEditorIfNeeded(isCommitting) {
        if (this.#uiManager.getMode() !== $cca4aceb320d03d3$var$AnnotationEditorType.INK) return;
        if (!isCommitting) {
            for (const editor of this.#editors.values())if (editor.isEmpty()) {
                editor.setInBackground();
                return;
            }
        }
        const editor = this.createAndAddNewEditor({
            offsetX: 0,
            offsetY: 0
        }, false);
        editor.setInBackground();
    }
    setEditingState(isEditing) {
        this.#uiManager.setEditingState(isEditing);
    }
    addCommands(params) {
        this.#uiManager.addCommands(params);
    }
    togglePointerEvents(enabled = false) {
        this.div.classList.toggle("disabled", !enabled);
    }
    toggleAnnotationLayerPointerEvents(enabled = false) {
        this.#annotationLayer?.div.classList.toggle("disabled", !enabled);
    }
    enable() {
        this.div.tabIndex = 0;
        this.togglePointerEvents(true);
        const annotationElementIds = new Set();
        for (const editor of this.#editors.values()){
            editor.enableEditing();
            editor.show(true);
            if (editor.annotationElementId) {
                this.#uiManager.removeChangedExistingAnnotation(editor);
                annotationElementIds.add(editor.annotationElementId);
            }
        }
        if (!this.#annotationLayer) return;
        const editables = this.#annotationLayer.getEditableAnnotations();
        for (const editable of editables){
            editable.hide();
            if (this.#uiManager.isDeletedAnnotationElement(editable.data.id)) continue;
            if (annotationElementIds.has(editable.data.id)) continue;
            const editor = this.deserialize(editable);
            if (!editor) continue;
            this.addOrRebuild(editor);
            editor.enableEditing();
        }
    }
    disable() {
        this.#isDisabling = true;
        this.div.tabIndex = -1;
        this.togglePointerEvents(false);
        const changedAnnotations = new Map();
        const resetAnnotations = new Map();
        for (const editor of this.#editors.values()){
            editor.disableEditing();
            if (!editor.annotationElementId) continue;
            if (editor.serialize() !== null) {
                changedAnnotations.set(editor.annotationElementId, editor);
                continue;
            } else resetAnnotations.set(editor.annotationElementId, editor);
            this.getEditableAnnotation(editor.annotationElementId)?.show();
            editor.remove();
        }
        if (this.#annotationLayer) {
            const editables = this.#annotationLayer.getEditableAnnotations();
            for (const editable of editables){
                const { id: id } = editable.data;
                if (this.#uiManager.isDeletedAnnotationElement(id)) continue;
                let editor = resetAnnotations.get(id);
                if (editor) {
                    editor.resetAnnotationElement(editable);
                    editor.show(false);
                    editable.show();
                    continue;
                }
                editor = changedAnnotations.get(id);
                if (editor) {
                    this.#uiManager.addChangedExistingAnnotation(editor);
                    editor.renderAnnotationElement(editable);
                    editor.show(false);
                }
                editable.show();
            }
        }
        this.#cleanup();
        if (this.isEmpty) this.div.hidden = true;
        const { classList: classList } = this.div;
        for (const editorType of $cca4aceb320d03d3$var$AnnotationEditorLayer.#editorTypes.values())classList.remove(`${editorType._type}Editing`);
        this.disableTextSelection();
        this.toggleAnnotationLayerPointerEvents(true);
        this.#isDisabling = false;
    }
    getEditableAnnotation(id) {
        return this.#annotationLayer?.getEditableAnnotation(id) || null;
    }
    setActiveEditor(editor) {
        const currentActive = this.#uiManager.getActive();
        if (currentActive === editor) return;
        this.#uiManager.setActiveEditor(editor);
    }
    enableTextSelection() {
        this.div.tabIndex = -1;
        if (this.#textLayer?.div && !this.#boundTextLayerPointerDown) {
            this.#boundTextLayerPointerDown = this.#textLayerPointerDown.bind(this);
            this.#textLayer.div.addEventListener("pointerdown", this.#boundTextLayerPointerDown, {
                signal: this.#uiManager._signal
            });
            this.#textLayer.div.classList.add("highlighting");
        }
    }
    disableTextSelection() {
        this.div.tabIndex = 0;
        if (this.#textLayer?.div && this.#boundTextLayerPointerDown) {
            this.#textLayer.div.removeEventListener("pointerdown", this.#boundTextLayerPointerDown);
            this.#boundTextLayerPointerDown = null;
            this.#textLayer.div.classList.remove("highlighting");
        }
    }
    #textLayerPointerDown(event) {
        this.#uiManager.unselectAll();
        if (event.target === this.#textLayer.div) {
            const { isMac: isMac } = $cca4aceb320d03d3$var$util_FeatureTest.platform;
            if (event.button !== 0 || event.ctrlKey && isMac) return;
            this.#uiManager.showAllEditors("highlight", true, true);
            this.#textLayer.div.classList.add("free");
            $cca4aceb320d03d3$var$HighlightEditor.startHighlighting(this, this.#uiManager.direction === "ltr", event);
            this.#textLayer.div.addEventListener("pointerup", ()=>{
                this.#textLayer.div.classList.remove("free");
            }, {
                once: true,
                signal: this.#uiManager._signal
            });
            event.preventDefault();
        }
    }
    enableClick() {
        if (this.#boundPointerdown) return;
        const signal = this.#uiManager._signal;
        this.#boundPointerdown = this.pointerdown.bind(this);
        this.#boundPointerup = this.pointerup.bind(this);
        this.div.addEventListener("pointerdown", this.#boundPointerdown, {
            signal: signal
        });
        this.div.addEventListener("pointerup", this.#boundPointerup, {
            signal: signal
        });
    }
    disableClick() {
        if (!this.#boundPointerdown) return;
        this.div.removeEventListener("pointerdown", this.#boundPointerdown);
        this.div.removeEventListener("pointerup", this.#boundPointerup);
        this.#boundPointerdown = null;
        this.#boundPointerup = null;
    }
    attach(editor) {
        this.#editors.set(editor.id, editor);
        const { annotationElementId: annotationElementId } = editor;
        if (annotationElementId && this.#uiManager.isDeletedAnnotationElement(annotationElementId)) this.#uiManager.removeDeletedAnnotationElement(editor);
    }
    detach(editor) {
        this.#editors.delete(editor.id);
        this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
        if (!this.#isDisabling && editor.annotationElementId) this.#uiManager.addDeletedAnnotationElement(editor);
    }
    remove(editor) {
        this.detach(editor);
        this.#uiManager.removeEditor(editor);
        editor.div.remove();
        editor.isAttachedToDOM = false;
        if (!this.#isCleaningUp) this.addInkEditorIfNeeded(false);
    }
    changeParent(editor) {
        if (editor.parent === this) return;
        if (editor.parent && editor.annotationElementId) {
            this.#uiManager.addDeletedAnnotationElement(editor.annotationElementId);
            $cca4aceb320d03d3$var$AnnotationEditor.deleteAnnotationElement(editor);
            editor.annotationElementId = null;
        }
        this.attach(editor);
        editor.parent?.detach(editor);
        editor.setParent(this);
        if (editor.div && editor.isAttachedToDOM) {
            editor.div.remove();
            this.div.append(editor.div);
        }
    }
    add(editor) {
        if (editor.parent === this && editor.isAttachedToDOM) return;
        this.changeParent(editor);
        this.#uiManager.addEditor(editor);
        this.attach(editor);
        if (!editor.isAttachedToDOM) {
            const div = editor.render();
            this.div.append(div);
            editor.isAttachedToDOM = true;
        }
        editor.fixAndSetPosition();
        editor.onceAdded();
        this.#uiManager.addToAnnotationStorage(editor);
        editor._reportTelemetry(editor.telemetryInitialData);
    }
    moveEditorInDOM(editor) {
        if (!editor.isAttachedToDOM) return;
        const { activeElement: activeElement } = document;
        if (editor.div.contains(activeElement) && !this.#editorFocusTimeoutId) {
            editor._focusEventsAllowed = false;
            this.#editorFocusTimeoutId = setTimeout(()=>{
                this.#editorFocusTimeoutId = null;
                if (!editor.div.contains(document.activeElement)) {
                    editor.div.addEventListener("focusin", ()=>{
                        editor._focusEventsAllowed = true;
                    }, {
                        once: true,
                        signal: this.#uiManager._signal
                    });
                    activeElement.focus();
                } else editor._focusEventsAllowed = true;
            }, 0);
        }
        editor._structTreeParentId = this.#accessibilityManager?.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
    }
    addOrRebuild(editor) {
        if (editor.needsToBeRebuilt()) {
            editor.parent ||= this;
            editor.rebuild();
            editor.show();
        } else this.add(editor);
    }
    addUndoableEditor(editor) {
        const cmd = ()=>editor._uiManager.rebuild(editor);
        const undo = ()=>{
            editor.remove();
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: false
        });
    }
    getNextId() {
        return this.#uiManager.getId();
    }
    get #currentEditorType() {
        return $cca4aceb320d03d3$var$AnnotationEditorLayer.#editorTypes.get(this.#uiManager.getMode());
    }
    get _signal() {
        return this.#uiManager._signal;
    }
    #createNewEditor(params) {
        const editorType = this.#currentEditorType;
        return editorType ? new editorType.prototype.constructor(params) : null;
    }
    canCreateNewEmptyEditor() {
        return this.#currentEditorType?.canCreateNewEmptyEditor();
    }
    pasteEditor(mode, params) {
        this.#uiManager.updateToolbar(mode);
        this.#uiManager.updateMode(mode);
        const { offsetX: offsetX, offsetY: offsetY } = this.#getCenterPoint();
        const id = this.getNextId();
        const editor = this.#createNewEditor({
            parent: this,
            id: id,
            x: offsetX,
            y: offsetY,
            uiManager: this.#uiManager,
            isCentered: true,
            ...params
        });
        if (editor) this.add(editor);
    }
    deserialize(data) {
        return $cca4aceb320d03d3$var$AnnotationEditorLayer.#editorTypes.get(data.annotationType ?? data.annotationEditorType)?.deserialize(data, this, this.#uiManager) || null;
    }
    createAndAddNewEditor(event, isCentered, data = {}) {
        const id = this.getNextId();
        const editor = this.#createNewEditor({
            parent: this,
            id: id,
            x: event.offsetX,
            y: event.offsetY,
            uiManager: this.#uiManager,
            isCentered: isCentered,
            ...data
        });
        if (editor) this.add(editor);
        return editor;
    }
    #getCenterPoint() {
        const { x: x, y: y, width: width, height: height } = this.div.getBoundingClientRect();
        const tlX = Math.max(0, x);
        const tlY = Math.max(0, y);
        const brX = Math.min(window.innerWidth, x + width);
        const brY = Math.min(window.innerHeight, y + height);
        const centerX = (tlX + brX) / 2 - x;
        const centerY = (tlY + brY) / 2 - y;
        const [offsetX, offsetY] = this.viewport.rotation % 180 === 0 ? [
            centerX,
            centerY
        ] : [
            centerY,
            centerX
        ];
        return {
            offsetX: offsetX,
            offsetY: offsetY
        };
    }
    addNewEditor() {
        this.createAndAddNewEditor(this.#getCenterPoint(), true);
    }
    setSelected(editor) {
        this.#uiManager.setSelected(editor);
    }
    toggleSelected(editor) {
        this.#uiManager.toggleSelected(editor);
    }
    isSelected(editor) {
        return this.#uiManager.isSelected(editor);
    }
    unselect(editor) {
        this.#uiManager.unselect(editor);
    }
    pointerup(event) {
        const { isMac: isMac } = $cca4aceb320d03d3$var$util_FeatureTest.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        if (event.target !== this.div) return;
        if (!this.#hadPointerDown) return;
        this.#hadPointerDown = false;
        if (!this.#allowClick) {
            this.#allowClick = true;
            return;
        }
        if (this.#uiManager.getMode() === $cca4aceb320d03d3$var$AnnotationEditorType.STAMP) {
            this.#uiManager.unselectAll();
            return;
        }
        this.createAndAddNewEditor(event, false);
    }
    pointerdown(event) {
        if (this.#uiManager.getMode() === $cca4aceb320d03d3$var$AnnotationEditorType.HIGHLIGHT) this.enableTextSelection();
        if (this.#hadPointerDown) {
            this.#hadPointerDown = false;
            return;
        }
        const { isMac: isMac } = $cca4aceb320d03d3$var$util_FeatureTest.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        if (event.target !== this.div) return;
        this.#hadPointerDown = true;
        const editor = this.#uiManager.getActive();
        this.#allowClick = !editor || editor.isEmpty();
    }
    findNewParent(editor, x, y) {
        const layer = this.#uiManager.findParent(x, y);
        if (layer === null || layer === this) return false;
        layer.changeParent(editor);
        return true;
    }
    destroy() {
        if (this.#uiManager.getActive()?.parent === this) {
            this.#uiManager.commitOrRemove();
            this.#uiManager.setActiveEditor(null);
        }
        if (this.#editorFocusTimeoutId) {
            clearTimeout(this.#editorFocusTimeoutId);
            this.#editorFocusTimeoutId = null;
        }
        for (const editor of this.#editors.values()){
            this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
            editor.setParent(null);
            editor.isAttachedToDOM = false;
            editor.div.remove();
        }
        this.div = null;
        this.#editors.clear();
        this.#uiManager.removeLayer(this);
    }
    #cleanup() {
        this.#isCleaningUp = true;
        for (const editor of this.#editors.values())if (editor.isEmpty()) editor.remove();
        this.#isCleaningUp = false;
    }
    render({ viewport: viewport }) {
        this.viewport = viewport;
        $cca4aceb320d03d3$var$setLayerDimensions(this.div, viewport);
        for (const editor of this.#uiManager.getEditors(this.pageIndex)){
            this.add(editor);
            editor.rebuild();
        }
        this.updateMode();
    }
    update({ viewport: viewport }) {
        this.#uiManager.commitOrRemove();
        this.#cleanup();
        const oldRotation = this.viewport.rotation;
        const rotation = viewport.rotation;
        this.viewport = viewport;
        $cca4aceb320d03d3$var$setLayerDimensions(this.div, {
            rotation: rotation
        });
        if (oldRotation !== rotation) for (const editor of this.#editors.values())editor.rotate(rotation);
        this.addInkEditorIfNeeded(false);
    }
    get pageDimensions() {
        const { pageWidth: pageWidth, pageHeight: pageHeight } = this.viewport.rawDims;
        return [
            pageWidth,
            pageHeight
        ];
    }
    get scale() {
        return this.#uiManager.viewParameters.realScale;
    }
}
class $cca4aceb320d03d3$var$DrawLayer {
    #parent = null;
    #id = 0;
    #mapping = new Map();
    #toUpdate = new Map();
    constructor({ pageIndex: pageIndex }){
        this.pageIndex = pageIndex;
    }
    setParent(parent) {
        if (!this.#parent) {
            this.#parent = parent;
            return;
        }
        if (this.#parent !== parent) {
            if (this.#mapping.size > 0) for (const root of this.#mapping.values()){
                root.remove();
                parent.append(root);
            }
            this.#parent = parent;
        }
    }
    static get _svgFactory() {
        return $cca4aceb320d03d3$var$shadow(this, "_svgFactory", new $cca4aceb320d03d3$var$DOMSVGFactory());
    }
    static #setBox(element, { x: x = 0, y: y = 0, width: width = 1, height: height = 1 } = {}) {
        const { style: style } = element;
        style.top = `${100 * y}%`;
        style.left = `${100 * x}%`;
        style.width = `${100 * width}%`;
        style.height = `${100 * height}%`;
    }
    #createSVG(box) {
        const svg = $cca4aceb320d03d3$var$DrawLayer._svgFactory.create(1, 1, true);
        this.#parent.append(svg);
        svg.setAttribute("aria-hidden", true);
        $cca4aceb320d03d3$var$DrawLayer.#setBox(svg, box);
        return svg;
    }
    #createClipPath(defs, pathId) {
        const clipPath = $cca4aceb320d03d3$var$DrawLayer._svgFactory.createElement("clipPath");
        defs.append(clipPath);
        const clipPathId = `clip_${pathId}`;
        clipPath.setAttribute("id", clipPathId);
        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
        const clipPathUse = $cca4aceb320d03d3$var$DrawLayer._svgFactory.createElement("use");
        clipPath.append(clipPathUse);
        clipPathUse.setAttribute("href", `#${pathId}`);
        clipPathUse.classList.add("clip");
        return clipPathId;
    }
    highlight(outlines, color, opacity, isPathUpdatable = false) {
        const id = this.#id++;
        const root = this.#createSVG(outlines.box);
        root.classList.add("highlight");
        if (outlines.free) root.classList.add("free");
        const defs = $cca4aceb320d03d3$var$DrawLayer._svgFactory.createElement("defs");
        root.append(defs);
        const path = $cca4aceb320d03d3$var$DrawLayer._svgFactory.createElement("path");
        defs.append(path);
        const pathId = `path_p${this.pageIndex}_${id}`;
        path.setAttribute("id", pathId);
        path.setAttribute("d", outlines.toSVGPath());
        if (isPathUpdatable) this.#toUpdate.set(id, path);
        const clipPathId = this.#createClipPath(defs, pathId);
        const use = $cca4aceb320d03d3$var$DrawLayer._svgFactory.createElement("use");
        root.append(use);
        root.setAttribute("fill", color);
        root.setAttribute("fill-opacity", opacity);
        use.setAttribute("href", `#${pathId}`);
        this.#mapping.set(id, root);
        return {
            id: id,
            clipPathId: `url(#${clipPathId})`
        };
    }
    highlightOutline(outlines) {
        const id = this.#id++;
        const root = this.#createSVG(outlines.box);
        root.classList.add("highlightOutline");
        const defs = $cca4aceb320d03d3$var$DrawLayer._svgFactory.createElement("defs");
        root.append(defs);
        const path = $cca4aceb320d03d3$var$DrawLayer._svgFactory.createElement("path");
        defs.append(path);
        const pathId = `path_p${this.pageIndex}_${id}`;
        path.setAttribute("id", pathId);
        path.setAttribute("d", outlines.toSVGPath());
        path.setAttribute("vector-effect", "non-scaling-stroke");
        let maskId;
        if (outlines.free) {
            root.classList.add("free");
            const mask = $cca4aceb320d03d3$var$DrawLayer._svgFactory.createElement("mask");
            defs.append(mask);
            maskId = `mask_p${this.pageIndex}_${id}`;
            mask.setAttribute("id", maskId);
            mask.setAttribute("maskUnits", "objectBoundingBox");
            const rect = $cca4aceb320d03d3$var$DrawLayer._svgFactory.createElement("rect");
            mask.append(rect);
            rect.setAttribute("width", "1");
            rect.setAttribute("height", "1");
            rect.setAttribute("fill", "white");
            const use = $cca4aceb320d03d3$var$DrawLayer._svgFactory.createElement("use");
            mask.append(use);
            use.setAttribute("href", `#${pathId}`);
            use.setAttribute("stroke", "none");
            use.setAttribute("fill", "black");
            use.setAttribute("fill-rule", "nonzero");
            use.classList.add("mask");
        }
        const use1 = $cca4aceb320d03d3$var$DrawLayer._svgFactory.createElement("use");
        root.append(use1);
        use1.setAttribute("href", `#${pathId}`);
        if (maskId) use1.setAttribute("mask", `url(#${maskId})`);
        const use2 = use1.cloneNode();
        root.append(use2);
        use1.classList.add("mainOutline");
        use2.classList.add("secondaryOutline");
        this.#mapping.set(id, root);
        return id;
    }
    finalizeLine(id, line) {
        const path = this.#toUpdate.get(id);
        this.#toUpdate.delete(id);
        this.updateBox(id, line.box);
        path.setAttribute("d", line.toSVGPath());
    }
    updateLine(id, line) {
        const root = this.#mapping.get(id);
        const defs = root.firstChild;
        const path = defs.firstChild;
        path.setAttribute("d", line.toSVGPath());
    }
    removeFreeHighlight(id) {
        this.remove(id);
        this.#toUpdate.delete(id);
    }
    updatePath(id, line) {
        this.#toUpdate.get(id).setAttribute("d", line.toSVGPath());
    }
    updateBox(id, box) {
        $cca4aceb320d03d3$var$DrawLayer.#setBox(this.#mapping.get(id), box);
    }
    show(id, visible) {
        this.#mapping.get(id).classList.toggle("hidden", !visible);
    }
    rotate(id, angle) {
        this.#mapping.get(id).setAttribute("data-main-rotation", angle);
    }
    changeColor(id, color) {
        this.#mapping.get(id).setAttribute("fill", color);
    }
    changeOpacity(id, opacity) {
        this.#mapping.get(id).setAttribute("fill-opacity", opacity);
    }
    addClass(id, className) {
        this.#mapping.get(id).classList.add(className);
    }
    removeClass(id, className) {
        this.#mapping.get(id).classList.remove(className);
    }
    remove(id) {
        if (this.#parent === null) return;
        this.#mapping.get(id).remove();
        this.#mapping.delete(id);
    }
    destroy() {
        this.#parent = null;
        for (const root of this.#mapping.values())root.remove();
        this.#mapping.clear();
    }
}
const $cca4aceb320d03d3$var$pdfjsVersion = "4.4.168";
const $cca4aceb320d03d3$var$pdfjsBuild = "19fbc8998";
var $cca4aceb320d03d3$export$d0e978393d193d1a = $cca4aceb320d03d3$var$__webpack_exports__.AbortException;
var $cca4aceb320d03d3$export$47948c9fe1adbf1b = $cca4aceb320d03d3$var$__webpack_exports__.AnnotationEditorLayer;
var $cca4aceb320d03d3$export$cf3df2a6ecc26692 = $cca4aceb320d03d3$var$__webpack_exports__.AnnotationEditorParamsType;
var $cca4aceb320d03d3$export$72ea3bfdd9a725bf = $cca4aceb320d03d3$var$__webpack_exports__.AnnotationEditorType;
var $cca4aceb320d03d3$export$26cb16552a82cf63 = $cca4aceb320d03d3$var$__webpack_exports__.AnnotationEditorUIManager;
var $cca4aceb320d03d3$export$3e7f45c326d9366c = $cca4aceb320d03d3$var$__webpack_exports__.AnnotationLayer;
var $cca4aceb320d03d3$export$5a7af0c07e33392e = $cca4aceb320d03d3$var$__webpack_exports__.AnnotationMode;
var $cca4aceb320d03d3$export$7c23995f9a5b159 = $cca4aceb320d03d3$var$__webpack_exports__.CMapCompressionType;
var $cca4aceb320d03d3$export$9feb1bc2e5f1ccb3 = $cca4aceb320d03d3$var$__webpack_exports__.ColorPicker;
var $cca4aceb320d03d3$export$425e69f00724e63a = $cca4aceb320d03d3$var$__webpack_exports__.DOMSVGFactory;
var $cca4aceb320d03d3$export$3eb4521511f02450 = $cca4aceb320d03d3$var$__webpack_exports__.DrawLayer;
var $cca4aceb320d03d3$export$5fb8891d35c36978 = $cca4aceb320d03d3$var$__webpack_exports__.FeatureTest;
var $cca4aceb320d03d3$export$edf38ba293eb934 = $cca4aceb320d03d3$var$__webpack_exports__.GlobalWorkerOptions;
var $cca4aceb320d03d3$export$b890e9c15247e0b3 = $cca4aceb320d03d3$var$__webpack_exports__.ImageKind;
var $cca4aceb320d03d3$export$e3d0f4ce5b91e9f1 = $cca4aceb320d03d3$var$__webpack_exports__.InvalidPDFException;
var $cca4aceb320d03d3$export$33dda1a4114f3e73 = $cca4aceb320d03d3$var$__webpack_exports__.MissingPDFException;
var $cca4aceb320d03d3$export$3a0f7f7a8a0b306b = $cca4aceb320d03d3$var$__webpack_exports__.OPS;
var $cca4aceb320d03d3$export$8b4a90ba6f04789e = $cca4aceb320d03d3$var$__webpack_exports__.Outliner;
var $cca4aceb320d03d3$export$c06899d9d7bce9ab = $cca4aceb320d03d3$var$__webpack_exports__.PDFDataRangeTransport;
var $cca4aceb320d03d3$export$66cbc314498fffc = $cca4aceb320d03d3$var$__webpack_exports__.PDFDateString;
var $cca4aceb320d03d3$export$84e2e9f37426b265 = $cca4aceb320d03d3$var$__webpack_exports__.PDFWorker;
var $cca4aceb320d03d3$export$5e72215208e4d9ad = $cca4aceb320d03d3$var$__webpack_exports__.PasswordResponses;
var $cca4aceb320d03d3$export$bb99a5b8411e07d8 = $cca4aceb320d03d3$var$__webpack_exports__.PermissionFlag;
var $cca4aceb320d03d3$export$6ef3b6b69e65342c = $cca4aceb320d03d3$var$__webpack_exports__.PixelsPerInch;
var $cca4aceb320d03d3$export$245847d31c09154f = $cca4aceb320d03d3$var$__webpack_exports__.RenderingCancelledException;
var $cca4aceb320d03d3$export$fdbdc423a78c5262 = $cca4aceb320d03d3$var$__webpack_exports__.TextLayer;
var $cca4aceb320d03d3$export$bed32a6c95ee1622 = $cca4aceb320d03d3$var$__webpack_exports__.UnexpectedResponseException;
var $cca4aceb320d03d3$export$f8f26dd395d7e1bd = $cca4aceb320d03d3$var$__webpack_exports__.Util;
var $cca4aceb320d03d3$export$b18df09d23c244c4 = $cca4aceb320d03d3$var$__webpack_exports__.VerbosityLevel;
var $cca4aceb320d03d3$export$f6af20c312d4b9a2 = $cca4aceb320d03d3$var$__webpack_exports__.XfaLayer;
var $cca4aceb320d03d3$export$3f8fe6489e95757d = $cca4aceb320d03d3$var$__webpack_exports__.build;
var $cca4aceb320d03d3$export$e076b47f5805ca0b = $cca4aceb320d03d3$var$__webpack_exports__.createValidAbsoluteUrl;
var $cca4aceb320d03d3$export$8134c072fddab6a5 = $cca4aceb320d03d3$var$__webpack_exports__.fetchData;
var $cca4aceb320d03d3$export$f65ca476c09acec0 = $cca4aceb320d03d3$var$__webpack_exports__.getDocument;
var $cca4aceb320d03d3$export$b1c11df0696253ae = $cca4aceb320d03d3$var$__webpack_exports__.getFilenameFromUrl;
var $cca4aceb320d03d3$export$9de51790aa4bc73a = $cca4aceb320d03d3$var$__webpack_exports__.getPdfFilenameFromUrl;
var $cca4aceb320d03d3$export$dd5d6edf3fc80aae = $cca4aceb320d03d3$var$__webpack_exports__.getXfaPageViewport;
var $cca4aceb320d03d3$export$f67aae4532d8295b = $cca4aceb320d03d3$var$__webpack_exports__.isDataScheme;
var $cca4aceb320d03d3$export$61b52d3570d24719 = $cca4aceb320d03d3$var$__webpack_exports__.isPdfFile;
var $cca4aceb320d03d3$export$455b7811f904cadc = $cca4aceb320d03d3$var$__webpack_exports__.noContextMenu;
var $cca4aceb320d03d3$export$1fa1e6b1a06bd7fa = $cca4aceb320d03d3$var$__webpack_exports__.normalizeUnicode;
var $cca4aceb320d03d3$export$f5f25a69ba172b88 = $cca4aceb320d03d3$var$__webpack_exports__.renderTextLayer;
var $cca4aceb320d03d3$export$af0a15a86e590226 = $cca4aceb320d03d3$var$__webpack_exports__.setLayerDimensions;
var $cca4aceb320d03d3$export$b8972b998723d602 = $cca4aceb320d03d3$var$__webpack_exports__.shadow;
var $cca4aceb320d03d3$export$36a3594acc1522d8 = $cca4aceb320d03d3$var$__webpack_exports__.updateTextLayer;
var $cca4aceb320d03d3$export$83d89fbfd8236492 = $cca4aceb320d03d3$var$__webpack_exports__.version;



var $6fFrj = parcelRequire("6fFrj");
'use client';
const $f2f2ad1917c466d9$var$documentContext = (0, $6fFrj.createContext)(null);
var $f2f2ad1917c466d9$export$2e2bcd8739ae039 = $f2f2ad1917c466d9$var$documentContext;



var $bb3TF = parcelRequire("bb3TF");
function $caf70c91cbc06108$export$2e2bcd8739ae039({ children: children, type: type }) {
    return (0, $bb3TF.jsx)("div", {
        className: `react-pdf__message react-pdf__message--${type}`,
        children: children
    });
}


/* Copyright 2015 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
const $3161fb142cc8de7f$var$DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
class $3161fb142cc8de7f$export$2e2bcd8739ae039 {
    constructor(){
        this.externalLinkEnabled = true;
        this.externalLinkRel = undefined;
        this.externalLinkTarget = undefined;
        this.isInPresentationMode = false;
        this.pdfDocument = undefined;
        this.pdfViewer = undefined;
    }
    setDocument(pdfDocument) {
        this.pdfDocument = pdfDocument;
    }
    setViewer(pdfViewer) {
        this.pdfViewer = pdfViewer;
    }
    setExternalLinkRel(externalLinkRel) {
        this.externalLinkRel = externalLinkRel;
    }
    setExternalLinkTarget(externalLinkTarget) {
        this.externalLinkTarget = externalLinkTarget;
    }
    setHistory() {
    // Intentionally empty
    }
    get pagesCount() {
        return this.pdfDocument ? this.pdfDocument.numPages : 0;
    }
    get page() {
        (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(this.pdfViewer, 'PDF viewer is not initialized.');
        return this.pdfViewer.currentPageNumber || 0;
    }
    set page(value) {
        (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(this.pdfViewer, 'PDF viewer is not initialized.');
        this.pdfViewer.currentPageNumber = value;
    }
    get rotation() {
        return 0;
    }
    set rotation(_value) {
    // Intentionally empty
    }
    goToDestination(dest) {
        return new Promise((resolve)=>{
            (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(this.pdfDocument, 'PDF document not loaded.');
            (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(dest, 'Destination is not specified.');
            if (typeof dest === 'string') this.pdfDocument.getDestination(dest).then(resolve);
            else if (Array.isArray(dest)) resolve(dest);
            else dest.then(resolve);
        }).then((explicitDest)=>{
            (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(Array.isArray(explicitDest), `"${explicitDest}" is not a valid destination array.`);
            const destRef = explicitDest[0];
            new Promise((resolve)=>{
                (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(this.pdfDocument, 'PDF document not loaded.');
                if (destRef instanceof Object) this.pdfDocument.getPageIndex(destRef).then((pageIndex)=>{
                    resolve(pageIndex);
                }).catch(()=>{
                    (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(false, `"${destRef}" is not a valid page reference.`);
                });
                else if (typeof destRef === 'number') resolve(destRef);
                else (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(false, `"${destRef}" is not a valid destination reference.`);
            }).then((pageIndex)=>{
                const pageNumber = pageIndex + 1;
                (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(this.pdfViewer, 'PDF viewer is not initialized.');
                (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(pageNumber >= 1 && pageNumber <= this.pagesCount, `"${pageNumber}" is not a valid page number.`);
                this.pdfViewer.scrollPageIntoView({
                    dest: explicitDest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
            });
        });
    }
    navigateTo(dest) {
        this.goToDestination(dest);
    }
    goToPage(pageNumber) {
        const pageIndex = pageNumber - 1;
        (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(this.pdfViewer, 'PDF viewer is not initialized.');
        (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(pageNumber >= 1 && pageNumber <= this.pagesCount, `"${pageNumber}" is not a valid page number.`);
        this.pdfViewer.scrollPageIntoView({
            pageIndex: pageIndex,
            pageNumber: pageNumber
        });
    }
    addLinkAttributes(link, url, newWindow) {
        link.href = url;
        link.rel = this.externalLinkRel || $3161fb142cc8de7f$var$DEFAULT_LINK_REL;
        link.target = newWindow ? '_blank' : this.externalLinkTarget || '';
    }
    getDestinationHash() {
        return '#';
    }
    getAnchorUrl() {
        return '#';
    }
    setHash() {
    // Intentionally empty
    }
    executeNamedAction() {
    // Intentionally empty
    }
    cachePageRef() {
    // Intentionally empty
    }
    isPageVisible() {
        return true;
    }
    isPageCached() {
        return true;
    }
    executeSetOCGState() {
    // Intentionally empty
    }
}


// As defined in https://github.com/mozilla/pdf.js/blob/d9fac3459609a807be6506fb3441b5da4b154d14/src/shared/util.js#L371-L374
const $0126b35659c2c7c3$var$PasswordResponses = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
var $0126b35659c2c7c3$export$2e2bcd8739ae039 = $0126b35659c2c7c3$var$PasswordResponses;




const $a890e5e35a863cbf$export$4e09c449d6c407f7 = typeof window !== 'undefined';
const $a890e5e35a863cbf$export$d528e4159a0e221e = $a890e5e35a863cbf$export$4e09c449d6c407f7 && window.location.protocol === 'file:';
function $a890e5e35a863cbf$export$4e62c701997796c1(variable) {
    return typeof variable !== 'undefined';
}
function $a890e5e35a863cbf$export$ef8866826b0b1f6d(variable) {
    return $a890e5e35a863cbf$export$4e62c701997796c1(variable) && variable !== null;
}
function $a890e5e35a863cbf$export$844ec244b1367d54(variable) {
    return typeof variable === 'string';
}
function $a890e5e35a863cbf$export$9dd3754ae86f0017(variable) {
    return variable instanceof ArrayBuffer;
}
function $a890e5e35a863cbf$export$5bcd6e94ed871c88(variable) {
    (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)($a890e5e35a863cbf$export$4e09c449d6c407f7, 'isBlob can only be used in a browser environment');
    return variable instanceof Blob;
}
function $a890e5e35a863cbf$export$4d82193ef6a8d75c(variable) {
    return $a890e5e35a863cbf$export$844ec244b1367d54(variable) && /^data:/.test(variable);
}
function $a890e5e35a863cbf$export$c1553384119518c3(dataURI) {
    (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)($a890e5e35a863cbf$export$4d82193ef6a8d75c(dataURI), 'Invalid data URI.');
    const [headersString = '', dataString = ''] = dataURI.split(',');
    const headers = headersString.split(';');
    if (headers.indexOf('base64') !== -1) return atob(dataString);
    return unescape(dataString);
}
function $a890e5e35a863cbf$export$cf4a949e5ad681d() {
    return $a890e5e35a863cbf$export$4e09c449d6c407f7 && window.devicePixelRatio || 1;
}
const $a890e5e35a863cbf$var$allowFileAccessFromFilesTip = 'On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.';
function $a890e5e35a863cbf$export$84884c3182d1bdda() {
    (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(!$a890e5e35a863cbf$export$d528e4159a0e221e, `Loading PDF as base64 strings/URLs may not work on protocols other than HTTP/HTTPS. ${$a890e5e35a863cbf$var$allowFileAccessFromFilesTip}`);
}
function $a890e5e35a863cbf$export$e7ec4a9e2d586a77() {
    (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(!$a890e5e35a863cbf$export$d528e4159a0e221e, `Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ${$a890e5e35a863cbf$var$allowFileAccessFromFilesTip}`);
}
function $a890e5e35a863cbf$export$b8c3f1dffc289352(runningTask) {
    if (runningTask === null || runningTask === void 0 ? void 0 : runningTask.cancel) runningTask.cancel();
}
function $a890e5e35a863cbf$export$8cc3f6b8d58bdda0(page, scale) {
    Object.defineProperty(page, 'width', {
        get () {
            return this.view[2] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, 'height', {
        get () {
            return this.view[3] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, 'originalWidth', {
        get () {
            return this.view[2];
        },
        configurable: true
    });
    Object.defineProperty(page, 'originalHeight', {
        get () {
            return this.view[3];
        },
        configurable: true
    });
    return page;
}
function $a890e5e35a863cbf$export$99075c4d008e6ab1(error) {
    return error.name === 'RenderingCancelledException';
}
function $a890e5e35a863cbf$export$21fedb3a7a137f3d(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            if (!reader.result) return reject(new Error('Error while reading a file.'));
            resolve(reader.result);
        };
        reader.onerror = (event)=>{
            if (!event.target) return reject(new Error('Error while reading a file.'));
            const { error: error } = event.target;
            if (!error) return reject(new Error('Error while reading a file.'));
            switch(error.code){
                case error.NOT_FOUND_ERR:
                    return reject(new Error('Error while reading a file: File not found.'));
                case error.SECURITY_ERR:
                    return reject(new Error('Error while reading a file: Security error.'));
                case error.ABORT_ERR:
                    return reject(new Error('Error while reading a file: Aborted.'));
                default:
                    return reject(new Error('Error while reading a file.'));
            }
        };
        reader.readAsArrayBuffer(file);
    });
}



var $6fFrj = parcelRequire("6fFrj");
function $02029098bb553e69$var$reducer(state, action) {
    switch(action.type){
        case 'RESOLVE':
            return {
                value: action.value,
                error: undefined
            };
        case 'REJECT':
            return {
                value: false,
                error: action.error
            };
        case 'RESET':
            return {
                value: undefined,
                error: undefined
            };
        default:
            return state;
    }
}
function $02029098bb553e69$export$2e2bcd8739ae039() {
    return (0, $6fFrj.useReducer)($02029098bb553e69$var$reducer, {
        value: undefined,
        error: undefined
    });
}


'use client';
var $f6e5f053c4705103$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f6e5f053c4705103$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const { PDFDataRangeTransport: $f6e5f053c4705103$var$PDFDataRangeTransport } = $cca4aceb320d03d3$exports;
const $f6e5f053c4705103$var$defaultOnPassword = (callback, reason)=>{
    switch(reason){
        case (0, $0126b35659c2c7c3$export$2e2bcd8739ae039).NEED_PASSWORD:
            {
                const password = prompt('Enter the password to open this PDF file.');
                callback(password);
                break;
            }
        case (0, $0126b35659c2c7c3$export$2e2bcd8739ae039).INCORRECT_PASSWORD:
            {
                const password = prompt('Invalid password. Please try again.');
                callback(password);
                break;
            }
        default:
    }
};
function $f6e5f053c4705103$var$isParameterObject(file) {
    return typeof file === 'object' && file !== null && ('data' in file || 'range' in file || 'url' in file);
}
/**
 * Loads a document passed using `file` prop.
 */ const $f6e5f053c4705103$var$Document = (0, $6fFrj.forwardRef)(function Document(_a, ref) {
    var { children: children, className: className, error: error = 'Failed to load PDF file.', externalLinkRel: externalLinkRel, externalLinkTarget: externalLinkTarget, file: file, inputRef: inputRef, imageResourcesPath: imageResourcesPath, loading: loading = "Loading PDF\u2026", noData: noData = 'No PDF file specified.', onItemClick: onItemClick, onLoadError: onLoadErrorProps, onLoadProgress: onLoadProgress, onLoadSuccess: onLoadSuccessProps, onPassword: onPassword = $f6e5f053c4705103$var$defaultOnPassword, onSourceError: onSourceErrorProps, onSourceSuccess: onSourceSuccessProps, options: options, renderMode: renderMode, rotate: rotate } = _a, otherProps = $f6e5f053c4705103$var$__rest(_a, [
        "children",
        "className",
        "error",
        "externalLinkRel",
        "externalLinkTarget",
        "file",
        "inputRef",
        "imageResourcesPath",
        "loading",
        "noData",
        "onItemClick",
        "onLoadError",
        "onLoadProgress",
        "onLoadSuccess",
        "onPassword",
        "onSourceError",
        "onSourceSuccess",
        "options",
        "renderMode",
        "rotate"
    ]);
    const [sourceState, sourceDispatch] = (0, $02029098bb553e69$export$2e2bcd8739ae039)();
    const { value: source, error: sourceError } = sourceState;
    const [pdfState, pdfDispatch] = (0, $02029098bb553e69$export$2e2bcd8739ae039)();
    const { value: pdf, error: pdfError } = pdfState;
    const linkService = (0, $6fFrj.useRef)(new (0, $3161fb142cc8de7f$export$2e2bcd8739ae039)());
    const pages = (0, $6fFrj.useRef)([]);
    const prevFile = (0, $6fFrj.useRef)(undefined);
    const prevOptions = (0, $6fFrj.useRef)(undefined);
    if (file && file !== prevFile.current && $f6e5f053c4705103$var$isParameterObject(file)) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(!(0, $3b52b919fe9803ad$export$de8294bb3be0322f)(file, prevFile.current), `File prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "file" prop.`);
        prevFile.current = file;
    }
    // Detect non-memoized changes in options prop
    if (options && options !== prevOptions.current) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(!(0, $3b52b919fe9803ad$export$de8294bb3be0322f)(options, prevOptions.current), `Options prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "options" prop.`);
        prevOptions.current = options;
    }
    const viewer = (0, $6fFrj.useRef)({
        // Handling jumping to internal links target
        scrollPageIntoView: (args)=>{
            const { dest: dest, pageNumber: pageNumber, pageIndex: pageIndex = pageNumber - 1 } = args;
            // First, check if custom handling of onItemClick was provided
            if (onItemClick) {
                onItemClick({
                    dest: dest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
                return;
            }
            // If not, try to look for target page within the <Document>.
            const page = pages.current[pageIndex];
            if (page) {
                // Scroll to the page automatically
                page.scrollIntoView();
                return;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(false, `An internal link leading to page ${pageNumber} was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>.`);
        }
    });
    (0, $6fFrj.useImperativeHandle)(ref, ()=>({
            linkService: linkService,
            pages: pages,
            viewer: viewer
        }), []);
    /**
     * Called when a document source is resolved correctly
     */ function onSourceSuccess() {
        if (onSourceSuccessProps) onSourceSuccessProps();
    }
    /**
     * Called when a document source failed to be resolved correctly
     */ function onSourceError() {
        if (!sourceError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(false, sourceError.toString());
        if (onSourceErrorProps) onSourceErrorProps(sourceError);
    }
    function resetSource() {
        sourceDispatch({
            type: 'RESET'
        });
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: See https://github.com/biomejs/biome/issues/3080
    (0, $6fFrj.useEffect)(resetSource, [
        file,
        sourceDispatch
    ]);
    const findDocumentSource = (0, $6fFrj.useCallback)(()=>$f6e5f053c4705103$var$__awaiter(this, void 0, void 0, function*() {
            if (!file) return null;
            // File is a string
            if (typeof file === 'string') {
                if ((0, $a890e5e35a863cbf$export$4d82193ef6a8d75c)(file)) {
                    const fileByteString = (0, $a890e5e35a863cbf$export$c1553384119518c3)(file);
                    return {
                        data: fileByteString
                    };
                }
                (0, $a890e5e35a863cbf$export$84884c3182d1bdda)();
                return {
                    url: file
                };
            }
            // File is PDFDataRangeTransport
            if (file instanceof $f6e5f053c4705103$var$PDFDataRangeTransport) return {
                range: file
            };
            // File is an ArrayBuffer
            if ((0, $a890e5e35a863cbf$export$9dd3754ae86f0017)(file)) return {
                data: file
            };
            /**
         * The cases below are browser-only.
         * If you're running on a non-browser environment, these cases will be of no use.
         */ if (0, $a890e5e35a863cbf$export$4e09c449d6c407f7) // File is a Blob
            {
                if ((0, $a890e5e35a863cbf$export$5bcd6e94ed871c88)(file)) {
                    const data = yield (0, $a890e5e35a863cbf$export$21fedb3a7a137f3d)(file);
                    return {
                        data: data
                    };
                }
            }
            // At this point, file must be an object
            (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(typeof file === 'object', 'Invalid parameter in file, need either Uint8Array, string or a parameter object');
            (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)($f6e5f053c4705103$var$isParameterObject(file), 'Invalid parameter object: need either .data, .range or .url');
            // File .url is a string
            if ('url' in file && typeof file.url === 'string') {
                if ((0, $a890e5e35a863cbf$export$4d82193ef6a8d75c)(file.url)) {
                    const { url: url } = file, otherParams = $f6e5f053c4705103$var$__rest(file, [
                        "url"
                    ]);
                    const fileByteString = (0, $a890e5e35a863cbf$export$c1553384119518c3)(url);
                    return Object.assign({
                        data: fileByteString
                    }, otherParams);
                }
                (0, $a890e5e35a863cbf$export$84884c3182d1bdda)();
            }
            return file;
        }), [
        file
    ]);
    (0, $6fFrj.useEffect)(()=>{
        const cancellable = (0, $e6416ed4a1a78a14$export$2e2bcd8739ae039)(findDocumentSource());
        cancellable.promise.then((nextSource)=>{
            sourceDispatch({
                type: 'RESOLVE',
                value: nextSource
            });
        }).catch((error)=>{
            sourceDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>{
            (0, $a890e5e35a863cbf$export$b8c3f1dffc289352)(cancellable);
        };
    }, [
        findDocumentSource,
        sourceDispatch
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Ommitted callbacks so they are not called every time they change
    (0, $6fFrj.useEffect)(()=>{
        if (typeof source === 'undefined') return;
        if (source === false) {
            onSourceError();
            return;
        }
        onSourceSuccess();
    }, [
        source
    ]);
    /**
     * Called when a document is read successfully
     */ function onLoadSuccess() {
        if (!pdf) // Impossible, but TypeScript doesn't know that
        return;
        if (onLoadSuccessProps) onLoadSuccessProps(pdf);
        pages.current = new Array(pdf.numPages);
        linkService.current.setDocument(pdf);
    }
    /**
     * Called when a document failed to read successfully
     */ function onLoadError() {
        if (!pdfError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(false, pdfError.toString());
        if (onLoadErrorProps) onLoadErrorProps(pdfError);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on source change
    (0, $6fFrj.useEffect)(function resetDocument() {
        pdfDispatch({
            type: 'RESET'
        });
    }, [
        pdfDispatch,
        source
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Ommitted callbacks so they are not called every time they change
    (0, $6fFrj.useEffect)(function loadDocument() {
        if (!source) return;
        const documentInitParams = options ? Object.assign(Object.assign({}, source), options) : source;
        const destroyable = $cca4aceb320d03d3$exports.getDocument(documentInitParams);
        if (onLoadProgress) destroyable.onProgress = onLoadProgress;
        if (onPassword) destroyable.onPassword = onPassword;
        const loadingTask = destroyable;
        const loadingPromise = loadingTask.promise.then((nextPdf)=>{
            pdfDispatch({
                type: 'RESOLVE',
                value: nextPdf
            });
        }).catch((error)=>{
            if (loadingTask.destroyed) return;
            pdfDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>{
            loadingPromise.finally(()=>loadingTask.destroy());
        };
    }, [
        options,
        pdfDispatch,
        source
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Ommitted callbacks so they are not called every time they change
    (0, $6fFrj.useEffect)(()=>{
        if (typeof pdf === 'undefined') return;
        if (pdf === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, [
        pdf
    ]);
    (0, $6fFrj.useEffect)(function setupLinkService() {
        linkService.current.setViewer(viewer.current);
        linkService.current.setExternalLinkRel(externalLinkRel);
        linkService.current.setExternalLinkTarget(externalLinkTarget);
    }, [
        externalLinkRel,
        externalLinkTarget
    ]);
    const registerPage = (0, $6fFrj.useCallback)((pageIndex, ref)=>{
        pages.current[pageIndex] = ref;
    }, []);
    const unregisterPage = (0, $6fFrj.useCallback)((pageIndex)=>{
        delete pages.current[pageIndex];
    }, []);
    const childContext = (0, $6fFrj.useMemo)(()=>({
            imageResourcesPath: imageResourcesPath,
            linkService: linkService.current,
            onItemClick: onItemClick,
            pdf: pdf,
            registerPage: registerPage,
            renderMode: renderMode,
            rotate: rotate,
            unregisterPage: unregisterPage
        }), [
        imageResourcesPath,
        onItemClick,
        pdf,
        registerPage,
        renderMode,
        rotate,
        unregisterPage
    ]);
    const eventProps = (0, $6fFrj.useMemo)(()=>(0, $a9af34f79898d35a$export$2e2bcd8739ae039)(otherProps, ()=>pdf), // biome-ignore lint/correctness/useExhaustiveDependencies: FIXME
    [
        otherProps,
        pdf
    ]);
    function renderChildren() {
        return (0, $bb3TF.jsx)((0, $f2f2ad1917c466d9$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: children
        });
    }
    function renderContent() {
        if (!file) return (0, $bb3TF.jsx)((0, $caf70c91cbc06108$export$2e2bcd8739ae039), {
            type: "no-data",
            children: typeof noData === 'function' ? noData() : noData
        });
        if (pdf === undefined || pdf === null) return (0, $bb3TF.jsx)((0, $caf70c91cbc06108$export$2e2bcd8739ae039), {
            type: "loading",
            children: typeof loading === 'function' ? loading() : loading
        });
        if (pdf === false) return (0, $bb3TF.jsx)((0, $caf70c91cbc06108$export$2e2bcd8739ae039), {
            type: "error",
            children: typeof error === 'function' ? error() : error
        });
        return renderChildren();
    }
    return (0, $bb3TF.jsx)("div", Object.assign({
        className: (0, $47f64881d26a6a18$export$2e2bcd8739ae039)('react-pdf__Document', className),
        // Assertion is needed for React 18 compatibility
        ref: inputRef,
        style: {
            ['--scale-factor']: '1'
        }
    }, eventProps, {
        children: renderContent()
    }));
});
var $f6e5f053c4705103$export$2e2bcd8739ae039 = $f6e5f053c4705103$var$Document;


var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



/**
 * A function that merges React refs into one.
 * Supports both functions and ref objects created using createRef() and useRef().
 *
 * Usage:
 * ```tsx
 * <div ref={mergeRefs(ref1, ref2, ref3)} />
 * ```
 *
 * @param {(React.Ref<T> | undefined)[]} inputRefs Array of refs
 * @returns {React.Ref<T> | React.RefCallback<T>} Merged refs
 */ function $2fed736794d80d98$export$2e2bcd8739ae039() {
    var inputRefs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputRefs[_i] = arguments[_i];
    var filteredInputRefs = inputRefs.filter(Boolean);
    if (filteredInputRefs.length <= 1) {
        var firstRef = filteredInputRefs[0];
        return firstRef || null;
    }
    return function mergedRefs(ref) {
        filteredInputRefs.forEach(function(inputRef) {
            if (typeof inputRef === 'function') inputRef(ref);
            else if (inputRef) inputRef.current = ref;
        });
    };
}





var $6fFrj = parcelRequire("6fFrj");
'use client';
const $3af4f3d8d4c94a77$var$pageContext = (0, $6fFrj.createContext)(null);
var $3af4f3d8d4c94a77$export$2e2bcd8739ae039 = $3af4f3d8d4c94a77$var$pageContext;




var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");





var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");
// From pdfjs-dist/lib/web/struct_tree_layer_builder.js
const $6e46cca9c61eb666$export$789cd800273ee71a = {
    // Document level structure types
    Document: null,
    DocumentFragment: null,
    // Grouping level structure types
    Part: 'group',
    Sect: 'group',
    Div: 'group',
    Aside: 'note',
    NonStruct: 'none',
    // Block level structure types
    P: null,
    // H<n>,
    H: 'heading',
    Title: null,
    FENote: 'note',
    // Sub-block level structure type
    Sub: 'group',
    // General inline level structure types
    Lbl: null,
    Span: null,
    Em: null,
    Strong: null,
    Link: 'link',
    Annot: 'note',
    Form: 'form',
    // Ruby and Warichu structure types
    Ruby: null,
    RB: null,
    RT: null,
    RP: null,
    Warichu: null,
    WT: null,
    WP: null,
    // List standard structure types
    L: 'list',
    LI: 'listitem',
    LBody: null,
    // Table standard structure types
    Table: 'table',
    TR: 'row',
    TH: 'columnheader',
    TD: 'cell',
    THead: 'columnheader',
    TBody: null,
    TFoot: null,
    // Standard structure type Caption
    Caption: null,
    // Standard structure type Figure
    Figure: 'figure',
    // Standard structure type Formula
    Formula: null,
    // standard structure type Artifact
    Artifact: null
};
const $6e46cca9c61eb666$export$4921bbe0701579e4 = /^H(\d+)$/;


function $a289bd235a0c7676$export$80a007e7cc9dad0d(role) {
    return role in (0, $6e46cca9c61eb666$export$789cd800273ee71a);
}
function $a289bd235a0c7676$export$9eeaf208d22fae4f(node) {
    return 'children' in node;
}
function $a289bd235a0c7676$export$3b7840712ba182f3(node) {
    if (!$a289bd235a0c7676$export$9eeaf208d22fae4f(node)) return false;
    return node.children.length === 1 && 0 in node.children && 'id' in node.children[0];
}
function $a289bd235a0c7676$export$aa440a09c67191c2(node) {
    const attributes = {};
    if ($a289bd235a0c7676$export$9eeaf208d22fae4f(node)) {
        const { role: role } = node;
        const matches = role.match((0, $6e46cca9c61eb666$export$4921bbe0701579e4));
        if (matches) {
            attributes.role = 'heading';
            attributes['aria-level'] = Number(matches[1]);
        } else if ($a289bd235a0c7676$export$80a007e7cc9dad0d(role)) {
            const htmlRole = (0, $6e46cca9c61eb666$export$789cd800273ee71a)[role];
            if (htmlRole) attributes.role = htmlRole;
        }
    }
    return attributes;
}
function $a289bd235a0c7676$export$e86e6c9c68c5154c(node) {
    const attributes = {};
    if ($a289bd235a0c7676$export$9eeaf208d22fae4f(node)) {
        if (node.alt !== undefined) attributes['aria-label'] = node.alt;
        if (node.lang !== undefined) attributes.lang = node.lang;
        if ($a289bd235a0c7676$export$3b7840712ba182f3(node)) {
            const [child] = node.children;
            if (child) {
                const childAttributes = $a289bd235a0c7676$export$e86e6c9c68c5154c(child);
                return Object.assign(Object.assign({}, attributes), childAttributes);
            }
        }
    } else if ('id' in node) attributes['aria-owns'] = node.id;
    return attributes;
}
function $a289bd235a0c7676$export$fe94072fee8a6976(node) {
    if (!node) return null;
    return Object.assign(Object.assign({}, $a289bd235a0c7676$export$aa440a09c67191c2(node)), $a289bd235a0c7676$export$e86e6c9c68c5154c(node));
}


function $d74835f2b79de60a$export$2e2bcd8739ae039({ className: className, node: node }) {
    const attributes = (0, $6fFrj.useMemo)(()=>(0, $a289bd235a0c7676$export$fe94072fee8a6976)(node), [
        node
    ]);
    const children = (0, $6fFrj.useMemo)(()=>{
        if (!(0, $a289bd235a0c7676$export$9eeaf208d22fae4f)(node)) return null;
        if ((0, $a289bd235a0c7676$export$3b7840712ba182f3)(node)) return null;
        return node.children.map((child, index)=>{
            return(// biome-ignore lint/suspicious/noArrayIndexKey: index is stable here
            (0, $bb3TF.jsx)($d74835f2b79de60a$export$2e2bcd8739ae039, {
                node: child
            }, index));
        });
    }, [
        node
    ]);
    return (0, $bb3TF.jsx)("span", Object.assign({
        className: className
    }, attributes, {
        children: children
    }));
}



var $6fFrj = parcelRequire("6fFrj");

function $5d20a0de1290353b$export$2e2bcd8739ae039() {
    return (0, $6fFrj.useContext)((0, $3af4f3d8d4c94a77$export$2e2bcd8739ae039));
}




function $4f35ef941a2e13a9$export$2e2bcd8739ae039() {
    const pageContext = (0, $5d20a0de1290353b$export$2e2bcd8739ae039)();
    (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(pageContext, 'Unable to find Page context.');
    const { onGetStructTreeError: onGetStructTreeErrorProps, onGetStructTreeSuccess: onGetStructTreeSuccessProps } = pageContext;
    const [structTreeState, structTreeDispatch] = (0, $02029098bb553e69$export$2e2bcd8739ae039)();
    const { value: structTree, error: structTreeError } = structTreeState;
    const { customTextRenderer: customTextRenderer, page: page } = pageContext;
    function onLoadSuccess() {
        if (!structTree) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetStructTreeSuccessProps) onGetStructTreeSuccessProps(structTree);
    }
    function onLoadError() {
        if (!structTreeError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(false, structTreeError.toString());
        if (onGetStructTreeErrorProps) onGetStructTreeErrorProps(structTreeError);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on page change
    (0, $6fFrj.useEffect)(function resetStructTree() {
        structTreeDispatch({
            type: 'RESET'
        });
    }, [
        structTreeDispatch,
        page
    ]);
    (0, $6fFrj.useEffect)(function loadStructTree() {
        if (customTextRenderer) // TODO: Document why this is necessary
        return;
        if (!page) return;
        const cancellable = (0, $e6416ed4a1a78a14$export$2e2bcd8739ae039)(page.getStructTree());
        const runningTask = cancellable;
        cancellable.promise.then((nextStructTree)=>{
            structTreeDispatch({
                type: 'RESOLVE',
                value: nextStructTree
            });
        }).catch((error)=>{
            structTreeDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>(0, $a890e5e35a863cbf$export$b8c3f1dffc289352)(runningTask);
    }, [
        customTextRenderer,
        page,
        structTreeDispatch
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Ommitted callbacks so they are not called every time they change
    (0, $6fFrj.useEffect)(()=>{
        if (structTree === undefined) return;
        if (structTree === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, [
        structTree
    ]);
    if (!structTree) return null;
    return (0, $bb3TF.jsx)((0, $d74835f2b79de60a$export$2e2bcd8739ae039), {
        className: "react-pdf__Page__structTree structTree",
        node: structTree
    });
}




'use client';
const $c647397067d6a82c$var$ANNOTATION_MODE = $cca4aceb320d03d3$export$5a7af0c07e33392e;
function $c647397067d6a82c$export$2e2bcd8739ae039(props) {
    const pageContext = (0, $5d20a0de1290353b$export$2e2bcd8739ae039)();
    (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(pageContext, 'Unable to find Page context.');
    const mergedProps = Object.assign(Object.assign({}, pageContext), props);
    const { _className: _className, canvasBackground: canvasBackground, devicePixelRatio: devicePixelRatio = (0, $a890e5e35a863cbf$export$cf4a949e5ad681d)(), onRenderError: onRenderErrorProps, onRenderSuccess: onRenderSuccessProps, page: page, renderForms: renderForms, renderTextLayer: renderTextLayer, rotate: rotate, scale: scale } = mergedProps;
    const { canvasRef: canvasRef } = props;
    (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(page, 'Attempted to render page canvas, but no page was specified.');
    const canvasElement = (0, $6fFrj.useRef)(null);
    /**
     * Called when a page is rendered successfully.
     */ function onRenderSuccess() {
        if (!page) // Impossible, but TypeScript doesn't know that
        return;
        if (onRenderSuccessProps) onRenderSuccessProps((0, $a890e5e35a863cbf$export$8cc3f6b8d58bdda0)(page, scale));
    }
    /**
     * Called when a page fails to render.
     */ function onRenderError(error) {
        if ((0, $a890e5e35a863cbf$export$99075c4d008e6ab1)(error)) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(false, error.toString());
        if (onRenderErrorProps) onRenderErrorProps(error);
    }
    const renderViewport = (0, $6fFrj.useMemo)(()=>page.getViewport({
            scale: scale * devicePixelRatio,
            rotation: rotate
        }), [
        devicePixelRatio,
        page,
        rotate,
        scale
    ]);
    const viewport = (0, $6fFrj.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Ommitted callbacks so they are not called every time they change
    (0, $6fFrj.useEffect)(function drawPageOnCanvas() {
        if (!page) return;
        // Ensures the canvas will be re-rendered from scratch. Otherwise all form data will stay.
        page.cleanup();
        const { current: canvas } = canvasElement;
        if (!canvas) return;
        canvas.width = renderViewport.width;
        canvas.height = renderViewport.height;
        canvas.style.width = `${Math.floor(viewport.width)}px`;
        canvas.style.height = `${Math.floor(viewport.height)}px`;
        canvas.style.visibility = 'hidden';
        const renderContext = {
            annotationMode: renderForms ? $c647397067d6a82c$var$ANNOTATION_MODE.ENABLE_FORMS : $c647397067d6a82c$var$ANNOTATION_MODE.ENABLE,
            canvasContext: canvas.getContext('2d', {
                alpha: false
            }),
            viewport: renderViewport
        };
        if (canvasBackground) renderContext.background = canvasBackground;
        const cancellable = page.render(renderContext);
        const runningTask = cancellable;
        cancellable.promise.then(()=>{
            canvas.style.visibility = '';
            onRenderSuccess();
        }).catch(onRenderError);
        return ()=>(0, $a890e5e35a863cbf$export$b8c3f1dffc289352)(runningTask);
    }, [
        canvasBackground,
        page,
        renderForms,
        renderViewport,
        viewport
    ]);
    const cleanup = (0, $6fFrj.useCallback)(()=>{
        const { current: canvas } = canvasElement;
        /**
         * Zeroing the width and height cause most browsers to release graphics
         * resources immediately, which can greatly reduce memory consumption.
         */ if (canvas) {
            canvas.width = 0;
            canvas.height = 0;
        }
    }, []);
    (0, $6fFrj.useEffect)(()=>cleanup, [
        cleanup
    ]);
    return (0, $bb3TF.jsx)("canvas", {
        className: `${_className}__canvas`,
        dir: "ltr",
        ref: (0, $2fed736794d80d98$export$2e2bcd8739ae039)(canvasRef, canvasElement),
        style: {
            display: 'block',
            userSelect: 'none'
        },
        children: renderTextLayer ? (0, $bb3TF.jsx)((0, $4f35ef941a2e13a9$export$2e2bcd8739ae039), {}) : null
    });
}



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");








'use client';
function $3f6a3e2d2b5dc02d$var$isTextItem(item) {
    return 'str' in item;
}
function $3f6a3e2d2b5dc02d$export$2e2bcd8739ae039() {
    const pageContext = (0, $5d20a0de1290353b$export$2e2bcd8739ae039)();
    (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(pageContext, 'Unable to find Page context.');
    const { customTextRenderer: customTextRenderer, onGetTextError: onGetTextError, onGetTextSuccess: onGetTextSuccess, onRenderTextLayerError: onRenderTextLayerError, onRenderTextLayerSuccess: onRenderTextLayerSuccess, page: page, pageIndex: pageIndex, pageNumber: pageNumber, rotate: rotate, scale: scale } = pageContext;
    (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(page, 'Attempted to load page text content, but no page was specified.');
    const [textContentState, textContentDispatch] = (0, $02029098bb553e69$export$2e2bcd8739ae039)();
    const { value: textContent, error: textContentError } = textContentState;
    const layerElement = (0, $6fFrj.useRef)(null);
    const endElement = (0, $6fFrj.useRef)(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(Number.parseInt(window.getComputedStyle(document.body).getPropertyValue('--react-pdf-text-layer'), 10) === 1, 'TextLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-text-layer');
    /**
     * Called when a page text content is read successfully
     */ function onLoadSuccess() {
        if (!textContent) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetTextSuccess) onGetTextSuccess(textContent);
    }
    /**
     * Called when a page text content failed to read successfully
     */ function onLoadError() {
        if (!textContentError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(false, textContentError.toString());
        if (onGetTextError) onGetTextError(textContentError);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on page change
    (0, $6fFrj.useEffect)(function resetTextContent() {
        textContentDispatch({
            type: 'RESET'
        });
    }, [
        page,
        textContentDispatch
    ]);
    (0, $6fFrj.useEffect)(function loadTextContent() {
        if (!page) return;
        const cancellable = (0, $e6416ed4a1a78a14$export$2e2bcd8739ae039)(page.getTextContent());
        const runningTask = cancellable;
        cancellable.promise.then((nextTextContent)=>{
            textContentDispatch({
                type: 'RESOLVE',
                value: nextTextContent
            });
        }).catch((error)=>{
            textContentDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>(0, $a890e5e35a863cbf$export$b8c3f1dffc289352)(runningTask);
    }, [
        page,
        textContentDispatch
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Ommitted callbacks so they are not called every time they change
    (0, $6fFrj.useEffect)(()=>{
        if (textContent === undefined) return;
        if (textContent === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, [
        textContent
    ]);
    /**
     * Called when a text layer is rendered successfully
     */ const onRenderSuccess = (0, $6fFrj.useCallback)(()=>{
        if (onRenderTextLayerSuccess) onRenderTextLayerSuccess();
    }, [
        onRenderTextLayerSuccess
    ]);
    /**
     * Called when a text layer failed to render successfully
     */ const onRenderError = (0, $6fFrj.useCallback)((error)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(false, error.toString());
        if (onRenderTextLayerError) onRenderTextLayerError(error);
    }, [
        onRenderTextLayerError
    ]);
    function onMouseDown() {
        const end = endElement.current;
        if (!end) return;
        end.classList.add('active');
    }
    function onMouseUp() {
        const end = endElement.current;
        if (!end) return;
        end.classList.remove('active');
    }
    const viewport = (0, $6fFrj.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    (0, $6fFrj.useLayoutEffect)(function renderTextLayer() {
        if (!page || !textContent) return;
        const { current: layer } = layerElement;
        if (!layer) return;
        layer.innerHTML = '';
        const textContentSource = page.streamTextContent({
            includeMarkedContent: true
        });
        const parameters = {
            container: layer,
            textContentSource: textContentSource,
            viewport: viewport
        };
        const cancellable = new $cca4aceb320d03d3$export$fdbdc423a78c5262(parameters);
        const runningTask = cancellable;
        cancellable.render().then(()=>{
            const end = document.createElement('div');
            end.className = 'endOfContent';
            layer.append(end);
            endElement.current = end;
            const layerChildren = layer.querySelectorAll('[role="presentation"]');
            if (customTextRenderer) {
                let index = 0;
                textContent.items.forEach((item, itemIndex)=>{
                    if (!$3f6a3e2d2b5dc02d$var$isTextItem(item)) return;
                    const child = layerChildren[index];
                    if (!child) return;
                    const content = customTextRenderer(Object.assign({
                        pageIndex: pageIndex,
                        pageNumber: pageNumber,
                        itemIndex: itemIndex
                    }, item));
                    child.innerHTML = content;
                    index += item.str && item.hasEOL ? 2 : 1;
                });
            }
            // Intentional immediate callback
            onRenderSuccess();
        }).catch(onRenderError);
        return ()=>(0, $a890e5e35a863cbf$export$b8c3f1dffc289352)(runningTask);
    }, [
        customTextRenderer,
        onRenderError,
        onRenderSuccess,
        page,
        pageIndex,
        pageNumber,
        textContent,
        viewport
    ]);
    return (0, $bb3TF.jsx)("div", {
        className: (0, $47f64881d26a6a18$export$2e2bcd8739ae039)('react-pdf__Page__textContent', 'textLayer'),
        onMouseUp: onMouseUp,
        onMouseDown: onMouseDown,
        ref: layerElement
    });
}



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");






var $6fFrj = parcelRequire("6fFrj");

function $488e61aca2c7a4d2$export$2e2bcd8739ae039() {
    return (0, $6fFrj.useContext)((0, $f2f2ad1917c466d9$export$2e2bcd8739ae039));
}





'use client';
function $3823383a2b1e4259$export$2e2bcd8739ae039() {
    const documentContext = (0, $488e61aca2c7a4d2$export$2e2bcd8739ae039)();
    const pageContext = (0, $5d20a0de1290353b$export$2e2bcd8739ae039)();
    (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(pageContext, 'Unable to find Page context.');
    const mergedProps = Object.assign(Object.assign({}, documentContext), pageContext);
    const { imageResourcesPath: imageResourcesPath, linkService: linkService, onGetAnnotationsError: onGetAnnotationsErrorProps, onGetAnnotationsSuccess: onGetAnnotationsSuccessProps, onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps, onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps, page: page, pdf: pdf, renderForms: renderForms, rotate: rotate, scale: scale = 1 } = mergedProps;
    (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(pdf, 'Attempted to load page annotations, but no document was specified. Wrap <Page /> in a <Document /> or pass explicit `pdf` prop.');
    (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(page, 'Attempted to load page annotations, but no page was specified.');
    (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(linkService, 'Attempted to load page annotations, but no linkService was specified.');
    const [annotationsState, annotationsDispatch] = (0, $02029098bb553e69$export$2e2bcd8739ae039)();
    const { value: annotations, error: annotationsError } = annotationsState;
    const layerElement = (0, $6fFrj.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(Number.parseInt(window.getComputedStyle(document.body).getPropertyValue('--react-pdf-annotation-layer'), 10) === 1, 'AnnotationLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-annotations');
    function onLoadSuccess() {
        if (!annotations) // Impossible, but TypeScript doesn't know that
        return;
        if (onGetAnnotationsSuccessProps) onGetAnnotationsSuccessProps(annotations);
    }
    function onLoadError() {
        if (!annotationsError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(false, annotationsError.toString());
        if (onGetAnnotationsErrorProps) onGetAnnotationsErrorProps(annotationsError);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on page change
    (0, $6fFrj.useEffect)(function resetAnnotations() {
        annotationsDispatch({
            type: 'RESET'
        });
    }, [
        annotationsDispatch,
        page
    ]);
    (0, $6fFrj.useEffect)(function loadAnnotations() {
        if (!page) return;
        const cancellable = (0, $e6416ed4a1a78a14$export$2e2bcd8739ae039)(page.getAnnotations());
        const runningTask = cancellable;
        cancellable.promise.then((nextAnnotations)=>{
            annotationsDispatch({
                type: 'RESOLVE',
                value: nextAnnotations
            });
        }).catch((error)=>{
            annotationsDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>{
            (0, $a890e5e35a863cbf$export$b8c3f1dffc289352)(runningTask);
        };
    }, [
        annotationsDispatch,
        page
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Ommitted callbacks so they are not called every time they change
    (0, $6fFrj.useEffect)(()=>{
        if (annotations === undefined) return;
        if (annotations === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, [
        annotations
    ]);
    function onRenderSuccess() {
        if (onRenderAnnotationLayerSuccessProps) onRenderAnnotationLayerSuccessProps();
    }
    function onRenderError(error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(false, `${error}`);
        if (onRenderAnnotationLayerErrorProps) onRenderAnnotationLayerErrorProps(error);
    }
    const viewport = (0, $6fFrj.useMemo)(()=>page.getViewport({
            scale: scale,
            rotation: rotate
        }), [
        page,
        rotate,
        scale
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Ommitted callbacks so they are not called every time they change
    (0, $6fFrj.useEffect)(function renderAnnotationLayer() {
        if (!pdf || !page || !linkService || !annotations) return;
        const { current: layer } = layerElement;
        if (!layer) return;
        const clonedViewport = viewport.clone({
            dontFlip: true
        });
        const annotationLayerParameters = {
            accessibilityManager: null,
            annotationCanvasMap: null,
            annotationEditorUIManager: null,
            div: layer,
            l10n: null,
            page: page,
            viewport: clonedViewport
        };
        const renderParameters = {
            annotations: annotations,
            annotationStorage: pdf.annotationStorage,
            div: layer,
            imageResourcesPath: imageResourcesPath,
            linkService: linkService,
            page: page,
            renderForms: renderForms,
            viewport: clonedViewport
        };
        layer.innerHTML = '';
        try {
            new $cca4aceb320d03d3$export$3e7f45c326d9366c(annotationLayerParameters).render(renderParameters);
            // Intentional immediate callback
            onRenderSuccess();
        } catch (error) {
            onRenderError(error);
        }
        return ()=>{
        // TODO: Cancel running task?
        };
    }, [
        annotations,
        imageResourcesPath,
        linkService,
        page,
        pdf,
        renderForms,
        viewport
    ]);
    return (0, $bb3TF.jsx)("div", {
        className: (0, $47f64881d26a6a18$export$2e2bcd8739ae039)('react-pdf__Page__annotations', 'annotationLayer'),
        ref: layerElement
    });
}





'use client';
var $1c5d9cfe7d7f1094$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $1c5d9cfe7d7f1094$var$defaultScale = 1;
function $1c5d9cfe7d7f1094$export$2e2bcd8739ae039(props) {
    const documentContext = (0, $488e61aca2c7a4d2$export$2e2bcd8739ae039)();
    const mergedProps = Object.assign(Object.assign({}, documentContext), props);
    const { _className: _className = 'react-pdf__Page', _enableRegisterUnregisterPage: _enableRegisterUnregisterPage = true, canvasBackground: canvasBackground, canvasRef: canvasRef, children: children, className: className, customRenderer: CustomRenderer, customTextRenderer: customTextRenderer, devicePixelRatio: devicePixelRatio, error: error = 'Failed to load the page.', height: height, inputRef: inputRef, loading: loading = "Loading page\u2026", noData: noData = 'No page specified.', onGetAnnotationsError: onGetAnnotationsErrorProps, onGetAnnotationsSuccess: onGetAnnotationsSuccessProps, onGetStructTreeError: onGetStructTreeErrorProps, onGetStructTreeSuccess: onGetStructTreeSuccessProps, onGetTextError: onGetTextErrorProps, onGetTextSuccess: onGetTextSuccessProps, onLoadError: onLoadErrorProps, onLoadSuccess: onLoadSuccessProps, onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps, onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps, onRenderError: onRenderErrorProps, onRenderSuccess: onRenderSuccessProps, onRenderTextLayerError: onRenderTextLayerErrorProps, onRenderTextLayerSuccess: onRenderTextLayerSuccessProps, pageIndex: pageIndexProps, pageNumber: pageNumberProps, pdf: pdf, registerPage: registerPage, renderAnnotationLayer: renderAnnotationLayerProps = true, renderForms: renderForms = false, renderMode: renderMode = 'canvas', renderTextLayer: renderTextLayerProps = true, rotate: rotateProps, scale: scaleProps = $1c5d9cfe7d7f1094$var$defaultScale, unregisterPage: unregisterPage, width: width } = mergedProps, otherProps = $1c5d9cfe7d7f1094$var$__rest(mergedProps, [
        "_className",
        "_enableRegisterUnregisterPage",
        "canvasBackground",
        "canvasRef",
        "children",
        "className",
        "customRenderer",
        "customTextRenderer",
        "devicePixelRatio",
        "error",
        "height",
        "inputRef",
        "loading",
        "noData",
        "onGetAnnotationsError",
        "onGetAnnotationsSuccess",
        "onGetStructTreeError",
        "onGetStructTreeSuccess",
        "onGetTextError",
        "onGetTextSuccess",
        "onLoadError",
        "onLoadSuccess",
        "onRenderAnnotationLayerError",
        "onRenderAnnotationLayerSuccess",
        "onRenderError",
        "onRenderSuccess",
        "onRenderTextLayerError",
        "onRenderTextLayerSuccess",
        "pageIndex",
        "pageNumber",
        "pdf",
        "registerPage",
        "renderAnnotationLayer",
        "renderForms",
        "renderMode",
        "renderTextLayer",
        "rotate",
        "scale",
        "unregisterPage",
        "width"
    ]);
    const [pageState, pageDispatch] = (0, $02029098bb553e69$export$2e2bcd8739ae039)();
    const { value: page, error: pageError } = pageState;
    const pageElement = (0, $6fFrj.useRef)(null);
    (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(pdf, 'Attempted to load a page, but no document was specified. Wrap <Page /> in a <Document /> or pass explicit `pdf` prop.');
    const pageIndex = (0, $a890e5e35a863cbf$export$ef8866826b0b1f6d)(pageNumberProps) ? pageNumberProps - 1 : pageIndexProps !== null && pageIndexProps !== void 0 ? pageIndexProps : null;
    const pageNumber = pageNumberProps !== null && pageNumberProps !== void 0 ? pageNumberProps : (0, $a890e5e35a863cbf$export$ef8866826b0b1f6d)(pageIndexProps) ? pageIndexProps + 1 : null;
    const rotate = rotateProps !== null && rotateProps !== void 0 ? rotateProps : page ? page.rotate : null;
    const scale = (0, $6fFrj.useMemo)(()=>{
        if (!page) return null;
        // Be default, we'll render page at 100% * scale width.
        let pageScale = 1;
        // Passing scale explicitly null would cause the page not to render
        const scaleWithDefault = scaleProps !== null && scaleProps !== void 0 ? scaleProps : $1c5d9cfe7d7f1094$var$defaultScale;
        // If width/height is defined, calculate the scale of the page so it could be of desired width.
        if (width || height) {
            const viewport = page.getViewport({
                scale: 1,
                rotation: rotate
            });
            if (width) pageScale = width / viewport.width;
            else if (height) pageScale = height / viewport.height;
        }
        return scaleWithDefault * pageScale;
    }, [
        height,
        page,
        rotate,
        scaleProps,
        width
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on pdf change
    (0, $6fFrj.useEffect)(function hook() {
        return ()=>{
            if (!(0, $a890e5e35a863cbf$export$ef8866826b0b1f6d)(pageIndex)) // Impossible, but TypeScript doesn't know that
            return;
            if (_enableRegisterUnregisterPage && unregisterPage) unregisterPage(pageIndex);
        };
    }, [
        _enableRegisterUnregisterPage,
        pdf,
        pageIndex,
        unregisterPage
    ]);
    /**
     * Called when a page is loaded successfully
     */ function onLoadSuccess() {
        if (onLoadSuccessProps) {
            if (!page || !scale) // Impossible, but TypeScript doesn't know that
            return;
            onLoadSuccessProps((0, $a890e5e35a863cbf$export$8cc3f6b8d58bdda0)(page, scale));
        }
        if (_enableRegisterUnregisterPage && registerPage) {
            if (!(0, $a890e5e35a863cbf$export$ef8866826b0b1f6d)(pageIndex) || !pageElement.current) // Impossible, but TypeScript doesn't know that
            return;
            registerPage(pageIndex, pageElement.current);
        }
    }
    /**
     * Called when a page failed to load
     */ function onLoadError() {
        if (!pageError) // Impossible, but TypeScript doesn't know that
        return;
        (0, (/*@__PURE__*/$parcel$interopDefault($4333bcd0e5f1fa22$exports)))(false, pageError.toString());
        if (onLoadErrorProps) onLoadErrorProps(pageError);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on pdf and pageIndex change
    (0, $6fFrj.useEffect)(function resetPage() {
        pageDispatch({
            type: 'RESET'
        });
    }, [
        pageDispatch,
        pdf,
        pageIndex
    ]);
    (0, $6fFrj.useEffect)(function loadPage() {
        if (!pdf || !pageNumber) return;
        const cancellable = (0, $e6416ed4a1a78a14$export$2e2bcd8739ae039)(pdf.getPage(pageNumber));
        const runningTask = cancellable;
        cancellable.promise.then((nextPage)=>{
            pageDispatch({
                type: 'RESOLVE',
                value: nextPage
            });
        }).catch((error)=>{
            pageDispatch({
                type: 'REJECT',
                error: error
            });
        });
        return ()=>(0, $a890e5e35a863cbf$export$b8c3f1dffc289352)(runningTask);
    }, [
        pageDispatch,
        pdf,
        pageNumber
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Ommitted callbacks so they are not called every time they change
    (0, $6fFrj.useEffect)(()=>{
        if (page === undefined) return;
        if (page === false) {
            onLoadError();
            return;
        }
        onLoadSuccess();
    }, [
        page,
        scale
    ]);
    const childContext = (0, $6fFrj.useMemo)(()=>// Technically there cannot be page without pageIndex, pageNumber, rotate and scale, but TypeScript doesn't know that
        page && (0, $a890e5e35a863cbf$export$ef8866826b0b1f6d)(pageIndex) && pageNumber && (0, $a890e5e35a863cbf$export$ef8866826b0b1f6d)(rotate) && (0, $a890e5e35a863cbf$export$ef8866826b0b1f6d)(scale) ? {
            _className: _className,
            canvasBackground: canvasBackground,
            customTextRenderer: customTextRenderer,
            devicePixelRatio: devicePixelRatio,
            onGetAnnotationsError: onGetAnnotationsErrorProps,
            onGetAnnotationsSuccess: onGetAnnotationsSuccessProps,
            onGetStructTreeError: onGetStructTreeErrorProps,
            onGetStructTreeSuccess: onGetStructTreeSuccessProps,
            onGetTextError: onGetTextErrorProps,
            onGetTextSuccess: onGetTextSuccessProps,
            onRenderAnnotationLayerError: onRenderAnnotationLayerErrorProps,
            onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccessProps,
            onRenderError: onRenderErrorProps,
            onRenderSuccess: onRenderSuccessProps,
            onRenderTextLayerError: onRenderTextLayerErrorProps,
            onRenderTextLayerSuccess: onRenderTextLayerSuccessProps,
            page: page,
            pageIndex: pageIndex,
            pageNumber: pageNumber,
            renderForms: renderForms,
            renderTextLayer: renderTextLayerProps,
            rotate: rotate,
            scale: scale
        } : null, [
        _className,
        canvasBackground,
        customTextRenderer,
        devicePixelRatio,
        onGetAnnotationsErrorProps,
        onGetAnnotationsSuccessProps,
        onGetStructTreeErrorProps,
        onGetStructTreeSuccessProps,
        onGetTextErrorProps,
        onGetTextSuccessProps,
        onRenderAnnotationLayerErrorProps,
        onRenderAnnotationLayerSuccessProps,
        onRenderErrorProps,
        onRenderSuccessProps,
        onRenderTextLayerErrorProps,
        onRenderTextLayerSuccessProps,
        page,
        pageIndex,
        pageNumber,
        renderForms,
        renderTextLayerProps,
        rotate,
        scale
    ]);
    const eventProps = (0, $6fFrj.useMemo)(()=>(0, $a9af34f79898d35a$export$2e2bcd8739ae039)(otherProps, ()=>page ? scale ? (0, $a890e5e35a863cbf$export$8cc3f6b8d58bdda0)(page, scale) : undefined : page), // biome-ignore lint/correctness/useExhaustiveDependencies: FIXME
    [
        otherProps,
        page,
        scale
    ]);
    const pageKey = `${pageIndex}@${scale}/${rotate}`;
    function renderMainLayer() {
        switch(renderMode){
            case 'custom':
                (0, $60bcf762ed5a0ede$export$2e2bcd8739ae039)(CustomRenderer, `renderMode was set to "custom", but no customRenderer was passed.`);
                return (0, $bb3TF.jsx)(CustomRenderer, {}, `${pageKey}_custom`);
            case 'none':
                return null;
            case 'canvas':
            default:
                return (0, $bb3TF.jsx)((0, $c647397067d6a82c$export$2e2bcd8739ae039), {
                    canvasRef: canvasRef
                }, `${pageKey}_canvas`);
        }
    }
    function renderTextLayer() {
        if (!renderTextLayerProps) return null;
        return (0, $bb3TF.jsx)((0, $3f6a3e2d2b5dc02d$export$2e2bcd8739ae039), {}, `${pageKey}_text`);
    }
    function renderAnnotationLayer() {
        if (!renderAnnotationLayerProps) return null;
        return (0, $bb3TF.jsx)((0, $3823383a2b1e4259$export$2e2bcd8739ae039), {}, `${pageKey}_annotations`);
    }
    function renderChildren() {
        return (0, $bb3TF.jsxs)((0, $3af4f3d8d4c94a77$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: [
                renderMainLayer(),
                renderTextLayer(),
                renderAnnotationLayer(),
                children
            ]
        });
    }
    function renderContent() {
        if (!pageNumber) return (0, $bb3TF.jsx)((0, $caf70c91cbc06108$export$2e2bcd8739ae039), {
            type: "no-data",
            children: typeof noData === 'function' ? noData() : noData
        });
        if (pdf === null || page === undefined || page === null) return (0, $bb3TF.jsx)((0, $caf70c91cbc06108$export$2e2bcd8739ae039), {
            type: "loading",
            children: typeof loading === 'function' ? loading() : loading
        });
        if (pdf === false || page === false) return (0, $bb3TF.jsx)((0, $caf70c91cbc06108$export$2e2bcd8739ae039), {
            type: "error",
            children: typeof error === 'function' ? error() : error
        });
        return renderChildren();
    }
    return (0, $bb3TF.jsx)("div", Object.assign({
        className: (0, $47f64881d26a6a18$export$2e2bcd8739ae039)(_className, className),
        "data-page-number": pageNumber,
        // Assertion is needed for React 18 compatibility
        ref: (0, $2fed736794d80d98$export$2e2bcd8739ae039)(inputRef, pageElement),
        style: {
            ['--scale-factor']: `${scale}`,
            backgroundColor: canvasBackground || 'white',
            position: 'relative',
            minWidth: 'min-content',
            minHeight: 'min-content'
        }
    }, eventProps, {
        children: renderContent()
    }));
}



var $57f193815f39df63$var$ActionType;
(function(ActionType) {
    ActionType[ActionType["INITIAL_STATE"] = 0] = "INITIAL_STATE";
    ActionType[ActionType["E_SIGN_MODAL_OK_BUTTON_CLICK"] = 1] = "E_SIGN_MODAL_OK_BUTTON_CLICK";
    ActionType[ActionType["E_SIGN_MODAL_CONTENT_TAB_ONCHANGE"] = 2] = "E_SIGN_MODAL_CONTENT_TAB_ONCHANGE";
    ActionType[ActionType["E_SIGN_MODAL_CANCEL_BUTTON_CLICK"] = 3] = "E_SIGN_MODAL_CANCEL_BUTTON_CLICK";
    ActionType[ActionType["UPDATE"] = 4] = "UPDATE";
    ActionType[ActionType["RESET_FORM"] = 5] = "RESET_FORM";
})($57f193815f39df63$var$ActionType || ($57f193815f39df63$var$ActionType = {}));
var $57f193815f39df63$export$2e2bcd8739ae039 = $57f193815f39df63$var$ActionType;


const $86ef73c4bf765a2c$var$getInitialStateAction = (payload)=>({
        type: (0, $57f193815f39df63$export$2e2bcd8739ae039).INITIAL_STATE,
        payload: payload
    });
const $86ef73c4bf765a2c$var$getESignModalOKButtonOnClickAction = (payload)=>({
        type: (0, $57f193815f39df63$export$2e2bcd8739ae039).E_SIGN_MODAL_OK_BUTTON_CLICK,
        payload: payload
    });
/**
 * This is called when the tabs inside the modal ( E Signature and Signature Fields ) are clicked.
 * @param payload
 */ const $86ef73c4bf765a2c$var$getESignModalTabOnChangeAction = (payload)=>({
        type: (0, $57f193815f39df63$export$2e2bcd8739ae039).E_SIGN_MODAL_CONTENT_TAB_ONCHANGE,
        payload: payload
    });
const $86ef73c4bf765a2c$var$getESignModalCancelButtonOnClickAction = (payload)=>({
        type: (0, $57f193815f39df63$export$2e2bcd8739ae039).E_SIGN_MODAL_CANCEL_BUTTON_CLICK,
        payload: payload
    });
const $86ef73c4bf765a2c$var$update = (payload)=>({
        type: (0, $57f193815f39df63$export$2e2bcd8739ae039).UPDATE,
        payload: payload
    });
const $86ef73c4bf765a2c$var$resetForm = ()=>({
        type: (0, $57f193815f39df63$export$2e2bcd8739ae039).RESET_FORM
    });
const $86ef73c4bf765a2c$var$actionCreators = {
    getInitialStateAction: $86ef73c4bf765a2c$var$getInitialStateAction,
    getESignModalOKButtonOnClickAction: $86ef73c4bf765a2c$var$getESignModalOKButtonOnClickAction,
    getESignModalTabOnChangeAction: $86ef73c4bf765a2c$var$getESignModalTabOnChangeAction,
    getESignModalCancelButtonOnClickAction: $86ef73c4bf765a2c$var$getESignModalCancelButtonOnClickAction,
    update: $86ef73c4bf765a2c$var$update,
    resetForm: $86ef73c4bf765a2c$var$resetForm
};
var $86ef73c4bf765a2c$export$2e2bcd8739ae039 = $86ef73c4bf765a2c$var$actionCreators;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

var $j5Jox = parcelRequire("j5Jox");
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $e9b58d58dbebfbda$var$getRandomValues;
var $e9b58d58dbebfbda$var$rnds8 = new Uint8Array(16);
function $e9b58d58dbebfbda$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$e9b58d58dbebfbda$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $e9b58d58dbebfbda$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$e9b58d58dbebfbda$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $e9b58d58dbebfbda$var$getRandomValues($e9b58d58dbebfbda$var$rnds8);
}


var $ccccc9425cd83655$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $03f8c3acff2df427$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $ccccc9425cd83655$export$2e2bcd8739ae039).test(uuid);
}
var $03f8c3acff2df427$export$2e2bcd8739ae039 = $03f8c3acff2df427$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $4245c192f85f7659$var$byteToHex = [];
for(var $4245c192f85f7659$var$i = 0; $4245c192f85f7659$var$i < 256; ++$4245c192f85f7659$var$i)$4245c192f85f7659$var$byteToHex.push(($4245c192f85f7659$var$i + 0x100).toString(16).substr(1));
function $4245c192f85f7659$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($4245c192f85f7659$var$byteToHex[arr[offset + 0]] + $4245c192f85f7659$var$byteToHex[arr[offset + 1]] + $4245c192f85f7659$var$byteToHex[arr[offset + 2]] + $4245c192f85f7659$var$byteToHex[arr[offset + 3]] + '-' + $4245c192f85f7659$var$byteToHex[arr[offset + 4]] + $4245c192f85f7659$var$byteToHex[arr[offset + 5]] + '-' + $4245c192f85f7659$var$byteToHex[arr[offset + 6]] + $4245c192f85f7659$var$byteToHex[arr[offset + 7]] + '-' + $4245c192f85f7659$var$byteToHex[arr[offset + 8]] + $4245c192f85f7659$var$byteToHex[arr[offset + 9]] + '-' + $4245c192f85f7659$var$byteToHex[arr[offset + 10]] + $4245c192f85f7659$var$byteToHex[arr[offset + 11]] + $4245c192f85f7659$var$byteToHex[arr[offset + 12]] + $4245c192f85f7659$var$byteToHex[arr[offset + 13]] + $4245c192f85f7659$var$byteToHex[arr[offset + 14]] + $4245c192f85f7659$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $03f8c3acff2df427$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $4245c192f85f7659$export$2e2bcd8739ae039 = $4245c192f85f7659$var$stringify;


function $d9fa1eeee74e23fa$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $e9b58d58dbebfbda$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $4245c192f85f7659$export$2e2bcd8739ae039)(rnds);
}
var $d9fa1eeee74e23fa$export$2e2bcd8739ae039 = $d9fa1eeee74e23fa$var$v4;




var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $6Sgv0 = parcelRequire("6Sgv0");




const { Text: $6bac5a0601db1ee7$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { DeleteTwoTone: $6bac5a0601db1ee7$var$DeleteTwoTone, CalendarTwoTone: $6bac5a0601db1ee7$var$CalendarTwoTone, DragOutlined: $6bac5a0601db1ee7$var$DragOutlined, EditTwoTone: $6bac5a0601db1ee7$var$EditTwoTone } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Option: $6bac5a0601db1ee7$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const $6bac5a0601db1ee7$var$SignatureFieldPostDropped = ({ id: id, fieldType: fieldType, left: left, top: top, componentName: componentName, index: index = 0, deleteSignatureFieldButtonOnClick: deleteSignatureFieldButtonOnClick, updateSigner: updateSigner, updateTitle: updateTitle, signersArray: signersArray, title: title, description: description, signerId: signerId, signatureImage: signatureImage, fileApprovalId: fileApprovalId, completedAt: completedAt })=>{
    const [signatureURL, setSignatureURL] = (0, $6fFrj.useState)('');
    const [urlS3File] = (0, $edf372aa0dea9531$export$4747d4e17950f93f)();
    const getSignatureURL = async (s3Key)=>{
        const { data: data } = await urlS3File({
            variables: {
                s3Key: s3Key
            }
        });
        setSignatureURL(data?.downloadFile?.signedUrl);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (signatureImage) getSignatureURL(signatureImage);
    }, [
        signatureImage
    ]);
    (0, $6fFrj.useEffect)(()=>{
        // if only one file approver (signer), set them as the selected value right away
        if (signersArray?.length === 1 && signerId !== signersArray[0].key) updateSigner(id, signersArray[0].key);
    }, [
        signersArray
    ]);
    // this is for dragging an already placed field
    const [, drag] = (0, $da77e72f9345f56b$export$7941f8aafa4b6021)(()=>({
            type: 'SIGNATURE_BOUNDARY_FIELD',
            item: {
                fieldType: fieldType,
                componentName: componentName,
                index: index,
                left: left,
                top: top,
                id: id,
                signerId: signerId,
                signatureImage: signatureImage,
                fileApprovalId: fileApprovalId,
                completedAt: completedAt
            },
            end: (item, monitor)=>{
                const dropResult = monitor.getDropResult();
                item && dropResult;
            },
            collect: (monitor)=>({
                    isDragging: monitor.isDragging()
                })
        }), [
        fieldType,
        componentName,
        index,
        left,
        top,
        id
    ]);
    const getPopoverContent = ()=>(0, $bb3TF.jsxs)("div", {
            children: [
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "space-between",
                    align: "middle",
                    children: [
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            style: {
                                width: '100px'
                            },
                            children: "Select Client:"
                        }),
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                size: "small",
                                defaultValue: signerId,
                                onChange: (sid)=>updateSigner(id, sid),
                                onSelect: (sid)=>updateSigner(id, sid),
                                style: {
                                    width: '200px',
                                    marginLeft: '5px'
                                },
                                disabled: completedAt,
                                children: signersArray.map((x)=>(0, $bb3TF.jsx)($6bac5a0601db1ee7$var$Option, {
                                        value: x.key,
                                        children: x.name
                                    }, `${id}-${x.key}`))
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: completedAt ? null : (0, $bb3TF.jsx)((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                                style: {
                                    marginLeft: '5px'
                                },
                                icon: (0, $bb3TF.jsx)($6bac5a0601db1ee7$var$DeleteTwoTone, {
                                    onClick: ()=>{
                                        deleteSignatureFieldButtonOnClick(index);
                                    }
                                }),
                                title: "Remove field"
                            })
                        })
                    ]
                }),
                fieldType === (0, $8f7fe33a44836803$export$ed12481c953b8653).Text && (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "start",
                    align: "middle",
                    style: {
                        marginTop: '5px'
                    },
                    children: [
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            style: {
                                width: '100px'
                            },
                            children: "Field Label:"
                        }),
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                size: "small",
                                style: {
                                    width: '200px',
                                    marginLeft: '5px'
                                },
                                defaultValue: title,
                                disabled: completedAt,
                                onChange: (e)=>updateTitle(id, e.target.value)
                            })
                        })
                    ]
                })
            ]
        });
    const currentSignerName = signersArray.find((s)=>s.key === signerId)?.name || '';
    const style = {
        border: currentSignerName ? '1px dashed gray' : '1px dotted #f34',
        backgroundColor: completedAt ? '#ddd' : 'gold',
        width: '250px',
        height: '32px',
        position: 'absolute',
        zIndex: 1,
        fontSize: 'medium',
        padding: signatureImage ? 0 : '6px 0 0 12px'
    };
    return (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
        placement: "top",
        content: getPopoverContent,
        children: (0, $bb3TF.jsxs)((0, $3c2758025c182ca4$export$2e2bcd8739ae039), {
            ref: completedAt ? null : drag,
            style: {
                ...style,
                left: left,
                top: top
            },
            children: [
                completedAt ? null : (0, $bb3TF.jsx)($6bac5a0601db1ee7$var$DragOutlined, {
                    style: {
                        position: 'absolute',
                        left: -6,
                        top: -6,
                        background: 'white',
                        borderRadius: '35%',
                        border: '1px dotted gray',
                        cursor: 'move'
                    }
                }),
                signatureImage && (0, $bb3TF.jsx)("img", {
                    src: signatureURL,
                    width: "250",
                    height: "32",
                    alt: "signature"
                }),
                !signatureImage && fieldType === (0, $8f7fe33a44836803$export$ed12481c953b8653).Signature && (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    style: {
                        flexFlow: 'nowrap'
                    },
                    children: [
                        (0, $bb3TF.jsx)((0, $cbc5b365d3ac7b18$export$2e2bcd8739ae039), {
                            style: {
                                height: '20px',
                                width: '20px',
                                minWidth: '20px',
                                marginRight: '7px',
                                fill: '#1890ff'
                            }
                        }),
                        (0, $bb3TF.jsx)($6bac5a0601db1ee7$var$Text, {
                            ellipsis: true,
                            style: {
                                color: '#1890ff'
                            },
                            children: currentSignerName ? `SIGNATURE - ${currentSignerName}` : 'SIGNATURE'
                        })
                    ]
                }),
                fieldType === (0, $8f7fe33a44836803$export$ed12481c953b8653).Date && (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    style: {
                        flexFlow: 'nowrap'
                    },
                    children: [
                        (0, $bb3TF.jsx)($6bac5a0601db1ee7$var$CalendarTwoTone, {
                            style: {
                                height: '16px',
                                width: '16px',
                                minWidth: '16px',
                                marginRight: '7px',
                                fill: '#1890ff'
                            }
                        }),
                        (0, $bb3TF.jsx)($6bac5a0601db1ee7$var$Text, {
                            ellipsis: true,
                            style: {
                                color: '#1890ff'
                            },
                            children: completedAt ? (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0))).utc(completedAt).format('MM/DD/YYYY') : `DATE ${currentSignerName ? ` - ${currentSignerName}` : ''}`
                        })
                    ]
                }),
                fieldType === (0, $8f7fe33a44836803$export$ed12481c953b8653).Text && (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    style: {
                        flexFlow: 'nowrap'
                    },
                    children: [
                        (0, $bb3TF.jsx)($6bac5a0601db1ee7$var$EditTwoTone, {
                            style: {
                                height: '16px',
                                width: '16px',
                                minWidth: '16px',
                                marginRight: '7px',
                                fill: '#1890ff'
                            }
                        }),
                        (0, $bb3TF.jsx)($6bac5a0601db1ee7$var$Text, {
                            ellipsis: true,
                            style: {
                                color: '#1890ff'
                            },
                            children: // eslint-disable-next-line no-nested-ternary
                            completedAt ? description : title ? `${title} ${currentSignerName ? ` - ${currentSignerName}` : ''}` : `TEXT ${currentSignerName ? ` - ${currentSignerName}` : ''}`
                        })
                    ]
                })
            ]
        })
    });
};
$6bac5a0601db1ee7$var$SignatureFieldPostDropped.defaultProps = {
    index: 0
};
var $6bac5a0601db1ee7$export$2e2bcd8739ae039 = $6bac5a0601db1ee7$var$SignatureFieldPostDropped;



const $1db5094c05ede50a$var$DroppableContainer = ({ children: children, className: className, thisPage: thisPage, state: state, dispatch: dispatch, signersArray: signersArray })=>{
    const ref = (0, $6fFrj.useRef)();
    const addDraggableSignatureField = (signatureField)=>{
        // eslint-disable-next-line no-param-reassign
        signatureField.id = (0, $d9fa1eeee74e23fa$export$2e2bcd8739ae039)();
        dispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).update({
            newDraggableBoundarySignFields: [
                ...state.newDraggableBoundarySignFields,
                signatureField
            ]
        }));
    };
    const moveBox = (0, $6fFrj.useCallback)((signatureField)=>{
        const index = signatureField.index ?? 0;
        const newCollection = (0, (/*@__PURE__*/$parcel$interopDefault($j5Jox)))(state.newDraggableBoundarySignFields, {
            [index]: {
                $set: {
                    ...signatureField
                }
            }
        });
        dispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).update({
            newDraggableBoundarySignFields: newCollection
        }));
    }, [
        state.newDraggableBoundarySignFields,
        dispatch
    ]);
    const updateSigner = (signatureFieldId, signerId)=>{
        const copyOfNewDraggableBoundarySignFields = [
            ...state.newDraggableBoundarySignFields
        ];
        const index = copyOfNewDraggableBoundarySignFields.findIndex((v)=>v.id === signatureFieldId);
        copyOfNewDraggableBoundarySignFields[index].signerId = signerId;
        dispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).update({
            newDraggableBoundarySignFields: [
                ...copyOfNewDraggableBoundarySignFields
            ]
        }));
    };
    const updateTitle = (signatureFieldId, title)=>{
        const copyOfNewDraggableBoundarySignFields = [
            ...state.newDraggableBoundarySignFields
        ];
        const index = copyOfNewDraggableBoundarySignFields.findIndex((v)=>v.id === signatureFieldId);
        copyOfNewDraggableBoundarySignFields[index].title = title;
        // console.log('updateTitle - copyOfNewDraggableBoundarySignFields:', copyOfNewDraggableBoundarySignFields);
        dispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).update({
            newDraggableBoundarySignFields: [
                ...copyOfNewDraggableBoundarySignFields
            ]
        }));
    };
    const [, drop] = (0, $985e950531ae07dc$export$ccdee5eaf73cf661)(()=>({
            accept: [
                'SIGNATURE_FIELD',
                'SIGNATURE_BOUNDARY_FIELD'
            ],
            drop (item, monitor) {
                const { index: index, id: id, email: email, fieldType: fieldType, fileApprovalId: fileApprovalId, signatureImage: signatureImage, completedAt: completedAt, signerId: signerId } = item;
                // console.log('fieldType:', fieldType);
                const offset = monitor.getSourceClientOffset();
                const dropTargetXy = ref.current.getBoundingClientRect();
                const left = offset.x - dropTargetXy.left;
                const top = offset.y - dropTargetXy.top;
                const signatureField = {
                    id: id,
                    email: email,
                    index: index,
                    left: left,
                    top: top,
                    page: thisPage,
                    fieldLeftPercentage: left / dropTargetXy.width * 100,
                    fieldTopPercentage: top / dropTargetXy.height * 100,
                    fieldWidthPercentage: 250 / dropTargetXy.width * 100,
                    fieldHeightPercentage: 32 / dropTargetXy.height * 100,
                    fieldType: fieldType,
                    fileApprovalId: fileApprovalId,
                    signatureImage: signatureImage,
                    completedAt: completedAt,
                    signerId: signerId
                };
                if (id) moveBox(signatureField);
                else if (offset && ref.current) addDraggableSignatureField(signatureField);
                return {
                    fieldType: fieldType,
                    left: left,
                    top: top,
                    index: index,
                    id: id,
                    fileApprovalId: fileApprovalId,
                    signatureImage: signatureImage,
                    completedAt: completedAt,
                    signerId: signerId
                };
            },
            collect: (monitor)=>({
                    isOver: monitor.isOver(),
                    canDrop: monitor.canDrop()
                })
        }), [
        moveBox,
        addDraggableSignatureField,
        thisPage
    ]);
    const deleteSignatureFieldButtonOnClick = (index)=>{
        // const removedUpdatedSignatureFileds = newDraggableBoundarySignFields.splice(index + 1, 1);
        const removedUpdatedSignatureFileds = state.newDraggableBoundarySignFields.filter((_, i)=>i !== index);
        // console.log('removedUpdatedSignatureFileds: ', removedUpdatedSignatureFileds, 'index: ', index);
        dispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).update({
            newDraggableBoundarySignFields: removedUpdatedSignatureFileds
        }));
    };
    // console.log('state.newDraggableBoundarySignFields, fileApprovals', state.newDraggableBoundarySignFields, fileApprovals);
    return (0, $bb3TF.jsx)("div", {
        ref: ref,
        style: {
            position: 'relative',
            display: 'block'
        },
        children: (0, $bb3TF.jsxs)("div", {
            ref: drop,
            className: className,
            style: {
                position: 'relative',
                display: 'block',
                border: '1px solid black',
                marginRight: 30
            },
            children: [
                state.newDraggableBoundarySignFields.map((field, index)=>{
                    const { id: id, fieldType: fieldType, left: left, top: top, page: page, title: title, signerId: signerId, signatureImage: signatureImage, fileApprovalId: fileApprovalId, completedAt: completedAt, description: description } = field;
                    if (thisPage === page) return (0, $bb3TF.jsx)((0, $6bac5a0601db1ee7$export$2e2bcd8739ae039), {
                        id: id,
                        deleteSignatureFieldButtonOnClick: deleteSignatureFieldButtonOnClick,
                        updateSigner: updateSigner,
                        updateTitle: updateTitle,
                        index: index,
                        componentName: "SignatureFieldPostDropped",
                        left: left,
                        top: top,
                        fieldType: fieldType,
                        signersArray: signersArray,
                        title: title,
                        description: description,
                        signerId: signerId,
                        signatureImage: signatureImage,
                        fileApprovalId: fileApprovalId,
                        completedAt: completedAt
                    }, `${signerId}-${index}`);
                    return null;
                }),
                children
            ]
        })
    });
};
var $1db5094c05ede50a$export$2e2bcd8739ae039 = $1db5094c05ede50a$var$DroppableContainer;



var $0cae0b28227cb83e$exports = {};

$0cae0b28227cb83e$exports = (parcelRequire("jN93C")).getBundleURL('a0IFD') + "pdf.worker.min.6e91ecaa.js";


(0, $cca4aceb320d03d3$exports).GlobalWorkerOptions.workerSrc = new URL($0cae0b28227cb83e$exports).toString();
// const pdfFile = 'https://raw.githubusercontent.com/wojtekmaj/react-pdf/main/sample/parcel2/sample.pdf';
const $0189d784466574b1$var$options = {
    cMapUrl: 'cmaps/',
    cMapPacked: true,
    standardFontDataUrl: 'standard_fonts/'
};
const $0189d784466574b1$var$SignatureDocSignAreaDroppable = ({ state: state, dispatch: dispatch, form: form, editMode: editMode, setSignatureFieldsCompleted: setSignatureFieldsCompleted, isCompiledFileUpdated: isCompiledFileUpdated })=>{
    const ref = (0, $6fFrj.useRef)();
    const finalValues = form.getFieldsValue(true);
    const { compiledFile: compiledFile, currentActiveTab: currentActiveTab } = state;
    const [numPages, setNumPages] = (0, $6fFrj.useState)(null);
    const [fileWidth, setFileWidth] = (0, $6fFrj.useState)(null);
    const [fileHeight, setFileHeight] = (0, $6fFrj.useState)(null);
    const [pageViewports, setPageViewports] = (0, $6fFrj.useState)([]);
    const [signersArray, setSignersArray] = (0, $6fFrj.useState)([]);
    const [documentRect, setDocumentRect] = (0, $6fFrj.useState)({
        width: 0,
        height: 0
    });
    (0, $6fFrj.useEffect)(()=>{
        if (currentActiveTab === '2') {
            if (ref.current) {
                const { width: width, height: height } = ref.current.getBoundingClientRect();
                if (width && height) setDocumentRect({
                    width: width,
                    height: height
                });
            }
        }
    }, [
        currentActiveTab,
        fileWidth,
        fileHeight,
        pageViewports
    ]);
    (0, $6fFrj.useEffect)(()=>{
        const signers = [];
        // eslint-disable-next-line no-restricted-syntax
        for(const key in finalValues)// eslint-disable-next-line no-prototype-builtins
        if (finalValues.hasOwnProperty(key)) {
            const element = finalValues[key];
            if (key.substring(0, 9) === 'signerKBA' && element.signatureKBAType) signers.push({
                key: key,
                email: element.signerEmail,
                name: element.signerName
            });
        }
        setSignersArray(signers);
    }, [
        finalValues
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (editMode) {
            // if compiled file was changed - do not restore existing fields
            if (isCompiledFileUpdated) {
                dispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).update({
                    newDraggableBoundarySignFields: []
                }));
                return;
            }
            if (!numPages || pageViewports.length < numPages || !documentRect.width) return;
            const singatureFields = [];
            state.fileRequest?.FileApproval?.forEach((fa)=>{
                const signer = signersArray.find((s)=>s.email === fa.email || s.name === fa.name);
                if (signer) fa?.SignatureFields.forEach((field)=>{
                    const pageViewport = pageViewports[field.page - 1];
                    const scale = documentRect.width / pageViewport.width;
                    const actualHeight = fileHeight * scale;
                    singatureFields.push({
                        id: field.id,
                        fieldType: field.fieldType,
                        left: field.fieldLeftPercentage / 100 * documentRect.width,
                        width: field.fieldWidthPercentage / 100 * documentRect.width,
                        top: field.fieldTopPercentage / 100 * actualHeight - 20,
                        height: field.fieldHeightPercentage / 100 * actualHeight - 20,
                        fieldLeftPercentage: field.fieldLeftPercentage,
                        fieldTopPercentage: field.fieldTopPercentage,
                        fieldWidthPercentage: field.fieldWidthPercentage,
                        fieldHeightPercentage: field.fieldHeightPercentage,
                        page: field.page,
                        title: field.title,
                        email: signer.email,
                        signerId: signer.key,
                        fileApprovalId: fa.id,
                        signatureImage: field.signatureImage,
                        completedAt: field.completedAt,
                        description: field.description
                    });
                });
            });
            dispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).update({
                newDraggableBoundarySignFields: singatureFields
            }));
        }
    }, [
        signersArray,
        isCompiledFileUpdated,
        documentRect,
        pageViewports
    ]);
    // this useDrop is for changing the background color of the signature area (if we want to)
    const [{ canDrop: canDrop, isOver: isOver }, drop] = (0, $985e950531ae07dc$export$ccdee5eaf73cf661)(()=>({
            accept: [
                'SIGNATURE_FIELD',
                'SIGNATURE_BOUNDARY_FIELD'
            ],
            collect: (monitor)=>({
                    isOver: monitor.isOver(),
                    canDrop: monitor.canDrop()
                })
        }), []);
    (0, $6fFrj.useEffect)(()=>{
        if (state.newDraggableBoundarySignFields?.filter((f)=>f.fieldType === 'SIGNATURE')?.length >= signersArray.length && state.newDraggableBoundarySignFields.every((field)=>field.signerId)) setSignatureFieldsCompleted(true);
        else setSignatureFieldsCompleted(false);
    }, [
        state.newDraggableBoundarySignFields
    ]);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const onDocumentLoadSuccess = async (pdf)=>{
        setNumPages(pdf.numPages);
        const firstPage = await pdf.getPage(1);
        setFileWidth(firstPage.view[2]);
        setFileHeight(firstPage.view[3]);
        const pageNumbers = Array.from(new Array(pdf.numPages)).map((_, index)=>index + 1);
        pageNumbers.forEach(async (pageNumber)=>{
            const page = await pdf.getPage(pageNumber);
            setPageViewports((oldVal)=>[
                    ...oldVal,
                    page.getViewport({
                        scale: 1
                    })
                ]);
        });
    };
    const onLoadError = (error)=>{
        console.log('loading error:', error);
    };
    if (!compiledFile) return (0, $bb3TF.jsx)("div", {
        children: "loading..."
    });
    return (0, $bb3TF.jsx)("div", {
        ref: ref,
        style: {
            padding: 0,
            margin: 0
        },
        children: (0, $bb3TF.jsx)((0, $f6e5f053c4705103$export$2e2bcd8739ae039), {
            file: compiledFile,
            onLoadSuccess: onDocumentLoadSuccess,
            options: $0189d784466574b1$var$options,
            onLoadError: onLoadError,
            children: Array.from(new Array(numPages), (_el, index)=>(0, $bb3TF.jsx)((0, $1db5094c05ede50a$export$2e2bcd8739ae039), {
                    className: "droppable-container",
                    thisPage: index + 1,
                    state: state,
                    dispatch: dispatch,
                    signersArray: signersArray,
                    children: (0, $bb3TF.jsx)("div", {
                        id: `page_${index + 1}`,
                        className: "page-wrapper",
                        "data-page": index + 1,
                        children: (0, $bb3TF.jsx)((0, $1c5d9cfe7d7f1094$export$2e2bcd8739ae039), {
                            pageNumber: index + 1,
                            renderTextLayer: false
                        })
                    })
                }, `page_${index + 1}`))
        })
    });
};
var $0189d784466574b1$export$2e2bcd8739ae039 = $0189d784466574b1$var$SignatureDocSignAreaDroppable;


var $ef009005735b1228$export$bfde8d7c40366e26;
$ef009005735b1228$export$bfde8d7c40366e26 = `BRRRRG_signatureDocSignArea`;


const $c2bde4dc1fe96b39$var$SignatureFields = ({ dispatch: dispatch, state: state, form: form, editMode: editMode, setSignatureFieldsCompleted: setSignatureFieldsCompleted, isCompiledFileUpdated: isCompiledFileUpdated })=>(0, $bb3TF.jsx)((0, $0fe3e251a617b179$export$9861489d68213f9c), {
        backend: (0, $5091b83b199b6305$export$f4f61d779bb20744),
        children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            children: [
                (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    span: 4,
                    style: {
                        paddingRight: 10,
                        paddingTop: 10
                    },
                    children: (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                        style: {
                            backgroundColor: 'aliceblue'
                        },
                        title: "Fields",
                        bordered: false,
                        children: [
                            (0, $bb3TF.jsx)((0, $6c753d928d69d6c7$export$2e2bcd8739ae039), {
                                name: "Signature",
                                fieldType: (0, $8f7fe33a44836803$export$ed12481c953b8653).Signature
                            }),
                            (0, $bb3TF.jsx)((0, $6c753d928d69d6c7$export$2e2bcd8739ae039), {
                                name: "Date",
                                fieldType: (0, $8f7fe33a44836803$export$ed12481c953b8653).Date
                            }),
                            (0, $bb3TF.jsx)((0, $6c753d928d69d6c7$export$2e2bcd8739ae039), {
                                name: "Text",
                                fieldType: (0, $8f7fe33a44836803$export$ed12481c953b8653).Text
                            })
                        ]
                    })
                }),
                (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    span: 20,
                    className: $ef009005735b1228$export$bfde8d7c40366e26,
                    children: (0, $bb3TF.jsx)((0, $0189d784466574b1$export$2e2bcd8739ae039), {
                        state: state,
                        dispatch: dispatch,
                        form: form,
                        editMode: editMode,
                        setSignatureFieldsCompleted: setSignatureFieldsCompleted,
                        isCompiledFileUpdated: isCompiledFileUpdated
                    })
                })
            ]
        })
    });
var $c2bde4dc1fe96b39$export$2e2bcd8739ae039 = $c2bde4dc1fe96b39$var$SignatureFields;




var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

var $cea714d4b81be3c5$exports = {};
var $2099fdff5c01c024$exports = {};
$parcel$export($2099fdff5c01c024$exports, "PDFDocument", function () { return $d524d17d41c918dc$export$2e2bcd8739ae039; });

var $47XJ3 = parcelRequire("47XJ3");

var $47XJ3 = parcelRequire("47XJ3");
parcelRequire("6AcCU");

var $90Qf4 = parcelRequire("90Qf4");

var $47XJ3 = parcelRequire("47XJ3");

var $hjofF = parcelRequire("hjofF");

var $90Qf4 = parcelRequire("90Qf4");
parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
var $ba9da13d8e8ae04e$var$PDFHeader = /** @class */ function() {
    function PDFHeader(major, minor) {
        this.major = String(major);
        this.minor = String(minor);
    }
    PDFHeader.prototype.toString = function() {
        var bc = (0, $8ZzAZ.charFromCode)(129);
        return "%PDF-" + this.major + "." + this.minor + "\n%" + bc + bc + bc + bc;
    };
    PDFHeader.prototype.sizeInBytes = function() {
        return 12 + this.major.length + this.minor.length;
    };
    PDFHeader.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $90Qf4.default).Percent;
        buffer[offset++] = (0, $90Qf4.default).P;
        buffer[offset++] = (0, $90Qf4.default).D;
        buffer[offset++] = (0, $90Qf4.default).F;
        buffer[offset++] = (0, $90Qf4.default).Dash;
        offset += (0, $8ZzAZ.copyStringIntoBuffer)(this.major, buffer, offset);
        buffer[offset++] = (0, $90Qf4.default).Period;
        offset += (0, $8ZzAZ.copyStringIntoBuffer)(this.minor, buffer, offset);
        buffer[offset++] = (0, $90Qf4.default).Newline;
        buffer[offset++] = (0, $90Qf4.default).Percent;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        return offset - initialOffset;
    };
    PDFHeader.forVersion = function(major, minor) {
        return new PDFHeader(major, minor);
    };
    return PDFHeader;
}();
var $ba9da13d8e8ae04e$export$2e2bcd8739ae039 = $ba9da13d8e8ae04e$var$PDFHeader;



var $6AcCU = parcelRequire("6AcCU");

var $6IKEk = parcelRequire("6IKEk");

var $HB3Cf = parcelRequire("HB3Cf");

var $47XJ3 = parcelRequire("47XJ3");

var $2npvA = parcelRequire("2npvA");

var $47XJ3 = parcelRequire("47XJ3");

var $l0PqT = parcelRequire("l0PqT");

var $90Qf4 = parcelRequire("90Qf4");
var $9aaf0b887d65bd59$var$PDFNull = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFNull, _super);
    function PDFNull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFNull.prototype.asNull = function() {
        return null;
    };
    PDFNull.prototype.clone = function() {
        return this;
    };
    PDFNull.prototype.toString = function() {
        return 'null';
    };
    PDFNull.prototype.sizeInBytes = function() {
        return 4;
    };
    PDFNull.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $90Qf4.default).n;
        buffer[offset++] = (0, $90Qf4.default).u;
        buffer[offset++] = (0, $90Qf4.default).l;
        buffer[offset++] = (0, $90Qf4.default).l;
        return 4;
    };
    return PDFNull;
}((0, $l0PqT.default));
var $9aaf0b887d65bd59$export$2e2bcd8739ae039 = new $9aaf0b887d65bd59$var$PDFNull();



var $l0PqT = parcelRequire("l0PqT");

var $90Qf4 = parcelRequire("90Qf4");
var $74b515754dab46b0$var$PDFDict = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFDict, _super);
    function PDFDict(map, context) {
        var _this = _super.call(this) || this;
        _this.dict = map;
        _this.context = context;
        return _this;
    }
    PDFDict.prototype.keys = function() {
        return Array.from(this.dict.keys());
    };
    PDFDict.prototype.values = function() {
        return Array.from(this.dict.values());
    };
    PDFDict.prototype.entries = function() {
        return Array.from(this.dict.entries());
    };
    PDFDict.prototype.set = function(key, value) {
        this.dict.set(key, value);
    };
    PDFDict.prototype.get = function(key, // TODO: `preservePDFNull` is for backwards compatibility. Should be
    // removed in next breaking API change.
    preservePDFNull) {
        if (preservePDFNull === void 0) preservePDFNull = false;
        var value = this.dict.get(key);
        if (value === (0, $9aaf0b887d65bd59$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.has = function(key) {
        var value = this.dict.get(key);
        return value !== undefined && value !== (0, $9aaf0b887d65bd59$export$2e2bcd8739ae039);
    };
    PDFDict.prototype.lookupMaybe = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $9aaf0b887d65bd59$export$2e2bcd8739ae039));
        var value = (_a = this.context).lookupMaybe.apply(_a, (0, $47XJ3.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $9aaf0b887d65bd59$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.lookup = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $9aaf0b887d65bd59$export$2e2bcd8739ae039));
        var value = (_a = this.context).lookup.apply(_a, (0, $47XJ3.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $9aaf0b887d65bd59$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.delete = function(key) {
        return this.dict.delete(key);
    };
    PDFDict.prototype.asMap = function() {
        return new Map(this.dict);
    };
    /** Generate a random key that doesn't exist in current key set */ PDFDict.prototype.uniqueKey = function(tag) {
        if (tag === void 0) tag = '';
        var existingKeys = this.keys();
        var key = (0, $2npvA.default).of(this.context.addRandomSuffix(tag, 10));
        while(existingKeys.includes(key))key = (0, $2npvA.default).of(this.context.addRandomSuffix(tag, 10));
        return key;
    };
    PDFDict.prototype.clone = function(context) {
        var clone = PDFDict.withContext(context || this.context);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFDict.prototype.toString = function() {
        var dictString = '<<\n';
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            dictString += key.toString() + ' ' + value.toString() + '\n';
        }
        dictString += '>>';
        return dictString;
    };
    PDFDict.prototype.sizeInBytes = function() {
        var size = 5;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            size += key.sizeInBytes() + value.sizeInBytes() + 2;
        }
        return size;
    };
    PDFDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $90Qf4.default).LessThan;
        buffer[offset++] = (0, $90Qf4.default).LessThan;
        buffer[offset++] = (0, $90Qf4.default).Newline;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            offset += key.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $90Qf4.default).Space;
            offset += value.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $90Qf4.default).Newline;
        }
        buffer[offset++] = (0, $90Qf4.default).GreaterThan;
        buffer[offset++] = (0, $90Qf4.default).GreaterThan;
        return offset - initialOffset;
    };
    PDFDict.withContext = function(context) {
        return new PDFDict(new Map(), context);
    };
    PDFDict.fromMapWithContext = function(map, context) {
        return new PDFDict(map, context);
    };
    return PDFDict;
}((0, $l0PqT.default));
var $74b515754dab46b0$export$2e2bcd8739ae039 = $74b515754dab46b0$var$PDFDict;



var $2npvA = parcelRequire("2npvA");


var $dKRgb = parcelRequire("dKRgb");

var $l0PqT = parcelRequire("l0PqT");

var $47XJ3 = parcelRequire("47XJ3");

var $47XJ3 = parcelRequire("47XJ3");

var $6AcCU = parcelRequire("6AcCU");

var $2npvA = parcelRequire("2npvA");

var $dKRgb = parcelRequire("dKRgb");

var $l0PqT = parcelRequire("l0PqT");

var $90Qf4 = parcelRequire("90Qf4");
var $1b80b011925bffc2$var$PDFStream = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFStream, _super);
    function PDFStream(dict) {
        var _this = _super.call(this) || this;
        _this.dict = dict;
        return _this;
    }
    PDFStream.prototype.clone = function(_context) {
        throw new (0, $6AcCU.MethodNotImplementedError)(this.constructor.name, 'clone');
    };
    PDFStream.prototype.getContentsString = function() {
        throw new (0, $6AcCU.MethodNotImplementedError)(this.constructor.name, 'getContentsString');
    };
    PDFStream.prototype.getContents = function() {
        throw new (0, $6AcCU.MethodNotImplementedError)(this.constructor.name, 'getContents');
    };
    PDFStream.prototype.getContentsSize = function() {
        throw new (0, $6AcCU.MethodNotImplementedError)(this.constructor.name, 'getContentsSize');
    };
    PDFStream.prototype.updateDict = function() {
        var contentsSize = this.getContentsSize();
        this.dict.set((0, $2npvA.default).Length, (0, $dKRgb.default).of(contentsSize));
    };
    PDFStream.prototype.sizeInBytes = function() {
        this.updateDict();
        return this.dict.sizeInBytes() + this.getContentsSize() + 18;
    };
    PDFStream.prototype.toString = function() {
        this.updateDict();
        var streamString = this.dict.toString();
        streamString += '\nstream\n';
        streamString += this.getContentsString();
        streamString += '\nendstream';
        return streamString;
    };
    PDFStream.prototype.copyBytesInto = function(buffer, offset) {
        this.updateDict();
        var initialOffset = offset;
        offset += this.dict.copyBytesInto(buffer, offset);
        buffer[offset++] = (0, $90Qf4.default).Newline;
        buffer[offset++] = (0, $90Qf4.default).s;
        buffer[offset++] = (0, $90Qf4.default).t;
        buffer[offset++] = (0, $90Qf4.default).r;
        buffer[offset++] = (0, $90Qf4.default).e;
        buffer[offset++] = (0, $90Qf4.default).a;
        buffer[offset++] = (0, $90Qf4.default).m;
        buffer[offset++] = (0, $90Qf4.default).Newline;
        var contents = this.getContents();
        for(var idx = 0, len = contents.length; idx < len; idx++)buffer[offset++] = contents[idx];
        buffer[offset++] = (0, $90Qf4.default).Newline;
        buffer[offset++] = (0, $90Qf4.default).e;
        buffer[offset++] = (0, $90Qf4.default).n;
        buffer[offset++] = (0, $90Qf4.default).d;
        buffer[offset++] = (0, $90Qf4.default).s;
        buffer[offset++] = (0, $90Qf4.default).t;
        buffer[offset++] = (0, $90Qf4.default).r;
        buffer[offset++] = (0, $90Qf4.default).e;
        buffer[offset++] = (0, $90Qf4.default).a;
        buffer[offset++] = (0, $90Qf4.default).m;
        return offset - initialOffset;
    };
    return PDFStream;
}((0, $l0PqT.default));
var $1b80b011925bffc2$export$2e2bcd8739ae039 = $1b80b011925bffc2$var$PDFStream;


parcelRequire("5w6hV");
var $4LYfy = parcelRequire("4LYfy");
var $9d0105b76c83b6a6$var$PDFRawStream = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFRawStream, _super);
    function PDFRawStream(dict, contents) {
        var _this = _super.call(this, dict) || this;
        _this.contents = contents;
        return _this;
    }
    PDFRawStream.prototype.asUint8Array = function() {
        return this.contents.slice();
    };
    PDFRawStream.prototype.clone = function(context) {
        return PDFRawStream.of(this.dict.clone(context), this.contents.slice());
    };
    PDFRawStream.prototype.getContentsString = function() {
        return (0, $4LYfy.arrayAsString)(this.contents);
    };
    PDFRawStream.prototype.getContents = function() {
        return this.contents;
    };
    PDFRawStream.prototype.getContentsSize = function() {
        return this.contents.length;
    };
    PDFRawStream.of = function(dict, contents) {
        return new PDFRawStream(dict, contents);
    };
    return PDFRawStream;
}((0, $1b80b011925bffc2$export$2e2bcd8739ae039));
var $9d0105b76c83b6a6$export$2e2bcd8739ae039 = $9d0105b76c83b6a6$var$PDFRawStream;



var $47XJ3 = parcelRequire("47XJ3");

var $6AcCU = parcelRequire("6AcCU");

var $l0PqT = parcelRequire("l0PqT");
parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
var $dac7b6b491336f5d$var$ENFORCER = {};
var $dac7b6b491336f5d$var$pool = new Map();
var $dac7b6b491336f5d$var$PDFRef = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFRef, _super);
    function PDFRef(enforcer, objectNumber, generationNumber) {
        var _this = this;
        if (enforcer !== $dac7b6b491336f5d$var$ENFORCER) throw new (0, $6AcCU.PrivateConstructorError)('PDFRef');
        _this = _super.call(this) || this;
        _this.objectNumber = objectNumber;
        _this.generationNumber = generationNumber;
        _this.tag = objectNumber + " " + generationNumber + " R";
        return _this;
    }
    PDFRef.prototype.clone = function() {
        return this;
    };
    PDFRef.prototype.toString = function() {
        return this.tag;
    };
    PDFRef.prototype.sizeInBytes = function() {
        return this.tag.length;
    };
    PDFRef.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $8ZzAZ.copyStringIntoBuffer)(this.tag, buffer, offset);
        return this.tag.length;
    };
    PDFRef.of = function(objectNumber, generationNumber) {
        if (generationNumber === void 0) generationNumber = 0;
        var tag = objectNumber + " " + generationNumber + " R";
        var instance = $dac7b6b491336f5d$var$pool.get(tag);
        if (!instance) {
            instance = new PDFRef($dac7b6b491336f5d$var$ENFORCER, objectNumber, generationNumber);
            $dac7b6b491336f5d$var$pool.set(tag, instance);
        }
        return instance;
    };
    return PDFRef;
}((0, $l0PqT.default));
var $dac7b6b491336f5d$export$2e2bcd8739ae039 = $dac7b6b491336f5d$var$PDFRef;



var $l0PqT = parcelRequire("l0PqT");

var $90Qf4 = parcelRequire("90Qf4");
parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
var $d7f4913eaa91561c$var$PDFOperator = /** @class */ function() {
    function PDFOperator(name, args) {
        this.name = name;
        this.args = args || [];
    }
    PDFOperator.prototype.clone = function(context) {
        var args = new Array(this.args.length);
        for(var idx = 0, len = args.length; idx < len; idx++){
            var arg = this.args[idx];
            args[idx] = arg instanceof (0, $l0PqT.default) ? arg.clone(context) : arg;
        }
        return PDFOperator.of(this.name, args);
    };
    PDFOperator.prototype.toString = function() {
        var value = '';
        for(var idx = 0, len = this.args.length; idx < len; idx++)value += String(this.args[idx]) + ' ';
        value += this.name;
        return value;
    };
    PDFOperator.prototype.sizeInBytes = function() {
        var size = 0;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            size += (arg instanceof (0, $l0PqT.default) ? arg.sizeInBytes() : arg.length) + 1;
        }
        size += this.name.length;
        return size;
    };
    PDFOperator.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            if (arg instanceof (0, $l0PqT.default)) offset += arg.copyBytesInto(buffer, offset);
            else offset += (0, $8ZzAZ.copyStringIntoBuffer)(arg, buffer, offset);
            buffer[offset++] = (0, $90Qf4.default).Space;
        }
        offset += (0, $8ZzAZ.copyStringIntoBuffer)(this.name, buffer, offset);
        return offset - initialOffset;
    };
    PDFOperator.of = function(name, args) {
        return new PDFOperator(name, args);
    };
    return PDFOperator;
}();
var $d7f4913eaa91561c$export$2e2bcd8739ae039 = $d7f4913eaa91561c$var$PDFOperator;


var $f7fc5d299ad06003$var$PDFOperatorNames;
(function(PDFOperatorNames) {
    // Non Stroking Color Operators
    PDFOperatorNames["NonStrokingColor"] = "sc";
    PDFOperatorNames["NonStrokingColorN"] = "scn";
    PDFOperatorNames["NonStrokingColorRgb"] = "rg";
    PDFOperatorNames["NonStrokingColorGray"] = "g";
    PDFOperatorNames["NonStrokingColorCmyk"] = "k";
    PDFOperatorNames["NonStrokingColorspace"] = "cs";
    // Stroking Color Operators
    PDFOperatorNames["StrokingColor"] = "SC";
    PDFOperatorNames["StrokingColorN"] = "SCN";
    PDFOperatorNames["StrokingColorRgb"] = "RG";
    PDFOperatorNames["StrokingColorGray"] = "G";
    PDFOperatorNames["StrokingColorCmyk"] = "K";
    PDFOperatorNames["StrokingColorspace"] = "CS";
    // Marked Content Operators
    PDFOperatorNames["BeginMarkedContentSequence"] = "BDC";
    PDFOperatorNames["BeginMarkedContent"] = "BMC";
    PDFOperatorNames["EndMarkedContent"] = "EMC";
    PDFOperatorNames["MarkedContentPointWithProps"] = "DP";
    PDFOperatorNames["MarkedContentPoint"] = "MP";
    PDFOperatorNames["DrawObject"] = "Do";
    // Graphics State Operators
    PDFOperatorNames["ConcatTransformationMatrix"] = "cm";
    PDFOperatorNames["PopGraphicsState"] = "Q";
    PDFOperatorNames["PushGraphicsState"] = "q";
    PDFOperatorNames["SetFlatness"] = "i";
    PDFOperatorNames["SetGraphicsStateParams"] = "gs";
    PDFOperatorNames["SetLineCapStyle"] = "J";
    PDFOperatorNames["SetLineDashPattern"] = "d";
    PDFOperatorNames["SetLineJoinStyle"] = "j";
    PDFOperatorNames["SetLineMiterLimit"] = "M";
    PDFOperatorNames["SetLineWidth"] = "w";
    PDFOperatorNames["SetTextMatrix"] = "Tm";
    PDFOperatorNames["SetRenderingIntent"] = "ri";
    // Graphics Operators
    PDFOperatorNames["AppendRectangle"] = "re";
    PDFOperatorNames["BeginInlineImage"] = "BI";
    PDFOperatorNames["BeginInlineImageData"] = "ID";
    PDFOperatorNames["EndInlineImage"] = "EI";
    PDFOperatorNames["ClipEvenOdd"] = "W*";
    PDFOperatorNames["ClipNonZero"] = "W";
    PDFOperatorNames["CloseAndStroke"] = "s";
    PDFOperatorNames["CloseFillEvenOddAndStroke"] = "b*";
    PDFOperatorNames["CloseFillNonZeroAndStroke"] = "b";
    PDFOperatorNames["ClosePath"] = "h";
    PDFOperatorNames["AppendBezierCurve"] = "c";
    PDFOperatorNames["CurveToReplicateFinalPoint"] = "y";
    PDFOperatorNames["CurveToReplicateInitialPoint"] = "v";
    PDFOperatorNames["EndPath"] = "n";
    PDFOperatorNames["FillEvenOddAndStroke"] = "B*";
    PDFOperatorNames["FillEvenOdd"] = "f*";
    PDFOperatorNames["FillNonZeroAndStroke"] = "B";
    PDFOperatorNames["FillNonZero"] = "f";
    PDFOperatorNames["LegacyFillNonZero"] = "F";
    PDFOperatorNames["LineTo"] = "l";
    PDFOperatorNames["MoveTo"] = "m";
    PDFOperatorNames["ShadingFill"] = "sh";
    PDFOperatorNames["StrokePath"] = "S";
    // Text Operators
    PDFOperatorNames["BeginText"] = "BT";
    PDFOperatorNames["EndText"] = "ET";
    PDFOperatorNames["MoveText"] = "Td";
    PDFOperatorNames["MoveTextSetLeading"] = "TD";
    PDFOperatorNames["NextLine"] = "T*";
    PDFOperatorNames["SetCharacterSpacing"] = "Tc";
    PDFOperatorNames["SetFontAndSize"] = "Tf";
    PDFOperatorNames["SetTextHorizontalScaling"] = "Tz";
    PDFOperatorNames["SetTextLineHeight"] = "TL";
    PDFOperatorNames["SetTextRenderingMode"] = "Tr";
    PDFOperatorNames["SetTextRise"] = "Ts";
    PDFOperatorNames["SetWordSpacing"] = "Tw";
    PDFOperatorNames["ShowText"] = "Tj";
    PDFOperatorNames["ShowTextAdjusted"] = "TJ";
    PDFOperatorNames["ShowTextLine"] = "'";
    PDFOperatorNames["ShowTextLineAndSpace"] = "\"";
    // Type3 Font Operators
    PDFOperatorNames["Type3D0"] = "d0";
    PDFOperatorNames["Type3D1"] = "d1";
    // Compatibility Section Operators
    PDFOperatorNames["BeginCompatibilitySection"] = "BX";
    PDFOperatorNames["EndCompatibilitySection"] = "EX";
})($f7fc5d299ad06003$var$PDFOperatorNames || ($f7fc5d299ad06003$var$PDFOperatorNames = {}));
var $f7fc5d299ad06003$export$2e2bcd8739ae039 = $f7fc5d299ad06003$var$PDFOperatorNames;



var $47XJ3 = parcelRequire("47XJ3");

var $47XJ3 = parcelRequire("47XJ3");

var $hjofF = parcelRequire("hjofF");

var $6AcCU = parcelRequire("6AcCU");

var $2npvA = parcelRequire("2npvA");

parcelRequire("5w6hV");
var $fdd94 = parcelRequire("fdd94");
var $d07fc0ef1d82823f$var$PDFFlateStream = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFFlateStream, _super);
    function PDFFlateStream(dict, encode) {
        var _this = _super.call(this, dict) || this;
        _this.computeContents = function() {
            var unencodedContents = _this.getUnencodedContents();
            return _this.encode ? (0, (/*@__PURE__*/$parcel$interopDefault($hjofF))).deflate(unencodedContents) : unencodedContents;
        };
        _this.encode = encode;
        if (encode) dict.set((0, $2npvA.default).of('Filter'), (0, $2npvA.default).of('FlateDecode'));
        _this.contentsCache = (0, $fdd94.default).populatedBy(_this.computeContents);
        return _this;
    }
    PDFFlateStream.prototype.getContents = function() {
        return this.contentsCache.access();
    };
    PDFFlateStream.prototype.getContentsSize = function() {
        return this.contentsCache.access().length;
    };
    PDFFlateStream.prototype.getUnencodedContents = function() {
        throw new (0, $6AcCU.MethodNotImplementedError)(this.constructor.name, 'getUnencodedContents');
    };
    return PDFFlateStream;
}((0, $1b80b011925bffc2$export$2e2bcd8739ae039));
var $d07fc0ef1d82823f$export$2e2bcd8739ae039 = $d07fc0ef1d82823f$var$PDFFlateStream;



var $90Qf4 = parcelRequire("90Qf4");
var $a23e3df52ace75a5$var$PDFContentStream = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFContentStream, _super);
    function PDFContentStream(dict, operators, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        _this.operators = operators;
        return _this;
    }
    PDFContentStream.prototype.push = function() {
        var _a;
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        (_a = this.operators).push.apply(_a, operators);
    };
    PDFContentStream.prototype.clone = function(context) {
        var operators = new Array(this.operators.length);
        for(var idx = 0, len = this.operators.length; idx < len; idx++)operators[idx] = this.operators[idx].clone(context);
        var _a = this, dict = _a.dict, encode = _a.encode;
        return PDFContentStream.of(dict.clone(context), operators, encode);
    };
    PDFContentStream.prototype.getContentsString = function() {
        var value = '';
        for(var idx = 0, len = this.operators.length; idx < len; idx++)value += this.operators[idx] + "\n";
        return value;
    };
    PDFContentStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++){
            offset += this.operators[idx].copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $90Qf4.default).Newline;
        }
        return buffer;
    };
    PDFContentStream.prototype.getUnencodedContentsSize = function() {
        var size = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++)size += this.operators[idx].sizeInBytes() + 1;
        return size;
    };
    PDFContentStream.of = function(dict, operators, encode) {
        if (encode === void 0) encode = true;
        return new PDFContentStream(dict, operators, encode);
    };
    return PDFContentStream;
}((0, $d07fc0ef1d82823f$export$2e2bcd8739ae039));
var $a23e3df52ace75a5$export$2e2bcd8739ae039 = $a23e3df52ace75a5$var$PDFContentStream;


parcelRequire("5w6hV");
var $4LYfy = parcelRequire("4LYfy");
/**
 * Generates a pseudo random number. Although it is not cryptographically secure
 * and uniformly distributed, it is not a concern for the intended use-case,
 * which is to generate distinct numbers.
 *
 * Credit: https://stackoverflow.com/a/19303725/10254049
 */ var $f7da7a816f96801a$export$205b650d120b95b5 = /** @class */ function() {
    function SimpleRNG(seed) {
        this.seed = seed;
    }
    SimpleRNG.prototype.nextInt = function() {
        var x = Math.sin(this.seed++) * 10000;
        return x - Math.floor(x);
    };
    SimpleRNG.withSeed = function(seed) {
        return new SimpleRNG(seed);
    };
    return SimpleRNG;
}();


var $68246e2808d5ea2f$var$byAscendingObjectNumber = function(_a, _b) {
    var a = _a[0];
    var b = _b[0];
    return a.objectNumber - b.objectNumber;
};
var $68246e2808d5ea2f$var$PDFContext = /** @class */ function() {
    function PDFContext() {
        this.largestObjectNumber = 0;
        this.header = (0, $ba9da13d8e8ae04e$export$2e2bcd8739ae039).forVersion(1, 7);
        this.trailerInfo = {};
        this.indirectObjects = new Map();
        this.rng = (0, $f7da7a816f96801a$export$205b650d120b95b5).withSeed(1);
    }
    PDFContext.prototype.assign = function(ref, object) {
        this.indirectObjects.set(ref, object);
        if (ref.objectNumber > this.largestObjectNumber) this.largestObjectNumber = ref.objectNumber;
    };
    PDFContext.prototype.nextRef = function() {
        this.largestObjectNumber += 1;
        return (0, $dac7b6b491336f5d$export$2e2bcd8739ae039).of(this.largestObjectNumber);
    };
    PDFContext.prototype.register = function(object) {
        var ref = this.nextRef();
        this.assign(ref, object);
        return ref;
    };
    PDFContext.prototype.delete = function(ref) {
        return this.indirectObjects.delete(ref);
    };
    PDFContext.prototype.lookupMaybe = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $9aaf0b887d65bd59$export$2e2bcd8739ae039));
        var result = ref instanceof (0, $dac7b6b491336f5d$export$2e2bcd8739ae039) ? this.indirectObjects.get(ref) : ref;
        if (!result || result === (0, $9aaf0b887d65bd59$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $9aaf0b887d65bd59$export$2e2bcd8739ae039)) {
                if (result === (0, $9aaf0b887d65bd59$export$2e2bcd8739ae039)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $6AcCU.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.lookup = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        var result = ref instanceof (0, $dac7b6b491336f5d$export$2e2bcd8739ae039) ? this.indirectObjects.get(ref) : ref;
        if (types.length === 0) return result;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $9aaf0b887d65bd59$export$2e2bcd8739ae039)) {
                if (result === (0, $9aaf0b887d65bd59$export$2e2bcd8739ae039)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $6AcCU.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.getObjectRef = function(pdfObject) {
        var entries = Array.from(this.indirectObjects.entries());
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], ref = _a[0], object = _a[1];
            if (object === pdfObject) return ref;
        }
        return undefined;
    };
    PDFContext.prototype.enumerateIndirectObjects = function() {
        return Array.from(this.indirectObjects.entries()).sort($68246e2808d5ea2f$var$byAscendingObjectNumber);
    };
    PDFContext.prototype.obj = function(literal) {
        if (literal instanceof (0, $l0PqT.default)) return literal;
        else if (literal === null || literal === undefined) return 0, $9aaf0b887d65bd59$export$2e2bcd8739ae039;
        else if (typeof literal === 'string') return (0, $2npvA.default).of(literal);
        else if (typeof literal === 'number') return (0, $dKRgb.default).of(literal);
        else if (typeof literal === 'boolean') return literal ? (0, $HB3Cf.default).True : (0, $HB3Cf.default).False;
        else if (Array.isArray(literal)) {
            var array = (0, $6IKEk.default).withContext(this);
            for(var idx = 0, len = literal.length; idx < len; idx++)array.push(this.obj(literal[idx]));
            return array;
        } else {
            var dict = (0, $74b515754dab46b0$export$2e2bcd8739ae039).withContext(this);
            var keys = Object.keys(literal);
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                var value = literal[key];
                if (value !== undefined) dict.set((0, $2npvA.default).of(key), this.obj(value));
            }
            return dict;
        }
    };
    PDFContext.prototype.stream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return (0, $9d0105b76c83b6a6$export$2e2bcd8739ae039).of(this.obj(dict), (0, $4LYfy.typedArrayFor)(contents));
    };
    PDFContext.prototype.flateStream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return this.stream((0, (/*@__PURE__*/$parcel$interopDefault($hjofF))).deflate((0, $4LYfy.typedArrayFor)(contents)), (0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, dict), {
            Filter: 'FlateDecode'
        }));
    };
    PDFContext.prototype.contentStream = function(operators, dict) {
        if (dict === void 0) dict = {};
        return (0, $a23e3df52ace75a5$export$2e2bcd8739ae039).of(this.obj(dict), operators);
    };
    PDFContext.prototype.formXObject = function(operators, dict) {
        if (dict === void 0) dict = {};
        return this.contentStream(operators, (0, $47XJ3.__assign)((0, $47XJ3.__assign)({
            BBox: this.obj([
                0,
                0,
                0,
                0
            ]),
            Matrix: this.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        }, dict), {
            Type: 'XObject',
            Subtype: 'Form'
        }));
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPushGraphicsStateContentStream = function() {
        if (this.pushGraphicsStateContentStreamRef) return this.pushGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).PushGraphicsState);
        var stream = (0, $a23e3df52ace75a5$export$2e2bcd8739ae039).of(dict, [
            op
        ]);
        this.pushGraphicsStateContentStreamRef = this.register(stream);
        return this.pushGraphicsStateContentStreamRef;
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `Q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPopGraphicsStateContentStream = function() {
        if (this.popGraphicsStateContentStreamRef) return this.popGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).PopGraphicsState);
        var stream = (0, $a23e3df52ace75a5$export$2e2bcd8739ae039).of(dict, [
            op
        ]);
        this.popGraphicsStateContentStreamRef = this.register(stream);
        return this.popGraphicsStateContentStreamRef;
    };
    PDFContext.prototype.addRandomSuffix = function(prefix, suffixLength) {
        if (suffixLength === void 0) suffixLength = 4;
        return prefix + "-" + Math.floor(this.rng.nextInt() * Math.pow(10, suffixLength));
    };
    PDFContext.create = function() {
        return new PDFContext();
    };
    return PDFContext;
}();
var $68246e2808d5ea2f$export$2e2bcd8739ae039 = $68246e2808d5ea2f$var$PDFContext;



var $6IKEk = parcelRequire("6IKEk");


var $2npvA = parcelRequire("2npvA");



var $47XJ3 = parcelRequire("47XJ3");

var $6IKEk = parcelRequire("6IKEk");


var $2npvA = parcelRequire("2npvA");

var $dKRgb = parcelRequire("dKRgb");

var $9575017b00e75ca2$var$PDFPageLeaf = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFPageLeaf, _super);
    function PDFPageLeaf(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        var _this = _super.call(this, map, context) || this;
        _this.normalized = false;
        _this.autoNormalizeCTM = autoNormalizeCTM;
        return _this;
    }
    PDFPageLeaf.prototype.clone = function(context) {
        var clone = PDFPageLeaf.fromMapWithContext(new Map(), context || this.context, this.autoNormalizeCTM);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFPageLeaf.prototype.Parent = function() {
        return this.lookupMaybe((0, $2npvA.default).Parent, (0, $74b515754dab46b0$export$2e2bcd8739ae039));
    };
    PDFPageLeaf.prototype.Contents = function() {
        return this.lookup((0, $2npvA.default).of('Contents'));
    };
    PDFPageLeaf.prototype.Annots = function() {
        return this.lookupMaybe((0, $2npvA.default).Annots, (0, $6IKEk.default));
    };
    PDFPageLeaf.prototype.BleedBox = function() {
        return this.lookupMaybe((0, $2npvA.default).BleedBox, (0, $6IKEk.default));
    };
    PDFPageLeaf.prototype.TrimBox = function() {
        return this.lookupMaybe((0, $2npvA.default).TrimBox, (0, $6IKEk.default));
    };
    PDFPageLeaf.prototype.ArtBox = function() {
        return this.lookupMaybe((0, $2npvA.default).ArtBox, (0, $6IKEk.default));
    };
    PDFPageLeaf.prototype.Resources = function() {
        var dictOrRef = this.getInheritableAttribute((0, $2npvA.default).Resources);
        return this.context.lookupMaybe(dictOrRef, (0, $74b515754dab46b0$export$2e2bcd8739ae039));
    };
    PDFPageLeaf.prototype.MediaBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $2npvA.default).MediaBox);
        return this.context.lookup(arrayOrRef, (0, $6IKEk.default));
    };
    PDFPageLeaf.prototype.CropBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $2npvA.default).CropBox);
        return this.context.lookupMaybe(arrayOrRef, (0, $6IKEk.default));
    };
    PDFPageLeaf.prototype.Rotate = function() {
        var numberOrRef = this.getInheritableAttribute((0, $2npvA.default).Rotate);
        return this.context.lookupMaybe(numberOrRef, (0, $dKRgb.default));
    };
    PDFPageLeaf.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.get(name);
        });
        return attribute;
    };
    PDFPageLeaf.prototype.setParent = function(parentRef) {
        this.set((0, $2npvA.default).Parent, parentRef);
    };
    PDFPageLeaf.prototype.addContentStream = function(contentStreamRef) {
        var Contents = this.normalizedEntries().Contents || this.context.obj([]);
        this.set((0, $2npvA.default).Contents, Contents);
        Contents.push(contentStreamRef);
    };
    PDFPageLeaf.prototype.wrapContentStreams = function(startStream, endStream) {
        var Contents = this.Contents();
        if (Contents instanceof (0, $6IKEk.default)) {
            Contents.insert(0, startStream);
            Contents.push(endStream);
            return true;
        }
        return false;
    };
    PDFPageLeaf.prototype.addAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        Annots.push(annotRef);
    };
    PDFPageLeaf.prototype.removeAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        var index = Annots.indexOf(annotRef);
        if (index !== undefined) Annots.remove(index);
    };
    PDFPageLeaf.prototype.setFontDictionary = function(name, fontDictRef) {
        var Font = this.normalizedEntries().Font;
        Font.set(name, fontDictRef);
    };
    PDFPageLeaf.prototype.newFontDictionaryKey = function(tag) {
        var Font = this.normalizedEntries().Font;
        return Font.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newFontDictionary = function(tag, fontDictRef) {
        var key = this.newFontDictionaryKey(tag);
        this.setFontDictionary(key, fontDictRef);
        return key;
    };
    PDFPageLeaf.prototype.setXObject = function(name, xObjectRef) {
        var XObject = this.normalizedEntries().XObject;
        XObject.set(name, xObjectRef);
    };
    PDFPageLeaf.prototype.newXObjectKey = function(tag) {
        var XObject = this.normalizedEntries().XObject;
        return XObject.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newXObject = function(tag, xObjectRef) {
        var key = this.newXObjectKey(tag);
        this.setXObject(key, xObjectRef);
        return key;
    };
    PDFPageLeaf.prototype.setExtGState = function(name, extGStateRef) {
        var ExtGState = this.normalizedEntries().ExtGState;
        ExtGState.set(name, extGStateRef);
    };
    PDFPageLeaf.prototype.newExtGStateKey = function(tag) {
        var ExtGState = this.normalizedEntries().ExtGState;
        return ExtGState.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newExtGState = function(tag, extGStateRef) {
        var key = this.newExtGStateKey(tag);
        this.setExtGState(key, extGStateRef);
        return key;
    };
    PDFPageLeaf.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    PDFPageLeaf.prototype.normalize = function() {
        if (this.normalized) return;
        var context = this.context;
        var contentsRef = this.get((0, $2npvA.default).Contents);
        var contents = this.context.lookup(contentsRef);
        if (contents instanceof (0, $1b80b011925bffc2$export$2e2bcd8739ae039)) this.set((0, $2npvA.default).Contents, context.obj([
            contentsRef
        ]));
        if (this.autoNormalizeCTM) this.wrapContentStreams(this.context.getPushGraphicsStateContentStream(), this.context.getPopGraphicsStateContentStream());
        // TODO: Clone `Resources` if it is inherited
        var dictOrRef = this.getInheritableAttribute((0, $2npvA.default).Resources);
        var Resources = context.lookupMaybe(dictOrRef, (0, $74b515754dab46b0$export$2e2bcd8739ae039)) || context.obj({});
        this.set((0, $2npvA.default).Resources, Resources);
        // TODO: Clone `Font` if it is inherited
        var Font = Resources.lookupMaybe((0, $2npvA.default).Font, (0, $74b515754dab46b0$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $2npvA.default).Font, Font);
        // TODO: Clone `XObject` if it is inherited
        var XObject = Resources.lookupMaybe((0, $2npvA.default).XObject, (0, $74b515754dab46b0$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $2npvA.default).XObject, XObject);
        // TODO: Clone `ExtGState` if it is inherited
        var ExtGState = Resources.lookupMaybe((0, $2npvA.default).ExtGState, (0, $74b515754dab46b0$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $2npvA.default).ExtGState, ExtGState);
        var Annots = this.Annots() || context.obj([]);
        this.set((0, $2npvA.default).Annots, Annots);
        this.normalized = true;
    };
    PDFPageLeaf.prototype.normalizedEntries = function() {
        this.normalize();
        var Annots = this.Annots();
        var Resources = this.Resources();
        var Contents = this.Contents();
        return {
            Annots: Annots,
            Resources: Resources,
            Contents: Contents,
            Font: Resources.lookup((0, $2npvA.default).Font, (0, $74b515754dab46b0$export$2e2bcd8739ae039)),
            XObject: Resources.lookup((0, $2npvA.default).XObject, (0, $74b515754dab46b0$export$2e2bcd8739ae039)),
            ExtGState: Resources.lookup((0, $2npvA.default).ExtGState, (0, $74b515754dab46b0$export$2e2bcd8739ae039))
        };
    };
    PDFPageLeaf.InheritableEntries = [
        'Resources',
        'MediaBox',
        'CropBox',
        'Rotate'
    ];
    PDFPageLeaf.withContextAndParent = function(context, parent) {
        var dict = new Map();
        dict.set((0, $2npvA.default).Type, (0, $2npvA.default).Page);
        dict.set((0, $2npvA.default).Parent, parent);
        dict.set((0, $2npvA.default).Resources, context.obj({}));
        dict.set((0, $2npvA.default).MediaBox, context.obj([
            0,
            0,
            612,
            792
        ]));
        return new PDFPageLeaf(dict, context, false);
    };
    PDFPageLeaf.fromMapWithContext = function(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        return new PDFPageLeaf(map, context, autoNormalizeCTM);
    };
    return PDFPageLeaf;
}((0, $74b515754dab46b0$export$2e2bcd8739ae039));
var $9575017b00e75ca2$export$2e2bcd8739ae039 = $9575017b00e75ca2$var$PDFPageLeaf;


/**
 * PDFObjectCopier copies PDFObjects from a src context to a dest context.
 * The primary use case for this is to copy pages between PDFs.
 *
 * _Copying_ an object with a PDFObjectCopier is different from _cloning_ an
 * object with its [[PDFObject.clone]] method:
 *
 * ```
 *   const src: PDFContext = ...
 *   const dest: PDFContext = ...
 *   const originalObject: PDFObject = ...
 *   const copiedObject = PDFObjectCopier.for(src, dest).copy(originalObject);
 *   const clonedObject = originalObject.clone();
 * ```
 *
 * Copying an object is equivalent to cloning it and then copying over any other
 * objects that it references. Note that only dictionaries, arrays, and streams
 * (or structures build from them) can contain indirect references to other
 * objects. Copying a PDFObject that is not a dictionary, array, or stream is
 * supported, but is equivalent to cloning it.
 */ var $d3c799b1d361558a$var$PDFObjectCopier = /** @class */ function() {
    function PDFObjectCopier(src, dest) {
        var _this = this;
        this.traversedObjects = new Map();
        // prettier-ignore
        this.copy = function(object) {
            return object instanceof (0, $9575017b00e75ca2$export$2e2bcd8739ae039) ? _this.copyPDFPage(object) : object instanceof (0, $74b515754dab46b0$export$2e2bcd8739ae039) ? _this.copyPDFDict(object) : object instanceof (0, $6IKEk.default) ? _this.copyPDFArray(object) : object instanceof (0, $1b80b011925bffc2$export$2e2bcd8739ae039) ? _this.copyPDFStream(object) : object instanceof (0, $dac7b6b491336f5d$export$2e2bcd8739ae039) ? _this.copyPDFIndirectObject(object) : object.clone();
        };
        this.copyPDFPage = function(originalPage) {
            var clonedPage = originalPage.clone();
            // Move any entries that the originalPage is inheriting from its parent
            // tree nodes directly into originalPage so they are preserved during
            // the copy.
            var InheritableEntries = (0, $9575017b00e75ca2$export$2e2bcd8739ae039).InheritableEntries;
            for(var idx = 0, len = InheritableEntries.length; idx < len; idx++){
                var key = (0, $2npvA.default).of(InheritableEntries[idx]);
                var value = clonedPage.getInheritableAttribute(key);
                if (!clonedPage.get(key) && value) clonedPage.set(key, value);
            }
            // Remove the parent reference to prevent the whole donor document's page
            // tree from being copied when we only need a single page.
            clonedPage.delete((0, $2npvA.default).of('Parent'));
            return _this.copyPDFDict(clonedPage);
        };
        this.copyPDFDict = function(originalDict) {
            if (_this.traversedObjects.has(originalDict)) return _this.traversedObjects.get(originalDict);
            var clonedDict = originalDict.clone(_this.dest);
            _this.traversedObjects.set(originalDict, clonedDict);
            var entries = originalDict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedDict.set(key, _this.copy(value));
            }
            return clonedDict;
        };
        this.copyPDFArray = function(originalArray) {
            if (_this.traversedObjects.has(originalArray)) return _this.traversedObjects.get(originalArray);
            var clonedArray = originalArray.clone(_this.dest);
            _this.traversedObjects.set(originalArray, clonedArray);
            for(var idx = 0, len = originalArray.size(); idx < len; idx++){
                var value = originalArray.get(idx);
                clonedArray.set(idx, _this.copy(value));
            }
            return clonedArray;
        };
        this.copyPDFStream = function(originalStream) {
            if (_this.traversedObjects.has(originalStream)) return _this.traversedObjects.get(originalStream);
            var clonedStream = originalStream.clone(_this.dest);
            _this.traversedObjects.set(originalStream, clonedStream);
            var entries = originalStream.dict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedStream.dict.set(key, _this.copy(value));
            }
            return clonedStream;
        };
        this.copyPDFIndirectObject = function(ref) {
            var alreadyMapped = _this.traversedObjects.has(ref);
            if (!alreadyMapped) {
                var newRef = _this.dest.nextRef();
                _this.traversedObjects.set(ref, newRef);
                var dereferencedValue = _this.src.lookup(ref);
                if (dereferencedValue) {
                    var cloned = _this.copy(dereferencedValue);
                    _this.dest.assign(newRef, cloned);
                }
            }
            return _this.traversedObjects.get(ref);
        };
        this.src = src;
        this.dest = dest;
    }
    PDFObjectCopier.for = function(src, dest) {
        return new PDFObjectCopier(src, dest);
    };
    return PDFObjectCopier;
}();
var $d3c799b1d361558a$export$2e2bcd8739ae039 = $d3c799b1d361558a$var$PDFObjectCopier;



var $47XJ3 = parcelRequire("47XJ3");


var $90Qf4 = parcelRequire("90Qf4");
parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
/**
 * Entries should be added using the [[addEntry]] and [[addDeletedEntry]]
 * methods **in order of ascending object number**.
 */ var $7af7c7e6764f444e$var$PDFCrossRefSection = /** @class */ function() {
    function PDFCrossRefSection(firstEntry) {
        this.subsections = firstEntry ? [
            [
                firstEntry
            ]
        ] : [];
        this.chunkIdx = 0;
        this.chunkLength = firstEntry ? 1 : 0;
    }
    PDFCrossRefSection.prototype.addEntry = function(ref, offset) {
        this.append({
            ref: ref,
            offset: offset,
            deleted: false
        });
    };
    PDFCrossRefSection.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        this.append({
            ref: ref,
            offset: nextFreeObjectNumber,
            deleted: true
        });
    };
    PDFCrossRefSection.prototype.toString = function() {
        var section = "xref\n";
        for(var rangeIdx = 0, rangeLen = this.subsections.length; rangeIdx < rangeLen; rangeIdx++){
            var range = this.subsections[rangeIdx];
            section += range[0].ref.objectNumber + " " + range.length + "\n";
            for(var entryIdx = 0, entryLen = range.length; entryIdx < entryLen; entryIdx++){
                var entry = range[entryIdx];
                section += (0, $8ZzAZ.padStart)(String(entry.offset), 10, '0');
                section += ' ';
                section += (0, $8ZzAZ.padStart)(String(entry.ref.generationNumber), 5, '0');
                section += ' ';
                section += entry.deleted ? 'f' : 'n';
                section += ' \n';
            }
        }
        return section;
    };
    PDFCrossRefSection.prototype.sizeInBytes = function() {
        var size = 5;
        for(var idx = 0, len = this.subsections.length; idx < len; idx++){
            var subsection = this.subsections[idx];
            var subsectionLength = subsection.length;
            var firstEntry = subsection[0];
            size += 2;
            size += String(firstEntry.ref.objectNumber).length;
            size += String(subsectionLength).length;
            size += 20 * subsectionLength;
        }
        return size;
    };
    PDFCrossRefSection.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $90Qf4.default).x;
        buffer[offset++] = (0, $90Qf4.default).r;
        buffer[offset++] = (0, $90Qf4.default).e;
        buffer[offset++] = (0, $90Qf4.default).f;
        buffer[offset++] = (0, $90Qf4.default).Newline;
        offset += this.copySubsectionsIntoBuffer(this.subsections, buffer, offset);
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copySubsectionsIntoBuffer = function(subsections, buffer, offset) {
        var initialOffset = offset;
        var length = subsections.length;
        for(var idx = 0; idx < length; idx++){
            var subsection = this.subsections[idx];
            var firstObjectNumber = String(subsection[0].ref.objectNumber);
            offset += (0, $8ZzAZ.copyStringIntoBuffer)(firstObjectNumber, buffer, offset);
            buffer[offset++] = (0, $90Qf4.default).Space;
            var rangeLength = String(subsection.length);
            offset += (0, $8ZzAZ.copyStringIntoBuffer)(rangeLength, buffer, offset);
            buffer[offset++] = (0, $90Qf4.default).Newline;
            offset += this.copyEntriesIntoBuffer(subsection, buffer, offset);
        }
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copyEntriesIntoBuffer = function(entries, buffer, offset) {
        var length = entries.length;
        for(var idx = 0; idx < length; idx++){
            var entry = entries[idx];
            var entryOffset = (0, $8ZzAZ.padStart)(String(entry.offset), 10, '0');
            offset += (0, $8ZzAZ.copyStringIntoBuffer)(entryOffset, buffer, offset);
            buffer[offset++] = (0, $90Qf4.default).Space;
            var entryGen = (0, $8ZzAZ.padStart)(String(entry.ref.generationNumber), 5, '0');
            offset += (0, $8ZzAZ.copyStringIntoBuffer)(entryGen, buffer, offset);
            buffer[offset++] = (0, $90Qf4.default).Space;
            buffer[offset++] = entry.deleted ? (0, $90Qf4.default).f : (0, $90Qf4.default).n;
            buffer[offset++] = (0, $90Qf4.default).Space;
            buffer[offset++] = (0, $90Qf4.default).Newline;
        }
        return 20 * length;
    };
    PDFCrossRefSection.prototype.append = function(currEntry) {
        if (this.chunkLength === 0) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx = 0;
            this.chunkLength = 1;
            return;
        }
        var chunk = this.subsections[this.chunkIdx];
        var prevEntry = chunk[this.chunkLength - 1];
        if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx += 1;
            this.chunkLength = 1;
        } else {
            chunk.push(currEntry);
            this.chunkLength += 1;
        }
    };
    PDFCrossRefSection.create = function() {
        return new PDFCrossRefSection({
            ref: (0, $dac7b6b491336f5d$export$2e2bcd8739ae039).of(0, 65535),
            offset: 0,
            deleted: true
        });
    };
    PDFCrossRefSection.createEmpty = function() {
        return new PDFCrossRefSection();
    };
    return PDFCrossRefSection;
}();
var $7af7c7e6764f444e$export$2e2bcd8739ae039 = $7af7c7e6764f444e$var$PDFCrossRefSection;




var $90Qf4 = parcelRequire("90Qf4");
parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
var $dd71effa95b04295$var$PDFTrailer = /** @class */ function() {
    function PDFTrailer(lastXRefOffset) {
        this.lastXRefOffset = String(lastXRefOffset);
    }
    PDFTrailer.prototype.toString = function() {
        return "startxref\n" + this.lastXRefOffset + "\n%%EOF";
    };
    PDFTrailer.prototype.sizeInBytes = function() {
        return 16 + this.lastXRefOffset.length;
    };
    PDFTrailer.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $90Qf4.default).s;
        buffer[offset++] = (0, $90Qf4.default).t;
        buffer[offset++] = (0, $90Qf4.default).a;
        buffer[offset++] = (0, $90Qf4.default).r;
        buffer[offset++] = (0, $90Qf4.default).t;
        buffer[offset++] = (0, $90Qf4.default).x;
        buffer[offset++] = (0, $90Qf4.default).r;
        buffer[offset++] = (0, $90Qf4.default).e;
        buffer[offset++] = (0, $90Qf4.default).f;
        buffer[offset++] = (0, $90Qf4.default).Newline;
        offset += (0, $8ZzAZ.copyStringIntoBuffer)(this.lastXRefOffset, buffer, offset);
        buffer[offset++] = (0, $90Qf4.default).Newline;
        buffer[offset++] = (0, $90Qf4.default).Percent;
        buffer[offset++] = (0, $90Qf4.default).Percent;
        buffer[offset++] = (0, $90Qf4.default).E;
        buffer[offset++] = (0, $90Qf4.default).O;
        buffer[offset++] = (0, $90Qf4.default).F;
        return offset - initialOffset;
    };
    PDFTrailer.forLastCrossRefSectionOffset = function(offset) {
        return new PDFTrailer(offset);
    };
    return PDFTrailer;
}();
var $dd71effa95b04295$export$2e2bcd8739ae039 = $dd71effa95b04295$var$PDFTrailer;



var $90Qf4 = parcelRequire("90Qf4");
var $5a78533b12583598$var$PDFTrailerDict = /** @class */ function() {
    function PDFTrailerDict(dict) {
        this.dict = dict;
    }
    PDFTrailerDict.prototype.toString = function() {
        return "trailer\n" + this.dict.toString();
    };
    PDFTrailerDict.prototype.sizeInBytes = function() {
        return 8 + this.dict.sizeInBytes();
    };
    PDFTrailerDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $90Qf4.default).t;
        buffer[offset++] = (0, $90Qf4.default).r;
        buffer[offset++] = (0, $90Qf4.default).a;
        buffer[offset++] = (0, $90Qf4.default).i;
        buffer[offset++] = (0, $90Qf4.default).l;
        buffer[offset++] = (0, $90Qf4.default).e;
        buffer[offset++] = (0, $90Qf4.default).r;
        buffer[offset++] = (0, $90Qf4.default).Newline;
        offset += this.dict.copyBytesInto(buffer, offset);
        return offset - initialOffset;
    };
    PDFTrailerDict.of = function(dict) {
        return new PDFTrailerDict(dict);
    };
    return PDFTrailerDict;
}();
var $5a78533b12583598$export$2e2bcd8739ae039 = $5a78533b12583598$var$PDFTrailerDict;



var $47XJ3 = parcelRequire("47XJ3");

var $2npvA = parcelRequire("2npvA");

var $dKRgb = parcelRequire("dKRgb");


var $90Qf4 = parcelRequire("90Qf4");
parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
var $4LYfy = parcelRequire("4LYfy");
var $4d5b123fbd2cdac2$var$PDFObjectStream = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFObjectStream, _super);
    function PDFObjectStream(context, objects, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, context.obj({}), encode) || this;
        _this.objects = objects;
        _this.offsets = _this.computeObjectOffsets();
        _this.offsetsString = _this.computeOffsetsString();
        _this.dict.set((0, $2npvA.default).of('Type'), (0, $2npvA.default).of('ObjStm'));
        _this.dict.set((0, $2npvA.default).of('N'), (0, $dKRgb.default).of(_this.objects.length));
        _this.dict.set((0, $2npvA.default).of('First'), (0, $dKRgb.default).of(_this.offsetsString.length));
        return _this;
    }
    PDFObjectStream.prototype.getObjectsCount = function() {
        return this.objects.length;
    };
    PDFObjectStream.prototype.clone = function(context) {
        return PDFObjectStream.withContextAndObjects(context || this.dict.context, this.objects.slice(), this.encode);
    };
    PDFObjectStream.prototype.getContentsString = function() {
        var value = this.offsetsString;
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            value += object + "\n";
        }
        return value;
    };
    PDFObjectStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = (0, $8ZzAZ.copyStringIntoBuffer)(this.offsetsString, buffer, 0);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            offset += object.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $90Qf4.default).Newline;
        }
        return buffer;
    };
    PDFObjectStream.prototype.getUnencodedContentsSize = function() {
        return this.offsetsString.length + (0, $4LYfy.last)(this.offsets)[1] + (0, $4LYfy.last)(this.objects)[1].sizeInBytes() + 1;
    };
    PDFObjectStream.prototype.computeOffsetsString = function() {
        var offsetsString = '';
        for(var idx = 0, len = this.offsets.length; idx < len; idx++){
            var _a = this.offsets[idx], objectNumber = _a[0], offset = _a[1];
            offsetsString += objectNumber + " " + offset + " ";
        }
        return offsetsString;
    };
    PDFObjectStream.prototype.computeObjectOffsets = function() {
        var offset = 0;
        var offsets = new Array(this.objects.length);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], ref = _a[0], object = _a[1];
            offsets[idx] = [
                ref.objectNumber,
                offset
            ];
            offset += object.sizeInBytes() + 1; // '\n'
        }
        return offsets;
    };
    PDFObjectStream.withContextAndObjects = function(context, objects, encode) {
        if (encode === void 0) encode = true;
        return new PDFObjectStream(context, objects, encode);
    };
    return PDFObjectStream;
}((0, $d07fc0ef1d82823f$export$2e2bcd8739ae039));
var $4d5b123fbd2cdac2$export$2e2bcd8739ae039 = $4d5b123fbd2cdac2$var$PDFObjectStream;



var $90Qf4 = parcelRequire("90Qf4");
parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
var $9J7bS = parcelRequire("9J7bS");
var $3b0651781259edc6$var$PDFWriter = /** @class */ function() {
    function PDFWriter(context, objectsPerTick) {
        var _this = this;
        this.parsedObjects = 0;
        this.shouldWaitForTick = function(n) {
            _this.parsedObjects += n;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        this.context = context;
        this.objectsPerTick = objectsPerTick;
    }
    PDFWriter.prototype.serializeToBuffer = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var _a, size, header, indirectObjects, xref, trailerDict, trailer, offset, buffer, idx, len, _b, ref, object, objectNumber, generationNumber, n;
            return (0, $47XJ3.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.computeBufferSize()
                        ];
                    case 1:
                        _a = _c.sent(), size = _a.size, header = _a.header, indirectObjects = _a.indirectObjects, xref = _a.xref, trailerDict = _a.trailerDict, trailer = _a.trailer;
                        offset = 0;
                        buffer = new Uint8Array(size);
                        offset += header.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $90Qf4.default).Newline;
                        buffer[offset++] = (0, $90Qf4.default).Newline;
                        idx = 0, len = indirectObjects.length;
                        _c.label = 2;
                    case 2:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            5
                        ];
                        _b = indirectObjects[idx], ref = _b[0], object = _b[1];
                        objectNumber = String(ref.objectNumber);
                        offset += (0, $8ZzAZ.copyStringIntoBuffer)(objectNumber, buffer, offset);
                        buffer[offset++] = (0, $90Qf4.default).Space;
                        generationNumber = String(ref.generationNumber);
                        offset += (0, $8ZzAZ.copyStringIntoBuffer)(generationNumber, buffer, offset);
                        buffer[offset++] = (0, $90Qf4.default).Space;
                        buffer[offset++] = (0, $90Qf4.default).o;
                        buffer[offset++] = (0, $90Qf4.default).b;
                        buffer[offset++] = (0, $90Qf4.default).j;
                        buffer[offset++] = (0, $90Qf4.default).Newline;
                        offset += object.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $90Qf4.default).Newline;
                        buffer[offset++] = (0, $90Qf4.default).e;
                        buffer[offset++] = (0, $90Qf4.default).n;
                        buffer[offset++] = (0, $90Qf4.default).d;
                        buffer[offset++] = (0, $90Qf4.default).o;
                        buffer[offset++] = (0, $90Qf4.default).b;
                        buffer[offset++] = (0, $90Qf4.default).j;
                        buffer[offset++] = (0, $90Qf4.default).Newline;
                        buffer[offset++] = (0, $90Qf4.default).Newline;
                        n = object instanceof (0, $4d5b123fbd2cdac2$export$2e2bcd8739ae039) ? object.getObjectsCount() : 1;
                        if (!this.shouldWaitForTick(n)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $9J7bS.waitForTick)()
                        ];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        idx++;
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        if (xref) {
                            offset += xref.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $90Qf4.default).Newline;
                        }
                        if (trailerDict) {
                            offset += trailerDict.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $90Qf4.default).Newline;
                            buffer[offset++] = (0, $90Qf4.default).Newline;
                        }
                        offset += trailer.copyBytesInto(buffer, offset);
                        return [
                            2 /*return*/ ,
                            buffer
                        ];
                }
            });
        });
    };
    PDFWriter.prototype.computeIndirectObjectSize = function(_a) {
        var ref = _a[0], object = _a[1];
        var refSize = ref.sizeInBytes() + 3; // 'R' -> 'obj\n'
        var objectSize = object.sizeInBytes() + 9; // '\nendobj\n\n'
        return refSize + objectSize;
    };
    PDFWriter.prototype.createTrailerDict = function() {
        return this.context.obj({
            Size: this.context.largestObjectNumber + 1,
            Root: this.context.trailerInfo.Root,
            Encrypt: this.context.trailerInfo.Encrypt,
            Info: this.context.trailerInfo.Info,
            ID: this.context.trailerInfo.ID
        });
    };
    PDFWriter.prototype.computeBufferSize = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var header, size, xref, indirectObjects, idx, len, indirectObject, ref, xrefOffset, trailerDict, trailer;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        header = (0, $ba9da13d8e8ae04e$export$2e2bcd8739ae039).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xref = (0, $7af7c7e6764f444e$export$2e2bcd8739ae039).create();
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0];
                        xref.addEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $9J7bS.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        xrefOffset = size;
                        size += xref.sizeInBytes() + 1; // '\n'
                        trailerDict = (0, $5a78533b12583598$export$2e2bcd8739ae039).of(this.createTrailerDict());
                        size += trailerDict.sizeInBytes() + 2; // '\n\n'
                        trailer = (0, $dd71effa95b04295$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: indirectObjects,
                                xref: xref,
                                trailerDict: trailerDict,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFWriter.forContext = function(context, objectsPerTick) {
        return new PDFWriter(context, objectsPerTick);
    };
    return PDFWriter;
}();
var $3b0651781259edc6$export$2e2bcd8739ae039 = $3b0651781259edc6$var$PDFWriter;



var $47XJ3 = parcelRequire("47XJ3");



var $47XJ3 = parcelRequire("47XJ3");

var $l0PqT = parcelRequire("l0PqT");
var $ed19c0faaed1b241$var$PDFInvalidObject = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFInvalidObject, _super);
    function PDFInvalidObject(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    PDFInvalidObject.prototype.clone = function() {
        return PDFInvalidObject.of(this.data.slice());
    };
    PDFInvalidObject.prototype.toString = function() {
        return "PDFInvalidObject(" + this.data.length + " bytes)";
    };
    PDFInvalidObject.prototype.sizeInBytes = function() {
        return this.data.length;
    };
    PDFInvalidObject.prototype.copyBytesInto = function(buffer, offset) {
        var length = this.data.length;
        for(var idx = 0; idx < length; idx++)buffer[offset++] = this.data[idx];
        return length;
    };
    PDFInvalidObject.of = function(data) {
        return new PDFInvalidObject(data);
    };
    return PDFInvalidObject;
}((0, $l0PqT.default));
var $ed19c0faaed1b241$export$2e2bcd8739ae039 = $ed19c0faaed1b241$var$PDFInvalidObject;



var $2npvA = parcelRequire("2npvA");

var $dKRgb = parcelRequire("dKRgb");



var $47XJ3 = parcelRequire("47XJ3");

var $2npvA = parcelRequire("2npvA");


parcelRequire("5w6hV");
var $bv0iE = parcelRequire("bv0iE");
var $fdd94 = parcelRequire("fdd94");
var $4LYfy = parcelRequire("4LYfy");
var $37df6718066d5b2e$export$e41c32906b33062a;
(function(EntryType) {
    EntryType[EntryType["Deleted"] = 0] = "Deleted";
    EntryType[EntryType["Uncompressed"] = 1] = "Uncompressed";
    EntryType[EntryType["Compressed"] = 2] = "Compressed";
})($37df6718066d5b2e$export$e41c32906b33062a || ($37df6718066d5b2e$export$e41c32906b33062a = {}));
/**
 * Entries should be added using the [[addDeletedEntry]],
 * [[addUncompressedEntry]], and [[addCompressedEntry]] methods
 * **in order of ascending object number**.
 */ var $37df6718066d5b2e$var$PDFCrossRefStream = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFCrossRefStream, _super);
    function PDFCrossRefStream(dict, entries, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        // Returns an array of integer pairs for each subsection of the cross ref
        // section, where each integer pair represents:
        //   firstObjectNumber(OfSection), length(OfSection)
        _this.computeIndex = function() {
            var subsections = [];
            var subsectionLength = 0;
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var currEntry = _this.entries[idx];
                var prevEntry = _this.entries[idx - 1];
                if (idx === 0) subsections.push(currEntry.ref.objectNumber);
                else if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
                    subsections.push(subsectionLength);
                    subsections.push(currEntry.ref.objectNumber);
                    subsectionLength = 0;
                }
                subsectionLength += 1;
            }
            subsections.push(subsectionLength);
            return subsections;
        };
        _this.computeEntryTuples = function() {
            var entryTuples = new Array(_this.entries.length);
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var entry = _this.entries[idx];
                if (entry.type === $37df6718066d5b2e$export$e41c32906b33062a.Deleted) {
                    var type = entry.type, nextFreeObjectNumber = entry.nextFreeObjectNumber, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        nextFreeObjectNumber,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $37df6718066d5b2e$export$e41c32906b33062a.Uncompressed) {
                    var type = entry.type, offset = entry.offset, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        offset,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $37df6718066d5b2e$export$e41c32906b33062a.Compressed) {
                    var type = entry.type, objectStreamRef = entry.objectStreamRef, index = entry.index;
                    entryTuples[idx] = [
                        type,
                        objectStreamRef.objectNumber,
                        index
                    ];
                }
            }
            return entryTuples;
        };
        _this.computeMaxEntryByteWidths = function() {
            var entryTuples = _this.entryTuplesCache.access();
            var widths = [
                0,
                0,
                0
            ];
            for(var idx = 0, len = entryTuples.length; idx < len; idx++){
                var _a = entryTuples[idx], first = _a[0], second = _a[1], third = _a[2];
                var firstSize = (0, $bv0iE.sizeInBytes)(first);
                var secondSize = (0, $bv0iE.sizeInBytes)(second);
                var thirdSize = (0, $bv0iE.sizeInBytes)(third);
                if (firstSize > widths[0]) widths[0] = firstSize;
                if (secondSize > widths[1]) widths[1] = secondSize;
                if (thirdSize > widths[2]) widths[2] = thirdSize;
            }
            return widths;
        };
        _this.entries = entries || [];
        _this.entryTuplesCache = (0, $fdd94.default).populatedBy(_this.computeEntryTuples);
        _this.maxByteWidthsCache = (0, $fdd94.default).populatedBy(_this.computeMaxEntryByteWidths);
        _this.indexCache = (0, $fdd94.default).populatedBy(_this.computeIndex);
        dict.set((0, $2npvA.default).of('Type'), (0, $2npvA.default).of('XRef'));
        return _this;
    }
    PDFCrossRefStream.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        var type = $37df6718066d5b2e$export$e41c32906b33062a.Deleted;
        this.entries.push({
            type: type,
            ref: ref,
            nextFreeObjectNumber: nextFreeObjectNumber
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addUncompressedEntry = function(ref, offset) {
        var type = $37df6718066d5b2e$export$e41c32906b33062a.Uncompressed;
        this.entries.push({
            type: type,
            ref: ref,
            offset: offset
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addCompressedEntry = function(ref, objectStreamRef, index) {
        var type = $37df6718066d5b2e$export$e41c32906b33062a.Compressed;
        this.entries.push({
            type: type,
            ref: ref,
            objectStreamRef: objectStreamRef,
            index: index
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.clone = function(context) {
        var _a = this, dict = _a.dict, entries = _a.entries, encode = _a.encode;
        return PDFCrossRefStream.of(dict.clone(context), entries.slice(), encode);
    };
    PDFCrossRefStream.prototype.getContentsString = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var value = '';
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $4LYfy.reverseArray)((0, $bv0iE.bytesFor)(first));
            var secondBytes = (0, $4LYfy.reverseArray)((0, $bv0iE.bytesFor)(second));
            var thirdBytes = (0, $4LYfy.reverseArray)((0, $bv0iE.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)value += (firstBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)value += (secondBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)value += (thirdBytes[idx] || 0).toString(2);
        }
        return value;
    };
    PDFCrossRefStream.prototype.getUnencodedContents = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $4LYfy.reverseArray)((0, $bv0iE.bytesFor)(first));
            var secondBytes = (0, $4LYfy.reverseArray)((0, $bv0iE.bytesFor)(second));
            var thirdBytes = (0, $4LYfy.reverseArray)((0, $bv0iE.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)buffer[offset++] = firstBytes[idx] || 0;
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)buffer[offset++] = secondBytes[idx] || 0;
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)buffer[offset++] = thirdBytes[idx] || 0;
        }
        return buffer;
    };
    PDFCrossRefStream.prototype.getUnencodedContentsSize = function() {
        var byteWidths = this.maxByteWidthsCache.access();
        var entryWidth = (0, $4LYfy.sum)(byteWidths);
        return entryWidth * this.entries.length;
    };
    PDFCrossRefStream.prototype.updateDict = function() {
        _super.prototype.updateDict.call(this);
        var byteWidths = this.maxByteWidthsCache.access();
        var index = this.indexCache.access();
        var context = this.dict.context;
        this.dict.set((0, $2npvA.default).of('W'), context.obj(byteWidths));
        this.dict.set((0, $2npvA.default).of('Index'), context.obj(index));
    };
    PDFCrossRefStream.create = function(dict, encode) {
        if (encode === void 0) encode = true;
        var stream = new PDFCrossRefStream(dict, [], encode);
        stream.addDeletedEntry((0, $dac7b6b491336f5d$export$2e2bcd8739ae039).of(0, 65535), 0);
        return stream;
    };
    PDFCrossRefStream.of = function(dict, entries, encode) {
        if (encode === void 0) encode = true;
        return new PDFCrossRefStream(dict, entries, encode);
    };
    return PDFCrossRefStream;
}((0, $d07fc0ef1d82823f$export$2e2bcd8739ae039));
var $37df6718066d5b2e$export$2e2bcd8739ae039 = $37df6718066d5b2e$var$PDFCrossRefStream;




parcelRequire("5w6hV");
var $4LYfy = parcelRequire("4LYfy");
var $9J7bS = parcelRequire("9J7bS");
var $e0f5b824d34cbb80$var$PDFStreamWriter = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFStreamWriter, _super);
    function PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream) {
        var _this = _super.call(this, context, objectsPerTick) || this;
        _this.encodeStreams = encodeStreams;
        _this.objectsPerStream = objectsPerStream;
        return _this;
    }
    PDFStreamWriter.prototype.computeBufferSize = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var objectNumber, header, size, xrefStream, uncompressedObjects, compressedObjects, objectStreamRefs, indirectObjects, idx, len, indirectObject, ref, object, shouldNotCompress, chunk, objectStreamRef, idx, len, chunk, ref, objectStream, xrefStreamRef, xrefOffset, trailer;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        objectNumber = this.context.largestObjectNumber + 1;
                        header = (0, $ba9da13d8e8ae04e$export$2e2bcd8739ae039).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xrefStream = (0, $37df6718066d5b2e$export$2e2bcd8739ae039).create(this.createTrailerDict(), this.encodeStreams);
                        uncompressedObjects = [];
                        compressedObjects = [];
                        objectStreamRefs = [];
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            6
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0], object = indirectObject[1];
                        shouldNotCompress = ref === this.context.trailerInfo.Encrypt || object instanceof (0, $1b80b011925bffc2$export$2e2bcd8739ae039) || object instanceof (0, $ed19c0faaed1b241$export$2e2bcd8739ae039) || ref.generationNumber !== 0;
                        if (!shouldNotCompress) return [
                            3 /*break*/ ,
                            4
                        ];
                        uncompressedObjects.push(indirectObject);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $9J7bS.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        chunk = (0, $4LYfy.last)(compressedObjects);
                        objectStreamRef = (0, $4LYfy.last)(objectStreamRefs);
                        if (!chunk || chunk.length % this.objectsPerStream === 0) {
                            chunk = [];
                            compressedObjects.push(chunk);
                            objectStreamRef = (0, $dac7b6b491336f5d$export$2e2bcd8739ae039).of(objectNumber++);
                            objectStreamRefs.push(objectStreamRef);
                        }
                        xrefStream.addCompressedEntry(ref, objectStreamRef, chunk.length);
                        chunk.push(indirectObject);
                        _a.label = 5;
                    case 5:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 6:
                        idx = 0, len = compressedObjects.length;
                        _a.label = 7;
                    case 7:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            10
                        ];
                        chunk = compressedObjects[idx];
                        ref = objectStreamRefs[idx];
                        objectStream = (0, $4d5b123fbd2cdac2$export$2e2bcd8739ae039).withContextAndObjects(this.context, chunk, this.encodeStreams);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize([
                            ref,
                            objectStream
                        ]);
                        uncompressedObjects.push([
                            ref,
                            objectStream
                        ]);
                        if (!this.shouldWaitForTick(chunk.length)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $9J7bS.waitForTick)()
                        ];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        idx++;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 10:
                        xrefStreamRef = (0, $dac7b6b491336f5d$export$2e2bcd8739ae039).of(objectNumber++);
                        xrefStream.dict.set((0, $2npvA.default).of('Size'), (0, $dKRgb.default).of(objectNumber));
                        xrefStream.addUncompressedEntry(xrefStreamRef, size);
                        xrefOffset = size;
                        size += this.computeIndirectObjectSize([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        uncompressedObjects.push([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        trailer = (0, $dd71effa95b04295$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: uncompressedObjects,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFStreamWriter.forContext = function(context, objectsPerTick, encodeStreams, objectsPerStream) {
        if (encodeStreams === void 0) encodeStreams = true;
        if (objectsPerStream === void 0) objectsPerStream = 50;
        return new PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream);
    };
    return PDFStreamWriter;
}((0, $3b0651781259edc6$export$2e2bcd8739ae039));
var $e0f5b824d34cbb80$export$2e2bcd8739ae039 = $e0f5b824d34cbb80$var$PDFStreamWriter;






parcelRequire("kLYdZ");
var $46WCp = parcelRequire("46WCp");
var $9h1QL = parcelRequire("9h1QL");

var $47XJ3 = parcelRequire("47XJ3");

var $l0PqT = parcelRequire("l0PqT");

var $90Qf4 = parcelRequire("90Qf4");
parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
var $asRCt = parcelRequire("asRCt");
var $8YZBr = parcelRequire("8YZBr");

var $6AcCU = parcelRequire("6AcCU");
var $f752a7014a04a4bd$var$PDFHexString = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFHexString, _super);
    function PDFHexString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFHexString.prototype.asBytes = function() {
        // Append a zero if the number of digits is odd. See PDF spec 7.3.4.3
        var hex = this.value + (this.value.length % 2 === 1 ? '0' : '');
        var hexLength = hex.length;
        var bytes = new Uint8Array(hex.length / 2);
        var hexOffset = 0;
        var bytesOffset = 0;
        // Interpret each pair of hex digits as a single byte
        while(hexOffset < hexLength){
            var byte = parseInt(hex.substring(hexOffset, hexOffset + 2), 16);
            bytes[bytesOffset] = byte;
            hexOffset += 2;
            bytesOffset += 1;
        }
        return bytes;
    };
    PDFHexString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $asRCt.hasUtf16BOM)(bytes)) return (0, $asRCt.utf16Decode)(bytes);
        return (0, $8YZBr.pdfDocEncodingDecode)(bytes);
    };
    PDFHexString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $8ZzAZ.parseDate)(text);
        if (!date) throw new (0, $6AcCU.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFHexString.prototype.asString = function() {
        return this.value;
    };
    PDFHexString.prototype.clone = function() {
        return PDFHexString.of(this.value);
    };
    PDFHexString.prototype.toString = function() {
        return "<" + this.value + ">";
    };
    PDFHexString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFHexString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $90Qf4.default).LessThan;
        offset += (0, $8ZzAZ.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $90Qf4.default).GreaterThan;
        return this.value.length + 2;
    };
    PDFHexString.of = function(value) {
        return new PDFHexString(value);
    };
    PDFHexString.fromText = function(value) {
        var encoded = (0, $asRCt.utf16Encode)(value);
        var hex = '';
        for(var idx = 0, len = encoded.length; idx < len; idx++)hex += (0, $8ZzAZ.toHexStringOfMinLength)(encoded[idx], 4);
        return new PDFHexString(hex);
    };
    return PDFHexString;
}((0, $l0PqT.default));
var $f752a7014a04a4bd$export$2e2bcd8739ae039 = $f752a7014a04a4bd$var$PDFHexString;


parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/f91bdd61c164a72ea06be1a43dc0a412afc3925f/lib/font/afm.coffee
 */ var $d778657fca830008$var$StandardFontEmbedder = /** @class */ function() {
    function StandardFontEmbedder(fontName, customName) {
        // prettier-ignore
        this.encoding = fontName === (0, $9h1QL.FontNames).ZapfDingbats ? (0, $46WCp.Encodings).ZapfDingbats : fontName === (0, $9h1QL.FontNames).Symbol ? (0, $46WCp.Encodings).Symbol : (0, $46WCp.Encodings).WinAnsi;
        this.font = (0, $9h1QL.Font).load(fontName);
        this.fontName = this.font.FontName;
        this.customName = customName;
    }
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but standard fonts use either WinAnsi, ZapfDingbats, or Symbol
     * encodings)
     */ StandardFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $8ZzAZ.toHexString)(glyphs[idx].code);
        return (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).of(hexCodes.join(''));
    };
    StandardFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var left = glyphs[idx].name;
            var right = (glyphs[idx + 1] || {}).name;
            var kernAmount = this.font.getXAxisKerningForPair(left, right) || 0;
            totalWidth += this.widthOfGlyph(left) + kernAmount;
        }
        var scale = size / 1000;
        return totalWidth * scale;
    };
    StandardFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, Ascender = _b.Ascender, Descender = _b.Descender, FontBBox = _b.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        var height = yTop - yBottom;
        if (!descender) height += Descender || 0;
        return height / 1000 * size;
    };
    StandardFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, Ascender = _a.Ascender, Descender = _a.Descender, FontBBox = _a.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        return 1000 * height / (yTop - yBottom);
    };
    StandardFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        var fontDict = context.obj({
            Type: 'Font',
            Subtype: 'Type1',
            BaseFont: this.customName || this.fontName,
            Encoding: this.encoding === (0, $46WCp.Encodings).WinAnsi ? 'WinAnsiEncoding' : undefined
        });
        if (ref) {
            context.assign(ref, fontDict);
            return ref;
        } else return context.register(fontDict);
    };
    StandardFontEmbedder.prototype.widthOfGlyph = function(glyphName) {
        // Default to 250 if font doesn't specify a width
        return this.font.getWidthOfGlyph(glyphName) || 250;
    };
    StandardFontEmbedder.prototype.encodeTextAsGlyphs = function(text) {
        var codePoints = Array.from(text);
        var glyphs = new Array(codePoints.length);
        for(var idx = 0, len = codePoints.length; idx < len; idx++){
            var codePoint = (0, $8ZzAZ.toCodePoint)(codePoints[idx]);
            glyphs[idx] = this.encoding.encodeUnicodeCodePoint(codePoint);
        }
        return glyphs;
    };
    StandardFontEmbedder.for = function(fontName, customName) {
        return new StandardFontEmbedder(fontName, customName);
    };
    return StandardFontEmbedder;
}();
var $d778657fca830008$export$2e2bcd8739ae039 = $d778657fca830008$var$StandardFontEmbedder;



var $47XJ3 = parcelRequire("47XJ3");
parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");

var $asRCt = parcelRequire("asRCt");
var $25948782afeeb4f1$export$ecb273704ecc155f = function(glyphs, glyphId) {
    var bfChars = new Array(glyphs.length);
    for(var idx = 0, len = glyphs.length; idx < len; idx++){
        var glyph = glyphs[idx];
        var id = $25948782afeeb4f1$var$cmapHexFormat($25948782afeeb4f1$var$cmapHexString(glyphId(glyph)));
        var unicode = $25948782afeeb4f1$var$cmapHexFormat.apply(void 0, glyph.codePoints.map($25948782afeeb4f1$var$cmapCodePointFormat));
        bfChars[idx] = [
            id,
            unicode
        ];
    }
    return $25948782afeeb4f1$var$fillCmapTemplate(bfChars);
};
/* =============================== Templates ================================ */ var $25948782afeeb4f1$var$fillCmapTemplate = function(bfChars) {
    return "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n" + bfChars.length + " beginbfchar\n" + bfChars.map(function(_a) {
        var glyphId = _a[0], codePoint = _a[1];
        return glyphId + " " + codePoint;
    }).join('\n') + "\nendbfchar\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
};
/* =============================== Utilities ================================ */ var $25948782afeeb4f1$var$cmapHexFormat = function() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return "<" + values.join('') + ">";
};
var $25948782afeeb4f1$var$cmapHexString = function(value) {
    return (0, $8ZzAZ.toHexStringOfMinLength)(value, 4);
};
var $25948782afeeb4f1$var$cmapCodePointFormat = function(codePoint) {
    if ((0, $asRCt.isWithinBMP)(codePoint)) return $25948782afeeb4f1$var$cmapHexString(codePoint);
    if ((0, $asRCt.hasSurrogates)(codePoint)) {
        var hs = (0, $asRCt.highSurrogate)(codePoint);
        var ls = (0, $asRCt.lowSurrogate)(codePoint);
        return "" + $25948782afeeb4f1$var$cmapHexString(hs) + $25948782afeeb4f1$var$cmapHexString(ls);
    }
    var hex = (0, $8ZzAZ.toHexString)(codePoint);
    var msg = "0x" + hex + " is not a valid UTF-8 or UTF-16 codepoint.";
    throw new Error(msg);
};


// prettier-ignore
var $06d5f826d8fd262e$var$makeFontFlags = function(options) {
    var flags = 0;
    var flipBit = function(bit) {
        flags |= 1 << bit - 1;
    };
    if (options.fixedPitch) flipBit(1);
    if (options.serif) flipBit(2);
    if (options.symbolic) flipBit(3);
    if (options.script) flipBit(4);
    if (options.nonsymbolic) flipBit(6);
    if (options.italic) flipBit(7);
    if (options.allCap) flipBit(17);
    if (options.smallCap) flipBit(18);
    if (options.forceBold) flipBit(19);
    return flags;
};
var $06d5f826d8fd262e$export$aa92af1a056b24e8 = function(font) {
    var familyClass = font['OS/2'] ? font['OS/2'].sFamilyClass : 0;
    var flags = $06d5f826d8fd262e$var$makeFontFlags({
        fixedPitch: font.post.isFixedPitch,
        serif: 1 <= familyClass && familyClass <= 7,
        symbolic: true,
        script: familyClass === 10,
        italic: font.head.macStyle.italic
    });
    return flags;
};




var $47XJ3 = parcelRequire("47XJ3");

var $l0PqT = parcelRequire("l0PqT");

var $90Qf4 = parcelRequire("90Qf4");
parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
var $asRCt = parcelRequire("asRCt");
var $8YZBr = parcelRequire("8YZBr");

var $6AcCU = parcelRequire("6AcCU");
var $14cdd14f9837102b$var$PDFString = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFString, _super);
    function PDFString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFString.prototype.asBytes = function() {
        var bytes = [];
        var octal = '';
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 0, len = this.value.length; idx < len; idx++){
            var char = this.value[idx];
            var byte = (0, $8ZzAZ.toCharCode)(char);
            var nextChar = this.value[idx + 1];
            if (!escaped) {
                if (byte === (0, $90Qf4.default).BackSlash) escaped = true;
                else pushByte(byte);
            } else {
                if (byte === (0, $90Qf4.default).Newline) pushByte();
                else if (byte === (0, $90Qf4.default).CarriageReturn) pushByte();
                else if (byte === (0, $90Qf4.default).n) pushByte((0, $90Qf4.default).Newline);
                else if (byte === (0, $90Qf4.default).r) pushByte((0, $90Qf4.default).CarriageReturn);
                else if (byte === (0, $90Qf4.default).t) pushByte((0, $90Qf4.default).Tab);
                else if (byte === (0, $90Qf4.default).b) pushByte((0, $90Qf4.default).Backspace);
                else if (byte === (0, $90Qf4.default).f) pushByte((0, $90Qf4.default).FormFeed);
                else if (byte === (0, $90Qf4.default).LeftParen) pushByte((0, $90Qf4.default).LeftParen);
                else if (byte === (0, $90Qf4.default).RightParen) pushByte((0, $90Qf4.default).RightParen);
                else if (byte === (0, $90Qf4.default).Backspace) pushByte((0, $90Qf4.default).BackSlash);
                else if (byte >= (0, $90Qf4.default).Zero && byte <= (0, $90Qf4.default).Seven) {
                    octal += char;
                    if (octal.length === 3 || !(nextChar >= '0' && nextChar <= '7')) {
                        pushByte(parseInt(octal, 8));
                        octal = '';
                    }
                } else pushByte(byte);
            }
        }
        return new Uint8Array(bytes);
    };
    PDFString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $asRCt.hasUtf16BOM)(bytes)) return (0, $asRCt.utf16Decode)(bytes);
        return (0, $8YZBr.pdfDocEncodingDecode)(bytes);
    };
    PDFString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $8ZzAZ.parseDate)(text);
        if (!date) throw new (0, $6AcCU.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFString.prototype.asString = function() {
        return this.value;
    };
    PDFString.prototype.clone = function() {
        return PDFString.of(this.value);
    };
    PDFString.prototype.toString = function() {
        return "(" + this.value + ")";
    };
    PDFString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $90Qf4.default).LeftParen;
        offset += (0, $8ZzAZ.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $90Qf4.default).RightParen;
        return this.value.length + 2;
    };
    // The PDF spec allows newlines and parens to appear directly within a literal
    // string. These character _may_ be escaped. But they do not _have_ to be. So
    // for simplicity, we will not bother escaping them.
    PDFString.of = function(value) {
        return new PDFString(value);
    };
    PDFString.fromDate = function(date) {
        var year = (0, $8ZzAZ.padStart)(String(date.getUTCFullYear()), 4, '0');
        var month = (0, $8ZzAZ.padStart)(String(date.getUTCMonth() + 1), 2, '0');
        var day = (0, $8ZzAZ.padStart)(String(date.getUTCDate()), 2, '0');
        var hours = (0, $8ZzAZ.padStart)(String(date.getUTCHours()), 2, '0');
        var mins = (0, $8ZzAZ.padStart)(String(date.getUTCMinutes()), 2, '0');
        var secs = (0, $8ZzAZ.padStart)(String(date.getUTCSeconds()), 2, '0');
        return new PDFString("D:" + year + month + day + hours + mins + secs + "Z");
    };
    return PDFString;
}((0, $l0PqT.default));
var $14cdd14f9837102b$export$2e2bcd8739ae039 = $14cdd14f9837102b$var$PDFString;


parcelRequire("5w6hV");
var $4LYfy = parcelRequire("4LYfy");
var $fdd94 = parcelRequire("fdd94");
var $8ZzAZ = parcelRequire("8ZzAZ");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $0bb5e016ec464ab5$var$CustomFontEmbedder = /** @class */ function() {
    function CustomFontEmbedder(font, fontData, customName, fontFeatures) {
        var _this = this;
        this.allGlyphsInFontSortedById = function() {
            var glyphs = new Array(_this.font.characterSet.length);
            for(var idx = 0, len = glyphs.length; idx < len; idx++){
                var codePoint = _this.font.characterSet[idx];
                glyphs[idx] = _this.font.glyphForCodePoint(codePoint);
            }
            return (0, $4LYfy.sortedUniq)(glyphs.sort((0, $4LYfy.byAscendingId)), function(g) {
                return g.id;
            });
        };
        this.font = font;
        this.scale = 1000 / this.font.unitsPerEm;
        this.fontData = fontData;
        this.fontName = this.font.postscriptName || 'Font';
        this.customName = customName;
        this.fontFeatures = fontFeatures;
        this.baseFontName = '';
        this.glyphCache = (0, $fdd94.default).populatedBy(this.allGlyphsInFontSortedById);
    }
    CustomFontEmbedder.for = function(fontkit, fontData, customName, fontFeatures) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontEmbedder(font, fontData, customName, fontFeatures)
                        ];
                }
            });
        });
    };
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but embedded fonts use their own custom encodings)
     */ CustomFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $8ZzAZ.toHexStringOfMinLength)(glyphs[idx].id, 4);
        return (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).of(hexCodes.join(''));
    };
    // The advanceWidth takes into account kerning automatically, so we don't
    // have to do that manually like we do for the standard fonts.
    CustomFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++)totalWidth += glyphs[idx].advanceWidth * this.scale;
        var scale = size / 1000;
        return totalWidth * scale;
    };
    CustomFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, ascent = _b.ascent, descent = _b.descent, bbox = _b.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        var height = yTop - yBottom;
        if (!descender) height -= Math.abs(descent) || 0;
        return height / 1000 * size;
    };
    CustomFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, ascent = _a.ascent, descent = _a.descent, bbox = _a.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        return 1000 * height / (yTop - yBottom);
    };
    CustomFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        this.baseFontName = this.customName || context.addRandomSuffix(this.fontName);
        return this.embedFontDict(context, ref);
    };
    CustomFontEmbedder.prototype.embedFontDict = function(context, ref) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var cidFontDictRef, unicodeCMapRef, fontDict;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedCIDFontDict(context)
                        ];
                    case 1:
                        cidFontDictRef = _a.sent();
                        unicodeCMapRef = this.embedUnicodeCmap(context);
                        fontDict = context.obj({
                            Type: 'Font',
                            Subtype: 'Type0',
                            BaseFont: this.baseFontName,
                            Encoding: 'Identity-H',
                            DescendantFonts: [
                                cidFontDictRef
                            ],
                            ToUnicode: unicodeCMapRef
                        });
                        if (ref) {
                            context.assign(ref, fontDict);
                            return [
                                2 /*return*/ ,
                                ref
                            ];
                        } else return [
                            2 /*return*/ ,
                            context.register(fontDict)
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.isCFF = function() {
        return this.font.cff;
    };
    CustomFontEmbedder.prototype.embedCIDFontDict = function(context) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var fontDescriptorRef, cidFontDict;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontDescriptor(context)
                        ];
                    case 1:
                        fontDescriptorRef = _a.sent();
                        cidFontDict = context.obj({
                            Type: 'Font',
                            Subtype: this.isCFF() ? 'CIDFontType0' : 'CIDFontType2',
                            CIDToGIDMap: 'Identity',
                            BaseFont: this.baseFontName,
                            CIDSystemInfo: {
                                Registry: (0, $14cdd14f9837102b$export$2e2bcd8739ae039).of('Adobe'),
                                Ordering: (0, $14cdd14f9837102b$export$2e2bcd8739ae039).of('Identity'),
                                Supplement: 0
                            },
                            FontDescriptor: fontDescriptorRef,
                            W: this.computeWidths()
                        });
                        return [
                            2 /*return*/ ,
                            context.register(cidFontDict)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontDescriptor = function(context) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var fontStreamRef, scale, _a, italicAngle, ascent, descent, capHeight, xHeight, _b, minX, minY, maxX, maxY, fontDescriptor;
            var _c;
            return (0, $47XJ3.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontStream(context)
                        ];
                    case 1:
                        fontStreamRef = _d.sent();
                        scale = this.scale;
                        _a = this.font, italicAngle = _a.italicAngle, ascent = _a.ascent, descent = _a.descent, capHeight = _a.capHeight, xHeight = _a.xHeight;
                        _b = this.font.bbox, minX = _b.minX, minY = _b.minY, maxX = _b.maxX, maxY = _b.maxY;
                        fontDescriptor = context.obj((_c = {
                            Type: 'FontDescriptor',
                            FontName: this.baseFontName,
                            Flags: (0, $06d5f826d8fd262e$export$aa92af1a056b24e8)(this.font),
                            FontBBox: [
                                minX * scale,
                                minY * scale,
                                maxX * scale,
                                maxY * scale
                            ],
                            ItalicAngle: italicAngle,
                            Ascent: ascent * scale,
                            Descent: descent * scale,
                            CapHeight: (capHeight || ascent) * scale,
                            XHeight: (xHeight || 0) * scale,
                            // Not sure how to compute/find this, nor is anybody else really:
                            // https://stackoverflow.com/questions/35485179/stemv-value-of-the-truetype-font
                            StemV: 0
                        }, _c[this.isCFF() ? 'FontFile3' : 'FontFile2'] = fontStreamRef, _c));
                        return [
                            2 /*return*/ ,
                            context.register(fontDescriptor)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.serializeFont = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            return (0, $47XJ3.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.fontData
                ];
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontStream = function(context) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var fontStream, _a, _b;
            return (0, $47XJ3.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = (_a = context).flateStream;
                        return [
                            4 /*yield*/ ,
                            this.serializeFont()
                        ];
                    case 1:
                        fontStream = _b.apply(_a, [
                            _c.sent(),
                            {
                                Subtype: this.isCFF() ? 'CIDFontType0C' : undefined
                            }
                        ]);
                        return [
                            2 /*return*/ ,
                            context.register(fontStream)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedUnicodeCmap = function(context) {
        var cmap = (0, $25948782afeeb4f1$export$ecb273704ecc155f)(this.glyphCache.access(), this.glyphId.bind(this));
        var cmapStream = context.flateStream(cmap);
        return context.register(cmapStream);
    };
    CustomFontEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? glyph.id : -1;
    };
    CustomFontEmbedder.prototype.computeWidths = function() {
        var glyphs = this.glyphCache.access();
        var widths = [];
        var currSection = [];
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var currGlyph = glyphs[idx];
            var prevGlyph = glyphs[idx - 1];
            var currGlyphId = this.glyphId(currGlyph);
            var prevGlyphId = this.glyphId(prevGlyph);
            if (idx === 0) widths.push(currGlyphId);
            else if (currGlyphId - prevGlyphId !== 1) {
                widths.push(currSection);
                widths.push(currGlyphId);
                currSection = [];
            }
            currSection.push(currGlyph.advanceWidth * this.scale);
        }
        widths.push(currSection);
        return widths;
    };
    return CustomFontEmbedder;
}();
var $0bb5e016ec464ab5$export$2e2bcd8739ae039 = $0bb5e016ec464ab5$var$CustomFontEmbedder;



var $47XJ3 = parcelRequire("47XJ3");


parcelRequire("5w6hV");
var $fdd94 = parcelRequire("fdd94");
var $4LYfy = parcelRequire("4LYfy");
var $8ZzAZ = parcelRequire("8ZzAZ");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $a8abb68c47435824$var$CustomFontSubsetEmbedder = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(CustomFontSubsetEmbedder, _super);
    function CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures) {
        var _this = _super.call(this, font, fontData, customFontName, fontFeatures) || this;
        _this.subset = _this.font.createSubset();
        _this.glyphs = [];
        _this.glyphCache = (0, $fdd94.default).populatedBy(function() {
            return _this.glyphs;
        });
        _this.glyphIdMap = new Map();
        return _this;
    }
    CustomFontSubsetEmbedder.for = function(fontkit, fontData, customFontName, fontFeatures) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures)
                        ];
                }
            });
        });
    };
    CustomFontSubsetEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var glyph = glyphs[idx];
            var subsetGlyphId = this.subset.includeGlyph(glyph);
            this.glyphs[subsetGlyphId - 1] = glyph;
            this.glyphIdMap.set(glyph.id, subsetGlyphId);
            hexCodes[idx] = (0, $8ZzAZ.toHexStringOfMinLength)(subsetGlyphId, 4);
        }
        this.glyphCache.invalidate();
        return (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).of(hexCodes.join(''));
    };
    CustomFontSubsetEmbedder.prototype.isCFF = function() {
        return this.subset.cff;
    };
    CustomFontSubsetEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? this.glyphIdMap.get(glyph.id) : -1;
    };
    CustomFontSubsetEmbedder.prototype.serializeFont = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var parts = [];
            _this.subset.encodeStream().on('data', function(bytes) {
                return parts.push(bytes);
            }).on('end', function() {
                return resolve((0, $4LYfy.mergeUint8Arrays)(parts));
            }).on('error', function(err) {
                return reject(err);
            });
        });
    };
    return CustomFontSubsetEmbedder;
}((0, $0bb5e016ec464ab5$export$2e2bcd8739ae039));
var $a8abb68c47435824$export$2e2bcd8739ae039 = $a8abb68c47435824$var$CustomFontSubsetEmbedder;



var $47XJ3 = parcelRequire("47XJ3");


var $35d045ee31589a91$export$c12eac46fbec1b74;
(function(AFRelationship) {
    AFRelationship["Source"] = "Source";
    AFRelationship["Data"] = "Data";
    AFRelationship["Alternative"] = "Alternative";
    AFRelationship["Supplement"] = "Supplement";
    AFRelationship["EncryptedPayload"] = "EncryptedPayload";
    AFRelationship["FormData"] = "EncryptedPayload";
    AFRelationship["Schema"] = "Schema";
    AFRelationship["Unspecified"] = "Unspecified";
})($35d045ee31589a91$export$c12eac46fbec1b74 || ($35d045ee31589a91$export$c12eac46fbec1b74 = {}));
var $35d045ee31589a91$var$FileEmbedder = /** @class */ function() {
    function FileEmbedder(fileData, fileName, options) {
        if (options === void 0) options = {};
        this.fileData = fileData;
        this.fileName = fileName;
        this.options = options;
    }
    FileEmbedder.for = function(bytes, fileName, options) {
        if (options === void 0) options = {};
        return new FileEmbedder(bytes, fileName, options);
    };
    FileEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var _a, mimeType, description, creationDate, modificationDate, afRelationship, embeddedFileStream, embeddedFileStreamRef, fileSpecDict;
            return (0, $47XJ3.__generator)(this, function(_b) {
                _a = this.options, mimeType = _a.mimeType, description = _a.description, creationDate = _a.creationDate, modificationDate = _a.modificationDate, afRelationship = _a.afRelationship;
                embeddedFileStream = context.flateStream(this.fileData, {
                    Type: 'EmbeddedFile',
                    Subtype: mimeType !== null && mimeType !== void 0 ? mimeType : undefined,
                    Params: {
                        Size: this.fileData.length,
                        CreationDate: creationDate ? (0, $14cdd14f9837102b$export$2e2bcd8739ae039).fromDate(creationDate) : undefined,
                        ModDate: modificationDate ? (0, $14cdd14f9837102b$export$2e2bcd8739ae039).fromDate(modificationDate) : undefined
                    }
                });
                embeddedFileStreamRef = context.register(embeddedFileStream);
                fileSpecDict = context.obj({
                    Type: 'Filespec',
                    F: (0, $14cdd14f9837102b$export$2e2bcd8739ae039).of(this.fileName),
                    UF: (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(this.fileName),
                    EF: {
                        F: embeddedFileStreamRef
                    },
                    Desc: description ? (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(description) : undefined,
                    AFRelationship: afRelationship !== null && afRelationship !== void 0 ? afRelationship : undefined
                });
                if (ref) {
                    context.assign(ref, fileSpecDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(fileSpecDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return FileEmbedder;
}();
var $35d045ee31589a91$export$2e2bcd8739ae039 = $35d045ee31589a91$var$FileEmbedder;



var $47XJ3 = parcelRequire("47XJ3");
// prettier-ignore
var $8fc02cbbe0289d96$var$MARKERS = [
    0xffc0,
    0xffc1,
    0xffc2,
    0xffc3,
    0xffc5,
    0xffc6,
    0xffc7,
    0xffc8,
    0xffc9,
    0xffca,
    0xffcb,
    0xffcc,
    0xffcd,
    0xffce,
    0xffcf
];
var $8fc02cbbe0289d96$var$ColorSpace;
(function(ColorSpace) {
    ColorSpace["DeviceGray"] = "DeviceGray";
    ColorSpace["DeviceRGB"] = "DeviceRGB";
    ColorSpace["DeviceCMYK"] = "DeviceCMYK";
})($8fc02cbbe0289d96$var$ColorSpace || ($8fc02cbbe0289d96$var$ColorSpace = {}));
var $8fc02cbbe0289d96$var$ChannelToColorSpace = {
    1: $8fc02cbbe0289d96$var$ColorSpace.DeviceGray,
    3: $8fc02cbbe0289d96$var$ColorSpace.DeviceRGB,
    4: $8fc02cbbe0289d96$var$ColorSpace.DeviceCMYK
};
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/a6af76467ce06bd6a2af4aa7271ccac9ff152a7d/lib/image/jpeg.js
 */ var $8fc02cbbe0289d96$var$JpegEmbedder = /** @class */ function() {
    function JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace) {
        this.imageData = imageData;
        this.bitsPerComponent = bitsPerComponent;
        this.width = width;
        this.height = height;
        this.colorSpace = colorSpace;
    }
    JpegEmbedder.for = function(imageData) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var dataView, soi, pos, marker, bitsPerComponent, height, width, channelByte, channelName, colorSpace;
            return (0, $47XJ3.__generator)(this, function(_a) {
                dataView = new DataView(imageData.buffer);
                soi = dataView.getUint16(0);
                if (soi !== 0xffd8) throw new Error('SOI not found in JPEG');
                pos = 2;
                while(pos < dataView.byteLength){
                    marker = dataView.getUint16(pos);
                    pos += 2;
                    if ($8fc02cbbe0289d96$var$MARKERS.includes(marker)) break;
                    pos += dataView.getUint16(pos);
                }
                if (!$8fc02cbbe0289d96$var$MARKERS.includes(marker)) throw new Error('Invalid JPEG');
                pos += 2;
                bitsPerComponent = dataView.getUint8(pos++);
                height = dataView.getUint16(pos);
                pos += 2;
                width = dataView.getUint16(pos);
                pos += 2;
                channelByte = dataView.getUint8(pos++);
                channelName = $8fc02cbbe0289d96$var$ChannelToColorSpace[channelByte];
                if (!channelName) throw new Error('Unknown JPEG channel.');
                colorSpace = channelName;
                return [
                    2 /*return*/ ,
                    new JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace)
                ];
            });
        });
    };
    JpegEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var xObject;
            return (0, $47XJ3.__generator)(this, function(_a) {
                xObject = context.stream(this.imageData, {
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.bitsPerComponent,
                    Width: this.width,
                    Height: this.height,
                    ColorSpace: this.colorSpace,
                    Filter: 'DCTDecode',
                    // CMYK JPEG streams in PDF are typically stored complemented,
                    // with 1 as 'off' and 0 as 'on' (PDF 32000-1:2008, 8.6.4.4).
                    //
                    // Standalone CMYK JPEG (usually exported by Photoshop) are
                    // stored inverse, with 0 as 'off' and 1 as 'on', like RGB.
                    //
                    // Applying a swap here as a hedge that most bytes passing
                    // through this method will benefit from it.
                    Decode: this.colorSpace === $8fc02cbbe0289d96$var$ColorSpace.DeviceCMYK ? [
                        1,
                        0,
                        1,
                        0,
                        1,
                        0,
                        1,
                        0
                    ] : undefined
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JpegEmbedder;
}();
var $8fc02cbbe0289d96$export$2e2bcd8739ae039 = $8fc02cbbe0289d96$var$JpegEmbedder;



var $47XJ3 = parcelRequire("47XJ3");

var $hjofF = parcelRequire("hjofF");
var $cd7c49497361173c$var$UPNG = {};
$cd7c49497361173c$var$UPNG.toRGBA8 = function(out) {
    var w = out.width, h = out.height;
    if (out.tabs.acTL == null) return [
        $cd7c49497361173c$var$UPNG.toRGBA8.decodeImage(out.data, w, h, out).buffer
    ];
    var frms = [];
    if (out.frames[0].data == null) out.frames[0].data = out.data;
    var len = w * h * 4, img = new Uint8Array(len), empty = new Uint8Array(len), prev = new Uint8Array(len);
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i];
        var fx = frm.rect.x, fy = frm.rect.y, fw = frm.rect.width, fh = frm.rect.height;
        var fdata = $cd7c49497361173c$var$UPNG.toRGBA8.decodeImage(frm.data, fw, fh, out);
        if (i != 0) for(var j = 0; j < len; j++)prev[j] = img[j];
        if (frm.blend == 0) $cd7c49497361173c$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.blend == 1) $cd7c49497361173c$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 1);
        frms.push(img.buffer.slice(0));
        if (frm.dispose == 0) ;
        else if (frm.dispose == 1) $cd7c49497361173c$var$UPNG._copyTile(empty, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.dispose == 2) for(var j = 0; j < len; j++)img[j] = prev[j];
    }
    return frms;
};
$cd7c49497361173c$var$UPNG.toRGBA8.decodeImage = function(data, w, h, out) {
    var area = w * h, bpp = $cd7c49497361173c$var$UPNG.decode._getBPP(out);
    var bpl = Math.ceil(w * bpp / 8); // bytes per line
    var bf = new Uint8Array(area * 4), bf32 = new Uint32Array(bf.buffer);
    var ctype = out.ctype, depth = out.depth;
    var rs = $cd7c49497361173c$var$UPNG._bin.readUshort;
    //console.log(ctype, depth);
    var time = Date.now();
    if (ctype == 6) {
        var qarea = area << 2;
        if (depth == 8) for(var i = 0; i < qarea; i += 4){
            bf[i] = data[i];
            bf[i + 1] = data[i + 1];
            bf[i + 2] = data[i + 2];
            bf[i + 3] = data[i + 3];
        }
        if (depth == 16) for(var i = 0; i < qarea; i++)bf[i] = data[i << 1];
    } else if (ctype == 2) {
        var ts = out.tabs["tRNS"];
        if (ts == null) {
            if (depth == 8) for(var i = 0; i < area; i++){
                var ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
            }
        } else {
            var tr = ts[0], tg = ts[1], tb = ts[2];
            if (depth == 8) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
                if (data[ti] == tr && data[ti + 1] == tg && data[ti + 2] == tb) bf[qi + 3] = 0;
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
                if (rs(data, ti) == tr && rs(data, ti + 2) == tg && rs(data, ti + 4) == tb) bf[qi + 3] = 0;
            }
        }
    } else if (ctype == 3) {
        var p = out.tabs["PLTE"], ap = out.tabs["tRNS"], tl = ap ? ap.length : 0;
        //console.log(p, ap);
        if (depth == 1) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 3)] >> 7 - ((i & 7) << 0) & 1, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 2) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 2)] >> 6 - ((i & 3) << 1) & 3, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 4) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 1)] >> 4 - ((i & 1) << 2) & 15, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, j = data[i], cj = 3 * j;
            bf[qi] = p[cj];
            bf[qi + 1] = p[cj + 1];
            bf[qi + 2] = p[cj + 2];
            bf[qi + 3] = j < tl ? ap[j] : 255;
        }
    } else if (ctype == 4) {
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 1, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 1];
        }
        if (depth == 16) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 2, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 2];
        }
    } else if (ctype == 0) {
        var tr = out.tabs["tRNS"] ? out.tabs["tRNS"] : -1;
        for(var y = 0; y < h; y++){
            var off = y * bpl, to = y * w;
            if (depth == 1) for(var x = 0; x < w; x++){
                var gr = 255 * (data[off + (x >>> 3)] >>> 7 - (x & 7) & 1), al = gr == tr * 255 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 2) for(var x = 0; x < w; x++){
                var gr = 85 * (data[off + (x >>> 2)] >>> 6 - ((x & 3) << 1) & 3), al = gr == tr * 85 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 4) for(var x = 0; x < w; x++){
                var gr = 17 * (data[off + (x >>> 1)] >>> 4 - ((x & 1) << 2) & 15), al = gr == tr * 17 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 8) for(var x = 0; x < w; x++){
                var gr = data[off + x], al = gr == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 16) for(var x = 0; x < w; x++){
                var gr = data[off + (x << 1)], al = rs(data, off + (x << i)) == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
        }
    }
    //console.log(Date.now()-time);
    return bf;
};
$cd7c49497361173c$var$UPNG.decode = function(buff) {
    var data = new Uint8Array(buff), offset = 8, bin = $cd7c49497361173c$var$UPNG._bin, rUs = bin.readUshort, rUi = bin.readUint;
    var out = {
        tabs: {},
        frames: []
    };
    var dd = new Uint8Array(data.length), doff = 0; // put all IDAT data into it
    var fd, foff = 0; // frames
    var mgck = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)if (data[i] != mgck[i]) throw "The input is not a PNG file!";
    while(offset < data.length){
        var len = bin.readUint(data, offset);
        offset += 4;
        var type = bin.readASCII(data, offset, 4);
        offset += 4;
        //console.log(type,len);
        if (type == "IHDR") $cd7c49497361173c$var$UPNG.decode._IHDR(data, offset, out);
        else if (type == "IDAT") {
            for(var i = 0; i < len; i++)dd[doff + i] = data[offset + i];
            doff += len;
        } else if (type == "acTL") {
            out.tabs[type] = {
                num_frames: rUi(data, offset),
                num_plays: rUi(data, offset + 4)
            };
            fd = new Uint8Array(data.length);
        } else if (type == "fcTL") {
            if (foff != 0) {
                var fr = out.frames[out.frames.length - 1];
                fr.data = $cd7c49497361173c$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
                foff = 0;
            }
            var rct = {
                x: rUi(data, offset + 12),
                y: rUi(data, offset + 16),
                width: rUi(data, offset + 4),
                height: rUi(data, offset + 8)
            };
            var del = rUs(data, offset + 22);
            del = rUs(data, offset + 20) / (del == 0 ? 100 : del);
            var frm = {
                rect: rct,
                delay: Math.round(del * 1000),
                dispose: data[offset + 24],
                blend: data[offset + 25]
            };
            //console.log(frm);
            out.frames.push(frm);
        } else if (type == "fdAT") {
            for(var i = 0; i < len - 4; i++)fd[foff + i] = data[offset + i + 4];
            foff += len - 4;
        } else if (type == "pHYs") out.tabs[type] = [
            bin.readUint(data, offset),
            bin.readUint(data, offset + 4),
            data[offset + 8]
        ];
        else if (type == "cHRM") {
            out.tabs[type] = [];
            for(var i = 0; i < 8; i++)out.tabs[type].push(bin.readUint(data, offset + i * 4));
        } else if (type == "tEXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = bin.nextZero(data, offset);
            var keyw = bin.readASCII(data, offset, nz - offset);
            var text = bin.readASCII(data, nz + 1, offset + len - nz - 1);
            out.tabs[type][keyw] = text;
        } else if (type == "iTXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = 0, off = offset;
            nz = bin.nextZero(data, off);
            var keyw = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            var cflag = data[off], cmeth = data[off + 1];
            off += 2;
            nz = bin.nextZero(data, off);
            var ltag = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            nz = bin.nextZero(data, off);
            var tkeyw = bin.readUTF8(data, off, nz - off);
            off = nz + 1;
            var text = bin.readUTF8(data, off, len - (off - offset));
            out.tabs[type][keyw] = text;
        } else if (type == "PLTE") out.tabs[type] = bin.readBytes(data, offset, len);
        else if (type == "hIST") {
            var pl = out.tabs["PLTE"].length / 3;
            out.tabs[type] = [];
            for(var i = 0; i < pl; i++)out.tabs[type].push(rUs(data, offset + i * 2));
        } else if (type == "tRNS") {
            if (out.ctype == 3) out.tabs[type] = bin.readBytes(data, offset, len);
            else if (out.ctype == 0) out.tabs[type] = rUs(data, offset);
            else if (out.ctype == 2) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
        //else console.log("tRNS for unsupported color type",out.ctype, len);
        } else if (type == "gAMA") out.tabs[type] = bin.readUint(data, offset) / 100000;
        else if (type == "sRGB") out.tabs[type] = data[offset];
        else if (type == "bKGD") {
            if (out.ctype == 0 || out.ctype == 4) out.tabs[type] = [
                rUs(data, offset)
            ];
            else if (out.ctype == 2 || out.ctype == 6) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
            else if (out.ctype == 3) out.tabs[type] = data[offset];
        } else if (type == "IEND") break;
        //else {  log("unknown chunk type", type, len);  }
        offset += len;
        var crc = bin.readUint(data, offset);
        offset += 4;
    }
    if (foff != 0) {
        var fr = out.frames[out.frames.length - 1];
        fr.data = $cd7c49497361173c$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
        foff = 0;
    }
    out.data = $cd7c49497361173c$var$UPNG.decode._decompress(out, dd, out.width, out.height);
    delete out.compress;
    delete out.interlace;
    delete out.filter;
    return out;
};
$cd7c49497361173c$var$UPNG.decode._decompress = function(out, dd, w, h) {
    var time = Date.now();
    var bpp = $cd7c49497361173c$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), buff = new Uint8Array((bpl + 1 + out.interlace) * h);
    dd = $cd7c49497361173c$var$UPNG.decode._inflate(dd, buff);
    //console.log(dd.length, buff.length);
    //console.log(Date.now()-time);
    var time = Date.now();
    if (out.interlace == 0) dd = $cd7c49497361173c$var$UPNG.decode._filterZero(dd, out, 0, w, h);
    else if (out.interlace == 1) dd = $cd7c49497361173c$var$UPNG.decode._readInterlace(dd, out);
    //console.log(Date.now()-time);
    return dd;
};
$cd7c49497361173c$var$UPNG.decode._inflate = function(data, buff) {
    var out = $cd7c49497361173c$var$UPNG["inflateRaw"](new Uint8Array(data.buffer, 2, data.length - 6), buff);
    return out;
};
$cd7c49497361173c$var$UPNG.inflateRaw = function() {
    var H = {};
    H.H = {};
    H.H.N = function(N, W) {
        var R = Uint8Array, i = 0, m = 0, J = 0, h = 0, Q = 0, X = 0, u = 0, w = 0, d = 0, v, C;
        if (N[0] == 3 && N[1] == 0) return W ? W : new R(0);
        var V = H.H, n = V.b, A = V.e, l = V.R, M = V.n, I = V.A, e = V.Z, b = V.m, Z = W == null;
        if (Z) W = new R(N.length >>> 2 << 3);
        while(i == 0){
            i = n(N, d, 1);
            m = n(N, d + 1, 2);
            d += 3;
            if (m == 0) {
                if ((d & 7) != 0) d += 8 - (d & 7);
                var D = (d >>> 3) + 4, q = N[D - 4] | N[D - 3] << 8;
                if (Z) W = H.H.W(W, w + q);
                W.set(new R(N.buffer, N.byteOffset + D, q), w);
                d = D + q << 3;
                w += q;
                continue;
            }
            if (Z) W = H.H.W(W, w + 131072);
            if (m == 1) {
                v = b.J;
                C = b.h;
                X = 511;
                u = 31;
            }
            if (m == 2) {
                J = A(N, d, 5) + 257;
                h = A(N, d + 5, 5) + 1;
                Q = A(N, d + 10, 4) + 4;
                d += 14;
                var E = d, j = 1;
                for(var c = 0; c < 38; c += 2){
                    b.Q[c] = 0;
                    b.Q[c + 1] = 0;
                }
                for(var c = 0; c < Q; c++){
                    var K = A(N, d + c * 3, 3);
                    b.Q[(b.X[c] << 1) + 1] = K;
                    if (K > j) j = K;
                }
                d += 3 * Q;
                M(b.Q, j);
                I(b.Q, j, b.u);
                v = b.w;
                C = b.d;
                d = l(b.u, (1 << j) - 1, J + h, N, d, b.v);
                var r = V.V(b.v, 0, J, b.C);
                X = (1 << r) - 1;
                var S = V.V(b.v, J, h, b.D);
                u = (1 << S) - 1;
                M(b.C, r);
                I(b.C, r, v);
                M(b.D, S);
                I(b.D, S, C);
            }
            while(true){
                var T = v[e(N, d) & X];
                d += T & 15;
                var p = T >>> 4;
                if (p >>> 8 == 0) W[w++] = p;
                else if (p == 256) break;
                else {
                    var z = w + p - 254;
                    if (p > 264) {
                        var _ = b.q[p - 257];
                        z = w + (_ >>> 3) + A(N, d, _ & 7);
                        d += _ & 7;
                    }
                    var $ = C[e(N, d) & u];
                    d += $ & 15;
                    var s = $ >>> 4, Y = b.c[s], a = (Y >>> 4) + n(N, d, Y & 15);
                    d += Y & 15;
                    while(w < z){
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                    }
                    w = z;
                }
            }
        }
        return W.length == w ? W : W.slice(0, w);
    };
    H.H.W = function(N, W) {
        var R = N.length;
        if (W <= R) return N;
        var V = new Uint8Array(R << 1);
        V.set(N, 0);
        return V;
    };
    H.H.R = function(N, W, R, V, n, A) {
        var l = H.H.e, M = H.H.Z, I = 0;
        while(I < R){
            var e = N[M(V, n) & W];
            n += e & 15;
            var b = e >>> 4;
            if (b <= 15) {
                A[I] = b;
                I++;
            } else {
                var Z = 0, m = 0;
                if (b == 16) {
                    m = 3 + l(V, n, 2);
                    n += 2;
                    Z = A[I - 1];
                } else if (b == 17) {
                    m = 3 + l(V, n, 3);
                    n += 3;
                } else if (b == 18) {
                    m = 11 + l(V, n, 7);
                    n += 7;
                }
                var J = I + m;
                while(I < J){
                    A[I] = Z;
                    I++;
                }
            }
        }
        return n;
    };
    H.H.V = function(N, W, R, V) {
        var n = 0, A = 0, l = V.length >>> 1;
        while(A < R){
            var M = N[A + W];
            V[A << 1] = 0;
            V[(A << 1) + 1] = M;
            if (M > n) n = M;
            A++;
        }
        while(A < l){
            V[A << 1] = 0;
            V[(A << 1) + 1] = 0;
            A++;
        }
        return n;
    };
    H.H.n = function(N, W) {
        var R = H.H.m, V = N.length, n, A, l, M, I, e = R.j;
        for(var M = 0; M <= W; M++)e[M] = 0;
        for(M = 1; M < V; M += 2)e[N[M]]++;
        var b = R.K;
        n = 0;
        e[0] = 0;
        for(A = 1; A <= W; A++){
            n = n + e[A - 1] << 1;
            b[A] = n;
        }
        for(l = 0; l < V; l += 2){
            I = N[l + 1];
            if (I != 0) {
                N[l] = b[I];
                b[I]++;
            }
        }
    };
    H.H.A = function(N, W, R) {
        var V = N.length, n = H.H.m, A = n.r;
        for(var l = 0; l < V; l += 2)if (N[l + 1] != 0) {
            var M = l >> 1, I = N[l + 1], e = M << 4 | I, b = W - I, Z = N[l] << b, m = Z + (1 << b);
            while(Z != m){
                var J = A[Z] >>> 15 - W;
                R[J] = e;
                Z++;
            }
        }
    };
    H.H.l = function(N, W) {
        var R = H.H.m.r, V = 15 - W;
        for(var n = 0; n < N.length; n += 2){
            var A = N[n] << W - N[n + 1];
            N[n] = R[A] >>> V;
        }
    };
    H.H.M = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
    };
    H.H.I = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
        N[V + 2] |= R >>> 16;
    };
    H.H.e = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.b = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.Z = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7);
    };
    H.H.i = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16 | N[(W >>> 3) + 3] << 24) >>> (W & 7);
    };
    H.H.m = function() {
        var N = Uint16Array, W = Uint32Array;
        return {
            K: new N(16),
            j: new N(16),
            X: [
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ],
            S: [
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                13,
                15,
                17,
                19,
                23,
                27,
                31,
                35,
                43,
                51,
                59,
                67,
                83,
                99,
                115,
                131,
                163,
                195,
                227,
                258,
                999,
                999,
                999
            ],
            T: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                3,
                3,
                3,
                3,
                4,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                0,
                0,
                0,
                0
            ],
            q: new N(32),
            p: [
                1,
                2,
                3,
                4,
                5,
                7,
                9,
                13,
                17,
                25,
                33,
                49,
                65,
                97,
                129,
                193,
                257,
                385,
                513,
                769,
                1025,
                1537,
                2049,
                3073,
                4097,
                6145,
                8193,
                12289,
                16385,
                24577,
                65535,
                65535
            ],
            z: [
                0,
                0,
                0,
                0,
                1,
                1,
                2,
                2,
                3,
                3,
                4,
                4,
                5,
                5,
                6,
                6,
                7,
                7,
                8,
                8,
                9,
                9,
                10,
                10,
                11,
                11,
                12,
                12,
                13,
                13,
                0,
                0
            ],
            c: new W(32),
            J: new N(512),
            _: [],
            h: new N(32),
            $: [],
            w: new N(32768),
            C: [],
            v: [],
            d: new N(32768),
            D: [],
            u: new N(512),
            Q: [],
            r: new N(32768),
            s: new W(286),
            Y: new W(30),
            a: new W(19),
            t: new W(15e3),
            k: new N(65536),
            g: new N(32768)
        };
    }();
    (function() {
        var N = H.H.m, W = 32768;
        for(var R = 0; R < W; R++){
            var V = R;
            V = (V & 2863311530) >>> 1 | (V & 1431655765) << 1;
            V = (V & 3435973836) >>> 2 | (V & 858993459) << 2;
            V = (V & 4042322160) >>> 4 | (V & 252645135) << 4;
            V = (V & 4278255360) >>> 8 | (V & 16711935) << 8;
            N.r[R] = (V >>> 16 | V << 16) >>> 17;
        }
        function n(A, l, M) {
            while(l-- != 0)A.push(0, M);
        }
        for(var R = 0; R < 32; R++){
            N.q[R] = N.S[R] << 3 | N.T[R];
            N.c[R] = N.p[R] << 4 | N.z[R];
        }
        n(N._, 144, 8);
        n(N._, 112, 9);
        n(N._, 24, 7);
        n(N._, 8, 8);
        H.H.n(N._, 9);
        H.H.A(N._, 9, N.J);
        H.H.l(N._, 9);
        n(N.$, 32, 5);
        H.H.n(N.$, 5);
        H.H.A(N.$, 5, N.h);
        H.H.l(N.$, 5);
        n(N.Q, 19, 0);
        n(N.C, 286, 0);
        n(N.D, 30, 0);
        n(N.v, 320, 0);
    })();
    return H.H.N;
}();
$cd7c49497361173c$var$UPNG.decode._readInterlace = function(data, out) {
    var w = out.width, h = out.height;
    var bpp = $cd7c49497361173c$var$UPNG.decode._getBPP(out), cbpp = bpp >> 3, bpl = Math.ceil(w * bpp / 8);
    var img = new Uint8Array(h * bpl);
    var di = 0;
    var starting_row = [
        0,
        0,
        4,
        0,
        2,
        0,
        1
    ];
    var starting_col = [
        0,
        4,
        0,
        2,
        0,
        1,
        0
    ];
    var row_increment = [
        8,
        8,
        8,
        4,
        4,
        2,
        2
    ];
    var col_increment = [
        8,
        8,
        4,
        4,
        2,
        2,
        1
    ];
    var pass = 0;
    while(pass < 7){
        var ri = row_increment[pass], ci = col_increment[pass];
        var sw = 0, sh = 0;
        var cr = starting_row[pass];
        while(cr < h){
            cr += ri;
            sh++;
        }
        var cc = starting_col[pass];
        while(cc < w){
            cc += ci;
            sw++;
        }
        var bpll = Math.ceil(sw * bpp / 8);
        $cd7c49497361173c$var$UPNG.decode._filterZero(data, out, di, sw, sh);
        var y = 0, row = starting_row[pass];
        while(row < h){
            var col = starting_col[pass];
            var cdi = di + y * bpll << 3;
            while(col < w){
                if (bpp == 1) {
                    var val = data[cdi >> 3];
                    val = val >> 7 - (cdi & 7) & 1;
                    img[row * bpl + (col >> 3)] |= val << 7 - ((col & 7) << 0);
                }
                if (bpp == 2) {
                    var val = data[cdi >> 3];
                    val = val >> 6 - (cdi & 7) & 3;
                    img[row * bpl + (col >> 2)] |= val << 6 - ((col & 3) << 1);
                }
                if (bpp == 4) {
                    var val = data[cdi >> 3];
                    val = val >> 4 - (cdi & 7) & 15;
                    img[row * bpl + (col >> 1)] |= val << 4 - ((col & 1) << 2);
                }
                if (bpp >= 8) {
                    var ii = row * bpl + col * cbpp;
                    for(var j = 0; j < cbpp; j++)img[ii + j] = data[(cdi >> 3) + j];
                }
                cdi += bpp;
                col += ci;
            }
            y++;
            row += ri;
        }
        if (sw * sh != 0) di += sh * (1 + bpll);
        pass = pass + 1;
    }
    return img;
};
$cd7c49497361173c$var$UPNG.decode._getBPP = function(out) {
    var noc = [
        1,
        null,
        3,
        1,
        2,
        null,
        4
    ][out.ctype];
    return noc * out.depth;
};
$cd7c49497361173c$var$UPNG.decode._filterZero = function(data, out, off, w, h) {
    var bpp = $cd7c49497361173c$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), paeth = $cd7c49497361173c$var$UPNG.decode._paeth;
    bpp = Math.ceil(bpp / 8);
    var i = 0, di = 1, type = data[off], x = 0;
    if (type > 1) data[off] = [
        0,
        0,
        1
    ][type - 2];
    if (type == 3) for(x = bpp; x < bpl; x++)data[x + 1] = data[x + 1] + (data[x + 1 - bpp] >>> 1) & 255;
    for(var y = 0; y < h; y++){
        i = off + y * bpl;
        di = i + y + 1;
        type = data[di - 1];
        x = 0;
        if (type == 0) for(; x < bpl; x++)data[i + x] = data[di + x];
        else if (type == 1) {
            for(; x < bpp; x++)data[i + x] = data[di + x];
            for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpp];
        } else if (type == 2) for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpl];
        else if (type == 3) {
            for(; x < bpp; x++)data[i + x] = data[di + x] + (data[i + x - bpl] >>> 1);
            for(; x < bpl; x++)data[i + x] = data[di + x] + (data[i + x - bpl] + data[i + x - bpp] >>> 1);
        } else {
            for(; x < bpp; x++)data[i + x] = data[di + x] + paeth(0, data[i + x - bpl], 0);
            for(; x < bpl; x++)data[i + x] = data[di + x] + paeth(data[i + x - bpp], data[i + x - bpl], data[i + x - bpp - bpl]);
        }
    }
    return data;
};
$cd7c49497361173c$var$UPNG.decode._paeth = function(a, b, c) {
    var p = a + b - c, pa = p - a, pb = p - b, pc = p - c;
    if (pa * pa <= pb * pb && pa * pa <= pc * pc) return a;
    else if (pb * pb <= pc * pc) return b;
    return c;
};
$cd7c49497361173c$var$UPNG.decode._IHDR = function(data, offset, out) {
    var bin = $cd7c49497361173c$var$UPNG._bin;
    out.width = bin.readUint(data, offset);
    offset += 4;
    out.height = bin.readUint(data, offset);
    offset += 4;
    out.depth = data[offset];
    offset++;
    out.ctype = data[offset];
    offset++;
    out.compress = data[offset];
    offset++;
    out.filter = data[offset];
    offset++;
    out.interlace = data[offset];
    offset++;
};
$cd7c49497361173c$var$UPNG._bin = {
    nextZero: function(data, p) {
        while(data[p] != 0)p++;
        return p;
    },
    readUshort: function(buff, p) {
        return buff[p] << 8 | buff[p + 1];
    },
    writeUshort: function(buff, p, n) {
        buff[p] = n >> 8 & 255;
        buff[p + 1] = n & 255;
    },
    readUint: function(buff, p) {
        return buff[p] * 16777216 + (buff[p + 1] << 16 | buff[p + 2] << 8 | buff[p + 3]);
    },
    writeUint: function(buff, p, n) {
        buff[p] = n >> 24 & 255;
        buff[p + 1] = n >> 16 & 255;
        buff[p + 2] = n >> 8 & 255;
        buff[p + 3] = n & 255;
    },
    readASCII: function(buff, p, l) {
        var s = "";
        for(var i = 0; i < l; i++)s += String.fromCharCode(buff[p + i]);
        return s;
    },
    writeASCII: function(data, p, s) {
        for(var i = 0; i < s.length; i++)data[p + i] = s.charCodeAt(i);
    },
    readBytes: function(buff, p, l) {
        var arr = [];
        for(var i = 0; i < l; i++)arr.push(buff[p + i]);
        return arr;
    },
    pad: function(n) {
        return n.length < 2 ? "0" + n : n;
    },
    readUTF8: function(buff, p, l) {
        var s = "", ns;
        for(var i = 0; i < l; i++)s += "%" + $cd7c49497361173c$var$UPNG._bin.pad(buff[p + i].toString(16));
        try {
            ns = decodeURIComponent(s);
        } catch (e) {
            return $cd7c49497361173c$var$UPNG._bin.readASCII(buff, p, l);
        }
        return ns;
    }
};
$cd7c49497361173c$var$UPNG._copyTile = function(sb, sw, sh, tb, tw, th, xoff, yoff, mode) {
    var w = Math.min(sw, tw), h = Math.min(sh, th);
    var si = 0, ti = 0;
    for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
        if (xoff >= 0 && yoff >= 0) {
            si = y * sw + x << 2;
            ti = (yoff + y) * tw + xoff + x << 2;
        } else {
            si = (-yoff + y) * sw - xoff + x << 2;
            ti = y * tw + x << 2;
        }
        if (mode == 0) {
            tb[ti] = sb[si];
            tb[ti + 1] = sb[si + 1];
            tb[ti + 2] = sb[si + 2];
            tb[ti + 3] = sb[si + 3];
        } else if (mode == 1) {
            var fa = sb[si + 3] * (1 / 255), fr = sb[si] * fa, fg = sb[si + 1] * fa, fb = sb[si + 2] * fa;
            var ba = tb[ti + 3] * (1 / 255), br = tb[ti] * ba, bg = tb[ti + 1] * ba, bb = tb[ti + 2] * ba;
            var ifa = 1 - fa, oa = fa + ba * ifa, ioa = oa == 0 ? 0 : 1 / oa;
            tb[ti + 3] = 255 * oa;
            tb[ti + 0] = (fr + br * ifa) * ioa;
            tb[ti + 1] = (fg + bg * ifa) * ioa;
            tb[ti + 2] = (fb + bb * ifa) * ioa;
        } else if (mode == 2) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) {
                tb[ti] = 0;
                tb[ti + 1] = 0;
                tb[ti + 2] = 0;
                tb[ti + 3] = 0;
            } else {
                tb[ti] = fr;
                tb[ti + 1] = fg;
                tb[ti + 2] = fb;
                tb[ti + 3] = fa;
            }
        } else if (mode == 3) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) continue;
            //if(fa!=255 && ba!=0) return false;
            if (fa < 220 && ba > 20) return false;
        }
    }
    return true;
};
$cd7c49497361173c$var$UPNG.encode = function(bufs, w, h, ps, dels, tabs, forbidPlte) {
    if (ps == null) ps = 0;
    if (forbidPlte == null) forbidPlte = false;
    var nimg = $cd7c49497361173c$var$UPNG.encode.compress(bufs, w, h, ps, [
        false,
        false,
        false,
        0,
        forbidPlte
    ]);
    $cd7c49497361173c$var$UPNG.encode.compressPNG(nimg, -1);
    return $cd7c49497361173c$var$UPNG.encode._main(nimg, w, h, dels, tabs);
};
$cd7c49497361173c$var$UPNG.encodeLL = function(bufs, w, h, cc, ac, depth, dels, tabs) {
    var nimg = {
        ctype: 0 + (cc == 1 ? 0 : 2) + (ac == 0 ? 0 : 4),
        depth: depth,
        frames: []
    };
    var time = Date.now();
    var bipp = (cc + ac) * depth, bipl = bipp * w;
    for(var i = 0; i < bufs.length; i++)nimg.frames.push({
        rect: {
            x: 0,
            y: 0,
            width: w,
            height: h
        },
        img: new Uint8Array(bufs[i]),
        blend: 0,
        dispose: 1,
        bpp: Math.ceil(bipp / 8),
        bpl: Math.ceil(bipl / 8)
    });
    $cd7c49497361173c$var$UPNG.encode.compressPNG(nimg, 0, true);
    var out = $cd7c49497361173c$var$UPNG.encode._main(nimg, w, h, dels, tabs);
    return out;
};
$cd7c49497361173c$var$UPNG.encode._main = function(nimg, w, h, dels, tabs) {
    if (tabs == null) tabs = {};
    var crc = $cd7c49497361173c$var$UPNG.crc.crc, wUi = $cd7c49497361173c$var$UPNG._bin.writeUint, wUs = $cd7c49497361173c$var$UPNG._bin.writeUshort, wAs = $cd7c49497361173c$var$UPNG._bin.writeASCII;
    var offset = 8, anim = nimg.frames.length > 1, pltAlpha = false;
    var leng = 33 + (anim ? 20 : 0);
    if (tabs["sRGB"] != null) leng += 13;
    if (tabs["pHYs"] != null) leng += 21;
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        for(var i = 0; i < dl; i++)if (nimg.plte[i] >>> 24 != 255) pltAlpha = true;
        leng += 8 + dl * 3 + 4 + (pltAlpha ? 8 + dl * 1 + 4 : 0);
    }
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) leng += 38;
        leng += fr.cimg.length + 12;
        if (j != 0) leng += 4;
    }
    leng += 12;
    var data = new Uint8Array(leng);
    var wr = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)data[i] = wr[i];
    wUi(data, offset, 13);
    offset += 4;
    wAs(data, offset, "IHDR");
    offset += 4;
    wUi(data, offset, w);
    offset += 4;
    wUi(data, offset, h);
    offset += 4;
    data[offset] = nimg.depth;
    offset++; // depth
    data[offset] = nimg.ctype;
    offset++; // ctype
    data[offset] = 0;
    offset++; // compress
    data[offset] = 0;
    offset++; // filter
    data[offset] = 0;
    offset++; // interlace
    wUi(data, offset, crc(data, offset - 17, 17));
    offset += 4; // crc
    // 13 bytes to say, that it is sRGB
    if (tabs["sRGB"] != null) {
        wUi(data, offset, 1);
        offset += 4;
        wAs(data, offset, "sRGB");
        offset += 4;
        data[offset] = tabs["sRGB"];
        offset++;
        wUi(data, offset, crc(data, offset - 5, 5));
        offset += 4; // crc
    }
    if (tabs["pHYs"] != null) {
        wUi(data, offset, 9);
        offset += 4;
        wAs(data, offset, "pHYs");
        offset += 4;
        wUi(data, offset, tabs["pHYs"][0]);
        offset += 4;
        wUi(data, offset, tabs["pHYs"][1]);
        offset += 4;
        data[offset] = tabs["pHYs"][2];
        offset++;
        wUi(data, offset, crc(data, offset - 13, 13));
        offset += 4; // crc
    }
    if (anim) {
        wUi(data, offset, 8);
        offset += 4;
        wAs(data, offset, "acTL");
        offset += 4;
        wUi(data, offset, nimg.frames.length);
        offset += 4;
        wUi(data, offset, tabs["loop"] != null ? tabs["loop"] : 0);
        offset += 4;
        wUi(data, offset, crc(data, offset - 12, 12));
        offset += 4; // crc
    }
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        wUi(data, offset, dl * 3);
        offset += 4;
        wAs(data, offset, "PLTE");
        offset += 4;
        for(var i = 0; i < dl; i++){
            var ti = i * 3, c = nimg.plte[i], r = c & 255, g = c >>> 8 & 255, b = c >>> 16 & 255;
            data[offset + ti + 0] = r;
            data[offset + ti + 1] = g;
            data[offset + ti + 2] = b;
        }
        offset += dl * 3;
        wUi(data, offset, crc(data, offset - dl * 3 - 4, dl * 3 + 4));
        offset += 4; // crc
        if (pltAlpha) {
            wUi(data, offset, dl);
            offset += 4;
            wAs(data, offset, "tRNS");
            offset += 4;
            for(var i = 0; i < dl; i++)data[offset + i] = nimg.plte[i] >>> 24 & 255;
            offset += dl;
            wUi(data, offset, crc(data, offset - dl - 4, dl + 4));
            offset += 4; // crc
        }
    }
    var fi = 0;
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) {
            wUi(data, offset, 26);
            offset += 4;
            wAs(data, offset, "fcTL");
            offset += 4;
            wUi(data, offset, fi++);
            offset += 4;
            wUi(data, offset, fr.rect.width);
            offset += 4;
            wUi(data, offset, fr.rect.height);
            offset += 4;
            wUi(data, offset, fr.rect.x);
            offset += 4;
            wUi(data, offset, fr.rect.y);
            offset += 4;
            wUs(data, offset, dels[j]);
            offset += 2;
            wUs(data, offset, 1000);
            offset += 2;
            data[offset] = fr.dispose;
            offset++; // dispose
            data[offset] = fr.blend;
            offset++; // blend
            wUi(data, offset, crc(data, offset - 30, 30));
            offset += 4; // crc
        }
        var imgd = fr.cimg, dl = imgd.length;
        wUi(data, offset, dl + (j == 0 ? 0 : 4));
        offset += 4;
        var ioff = offset;
        wAs(data, offset, j == 0 ? "IDAT" : "fdAT");
        offset += 4;
        if (j != 0) {
            wUi(data, offset, fi++);
            offset += 4;
        }
        data.set(imgd, offset);
        offset += dl;
        wUi(data, offset, crc(data, ioff, offset - ioff));
        offset += 4; // crc
    }
    wUi(data, offset, 0);
    offset += 4;
    wAs(data, offset, "IEND");
    offset += 4;
    wUi(data, offset, crc(data, offset - 4, 4));
    offset += 4; // crc
    return data.buffer;
};
$cd7c49497361173c$var$UPNG.encode.compressPNG = function(out, filter, levelZero) {
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i], nw = frm.rect.width, nh = frm.rect.height;
        var fdata = new Uint8Array(nh * frm.bpl + nh);
        frm.cimg = $cd7c49497361173c$var$UPNG.encode._filterZero(frm.img, nh, frm.bpp, frm.bpl, fdata, filter, levelZero);
    }
};
$cd7c49497361173c$var$UPNG.encode.compress = function(bufs, w, h, ps, prms) {
    //var time = Date.now();
    var onlyBlend = prms[0], evenCrd = prms[1], forbidPrev = prms[2], minBits = prms[3], forbidPlte = prms[4];
    var ctype = 6, depth = 8, alphaAnd = 255;
    for(var j = 0; j < bufs.length; j++){
        var img = new Uint8Array(bufs[j]), ilen = img.length;
        for(var i = 0; i < ilen; i += 4)alphaAnd &= img[i + 3];
    }
    var gotAlpha = alphaAnd != 255;
    //console.log("alpha check", Date.now()-time);  time = Date.now();
    //var brute = gotAlpha && forGIF;		// brute : frames can only be copied, not "blended"
    var frms = $cd7c49497361173c$var$UPNG.encode.framize(bufs, w, h, onlyBlend, evenCrd, forbidPrev);
    //console.log("framize", Date.now()-time);  time = Date.now();
    var cmap = {}, plte = [], inds = [];
    if (ps != 0) {
        var nbufs = [];
        for(var i = 0; i < frms.length; i++)nbufs.push(frms[i].img.buffer);
        var abuf = $cd7c49497361173c$var$UPNG.encode.concatRGBA(nbufs), qres = $cd7c49497361173c$var$UPNG.quantize(abuf, ps);
        var cof = 0, bb = new Uint8Array(qres.abuf);
        for(var i = 0; i < frms.length; i++){
            var ti = frms[i].img, bln = ti.length;
            inds.push(new Uint8Array(qres.inds.buffer, cof >> 2, bln >> 2));
            for(var j = 0; j < bln; j += 4){
                ti[j] = bb[cof + j];
                ti[j + 1] = bb[cof + j + 1];
                ti[j + 2] = bb[cof + j + 2];
                ti[j + 3] = bb[cof + j + 3];
            }
            cof += bln;
        }
        for(var i = 0; i < qres.plte.length; i++)plte.push(qres.plte[i].est.rgba);
    //console.log("quantize", Date.now()-time);  time = Date.now();
    } else // what if ps==0, but there are <=256 colors?  we still need to detect, if the palette could be used
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], img32 = new Uint32Array(frm.img.buffer), nw = frm.rect.width, ilen = img32.length;
        var ind = new Uint8Array(ilen);
        inds.push(ind);
        for(var i = 0; i < ilen; i++){
            var c = img32[i];
            if (i != 0 && c == img32[i - 1]) ind[i] = ind[i - 1];
            else if (i > nw && c == img32[i - nw]) ind[i] = ind[i - nw];
            else {
                var cmc = cmap[c];
                if (cmc == null) {
                    cmap[c] = cmc = plte.length;
                    plte.push(c);
                    if (plte.length >= 300) break;
                }
                ind[i] = cmc;
            }
        }
    }
    var cc = plte.length; //console.log("colors:",cc);
    if (cc <= 256 && forbidPlte == false) {
        if (cc <= 2) depth = 1;
        else if (cc <= 4) depth = 2;
        else if (cc <= 16) depth = 4;
        else depth = 8;
        depth = Math.max(depth, minBits);
    }
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], nx = frm.rect.x, ny = frm.rect.y, nw = frm.rect.width, nh = frm.rect.height;
        var cimg = frm.img, cimg32 = new Uint32Array(cimg.buffer);
        var bpl = 4 * nw, bpp = 4;
        if (cc <= 256 && forbidPlte == false) {
            bpl = Math.ceil(depth * nw / 8);
            var nimg = new Uint8Array(bpl * nh);
            var inj = inds[j];
            for(var y = 0; y < nh; y++){
                var i = y * bpl, ii = y * nw;
                if (depth == 8) for(var x = 0; x < nw; x++)nimg[i + x] = inj[ii + x];
                else if (depth == 4) for(var x = 0; x < nw; x++)nimg[i + (x >> 1)] |= inj[ii + x] << 4 - (x & 1) * 4;
                else if (depth == 2) for(var x = 0; x < nw; x++)nimg[i + (x >> 2)] |= inj[ii + x] << 6 - (x & 3) * 2;
                else if (depth == 1) for(var x = 0; x < nw; x++)nimg[i + (x >> 3)] |= inj[ii + x] << 7 - (x & 7) * 1;
            }
            cimg = nimg;
            ctype = 3;
            bpp = 1;
        } else if (gotAlpha == false && frms.length == 1) {
            var nimg = new Uint8Array(nw * nh * 3), area = nw * nh;
            for(var i = 0; i < area; i++){
                var ti = i * 3, qi = i * 4;
                nimg[ti] = cimg[qi];
                nimg[ti + 1] = cimg[qi + 1];
                nimg[ti + 2] = cimg[qi + 2];
            }
            cimg = nimg;
            ctype = 2;
            bpp = 3;
            bpl = 3 * nw;
        }
        frm.img = cimg;
        frm.bpl = bpl;
        frm.bpp = bpp;
    }
    //console.log("colors => palette indices", Date.now()-time);  time = Date.now();
    return {
        ctype: ctype,
        depth: depth,
        plte: plte,
        frames: frms
    };
};
$cd7c49497361173c$var$UPNG.encode.framize = function(bufs, w, h, alwaysBlend, evenCrd, forbidPrev) {
    /*  DISPOSE
	    - 0 : no change
		- 1 : clear to transparent
		- 2 : retstore to content before rendering (previous frame disposed)
		BLEND
		- 0 : replace
		- 1 : blend
	*/ var frms = [];
    for(var j = 0; j < bufs.length; j++){
        var cimg = new Uint8Array(bufs[j]), cimg32 = new Uint32Array(cimg.buffer);
        var nimg;
        var nx = 0, ny = 0, nw = w, nh = h, blend = alwaysBlend ? 1 : 0;
        if (j != 0) {
            var tlim = forbidPrev || alwaysBlend || j == 1 || frms[j - 2].dispose != 0 ? 1 : 2, tstp = 0, tarea = 1e9;
            for(var it = 0; it < tlim; it++){
                var pimg = new Uint8Array(bufs[j - 1 - it]), p32 = new Uint32Array(bufs[j - 1 - it]);
                var mix = w, miy = h, max = -1, may = -1;
                for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
                    var i = y * w + x;
                    if (cimg32[i] != p32[i]) {
                        if (x < mix) mix = x;
                        if (x > max) max = x;
                        if (y < miy) miy = y;
                        if (y > may) may = y;
                    }
                }
                if (max == -1) mix = miy = max = may = 0;
                if (evenCrd) {
                    if ((mix & 1) == 1) mix--;
                    if ((miy & 1) == 1) miy--;
                }
                var sarea = (max - mix + 1) * (may - miy + 1);
                if (sarea < tarea) {
                    tarea = sarea;
                    tstp = it;
                    nx = mix;
                    ny = miy;
                    nw = max - mix + 1;
                    nh = may - miy + 1;
                }
            }
            // alwaysBlend: pokud zjistím, že blendit nelze, nastavím předchozímu snímku dispose=1. Zajistím, aby obsahoval můj obdélník.
            var pimg = new Uint8Array(bufs[j - 1 - tstp]);
            if (tstp == 1) frms[j - 1].dispose = 2;
            nimg = new Uint8Array(nw * nh * 4);
            $cd7c49497361173c$var$UPNG._copyTile(pimg, w, h, nimg, nw, nh, -nx, -ny, 0);
            blend = $cd7c49497361173c$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 3) ? 1 : 0;
            if (blend == 1) $cd7c49497361173c$var$UPNG.encode._prepareDiff(cimg, w, h, nimg, {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            });
            else $cd7c49497361173c$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 0);
        //UPNG._copyTile(cimg,w,h, nimg,nw,nh, -nx,-ny, blend==1?2:0);
        } else nimg = cimg.slice(0); // img may be rewritten further ... don't rewrite input
        frms.push({
            rect: {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            },
            img: nimg,
            blend: blend,
            dispose: 0
        });
    }
    if (alwaysBlend) for(var j = 0; j < frms.length; j++){
        var frm = frms[j];
        if (frm.blend == 1) continue;
        var r0 = frm.rect, r1 = frms[j - 1].rect;
        var miX = Math.min(r0.x, r1.x), miY = Math.min(r0.y, r1.y);
        var maX = Math.max(r0.x + r0.width, r1.x + r1.width), maY = Math.max(r0.y + r0.height, r1.y + r1.height);
        var r = {
            x: miX,
            y: miY,
            width: maX - miX,
            height: maY - miY
        };
        frms[j - 1].dispose = 1;
        if (j - 1 != 0) $cd7c49497361173c$var$UPNG.encode._updateFrame(bufs, w, h, frms, j - 1, r, evenCrd);
        $cd7c49497361173c$var$UPNG.encode._updateFrame(bufs, w, h, frms, j, r, evenCrd);
    }
    var area = 0;
    if (bufs.length != 1) for(var i = 0; i < frms.length; i++){
        var frm = frms[i];
        area += frm.rect.width * frm.rect.height;
    //if(i==0 || frm.blend!=1) continue;
    //var ob = new Uint8Array(
    //console.log(frm.blend, frm.dispose, frm.rect);
    }
    //if(area!=0) console.log(area);
    return frms;
};
$cd7c49497361173c$var$UPNG.encode._updateFrame = function(bufs, w, h, frms, i, r, evenCrd) {
    var U8 = Uint8Array, U32 = Uint32Array;
    var pimg = new U8(bufs[i - 1]), pimg32 = new U32(bufs[i - 1]), nimg = i + 1 < bufs.length ? new U8(bufs[i + 1]) : null;
    var cimg = new U8(bufs[i]), cimg32 = new U32(cimg.buffer);
    var mix = w, miy = h, max = -1, may = -1;
    for(var y = 0; y < r.height; y++)for(var x = 0; x < r.width; x++){
        var cx = r.x + x, cy = r.y + y;
        var j = cy * w + cx, cc = cimg32[j];
        // no need to draw transparency, or to dispose it. Or, if writing the same color and the next one does not need transparency.
        if (cc == 0 || frms[i - 1].dispose == 0 && pimg32[j] == cc && (nimg == null || nimg[j * 4 + 3] != 0)) ;
        else {
            if (cx < mix) mix = cx;
            if (cx > max) max = cx;
            if (cy < miy) miy = cy;
            if (cy > may) may = cy;
        }
    }
    if (max == -1) mix = miy = max = may = 0;
    if (evenCrd) {
        if ((mix & 1) == 1) mix--;
        if ((miy & 1) == 1) miy--;
    }
    r = {
        x: mix,
        y: miy,
        width: max - mix + 1,
        height: may - miy + 1
    };
    var fr = frms[i];
    fr.rect = r;
    fr.blend = 1;
    fr.img = new Uint8Array(r.width * r.height * 4);
    if (frms[i - 1].dispose == 0) {
        $cd7c49497361173c$var$UPNG._copyTile(pimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
        $cd7c49497361173c$var$UPNG.encode._prepareDiff(cimg, w, h, fr.img, r);
    //UPNG._copyTile(cimg,w,h, fr.img,r.width,r.height, -r.x,-r.y, 2);
    } else $cd7c49497361173c$var$UPNG._copyTile(cimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
};
$cd7c49497361173c$var$UPNG.encode._prepareDiff = function(cimg, w, h, nimg, rec) {
    $cd7c49497361173c$var$UPNG._copyTile(cimg, w, h, nimg, rec.width, rec.height, -rec.x, -rec.y, 2);
/*
	var n32 = new Uint32Array(nimg.buffer);
	var og = new Uint8Array(rec.width*rec.height*4), o32 = new Uint32Array(og.buffer);
	UPNG._copyTile(cimg,w,h, og,rec.width,rec.height, -rec.x,-rec.y, 0);
	for(var i=4; i<nimg.length; i+=4) {
		if(nimg[i-1]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)-1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}
	for(var i=nimg.length-8; i>0; i-=4) {
		if(nimg[i+7]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)+1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}*/ };
$cd7c49497361173c$var$UPNG.encode._filterZero = function(img, h, bpp, bpl, data, filter, levelZero) {
    var fls = [], ftry = [
        0,
        1,
        2,
        3,
        4
    ];
    if (filter != -1) ftry = [
        filter
    ];
    else if (h * bpl > 500000 || bpp == 1) ftry = [
        0
    ];
    var opts;
    if (levelZero) opts = {
        level: 0
    };
    var CMPR = levelZero && UZIP != null ? UZIP : (0, (/*@__PURE__*/$parcel$interopDefault($hjofF)));
    for(var i = 0; i < ftry.length; i++){
        for(var y = 0; y < h; y++)$cd7c49497361173c$var$UPNG.encode._filterLine(data, img, y, bpl, bpp, ftry[i]);
        //var nimg = new Uint8Array(data.length);
        //var sz = UZIP.F.deflate(data, nimg);  fls.push(nimg.slice(0,sz));
        //var dfl = pako["deflate"](data), dl=dfl.length-4;
        //var crc = (dfl[dl+3]<<24)|(dfl[dl+2]<<16)|(dfl[dl+1]<<8)|(dfl[dl+0]<<0);
        //console.log(crc, UZIP.adler(data,2,data.length-6));
        fls.push(CMPR["deflate"](data, opts));
    }
    var ti, tsize = 1e9;
    for(var i = 0; i < fls.length; i++)if (fls[i].length < tsize) {
        ti = i;
        tsize = fls[i].length;
    }
    return fls[ti];
};
$cd7c49497361173c$var$UPNG.encode._filterLine = function(data, img, y, bpl, bpp, type) {
    var i = y * bpl, di = i + y, paeth = $cd7c49497361173c$var$UPNG.decode._paeth;
    data[di] = type;
    di++;
    if (type == 0) {
        if (bpl < 500) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x];
        else data.set(new Uint8Array(img.buffer, i, bpl), di);
    } else if (type == 1) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - img[i + x - bpp] + 256 & 255;
    } else if (y == 0) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        if (type == 2) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x];
        if (type == 3) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - (img[i + x - bpp] >> 1) + 256 & 255;
        if (type == 4) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - paeth(img[i + x - bpp], 0, 0) + 256 & 255;
    } else {
        if (type == 2) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x] + 256 - img[i + x - bpl] & 255;
        if (type == 3) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] >> 1) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] + img[i + x - bpp] >> 1) & 255;
        }
        if (type == 4) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - paeth(0, img[i + x - bpl], 0) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - paeth(img[i + x - bpp], img[i + x - bpl], img[i + x - bpp - bpl]) & 255;
        }
    }
};
$cd7c49497361173c$var$UPNG.crc = {
    table: function() {
        var tab = new Uint32Array(256);
        for(var n = 0; n < 256; n++){
            var c = n;
            for(var k = 0; k < 8; k++)if (c & 1) c = 0xedb88320 ^ c >>> 1;
            else c = c >>> 1;
            tab[n] = c;
        }
        return tab;
    }(),
    update: function(c, buf, off, len) {
        for(var i = 0; i < len; i++)c = $cd7c49497361173c$var$UPNG.crc.table[(c ^ buf[off + i]) & 0xff] ^ c >>> 8;
        return c;
    },
    crc: function(b, o, l) {
        return $cd7c49497361173c$var$UPNG.crc.update(0xffffffff, b, o, l) ^ 0xffffffff;
    }
};
$cd7c49497361173c$var$UPNG.quantize = function(abuf, ps) {
    var oimg = new Uint8Array(abuf), nimg = oimg.slice(0), nimg32 = new Uint32Array(nimg.buffer);
    var KD = $cd7c49497361173c$var$UPNG.quantize.getKDtree(nimg, ps);
    var root = KD[0], leafs = KD[1];
    var planeDst = $cd7c49497361173c$var$UPNG.quantize.planeDst;
    var sb = oimg, tb = nimg32, len = sb.length;
    var inds = new Uint8Array(oimg.length >> 2);
    for(var i = 0; i < len; i += 4){
        var r = sb[i] * (1 / 255), g = sb[i + 1] * (1 / 255), b = sb[i + 2] * (1 / 255), a = sb[i + 3] * (1 / 255);
        //  exact, but too slow :(
        var nd = $cd7c49497361173c$var$UPNG.quantize.getNearest(root, r, g, b, a);
        //var nd = root;
        //while(nd.left) nd = (planeDst(nd.est,r,g,b,a)<=0) ? nd.left : nd.right;
        inds[i >> 2] = nd.ind;
        tb[i >> 2] = nd.est.rgba;
    }
    return {
        abuf: nimg.buffer,
        inds: inds,
        plte: leafs
    };
};
$cd7c49497361173c$var$UPNG.quantize.getKDtree = function(nimg, ps, err) {
    if (err == null) err = 0.0001;
    var nimg32 = new Uint32Array(nimg.buffer);
    var root = {
        i0: 0,
        i1: nimg.length,
        bst: null,
        est: null,
        tdst: 0,
        left: null,
        right: null
    }; // basic statistic, extra statistic
    root.bst = $cd7c49497361173c$var$UPNG.quantize.stats(nimg, root.i0, root.i1);
    root.est = $cd7c49497361173c$var$UPNG.quantize.estats(root.bst);
    var leafs = [
        root
    ];
    while(leafs.length < ps){
        var maxL = 0, mi = 0;
        for(var i = 0; i < leafs.length; i++)if (leafs[i].est.L > maxL) {
            maxL = leafs[i].est.L;
            mi = i;
        }
        if (maxL < err) break;
        var node = leafs[mi];
        var s0 = $cd7c49497361173c$var$UPNG.quantize.splitPixels(nimg, nimg32, node.i0, node.i1, node.est.e, node.est.eMq255);
        var s0wrong = node.i0 >= s0 || node.i1 <= s0;
        //console.log(maxL, leafs.length, mi);
        if (s0wrong) {
            node.est.L = 0;
            continue;
        }
        var ln = {
            i0: node.i0,
            i1: s0,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        ln.bst = $cd7c49497361173c$var$UPNG.quantize.stats(nimg, ln.i0, ln.i1);
        ln.est = $cd7c49497361173c$var$UPNG.quantize.estats(ln.bst);
        var rn = {
            i0: s0,
            i1: node.i1,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        rn.bst = {
            R: [],
            m: [],
            N: node.bst.N - ln.bst.N
        };
        for(var i = 0; i < 16; i++)rn.bst.R[i] = node.bst.R[i] - ln.bst.R[i];
        for(var i = 0; i < 4; i++)rn.bst.m[i] = node.bst.m[i] - ln.bst.m[i];
        rn.est = $cd7c49497361173c$var$UPNG.quantize.estats(rn.bst);
        node.left = ln;
        node.right = rn;
        leafs[mi] = ln;
        leafs.push(rn);
    }
    leafs.sort(function(a, b) {
        return b.bst.N - a.bst.N;
    });
    for(var i = 0; i < leafs.length; i++)leafs[i].ind = i;
    return [
        root,
        leafs
    ];
};
$cd7c49497361173c$var$UPNG.quantize.getNearest = function(nd, r, g, b, a) {
    if (nd.left == null) {
        nd.tdst = $cd7c49497361173c$var$UPNG.quantize.dist(nd.est.q, r, g, b, a);
        return nd;
    }
    var planeDst = $cd7c49497361173c$var$UPNG.quantize.planeDst(nd.est, r, g, b, a);
    var node0 = nd.left, node1 = nd.right;
    if (planeDst > 0) {
        node0 = nd.right;
        node1 = nd.left;
    }
    var ln = $cd7c49497361173c$var$UPNG.quantize.getNearest(node0, r, g, b, a);
    if (ln.tdst <= planeDst * planeDst) return ln;
    var rn = $cd7c49497361173c$var$UPNG.quantize.getNearest(node1, r, g, b, a);
    return rn.tdst < ln.tdst ? rn : ln;
};
$cd7c49497361173c$var$UPNG.quantize.planeDst = function(est, r, g, b, a) {
    var e = est.e;
    return e[0] * r + e[1] * g + e[2] * b + e[3] * a - est.eMq;
};
$cd7c49497361173c$var$UPNG.quantize.dist = function(q, r, g, b, a) {
    var d0 = r - q[0], d1 = g - q[1], d2 = b - q[2], d3 = a - q[3];
    return d0 * d0 + d1 * d1 + d2 * d2 + d3 * d3;
};
$cd7c49497361173c$var$UPNG.quantize.splitPixels = function(nimg, nimg32, i0, i1, e, eMq) {
    var vecDot = $cd7c49497361173c$var$UPNG.quantize.vecDot;
    i1 -= 4;
    var shfs = 0;
    while(i0 < i1){
        while(vecDot(nimg, i0, e) <= eMq)i0 += 4;
        while(vecDot(nimg, i1, e) > eMq)i1 -= 4;
        if (i0 >= i1) break;
        var t = nimg32[i0 >> 2];
        nimg32[i0 >> 2] = nimg32[i1 >> 2];
        nimg32[i1 >> 2] = t;
        i0 += 4;
        i1 -= 4;
    }
    while(vecDot(nimg, i0, e) > eMq)i0 -= 4;
    return i0 + 4;
};
$cd7c49497361173c$var$UPNG.quantize.vecDot = function(nimg, i, e) {
    return nimg[i] * e[0] + nimg[i + 1] * e[1] + nimg[i + 2] * e[2] + nimg[i + 3] * e[3];
};
$cd7c49497361173c$var$UPNG.quantize.stats = function(nimg, i0, i1) {
    var R = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var m = [
        0,
        0,
        0,
        0
    ];
    var N = i1 - i0 >> 2;
    for(var i = i0; i < i1; i += 4){
        var r = nimg[i] * (1 / 255), g = nimg[i + 1] * (1 / 255), b = nimg[i + 2] * (1 / 255), a = nimg[i + 3] * (1 / 255);
        //var r = nimg[i], g = nimg[i+1], b = nimg[i+2], a = nimg[i+3];
        m[0] += r;
        m[1] += g;
        m[2] += b;
        m[3] += a;
        R[0] += r * r;
        R[1] += r * g;
        R[2] += r * b;
        R[3] += r * a;
        R[5] += g * g;
        R[6] += g * b;
        R[7] += g * a;
        R[10] += b * b;
        R[11] += b * a;
        R[15] += a * a;
    }
    R[4] = R[1];
    R[8] = R[2];
    R[9] = R[6];
    R[12] = R[3];
    R[13] = R[7];
    R[14] = R[11];
    return {
        R: R,
        m: m,
        N: N
    };
};
$cd7c49497361173c$var$UPNG.quantize.estats = function(stats) {
    var R = stats.R, m = stats.m, N = stats.N;
    // when all samples are equal, but N is large (millions), the Rj can be non-zero ( 0.0003.... - precission error)
    var m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], iN = N == 0 ? 0 : 1 / N;
    var Rj = [
        R[0] - m0 * m0 * iN,
        R[1] - m0 * m1 * iN,
        R[2] - m0 * m2 * iN,
        R[3] - m0 * m3 * iN,
        R[4] - m1 * m0 * iN,
        R[5] - m1 * m1 * iN,
        R[6] - m1 * m2 * iN,
        R[7] - m1 * m3 * iN,
        R[8] - m2 * m0 * iN,
        R[9] - m2 * m1 * iN,
        R[10] - m2 * m2 * iN,
        R[11] - m2 * m3 * iN,
        R[12] - m3 * m0 * iN,
        R[13] - m3 * m1 * iN,
        R[14] - m3 * m2 * iN,
        R[15] - m3 * m3 * iN
    ];
    var A = Rj, M = $cd7c49497361173c$var$UPNG.M4;
    var b = [
        0.5,
        0.5,
        0.5,
        0.5
    ], mi = 0, tmi = 0;
    if (N != 0) for(var i = 0; i < 10; i++){
        b = M.multVec(A, b);
        tmi = Math.sqrt(M.dot(b, b));
        b = M.sml(1 / tmi, b);
        if (Math.abs(tmi - mi) < 1e-9) break;
        mi = tmi;
    }
    //b = [0,0,1,0];  mi=N;
    var q = [
        m0 * iN,
        m1 * iN,
        m2 * iN,
        m3 * iN
    ];
    var eMq255 = M.dot(M.sml(255, q), b);
    return {
        Cov: Rj,
        q: q,
        e: b,
        L: mi,
        eMq255: eMq255,
        eMq: M.dot(b, q),
        rgba: (Math.round(255 * q[3]) << 24 | Math.round(255 * q[2]) << 16 | Math.round(255 * q[1]) << 8 | Math.round(255 * q[0]) << 0) >>> 0
    };
};
$cd7c49497361173c$var$UPNG.M4 = {
    multVec: function(m, v) {
        return [
            m[0] * v[0] + m[1] * v[1] + m[2] * v[2] + m[3] * v[3],
            m[4] * v[0] + m[5] * v[1] + m[6] * v[2] + m[7] * v[3],
            m[8] * v[0] + m[9] * v[1] + m[10] * v[2] + m[11] * v[3],
            m[12] * v[0] + m[13] * v[1] + m[14] * v[2] + m[15] * v[3]
        ];
    },
    dot: function(x, y) {
        return x[0] * y[0] + x[1] * y[1] + x[2] * y[2] + x[3] * y[3];
    },
    sml: function(a, y) {
        return [
            a * y[0],
            a * y[1],
            a * y[2],
            a * y[3]
        ];
    }
};
$cd7c49497361173c$var$UPNG.encode.concatRGBA = function(bufs) {
    var tlen = 0;
    for(var i = 0; i < bufs.length; i++)tlen += bufs[i].byteLength;
    var nimg = new Uint8Array(tlen), noff = 0;
    for(var i = 0; i < bufs.length; i++){
        var img = new Uint8Array(bufs[i]), il = img.length;
        for(var j = 0; j < il; j += 4){
            var r = img[j], g = img[j + 1], b = img[j + 2], a = img[j + 3];
            if (a == 0) r = g = b = 0;
            nimg[noff + j] = r;
            nimg[noff + j + 1] = g;
            nimg[noff + j + 2] = b;
            nimg[noff + j + 3] = a;
        }
        noff += il;
    }
    return nimg.buffer;
};
var $cd7c49497361173c$export$2e2bcd8739ae039 = $cd7c49497361173c$var$UPNG;


var $2d06022bd11ab574$var$getImageType = function(ctype) {
    if (ctype === 0) return $2d06022bd11ab574$export$3ff975e8f63e458c.Greyscale;
    if (ctype === 2) return $2d06022bd11ab574$export$3ff975e8f63e458c.Truecolour;
    if (ctype === 3) return $2d06022bd11ab574$export$3ff975e8f63e458c.IndexedColour;
    if (ctype === 4) return $2d06022bd11ab574$export$3ff975e8f63e458c.GreyscaleWithAlpha;
    if (ctype === 6) return $2d06022bd11ab574$export$3ff975e8f63e458c.TruecolourWithAlpha;
    throw new Error("Unknown color type: " + ctype);
};
var $2d06022bd11ab574$var$splitAlphaChannel = function(rgbaChannel) {
    var pixelCount = Math.floor(rgbaChannel.length / 4);
    var rgbChannel = new Uint8Array(pixelCount * 3);
    var alphaChannel = new Uint8Array(pixelCount * 1);
    var rgbaOffset = 0;
    var rgbOffset = 0;
    var alphaOffset = 0;
    while(rgbaOffset < rgbaChannel.length){
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        alphaChannel[alphaOffset++] = rgbaChannel[rgbaOffset++];
    }
    return {
        rgbChannel: rgbChannel,
        alphaChannel: alphaChannel
    };
};
var $2d06022bd11ab574$export$3ff975e8f63e458c;
(function(PngType) {
    PngType["Greyscale"] = "Greyscale";
    PngType["Truecolour"] = "Truecolour";
    PngType["IndexedColour"] = "IndexedColour";
    PngType["GreyscaleWithAlpha"] = "GreyscaleWithAlpha";
    PngType["TruecolourWithAlpha"] = "TruecolourWithAlpha";
})($2d06022bd11ab574$export$3ff975e8f63e458c || ($2d06022bd11ab574$export$3ff975e8f63e458c = {}));
var $2d06022bd11ab574$export$1f536085c24cc947 = /** @class */ function() {
    function PNG(pngData) {
        var upng = (0, $cd7c49497361173c$export$2e2bcd8739ae039).decode(pngData);
        var frames = (0, $cd7c49497361173c$export$2e2bcd8739ae039).toRGBA8(upng);
        if (frames.length > 1) throw new Error("Animated PNGs are not supported");
        var frame = new Uint8Array(frames[0]);
        var _a = $2d06022bd11ab574$var$splitAlphaChannel(frame), rgbChannel = _a.rgbChannel, alphaChannel = _a.alphaChannel;
        this.rgbChannel = rgbChannel;
        var hasAlphaValues = alphaChannel.some(function(a) {
            return a < 255;
        });
        if (hasAlphaValues) this.alphaChannel = alphaChannel;
        this.type = $2d06022bd11ab574$var$getImageType(upng.ctype);
        this.width = upng.width;
        this.height = upng.height;
        this.bitsPerComponent = 8;
    }
    PNG.load = function(pngData) {
        return new PNG(pngData);
    };
    return PNG;
}();


/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/png.coffee
 */ var $af70ed359aebef3f$var$PngEmbedder = /** @class */ function() {
    function PngEmbedder(png) {
        this.image = png;
        this.bitsPerComponent = png.bitsPerComponent;
        this.width = png.width;
        this.height = png.height;
        this.colorSpace = 'DeviceRGB';
    }
    PngEmbedder.for = function(imageData) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var png;
            return (0, $47XJ3.__generator)(this, function(_a) {
                png = (0, $2d06022bd11ab574$export$1f536085c24cc947).load(imageData);
                return [
                    2 /*return*/ ,
                    new PngEmbedder(png)
                ];
            });
        });
    };
    PngEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var SMask, xObject;
            return (0, $47XJ3.__generator)(this, function(_a) {
                SMask = this.embedAlphaChannel(context);
                xObject = context.flateStream(this.image.rgbChannel, {
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.image.bitsPerComponent,
                    Width: this.image.width,
                    Height: this.image.height,
                    ColorSpace: this.colorSpace,
                    SMask: SMask
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    PngEmbedder.prototype.embedAlphaChannel = function(context) {
        if (!this.image.alphaChannel) return undefined;
        var xObject = context.flateStream(this.image.alphaChannel, {
            Type: 'XObject',
            Subtype: 'Image',
            Height: this.image.height,
            Width: this.image.width,
            BitsPerComponent: this.image.bitsPerComponent,
            ColorSpace: 'DeviceGray',
            Decode: [
                0,
                1
            ]
        });
        return context.register(xObject);
    };
    return PngEmbedder;
}();
var $af70ed359aebef3f$export$2e2bcd8739ae039 = $af70ed359aebef3f$var$PngEmbedder;



var $47XJ3 = parcelRequire("47XJ3");

var $6AcCU = parcelRequire("6AcCU");

var $dKRgb = parcelRequire("dKRgb");



var $6AcCU = parcelRequire("6AcCU");

var $6IKEk = parcelRequire("6IKEk");


var $2npvA = parcelRequire("2npvA");

var $dKRgb = parcelRequire("dKRgb");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Ascii85Stream class contained in this file is a TypeScript port of the
 * JavaScript Ascii85Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $47XJ3 = parcelRequire("47XJ3");

var $6AcCU = parcelRequire("6AcCU");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Stream class contained in this file is a TypeScript port of the
 * JavaScript Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ var $50245caf61d3d1e1$var$Stream = /** @class */ function() {
    function Stream(buffer, start, length) {
        this.bytes = buffer;
        this.start = start || 0;
        this.pos = this.start;
        this.end = !!start && !!length ? start + length : this.bytes.length;
    }
    Object.defineProperty(Stream.prototype, "length", {
        get: function() {
            return this.end - this.start;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Stream.prototype, "isEmpty", {
        get: function() {
            return this.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Stream.prototype.getByte = function() {
        if (this.pos >= this.end) return -1;
        return this.bytes[this.pos++];
    };
    Stream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    Stream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    // Returns subarray of original buffer, should only be read.
    Stream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.bytes;
        var pos = this.pos;
        var strEnd = this.end;
        if (!length) {
            var subarray = bytes.subarray(pos, strEnd);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        } else {
            var end = pos + length;
            if (end > strEnd) end = strEnd;
            this.pos = end;
            var subarray = bytes.subarray(pos, end);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        }
    };
    Stream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    Stream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    Stream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    Stream.prototype.reset = function() {
        this.pos = this.start;
    };
    Stream.prototype.moveStart = function() {
        this.start = this.pos;
    };
    Stream.prototype.makeSubStream = function(start, length) {
        return new Stream(this.bytes, start, length);
    };
    Stream.prototype.decode = function() {
        return this.bytes;
    };
    return Stream;
}();
var $50245caf61d3d1e1$export$2e2bcd8739ae039 = $50245caf61d3d1e1$var$Stream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The DecodeStream class contained in this file is a TypeScript port of the
 * JavaScript DecodeStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ // Lots of DecodeStreams are created whose buffers are never used.  For these
// we share a single empty buffer. This is (a) space-efficient and (b) avoids
// having special cases that would be required if we used |null| for an empty
// buffer.
var $f8f841492d3bfcbc$var$emptyBuffer = new Uint8Array(0);
/**
 * Super class for the decoding streams
 */ var $f8f841492d3bfcbc$var$DecodeStream = /** @class */ function() {
    function DecodeStream(maybeMinBufferLength) {
        this.pos = 0;
        this.bufferLength = 0;
        this.eof = false;
        this.buffer = $f8f841492d3bfcbc$var$emptyBuffer;
        this.minBufferLength = 512;
        if (maybeMinBufferLength) // Compute the first power of two that is as big as maybeMinBufferLength.
        while(this.minBufferLength < maybeMinBufferLength)this.minBufferLength *= 2;
    }
    Object.defineProperty(DecodeStream.prototype, "isEmpty", {
        get: function() {
            while(!this.eof && this.bufferLength === 0)this.readBlock();
            return this.bufferLength === 0;
        },
        enumerable: false,
        configurable: true
    });
    DecodeStream.prototype.getByte = function() {
        var pos = this.pos;
        while(this.bufferLength <= pos){
            if (this.eof) return -1;
            this.readBlock();
        }
        return this.buffer[this.pos++];
    };
    DecodeStream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    DecodeStream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    DecodeStream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var end;
        var pos = this.pos;
        if (length) {
            this.ensureBuffer(pos + length);
            end = pos + length;
            while(!this.eof && this.bufferLength < end)this.readBlock();
            var bufEnd = this.bufferLength;
            if (end > bufEnd) end = bufEnd;
        } else {
            while(!this.eof)this.readBlock();
            end = this.bufferLength;
        }
        this.pos = end;
        var subarray = this.buffer.subarray(pos, end);
        // `this.buffer` is either a `Uint8Array` or `Uint8ClampedArray` here.
        return forceClamped && !(subarray instanceof Uint8ClampedArray) ? new Uint8ClampedArray(subarray) : subarray;
    };
    DecodeStream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    DecodeStream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    DecodeStream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    DecodeStream.prototype.reset = function() {
        this.pos = 0;
    };
    DecodeStream.prototype.makeSubStream = function(start, length /* dict */ ) {
        var end = start + length;
        while(this.bufferLength <= end && !this.eof)this.readBlock();
        return new (0, $50245caf61d3d1e1$export$2e2bcd8739ae039)(this.buffer, start, length /* dict */ );
    };
    DecodeStream.prototype.decode = function() {
        while(!this.eof)this.readBlock();
        return this.buffer.subarray(0, this.bufferLength);
    };
    DecodeStream.prototype.readBlock = function() {
        throw new (0, $6AcCU.MethodNotImplementedError)(this.constructor.name, 'readBlock');
    };
    DecodeStream.prototype.ensureBuffer = function(requested) {
        var buffer = this.buffer;
        if (requested <= buffer.byteLength) return buffer;
        var size = this.minBufferLength;
        while(size < requested)size *= 2;
        var buffer2 = new Uint8Array(size);
        buffer2.set(buffer);
        return this.buffer = buffer2;
    };
    return DecodeStream;
}();
var $f8f841492d3bfcbc$export$2e2bcd8739ae039 = $f8f841492d3bfcbc$var$DecodeStream;


var $70b8f7d5dfd8c747$var$isSpace = function(ch) {
    return ch === 0x20 || ch === 0x09 || ch === 0x0d || ch === 0x0a;
};
var $70b8f7d5dfd8c747$var$Ascii85Stream = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(Ascii85Stream, _super);
    function Ascii85Stream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.input = new Uint8Array(5);
        // Most streams increase in size when decoded, but Ascii85 streams
        // typically shrink by ~20%.
        if (maybeLength) maybeLength = 0.8 * maybeLength;
        return _this;
    }
    Ascii85Stream.prototype.readBlock = function() {
        var TILDA_CHAR = 0x7e; // '~'
        var Z_LOWER_CHAR = 0x7a; // 'z'
        var EOF = -1;
        var stream = this.stream;
        var c = stream.getByte();
        while($70b8f7d5dfd8c747$var$isSpace(c))c = stream.getByte();
        if (c === EOF || c === TILDA_CHAR) {
            this.eof = true;
            return;
        }
        var bufferLength = this.bufferLength;
        var buffer;
        var i;
        // special code for z
        if (c === Z_LOWER_CHAR) {
            buffer = this.ensureBuffer(bufferLength + 4);
            for(i = 0; i < 4; ++i)buffer[bufferLength + i] = 0;
            this.bufferLength += 4;
        } else {
            var input = this.input;
            input[0] = c;
            for(i = 1; i < 5; ++i){
                c = stream.getByte();
                while($70b8f7d5dfd8c747$var$isSpace(c))c = stream.getByte();
                input[i] = c;
                if (c === EOF || c === TILDA_CHAR) break;
            }
            buffer = this.ensureBuffer(bufferLength + i - 1);
            this.bufferLength += i - 1;
            // partial ending;
            if (i < 5) {
                for(; i < 5; ++i)input[i] = 117;
                this.eof = true;
            }
            var t = 0;
            for(i = 0; i < 5; ++i)t = t * 85 + (input[i] - 0x21);
            for(i = 3; i >= 0; --i){
                buffer[bufferLength + i] = t & 0xff;
                t >>= 8;
            }
        }
    };
    return Ascii85Stream;
}((0, $f8f841492d3bfcbc$export$2e2bcd8739ae039));
var $70b8f7d5dfd8c747$export$2e2bcd8739ae039 = $70b8f7d5dfd8c747$var$Ascii85Stream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The AsciiHexStream class contained in this file is a TypeScript port of the
 * JavaScript AsciiHexStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $47XJ3 = parcelRequire("47XJ3");

var $aa7cb0decf98e229$var$AsciiHexStream = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(AsciiHexStream, _super);
    function AsciiHexStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.firstDigit = -1;
        // Most streams increase in size when decoded, but AsciiHex streams shrink
        // by 50%.
        if (maybeLength) maybeLength = 0.5 * maybeLength;
        return _this;
    }
    AsciiHexStream.prototype.readBlock = function() {
        var UPSTREAM_BLOCK_SIZE = 8000;
        var bytes = this.stream.getBytes(UPSTREAM_BLOCK_SIZE);
        if (!bytes.length) {
            this.eof = true;
            return;
        }
        var maxDecodeLength = bytes.length + 1 >> 1;
        var buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
        var bufferLength = this.bufferLength;
        var firstDigit = this.firstDigit;
        for(var i = 0, ii = bytes.length; i < ii; i++){
            var ch = bytes[i];
            var digit = void 0;
            if (ch >= 0x30 && ch <= 0x39) // '0'-'9'
            digit = ch & 0x0f;
            else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) // 'A'-'Z', 'a'-'z'
            digit = (ch & 0x0f) + 9;
            else if (ch === 0x3e) {
                // '>'
                this.eof = true;
                break;
            } else continue; // ignoring
            if (firstDigit < 0) firstDigit = digit;
            else {
                buffer[bufferLength++] = firstDigit << 4 | digit;
                firstDigit = -1;
            }
        }
        if (firstDigit >= 0 && this.eof) {
            // incomplete byte
            buffer[bufferLength++] = firstDigit << 4;
            firstDigit = -1;
        }
        this.firstDigit = firstDigit;
        this.bufferLength = bufferLength;
    };
    return AsciiHexStream;
}((0, $f8f841492d3bfcbc$export$2e2bcd8739ae039));
var $aa7cb0decf98e229$export$2e2bcd8739ae039 = $aa7cb0decf98e229$var$AsciiHexStream;


/*
 * Copyright 1996-2003 Glyph & Cog, LLC
 *
 * The flate stream implementation contained in this file is a JavaScript port
 * of XPDF's implementation, made available under the Apache 2.0 open source
 * license.
 */ 
var $47XJ3 = parcelRequire("47XJ3");

// prettier-ignore
var $a85c4d1c3a2432bc$var$codeLenCodeMap = new Int32Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// prettier-ignore
var $a85c4d1c3a2432bc$var$lengthDecode = new Int32Array([
    0x00003,
    0x00004,
    0x00005,
    0x00006,
    0x00007,
    0x00008,
    0x00009,
    0x0000a,
    0x1000b,
    0x1000d,
    0x1000f,
    0x10011,
    0x20013,
    0x20017,
    0x2001b,
    0x2001f,
    0x30023,
    0x3002b,
    0x30033,
    0x3003b,
    0x40043,
    0x40053,
    0x40063,
    0x40073,
    0x50083,
    0x500a3,
    0x500c3,
    0x500e3,
    0x00102,
    0x00102,
    0x00102
]);
// prettier-ignore
var $a85c4d1c3a2432bc$var$distDecode = new Int32Array([
    0x00001,
    0x00002,
    0x00003,
    0x00004,
    0x10005,
    0x10007,
    0x20009,
    0x2000d,
    0x30011,
    0x30019,
    0x40021,
    0x40031,
    0x50041,
    0x50061,
    0x60081,
    0x600c1,
    0x70101,
    0x70181,
    0x80201,
    0x80301,
    0x90401,
    0x90601,
    0xa0801,
    0xa0c01,
    0xb1001,
    0xb1801,
    0xc2001,
    0xc3001,
    0xd4001,
    0xd6001
]);
// prettier-ignore
var $a85c4d1c3a2432bc$var$fixedLitCodeTab = [
    new Int32Array([
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c0,
        0x70108,
        0x80060,
        0x80020,
        0x900a0,
        0x80000,
        0x80080,
        0x80040,
        0x900e0,
        0x70104,
        0x80058,
        0x80018,
        0x90090,
        0x70114,
        0x80078,
        0x80038,
        0x900d0,
        0x7010c,
        0x80068,
        0x80028,
        0x900b0,
        0x80008,
        0x80088,
        0x80048,
        0x900f0,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c8,
        0x7010a,
        0x80064,
        0x80024,
        0x900a8,
        0x80004,
        0x80084,
        0x80044,
        0x900e8,
        0x70106,
        0x8005c,
        0x8001c,
        0x90098,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d8,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b8,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f8,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c4,
        0x70109,
        0x80062,
        0x80022,
        0x900a4,
        0x80002,
        0x80082,
        0x80042,
        0x900e4,
        0x70105,
        0x8005a,
        0x8001a,
        0x90094,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d4,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b4,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f4,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cc,
        0x7010b,
        0x80066,
        0x80026,
        0x900ac,
        0x80006,
        0x80086,
        0x80046,
        0x900ec,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009c,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dc,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bc,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fc,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c2,
        0x70108,
        0x80061,
        0x80021,
        0x900a2,
        0x80001,
        0x80081,
        0x80041,
        0x900e2,
        0x70104,
        0x80059,
        0x80019,
        0x90092,
        0x70114,
        0x80079,
        0x80039,
        0x900d2,
        0x7010c,
        0x80069,
        0x80029,
        0x900b2,
        0x80009,
        0x80089,
        0x80049,
        0x900f2,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900ca,
        0x7010a,
        0x80065,
        0x80025,
        0x900aa,
        0x80005,
        0x80085,
        0x80045,
        0x900ea,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009a,
        0x70116,
        0x8007d,
        0x8003d,
        0x900da,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900ba,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fa,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c6,
        0x70109,
        0x80063,
        0x80023,
        0x900a6,
        0x80003,
        0x80083,
        0x80043,
        0x900e6,
        0x70105,
        0x8005b,
        0x8001b,
        0x90096,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d6,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b6,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f6,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900ce,
        0x7010b,
        0x80067,
        0x80027,
        0x900ae,
        0x80007,
        0x80087,
        0x80047,
        0x900ee,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009e,
        0x70117,
        0x8007f,
        0x8003f,
        0x900de,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900be,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900fe,
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c1,
        0x70108,
        0x80060,
        0x80020,
        0x900a1,
        0x80000,
        0x80080,
        0x80040,
        0x900e1,
        0x70104,
        0x80058,
        0x80018,
        0x90091,
        0x70114,
        0x80078,
        0x80038,
        0x900d1,
        0x7010c,
        0x80068,
        0x80028,
        0x900b1,
        0x80008,
        0x80088,
        0x80048,
        0x900f1,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c9,
        0x7010a,
        0x80064,
        0x80024,
        0x900a9,
        0x80004,
        0x80084,
        0x80044,
        0x900e9,
        0x70106,
        0x8005c,
        0x8001c,
        0x90099,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d9,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b9,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f9,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c5,
        0x70109,
        0x80062,
        0x80022,
        0x900a5,
        0x80002,
        0x80082,
        0x80042,
        0x900e5,
        0x70105,
        0x8005a,
        0x8001a,
        0x90095,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d5,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b5,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f5,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cd,
        0x7010b,
        0x80066,
        0x80026,
        0x900ad,
        0x80006,
        0x80086,
        0x80046,
        0x900ed,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009d,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dd,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bd,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fd,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c3,
        0x70108,
        0x80061,
        0x80021,
        0x900a3,
        0x80001,
        0x80081,
        0x80041,
        0x900e3,
        0x70104,
        0x80059,
        0x80019,
        0x90093,
        0x70114,
        0x80079,
        0x80039,
        0x900d3,
        0x7010c,
        0x80069,
        0x80029,
        0x900b3,
        0x80009,
        0x80089,
        0x80049,
        0x900f3,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900cb,
        0x7010a,
        0x80065,
        0x80025,
        0x900ab,
        0x80005,
        0x80085,
        0x80045,
        0x900eb,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009b,
        0x70116,
        0x8007d,
        0x8003d,
        0x900db,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900bb,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fb,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c7,
        0x70109,
        0x80063,
        0x80023,
        0x900a7,
        0x80003,
        0x80083,
        0x80043,
        0x900e7,
        0x70105,
        0x8005b,
        0x8001b,
        0x90097,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d7,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b7,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f7,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900cf,
        0x7010b,
        0x80067,
        0x80027,
        0x900af,
        0x80007,
        0x80087,
        0x80047,
        0x900ef,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009f,
        0x70117,
        0x8007f,
        0x8003f,
        0x900df,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900bf,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900ff
    ]),
    9
];
// prettier-ignore
var $a85c4d1c3a2432bc$var$fixedDistCodeTab = [
    new Int32Array([
        0x50000,
        0x50010,
        0x50008,
        0x50018,
        0x50004,
        0x50014,
        0x5000c,
        0x5001c,
        0x50002,
        0x50012,
        0x5000a,
        0x5001a,
        0x50006,
        0x50016,
        0x5000e,
        0x00000,
        0x50001,
        0x50011,
        0x50009,
        0x50019,
        0x50005,
        0x50015,
        0x5000d,
        0x5001d,
        0x50003,
        0x50013,
        0x5000b,
        0x5001b,
        0x50007,
        0x50017,
        0x5000f,
        0x00000
    ]),
    5
];
var $a85c4d1c3a2432bc$var$FlateStream = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(FlateStream, _super);
    function FlateStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        var cmf = stream.getByte();
        var flg = stream.getByte();
        if (cmf === -1 || flg === -1) throw new Error("Invalid header in flate stream: " + cmf + ", " + flg);
        if ((cmf & 0x0f) !== 0x08) throw new Error("Unknown compression method in flate stream: " + cmf + ", " + flg);
        if (((cmf << 8) + flg) % 31 !== 0) throw new Error("Bad FCHECK in flate stream: " + cmf + ", " + flg);
        if (flg & 0x20) throw new Error("FDICT bit set in flate stream: " + cmf + ", " + flg);
        _this.codeSize = 0;
        _this.codeBuf = 0;
        return _this;
    }
    FlateStream.prototype.readBlock = function() {
        var buffer;
        var len;
        var str = this.stream;
        // read block header
        var hdr = this.getBits(3);
        if (hdr & 1) this.eof = true;
        hdr >>= 1;
        if (hdr === 0) {
            // uncompressed block
            var b = void 0;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            var blockLen = b;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            blockLen |= b << 8;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            var check = b;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            check |= b << 8;
            if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) // Ignoring error for bad "empty" block (see issue 1277)
            throw new Error('Bad uncompressed block length in flate stream');
            this.codeBuf = 0;
            this.codeSize = 0;
            var bufferLength = this.bufferLength;
            buffer = this.ensureBuffer(bufferLength + blockLen);
            var end = bufferLength + blockLen;
            this.bufferLength = end;
            if (blockLen === 0) {
                if (str.peekByte() === -1) this.eof = true;
            } else for(var n = bufferLength; n < end; ++n){
                if ((b = str.getByte()) === -1) {
                    this.eof = true;
                    break;
                }
                buffer[n] = b;
            }
            return;
        }
        var litCodeTable;
        var distCodeTable;
        if (hdr === 1) {
            // compressed block, fixed codes
            litCodeTable = $a85c4d1c3a2432bc$var$fixedLitCodeTab;
            distCodeTable = $a85c4d1c3a2432bc$var$fixedDistCodeTab;
        } else if (hdr === 2) {
            // compressed block, dynamic codes
            var numLitCodes = this.getBits(5) + 257;
            var numDistCodes = this.getBits(5) + 1;
            var numCodeLenCodes = this.getBits(4) + 4;
            // build the code lengths code table
            var codeLenCodeLengths = new Uint8Array($a85c4d1c3a2432bc$var$codeLenCodeMap.length);
            var i = void 0;
            for(i = 0; i < numCodeLenCodes; ++i)codeLenCodeLengths[$a85c4d1c3a2432bc$var$codeLenCodeMap[i]] = this.getBits(3);
            var codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
            // build the literal and distance code tables
            len = 0;
            i = 0;
            var codes = numLitCodes + numDistCodes;
            var codeLengths = new Uint8Array(codes);
            var bitsLength = void 0;
            var bitsOffset = void 0;
            var what = void 0;
            while(i < codes){
                var code = this.getCode(codeLenCodeTab);
                if (code === 16) {
                    bitsLength = 2;
                    bitsOffset = 3;
                    what = len;
                } else if (code === 17) {
                    bitsLength = 3;
                    bitsOffset = 3;
                    what = len = 0;
                } else if (code === 18) {
                    bitsLength = 7;
                    bitsOffset = 11;
                    what = len = 0;
                } else {
                    codeLengths[i++] = len = code;
                    continue;
                }
                var repeatLength = this.getBits(bitsLength) + bitsOffset;
                while(repeatLength-- > 0)codeLengths[i++] = what;
            }
            litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
            distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
        } else throw new Error('Unknown block type in flate stream');
        buffer = this.buffer;
        var limit = buffer ? buffer.length : 0;
        var pos = this.bufferLength;
        while(true){
            var code1 = this.getCode(litCodeTable);
            if (code1 < 256) {
                if (pos + 1 >= limit) {
                    buffer = this.ensureBuffer(pos + 1);
                    limit = buffer.length;
                }
                buffer[pos++] = code1;
                continue;
            }
            if (code1 === 256) {
                this.bufferLength = pos;
                return;
            }
            code1 -= 257;
            code1 = $a85c4d1c3a2432bc$var$lengthDecode[code1];
            var code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            len = (code1 & 0xffff) + code2;
            code1 = this.getCode(distCodeTable);
            code1 = $a85c4d1c3a2432bc$var$distDecode[code1];
            code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            var dist = (code1 & 0xffff) + code2;
            if (pos + len >= limit) {
                buffer = this.ensureBuffer(pos + len);
                limit = buffer.length;
            }
            for(var k = 0; k < len; ++k, ++pos)buffer[pos] = buffer[pos - dist];
        }
    };
    FlateStream.prototype.getBits = function(bits) {
        var str = this.stream;
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < bits){
            if ((b = str.getByte()) === -1) throw new Error('Bad encoding in flate stream');
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        b = codeBuf & (1 << bits) - 1;
        this.codeBuf = codeBuf >> bits;
        this.codeSize = codeSize -= bits;
        return b;
    };
    FlateStream.prototype.getCode = function(table) {
        var str = this.stream;
        var codes = table[0];
        var maxLen = table[1];
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < maxLen){
            if ((b = str.getByte()) === -1) break;
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        var code = codes[codeBuf & (1 << maxLen) - 1];
        if (typeof codes === 'number') console.log('FLATE:', code);
        var codeLen = code >> 16;
        var codeVal = code & 0xffff;
        if (codeLen < 1 || codeSize < codeLen) throw new Error('Bad encoding in flate stream');
        this.codeBuf = codeBuf >> codeLen;
        this.codeSize = codeSize - codeLen;
        return codeVal;
    };
    FlateStream.prototype.generateHuffmanTable = function(lengths) {
        var n = lengths.length;
        // find max code length
        var maxLen = 0;
        var i;
        for(i = 0; i < n; ++i)if (lengths[i] > maxLen) maxLen = lengths[i];
        // build the table
        var size = 1 << maxLen;
        var codes = new Int32Array(size);
        for(var len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1){
            for(var val = 0; val < n; ++val)if (lengths[val] === len) {
                // bit-reverse the code
                var code2 = 0;
                var t = code;
                for(i = 0; i < len; ++i){
                    code2 = code2 << 1 | t & 1;
                    t >>= 1;
                }
                // fill the table entries
                for(i = code2; i < size; i += skip)codes[i] = len << 16 | val;
                ++code;
            }
        }
        return [
            codes,
            maxLen
        ];
    };
    return FlateStream;
}((0, $f8f841492d3bfcbc$export$2e2bcd8739ae039));
var $a85c4d1c3a2432bc$export$2e2bcd8739ae039 = $a85c4d1c3a2432bc$var$FlateStream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The LZWStream class contained in this file is a TypeScript port of the
 * JavaScript LZWStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $47XJ3 = parcelRequire("47XJ3");

var $7e83e3fd4b7d3302$var$LZWStream = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(LZWStream, _super);
    function LZWStream(stream, maybeLength, earlyChange) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.cachedData = 0;
        _this.bitsCached = 0;
        var maxLzwDictionarySize = 4096;
        var lzwState = {
            earlyChange: earlyChange,
            codeLength: 9,
            nextCode: 258,
            dictionaryValues: new Uint8Array(maxLzwDictionarySize),
            dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
            dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
            currentSequence: new Uint8Array(maxLzwDictionarySize),
            currentSequenceLength: 0
        };
        for(var i = 0; i < 256; ++i){
            lzwState.dictionaryValues[i] = i;
            lzwState.dictionaryLengths[i] = 1;
        }
        _this.lzwState = lzwState;
        return _this;
    }
    LZWStream.prototype.readBlock = function() {
        var blockSize = 512;
        var estimatedDecodedSize = blockSize * 2;
        var decodedSizeDelta = blockSize;
        var i;
        var j;
        var q;
        var lzwState = this.lzwState;
        if (!lzwState) return; // eof was found
        var earlyChange = lzwState.earlyChange;
        var nextCode = lzwState.nextCode;
        var dictionaryValues = lzwState.dictionaryValues;
        var dictionaryLengths = lzwState.dictionaryLengths;
        var dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
        var codeLength = lzwState.codeLength;
        var prevCode = lzwState.prevCode;
        var currentSequence = lzwState.currentSequence;
        var currentSequenceLength = lzwState.currentSequenceLength;
        var decodedLength = 0;
        var currentBufferLength = this.bufferLength;
        var buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
        for(i = 0; i < blockSize; i++){
            var code = this.readBits(codeLength);
            var hasPrev = currentSequenceLength > 0;
            if (!code || code < 256) {
                currentSequence[0] = code;
                currentSequenceLength = 1;
            } else if (code >= 258) {
                if (code < nextCode) {
                    currentSequenceLength = dictionaryLengths[code];
                    for(j = currentSequenceLength - 1, q = code; j >= 0; j--){
                        currentSequence[j] = dictionaryValues[q];
                        q = dictionaryPrevCodes[q];
                    }
                } else currentSequence[currentSequenceLength++] = currentSequence[0];
            } else if (code === 256) {
                codeLength = 9;
                nextCode = 258;
                currentSequenceLength = 0;
                continue;
            } else {
                this.eof = true;
                delete this.lzwState;
                break;
            }
            if (hasPrev) {
                dictionaryPrevCodes[nextCode] = prevCode;
                dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
                dictionaryValues[nextCode] = currentSequence[0];
                nextCode++;
                codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
            }
            prevCode = code;
            decodedLength += currentSequenceLength;
            if (estimatedDecodedSize < decodedLength) {
                do estimatedDecodedSize += decodedSizeDelta;
                while (estimatedDecodedSize < decodedLength);
                buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
            }
            for(j = 0; j < currentSequenceLength; j++)buffer[currentBufferLength++] = currentSequence[j];
        }
        lzwState.nextCode = nextCode;
        lzwState.codeLength = codeLength;
        lzwState.prevCode = prevCode;
        lzwState.currentSequenceLength = currentSequenceLength;
        this.bufferLength = currentBufferLength;
    };
    LZWStream.prototype.readBits = function(n) {
        var bitsCached = this.bitsCached;
        var cachedData = this.cachedData;
        while(bitsCached < n){
            var c = this.stream.getByte();
            if (c === -1) {
                this.eof = true;
                return null;
            }
            cachedData = cachedData << 8 | c;
            bitsCached += 8;
        }
        this.bitsCached = bitsCached -= n;
        this.cachedData = cachedData;
        return cachedData >>> bitsCached & (1 << n) - 1;
    };
    return LZWStream;
}((0, $f8f841492d3bfcbc$export$2e2bcd8739ae039));
var $7e83e3fd4b7d3302$export$2e2bcd8739ae039 = $7e83e3fd4b7d3302$var$LZWStream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The RunLengthStream class contained in this file is a TypeScript port of the
 * JavaScript RunLengthStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $47XJ3 = parcelRequire("47XJ3");

var $6ed53dcce72ad753$var$RunLengthStream = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(RunLengthStream, _super);
    function RunLengthStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        return _this;
    }
    RunLengthStream.prototype.readBlock = function() {
        // The repeatHeader has following format. The first byte defines type of run
        // and amount of bytes to repeat/copy: n = 0 through 127 - copy next n bytes
        // (in addition to the second byte from the header), n = 129 through 255 -
        // duplicate the second byte from the header (257 - n) times, n = 128 - end.
        var repeatHeader = this.stream.getBytes(2);
        if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
            this.eof = true;
            return;
        }
        var buffer;
        var bufferLength = this.bufferLength;
        var n = repeatHeader[0];
        if (n < 128) {
            // copy n bytes
            buffer = this.ensureBuffer(bufferLength + n + 1);
            buffer[bufferLength++] = repeatHeader[1];
            if (n > 0) {
                var source = this.stream.getBytes(n);
                buffer.set(source, bufferLength);
                bufferLength += n;
            }
        } else {
            n = 257 - n;
            var b = repeatHeader[1];
            buffer = this.ensureBuffer(bufferLength + n + 1);
            for(var i = 0; i < n; i++)buffer[bufferLength++] = b;
        }
        this.bufferLength = bufferLength;
    };
    return RunLengthStream;
}((0, $f8f841492d3bfcbc$export$2e2bcd8739ae039));
var $6ed53dcce72ad753$export$2e2bcd8739ae039 = $6ed53dcce72ad753$var$RunLengthStream;



var $30fd433752b1e562$var$decodeStream = function(stream, encoding, params) {
    if (encoding === (0, $2npvA.default).of('FlateDecode')) return new (0, $a85c4d1c3a2432bc$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $2npvA.default).of('LZWDecode')) {
        var earlyChange = 1;
        if (params instanceof (0, $74b515754dab46b0$export$2e2bcd8739ae039)) {
            var EarlyChange = params.lookup((0, $2npvA.default).of('EarlyChange'));
            if (EarlyChange instanceof (0, $dKRgb.default)) earlyChange = EarlyChange.asNumber();
        }
        return new (0, $7e83e3fd4b7d3302$export$2e2bcd8739ae039)(stream, undefined, earlyChange);
    }
    if (encoding === (0, $2npvA.default).of('ASCII85Decode')) return new (0, $70b8f7d5dfd8c747$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $2npvA.default).of('ASCIIHexDecode')) return new (0, $aa7cb0decf98e229$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $2npvA.default).of('RunLengthDecode')) return new (0, $6ed53dcce72ad753$export$2e2bcd8739ae039)(stream);
    throw new (0, $6AcCU.UnsupportedEncodingError)(encoding.asString());
};
var $30fd433752b1e562$export$b8317e68ca978594 = function(_a) {
    var dict = _a.dict, contents = _a.contents;
    var stream = new (0, $50245caf61d3d1e1$export$2e2bcd8739ae039)(contents);
    var Filter = dict.lookup((0, $2npvA.default).of('Filter'));
    var DecodeParms = dict.lookup((0, $2npvA.default).of('DecodeParms'));
    if (Filter instanceof (0, $2npvA.default)) stream = $30fd433752b1e562$var$decodeStream(stream, Filter, DecodeParms);
    else if (Filter instanceof (0, $6IKEk.default)) for(var idx = 0, len = Filter.size(); idx < len; idx++)stream = $30fd433752b1e562$var$decodeStream(stream, Filter.lookup(idx, (0, $2npvA.default)), DecodeParms && DecodeParms.lookupMaybe(idx, (0, $74b515754dab46b0$export$2e2bcd8739ae039)));
    else if (!!Filter) throw new (0, $6AcCU.UnexpectedObjectTypeError)([
        (0, $2npvA.default),
        (0, $6IKEk.default)
    ], Filter);
    return stream;
};




var $90Qf4 = parcelRequire("90Qf4");
parcelRequire("5w6hV");
var $4LYfy = parcelRequire("4LYfy");
var $5b0b737ae7e3d3aa$var$fullPageBoundingBox = function(page) {
    var mediaBox = page.MediaBox();
    var width = mediaBox.lookup(2, (0, $dKRgb.default)).asNumber() - mediaBox.lookup(0, (0, $dKRgb.default)).asNumber();
    var height = mediaBox.lookup(3, (0, $dKRgb.default)).asNumber() - mediaBox.lookup(1, (0, $dKRgb.default)).asNumber();
    return {
        left: 0,
        bottom: 0,
        right: width,
        top: height
    };
};
// Returns the identity matrix, modified to position the content of the given
// bounding box at (0, 0).
var $5b0b737ae7e3d3aa$var$boundingBoxAdjustedMatrix = function(bb) {
    return [
        1,
        0,
        0,
        1,
        -bb.left,
        -bb.bottom
    ];
};
var $5b0b737ae7e3d3aa$var$PDFPageEmbedder = /** @class */ function() {
    function PDFPageEmbedder(page, boundingBox, transformationMatrix) {
        this.page = page;
        var bb = boundingBox !== null && boundingBox !== void 0 ? boundingBox : $5b0b737ae7e3d3aa$var$fullPageBoundingBox(page);
        this.width = bb.right - bb.left;
        this.height = bb.top - bb.bottom;
        this.boundingBox = bb;
        this.transformationMatrix = transformationMatrix !== null && transformationMatrix !== void 0 ? transformationMatrix : $5b0b737ae7e3d3aa$var$boundingBoxAdjustedMatrix(bb);
    }
    PDFPageEmbedder.for = function(page, boundingBox, transformationMatrix) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            return (0, $47XJ3.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new PDFPageEmbedder(page, boundingBox, transformationMatrix)
                ];
            });
        });
    };
    PDFPageEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var _a, Contents, Resources, decodedContents, _b, left, bottom, right, top, xObject;
            return (0, $47XJ3.__generator)(this, function(_c) {
                _a = this.page.normalizedEntries(), Contents = _a.Contents, Resources = _a.Resources;
                if (!Contents) throw new (0, $6AcCU.MissingPageContentsEmbeddingError)();
                decodedContents = this.decodeContents(Contents);
                _b = this.boundingBox, left = _b.left, bottom = _b.bottom, right = _b.right, top = _b.top;
                xObject = context.flateStream(decodedContents, {
                    Type: 'XObject',
                    Subtype: 'Form',
                    FormType: 1,
                    BBox: [
                        left,
                        bottom,
                        right,
                        top
                    ],
                    Matrix: this.transformationMatrix,
                    Resources: Resources
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    // `contents` is an array of streams which are merged to include them in the XObject.
    // This methods extracts each stream and joins them with a newline character.
    PDFPageEmbedder.prototype.decodeContents = function(contents) {
        var newline = Uint8Array.of((0, $90Qf4.default).Newline);
        var decodedContents = [];
        for(var idx = 0, len = contents.size(); idx < len; idx++){
            var stream = contents.lookup(idx, (0, $1b80b011925bffc2$export$2e2bcd8739ae039));
            var content = void 0;
            if (stream instanceof (0, $9d0105b76c83b6a6$export$2e2bcd8739ae039)) content = (0, $30fd433752b1e562$export$b8317e68ca978594)(stream).decode();
            else if (stream instanceof (0, $a23e3df52ace75a5$export$2e2bcd8739ae039)) content = stream.getUnencodedContents();
            else throw new (0, $6AcCU.UnrecognizedStreamTypeError)(stream);
            decodedContents.push(content, newline);
        }
        return (0, $4LYfy.mergeIntoTypedArray).apply(void 0, decodedContents);
    };
    return PDFPageEmbedder;
}();
var $5b0b737ae7e3d3aa$export$2e2bcd8739ae039 = $5b0b737ae7e3d3aa$var$PDFPageEmbedder;



var $4A1Hw = parcelRequire("4A1Hw");

var $l0PqT = parcelRequire("l0PqT");

var $HB3Cf = parcelRequire("HB3Cf");

var $dKRgb = parcelRequire("dKRgb");



var $2npvA = parcelRequire("2npvA");


var $6IKEk = parcelRequire("6IKEk");






var $47XJ3 = parcelRequire("47XJ3");


var $2npvA = parcelRequire("2npvA");

var $47XJ3 = parcelRequire("47XJ3");



var $6IKEk = parcelRequire("6IKEk");

var $2npvA = parcelRequire("2npvA");

var $47XJ3 = parcelRequire("47XJ3");


var $2npvA = parcelRequire("2npvA");




var $2npvA = parcelRequire("2npvA");

var $dKRgb = parcelRequire("dKRgb");

var $6IKEk = parcelRequire("6IKEk");

parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");

var $6AcCU = parcelRequire("6AcCU");
// Examples:
//   `/Helv 12 Tf` -> ['Helv', '12']
//   `/HeBo 8.00 Tf` -> ['HeBo', '8.00']
//   `/HeBo Tf` -> ['HeBo', undefined]
var $753ebefef156b664$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+Tf/;
var $753ebefef156b664$var$PDFAcroField = /** @class */ function() {
    function PDFAcroField(dict, ref) {
        this.dict = dict;
        this.ref = ref;
    }
    PDFAcroField.prototype.T = function() {
        return this.dict.lookupMaybe((0, $2npvA.default).of('T'), (0, $14cdd14f9837102b$export$2e2bcd8739ae039), (0, $f752a7014a04a4bd$export$2e2bcd8739ae039));
    };
    PDFAcroField.prototype.Ff = function() {
        var numberOrRef = this.getInheritableAttribute((0, $2npvA.default).of('Ff'));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $dKRgb.default));
    };
    PDFAcroField.prototype.V = function() {
        var valueOrRef = this.getInheritableAttribute((0, $2npvA.default).of('V'));
        return this.dict.context.lookup(valueOrRef);
    };
    PDFAcroField.prototype.Kids = function() {
        return this.dict.lookupMaybe((0, $2npvA.default).of('Kids'), (0, $6IKEk.default));
    };
    // Parent(): PDFDict | undefined {
    //   return this.dict.lookupMaybe(PDFName.of('Parent'), PDFDict);
    // }
    PDFAcroField.prototype.DA = function() {
        var da = this.dict.lookup((0, $2npvA.default).of('DA'));
        if (da instanceof (0, $14cdd14f9837102b$export$2e2bcd8739ae039) || da instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039)) return da;
        return undefined;
    };
    PDFAcroField.prototype.setKids = function(kids) {
        this.dict.set((0, $2npvA.default).of('Kids'), this.dict.context.obj(kids));
    };
    PDFAcroField.prototype.getParent = function() {
        // const parent = this.Parent();
        // if (!parent) return undefined;
        // return new PDFAcroField(parent);
        var parentRef = this.dict.get((0, $2npvA.default).of('Parent'));
        if (parentRef instanceof (0, $dac7b6b491336f5d$export$2e2bcd8739ae039)) {
            var parent_1 = this.dict.lookup((0, $2npvA.default).of('Parent'), (0, $74b515754dab46b0$export$2e2bcd8739ae039));
            return new PDFAcroField(parent_1, parentRef);
        }
        return undefined;
    };
    PDFAcroField.prototype.setParent = function(parent) {
        if (!parent) this.dict.delete((0, $2npvA.default).of('Parent'));
        else this.dict.set((0, $2npvA.default).of('Parent'), parent);
    };
    PDFAcroField.prototype.getFullyQualifiedName = function() {
        var parent = this.getParent();
        if (!parent) return this.getPartialName();
        return parent.getFullyQualifiedName() + "." + this.getPartialName();
    };
    PDFAcroField.prototype.getPartialName = function() {
        var _a;
        return (_a = this.T()) === null || _a === void 0 ? void 0 : _a.decodeText();
    };
    PDFAcroField.prototype.setPartialName = function(partialName) {
        if (!partialName) this.dict.delete((0, $2npvA.default).of('T'));
        else this.dict.set((0, $2npvA.default).of('T'), (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(partialName));
    };
    PDFAcroField.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $2npvA.default).of('DA'), (0, $14cdd14f9837102b$export$2e2bcd8739ae039).of(appearance));
    };
    PDFAcroField.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFAcroField.prototype.setFontSize = function(fontSize) {
        var _a;
        var name = (_a = this.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
        var da = this.getDefaultAppearance();
        if (!da) throw new (0, $6AcCU.MissingDAEntryError)(name);
        var daMatch = (0, $8ZzAZ.findLastMatch)(da, $753ebefef156b664$var$tfRegex);
        if (!daMatch.match) throw new (0, $6AcCU.MissingTfOperatorError)(name);
        var daStart = da.slice(0, daMatch.pos - daMatch.match[0].length);
        var daEnd = daMatch.pos <= da.length ? da.slice(daMatch.pos) : '';
        var fontName = daMatch.match[1];
        var modifiedDa = daStart + " /" + fontName + " " + fontSize + " Tf " + daEnd;
        this.setDefaultAppearance(modifiedDa);
    };
    PDFAcroField.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.Ff()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAcroField.prototype.setFlags = function(flags) {
        this.dict.set((0, $2npvA.default).of('Ff'), (0, $dKRgb.default).of(flags));
    };
    PDFAcroField.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAcroField.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAcroField.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAcroField.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAcroField.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.dict.get(name);
        });
        return attribute;
    };
    PDFAcroField.prototype.ascend = function(visitor) {
        visitor(this);
        var parent = this.getParent();
        if (parent) parent.ascend(visitor);
    };
    return PDFAcroField;
}();
var $753ebefef156b664$export$2e2bcd8739ae039 = $753ebefef156b664$var$PDFAcroField;



var $47XJ3 = parcelRequire("47XJ3");


var $2npvA = parcelRequire("2npvA");




var $2npvA = parcelRequire("2npvA");

var $dKRgb = parcelRequire("dKRgb");
// TODO: Also handle the `/S` and `/D` entries
var $727885c4e5408cfa$var$BorderStyle = /** @class */ function() {
    function BorderStyle(dict) {
        this.dict = dict;
    }
    BorderStyle.prototype.W = function() {
        var W = this.dict.lookup((0, $2npvA.default).of('W'));
        if (W instanceof (0, $dKRgb.default)) return W;
        return undefined;
    };
    BorderStyle.prototype.getWidth = function() {
        var _a, _b;
        return (_b = (_a = this.W()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    BorderStyle.prototype.setWidth = function(width) {
        var W = this.dict.context.obj(width);
        this.dict.set((0, $2npvA.default).of('W'), W);
    };
    BorderStyle.fromDict = function(dict) {
        return new BorderStyle(dict);
    };
    return BorderStyle;
}();
var $727885c4e5408cfa$export$2e2bcd8739ae039 = $727885c4e5408cfa$var$BorderStyle;




var $2npvA = parcelRequire("2npvA");


var $6IKEk = parcelRequire("6IKEk");


var $dKRgb = parcelRequire("dKRgb");
var $019e40d485ae9e24$var$PDFAnnotation = /** @class */ function() {
    function PDFAnnotation(dict) {
        this.dict = dict;
    }
    // This is technically required by the PDF spec
    PDFAnnotation.prototype.Rect = function() {
        return this.dict.lookup((0, $2npvA.default).of('Rect'), (0, $6IKEk.default));
    };
    PDFAnnotation.prototype.AP = function() {
        return this.dict.lookupMaybe((0, $2npvA.default).of('AP'), (0, $74b515754dab46b0$export$2e2bcd8739ae039));
    };
    PDFAnnotation.prototype.F = function() {
        var numberOrRef = this.dict.lookup((0, $2npvA.default).of('F'));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $dKRgb.default));
    };
    PDFAnnotation.prototype.getRectangle = function() {
        var _a;
        var Rect = this.Rect();
        return (_a = Rect === null || Rect === void 0 ? void 0 : Rect.asRectangle()) !== null && _a !== void 0 ? _a : {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    };
    PDFAnnotation.prototype.setRectangle = function(rect) {
        var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
        var Rect = this.dict.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.dict.set((0, $2npvA.default).of('Rect'), Rect);
    };
    PDFAnnotation.prototype.getAppearanceState = function() {
        var AS = this.dict.lookup((0, $2npvA.default).of('AS'));
        if (AS instanceof (0, $2npvA.default)) return AS;
        return undefined;
    };
    PDFAnnotation.prototype.setAppearanceState = function(state) {
        this.dict.set((0, $2npvA.default).of('AS'), state);
    };
    PDFAnnotation.prototype.setAppearances = function(appearances) {
        this.dict.set((0, $2npvA.default).of('AP'), appearances);
    };
    PDFAnnotation.prototype.ensureAP = function() {
        var AP = this.AP();
        if (!AP) {
            AP = this.dict.context.obj({});
            this.dict.set((0, $2npvA.default).of('AP'), AP);
        }
        return AP;
    };
    PDFAnnotation.prototype.getNormalAppearance = function() {
        var AP = this.ensureAP();
        var N = AP.get((0, $2npvA.default).of('N'));
        if (N instanceof (0, $dac7b6b491336f5d$export$2e2bcd8739ae039) || N instanceof (0, $74b515754dab46b0$export$2e2bcd8739ae039)) return N;
        throw new Error("Unexpected N type: " + (N === null || N === void 0 ? void 0 : N.constructor.name));
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setNormalAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $2npvA.default).of('N'), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setRolloverAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $2npvA.default).of('R'), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setDownAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $2npvA.default).of('D'), appearance);
    };
    PDFAnnotation.prototype.removeRolloverAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $2npvA.default).of('R'));
    };
    PDFAnnotation.prototype.removeDownAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $2npvA.default).of('D'));
    };
    PDFAnnotation.prototype.getAppearances = function() {
        var AP = this.AP();
        if (!AP) return undefined;
        var N = AP.lookup((0, $2npvA.default).of('N'), (0, $74b515754dab46b0$export$2e2bcd8739ae039), (0, $1b80b011925bffc2$export$2e2bcd8739ae039));
        var R = AP.lookupMaybe((0, $2npvA.default).of('R'), (0, $74b515754dab46b0$export$2e2bcd8739ae039), (0, $1b80b011925bffc2$export$2e2bcd8739ae039));
        var D = AP.lookupMaybe((0, $2npvA.default).of('D'), (0, $74b515754dab46b0$export$2e2bcd8739ae039), (0, $1b80b011925bffc2$export$2e2bcd8739ae039));
        return {
            normal: N,
            rollover: R,
            down: D
        };
    };
    PDFAnnotation.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.F()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAnnotation.prototype.setFlags = function(flags) {
        this.dict.set((0, $2npvA.default).of('F'), (0, $dKRgb.default).of(flags));
    };
    PDFAnnotation.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAnnotation.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAnnotation.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAnnotation.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAnnotation.fromDict = function(dict) {
        return new PDFAnnotation(dict);
    };
    return PDFAnnotation;
}();
var $019e40d485ae9e24$export$2e2bcd8739ae039 = $019e40d485ae9e24$var$PDFAnnotation;



var $2npvA = parcelRequire("2npvA");

var $dKRgb = parcelRequire("dKRgb");

var $6IKEk = parcelRequire("6IKEk");


var $c030ec0b46d32883$var$AppearanceCharacteristics = /** @class */ function() {
    function AppearanceCharacteristics(dict) {
        this.dict = dict;
    }
    AppearanceCharacteristics.prototype.R = function() {
        var R = this.dict.lookup((0, $2npvA.default).of('R'));
        if (R instanceof (0, $dKRgb.default)) return R;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BC = function() {
        var BC = this.dict.lookup((0, $2npvA.default).of('BC'));
        if (BC instanceof (0, $6IKEk.default)) return BC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BG = function() {
        var BG = this.dict.lookup((0, $2npvA.default).of('BG'));
        if (BG instanceof (0, $6IKEk.default)) return BG;
        return undefined;
    };
    AppearanceCharacteristics.prototype.CA = function() {
        var CA = this.dict.lookup((0, $2npvA.default).of('CA'));
        if (CA instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039) || CA instanceof (0, $14cdd14f9837102b$export$2e2bcd8739ae039)) return CA;
        return undefined;
    };
    AppearanceCharacteristics.prototype.RC = function() {
        var RC = this.dict.lookup((0, $2npvA.default).of('RC'));
        if (RC instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039) || RC instanceof (0, $14cdd14f9837102b$export$2e2bcd8739ae039)) return RC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.AC = function() {
        var AC = this.dict.lookup((0, $2npvA.default).of('AC'));
        if (AC instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039) || AC instanceof (0, $14cdd14f9837102b$export$2e2bcd8739ae039)) return AC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.getRotation = function() {
        var _a;
        return (_a = this.R()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    AppearanceCharacteristics.prototype.getBorderColor = function() {
        var BC = this.BC();
        if (!BC) return undefined;
        var components = [];
        for(var idx = 0, len = BC === null || BC === void 0 ? void 0 : BC.size(); idx < len; idx++){
            var component = BC.get(idx);
            if (component instanceof (0, $dKRgb.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getBackgroundColor = function() {
        var BG = this.BG();
        if (!BG) return undefined;
        var components = [];
        for(var idx = 0, len = BG === null || BG === void 0 ? void 0 : BG.size(); idx < len; idx++){
            var component = BG.get(idx);
            if (component instanceof (0, $dKRgb.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getCaptions = function() {
        var CA = this.CA();
        var RC = this.RC();
        var AC = this.AC();
        return {
            normal: CA === null || CA === void 0 ? void 0 : CA.decodeText(),
            rollover: RC === null || RC === void 0 ? void 0 : RC.decodeText(),
            down: AC === null || AC === void 0 ? void 0 : AC.decodeText()
        };
    };
    AppearanceCharacteristics.prototype.setRotation = function(rotation) {
        var R = this.dict.context.obj(rotation);
        this.dict.set((0, $2npvA.default).of('R'), R);
    };
    AppearanceCharacteristics.prototype.setBorderColor = function(color) {
        var BC = this.dict.context.obj(color);
        this.dict.set((0, $2npvA.default).of('BC'), BC);
    };
    AppearanceCharacteristics.prototype.setBackgroundColor = function(color) {
        var BG = this.dict.context.obj(color);
        this.dict.set((0, $2npvA.default).of('BG'), BG);
    };
    AppearanceCharacteristics.prototype.setCaptions = function(captions) {
        var CA = (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(captions.normal);
        this.dict.set((0, $2npvA.default).of('CA'), CA);
        if (captions.rollover) {
            var RC = (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(captions.rollover);
            this.dict.set((0, $2npvA.default).of('RC'), RC);
        } else this.dict.delete((0, $2npvA.default).of('RC'));
        if (captions.down) {
            var AC = (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(captions.down);
            this.dict.set((0, $2npvA.default).of('AC'), AC);
        } else this.dict.delete((0, $2npvA.default).of('AC'));
    };
    AppearanceCharacteristics.fromDict = function(dict) {
        return new AppearanceCharacteristics(dict);
    };
    return AppearanceCharacteristics;
}();
var $c030ec0b46d32883$export$2e2bcd8739ae039 = $c030ec0b46d32883$var$AppearanceCharacteristics;


var $67a3a0ae6b16125d$var$PDFWidgetAnnotation = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFWidgetAnnotation, _super);
    function PDFWidgetAnnotation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFWidgetAnnotation.prototype.MK = function() {
        var MK = this.dict.lookup((0, $2npvA.default).of('MK'));
        if (MK instanceof (0, $74b515754dab46b0$export$2e2bcd8739ae039)) return MK;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.BS = function() {
        var BS = this.dict.lookup((0, $2npvA.default).of('BS'));
        if (BS instanceof (0, $74b515754dab46b0$export$2e2bcd8739ae039)) return BS;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.DA = function() {
        var da = this.dict.lookup((0, $2npvA.default).of('DA'));
        if (da instanceof (0, $14cdd14f9837102b$export$2e2bcd8739ae039) || da instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039)) return da;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.P = function() {
        var P = this.dict.get((0, $2npvA.default).of('P'));
        if (P instanceof (0, $dac7b6b491336f5d$export$2e2bcd8739ae039)) return P;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.setP = function(page) {
        this.dict.set((0, $2npvA.default).of('P'), page);
    };
    PDFWidgetAnnotation.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $2npvA.default).of('DA'), (0, $14cdd14f9837102b$export$2e2bcd8739ae039).of(appearance));
    };
    PDFWidgetAnnotation.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFWidgetAnnotation.prototype.getAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $c030ec0b46d32883$export$2e2bcd8739ae039).fromDict(MK);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $c030ec0b46d32883$export$2e2bcd8739ae039).fromDict(MK);
        var ac = (0, $c030ec0b46d32883$export$2e2bcd8739ae039).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $2npvA.default).of('MK'), ac.dict);
        return ac;
    };
    PDFWidgetAnnotation.prototype.getBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $727885c4e5408cfa$export$2e2bcd8739ae039).fromDict(BS);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $727885c4e5408cfa$export$2e2bcd8739ae039).fromDict(BS);
        var bs = (0, $727885c4e5408cfa$export$2e2bcd8739ae039).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $2npvA.default).of('BS'), bs.dict);
        return bs;
    };
    PDFWidgetAnnotation.prototype.getOnValue = function() {
        var _a;
        var normal = (_a = this.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
        if (normal instanceof (0, $74b515754dab46b0$export$2e2bcd8739ae039)) {
            var keys = normal.keys();
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                if (key !== (0, $2npvA.default).of('Off')) return key;
            }
        }
        return undefined;
    };
    PDFWidgetAnnotation.fromDict = function(dict) {
        return new PDFWidgetAnnotation(dict);
    };
    PDFWidgetAnnotation.create = function(context, parent) {
        var dict = context.obj({
            Type: 'Annot',
            Subtype: 'Widget',
            Rect: [
                0,
                0,
                0,
                0
            ],
            Parent: parent
        });
        return new PDFWidgetAnnotation(dict);
    };
    return PDFWidgetAnnotation;
}((0, $019e40d485ae9e24$export$2e2bcd8739ae039));
var $67a3a0ae6b16125d$export$2e2bcd8739ae039 = $67a3a0ae6b16125d$var$PDFWidgetAnnotation;



var $6AcCU = parcelRequire("6AcCU");
var $1d777609aab029cf$var$PDFAcroTerminal = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFAcroTerminal, _super);
    function PDFAcroTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroTerminal.prototype.FT = function() {
        var nameOrRef = this.getInheritableAttribute((0, $2npvA.default).of('FT'));
        return this.dict.context.lookup(nameOrRef, (0, $2npvA.default));
    };
    PDFAcroTerminal.prototype.getWidgets = function() {
        var kidDicts = this.Kids();
        // This field is itself a widget
        if (!kidDicts) return [
            (0, $67a3a0ae6b16125d$export$2e2bcd8739ae039).fromDict(this.dict)
        ];
        // This field's kids are its widgets
        var widgets = new Array(kidDicts.size());
        for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
            var dict = kidDicts.lookup(idx, (0, $74b515754dab46b0$export$2e2bcd8739ae039));
            widgets[idx] = (0, $67a3a0ae6b16125d$export$2e2bcd8739ae039).fromDict(dict);
        }
        return widgets;
    };
    PDFAcroTerminal.prototype.addWidget = function(ref) {
        var Kids = this.normalizedEntries().Kids;
        Kids.push(ref);
    };
    PDFAcroTerminal.prototype.removeWidget = function(idx) {
        var kidDicts = this.Kids();
        if (!kidDicts) {
            // This field is itself a widget
            if (idx !== 0) throw new (0, $6AcCU.IndexOutOfBoundsError)(idx, 0, 0);
            this.setKids([]);
        } else {
            // This field's kids are its widgets
            if (idx < 0 || idx > kidDicts.size()) throw new (0, $6AcCU.IndexOutOfBoundsError)(idx, 0, kidDicts.size());
            kidDicts.remove(idx);
        }
    };
    PDFAcroTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        // If this field is itself a widget (because it was only rendered once in
        // the document, so the field and widget properties were merged) then we
        // add itself to the `Kids` array. The alternative would be to try
        // splitting apart the widget properties and creating a separate object
        // for them.
        if (!Kids) {
            Kids = this.dict.context.obj([
                this.ref
            ]);
            this.dict.set((0, $2npvA.default).of('Kids'), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroTerminal.fromDict = function(dict, ref) {
        return new PDFAcroTerminal(dict, ref);
    };
    return PDFAcroTerminal;
}((0, $753ebefef156b664$export$2e2bcd8739ae039));
var $1d777609aab029cf$export$2e2bcd8739ae039 = $1d777609aab029cf$var$PDFAcroTerminal;



var $6AcCU = parcelRequire("6AcCU");
var $7bb9be65840f54d2$var$PDFAcroButton = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFAcroButton, _super);
    function PDFAcroButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroButton.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $2npvA.default).of('Opt'), (0, $14cdd14f9837102b$export$2e2bcd8739ae039), (0, $f752a7014a04a4bd$export$2e2bcd8739ae039), (0, $6IKEk.default));
    };
    PDFAcroButton.prototype.setOpt = function(opt) {
        this.dict.set((0, $2npvA.default).of('Opt'), this.dict.context.obj(opt));
    };
    PDFAcroButton.prototype.getExportValues = function() {
        var opt = this.Opt();
        if (!opt) return undefined;
        if (opt instanceof (0, $14cdd14f9837102b$export$2e2bcd8739ae039) || opt instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039)) return [
            opt
        ];
        var values = [];
        for(var idx = 0, len = opt.size(); idx < len; idx++){
            var value = opt.lookup(idx);
            if (value instanceof (0, $14cdd14f9837102b$export$2e2bcd8739ae039) || value instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039)) values.push(value);
        }
        return values;
    };
    PDFAcroButton.prototype.removeExportValue = function(idx) {
        var opt = this.Opt();
        if (!opt) return;
        if (opt instanceof (0, $14cdd14f9837102b$export$2e2bcd8739ae039) || opt instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039)) {
            if (idx !== 0) throw new (0, $6AcCU.IndexOutOfBoundsError)(idx, 0, 0);
            this.setOpt([]);
        } else {
            if (idx < 0 || idx > opt.size()) throw new (0, $6AcCU.IndexOutOfBoundsError)(idx, 0, opt.size());
            opt.remove(idx);
        }
    };
    // Enforce use use of /Opt even if it isn't strictly necessary
    PDFAcroButton.prototype.normalizeExportValues = function() {
        var _a, _b, _c, _d;
        var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
        var Opt = [];
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var exportVal = (_b = exportValues[idx]) !== null && _b !== void 0 ? _b : (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText((_d = (_c = widget.getOnValue()) === null || _c === void 0 ? void 0 : _c.decodeText()) !== null && _d !== void 0 ? _d : '');
            Opt.push(exportVal);
        }
        this.setOpt(Opt);
    };
    /**
     * Reuses existing opt if one exists with the same value (assuming
     * `useExistingIdx` is `true`). Returns index of existing (or new) opt.
     */ PDFAcroButton.prototype.addOpt = function(opt, useExistingOptIdx) {
        var _a;
        this.normalizeExportValues();
        var optText = opt.decodeText();
        var existingIdx;
        if (useExistingOptIdx) {
            var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
            for(var idx = 0, len = exportValues.length; idx < len; idx++){
                var exportVal = exportValues[idx];
                if (exportVal.decodeText() === optText) existingIdx = idx;
            }
        }
        var Opt = this.Opt();
        Opt.push(opt);
        return existingIdx !== null && existingIdx !== void 0 ? existingIdx : Opt.size() - 1;
    };
    PDFAcroButton.prototype.addWidgetWithOpt = function(widget, opt, useExistingOptIdx) {
        var optIdx = this.addOpt(opt, useExistingOptIdx);
        var apStateValue = (0, $2npvA.default).of(String(optIdx));
        this.addWidget(widget);
        return apStateValue;
    };
    return PDFAcroButton;
}((0, $1d777609aab029cf$export$2e2bcd8739ae039));
var $7bb9be65840f54d2$export$2e2bcd8739ae039 = $7bb9be65840f54d2$var$PDFAcroButton;



var $47XJ3 = parcelRequire("47XJ3");

var $2npvA = parcelRequire("2npvA");


var $6AcCU = parcelRequire("6AcCU");
var $c3b1375c30b7a81d$var$PDFAcroCheckBox = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFAcroCheckBox, _super);
    function PDFAcroCheckBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroCheckBox.prototype.setValue = function(value) {
        var _a;
        var onValue = (_a = this.getOnValue()) !== null && _a !== void 0 ? _a : (0, $2npvA.default).of('Yes');
        if (value !== onValue && value !== (0, $2npvA.default).of('Off')) throw new (0, $6AcCU.InvalidAcroFieldValueError)();
        this.dict.set((0, $2npvA.default).of('V'), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $2npvA.default).of('Off');
            widget.setAppearanceState(state);
        }
    };
    PDFAcroCheckBox.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $2npvA.default)) return v;
        return (0, $2npvA.default).of('Off');
    };
    PDFAcroCheckBox.prototype.getOnValue = function() {
        var widget = this.getWidgets()[0];
        return widget === null || widget === void 0 ? void 0 : widget.getOnValue();
    };
    PDFAcroCheckBox.fromDict = function(dict, ref) {
        return new PDFAcroCheckBox(dict, ref);
    };
    PDFAcroCheckBox.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroCheckBox(dict, ref);
    };
    return PDFAcroCheckBox;
}((0, $7bb9be65840f54d2$export$2e2bcd8739ae039));
var $c3b1375c30b7a81d$export$2e2bcd8739ae039 = $c3b1375c30b7a81d$var$PDFAcroCheckBox;



var $47XJ3 = parcelRequire("47XJ3");




var $6IKEk = parcelRequire("6IKEk");

var $2npvA = parcelRequire("2npvA");
var $ccb031b501604dea$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $ccb031b501604dea$export$3600c95532547643;
(function(AcroFieldFlags) {
    /**
     * If set, the user may not change the value of the field. Any associated
     * widget annotations will not interact with the user; that is, they will not
     * respond to mouse clicks or change their appearance in response to mouse
     * motions. This flag is useful for fields whose values are computed or
     * imported from a database.
     */ AcroFieldFlags[AcroFieldFlags["ReadOnly"] = $ccb031b501604dea$var$flag(0)] = "ReadOnly";
    /**
     * If set, the field shall have a value at the time it is exported by a
     * submit-form action (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["Required"] = $ccb031b501604dea$var$flag(1)] = "Required";
    /**
     * If set, the field shall not be exported by a submit-form action
     * (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["NoExport"] = $ccb031b501604dea$var$flag(2)] = "NoExport";
})($ccb031b501604dea$export$3600c95532547643 || ($ccb031b501604dea$export$3600c95532547643 = {}));
var $ccb031b501604dea$export$59f660e89ffb4f8a;
(function(AcroButtonFlags) {
    /**
     * (Radio buttons only) If set, exactly one radio button shall be selected at
     * all times; selecting the currently selected button has no effect. If clear,
     * clicking the selected button deselects it, leaving no button selected.
     */ AcroButtonFlags[AcroButtonFlags["NoToggleToOff"] = $ccb031b501604dea$var$flag(14)] = "NoToggleToOff";
    /**
     * If set, the field is a set of radio buttons; if clear, the field is a check
     * box. This flag may be set only if the Pushbutton flag is clear.
     */ AcroButtonFlags[AcroButtonFlags["Radio"] = $ccb031b501604dea$var$flag(15)] = "Radio";
    /**
     * If set, the field is a pushbutton that does not retain a permanent value.
     */ AcroButtonFlags[AcroButtonFlags["PushButton"] = $ccb031b501604dea$var$flag(16)] = "PushButton";
    /**
     * If set, a group of radio buttons within a radio button field that use the
     * same value for the on state will turn on and off in unison; that is if one
     * is checked, they are all checked. If clear, the buttons are mutually
     * exclusive (the same behavior as HTML radio buttons).
     */ AcroButtonFlags[AcroButtonFlags["RadiosInUnison"] = $ccb031b501604dea$var$flag(25)] = "RadiosInUnison";
})($ccb031b501604dea$export$59f660e89ffb4f8a || ($ccb031b501604dea$export$59f660e89ffb4f8a = {}));
var $ccb031b501604dea$export$389fc7b97397dc8b;
(function(AcroTextFlags) {
    /**
     * If set, the field may contain multiple lines of text; if clear, the field's
     * text shall be restricted to a single line.
     */ AcroTextFlags[AcroTextFlags["Multiline"] = $ccb031b501604dea$var$flag(12)] = "Multiline";
    /**
     * If set, the field is intended for entering a secure password that should
     * not be echoed visibly to the screen. Characters typed from the keyboard
     * shall instead be echoed in some unreadable form, such as asterisks or
     * bullet characters.
     * > NOTE   To protect password confidentiality, readers should never store
     * >        the value of the text field in the PDF file if this flag is set.
     */ AcroTextFlags[AcroTextFlags["Password"] = $ccb031b501604dea$var$flag(13)] = "Password";
    /**
     * If set, the text entered in the field represents the pathname of a file
     * whose contents shall be submitted as the value of the field.
     */ AcroTextFlags[AcroTextFlags["FileSelect"] = $ccb031b501604dea$var$flag(20)] = "FileSelect";
    /**
     * If set, text entered in the field shall not be spell-checked.
     */ AcroTextFlags[AcroTextFlags["DoNotSpellCheck"] = $ccb031b501604dea$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the field shall not scroll (horizontally for single-line fields,
     * vertically for multiple-line fields) to accommodate more text than fits
     * within its annotation rectangle. Once the field is full, no further text
     * shall be accepted for interactive form filling; for non-interactive form
     * filling, the filler should take care not to add more character than will
     * visibly fit in the defined area.
     */ AcroTextFlags[AcroTextFlags["DoNotScroll"] = $ccb031b501604dea$var$flag(23)] = "DoNotScroll";
    /**
     * May be set only if the MaxLen entry is present in the text field dictionary
     * (see Table 229) and if the Multiline, Password, and FileSelect flags are
     * clear. If set, the field shall be automatically divided into as many
     * equally spaced positions, or combs, as the value of MaxLen, and the text
     * is laid out into those combs.
     */ AcroTextFlags[AcroTextFlags["Comb"] = $ccb031b501604dea$var$flag(24)] = "Comb";
    /**
     * If set, the value of this field shall be a rich text string
     * (see 12.7.3.4, "Rich Text Strings"). If the field has a value, the RV
     * entry of the field dictionary (Table 222) shall specify the rich text
     * string.
     */ AcroTextFlags[AcroTextFlags["RichText"] = $ccb031b501604dea$var$flag(25)] = "RichText";
})($ccb031b501604dea$export$389fc7b97397dc8b || ($ccb031b501604dea$export$389fc7b97397dc8b = {}));
var $ccb031b501604dea$export$eb88827058402599;
(function(AcroChoiceFlags) {
    /**
     * If set, the field is a combo box; if clear, the field is a list box.
     */ AcroChoiceFlags[AcroChoiceFlags["Combo"] = $ccb031b501604dea$var$flag(17)] = "Combo";
    /**
     * If set, the combo box shall include an editable text box as well as a
     * drop-down list; if clear, it shall include only a drop-down list. This
     * flag shall be used only if the Combo flag is set.
     */ AcroChoiceFlags[AcroChoiceFlags["Edit"] = $ccb031b501604dea$var$flag(18)] = "Edit";
    /**
     * If set, the field's option items shall be sorted alphabetically. This flag
     * is intended for use by writers, not by readers. Conforming readers shall
     * display the options in the order in which they occur in the Opt array
     * (see Table 231).
     */ AcroChoiceFlags[AcroChoiceFlags["Sort"] = $ccb031b501604dea$var$flag(19)] = "Sort";
    /**
     * If set, more than one of the field's option items may be selected
     * simultaneously; if clear, at most one item shall be selected.
     */ AcroChoiceFlags[AcroChoiceFlags["MultiSelect"] = $ccb031b501604dea$var$flag(21)] = "MultiSelect";
    /**
     * If set, text entered in the field shall not be spell-checked. This flag
     * shall not be used unless the Combo and Edit flags are both set.
     */ AcroChoiceFlags[AcroChoiceFlags["DoNotSpellCheck"] = $ccb031b501604dea$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the new value shall be committed as soon as a selection is made
     * (commonly with the pointing device). In this case, supplying a value for
     * a field involves three actions: selecting the field for fill-in,
     * selecting a choice for the fill-in value, and leaving that field, which
     * finalizes or "commits" the data choice and triggers any actions associated
     * with the entry or changing of this data. If this flag is on, then
     * processing does not wait for leaving the field action to occur, but
     * immediately proceeds to the third step.
     *
     * This option enables applications to perform an action once a selection is
     * made, without requiring the user to exit the field. If clear, the new
     * value is not committed until the user exits the field.
     */ AcroChoiceFlags[AcroChoiceFlags["CommitOnSelChange"] = $ccb031b501604dea$var$flag(26)] = "CommitOnSelChange";
})($ccb031b501604dea$export$eb88827058402599 || ($ccb031b501604dea$export$eb88827058402599 = {}));



var $6AcCU = parcelRequire("6AcCU");
var $b25b288d4a64df5d$var$PDFAcroChoice = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFAcroChoice, _super);
    function PDFAcroChoice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroChoice.prototype.setValues = function(values) {
        if (this.hasFlag((0, $ccb031b501604dea$export$eb88827058402599).Combo) && !this.hasFlag((0, $ccb031b501604dea$export$eb88827058402599).Edit) && !this.valuesAreValid(values)) throw new (0, $6AcCU.InvalidAcroFieldValueError)();
        if (values.length === 0) this.dict.delete((0, $2npvA.default).of('V'));
        if (values.length === 1) this.dict.set((0, $2npvA.default).of('V'), values[0]);
        if (values.length > 1) {
            if (!this.hasFlag((0, $ccb031b501604dea$export$eb88827058402599).MultiSelect)) throw new (0, $6AcCU.MultiSelectValueError)();
            this.dict.set((0, $2npvA.default).of('V'), this.dict.context.obj(values));
        }
        this.updateSelectedIndices(values);
    };
    PDFAcroChoice.prototype.valuesAreValid = function(values) {
        var options = this.getOptions();
        var _loop_1 = function(idx, len) {
            var val = values[idx].decodeText();
            if (!options.find(function(o) {
                return val === (o.display || o.value).decodeText();
            })) return {
                value: false
            };
        };
        for(var idx = 0, len = values.length; idx < len; idx++){
            var state_1 = _loop_1(idx, len);
            if (typeof state_1 === "object") return state_1.value;
        }
        return true;
    };
    PDFAcroChoice.prototype.updateSelectedIndices = function(values) {
        if (values.length > 1) {
            var indices = new Array(values.length);
            var options = this.getOptions();
            var _loop_2 = function(idx, len) {
                var val = values[idx].decodeText();
                indices[idx] = options.findIndex(function(o) {
                    return val === (o.display || o.value).decodeText();
                });
            };
            for(var idx = 0, len = values.length; idx < len; idx++)_loop_2(idx, len);
            this.dict.set((0, $2npvA.default).of('I'), this.dict.context.obj(indices.sort()));
        } else this.dict.delete((0, $2npvA.default).of('I'));
    };
    PDFAcroChoice.prototype.getValues = function() {
        var v = this.V();
        if (v instanceof (0, $14cdd14f9837102b$export$2e2bcd8739ae039) || v instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039)) return [
            v
        ];
        if (v instanceof (0, $6IKEk.default)) {
            var values = [];
            for(var idx = 0, len = v.size(); idx < len; idx++){
                var value = v.lookup(idx);
                if (value instanceof (0, $14cdd14f9837102b$export$2e2bcd8739ae039) || value instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039)) values.push(value);
            }
            return values;
        }
        return [];
    };
    PDFAcroChoice.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $2npvA.default).of('Opt'), (0, $14cdd14f9837102b$export$2e2bcd8739ae039), (0, $f752a7014a04a4bd$export$2e2bcd8739ae039), (0, $6IKEk.default));
    };
    PDFAcroChoice.prototype.setOptions = function(options) {
        var newOpt = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = options[idx], value = _a.value, display = _a.display;
            newOpt[idx] = this.dict.context.obj([
                value,
                display || value
            ]);
        }
        this.dict.set((0, $2npvA.default).of('Opt'), this.dict.context.obj(newOpt));
    };
    PDFAcroChoice.prototype.getOptions = function() {
        var Opt = this.Opt();
        // Not supposed to happen - Opt _should_ always be `PDFArray | undefined`
        if (Opt instanceof (0, $14cdd14f9837102b$export$2e2bcd8739ae039) || Opt instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039)) return [
            {
                value: Opt,
                display: Opt
            }
        ];
        if (Opt instanceof (0, $6IKEk.default)) {
            var res = [];
            for(var idx = 0, len = Opt.size(); idx < len; idx++){
                var item = Opt.lookup(idx);
                // If `item` is a string, use that as both the export and text value
                if (item instanceof (0, $14cdd14f9837102b$export$2e2bcd8739ae039) || item instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039)) res.push({
                    value: item,
                    display: item
                });
                // If `item` is an array of one, treat it the same as just a string,
                // if it's an array of two then `item[0]` is the export value and
                // `item[1]` is the text value
                if (item instanceof (0, $6IKEk.default)) {
                    if (item.size() > 0) {
                        var first = item.lookup(0, (0, $14cdd14f9837102b$export$2e2bcd8739ae039), (0, $f752a7014a04a4bd$export$2e2bcd8739ae039));
                        var second = item.lookupMaybe(1, (0, $14cdd14f9837102b$export$2e2bcd8739ae039), (0, $f752a7014a04a4bd$export$2e2bcd8739ae039));
                        res.push({
                            value: first,
                            display: second || first
                        });
                    }
                }
            }
            return res;
        }
        return [];
    };
    return PDFAcroChoice;
}((0, $1d777609aab029cf$export$2e2bcd8739ae039));
var $b25b288d4a64df5d$export$2e2bcd8739ae039 = $b25b288d4a64df5d$var$PDFAcroChoice;



var $47XJ3 = parcelRequire("47XJ3");


var $bf8a873fef9e7de8$var$PDFAcroComboBox = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFAcroComboBox, _super);
    function PDFAcroComboBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroComboBox.fromDict = function(dict, ref) {
        return new PDFAcroComboBox(dict, ref);
    };
    PDFAcroComboBox.create = function(context) {
        var dict = context.obj({
            FT: 'Ch',
            Ff: (0, $ccb031b501604dea$export$eb88827058402599).Combo,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroComboBox(dict, ref);
    };
    return PDFAcroComboBox;
}((0, $b25b288d4a64df5d$export$2e2bcd8739ae039));
var $bf8a873fef9e7de8$export$2e2bcd8739ae039 = $bf8a873fef9e7de8$var$PDFAcroComboBox;





var $6IKEk = parcelRequire("6IKEk");

var $2npvA = parcelRequire("2npvA");

var $47XJ3 = parcelRequire("47XJ3");

var $2npvA = parcelRequire("2npvA");

var $1416fe06ca3d86c2$var$PDFAcroNonTerminal = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFAcroNonTerminal, _super);
    function PDFAcroNonTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroNonTerminal.prototype.addField = function(field) {
        var Kids = this.normalizedEntries().Kids;
        Kids === null || Kids === void 0 || Kids.push(field);
    };
    PDFAcroNonTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        if (!Kids) {
            Kids = this.dict.context.obj([]);
            this.dict.set((0, $2npvA.default).of('Kids'), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroNonTerminal.fromDict = function(dict, ref) {
        return new PDFAcroNonTerminal(dict, ref);
    };
    PDFAcroNonTerminal.create = function(context) {
        var dict = context.obj({});
        var ref = context.register(dict);
        return new PDFAcroNonTerminal(dict, ref);
    };
    return PDFAcroNonTerminal;
}((0, $753ebefef156b664$export$2e2bcd8739ae039));
var $1416fe06ca3d86c2$export$2e2bcd8739ae039 = $1416fe06ca3d86c2$var$PDFAcroNonTerminal;



var $dKRgb = parcelRequire("dKRgb");


var $2npvA = parcelRequire("2npvA");

var $6IKEk = parcelRequire("6IKEk");




var $47XJ3 = parcelRequire("47XJ3");

var $3bb4d5d3b9a6eaaa$var$PDFAcroSignature = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFAcroSignature, _super);
    function PDFAcroSignature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroSignature.fromDict = function(dict, ref) {
        return new PDFAcroSignature(dict, ref);
    };
    return PDFAcroSignature;
}((0, $1d777609aab029cf$export$2e2bcd8739ae039));
var $3bb4d5d3b9a6eaaa$export$2e2bcd8739ae039 = $3bb4d5d3b9a6eaaa$var$PDFAcroSignature;



var $47XJ3 = parcelRequire("47XJ3");

var $dKRgb = parcelRequire("dKRgb");



var $2npvA = parcelRequire("2npvA");

var $197bdef3d7df2cfd$var$PDFAcroText = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFAcroText, _super);
    function PDFAcroText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroText.prototype.MaxLen = function() {
        var maxLen = this.dict.lookup((0, $2npvA.default).of('MaxLen'));
        if (maxLen instanceof (0, $dKRgb.default)) return maxLen;
        return undefined;
    };
    PDFAcroText.prototype.Q = function() {
        var q = this.dict.lookup((0, $2npvA.default).of('Q'));
        if (q instanceof (0, $dKRgb.default)) return q;
        return undefined;
    };
    PDFAcroText.prototype.setMaxLength = function(maxLength) {
        this.dict.set((0, $2npvA.default).of('MaxLen'), (0, $dKRgb.default).of(maxLength));
    };
    PDFAcroText.prototype.removeMaxLength = function() {
        this.dict.delete((0, $2npvA.default).of('MaxLen'));
    };
    PDFAcroText.prototype.getMaxLength = function() {
        var _a;
        return (_a = this.MaxLen()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setQuadding = function(quadding) {
        this.dict.set((0, $2npvA.default).of('Q'), (0, $dKRgb.default).of(quadding));
    };
    PDFAcroText.prototype.getQuadding = function() {
        var _a;
        return (_a = this.Q()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setValue = function(value) {
        this.dict.set((0, $2npvA.default).of('V'), value);
    // const widgets = this.getWidgets();
    // for (let idx = 0, len = widgets.length; idx < len; idx++) {
    //   const widget = widgets[idx];
    //   const state = widget.getOnValue() === value ? value : PDFName.of('Off');
    //   widget.setAppearanceState(state);
    // }
    };
    PDFAcroText.prototype.removeValue = function() {
        this.dict.delete((0, $2npvA.default).of('V'));
    };
    PDFAcroText.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $14cdd14f9837102b$export$2e2bcd8739ae039) || v instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039)) return v;
        return undefined;
    };
    PDFAcroText.fromDict = function(dict, ref) {
        return new PDFAcroText(dict, ref);
    };
    PDFAcroText.create = function(context) {
        var dict = context.obj({
            FT: 'Tx',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroText(dict, ref);
    };
    return PDFAcroText;
}((0, $1d777609aab029cf$export$2e2bcd8739ae039));
var $197bdef3d7df2cfd$export$2e2bcd8739ae039 = $197bdef3d7df2cfd$var$PDFAcroText;



var $47XJ3 = parcelRequire("47XJ3");


var $96dc99afef1c0142$var$PDFAcroPushButton = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFAcroPushButton, _super);
    function PDFAcroPushButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroPushButton.fromDict = function(dict, ref) {
        return new PDFAcroPushButton(dict, ref);
    };
    PDFAcroPushButton.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Ff: (0, $ccb031b501604dea$export$59f660e89ffb4f8a).PushButton,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroPushButton(dict, ref);
    };
    return PDFAcroPushButton;
}((0, $7bb9be65840f54d2$export$2e2bcd8739ae039));
var $96dc99afef1c0142$export$2e2bcd8739ae039 = $96dc99afef1c0142$var$PDFAcroPushButton;



var $47XJ3 = parcelRequire("47XJ3");

var $2npvA = parcelRequire("2npvA");



var $6AcCU = parcelRequire("6AcCU");
var $3aa58c09e70127a0$var$PDFAcroRadioButton = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFAcroRadioButton, _super);
    function PDFAcroRadioButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroRadioButton.prototype.setValue = function(value) {
        var onValues = this.getOnValues();
        if (!onValues.includes(value) && value !== (0, $2npvA.default).of('Off')) throw new (0, $6AcCU.InvalidAcroFieldValueError)();
        this.dict.set((0, $2npvA.default).of('V'), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $2npvA.default).of('Off');
            widget.setAppearanceState(state);
        }
    };
    PDFAcroRadioButton.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $2npvA.default)) return v;
        return (0, $2npvA.default).of('Off');
    };
    PDFAcroRadioButton.prototype.getOnValues = function() {
        var widgets = this.getWidgets();
        var onValues = [];
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var onValue = widgets[idx].getOnValue();
            if (onValue) onValues.push(onValue);
        }
        return onValues;
    };
    PDFAcroRadioButton.fromDict = function(dict, ref) {
        return new PDFAcroRadioButton(dict, ref);
    };
    PDFAcroRadioButton.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Ff: (0, $ccb031b501604dea$export$59f660e89ffb4f8a).Radio,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroRadioButton(dict, ref);
    };
    return PDFAcroRadioButton;
}((0, $7bb9be65840f54d2$export$2e2bcd8739ae039));
var $3aa58c09e70127a0$export$2e2bcd8739ae039 = $3aa58c09e70127a0$var$PDFAcroRadioButton;





var $47XJ3 = parcelRequire("47XJ3");

var $c262204623e264f5$var$PDFAcroListBox = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFAcroListBox, _super);
    function PDFAcroListBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroListBox.fromDict = function(dict, ref) {
        return new PDFAcroListBox(dict, ref);
    };
    PDFAcroListBox.create = function(context) {
        var dict = context.obj({
            FT: 'Ch',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroListBox(dict, ref);
    };
    return PDFAcroListBox;
}((0, $b25b288d4a64df5d$export$2e2bcd8739ae039));
var $c262204623e264f5$export$2e2bcd8739ae039 = $c262204623e264f5$var$PDFAcroListBox;



var $3ac6010d818efd71$export$34b4fb8893136c4c = function(kidDicts) {
    if (!kidDicts) return [];
    var kids = [];
    for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
        var ref = kidDicts.get(idx);
        var dict = kidDicts.lookup(idx);
        // if (dict instanceof PDFDict) kids.push(PDFAcroField.fromDict(dict));
        if (ref instanceof (0, $dac7b6b491336f5d$export$2e2bcd8739ae039) && dict instanceof (0, $74b515754dab46b0$export$2e2bcd8739ae039)) kids.push([
            $3ac6010d818efd71$export$fe770f59a8fbe6d(dict, ref),
            ref
        ]);
    }
    return kids;
};
var $3ac6010d818efd71$export$fe770f59a8fbe6d = function(dict, ref) {
    var isNonTerminal = $3ac6010d818efd71$var$isNonTerminalAcroField(dict);
    if (isNonTerminal) return (0, $1416fe06ca3d86c2$export$2e2bcd8739ae039).fromDict(dict, ref);
    return $3ac6010d818efd71$var$createPDFAcroTerminal(dict, ref);
};
// TODO: Maybe just check if the dict is *not* a widget? That might be better.
// According to the PDF spec:
//
//   > A field's children in the hierarchy may also include widget annotations
//   > that define its appearance on the page. A field that has children that
//   > are fields is called a non-terminal field. A field that does not have
//   > children that are fields is called a terminal field.
//
// The spec is not entirely clear about how to determine whether a given
// dictionary represents an acrofield or a widget annotation. So we will assume
// that a dictionary is an acrofield if it is a member of the `/Kids` array
// and it contains a `/T` entry (widgets do not have `/T` entries). This isn't
// a bullet proof solution, because the `/T` entry is technically defined as
// optional for acrofields by the PDF spec. But in practice all acrofields seem
// to have a `/T` entry defined.
var $3ac6010d818efd71$var$isNonTerminalAcroField = function(dict) {
    var kids = dict.lookup((0, $2npvA.default).of('Kids'));
    if (kids instanceof (0, $6IKEk.default)) for(var idx = 0, len = kids.size(); idx < len; idx++){
        var kid = kids.lookup(idx);
        var kidIsField = kid instanceof (0, $74b515754dab46b0$export$2e2bcd8739ae039) && kid.has((0, $2npvA.default).of('T'));
        if (kidIsField) return true;
    }
    return false;
};
var $3ac6010d818efd71$var$createPDFAcroTerminal = function(dict, ref) {
    var ftNameOrRef = $3ac6010d818efd71$var$getInheritableAttribute(dict, (0, $2npvA.default).of('FT'));
    var type = dict.context.lookup(ftNameOrRef, (0, $2npvA.default));
    if (type === (0, $2npvA.default).of('Btn')) return $3ac6010d818efd71$var$createPDFAcroButton(dict, ref);
    if (type === (0, $2npvA.default).of('Ch')) return $3ac6010d818efd71$var$createPDFAcroChoice(dict, ref);
    if (type === (0, $2npvA.default).of('Tx')) return (0, $197bdef3d7df2cfd$export$2e2bcd8739ae039).fromDict(dict, ref);
    if (type === (0, $2npvA.default).of('Sig')) return (0, $3bb4d5d3b9a6eaaa$export$2e2bcd8739ae039).fromDict(dict, ref);
    // We should never reach this line. But there are a lot of weird PDFs out
    // there. So, just to be safe, we'll try to handle things gracefully instead
    // of throwing an error.
    return (0, $1d777609aab029cf$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $3ac6010d818efd71$var$createPDFAcroButton = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $3ac6010d818efd71$var$getInheritableAttribute(dict, (0, $2npvA.default).of('Ff'));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $dKRgb.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($3ac6010d818efd71$var$flagIsSet(flags, (0, $ccb031b501604dea$export$59f660e89ffb4f8a).PushButton)) return (0, $96dc99afef1c0142$export$2e2bcd8739ae039).fromDict(dict, ref);
    else if ($3ac6010d818efd71$var$flagIsSet(flags, (0, $ccb031b501604dea$export$59f660e89ffb4f8a).Radio)) return (0, $3aa58c09e70127a0$export$2e2bcd8739ae039).fromDict(dict, ref);
    else return (0, $c3b1375c30b7a81d$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $3ac6010d818efd71$var$createPDFAcroChoice = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $3ac6010d818efd71$var$getInheritableAttribute(dict, (0, $2npvA.default).of('Ff'));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $dKRgb.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($3ac6010d818efd71$var$flagIsSet(flags, (0, $ccb031b501604dea$export$eb88827058402599).Combo)) return (0, $bf8a873fef9e7de8$export$2e2bcd8739ae039).fromDict(dict, ref);
    else return (0, $c262204623e264f5$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $3ac6010d818efd71$var$flagIsSet = function(flags, flag) {
    return (flags & flag) !== 0;
};
var $3ac6010d818efd71$var$getInheritableAttribute = function(startNode, name) {
    var attribute;
    $3ac6010d818efd71$var$ascend(startNode, function(node) {
        if (!attribute) attribute = node.get(name);
    });
    return attribute;
};
var $3ac6010d818efd71$var$ascend = function(startNode, visitor) {
    visitor(startNode);
    var Parent = startNode.lookupMaybe((0, $2npvA.default).of('Parent'), (0, $74b515754dab46b0$export$2e2bcd8739ae039));
    if (Parent) $3ac6010d818efd71$var$ascend(Parent, visitor);
};


var $810a93aeb80d1ced$var$PDFAcroForm = /** @class */ function() {
    function PDFAcroForm(dict) {
        this.dict = dict;
    }
    PDFAcroForm.prototype.Fields = function() {
        var fields = this.dict.lookup((0, $2npvA.default).of('Fields'));
        if (fields instanceof (0, $6IKEk.default)) return fields;
        return undefined;
    };
    PDFAcroForm.prototype.getFields = function() {
        var Fields = this.normalizedEntries().Fields;
        var fields = new Array(Fields.size());
        for(var idx = 0, len = Fields.size(); idx < len; idx++){
            var ref = Fields.get(idx);
            var dict = Fields.lookup(idx, (0, $74b515754dab46b0$export$2e2bcd8739ae039));
            fields[idx] = [
                (0, $3ac6010d818efd71$export$fe770f59a8fbe6d)(dict, ref),
                ref
            ];
        }
        return fields;
    };
    PDFAcroForm.prototype.getAllFields = function() {
        var allFields = [];
        var pushFields = function(fields) {
            if (!fields) return;
            for(var idx = 0, len = fields.length; idx < len; idx++){
                var field = fields[idx];
                allFields.push(field);
                var fieldModel = field[0];
                if (fieldModel instanceof (0, $1416fe06ca3d86c2$export$2e2bcd8739ae039)) pushFields((0, $3ac6010d818efd71$export$34b4fb8893136c4c)(fieldModel.Kids()));
            }
        };
        pushFields(this.getFields());
        return allFields;
    };
    PDFAcroForm.prototype.addField = function(field) {
        var Fields = this.normalizedEntries().Fields;
        Fields === null || Fields === void 0 || Fields.push(field);
    };
    PDFAcroForm.prototype.removeField = function(field) {
        var parent = field.getParent();
        var fields = parent === undefined ? this.normalizedEntries().Fields : parent.Kids();
        var index = fields === null || fields === void 0 ? void 0 : fields.indexOf(field.ref);
        if (fields === undefined || index === undefined) throw new Error("Tried to remove inexistent field " + field.getFullyQualifiedName());
        fields.remove(index);
        if (parent !== undefined && fields.size() === 0) this.removeField(parent);
    };
    PDFAcroForm.prototype.normalizedEntries = function() {
        var Fields = this.Fields();
        if (!Fields) {
            Fields = this.dict.context.obj([]);
            this.dict.set((0, $2npvA.default).of('Fields'), Fields);
        }
        return {
            Fields: Fields
        };
    };
    PDFAcroForm.fromDict = function(dict) {
        return new PDFAcroForm(dict);
    };
    PDFAcroForm.create = function(context) {
        var dict = context.obj({
            Fields: []
        });
        return new PDFAcroForm(dict);
    };
    return PDFAcroForm;
}();
var $810a93aeb80d1ced$export$2e2bcd8739ae039 = $810a93aeb80d1ced$var$PDFAcroForm;














var $4A1Hw = parcelRequire("4A1Hw");
var $1ce603ba86b90efd$var$PDFCatalog = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFCatalog, _super);
    function PDFCatalog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFCatalog.prototype.Pages = function() {
        return this.lookup((0, $2npvA.default).of('Pages'), (0, $74b515754dab46b0$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.AcroForm = function() {
        return this.lookupMaybe((0, $2npvA.default).of('AcroForm'), (0, $74b515754dab46b0$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.getAcroForm = function() {
        var dict = this.AcroForm();
        if (!dict) return undefined;
        return (0, $810a93aeb80d1ced$export$2e2bcd8739ae039).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateAcroForm = function() {
        var acroForm = this.getAcroForm();
        if (!acroForm) {
            acroForm = (0, $810a93aeb80d1ced$export$2e2bcd8739ae039).create(this.context);
            var acroFormRef = this.context.register(acroForm.dict);
            this.set((0, $2npvA.default).of('AcroForm'), acroFormRef);
        }
        return acroForm;
    };
    PDFCatalog.prototype.ViewerPreferences = function() {
        return this.lookupMaybe((0, $2npvA.default).of('ViewerPreferences'), (0, $74b515754dab46b0$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.getViewerPreferences = function() {
        var dict = this.ViewerPreferences();
        if (!dict) return undefined;
        return (0, $4A1Hw.default).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateViewerPreferences = function() {
        var viewerPrefs = this.getViewerPreferences();
        if (!viewerPrefs) {
            viewerPrefs = (0, $4A1Hw.default).create(this.context);
            var viewerPrefsRef = this.context.register(viewerPrefs.dict);
            this.set((0, $2npvA.default).of('ViewerPreferences'), viewerPrefsRef);
        }
        return viewerPrefs;
    };
    /**
     * Inserts the given ref as a leaf node of this catalog's page tree at the
     * specified index (zero-based). Also increments the `Count` of each node in
     * the page tree hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted.
     */ PDFCatalog.prototype.insertLeafNode = function(leafRef, index) {
        var pagesRef = this.get((0, $2npvA.default).of('Pages'));
        var maybeParentRef = this.Pages().insertLeafNode(leafRef, index);
        return maybeParentRef || pagesRef;
    };
    PDFCatalog.prototype.removeLeafNode = function(index) {
        this.Pages().removeLeafNode(index);
    };
    PDFCatalog.withContextAndPages = function(context, pages) {
        var dict = new Map();
        dict.set((0, $2npvA.default).of('Type'), (0, $2npvA.default).of('Catalog'));
        dict.set((0, $2npvA.default).of('Pages'), pages);
        return new PDFCatalog(dict, context);
    };
    PDFCatalog.fromMapWithContext = function(map, context) {
        return new PDFCatalog(map, context);
    };
    return PDFCatalog;
}((0, $74b515754dab46b0$export$2e2bcd8739ae039));
var $1ce603ba86b90efd$export$2e2bcd8739ae039 = $1ce603ba86b90efd$var$PDFCatalog;






var $47XJ3 = parcelRequire("47XJ3");

var $6IKEk = parcelRequire("6IKEk");


var $2npvA = parcelRequire("2npvA");

var $dKRgb = parcelRequire("dKRgb");


var $6AcCU = parcelRequire("6AcCU");
var $bab5d6f3d67c8575$var$PDFPageTree = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFPageTree, _super);
    function PDFPageTree() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFPageTree.prototype.Parent = function() {
        return this.lookup((0, $2npvA.default).of('Parent'));
    };
    PDFPageTree.prototype.Kids = function() {
        return this.lookup((0, $2npvA.default).of('Kids'), (0, $6IKEk.default));
    };
    PDFPageTree.prototype.Count = function() {
        return this.lookup((0, $2npvA.default).of('Count'), (0, $dKRgb.default));
    };
    PDFPageTree.prototype.pushTreeNode = function(treeRef) {
        var Kids = this.Kids();
        Kids.push(treeRef);
    };
    PDFPageTree.prototype.pushLeafNode = function(leafRef) {
        var Kids = this.Kids();
        this.insertLeafKid(Kids.size(), leafRef);
    };
    /**
     * Inserts the given ref as a leaf node of this page tree at the specified
     * index (zero-based). Also increments the `Count` of each page tree in the
     * hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted,
     * or `undefined` if it was inserted into the root node (the PDFPageTree upon
     * which the method was first called).
     */ PDFPageTree.prototype.insertLeafNode = function(leafRef, targetIndex) {
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex > Count) throw new (0, $6AcCU.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            if (leafsRemainingUntilTarget === 0) {
                // Insert page and return
                this.insertLeafKid(idx, leafRef);
                return undefined;
            }
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) // Dig in
                return kid.insertLeafNode(leafRef, leafsRemainingUntilTarget) || kidRef;
                else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $9575017b00e75ca2$export$2e2bcd8739ae039)) // Move on
            leafsRemainingUntilTarget -= 1;
        }
        if (leafsRemainingUntilTarget === 0) {
            // Insert page at the end and return
            this.insertLeafKid(Kids.size(), leafRef);
            return undefined;
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $6AcCU.CorruptPageTreeError)(targetIndex, 'insertLeafNode');
    };
    /**
     * Removes the leaf node at the specified index (zero-based) from this page
     * tree. Also decrements the `Count` of each page tree in the hierarchy to
     * account for the removed page.
     *
     * If `prune` is true, then intermediate tree nodes will be removed from the
     * tree if they contain 0 children after the leaf node is removed.
     */ PDFPageTree.prototype.removeLeafNode = function(targetIndex, prune) {
        if (prune === void 0) prune = true;
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex >= Count) throw new (0, $6AcCU.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) {
                    // Dig in
                    kid.removeLeafNode(leafsRemainingUntilTarget, prune);
                    if (prune && kid.Kids().size() === 0) Kids.remove(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $9575017b00e75ca2$export$2e2bcd8739ae039)) {
                if (leafsRemainingUntilTarget === 0) {
                    // Remove page and return
                    this.removeKid(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= 1;
            }
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $6AcCU.CorruptPageTreeError)(targetIndex, 'removeLeafNode');
    };
    PDFPageTree.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    /** Performs a Post-Order traversal of this page tree */ PDFPageTree.prototype.traverse = function(visitor) {
        var Kids = this.Kids();
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) kid.traverse(visitor);
            visitor(kid, kidRef);
        }
    };
    PDFPageTree.prototype.insertLeafKid = function(kidIdx, leafRef) {
        var Kids = this.Kids();
        this.ascend(function(node) {
            var newCount = node.Count().asNumber() + 1;
            node.set((0, $2npvA.default).of('Count'), (0, $dKRgb.default).of(newCount));
        });
        Kids.insert(kidIdx, leafRef);
    };
    PDFPageTree.prototype.removeKid = function(kidIdx) {
        var Kids = this.Kids();
        var kid = Kids.lookup(kidIdx);
        if (kid instanceof (0, $9575017b00e75ca2$export$2e2bcd8739ae039)) this.ascend(function(node) {
            var newCount = node.Count().asNumber() - 1;
            node.set((0, $2npvA.default).of('Count'), (0, $dKRgb.default).of(newCount));
        });
        Kids.remove(kidIdx);
    };
    PDFPageTree.withContext = function(context, parent) {
        var dict = new Map();
        dict.set((0, $2npvA.default).of('Type'), (0, $2npvA.default).of('Pages'));
        dict.set((0, $2npvA.default).of('Kids'), context.obj([]));
        dict.set((0, $2npvA.default).of('Count'), context.obj(0));
        if (parent) dict.set((0, $2npvA.default).of('Parent'), parent);
        return new PDFPageTree(dict, context);
    };
    PDFPageTree.fromMapWithContext = function(map, context) {
        return new PDFPageTree(map, context);
    };
    return PDFPageTree;
}((0, $74b515754dab46b0$export$2e2bcd8739ae039));
var $bab5d6f3d67c8575$export$2e2bcd8739ae039 = $bab5d6f3d67c8575$var$PDFPageTree;







var $47XJ3 = parcelRequire("47XJ3");

var $6AcCU = parcelRequire("6AcCU");

var $6IKEk = parcelRequire("6IKEk");

var $HB3Cf = parcelRequire("HB3Cf");



var $2npvA = parcelRequire("2npvA");


var $dKRgb = parcelRequire("dKRgb");




var $6AcCU = parcelRequire("6AcCU");

var $90Qf4 = parcelRequire("90Qf4");

var $90Qf4 = parcelRequire("90Qf4");
var $7473c2a738fdb60b$export$9492c31549e88980 = new Uint8Array(256);
$7473c2a738fdb60b$export$9492c31549e88980[(0, $90Qf4.default).Zero] = 1;
$7473c2a738fdb60b$export$9492c31549e88980[(0, $90Qf4.default).One] = 1;
$7473c2a738fdb60b$export$9492c31549e88980[(0, $90Qf4.default).Two] = 1;
$7473c2a738fdb60b$export$9492c31549e88980[(0, $90Qf4.default).Three] = 1;
$7473c2a738fdb60b$export$9492c31549e88980[(0, $90Qf4.default).Four] = 1;
$7473c2a738fdb60b$export$9492c31549e88980[(0, $90Qf4.default).Five] = 1;
$7473c2a738fdb60b$export$9492c31549e88980[(0, $90Qf4.default).Six] = 1;
$7473c2a738fdb60b$export$9492c31549e88980[(0, $90Qf4.default).Seven] = 1;
$7473c2a738fdb60b$export$9492c31549e88980[(0, $90Qf4.default).Eight] = 1;
$7473c2a738fdb60b$export$9492c31549e88980[(0, $90Qf4.default).Nine] = 1;
var $7473c2a738fdb60b$export$d438b84505bee68c = new Uint8Array(256);
$7473c2a738fdb60b$export$d438b84505bee68c[(0, $90Qf4.default).Period] = 1;
$7473c2a738fdb60b$export$d438b84505bee68c[(0, $90Qf4.default).Plus] = 1;
$7473c2a738fdb60b$export$d438b84505bee68c[(0, $90Qf4.default).Minus] = 1;
var $7473c2a738fdb60b$export$4d926b029fa61cfe = new Uint8Array(256);
for(var $7473c2a738fdb60b$var$idx = 0, $7473c2a738fdb60b$var$len = 256; $7473c2a738fdb60b$var$idx < $7473c2a738fdb60b$var$len; $7473c2a738fdb60b$var$idx++)$7473c2a738fdb60b$export$4d926b029fa61cfe[$7473c2a738fdb60b$var$idx] = $7473c2a738fdb60b$export$9492c31549e88980[$7473c2a738fdb60b$var$idx] || $7473c2a738fdb60b$export$d438b84505bee68c[$7473c2a738fdb60b$var$idx] ? 1 : 0;



var $fKAUz = parcelRequire("fKAUz");
parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
var $fa769eb275d19001$var$Newline = (0, $90Qf4.default).Newline, $fa769eb275d19001$var$CarriageReturn = (0, $90Qf4.default).CarriageReturn;
// TODO: Throw error if eof is reached before finishing object parse...
var $fa769eb275d19001$var$BaseParser = /** @class */ function() {
    function BaseParser(bytes, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        this.bytes = bytes;
        this.capNumbers = capNumbers;
    }
    BaseParser.prototype.parseRawInt = function() {
        var value = '';
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $7473c2a738fdb60b$export$9492c31549e88980)[byte]) break;
            value += (0, $8ZzAZ.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $6AcCU.NumberParsingError)(this.bytes.position(), value);
        return numberValue;
    };
    // TODO: Maybe handle exponential format?
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    BaseParser.prototype.parseRawNumber = function() {
        var value = '';
        // Parse integer-part, the leading (+ | - | . | 0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $7473c2a738fdb60b$export$4d926b029fa61cfe)[byte]) break;
            value += (0, $8ZzAZ.charFromCode)(this.bytes.next());
            if (byte === (0, $90Qf4.default).Period) break;
        }
        // Parse decimal-part, the trailing (0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $7473c2a738fdb60b$export$9492c31549e88980)[byte]) break;
            value += (0, $8ZzAZ.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $6AcCU.NumberParsingError)(this.bytes.position(), value);
        if (numberValue > Number.MAX_SAFE_INTEGER) {
            if (this.capNumbers) {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", using Number.MAX_SAFE_INTEGER instead.";
                console.warn(msg);
                return Number.MAX_SAFE_INTEGER;
            } else {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", not capping.";
                console.warn(msg);
            }
        }
        return numberValue;
    };
    BaseParser.prototype.skipWhitespace = function() {
        while(!this.bytes.done() && (0, $fKAUz.IsWhitespace)[this.bytes.peek()])this.bytes.next();
    };
    BaseParser.prototype.skipLine = function() {
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $fa769eb275d19001$var$Newline || byte === $fa769eb275d19001$var$CarriageReturn) return;
            this.bytes.next();
        }
    };
    BaseParser.prototype.skipComment = function() {
        if (this.bytes.peek() !== (0, $90Qf4.default).Percent) return false;
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $fa769eb275d19001$var$Newline || byte === $fa769eb275d19001$var$CarriageReturn) return true;
            this.bytes.next();
        }
        return true;
    };
    BaseParser.prototype.skipWhitespaceAndComments = function() {
        this.skipWhitespace();
        while(this.skipComment())this.skipWhitespace();
    };
    BaseParser.prototype.matchKeyword = function(keyword) {
        var initialOffset = this.bytes.offset();
        for(var idx = 0, len = keyword.length; idx < len; idx++)if (this.bytes.done() || this.bytes.next() !== keyword[idx]) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
        return true;
    };
    return BaseParser;
}();
var $fa769eb275d19001$export$2e2bcd8739ae039 = $fa769eb275d19001$var$BaseParser;



var $6AcCU = parcelRequire("6AcCU");


var $90Qf4 = parcelRequire("90Qf4");
// TODO: See how line/col tracking affects performance
var $a7e338bf71a7ed15$var$ByteStream = /** @class */ function() {
    function ByteStream(bytes) {
        this.idx = 0;
        this.line = 0;
        this.column = 0;
        this.bytes = bytes;
        this.length = this.bytes.length;
    }
    ByteStream.prototype.moveTo = function(offset) {
        this.idx = offset;
    };
    ByteStream.prototype.next = function() {
        var byte = this.bytes[this.idx++];
        if (byte === (0, $90Qf4.default).Newline) {
            this.line += 1;
            this.column = 0;
        } else this.column += 1;
        return byte;
    };
    ByteStream.prototype.assertNext = function(expected) {
        if (this.peek() !== expected) throw new (0, $6AcCU.NextByteAssertionError)(this.position(), expected, this.peek());
        return this.next();
    };
    ByteStream.prototype.peek = function() {
        return this.bytes[this.idx];
    };
    ByteStream.prototype.peekAhead = function(steps) {
        return this.bytes[this.idx + steps];
    };
    ByteStream.prototype.peekAt = function(offset) {
        return this.bytes[offset];
    };
    ByteStream.prototype.done = function() {
        return this.idx >= this.length;
    };
    ByteStream.prototype.offset = function() {
        return this.idx;
    };
    ByteStream.prototype.slice = function(start, end) {
        return this.bytes.slice(start, end);
    };
    ByteStream.prototype.position = function() {
        return {
            line: this.line,
            column: this.column,
            offset: this.idx
        };
    };
    ByteStream.of = function(bytes) {
        return new ByteStream(bytes);
    };
    ByteStream.fromPDFRawStream = function(rawStream) {
        return ByteStream.of((0, $30fd433752b1e562$export$b8317e68ca978594)(rawStream).decode());
    };
    return ByteStream;
}();
var $a7e338bf71a7ed15$export$2e2bcd8739ae039 = $a7e338bf71a7ed15$var$ByteStream;






var $90Qf4 = parcelRequire("90Qf4");

var $bomHe = parcelRequire("bomHe");

var $47XJ3 = parcelRequire("47XJ3");

var $90Qf4 = parcelRequire("90Qf4");
var $dd0dd58ce45b7afc$var$Space = (0, $90Qf4.default).Space, $dd0dd58ce45b7afc$var$CarriageReturn = (0, $90Qf4.default).CarriageReturn, $dd0dd58ce45b7afc$var$Newline = (0, $90Qf4.default).Newline;
var $dd0dd58ce45b7afc$var$stream = [
    (0, $90Qf4.default).s,
    (0, $90Qf4.default).t,
    (0, $90Qf4.default).r,
    (0, $90Qf4.default).e,
    (0, $90Qf4.default).a,
    (0, $90Qf4.default).m
];
var $dd0dd58ce45b7afc$var$endstream = [
    (0, $90Qf4.default).e,
    (0, $90Qf4.default).n,
    (0, $90Qf4.default).d,
    (0, $90Qf4.default).s,
    (0, $90Qf4.default).t,
    (0, $90Qf4.default).r,
    (0, $90Qf4.default).e,
    (0, $90Qf4.default).a,
    (0, $90Qf4.default).m
];
var $dd0dd58ce45b7afc$export$93ad50ccfacdd77 = {
    header: [
        (0, $90Qf4.default).Percent,
        (0, $90Qf4.default).P,
        (0, $90Qf4.default).D,
        (0, $90Qf4.default).F,
        (0, $90Qf4.default).Dash
    ],
    eof: [
        (0, $90Qf4.default).Percent,
        (0, $90Qf4.default).Percent,
        (0, $90Qf4.default).E,
        (0, $90Qf4.default).O,
        (0, $90Qf4.default).F
    ],
    obj: [
        (0, $90Qf4.default).o,
        (0, $90Qf4.default).b,
        (0, $90Qf4.default).j
    ],
    endobj: [
        (0, $90Qf4.default).e,
        (0, $90Qf4.default).n,
        (0, $90Qf4.default).d,
        (0, $90Qf4.default).o,
        (0, $90Qf4.default).b,
        (0, $90Qf4.default).j
    ],
    xref: [
        (0, $90Qf4.default).x,
        (0, $90Qf4.default).r,
        (0, $90Qf4.default).e,
        (0, $90Qf4.default).f
    ],
    trailer: [
        (0, $90Qf4.default).t,
        (0, $90Qf4.default).r,
        (0, $90Qf4.default).a,
        (0, $90Qf4.default).i,
        (0, $90Qf4.default).l,
        (0, $90Qf4.default).e,
        (0, $90Qf4.default).r
    ],
    startxref: [
        (0, $90Qf4.default).s,
        (0, $90Qf4.default).t,
        (0, $90Qf4.default).a,
        (0, $90Qf4.default).r,
        (0, $90Qf4.default).t,
        (0, $90Qf4.default).x,
        (0, $90Qf4.default).r,
        (0, $90Qf4.default).e,
        (0, $90Qf4.default).f
    ],
    true: [
        (0, $90Qf4.default).t,
        (0, $90Qf4.default).r,
        (0, $90Qf4.default).u,
        (0, $90Qf4.default).e
    ],
    false: [
        (0, $90Qf4.default).f,
        (0, $90Qf4.default).a,
        (0, $90Qf4.default).l,
        (0, $90Qf4.default).s,
        (0, $90Qf4.default).e
    ],
    null: [
        (0, $90Qf4.default).n,
        (0, $90Qf4.default).u,
        (0, $90Qf4.default).l,
        (0, $90Qf4.default).l
    ],
    stream: $dd0dd58ce45b7afc$var$stream,
    streamEOF1: (0, $47XJ3.__spreadArrays)($dd0dd58ce45b7afc$var$stream, [
        $dd0dd58ce45b7afc$var$Space,
        $dd0dd58ce45b7afc$var$CarriageReturn,
        $dd0dd58ce45b7afc$var$Newline
    ]),
    streamEOF2: (0, $47XJ3.__spreadArrays)($dd0dd58ce45b7afc$var$stream, [
        $dd0dd58ce45b7afc$var$CarriageReturn,
        $dd0dd58ce45b7afc$var$Newline
    ]),
    streamEOF3: (0, $47XJ3.__spreadArrays)($dd0dd58ce45b7afc$var$stream, [
        $dd0dd58ce45b7afc$var$CarriageReturn
    ]),
    streamEOF4: (0, $47XJ3.__spreadArrays)($dd0dd58ce45b7afc$var$stream, [
        $dd0dd58ce45b7afc$var$Newline
    ]),
    endstream: $dd0dd58ce45b7afc$var$endstream,
    EOF1endstream: (0, $47XJ3.__spreadArrays)([
        $dd0dd58ce45b7afc$var$CarriageReturn,
        $dd0dd58ce45b7afc$var$Newline
    ], $dd0dd58ce45b7afc$var$endstream),
    EOF2endstream: (0, $47XJ3.__spreadArrays)([
        $dd0dd58ce45b7afc$var$CarriageReturn
    ], $dd0dd58ce45b7afc$var$endstream),
    EOF3endstream: (0, $47XJ3.__spreadArrays)([
        $dd0dd58ce45b7afc$var$Newline
    ], $dd0dd58ce45b7afc$var$endstream)
};




var $fKAUz = parcelRequire("fKAUz");
parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
// TODO: Throw error if eof is reached before finishing object parse...
var $76fd1e3e826cc066$var$PDFObjectParser = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFObjectParser, _super);
    function PDFObjectParser(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, byteStream, capNumbers) || this;
        _this.context = context;
        return _this;
    }
    // TODO: Is it possible to reduce duplicate parsing for ref lookaheads?
    PDFObjectParser.prototype.parseObject = function() {
        this.skipWhitespaceAndComments();
        if (this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).true)) return (0, $HB3Cf.default).True;
        if (this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).false)) return (0, $HB3Cf.default).False;
        if (this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).null)) return 0, $9aaf0b887d65bd59$export$2e2bcd8739ae039;
        var byte = this.bytes.peek();
        if (byte === (0, $90Qf4.default).LessThan && this.bytes.peekAhead(1) === (0, $90Qf4.default).LessThan) return this.parseDictOrStream();
        if (byte === (0, $90Qf4.default).LessThan) return this.parseHexString();
        if (byte === (0, $90Qf4.default).LeftParen) return this.parseString();
        if (byte === (0, $90Qf4.default).ForwardSlash) return this.parseName();
        if (byte === (0, $90Qf4.default).LeftSquareBracket) return this.parseArray();
        if ((0, $7473c2a738fdb60b$export$4d926b029fa61cfe)[byte]) return this.parseNumberOrRef();
        throw new (0, $6AcCU.PDFObjectParsingError)(this.bytes.position(), byte);
    };
    PDFObjectParser.prototype.parseNumberOrRef = function() {
        var firstNum = this.parseRawNumber();
        this.skipWhitespaceAndComments();
        var lookaheadStart = this.bytes.offset();
        if ((0, $7473c2a738fdb60b$export$9492c31549e88980)[this.bytes.peek()]) {
            var secondNum = this.parseRawNumber();
            this.skipWhitespaceAndComments();
            if (this.bytes.peek() === (0, $90Qf4.default).R) {
                this.bytes.assertNext((0, $90Qf4.default).R);
                return (0, $dac7b6b491336f5d$export$2e2bcd8739ae039).of(firstNum, secondNum);
            }
        }
        this.bytes.moveTo(lookaheadStart);
        return (0, $dKRgb.default).of(firstNum);
    };
    // TODO: Maybe update PDFHexString.of() logic to remove whitespace and validate input?
    PDFObjectParser.prototype.parseHexString = function() {
        var value = '';
        this.bytes.assertNext((0, $90Qf4.default).LessThan);
        while(!this.bytes.done() && this.bytes.peek() !== (0, $90Qf4.default).GreaterThan)value += (0, $8ZzAZ.charFromCode)(this.bytes.next());
        this.bytes.assertNext((0, $90Qf4.default).GreaterThan);
        return (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).of(value);
    };
    PDFObjectParser.prototype.parseString = function() {
        var nestingLvl = 0;
        var isEscaped = false;
        var value = '';
        while(!this.bytes.done()){
            var byte = this.bytes.next();
            value += (0, $8ZzAZ.charFromCode)(byte);
            // Check for unescaped parenthesis
            if (!isEscaped) {
                if (byte === (0, $90Qf4.default).LeftParen) nestingLvl += 1;
                if (byte === (0, $90Qf4.default).RightParen) nestingLvl -= 1;
            }
            // Track whether current character is being escaped or not
            if (byte === (0, $90Qf4.default).BackSlash) isEscaped = !isEscaped;
            else if (isEscaped) isEscaped = false;
            // Once (if) the unescaped parenthesis balance out, return their contents
            if (nestingLvl === 0) // Remove the outer parens so they aren't part of the contents
            return (0, $14cdd14f9837102b$export$2e2bcd8739ae039).of(value.substring(1, value.length - 1));
        }
        throw new (0, $6AcCU.UnbalancedParenthesisError)(this.bytes.position());
    };
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    // TODO: Maybe preallocate small Uint8Array if can use charFromCode?
    PDFObjectParser.prototype.parseName = function() {
        this.bytes.assertNext((0, $90Qf4.default).ForwardSlash);
        var name = '';
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if ((0, $fKAUz.IsWhitespace)[byte] || (0, $bomHe.IsDelimiter)[byte]) break;
            name += (0, $8ZzAZ.charFromCode)(byte);
            this.bytes.next();
        }
        return (0, $2npvA.default).of(name);
    };
    PDFObjectParser.prototype.parseArray = function() {
        this.bytes.assertNext((0, $90Qf4.default).LeftSquareBracket);
        this.skipWhitespaceAndComments();
        var pdfArray = (0, $6IKEk.default).withContext(this.context);
        while(this.bytes.peek() !== (0, $90Qf4.default).RightSquareBracket){
            var element = this.parseObject();
            pdfArray.push(element);
            this.skipWhitespaceAndComments();
        }
        this.bytes.assertNext((0, $90Qf4.default).RightSquareBracket);
        return pdfArray;
    };
    PDFObjectParser.prototype.parseDict = function() {
        this.bytes.assertNext((0, $90Qf4.default).LessThan);
        this.bytes.assertNext((0, $90Qf4.default).LessThan);
        this.skipWhitespaceAndComments();
        var dict = new Map();
        while(!this.bytes.done() && this.bytes.peek() !== (0, $90Qf4.default).GreaterThan && this.bytes.peekAhead(1) !== (0, $90Qf4.default).GreaterThan){
            var key = this.parseName();
            var value = this.parseObject();
            dict.set(key, value);
            this.skipWhitespaceAndComments();
        }
        this.skipWhitespaceAndComments();
        this.bytes.assertNext((0, $90Qf4.default).GreaterThan);
        this.bytes.assertNext((0, $90Qf4.default).GreaterThan);
        var Type = dict.get((0, $2npvA.default).of('Type'));
        if (Type === (0, $2npvA.default).of('Catalog')) return (0, $1ce603ba86b90efd$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else if (Type === (0, $2npvA.default).of('Pages')) return (0, $bab5d6f3d67c8575$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else if (Type === (0, $2npvA.default).of('Page')) return (0, $9575017b00e75ca2$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else return (0, $74b515754dab46b0$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
    };
    PDFObjectParser.prototype.parseDictOrStream = function() {
        var startPos = this.bytes.position();
        var dict = this.parseDict();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).streamEOF1) && !this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).streamEOF2) && !this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).streamEOF3) && !this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).streamEOF4) && !this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).stream)) return dict;
        var start = this.bytes.offset();
        var end;
        var Length = dict.get((0, $2npvA.default).of('Length'));
        if (Length instanceof (0, $dKRgb.default)) {
            end = start + Length.asNumber();
            this.bytes.moveTo(end);
            this.skipWhitespaceAndComments();
            if (!this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).endstream)) {
                this.bytes.moveTo(start);
                end = this.findEndOfStreamFallback(startPos);
            }
        } else end = this.findEndOfStreamFallback(startPos);
        var contents = this.bytes.slice(start, end);
        return (0, $9d0105b76c83b6a6$export$2e2bcd8739ae039).of(dict, contents);
    };
    PDFObjectParser.prototype.findEndOfStreamFallback = function(startPos) {
        // Move to end of stream, while handling nested streams
        var nestingLvl = 1;
        var end = this.bytes.offset();
        while(!this.bytes.done()){
            end = this.bytes.offset();
            if (this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).stream)) nestingLvl += 1;
            else if (this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).EOF1endstream) || this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).EOF2endstream) || this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).EOF3endstream) || this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).endstream)) nestingLvl -= 1;
            else this.bytes.next();
            if (nestingLvl === 0) break;
        }
        if (nestingLvl !== 0) throw new (0, $6AcCU.PDFStreamParsingError)(startPos);
        return end;
    };
    PDFObjectParser.forBytes = function(bytes, context, capNumbers) {
        return new PDFObjectParser((0, $a7e338bf71a7ed15$export$2e2bcd8739ae039).of(bytes), context, capNumbers);
    };
    PDFObjectParser.forByteStream = function(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        return new PDFObjectParser(byteStream, context, capNumbers);
    };
    return PDFObjectParser;
}((0, $fa769eb275d19001$export$2e2bcd8739ae039));
var $76fd1e3e826cc066$export$2e2bcd8739ae039 = $76fd1e3e826cc066$var$PDFObjectParser;



var $47XJ3 = parcelRequire("47XJ3");

var $6AcCU = parcelRequire("6AcCU");

var $2npvA = parcelRequire("2npvA");

var $dKRgb = parcelRequire("dKRgb");



parcelRequire("5w6hV");
var $9J7bS = parcelRequire("9J7bS");
var $8bc1088313863ee6$var$PDFObjectStreamParser = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFObjectStreamParser, _super);
    function PDFObjectStreamParser(rawStream, shouldWaitForTick) {
        var _this = _super.call(this, (0, $a7e338bf71a7ed15$export$2e2bcd8739ae039).fromPDFRawStream(rawStream), rawStream.dict.context) || this;
        var dict = rawStream.dict;
        _this.alreadyParsed = false;
        _this.shouldWaitForTick = shouldWaitForTick || function() {
            return false;
        };
        _this.firstOffset = dict.lookup((0, $2npvA.default).of('First'), (0, $dKRgb.default)).asNumber();
        _this.objectCount = dict.lookup((0, $2npvA.default).of('N'), (0, $dKRgb.default)).asNumber();
        return _this;
    }
    PDFObjectStreamParser.prototype.parseIntoContext = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var offsetsAndObjectNumbers, idx, len, _a, objectNumber, offset, object, ref;
            return (0, $47XJ3.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $6AcCU.ReparseError)('PDFObjectStreamParser', 'parseIntoContext');
                        this.alreadyParsed = true;
                        offsetsAndObjectNumbers = this.parseOffsetsAndObjectNumbers();
                        idx = 0, len = offsetsAndObjectNumbers.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a = offsetsAndObjectNumbers[idx], objectNumber = _a.objectNumber, offset = _a.offset;
                        this.bytes.moveTo(this.firstOffset + offset);
                        object = this.parseObject();
                        ref = (0, $dac7b6b491336f5d$export$2e2bcd8739ae039).of(objectNumber, 0);
                        this.context.assign(ref, object);
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $9J7bS.waitForTick)()
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFObjectStreamParser.prototype.parseOffsetsAndObjectNumbers = function() {
        var offsetsAndObjectNumbers = [];
        for(var idx = 0, len = this.objectCount; idx < len; idx++){
            this.skipWhitespaceAndComments();
            var objectNumber = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var offset = this.parseRawInt();
            offsetsAndObjectNumbers.push({
                objectNumber: objectNumber,
                offset: offset
            });
        }
        return offsetsAndObjectNumbers;
    };
    PDFObjectStreamParser.forStream = function(rawStream, shouldWaitForTick) {
        return new PDFObjectStreamParser(rawStream, shouldWaitForTick);
    };
    return PDFObjectStreamParser;
}((0, $76fd1e3e826cc066$export$2e2bcd8739ae039));
var $8bc1088313863ee6$export$2e2bcd8739ae039 = $8bc1088313863ee6$var$PDFObjectStreamParser;



var $47XJ3 = parcelRequire("47XJ3");




var $6AcCU = parcelRequire("6AcCU");



var $2npvA = parcelRequire("2npvA");






var $6AcCU = parcelRequire("6AcCU");

var $6IKEk = parcelRequire("6IKEk");

var $2npvA = parcelRequire("2npvA");

var $dKRgb = parcelRequire("dKRgb");


var $1f5d51a68f43f227$var$PDFXRefStreamParser = /** @class */ function() {
    function PDFXRefStreamParser(rawStream) {
        this.alreadyParsed = false;
        this.dict = rawStream.dict;
        this.bytes = (0, $a7e338bf71a7ed15$export$2e2bcd8739ae039).fromPDFRawStream(rawStream);
        this.context = this.dict.context;
        var Size = this.dict.lookup((0, $2npvA.default).of('Size'), (0, $dKRgb.default));
        var Index = this.dict.lookup((0, $2npvA.default).of('Index'));
        if (Index instanceof (0, $6IKEk.default)) {
            this.subsections = [];
            for(var idx = 0, len = Index.size(); idx < len; idx += 2){
                var firstObjectNumber = Index.lookup(idx + 0, (0, $dKRgb.default)).asNumber();
                var length_1 = Index.lookup(idx + 1, (0, $dKRgb.default)).asNumber();
                this.subsections.push({
                    firstObjectNumber: firstObjectNumber,
                    length: length_1
                });
            }
        } else this.subsections = [
            {
                firstObjectNumber: 0,
                length: Size.asNumber()
            }
        ];
        var W = this.dict.lookup((0, $2npvA.default).of('W'), (0, $6IKEk.default));
        this.byteWidths = [
            -1,
            -1,
            -1
        ];
        for(var idx = 0, len = W.size(); idx < len; idx++)this.byteWidths[idx] = W.lookup(idx, (0, $dKRgb.default)).asNumber();
    }
    PDFXRefStreamParser.prototype.parseIntoContext = function() {
        if (this.alreadyParsed) throw new (0, $6AcCU.ReparseError)('PDFXRefStreamParser', 'parseIntoContext');
        this.alreadyParsed = true;
        this.context.trailerInfo = {
            Root: this.dict.get((0, $2npvA.default).of('Root')),
            Encrypt: this.dict.get((0, $2npvA.default).of('Encrypt')),
            Info: this.dict.get((0, $2npvA.default).of('Info')),
            ID: this.dict.get((0, $2npvA.default).of('ID'))
        };
        var entries = this.parseEntries();
        // for (let idx = 0, len = entries.length; idx < len; idx++) {
        // const entry = entries[idx];
        // if (entry.deleted) this.context.delete(entry.ref);
        // }
        return entries;
    };
    PDFXRefStreamParser.prototype.parseEntries = function() {
        var entries = [];
        var _a = this.byteWidths, typeFieldWidth = _a[0], offsetFieldWidth = _a[1], genFieldWidth = _a[2];
        for(var subsectionIdx = 0, subsectionLen = this.subsections.length; subsectionIdx < subsectionLen; subsectionIdx++){
            var _b = this.subsections[subsectionIdx], firstObjectNumber = _b.firstObjectNumber, length_2 = _b.length;
            for(var objIdx = 0; objIdx < length_2; objIdx++){
                var type = 0;
                for(var idx = 0, len = typeFieldWidth; idx < len; idx++)type = type << 8 | this.bytes.next();
                var offset = 0;
                for(var idx = 0, len = offsetFieldWidth; idx < len; idx++)offset = offset << 8 | this.bytes.next();
                var generationNumber = 0;
                for(var idx = 0, len = genFieldWidth; idx < len; idx++)generationNumber = generationNumber << 8 | this.bytes.next();
                // When the `type` field is absent, it defaults to 1
                if (typeFieldWidth === 0) type = 1;
                var objectNumber = firstObjectNumber + objIdx;
                var entry = {
                    ref: (0, $dac7b6b491336f5d$export$2e2bcd8739ae039).of(objectNumber, generationNumber),
                    offset: offset,
                    deleted: type === 0,
                    inObjectStream: type === 2
                };
                entries.push(entry);
            }
        }
        return entries;
    };
    PDFXRefStreamParser.forStream = function(rawStream) {
        return new PDFXRefStreamParser(rawStream);
    };
    return PDFXRefStreamParser;
}();
var $1f5d51a68f43f227$export$2e2bcd8739ae039 = $1f5d51a68f43f227$var$PDFXRefStreamParser;




var $90Qf4 = parcelRequire("90Qf4");


parcelRequire("5w6hV");
var $9J7bS = parcelRequire("9J7bS");
var $9b9a87c9eb1ad6d0$var$PDFParser = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFParser, _super);
    function PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        if (objectsPerTick === void 0) objectsPerTick = Infinity;
        if (throwOnInvalidObject === void 0) throwOnInvalidObject = false;
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, (0, $a7e338bf71a7ed15$export$2e2bcd8739ae039).of(pdfBytes), (0, $68246e2808d5ea2f$export$2e2bcd8739ae039).create(), capNumbers) || this;
        _this.alreadyParsed = false;
        _this.parsedObjects = 0;
        _this.shouldWaitForTick = function() {
            _this.parsedObjects += 1;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        _this.objectsPerTick = objectsPerTick;
        _this.throwOnInvalidObject = throwOnInvalidObject;
        return _this;
    }
    PDFParser.prototype.parseDocument = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var prevOffset, offset;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $6AcCU.ReparseError)('PDFParser', 'parseDocument');
                        this.alreadyParsed = true;
                        this.context.header = this.parseHeader();
                        _a.label = 1;
                    case 1:
                        if (!!this.bytes.done()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.parseDocumentSection()
                        ];
                    case 2:
                        _a.sent();
                        offset = this.bytes.offset();
                        if (offset === prevOffset) throw new (0, $6AcCU.StalledParserError)(this.bytes.position());
                        prevOffset = offset;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        this.maybeRecoverRoot();
                        if (this.context.lookup((0, $dac7b6b491336f5d$export$2e2bcd8739ae039).of(0))) {
                            console.warn('Removing parsed object: 0 0 R');
                            this.context.delete((0, $dac7b6b491336f5d$export$2e2bcd8739ae039).of(0));
                        }
                        return [
                            2 /*return*/ ,
                            this.context
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeRecoverRoot = function() {
        var isValidCatalog = function(obj) {
            return obj instanceof (0, $74b515754dab46b0$export$2e2bcd8739ae039) && obj.lookup((0, $2npvA.default).of('Type')) === (0, $2npvA.default).of('Catalog');
        };
        var catalog = this.context.lookup(this.context.trailerInfo.Root);
        if (!isValidCatalog(catalog)) {
            var indirectObjects = this.context.enumerateIndirectObjects();
            for(var idx = 0, len = indirectObjects.length; idx < len; idx++){
                var _a = indirectObjects[idx], ref = _a[0], object = _a[1];
                if (isValidCatalog(object)) this.context.trailerInfo.Root = ref;
            }
        }
    };
    PDFParser.prototype.parseHeader = function() {
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).header)) {
                var major = this.parseRawInt();
                this.bytes.assertNext((0, $90Qf4.default).Period);
                var minor = this.parseRawInt();
                var header = (0, $ba9da13d8e8ae04e$export$2e2bcd8739ae039).forVersion(major, minor);
                this.skipBinaryHeaderComment();
                return header;
            }
            this.bytes.next();
        }
        throw new (0, $6AcCU.MissingPDFHeaderError)(this.bytes.position());
    };
    PDFParser.prototype.parseIndirectObjectHeader = function() {
        this.skipWhitespaceAndComments();
        var objectNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        var generationNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).obj)) throw new (0, $6AcCU.MissingKeywordError)(this.bytes.position(), (0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).obj);
        return (0, $dac7b6b491336f5d$export$2e2bcd8739ae039).of(objectNumber, generationNumber);
    };
    PDFParser.prototype.matchIndirectObjectHeader = function() {
        var initialOffset = this.bytes.offset();
        try {
            this.parseIndirectObjectHeader();
            return true;
        } catch (e) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
    };
    PDFParser.prototype.parseIndirectObject = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var ref, object;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ref = this.parseIndirectObjectHeader();
                        this.skipWhitespaceAndComments();
                        object = this.parseObject();
                        this.skipWhitespaceAndComments();
                        // if (!this.matchKeyword(Keywords.endobj)) {
                        // throw new MissingKeywordError(this.bytes.position(), Keywords.endobj);
                        // }
                        // TODO: Log a warning if this fails...
                        this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).endobj);
                        if (!(object instanceof (0, $9d0105b76c83b6a6$export$2e2bcd8739ae039) && object.dict.lookup((0, $2npvA.default).of('Type')) === (0, $2npvA.default).of('ObjStm'))) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $8bc1088313863ee6$export$2e2bcd8739ae039).forStream(object, this.shouldWaitForTick).parseIntoContext()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (object instanceof (0, $9d0105b76c83b6a6$export$2e2bcd8739ae039) && object.dict.lookup((0, $2npvA.default).of('Type')) === (0, $2npvA.default).of('XRef')) (0, $1f5d51a68f43f227$export$2e2bcd8739ae039).forStream(object).parseIntoContext();
                        else this.context.assign(ref, object);
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ ,
                            ref
                        ];
                }
            });
        });
    };
    // TODO: Improve and clean this up
    PDFParser.prototype.tryToParseInvalidIndirectObject = function() {
        var startPos = this.bytes.position();
        var msg = "Trying to parse invalid object: " + JSON.stringify(startPos) + ")";
        if (this.throwOnInvalidObject) throw new Error(msg);
        console.warn(msg);
        var ref = this.parseIndirectObjectHeader();
        console.warn("Invalid object ref: " + ref);
        this.skipWhitespaceAndComments();
        var start = this.bytes.offset();
        var failed = true;
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).endobj)) failed = false;
            if (!failed) break;
            this.bytes.next();
        }
        if (failed) throw new (0, $6AcCU.PDFInvalidObjectParsingError)(startPos);
        var end = this.bytes.offset() - (0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).endobj.length;
        var object = (0, $ed19c0faaed1b241$export$2e2bcd8739ae039).of(this.bytes.slice(start, end));
        this.context.assign(ref, object);
        return ref;
    };
    PDFParser.prototype.parseIndirectObjects = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var initialOffset, e_1;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.skipWhitespaceAndComments();
                        _a.label = 1;
                    case 1:
                        if (!(!this.bytes.done() && (0, $7473c2a738fdb60b$export$9492c31549e88980)[this.bytes.peek()])) return [
                            3 /*break*/ ,
                            8
                        ];
                        initialOffset = this.bytes.offset();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObject()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        e_1 = _a.sent();
                        // TODO: Add tracing/logging mechanism to track when this happens!
                        this.bytes.moveTo(initialOffset);
                        this.tryToParseInvalidIndirectObject();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        this.skipWhitespaceAndComments();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $9J7bS.waitForTick)()
                        ];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeParseCrossRefSection = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).xref)) return;
        this.skipWhitespaceAndComments();
        var objectNumber = -1;
        var xref = (0, $7af7c7e6764f444e$export$2e2bcd8739ae039).createEmpty();
        while(!this.bytes.done() && (0, $7473c2a738fdb60b$export$9492c31549e88980)[this.bytes.peek()]){
            var firstInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var secondInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var byte = this.bytes.peek();
            if (byte === (0, $90Qf4.default).n || byte === (0, $90Qf4.default).f) {
                var ref = (0, $dac7b6b491336f5d$export$2e2bcd8739ae039).of(objectNumber, secondInt);
                if (this.bytes.next() === (0, $90Qf4.default).n) xref.addEntry(ref, firstInt);
                else // this.context.delete(ref);
                xref.addDeletedEntry(ref, firstInt);
                objectNumber += 1;
            } else objectNumber = firstInt;
            this.skipWhitespaceAndComments();
        }
        return xref;
    };
    PDFParser.prototype.maybeParseTrailerDict = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).trailer)) return;
        this.skipWhitespaceAndComments();
        var dict = this.parseDict();
        var context = this.context;
        context.trailerInfo = {
            Root: dict.get((0, $2npvA.default).of('Root')) || context.trailerInfo.Root,
            Encrypt: dict.get((0, $2npvA.default).of('Encrypt')) || context.trailerInfo.Encrypt,
            Info: dict.get((0, $2npvA.default).of('Info')) || context.trailerInfo.Info,
            ID: dict.get((0, $2npvA.default).of('ID')) || context.trailerInfo.ID
        };
    };
    PDFParser.prototype.maybeParseTrailer = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).startxref)) return;
        this.skipWhitespaceAndComments();
        var offset = this.parseRawInt();
        this.skipWhitespace();
        this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).eof);
        this.skipWhitespaceAndComments();
        this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).eof);
        this.skipWhitespaceAndComments();
        return (0, $dd71effa95b04295$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(offset);
    };
    PDFParser.prototype.parseDocumentSection = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObjects()
                        ];
                    case 1:
                        _a.sent();
                        this.maybeParseCrossRefSection();
                        this.maybeParseTrailerDict();
                        this.maybeParseTrailer();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * This operation is not necessary for valid PDF files. But some invalid PDFs
     * contain jibberish in between indirect objects. This method is designed to
     * skip past that jibberish, should it exist, until it reaches the next
     * indirect object header, an xref table section, or the file trailer.
     */ PDFParser.prototype.skipJibberish = function() {
        this.skipWhitespaceAndComments();
        while(!this.bytes.done()){
            var initialOffset = this.bytes.offset();
            var byte = this.bytes.peek();
            var isAlphaNumeric = byte >= (0, $90Qf4.default).Space && byte <= (0, $90Qf4.default).Tilde;
            if (isAlphaNumeric) {
                if (this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).xref) || this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).trailer) || this.matchKeyword((0, $dd0dd58ce45b7afc$export$93ad50ccfacdd77).startxref) || this.matchIndirectObjectHeader()) {
                    this.bytes.moveTo(initialOffset);
                    break;
                }
            }
            this.bytes.next();
        }
    };
    /**
     * Skips the binary comment following a PDF header. The specification
     * defines this binary comment (section 7.5.2 File Header) as a sequence of 4
     * or more bytes that are 128 or greater, and which are preceded by a "%".
     *
     * This would imply that to strip out this binary comment, we could check for
     * a sequence of bytes starting with "%", and remove all subsequent bytes that
     * are 128 or greater. This works for many documents that properly comply with
     * the spec. But in the wild, there are PDFs that omit the leading "%", and
     * include bytes that are less than 128 (e.g. 0 or 1). So in order to parse
     * these headers correctly, we just throw out all bytes leading up to the
     * first indirect object header.
     */ PDFParser.prototype.skipBinaryHeaderComment = function() {
        this.skipWhitespaceAndComments();
        try {
            var initialOffset = this.bytes.offset();
            this.parseIndirectObjectHeader();
            this.bytes.moveTo(initialOffset);
        } catch (e) {
            this.bytes.next();
            this.skipWhitespaceAndComments();
        }
    };
    PDFParser.forBytesWithOptions = function(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        return new PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers);
    };
    return PDFParser;
}((0, $76fd1e3e826cc066$export$2e2bcd8739ae039));
var $9b9a87c9eb1ad6d0$export$2e2bcd8739ae039 = $9b9a87c9eb1ad6d0$var$PDFParser;







var $d9bf19078b097164$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $d9bf19078b097164$export$1fa7b68b35026177;
(function(AnnotationFlags) {
    /**
     * If set, do not display the annotation if it does not belong to one of the
     * standard annotation types and no annotation handler is available. If clear,
     * display such an unknown annotation using an appearance stream specified by
     * its appearance dictionary, if any.
     */ AnnotationFlags[AnnotationFlags["Invisible"] = $d9bf19078b097164$var$flag(0)] = "Invisible";
    /**
     * If set, do not display or print the annotation or allow it to interact with
     * the user, regardless of its annotation type or whether an annotation
     * handler is available.
     *
     * In cases where screen space is limited, the ability to hide and show
     * annotations selectively can be used in combination with appearance streams
     * to display auxiliary pop-up information similar in function to online help
     * systems.
     */ AnnotationFlags[AnnotationFlags["Hidden"] = $d9bf19078b097164$var$flag(1)] = "Hidden";
    /**
     * If set, print the annotation when the page is printed. If clear, never
     * print the annotation, regardless of whether it is displayed on the screen.
     *
     * This can be useful for annotations representing interactive pushbuttons,
     * which would serve no meaningful purpose on the printed page.
     */ AnnotationFlags[AnnotationFlags["Print"] = $d9bf19078b097164$var$flag(2)] = "Print";
    /**
     * If set, do not scale the annotation’s appearance to match the magnification
     * of the page. The location of the annotation on the page (defined by the
     * upper-left corner of its annotation rectangle) shall remain fixed,
     * regardless of the page magnification.
     */ AnnotationFlags[AnnotationFlags["NoZoom"] = $d9bf19078b097164$var$flag(3)] = "NoZoom";
    /**
     * If set, do not rotate the annotation’s appearance to match the rotation of
     * the page. The upper-left corner of the annotation rectangle shall remain in
     * a fixed location on the page, regardless of the page rotation.
     */ AnnotationFlags[AnnotationFlags["NoRotate"] = $d9bf19078b097164$var$flag(4)] = "NoRotate";
    /**
     * If set, do not display the annotation on the screen or allow it to interact
     * with the user. The annotation may be printed (depending on the setting of
     * the Print flag) but should be considered hidden for purposes of on-screen
     * display and user interaction.
     */ AnnotationFlags[AnnotationFlags["NoView"] = $d9bf19078b097164$var$flag(5)] = "NoView";
    /**
     * If set, do not allow the annotation to interact with the user. The
     * annotation may be displayed or printed (depending on the settings of the
     * NoView and Print flags) but should not respond to mouse clicks or change
     * its appearance in response to mouse motions.
     *
     * This flag shall be ignored for widget annotations; its function is
     * subsumed by the ReadOnly flag of the associated form field.
     */ AnnotationFlags[AnnotationFlags["ReadOnly"] = $d9bf19078b097164$var$flag(6)] = "ReadOnly";
    /**
     * If set, do not allow the annotation to be deleted or its properties
     * (including position and size) to be modified by the user. However, this
     * flag does not restrict changes to the annotation’s contents, such as the
     * value of a form field.
     */ AnnotationFlags[AnnotationFlags["Locked"] = $d9bf19078b097164$var$flag(7)] = "Locked";
    /**
     * If set, invert the interpretation of the NoView flag for certain events.
     *
     * A typical use is to have an annotation that appears only when a mouse
     * cursor is held over it.
     */ AnnotationFlags[AnnotationFlags["ToggleNoView"] = $d9bf19078b097164$var$flag(8)] = "ToggleNoView";
    /**
     * If set, do not allow the contents of the annotation to be modified by the
     * user. This flag does not restrict deletion of the annotation or changes to
     * other annotation properties, such as position and size.
     */ AnnotationFlags[AnnotationFlags["LockedContents"] = $d9bf19078b097164$var$flag(9)] = "LockedContents";
})($d9bf19078b097164$export$1fa7b68b35026177 || ($d9bf19078b097164$export$1fa7b68b35026177 = {}));







var $2npvA = parcelRequire("2npvA");
var $dKRgb = parcelRequire("dKRgb");
var $c86172f2b9ebac7a$export$69d5e1b305482e08 = function(name) {
    return name instanceof (0, $2npvA.default) ? name : (0, $2npvA.default).of(name);
};
var $c86172f2b9ebac7a$export$fb5b5e76a3a5c568 = function(num) {
    return num instanceof (0, $dKRgb.default) ? num : (0, $dKRgb.default).of(num);
};
var $c86172f2b9ebac7a$export$37576b9ba69b50db = function(num) {
    return num instanceof (0, $dKRgb.default) ? num.asNumber() : num;
};


parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
var $ffMdc = parcelRequire("ffMdc");
var $ea262ab75d90e986$export$c3cc0f63dbb3500f;
(function(RotationTypes) {
    RotationTypes["Degrees"] = "degrees";
    RotationTypes["Radians"] = "radians";
})($ea262ab75d90e986$export$c3cc0f63dbb3500f || ($ea262ab75d90e986$export$c3cc0f63dbb3500f = {}));
var $ea262ab75d90e986$export$8449e153fbd325fc = function(radianAngle) {
    (0, $afaKe.assertIs)(radianAngle, 'radianAngle', [
        'number'
    ]);
    return {
        type: $ea262ab75d90e986$export$c3cc0f63dbb3500f.Radians,
        angle: radianAngle
    };
};
var $ea262ab75d90e986$export$41fc368e1a942b97 = function(degreeAngle) {
    (0, $afaKe.assertIs)(degreeAngle, 'degreeAngle', [
        'number'
    ]);
    return {
        type: $ea262ab75d90e986$export$c3cc0f63dbb3500f.Degrees,
        angle: degreeAngle
    };
};
var $ea262ab75d90e986$var$Radians = $ea262ab75d90e986$export$c3cc0f63dbb3500f.Radians, $ea262ab75d90e986$var$Degrees = $ea262ab75d90e986$export$c3cc0f63dbb3500f.Degrees;
var $ea262ab75d90e986$export$c9fcf1a7df975d78 = function(degree) {
    return degree * Math.PI / 180;
};
var $ea262ab75d90e986$export$c41dd2a8460d3196 = function(radian) {
    return radian * 180 / Math.PI;
};
var $ea262ab75d90e986$export$cba01ba138429a1d = function(rotation) {
    return rotation.type === $ea262ab75d90e986$var$Radians ? rotation.angle : rotation.type === $ea262ab75d90e986$var$Degrees ? $ea262ab75d90e986$export$c9fcf1a7df975d78(rotation.angle) : (0, $ffMdc.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $ea262ab75d90e986$export$56cb859c01fa134d = function(rotation) {
    return rotation.type === $ea262ab75d90e986$var$Radians ? $ea262ab75d90e986$export$c41dd2a8460d3196(rotation.angle) : rotation.type === $ea262ab75d90e986$var$Degrees ? rotation.angle : (0, $ffMdc.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $ea262ab75d90e986$export$ee0ed07fe78ec05 = function(degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var quadrants = degreeAngle / 90 % 4;
    if (quadrants === 0) return 0;
    if (quadrants === 1) return 90;
    if (quadrants === 2) return 180;
    if (quadrants === 3) return 270;
    return 0; // `degreeAngle` is not a multiple of 90
};
var $ea262ab75d90e986$export$312e44550db33c6a = function(dims, degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var rotation = $ea262ab75d90e986$export$ee0ed07fe78ec05(degreeAngle);
    return rotation === 90 || rotation === 270 ? {
        width: dims.height,
        height: dims.width
    } : {
        width: dims.width,
        height: dims.height
    };
};
var $ea262ab75d90e986$export$afddc3b8600307a4 = function(rectangle, borderWidth, degreeAngle) {
    if (borderWidth === void 0) borderWidth = 0;
    if (degreeAngle === void 0) degreeAngle = 0;
    var x = rectangle.x, y = rectangle.y, w = rectangle.width, h = rectangle.height;
    var r = $ea262ab75d90e986$export$ee0ed07fe78ec05(degreeAngle);
    var b = borderWidth / 2;
    // prettier-ignore
    if (r === 0) return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
    else if (r === 90) return {
        x: x - h + b,
        y: y - b,
        width: h,
        height: w
    };
    else if (r === 180) return {
        x: x - w + b,
        y: y - h + b,
        width: w,
        height: h
    };
    else if (r === 270) return {
        x: x - b,
        y: y - w + b,
        width: h,
        height: w
    };
    else return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
};



var $067caf076a00b79f$export$e0b576e7a74416cd = function() {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).ClipNonZero);
};
var $067caf076a00b79f$export$dd6fb25f201b5a7a = function() {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).ClipEvenOdd);
};
/* ==================== Graphics State Operators ==================== */ var $067caf076a00b79f$var$cos = Math.cos, $067caf076a00b79f$var$sin = Math.sin, $067caf076a00b79f$var$tan = Math.tan;
var $067caf076a00b79f$export$ed5b99ee38154497 = function(a, b, c, d, e, f) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).ConcatTransformationMatrix, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(a),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(b),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(c),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(d),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(e),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(f)
    ]);
};
var $067caf076a00b79f$export$d73ee8ef04f5226a = function(xPos, yPos) {
    return $067caf076a00b79f$export$ed5b99ee38154497(1, 0, 0, 1, xPos, yPos);
};
var $067caf076a00b79f$export$dcdf75081b88279d = function(xPos, yPos) {
    return $067caf076a00b79f$export$ed5b99ee38154497(xPos, 0, 0, yPos, 0, 0);
};
var $067caf076a00b79f$export$a2ba89726971a90f = function(angle) {
    return $067caf076a00b79f$export$ed5b99ee38154497($067caf076a00b79f$var$cos((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(angle)), $067caf076a00b79f$var$sin((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(angle)), -$067caf076a00b79f$var$sin((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(angle)), $067caf076a00b79f$var$cos((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(angle)), 0, 0);
};
var $067caf076a00b79f$export$91df22fbff99d059 = function(angle) {
    return $067caf076a00b79f$export$a2ba89726971a90f((0, $ea262ab75d90e986$export$c9fcf1a7df975d78)((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(angle)));
};
var $067caf076a00b79f$export$985cb1d69d6a3add = function(xSkewAngle, ySkewAngle) {
    return $067caf076a00b79f$export$ed5b99ee38154497(1, $067caf076a00b79f$var$tan((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(xSkewAngle)), $067caf076a00b79f$var$tan((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(ySkewAngle)), 1, 0, 0);
};
var $067caf076a00b79f$export$8ecb831b3efbb169 = function(xSkewAngle, ySkewAngle) {
    return $067caf076a00b79f$export$985cb1d69d6a3add((0, $ea262ab75d90e986$export$c9fcf1a7df975d78)((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(xSkewAngle)), (0, $ea262ab75d90e986$export$c9fcf1a7df975d78)((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(ySkewAngle)));
};
var $067caf076a00b79f$export$e0e900d241274e06 = function(dashArray, dashPhase) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).SetLineDashPattern, [
        "[" + dashArray.map((0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)).join(' ') + "]",
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(dashPhase)
    ]);
};
var $067caf076a00b79f$export$d10d019aadfd45c7 = function() {
    return $067caf076a00b79f$export$e0e900d241274e06([], 0);
};
var $067caf076a00b79f$export$7a77bc708e50709e;
(function(LineCapStyle) {
    LineCapStyle[LineCapStyle["Butt"] = 0] = "Butt";
    LineCapStyle[LineCapStyle["Round"] = 1] = "Round";
    LineCapStyle[LineCapStyle["Projecting"] = 2] = "Projecting";
})($067caf076a00b79f$export$7a77bc708e50709e || ($067caf076a00b79f$export$7a77bc708e50709e = {}));
var $067caf076a00b79f$export$6c65ed24e870eec = function(style) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).SetLineCapStyle, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(style)
    ]);
};
var $067caf076a00b79f$export$cba5d0f1cde60b86;
(function(LineJoinStyle) {
    LineJoinStyle[LineJoinStyle["Miter"] = 0] = "Miter";
    LineJoinStyle[LineJoinStyle["Round"] = 1] = "Round";
    LineJoinStyle[LineJoinStyle["Bevel"] = 2] = "Bevel";
})($067caf076a00b79f$export$cba5d0f1cde60b86 || ($067caf076a00b79f$export$cba5d0f1cde60b86 = {}));
var $067caf076a00b79f$export$97dfb3b4509cd5bc = function(style) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).SetLineJoinStyle, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(style)
    ]);
};
var $067caf076a00b79f$export$568567f665d3f3bb = function(state) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).SetGraphicsStateParams, [
        (0, $c86172f2b9ebac7a$export$69d5e1b305482e08)(state)
    ]);
};
var $067caf076a00b79f$export$cb182c48e35739ac = function() {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).PushGraphicsState);
};
var $067caf076a00b79f$export$10581a6f45bf75eb = function() {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).PopGraphicsState);
};
var $067caf076a00b79f$export$558e0f90d8262345 = function(width) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).SetLineWidth, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(width)
    ]);
};
var $067caf076a00b79f$export$45bd49bb15a3c5cb = function(x1, y1, x2, y2, x3, y3) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).AppendBezierCurve, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(x1),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(y1),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(x2),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(y2),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(x3),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(y3)
    ]);
};
var $067caf076a00b79f$export$6f4913b22432f892 = function(x1, y1, x2, y2) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).CurveToReplicateInitialPoint, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(x1),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(y1),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(x2),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(y2)
    ]);
};
var $067caf076a00b79f$export$21f87e210c424cd0 = function() {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).ClosePath);
};
var $067caf076a00b79f$export$75f1ccd6dc32e80a = function(xPos, yPos) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).MoveTo, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(xPos),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(yPos)
    ]);
};
var $067caf076a00b79f$export$73abee0cf983cb99 = function(xPos, yPos) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).LineTo, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(xPos),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(yPos)
    ]);
};
var $067caf076a00b79f$export$405b065079b7caf2 = function(xPos, yPos, width, height) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).AppendRectangle, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(xPos),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(yPos),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(width),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(height)
    ]);
};
var $067caf076a00b79f$export$dd4f28cef696bc7d = function(xPos, yPos, size) {
    return $067caf076a00b79f$export$405b065079b7caf2(xPos, yPos, size, size);
};
var $067caf076a00b79f$export$d9b706f8d0a70aef = function() {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).StrokePath);
};
var $067caf076a00b79f$export$9563e054e6f787fb = function() {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).FillNonZero);
};
var $067caf076a00b79f$export$76d37801baac10fb = function() {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).FillNonZeroAndStroke);
};
var $067caf076a00b79f$export$d366e9c0a9bd860f = function() {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).EndPath);
};
var $067caf076a00b79f$export$829ffc2dbe358942 = function() {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).NextLine);
};
var $067caf076a00b79f$export$b84c1833e225e397 = function(x, y) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).MoveText, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(x),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(y)
    ]);
};
var $067caf076a00b79f$export$778bfc3c1a2b7ba4 = function(text) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).ShowText, [
        text
    ]);
};
var $067caf076a00b79f$export$337b8dbf65fbb95e = function() {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).BeginText);
};
var $067caf076a00b79f$export$e3caa83a99d72806 = function() {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).EndText);
};
var $067caf076a00b79f$export$df01d619ff6ce7f7 = function(name, size) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).SetFontAndSize, [
        (0, $c86172f2b9ebac7a$export$69d5e1b305482e08)(name),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(size)
    ]);
};
var $067caf076a00b79f$export$710392ce2617f080 = function(spacing) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).SetCharacterSpacing, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(spacing)
    ]);
};
var $067caf076a00b79f$export$a2801242b2f8967d = function(spacing) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).SetWordSpacing, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(spacing)
    ]);
};
var $067caf076a00b79f$export$20dbb065c447b4da = function(squeeze) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).SetTextHorizontalScaling, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(squeeze)
    ]);
};
var $067caf076a00b79f$export$79399e66b6bb212c = function(lineHeight) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).SetTextLineHeight, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(lineHeight)
    ]);
};
var $067caf076a00b79f$export$ad1653459b07f70c = function(rise) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).SetTextRise, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(rise)
    ]);
};
var $067caf076a00b79f$export$ca45e4ab114d4814;
(function(TextRenderingMode) {
    TextRenderingMode[TextRenderingMode["Fill"] = 0] = "Fill";
    TextRenderingMode[TextRenderingMode["Outline"] = 1] = "Outline";
    TextRenderingMode[TextRenderingMode["FillAndOutline"] = 2] = "FillAndOutline";
    TextRenderingMode[TextRenderingMode["Invisible"] = 3] = "Invisible";
    TextRenderingMode[TextRenderingMode["FillAndClip"] = 4] = "FillAndClip";
    TextRenderingMode[TextRenderingMode["OutlineAndClip"] = 5] = "OutlineAndClip";
    TextRenderingMode[TextRenderingMode["FillAndOutlineAndClip"] = 6] = "FillAndOutlineAndClip";
    TextRenderingMode[TextRenderingMode["Clip"] = 7] = "Clip";
})($067caf076a00b79f$export$ca45e4ab114d4814 || ($067caf076a00b79f$export$ca45e4ab114d4814 = {}));
var $067caf076a00b79f$export$99f0dc2c4cb099ab = function(mode) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).SetTextRenderingMode, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(mode)
    ]);
};
var $067caf076a00b79f$export$d3656d656af31043 = function(a, b, c, d, e, f) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).SetTextMatrix, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(a),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(b),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(c),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(d),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(e),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(f)
    ]);
};
var $067caf076a00b79f$export$f567083ac6aa5aa3 = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $067caf076a00b79f$export$d3656d656af31043($067caf076a00b79f$var$cos((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(rotationAngle)), $067caf076a00b79f$var$sin((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(rotationAngle)) + $067caf076a00b79f$var$tan((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(xSkewAngle)), -$067caf076a00b79f$var$sin((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(rotationAngle)) + $067caf076a00b79f$var$tan((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(ySkewAngle)), $067caf076a00b79f$var$cos((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(rotationAngle)), x, y);
};
var $067caf076a00b79f$export$909384d9b9d39aff = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $067caf076a00b79f$export$f567083ac6aa5aa3((0, $ea262ab75d90e986$export$c9fcf1a7df975d78)((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(rotationAngle)), (0, $ea262ab75d90e986$export$c9fcf1a7df975d78)((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(xSkewAngle)), (0, $ea262ab75d90e986$export$c9fcf1a7df975d78)((0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(ySkewAngle)), x, y);
};
var $067caf076a00b79f$export$382c18f8bccd9e2b = function(name) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).DrawObject, [
        (0, $c86172f2b9ebac7a$export$69d5e1b305482e08)(name)
    ]);
};
var $067caf076a00b79f$export$f30201749d00f572 = function(gray) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).NonStrokingColorGray, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(gray)
    ]);
};
var $067caf076a00b79f$export$6502921112196b8f = function(gray) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).StrokingColorGray, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(gray)
    ]);
};
var $067caf076a00b79f$export$f59cae633978eea7 = function(red, green, blue) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).NonStrokingColorRgb, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(red),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(green),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(blue)
    ]);
};
var $067caf076a00b79f$export$e743468c48a4fd5a = function(red, green, blue) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).StrokingColorRgb, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(red),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(green),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(blue)
    ]);
};
var $067caf076a00b79f$export$e836aceb3db98cc0 = function(cyan, magenta, yellow, key) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).NonStrokingColorCmyk, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(cyan),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(magenta),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(yellow),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(key)
    ]);
};
var $067caf076a00b79f$export$4004b818fda831c1 = function(cyan, magenta, yellow, key) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).StrokingColorCmyk, [
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(cyan),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(magenta),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(yellow),
        (0, $c86172f2b9ebac7a$export$fb5b5e76a3a5c568)(key)
    ]);
};
var $067caf076a00b79f$export$a028b403e40f1ab2 = function(tag) {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).BeginMarkedContent, [
        (0, $c86172f2b9ebac7a$export$69d5e1b305482e08)(tag)
    ]);
};
var $067caf076a00b79f$export$935e2334f5a50589 = function() {
    return (0, $d7f4913eaa91561c$export$2e2bcd8739ae039).of((0, $f7fc5d299ad06003$export$2e2bcd8739ae039).EndMarkedContent);
};


parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
var $ffMdc = parcelRequire("ffMdc");
var $a0c4165d43c51676$export$4eb09b1c0a6dec24;
(function(ColorTypes) {
    ColorTypes["Grayscale"] = "Grayscale";
    ColorTypes["RGB"] = "RGB";
    ColorTypes["CMYK"] = "CMYK";
})($a0c4165d43c51676$export$4eb09b1c0a6dec24 || ($a0c4165d43c51676$export$4eb09b1c0a6dec24 = {}));
var $a0c4165d43c51676$export$6f416a6db2dfcd5c = function(gray) {
    (0, $afaKe.assertRange)(gray, 'gray', 0.0, 1.0);
    return {
        type: $a0c4165d43c51676$export$4eb09b1c0a6dec24.Grayscale,
        gray: gray
    };
};
var $a0c4165d43c51676$export$8972dc0e6ad9238f = function(red, green, blue) {
    (0, $afaKe.assertRange)(red, 'red', 0, 1);
    (0, $afaKe.assertRange)(green, 'green', 0, 1);
    (0, $afaKe.assertRange)(blue, 'blue', 0, 1);
    return {
        type: $a0c4165d43c51676$export$4eb09b1c0a6dec24.RGB,
        red: red,
        green: green,
        blue: blue
    };
};
var $a0c4165d43c51676$export$358b1a66a3c77756 = function(cyan, magenta, yellow, key) {
    (0, $afaKe.assertRange)(cyan, 'cyan', 0, 1);
    (0, $afaKe.assertRange)(magenta, 'magenta', 0, 1);
    (0, $afaKe.assertRange)(yellow, 'yellow', 0, 1);
    (0, $afaKe.assertRange)(key, 'key', 0, 1);
    return {
        type: $a0c4165d43c51676$export$4eb09b1c0a6dec24.CMYK,
        cyan: cyan,
        magenta: magenta,
        yellow: yellow,
        key: key
    };
};
var $a0c4165d43c51676$var$Grayscale = $a0c4165d43c51676$export$4eb09b1c0a6dec24.Grayscale, $a0c4165d43c51676$var$RGB = $a0c4165d43c51676$export$4eb09b1c0a6dec24.RGB, $a0c4165d43c51676$var$CMYK = $a0c4165d43c51676$export$4eb09b1c0a6dec24.CMYK;
var $a0c4165d43c51676$export$6126e5d7ba707741 = function(color) {
    return color.type === $a0c4165d43c51676$var$Grayscale ? (0, $067caf076a00b79f$export$f30201749d00f572)(color.gray) : color.type === $a0c4165d43c51676$var$RGB ? (0, $067caf076a00b79f$export$f59cae633978eea7)(color.red, color.green, color.blue) : color.type === $a0c4165d43c51676$var$CMYK ? (0, $067caf076a00b79f$export$e836aceb3db98cc0)(color.cyan, color.magenta, color.yellow, color.key) : (0, $ffMdc.error)("Invalid color: " + JSON.stringify(color));
};
var $a0c4165d43c51676$export$ae31e5cacc8bb23d = function(color) {
    return color.type === $a0c4165d43c51676$var$Grayscale ? (0, $067caf076a00b79f$export$6502921112196b8f)(color.gray) : color.type === $a0c4165d43c51676$var$RGB ? (0, $067caf076a00b79f$export$e743468c48a4fd5a)(color.red, color.green, color.blue) : color.type === $a0c4165d43c51676$var$CMYK ? (0, $067caf076a00b79f$export$4004b818fda831c1)(color.cyan, color.magenta, color.yellow, color.key) : (0, $ffMdc.error)("Invalid color: " + JSON.stringify(color));
};
var $a0c4165d43c51676$export$8750a268217b0987 = function(comps, scale) {
    if (scale === void 0) scale = 1;
    return (comps === null || comps === void 0 ? void 0 : comps.length) === 1 ? $a0c4165d43c51676$export$6f416a6db2dfcd5c(comps[0] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 3 ? $a0c4165d43c51676$export$8972dc0e6ad9238f(comps[0] * scale, comps[1] * scale, comps[2] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 4 ? $a0c4165d43c51676$export$358b1a66a3c77756(comps[0] * scale, comps[1] * scale, comps[2] * scale, comps[3] * scale) : undefined;
};
var $a0c4165d43c51676$export$ffee2793812e3e56 = function(color) {
    return color.type === $a0c4165d43c51676$var$Grayscale ? [
        color.gray
    ] : color.type === $a0c4165d43c51676$var$RGB ? [
        color.red,
        color.green,
        color.blue
    ] : color.type === $a0c4165d43c51676$var$CMYK ? [
        color.cyan,
        color.magenta,
        color.yellow,
        color.key
    ] : (0, $ffMdc.error)("Invalid color: " + JSON.stringify(color));
};




// Originated from pdfkit Copyright (c) 2014 Devon Govett
// https://github.com/foliojs/pdfkit/blob/1e62e6ffe24b378eb890df507a47610f4c4a7b24/lib/path.js
// MIT LICENSE
// Updated for pdf-lib & TypeScript by Jeremy Messenger

var $82acc0b64eecc88a$var$cx = 0;
var $82acc0b64eecc88a$var$cy = 0;
var $82acc0b64eecc88a$var$px = 0;
var $82acc0b64eecc88a$var$py = 0;
var $82acc0b64eecc88a$var$sx = 0;
var $82acc0b64eecc88a$var$sy = 0;
var $82acc0b64eecc88a$var$parameters = new Map([
    [
        'A',
        7
    ],
    [
        'a',
        7
    ],
    [
        'C',
        6
    ],
    [
        'c',
        6
    ],
    [
        'H',
        1
    ],
    [
        'h',
        1
    ],
    [
        'L',
        2
    ],
    [
        'l',
        2
    ],
    [
        'M',
        2
    ],
    [
        'm',
        2
    ],
    [
        'Q',
        4
    ],
    [
        'q',
        4
    ],
    [
        'S',
        4
    ],
    [
        's',
        4
    ],
    [
        'T',
        2
    ],
    [
        't',
        2
    ],
    [
        'V',
        1
    ],
    [
        'v',
        1
    ],
    [
        'Z',
        0
    ],
    [
        'z',
        0
    ]
]);
var $82acc0b64eecc88a$var$parse = function(path) {
    var cmd;
    var ret = [];
    var args = [];
    var curArg = '';
    var foundDecimal = false;
    var params = 0;
    for(var _i = 0, path_1 = path; _i < path_1.length; _i++){
        var c = path_1[_i];
        if ($82acc0b64eecc88a$var$parameters.has(c)) {
            params = $82acc0b64eecc88a$var$parameters.get(c);
            if (cmd) {
                // save existing command
                if (curArg.length > 0) args[args.length] = +curArg;
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [];
                curArg = '';
                foundDecimal = false;
            }
            cmd = c;
        } else if ([
            ' ',
            ','
        ].includes(c) || c === '-' && curArg.length > 0 && curArg[curArg.length - 1] !== 'e' || c === '.' && foundDecimal) {
            if (curArg.length === 0) continue;
            if (args.length === params) {
                // handle reused commands
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [
                    +curArg
                ];
                // handle assumed commands
                if (cmd === 'M') cmd = 'L';
                if (cmd === 'm') cmd = 'l';
            } else args[args.length] = +curArg;
            foundDecimal = c === '.';
            // fix for negative numbers or repeated decimals with no delimeter between commands
            curArg = [
                '-',
                '.'
            ].includes(c) ? c : '';
        } else {
            curArg += c;
            if (c === '.') foundDecimal = true;
        }
    }
    // add the last command
    if (curArg.length > 0) {
        if (args.length === params) {
            // handle reused commands
            ret[ret.length] = {
                cmd: cmd,
                args: args
            };
            args = [
                +curArg
            ];
            // handle assumed commands
            if (cmd === 'M') cmd = 'L';
            if (cmd === 'm') cmd = 'l';
        } else args[args.length] = +curArg;
    }
    ret[ret.length] = {
        cmd: cmd,
        args: args
    };
    return ret;
};
var $82acc0b64eecc88a$var$apply = function(commands) {
    // current point, control point, and subpath starting point
    $82acc0b64eecc88a$var$cx = $82acc0b64eecc88a$var$cy = $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$py = $82acc0b64eecc88a$var$sx = $82acc0b64eecc88a$var$sy = 0;
    // run the commands
    var cmds = [];
    for(var i = 0; i < commands.length; i++){
        var c = commands[i];
        if (c.cmd && typeof $82acc0b64eecc88a$var$runners[c.cmd] === 'function') {
            var cmd = $82acc0b64eecc88a$var$runners[c.cmd](c.args);
            if (Array.isArray(cmd)) cmds = cmds.concat(cmd);
            else cmds.push(cmd);
        }
    }
    return cmds;
};
var $82acc0b64eecc88a$var$runners = {
    M: function(a) {
        $82acc0b64eecc88a$var$cx = a[0];
        $82acc0b64eecc88a$var$cy = a[1];
        $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$py = null;
        $82acc0b64eecc88a$var$sx = $82acc0b64eecc88a$var$cx;
        $82acc0b64eecc88a$var$sy = $82acc0b64eecc88a$var$cy;
        return (0, $067caf076a00b79f$export$75f1ccd6dc32e80a)($82acc0b64eecc88a$var$cx, $82acc0b64eecc88a$var$cy);
    },
    m: function(a) {
        $82acc0b64eecc88a$var$cx += a[0];
        $82acc0b64eecc88a$var$cy += a[1];
        $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$py = null;
        $82acc0b64eecc88a$var$sx = $82acc0b64eecc88a$var$cx;
        $82acc0b64eecc88a$var$sy = $82acc0b64eecc88a$var$cy;
        return (0, $067caf076a00b79f$export$75f1ccd6dc32e80a)($82acc0b64eecc88a$var$cx, $82acc0b64eecc88a$var$cy);
    },
    C: function(a) {
        $82acc0b64eecc88a$var$cx = a[4];
        $82acc0b64eecc88a$var$cy = a[5];
        $82acc0b64eecc88a$var$px = a[2];
        $82acc0b64eecc88a$var$py = a[3];
        return (0, $067caf076a00b79f$export$45bd49bb15a3c5cb)(a[0], a[1], a[2], a[3], a[4], a[5]);
    },
    c: function(a) {
        var cmd = (0, $067caf076a00b79f$export$45bd49bb15a3c5cb)(a[0] + $82acc0b64eecc88a$var$cx, a[1] + $82acc0b64eecc88a$var$cy, a[2] + $82acc0b64eecc88a$var$cx, a[3] + $82acc0b64eecc88a$var$cy, a[4] + $82acc0b64eecc88a$var$cx, a[5] + $82acc0b64eecc88a$var$cy);
        $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$cx + a[2];
        $82acc0b64eecc88a$var$py = $82acc0b64eecc88a$var$cy + a[3];
        $82acc0b64eecc88a$var$cx += a[4];
        $82acc0b64eecc88a$var$cy += a[5];
        return cmd;
    },
    S: function(a) {
        if ($82acc0b64eecc88a$var$px === null || $82acc0b64eecc88a$var$py === null) {
            $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$cx;
            $82acc0b64eecc88a$var$py = $82acc0b64eecc88a$var$cy;
        }
        var cmd = (0, $067caf076a00b79f$export$45bd49bb15a3c5cb)($82acc0b64eecc88a$var$cx - ($82acc0b64eecc88a$var$px - $82acc0b64eecc88a$var$cx), $82acc0b64eecc88a$var$cy - ($82acc0b64eecc88a$var$py - $82acc0b64eecc88a$var$cy), a[0], a[1], a[2], a[3]);
        $82acc0b64eecc88a$var$px = a[0];
        $82acc0b64eecc88a$var$py = a[1];
        $82acc0b64eecc88a$var$cx = a[2];
        $82acc0b64eecc88a$var$cy = a[3];
        return cmd;
    },
    s: function(a) {
        if ($82acc0b64eecc88a$var$px === null || $82acc0b64eecc88a$var$py === null) {
            $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$cx;
            $82acc0b64eecc88a$var$py = $82acc0b64eecc88a$var$cy;
        }
        var cmd = (0, $067caf076a00b79f$export$45bd49bb15a3c5cb)($82acc0b64eecc88a$var$cx - ($82acc0b64eecc88a$var$px - $82acc0b64eecc88a$var$cx), $82acc0b64eecc88a$var$cy - ($82acc0b64eecc88a$var$py - $82acc0b64eecc88a$var$cy), $82acc0b64eecc88a$var$cx + a[0], $82acc0b64eecc88a$var$cy + a[1], $82acc0b64eecc88a$var$cx + a[2], $82acc0b64eecc88a$var$cy + a[3]);
        $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$cx + a[0];
        $82acc0b64eecc88a$var$py = $82acc0b64eecc88a$var$cy + a[1];
        $82acc0b64eecc88a$var$cx += a[2];
        $82acc0b64eecc88a$var$cy += a[3];
        return cmd;
    },
    Q: function(a) {
        $82acc0b64eecc88a$var$px = a[0];
        $82acc0b64eecc88a$var$py = a[1];
        $82acc0b64eecc88a$var$cx = a[2];
        $82acc0b64eecc88a$var$cy = a[3];
        return (0, $067caf076a00b79f$export$6f4913b22432f892)(a[0], a[1], $82acc0b64eecc88a$var$cx, $82acc0b64eecc88a$var$cy);
    },
    q: function(a) {
        var cmd = (0, $067caf076a00b79f$export$6f4913b22432f892)(a[0] + $82acc0b64eecc88a$var$cx, a[1] + $82acc0b64eecc88a$var$cy, a[2] + $82acc0b64eecc88a$var$cx, a[3] + $82acc0b64eecc88a$var$cy);
        $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$cx + a[0];
        $82acc0b64eecc88a$var$py = $82acc0b64eecc88a$var$cy + a[1];
        $82acc0b64eecc88a$var$cx += a[2];
        $82acc0b64eecc88a$var$cy += a[3];
        return cmd;
    },
    T: function(a) {
        if ($82acc0b64eecc88a$var$px === null || $82acc0b64eecc88a$var$py === null) {
            $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$cx;
            $82acc0b64eecc88a$var$py = $82acc0b64eecc88a$var$cy;
        } else {
            $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$cx - ($82acc0b64eecc88a$var$px - $82acc0b64eecc88a$var$cx);
            $82acc0b64eecc88a$var$py = $82acc0b64eecc88a$var$cy - ($82acc0b64eecc88a$var$py - $82acc0b64eecc88a$var$cy);
        }
        var cmd = (0, $067caf076a00b79f$export$6f4913b22432f892)($82acc0b64eecc88a$var$px, $82acc0b64eecc88a$var$py, a[0], a[1]);
        $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$cx - ($82acc0b64eecc88a$var$px - $82acc0b64eecc88a$var$cx);
        $82acc0b64eecc88a$var$py = $82acc0b64eecc88a$var$cy - ($82acc0b64eecc88a$var$py - $82acc0b64eecc88a$var$cy);
        $82acc0b64eecc88a$var$cx = a[0];
        $82acc0b64eecc88a$var$cy = a[1];
        return cmd;
    },
    t: function(a) {
        if ($82acc0b64eecc88a$var$px === null || $82acc0b64eecc88a$var$py === null) {
            $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$cx;
            $82acc0b64eecc88a$var$py = $82acc0b64eecc88a$var$cy;
        } else {
            $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$cx - ($82acc0b64eecc88a$var$px - $82acc0b64eecc88a$var$cx);
            $82acc0b64eecc88a$var$py = $82acc0b64eecc88a$var$cy - ($82acc0b64eecc88a$var$py - $82acc0b64eecc88a$var$cy);
        }
        var cmd = (0, $067caf076a00b79f$export$6f4913b22432f892)($82acc0b64eecc88a$var$px, $82acc0b64eecc88a$var$py, $82acc0b64eecc88a$var$cx + a[0], $82acc0b64eecc88a$var$cy + a[1]);
        $82acc0b64eecc88a$var$cx += a[0];
        $82acc0b64eecc88a$var$cy += a[1];
        return cmd;
    },
    A: function(a) {
        var cmds = $82acc0b64eecc88a$var$solveArc($82acc0b64eecc88a$var$cx, $82acc0b64eecc88a$var$cy, a);
        $82acc0b64eecc88a$var$cx = a[5];
        $82acc0b64eecc88a$var$cy = a[6];
        return cmds;
    },
    a: function(a) {
        a[5] += $82acc0b64eecc88a$var$cx;
        a[6] += $82acc0b64eecc88a$var$cy;
        var cmds = $82acc0b64eecc88a$var$solveArc($82acc0b64eecc88a$var$cx, $82acc0b64eecc88a$var$cy, a);
        $82acc0b64eecc88a$var$cx = a[5];
        $82acc0b64eecc88a$var$cy = a[6];
        return cmds;
    },
    L: function(a) {
        $82acc0b64eecc88a$var$cx = a[0];
        $82acc0b64eecc88a$var$cy = a[1];
        $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$py = null;
        return (0, $067caf076a00b79f$export$73abee0cf983cb99)($82acc0b64eecc88a$var$cx, $82acc0b64eecc88a$var$cy);
    },
    l: function(a) {
        $82acc0b64eecc88a$var$cx += a[0];
        $82acc0b64eecc88a$var$cy += a[1];
        $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$py = null;
        return (0, $067caf076a00b79f$export$73abee0cf983cb99)($82acc0b64eecc88a$var$cx, $82acc0b64eecc88a$var$cy);
    },
    H: function(a) {
        $82acc0b64eecc88a$var$cx = a[0];
        $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$py = null;
        return (0, $067caf076a00b79f$export$73abee0cf983cb99)($82acc0b64eecc88a$var$cx, $82acc0b64eecc88a$var$cy);
    },
    h: function(a) {
        $82acc0b64eecc88a$var$cx += a[0];
        $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$py = null;
        return (0, $067caf076a00b79f$export$73abee0cf983cb99)($82acc0b64eecc88a$var$cx, $82acc0b64eecc88a$var$cy);
    },
    V: function(a) {
        $82acc0b64eecc88a$var$cy = a[0];
        $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$py = null;
        return (0, $067caf076a00b79f$export$73abee0cf983cb99)($82acc0b64eecc88a$var$cx, $82acc0b64eecc88a$var$cy);
    },
    v: function(a) {
        $82acc0b64eecc88a$var$cy += a[0];
        $82acc0b64eecc88a$var$px = $82acc0b64eecc88a$var$py = null;
        return (0, $067caf076a00b79f$export$73abee0cf983cb99)($82acc0b64eecc88a$var$cx, $82acc0b64eecc88a$var$cy);
    },
    Z: function() {
        var cmd = (0, $067caf076a00b79f$export$21f87e210c424cd0)();
        $82acc0b64eecc88a$var$cx = $82acc0b64eecc88a$var$sx;
        $82acc0b64eecc88a$var$cy = $82acc0b64eecc88a$var$sy;
        return cmd;
    },
    z: function() {
        var cmd = (0, $067caf076a00b79f$export$21f87e210c424cd0)();
        $82acc0b64eecc88a$var$cx = $82acc0b64eecc88a$var$sx;
        $82acc0b64eecc88a$var$cy = $82acc0b64eecc88a$var$sy;
        return cmd;
    }
};
var $82acc0b64eecc88a$var$solveArc = function(x, y, coords) {
    var rx = coords[0], ry = coords[1], rot = coords[2], large = coords[3], sweep = coords[4], ex = coords[5], ey = coords[6];
    var segs = $82acc0b64eecc88a$var$arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
    var cmds = [];
    for(var _i = 0, segs_1 = segs; _i < segs_1.length; _i++){
        var seg = segs_1[_i];
        var bez = $82acc0b64eecc88a$var$segmentToBezier.apply(void 0, seg);
        cmds.push((0, $067caf076a00b79f$export$45bd49bb15a3c5cb).apply(void 0, bez));
    }
    return cmds;
};
// from Inkscape svgtopdf, thanks!
var $82acc0b64eecc88a$var$arcToSegments = function(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    var th = rotateX * (Math.PI / 180);
    var sinTh = Math.sin(th);
    var cosTh = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    $82acc0b64eecc88a$var$px = cosTh * (ox - x) * 0.5 + sinTh * (oy - y) * 0.5;
    $82acc0b64eecc88a$var$py = cosTh * (oy - y) * 0.5 - sinTh * (ox - x) * 0.5;
    var pl = $82acc0b64eecc88a$var$px * $82acc0b64eecc88a$var$px / (rx * rx) + $82acc0b64eecc88a$var$py * $82acc0b64eecc88a$var$py / (ry * ry);
    if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
    }
    var a00 = cosTh / rx;
    var a01 = sinTh / rx;
    var a10 = -sinTh / ry;
    var a11 = cosTh / ry;
    var x0 = a00 * ox + a01 * oy;
    var y0 = a10 * ox + a11 * oy;
    var x1 = a00 * x + a01 * y;
    var y1 = a10 * x + a11 * y;
    var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    var sfactorSq = 1 / d - 0.25;
    if (sfactorSq < 0) sfactorSq = 0;
    var sfactor = Math.sqrt(sfactorSq);
    if (sweep === large) sfactor = -sfactor;
    var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    var th0 = Math.atan2(y0 - yc, x0 - xc);
    var th1 = Math.atan2(y1 - yc, x1 - xc);
    var thArc = th1 - th0;
    if (thArc < 0 && sweep === 1) thArc += 2 * Math.PI;
    else if (thArc > 0 && sweep === 0) thArc -= 2 * Math.PI;
    var segments = Math.ceil(Math.abs(thArc / (Math.PI * 0.5 + 0.001)));
    var result = [];
    for(var i = 0; i < segments; i++){
        var th2 = th0 + i * thArc / segments;
        var th3 = th0 + (i + 1) * thArc / segments;
        result[i] = [
            xc,
            yc,
            th2,
            th3,
            rx,
            ry,
            sinTh,
            cosTh
        ];
    }
    return result;
};
var $82acc0b64eecc88a$var$segmentToBezier = function(cx1, cy1, th0, th1, rx, ry, sinTh, cosTh) {
    var a00 = cosTh * rx;
    var a01 = -sinTh * ry;
    var a10 = sinTh * rx;
    var a11 = cosTh * ry;
    var thHalf = 0.5 * (th1 - th0);
    var t = 8 / 3 * Math.sin(thHalf * 0.5) * Math.sin(thHalf * 0.5) / Math.sin(thHalf);
    var x1 = cx1 + Math.cos(th0) - t * Math.sin(th0);
    var y1 = cy1 + Math.sin(th0) + t * Math.cos(th0);
    var x3 = cx1 + Math.cos(th1);
    var y3 = cy1 + Math.sin(th1);
    var x2 = x3 + t * Math.sin(th1);
    var y2 = y3 - t * Math.cos(th1);
    var result = [
        a00 * x1 + a01 * y1,
        a10 * x1 + a11 * y1,
        a00 * x2 + a01 * y2,
        a10 * x2 + a11 * y2,
        a00 * x3 + a01 * y3,
        a10 * x3 + a11 * y3
    ];
    return result;
};
var $82acc0b64eecc88a$export$8de5166f0a5bde2a = function(path) {
    return $82acc0b64eecc88a$var$apply($82acc0b64eecc88a$var$parse(path));
};



var $4a8a6ab3e9d5c542$export$b11bd9a0808bdc9 = function(line, options) {
    return [
        (0, $067caf076a00b79f$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $067caf076a00b79f$export$568567f665d3f3bb)(options.graphicsState),
        (0, $067caf076a00b79f$export$337b8dbf65fbb95e)(),
        (0, $a0c4165d43c51676$export$6126e5d7ba707741)(options.color),
        (0, $067caf076a00b79f$export$df01d619ff6ce7f7)(options.font, options.size),
        (0, $067caf076a00b79f$export$f567083ac6aa5aa3)((0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.rotate), (0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.xSkew), (0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.ySkew), options.x, options.y),
        (0, $067caf076a00b79f$export$778bfc3c1a2b7ba4)(line),
        (0, $067caf076a00b79f$export$e3caa83a99d72806)(),
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $4a8a6ab3e9d5c542$export$f7b8b44d3d84bc26 = function(lines, options) {
    var operators = [
        (0, $067caf076a00b79f$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $067caf076a00b79f$export$568567f665d3f3bb)(options.graphicsState),
        (0, $067caf076a00b79f$export$337b8dbf65fbb95e)(),
        (0, $a0c4165d43c51676$export$6126e5d7ba707741)(options.color),
        (0, $067caf076a00b79f$export$df01d619ff6ce7f7)(options.font, options.size),
        (0, $067caf076a00b79f$export$79399e66b6bb212c)(options.lineHeight),
        (0, $067caf076a00b79f$export$f567083ac6aa5aa3)((0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.rotate), (0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.xSkew), (0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.ySkew), options.x, options.y)
    ].filter(Boolean);
    for(var idx = 0, len = lines.length; idx < len; idx++)operators.push((0, $067caf076a00b79f$export$778bfc3c1a2b7ba4)(lines[idx]), (0, $067caf076a00b79f$export$829ffc2dbe358942)());
    operators.push((0, $067caf076a00b79f$export$e3caa83a99d72806)(), (0, $067caf076a00b79f$export$10581a6f45bf75eb)());
    return operators;
};
var $4a8a6ab3e9d5c542$export$21a059be5bfd5fb = function(name, options) {
    return [
        (0, $067caf076a00b79f$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $067caf076a00b79f$export$568567f665d3f3bb)(options.graphicsState),
        (0, $067caf076a00b79f$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $067caf076a00b79f$export$a2ba89726971a90f)((0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.rotate)),
        (0, $067caf076a00b79f$export$dcdf75081b88279d)(options.width, options.height),
        (0, $067caf076a00b79f$export$985cb1d69d6a3add)((0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.xSkew), (0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.ySkew)),
        (0, $067caf076a00b79f$export$382c18f8bccd9e2b)(name),
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $4a8a6ab3e9d5c542$export$f8ea28c31069cbc9 = function(name, options) {
    return [
        (0, $067caf076a00b79f$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $067caf076a00b79f$export$568567f665d3f3bb)(options.graphicsState),
        (0, $067caf076a00b79f$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $067caf076a00b79f$export$a2ba89726971a90f)((0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.rotate)),
        (0, $067caf076a00b79f$export$dcdf75081b88279d)(options.xScale, options.yScale),
        (0, $067caf076a00b79f$export$985cb1d69d6a3add)((0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.xSkew), (0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.ySkew)),
        (0, $067caf076a00b79f$export$382c18f8bccd9e2b)(name),
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $4a8a6ab3e9d5c542$export$819db45aec5fcbe5 = function(options) {
    var _a, _b;
    return [
        (0, $067caf076a00b79f$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $067caf076a00b79f$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $a0c4165d43c51676$export$ae31e5cacc8bb23d)(options.color),
        (0, $067caf076a00b79f$export$558e0f90d8262345)(options.thickness),
        (0, $067caf076a00b79f$export$e0e900d241274e06)((_a = options.dashArray) !== null && _a !== void 0 ? _a : [], (_b = options.dashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $067caf076a00b79f$export$75f1ccd6dc32e80a)(options.start.x, options.start.y),
        options.lineCap && (0, $067caf076a00b79f$export$6c65ed24e870eec)(options.lineCap),
        (0, $067caf076a00b79f$export$75f1ccd6dc32e80a)(options.start.x, options.start.y),
        (0, $067caf076a00b79f$export$73abee0cf983cb99)(options.end.x, options.end.y),
        (0, $067caf076a00b79f$export$d9b706f8d0a70aef)(),
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $4a8a6ab3e9d5c542$export$cac848e0621718d8 = function(options) {
    var _a, _b;
    return [
        (0, $067caf076a00b79f$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $067caf076a00b79f$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $a0c4165d43c51676$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $a0c4165d43c51676$export$ae31e5cacc8bb23d)(options.borderColor),
        (0, $067caf076a00b79f$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $067caf076a00b79f$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $067caf076a00b79f$export$e0e900d241274e06)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $067caf076a00b79f$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $067caf076a00b79f$export$a2ba89726971a90f)((0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.rotate)),
        (0, $067caf076a00b79f$export$985cb1d69d6a3add)((0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.xSkew), (0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.ySkew)),
        (0, $067caf076a00b79f$export$75f1ccd6dc32e80a)(0, 0),
        (0, $067caf076a00b79f$export$73abee0cf983cb99)(0, options.height),
        (0, $067caf076a00b79f$export$73abee0cf983cb99)(options.width, options.height),
        (0, $067caf076a00b79f$export$73abee0cf983cb99)(options.width, 0),
        (0, $067caf076a00b79f$export$21f87e210c424cd0)(),
        // prettier-ignore
        options.color && options.borderWidth ? (0, $067caf076a00b79f$export$76d37801baac10fb)() : options.color ? (0, $067caf076a00b79f$export$9563e054e6f787fb)() : options.borderColor ? (0, $067caf076a00b79f$export$d9b706f8d0a70aef)() : (0, $067caf076a00b79f$export$21f87e210c424cd0)(),
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $4a8a6ab3e9d5c542$var$KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var $4a8a6ab3e9d5c542$export$f219d5f4b18063ad = function(config) {
    var x = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(config.x);
    var y = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(config.y);
    var xScale = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(config.xScale);
    var yScale = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(config.yScale);
    x -= xScale;
    y -= yScale;
    var ox = xScale * $4a8a6ab3e9d5c542$var$KAPPA;
    var oy = yScale * $4a8a6ab3e9d5c542$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $067caf076a00b79f$export$cb182c48e35739ac)(),
        (0, $067caf076a00b79f$export$75f1ccd6dc32e80a)(x, ym),
        (0, $067caf076a00b79f$export$45bd49bb15a3c5cb)(x, ym - oy, xm - ox, y, xm, y),
        (0, $067caf076a00b79f$export$45bd49bb15a3c5cb)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $067caf076a00b79f$export$45bd49bb15a3c5cb)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $067caf076a00b79f$export$45bd49bb15a3c5cb)(xm - ox, ye, x, ym + oy, x, ym),
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)()
    ];
};
var $4a8a6ab3e9d5c542$var$drawEllipseCurves = function(config) {
    var centerX = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(config.x);
    var centerY = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(config.y);
    var xScale = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(config.xScale);
    var yScale = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(config.yScale);
    var x = -xScale;
    var y = -yScale;
    var ox = xScale * $4a8a6ab3e9d5c542$var$KAPPA;
    var oy = yScale * $4a8a6ab3e9d5c542$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $067caf076a00b79f$export$d73ee8ef04f5226a)(centerX, centerY),
        (0, $067caf076a00b79f$export$a2ba89726971a90f)((0, $ea262ab75d90e986$export$cba01ba138429a1d)(config.rotate)),
        (0, $067caf076a00b79f$export$75f1ccd6dc32e80a)(x, ym),
        (0, $067caf076a00b79f$export$45bd49bb15a3c5cb)(x, ym - oy, xm - ox, y, xm, y),
        (0, $067caf076a00b79f$export$45bd49bb15a3c5cb)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $067caf076a00b79f$export$45bd49bb15a3c5cb)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $067caf076a00b79f$export$45bd49bb15a3c5cb)(xm - ox, ye, x, ym + oy, x, ym)
    ];
};
var $4a8a6ab3e9d5c542$export$43c9e2bb0dc74582 = function(options) {
    var _a, _b, _c;
    return (0, $47XJ3.__spreadArrays)([
        (0, $067caf076a00b79f$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $067caf076a00b79f$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $a0c4165d43c51676$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $a0c4165d43c51676$export$ae31e5cacc8bb23d)(options.borderColor),
        (0, $067caf076a00b79f$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $067caf076a00b79f$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $067caf076a00b79f$export$e0e900d241274e06)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0)
    ], options.rotate === undefined ? $4a8a6ab3e9d5c542$export$f219d5f4b18063ad({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale
    }) : $4a8a6ab3e9d5c542$var$drawEllipseCurves({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale,
        rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0)
    }), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $067caf076a00b79f$export$76d37801baac10fb)() : options.color ? (0, $067caf076a00b79f$export$9563e054e6f787fb)() : options.borderColor ? (0, $067caf076a00b79f$export$d9b706f8d0a70aef)() : (0, $067caf076a00b79f$export$21f87e210c424cd0)(),
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)()
    ]).filter(Boolean);
};
var $4a8a6ab3e9d5c542$export$47c8a640c39d0756 = function(path, options) {
    var _a, _b, _c;
    return (0, $47XJ3.__spreadArrays)([
        (0, $067caf076a00b79f$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $067caf076a00b79f$export$568567f665d3f3bb)(options.graphicsState),
        (0, $067caf076a00b79f$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $067caf076a00b79f$export$a2ba89726971a90f)((0, $ea262ab75d90e986$export$cba01ba138429a1d)((_a = options.rotate) !== null && _a !== void 0 ? _a : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0))),
        // SVG path Y axis is opposite pdf-lib's
        options.scale ? (0, $067caf076a00b79f$export$dcdf75081b88279d)(options.scale, -options.scale) : (0, $067caf076a00b79f$export$dcdf75081b88279d)(1, -1),
        options.color && (0, $a0c4165d43c51676$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $a0c4165d43c51676$export$ae31e5cacc8bb23d)(options.borderColor),
        options.borderWidth && (0, $067caf076a00b79f$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $067caf076a00b79f$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $067caf076a00b79f$export$e0e900d241274e06)((_b = options.borderDashArray) !== null && _b !== void 0 ? _b : [], (_c = options.borderDashPhase) !== null && _c !== void 0 ? _c : 0)
    ], (0, $82acc0b64eecc88a$export$8de5166f0a5bde2a)(path), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $067caf076a00b79f$export$76d37801baac10fb)() : options.color ? (0, $067caf076a00b79f$export$9563e054e6f787fb)() : options.borderColor ? (0, $067caf076a00b79f$export$d9b706f8d0a70aef)() : (0, $067caf076a00b79f$export$21f87e210c424cd0)(),
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)()
    ]).filter(Boolean);
};
var $4a8a6ab3e9d5c542$export$695703ffa02b3ffb = function(options) {
    var size = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.size);
    /*********************** Define Check Mark Points ***************************/ // A check mark is defined by three points in some coordinate space. Here, we
    // define these points in a unit coordinate system, where the range of the x
    // and y axis are both [-1, 1].
    //
    // Note that we do not hard code `p1y` in case we wish to change the
    // size/shape of the check mark in the future. We want the check mark to
    // always form a right angle. This means that the dot product between (p1-p2)
    // and (p3-p2) should be zero:
    //
    //   (p1x-p2x) * (p3x-p2x) + (p1y-p2y) * (p3y-p2y) = 0
    //
    // We can now rejigger this equation to solve for `p1y`:
    //
    //   (p1y-p2y) * (p3y-p2y) = -((p1x-p2x) * (p3x-p2x))
    //   (p1y-p2y) = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y)
    //   p1y = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y) + p2y
    //
    // Thanks to my friend Joel Walker (https://github.com/JWalker1995) for
    // devising the above equation and unit coordinate system approach!
    // (x, y) coords of the check mark's bottommost point
    var p2x = -0.25;
    var p2y = -0.49;
    // (x, y) coords of the check mark's topmost point
    var p3y = 0.475;
    var p3x = 0.69;
    // (x, y) coords of the check mark's center (vertically) point
    var p1x = -0.675;
    var p1y = -((p1x - p2x) * (p3x - p2x)) / (p3y - p2y) + p2y;
    /****************************************************************************/ return [
        (0, $067caf076a00b79f$export$cb182c48e35739ac)(),
        options.color && (0, $a0c4165d43c51676$export$ae31e5cacc8bb23d)(options.color),
        (0, $067caf076a00b79f$export$558e0f90d8262345)(options.thickness),
        (0, $067caf076a00b79f$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $067caf076a00b79f$export$75f1ccd6dc32e80a)(p1x * size, p1y * size),
        (0, $067caf076a00b79f$export$73abee0cf983cb99)(p2x * size, p2y * size),
        (0, $067caf076a00b79f$export$73abee0cf983cb99)(p3x * size, p3y * size),
        (0, $067caf076a00b79f$export$d9b706f8d0a70aef)(),
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $4a8a6ab3e9d5c542$export$5dd9a0a87f38a2a6 = function(options) {
    return options.rotation === 0 ? [
        (0, $067caf076a00b79f$export$d73ee8ef04f5226a)(0, 0),
        (0, $067caf076a00b79f$export$91df22fbff99d059)(0)
    ] : options.rotation === 90 ? [
        (0, $067caf076a00b79f$export$d73ee8ef04f5226a)(options.width, 0),
        (0, $067caf076a00b79f$export$91df22fbff99d059)(90)
    ] : options.rotation === 180 ? [
        (0, $067caf076a00b79f$export$d73ee8ef04f5226a)(options.width, options.height),
        (0, $067caf076a00b79f$export$91df22fbff99d059)(180)
    ] : options.rotation === 270 ? [
        (0, $067caf076a00b79f$export$d73ee8ef04f5226a)(0, options.height),
        (0, $067caf076a00b79f$export$91df22fbff99d059)(270)
    ] : [];
}; // Invalid rotation - noop
var $4a8a6ab3e9d5c542$export$1c2f7a8d0ec539ab = function(options) {
    var outline = $4a8a6ab3e9d5c542$export$cac848e0621718d8({
        x: options.x,
        y: options.y,
        width: options.width,
        height: options.height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
        xSkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
        ySkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0)
    });
    if (!options.filled) return outline;
    var width = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.width);
    var height = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.height);
    var checkMarkSize = Math.min(width, height) / 2;
    var checkMark = $4a8a6ab3e9d5c542$export$695703ffa02b3ffb({
        x: width / 2,
        y: height / 2,
        size: checkMarkSize,
        thickness: options.thickness,
        color: options.markColor
    });
    return (0, $47XJ3.__spreadArrays)([
        (0, $067caf076a00b79f$export$cb182c48e35739ac)()
    ], outline, checkMark, [
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)()
    ]);
};
var $4a8a6ab3e9d5c542$export$d01bb537f184a293 = function(options) {
    var width = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.width);
    var height = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.height);
    var outlineScale = Math.min(width, height) / 2;
    var outline = $4a8a6ab3e9d5c542$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale,
        yScale: outlineScale,
        color: options.color,
        borderColor: options.borderColor,
        borderWidth: options.borderWidth
    });
    if (!options.filled) return outline;
    var dot = $4a8a6ab3e9d5c542$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale * 0.45,
        yScale: outlineScale * 0.45,
        color: options.dotColor,
        borderColor: undefined,
        borderWidth: 0
    });
    return (0, $47XJ3.__spreadArrays)([
        (0, $067caf076a00b79f$export$cb182c48e35739ac)()
    ], outline, dot, [
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)()
    ]);
};
var $4a8a6ab3e9d5c542$export$31046eb8c5070d92 = function(options) {
    var x = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.x);
    var y = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.y);
    var width = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.width);
    var height = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.height);
    var background = $4a8a6ab3e9d5c542$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
        xSkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
        ySkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0)
    });
    var lines = $4a8a6ab3e9d5c542$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
        xSkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
        ySkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0)
    });
    return (0, $47XJ3.__spreadArrays)([
        (0, $067caf076a00b79f$export$cb182c48e35739ac)()
    ], background, lines, [
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)()
    ]);
};
var $4a8a6ab3e9d5c542$export$8a28629e0fa0aec4 = function(lines, options) {
    var operators = [
        (0, $067caf076a00b79f$export$337b8dbf65fbb95e)(),
        (0, $a0c4165d43c51676$export$6126e5d7ba707741)(options.color),
        (0, $067caf076a00b79f$export$df01d619ff6ce7f7)(options.font, options.size)
    ];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var _a = lines[idx], encoded = _a.encoded, x = _a.x, y = _a.y;
        operators.push((0, $067caf076a00b79f$export$f567083ac6aa5aa3)((0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.rotate), (0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.xSkew), (0, $ea262ab75d90e986$export$cba01ba138429a1d)(options.ySkew), x, y), (0, $067caf076a00b79f$export$778bfc3c1a2b7ba4)(encoded));
    }
    operators.push((0, $067caf076a00b79f$export$e3caa83a99d72806)());
    return operators;
};
var $4a8a6ab3e9d5c542$export$7d8517ad99905084 = function(options) {
    var x = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.x);
    var y = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.y);
    var width = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.width);
    var height = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.height);
    var borderWidth = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.borderWidth);
    var padding = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $067caf076a00b79f$export$75f1ccd6dc32e80a)(clipX, clipY),
        (0, $067caf076a00b79f$export$73abee0cf983cb99)(clipX, clipY + clipHeight),
        (0, $067caf076a00b79f$export$73abee0cf983cb99)(clipX + clipWidth, clipY + clipHeight),
        (0, $067caf076a00b79f$export$73abee0cf983cb99)(clipX + clipWidth, clipY),
        (0, $067caf076a00b79f$export$21f87e210c424cd0)(),
        (0, $067caf076a00b79f$export$e0b576e7a74416cd)(),
        (0, $067caf076a00b79f$export$d366e9c0a9bd860f)()
    ];
    var background = $4a8a6ab3e9d5c542$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
        xSkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
        ySkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0)
    });
    var lines = $4a8a6ab3e9d5c542$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
        xSkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
        ySkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0)
    });
    var markedContent = (0, $47XJ3.__spreadArrays)([
        (0, $067caf076a00b79f$export$a028b403e40f1ab2)('Tx'),
        (0, $067caf076a00b79f$export$cb182c48e35739ac)()
    ], lines, [
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)(),
        (0, $067caf076a00b79f$export$935e2334f5a50589)()
    ]);
    return (0, $47XJ3.__spreadArrays)([
        (0, $067caf076a00b79f$export$cb182c48e35739ac)()
    ], background, clippingArea, markedContent, [
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)()
    ]);
};
var $4a8a6ab3e9d5c542$export$5a3093287b85b7c0 = function(options) {
    var x = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.x);
    var y = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.y);
    var width = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.width);
    var height = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.height);
    var lineHeight = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.lineHeight);
    var borderWidth = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.borderWidth);
    var padding = (0, $c86172f2b9ebac7a$export$37576b9ba69b50db)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $067caf076a00b79f$export$75f1ccd6dc32e80a)(clipX, clipY),
        (0, $067caf076a00b79f$export$73abee0cf983cb99)(clipX, clipY + clipHeight),
        (0, $067caf076a00b79f$export$73abee0cf983cb99)(clipX + clipWidth, clipY + clipHeight),
        (0, $067caf076a00b79f$export$73abee0cf983cb99)(clipX + clipWidth, clipY),
        (0, $067caf076a00b79f$export$21f87e210c424cd0)(),
        (0, $067caf076a00b79f$export$e0b576e7a74416cd)(),
        (0, $067caf076a00b79f$export$d366e9c0a9bd860f)()
    ];
    var background = $4a8a6ab3e9d5c542$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
        xSkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
        ySkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0)
    });
    var highlights = [];
    for(var idx = 0, len = options.selectedLines.length; idx < len; idx++){
        var line = options.textLines[options.selectedLines[idx]];
        highlights.push.apply(highlights, $4a8a6ab3e9d5c542$export$cac848e0621718d8({
            x: line.x - padding,
            y: line.y - (lineHeight - line.height) / 2,
            width: width - borderWidth,
            height: line.height + (lineHeight - line.height) / 2,
            borderWidth: 0,
            color: options.selectedColor,
            borderColor: undefined,
            rotate: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            xSkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            ySkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0)
        }));
    }
    var lines = $4a8a6ab3e9d5c542$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
        xSkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
        ySkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0)
    });
    var markedContent = (0, $47XJ3.__spreadArrays)([
        (0, $067caf076a00b79f$export$a028b403e40f1ab2)('Tx'),
        (0, $067caf076a00b79f$export$cb182c48e35739ac)()
    ], lines, [
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)(),
        (0, $067caf076a00b79f$export$935e2334f5a50589)()
    ]);
    return (0, $47XJ3.__spreadArrays)([
        (0, $067caf076a00b79f$export$cb182c48e35739ac)()
    ], background, highlights, clippingArea, markedContent, [
        (0, $067caf076a00b79f$export$10581a6f45bf75eb)()
    ]);
};




// tslint:disable: max-classes-per-file

var $47XJ3 = parcelRequire("47XJ3");
// TODO: Include link to documentation with example
var $246e6eb6d30233a0$export$20fcceeca2b098d2 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(EncryptedPDFError, _super);
    function EncryptedPDFError() {
        var _this = this;
        var msg = 'Input document to `PDFDocument.load` is encrypted. You can use `PDFDocument.load(..., { ignoreEncryption: true })` if you wish to load the document anyways.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return EncryptedPDFError;
}(Error);
// TODO: Include link to documentation with example
var $246e6eb6d30233a0$export$529a7c74d0636a48 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(FontkitNotRegisteredError, _super);
    function FontkitNotRegisteredError() {
        var _this = this;
        var msg = 'Input to `PDFDocument.embedFont` was a custom font, but no `fontkit` instance was found. You must register a `fontkit` instance with `PDFDocument.registerFontkit(...)` before embedding custom fonts.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FontkitNotRegisteredError;
}(Error);
// TODO: Include link to documentation with example
var $246e6eb6d30233a0$export$9564a4d28d94eae2 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(ForeignPageError, _super);
    function ForeignPageError() {
        var _this = this;
        var msg = 'A `page` passed to `PDFDocument.addPage` or `PDFDocument.insertPage` was from a different (foreign) PDF document. If you want to copy pages from one PDFDocument to another, you must use `PDFDocument.copyPages(...)` to copy the pages before adding or inserting them.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ForeignPageError;
}(Error);
// TODO: Include link to documentation with example
var $246e6eb6d30233a0$export$cdca06c5927ddc2d = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(RemovePageFromEmptyDocumentError, _super);
    function RemovePageFromEmptyDocumentError() {
        var _this = this;
        var msg = 'PDFDocument has no pages so `PDFDocument.removePage` cannot be called';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RemovePageFromEmptyDocumentError;
}(Error);
var $246e6eb6d30233a0$export$5bc08baa4a027cbd = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(NoSuchFieldError, _super);
    function NoSuchFieldError(name) {
        var _this = this;
        var msg = "PDFDocument has no form field with the name \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NoSuchFieldError;
}(Error);
var $246e6eb6d30233a0$export$8909da6c566ff652 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(UnexpectedFieldTypeError, _super);
    function UnexpectedFieldTypeError(name, expected, actual) {
        var _a, _b;
        var _this = this;
        var expectedType = expected === null || expected === void 0 ? void 0 : expected.name;
        var actualType = (_b = (_a = actual === null || actual === void 0 ? void 0 : actual.constructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : actual;
        var msg = "Expected field \"" + name + "\" to be of type " + expectedType + ", " + ("but it is actually of type " + actualType);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedFieldTypeError;
}(Error);
var $246e6eb6d30233a0$export$3437b42908c7d7a3 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(MissingOnValueCheckError, _super);
    function MissingOnValueCheckError(onValue) {
        var _this = this;
        var msg = "Failed to select check box due to missing onValue: \"" + onValue + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingOnValueCheckError;
}(Error);
var $246e6eb6d30233a0$export$c428cfe4dc6c68df = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(FieldAlreadyExistsError, _super);
    function FieldAlreadyExistsError(name) {
        var _this = this;
        var msg = "A field already exists with the specified name: \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldAlreadyExistsError;
}(Error);
var $246e6eb6d30233a0$export$83c39fdacfe38500 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(InvalidFieldNamePartError, _super);
    function InvalidFieldNamePartError(namePart) {
        var _this = this;
        var msg = "Field name contains invalid component: \"" + namePart + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidFieldNamePartError;
}(Error);
var $246e6eb6d30233a0$export$6353a2ffd9106bd2 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(FieldExistsAsNonTerminalError, _super);
    function FieldExistsAsNonTerminalError(name) {
        var _this = this;
        var msg = "A non-terminal field already exists with the specified name: \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldExistsAsNonTerminalError;
}(Error);
var $246e6eb6d30233a0$export$f2fed572e1ed57ab = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(RichTextFieldReadError, _super);
    function RichTextFieldReadError(fieldName) {
        var _this = this;
        var msg = "Reading rich text fields is not supported: Attempted to read rich text field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RichTextFieldReadError;
}(Error);
var $246e6eb6d30233a0$export$5283dffc620a5c9f = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(CombedTextLayoutError, _super);
    function CombedTextLayoutError(lineLength, cellCount) {
        var _this = this;
        var msg = "Failed to layout combed text as lineLength=" + lineLength + " is greater than cellCount=" + cellCount;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CombedTextLayoutError;
}(Error);
var $246e6eb6d30233a0$export$1577e99040d42609 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(ExceededMaxLengthError, _super);
    function ExceededMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set text with length=" + textLength + " for TextField with maxLength=" + maxLength + " and name=" + name;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ExceededMaxLengthError;
}(Error);
var $246e6eb6d30233a0$export$6da6c372180e79b0 = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(InvalidMaxLengthError, _super);
    function InvalidMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set maxLength=" + maxLength + ", which is less than " + textLength + ", the length of this field's current value (name=" + name + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidMaxLengthError;
}(Error);


var $5d0822d6fb71c4c5$export$84b2d1b68830363f;
(function(TextAlignment) {
    TextAlignment[TextAlignment["Left"] = 0] = "Left";
    TextAlignment[TextAlignment["Center"] = 1] = "Center";
    TextAlignment[TextAlignment["Right"] = 2] = "Right";
})($5d0822d6fb71c4c5$export$84b2d1b68830363f || ($5d0822d6fb71c4c5$export$84b2d1b68830363f = {}));


parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
var $9ebb76aa044b1491$var$MIN_FONT_SIZE = 4;
var $9ebb76aa044b1491$var$MAX_FONT_SIZE = 500;
var $9ebb76aa044b1491$var$computeFontSize = function(lines, font, bounds, multiline) {
    if (multiline === void 0) multiline = false;
    var fontSize = $9ebb76aa044b1491$var$MIN_FONT_SIZE;
    while(fontSize < $9ebb76aa044b1491$var$MAX_FONT_SIZE){
        var linesUsed = 0;
        for(var lineIdx = 0, lineLen = lines.length; lineIdx < lineLen; lineIdx++){
            linesUsed += 1;
            var line = lines[lineIdx];
            var words = line.split(' ');
            // Layout the words using the current `fontSize`, line wrapping
            // whenever we reach the end of the current line.
            var spaceInLineRemaining = bounds.width;
            for(var idx = 0, len = words.length; idx < len; idx++){
                var isLastWord = idx === len - 1;
                var word = isLastWord ? words[idx] : words[idx] + ' ';
                var widthOfWord = font.widthOfTextAtSize(word, fontSize);
                spaceInLineRemaining -= widthOfWord;
                if (spaceInLineRemaining <= 0) {
                    linesUsed += 1;
                    spaceInLineRemaining = bounds.width - widthOfWord;
                }
            }
        }
        // Return if we exceeded the allowed width
        if (!multiline && linesUsed > lines.length) return fontSize - 1;
        var height = font.heightAtSize(fontSize);
        var lineHeight = height + height * 0.2;
        var totalHeight = lineHeight * linesUsed;
        // Return if we exceeded the allowed height
        if (totalHeight > Math.abs(bounds.height)) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $9ebb76aa044b1491$var$computeCombedFontSize = function(line, font, bounds, cellCount) {
    var cellWidth = bounds.width / cellCount;
    var cellHeight = bounds.height;
    var fontSize = $9ebb76aa044b1491$var$MIN_FONT_SIZE;
    var chars = (0, $8ZzAZ.charSplit)(line);
    while(fontSize < $9ebb76aa044b1491$var$MAX_FONT_SIZE){
        for(var idx = 0, len = chars.length; idx < len; idx++){
            var c = chars[idx];
            var tooLong = font.widthOfTextAtSize(c, fontSize) > cellWidth * 0.75;
            if (tooLong) return fontSize - 1;
        }
        var height = font.heightAtSize(fontSize, {
            descender: false
        });
        if (height > cellHeight) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $9ebb76aa044b1491$var$lastIndexOfWhitespace = function(line) {
    for(var idx = line.length; idx > 0; idx--){
        if (/\s/.test(line[idx])) return idx;
    }
    return undefined;
};
var $9ebb76aa044b1491$var$splitOutLines = function(input, maxWidth, font, fontSize) {
    var _a;
    var lastWhitespaceIdx = input.length;
    while(lastWhitespaceIdx > 0){
        var line = input.substring(0, lastWhitespaceIdx);
        var encoded = font.encodeText(line);
        var width = font.widthOfTextAtSize(line, fontSize);
        if (width < maxWidth) {
            var remainder = input.substring(lastWhitespaceIdx) || undefined;
            return {
                line: line,
                encoded: encoded,
                width: width,
                remainder: remainder
            };
        }
        lastWhitespaceIdx = (_a = $9ebb76aa044b1491$var$lastIndexOfWhitespace(line)) !== null && _a !== void 0 ? _a : 0;
    }
    // We were unable to split the input enough to get a chunk that would fit
    // within the specified `maxWidth` so we'll just return everything
    return {
        line: input,
        encoded: font.encodeText(input),
        width: font.widthOfTextAtSize(input, fontSize),
        remainder: undefined
    };
};
var $9ebb76aa044b1491$export$f6ba9f13f815cc95 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var lines = (0, $8ZzAZ.lineSplit)((0, $8ZzAZ.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $9ebb76aa044b1491$var$computeFontSize(lines, font, bounds, true);
    var height = font.heightAtSize(fontSize);
    var lineHeight = height + height * 0.2;
    var textLines = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var y = bounds.y + bounds.height;
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var prevRemainder = lines[idx];
        while(prevRemainder !== undefined){
            var _b = $9ebb76aa044b1491$var$splitOutLines(prevRemainder, bounds.width, font, fontSize), line = _b.line, encoded = _b.encoded, width = _b.width, remainder = _b.remainder;
            // prettier-ignore
            var x = alignment === (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Left ? bounds.x : alignment === (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Right ? bounds.x + bounds.width - width : bounds.x;
            y -= lineHeight;
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x + width > maxX) maxX = x + width;
            if (y + height > maxY) maxY = y + height;
            textLines.push({
                text: line,
                encoded: encoded,
                width: width,
                height: height,
                x: x,
                y: y
            });
            // Only trim lines that we had to split ourselves. So we won't trim lines
            // that the user provided themselves with whitespace.
            prevRemainder = remainder === null || remainder === void 0 ? void 0 : remainder.trim();
        }
    }
    return {
        fontSize: fontSize,
        lineHeight: lineHeight,
        lines: textLines,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $9ebb76aa044b1491$export$deba41d88dd75dfc = function(text, _a) {
    var fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds, cellCount = _a.cellCount;
    var line = (0, $8ZzAZ.mergeLines)((0, $8ZzAZ.cleanText)(text));
    if (line.length > cellCount) throw new (0, $246e6eb6d30233a0$export$5283dffc620a5c9f)(line.length, cellCount);
    if (fontSize === undefined || fontSize === 0) fontSize = $9ebb76aa044b1491$var$computeCombedFontSize(line, font, bounds, cellCount);
    var cellWidth = bounds.width / cellCount;
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    var y = bounds.y + (bounds.height / 2 - height / 2);
    var cells = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var cellOffset = 0;
    var charOffset = 0;
    while(cellOffset < cellCount){
        var _b = (0, $8ZzAZ.charAtIndex)(line, charOffset), char = _b[0], charLength = _b[1];
        var encoded = font.encodeText(char);
        var width = font.widthOfTextAtSize(char, fontSize);
        var cellCenter = bounds.x + (cellWidth * cellOffset + cellWidth / 2);
        var x = cellCenter - width / 2;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x + width > maxX) maxX = x + width;
        if (y + height > maxY) maxY = y + height;
        cells.push({
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        });
        cellOffset += 1;
        charOffset += charLength;
    }
    return {
        fontSize: fontSize,
        cells: cells,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $9ebb76aa044b1491$export$c0030606588cf6f2 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var line = (0, $8ZzAZ.mergeLines)((0, $8ZzAZ.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $9ebb76aa044b1491$var$computeFontSize([
        line
    ], font, bounds);
    var encoded = font.encodeText(line);
    var width = font.widthOfTextAtSize(line, fontSize);
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    // prettier-ignore
    var x = alignment === (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Left ? bounds.x : alignment === (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Right ? bounds.x + bounds.width - width : bounds.x;
    var y = bounds.y + (bounds.height / 2 - height / 2);
    return {
        fontSize: fontSize,
        line: {
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        },
        bounds: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    };
};




parcelRequire("5w6hV");
var $8ZzAZ = parcelRequire("8ZzAZ");
var $9986a803db2c3c73$export$8a3aea031520d39b = function(appearance) {
    if ('normal' in appearance) return appearance;
    return {
        normal: appearance
    };
};
// Examples:
//   `/Helv 12 Tf` -> ['/Helv 12 Tf', 'Helv', '12']
//   `/HeBo 8.00 Tf` -> ['/HeBo 8 Tf', 'HeBo', '8.00']
var $9986a803db2c3c73$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]+(\d*\.\d+|\d+)[\0\t\n\f\r\ ]+Tf/;
var $9986a803db2c3c73$var$getDefaultFontSize = function(field) {
    var _a, _b;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
    var daMatch = (_b = (0, $8ZzAZ.findLastMatch)(da, $9986a803db2c3c73$var$tfRegex).match) !== null && _b !== void 0 ? _b : [];
    var defaultFontSize = Number(daMatch[2]);
    return isFinite(defaultFontSize) ? defaultFontSize : undefined;
};
// Examples:
//   `0.3 g` -> ['0.3', 'g']
//   `0.3 1 .3 rg` -> ['0.3', '1', '.3', 'rg']
//   `0.3 1 .3 0 k` -> ['0.3', '1', '.3', '0', 'k']
var $9986a803db2c3c73$var$colorRegex = /(\d*\.\d+|\d+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+(g|rg|k)/;
var $9986a803db2c3c73$var$getDefaultColor = function(field) {
    var _a;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
    var daMatch = (0, $8ZzAZ.findLastMatch)(da, $9986a803db2c3c73$var$colorRegex).match;
    var _b = daMatch !== null && daMatch !== void 0 ? daMatch : [], c1 = _b[1], c2 = _b[2], c3 = _b[3], c4 = _b[4], colorSpace = _b[5];
    if (colorSpace === 'g' && c1) return (0, $a0c4165d43c51676$export$6f416a6db2dfcd5c)(Number(c1));
    if (colorSpace === 'rg' && c1 && c2 && c3) return (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(Number(c1), Number(c2), Number(c3));
    if (colorSpace === 'k' && c1 && c2 && c3 && c4) return (0, $a0c4165d43c51676$export$358b1a66a3c77756)(Number(c1), Number(c2), Number(c3), Number(c4));
    return undefined;
};
var $9986a803db2c3c73$var$updateDefaultAppearance = function(field, color, font, fontSize) {
    var _a;
    if (fontSize === void 0) fontSize = 0;
    var da = [
        (0, $a0c4165d43c51676$export$6126e5d7ba707741)(color).toString(),
        (0, $067caf076a00b79f$export$df01d619ff6ce7f7)((_a = font === null || font === void 0 ? void 0 : font.name) !== null && _a !== void 0 ? _a : 'dummy__noop', fontSize).toString()
    ].join('\n');
    field.setDefaultAppearance(da);
};
var $9986a803db2c3c73$export$e11eab3ac6c06eb0 = function(checkBox, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $9986a803db2c3c73$var$getDefaultColor(widget);
    var fieldColor = $9986a803db2c3c73$var$getDefaultColor(checkBox.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $ea262ab75d90e986$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $ea262ab75d90e986$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $4a8a6ab3e9d5c542$export$5dd9a0a87f38a2a6)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (_b = (0, $a0c4165d43c51676$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $a0c4165d43c51676$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $a0c4165d43c51676$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $9986a803db2c3c73$var$updateDefaultAppearance(widget, textColor);
    else $9986a803db2c3c73$var$updateDefaultAppearance(checkBox.acroField, textColor);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        thickness: 1.5,
        borderWidth: borderWidth,
        borderColor: borderColor,
        markColor: textColor
    };
    return {
        normal: {
            on: (0, $47XJ3.__spreadArrays)(rotate, (0, $4a8a6ab3e9d5c542$export$1c2f7a8d0ec539ab)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $47XJ3.__spreadArrays)(rotate, (0, $4a8a6ab3e9d5c542$export$1c2f7a8d0ec539ab)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $47XJ3.__spreadArrays)(rotate, (0, $4a8a6ab3e9d5c542$export$1c2f7a8d0ec539ab)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $47XJ3.__spreadArrays)(rotate, (0, $4a8a6ab3e9d5c542$export$1c2f7a8d0ec539ab)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $9986a803db2c3c73$export$6440094330a99ef8 = function(radioGroup, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $9986a803db2c3c73$var$getDefaultColor(widget);
    var fieldColor = $9986a803db2c3c73$var$getDefaultColor(radioGroup.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $ea262ab75d90e986$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $ea262ab75d90e986$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $4a8a6ab3e9d5c542$export$5dd9a0a87f38a2a6)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (_b = (0, $a0c4165d43c51676$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $a0c4165d43c51676$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $a0c4165d43c51676$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $9986a803db2c3c73$var$updateDefaultAppearance(widget, textColor);
    else $9986a803db2c3c73$var$updateDefaultAppearance(radioGroup.acroField, textColor);
    var options = {
        x: width / 2,
        y: height / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        dotColor: textColor
    };
    return {
        normal: {
            on: (0, $47XJ3.__spreadArrays)(rotate, (0, $4a8a6ab3e9d5c542$export$d01bb537f184a293)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $47XJ3.__spreadArrays)(rotate, (0, $4a8a6ab3e9d5c542$export$d01bb537f184a293)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $47XJ3.__spreadArrays)(rotate, (0, $4a8a6ab3e9d5c542$export$d01bb537f184a293)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $47XJ3.__spreadArrays)(rotate, (0, $4a8a6ab3e9d5c542$export$d01bb537f184a293)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $9986a803db2c3c73$export$68f9b19f48ffeeec = function(button, widget, font) {
    var _a, _b, _c, _d, _e;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $9986a803db2c3c73$var$getDefaultColor(widget);
    var fieldColor = $9986a803db2c3c73$var$getDefaultColor(button.acroField);
    var widgetFontSize = $9986a803db2c3c73$var$getDefaultFontSize(widget);
    var fieldFontSize = $9986a803db2c3c73$var$getDefaultFontSize(button.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var captions = ap === null || ap === void 0 ? void 0 : ap.getCaptions();
    var normalText = (_a = captions === null || captions === void 0 ? void 0 : captions.normal) !== null && _a !== void 0 ? _a : '';
    var downText = (_c = (_b = captions === null || captions === void 0 ? void 0 : captions.down) !== null && _b !== void 0 ? _b : normalText) !== null && _c !== void 0 ? _c : '';
    var borderWidth = (_d = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _d !== void 0 ? _d : 0;
    var rotation = (0, $ea262ab75d90e986$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _f = (0, $ea262ab75d90e986$export$312e44550db33c6a)(rectangle, rotation), width = _f.width, height = _f.height;
    var rotate = (0, $4a8a6ab3e9d5c542$export$5dd9a0a87f38a2a6)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $a0c4165d43c51676$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $a0c4165d43c51676$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $a0c4165d43c51676$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    var bounds = {
        x: borderWidth,
        y: borderWidth,
        width: width - borderWidth * 2,
        height: height - borderWidth * 2
    };
    var normalLayout = (0, $9ebb76aa044b1491$export$c0030606588cf6f2)(normalText, {
        alignment: (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    var downLayout = (0, $9ebb76aa044b1491$export$c0030606588cf6f2)(downText, {
        alignment: (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    // Update font size and color
    var fontSize = Math.min(normalLayout.fontSize, downLayout.fontSize);
    var textColor = (_e = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _e !== void 0 ? _e : black;
    if (widgetColor || widgetFontSize !== undefined) $9986a803db2c3c73$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $9986a803db2c3c73$var$updateDefaultAppearance(button.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize
    };
    return {
        normal: (0, $47XJ3.__spreadArrays)(rotate, (0, $4a8a6ab3e9d5c542$export$31046eb8c5070d92)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, options), {
            color: normalBackgroundColor,
            textLines: [
                normalLayout.line
            ]
        }))),
        down: (0, $47XJ3.__spreadArrays)(rotate, (0, $4a8a6ab3e9d5c542$export$31046eb8c5070d92)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, options), {
            color: downBackgroundColor,
            textLines: [
                downLayout.line
            ]
        })))
    };
};
var $9986a803db2c3c73$export$42ba95e6b8df3d7 = function(textField, widget, font) {
    var _a, _b, _c, _d;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $9986a803db2c3c73$var$getDefaultColor(widget);
    var fieldColor = $9986a803db2c3c73$var$getDefaultColor(textField.acroField);
    var widgetFontSize = $9986a803db2c3c73$var$getDefaultFontSize(widget);
    var fieldFontSize = $9986a803db2c3c73$var$getDefaultFontSize(textField.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = textField.getText()) !== null && _a !== void 0 ? _a : '';
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $ea262ab75d90e986$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _e = (0, $ea262ab75d90e986$export$312e44550db33c6a)(rectangle, rotation), width = _e.width, height = _e.height;
    var rotate = (0, $4a8a6ab3e9d5c542$export$5dd9a0a87f38a2a6)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $a0c4165d43c51676$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $a0c4165d43c51676$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var textLines;
    var fontSize;
    var padding = textField.isCombed() ? 0 : 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    if (textField.isMultiline()) {
        var layout = (0, $9ebb76aa044b1491$export$f6ba9f13f815cc95)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = layout.lines;
        fontSize = layout.fontSize;
    } else if (textField.isCombed()) {
        var layout = (0, $9ebb76aa044b1491$export$deba41d88dd75dfc)(text, {
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds,
            cellCount: (_c = textField.getMaxLength()) !== null && _c !== void 0 ? _c : 0
        });
        textLines = layout.cells;
        fontSize = layout.fontSize;
    } else {
        var layout = (0, $9ebb76aa044b1491$export$c0030606588cf6f2)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = [
            layout.line
        ];
        fontSize = layout.fontSize;
    }
    // Update font size and color
    var textColor = (_d = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _d !== void 0 ? _d : black;
    if (widgetColor || widgetFontSize !== undefined) $9986a803db2c3c73$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $9986a803db2c3c73$var$updateDefaultAppearance(textField.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: textLines,
        padding: padding
    };
    return (0, $47XJ3.__spreadArrays)(rotate, (0, $4a8a6ab3e9d5c542$export$7d8517ad99905084)(options));
};
var $9986a803db2c3c73$export$90f1ca03d512ec5 = function(dropdown, widget, font) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $9986a803db2c3c73$var$getDefaultColor(widget);
    var fieldColor = $9986a803db2c3c73$var$getDefaultColor(dropdown.acroField);
    var widgetFontSize = $9986a803db2c3c73$var$getDefaultFontSize(widget);
    var fieldFontSize = $9986a803db2c3c73$var$getDefaultFontSize(dropdown.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = dropdown.getSelected()[0]) !== null && _a !== void 0 ? _a : '';
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $ea262ab75d90e986$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $ea262ab75d90e986$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $4a8a6ab3e9d5c542$export$5dd9a0a87f38a2a6)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $a0c4165d43c51676$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $a0c4165d43c51676$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _e = (0, $9ebb76aa044b1491$export$c0030606588cf6f2)(text, {
        alignment: (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), line = _e.line, fontSize = _e.fontSize;
    // Update font size and color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor || widgetFontSize !== undefined) $9986a803db2c3c73$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $9986a803db2c3c73$var$updateDefaultAppearance(dropdown.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: [
            line
        ],
        padding: padding
    };
    return (0, $47XJ3.__spreadArrays)(rotate, (0, $4a8a6ab3e9d5c542$export$7d8517ad99905084)(options));
};
var $9986a803db2c3c73$export$f9fab495286778d2 = function(optionList, widget, font) {
    var _a, _b;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $9986a803db2c3c73$var$getDefaultColor(widget);
    var fieldColor = $9986a803db2c3c73$var$getDefaultColor(optionList.acroField);
    var widgetFontSize = $9986a803db2c3c73$var$getDefaultFontSize(widget);
    var fieldFontSize = $9986a803db2c3c73$var$getDefaultFontSize(optionList.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $ea262ab75d90e986$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _c = (0, $ea262ab75d90e986$export$312e44550db33c6a)(rectangle, rotation), width = _c.width, height = _c.height;
    var rotate = (0, $4a8a6ab3e9d5c542$export$5dd9a0a87f38a2a6)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $a0c4165d43c51676$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $a0c4165d43c51676$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var options = optionList.getOptions();
    var selected = optionList.getSelected();
    if (optionList.isSorted()) options.sort();
    var text = '';
    for(var idx = 0, len = options.length; idx < len; idx++){
        text += options[idx];
        if (idx < len - 1) text += '\n';
    }
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _d = (0, $9ebb76aa044b1491$export$f6ba9f13f815cc95)(text, {
        alignment: (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), lines = _d.lines, fontSize = _d.fontSize, lineHeight = _d.lineHeight;
    var selectedLines = [];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var line = lines[idx];
        if (selected.includes(line.text)) selectedLines.push(idx);
    }
    var blue = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0.6, 193 / 255, 218 / 255);
    // Update font size and color
    var textColor = (_b = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _b !== void 0 ? _b : black;
    if (widgetColor || widgetFontSize !== undefined) $9986a803db2c3c73$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $9986a803db2c3c73$var$updateDefaultAppearance(optionList.acroField, textColor, font, fontSize);
    return (0, $47XJ3.__spreadArrays)(rotate, (0, $4a8a6ab3e9d5c542$export$5a3093287b85b7c0)({
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: lines,
        lineHeight: lineHeight,
        selectedColor: blue,
        selectedLines: selectedLines,
        padding: padding
    }));
};



var $47XJ3 = parcelRequire("47XJ3");

var $47XJ3 = parcelRequire("47XJ3");




var $47XJ3 = parcelRequire("47XJ3");


var $47XJ3 = parcelRequire("47XJ3");


parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
/**
 * Represents a PDF page that has been embedded in a [[PDFDocument]].
 */ var $7561c064649146d8$var$PDFEmbeddedPage = /** @class */ function() {
    function PDFEmbeddedPage(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        (0, $afaKe.assertIs)(ref, 'ref', [
            [
                (0, $dac7b6b491336f5d$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $afaKe.assertIs)(doc, 'doc', [
            [
                (0, $d524d17d41c918dc$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        (0, $afaKe.assertIs)(embedder, 'embedder', [
            [
                (0, $5b0b737ae7e3d3aa$export$2e2bcd8739ae039),
                'PDFPageEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this page after being scaled by the
     * given `factor`. For example:
     * ```js
     * embeddedPage.width  // => 500
     * embeddedPage.height // => 250
     *
     * const scaled = embeddedPage.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing a page with
     * [[PDFPage.drawPage]] to compute the `width` and `height` options.
     * @param factor The factor by which this page should be scaled.
     * @returns The width and height of the page after being scaled.
     */ PDFEmbeddedPage.prototype.scale = function(factor) {
        (0, $afaKe.assertIs)(factor, 'factor', [
            'number'
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this page. For example:
     * ```js
     * const { width, height } = embeddedPage.size()
     * ```
     * @returns The width and height of the page.
     */ PDFEmbeddedPage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable pages get embedded.
     *
     * Embed this embeddable page in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedPage.prototype.embed = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPdf]] and
     * > [[PDFDocument.embedPage]] methods, which will create instances of
     * > [[PDFEmbeddedPage]] for you.
     *
     * Create an instance of [[PDFEmbeddedPage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this embedded page.
     * @param doc The document to which the embedded page will belong.
     * @param embedder The embedder that will be used to embed the page.
     */ PDFEmbeddedPage.of = function(ref, doc, embedder) {
        return new PDFEmbeddedPage(ref, doc, embedder);
    };
    return PDFEmbeddedPage;
}();
var $7561c064649146d8$export$2e2bcd8739ae039 = $7561c064649146d8$var$PDFEmbeddedPage;



var $47XJ3 = parcelRequire("47XJ3");


parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
/**
 * Represents a font that has been embedded in a [[PDFDocument]].
 */ var $8a85d13aa5e04534$var$PDFFont = /** @class */ function() {
    function PDFFont(ref, doc, embedder) {
        this.modified = true;
        (0, $afaKe.assertIs)(ref, 'ref', [
            [
                (0, $dac7b6b491336f5d$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $afaKe.assertIs)(doc, 'doc', [
            [
                (0, $d524d17d41c918dc$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        (0, $afaKe.assertIs)(embedder, 'embedder', [
            [
                (0, $0bb5e016ec464ab5$export$2e2bcd8739ae039),
                'CustomFontEmbedder'
            ],
            [
                (0, $d778657fca830008$export$2e2bcd8739ae039),
                'StandardFontEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.name = embedder.fontName;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFPage.drawText]] method will automatically encode the text it is
     * > given.
     *
     * Encodes a string of text in this font.
     *
     * @param text The text to be encoded.
     * @returns The encoded text as a hex string.
     */ PDFFont.prototype.encodeText = function(text) {
        (0, $afaKe.assertIs)(text, 'text', [
            'string'
        ]);
        this.modified = true;
        return this.embedder.encodeText(text);
    };
    /**
     * Measure the width of a string of text drawn in this font at a given size.
     * For example:
     * ```js
     * const width = font.widthOfTextAtSize('Foo Bar Qux Baz', 36)
     * ```
     * @param text The string of text to be measured.
     * @param size The font size to be used for this measurement.
     * @returns The width of the string of text when drawn in this font at the
     *          given size.
     */ PDFFont.prototype.widthOfTextAtSize = function(text, size) {
        (0, $afaKe.assertIs)(text, 'text', [
            'string'
        ]);
        (0, $afaKe.assertIs)(size, 'size', [
            'number'
        ]);
        return this.embedder.widthOfTextAtSize(text, size);
    };
    /**
     * Measure the height of this font at a given size. For example:
     * ```js
     * const height = font.heightAtSize(24)
     * ```
     *
     * The `options.descender` value controls whether or not the font's
     * descender is included in the height calculation.
     *
     * @param size The font size to be used for this measurement.
     * @param options The options to be used when computing this measurement.
     * @returns The height of this font at the given size.
     */ PDFFont.prototype.heightAtSize = function(size, options) {
        var _a;
        (0, $afaKe.assertIs)(size, 'size', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.descender, 'options.descender', [
            'boolean'
        ]);
        return this.embedder.heightOfFontAtSize(size, {
            descender: (_a = options === null || options === void 0 ? void 0 : options.descender) !== null && _a !== void 0 ? _a : true
        });
    };
    /**
     * Compute the font size at which this font is a given height. For example:
     * ```js
     * const fontSize = font.sizeAtHeight(12)
     * ```
     * @param height The height to be used for this calculation.
     * @returns The font size at which this font is the given height.
     */ PDFFont.prototype.sizeAtHeight = function(height) {
        (0, $afaKe.assertIs)(height, 'height', [
            'number'
        ]);
        return this.embedder.sizeOfFontAtHeight(height);
    };
    /**
     * Get the set of unicode code points that can be represented by this font.
     * @returns The set of unicode code points supported by this font.
     */ PDFFont.prototype.getCharacterSet = function() {
        if (this.embedder instanceof (0, $d778657fca830008$export$2e2bcd8739ae039)) return this.embedder.encoding.supportedCodePoints;
        else return this.embedder.font.characterSet;
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all fonts get embedded.
     *
     * Embed this font in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFFont.prototype.embed = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.modified) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.modified = false;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedFont]] and
     * > [[PDFDocument.embedStandardFont]] methods, which will create instances
     * > of [[PDFFont]] for you.
     *
     * Create an instance of [[PDFFont]] from an existing ref and embedder
     *
     * @param ref The unique reference for this font.
     * @param doc The document to which the font will belong.
     * @param embedder The embedder that will be used to embed the font.
     */ PDFFont.of = function(ref, doc, embedder) {
        return new PDFFont(ref, doc, embedder);
    };
    return PDFFont;
}();
var $8a85d13aa5e04534$export$2e2bcd8739ae039 = $8a85d13aa5e04534$var$PDFFont;



var $47XJ3 = parcelRequire("47XJ3");


parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
/**
 * Represents an image that has been embedded in a [[PDFDocument]].
 */ var $9503338f4d18fe05$var$PDFImage = /** @class */ function() {
    function PDFImage(ref, doc, embedder) {
        (0, $afaKe.assertIs)(ref, 'ref', [
            [
                (0, $dac7b6b491336f5d$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $afaKe.assertIs)(doc, 'doc', [
            [
                (0, $d524d17d41c918dc$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        (0, $afaKe.assertIs)(embedder, 'embedder', [
            [
                (0, $8fc02cbbe0289d96$export$2e2bcd8739ae039),
                'JpegEmbedder'
            ],
            [
                (0, $af70ed359aebef3f$export$2e2bcd8739ae039),
                'PngEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this image after being scaled by the
     * given `factor`. For example:
     * ```js
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing an image with
     * [[PDFPage.drawImage]] to compute the `width` and `height` options.
     * @param factor The factor by which this image should be scaled.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scale = function(factor) {
        (0, $afaKe.assertIs)(factor, 'factor', [
            'number'
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this image after scaling it as large as
     * possible while maintaining its aspect ratio and not exceeding the
     * specified `width` and `height`. For example:
     * ```
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scaleToFit(750, 1000)
     * scaled.width  // => 750
     * scaled.height // => 375
     * ```
     * The `width` and `height` parameters can also be thought of as the width
     * and height of a box that the scaled image must fit within.
     * @param width The bounding box's width.
     * @param height The bounding box's height.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scaleToFit = function(width, height) {
        (0, $afaKe.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $afaKe.assertIs)(height, 'height', [
            'number'
        ]);
        var imgWidthScale = width / this.width;
        var imgHeightScale = height / this.height;
        var scale = Math.min(imgWidthScale, imgHeightScale);
        return this.scale(scale);
    };
    /**
     * Get the width and height of this image. For example:
     * ```js
     * const { width, height } = image.size()
     * ```
     * @returns The width and height of the image.
     */ PDFImage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all images get embedded.
     *
     * Embed this image in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFImage.prototype.embed = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var _a, doc, ref;
            return (0, $47XJ3.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.embedder) return [
                            2 /*return*/ 
                        ];
                        // The image should only be embedded once. If there's a pending embed
                        // operation then wait on it. Otherwise we need to start the embed.
                        if (!this.embedTask) {
                            _a = this, doc = _a.doc, ref = _a.ref;
                            this.embedTask = this.embedder.embedIntoContext(doc.context, ref);
                        }
                        return [
                            4 /*yield*/ ,
                            this.embedTask
                        ];
                    case 1:
                        _b.sent();
                        // We clear `this.embedder` so that the indirectly referenced image data
                        // can be garbage collected, thus avoiding a memory leak.
                        // See https://github.com/Hopding/pdf-lib/pull/1032/files.
                        this.embedder = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPng]] and [[PDFDocument.embedJpg]]
     * > methods, which will create instances of [[PDFImage]] for you.
     *
     * Create an instance of [[PDFImage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this image.
     * @param doc The document to which the image will belong.
     * @param embedder The embedder that will be used to embed the image.
     */ PDFImage.of = function(ref, doc, embedder) {
        return new PDFImage(ref, doc, embedder);
    };
    return PDFImage;
}();
var $9503338f4d18fe05$export$2e2bcd8739ae039 = $9503338f4d18fe05$var$PDFImage;




var $47XJ3 = parcelRequire("47XJ3");



var $47XJ3 = parcelRequire("47XJ3");





var $47XJ3 = parcelRequire("47XJ3");




var $6AcCU = parcelRequire("6AcCU");
var $2npvA = parcelRequire("2npvA");
parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
var $d0179262af07ed10$export$8efa99ca8f041e7e;
(function(ImageAlignment) {
    ImageAlignment[ImageAlignment["Left"] = 0] = "Left";
    ImageAlignment[ImageAlignment["Center"] = 1] = "Center";
    ImageAlignment[ImageAlignment["Right"] = 2] = "Right";
})($d0179262af07ed10$export$8efa99ca8f041e7e || ($d0179262af07ed10$export$8efa99ca8f041e7e = {}));





var $c15606bfc3a2beb4$export$55643210f1835a35 = function(options) {
    (0, $afaKe.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.x, 'options.x', [
        'number'
    ]);
    (0, $afaKe.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.y, 'options.y', [
        'number'
    ]);
    (0, $afaKe.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.width, 'options.width', [
        'number'
    ]);
    (0, $afaKe.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.height, 'options.height', [
        'number'
    ]);
    (0, $afaKe.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.textColor, 'options.textColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $afaKe.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.backgroundColor, 'options.backgroundColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $afaKe.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderColor, 'options.borderColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $afaKe.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderWidth, 'options.borderWidth', [
        'number'
    ]);
    (0, $afaKe.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.rotate, 'options.rotate', [
        [
            Object,
            'Rotation'
        ]
    ]);
};
/**
 * Represents a field of a [[PDFForm]].
 *
 * This class is effectively abstract. All fields in a [[PDFForm]] will
 * actually be an instance of a subclass of this class.
 *
 * Note that each field in a PDF is represented by a single field object.
 * However, a given field object may be rendered at multiple locations within
 * the document (across one or more pages). The rendering of a field is
 * controlled by its widgets. Each widget causes its field to be displayed at a
 * particular location in the document.
 *
 * Most of the time each field in a PDF has only a single widget, and thus is
 * only rendered once. However, if a field is rendered multiple times, it will
 * have multiple widgets - one for each location it is rendered.
 *
 * This abstraction of field objects and widgets is defined in the PDF
 * specification and dictates how PDF files store fields and where they are
 * to be rendered.
 */ var $c15606bfc3a2beb4$var$PDFField = /** @class */ function() {
    function PDFField(acroField, ref, doc) {
        (0, $afaKe.assertIs)(acroField, 'acroField', [
            [
                (0, $1d777609aab029cf$export$2e2bcd8739ae039),
                'PDFAcroTerminal'
            ]
        ]);
        (0, $afaKe.assertIs)(ref, 'ref', [
            [
                (0, $dac7b6b491336f5d$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $afaKe.assertIs)(doc, 'doc', [
            [
                (0, $d524d17d41c918dc$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        this.acroField = acroField;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Get the fully qualified name of this field. For example:
     * ```js
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const name = field.getName()
     *   console.log('Field name:', name)
     * })
     * ```
     * Note that PDF fields are structured as a tree. Each field is the
     * descendent of a series of ancestor nodes all the way up to the form node,
     * which is always the root of the tree. Each node in the tree (except for
     * the form node) has a partial name. Partial names can be composed of any
     * unicode characters except a period (`.`). The fully qualified name of a
     * field is composed of the partial names of all its ancestors joined
     * with periods. This means that splitting the fully qualified name on
     * periods and taking the last element of the resulting array will give you
     * the partial name of a specific field.
     * @returns The fully qualified name of this field.
     */ PDFField.prototype.getName = function() {
        var _a;
        return (_a = this.acroField.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
    };
    /**
     * Returns `true` if this field is read only. This means that PDF readers
     * will not allow users to interact with the field or change its value. See
     * [[PDFField.enableReadOnly]] and [[PDFField.disableReadOnly]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isReadOnly()) console.log('Read only is enabled')
     * ```
     * @returns Whether or not this is a read only field.
     */ PDFField.prototype.isReadOnly = function() {
        return this.acroField.hasFlag((0, $ccb031b501604dea$export$3600c95532547643).ReadOnly);
    };
    /**
     * Prevent PDF readers from allowing users to interact with this field or
     * change its value. The field will not respond to mouse or keyboard input.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableReadOnly()
     * ```
     * Useful for fields whose values are computed, imported from a database, or
     * prefilled by software before being displayed to the user.
     */ PDFField.prototype.enableReadOnly = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$3600c95532547643).ReadOnly, true);
    };
    /**
     * Allow users to interact with this field and change its value in PDF
     * readers via mouse and keyboard input. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableReadOnly()
     * ```
     */ PDFField.prototype.disableReadOnly = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$3600c95532547643).ReadOnly, false);
    };
    /**
     * Returns `true` if this field must have a value when the form is submitted.
     * See [[PDFField.enableRequired]] and [[PDFField.disableRequired]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isRequired()) console.log('Field is required')
     * ```
     * @returns Whether or not this field is required.
     */ PDFField.prototype.isRequired = function() {
        return this.acroField.hasFlag((0, $ccb031b501604dea$export$3600c95532547643).Required);
    };
    /**
     * Require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableRequired()
     * ```
     */ PDFField.prototype.enableRequired = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$3600c95532547643).Required, true);
    };
    /**
     * Do not require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableRequired()
     * ```
     */ PDFField.prototype.disableRequired = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$3600c95532547643).Required, false);
    };
    /**
     * Returns `true` if this field's value should be exported when the form is
     * submitted. See [[PDFField.enableExporting]] and
     * [[PDFField.disableExporting]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isExported()) console.log('Exporting is enabled')
     * ```
     * @returns Whether or not this field's value should be exported.
     */ PDFField.prototype.isExported = function() {
        return !this.acroField.hasFlag((0, $ccb031b501604dea$export$3600c95532547643).NoExport);
    };
    /**
     * Indicate that this field's value should be exported when the form is
     * submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableExporting()
     * ```
     */ PDFField.prototype.enableExporting = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$3600c95532547643).NoExport, false);
    };
    /**
     * Indicate that this field's value should **not** be exported when the form
     * is submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableExporting()
     * ```
     */ PDFField.prototype.disableExporting = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$3600c95532547643).NoExport, true);
    };
    /** @ignore */ PDFField.prototype.needsAppearancesUpdate = function() {
        throw new (0, $6AcCU.MethodNotImplementedError)(this.constructor.name, 'needsAppearancesUpdate');
    };
    /** @ignore */ PDFField.prototype.defaultUpdateAppearances = function(_font) {
        throw new (0, $6AcCU.MethodNotImplementedError)(this.constructor.name, 'defaultUpdateAppearances');
    };
    PDFField.prototype.markAsDirty = function() {
        this.doc.getForm().markFieldAsDirty(this.ref);
    };
    PDFField.prototype.markAsClean = function() {
        this.doc.getForm().markFieldAsClean(this.ref);
    };
    PDFField.prototype.isDirty = function() {
        return this.doc.getForm().fieldIsDirty(this.ref);
    };
    PDFField.prototype.createWidget = function(options) {
        var _a;
        var textColor = options.textColor;
        var backgroundColor = options.backgroundColor;
        var borderColor = options.borderColor;
        var borderWidth = options.borderWidth;
        var degreesAngle = (0, $ea262ab75d90e986$export$56cb859c01fa134d)(options.rotate);
        var caption = options.caption;
        var x = options.x;
        var y = options.y;
        var width = options.width + borderWidth;
        var height = options.height + borderWidth;
        var hidden = Boolean(options.hidden);
        var pageRef = options.page;
        (0, $afaKe.assertMultiple)(degreesAngle, 'degreesAngle', 90);
        // Create a widget for this field
        var widget = (0, $67a3a0ae6b16125d$export$2e2bcd8739ae039).create(this.doc.context, this.ref);
        // Set widget properties
        var rect = (0, $ea262ab75d90e986$export$afddc3b8600307a4)({
            x: x,
            y: y,
            width: width,
            height: height
        }, borderWidth, degreesAngle);
        widget.setRectangle(rect);
        if (pageRef) widget.setP(pageRef);
        var ac = widget.getOrCreateAppearanceCharacteristics();
        if (backgroundColor) ac.setBackgroundColor((0, $a0c4165d43c51676$export$ffee2793812e3e56)(backgroundColor));
        ac.setRotation(degreesAngle);
        if (caption) ac.setCaptions({
            normal: caption
        });
        if (borderColor) ac.setBorderColor((0, $a0c4165d43c51676$export$ffee2793812e3e56)(borderColor));
        var bs = widget.getOrCreateBorderStyle();
        if (borderWidth !== undefined) bs.setWidth(borderWidth);
        widget.setFlagTo((0, $d9bf19078b097164$export$1fa7b68b35026177).Print, true);
        widget.setFlagTo((0, $d9bf19078b097164$export$1fa7b68b35026177).Hidden, hidden);
        widget.setFlagTo((0, $d9bf19078b097164$export$1fa7b68b35026177).Invisible, false);
        // Set acrofield properties
        if (textColor) {
            var da = (_a = this.acroField.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
            var newDa = da + '\n' + (0, $a0c4165d43c51676$export$6126e5d7ba707741)(textColor).toString();
            this.acroField.setDefaultAppearance(newDa);
        }
        return widget;
    };
    PDFField.prototype.updateWidgetAppearanceWithFont = function(widget, font, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceStream(widget, normal, font),
            rollover: rollover && this.createAppearanceStream(widget, rollover, font),
            down: down && this.createAppearanceStream(widget, down, font)
        });
    };
    PDFField.prototype.updateOnOffWidgetAppearance = function(widget, onValue, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceDict(widget, normal, onValue),
            rollover: rollover && this.createAppearanceDict(widget, rollover, onValue),
            down: down && this.createAppearanceDict(widget, down, onValue)
        });
    };
    PDFField.prototype.updateWidgetAppearances = function(widget, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        widget.setNormalAppearance(normal);
        if (rollover) widget.setRolloverAppearance(rollover);
        else widget.removeRolloverAppearance();
        if (down) widget.setDownAppearance(down);
        else widget.removeDownAppearance();
    };
    // // TODO: Do we need to do this...?
    // private foo(font: PDFFont, dict: PDFDict) {
    //   if (!dict.lookup(PDFName.of('DR'))) {
    //     dict.set(PDFName.of('DR'), dict.context.obj({}));
    //   }
    //   const DR = dict.lookup(PDFName.of('DR'), PDFDict);
    //   if (!DR.lookup(PDFName.of('Font'))) {
    //     DR.set(PDFName.of('Font'), dict.context.obj({}));
    //   }
    //   const Font = DR.lookup(PDFName.of('Font'), PDFDict);
    //   Font.set(PDFName.of(font.name), font.ref);
    // }
    PDFField.prototype.createAppearanceStream = function(widget, appearance, font) {
        var _a;
        var context = this.acroField.dict.context;
        var _b = widget.getRectangle(), width = _b.width, height = _b.height;
        // TODO: Do we need to do this...?
        // if (font) {
        //   this.foo(font, widget.dict);
        //   this.foo(font, this.doc.getForm().acroForm.dict);
        // }
        // END TODO
        var Resources = font && {
            Font: (_a = {}, _a[font.name] = font.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                width,
                height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        var streamRef = context.register(stream);
        return streamRef;
    };
    /**
     * Create a FormXObject of the supplied image and add it to context.
     * The FormXObject size is calculated based on the widget (including
     * the alignment).
     * @param widget The widget that should display the image.
     * @param alignment The alignment of the image.
     * @param image The image that should be displayed.
     * @returns The ref for the FormXObject that was added to the context.
     */ PDFField.prototype.createImageAppearanceStream = function(widget, image, alignment) {
        // NOTE: This implementation doesn't handle image borders.
        // NOTE: Acrobat seems to resize the image (maybe even skewing its aspect
        //       ratio) to fit perfectly within the widget's rectangle. This method
        //       does not currently do that. Should there be an option for that?
        var _a;
        var _b;
        var context = this.acroField.dict.context;
        var rectangle = widget.getRectangle();
        var ap = widget.getAppearanceCharacteristics();
        var bs = widget.getBorderStyle();
        var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
        var rotation = (0, $ea262ab75d90e986$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
        var rotate = (0, $4a8a6ab3e9d5c542$export$5dd9a0a87f38a2a6)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, rectangle), {
            rotation: rotation
        }));
        var adj = (0, $ea262ab75d90e986$export$312e44550db33c6a)(rectangle, rotation);
        var imageDims = image.scaleToFit(adj.width - borderWidth * 2, adj.height - borderWidth * 2);
        // Support borders on images and maybe other properties
        var options = {
            x: borderWidth,
            y: borderWidth,
            width: imageDims.width,
            height: imageDims.height,
            //
            rotate: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            xSkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            ySkew: (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0)
        };
        if (alignment === (0, $d0179262af07ed10$export$8efa99ca8f041e7e).Center) {
            options.x += (adj.width - borderWidth * 2) / 2 - imageDims.width / 2;
            options.y += (adj.height - borderWidth * 2) / 2 - imageDims.height / 2;
        } else if (alignment === (0, $d0179262af07ed10$export$8efa99ca8f041e7e).Right) {
            options.x = adj.width - borderWidth - imageDims.width;
            options.y = adj.height - borderWidth - imageDims.height;
        }
        var imageName = this.doc.context.addRandomSuffix('Image', 10);
        var appearance = (0, $47XJ3.__spreadArrays)(rotate, (0, $4a8a6ab3e9d5c542$export$21a059be5bfd5fb)(imageName, options));
        ////////////
        var Resources = {
            XObject: (_a = {}, _a[imageName] = image.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                rectangle.width,
                rectangle.height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        return context.register(stream);
    };
    PDFField.prototype.createAppearanceDict = function(widget, appearance, onValue) {
        var context = this.acroField.dict.context;
        var onStreamRef = this.createAppearanceStream(widget, appearance.on);
        var offStreamRef = this.createAppearanceStream(widget, appearance.off);
        var appearanceDict = context.obj({});
        appearanceDict.set(onValue, onStreamRef);
        appearanceDict.set((0, $2npvA.default).of('Off'), offStreamRef);
        return appearanceDict;
    };
    return PDFField;
}();
var $c15606bfc3a2beb4$export$2e2bcd8739ae039 = $c15606bfc3a2beb4$var$PDFField;



var $2npvA = parcelRequire("2npvA");
parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
/**
 * Represents a check box field of a [[PDFForm]].
 *
 * [[PDFCheckBox]] fields are interactive boxes that users can click with their
 * mouse. This type of [[PDFField]] has two states: `on` and `off`. The purpose
 * of a check box is to enable users to select from one or more options, where
 * each option is represented by a single check box. Check boxes are typically
 * square in shape and display a check mark when they are in the `on` state.
 */ var $003877d66834e0bd$var$PDFCheckBox = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFCheckBox, _super);
    function PDFCheckBox(acroCheckBox, ref, doc) {
        var _this = _super.call(this, acroCheckBox, ref, doc) || this;
        (0, $afaKe.assertIs)(acroCheckBox, 'acroCheckBox', [
            [
                (0, $c3b1375c30b7a81d$export$2e2bcd8739ae039),
                'PDFAcroCheckBox'
            ]
        ]);
        _this.acroField = acroCheckBox;
        return _this;
    }
    /**
     * Mark this check box. This operation is analogous to a human user clicking
     * a check box to fill it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been selected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.check()
     * ```
     *
     * This method will mark this check box as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a check mark inside the widgets of this check box
     * field.
     */ PDFCheckBox.prototype.check = function() {
        var _a;
        var onValue = (_a = this.acroField.getOnValue()) !== null && _a !== void 0 ? _a : (0, $2npvA.default).of('Yes');
        this.markAsDirty();
        this.acroField.setValue(onValue);
    };
    /**
     * Clears this check box. This operation is analogous to a human user clicking
     * a check box to unmark it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been deselected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was not selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.uncheck()
     * ```
     *
     * This method will mark this check box as dirty. See [[PDFCheckBox.check]]
     * for more details about what this means.
     */ PDFCheckBox.prototype.uncheck = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $2npvA.default).of('Off'));
    };
    /**
     * Returns `true` if this check box is selected (either by a human user via
     * a PDF reader, or else programmatically via software). For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.isChecked()) console.log('check box is selected')
     * ```
     * @returns Whether or not this check box is selected.
     */ PDFCheckBox.prototype.isChecked = function() {
        var onValue = this.acroField.getOnValue();
        return !!onValue && onValue === this.acroField.getValue();
    };
    /**
     * Show this check box on the specified page. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('some.checkBox.field')
     *
     * checkBox.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * })
     * ```
     * This will create a new widget for this check box field.
     * @param page The page to which this check box widget should be added.
     * @param options The options to be used when adding this check box widget.
     */ PDFCheckBox.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f;
        (0, $afaKe.assertIs)(page, 'page', [
            [
                (0, $b8eacf6334b41c1a$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $c15606bfc3a2beb4$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this check box
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        widget.setAppearanceState((0, $2npvA.default).of('Off'));
        this.updateWidgetAppearance(widget, (0, $2npvA.default).of('Yes'));
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this check box's widgets do not have an
     * appearance stream for its current state. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this check box needs an appearance update.
     */ PDFCheckBox.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $74b515754dab46b0$export$2e2bcd8739ae039))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the default appearance provider for check boxes. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.defaultUpdateAppearances()
     * ```
     */ PDFCheckBox.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for check boxs will be used. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *     down: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFCheckBox.prototype.updateAppearances = function(provider) {
        var _a;
        (0, $afaKe.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = (_a = widget.getOnValue()) !== null && _a !== void 0 ? _a : (0, $2npvA.default).of('Yes');
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
        this.markAsClean();
    };
    PDFCheckBox.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $9986a803db2c3c73$export$e11eab3ac6c06eb0);
        var appearances = (0, $9986a803db2c3c73$export$8a3aea031520d39b)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getCheckBox]] method, which will create an
     * > instance of [[PDFCheckBox]] for you.
     *
     * Create an instance of [[PDFCheckBox]] from an existing acroCheckBox and ref
     *
     * @param acroCheckBox The underlying `PDFAcroCheckBox` for this check box.
     * @param ref The unique reference for this check box.
     * @param doc The document to which this check box will belong.
     */ PDFCheckBox.of = function(acroCheckBox, ref, doc) {
        return new PDFCheckBox(acroCheckBox, ref, doc);
    };
    return PDFCheckBox;
}((0, $c15606bfc3a2beb4$export$2e2bcd8739ae039));
var $003877d66834e0bd$export$2e2bcd8739ae039 = $003877d66834e0bd$var$PDFCheckBox;



var $47XJ3 = parcelRequire("47XJ3");







parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
/**
 * Represents a dropdown field of a [[PDFForm]].
 *
 * [[PDFDropdown]] fields are interactive text boxes that display a single
 * element (the currently selected value). The purpose of a dropdown is to
 * enable users to select a single option from a set of possible options. Users
 * can click on a dropdown to view the full list of options it provides.
 * Clicking on an option in the list will cause it to be selected and displayed
 * in the dropdown's text box. Some dropdowns allow users to enter text
 * directly into the box from their keyboard, rather than only being allowed to
 * choose an option from the list (see [[PDFDropdown.isEditable]]).
 */ var $385dc023788ce819$var$PDFDropdown = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFDropdown, _super);
    function PDFDropdown(acroComboBox, ref, doc) {
        var _this = _super.call(this, acroComboBox, ref, doc) || this;
        (0, $afaKe.assertIs)(acroComboBox, 'acroComboBox', [
            [
                (0, $bf8a873fef9e7de8$export$2e2bcd8739ae039),
                'PDFAcroComboBox'
            ]
        ]);
        _this.acroField = acroComboBox;
        return _this;
    }
    /**
     * Get the list of available options for this dropdown. These options will be
     * displayed to users who click on this dropdown in a PDF reader.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const options = dropdown.getOptions()
     * console.log('Dropdown options:', options)
     * ```
     * @returns The options for this dropdown.
     */ PDFDropdown.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this dropdown. These are the values that were
     * selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const selections = dropdown.getSelected()
     * console.log('Dropdown selections:', selections)
     * ```
     * > **NOTE:** Note that PDF readers only display one selected option when
     * > rendering dropdowns. However, the PDF specification does allow for
     * > multiple values to be selected in a dropdown. As such, the `pdf-lib`
     * > API supports this. However, in most cases the array returned by this
     * > method will contain only a single element (or no elements).
     * @returns The selected options in this dropdown.
     */ PDFDropdown.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this dropdown. These are
     * the values that will be available for users to select when they view this
     * dropdown in a PDF reader. Note that preexisting options for this dropdown
     * will be removed. Only the values passed as `options` will be available to
     * select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('planets.dropdown')
     * dropdown.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     * @param options The options that should be available in this dropdown.
     */ PDFDropdown.prototype.setOptions = function(options) {
        (0, $afaKe.assertIs)(options, 'options', [
            Array
        ]);
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this dropdown. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this dropdown will
     * still be available for users to select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('rockets.dropdown')
     * dropdown.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * @param options New options that should be available in this dropdown.
     */ PDFDropdown.prototype.addOptions = function(options) {
        (0, $afaKe.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this dropdown. This operation is analogous
     * to a human user opening the dropdown in a PDF reader and clicking on a
     * value to select it. This method will update the underlying state of the
     * dropdown to indicate which values have been selected. PDF libraries and
     * readers will be able to extract these values from the saved document and
     * determine which values were selected.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('best.superhero.dropdown')
     * dropdown.select('One Punch Man')
     * ```
     *
     * This method will mark this dropdown as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the selected option inside the widgets of this dropdown.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if the selected option for this field
     * contains characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFDropdown.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * Selecting an option that does not exist in this dropdown's option list
     * (see [[PDFDropdown.getOptions]]) will enable editing on this dropdown
     * (see [[PDFDropdown.enableEditing]]).
     *
     * > **NOTE:** PDF readers only display one selected option when rendering
     * > dropdowns. However, the PDF specification does allow for multiple values
     * > to be selected in a dropdown. As such, the `pdf-lib` API supports this.
     * > However, it is not recommended to select more than one value with this
     * > method, as only one will be visible. [[PDFOptionList]] fields are better
     * > suited for displaying multiple selected values.
     *
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFDropdown.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $afaKe.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        (0, $afaKe.assertIs)(merge, 'merge', [
            'boolean'
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        var hasCustomOption = optionsArr.find(function(option) {
            return !validOptions.includes(option);
        });
        if (hasCustomOption) this.enableEditing();
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this dropdown. This operation is equivalent
     * to selecting an empty list. This method will update the underlying state
     * of the dropdown to indicate that no values have been selected.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.clear()
     * ```
     * This method will mark this text field as dirty. See [[PDFDropdown.select]]
     * for more details about what this means.
     */ PDFDropdown.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this dropdown. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.setFontSize(4)
     * dropdown.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFDropdown.prototype.setFontSize = function(fontSize) {
        (0, $afaKe.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if users are allowed to edit the selected value of this
     * dropdown directly and are not constrained by the list of available
     * options. See [[PDFDropdown.enableEditing]] and
     * [[PDFDropdown.disableEditing]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isEditable()) console.log('Editing is enabled')
     * ```
     * @returns Whether or not this dropdown is editable.
     */ PDFDropdown.prototype.isEditable = function() {
        return this.acroField.hasFlag((0, $ccb031b501604dea$export$eb88827058402599).Edit);
    };
    /**
     * Allow users to edit the selected value of this dropdown in PDF readers
     * with their keyboard. This means that the selected value of this dropdown
     * will not be constrained by the list of available options. However, if this
     * dropdown has any available options, users will still be allowed to select
     * from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableEditing()
     * ```
     */ PDFDropdown.prototype.enableEditing = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).Edit, true);
    };
    /**
     * Do not allow users to edit the selected value of this dropdown in PDF
     * readers with their keyboard. This will constrain the selected value of
     * this dropdown to the list of available options. Users will only be able
     * to select an option from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableEditing()
     * ```
     */ PDFDropdown.prototype.disableEditing = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).Edit, false);
    };
    /**
     * Returns `true` if the option list of this dropdown is always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the dropdown. See [[PDFDropdown.enableSorting]] and
     * [[PDFDropdown.disableSorting]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this dropdown's options are sorted.
     */ PDFDropdown.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $ccb031b501604dea$export$eb88827058402599).Sort);
    };
    /**
     * Always display the option list of this dropdown in alphabetical order,
     * irrespective of the order in which the options were added to this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSorting()
     * ```
     */ PDFDropdown.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).Sort, true);
    };
    /**
     * Do not always display the option list of this dropdown in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to the list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSorting()
     * ```
     */ PDFDropdown.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this dropdown's
     * option list. See [[PDFDropdown.enableMultiselect]] and
     * [[PDFDropdown.disableMultiselect]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFDropdown.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $ccb031b501604dea$export$eb88827058402599).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this dropdown's option
     * list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableMultiselect()
     * ```
     */ PDFDropdown.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this dropdown's
     * option list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableMultiselect()
     * ```
     */ PDFDropdown.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).MultiSelect, false);
    };
    /**
     * Returns `true` if the selected option should be spell checked by PDF
     * readers. Spell checking will only be performed if this dropdown allows
     * editing (see [[PDFDropdown.isEditable]]). See
     * [[PDFDropdown.enableSpellChecking]] and
     * [[PDFDropdown.disableSpellChecking]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this dropdown can be spell checked.
     */ PDFDropdown.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $ccb031b501604dea$export$eb88827058402599).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the selected option of this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSpellChecking()
     * ```
     */ PDFDropdown.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the selected option of this
     * dropdown. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSpellChecking()
     * ```
     */ PDFDropdown.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this dropdown field (by clicking
     * outside of it - on another field, for example). See
     * [[PDFDropdown.enableSelectOnClick]] and
     * [[PDFDropdown.disableSelectOnClick]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFDropdown.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $ccb031b501604dea$export$eb88827058402599).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this dropdown field (by clicking
     * outside of it - on another field, for example). For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this dropdown
     * field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).CommitOnSelChange, false);
    };
    /**
     * Show this dropdown on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('best.gundam')
     * dropdown.setOptions(['Exia', 'Dynames'])
     * dropdown.select('Exia')
     *
     * dropdown.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this dropdown field.
     * @param page The page to which this dropdown widget should be added.
     * @param options The options to be used when adding this dropdown widget.
     */ PDFDropdown.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $afaKe.assertIs)(page, 'page', [
            [
                (0, $b8eacf6334b41c1a$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $c15606bfc3a2beb4$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this dropdown
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this dropdown has been marked as dirty, or if any of
     * this dropdown's widgets do not have an appearance stream. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this dropdown needs an appearance update.
     */ PDFDropdown.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $1b80b011925bffc2$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the default appearance provider for dropdowns. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFDropdown.prototype.defaultUpdateAppearances = function(font) {
        (0, $afaKe.assertIs)(font, 'font', [
            [
                (0, $8a85d13aa5e04534$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for dropdowns will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFDropdown.prototype.updateAppearances = function(font, provider) {
        (0, $afaKe.assertIs)(font, 'font', [
            [
                (0, $8a85d13aa5e04534$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFDropdown.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $9986a803db2c3c73$export$90f1ca03d512ec5);
        var appearances = (0, $9986a803db2c3c73$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getDropdown]] method, which will create an
     * > instance of [[PDFDropdown]] for you.
     *
     * Create an instance of [[PDFDropdown]] from an existing acroComboBox and ref
     *
     * @param acroComboBox The underlying `PDFAcroComboBox` for this dropdown.
     * @param ref The unique reference for this dropdown.
     * @param doc The document to which this dropdown will belong.
     */ PDFDropdown.of = function(acroComboBox, ref, doc) {
        return new PDFDropdown(acroComboBox, ref, doc);
    };
    return PDFDropdown;
}((0, $c15606bfc3a2beb4$export$2e2bcd8739ae039));
var $385dc023788ce819$export$2e2bcd8739ae039 = $385dc023788ce819$var$PDFDropdown;



var $47XJ3 = parcelRequire("47XJ3");







parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
/**
 * Represents an option list field of a [[PDFForm]].
 *
 * [[PDFOptionList]] fields are interactive lists of options. The purpose of an
 * option list is to enable users to select one or more options from a set of
 * possible options. Users are able to see the full set of options without
 * first having to click on the field (though scrolling may be necessary).
 * Clicking an option in the list will cause it to be selected and displayed
 * with a highlighted background. Some option lists allow users to select
 * more than one option (see [[PDFOptionList.isMultiselect]]).
 */ var $400baa7c926c3078$var$PDFOptionList = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFOptionList, _super);
    function PDFOptionList(acroListBox, ref, doc) {
        var _this = _super.call(this, acroListBox, ref, doc) || this;
        (0, $afaKe.assertIs)(acroListBox, 'acroListBox', [
            [
                (0, $c262204623e264f5$export$2e2bcd8739ae039),
                'PDFAcroListBox'
            ]
        ]);
        _this.acroField = acroListBox;
        return _this;
    }
    /**
     * Get the list of available options for this option list. These options will
     * be displayed to users who view this option list in a PDF reader.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const options = optionList.getOptions()
     * console.log('Option List options:', options)
     * ```
     * @returns The options for this option list.
     */ PDFOptionList.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this option list. These are the values that
     * were selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const selections = optionList.getSelected()
     * console.log('Option List selections:', selections)
     * ```
     * @returns The selected options for this option list.
     */ PDFOptionList.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this option list. These are
     * the values that will be available for users to select when they view this
     * option list in a PDF reader. Note that preexisting options for this
     * option list will be removed. Only the values passed as `options` will be
     * available to select.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('planets.optionList')
     * optionList.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     *
     * This method will mark this option list as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the options this field contains inside the widgets of this text
     * field (with selected options highlighted).
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains any options
     * with characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFOptionList.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * @param options The options that should be available in this option list.
     */ PDFOptionList.prototype.setOptions = function(options) {
        (0, $afaKe.assertIs)(options, 'options', [
            Array
        ]);
        this.markAsDirty();
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this option list. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this option list
     * will still be available for users to select.
     * For example:
     * ```js
     * const optionList = form.getOptionList('rockets.optionList')
     * optionList.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options New options that should be available in this option list.
     */ PDFOptionList.prototype.addOptions = function(options) {
        (0, $afaKe.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        this.markAsDirty();
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this option list. This operation is analogous
     * to a human user opening the option list in a PDF reader and clicking on one
     * or more values to select them. This method will update the underlying state
     * of the option list to indicate which values have been selected. PDF
     * libraries and readers will be able to extract these values from the saved
     * document and determine which values were selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('best.superheroes.optionList')
     * optionList.select(['One Punch Man', 'Iron Man'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFOptionList.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $afaKe.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        (0, $afaKe.assertIs)(merge, 'merge', [
            'boolean'
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        (0, $afaKe.assertIsSubset)(optionsArr, 'option', validOptions);
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this option list. This operation is
     * equivalent to selecting an empty list. This method will update the
     * underlying state of the option list to indicate that no values have been
     * selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.clear()
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     */ PDFOptionList.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for the text in this field. There needs to be a
     * default appearance string (DA) set with a font value specified
     * for this to work. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4);
     * ```
     * @param fontSize The font size to set the font to.
     */ /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this option list. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4)
     * optionList.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFOptionList.prototype.setFontSize = function(fontSize) {
        (0, $afaKe.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if the options of this option list are always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the option list. See [[PDFOptionList.enableSorting]] and
     * [[PDFOptionList.disableSorting]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this option list is sorted.
     */ PDFOptionList.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $ccb031b501604dea$export$eb88827058402599).Sort);
    };
    /**
     * Always display the options of this option list in alphabetical order,
     * irrespective of the order in which the options were added to this option
     * list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSorting()
     * ```
     */ PDFOptionList.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).Sort, true);
    };
    /**
     * Do not always display the options of this option list in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to this option list. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSorting()
     * ```
     */ PDFOptionList.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this option list.
     * See [[PDFOptionList.enableMultiselect]] and
     * [[PDFOptionList.disableMultiselect]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFOptionList.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $ccb031b501604dea$export$eb88827058402599).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableMultiselect()
     * ```
     */ PDFOptionList.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableMultiselect()
     * ```
     */ PDFOptionList.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).MultiSelect, false);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this option list field (by
     * clicking outside of it - on another field, for example). See
     * [[PDFOptionList.enableSelectOnClick]] and
     * [[PDFOptionList.disableSelectOnClick]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFOptionList.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $ccb031b501604dea$export$eb88827058402599).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this option list field (by
     * clicking outside of it - on another field, for example). For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this option
     * list field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$eb88827058402599).CommitOnSelChange, false);
    };
    /**
     * Show this option list on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('best.gundams')
     * optionList.setOptions(['Exia', 'Dynames', 'Kyrios', 'Virtue'])
     * optionList.select(['Exia', 'Virtue'])
     *
     * optionList.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this option list field.
     * @param page The page to which this option list widget should be added.
     * @param options The options to be used when adding this option list widget.
     */ PDFOptionList.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $afaKe.assertIs)(page, 'page', [
            [
                (0, $b8eacf6334b41c1a$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $c15606bfc3a2beb4$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this option list
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this option list has been marked as dirty, or if any of
     * this option list's widgets do not have an appearance stream. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this option list needs an appearance update.
     */ PDFOptionList.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $1b80b011925bffc2$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the default appearance provider for option lists. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFOptionList.prototype.defaultUpdateAppearances = function(font) {
        (0, $afaKe.assertIs)(font, 'font', [
            [
                (0, $8a85d13aa5e04534$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for option lists will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawOptionList(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFOptionList.prototype.updateAppearances = function(font, provider) {
        (0, $afaKe.assertIs)(font, 'font', [
            [
                (0, $8a85d13aa5e04534$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFOptionList.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $9986a803db2c3c73$export$f9fab495286778d2);
        var appearances = (0, $9986a803db2c3c73$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create
     * > an instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroListBox and
     * ref
     *
     * @param acroComboBox The underlying `PDFAcroListBox` for this option list.
     * @param ref The unique reference for this option list.
     * @param doc The document to which this option list will belong.
     */ PDFOptionList.of = function(acroListBox, ref, doc) {
        return new PDFOptionList(acroListBox, ref, doc);
    };
    return PDFOptionList;
}((0, $c15606bfc3a2beb4$export$2e2bcd8739ae039));
var $400baa7c926c3078$export$2e2bcd8739ae039 = $400baa7c926c3078$var$PDFOptionList;



var $47XJ3 = parcelRequire("47XJ3");






var $2npvA = parcelRequire("2npvA");
parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
/**
 * Represents a radio group field of a [[PDFForm]].
 *
 * [[PDFRadioGroup]] fields are collections of radio buttons. The purpose of a
 * radio group is to enable users to select one option from a set of mutually
 * exclusive choices. Each choice in a radio group is represented by a radio
 * button. Radio buttons each have two states: `on` and `off`. At most one
 * radio button in a group may be in the `on` state at any time. Users can
 * click on a radio button to select it (and thereby automatically deselect any
 * other radio button that might have already been selected). Some radio
 * groups allow users to toggle a selected radio button `off` by clicking on
 * it (see [[PDFRadioGroup.isOffToggleable]]).
 *
 * Note that some radio groups allow multiple radio buttons to be in the `on`
 * state at the same type **if** they represent the same underlying value (see
 * [[PDFRadioGroup.isMutuallyExclusive]]).
 */ var $c73fe040b6d0f99e$var$PDFRadioGroup = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFRadioGroup, _super);
    function PDFRadioGroup(acroRadioButton, ref, doc) {
        var _this = _super.call(this, acroRadioButton, ref, doc) || this;
        (0, $afaKe.assertIs)(acroRadioButton, 'acroRadioButton', [
            [
                (0, $3aa58c09e70127a0$export$2e2bcd8739ae039),
                'PDFAcroRadioButton'
            ]
        ]);
        _this.acroField = acroRadioButton;
        return _this;
    }
    /**
     * Get the list of available options for this radio group. Each option is
     * represented by a radio button. These radio buttons are displayed at
     * various locations in the document, potentially on different pages (though
     * typically they are stacked horizontally or vertically on the same page).
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const options = radioGroup.getOptions()
     * console.log('Radio Group options:', options)
     * ```
     * @returns The options for this radio group.
     */ PDFRadioGroup.prototype.getOptions = function() {
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var exportOptions = new Array(exportValues.length);
            for(var idx = 0, len = exportValues.length; idx < len; idx++)exportOptions[idx] = exportValues[idx].decodeText();
            return exportOptions;
        }
        var onValues = this.acroField.getOnValues();
        var onOptions = new Array(onValues.length);
        for(var idx = 0, len = onOptions.length; idx < len; idx++)onOptions[idx] = onValues[idx].decodeText();
        return onOptions;
    };
    /**
     * Get the selected option for this radio group. The selected option is
     * represented by the radio button in this group that is turned on. At most
     * one radio button in a group can be selected. If no buttons in this group
     * are selected, `undefined` is returned.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const selected = radioGroup.getSelected()
     * console.log('Selected radio button:', selected)
     * ```
     * @returns The selected option for this radio group.
     */ PDFRadioGroup.prototype.getSelected = function() {
        var value = this.acroField.getValue();
        if (value === (0, $2npvA.default).of('Off')) return undefined;
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var onValues = this.acroField.getOnValues();
            for(var idx = 0, len = onValues.length; idx < len; idx++){
                if (onValues[idx] === value) return exportValues[idx].decodeText();
            }
        }
        return value.decodeText();
    };
    // // TODO: Figure out why this seems to crash Acrobat. Maybe it's because we
    // //       aren't removing the widget reference from the page's Annots?
    // removeOption(option: string) {
    //   assertIs(option, 'option', ['string']);
    //   // TODO: Assert is valid `option`!
    //   const onValues = this.acroField.getOnValues();
    //   const exportValues = this.acroField.getExportValues();
    //   if (exportValues) {
    //     for (let idx = 0, len = exportValues.length; idx < len; idx++) {
    //       if (exportValues[idx].decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   } else {
    //     for (let idx = 0, len = onValues.length; idx < len; idx++) {
    //       const value = onValues[idx];
    //       if (value.decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   }
    // }
    /**
     * Select an option for this radio group. This operation is analogous to a
     * human user clicking one of the radio buttons in this group via a PDF
     * reader to toggle it on. This method will update the underlying state of
     * the radio group to indicate which option has been selected. PDF libraries
     * and readers will be able to extract this value from the saved document and
     * determine which option was selected.
     *
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('best.superhero.radioGroup')
     * radioGroup.select('One Punch Man')
     * ```
     *
     * This method will mark this radio group as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a dot inside the widget of this check box field
     * that represents the selected option.
     *
     * @param option The option to be selected.
     */ PDFRadioGroup.prototype.select = function(option) {
        (0, $afaKe.assertIs)(option, 'option', [
            'string'
        ]);
        var validOptions = this.getOptions();
        (0, $afaKe.assertIsOneOf)(option, 'option', validOptions);
        this.markAsDirty();
        var onValues = this.acroField.getOnValues();
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            for(var idx = 0, len = exportValues.length; idx < len; idx++)if (exportValues[idx].decodeText() === option) this.acroField.setValue(onValues[idx]);
        } else for(var idx = 0, len = onValues.length; idx < len; idx++){
            var value = onValues[idx];
            if (value.decodeText() === option) this.acroField.setValue(value);
        }
    };
    /**
     * Clear any selected option for this dropdown. This will result in all
     * radio buttons in this group being toggled off. This method will update
     * the underlying state of the dropdown to indicate that no radio buttons
     * have been selected.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.clear()
     * ```
     * This method will mark this radio group as dirty. See
     * [[PDFRadioGroup.select]] for more details about what this means.
     */ PDFRadioGroup.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $2npvA.default).of('Off'));
    };
    /**
     * Returns `true` if users can click on radio buttons in this group to toggle
     * them off. The alternative is that once a user clicks on a radio button
     * to select it, the only way to deselect it is by selecting on another radio
     * button in the group. See [[PDFRadioGroup.enableOffToggling]] and
     * [[PDFRadioGroup.disableOffToggling]]. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isOffToggleable()) console.log('Off toggling is enabled')
     * ```
     */ PDFRadioGroup.prototype.isOffToggleable = function() {
        return !this.acroField.hasFlag((0, $ccb031b501604dea$export$59f660e89ffb4f8a).NoToggleToOff);
    };
    /**
     * Allow users to click on selected radio buttons in this group to toggle
     * them off. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableOffToggling()
     * ```
     * > **NOTE:** This feature is documented in the PDF specification
     * > (Table 226). However, most PDF readers do not respect this option and
     * > prevent users from toggling radio buttons off even when it is enabled.
     * > At the time of this writing (9/6/2020) Mac's Preview software did
     * > respect the option. Adobe Acrobat, Foxit Reader, and Google Chrome did
     * > not.
     */ PDFRadioGroup.prototype.enableOffToggling = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$59f660e89ffb4f8a).NoToggleToOff, false);
    };
    /**
     * Prevent users from clicking on selected radio buttons in this group to
     * toggle them off. Clicking on a selected radio button will have no effect.
     * The only way to deselect a selected radio button is to click on a
     * different radio button in the group. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableOffToggling()
     * ```
     */ PDFRadioGroup.prototype.disableOffToggling = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$59f660e89ffb4f8a).NoToggleToOff, true);
    };
    /**
     * Returns `true` if the radio buttons in this group are mutually exclusive.
     * This means that when the user selects a radio button, only that specific
     * button will be turned on. Even if other radio buttons in the group
     * represent the same value, they will not be enabled. The alternative to
     * this is that clicking a radio button will select that button along with
     * any other radio buttons in the group that share the same value. See
     * [[PDFRadioGroup.enableMutualExclusion]] and
     * [[PDFRadioGroup.disableMutualExclusion]].
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isMutuallyExclusive()) console.log('Mutual exclusion is enabled')
     * ```
     */ PDFRadioGroup.prototype.isMutuallyExclusive = function() {
        return !this.acroField.hasFlag((0, $ccb031b501604dea$export$59f660e89ffb4f8a).RadiosInUnison);
    };
    /**
     * When the user clicks a radio button in this group it will be selected. In
     * addition, any other radio buttons in this group that share the same
     * underlying value will also be selected. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableMutualExclusion()
     * ```
     * Note that this option must be enabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.enableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$59f660e89ffb4f8a).RadiosInUnison, false);
    };
    /**
     * When the user clicks a radio button in this group only it will be selected.
     * No other radio buttons in the group will be selected, even if they share
     * the same underlying value. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableMutualExclusion()
     * ```
     * Note that this option must be disabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.disableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$59f660e89ffb4f8a).RadiosInUnison, true);
    };
    /**
     * Add a new radio button to this group on the specified page. For example:
     * ```js
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('best.gundam')
     *
     * const options = {
     *   x: 50,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * }
     *
     * radioGroup.addOptionToPage('Exia', page, { ...options, y: 50 })
     * radioGroup.addOptionToPage('Dynames', page, { ...options, y: 110 })
     * ```
     * This will create a new radio button widget for this radio group field.
     * @param option The option that the radio button widget represents.
     * @param page The page to which the radio button widget should be added.
     * @param options The options to be used when adding the radio button widget.
     */ PDFRadioGroup.prototype.addOptionToPage = function(option, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        (0, $afaKe.assertIs)(option, 'option', [
            'string'
        ]);
        (0, $afaKe.assertIs)(page, 'page', [
            [
                (0, $b8eacf6334b41c1a$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $c15606bfc3a2beb4$export$55643210f1835a35)(options);
        // Create a widget for this radio button
        var widget = this.createWidget({
            x: (_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options === null || options === void 0 ? void 0 : options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options === null || options === void 0 ? void 0 : options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options === null || options === void 0 ? void 0 : options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: (_e = options === null || options === void 0 ? void 0 : options.textColor) !== null && _e !== void 0 ? _e : (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0),
            backgroundColor: (_f = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _f !== void 0 ? _f : (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(1, 1, 1),
            borderColor: (_g = options === null || options === void 0 ? void 0 : options.borderColor) !== null && _g !== void 0 ? _g : (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0),
            borderWidth: (_h = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _h !== void 0 ? _h : 1,
            rotate: (_j = options === null || options === void 0 ? void 0 : options.rotate) !== null && _j !== void 0 ? _j : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        var apStateValue = this.acroField.addWidgetWithOpt(widgetRef, (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(option), !this.isMutuallyExclusive());
        // Set appearance streams for widget
        widget.setAppearanceState((0, $2npvA.default).of('Off'));
        this.updateWidgetAppearance(widget, apStateValue);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this group's radio button widgets do not have an
     * appearance stream for their current state. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this radio group needs an appearance update.
     */ PDFRadioGroup.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $74b515754dab46b0$export$2e2bcd8739ae039))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the default appearance provider for radio groups. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.defaultUpdateAppearances()
     * ```
     */ PDFRadioGroup.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    // rg.updateAppearances((field: any, widget: any) => {
    //   assert(field === rg);
    //   assert(widget instanceof PDFWidgetAnnotation);
    //   return { on: [...rectangle, ...circle], off: [...rectangle, ...circle] };
    // });
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the given appearance provider. If no `provider` is passed, the
     * default appearance provider for radio groups will be used. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *     down: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFRadioGroup.prototype.updateAppearances = function(provider) {
        (0, $afaKe.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = widget.getOnValue();
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
    };
    PDFRadioGroup.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $9986a803db2c3c73$export$6440094330a99ef8);
        var appearances = (0, $9986a803db2c3c73$export$8a3aea031520d39b)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create an
     * > instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroRadioButton
     * and ref
     *
     * @param acroRadioButton The underlying `PDFAcroRadioButton` for this
     *                        radio group.
     * @param ref The unique reference for this radio group.
     * @param doc The document to which this radio group will belong.
     */ PDFRadioGroup.of = function(acroRadioButton, ref, doc) {
        return new PDFRadioGroup(acroRadioButton, ref, doc);
    };
    return PDFRadioGroup;
}((0, $c15606bfc3a2beb4$export$2e2bcd8739ae039));
var $c73fe040b6d0f99e$export$2e2bcd8739ae039 = $c73fe040b6d0f99e$var$PDFRadioGroup;



var $47XJ3 = parcelRequire("47XJ3");


parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
/**
 * Represents a signature field of a [[PDFForm]].
 *
 * [[PDFSignature]] fields are digital signatures. `pdf-lib` does not
 * currently provide any specialized APIs for creating digital signatures or
 * reading the contents of existing digital signatures.
 */ var $de4617bcb180f5e3$var$PDFSignature = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFSignature, _super);
    function PDFSignature(acroSignature, ref, doc) {
        var _this = _super.call(this, acroSignature, ref, doc) || this;
        (0, $afaKe.assertIs)(acroSignature, 'acroSignature', [
            [
                (0, $3bb4d5d3b9a6eaaa$export$2e2bcd8739ae039),
                'PDFAcroSignature'
            ]
        ]);
        _this.acroField = acroSignature;
        return _this;
    }
    PDFSignature.prototype.needsAppearancesUpdate = function() {
        return false;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getSignature]] method, which will create an
     * > instance of [[PDFSignature]] for you.
     *
     * Create an instance of [[PDFSignature]] from an existing acroSignature and
     * ref
     *
     * @param acroSignature The underlying `PDFAcroSignature` for this signature.
     * @param ref The unique reference for this signature.
     * @param doc The document to which this signature will belong.
     */ PDFSignature.of = function(acroSignature, ref, doc) {
        return new PDFSignature(acroSignature, ref, doc);
    };
    return PDFSignature;
}((0, $c15606bfc3a2beb4$export$2e2bcd8739ae039));
var $de4617bcb180f5e3$export$2e2bcd8739ae039 = $de4617bcb180f5e3$var$PDFSignature;



var $47XJ3 = parcelRequire("47XJ3");










parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
/**
 * Represents a text field of a [[PDFForm]].
 *
 * [[PDFTextField]] fields are boxes that display text entered by the user. The
 * purpose of a text field is to enable users to enter text or view text values
 * in the document prefilled by software. Users can click on a text field and
 * input text via their keyboard. Some text fields allow multiple lines of text
 * to be entered (see [[PDFTextField.isMultiline]]).
 */ var $1c6bd679e6b0e52b$var$PDFTextField = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFTextField, _super);
    function PDFTextField(acroText, ref, doc) {
        var _this = _super.call(this, acroText, ref, doc) || this;
        (0, $afaKe.assertIs)(acroText, 'acroText', [
            [
                (0, $197bdef3d7df2cfd$export$2e2bcd8739ae039),
                'PDFAcroText'
            ]
        ]);
        _this.acroField = acroText;
        return _this;
    }
    /**
     * Get the text that this field contains. This text is visible to users who
     * view this field in a PDF reader.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const text = textField.getText()
     * console.log('Text field contents:', text)
     * ```
     *
     * Note that if this text field contains no underlying value, `undefined`
     * will be returned. Text fields may also contain an underlying value that
     * is simply an empty string (`''`). This detail is largely irrelevant for
     * most applications. In general, you'll want to treat both cases the same
     * way and simply consider the text field to be empty. In either case, the
     * text field will appear empty to users when viewed in a PDF reader.
     *
     * An error will be thrown if this is a rich text field. `pdf-lib` does not
     * support reading rich text fields. Nor do most PDF readers and writers.
     * Rich text fields are based on XFA (XML Forms Architecture). Relatively few
     * PDFs use rich text fields or XFA. Unlike PDF itself, XFA is not an ISO
     * standard. XFA has been deprecated in PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     *
     * @returns The text contained in this text field.
     */ PDFTextField.prototype.getText = function() {
        var value = this.acroField.getValue();
        if (!value && this.isRichFormatted()) throw new (0, $246e6eb6d30233a0$export$f2fed572e1ed57ab)(this.getName());
        return value === null || value === void 0 ? void 0 : value.decodeText();
    };
    /**
     * Set the text for this field. This operation is analogous to a human user
     * clicking on the text field in a PDF reader and typing in text via their
     * keyboard. This method will update the underlying state of the text field
     * to indicate what text has been set. PDF libraries and readers will be able
     * to extract these values from the saved document and determine what text
     * was set.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('best.superhero.text.field')
     * textField.setText('One Punch Man')
     * ```
     *
     * This method will mark this text field as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the text this field contains inside the widgets of this text
     * field.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains text outside
     * the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFTextField.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * If this is a rich text field, it will be converted to a standard text
     * field in order to set the text. `pdf-lib` does not support writing rich
     * text strings. Nor do most PDF readers and writers. See
     * [[PDFTextField.getText]] for more information about rich text fields and
     * their deprecation in PDF 2.0.
     *
     * @param text The text this field should contain.
     */ PDFTextField.prototype.setText = function(text) {
        (0, $afaKe.assertOrUndefined)(text, 'text', [
            'string'
        ]);
        var maxLength = this.getMaxLength();
        if (maxLength !== undefined && text && text.length > maxLength) throw new (0, $246e6eb6d30233a0$export$1577e99040d42609)(text.length, maxLength, this.getName());
        this.markAsDirty();
        this.disableRichFormatting();
        if (text) this.acroField.setValue((0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(text));
        else this.acroField.removeValue();
    };
    /**
     * Get the alignment for this text field. This value represents the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const alignment = textField.getAlignment()
     * if (alignment === TextAlignment.Left) console.log('Text is left justified')
     * if (alignment === TextAlignment.Center) console.log('Text is centered')
     * if (alignment === TextAlignment.Right) console.log('Text is right justified')
     * ```
     * @returns The alignment of this text field.
     */ PDFTextField.prototype.getAlignment = function() {
        var quadding = this.acroField.getQuadding();
        // prettier-ignore
        return quadding === 0 ? (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Left : quadding === 1 ? (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Center : quadding === 2 ? (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Right : (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Left;
    };
    /**
     * Set the alignment for this text field. This will determine the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Text will be left justified when displayed
     * textField.setAlignment(TextAlignment.Left)
     *
     * // Text will be centered when displayed
     * textField.setAlignment(TextAlignment.Center)
     *
     * // Text will be right justified when displayed
     * textField.setAlignment(TextAlignment.Right)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param alignment The alignment for this text field.
     */ PDFTextField.prototype.setAlignment = function(alignment) {
        (0, $afaKe.assertIsOneOf)(alignment, 'alignment', (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f));
        this.markAsDirty();
        this.acroField.setQuadding(alignment);
    };
    /**
     * Get the maximum length of this field. This value represents the maximum
     * number of characters that can be typed into this field by the user. If
     * this field does not have a maximum length, `undefined` is returned.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const maxLength = textField.getMaxLength()
     * if (maxLength === undefined) console.log('No max length')
     * else console.log(`Max length is ${maxLength}`)
     * ```
     * @returns The maximum number of characters allowed in this field, or
     *          `undefined` if no limit exists.
     */ PDFTextField.prototype.getMaxLength = function() {
        return this.acroField.getMaxLength();
    };
    /**
     * Set the maximum length of this field. This limits the number of characters
     * that can be typed into this field by the user. This also limits the length
     * of the string that can be passed to [[PDFTextField.setText]]. This limit
     * can be removed by passing `undefined` as `maxLength`. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Allow between 0 and 5 characters to be entered
     * textField.setMaxLength(5)
     *
     * // Allow any number of characters to be entered
     * textField.setMaxLength(undefined)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param maxLength The maximum number of characters allowed in this field, or
     *                  `undefined` to remove the limit.
     */ PDFTextField.prototype.setMaxLength = function(maxLength) {
        (0, $afaKe.assertRangeOrUndefined)(maxLength, 'maxLength', 0, Number.MAX_SAFE_INTEGER);
        this.markAsDirty();
        if (maxLength === undefined) this.acroField.removeMaxLength();
        else {
            var text = this.getText();
            if (text && text.length > maxLength) throw new (0, $246e6eb6d30233a0$export$6da6c372180e79b0)(text.length, maxLength, this.getName());
            this.acroField.setMaxLength(maxLength);
        }
    };
    /**
     * Remove the maximum length for this text field. This allows any number of
     * characters to be typed into this field by the user. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.removeMaxLength()
     * ```
     * Calling this method is equivalent to passing `undefined` to
     * [[PDFTextField.setMaxLength]].
     */ PDFTextField.prototype.removeMaxLength = function() {
        this.markAsDirty();
        this.acroField.removeMaxLength();
    };
    /**
     * Display an image inside the bounds of this text field's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const textField = form.getTextField('some.text.field')
     * textField.setImage(pngImage)
     * ```
     * This will update the appearances streams for each of this text field's widgets.
     * @param image The image that should be displayed.
     */ PDFTextField.prototype.setImage = function(image) {
        var fieldAlignment = this.getAlignment();
        // prettier-ignore
        var alignment = fieldAlignment === (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Center ? (0, $d0179262af07ed10$export$8efa99ca8f041e7e).Center : fieldAlignment === (0, $5d0822d6fb71c4c5$export$84b2d1b68830363f).Right ? (0, $d0179262af07ed10$export$8efa99ca8f041e7e).Right : (0, $d0179262af07ed10$export$8efa99ca8f041e7e).Left;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this text field. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.setFontSize(4)
     * textField.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFTextField.prototype.setFontSize = function(fontSize) {
        (0, $afaKe.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if each line of text is shown on a new line when this
     * field is displayed in a PDF reader. The alternative is that all lines of
     * text are merged onto a single line when displayed. See
     * [[PDFTextField.enableMultiline]] and [[PDFTextField.disableMultiline]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isMultiline()) console.log('Multiline is enabled')
     * ```
     * @returns Whether or not this is a multiline text field.
     */ PDFTextField.prototype.isMultiline = function() {
        return this.acroField.hasFlag((0, $ccb031b501604dea$export$389fc7b97397dc8b).Multiline);
    };
    /**
     * Display each line of text on a new line when this field is displayed in a
     * PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$389fc7b97397dc8b).Multiline, true);
    };
    /**
     * Display each line of text on the same line when this field is displayed
     * in a PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$389fc7b97397dc8b).Multiline, false);
    };
    /**
     * Returns `true` if this is a password text field. This means that the field
     * is intended for storing a secure password. See
     * [[PDFTextField.enablePassword]] and [[PDFTextField.disablePassword]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isPassword()) console.log('Password is enabled')
     * ```
     * @returns Whether or not this is a password text field.
     */ PDFTextField.prototype.isPassword = function() {
        return this.acroField.hasFlag((0, $ccb031b501604dea$export$389fc7b97397dc8b).Password);
    };
    /**
     * Indicate that this text field is intended for storing a secure password.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enablePassword()
     * ```
     * Values entered into password text fields should not be displayed on the
     * screen by PDF readers. Most PDF readers will display the value as
     * asterisks or bullets. PDF readers should never store values entered by the
     * user into password text fields. Similarly, applications should not
     * write data to a password text field.
     *
     * **Please note that this method does not cause entered values to be
     * encrypted or secured in any way! It simply sets a flag that PDF software
     * and readers can access to determine the _purpose_ of this field.**
     */ PDFTextField.prototype.enablePassword = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$389fc7b97397dc8b).Password, true);
    };
    /**
     * Indicate that this text field is **not** intended for storing a secure
     * password. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disablePassword()
     * ```
     */ PDFTextField.prototype.disablePassword = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$389fc7b97397dc8b).Password, false);
    };
    /**
     * Returns `true` if the contents of this text field represent a file path.
     * See [[PDFTextField.enableFileSelection]] and
     * [[PDFTextField.disableFileSelection]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isFileSelector()) console.log('Is a file selector')
     * ```
     * @returns Whether or not this field should contain file paths.
     */ PDFTextField.prototype.isFileSelector = function() {
        return this.acroField.hasFlag((0, $ccb031b501604dea$export$389fc7b97397dc8b).FileSelect);
    };
    /**
     * Indicate that this text field is intended to store a file path. The
     * contents of the file stored at that path should be submitted as the value
     * of the field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableFileSelection()
     * ```
     */ PDFTextField.prototype.enableFileSelection = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$389fc7b97397dc8b).FileSelect, true);
    };
    /**
     * Indicate that this text field is **not** intended to store a file path.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableFileSelection()
     * ```
     */ PDFTextField.prototype.disableFileSelection = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$389fc7b97397dc8b).FileSelect, false);
    };
    /**
     * Returns `true` if the text entered in this field should be spell checked
     * by PDF readers. See [[PDFTextField.enableSpellChecking]] and
     * [[PDFTextField.disableSpellChecking]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this field should be spell checked.
     */ PDFTextField.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $ccb031b501604dea$export$389fc7b97397dc8b).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableSpellChecking()
     * ```
     */ PDFTextField.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$389fc7b97397dc8b).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableSpellChecking()
     * ```
     */ PDFTextField.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$389fc7b97397dc8b).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if PDF readers should allow the user to scroll the text
     * field when its contents do not fit within the field's view bounds. See
     * [[PDFTextField.enableScrolling]] and [[PDFTextField.disableScrolling]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isScrollable()) console.log('Scrolling is enabled')
     * ```
     * @returns Whether or not the field is scrollable in PDF readers.
     */ PDFTextField.prototype.isScrollable = function() {
        return !this.acroField.hasFlag((0, $ccb031b501604dea$export$389fc7b97397dc8b).DoNotScroll);
    };
    /**
     * Allow PDF readers to present a scroll bar to the user when the contents
     * of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableScrolling()
     * ```
     * A horizontal scroll bar should be shown for singleline fields. A vertical
     * scroll bar should be shown for multiline fields.
     */ PDFTextField.prototype.enableScrolling = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$389fc7b97397dc8b).DoNotScroll, false);
    };
    /**
     * Do not allow PDF readers to present a scroll bar to the user when the
     * contents of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableScrolling()
     * ```
     */ PDFTextField.prototype.disableScrolling = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$389fc7b97397dc8b).DoNotScroll, true);
    };
    /**
     * Returns `true` if this is a combed text field. This means that the field
     * is split into `n` equal size cells with one character in each (where `n`
     * is equal to the max length of the text field). The result is that all
     * characters in this field are displayed an equal distance apart from one
     * another. See [[PDFTextField.enableCombing]] and
     * [[PDFTextField.disableCombing]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isCombed()) console.log('Combing is enabled')
     * ```
     * Note that in order for a text field to be combed, the following must be
     * true (in addition to enabling combing):
     * * It must not be a multiline field (see [[PDFTextField.isMultiline]])
     * * It must not be a password field (see [[PDFTextField.isPassword]])
     * * It must not be a file selector field (see [[PDFTextField.isFileSelector]])
     * * It must have a max length defined (see [[PDFTextField.setMaxLength]])
     * @returns Whether or not this field is combed.
     */ PDFTextField.prototype.isCombed = function() {
        return this.acroField.hasFlag((0, $ccb031b501604dea$export$389fc7b97397dc8b).Comb) && !this.isMultiline() && !this.isPassword() && !this.isFileSelector() && this.getMaxLength() !== undefined;
    };
    /**
     * Split this field into `n` equal size cells with one character in each
     * (where `n` is equal to the max length of the text field). This will cause
     * all characters in the field to be displayed an equal distance apart from
     * one another. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableCombing()
     * ```
     *
     * In addition to calling this method, text fields must have a max length
     * defined in order to be combed (see [[PDFTextField.setMaxLength]]).
     *
     * This method will also call the following three methods internally:
     * * [[PDFTextField.disableMultiline]]
     * * [[PDFTextField.disablePassword]]
     * * [[PDFTextField.disableFileSelection]]
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableCombing = function() {
        if (this.getMaxLength() === undefined) {
            var msg = "PDFTextFields must have a max length in order to be combed";
            console.warn(msg);
        }
        this.markAsDirty();
        this.disableMultiline();
        this.disablePassword();
        this.disableFileSelection();
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$389fc7b97397dc8b).Comb, true);
    };
    /**
     * Turn off combing for this text field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableCombing()
     * ```
     * See [[PDFTextField.isCombed]] and [[PDFTextField.enableCombing]] for more
     * information about what combing is.
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableCombing = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$389fc7b97397dc8b).Comb, false);
    };
    /**
     * Returns `true` if this text field contains rich text. See
     * [[PDFTextField.enableRichFormatting]] and
     * [[PDFTextField.disableRichFormatting]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isRichFormatted()) console.log('Rich formatting enabled')
     * ```
     * @returns Whether or not this field contains rich text.
     */ PDFTextField.prototype.isRichFormatted = function() {
        return this.acroField.hasFlag((0, $ccb031b501604dea$export$389fc7b97397dc8b).RichText);
    };
    /**
     * Indicate that this field contains XFA data - or rich text. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableRichFormatting()
     * ```
     * Note that `pdf-lib` does not support reading or writing rich text fields.
     * Nor do most PDF readers and writers. Rich text fields are based on XFA
     * (XML Forms Architecture). Relatively few PDFs use rich text fields or XFA.
     * Unlike PDF itself, XFA is not an ISO standard. XFA has been deprecated in
     * PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     */ PDFTextField.prototype.enableRichFormatting = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$389fc7b97397dc8b).RichText, true);
    };
    /**
     * Indicate that this is a standard text field that does not XFA data (rich
     * text). For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableRichFormatting()
     * ```
     */ PDFTextField.prototype.disableRichFormatting = function() {
        this.acroField.setFlagTo((0, $ccb031b501604dea$export$389fc7b97397dc8b).RichText, false);
    };
    /**
     * Show this text field on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('best.gundam')
     * textField.setText('Exia')
     *
     * textField.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this text field.
     * @param page The page to which this text field widget should be added.
     * @param options The options to be used when adding this text field widget.
     */ PDFTextField.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $afaKe.assertIs)(page, 'page', [
            [
                (0, $b8eacf6334b41c1a$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $c15606bfc3a2beb4$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this text field
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this text field has been marked as dirty, or if any of
     * this text field's widgets do not have an appearance stream. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this text field needs an appearance update.
     */ PDFTextField.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $1b80b011925bffc2$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the default appearance provider for text fields. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFTextField.prototype.defaultUpdateAppearances = function(font) {
        (0, $afaKe.assertIs)(font, 'font', [
            [
                (0, $8a85d13aa5e04534$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for text fields will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFTextField.prototype.updateAppearances = function(font, provider) {
        (0, $afaKe.assertIs)(font, 'font', [
            [
                (0, $8a85d13aa5e04534$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    PDFTextField.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $9986a803db2c3c73$export$42ba95e6b8df3d7);
        var appearances = (0, $9986a803db2c3c73$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getTextField]] method, which will create an
     * > instance of [[PDFTextField]] for you.
     *
     * Create an instance of [[PDFTextField]] from an existing acroText and ref
     *
     * @param acroText The underlying `PDFAcroText` for this text field.
     * @param ref The unique reference for this text field.
     * @param doc The document to which this text field will belong.
     */ PDFTextField.of = function(acroText, ref, doc) {
        return new PDFTextField(acroText, ref, doc);
    };
    return PDFTextField;
}((0, $c15606bfc3a2beb4$export$2e2bcd8739ae039));
var $1c6bd679e6b0e52b$export$2e2bcd8739ae039 = $1c6bd679e6b0e52b$var$PDFTextField;




var $37c1c247d1a78dcd$export$7dcb046109e65a3d;
(function(StandardFonts) {
    StandardFonts["Courier"] = "Courier";
    StandardFonts["CourierBold"] = "Courier-Bold";
    StandardFonts["CourierOblique"] = "Courier-Oblique";
    StandardFonts["CourierBoldOblique"] = "Courier-BoldOblique";
    StandardFonts["Helvetica"] = "Helvetica";
    StandardFonts["HelveticaBold"] = "Helvetica-Bold";
    StandardFonts["HelveticaOblique"] = "Helvetica-Oblique";
    StandardFonts["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    StandardFonts["TimesRoman"] = "Times-Roman";
    StandardFonts["TimesRomanBold"] = "Times-Bold";
    StandardFonts["TimesRomanItalic"] = "Times-Italic";
    StandardFonts["TimesRomanBoldItalic"] = "Times-BoldItalic";
    StandardFonts["Symbol"] = "Symbol";
    StandardFonts["ZapfDingbats"] = "ZapfDingbats";
})($37c1c247d1a78dcd$export$7dcb046109e65a3d || ($37c1c247d1a78dcd$export$7dcb046109e65a3d = {}));





var $2npvA = parcelRequire("2npvA");
parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
var $fdd94 = parcelRequire("fdd94");
/**
 * Represents the interactive form of a [[PDFDocument]].
 *
 * Interactive forms (sometimes called _AcroForms_) are collections of fields
 * designed to gather information from a user. A PDF document may contains any
 * number of fields that appear on various pages, all of which make up a single,
 * global interactive form spanning the entire document. This means that
 * instances of [[PDFDocument]] shall contain at most one [[PDFForm]].
 *
 * The fields of an interactive form are represented by [[PDFField]] instances.
 */ var $65594680fabd4fa0$var$PDFForm = /** @class */ function() {
    function PDFForm(acroForm, doc) {
        var _this = this;
        this.embedDefaultFont = function() {
            return _this.doc.embedStandardFont((0, $37c1c247d1a78dcd$export$7dcb046109e65a3d).Helvetica);
        };
        (0, $afaKe.assertIs)(acroForm, 'acroForm', [
            [
                (0, $810a93aeb80d1ced$export$2e2bcd8739ae039),
                'PDFAcroForm'
            ]
        ]);
        (0, $afaKe.assertIs)(doc, 'doc', [
            [
                (0, $d524d17d41c918dc$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        this.acroForm = acroForm;
        this.doc = doc;
        this.dirtyFields = new Set();
        this.defaultFontCache = (0, $fdd94.default).populatedBy(this.embedDefaultFont);
    }
    /**
     * Returns `true` if this [[PDFForm]] has XFA data. Most PDFs with form
     * fields do not use XFA as it is not widely supported by PDF readers.
     *
     * > `pdf-lib` does not support creation, modification, or reading of XFA
     * > fields.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * if (form.hasXFA()) console.log('PDF has XFA data')
     * ```
     * @returns Whether or not this form has XFA data.
     */ PDFForm.prototype.hasXFA = function() {
        return this.acroForm.dict.has((0, $2npvA.default).of('XFA'));
    };
    /**
     * Disconnect the XFA data from this [[PDFForm]] (if any exists). This will
     * force readers to fallback to standard fields if the [[PDFDocument]]
     * contains any. For example:
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * form.deleteXFA()
     * ```
     */ PDFForm.prototype.deleteXFA = function() {
        this.acroForm.dict.delete((0, $2npvA.default).of('XFA'));
    };
    /**
     * Get all fields contained in this [[PDFForm]]. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns An array of all fields in this form.
     */ PDFForm.prototype.getFields = function() {
        var allFields = this.acroForm.getAllFields();
        var fields = [];
        for(var idx = 0, len = allFields.length; idx < len; idx++){
            var _a = allFields[idx], acroField = _a[0], ref = _a[1];
            var field = $65594680fabd4fa0$var$convertToPDFField(acroField, ref, this.doc);
            if (field) fields.push(field);
        }
        return fields;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getFieldMaybe('Page1.Foo.Bar[0]')
     * if (field) console.log('Field exists!')
     * ```
     * @param name A fully qualified field name.
     * @returns The field with the specified name, if one exists.
     */ PDFForm.prototype.getFieldMaybe = function(name) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.getName() === name) return field;
        }
        return undefined;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('Page1.Foo.Bar[0]')
     * ```
     * If no field exists with the provided name, an error will be thrown.
     * @param name A fully qualified field name.
     * @returns The field with the specified name.
     */ PDFForm.prototype.getField = function(name) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getFieldMaybe(name);
        if (field) return field;
        throw new (0, $246e6eb6d30233a0$export$5bc08baa4a027cbd)(name);
    };
    /**
     * Get the button field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const button = form.getButton('Page1.Foo.Button[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a button.
     * @param name A fully qualified button name.
     * @returns The button with the specified name.
     */ PDFForm.prototype.getButton = function(name) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $25554cdcac14ffa8$export$2e2bcd8739ae039)) return field;
        throw new (0, $246e6eb6d30233a0$export$8909da6c566ff652)(name, (0, $25554cdcac14ffa8$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const checkBox = form.getCheckBox('Page1.Foo.CheckBox[0]')
     * checkBox.check()
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a check box.
     * @param name A fully qualified check box name.
     * @returns The check box with the specified name.
     */ PDFForm.prototype.getCheckBox = function(name) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $003877d66834e0bd$export$2e2bcd8739ae039)) return field;
        throw new (0, $246e6eb6d30233a0$export$8909da6c566ff652)(name, (0, $003877d66834e0bd$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const dropdown = form.getDropdown('Page1.Foo.Dropdown[0]')
     * const options = dropdown.getOptions()
     * dropdown.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a dropdown.
     * @param name A fully qualified dropdown name.
     * @returns The dropdown with the specified name.
     */ PDFForm.prototype.getDropdown = function(name) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $385dc023788ce819$export$2e2bcd8739ae039)) return field;
        throw new (0, $246e6eb6d30233a0$export$8909da6c566ff652)(name, (0, $385dc023788ce819$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const optionList = form.getOptionList('Page1.Foo.OptionList[0]')
     * const options = optionList.getOptions()
     * optionList.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not an option list.
     * @param name A fully qualified option list name.
     * @returns The option list with the specified name.
     */ PDFForm.prototype.getOptionList = function(name) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $400baa7c926c3078$export$2e2bcd8739ae039)) return field;
        throw new (0, $246e6eb6d30233a0$export$8909da6c566ff652)(name, (0, $400baa7c926c3078$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const radioGroup = form.getRadioGroup('Page1.Foo.RadioGroup[0]')
     * const options = radioGroup.getOptions()
     * radioGroup.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a radio group.
     * @param name A fully qualified radio group name.
     * @returns The radio group with the specified name.
     */ PDFForm.prototype.getRadioGroup = function(name) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $c73fe040b6d0f99e$export$2e2bcd8739ae039)) return field;
        throw new (0, $246e6eb6d30233a0$export$8909da6c566ff652)(name, (0, $c73fe040b6d0f99e$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the signature field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const signature = form.getSignature('Page1.Foo.Signature[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a signature.
     * @param name A fully qualified signature name.
     * @returns The signature with the specified name.
     */ PDFForm.prototype.getSignature = function(name) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $de4617bcb180f5e3$export$2e2bcd8739ae039)) return field;
        throw new (0, $246e6eb6d30233a0$export$8909da6c566ff652)(name, (0, $de4617bcb180f5e3$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const textField = form.getTextField('Page1.Foo.TextField[0]')
     * textField.setText('Are you designed to act or to be acted upon?')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a text field.
     * @param name A fully qualified text field name.
     * @returns The text field with the specified name.
     */ PDFForm.prototype.getTextField = function(name) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $1c6bd679e6b0e52b$export$2e2bcd8739ae039)) return field;
        throw new (0, $246e6eb6d30233a0$export$8909da6c566ff652)(name, (0, $1c6bd679e6b0e52b$export$2e2bcd8739ae039), field);
    };
    /**
     * Create a new button field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('cool.new.button')
     *
     * button.addToPage('Do Stuff', font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new button.
     * @returns The new button field.
     */ PDFForm.prototype.createButton = function(name) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $65594680fabd4fa0$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var button = (0, $96dc99afef1c0142$export$2e2bcd8739ae039).create(this.doc.context);
        button.setPartialName(nameParts.terminal);
        $65594680fabd4fa0$var$addFieldToParent(parent, [
            button,
            button.ref
        ], nameParts.terminal);
        return (0, $25554cdcac14ffa8$export$2e2bcd8739ae039).of(button, button.ref, this.doc);
    };
    /**
     * Create a new check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('cool.new.checkBox')
     *
     * checkBox.addToPage(page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new check box.
     * @returns The new check box field.
     */ PDFForm.prototype.createCheckBox = function(name) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $65594680fabd4fa0$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var checkBox = (0, $c3b1375c30b7a81d$export$2e2bcd8739ae039).create(this.doc.context);
        checkBox.setPartialName(nameParts.terminal);
        $65594680fabd4fa0$var$addFieldToParent(parent, [
            checkBox,
            checkBox.ref
        ], nameParts.terminal);
        return (0, $003877d66834e0bd$export$2e2bcd8739ae039).of(checkBox, checkBox.ref, this.doc);
    };
    /**
     * Create a new dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('cool.new.dropdown')
     *
     * dropdown.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new dropdown.
     * @returns The new dropdown field.
     */ PDFForm.prototype.createDropdown = function(name) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $65594680fabd4fa0$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var comboBox = (0, $bf8a873fef9e7de8$export$2e2bcd8739ae039).create(this.doc.context);
        comboBox.setPartialName(nameParts.terminal);
        $65594680fabd4fa0$var$addFieldToParent(parent, [
            comboBox,
            comboBox.ref
        ], nameParts.terminal);
        return (0, $385dc023788ce819$export$2e2bcd8739ae039).of(comboBox, comboBox.ref, this.doc);
    };
    /**
     * Create a new option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('cool.new.optionList')
     *
     * optionList.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new option list.
     * @returns The new option list field.
     */ PDFForm.prototype.createOptionList = function(name) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $65594680fabd4fa0$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var listBox = (0, $c262204623e264f5$export$2e2bcd8739ae039).create(this.doc.context);
        listBox.setPartialName(nameParts.terminal);
        $65594680fabd4fa0$var$addFieldToParent(parent, [
            listBox,
            listBox.ref
        ], nameParts.terminal);
        return (0, $400baa7c926c3078$export$2e2bcd8739ae039).of(listBox, listBox.ref, this.doc);
    };
    /**
     * Create a new radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('cool.new.radioGroup')
     *
     * radioGroup.addOptionToPage('is-dog', page, { y: 0 })
     * radioGroup.addOptionToPage('is-cat', page, { y: 75 })
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createRadioGroup = function(name) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $65594680fabd4fa0$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var radioButton = (0, $3aa58c09e70127a0$export$2e2bcd8739ae039).create(this.doc.context);
        radioButton.setPartialName(nameParts.terminal);
        $65594680fabd4fa0$var$addFieldToParent(parent, [
            radioButton,
            radioButton.ref
        ], nameParts.terminal);
        return (0, $c73fe040b6d0f99e$export$2e2bcd8739ae039).of(radioButton, radioButton.ref, this.doc);
    };
    /**
     * Create a new text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('cool.new.textField')
     *
     * textField.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createTextField = function(name) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $65594680fabd4fa0$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var text = (0, $197bdef3d7df2cfd$export$2e2bcd8739ae039).create(this.doc.context);
        text.setPartialName(nameParts.terminal);
        $65594680fabd4fa0$var$addFieldToParent(parent, [
            text,
            text.ref
        ], nameParts.terminal);
        return (0, $1c6bd679e6b0e52b$export$2e2bcd8739ae039).of(text, text.ref, this.doc);
    };
    /**
     * Flatten all fields in this [[PDFForm]].
     *
     * Flattening a form field will take the current appearance for each of that
     * field's widgets and make them part of their page's content stream. All form
     * fields and annotations associated are then removed. Note that once a form
     * has been flattened its fields can no longer be accessed or edited.
     *
     * This operation is often used after filling form fields to ensure a
     * consistent appearance across different PDF readers and/or printers.
     * Another common use case is to copy a template document with form fields
     * into another document. In this scenario you would load the template
     * document, fill its fields, flatten it, and then copy its pages into the
     * recipient document - the filled fields will be copied over.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * form.flatten();
     * ```
     */ PDFForm.prototype.flatten = function(options) {
        if (options === void 0) options = {
            updateFieldAppearances: true
        };
        if (options.updateFieldAppearances) this.updateFieldAppearances();
        var fields = this.getFields();
        for(var i = 0, lenFields = fields.length; i < lenFields; i++){
            var field = fields[i];
            var widgets = field.acroField.getWidgets();
            for(var j = 0, lenWidgets = widgets.length; j < lenWidgets; j++){
                var widget = widgets[j];
                var page = this.findWidgetPage(widget);
                var widgetRef = this.findWidgetAppearanceRef(field, widget);
                var xObjectKey = page.node.newXObject('FlatWidget', widgetRef);
                var rectangle = widget.getRectangle();
                var operators = (0, $47XJ3.__spreadArrays)([
                    (0, $067caf076a00b79f$export$cb182c48e35739ac)(),
                    (0, $067caf076a00b79f$export$d73ee8ef04f5226a)(rectangle.x, rectangle.y)
                ], (0, $4a8a6ab3e9d5c542$export$5dd9a0a87f38a2a6)((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, rectangle), {
                    rotation: 0
                })), [
                    (0, $067caf076a00b79f$export$382c18f8bccd9e2b)(xObjectKey),
                    (0, $067caf076a00b79f$export$10581a6f45bf75eb)()
                ]).filter(Boolean);
                page.pushOperators.apply(page, operators);
            }
            this.removeField(field);
        }
    };
    /**
     * Remove a field from this [[PDFForm]].
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * const ageField = form.getFields().find(x => x.getName() === 'Age');
     * form.removeField(ageField);
     * ```
     */ PDFForm.prototype.removeField = function(field) {
        var widgets = field.acroField.getWidgets();
        var pages = new Set();
        for(var i = 0, len = widgets.length; i < len; i++){
            var widget = widgets[i];
            var widgetRef = this.findWidgetAppearanceRef(field, widget);
            var page = this.findWidgetPage(widget);
            pages.add(page);
            page.node.removeAnnot(widgetRef);
        }
        pages.forEach(function(page) {
            return page.node.removeAnnot(field.ref);
        });
        this.acroForm.removeField(field.acroField);
        var fieldKids = field.acroField.normalizedEntries().Kids;
        var kidsCount = fieldKids.size();
        for(var childIndex = 0; childIndex < kidsCount; childIndex++){
            var child = fieldKids.get(childIndex);
            if (child instanceof (0, $dac7b6b491336f5d$export$2e2bcd8739ae039)) this.doc.context.delete(child);
        }
        this.doc.context.delete(field.ref);
    };
    /**
     * Update the appearance streams for all widgets of all fields in this
     * [[PDFForm]]. Appearance streams will only be created for a widget if it
     * does not have any existing appearance streams, or the field's value has
     * changed (e.g. by calling [[PDFTextField.setText]] or
     * [[PDFDropdown.select]]).
     *
     * For example:
     * ```js
     * const courier = await pdfDoc.embedFont(StandardFonts.Courier)
     * const form = pdfDoc.getForm()
     * form.updateFieldAppearances(courier)
     * ```
     *
     * **IMPORTANT:** The default value for the `font` parameter is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if any fields contain text with
     * characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing that as the `font`
     * parameter allows you to generate appearance streams with non WinAnsi
     * characters (assuming your custom font supports them).
     *
     * > **NOTE:** The [[PDFDocument.save]] method will call this method to
     * > update appearances automatically if a form was accessed via the
     * > [[PDFDocument.getForm]] method prior to saving.
     *
     * @param font Optionally, the font to use when creating new appearances.
     */ PDFForm.prototype.updateFieldAppearances = function(font) {
        (0, $afaKe.assertOrUndefined)(font, 'font', [
            [
                (0, $8a85d13aa5e04534$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        font = font !== null && font !== void 0 ? font : this.getDefaultFont();
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.needsAppearancesUpdate()) field.defaultUpdateAppearances(font);
        }
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsDirty(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsDirty = function(fieldRef) {
        (0, $afaKe.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $dac7b6b491336f5d$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        this.dirtyFields.add(fieldRef);
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to not be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsClean(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsClean = function(fieldRef) {
        (0, $afaKe.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $dac7b6b491336f5d$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        this.dirtyFields.delete(fieldRef);
    };
    /**
     * Returns `true` is the specified field has been marked as dirty.
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * if (form.fieldIsDirty(field.ref)) console.log('Field is dirty')
     * ```
     * @param fieldRef The reference to the field that should be checked.
     * @returns Whether or not the specified field is dirty.
     */ PDFForm.prototype.fieldIsDirty = function(fieldRef) {
        (0, $afaKe.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $dac7b6b491336f5d$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        return this.dirtyFields.has(fieldRef);
    };
    PDFForm.prototype.getDefaultFont = function() {
        return this.defaultFontCache.access();
    };
    PDFForm.prototype.findWidgetPage = function(widget) {
        var pageRef = widget.P();
        var page = this.doc.getPages().find(function(x) {
            return x.ref === pageRef;
        });
        if (page === undefined) {
            var widgetRef = this.doc.context.getObjectRef(widget.dict);
            if (widgetRef === undefined) throw new Error('Could not find PDFRef for PDFObject');
            page = this.doc.findPageForAnnotationRef(widgetRef);
            if (page === undefined) throw new Error("Could not find page for PDFRef " + widgetRef);
        }
        return page;
    };
    PDFForm.prototype.findWidgetAppearanceRef = function(field, widget) {
        var _a;
        var refOrDict = widget.getNormalAppearance();
        if (refOrDict instanceof (0, $74b515754dab46b0$export$2e2bcd8739ae039) && (field instanceof (0, $003877d66834e0bd$export$2e2bcd8739ae039) || field instanceof (0, $c73fe040b6d0f99e$export$2e2bcd8739ae039))) {
            var value = field.acroField.getValue();
            var ref = (_a = refOrDict.get(value)) !== null && _a !== void 0 ? _a : refOrDict.get((0, $2npvA.default).of('Off'));
            if (ref instanceof (0, $dac7b6b491336f5d$export$2e2bcd8739ae039)) refOrDict = ref;
        }
        if (!(refOrDict instanceof (0, $dac7b6b491336f5d$export$2e2bcd8739ae039))) {
            var name_1 = field.getName();
            throw new Error("Failed to extract appearance ref for: " + name_1);
        }
        return refOrDict;
    };
    PDFForm.prototype.findOrCreateNonTerminals = function(partialNames) {
        var nonTerminal = [
            this.acroForm
        ];
        for(var idx = 0, len = partialNames.length; idx < len; idx++){
            var namePart = partialNames[idx];
            if (!namePart) throw new (0, $246e6eb6d30233a0$export$83c39fdacfe38500)(namePart);
            var parent_1 = nonTerminal[0], parentRef = nonTerminal[1];
            var res = this.findNonTerminal(namePart, parent_1);
            if (res) nonTerminal = res;
            else {
                var node = (0, $1416fe06ca3d86c2$export$2e2bcd8739ae039).create(this.doc.context);
                node.setPartialName(namePart);
                node.setParent(parentRef);
                var nodeRef = this.doc.context.register(node.dict);
                parent_1.addField(nodeRef);
                nonTerminal = [
                    node,
                    nodeRef
                ];
            }
        }
        return nonTerminal;
    };
    PDFForm.prototype.findNonTerminal = function(partialName, parent) {
        var fields = parent instanceof (0, $810a93aeb80d1ced$export$2e2bcd8739ae039) ? this.acroForm.getFields() : (0, $3ac6010d818efd71$export$34b4fb8893136c4c)(parent.Kids());
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var _a = fields[idx], field = _a[0], ref = _a[1];
            if (field.getPartialName() === partialName) {
                if (field instanceof (0, $1416fe06ca3d86c2$export$2e2bcd8739ae039)) return [
                    field,
                    ref
                ];
                throw new (0, $246e6eb6d30233a0$export$c428cfe4dc6c68df)(partialName);
            }
        }
        return undefined;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.getForm]] method, which will create an
     * > instance of [[PDFForm]] for you.
     *
     * Create an instance of [[PDFForm]] from an existing acroForm and embedder
     *
     * @param acroForm The underlying `PDFAcroForm` for this form.
     * @param doc The document to which the form will belong.
     */ PDFForm.of = function(acroForm, doc) {
        return new PDFForm(acroForm, doc);
    };
    return PDFForm;
}();
var $65594680fabd4fa0$export$2e2bcd8739ae039 = $65594680fabd4fa0$var$PDFForm;
var $65594680fabd4fa0$var$convertToPDFField = function(field, ref, doc) {
    if (field instanceof (0, $96dc99afef1c0142$export$2e2bcd8739ae039)) return (0, $25554cdcac14ffa8$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $c3b1375c30b7a81d$export$2e2bcd8739ae039)) return (0, $003877d66834e0bd$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $bf8a873fef9e7de8$export$2e2bcd8739ae039)) return (0, $385dc023788ce819$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $c262204623e264f5$export$2e2bcd8739ae039)) return (0, $400baa7c926c3078$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $197bdef3d7df2cfd$export$2e2bcd8739ae039)) return (0, $1c6bd679e6b0e52b$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $3aa58c09e70127a0$export$2e2bcd8739ae039)) return (0, $c73fe040b6d0f99e$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $3bb4d5d3b9a6eaaa$export$2e2bcd8739ae039)) return (0, $de4617bcb180f5e3$export$2e2bcd8739ae039).of(field, ref, doc);
    return undefined;
};
var $65594680fabd4fa0$var$splitFieldName = function(fullyQualifiedName) {
    if (fullyQualifiedName.length === 0) throw new Error('PDF field names must not be empty strings');
    var parts = fullyQualifiedName.split('.');
    for(var idx = 0, len = parts.length; idx < len; idx++){
        if (parts[idx] === '') throw new Error("Periods in PDF field names must be separated by at least one character: \"" + fullyQualifiedName + "\"");
    }
    if (parts.length === 1) return {
        nonTerminal: [],
        terminal: parts[0]
    };
    return {
        nonTerminal: parts.slice(0, parts.length - 1),
        terminal: parts[parts.length - 1]
    };
};
var $65594680fabd4fa0$var$addFieldToParent = function(_a, _b, partialName) {
    var parent = _a[0], parentRef = _a[1];
    var field = _b[0], fieldRef = _b[1];
    var entries = parent.normalizedEntries();
    var fields = (0, $3ac6010d818efd71$export$34b4fb8893136c4c)('Kids' in entries ? entries.Kids : entries.Fields);
    for(var idx = 0, len = fields.length; idx < len; idx++){
        if (fields[idx][0].getPartialName() === partialName) throw new (0, $246e6eb6d30233a0$export$c428cfe4dc6c68df)(partialName);
    }
    parent.addField(fieldRef);
    field.setParent(parentRef);
};


var $084ebd8507b51e87$export$b4a05ae367f5515c = {
    '4A0': [
        4767.87,
        6740.79
    ],
    '2A0': [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    Executive: [
        521.86,
        756.0
    ],
    Folio: [
        612.0,
        936.0
    ],
    Legal: [
        612.0,
        1008.0
    ],
    Letter: [
        612.0,
        792.0
    ],
    Tabloid: [
        792.0,
        1224.0
    ]
};



var $6AcCU = parcelRequire("6AcCU");
var $2npvA = parcelRequire("2npvA");
var $28a2438ee3e6bd83$export$ba19d141a3749548;
(function(ParseSpeeds) {
    ParseSpeeds[ParseSpeeds["Fastest"] = Infinity] = "Fastest";
    ParseSpeeds[ParseSpeeds["Fast"] = 1500] = "Fast";
    ParseSpeeds[ParseSpeeds["Medium"] = 500] = "Medium";
    ParseSpeeds[ParseSpeeds["Slow"] = 100] = "Slow";
})($28a2438ee3e6bd83$export$ba19d141a3749548 || ($28a2438ee3e6bd83$export$ba19d141a3749548 = {}));


parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
var $fdd94 = parcelRequire("fdd94");
var $4LYfy = parcelRequire("4LYfy");
var $aLhPo = parcelRequire("aLhPo");
var $5dg82 = parcelRequire("5dg82");


var $47XJ3 = parcelRequire("47XJ3");

var $6IKEk = parcelRequire("6IKEk");
var $2npvA = parcelRequire("2npvA");
/**
 * Represents a file that has been embedded in a [[PDFDocument]].
 */ var $1ff5da8e000b211d$var$PDFEmbeddedFile = /** @class */ function() {
    function PDFEmbeddedFile(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable files get embedded.
     *
     * Embed this embeddable file in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedFile.prototype.embed = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var ref, Names, EmbeddedFiles, EFNames, AF;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _a.sent();
                        if (!this.doc.catalog.has((0, $2npvA.default).of('Names'))) this.doc.catalog.set((0, $2npvA.default).of('Names'), this.doc.context.obj({}));
                        Names = this.doc.catalog.lookup((0, $2npvA.default).of('Names'), (0, $74b515754dab46b0$export$2e2bcd8739ae039));
                        if (!Names.has((0, $2npvA.default).of('EmbeddedFiles'))) Names.set((0, $2npvA.default).of('EmbeddedFiles'), this.doc.context.obj({}));
                        EmbeddedFiles = Names.lookup((0, $2npvA.default).of('EmbeddedFiles'), (0, $74b515754dab46b0$export$2e2bcd8739ae039));
                        if (!EmbeddedFiles.has((0, $2npvA.default).of('Names'))) EmbeddedFiles.set((0, $2npvA.default).of('Names'), this.doc.context.obj([]));
                        EFNames = EmbeddedFiles.lookup((0, $2npvA.default).of('Names'), (0, $6IKEk.default));
                        EFNames.push((0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(this.embedder.fileName));
                        EFNames.push(ref);
                        /**
                         * The AF-Tag is needed to achieve PDF-A3 compliance for embedded files
                         *
                         * The following document outlines the uses cases of the associated files (AF) tag.
                         * See:
                         * https://www.pdfa.org/wp-content/uploads/2018/10/PDF20_AN002-AF.pdf
                         */ if (!this.doc.catalog.has((0, $2npvA.default).of('AF'))) this.doc.catalog.set((0, $2npvA.default).of('AF'), this.doc.context.obj([]));
                        AF = this.doc.catalog.lookup((0, $2npvA.default).of('AF'), (0, $6IKEk.default));
                        AF.push(ref);
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.attach]] method, which will create
     * instances of [[PDFEmbeddedFile]] for you.
     *
     * Create an instance of [[PDFEmbeddedFile]] from an existing ref and embedder
     *
     * @param ref The unique reference for this file.
     * @param doc The document to which the file will belong.
     * @param embedder The embedder that will be used to embed the file.
     */ PDFEmbeddedFile.of = function(ref, doc, embedder) {
        return new PDFEmbeddedFile(ref, doc, embedder);
    };
    return PDFEmbeddedFile;
}();
var $1ff5da8e000b211d$export$2e2bcd8739ae039 = $1ff5da8e000b211d$var$PDFEmbeddedFile;



var $47XJ3 = parcelRequire("47XJ3");

var $6IKEk = parcelRequire("6IKEk");
var $2npvA = parcelRequire("2npvA");
/**
 * Represents JavaScript that has been embedded in a [[PDFDocument]].
 */ var $f18575c283f3f54e$var$PDFJavaScript = /** @class */ function() {
    function PDFJavaScript(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all JavaScripts get embedded.
     *
     * Embed this JavaScript in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFJavaScript.prototype.embed = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var _a, catalog, context, ref, Names, Javascript, JSNames;
            return (0, $47XJ3.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = this.doc, catalog = _a.catalog, context = _a.context;
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _b.sent();
                        if (!catalog.has((0, $2npvA.default).of('Names'))) catalog.set((0, $2npvA.default).of('Names'), context.obj({}));
                        Names = catalog.lookup((0, $2npvA.default).of('Names'), (0, $74b515754dab46b0$export$2e2bcd8739ae039));
                        if (!Names.has((0, $2npvA.default).of('JavaScript'))) Names.set((0, $2npvA.default).of('JavaScript'), context.obj({}));
                        Javascript = Names.lookup((0, $2npvA.default).of('JavaScript'), (0, $74b515754dab46b0$export$2e2bcd8739ae039));
                        if (!Javascript.has((0, $2npvA.default).of('Names'))) Javascript.set((0, $2npvA.default).of('Names'), context.obj([]));
                        JSNames = Javascript.lookup((0, $2npvA.default).of('Names'), (0, $6IKEk.default));
                        JSNames.push((0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(this.embedder.scriptName));
                        JSNames.push(ref);
                        this.alreadyEmbedded = true;
                        _b.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addJavaScript]] method, which will
     * create instances of [[PDFJavaScript]] for you.
     *
     * Create an instance of [[PDFJavaScript]] from an existing ref and script
     *
     * @param ref The unique reference for this script.
     * @param doc The document to which the script will belong.
     * @param embedder The embedder that will be used to embed the script.
     */ PDFJavaScript.of = function(ref, doc, embedder) {
        return new PDFJavaScript(ref, doc, embedder);
    };
    return PDFJavaScript;
}();
var $f18575c283f3f54e$export$2e2bcd8739ae039 = $f18575c283f3f54e$var$PDFJavaScript;



var $47XJ3 = parcelRequire("47XJ3");

var $f58abdb576ca812e$var$JavaScriptEmbedder = /** @class */ function() {
    function JavaScriptEmbedder(script, scriptName) {
        this.script = script;
        this.scriptName = scriptName;
    }
    JavaScriptEmbedder.for = function(script, scriptName) {
        return new JavaScriptEmbedder(script, scriptName);
    };
    JavaScriptEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var jsActionDict;
            return (0, $47XJ3.__generator)(this, function(_a) {
                jsActionDict = context.obj({
                    Type: 'Action',
                    S: 'JavaScript',
                    JS: (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(this.script)
                });
                if (ref) {
                    context.assign(ref, jsActionDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(jsActionDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JavaScriptEmbedder;
}();
var $f58abdb576ca812e$export$2e2bcd8739ae039 = $f58abdb576ca812e$var$JavaScriptEmbedder;


/**
 * Represents a PDF document.
 */ var $d524d17d41c918dc$var$PDFDocument = /** @class */ function() {
    function PDFDocument(context, ignoreEncryption, updateMetadata) {
        var _this = this;
        /** The default word breaks used in PDFPage.drawText */ this.defaultWordBreaks = [
            ' '
        ];
        this.computePages = function() {
            var pages = [];
            _this.catalog.Pages().traverse(function(node, ref) {
                if (node instanceof (0, $9575017b00e75ca2$export$2e2bcd8739ae039)) {
                    var page = _this.pageMap.get(node);
                    if (!page) {
                        page = (0, $b8eacf6334b41c1a$export$2e2bcd8739ae039).of(node, ref, _this);
                        _this.pageMap.set(node, page);
                    }
                    pages.push(page);
                }
            });
            return pages;
        };
        this.getOrCreateForm = function() {
            var acroForm = _this.catalog.getOrCreateAcroForm();
            return (0, $65594680fabd4fa0$export$2e2bcd8739ae039).of(acroForm, _this);
        };
        (0, $afaKe.assertIs)(context, 'context', [
            [
                (0, $68246e2808d5ea2f$export$2e2bcd8739ae039),
                'PDFContext'
            ]
        ]);
        (0, $afaKe.assertIs)(ignoreEncryption, 'ignoreEncryption', [
            'boolean'
        ]);
        this.context = context;
        this.catalog = context.lookup(context.trailerInfo.Root);
        this.isEncrypted = !!context.lookup(context.trailerInfo.Encrypt);
        this.pageCache = (0, $fdd94.default).populatedBy(this.computePages);
        this.pageMap = new Map();
        this.formCache = (0, $fdd94.default).populatedBy(this.getOrCreateForm);
        this.fonts = [];
        this.images = [];
        this.embeddedPages = [];
        this.embeddedFiles = [];
        this.javaScripts = [];
        if (!ignoreEncryption && this.isEncrypted) throw new (0, $246e6eb6d30233a0$export$20fcceeca2b098d2)();
        if (updateMetadata) this.updateInfoDict();
    }
    /**
     * Load an existing [[PDFDocument]]. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                               |
     * | ------------- | ------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PDF |
     * | `Uint8Array`  | The raw bytes of a PDF                                 |
     * | `ArrayBuffer` | The raw bytes of a PDF                                 |
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * // pdf=string
     * const base64 =
     *  'JVBERi0xLjcKJYGBgYEKCjUgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbm' +
     *  'd0aCAxMDQKPj4Kc3RyZWFtCniccwrhMlAAwaJ0Ln2P1Jyy1JLM5ERdc0MjCwUjE4WQNC4Q' +
     *  '6cNlCFZkqGCqYGSqEJLLZWNuYGZiZmbkYuZsZmlmZGRgZmluDCQNzc3NTM2NzdzMXMxMjQ' +
     *  'ztFEKyuEK0uFxDuAAOERdVCmVuZHN0cmVhbQplbmRvYmoKCjYgMCBvYmoKPDwKL0ZpbHRl' +
     *  'ciAvRmxhdGVEZWNvZGUKL1R5cGUgL09ialN0bQovTiA0Ci9GaXJzdCAyMAovTGVuZ3RoID' +
     *  'IxNQo+PgpzdHJlYW0KeJxVj9GqwjAMhu/zFHkBzTo3nCCCiiKIHPEICuJF3cKoSCu2E8/b' +
     *  '20wPIr1p8v9/8kVhgilmGfawX2CGaVrgcAi0/bsy0lrX7IGWpvJ4iJYEN3gEmrrGBlQwGs' +
     *  'HHO9VBX1wNrxAqMX87RBD5xpJuddqwd82tjAHxzV1U5LPgy52DKXWnr1Lheg+j/c/pzGVr' +
     *  'iqV0VlwZPXGPCJjElw/ybkwUmeoWgxesDXGhHJC/D/iikp1Av80ptKU0FdBEe25pPihAM1' +
     *  'u6ytgaaWfs2Hrz35CJT1+EWmAKZW5kc3RyZWFtCmVuZG9iagoKNyAwIG9iago8PAovU2l6' +
     *  'ZSA4Ci9Sb290IDIgMCBSCi9GaWx0ZXIgL0ZsYXRlRGVjb2RlCi9UeXBlIC9YUmVmCi9MZW' +
     *  '5ndGggMzgKL1cgWyAxIDIgMiBdCi9JbmRleCBbIDAgOCBdCj4+CnN0cmVhbQp4nBXEwREA' +
     *  'EBAEsCwz3vrvRmOOyyOoGhZdutHN2MT55fIAVocD+AplbmRzdHJlYW0KZW5kb2JqCgpzdG' +
     *  'FydHhyZWYKNTEwCiUlRU9G'
     *
     * const dataUri = 'data:application/pdf;base64,' + base64
     *
     * const pdfDoc1 = await PDFDocument.load(base64)
     * const pdfDoc2 = await PDFDocument.load(dataUri)
     *
     * // pdf=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('with_update_sections.pdf')
     * const pdfDoc3 = await PDFDocument.load(uint8Array)
     *
     * // pdf=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/with_update_sections.pdf'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const pdfDoc4 = await PDFDocument.load(arrayBuffer)
     *
     * ```
     *
     * @param pdf The input data containing a PDF document.
     * @param options The options to be used when loading the document.
     * @returns Resolves with a document loaded from the input.
     */ PDFDocument.load = function(pdf, options) {
        if (options === void 0) options = {};
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var _a, ignoreEncryption, _b, parseSpeed, _c, throwOnInvalidObject, _d, updateMetadata, _e, capNumbers, bytes, context;
            return (0, $47XJ3.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        _a = options.ignoreEncryption, ignoreEncryption = _a === void 0 ? false : _a, _b = options.parseSpeed, parseSpeed = _b === void 0 ? (0, $28a2438ee3e6bd83$export$ba19d141a3749548).Slow : _b, _c = options.throwOnInvalidObject, throwOnInvalidObject = _c === void 0 ? false : _c, _d = options.updateMetadata, updateMetadata = _d === void 0 ? true : _d, _e = options.capNumbers, capNumbers = _e === void 0 ? false : _e;
                        (0, $afaKe.assertIs)(pdf, 'pdf', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $afaKe.assertIs)(ignoreEncryption, 'ignoreEncryption', [
                            'boolean'
                        ]);
                        (0, $afaKe.assertIs)(parseSpeed, 'parseSpeed', [
                            'number'
                        ]);
                        (0, $afaKe.assertIs)(throwOnInvalidObject, 'throwOnInvalidObject', [
                            'boolean'
                        ]);
                        bytes = (0, $4LYfy.toUint8Array)(pdf);
                        return [
                            4 /*yield*/ ,
                            (0, $9b9a87c9eb1ad6d0$export$2e2bcd8739ae039).forBytesWithOptions(bytes, parseSpeed, throwOnInvalidObject, capNumbers).parseDocument()
                        ];
                    case 1:
                        context = _f.sent();
                        return [
                            2 /*return*/ ,
                            new PDFDocument(context, ignoreEncryption, updateMetadata)
                        ];
                }
            });
        });
    };
    /**
     * Create a new [[PDFDocument]].
     * @returns Resolves with the newly created document.
     */ PDFDocument.create = function(options) {
        if (options === void 0) options = {};
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var _a, updateMetadata, context, pageTree, pageTreeRef, catalog;
            return (0, $47XJ3.__generator)(this, function(_b) {
                _a = options.updateMetadata, updateMetadata = _a === void 0 ? true : _a;
                context = (0, $68246e2808d5ea2f$export$2e2bcd8739ae039).create();
                pageTree = (0, $bab5d6f3d67c8575$export$2e2bcd8739ae039).withContext(context);
                pageTreeRef = context.register(pageTree);
                catalog = (0, $1ce603ba86b90efd$export$2e2bcd8739ae039).withContextAndPages(context, pageTreeRef);
                context.trailerInfo.Root = context.register(catalog);
                return [
                    2 /*return*/ ,
                    new PDFDocument(context, false, updateMetadata)
                ];
            });
        });
    };
    /**
     * Register a fontkit instance. This must be done before custom fonts can
     * be embedded. See [here](https://github.com/Hopding/pdf-lib/tree/master#fontkit-installation)
     * for instructions on how to install and register a fontkit instance.
     *
     * > You do **not** need to call this method to embed standard fonts.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     * import fontkit from '@pdf-lib/fontkit'
     *
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.registerFontkit(fontkit)
     * ```
     *
     * @param fontkit The fontkit instance to be registered.
     */ PDFDocument.prototype.registerFontkit = function(fontkit) {
        this.fontkit = fontkit;
    };
    /**
     * Get the [[PDFForm]] containing all interactive fields for this document.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns The form for this document.
     */ PDFDocument.prototype.getForm = function() {
        var form = this.formCache.access();
        if (form.hasXFA()) {
            console.warn('Removing XFA form data as pdf-lib does not support reading or writing XFA');
            form.deleteXFA();
        }
        return form;
    };
    /**
     * Get this document's title metadata. The title appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const title = pdfDoc.getTitle()
     * ```
     * @returns A string containing the title of this document, if it has one.
     */ PDFDocument.prototype.getTitle = function() {
        var title = this.getInfoDict().lookup((0, $2npvA.default).Title);
        if (!title) return undefined;
        $d524d17d41c918dc$var$assertIsLiteralOrHexString(title);
        return title.decodeText();
    };
    /**
     * Get this document's author metadata. The author appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const author = pdfDoc.getAuthor()
     * ```
     * @returns A string containing the author of this document, if it has one.
     */ PDFDocument.prototype.getAuthor = function() {
        var author = this.getInfoDict().lookup((0, $2npvA.default).Author);
        if (!author) return undefined;
        $d524d17d41c918dc$var$assertIsLiteralOrHexString(author);
        return author.decodeText();
    };
    /**
     * Get this document's subject metadata. The subject appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const subject = pdfDoc.getSubject()
     * ```
     * @returns A string containing the subject of this document, if it has one.
     */ PDFDocument.prototype.getSubject = function() {
        var subject = this.getInfoDict().lookup((0, $2npvA.default).Subject);
        if (!subject) return undefined;
        $d524d17d41c918dc$var$assertIsLiteralOrHexString(subject);
        return subject.decodeText();
    };
    /**
     * Get this document's keywords metadata. The keywords appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const keywords = pdfDoc.getKeywords()
     * ```
     * @returns A string containing the keywords of this document, if it has any.
     */ PDFDocument.prototype.getKeywords = function() {
        var keywords = this.getInfoDict().lookup((0, $2npvA.default).Keywords);
        if (!keywords) return undefined;
        $d524d17d41c918dc$var$assertIsLiteralOrHexString(keywords);
        return keywords.decodeText();
    };
    /**
     * Get this document's creator metadata. The creator appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creator = pdfDoc.getCreator()
     * ```
     * @returns A string containing the creator of this document, if it has one.
     */ PDFDocument.prototype.getCreator = function() {
        var creator = this.getInfoDict().lookup((0, $2npvA.default).Creator);
        if (!creator) return undefined;
        $d524d17d41c918dc$var$assertIsLiteralOrHexString(creator);
        return creator.decodeText();
    };
    /**
     * Get this document's producer metadata. The producer appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const producer = pdfDoc.getProducer()
     * ```
     * @returns A string containing the producer of this document, if it has one.
     */ PDFDocument.prototype.getProducer = function() {
        var producer = this.getInfoDict().lookup((0, $2npvA.default).Producer);
        if (!producer) return undefined;
        $d524d17d41c918dc$var$assertIsLiteralOrHexString(producer);
        return producer.decodeText();
    };
    /**
     * Get this document's creation date metadata. The creation date appears in
     * the "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creationDate = pdfDoc.getCreationDate()
     * ```
     * @returns A Date containing the creation date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getCreationDate = function() {
        var creationDate = this.getInfoDict().lookup((0, $2npvA.default).CreationDate);
        if (!creationDate) return undefined;
        $d524d17d41c918dc$var$assertIsLiteralOrHexString(creationDate);
        return creationDate.decodeDate();
    };
    /**
     * Get this document's modification date metadata. The modification date
     * appears in the "Document Properties" section of most PDF readers.
     * For example:
     * ```js
     * const modification = pdfDoc.getModificationDate()
     * ```
     * @returns A Date containing the modification date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getModificationDate = function() {
        var modificationDate = this.getInfoDict().lookup((0, $2npvA.default).ModDate);
        if (!modificationDate) return undefined;
        $d524d17d41c918dc$var$assertIsLiteralOrHexString(modificationDate);
        return modificationDate.decodeDate();
    };
    /**
     * Set this document's title metadata. The title will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳')
     * ```
     *
     * To display the title in the window's title bar, set the
     * `showInWindowTitleBar` option to `true` (works for _most_ PDF readers).
     * For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳', { showInWindowTitleBar: true })
     * ```
     *
     * @param title The title of this document.
     * @param options The options to be used when setting the title.
     */ PDFDocument.prototype.setTitle = function(title, options) {
        (0, $afaKe.assertIs)(title, 'title', [
            'string'
        ]);
        var key = (0, $2npvA.default).of('Title');
        this.getInfoDict().set(key, (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(title));
        // Indicate that readers should display the title rather than the filename
        if (options === null || options === void 0 ? void 0 : options.showInWindowTitleBar) {
            var prefs = this.catalog.getOrCreateViewerPreferences();
            prefs.setDisplayDocTitle(true);
        }
    };
    /**
     * Set this document's author metadata. The author will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setAuthor('Humpty Dumpty')
     * ```
     * @param author The author of this document.
     */ PDFDocument.prototype.setAuthor = function(author) {
        (0, $afaKe.assertIs)(author, 'author', [
            'string'
        ]);
        var key = (0, $2npvA.default).of('Author');
        this.getInfoDict().set(key, (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(author));
    };
    /**
     * Set this document's subject metadata. The subject will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setSubject('📘 An Epic Tale of Woe 📖')
     * ```
     * @param subject The subject of this document.
     */ PDFDocument.prototype.setSubject = function(subject) {
        (0, $afaKe.assertIs)(subject, 'author', [
            'string'
        ]);
        var key = (0, $2npvA.default).of('Subject');
        this.getInfoDict().set(key, (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(subject));
    };
    /**
     * Set this document's keyword metadata. These keywords will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setKeywords(['eggs', 'wall', 'fall', 'king', 'horses', 'men'])
     * ```
     * @param keywords An array of keywords associated with this document.
     */ PDFDocument.prototype.setKeywords = function(keywords) {
        (0, $afaKe.assertIs)(keywords, 'keywords', [
            Array
        ]);
        var key = (0, $2npvA.default).of('Keywords');
        this.getInfoDict().set(key, (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(keywords.join(' ')));
    };
    /**
     * Set this document's creator metadata. The creator will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreator('PDF App 9000 🤖')
     * ```
     * @param creator The creator of this document.
     */ PDFDocument.prototype.setCreator = function(creator) {
        (0, $afaKe.assertIs)(creator, 'creator', [
            'string'
        ]);
        var key = (0, $2npvA.default).of('Creator');
        this.getInfoDict().set(key, (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(creator));
    };
    /**
     * Set this document's producer metadata. The producer will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setProducer('PDF App 9000 🤖')
     * ```
     * @param producer The producer of this document.
     */ PDFDocument.prototype.setProducer = function(producer) {
        (0, $afaKe.assertIs)(producer, 'creator', [
            'string'
        ]);
        var key = (0, $2npvA.default).of('Producer');
        this.getInfoDict().set(key, (0, $f752a7014a04a4bd$export$2e2bcd8739ae039).fromText(producer));
    };
    /**
     * Set this document's language metadata. The language will appear in the
     * "Document Properties" section of some PDF readers. For example:
     * ```js
     * pdfDoc.setLanguage('en-us')
     * ```
     *
     * @param language An RFC 3066 _Language-Tag_ denoting the language of this
     *                 document, or an empty string if the language is unknown.
     */ PDFDocument.prototype.setLanguage = function(language) {
        (0, $afaKe.assertIs)(language, 'language', [
            'string'
        ]);
        var key = (0, $2npvA.default).of('Lang');
        this.catalog.set(key, (0, $14cdd14f9837102b$export$2e2bcd8739ae039).of(language));
    };
    /**
     * Set this document's creation date metadata. The creation date will appear
     * in the "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreationDate(new Date())
     * ```
     * @param creationDate The date this document was created.
     */ PDFDocument.prototype.setCreationDate = function(creationDate) {
        (0, $afaKe.assertIs)(creationDate, 'creationDate', [
            [
                Date,
                'Date'
            ]
        ]);
        var key = (0, $2npvA.default).of('CreationDate');
        this.getInfoDict().set(key, (0, $14cdd14f9837102b$export$2e2bcd8739ae039).fromDate(creationDate));
    };
    /**
     * Set this document's modification date metadata. The modification date will
     * appear in the "Document Properties" section of most PDF readers. For
     * example:
     * ```js
     * pdfDoc.setModificationDate(new Date())
     * ```
     * @param modificationDate The date this document was last modified.
     */ PDFDocument.prototype.setModificationDate = function(modificationDate) {
        (0, $afaKe.assertIs)(modificationDate, 'modificationDate', [
            [
                Date,
                'Date'
            ]
        ]);
        var key = (0, $2npvA.default).of('ModDate');
        this.getInfoDict().set(key, (0, $14cdd14f9837102b$export$2e2bcd8739ae039).fromDate(modificationDate));
    };
    /**
     * Get the number of pages contained in this document. For example:
     * ```js
     * const totalPages = pdfDoc.getPageCount()
     * ```
     * @returns The number of pages in this document.
     */ PDFDocument.prototype.getPageCount = function() {
        if (this.pageCount === undefined) this.pageCount = this.getPages().length;
        return this.pageCount;
    };
    /**
     * Get an array of all the pages contained in this document. The pages are
     * stored in the array in the same order that they are rendered in the
     * document. For example:
     * ```js
     * const pages = pdfDoc.getPages()
     * pages[0]   // The first page of the document
     * pages[2]   // The third page of the document
     * pages[197] // The 198th page of the document
     * ```
     * @returns An array of all the pages contained in this document.
     */ PDFDocument.prototype.getPages = function() {
        return this.pageCache.access();
    };
    /**
     * Get the page rendered at a particular `index` of the document. For example:
     * ```js
     * pdfDoc.getPage(0)   // The first page of the document
     * pdfDoc.getPage(2)   // The third page of the document
     * pdfDoc.getPage(197) // The 198th page of the document
     * ```
     * @returns The [[PDFPage]] rendered at the given `index` of the document.
     */ PDFDocument.prototype.getPage = function(index) {
        var pages = this.getPages();
        (0, $afaKe.assertRange)(index, 'index', 0, pages.length - 1);
        return pages[index];
    };
    /**
     * Get an array of indices for all the pages contained in this document. The
     * array will contain a range of integers from
     * `0..pdfDoc.getPageCount() - 1`. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     *
     * const indices = pdfDoc.getPageIndices()
     * indices // => [0, 1, 2]
     * ```
     * @returns An array of indices for all pages contained in this document.
     */ PDFDocument.prototype.getPageIndices = function() {
        return (0, $4LYfy.range)(0, this.getPageCount());
    };
    /**
     * Remove the page at a given index from this document. For example:
     * ```js
     * pdfDoc.removePage(0)   // Remove the first page of the document
     * pdfDoc.removePage(2)   // Remove the third page of the document
     * pdfDoc.removePage(197) // Remove the 198th page of the document
     * ```
     * Once a page has been removed, it will no longer be rendered at that index
     * in the document.
     * @param index The index of the page to be removed.
     */ PDFDocument.prototype.removePage = function(index) {
        var pageCount = this.getPageCount();
        if (this.pageCount === 0) throw new (0, $246e6eb6d30233a0$export$cdca06c5927ddc2d)();
        (0, $afaKe.assertRange)(index, 'index', 0, pageCount - 1);
        this.catalog.removeLeafNode(index);
        this.pageCount = pageCount - 1;
    };
    /**
     * Add a page to the end of this document. This method accepts three
     * different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                            |
     * | ------------------ | ----------------------------------------------------------------------------------- |
     * | `undefined`        | Create a new page and add it to the end of this document                            |
     * | `[number, number]` | Create a new page with the given dimensions and add it to the end of this document  |
     * | `PDFPage`          | Add the existing page to the end of this document                                   |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.addPage()
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.addPage(PageSizes.A7)
     * const newPage2 = pdfDoc.addPage(PageSizes.Letter)
     * const newPage3 = pdfDoc.addPage([500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.addPage(existingPage)
     * ```
     *
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.addPage = function(page) {
        (0, $afaKe.assertIs)(page, 'page', [
            'undefined',
            [
                (0, $b8eacf6334b41c1a$export$2e2bcd8739ae039),
                'PDFPage'
            ],
            Array
        ]);
        return this.insertPage(this.getPageCount(), page);
    };
    /**
     * Insert a page at a given index within this document. This method accepts
     * three different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                       |
     * | ------------------ | ------------------------------------------------------------------------------ |
     * | `undefined`        | Create a new page and insert it into this document                             |
     * | `[number, number]` | Create a new page with the given dimensions and insert it into this document   |
     * | `PDFPage`          | Insert the existing page into this document                                    |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.insertPage(2)
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.insertPage(2, PageSizes.A7)
     * const newPage2 = pdfDoc.insertPage(0, PageSizes.Letter)
     * const newPage3 = pdfDoc.insertPage(198, [500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.insertPage(0, existingPage)
     * ```
     *
     * @param index The index at which the page should be inserted (zero-based).
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.insertPage = function(index, page) {
        var pageCount = this.getPageCount();
        (0, $afaKe.assertRange)(index, 'index', 0, pageCount);
        (0, $afaKe.assertIs)(page, 'page', [
            'undefined',
            [
                (0, $b8eacf6334b41c1a$export$2e2bcd8739ae039),
                'PDFPage'
            ],
            Array
        ]);
        if (!page || Array.isArray(page)) {
            var dims = Array.isArray(page) ? page : (0, $084ebd8507b51e87$export$b4a05ae367f5515c).A4;
            page = (0, $b8eacf6334b41c1a$export$2e2bcd8739ae039).create(this);
            page.setSize.apply(page, dims);
        } else if (page.doc !== this) throw new (0, $246e6eb6d30233a0$export$9564a4d28d94eae2)();
        var parentRef = this.catalog.insertLeafNode(page.ref, index);
        page.node.setParent(parentRef);
        this.pageMap.set(page.node, page);
        this.pageCache.invalidate();
        this.pageCount = pageCount + 1;
        return page;
    };
    /**
     * Copy pages from a source document into this document. Allows pages to be
     * copied between different [[PDFDocument]] instances. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * const srcDoc = await PDFDocument.load(...)
     *
     * const copiedPages = await pdfDoc.copyPages(srcDoc, [0, 3, 89])
     * const [firstPage, fourthPage, ninetiethPage] = copiedPages;
     *
     * pdfDoc.addPage(fourthPage)
     * pdfDoc.insertPage(0, ninetiethPage)
     * pdfDoc.addPage(firstPage)
     * ```
     * @param srcDoc The document from which pages should be copied.
     * @param indices The indices of the pages that should be copied.
     * @returns Resolves with an array of pages copied into this document.
     */ PDFDocument.prototype.copyPages = function(srcDoc, indices) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var copier, srcPages, copiedPages, idx, len, srcPage, copiedPage, ref;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $afaKe.assertIs)(srcDoc, 'srcDoc', [
                            [
                                PDFDocument,
                                'PDFDocument'
                            ]
                        ]);
                        (0, $afaKe.assertIs)(indices, 'indices', [
                            Array
                        ]);
                        return [
                            4 /*yield*/ ,
                            srcDoc.flush()
                        ];
                    case 1:
                        _a.sent();
                        copier = (0, $d3c799b1d361558a$export$2e2bcd8739ae039).for(srcDoc.context, this.context);
                        srcPages = srcDoc.getPages();
                        copiedPages = new Array(indices.length);
                        for(idx = 0, len = indices.length; idx < len; idx++){
                            srcPage = srcPages[indices[idx]];
                            copiedPage = copier.copy(srcPage.node);
                            ref = this.context.register(copiedPage);
                            copiedPages[idx] = (0, $b8eacf6334b41c1a$export$2e2bcd8739ae039).of(copiedPage, ref, this);
                        }
                        return [
                            2 /*return*/ ,
                            copiedPages
                        ];
                }
            });
        });
    };
    /**
     * Get a copy of this document.
     *
     * For example:
     * ```js
     * const srcDoc = await PDFDocument.load(...)
     * const pdfDoc = await srcDoc.copy()
     * ```
     *
     * > **NOTE:**  This method won't copy all information over to the new
     * > document (acroforms, outlines, etc...).
     *
     * @returns Resolves with a copy this document.
     */ PDFDocument.prototype.copy = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var pdfCopy, contentPages, idx, len;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.create()
                        ];
                    case 1:
                        pdfCopy = _a.sent();
                        return [
                            4 /*yield*/ ,
                            pdfCopy.copyPages(this, this.getPageIndices())
                        ];
                    case 2:
                        contentPages = _a.sent();
                        for(idx = 0, len = contentPages.length; idx < len; idx++)pdfCopy.addPage(contentPages[idx]);
                        if (this.getAuthor() !== undefined) pdfCopy.setAuthor(this.getAuthor());
                        if (this.getCreationDate() !== undefined) pdfCopy.setCreationDate(this.getCreationDate());
                        if (this.getCreator() !== undefined) pdfCopy.setCreator(this.getCreator());
                        if (this.getModificationDate() !== undefined) pdfCopy.setModificationDate(this.getModificationDate());
                        if (this.getProducer() !== undefined) pdfCopy.setProducer(this.getProducer());
                        if (this.getSubject() !== undefined) pdfCopy.setSubject(this.getSubject());
                        if (this.getTitle() !== undefined) pdfCopy.setTitle(this.getTitle());
                        pdfCopy.defaultWordBreaks = this.defaultWordBreaks;
                        return [
                            2 /*return*/ ,
                            pdfCopy
                        ];
                }
            });
        });
    };
    /**
     * Add JavaScript to this document. The supplied `script` is executed when the
     * document is opened. The `script` can be used to perform some operation
     * when the document is opened (e.g. logging to the console), or it can be
     * used to define a function that can be referenced later in a JavaScript
     * action. For example:
     * ```js
     * // Show "Hello World!" in the console when the PDF is opened
     * pdfDoc.addJavaScript(
     *   'main',
     *   'console.show(); console.println("Hello World!");'
     * );
     *
     * // Define a function named "foo" that can be called in JavaScript Actions
     * pdfDoc.addJavaScript(
     *   'foo',
     *   'function foo() { return "foo"; }'
     * );
     * ```
     * See the [JavaScript for Acrobat API Reference](https://www.adobe.com/content/dam/acom/en/devnet/acrobat/pdfs/js_api_reference.pdf)
     * for details.
     * @param name The name of the script. Must be unique per document.
     * @param script The JavaScript to execute.
     */ PDFDocument.prototype.addJavaScript = function(name, script) {
        (0, $afaKe.assertIs)(name, 'name', [
            'string'
        ]);
        (0, $afaKe.assertIs)(script, 'script', [
            'string'
        ]);
        var embedder = (0, $f58abdb576ca812e$export$2e2bcd8739ae039).for(script, name);
        var ref = this.context.nextRef();
        var javaScript = (0, $f18575c283f3f54e$export$2e2bcd8739ae039).of(ref, this, embedder);
        this.javaScripts.push(javaScript);
    };
    /**
     * Add an attachment to this document. Attachments are visible in the
     * "Attachments" panel of Adobe Acrobat and some other PDF readers. Any
     * type of file can be added as an attachment. This includes, but is not
     * limited to, `.png`, `.jpg`, `.pdf`, `.csv`, `.docx`, and `.xlsx` files.
     *
     * The input data can be provided in multiple formats:
     *
     * | Type          | Contents                                                       |
     * | ------------- | -------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing an attachment |
     * | `Uint8Array`  | The raw bytes of an attachment                                 |
     * | `ArrayBuffer` | The raw bytes of an attachment                                 |
     *
     * For example:
     * ```js
     * // attachment=string
     * await pdfDoc.attach('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * await pdfDoc.attach('data:image/jpeg;base64,/9j/4AAQ...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * await pdfDoc.attach(uint8Array, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * await pdfDoc.attach(arrayBuffer, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * ```
     *
     * @param attachment The input data containing the file to be attached.
     * @param name The name of the file to be attached.
     * @returns Resolves when the attachment is complete.
     */ PDFDocument.prototype.attach = function(attachment, name, options) {
        if (options === void 0) options = {};
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, embeddedFile;
            return (0, $47XJ3.__generator)(this, function(_a) {
                (0, $afaKe.assertIs)(attachment, 'attachment', [
                    'string',
                    Uint8Array,
                    ArrayBuffer
                ]);
                (0, $afaKe.assertIs)(name, 'name', [
                    'string'
                ]);
                (0, $afaKe.assertOrUndefined)(options.mimeType, 'mimeType', [
                    'string'
                ]);
                (0, $afaKe.assertOrUndefined)(options.description, 'description', [
                    'string'
                ]);
                (0, $afaKe.assertOrUndefined)(options.creationDate, 'options.creationDate', [
                    Date
                ]);
                (0, $afaKe.assertOrUndefined)(options.modificationDate, 'options.modificationDate', [
                    Date
                ]);
                (0, $afaKe.assertIsOneOfOrUndefined)(options.afRelationship, 'options.afRelationship', (0, $35d045ee31589a91$export$c12eac46fbec1b74));
                bytes = (0, $4LYfy.toUint8Array)(attachment);
                embedder = (0, $35d045ee31589a91$export$2e2bcd8739ae039).for(bytes, name, options);
                ref = this.context.nextRef();
                embeddedFile = (0, $1ff5da8e000b211d$export$2e2bcd8739ae039).of(ref, this, embedder);
                this.embeddedFiles.push(embeddedFile);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Embed a font into this document. The input data can be provided in multiple
     * formats:
     *
     * | Type            | Contents                                                |
     * | --------------- | ------------------------------------------------------- |
     * | `StandardFonts` | One of the standard 14 fonts                            |
     * | `string`        | A base64 encoded string (or data URI) containing a font |
     * | `Uint8Array`    | The raw bytes of a font                                 |
     * | `ArrayBuffer`   | The raw bytes of a font                                 |
     *
     * For example:
     * ```js
     * // font=StandardFonts
     * import { StandardFonts } from 'pdf-lib'
     * const font1 = await pdfDoc.embedFont(StandardFonts.Helvetica)
     *
     * // font=string
     * const font2 = await pdfDoc.embedFont('AAEAAAAVAQAABABQRFNJRx/upe...')
     * const font3 = await pdfDoc.embedFont('data:font/opentype;base64,AAEAAA...')
     *
     * // font=Uint8Array
     * import fs from 'fs'
     * const font4 = await pdfDoc.embedFont(fs.readFileSync('Ubuntu-R.ttf'))
     *
     * // font=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/ubuntu/Ubuntu-R.ttf'
     * const ubuntuBytes = await fetch(url).then(res => res.arrayBuffer())
     * const font5 = await pdfDoc.embedFont(ubuntuBytes)
     * ```
     * See also: [[registerFontkit]]
     * @param font The input data for a font.
     * @param options The options to be used when embedding the font.
     * @returns Resolves with the embedded font.
     */ PDFDocument.prototype.embedFont = function(font, options) {
        if (options === void 0) options = {};
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var _a, subset, customName, features, embedder, bytes, fontkit, _b, ref, pdfFont;
            return (0, $47XJ3.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = options.subset, subset = _a === void 0 ? false : _a, customName = options.customName, features = options.features;
                        (0, $afaKe.assertIs)(font, 'font', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $afaKe.assertIs)(subset, 'subset', [
                            'boolean'
                        ]);
                        if (!(0, $5dg82.isStandardFont)(font)) return [
                            3 /*break*/ ,
                            1
                        ];
                        embedder = (0, $d778657fca830008$export$2e2bcd8739ae039).for(font, customName);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 1:
                        if (!(0, $4LYfy.canBeConvertedToUint8Array)(font)) return [
                            3 /*break*/ ,
                            6
                        ];
                        bytes = (0, $4LYfy.toUint8Array)(font);
                        fontkit = this.assertFontkit();
                        if (!subset) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $a8abb68c47435824$export$2e2bcd8739ae039).for(fontkit, bytes, customName, features)
                        ];
                    case 2:
                        _b = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            (0, $0bb5e016ec464ab5$export$2e2bcd8739ae039).for(fontkit, bytes, customName, features)
                        ];
                    case 4:
                        _b = _c.sent();
                        _c.label = 5;
                    case 5:
                        embedder = _b;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        throw new TypeError('`font` must be one of `StandardFonts | string | Uint8Array | ArrayBuffer`');
                    case 7:
                        ref = this.context.nextRef();
                        pdfFont = (0, $8a85d13aa5e04534$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.fonts.push(pdfFont);
                        return [
                            2 /*return*/ ,
                            pdfFont
                        ];
                }
            });
        });
    };
    /**
     * Embed a standard font into this document.
     * For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     * const helveticaFont = pdfDoc.embedFont(StandardFonts.Helvetica)
     * ```
     * @param font The standard font to be embedded.
     * @param customName The name to be used when embedding the font.
     * @returns The embedded font.
     */ PDFDocument.prototype.embedStandardFont = function(font, customName) {
        (0, $afaKe.assertIs)(font, 'font', [
            'string'
        ]);
        if (!(0, $5dg82.isStandardFont)(font)) throw new TypeError('`font` must be one of type `StandardFonts`');
        var embedder = (0, $d778657fca830008$export$2e2bcd8739ae039).for(font, customName);
        var ref = this.context.nextRef();
        var pdfFont = (0, $8a85d13aa5e04534$export$2e2bcd8739ae039).of(ref, this, embedder);
        this.fonts.push(pdfFont);
        return pdfFont;
    };
    /**
     * Embed a JPEG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                      |
     * | ------------- | ------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing a JPEG image |
     * | `Uint8Array`  | The raw bytes of a JPEG image                                 |
     * | `ArrayBuffer` | The raw bytes of a JPEG image                                 |
     *
     * For example:
     * ```js
     * // jpg=string
     * const image1 = await pdfDoc.embedJpg('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...')
     * const image2 = await pdfDoc.embedJpg('data:image/jpeg;base64,/9j/4AAQ...')
     *
     * // jpg=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * const image3 = await pdfDoc.embedJpg(uint8Array)
     *
     * // jpg=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedJpg(arrayBuffer)
     * ```
     *
     * @param jpg The input data for a JPEG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedJpg = function(jpg) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $afaKe.assertIs)(jpg, 'jpg', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $4LYfy.toUint8Array)(jpg);
                        return [
                            4 /*yield*/ ,
                            (0, $8fc02cbbe0289d96$export$2e2bcd8739ae039).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $9503338f4d18fe05$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed a PNG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                     |
     * | ------------- | ------------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PNG image |
     * | `Uint8Array`  | The raw bytes of a PNG image                                 |
     * | `ArrayBuffer` | The raw bytes of a PNG image                                 |
     *
     * For example:
     * ```js
     * // png=string
     * const image1 = await pdfDoc.embedPng('iVBORw0KGgoAAAANSUhEUgAAAlgAAAF3...')
     * const image2 = await pdfDoc.embedPng('data:image/png;base64,iVBORw0KGg...')
     *
     * // png=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('small_mario.png')
     * const image3 = await pdfDoc.embedPng(uint8Array)
     *
     * // png=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/small_mario.png'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedPng(arrayBuffer)
     * ```
     *
     * @param png The input data for a PNG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedPng = function(png) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $afaKe.assertIs)(png, 'png', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $4LYfy.toUint8Array)(png);
                        return [
                            4 /*yield*/ ,
                            (0, $af70ed359aebef3f$export$2e2bcd8739ae039).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $9503338f4d18fe05$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 of `sourcePdf` into `pdfDoc`
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, [73])
     * ```
     *
     * See [[PDFDocument.load]] for examples of the allowed input data formats.
     *
     * @param pdf The input data containing a PDF document.
     * @param indices The indices of the pages that should be embedded.
     * @returns Resolves with an array of the embedded pages.
     */ PDFDocument.prototype.embedPdf = function(pdf, indices) {
        if (indices === void 0) indices = [
            0
        ];
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var srcDoc, _a, srcPages;
            return (0, $47XJ3.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (0, $afaKe.assertIs)(pdf, 'pdf', [
                            'string',
                            Uint8Array,
                            ArrayBuffer,
                            [
                                PDFDocument,
                                'PDFDocument'
                            ]
                        ]);
                        (0, $afaKe.assertIs)(indices, 'indices', [
                            Array
                        ]);
                        if (!(pdf instanceof PDFDocument)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = pdf;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.load(pdf)
                        ];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        srcDoc = _a;
                        srcPages = (0, $4LYfy.pluckIndices)(srcDoc.getPages(), indices);
                        return [
                            2 /*return*/ ,
                            this.embedPages(srcPages)
                        ];
                }
            });
        });
    };
    /**
     * Embed a single PDF page into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     * const sourcePdfPage = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPage = await pdfDoc.embedPage(
     *   sourcePdfPage,
     *
     *   // Clip a section of the source page so that we only embed part of it
     *   { left: 100, right: 450, bottom: 330, top: 570 },
     *
     *   // Translate all drawings of the embedded page by (10, 200) units
     *   [1, 0, 0, 1, 10, 200],
     * )
     * ```
     *
     * @param page The page to be embedded.
     * @param boundingBox
     * Optionally, an area of the source page that should be embedded
     * (defaults to entire page).
     * @param transformationMatrix
     * Optionally, a transformation matrix that is always applied to the embedded
     * page anywhere it is drawn.
     * @returns Resolves with the embedded pdf page.
     */ PDFDocument.prototype.embedPage = function(page, boundingBox, transformationMatrix) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var embeddedPage;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $afaKe.assertIs)(page, 'page', [
                            [
                                (0, $b8eacf6334b41c1a$export$2e2bcd8739ae039),
                                'PDFPage'
                            ]
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.embedPages([
                                page
                            ], [
                                boundingBox
                            ], [
                                transformationMatrix
                            ])
                        ];
                    case 1:
                        embeddedPage = _a.sent()[0];
                        return [
                            2 /*return*/ ,
                            embeddedPage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     *
     * const page1 = sourcePdfDoc.getPages()[0]
     * const page2 = sourcePdfDoc.getPages()[52]
     * const page3 = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPages = await pdfDoc.embedPages([page1, page2, page3])
     * ```
     *
     * @param page
     * The pages to be embedded (they must all share the same context).
     * @param boundingBoxes
     * Optionally, an array of clipping boundaries - one for each page
     * (defaults to entirety of each page).
     * @param transformationMatrices
     * Optionally, an array of transformation matrices - one for each page
     * (each page's transformation will apply anywhere it is drawn).
     * @returns Resolves with an array of the embedded pdf pages.
     */ PDFDocument.prototype.embedPages = function(pages, boundingBoxes, transformationMatrices) {
        if (boundingBoxes === void 0) boundingBoxes = [];
        if (transformationMatrices === void 0) transformationMatrices = [];
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var idx, len, currPage, nextPage, context, maybeCopyPage, embeddedPages, idx, len, page, box, matrix, embedder, ref;
            var _a;
            return (0, $47XJ3.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (pages.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        // Assert all pages have the same context
                        for(idx = 0, len = pages.length - 1; idx < len; idx++){
                            currPage = pages[idx];
                            nextPage = pages[idx + 1];
                            if (currPage.node.context !== nextPage.node.context) throw new (0, $6AcCU.PageEmbeddingMismatchedContextError)();
                        }
                        context = pages[0].node.context;
                        maybeCopyPage = context === this.context ? function(p) {
                            return p;
                        } : (0, $d3c799b1d361558a$export$2e2bcd8739ae039).for(context, this.context).copy;
                        embeddedPages = new Array(pages.length);
                        idx = 0, len = pages.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        page = maybeCopyPage(pages[idx].node);
                        box = boundingBoxes[idx];
                        matrix = transformationMatrices[idx];
                        return [
                            4 /*yield*/ ,
                            (0, $5b0b737ae7e3d3aa$export$2e2bcd8739ae039).for(page, box, matrix)
                        ];
                    case 2:
                        embedder = _b.sent();
                        ref = this.context.nextRef();
                        embeddedPages[idx] = (0, $7561c064649146d8$export$2e2bcd8739ae039).of(ref, this, embedder);
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        (_a = this.embeddedPages).push.apply(_a, embeddedPages);
                        return [
                            2 /*return*/ ,
                            embeddedPages
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You shouldn't need to call this method directly. The [[save]]
     * > and [[saveAsBase64]] methods will automatically ensure that all embedded
     * > assets are flushed before serializing the document.
     *
     * Flush all embedded fonts, PDF pages, and images to this document's
     * [[context]].
     *
     * @returns Resolves when the flush is complete.
     */ PDFDocument.prototype.flush = function() {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.fonts)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.images)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedPages)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedFiles)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.javaScripts)
                        ];
                    case 5:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to an array of bytes making up a PDF file.
     * For example:
     * ```js
     * const pdfBytes = await pdfDoc.save()
     * ```
     *
     * There are a number of things you can do with the serialized document,
     * depending on the JavaScript environment you're running in:
     * * Write it to a file in Node or React Native
     * * Download it as a Blob in the browser
     * * Render it in an `iframe`
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with the bytes of the serialized document.
     */ PDFDocument.prototype.save = function(options) {
        if (options === void 0) options = {};
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var _a, useObjectStreams, _b, addDefaultPage, _c, objectsPerTick, _d, updateFieldAppearances, form, Writer;
            return (0, $47XJ3.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.useObjectStreams, useObjectStreams = _a === void 0 ? true : _a, _b = options.addDefaultPage, addDefaultPage = _b === void 0 ? true : _b, _c = options.objectsPerTick, objectsPerTick = _c === void 0 ? 50 : _c, _d = options.updateFieldAppearances, updateFieldAppearances = _d === void 0 ? true : _d;
                        (0, $afaKe.assertIs)(useObjectStreams, 'useObjectStreams', [
                            'boolean'
                        ]);
                        (0, $afaKe.assertIs)(addDefaultPage, 'addDefaultPage', [
                            'boolean'
                        ]);
                        (0, $afaKe.assertIs)(objectsPerTick, 'objectsPerTick', [
                            'number'
                        ]);
                        (0, $afaKe.assertIs)(updateFieldAppearances, 'updateFieldAppearances', [
                            'boolean'
                        ]);
                        if (addDefaultPage && this.getPageCount() === 0) this.addPage();
                        if (updateFieldAppearances) {
                            form = this.formCache.getValue();
                            if (form) form.updateFieldAppearances();
                        }
                        return [
                            4 /*yield*/ ,
                            this.flush()
                        ];
                    case 1:
                        _e.sent();
                        Writer = useObjectStreams ? (0, $e0f5b824d34cbb80$export$2e2bcd8739ae039) : (0, $3b0651781259edc6$export$2e2bcd8739ae039);
                        return [
                            2 /*return*/ ,
                            Writer.forContext(this.context, objectsPerTick).serializeToBuffer()
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to a base64 encoded string or data URI making up a
     * PDF file. For example:
     * ```js
     * const base64String = await pdfDoc.saveAsBase64()
     * base64String // => 'JVBERi0xLjcKJYGBgYEKC...'
     *
     * const base64DataUri = await pdfDoc.saveAsBase64({ dataUri: true })
     * base64DataUri // => 'data:application/pdf;base64,JVBERi0xLjcKJYGBgYEKC...'
     * ```
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with a base64 encoded string or data URI of the
     *          serialized document.
     */ PDFDocument.prototype.saveAsBase64 = function(options) {
        if (options === void 0) options = {};
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var _a, dataUri, otherOptions, bytes, base64;
            return (0, $47XJ3.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = options.dataUri, dataUri = _a === void 0 ? false : _a, otherOptions = (0, $47XJ3.__rest)(options, [
                            "dataUri"
                        ]);
                        (0, $afaKe.assertIs)(dataUri, 'dataUri', [
                            'boolean'
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.save(otherOptions)
                        ];
                    case 1:
                        bytes = _b.sent();
                        base64 = (0, $aLhPo.encodeToBase64)(bytes);
                        return [
                            2 /*return*/ ,
                            dataUri ? "data:application/pdf;base64," + base64 : base64
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.findPageForAnnotationRef = function(ref) {
        var pages = this.getPages();
        for(var idx = 0, len = pages.length; idx < len; idx++){
            var page = pages[idx];
            var annotations = page.node.Annots();
            if ((annotations === null || annotations === void 0 ? void 0 : annotations.indexOf(ref)) !== undefined) return page;
        }
        return undefined;
    };
    PDFDocument.prototype.embedAll = function(embeddables) {
        return (0, $47XJ3.__awaiter)(this, void 0, void 0, function() {
            var idx, len;
            return (0, $47XJ3.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        idx = 0, len = embeddables.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            embeddables[idx].embed()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.updateInfoDict = function() {
        var pdfLib = "pdf-lib (https://github.com/Hopding/pdf-lib)";
        var now = new Date();
        var info = this.getInfoDict();
        this.setProducer(pdfLib);
        this.setModificationDate(now);
        if (!info.get((0, $2npvA.default).of('Creator'))) this.setCreator(pdfLib);
        if (!info.get((0, $2npvA.default).of('CreationDate'))) this.setCreationDate(now);
    };
    PDFDocument.prototype.getInfoDict = function() {
        var existingInfo = this.context.lookup(this.context.trailerInfo.Info);
        if (existingInfo instanceof (0, $74b515754dab46b0$export$2e2bcd8739ae039)) return existingInfo;
        var newInfo = this.context.obj({});
        this.context.trailerInfo.Info = this.context.register(newInfo);
        return newInfo;
    };
    PDFDocument.prototype.assertFontkit = function() {
        if (!this.fontkit) throw new (0, $246e6eb6d30233a0$export$529a7c74d0636a48)();
        return this.fontkit;
    };
    return PDFDocument;
}();
var $d524d17d41c918dc$export$2e2bcd8739ae039 = $d524d17d41c918dc$var$PDFDocument;
/* tslint:disable-next-line only-arrow-functions */ function $d524d17d41c918dc$var$assertIsLiteralOrHexString(pdfObject) {
    if (!(pdfObject instanceof (0, $f752a7014a04a4bd$export$2e2bcd8739ae039)) && !(pdfObject instanceof (0, $14cdd14f9837102b$export$2e2bcd8739ae039))) throw new (0, $6AcCU.UnexpectedObjectTypeError)([
        (0, $f752a7014a04a4bd$export$2e2bcd8739ae039),
        (0, $14cdd14f9837102b$export$2e2bcd8739ae039)
    ], pdfObject);
}





var $c2e0ec07cfbd64ac$export$c9b8fe72ac71821;
(function(BlendMode) {
    BlendMode["Normal"] = "Normal";
    BlendMode["Multiply"] = "Multiply";
    BlendMode["Screen"] = "Screen";
    BlendMode["Overlay"] = "Overlay";
    BlendMode["Darken"] = "Darken";
    BlendMode["Lighten"] = "Lighten";
    BlendMode["ColorDodge"] = "ColorDodge";
    BlendMode["ColorBurn"] = "ColorBurn";
    BlendMode["HardLight"] = "HardLight";
    BlendMode["SoftLight"] = "SoftLight";
    BlendMode["Difference"] = "Difference";
    BlendMode["Exclusion"] = "Exclusion";
})($c2e0ec07cfbd64ac$export$c9b8fe72ac71821 || ($c2e0ec07cfbd64ac$export$c9b8fe72ac71821 = {}));





var $6IKEk = parcelRequire("6IKEk");
var $2npvA = parcelRequire("2npvA");
parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
var $8ZzAZ = parcelRequire("8ZzAZ");
var $5dg82 = parcelRequire("5dg82");
/**
 * Represents a single page of a [[PDFDocument]].
 */ var $b8eacf6334b41c1a$var$PDFPage = /** @class */ function() {
    function PDFPage(leafNode, ref, doc) {
        this.fontSize = 24;
        this.fontColor = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
        this.lineHeight = 24;
        this.x = 0;
        this.y = 0;
        (0, $afaKe.assertIs)(leafNode, 'leafNode', [
            [
                (0, $9575017b00e75ca2$export$2e2bcd8739ae039),
                'PDFPageLeaf'
            ]
        ]);
        (0, $afaKe.assertIs)(ref, 'ref', [
            [
                (0, $dac7b6b491336f5d$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $afaKe.assertIs)(doc, 'doc', [
            [
                (0, $d524d17d41c918dc$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        this.node = leafNode;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Rotate this page by a multiple of 90 degrees. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * page.setRotation(degrees(-90))
     * page.setRotation(degrees(0))
     * page.setRotation(degrees(90))
     * page.setRotation(degrees(180))
     * page.setRotation(degrees(270))
     * ```
     * @param angle The angle to rotate this page.
     */ PDFPage.prototype.setRotation = function(angle) {
        var degreesAngle = (0, $ea262ab75d90e986$export$56cb859c01fa134d)(angle);
        (0, $afaKe.assertMultiple)(degreesAngle, 'degreesAngle', 90);
        this.node.set((0, $2npvA.default).of('Rotate'), this.doc.context.obj(degreesAngle));
    };
    /**
     * Get this page's rotation angle in degrees. For example:
     * ```js
     * const rotationAngle = page.getRotation().angle;
     * ```
     * @returns The rotation angle of the page in degrees (always a multiple of
     *          90 degrees).
     */ PDFPage.prototype.getRotation = function() {
        var Rotate = this.node.Rotate();
        return (0, $ea262ab75d90e986$export$41fc368e1a942b97)(Rotate ? Rotate.asNumber() : 0);
    };
    /**
     * Resize this page by increasing or decreasing its width and height. For
     * example:
     * ```js
     * page.setSize(250, 500)
     * page.setSize(page.getWidth() + 50, page.getHeight() + 100)
     * page.setSize(page.getWidth() - 50, page.getHeight() - 100)
     * ```
     *
     * Note that the PDF specification does not allow for pages to have explicit
     * widths and heights. Instead it defines the "size" of a page in terms of
     * five rectangles: the MediaBox, CropBox, BleedBox, TrimBox, and ArtBox. As a
     * result, this method cannot directly change the width and height of a page.
     * Instead, it works by adjusting these five boxes.
     *
     * This method performs the following steps:
     *   1. Set width & height of MediaBox.
     *   2. Set width & height of CropBox, if it has same dimensions as MediaBox.
     *   3. Set width & height of BleedBox, if it has same dimensions as MediaBox.
     *   4. Set width & height of TrimBox, if it has same dimensions as MediaBox.
     *   5. Set width & height of ArtBox, if it has same dimensions as MediaBox.
     *
     * This approach works well for most PDF documents as all PDF pages must
     * have a MediaBox, but relatively few have a CropBox, BleedBox, TrimBox, or
     * ArtBox. And when they do have these additional boxes, they often have the
     * same dimensions as the MediaBox. However, if you find this method does not
     * work for your document, consider setting the boxes directly:
     *   * [[PDFPage.setMediaBox]]
     *   * [[PDFPage.setCropBox]]
     *   * [[PDFPage.setBleedBox]]
     *   * [[PDFPage.setTrimBox]]
     *   * [[PDFPage.setArtBox]]
     *
     * @param width The new width of the page.
     * @param height The new height of the page.
     */ PDFPage.prototype.setSize = function(width, height) {
        (0, $afaKe.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $afaKe.assertIs)(height, 'height', [
            'number'
        ]);
        var mediaBox = this.getMediaBox();
        this.setMediaBox(mediaBox.x, mediaBox.y, width, height);
        var cropBox = this.getCropBox();
        var bleedBox = this.getBleedBox();
        var trimBox = this.getTrimBox();
        var artBox = this.getArtBox();
        var hasCropBox = this.node.CropBox();
        var hasBleedBox = this.node.BleedBox();
        var hasTrimBox = this.node.TrimBox();
        var hasArtBox = this.node.ArtBox();
        if (hasCropBox && (0, $5dg82.rectanglesAreEqual)(cropBox, mediaBox)) this.setCropBox(mediaBox.x, mediaBox.y, width, height);
        if (hasBleedBox && (0, $5dg82.rectanglesAreEqual)(bleedBox, mediaBox)) this.setBleedBox(mediaBox.x, mediaBox.y, width, height);
        if (hasTrimBox && (0, $5dg82.rectanglesAreEqual)(trimBox, mediaBox)) this.setTrimBox(mediaBox.x, mediaBox.y, width, height);
        if (hasArtBox && (0, $5dg82.rectanglesAreEqual)(artBox, mediaBox)) this.setArtBox(mediaBox.x, mediaBox.y, width, height);
    };
    /**
     * Resize this page by increasing or decreasing its width. For example:
     * ```js
     * page.setWidth(250)
     * page.setWidth(page.getWidth() + 50)
     * page.setWidth(page.getWidth() - 50)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's width.
     *
     * @param width The new width of the page.
     */ PDFPage.prototype.setWidth = function(width) {
        (0, $afaKe.assertIs)(width, 'width', [
            'number'
        ]);
        this.setSize(width, this.getSize().height);
    };
    /**
     * Resize this page by increasing or decreasing its height. For example:
     * ```js
     * page.setHeight(500)
     * page.setHeight(page.getWidth() + 100)
     * page.setHeight(page.getWidth() - 100)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's height.
     *
     * @param height The new height of the page.
     */ PDFPage.prototype.setHeight = function(height) {
        (0, $afaKe.assertIs)(height, 'height', [
            'number'
        ]);
        this.setSize(this.getSize().width, height);
    };
    /**
     * Set the MediaBox of this page. For example:
     * ```js
     * const mediaBox = page.getMediaBox()
     *
     * page.setMediaBox(0, 0, 250, 500)
     * page.setMediaBox(mediaBox.x, mediaBox.y, 50, 100)
     * page.setMediaBox(15, 5, mediaBox.width - 50, mediaBox.height - 100)
     * ```
     *
     * See [[PDFPage.getMediaBox]] for details about what the MediaBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new MediaBox.
     * @param y The y coordinate of the lower left corner of the new MediaBox.
     * @param width The width of the new MediaBox.
     * @param height The height of the new MediaBox.
     */ PDFPage.prototype.setMediaBox = function(x, y, width, height) {
        (0, $afaKe.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $afaKe.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $afaKe.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $afaKe.assertIs)(height, 'height', [
            'number'
        ]);
        var mediaBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $2npvA.default).MediaBox, mediaBox);
    };
    /**
     * Set the CropBox of this page. For example:
     * ```js
     * const cropBox = page.getCropBox()
     *
     * page.setCropBox(0, 0, 250, 500)
     * page.setCropBox(cropBox.x, cropBox.y, 50, 100)
     * page.setCropBox(15, 5, cropBox.width - 50, cropBox.height - 100)
     * ```
     *
     * See [[PDFPage.getCropBox]] for details about what the CropBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new CropBox.
     * @param y The y coordinate of the lower left corner of the new CropBox.
     * @param width The width of the new CropBox.
     * @param height The height of the new CropBox.
     */ PDFPage.prototype.setCropBox = function(x, y, width, height) {
        (0, $afaKe.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $afaKe.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $afaKe.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $afaKe.assertIs)(height, 'height', [
            'number'
        ]);
        var cropBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $2npvA.default).CropBox, cropBox);
    };
    /**
     * Set the BleedBox of this page. For example:
     * ```js
     * const bleedBox = page.getBleedBox()
     *
     * page.setBleedBox(0, 0, 250, 500)
     * page.setBleedBox(bleedBox.x, bleedBox.y, 50, 100)
     * page.setBleedBox(15, 5, bleedBox.width - 50, bleedBox.height - 100)
     * ```
     *
     * See [[PDFPage.getBleedBox]] for details about what the BleedBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new BleedBox.
     * @param y The y coordinate of the lower left corner of the new BleedBox.
     * @param width The width of the new BleedBox.
     * @param height The height of the new BleedBox.
     */ PDFPage.prototype.setBleedBox = function(x, y, width, height) {
        (0, $afaKe.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $afaKe.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $afaKe.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $afaKe.assertIs)(height, 'height', [
            'number'
        ]);
        var bleedBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $2npvA.default).BleedBox, bleedBox);
    };
    /**
     * Set the TrimBox of this page. For example:
     * ```js
     * const trimBox = page.getTrimBox()
     *
     * page.setTrimBox(0, 0, 250, 500)
     * page.setTrimBox(trimBox.x, trimBox.y, 50, 100)
     * page.setTrimBox(15, 5, trimBox.width - 50, trimBox.height - 100)
     * ```
     *
     * See [[PDFPage.getTrimBox]] for details about what the TrimBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new TrimBox.
     * @param y The y coordinate of the lower left corner of the new TrimBox.
     * @param width The width of the new TrimBox.
     * @param height The height of the new TrimBox.
     */ PDFPage.prototype.setTrimBox = function(x, y, width, height) {
        (0, $afaKe.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $afaKe.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $afaKe.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $afaKe.assertIs)(height, 'height', [
            'number'
        ]);
        var trimBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $2npvA.default).TrimBox, trimBox);
    };
    /**
     * Set the ArtBox of this page. For example:
     * ```js
     * const artBox = page.getArtBox()
     *
     * page.setArtBox(0, 0, 250, 500)
     * page.setArtBox(artBox.x, artBox.y, 50, 100)
     * page.setArtBox(15, 5, artBox.width - 50, artBox.height - 100)
     * ```
     *
     * See [[PDFPage.getArtBox]] for details about what the ArtBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new ArtBox.
     * @param y The y coordinate of the lower left corner of the new ArtBox.
     * @param width The width of the new ArtBox.
     * @param height The height of the new ArtBox.
     */ PDFPage.prototype.setArtBox = function(x, y, width, height) {
        (0, $afaKe.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $afaKe.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $afaKe.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $afaKe.assertIs)(height, 'height', [
            'number'
        ]);
        var artBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $2npvA.default).ArtBox, artBox);
    };
    /**
     * Get this page's width and height. For example:
     * ```js
     * const { width, height } = page.getSize()
     * ```
     *
     * This method uses [[PDFPage.getMediaBox]] to obtain the page's
     * width and height.
     *
     * @returns The width and height of the page.
     */ PDFPage.prototype.getSize = function() {
        var _a = this.getMediaBox(), width = _a.width, height = _a.height;
        return {
            width: width,
            height: height
        };
    };
    /**
     * Get this page's width. For example:
     * ```js
     * const width = page.getWidth()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The width of the page.
     */ PDFPage.prototype.getWidth = function() {
        return this.getSize().width;
    };
    /**
     * Get this page's height. For example:
     * ```js
     * const height = page.getHeight()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The height of the page.
     */ PDFPage.prototype.getHeight = function() {
        return this.getSize().height;
    };
    /**
     * Get the rectangle defining this page's MediaBox. For example:
     * ```js
     * const { x, y, width, height } = page.getMediaBox()
     * ```
     *
     * The MediaBox of a page defines the boundaries of the physical medium on
     * which the page is to be displayed/printed. It may include extended area
     * surrounding the page content for bleed marks, printing marks, etc...
     * It may also include areas close to the edges of the medium that cannot be
     * marked because of physical limitations of the output device. Content
     * falling outside this boundary may safely be discarded without affecting
     * the meaning of the PDF file.
     *
     * @returns An object defining the lower left corner of the MediaBox and its
     *          width & height.
     */ PDFPage.prototype.getMediaBox = function() {
        var mediaBox = this.node.MediaBox();
        return mediaBox.asRectangle();
    };
    /**
     * Get the rectangle defining this page's CropBox. For example:
     * ```js
     * const { x, y, width, height } = page.getCropBox()
     * ```
     *
     * The CropBox of a page defines the region to which the contents of the page
     * shall be clipped when displayed or printed. Unlike the other boxes, the
     * CropBox does not necessarily represent the physical page geometry. It
     * merely imposes clipping on the page contents.
     *
     * The CropBox's default value is the page's MediaBox.
     *
     * @returns An object defining the lower left corner of the CropBox and its
     *          width & height.
     */ PDFPage.prototype.getCropBox = function() {
        var _a;
        var cropBox = this.node.CropBox();
        return (_a = cropBox === null || cropBox === void 0 ? void 0 : cropBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getMediaBox();
    };
    /**
     * Get the rectangle defining this page's BleedBox. For example:
     * ```js
     * const { x, y, width, height } = page.getBleedBox()
     * ```
     *
     * The BleedBox of a page defines the region to which the contents of the
     * page shall be clipped when output in a production environment. This may
     * include any extra bleed area needed to accommodate the physical
     * limitations of cutting, folding, and trimming equipment. The actual
     * printed page may include printing marks that fall outside the BleedBox.
     *
     * The BleedBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the BleedBox and its
     *          width & height.
     */ PDFPage.prototype.getBleedBox = function() {
        var _a;
        var bleedBox = this.node.BleedBox();
        return (_a = bleedBox === null || bleedBox === void 0 ? void 0 : bleedBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's TrimBox. For example:
     * ```js
     * const { x, y, width, height } = page.getTrimBox()
     * ```
     *
     * The TrimBox of a page defines the intended dimensions of the finished
     * page after trimming. It may be smaller than the MediaBox to allow for
     * production-related content, such as printing instructions, cut marks, or
     * color bars.
     *
     * The TrimBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the TrimBox and its
     *          width & height.
     */ PDFPage.prototype.getTrimBox = function() {
        var _a;
        var trimBox = this.node.TrimBox();
        return (_a = trimBox === null || trimBox === void 0 ? void 0 : trimBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's ArtBox. For example:
     * ```js
     * const { x, y, width, height } = page.getArtBox()
     * ```
     *
     * The ArtBox of a page defines the extent of the page's meaningful content
     * (including potential white space).
     *
     * The ArtBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the ArtBox and its
     *          width & height.
     */ PDFPage.prototype.getArtBox = function() {
        var _a;
        var artBox = this.node.ArtBox();
        return (_a = artBox === null || artBox === void 0 ? void 0 : artBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Translate this page's content to a new location on the page. This operation
     * is often useful after resizing the page with [[setSize]]. For example:
     * ```js
     * // Add 50 units of whitespace to the top and right of the page
     * page.setSize(page.getWidth() + 50, page.getHeight() + 50)
     *
     * // Move the page's content from the lower-left corner of the page
     * // to the top-right corner.
     * page.translateContent(50, 50)
     *
     * // Now there are 50 units of whitespace to the left and bottom of the page
     * ```
     * See also: [[resetPosition]]
     * @param x The new position on the x-axis for this page's content.
     * @param y The new position on the y-axis for this page's content.
     */ PDFPage.prototype.translateContent = function(x, y) {
        (0, $afaKe.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $afaKe.assertIs)(y, 'y', [
            'number'
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $067caf076a00b79f$export$cb182c48e35739ac)(), (0, $067caf076a00b79f$export$d73ee8ef04f5226a)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $067caf076a00b79f$export$10581a6f45bf75eb)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the size, content, and annotations of a page.
     *
     * For example:
     * ```js
     * page.scale(0.5, 0.5);
     * ```
     *
     * @param x The factor by which the width for the page should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the height for the page should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scale = function(x, y) {
        (0, $afaKe.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $afaKe.assertIs)(y, 'y', [
            'number'
        ]);
        this.setSize(this.getWidth() * x, this.getHeight() * y);
        this.scaleContent(x, y);
        this.scaleAnnotations(x, y);
    };
    /**
     * Scale the content of a page. This is useful after resizing an existing
     * page. This scales only the content, not the annotations.
     *
     * For example:
     * ```js
     * // Bisect the size of the page
     * page.setSize(page.getWidth() / 2, page.getHeight() / 2);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     * ```
     * See also: [[scaleAnnotations]]
     * @param x The factor by which the x-axis for the content should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the content should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleContent = function(x, y) {
        (0, $afaKe.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $afaKe.assertIs)(y, 'y', [
            'number'
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $067caf076a00b79f$export$cb182c48e35739ac)(), (0, $067caf076a00b79f$export$dcdf75081b88279d)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $067caf076a00b79f$export$10581a6f45bf75eb)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the annotations of a page. This is useful if you want to scale a
     * page with comments or other annotations.
     * ```js
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleAnnotations(0.5, 0.5);
     * ```
     * See also: [[scaleContent]]
     * @param x The factor by which the x-axis for the annotations should be
     *          scaled (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the annotations should be
     *          scaled (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleAnnotations = function(x, y) {
        (0, $afaKe.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $afaKe.assertIs)(y, 'y', [
            'number'
        ]);
        var annots = this.node.Annots();
        if (!annots) return;
        for(var idx = 0; idx < annots.size(); idx++){
            var annot = annots.lookup(idx);
            if (annot instanceof (0, $74b515754dab46b0$export$2e2bcd8739ae039)) this.scaleAnnot(annot, x, y);
        }
    };
    /**
     * Reset the x and y coordinates of this page to `(0, 0)`. This operation is
     * often useful after calling [[translateContent]]. For example:
     * ```js
     * // Shift the page's contents up and to the right by 50 units
     * page.translateContent(50, 50)
     *
     * // This text will shifted - it will be drawn at (50, 50)
     * page.drawText('I am shifted')
     *
     * // Move back to (0, 0)
     * page.resetPosition()
     *
     * // This text will not be shifted - it will be drawn at (0, 0)
     * page.drawText('I am not shifted')
     * ```
     */ PDFPage.prototype.resetPosition = function() {
        this.getContentStream(false);
        this.x = 0;
        this.y = 0;
    };
    /**
     * Choose a default font for this page. The default font will be used whenever
     * text is drawn on this page and no font is specified. For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     *
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const courierFont = await pdfDoc.embedFont(StandardFonts.Courier)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     * page.drawText('I will be drawn in Helvetica')
     *
     * page.setFont(timesRomanFont)
     * page.drawText('I will be drawn in Courier', { font: courierFont })
     * ```
     * @param font The default font to be used when drawing text on this page.
     */ PDFPage.prototype.setFont = function(font) {
        // TODO: Reuse image Font name if we've already added this image to Resources.Fonts
        (0, $afaKe.assertIs)(font, 'font', [
            [
                (0, $8a85d13aa5e04534$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.font = font;
        this.fontKey = this.node.newFontDictionary(this.font.name, this.font.ref);
    };
    /**
     * Choose a default font size for this page. The default font size will be
     * used whenever text is drawn on this page and no font size is specified.
     * For example:
     * ```js
     * page.setFontSize(12)
     * page.drawText('I will be drawn in size 12')
     *
     * page.setFontSize(36)
     * page.drawText('I will be drawn in size 24', { fontSize: 24 })
     * ```
     * @param fontSize The default font size to be used when drawing text on this
     *                 page.
     */ PDFPage.prototype.setFontSize = function(fontSize) {
        (0, $afaKe.assertIs)(fontSize, 'fontSize', [
            'number'
        ]);
        this.fontSize = fontSize;
    };
    /**
     * Choose a default font color for this page. The default font color will be
     * used whenever text is drawn on this page and no font color is specified.
     * For example:
     * ```js
     * import { rgb, cmyk, grayscale } from 'pdf-lib'
     *
     * page.setFontColor(rgb(0.97, 0.02, 0.97))
     * page.drawText('I will be drawn in pink')
     *
     * page.setFontColor(cmyk(0.4, 0.7, 0.39, 0.15))
     * page.drawText('I will be drawn in gray', { color: grayscale(0.5) })
     * ```
     * @param fontColor The default font color to be used when drawing text on
     *                  this page.
     */ PDFPage.prototype.setFontColor = function(fontColor) {
        (0, $afaKe.assertIs)(fontColor, 'fontColor', [
            [
                Object,
                'Color'
            ]
        ]);
        this.fontColor = fontColor;
    };
    /**
     * Choose a default line height for this page. The default line height will be
     * used whenever text is drawn on this page and no line height is specified.
     * For example:
     * ```js
     * page.setLineHeight(12);
     * page.drawText('These lines will be vertically \n separated by 12 units')
     *
     * page.setLineHeight(36);
     * page.drawText('These lines will be vertically \n separated by 24 units', {
     *   lineHeight: 24
     * })
     * ```
     * @param lineHeight The default line height to be used when drawing text on
     *                   this page.
     */ PDFPage.prototype.setLineHeight = function(lineHeight) {
        (0, $afaKe.assertIs)(lineHeight, 'lineHeight', [
            'number'
        ]);
        this.lineHeight = lineHeight;
    };
    /**
     * Get the default position of this page. For example:
     * ```js
     * const { x, y } = page.getPosition()
     * ```
     * @returns The default position of the page.
     */ PDFPage.prototype.getPosition = function() {
        return {
            x: this.x,
            y: this.y
        };
    };
    /**
     * Get the default x coordinate of this page. For example:
     * ```js
     * const x = page.getX()
     * ```
     * @returns The default x coordinate of the page.
     */ PDFPage.prototype.getX = function() {
        return this.x;
    };
    /**
     * Get the default y coordinate of this page. For example:
     * ```js
     * const y = page.getY()
     * ```
     * @returns The default y coordinate of the page.
     */ PDFPage.prototype.getY = function() {
        return this.y;
    };
    /**
     * Change the default position of this page. For example:
     * ```js
     * page.moveTo(0, 0)
     * page.drawText('I will be drawn at the origin')
     *
     * page.moveTo(0, 25)
     * page.drawText('I will be drawn 25 units up')
     *
     * page.moveTo(25, 25)
     * page.drawText('I will be drawn 25 units up and 25 units to the right')
     * ```
     * @param x The new default position on the x-axis for this page.
     * @param y The new default position on the y-axis for this page.
     */ PDFPage.prototype.moveTo = function(x, y) {
        (0, $afaKe.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $afaKe.assertIs)(y, 'y', [
            'number'
        ]);
        this.x = x;
        this.y = y;
    };
    /**
     * Change the default position of this page to be further down the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveDown(10)
     * page.drawText('I will be drawn at (50, 40)')
     * ```
     * @param yDecrease The amount by which the page's default position along the
     *                  y-axis should be decreased.
     */ PDFPage.prototype.moveDown = function(yDecrease) {
        (0, $afaKe.assertIs)(yDecrease, 'yDecrease', [
            'number'
        ]);
        this.y -= yDecrease;
    };
    /**
     * Change the default position of this page to be further up the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveUp(10)
     * page.drawText('I will be drawn at (50, 60)')
     * ```
     * @param yIncrease The amount by which the page's default position along the
     *                  y-axis should be increased.
     */ PDFPage.prototype.moveUp = function(yIncrease) {
        (0, $afaKe.assertIs)(yIncrease, 'yIncrease', [
            'number'
        ]);
        this.y += yIncrease;
    };
    /**
     * Change the default position of this page to be further left on the x-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveLeft(10)
     * page.drawText('I will be drawn at (40, 50)')
     * ```
     * @param xDecrease The amount by which the page's default position along the
     *                  x-axis should be decreased.
     */ PDFPage.prototype.moveLeft = function(xDecrease) {
        (0, $afaKe.assertIs)(xDecrease, 'xDecrease', [
            'number'
        ]);
        this.x -= xDecrease;
    };
    /**
     * Change the default position of this page to be further right on the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveRight(10)
     * page.drawText('I will be drawn at (60, 50)')
     * ```
     * @param xIncrease The amount by which the page's default position along the
     *                  x-axis should be increased.
     */ PDFPage.prototype.moveRight = function(xIncrease) {
        (0, $afaKe.assertIs)(xIncrease, 'xIncrease', [
            'number'
        ]);
        this.x += xIncrease;
    };
    /**
     * Push one or more operators to the end of this page's current content
     * stream. For example:
     * ```js
     * import {
     *   pushGraphicsState,
     *   moveTo,
     *   lineTo,
     *   closePath,
     *   setFillingColor,
     *   rgb,
     *   fill,
     *   popGraphicsState,
     * } from 'pdf-lib'
     *
     * // Draw a green triangle in the lower-left corner of the page
     * page.pushOperators(
     *   pushGraphicsState(),
     *   moveTo(0, 0),
     *   lineTo(100, 0),
     *   lineTo(50, 100),
     *   closePath(),
     *   setFillingColor(rgb(0.0, 1.0, 0.0)),
     *   fill(),
     *   popGraphicsState(),
     * )
     * ```
     * @param operator The operators to be pushed.
     */ PDFPage.prototype.pushOperators = function() {
        var operator = [];
        for(var _i = 0; _i < arguments.length; _i++)operator[_i] = arguments[_i];
        (0, $afaKe.assertEachIs)(operator, 'operator', [
            [
                (0, $d7f4913eaa91561c$export$2e2bcd8739ae039),
                'PDFOperator'
            ]
        ]);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, operator);
    };
    /**
     * Draw one or more lines of text on this page. For example:
     * ```js
     * import { StandardFonts, rgb } from 'pdf-lib'
     *
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     *
     * page.moveTo(5, 200)
     * page.drawText('The Life of an Egg', { size: 36 })
     *
     * page.moveDown(36)
     * page.drawText('An Epic Tale of Woe', { size: 30 })
     *
     * page.drawText(
     *   `Humpty Dumpty sat on a wall \n` +
     *   `Humpty Dumpty had a great fall; \n` +
     *   `All the king's horses and all the king's men \n` +
     *   `Couldn't put Humpty together again. \n`,
     *   {
     *     x: 25,
     *     y: 100,
     *     font: timesRomanFont,
     *     size: 24,
     *     color: rgb(1, 0, 0),
     *     lineHeight: 24,
     *     opacity: 0.75,
     *   },
     * )
     * ```
     * @param text The text to be drawn.
     * @param options The options to be used when drawing the text.
     */ PDFPage.prototype.drawText = function(text, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        (0, $afaKe.assertIs)(text, 'text', [
            'string'
        ]);
        (0, $afaKe.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $afaKe.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $afaKe.assertOrUndefined)(options.font, 'options.font', [
            [
                (0, $8a85d13aa5e04534$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.size, 'options.size', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.lineHeight, 'options.lineHeight', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.maxWidth, 'options.maxWidth', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.wordBreaks, 'options.wordBreaks', [
            Array
        ]);
        (0, $afaKe.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $c2e0ec07cfbd64ac$export$c9b8fe72ac71821));
        var _h = this.setOrEmbedFont(options.font), oldFont = _h.oldFont, newFont = _h.newFont, newFontKey = _h.newFontKey;
        var fontSize = options.size || this.fontSize;
        var wordBreaks = options.wordBreaks || this.doc.defaultWordBreaks;
        var textWidth = function(t) {
            return newFont.widthOfTextAtSize(t, fontSize);
        };
        var lines = options.maxWidth === undefined ? (0, $8ZzAZ.lineSplit)((0, $8ZzAZ.cleanText)(text)) : (0, $8ZzAZ.breakTextIntoLines)(text, wordBreaks, options.maxWidth, textWidth);
        var encodedLines = new Array(lines.length);
        for(var idx = 0, len = lines.length; idx < len; idx++)encodedLines[idx] = newFont.encodeText(lines[idx]);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $4a8a6ab3e9d5c542$export$f7b8b44d3d84bc26)(encodedLines, {
            color: (_a = options.color) !== null && _a !== void 0 ? _a : this.fontColor,
            font: newFontKey,
            size: fontSize,
            rotate: (_b = options.rotate) !== null && _b !== void 0 ? _b : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            xSkew: (_c = options.xSkew) !== null && _c !== void 0 ? _c : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            ySkew: (_d = options.ySkew) !== null && _d !== void 0 ? _d : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            x: (_e = options.x) !== null && _e !== void 0 ? _e : this.x,
            y: (_f = options.y) !== null && _f !== void 0 ? _f : this.y,
            lineHeight: (_g = options.lineHeight) !== null && _g !== void 0 ? _g : this.lineHeight,
            graphicsState: graphicsStateKey
        }));
        if (options.font) {
            if (oldFont) this.setFont(oldFont);
            else this.resetFont();
        }
    };
    /**
     * Draw an image on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const jpgUrl = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer())
     *
     * const jpgImage = await pdfDoc.embedJpg(jpgImageBytes)
     * const jpgDims = jpgImage.scale(0.5)
     *
     * const page = pdfDoc.addPage()
     *
     * page.drawImage(jpgImage, {
     *   x: 25,
     *   y: 25,
     *   width: jpgDims.width,
     *   height: jpgDims.height,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     * @param image The image to be drawn.
     * @param options The options to be used when drawing the image.
     */ PDFPage.prototype.drawImage = function(image, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        // TODO: Reuse image XObject name if we've already added this image to Resources.XObjects
        (0, $afaKe.assertIs)(image, 'image', [
            [
                (0, $9503338f4d18fe05$export$2e2bcd8739ae039),
                'PDFImage'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $afaKe.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $afaKe.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $c2e0ec07cfbd64ac$export$c9b8fe72ac71821));
        var xObjectKey = this.node.newXObject('Image', image.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $4a8a6ab3e9d5c542$export$21a059be5bfd5fb)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : image.size().width,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : image.size().height,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an embedded PDF page on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const page = pdfDoc.addPage()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 from the PDF
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, 73)
     *
     * page.drawPage(embeddedPage, {
     *   x: 250,
     *   y: 200,
     *   xScale: 0.5,
     *   yScale: 0.5,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     *
     * The `options` argument accepts both `width`/`height` and `xScale`/`yScale`
     * as options. Since each of these options defines the size of the drawn page,
     * if both options are given, `width` and `height` take precedence and the
     * corresponding scale variants are ignored.
     *
     * @param embeddedPage The embedded page to be drawn.
     * @param options The options to be used when drawing the embedded page.
     */ PDFPage.prototype.drawPage = function(embeddedPage, options) {
        var _a, _b, _c, _d, _e;
        if (options === void 0) options = {};
        // TODO: Reuse embeddedPage XObject name if we've already added this embeddedPage to Resources.XObjects
        (0, $afaKe.assertIs)(embeddedPage, 'embeddedPage', [
            [
                (0, $7561c064649146d8$export$2e2bcd8739ae039),
                'PDFEmbeddedPage'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.xScale, 'options.xScale', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.yScale, 'options.yScale', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $afaKe.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $afaKe.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $c2e0ec07cfbd64ac$export$c9b8fe72ac71821));
        var xObjectKey = this.node.newXObject('EmbeddedPdfPage', embeddedPage.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        // prettier-ignore
        var xScale = options.width !== undefined ? options.width / embeddedPage.width : options.xScale !== undefined ? options.xScale : 1;
        // prettier-ignore
        var yScale = options.height !== undefined ? options.height / embeddedPage.height : options.yScale !== undefined ? options.yScale : 1;
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $4a8a6ab3e9d5c542$export$f8ea28c31069cbc9)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: xScale,
            yScale: yScale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            xSkew: (_d = options.xSkew) !== null && _d !== void 0 ? _d : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            ySkew: (_e = options.ySkew) !== null && _e !== void 0 ? _e : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an SVG path on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * const svgPath = 'M 0,20 L 100,160 Q 130,200 150,120 C 190,-40 200,200 300,150 L 400,90'
     *
     * // Draw path as black line
     * page.drawSvgPath(svgPath, { x: 25, y: 75 })
     *
     * // Change border style and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 275,
     *   borderColor: rgb(0.5, 0.5, 0.5),
     *   borderWidth: 2,
     *   borderOpacity: 0.75,
     * })
     *
     * // Set fill color and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 475,
     *   color: rgb(1.0, 0, 0),
     *   opacity: 0.75,
     * })
     *
     * // Draw 50% of original size
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 675,
     *   scale: 0.5,
     * })
     * ```
     * @param path The SVG path to be drawn.
     * @param options The options to be used when drawing the SVG path.
     */ PDFPage.prototype.drawSvgPath = function(path, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (options === void 0) options = {};
        (0, $afaKe.assertIs)(path, 'path', [
            'string'
        ]);
        (0, $afaKe.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.scale, 'options.scale', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $afaKe.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $afaKe.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $afaKe.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $afaKe.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $067caf076a00b79f$export$7a77bc708e50709e));
        (0, $afaKe.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $afaKe.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $c2e0ec07cfbd64ac$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.borderColor = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $4a8a6ab3e9d5c542$export$47c8a640c39d0756)(path, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            scale: options.scale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            color: (_d = options.color) !== null && _d !== void 0 ? _d : undefined,
            borderColor: (_e = options.borderColor) !== null && _e !== void 0 ? _e : undefined,
            borderWidth: (_f = options.borderWidth) !== null && _f !== void 0 ? _f : 0,
            borderDashArray: (_g = options.borderDashArray) !== null && _g !== void 0 ? _g : undefined,
            borderDashPhase: (_h = options.borderDashPhase) !== null && _h !== void 0 ? _h : undefined,
            borderLineCap: (_j = options.borderLineCap) !== null && _j !== void 0 ? _j : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a line on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * page.drawLine({
     *   start: { x: 25, y: 75 },
     *   end: { x: 125, y: 175 },
     *   thickness: 2,
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the line.
     */ PDFPage.prototype.drawLine = function(options) {
        var _a, _b, _c, _d, _e;
        (0, $afaKe.assertIs)(options.start, 'options.start', [
            [
                Object,
                '{ x: number, y: number }'
            ]
        ]);
        (0, $afaKe.assertIs)(options.end, 'options.end', [
            [
                Object,
                '{ x: number, y: number }'
            ]
        ]);
        (0, $afaKe.assertIs)(options.start.x, 'options.start.x', [
            'number'
        ]);
        (0, $afaKe.assertIs)(options.start.y, 'options.start.y', [
            'number'
        ]);
        (0, $afaKe.assertIs)(options.end.x, 'options.end.x', [
            'number'
        ]);
        (0, $afaKe.assertIs)(options.end.y, 'options.end.y', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.thickness, 'options.thickness', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.dashArray, 'options.dashArray', [
            Array
        ]);
        (0, $afaKe.assertOrUndefined)(options.dashPhase, 'options.dashPhase', [
            'number'
        ]);
        (0, $afaKe.assertIsOneOfOrUndefined)(options.lineCap, 'options.lineCap', (0, $067caf076a00b79f$export$7a77bc708e50709e));
        (0, $afaKe.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $afaKe.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $c2e0ec07cfbd64ac$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            borderOpacity: options.opacity,
            blendMode: options.blendMode
        });
        if (!('color' in options)) options.color = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $4a8a6ab3e9d5c542$export$819db45aec5fcbe5)({
            start: options.start,
            end: options.end,
            thickness: (_a = options.thickness) !== null && _a !== void 0 ? _a : 1,
            color: (_b = options.color) !== null && _b !== void 0 ? _b : undefined,
            dashArray: (_c = options.dashArray) !== null && _c !== void 0 ? _c : undefined,
            dashPhase: (_d = options.dashPhase) !== null && _d !== void 0 ? _d : undefined,
            lineCap: (_e = options.lineCap) !== null && _e !== void 0 ? _e : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a rectangle on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawRectangle({
     *   x: 25,
     *   y: 75,
     *   width: 250,
     *   height: 75,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the rectangle.
     */ PDFPage.prototype.drawRectangle = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (options === void 0) options = {};
        (0, $afaKe.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $afaKe.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $afaKe.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $afaKe.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $afaKe.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $067caf076a00b79f$export$7a77bc708e50709e));
        (0, $afaKe.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $afaKe.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $c2e0ec07cfbd64ac$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.color = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $4a8a6ab3e9d5c542$export$cac848e0621718d8)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 150,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            color: (_j = options.color) !== null && _j !== void 0 ? _j : undefined,
            borderColor: (_k = options.borderColor) !== null && _k !== void 0 ? _k : undefined,
            borderDashArray: (_l = options.borderDashArray) !== null && _l !== void 0 ? _l : undefined,
            borderDashPhase: (_m = options.borderDashPhase) !== null && _m !== void 0 ? _m : undefined,
            graphicsState: graphicsStateKey,
            borderLineCap: (_o = options.borderLineCap) !== null && _o !== void 0 ? _o : undefined
        }));
    };
    /**
     * Draw a square on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawSquare({
     *   x: 25,
     *   y: 75,
     *   size: 100,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the square.
     */ PDFPage.prototype.drawSquare = function(options) {
        if (options === void 0) options = {};
        var size = options.size;
        (0, $afaKe.assertOrUndefined)(size, 'size', [
            'number'
        ]);
        this.drawRectangle((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, options), {
            width: size,
            height: size
        }));
    };
    /**
     * Draw an ellipse on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawEllipse({
     *   x: 200,
     *   y: 75,
     *   xScale: 100,
     *   yScale: 50,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawEllipse = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (options === void 0) options = {};
        (0, $afaKe.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.xScale, 'options.xScale', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.yScale, 'options.yScale', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $afaKe.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $afaKe.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $afaKe.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $afaKe.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $afaKe.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $afaKe.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $afaKe.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $067caf076a00b79f$export$7a77bc708e50709e));
        (0, $afaKe.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $c2e0ec07cfbd64ac$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.color = (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $4a8a6ab3e9d5c542$export$43c9e2bb0dc74582)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: (_c = options.xScale) !== null && _c !== void 0 ? _c : 100,
            yScale: (_d = options.yScale) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : undefined,
            color: (_f = options.color) !== null && _f !== void 0 ? _f : undefined,
            borderColor: (_g = options.borderColor) !== null && _g !== void 0 ? _g : undefined,
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            borderDashArray: (_j = options.borderDashArray) !== null && _j !== void 0 ? _j : undefined,
            borderDashPhase: (_k = options.borderDashPhase) !== null && _k !== void 0 ? _k : undefined,
            borderLineCap: (_l = options.borderLineCap) !== null && _l !== void 0 ? _l : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a circle on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawCircle({
     *   x: 200,
     *   y: 150,
     *   size: 100,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawCircle = function(options) {
        if (options === void 0) options = {};
        var _a = options.size, size = _a === void 0 ? 100 : _a;
        (0, $afaKe.assertOrUndefined)(size, 'size', [
            'number'
        ]);
        this.drawEllipse((0, $47XJ3.__assign)((0, $47XJ3.__assign)({}, options), {
            xScale: size,
            yScale: size
        }));
    };
    PDFPage.prototype.setOrEmbedFont = function(font) {
        var oldFont = this.font;
        var oldFontKey = this.fontKey;
        if (font) this.setFont(font);
        else this.getFont();
        var newFont = this.font;
        var newFontKey = this.fontKey;
        return {
            oldFont: oldFont,
            oldFontKey: oldFontKey,
            newFont: newFont,
            newFontKey: newFontKey
        };
    };
    PDFPage.prototype.getFont = function() {
        if (!this.font || !this.fontKey) {
            var font = this.doc.embedStandardFont((0, $37c1c247d1a78dcd$export$7dcb046109e65a3d).Helvetica);
            this.setFont(font);
        }
        return [
            this.font,
            this.fontKey
        ];
    };
    PDFPage.prototype.resetFont = function() {
        this.font = undefined;
        this.fontKey = undefined;
    };
    PDFPage.prototype.getContentStream = function(useExisting) {
        if (useExisting === void 0) useExisting = true;
        if (useExisting && this.contentStream) return this.contentStream;
        this.contentStream = this.createContentStream();
        this.contentStreamRef = this.doc.context.register(this.contentStream);
        this.node.addContentStream(this.contentStreamRef);
        return this.contentStream;
    };
    PDFPage.prototype.createContentStream = function() {
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        var dict = this.doc.context.obj({});
        var contentStream = (0, $a23e3df52ace75a5$export$2e2bcd8739ae039).of(dict, operators);
        return contentStream;
    };
    PDFPage.prototype.maybeEmbedGraphicsState = function(options) {
        var opacity = options.opacity, borderOpacity = options.borderOpacity, blendMode = options.blendMode;
        if (opacity === undefined && borderOpacity === undefined && blendMode === undefined) return undefined;
        var graphicsState = this.doc.context.obj({
            Type: 'ExtGState',
            ca: opacity,
            CA: borderOpacity,
            BM: blendMode
        });
        var key = this.node.newExtGState('GS', graphicsState);
        return key;
    };
    PDFPage.prototype.scaleAnnot = function(annot, x, y) {
        var selectors = [
            'RD',
            'CL',
            'Vertices',
            'QuadPoints',
            'L',
            'Rect'
        ];
        for(var idx = 0, len = selectors.length; idx < len; idx++){
            var list = annot.lookup((0, $2npvA.default).of(selectors[idx]));
            if (list instanceof (0, $6IKEk.default)) list.scalePDFNumbers(x, y);
        }
        var inkLists = annot.lookup((0, $2npvA.default).of('InkList'));
        if (inkLists instanceof (0, $6IKEk.default)) for(var idx = 0, len = inkLists.size(); idx < len; idx++){
            var arr = inkLists.lookup(idx);
            if (arr instanceof (0, $6IKEk.default)) arr.scalePDFNumbers(x, y);
        }
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]] from an existing leaf node.
     *
     * @param leafNode The leaf node to be wrapped.
     * @param ref The unique reference for the page.
     * @param doc The document to which the page will belong.
     */ PDFPage.of = function(leafNode, ref, doc) {
        return new PDFPage(leafNode, ref, doc);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]].
     *
     * @param doc The document to which the page will belong.
     */ PDFPage.create = function(doc) {
        (0, $afaKe.assertIs)(doc, 'doc', [
            [
                (0, $d524d17d41c918dc$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        var dummyRef = (0, $dac7b6b491336f5d$export$2e2bcd8739ae039).of(-1);
        var pageLeaf = (0, $9575017b00e75ca2$export$2e2bcd8739ae039).withContextAndParent(doc.context, dummyRef);
        var pageRef = doc.context.register(pageLeaf);
        return new PDFPage(pageLeaf, pageRef, doc);
    };
    return PDFPage;
}();
var $b8eacf6334b41c1a$export$2e2bcd8739ae039 = $b8eacf6334b41c1a$var$PDFPage;









parcelRequire("5w6hV");
var $afaKe = parcelRequire("afaKe");
/**
 * Represents a button field of a [[PDFForm]].
 *
 * [[PDFButton]] fields are interactive controls that users can click with their
 * mouse. This type of [[PDFField]] is not stateful. The purpose of a button
 * is to perform an action when the user clicks on it, such as opening a print
 * modal or resetting the form. Buttons are typically rectangular in shape and
 * have a text label describing the action that they perform when clicked.
 */ var $25554cdcac14ffa8$var$PDFButton = /** @class */ function(_super) {
    (0, $47XJ3.__extends)(PDFButton, _super);
    function PDFButton(acroPushButton, ref, doc) {
        var _this = _super.call(this, acroPushButton, ref, doc) || this;
        (0, $afaKe.assertIs)(acroPushButton, 'acroButton', [
            [
                (0, $96dc99afef1c0142$export$2e2bcd8739ae039),
                'PDFAcroPushButton'
            ]
        ]);
        _this.acroField = acroPushButton;
        return _this;
    }
    /**
     * Display an image inside the bounds of this button's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const button = form.getButton('some.button.field')
     * button.setImage(pngImage, ImageAlignment.Center)
     * ```
     * This will update the appearances streams for each of this button's widgets.
     * @param image The image that should be displayed.
     * @param alignment The alignment of the image.
     */ PDFButton.prototype.setImage = function(image, alignment) {
        if (alignment === void 0) alignment = (0, $d0179262af07ed10$export$8efa99ca8f041e7e).Center;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this button. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * button.setFontSize(4)
     * button.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFButton.prototype.setFontSize = function(fontSize) {
        (0, $afaKe.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Show this button on the specified page with the given text. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('some.button.field')
     *
     * button.addToPage('Do Stuff', page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this button field.
     * @param text The text to be displayed for this button widget.
     * @param page The page to which this button widget should be added.
     * @param options The options to be used when adding this button widget.
     */ PDFButton.prototype.addToPage = function(// TODO: This needs to be optional, e.g. for image buttons
    text, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        (0, $afaKe.assertOrUndefined)(text, 'text', [
            'string'
        ]);
        (0, $afaKe.assertOrUndefined)(page, 'page', [
            [
                (0, $b8eacf6334b41c1a$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $c15606bfc3a2beb4$export$55643210f1835a35)(options);
        // Create a widget for this button
        var widget = this.createWidget({
            x: ((_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0) - ((_b = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _b !== void 0 ? _b : 0) / 2,
            y: ((_c = options === null || options === void 0 ? void 0 : options.y) !== null && _c !== void 0 ? _c : 0) - ((_d = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _d !== void 0 ? _d : 0) / 2,
            width: (_e = options === null || options === void 0 ? void 0 : options.width) !== null && _e !== void 0 ? _e : 100,
            height: (_f = options === null || options === void 0 ? void 0 : options.height) !== null && _f !== void 0 ? _f : 50,
            textColor: (_g = options === null || options === void 0 ? void 0 : options.textColor) !== null && _g !== void 0 ? _g : (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0, 0, 0),
            backgroundColor: (_h = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _h !== void 0 ? _h : (0, $a0c4165d43c51676$export$8972dc0e6ad9238f)(0.75, 0.75, 0.75),
            borderColor: options === null || options === void 0 ? void 0 : options.borderColor,
            borderWidth: (_j = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _j !== void 0 ? _j : 0,
            rotate: (_k = options === null || options === void 0 ? void 0 : options.rotate) !== null && _k !== void 0 ? _k : (0, $ea262ab75d90e986$export$41fc368e1a942b97)(0),
            caption: text,
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_l = options === null || options === void 0 ? void 0 : options.font) !== null && _l !== void 0 ? _l : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this button has been marked as dirty, or if any of this
     * button's widgets do not have an appearance stream. For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * if (button.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this button needs an appearance update.
     */ PDFButton.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $1b80b011925bffc2$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the default appearance provider for buttons. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFButton.prototype.defaultUpdateAppearances = function(font) {
        (0, $afaKe.assertIs)(font, 'font', [
            [
                (0, $8a85d13aa5e04534$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for buttons will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return {
     *     normal: drawButton(...),
     *     down: drawButton(...),
     *   }
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFButton.prototype.updateAppearances = function(font, provider) {
        (0, $afaKe.assertIs)(font, 'font', [
            [
                (0, $8a85d13aa5e04534$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $afaKe.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
    };
    PDFButton.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $9986a803db2c3c73$export$68f9b19f48ffeeec);
        var appearances = (0, $9986a803db2c3c73$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getButton]] method, which will create an
     * > instance of [[PDFButton]] for you.
     *
     * Create an instance of [[PDFButton]] from an existing acroPushButton and ref
     *
     * @param acroPushButton The underlying `PDFAcroPushButton` for this button.
     * @param ref The unique reference for this button.
     * @param doc The document to which this button will belong.
     */ PDFButton.of = function(acroPushButton, ref, doc) {
        return new PDFButton(acroPushButton, ref, doc);
    };
    return PDFButton;
}((0, $c15606bfc3a2beb4$export$2e2bcd8739ae039));
var $25554cdcac14ffa8$export$2e2bcd8739ae039 = $25554cdcac14ffa8$var$PDFButton;




































var $a8d09c9f4066ec81$exports = {};


parcelRequire("5w6hV");
$parcel$exportWildcard($2099fdff5c01c024$exports, $a8d09c9f4066ec81$exports);


var $cea714d4b81be3c5$require$PDFDocument = $d524d17d41c918dc$export$2e2bcd8739ae039;
class $cea714d4b81be3c5$var$PDFMerger {
    constructor(){
        this.doc = undefined;
    }
    async add(inputFile, pages) {
        await this._ensureDoc();
        if (typeof pages === 'undefined' || pages === null) await this._addEntireDocument(inputFile);
        else if (Array.isArray(pages)) await this._addGivenPages(inputFile, pages);
        else if (pages.indexOf(',') > 0) {
            const aPages = pages.replace(/ /g, '').split(',');
            await this._addGivenPages(inputFile, aPages);
        } else if (pages.toLowerCase().indexOf('to') >= 0) {
            const span = pages.replace(/ /g, '').split('to');
            const from = parseInt(span[0]);
            const to = parseInt(span[1]);
            await this._addFromToPage(inputFile, from, to);
        } else if (pages.indexOf('-') >= 0) {
            const span = pages.replace(/ /g, '').split('-');
            const from = parseInt(span[0]);
            const to = parseInt(span[1]);
            await this._addFromToPage(inputFile, from, to);
        } else throw new Error('invalid parameter "pages"');
    }
    async _ensureDoc() {
        if (!this.doc) this.doc = await $cea714d4b81be3c5$require$PDFDocument.create();
    }
    async _getInputAsUint8Array(input) {
        if (input instanceof Uint8Array) return input;
        if (input instanceof ArrayBuffer || Object.prototype.toString.call(input) === '[object ArrayBuffer]') return new Uint8Array(input);
        if (typeof input === 'string' || input instanceof String) {
            try {
                Boolean(new URL(input));
            } catch (e) {
                throw new Error(`This is not a valid url: ${input}`);
            }
            const res = await window.fetch(input);
            const aBuffer = await res.arrayBuffer();
            return new Uint8Array(aBuffer);
        }
        if (input instanceof window.File) {
            const fileReader = new window.FileReader();
            fileReader.onload = function(evt) {
                return fileReader.result;
            };
            fileReader.readAsArrayBuffer(input);
        }
        if (input instanceof window.Blob) {
            const aBuffer = await input.arrayBuffer();
            return new Uint8Array(aBuffer);
        }
        console.log({
            input: input,
            inputc: Object.prototype.toString.call(input),
            ArrayBuffer: ArrayBuffer,
            eq: input.contructor !== ArrayBuffer
        });
        throw new Error('pdf must be represented as an ArrayBuffer, Blob, File, URL or fetchable string');
    }
    async _addEntireDocument(input) {
        const src = await this._getInputAsUint8Array(input);
        const srcDoc = await $cea714d4b81be3c5$require$PDFDocument.load(src);
        const copiedPages = await this.doc.copyPages(srcDoc, srcDoc.getPageIndices());
        copiedPages.forEach((page)=>{
            this.doc.addPage(page);
        });
    }
    async _addFromToPage(inputFile, from, to) {
        if (typeof from !== 'number' || typeof to !== 'number' || from < 0 || from < 0) throw new Error('Invalid function parameter. \'from\' and \'to\' must be positive \'numbers\'.');
        if (to < from) throw new Error('Invalid function parameter. \'to\' must be greater or eaqual to \'from\'.');
        const src = await this._getInputAsUint8Array(inputFile);
        const srcDoc = await $cea714d4b81be3c5$require$PDFDocument.load(src);
        const pageCount = srcDoc.getPageCount();
        if (from >= pageCount || to >= pageCount) throw new Error(`Invalid function parameter. The document has not enough pages. (from:${from}, to:${to}, pages:${pageCount})`);
        // create a array [2,3,4] with from=2 and to=4
        const pages = Array.from({
            length: to - from + 1
        }, (_, i)=>i + from - 1);
        const copiedPages = await this.doc.copyPages(srcDoc, pages);
        copiedPages.forEach((page)=>{
            this.doc.addPage(page);
        });
    }
    async _addGivenPages(inputFile, pages) {
        if (pages.length <= 0) return;
        const src = await this._getInputAsUint8Array(inputFile);
        const srcDoc = await $cea714d4b81be3c5$require$PDFDocument.load(src);
        const pagesIndexed1 = pages.map((p)=>p - 1);
        const copiedPages = await this.doc.copyPages(srcDoc, pagesIndexed1);
        copiedPages.forEach((page)=>{
            this.doc.addPage(page);
        });
    }
    async setMetadata(metadata) {
        await this._ensureDoc();
        if (metadata.producer) this.doc.setProducer(metadata.producer);
        if (metadata.author) this.doc.setAuthor(metadata.author);
        if (metadata.title) this.doc.setTitle(metadata.title);
        if (metadata.creator) this.doc.setCreator(metadata.creator);
    }
    async saveAsBuffer() {
        await this._ensureDoc();
        return await this.doc.save();
    }
    async saveAsBlob() {
        const buffer = await this.saveAsBuffer();
        return new window.Blob([
            buffer
        ], {
            type: 'application/pdf'
        });
    }
    async save(fileName) {
        const dataUri = await this.doc.saveAsBase64({
            dataUri: true
        });
        const link = document.createElement('a');
        link.href = dataUri;
        link.download = `${fileName}.pdf`;
        link.click();
    }
}
$cea714d4b81be3c5$exports = $cea714d4b81be3c5$var$PDFMerger;



var $6Sgv0 = parcelRequire("6Sgv0");





const $1585b70f80e547b7$var$defaultOptions = {};
const $1585b70f80e547b7$export$d5317a4bac0b56a8 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetFileTemplates {
  FileTemplates {
    id
    name
    fileName
    s3Key
  }
}
    `;
function $1585b70f80e547b7$export$facca7a7c3bff4c4(baseOptions) {
    const options = {
        ...$1585b70f80e547b7$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($1585b70f80e547b7$export$d5317a4bac0b56a8, options);
}
function $1585b70f80e547b7$export$e3a8ca040ff6b551(baseOptions) {
    const options = {
        ...$1585b70f80e547b7$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($1585b70f80e547b7$export$d5317a4bac0b56a8, options);
}
const $1585b70f80e547b7$export$39ac829ab91f0716 = {
    Query: {
        GetFileTemplates: 'GetFileTemplates'
    }
};









var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



var $6Sgv0 = parcelRequire("6Sgv0");

var $bb3TF = parcelRequire("bb3TF");



const $656cec9a0cc378ab$var$KbaFormInputs = ({ kbaTypeValue: kbaTypeValue, index: index, form: form })=>{
    if (kbaTypeValue === (0, $8f7fe33a44836803$export$929a37757e01f43a).Without) return null;
    if (kbaTypeValue === (0, $8f7fe33a44836803$export$929a37757e01f43a).Basic) return (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
        style: {
            boxShadow: 'none',
            border: '2px solid #f4f4f4'
        },
        bodyStyle: {
            paddingBottom: '0px'
        },
        children: [
            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                rules: [
                    {
                        required: true,
                        message: 'Last name is required'
                    }
                ],
                name: [
                    `signerKBA[${index}]`,
                    'name'
                ],
                extra: "Last Name",
                style: {
                    maxWidth: 300
                },
                children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {})
            }),
            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                rules: [
                    {
                        required: true,
                        message: 'Last four of SSN is required'
                    },
                    {
                        pattern: '[0-9]{4}',
                        message: 'Must be 4 numbers'
                    }
                ],
                name: [
                    `signerKBA[${index}]`,
                    'lastFourSSN'
                ],
                extra: "Last four SSN or EIN",
                style: {
                    maxWidth: 155
                },
                onChange: (e)=>{
                    form.setFields([
                        {
                            name: [
                                `signerKBA[${index}]`,
                                'lastFourSSN'
                            ],
                            value: e.target.value.replace(/[^0-9]/g, '')
                        }
                    ]);
                },
                children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                    type: "text",
                    maxLength: "4"
                })
            }),
            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                rules: [
                    {
                        required: true,
                        message: 'Date of birth is required'
                    }
                ],
                name: [
                    `signerKBA[${index}]`,
                    'dateOfBirth'
                ],
                extra: "Date of Birth",
                children: (0, $bb3TF.jsx)((0, $dd1293f125eb7a8a$export$2e2bcd8739ae039), {})
            })
        ]
    });
    if (kbaTypeValue === (0, $8f7fe33a44836803$export$929a37757e01f43a).Enhanced) return (0, $bb3TF.jsx)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
        style: {
            boxShadow: 'none',
            border: '2px solid #f4f4f4'
        },
        bodyStyle: {
            paddingBottom: '0px'
        },
        children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
            rules: [
                {
                    required: true,
                    message: 'Mobile phone number is required'
                }
            ],
            name: [
                `signerKBA[${index}]`,
                'mobilePhone'
            ],
            extra: "Mobile Phone",
            style: {
                maxWidth: 200
            },
            children: (0, $bb3TF.jsx)((0, $5ba7d8eeafddcf67$export$2e2bcd8739ae039), {})
        })
    });
    return null;
};
var $656cec9a0cc378ab$export$2e2bcd8739ae039 = $656cec9a0cc378ab$var$KbaFormInputs;


const { CloseOutlined: $326edc33cb8deaa7$var$CloseOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $326edc33cb8deaa7$var$SignerKBASection = ({ index: index, handleClose: handleClose, numApprovers: numApprovers, type: type, initialApproverFullName: initialApproverFullName, initialApproverLastName: initialApproverLastName, initialApproverEmail: initialApproverEmail, initialApproverPhone: initialApproverPhone, initialApproverBirthday: initialApproverBirthday, initialApproverLastSsn: initialApproverLastSsn, form: form, initialKbaType: initialKbaType, fileRequestId: fileRequestId })=>{
    const [kbaTypeSelection, setKbaTypeSelection] = (0, $6fFrj.useState)(undefined);
    const signerOrApprover = type === 'signer' ? 'Signer' : 'Approver';
    (0, $6fFrj.useEffect)(()=>{
        setKbaTypeSelection(initialKbaType);
        form.setFields([
            {
                name: [
                    `signerKBA[${index}]`,
                    'signatureKBAType'
                ],
                value: initialKbaType
            },
            {
                name: [
                    `signerKBA[${index}]`,
                    'signerName'
                ],
                value: initialApproverFullName
            },
            {
                name: [
                    `signerKBA[${index}]`,
                    'signerEmail'
                ],
                value: initialApproverEmail
            },
            {
                name: [
                    `signerKBA[${index}]`,
                    'name'
                ],
                value: initialApproverLastName
            },
            {
                name: [
                    `signerKBA[${index}]`,
                    'lastFourSSN'
                ],
                value: initialApproverLastSsn
            },
            {
                name: [
                    `signerKBA[${index}]`,
                    'dateOfBirth'
                ],
                value: initialApproverBirthday ? (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(initialApproverBirthday) : null
            },
            {
                name: [
                    `signerKBA[${index}]`,
                    'mobilePhone'
                ],
                value: initialApproverPhone
            }
        ]);
    }, [
        fileRequestId
    ]);
    return (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
        title: `${signerOrApprover} #${index + 1}`,
        extra: index + 1 === numApprovers && index > 0 ? (0, $bb3TF.jsx)($326edc33cb8deaa7$var$CloseOutlined, {
            onClick: handleClose
        }) : undefined,
        children: [
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 50,
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        md: 12,
                        sm: 24,
                        children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                            rules: [
                                {
                                    required: true,
                                    message: `${signerOrApprover} name is required`
                                }
                            ],
                            name: [
                                `signerKBA[${index}]`,
                                'signerName'
                            ],
                            extra: `${signerOrApprover} Name`,
                            children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {})
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        md: 12,
                        sm: 24,
                        children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                            rules: [
                                {
                                    required: true,
                                    type: 'email',
                                    message: 'A valid email is required'
                                }
                            ],
                            name: [
                                `signerKBA[${index}]`,
                                'signerEmail'
                            ],
                            extra: `${signerOrApprover} Email`,
                            children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {})
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 2,
                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    span: 24,
                    children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                        rules: [
                            {
                                required: true,
                                message: 'KBA type is required'
                            }
                        ],
                        name: [
                            `signerKBA[${index}]`,
                            'signatureKBAType'
                        ],
                        label: "KBA Type:",
                        children: (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Group, {
                            name: "signatureKBAType",
                            onChange: (e)=>setKbaTypeSelection(e.target.value),
                            children: (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                                direction: "vertical",
                                children: [
                                    (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039), {
                                        value: (0, $8f7fe33a44836803$export$929a37757e01f43a).Without,
                                        children: "Without KBA"
                                    }),
                                    (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039), {
                                        value: (0, $8f7fe33a44836803$export$929a37757e01f43a).Basic,
                                        children: `Free KBA for this ${type}`
                                    }),
                                    (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039), {
                                        value: (0, $8f7fe33a44836803$export$929a37757e01f43a).Enhanced,
                                        children: `Enhanced KBA for this ${type}`
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            (0, $bb3TF.jsx)((0, $656cec9a0cc378ab$export$2e2bcd8739ae039), {
                index: index,
                kbaTypeValue: kbaTypeSelection,
                form: form
            })
        ]
    });
};
$326edc33cb8deaa7$var$SignerKBASection.defaultProps = {
    initialApproverFullName: '',
    initialApproverLastName: '',
    initialApproverEmail: '',
    initialApproverPhone: '',
    initialApproverBirthday: null,
    initialApproverLastSsn: '',
    initialKbaType: undefined,
    fileRequestId: undefined
};
var $326edc33cb8deaa7$export$2e2bcd8739ae039 = $326edc33cb8deaa7$var$SignerKBASection;



var $1e4d9fbdb1e94dd1$exports = {};

$parcel$export($1e4d9fbdb1e94dd1$exports, "templateContainer", function () { return $1e4d9fbdb1e94dd1$export$454f349f82f2d88d; }, function (v) { return $1e4d9fbdb1e94dd1$export$454f349f82f2d88d = v; });
$parcel$export($1e4d9fbdb1e94dd1$exports, "templateSelect", function () { return $1e4d9fbdb1e94dd1$export$cb12738593a84484; }, function (v) { return $1e4d9fbdb1e94dd1$export$cb12738593a84484 = v; });
var $1e4d9fbdb1e94dd1$export$454f349f82f2d88d;
var $1e4d9fbdb1e94dd1$export$cb12738593a84484;
$1e4d9fbdb1e94dd1$export$454f349f82f2d88d = `jRmZbq_templateContainer`;
$1e4d9fbdb1e94dd1$export$cb12738593a84484 = `jRmZbq_templateSelect`;



var $06620ba416108982$require$Buffer = $c62b475e31b1e858$export$a143d493d941bafc;
const { PlusOutlined: $06620ba416108982$var$PlusOutlined, DeleteOutlined: $06620ba416108982$var$DeleteOutlined, CheckCircleOutlined: $06620ba416108982$var$CheckCircleOutlined, EditOutlined: $06620ba416108982$var$EditOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Text: $06620ba416108982$var$Text, Paragraph: $06620ba416108982$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { Option: $06620ba416108982$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const $06620ba416108982$var$DocumentSignApproveRequestModalContent = ({ type: type, form: form, editMode: editMode, dispatch: dispatch, state: state, setSendButtonDisabled: setSendButtonDisabled, closeModal: closeModal, setOkButtonLoading: setOkButtonLoading, refetchFileRequests: refetchFileRequests, isCompiledFileUpdated: isCompiledFileUpdated, setIsCompiledFileUpdated: setIsCompiledFileUpdated })=>{
    const [numApprovers, setNumApprovers] = (0, $6fFrj.useState)(1);
    const { taxYearInterviewId: taxYearInterviewId, clientFirstName: clientFirstName, clientLastName: clientLastName, clientEmail: clientEmail, clientMobilePhone: clientMobilePhone, clientBirthday: clientBirthday, entityOwnerId: entityOwnerId } = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const { data: interviewData } = (0, $2d09ce9c73e1e422$export$b5e05cf0bcf238e6)({
        variables: {
            id: taxYearInterviewId
        }
    });
    const { data: fileTemplateData, refetch: refetchFileTemplateRequest } = (0, $1585b70f80e547b7$export$facca7a7c3bff4c4)();
    const [createFileTemplate] = (0, $d62a09867fddedad$export$f4dbcc234b01848)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message, 10)
    });
    const [updateFileTemplate] = (0, $d62a09867fddedad$export$3e9148a9b1c73e06)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message, 10)
    });
    const [deleteFileTemplate] = (0, $d62a09867fddedad$export$8e6426240acf6a11)();
    const [updateApprovalSignatureRequest] = (0, $d4866daa2fbe65f8$export$b2923732f6adc233)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message, 10)
    });
    const [updateCompiledFilePreSignedUrl] = (0, $d62a09867fddedad$export$95dd438c05b280e2)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message, 10)
    });
    const [urlS3File] = (0, $edf372aa0dea9531$export$4747d4e17950f93f)();
    const [documentApprovalUpload] = (0, $d62a09867fddedad$export$ad78f728a994fc6e)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message, 10)
    });
    const [documentSignatureUpload] = (0, $d62a09867fddedad$export$2ff795a19cb0ef73)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message, 10)
    });
    const { accessToken: accessToken, firmAccountId: firmAccountId, userId: userId } = (0, $58073eff19365823$export$a7347740d65f620b)((s)=>s.session);
    const { compiledFile: compiledFile, newDraggableBoundarySignFields: newDraggableBoundarySignFields, fileList: fileList } = state;
    const [clientLastSsn, setClientLastSsn] = (0, $6fFrj.useState)('');
    const [client2FirstName, setClient2FirstName] = (0, $6fFrj.useState)('');
    const [client2LastName, setClient2LastName] = (0, $6fFrj.useState)('');
    const [client2Email, setClient2Email] = (0, $6fFrj.useState)('');
    const [client2LastSsn, setClient2LastSsn] = (0, $6fFrj.useState)('');
    const [client2Birthday, setClient2Birthday] = (0, $6fFrj.useState)(null);
    const [client2MobilePhone, setClient2MobilePhone] = (0, $6fFrj.useState)('');
    const [deletedFileIndex, setDeletedFileIndex] = (0, $6fFrj.useState)(-1);
    const [deleteFileModalVisible, setDeleteFileModalVisible] = (0, $6fFrj.useState)(false);
    const [templates, setTemplates] = (0, $6fFrj.useState)([]);
    const [fileToTemplateId, setFileToTemplateId] = (0, $6fFrj.useState)('');
    const [selectedTemplateId, setSelectedTemplateId] = (0, $6fFrj.useState)('');
    const [createTemplateModalVisible, setCreateTemplateModalVisible] = (0, $6fFrj.useState)(false);
    const [createTemplateName, setCreateTemplateName] = (0, $6fFrj.useState)('');
    const [editTemplateModalVisible, setEditTemplateModalVisible] = (0, $6fFrj.useState)(false);
    const [editTemplateName, setEditTemplateName] = (0, $6fFrj.useState)('');
    const [deleteTemplateModalVisible, setDeleteTemplateModalVisible] = (0, $6fFrj.useState)(false);
    const getInterviewAnswer = (section, questionDescription, answers)=>{
        const question = section.Questions?.find((q)=>q.Translations?.some((t)=>t.description === questionDescription));
        const answer = question ? answers.find((a)=>a.questionId === question.id) : null;
        return answer?.description ?? '';
    };
    (0, $6fFrj.useEffect)(()=>{
        // get initial data
        const content = interviewData?.GetTaxYearInterviewIncludeInterviews;
        const interview = content?.Interviews;
        const clientSection = interview?.Sections?.find((s)=>s.Translations?.some((t)=>t.description === 'Basic Personal Information'));
        if (clientSection) {
            const answers = content.Answers;
            const clientSsn = getInterviewAnswer(clientSection, 'Taxpayer SSN/Taxpayer ID Number', answers);
            setClientLastSsn(clientSsn.substring(clientSsn.length - 4));
            const client2Section = clientSection?.SubSections?.find((s)=>s.Translations?.some((t)=>t.description === 'Spouse Information'));
            if (client2Section) {
                const client2Names = getInterviewAnswer(client2Section, 'Spouse Name', answers).trim().split(' ');
                setClient2FirstName(client2Names[0] ?? '');
                setClient2LastName(client2Names[1] ?? '');
                setClient2Email(getInterviewAnswer(client2Section, 'Spouse Email Address', answers));
                const client2Ssn = getInterviewAnswer(client2Section, 'Spouse SSN/Taxpayer ID Number', answers);
                setClient2LastSsn(client2Ssn.substring(client2Ssn.length - 4));
                const client2BirthdayStr = getInterviewAnswer(client2Section, 'Spouse Date of Birth', answers);
                setClient2Birthday(client2BirthdayStr ? (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(client2BirthdayStr).toDate() : null);
                setClient2MobilePhone(getInterviewAnswer(client2Section, 'Spouse Phone Number', answers));
            }
        }
    }, [
        interviewData
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (fileTemplateData?.FileTemplates) setTemplates(fileTemplateData?.FileTemplates);
    }, [
        fileTemplateData
    ]);
    const validateSubmitButton = async ()=>{
        if (fileList.length > 0) {
            const fields = await form.getFieldsError().filter((field)=>field.errors.length > 0);
            setSendButtonDisabled(fields.length > 0);
        } else setSendButtonDisabled(true);
    };
    (0, $6fFrj.useEffect)(()=>{
        validateSubmitButton();
    }, [
        fileList.length,
        selectedTemplateId
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (editMode) {
            form.setFieldsValue({
                documentTitle: state?.fileRequest?.title || ''
            });
            form.setFieldsValue({
                reviewerNotes: state?.fileRequest?.notes || ''
            });
            setNumApprovers(state?.fileRequest?.FileApproval?.length);
        } else {
            form.setFieldsValue({
                documentTitle: ''
            });
            form.setFieldsValue({
                reviewerNotes: ''
            });
            setNumApprovers(1);
        }
    }, [
        state?.fileRequest?.title,
        state?.fileRequest?.notes,
        editMode
    ]);
    // merge files into one and save to compiledFile state
    (0, $6fFrj.useEffect)(()=>{
        const render = async ()=>{
            const merger = new (0, (/*@__PURE__*/$parcel$interopDefault($cea714d4b81be3c5$exports)))();
            // eslint-disable-next-line no-restricted-syntax
            for (const file of state.fileList)// kyle todo: can I remove this await?
            // eslint-disable-next-line no-await-in-loop
            await merger.add(file);
            const mergedPdf = await merger.saveAsBlob();
            // const url = URL.createObjectURL(mergedPdf);
            // setCompiledFile(mergedPdf);
            dispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).update({
                compiledFile: mergedPdf
            }));
            return null;
        };
        render().catch((err)=>{
            throw err;
        });
        // eslint-disable-next-line no-unused-expressions
        ()=>dispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).update({
                compiledFile: null
            }));
    }, [
        JSON.stringify(state.fileList)
    ]);
    const onFinish = async (values)=>{
        setOkButtonLoading(true);
        // This converts the { signerKBA[0]: {}, signerKBA[1]: {} } format into { signerKBAs: [{}, {}] }
        const finalValues = {};
        const signerKBAArray = [];
        // loop through object
        // eslint-disable-next-line no-restricted-syntax
        for(const key in values)// eslint-disable-next-line no-prototype-builtins
        if (values.hasOwnProperty(key)) {
            const element = values[key];
            if (key.substring(0, 9) === 'signerKBA') {
                element.signerId = key;
                signerKBAArray.push(element);
            } else finalValues[key] = element;
        }
        // loop through the signerKBAArray and change moment objects to dates without time
        for(let index = 0; index < signerKBAArray.length; index += 1){
            const element = signerKBAArray[index];
            if (element.dateOfBirth) signerKBAArray[index].dateOfBirth = element.dateOfBirth.format('MM-DD-YYYY'); // Using Moment.js to format the date
        }
        finalValues.signerKBAs = signerKBAArray;
        // if only one signerKBA, set the newDraggableBoundarySignFields emails to the only available signerKBA
        if (finalValues.signerKBAs.length === 1) for(let index = 0; index < newDraggableBoundarySignFields.length; index += 1){
            newDraggableBoundarySignFields[index].key = 'signerKBA[0]'; // do we need this?
            newDraggableBoundarySignFields[index].email = values?.['signerKba[0]']?.signerEmail;
        }
        const signatureFields = newDraggableBoundarySignFields.map((item, index)=>({
                signatureId: item.id,
                signerId: item.signerId,
                email: values[item?.signerId]?.signerEmail,
                page: item.page,
                fieldLeftPercentage: item.fieldLeftPercentage,
                fieldTopPercentage: item.fieldTopPercentage,
                fieldWidthPercentage: item.fieldWidthPercentage,
                fieldHeightPercentage: item.fieldHeightPercentage,
                // fieldId: what's this?: todo
                fieldType: item.fieldType,
                title: item.title
            }));
        if (signatureFields.some((item)=>!item.email)) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Please select a signer for each field by hovering over the field and selecting a client.', 10);
            setOkButtonLoading(false);
            return;
        }
        const { documentTitle: documentTitle, reviewerNotes: reviewerNotes, signerKBAs: signerKBAs } = finalValues;
        const documentExt = documentTitle.split('.').pop();
        try {
            const buffer = $06620ba416108982$require$Buffer.from(await compiledFile.arrayBuffer());
            const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
            const input = {
                compiledHash: $06620ba416108982$require$Buffer.from(hashBuffer).toString('base64'),
                fileName: documentExt === 'pdf' ? documentTitle : `${documentTitle}.pdf`,
                fileSize: buffer.toString().length,
                taxYearInterviewId: taxYearInterviewId,
                clientId: entityOwnerId,
                documentTitle: documentTitle,
                reviewerNotes: reviewerNotes,
                signerKBAs: signerKBAs
            };
            const result = type === 'sign' ? documentSignatureUpload({
                variables: {
                    documentSignatureUploadInput: {
                        ...input,
                        signatureFields: signatureFields
                    }
                }
            }).then((res)=>res.data?.DocumentSignatureUpload) : documentApprovalUpload({
                variables: {
                    documentApprovalUploadInput: {
                        ...input
                    }
                }
            }).then((res)=>res.data?.DocumentApprovalUpload);
            const fileUrl = new URL(await result);
            await (0, (/*@__PURE__*/$parcel$interopDefault($18ae57eea10fd4c8$exports))).put(fileUrl.toString(), buffer, {
                headers: {
                    'Content-Type': 'application/pdf'
                }
            });
            setOkButtonLoading(false);
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Success!');
            closeModal();
            // refetch the file requests table
            refetchFileRequests();
            // reset the form data and the draggableBoundarySignFields
            form.resetFields();
            dispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).resetForm());
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`An error has occured: ${error}`);
            setOkButtonLoading(false);
        }
    };
    const onUpdate = async (values)=>{
        setOkButtonLoading(true);
        const signatureFields = newDraggableBoundarySignFields.map((item)=>({
                id: item.id,
                signerId: item.signerId,
                email: values[item?.signerId]?.signerEmail,
                page: item.page,
                fieldLeftPercentage: item.fieldLeftPercentage,
                fieldTopPercentage: item.fieldTopPercentage,
                fieldWidthPercentage: item.fieldWidthPercentage,
                fieldHeightPercentage: item.fieldHeightPercentage,
                fieldType: item.fieldType,
                title: item.title,
                fileApprovalId: item.fileApprovalId,
                signatureImage: item.signatureImage,
                completedAt: item.completedAt
            }));
        const initialSignatureFields = [];
        state.fileRequest?.FileApproval?.forEach((fa)=>{
            fa?.SignatureFields?.forEach((field)=>initialSignatureFields.push(field));
        });
        const signerKBAArray = [];
        // eslint-disable-next-line no-restricted-syntax
        for(const key in values)// eslint-disable-next-line no-prototype-builtins
        if (values.hasOwnProperty(key)) {
            const element = values[key];
            if (key.substring(0, 9) === 'signerKBA') {
                element.signerId = key;
                signerKBAArray.push(element);
            }
        }
        const updateValues = {
            id: state.fileRequest.id,
            title: values.documentTitle,
            notes: values.reviewerNotes,
            type: type,
            isCompiledFileUpdated: isCompiledFileUpdated,
            taxYearInterviewId: state.fileRequest.taxYearInterviewId,
            fileApprovals: signerKBAArray.map((signer, index)=>{
                const kBaFields = [];
                const fileApprovalId = state.fileRequest?.FileApproval?.[index]?.id;
                const createSignatureFields = signatureFields.filter((sf)=>!sf.fileApprovalId && sf.email === signer.signerEmail && sf.signerId === signer.signerId);
                const updateSignatureFields = signatureFields.filter((sf)=>sf.fileApprovalId && sf.fileApprovalId === fileApprovalId && !sf.completedAt);
                const deleteSignatureFields = isCompiledFileUpdated ? initialSignatureFields.filter((sf)=>sf.fileApprovalId && sf.fileApprovalId === fileApprovalId && !updateSignatureFields.some((usf)=>usf.id === sf.id)) : initialSignatureFields.filter((sf)=>sf.fileApprovalId && sf.fileApprovalId === fileApprovalId && !sf.completedAt && !updateSignatureFields.some((usf)=>usf.id === sf.id));
                switch(signer.signatureKBAType){
                    case 'BASIC':
                        kBaFields.push({
                            type: (0, $8f7fe33a44836803$export$51940fbbacba35d4).Date,
                            description: 'dateOfBirth',
                            value: signer.dateOfBirth.format('MM/DD/YYYY')
                        });
                        kBaFields.push({
                            type: (0, $8f7fe33a44836803$export$51940fbbacba35d4).Text,
                            description: 'lastFourSSN',
                            value: signer.lastFourSSN.trim()
                        });
                        kBaFields.push({
                            type: (0, $8f7fe33a44836803$export$51940fbbacba35d4).Text,
                            description: 'name',
                            value: signer.name.trim()
                        });
                        break;
                    case 'ENHANCED':
                        kBaFields.push({
                            type: (0, $8f7fe33a44836803$export$51940fbbacba35d4).Phone,
                            description: 'mobilePhone',
                            value: signer.mobilePhone.trim()
                        });
                        break;
                    default:
                        break;
                }
                return {
                    id: fileApprovalId,
                    name: signer.signerName.trim(),
                    email: signer.signerEmail.trim().toLowerCase(),
                    action: fileApprovalId ? 'update' : 'create',
                    taskId: state.fileRequest?.FileApproval?.[index]?.Tasks?.id,
                    kBA: state.fileRequest?.FileApproval?.[index]?.completedAt // do not send id for completed KBA (to not delete them)
                     ? {
                        type: signer.signatureKBAType,
                        kBaFields: kBaFields
                    } : {
                        id: state.fileRequest?.FileApproval?.[index]?.KBA?.[0]?.id,
                        type: signer.signatureKBAType,
                        kBaFields: kBaFields
                    },
                    signatureFields: {
                        create: createSignatureFields.map((sf)=>({
                                id: sf.id,
                                page: sf.page,
                                fieldLeftPercentage: sf.fieldLeftPercentage,
                                fieldTopPercentage: sf.fieldTopPercentage,
                                fieldWidthPercentage: sf.fieldWidthPercentage,
                                fieldHeightPercentage: sf.fieldHeightPercentage,
                                fieldType: sf.fieldType,
                                title: sf.title
                            })),
                        update: updateSignatureFields.map((sf)=>({
                                id: sf.id,
                                page: sf.page,
                                fieldLeftPercentage: sf.fieldLeftPercentage,
                                fieldTopPercentage: sf.fieldTopPercentage,
                                fieldWidthPercentage: sf.fieldWidthPercentage,
                                fieldHeightPercentage: sf.fieldHeightPercentage,
                                fieldType: sf.fieldType,
                                title: sf.title
                            })),
                        delete: deleteSignatureFields.map((sf)=>({
                                id: sf.id,
                                page: sf.page,
                                fieldLeftPercentage: sf.fieldLeftPercentage,
                                fieldTopPercentage: sf.fieldTopPercentage,
                                fieldWidthPercentage: sf.fieldWidthPercentage,
                                fieldHeightPercentage: sf.fieldHeightPercentage,
                                fieldType: sf.fieldType,
                                title: sf.title
                            }))
                    }
                };
            })
        };
        // remove file approvals KBA that were not updated from updateValues array
        state.fileRequest?.FileApproval.forEach((fa)=>{
            const uFa = updateValues.fileApprovals.find((updateFileApproval)=>updateFileApproval.id === fa.id);
            if (uFa) {
                const updatedIndex = updateValues.fileApprovals.findIndex((updateFileApproval)=>updateFileApproval.id === fa.id);
                if (fa.name.trim() === uFa.name && fa.email.trim().toLowerCase() === uFa.email && fa.KBA?.[0].type === uFa.kBA.type) {
                    if (uFa.kBA.type === 'BASIC' && fa.KBA?.[0].KBAFields.find((field)=>field.description === 'dateOfBirth')?.value === uFa.kBA.kBaFields[0].value && fa.KBA?.[0].KBAFields.find((field)=>field.description === 'lastFourSSN')?.value.trim() === uFa.kBA.kBaFields[1].value && fa.KBA?.[0].KBAFields.find((field)=>field.description === 'name')?.value.trim() === uFa.kBA.kBaFields[2].value) {
                        updateValues.fileApprovals[updatedIndex].kBA.id = undefined;
                        updateValues.fileApprovals[updatedIndex].kBA.kBaFields = undefined;
                    } else if (uFa.kBA.type === 'ENHANCED' && fa.KBA?.[0].KBAFields.find((field)=>field.description === 'mobilePhone')?.value.trim() === uFa.kBA.kBaFields[0].value) {
                        updateValues.fileApprovals[updatedIndex].kBA.id = undefined;
                        updateValues.fileApprovals[updatedIndex].kBA.kBaFields = undefined;
                    } else if (uFa.kBA.type === 'WITHOUT') {
                        updateValues.fileApprovals[updatedIndex].kBA.id = undefined;
                        updateValues.fileApprovals[updatedIndex].kBA.kBaFields = undefined;
                    }
                }
            }
        });
        // if some of the approvals needs to be deleted
        const diff = state.fileRequest.FileApproval.length - signerKBAArray.length;
        if (diff > 0) for(let i = 0; i < diff; i += 1){
            const fa = state.fileRequest?.FileApproval?.[signerKBAArray.length + i];
            updateValues.fileApprovals.push({
                id: fa?.id,
                name: fa?.name,
                email: fa?.email,
                action: 'delete',
                taskId: fa?.Tasks?.id,
                kBA: {
                    id: fa?.KBA?.[0]?.id,
                    type: fa?.KBA?.[0]?.type,
                    kBaFields: fa?.KBA?.[0]?.KBAFields?.map((field)=>({
                            ...field,
                            __typename: undefined
                        }))
                }
            });
        }
        try {
            const result = await updateApprovalSignatureRequest({
                variables: {
                    input: updateValues
                }
            });
            if (result?.data?.updateApprovalSignatureRequest?.id) {
                if (isCompiledFileUpdated) {
                    const buffer = $06620ba416108982$require$Buffer.from(await compiledFile.arrayBuffer());
                    const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
                    const presignedUrlData = await updateCompiledFilePreSignedUrl({
                        variables: {
                            fileRequestId: state.fileRequest.id,
                            compiledHash: $06620ba416108982$require$Buffer.from(hashBuffer).toString('base64'),
                            fileSize: buffer.toString().length
                        }
                    });
                    if (presignedUrlData?.data?.updateCompiledFilePreSignedUrl) {
                        const fileUrl = new URL(presignedUrlData.data.updateCompiledFilePreSignedUrl);
                        await (0, (/*@__PURE__*/$parcel$interopDefault($18ae57eea10fd4c8$exports))).put(fileUrl.toString(), buffer, {
                            headers: {
                                'Content-Type': 'application/pdf'
                            }
                        });
                    }
                }
                refetchFileRequests();
                dispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).resetForm());
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Success!');
            }
            setOkButtonLoading(false);
            closeModal();
        } catch (err) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`An error has occured: ${err.message}`);
            setOkButtonLoading(false);
        }
    };
    const handleFileUpload = async (options)=>{
        console.log('handleFileUpload - options: ', options);
        // Atleast one file is uploaded. Now call the dispatch and inform the parent
        // dispatch({ type: "FILE_UPLOADED_SUCCESS", payload: state.fileUploadedSuccessCount += 1 });
        return options.onSuccess('ok');
    };
    const fileUploadOnChange = (info)=>{
        const { status: status } = info.file;
        if (status === 'uploading') console.log('Uploading');
        else if (status === 'done') {
            console.log('done uploading');
            // console.log('info.file', info.file.originFileObj);
            dispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).update({
                fileList: [
                    ...state.fileList,
                    info.file.originFileObj
                ]
            }));
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success(`${info.file.name} file uploaded successfully.`);
            const documentTitle = form.getFieldValue('documentTitle');
            if (!documentTitle) form.setFieldsValue({
                documentTitle: info.file.name
            });
            setIsCompiledFileUpdated(true);
        } else if (status === 'error') (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`${info.file.name} file upload failed.`);
    };
    const onSelectedTemplateChange = (id)=>{
        setSelectedTemplateId(id);
    };
    const onCreateTemplate = (id)=>{
        setFileToTemplateId(id);
        setCreateTemplateName('');
        setCreateTemplateModalVisible(true);
    };
    const handleCreateTemplate = async ()=>{
        const file = fileList.find((x)=>x.uid === fileToTemplateId);
        try {
            const result = await createFileTemplate({
                variables: {
                    templateName: createTemplateName,
                    fileName: file.name
                }
            });
            if (result.data.CreateFileTemplate) {
                const fileUrl = new URL(result.data.CreateFileTemplate);
                const buffer = $06620ba416108982$require$Buffer.from(await file.arrayBuffer());
                await (0, (/*@__PURE__*/$parcel$interopDefault($18ae57eea10fd4c8$exports))).put(fileUrl.toString(), buffer, {
                    headers: {
                        'Content-Type': 'application/pdf'
                    }
                });
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Template is successfully created');
                refetchFileTemplateRequest();
            }
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`An error has occured: ${error.message}`, 10);
        }
    };
    const onUseTemplate = async ()=>{
        try {
            const template = templates.find((x)=>x.id === selectedTemplateId);
            const { data: data } = await urlS3File({
                variables: {
                    s3Key: template.s3Key
                }
            });
            const response = await fetch(data?.downloadFile?.signedUrl);
            if (response.ok) {
                const blob = await response.blob();
                const file = new File([
                    blob
                ], template.fileName, {
                    type: 'application/pdf'
                });
                dispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).update({
                    fileList: [
                        ...state.fileList,
                        file
                    ],
                    eSignatureModalOkText: 'Add Signature Fields'
                }));
                const documentTitle = form.getFieldValue('documentTitle');
                if (!documentTitle) form.setFieldsValue({
                    documentTitle: template.name
                });
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Template was used');
                setIsCompiledFileUpdated(true);
            }
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Error on downloading file template', 10);
        }
    };
    const onRenameTemplate = ()=>{
        const template = templates.find((x)=>x.id === selectedTemplateId);
        setEditTemplateName(template.name);
        setEditTemplateModalVisible(true);
    };
    const handleRenameTemplate = ()=>{
        updateFileTemplate({
            variables: {
                id: selectedTemplateId,
                templateName: editTemplateName
            },
            refetchQueries: [
                (0, $1585b70f80e547b7$export$d5317a4bac0b56a8)
            ]
        });
    };
    const onDeleteTemplate = ()=>{
        setDeleteTemplateModalVisible(true);
    };
    const handleDeleteTemplate = ()=>{
        deleteFileTemplate({
            variables: {
                id: selectedTemplateId
            },
            onCompleted: ()=>{
                refetchFileTemplateRequest();
                setSelectedTemplateId('');
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Template is successfully deleted.');
            },
            onError: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Cannot delete the template.');
            }
        });
    };
    const onDeleteFile = (uid, index)=>{
        setDeletedFileIndex(index);
        setDeleteFileModalVisible(true);
    };
    const handleDeleteFile = ()=>{
        const deleteFileRemainingList = fileList.filter((file, index)=>index !== deletedFileIndex);
        dispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).update({
            // fileUploadedSuccessCount: state.fileUploadedSuccessCount += 1,
            fileList: deleteFileRemainingList,
            eSignatureModalOkText: 'Add Signature Fields',
            newDraggableBoundarySignFields: []
        }));
        setDeletedFileIndex(-1);
        setIsCompiledFileUpdated(true);
    };
    const handleRemoveApprover = async (indexToRemove)=>{
        setNumApprovers((prev)=>prev - 1);
        // Get the current form values
        const allFormValues = await form.getFieldsValue();
        // Create a new signerKBA object without the removed key using destructuring
        const { [`signerKBA[${indexToRemove}]`]: valueToRemove, ...remainingSignerKBA } = allFormValues;
        valueToRemove.dateOfBirth = null;
        valueToRemove.lastFourSSN = null;
        valueToRemove.name = null;
        valueToRemove.signatureKBAType = null;
        valueToRemove.signerEmail = null;
        valueToRemove.signerName = null;
        valueToRemove.mobilePhone = null;
        // Set the updated values back into the form
        await form.setFieldsValue({
            [`signerKBA[${indexToRemove}]`]: valueToRemove,
            ...remainingSignerKBA
        });
        // revalidate the form to enable the submit button (if button was disabled from invalid data related to deleted approver)
        validateSubmitButton();
        // remove signature fields related to the removed approver
        const tmpNewDraggableBoundarySignFields = state.newDraggableBoundarySignFields.filter((item)=>item.signerId !== `signerKBA[${indexToRemove}]`);
        dispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).update({
            newDraggableBoundarySignFields: tmpNewDraggableBoundarySignFields
        }));
    };
    const beforeUpload = (file)=>{
        const { size: size } = file;
        const maxSize = 26214400; // 25MB
        if (size > maxSize) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('File size exceeds 25MB');
            return false;
        }
        return true;
    };
    return (0, $bb3TF.jsxs)("div", {
        className: "document-sign-approve-request-modal-content",
        style: {
            height: type === 'sign' ? 510 : 420,
            overflowY: type === 'sign' ? 'scroll' : undefined,
            paddingRight: (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? 0 : 30
        },
        children: [
            (0, $bb3TF.jsx)($06620ba416108982$var$Text, {
                children: (0, $bb3TF.jsx)("b", {
                    children: "Add documents for review:"
                })
            }),
            (0, $bb3TF.jsxs)($06620ba416108982$var$Paragraph, {
                style: {
                    fontSize: 'small'
                },
                children: [
                    "Send to one or more",
                    ' ',
                    type === 'sign' ? 'signers' : 'approvers',
                    ' ',
                    "below, using basic or enhanced Knowledge-Based Authentication (KBA)"
                ]
            }),
            (0, $bb3TF.jsx)("div", {
                style: {
                    height: '10px'
                }
            }),
            templates.length > 0 && (0, $bb3TF.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4d9fbdb1e94dd1$exports))).templateContainer,
                children: [
                    (0, $bb3TF.jsx)("span", {
                        style: {
                            marginRight: 10
                        },
                        children: "Select Template:"
                    }),
                    (0, $bb3TF.jsxs)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1e4d9fbdb1e94dd1$exports))).templateSelect,
                        value: selectedTemplateId,
                        onChange: onSelectedTemplateChange,
                        children: [
                            (0, $bb3TF.jsx)($06620ba416108982$var$Option, {
                                value: "",
                                children: "Not selected"
                            }),
                            templates.map((template, index)=>(0, $bb3TF.jsx)($06620ba416108982$var$Option, {
                                    value: template.id,
                                    children: template.name
                                }, index))
                        ]
                    }),
                    selectedTemplateId && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                        children: [
                            (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                title: "Use Template",
                                children: (0, $bb3TF.jsx)((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                                    icon: (0, $bb3TF.jsx)($06620ba416108982$var$CheckCircleOutlined, {
                                        onClick: onUseTemplate
                                    })
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                title: "Rename Template",
                                children: (0, $bb3TF.jsx)((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                                    icon: (0, $bb3TF.jsx)($06620ba416108982$var$EditOutlined, {
                                        onClick: onRenameTemplate
                                    })
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                title: "Delete Template",
                                children: (0, $bb3TF.jsx)((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                                    icon: (0, $bb3TF.jsx)($06620ba416108982$var$DeleteOutlined, {
                                        onClick: onDeleteTemplate
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $9c37b10a97eda40c$export$2e2bcd8739ae039), {
                style: {
                    backgroundColor: 'aliceblue',
                    height: '200px!important'
                },
                showUploadList: false,
                accept: ".pdf",
                customRequest: handleFileUpload,
                beforeUpload: beforeUpload,
                name: "file",
                multiple: true,
                onChange: fileUploadOnChange,
                fileList: state.fileList,
                createTemplate: onCreateTemplate,
                deleteFile: onDeleteFile
            }),
            (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {}),
            (0, $bb3TF.jsx)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)($06620ba416108982$var$Paragraph, {
                    children: (0, $bb3TF.jsx)($06620ba416108982$var$Text, {
                        children: (0, $bb3TF.jsxs)("b", {
                            children: [
                                "Who needs to",
                                ' ',
                                type === 'sign' ? 'sign' : 'approve',
                                "?"
                            ]
                        })
                    })
                })
            }),
            (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                form: form,
                onFinish: (values)=>{
                    if (editMode) onUpdate(values);
                    else onFinish(values);
                },
                layout: "vertical",
                onFieldsChange: validateSubmitButton,
                children: [
                    [
                        ...Array(numApprovers)
                    ].map((_, index)=>(0, $bb3TF.jsxs)("div", {
                            children: [
                                (0, $bb3TF.jsx)((0, $326edc33cb8deaa7$export$2e2bcd8739ae039), {
                                    numApprovers: numApprovers,
                                    index: index,
                                    handleClose: ()=>handleRemoveApprover(index),
                                    type: type === 'sign' ? 'signer' : 'approver',
                                    fileRequestId: state?.fileRequest?.id,
                                    initialApproverFullName: state?.fileRequest?.FileApproval?.[index]?.name || [
                                        `${clientFirstName} ${clientLastName}`,
                                        `${client2FirstName} ${client2LastName}`
                                    ][index] || '',
                                    initialApproverEmail: state?.fileRequest?.FileApproval?.[index]?.email || [
                                        clientEmail,
                                        client2Email
                                    ][index] || '',
                                    initialApproverLastName: state?.fileRequest?.FileApproval?.[index]?.KBA?.[0].KBAFields.find((f)=>f.description === 'name')?.value || [
                                        clientLastName,
                                        client2LastName
                                    ][index] || '',
                                    initialApproverPhone: state?.fileRequest?.FileApproval?.[index]?.KBA?.[0].KBAFields.find((f)=>f.description === 'mobilePhone')?.value || [
                                        clientMobilePhone?.value,
                                        client2MobilePhone
                                    ][index] || '',
                                    initialApproverBirthday: state?.fileRequest?.FileApproval?.[index]?.KBA?.[0].KBAFields.find((f)=>f.description === 'dateOfBirth')?.value ? new Date(state.fileRequest.FileApproval[index].KBA[0].KBAFields.find((f)=>f.description === 'dateOfBirth').value) : [
                                        clientBirthday,
                                        client2Birthday
                                    ][index] || null,
                                    initialApproverLastSsn: state?.fileRequest?.FileApproval?.[index]?.KBA?.[0].KBAFields.find((f)=>f.description === 'lastFourSSN')?.value || [
                                        clientLastSsn,
                                        client2LastSsn
                                    ][index] || '',
                                    form: form,
                                    initialKbaType: state?.fileRequest?.FileApproval?.[index]?.KBA?.[0]?.type
                                }),
                                index + 1 !== numApprovers ? (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {}) : (0, $bb3TF.jsx)("div", {
                                    style: {
                                        height: '30px'
                                    }
                                })
                            ]
                        }, `signer-kba-section-${index}`)),
                    (0, $bb3TF.jsxs)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        type: "primary",
                        onClick: ()=>setNumApprovers((prev)=>prev + 1),
                        icon: (0, $bb3TF.jsx)($06620ba416108982$var$PlusOutlined, {}),
                        children: [
                            "Add",
                            ' ',
                            type === 'sign' ? 'signer' : 'approver'
                        ]
                    }),
                    (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {}),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? 8 : 4,
                                offset: (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? 0 : 4,
                                children: (0, $bb3TF.jsx)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                                    children: (0, $bb3TF.jsx)($06620ba416108982$var$Paragraph, {
                                        children: (0, $bb3TF.jsx)($06620ba416108982$var$Text, {
                                            children: (0, $bb3TF.jsx)("b", {
                                                children: "Document title"
                                            })
                                        })
                                    })
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: 12,
                                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Document title is required'
                                        }
                                    ],
                                    name: "documentTitle",
                                    extra: "The name that will be visible to the client",
                                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {})
                                })
                            })
                        ]
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? 8 : 4,
                                offset: (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? 0 : 4,
                                children: (0, $bb3TF.jsx)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                                    children: (0, $bb3TF.jsx)($06620ba416108982$var$Paragraph, {
                                        children: (0, $bb3TF.jsx)($06620ba416108982$var$Text, {
                                            children: (0, $bb3TF.jsx)("b", {
                                                children: "Note to Client"
                                            })
                                        })
                                    })
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: 12,
                                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "reviewerNotes",
                                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039).TextArea, {
                                        placeholder: "Describe what is being sent (optional)"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
                visible: deleteFileModalVisible,
                title: "Deleting this document is permanent. Are you sure?",
                onCancel: ()=>{
                    setDeleteFileModalVisible(false);
                    setDeletedFileIndex(-1);
                },
                onOk: ()=>{
                    setDeleteFileModalVisible(false);
                    handleDeleteFile();
                },
                okText: "Delete File",
                okType: "primary",
                okButtonProps: {
                    danger: true
                },
                children: (0, $bb3TF.jsx)($06620ba416108982$var$Text, {
                    children: "You are about to permanently delete this file."
                })
            }),
            (0, $bb3TF.jsxs)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
                visible: createTemplateModalVisible,
                title: "Do you really want to save this file as template?",
                onCancel: ()=>{
                    setCreateTemplateModalVisible(false);
                    setFileToTemplateId('');
                },
                onOk: ()=>{
                    setCreateTemplateModalVisible(false);
                    handleCreateTemplate();
                },
                okText: "Create Template",
                okType: "primary",
                okButtonProps: {
                    disabled: !createTemplateName.trim().length
                },
                children: [
                    (0, $bb3TF.jsx)($06620ba416108982$var$Text, {
                        children: "You are about to save the file as template. Please input the name for the template:"
                    }),
                    (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                        value: createTemplateName,
                        onChange: (e)=>setCreateTemplateName(e.target.value)
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
                visible: editTemplateModalVisible,
                title: "Rename template",
                onCancel: ()=>{
                    setEditTemplateModalVisible(false);
                },
                onOk: ()=>{
                    setEditTemplateModalVisible(false);
                    handleRenameTemplate();
                },
                okText: "Rename",
                okType: "primary",
                okButtonProps: {
                    disabled: !editTemplateName.trim().length
                },
                children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                    value: editTemplateName,
                    onChange: (e)=>setEditTemplateName(e.target.value)
                })
            }),
            (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
                visible: deleteTemplateModalVisible,
                title: "Deleting this template is permanent. Are you sure?",
                onCancel: ()=>{
                    setDeleteTemplateModalVisible(false);
                },
                onOk: ()=>{
                    setDeleteTemplateModalVisible(false);
                    handleDeleteTemplate();
                },
                okText: "Delete Template",
                okType: "primary",
                okButtonProps: {
                    danger: true
                },
                children: (0, $bb3TF.jsx)($06620ba416108982$var$Text, {
                    children: "You are about to permanently delete this template."
                })
            })
        ]
    });
};
var $06620ba416108982$export$2e2bcd8739ae039 = $06620ba416108982$var$DocumentSignApproveRequestModalContent;



const { HighlightOutlined: $8cc93469b46eb8ed$var$HighlightOutlined, FormOutlined: $8cc93469b46eb8ed$var$FormOutlined, ExclamationCircleOutlined: $8cc93469b46eb8ed$var$ExclamationCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { useForm: $8cc93469b46eb8ed$var$useForm } = (0, $6ee812964d9db826$export$2e2bcd8739ae039);
const { TabPane: $8cc93469b46eb8ed$var$TabPane } = (0, $5024ed5b7bb39672$export$2e2bcd8739ae039);
const $8cc93469b46eb8ed$var$NewESignatureRequestModal = ({ isModalVisible: isModalVisible, setIsModalVisible: setIsModalVisible, mode: mode, eSignatureAndApprovalState: eSignatureAndApprovalState, eSignatureAndApprovalDispatch: eSignatureAndApprovalDispatch, refetchFileRequests: refetchFileRequests })=>{
    // const { accessToken, firmAccountId, userId, lastName } = useAppSelector((state) => state.session);
    const [signatureFieldsTabDisabled, setSignatureFieldsTabDisabled] = (0, $6fFrj.useState)(true);
    const [okButtonLoading, setOkButtonLoading] = (0, $6fFrj.useState)(false);
    const [isCompiledFileUpdated, setIsCompiledFileUpdated] = (0, $6fFrj.useState)(false);
    const [signatureFieldsCompleted, setSignatureFieldsCompleted] = (0, $6fFrj.useState)(false);
    const { currentActiveTab: currentActiveTab } = eSignatureAndApprovalState;
    const [form] = $8cc93469b46eb8ed$var$useForm();
    (0, $6fFrj.useEffect)(()=>{
        if (eSignatureAndApprovalState.fileList?.length > 0) setSignatureFieldsTabDisabled(false);
        else setSignatureFieldsTabDisabled(true);
    }, [
        eSignatureAndApprovalState.fileList
    ]);
    const onOk = async ()=>{
        if (currentActiveTab === '1') // User has uploaded atleast one file and its upload API call is sucess.
        // Change the currentActiveTab to '2'
        try {
            await form.validateFields();
            eSignatureAndApprovalDispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).getESignModalOKButtonOnClickAction({
                currentActiveTab: '2',
                eSignatureModalOkText: 'Send For Signature',
                eSignatureModalCacelText: 'Back'
            }));
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Please fill all the mandatory fields.');
        }
        else {
            form.submit();
            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
                Title: mode === 'edit' ? 'Update signature request' : 'Create signature request',
                Source: 'Button click',
                url: window.location.href
            });
        }
    };
    const onModalExit = ()=>{
        // reset fileList and newDraggableBoundarySignFields
        eSignatureAndApprovalDispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).update({
            newDraggableBoundarySignFields: [],
            fileList: [],
            eSignatureModalOkText: 'Add Signature Fields',
            currentActiveTab: '1',
            eSignatureModalCacelText: 'Cancel',
            fileRequest: undefined
        }));
        setIsCompiledFileUpdated(false);
        setIsModalVisible(false);
    };
    const onCancel = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const { currentActiveTab: currentActiveTab, eSignatureModalCacelText: eSignatureModalCacelText } = eSignatureAndApprovalState;
        if (currentActiveTab === '2' && eSignatureModalCacelText === 'Back') eSignatureAndApprovalDispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).getESignModalCancelButtonOnClickAction({
            eSignatureModalOkText: mode === 'edit' ? 'Update Signatures' : 'Add Signature Fields',
            currentActiveTab: '1',
            eSignatureModalCacelText: 'Cancel'
        }));
        else (0, $6db0040c215ed6e9$export$2e2bcd8739ae039).confirm({
            title: 'Confirm',
            icon: (0, $bb3TF.jsx)($8cc93469b46eb8ed$var$ExclamationCircleOutlined, {}),
            content: 'Are you sure you want to quit the E-Signature process?',
            okText: 'Ok',
            cancelText: 'Cancel',
            onOk: onModalExit
        });
    };
    const tabOnClick = async (value)=>{
        try {
            await form.validateFields();
        } catch (error) {
            // form values not valid
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Please fill all the mandatory fields below.');
            eSignatureAndApprovalDispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).getESignModalTabOnChangeAction({
                currentActiveTab: '1',
                eSignatureModalOkText: mode === 'edit' ? 'Update Signatures' : 'Add Signature Fields',
                eSignatureModalCacelText: 'Cancel'
            }));
        }
    };
    const tabOnChange = (value)=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow
        let eSignatureModalOkText = '';
        let eSignatureModalCacelText = 'Cancel';
        if (value === '1') eSignatureModalOkText = mode === 'edit' ? 'Update Signatures' : 'Add Signature Fields';
        else {
            eSignatureModalCacelText = 'Back';
            eSignatureModalOkText = 'Send For Signature';
        }
        eSignatureAndApprovalDispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).getESignModalTabOnChangeAction({
            currentActiveTab: value,
            eSignatureModalOkText: eSignatureModalOkText,
            eSignatureModalCacelText: eSignatureModalCacelText
        }));
    };
    return (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        wrapClassName: "signer-kba-section-wrapper",
        bodyStyle: {
            height: 600
        },
        title: mode === 'create' ? 'Create Document Signature' : 'Edit Document Signature',
        okText: eSignatureAndApprovalState.eSignatureModalOkText,
        cancelText: eSignatureAndApprovalState.eSignatureModalCacelText,
        okButtonProps: {
            disabled: signatureFieldsTabDisabled || currentActiveTab === '2' && !signatureFieldsCompleted,
            loading: okButtonLoading
        },
        centered: true,
        visible: isModalVisible,
        onOk: onOk,
        onCancel: onCancel,
        width: 1000,
        maskClosable: false,
        destroyOnClose: true,
        children: (0, $bb3TF.jsxs)((0, $5024ed5b7bb39672$export$2e2bcd8739ae039), {
            activeKey: eSignatureAndApprovalState.currentActiveTab,
            onTabClick: tabOnClick,
            onChange: tabOnChange,
            defaultActiveKey: "1",
            style: {
                padding: '2px',
                width: 'calc(100% + 30px)'
            },
            children: [
                (0, $bb3TF.jsx)($8cc93469b46eb8ed$var$TabPane, {
                    tab: (0, $bb3TF.jsxs)("span", {
                        children: [
                            (0, $bb3TF.jsx)($8cc93469b46eb8ed$var$HighlightOutlined, {}),
                            "E Signature"
                        ]
                    }),
                    children: (0, $bb3TF.jsx)((0, $06620ba416108982$export$2e2bcd8739ae039), {
                        form: form,
                        type: "sign",
                        editMode: mode === 'edit',
                        setSendButtonDisabled: setSignatureFieldsTabDisabled,
                        dispatch: eSignatureAndApprovalDispatch,
                        state: eSignatureAndApprovalState,
                        closeModal: onModalExit,
                        setOkButtonLoading: setOkButtonLoading,
                        refetchFileRequests: refetchFileRequests,
                        isCompiledFileUpdated: isCompiledFileUpdated,
                        setIsCompiledFileUpdated: setIsCompiledFileUpdated
                    })
                }, "1"),
                (0, $bb3TF.jsx)($8cc93469b46eb8ed$var$TabPane, {
                    disabled: signatureFieldsTabDisabled,
                    tab: (0, $bb3TF.jsxs)("span", {
                        children: [
                            (0, $bb3TF.jsx)($8cc93469b46eb8ed$var$FormOutlined, {}),
                            "Signature Fields"
                        ]
                    }),
                    children: (0, $bb3TF.jsx)((0, $c2bde4dc1fe96b39$export$2e2bcd8739ae039), {
                        dispatch: eSignatureAndApprovalDispatch,
                        state: eSignatureAndApprovalState,
                        form: form,
                        editMode: mode === 'edit',
                        setSignatureFieldsCompleted: setSignatureFieldsCompleted,
                        isCompiledFileUpdated: isCompiledFileUpdated
                    })
                }, "2")
            ]
        })
    });
};
var $8cc93469b46eb8ed$export$2e2bcd8739ae039 = $8cc93469b46eb8ed$var$NewESignatureRequestModal;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");





const $21bf98074951f42f$var$DocumentApprovalRequestModal = ({ isModalVisible: isModalVisible, setIsModalVisible: setIsModalVisible, mode: mode, eSignatureAndApprovalState: eSignatureAndApprovalState, eSignatureAndApprovalDispatch: eSignatureAndApprovalDispatch, refetchFileRequests: refetchFileRequests })=>{
    const [sendButtonDisabled, setSendButtonDisabled] = (0, $6fFrj.useState)(true);
    const [okButtonLoading, setOkButtonLoading] = (0, $6fFrj.useState)(false);
    const [form] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    const [isCompiledFileUpdated, setIsCompiledFileUpdated] = (0, $6fFrj.useState)(false);
    const onOk = async ()=>{
        try {
            await form.validateFields();
            form.submit();
            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
                Title: mode === 'create' ? 'Create document approval request' : 'Update document approval request',
                Source: 'Button click',
                url: window.location.href
            });
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Please fill in all required fields.');
        }
    };
    const onCancel = ()=>{
        // reset fileList and newDraggableBoundarySignFields
        eSignatureAndApprovalDispatch((0, $86ef73c4bf765a2c$export$2e2bcd8739ae039).update({
            newDraggableBoundarySignFields: [],
            fileList: [],
            fileRequest: undefined
        }));
        setIsCompiledFileUpdated(false);
        setIsModalVisible(false);
    };
    return (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        wrapClassName: "document-approval-request-modal-wrapper",
        bodyStyle: {
            height: 450,
            overflowY: 'scroll'
        },
        title: mode === 'create' ? 'Create Document Approval' : 'Edit Document Approval',
        okText: mode === 'create' ? 'Send For Approval' : 'Update Approval',
        okButtonProps: {
            disabled: sendButtonDisabled,
            loading: okButtonLoading
        },
        centered: true,
        visible: isModalVisible,
        onOk: onOk,
        onCancel: onCancel,
        width: 1000,
        destroyOnClose: true,
        children: (0, $bb3TF.jsx)((0, $06620ba416108982$export$2e2bcd8739ae039), {
            form: form,
            type: "approve",
            editMode: mode === 'edit',
            setSendButtonDisabled: setSendButtonDisabled,
            closeModal: onCancel,
            setOkButtonLoading: setOkButtonLoading,
            state: eSignatureAndApprovalState,
            dispatch: eSignatureAndApprovalDispatch,
            refetchFileRequests: refetchFileRequests,
            isCompiledFileUpdated: isCompiledFileUpdated,
            setIsCompiledFileUpdated: setIsCompiledFileUpdated
        })
    });
};
var $21bf98074951f42f$export$2e2bcd8739ae039 = $21bf98074951f42f$var$DocumentApprovalRequestModal;


var $26ef1ea7b3ecd3ba$var$ActionType;
(function(ActionType) {
    ActionType[ActionType["INITIAL_STATE"] = 0] = "INITIAL_STATE";
    ActionType[ActionType["E_SIGN_MODAL_OK_BUTTON_CLICK"] = 1] = "E_SIGN_MODAL_OK_BUTTON_CLICK";
    ActionType[ActionType["E_SIGN_MODAL_CONTENT_TAB_ONCHANGE"] = 2] = "E_SIGN_MODAL_CONTENT_TAB_ONCHANGE";
    ActionType[ActionType["E_SIGN_MODAL_CANCEL_BUTTON_CLICK"] = 3] = "E_SIGN_MODAL_CANCEL_BUTTON_CLICK";
    ActionType[ActionType["UPDATE"] = 4] = "UPDATE";
    ActionType[ActionType["RESET_FORM"] = 5] = "RESET_FORM";
})($26ef1ea7b3ecd3ba$var$ActionType || ($26ef1ea7b3ecd3ba$var$ActionType = {}));
var $26ef1ea7b3ecd3ba$export$2e2bcd8739ae039 = $26ef1ea7b3ecd3ba$var$ActionType;



const $9fc05c2451343e9c$var$getInitialStateAction = (payload)=>({
        type: (0, $26ef1ea7b3ecd3ba$export$2e2bcd8739ae039).INITIAL_STATE,
        payload: payload
    });
const $9fc05c2451343e9c$var$getESignModalOKButtonOnClickAction = (payload)=>({
        type: (0, $26ef1ea7b3ecd3ba$export$2e2bcd8739ae039).E_SIGN_MODAL_OK_BUTTON_CLICK,
        payload: payload
    });
/**
 * This is called when the tabs inside the modal ( E Signature and Signature Fields ) are clicked.
 * @param payload
 */ const $9fc05c2451343e9c$var$getESignModalTabOnChangeAction = (payload)=>({
        type: (0, $26ef1ea7b3ecd3ba$export$2e2bcd8739ae039).E_SIGN_MODAL_CONTENT_TAB_ONCHANGE,
        payload: payload
    });
const $9fc05c2451343e9c$var$getESignModalCancelButtonOnClickAction = (payload)=>({
        type: (0, $26ef1ea7b3ecd3ba$export$2e2bcd8739ae039).E_SIGN_MODAL_CANCEL_BUTTON_CLICK,
        payload: payload
    });
const $9fc05c2451343e9c$var$update = (payload)=>({
        type: (0, $26ef1ea7b3ecd3ba$export$2e2bcd8739ae039).UPDATE,
        payload: payload
    });
const $9fc05c2451343e9c$var$resetForm = ()=>({
        type: (0, $26ef1ea7b3ecd3ba$export$2e2bcd8739ae039).RESET_FORM
    });
const $9fc05c2451343e9c$var$actionCreators = {
    getInitialStateAction: $9fc05c2451343e9c$var$getInitialStateAction,
    getESignModalOKButtonOnClickAction: $9fc05c2451343e9c$var$getESignModalOKButtonOnClickAction,
    getESignModalTabOnChangeAction: $9fc05c2451343e9c$var$getESignModalTabOnChangeAction,
    getESignModalCancelButtonOnClickAction: $9fc05c2451343e9c$var$getESignModalCancelButtonOnClickAction,
    update: $9fc05c2451343e9c$var$update,
    resetForm: $9fc05c2451343e9c$var$resetForm
};
var $9fc05c2451343e9c$export$2e2bcd8739ae039 = $9fc05c2451343e9c$var$actionCreators;


const { Paragraph: $92570d4a889a3076$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { SendOutlined: $92570d4a889a3076$var$SendOutlined, PlusOutlined: $92570d4a889a3076$var$PlusOutlined, CheckCircleOutlined: $92570d4a889a3076$var$CheckCircleOutlined, ArrowDownOutlined: $92570d4a889a3076$var$ArrowDownOutlined, UndoOutlined: $92570d4a889a3076$var$UndoOutlined, DeleteOutlined: $92570d4a889a3076$var$DeleteOutlined, CheckOutlined: $92570d4a889a3076$var$CheckOutlined, DownloadOutlined: $92570d4a889a3076$var$DownloadOutlined, EyeOutlined: $92570d4a889a3076$var$EyeOutlined, ExclamationCircleOutlined: $92570d4a889a3076$var$ExclamationCircleOutlined, EditOutlined: $92570d4a889a3076$var$EditOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $92570d4a889a3076$var$ESignatureAndApproval = ()=>{
    const [isESignatureRequestModalVisible, setIsESignatureRequestModalVisible] = (0, $6fFrj.useState)(false);
    const [isDocApprovalRequestModalVisible, setIsDocApprovalRequestModalVisible] = (0, $6fFrj.useState)(false);
    const [eSignatureApprovalMode, setESignatureApprovalMode] = (0, $6fFrj.useState)('create');
    const { showModal: showModal, accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    // context
    const { taxYearInterviewId: taxYearInterviewId, progressStatusId: progressStatusId, approvalsCompletedAt: approvalsCompletedAt, dispatch: dispatch, clientEmail: clientEmail } = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    // graphql
    // fetch all eSignature requests
    const { data: fileRequestsData, loading: loadingFileRequests, refetch: refetchFileRequests } = (0, $a5a7edef5e85165a$export$3f2950564001f69b)({
        variables: {
            taxYearInterviewId: taxYearInterviewId
        },
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    const fileRequests = fileRequestsData?.fileRequestsByTaxYearInterviewId;
    // getSignedFile
    const [urlS3File] = (0, $edf372aa0dea9531$export$4747d4e17950f93f)();
    // mutations
    // mark approved
    const [markApprovalsComplete, { loading: loadingMarkComplete }] = (0, $d4866daa2fbe65f8$export$f2c979db84f65bcb)({
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('File approvals marked as complete.');
        },
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    // resend file request
    const [resendRequest, { loading: loadingResendRequest }] = (0, $d4866daa2fbe65f8$export$54155b93e50dd70b)({
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Request re-sent.');
        },
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        },
        refetchQueries: [
            'GetFileRequetsByTaxYearInterviewId'
        ]
    });
    // remove file request
    const [removeFileRequest, { loading: loadingRemoveFileRequest }] = (0, $d4866daa2fbe65f8$export$2459b5b0c1676ef)({
        onCompleted: ()=>{
            refetchFileRequests();
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('File request deleted.');
        },
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    const [upsertJobTracking, { loading: loadingUpsertJobTracking }] = (0, $4066a7fc7221bcd4$export$5d2654c94a62b996)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    // end graphql
    const eSignatureAndApprovalReducer = (state, action)=>{
        switch(action.type){
            case (0, $26ef1ea7b3ecd3ba$export$2e2bcd8739ae039).INITIAL_STATE:
                return action.payload;
            case (0, $26ef1ea7b3ecd3ba$export$2e2bcd8739ae039).E_SIGN_MODAL_OK_BUTTON_CLICK:
                // console.log('ActionType.E_SIGN_MODAL_OK_BUTTON_CLICK ', state, action);
                return {
                    ...state,
                    ...action.payload
                };
            case (0, $26ef1ea7b3ecd3ba$export$2e2bcd8739ae039).E_SIGN_MODAL_CONTENT_TAB_ONCHANGE:
                return {
                    ...state,
                    ...action.payload
                };
            case (0, $26ef1ea7b3ecd3ba$export$2e2bcd8739ae039).E_SIGN_MODAL_CANCEL_BUTTON_CLICK:
                return {
                    ...state,
                    ...action.payload
                };
            case (0, $26ef1ea7b3ecd3ba$export$2e2bcd8739ae039).UPDATE:
                return {
                    ...state,
                    ...action.payload
                };
            case (0, $26ef1ea7b3ecd3ba$export$2e2bcd8739ae039).RESET_FORM:
                return {
                    ...state,
                    currentActiveTab: '1',
                    fileList: [],
                    eSignatureModalOkText: 'Add Signature Fields',
                    eSignatureModalCacelText: 'Cancel',
                    newDraggableBoundarySignFields: [],
                    compiledFile: null
                };
            default:
                throw new Error();
        }
    };
    const [eSignatureAndApprovalState, eSignatureAndApprovalDispatch] = (0, $6fFrj.useReducer)(eSignatureAndApprovalReducer, {
        currentActiveTab: '1',
        fileList: [],
        eSignatureModalOkText: 'Add Signature Fields',
        eSignatureModalCacelText: 'Cancel',
        newDraggableBoundarySignFields: [],
        compiledFile: null
    });
    const newESignatureRequestButtonOnClick = ()=>{
        if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).signatures]) {
            showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).signatures);
            return;
        }
        setESignatureApprovalMode('create');
        eSignatureAndApprovalDispatch((0, $9fc05c2451343e9c$export$2e2bcd8739ae039).update({
            fileRequest: undefined,
            fileList: []
        }));
        setIsESignatureRequestModalVisible(true);
        (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).MODAL_SHOW, {
            'Modal Title': 'Create new signature request',
            Source: 'Click on button',
            url: window.location.href
        });
    };
    const documentApprovalRequestButtonOnClick = ()=>{
        if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).approvals]) {
            showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).approvals);
            return;
        }
        setESignatureApprovalMode('create');
        eSignatureAndApprovalDispatch((0, $9fc05c2451343e9c$export$2e2bcd8739ae039).update({
            fileRequest: undefined,
            fileList: []
        }));
        setIsDocApprovalRequestModalVisible(true);
        (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).MODAL_SHOW, {
            'Modal Title': 'Create new document approval request',
            Source: 'Click on button',
            url: window.location.href
        });
    };
    const openLink = async (key, download = false)=>{
        try {
            const { data: data } = await urlS3File({
                variables: {
                    s3Key: key
                }
            });
            // todo: remove this once confirmed I don't need it
            // const result = await getSignedFile({
            //   variables: {
            //     s3Key: key,
            //     download,
            //   },
            // });
            // const url = result?.data?.SignedFileByS3Key;
            const url = data?.downloadFile?.signedUrl;
            window.open(url, '_blank');
        } catch (e) {
            console.log('caught error... ');
            console.warn(e);
        }
    };
    const updatefileListWithEditableFile = async (s3Key, fileName)=>{
        const { data: data } = await urlS3File({
            variables: {
                s3Key: s3Key
            }
        });
        const response = await fetch(data?.downloadFile?.signedUrl);
        if (response.ok) {
            const docBlob = await response.blob();
            eSignatureAndApprovalDispatch((0, $9fc05c2451343e9c$export$2e2bcd8739ae039).update({
                fileList: [
                    new File([
                        docBlob
                    ], fileName, {
                        type: 'application/pdf'
                    })
                ]
            }));
        }
    };
    const menuItemOnClick = (menuItem, tableRow)=>{
        // console.log('tableRow: ', tableRow);
        switch(menuItem.key){
            case 'viewOriginal':
                openLink(tableRow?.CompiledFile?.s3Key);
                break;
            case 'editFields':
                if (tableRow?.FileApproval?.[0]?.Tasks?.taskType === (0, $8f7fe33a44836803$export$1f8b1cab05cab788).Signatures) {
                    eSignatureAndApprovalDispatch((0, $9fc05c2451343e9c$export$2e2bcd8739ae039).update({
                        fileRequest: tableRow,
                        eSignatureModalOkText: 'Update Signatures'
                    }));
                    updatefileListWithEditableFile(tableRow?.CompiledFile?.s3Key, tableRow?.CompiledFile?.name);
                    setESignatureApprovalMode('edit');
                    setIsESignatureRequestModalVisible(true);
                    (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).MODAL_SHOW, {
                        'Modal Title': 'Update signature request',
                        Source: 'Click from menu',
                        url: window.location.href
                    });
                }
                if (tableRow?.FileApproval?.[0]?.Tasks?.taskType === (0, $8f7fe33a44836803$export$1f8b1cab05cab788).ApproveDocuments) {
                    eSignatureAndApprovalDispatch((0, $9fc05c2451343e9c$export$2e2bcd8739ae039).update({
                        fileRequest: tableRow,
                        eSignatureModalOkText: 'Update Signatures'
                    }));
                    updatefileListWithEditableFile(tableRow?.CompiledFile?.s3Key, tableRow?.CompiledFile?.name);
                    setESignatureApprovalMode('edit');
                    setIsDocApprovalRequestModalVisible(true);
                    (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).MODAL_SHOW, {
                        'Modal Title': 'Update document approval request',
                        Source: 'Click from menu',
                        url: window.location.href
                    });
                }
                break;
            case 'resendRequest':
            case 'resetKBA':
                resendRequest({
                    variables: {
                        fileRequestId: tableRow.id
                    }
                });
                break;
            case 'markApprovalsComplete':
                markApprovalsComplete({
                    variables: {
                        fileRequestId: tableRow.id
                    }
                });
                break;
            case 'deleteFile':
                removeFileRequest({
                    variables: {
                        id: tableRow.id
                    }
                });
                break;
            case 'downloadFinalCopy':
                openLink(tableRow?.SignedFile?.s3Key, true);
                break;
            default:
                break;
        }
    };
    const getMenuItemList = (fileRequest)=>{
        const allComplete = fileRequest?.FileApproval?.every((fileApproval)=>fileApproval.completedAt);
        const menuItems = new Array();
        if (allComplete && fileRequest.SignedFile) menuItems.push({
            key: 'downloadFinalCopy',
            title: 'Download Final Copy',
            icon: (0, $bb3TF.jsx)($92570d4a889a3076$var$DownloadOutlined, {})
        });
        menuItems.push({
            key: 'viewOriginal',
            title: 'View Original',
            icon: (0, $bb3TF.jsx)($92570d4a889a3076$var$EyeOutlined, {})
        });
        if (!allComplete) menuItems.push({
            key: 'editFields',
            title: 'Edit Fields',
            icon: (0, $bb3TF.jsx)($92570d4a889a3076$var$EditOutlined, {})
        }, {
            key: 'resendRequest',
            title: 'Resend Request',
            icon: (0, $bb3TF.jsx)($92570d4a889a3076$var$SendOutlined, {})
        }, {
            key: 'resetKBA',
            title: 'Reset KBA Attempts',
            icon: (0, $bb3TF.jsx)($92570d4a889a3076$var$UndoOutlined, {})
        }, {
            key: 'markApprovalsComplete',
            title: 'Mark as Completed',
            icon: (0, $bb3TF.jsx)($92570d4a889a3076$var$CheckOutlined, {})
        }, {
            key: 'deleteFile',
            title: 'Delete File',
            icon: (0, $bb3TF.jsx)($92570d4a889a3076$var$DeleteOutlined, {})
        });
        return menuItems;
    };
    const getStatusTag = (fileRequest)=>{
        let color = 'processing';
        let status = 'SENT';
        let icon = (0, $bb3TF.jsx)($92570d4a889a3076$var$SendOutlined, {});
        let title = null;
        const completedFileApprovals = fileRequest?.FileApproval?.filter((fileApproval)=>fileApproval.completedAt);
        // I want to show kba status failed if any of the kba attempts are greater than 2
        const failedKbaApprovals = fileRequest?.FileApproval?.filter((fileApproval)=>{
            const failedKbaAttempts = fileApproval?.KBA?.filter((kba)=>kba.numKbaFailedAttempts > 2);
            return failedKbaAttempts?.length;
        });
        if (completedFileApprovals?.length === fileRequest?.FileApproval?.length) {
            color = 'success';
            status = 'COMPLETED';
            icon = (0, $bb3TF.jsx)($92570d4a889a3076$var$CheckCircleOutlined, {});
        } else if (failedKbaApprovals?.length) {
            color = 'error';
            status = 'KBA FAILED';
            icon = (0, $bb3TF.jsx)($92570d4a889a3076$var$ExclamationCircleOutlined, {});
            title = `${failedKbaApprovals?.[0]?.name || failedKbaApprovals?.[0]?.email} failed KBA`;
        } else if (completedFileApprovals?.length === 0) {
            color = 'processing';
            status = 'SENT';
            icon = (0, $bb3TF.jsx)($92570d4a889a3076$var$SendOutlined, {});
        } else {
            color = 'processing';
            status = 'IN PROGRESS';
            icon = (0, $bb3TF.jsx)($92570d4a889a3076$var$SendOutlined, {});
            const completedNames = new Array();
            const notCompletedNames = new Array();
            fileRequest?.FileApproval.forEach((fa)=>fa.completedAt ? completedNames.push(fa.name) : notCompletedNames.push(fa.name));
            title = (0, $bb3TF.jsxs)("div", {
                style: {
                    textAlign: 'center'
                },
                children: [
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        gutter: 16,
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: 12,
                                children: (0, $bb3TF.jsx)("b", {
                                    children: "Completed"
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: 12,
                                children: (0, $bb3TF.jsx)("b", {
                                    children: "Pending"
                                })
                            })
                        ]
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        gutter: 16,
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: 12,
                                children: completedNames.map((n)=>(0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                                        children: [
                                            n,
                                            (0, $bb3TF.jsx)("br", {})
                                        ]
                                    }))
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: 12,
                                children: notCompletedNames.map((n)=>(0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                                        children: [
                                            n,
                                            (0, $bb3TF.jsx)("br", {})
                                        ]
                                    }))
                            })
                        ]
                    })
                ]
            });
        }
        return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: title,
            overlayInnerStyle: !failedKbaApprovals?.length ? {
                width: '280px'
            } : {},
            children: (0, $bb3TF.jsx)((0, $3c2758025c182ca4$export$2e2bcd8739ae039), {
                icon: icon,
                color: color,
                children: status
            }, fileRequest.id)
        });
    };
    const getCompletedDate = (fileRequest)=>{
        const completedFileApprovals = fileRequest?.FileApproval?.filter((fileApproval)=>fileApproval.completedAt);
        if (completedFileApprovals?.length === fileRequest?.FileApproval?.length) {
            // find the most recent completedAt date
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const mostRecentCompletedAt = completedFileApprovals?.reduce((mostRecentCompletedAt, fileApproval)=>{
                if (fileApproval?.completedAt > mostRecentCompletedAt) return fileApproval?.completedAt;
                return mostRecentCompletedAt;
            }, completedFileApprovals[0]?.completedAt);
            return new Date(mostRecentCompletedAt).toLocaleString('en-US', {
                weekday: 'short',
                year: 'numeric',
                month: 'short',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        }
        return null;
    };
    const columns = [
        {
            title: 'Document',
            dataIndex: 'title',
            key: 'title',
            sorter: (a, b)=>a.title.localeCompare(b.title),
            // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            render: (text, row)=>(0, $bb3TF.jsx)("a", {
                    onClick: ()=>openLink(row?.SignedFile?.s3Key || row?.CompiledFile?.s3Key),
                    children: text
                }),
            // fixed: true,
            width: 250
        },
        {
            title: 'Status',
            // dataIndex: 'signaturesComplete',
            key: 'signaturesComplete',
            sorter: (a, b)=>{
                const getStatusValue = (fileRequest)=>{
                    const completedFileApprovalsLength = fileRequest?.FileApproval?.filter((fileApproval)=>fileApproval.completedAt).length;
                    if (completedFileApprovalsLength === fileRequest?.FileApproval?.length) return 3; // All approvals completed
                    if (completedFileApprovalsLength === 0) return 1; // No approvals completed
                    return 2; // Some approvals completed
                };
                return getStatusValue(a) - getStatusValue(b);
            },
            render: (text, row)=>getStatusTag(row),
            width: 100
        },
        {
            title: 'Date Requested',
            dataIndex: 'signatureRequest',
            key: 'signatureRequest',
            sorter: (a, b)=>a.signatureRequest.localeCompare(b.signatureRequest),
            render: (text)=>(0, $bb3TF.jsx)("div", {
                    style: {
                        minWidth: 100
                    },
                    children: text ? new Date(text).toLocaleString('en-US', {
                        weekday: 'short',
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                    }) : ''
                }),
            width: 250
        },
        {
            title: 'Date Completed',
            key: 'completedAt',
            // dataIndex: 'signaturesComplete',
            sorter: (a, b)=>{
                const getMostRecentCompletedAt = (fileRequest)=>{
                    const completedFileApprovals = fileRequest?.FileApproval?.filter((fileApproval)=>fileApproval.completedAt);
                    if (completedFileApprovals?.length === fileRequest?.FileApproval?.length) // find the most recent completedAt date
                    return completedFileApprovals.reduce((mostRecent, fileApproval)=>{
                        const currentCompletedAt = new Date(fileApproval.completedAt);
                        if (currentCompletedAt > mostRecent) return currentCompletedAt;
                        return mostRecent;
                    }, new Date(completedFileApprovals[0].completedAt));
                    return new Date(0); // Return epoch date if no completions, so it will sort to the bottom
                };
                const dateA = getMostRecentCompletedAt(a);
                const dateB = getMostRecentCompletedAt(b);
                return dateA > dateB ? 1 : -1;
            },
            render: (text, row)=>(0, $bb3TF.jsx)("div", {
                    style: {
                        minWidth: 100
                    },
                    children: getCompletedDate(row)
                }),
            width: 250
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, row)=>{
                const menuItems = getMenuItemList(row);
                return menuItems.length === 1 ? (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    size: "small",
                    onClick: ()=>menuItemOnClick(menuItems[0], row),
                    children: menuItems[0].title
                }) : (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039).Button, {
                    icon: (0, $bb3TF.jsx)($92570d4a889a3076$var$ArrowDownOutlined, {}),
                    trigger: [
                        'click'
                    ],
                    size: "small",
                    onClick: ()=>menuItemOnClick(menuItems[0], row),
                    overlay: (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
                        onClick: (menuItem)=>{
                            menuItemOnClick(menuItem, row);
                        },
                        children: menuItems.slice(1).map((menuItem)=>(0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
                                danger: menuItem.key === 'deleteFile',
                                children: (0, $bb3TF.jsx)("span", {
                                    children: (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                                        children: [
                                            menuItem.icon,
                                            menuItem.title
                                        ]
                                    })
                                })
                            }, menuItem.key))
                    }),
                    children: menuItems[0].title
                });
            },
            width: 100
        }
    ];
    // eslint-disable-next-line react/no-unstable-nested-components
    function NoDataExtra() {
        return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
            children: [
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "center",
                    style: {
                        marginTop: 25
                    },
                    children: (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
                        placement: "top",
                        content: clientEmail ? null : 'Client email is required to send E-Signature requests',
                        children: (0, $bb3TF.jsx)("span", {
                            children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                type: "primary",
                                shape: "round",
                                icon: (0, $bb3TF.jsx)($92570d4a889a3076$var$PlusOutlined, {}),
                                onClick: newESignatureRequestButtonOnClick,
                                disabled: !clientEmail,
                                children: "Create your first E-Signature"
                            })
                        })
                    })
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "center",
                    style: {
                        marginTop: 10
                    },
                    children: (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
                        placement: "top",
                        content: clientEmail ? null : 'Client email is required to send document approvals',
                        children: (0, $bb3TF.jsx)("span", {
                            children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                type: "primary",
                                shape: "round",
                                icon: (0, $bb3TF.jsx)($92570d4a889a3076$var$PlusOutlined, {}),
                                onClick: documentApprovalRequestButtonOnClick,
                                disabled: !clientEmail,
                                children: "Create your first document approval"
                            })
                        })
                    })
                })
            ]
        });
    }
    const handleApprovalsComplete = ()=>{
        const today = new Date();
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    approvalsCompletedAt: today
                }
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Approvals marked completed.');
                dispatch({
                    type: 'UPDATE',
                    payload: {
                        approvalsCompletedAt: today
                    }
                });
            },
            refetchQueries: [
                {
                    query: (0, $732264f53056e08f$export$a3bc4d02ba9c53fe)
                },
                {
                    query: (0, $732264f53056e08f$export$d4e23f314f782a9d),
                    variables: {
                        progressStatusId: progressStatusId
                    }
                }
            ]
        });
    };
    const handleApprovalsNotComplete = ()=>{
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    approvalsCompletedAt: null
                }
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Approvals marked not completed.');
                dispatch({
                    type: 'UPDATE',
                    payload: {
                        approvalsCompletedAt: null
                    }
                });
            }
        });
    };
    return (0, $bb3TF.jsxs)("div", {
        style: {
            marginLeft: 5
        },
        children: [
            (0, $bb3TF.jsx)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)($92570d4a889a3076$var$Paragraph, {
                    style: {
                        marginTop: 30
                    },
                    children: "Upload any documents, such as E-File authorizations or final returns, that you would like your client to electronically review or sign."
                })
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    20,
                    10
                ],
                style: {
                    marginTop: 10,
                    marginBottom: 15
                },
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
                            placement: "top",
                            content: clientEmail ? null : 'Client email is required to send E-Signature requests',
                            children: (0, $bb3TF.jsx)("span", {
                                children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                    type: "default",
                                    icon: (0, $bb3TF.jsx)($92570d4a889a3076$var$PlusOutlined, {}),
                                    iconDirection: "left",
                                    onClick: newESignatureRequestButtonOnClick,
                                    disabled: !clientEmail,
                                    children: "New E-Signature"
                                })
                            })
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
                            placement: "top",
                            content: clientEmail ? null : 'Client email is required to send document approvals',
                            children: (0, $bb3TF.jsx)("span", {
                                children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                    type: "default",
                                    icon: (0, $bb3TF.jsx)($92570d4a889a3076$var$PlusOutlined, {}),
                                    iconDirection: "left",
                                    onClick: documentApprovalRequestButtonOnClick,
                                    disabled: !clientEmail,
                                    children: "New Document Approval"
                                })
                            })
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: !approvalsCompletedAt ? (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "primary",
                            onClick: handleApprovalsComplete,
                            icon: (0, $bb3TF.jsx)($92570d4a889a3076$var$CheckCircleOutlined, {}),
                            iconDirection: "left",
                            style: {
                                whiteSpace: 'normal',
                                height: 'auto',
                                textAlign: 'left'
                            },
                            children: "Mark E-Signatures & Approvals Complete"
                        }) : (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "default",
                            onClick: handleApprovalsNotComplete,
                            icon: (0, $bb3TF.jsx)($92570d4a889a3076$var$UndoOutlined, {}),
                            iconDirection: "left",
                            style: {
                                whiteSpace: 'normal',
                                height: 'auto',
                                textAlign: 'left'
                            },
                            children: "Mark E-Signatures & Approvals Not Complete"
                        })
                    })
                ]
            }),
            fileRequests?.length > 0 ? (0, $bb3TF.jsx)((0, $2eb2b7b37988b8f9$export$2e2bcd8739ae039), {
                columns: columns,
                rowKey: (record)=>record.id,
                // locale={{emptyText: eSignatureTableCustomEmpty() }}
                noDataProps: {
                    title: 'No documents sent yet',
                    extra: (0, $bb3TF.jsx)(NoDataExtra, {})
                },
                dataSource: fileRequests || [],
                pagination: false,
                scroll: {
                    x: true,
                    y: 320
                },
                loading: loadingFileRequests || loadingMarkComplete || loadingResendRequest || loadingRemoveFileRequest || loadingUpsertJobTracking
            }) : (0, $bb3TF.jsx)((0, $9150234f0969a884$export$2e2bcd8739ae039), {
                description: "No documents sent yet"
            }),
            (0, $bb3TF.jsx)((0, $8cc93469b46eb8ed$export$2e2bcd8739ae039), {
                isModalVisible: isESignatureRequestModalVisible,
                setIsModalVisible: setIsESignatureRequestModalVisible,
                mode: eSignatureApprovalMode,
                eSignatureAndApprovalState: eSignatureAndApprovalState,
                eSignatureAndApprovalDispatch: eSignatureAndApprovalDispatch,
                refetchFileRequests: refetchFileRequests
            }),
            (0, $bb3TF.jsx)((0, $21bf98074951f42f$export$2e2bcd8739ae039), {
                isModalVisible: isDocApprovalRequestModalVisible,
                setIsModalVisible: setIsDocApprovalRequestModalVisible,
                mode: eSignatureApprovalMode,
                eSignatureAndApprovalState: eSignatureAndApprovalState,
                eSignatureAndApprovalDispatch: eSignatureAndApprovalDispatch,
                refetchFileRequests: refetchFileRequests
            })
        ]
    });
};
var $92570d4a889a3076$export$2e2bcd8739ae039 = $92570d4a889a3076$var$ESignatureAndApproval;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");





const { SendOutlined: $0a9025b4a0ec5273$var$SendOutlined, CheckCircleOutlined: $0a9025b4a0ec5273$var$CheckCircleOutlined, UndoOutlined: $0a9025b4a0ec5273$var$UndoOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Paragraph: $0a9025b4a0ec5273$var$Paragraph, Link: $0a9025b4a0ec5273$var$Link } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
function $0a9025b4a0ec5273$var$Interview() {
    const { interviewCompletedAt: interviewCompletedAt, taxYearInterviewId: taxYearInterviewId, progressStatusId: progressStatusId, dispatch: dispatch } = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    // graphql
    const [upsertJobTracking, { loading: loadingUpsertJobTracking }] = (0, $4066a7fc7221bcd4$export$5d2654c94a62b996)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    const [sendInterview, { loading: sendInterviewLoading }] = (0, $edf372aa0dea9531$export$a505897ebde01618)();
    const handleMarkComplete = async ()=>{
        const today = new Date();
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    interviewCompletedAt: today
                }
            },
            onCompleted: ()=>{
                dispatch({
                    type: 'UPDATE',
                    payload: {
                        interviewCompletedAt: today
                    }
                });
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Interview marked as complete.');
            },
            refetchQueries: [
                {
                    query: (0, $732264f53056e08f$export$a3bc4d02ba9c53fe)
                },
                {
                    query: (0, $732264f53056e08f$export$d4e23f314f782a9d),
                    variables: {
                        progressStatusId: progressStatusId
                    }
                }
            ]
        });
    };
    const handleMarkNotComplete = async ()=>{
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    interviewCompletedAt: null
                }
            },
            onCompleted: ()=>{
                dispatch({
                    type: 'UPDATE',
                    payload: {
                        interviewCompletedAt: null
                    }
                });
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Interview marked as not complete.');
            },
            refetchQueries: [
                {
                    query: (0, $732264f53056e08f$export$a3bc4d02ba9c53fe)
                },
                {
                    query: (0, $732264f53056e08f$export$d4e23f314f782a9d),
                    variables: {
                        progressStatusId: progressStatusId
                    }
                }
            ]
        });
    };
    const handleResend = async ()=>{
        try {
            const sent = await sendInterview({
                variables: {
                    taxYearInterviewId: taxYearInterviewId
                }
            });
            if (sent.data.SendInterview.success) (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('The Interview was resent successfully.');
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('The interview could not be sent');
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to send the interview.');
        }
    };
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsxs)($0a9025b4a0ec5273$var$Paragraph, {
                style: {
                    marginTop: 30
                },
                children: [
                    "Send a pre-defined set of interview questions to your client. Answers will be populated in the\u00A0",
                    (0, $bb3TF.jsx)($0a9025b4a0ec5273$var$Link, {
                        href: `#account-client-interview-section-${taxYearInterviewId}`,
                        children: "Client Interview"
                    }),
                    ' ',
                    "section below."
                ]
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    20,
                    10
                ],
                style: {
                    marginTop: 10,
                    marginBottom: 15
                },
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "default",
                            icon: (0, $bb3TF.jsx)($0a9025b4a0ec5273$var$SendOutlined, {}),
                            iconDirection: "left",
                            onClick: handleResend,
                            loading: sendInterviewLoading,
                            children: "Resend client interview"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: !interviewCompletedAt ? (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "primary",
                            icon: (0, $bb3TF.jsx)($0a9025b4a0ec5273$var$CheckCircleOutlined, {}),
                            iconDirection: "left",
                            onClick: handleMarkComplete,
                            loading: loadingUpsertJobTracking,
                            disabled: loadingUpsertJobTracking,
                            children: "Mark interview complete"
                        }) : (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "default",
                            icon: (0, $bb3TF.jsx)($0a9025b4a0ec5273$var$UndoOutlined, {}),
                            iconDirection: "left",
                            onClick: handleMarkNotComplete,
                            loading: loadingUpsertJobTracking,
                            disabled: loadingUpsertJobTracking,
                            children: "Mark interview not complete"
                        })
                    })
                ]
            })
        ]
    });
}
var $0a9025b4a0ec5273$export$2e2bcd8739ae039 = $0a9025b4a0ec5273$var$Interview;


var $a1a69cd9d87fafd8$export$ec6bc36c360d4313;
var $a1a69cd9d87fafd8$export$d53853853de990fa;
$a1a69cd9d87fafd8$export$ec6bc36c360d4313 = `sRewgG_completed`;
$a1a69cd9d87fafd8$export$d53853853de990fa = `sRewgG_notCompleted`;



var $bb3TF = parcelRequire("bb3TF");

var $6Sgv0 = parcelRequire("6Sgv0");

var $6fFrj = parcelRequire("6fFrj");





const { CheckCircleOutlined: $6c21e4ab0172823f$var$CheckCircleOutlined, UndoOutlined: $6c21e4ab0172823f$var$UndoOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Paragraph: $6c21e4ab0172823f$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
// interface PreparationProps {}
function $6c21e4ab0172823f$var$Preparation() {
    const { dispatch: dispatch, completedAt: completedAt, taxYearInterviewId: taxYearInterviewId, progressStatusId: progressStatusId, expectedCompletion: expectedCompletion, preparationStartedAt: preparationStartedAt } = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const [selectedDate, setSelectedDate] = (0, $6fFrj.useState)(expectedCompletion ? (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(expectedCompletion) : null);
    // graphql
    const [markCompleted, { loading: loadingMarkCompleted }] = (0, $edf372aa0dea9531$export$355bcfc02b1246d4)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        },
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Job marked as completed.');
            dispatch({
                type: 'UPDATE',
                payload: {
                    completedAt: new Date()
                }
            });
        }
    });
    const [markNotCompleted, { loading: loadingMarkNotCompleted }] = (0, $edf372aa0dea9531$export$a4a0ee16bc2f284e)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        },
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Job marked as not completed.');
            dispatch({
                type: 'UPDATE',
                payload: {
                    completedAt: null
                }
            });
        }
    });
    const [upsertJobTracking, { loading: loadingUpsertJobTracking }] = (0, $4066a7fc7221bcd4$export$5d2654c94a62b996)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    const handleMarkPrepared = ()=>{
        markCompleted({
            variables: {
                id: taxYearInterviewId
            }
        });
    };
    const handleMarkPreparationStarted = (value)=>{
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    preparationStartedAt: value ? (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))().toISOString() : null
                }
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Marked preparation started.');
                dispatch({
                    type: 'UPDATE',
                    payload: {
                        preparationStartedAt: value ? new Date() : undefined
                    }
                });
            },
            refetchQueries: [
                {
                    query: (0, $732264f53056e08f$export$a3bc4d02ba9c53fe)
                },
                {
                    query: (0, $732264f53056e08f$export$d4e23f314f782a9d),
                    variables: {
                        progressStatusId: progressStatusId
                    }
                }
            ]
        });
    };
    const handleMarkNotPrepared = ()=>{
        markNotCompleted({
            variables: {
                id: taxYearInterviewId
            }
        });
    };
    const handleSaveNewDate = ()=>{
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    expectedCompletion: selectedDate?.toISOString() || null
                }
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Expected date of completion saved.');
                dispatch({
                    type: 'UPDATE',
                    payload: {
                        expectedCompletion: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(selectedDate).toDate() || null
                    }
                });
            },
            refetchQueries: [
                {
                    query: (0, $732264f53056e08f$export$a3bc4d02ba9c53fe)
                },
                {
                    query: (0, $732264f53056e08f$export$d4e23f314f782a9d),
                    variables: {
                        progressStatusId: progressStatusId
                    }
                }
            ]
        });
    };
    const onChange = (date, dateString)=>{
        console.log(date, dateString);
        setSelectedDate(date);
    };
    const renderCompletionButton = ()=>{
        if (!preparationStartedAt) return null;
        if (!completedAt) return (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
            type: "primary",
            icon: (0, $bb3TF.jsx)($6c21e4ab0172823f$var$CheckCircleOutlined, {}),
            iconDirection: "left",
            onClick: handleMarkPrepared,
            loading: loadingMarkCompleted,
            disabled: loadingMarkCompleted,
            children: "Mark as return completed"
        });
        return (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
            type: "default",
            icon: (0, $bb3TF.jsx)($6c21e4ab0172823f$var$UndoOutlined, {}),
            iconDirection: "left",
            onClick: handleMarkNotPrepared,
            loading: loadingMarkNotCompleted,
            disabled: loadingMarkNotCompleted,
            children: "Mark as return not completed"
        });
    };
    return (0, $bb3TF.jsxs)("div", {
        style: {
            marginLeft: 5
        },
        children: [
            (0, $bb3TF.jsx)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)($6c21e4ab0172823f$var$Paragraph, {
                    style: {
                        marginTop: 30
                    },
                    children: "Expected date of completion. Currently, this information is not shared with your client."
                })
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    20,
                    10
                ],
                style: {
                    marginTop: 10,
                    marginBottom: 15
                },
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $dd1293f125eb7a8a$export$2e2bcd8739ae039), {
                            onChange: onChange,
                            value: selectedDate
                        })
                    }),
                    (!(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(expectedCompletion).isSame(selectedDate, 'day') && selectedDate || !selectedDate && expectedCompletion) && (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "primary",
                            onClick: handleSaveNewDate,
                            loading: loadingUpsertJobTracking,
                            children: "Save"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: !preparationStartedAt ? (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "primary",
                            icon: (0, $bb3TF.jsx)($6c21e4ab0172823f$var$CheckCircleOutlined, {}),
                            iconDirection: "left",
                            onClick: ()=>handleMarkPreparationStarted(true),
                            loading: loadingUpsertJobTracking,
                            disabled: loadingUpsertJobTracking,
                            children: "Mark Preparation Started"
                        }) : (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "default",
                            icon: (0, $bb3TF.jsx)($6c21e4ab0172823f$var$UndoOutlined, {}),
                            iconDirection: "left",
                            onClick: ()=>handleMarkPreparationStarted(false),
                            loading: loadingUpsertJobTracking,
                            disabled: loadingUpsertJobTracking,
                            children: "Mark Preparation Not Started"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: renderCompletionButton()
                    })
                ]
            })
        ]
    });
}
var $6c21e4ab0172823f$export$2e2bcd8739ae039 = $6c21e4ab0172823f$var$Preparation;


const { CheckCircleFilled: $2b4faa95d6ffd36d$var$CheckCircleFilled, FileOutlined: $2b4faa95d6ffd36d$var$FileOutlined, ClockCircleOutlined: $2b4faa95d6ffd36d$var$ClockCircleOutlined, DollarOutlined: $2b4faa95d6ffd36d$var$DollarOutlined, LockFilled: $2b4faa95d6ffd36d$var$LockFilled, FormOutlined: $2b4faa95d6ffd36d$var$FormOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { TabPane: $2b4faa95d6ffd36d$var$TabPane } = (0, $5024ed5b7bb39672$export$2e2bcd8739ae039);
const { Panel: $2b4faa95d6ffd36d$var$Panel } = (0, $45def89f679453ce$export$2e2bcd8739ae039);
const $2b4faa95d6ffd36d$var$SubJobCollapse = (0, $7ae336b16849d71a$export$2e2bcd8739ae039)((0, $45def89f679453ce$export$2e2bcd8739ae039))`
  &.ant-collapse-borderless {
    background-color: white;
    border: 1px solid #d9d9d9;
  }
`;
function $2b4faa95d6ffd36d$var$ClientStatusTracking({ jobId: jobId }) {
    const jobContext = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const { completedAt: completedAt, interviewCompletedAt: interviewCompletedAt, paymentsCompletedAt: paymentsCompletedAt, filesCompletedAt: filesCompletedAt, approvalsCompletedAt: approvalsCompletedAt } = jobContext;
    const tabOnChange = (value)=>{
        (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).TAB_SELECT, {
            'Tab Description': 'Job Specific Status Tracking',
            'Tab Selected': value,
            url: window.location.href
        });
    };
    return (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$SubJobCollapse, {
        bordered: false,
        defaultActiveKey: [
            'tracking'
        ],
        children: (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$Panel, {
            header: "Job Specific Status Tracking",
            children: (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    0,
                    10
                ],
                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    span: 24,
                    children: (0, $bb3TF.jsxs)((0, $5024ed5b7bb39672$export$2e2bcd8739ae039), {
                        type: "card",
                        centered: true,
                        onChange: tabOnChange,
                        children: [
                            (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$TabPane, {
                                tab: (0, $bb3TF.jsxs)("span", {
                                    children: [
                                        interviewCompletedAt ? (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$CheckCircleFilled, {
                                            className: $a1a69cd9d87fafd8$export$ec6bc36c360d4313
                                        }) : (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$FormOutlined, {
                                            className: $a1a69cd9d87fafd8$export$d53853853de990fa
                                        }),
                                        "\u00A0 Interview"
                                    ]
                                }),
                                children: (0, $bb3TF.jsx)((0, $0a9025b4a0ec5273$export$2e2bcd8739ae039), {})
                            }, "Interview"),
                            (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$TabPane, {
                                tab: (0, $bb3TF.jsxs)("span", {
                                    children: [
                                        filesCompletedAt ? (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$CheckCircleFilled, {
                                            className: $a1a69cd9d87fafd8$export$ec6bc36c360d4313
                                        }) : (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$FileOutlined, {
                                            className: $a1a69cd9d87fafd8$export$d53853853de990fa
                                        }),
                                        "\u00A0 Files"
                                    ]
                                }),
                                children: (0, $bb3TF.jsx)((0, $374b9ff2696ee2b0$export$2e2bcd8739ae039), {})
                            }, "Files"),
                            (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$TabPane, {
                                tab: (0, $bb3TF.jsxs)("span", {
                                    children: [
                                        completedAt ? (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$CheckCircleFilled, {
                                            className: $a1a69cd9d87fafd8$export$ec6bc36c360d4313
                                        }) : (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$ClockCircleOutlined, {
                                            className: $a1a69cd9d87fafd8$export$d53853853de990fa
                                        }),
                                        "\u00A0 Preparation"
                                    ]
                                }),
                                children: (0, $bb3TF.jsx)((0, $6c21e4ab0172823f$export$2e2bcd8739ae039), {})
                            }, "Preparation"),
                            (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$TabPane, {
                                tab: (0, $bb3TF.jsxs)("span", {
                                    children: [
                                        paymentsCompletedAt ? (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$CheckCircleFilled, {
                                            className: $a1a69cd9d87fafd8$export$ec6bc36c360d4313
                                        }) : (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$DollarOutlined, {
                                            className: $a1a69cd9d87fafd8$export$d53853853de990fa
                                        }),
                                        "\u00A0 Payments"
                                    ]
                                }),
                                children: (0, $bb3TF.jsx)((0, $b082f0c82a59db60$export$2e2bcd8739ae039), {})
                            }, "Payments"),
                            (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$TabPane, {
                                tab: (0, $bb3TF.jsxs)("span", {
                                    children: [
                                        approvalsCompletedAt ? (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$CheckCircleFilled, {
                                            className: $a1a69cd9d87fafd8$export$ec6bc36c360d4313
                                        }) : (0, $bb3TF.jsx)($2b4faa95d6ffd36d$var$LockFilled, {
                                            className: $a1a69cd9d87fafd8$export$d53853853de990fa
                                        }),
                                        "\u00A0 E-Signatures & Approvals"
                                    ]
                                }),
                                children: (0, $bb3TF.jsx)((0, $92570d4a889a3076$export$2e2bcd8739ae039), {})
                            }, "E-Signatures & Approvals")
                        ]
                    })
                })
            })
        }, "tracking")
    });
}
var $2b4faa95d6ffd36d$export$2e2bcd8739ae039 = $2b4faa95d6ffd36d$var$ClientStatusTracking;




var $bb3TF = parcelRequire("bb3TF");

const { Text: $21e47b768259853f$var$Text, Paragraph: $21e47b768259853f$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $21e47b768259853f$var$LegacyInterviewBackup = ({ answers: answers })=>{
    const data = answers.map((a)=>a.interviewForm).flat();
    const columns = [
        {
            title: 'Section',
            dataIndex: 'sections',
            width: '25%',
            sorter: (a, b)=>{
                const section1 = a.sections?.join(' -> ') || '';
                const section2 = b.sections?.join(' -> ') || '';
                if (section1 < section2) return -1;
                if (section1 > section2) return 1;
                return 0;
            },
            render: (item)=>item?.join(' -> ') || ''
        },
        {
            title: 'Question',
            dataIndex: 'question',
            width: '25%',
            sorter: (a, b)=>{
                if (a.question < b.question) return -1;
                if (a.question > b.question) return 1;
                return 0;
            }
        },
        {
            title: 'Field Name',
            dataIndex: 'key',
            width: '25%',
            sorter: (a, b)=>{
                if (a.key < b.key) return -1;
                if (a.key > b.key) return 1;
                return 0;
            }
        },
        {
            title: 'Answer',
            dataIndex: 'answer',
            width: '25%',
            sorter: (a, b)=>{
                if (a.answer < b.answer) return -1;
                if (a.answer > b.answer) return 1;
                return 0;
            }
        }
    ];
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)($21e47b768259853f$var$Paragraph, {
                children: (0, $bb3TF.jsx)($21e47b768259853f$var$Text, {
                    children: "Not all interview data could be transferred into the main interviews fields above. Please see below for all of the data originally collected from this job."
                })
            }),
            (0, $bb3TF.jsx)((0, $2eb2b7b37988b8f9$export$2e2bcd8739ae039), {
                columns: columns,
                dataSource: data,
                pagination: {
                    pageSize: 100
                },
                bordered: true
            })
        ]
    });
};
var $21e47b768259853f$export$2e2bcd8739ae039 = $21e47b768259853f$var$LegacyInterviewBackup;


const { Panel: $bce387252e266df0$var$Panel } = (0, $45def89f679453ce$export$2e2bcd8739ae039);
const { Text: $bce387252e266df0$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { PrinterOutlined: $bce387252e266df0$var$PrinterOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $bce387252e266df0$var$MyDivider() {
    return (0, $bb3TF.jsx)("div", {
        style: {
            height: '20px'
        }
    });
}
const $bce387252e266df0$var$SubJobCollapse = (0, $7ae336b16849d71a$export$2e2bcd8739ae039)((0, $45def89f679453ce$export$2e2bcd8739ae039))`
  &.ant-collapse-borderless {
    background-color: white;
    border: 1px solid #d9d9d9;
  }
`;
const $bce387252e266df0$var$Job = ({ jobId: jobId, printInterview: printInterview, jobName: jobName })=>{
    const [expandInterviewSections, setExpandInterviewSections] = (0, $6fFrj.useState)(false);
    const { notes: notes, taxYearInterviewId: taxYearInterviewId } = (0, $6fFrj.useContext)((0, $6d76742931538b46$export$9534a7e06b098e29));
    const [updateNotes, { loading: loading }] = (0, $33beb5b1bfae180c$export$6e786766956d6d68)();
    const { data: data, loading: interviewLoading, refetch: refetchInterviews } = (0, $2d09ce9c73e1e422$export$b5e05cf0bcf238e6)({
        variables: {
            id: taxYearInterviewId
        }
    });
    const { Answers: Answers, Interviews: Interviews, LegacyTaxYearInterviewAnswers: LegacyTaxYearInterviewAnswers } = data?.GetTaxYearInterviewIncludeInterviews || {};
    const { Sections: Sections } = Interviews || {};
    const handleSaveNotes = (notesValue)=>{
        try {
            updateNotes({
                variables: {
                    id: taxYearInterviewId,
                    notes: notesValue
                },
                onCompleted: ()=>{
                    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('The job notes have been successfully saved.');
                }
            });
        } catch (err) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to update the job notes.');
        }
    };
    // action after preview closed
    window.addEventListener('afterprint', ()=>setExpandInterviewSections(false));
    return (0, $bb3TF.jsxs)("div", {
        className: "project-container",
        children: [
            (0, $bb3TF.jsx)("div", {
                className: "not-printable",
                children: (0, $bb3TF.jsx)((0, $2b4faa95d6ffd36d$export$2e2bcd8739ae039), {
                    jobId: jobId
                })
            }),
            (0, $bb3TF.jsxs)("div", {
                className: "not-printable",
                children: [
                    (0, $bb3TF.jsx)($bce387252e266df0$var$MyDivider, {}),
                    (0, $bb3TF.jsx)($bce387252e266df0$var$SubJobCollapse, {
                        bordered: false,
                        defaultActiveKey: [
                            'preparerNotes'
                        ],
                        children: (0, $bb3TF.jsx)($bce387252e266df0$var$Panel, {
                            header: "Job Specific Notes - Visible only to you and your team",
                            children: (0, $bb3TF.jsx)((0, $151752236f277880$export$2e2bcd8739ae039), {
                                initialNotes: notes,
                                onSaveNotes: handleSaveNotes,
                                loading: loading
                            })
                        }, "preparerNotes")
                    })
                ]
            }),
            (0, $bb3TF.jsxs)("div", {
                className: "not-printable",
                children: [
                    (0, $bb3TF.jsx)($bce387252e266df0$var$MyDivider, {}),
                    (0, $bb3TF.jsx)($bce387252e266df0$var$SubJobCollapse, {
                        bordered: false,
                        defaultActiveKey: [
                            'firmFiles'
                        ],
                        children: (0, $bb3TF.jsx)($bce387252e266df0$var$Panel, {
                            header: "Job Specific Firm Files - Visible only to you and your team",
                            children: (0, $bb3TF.jsx)((0, $d4f06d030d275f03$export$2e2bcd8739ae039), {
                                jobName: jobName
                            })
                        }, "firmFiles")
                    })
                ]
            }),
            (0, $bb3TF.jsxs)("div", {
                className: "not-printable",
                children: [
                    (0, $bb3TF.jsx)($bce387252e266df0$var$MyDivider, {}),
                    (0, $bb3TF.jsx)($bce387252e266df0$var$SubJobCollapse, {
                        bordered: false,
                        defaultActiveKey: [
                            'clientFiles'
                        ],
                        children: (0, $bb3TF.jsx)($bce387252e266df0$var$Panel, {
                            id: `account-client-interview-files-section-${jobId}`,
                            header: "Job Specific Client Files - Files uploaded by your client",
                            children: (0, $bb3TF.jsx)((0, $014c01a6aee2960a$export$2e2bcd8739ae039), {
                                jobName: jobName
                            })
                        }, "clientFiles")
                    })
                ]
            }),
            (0, $bb3TF.jsx)($bce387252e266df0$var$MyDivider, {}),
            (0, $bb3TF.jsx)($bce387252e266df0$var$SubJobCollapse, {
                bordered: false,
                defaultActiveKey: [
                    'clientInterview'
                ],
                children: (0, $bb3TF.jsx)($bce387252e266df0$var$Panel, {
                    id: `account-client-interview-section-${jobId}`,
                    header: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "space-between",
                        children: [
                            (0, $bb3TF.jsx)($bce387252e266df0$var$Text, {
                                children: "Job Specific Client Interview"
                            }),
                            (0, $bb3TF.jsxs)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                type: "link",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    setExpandInterviewSections(true);
                                    printInterview(jobId);
                                },
                                children: [
                                    (0, $bb3TF.jsx)($bce387252e266df0$var$PrinterOutlined, {}),
                                    "Print"
                                ]
                            })
                        ]
                    }),
                    children: (0, $bb3TF.jsx)((0, $187560d63dadb93e$export$2e2bcd8739ae039), {
                        loading: interviewLoading,
                        sections: Sections,
                        answers: Answers,
                        interview: Interviews,
                        refetchInterviews: refetchInterviews,
                        expandInterviewSections: expandInterviewSections
                    })
                }, "clientInterview")
            }),
            Boolean(LegacyTaxYearInterviewAnswers?.length) && (0, $bb3TF.jsxs)("div", {
                className: "not-printable",
                children: [
                    (0, $bb3TF.jsx)($bce387252e266df0$var$MyDivider, {}),
                    (0, $bb3TF.jsx)((0, $45def89f679453ce$export$2e2bcd8739ae039), {
                        bordered: false,
                        defaultActiveKey: [
                            'legacyInterviewAnswers'
                        ],
                        children: (0, $bb3TF.jsx)($bce387252e266df0$var$Panel, {
                            id: `account-client-interview-legacy-answers-${jobId}`,
                            header: "Job Specific Legacy Interview",
                            children: (0, $bb3TF.jsx)((0, $21e47b768259853f$export$2e2bcd8739ae039), {
                                answers: LegacyTaxYearInterviewAnswers
                            })
                        }, "legacyInterviewAnswers")
                    })
                ]
            })
        ]
    });
};
var $bce387252e266df0$export$2e2bcd8739ae039 = $bce387252e266df0$var$Job;



var $6fFrj = parcelRequire("6fFrj");

var $bb3TF = parcelRequire("bb3TF");


var $ipnkk = parcelRequire("ipnkk");

var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $6Sgv0 = parcelRequire("6Sgv0");


var $6d5deee8c992e4d8$export$f683f479e7d25898;
var $6d5deee8c992e4d8$export$268c6a1278ce4376;
var $6d5deee8c992e4d8$export$1f46647440505385;
var $6d5deee8c992e4d8$export$835ed6b7b19be598;
var $6d5deee8c992e4d8$export$b7e3ae3d7c15e42e;
var $6d5deee8c992e4d8$export$133cbe2b1babff81;
var $6d5deee8c992e4d8$export$72108e4fb43880e3;
var $6d5deee8c992e4d8$export$4b9de94284412262;
var $6d5deee8c992e4d8$export$4f502711de93d534;
$6d5deee8c992e4d8$export$f683f479e7d25898 = `Ajdtlq_addon`;
$6d5deee8c992e4d8$export$268c6a1278ce4376 = `Ajdtlq_errorInput`;
$6d5deee8c992e4d8$export$1f46647440505385 = `Ajdtlq_extraPadding`;
$6d5deee8c992e4d8$export$835ed6b7b19be598 = `Ajdtlq_innerContainer`;
$6d5deee8c992e4d8$export$b7e3ae3d7c15e42e = `Ajdtlq_input`;
$6d5deee8c992e4d8$export$133cbe2b1babff81 = `Ajdtlq_inputAddon`;
$6d5deee8c992e4d8$export$72108e4fb43880e3 = `Ajdtlq_inputContainer`;
$6d5deee8c992e4d8$export$4b9de94284412262 = `Ajdtlq_requiredInputField`;
$6d5deee8c992e4d8$export$4f502711de93d534 = `Ajdtlq_selectInput`;


const { Option: $ee43b16a73c53ab8$var$UiOption } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const { Text: $ee43b16a73c53ab8$var$UiText } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $ee43b16a73c53ab8$var$Option = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).memo($ee43b16a73c53ab8$var$UiOption);
const $ee43b16a73c53ab8$var$Select = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).memo((0, $f7b06a01f57032f1$export$2e2bcd8739ae039));
const $ee43b16a73c53ab8$var$DatePicker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).memo((0, $dd1293f125eb7a8a$export$2e2bcd8739ae039));
const $ee43b16a73c53ab8$var$Text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).memo($ee43b16a73c53ab8$var$UiText);
const $ee43b16a73c53ab8$var$allWidth = {
    width: '100%'
};
const $ee43b16a73c53ab8$var$InputType = ({ item: item, handleBlur: handleBlur, handleChange: handleChange, value: value, addonAfter: addonAfter, setFieldValue: setFieldValue, disabled: disabled })=>{
    const handleDateChange = (0, $6fFrj.useCallback)((e)=>setFieldValue(item.key, e?.toDate()?.toString() || ''), []);
    const handleInputBlur = (0, $6fFrj.useCallback)((event)=>{
        handleBlur(event);
    }, []);
    const handleInputChange = (0, $6fFrj.useCallback)((event)=>{
        handleChange(event);
    }, []);
    const handlePhoneInputChange = (0, $6fFrj.useCallback)((phoneNumber)=>{
        setFieldValue(item.key, phoneNumber);
    }, [
        setFieldValue
    ]);
    const handleSelectChange = (0, $6fFrj.useCallback)((selected)=>setFieldValue(item.key, selected), []);
    const handleCheckboxChange = (checked)=>{
        setFieldValue(item.key, checked);
    };
    if (typeof value !== 'boolean' && item.inputType !== 'checkbox') {
        if (item.inputType === 'radioButton') return (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Group, {
            name: item.key,
            value: value,
            onChange: handleInputChange,
            children: item.options && item.options.map((option)=>(0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039), {
                    value: option.value,
                    children: option.label
                }, option.label))
        });
        if (item.inputType === 'date') return (0, $bb3TF.jsx)($ee43b16a73c53ab8$var$DatePicker, {
            name: item.key,
            style: $ee43b16a73c53ab8$var$allWidth,
            onChange: handleDateChange,
            placeholder: item.placeHolder,
            value: value ? (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(value) : null,
            format: "MM/DD/YYYY",
            autoComplete: item.autoComplete || 'off'
        });
        if (item.inputType === 'textArea') return (0, $bb3TF.jsx)("textarea", {
            value: value,
            name: item.key,
            disabled: !!disabled,
            onBlur: handleInputBlur,
            onChange: handleInputChange,
            placeholder: item.placeHolder,
            className: [
                $6d5deee8c992e4d8$export$b7e3ae3d7c15e42e,
                addonAfter && $6d5deee8c992e4d8$export$133cbe2b1babff81
            ].join(' '),
            autoComplete: item.autoComplete || 'off'
        });
        if (item.inputType === 'phoneNumber') return (0, $bb3TF.jsx)((0, $5ba7d8eeafddcf67$export$2e2bcd8739ae039), {
            value: value,
            name: item.key,
            disabled: !!disabled,
            onBlur: handleInputBlur,
            onChange: handlePhoneInputChange,
            placeholder: item.placeHolder,
            className: [
                $6d5deee8c992e4d8$export$b7e3ae3d7c15e42e,
                addonAfter && $6d5deee8c992e4d8$export$133cbe2b1babff81
            ].join(' '),
            defaultCountry: "US"
        });
        if (item.inputType === 'select' && item.options) return (0, $bb3TF.jsx)($ee43b16a73c53ab8$var$Select, {
            id: item.key,
            disabled: disabled,
            onChange: handleSelectChange,
            className: $6d5deee8c992e4d8$export$4f502711de93d534,
            placeholder: item.placeHolder,
            value: value.length ? value : undefined,
            autoComplete: item.autoComplete || 'off',
            children: item.options.map(({ label: label, value: optionValue })=>(0, $bb3TF.jsx)($ee43b16a73c53ab8$var$Option, {
                    value: optionValue,
                    children: label
                }, optionValue))
        });
        if (item.inputType === 'selectJobType') return (0, $bb3TF.jsx)((0, $89a92f440564d95a$export$2e2bcd8739ae039), {
            id: item.key,
            disabled: disabled,
            onChange: handleSelectChange,
            className: $6d5deee8c992e4d8$export$4f502711de93d534,
            value: value.length ? value : undefined
        });
        return (0, $bb3TF.jsx)("input", {
            value: value,
            name: item.key,
            disabled: disabled,
            type: item.inputType,
            onBlur: handleInputBlur,
            style: {
                ...disabled ? {
                    opacity: 0.5,
                    userSelect: 'none',
                    cursor: 'not-allowed'
                } : {}
            },
            autoComplete: item.autoComplete || 'off',
            onChange: handleInputChange,
            placeholder: item.placeHolder,
            className: `${$6d5deee8c992e4d8$export$b7e3ae3d7c15e42e}${addonAfter ? ` ${$6d5deee8c992e4d8$export$133cbe2b1babff81}` : ''}`
        });
    }
    return (0, $bb3TF.jsx)((0, $66ef76fa6be8ca1a$export$2e2bcd8739ae039), {
        disabled: disabled,
        checked: item.value,
        value: item.value,
        onChange: (event)=>{
            handleCheckboxChange(event.target.checked);
        },
        children: typeof item.checkLabel !== 'function' ? item.checkLabel : item.checkLabel()
    });
};
$ee43b16a73c53ab8$var$InputType.defaultProps = {
    addonAfter: null,
    disabled: undefined
};
const $ee43b16a73c53ab8$var$Input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).memo($ee43b16a73c53ab8$var$InputType);
const $ee43b16a73c53ab8$var$redColor = {
    color: 'red'
};
const $ee43b16a73c53ab8$var$FormikInput = ({ item: item, handleBlur: handleBlur, handleChange: handleChange, errors: errors, touched: touched, value: value, addonAfter: addonAfter, setFieldValue: setFieldValue, customError: customError, disabled: disabled })=>(0, $bb3TF.jsxs)("div", {
        className: $6d5deee8c992e4d8$export$72108e4fb43880e3,
        children: [
            (0, $bb3TF.jsxs)("div", {
                children: [
                    (0, $bb3TF.jsx)($ee43b16a73c53ab8$var$Text, {
                        strong: true,
                        children: item.label
                    }),
                    item.required && (0, $bb3TF.jsx)($ee43b16a73c53ab8$var$Text, {
                        style: $ee43b16a73c53ab8$var$redColor,
                        children: " *"
                    })
                ]
            }),
            (0, $bb3TF.jsxs)("div", {
                className: [
                    $6d5deee8c992e4d8$export$835ed6b7b19be598,
                    (errors[item.key] && touched[item.key] || customError && customError.keys.find((obj)=>obj === item.key)) && $6d5deee8c992e4d8$export$268c6a1278ce4376,
                    item.inputType === 'radioButton' && errors[item.key] && touched[item.key]
                ].join(' '),
                children: [
                    (0, $bb3TF.jsx)($ee43b16a73c53ab8$var$Input, {
                        item: item,
                        value: value,
                        disabled: disabled,
                        handleBlur: handleBlur,
                        addonAfter: addonAfter,
                        handleChange: handleChange,
                        setFieldValue: setFieldValue
                    }),
                    addonAfter && (0, $bb3TF.jsx)("div", {
                        className: $6d5deee8c992e4d8$export$f683f479e7d25898,
                        children: addonAfter
                    })
                ]
            }),
            errors[item.key] && touched[item.key] && (0, $bb3TF.jsx)($ee43b16a73c53ab8$var$Text, {
                style: {
                    color: 'red'
                },
                children: errors[item.key]
            }),
            customError && customError.keys.find((obj)=>obj === item.key) && (0, $bb3TF.jsx)($ee43b16a73c53ab8$var$Text, {
                style: {
                    color: 'red'
                },
                children: customError.error
            })
        ]
    });
$ee43b16a73c53ab8$var$FormikInput.defaultProps = {
    setFieldValue: null,
    addonAfter: null,
    customError: null,
    disabled: undefined
};
var $ee43b16a73c53ab8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).memo($ee43b16a73c53ab8$var$FormikInput);







var $bfde32a6607e7300$exports = {};

$parcel$export($bfde32a6607e7300$exports, "form", function () { return $bfde32a6607e7300$export$6210fa4921d2a466; }, function (v) { return $bfde32a6607e7300$export$6210fa4921d2a466 = v; });
$parcel$export($bfde32a6607e7300$exports, "select", function () { return $bfde32a6607e7300$export$2e6c959c16ff56b8; }, function (v) { return $bfde32a6607e7300$export$2e6c959c16ff56b8 = v; });
var $bfde32a6607e7300$export$6210fa4921d2a466;
var $bfde32a6607e7300$export$2e6c959c16ff56b8;
$bfde32a6607e7300$export$6210fa4921d2a466 = `mrkpoW_form`;
$bfde32a6607e7300$export$2e6c959c16ff56b8 = `mrkpoW_select`;



var $bb3TF = parcelRequire("bb3TF");

const { InfoCircleOutlined: $4e0a5e0067eeb76c$var$InfoCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
var $4e0a5e0067eeb76c$export$2e2bcd8739ae039 = ({ jobType: jobType, taxYear: taxYear, progressStatusId: progressStatusId, sendEmail: sendEmail }, taxYearOptions, progressStatusOptions)=>[
        {
            span: {
                xs: 24
            },
            key: 'taxYear',
            value: taxYear,
            required: true,
            label: 'Tax Year',
            inputType: 'select',
            options: taxYearOptions,
            placeHolder: 'Select Tax Year'
        },
        {
            span: {
                xs: 24
            },
            key: 'jobType',
            value: jobType,
            required: true,
            label: 'Job Type',
            inputType: 'selectJobType',
            placeHolder: 'Select Job Type'
        },
        {
            span: {
                xs: 24
            },
            key: 'progressStatusId',
            value: progressStatusId,
            required: false,
            label: 'Progress Status',
            inputType: 'select',
            options: progressStatusOptions,
            placeHolder: 'Select Progress Status'
        },
        {
            span: {
                xs: 24
            },
            label: '',
            key: 'sendEmail',
            value: sendEmail,
            required: false,
            placeHolder: '',
            inputType: 'checkbox',
            checkLabel: ()=>(0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                    children: [
                        "Send email to request to ask client to complete on-boarding interview",
                        ' ',
                        (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                            title: "We will send an email on your behalf to request that the client provide their detailed tax situation.",
                            children: (0, $bb3TF.jsx)($4e0a5e0067eeb76c$var$InfoCircleOutlined, {
                                style: {
                                    fontSize: '14px'
                                }
                            })
                        })
                    ]
                })
        }
    ];



const $dd91cffe12214c11$var$schema = $ee6ba11cc5736d52$export$185802fd694ee1f5().shape({
    taxYear: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('Tax year is required'),
    jobType: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('Job type is required'),
    progressStatus: $2746dd37f1d91ea1$export$185802fd694ee1f5(),
    sendEmail: $fb77e000a80648d3$export$185802fd694ee1f5()
});
var $dd91cffe12214c11$export$2e2bcd8739ae039 = $dd91cffe12214c11$var$schema;


const { PlusOutlined: $3122576ba878099d$var$PlusOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Text: $3122576ba878099d$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $3122576ba878099d$var$TAX_YEAR_OPTIONS = (0, $02555ecb9d643fe4$export$2e2bcd8739ae039)(10);
function $3122576ba878099d$var$AddJobModal({ email: email, entityId: entityId, lastName: lastName, firstName: firstName, interviews: interviews, isModalVisible: isModalVisible, setIsModalVisible: setIsModalVisible }) {
    // get all the progressStatuses from the session
    const { progressStatuses: progressStatuses } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    // find the inProgress and unassigned statuses
    const unassignedStatus = progressStatuses.find((status)=>status.underlyingStatus === (0, $8f7fe33a44836803$export$f493388d2527ca1f).Unassigned);
    const progressStatusOptions = progressStatuses.map((x)=>({
            value: x.id,
            label: x.status,
            index: x.index
        })).sort((a, b)=>a && b ? a.index - b.index : 0);
    // graphql
    const [addJob, { loading: loading }] = (0, $edf372aa0dea9531$export$6f506beac00a714a)();
    const onSubmit = (0, $6fFrj.useCallback)(async ({ taxYear: year, jobType: interviewId, progressStatusId: progressStatusId, sendEmail: sendEmail })=>{
        if (entityId) try {
            await addJob({
                variables: {
                    addJobInput: {
                        year: year,
                        entityId: entityId,
                        interviewId: interviewId,
                        progressStatusId: progressStatusId ?? unassignedStatus.id,
                        ...sendEmail ? {
                            sendEmail: sendEmail,
                            email: email
                        } : {
                            sendEmail: sendEmail
                        }
                    }
                },
                refetchQueries: [
                    'GetAllEntityDataByEntityId',
                    'GetClients',
                    {
                        query: (0, $732264f53056e08f$export$d4e23f314f782a9d),
                        variables: {
                            progressStatusId: progressStatusId ?? unassignedStatus.id
                        }
                    }
                ]
            });
            setIsModalVisible(false);
        } catch (err) {
            if (err.message.includes('Unique constraint failed') || err.message.includes('Error code 1002')) (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`Job (${year} - ${interviews.find((i)=>i.value === interviewId).label}) is already registered.`);
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to add a new job.');
        }
    }, [
        entityId
    ]);
    const { values: values, errors: errors, touched: touched, handleBlur: handleBlur, submitForm: submitForm, handleChange: handleChange, handleSubmit: handleSubmit, resetForm: resetForm, setFieldValue: setFieldValue } = (0, $ipnkk.useFormik)({
        onSubmit: onSubmit,
        validationSchema: $dd91cffe12214c11$export$2e2bcd8739ae039,
        enableReinitialize: true,
        initialValues: {
            taxYear: '',
            jobType: '',
            progressStatusId: unassignedStatus.id,
            sendEmail: !!email
        }
    });
    const handleCancel = ()=>{
        resetForm();
        setIsModalVisible(false);
    };
    return (0, $bb3TF.jsxs)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        visible: isModalVisible,
        title: "Add Job",
        okButtonProps: {
            icon: (0, $bb3TF.jsx)($3122576ba878099d$var$PlusOutlined, {})
        },
        okText: "Add Job",
        onCancel: handleCancel,
        onOk: ()=>{
            submitForm();
        },
        children: [
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    10,
                    10
                ],
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        lg: 7,
                        children: (0, $bb3TF.jsx)($3122576ba878099d$var$Text, {
                            children: "Client Name:"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        lg: 17,
                        children: (0, $bb3TF.jsx)($3122576ba878099d$var$Text, {
                            children: `${firstName} ${lastName}`
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)("div", {
                style: {
                    height: 20
                }
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    10,
                    10
                ],
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        lg: 7,
                        children: (0, $bb3TF.jsx)($3122576ba878099d$var$Text, {
                            children: "Client Email:"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        lg: 17,
                        children: (0, $bb3TF.jsx)($3122576ba878099d$var$Text, {
                            children: email || 'Client email is not set'
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)("div", {
                style: {
                    height: 30
                }
            }),
            (0, $bb3TF.jsx)("form", {
                onSubmit: handleSubmit,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bfde32a6607e7300$exports))).form,
                children: (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    gutter: [
                        16,
                        16
                    ],
                    children: loading ? (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {}) : (0, $4e0a5e0067eeb76c$export$2e2bcd8739ae039)(values, $3122576ba878099d$var$TAX_YEAR_OPTIONS, progressStatusOptions).map((item, index)=>/*#__PURE__*/ (0, $6fFrj.createElement)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            ...item.span,
                            key: index
                        }, (0, $bb3TF.jsx)((0, $ee43b16a73c53ab8$export$2e2bcd8739ae039), {
                            item: item,
                            errors: errors,
                            touched: touched,
                            handleBlur: handleBlur,
                            value: values[item.key],
                            handleChange: handleChange,
                            setFieldValue: setFieldValue,
                            disabled: !!(item.key === 'sendEmail' && !email)
                        }, item.key)))
                })
            })
        ]
    });
}
var $3122576ba878099d$export$2e2bcd8739ae039 = $3122576ba878099d$var$AddJobModal;


const { PlusOutlined: $b6c4300dae874cfe$var$PlusOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Title: $b6c4300dae874cfe$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { Panel: $b6c4300dae874cfe$var$Panel } = (0, $45def89f679453ce$export$2e2bcd8739ae039);
const $b6c4300dae874cfe$var$JobPanel = (0, $7ae336b16849d71a$export$2e2bcd8739ae039)($b6c4300dae874cfe$var$Panel)`
  .ant-collapse-content {
    background-color: #fafafa;
  }
`;
const $b6c4300dae874cfe$var$Jobs = ({ interviews: interviews, printInterview: printInterview, printableJob: printableJob })=>{
    const taxPayerContext = (0, $6fFrj.useContext)((0, $9f8459ba594d5b47$export$7fd9bd9faa7887cb));
    const { loading: loading, entityId: entityId, ownerId: ownerId, jobs: jobs, urlTaxYearInterviewId: urlTaxYearInterviewId, firstName: firstName, lastName: lastName, email: email, phone: phoneNumber, birthday: birthday } = taxPayerContext;
    const [addJobModalVisible, setAddJobModalVisible] = (0, $6fFrj.useState)(false);
    // graphql
    const [updateTaxYearInterviewProgressStatus, { loading: loadingUpdateTaxYearInterviewProgressStatus }] = (0, $d70a105713c5d11d$export$7ff6acaf391acb3d)({
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Job status updated successfully!');
        },
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    const onStatusChange = (progressStatusId, prevProgressStatusId, jobId)=>{
        try {
            updateTaxYearInterviewProgressStatus({
                variables: {
                    id: jobId,
                    progressStatusId: progressStatusId
                },
                refetchQueries: [
                    {
                        query: (0, $732264f53056e08f$export$d4e23f314f782a9d),
                        variables: {
                            progressStatusId: progressStatusId
                        }
                    },
                    {
                        query: (0, $732264f53056e08f$export$d4e23f314f782a9d),
                        variables: {
                            progressStatusId: prevProgressStatusId
                        }
                    }
                ]
            });
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to update the job status');
        }
    };
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 12,
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsxs)($b6c4300dae874cfe$var$Title, {
                            level: 3,
                            children: [
                                "Job",
                                urlTaxYearInterviewId === '' ? 's' : ''
                            ]
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: urlTaxYearInterviewId === '' && (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "primary",
                            size: "small",
                            shape: "round",
                            icon: (0, $bb3TF.jsx)($b6c4300dae874cfe$var$PlusOutlined, {}),
                            iconDirection: "left",
                            style: {
                                marginTop: 6
                            },
                            disabled: !entityId || !email || !firstName || !lastName || !firstName && !lastName,
                            onClick: ()=>setAddJobModalVisible(true),
                            children: "Add Job"
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsxs)("div", {
                children: [
                    loading && (0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039), {
                        active: true
                    }),
                    !loading && jobs && jobs.map((taxYearInterview, index, array)=>(0, $bb3TF.jsx)((0, $6d76742931538b46$export$f8feb14ab79a59cf), {
                            entityId: entityId,
                            entityOwnerId: ownerId,
                            taxYearInterviewId: taxYearInterview.id,
                            progressStatusId: taxYearInterview.progressStatusId,
                            completedAt: taxYearInterview.completedAt,
                            filesCompletedAt: taxYearInterview?.JobTracking?.filesCompletedAt,
                            expectedCompletion: taxYearInterview?.JobTracking?.expectedCompletion,
                            paymentsCompletedAt: taxYearInterview?.JobTracking?.paymentsCompletedAt,
                            approvalsCompletedAt: taxYearInterview?.JobTracking?.approvalsCompletedAt,
                            interviewCompletedAt: taxYearInterview?.JobTracking?.interviewCompletedAt,
                            notes: taxYearInterview.notes,
                            tasks: taxYearInterview.Tasks,
                            clientFirstName: firstName,
                            clientLastName: lastName,
                            clientEmail: email,
                            clientMobilePhone: phoneNumber,
                            clientBirthday: birthday,
                            children: (0, $bb3TF.jsx)("div", {
                                className: printableJob && printableJob !== taxYearInterview.id ? 'not-printable' : '',
                                children: (0, $bb3TF.jsx)((0, $45def89f679453ce$export$2e2bcd8739ae039), {
                                    style: {
                                        ...index !== array.length - 1 ? {
                                            marginBottom: 20
                                        } : {}
                                    },
                                    defaultActiveKey: `job-panel-${urlTaxYearInterviewId}` || `job-panel-${array[0].id}`,
                                    children: (0, $bb3TF.jsx)($b6c4300dae874cfe$var$JobPanel, {
                                        header: taxYearInterview.TaxYear?.year && taxYearInterview.Interviews?.name ? `${taxYearInterview.TaxYear?.year} - ${taxYearInterview.Interviews?.name}` : (0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039).Button, {
                                            size: "small",
                                            shape: "round",
                                            style: {
                                                width: 200
                                            }
                                        }),
                                        extra: (0, $bb3TF.jsx)((0, $7a42c79474d8eff4$export$2e2bcd8739ae039), {
                                            progressStatusId: taxYearInterview.progressStatusId,
                                            taxYear: taxYearInterview.TaxYear?.year,
                                            onChange: (progressStatusId)=>{
                                                onStatusChange(progressStatusId, taxYearInterview.progressStatusId, taxYearInterview.id);
                                            },
                                            interviewId: taxYearInterview.Interviews?.id,
                                            interviewName: taxYearInterview.Interviews?.name,
                                            loading: loadingUpdateTaxYearInterviewProgressStatus
                                        }),
                                        children: (0, $bb3TF.jsx)((0, $bce387252e266df0$export$2e2bcd8739ae039), {
                                            jobId: taxYearInterview.id,
                                            printInterview: printInterview,
                                            jobName: `${taxYearInterview.TaxYear?.year}-${taxYearInterview.Interviews?.name}`
                                        }, taxYearInterview.id)
                                    }, `job-panel-${taxYearInterview.id}`)
                                }, `job-collapse-${taxYearInterview.id}`)
                            })
                        }, taxYearInterview.id))
                ]
            }),
            (0, $bb3TF.jsx)((0, $3122576ba878099d$export$2e2bcd8739ae039), {
                entityId: entityId ?? '',
                interviews: interviews?.map(({ id: interview, name: name })=>({
                        value: interview,
                        label: name
                    })) ?? [],
                email: email,
                firstName: firstName ?? '',
                lastName: lastName ?? '',
                isModalVisible: addJobModalVisible,
                setIsModalVisible: setAddJobModalVisible
            })
        ]
    });
};
var $b6c4300dae874cfe$export$2e2bcd8739ae039 = $b6c4300dae874cfe$var$Jobs;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




var $bb3TF = parcelRequire("bb3TF");



const $0f9e8e0778fd324a$export$e692585c84074313 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Activation sent succesfully!');
};
const $0f9e8e0778fd324a$export$85b43ea59a8cb058 = (error)=>{
    const errorMessage = error?.graphQLErrors?.[0]?.message;
    if (errorMessage === 'Error code 1022') (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error has occurred, the user has been already activated.');
    else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(errorMessage);
};


const { SendOutlined: $3c3dd6e2f8260b95$var$SendOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $3c3dd6e2f8260b95$var$ResendActivationEmailButton = ({ userId: userId })=>{
    const [resendEmailActivation, { loading: loadingResendEmailActivation }] = (0, $edf372aa0dea9531$export$e475b5f069030ded)({
        onCompleted: (0, $0f9e8e0778fd324a$export$e692585c84074313),
        onError: (0, $0f9e8e0778fd324a$export$85b43ea59a8cb058)
    });
    const handleSendActivation = async ()=>{
        await resendEmailActivation({
            variables: {
                userId: userId
            }
        });
    };
    return (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
        type: "link",
        // size="small"
        icon: (0, $bb3TF.jsx)($3c3dd6e2f8260b95$var$SendOutlined, {}),
        iconDirection: "left",
        loading: loadingResendEmailActivation,
        onClick: ()=>handleSendActivation(),
        children: "Send Activation Email"
    });
};
var $3c3dd6e2f8260b95$export$2e2bcd8739ae039 = $3c3dd6e2f8260b95$var$ResendActivationEmailButton;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



const { UserOutlined: $ee238ab0e18490ad$var$UserOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $ee238ab0e18490ad$var$LoginAsClientButton = ({ userId: userId })=>{
    const [encryptToken, setEncryptToken] = (0, $6fFrj.useState)(null);
    const [encryptTokenError, setEncryptTokenError] = (0, $6fFrj.useState)(null);
    const [encryptMyToken, { loading: loadingEncryptMyToken }] = (0, $edf372aa0dea9531$export$e667747ad459634e)({
        onError: (error)=>{
            const errorMessage = error.graphQLErrors?.at(0)?.message;
            const isPasswordError = errorMessage && errorMessage.indexOf('password') > 0;
            if (isPasswordError) setEncryptTokenError('Login is not possible because the client account has not been activated yet.');
            else setEncryptTokenError(errorMessage);
        }
    });
    const fetchEncryptToken = async ()=>{
        const result = await encryptMyToken();
        setEncryptToken(result.data);
    };
    (0, $6fFrj.useEffect)(()=>{
        fetchEncryptToken();
    }, []);
    const url = encryptToken?.EncryptMyToken?.headToURL;
    const token = encodeURIComponent(encryptToken?.EncryptMyToken?.accessToken);
    const handleLoginAsClient = async ()=>{
        if (!url || !token) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(encryptTokenError);
            return;
        }
        window.open(`${url}?token=${token}&userId=${userId}`, '_blank', 'noreferrer');
        (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
            Title: 'Login as client',
            Source: 'Button click',
            url: window.location.href
        });
    };
    return (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
        type: "link",
        // size="small"
        icon: (0, $bb3TF.jsx)($ee238ab0e18490ad$var$UserOutlined, {}),
        iconDirection: "left",
        onClick: ()=>handleLoginAsClient(),
        children: "Log in as client"
    });
};
var $ee238ab0e18490ad$export$2e2bcd8739ae039 = $ee238ab0e18490ad$var$LoginAsClientButton;




var $bb3TF = parcelRequire("bb3TF");


const { MobileOutlined: $d637e76af0848ec5$var$MobileOutlined, BankOutlined: $d637e76af0848ec5$var$BankOutlined, PhoneOutlined: $d637e76af0848ec5$var$PhoneOutlined, HomeOutlined: $d637e76af0848ec5$var$HomeOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $d637e76af0848ec5$var$getPhoneIcon = (phone)=>{
    if (!phone) return undefined;
    if (phone.type === (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Mobile) return (0, $bb3TF.jsx)($d637e76af0848ec5$var$MobileOutlined, {
        title: "Mobile Number"
    });
    if (phone.type === (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Work) return (0, $bb3TF.jsx)($d637e76af0848ec5$var$PhoneOutlined, {
        title: "Work Number"
    });
    if (phone.type === (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Landline) return (0, $bb3TF.jsx)($d637e76af0848ec5$var$HomeOutlined, {
        title: "Landline Number"
    });
    return undefined;
};
var $d637e76af0848ec5$export$2e2bcd8739ae039 = $d637e76af0848ec5$var$getPhoneIcon;




var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


const { Option: $b3c9965b4dc9ea15$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const { UserOutlined: $b3c9965b4dc9ea15$var$UserOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $b3c9965b4dc9ea15$var$UpdateClientInfoModal({ setIsModalVisible: setIsModalVisible, isModalVisible: isModalVisible }) {
    const [form] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    const onSubmit = (0, $6fFrj.useCallback)((values)=>{
        console.log('values:', values);
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Client Updated!');
        setIsModalVisible(false);
    }, [
        setIsModalVisible
    ]);
    const handleCancel = (0, $6fFrj.useCallback)(()=>{
        form.resetFields();
        setIsModalVisible(false);
    }, [
        form,
        setIsModalVisible
    ]);
    return (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        visible: isModalVisible,
        title: "Edit Client Info",
        okButtonProps: {
            icon: (0, $bb3TF.jsx)($b3c9965b4dc9ea15$var$UserOutlined, {})
        },
        okText: "Update Client",
        onCancel: handleCancel,
        onOk: form.submit,
        children: (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
            layout: "vertical",
            form: form,
            onFinish: onSubmit,
            // eslint-disable-next-line no-template-curly-in-string
            validateMessages: {
                required: '${label} is required'
            },
            children: [
                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "firstName",
                    label: "First Name",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                        placeholder: "Taxpayer First Name"
                    })
                }),
                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "lastName",
                    label: "Last Name",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                        placeholder: "Taxpayer Last Name"
                    })
                }),
                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "email",
                    label: "Email",
                    rules: [
                        {
                            required: true,
                            type: 'email'
                        }
                    ],
                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                        placeholder: "Taxpayer Email"
                    })
                }),
                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "phone",
                    label: "Phone",
                    rules: [
                        {
                            required: true,
                            type: 'string'
                        }
                    ],
                    children: (0, $bb3TF.jsx)((0, $5ba7d8eeafddcf67$export$2e2bcd8739ae039), {
                        onChange: (value)=>form.setFieldsValue({
                                phone: value
                            })
                    })
                }),
                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "language",
                    label: "Language",
                    rules: [
                        {
                            required: false
                        }
                    ],
                    children: (0, $bb3TF.jsxs)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                        placeholder: "Select language",
                        onChange: (value)=>form.setFieldsValue({
                                taxYear: value
                            }),
                        children: [
                            (0, $bb3TF.jsx)($b3c9965b4dc9ea15$var$Option, {
                                value: "english",
                                children: "English"
                            }, "english"),
                            (0, $bb3TF.jsx)($b3c9965b4dc9ea15$var$Option, {
                                value: "spanish",
                                children: "Spanish"
                            }, "spanish")
                        ]
                    })
                })
            ]
        })
    });
}
var $b3c9965b4dc9ea15$export$2e2bcd8739ae039 = $b3c9965b4dc9ea15$var$UpdateClientInfoModal;


var $1e7f58118825d5bd$export$a40ebde8ba896166;
var $1e7f58118825d5bd$export$1d34bab5b94e8b98;
$1e7f58118825d5bd$export$a40ebde8ba896166 = `jyt0Da_breadcrumb`;
$1e7f58118825d5bd$export$1d34bab5b94e8b98 = `jyt0Da_reload-icon`;


const { useBreakpoint: $b0289edaf6f6d374$var$useBreakpoint } = (0, $89d88a41b53d163f$export$2e2bcd8739ae039);
const { PlusCircleOutlined: $b0289edaf6f6d374$var$PlusCircleOutlined, MobileOutlined: $b0289edaf6f6d374$var$MobileOutlined, MailOutlined: $b0289edaf6f6d374$var$MailOutlined, MessageOutlined: $b0289edaf6f6d374$var$MessageOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $b0289edaf6f6d374$var$UnderlineLink = (0, $7ae336b16849d71a$export$2e2bcd8739ae039).a`
  &:hover {
    text-decoration: underline;
    text-decoration-color: '#0076e2';
    text-decoration-thickness: 2px;
    text-underline-offset: 2px;
  }
`;
function $b0289edaf6f6d374$var$ProfileCard({ interviews: interviews }) {
    const taxPayerContext = (0, $6fFrj.useContext)((0, $9f8459ba594d5b47$export$7fd9bd9faa7887cb));
    const { email: email, phone: phoneNumber, firstName: firstName, lastName: lastName, entityId: entityId, ownerId: ownerId, deleteAt: deleteAt } = taxPayerContext;
    const [clientInfoModalVisible, setClientInfoModalVisible] = (0, $6fFrj.useState)(false);
    const [addJobModalVisible, setAddJobModalVisible] = (0, $6fFrj.useState)(false);
    const screens = $b0289edaf6f6d374$var$useBreakpoint();
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            deleteAt && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                type: "error",
                message: "This client has been deleted.",
                style: {
                    marginBottom: 10
                }
            }),
            (0, $bb3TF.jsx)((0, $9ce2b479d453b45d$export$2e2bcd8739ae039), {
                className: $1e7f58118825d5bd$export$a40ebde8ba896166,
                items: [
                    {
                        label: 'Client Dashboard',
                        href: '/'
                    },
                    {
                        label: `${firstName ?? ''} ${lastName ?? ''}`
                    }
                ]
            }),
            (0, $bb3TF.jsx)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                headStyle: {
                    display: 'none'
                },
                bodyStyle: {
                    paddingTop: 8,
                    paddingBottom: 8
                },
                style: screens.xl ? {
                    position: 'sticky',
                    top: '50px',
                    zIndex: 2,
                    margin: '0 auto'
                } : {},
                children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    gutter: [
                        0,
                        10
                    ],
                    justify: "space-between",
                    children: [
                        Boolean(phoneNumber) && (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsxs)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                type: "link",
                                children: [
                                    (0, $d637e76af0848ec5$export$2e2bcd8739ae039)(phoneNumber),
                                    ' ',
                                    (0, $bb3TF.jsx)($b0289edaf6f6d374$var$UnderlineLink, {
                                        href: "tel:",
                                        children: (0, $8ffa95678d96c8dd$export$88012462592bc004)(phoneNumber.value)
                                    })
                                ]
                            })
                        }),
                        Boolean(email) && (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsxs)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                type: "link",
                                children: [
                                    (0, $bb3TF.jsx)($b0289edaf6f6d374$var$MailOutlined, {}),
                                    ' ',
                                    (0, $bb3TF.jsx)($b0289edaf6f6d374$var$UnderlineLink, {
                                        href: `mailto:${email}`,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: email
                                    })
                                ]
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsxs)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                type: "link",
                                children: [
                                    (0, $bb3TF.jsx)($b0289edaf6f6d374$var$MessageOutlined, {}),
                                    ' ',
                                    (0, $bb3TF.jsx)($b0289edaf6f6d374$var$UnderlineLink, {
                                        href: `/chat?userToChatWith=${ownerId}&description=${encodeURIComponent(`${firstName} ${lastName}`)}`,
                                        children: "Messaging"
                                    })
                                ]
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                type: "link",
                                // size="small"
                                icon: (0, $bb3TF.jsx)($b0289edaf6f6d374$var$PlusCircleOutlined, {}),
                                iconDirection: "left",
                                onClick: ()=>setAddJobModalVisible(true),
                                children: "Add Job"
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsx)((0, $3c3dd6e2f8260b95$export$2e2bcd8739ae039), {
                                userId: ownerId
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsx)((0, $ee238ab0e18490ad$export$2e2bcd8739ae039), {
                                userId: ownerId
                            })
                        })
                    ]
                })
            }),
            (0, $bb3TF.jsx)((0, $b3c9965b4dc9ea15$export$2e2bcd8739ae039), {
                isModalVisible: clientInfoModalVisible,
                setIsModalVisible: setClientInfoModalVisible
            }),
            (0, $bb3TF.jsx)((0, $3122576ba878099d$export$2e2bcd8739ae039), {
                entityId: entityId,
                isModalVisible: addJobModalVisible,
                setIsModalVisible: setAddJobModalVisible,
                email: email,
                lastName: lastName,
                firstName: firstName,
                interviews: interviews?.map(({ name: name, id: id })=>({
                        label: name,
                        value: id
                    }))
            })
        ]
    });
}
var $b0289edaf6f6d374$export$2e2bcd8739ae039 = $b0289edaf6f6d374$var$ProfileCard;





var $6fFrj = parcelRequire("6fFrj");

function $db098769933d8656$var$Divider() {
    return (0, $bb3TF.jsx)("div", {
        style: {
            height: '30px'
        }
    });
}
function $db098769933d8656$var$Client() {
    const { data: interviewsData } = (0, $774cc9a1c383b6aa$export$194d4356b994f52)();
    const [initialActiveKeys, setInitialActiveKeys] = (0, $6fFrj.useState)([
        'client-info'
    ]);
    const [printableJob, setPrintableJob] = (0, $6fFrj.useState)('');
    const printInterview = (taxYearInterviewId)=>{
        setInitialActiveKeys([
            'client-info',
            'notes'
        ]);
        setPrintableJob(taxYearInterviewId);
        setTimeout(()=>window.print(), 500);
        (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
            Title: 'Print interview',
            Source: 'Button click',
            url: window.location.href
        });
    };
    // action after preview closed
    window.addEventListener('afterprint', ()=>{
        setInitialActiveKeys([]);
        setPrintableJob('');
    });
    return (0, $bb3TF.jsxs)((0, $9f8459ba594d5b47$export$8624ff1b6d3ea6ae), {
        children: [
            (0, $bb3TF.jsx)((0, $b0289edaf6f6d374$export$2e2bcd8739ae039), {
                interviews: interviewsData?.interviewNames ?? []
            }),
            (0, $bb3TF.jsx)($db098769933d8656$var$Divider, {}),
            (0, $bb3TF.jsx)((0, $b82c4e45f6e5d15e$export$2e2bcd8739ae039), {
                initialActiveKeys: initialActiveKeys
            }),
            (0, $bb3TF.jsx)($db098769933d8656$var$Divider, {}),
            (0, $bb3TF.jsx)((0, $b6c4300dae874cfe$export$2e2bcd8739ae039), {
                interviews: interviewsData?.interviewNames ?? [],
                printInterview: printInterview,
                printableJob: printableJob
            })
        ]
    });
}
var $db098769933d8656$export$2e2bcd8739ae039 = $db098769933d8656$var$Client;


// interface DashboardProps {}
const $2fb70ad5439dfc40$var$ClientDetails = ()=>(0, $bb3TF.jsx)((0, $db098769933d8656$export$2e2bcd8739ae039), {});
var $2fb70ad5439dfc40$export$2e2bcd8739ae039 = $2fb70ad5439dfc40$var$ClientDetails;


var $2d5c0cd7350fded7$export$2e2bcd8739ae039 = (0, $2fb70ad5439dfc40$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");

var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");











var $bb3TF = parcelRequire("bb3TF");


const $f1120d6cd6b5f938$var$style = {
    textAlign: 'center',
    lineHeight: 'normal',
    float: 'left'
};
const $f1120d6cd6b5f938$var$DroppableTabPane = ({ node: node, name: name, id: id })=>{
    const [{ canDrop: canDrop, isOver: isOver }, drop] = (0, $985e950531ae07dc$export$ccdee5eaf73cf661)(()=>({
            accept: 'box',
            drop: ()=>({
                    name: name,
                    id: id
                }),
            collect: (monitor)=>({
                    isOver: monitor.isOver(),
                    canDrop: monitor.canDrop()
                })
        }));
    const animationName = canDrop ? 'beat' : '';
    const isOverStyle = isOver ? {
        zoom: 1.1
    } : {};
    const animationStyleApply = canDrop ? {
        animation: 'beat .75s alternate'
    } : {};
    // const animationStyleApply = canDrop ? { textShadow: '2px' } : {};
    // console.log("Actual canDrop: ", canDrop, "isOver: ", isOver);
    return (0, $bb3TF.jsx)("div", {
        style: {
            ...$f1120d6cd6b5f938$var$style,
            animationName: animationName,
            ...animationStyleApply,
            ...isOverStyle
        },
        ref: drop,
        role: "Dustbin",
        children: node
    });
};
var $f1120d6cd6b5f938$export$2e2bcd8739ae039 = $f1120d6cd6b5f938$var$DroppableTabPane;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");






var $bb3TF = parcelRequire("bb3TF");


const $259896312063de80$var$DraggableBodyRow = ({ index: index, moveRow: moveRow, className: className, style: style, ...props })=>{
    const restProps = {
        ...props
    };
    const { children: children } = restProps;
    delete restProps.children;
    const tableRowKeyJson = JSON.parse(JSON.stringify(restProps));
    // console.log("tableRowKeyJson: ", tableRowKeyJson);
    restProps.children = children;
    const [{ isDragging: isDragging }, drag] = (0, $da77e72f9345f56b$export$7941f8aafa4b6021)(()=>({
            type: 'box',
            item: {
                index: index
            },
            end: (item, monitor)=>{
                const dropResult = monitor.getDropResult();
                console.log('item: ', item, 'monitor: ', monitor, 'dropResult: ', dropResult);
                if (item && dropResult) moveRow(tableRowKeyJson['data-row-key'], dropResult);
            },
            collect: (monitor)=>({
                    isDragging: monitor.isDragging(),
                    handlerId: monitor.getHandlerId()
                })
        }));
    const opacity = isDragging ? 0.4 : 1;
    // const animationName = isDragging ? 'beat': '';
    // const animationStyle = isDragging ? {animation: 'beat .25s infinite alternate'} : {};
    // const color = isDragging ? "var(--primary-dark)": '';
    if (className === 'ant-table-expanded-row ant-table-expanded-row-level-1 expandedSection') {
        console.log('found subsection');
        return (0, $bb3TF.jsx)("tr", {
            // role="Box"
            className: `${className}`,
            style: {
                cursor: 'default',
                backgroundColor: 'aliceblue',
                ...style
            },
            ...restProps
        });
    }
    if (className === 'ant-table-placeholder') return (0, $bb3TF.jsx)("tr", {
        // role="Box"
        className: `${className}`,
        style: {
            cursor: 'default',
            backgroundColor: 'aliceblue',
            ...style
        },
        ...restProps
    });
    return (0, $bb3TF.jsx)("tr", {
        ref: drag,
        className: `${className}`,
        style: {
            opacity: opacity,
            cursor: 'move',
            backgroundColor: 'aliceblue',
            ...style
        },
        ...restProps
    });
};
var $259896312063de80$export$2e2bcd8739ae039 = $259896312063de80$var$DraggableBodyRow;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");








var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $e829570e739753a7$exports = {};


!function(e, t) {
    $e829570e739753a7$exports = t((parcelRequire("6fFrj")), (parcelRequire("8CZEB")));
}("undefined" != typeof self ? self : $e829570e739753a7$exports, function(e, t) {
    return function() {
        "use strict";
        var n = {
            655: function(e, t, n) {
                n.r(t), n.d(t, {
                    __extends: function() {
                        return o;
                    },
                    __assign: function() {
                        return i;
                    },
                    __rest: function() {
                        return a;
                    },
                    __decorate: function() {
                        return l;
                    },
                    __param: function() {
                        return c;
                    },
                    __metadata: function() {
                        return u;
                    },
                    __awaiter: function() {
                        return s;
                    },
                    __generator: function() {
                        return f;
                    },
                    __createBinding: function() {
                        return d;
                    },
                    __exportStar: function() {
                        return p;
                    },
                    __values: function() {
                        return h;
                    },
                    __read: function() {
                        return y;
                    },
                    __spread: function() {
                        return b;
                    },
                    __spreadArrays: function() {
                        return g;
                    },
                    __spreadArray: function() {
                        return m;
                    },
                    __await: function() {
                        return v;
                    },
                    __asyncGenerator: function() {
                        return w;
                    },
                    __asyncDelegator: function() {
                        return _;
                    },
                    __asyncValues: function() {
                        return P;
                    },
                    __makeTemplateObject: function() {
                        return O;
                    },
                    __importStar: function() {
                        return x;
                    },
                    __importDefault: function() {
                        return E;
                    },
                    __classPrivateFieldGet: function() {
                        return T;
                    },
                    __classPrivateFieldSet: function() {
                        return j;
                    },
                    __classPrivateFieldIn: function() {
                        return A;
                    }
                });
                var r = function(e, t) {
                    return r = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    }, r(e, t);
                };
                function o(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function n() {
                        this.constructor = e;
                    }
                    r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
                }
                var i = function() {
                    return i = Object.assign || function(e) {
                        for(var t, n = 1, r = arguments.length; n < r; n++)for(var o in t = arguments[n])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                        return e;
                    }, i.apply(this, arguments);
                };
                function a(e, t) {
                    var n = {};
                    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var o = 0;
                        for(r = Object.getOwnPropertySymbols(e); o < r.length; o++)t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
                    }
                    return n;
                }
                function l(e, t, n, r) {
                    var o, i = arguments.length, a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);
                    else for(var l = e.length - 1; l >= 0; l--)(o = e[l]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
                    return i > 3 && a && Object.defineProperty(t, n, a), a;
                }
                function c(e, t) {
                    return function(n, r) {
                        t(n, r, e);
                    };
                }
                function u(e, t) {
                    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
                }
                function s(e, t, n, r) {
                    return new (n || (n = Promise))(function(o, i) {
                        function a(e) {
                            try {
                                c(r.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function l(e) {
                            try {
                                c(r.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                e(t);
                            })).then(a, l);
                        }
                        c((r = r.apply(e, t || [])).next());
                    });
                }
                function f(e, t) {
                    var n, r, o, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & o[0]) throw o[1];
                            return o[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: l(0),
                        throw: l(1),
                        return: l(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function l(l) {
                        return function(c) {
                            return function(l) {
                                if (n) throw new TypeError("Generator is already executing.");
                                for(; i && (i = 0, l[0] && (a = 0)), a;)try {
                                    if (n = 1, r && (o = 2 & l[0] ? r.return : l[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, l[1])).done) return o;
                                    switch(r = 0, o && (l = [
                                        2 & l[0],
                                        o.value
                                    ]), l[0]){
                                        case 0:
                                        case 1:
                                            o = l;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: l[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, r = l[1], l = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            l = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== l[0] && 2 !== l[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === l[0] && (!o || l[1] > o[0] && l[1] < o[3])) {
                                                a.label = l[1];
                                                break;
                                            }
                                            if (6 === l[0] && a.label < o[1]) {
                                                a.label = o[1], o = l;
                                                break;
                                            }
                                            if (o && a.label < o[2]) {
                                                a.label = o[2], a.ops.push(l);
                                                break;
                                            }
                                            o[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    l = t.call(e, a);
                                } catch (e) {
                                    l = [
                                        6,
                                        e
                                    ], r = 0;
                                } finally{
                                    n = o = 0;
                                }
                                if (5 & l[0]) throw l[1];
                                return {
                                    value: l[0] ? l[1] : void 0,
                                    done: !0
                                };
                            }([
                                l,
                                c
                            ]);
                        };
                    }
                }
                var d = Object.create ? function(e, t, n, r) {
                    void 0 === r && (r = n);
                    var o = Object.getOwnPropertyDescriptor(t, n);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[n];
                        }
                    }), Object.defineProperty(e, r, o);
                } : function(e, t, n, r) {
                    void 0 === r && (r = n), e[r] = t[n];
                };
                function p(e, t) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || d(t, e, n);
                }
                function h(e) {
                    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], r = 0;
                    if (n) return n.call(e);
                    if (e && "number" == typeof e.length) return {
                        next: function() {
                            return e && r >= e.length && (e = void 0), {
                                value: e && e[r++],
                                done: !e
                            };
                        }
                    };
                    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                }
                function y(e, t) {
                    var n = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!n) return e;
                    var r, o, i = n.call(e), a = [];
                    try {
                        for(; (void 0 === t || t-- > 0) && !(r = i.next()).done;)a.push(r.value);
                    } catch (e) {
                        o = {
                            error: e
                        };
                    } finally{
                        try {
                            r && !r.done && (n = i.return) && n.call(i);
                        } finally{
                            if (o) throw o.error;
                        }
                    }
                    return a;
                }
                function b() {
                    for(var e = [], t = 0; t < arguments.length; t++)e = e.concat(y(arguments[t]));
                    return e;
                }
                function g() {
                    for(var e = 0, t = 0, n = arguments.length; t < n; t++)e += arguments[t].length;
                    var r = Array(e), o = 0;
                    for(t = 0; t < n; t++)for(var i = arguments[t], a = 0, l = i.length; a < l; a++, o++)r[o] = i[a];
                    return r;
                }
                function m(e, t, n) {
                    if (n || 2 === arguments.length) for(var r, o = 0, i = t.length; o < i; o++)!r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
                    return e.concat(r || Array.prototype.slice.call(t));
                }
                function v(e) {
                    return this instanceof v ? (this.v = e, this) : new v(e);
                }
                function w(e, t, n) {
                    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                    var r, o = n.apply(e, t || []), i = [];
                    return r = {}, a("next"), a("throw"), a("return"), r[Symbol.asyncIterator] = function() {
                        return this;
                    }, r;
                    function a(e) {
                        o[e] && (r[e] = function(t) {
                            return new Promise(function(n, r) {
                                i.push([
                                    e,
                                    t,
                                    n,
                                    r
                                ]) > 1 || l(e, t);
                            });
                        });
                    }
                    function l(e, t) {
                        try {
                            (n = o[e](t)).value instanceof v ? Promise.resolve(n.value.v).then(c, u) : s(i[0][2], n);
                        } catch (e) {
                            s(i[0][3], e);
                        }
                        var n;
                    }
                    function c(e) {
                        l("next", e);
                    }
                    function u(e) {
                        l("throw", e);
                    }
                    function s(e, t) {
                        e(t), i.shift(), i.length && l(i[0][0], i[0][1]);
                    }
                }
                function _(e) {
                    var t, n;
                    return t = {}, r("next"), r("throw", function(e) {
                        throw e;
                    }), r("return"), t[Symbol.iterator] = function() {
                        return this;
                    }, t;
                    function r(r, o) {
                        t[r] = e[r] ? function(t) {
                            return (n = !n) ? {
                                value: v(e[r](t)),
                                done: "return" === r
                            } : o ? o(t) : t;
                        } : o;
                    }
                }
                function P(e) {
                    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                    var t, n = e[Symbol.asyncIterator];
                    return n ? n.call(e) : (e = h(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function() {
                        return this;
                    }, t);
                    function r(n) {
                        t[n] = e[n] && function(t) {
                            return new Promise(function(r, o) {
                                !function(e, t, n, r) {
                                    Promise.resolve(r).then(function(t) {
                                        e({
                                            value: t,
                                            done: n
                                        });
                                    }, t);
                                }(r, o, (t = e[n](t)).done, t.value);
                            });
                        };
                    }
                }
                function O(e, t) {
                    return Object.defineProperty ? Object.defineProperty(e, "raw", {
                        value: t
                    }) : e.raw = t, e;
                }
                var S = Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                };
                function x(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && d(t, e, n);
                    return S(t, e), t;
                }
                function E(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function T(e, t, n, r) {
                    if ("a" === n && !r) throw new TypeError("Private accessor was defined without a getter");
                    if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
                    return "m" === n ? r : "a" === n ? r.call(e) : r ? r.value : t.get(e);
                }
                function j(e, t, n, r, o) {
                    if ("m" === r) throw new TypeError("Private method is not writable");
                    if ("a" === r && !o) throw new TypeError("Private accessor was defined without a setter");
                    if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
                    return "a" === r ? o.call(e, n) : o ? o.value = n : t.set(e, n), n;
                }
                function A(e, t) {
                    if (null === t || "object" != typeof t && "function" != typeof t) throw new TypeError("Cannot use 'in' operator on non-object");
                    return "function" == typeof e ? t === e : e.has(t);
                }
            },
            156: function(t) {
                t.exports = e;
            },
            111: function(e) {
                e.exports = t;
            }
        }, r = {};
        function o(e) {
            var t = r[e];
            if (void 0 !== t) return t.exports;
            var i = r[e] = {
                exports: {}
            };
            return n[e](i, i.exports, o), i.exports;
        }
        o.d = function(e, t) {
            for(var n in t)o.o(t, n) && !o.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, o.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, o.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var i = {};
        return function() {
            var e = i;
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.useReactToPrint = e.PrintContextConsumer = void 0;
            var t = o(655), n = o(156), r = o(111), a = Object.prototype.hasOwnProperty.call(n, "createContext"), l = Object.prototype.hasOwnProperty.call(n, "useMemo") && Object.prototype.hasOwnProperty.call(n, "useCallback"), c = a ? n.createContext({}) : null;
            e.PrintContextConsumer = c ? c.Consumer : function() {
                return null;
            };
            var u = {
                copyStyles: !0,
                pageStyle: "@page { size: auto;  margin: 0mm; } @media print { body { -webkit-print-color-adjust: exact; } }",
                removeAfterPrint: !1,
                suppressErrors: !1
            }, s = function(e) {
                function o() {
                    var n = null !== e && e.apply(this, arguments) || this;
                    return n.startPrint = function(e) {
                        var t = n.props, r = t.onAfterPrint, o = t.onPrintError, i = t.print, a = t.documentTitle;
                        setTimeout(function() {
                            var t, l;
                            if (e.contentWindow) {
                                if (e.contentWindow.focus(), i) i(e).then(n.handleRemoveIframe).catch(function(e) {
                                    o ? o("print", e) : n.logMessages([
                                        "An error was thrown by the specified `print` function"
                                    ]);
                                });
                                else if (e.contentWindow.print) {
                                    var c = null !== (l = null === (t = e.contentDocument) || void 0 === t ? void 0 : t.title) && void 0 !== l ? l : "", u = e.ownerDocument.title;
                                    a && (e.ownerDocument.title = a, e.contentDocument && (e.contentDocument.title = a)), e.contentWindow.print(), a && (e.ownerDocument.title = u, e.contentDocument && (e.contentDocument.title = c));
                                } else n.logMessages([
                                    "Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes."
                                ]);
                                r && r(), n.handleRemoveIframe();
                            } else n.logMessages([
                                "Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/gregnb/react-to-print/issues/"
                            ]);
                        }, 500);
                    }, n.triggerPrint = function(e) {
                        var t = n.props, r = t.onBeforePrint, o = t.onPrintError;
                        if (r) {
                            var i = r();
                            i && "function" == typeof i.then ? i.then(function() {
                                n.startPrint(e);
                            }).catch(function(e) {
                                o && o("onBeforePrint", e);
                            }) : n.startPrint(e);
                        } else n.startPrint(e);
                    }, n.handleClick = function() {
                        var e = n.props, t = e.onBeforeGetContent, r = e.onPrintError;
                        if (t) {
                            var o = t();
                            o && "function" == typeof o.then ? o.then(n.handlePrint).catch(function(e) {
                                r && r("onBeforeGetContent", e);
                            }) : n.handlePrint();
                        } else n.handlePrint();
                    }, n.handlePrint = function() {
                        var e = n.props, o = e.bodyClass, i = e.content, a = e.copyStyles, l = e.fonts, c = e.pageStyle, u = e.nonce, s = i();
                        if (void 0 !== s) {
                            if (null !== s) {
                                var f = document.createElement("iframe");
                                f.width = "".concat(document.documentElement.clientWidth, "px"), f.height = "".concat(document.documentElement.clientHeight, "px"), f.style.position = "absolute", f.style.top = "-".concat(document.documentElement.clientHeight + 100, "px"), f.style.left = "-".concat(document.documentElement.clientWidth + 100, "px"), f.id = "printWindow", f.srcdoc = "<!DOCTYPE html>";
                                var d = (0, r.findDOMNode)(s);
                                if (d) {
                                    var p = d.cloneNode(!0), h = p instanceof Text, y = document.querySelectorAll("link[rel='stylesheet']"), b = h ? [] : p.querySelectorAll("img"), g = h ? [] : p.querySelectorAll("video");
                                    n.linkTotal = y.length + b.length + g.length, n.linksLoaded = [], n.linksErrored = [], n.fontsLoaded = [], n.fontsErrored = [];
                                    var m = function(e, t) {
                                        t ? n.linksLoaded.push(e) : (n.logMessages([
                                            '"react-to-print" was unable to load a linked node. It may be invalid. "react-to-print" will continue attempting to print the page. The linked node that errored was:',
                                            e
                                        ]), n.linksErrored.push(e)), n.linksLoaded.length + n.linksErrored.length + n.fontsLoaded.length + n.fontsErrored.length === n.linkTotal && n.triggerPrint(f);
                                    };
                                    f.onload = function() {
                                        var e, r, i, s;
                                        f.onload = null;
                                        var y = f.contentDocument || (null === (r = f.contentWindow) || void 0 === r ? void 0 : r.document);
                                        if (y) {
                                            y.body.appendChild(p), l && ((null === (i = f.contentDocument) || void 0 === i ? void 0 : i.fonts) && (null === (s = f.contentWindow) || void 0 === s ? void 0 : s.FontFace) ? l.forEach(function(e) {
                                                var t = new FontFace(e.family, e.source);
                                                f.contentDocument.fonts.add(t), t.loaded.then(function(e) {
                                                    n.fontsLoaded.push(e);
                                                }).catch(function(e) {
                                                    n.fontsErrored.push(t), n.logMessages([
                                                        '"react-to-print" was unable to load a font. "react-to-print" will continue attempting to print the page. The font that failed to load is:',
                                                        t,
                                                        "The error from loading the font is:",
                                                        e
                                                    ]);
                                                });
                                            }) : n.logMessages([
                                                '"react-to-print" is not able to load custom fonts because the browser does not support the FontFace API'
                                            ]));
                                            var v = "function" == typeof c ? c() : c;
                                            if ("string" != typeof v) n.logMessages([
                                                '"react-to-print" expected a "string" from `pageStyle` but received "'.concat(typeof v, '". Styles from `pageStyle` will not be applied.')
                                            ]);
                                            else {
                                                var w = y.createElement("style");
                                                u && (w.setAttribute("nonce", u), y.head.setAttribute("nonce", u)), w.appendChild(y.createTextNode(v)), y.head.appendChild(w);
                                            }
                                            if (o && (e = y.body.classList).add.apply(e, (0, t.__spreadArray)([], (0, t.__read)(o.split(" ")), !1)), !h) {
                                                for(var _ = h ? [] : d.querySelectorAll("canvas"), P = y.querySelectorAll("canvas"), O = 0; O < _.length; ++O){
                                                    var S = _[O], x = P[O].getContext("2d");
                                                    x && x.drawImage(S, 0, 0);
                                                }
                                                for(O = 0; O < b.length; O++){
                                                    var E = b[O], T = E.getAttribute("src");
                                                    T ? ((A = new Image).onload = m.bind(null, E, !0), A.onerror = m.bind(null, E, !1), A.src = T) : (n.logMessages([
                                                        '"react-to-print" encountered an <img> tag with an empty "src" attribute. It will not attempt to pre-load it. The <img> is:',
                                                        E
                                                    ], "warning"), m(E, !1));
                                                }
                                                for(O = 0; O < g.length; O++){
                                                    var j = g[O];
                                                    j.preload = "auto";
                                                    var A, k = j.getAttribute("poster");
                                                    k ? ((A = new Image).onload = m.bind(null, j, !0), A.onerror = m.bind(null, j, !1), A.src = k) : j.readyState >= 2 ? m(j, !0) : (j.onloadeddata = m.bind(null, j, !0), j.onerror = m.bind(null, j, !1), j.onstalled = m.bind(null, j, !1));
                                                }
                                                var C = "input", M = d.querySelectorAll(C), R = y.querySelectorAll(C);
                                                for(O = 0; O < M.length; O++)R[O].value = M[O].value;
                                                var I = "input[type=checkbox],input[type=radio]", q = d.querySelectorAll(I), D = y.querySelectorAll(I);
                                                for(O = 0; O < q.length; O++)D[O].checked = q[O].checked;
                                                var W = "select", L = d.querySelectorAll(W), F = y.querySelectorAll(W);
                                                for(O = 0; O < L.length; O++)F[O].value = L[O].value;
                                            }
                                            if (a) for(var N = document.querySelectorAll("style, link[rel='stylesheet']"), B = (O = 0, N.length); O < B; ++O){
                                                var G = N[O];
                                                if ("style" === G.tagName.toLowerCase()) {
                                                    var H = y.createElement(G.tagName), Y = G.sheet;
                                                    if (Y) {
                                                        var z = "";
                                                        try {
                                                            for(var V = Y.cssRules.length, U = 0; U < V; ++U)"string" == typeof Y.cssRules[U].cssText && (z += "".concat(Y.cssRules[U].cssText, "\r\n"));
                                                        } catch (e) {
                                                            n.logMessages([
                                                                "A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/gregnb/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross `crossorigin` attribute, and setting the `Access-Control-Allow-Origin` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.",
                                                                G
                                                            ], "warning");
                                                        }
                                                        H.setAttribute("id", "react-to-print-".concat(O)), u && H.setAttribute("nonce", u), H.appendChild(y.createTextNode(z)), y.head.appendChild(H);
                                                    }
                                                } else if (G.getAttribute("href")) {
                                                    if (G.hasAttribute("disabled")) n.logMessages([
                                                        "`react-to-print` encountered a <link> tag with a `disabled` attribute and will ignore it. Note that the `disabled` attribute is deprecated, and some browsers ignore it. You should stop using it. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-disabled. The <link> is:",
                                                        G
                                                    ], "warning"), m(G, !0);
                                                    else {
                                                        H = y.createElement(G.tagName), U = 0;
                                                        for(var J = G.attributes.length; U < J; ++U){
                                                            var K = G.attributes[U];
                                                            K && H.setAttribute(K.nodeName, K.nodeValue || "");
                                                        }
                                                        H.onload = m.bind(null, H, !0), H.onerror = m.bind(null, H, !1), u && H.setAttribute("nonce", u), y.head.appendChild(H);
                                                    }
                                                } else n.logMessages([
                                                    "`react-to-print` encountered a <link> tag with an empty `href` attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:",
                                                    G
                                                ], "warning"), m(G, !0);
                                            }
                                        }
                                        0 !== n.linkTotal && a || n.triggerPrint(f);
                                    }, n.handleRemoveIframe(!0), document.body.appendChild(f);
                                } else n.logMessages([
                                    '"react-to-print" could not locate the DOM node corresponding with the `content` prop'
                                ]);
                            } else n.logMessages([
                                'There is nothing to print because the "content" prop returned "null". Please ensure "content" is renderable before allowing "react-to-print" to be called.'
                            ]);
                        } else n.logMessages([
                            "To print a functional component ensure it is wrapped with `React.forwardRef`, and ensure the forwarded ref is used. See the README for an example: https://github.com/gregnb/react-to-print#examples"
                        ]);
                    }, n.handleRemoveIframe = function(e) {
                        var t = n.props.removeAfterPrint;
                        if (e || t) {
                            var r = document.getElementById("printWindow");
                            r && document.body.removeChild(r);
                        }
                    }, n.logMessages = function(e, t) {
                        void 0 === t && (t = "error"), n.props.suppressErrors || ("error" === t ? console.error(e) : "warning" === t ? console.warn(e) : "debug" === t && console.debug(e));
                    }, n;
                }
                return (0, t.__extends)(o, e), o.prototype.render = function() {
                    var e = this.props, t = e.children, r = e.trigger;
                    if (r) return n.cloneElement(r(), {
                        onClick: this.handleClick
                    });
                    if (!c) return this.logMessages([
                        '"react-to-print" requires React ^16.3.0 to be able to use "PrintContext"'
                    ]), null;
                    var o = {
                        handlePrint: this.handleClick
                    };
                    return n.createElement(c.Provider, {
                        value: o
                    }, t);
                }, o.defaultProps = u, o;
            }(n.Component);
            e.default = s, e.useReactToPrint = function(e) {
                if (!l) return e.suppressErrors || console.error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"'), function() {
                    throw new Error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"');
                };
                var r = n.useMemo(function() {
                    return new s((0, t.__assign)((0, t.__assign)({}, u), e));
                }, [
                    e
                ]);
                return n.useCallback(function() {
                    return r.handleClick();
                }, [
                    r
                ]);
            };
        }(), i;
    }();
});





const $a235700cfe6b773e$var$getDocumentStatus = (item)=>{
    if (item.filesCompletedAt) return 'Completed!';
    const documentTasks = (item.tasks ?? []).filter((task)=>task.taskType === (0, $8f7fe33a44836803$export$1f8b1cab05cab788)?.Documents || task.taskType === (0, $8f7fe33a44836803$export$1f8b1cab05cab788)?.RequestDocuments);
    const inCompleteDocumentTasks = documentTasks.filter((task)=>!task.completedAt);
    if (documentTasks?.length > 0 && inCompleteDocumentTasks?.length === 0) return 'Client updated info';
    if (documentTasks?.length > 0 && inCompleteDocumentTasks?.length > 0) return 'Waiting for client response';
    return 'Documents not found';
};
const $a235700cfe6b773e$var$getPaymentStatus = (item)=>{
    if (item.paymentsCompletedAt) return 'Completed!';
    const invoiceTasks = (item.tasks ?? []).filter((task)=>task.taskType === (0, $8f7fe33a44836803$export$1f8b1cab05cab788).Payments);
    const inCompleteInvoiceTasks = invoiceTasks.filter((task)=>!task.completedAt);
    if (invoiceTasks.length > 0 && inCompleteInvoiceTasks.length === 0) return 'Client updated info';
    if (invoiceTasks.length > 0 && inCompleteInvoiceTasks.length > 0) return 'Waiting for client payment';
    return 'Not started';
};
const $a235700cfe6b773e$var$getInterviewStatus = (item)=>{
    if (item.interviewCompletedAt) return 'Completed!';
    const interviewTasks = (item.tasks ?? []).filter((task)=>task.taskType === (0, $8f7fe33a44836803$export$1f8b1cab05cab788).Interview);
    const inCompleteInterviewTasks = interviewTasks?.filter((task)=>!task.completedAt);
    if (interviewTasks?.length > 0 && inCompleteInterviewTasks?.length === 0) return 'Client updated info';
    if (interviewTasks?.length > 0 && inCompleteInterviewTasks?.length > 0) return 'Waiting for client response';
    return 'Not started';
};
const $a235700cfe6b773e$export$b3036169bcac7eae = (item)=>{
    if (item.reviewStatus === (0, $8f7fe33a44836803$export$ddbe8748ad68508)?.Accepted) return 'Completed!';
    if (item.reviewStatus === (0, $8f7fe33a44836803$export$ddbe8748ad68508)?.In) return 'In review';
    if (item.reviewStatus === (0, $8f7fe33a44836803$export$ddbe8748ad68508)?.Rejected) return 'Rejected';
    return 'No review';
};
const $a235700cfe6b773e$export$6fe772dde95a83ff = (item)=>{
    const approvalTasks = (item.tasks ?? []).filter((task)=>task.taskType === (0, $8f7fe33a44836803$export$1f8b1cab05cab788)?.Signatures);
    const inCompleteApprovalTasks = approvalTasks?.filter((task)=>!task.completedAt);
    if (item.approvalsCompletedAt) return 'Completed!';
    if (approvalTasks?.length > 0 && inCompleteApprovalTasks?.length === 0) return 'Client updated info';
    if (approvalTasks?.length > 0 && inCompleteApprovalTasks?.length > 0) return 'Waiting for client response';
    return 'Not started';
};
const $a235700cfe6b773e$export$160b7cf392d369f = (data)=>{
    const titles = [
        [
            'Name',
            'Email',
            'Phone',
            'Recent Tax Year',
            'Job Type',
            'Activation Sent',
            'Documents',
            'Notes',
            'Client Payment Status',
            'Referred By',
            'Preparer',
            'Reviewer'
        ]
    ];
    return titles.concat(data.map((item)=>{
        const result = [
            `${item.firstName} ${item.lastName}`,
            item.email,
            item.phone?.value,
            item.taxYear,
            item.jobType,
            item.invitationEmailSent,
            $a235700cfe6b773e$var$getDocumentStatus(item),
            item.notes,
            $a235700cfe6b773e$var$getPaymentStatus(item),
            item.referredBy,
            item.preparedName ?? 'Not assigned',
            item.reviewedName ?? 'Not assigned'
        ];
        return result;
    }));
};
const $a235700cfe6b773e$export$d14e1e671c047e6c = (data)=>{
    const titles = [
        [
            'Name',
            'TaxYear',
            'Job Type',
            'Email',
            'Time in Progress',
            'Activation Sent',
            'Documents',
            'Notes',
            'Client Interview Status',
            'Client Payment Status',
            'Review Status',
            'Client Document Approval Status',
            'Referred By',
            'Preparer',
            'Reviewer'
        ]
    ];
    return titles.concat(data.map((item)=>[
            `${item.firstName} ${item.lastName}`,
            item.taxYear,
            item.jobType,
            item.email,
            (0, $5bafd68f69b44f55$export$d784918a83e8de76)(item.inProgressTime),
            item.invitationEmailSent,
            $a235700cfe6b773e$var$getDocumentStatus(item),
            item.notes,
            $a235700cfe6b773e$var$getInterviewStatus(item),
            $a235700cfe6b773e$var$getPaymentStatus(item),
            $a235700cfe6b773e$export$b3036169bcac7eae(item),
            $a235700cfe6b773e$export$6fe772dde95a83ff(item),
            item.referredBy,
            item.preparedName,
            item.reviewedName
        ]));
};
const $a235700cfe6b773e$export$d3bc228d5ab0dcdf = (csvData)=>csvData.map((item)=>item.join('   ')).join('\n');


const { CopyOutlined: $40c55f804921f3ec$var$CopyOutlined, DownOutlined: $40c55f804921f3ec$var$DownOutlined, PrinterOutlined: $40c55f804921f3ec$var$PrinterOutlined, CloudDownloadOutlined: $40c55f804921f3ec$var$CloudDownloadOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $40c55f804921f3ec$var$pageStyle = `
  @page {
    size: auto;
    margin: 5mm 1mm;
  }
  @media print {
    body {
      -webkit-print-color-adjust: exact;
    }
    .ant-table-sticky-holder {
      top: 0px !important;
    }
    .ant-table-body {
      overflow: visible !important;
    }
  }
`;
const $40c55f804921f3ec$var$onCopy = (copyText)=>{
    navigator.clipboard.writeText(copyText).then(()=>{
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Copied!');
    }).catch((error)=>{
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error);
    });
};
function $40c55f804921f3ec$var$ExportButton({ dataType: dataType, progressStatusName: progressStatusName, tableData: tableData, tableRef: tableRef }) {
    // setup the ref that we'll use for the hidden CsvLink click once we've updated the data
    const csvLink = (0, $6fFrj.useRef)();
    const csvData = dataType === 'clients' ? (0, $a235700cfe6b773e$export$160b7cf392d369f)(tableData) : (0, $a235700cfe6b773e$export$d14e1e671c047e6c)(tableData);
    const handlePrint = (0, $e829570e739753a7$exports.useReactToPrint)({
        content: ()=>tableRef.current,
        pageStyle: $40c55f804921f3ec$var$pageStyle
    });
    const handleDropdownSelection = (option)=>{
        const { type: type } = option;
        if (type === 'copy') $40c55f804921f3ec$var$onCopy((0, $a235700cfe6b773e$export$d3bc228d5ab0dcdf)(csvData));
        else if (type === 'print') {
            if (handlePrint) handlePrint();
        } else if (type === 'csv_export') {
            if (csvLink?.current?.link) csvLink.current.link.click();
        }
    };
    const getCsvFileName = ()=>{
        let prefix = '';
        if (progressStatusName) prefix = `${progressStatusName.toLowerCase().replace(/ /g, '_')}_`;
        const name = dataType === 'jobs' ? 'jobs' : 'clients';
        return `${prefix}${name}`;
    };
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $48dfff27a418d97c$export$2e2bcd8739ae039), {
                buttonProps: {
                    style: {
                        color: '#5a5a5a',
                        borderColor: '#5a5a5a'
                    },
                    icon: (0, $bb3TF.jsx)($40c55f804921f3ec$var$DownOutlined, {}),
                    // iconDirection: 'left',
                    type: 'default'
                },
                dropDownProps: {
                    placement: 'bottomLeft'
                },
                onSelect: (option)=>handleDropdownSelection(option),
                options: [
                    {
                        type: 'copy',
                        title: 'Copy',
                        icon: (0, $bb3TF.jsx)($40c55f804921f3ec$var$CopyOutlined, {})
                    },
                    {
                        type: 'print',
                        title: 'Print',
                        icon: (0, $bb3TF.jsx)($40c55f804921f3ec$var$PrinterOutlined, {})
                    },
                    {
                        type: 'csv_export',
                        title: 'CSV Export',
                        icon: (0, $bb3TF.jsx)($40c55f804921f3ec$var$CloudDownloadOutlined, {})
                    }
                ],
                keyText: "title",
                children: "Export Grid"
            }),
            (0, $bb3TF.jsx)((0, $ff22b7405cb76de7$exports.CSVLink), {
                data: csvData,
                filename: getCsvFileName(),
                className: "hidden",
                ref: csvLink,
                target: "_blank"
            })
        ]
    });
}
var $40c55f804921f3ec$export$2e2bcd8739ae039 = $40c55f804921f3ec$var$ExportButton;



var $bb3TF = parcelRequire("bb3TF");

const { Search: $6ff7c6eb62f4e134$var$Search } = (0, $1fb834916a156dcf$export$2e2bcd8739ae039);
const $6ff7c6eb62f4e134$var$SearchBar = ({ disabled: disabled, searchRef: searchRef, setSearchedValue: setSearchedValue, searchBarValue: searchBarValue, setSearchBarValue: setSearchBarValue, prefix: prefix })=>{
    const handleSearch = (v)=>{
        setSearchedValue(v);
    };
    return (0, $bb3TF.jsx)($6ff7c6eb62f4e134$var$Search, {
        ref: searchRef,
        placeholder: "Search by name, email, phone (numbers only), or tax year",
        onSearch: handleSearch,
        disabled: disabled,
        value: searchBarValue,
        onChange: (e)=>setSearchBarValue(e.target.value),
        addonBefore: prefix
    });
};
var $6ff7c6eb62f4e134$export$2e2bcd8739ae039 = $6ff7c6eb62f4e134$var$SearchBar;



var $bb3TF = parcelRequire("bb3TF");

const { Option: $2451ab9d82f74733$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
function $2451ab9d82f74733$var$SelectNumJobsDropdown({ type: type, onChange: onChange, currentPageSize: currentPageSize }) {
    const handleChange = (value)=>{
        onChange(parseInt(value, 10));
    };
    const typeStr = type === 'clients' ? 'clients' : 'jobs';
    return (0, $bb3TF.jsxs)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
        defaultValue: currentPageSize.toString(),
        style: {
            marginRight: '5px'
        },
        onChange: handleChange,
        value: currentPageSize.toString(),
        children: [
            (0, $bb3TF.jsx)($2451ab9d82f74733$var$Option, {
                value: "10",
                children: `Show 10 ${typeStr}`
            }),
            (0, $bb3TF.jsx)($2451ab9d82f74733$var$Option, {
                value: "25",
                children: `Show 25 ${typeStr}`
            }),
            (0, $bb3TF.jsx)($2451ab9d82f74733$var$Option, {
                value: "100",
                children: `Show 100 ${typeStr}`
            })
        ]
    });
}
$2451ab9d82f74733$var$SelectNumJobsDropdown.defaultProps = {
    type: 'clients'
};
var $2451ab9d82f74733$export$2e2bcd8739ae039 = $2451ab9d82f74733$var$SelectNumJobsDropdown;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



const { TextArea: $fe5524b3f66f0fe1$var$TextArea } = (0, $1fb834916a156dcf$export$2e2bcd8739ae039);
const $fe5524b3f66f0fe1$var$SendTextMessageButton = ({ selectedRows: selectedRows, setSelectedRows: setSelectedRows, setSelectedKeys: setSelectedKeys, sendTextDisabled: sendTextDisabled })=>{
    const [isModalVisible, setIsModalVisible] = (0, $6fFrj.useState)(false);
    const [textAreaValue, setTextAreaValue] = (0, $6fFrj.useState)('');
    const [createBulkMessage, { loading: loadingBulkMessage }] = (0, $4cdb1470f9874f96$export$95b4eb0de63a5c3f)({
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message)
    });
    const handleSendTextMessages = ()=>{
        setIsModalVisible(true);
        (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).MODAL_SHOW, {
            'Modal Title': 'Send Text Message',
            Source: 'Click on button',
            url: window.location.href
        });
    };
    const handleOK = async ()=>{
        const phoneIds = selectedRows.map((row)=>row.phone?.id).filter((p)=>p);
        if (phoneIds.length === 0) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('No phone input');
            return;
        }
        const result = await createBulkMessage({
            variables: {
                createBulkMessage: {
                    phoneIds: phoneIds,
                    text: textAreaValue
                }
            }
        });
        if (result.data?.createBulkMessage) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success(result.data?.createBulkMessage?.message);
            setIsModalVisible(false);
            setTextAreaValue('');
            setSelectedRows([]);
            setSelectedKeys([]);
        }
    };
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                placement: "top",
                title: selectedRows.length > 0 && sendTextDisabled ? 'Cannot send multiple messages before 9 AM or after 8 PM' : '',
                children: (0, $bb3TF.jsx)("span", {
                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        type: "primary",
                        disabled: sendTextDisabled,
                        onClick: handleSendTextMessages,
                        children: "Send Text Message"
                    })
                })
            }),
            (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
                title: "Send Text Message",
                visible: isModalVisible,
                onOk: handleOK,
                onCancel: ()=>setIsModalVisible(false),
                okText: "Send Text Message",
                okButtonProps: {
                    loading: loadingBulkMessage,
                    disabled: textAreaValue.length < 1
                },
                cancelText: "Cancel",
                children: (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    children: (0, $bb3TF.jsx)($fe5524b3f66f0fe1$var$TextArea, {
                        rows: 4,
                        value: textAreaValue,
                        onChange: (e)=>setTextAreaValue(e.target.value),
                        showCount: true,
                        maxLength: 160,
                        style: {
                            width: '100%',
                            paddingBottom: '10px'
                        }
                    })
                })
            })
        ]
    });
};
var $fe5524b3f66f0fe1$export$2e2bcd8739ae039 = $fe5524b3f66f0fe1$var$SendTextMessageButton;


const { FilterOutlined: $e3c84263568120dd$var$FilterOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Option: $e3c84263568120dd$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
// fill tax year list
const $e3c84263568120dd$var$currentYear = new Date().getFullYear();
const $e3c84263568120dd$var$taxYears = [
    $e3c84263568120dd$var$currentYear - 1,
    $e3c84263568120dd$var$currentYear
];
for(let year = $e3c84263568120dd$var$currentYear - 2; year > $e3c84263568120dd$var$currentYear - 10; year -= 1)$e3c84263568120dd$var$taxYears.push(year);
//
const $e3c84263568120dd$var$paymentStatusOptions = [
    {
        value: 'completed',
        label: 'Completed',
        key: 'completed_status_payment'
    },
    {
        value: 'client_updated',
        label: 'Client Updated Info',
        key: 'client_updated_status_payment'
    },
    {
        value: 'waiting_for_client',
        label: 'Waiting for client payment',
        key: 'waiting_for_client_status_payment'
    },
    {
        value: 'payments_not_found',
        label: 'Not started',
        key: 'not_found_status_payment'
    }
];
//
const $e3c84263568120dd$var$documentStatusOptions = [
    {
        value: 'completed',
        label: 'Completed',
        key: 'completed_status_document'
    },
    {
        value: 'client_updated',
        label: 'Client Updated Info',
        key: 'client_updated_status_document'
    },
    {
        value: 'waiting_for_client',
        label: 'Waiting for client response',
        key: 'waiting_for_client_status_document'
    },
    {
        value: 'documents_not_found',
        label: 'No pending documents',
        key: 'not_found_status_document'
    }
];
//
const $e3c84263568120dd$var$notesOptions = [
    {
        value: true,
        label: 'Yes',
        key: 'yes_notes'
    },
    {
        value: false,
        label: 'No',
        key: 'no_notes'
    }
];
//
const $e3c84263568120dd$var$activationStatusOptions = [
    {
        value: 'sent_accepted',
        label: 'Sent and accepted',
        key: 'sent_accepted_status_email'
    },
    {
        value: 'sent_not_accepted',
        label: 'Sent and not accepted',
        key: 'client_updated_status_email'
    },
    {
        value: 'not_sent',
        label: 'Not sent',
        key: 'not_sent_status_email'
    },
    {
        value: 'active_client',
        label: 'Active client',
        key: 'active_client_status_email'
    }
];
const $e3c84263568120dd$var$CollapseFilterComponent = (0, $7ae336b16849d71a$export$2e2bcd8739ae039)((0, $45def89f679453ce$export$2e2bcd8739ae039))`
  .ant-collapse-item > .ant-collapse-header {
    padding: 0 0 20px 0;
  }

  .ant-collapse-content > .ant-collapse-content-box {
    padding: 0;
  }
`;
const $e3c84263568120dd$var$RowAboveJobsTable = ({ selectedRows: selectedRows, setSelectedRows: setSelectedRows, setSelectedKeys: setSelectedKeys, tableData: tableData, tableRef: tableRef, type: type, displayClearbutton: displayClearbutton, pageSize: pageSize, setPageSize: setPageSize, setSearchedValue: setSearchedValue, searchRef: searchRef, loading: loading, progressStatusName: progressStatusName, setFilters: setFilters, underlyingStatus: underlyingStatus })=>{
    const [searchBarValue, setSearchBarValue] = (0, $6fFrj.useState)('');
    const [sendTextDisabled, setSendTextDisabled] = (0, $6fFrj.useState)(true);
    const [filterType, setFilterType] = (0, $6fFrj.useState)('AND');
    const [activeFilters, setActiveFilters] = (0, $6fFrj.useState)(0);
    const [form] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    const { firmAccountId: firmAccountId } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const { data: data, loading: loadingMembers } = (0, $732264f53056e08f$export$deb804dbb627e21)({
        variables: {
            firmAccountId: firmAccountId,
            filterDelete: true
        }
    });
    const userFirmAccounts = data?.UserFirmAccountByFirmAccountAndFilter;
    (0, $6fFrj.useEffect)(()=>{
        setActiveFilters(Object.values(form.getFieldsValue()).filter((item)=>item && item.length > 0).length);
    }, [
        form.getFieldsValue()
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (selectedRows.length > 0) {
            const now = new Date().getHours();
            if (now >= 20 || now < 9) setSendTextDisabled(true);
            else setSendTextDisabled(false);
        } else setSendTextDisabled(true);
    }, [
        selectedRows?.length
    ]);
    const clearTable = ()=>{
        setSearchedValue('');
        setSearchBarValue('');
    };
    const onChangeFilters = ()=>{
        setFilters({
            ...form.getFieldsValue(),
            filterType: filterType
        });
    };
    const onClearFilters = ()=>{
        form.resetFields();
    };
    const getFilterContent = ()=>(0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
            children: [
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "center",
                    style: {
                        margin: '5px 0px 15px 0px'
                    },
                    children: (0, $bb3TF.jsxs)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Group, {
                        value: filterType,
                        onChange: (e)=>setFilterType(e.target.value),
                        children: [
                            (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Button, {
                                value: "AND",
                                children: "AND"
                            }),
                            (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Button, {
                                value: "OR",
                                children: "OR"
                            })
                        ]
                    })
                }),
                (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                    form: form,
                    layout: "horizontal",
                    style: {
                        width: '400px'
                    },
                    initialValues: {
                        filterType: 'AND'
                    },
                    children: [
                        (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                            label: "Tax Year",
                            name: "taxYear",
                            children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                placeholder: "Select tax year",
                                mode: "multiple",
                                allowClear: true,
                                children: $e3c84263568120dd$var$taxYears.map((item)=>(0, $bb3TF.jsx)($e3c84263568120dd$var$Option, {
                                        value: item,
                                        children: item
                                    }, item))
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                            label: "Job Type",
                            name: "jobType",
                            children: (0, $bb3TF.jsx)((0, $89a92f440564d95a$export$2e2bcd8739ae039), {
                                mode: "multiple",
                                allowClear: true
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                            label: "Document Status",
                            name: "documentStatus",
                            children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                placeholder: "Select a status",
                                mode: "multiple",
                                allowClear: true,
                                children: $e3c84263568120dd$var$documentStatusOptions.map((item)=>(0, $bb3TF.jsx)($e3c84263568120dd$var$Option, {
                                        value: item.value,
                                        children: item.label
                                    }, item.key))
                            })
                        }),
                        [
                            (0, $8f7fe33a44836803$export$f493388d2527ca1f).Custom,
                            (0, $8f7fe33a44836803$export$f493388d2527ca1f).InProgress
                        ].includes(underlyingStatus) ? (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                            label: "Interview Completed",
                            name: "interviewCompleted",
                            children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                placeholder: "Select an option",
                                allowClear: true,
                                children: [
                                    {
                                        label: 'Yes',
                                        value: true
                                    },
                                    {
                                        label: 'No',
                                        value: false
                                    }
                                ].map((item)=>(0, $bb3TF.jsx)($e3c84263568120dd$var$Option, {
                                        value: item.value,
                                        children: item.label
                                    }, item.value))
                            })
                        }) : null,
                        (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                            label: "Activation Email Status",
                            name: "activationStatus",
                            children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                placeholder: "Select a status",
                                mode: "multiple",
                                allowClear: true,
                                children: $e3c84263568120dd$var$activationStatusOptions.map((item)=>(0, $bb3TF.jsx)($e3c84263568120dd$var$Option, {
                                        value: item.value,
                                        children: item.label
                                    }, item.key))
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                            label: "Has Notes",
                            name: "notes",
                            children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                placeholder: "Select an option",
                                allowClear: true,
                                children: $e3c84263568120dd$var$notesOptions.map((item)=>(0, $bb3TF.jsx)($e3c84263568120dd$var$Option, {
                                        value: item.value,
                                        children: item.label
                                    }, item.key))
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                            label: "Payment Status",
                            name: "paymentStatus",
                            children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                placeholder: "Select a status",
                                mode: "multiple",
                                allowClear: true,
                                children: $e3c84263568120dd$var$paymentStatusOptions.map((item)=>(0, $bb3TF.jsx)($e3c84263568120dd$var$Option, {
                                        value: item.value,
                                        children: item.label
                                    }, item.key))
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                            label: "Preparer",
                            name: "preparerId",
                            children: (0, $bb3TF.jsxs)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                placeholder: "Select a preparer",
                                mode: "multiple",
                                allowClear: true,
                                children: [
                                    (0, $bb3TF.jsx)($e3c84263568120dd$var$Option, {
                                        value: "Not Assigned",
                                        children: "Not Assigned"
                                    }),
                                    userFirmAccounts && userFirmAccounts.map((item)=>(0, $bb3TF.jsx)($e3c84263568120dd$var$Option, {
                                            value: item.Users.id,
                                            style: item.Users.deleteAt ? {
                                                display: 'none'
                                            } : {},
                                            children: `${item.Users.UserInformation.firstName} ${item.Users.UserInformation.lastName}`
                                        }, item.Users.id))
                                ]
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                            label: "Reviewer",
                            name: "reviewerId",
                            children: (0, $bb3TF.jsxs)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                placeholder: "Select a reviewer",
                                mode: "multiple",
                                allowClear: true,
                                children: [
                                    (0, $bb3TF.jsx)($e3c84263568120dd$var$Option, {
                                        value: "Not Assigned",
                                        children: "Not Assigned"
                                    }),
                                    userFirmAccounts && userFirmAccounts.map((item)=>(0, $bb3TF.jsx)($e3c84263568120dd$var$Option, {
                                            value: item.Users.id,
                                            children: `${item.Users.UserInformation.firstName} ${item.Users.UserInformation.lastName}`
                                        }, item.Users.id))
                                ]
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {}),
                        (0, $bb3TF.jsx)($e3c84263568120dd$var$CollapseFilterComponent, {
                            ghost: true,
                            children: (0, $bb3TF.jsxs)((0, $45def89f679453ce$export$2e2bcd8739ae039).Panel, {
                                header: "Client Basic Info",
                                children: [
                                    (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                        label: "First Name",
                                        name: "firstName",
                                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {})
                                    }),
                                    (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                        label: "Last Name",
                                        name: "lastName",
                                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {})
                                    }),
                                    (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                        label: "Email",
                                        name: "email",
                                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {})
                                    }),
                                    (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                        label: "Phone number",
                                        name: "phoneNumber",
                                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }, "1")
                        }),
                        (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            justify: "space-between",
                            children: [
                                (0, $bb3TF.jsx)((0, $92b07c154bbb4d14$export$2e2bcd8739ae039), {
                                    tooltip: null,
                                    onClick: ()=>onClearFilters(),
                                    children: "Clear"
                                }),
                                (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    onClick: ()=>onChangeFilters(),
                                    children: "Apply"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    const filterElement = (0, $bb3TF.jsx)((0, $0e541b76c0e3ec69$export$2e2bcd8739ae039), {
        count: activeFilters,
        size: "small",
        children: (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
            content: getFilterContent(),
            placement: "bottom",
            trigger: "click",
            autoAdjustOverflow: true,
            children: (0, $bb3TF.jsx)($e3c84263568120dd$var$FilterOutlined, {})
        })
    });
    return (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        justify: "start",
        gutter: [
            {
                xs: 8,
                sm: 16,
                md: 26
            },
            16
        ],
        style: {
            marginTop: '15px'
        },
        children: [
            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)((0, $fe5524b3f66f0fe1$export$2e2bcd8739ae039), {
                    selectedRows: selectedRows,
                    setSelectedRows: setSelectedRows,
                    setSelectedKeys: setSelectedKeys,
                    sendTextDisabled: sendTextDisabled
                })
            }),
            tableData && (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)((0, $40c55f804921f3ec$export$2e2bcd8739ae039), {
                    dataType: type,
                    progressStatusName: progressStatusName,
                    tableData: tableData,
                    tableRef: tableRef
                })
            }),
            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                style: {
                    flexGrow: 1
                },
                children: (0, $bb3TF.jsx)((0, $6ff7c6eb62f4e134$export$2e2bcd8739ae039), {
                    disabled: loading,
                    searchRef: searchRef,
                    setSearchedValue: setSearchedValue,
                    searchBarValue: searchBarValue,
                    setSearchBarValue: setSearchBarValue,
                    prefix: filterElement
                })
            }),
            displayClearbutton && (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)((0, $92b07c154bbb4d14$export$2e2bcd8739ae039), {
                    buttonProps: {
                        type: 'primary'
                    },
                    tooltip: "Clear results",
                    onClick: clearTable,
                    children: "clear"
                })
            }),
            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {}),
            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)((0, $2451ab9d82f74733$export$2e2bcd8739ae039), {
                    type: type,
                    onChange: (value)=>setPageSize(value),
                    currentPageSize: pageSize
                })
            })
        ]
    });
};
$e3c84263568120dd$var$RowAboveJobsTable.defaultProps = {
    type: 'clients',
    progressStatusName: '',
    underlyingStatus: undefined
};
var $e3c84263568120dd$export$2e2bcd8739ae039 = $e3c84263568120dd$var$RowAboveJobsTable;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




const $dfa33edebc49de1f$var$NoClients = ()=>{
    const [isAddClientModalVisible, setIsAddClientModalVisible] = (0, $6fFrj.useState)(false);
    const navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    // graphql
    // check if the firm has created any interviews yet. if not, prompt to create one first
    const { data: jobTypes, loading: loadingGetInterviews } = (0, $774cc9a1c383b6aa$export$194d4356b994f52)();
    if (loadingGetInterviews) return null;
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                justify: "center",
                style: {
                    marginTop: 25
                },
                children: jobTypes?.interviewNames?.length === 0 ? (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    type: "primary",
                    shape: "round",
                    onClick: ()=>navigate('interviews'),
                    children: "Create your first interview"
                }) : (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    type: "primary",
                    shape: "round",
                    onClick: ()=>setIsAddClientModalVisible(true),
                    children: "Add client"
                })
            }),
            (0, $bb3TF.jsx)((0, $2d52d8d286e39b3a$export$2e2bcd8739ae039), {
                isModalVisible: isAddClientModalVisible,
                setIsModalVisible: setIsAddClientModalVisible
            })
        ]
    });
};
var $dfa33edebc49de1f$export$2e2bcd8739ae039 = $dfa33edebc49de1f$var$NoClients;


const $a5ca70def816e8cb$var$JobsTable = ({ setProgressStatusDnDConfirmModalVisible: setProgressStatusDnDConfirmModalVisible, setDndData: setDndData, columns: columns, progressStatusId: progressStatusId, progressStatusName: progressStatusName, underlyingStatus: underlyingStatus, setTabCountMap: setTabCountMap, loadingProp: loadingProp })=>{
    const sortedInfo = {
        order: 'ascend',
        columnKey: 'clientInterview'
    };
    const [selectedKeys, setSelectedKeys] = (0, $6fFrj.useState)([]);
    const [selectedRows, setSelectedRows] = (0, $6fFrj.useState)([]);
    const [displayClearbutton, setDisplayClearButton] = (0, $6fFrj.useState)(false);
    const [pageSize, setPageSize] = (0, $6fFrj.useState)(25);
    const [currentPage, setCurrentPage] = (0, $6fFrj.useState)(1);
    const [searchedValue, setSearchedValue] = (0, $6fFrj.useState)('');
    const [filters, setFilters] = (0, $6fFrj.useState)({
        filterType: 'AND'
    });
    const [sortObject, setSortObject] = (0, $6fFrj.useState)(()=>{
        // Check if there is a sort order saved in localStorage
        const savedSort = localStorage.getItem(`${progressStatusId}SortOrder`);
        return savedSort ? JSON.parse(savedSort) : {
            updateAt: 'desc'
        };
    });
    const tableDivRef = (0, $6fFrj.useRef)(null);
    const searchRef = (0, $6fFrj.useRef)(null);
    // graphql
    const { data: jobsDataWithPagination, loading: loadingJobs } = (0, $732264f53056e08f$export$a2975d7a4f6b5e8e)({
        variables: {
            progressStatusId: progressStatusId,
            skip: (currentPage - 1) * pageSize,
            take: pageSize,
            searchTerm: searchedValue,
            orderBy: sortObject,
            filter: filters
        },
        fetchPolicy: 'cache-and-network',
        onCompleted: (data)=>{
            if (searchedValue.length > 0) {
                if (data?.ClientsByTaxYearStatus?.data?.length === 0) {
                    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('No results found');
                    searchRef.current?.focus();
                }
                setDisplayClearButton(true);
            } else setDisplayClearButton(false);
        },
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
            // reset local storage sort order to default
            setSortObject({
                updateAt: 'desc'
            });
            localStorage.setItem(`${progressStatusId}SortOrder`, JSON.stringify({
                updateAt: 'desc'
            }));
        }
    });
    const { data: jobsData, pagination: pagination } = jobsDataWithPagination?.ClientsByTaxYearStatus || {};
    (0, $6fFrj.useEffect)(()=>{
        if (pagination?.total !== undefined) setTabCountMap((prevState)=>({
                ...prevState,
                [progressStatusId]: pagination.total
            }));
    }, [
        pagination?.total,
        progressStatusId
    ]);
    const components = {
        body: {
            row: (0, $259896312063de80$export$2e2bcd8739ae039)
        }
    };
    const progressStatusOnChange = (record, dropResult)=>{
        setDndData({
            record: record,
            dropResult: dropResult,
            prevProgressStatusId: progressStatusId
        });
        setProgressStatusDnDConfirmModalVisible(true);
    };
    const rowSelection = {
        onChange: (selectedRowKeys, row)=>{
            setSelectedKeys(selectedRowKeys);
            setSelectedRows(row);
        }
    };
    const moveRow = (0, $6fFrj.useCallback)((record, notSure, dropResult)=>{
        progressStatusOnChange(record, dropResult);
    }, []);
    const handleTableChange = (paginationInfo, filterss, sorter)=>{
        const orderByColumn = sorter.columnKey;
        const orderDirection = sorter.order === 'ascend' ? 'asc' : 'desc';
        let newSort = {
            updateAt: 'desc'
        };
        switch(orderByColumn){
            case 'firstName':
                newSort = {
                    TaxYear: {
                        Entity: {
                            Users: {
                                UserInformation: {
                                    firstName: orderDirection
                                }
                            }
                        }
                    }
                };
                break;
            case 'lastName':
                newSort = {
                    TaxYear: {
                        Entity: {
                            Users: {
                                UserInformation: {
                                    lastName: orderDirection
                                }
                            }
                        }
                    }
                };
                break;
            case 'email':
                newSort = {
                    TaxYear: {
                        Entity: {
                            Users: {
                                email: orderDirection
                            }
                        }
                    }
                };
                break;
            case 'taxYear':
                newSort = {
                    TaxYear: {
                        year: orderDirection
                    }
                };
                break;
            case 'jobType':
                newSort = {
                    Interviews: {
                        name: orderDirection
                    }
                };
                break;
            case 'timeInQueue':
                newSort = {
                    createAt: orderDirection
                };
                break;
            case 'inProgressTime':
                newSort = {
                    assignedAt: orderDirection
                };
                break;
            case 'currentPreparer':
                newSort = {
                    PreparedUser: {
                        UserInformation: {
                            lastName: orderDirection
                        }
                    }
                };
                break;
            case 'currentReviewer':
                newSort = {
                    ReviewedUser: {
                        UserInformation: {
                            lastName: orderDirection
                        }
                    }
                };
                break;
            case 'files':
                newSort = {
                    JobTracking: {
                        filesCompletedAt: orderDirection
                    }
                };
                break;
            case 'clientInterview':
                newSort = {
                    JobTracking: {
                        interviewCompletedAt: orderDirection
                    }
                };
                break;
            case 'clientInvoice':
                newSort = {
                    JobTracking: {
                        paymentsCompletedAt: orderDirection
                    }
                };
                break;
            case 'reviewStatus':
                newSort = {
                    reviewStatus: orderDirection
                };
                break;
            case 'clientCopyUploaded':
                newSort = {
                    JobTracking: {
                        approvalsCompletedAt: orderDirection
                    }
                };
                break;
            case 'completedDate':
                newSort = {
                    completedAt: orderDirection
                };
                break;
            default:
                newSort = {
                    updateAt: 'desc'
                };
                break;
        }
        setSortObject(newSort);
        localStorage.setItem(`${progressStatusId}SortOrder`, JSON.stringify(newSort));
    };
    // ! assignment to property of function parameter 'columns'
    // columns[0].fixed = screens.sm ? 'left' : false;
    // columns.forEach((item: any) => {
    //  item.sortOrder = sortedInfo.columnKey === 'referredBy' && sortedInfo.order;
    // });
    const today = new Date();
    const timeElapsed = (date)=>{
        const prevDate = new Date(date);
        const difference = today.getTime() - prevDate.getTime();
        return difference;
    };
    const jobs = jobsData?.map((item)=>{
        const taxYear = item?.TaxYear;
        const entity = taxYear?.Entity;
        const user = entity?.Users;
        const userInfo = user?.UserInformation;
        const interview = item?.Interviews;
        const jobTracking = item?.JobTracking;
        const preparedUser = item?.PreparedUser;
        const preparedUserInfo = preparedUser?.UserInformation;
        const preparedName = preparedUserInfo ? `${preparedUserInfo.firstName} ${preparedUserInfo.lastName}` : undefined;
        const reviewedUser = item?.ReviewedUser;
        const reviewedUserInfo = reviewedUser?.UserInformation;
        const reviewedName = reviewedUserInfo ? `${reviewedUserInfo.firstName} ${reviewedUserInfo.lastName}` : undefined;
        return {
            entityId: entity?.id,
            taxYearInterviewId: item?.id,
            firstName: userInfo?.firstName,
            lastName: userInfo?.lastName,
            name: `${userInfo?.firstName} ${userInfo?.lastName}`,
            email: user?.email,
            phone: (0, $c1ea95f1cc108fcb$export$2e2bcd8739ae039)(userInfo?.Phones),
            taxYear: taxYear?.year,
            jobType: interview?.name,
            inProgressTime: item?.assignedAt ? timeElapsed(item?.assignedAt) : undefined,
            userId: user?.id,
            referredBy: (0, $a4f6f7c5f30e5097$export$2e2bcd8739ae039).getUserName(user?.ReferredByUser),
            languageId: user?.languageId,
            progressStatusId: item?.progressStatusId,
            invitationEmailSent: user?.invitationEmailSent,
            password: user?.hasPassword,
            preparedId: preparedUser?.id,
            preparedName: preparedName,
            reviewedId: reviewedUser?.id,
            reviewedName: reviewedName,
            completedDate: item?.completedAt,
            timeInQueue: timeElapsed(item?.createAt),
            expectedCompletion: jobTracking?.expectedCompletion,
            paymentsCompletedAt: jobTracking?.paymentsCompletedAt,
            approvalsCompletedAt: jobTracking?.approvalsCompletedAt,
            interviewCompletedAt: jobTracking?.interviewCompletedAt,
            filesCompletedAt: jobTracking?.filesCompletedAt,
            assign: underlyingStatus !== 'COMPLETED' ? {
                taxYearId: taxYear?.id,
                preparedId: item?.PreparedUser?.id,
                reviewedId: item?.ReviewedUser?.id || undefined,
                interviewId: interview?.id,
                // status: TaxYearStatus.InProgress, // TODO: do I need this?
                assignedAt: item?.assignedAt,
                id: item?.id
            } : undefined,
            tasks: item?.Tasks,
            notes: item?.notes,
            reviewStatus: item?.reviewStatus
        };
    });
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $e3c84263568120dd$export$2e2bcd8739ae039), {
                selectedRows: selectedRows,
                setSelectedRows: setSelectedRows,
                setSelectedKeys: setSelectedKeys,
                tableData: jobs,
                tableRef: tableDivRef,
                type: "jobs",
                displayClearbutton: displayClearbutton,
                progressStatusName: progressStatusName,
                underlyingStatus: underlyingStatus,
                pageSize: pageSize,
                setPageSize: setPageSize,
                setSearchedValue: setSearchedValue,
                searchRef: searchRef,
                loading: loadingJobs || loadingProp,
                setFilters: setFilters
            }),
            (0, $bb3TF.jsx)("div", {
                style: {
                    height: '15px'
                }
            }),
            (0, $bb3TF.jsx)("div", {
                className: "tableDivRef",
                ref: tableDivRef,
                children: (0, $bb3TF.jsx)((0, $2eb2b7b37988b8f9$export$2e2bcd8739ae039), {
                    loading: loadingJobs || loadingProp,
                    sticky: {
                        offsetHeader: 45
                    },
                    tableLayout: "fixed",
                    rowSelection: {
                        type: 'checkbox',
                        fixed: true,
                        columnWidth: 35,
                        selectedRowKeys: selectedKeys,
                        ...rowSelection
                    },
                    scroll: {
                        x: 1000
                    },
                    showSorterTooltip: false,
                    components: components,
                    // eslint-disable-next-line arrow-body-style
                    onRow: (record, rowIndex)=>{
                        return {
                            // eslint-disable-next-line @typescript-eslint/no-empty-function
                            onClick: ()=>{},
                            moveRow: (event, p)=>{
                                moveRow(record, event, p);
                            }
                        };
                    },
                    columns: columns,
                    dataSource: jobs,
                    rowKey: (record)=>record.taxYearInterviewId,
                    onChange: handleTableChange,
                    noDataProps: {
                        title: 'No jobs yet',
                        extra: (0, $bb3TF.jsx)((0, $dfa33edebc49de1f$export$2e2bcd8739ae039), {})
                    },
                    pagination: {
                        hideOnSinglePage: true,
                        pageSize: pageSize,
                        total: pagination?.total,
                        current: currentPage,
                        showTotal: (total)=>`Total ${total} clients`,
                        onChange: (page)=>{
                            setCurrentPage(page);
                        },
                        onShowSizeChange: (current, size)=>{
                            setPageSize(size);
                        },
                        pageSizeOptions: [
                            '25',
                            '100',
                            '250',
                            '500'
                        ]
                    }
                })
            })
        ]
    });
};
var $a5ca70def816e8cb$export$2e2bcd8739ae039 = $a5ca70def816e8cb$var$JobsTable;



var $bb3TF = parcelRequire("bb3TF");


var $6Sgv0 = parcelRequire("6Sgv0");

var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");




const { Option: $9d1300c931ed4287$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const $9d1300c931ed4287$var$SelectTeamMember = ({ type: type, taxYearInterviewId: taxYearInterviewId, assignedMemberId: assignedMemberId, progressStatusId: progressStatusId, userRole: userRole })=>{
    const { firmAccountId: firmAccountId, progressStatuses: progressStatuses } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const { data: data, loading: loading } = (0, $732264f53056e08f$export$deb804dbb627e21)({
        variables: {
            firmAccountId: firmAccountId,
            filterDelete: true
        }
    });
    const [assignTaxYearInterview, { loading: assignTaxYearInterviewLoading }] = (0, $33beb5b1bfae180c$export$232e68358ba46ee7)();
    const handleChange = async (value)=>{
        try {
            if (value !== assignedMemberId && !(assignedMemberId === undefined && value === 'Not Assigned')) {
                const preparedOrReviewed = type === 'Preparer' ? 'preparedId' : 'reviewedId';
                const payload = type === 'Preparer' ? {
                    preparedId: value !== 'Not Assigned' ? value : null
                } : {
                    reviewedId: value !== 'Not Assigned' ? value : null
                };
                const result = await assignTaxYearInterview({
                    variables: {
                        input: {
                            id: taxYearInterviewId,
                            ...payload
                        }
                    },
                    refetchQueries: [
                        'GetClientsByProgressStatusId'
                    ],
                    awaitRefetchQueries: true
                });
                const updatedJob = result.data?.AssignTaxYearInterviewJob;
                const newAssigned = updatedJob[preparedOrReviewed];
                const newProgressStatusId = updatedJob.progressStatusId;
                let messageText = `The ${type.toLocaleLowerCase()} was successfully ${newAssigned ? 'assigned' : 'unassigned'}.`;
                if (newProgressStatusId !== progressStatusId) {
                    const newProgressStatusName = progressStatuses.find((x)=>x.id === newProgressStatusId)?.status;
                    if (newProgressStatusName) messageText += ` The job progress status was changed to ${newProgressStatusName}.`;
                }
                // dispatch(updateJobInList({ id: taxYearInterviewId, [preparedOrReviewed]: newAssigned }));
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success(messageText);
            }
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`Something went wrong while trying to assign the ${type.toLocaleLowerCase()}`);
        }
    };
    const userFirmAccounts = data?.UserFirmAccountByFirmAccountAndFilter;
    const currentItem = userFirmAccounts?.find((x)=>x?.Users?.id === assignedMemberId);
    const currentUserInfo = currentItem?.Users?.UserInformation;
    const currentName = currentUserInfo ? `${currentUserInfo.firstName} ${currentUserInfo.lastName}` : 'Not Assigned';
    return (0, $bb3TF.jsx)("div", {
        children: userRole === 'STAFF' ? (0, $bb3TF.jsx)("span", {
            children: currentName
        }) : (0, $bb3TF.jsxs)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
            size: "small",
            style: {
                maxWidth: '250px',
                minWidth: '145px'
            },
            onSelect: handleChange,
            loading: loading || assignTaxYearInterviewLoading,
            onClick: (e)=>{
                e.stopPropagation();
            },
            value: assignedMemberId ?? 'Not Assigned',
            defaultValue: assignedMemberId ?? 'Not Assigned',
            children: [
                (0, $bb3TF.jsx)($9d1300c931ed4287$var$Option, {
                    value: "Not Assigned",
                    children: "Not Assigned"
                }),
                userFirmAccounts && userFirmAccounts.map((item)=>(0, $bb3TF.jsx)($9d1300c931ed4287$var$Option, {
                        value: item.Users.id,
                        style: item.Users.deleteAt ? {
                            display: 'none'
                        } : {},
                        children: `${item.Users.UserInformation?.firstName} ${item.Users.UserInformation?.lastName}`
                    }, item.Users.id))
            ]
        })
    });
};
var $9d1300c931ed4287$export$2e2bcd8739ae039 = $9d1300c931ed4287$var$SelectTeamMember;





var $bb3TF = parcelRequire("bb3TF");



const { Circle: $e39c35e1ca5a0e9e$var$Circle, CheckCircleOutlined: $e39c35e1ca5a0e9e$var$CheckCircleOutlined, ExclamationCircleOutlined: $e39c35e1ca5a0e9e$var$ExclamationCircleOutlined, ClockCircleOutlined: $e39c35e1ca5a0e9e$var$ClockCircleOutlined, LoadingOutlined: $e39c35e1ca5a0e9e$var$LoadingOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $e39c35e1ca5a0e9e$var$Documents(props) {
    const { record: record } = props || {};
    const { filesCompletedAt: filesCompletedAt, tasks: tasks, taxYearInterviewId: taxYearInterviewId } = record || {};
    const documentTasks = (tasks ?? []).filter((task)=>task.taskType === (0, $8f7fe33a44836803$export$1f8b1cab05cab788)?.Documents || task.taskType === (0, $8f7fe33a44836803$export$1f8b1cab05cab788)?.RequestDocuments);
    const inCompleteDocumentTasks = documentTasks.filter((task)=>!task.completedAt);
    // graphql
    const [upsertJobTracking, { loading: loadingUpsertJobTracking }] = (0, $4066a7fc7221bcd4$export$5d2654c94a62b996)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    const markComplete = async ()=>{
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    filesCompletedAt: new Date()
                }
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Marked as complete');
            }
        });
    };
    const markNotComplete = async ()=>{
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    filesCompletedAt: null
                }
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Marked as not complete');
            }
        });
    };
    if (loadingUpsertJobTracking) return (0, $bb3TF.jsx)($e39c35e1ca5a0e9e$var$LoadingOutlined, {
        className: "status-icon"
    });
    const markReadMenu = (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
        children: (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
            onClick: markNotComplete,
            children: "Mark as not complete"
        }, "mark-read")
    });
    const markUnreadMenu = (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
        children: (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
            onClick: markComplete,
            children: "Mark as complete"
        }, "mark-unread")
    });
    if (filesCompletedAt) return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markReadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Completed!",
            children: (0, $bb3TF.jsx)($e39c35e1ca5a0e9e$var$CheckCircleOutlined, {
                className: "status-icon",
                style: {
                    color: 'green'
                }
            })
        })
    });
    if (documentTasks?.length > 0 && inCompleteDocumentTasks?.length === 0) return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markUnreadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Client Updated Info",
            children: (0, $bb3TF.jsx)($e39c35e1ca5a0e9e$var$ExclamationCircleOutlined, {
                className: "status-icon",
                style: {
                    color: 'orange'
                }
            })
        })
    });
    if (documentTasks?.length > 0 && inCompleteDocumentTasks?.length > 0) return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markUnreadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Waiting for client response",
            children: (0, $bb3TF.jsx)($e39c35e1ca5a0e9e$var$ClockCircleOutlined, {
                className: "status-icon",
                style: {
                    color: 'orange'
                }
            })
        })
    });
    return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markUnreadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Documents not found",
            children: (0, $bb3TF.jsx)("span", {
                role: "img",
                tabIndex: -1,
                className: "anticon status-icon ant-dropdown-trigger",
                children: (0, $bb3TF.jsx)($e39c35e1ca5a0e9e$var$Circle, {
                    width: "1em",
                    height: "1em",
                    className: "status-icon",
                    style: {
                        color: 'gray'
                    }
                })
            })
        })
    });
}
var $e39c35e1ca5a0e9e$export$2e2bcd8739ae039 = $e39c35e1ca5a0e9e$var$Documents;



var $bb3TF = parcelRequire("bb3TF");

const { Circle: $feec7e745fbd67e1$var$Circle, CheckCircleOutlined: $feec7e745fbd67e1$var$CheckCircleOutlined, ClockCircleOutlined: $feec7e745fbd67e1$var$ClockCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $feec7e745fbd67e1$var$Activation({ invitationEmailSent: invitationEmailSent, password: password }) {
    if (invitationEmailSent && password) return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        title: "Activation sent & accepted!",
        children: (0, $bb3TF.jsx)($feec7e745fbd67e1$var$CheckCircleOutlined, {
            className: "status-icon",
            style: {
                color: 'green'
            }
        })
    });
    if (invitationEmailSent && !password) return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        title: "Activation sent, not yet accepted",
        children: (0, $bb3TF.jsx)($feec7e745fbd67e1$var$ClockCircleOutlined, {
            className: "status-icon",
            style: {
                color: 'orange'
            }
        })
    });
    if (!invitationEmailSent && password) return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        title: "Client is active!",
        children: (0, $bb3TF.jsx)($feec7e745fbd67e1$var$CheckCircleOutlined, {
            className: "status-icon",
            style: {
                color: 'green'
            }
        })
    });
    return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        title: "Activation not sent",
        children: (0, $bb3TF.jsx)("span", {
            role: "img",
            tabIndex: -1,
            className: "anticon status-icon",
            children: (0, $bb3TF.jsx)($feec7e745fbd67e1$var$Circle, {
                width: "1em",
                height: "1em",
                className: "status-icon",
                style: {
                    color: 'gray'
                }
            })
        })
    });
}
var $feec7e745fbd67e1$export$2e2bcd8739ae039 = $feec7e745fbd67e1$var$Activation;



var $bb3TF = parcelRequire("bb3TF");

const { Circle: $ef0c8dde88639a9c$var$Circle, CheckCircleOutlined: $ef0c8dde88639a9c$var$CheckCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $ef0c8dde88639a9c$var$Notes(props) {
    const { record: record } = props || {};
    const { notes: notes } = record || {};
    if (notes?.length > 0) return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        title: "Notes found",
        children: (0, $bb3TF.jsx)($ef0c8dde88639a9c$var$CheckCircleOutlined, {
            className: "status-icon",
            style: {
                color: 'green'
            }
        })
    });
    return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        title: "Notes not found",
        children: (0, $bb3TF.jsx)("span", {
            role: "img",
            tabIndex: -1,
            className: "anticon status-icon",
            children: (0, $bb3TF.jsx)($ef0c8dde88639a9c$var$Circle, {
                width: "1em",
                height: "1em",
                className: "status-icon",
                style: {
                    color: 'gray'
                }
            })
        })
    });
}
var $ef0c8dde88639a9c$export$2e2bcd8739ae039 = $ef0c8dde88639a9c$var$Notes;



var $bb3TF = parcelRequire("bb3TF");



const { CheckCircleOutlined: $bcfed50df82b3605$var$CheckCircleOutlined, ExclamationCircleOutlined: $bcfed50df82b3605$var$ExclamationCircleOutlined, Circle: $bcfed50df82b3605$var$Circle, LoadingOutlined: $bcfed50df82b3605$var$LoadingOutlined, ClockCircleOutlined: $bcfed50df82b3605$var$ClockCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $bcfed50df82b3605$var$Interview(props) {
    const { record: record } = props;
    const { interviewCompletedAt: interviewCompletedAt, tasks: tasks, taxYearInterviewId: taxYearInterviewId } = record;
    const interviewTasks = tasks?.filter((task)=>task.taskType === (0, $8f7fe33a44836803$export$1f8b1cab05cab788).Interview);
    const inCompleteInterviewTasks = interviewTasks?.filter((task)=>!task.completedAt);
    // graphql
    const [upsertJobTracking, { loading: loadingUpsertJobTracking }] = (0, $4066a7fc7221bcd4$export$5d2654c94a62b996)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    const markComplete = async ()=>{
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    interviewCompletedAt: new Date()
                }
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Marked as complete');
            }
        });
    };
    const markNotComplete = async ()=>{
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    interviewCompletedAt: null
                }
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Marked as not complete');
            }
        });
    };
    const markReadMenu = (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
        children: (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
            onClick: markNotComplete,
            children: "Mark as not complete"
        }, "mark-read")
    });
    const markUnreadMenu = (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
        children: (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
            onClick: markComplete,
            children: "Mark as complete"
        }, "mark-unread")
    });
    if (loadingUpsertJobTracking) return (0, $bb3TF.jsx)($bcfed50df82b3605$var$LoadingOutlined, {
        className: "status-icon"
    });
    if (interviewCompletedAt) return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markReadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Interview Completed!",
            children: (0, $bb3TF.jsx)($bcfed50df82b3605$var$CheckCircleOutlined, {
                className: "status-icon",
                style: {
                    color: 'green'
                }
            })
        })
    });
    if (interviewTasks?.length > 0 && inCompleteInterviewTasks?.length === 0) return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markUnreadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Client updated info",
            children: (0, $bb3TF.jsx)($bcfed50df82b3605$var$ExclamationCircleOutlined, {
                className: "status-icon",
                style: {
                    color: 'orange'
                }
            })
        })
    });
    if (interviewTasks?.length > 0 && inCompleteInterviewTasks?.length > 0) return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markUnreadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Waiting for client response",
            children: (0, $bb3TF.jsx)($bcfed50df82b3605$var$ClockCircleOutlined, {
                className: "status-icon",
                style: {
                    color: 'orange'
                }
            })
        })
    });
    return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markUnreadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Not started",
            children: (0, $bb3TF.jsx)("span", {
                role: "img",
                tabIndex: -1,
                className: "anticon status-icon ant-dropdown-trigger",
                children: (0, $bb3TF.jsx)($bcfed50df82b3605$var$Circle, {
                    width: "1em",
                    height: "1em",
                    className: "status-icon",
                    style: {
                        color: 'gray'
                    }
                })
            })
        })
    });
}
var $bcfed50df82b3605$export$2e2bcd8739ae039 = $bcfed50df82b3605$var$Interview;



var $bb3TF = parcelRequire("bb3TF");



const { Circle: $0c6014fe769fedd1$var$Circle, CheckCircleOutlined: $0c6014fe769fedd1$var$CheckCircleOutlined, ClockCircleOutlined: $0c6014fe769fedd1$var$ClockCircleOutlined, ExclamationCircleOutlined: $0c6014fe769fedd1$var$ExclamationCircleOutlined, LoadingOutlined: $0c6014fe769fedd1$var$LoadingOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $0c6014fe769fedd1$var$Invoice(props) {
    const { record: record } = props;
    const { paymentsCompletedAt: paymentsCompletedAt, tasks: tasks, taxYearInterviewId: taxYearInterviewId } = record;
    const invoiceTasks = (tasks ?? []).filter((task)=>task.taskType === (0, $8f7fe33a44836803$export$1f8b1cab05cab788).Payments);
    const inCompleteInvoiceTasks = invoiceTasks.filter((task)=>!task.completedAt);
    // graphql
    const [upsertJobTracking, { loading: loadingUpsertJobTracking }] = (0, $4066a7fc7221bcd4$export$5d2654c94a62b996)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    const markComplete = async ()=>{
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    paymentsCompletedAt: new Date()
                }
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Marked as complete');
            }
        });
    };
    const markNotComplete = async ()=>{
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    paymentsCompletedAt: null
                }
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Marked as not complete');
            }
        });
    };
    const markReadMenu = (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
        children: (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
            onClick: markNotComplete,
            children: "Mark as not complete"
        }, "mark-read")
    });
    const markUnreadMenu = (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
        children: (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
            onClick: markComplete,
            children: "Mark as complete"
        }, "mark-unread")
    });
    if (loadingUpsertJobTracking) return (0, $bb3TF.jsx)($0c6014fe769fedd1$var$LoadingOutlined, {
        className: "status-icon"
    });
    if (paymentsCompletedAt) return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markReadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Completed!",
            children: (0, $bb3TF.jsx)($0c6014fe769fedd1$var$CheckCircleOutlined, {
                className: "status-icon",
                style: {
                    color: 'green'
                }
            })
        })
    });
    if (invoiceTasks.length > 0 && inCompleteInvoiceTasks.length === 0) return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markUnreadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Client Updated Info",
            children: (0, $bb3TF.jsx)($0c6014fe769fedd1$var$ExclamationCircleOutlined, {
                className: "status-icon",
                style: {
                    color: 'orange'
                }
            })
        })
    });
    if (invoiceTasks.length > 0 && inCompleteInvoiceTasks.length > 0) return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markUnreadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Waiting for client payment",
            children: (0, $bb3TF.jsx)($0c6014fe769fedd1$var$ClockCircleOutlined, {
                className: "status-icon",
                style: {
                    color: 'orange'
                }
            })
        })
    });
    return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markUnreadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Not started",
            children: (0, $bb3TF.jsx)("span", {
                role: "img",
                tabIndex: -1,
                className: "anticon status-icon ant-dropdown-trigger",
                children: (0, $bb3TF.jsx)($0c6014fe769fedd1$var$Circle, {
                    width: "1em",
                    height: "1em",
                    className: "status-icon",
                    style: {
                        color: 'gray'
                    }
                })
            })
        })
    });
}
var $0c6014fe769fedd1$export$2e2bcd8739ae039 = $0c6014fe769fedd1$var$Invoice;



var $bb3TF = parcelRequire("bb3TF");


const { Circle: $e90d760a1801a805$var$Circle, CheckCircleOutlined: $e90d760a1801a805$var$CheckCircleOutlined, ClockCircleOutlined: $e90d760a1801a805$var$ClockCircleOutlined, ExclamationCircleOutlined: $e90d760a1801a805$var$ExclamationCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $e90d760a1801a805$var$Review({ reviewStatus: reviewStatus }) {
    if (reviewStatus === (0, $8f7fe33a44836803$export$ddbe8748ad68508)?.Accepted) return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        title: "Review completed!",
        children: (0, $bb3TF.jsx)($e90d760a1801a805$var$CheckCircleOutlined, {
            className: "status-icon",
            style: {
                color: 'green'
            }
        })
    });
    if (reviewStatus === (0, $8f7fe33a44836803$export$ddbe8748ad68508)?.In) return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        title: "In Review",
        children: (0, $bb3TF.jsx)($e90d760a1801a805$var$ClockCircleOutlined, {
            className: "status-icon",
            style: {
                color: 'orange'
            }
        })
    });
    if (reviewStatus === (0, $8f7fe33a44836803$export$ddbe8748ad68508)?.Rejected) return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        title: "Review rejected",
        children: (0, $bb3TF.jsx)($e90d760a1801a805$var$ExclamationCircleOutlined, {
            className: "status-icon",
            style: {
                color: 'red'
            }
        })
    });
    return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        title: "No review",
        children: (0, $bb3TF.jsx)("span", {
            role: "img",
            tabIndex: -1,
            className: "anticon status-icon",
            children: (0, $bb3TF.jsx)($e90d760a1801a805$var$Circle, {
                width: "1em",
                height: "1em",
                className: "status-icon",
                style: {
                    color: 'gray'
                }
            })
        })
    });
}
var $e90d760a1801a805$export$2e2bcd8739ae039 = $e90d760a1801a805$var$Review;



var $bb3TF = parcelRequire("bb3TF");



const { Circle: $91def2f8fe3a5918$var$Circle, CheckCircleOutlined: $91def2f8fe3a5918$var$CheckCircleOutlined, ClockCircleOutlined: $91def2f8fe3a5918$var$ClockCircleOutlined, ExclamationCircleOutlined: $91def2f8fe3a5918$var$ExclamationCircleOutlined, LoadingOutlined: $91def2f8fe3a5918$var$LoadingOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $91def2f8fe3a5918$var$Approval(props) {
    const { record: record } = props || {};
    const { approvalsCompletedAt: approvalsCompletedAt, tasks: tasks, taxYearInterviewId: taxYearInterviewId } = record || {};
    const approvalTasks = tasks?.filter((task)=>task.taskType === (0, $8f7fe33a44836803$export$1f8b1cab05cab788)?.Signatures);
    const inCompleteApprovalTasks = approvalTasks?.filter((task)=>!task.completedAt);
    // graphql
    const [upsertJobTracking, { loading: loadingUpsertJobTracking }] = (0, $4066a7fc7221bcd4$export$5d2654c94a62b996)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    const markComplete = async ()=>{
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    approvalsCompletedAt: new Date()
                }
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Marked as complete');
            }
        });
    };
    const markNotComplete = async ()=>{
        upsertJobTracking({
            variables: {
                createJobTrackingInput: {
                    taxYearInterviewId: taxYearInterviewId,
                    approvalsCompletedAt: null
                }
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Marked as not complete');
            }
        });
    };
    const markReadMenu = (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
        children: (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
            onClick: markNotComplete,
            children: "Mark as not complete"
        }, "mark-read")
    });
    const markUnreadMenu = (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
        children: (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
            onClick: markComplete,
            children: "Mark as complete"
        }, "mark-unread")
    });
    if (loadingUpsertJobTracking) return (0, $bb3TF.jsx)($91def2f8fe3a5918$var$LoadingOutlined, {
        className: "status-icon"
    });
    if (approvalsCompletedAt) return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markReadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Completed!",
            children: (0, $bb3TF.jsx)($91def2f8fe3a5918$var$CheckCircleOutlined, {
                className: "status-icon",
                style: {
                    color: 'green'
                }
            })
        })
    });
    if (approvalTasks?.length > 0 && inCompleteApprovalTasks?.length === 0) return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markUnreadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Client Updated Info",
            children: (0, $bb3TF.jsx)($91def2f8fe3a5918$var$ExclamationCircleOutlined, {
                className: "status-icon",
                style: {
                    color: 'orange'
                }
            })
        })
    });
    if (approvalTasks?.length > 0 && inCompleteApprovalTasks?.length > 0) return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markUnreadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Waiting for client response",
            children: (0, $bb3TF.jsx)($91def2f8fe3a5918$var$ClockCircleOutlined, {
                className: "status-icon",
                style: {
                    color: 'orange'
                }
            })
        })
    });
    return (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
        overlay: markUnreadMenu,
        trigger: [
            'click'
        ],
        children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
            title: "Not started",
            children: (0, $bb3TF.jsx)("span", {
                role: "img",
                tabIndex: -1,
                className: "anticon status-icon ant-dropdown-trigger",
                children: (0, $bb3TF.jsx)($91def2f8fe3a5918$var$Circle, {
                    width: "1em",
                    height: "1em",
                    className: "status-icon",
                    style: {
                        color: 'gray'
                    }
                })
            })
        })
    });
}
var $91def2f8fe3a5918$export$2e2bcd8739ae039 = $91def2f8fe3a5918$var$Approval;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");




function $726657375c530783$export$2e2bcd8739ae039({ email: email, phone: phone, userId: userId, entityId: entityId, name: name, workNumber: workNumber, languageId: languageId, landlineNumber: landlineNumber, userInformationId: userInformationId, taxYearInterviewId: taxYearInterviewId, allTaxYearInterview: allTaxYearInterview = false }) {
    const { jobs: jobs } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $59a61dbb6cd2676b$export$6ff67ccf1d823f06));
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const to = `/clients/details?entityId=${entityId}${!allTaxYearInterview ? `&taxYearInterviewId=${taxYearInterviewId}` : ''}`;
    const setClientState = ()=>{
        dispatch((0, $59a61dbb6cd2676b$export$b7c209536cc73fdf)({
            email: email,
            entityId: entityId,
            name: name,
            languageId: languageId,
            id: userId,
            workNumber: workNumber,
            landlineNumber: landlineNumber,
            userInformationId: userInformationId,
            phoneNumber: phone,
            job: jobs.filter((item)=>item.id === taxYearInterviewId)[0] ?? undefined
        }));
    };
    const handleLinkClick = (event)=>{
        event.stopPropagation();
        // setClientState();
        (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).JOB_DETAILS, {
            email: email,
            url: window.location.href,
            to: to
        });
    };
    return (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
        onClick: handleLinkClick,
        to: to,
        children: (0, $bb3TF.jsx)("div", {
            style: {
                whiteSpace: 'nowrap'
            },
            children: name
        })
    });
}



const { MailOutlined: $5a6b7b66be5b12f3$var$MailOutlined, FileOutlined: $5a6b7b66be5b12f3$var$FileOutlined, FormOutlined: $5a6b7b66be5b12f3$var$FormOutlined, QuestionCircleOutlined: $5a6b7b66be5b12f3$var$QuestionCircleOutlined, DollarOutlined: $5a6b7b66be5b12f3$var$DollarOutlined, LikeOutlined: $5a6b7b66be5b12f3$var$LikeOutlined, CheckOutlined: $5a6b7b66be5b12f3$var$CheckOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $5a6b7b66be5b12f3$var$convertShortFormSortOrderToLongForm = (sortOrder)=>{
    if (sortOrder === 'asc') return 'ascend';
    if (sortOrder === 'desc') return 'descend';
    return null;
};
const $5a6b7b66be5b12f3$var$getInProgressColumns = (userRole, progressStatusId)=>{
    const savedSort = JSON.parse(localStorage.getItem(`${progressStatusId}SortOrder`));
    return [
        {
            title: 'First Name',
            dataIndex: '',
            key: 'firstName',
            sorter: true,
            defaultSortOrder: $5a6b7b66be5b12f3$var$convertShortFormSortOrderToLongForm(savedSort?.TaxYear?.Entity?.Users?.UserInformation?.firstName),
            // sortOrder: sortedInfo.columnKey === "name" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: ({ email: email, phone: phone, userId: userId, entityId: entityId, firstName: firstName, workNumber: workNumber, languageId: languageId, landlineNumber: landlineNumber, userInformationId: userInformationId, taxYearInterviewId: taxYearInterviewId })=>(0, $bb3TF.jsx)((0, $726657375c530783$export$2e2bcd8739ae039), {
                    email: email,
                    userId: userId,
                    phone: phone?.value,
                    entityId: entityId,
                    name: firstName,
                    languageId: languageId,
                    workNumber: workNumber?.value,
                    userInformationId: userInformationId,
                    landlineNumber: landlineNumber?.value,
                    taxYearInterviewId: taxYearInterviewId
                }),
            // fixed: screens.sm ? 'left' : false,
            width: 126,
            className: 'column-name-overflow-hidden'
        },
        {
            title: 'Last Name',
            dataIndex: '',
            key: 'lastName',
            sorter: true,
            defaultSortOrder: $5a6b7b66be5b12f3$var$convertShortFormSortOrderToLongForm(savedSort?.TaxYear?.Entity?.Users?.UserInformation?.lastName),
            // sortOrder: sortedInfo.columnKey === "name" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: ({ email: email, phone: phone, userId: userId, entityId: entityId, lastName: lastName, workNumber: workNumber, languageId: languageId, landlineNumber: landlineNumber, userInformationId: userInformationId, taxYearInterviewId: taxYearInterviewId })=>(0, $bb3TF.jsx)((0, $726657375c530783$export$2e2bcd8739ae039), {
                    email: email,
                    userId: userId,
                    phone: phone?.value,
                    entityId: entityId,
                    name: lastName,
                    languageId: languageId,
                    workNumber: workNumber?.value,
                    userInformationId: userInformationId,
                    landlineNumber: landlineNumber?.value,
                    taxYearInterviewId: taxYearInterviewId
                }),
            // fixed: screens.sm ? 'left' : false,
            width: 126,
            className: 'column-name-overflow-hidden'
        },
        {
            title: 'Email',
            dataIndex: 'email',
            sorter: true,
            defaultSortOrder: $5a6b7b66be5b12f3$var$convertShortFormSortOrderToLongForm(savedSort?.TaxYear?.Entity?.Users?.email),
            // sortOrder: sortedInfo.columnKey === "email" && sortedInfo.order,
            key: 'email',
            width: 200
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            sorter: false,
            // sortOrder: sortedInfo.columnKey === "email" && sortedInfo.order,
            render: (record)=>(0, $bb3TF.jsx)("span", {
                    children: record?.value && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                        children: [
                            (0, $d637e76af0848ec5$export$2e2bcd8739ae039)(record),
                            ' ',
                            record?.value ?? ''
                        ]
                    })
                }),
            key: 'phone',
            width: 200
        },
        {
            title: 'Tax Year',
            dataIndex: 'taxYear',
            sorter: true,
            defaultSortOrder: $5a6b7b66be5b12f3$var$convertShortFormSortOrderToLongForm(savedSort?.TaxYear?.year),
            // sortOrder: sortedInfo.columnKey === "taxYear" && sortedInfo.order,
            key: 'taxYear',
            width: 85
        },
        {
            title: 'Job Type',
            dataIndex: 'jobType',
            sorter: true,
            defaultSortOrder: $5a6b7b66be5b12f3$var$convertShortFormSortOrderToLongForm(savedSort?.Interviews?.name),
            // sortOrder: sortedInfo.columnKey === "jobType" && sortedInfo.order,
            key: 'jobType',
            width: 140
        },
        {
            title: 'Time in Progress',
            dataIndex: 'inProgressTime',
            sorter: true,
            defaultSortOrder: $5a6b7b66be5b12f3$var$convertShortFormSortOrderToLongForm(savedSort?.assignedAt),
            // sortOrder: sortedInfo.columnKey === "inProgressTime" && sortedInfo.order,
            key: 'inProgressTime',
            render: (text)=>(0, $5bafd68f69b44f55$export$d784918a83e8de76)(text),
            renderText: (text)=>(0, $5bafd68f69b44f55$export$d784918a83e8de76)(text),
            width: 115
        },
        {
            title: (0, $bb3TF.jsx)($5a6b7b66be5b12f3$var$FileOutlined, {
                title: "Documents",
                className: "column-icon"
            }),
            label: 'Documents',
            key: 'files',
            sorter: true,
            defaultSortOrder: $5a6b7b66be5b12f3$var$convertShortFormSortOrderToLongForm(savedSort?.JobTracking?.filesCompletedAt),
            // sortOrder: sortedInfo.columnKey === "files" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: (text, record)=>(0, $bb3TF.jsx)((0, $e39c35e1ca5a0e9e$export$2e2bcd8739ae039), {
                    record: record
                }),
            renderText: (docStatus)=>{
                if (!docStatus) return 'Documents not found';
                return null;
            },
            width: 55
        },
        {
            title: (0, $bb3TF.jsx)($5a6b7b66be5b12f3$var$QuestionCircleOutlined, {
                title: "Client Interview Status",
                className: "column-icon"
            }),
            label: 'Client Interview Status',
            dataIndex: '',
            key: 'clientInterview',
            sorter: true,
            defaultSortOrder: $5a6b7b66be5b12f3$var$convertShortFormSortOrderToLongForm(savedSort?.JobTracking?.interviewCompletedAt),
            // sortOrder: sortedInfo.columnKey === "clientInterview" && sortedInfo.order,
            render: (text, record)=>(0, $bb3TF.jsx)((0, $bcfed50df82b3605$export$2e2bcd8739ae039), {
                    record: record
                }),
            // renderText: (data, row) => statusIndicators(row.taxYearStatus.clientInterview, row, true),
            width: 55
        },
        {
            title: (0, $bb3TF.jsx)($5a6b7b66be5b12f3$var$LikeOutlined, {
                title: "Review Status",
                className: "column-icon"
            }),
            label: 'Review Status',
            dataIndex: 'reviewStatus',
            key: 'reviewStatus',
            sorter: true,
            defaultSortOrder: $5a6b7b66be5b12f3$var$convertShortFormSortOrderToLongForm(savedSort?.reviewStatus),
            // sortOrder: sortedInfo.columnKey === "reviewStatus" && sortedInfo.order,
            render: (text, record)=>(0, $bb3TF.jsx)((0, $e90d760a1801a805$export$2e2bcd8739ae039), {
                    reviewStatus: text
                }),
            // renderText: (data, row) => RenderInternalReviewStatus(data, row, true),
            width: 55
        },
        {
            title: (0, $bb3TF.jsx)($5a6b7b66be5b12f3$var$CheckOutlined, {
                title: "Client E-File Approval",
                className: "column-icon"
            }),
            label: 'Client Document Approval Status',
            dataIndex: '',
            key: 'clientCopyUploaded',
            sorter: true,
            defaultSortOrder: $5a6b7b66be5b12f3$var$convertShortFormSortOrderToLongForm(savedSort?.JobTracking?.approvalsCompletedAt),
            // sortOrder: sortedInfo.columnKey === "clientCopyUploaded" && sortedInfo.order,
            render: (text, record)=>(0, $bb3TF.jsx)((0, $91def2f8fe3a5918$export$2e2bcd8739ae039), {
                    record: record
                }),
            // renderText: (data, row) => statusIndicators(row.taxYearStatus.eFileAuth, row, true),
            width: 55
        },
        {
            title: ()=>(0, $bb3TF.jsx)($5a6b7b66be5b12f3$var$MailOutlined, {
                    title: "Activation Sent",
                    className: "column-icon"
                }),
            label: 'Envelop',
            dataIndex: 'invitationEmailSent',
            key: 'invitationEmailSent',
            sorter: false,
            // sortOrder: sortedInfo.columnKey === "invitationEmailSent" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: (text, record)=>(0, $bb3TF.jsx)((0, $feec7e745fbd67e1$export$2e2bcd8739ae039), {
                    invitationEmailSent: text,
                    password: record?.password
                }),
            width: 55
        },
        {
            title: (0, $bb3TF.jsx)($5a6b7b66be5b12f3$var$FormOutlined, {
                title: "Notes",
                className: "column-icon"
            }),
            label: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
            sorter: false,
            // sortOrder: sortedInfo.columnKey === "comments" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: (text, record)=>(0, $bb3TF.jsx)((0, $ef0c8dde88639a9c$export$2e2bcd8739ae039), {
                    record: record
                }),
            renderText: (comments)=>{
                if (!comments) return 'Notes not found';
                return (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(new Date(comments.createdAt)).format();
            },
            width: 55
        },
        {
            title: (0, $bb3TF.jsx)($5a6b7b66be5b12f3$var$DollarOutlined, {
                title: "Client Payment Received",
                className: "column-icon"
            }),
            label: 'Client Payment Status',
            dataIndex: '',
            key: 'clientInvoice',
            sorter: false,
            // sortOrder: sortedInfo.columnKey === "clientInvoice" && sortedInfo.order,
            render: (record)=>(0, $bb3TF.jsx)((0, $0c6014fe769fedd1$export$2e2bcd8739ae039), {
                    record: record
                }),
            // renderText: (data, row) => statusIndicators(row.taxYearStatus.clientInvoice, row, true),
            width: 55
        },
        {
            title: 'Referred By',
            dataIndex: 'referredBy',
            sorter: false,
            // sortOrder: sortedInfo.columnKey === "referredBy" && sortedInfo.order,
            key: 'referredBy',
            width: 150
        },
        {
            title: 'Preparer',
            dataIndex: '',
            align: 'center',
            sorter: true,
            defaultSortOrder: $5a6b7b66be5b12f3$var$convertShortFormSortOrderToLongForm(savedSort?.PreparedUser?.UserInformation?.firstName),
            key: 'currentPreparer',
            // sortOrder: sortedInfo.columnKey === "currentPreparer" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: ({ taxYearInterviewId: taxYearInterviewId, preparedId: preparedId, progressStatusId: progStatusId })=>(0, $bb3TF.jsx)((0, $9d1300c931ed4287$export$2e2bcd8739ae039), {
                    type: "Preparer",
                    taxYearInterviewId: taxYearInterviewId,
                    assignedMemberId: preparedId,
                    progressStatusId: progStatusId,
                    userRole: userRole
                }),
            width: 170
        },
        {
            title: 'Reviewer',
            dataIndex: '',
            align: 'center',
            sorter: true,
            defaultSortOrder: $5a6b7b66be5b12f3$var$convertShortFormSortOrderToLongForm(savedSort?.ReviewedUser?.UserInformation?.firstName),
            key: 'currentReviewer',
            // sortOrder: sortedInfo.columnKey === "currentReviewer" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: ({ taxYearInterviewId: taxYearInterviewId, reviewedId: reviewedId, progressStatusId: progStatusId })=>(0, $bb3TF.jsx)((0, $9d1300c931ed4287$export$2e2bcd8739ae039), {
                    type: "Reviewer",
                    taxYearInterviewId: taxYearInterviewId,
                    assignedMemberId: reviewedId,
                    progressStatusId: progStatusId,
                    userRole: userRole
                }),
            width: 170
        }
    ];
};
var $5a6b7b66be5b12f3$export$2e2bcd8739ae039 = $5a6b7b66be5b12f3$var$getInProgressColumns;



var $bb3TF = parcelRequire("bb3TF");


var $6Sgv0 = parcelRequire("6Sgv0");














const { MailOutlined: $a4248ac38bbe43ba$var$MailOutlined, FileOutlined: $a4248ac38bbe43ba$var$FileOutlined, FormOutlined: $a4248ac38bbe43ba$var$FormOutlined, DollarOutlined: $a4248ac38bbe43ba$var$DollarOutlined, RightOutlined: $a4248ac38bbe43ba$var$RightOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $a4248ac38bbe43ba$var$convertShortFormSortOrderToLongForm = (sortOrder)=>{
    if (sortOrder === 'asc') return 'ascend';
    if (sortOrder === 'desc') return 'descend';
    return null;
};
const $a4248ac38bbe43ba$var$StartButton = ({ record: { taxYearInterviewId: taxYearInterviewId } })=>{
    // get all the progressStatuses from the session
    const { progressStatuses: progressStatuses } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    // find the inProgress and unassigned statuses
    const inProgressStatus = progressStatuses.find((status)=>status.underlyingStatus === (0, $8f7fe33a44836803$export$f493388d2527ca1f).InProgress);
    const unassignedStatus = progressStatuses.find((status)=>status.underlyingStatus === (0, $8f7fe33a44836803$export$f493388d2527ca1f).Unassigned);
    const [updateTaxYearInterviewMutation, { loading: loading }] = (0, $33beb5b1bfae180c$export$5ef9f018471fce4)({
        onCompleted: ()=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Changes saved successfully'),
        onError: (error)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.name),
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$d4e23f314f782a9d),
                variables: {
                    progressStatusId: inProgressStatus.id
                }
            },
            {
                query: (0, $732264f53056e08f$export$d4e23f314f782a9d),
                variables: {
                    progressStatusId: unassignedStatus.id
                }
            }
        ],
        awaitRefetchQueries: true
    });
    return (0, $bb3TF.jsx)("div", {
        children: (0, $bb3TF.jsxs)((0, $92b07c154bbb4d14$export$2e2bcd8739ae039), {
            tooltip: "Start Job",
            confirmAction: true,
            confirmLabel: "Are you sure?",
            buttonProps: {
                type: 'primary'
            },
            loading: loading,
            onClick: ()=>updateTaxYearInterviewMutation({
                    variables: {
                        updateTaxYearInterviewInput: {
                            id: taxYearInterviewId,
                            progressStatusId: inProgressStatus.id
                        }
                    }
                }),
            children: [
                (0, $bb3TF.jsx)($a4248ac38bbe43ba$var$RightOutlined, {}),
                "Start"
            ]
        })
    });
};
const $a4248ac38bbe43ba$var$getUnassignedColumns = (userRole, progressStatusId)=>{
    const savedSort = JSON.parse(localStorage.getItem(`${progressStatusId}SortOrder`));
    return [
        {
            title: 'First Name',
            dataIndex: '',
            key: 'firstName',
            sorter: true,
            defaultSortOrder: $a4248ac38bbe43ba$var$convertShortFormSortOrderToLongForm(savedSort?.TaxYear?.Entity?.Users?.UserInformation?.firstName),
            // sortOrder: sortedInfo.columnKey === "name" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: ({ email: email, phone: phone, userId: userId, entityId: entityId, firstName: firstName, workNumber: workNumber, languageId: languageId, landlineNumber: landlineNumber, userInformationId: userInformationId, taxYearInterviewId: taxYearInterviewId })=>(0, $bb3TF.jsx)((0, $726657375c530783$export$2e2bcd8739ae039), {
                    email: email,
                    userId: userId,
                    entityId: entityId,
                    phone: phone?.value,
                    name: firstName,
                    languageId: languageId,
                    workNumber: workNumber?.value,
                    userInformationId: userInformationId,
                    landlineNumber: landlineNumber?.value,
                    taxYearInterviewId: taxYearInterviewId
                }),
            // fixed: screens.sm ? 'left' : false,
            width: 126,
            className: 'column-name-overflow-hidden'
        },
        {
            title: 'Last Name',
            dataIndex: '',
            key: 'lastName',
            sorter: true,
            defaultSortOrder: $a4248ac38bbe43ba$var$convertShortFormSortOrderToLongForm(savedSort?.TaxYear?.Entity?.Users?.UserInformation?.lastName),
            // sortOrder: sortedInfo.columnKey === "name" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: ({ email: email, phone: phone, userId: userId, lastName: lastName, entityId: entityId, workNumber: workNumber, languageId: languageId, landlineNumber: landlineNumber, userInformationId: userInformationId, taxYearInterviewId: taxYearInterviewId })=>(0, $bb3TF.jsx)((0, $726657375c530783$export$2e2bcd8739ae039), {
                    email: email,
                    userId: userId,
                    name: lastName,
                    entityId: entityId,
                    phone: phone?.value,
                    languageId: languageId,
                    workNumber: workNumber?.value,
                    userInformationId: userInformationId,
                    landlineNumber: landlineNumber?.value,
                    taxYearInterviewId: taxYearInterviewId
                }),
            // fixed: screens.sm ? 'left' : false,
            width: 126,
            className: 'column-name-overflow-hidden'
        },
        {
            title: 'Email',
            dataIndex: 'email',
            sorter: true,
            defaultSortOrder: $a4248ac38bbe43ba$var$convertShortFormSortOrderToLongForm(savedSort?.TaxYear?.Entity?.Users?.email),
            // sortOrder: sortedInfo.columnKey === "email" && sortedInfo.order,
            key: 'email',
            width: 200
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            sorter: false,
            // sortOrder: sortedInfo.columnKey === "email" && sortedInfo.order,
            render: (record)=>(0, $bb3TF.jsx)("span", {
                    children: record?.value && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                        children: [
                            (0, $d637e76af0848ec5$export$2e2bcd8739ae039)(record),
                            ' ',
                            record?.value ?? ''
                        ]
                    })
                }),
            key: 'phone',
            width: 200
        },
        {
            title: 'Tax Year',
            dataIndex: 'taxYear',
            sorter: true,
            defaultSortOrder: $a4248ac38bbe43ba$var$convertShortFormSortOrderToLongForm(savedSort?.TaxYear?.year),
            // sortOrder: sortedInfo.columnKey === "taxYear" && sortedInfo.order,
            key: 'taxYear',
            width: 85
        },
        {
            title: 'Job Type',
            dataIndex: 'jobType',
            sorter: true,
            defaultSortOrder: $a4248ac38bbe43ba$var$convertShortFormSortOrderToLongForm(savedSort?.Interviews?.name),
            // sortOrder: sortedInfo.columnKey === "jobType" && sortedInfo.order,
            key: 'jobType',
            width: 140
        },
        {
            title: 'Time in Queue',
            dataIndex: 'timeInQueue',
            sorter: true,
            defaultSortOrder: $a4248ac38bbe43ba$var$convertShortFormSortOrderToLongForm(savedSort?.createAt),
            // sortOrder: sortedInfo.columnKey === "inProgressTime" && sortedInfo.order,
            key: 'timeInQueue',
            render: (text)=>(0, $5bafd68f69b44f55$export$d784918a83e8de76)(text),
            renderText: (text)=>(0, $5bafd68f69b44f55$export$d784918a83e8de76)(text),
            width: 115
        },
        {
            title: (0, $bb3TF.jsx)($a4248ac38bbe43ba$var$FileOutlined, {
                title: "Documents",
                className: "column-icon"
            }),
            label: 'Documents',
            key: 'files',
            sorter: true,
            defaultSortOrder: $a4248ac38bbe43ba$var$convertShortFormSortOrderToLongForm(savedSort?.JobTracking?.filesCompletedAt),
            // sortOrder: sortedInfo.columnKey === "files" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: (text, record)=>(0, $bb3TF.jsx)((0, $e39c35e1ca5a0e9e$export$2e2bcd8739ae039), {
                    record: record
                }),
            renderText: (docStatus)=>{
                if (!docStatus) return 'Documents not found';
                return null;
            },
            width: 55
        },
        {
            title: ()=>(0, $bb3TF.jsx)($a4248ac38bbe43ba$var$MailOutlined, {
                    title: "Activation Sent",
                    className: "column-icon"
                }),
            label: 'Envelop',
            dataIndex: 'invitationEmailSent',
            key: 'invitationEmailSent',
            sorter: false,
            // sortOrder: sortedInfo.columnKey === "invitationEmailSent" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: (text, record)=>(0, $bb3TF.jsx)((0, $feec7e745fbd67e1$export$2e2bcd8739ae039), {
                    invitationEmailSent: text,
                    password: record?.password
                }),
            width: 55
        },
        {
            title: (0, $bb3TF.jsx)($a4248ac38bbe43ba$var$FormOutlined, {
                title: "Notes",
                className: "column-icon"
            }),
            label: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
            sorter: false,
            // sortOrder: sortedInfo.columnKey === "comments" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: (text, record)=>(0, $bb3TF.jsx)((0, $ef0c8dde88639a9c$export$2e2bcd8739ae039), {
                    record: record
                }),
            renderText: (comments)=>{
                if (!comments) return 'Notes not found';
                return (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(new Date(comments.createdAt)).format();
            },
            width: 55
        },
        {
            title: (0, $bb3TF.jsx)($a4248ac38bbe43ba$var$DollarOutlined, {
                title: "Client Payment Received",
                className: "column-icon"
            }),
            label: 'Client Payment Status',
            dataIndex: '',
            key: 'clientInvoice',
            sorter: false,
            // sortOrder: sortedInfo.columnKey === "clientInvoice" && sortedInfo.order,
            render: (record)=>(0, $bb3TF.jsx)((0, $0c6014fe769fedd1$export$2e2bcd8739ae039), {
                    record: record
                }),
            // renderText: (data, row) => statusIndicators(row.taxYearStatus.clientInvoice, row, true),
            width: 55
        },
        {
            title: 'Referred By',
            dataIndex: 'referredBy',
            sorter: false,
            // sortOrder: sortedInfo.columnKey === "referredBy" && sortedInfo.order,
            key: 'referredBy',
            width: 150
        },
        {
            title: 'Preparer',
            dataIndex: '',
            align: 'center',
            sorter: true,
            defaultSortOrder: $a4248ac38bbe43ba$var$convertShortFormSortOrderToLongForm(savedSort?.PreparedUser?.UserInformation?.firstName),
            key: 'currentPreparer',
            // sortOrder: sortedInfo.columnKey === "currentPreparer" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: ({ taxYearInterviewId: taxYearInterviewId, preparedId: preparedId, progressStatusId: progStatusId })=>(0, $bb3TF.jsx)((0, $9d1300c931ed4287$export$2e2bcd8739ae039), {
                    type: "Preparer",
                    taxYearInterviewId: taxYearInterviewId,
                    assignedMemberId: preparedId,
                    progressStatusId: progStatusId,
                    userRole: userRole
                }),
            width: 170
        },
        {
            title: 'Reviewer',
            dataIndex: '',
            align: 'center',
            sorter: true,
            defaultSortOrder: $a4248ac38bbe43ba$var$convertShortFormSortOrderToLongForm(savedSort?.ReviewedUser?.UserInformation?.firstName),
            key: 'currentReviewer',
            // sortOrder: sortedInfo.columnKey === "currentReviewer" && sortedInfo.order,
            render: ({ taxYearInterviewId: taxYearInterviewId, reviewedId: reviewedId, progressStatusId: progStatusId })=>(0, $bb3TF.jsx)((0, $9d1300c931ed4287$export$2e2bcd8739ae039), {
                    type: "Reviewer",
                    taxYearInterviewId: taxYearInterviewId,
                    assignedMemberId: reviewedId,
                    progressStatusId: progStatusId,
                    userRole: userRole
                }),
            width: 170
        },
        // {
        //   title: 'Assign',
        //   dataIndex: '',
        //   align: 'center',
        //   sorter: () => undefined,
        //   key: 'assign',
        //   // sortOrder: sortedInfo.columnKey === "currentReviewer" && sortedInfo.order,
        //   // eslint-disable-next-line react/display-name
        //   render: (record: any) => <AssignButton record={record} />,
        //   width: 170,
        // },
        {
            title: 'Start Job',
            dataIndex: '',
            align: 'center',
            sorter: false,
            key: 'assign',
            // sortOrder: sortedInfo.columnKey === "currentReviewer" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: (record)=>(0, $bb3TF.jsx)($a4248ac38bbe43ba$var$StartButton, {
                    record: record
                }),
            width: 150
        }
    ]; // end columns
};
var $a4248ac38bbe43ba$export$2e2bcd8739ae039 = $a4248ac38bbe43ba$var$getUnassignedColumns;



var $bb3TF = parcelRequire("bb3TF");


var $6Sgv0 = parcelRequire("6Sgv0");











const { MailOutlined: $56a2df109dff1160$var$MailOutlined, FileOutlined: $56a2df109dff1160$var$FileOutlined, FormOutlined: $56a2df109dff1160$var$FormOutlined, QuestionCircleOutlined: $56a2df109dff1160$var$QuestionCircleOutlined, DollarOutlined: $56a2df109dff1160$var$DollarOutlined, LikeOutlined: $56a2df109dff1160$var$LikeOutlined, CheckOutlined: $56a2df109dff1160$var$CheckOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $56a2df109dff1160$var$convertShortFormSortOrderToLongForm = (sortOrder)=>{
    if (sortOrder === 'asc') return 'ascend';
    if (sortOrder === 'desc') return 'descend';
    return null;
};
const $56a2df109dff1160$var$getCompletedColumns = (userRole, progressStatusId)=>{
    const savedSort = JSON.parse(localStorage.getItem(`${progressStatusId}SortOrder`));
    return [
        {
            title: 'First Name',
            dataIndex: '',
            key: 'firstName',
            sorter: true,
            defaultSortOrder: $56a2df109dff1160$var$convertShortFormSortOrderToLongForm(savedSort?.TaxYear?.Entity?.Users?.UserInformation?.firstName),
            // sortOrder: sortedInfo.columnKey === "name" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: ({ email: email, phone: phone, userId: userId, entityId: entityId, firstName: firstName, languageId: languageId, workNumber: workNumber, landlineNumber: landlineNumber, userInformationId: userInformationId, taxYearInterviewId: taxYearInterviewId })=>(0, $bb3TF.jsx)((0, $726657375c530783$export$2e2bcd8739ae039), {
                    email: email,
                    userId: userId,
                    entityId: entityId,
                    phone: phone?.value,
                    name: firstName,
                    languageId: languageId,
                    workNumber: workNumber?.value,
                    userInformationId: userInformationId,
                    landlineNumber: landlineNumber?.value,
                    taxYearInterviewId: taxYearInterviewId
                }),
            // fixed: screens.sm ? 'left' : false,
            width: 126,
            className: 'column-name-overflow-hidden'
        },
        {
            title: 'Last Name',
            dataIndex: '',
            key: 'lastName',
            sorter: true,
            defaultSortOrder: $56a2df109dff1160$var$convertShortFormSortOrderToLongForm(savedSort?.TaxYear?.Entity?.Users?.UserInformation?.lastName),
            // sortOrder: sortedInfo.columnKey === "name" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: ({ email: email, phone: phone, userId: userId, entityId: entityId, lastName: lastName, languageId: languageId, workNumber: workNumber, landlineNumber: landlineNumber, userInformationId: userInformationId, taxYearInterviewId: taxYearInterviewId })=>(0, $bb3TF.jsx)((0, $726657375c530783$export$2e2bcd8739ae039), {
                    email: email,
                    userId: userId,
                    entityId: entityId,
                    phone: phone?.value,
                    name: lastName,
                    languageId: languageId,
                    workNumber: workNumber?.value,
                    userInformationId: userInformationId,
                    landlineNumber: landlineNumber?.value,
                    taxYearInterviewId: taxYearInterviewId
                }),
            // fixed: screens.sm ? 'left' : false,
            width: 126,
            className: 'column-name-overflow-hidden'
        },
        {
            title: 'Email',
            dataIndex: 'email',
            sorter: true,
            defaultSortOrder: $56a2df109dff1160$var$convertShortFormSortOrderToLongForm(savedSort?.TaxYear?.Entity?.Users?.email),
            // sortOrder: sortedInfo.columnKey === "email" && sortedInfo.order,
            key: 'email',
            width: 200
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            sorter: false,
            // sortOrder: sortedInfo.columnKey === "email" && sortedInfo.order,
            render: (record)=>(0, $bb3TF.jsx)("span", {
                    children: record?.value && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                        children: [
                            (0, $d637e76af0848ec5$export$2e2bcd8739ae039)(record),
                            ' ',
                            record?.value ?? ''
                        ]
                    })
                }),
            key: 'phone',
            width: 200
        },
        {
            title: 'Tax Year',
            dataIndex: 'taxYear',
            sorter: true,
            defaultSortOrder: $56a2df109dff1160$var$convertShortFormSortOrderToLongForm(savedSort?.TaxYear?.year),
            // sortOrder: sortedInfo.columnKey === "taxYear" && sortedInfo.order,
            key: 'taxYear',
            width: 85
        },
        {
            title: 'Job Type',
            dataIndex: 'jobType',
            sorter: true,
            defaultSortOrder: $56a2df109dff1160$var$convertShortFormSortOrderToLongForm(savedSort?.Interviews?.name),
            // sortOrder: sortedInfo.columnKey === "jobType" && sortedInfo.order,
            key: 'jobType',
            width: 140
        },
        {
            title: 'Completed Date',
            dataIndex: 'completedDate',
            sorter: true,
            defaultSortOrder: $56a2df109dff1160$var$convertShortFormSortOrderToLongForm(savedSort?.completedAt),
            // sortOrder: sortedInfo.columnKey === "inProgressTime" && sortedInfo.order,
            key: 'completedDate',
            render: (text)=>(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(new Date(text)).format('MM/DD/YYYY'),
            renderText: (text)=>(0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(new Date(text)).format('MM/DD/YYYY'),
            width: 130
        },
        {
            title: (0, $bb3TF.jsx)($56a2df109dff1160$var$FileOutlined, {
                title: "Documents",
                className: "column-icon"
            }),
            label: 'Documents',
            key: 'files',
            sorter: true,
            defaultSortOrder: $56a2df109dff1160$var$convertShortFormSortOrderToLongForm(savedSort?.JobTracking?.filesCompletedAt),
            // sortOrder: sortedInfo.columnKey === "files" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: (text, record)=>(0, $bb3TF.jsx)((0, $e39c35e1ca5a0e9e$export$2e2bcd8739ae039), {
                    record: record
                }),
            renderText: (docStatus)=>{
                if (!docStatus) return 'Documents not found';
                return null;
            },
            width: 55
        },
        {
            title: (0, $bb3TF.jsx)($56a2df109dff1160$var$QuestionCircleOutlined, {
                title: "Client Interview Status",
                className: "column-icon"
            }),
            label: 'Client Interview Status',
            dataIndex: '',
            key: 'clientInterview',
            sorter: true,
            defaultSortOrder: $56a2df109dff1160$var$convertShortFormSortOrderToLongForm(savedSort?.JobTracking?.interviewCompletedAt),
            // sortOrder: sortedInfo.columnKey === "clientInterview" && sortedInfo.order,
            render: (text, record)=>(0, $bb3TF.jsx)((0, $bcfed50df82b3605$export$2e2bcd8739ae039), {
                    record: record
                }),
            // renderText: (data, row) => statusIndicators(row.taxYearStatus.clientInterview, row, true),
            width: 55
        },
        {
            title: (0, $bb3TF.jsx)($56a2df109dff1160$var$LikeOutlined, {
                title: "Review Status",
                className: "column-icon"
            }),
            label: 'Review Status',
            dataIndex: 'reviewStatus',
            key: 'reviewStatus',
            sorter: true,
            defaultSortOrder: $56a2df109dff1160$var$convertShortFormSortOrderToLongForm(savedSort?.reviewStatus),
            // sortOrder: sortedInfo.columnKey === "reviewStatus" && sortedInfo.order,
            render: (text, record)=>(0, $bb3TF.jsx)((0, $e90d760a1801a805$export$2e2bcd8739ae039), {
                    reviewStatus: text
                }),
            // renderText: (data, row) => RenderInternalReviewStatus(data, row, true),
            width: 55
        },
        {
            title: (0, $bb3TF.jsx)($56a2df109dff1160$var$CheckOutlined, {
                title: "Client E-File Approval",
                className: "column-icon"
            }),
            label: 'Client Document Approval Status',
            dataIndex: '',
            key: 'clientCopyUploaded',
            sorter: true,
            defaultSortOrder: $56a2df109dff1160$var$convertShortFormSortOrderToLongForm(savedSort?.JobTracking?.approvalsCompletedAt),
            // sortOrder: sortedInfo.columnKey === "clientCopyUploaded" && sortedInfo.order,
            render: (text, record)=>(0, $bb3TF.jsx)((0, $91def2f8fe3a5918$export$2e2bcd8739ae039), {
                    record: record
                }),
            // renderText: (data, row) => statusIndicators(row.taxYearStatus.eFileAuth, row, true),
            width: 55
        },
        {
            title: ()=>(0, $bb3TF.jsx)($56a2df109dff1160$var$MailOutlined, {
                    title: "Activation Sent",
                    className: "column-icon"
                }),
            label: 'Envelop',
            dataIndex: 'invitationEmailSent',
            key: 'invitationEmailSent',
            sorter: false,
            // sortOrder: sortedInfo.columnKey === "invitationEmailSent" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: (text, record)=>(0, $bb3TF.jsx)((0, $feec7e745fbd67e1$export$2e2bcd8739ae039), {
                    invitationEmailSent: text,
                    password: record?.password
                }),
            width: 55
        },
        {
            title: (0, $bb3TF.jsx)($56a2df109dff1160$var$FormOutlined, {
                title: "Notes",
                className: "column-icon"
            }),
            label: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
            sorter: false,
            // sortOrder: sortedInfo.columnKey === "comments" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: (text, record)=>(0, $bb3TF.jsx)((0, $ef0c8dde88639a9c$export$2e2bcd8739ae039), {
                    record: record
                }),
            renderText: (comments)=>{
                if (!comments) return 'Notes not found';
                return (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(new Date(comments.createdAt)).format();
            },
            width: 55
        },
        {
            title: (0, $bb3TF.jsx)($56a2df109dff1160$var$DollarOutlined, {
                title: "Client Payment Received",
                className: "column-icon"
            }),
            label: 'Client Payment Status',
            dataIndex: '',
            key: 'clientInvoice',
            sorter: false,
            // sortOrder: sortedInfo.columnKey === "clientInvoice" && sortedInfo.order,
            render: (record)=>(0, $bb3TF.jsx)((0, $0c6014fe769fedd1$export$2e2bcd8739ae039), {
                    record: record
                }),
            // renderText: (data, row) => statusIndicators(row.taxYearStatus.clientInvoice, row, true),
            width: 55
        },
        {
            title: 'Referred By',
            dataIndex: 'referredBy',
            sorter: false,
            // sortOrder: sortedInfo.columnKey === "referredBy" && sortedInfo.order,
            key: 'referredBy',
            width: 150
        },
        {
            title: 'Preparer',
            dataIndex: '',
            align: 'center',
            sorter: true,
            defaultSortOrder: $56a2df109dff1160$var$convertShortFormSortOrderToLongForm(savedSort?.PreparedUser?.UserInformation?.firstName),
            key: 'currentPreparer',
            // sortOrder: sortedInfo.columnKey === "currentPreparer" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: ({ taxYearInterviewId: taxYearInterviewId, preparedId: preparedId, progressStatusId: progStatusId })=>(0, $bb3TF.jsx)((0, $9d1300c931ed4287$export$2e2bcd8739ae039), {
                    type: "Preparer",
                    taxYearInterviewId: taxYearInterviewId,
                    assignedMemberId: preparedId,
                    progressStatusId: progStatusId,
                    userRole: userRole
                }),
            width: 170
        },
        {
            title: 'Reviewer',
            dataIndex: '',
            align: 'center',
            sorter: true,
            defaultSortOrder: $56a2df109dff1160$var$convertShortFormSortOrderToLongForm(savedSort?.ReviewedUser?.UserInformation?.firstName),
            key: 'currentReviewer',
            // sortOrder: sortedInfo.columnKey === "currentReviewer" && sortedInfo.order,
            // eslint-disable-next-line react/display-name
            render: ({ taxYearInterviewId: taxYearInterviewId, reviewedId: reviewedId, progressStatusId: progStatusId })=>(0, $bb3TF.jsx)((0, $9d1300c931ed4287$export$2e2bcd8739ae039), {
                    type: "Reviewer",
                    taxYearInterviewId: taxYearInterviewId,
                    assignedMemberId: reviewedId,
                    progressStatusId: progStatusId,
                    userRole: userRole
                }),
            width: 170
        }
    ];
};
var $56a2df109dff1160$export$2e2bcd8739ae039 = $56a2df109dff1160$var$getCompletedColumns;





var $bb3TF = parcelRequire("bb3TF");


var $6Sgv0 = parcelRequire("6Sgv0");








const { MailOutlined: $3279029e4f4e60fb$var$MailOutlined, FileOutlined: $3279029e4f4e60fb$var$FileOutlined, FormOutlined: $3279029e4f4e60fb$var$FormOutlined, DollarOutlined: $3279029e4f4e60fb$var$DollarOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $3279029e4f4e60fb$export$215ab238c5faf973 = (a, b, prop)=>{
    if (!a[prop]) return -1;
    if (!b[prop]) return 1;
    if (a[prop] > b[prop]) return 1;
    if (a[prop] < b[prop]) return -1;
    return 0;
};
const $3279029e4f4e60fb$export$d43db1b9b18842f = (a, b)=>{
    if (`${a.firstName} ${a.lastName}` > `${b.firstName} ${b.lastName}`) return 1;
    if (`${a.firstName} ${a.lastName}` < `${b.firstName} ${b.lastName}`) return -1;
    return 0;
};
const $3279029e4f4e60fb$export$318284a2ebe23308 = (a, b)=>{
    if (a.phone?.value || b.phone?.value < '' || '') return 1;
    if (a.phone?.value || b.phone?.value > '' || '') return -1;
    return 0;
};
const $3279029e4f4e60fb$export$f0d3124df0fd8647 = (a, b)=>{
    if (a.tasks?.find((task)=>task.taskType === 'DOCUMENTS')?.completedAt || b.tasks?.find((task)=>task.taskType === 'DOCUMENTS')?.completedAt < '' || '') return 1;
    if (a.tasks?.find((task)=>task.taskType === 'DOCUMENTS')?.completedAt || b.tasks?.find((task)=>task.taskType === 'DOCUMENTS')?.completedAt > '' || '') return -1;
    return 0;
};
const $3279029e4f4e60fb$var$convertShortFormSortOrderToLongForm = (sortOrder)=>{
    if (sortOrder === 'asc') return 'ascend';
    if (sortOrder === 'desc') return 'descend';
    return null;
};
const $3279029e4f4e60fb$var$getClientList = (userRole)=>{
    const savedSort = JSON.parse(localStorage.getItem('clientsListSortOrder'));
    return [
        {
            key: 'firstName',
            title: 'First Name',
            dataIndex: '',
            sorter: true,
            defaultSortOrder: $3279029e4f4e60fb$var$convertShortFormSortOrderToLongForm(savedSort?.Entity?.Users?.UserInformation?.firstName),
            render: ({ phone: phone, email: email, userId: userId, entityId: entityId, firstName: firstName, languageId: languageId, workNumber: workNumber, landlineNumber: landlineNumber, userInformationId: userInformationId, taxYearInterviewId: taxYearInterviewId })=>(0, $bb3TF.jsx)((0, $726657375c530783$export$2e2bcd8739ae039), {
                    email: email,
                    userId: userId,
                    entityId: entityId,
                    name: firstName,
                    phone: phone?.value,
                    languageId: languageId,
                    workNumber: workNumber?.value,
                    userInformationId: userInformationId,
                    landlineNumber: landlineNumber?.value,
                    taxYearInterviewId: taxYearInterviewId,
                    allTaxYearInterview: true
                }),
            width: 126,
            className: 'column-name-overflow-hidden'
        },
        {
            key: 'lastName',
            title: 'Last Name',
            dataIndex: '',
            sorter: true,
            defaultSortOrder: $3279029e4f4e60fb$var$convertShortFormSortOrderToLongForm(savedSort?.Entity?.Users?.UserInformation?.lastName),
            render: ({ phone: phone, email: email, userId: userId, entityId: entityId, lastName: lastName, languageId: languageId, workNumber: workNumber, landlineNumber: landlineNumber, userInformationId: userInformationId, taxYearInterviewId: taxYearInterviewId })=>(0, $bb3TF.jsx)((0, $726657375c530783$export$2e2bcd8739ae039), {
                    email: email,
                    userId: userId,
                    entityId: entityId,
                    name: lastName,
                    phone: phone?.value,
                    languageId: languageId,
                    workNumber: workNumber?.value,
                    userInformationId: userInformationId,
                    landlineNumber: landlineNumber?.value,
                    taxYearInterviewId: taxYearInterviewId,
                    allTaxYearInterview: true
                }),
            width: 126,
            className: 'column-name-overflow-hidden'
        },
        {
            title: 'Email',
            dataIndex: 'email',
            sorter: true,
            defaultSortOrder: $3279029e4f4e60fb$var$convertShortFormSortOrderToLongForm(savedSort?.Entity?.Users?.email),
            key: 'email',
            width: 200
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            sorter: false,
            render: (record)=>(0, $bb3TF.jsx)("span", {
                    children: record?.value && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                        children: [
                            (0, $d637e76af0848ec5$export$2e2bcd8739ae039)(record),
                            ' ',
                            record?.value ?? ''
                        ]
                    })
                }),
            key: 'phone',
            width: 200
        },
        {
            title: 'Recent Tax Year',
            dataIndex: 'taxYear',
            sorter: false,
            key: 'taxYear',
            width: 115
        },
        {
            title: 'Job Type',
            dataIndex: 'jobType',
            sorter: false,
            key: 'jobType',
            width: 140
        },
        {
            title: ()=>(0, $bb3TF.jsx)($3279029e4f4e60fb$var$MailOutlined, {
                    title: "Activation Sent",
                    className: "column-icon"
                }),
            label: 'Envelop',
            dataIndex: 'invitationEmailSent',
            key: 'invitationEmailSent',
            sorter: false,
            // eslint-disable-next-line react/display-name
            render: (text, record)=>(0, $bb3TF.jsx)((0, $feec7e745fbd67e1$export$2e2bcd8739ae039), {
                    invitationEmailSent: text,
                    password: record?.password
                }),
            width: 55
        },
        {
            title: (0, $bb3TF.jsx)($3279029e4f4e60fb$var$FileOutlined, {
                title: "Documents",
                className: "column-icon"
            }),
            label: 'Documents',
            key: 'files',
            sorter: false,
            // eslint-disable-next-line react/display-name
            render: (text, record)=>(0, $bb3TF.jsx)((0, $e39c35e1ca5a0e9e$export$2e2bcd8739ae039), {
                    record: record
                }),
            renderText: (docStatus)=>{
                if (!docStatus) return 'Documents not found';
                return null;
            },
            width: 55
        },
        {
            title: (0, $bb3TF.jsx)($3279029e4f4e60fb$var$FormOutlined, {
                title: "Notes",
                className: "column-icon"
            }),
            label: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
            sorter: false,
            // eslint-disable-next-line react/display-name
            render: (text, record)=>(0, $bb3TF.jsx)((0, $ef0c8dde88639a9c$export$2e2bcd8739ae039), {
                    record: record
                }),
            renderText: (comments)=>{
                if (!comments) return 'Notes not found';
                return (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(new Date(comments.createdAt)).format();
            },
            width: 55
        },
        {
            title: (0, $bb3TF.jsx)($3279029e4f4e60fb$var$DollarOutlined, {
                title: "Client Payment Received",
                className: "column-icon"
            }),
            label: 'Client Payment Status',
            dataIndex: '',
            key: 'clientInvoice',
            sorter: false,
            render: (record)=>(0, $bb3TF.jsx)((0, $0c6014fe769fedd1$export$2e2bcd8739ae039), {
                    record: record
                }),
            // renderText: (data, row) => statusIndicators(row.taxYearStatus.clientInvoice, row, true),
            width: 55
        },
        {
            title: 'Referred By',
            dataIndex: 'referredBy',
            sorter: false,
            key: 'referredBy',
            width: 150
        },
        {
            title: 'Preparer',
            dataIndex: '',
            align: 'center',
            sorter: false,
            key: 'currentPreparer',
            // eslint-disable-next-line react/display-name
            render: ({ taxYearInterviewId: taxYearInterviewId, preparedId: preparedId, progressStatusId: progressStatusId })=>taxYearInterviewId ? (0, $bb3TF.jsx)((0, $9d1300c931ed4287$export$2e2bcd8739ae039), {
                    type: "Preparer",
                    taxYearInterviewId: taxYearInterviewId,
                    assignedMemberId: preparedId,
                    progressStatusId: progressStatusId,
                    userRole: userRole
                }) : null,
            width: 170
        },
        {
            title: 'Reviewer',
            dataIndex: '',
            align: 'center',
            sorter: false,
            key: 'currentReviewer',
            // eslint-disable-next-line react/display-name
            render: ({ taxYearInterviewId: taxYearInterviewId, reviewedId: reviewedId, progressStatusId: progressStatusId })=>taxYearInterviewId ? (0, $bb3TF.jsx)((0, $9d1300c931ed4287$export$2e2bcd8739ae039), {
                    type: "Reviewer",
                    taxYearInterviewId: taxYearInterviewId,
                    assignedMemberId: reviewedId,
                    progressStatusId: progressStatusId,
                    userRole: userRole
                }) : null,
            width: 170
        }
    ];
};
var $3279029e4f4e60fb$export$2e2bcd8739ae039 = $3279029e4f4e60fb$var$getClientList;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");








const $6da8d7e0b3c816ba$var$ClientsTable = ({ setProgressStatusDnDConfirmModalVisible: setProgressStatusDnDConfirmModalVisible, setDndData: setDndData, columns: columns, loadingProp: loadingProp, setClientsCount: setClientsCount })=>{
    const sortedInfo = {
        order: 'ascend',
        columnKey: 'clientInterview'
    };
    const [selectedKeys, setSelectedKeys] = (0, $6fFrj.useState)([]);
    const [selectedRows, setSelectedRows] = (0, $6fFrj.useState)([]);
    const [displayClearbutton, setDisplayClearButton] = (0, $6fFrj.useState)(false);
    const [pageSize, setPageSize] = (0, $6fFrj.useState)(25);
    const [currentPage, setCurrentPage] = (0, $6fFrj.useState)(1);
    const [searchedValue, setSearchedValue] = (0, $6fFrj.useState)('');
    const [filters, setFilters] = (0, $6fFrj.useState)({
        filterType: 'AND'
    });
    const [sortObject, setSortObject] = (0, $6fFrj.useState)(()=>{
        // Check if there is a sort order saved in localStorage
        const savedSort = localStorage.getItem('clientsListSortOrder');
        return savedSort ? JSON.parse(savedSort) : {
            updateAt: 'desc'
        };
    });
    const tableDivRef = (0, $6fFrj.useRef)(null);
    const searchRef = (0, $6fFrj.useRef)(null);
    const { data: clientsDataWithPagination, loading: loadingClients } = (0, $732264f53056e08f$export$a7142e44db2eb9b2)({
        variables: {
            skip: (currentPage - 1) * pageSize,
            take: pageSize,
            searchTerm: searchedValue,
            orderBy: sortObject,
            filter: filters
        },
        fetchPolicy: 'cache-and-network',
        onCompleted: (data)=>{
            if (searchedValue.length > 0) {
                if (data.Clients.data.length === 0) {
                    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('No results found');
                    searchRef.current?.focus();
                }
                setDisplayClearButton(true);
            } else setDisplayClearButton(false);
            setClientsCount(data.Clients?.pagination?.total);
        },
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
            // reset local storage sort order to default
            setSortObject({
                updateAt: 'desc'
            });
            localStorage.setItem('clientsListSortOrder', JSON.stringify({
                updateAt: 'desc'
            }));
        }
    });
    const { data: clientsData, pagination: pagination } = clientsDataWithPagination?.Clients || {};
    const components = {
        body: {
            row: (0, $259896312063de80$export$2e2bcd8739ae039)
        }
    };
    // kyle todo: is this a duplicate?
    const progressStatusOnChange = (record, dropResult)=>{
        setDndData({
            record: record,
            dropResult: dropResult
        });
        setProgressStatusDnDConfirmModalVisible(true);
    };
    const rowSelection = {
        onChange: (selectedRowKeys, row)=>{
            setSelectedKeys(selectedRowKeys);
            setSelectedRows(row);
        }
    };
    const moveRow = (0, $6fFrj.useCallback)((record, notSure, dropResult)=>{
        progressStatusOnChange(record, dropResult);
    }, []);
    const handleTableChange = (paginationInfo, inputFilters, sorter)=>{
        const orderByColumn = sorter.columnKey;
        const orderDirection = sorter.order === 'ascend' ? 'asc' : 'desc';
        let newSort = {
            updateAt: 'desc'
        };
        switch(orderByColumn){
            case 'firstName':
                newSort = {
                    Entity: {
                        Users: {
                            UserInformation: {
                                firstName: orderDirection
                            }
                        }
                    }
                };
                break;
            case 'lastName':
                newSort = {
                    Entity: {
                        Users: {
                            UserInformation: {
                                lastName: orderDirection
                            }
                        }
                    }
                };
                break;
            case 'email':
                newSort = {
                    Entity: {
                        Users: {
                            email: orderDirection
                        }
                    }
                };
                break;
            default:
                newSort = {
                    updateAt: 'desc'
                };
                break;
        }
        setSortObject(newSort);
        localStorage.setItem('clientsListSortOrder', JSON.stringify(newSort));
    };
    // ! assignment to property of function parameter 'columns'
    // columns[0].fixed = screens.sm ? 'left' : false;
    // columns.forEach((item: any) => {
    //   item.sortOrder = sortedInfo.columnKey === 'referredBy' && sortedInfo.order;
    // });
    // eslint-disable-next-line react/no-unstable-nested-components
    function NoClients() {
        const [isAddClientModalVisible, setIsAddClientModalVisible] = (0, $6fFrj.useState)(false);
        return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
            children: [
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "center",
                    style: {
                        marginTop: 25
                    },
                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        type: "primary",
                        shape: "round",
                        onClick: ()=>setIsAddClientModalVisible(true),
                        children: "Add your first client"
                    })
                }),
                (0, $bb3TF.jsx)((0, $2d52d8d286e39b3a$export$2e2bcd8739ae039), {
                    isModalVisible: isAddClientModalVisible,
                    setIsModalVisible: setIsAddClientModalVisible
                })
            ]
        });
    }
    const today = new Date();
    const timeElapsed = (date)=>{
        const prevDate = new Date(date);
        const difference = today.getTime() - prevDate.getTime();
        return difference;
    };
    const clients = clientsData?.map((item)=>{
        const entity = item.Entity;
        const user = entity.Users;
        const userInfo = user.UserInformation;
        const taxYear = item.Entity.TaxYear[0];
        const taxYearInterview = taxYear?.TaxYearInterview[0];
        const interview = taxYearInterview?.Interviews;
        const jobTracking = taxYearInterview?.JobTracking;
        const preparedUser = taxYearInterview?.PreparedUser;
        const preparedUserInfo = preparedUser?.UserInformation;
        const preparedName = preparedUserInfo ? `${preparedUserInfo.firstName} ${preparedUserInfo.lastName}` : undefined;
        const reviewedUser = taxYearInterview?.ReviewedUser;
        const reviewedUserInfo = reviewedUser?.UserInformation;
        const reviewedName = reviewedUserInfo ? `${reviewedUserInfo.firstName} ${reviewedUserInfo.lastName}` : undefined;
        return {
            lastName: userInfo.lastName,
            firstName: userInfo.firstName,
            taxYear: taxYear?.year,
            taxYearId: taxYear?.id,
            assignedAt: taxYearInterview?.assignedAt,
            taxYearInterviewId: taxYearInterview?.id,
            entityId: entity.id,
            name: `${userInfo.firstName} ${userInfo.lastName}`,
            email: user.email,
            phone: (0, $c1ea95f1cc108fcb$export$2e2bcd8739ae039)(userInfo.Phones),
            jobType: interview?.name,
            invitationEmailSent: user.invitationEmailSent,
            password: user.hasPassword,
            userId: user.id,
            referredBy: (0, $a4f6f7c5f30e5097$export$2e2bcd8739ae039).getUserName(user?.ReferredByUser),
            languageId: user?.languageId,
            userInformationId: userInfo?.id,
            progressStatusId: taxYearInterview?.progressStatusId,
            preparedId: preparedUser?.id,
            preparedName: preparedName,
            reviewedId: reviewedUser?.id,
            reviewedName: reviewedName,
            completedDate: taxYearInterview?.completedAt,
            timeInQueue: timeElapsed(taxYearInterview?.createAt),
            expectedCompletion: jobTracking?.expectedCompletion,
            paymentsCompletedAt: jobTracking?.paymentsCompletedAt,
            approvalsCompletedAt: jobTracking?.approvalsCompletedAt,
            interviewCompletedAt: jobTracking?.interviewCompletedAt,
            filesCompletedAt: jobTracking?.filesCompletedAt,
            tasks: taxYearInterview?.Tasks,
            notes: userInfo?.notes,
            reviewStatus: taxYearInterview?.reviewStatus
        };
    });
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $e3c84263568120dd$export$2e2bcd8739ae039), {
                selectedRows: selectedRows,
                setSelectedRows: setSelectedRows,
                setSelectedKeys: setSelectedKeys,
                tableData: clients,
                tableRef: tableDivRef,
                type: "clients",
                displayClearbutton: displayClearbutton,
                pageSize: pageSize,
                setPageSize: setPageSize,
                setSearchedValue: setSearchedValue,
                searchRef: searchRef,
                loading: loadingClients || loadingProp,
                setFilters: setFilters
            }),
            (0, $bb3TF.jsx)("div", {
                style: {
                    height: '15px'
                }
            }),
            (0, $bb3TF.jsx)("div", {
                className: "tableDivRef",
                ref: tableDivRef,
                children: (0, $bb3TF.jsx)((0, $2eb2b7b37988b8f9$export$2e2bcd8739ae039), {
                    loading: loadingClients || loadingProp,
                    sticky: {
                        offsetHeader: 45
                    },
                    tableLayout: "fixed",
                    rowSelection: {
                        type: 'checkbox',
                        fixed: true,
                        columnWidth: 35,
                        selectedRowKeys: selectedKeys,
                        ...rowSelection
                    },
                    // scroll={{ x: 1000, y: 'calc(100vh - 200px)' }}
                    scroll: {
                        x: 1000
                    },
                    showSorterTooltip: false,
                    components: components,
                    onRow: (record, rowIndex)=>({
                            // eslint-disable-next-line @typescript-eslint/no-empty-function
                            onClick: (event)=>{},
                            moveRow: (event, p)=>{
                                moveRow(record, event, p);
                            }
                        }),
                    columns: columns,
                    dataSource: clients,
                    rowKey: (record)=>record.taxYearInterviewId,
                    // onchange={function noRefCheck() {}}
                    pagination: {
                        hideOnSinglePage: true,
                        pageSize: pageSize,
                        total: pagination?.total,
                        current: currentPage,
                        showTotal: (total)=>`Total ${total} clients`,
                        onChange: (page)=>{
                            setCurrentPage(page);
                        },
                        onShowSizeChange: (current, size)=>{
                            setPageSize(size);
                        },
                        pageSizeOptions: [
                            '25',
                            '100',
                            '250',
                            '500'
                        ]
                    },
                    onChange: handleTableChange,
                    noDataProps: {
                        title: 'No clients yet',
                        extra: (0, $bb3TF.jsx)(NoClients, {})
                    }
                })
            })
        ]
    });
};
var $6da8d7e0b3c816ba$export$2e2bcd8739ae039 = $6da8d7e0b3c816ba$var$ClientsTable;



var $bb3TF = parcelRequire("bb3TF");

var $6Sgv0 = parcelRequire("6Sgv0");

var $6fFrj = parcelRequire("6fFrj");





const { UserSwitchOutlined: $5bb696749159213b$var$UserSwitchOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $5bb696749159213b$var$DeletedClientsTable({ loadData: loadData }) {
    const [tableParams, setTableParams] = (0, $6fFrj.useState)({
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: true
        },
        sorter: {}
    });
    const [getDeletedClients, { loading: loading }] = (0, $732264f53056e08f$export$f495b24d594a709e)();
    const [deletedClients, setDeletedClients] = (0, $6fFrj.useState)([]);
    const [recoverDeletedClient, { loading: recoverLoading, data: deletedClientResult }] = (0, $33beb5b1bfae180c$export$59e1ce8f5f054594)();
    const mapDeletedClients = (data)=>data?.map((client)=>{
            const taxYear = client.Entity.TaxYear[0];
            const taxYearInterview = taxYear?.TaxYearInterview[0];
            const interview = taxYearInterview?.Interviews;
            return {
                userFirmAccountId: client.id,
                firstName: client.Entity?.Users?.UserInformation?.firstName,
                lastName: client.Entity?.Users?.UserInformation?.lastName,
                email: client.Entity?.Users?.email,
                phone: (0, $c1ea95f1cc108fcb$export$2e2bcd8739ae039)(client.Entity?.Users?.UserInformation?.Phones),
                taxYear: taxYear?.year,
                jobType: interview?.name,
                deleteAt: (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(client.deleteAt).format('MMM DD, YYYY')
            };
        });
    (0, $6fFrj.useEffect)(()=>{
        if (loadData) getDeletedClients({
            variables: {
                orderBy: tableParams.sorter,
                skip: (tableParams.pagination.current - 1) * tableParams.pagination.pageSize,
                take: tableParams.pagination.pageSize
            },
            onCompleted: (data)=>{
                setDeletedClients(mapDeletedClients(data?.DeletedClients?.data));
                setTableParams((prev)=>({
                        ...prev,
                        pagination: {
                            ...prev.pagination,
                            total: data?.DeletedClients?.pagination?.total
                        }
                    }));
            },
            onError: (error)=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
            }
        });
    }, [
        loadData,
        tableParams.pagination.current,
        tableParams.pagination.pageSize,
        tableParams.sorter
    ]);
    const handleTableChange = (pagination, filters, sorter)=>{
        const orderByColumn = sorter.columnKey;
        const orderDirection = sorter.order === 'ascend' ? 'asc' : 'desc';
        let newSort = {
            updateAt: 'desc'
        };
        switch(orderByColumn){
            case 'firstName':
                newSort = {
                    Entity: {
                        Users: {
                            UserInformation: {
                                firstName: orderDirection
                            }
                        }
                    }
                };
                break;
            case 'lastName':
                newSort = {
                    Entity: {
                        Users: {
                            UserInformation: {
                                lastName: orderDirection
                            }
                        }
                    }
                };
                break;
            case 'email':
                newSort = {
                    Entity: {
                        Users: {
                            email: orderDirection
                        }
                    }
                };
                break;
            case 'deleteAt':
                newSort = {
                    deleteAt: orderDirection
                };
                break;
            default:
                newSort = {
                    updateAt: 'desc'
                };
                break;
        }
        setTableParams({
            pagination: pagination,
            sorter: newSort
        });
    };
    const handleRecoverClient = (record)=>{
        recoverDeletedClient({
            variables: {
                userFirmAccountId: record
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Client recovered successfully');
            },
            onError: (error)=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
            },
            refetchQueries: [
                'GetDeletedClients',
                'GetClients'
            ]
        });
    };
    const columns = [
        {
            title: 'First Name',
            dataIndex: 'firstName',
            key: 'firstName',
            width: 200,
            sorter: true
        },
        {
            title: 'Last Name',
            dataIndex: 'lastName',
            key: 'lastName',
            width: 200,
            sorter: true
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            width: 200,
            sorter: true
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            sorter: false,
            render: (record)=>(0, $bb3TF.jsx)("span", {
                    children: record?.value && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                        children: [
                            (0, $d637e76af0848ec5$export$2e2bcd8739ae039)(record),
                            ' ',
                            record?.value ?? ''
                        ]
                    })
                }),
            key: 'phone',
            width: 200
        },
        {
            title: 'Recent Tax Year',
            dataIndex: 'taxYear',
            sorter: false,
            key: 'taxYear',
            width: 115
        },
        {
            title: 'Deleted At',
            dataIndex: 'deleteAt',
            sorter: true,
            key: 'deleteAt',
            width: 140
        },
        {
            title: 'Recover Client',
            dataIndex: 'userFirmAccountId',
            key: 'userFirmAccountId',
            width: 120,
            align: 'center',
            render: (record)=>(0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    type: "primary",
                    shape: "circle",
                    icon: (0, $bb3TF.jsx)($5bb696749159213b$var$UserSwitchOutlined, {}),
                    onClick: ()=>{
                        handleRecoverClient(record);
                    }
                })
        }
    ];
    return (0, $bb3TF.jsx)((0, $2eb2b7b37988b8f9$export$2e2bcd8739ae039), {
        loading: loading,
        sticky: {
            offsetHeader: 45
        },
        tableLayout: "fixed",
        scroll: {
            x: 1000
        },
        showSorterTooltip: false,
        columns: columns,
        dataSource: deletedClients,
        rowKey: (record)=>record.taxYearInterviewId,
        pagination: tableParams.pagination,
        onChange: handleTableChange,
        noDataProps: {
            title: 'No clients deleted'
        }
    });
}
var $5bb696749159213b$export$2e2bcd8739ae039 = $5bb696749159213b$var$DeletedClientsTable;


const { UnorderedListOutlined: $f713996e244cfc2d$var$UnorderedListOutlined, InboxOutlined: $f713996e244cfc2d$var$InboxOutlined, CheckOutlined: $f713996e244cfc2d$var$CheckOutlined, FolderOpenOutlined: $f713996e244cfc2d$var$FolderOpenOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { TabPane: $f713996e244cfc2d$var$TabPane } = (0, $5024ed5b7bb39672$export$2e2bcd8739ae039);
const $f713996e244cfc2d$var$JobProgressTabs = ()=>{
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const { userRole: userRole } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const clientListColumns = (0, $3279029e4f4e60fb$export$2e2bcd8739ae039)(userRole);
    const today = new Date();
    const [isAddClientModalVisible, setIsAddClientModalVisible] = (0, $6fFrj.useState)(false);
    // graphql
    const { data: progressStatusesData, loading: loadingProgressStatuses } = (0, $732264f53056e08f$export$9ca2f42b9d2b732f)();
    const progressStatuses = progressStatusesData?.ProgressStatuses || [];
    const [updateTaxYearInterviewProgressStatus, { loading: loadingUpdateTaxYearInterviewProgressStatus }] = (0, $d70a105713c5d11d$export$7ff6acaf391acb3d)({
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Job status updated successfully!');
        },
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    // add property for identity tracking
    (0, $732264f53056e08f$export$65d51915dfd746a3)({
        onCompleted: (result)=>{
            (0, $dfc6a33c14790f87$export$15307ef7a3dbf74e)(result.CustomDomainUser?.name, result.CustomDomainUser?.status);
        }
    });
    const [progressStatusDnDConfirmModalVisible, setProgressStatusDnDConfirmModalVisible] = (0, $6fFrj.useState)(false);
    const [dndData, setDndData] = (0, $6fFrj.useState)(null);
    const [activeTab, setActiveTab] = (0, $6fFrj.useState)('clients');
    const [tabCountMap, setTabCountMap] = (0, $6fFrj.useState)({});
    const [getLanguages, { data: languagesData }] = (0, $e9d4d19cd26b2dae$export$5d4e05e09dcdd3b7)();
    const [deletedClientOpened, setDeletedClientOpened] = (0, $6fFrj.useState)(false);
    const [clientsCount, setClientsCount] = (0, $6fFrj.useState)(0);
    const timeElapsed = (date)=>{
        const prevDate = new Date(date);
        const difference = today.getTime() - prevDate.getTime();
        return difference;
    };
    const handleClickTab = (key)=>{
        setActiveTab(key);
        (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).TAB_SELECT, {
            'Tab Description': 'Dashboard Tabs',
            'Tab Selected': progressStatuses.find((ps)=>ps.id === key)?.status || key,
            'Records Count': key === 'clients' ? clientsCount : tabCountMap[key],
            url: window.location.href
        });
    };
    const handleProgressStatusDnDConfirmModal = ()=>{
        // update job progress status
        try {
            updateTaxYearInterviewProgressStatus({
                variables: {
                    id: dndData?.record?.taxYearInterviewId,
                    progressStatusId: dndData?.dropResult?.id
                },
                refetchQueries: [
                    'GetClientsByProgressStatusId'
                ],
                awaitRefetchQueries: true
            });
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to update the job status');
        }
        setProgressStatusDnDConfirmModalVisible(false);
    };
    const returnTableColumns = (underlyingStatus, progressStatusId)=>{
        switch(underlyingStatus){
            case 'UNASSIGNED':
                return (0, $a4248ac38bbe43ba$export$2e2bcd8739ae039)(userRole, progressStatusId);
            case 'IN_PROGRESS':
                return (0, $5a6b7b66be5b12f3$export$2e2bcd8739ae039)(userRole, progressStatusId);
            case 'COMPLETED':
                return (0, $56a2df109dff1160$export$2e2bcd8739ae039)(userRole, progressStatusId);
            case 'CUSTOM':
                return (0, $5a6b7b66be5b12f3$export$2e2bcd8739ae039)(userRole, progressStatusId);
            default:
                return (0, $5a6b7b66be5b12f3$export$2e2bcd8739ae039)(userRole, progressStatusId);
        }
    };
    const returnTableIcons = (underlyingStatus)=>{
        switch(underlyingStatus){
            case 'UNASSIGNED':
                return (0, $bb3TF.jsx)($f713996e244cfc2d$var$InboxOutlined, {});
            case 'IN_PROGRESS':
                return (0, $bb3TF.jsx)($f713996e244cfc2d$var$FolderOpenOutlined, {});
            case 'COMPLETED':
                return (0, $bb3TF.jsx)($f713996e244cfc2d$var$CheckOutlined, {});
            case 'CUSTOM':
                return (0, $bb3TF.jsx)($f713996e244cfc2d$var$FolderOpenOutlined, {});
            default:
                return (0, $bb3TF.jsx)($f713996e244cfc2d$var$FolderOpenOutlined, {});
        }
    };
    // store all languages in session slice
    (0, $6fFrj.useEffect)(()=>{
        if (languagesData) {
            const { languages: languages } = languagesData;
            dispatch((0, $e3b9937a336ce5aa$export$d25bc3c2e588da99)({
                languages: languages
            }));
        }
    }, [
        languagesData
    ]);
    (0, $6fFrj.useEffect)(()=>{
        getLanguages();
    }, []);
    if (!setProgressStatusDnDConfirmModalVisible || !setDndData) return null;
    if (loadingProgressStatuses) return (0, $bb3TF.jsx)("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'flex-start'
        },
        children: (0, $bb3TF.jsx)((0, $53a209758b3184a9$export$2e2bcd8739ae039), {
            size: "calc(100vh - 100px)",
            type: "full",
            id: "loading_jobs"
        })
    });
    const handleDeleteClientCollapseChange = (keys)=>{
        if (keys.length > 0) setDeletedClientOpened(true);
        else setDeletedClientOpened(false);
    };
    return (0, $bb3TF.jsxs)((0, $0fe3e251a617b179$export$9861489d68213f9c), {
        backend: (0, $5091b83b199b6305$export$f4f61d779bb20744),
        children: [
            (0, $bb3TF.jsxs)((0, $5024ed5b7bb39672$export$2e2bcd8739ae039), {
                activeKey: activeTab,
                onTabClick: handleClickTab,
                type: "card",
                defaultActiveKey: progressStatuses?.[0]?.id,
                children: [
                    (0, $bb3TF.jsx)($f713996e244cfc2d$var$TabPane, {
                        tab: (0, $bb3TF.jsxs)("span", {
                            children: [
                                (0, $bb3TF.jsx)($f713996e244cfc2d$var$UnorderedListOutlined, {}),
                                "Client List"
                            ]
                        }),
                        children: (0, $bb3TF.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column'
                            },
                            children: [
                                (0, $bb3TF.jsx)((0, $6da8d7e0b3c816ba$export$2e2bcd8739ae039), {
                                    setProgressStatusDnDConfirmModalVisible: setProgressStatusDnDConfirmModalVisible,
                                    setDndData: setDndData,
                                    columns: clientListColumns,
                                    loadingProp: loadingUpdateTaxYearInterviewProgressStatus,
                                    setClientsCount: setClientsCount
                                }),
                                (0, $bb3TF.jsx)("div", {
                                    style: {
                                        height: '15px'
                                    }
                                }),
                                (0, $bb3TF.jsx)((0, $45def89f679453ce$export$2e2bcd8739ae039), {
                                    onChange: (keys)=>{
                                        handleDeleteClientCollapseChange(keys);
                                    },
                                    children: (0, $bb3TF.jsx)((0, $45def89f679453ce$export$2e2bcd8739ae039).Panel, {
                                        header: "Deleted Clients",
                                        children: (0, $bb3TF.jsx)((0, $5bb696749159213b$export$2e2bcd8739ae039), {
                                            loadData: deletedClientOpened
                                        })
                                    })
                                })
                            ]
                        })
                    }, "clients"),
                    progressStatuses && progressStatuses.map((item)=>(0, $bb3TF.jsx)($f713996e244cfc2d$var$TabPane, {
                            forceRender: true,
                            tab: (0, $bb3TF.jsx)((0, $f1120d6cd6b5f938$export$2e2bcd8739ae039), {
                                name: item.status,
                                id: item.id,
                                node: (0, $bb3TF.jsxs)("span", {
                                    children: [
                                        returnTableIcons(item.underlyingStatus),
                                        item.status,
                                        (0, $bb3TF.jsx)((0, $0e541b76c0e3ec69$export$2e2bcd8739ae039), {
                                            className: "column-count-badge",
                                            count: item.underlyingStatus !== 'COMPLETED' ? tabCountMap[item.id] : null,
                                            overflowCount: 9999
                                        })
                                    ]
                                })
                            }),
                            children: (0, $bb3TF.jsx)((0, $a5ca70def816e8cb$export$2e2bcd8739ae039), {
                                setProgressStatusDnDConfirmModalVisible: setProgressStatusDnDConfirmModalVisible,
                                setDndData: setDndData,
                                columns: returnTableColumns(item.underlyingStatus, item.id),
                                progressStatusId: item.id,
                                progressStatusName: item.status,
                                underlyingStatus: item.underlyingStatus,
                                setTabCountMap: setTabCountMap,
                                loadingProp: loadingUpdateTaxYearInterviewProgressStatus
                            })
                        }, item.id))
                ]
            }),
            (0, $bb3TF.jsx)((0, $2d52d8d286e39b3a$export$2e2bcd8739ae039), {
                isModalVisible: isAddClientModalVisible,
                setIsModalVisible: setIsAddClientModalVisible
            }),
            (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
                title: "Confirm",
                visible: progressStatusDnDConfirmModalVisible,
                onOk: handleProgressStatusDnDConfirmModal,
                onCancel: ()=>setProgressStatusDnDConfirmModalVisible(false),
                okText: "Confirm",
                okButtonProps: {
                    loading: loadingUpdateTaxYearInterviewProgressStatus
                },
                cancelText: "Cancel",
                children: (0, $bb3TF.jsxs)("span", {
                    children: [
                        `${dndData?.record?.firstName} ${dndData?.record?.lastName}`,
                        (0, $bb3TF.jsx)("b", {
                            children: ` ${dndData?.record?.taxYear} - ${dndData?.record?.jobType} `
                        }),
                        "will be moved to",
                        (0, $bb3TF.jsx)("b", {
                            children: ` ${dndData?.dropResult?.name}`
                        }),
                        "."
                    ]
                })
            })
        ]
    });
};
var $f713996e244cfc2d$export$2e2bcd8739ae039 = $f713996e244cfc2d$var$JobProgressTabs;


// interface DashboardProps {}
const $7b059d99f01763a9$var$Dashboard = ()=>(0, $bb3TF.jsx)((0, $f713996e244cfc2d$export$2e2bcd8739ae039), {});
var $7b059d99f01763a9$export$2e2bcd8739ae039 = $7b059d99f01763a9$var$Dashboard;


var $cfcef03c4146f02b$export$2e2bcd8739ae039 = (0, $7b059d99f01763a9$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");

var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");





var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");






const $52d7f973131cdcf3$export$188d396885848ae9 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('File deleted');
};
const $52d7f973131cdcf3$export$e466e2e7b6c9e7e0 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error has occurred while trying to download file. Please try again');
};



var $b3b18310f0e05a08$exports = {};

$parcel$export($b3b18310f0e05a08$exports, "checkbox-container", function () { return $b3b18310f0e05a08$export$9039ae56a700b4b4; }, function (v) { return $b3b18310f0e05a08$export$9039ae56a700b4b4 = v; });
$parcel$export($b3b18310f0e05a08$exports, "modal-content-container", function () { return $b3b18310f0e05a08$export$b1dd409560e393d2; }, function (v) { return $b3b18310f0e05a08$export$b1dd409560e393d2 = v; });
$parcel$export($b3b18310f0e05a08$exports, "modal-header", function () { return $b3b18310f0e05a08$export$f0744c4ecf20e42a; }, function (v) { return $b3b18310f0e05a08$export$f0744c4ecf20e42a = v; });
$parcel$export($b3b18310f0e05a08$exports, "select-container", function () { return $b3b18310f0e05a08$export$63511b38af8e3a8; }, function (v) { return $b3b18310f0e05a08$export$63511b38af8e3a8 = v; });
var $b3b18310f0e05a08$export$9039ae56a700b4b4;
var $b3b18310f0e05a08$export$b1dd409560e393d2;
var $b3b18310f0e05a08$export$f0744c4ecf20e42a;
var $b3b18310f0e05a08$export$63511b38af8e3a8;
$b3b18310f0e05a08$export$9039ae56a700b4b4 = `wwCPya_checkbox-container`;
$b3b18310f0e05a08$export$b1dd409560e393d2 = `wwCPya_modal-content-container`;
$b3b18310f0e05a08$export$f0744c4ecf20e42a = `wwCPya_modal-header`;
$b3b18310f0e05a08$export$63511b38af8e3a8 = `wwCPya_select-container`;


const { Text: $babc6c603c3accf4$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { InfoCircleOutlined: $babc6c603c3accf4$var$InfoCircleOutlined, DeleteOutlined: $babc6c603c3accf4$var$DeleteOutlined, PlusOutlined: $babc6c603c3accf4$var$PlusOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $babc6c603c3accf4$var$UploadButton = ()=>(0, $bb3TF.jsxs)("button", {
        style: {
            border: 0,
            background: 'none'
        },
        type: "button",
        children: [
            (0, $bb3TF.jsx)($babc6c603c3accf4$var$PlusOutlined, {}),
            (0, $bb3TF.jsx)("div", {
                style: {
                    marginTop: 8
                },
                children: "Upload"
            })
        ]
    });
const $babc6c603c3accf4$var$ConditionalModal = ({ visible: visible, options: options, isEditing: isEditing, onCancel: onCancel, onOk: onOk, loading: loading, isSubsection: isSubsection = false, onOkCreateQuestion: onOkCreateQuestion, conditional: conditional, interviewId: interviewId, sectionId: sectionId, onDeleteConditional: onDeleteConditional })=>{
    const initialRender = (0, $6fFrj.useRef)(true);
    const { languageId: currentLanguageId } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const [initialOptions, setInitialOptions] = (0, $6fFrj.useState)(options);
    const [optionCheckboxes, setOptionCheckboxes] = (0, $6fFrj.useState)(options);
    const [form] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    const [conditionalImage, setConditionalImage] = (0, $6fFrj.useState)(null);
    const [conditionalImageUrl, setConditionalImageUrl] = (0, $6fFrj.useState)(null);
    const [getPresignedUrl, { data: uploadFileData }] = (0, $edf372aa0dea9531$export$ea7e982b7f736995)({
        onError: (0, $b0edf9f13e354d28$export$b728c07d3fd30236)
    });
    const [downloadFile] = (0, $edf372aa0dea9531$export$4747d4e17950f93f)({
        onError: (0, $52d7f973131cdcf3$export$e466e2e7b6c9e7e0)
    });
    (0, $6fFrj.useEffect)(()=>{
        console.log(sectionId, interviewId);
    }, [
        interviewId,
        sectionId
    ]);
    const getTitle = (translations)=>{
        const translation = translations.find((t)=>t.languageId === currentLanguageId);
        return translation?.description;
    };
    (0, $6fFrj.useEffect)(()=>{
        if (conditional?.picture) downloadFile({
            variables: {
                s3Key: conditional?.picture
            },
            onCompleted: (data)=>{
                setConditionalImageUrl(data.downloadFile.signedUrl);
            }
        });
    }, [
        conditional
    ]);
    (0, $6fFrj.useEffect)(()=>{
        console.log('conditionalImageUrl', conditionalImageUrl);
    }, [
        conditionalImageUrl
    ]);
    const intiialValues = (0, $6fFrj.useMemo)(()=>{
        if (conditional) {
            console.log('conditional', conditional);
            setConditionalImage(conditional.picture);
            const selectedOptionTranslation = conditional.Options.Questions.Options.find((option)=>option.id === conditional.optionId).Translations.find((t)=>t.Language.lang === 'EN');
            console.log(selectedOptionTranslation);
            return {
                questionTitle: getTitle(conditional.Options.Questions.Translations),
                optionToEnable: selectedOptionTranslation?.description.toLowerCase(),
                hint: conditional.hintText
            };
        }
        return {};
    }, [
        conditional
    ]);
    const uploadConditionalImage = async (file)=>{
        try {
            const key = `conditionals/${interviewId}/${sectionId}/${file.name}`;
            const { data: conditionalUploadData } = await getPresignedUrl({
                variables: {
                    fileName: key,
                    fileType: file.type
                }
            });
            if (conditionalUploadData.generatePreSignedPutUrl) {
                const { signedUrl: signedUrl, url: url } = conditionalUploadData.generatePreSignedPutUrl;
                const fileUrl = new URL(signedUrl);
                await (0, (/*@__PURE__*/$parcel$interopDefault($18ae57eea10fd4c8$exports))).put(fileUrl.toString(), file, {
                    headers: {
                        'Content-Type': 'image/png'
                    }
                });
                return url.split('.com/')[1];
            }
            return undefined;
        } catch (error) {
            console.log('error', error);
            return undefined;
        }
    };
    const handleOnOk = async ()=>{
        if (isSubsection) {
            if (!isEditing) {
                onOk({
                    selectedOptions: optionCheckboxes.filter(({ checked: checked })=>checked)
                });
                setInitialOptions([]);
            } else {
                onOk({
                    selectedOptions: optionCheckboxes.filter(({ value: value, checked: checked })=>{
                        const currentOption = initialOptions.find(({ value: optionId })=>optionId === value);
                        return !!currentOption && currentOption.checked !== checked;
                    })
                });
                setInitialOptions([]);
            }
        } else {
            const valid = await form.validateFields();
            if (valid) {
                const { questionTitle: questionTitle, optionToEnable: optionToEnable, hint: hint } = form.getFieldsValue();
                console.log('conditional image!', conditionalImage);
                const imageUploadResult = conditionalImage ? await uploadConditionalImage(conditionalImage) : null;
                console.log(imageUploadResult);
                if (!conditionalImage || conditionalImage && imageUploadResult) onOkCreateQuestion({
                    questionTitle: questionTitle,
                    optionToEnable: optionToEnable,
                    picture: imageUploadResult,
                    hintText: hint,
                    questionId: conditional?.Options.questionId || null
                });
            }
        }
    };
    const handleSelectedOptionsChange = (event)=>{
        setOptionCheckboxes((previous)=>previous.map((option)=>{
                if (event.target.id === option.value) return {
                    ...option,
                    checked: !option.checked
                };
                return option;
            }));
    };
    (0, $6fFrj.useEffect)(()=>{
        if (initialRender.current) initialRender.current = false;
        if (!initialRender.current && !initialOptions.length) setInitialOptions(options);
        setOptionCheckboxes(options);
        form.resetFields();
    }, [
        options
    ]);
    /// ///////////////////////
    // const [submittable, setSubmittable] = React.useState<boolean>(false);
    // // Watch all values
    // const values = Form.useWatch([], form);
    // useEffect(() => {
    //   form
    //     .validateFields({ validateOnly: true })
    //     .then(() => setSubmittable(true))
    //     .catch(() => setSubmittable(false));
    // }, [form, values]);
    /// ///////////////////////
    const handleDeleteConditional = ()=>{
        onDeleteConditional({
            questionId: conditional.Options.Questions.id,
            conditionalId: conditional.id
        });
    };
    const beforeUpload = (file)=>{
        const maxSize = 26214400; // 25MB
        if (file.size > maxSize) {
            (0, $b0edf9f13e354d28$export$16dbc74f3d5490d5)();
            return false;
        }
        if (!(0, $2bd45c4ca422dc00$export$21f4b1dc927890d3)(file.type)) {
            (0, $b0edf9f13e354d28$export$f5a7890bfa0f9b35)();
            return false;
        }
        return false;
    };
    const handleChange = (info)=>{
        setConditionalImage(info.file);
    };
    return visible ? (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        open: visible,
        onCancel: onCancel,
        okText: "Save",
        okButtonProps: {
            disabled: isSubsection ? !optionCheckboxes.length : false
        },
        onOk: handleOnOk,
        footer: [
            conditional && (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                color: "red",
                onClick: handleDeleteConditional,
                children: "Delete"
            }, "delete"),
            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                onClick: onCancel,
                children: "Cancel"
            }, "cancel"),
            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                type: "primary",
                onClick: handleOnOk,
                children: "Save"
            }, "submit")
        ],
        title: (0, $bb3TF.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($b3b18310f0e05a08$exports))).modalHeader,
            children: [
                (0, $bb3TF.jsxs)("h2", {
                    children: [
                        `${isEditing ? 'Update' : 'Create'}`,
                        ' ',
                        "Cards"
                    ]
                }),
                (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                    placement: "bottom",
                    title: "Consists of selecting the options of the questions of the parent section with which you want this section to be active/visible to the client.",
                    children: (0, $bb3TF.jsx)($babc6c603c3accf4$var$InfoCircleOutlined, {
                        size: "small"
                    })
                })
            ]
        }),
        children: (0, $bb3TF.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($b3b18310f0e05a08$exports))).modalContentContainer,
            children: [
                loading && (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {}),
                isSubsection && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                    children: [
                        (0, $bb3TF.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($b3b18310f0e05a08$exports))).selectContainer,
                            children: [
                                (0, $bb3TF.jsx)("strong", {
                                    children: optionCheckboxes.length ? 'Check the desired options to condition this section' : 'There is no options to condition this section'
                                }),
                                (0, $bb3TF.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($b3b18310f0e05a08$exports))).checkboxContainer,
                                    children: optionCheckboxes.map(({ label: label, checked: checked, value: value })=>(0, $bb3TF.jsx)((0, $66ef76fa6be8ca1a$export$2e2bcd8739ae039), {
                                            id: value,
                                            checked: checked,
                                            onChange: handleSelectedOptionsChange,
                                            Tooltip: true,
                                            children: label
                                        }))
                                })
                            ]
                        }),
                        (0, $bb3TF.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($b3b18310f0e05a08$exports))).selectContainer
                        })
                    ]
                }),
                !isSubsection && (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                    form: form,
                    layout: "vertical",
                    initialValues: intiialValues,
                    children: [
                        (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                            name: "questionTitle",
                            label: "Question title",
                            rules: [
                                {
                                    required: true,
                                    message: 'Add a question title'
                                }
                            ],
                            children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {})
                        }),
                        (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                            name: "conditionalPhoto",
                            label: "Card picture",
                            children: (0, $bb3TF.jsx)((0, $09e7a312b8c0b52f$export$2e2bcd8739ae039), {
                                name: "conditionalPhoto",
                                listType: "picture-card",
                                accept: "image/png, image/jpeg",
                                beforeUpload: beforeUpload,
                                onChange: handleChange,
                                onRemove: ()=>setConditionalImage(null),
                                children: conditional?.picture ? (0, $bb3TF.jsx)((0, $290d39e90e1ee9b2$export$2e2bcd8739ae039), {
                                    src: conditionalImageUrl
                                }) : !conditionalImage && (0, $bb3TF.jsx)($babc6c603c3accf4$var$UploadButton, {})
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                            name: "hint",
                            label: "Card Hint",
                            children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                placeholder: "Add a hint to help users"
                            })
                        })
                    ]
                })
            ]
        })
    }) : null;
};
$babc6c603c3accf4$var$ConditionalModal.defaultProps = {
    isSubsection: false
};
var $babc6c603c3accf4$export$2e2bcd8739ae039 = $babc6c603c3accf4$var$ConditionalModal;



var $bb3TF = parcelRequire("bb3TF");



var $6fFrj = parcelRequire("6fFrj");






const $f74b63f5d3b4edd3$var$defaultOptions = {};
const $f74b63f5d3b4edd3$export$151f277978e184a9 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateConditionals($createConditionalsInput: [CreateConditionalInput!]!) {
  createConditionals(createConditionalsInput: $createConditionalsInput) {
    id
    sectionId
    optionId
    createAt
  }
}
    `;
function $f74b63f5d3b4edd3$export$f2918fa6ee7289c3(baseOptions) {
    const options = {
        ...$f74b63f5d3b4edd3$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($f74b63f5d3b4edd3$export$151f277978e184a9, options);
}
const $f74b63f5d3b4edd3$export$4aa998cdb1e4704c = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateConditionals($updateConditionalInput: [UpdateConditionalInput!]!) {
  updateConditionals(updateConditionalInput: $updateConditionalInput) {
    id
    sectionId
    optionId
    createAt
  }
}
    `;
function $f74b63f5d3b4edd3$export$2d0f72520537e036(baseOptions) {
    const options = {
        ...$f74b63f5d3b4edd3$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($f74b63f5d3b4edd3$export$4aa998cdb1e4704c, options);
}
const $f74b63f5d3b4edd3$export$ecc913cb9ba38e4 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation SaveConditionalQuestion($saveConditionalQuestionInput: SaveConditionalQuestionInput!) {
  saveConditionalQuestion(data: $saveConditionalQuestionInput)
}
    `;
function $f74b63f5d3b4edd3$export$5a7437969dd0f429(baseOptions) {
    const options = {
        ...$f74b63f5d3b4edd3$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($f74b63f5d3b4edd3$export$ecc913cb9ba38e4, options);
}
const $f74b63f5d3b4edd3$export$837cf8b602dfb707 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation deleteConditional($questionId: String!, $conditionalId: String!) {
  deleteConditional(questionId: $questionId, conditionalId: $conditionalId)
}
    `;
function $f74b63f5d3b4edd3$export$36d5181b6e4d89da(baseOptions) {
    const options = {
        ...$f74b63f5d3b4edd3$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($f74b63f5d3b4edd3$export$837cf8b602dfb707, options);
}
const $f74b63f5d3b4edd3$export$39ac829ab91f0716 = {
    Mutation: {
        CreateConditionals: 'CreateConditionals',
        UpdateConditionals: 'UpdateConditionals',
        SaveConditionalQuestion: 'SaveConditionalQuestion',
        deleteConditional: 'deleteConditional'
    }
};




const $424f41c1a1283b75$var$defaultOptions = {};
const $424f41c1a1283b75$export$9f3a6afd8d0fde45 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment Translation on TranslationEntity {
  id
  createAt
  updateAt
  questionId
  sectionId
  optionId
  languageId
  description
  Language {
    id
    lang
    description
  }
}
    `;
const $424f41c1a1283b75$export$c2fef5ce512feb9e = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment Questions on QuestionEntity {
  id
  type
  order
  required
  forwardable
  createAt
  updateAt
  sectionId
  Translations {
    ...Translation
  }
}
    ${$424f41c1a1283b75$export$9f3a6afd8d0fde45}`;
const $424f41c1a1283b75$export$81d909d0e8d2c431 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment Options on OptionsEntity {
  id
  questionId
  createAt
  updateAt
  Translations {
    ...Translation
  }
}
    ${$424f41c1a1283b75$export$9f3a6afd8d0fde45}`;
const $424f41c1a1283b75$export$9a3114ea4c009b20 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment Section on SectionEntity {
  id
  order
  parentId
  interviewId
  createAt
  updateAt
  isSpecial
  Translations {
    ...Translation
  }
  Questions {
    ...Questions
    Options {
      ...Options
    }
  }
}
    ${$424f41c1a1283b75$export$9f3a6afd8d0fde45}
${$424f41c1a1283b75$export$c2fef5ce512feb9e}
${$424f41c1a1283b75$export$81d909d0e8d2c431}`;
const $424f41c1a1283b75$export$2654ef0bea91680d = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    fragment SectionsEntity on SectionEntity {
  ...Section
  SubSections {
    ...Section
    SubSections {
      ...Section
      SubSections {
        ...Section
      }
    }
  }
}
    ${$424f41c1a1283b75$export$9a3114ea4c009b20}`;
const $424f41c1a1283b75$export$a9a9f6c5eed754b8 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateInterview($createInterviewInput: CreateInterviewInput!) {
  CreateInterview(createInterviewInput: $createInterviewInput) {
    id
    name
    isLive
    createAt
    updateAt
    isTemplate
    Sections {
      ...SectionsEntity
    }
  }
}
    ${$424f41c1a1283b75$export$2654ef0bea91680d}`;
function $424f41c1a1283b75$export$9578d2ea45102e7f(baseOptions) {
    const options = {
        ...$424f41c1a1283b75$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($424f41c1a1283b75$export$a9a9f6c5eed754b8, options);
}
const $424f41c1a1283b75$export$ede23cebdf26d8e3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CopyInterview($id: String!) {
  copyInterview(id: $id) {
    id
    name
    isLive
    createAt
    updateAt
    isTemplate
    firmAccountId
    Sections {
      ...SectionsEntity
    }
  }
}
    ${$424f41c1a1283b75$export$2654ef0bea91680d}`;
function $424f41c1a1283b75$export$94f4f245cab153e5(baseOptions) {
    const options = {
        ...$424f41c1a1283b75$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($424f41c1a1283b75$export$ede23cebdf26d8e3, options);
}
const $424f41c1a1283b75$export$8d2aaa163b6f4c8 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation DeleteInterview($id: String!) {
  softDeleteInterview(id: $id) {
    success
  }
}
    `;
function $424f41c1a1283b75$export$dd1ee8b0fe2427cd(baseOptions) {
    const options = {
        ...$424f41c1a1283b75$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($424f41c1a1283b75$export$8d2aaa163b6f4c8, options);
}
const $424f41c1a1283b75$export$5575c25eb86d9bf7 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation CreateSpecialSection($createSpecialSectionInput: CreateSpecialSectionInput!) {
  createSpecialSection(createSpecialSectionInput: $createSpecialSectionInput) {
    ...SectionEntity
  }
}
    ${(0, $774cc9a1c383b6aa$export$e736e2f724f2256d)}`;
function $424f41c1a1283b75$export$dcc800819d215788(baseOptions) {
    const options = {
        ...$424f41c1a1283b75$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($424f41c1a1283b75$export$5575c25eb86d9bf7, options);
}
const $424f41c1a1283b75$export$b5fc1d2bfe8d2a71 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateInterview($updateInterviewInput: UpdateInterviewInput!) {
  updateInterview(updateInterviewInput: $updateInterviewInput) {
    id
    name
    isLive
    createAt
    updateAt
    isTemplate
    Sections {
      ...SectionsEntity
    }
  }
}
    ${$424f41c1a1283b75$export$2654ef0bea91680d}`;
function $424f41c1a1283b75$export$1702b67be0d9481e(baseOptions) {
    const options = {
        ...$424f41c1a1283b75$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($424f41c1a1283b75$export$b5fc1d2bfe8d2a71, options);
}
const $424f41c1a1283b75$export$2644bd286973e8a3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation updateInterviewState($id: String!, $isLive: Boolean!) {
  updateInterviewState(id: $id, isLive: $isLive) {
    id
    name
    isLive
    createAt
    updateAt
    isTemplate
  }
}
    `;
function $424f41c1a1283b75$export$8467f1ec132fab8e(baseOptions) {
    const options = {
        ...$424f41c1a1283b75$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($424f41c1a1283b75$export$2644bd286973e8a3, options);
}
const $424f41c1a1283b75$export$39ac829ab91f0716 = {
    Mutation: {
        CreateInterview: 'CreateInterview',
        CopyInterview: 'CopyInterview',
        DeleteInterview: 'DeleteInterview',
        CreateSpecialSection: 'CreateSpecialSection',
        UpdateInterview: 'UpdateInterview',
        updateInterviewState: 'updateInterviewState'
    },
    Fragment: {
        Translation: 'Translation',
        Options: 'Options',
        Questions: 'Questions',
        Section: 'Section',
        SectionsEntity: 'SectionsEntity'
    }
};



var $i5UNc = parcelRequire("i5UNc");


var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

var $bb3TF = parcelRequire("bb3TF");


var $6fFrj = parcelRequire("6fFrj");




var $0bf2660859f1ee8e$export$62da7bced551921f;
var $0bf2660859f1ee8e$export$9fa75baca6b6ebc0;
var $0bf2660859f1ee8e$export$e536286417c9d629;
var $0bf2660859f1ee8e$export$5e73d8be3ea76146;
var $0bf2660859f1ee8e$export$4f6efa6c6158c27;
var $0bf2660859f1ee8e$export$4f27a36f18d465b8;
var $0bf2660859f1ee8e$export$7aaed169f2f99da;
$0bf2660859f1ee8e$export$62da7bced551921f = `Yr3m8a_deleteSectionButton`;
$0bf2660859f1ee8e$export$9fa75baca6b6ebc0 = `Yr3m8a_dragContainer`;
$0bf2660859f1ee8e$export$e536286417c9d629 = `Yr3m8a_moveIcon`;
$0bf2660859f1ee8e$export$5e73d8be3ea76146 = `Yr3m8a_noQuestionsAlert`;
$0bf2660859f1ee8e$export$4f6efa6c6158c27 = `Yr3m8a_questionDragContainer`;
$0bf2660859f1ee8e$export$4f27a36f18d465b8 = `Yr3m8a_sectionNameInput`;
$0bf2660859f1ee8e$export$7aaed169f2f99da = `Yr3m8a_subSection`;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



var $bb3TF = parcelRequire("bb3TF");



var $6fFrj = parcelRequire("6fFrj");
var $938604c307ac7ebd$exports = {};

$parcel$export($938604c307ac7ebd$exports, "option-element", function () { return $938604c307ac7ebd$export$f0d3d29a9bd8695c; }, function (v) { return $938604c307ac7ebd$export$f0d3d29a9bd8695c = v; });
$parcel$export($938604c307ac7ebd$exports, "option-list-container", function () { return $938604c307ac7ebd$export$a4e378eb934e3fa9; }, function (v) { return $938604c307ac7ebd$export$a4e378eb934e3fa9 = v; });
$parcel$export($938604c307ac7ebd$exports, "option-list-header", function () { return $938604c307ac7ebd$export$8a93375312ce13fd; }, function (v) { return $938604c307ac7ebd$export$8a93375312ce13fd = v; });
var $938604c307ac7ebd$export$f0d3d29a9bd8695c;
var $938604c307ac7ebd$export$a4e378eb934e3fa9;
var $938604c307ac7ebd$export$8a93375312ce13fd;
$938604c307ac7ebd$export$f0d3d29a9bd8695c = `cpoBDq_option-element`;
$938604c307ac7ebd$export$a4e378eb934e3fa9 = `cpoBDq_option-list-container`;
$938604c307ac7ebd$export$8a93375312ce13fd = `cpoBDq_option-list-header`;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $dc1a0e822c5bb0f9$export$cf2c44f9bbee2ed;
$dc1a0e822c5bb0f9$export$cf2c44f9bbee2ed = `tLl2xq_optionElement`;


const { DeleteOutlined: $b828304f4d1239c6$var$DeleteOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $b828304f4d1239c6$var$InterviewOption = ({ id: id, temporalId: temporalId, label: label, onOptionChange: onOptionChange, onDeleteOptionClick: onDeleteOptionClick })=>{
    const [labelValue, setLabelValue] = (0, $6fFrj.useState)(label);
    const firstRender = (0, $6fFrj.useRef)(true);
    const handleOptionChange = (event)=>{
        setLabelValue(event.target.value);
    };
    const handleDeleteOptionClick = ()=>{
        onDeleteOptionClick();
    };
    (0, $6fFrj.useEffect)(()=>{
        if (firstRender.current) firstRender.current = false;
        else setLabelValue(label);
    }, [
        label
    ]);
    (0, $ad3306746e490c84$export$2e2bcd8739ae039)(()=>{
        if (firstRender.current) firstRender.current = false;
        else onOptionChange(labelValue);
    }, 500, [
        labelValue
    ]);
    return (0, $bb3TF.jsxs)("div", {
        className: $dc1a0e822c5bb0f9$export$cf2c44f9bbee2ed,
        children: [
            (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                value: labelValue,
                onChange: handleOptionChange
            }),
            (0, $bb3TF.jsx)((0, $a361442371f1d4e9$export$2e2bcd8739ae039), {
                okText: "Yes",
                cancelText: "No",
                placement: "topRight",
                okButtonProps: {
                    danger: true
                },
                onConfirm: handleDeleteOptionClick,
                cancelButtonProps: {
                    type: 'default'
                },
                title: "Are you sure you want to delete this?",
                children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                    title: "Delete",
                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        type: "danger",
                        icon: (0, $bb3TF.jsx)($b828304f4d1239c6$var$DeleteOutlined, {})
                    })
                })
            })
        ]
    }, id ?? temporalId);
};
$b828304f4d1239c6$var$InterviewOption.defaultProps = {
    id: null,
    temporalId: null
};
var $b828304f4d1239c6$export$2e2bcd8739ae039 = $b828304f4d1239c6$var$InterviewOption;


const { InfoCircleOutlined: $d3e244963037be06$var$InfoCircleOutlined, PlusCircleFilled: $d3e244963037be06$var$PlusCircleFilled } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $d3e244963037be06$var$InterviewOptionList = ({ options: options, questionId: questionId, temporalQuestionId: temporalQuestionId, onOptionsChange: onOptionsChange })=>{
    const handleAddOptionClick = ()=>{
        onOptionsChange([
            ...options,
            {
                label: '',
                questionId: questionId,
                temporalId: (0, $d9fa1eeee74e23fa$export$2e2bcd8739ae039)(),
                temporalQuestionId: temporalQuestionId,
                operation: 'create'
            }
        ]);
    };
    const handleDeleteOptionClick = (optionIndex)=>{
        const currentOptions = [
            ...options
        ];
        if (currentOptions[optionIndex] && currentOptions[optionIndex].id) currentOptions[optionIndex].operation = 'delete';
        else currentOptions.splice(optionIndex, 1);
        onOptionsChange(currentOptions);
    };
    const handleOptionChange = (value, optionIndex)=>{
        const currentOptions = [
            ...options
        ];
        currentOptions[optionIndex].label = value;
        if (questionId && questionId.length && currentOptions[optionIndex].id && !currentOptions[optionIndex].operation) currentOptions[optionIndex].operation = 'update';
        onOptionsChange(currentOptions);
    };
    return (0, $bb3TF.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($938604c307ac7ebd$exports))).optionListContainer,
        children: [
            (0, $bb3TF.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($938604c307ac7ebd$exports))).optionListHeader,
                children: [
                    (0, $bb3TF.jsxs)("div", {
                        children: [
                            "Options:",
                            ' ',
                            (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                title: "The possible choices for your client to pick from. i.e. Selecting a dropdown/radio question type will require multiple options to choose from.",
                                children: (0, $bb3TF.jsx)($d3e244963037be06$var$InfoCircleOutlined, {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($938604c307ac7ebd$exports))).info
                                })
                            })
                        ]
                    }),
                    (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        onClick: handleAddOptionClick,
                        icon: (0, $bb3TF.jsx)($d3e244963037be06$var$PlusCircleFilled, {}),
                        type: "default",
                        children: "Add Option"
                    })
                ]
            }),
            options.length ? options.map(({ id: id, label: label, temporalId: temporalId }, index)=>{
                const onOptionChangeHandler = (value)=>{
                    handleOptionChange(value, index);
                };
                const onDeleteOptionHandler = ()=>{
                    handleDeleteOptionClick(index);
                };
                return (0, $bb3TF.jsx)((0, $b828304f4d1239c6$export$2e2bcd8739ae039), {
                    id: id,
                    label: label,
                    temporalId: temporalId,
                    onOptionChange: onOptionChangeHandler,
                    onDeleteOptionClick: onDeleteOptionHandler
                });
            }) : (0, $bb3TF.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($938604c307ac7ebd$exports))).noOptionsAlertContainer,
                children: (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                    showIcon: true,
                    type: "warning",
                    message: "Hey!",
                    description: "A 'radio' or 'drop-down' question must contain at least one option for the taxpayer to choose from."
                })
            })
        ]
    });
};
$d3e244963037be06$var$InterviewOptionList.defaultProps = {
    questionId: null,
    temporalQuestionId: null
};
var $d3e244963037be06$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).memo($d3e244963037be06$var$InterviewOptionList);




const $7e72534d935cc338$export$41c562ebe57d11e2 = Object.values((0, $8f7fe33a44836803$export$51940fbbacba35d4)).map((type)=>({
        name: type.toLowerCase().replace(/[^a-zA-Z0-9 ]/g, ' ').replace(/\s_/g, '_'),
        value: type
    }));


var $29197ecdf6ac0a78$export$6a014a242a93bb63;
var $29197ecdf6ac0a78$export$f6fea39d918e50d9;
var $29197ecdf6ac0a78$export$a80b3bd66acc52ff;
var $29197ecdf6ac0a78$export$f150298ec4c3ee20;
var $29197ecdf6ac0a78$export$9c18ec6fb3bcaa72;
var $29197ecdf6ac0a78$export$2e6c959c16ff56b8;
$29197ecdf6ac0a78$export$6a014a242a93bb63 = `nCJZIG_anticon`;
$29197ecdf6ac0a78$export$f6fea39d918e50d9 = `nCJZIG_flex-child`;
$29197ecdf6ac0a78$export$a80b3bd66acc52ff = `nCJZIG_info`;
$29197ecdf6ac0a78$export$f150298ec4c3ee20 = `nCJZIG_options-container`;
$29197ecdf6ac0a78$export$9c18ec6fb3bcaa72 = `nCJZIG_popconfirmDangerButton`;
$29197ecdf6ac0a78$export$2e6c959c16ff56b8 = `nCJZIG_select`;


const { DeleteOutlined: $1b7b7b26dc2d1612$var$DeleteOutlined, InfoCircleOutlined: $1b7b7b26dc2d1612$var$InfoCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Option: $1b7b7b26dc2d1612$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
function $1b7b7b26dc2d1612$var$InterviewField({ id: id, type: type, label: label, Options: Options, required: required, onDelete: onDelete, disabled: disabled, temporalId: temporalId, onFieldChange: onFieldChange, onOptionsChange: onOptionsChange }) {
    const firstRender = (0, $6fFrj.useRef)(true);
    const [labelValue, setLabelValue] = (0, $6fFrj.useState)(label);
    const hasFieldOptions = (0, $6fFrj.useMemo)(()=>type === (0, $8f7fe33a44836803$export$51940fbbacba35d4).Dropdown || type === (0, $8f7fe33a44836803$export$51940fbbacba35d4).Radio, [
        type
    ]);
    const handleSelect = (value)=>{
        // field options depending of the field type
        const fieldOptions = (value === 'DROPDOWN' || value === 'RADIO') && !Options ? [] : Options;
        onFieldChange({
            type: value,
            Options: fieldOptions
        });
    };
    const handleSwitch = ()=>{
        onFieldChange({
            required: !required
        });
    };
    const handleInput = (ev)=>{
        const labelText = ev.target.value;
        if (id) onFieldChange({
            operation: 'update'
        });
        setLabelValue(labelText);
    };
    const onOptionsChangeHandler = (newOptions)=>{
        onOptionsChange(newOptions);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (firstRender.current) firstRender.current = false;
        else setLabelValue(label);
    }, [
        label
    ]);
    (0, $ad3306746e490c84$export$2e2bcd8739ae039)(()=>{
        if (firstRender.current) firstRender.current = false;
        else onFieldChange({
            label: labelValue
        });
    }, 500, [
        labelValue
    ]);
    return (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
        type: "inner",
        style: {
            marginBottom: '25px'
        },
        title: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
            disabled: !!disabled,
            addonBefore: (0, $bb3TF.jsxs)("span", {
                children: [
                    "Question:",
                    ' ',
                    (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                        title: "A question you want your client to answer. i.e. What is your first name?",
                        children: (0, $bb3TF.jsx)($1b7b7b26dc2d1612$var$InfoCircleOutlined, {
                            className: $29197ecdf6ac0a78$export$a80b3bd66acc52ff
                        })
                    })
                ]
            }),
            value: labelValue,
            onChange: handleInput
        }),
        extra: !disabled ? (0, $bb3TF.jsxs)("div", {
            style: {
                marginLeft: '10px'
            },
            children: [
                (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                    title: required ? 'Mark Optional' : 'Mark Required',
                    children: (0, $bb3TF.jsx)((0, $4fd303306a27e42e$export$2e2bcd8739ae039), {
                        checked: required,
                        onClick: handleSwitch,
                        style: {
                            marginRight: '10px'
                        }
                    })
                }),
                (0, $bb3TF.jsx)((0, $a361442371f1d4e9$export$2e2bcd8739ae039), {
                    onConfirm: onDelete,
                    onCancel: (ev)=>ev.preventDefault,
                    title: "Are you sure you want to delete this?",
                    okText: "Yes",
                    cancelText: "No",
                    okButtonProps: {
                        danger: true
                    },
                    cancelButtonProps: {
                        type: 'default'
                    },
                    placement: "topRight",
                    children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                        title: "Delete",
                        children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "primary",
                            danger: true,
                            className: $29197ecdf6ac0a78$export$9c18ec6fb3bcaa72,
                            icon: (0, $bb3TF.jsx)($1b7b7b26dc2d1612$var$DeleteOutlined, {})
                        })
                    })
                })
            ]
        }) : null,
        children: [
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    5,
                    0
                ],
                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {})
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                style: {
                    marginTop: '5px',
                    alignItems: 'center'
                },
                gutter: [
                    35,
                    0
                ],
                children: (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    children: [
                        (0, $bb3TF.jsxs)("div", {
                            children: [
                                "Answer Field Type:",
                                ' ',
                                (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                    title: "Select the type of field that you would like to use for the answer of this question.",
                                    children: (0, $bb3TF.jsx)($1b7b7b26dc2d1612$var$InfoCircleOutlined, {
                                        className: $29197ecdf6ac0a78$export$a80b3bd66acc52ff
                                    })
                                })
                            ]
                        }),
                        (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                            disabled: !!disabled,
                            defaultValue: type,
                            className: $29197ecdf6ac0a78$export$2e6c959c16ff56b8,
                            onChange: handleSelect,
                            children: (0, $7e72534d935cc338$export$41c562ebe57d11e2).map((opt)=>(0, $bb3TF.jsx)($1b7b7b26dc2d1612$var$Option, {
                                    value: opt.value,
                                    children: opt.name === 'float' ? 'number' : opt.name
                                }, opt.value))
                        })
                    ]
                })
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                style: {
                    marginTop: '15px'
                },
                children: hasFieldOptions && (0, $bb3TF.jsx)((0, $d3e244963037be06$export$2e2bcd8739ae039), {
                    questionId: id,
                    options: Options,
                    temporalQuestionId: temporalId,
                    onOptionsChange: onOptionsChangeHandler
                })
            })
        ]
    });
}
$1b7b7b26dc2d1612$var$InterviewField.defaultProps = {
    type: undefined,
    id: null,
    temporalId: null
};
var $1b7b7b26dc2d1612$export$2e2bcd8739ae039 = $1b7b7b26dc2d1612$var$InterviewField;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $f15d8985db3837b0$var$SvgDragNDropIcon = (props)=>/*#__PURE__*/ (0, $bb3TF.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 266,
        height: 266,
        ...props,
        children: /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
            d: "m121.562 87.78-9.842 13.3h7.98c7.714 0 7.98.532 7.98 11.97 0 10.108.798 11.97 5.32 11.97s5.32-1.862 5.32-11.97c0-11.438.266-11.97 7.98-11.97h7.98l-9.842-13.3c-5.32-7.448-10.64-13.3-11.438-13.3s-6.118 5.852-11.438 13.3zM85.12 133c0 4.788 1.33 5.586 10.108 4.788 6.65-.532 9.842-2.128 9.842-4.788s-3.192-4.256-9.842-4.788c-8.778-.798-10.108 0-10.108 4.788zM119.7 133c0 4.522 1.862 5.32 13.3 5.32s13.3-.798 13.3-5.32-1.862-5.32-13.3-5.32-13.3.798-13.3 5.32zM160.93 130.34c-2.926 4.788 1.33 7.98 10.906 7.98 7.182 0 9.044-1.064 9.044-5.32s-1.862-5.32-9.044-5.32c-5.054 0-10.108 1.064-10.906 2.66zM127.68 152.95c0 11.438-.266 11.97-7.98 11.97h-7.98l9.842 13.3c5.32 7.182 10.64 13.3 11.438 13.3s6.118-6.118 11.438-13.3l9.842-13.3h-7.98c-7.714 0-7.98-.532-7.98-11.97 0-10.108-.798-11.97-5.32-11.97s-5.32 1.862-5.32 11.97z"
        })
    });
var $f15d8985db3837b0$export$2e2bcd8739ae039 = $f15d8985db3837b0$var$SvgDragNDropIcon;


const { DeleteOutlined: $5c6aa6d532f2c01d$var$DeleteOutlined, PlusCircleOutlined: $5c6aa6d532f2c01d$var$PlusCircleOutlined, PlusCircleFilled: $5c6aa6d532f2c01d$var$PlusCircleFilled, EditOutlined: $5c6aa6d532f2c01d$var$EditOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $5c6aa6d532f2c01d$var$SUBSECTION_DEEP_LEVEL_LIMIT = 3;
const $5c6aa6d532f2c01d$var$INITIAL_QUESTION = {
    id: null,
    label: '',
    required: false,
    sectionId: null,
    temporalId: null,
    type: (0, $8f7fe33a44836803$export$51940fbbacba35d4).Text
};
const $5c6aa6d532f2c01d$export$65be24a7a22eebd8 = {
    id: null,
    name: '',
    isSpecial: false,
    order: 0,
    Questions: [
        $5c6aa6d532f2c01d$var$INITIAL_QUESTION
    ],
    SubSections: []
};
const $5c6aa6d532f2c01d$var$SectionContext = /*#__PURE__*/ (0, $6fFrj.createContext)(null);
const $5c6aa6d532f2c01d$var$InterviewSection = ({ id: id, index: index, disabled: disabled, parentId: parentId, Questions: Questions, temporalId: temporalId, sectionName: sectionName, SubSections: SubSections, Conditionals: Conditionals, onDeleteSection: onDeleteSection, temporalParentId: temporalParentId, onSectionDragEnd: onSectionDragEnd, onQuestionDragEnd: onQuestionDragEnd, onQuestionsChange: onQuestionsChange, onSectionNameChange: onSectionNameChange, onSubSectionsChange: onSubSectionsChange, onAddConditionalClick: onAddConditionalClick, interviewLanguage: interviewLanguage })=>{
    // TODO: Add Drag & Drop Functionality
    const firstRender = (0, $6fFrj.useRef)(true);
    const [nameValue, setNameValue] = (0, $6fFrj.useState)(sectionName);
    const currentSectionContextValue = (0, $6fFrj.useContext)($5c6aa6d532f2c01d$var$SectionContext);
    const hasSubSections = (0, $6fFrj.useMemo)(()=>!!SubSections?.length, [
        SubSections
    ]);
    const isConditionalEditable = (0, $6fFrj.useMemo)(()=>Conditionals && Conditionals.length, [
        Conditionals
    ]);
    const hasSubsectionsWithQuestions = (0, $6fFrj.useMemo)(()=>SubSections.some((ss)=>ss.Questions.length), [
        SubSections
    ]);
    const newSectionContextValue = (0, $6fFrj.useMemo)(()=>({
            level: currentSectionContextValue ? currentSectionContextValue.level + 1 : 1
        }), [
        currentSectionContextValue
    ]);
    const handleQuestionDragEnd = (target, sectionIndex)=>{
        onQuestionDragEnd(target, sectionIndex);
    };
    const handleSectionDragEnd = (target)=>{
        onSectionDragEnd(target);
    };
    const handleAddConditionalClick = (event)=>{
        event.stopPropagation();
        onAddConditionalClick({
            id: id,
            parentId: parentId,
            Questions: Questions,
            temporalId: temporalId,
            SubSections: SubSections,
            order: index,
            temporalParentId: temporalParentId,
            name: sectionName,
            isSpecial: disabled
        }, index);
    };
    const onDeleteSectionClick = (0, $6fFrj.useCallback)((event)=>{
        event.stopPropagation();
        if (!event.currentTarget.id) onDeleteSection(index);
    }, [
        id,
        temporalId,
        index,
        SubSections
    ]);
    const sectionExtra = (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            id && id.length && !disabled && (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                title: !isConditionalEditable ? 'Add card to this section' : 'Update card',
                children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    type: "primary",
                    icon: !isConditionalEditable ? (0, $bb3TF.jsx)($5c6aa6d532f2c01d$var$PlusCircleOutlined, {}) : (0, $bb3TF.jsx)($5c6aa6d532f2c01d$var$EditOutlined, {}),
                    onClick: handleAddConditionalClick
                })
            }),
            (0, $bb3TF.jsx)((0, $a361442371f1d4e9$export$2e2bcd8739ae039), {
                okText: "Yes",
                cancelText: "No",
                placement: "topRight",
                okButtonProps: {
                    danger: true
                },
                onConfirm: onDeleteSectionClick,
                onCancel: (ev)=>{
                    ev.stopPropagation();
                },
                cancelButtonProps: {
                    type: 'default'
                },
                title: "Are you sure you want to delete this?",
                children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                    title: "Delete Section",
                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        id: `delete-section-${id ?? temporalId}`,
                        className: $0bf2660859f1ee8e$export$62da7bced551921f,
                        danger: true,
                        type: "primary",
                        icon: (0, $bb3TF.jsx)($5c6aa6d532f2c01d$var$DeleteOutlined, {}),
                        onClick: onDeleteSectionClick
                    })
                })
            })
        ]
    });
    const handleQuestionChange = (0, $6fFrj.useCallback)(({ id: targetId, temporalId: targetTemporalId }, changes)=>{
        onQuestionsChange(Questions.map((question)=>{
            if (question.id && targetId && !targetTemporalId && !question.temporalId && question.id === targetId || question.temporalId && targetTemporalId && !question.id && !targetId && question.temporalId === targetTemporalId) {
                const { ...questionChanges } = changes;
                return {
                    ...question,
                    ...questionChanges,
                    ...question.id ? {
                        operation: 'update'
                    } : {}
                };
            }
            return question;
        }));
    }, [
        Questions
    ]);
    const onAddSubSectionClick = (0, $6fFrj.useCallback)(({ id: targetId, temporalId: targetTemporalId })=>{
        onSubSectionsChange([
            ...SubSections ?? [],
            {
                ...$5c6aa6d532f2c01d$export$65be24a7a22eebd8,
                name: interviewLanguage.lang === 'EN' ? (0, $d5d0cbad803b1256$export$b20afe9c0a773016) : (0, $d5d0cbad803b1256$export$6bd8e2916751b902),
                operation: 'create',
                order: SubSections.length,
                temporalId: (0, $d9fa1eeee74e23fa$export$2e2bcd8739ae039)(),
                ...targetId && !targetTemporalId ? {
                    parentId: targetId
                } : {
                    temporalParentId: targetTemporalId
                },
                Questions: $5c6aa6d532f2c01d$export$65be24a7a22eebd8.Questions.map((question)=>({
                        ...question,
                        label: interviewLanguage.lang === 'EN' ? (0, $d5d0cbad803b1256$export$9e4889a9bd19f0b4) : (0, $d5d0cbad803b1256$export$597ec1fd6bdff88),
                        order: 0,
                        operation: 'create',
                        temporalId: (0, $d9fa1eeee74e23fa$export$2e2bcd8739ae039)(),
                        ...targetId && !targetTemporalId ? {
                            sectionId: targetId
                        } : {
                            temporalSectionId: targetTemporalId
                        }
                    }))
            }
        ]);
    }, [
        SubSections
    ]);
    const onAddQuestionFieldClick = (0, $6fFrj.useCallback)(({ id: targetId, temporalId: targetTemporalId })=>{
        onQuestionsChange([
            ...Questions,
            {
                ...$5c6aa6d532f2c01d$var$INITIAL_QUESTION,
                label: interviewLanguage.lang === 'EN' ? (0, $d5d0cbad803b1256$export$9e4889a9bd19f0b4) : (0, $d5d0cbad803b1256$export$597ec1fd6bdff88),
                temporalId: (0, $d9fa1eeee74e23fa$export$2e2bcd8739ae039)(),
                operation: 'create',
                order: Questions.length,
                ...targetId && !targetTemporalId ? {
                    sectionId: targetId
                } : {
                    temporalSectionId: targetTemporalId
                }
            }
        ]);
    }, [
        Questions
    ]);
    const onDeleteQuestionFieldClick = (questionIndex)=>{
        const currentQuestions = [
            ...Questions
        ];
        const currentQuestionToDelete = currentQuestions[questionIndex];
        if (currentQuestionToDelete.id) currentQuestions[questionIndex] = {
            ...currentQuestionToDelete,
            operation: 'delete',
            Options: currentQuestionToDelete.Options?.map((option)=>({
                    ...option,
                    operation: 'delete'
                })) ?? []
        };
        else currentQuestions.splice(questionIndex, 1);
        onQuestionsChange(currentQuestions);
    };
    const onSectionNameChangeHandler = (event)=>{
        setNameValue(event.target.value);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (firstRender.current) firstRender.current = false;
        else setNameValue(sectionName);
    }, [
        sectionName
    ]);
    (0, $ad3306746e490c84$export$2e2bcd8739ae039)(()=>{
        if (firstRender.current) firstRender.current = false;
        else onSectionNameChange(nameValue);
    }, 500, [
        nameValue
    ]);
    return (0, $bb3TF.jsxs)("div", {
        className: $0bf2660859f1ee8e$export$9fa75baca6b6ebc0,
        children: [
            (0, $bb3TF.jsx)((0, $f15d8985db3837b0$export$2e2bcd8739ae039), {
                // style={isDragging ? { visibility: 'visible' } : null}
                className: $0bf2660859f1ee8e$export$e536286417c9d629
            }),
            (0, $bb3TF.jsx)((0, $45def89f679453ce$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsxs)((0, $45def89f679453ce$export$2e2bcd8739ae039).Panel, {
                    header: !disabled ? (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                        value: nameValue,
                        className: $0bf2660859f1ee8e$export$4f27a36f18d465b8,
                        onChange: onSectionNameChangeHandler,
                        onClick: (e)=>{
                            e.stopPropagation();
                        }
                    }) : sectionName,
                    extra: sectionExtra,
                    children: [
                        disabled && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            showIcon: true,
                            type: "info",
                            message: "Hey!",
                            className: $0bf2660859f1ee8e$export$5e73d8be3ea76146,
                            description: "This is a pre-built section, and the content cannot be customized. You can delete it if you like."
                        }),
                        (0, $bb3TF.jsxs)("div", {
                            children: [
                                Questions?.length ? Questions.map(({ type: type, label: label, Options: Options, required: required, sectionId: sectionId, id: questionId, temporalSectionId: temporalSectionId, temporalId: questionTemporalId }, questionIndex)=>{
                                    const handleInterviewFieldDelete = ()=>{
                                        onDeleteQuestionFieldClick(questionIndex);
                                    };
                                    const handleInterviewFieldChange = (changes)=>{
                                        handleQuestionChange({
                                            sectionId: id,
                                            id: questionId ?? '',
                                            temporalId: questionTemporalId
                                        }, changes);
                                    };
                                    const handleOptionsChange = (newOptions)=>{
                                        const currentQuestions = [
                                            ...Questions
                                        ];
                                        currentQuestions[questionIndex].Options = newOptions;
                                        onQuestionsChange(currentQuestions);
                                    };
                                    return (0, $bb3TF.jsxs)("div", {
                                        className: $0bf2660859f1ee8e$export$4f6efa6c6158c27,
                                        children: [
                                            (0, $bb3TF.jsx)((0, $f15d8985db3837b0$export$2e2bcd8739ae039), {
                                                className: $0bf2660859f1ee8e$export$e536286417c9d629
                                            }),
                                            (0, $bb3TF.jsx)((0, $1b7b7b26dc2d1612$export$2e2bcd8739ae039), {
                                                type: type,
                                                label: label,
                                                id: questionId,
                                                disabled: disabled,
                                                required: required,
                                                Options: Options ?? [],
                                                temporalId: questionTemporalId,
                                                onOptionsChange: handleOptionsChange,
                                                onDelete: handleInterviewFieldDelete,
                                                onFieldChange: handleInterviewFieldChange
                                            })
                                        ]
                                    }, questionId ?? questionTemporalId);
                                }) : !hasSubsectionsWithQuestions && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                                    showIcon: true,
                                    message: "Hey!",
                                    type: "warning",
                                    className: $0bf2660859f1ee8e$export$5e73d8be3ea76146,
                                    description: "A Section should contain at least one question"
                                }),
                                hasSubSections && (0, $bb3TF.jsx)("section", {
                                    className: $0bf2660859f1ee8e$export$7aaed169f2f99da,
                                    children: (0, $bb3TF.jsx)($5c6aa6d532f2c01d$var$SectionContext.Provider, {
                                        value: newSectionContextValue,
                                        children: SubSections.map(({ name: name, id: subSectionId, SubSections: Sub, parentId: subParentId, Questions: SubQuestions, temporalId: temporalSubId, Conditionals: SubConditionals, temporalParentId: subTemporalParentId }, subIndex)=>{
                                            const handleSubSectionSubSectionsChange = (newSubSections)=>{
                                                const currentSubSections = [
                                                    ...SubSections
                                                ];
                                                currentSubSections[subIndex].SubSections = newSubSections;
                                                currentSubSections[subIndex].operation = currentSubSections[subIndex].operation || 'update';
                                                onSubSectionsChange(currentSubSections);
                                            };
                                            const handleSubSectionQuestionsChange = (newQuestions)=>{
                                                const currentSubSections = [
                                                    ...SubSections
                                                ];
                                                currentSubSections[subIndex].Questions = newQuestions;
                                                currentSubSections[subIndex].operation = currentSubSections[subIndex].operation || 'update';
                                                onSubSectionsChange(currentSubSections);
                                            };
                                            const handleSubSectionDelete = (subIndexTarget)=>{
                                                const currentSubSections = [
                                                    ...SubSections
                                                ];
                                                const mapDeletesCascade = (section)=>({
                                                        ...section,
                                                        operation: 'delete',
                                                        Questions: section.Questions.map((question)=>({
                                                                ...question,
                                                                operation: 'delete',
                                                                Options: question.Options?.map((option)=>({
                                                                        ...option,
                                                                        operation: 'delete'
                                                                    })) ?? []
                                                            })),
                                                        SubSections: section.SubSections?.map((subSection)=>mapDeletesCascade(subSection)) ?? []
                                                    });
                                                if (currentSubSections[subIndexTarget].id) currentSubSections[subIndexTarget] = mapDeletesCascade(currentSubSections[subIndexTarget]);
                                                else currentSubSections.splice(subIndexTarget, 1);
                                                onSubSectionsChange(currentSubSections);
                                            };
                                            const handleSubSectionNameChange = (newName)=>{
                                                const currentSubSections = [
                                                    ...SubSections
                                                ];
                                                if (currentSubSections[subIndex].id) currentSubSections[subIndex].operation = 'update';
                                                currentSubSections[subIndex].name = newName;
                                                onSubSectionsChange(currentSubSections);
                                            };
                                            const handleSubSectionAddConditionalClick = (section)=>{
                                                onAddConditionalClick(section, subIndex);
                                            };
                                            return (0, $bb3TF.jsx)($5c6aa6d532f2c01d$var$InterviewSection, {
                                                index: subIndex,
                                                id: subSectionId,
                                                sectionName: name,
                                                parentId: subParentId,
                                                SubSections: Sub ?? [],
                                                Questions: SubQuestions,
                                                temporalId: temporalSubId,
                                                Conditionals: SubConditionals,
                                                temporalParentId: subTemporalParentId,
                                                onSectionDragEnd: handleSectionDragEnd,
                                                onDeleteSection: handleSubSectionDelete,
                                                onQuestionDragEnd: handleQuestionDragEnd,
                                                onSectionNameChange: handleSubSectionNameChange,
                                                onQuestionsChange: handleSubSectionQuestionsChange,
                                                onSubSectionsChange: handleSubSectionSubSectionsChange,
                                                onAddConditionalClick: handleSubSectionAddConditionalClick,
                                                interviewLanguage: interviewLanguage
                                            }, `interview-section-${subSectionId ?? temporalSubId}`);
                                        })
                                    })
                                }),
                                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    gutter: [
                                        5,
                                        0
                                    ],
                                    children: [
                                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                            children: (0, $bb3TF.jsxs)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                type: "default",
                                                onClick: (event)=>{
                                                    event.stopPropagation();
                                                    onAddQuestionFieldClick({
                                                        id: id,
                                                        temporalId: temporalId,
                                                        parentId: parentId,
                                                        temporalParentId: temporalParentId
                                                    });
                                                },
                                                children: [
                                                    (0, $bb3TF.jsx)($5c6aa6d532f2c01d$var$PlusCircleFilled, {}),
                                                    "Add Question"
                                                ]
                                            })
                                        }),
                                        currentSectionContextValue?.level !== $5c6aa6d532f2c01d$var$SUBSECTION_DEEP_LEVEL_LIMIT && (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                            children: (0, $bb3TF.jsxs)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                type: "default",
                                                onClick: ()=>onAddSubSectionClick({
                                                        id: id,
                                                        parentId: parentId,
                                                        temporalId: temporalId,
                                                        temporalParentId: temporalParentId
                                                    }),
                                                children: [
                                                    (0, $bb3TF.jsx)($5c6aa6d532f2c01d$var$PlusCircleFilled, {}),
                                                    "Add Subsection"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, `panel-${id ?? temporalId}`)
            })
        ]
    }, id ?? temporalId);
};
$5c6aa6d532f2c01d$var$InterviewSection.defaultProps = {
    id: null,
    parentId: null,
    disabled: false,
    temporalId: null,
    temporalParentId: null
};
var $5c6aa6d532f2c01d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).memo($5c6aa6d532f2c01d$var$InterviewSection);


const $c7d2533192511968$var$InterviewSectionList = ({ sections: sections, onAddConditional: onAddConditional, onSectionsChange: onSectionsChange, interviewLanguage: interviewLanguage })=>{
    const firstRender = (0, $6fFrj.useRef)(true);
    const [data, setData] = (0, $6fFrj.useState)(sections);
    const onSectionsChangeRef = (0, $6fFrj.useRef)();
    onSectionsChangeRef.current = onSectionsChange;
    const swapArrayElementPosition = (arr, fromIndex, toIndex)=>{
        if (arr.length === 1) return arr;
        const element = arr.splice(fromIndex, 1)[0];
        arr.splice(toIndex, 0, element);
        return arr;
    };
    const moveListItem = (0, $6fFrj.useCallback)((dragIndex, hoverIndex)=>{
        setData((prevData)=>{
            const updatedData = swapArrayElementPosition(prevData, dragIndex, hoverIndex);
            return updatedData;
        });
    }, [
        data
    ]);
    const onDragEndHandler = ({ dragIndex: dragIndex, hoverIndex: hoverIndex })=>{
        moveListItem(dragIndex, hoverIndex);
    };
    const onQuestionDragEndHandler = ({ dragIndex: dragIndex, hoverIndex: hoverIndex }, sectionIndex)=>{
        setData(data.map((section, secIndex)=>sectionIndex === secIndex ? {
                ...section,
                Questions: swapArrayElementPosition(section.Questions, dragIndex, hoverIndex)
            } : section));
    };
    (0, $6fFrj.useEffect)(()=>{
        if (firstRender.current) firstRender.current = false;
        else setData(sections);
    }, [
        sections
    ]);
    return (0, $bb3TF.jsx)((0, $bb3TF.Fragment), {
        children: data.map(({ id: id, name: name, Conditionals: Conditionals, Questions: Questions, SubSections: SubSections, temporalId: temporalId, parentId: parentId, temporalParentId: temporalParentId, isSpecial: isSpecial }, index)=>{
            const handleSubSectionsChange = (newSubSections)=>{
                const currentData = [
                    ...data
                ];
                currentData[index].SubSections = newSubSections;
                currentData[index].operation = currentData[index].operation || 'update';
                setData(currentData);
                onSectionsChangeRef.current(currentData);
            };
            const handleQuestionsChange = (newQuestions)=>{
                const currentData = [
                    ...data
                ];
                currentData[index].Questions = newQuestions;
                currentData[index].operation = currentData[index].operation || 'update';
                onSectionsChangeRef.current(currentData);
                setData(currentData);
            };
            const handleDeleteSection = (indexTarget)=>{
                const mapDeletesCascade = (section)=>({
                        ...section,
                        operation: 'delete',
                        Questions: section.Questions.map((question)=>({
                                ...question,
                                operation: 'delete',
                                Options: question.Options?.map((option)=>({
                                        ...option,
                                        operation: 'delete'
                                    })) ?? []
                            })),
                        SubSections: section.SubSections?.map((subSection)=>mapDeletesCascade(subSection)) ?? []
                    });
                setData((prevData)=>{
                    const newData = [
                        ...prevData
                    ];
                    if (newData[indexTarget].id) newData[indexTarget] = mapDeletesCascade(newData[indexTarget]);
                    else newData.splice(indexTarget, 1);
                    onSectionsChangeRef.current(newData);
                    return newData;
                });
            };
            const handleSectionNameChange = (newName)=>{
                const currentData = [
                    ...data
                ];
                currentData[index].name = newName;
                if (currentData[index].id && !currentData[index].operation) currentData[index].operation = 'update';
                onSectionsChangeRef.current(currentData);
                setData(currentData);
            };
            const handleAddConditionalClick = (section)=>{
                onAddConditional(section, index);
            };
            return (0, $bb3TF.jsx)((0, $5c6aa6d532f2c01d$export$2e2bcd8739ae039), {
                id: id,
                index: index,
                sectionName: name,
                parentId: parentId,
                Questions: Questions,
                disabled: !!isSpecial,
                temporalId: temporalId,
                Conditionals: Conditionals,
                SubSections: SubSections ?? [],
                temporalParentId: temporalParentId,
                onSectionDragEnd: onDragEndHandler,
                onDeleteSection: handleDeleteSection,
                onQuestionsChange: handleQuestionsChange,
                onQuestionDragEnd: onQuestionDragEndHandler,
                onSectionNameChange: handleSectionNameChange,
                onSubSectionsChange: handleSubSectionsChange,
                onAddConditionalClick: handleAddConditionalClick,
                interviewLanguage: interviewLanguage
            }, id ?? temporalId);
        })
    });
};
var $c7d2533192511968$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).memo($c7d2533192511968$var$InterviewSectionList);



const $d5d0cbad803b1256$export$3c72a4a641564d92 = "\u2757TRANSLATION REQUIRED - ADD IT HERE\u2757";
const $d5d0cbad803b1256$export$6bd8e2916751b902 = 'ENTER YOUR SECTION NAME HERE';
const $d5d0cbad803b1256$export$b20afe9c0a773016 = `${$d5d0cbad803b1256$export$6bd8e2916751b902} - \u{2757}SWITCH TO SPANISH ABOVE TO ADD TRANSLATION\u{2757}`;
const $d5d0cbad803b1256$export$597ec1fd6bdff88 = 'ENTER YOUR QUESTION HERE';
const $d5d0cbad803b1256$export$9e4889a9bd19f0b4 = `${$d5d0cbad803b1256$export$597ec1fd6bdff88} - \u{2757}SWITCH TO SPANISH ABOVE TO ADD TRANSLATION\u{2757}`;
const $d5d0cbad803b1256$export$5a6f0bf2ccb8ba3e = 'ENTER YOUR OPTION HERE';
const $d5d0cbad803b1256$export$3369bf9506258508 = `${$d5d0cbad803b1256$export$5a6f0bf2ccb8ba3e} - \u{2757}SWITCH TO SPANISH ABOVE TO ADD TRANSLATION\u{2757}`;
const $d5d0cbad803b1256$var$useInterviews = ()=>{
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const initialRender = (0, $6fFrj.useRef)(true);
    const interviews = (0, $58073eff19365823$export$a7347740d65f620b)((0, $af02328711f8c5fd$export$c0faa43928530039));
    // * currentLanguage is the language of the user in session
    const currentLanguage = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$20b36ebcfeb0a091));
    const currentInterview = (0, $58073eff19365823$export$a7347740d65f620b)((0, $af02328711f8c5fd$export$7708ce48455f25ad));
    const [hasTranslations, setHasTranslations] = (0, $6fFrj.useState)(true);
    const currentInterviewData = (0, $58073eff19365823$export$a7347740d65f620b)((0, $af02328711f8c5fd$export$a4d45c787b899913));
    const [interviewLanguage, setInterviewLanguage] = (0, $6fFrj.useState)({
        id: currentLanguage.id,
        lang: currentLanguage.lang,
        description: currentLanguage?.description ?? ''
    });
    const { languages: languages } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$ca779d385d6ad982));
    const [interviewLanguageId, setInterviewLanguageId] = (0, $6fFrj.useState)('');
    const [selectedInterviewKey, setSelectedInterviewKey] = (0, $6fFrj.useState)('');
    const [getinterviewNames, { loading: getInterviewsLoading }] = (0, $774cc9a1c383b6aa$export$2d8ec82bd3e5a3ff)();
    const [getInterviewById, { loading: loadingInterviewById }] = (0, $774cc9a1c383b6aa$export$ccb3623d5ceb2c34)();
    const [interviewName, setInterviewName] = (0, $6fFrj.useState)(currentInterview?.name ?? '');
    const [createConditionals, { loading: createConditionalLoading }] = (0, $f74b63f5d3b4edd3$export$f2918fa6ee7289c3)();
    const [updateConditionals, { loading: updateConditionalLoading }] = (0, $f74b63f5d3b4edd3$export$2d0f72520537e036)();
    const [currentSectionToConditionId, setCurrentSectionToConditionId] = (0, $6fFrj.useState)('');
    const [isConditionalModalVisible, setIsConditionalModalVisible] = (0, $6fFrj.useState)(false);
    const [currentConditionals, setCurrentConditionals] = (0, $6fFrj.useState)([]);
    const [currentOptionsToCondition, setCurrentOptionsToCondition] = (0, $6fFrj.useState)([]);
    const [createInterview, { loading: createInterviewLoading }] = (0, $424f41c1a1283b75$export$9578d2ea45102e7f)();
    const [updateInterview, { loading: updateInterviewLoading }] = (0, $424f41c1a1283b75$export$1702b67be0d9481e)();
    const [deleteInterview, { loading: deleteInterviewLoading }] = (0, $424f41c1a1283b75$export$dd1ee8b0fe2427cd)();
    const [copyInterview, { loading: copyInterviewLoading }] = (0, $424f41c1a1283b75$export$94f4f245cab153e5)();
    const [createSpecialSection, { loading: createSpecialSectionLoading }] = (0, $424f41c1a1283b75$export$dcc800819d215788)();
    const { showModal: showModal, accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    const [updateInterviewState, { loading: loadingUpdateInterviewState }] = (0, $424f41c1a1283b75$export$8467f1ec132fab8e)();
    const [currentSectionIsSubsection, setCurrentSectionIsSubsection] = (0, $6fFrj.useState)(false);
    const [saveConditionalQuestion, { loading: loadingSaveConditionalQuestion }] = (0, $f74b63f5d3b4edd3$export$5a7437969dd0f429)();
    const [deleteConditional, { loading: loadingDeleteConditional }] = (0, $f74b63f5d3b4edd3$export$36d5181b6e4d89da)();
    /*
      * Since in this component we use a different types than the UI components,
      * it is necessary to map the sections recursively in this way:  InterviewSection => Section.
  
      * types:
        * - InterviewSection (Type for store in redux)
        * - Section (Type for UI components)
    */ const transformSectionsFromStoreToUi = (Sections)=>Sections.map(({ Questions: Questions, SubSections: SubSections, Translations: Translations, ...restSection })=>{
            const description = Translations.find(({ Language: Language })=>Language.id === interviewLanguageId)?.description || `${$d5d0cbad803b1256$export$3c72a4a641564d92} ${Translations.find((t)=>t?.description)?.description || ''}`;
            const mappedQuestions = Questions.map(({ Options: Options, Translations: QuestionTranslations, ...question })=>{
                const questionDescription = QuestionTranslations?.find(({ Language: Language })=>Language.id === interviewLanguageId)?.description || `${$d5d0cbad803b1256$export$3c72a4a641564d92} ${QuestionTranslations.find((t)=>t.description)?.description || ''}`;
                const mappedOptions = Options?.map(({ id: id, temporalId: temporalId, operation: operation, Translations: OptionTranslations })=>{
                    const label = OptionTranslations.find(({ Language: Language })=>Language.id === interviewLanguageId)?.description || `${$d5d0cbad803b1256$export$3c72a4a641564d92} ${OptionTranslations.find((t)=>t?.description)?.description || ''}`;
                    return {
                        id: id,
                        label: label,
                        operation: operation,
                        temporalId: temporalId
                    };
                }) ?? [];
                return {
                    ...question,
                    Options: mappedOptions,
                    label: questionDescription
                };
            });
            return {
                ...restSection,
                name: description,
                Questions: mappedQuestions,
                SubSections: SubSections?.length ? transformSectionsFromStoreToUi(SubSections) : []
            };
        });
    // * This method map from UI type to store type when a sections is new.
    const mapNewSectionToStore = (currentSection, index)=>{
        const { lang: lang, id: languageId, description: description } = interviewLanguage;
        return {
            ...currentSection,
            order: index,
            interviewId: currentInterview.id,
            Translations: [
                {
                    description: currentSection.name,
                    Language: {
                        lang: lang,
                        description: description,
                        id: languageId
                    }
                }
            ],
            Questions: currentSection.Questions.map(({ label: label, Options: Options, ...question }, questionIndex)=>({
                    ...question,
                    sectionId: question.sectionId ?? question.temporalSectionId ?? '',
                    order: questionIndex,
                    Options: Options?.map(({ label: optionLabel, ...restOption })=>({
                            id: restOption.id,
                            temporalId: restOption.temporalId,
                            Translations: question.type === (0, $8f7fe33a44836803$export$51940fbbacba35d4).Dropdown || question.type === (0, $8f7fe33a44836803$export$51940fbbacba35d4).Radio ? [
                                {
                                    description: optionLabel,
                                    Language: {
                                        lang: lang,
                                        description: description,
                                        id: languageId
                                    }
                                }
                            ] : []
                        })) ?? [],
                    Translations: [
                        {
                            description: label ?? '',
                            Language: {
                                lang: lang,
                                description: description,
                                id: languageId
                            }
                        }
                    ]
                })),
            SubSections: currentSection.SubSections?.map((subSection, subIndex)=>mapNewSectionToStore(subSection, subIndex)) ?? []
        };
    };
    const getAllSections = (sections)=>sections?.map(({ SubSections: SubSections, ...restSection })=>[
                {
                    ...restSection,
                    SubSections: SubSections
                },
                ...getAllSections(SubSections ?? [])
            ]).flatMap((element)=>element) ?? [];
    /*
      * Since in this component we use a different types than the UI components,
      * it is necessary to map the sections recursively in this way: Section => InterviewSection.
  
      * types:
        * - Section (Type for UI components)
        * - InterviewSection (Type for store in redux)
    */ const transformSectionsFromUiToStore = (Sections)=>Sections.map((section, sectionIndex)=>{
            const selectedLanguage = languages.find((language)=>language.id === interviewLanguageId);
            const { lang: lang, id: languageId, description: description } = selectedLanguage;
            const { name: name, Questions: Questions, SubSections: SubSections, operation: operation, ...restSection } = section;
            const currentSectionData = getAllSections(currentInterviewData.Sections ?? []).find(({ id: id, temporalId: temporalId })=>id && id === section.id || temporalId && temporalId === section.temporalId) ?? mapNewSectionToStore(section, sectionIndex);
            // * This is to pick all the questions without filtering by operation === 'delete'
            const { Questions: questionsFiltered, SubSections: filteredSubSections } = {
                SubSections: [
                    ...currentSectionData.SubSections
                ].filter(({ operation: subsectionOperation })=>subsectionOperation && subsectionOperation === 'delete'),
                Questions: [
                    ...currentSectionData.Questions
                ].filter(({ operation: questionOperation })=>questionOperation && questionOperation === 'delete')
            };
            return {
                ...restSection,
                operation: operation,
                order: sectionIndex,
                interviewId: currentInterview.id,
                Conditionals: currentSectionData.Conditionals,
                Questions: [
                    ...Questions.map(({ label: label, Options: Options, operation: questionOperation, ...question }, questionIndex)=>{
                        const currentQuestion = currentSectionData.Questions.find((q)=>q.id === question.id);
                        return {
                            ...question,
                            operation: questionOperation ?? currentQuestion.operation,
                            Options: (question.type === (0, $8f7fe33a44836803$export$51940fbbacba35d4).Radio || question.type === (0, $8f7fe33a44836803$export$51940fbbacba35d4).Dropdown) && Options && Options.length ? [
                                ...Options.map((option)=>{
                                    const filteredOptionTranslations = currentQuestion.Options.find(({ id: id, temporalId: temporalId })=>id && id === option.id || temporalId && temporalId === option.temporalId)?.Translations?.filter(({ optionId: optionId, operation: translationOperation })=>translationOperation === 'delete' && optionId && optionId === option.id) ?? [];
                                    const noFilteredOptionTranslations = currentQuestion.Options.find(({ id: id, temporalId: temporalId })=>id && id === option.id || temporalId && temporalId === option.temporalId)?.Translations?.filter(({ operation: translationOperation })=>translationOperation !== 'delete').map((translation)=>{
                                        if (translation.Language.id === languageId) return {
                                            ...translation,
                                            description: option.label ?? '',
                                            optionId: option.id ?? option.temporalId,
                                            operation: translation.operation ?? option.operation
                                        };
                                        return translation;
                                    }) ?? [
                                        {
                                            description: option.label,
                                            operation: option.operation,
                                            optionId: option.id ?? option.temporalId,
                                            Language: {
                                                lang: lang,
                                                id: languageId,
                                                description: description ?? ''
                                            }
                                        }
                                    ];
                                    return {
                                        id: option.id ?? currentQuestion.Options.find(({ id: id })=>id === option.id)?.id,
                                        questionId: option.questionId ?? currentQuestion.id ?? currentQuestion.temporalId,
                                        operation: option.operation ?? currentQuestion.Options.find(({ id: id })=>id && id === option.id)?.operation,
                                        temporalId: option.temporalId,
                                        Translations: [
                                            ...noFilteredOptionTranslations,
                                            ...filteredOptionTranslations
                                        ]
                                    };
                                }),
                                ...currentQuestion.Options?.filter(({ operation: optionOperation })=>optionOperation && optionOperation === 'delete') ?? []
                            ] : [],
                            sectionId: section.id ?? section.temporalId ?? '',
                            order: questionIndex,
                            Translations: currentQuestion?.Translations?.length ? currentQuestion.Translations.map((translation)=>{
                                if (translation.Language.id === interviewLanguageId) return {
                                    ...translation,
                                    description: label,
                                    operation: translation.operation ?? questionOperation
                                };
                                return translation;
                            }) : [
                                {
                                    questionId: question.id ?? question.temporalId ?? '',
                                    description: label.length ? label : '',
                                    Language: {
                                        lang: lang,
                                        id: languageId,
                                        description: description ?? ''
                                    }
                                }
                            ]
                        };
                    }),
                    ...questionsFiltered
                ].sort(({ order: order }, { order: orderB })=>order - orderB),
                SubSections: [
                    ...transformSectionsFromUiToStore(SubSections ?? []),
                    ...filteredSubSections ?? []
                ],
                Translations: currentSectionData && currentSectionData.Translations && currentSectionData.Translations.length ? currentSectionData.Translations.map((translation)=>{
                    if (translation.Language.id === interviewLanguageId) return {
                        ...translation,
                        description: name,
                        operation: translation.operation ?? operation
                    };
                    return translation;
                }) : [
                    {
                        description: name,
                        sectionId: restSection.id,
                        Language: {
                            id: currentLanguage.id,
                            lang: currentLanguage.lang,
                            description: currentLanguage?.description
                        }
                    }
                ]
            };
        });
    // eslint-disable-next-line max-len
    // * This functionality is for transform the type from the Graphql output to the UI type that we need
    const mapSectionsToStore = (sections)=>sections.map(({ id: id, order: order, parentId: parentId, Questions: Questions, isSpecial: isSpecial, interviewId: interviewId, SubSections: SubSections, Translations: Translations, Conditionals: Conditionals })=>({
                id: id,
                order: order,
                parentId: parentId,
                isSpecial: isSpecial,
                interviewId: interviewId,
                Conditionals: Conditionals,
                Questions: Questions.map(({ type: type, Options: Options, required: required, sectionId: sectionId, id: questionId, order: questionOrder, Translations: QuestionTranslations })=>({
                        type: type,
                        Options: Options.map(({ id: optionId, Translations: OptionTranslations })=>({
                                questionId: questionId,
                                id: optionId,
                                Translations: OptionTranslations.map(({ id: optionTranslationId, description: description, Language: Language, languageId: languageId })=>({
                                        id: optionTranslationId,
                                        optionId: optionId,
                                        languageId: languageId,
                                        description: description,
                                        Language: {
                                            id: Language?.id,
                                            lang: Language?.lang,
                                            description: Language?.description
                                        }
                                    }))
                            })),
                        required: required,
                        sectionId: sectionId,
                        id: questionId,
                        order: questionOrder,
                        Translations: QuestionTranslations.map(({ Language: Language, languageId: languageId, description: description, id: translationId, questionId: translationQuestionId })=>({
                                languageId: languageId,
                                description: description,
                                id: translationId,
                                questionId: translationQuestionId,
                                Language: {
                                    id: Language.id,
                                    lang: Language.lang,
                                    description: Language?.description ?? ''
                                }
                            }))
                    })),
                Translations: Translations.map(({ id: translationId, sectionId: translationSectionId, description: description, Language: Language, languageId: languageId })=>({
                        languageId: languageId,
                        description: description,
                        id: translationId,
                        sectionId: translationSectionId,
                        Language: {
                            id: Language.id,
                            lang: Language.lang,
                            description: Language?.description ?? ''
                        }
                    })),
                SubSections: mapSectionsToStore(SubSections ?? [])
            }));
    // * Map the getInterviews query result as expected in the interviews slice
    const mapInterviewsToStore = (interviewList)=>interviewList.map(({ id: id, name: name, isLive: isLive, Sections: Sections, isTemplate: isTemplate })=>({
                id: id,
                name: name,
                isLive: isLive,
                isTemplate: isTemplate,
                Sections: mapSectionsToStore(Sections)
            }));
    const handleInterviewLanguageChange = (languageId)=>{
        setInterviewLanguageId(languageId);
    };
    const onInterviewNameChange = (event)=>{
        setInterviewName(event.target.value);
        dispatch((0, $af02328711f8c5fd$export$7cde7a299bfe1e43)({
            operation: 'update'
        }));
    };
    const onAddSectionClick = ()=>{
        const sectionId = (0, $d9fa1eeee74e23fa$export$2e2bcd8739ae039)();
        const questionId = (0, $d9fa1eeee74e23fa$export$2e2bcd8739ae039)();
        const selectedLanguage = languages.find((language)=>language.id === interviewLanguageId);
        const { id: languageId, lang: lang, description: description } = selectedLanguage;
        const newSection = {
            isSpecial: false,
            temporalId: (0, $d9fa1eeee74e23fa$export$2e2bcd8739ae039)(),
            operation: 'create',
            interviewId: currentInterview.id,
            order: currentInterview.Sections.length,
            Translations: [
                {
                    sectionId: sectionId,
                    description: lang === 'EN' ? $d5d0cbad803b1256$export$b20afe9c0a773016 : $d5d0cbad803b1256$export$6bd8e2916751b902,
                    operation: 'create',
                    Language: {
                        lang: lang,
                        id: languageId,
                        description: description ?? ''
                    }
                }
            ],
            Questions: [
                {
                    order: 0,
                    sectionId: sectionId,
                    required: true,
                    operation: 'create',
                    temporalId: questionId,
                    type: (0, $8f7fe33a44836803$export$51940fbbacba35d4).Text,
                    Translations: [
                        {
                            questionId: questionId,
                            description: lang === 'EN' ? $d5d0cbad803b1256$export$9e4889a9bd19f0b4 : $d5d0cbad803b1256$export$597ec1fd6bdff88,
                            operation: 'create',
                            Language: {
                                lang: lang,
                                id: languageId,
                                description: description ?? ''
                            }
                        }
                    ]
                }
            ],
            SubSections: []
        };
        dispatch((0, $af02328711f8c5fd$export$7cde7a299bfe1e43)({
            Sections: [
                ...currentInterviewData.Sections,
                newSection
            ]
        }));
    };
    /*
     * This function checks if an array of translations already has the translation of the language
     * selected in the interview, if it already exists it returns the same
     * array and if not it creates its translation.
     */ const handleLanguageTranslations = (translations)=>{
        const alreadyHasTranslation = translations.some(({ Language: Language })=>Language.id === interviewLanguageId);
        if (alreadyHasTranslation) {
            if (translations.filter(({ Language: Language })=>Language.id === interviewLanguageId).some(({ description: description })=>!description.length || description.startsWith($d5d0cbad803b1256$export$3c72a4a641564d92))) setHasTranslations(false);
            else if (!hasTranslations) setHasTranslations(true);
            const currentLang = translations.find(({ Language: Language })=>Language.id === interviewLanguageId);
            if (currentLang.id !== interviewLanguage.id) setInterviewLanguage(currentLang.Language);
            return translations;
        }
        const selectedLanguage = languages.find((language)=>language.id === interviewLanguageId);
        if (hasTranslations) setHasTranslations(false);
        const newTranslation = {
            operation: 'create',
            description: '',
            Language: {
                id: selectedLanguage.id,
                lang: selectedLanguage.lang,
                description: selectedLanguage?.description ?? ''
            }
        };
        return [
            ...translations,
            newTranslation
        ];
    };
    // * Map the sections array recursively with the usage of the handleLangueageTranslations method
    const mapSectionsTranslations = (sections)=>sections.map(({ Translations: Translations, Questions: Questions, SubSections: SubSections, ...section })=>({
                ...section,
                Translations: handleLanguageTranslations(Translations ?? []),
                Questions: Questions.map(({ Options: Options, Translations: QuestionTranslations, ...question })=>({
                        ...question,
                        Translations: handleLanguageTranslations(QuestionTranslations ?? []),
                        Options: Options?.map(({ Translations: OptionTranslations, ...option })=>({
                                ...option,
                                Translations: handleLanguageTranslations(OptionTranslations)
                            })) ?? []
                    })),
                SubSections: mapSectionsTranslations(SubSections ?? [])
            }));
    const loadInterviewByIdToStore = async (id)=>{
        if (!id) return;
        const currentInterviewResult = await getInterviewById({
            variables: {
                id: id
            }
        });
        const clickedInterviewData = currentInterviewResult?.data?.interview;
        if (clickedInterviewData) {
            const clickedInterview = {
                id: clickedInterviewData.id,
                name: clickedInterviewData.name,
                isLive: clickedInterviewData.isLive,
                isTemplate: clickedInterviewData.isTemplate,
                Sections: mapSectionsToStore(clickedInterviewData.Sections)
            };
            dispatch((0, $af02328711f8c5fd$export$7cde7a299bfe1e43)(clickedInterview));
            dispatch((0, $af02328711f8c5fd$export$51529446d9f71f44)(interviews.map((interview)=>{
                const { id: inerviewId } = interview;
                if (inerviewId === clickedInterview.id) return clickedInterview;
                return interview;
            })));
        }
    };
    const handleInterviewClick = async ({ key: key })=>{
        // console.log("interview click", key);
        if (currentInterview?.id && currentInterview?.id !== key) {
            if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).entityInterviews]) {
                showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).entityInterviews);
                return;
            }
        }
        await loadInterviewByIdToStore(key);
        setSelectedInterviewKey(key);
    /* if (currentInterview) {
          if ((currentInterview.id && currentInterview.id !== key)
          || (currentInterview.temporalId && currentInterview.temporalId !== key)) {
            setHasTranslations(true);
            dispatch((clearCurrentInterview()));
          }
    
          if (interviewLanguage.id !== currentLanguage.id) {
            const { id, lang, description } = currentLanguage;
            setInterviewLanguage({
              id,
              lang,
              description: description ?? '',
            });
          }
        } */ };
    /*
     * This functionality allows us to know if you have any element without
     * any translation (such as an empty string) through the 3 levels of depth that can
     * have a section
     */ const hasPendingTranslations = (sections)=>sections.reduce((acc, section)=>{
            const hasPendingSectionTranslations = section.Translations.filter(({ Language: Language })=>Language.id === interviewLanguageId).some(({ description: description })=>!description.length || description.startsWith($d5d0cbad803b1256$export$3c72a4a641564d92));
            const checkPendingQuestionTranslations = section.Questions.reduce((questionAcc, question)=>{
                const hasPendingQuestionTranslations = question.Translations.filter(({ Language: Language })=>Language.id === interviewLanguageId).some(({ description: description })=>!description.length || description.startsWith($d5d0cbad803b1256$export$3c72a4a641564d92));
                const checkPendingOptionTranslations = (options)=>{
                    if ((question.type === (0, $8f7fe33a44836803$export$51940fbbacba35d4).Radio || question.type === (0, $8f7fe33a44836803$export$51940fbbacba35d4).Dropdown) && options.length === 0) return {
                        [`hasPendingOptionTranslations-${question.temporalId ?? question.id}`]: true
                    };
                    if ((question.type === (0, $8f7fe33a44836803$export$51940fbbacba35d4).Radio || question.type === (0, $8f7fe33a44836803$export$51940fbbacba35d4).Dropdown) && options.length > 0) return options.reduce((optionAcc, option, optionIndex)=>{
                        const hasPendingOptionTranslations = option.Translations?.filter(({ Language: Language, operation: optionOperation })=>Language.id === interviewLanguageId && (!optionOperation || optionOperation !== 'delete')).some(({ description: description })=>!description.length || description.startsWith($d5d0cbad803b1256$export$3c72a4a641564d92)) ?? false;
                        return {
                            ...optionAcc,
                            [`hasPendingOptionTranslations-${option.temporalId ?? option.id ?? question.temporalId ?? question.id ?? optionIndex}`]: hasPendingOptionTranslations
                        };
                    }, {});
                    return null;
                };
                return {
                    ...questionAcc,
                    ...checkPendingOptionTranslations(question.Options ?? []) ?? {},
                    [`hasPendingQuestionTranslations-${question.temporalId ?? question.id}`]: hasPendingQuestionTranslations
                };
            }, {});
            return {
                ...acc,
                ...checkPendingQuestionTranslations,
                ...section.SubSections && section.SubSections.length ? hasPendingTranslations(section.SubSections) : {},
                [`hasPendingSectionTranslations-${section.temporalId ?? section.id}`]: hasPendingSectionTranslations
            };
        }, {});
    const onSectionsChangeHandler = (newSections)=>{
        const changes = transformSectionsFromUiToStore(newSections);
        const hasPendingLanguageTranslations = hasPendingTranslations(changes);
        if (Object.values(hasPendingLanguageTranslations).some((value)=>!!value)) setHasTranslations(false);
        else if (Object.values(hasPendingLanguageTranslations).every((value)=>!value)) setHasTranslations(true);
        dispatch((0, $af02328711f8c5fd$export$7cde7a299bfe1e43)({
            Sections: [
                ...currentInterviewData.Sections.filter(({ operation: operation })=>operation && operation === 'delete'),
                ...changes
            ]
        }));
    };
    const onAddConditionalHandler = (section, index)=>{
        const [{ id: sectionId, Conditionals: Conditionals }] = transformSectionsFromUiToStore([
            section
        ]);
        // * Get the parent section
        const { Questions: Questions } = getAllSections(currentInterview.Sections ?? []).find(({ id: id })=>id === section.parentId) ?? {
            Questions: []
        };
        const optionsToConditioning = Questions.filter(({ type: type, Options: Options })=>(type === (0, $8f7fe33a44836803$export$51940fbbacba35d4).Dropdown || type === (0, $8f7fe33a44836803$export$51940fbbacba35d4).Radio) && Options && Options.length).map(({ Options: Options })=>Options).flatMap((option)=>option).map(({ id: id, Translations: Translations })=>{
            const currentLabel = Translations.find(({ Language: Language })=>Language.id === interviewLanguageId)?.description;
            return {
                value: id,
                label: currentLabel
            };
        });
        setCurrentConditionals(Conditionals);
        setCurrentOptionsToCondition(optionsToConditioning);
        setCurrentSectionToConditionId(section.id);
        setCurrentSectionIsSubsection(Boolean(section.parentId));
        setIsConditionalModalVisible(true);
    };
    const handleConditionalOk = async (result)=>{
        if (!currentConditionals || !currentConditionals.length) {
            const newConditionals = (await createConditionals({
                variables: {
                    createConditionalsInput: result.selectedOptions.map(({ value: optionId })=>({
                            optionId: optionId,
                            sectionId: currentSectionToConditionId
                        }))
                }
            })).data?.createConditionals;
            if (newConditionals.length) {
                const refreshedInterview = (await getInterviewById({
                    variables: {
                        id: currentInterview.id
                    }
                })).data.interview;
                dispatch((0, $af02328711f8c5fd$export$7cde7a299bfe1e43)(refreshedInterview));
                dispatch((0, $af02328711f8c5fd$export$51529446d9f71f44)(interviews.map((interview)=>{
                    const { id: id } = interview;
                    if (id === refreshedInterview.id) return refreshedInterview;
                    return interview;
                })));
                setIsConditionalModalVisible(false);
                setCurrentOptionsToCondition([]);
                setCurrentSectionIsSubsection(false);
            }
        } else {
            const updates = currentConditionals.filter(({ id: id, optionId: optionId })=>{
                const currentOption = result.selectedOptions.find(({ value: value })=>value === optionId);
                return currentOption?.value.length;
            }).map(({ id: id, optionId: optionId })=>({
                    id: id,
                    optionId: optionId
                }));
            const creates = result.selectedOptions.filter(({ value: value, label: label })=>{
                const hasCondtional = currentConditionals.find(({ optionId: optionId })=>optionId === value);
                return !hasCondtional;
            }).map(({ value: value })=>({
                    optionId: value,
                    sectionId: currentSectionToConditionId
                }));
            let updateResult = [];
            let createResult = [];
            if (updates.length) {
                const updatedConditionals = (await updateConditionals({
                    variables: {
                        updateConditionalInput: updates
                    }
                })).data?.updateConditionals ?? [];
                if (updatedConditionals.length) updateResult = updatedConditionals;
            }
            if (creates.length) {
                const newConditionals = (await createConditionals({
                    variables: {
                        createConditionalsInput: creates
                    }
                })).data?.createConditionals ?? [];
                if (newConditionals.length) createResult = newConditionals;
            }
            if (!![
                ...updateResult,
                ...createResult
            ].length && currentInterview.id) {
                const refreshedInterview = (await getInterviewById({
                    variables: {
                        id: currentInterview.id
                    }
                })).data.interview;
                dispatch((0, $af02328711f8c5fd$export$7cde7a299bfe1e43)(refreshedInterview));
                dispatch((0, $af02328711f8c5fd$export$51529446d9f71f44)(interviews.map((interview)=>{
                    const { id: id } = interview;
                    if (id === refreshedInterview.id) return refreshedInterview;
                    return interview;
                })));
                setIsConditionalModalVisible(false);
                setCurrentOptionsToCondition([]);
                setCurrentSectionIsSubsection(false);
            }
        }
    };
    const handleConditionalOkCreateQuestion = async (data)=>{
        const toSave = {
            question: {
                order: 0,
                required: true,
                sectionId: currentSectionToConditionId,
                type: (0, $8f7fe33a44836803$export$51940fbbacba35d4).Radio,
                description: data.questionTitle
            },
            optionToEnable: 'yes',
            languageId: interviewLanguageId,
            questionId: data.questionId || null,
            picture: data.picture || null,
            hintText: data.hintText || null
        };
        console.log('toSave', toSave);
        await saveConditionalQuestion({
            variables: {
                saveConditionalQuestionInput: toSave
            },
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('The conditional was created successfully');
            },
            onError: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to create the conditional');
            }
        });
        setIsConditionalModalVisible(false);
        setCurrentOptionsToCondition([]);
        setCurrentSectionIsSubsection(false);
    };
    const handleConditionalCancel = ()=>{
        if (currentConditionals && currentConditionals.length) setCurrentConditionals([]);
        setCurrentOptionsToCondition([]);
        setCurrentSectionIsSubsection(false);
        setIsConditionalModalVisible(false);
    };
    const handleCreateInterviewClick = ()=>{
        if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).entityInterviews]) {
            showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).entityInterviews);
            return;
        }
        const temporalId = (0, $d9fa1eeee74e23fa$export$2e2bcd8739ae039)();
        const newInterview = {
            temporalId: temporalId,
            Sections: [],
            isLive: false,
            isTemplate: false,
            name: 'New Interview'
        };
        dispatch((0, $af02328711f8c5fd$export$51529446d9f71f44)([
            ...interviews,
            newInterview
        ]));
        if (currentInterview) {
            if (interviewLanguage.id !== currentLanguage.id) {
                const { id: id, lang: lang, description: description } = currentLanguage;
                setInterviewLanguage({
                    id: id,
                    lang: lang,
                    description: description ?? ''
                });
            }
            dispatch((0, $af02328711f8c5fd$export$752f0a70a89451c5)());
        }
        setSelectedInterviewKey(temporalId);
    };
    const onSaveChangesClick = async ()=>{
        const { id: id, temporalId: temporalId, name: name, isLive: isLive, isTemplate: isTemplate, Sections: Sections } = currentInterview;
        try {
            if (temporalId) {
                const getSectionsToCreate = (sections)=>sections.map(({ Questions: Questions, SubSections: SubSections, Translations: Translations, ...restSection })=>{
                        const { order: order } = restSection;
                        return {
                            order: order,
                            translations: Translations.map(({ description: description, Language: Language })=>{
                                const { id: languageId } = Language;
                                return {
                                    languageId: languageId,
                                    description: description
                                };
                            }),
                            questions: Questions.map(({ Translations: QuestionTranslations, Options: Options, required: required, order: questionOrder, type: type })=>({
                                    type: type,
                                    required: required,
                                    order: questionOrder,
                                    options: Options.map(({ Translations: OptionTranslations })=>({
                                            translations: OptionTranslations.map(({ description: description, Language: Language })=>({
                                                    description: description,
                                                    languageId: Language.id
                                                }))
                                        })),
                                    translations: QuestionTranslations.map(({ description: description, Language: Language })=>{
                                        const { id: languageId } = Language;
                                        return {
                                            languageId: languageId,
                                            description: description
                                        };
                                    })
                                })),
                            subSections: getSectionsToCreate(SubSections ?? [])
                        };
                    });
                const newInterview = (await createInterview({
                    variables: {
                        createInterviewInput: {
                            name: name,
                            isLive: isLive,
                            isTemplate: isTemplate,
                            sections: getSectionsToCreate(Sections)
                        }
                    }
                })).data.CreateInterview;
                if (newInterview.id) {
                    const { name: newName, id: interviewId, isLive: newIsLive, Sections: newSections, isTemplate: newIsTemplate } = newInterview;
                    dispatch((0, $af02328711f8c5fd$export$51529446d9f71f44)(interviews.map((interview)=>{
                        if (interview.temporalId && currentInterview.temporalId && interview.temporalId === currentInterview.temporalId) return {
                            name: newName,
                            id: interviewId,
                            temporalId: null,
                            isLive: newIsLive,
                            isTemplate: newIsTemplate,
                            Sections: mapSectionsToStore(newSections)
                        };
                        return interview;
                    })));
                    dispatch((0, $af02328711f8c5fd$export$7cde7a299bfe1e43)({
                        name: newName,
                        id: interviewId,
                        isLive: newIsLive,
                        isTemplate: newIsTemplate,
                        Sections: mapSectionsToStore(newSections)
                    }));
                    setSelectedInterviewKey(interviewId);
                    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('The Interview was created successfully');
                }
            } else if (id) {
                const { Sections: currentSections, temporalId: currentInterviewId, ...currentData } = currentInterviewData;
                const getTranslationsWithOperations = (translations)=>translations.filter(({ operation: operation })=>!!operation).map(({ id: translationId, optionId: optionId, sectionId: sectionId, Language: Language, questionId: questionId, description: description, operation: operation })=>({
                            optionId: optionId,
                            sectionId: sectionId,
                            operation: operation,
                            questionId: questionId,
                            description: description,
                            id: translationId,
                            languageId: Language.id
                        }));
                const getOptionsWithOperations = (options)=>options.filter(({ operation: operation })=>!!operation).map((option)=>{
                        const { Translations: Translations } = option;
                        const translationsWithOperations = getTranslationsWithOperations(Translations);
                        const { temporalId: temporalOptionId, questionId: questionId, ...restOption } = option;
                        return {
                            ...restOption,
                            Translations: translationsWithOperations
                        };
                    });
                const getQuestionsWithOperations = (questions)=>questions.filter(({ operation: operation, Options: Options })=>!!operation || Options.some(({ operation: optionOperation })=>!!optionOperation)).map((question)=>{
                        const { Translations: Translations, Options: Options } = question;
                        const translationsWithOperations = getTranslationsWithOperations(Translations);
                        const optionsWithOperations = getOptionsWithOperations(Options);
                        const { temporalId: temporalQuestionId, temporalSectionId: temporalSectionId, operation: operation, ...restQuestion } = question;
                        return {
                            ...restQuestion,
                            ...!operation && optionsWithOperations.some(({ operation: optionOperation })=>!!optionOperation) ? {
                                operation: 'update'
                            } : {
                                operation: operation
                            },
                            Options: optionsWithOperations,
                            Translations: translationsWithOperations
                        };
                    });
                const getSectionsWithOperations = (sections)=>sections.filter(({ operation: operation, SubSections: SubSections })=>!!operation || SubSections.some(({ operation: subOperation })=>subOperation)).map((section)=>{
                        const { Questions: Questions, Translations: Translations, SubSections: currentSubSections } = section;
                        const questionsWithOperations = getQuestionsWithOperations(Questions.map((question)=>({
                                ...question,
                                ...!question.operation && question.Options.some(({ operation: optionOperation })=>optionOperation) ? {
                                    operation: 'update'
                                } : {
                                    operation: question.operation
                                }
                            })));
                        const translationsWithOperations = getTranslationsWithOperations(Translations);
                        const subSectionsWithOperations = getSectionsWithOperations(currentSubSections ?? []);
                        const { parentId: parentId, isSpecial: isSpecial, operation: operation, Conditionals: Conditionals, temporalParentId: temporalParentId, temporalId: temporalSectionId, ...restSection } = section;
                        return {
                            ...restSection,
                            parentId: parentId,
                            ...!operation && (subSectionsWithOperations.some(({ operation: subOperation })=>!!subOperation) || questionsWithOperations.some(({ operation: questionOperation })=>!!questionOperation)) ? {
                                operation: 'update'
                            } : {
                                operation: operation
                            },
                            Questions: questionsWithOperations,
                            SubSections: subSectionsWithOperations,
                            Translations: translationsWithOperations
                        };
                    });
                const interviewOperations = {
                    id: currentData.id,
                    ...currentData.operation ? {
                        ...currentData
                    } : {},
                    ...currentSections.length ? {
                        Sections: getSectionsWithOperations(currentSections)
                    } : {}
                };
                const savedChanges = (await updateInterview({
                    variables: {
                        updateInterviewInput: (0, $i5UNc.omit)(interviewOperations, [
                            'createAt',
                            'updateAt',
                            '__typename'
                        ])
                    }
                })).data?.updateInterview;
                if (savedChanges && savedChanges.id) {
                    const newInterview = {
                        ...savedChanges,
                        Sections: mapSectionsToStore(savedChanges.Sections)
                    };
                    dispatch((0, $af02328711f8c5fd$export$7cde7a299bfe1e43)(newInterview));
                    dispatch((0, $af02328711f8c5fd$export$51529446d9f71f44)(interviews.map((interview)=>{
                        if (interview.id === newInterview.id) return newInterview;
                        return interview;
                    })));
                    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('The changes was saved successfully!');
                }
            }
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error?.message || 'Something went worng while trying to save interview changes');
        }
    };
    const onDeleteInterviewClick = async ()=>{
        if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).entityInterviews]) {
            showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).entityInterviews);
            return;
        }
        if (currentInterview.temporalId && currentInterview.temporalId.length) {
            dispatch((0, $af02328711f8c5fd$export$752f0a70a89451c5)());
            dispatch((0, $af02328711f8c5fd$export$51529446d9f71f44)(interviews.filter(({ temporalId: temporalId, id: id })=>!id && temporalId && temporalId !== currentInterview.temporalId || id && id.length)));
            setSelectedInterviewKey(undefined);
        } else if (currentInterview.id?.length) try {
            const deleteSuccess = !!(await deleteInterview({
                variables: {
                    id: currentInterview.id
                }
            })).data?.softDeleteInterview.success;
            if (deleteSuccess) {
                dispatch((0, $af02328711f8c5fd$export$752f0a70a89451c5)());
                dispatch((0, $af02328711f8c5fd$export$51529446d9f71f44)(interviews.filter(({ id: id, temporalId: temporalId })=>id && id.length && id !== currentInterview.id || temporalId && temporalId.length)));
                setSelectedInterviewKey(undefined);
            }
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to delete this Interview');
        }
    };
    const onCopyInterviewClick = async ()=>{
        if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).entityInterviews]) {
            showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).entityInterviews);
            return;
        }
        const { id: id } = currentInterview;
        const copiedInterview = (await copyInterview({
            variables: {
                id: id
            }
        })).data.copyInterview;
        dispatch((0, $af02328711f8c5fd$export$51529446d9f71f44)([
            ...interviews,
            ...mapInterviewsToStore([
                copiedInterview
            ]) ?? []
        ]));
        setSelectedInterviewKey(copiedInterview.id);
    };
    const handleSpecialSectionClick = async ({ key: type })=>{
        try {
            const newSpecialSection = (await createSpecialSection({
                variables: {
                    createSpecialSectionInput: {
                        type: type,
                        parentId: null,
                        interviewId: currentInterview.id,
                        order: currentInterview.Sections.length
                    }
                }
            })).data?.createSpecialSection;
            if (newSpecialSection && newSpecialSection.id) {
                const [sectionToSave] = mapSectionsToStore([
                    newSpecialSection
                ]);
                dispatch((0, $af02328711f8c5fd$export$7cde7a299bfe1e43)({
                    ...currentInterview,
                    Sections: [
                        ...currentInterview.Sections,
                        sectionToSave
                    ]
                }));
                dispatch((0, $af02328711f8c5fd$export$51529446d9f71f44)(interviews.map((interview)=>{
                    if (interview.id && interview.id === currentInterview.id) return {
                        ...interview,
                        Sections: [
                            ...interview.Sections,
                            sectionToSave
                        ]
                    };
                    return interview;
                })));
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('The Special Section Was Added Successfully!');
            }
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to add the special section');
        }
    };
    const SectionList = (0, $6fFrj.useMemo)(()=>(0, $bb3TF.jsx)((0, $c7d2533192511968$export$2e2bcd8739ae039), {
            onAddConditional: onAddConditionalHandler,
            onSectionsChange: onSectionsChangeHandler,
            sections: transformSectionsFromStoreToUi(currentInterview?.Sections ?? []),
            interviewLanguage: interviewLanguage
        }), [
        interviewLanguageId,
        currentInterview.Sections
    ]);
    const changeInterviewStatus = async ()=>{
        if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).entityInterviews]) {
            showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).entityInterviews);
            return;
        }
        if (currentInterview && currentInterview.id) {
            const result = await updateInterviewState({
                variables: {
                    id: currentInterview.id,
                    isLive: !currentInterview.isLive
                }
            });
            const updatedInterview = result.data?.updateInterviewState;
            if (updatedInterview) {
                dispatch((0, $af02328711f8c5fd$export$7cde7a299bfe1e43)(updatedInterview));
                dispatch((0, $af02328711f8c5fd$export$51529446d9f71f44)(interviews.map((interview)=>{
                    if (interview.id === updatedInterview.id) return updatedInterview;
                    return interview;
                })));
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('The changes was saved successfully!');
            } else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(result.errors?.join(','));
        }
    };
    (0, $6fFrj.useEffect)(()=>{
        const abortController = new AbortController();
        const fetchInterviews = async ()=>getinterviewNames({
                variables: {
                    filterLiveInterviews: false
                }
            });
        fetchInterviews().then((data)=>{
            // dispatch(setInterviews(mapInterviewsToStore(data)));
            const interviewInitial = data?.data.interviewNames?.slice()?.sort((a, b)=>a.isLive && !b.isLive ? -1 : 0) || [];
            dispatch((0, $af02328711f8c5fd$export$51529446d9f71f44)(mapInterviewsToStore(interviewInitial.map((i)=>({
                    ...i,
                    Sections: []
                })))));
            if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).entityInterviews]) setSelectedInterviewKey(interviewInitial.filter((i)=>i?.name?.toLowerCase().includes('individual'))[0]?.id || interviewInitial[0]?.id);
            else setSelectedInterviewKey(interviewInitial[0]?.id);
        }).catch(()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to fetch the Interviews');
        });
        return ()=>{
            abortController.abort();
        };
    }, []);
    (0, $6fFrj.useEffect)(()=>{
        if (interviews.length) {
            const current = interviews.find((interview)=>!interview.temporalId && interview.id && interview.id === selectedInterviewKey || interview.temporalId && !interview.id && interview.temporalId === selectedInterviewKey);
            if (current?.id?.length && current?.id === selectedInterviewKey || current?.temporalId?.length && current?.temporalId === selectedInterviewKey) {
                dispatch((0, $af02328711f8c5fd$export$7cde7a299bfe1e43)({
                    ...current,
                    ...current.id ? {
                        operation: 'update'
                    } : {}
                }));
                setInterviewName(current.name);
                setInterviewLanguageId(currentLanguage.id);
            }
            loadInterviewByIdToStore(selectedInterviewKey);
        }
    }, [
        selectedInterviewKey
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (!selectedInterviewKey && interviews.length) setSelectedInterviewKey(interviews[0].id ?? interviews[0].temporalId ?? '');
    }, [
        selectedInterviewKey,
        interviews
    ]);
    (0, $ad3306746e490c84$export$2e2bcd8739ae039)(()=>{
        if (initialRender.current) initialRender.current = false;
        else if (currentInterview && currentInterview.name !== interviewName) dispatch((0, $af02328711f8c5fd$export$7cde7a299bfe1e43)({
            name: interviewName
        }));
    }, 500, [
        interviewName
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (initialRender.current) initialRender.current = false;
        else if (currentInterview) {
            const translatedSections = mapSectionsTranslations(currentInterview.Sections ?? []);
            dispatch((0, $af02328711f8c5fd$export$7cde7a299bfe1e43)({
                Sections: translatedSections
            }));
        }
    }, [
        interviewLanguageId
    ]);
    const handleDeleteConditional = async (data)=>{
        await deleteConditional({
            variables: {
                questionId: data.questionId,
                conditionalId: data.conditionalId
            },
            onCompleted: ()=>{
                setIsConditionalModalVisible(false);
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('The conditional was deleted successfully');
            },
            onError: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong while trying to delete the conditional');
            }
        });
    };
    return {
        interviews: interviews,
        SectionList: SectionList,
        interviewName: interviewName,
        hasTranslations: hasTranslations,
        currentInterview: currentInterview,
        onAddSectionClick: onAddSectionClick,
        interviewLanguage: interviewLanguage,
        mapSectionsToStore: mapSectionsToStore,
        onSaveChangesClick: onSaveChangesClick,
        interviewLanguageId: interviewLanguageId,
        handleConditionalOk: handleConditionalOk,
        currentConditionals: currentConditionals,
        getInterviewsLoading: getInterviewsLoading,
        mapInterviewsToStore: mapInterviewsToStore,
        handleInterviewClick: handleInterviewClick,
        selectedInterviewKey: selectedInterviewKey,
        onCopyInterviewClick: onCopyInterviewClick,
        copyInterviewLoading: copyInterviewLoading,
        changeInterviewStatus: changeInterviewStatus,
        onInterviewNameChange: onInterviewNameChange,
        createInterviewLoading: createInterviewLoading,
        onDeleteInterviewClick: onDeleteInterviewClick,
        updateInterviewLoading: updateInterviewLoading,
        deleteInterviewLoading: deleteInterviewLoading,
        handleConditionalCancel: handleConditionalCancel,
        createConditionalLoading: createConditionalLoading,
        updateConditionalLoading: updateConditionalLoading,
        isConditionalModalVisible: isConditionalModalVisible,
        currentOptionsToCondition: currentOptionsToCondition,
        handleSpecialSectionClick: handleSpecialSectionClick,
        handleCreateInterviewClick: handleCreateInterviewClick,
        createSpecialSectionLoading: createSpecialSectionLoading,
        handleInterviewLanguageChange: handleInterviewLanguageChange,
        transformSectionsFromUiToStore: transformSectionsFromUiToStore,
        loadingInterviewById: loadingInterviewById,
        loadingUpdateInterviewState: loadingUpdateInterviewState,
        currentSectionIsSubsection: currentSectionIsSubsection,
        handleConditionalOkCreateQuestion: handleConditionalOkCreateQuestion,
        currentSectionToConditionId: currentSectionToConditionId,
        handleDeleteConditional: handleDeleteConditional
    };
};
var $d5d0cbad803b1256$export$2e2bcd8739ae039 = $d5d0cbad803b1256$var$useInterviews;




var $da036b5f14f936e4$export$87898a1d7a65f144;
var $da036b5f14f936e4$export$f768d67beb84ac8d;
var $da036b5f14f936e4$export$e18056e9974d769b;
var $da036b5f14f936e4$export$760ca3c98e848cb7;
var $da036b5f14f936e4$export$26efbb8eaf86235f;
var $da036b5f14f936e4$export$c61de213a6a77c42;
var $da036b5f14f936e4$export$18d5e2ede43327bf;
var $da036b5f14f936e4$export$cb480db108ed734a;
var $da036b5f14f936e4$export$50e6c862909d9bea;
var $da036b5f14f936e4$export$7fcbe12c5cdd142e;
var $da036b5f14f936e4$export$2de2670e14907f8;
var $da036b5f14f936e4$export$622e12cd0eefbec5;
var $da036b5f14f936e4$export$e49af5cc0c5a6787;
var $da036b5f14f936e4$export$ee87082feaa0b4ea;
var $da036b5f14f936e4$export$2f15c0617d739395;
var $da036b5f14f936e4$export$c1801a99f914f580;
var $da036b5f14f936e4$export$4cf1388ef83aed25;
var $da036b5f14f936e4$export$5a1dbaa3e4449344;
var $da036b5f14f936e4$export$aa9524c889a60836;
var $da036b5f14f936e4$export$e39e8873928166f5;
$da036b5f14f936e4$export$87898a1d7a65f144 = `x0iYLG_addSpecialSectionButton`;
$da036b5f14f936e4$export$f768d67beb84ac8d = `x0iYLG_copyDeleteButtons`;
$da036b5f14f936e4$export$e18056e9974d769b = `x0iYLG_interviewButtonsContainer`;
$da036b5f14f936e4$export$760ca3c98e848cb7 = `x0iYLG_interviewContainer`;
$da036b5f14f936e4$export$26efbb8eaf86235f = `x0iYLG_interviewLanguageContainer`;
$da036b5f14f936e4$export$c61de213a6a77c42 = `x0iYLG_interviewNameInput`;
$da036b5f14f936e4$export$18d5e2ede43327bf = `x0iYLG_interviewStatusAlert`;
$da036b5f14f936e4$export$cb480db108ed734a = `x0iYLG_interviewStatusContainer`;
$da036b5f14f936e4$export$50e6c862909d9bea = `x0iYLG_interviewsContainer`;
$da036b5f14f936e4$export$7fcbe12c5cdd142e = `x0iYLG_interviewsContentContainer`;
$da036b5f14f936e4$export$2de2670e14907f8 = `x0iYLG_interviewsLoadingContainer`;
$da036b5f14f936e4$export$622e12cd0eefbec5 = `x0iYLG_interviewsMenu`;
$da036b5f14f936e4$export$e49af5cc0c5a6787 = `x0iYLG_mainSectionsOperationsContainer`;
$da036b5f14f936e4$export$ee87082feaa0b4ea = `x0iYLG_newInterviewButton`;
$da036b5f14f936e4$export$2f15c0617d739395 = `x0iYLG_noInterviewsInfo`;
$da036b5f14f936e4$export$c1801a99f914f580 = `x0iYLG_noInterviewsInfoContainer`;
$da036b5f14f936e4$export$4cf1388ef83aed25 = `x0iYLG_pageHeader`;
$da036b5f14f936e4$export$5a1dbaa3e4449344 = `x0iYLG_sections`;
$da036b5f14f936e4$export$aa9524c889a60836 = `x0iYLG_sectionsButtonContainer`;
$da036b5f14f936e4$export$e39e8873928166f5 = `x0iYLG_skeletonContainer`;


const { Sider: $0244d4e321aabfb3$var$Sider } = (0, $0102c485edc5bdcf$export$2e2bcd8739ae039);
const { PlusOutlined: $0244d4e321aabfb3$var$PlusOutlined, MenuFoldOutlined: $0244d4e321aabfb3$var$MenuFoldOutlined, MenuUnfoldOutlined: $0244d4e321aabfb3$var$MenuUnfoldOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $0244d4e321aabfb3$var$InterviewsTemplate = ()=>{
    const { languages: languages } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $e3b9937a336ce5aa$export$ca779d385d6ad982));
    const { interviews: interviews, SectionList: SectionList, interviewName: interviewName, hasTranslations: hasTranslations, currentInterview: currentInterview, onAddSectionClick: onAddSectionClick, onSaveChangesClick: onSaveChangesClick, interviewLanguageId: interviewLanguageId, handleConditionalOk: handleConditionalOk, currentConditionals: currentConditionals, getInterviewsLoading: getInterviewsLoading, onCopyInterviewClick: onCopyInterviewClick, handleInterviewClick: handleInterviewClick, selectedInterviewKey: selectedInterviewKey, copyInterviewLoading: copyInterviewLoading, changeInterviewStatus: changeInterviewStatus, onInterviewNameChange: onInterviewNameChange, deleteInterviewLoading: deleteInterviewLoading, createInterviewLoading: createInterviewLoading, updateInterviewLoading: updateInterviewLoading, onDeleteInterviewClick: onDeleteInterviewClick, handleConditionalCancel: handleConditionalCancel, createConditionalLoading: createConditionalLoading, updateConditionalLoading: updateConditionalLoading, isConditionalModalVisible: isConditionalModalVisible, currentOptionsToCondition: currentOptionsToCondition, handleSpecialSectionClick: handleSpecialSectionClick, handleCreateInterviewClick: handleCreateInterviewClick, createSpecialSectionLoading: createSpecialSectionLoading, handleInterviewLanguageChange: handleInterviewLanguageChange, loadingInterviewById: loadingInterviewById, loadingUpdateInterviewState: loadingUpdateInterviewState, currentSectionIsSubsection: currentSectionIsSubsection, handleConditionalOkCreateQuestion: handleConditionalOkCreateQuestion, currentSectionToConditionId: currentSectionToConditionId, handleDeleteConditional: handleDeleteConditional } = (0, $d5d0cbad803b1256$export$2e2bcd8739ae039)();
    const [collapsed, setCollapsed] = (0, $6fFrj.useState)(false);
    const { accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    const languagesToSelect = (0, $6fFrj.useMemo)(()=>languages.filter(({ lang: lang })=>[
                'EN',
                'ES'
            ].includes(lang)).map(({ id: id, description: description })=>({
                value: id,
                label: description ?? ''
            })) ?? [], [
        languages
    ]);
    const conditionalOptions = (0, $6fFrj.useMemo)(()=>currentOptionsToCondition.map((option)=>{
            const isOptionAlreadyConditioned = !!currentConditionals?.some(({ optionId: optionId })=>optionId === option.value);
            if (isOptionAlreadyConditioned) return {
                ...option,
                checked: true
            };
            return {
                ...option,
                checked: false
            };
        }), [
        currentOptionsToCondition
    ]);
    const toggleMenu = ()=>{
        setCollapsed(!collapsed);
    };
    return (0, $bb3TF.jsxs)("div", {
        className: $da036b5f14f936e4$export$50e6c862909d9bea,
        children: [
            (0, $bb3TF.jsx)($0244d4e321aabfb3$var$Sider, {
                collapsible: true,
                collapsed: collapsed,
                trigger: null,
                children: (0, $bb3TF.jsxs)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
                    mode: "inline",
                    defaultSelectedKeys: [
                        selectedInterviewKey
                    ],
                    selectedKeys: [
                        selectedInterviewKey
                    ],
                    className: $da036b5f14f936e4$export$622e12cd0eefbec5,
                    children: [
                        getInterviewsLoading ? (0, $bb3TF.jsx)("div", {
                            className: $da036b5f14f936e4$export$2de2670e14907f8,
                            children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {})
                        }) : interviews.slice().sort((a, b)=>a.isLive && !b.isLive ? -1 : 0).map(({ id: id, name: name, isLive: isLive, temporalId: temporalId })=>(0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
                                icon: (0, $bb3TF.jsx)((0, $0e541b76c0e3ec69$export$2e2bcd8739ae039), {
                                    style: {
                                        backgroundColor: isLive ? '#52c41a' : '#ff4d4f'
                                    },
                                    count: `${isLive ? 'Live' : 'Off'}`
                                }),
                                onClick: handleInterviewClick,
                                children: name
                            }, id ?? temporalId)),
                        (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                            title: "Create Interview",
                            children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                icon: (0, $bb3TF.jsx)($0244d4e321aabfb3$var$PlusOutlined, {}),
                                className: $da036b5f14f936e4$export$ee87082feaa0b4ea,
                                onClick: handleCreateInterviewClick
                            })
                        })
                    ]
                })
            }),
            (0, $bb3TF.jsxs)("div", {
                className: $da036b5f14f936e4$export$7fcbe12c5cdd142e,
                children: [
                    (0, $bb3TF.jsx)((0, $d8be83256c7630cc$export$2e2bcd8739ae039), {
                        title: "Interviews",
                        onBack: toggleMenu,
                        className: $da036b5f14f936e4$export$4cf1388ef83aed25,
                        backIcon: collapsed ? (0, $bb3TF.jsx)($0244d4e321aabfb3$var$MenuUnfoldOutlined, {}) : (0, $bb3TF.jsx)($0244d4e321aabfb3$var$MenuFoldOutlined, {})
                    }),
                    currentInterview && (currentInterview.id || currentInterview.temporalId) && !loadingInterviewById && !loadingUpdateInterviewState ? (0, $bb3TF.jsxs)("div", {
                        className: $da036b5f14f936e4$export$760ca3c98e848cb7,
                        children: [
                            (0, $bb3TF.jsx)("div", {
                                className: $da036b5f14f936e4$export$cb480db108ed734a,
                                children: (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                                    showIcon: true,
                                    className: $da036b5f14f936e4$export$18d5e2ede43327bf,
                                    message: !currentInterview.isLive ? 'This interview is not live yet' : '',
                                    type: currentInterview.isLive ? 'success' : 'warning',
                                    description: currentInterview.isLive ? (0, $bb3TF.jsxs)("div", {
                                        children: [
                                            (0, $bb3TF.jsx)("h3", {
                                                style: {
                                                    color: 'white',
                                                    marginTop: '-5px'
                                                },
                                                children: "This interview is currently live."
                                            }),
                                            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                type: "default",
                                                onClick: changeInterviewStatus,
                                                children: "Hide this interview"
                                            })
                                        ]
                                    }) : (0, $bb3TF.jsxs)("div", {
                                        children: [
                                            (0, $bb3TF.jsx)("p", {
                                                children: "While you configure this interview, it will not be made available for staff or clients. Once you are done editing and ready for it to go live, select \"Make it available!\" below."
                                            }),
                                            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                type: "default",
                                                onClick: changeInterviewStatus,
                                                children: "Make it available!"
                                            })
                                        ]
                                    })
                                })
                            }),
                            (0, $bb3TF.jsx)("strong", {
                                children: "Interview Name"
                            }),
                            (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                value: interviewName,
                                onChange: onInterviewNameChange,
                                className: $da036b5f14f936e4$export$c61de213a6a77c42,
                                disabled: !accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).entityInterviews]
                            }),
                            (0, $bb3TF.jsxs)("div", {
                                className: $da036b5f14f936e4$export$26efbb8eaf86235f,
                                children: [
                                    (0, $bb3TF.jsx)("strong", {
                                        children: "Show In Language"
                                    }),
                                    (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                        value: interviewLanguageId,
                                        onChange: (langId)=>{
                                            handleInterviewLanguageChange(langId);
                                            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
                                                Title: 'Show In Language',
                                                Source: 'Select option',
                                                value: languagesToSelect.find((l)=>l.value === langId)?.label,
                                                url: window.location.href
                                            });
                                        },
                                        children: languagesToSelect.map(({ value: value, label: label })=>(0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039).Option, {
                                                value: value,
                                                children: label
                                            }, value))
                                    })
                                ]
                            }),
                            !!currentInterview.Sections.length && !hasTranslations && (0, $bb3TF.jsx)("div", {
                                className: $da036b5f14f936e4$export$cb480db108ed734a,
                                children: (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                                    showIcon: true,
                                    type: "info",
                                    message: "Interview Translations",
                                    className: $da036b5f14f936e4$export$18d5e2ede43327bf,
                                    description: (0, $bb3TF.jsx)("div", {
                                        children: (0, $bb3TF.jsx)("h3", {
                                            style: {
                                                color: 'white',
                                                marginTop: '-5px'
                                            },
                                            children: "Complete all the translations for the selected language"
                                        })
                                    })
                                })
                            }),
                            (0, $bb3TF.jsx)("div", {
                                className: $da036b5f14f936e4$export$5a1dbaa3e4449344,
                                children: (0, $bb3TF.jsxs)("div", {
                                    className: $da036b5f14f936e4$export$e49af5cc0c5a6787,
                                    children: [
                                        (0, $bb3TF.jsxs)("div", {
                                            className: $da036b5f14f936e4$export$aa9524c889a60836,
                                            children: [
                                                (0, $bb3TF.jsx)("strong", {
                                                    children: "Sections"
                                                }),
                                                (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                    icon: (0, $bb3TF.jsx)($0244d4e321aabfb3$var$PlusOutlined, {}),
                                                    onClick: onAddSectionClick,
                                                    children: "Add Section"
                                                })
                                            ]
                                        }),
                                        currentInterview && currentInterview.id && (0, $bb3TF.jsx)((0, $7372c2afe14f5106$export$2e2bcd8739ae039), {
                                            trigger: [
                                                'click'
                                            ],
                                            overlay: (0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039), {
                                                children: Object.values((0, $8f7fe33a44836803$export$8ae99efa3d653842)).map((key)=>(0, $bb3TF.jsx)((0, $cd46f582474e92de$export$2e2bcd8739ae039).Item, {
                                                        onClick: handleSpecialSectionClick,
                                                        children: key.split('_').map((s)=>s[0].toUpperCase() + s.slice(1).toLowerCase()).join(' ')
                                                    }, key))
                                            }),
                                            children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                loading: createSpecialSectionLoading,
                                                className: $da036b5f14f936e4$export$87898a1d7a65f144,
                                                type: "primary",
                                                icon: (0, $bb3TF.jsx)($0244d4e321aabfb3$var$PlusOutlined, {}),
                                                onClick: (event)=>{
                                                    event.preventDefault();
                                                },
                                                children: "Add Special Section"
                                            })
                                        })
                                    ]
                                })
                            }),
                            !currentInterview?.Sections?.length && (currentInterview.id || currentInterview.temporalId) && (0, $bb3TF.jsx)("div", {
                                className: $da036b5f14f936e4$export$cb480db108ed734a,
                                children: (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                                    showIcon: true,
                                    type: "info",
                                    message: "Interview Sections",
                                    className: $da036b5f14f936e4$export$18d5e2ede43327bf,
                                    description: (0, $bb3TF.jsx)("div", {
                                        children: (0, $bb3TF.jsx)("h3", {
                                            style: {
                                                color: 'white',
                                                marginTop: '-5px'
                                            },
                                            children: "An interview should have at least one section"
                                        })
                                    })
                                })
                            }),
                            SectionList,
                            (0, $bb3TF.jsxs)("div", {
                                className: $da036b5f14f936e4$export$e18056e9974d769b,
                                children: [
                                    (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                        onClick: onSaveChangesClick,
                                        loading: createInterviewLoading || updateInterviewLoading,
                                        disabled: !currentInterview?.Sections?.length || !hasTranslations,
                                        children: "Save Changes"
                                    }),
                                    (0, $bb3TF.jsxs)("div", {
                                        className: $da036b5f14f936e4$export$f768d67beb84ac8d,
                                        children: [
                                            currentInterview.id && (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                loading: copyInterviewLoading,
                                                onClick: onCopyInterviewClick,
                                                type: "primary",
                                                children: "Copy Interview"
                                            }),
                                            (0, $bb3TF.jsx)((0, $a361442371f1d4e9$export$2e2bcd8739ae039), {
                                                okText: "Yes",
                                                cancelText: "No",
                                                placement: "topRight",
                                                okButtonProps: {
                                                    danger: true
                                                },
                                                onConfirm: onDeleteInterviewClick,
                                                cancelButtonProps: {
                                                    type: 'default'
                                                },
                                                title: "Are you sure you want to delete this?",
                                                children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                    loading: deleteInterviewLoading,
                                                    danger: true,
                                                    children: "Delete Interview"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (0, $bb3TF.jsx)((0, $babc6c603c3accf4$export$2e2bcd8739ae039), {
                                onOk: handleConditionalOk,
                                options: conditionalOptions,
                                onCancel: handleConditionalCancel,
                                visible: isConditionalModalVisible,
                                isEditing: !!currentConditionals?.length,
                                loading: createConditionalLoading || updateConditionalLoading,
                                isSubsection: currentSectionIsSubsection,
                                onOkCreateQuestion: handleConditionalOkCreateQuestion,
                                onDeleteConditional: handleDeleteConditional,
                                conditional: currentConditionals.find(({ sectionId: sectionId })=>sectionId === currentSectionToConditionId),
                                interviewId: currentInterview.id,
                                sectionId: currentSectionToConditionId
                            })
                        ]
                    }) : (0, $bb3TF.jsx)("div", {
                        className: $da036b5f14f936e4$export$e39e8873928166f5,
                        children: [
                            ...Array(3)
                        ].map(()=>(0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039), {
                                active: getInterviewsLoading
                            }))
                    }),
                    !getInterviewsLoading && !interviews.length && (0, $bb3TF.jsx)("div", {
                        className: $da036b5f14f936e4$export$c1801a99f914f580,
                        children: (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            className: $da036b5f14f936e4$export$2f15c0617d739395,
                            showIcon: true,
                            type: "info",
                            description: "Your team has not yet registered any interviews."
                        })
                    })
                ]
            })
        ]
    });
};
var $0244d4e321aabfb3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).memo($0244d4e321aabfb3$var$InterviewsTemplate);


const $e26a1ed35617e99f$var$Interviews = ()=>(0, $bb3TF.jsx)((0, $0244d4e321aabfb3$export$2e2bcd8739ae039), {});
var $e26a1ed35617e99f$export$2e2bcd8739ae039 = $e26a1ed35617e99f$var$Interviews;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



const $0ddf390d079c5075$var$defaultOptions = {};
const $0ddf390d079c5075$export$7a1ca645c629d394 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetUserStepsByUserId($userId: String!) {
  userSteps(userId: $userId) {
    stepId
    userId
    completed
    Steps {
      id
      name
      description
      order
      tooltip
      Buttons {
        id
        label
        stepId
        action
        className
        color
        link
        popConfirm
      }
    }
  }
}
    `;
function $0ddf390d079c5075$export$640c4c736ed2e29c(baseOptions) {
    const options = {
        ...$0ddf390d079c5075$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($0ddf390d079c5075$export$7a1ca645c629d394, options);
}
function $0ddf390d079c5075$export$972f6e3578ae962b(baseOptions) {
    const options = {
        ...$0ddf390d079c5075$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($0ddf390d079c5075$export$7a1ca645c629d394, options);
}
const $0ddf390d079c5075$export$c90b18a46d90751e = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetFirmOperatingAs($id: String!) {
  FirmAccountById(id: $id) {
    id
    businessType
  }
}
    `;
function $0ddf390d079c5075$export$942e15e03134b6fe(baseOptions) {
    const options = {
        ...$0ddf390d079c5075$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($0ddf390d079c5075$export$c90b18a46d90751e, options);
}
function $0ddf390d079c5075$export$d53bcbc8e969e700(baseOptions) {
    const options = {
        ...$0ddf390d079c5075$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($0ddf390d079c5075$export$c90b18a46d90751e, options);
}
const $0ddf390d079c5075$export$39ac829ab91f0716 = {
    Query: {
        GetUserStepsByUserId: 'GetUserStepsByUserId',
        GetFirmOperatingAs: 'GetFirmOperatingAs'
    }
};



const $38b15148eab410f9$var$defaultOptions = {};
const $38b15148eab410f9$export$216fbb0e555c961c = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation UpdateUserStep($updateUserStepInput: UpdateUserStepInput!) {
  updateUserStep(updateUserStepInput: $updateUserStepInput) {
    stepId
    userId
    completed
  }
}
    `;
function $38b15148eab410f9$export$6a5fa00eda3e6c68(baseOptions) {
    const options = {
        ...$38b15148eab410f9$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($38b15148eab410f9$export$216fbb0e555c961c, options);
}
const $38b15148eab410f9$export$2ed5a1807f97cdb9 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation SendWelcomeEmailToAllClients($sendWelcomeEmailInput: SendWelcomeEmailInput!) {
  sendWelcomeEmailToAllClients(sendWelcomeEmailInput: $sendWelcomeEmailInput)
}
    `;
function $38b15148eab410f9$export$d2e8d7c657f505e(baseOptions) {
    const options = {
        ...$38b15148eab410f9$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($38b15148eab410f9$export$2ed5a1807f97cdb9, options);
}
const $38b15148eab410f9$export$39ac829ab91f0716 = {
    Mutation: {
        UpdateUserStep: 'UpdateUserStep',
        SendWelcomeEmailToAllClients: 'SendWelcomeEmailToAllClients'
    }
};



var $bb3TF = parcelRequire("bb3TF");

var $1986810e3d25a422$export$f706c8379844ca4d;
$1986810e3d25a422$export$f706c8379844ca4d = `r3XbiG_onBoardingBar`;


const $df61c38e027db076$var$colors = {
    normal: '#1754a2',
    success: '#52c41a'
};
const $df61c38e027db076$var$getPercent = (total, completed)=>Math.ceil(100 / total * completed);
const $df61c38e027db076$var$ProgressBar = ({ completed: completed, total: total })=>(0, $bb3TF.jsxs)("div", {
        className: $1986810e3d25a422$export$f706c8379844ca4d,
        children: [
            (0, $bb3TF.jsx)("span", {
                children: `${completed}/${total} complete`
            }),
            (0, $bb3TF.jsx)((0, $35ec803a48e00dda$export$2e2bcd8739ae039), {
                percent: $df61c38e027db076$var$getPercent(total, completed),
                showInfo: false,
                strokeColor: $df61c38e027db076$var$getPercent(total, completed) >= 100 ? $df61c38e027db076$var$colors.success : $df61c38e027db076$var$colors.normal
            })
        ]
    });
var $df61c38e027db076$export$2e2bcd8739ae039 = $df61c38e027db076$var$ProgressBar;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $ipnkk = parcelRequire("ipnkk");






var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $12002acf5fa75244$var$SvgAddTeamembers = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        id: "addTeamembers_svg__Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("defs", {
                children: /*#__PURE__*/ (0, $bb3TF.jsx)("style", {
                    children: ".addTeamembers_svg__cls-1{fill:#dfe9f7}.addTeamembers_svg__cls-2{fill:#fff}.addTeamembers_svg__cls-3{fill:#0a64b2}"
                })
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("circle", {
                className: "addTeamembers_svg__cls-1",
                cx: 18.99,
                cy: 9.61,
                r: 3.88
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "addTeamembers_svg__cls-2",
                d: "M.72 24.54C1.26 19.27 8.08 19 9.49 19s8.24.27 8.78 5.54Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "addTeamembers_svg__cls-3",
                d: "M9.49 19.68c1.23 0 6.91.22 8 4.18H1.53c1.06-4 6.73-4.18 8-4.18m0-1.37C5.18 18.31 0 20 0 25.22h19c0-5.18-5.18-6.91-9.5-6.91Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "addTeamembers_svg__cls-2",
                d: "M9.49 15a3.2 3.2 0 1 1 3.21-3.2A3.2 3.2 0 0 1 9.49 15Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "addTeamembers_svg__cls-3",
                d: "M9.49 9.32A2.52 2.52 0 1 1 7 11.84a2.52 2.52 0 0 1 2.49-2.52m0-1.32a3.89 3.89 0 1 0 3.89 3.88A3.88 3.88 0 0 0 9.49 8Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "addTeamembers_svg__cls-1",
                d: "M24.93 21h1.8v-1.79a3 3 0 0 1 0-.52c-1.89-1.89-5-2.61-7.78-2.61a13.73 13.73 0 0 0-5.44 1.05 11.91 11.91 0 0 1 3.16 1.25 7.68 7.68 0 0 1 3.7 4.62h1.28a3.71 3.71 0 0 1 3.28-2Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "addTeamembers_svg__cls-3",
                d: "M34.88 22.92h-4v-4a1.12 1.12 0 1 0-2.23 0v4h-4a1.12 1.12 0 0 0 0 2.23h4v4a1.12 1.12 0 1 0 2.23 0v-4h4a1.12 1.12 0 1 0 0-2.23Z"
            })
        ]
    });
var $12002acf5fa75244$export$2e2bcd8739ae039 = $12002acf5fa75244$var$SvgAddTeamembers;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $96e57deddb4ac05c$var$SvgConnectCalendar = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        id: "connectCalendar_svg__Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("defs", {
                children: /*#__PURE__*/ (0, $bb3TF.jsx)("style", {
                    children: ".connectCalendar_svg__cls-3{fill:#0a64b2}"
                })
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M0 33.61A2.39 2.39 0 0 0 2.39 36h31.22A2.39 2.39 0 0 0 36 33.61V13H0Z",
                style: {
                    fill: "#fff"
                }
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M33.61 4H2.39A2.39 2.39 0 0 0 0 6.39V13h36V6.39A2.39 2.39 0 0 0 33.61 4Z",
                style: {
                    fill: "#dfe9f7"
                }
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "connectCalendar_svg__cls-3",
                d: "M33.61 5.5a.89.89 0 0 1 .89.89v27.22a.89.89 0 0 1-.89.89H2.39a.89.89 0 0 1-.89-.89V6.39a.89.89 0 0 1 .89-.89h31.22m0-1.5H2.39A2.39 2.39 0 0 0 0 6.39v27.22A2.39 2.39 0 0 0 2.39 36h31.22A2.39 2.39 0 0 0 36 33.61V6.39A2.39 2.39 0 0 0 33.61 4Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "connectCalendar_svg__cls-3",
                d: "M7.5 0a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1ZM12.5 0a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1ZM23.5 0a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1ZM28.5 0a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1ZM.5 12.25h35v1.5H.5zM16.17 15.58h3.67v2.1h-3.67zM21.93 15.58h3.67v2.1h-3.67zM27.69 15.58h3.67v2.1h-3.67zM16.17 20.3h3.67v2.1h-3.67zM21.93 20.3h3.67v2.1h-3.67zM27.69 20.3h3.67v2.1h-3.67zM16.17 25.01h3.67v2.1h-3.67zM21.93 25.01h3.67v2.1h-3.67zM27.69 25.01h3.67v2.1h-3.67zM4.64 20.3h3.67v2.1H4.64zM10.4 20.3h3.67v2.1H10.4zM4.64 25.01h3.67v2.1H4.64zM10.4 25.01h3.67v2.1H10.4zM16.17 29.73h3.67v2.1h-3.67zM4.64 29.73h3.67v2.1H4.64zM10.4 29.73h3.67v2.1H10.4z"
            })
        ]
    });
var $96e57deddb4ac05c$export$2e2bcd8739ae039 = $96e57deddb4ac05c$var$SvgConnectCalendar;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $3049c71d8ef8d45b$var$SvgConnectingStripe = (props)=>/*#__PURE__*/ (0, $bb3TF.jsx)("svg", {
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        ...props,
        children: /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
            d: "M15.44 10.71c0-1.54 1.29-2.14 3.36-2.14a22.18 22.18 0 0 1 9.83 2.54v-9.3A26 26 0 0 0 18.81 0c-8 0-13.36 4.19-13.36 11.18 0 10.94 15 9.16 15 13.88 0 1.83-1.58 2.42-3.79 2.42a24.79 24.79 0 0 1-10.79-3.16v9.44A27.41 27.41 0 0 0 16.67 36c8.22 0 13.88-4.06 13.88-11.17 0-11.78-15.11-9.67-15.11-14.12Z",
            style: {
                fill: "#0a64b2",
                fillRule: "evenodd"
            }
        })
    });
var $3049c71d8ef8d45b$export$2e2bcd8739ae039 = $3049c71d8ef8d45b$var$SvgConnectingStripe;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $a4d6f66506af69c0$var$SvgCustomizeYourOwnWorkflow = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        id: "customizeYourOwnWorkflow_svg__Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("defs", {
                children: /*#__PURE__*/ (0, $bb3TF.jsx)("style", {
                    children: ".customizeYourOwnWorkflow_svg__cls-2{fill:#0a64b2}"
                })
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M14.78 23.83a2 2 0 0 1 .71.14 1.81 1.81 0 0 1 1.16 1.67v.84a.36.36 0 0 0 .36.36h2a.36.36 0 0 0 .36-.36v-.84A1.8 1.8 0 0 1 20.49 24a1.81 1.81 0 0 1 2 .39l.6.59a.36.36 0 0 0 .51 0l1.4-1.43a.35.35 0 0 0 0-.5l-.6-.59a1.79 1.79 0 0 1-.4-1.93v-.07a1.81 1.81 0 0 1 1.67-1.12h.85a.36.36 0 0 0 .36-.36V17a.36.36 0 0 0-.36-.36h-.82a1.83 1.83 0 0 1-1.7-1.12 1.79 1.79 0 0 1 .38-2L25 13a.36.36 0 0 0 0-.51l-1.4-1.38a.34.34 0 0 0-.26-.11.33.33 0 0 0-.25.11l-.6.59a1.86 1.86 0 0 1-3.14-1.3v-.88a.36.36 0 0 0-.35-.36h-2a.36.36 0 0 0-.36.36v.83A1.8 1.8 0 0 1 15.51 12a1.84 1.84 0 0 1-2-.37l-.6-.59a.35.35 0 0 0-.51 0l-1.4 1.4a.36.36 0 0 0 0 .56l.6.59a1.78 1.78 0 0 1 .38 2 1.81 1.81 0 0 1-1.68 1.15h-.85a.36.36 0 0 0-.36.36v2a.36.36 0 0 0 .36.36h.85a1.82 1.82 0 0 1 1.7 1.01 1.81 1.81 0 0 1-.38 2l-.6.59a.35.35 0 0 0 0 .5l1.4 1.39a.36.36 0 0 0 .51 0l.6-.59a1.79 1.79 0 0 1 1.27-.52Z",
                style: {
                    fill: "#dfe9f7"
                }
            }),
            /*#__PURE__*/ (0, $bb3TF.jsxs)("g", {
                id: "customizeYourOwnWorkflow_svg__icon",
                children: [
                    /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                        className: "customizeYourOwnWorkflow_svg__cls-2",
                        d: "M19 28.28h-2a1.81 1.81 0 0 1-1.81-1.8v-.84a.38.38 0 0 0-.24-.33.37.37 0 0 0-.42.06l-.6.59a1.82 1.82 0 0 1-2.56 0L10 24.57A1.78 1.78 0 0 1 10 22l.6-.59a.36.36 0 0 0 .06-.4.38.38 0 0 0-.34-.26h-.87A1.81 1.81 0 0 1 7.64 19v-2a1.81 1.81 0 0 1 1.81-1.8h.85a.38.38 0 0 0 .34-.24.39.39 0 0 0-.06-.42L10 14a1.79 1.79 0 0 1 0-2.55L11.38 10a1.86 1.86 0 0 1 2.56 0l.6.59a.36.36 0 0 0 .4.07.39.39 0 0 0 .26-.35v-.79a1.81 1.81 0 0 1 1.8-1.8h2a1.81 1.81 0 0 1 1.81 1.8v.83a.37.37 0 0 0 .25.34.35.35 0 0 0 .41-.06l.6-.59a1.86 1.86 0 0 1 2.56 0L26 11.42A1.79 1.79 0 0 1 26 14l-.6.59a.36.36 0 0 0-.06.4.38.38 0 0 0 .34.26h.85A1.81 1.81 0 0 1 28.36 17v2a1.81 1.81 0 0 1-1.81 1.8h-.85a.36.36 0 0 0-.33.24.37.37 0 0 0 .05.42L26 22a1.78 1.78 0 0 1 0 2.54L24.62 26a1.82 1.82 0 0 1-2.56 0l-.6-.59a.36.36 0 0 0-.4-.07.38.38 0 0 0-.25.33v.84A1.81 1.81 0 0 1 19 28.28Zm-4.21-4.45a2 2 0 0 1 .71.14 1.81 1.81 0 0 1 1.16 1.67v.84a.36.36 0 0 0 .36.36h2a.36.36 0 0 0 .36-.36v-.84A1.8 1.8 0 0 1 20.49 24a1.81 1.81 0 0 1 2 .39l.6.59a.36.36 0 0 0 .51 0l1.4-1.43a.35.35 0 0 0 0-.5l-.6-.59a1.79 1.79 0 0 1-.4-1.93v-.07a1.81 1.81 0 0 1 1.67-1.12h.85a.36.36 0 0 0 .36-.36V17a.36.36 0 0 0-.36-.36h-.82a1.83 1.83 0 0 1-1.7-1.12 1.79 1.79 0 0 1 .38-2L25 13a.36.36 0 0 0 0-.51l-1.4-1.38a.34.34 0 0 0-.26-.11.33.33 0 0 0-.25.11l-.6.59a1.86 1.86 0 0 1-3.14-1.3v-.88a.36.36 0 0 0-.35-.36h-2a.36.36 0 0 0-.36.36v.83A1.8 1.8 0 0 1 15.51 12a1.84 1.84 0 0 1-2-.37l-.6-.59a.35.35 0 0 0-.51 0l-1.4 1.4a.36.36 0 0 0 0 .56l.6.59a1.78 1.78 0 0 1 .38 2 1.81 1.81 0 0 1-1.68 1.15h-.84a.36.36 0 0 0-.36.26v2a.36.36 0 0 0 .36.36h.84a1.82 1.82 0 0 1 1.7 1.11 1.81 1.81 0 0 1-.38 2l-.6.59a.35.35 0 0 0 0 .5l1.4 1.39a.36.36 0 0 0 .51 0l.6-.59a1.79 1.79 0 0 1 1.27-.52Z"
                    }),
                    /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                        className: "customizeYourOwnWorkflow_svg__cls-2",
                        d: "M18 22a4 4 0 1 1 4-4 4 4 0 0 1-4 4Zm0-6.56A2.56 2.56 0 1 0 20.58 18 2.57 2.57 0 0 0 18 15.44ZM2.81 16.2h-.1a.73.73 0 0 1-.62-.82A16.07 16.07 0 0 1 14.54 2.09a.72.72 0 1 1 .31 1.41A14.62 14.62 0 0 0 3.53 15.58a.72.72 0 0 1-.72.62ZM14.7 33.28h-.16A16 16 0 0 1 2.05 19.67a.73.73 0 0 1 1.44-.18 14.56 14.56 0 0 0 11.37 12.37.72.72 0 0 1-.16 1.42ZM20.68 33.41a.73.73 0 0 1-.71-.6.71.71 0 0 1 .59-.83 14.67 14.67 0 0 0 12-12.49.73.73 0 0 1 1.44.18A16.13 16.13 0 0 1 20.81 33.4ZM33.21 16.2a.72.72 0 0 1-.72-.62 14.52 14.52 0 0 0-11.93-12.2.72.72 0 1 1 .25-1.38 15.94 15.94 0 0 1 13.11 13.37.72.72 0 0 1-.61.82Z"
                    }),
                    /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                        className: "customizeYourOwnWorkflow_svg__cls-2",
                        d: "M14 6.26a.74.74 0 0 1-.25 0 .71.71 0 0 1-.43-.92l.94-2.57-2.66-1a.7.7 0 0 1-.43-.92.73.73 0 0 1 .93-.43l3.33 1.2a.72.72 0 0 1 .44.92l-1.22 3.24a.73.73 0 0 1-.68.48ZM33.51 16.54a.64.64 0 0 1-.35-.1l-3-1.71a.71.71 0 0 1-.27-1 .72.72 0 0 1 1-.27l2.39 1.35 1.4-2.43a.74.74 0 0 1 1-.27.71.71 0 0 1 .27 1l-1.75 3.06a.73.73 0 0 1-.64.37ZM22.88 35.63a.7.7 0 0 1-.47-.17l-2.72-2.26a.72.72 0 0 1-.26-.49.74.74 0 0 1 .17-.52l2.24-2.65a.74.74 0 0 1 1-.09.71.71 0 0 1 .09 1l-1.77 2.1 2.16 1.8a.72.72 0 0 1 .09 1 .75.75 0 0 1-.55.25ZM.72 22.88a.75.75 0 0 1-.42-.14.71.71 0 0 1-.16-1l2.09-2.85a.72.72 0 0 1 1-.15l2.82 2a.72.72 0 1 1-.86 1.16L3 20.31l-1.69 2.27a.73.73 0 0 1-.59.3Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M18 15.44A2.56 2.56 0 1 0 20.58 18 2.58 2.58 0 0 0 18 15.44Z",
                style: {
                    fill: "#fff"
                }
            })
        ]
    });
var $a4d6f66506af69c0$export$2e2bcd8739ae039 = $a4d6f66506af69c0$var$SvgCustomizeYourOwnWorkflow;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $61a968b0d04c3faa$var$SvgDoATestReturn = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        id: "doATestReturn_svg__Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("defs", {
                children: /*#__PURE__*/ (0, $bb3TF.jsx)("style", {
                    children: ".doATestReturn_svg__cls-1{fill:#fff}.doATestReturn_svg__cls-2{fill:#dfe9f7}.doATestReturn_svg__cls-3{fill:#0a64b2}.doATestReturn_svg__cls-4{fill:none}"
                })
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "doATestReturn_svg__cls-1",
                d: "M27.05 19.05V5.63a2.16 2.16 0 0 0-2.16-2.15h-3.95v-.29A1.22 1.22 0 0 0 19.72 2h-2.54v-.78A1.22 1.22 0 0 0 16 0h-1.52a1.22 1.22 0 0 0-1.21 1.22V2h-2.55a1.21 1.21 0 0 0-1.21 1.19v.29h-4a2.16 2.16 0 0 0-2.12 2.15v24.1a2.16 2.16 0 0 0 2.16 2.16h12.13a7.32 7.32 0 0 1-.23-.8 8.21 8.21 0 0 1-.24-2V29a8.56 8.56 0 0 1 5-7.68 8.65 8.65 0 0 1 1.91-.59 8.41 8.41 0 0 1 1.59-.16 8.58 8.58 0 0 1 1.35.11v-1.63Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "doATestReturn_svg__cls-1",
                d: "M31 24.7a6.8 6.8 0 0 0-1.33-1.24 6.93 6.93 0 0 0-6.84-.66 7.07 7.07 0 0 0-1.33.79 6.9 6.9 0 0 0-2.7 5.51 7.25 7.25 0 0 0 .2 1.62 6.68 6.68 0 0 0 .46 1.28A6.9 6.9 0 1 0 31 24.7Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "doATestReturn_svg__cls-2",
                d: "M13.04 13.08h9.78v.75h-9.78zM13.04 14.58h6.02v.75h-6.02zM13.04 17.59h9.78v.75h-9.78zM13.04 19.1h6.02v.75h-6.02zM13.04 22.11h6.25v.75h-6.25zM13.04 23.61h4.75v.75h-4.75z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "doATestReturn_svg__cls-3",
                d: "M12.18 12.75a.38.38 0 0 0-.54 0l-.36.36-.69.69L9.37 15l-.95-.95A.4.4 0 0 0 8 14a.42.42 0 0 0-.14.09.38.38 0 0 0 0 .54l.05.05 1.19 1.15a.37.37 0 0 0 .53 0l1.65-1.65.69-.69.21-.2a.38.38 0 0 0 0-.54ZM12.18 17.26a.4.4 0 0 0-.54 0l-.36.37-.69.69-1.22 1.22-.95-.94a.36.36 0 0 0-.42-.09.42.42 0 0 0-.14.09.37.37 0 0 0 0 .53l.05.06 1.19 1.16a.39.39 0 0 0 .53 0l1.65-1.66L12 18l.21-.21a.38.38 0 0 0-.03-.53Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "doATestReturn_svg__cls-4",
                d: "M11.83 8.39a.1.1 0 0 0 .1.1h6.58a.1.1 0 0 0 .1-.1v-.73h-6.78ZM16.24 1.22A.29.29 0 0 0 16 .93h-1.52a.29.29 0 0 0-.28.29V2h2ZM11.83 6.72h6.78v-.83h-6.78v.83z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "doATestReturn_svg__cls-2",
                d: "M24.89 4.41h-3.95v.26a1.22 1.22 0 0 1-1.22 1.21h-.17v.83h4.61a.89.89 0 0 1 .88.89v13.12h1.08V5.63a1.23 1.23 0 0 0-1.23-1.22ZM17.09 30H6.29a.89.89 0 0 1-.89-.89V7.61a.89.89 0 0 1 .89-.89h4.61v-.83h-.18a1.21 1.21 0 0 1-1.21-1.21v-.27h-4a1.22 1.22 0 0 0-1.18 1.22v24.1A1.21 1.21 0 0 0 5.55 31h12a6.46 6.46 0 0 1-.16-1Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "doATestReturn_svg__cls-4",
                d: "M10.73 5h9a.29.29 0 0 0 .27-.33V3.19a.29.29 0 0 0-.28-.28h-9a.29.29 0 0 0-.28.28v1.48a.3.3 0 0 0 .29.33Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "doATestReturn_svg__cls-3",
                d: "M17.51 31h-12a1.21 1.21 0 0 1-1.22-1.22V5.63a1.22 1.22 0 0 1 1.26-1.22h4v.26a1.21 1.21 0 0 0 1.21 1.21h.18v.83H6.29a.89.89 0 0 0-.89.89v21.48a.89.89 0 0 0 .89.89h11.06a8.48 8.48 0 0 1-.06-.87s0-.05 0-.07h-11V7.66h4.61v.73a1 1 0 0 0 1 1h6.58a1 1 0 0 0 1-1v-.73h4.56v13.18c.3-.05.62-.09.93-.12V7.61a.89.89 0 0 0-.88-.89h-4.54v-.83h.17a1.22 1.22 0 0 0 1.22-1.21v-.27h3.95a1.23 1.23 0 0 1 1.23 1.22V20.7c.31 0 .63 0 .93.09V5.63a2.16 2.16 0 0 0-2.16-2.15h-3.95v-.29A1.22 1.22 0 0 0 19.72 2h-2.54v-.78A1.22 1.22 0 0 0 16 0h-1.52a1.22 1.22 0 0 0-1.21 1.22V2h-2.55a1.21 1.21 0 0 0-1.21 1.19v.29h-4a2.16 2.16 0 0 0-2.12 2.15v24.1a2.16 2.16 0 0 0 2.16 2.16h12.22a7.71 7.71 0 0 1-.24-.82s-.01-.07-.02-.07Zm1.1-22.56a.1.1 0 0 1-.1.1h-6.58a.1.1 0 0 1-.1-.1v-.78h6.78Zm0-1.67h-6.78v-.88h6.78ZM14.2 1.22a.29.29 0 0 1 .28-.29H16a.29.29 0 0 1 .28.29V2h-2Zm-3.76 2a.29.29 0 0 1 .28-.28h9a.29.29 0 0 1 .28.28v1.45a.29.29 0 0 1-.28.29h-9a.3.3 0 0 1-.29-.29Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "doATestReturn_svg__cls-3",
                d: "M25.71 26.74h-1.54l.55-.55a.43.43 0 0 0 0-.61.42.42 0 0 0-.6 0l-1.29 1.29a.43.43 0 0 0 0 .6l1.29 1.29a.42.42 0 0 0 .6 0 .43.43 0 0 0 0-.61l-.55-.55h1.54a2.14 2.14 0 1 1-2.14 2.14.43.43 0 0 0-.43-.43.43.43 0 0 0-.43.43 3 3 0 1 0 3-3Z",
                id: "doATestReturn_svg__Layer_67",
                "data-name": "Layer 67"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "doATestReturn_svg__cls-3",
                d: "M31 24.7a6.8 6.8 0 0 0-1.33-1.24 6.93 6.93 0 0 0-6.84-.66 7.07 7.07 0 0 0-1.33.79 6.9 6.9 0 0 0-2.7 5.51 7.25 7.25 0 0 0 .2 1.62 6.68 6.68 0 0 0 .46 1.28A6.9 6.9 0 1 0 31 24.7Zm-5.3 10.22a5.86 5.86 0 0 1-5.62-4.28 6 6 0 0 1-.2-1.54 5.81 5.81 0 0 1 1.65-4.1 6 6 0 0 1 1.33-1 5.83 5.83 0 1 1 2.84 10.92Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "doATestReturn_svg__cls-2",
                d: "M18.61 6.72h-6.78v-.83h6.78v.83z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "doATestReturn_svg__cls-3",
                d: "M24.11 20.76v.08c.3-.05.62-.09.93-.12s.44 0 .66 0h.42c.31 0 .63 0 .93.09v-.08a8.58 8.58 0 0 0-1.35-.11 8.41 8.41 0 0 0-1.59.14ZM17.53 31.07v-.12a6.46 6.46 0 0 1-.16-1 8.48 8.48 0 0 1-.06-.87s0-.05 0-.07h-.09v.07a8.21 8.21 0 0 0 .24 2 7.32 7.32 0 0 0 .23.8h.09a7.71 7.71 0 0 1-.25-.81Z"
            })
        ]
    });
var $61a968b0d04c3faa$export$2e2bcd8739ae039 = $61a968b0d04c3faa$var$SvgDoATestReturn;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $2195c1f68416b5de$var$SvgImportClients = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        id: "importClients_svg__Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("defs", {
                children: /*#__PURE__*/ (0, $bb3TF.jsx)("style", {
                    children: ".importClients_svg__cls-3{fill:#0a64b2}"
                })
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M18.76 22.34a2.36 2.36 0 0 0 3.8-1.8 2.37 2.37 0 0 0 2.28-2.29A2.36 2.36 0 0 0 27.12 16a2.38 2.38 0 0 0 1.6-4.05l-.16-.15a7.14 7.14 0 0 0 1.61-4.55A7.21 7.21 0 0 0 18 2 7.21 7.21 0 0 0 7.82 12.19 2.37 2.37 0 0 0 9.64 16a2.36 2.36 0 0 0 2.28 2.28 2.38 2.38 0 0 0 2.28 2.29 2.38 2.38 0 0 0 2.37 2.29 2.54 2.54 0 0 0 .67-.11l.93-.88Z",
                style: {
                    fill: "#fff"
                }
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M13 1.52a5.7 5.7 0 0 1 3.88 1.53l-3.67 3.71a1.78 1.78 0 0 0-.54 1.29 1.84 1.84 0 0 0 1.84 1.84h2.86A2.26 2.26 0 0 0 19 9.22l.86-.85h.57A6 6 0 0 0 22.6 8l5 5.05a.86.86 0 0 1-.6 1.46.84.84 0 0 1-.6-.25l-1.77-1.86-1.08 1.07 1.81 1.81a.86.86 0 0 1 .25.61.85.85 0 0 1-.85.85.86.86 0 0 1-.61-.25l-1.81-1.81-1.07 1.08 1.81 1.81a.84.84 0 0 1 .25.6.86.86 0 0 1-1.46.6L20.06 17 19 18l1.81 1.81a.84.84 0 0 1 .25.6.86.86 0 0 1-.85.86.84.84 0 0 1-.6-.25l-.26-.26a2.23 2.23 0 0 0 .19-.92 2.37 2.37 0 0 0-2.29-2.37A2.36 2.36 0 0 0 15 15.23a2.38 2.38 0 0 0-2.28-2.29 2.38 2.38 0 0 0-2.37-2.29 2.34 2.34 0 0 0-1.4.47A5.69 5.69 0 0 1 13 1.52Z",
                style: {
                    fill: "#dfe9f7"
                }
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "importClients_svg__cls-3",
                d: "M18.76 22.34a2.36 2.36 0 0 0 3.8-1.8 2.37 2.37 0 0 0 2.28-2.29A2.36 2.36 0 0 0 27.12 16a2.38 2.38 0 0 0 1.6-4.05l-.16-.15a7.14 7.14 0 0 0 1.61-4.55A7.21 7.21 0 0 0 18 2 7.21 7.21 0 0 0 7.82 12.19 2.37 2.37 0 0 0 9.64 16a2.36 2.36 0 0 0 2.28 2.28 2.38 2.38 0 0 0 2.28 2.29 2.38 2.38 0 0 0 2.37 2.29 2.54 2.54 0 0 0 .67-.11l.93-.88ZM23 1.52a5.69 5.69 0 0 1 4.51 9.16L24 7.18a6.87 6.87 0 0 0 .66-.55l-1.11-1.08a4.4 4.4 0 0 1-3.14 1.3h-1.2l-1.3 1.3a.79.79 0 0 1-.54.22h-2.86a.31.31 0 0 1-.31-.32.31.31 0 0 1 .09-.22l4.64-4.64a5.66 5.66 0 0 1 4-1.67Zm-10 0a5.7 5.7 0 0 1 3.88 1.53l-3.67 3.71a1.78 1.78 0 0 0-.54 1.29 1.84 1.84 0 0 0 1.84 1.84h2.86A2.26 2.26 0 0 0 19 9.22l.86-.85h.57A6 6 0 0 0 22.6 8l5 5.05a.86.86 0 0 1-.6 1.46.84.84 0 0 1-.6-.25l-1.77-1.86-1.08 1.07 1.81 1.81a.86.86 0 0 1 .25.61.85.85 0 0 1-.85.85.86.86 0 0 1-.61-.25l-1.81-1.81-1.07 1.08 1.81 1.81a.84.84 0 0 1 .25.6.86.86 0 0 1-1.46.6L20.06 17 19 18l1.81 1.81a.84.84 0 0 1 .25.6.86.86 0 0 1-.85.86.84.84 0 0 1-.6-.25l-.26-.26a2.23 2.23 0 0 0 .19-.92 2.37 2.37 0 0 0-2.29-2.37A2.36 2.36 0 0 0 15 15.23a2.38 2.38 0 0 0-2.28-2.29 2.38 2.38 0 0 0-2.37-2.29 2.34 2.34 0 0 0-1.4.47A5.69 5.69 0 0 1 13 1.52ZM8.87 13.6a.86.86 0 0 1 .25-.6l.58-.58a.84.84 0 0 1 .6-.25.86.86 0 0 1 .85.86.84.84 0 0 1-.25.6l-.57.58a.88.88 0 0 1-.61.25.86.86 0 0 1-.85-.86Zm2.28 2.29a.86.86 0 0 1 .25-.61l.58-.57a.84.84 0 0 1 .6-.25.85.85 0 0 1 .85.85.8.8 0 0 1-.25.6l-.57.58a.86.86 0 0 1-.61.25.85.85 0 0 1-.85-.85Zm2.28 2.28a.84.84 0 0 1 .25-.6l.58-.58a.86.86 0 0 1 1.21 1.21l-.58.57a.84.84 0 0 1-.6.25.86.86 0 0 1-.86-.85Zm3.14 3.14a.86.86 0 0 1-.85-.86.84.84 0 0 1 .25-.6l.57-.58a.86.86 0 0 1 1.21 1.21l-.58.58a.84.84 0 0 1-.6.25ZM24.1 29.13a.91.91 0 0 0-1.29 0l-3.9 3.82v-8a.91.91 0 1 0-1.82 0v8l-3.9-3.81a.91.91 0 1 0-1.27 1.29l5.45 5.33a.9.9 0 0 0 1.28 0l5.43-5.32a.9.9 0 0 0 .02-1.31Z"
            })
        ]
    });
var $2195c1f68416b5de$export$2e2bcd8739ae039 = $2195c1f68416b5de$var$SvgImportClients;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $8b22fb07f35dcb9f$var$SvgScheduleOneWelcomeCall = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M19 10.09a7.3 7.3 0 1 0 7.24-7.29A7.3 7.3 0 0 0 19 10.09Z",
                style: {
                    fill: "#fff"
                }
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M34.3 26.6c-1-.55-2-1.08-3-1.65l-2.8-1.48a5 5 0 0 0-2.4-.65 4.27 4.27 0 0 0-2.19.6l-.56.34a3.47 3.47 0 0 1-1.78.5 3.44 3.44 0 0 1-2.26-.87 72.35 72.35 0 0 1-6.73-6.72 3.39 3.39 0 0 1-.37-4l.34-.57a4.53 4.53 0 0 0 0-4.57C11.5 5.59 10.62 4 9.68 2.28l-.31-.58A3.16 3.16 0 0 0 6.65 0a3.16 3.16 0 0 0-.81.11C3.73.72 1.63 2.91.6 5.56a6.57 6.57 0 0 0 .12 5.78 73.32 73.32 0 0 0 10.75 13.47 72.41 72.41 0 0 0 13.18 10.43 5.36 5.36 0 0 0 2.86.76c3.49 0 7.49-2.8 8.37-5.87a3.05 3.05 0 0 0-1.58-3.53Z",
                style: {
                    fill: "#dfe9f7"
                }
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M34.3 26.6c-1-.55-2-1.08-3-1.65l-2.8-1.48a5 5 0 0 0-2.4-.65 4.27 4.27 0 0 0-2.19.6l-.56.34a3.47 3.47 0 0 1-1.78.5 3.44 3.44 0 0 1-2.26-.87 72.35 72.35 0 0 1-6.73-6.72 3.39 3.39 0 0 1-.37-4l.34-.57a4.53 4.53 0 0 0 0-4.57C11.5 5.59 10.62 4 9.68 2.28l-.31-.58A3.16 3.16 0 0 0 6.65 0a3.16 3.16 0 0 0-.81.11C3.73.72 1.63 2.91.6 5.56a6.57 6.57 0 0 0 .12 5.78 73.32 73.32 0 0 0 10.75 13.47 72.41 72.41 0 0 0 13.18 10.43 5.36 5.36 0 0 0 2.86.76c3.49 0 7.49-2.8 8.37-5.87a3.05 3.05 0 0 0-1.58-3.53Zm0 3.06c-.68 2.35-4 4.65-6.75 4.65a3.77 3.77 0 0 1-2-.51 70.59 70.59 0 0 1-12.89-10.19 71.39 71.39 0 0 1-10.5-13.15 5 5 0 0 1 0-4.29C3 4 4.71 2.2 6.31 1.74a1 1 0 0 1 .34-.05 1.47 1.47 0 0 1 1.24.82l.31.58c.93 1.7 1.8 3.3 2.8 5.2a2.92 2.92 0 0 1 .08 2.92l-.34.57a5 5 0 0 0 .55 6 73.35 73.35 0 0 0 6.89 6.88A5.12 5.12 0 0 0 21.57 26a5.19 5.19 0 0 0 2.64-.74l.56-.33a2.57 2.57 0 0 1 1.33-.37 3.22 3.22 0 0 1 1.59.44l2.76 1.49c1.06.56 2.05 1.1 3 1.64a1.39 1.39 0 0 1 .81 1.53ZM29.9.53A.84.84 0 0 1 31 .07a13.53 13.53 0 0 1 3.19 1.87.84.84 0 1 1-1 1.33 12.25 12.25 0 0 0-2.78-1.64.84.84 0 0 1-.51-1.1Zm-11.75 2.6a.86.86 0 0 1 .15-1.19A13.84 13.84 0 0 1 21.51.06a.84.84 0 1 1 .63 1.56 12 12 0 0 0-2.8 1.65.85.85 0 0 1-1.19-.14Zm.8 7a7.3 7.3 0 1 0 7.29-7.33A7.3 7.3 0 0 0 19 10.09Zm7.29-5.6a5.61 5.61 0 1 1-5.6 5.6 5.61 5.61 0 0 1 5.6-5.6Zm-.59 6.2a.86.86 0 0 1-.25-.6V6.49a.85.85 0 1 1 1.69 0v3.25l2 2a.85.85 0 1 1-1.19 1.2Z",
                style: {
                    fill: "#0a64b2"
                }
            })
        ]
    });
var $8b22fb07f35dcb9f$export$2e2bcd8739ae039 = $8b22fb07f35dcb9f$var$SvgScheduleOneWelcomeCall;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $139b81d6045ce426$var$SvgSendEmai = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        id: "sendEmai_svg__Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("defs", {
                children: /*#__PURE__*/ (0, $bb3TF.jsx)("style", {
                    children: ".sendEmai_svg__cls-3{fill:#0a64b2}"
                })
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M32.4 12.59V5.83a.43.43 0 0 0-.4-.43h-7.32L19.53.6a2.25 2.25 0 0 0-3.06 0l-5.15 4.8H4a.43.43 0 0 0-.43.43v6.76L0 15.94v19.3a.76.76 0 0 0 .75.76h34.5a.76.76 0 0 0 .75-.76v-19.3Z",
                style: {
                    fill: "#fff"
                }
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                style: {
                    fill: "#dfe9f7"
                },
                d: "M4.17 10.88h27.44v8.28l-8.8 6.74h-9.84l-8.8-6.74v-8.28z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "sendEmai_svg__cls-3",
                d: "M32.4 12.59V5.83a.43.43 0 0 0-.4-.43h-7.32L19.53.6a2.25 2.25 0 0 0-3.06 0l-5.15 4.8H4a.43.43 0 0 0-.43.43v6.76L0 15.94v19.3a.76.76 0 0 0 .75.76h34.5a.76.76 0 0 0 .75-.76v-19.3ZM12 25.66a.34.34 0 0 0 0 .28L1.2 34.19V17.41Zm1.37.74h9.2l11 8.4H2.38Zm21.4-9v16.79l-11-8.39Zm-.32-1.25h-.06l-2 1.54v-3.47ZM17.29 1.48a1 1 0 0 1 1.42 0l4.21 3.92h-9.84ZM4.8 7a.43.43 0 0 1 .43-.43h25.54a.43.43 0 0 1 .43.43v11.64l-8.6 6.56h-9.2l-8.6-6.56V7ZM3.6 17.73l-2-1.54h-.06l2.06-1.97Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "sendEmai_svg__cls-3",
                d: "M8.2 9.39a.7.7 0 1 1 .7-.7.69.69 0 0 1-.7.7ZM11 9.39a.7.7 0 1 1 .7-.7.69.69 0 0 1-.7.7ZM13.7 9.39a.7.7 0 1 1 .7-.7.69.69 0 0 1-.7.7ZM13 19.24H7.37a.42.42 0 0 1-.37-.42v-5.58a.42.42 0 0 1 .42-.42H13a.42.42 0 0 1 .42.42v5.58a.42.42 0 0 1-.42.42Zm-5.21-.84h4.74v-4.74H7.79ZM28.63 19.24H15.5a.42.42 0 0 1-.42-.42v-5.58a.42.42 0 0 1 .42-.42h13.13a.42.42 0 0 1 .42.42v5.58a.42.42 0 0 1-.42.42Zm-12.71-.84h12.29v-4.74H15.92ZM19 21.71H7.37a.42.42 0 1 1 0-.83H19a.42.42 0 0 1 0 .83ZM31.71 11.52H4.44a.42.42 0 1 1 0-.83h27.27a.42.42 0 1 1 0 .83ZM28.63 21.71H21a.42.42 0 1 1 0-.83h7.59a.42.42 0 1 1 0 .83ZM14.78 24.19h-4.1a.42.42 0 1 1 0-.83h4.1a.42.42 0 1 1 0 .83ZM25.44 24.19h-8.91a.42.42 0 0 1 0-.83h8.91a.42.42 0 0 1 0 .83Z"
            })
        ]
    });
var $139b81d6045ce426$export$2e2bcd8739ae039 = $139b81d6045ce426$var$SvgSendEmai;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $4e3d18687fd27b0f$var$SvgSetupBranding = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        id: "setupBranding_svg__Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("defs", {
                children: /*#__PURE__*/ (0, $bb3TF.jsx)("style", {
                    children: ".setupBranding_svg__cls-1{fill:#fff}.setupBranding_svg__cls-2{fill:#dfe9f7}.setupBranding_svg__cls-3{fill:#0a64b2}"
                })
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "setupBranding_svg__cls-1",
                d: "M16.46 27.76h2.7l1.36 4.74H15.1l1.36-4.74z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "setupBranding_svg__cls-1",
                d: "M3.48 4.81a1.76 1.76 0 0 0-1.76 1.76v20.11a1.76 1.76 0 0 0 1.76 1.76h29a1.76 1.76 0 0 0 1.76-1.76V6.57a1.76 1.76 0 0 0-1.76-1.76Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "setupBranding_svg__cls-2",
                d: "M2.24 21.67h31.15v6.09H2.24zM23 33.43a.72.72 0 0 1 .72.72v.44H12.24v-.44a.72.72 0 0 1 .72-.72ZM27 2.15a1.67 1.67 0 1 1 2.68 2L25 9.89l-2.1-1.55ZM21.39 17c-1.1.77-3.16-.27-5.12.78-.48-2.5-.18-4.84 2.32-5.36a4 4 0 0 1 1-.09l2.55 1.89a2.26 2.26 0 0 1-.75 2.78Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "setupBranding_svg__cls-3",
                d: "M21.39 17c-1.1.77-3.16-.27-5.12.78-.48-2.5-.18-4.84 2.32-5.36a4 4 0 0 1 1-.09l2.55 1.89a2.26 2.26 0 0 1-.75 2.78Zm.71-7.53 2 1.47-1.53 1.87-1.8-1.34ZM27 2.15a1.67 1.67 0 1 1 2.68 2L25 9.89l-2.1-1.55Zm4 2.53a3.08 3.08 0 0 0-5.19-3.31l-2.17 3.31-.95 1.41C22 7.09 20.06 10 19.43 11a4.77 4.77 0 0 0-3.65 1.55c-1.23 1.43-1.44 3.67-.64 6.68a.7.7 0 0 0 1.16.32c1.82-1.73 4.09.16 6.11-1.48A3.67 3.67 0 0 0 23.48 14l6.44-7.86ZM13 32a2.14 2.14 0 0 0-2.13 2.13v.44H8.61a.71.71 0 0 0-.7.71.7.7 0 0 0 .7.7h18.78a.7.7 0 0 0 .7-.7.71.71 0 0 0-.7-.71h-2.22v-.44A2.14 2.14 0 0 0 23 32h-1.8l-.83-3.5H19l.8 3.5h-3.6l.84-3.5h-1.45l-.83 3.5Zm10 1.43a.72.72 0 0 1 .72.72v.44H12.24v-.44a.72.72 0 0 1 .72-.72Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "setupBranding_svg__cls-3",
                d: "M32.95 6.13v21H3.05v-21H33m0-1.34H3a1.32 1.32 0 0 0-1.28 1.34V27.2A1.32 1.32 0 0 0 3 28.52h30a1.32 1.32 0 0 0 1.32-1.32V6.13A1.32 1.32 0 0 0 33 4.81Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "setupBranding_svg__cls-3",
                d: "M1.72 20.98h32.56v1.41H1.72z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "setupBranding_svg__cls-2",
                d: "m22.1 9.51 2 1.47-1.53 1.87-1.8-1.34Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "setupBranding_svg__cls-1",
                d: "M27 2.15a1.67 1.67 0 1 1 2.68 2L25 9.89l-2.1-1.55Z"
            })
        ]
    });
var $4e3d18687fd27b0f$export$2e2bcd8739ae039 = $4e3d18687fd27b0f$var$SvgSetupBranding;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $73f43854409af5f6$var$SvgTestVideoCapabilityWithStaff = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        id: "testVideoCapabilityWithStaff_svg__Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("defs", {
                children: /*#__PURE__*/ (0, $bb3TF.jsx)("style", {
                    children: ".testVideoCapabilityWithStaff_svg__cls-1{fill:#fff}.testVideoCapabilityWithStaff_svg__cls-3{fill:#0a64b2}"
                })
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "testVideoCapabilityWithStaff_svg__cls-1",
                d: "M34.27 18.6a7.52 7.52 0 0 0-5.82-2.74 7.53 7.53 0 0 0-7.55 7.55 7.65 7.65 0 0 0 .72 3.23 7.55 7.55 0 1 0 12.65-8Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M23.88 15.84V8.67a2.18 2.18 0 0 0-2.18-2.18H3.63a2.19 2.19 0 0 0-2.18 2.18V23a2.18 2.18 0 0 0 2.18 2.18h16.16a8.57 8.57 0 0 1-.18-1.77 8.81 8.81 0 0 1 4.27-7.57Z",
                style: {
                    fill: "#dfe9f7"
                }
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "testVideoCapabilityWithStaff_svg__cls-3",
                d: "M3.63 25.18A2.18 2.18 0 0 1 1.45 23V8.67a2.19 2.19 0 0 1 2.18-2.18H21.7a2.18 2.18 0 0 1 2.18 2.18v7.17a8.85 8.85 0 0 1 1.45-.71V12.9l7.49-4.09v6.91a8.88 8.88 0 0 1 1.45 1V7.59A.73.73 0 0 0 33.2 7l-7.87 4.3V8.67A3.63 3.63 0 0 0 21.7 5H3.63A3.64 3.64 0 0 0 0 8.67V23a3.64 3.64 0 0 0 3.63 3.64h16.58a9 9 0 0 1-.42-1.46Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "testVideoCapabilityWithStaff_svg__cls-3",
                d: "m31 21-.56.57-1.07 1.07-1.91 1.9-1.47-1.46a.58.58 0 0 0-.61-.14.59.59 0 0 0-.22 1l.08.08L27 25.81a.6.6 0 0 0 .84 0l2.57-2.57 1.07-1.07.32-.32A.59.59 0 0 0 31 21Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "testVideoCapabilityWithStaff_svg__cls-3",
                d: "M34.27 18.6a7.52 7.52 0 0 0-5.82-2.74 7.53 7.53 0 0 0-7.55 7.55 7.65 7.65 0 0 0 .72 3.23 7.55 7.55 0 1 0 12.65-8Zm-5.82 11.18a6.41 6.41 0 0 1-6.15-4.68 6.75 6.75 0 0 1-.22-1.69 6.35 6.35 0 0 1 1.8-4.41 6.81 6.81 0 0 1 1.45-1.11 6.37 6.37 0 1 1 3.12 11.93Z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                className: "testVideoCapabilityWithStaff_svg__cls-1",
                d: "M25.33 12.9v2a9 9 0 0 1 7.49.57V8.81Z"
            })
        ]
    });
var $73f43854409af5f6$export$2e2bcd8739ae039 = $73f43854409af5f6$var$SvgTestVideoCapabilityWithStaff;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $2543d1d2b9183e54$var$SvgIdcardTwoTone = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        "data-icon": "idcard",
        width: "1em",
        height: "1em",
        fill: "currentColor",
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "64 64 896 896",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z",
                fill: "#1164b2"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M136 792h752V232H136v560zm472-372c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm0 144c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48c0 4.4-3.2 8-7.1 8H615.1c-3.9 0-7.1-3.6-7.1-8v-48zM216.2 664.6c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.6 26.4 71.8 72.8 74.6 126.1a8 8 0 0 1-8 8.4h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224c-4.6 0-8.2-3.8-7.8-8.4z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M321.3 463a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z",
                fill: "#1164b2"
            })
        ]
    });
var $2543d1d2b9183e54$export$2e2bcd8739ae039 = $2543d1d2b9183e54$var$SvgIdcardTwoTone;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $ebcb44d34b1ec734$var$SvgUserOutlined = (props)=>/*#__PURE__*/ (0, $bb3TF.jsx)("svg", {
        viewBox: "64 64 896 896",
        "data-icon": "user",
        width: "1em",
        height: "1em",
        fill: "#1164b2",
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
            d: "M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"
        })
    });
var $ebcb44d34b1ec734$export$2e2bcd8739ae039 = $ebcb44d34b1ec734$var$SvgUserOutlined;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $84eef43eff5047d1$var$SvgUserFilled = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 548.169,
        height: 548.169,
        style: {
            enableBackground: "new 0 0 548.169 548.169"
        },
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M109.634 164.452c20.179 0 37.402-7.135 51.674-21.411 14.277-14.275 21.416-31.503 21.416-51.678 0-20.173-7.139-37.401-21.416-51.678-14.272-14.275-31.496-21.414-51.674-21.414-20.177 0-37.401 7.139-51.676 21.414-14.274 14.277-21.413 31.501-21.413 51.678 0 20.179 7.139 37.403 21.413 51.678 14.275 14.272 31.499 21.411 51.676 21.411zM196.569 278.519c21.413 21.406 47.248 32.114 77.516 32.114 30.269 0 56.103-10.708 77.515-32.114 21.409-21.42 32.117-47.258 32.117-77.52 0-30.264-10.708-56.101-32.117-77.515-21.412-21.414-47.246-32.121-77.515-32.121-30.268 0-56.105 10.709-77.516 32.121-21.411 21.411-32.12 47.248-32.12 77.515s10.709 56.103 32.12 77.52zM438.543 164.452c20.17 0 37.397-7.135 51.671-21.411 14.274-14.275 21.409-31.503 21.409-51.678 0-20.173-7.135-37.401-21.409-51.678-14.273-14.275-31.501-21.414-51.671-21.414-20.184 0-37.407 7.139-51.682 21.414-14.271 14.277-21.409 31.501-21.409 51.678 0 20.179 7.139 37.403 21.409 51.678 14.275 14.272 31.498 21.411 51.682 21.411zM512.763 164.456c-1.136 0-5.276 1.999-12.415 5.996-7.132 3.999-16.416 8.044-27.833 12.137-11.416 4.089-22.747 6.136-33.972 6.136-12.758 0-25.406-2.187-37.973-6.567.945 7.039 1.424 13.322 1.424 18.842 0 26.457-7.71 50.819-23.134 73.089 30.841.955 56.056 13.134 75.668 36.552h38.256c15.605 0 28.739-3.863 39.396-11.57 10.657-7.703 15.989-18.986 15.989-33.83.003-67.194-11.793-100.789-35.406-100.785z"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M470.096 395.284c-1.999-11.136-4.524-21.464-7.57-30.978-3.046-9.521-7.139-18.794-12.271-27.836-5.141-9.034-11.044-16.748-17.706-23.127-6.667-6.379-14.805-11.464-24.414-15.276-9.609-3.806-20.225-5.708-31.833-5.708-1.906 0-5.996 2.047-12.278 6.14a3489 3489 0 0 0-20.841 13.702c-7.615 5.037-17.789 9.609-30.55 13.702-12.762 4.093-25.608 6.14-38.544 6.14-12.941 0-25.791-2.047-38.544-6.14-12.756-4.093-22.936-8.665-30.55-13.702a3554.86 3554.86 0 0 0-20.841-13.702c-6.283-4.093-10.373-6.14-12.279-6.14-11.609 0-22.22 1.902-31.833 5.708-9.613 3.812-17.749 8.897-24.41 15.276-6.667 6.372-12.562 14.093-17.705 23.127-5.137 9.042-9.229 18.315-12.275 27.836-3.045 9.514-5.564 19.842-7.566 30.978-2 11.136-3.331 21.505-3.997 31.121a427.043 427.043 0 0 0-.999 29.554c0 22.836 6.945 40.874 20.839 54.098 13.899 13.223 32.363 19.842 55.389 19.842h249.535c23.028 0 41.49-6.619 55.392-19.842 13.894-13.224 20.841-31.262 20.841-54.098 0-10.088-.335-19.938-.992-29.554-.676-9.616-2.007-19.986-3.998-31.121zM169.303 274.088c-15.418-22.27-23.125-46.632-23.122-73.089 0-5.52.477-11.799 1.427-18.842-12.564 4.377-25.221 6.567-37.974 6.567-11.23 0-22.552-2.046-33.974-6.136-11.417-4.093-20.699-8.138-27.834-12.137-7.138-3.997-11.281-5.996-12.422-5.996C11.801 164.456 0 198.051 0 265.24c0 14.844 5.33 26.127 15.987 33.83 10.66 7.707 23.794 11.563 39.397 11.563h38.26c19.607-23.411 44.823-35.591 75.659-36.545z"
            })
        ]
    });
var $84eef43eff5047d1$export$2e2bcd8739ae039 = $84eef43eff5047d1$var$SvgUserFilled;



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $ccb0110de073a5eb$var$SvgAiMagic = (props)=>/*#__PURE__*/ (0, $bb3TF.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 32,
            d: "M259.92 262.91 216.4 149.77a9 9 0 0 0-16.8 0l-43.52 113.14a9 9 0 0 1-5.17 5.17L37.77 311.6a9 9 0 0 0 0 16.8l113.14 43.52a9 9 0 0 1 5.17 5.17l43.52 113.14a9 9 0 0 0 16.8 0l43.52-113.14a9 9 0 0 1 5.17-5.17l113.14-43.52a9 9 0 0 0 0-16.8l-113.14-43.52a9 9 0 0 1-5.17-5.17M108 68 88 16 68 68 16 88l52 20 20 52 20-52 52-20zm318.67 49.33L400 48l-26.67 69.33L304 144l69.33 26.67L400 240l26.67-69.33L496 144z"
        })
    });
var $ccb0110de073a5eb$export$2e2bcd8739ae039 = $ccb0110de073a5eb$var$SvgAiMagic;


const $c8efa4c2e6243fee$export$f04a61298a47a40f = {
    addTeamembers: $12002acf5fa75244$export$2e2bcd8739ae039,
    connectCalendar: $96e57deddb4ac05c$export$2e2bcd8739ae039,
    connectingStripe: $3049c71d8ef8d45b$export$2e2bcd8739ae039,
    customizeYourOwnWorkflow: $a4d6f66506af69c0$export$2e2bcd8739ae039,
    doATestReturn: $61a968b0d04c3faa$export$2e2bcd8739ae039,
    importClients: $2195c1f68416b5de$export$2e2bcd8739ae039,
    scheduleOneWelcomeCall: $8b22fb07f35dcb9f$export$2e2bcd8739ae039,
    sendEmai: $139b81d6045ce426$export$2e2bcd8739ae039,
    setupBranding: $4e3d18687fd27b0f$export$2e2bcd8739ae039,
    testVideoCapabilityWithStaff: $73f43854409af5f6$export$2e2bcd8739ae039,
    idcardTwoTone: $2543d1d2b9183e54$export$2e2bcd8739ae039,
    userOutlined: $ebcb44d34b1ec734$export$2e2bcd8739ae039,
    userFilled: $84eef43eff5047d1$export$2e2bcd8739ae039,
    AiMagic: $ccb0110de073a5eb$export$2e2bcd8739ae039
};
const $c8efa4c2e6243fee$export$cfaa2bf89b52bbef = {
    addTeamembers: true,
    connectCalendar: true,
    connectingStripe: true,
    customizeYourOwnWorkflow: true,
    doATestReturn: true,
    importClients: true,
    scheduleOneWelcomeCall: true,
    sendEmai: true,
    setupBranding: true,
    testVideoCapabilityWithStaff: true,
    AiMagic: true
};
 // export defualt Icons;


var $42035b49d2a07f66$export$534219b709288da9;
var $42035b49d2a07f66$export$44229d3eb35bf890;
var $42035b49d2a07f66$export$5e63894f961a3223;
var $42035b49d2a07f66$export$76faf538ac346bf;
var $42035b49d2a07f66$export$c153b473afeefaae;
var $42035b49d2a07f66$export$4bddaa7f02604dfc;
var $42035b49d2a07f66$export$1668583c27e172fe;
var $42035b49d2a07f66$export$e032c619be8e8a68;
$42035b49d2a07f66$export$534219b709288da9 = `QBI3GG_btn`;
$42035b49d2a07f66$export$44229d3eb35bf890 = `QBI3GG_btnComplete`;
$42035b49d2a07f66$export$5e63894f961a3223 = `QBI3GG_hasError`;
$42035b49d2a07f66$export$76faf538ac346bf = `QBI3GG_leftIcons`;
$42035b49d2a07f66$export$c153b473afeefaae = `QBI3GG_onBoardingListContainer`;
$42035b49d2a07f66$export$4bddaa7f02604dfc = `QBI3GG_rowEmail`;
$42035b49d2a07f66$export$1668583c27e172fe = `QBI3GG_secondSendButton`;
$42035b49d2a07f66$export$e032c619be8e8a68 = `QBI3GG_titleList`;


const { CheckCircleTwoTone: $efc99d4d4dd69b2b$var$CheckCircleTwoTone, CheckCircleFilled: $efc99d4d4dd69b2b$var$CheckCircleFilled } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { TextArea: $efc99d4d4dd69b2b$var$TextArea } = (0, $1fb834916a156dcf$export$2e2bcd8739ae039);
const $efc99d4d4dd69b2b$var$initialBody = `Dear Client,

First and foremost, we would like to express our gratitude for your continued trust in us. As part of our commitment to providing you with the best possible service, we are excited to announce the launch of our new secure, user-friendly client portal.

The first step in getting access is that you will receive an email containing a link to activate your new secure client portal. We encourage you to complete this process promptly. Here are some of the key benefits you can look forward to:

1. Secure Document Portal: We safeguard your sensitive information with bank-grade 256-bit AES encryption. Share and access your documents with us with confidence.

2. Appointment Scheduling: Schedule your appointments with us at your convenience directly through your portal.

3. Messaging: Send us quick updates, ask us questions and even have video calls with us right within the portal.

4. Mobile Access: Our mobile-friendly portal allows you to upload documents right from the camera on your phone.

5. Payments: Conveniently pay your invoices through the portal using credit/debit cards or ACH.

6. Electronic Signatures: Save time by signing your documents electronically right in the portal, ensuring a fast and seamless process.

With all these features in one place and a single login, working with us has never been easier. 

Please don't hesitate to reach out to us with any questions you may have.

Warm regards,

[Your Name], [Your Title] 
[Firm Name]
[Phone Number]
[Email Address]
`;
function $efc99d4d4dd69b2b$var$OnBoardingList({ userSteps: userSteps, updateUserStepStatus: updateUserStepStatus, setShowRegisterFlow: setShowRegisterFlow }) {
    const [editEmail, setEditEmail] = (0, $6fFrj.useState)(false);
    const [editEmailIndex, setEditEmailIndex] = (0, $6fFrj.useState)(null);
    const [sendEmailButtonIndex, setSendEmailButtonIndex] = (0, $6fFrj.useState)(null);
    const [editEmailButtonIndex, setEditEmailButtonIndex] = (0, $6fFrj.useState)(null);
    const { firmAccountId: firmAccountId } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    // useEffect to find index of email step
    (0, $6fFrj.useEffect)(()=>{
        setEditEmailIndex(userSteps.findIndex((userStep)=>userStep?.Steps?.name === 'templated-email'));
    }, [
        userSteps,
        setEditEmailIndex
    ]);
    // useEffect to find index of send email button
    (0, $6fFrj.useEffect)(()=>{
        if (editEmailIndex) {
            setSendEmailButtonIndex(userSteps[editEmailIndex]?.Steps?.Buttons?.findIndex((button)=>button.action === 'handleSendEmail'));
            setEditEmailButtonIndex(userSteps[editEmailIndex]?.Steps?.Buttons?.findIndex((button)=>button.action === 'handleEditEmail'));
        }
    }, [
        editEmailIndex,
        userSteps,
        setEditEmailIndex,
        setEditEmailButtonIndex
    ]);
    // graphql
    // send welcome emails mutation
    const [sendWelcomeEmails, { loading: loadingSendWelcomeEmails }] = (0, $38b15148eab410f9$export$d2e8d7c657f505e)({
        onCompleted: (data)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success(data?.sendWelcomeEmailToAllClients, 10);
            updateUserStepStatus(userSteps[editEmailIndex].userId, userSteps[editEmailIndex].stepId, true);
        },
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.toString().replace('Error: ', ''));
        }
    });
    const formik = (0, $ipnkk.useFormik)({
        validationSchema: $ee6ba11cc5736d52$export$185802fd694ee1f5().shape({
            subject: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('Subject is required.'),
            body: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('Body is required.')
        }),
        initialValues: {
            subject: 'Exciting Update: New Secure Client Portal and Enhanced Communication Tools',
            body: $efc99d4d4dd69b2b$var$initialBody
        },
        onSubmit: async (values)=>{
            if (values.body === $efc99d4d4dd69b2b$var$initialBody) {
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Please edit the email body before sending by adding your contact information at the end of the email.', 8);
                return;
            }
            // send welcome emails
            await sendWelcomeEmails({
                variables: {
                    sendWelcomeEmailInput: {
                        firmAccountId: firmAccountId,
                        subject: values.subject,
                        body: values.body
                    }
                }
            });
        }
    });
    const { values: values, errors: errors, handleSubmit: handleSubmit, handleChange: handleChange, validateForm: validateForm } = formik;
    const execAction = async (ev, stepId, userId, button)=>{
        if (button.link) {
            window.open(button.link, '_blank');
            // mark as completed
            // updateUserStepStatus(userId, stepId, true); // moved to manual only
            return;
        }
        switch(button.action){
            case 'handleBasicInfo':
                setShowRegisterFlow(true);
                break;
            case 'handleSendEmail':
                {
                    ev.preventDefault();
                    // if already completed return and do nothing
                    if (userSteps[editEmailIndex].completed) {
                        (0, $55c6005cab9be059$export$2e2bcd8739ae039).info('This step is already complete. Click the green check mark, to mark this step incomplete and send again.', 8);
                        return;
                    }
                    const formErrors = await validateForm();
                    if (Object.keys(formErrors)?.length === 0) handleSubmit();
                    else {
                        setEditEmail(true); // open up edit section if not already open
                        Object.keys(formErrors).forEach((key)=>{
                            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(formErrors[key]);
                        });
                    }
                    break;
                }
            case 'handleEditEmail':
                setEditEmail((prev)=>!prev);
                break;
            default:
                break;
        }
    };
    const popconfirmButton = (button, stepId, userId)=>(0, $bb3TF.jsx)((0, $a361442371f1d4e9$export$2e2bcd8739ae039), {
            title: button.popConfirm,
            okText: "Yes",
            cancelText: "No",
            onConfirm: (ev)=>execAction(ev, stepId, userId, button),
            okButtonProps: {
                danger: true
            },
            cancelButtonProps: {
                type: 'default'
            },
            children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                type: button.action === 'handleSendEmail' && loadingSendWelcomeEmails ? 'primary' : 'default',
                disabled: button.action === 'handleSendEmail' && loadingSendWelcomeEmails,
                className: $42035b49d2a07f66$export$534219b709288da9,
                loading: button.action === 'handleSendEmail' && loadingSendWelcomeEmails,
                children: button.label
            })
        });
    const normalButton = (button, stepId, userId, completed)=>(0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
            type: "default",
            className: !completed ? $42035b49d2a07f66$export$534219b709288da9 : $42035b49d2a07f66$export$44229d3eb35bf890,
            onClick: (ev)=>execAction(ev, stepId, userId, button),
            children: button.label
        });
    return (0, $bb3TF.jsx)((0, $bb3TF.Fragment), {
        children: (0, $bb3TF.jsxs)("div", {
            className: $42035b49d2a07f66$export$c153b473afeefaae,
            children: [
                (0, $bb3TF.jsx)((0, $550318ddff00815a$export$2e2bcd8739ae039), {
                    className: "on-boarding-list",
                    // loading={loading}
                    itemLayout: "horizontal",
                    dataSource: userSteps,
                    renderItem: ({ userId: userId, completed: completed, Steps: step })=>(0, $bb3TF.jsxs)((0, $550318ddff00815a$export$2e2bcd8739ae039).Item, {
                            style: {
                                alignItems: 'flex-start'
                            },
                            children: [
                                (0, $bb3TF.jsx)((0, $550318ddff00815a$export$2e2bcd8739ae039).Item.Meta, {
                                    avatar: (0, $bb3TF.jsxs)("div", {
                                        className: $42035b49d2a07f66$export$76faf538ac346bf,
                                        children: [
                                            completed ? (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                                title: completed ? 'Mark as not complete' : 'Mark as complete',
                                                children: (0, $bb3TF.jsx)($efc99d4d4dd69b2b$var$CheckCircleTwoTone, {
                                                    style: {
                                                        fontSize: 20
                                                    },
                                                    twoToneColor: "#52c41a",
                                                    onClick: ()=>updateUserStepStatus(userId, step?.id, false)
                                                })
                                            }) : (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                                title: completed ? 'Mark as not complete' : 'Mark as complete',
                                                children: (0, $bb3TF.jsx)($efc99d4d4dd69b2b$var$CheckCircleFilled, {
                                                    style: {
                                                        fontSize: 20,
                                                        color: '#e9eced'
                                                    },
                                                    onClick: ()=>updateUserStepStatus(userId, step.id, true)
                                                })
                                            }),
                                            step?.icon && (0, $bb3TF.jsx)((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                                                style: {
                                                    background: 'white',
                                                    marginLeft: '0px'
                                                },
                                                shape: "square",
                                                src: (0, $c8efa4c2e6243fee$export$f04a61298a47a40f)[step.icon],
                                                size: 30
                                            })
                                        ]
                                    }),
                                    title: (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                                        children: [
                                            step?.description,
                                            step?.tooltip && (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                                title: step.tooltip,
                                                children: (0, $bb3TF.jsx)((0, $60bea5c3f0793107$export$2e2bcd8739ae039), {
                                                    style: {
                                                        fontSize: 10,
                                                        position: 'relative',
                                                        top: '-0.5em',
                                                        left: '0.4em',
                                                        cursor: 'pointer'
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    gutter: [
                                        7,
                                        0
                                    ],
                                    children: step?.Buttons.map((button)=>(0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                            children: [
                                                !!button.popConfirm && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                                                    children: [
                                                        !completed && (0, $bb3TF.jsx)((0, $bb3TF.Fragment), {
                                                            children: popconfirmButton(button, step?.id, userId)
                                                        }),
                                                        completed && (0, $bb3TF.jsx)((0, $bb3TF.Fragment), {
                                                            children: normalButton(button, step?.id, userId, completed)
                                                        })
                                                    ]
                                                }),
                                                !button.popConfirm && (0, $bb3TF.jsx)((0, $bb3TF.Fragment), {
                                                    children: normalButton(button, step?.id, userId, completed)
                                                })
                                            ]
                                        }))
                                })
                            ]
                        })
                }),
                ' ',
                editEmail && (0, $bb3TF.jsxs)((0, $550318ddff00815a$export$2e2bcd8739ae039).Item, {
                    style: {
                        flexDirection: 'column'
                    },
                    children: [
                        (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                            layout: "vertical",
                            labelAlign: "left",
                            style: {
                                width: '100%'
                            },
                            children: [
                                (0, $bb3TF.jsxs)("label", {
                                    htmlFor: "subject",
                                    children: [
                                        "Subject:",
                                        ' '
                                    ]
                                }),
                                (0, $bb3TF.jsx)("div", {
                                    className: $42035b49d2a07f66$export$4bddaa7f02604dfc,
                                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                        name: "subject",
                                        // style={{ flex: 1 }}
                                        value: values.subject,
                                        onChange: handleChange,
                                        className: errors.subject ? $42035b49d2a07f66$export$5e63894f961a3223 : ''
                                    })
                                }),
                                (0, $bb3TF.jsx)("br", {}),
                                (0, $bb3TF.jsxs)("label", {
                                    htmlFor: "body",
                                    children: [
                                        "Body:",
                                        ' '
                                    ]
                                }),
                                (0, $bb3TF.jsx)("div", {
                                    className: $42035b49d2a07f66$export$4bddaa7f02604dfc,
                                    children: (0, $bb3TF.jsx)($efc99d4d4dd69b2b$var$TextArea, {
                                        name: "body",
                                        style: {
                                            flex: 1
                                        },
                                        value: values.body,
                                        onChange: handleChange,
                                        rows: 20,
                                        className: errors.body ? $42035b49d2a07f66$export$5e63894f961a3223 : ''
                                    })
                                })
                            ]
                        }),
                        (0, $bb3TF.jsxs)("div", {
                            className: $42035b49d2a07f66$export$1668583c27e172fe,
                            children: [
                                editEmailIndex !== null && sendEmailButtonIndex !== null && !!userSteps[editEmailIndex]?.Steps?.Buttons[sendEmailButtonIndex]?.popConfirm ? (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                                    children: [
                                        normalButton(userSteps[editEmailIndex]?.Steps?.Buttons[editEmailButtonIndex], userSteps[editEmailIndex]?.userId, userSteps[editEmailIndex]?.Steps.id, userSteps[editEmailIndex]?.completed),
                                        !userSteps[editEmailIndex]?.completed && (0, $bb3TF.jsx)((0, $bb3TF.Fragment), {
                                            children: popconfirmButton(userSteps[editEmailIndex]?.Steps?.Buttons[sendEmailButtonIndex], userSteps[editEmailIndex]?.Steps?.id, userSteps[editEmailIndex]?.userId)
                                        }),
                                        userSteps[editEmailIndex]?.completed && (0, $bb3TF.jsx)((0, $bb3TF.Fragment), {
                                            children: normalButton(userSteps[editEmailIndex]?.Steps?.Buttons[sendEmailButtonIndex], userSteps[editEmailIndex]?.userId, userSteps[editEmailIndex]?.Steps.id, userSteps[editEmailIndex]?.completed)
                                        })
                                    ]
                                }) : null,
                                editEmailIndex !== null && sendEmailButtonIndex !== null && !userSteps[editEmailIndex]?.Steps?.Buttons[sendEmailButtonIndex]?.popConfirm ? (0, $bb3TF.jsx)((0, $bb3TF.Fragment), {
                                    children: normalButton(userSteps[editEmailIndex]?.Steps.Buttons[sendEmailButtonIndex], userSteps[editEmailIndex]?.Steps.id, userSteps[editEmailIndex]?.userId, userSteps[editEmailIndex]?.completed)
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var // OnBoardingList.defaultProps = defaultProps;
$efc99d4d4dd69b2b$export$2e2bcd8739ae039 = $efc99d4d4dd69b2b$var$OnBoardingList;



var $bb3TF = parcelRequire("bb3TF");


var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");









var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




var $bb3TF = parcelRequire("bb3TF");

const { RightOutlined: $61da11bdaac935c8$var$RightOutlined, LeftOutlined: $61da11bdaac935c8$var$LeftOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $61da11bdaac935c8$var$CardNav({ onBack: onBack, onNext: onNext, onSkip: onSkip, loading: loading, showBack: showBack = true, showSkip: showSkip = true, disabled: disabled = false, nextText: nextText = 'Next', nextSubtext: nextSubtext = ()=>null, cancelSubtext: cancelSubtext = ()=>null }) {
    return (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        justify: !showBack ? 'start' : 'space-between',
        style: {
            marginTop: '5px'
        },
        children: [
            showBack ? (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                children: [
                    (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                        children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            icon: (0, $bb3TF.jsx)($61da11bdaac935c8$var$LeftOutlined, {}),
                            iconDirection: "left",
                            type: "default",
                            disabled: false,
                            onClick: onBack,
                            children: "Back"
                        })
                    }),
                    cancelSubtext()
                ]
            }) : (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {}),
            showSkip && (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        // icon={<LeftOutlined />}
                        // iconDirection="left"
                        type: "link",
                        disabled: false,
                        onClick: onSkip,
                        children: "Skip"
                    })
                })
            }),
            (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                children: [
                    (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                        children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "primary",
                            loading: loading,
                            htmlType: "submit",
                            icon: (0, $bb3TF.jsx)($61da11bdaac935c8$var$RightOutlined, {}),
                            disabled: disabled,
                            onClick: onNext || undefined,
                            children: nextText
                        })
                    }),
                    nextSubtext()
                ]
            })
        ]
    });
}
$61da11bdaac935c8$var$CardNav.defaultProps = {
    showBack: true,
    showSkip: true,
    loading: false,
    disabled: false,
    nextText: 'Next',
    nextSubtext: ()=>null,
    cancelSubtext: ()=>null,
    onBack: ()=>undefined,
    onNext: ()=>undefined,
    onSkip: ()=>undefined
};
var $61da11bdaac935c8$export$2e2bcd8739ae039 = $61da11bdaac935c8$var$CardNav;


const $d795f89fa43cfb57$var$USStates = [
    {
        name: 'Alabama',
        abbreviation: 'AL'
    },
    {
        name: 'Alaska',
        abbreviation: 'AK'
    },
    {
        name: 'American Samoa',
        abbreviation: 'AS'
    },
    {
        name: 'Arizona',
        abbreviation: 'AZ'
    },
    {
        name: 'Arkansas',
        abbreviation: 'AR'
    },
    {
        name: 'California',
        abbreviation: 'CA'
    },
    {
        name: 'Colorado',
        abbreviation: 'CO'
    },
    {
        name: 'Connecticut',
        abbreviation: 'CT'
    },
    {
        name: 'Delaware',
        abbreviation: 'DE'
    },
    {
        name: 'District Of Columbia',
        abbreviation: 'DC'
    },
    {
        name: 'Federated States Of Micronesia',
        abbreviation: 'FM'
    },
    {
        name: 'Florida',
        abbreviation: 'FL'
    },
    {
        name: 'Georgia',
        abbreviation: 'GA'
    },
    {
        name: 'Guam',
        abbreviation: 'GU'
    },
    {
        name: 'Hawaii',
        abbreviation: 'HI'
    },
    {
        name: 'Idaho',
        abbreviation: 'ID'
    },
    {
        name: 'Illinois',
        abbreviation: 'IL'
    },
    {
        name: 'Indiana',
        abbreviation: 'IN'
    },
    {
        name: 'Iowa',
        abbreviation: 'IA'
    },
    {
        name: 'Kansas',
        abbreviation: 'KS'
    },
    {
        name: 'Kentucky',
        abbreviation: 'KY'
    },
    {
        name: 'Louisiana',
        abbreviation: 'LA'
    },
    {
        name: 'Maine',
        abbreviation: 'ME'
    },
    {
        name: 'Marshall Islands',
        abbreviation: 'MH'
    },
    {
        name: 'Maryland',
        abbreviation: 'MD'
    },
    {
        name: 'Massachusetts',
        abbreviation: 'MA'
    },
    {
        name: 'Michigan',
        abbreviation: 'MI'
    },
    {
        name: 'Minnesota',
        abbreviation: 'MN'
    },
    {
        name: 'Mississippi',
        abbreviation: 'MS'
    },
    {
        name: 'Missouri',
        abbreviation: 'MO'
    },
    {
        name: 'Montana',
        abbreviation: 'MT'
    },
    {
        name: 'Nebraska',
        abbreviation: 'NE'
    },
    {
        name: 'Nevada',
        abbreviation: 'NV'
    },
    {
        name: 'New Hampshire',
        abbreviation: 'NH'
    },
    {
        name: 'New Jersey',
        abbreviation: 'NJ'
    },
    {
        name: 'New Mexico',
        abbreviation: 'NM'
    },
    {
        name: 'New York',
        abbreviation: 'NY'
    },
    {
        name: 'North Carolina',
        abbreviation: 'NC'
    },
    {
        name: 'North Dakota',
        abbreviation: 'ND'
    },
    {
        name: 'Northern Mariana Islands',
        abbreviation: 'MP'
    },
    {
        name: 'Ohio',
        abbreviation: 'OH'
    },
    {
        name: 'Oklahoma',
        abbreviation: 'OK'
    },
    {
        name: 'Oregon',
        abbreviation: 'OR'
    },
    {
        name: 'Palau',
        abbreviation: 'PW'
    },
    {
        name: 'Pennsylvania',
        abbreviation: 'PA'
    },
    {
        name: 'Puerto Rico',
        abbreviation: 'PR'
    },
    {
        name: 'Rhode Island',
        abbreviation: 'RI'
    },
    {
        name: 'South Carolina',
        abbreviation: 'SC'
    },
    {
        name: 'South Dakota',
        abbreviation: 'SD'
    },
    {
        name: 'Tennessee',
        abbreviation: 'TN'
    },
    {
        name: 'Texas',
        abbreviation: 'TX'
    },
    {
        name: 'Utah',
        abbreviation: 'UT'
    },
    {
        name: 'Vermont',
        abbreviation: 'VT'
    },
    {
        name: 'Virgin Islands',
        abbreviation: 'VI'
    },
    {
        name: 'Virginia',
        abbreviation: 'VA'
    },
    {
        name: 'Washington',
        abbreviation: 'WA'
    },
    {
        name: 'West Virginia',
        abbreviation: 'WV'
    },
    {
        name: 'Wisconsin',
        abbreviation: 'WI'
    },
    {
        name: 'Wyoming',
        abbreviation: 'WY'
    }
];
var $d795f89fa43cfb57$export$2e2bcd8739ae039 = $d795f89fa43cfb57$var$USStates;


const { Title: $7cf79dc8b672b2cd$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { Option: $7cf79dc8b672b2cd$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
function $7cf79dc8b672b2cd$var$BusinessAddress({ setStep: setStep, signUpFlow: signUpFlow, onSave: onSave, loadingSave: loadingSave }) {
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const { businessAddress: { the_line1: the_line1, the_line2: the_line2, the_city: the_city, the_state: the_state, the_zip_code: the_zip_code } } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $6321cad55da6617a$export$534a056efe5a6df1));
    const [form] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    const [disabledNext, setDisabledNext] = (0, $6fFrj.useState)(true);
    const onSubmit = (0, $6fFrj.useCallback)((values)=>{
        // update the redux store
        dispatch((0, $6321cad55da6617a$export$eac745c5d2b8d5ca)({
            the_line1: values.the_line1,
            the_line2: values.the_line2,
            the_city: values.the_city,
            the_state: values.the_state,
            the_zip_code: values.the_zip_code
        }));
        // move to next step
        if (signUpFlow) setStep('SELECT_PLAN');
        else // save the changes
        onSave();
    }, [
        setStep,
        dispatch,
        signUpFlow,
        onSave,
        (0, $6321cad55da6617a$export$eac745c5d2b8d5ca)
    ]);
    // const handleCancel = useCallback(() => {
    //   form.resetFields();
    // }, [form]);
    const handleFormChange = (target)=>{
        const [{ name: [name], value: value }] = target;
        const hasErrors = form.getFieldsError().some(({ errors: errors })=>errors?.length);
        const currentLine1 = form.getFieldValue('the_line1');
        const currentCity = form.getFieldValue('the_city');
        const currentState = form.getFieldValue('the_state');
        const currentZipCode = form.getFieldValue('the_zip_code');
        const noValues = [
            currentLine1,
            currentCity,
            currentState,
            currentZipCode
        ].every((fieldValue)=>fieldValue?.length);
        setDisabledNext(hasErrors || !noValues);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (the_line1?.length && the_city?.length && the_state?.length && the_zip_code?.length) setDisabledNext(false);
    }, []);
    return (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
        style: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        },
        layout: "vertical",
        form: form,
        onFinish: onSubmit,
        onFieldsChange: handleFormChange,
        // eslint-disable-next-line no-template-curly-in-string
        validateMessages: {
            required: '${label} is required'
        },
        initialValues: {
            the_city: the_city,
            the_state: the_state,
            the_line1: the_line1,
            the_line2: the_line2,
            the_zip_code: the_zip_code
        },
        children: [
            (0, $bb3TF.jsxs)("div", {
                children: [
                    (0, $bb3TF.jsx)($7cf79dc8b672b2cd$var$Title, {
                        level: 4,
                        children: "Business Address"
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        gutter: [
                            15,
                            15
                        ],
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                md: 12,
                                sm: 24,
                                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "the_line1",
                                    label: "Address Line 1",
                                    rules: [
                                        {
                                            required: true
                                        }
                                    ],
                                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                        placeholder: "Address Line 1",
                                        autoComplete: "address-line1"
                                    })
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                md: 12,
                                sm: 24,
                                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "the_line2",
                                    label: "Address Line 2",
                                    rules: [
                                        {
                                            required: false
                                        }
                                    ],
                                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                        placeholder: "Address Line 2",
                                        autoComplete: "address-line2"
                                    })
                                })
                            })
                        ]
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        gutter: [
                            15,
                            15
                        ],
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                md: 8,
                                sm: 24,
                                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "the_city",
                                    label: "City",
                                    rules: [
                                        {
                                            required: true
                                        }
                                    ],
                                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                        placeholder: "City",
                                        autoComplete: "address-level2"
                                    })
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                md: 8,
                                sm: 24,
                                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "the_state",
                                    label: "State",
                                    rules: [
                                        {
                                            required: true
                                        }
                                    ],
                                    children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                                        placeholder: "Select state",
                                        showSearch: true,
                                        filterOption: (input, option)=>{
                                            if (option) return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                            return false;
                                        },
                                        onChange: (value)=>form.setFieldsValue({
                                                state: value
                                            }),
                                        autoComplete: "address-level1",
                                        children: (0, $d795f89fa43cfb57$export$2e2bcd8739ae039).map((item)=>(0, $bb3TF.jsx)($7cf79dc8b672b2cd$var$Option, {
                                                value: item.abbreviation,
                                                children: `${item.name}`
                                            }, item?.abbreviation))
                                    })
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                md: 8,
                                sm: 24,
                                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "the_zip_code",
                                    label: "Zip code",
                                    rules: [
                                        {
                                            required: true
                                        }
                                    ],
                                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                        placeholder: "Zip code",
                                        autoComplete: "postal-code"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $61da11bdaac935c8$export$2e2bcd8739ae039), {
                onBack: ()=>setStep('BUSINESS_INFO'),
                onSkip: ()=>setStep('SELECT_PLAN'),
                showSkip: false,
                disabled: disabledNext,
                nextText: signUpFlow ? 'Next' : 'Finish',
                loading: loadingSave
            })
        ]
    });
}
var $7cf79dc8b672b2cd$export$2e2bcd8739ae039 = $7cf79dc8b672b2cd$var$BusinessAddress;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");






const { Title: $12c1f5e468c4aeb3$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
function $12c1f5e468c4aeb3$var$BusinessInfo({ setStep: setStep, signUpFlow: signUpFlow }) {
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const { businessInfo: { the_tax_returns: the_tax_returns, the_business_name: the_business_name, the_business_phone: the_business_phone, the_business_phone_id: the_business_phone_id } } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $6321cad55da6617a$export$534a056efe5a6df1));
    const [form] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    const [disabledNext, setDisabledNext] = (0, $6fFrj.useState)(true);
    const [loadingBusinessInfo, setLoadingBusinessInfo] = (0, $6fFrj.useState)(!signUpFlow);
    // graphql
    // query to fetch existing business information
    const { data: firmData } = (0, $732264f53056e08f$export$c65bb1005cf74961)();
    const businessInfo = firmData?.BusinessInformation || {};
    // set the businessInfo initial values if any are present
    (0, $6fFrj.useEffect)(()=>{
        if (businessInfo && form && dispatch) {
            const { id: id, FirmAccount: FirmAccount, Address: Address, Phones: Phones, taxReturns: taxReturns } = businessInfo;
            const { name: name } = FirmAccount || {};
            // if one of these is present, then the user has already filled out this step
            if (!the_business_name && name || !the_business_phone && Phones?.[0]?.value) {
                dispatch((0, $6321cad55da6617a$export$90792fd0d1fe4d64)({
                    the_id: id,
                    the_tax_returns: taxReturns,
                    the_business_name: name,
                    the_business_phone: Phones?.[0]?.value,
                    the_business_phone_id: Phones?.[0]?.id
                }));
                dispatch((0, $6321cad55da6617a$export$eac745c5d2b8d5ca)({
                    the_id: Address?.[0]?.id,
                    the_line1: Address?.[0]?.lineOne,
                    the_line2: Address?.[0]?.lineTwo,
                    the_city: Address?.[0]?.city,
                    the_state: Address?.[0]?.state,
                    the_zip_code: Address?.[0]?.zip
                }));
            }
            setLoadingBusinessInfo(false);
            if (name) setDisabledNext(false);
        }
    }, [
        businessInfo,
        businessInfo?.Phones?.length,
        businessInfo?.Address?.length,
        form,
        dispatch
    ]);
    const onSubmit = (0, $6fFrj.useCallback)((values)=>{
        dispatch((0, $6321cad55da6617a$export$90792fd0d1fe4d64)({
            the_tax_returns: values?.the_tax_returns,
            the_business_name: values?.the_business_name,
            the_business_phone: values?.the_business_phone
        }));
        setStep('BUSINESS_ADDRESS');
    }, [
        setStep
    ]);
    // const handleCancel = useCallback(() => {
    //   form.resetFields();
    // }, [form]);
    const handleFormChange = (target)=>{
        const hasErrors = form.getFieldsError().some(({ errors: errors })=>errors?.length);
        const noValue = !form.getFieldValue('the_business_name')?.length;
        setDisabledNext(hasErrors || noValue);
    // const [{ name: [name], value }] = target;
    };
    (0, $6fFrj.useEffect)(()=>{
        if (the_business_name?.length) setDisabledNext(false);
    }, []);
    if (loadingBusinessInfo) return (0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039), {
        paragraph: {
            rows: 8
        }
    });
    return (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
        style: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        },
        layout: "vertical",
        form: form,
        onFinish: onSubmit,
        onFieldsChange: handleFormChange,
        // eslint-disable-next-line no-template-curly-in-string
        validateMessages: {
            required: '${label} is required'
        },
        initialValues: {
            the_tax_returns: the_tax_returns,
            the_business_name: the_business_name,
            the_business_phone: the_business_phone
        },
        children: [
            (0, $bb3TF.jsxs)("div", {
                children: [
                    (0, $bb3TF.jsx)($12c1f5e468c4aeb3$var$Title, {
                        level: 4,
                        children: "Business Information"
                    }),
                    (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                        name: "the_business_name",
                        label: "Business Name",
                        rules: [
                            {
                                required: true
                            }
                        ],
                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                            placeholder: "Business Name",
                            autoComplete: "organization"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                        name: "the_business_phone",
                        label: "Business Phone",
                        rules: [
                            {
                                required: false
                            }
                        ],
                        children: (0, $bb3TF.jsx)((0, $5ba7d8eeafddcf67$export$2e2bcd8739ae039), {
                            phoneNumber: the_business_phone,
                            autoComplete: "tel"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                        name: "the_tax_returns",
                        label: "Number of Tax Returns in the Past Season",
                        rules: [
                            {
                                required: false
                            }
                        ],
                        children: (0, $bb3TF.jsx)((0, $4d58e046767e1c41$export$2e2bcd8739ae039), {
                            style: {
                                width: '100%'
                            },
                            placeholder: "Numer of returns"
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $61da11bdaac935c8$export$2e2bcd8739ae039), {
                onBack: ()=>setStep('PERSONAL_INFO'),
                onSkip: ()=>setStep('BUSINESS_ADDRESS'),
                showSkip: false,
                disabled: disabledNext
            })
        ]
    });
}
var $12c1f5e468c4aeb3$export$2e2bcd8739ae039 = $12c1f5e468c4aeb3$var$BusinessInfo;



var $bb3TF = parcelRequire("bb3TF");








function $7bed86c7a8be606b$var$IntroVideo({ setStep: setStep, setModalVisible: setModalVisible, signUpFlow: signUpFlow }) {
    const navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const { personalInfo: { the_em: the_em, the_pass: the_pass } } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $6321cad55da6617a$export$534a056efe5a6df1));
    const [login, { loading: loadingLogin }] = (0, $7e016fc573eed7c4$export$cddfb6c1bfa4d45f)();
    const [getLanguages] = (0, $e9d4d19cd26b2dae$export$5d4e05e09dcdd3b7)();
    const getFirmAddress = (businessType, { User: User, BusinessInformation: BusinessInformation })=>{
        if (businessType === 'INDIVIDUAL') {
            const [Address] = User.UserInformation.Address.filter(({ type: type })=>type === 'PERSONAL');
            if (Address) {
                const { lineOne: lineOne, lineTwo: lineTwo, city: city, state: state, zip: zip } = Address;
                return `${lineOne ?? ''}, ${lineTwo ?? ''} ${city}, ${state} ${zip}`;
            }
        }
        const [Address] = BusinessInformation?.Address.filter(({ type: type })=>type === 'BUSINESS') ?? [];
        if (Address) {
            const { lineOne: lineOne, lineTwo: lineTwo, city: city, state: state, zip: zip } = Address;
            return `${lineOne ?? ''}, ${lineTwo ?? ''} ${city}, ${state} ${zip}`;
        }
        return '';
    };
    const getFirmPhoneNumber = (businessType, { User: User, BusinessInformation: BusinessInformation })=>{
        if (businessType === 'INDIVIDUAL') {
            const [Phone] = User.UserInformation.Phones.filter(({ type: type })=>type === 'PERSONAL');
            if (Phone) {
                const { value: value } = Phone;
                return value ?? '';
            }
            return '';
        }
        const [Phone] = BusinessInformation.Phones.filter(({ type: type })=>type === 'OFFICE');
        if (Phone) {
            const { value: value } = Phone;
            return value ?? '';
        }
        return '';
    };
    const onSubmit = async ()=>{
        try {
            if (signUpFlow) {
                const languagesResult = await getLanguages();
                const { languages: languages } = languagesResult.data;
                const loginResult = (await login({
                    variables: {
                        loginInput: {
                            email: the_em,
                            password: the_pass
                        }
                    }
                })).data?.Login ?? {};
                if (loginResult.accessToken?.length) {
                    const { accessToken: accessToken, UserFirmAccount: UserFirmAccount } = loginResult;
                    const { FirmAccount: FirmAccount, Users: Users, Roles: Roles } = UserFirmAccount;
                    const { businessType: businessType, Users: FirmUser, BusinessInformation: BusinessInformation } = FirmAccount;
                    const { UserInformation: UserInformation } = Users;
                    dispatch((0, $e3b9937a336ce5aa$export$b94982631f8f9752)({
                        accessToken: accessToken,
                        id: UserInformation?.id ?? '',
                        email: Users?.email ?? '',
                        userId: UserInformation?.userId ?? '',
                        userInformationId: UserInformation?.id ?? '',
                        firstName: UserInformation?.firstName ?? '',
                        lastName: UserInformation?.lastName ?? '',
                        birthday: UserInformation?.birthday ?? '',
                        ssn: UserInformation?.ssn ?? '',
                        profilePhoto: UserInformation?.profilePhoto ?? '',
                        firmAccountId: FirmAccount?.id ?? '',
                        languageId: Users?.languageId ?? '',
                        userRole: Roles?.description ?? '',
                        progressStatuses: [
                            ...FirmAccount.ProgressStatuses ?? []
                        ].map(({ id: id, status: status, underlyingStatus: underlyingStatus, index: index })=>({
                                status: status,
                                underlyingStatus: underlyingStatus,
                                index: index,
                                id: id
                            })),
                        firmName: FirmAccount.name ?? '',
                        firmAddress: getFirmAddress(businessType, {
                            User: FirmUser,
                            BusinessInformation: BusinessInformation
                        }),
                        firmPhoneNumber: getFirmPhoneNumber(businessType, {
                            User: FirmUser,
                            BusinessInformation: BusinessInformation
                        }),
                        firmCreatedAt: FirmAccount.createAt ?? ''
                    }));
                    dispatch((0, $6321cad55da6617a$export$c280c27017a6bb0f)());
                    dispatch((0, $e3b9937a336ce5aa$export$d25bc3c2e588da99)({
                        languages: languages
                    }));
                    navigate('/onboarding');
                }
            } else setModalVisible(false);
        } catch (error) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message ?? 'Something went while trying to sign in into your account');
        }
    };
    return (0, $bb3TF.jsxs)("div", {
        style: {
            width: '100%'
        },
        children: [
            (0, $bb3TF.jsx)("iframe", {
                width: "560",
                height: "315",
                src: "https://www.youtube-nocookie.com/embed/YFM3UTcukXo?start=1",
                title: "Welcome video",
                // frameborder="0"
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: true,
                style: {
                    display: 'block',
                    margin: '0 -25px'
                }
            }),
            (0, $bb3TF.jsx)((0, $61da11bdaac935c8$export$2e2bcd8739ae039), {
                showSkip: false,
                showBack: false,
                onNext: ()=>onSubmit(),
                nextText: "Finished",
                disabled: false,
                loading: loadingLogin
            })
        ]
    });
}
var $7bed86c7a8be606b$export$2e2bcd8739ae039 = $7bed86c7a8be606b$var$IntroVideo;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");






const { Title: $b0b169dcc58199e4$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { Option: $b0b169dcc58199e4$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
function $b0b169dcc58199e4$var$PersonalAddress({ setStep: setStep, signUpFlow: signUpFlow, onSave: onSave, loadingSave: loadingSave }) {
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const [form] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    const [disabledNext, setDisabledNext] = (0, $6fFrj.useState)(true);
    const { personalAddress: { the_line1: the_line1, the_line2: the_line2, the_city: the_city, the_state: the_state, the_zip_code: the_zip_code } } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $6321cad55da6617a$export$534a056efe5a6df1));
    const onSubmit = (0, $6fFrj.useCallback)((values)=>{
        // update the redux store
        dispatch((0, $6321cad55da6617a$export$6758be4729bd8a95)({
            the_line1: values.the_line1,
            the_line2: values.the_line2,
            the_city: values.the_city,
            the_state: values.the_state,
            the_zip_code: values.the_zip_code
        }));
        // move to next step
        if (signUpFlow) setStep('SELECT_PLAN');
        else // save the changes
        onSave();
    }, [
        setStep,
        dispatch,
        (0, $6321cad55da6617a$export$6758be4729bd8a95),
        setStep
    ]);
    // const handleCancel = useCallback(() => {
    //   form.resetFields();
    // }, [form]);
    const handleFormChange = (target)=>{
        const [{ name: [name], value: value }] = target;
        const hasErrors = form.getFieldsError().some(({ errors: errors })=>errors?.length);
        const currentLine1 = form.getFieldValue('the_line1');
        const currentCity = form.getFieldValue('the_city');
        const currentState = form.getFieldValue('the_state');
        const currentZipCode = form.getFieldValue('the_zip_code');
        const noValues = [
            currentLine1,
            currentCity,
            currentState,
            currentZipCode
        ].every((fieldValue)=>fieldValue?.length);
        setDisabledNext(hasErrors || !noValues);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (the_line1?.length && the_city?.length && the_state?.length && the_zip_code?.length) setDisabledNext(false);
    }, []);
    const firstLine = (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                md: 12,
                sm: 24,
                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "the_line1",
                    label: "Address Line 1",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                        placeholder: "Address Line 1",
                        autoComplete: "address-line1"
                    })
                })
            }),
            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                md: 12,
                sm: 24,
                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "the_line2",
                    label: "Address Line 2",
                    rules: [
                        {
                            required: false
                        }
                    ],
                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                        placeholder: "Address Line 2",
                        autoComplete: "address-line2"
                    })
                })
            })
        ]
    });
    const secondLine = (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                md: 8,
                sm: 24,
                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "the_city",
                    label: "City",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                        placeholder: "City",
                        autoComplete: "address-level2"
                    })
                })
            }),
            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                md: 8,
                sm: 24,
                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "the_state",
                    label: "State",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                        placeholder: "Select state",
                        showSearch: true,
                        filterOption: (input, option)=>{
                            if (option) return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            return false;
                        },
                        onChange: (value)=>form.setFieldsValue({
                                state: value
                            }),
                        autoComplete: "address-level1",
                        children: (0, $d795f89fa43cfb57$export$2e2bcd8739ae039).map((item)=>(0, $bb3TF.jsx)($b0b169dcc58199e4$var$Option, {
                                value: item.abbreviation,
                                children: `${item.name}`
                            }))
                    })
                })
            }),
            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                md: 8,
                sm: 24,
                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                    name: "the_zip_code",
                    label: "Zip code",
                    rules: [
                        {
                            required: true
                        }
                    ],
                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                        placeholder: "Zip code",
                        autoComplete: "postal-code"
                    })
                })
            })
        ]
    });
    return (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
        style: {
            width: '100%'
        },
        layout: "vertical",
        form: form,
        onFinish: onSubmit,
        onFieldsChange: handleFormChange,
        // eslint-disable-next-line no-template-curly-in-string
        validateMessages: {
            required: '${label} is required'
        },
        initialValues: {
            the_city: the_city,
            the_state: the_state,
            the_line1: the_line1,
            the_line2: the_line2,
            the_zip_code: the_zip_code
        },
        children: [
            (0, $bb3TF.jsx)($b0b169dcc58199e4$var$Title, {
                level: 4,
                children: "Personal Address"
            }),
            (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? firstLine : (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    15,
                    15
                ],
                children: firstLine
            }),
            (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? secondLine : (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    15,
                    15
                ],
                children: secondLine
            }),
            (0, $bb3TF.jsx)((0, $61da11bdaac935c8$export$2e2bcd8739ae039), {
                onBack: ()=>setStep('PERSONAL_INFO'),
                onSkip: ()=>setStep('SELECT_PLAN'),
                showSkip: false,
                disabled: disabledNext,
                nextText: signUpFlow ? 'Next' : 'Finish',
                loading: loadingSave
            })
        ]
    });
}
var $b0b169dcc58199e4$export$2e2bcd8739ae039 = $b0b169dcc58199e4$var$PersonalAddress;



var $bb3TF = parcelRequire("bb3TF");


var $6fFrj = parcelRequire("6fFrj");








const { Title: $cd4f435b41fbb6cc$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
function $cd4f435b41fbb6cc$var$PersonalInfo({ setStep: setStep, signUpFlow: signUpFlow }) {
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const { personalInfo: { the_em: the_em, the_pass: the_pass, the_first_name: the_first_name, the_last_name: the_last_name, the_confirm_pass: the_confirm_pass, the_operating_as: the_operating_as, the_date_of_birth: the_date_of_birth } } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $6321cad55da6617a$export$534a056efe5a6df1));
    const { firmAccountId: firmAccountId, userInformationId: userInformationId, userRole: userRole } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const [form] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    const [disabledNext, setDisabledNext] = (0, $6fFrj.useState)(true);
    const [loadingUserInfo, setLoadingUserInfo] = (0, $6fFrj.useState)(!signUpFlow);
    const [loadingOperatingAs, setLoadingOperatingAs] = (0, $6fFrj.useState)(!signUpFlow);
    const [searchParams, setSearchParams] = (0, $a6e470ffbc8d2470$export$f1a78c17382fe22a)();
    const initialEmail = searchParams.get('email');
    // graphql
    // query to fetch existing user information
    const { data: userData } = (0, $732264f53056e08f$export$e58c984431e9a06d)({
        variables: {
            id: userInformationId
        }
    });
    const userInformation = userData?.UserInformation;
    const { data: firmData } = (0, $0ddf390d079c5075$export$942e15e03134b6fe)({
        variables: {
            id: firmAccountId
        }
    });
    const operatingAs = firmData?.FirmAccountById?.businessType;
    // useEffect(() => {
    //   setLoadingUserInfo(false);
    //   setLoadingOperatingAs(false);
    // }, []);
    // set the userInformation initial values if any are present
    (0, $6fFrj.useEffect)(()=>{
        console.log('in useEffect');
        if (userInformation && form && dispatch) {
            console.log('userinformation:', userInformation);
            const { firstName: firstName, lastName: lastName, birthday: dateOfBirth, Address: Address } = userInformation;
            // if one of these is present, then the user has already filled out this step
            if (!the_first_name && !the_last_name && !the_date_of_birth) {
                dispatch((0, $6321cad55da6617a$export$16ff3f9024376b12)({
                    the_first_name: firstName,
                    the_last_name: lastName,
                    the_date_of_birth: (0, (/*@__PURE__*/$parcel$interopDefault($7b899c8e5076dc5b$exports)))(dateOfBirth).toISOString()
                }));
                dispatch((0, $6321cad55da6617a$export$6758be4729bd8a95)({
                    the_id: Address?.[0]?.id,
                    the_line1: Address?.[0]?.lineOne,
                    the_line2: Address?.[0]?.lineTwo,
                    the_city: Address?.[0]?.city,
                    the_state: Address?.[0]?.state,
                    the_zip_code: Address?.[0]?.zip
                }));
            }
            setLoadingUserInfo(false);
            if (firstName && lastName && dateOfBirth) setDisabledNext(false);
        }
    }, [
        userInformation,
        form,
        dispatch
    ]);
    // set the operatingAs initial values if any are present
    (0, $6fFrj.useEffect)(()=>{
        if (operatingAs && form && dispatch) {
            // if one of these is present, then the user has already filled out this step
            if (!the_operating_as) {
                const operatingAsValue = operatingAs === (0, $8f7fe33a44836803$export$23014ea746dc1f96).Individual ? 'Individual' : 'Company';
                dispatch((0, $6321cad55da6617a$export$16ff3f9024376b12)({
                    the_operating_as: operatingAsValue
                }));
                setLoadingOperatingAs(false);
            } else setLoadingOperatingAs(false);
        }
    }, [
        operatingAs,
        form,
        dispatch
    ]);
    const onSubmit = (0, $6fFrj.useCallback)((values)=>{
        // first dispatch the values to the redux store
        dispatch((0, $6321cad55da6617a$export$16ff3f9024376b12)({
            the_em: values.the_em,
            the_pass: values.the_pass,
            the_first_name: values.the_first_name,
            the_last_name: values.the_last_name,
            the_confirm_pass: values.the_confirm_pass,
            the_operating_as: values.the_operating_as,
            the_date_of_birth: values.the_date_of_birth.format('MM/DD/YYYY')
        }));
        // then move to the next step
        if (userRole !== 'TAX_PREPARER' && !signUpFlow) setStep('PERSONAL_ADDRESS');
        else if (values.the_operating_as === 'Individual') setStep('PERSONAL_ADDRESS');
        else if (values.the_operating_as === 'Company') setStep('BUSINESS_INFO');
    }, [
        setStep,
        dispatch,
        (0, $6321cad55da6617a$export$16ff3f9024376b12)
    ]);
    // const handleCancel = useCallback(() => {
    //   form.resetFields();
    // }, [form]);
    const handleFormChange = (target)=>{
        const [{ name: [name], value: value }] = target;
        const hasErrors = form.getFieldsError().some(({ errors: errors })=>errors?.length);
        const currentFirstName = form.getFieldValue('the_first_name');
        const currentLastName = form.getFieldValue('the_last_name');
        const currentDateOfBirth = form.getFieldValue('the_date_of_birth');
        const currentOperatingAs = form.getFieldValue('the_operating_as');
        const currentEmail = form.getFieldValue('the_em');
        const currentPassword = form.getFieldValue('the_pass');
        const currentConfirmPassword = form.getFieldValue('the_confirm_pass');
        const noValues = [
            currentFirstName,
            currentLastName,
            currentDateOfBirth,
            currentOperatingAs
        ].concat(signUpFlow ? [
            currentEmail,
            currentPassword,
            currentConfirmPassword
        ] : []).filter((fieldValue)=>typeof fieldValue === 'string' && !fieldValue?.length || typeof fieldValue === 'object' && !fieldValue);
        setDisabledNext(hasErrors || noValues?.length > 0);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (the_first_name?.length && the_last_name?.length && the_date_of_birth?.length && the_operating_as?.length && (the_em?.length || !signUpFlow) && (the_pass?.length || !signUpFlow) && (the_confirm_pass?.length || !signUpFlow)) setDisabledNext(false);
        return ()=>{
            form.resetFields();
        };
    }, [
        the_first_name,
        the_last_name,
        the_date_of_birth,
        the_operating_as,
        the_em,
        the_pass,
        the_confirm_pass,
        signUpFlow,
        form
    ]);
    if (loadingUserInfo || loadingOperatingAs) return (0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039), {
        paragraph: {
            rows: 8
        }
    });
    return (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
        style: {
            width: '100%'
        },
        layout: "vertical",
        form: form,
        initialValues: {
            the_em: initialEmail || the_em,
            the_pass: the_pass,
            the_last_name: the_last_name,
            the_first_name: the_first_name,
            the_operating_as: the_operating_as,
            the_confirm_pass: the_confirm_pass,
            the_date_of_birth: the_date_of_birth?.length ? (0, (/*@__PURE__*/$parcel$interopDefault($7b899c8e5076dc5b$exports)))(the_date_of_birth) : null
        },
        onFinish: onSubmit,
        onFieldsChange: handleFormChange,
        // eslint-disable-next-line no-template-curly-in-string
        validateMessages: {
            required: '${label} is required'
        },
        children: [
            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                name: "the_first_name",
                label: "First Name",
                rules: [
                    {
                        required: true
                    }
                ],
                children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                    autoComplete: "given-name",
                    placeholder: "First Name"
                }, "first-name-input")
            }, "first-name"),
            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                name: "the_last_name",
                label: "Last Name",
                rules: [
                    {
                        required: true
                    }
                ],
                children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                    autoComplete: "family-name",
                    placeholder: "Last Name"
                })
            }, "last-name"),
            (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                style: {
                    flex: 1
                },
                name: "the_date_of_birth",
                label: "Date of birth",
                rules: [
                    {
                        required: true
                    }
                ],
                children: (0, $bb3TF.jsx)((0, $dd1293f125eb7a8a$export$2e2bcd8739ae039), {
                    style: {
                        width: '100%'
                    },
                    onChange: (value)=>{
                        form.setFieldsValue({
                            dateOfBirth: value
                        });
                    },
                    format: "MM/DD/YYYY",
                    autoComplete: "bday"
                })
            }, "date-of-birth"),
            signUpFlow && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                children: [
                    (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                        name: "the_em",
                        label: "Email",
                        rules: [
                            {
                                required: true,
                                message: 'Email is required'
                            },
                            {
                                type: 'email',
                                message: 'Invalid email'
                            }
                        ],
                        style: {
                            display: initialEmail ? 'none' : 'block'
                        },
                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                            autoComplete: "email",
                            placeholder: "Email"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                        name: "the_pass",
                        label: "Password",
                        rules: [
                            {
                                required: true
                            },
                            {
                                min: 6,
                                message: 'The password must be at least 6 characters of length'
                            },
                            {
                                pattern: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
                                message: 'The password should include at least one lowercase letter,\n one uppercase letter \n and one number and one of these symbols: !@#$%^&*.'
                            }
                        ],
                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039).Password, {
                            autoComplete: "new-password",
                            placeholder: "Password"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                        name: "the_confirm_pass",
                        label: "Confirm Password",
                        dependencies: [
                            'the_pass'
                        ],
                        rules: [
                            {
                                required: true
                            },
                            ({ getFieldValue: getFieldValue })=>({
                                    validator (_, value) {
                                        if (!value || getFieldValue('the_pass') === value) return Promise.resolve();
                                        return Promise.reject(new Error('The two passwords that you entered do not match!'));
                                    }
                                })
                        ],
                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039).Password, {
                            autoComplete: "new-password",
                            placeholder: "Confirm Password"
                        })
                    })
                ]
            }),
            (userRole === 'TAX_PREPARER' || signUpFlow) && (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                name: "the_operating_as",
                label: "I am operating as",
                rules: [
                    {
                        required: true
                    }
                ],
                style: {
                    paddingLeft: 5
                },
                children: (0, $bb3TF.jsxs)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Group, {
                    children: [
                        (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039), {
                            value: "Individual",
                            children: "An individual tax preparer"
                        }),
                        (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039), {
                            value: "Company",
                            children: "A business"
                        })
                    ]
                })
            }, "operating-as"),
            (0, $bb3TF.jsx)((0, $61da11bdaac935c8$export$2e2bcd8739ae039), {
                showBack: false,
                showSkip: false,
                disabled: disabledNext
            })
        ]
    }, "personal-info");
}
var $cd4f435b41fbb6cc$export$2e2bcd8739ae039 = $cd4f435b41fbb6cc$var$PersonalInfo;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");





const $43b72605a58be821$var$defaultOptions = {};
const $43b72605a58be821$export$34ff45b621e86a5 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation Register($createUserInput: CreateUserInput!, $stripeCardInput: CreateStripePaymentMethodInput) {
  Register(createUserInput: $createUserInput, stripeCardInput: $stripeCardInput) {
    accessToken
    headToURL
    selectedFirmAccount
    Entity {
      id
      Users {
        email
        languageId
        UserInformation {
          id
          userId
          firstName
          lastName
          birthday
          ssn
          profilePhoto
        }
      }
    }
    RelatedFirms {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
      }
      Users {
        UserInformation {
          firstName
          lastName
        }
      }
      Roles {
        id
        description
      }
    }
    UserFirmAccount {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
        type
        businessType
        Users {
          id
          email
          createAt
          updateAt
          languageId
          UserInformation {
            id
            userId
            birthday
            lastName
            firstName
            createAt
            updateAt
            Phones {
              id
              value
              type
              createAt
              updateAt
            }
            Address {
              id
              lineOne
              lineTwo
              city
              state
              type
              zip
              createAt
              updateAt
            }
          }
        }
        BusinessInformation {
          id
          Phones {
            id
            value
            type
            createAt
            updateAt
          }
          Address {
            id
            lineOne
            lineTwo
            city
            state
            type
            zip
            createAt
            updateAt
          }
        }
        ProgressStatuses {
          id
          firmAccountId
          status
          createAt
          updateAt
          underlyingStatus
          index
        }
      }
      Entity {
        id
        Users {
          id
          email
          languageId
          UserInformation {
            id
            firstName
            lastName
            birthday
            ssn
            profilePhoto
          }
        }
      }
      Users {
        UserInformation {
          id
          userId
          firstName
          lastName
          birthday
          ssn
          profilePhoto
        }
        email
        languageId
      }
      Roles {
        id
        description
      }
    }
  }
}
    `;
function $43b72605a58be821$export$29f624c4457620bb(baseOptions) {
    const options = {
        ...$43b72605a58be821$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($43b72605a58be821$export$34ff45b621e86a5, options);
}
const $43b72605a58be821$export$39ac829ab91f0716 = {
    Mutation: {
        Register: 'Register'
    }
};




var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $7a404267c85be0c6$var$SvgPoweredByStripeLogo = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: 160,
        width: 240,
        viewBox: "-22.35 -10.25 193.7 61.5",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M6 0h137a6 6 0 0 1 6 6v29a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6z",
                fill: "#32364E",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                d: "M71.403 26.625h-1.462l1.132-2.796-2.253-5.685h1.545l1.416 3.869 1.427-3.869h1.545zm-5.615-2.442c-.507 0-1.026-.188-1.498-.554v.413h-1.509v-8.481h1.509v2.985c.472-.354.991-.543 1.498-.543 1.581 0 2.666 1.274 2.666 3.09 0 1.816-1.085 3.09-2.666 3.09zM65.47 19.3c-.413 0-.826.177-1.18.531v2.524c.354.354.767.531 1.18.531.849 0 1.439-.731 1.439-1.793 0-1.061-.59-1.793-1.439-1.793zm-8.8 4.329c-.46.366-.979.554-1.498.554-1.569 0-2.665-1.274-2.665-3.09 0-1.816 1.096-3.09 2.665-3.09.519 0 1.038.189 1.498.543v-2.985h1.522v8.481H56.67zm0-3.798c-.342-.354-.755-.531-1.168-.531-.861 0-1.45.732-1.45 1.793 0 1.062.589 1.793 1.45 1.793.413 0 .826-.177 1.168-.531zm-8.988 1.675c.094.896.802 1.51 1.793 1.51.542 0 1.144-.201 1.757-.555v1.262a4.805 4.805 0 0 1-2.005.46c-1.781 0-3.031-1.297-3.031-3.137 0-1.781 1.227-3.043 2.913-3.043 1.545 0 2.595 1.215 2.595 2.949 0 .165 0 .353-.024.554zm1.368-2.335c-.731 0-1.297.542-1.368 1.356h2.571c-.047-.802-.531-1.356-1.203-1.356zm-5.343.931v3.94h-1.51v-5.898h1.51v.59c.424-.472.943-.731 1.45-.731.166 0 .331.012.496.059v1.345a1.955 1.955 0 0 0-.531-.071c-.495 0-1.026.271-1.415.766zm-6.736 1.404c.095.896.802 1.51 1.793 1.51.543 0 1.144-.201 1.758-.555v1.262a4.813 4.813 0 0 1-2.006.46c-1.781 0-3.031-1.297-3.031-3.137 0-1.781 1.227-3.043 2.913-3.043 1.546 0 2.595 1.215 2.595 2.949 0 .165 0 .353-.023.554zm1.368-2.335c-.731 0-1.297.542-1.368 1.356h2.572c-.048-.802-.531-1.356-1.204-1.356zm-6.641 4.871-1.203-4.01-1.191 4.01h-1.357l-2.028-5.898h1.509l1.192 4.011 1.191-4.011h1.368l1.191 4.011 1.192-4.011h1.509l-2.017 5.898zm-9.224.141c-1.781 0-3.043-1.285-3.043-3.09 0-1.816 1.262-3.09 3.043-3.09 1.781 0 3.031 1.274 3.031 3.09 0 1.805-1.25 3.09-3.031 3.09zm0-4.918c-.885 0-1.498.743-1.498 1.828s.613 1.828 1.498 1.828c.873 0 1.486-.743 1.486-1.828s-.613-1.828-1.486-1.828zm-6.629 1.864h-1.357v2.913h-1.509v-8.115h2.866c1.651 0 2.83 1.073 2.83 2.607 0 1.533-1.179 2.595-2.83 2.595zm-.213-3.975h-1.144v2.748h1.144c.873 0 1.486-.554 1.486-1.368 0-.826-.613-1.38-1.486-1.38zm121.195 4.714h-7.25c.165 1.736 1.437 2.247 2.88 2.247 1.471 0 2.629-.309 3.639-.819v2.984c-1.007.557-2.335.96-4.106.96-3.607 0-6.135-2.259-6.135-6.726 0-3.772 2.144-6.768 5.668-6.768 3.518 0 5.354 2.995 5.354 6.788 0 .358-.033 1.134-.05 1.334zm-5.328-5.102c-.926 0-1.955.699-1.955 2.368h3.829c0-1.667-.964-2.368-1.874-2.368zM119.981 27.24c-1.296 0-2.088-.547-2.62-.937l-.008 4.191-3.703.788-.002-17.289h3.262l.192.915c.513-.479 1.45-1.162 2.902-1.162 2.601 0 5.051 2.343 5.051 6.655 0 4.707-2.424 6.839-5.074 6.839zm-.862-10.213c-.851 0-1.383.311-1.769.734l.022 5.504c.359.389.878.703 1.747.703 1.369 0 2.287-1.491 2.287-3.485 0-1.938-.932-3.456-2.287-3.456zm-10.702-3.034h3.718v12.982h-3.718zm0-4.145 3.718-.791v3.017l-3.718.79zm-3.841 8.326v8.801h-3.702V13.993h3.202l.233 1.095c.866-1.594 2.598-1.271 3.091-1.094v3.404c-.471-.152-1.949-.374-2.824.776zm-7.817 4.246c0 2.183 2.337 1.504 2.812 1.314v3.015c-.494.271-1.389.491-2.6.491-2.198 0-3.847-1.619-3.847-3.812l.016-11.883 3.616-.768.003 3.216h2.813v3.158h-2.813zm-4.494.632c0 2.666-2.122 4.188-5.202 4.188-1.277 0-2.673-.248-4.05-.841v-3.536c1.243.676 2.827 1.183 4.054 1.183.826 0 1.421-.222 1.421-.906 0-1.768-5.631-1.102-5.631-5.203 0-2.622 2.003-4.191 5.007-4.191 1.227 0 2.454.189 3.681.678v3.488c-1.127-.608-2.557-.953-3.684-.953-.776 0-1.258.224-1.258.803 0 1.666 5.662.874 5.662 5.29z",
                fill: "#FFF",
                fillRule: "evenodd"
            })
        ]
    });
var $7a404267c85be0c6$export$2e2bcd8739ae039 = $7a404267c85be0c6$var$SvgPoweredByStripeLogo;




var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");



var $de26d210ebfa5da2$export$3c5e74c44aec3b41;
var $de26d210ebfa5da2$export$627bf44ec89b4019;
$de26d210ebfa5da2$export$3c5e74c44aec3b41 = `Tg4DGa_cardItem`;
$de26d210ebfa5da2$export$627bf44ec89b4019 = `Tg4DGa_cardListContainer`;


const $f303e9430ff2c01b$var$CardList = ({ cards: cards })=>{
    const { selectedPlanId: selectedPlanId } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $6321cad55da6617a$export$534a056efe5a6df1));
    return (0, $bb3TF.jsx)("ul", {
        className: $de26d210ebfa5da2$export$627bf44ec89b4019,
        children: cards.map(({ id: id, title: title, content: content, onClick: onClick })=>(0, $bb3TF.jsx)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                hoverable: true,
                title: title,
                onClick: onClick,
                style: {
                    transition: 'border 300ms ease',
                    ...selectedPlanId && selectedPlanId === id ? {
                        border: 'solid 1px #0D76D1'
                    } : {}
                },
                className: $de26d210ebfa5da2$export$3c5e74c44aec3b41,
                children: content
            }, id))
    });
};
var $f303e9430ff2c01b$export$2e2bcd8739ae039 = $f303e9430ff2c01b$var$CardList;


var $eb2cba9c12d2ef78$export$2671b48afe611fa2;
var $eb2cba9c12d2ef78$export$9a9bfc01491ee100;
$eb2cba9c12d2ef78$export$2671b48afe611fa2 = `SgE10W_paymentContainer`;
$eb2cba9c12d2ef78$export$9a9bfc01491ee100 = `SgE10W_planAmount`;


const { Title: $9ba74ef197b68a4d$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $9ba74ef197b68a4d$var$formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
});
function $9ba74ef197b68a4d$var$SelectPlan({ setStep: setStep }) {
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const { selectedPlanId: selectedPlanId, personalInfo: { the_em: the_em, the_pass: the_pass, the_first_name: the_first_name, the_last_name: the_last_name, the_operating_as: the_operating_as, the_date_of_birth: the_date_of_birth }, personalAddress: personalAddress, businessAddress: businessAddress, // paymentInfo: { cvc, cardNumber, expireDate },
    businessInfo: { the_business_name: the_business_name, the_business_phone: the_business_phone, the_tax_returns: the_tax_returns } } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $6321cad55da6617a$export$534a056efe5a6df1));
    const [getAllPlans, { data: data, loading: loading }] = (0, $732264f53056e08f$export$119a02c7f292c53d)();
    const [isPlanSelected, setIsPlanSelected] = (0, $6fFrj.useState)(!!selectedPlanId?.length);
    const [registUser, { loading: registerLoading }] = (0, $43b72605a58be821$export$29f624c4457620bb)();
    const [nextDisabled, setNextDisabled] = (0, $6fFrj.useState)(false);
    const [loadingSubmit, setLoadingSubmit] = (0, $6fFrj.useState)(false);
    // save payment info in state then add to redux on submit
    const [cvc, setCvc] = (0, $6fFrj.useState)('');
    const [cardNumber, setCardNumber] = (0, $6fFrj.useState)('');
    const [expireDate, setExpireDate] = (0, $6fFrj.useState)('');
    const onSubmit = async ()=>{
        try {
            // if (!selectedPlanId) {
            //   message.error('Please select a plan.');
            //   return;
            // }
            setLoadingSubmit(true);
            // add to redux in case it's needed elsewhere
            dispatch((0, $6321cad55da6617a$export$daba6e5feed163b5)({
                cardNumber: cardNumber,
                cvc: cvc,
                expireDate: expireDate
            }));
            const exp_month = Number(expireDate.split(' / ')[0]);
            const exp_year = Number(expireDate.split(' / ')[1]);
            const { id: id } = (await registUser({
                variables: {
                    createUserInput: {
                        email: the_em,
                        password: the_pass,
                        planId: selectedPlanId,
                        firmName: the_business_name ?? '',
                        // English languageId
                        languageId: 'b06939c3-e2cb-4bc6-8f6e-d85dc8c0aef2',
                        ...the_operating_as === 'Company' ? {
                            BusinessInformation: {
                                taxReturns: the_tax_returns,
                                Phones: [
                                    {
                                        value: the_business_phone,
                                        type: (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Office
                                    }
                                ],
                                Address: [
                                    {
                                        type: (0, $8f7fe33a44836803$export$189c6ba3eaa96ac2).Business,
                                        city: businessAddress.the_city,
                                        state: businessAddress.the_state,
                                        zip: businessAddress.the_zip_code,
                                        lineOne: businessAddress.the_line1,
                                        lineTwo: businessAddress.the_line2
                                    }
                                ]
                            }
                        } : {},
                        UserInformation: {
                            firstName: the_first_name,
                            lastName: the_last_name,
                            birthday: the_date_of_birth,
                            ...the_operating_as === 'Individual' ? {
                                Address: [
                                    {
                                        type: (0, $8f7fe33a44836803$export$189c6ba3eaa96ac2).Personal,
                                        city: personalAddress.the_city,
                                        state: personalAddress.the_state,
                                        zip: personalAddress.the_zip_code,
                                        lineOne: personalAddress.the_line1,
                                        lineTwo: personalAddress.the_line2
                                    }
                                ]
                            } : {}
                        }
                    }
                }
            })).data?.Register ?? {};
            if (id) {
                setStep('VIDEO');
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Your account was successfully created!');
            }
        } catch (error) {
            if (error.message && error.message === 'Error code 1002') (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('The user with this email is already registered. Please try another email.');
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message ?? 'Something went wrong while trying to regist the user');
        } finally{
            setLoadingSubmit(false);
        }
    };
    const handleCardNumberChange = (event)=>{
        setCardNumber(event.target.value);
    };
    const handleCardExpireDateChange = (event)=>{
        setExpireDate(event.target.value);
    };
    const handleCardCvcChange = (event)=>{
        setCvc(event.target.value);
    };
    const handlePaymentMethodError = ()=>{
        setNextDisabled(true);
    };
    (0, $6fFrj.useEffect)(()=>{
        const controller = new AbortController();
        getAllPlans();
        return ()=>{
            controller.abort();
        };
    }, []);
    (0, $6fFrj.useEffect)(()=>{
        if (!isPlanSelected) setNextDisabled(true);
        else if (cardNumber.length === 19 && expireDate.length === 7 && cvc.length === 3) setNextDisabled(false);
    }, [
        isPlanSelected
    ]);
    (0, $6fFrj.useEffect)(()=>{
        // add spaces into copy-pasted card number
        if (cardNumber.length === 16 && cardNumber.indexOf(' ') === -1) setCardNumber(`${cardNumber.substring(0, 4)} ${cardNumber.substring(4, 8)} ${cardNumber.substring(8, 12)} ${cardNumber.substring(12, 16)}`);
    }, [
        cardNumber
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (cardNumber.length === 19 && expireDate.length === 7 && cvc.length === 3) {
            if (nextDisabled) setNextDisabled(false);
        } else setNextDisabled(true);
    }, [
        cardNumber,
        expireDate,
        cvc
    ]);
    const rendercancelSubtext = ()=>(0, $bb3TF.jsx)("p", {
            style: {
                marginTop: -12
            },
            children: "Cancel anytime"
        });
    const renderNextSubtext = ()=>(0, $bb3TF.jsx)("p", {
            style: {
                marginTop: -12
            },
            children: (0, $bb3TF.jsx)("a", {
                style: {
                    color: 'inherit'
                },
                href: "https://taxaroo.com/pricing",
                target: "_blank",
                rel: "noreferrer",
                children: "100% Money-Back Guarantee"
            })
        });
    return (0, $bb3TF.jsxs)("div", {
        style: {
            marginTop: '-25px'
        },
        children: [
            (0, $bb3TF.jsx)($9ba74ef197b68a4d$var$Title, {
                level: 4,
                children: "Choose the plan that\u2019s right for you"
            }),
            loading && (0, $bb3TF.jsx)("div", {
                style: {
                    flex: 1,
                    height: 300,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {})
            }),
            (0, $bb3TF.jsx)((0, $f303e9430ff2c01b$export$2e2bcd8739ae039), {
                cards: [
                    ...data?.GetAllPlans ?? []
                ].map(({ id: id, metadata: { description: description, plan_name: plan_name }, tiers: tiers })=>({
                        id: id,
                        onClick () {
                            setIsPlanSelected(true);
                            dispatch((0, $6321cad55da6617a$export$8752e44945104444)(id));
                        },
                        title: (0, $bb3TF.jsxs)("p", {
                            children: [
                                plan_name,
                                ' ',
                                (0, $bb3TF.jsx)("span", {
                                    className: $eb2cba9c12d2ef78$export$9a9bfc01491ee100,
                                    children: $9ba74ef197b68a4d$var$formatter.format((tiers?.[0]?.flat_amount || 0) / 100)
                                })
                            ]
                        }),
                        content: (0, $bb3TF.jsx)("p", {
                            style: {
                                marginTop: -40,
                                marginBottom: -5
                            },
                            children: description ?? ''
                        })
                    }))
            }),
            (0, $bb3TF.jsx)("div", {
                className: $eb2cba9c12d2ef78$export$2671b48afe611fa2,
                children: (0, $bb3TF.jsx)("p", {
                    children: "Your card will not be charged until after the 14-day free trial ends."
                })
            }),
            (0, $bb3TF.jsx)((0, $61da11bdaac935c8$export$2e2bcd8739ae039), {
                loading: loadingSubmit,
                onBack: ()=>setStep(the_operating_as === 'Company' ? 'BUSINESS_ADDRESS' : 'PERSONAL_ADDRESS'),
                showSkip: false,
                onNext: ()=>onSubmit(),
                nextText: "START SUBSCRIPTION",
                disabled: false,
                cancelSubtext: rendercancelSubtext,
                nextSubtext: renderNextSubtext
            }),
            (0, $bb3TF.jsxs)("div", {
                style: {
                    marginTop: 20
                },
                children: [
                    (0, $bb3TF.jsx)("p", {
                        style: {
                            textAlign: 'center'
                        },
                        children: "Your payment information is secure with us."
                    }),
                    (0, $bb3TF.jsx)("p", {
                        style: {
                            textAlign: 'center',
                            margin: -50
                        },
                        children: (0, $bb3TF.jsx)((0, $7a404267c85be0c6$export$2e2bcd8739ae039), {})
                    }),
                    (0, $bb3TF.jsx)("br", {}),
                    (0, $bb3TF.jsxs)("p", {
                        style: {
                            textAlign: 'center'
                        },
                        children: [
                            (0, $bb3TF.jsx)("a", {
                                style: {
                                    color: 'inherit'
                                },
                                href: "https://taxaroo.com/privacy",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "Privacy Policy"
                            }),
                            ' ',
                            "|",
                            ' ',
                            (0, $bb3TF.jsx)("a", {
                                style: {
                                    color: 'inherit'
                                },
                                href: "https://taxaroo.com//terms-of-use",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "Terms of Service"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $9ba74ef197b68a4d$export$2e2bcd8739ae039 = $9ba74ef197b68a4d$var$SelectPlan;


var $475b068d6d6e03b7$export$c713e2f9d13dd9ff;
$475b068d6d6e03b7$export$c713e2f9d13dd9ff = `W6LaKq_registerFlowContainer`;


const { Title: $e8a39231f31cbf92$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $e8a39231f31cbf92$var$RegisterSteps = ({ setModalVisible: setModalVisible, markBasicInfoStepComplete: markBasicInfoStepComplete })=>{
    const { userRole: userRole, firmAccountId: firmAccountId, userInformationId: userInformationId } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const [step, setStep] = (0, $6fFrj.useState)((0, $6321cad55da6617a$export$6df15c054eb3c4d7).PERSONAL_INFO);
    const [isPreparer] = (0, $6fFrj.useState)(userRole === 'TAX_PREPARER');
    const [isLoading, setIsLoading] = (0, $6fFrj.useState)(false);
    // redux
    const { personalInfo: { the_first_name: the_first_name, the_last_name: the_last_name, the_operating_as: the_operating_as, the_date_of_birth: the_date_of_birth }, businessInfo: // personalAddress, // got the get these directly from store in onSave function
    // businessAddress, // got the get these directly from store in onSave function
    businessInfo, businessInfo: { the_business_name: the_business_name, the_business_phone: the_business_phone, the_business_phone_id: the_business_phone_id, the_tax_returns: the_tax_returns } } = (0, $58073eff19365823$export$a7347740d65f620b)((0, $6321cad55da6617a$export$534a056efe5a6df1));
    // graphql
    // query to fetch existing business information
    const { data: firmData } = (0, $732264f53056e08f$export$c65bb1005cf74961)();
    const currentBusinessInfo = firmData?.BusinessInformation || {};
    // Create business info
    const [createBusinessInformationMutation] = (0, $33beb5b1bfae180c$export$da7467fe254a46d8)({
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$fde7a102bea6da56)
            }
        ],
        awaitRefetchQueries: true
    });
    // Update business info
    const [updateBusinessInformationMutation] = (0, $33beb5b1bfae180c$export$28256303d1a07fbc)({
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$fde7a102bea6da56)
            }
        ],
        awaitRefetchQueries: true
    });
    // Mutation to update user information
    const [updateUserInformation] = (0, $33beb5b1bfae180c$export$e3e115fc54c52e18)({
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$73c49c0d19880aef),
                variables: {
                    id: userInformationId
                }
            },
            ...isPreparer && businessInfo ? [
                {
                    query: (0, $732264f53056e08f$export$fde7a102bea6da56)
                }
            ] : []
        ],
        awaitRefetchQueries: true
    });
    const [removeBusinessInfo] = (0, $33beb5b1bfae180c$export$9ffbbb21aab6135e)({
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$fde7a102bea6da56)
            }
        ],
        awaitRefetchQueries: true
    });
    const [updateFirmAccount] = (0, $33beb5b1bfae180c$export$3651467deb80cf0)({
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$fde7a102bea6da56)
            }
        ],
        awaitRefetchQueries: true
    });
    const onSave = (0, $6fFrj.useCallback)(()=>{
        // don't know why I need to get this directly from the store but I do
        const businessAddressFromStore = (0, $e4ec60025026f14e$export$2e2bcd8739ae039).getState().register.businessAddress;
        const personalAddressFromStore = (0, $e4ec60025026f14e$export$2e2bcd8739ae039).getState().register.personalAddress;
        if (isPreparer) {
            // setCustomError(null);
            setIsLoading(true);
            Promise.all([
                updateUserInformation({
                    variables: {
                        updateUserInformationInput: {
                            lastName: the_last_name,
                            firstName: the_first_name,
                            id: userInformationId,
                            birthday: the_date_of_birth,
                            Address: personalAddressFromStore.the_line1 ? [
                                {
                                    zip: personalAddressFromStore.the_zip_code,
                                    city: personalAddressFromStore.the_city,
                                    state: personalAddressFromStore.the_state,
                                    lineOne: personalAddressFromStore.the_line1,
                                    lineTwo: personalAddressFromStore?.the_line2,
                                    id: personalAddressFromStore?.the_id || undefined,
                                    type: 'PERSONAL'
                                }
                            ] : undefined
                        }
                    }
                }),
                businessInfo?.the_id ? [
                    the_operating_as === 'Company' ? [
                        updateBusinessInformationMutation({
                            variables: {
                                updateBusinessInformationInput: {
                                    taxReturns: the_tax_returns,
                                    businessName: the_business_name,
                                    businessType: the_operating_as === 'Company' ? (0, $8f7fe33a44836803$export$23014ea746dc1f96).Company : (0, $8f7fe33a44836803$export$23014ea746dc1f96).Individual,
                                    ...businessAddressFromStore?.the_id?.length && currentBusinessInfo?.Phones?.[0]?.id?.length || !businessAddressFromStore?.the_id?.length && currentBusinessInfo?.Phones?.[0]?.id?.length || businessAddressFromStore?.the_id?.length && !currentBusinessInfo?.Phones?.[0]?.id?.length ? {
                                        Address: [
                                            {
                                                zip: businessAddressFromStore?.the_zip_code,
                                                city: businessAddressFromStore?.the_city,
                                                state: businessAddressFromStore?.the_state,
                                                id: businessAddressFromStore?.the_id,
                                                lineOne: businessAddressFromStore?.the_line1,
                                                lineTwo: businessAddressFromStore?.the_line2
                                            }
                                        ],
                                        ...the_business_phone?.length && {
                                            Phones: [
                                                {
                                                    id: currentBusinessInfo?.Phones?.[0]?.id || undefined,
                                                    value: the_business_phone
                                                }
                                            ]
                                        }
                                    } : {},
                                    id: businessInfo?.the_id
                                }
                            }
                        })
                    ] : [
                        updateFirmAccount({
                            variables: {
                                updateFirmAccountInput: {
                                    name: null,
                                    businessType: (0, $8f7fe33a44836803$export$23014ea746dc1f96).Individual,
                                    id: firmAccountId
                                }
                            }
                        }),
                        removeBusinessInfo({
                            variables: {
                                id: businessInfo?.the_id
                            }
                        })
                    ]
                ] : [
                    ...the_operating_as ? [
                        updateFirmAccount({
                            variables: {
                                updateFirmAccountInput: {
                                    businessType: the_operating_as === 'Company' ? (0, $8f7fe33a44836803$export$23014ea746dc1f96).Company : (0, $8f7fe33a44836803$export$23014ea746dc1f96).Individual,
                                    id: firmAccountId,
                                    name: the_business_name
                                }
                            }
                        })
                    ] : [],
                    ...the_operating_as === 'Company' ? [
                        createBusinessInformationMutation({
                            variables: {
                                createBusinessInformationInput: {
                                    taxReturns: the_tax_returns,
                                    Phones: [
                                        {
                                            value: businessInfo?.the_business_phone,
                                            type: 'OFFICE'
                                        }
                                    ],
                                    Address: [
                                        {
                                            zip: businessAddressFromStore?.the_zip_code,
                                            city: businessAddressFromStore?.the_city,
                                            state: businessAddressFromStore?.the_state,
                                            lineOne: businessAddressFromStore?.the_line1,
                                            lineTwo: businessAddressFromStore?.the_line2,
                                            type: 'BUSINESS'
                                        }
                                    ]
                                }
                            }
                        })
                    ] : []
                ]
            ]).then(()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Information saved successfully');
                setModalVisible(false);
                markBasicInfoStepComplete();
            }).catch((error)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message)).finally(()=>{
                setIsLoading(false);
            });
        } else {
            setIsLoading(true);
            updateUserInformation({
                variables: {
                    updateUserInformationInput: {
                        birthday: the_date_of_birth,
                        lastName: the_last_name,
                        firstName: the_first_name,
                        id: userInformationId,
                        ...personalAddressFromStore?.the_line1 ? {
                            Address: personalAddressFromStore?.the_line1 ? [
                                {
                                    zip: personalAddressFromStore?.the_zip_code,
                                    city: personalAddressFromStore?.the_city,
                                    state: personalAddressFromStore?.the_state,
                                    lineOne: personalAddressFromStore?.the_line1,
                                    lineTwo: personalAddressFromStore?.the_line2,
                                    id: personalAddressFromStore?.the_id || undefined,
                                    type: 'PERSONAL'
                                }
                            ] : undefined
                        } : {}
                    }
                }
            }).then(()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Information saved successfully');
                setModalVisible(false);
                markBasicInfoStepComplete();
            }).catch((error)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message)).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        isPreparer,
        the_date_of_birth,
        the_last_name,
        the_first_name,
        the_business_phone,
        the_business_phone_id,
        the_tax_returns,
        the_business_name,
        the_operating_as,
        businessInfo,
        firmAccountId,
        userInformationId,
        setIsLoading,
        updateUserInformation,
        createBusinessInformationMutation,
        updateBusinessInformationMutation,
        updateFirmAccount,
        removeBusinessInfo
    ]);
    // eslint-disable-next-line react/no-unstable-nested-components
    const CurrentStep = ()=>{
        switch(step){
            case 'PERSONAL_INFO':
                return (0, $bb3TF.jsx)((0, $cd4f435b41fbb6cc$export$2e2bcd8739ae039), {
                    setStep: setStep,
                    signUpFlow: !setModalVisible
                });
            case 'PERSONAL_ADDRESS':
                return (0, $bb3TF.jsx)((0, $b0b169dcc58199e4$export$2e2bcd8739ae039), {
                    setStep: setStep,
                    signUpFlow: !setModalVisible,
                    onSave: onSave,
                    loadingSave: isLoading
                });
            case 'BUSINESS_INFO':
                return (0, $bb3TF.jsx)((0, $12c1f5e468c4aeb3$export$2e2bcd8739ae039), {
                    setStep: setStep,
                    signUpFlow: !setModalVisible
                });
            case 'BUSINESS_ADDRESS':
                return (0, $bb3TF.jsx)((0, $7cf79dc8b672b2cd$export$2e2bcd8739ae039), {
                    setStep: setStep,
                    signUpFlow: !setModalVisible,
                    onSave: onSave,
                    loadingSave: isLoading
                });
            case 'SELECT_PLAN':
                return (0, $bb3TF.jsx)((0, $9ba74ef197b68a4d$export$2e2bcd8739ae039), {
                    setStep: setStep
                });
            case 'VIDEO':
                return (0, $bb3TF.jsx)((0, $7bed86c7a8be606b$export$2e2bcd8739ae039), {
                    setStep: setStep,
                    signUpFlow: !setModalVisible,
                    setModalVisible: setModalVisible
                });
            case 'DONE':
                setModalVisible(false);
                return null;
            default:
                return (0, $bb3TF.jsx)((0, $cd4f435b41fbb6cc$export$2e2bcd8739ae039), {
                    signUpFlow: !setModalVisible,
                    setStep: setStep
                });
        }
    };
    return (0, $bb3TF.jsxs)("div", {
        className: `showScrollbar ${$475b068d6d6e03b7$export$c713e2f9d13dd9ff}`,
        children: [
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                justify: "center",
                children: (0, $bb3TF.jsx)((0, $1cbcb18aa67bf12c$export$2e2bcd8739ae039), {
                    width: "170",
                    height: "40"
                })
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                justify: "center",
                children: (0, $bb3TF.jsx)($e8a39231f31cbf92$var$Title, {
                    level: 3,
                    style: {
                        color: '#0d57a5',
                        textAlign: 'center'
                    },
                    children: "Let's set up your new Taxaroo account"
                })
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                justify: "center",
                style: {
                    flex: 1,
                    marginTop: '30px',
                    marginRight: 12
                },
                children: (0, $bb3TF.jsx)(CurrentStep, {})
            })
        ]
    });
};
$e8a39231f31cbf92$var$RegisterSteps.defaultProps = {
    setModalVisible: null,
    markBasicInfoStepComplete: null
};
var $e8a39231f31cbf92$export$2e2bcd8739ae039 = $e8a39231f31cbf92$var$RegisterSteps;


const $0cdf02c01c127580$var$RegisterFlow = ({ isModal: isModal, showRegisterFlow: showRegisterFlow, setShowRegisterFlow: setShowRegisterFlow, markBasicInfoStepComplete: markBasicInfoStepComplete })=>isModal ? (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        visible: showRegisterFlow,
        width: "70%",
        footer: null,
        onCancel: ()=>setShowRegisterFlow(false),
        centered: true,
        style: {
            top: '10px'
        },
        children: (0, $bb3TF.jsx)((0, $e8a39231f31cbf92$export$2e2bcd8739ae039), {
            setModalVisible: setShowRegisterFlow,
            markBasicInfoStepComplete: markBasicInfoStepComplete
        })
    }) : (0, $bb3TF.jsx)((0, $e8a39231f31cbf92$export$2e2bcd8739ae039), {
        markBasicInfoStepComplete: markBasicInfoStepComplete
    });
$0cdf02c01c127580$var$RegisterFlow.defaultProps = {
    isModal: true,
    showRegisterFlow: false,
    setShowRegisterFlow: null,
    markBasicInfoStepComplete: null
};
var $0cdf02c01c127580$export$2e2bcd8739ae039 = $0cdf02c01c127580$var$RegisterFlow;


var $09b5ddd9fb2207be$export$697337a473f96bad;
$09b5ddd9fb2207be$export$697337a473f96bad = `_1P183W_containerList`;


// interface OnboardingProps {}
const $692778c9933b99d3$var$Onboarding = ()=>{
    const { userId: userId, userRole: userRole } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const [basicInfoUserStep, setBasicInfoStep] = (0, $6fFrj.useState)();
    const [basicInfoStepWasJustUpdated, setBasicInfoStepWasJustUpdated] = (0, $6fFrj.useState)(false);
    const [showRegisterFlow, setShowRegisterFlow] = (0, $6fFrj.useState)(false);
    // graphql
    const { data: stepsData, loading: stepsLoading } = (0, $0ddf390d079c5075$export$640c4c736ed2e29c)({
        variables: {
            userId: userId
        },
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.toString());
        }
    });
    let { userSteps: userSteps } = stepsData || {};
    // filter out userSteps that staff shouldn't see
    if (userRole === 'STAFF') userSteps = userSteps?.filter((userStep)=>userStep?.Steps?.name !== 'workflow' && userStep?.Steps?.name !== 'branding' && userStep?.Steps?.name !== 'stripe' && userStep?.Steps?.name !== 'templated-email' && userStep?.Steps?.name !== 'interview');
    // update userStep
    const [updateUserStep, { loading: loadingUpdateUserStep }] = (0, $38b15148eab410f9$export$6a5fa00eda3e6c68)({
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Status updated');
        },
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.toString());
        }
    });
    // a function for updating userStep
    const updateUserStepStatus = (theUserId, stepId, completed)=>{
        // update UserStep
        updateUserStep({
            variables: {
                updateUserStepInput: {
                    userId: theUserId,
                    stepId: stepId,
                    completed: completed
                }
            }
        });
        // if the step is basicInfo, set basicInfoStepWasJustUpdated to true (avoid the RegisterFlow from poping back up)
        if (stepId === basicInfoUserStep?.stepId) setBasicInfoStepWasJustUpdated(true);
    };
    // useEffect to find basicInfo step
    (0, $6fFrj.useEffect)(()=>{
        if (userSteps) setBasicInfoStep(userSteps.filter((userStep)=>userStep?.Steps?.name === 'basic-info')[0]);
    }, [
        userSteps,
        setBasicInfoStep
    ]);
    // function to update basicInfoStep to completed
    const markBasicInfoStepComplete = ()=>{
        if (basicInfoUserStep) updateUserStepStatus(basicInfoUserStep.userId, basicInfoUserStep.stepId, true);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (basicInfoUserStep) setShowRegisterFlow(!basicInfoUserStep?.completed && !basicInfoStepWasJustUpdated);
    }, [
        basicInfoUserStep,
        basicInfoStepWasJustUpdated
    ]);
    if (stepsLoading) return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039), {
                active: true,
                paragraph: {
                    rows: 3
                }
            }),
            (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {}),
            (0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039), {
                active: true,
                paragraph: {
                    rows: 3
                }
            }),
            (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {}),
            (0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039), {
                active: true,
                paragraph: {
                    rows: 3
                }
            }),
            (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {})
        ]
    });
    return (0, $bb3TF.jsxs)("div", {
        children: [
            (0, $bb3TF.jsx)((0, $d8be83256c7630cc$export$2e2bcd8739ae039), {
                title: "Get Started",
                style: {
                    display: 'flex',
                    justifyContent: 'center'
                }
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 24,
                justify: "center",
                children: (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    className: $09b5ddd9fb2207be$export$697337a473f96bad,
                    span: 20,
                    children: [
                        (0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039), {
                            loading: stepsLoading,
                            children: (0, $bb3TF.jsx)((0, $df61c38e027db076$export$2e2bcd8739ae039), {
                                total: userSteps?.length,
                                completed: userSteps?.filter((step)=>step.completed)?.length
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $efc99d4d4dd69b2b$export$2e2bcd8739ae039), {
                            userSteps: userSteps,
                            updateUserStepStatus: updateUserStepStatus,
                            setShowRegisterFlow: setShowRegisterFlow
                        })
                    ]
                })
            }),
            (0, $bb3TF.jsx)((0, $0cdf02c01c127580$export$2e2bcd8739ae039), {
                showRegisterFlow: showRegisterFlow,
                setShowRegisterFlow: setShowRegisterFlow,
                markBasicInfoStepComplete: markBasicInfoStepComplete
            })
        ]
    });
};
var $692778c9933b99d3$export$2e2bcd8739ae039 = $692778c9933b99d3$var$Onboarding;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");





var $bb3TF = parcelRequire("bb3TF");

const { Title: $58c1491b566e843c$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { InfoCircleTwoTone: $58c1491b566e843c$var$InfoCircleTwoTone } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
function $58c1491b566e843c$var$SettingsHeader({ title: title, tooltipTitle: tooltipTitle, tooltipContent: tooltipContent }) {
    return (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        gutter: 16,
        style: {
            borderBottom: '1px dashed #D6D6D6'
        },
        children: [
            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)($58c1491b566e843c$var$Title, {
                    level: 3,
                    children: title
                })
            }),
            Boolean(tooltipTitle) && Boolean(tooltipContent) && (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                style: {
                    marginTop: '5px'
                },
                children: (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
                    overlayStyle: {
                        width: '50%'
                    },
                    placement: "right",
                    content: tooltipContent,
                    title: tooltipTitle,
                    trigger: "click",
                    children: (0, $bb3TF.jsx)($58c1491b566e843c$var$InfoCircleTwoTone, {})
                })
            })
        ]
    });
}
$58c1491b566e843c$var$SettingsHeader.defaultProps = {
    tooltipTitle: null,
    tooltipContent: null
};
var $58c1491b566e843c$export$2e2bcd8739ae039 = $58c1491b566e843c$var$SettingsHeader;




var $f2c2338526651060$export$20d4618f963aa6ef;
var $f2c2338526651060$export$a46a71c66786da6d;
var $f2c2338526651060$export$60576639ab27a08c;
$f2c2338526651060$export$20d4618f963aa6ef = `_9Ql3pW_descriptionRow`;
$f2c2338526651060$export$a46a71c66786da6d = `_9Ql3pW_fileUploadCol`;
$f2c2338526651060$export$60576639ab27a08c = `_9Ql3pW_uploadProfilePhotoBtn`;


//
// https://www.npmjs.com/package/react-avatar-edit
//
/* eslint-disable consistent-return */ /* eslint-disable react/jsx-filename-extension */ /* eslint-disable prefer-destructuring */ /* eslint-disable object-shorthand */ /* eslint-disable func-names */ /* eslint-disable no-return-assign */ /* eslint-disable no-nested-ternary */ /* eslint-disable no-else-return */ /* eslint-disable no-confusing-arrow */ /* eslint-disable operator-linebreak */ /* eslint-disable prefer-template */ /* eslint-disable implicit-arrow-linebreak */ /* eslint-disable class-methods-use-this */ /* eslint-disable comma-dangle */ /* eslint-disable @typescript-eslint/no-shadow */ /* eslint-disable prefer-arrow-callback */ /* eslint-disable @typescript-eslint/no-this-alias */ /* eslint-disable prefer-const */ /* eslint-disable react/sort-comp */ /* eslint-disable react/prop-types */ /* eslint-disable react/destructuring-assignment */ /* eslint-disable @typescript-eslint/no-empty-function */ /* eslint-disable react/static-property-placement */ 
var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");
var $e7665822d65865e0$exports = {};
"use strict";
Object.defineProperty($e7665822d65865e0$exports, "__esModule", {
    value: true
});
$e7665822d65865e0$exports.Konva = void 0;
var $748e96e4fda143cd$exports = {};
"use strict";
Object.defineProperty($748e96e4fda143cd$exports, "__esModule", {
    value: true
});
$748e96e4fda143cd$exports.Konva = void 0;
var $2aee50cb6c94cb28$exports = {};
"use strict";
Object.defineProperty($2aee50cb6c94cb28$exports, "__esModule", {
    value: true
});
$2aee50cb6c94cb28$exports._registerNode = $2aee50cb6c94cb28$exports.Konva = $2aee50cb6c94cb28$exports.glob = void 0;
var $2aee50cb6c94cb28$var$PI_OVER_180 = Math.PI / 180;
function $2aee50cb6c94cb28$var$detectBrowser() {
    return typeof window !== 'undefined' && (({}).toString.call(window) === '[object Window]' || ({}).toString.call(window) === '[object global]');
}
$2aee50cb6c94cb28$exports.glob = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof WorkerGlobalScope !== 'undefined' ? self : {};
$2aee50cb6c94cb28$exports.Konva = {
    _global: $2aee50cb6c94cb28$exports.glob,
    version: '9.0.2',
    isBrowser: $2aee50cb6c94cb28$var$detectBrowser(),
    isUnminified: /param/.test((function(param) {}).toString()),
    dblClickWindow: 400,
    getAngle (angle) {
        return $2aee50cb6c94cb28$exports.Konva.angleDeg ? angle * $2aee50cb6c94cb28$var$PI_OVER_180 : angle;
    },
    enableTrace: false,
    pointerEventsEnabled: true,
    autoDrawEnabled: true,
    hitOnDragEnabled: false,
    capturePointerEventsEnabled: false,
    _mouseListenClick: false,
    _touchListenClick: false,
    _pointerListenClick: false,
    _mouseInDblClickWindow: false,
    _touchInDblClickWindow: false,
    _pointerInDblClickWindow: false,
    _mouseDblClickPointerId: null,
    _touchDblClickPointerId: null,
    _pointerDblClickPointerId: null,
    pixelRatio: typeof window !== 'undefined' && window.devicePixelRatio || 1,
    dragDistance: 3,
    angleDeg: true,
    showWarnings: true,
    dragButtons: [
        0,
        1
    ],
    isDragging () {
        return $2aee50cb6c94cb28$exports.Konva['DD'].isDragging;
    },
    isDragReady () {
        return !!$2aee50cb6c94cb28$exports.Konva['DD'].node;
    },
    releaseCanvasOnDestroy: true,
    document: $2aee50cb6c94cb28$exports.glob.document,
    _injectGlobal (Konva) {
        $2aee50cb6c94cb28$exports.glob.Konva = Konva;
    }
};
const $2aee50cb6c94cb28$var$_registerNode = (NodeClass)=>{
    $2aee50cb6c94cb28$exports.Konva[NodeClass.prototype.getClassName()] = NodeClass;
};
$2aee50cb6c94cb28$exports._registerNode = $2aee50cb6c94cb28$var$_registerNode;
$2aee50cb6c94cb28$exports.Konva._injectGlobal($2aee50cb6c94cb28$exports.Konva);


var $f4b7065bbd5eff66$exports = {};
"use strict";
Object.defineProperty($f4b7065bbd5eff66$exports, "__esModule", {
    value: true
});
$f4b7065bbd5eff66$exports.Util = $f4b7065bbd5eff66$exports.Transform = void 0;

class $f4b7065bbd5eff66$var$Transform {
    constructor(m = [
        1,
        0,
        0,
        1,
        0,
        0
    ]){
        this.dirty = false;
        this.m = m && m.slice() || [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    reset() {
        this.m[0] = 1;
        this.m[1] = 0;
        this.m[2] = 0;
        this.m[3] = 1;
        this.m[4] = 0;
        this.m[5] = 0;
    }
    copy() {
        return new $f4b7065bbd5eff66$var$Transform(this.m);
    }
    copyInto(tr) {
        tr.m[0] = this.m[0];
        tr.m[1] = this.m[1];
        tr.m[2] = this.m[2];
        tr.m[3] = this.m[3];
        tr.m[4] = this.m[4];
        tr.m[5] = this.m[5];
    }
    point(point) {
        var m = this.m;
        return {
            x: m[0] * point.x + m[2] * point.y + m[4],
            y: m[1] * point.x + m[3] * point.y + m[5]
        };
    }
    translate(x, y) {
        this.m[4] += this.m[0] * x + this.m[2] * y;
        this.m[5] += this.m[1] * x + this.m[3] * y;
        return this;
    }
    scale(sx, sy) {
        this.m[0] *= sx;
        this.m[1] *= sx;
        this.m[2] *= sy;
        this.m[3] *= sy;
        return this;
    }
    rotate(rad) {
        var c = Math.cos(rad);
        var s = Math.sin(rad);
        var m11 = this.m[0] * c + this.m[2] * s;
        var m12 = this.m[1] * c + this.m[3] * s;
        var m21 = this.m[0] * -s + this.m[2] * c;
        var m22 = this.m[1] * -s + this.m[3] * c;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    getTranslation() {
        return {
            x: this.m[4],
            y: this.m[5]
        };
    }
    skew(sx, sy) {
        var m11 = this.m[0] + this.m[2] * sy;
        var m12 = this.m[1] + this.m[3] * sy;
        var m21 = this.m[2] + this.m[0] * sx;
        var m22 = this.m[3] + this.m[1] * sx;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    multiply(matrix) {
        var m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
        var m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
        var m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
        var m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
        var dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
        var dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        this.m[4] = dx;
        this.m[5] = dy;
        return this;
    }
    invert() {
        var d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
        var m0 = this.m[3] * d;
        var m1 = -this.m[1] * d;
        var m2 = -this.m[2] * d;
        var m3 = this.m[0] * d;
        var m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
        var m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        this.m[0] = m0;
        this.m[1] = m1;
        this.m[2] = m2;
        this.m[3] = m3;
        this.m[4] = m4;
        this.m[5] = m5;
        return this;
    }
    getMatrix() {
        return this.m;
    }
    decompose() {
        var a = this.m[0];
        var b = this.m[1];
        var c = this.m[2];
        var d = this.m[3];
        var e = this.m[4];
        var f = this.m[5];
        var delta = a * d - b * c;
        let result = {
            x: e,
            y: f,
            rotation: 0,
            scaleX: 0,
            scaleY: 0,
            skewX: 0,
            skewY: 0
        };
        if (a != 0 || b != 0) {
            var r = Math.sqrt(a * a + b * b);
            result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
            result.scaleX = r;
            result.scaleY = delta / r;
            result.skewX = (a * c + b * d) / delta;
            result.skewY = 0;
        } else if (c != 0 || d != 0) {
            var s = Math.sqrt(c * c + d * d);
            result.rotation = Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
            result.scaleX = delta / s;
            result.scaleY = s;
            result.skewX = 0;
            result.skewY = (a * c + b * d) / delta;
        }
        result.rotation = $f4b7065bbd5eff66$exports.Util._getRotation(result.rotation);
        return result;
    }
}
$f4b7065bbd5eff66$exports.Transform = $f4b7065bbd5eff66$var$Transform;
var $f4b7065bbd5eff66$var$OBJECT_ARRAY = '[object Array]', $f4b7065bbd5eff66$var$OBJECT_NUMBER = '[object Number]', $f4b7065bbd5eff66$var$OBJECT_STRING = '[object String]', $f4b7065bbd5eff66$var$OBJECT_BOOLEAN = '[object Boolean]', $f4b7065bbd5eff66$var$PI_OVER_DEG180 = Math.PI / 180, $f4b7065bbd5eff66$var$DEG180_OVER_PI = 180 / Math.PI, $f4b7065bbd5eff66$var$HASH = '#', $f4b7065bbd5eff66$var$EMPTY_STRING = '', $f4b7065bbd5eff66$var$ZERO = '0', $f4b7065bbd5eff66$var$KONVA_WARNING = 'Konva warning: ', $f4b7065bbd5eff66$var$KONVA_ERROR = 'Konva error: ', $f4b7065bbd5eff66$var$RGB_PAREN = 'rgb(', $f4b7065bbd5eff66$var$COLORS = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        132,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        255,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        203
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        119,
        128,
        144
    ],
    slategrey: [
        119,
        128,
        144
    ],
    snow: [
        255,
        255,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    transparent: [
        255,
        255,
        255,
        0
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        5
    ]
}, $f4b7065bbd5eff66$var$RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, $f4b7065bbd5eff66$var$animQueue = [];
const $f4b7065bbd5eff66$var$req = typeof requestAnimationFrame !== 'undefined' && requestAnimationFrame || function(f) {
    setTimeout(f, 60);
};
$f4b7065bbd5eff66$exports.Util = {
    _isElement (obj) {
        return !!(obj && obj.nodeType == 1);
    },
    _isFunction (obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    },
    _isPlainObject (obj) {
        return !!obj && obj.constructor === Object;
    },
    _isArray (obj) {
        return Object.prototype.toString.call(obj) === $f4b7065bbd5eff66$var$OBJECT_ARRAY;
    },
    _isNumber (obj) {
        return Object.prototype.toString.call(obj) === $f4b7065bbd5eff66$var$OBJECT_NUMBER && !isNaN(obj) && isFinite(obj);
    },
    _isString (obj) {
        return Object.prototype.toString.call(obj) === $f4b7065bbd5eff66$var$OBJECT_STRING;
    },
    _isBoolean (obj) {
        return Object.prototype.toString.call(obj) === $f4b7065bbd5eff66$var$OBJECT_BOOLEAN;
    },
    isObject (val) {
        return val instanceof Object;
    },
    isValidSelector (selector) {
        if (typeof selector !== 'string') return false;
        var firstChar = selector[0];
        return firstChar === '#' || firstChar === '.' || firstChar === firstChar.toUpperCase();
    },
    _sign (number) {
        if (number === 0) return 1;
        if (number > 0) return 1;
        else return -1;
    },
    requestAnimFrame (callback) {
        $f4b7065bbd5eff66$var$animQueue.push(callback);
        if ($f4b7065bbd5eff66$var$animQueue.length === 1) $f4b7065bbd5eff66$var$req(function() {
            const queue = $f4b7065bbd5eff66$var$animQueue;
            $f4b7065bbd5eff66$var$animQueue = [];
            queue.forEach(function(cb) {
                cb();
            });
        });
    },
    createCanvasElement () {
        var canvas = document.createElement('canvas');
        try {
            canvas.style = canvas.style || {};
        } catch (e) {}
        return canvas;
    },
    createImageElement () {
        return document.createElement('img');
    },
    _isInDocument (el) {
        while(el = el.parentNode){
            if (el == document) return true;
        }
        return false;
    },
    _urlToImage (url, callback) {
        var imageObj = $f4b7065bbd5eff66$exports.Util.createImageElement();
        imageObj.onload = function() {
            callback(imageObj);
        };
        imageObj.src = url;
    },
    _rgbToHex (r, g, b) {
        return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    _hexToRgb (hex) {
        hex = hex.replace($f4b7065bbd5eff66$var$HASH, $f4b7065bbd5eff66$var$EMPTY_STRING);
        var bigint = parseInt(hex, 16);
        return {
            r: bigint >> 16 & 255,
            g: bigint >> 8 & 255,
            b: bigint & 255
        };
    },
    getRandomColor () {
        var randColor = (Math.random() * 0xffffff << 0).toString(16);
        while(randColor.length < 6)randColor = $f4b7065bbd5eff66$var$ZERO + randColor;
        return $f4b7065bbd5eff66$var$HASH + randColor;
    },
    getRGB (color) {
        var rgb;
        if (color in $f4b7065bbd5eff66$var$COLORS) {
            rgb = $f4b7065bbd5eff66$var$COLORS[color];
            return {
                r: rgb[0],
                g: rgb[1],
                b: rgb[2]
            };
        } else if (color[0] === $f4b7065bbd5eff66$var$HASH) return this._hexToRgb(color.substring(1));
        else if (color.substr(0, 4) === $f4b7065bbd5eff66$var$RGB_PAREN) {
            rgb = $f4b7065bbd5eff66$var$RGB_REGEX.exec(color.replace(/ /g, ''));
            return {
                r: parseInt(rgb[1], 10),
                g: parseInt(rgb[2], 10),
                b: parseInt(rgb[3], 10)
            };
        } else return {
            r: 0,
            g: 0,
            b: 0
        };
    },
    colorToRGBA (str) {
        str = str || 'black';
        return $f4b7065bbd5eff66$exports.Util._namedColorToRBA(str) || $f4b7065bbd5eff66$exports.Util._hex3ColorToRGBA(str) || $f4b7065bbd5eff66$exports.Util._hex4ColorToRGBA(str) || $f4b7065bbd5eff66$exports.Util._hex6ColorToRGBA(str) || $f4b7065bbd5eff66$exports.Util._hex8ColorToRGBA(str) || $f4b7065bbd5eff66$exports.Util._rgbColorToRGBA(str) || $f4b7065bbd5eff66$exports.Util._rgbaColorToRGBA(str) || $f4b7065bbd5eff66$exports.Util._hslColorToRGBA(str);
    },
    _namedColorToRBA (str) {
        var c = $f4b7065bbd5eff66$var$COLORS[str.toLowerCase()];
        if (!c) return null;
        return {
            r: c[0],
            g: c[1],
            b: c[2],
            a: 1
        };
    },
    _rgbColorToRGBA (str) {
        if (str.indexOf('rgb(') === 0) {
            str = str.match(/rgb\(([^)]+)\)/)[1];
            var parts = str.split(/ *, */).map(Number);
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: 1
            };
        }
    },
    _rgbaColorToRGBA (str) {
        if (str.indexOf('rgba(') === 0) {
            str = str.match(/rgba\(([^)]+)\)/)[1];
            var parts = str.split(/ *, */).map((n, index)=>{
                if (n.slice(-1) === '%') return index === 3 ? parseInt(n) / 100 : parseInt(n) / 100 * 255;
                return Number(n);
            });
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: parts[3]
            };
        }
    },
    _hex8ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 9) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: parseInt(str.slice(7, 9), 16) / 0xff
        };
    },
    _hex6ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 7) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: 1
        };
    },
    _hex4ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 5) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: parseInt(str[4] + str[4], 16) / 0xff
        };
    },
    _hex3ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 4) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: 1
        };
    },
    _hslColorToRGBA (str) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
            const [_, ...hsl] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str);
            const h = Number(hsl[0]) / 360;
            const s = Number(hsl[1]) / 100;
            const l = Number(hsl[2]) / 100;
            let t2;
            let t3;
            let val;
            if (s === 0) {
                val = l * 255;
                return {
                    r: Math.round(val),
                    g: Math.round(val),
                    b: Math.round(val),
                    a: 1
                };
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            const t1 = 2 * l - t2;
            const rgb = [
                0,
                0,
                0
            ];
            for(let i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return {
                r: Math.round(rgb[0]),
                g: Math.round(rgb[1]),
                b: Math.round(rgb[2]),
                a: 1
            };
        }
    },
    haveIntersection (r1, r2) {
        return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y);
    },
    cloneObject (obj) {
        var retObj = {};
        for(var key in obj){
            if (this._isPlainObject(obj[key])) retObj[key] = this.cloneObject(obj[key]);
            else if (this._isArray(obj[key])) retObj[key] = this.cloneArray(obj[key]);
            else retObj[key] = obj[key];
        }
        return retObj;
    },
    cloneArray (arr) {
        return arr.slice(0);
    },
    degToRad (deg) {
        return deg * $f4b7065bbd5eff66$var$PI_OVER_DEG180;
    },
    radToDeg (rad) {
        return rad * $f4b7065bbd5eff66$var$DEG180_OVER_PI;
    },
    _degToRad (deg) {
        $f4b7065bbd5eff66$exports.Util.warn('Util._degToRad is removed. Please use public Util.degToRad instead.');
        return $f4b7065bbd5eff66$exports.Util.degToRad(deg);
    },
    _radToDeg (rad) {
        $f4b7065bbd5eff66$exports.Util.warn('Util._radToDeg is removed. Please use public Util.radToDeg instead.');
        return $f4b7065bbd5eff66$exports.Util.radToDeg(rad);
    },
    _getRotation (radians) {
        return $2aee50cb6c94cb28$exports.Konva.angleDeg ? $f4b7065bbd5eff66$exports.Util.radToDeg(radians) : radians;
    },
    _capitalize (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    throw (str) {
        throw new Error($f4b7065bbd5eff66$var$KONVA_ERROR + str);
    },
    error (str) {
        console.error($f4b7065bbd5eff66$var$KONVA_ERROR + str);
    },
    warn (str) {
        if (!$2aee50cb6c94cb28$exports.Konva.showWarnings) return;
        console.warn($f4b7065bbd5eff66$var$KONVA_WARNING + str);
    },
    each (obj, func) {
        for(var key in obj)func(key, obj[key]);
    },
    _inRange (val, left, right) {
        return left <= val && val < right;
    },
    _getProjectionToSegment (x1, y1, x2, y2, x3, y3) {
        var x, y, dist;
        var pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
        if (pd2 == 0) {
            x = x1;
            y = y1;
            dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
        } else {
            var u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
            if (u < 0) {
                x = x1;
                y = y1;
                dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
            } else if (u > 1.0) {
                x = x2;
                y = y2;
                dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
            } else {
                x = x1 + u * (x2 - x1);
                y = y1 + u * (y2 - y1);
                dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
            }
        }
        return [
            x,
            y,
            dist
        ];
    },
    _getProjectionToLine (pt, line, isClosed) {
        var pc = $f4b7065bbd5eff66$exports.Util.cloneObject(pt);
        var dist = Number.MAX_VALUE;
        line.forEach(function(p1, i) {
            if (!isClosed && i === line.length - 1) return;
            var p2 = line[(i + 1) % line.length];
            var proj = $f4b7065bbd5eff66$exports.Util._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
            var px = proj[0], py = proj[1], pdist = proj[2];
            if (pdist < dist) {
                pc.x = px;
                pc.y = py;
                dist = pdist;
            }
        });
        return pc;
    },
    _prepareArrayForTween (startArray, endArray, isClosed) {
        var n, start = [], end = [];
        if (startArray.length > endArray.length) {
            var temp = endArray;
            endArray = startArray;
            startArray = temp;
        }
        for(n = 0; n < startArray.length; n += 2)start.push({
            x: startArray[n],
            y: startArray[n + 1]
        });
        for(n = 0; n < endArray.length; n += 2)end.push({
            x: endArray[n],
            y: endArray[n + 1]
        });
        var newStart = [];
        end.forEach(function(point) {
            var pr = $f4b7065bbd5eff66$exports.Util._getProjectionToLine(point, start, isClosed);
            newStart.push(pr.x);
            newStart.push(pr.y);
        });
        return newStart;
    },
    _prepareToStringify (obj) {
        var desc;
        obj.visitedByCircularReferenceRemoval = true;
        for(var key in obj){
            if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == 'object')) continue;
            desc = Object.getOwnPropertyDescriptor(obj, key);
            if (obj[key].visitedByCircularReferenceRemoval || $f4b7065bbd5eff66$exports.Util._isElement(obj[key])) {
                if (desc.configurable) delete obj[key];
                else return null;
            } else if ($f4b7065bbd5eff66$exports.Util._prepareToStringify(obj[key]) === null) {
                if (desc.configurable) delete obj[key];
                else return null;
            }
        }
        delete obj.visitedByCircularReferenceRemoval;
        return obj;
    },
    _assign (target, source) {
        for(var key in source)target[key] = source[key];
        return target;
    },
    _getFirstPointerId (evt) {
        if (!evt.touches) return evt.pointerId || 999;
        else return evt.changedTouches[0].identifier;
    },
    releaseCanvas (...canvases) {
        if (!$2aee50cb6c94cb28$exports.Konva.releaseCanvasOnDestroy) return;
        canvases.forEach((c)=>{
            c.width = 0;
            c.height = 0;
        });
    },
    drawRoundedRectPath (context, width, height, cornerRadius) {
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === 'number') topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.moveTo(topLeft, 0);
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
    }
};


var $f5298bb5f7719915$exports = {};
"use strict";
Object.defineProperty($f5298bb5f7719915$exports, "__esModule", {
    value: true
});
$f5298bb5f7719915$exports.Node = void 0;

var $4831cc45767eb450$exports = {};
"use strict";
Object.defineProperty($4831cc45767eb450$exports, "__esModule", {
    value: true
});
$4831cc45767eb450$exports.Factory = void 0;

var $b21213ef7b53b4df$exports = {};
"use strict";
Object.defineProperty($b21213ef7b53b4df$exports, "__esModule", {
    value: true
});
$b21213ef7b53b4df$exports.getComponentValidator = $b21213ef7b53b4df$exports.getBooleanValidator = $b21213ef7b53b4df$exports.getNumberArrayValidator = $b21213ef7b53b4df$exports.getFunctionValidator = $b21213ef7b53b4df$exports.getStringOrGradientValidator = $b21213ef7b53b4df$exports.getStringValidator = $b21213ef7b53b4df$exports.getNumberOrAutoValidator = $b21213ef7b53b4df$exports.getNumberOrArrayOfNumbersValidator = $b21213ef7b53b4df$exports.getNumberValidator = $b21213ef7b53b4df$exports.alphaComponent = $b21213ef7b53b4df$exports.RGBComponent = void 0;


function $b21213ef7b53b4df$var$_formatValue(val) {
    if ($f4b7065bbd5eff66$exports.Util._isString(val)) return '"' + val + '"';
    if (Object.prototype.toString.call(val) === '[object Number]') return val;
    if ($f4b7065bbd5eff66$exports.Util._isBoolean(val)) return val;
    return Object.prototype.toString.call(val);
}
function $b21213ef7b53b4df$var$RGBComponent(val) {
    if (val > 255) return 255;
    else if (val < 0) return 0;
    return Math.round(val);
}
$b21213ef7b53b4df$exports.RGBComponent = $b21213ef7b53b4df$var$RGBComponent;
function $b21213ef7b53b4df$var$alphaComponent(val) {
    if (val > 1) return 1;
    else if (val < 0.0001) return 0.0001;
    return val;
}
$b21213ef7b53b4df$exports.alphaComponent = $b21213ef7b53b4df$var$alphaComponent;
function $b21213ef7b53b4df$var$getNumberValidator() {
    if ($2aee50cb6c94cb28$exports.Konva.isUnminified) return function(val, attr) {
        if (!$f4b7065bbd5eff66$exports.Util._isNumber(val)) $f4b7065bbd5eff66$exports.Util.warn($b21213ef7b53b4df$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number.');
        return val;
    };
}
$b21213ef7b53b4df$exports.getNumberValidator = $b21213ef7b53b4df$var$getNumberValidator;
function $b21213ef7b53b4df$var$getNumberOrArrayOfNumbersValidator(noOfElements) {
    if ($2aee50cb6c94cb28$exports.Konva.isUnminified) return function(val, attr) {
        let isNumber = $f4b7065bbd5eff66$exports.Util._isNumber(val);
        let isValidArray = $f4b7065bbd5eff66$exports.Util._isArray(val) && val.length == noOfElements;
        if (!isNumber && !isValidArray) $f4b7065bbd5eff66$exports.Util.warn($b21213ef7b53b4df$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or Array<number>(' + noOfElements + ')');
        return val;
    };
}
$b21213ef7b53b4df$exports.getNumberOrArrayOfNumbersValidator = $b21213ef7b53b4df$var$getNumberOrArrayOfNumbersValidator;
function $b21213ef7b53b4df$var$getNumberOrAutoValidator() {
    if ($2aee50cb6c94cb28$exports.Konva.isUnminified) return function(val, attr) {
        var isNumber = $f4b7065bbd5eff66$exports.Util._isNumber(val);
        var isAuto = val === 'auto';
        if (!(isNumber || isAuto)) $f4b7065bbd5eff66$exports.Util.warn($b21213ef7b53b4df$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or "auto".');
        return val;
    };
}
$b21213ef7b53b4df$exports.getNumberOrAutoValidator = $b21213ef7b53b4df$var$getNumberOrAutoValidator;
function $b21213ef7b53b4df$var$getStringValidator() {
    if ($2aee50cb6c94cb28$exports.Konva.isUnminified) return function(val, attr) {
        if (!$f4b7065bbd5eff66$exports.Util._isString(val)) $f4b7065bbd5eff66$exports.Util.warn($b21213ef7b53b4df$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string.');
        return val;
    };
}
$b21213ef7b53b4df$exports.getStringValidator = $b21213ef7b53b4df$var$getStringValidator;
function $b21213ef7b53b4df$var$getStringOrGradientValidator() {
    if ($2aee50cb6c94cb28$exports.Konva.isUnminified) return function(val, attr) {
        const isString = $f4b7065bbd5eff66$exports.Util._isString(val);
        const isGradient = Object.prototype.toString.call(val) === '[object CanvasGradient]' || val && val.addColorStop;
        if (!(isString || isGradient)) $f4b7065bbd5eff66$exports.Util.warn($b21213ef7b53b4df$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string or a native gradient.');
        return val;
    };
}
$b21213ef7b53b4df$exports.getStringOrGradientValidator = $b21213ef7b53b4df$var$getStringOrGradientValidator;
function $b21213ef7b53b4df$var$getFunctionValidator() {
    if ($2aee50cb6c94cb28$exports.Konva.isUnminified) return function(val, attr) {
        if (!$f4b7065bbd5eff66$exports.Util._isFunction(val)) $f4b7065bbd5eff66$exports.Util.warn($b21213ef7b53b4df$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a function.');
        return val;
    };
}
$b21213ef7b53b4df$exports.getFunctionValidator = $b21213ef7b53b4df$var$getFunctionValidator;
function $b21213ef7b53b4df$var$getNumberArrayValidator() {
    if ($2aee50cb6c94cb28$exports.Konva.isUnminified) return function(val, attr) {
        const TypedArray = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        if (TypedArray && val instanceof TypedArray) return val;
        if (!$f4b7065bbd5eff66$exports.Util._isArray(val)) $f4b7065bbd5eff66$exports.Util.warn($b21213ef7b53b4df$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a array of numbers.');
        else val.forEach(function(item) {
            if (!$f4b7065bbd5eff66$exports.Util._isNumber(item)) $f4b7065bbd5eff66$exports.Util.warn('"' + attr + '" attribute has non numeric element ' + item + '. Make sure that all elements are numbers.');
        });
        return val;
    };
}
$b21213ef7b53b4df$exports.getNumberArrayValidator = $b21213ef7b53b4df$var$getNumberArrayValidator;
function $b21213ef7b53b4df$var$getBooleanValidator() {
    if ($2aee50cb6c94cb28$exports.Konva.isUnminified) return function(val, attr) {
        var isBool = val === true || val === false;
        if (!isBool) $f4b7065bbd5eff66$exports.Util.warn($b21213ef7b53b4df$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a boolean.');
        return val;
    };
}
$b21213ef7b53b4df$exports.getBooleanValidator = $b21213ef7b53b4df$var$getBooleanValidator;
function $b21213ef7b53b4df$var$getComponentValidator(components) {
    if ($2aee50cb6c94cb28$exports.Konva.isUnminified) return function(val, attr) {
        if (val === undefined || val === null) return val;
        if (!$f4b7065bbd5eff66$exports.Util.isObject(val)) $f4b7065bbd5eff66$exports.Util.warn($b21213ef7b53b4df$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be an object with properties ' + components);
        return val;
    };
}
$b21213ef7b53b4df$exports.getComponentValidator = $b21213ef7b53b4df$var$getComponentValidator;


var $4831cc45767eb450$var$GET = 'get', $4831cc45767eb450$var$SET = 'set';
$4831cc45767eb450$exports.Factory = {
    addGetterSetter (constructor, attr, def, validator, after) {
        $4831cc45767eb450$exports.Factory.addGetter(constructor, attr, def);
        $4831cc45767eb450$exports.Factory.addSetter(constructor, attr, validator, after);
        $4831cc45767eb450$exports.Factory.addOverloadedGetterSetter(constructor, attr);
    },
    addGetter (constructor, attr, def) {
        var method = $4831cc45767eb450$var$GET + $f4b7065bbd5eff66$exports.Util._capitalize(attr);
        constructor.prototype[method] = constructor.prototype[method] || function() {
            var val = this.attrs[attr];
            return val === undefined ? def : val;
        };
    },
    addSetter (constructor, attr, validator, after) {
        var method = $4831cc45767eb450$var$SET + $f4b7065bbd5eff66$exports.Util._capitalize(attr);
        if (!constructor.prototype[method]) $4831cc45767eb450$exports.Factory.overWriteSetter(constructor, attr, validator, after);
    },
    overWriteSetter (constructor, attr, validator, after) {
        var method = $4831cc45767eb450$var$SET + $f4b7065bbd5eff66$exports.Util._capitalize(attr);
        constructor.prototype[method] = function(val) {
            if (validator && val !== undefined && val !== null) val = validator.call(this, val, attr);
            this._setAttr(attr, val);
            if (after) after.call(this);
            return this;
        };
    },
    addComponentsGetterSetter (constructor, attr, components, validator, after) {
        var len = components.length, capitalize = $f4b7065bbd5eff66$exports.Util._capitalize, getter = $4831cc45767eb450$var$GET + capitalize(attr), setter = $4831cc45767eb450$var$SET + capitalize(attr), n, component;
        constructor.prototype[getter] = function() {
            var ret = {};
            for(n = 0; n < len; n++){
                component = components[n];
                ret[component] = this.getAttr(attr + capitalize(component));
            }
            return ret;
        };
        var basicValidator = (0, $b21213ef7b53b4df$exports.getComponentValidator)(components);
        constructor.prototype[setter] = function(val) {
            var oldVal = this.attrs[attr], key;
            if (validator) val = validator.call(this, val);
            if (basicValidator) basicValidator.call(this, val, attr);
            for(key in val){
                if (!val.hasOwnProperty(key)) continue;
                this._setAttr(attr + capitalize(key), val[key]);
            }
            if (!val) components.forEach((component)=>{
                this._setAttr(attr + capitalize(component), undefined);
            });
            this._fireChangeEvent(attr, oldVal, val);
            if (after) after.call(this);
            return this;
        };
        $4831cc45767eb450$exports.Factory.addOverloadedGetterSetter(constructor, attr);
    },
    addOverloadedGetterSetter (constructor, attr) {
        var capitalizedAttr = $f4b7065bbd5eff66$exports.Util._capitalize(attr), setter = $4831cc45767eb450$var$SET + capitalizedAttr, getter = $4831cc45767eb450$var$GET + capitalizedAttr;
        constructor.prototype[attr] = function() {
            if (arguments.length) {
                this[setter](arguments[0]);
                return this;
            }
            return this[getter]();
        };
    },
    addDeprecatedGetterSetter (constructor, attr, def, validator) {
        $f4b7065bbd5eff66$exports.Util.error('Adding deprecated ' + attr);
        var method = $4831cc45767eb450$var$GET + $f4b7065bbd5eff66$exports.Util._capitalize(attr);
        var message = attr + ' property is deprecated and will be removed soon. Look at Konva change log for more information.';
        constructor.prototype[method] = function() {
            $f4b7065bbd5eff66$exports.Util.error(message);
            var val = this.attrs[attr];
            return val === undefined ? def : val;
        };
        $4831cc45767eb450$exports.Factory.addSetter(constructor, attr, validator, function() {
            $f4b7065bbd5eff66$exports.Util.error(message);
        });
        $4831cc45767eb450$exports.Factory.addOverloadedGetterSetter(constructor, attr);
    },
    backCompat (constructor, methods) {
        $f4b7065bbd5eff66$exports.Util.each(methods, function(oldMethodName, newMethodName) {
            var method = constructor.prototype[newMethodName];
            var oldGetter = $4831cc45767eb450$var$GET + $f4b7065bbd5eff66$exports.Util._capitalize(oldMethodName);
            var oldSetter = $4831cc45767eb450$var$SET + $f4b7065bbd5eff66$exports.Util._capitalize(oldMethodName);
            function deprecated() {
                method.apply(this, arguments);
                $f4b7065bbd5eff66$exports.Util.error('"' + oldMethodName + '" method is deprecated and will be removed soon. Use ""' + newMethodName + '" instead.');
            }
            constructor.prototype[oldMethodName] = deprecated;
            constructor.prototype[oldGetter] = deprecated;
            constructor.prototype[oldSetter] = deprecated;
        });
    },
    afterSetFilter () {
        this._filterUpToDate = false;
    }
};


var $e708bc73165de52e$exports = {};
"use strict";
Object.defineProperty($e708bc73165de52e$exports, "__esModule", {
    value: true
});
$e708bc73165de52e$exports.HitCanvas = $e708bc73165de52e$exports.SceneCanvas = $e708bc73165de52e$exports.Canvas = void 0;

var $ba5dd10b43d209dd$exports = {};
"use strict";
Object.defineProperty($ba5dd10b43d209dd$exports, "__esModule", {
    value: true
});
$ba5dd10b43d209dd$exports.HitContext = $ba5dd10b43d209dd$exports.SceneContext = $ba5dd10b43d209dd$exports.Context = void 0;


function $ba5dd10b43d209dd$var$simplifyArray(arr) {
    var retArr = [], len = arr.length, util = $f4b7065bbd5eff66$exports.Util, n, val;
    for(n = 0; n < len; n++){
        val = arr[n];
        if (util._isNumber(val)) val = Math.round(val * 1000) / 1000;
        else if (!util._isString(val)) val = val + '';
        retArr.push(val);
    }
    return retArr;
}
var $ba5dd10b43d209dd$var$COMMA = ',', $ba5dd10b43d209dd$var$OPEN_PAREN = '(', $ba5dd10b43d209dd$var$CLOSE_PAREN = ')', $ba5dd10b43d209dd$var$OPEN_PAREN_BRACKET = '([', $ba5dd10b43d209dd$var$CLOSE_BRACKET_PAREN = '])', $ba5dd10b43d209dd$var$SEMICOLON = ';', $ba5dd10b43d209dd$var$DOUBLE_PAREN = '()', $ba5dd10b43d209dd$var$EQUALS = '=', $ba5dd10b43d209dd$var$CONTEXT_METHODS = [
    'arc',
    'arcTo',
    'beginPath',
    'bezierCurveTo',
    'clearRect',
    'clip',
    'closePath',
    'createLinearGradient',
    'createPattern',
    'createRadialGradient',
    'drawImage',
    'ellipse',
    'fill',
    'fillText',
    'getImageData',
    'createImageData',
    'lineTo',
    'moveTo',
    'putImageData',
    'quadraticCurveTo',
    'rect',
    'restore',
    'rotate',
    'save',
    'scale',
    'setLineDash',
    'setTransform',
    'stroke',
    'strokeText',
    'transform',
    'translate'
];
var $ba5dd10b43d209dd$var$CONTEXT_PROPERTIES = [
    'fillStyle',
    'strokeStyle',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'lineCap',
    'lineDashOffset',
    'lineJoin',
    'lineWidth',
    'miterLimit',
    'font',
    'textAlign',
    'textBaseline',
    'globalAlpha',
    'globalCompositeOperation',
    'imageSmoothingEnabled'
];
const $ba5dd10b43d209dd$var$traceArrMax = 100;
class $ba5dd10b43d209dd$var$Context {
    constructor(canvas){
        this.canvas = canvas;
        if ($2aee50cb6c94cb28$exports.Konva.enableTrace) {
            this.traceArr = [];
            this._enableTrace();
        }
    }
    fillShape(shape) {
        if (shape.fillEnabled()) this._fill(shape);
    }
    _fill(shape) {}
    strokeShape(shape) {
        if (shape.hasStroke()) this._stroke(shape);
    }
    _stroke(shape) {}
    fillStrokeShape(shape) {
        if (shape.attrs.fillAfterStrokeEnabled) {
            this.strokeShape(shape);
            this.fillShape(shape);
        } else {
            this.fillShape(shape);
            this.strokeShape(shape);
        }
    }
    getTrace(relaxed, rounded) {
        var traceArr = this.traceArr, len = traceArr.length, str = '', n, trace, method, args;
        for(n = 0; n < len; n++){
            trace = traceArr[n];
            method = trace.method;
            if (method) {
                args = trace.args;
                str += method;
                if (relaxed) str += $ba5dd10b43d209dd$var$DOUBLE_PAREN;
                else if ($f4b7065bbd5eff66$exports.Util._isArray(args[0])) str += $ba5dd10b43d209dd$var$OPEN_PAREN_BRACKET + args.join($ba5dd10b43d209dd$var$COMMA) + $ba5dd10b43d209dd$var$CLOSE_BRACKET_PAREN;
                else {
                    if (rounded) args = args.map((a)=>typeof a === 'number' ? Math.floor(a) : a);
                    str += $ba5dd10b43d209dd$var$OPEN_PAREN + args.join($ba5dd10b43d209dd$var$COMMA) + $ba5dd10b43d209dd$var$CLOSE_PAREN;
                }
            } else {
                str += trace.property;
                if (!relaxed) str += $ba5dd10b43d209dd$var$EQUALS + trace.val;
            }
            str += $ba5dd10b43d209dd$var$SEMICOLON;
        }
        return str;
    }
    clearTrace() {
        this.traceArr = [];
    }
    _trace(str) {
        var traceArr = this.traceArr, len;
        traceArr.push(str);
        len = traceArr.length;
        if (len >= $ba5dd10b43d209dd$var$traceArrMax) traceArr.shift();
    }
    reset() {
        var pixelRatio = this.getCanvas().getPixelRatio();
        this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
    }
    getCanvas() {
        return this.canvas;
    }
    clear(bounds) {
        var canvas = this.getCanvas();
        if (bounds) this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
        else this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
    }
    _applyLineCap(shape) {
        const lineCap = shape.attrs.lineCap;
        if (lineCap) this.setAttr('lineCap', lineCap);
    }
    _applyOpacity(shape) {
        var absOpacity = shape.getAbsoluteOpacity();
        if (absOpacity !== 1) this.setAttr('globalAlpha', absOpacity);
    }
    _applyLineJoin(shape) {
        const lineJoin = shape.attrs.lineJoin;
        if (lineJoin) this.setAttr('lineJoin', lineJoin);
    }
    setAttr(attr, val) {
        this._context[attr] = val;
    }
    arc(a0, a1, a2, a3, a4, a5) {
        this._context.arc(a0, a1, a2, a3, a4, a5);
    }
    arcTo(a0, a1, a2, a3, a4) {
        this._context.arcTo(a0, a1, a2, a3, a4);
    }
    beginPath() {
        this._context.beginPath();
    }
    bezierCurveTo(a0, a1, a2, a3, a4, a5) {
        this._context.bezierCurveTo(a0, a1, a2, a3, a4, a5);
    }
    clearRect(a0, a1, a2, a3) {
        this._context.clearRect(a0, a1, a2, a3);
    }
    clip() {
        this._context.clip();
    }
    closePath() {
        this._context.closePath();
    }
    createImageData(a0, a1) {
        var a = arguments;
        if (a.length === 2) return this._context.createImageData(a0, a1);
        else if (a.length === 1) return this._context.createImageData(a0);
    }
    createLinearGradient(a0, a1, a2, a3) {
        return this._context.createLinearGradient(a0, a1, a2, a3);
    }
    createPattern(a0, a1) {
        return this._context.createPattern(a0, a1);
    }
    createRadialGradient(a0, a1, a2, a3, a4, a5) {
        return this._context.createRadialGradient(a0, a1, a2, a3, a4, a5);
    }
    drawImage(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        var a = arguments, _context = this._context;
        if (a.length === 3) _context.drawImage(a0, a1, a2);
        else if (a.length === 5) _context.drawImage(a0, a1, a2, a3, a4);
        else if (a.length === 9) _context.drawImage(a0, a1, a2, a3, a4, a5, a6, a7, a8);
    }
    ellipse(a0, a1, a2, a3, a4, a5, a6, a7) {
        this._context.ellipse(a0, a1, a2, a3, a4, a5, a6, a7);
    }
    isPointInPath(x, y, path, fillRule) {
        if (path) return this._context.isPointInPath(path, x, y, fillRule);
        return this._context.isPointInPath(x, y, fillRule);
    }
    fill(path2d) {
        if (path2d) this._context.fill(path2d);
        else this._context.fill();
    }
    fillRect(x, y, width, height) {
        this._context.fillRect(x, y, width, height);
    }
    strokeRect(x, y, width, height) {
        this._context.strokeRect(x, y, width, height);
    }
    fillText(text, x, y, maxWidth) {
        if (maxWidth) this._context.fillText(text, x, y, maxWidth);
        else this._context.fillText(text, x, y);
    }
    measureText(text) {
        return this._context.measureText(text);
    }
    getImageData(a0, a1, a2, a3) {
        return this._context.getImageData(a0, a1, a2, a3);
    }
    lineTo(a0, a1) {
        this._context.lineTo(a0, a1);
    }
    moveTo(a0, a1) {
        this._context.moveTo(a0, a1);
    }
    rect(a0, a1, a2, a3) {
        this._context.rect(a0, a1, a2, a3);
    }
    putImageData(a0, a1, a2) {
        this._context.putImageData(a0, a1, a2);
    }
    quadraticCurveTo(a0, a1, a2, a3) {
        this._context.quadraticCurveTo(a0, a1, a2, a3);
    }
    restore() {
        this._context.restore();
    }
    rotate(a0) {
        this._context.rotate(a0);
    }
    save() {
        this._context.save();
    }
    scale(a0, a1) {
        this._context.scale(a0, a1);
    }
    setLineDash(a0) {
        if (this._context.setLineDash) this._context.setLineDash(a0);
        else if ('mozDash' in this._context) this._context['mozDash'] = a0;
        else if ('webkitLineDash' in this._context) this._context['webkitLineDash'] = a0;
    }
    getLineDash() {
        return this._context.getLineDash();
    }
    setTransform(a0, a1, a2, a3, a4, a5) {
        this._context.setTransform(a0, a1, a2, a3, a4, a5);
    }
    stroke(path2d) {
        if (path2d) this._context.stroke(path2d);
        else this._context.stroke();
    }
    strokeText(a0, a1, a2, a3) {
        this._context.strokeText(a0, a1, a2, a3);
    }
    transform(a0, a1, a2, a3, a4, a5) {
        this._context.transform(a0, a1, a2, a3, a4, a5);
    }
    translate(a0, a1) {
        this._context.translate(a0, a1);
    }
    _enableTrace() {
        var that = this, len = $ba5dd10b43d209dd$var$CONTEXT_METHODS.length, origSetter = this.setAttr, n, args;
        var func = function(methodName) {
            var origMethod = that[methodName], ret;
            that[methodName] = function() {
                args = $ba5dd10b43d209dd$var$simplifyArray(Array.prototype.slice.call(arguments, 0));
                ret = origMethod.apply(that, arguments);
                that._trace({
                    method: methodName,
                    args: args
                });
                return ret;
            };
        };
        for(n = 0; n < len; n++)func($ba5dd10b43d209dd$var$CONTEXT_METHODS[n]);
        that.setAttr = function() {
            origSetter.apply(that, arguments);
            var prop = arguments[0];
            var val = arguments[1];
            if (prop === 'shadowOffsetX' || prop === 'shadowOffsetY' || prop === 'shadowBlur') val = val / this.canvas.getPixelRatio();
            that._trace({
                property: prop,
                val: val
            });
        };
    }
    _applyGlobalCompositeOperation(node) {
        const op = node.attrs.globalCompositeOperation;
        var def = !op || op === 'source-over';
        if (!def) this.setAttr('globalCompositeOperation', op);
    }
}
$ba5dd10b43d209dd$exports.Context = $ba5dd10b43d209dd$var$Context;
$ba5dd10b43d209dd$var$CONTEXT_PROPERTIES.forEach(function(prop) {
    Object.defineProperty($ba5dd10b43d209dd$var$Context.prototype, prop, {
        get () {
            return this._context[prop];
        },
        set (val) {
            this._context[prop] = val;
        }
    });
});
class $ba5dd10b43d209dd$var$SceneContext extends $ba5dd10b43d209dd$var$Context {
    constructor(canvas, { willReadFrequently: willReadFrequently = false } = {}){
        super(canvas);
        this._context = canvas._canvas.getContext('2d', {
            willReadFrequently: willReadFrequently
        });
    }
    _fillColor(shape) {
        var fill = shape.fill();
        this.setAttr('fillStyle', fill);
        shape._fillFunc(this);
    }
    _fillPattern(shape) {
        this.setAttr('fillStyle', shape._getFillPattern());
        shape._fillFunc(this);
    }
    _fillLinearGradient(shape) {
        var grd = shape._getLinearGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    }
    _fillRadialGradient(shape) {
        const grd = shape._getRadialGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    }
    _fill(shape) {
        const hasColor = shape.fill(), fillPriority = shape.getFillPriority();
        if (hasColor && fillPriority === 'color') {
            this._fillColor(shape);
            return;
        }
        const hasPattern = shape.getFillPatternImage();
        if (hasPattern && fillPriority === 'pattern') {
            this._fillPattern(shape);
            return;
        }
        const hasLinearGradient = shape.getFillLinearGradientColorStops();
        if (hasLinearGradient && fillPriority === 'linear-gradient') {
            this._fillLinearGradient(shape);
            return;
        }
        const hasRadialGradient = shape.getFillRadialGradientColorStops();
        if (hasRadialGradient && fillPriority === 'radial-gradient') {
            this._fillRadialGradient(shape);
            return;
        }
        if (hasColor) this._fillColor(shape);
        else if (hasPattern) this._fillPattern(shape);
        else if (hasLinearGradient) this._fillLinearGradient(shape);
        else if (hasRadialGradient) this._fillRadialGradient(shape);
    }
    _strokeLinearGradient(shape) {
        const start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
        if (colorStops) {
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            this.setAttr('strokeStyle', grd);
        }
    }
    _stroke(shape) {
        var dash = shape.dash(), strokeScaleEnabled = shape.getStrokeScaleEnabled();
        if (shape.hasStroke()) {
            if (!strokeScaleEnabled) {
                this.save();
                var pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            if (dash && shape.dashEnabled()) {
                this.setLineDash(dash);
                this.setAttr('lineDashOffset', shape.dashOffset());
            }
            this.setAttr('lineWidth', shape.strokeWidth());
            if (!shape.getShadowForStrokeEnabled()) this.setAttr('shadowColor', 'rgba(0,0,0,0)');
            var hasLinearGradient = shape.getStrokeLinearGradientColorStops();
            if (hasLinearGradient) this._strokeLinearGradient(shape);
            else this.setAttr('strokeStyle', shape.stroke());
            shape._strokeFunc(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
    _applyShadow(shape) {
        var _a, _b, _c;
        var color = (_a = shape.getShadowRGBA()) !== null && _a !== void 0 ? _a : 'black', blur = (_b = shape.getShadowBlur()) !== null && _b !== void 0 ? _b : 5, offset = (_c = shape.getShadowOffset()) !== null && _c !== void 0 ? _c : {
            x: 0,
            y: 0
        }, scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
        this.setAttr('shadowColor', color);
        this.setAttr('shadowBlur', blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
        this.setAttr('shadowOffsetX', offset.x * scaleX);
        this.setAttr('shadowOffsetY', offset.y * scaleY);
    }
}
$ba5dd10b43d209dd$exports.SceneContext = $ba5dd10b43d209dd$var$SceneContext;
class $ba5dd10b43d209dd$var$HitContext extends $ba5dd10b43d209dd$var$Context {
    constructor(canvas){
        super(canvas);
        this._context = canvas._canvas.getContext('2d', {
            willReadFrequently: true
        });
    }
    _fill(shape) {
        this.save();
        this.setAttr('fillStyle', shape.colorKey);
        shape._fillFuncHit(this);
        this.restore();
    }
    strokeShape(shape) {
        if (shape.hasHitStroke()) this._stroke(shape);
    }
    _stroke(shape) {
        if (shape.hasHitStroke()) {
            const strokeScaleEnabled = shape.getStrokeScaleEnabled();
            if (!strokeScaleEnabled) {
                this.save();
                var pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            var hitStrokeWidth = shape.hitStrokeWidth();
            var strokeWidth = hitStrokeWidth === 'auto' ? shape.strokeWidth() : hitStrokeWidth;
            this.setAttr('lineWidth', strokeWidth);
            this.setAttr('strokeStyle', shape.colorKey);
            shape._strokeFuncHit(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
}
$ba5dd10b43d209dd$exports.HitContext = $ba5dd10b43d209dd$var$HitContext;





var $e708bc73165de52e$var$_pixelRatio;
function $e708bc73165de52e$var$getDevicePixelRatio() {
    if ($e708bc73165de52e$var$_pixelRatio) return $e708bc73165de52e$var$_pixelRatio;
    var canvas = $f4b7065bbd5eff66$exports.Util.createCanvasElement();
    var context = canvas.getContext('2d');
    $e708bc73165de52e$var$_pixelRatio = function() {
        var devicePixelRatio = $2aee50cb6c94cb28$exports.Konva._global.devicePixelRatio || 1, backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
        return devicePixelRatio / backingStoreRatio;
    }();
    $f4b7065bbd5eff66$exports.Util.releaseCanvas(canvas);
    return $e708bc73165de52e$var$_pixelRatio;
}
class $e708bc73165de52e$var$Canvas {
    constructor(config){
        this.pixelRatio = 1;
        this.width = 0;
        this.height = 0;
        this.isCache = false;
        var conf = config || {};
        var pixelRatio = conf.pixelRatio || $2aee50cb6c94cb28$exports.Konva.pixelRatio || $e708bc73165de52e$var$getDevicePixelRatio();
        this.pixelRatio = pixelRatio;
        this._canvas = $f4b7065bbd5eff66$exports.Util.createCanvasElement();
        this._canvas.style.padding = '0';
        this._canvas.style.margin = '0';
        this._canvas.style.border = '0';
        this._canvas.style.background = 'transparent';
        this._canvas.style.position = 'absolute';
        this._canvas.style.top = '0';
        this._canvas.style.left = '0';
    }
    getContext() {
        return this.context;
    }
    getPixelRatio() {
        return this.pixelRatio;
    }
    setPixelRatio(pixelRatio) {
        var previousRatio = this.pixelRatio;
        this.pixelRatio = pixelRatio;
        this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
    }
    setWidth(width) {
        this.width = this._canvas.width = width * this.pixelRatio;
        this._canvas.style.width = width + 'px';
        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    setHeight(height) {
        this.height = this._canvas.height = height * this.pixelRatio;
        this._canvas.style.height = height + 'px';
        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    setSize(width, height) {
        this.setWidth(width || 0);
        this.setHeight(height || 0);
    }
    toDataURL(mimeType, quality) {
        try {
            return this._canvas.toDataURL(mimeType, quality);
        } catch (e) {
            try {
                return this._canvas.toDataURL();
            } catch (err) {
                $f4b7065bbd5eff66$exports.Util.error('Unable to get data URL. ' + err.message + ' For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.');
                return '';
            }
        }
    }
}
$e708bc73165de52e$exports.Canvas = $e708bc73165de52e$var$Canvas;
$4831cc45767eb450$exports.Factory.addGetterSetter($e708bc73165de52e$var$Canvas, 'pixelRatio', undefined, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
class $e708bc73165de52e$var$SceneCanvas extends $e708bc73165de52e$var$Canvas {
    constructor(config = {
        width: 0,
        height: 0,
        willReadFrequently: false
    }){
        super(config);
        this.context = new $ba5dd10b43d209dd$exports.SceneContext(this, {
            willReadFrequently: config.willReadFrequently
        });
        this.setSize(config.width, config.height);
    }
}
$e708bc73165de52e$exports.SceneCanvas = $e708bc73165de52e$var$SceneCanvas;
class $e708bc73165de52e$var$HitCanvas extends $e708bc73165de52e$var$Canvas {
    constructor(config = {
        width: 0,
        height: 0
    }){
        super(config);
        this.hitCanvas = true;
        this.context = new $ba5dd10b43d209dd$exports.HitContext(this);
        this.setSize(config.width, config.height);
    }
}
$e708bc73165de52e$exports.HitCanvas = $e708bc73165de52e$var$HitCanvas;



var $49b27c4d80a13abe$exports = {};
"use strict";
Object.defineProperty($49b27c4d80a13abe$exports, "__esModule", {
    value: true
});
$49b27c4d80a13abe$exports.DD = void 0;


$49b27c4d80a13abe$exports.DD = {
    get isDragging () {
        var flag = false;
        $49b27c4d80a13abe$exports.DD._dragElements.forEach((elem)=>{
            if (elem.dragStatus === 'dragging') flag = true;
        });
        return flag;
    },
    justDragged: false,
    get node () {
        var node;
        $49b27c4d80a13abe$exports.DD._dragElements.forEach((elem)=>{
            node = elem.node;
        });
        return node;
    },
    _dragElements: new Map(),
    _drag (evt) {
        const nodesToFireEvents = [];
        $49b27c4d80a13abe$exports.DD._dragElements.forEach((elem, key)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            stage.setPointersPositions(evt);
            if (elem.pointerId === undefined) elem.pointerId = $f4b7065bbd5eff66$exports.Util._getFirstPointerId(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus !== 'dragging') {
                var dragDistance = node.dragDistance();
                var distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
                if (distance < dragDistance) return;
                node.startDrag({
                    evt: evt
                });
                if (!node.isDragging()) return;
            }
            node._setDragPosition(evt, elem);
            nodesToFireEvents.push(node);
        });
        nodesToFireEvents.forEach((node)=>{
            node.fire('dragmove', {
                type: 'dragmove',
                target: node,
                evt: evt
            }, true);
        });
    },
    _endDragBefore (evt) {
        const drawNodes = [];
        $49b27c4d80a13abe$exports.DD._dragElements.forEach((elem)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            if (evt) stage.setPointersPositions(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus === 'dragging' || elem.dragStatus === 'stopped') {
                $49b27c4d80a13abe$exports.DD.justDragged = true;
                $2aee50cb6c94cb28$exports.Konva._mouseListenClick = false;
                $2aee50cb6c94cb28$exports.Konva._touchListenClick = false;
                $2aee50cb6c94cb28$exports.Konva._pointerListenClick = false;
                elem.dragStatus = 'stopped';
            }
            const drawNode = elem.node.getLayer() || elem.node instanceof $2aee50cb6c94cb28$exports.Konva['Stage'] && elem.node;
            if (drawNode && drawNodes.indexOf(drawNode) === -1) drawNodes.push(drawNode);
        });
        drawNodes.forEach((drawNode)=>{
            drawNode.draw();
        });
    },
    _endDragAfter (evt) {
        $49b27c4d80a13abe$exports.DD._dragElements.forEach((elem, key)=>{
            if (elem.dragStatus === 'stopped') elem.node.fire('dragend', {
                type: 'dragend',
                target: elem.node,
                evt: evt
            }, true);
            if (elem.dragStatus !== 'dragging') $49b27c4d80a13abe$exports.DD._dragElements.delete(key);
        });
    }
};
if ($2aee50cb6c94cb28$exports.Konva.isBrowser) {
    window.addEventListener('mouseup', $49b27c4d80a13abe$exports.DD._endDragBefore, true);
    window.addEventListener('touchend', $49b27c4d80a13abe$exports.DD._endDragBefore, true);
    window.addEventListener('mousemove', $49b27c4d80a13abe$exports.DD._drag);
    window.addEventListener('touchmove', $49b27c4d80a13abe$exports.DD._drag);
    window.addEventListener('mouseup', $49b27c4d80a13abe$exports.DD._endDragAfter, false);
    window.addEventListener('touchend', $49b27c4d80a13abe$exports.DD._endDragAfter, false);
}



var $f5298bb5f7719915$var$ABSOLUTE_OPACITY = 'absoluteOpacity', $f5298bb5f7719915$var$ALL_LISTENERS = 'allEventListeners', $f5298bb5f7719915$var$ABSOLUTE_TRANSFORM = 'absoluteTransform', $f5298bb5f7719915$var$ABSOLUTE_SCALE = 'absoluteScale', $f5298bb5f7719915$var$CANVAS = 'canvas', $f5298bb5f7719915$var$CHANGE = 'Change', $f5298bb5f7719915$var$CHILDREN = 'children', $f5298bb5f7719915$var$KONVA = 'konva', $f5298bb5f7719915$var$LISTENING = 'listening', $f5298bb5f7719915$var$MOUSEENTER = 'mouseenter', $f5298bb5f7719915$var$MOUSELEAVE = 'mouseleave', $f5298bb5f7719915$var$NAME = 'name', $f5298bb5f7719915$var$SET = 'set', $f5298bb5f7719915$var$SHAPE = 'Shape', $f5298bb5f7719915$var$SPACE = ' ', $f5298bb5f7719915$var$STAGE = 'stage', $f5298bb5f7719915$var$TRANSFORM = 'transform', $f5298bb5f7719915$var$UPPER_STAGE = 'Stage', $f5298bb5f7719915$var$VISIBLE = 'visible', $f5298bb5f7719915$var$TRANSFORM_CHANGE_STR = [
    'xChange.konva',
    'yChange.konva',
    'scaleXChange.konva',
    'scaleYChange.konva',
    'skewXChange.konva',
    'skewYChange.konva',
    'rotationChange.konva',
    'offsetXChange.konva',
    'offsetYChange.konva',
    'transformsEnabledChange.konva'
].join($f5298bb5f7719915$var$SPACE);
let $f5298bb5f7719915$var$idCounter = 1;
class $f5298bb5f7719915$var$Node {
    constructor(config){
        this._id = $f5298bb5f7719915$var$idCounter++;
        this.eventListeners = {};
        this.attrs = {};
        this.index = 0;
        this._allEventListeners = null;
        this.parent = null;
        this._cache = new Map();
        this._attachedDepsListeners = new Map();
        this._lastPos = null;
        this._batchingTransformChange = false;
        this._needClearTransformCache = false;
        this._filterUpToDate = false;
        this._isUnderCache = false;
        this._dragEventId = null;
        this._shouldFireChangeEvents = false;
        this.setAttrs(config);
        this._shouldFireChangeEvents = true;
    }
    hasChildren() {
        return false;
    }
    _clearCache(attr) {
        if ((attr === $f5298bb5f7719915$var$TRANSFORM || attr === $f5298bb5f7719915$var$ABSOLUTE_TRANSFORM) && this._cache.get(attr)) this._cache.get(attr).dirty = true;
        else if (attr) this._cache.delete(attr);
        else this._cache.clear();
    }
    _getCache(attr, privateGetter) {
        var cache = this._cache.get(attr);
        var isTransform = attr === $f5298bb5f7719915$var$TRANSFORM || attr === $f5298bb5f7719915$var$ABSOLUTE_TRANSFORM;
        var invalid = cache === undefined || isTransform && cache.dirty === true;
        if (invalid) {
            cache = privateGetter.call(this);
            this._cache.set(attr, cache);
        }
        return cache;
    }
    _calculate(name, deps, getter) {
        if (!this._attachedDepsListeners.get(name)) {
            const depsString = deps.map((dep)=>dep + 'Change.konva').join($f5298bb5f7719915$var$SPACE);
            this.on(depsString, ()=>{
                this._clearCache(name);
            });
            this._attachedDepsListeners.set(name, true);
        }
        return this._getCache(name, getter);
    }
    _getCanvasCache() {
        return this._cache.get($f5298bb5f7719915$var$CANVAS);
    }
    _clearSelfAndDescendantCache(attr) {
        this._clearCache(attr);
        if (attr === $f5298bb5f7719915$var$ABSOLUTE_TRANSFORM) this.fire('absoluteTransformChange');
    }
    clearCache() {
        if (this._cache.has($f5298bb5f7719915$var$CANVAS)) {
            const { scene: scene, filter: filter, hit: hit } = this._cache.get($f5298bb5f7719915$var$CANVAS);
            $f4b7065bbd5eff66$exports.Util.releaseCanvas(scene, filter, hit);
            this._cache.delete($f5298bb5f7719915$var$CANVAS);
        }
        this._clearSelfAndDescendantCache();
        this._requestDraw();
        return this;
    }
    cache(config) {
        var conf = config || {};
        var rect = {};
        if (conf.x === undefined || conf.y === undefined || conf.width === undefined || conf.height === undefined) rect = this.getClientRect({
            skipTransform: true,
            relativeTo: this.getParent()
        });
        var width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === undefined ? Math.floor(rect.x) : conf.x, y = conf.y === undefined ? Math.floor(rect.y) : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false, hitCanvasPixelRatio = conf.hitCanvasPixelRatio || 1;
        if (!width || !height) {
            $f4b7065bbd5eff66$exports.Util.error('Can not cache the node. Width or height of the node equals 0. Caching is skipped.');
            return;
        }
        width += offset * 2 + 1;
        height += offset * 2 + 1;
        x -= offset;
        y -= offset;
        var cachedSceneCanvas = new $e708bc73165de52e$exports.SceneCanvas({
            pixelRatio: pixelRatio,
            width: width,
            height: height
        }), cachedFilterCanvas = new $e708bc73165de52e$exports.SceneCanvas({
            pixelRatio: pixelRatio,
            width: 0,
            height: 0,
            willReadFrequently: true
        }), cachedHitCanvas = new $e708bc73165de52e$exports.HitCanvas({
            pixelRatio: hitCanvasPixelRatio,
            width: width,
            height: height
        }), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
        cachedHitCanvas.isCache = true;
        cachedSceneCanvas.isCache = true;
        this._cache.delete($f5298bb5f7719915$var$CANVAS);
        this._filterUpToDate = false;
        if (conf.imageSmoothingEnabled === false) {
            cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
            cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
        }
        sceneContext.save();
        hitContext.save();
        sceneContext.translate(-x, -y);
        hitContext.translate(-x, -y);
        this._isUnderCache = true;
        this._clearSelfAndDescendantCache($f5298bb5f7719915$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($f5298bb5f7719915$var$ABSOLUTE_SCALE);
        this.drawScene(cachedSceneCanvas, this);
        this.drawHit(cachedHitCanvas, this);
        this._isUnderCache = false;
        sceneContext.restore();
        hitContext.restore();
        if (drawBorder) {
            sceneContext.save();
            sceneContext.beginPath();
            sceneContext.rect(0, 0, width, height);
            sceneContext.closePath();
            sceneContext.setAttr('strokeStyle', 'red');
            sceneContext.setAttr('lineWidth', 5);
            sceneContext.stroke();
            sceneContext.restore();
        }
        this._cache.set($f5298bb5f7719915$var$CANVAS, {
            scene: cachedSceneCanvas,
            filter: cachedFilterCanvas,
            hit: cachedHitCanvas,
            x: x,
            y: y
        });
        this._requestDraw();
        return this;
    }
    isCached() {
        return this._cache.has($f5298bb5f7719915$var$CANVAS);
    }
    getClientRect(config) {
        throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(rect, top) {
        var points = [
            {
                x: rect.x,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y + rect.height
            },
            {
                x: rect.x,
                y: rect.y + rect.height
            }
        ];
        var minX, minY, maxX, maxY;
        var trans = this.getAbsoluteTransform(top);
        points.forEach(function(point) {
            var transformed = trans.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    _drawCachedSceneCanvas(context) {
        context.save();
        context._applyOpacity(this);
        context._applyGlobalCompositeOperation(this);
        const canvasCache = this._getCanvasCache();
        context.translate(canvasCache.x, canvasCache.y);
        var cacheCanvas = this._getCachedSceneCanvas();
        var ratio = cacheCanvas.pixelRatio;
        context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
        context.restore();
    }
    _drawCachedHitCanvas(context) {
        var canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
        context.save();
        context.translate(canvasCache.x, canvasCache.y);
        context.drawImage(hitCanvas._canvas, 0, 0, hitCanvas.width / hitCanvas.pixelRatio, hitCanvas.height / hitCanvas.pixelRatio);
        context.restore();
    }
    _getCachedSceneCanvas() {
        var filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
        if (filters) {
            if (!this._filterUpToDate) {
                var ratio = sceneCanvas.pixelRatio;
                filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
                try {
                    len = filters.length;
                    filterContext.clear();
                    filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
                    imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
                    for(n = 0; n < len; n++){
                        filter = filters[n];
                        if (typeof filter !== 'function') {
                            $f4b7065bbd5eff66$exports.Util.error('Filter should be type of function, but got ' + typeof filter + ' instead. Please check correct filters');
                            continue;
                        }
                        filter.call(this, imageData);
                        filterContext.putImageData(imageData, 0, 0);
                    }
                } catch (e) {
                    $f4b7065bbd5eff66$exports.Util.error('Unable to apply filter. ' + e.message + ' This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.');
                }
                this._filterUpToDate = true;
            }
            return filterCanvas;
        }
        return sceneCanvas;
    }
    on(evtStr, handler) {
        this._cache && this._cache.delete($f5298bb5f7719915$var$ALL_LISTENERS);
        if (arguments.length === 3) return this._delegate.apply(this, arguments);
        var events = evtStr.split($f5298bb5f7719915$var$SPACE), len = events.length, n, event, parts, baseEvent, name;
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split('.');
            baseEvent = parts[0];
            name = parts[1] || '';
            if (!this.eventListeners[baseEvent]) this.eventListeners[baseEvent] = [];
            this.eventListeners[baseEvent].push({
                name: name,
                handler: handler
            });
        }
        return this;
    }
    off(evtStr, callback) {
        var events = (evtStr || '').split($f5298bb5f7719915$var$SPACE), len = events.length, n, t, event, parts, baseEvent, name;
        this._cache && this._cache.delete($f5298bb5f7719915$var$ALL_LISTENERS);
        if (!evtStr) for(t in this.eventListeners)this._off(t);
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split('.');
            baseEvent = parts[0];
            name = parts[1];
            if (baseEvent) {
                if (this.eventListeners[baseEvent]) this._off(baseEvent, name, callback);
            } else for(t in this.eventListeners)this._off(t, name, callback);
        }
        return this;
    }
    dispatchEvent(evt) {
        var e = {
            target: this,
            type: evt.type,
            evt: evt
        };
        this.fire(evt.type, e);
        return this;
    }
    addEventListener(type, handler) {
        this.on(type, function(evt) {
            handler.call(this, evt.evt);
        });
        return this;
    }
    removeEventListener(type) {
        this.off(type);
        return this;
    }
    _delegate(event, selector, handler) {
        var stopNode = this;
        this.on(event, function(evt) {
            var targets = evt.target.findAncestors(selector, true, stopNode);
            for(var i = 0; i < targets.length; i++){
                evt = $f4b7065bbd5eff66$exports.Util.cloneObject(evt);
                evt.currentTarget = targets[i];
                handler.call(targets[i], evt);
            }
        });
    }
    remove() {
        if (this.isDragging()) this.stopDrag();
        $49b27c4d80a13abe$exports.DD._dragElements.delete(this._id);
        this._remove();
        return this;
    }
    _clearCaches() {
        this._clearSelfAndDescendantCache($f5298bb5f7719915$var$ABSOLUTE_TRANSFORM);
        this._clearSelfAndDescendantCache($f5298bb5f7719915$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($f5298bb5f7719915$var$ABSOLUTE_SCALE);
        this._clearSelfAndDescendantCache($f5298bb5f7719915$var$STAGE);
        this._clearSelfAndDescendantCache($f5298bb5f7719915$var$VISIBLE);
        this._clearSelfAndDescendantCache($f5298bb5f7719915$var$LISTENING);
    }
    _remove() {
        this._clearCaches();
        var parent = this.getParent();
        if (parent && parent.children) {
            parent.children.splice(this.index, 1);
            parent._setChildrenIndices();
            this.parent = null;
        }
    }
    destroy() {
        this.remove();
        this.clearCache();
        return this;
    }
    getAttr(attr) {
        var method = 'get' + $f4b7065bbd5eff66$exports.Util._capitalize(attr);
        if ($f4b7065bbd5eff66$exports.Util._isFunction(this[method])) return this[method]();
        return this.attrs[attr];
    }
    getAncestors() {
        var parent = this.getParent(), ancestors = [];
        while(parent){
            ancestors.push(parent);
            parent = parent.getParent();
        }
        return ancestors;
    }
    getAttrs() {
        return this.attrs || {};
    }
    setAttrs(config) {
        this._batchTransformChanges(()=>{
            var key, method;
            if (!config) return this;
            for(key in config){
                if (key === $f5298bb5f7719915$var$CHILDREN) continue;
                method = $f5298bb5f7719915$var$SET + $f4b7065bbd5eff66$exports.Util._capitalize(key);
                if ($f4b7065bbd5eff66$exports.Util._isFunction(this[method])) this[method](config[key]);
                else this._setAttr(key, config[key]);
            }
        });
        return this;
    }
    isListening() {
        return this._getCache($f5298bb5f7719915$var$LISTENING, this._isListening);
    }
    _isListening(relativeTo) {
        const listening = this.listening();
        if (!listening) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isListening(relativeTo);
        else return true;
    }
    isVisible() {
        return this._getCache($f5298bb5f7719915$var$VISIBLE, this._isVisible);
    }
    _isVisible(relativeTo) {
        const visible = this.visible();
        if (!visible) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isVisible(relativeTo);
        else return true;
    }
    shouldDrawHit(top, skipDragCheck = false) {
        if (top) return this._isVisible(top) && this._isListening(top);
        var layer = this.getLayer();
        var layerUnderDrag = false;
        $49b27c4d80a13abe$exports.DD._dragElements.forEach((elem)=>{
            if (elem.dragStatus !== 'dragging') return;
            else if (elem.node.nodeType === 'Stage') layerUnderDrag = true;
            else if (elem.node.getLayer() === layer) layerUnderDrag = true;
        });
        var dragSkip = !skipDragCheck && !$2aee50cb6c94cb28$exports.Konva.hitOnDragEnabled && layerUnderDrag;
        return this.isListening() && this.isVisible() && !dragSkip;
    }
    show() {
        this.visible(true);
        return this;
    }
    hide() {
        this.visible(false);
        return this;
    }
    getZIndex() {
        return this.index || 0;
    }
    getAbsoluteZIndex() {
        var depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
        function addChildren(children) {
            nodes = [];
            len = children.length;
            for(n = 0; n < len; n++){
                child = children[n];
                index++;
                if (child.nodeType !== $f5298bb5f7719915$var$SHAPE) nodes = nodes.concat(child.getChildren().slice());
                if (child._id === that._id) n = len;
            }
            if (nodes.length > 0 && nodes[0].getDepth() <= depth) addChildren(nodes);
        }
        if (that.nodeType !== $f5298bb5f7719915$var$UPPER_STAGE) addChildren(that.getStage().getChildren());
        return index;
    }
    getDepth() {
        var depth = 0, parent = this.parent;
        while(parent){
            depth++;
            parent = parent.parent;
        }
        return depth;
    }
    _batchTransformChanges(func) {
        this._batchingTransformChange = true;
        func();
        this._batchingTransformChange = false;
        if (this._needClearTransformCache) {
            this._clearCache($f5298bb5f7719915$var$TRANSFORM);
            this._clearSelfAndDescendantCache($f5298bb5f7719915$var$ABSOLUTE_TRANSFORM);
        }
        this._needClearTransformCache = false;
    }
    setPosition(pos) {
        this._batchTransformChanges(()=>{
            this.x(pos.x);
            this.y(pos.y);
        });
        return this;
    }
    getPosition() {
        return {
            x: this.x(),
            y: this.y()
        };
    }
    getRelativePointerPosition() {
        if (!this.getStage()) return null;
        var pos = this.getStage().getPointerPosition();
        if (!pos) return null;
        var transform = this.getAbsoluteTransform().copy();
        transform.invert();
        return transform.point(pos);
    }
    getAbsolutePosition(top) {
        let haveCachedParent = false;
        let parent = this.parent;
        while(parent){
            if (parent.isCached()) {
                haveCachedParent = true;
                break;
            }
            parent = parent.parent;
        }
        if (haveCachedParent && !top) top = true;
        var absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new $f4b7065bbd5eff66$exports.Transform(), offset = this.offset();
        absoluteTransform.m = absoluteMatrix.slice();
        absoluteTransform.translate(offset.x, offset.y);
        return absoluteTransform.getTranslation();
    }
    setAbsolutePosition(pos) {
        var origTrans = this._clearTransform();
        this.attrs.x = origTrans.x;
        this.attrs.y = origTrans.y;
        delete origTrans.x;
        delete origTrans.y;
        this._clearCache($f5298bb5f7719915$var$TRANSFORM);
        var it = this._getAbsoluteTransform().copy();
        it.invert();
        it.translate(pos.x, pos.y);
        pos = {
            x: this.attrs.x + it.getTranslation().x,
            y: this.attrs.y + it.getTranslation().y
        };
        this._setTransform(origTrans);
        this.setPosition({
            x: pos.x,
            y: pos.y
        });
        this._clearCache($f5298bb5f7719915$var$TRANSFORM);
        this._clearSelfAndDescendantCache($f5298bb5f7719915$var$ABSOLUTE_TRANSFORM);
        return this;
    }
    _setTransform(trans) {
        var key;
        for(key in trans)this.attrs[key] = trans[key];
    }
    _clearTransform() {
        var trans = {
            x: this.x(),
            y: this.y(),
            rotation: this.rotation(),
            scaleX: this.scaleX(),
            scaleY: this.scaleY(),
            offsetX: this.offsetX(),
            offsetY: this.offsetY(),
            skewX: this.skewX(),
            skewY: this.skewY()
        };
        this.attrs.x = 0;
        this.attrs.y = 0;
        this.attrs.rotation = 0;
        this.attrs.scaleX = 1;
        this.attrs.scaleY = 1;
        this.attrs.offsetX = 0;
        this.attrs.offsetY = 0;
        this.attrs.skewX = 0;
        this.attrs.skewY = 0;
        return trans;
    }
    move(change) {
        var changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
        if (changeX !== undefined) x += changeX;
        if (changeY !== undefined) y += changeY;
        this.setPosition({
            x: x,
            y: y
        });
        return this;
    }
    _eachAncestorReverse(func, top) {
        var family = [], parent = this.getParent(), len, n;
        if (top && top._id === this._id) return;
        family.unshift(this);
        while(parent && (!top || parent._id !== top._id)){
            family.unshift(parent);
            parent = parent.parent;
        }
        len = family.length;
        for(n = 0; n < len; n++)func(family[n]);
    }
    rotate(theta) {
        this.rotation(this.rotation() + theta);
        return this;
    }
    moveToTop() {
        if (!this.parent) {
            $f4b7065bbd5eff66$exports.Util.warn('Node has no parent. moveToTop function is ignored.');
            return false;
        }
        var index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.push(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveUp() {
        if (!this.parent) {
            $f4b7065bbd5eff66$exports.Util.warn('Node has no parent. moveUp function is ignored.');
            return false;
        }
        var index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index + 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveDown() {
        if (!this.parent) {
            $f4b7065bbd5eff66$exports.Util.warn('Node has no parent. moveDown function is ignored.');
            return false;
        }
        var index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index - 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveToBottom() {
        if (!this.parent) {
            $f4b7065bbd5eff66$exports.Util.warn('Node has no parent. moveToBottom function is ignored.');
            return false;
        }
        var index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.unshift(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    setZIndex(zIndex) {
        if (!this.parent) {
            $f4b7065bbd5eff66$exports.Util.warn('Node has no parent. zIndex parameter is ignored.');
            return this;
        }
        if (zIndex < 0 || zIndex >= this.parent.children.length) $f4b7065bbd5eff66$exports.Util.warn('Unexpected value ' + zIndex + ' for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to ' + (this.parent.children.length - 1) + '.');
        var index = this.index;
        this.parent.children.splice(index, 1);
        this.parent.children.splice(zIndex, 0, this);
        this.parent._setChildrenIndices();
        return this;
    }
    getAbsoluteOpacity() {
        return this._getCache($f5298bb5f7719915$var$ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
        var absOpacity = this.opacity();
        var parent = this.getParent();
        if (parent && !parent._isUnderCache) absOpacity *= parent.getAbsoluteOpacity();
        return absOpacity;
    }
    moveTo(newContainer) {
        if (this.getParent() !== newContainer) {
            this._remove();
            newContainer.add(this);
        }
        return this;
    }
    toObject() {
        var obj = {}, attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
        obj.attrs = {};
        for(key in attrs){
            val = attrs[key];
            nonPlainObject = $f4b7065bbd5eff66$exports.Util.isObject(val) && !$f4b7065bbd5eff66$exports.Util._isPlainObject(val) && !$f4b7065bbd5eff66$exports.Util._isArray(val);
            if (nonPlainObject) continue;
            getter = typeof this[key] === 'function' && this[key];
            delete attrs[key];
            defaultValue = getter ? getter.call(this) : null;
            attrs[key] = val;
            if (defaultValue !== val) obj.attrs[key] = val;
        }
        obj.className = this.getClassName();
        return $f4b7065bbd5eff66$exports.Util._prepareToStringify(obj);
    }
    toJSON() {
        return JSON.stringify(this.toObject());
    }
    getParent() {
        return this.parent;
    }
    findAncestors(selector, includeSelf, stopNode) {
        var res = [];
        if (includeSelf && this._isMatch(selector)) res.push(this);
        var ancestor = this.parent;
        while(ancestor){
            if (ancestor === stopNode) return res;
            if (ancestor._isMatch(selector)) res.push(ancestor);
            ancestor = ancestor.parent;
        }
        return res;
    }
    isAncestorOf(node) {
        return false;
    }
    findAncestor(selector, includeSelf, stopNode) {
        return this.findAncestors(selector, includeSelf, stopNode)[0];
    }
    _isMatch(selector) {
        if (!selector) return false;
        if (typeof selector === 'function') return selector(this);
        var selectorArr = selector.replace(/ /g, '').split(','), len = selectorArr.length, n, sel;
        for(n = 0; n < len; n++){
            sel = selectorArr[n];
            if (!$f4b7065bbd5eff66$exports.Util.isValidSelector(sel)) {
                $f4b7065bbd5eff66$exports.Util.warn('Selector "' + sel + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
                $f4b7065bbd5eff66$exports.Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
                $f4b7065bbd5eff66$exports.Util.warn('Konva is awesome, right?');
            }
            if (sel.charAt(0) === '#') {
                if (this.id() === sel.slice(1)) return true;
            } else if (sel.charAt(0) === '.') {
                if (this.hasName(sel.slice(1))) return true;
            } else if (this.className === sel || this.nodeType === sel) return true;
        }
        return false;
    }
    getLayer() {
        var parent = this.getParent();
        return parent ? parent.getLayer() : null;
    }
    getStage() {
        return this._getCache($f5298bb5f7719915$var$STAGE, this._getStage);
    }
    _getStage() {
        var parent = this.getParent();
        if (parent) return parent.getStage();
        else return undefined;
    }
    fire(eventType, evt = {}, bubble) {
        evt.target = evt.target || this;
        if (bubble) this._fireAndBubble(eventType, evt);
        else this._fire(eventType, evt);
        return this;
    }
    getAbsoluteTransform(top) {
        if (top) return this._getAbsoluteTransform(top);
        else return this._getCache($f5298bb5f7719915$var$ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
    }
    _getAbsoluteTransform(top) {
        var at;
        if (top) {
            at = new $f4b7065bbd5eff66$exports.Transform();
            this._eachAncestorReverse(function(node) {
                var transformsEnabled = node.transformsEnabled();
                if (transformsEnabled === 'all') at.multiply(node.getTransform());
                else if (transformsEnabled === 'position') at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
            }, top);
            return at;
        } else {
            at = this._cache.get($f5298bb5f7719915$var$ABSOLUTE_TRANSFORM) || new $f4b7065bbd5eff66$exports.Transform();
            if (this.parent) this.parent.getAbsoluteTransform().copyInto(at);
            else at.reset();
            var transformsEnabled = this.transformsEnabled();
            if (transformsEnabled === 'all') at.multiply(this.getTransform());
            else if (transformsEnabled === 'position') {
                const x = this.attrs.x || 0;
                const y = this.attrs.y || 0;
                const offsetX = this.attrs.offsetX || 0;
                const offsetY = this.attrs.offsetY || 0;
                at.translate(x - offsetX, y - offsetY);
            }
            at.dirty = false;
            return at;
        }
    }
    getAbsoluteScale(top) {
        var parent = this;
        while(parent){
            if (parent._isUnderCache) top = parent;
            parent = parent.getParent();
        }
        const transform = this.getAbsoluteTransform(top);
        const attrs = transform.decompose();
        return {
            x: attrs.scaleX,
            y: attrs.scaleY
        };
    }
    getAbsoluteRotation() {
        return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
        return this._getCache($f5298bb5f7719915$var$TRANSFORM, this._getTransform);
    }
    _getTransform() {
        var _a, _b;
        var m = this._cache.get($f5298bb5f7719915$var$TRANSFORM) || new $f4b7065bbd5eff66$exports.Transform();
        m.reset();
        var x = this.x(), y = this.y(), rotation = $2aee50cb6c94cb28$exports.Konva.getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
        if (x !== 0 || y !== 0) m.translate(x, y);
        if (rotation !== 0) m.rotate(rotation);
        if (skewX !== 0 || skewY !== 0) m.skew(skewX, skewY);
        if (scaleX !== 1 || scaleY !== 1) m.scale(scaleX, scaleY);
        if (offsetX !== 0 || offsetY !== 0) m.translate(-1 * offsetX, -1 * offsetY);
        m.dirty = false;
        return m;
    }
    clone(obj) {
        var attrs = $f4b7065bbd5eff66$exports.Util.cloneObject(this.attrs), key, allListeners, len, n, listener;
        for(key in obj)attrs[key] = obj[key];
        var node = new this.constructor(attrs);
        for(key in this.eventListeners){
            allListeners = this.eventListeners[key];
            len = allListeners.length;
            for(n = 0; n < len; n++){
                listener = allListeners[n];
                if (listener.name.indexOf($f5298bb5f7719915$var$KONVA) < 0) {
                    if (!node.eventListeners[key]) node.eventListeners[key] = [];
                    node.eventListeners[key].push(listener);
                }
            }
        }
        return node;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        var box = this.getClientRect();
        var stage = this.getStage(), x = config.x !== undefined ? config.x : Math.floor(box.x), y = config.y !== undefined ? config.y : Math.floor(box.y), pixelRatio = config.pixelRatio || 1, canvas = new $e708bc73165de52e$exports.SceneCanvas({
            width: config.width || Math.ceil(box.width) || (stage ? stage.width() : 0),
            height: config.height || Math.ceil(box.height) || (stage ? stage.height() : 0),
            pixelRatio: pixelRatio
        }), context = canvas.getContext();
        if (config.imageSmoothingEnabled === false) context._context.imageSmoothingEnabled = false;
        context.save();
        if (x || y) context.translate(-1 * x, -1 * y);
        this.drawScene(canvas);
        context.restore();
        return canvas;
    }
    toCanvas(config) {
        return this._toKonvaCanvas(config)._canvas;
    }
    toDataURL(config) {
        config = config || {};
        var mimeType = config.mimeType || null, quality = config.quality || null;
        var url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
        if (config.callback) config.callback(url);
        return url;
    }
    toImage(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                $f4b7065bbd5eff66$exports.Util._urlToImage(this.toDataURL(config), function(img) {
                    resolve(img);
                    callback === null || callback === void 0 || callback(img);
                });
            } catch (err) {
                reject(err);
            }
        });
    }
    toBlob(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                this.toCanvas(config).toBlob((blob)=>{
                    resolve(blob);
                    callback === null || callback === void 0 || callback(blob);
                });
            } catch (err) {
                reject(err);
            }
        });
    }
    setSize(size) {
        this.width(size.width);
        this.height(size.height);
        return this;
    }
    getSize() {
        return {
            width: this.width(),
            height: this.height()
        };
    }
    getClassName() {
        return this.className || this.nodeType;
    }
    getType() {
        return this.nodeType;
    }
    getDragDistance() {
        if (this.attrs.dragDistance !== undefined) return this.attrs.dragDistance;
        else if (this.parent) return this.parent.getDragDistance();
        else return $2aee50cb6c94cb28$exports.Konva.dragDistance;
    }
    _off(type, name, callback) {
        var evtListeners = this.eventListeners[type], i, evtName, handler;
        for(i = 0; i < evtListeners.length; i++){
            evtName = evtListeners[i].name;
            handler = evtListeners[i].handler;
            if ((evtName !== 'konva' || name === 'konva') && (!name || evtName === name) && (!callback || callback === handler)) {
                evtListeners.splice(i, 1);
                if (evtListeners.length === 0) {
                    delete this.eventListeners[type];
                    break;
                }
                i--;
            }
        }
    }
    _fireChangeEvent(attr, oldVal, newVal) {
        this._fire(attr + $f5298bb5f7719915$var$CHANGE, {
            oldVal: oldVal,
            newVal: newVal
        });
    }
    addName(name) {
        if (!this.hasName(name)) {
            var oldName = this.name();
            var newName = oldName ? oldName + ' ' + name : name;
            this.name(newName);
        }
        return this;
    }
    hasName(name) {
        if (!name) return false;
        const fullName = this.name();
        if (!fullName) return false;
        var names = (fullName || '').split(/\s/g);
        return names.indexOf(name) !== -1;
    }
    removeName(name) {
        var names = (this.name() || '').split(/\s/g);
        var index = names.indexOf(name);
        if (index !== -1) {
            names.splice(index, 1);
            this.name(names.join(' '));
        }
        return this;
    }
    setAttr(attr, val) {
        var func = this[$f5298bb5f7719915$var$SET + $f4b7065bbd5eff66$exports.Util._capitalize(attr)];
        if ($f4b7065bbd5eff66$exports.Util._isFunction(func)) func.call(this, val);
        else this._setAttr(attr, val);
        return this;
    }
    _requestDraw() {
        if ($2aee50cb6c94cb28$exports.Konva.autoDrawEnabled) {
            const drawNode = this.getLayer() || this.getStage();
            drawNode === null || drawNode === void 0 || drawNode.batchDraw();
        }
    }
    _setAttr(key, val) {
        var oldVal = this.attrs[key];
        if (oldVal === val && !$f4b7065bbd5eff66$exports.Util.isObject(val)) return;
        if (val === undefined || val === null) delete this.attrs[key];
        else this.attrs[key] = val;
        if (this._shouldFireChangeEvents) this._fireChangeEvent(key, oldVal, val);
        this._requestDraw();
    }
    _setComponentAttr(key, component, val) {
        var oldVal;
        if (val !== undefined) {
            oldVal = this.attrs[key];
            if (!oldVal) this.attrs[key] = this.getAttr(key);
            this.attrs[key][component] = val;
            this._fireChangeEvent(key, oldVal, val);
        }
    }
    _fireAndBubble(eventType, evt, compareShape) {
        if (evt && this.nodeType === $f5298bb5f7719915$var$SHAPE) evt.target = this;
        var shouldStop = (eventType === $f5298bb5f7719915$var$MOUSEENTER || eventType === $f5298bb5f7719915$var$MOUSELEAVE) && (compareShape && (this === compareShape || this.isAncestorOf && this.isAncestorOf(compareShape)) || this.nodeType === 'Stage' && !compareShape);
        if (!shouldStop) {
            this._fire(eventType, evt);
            var stopBubble = (eventType === $f5298bb5f7719915$var$MOUSEENTER || eventType === $f5298bb5f7719915$var$MOUSELEAVE) && compareShape && compareShape.isAncestorOf && compareShape.isAncestorOf(this) && !compareShape.isAncestorOf(this.parent);
            if ((evt && !evt.cancelBubble || !evt) && this.parent && this.parent.isListening() && !stopBubble) {
                if (compareShape && compareShape.parent) this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
                else this._fireAndBubble.call(this.parent, eventType, evt);
            }
        }
    }
    _getProtoListeners(eventType) {
        var _a, _b, _c;
        const allListeners = (_a = this._cache.get($f5298bb5f7719915$var$ALL_LISTENERS)) !== null && _a !== void 0 ? _a : {};
        let events = allListeners === null || allListeners === void 0 ? void 0 : allListeners[eventType];
        if (events === undefined) {
            events = [];
            let obj = Object.getPrototypeOf(this);
            while(obj){
                const hierarchyEvents = (_c = (_b = obj.eventListeners) === null || _b === void 0 ? void 0 : _b[eventType]) !== null && _c !== void 0 ? _c : [];
                events.push(...hierarchyEvents);
                obj = Object.getPrototypeOf(obj);
            }
            allListeners[eventType] = events;
            this._cache.set($f5298bb5f7719915$var$ALL_LISTENERS, allListeners);
        }
        return events;
    }
    _fire(eventType, evt) {
        evt = evt || {};
        evt.currentTarget = this;
        evt.type = eventType;
        const topListeners = this._getProtoListeners(eventType);
        if (topListeners) for(var i = 0; i < topListeners.length; i++)topListeners[i].handler.call(this, evt);
        const selfListeners = this.eventListeners[eventType];
        if (selfListeners) for(var i = 0; i < selfListeners.length; i++)selfListeners[i].handler.call(this, evt);
    }
    draw() {
        this.drawScene();
        this.drawHit();
        return this;
    }
    _createDragElement(evt) {
        var pointerId = evt ? evt.pointerId : undefined;
        var stage = this.getStage();
        var ap = this.getAbsolutePosition();
        var pos = stage._getPointerById(pointerId) || stage._changedPointerPositions[0] || ap;
        $49b27c4d80a13abe$exports.DD._dragElements.set(this._id, {
            node: this,
            startPointerPos: pos,
            offset: {
                x: pos.x - ap.x,
                y: pos.y - ap.y
            },
            dragStatus: 'ready',
            pointerId: pointerId
        });
    }
    startDrag(evt, bubbleEvent = true) {
        if (!$49b27c4d80a13abe$exports.DD._dragElements.has(this._id)) this._createDragElement(evt);
        const elem = $49b27c4d80a13abe$exports.DD._dragElements.get(this._id);
        elem.dragStatus = 'dragging';
        this.fire('dragstart', {
            type: 'dragstart',
            target: this,
            evt: evt && evt.evt
        }, bubbleEvent);
    }
    _setDragPosition(evt, elem) {
        const pos = this.getStage()._getPointerById(elem.pointerId);
        if (!pos) return;
        var newNodePos = {
            x: pos.x - elem.offset.x,
            y: pos.y - elem.offset.y
        };
        var dbf = this.dragBoundFunc();
        if (dbf !== undefined) {
            const bounded = dbf.call(this, newNodePos, evt);
            if (!bounded) $f4b7065bbd5eff66$exports.Util.warn('dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.');
            else newNodePos = bounded;
        }
        if (!this._lastPos || this._lastPos.x !== newNodePos.x || this._lastPos.y !== newNodePos.y) {
            this.setAbsolutePosition(newNodePos);
            this._requestDraw();
        }
        this._lastPos = newNodePos;
    }
    stopDrag(evt) {
        const elem = $49b27c4d80a13abe$exports.DD._dragElements.get(this._id);
        if (elem) elem.dragStatus = 'stopped';
        $49b27c4d80a13abe$exports.DD._endDragBefore(evt);
        $49b27c4d80a13abe$exports.DD._endDragAfter(evt);
    }
    setDraggable(draggable) {
        this._setAttr('draggable', draggable);
        this._dragChange();
    }
    isDragging() {
        const elem = $49b27c4d80a13abe$exports.DD._dragElements.get(this._id);
        return elem ? elem.dragStatus === 'dragging' : false;
    }
    _listenDrag() {
        this._dragCleanup();
        this.on('mousedown.konva touchstart.konva', function(evt) {
            var shouldCheckButton = evt.evt['button'] !== undefined;
            var canDrag = !shouldCheckButton || $2aee50cb6c94cb28$exports.Konva.dragButtons.indexOf(evt.evt['button']) >= 0;
            if (!canDrag) return;
            if (this.isDragging()) return;
            var hasDraggingChild = false;
            $49b27c4d80a13abe$exports.DD._dragElements.forEach((elem)=>{
                if (this.isAncestorOf(elem.node)) hasDraggingChild = true;
            });
            if (!hasDraggingChild) this._createDragElement(evt);
        });
    }
    _dragChange() {
        if (this.attrs.draggable) this._listenDrag();
        else {
            this._dragCleanup();
            var stage = this.getStage();
            if (!stage) return;
            const dragElement = $49b27c4d80a13abe$exports.DD._dragElements.get(this._id);
            const isDragging = dragElement && dragElement.dragStatus === 'dragging';
            const isReady = dragElement && dragElement.dragStatus === 'ready';
            if (isDragging) this.stopDrag();
            else if (isReady) $49b27c4d80a13abe$exports.DD._dragElements.delete(this._id);
        }
    }
    _dragCleanup() {
        this.off('mousedown.konva');
        this.off('touchstart.konva');
    }
    isClientRectOnScreen(margin = {
        x: 0,
        y: 0
    }) {
        const stage = this.getStage();
        if (!stage) return false;
        const screenRect = {
            x: -margin.x,
            y: -margin.y,
            width: stage.width() + 2 * margin.x,
            height: stage.height() + 2 * margin.y
        };
        return $f4b7065bbd5eff66$exports.Util.haveIntersection(screenRect, this.getClientRect());
    }
    static create(data, container) {
        if ($f4b7065bbd5eff66$exports.Util._isString(data)) data = JSON.parse(data);
        return this._createNode(data, container);
    }
    static _createNode(obj, container) {
        var className = $f5298bb5f7719915$var$Node.prototype.getClassName.call(obj), children = obj.children, no, len, n;
        if (container) obj.attrs.container = container;
        if (!$2aee50cb6c94cb28$exports.Konva[className]) {
            $f4b7065bbd5eff66$exports.Util.warn('Can not find a node with class name "' + className + '". Fallback to "Shape".');
            className = 'Shape';
        }
        const Class = $2aee50cb6c94cb28$exports.Konva[className];
        no = new Class(obj.attrs);
        if (children) {
            len = children.length;
            for(n = 0; n < len; n++)no.add($f5298bb5f7719915$var$Node._createNode(children[n]));
        }
        return no;
    }
}
$f5298bb5f7719915$exports.Node = $f5298bb5f7719915$var$Node;
$f5298bb5f7719915$var$Node.prototype.nodeType = 'Node';
$f5298bb5f7719915$var$Node.prototype._attrsAffectingSize = [];
$f5298bb5f7719915$var$Node.prototype.eventListeners = {};
$f5298bb5f7719915$var$Node.prototype.on.call($f5298bb5f7719915$var$Node.prototype, $f5298bb5f7719915$var$TRANSFORM_CHANGE_STR, function() {
    if (this._batchingTransformChange) {
        this._needClearTransformCache = true;
        return;
    }
    this._clearCache($f5298bb5f7719915$var$TRANSFORM);
    this._clearSelfAndDescendantCache($f5298bb5f7719915$var$ABSOLUTE_TRANSFORM);
});
$f5298bb5f7719915$var$Node.prototype.on.call($f5298bb5f7719915$var$Node.prototype, 'visibleChange.konva', function() {
    this._clearSelfAndDescendantCache($f5298bb5f7719915$var$VISIBLE);
});
$f5298bb5f7719915$var$Node.prototype.on.call($f5298bb5f7719915$var$Node.prototype, 'listeningChange.konva', function() {
    this._clearSelfAndDescendantCache($f5298bb5f7719915$var$LISTENING);
});
$f5298bb5f7719915$var$Node.prototype.on.call($f5298bb5f7719915$var$Node.prototype, 'opacityChange.konva', function() {
    this._clearSelfAndDescendantCache($f5298bb5f7719915$var$ABSOLUTE_OPACITY);
});
const $f5298bb5f7719915$var$addGetterSetter = $4831cc45767eb450$exports.Factory.addGetterSetter;
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'zIndex');
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'absolutePosition');
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'position');
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'x', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'y', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'globalCompositeOperation', 'source-over', (0, $b21213ef7b53b4df$exports.getStringValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'opacity', 1, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'name', '', (0, $b21213ef7b53b4df$exports.getStringValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'id', '', (0, $b21213ef7b53b4df$exports.getStringValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'rotation', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addComponentsGetterSetter($f5298bb5f7719915$var$Node, 'scale', [
    'x',
    'y'
]);
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'scaleX', 1, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'scaleY', 1, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addComponentsGetterSetter($f5298bb5f7719915$var$Node, 'skew', [
    'x',
    'y'
]);
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'skewX', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'skewY', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addComponentsGetterSetter($f5298bb5f7719915$var$Node, 'offset', [
    'x',
    'y'
]);
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'offsetX', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'offsetY', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'dragDistance', null, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'width', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'height', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'listening', true, (0, $b21213ef7b53b4df$exports.getBooleanValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'preventDefault', true, (0, $b21213ef7b53b4df$exports.getBooleanValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'filters', null, function(val) {
    this._filterUpToDate = false;
    return val;
});
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'visible', true, (0, $b21213ef7b53b4df$exports.getBooleanValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'transformsEnabled', 'all', (0, $b21213ef7b53b4df$exports.getStringValidator)());
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'size');
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'dragBoundFunc');
$f5298bb5f7719915$var$addGetterSetter($f5298bb5f7719915$var$Node, 'draggable', false, (0, $b21213ef7b53b4df$exports.getBooleanValidator)());
$4831cc45767eb450$exports.Factory.backCompat($f5298bb5f7719915$var$Node, {
    rotateDeg: 'rotate',
    setRotationDeg: 'setRotation',
    getRotationDeg: 'getRotation'
});


var $a98a57b280deff40$exports = {};
"use strict";
Object.defineProperty($a98a57b280deff40$exports, "__esModule", {
    value: true
});
$a98a57b280deff40$exports.Container = void 0;



class $a98a57b280deff40$var$Container extends $f5298bb5f7719915$exports.Node {
    constructor(){
        super(...arguments);
        this.children = [];
    }
    getChildren(filterFunc) {
        if (!filterFunc) return this.children || [];
        const children = this.children || [];
        var results = [];
        children.forEach(function(child) {
            if (filterFunc(child)) results.push(child);
        });
        return results;
    }
    hasChildren() {
        return this.getChildren().length > 0;
    }
    removeChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.remove();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    destroyChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.destroy();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    add(...children) {
        if (children.length === 0) return this;
        if (children.length > 1) {
            for(var i = 0; i < children.length; i++)this.add(children[i]);
            return this;
        }
        const child = children[0];
        if (child.getParent()) {
            child.moveTo(this);
            return this;
        }
        this._validateAdd(child);
        child.index = this.getChildren().length;
        child.parent = this;
        child._clearCaches();
        this.getChildren().push(child);
        this._fire('add', {
            child: child
        });
        this._requestDraw();
        return this;
    }
    destroy() {
        if (this.hasChildren()) this.destroyChildren();
        super.destroy();
        return this;
    }
    find(selector) {
        return this._generalFind(selector, false);
    }
    findOne(selector) {
        var result = this._generalFind(selector, true);
        return result.length > 0 ? result[0] : undefined;
    }
    _generalFind(selector, findOne) {
        var retArr = [];
        this._descendants((node)=>{
            const valid = node._isMatch(selector);
            if (valid) retArr.push(node);
            if (valid && findOne) return true;
            return false;
        });
        return retArr;
    }
    _descendants(fn) {
        let shouldStop = false;
        const children = this.getChildren();
        for (const child of children){
            shouldStop = fn(child);
            if (shouldStop) return true;
            if (!child.hasChildren()) continue;
            shouldStop = child._descendants(fn);
            if (shouldStop) return true;
        }
        return false;
    }
    toObject() {
        var obj = $f5298bb5f7719915$exports.Node.prototype.toObject.call(this);
        obj.children = [];
        this.getChildren().forEach((child)=>{
            obj.children.push(child.toObject());
        });
        return obj;
    }
    isAncestorOf(node) {
        var parent = node.getParent();
        while(parent){
            if (parent._id === this._id) return true;
            parent = parent.getParent();
        }
        return false;
    }
    clone(obj) {
        var node = $f5298bb5f7719915$exports.Node.prototype.clone.call(this, obj);
        this.getChildren().forEach(function(no) {
            node.add(no.clone());
        });
        return node;
    }
    getAllIntersections(pos) {
        var arr = [];
        this.find('Shape').forEach(function(shape) {
            if (shape.isVisible() && shape.intersects(pos)) arr.push(shape);
        });
        return arr;
    }
    _clearSelfAndDescendantCache(attr) {
        var _a;
        super._clearSelfAndDescendantCache(attr);
        if (this.isCached()) return;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(node) {
            node._clearSelfAndDescendantCache(attr);
        });
    }
    _setChildrenIndices() {
        var _a;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child, n) {
            child.index = n;
        });
        this._requestDraw();
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.getCanvas(), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
        var caching = canvas && canvas.isCache;
        if (!this.isVisible() && !caching) return this;
        if (cachedSceneCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
        } else this._drawChildren('drawScene', canvas, top);
        return this;
    }
    drawHit(can, top) {
        if (!this.shouldDrawHit(top)) return this;
        var layer = this.getLayer(), canvas = can || layer && layer.hitCanvas, context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (cachedHitCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
        } else this._drawChildren('drawHit', canvas, top);
        return this;
    }
    _drawChildren(drawMethod, canvas, top) {
        var _a;
        var context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = clipWidth && clipHeight || clipFunc;
        const selfCache = top === this;
        if (hasClip) {
            context.save();
            var transform = this.getAbsoluteTransform(top);
            var m = transform.getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            context.beginPath();
            if (clipFunc) clipFunc.call(this, context, this);
            else {
                var clipX = this.clipX();
                var clipY = this.clipY();
                context.rect(clipX, clipY, clipWidth, clipHeight);
            }
            context.clip();
            m = transform.copy().invert().getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        var hasComposition = !selfCache && this.globalCompositeOperation() !== 'source-over' && drawMethod === 'drawScene';
        if (hasComposition) {
            context.save();
            context._applyGlobalCompositeOperation(this);
        }
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            child[drawMethod](canvas, top);
        });
        if (hasComposition) context.restore();
        if (hasClip) context.restore();
    }
    getClientRect(config) {
        var _a;
        config = config || {};
        var skipTransform = config.skipTransform;
        var relativeTo = config.relativeTo;
        var minX, minY, maxX, maxY;
        var selfRect = {
            x: Infinity,
            y: Infinity,
            width: 0,
            height: 0
        };
        var that = this;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            if (!child.visible()) return;
            var rect = child.getClientRect({
                relativeTo: that,
                skipShadow: config.skipShadow,
                skipStroke: config.skipStroke
            });
            if (rect.width === 0 && rect.height === 0) return;
            if (minX === undefined) {
                minX = rect.x;
                minY = rect.y;
                maxX = rect.x + rect.width;
                maxY = rect.y + rect.height;
            } else {
                minX = Math.min(minX, rect.x);
                minY = Math.min(minY, rect.y);
                maxX = Math.max(maxX, rect.x + rect.width);
                maxY = Math.max(maxY, rect.y + rect.height);
            }
        });
        var shapes = this.find('Shape');
        var hasVisible = false;
        for(var i = 0; i < shapes.length; i++){
            var shape = shapes[i];
            if (shape._isVisible(this)) {
                hasVisible = true;
                break;
            }
        }
        if (hasVisible && minX !== undefined) selfRect = {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
        else selfRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (!skipTransform) return this._transformedRect(selfRect, relativeTo);
        return selfRect;
    }
}
$a98a57b280deff40$exports.Container = $a98a57b280deff40$var$Container;
$4831cc45767eb450$exports.Factory.addComponentsGetterSetter($a98a57b280deff40$var$Container, 'clip', [
    'x',
    'y',
    'width',
    'height'
]);
$4831cc45767eb450$exports.Factory.addGetterSetter($a98a57b280deff40$var$Container, 'clipX', undefined, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($a98a57b280deff40$var$Container, 'clipY', undefined, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($a98a57b280deff40$var$Container, 'clipWidth', undefined, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($a98a57b280deff40$var$Container, 'clipHeight', undefined, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($a98a57b280deff40$var$Container, 'clipFunc');


var $607fbe05cce0d783$exports = {};
"use strict";
Object.defineProperty($607fbe05cce0d783$exports, "__esModule", {
    value: true
});
$607fbe05cce0d783$exports.Stage = $607fbe05cce0d783$exports.stages = void 0;







var $86075c410dc0663b$exports = {};
"use strict";
Object.defineProperty($86075c410dc0663b$exports, "__esModule", {
    value: true
});
$86075c410dc0663b$exports.releaseCapture = $86075c410dc0663b$exports.setPointerCapture = $86075c410dc0663b$exports.hasPointerCapture = $86075c410dc0663b$exports.createEvent = $86075c410dc0663b$exports.getCapturedShape = void 0;

const $86075c410dc0663b$var$Captures = new Map();
const $86075c410dc0663b$var$SUPPORT_POINTER_EVENTS = $2aee50cb6c94cb28$exports.Konva._global['PointerEvent'] !== undefined;
function $86075c410dc0663b$var$getCapturedShape(pointerId) {
    return $86075c410dc0663b$var$Captures.get(pointerId);
}
$86075c410dc0663b$exports.getCapturedShape = $86075c410dc0663b$var$getCapturedShape;
function $86075c410dc0663b$var$createEvent(evt) {
    return {
        evt: evt,
        pointerId: evt.pointerId
    };
}
$86075c410dc0663b$exports.createEvent = $86075c410dc0663b$var$createEvent;
function $86075c410dc0663b$var$hasPointerCapture(pointerId, shape) {
    return $86075c410dc0663b$var$Captures.get(pointerId) === shape;
}
$86075c410dc0663b$exports.hasPointerCapture = $86075c410dc0663b$var$hasPointerCapture;
function $86075c410dc0663b$var$setPointerCapture(pointerId, shape) {
    $86075c410dc0663b$var$releaseCapture(pointerId);
    const stage = shape.getStage();
    if (!stage) return;
    $86075c410dc0663b$var$Captures.set(pointerId, shape);
    if ($86075c410dc0663b$var$SUPPORT_POINTER_EVENTS) shape._fire('gotpointercapture', $86075c410dc0663b$var$createEvent(new PointerEvent('gotpointercapture')));
}
$86075c410dc0663b$exports.setPointerCapture = $86075c410dc0663b$var$setPointerCapture;
function $86075c410dc0663b$var$releaseCapture(pointerId, target) {
    const shape = $86075c410dc0663b$var$Captures.get(pointerId);
    if (!shape) return;
    const stage = shape.getStage();
    stage && stage.content;
    $86075c410dc0663b$var$Captures.delete(pointerId);
    if ($86075c410dc0663b$var$SUPPORT_POINTER_EVENTS) shape._fire('lostpointercapture', $86075c410dc0663b$var$createEvent(new PointerEvent('lostpointercapture')));
}
$86075c410dc0663b$exports.releaseCapture = $86075c410dc0663b$var$releaseCapture;


var $607fbe05cce0d783$var$STAGE = 'Stage', $607fbe05cce0d783$var$STRING = 'string', $607fbe05cce0d783$var$PX = 'px', $607fbe05cce0d783$var$MOUSEOUT = 'mouseout', $607fbe05cce0d783$var$MOUSELEAVE = 'mouseleave', $607fbe05cce0d783$var$MOUSEOVER = 'mouseover', $607fbe05cce0d783$var$MOUSEENTER = 'mouseenter', $607fbe05cce0d783$var$MOUSEMOVE = 'mousemove', $607fbe05cce0d783$var$MOUSEDOWN = 'mousedown', $607fbe05cce0d783$var$MOUSEUP = 'mouseup', $607fbe05cce0d783$var$POINTERMOVE = 'pointermove', $607fbe05cce0d783$var$POINTERDOWN = 'pointerdown', $607fbe05cce0d783$var$POINTERUP = 'pointerup', $607fbe05cce0d783$var$POINTERCANCEL = 'pointercancel', $607fbe05cce0d783$var$LOSTPOINTERCAPTURE = 'lostpointercapture', $607fbe05cce0d783$var$POINTEROUT = 'pointerout', $607fbe05cce0d783$var$POINTERLEAVE = 'pointerleave', $607fbe05cce0d783$var$POINTEROVER = 'pointerover', $607fbe05cce0d783$var$POINTERENTER = 'pointerenter', $607fbe05cce0d783$var$CONTEXTMENU = 'contextmenu', $607fbe05cce0d783$var$TOUCHSTART = 'touchstart', $607fbe05cce0d783$var$TOUCHEND = 'touchend', $607fbe05cce0d783$var$TOUCHMOVE = 'touchmove', $607fbe05cce0d783$var$TOUCHCANCEL = 'touchcancel', $607fbe05cce0d783$var$WHEEL = 'wheel', $607fbe05cce0d783$var$MAX_LAYERS_NUMBER = 5, $607fbe05cce0d783$var$EVENTS = [
    [
        $607fbe05cce0d783$var$MOUSEENTER,
        '_pointerenter'
    ],
    [
        $607fbe05cce0d783$var$MOUSEDOWN,
        '_pointerdown'
    ],
    [
        $607fbe05cce0d783$var$MOUSEMOVE,
        '_pointermove'
    ],
    [
        $607fbe05cce0d783$var$MOUSEUP,
        '_pointerup'
    ],
    [
        $607fbe05cce0d783$var$MOUSELEAVE,
        '_pointerleave'
    ],
    [
        $607fbe05cce0d783$var$TOUCHSTART,
        '_pointerdown'
    ],
    [
        $607fbe05cce0d783$var$TOUCHMOVE,
        '_pointermove'
    ],
    [
        $607fbe05cce0d783$var$TOUCHEND,
        '_pointerup'
    ],
    [
        $607fbe05cce0d783$var$TOUCHCANCEL,
        '_pointercancel'
    ],
    [
        $607fbe05cce0d783$var$MOUSEOVER,
        '_pointerover'
    ],
    [
        $607fbe05cce0d783$var$WHEEL,
        '_wheel'
    ],
    [
        $607fbe05cce0d783$var$CONTEXTMENU,
        '_contextmenu'
    ],
    [
        $607fbe05cce0d783$var$POINTERDOWN,
        '_pointerdown'
    ],
    [
        $607fbe05cce0d783$var$POINTERMOVE,
        '_pointermove'
    ],
    [
        $607fbe05cce0d783$var$POINTERUP,
        '_pointerup'
    ],
    [
        $607fbe05cce0d783$var$POINTERCANCEL,
        '_pointercancel'
    ],
    [
        $607fbe05cce0d783$var$LOSTPOINTERCAPTURE,
        '_lostpointercapture'
    ]
];
const $607fbe05cce0d783$var$EVENTS_MAP = {
    mouse: {
        [$607fbe05cce0d783$var$POINTEROUT]: $607fbe05cce0d783$var$MOUSEOUT,
        [$607fbe05cce0d783$var$POINTERLEAVE]: $607fbe05cce0d783$var$MOUSELEAVE,
        [$607fbe05cce0d783$var$POINTEROVER]: $607fbe05cce0d783$var$MOUSEOVER,
        [$607fbe05cce0d783$var$POINTERENTER]: $607fbe05cce0d783$var$MOUSEENTER,
        [$607fbe05cce0d783$var$POINTERMOVE]: $607fbe05cce0d783$var$MOUSEMOVE,
        [$607fbe05cce0d783$var$POINTERDOWN]: $607fbe05cce0d783$var$MOUSEDOWN,
        [$607fbe05cce0d783$var$POINTERUP]: $607fbe05cce0d783$var$MOUSEUP,
        [$607fbe05cce0d783$var$POINTERCANCEL]: 'mousecancel',
        pointerclick: 'click',
        pointerdblclick: 'dblclick'
    },
    touch: {
        [$607fbe05cce0d783$var$POINTEROUT]: 'touchout',
        [$607fbe05cce0d783$var$POINTERLEAVE]: 'touchleave',
        [$607fbe05cce0d783$var$POINTEROVER]: 'touchover',
        [$607fbe05cce0d783$var$POINTERENTER]: 'touchenter',
        [$607fbe05cce0d783$var$POINTERMOVE]: $607fbe05cce0d783$var$TOUCHMOVE,
        [$607fbe05cce0d783$var$POINTERDOWN]: $607fbe05cce0d783$var$TOUCHSTART,
        [$607fbe05cce0d783$var$POINTERUP]: $607fbe05cce0d783$var$TOUCHEND,
        [$607fbe05cce0d783$var$POINTERCANCEL]: $607fbe05cce0d783$var$TOUCHCANCEL,
        pointerclick: 'tap',
        pointerdblclick: 'dbltap'
    },
    pointer: {
        [$607fbe05cce0d783$var$POINTEROUT]: $607fbe05cce0d783$var$POINTEROUT,
        [$607fbe05cce0d783$var$POINTERLEAVE]: $607fbe05cce0d783$var$POINTERLEAVE,
        [$607fbe05cce0d783$var$POINTEROVER]: $607fbe05cce0d783$var$POINTEROVER,
        [$607fbe05cce0d783$var$POINTERENTER]: $607fbe05cce0d783$var$POINTERENTER,
        [$607fbe05cce0d783$var$POINTERMOVE]: $607fbe05cce0d783$var$POINTERMOVE,
        [$607fbe05cce0d783$var$POINTERDOWN]: $607fbe05cce0d783$var$POINTERDOWN,
        [$607fbe05cce0d783$var$POINTERUP]: $607fbe05cce0d783$var$POINTERUP,
        [$607fbe05cce0d783$var$POINTERCANCEL]: $607fbe05cce0d783$var$POINTERCANCEL,
        pointerclick: 'pointerclick',
        pointerdblclick: 'pointerdblclick'
    }
};
const $607fbe05cce0d783$var$getEventType = (type)=>{
    if (type.indexOf('pointer') >= 0) return 'pointer';
    if (type.indexOf('touch') >= 0) return 'touch';
    return 'mouse';
};
const $607fbe05cce0d783$var$getEventsMap = (eventType)=>{
    const type = $607fbe05cce0d783$var$getEventType(eventType);
    if (type === 'pointer') return $2aee50cb6c94cb28$exports.Konva.pointerEventsEnabled && $607fbe05cce0d783$var$EVENTS_MAP.pointer;
    if (type === 'touch') return $607fbe05cce0d783$var$EVENTS_MAP.touch;
    if (type === 'mouse') return $607fbe05cce0d783$var$EVENTS_MAP.mouse;
};
function $607fbe05cce0d783$var$checkNoClip(attrs = {}) {
    if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) $f4b7065bbd5eff66$exports.Util.warn('Stage does not support clipping. Please use clip for Layers or Groups.');
    return attrs;
}
const $607fbe05cce0d783$var$NO_POINTERS_MESSAGE = `Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);`;
$607fbe05cce0d783$exports.stages = [];
class $607fbe05cce0d783$var$Stage extends $a98a57b280deff40$exports.Container {
    constructor(config){
        super($607fbe05cce0d783$var$checkNoClip(config));
        this._pointerPositions = [];
        this._changedPointerPositions = [];
        this._buildDOM();
        this._bindContentEvents();
        $607fbe05cce0d783$exports.stages.push(this);
        this.on('widthChange.konva heightChange.konva', this._resizeDOM);
        this.on('visibleChange.konva', this._checkVisibility);
        this.on('clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva', ()=>{
            $607fbe05cce0d783$var$checkNoClip(this.attrs);
        });
        this._checkVisibility();
    }
    _validateAdd(child) {
        const isLayer = child.getType() === 'Layer';
        const isFastLayer = child.getType() === 'FastLayer';
        const valid = isLayer || isFastLayer;
        if (!valid) $f4b7065bbd5eff66$exports.Util.throw('You may only add layers to the stage.');
    }
    _checkVisibility() {
        if (!this.content) return;
        const style = this.visible() ? '' : 'none';
        this.content.style.display = style;
    }
    setContainer(container) {
        if (typeof container === $607fbe05cce0d783$var$STRING) {
            if (container.charAt(0) === '.') {
                var className = container.slice(1);
                container = document.getElementsByClassName(className)[0];
            } else {
                var id;
                if (container.charAt(0) !== '#') id = container;
                else id = container.slice(1);
                container = document.getElementById(id);
            }
            if (!container) throw 'Can not find container in document with id ' + id;
        }
        this._setAttr('container', container);
        if (this.content) {
            if (this.content.parentElement) this.content.parentElement.removeChild(this.content);
            container.appendChild(this.content);
        }
        return this;
    }
    shouldDrawHit() {
        return true;
    }
    clear() {
        var layers = this.children, len = layers.length, n;
        for(n = 0; n < len; n++)layers[n].clear();
        return this;
    }
    clone(obj) {
        if (!obj) obj = {};
        obj.container = typeof document !== 'undefined' && document.createElement('div');
        return $a98a57b280deff40$exports.Container.prototype.clone.call(this, obj);
    }
    destroy() {
        super.destroy();
        var content = this.content;
        if (content && $f4b7065bbd5eff66$exports.Util._isInDocument(content)) this.container().removeChild(content);
        var index = $607fbe05cce0d783$exports.stages.indexOf(this);
        if (index > -1) $607fbe05cce0d783$exports.stages.splice(index, 1);
        $f4b7065bbd5eff66$exports.Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas);
        return this;
    }
    getPointerPosition() {
        const pos = this._pointerPositions[0] || this._changedPointerPositions[0];
        if (!pos) {
            $f4b7065bbd5eff66$exports.Util.warn($607fbe05cce0d783$var$NO_POINTERS_MESSAGE);
            return null;
        }
        return {
            x: pos.x,
            y: pos.y
        };
    }
    _getPointerById(id) {
        return this._pointerPositions.find((p)=>p.id === id);
    }
    getPointersPositions() {
        return this._pointerPositions;
    }
    getStage() {
        return this;
    }
    getContent() {
        return this.content;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        config.x = config.x || 0;
        config.y = config.y || 0;
        config.width = config.width || this.width();
        config.height = config.height || this.height();
        var canvas = new $e708bc73165de52e$exports.SceneCanvas({
            width: config.width,
            height: config.height,
            pixelRatio: config.pixelRatio || 1
        });
        var _context = canvas.getContext()._context;
        var layers = this.children;
        if (config.x || config.y) _context.translate(-1 * config.x, -1 * config.y);
        layers.forEach(function(layer) {
            if (!layer.isVisible()) return;
            var layerCanvas = layer._toKonvaCanvas(config);
            _context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
        });
        return canvas;
    }
    getIntersection(pos) {
        if (!pos) return null;
        var layers = this.children, len = layers.length, end = len - 1, n;
        for(n = end; n >= 0; n--){
            const shape = layers[n].getIntersection(pos);
            if (shape) return shape;
        }
        return null;
    }
    _resizeDOM() {
        var width = this.width();
        var height = this.height();
        if (this.content) {
            this.content.style.width = width + $607fbe05cce0d783$var$PX;
            this.content.style.height = height + $607fbe05cce0d783$var$PX;
        }
        this.bufferCanvas.setSize(width, height);
        this.bufferHitCanvas.setSize(width, height);
        this.children.forEach((layer)=>{
            layer.setSize({
                width: width,
                height: height
            });
            layer.draw();
        });
    }
    add(layer, ...rest) {
        if (arguments.length > 1) {
            for(var i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        super.add(layer);
        var length = this.children.length;
        if (length > $607fbe05cce0d783$var$MAX_LAYERS_NUMBER) $f4b7065bbd5eff66$exports.Util.warn('The stage has ' + length + ' layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.');
        layer.setSize({
            width: this.width(),
            height: this.height()
        });
        layer.draw();
        if ($2aee50cb6c94cb28$exports.Konva.isBrowser) this.content.appendChild(layer.canvas._canvas);
        return this;
    }
    getParent() {
        return null;
    }
    getLayer() {
        return null;
    }
    hasPointerCapture(pointerId) {
        return $86075c410dc0663b$exports.hasPointerCapture(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $86075c410dc0663b$exports.setPointerCapture(pointerId, this);
    }
    releaseCapture(pointerId) {
        $86075c410dc0663b$exports.releaseCapture(pointerId, this);
    }
    getLayers() {
        return this.children;
    }
    _bindContentEvents() {
        if (!$2aee50cb6c94cb28$exports.Konva.isBrowser) return;
        $607fbe05cce0d783$var$EVENTS.forEach(([event, methodName])=>{
            this.content.addEventListener(event, (evt)=>{
                this[methodName](evt);
            }, {
                passive: false
            });
        });
    }
    _pointerenter(evt) {
        this.setPointersPositions(evt);
        const events = $607fbe05cce0d783$var$getEventsMap(evt.type);
        this._fire(events.pointerenter, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointerover(evt) {
        this.setPointersPositions(evt);
        const events = $607fbe05cce0d783$var$getEventsMap(evt.type);
        this._fire(events.pointerover, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _getTargetShape(evenType) {
        let shape = this[evenType + 'targetShape'];
        if (shape && !shape.getStage()) shape = null;
        return shape;
    }
    _pointerleave(evt) {
        const events = $607fbe05cce0d783$var$getEventsMap(evt.type);
        const eventType = $607fbe05cce0d783$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        var targetShape = this._getTargetShape(eventType);
        var eventsEnabled = !$49b27c4d80a13abe$exports.DD.isDragging || $2aee50cb6c94cb28$exports.Konva.hitOnDragEnabled;
        if (targetShape && eventsEnabled) {
            targetShape._fireAndBubble(events.pointerout, {
                evt: evt
            });
            targetShape._fireAndBubble(events.pointerleave, {
                evt: evt
            });
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this[eventType + 'targetShape'] = null;
        } else if (eventsEnabled) {
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this._fire(events.pointerout, {
                evt: evt,
                target: this,
                currentTarget: this
            });
        }
        this.pointerPos = undefined;
        this._pointerPositions = [];
    }
    _pointerdown(evt) {
        const events = $607fbe05cce0d783$var$getEventsMap(evt.type);
        const eventType = $607fbe05cce0d783$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        var triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            var shape = this.getIntersection(pos);
            $49b27c4d80a13abe$exports.DD.justDragged = false;
            $2aee50cb6c94cb28$exports.Konva['_' + eventType + 'ListenClick'] = true;
            const hasShape = shape && shape.isListening();
            if (!hasShape) return;
            if ($2aee50cb6c94cb28$exports.Konva.capturePointerEventsEnabled) shape.setPointerCapture(pos.id);
            this[eventType + 'ClickStartShape'] = shape;
            shape._fireAndBubble(events.pointerdown, {
                evt: evt,
                pointerId: pos.id
            });
            triggeredOnShape = true;
            const isTouch = evt.type.indexOf('touch') >= 0;
            if (shape.preventDefault() && evt.cancelable && isTouch) evt.preventDefault();
        });
        if (!triggeredOnShape) this._fire(events.pointerdown, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._pointerPositions[0].id
        });
    }
    _pointermove(evt) {
        const events = $607fbe05cce0d783$var$getEventsMap(evt.type);
        const eventType = $607fbe05cce0d783$var$getEventType(evt.type);
        if (!events) return;
        if ($49b27c4d80a13abe$exports.DD.isDragging && $49b27c4d80a13abe$exports.DD.node.preventDefault() && evt.cancelable) evt.preventDefault();
        this.setPointersPositions(evt);
        var eventsEnabled = !$49b27c4d80a13abe$exports.DD.isDragging || $2aee50cb6c94cb28$exports.Konva.hitOnDragEnabled;
        if (!eventsEnabled) return;
        var processedShapesIds = {};
        let triggeredOnShape = false;
        var targetShape = this._getTargetShape(eventType);
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $86075c410dc0663b$exports.getCapturedShape(pos.id) || this.getIntersection(pos);
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            var differentTarget = targetShape !== shape;
            if (differentTarget && targetShape) {
                targetShape._fireAndBubble(events.pointerout, Object.assign({}, event), shape);
                targetShape._fireAndBubble(events.pointerleave, Object.assign({}, event), shape);
            }
            if (shape) {
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                if (differentTarget) {
                    shape._fireAndBubble(events.pointerover, Object.assign({}, event), targetShape);
                    shape._fireAndBubble(events.pointerenter, Object.assign({}, event), targetShape);
                    this[eventType + 'targetShape'] = shape;
                }
                shape._fireAndBubble(events.pointermove, Object.assign({}, event));
            } else if (targetShape) {
                this._fire(events.pointerover, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                this[eventType + 'targetShape'] = null;
            }
        });
        if (!triggeredOnShape) this._fire(events.pointermove, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
    }
    _pointerup(evt) {
        const events = $607fbe05cce0d783$var$getEventsMap(evt.type);
        const eventType = $607fbe05cce0d783$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        const clickStartShape = this[eventType + 'ClickStartShape'];
        const clickEndShape = this[eventType + 'ClickEndShape'];
        var processedShapesIds = {};
        let triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $86075c410dc0663b$exports.getCapturedShape(pos.id) || this.getIntersection(pos);
            if (shape) {
                shape.releaseCapture(pos.id);
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            let fireDblClick = false;
            if ($2aee50cb6c94cb28$exports.Konva['_' + eventType + 'InDblClickWindow']) {
                fireDblClick = true;
                clearTimeout(this[eventType + 'DblTimeout']);
            } else if (!$49b27c4d80a13abe$exports.DD.justDragged) {
                $2aee50cb6c94cb28$exports.Konva['_' + eventType + 'InDblClickWindow'] = true;
                clearTimeout(this[eventType + 'DblTimeout']);
            }
            this[eventType + 'DblTimeout'] = setTimeout(function() {
                $2aee50cb6c94cb28$exports.Konva['_' + eventType + 'InDblClickWindow'] = false;
            }, $2aee50cb6c94cb28$exports.Konva.dblClickWindow);
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                this[eventType + 'ClickEndShape'] = shape;
                shape._fireAndBubble(events.pointerup, Object.assign({}, event));
                if ($2aee50cb6c94cb28$exports.Konva['_' + eventType + 'ListenClick'] && clickStartShape && clickStartShape === shape) {
                    shape._fireAndBubble(events.pointerclick, Object.assign({}, event));
                    if (fireDblClick && clickEndShape && clickEndShape === shape) shape._fireAndBubble(events.pointerdblclick, Object.assign({}, event));
                }
            } else {
                this[eventType + 'ClickEndShape'] = null;
                if ($2aee50cb6c94cb28$exports.Konva['_' + eventType + 'ListenClick']) this._fire(events.pointerclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                if (fireDblClick) this._fire(events.pointerdblclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
            }
        });
        if (!triggeredOnShape) this._fire(events.pointerup, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
        $2aee50cb6c94cb28$exports.Konva['_' + eventType + 'ListenClick'] = false;
        if (evt.cancelable && eventType !== 'touch') evt.preventDefault();
    }
    _contextmenu(evt) {
        this.setPointersPositions(evt);
        var shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($607fbe05cce0d783$var$CONTEXTMENU, {
            evt: evt
        });
        else this._fire($607fbe05cce0d783$var$CONTEXTMENU, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _wheel(evt) {
        this.setPointersPositions(evt);
        var shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($607fbe05cce0d783$var$WHEEL, {
            evt: evt
        });
        else this._fire($607fbe05cce0d783$var$WHEEL, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointercancel(evt) {
        this.setPointersPositions(evt);
        const shape = $86075c410dc0663b$exports.getCapturedShape(evt.pointerId) || this.getIntersection(this.getPointerPosition());
        if (shape) shape._fireAndBubble($607fbe05cce0d783$var$POINTERUP, $86075c410dc0663b$exports.createEvent(evt));
        $86075c410dc0663b$exports.releaseCapture(evt.pointerId);
    }
    _lostpointercapture(evt) {
        $86075c410dc0663b$exports.releaseCapture(evt.pointerId);
    }
    setPointersPositions(evt) {
        var contentPosition = this._getContentPosition(), x = null, y = null;
        evt = evt ? evt : window.event;
        if (evt.touches !== undefined) {
            this._pointerPositions = [];
            this._changedPointerPositions = [];
            Array.prototype.forEach.call(evt.touches, (touch)=>{
                this._pointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
            Array.prototype.forEach.call(evt.changedTouches || evt.touches, (touch)=>{
                this._changedPointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
        } else {
            x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
            y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
            this.pointerPos = {
                x: x,
                y: y
            };
            this._pointerPositions = [
                {
                    x: x,
                    y: y,
                    id: $f4b7065bbd5eff66$exports.Util._getFirstPointerId(evt)
                }
            ];
            this._changedPointerPositions = [
                {
                    x: x,
                    y: y,
                    id: $f4b7065bbd5eff66$exports.Util._getFirstPointerId(evt)
                }
            ];
        }
    }
    _setPointerPosition(evt) {
        $f4b7065bbd5eff66$exports.Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
        this.setPointersPositions(evt);
    }
    _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect) return {
            top: 0,
            left: 0,
            scaleX: 1,
            scaleY: 1
        };
        var rect = this.content.getBoundingClientRect();
        return {
            top: rect.top,
            left: rect.left,
            scaleX: rect.width / this.content.clientWidth || 1,
            scaleY: rect.height / this.content.clientHeight || 1
        };
    }
    _buildDOM() {
        this.bufferCanvas = new $e708bc73165de52e$exports.SceneCanvas({
            width: this.width(),
            height: this.height()
        });
        this.bufferHitCanvas = new $e708bc73165de52e$exports.HitCanvas({
            pixelRatio: 1,
            width: this.width(),
            height: this.height()
        });
        if (!$2aee50cb6c94cb28$exports.Konva.isBrowser) return;
        var container = this.container();
        if (!container) throw 'Stage has no container. A container is required.';
        container.innerHTML = '';
        this.content = document.createElement('div');
        this.content.style.position = 'relative';
        this.content.style.userSelect = 'none';
        this.content.className = 'konvajs-content';
        this.content.setAttribute('role', 'presentation');
        container.appendChild(this.content);
        this._resizeDOM();
    }
    cache() {
        $f4b7065bbd5eff66$exports.Util.warn('Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.');
        return this;
    }
    clearCache() {
        return this;
    }
    batchDraw() {
        this.getChildren().forEach(function(layer) {
            layer.batchDraw();
        });
        return this;
    }
}
$607fbe05cce0d783$exports.Stage = $607fbe05cce0d783$var$Stage;
$607fbe05cce0d783$var$Stage.prototype.nodeType = $607fbe05cce0d783$var$STAGE;
(0, $2aee50cb6c94cb28$exports._registerNode)($607fbe05cce0d783$var$Stage);
$4831cc45767eb450$exports.Factory.addGetterSetter($607fbe05cce0d783$var$Stage, 'container');


var $48dd4613a2b4f2df$exports = {};
"use strict";
Object.defineProperty($48dd4613a2b4f2df$exports, "__esModule", {
    value: true
});
$48dd4613a2b4f2df$exports.Layer = void 0;






var $1d27e4c6cbd221af$exports = {};
"use strict";
Object.defineProperty($1d27e4c6cbd221af$exports, "__esModule", {
    value: true
});
$1d27e4c6cbd221af$exports.Shape = $1d27e4c6cbd221af$exports.shapes = void 0;







var $1d27e4c6cbd221af$var$HAS_SHADOW = 'hasShadow';
var $1d27e4c6cbd221af$var$SHADOW_RGBA = 'shadowRGBA';
var $1d27e4c6cbd221af$var$patternImage = 'patternImage';
var $1d27e4c6cbd221af$var$linearGradient = 'linearGradient';
var $1d27e4c6cbd221af$var$radialGradient = 'radialGradient';
let $1d27e4c6cbd221af$var$dummyContext;
function $1d27e4c6cbd221af$var$getDummyContext() {
    if ($1d27e4c6cbd221af$var$dummyContext) return $1d27e4c6cbd221af$var$dummyContext;
    $1d27e4c6cbd221af$var$dummyContext = $f4b7065bbd5eff66$exports.Util.createCanvasElement().getContext('2d');
    return $1d27e4c6cbd221af$var$dummyContext;
}
$1d27e4c6cbd221af$exports.shapes = {};
function $1d27e4c6cbd221af$var$_fillFunc(context) {
    context.fill();
}
function $1d27e4c6cbd221af$var$_strokeFunc(context) {
    context.stroke();
}
function $1d27e4c6cbd221af$var$_fillFuncHit(context) {
    context.fill();
}
function $1d27e4c6cbd221af$var$_strokeFuncHit(context) {
    context.stroke();
}
function $1d27e4c6cbd221af$var$_clearHasShadowCache() {
    this._clearCache($1d27e4c6cbd221af$var$HAS_SHADOW);
}
function $1d27e4c6cbd221af$var$_clearGetShadowRGBACache() {
    this._clearCache($1d27e4c6cbd221af$var$SHADOW_RGBA);
}
function $1d27e4c6cbd221af$var$_clearFillPatternCache() {
    this._clearCache($1d27e4c6cbd221af$var$patternImage);
}
function $1d27e4c6cbd221af$var$_clearLinearGradientCache() {
    this._clearCache($1d27e4c6cbd221af$var$linearGradient);
}
function $1d27e4c6cbd221af$var$_clearRadialGradientCache() {
    this._clearCache($1d27e4c6cbd221af$var$radialGradient);
}
class $1d27e4c6cbd221af$var$Shape extends $f5298bb5f7719915$exports.Node {
    constructor(config){
        super(config);
        let key;
        while(true){
            key = $f4b7065bbd5eff66$exports.Util.getRandomColor();
            if (key && !(key in $1d27e4c6cbd221af$exports.shapes)) break;
        }
        this.colorKey = key;
        $1d27e4c6cbd221af$exports.shapes[key] = this;
    }
    getContext() {
        $f4b7065bbd5eff66$exports.Util.warn('shape.getContext() method is deprecated. Please do not use it.');
        return this.getLayer().getContext();
    }
    getCanvas() {
        $f4b7065bbd5eff66$exports.Util.warn('shape.getCanvas() method is deprecated. Please do not use it.');
        return this.getLayer().getCanvas();
    }
    getSceneFunc() {
        return this.attrs.sceneFunc || this['_sceneFunc'];
    }
    getHitFunc() {
        return this.attrs.hitFunc || this['_hitFunc'];
    }
    hasShadow() {
        return this._getCache($1d27e4c6cbd221af$var$HAS_SHADOW, this._hasShadow);
    }
    _hasShadow() {
        return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
    }
    _getFillPattern() {
        return this._getCache($1d27e4c6cbd221af$var$patternImage, this.__getFillPattern);
    }
    __getFillPattern() {
        if (this.fillPatternImage()) {
            var ctx = $1d27e4c6cbd221af$var$getDummyContext();
            const pattern = ctx.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || 'repeat');
            if (pattern && pattern.setTransform) {
                const tr = new $f4b7065bbd5eff66$exports.Transform();
                tr.translate(this.fillPatternX(), this.fillPatternY());
                tr.rotate($2aee50cb6c94cb28$exports.Konva.getAngle(this.fillPatternRotation()));
                tr.scale(this.fillPatternScaleX(), this.fillPatternScaleY());
                tr.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
                const m = tr.getMatrix();
                const matrix = typeof DOMMatrix === 'undefined' ? {
                    a: m[0],
                    b: m[1],
                    c: m[2],
                    d: m[3],
                    e: m[4],
                    f: m[5]
                } : new DOMMatrix(m);
                pattern.setTransform(matrix);
            }
            return pattern;
        }
    }
    _getLinearGradient() {
        return this._getCache($1d27e4c6cbd221af$var$linearGradient, this.__getLinearGradient);
    }
    __getLinearGradient() {
        var colorStops = this.fillLinearGradientColorStops();
        if (colorStops) {
            var ctx = $1d27e4c6cbd221af$var$getDummyContext();
            var start = this.fillLinearGradientStartPoint();
            var end = this.fillLinearGradientEndPoint();
            var grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    _getRadialGradient() {
        return this._getCache($1d27e4c6cbd221af$var$radialGradient, this.__getRadialGradient);
    }
    __getRadialGradient() {
        var colorStops = this.fillRadialGradientColorStops();
        if (colorStops) {
            var ctx = $1d27e4c6cbd221af$var$getDummyContext();
            var start = this.fillRadialGradientStartPoint();
            var end = this.fillRadialGradientEndPoint();
            var grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    getShadowRGBA() {
        return this._getCache($1d27e4c6cbd221af$var$SHADOW_RGBA, this._getShadowRGBA);
    }
    _getShadowRGBA() {
        if (!this.hasShadow()) return;
        var rgba = $f4b7065bbd5eff66$exports.Util.colorToRGBA(this.shadowColor());
        if (rgba) return 'rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a * (this.shadowOpacity() || 1) + ')';
    }
    hasFill() {
        return this._calculate('hasFill', [
            'fillEnabled',
            'fill',
            'fillPatternImage',
            'fillLinearGradientColorStops',
            'fillRadialGradientColorStops'
        ], ()=>{
            return this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops());
        });
    }
    hasStroke() {
        return this._calculate('hasStroke', [
            'strokeEnabled',
            'strokeWidth',
            'stroke',
            'strokeLinearGradientColorStops'
        ], ()=>{
            return this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops());
        });
    }
    hasHitStroke() {
        const width = this.hitStrokeWidth();
        if (width === 'auto') return this.hasStroke();
        return this.strokeEnabled() && !!width;
    }
    intersects(point) {
        var stage = this.getStage(), bufferHitCanvas = stage.bufferHitCanvas, p;
        bufferHitCanvas.getContext().clear();
        this.drawHit(bufferHitCanvas, null, true);
        p = bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
        return p[3] > 0;
    }
    destroy() {
        $f5298bb5f7719915$exports.Node.prototype.destroy.call(this);
        delete $1d27e4c6cbd221af$exports.shapes[this.colorKey];
        delete this.colorKey;
        return this;
    }
    _useBufferCanvas(forceFill) {
        var _a;
        if (!this.getStage()) return false;
        const perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
        if (!perfectDrawEnabled) return false;
        const hasFill = forceFill || this.hasFill();
        const hasStroke = this.hasStroke();
        const isTransparent = this.getAbsoluteOpacity() !== 1;
        if (hasFill && hasStroke && isTransparent) return true;
        const hasShadow = this.hasShadow();
        const strokeForShadow = this.shadowForStrokeEnabled();
        if (hasFill && hasStroke && hasShadow && strokeForShadow) return true;
        return false;
    }
    setStrokeHitEnabled(val) {
        $f4b7065bbd5eff66$exports.Util.warn('strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.');
        if (val) this.hitStrokeWidth('auto');
        else this.hitStrokeWidth(0);
    }
    getStrokeHitEnabled() {
        if (this.hitStrokeWidth() === 0) return false;
        else return true;
    }
    getSelfRect() {
        var size = this.size();
        return {
            x: this._centroid ? -size.width / 2 : 0,
            y: this._centroid ? -size.height / 2 : 0,
            width: size.width,
            height: size.height
        };
    }
    getClientRect(config = {}) {
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo;
        const fillRect = this.getSelfRect();
        const applyStroke = !config.skipStroke && this.hasStroke();
        const strokeWidth = applyStroke && this.strokeWidth() || 0;
        const fillAndStrokeWidth = fillRect.width + strokeWidth;
        const fillAndStrokeHeight = fillRect.height + strokeWidth;
        const applyShadow = !config.skipShadow && this.hasShadow();
        const shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
        const shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
        const preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
        const preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
        const blurRadius = applyShadow && this.shadowBlur() || 0;
        const width = preWidth + blurRadius * 2;
        const height = preHeight + blurRadius * 2;
        const rect = {
            width: width,
            height: height,
            x: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetX, 0) + fillRect.x,
            y: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetY, 0) + fillRect.y
        };
        if (!skipTransform) return this._transformedRect(rect, relativeTo);
        return rect;
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow(), stage, bufferCanvas, bufferContext;
        var skipBuffer = canvas.isCache;
        var cachingSelf = top === this;
        if (!this.isVisible() && !cachingSelf) return this;
        if (cachedCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        if (this._useBufferCanvas() && !skipBuffer) {
            stage = this.getStage();
            bufferCanvas = stage.bufferCanvas;
            bufferContext = bufferCanvas.getContext();
            bufferContext.clear();
            bufferContext.save();
            bufferContext._applyLineJoin(this);
            var o = this.getAbsoluteTransform(top).getMatrix();
            bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
            drawFunc.call(this, bufferContext, this);
            bufferContext.restore();
            var ratio = bufferCanvas.pixelRatio;
            if (hasShadow) context._applyShadow(this);
            context._applyOpacity(this);
            context._applyGlobalCompositeOperation(this);
            context.drawImage(bufferCanvas._canvas, 0, 0, bufferCanvas.width / ratio, bufferCanvas.height / ratio);
        } else {
            context._applyLineJoin(this);
            if (!cachingSelf) {
                var o = this.getAbsoluteTransform(top).getMatrix();
                context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
                context._applyOpacity(this);
                context._applyGlobalCompositeOperation(this);
            }
            if (hasShadow) context._applyShadow(this);
            drawFunc.call(this, context, this);
        }
        context.restore();
        return this;
    }
    drawHit(can, top, skipDragCheck = false) {
        if (!this.shouldDrawHit(top, skipDragCheck)) return this;
        var layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (!this.colorKey) $f4b7065bbd5eff66$exports.Util.warn('Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()');
        if (cachedHitCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        context._applyLineJoin(this);
        const selfCache = this === top;
        if (!selfCache) {
            var o = this.getAbsoluteTransform(top).getMatrix();
            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
        }
        drawFunc.call(this, context, this);
        context.restore();
        return this;
    }
    drawHitFromCache(alphaThreshold = 0) {
        var cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight(), hitImageData, hitData, len, rgbColorKey, i, alpha;
        hitContext.clear();
        hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
        try {
            hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
            hitData = hitImageData.data;
            len = hitData.length;
            rgbColorKey = $f4b7065bbd5eff66$exports.Util._hexToRgb(this.colorKey);
            for(i = 0; i < len; i += 4){
                alpha = hitData[i + 3];
                if (alpha > alphaThreshold) {
                    hitData[i] = rgbColorKey.r;
                    hitData[i + 1] = rgbColorKey.g;
                    hitData[i + 2] = rgbColorKey.b;
                    hitData[i + 3] = 255;
                } else hitData[i + 3] = 0;
            }
            hitContext.putImageData(hitImageData, 0, 0);
        } catch (e) {
            $f4b7065bbd5eff66$exports.Util.error('Unable to draw hit graph from cached scene canvas. ' + e.message);
        }
        return this;
    }
    hasPointerCapture(pointerId) {
        return $86075c410dc0663b$exports.hasPointerCapture(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $86075c410dc0663b$exports.setPointerCapture(pointerId, this);
    }
    releaseCapture(pointerId) {
        $86075c410dc0663b$exports.releaseCapture(pointerId, this);
    }
}
$1d27e4c6cbd221af$exports.Shape = $1d27e4c6cbd221af$var$Shape;
$1d27e4c6cbd221af$var$Shape.prototype._fillFunc = $1d27e4c6cbd221af$var$_fillFunc;
$1d27e4c6cbd221af$var$Shape.prototype._strokeFunc = $1d27e4c6cbd221af$var$_strokeFunc;
$1d27e4c6cbd221af$var$Shape.prototype._fillFuncHit = $1d27e4c6cbd221af$var$_fillFuncHit;
$1d27e4c6cbd221af$var$Shape.prototype._strokeFuncHit = $1d27e4c6cbd221af$var$_strokeFuncHit;
$1d27e4c6cbd221af$var$Shape.prototype._centroid = false;
$1d27e4c6cbd221af$var$Shape.prototype.nodeType = 'Shape';
(0, $2aee50cb6c94cb28$exports._registerNode)($1d27e4c6cbd221af$var$Shape);
$1d27e4c6cbd221af$var$Shape.prototype.eventListeners = {};
$1d27e4c6cbd221af$var$Shape.prototype.on.call($1d27e4c6cbd221af$var$Shape.prototype, 'shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', $1d27e4c6cbd221af$var$_clearHasShadowCache);
$1d27e4c6cbd221af$var$Shape.prototype.on.call($1d27e4c6cbd221af$var$Shape.prototype, 'shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', $1d27e4c6cbd221af$var$_clearGetShadowRGBACache);
$1d27e4c6cbd221af$var$Shape.prototype.on.call($1d27e4c6cbd221af$var$Shape.prototype, 'fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva', $1d27e4c6cbd221af$var$_clearFillPatternCache);
$1d27e4c6cbd221af$var$Shape.prototype.on.call($1d27e4c6cbd221af$var$Shape.prototype, 'fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva', $1d27e4c6cbd221af$var$_clearLinearGradientCache);
$1d27e4c6cbd221af$var$Shape.prototype.on.call($1d27e4c6cbd221af$var$Shape.prototype, 'fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva', $1d27e4c6cbd221af$var$_clearRadialGradientCache);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'stroke', undefined, (0, $b21213ef7b53b4df$exports.getStringOrGradientValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'strokeWidth', 2, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillAfterStrokeEnabled', false);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'hitStrokeWidth', 'auto', (0, $b21213ef7b53b4df$exports.getNumberOrAutoValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'strokeHitEnabled', true, (0, $b21213ef7b53b4df$exports.getBooleanValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'perfectDrawEnabled', true, (0, $b21213ef7b53b4df$exports.getBooleanValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'shadowForStrokeEnabled', true, (0, $b21213ef7b53b4df$exports.getBooleanValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'lineJoin');
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'lineCap');
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'sceneFunc');
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'hitFunc');
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'dash');
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'dashOffset', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'shadowColor', undefined, (0, $b21213ef7b53b4df$exports.getStringValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'shadowBlur', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'shadowOpacity', 1, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addComponentsGetterSetter($1d27e4c6cbd221af$var$Shape, 'shadowOffset', [
    'x',
    'y'
]);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'shadowOffsetX', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'shadowOffsetY', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillPatternImage');
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fill', undefined, (0, $b21213ef7b53b4df$exports.getStringOrGradientValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillPatternX', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillPatternY', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillLinearGradientColorStops');
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'strokeLinearGradientColorStops');
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillRadialGradientStartRadius', 0);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillRadialGradientEndRadius', 0);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillRadialGradientColorStops');
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillPatternRepeat', 'repeat');
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillEnabled', true);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'strokeEnabled', true);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'shadowEnabled', true);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'dashEnabled', true);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'strokeScaleEnabled', true);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillPriority', 'color');
$4831cc45767eb450$exports.Factory.addComponentsGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillPatternOffset', [
    'x',
    'y'
]);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillPatternOffsetX', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillPatternOffsetY', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addComponentsGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillPatternScale', [
    'x',
    'y'
]);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillPatternScaleX', 1, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillPatternScaleY', 1, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addComponentsGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillLinearGradientStartPoint', [
    'x',
    'y'
]);
$4831cc45767eb450$exports.Factory.addComponentsGetterSetter($1d27e4c6cbd221af$var$Shape, 'strokeLinearGradientStartPoint', [
    'x',
    'y'
]);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillLinearGradientStartPointX', 0);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'strokeLinearGradientStartPointX', 0);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillLinearGradientStartPointY', 0);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'strokeLinearGradientStartPointY', 0);
$4831cc45767eb450$exports.Factory.addComponentsGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillLinearGradientEndPoint', [
    'x',
    'y'
]);
$4831cc45767eb450$exports.Factory.addComponentsGetterSetter($1d27e4c6cbd221af$var$Shape, 'strokeLinearGradientEndPoint', [
    'x',
    'y'
]);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillLinearGradientEndPointX', 0);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'strokeLinearGradientEndPointX', 0);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillLinearGradientEndPointY', 0);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'strokeLinearGradientEndPointY', 0);
$4831cc45767eb450$exports.Factory.addComponentsGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillRadialGradientStartPoint', [
    'x',
    'y'
]);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillRadialGradientStartPointX', 0);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillRadialGradientStartPointY', 0);
$4831cc45767eb450$exports.Factory.addComponentsGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillRadialGradientEndPoint', [
    'x',
    'y'
]);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillRadialGradientEndPointX', 0);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillRadialGradientEndPointY', 0);
$4831cc45767eb450$exports.Factory.addGetterSetter($1d27e4c6cbd221af$var$Shape, 'fillPatternRotation', 0);
$4831cc45767eb450$exports.Factory.backCompat($1d27e4c6cbd221af$var$Shape, {
    dashArray: 'dash',
    getDashArray: 'getDash',
    setDashArray: 'getDash',
    drawFunc: 'sceneFunc',
    getDrawFunc: 'getSceneFunc',
    setDrawFunc: 'setSceneFunc',
    drawHitFunc: 'hitFunc',
    getDrawHitFunc: 'getHitFunc',
    setDrawHitFunc: 'setHitFunc'
});



var $48dd4613a2b4f2df$var$HASH = '#', $48dd4613a2b4f2df$var$BEFORE_DRAW = 'beforeDraw', $48dd4613a2b4f2df$var$DRAW = 'draw', $48dd4613a2b4f2df$var$INTERSECTION_OFFSETS = [
    {
        x: 0,
        y: 0
    },
    {
        x: -1,
        y: -1
    },
    {
        x: 1,
        y: -1
    },
    {
        x: 1,
        y: 1
    },
    {
        x: -1,
        y: 1
    }
], $48dd4613a2b4f2df$var$INTERSECTION_OFFSETS_LEN = $48dd4613a2b4f2df$var$INTERSECTION_OFFSETS.length;
class $48dd4613a2b4f2df$var$Layer extends $a98a57b280deff40$exports.Container {
    constructor(config){
        super(config);
        this.canvas = new $e708bc73165de52e$exports.SceneCanvas();
        this.hitCanvas = new $e708bc73165de52e$exports.HitCanvas({
            pixelRatio: 1
        });
        this._waitingForDraw = false;
        this.on('visibleChange.konva', this._checkVisibility);
        this._checkVisibility();
        this.on('imageSmoothingEnabledChange.konva', this._setSmoothEnabled);
        this._setSmoothEnabled();
    }
    createPNGStream() {
        const c = this.canvas._canvas;
        return c.createPNGStream();
    }
    getCanvas() {
        return this.canvas;
    }
    getNativeCanvasElement() {
        return this.canvas._canvas;
    }
    getHitCanvas() {
        return this.hitCanvas;
    }
    getContext() {
        return this.getCanvas().getContext();
    }
    clear(bounds) {
        this.getContext().clear(bounds);
        this.getHitCanvas().getContext().clear(bounds);
        return this;
    }
    setZIndex(index) {
        super.setZIndex(index);
        var stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            if (index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
            else stage.content.appendChild(this.getNativeCanvasElement());
        }
        return this;
    }
    moveToTop() {
        $f5298bb5f7719915$exports.Node.prototype.moveToTop.call(this);
        var stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            stage.content.appendChild(this.getNativeCanvasElement());
        }
        return true;
    }
    moveUp() {
        var moved = $f5298bb5f7719915$exports.Node.prototype.moveUp.call(this);
        if (!moved) return false;
        var stage = this.getStage();
        if (!stage || !stage.content) return false;
        stage.content.removeChild(this.getNativeCanvasElement());
        if (this.index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
        else stage.content.appendChild(this.getNativeCanvasElement());
        return true;
    }
    moveDown() {
        if ($f5298bb5f7719915$exports.Node.prototype.moveDown.call(this)) {
            var stage = this.getStage();
            if (stage) {
                var children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    moveToBottom() {
        if ($f5298bb5f7719915$exports.Node.prototype.moveToBottom.call(this)) {
            var stage = this.getStage();
            if (stage) {
                var children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    getLayer() {
        return this;
    }
    remove() {
        var _canvas = this.getNativeCanvasElement();
        $f5298bb5f7719915$exports.Node.prototype.remove.call(this);
        if (_canvas && _canvas.parentNode && $f4b7065bbd5eff66$exports.Util._isInDocument(_canvas)) _canvas.parentNode.removeChild(_canvas);
        return this;
    }
    getStage() {
        return this.parent;
    }
    setSize({ width: width, height: height }) {
        this.canvas.setSize(width, height);
        this.hitCanvas.setSize(width, height);
        this._setSmoothEnabled();
        return this;
    }
    _validateAdd(child) {
        var type = child.getType();
        if (type !== 'Group' && type !== 'Shape') $f4b7065bbd5eff66$exports.Util.throw('You may only add groups and shapes to a layer.');
    }
    _toKonvaCanvas(config) {
        config = config || {};
        config.width = config.width || this.getWidth();
        config.height = config.height || this.getHeight();
        config.x = config.x !== undefined ? config.x : this.x();
        config.y = config.y !== undefined ? config.y : this.y();
        return $f5298bb5f7719915$exports.Node.prototype._toKonvaCanvas.call(this, config);
    }
    _checkVisibility() {
        const visible = this.visible();
        if (visible) this.canvas._canvas.style.display = 'block';
        else this.canvas._canvas.style.display = 'none';
    }
    _setSmoothEnabled() {
        this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    getWidth() {
        if (this.parent) return this.parent.width();
    }
    setWidth() {
        $f4b7065bbd5eff66$exports.Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
        if (this.parent) return this.parent.height();
    }
    setHeight() {
        $f4b7065bbd5eff66$exports.Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
        if (!this._waitingForDraw) {
            this._waitingForDraw = true;
            $f4b7065bbd5eff66$exports.Util.requestAnimFrame(()=>{
                this.draw();
                this._waitingForDraw = false;
            });
        }
        return this;
    }
    getIntersection(pos) {
        if (!this.isListening() || !this.isVisible()) return null;
        var spiralSearchDistance = 1;
        var continueSearch = false;
        while(true){
            for(let i = 0; i < $48dd4613a2b4f2df$var$INTERSECTION_OFFSETS_LEN; i++){
                const intersectionOffset = $48dd4613a2b4f2df$var$INTERSECTION_OFFSETS[i];
                const obj = this._getIntersection({
                    x: pos.x + intersectionOffset.x * spiralSearchDistance,
                    y: pos.y + intersectionOffset.y * spiralSearchDistance
                });
                const shape = obj.shape;
                if (shape) return shape;
                continueSearch = !!obj.antialiased;
                if (!obj.antialiased) break;
            }
            if (continueSearch) spiralSearchDistance += 1;
            else return null;
        }
    }
    _getIntersection(pos) {
        const ratio = this.hitCanvas.pixelRatio;
        const p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
        const p3 = p[3];
        if (p3 === 255) {
            const colorKey = $f4b7065bbd5eff66$exports.Util._rgbToHex(p[0], p[1], p[2]);
            const shape = $1d27e4c6cbd221af$exports.shapes[$48dd4613a2b4f2df$var$HASH + colorKey];
            if (shape) return {
                shape: shape
            };
            return {
                antialiased: true
            };
        } else if (p3 > 0) return {
            antialiased: true
        };
        return {};
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.getCanvas();
        this._fire($48dd4613a2b4f2df$var$BEFORE_DRAW, {
            node: this
        });
        if (this.clearBeforeDraw()) canvas.getContext().clear();
        $a98a57b280deff40$exports.Container.prototype.drawScene.call(this, canvas, top);
        this._fire($48dd4613a2b4f2df$var$DRAW, {
            node: this
        });
        return this;
    }
    drawHit(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.hitCanvas;
        if (layer && layer.clearBeforeDraw()) layer.getHitCanvas().getContext().clear();
        $a98a57b280deff40$exports.Container.prototype.drawHit.call(this, canvas, top);
        return this;
    }
    enableHitGraph() {
        this.hitGraphEnabled(true);
        return this;
    }
    disableHitGraph() {
        this.hitGraphEnabled(false);
        return this;
    }
    setHitGraphEnabled(val) {
        $f4b7065bbd5eff66$exports.Util.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        this.listening(val);
    }
    getHitGraphEnabled(val) {
        $f4b7065bbd5eff66$exports.Util.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        return this.listening();
    }
    toggleHitCanvas() {
        if (!this.parent || !this.parent['content']) return;
        var parent = this.parent;
        var added = !!this.hitCanvas._canvas.parentNode;
        if (added) parent.content.removeChild(this.hitCanvas._canvas);
        else parent.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
        $f4b7065bbd5eff66$exports.Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas);
        return super.destroy();
    }
}
$48dd4613a2b4f2df$exports.Layer = $48dd4613a2b4f2df$var$Layer;
$48dd4613a2b4f2df$var$Layer.prototype.nodeType = 'Layer';
(0, $2aee50cb6c94cb28$exports._registerNode)($48dd4613a2b4f2df$var$Layer);
$4831cc45767eb450$exports.Factory.addGetterSetter($48dd4613a2b4f2df$var$Layer, 'imageSmoothingEnabled', true);
$4831cc45767eb450$exports.Factory.addGetterSetter($48dd4613a2b4f2df$var$Layer, 'clearBeforeDraw', true);
$4831cc45767eb450$exports.Factory.addGetterSetter($48dd4613a2b4f2df$var$Layer, 'hitGraphEnabled', true, (0, $b21213ef7b53b4df$exports.getBooleanValidator)());


var $23cb2c6573741a54$exports = {};
"use strict";
Object.defineProperty($23cb2c6573741a54$exports, "__esModule", {
    value: true
});
$23cb2c6573741a54$exports.FastLayer = void 0;



class $23cb2c6573741a54$var$FastLayer extends $48dd4613a2b4f2df$exports.Layer {
    constructor(attrs){
        super(attrs);
        this.listening(false);
        $f4b7065bbd5eff66$exports.Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
}
$23cb2c6573741a54$exports.FastLayer = $23cb2c6573741a54$var$FastLayer;
$23cb2c6573741a54$var$FastLayer.prototype.nodeType = 'FastLayer';
(0, $2aee50cb6c94cb28$exports._registerNode)($23cb2c6573741a54$var$FastLayer);


var $5055ca4f98315c6f$exports = {};
"use strict";
Object.defineProperty($5055ca4f98315c6f$exports, "__esModule", {
    value: true
});
$5055ca4f98315c6f$exports.Group = void 0;



class $5055ca4f98315c6f$var$Group extends $a98a57b280deff40$exports.Container {
    _validateAdd(child) {
        var type = child.getType();
        if (type !== 'Group' && type !== 'Shape') $f4b7065bbd5eff66$exports.Util.throw('You may only add groups and shapes to groups.');
    }
}
$5055ca4f98315c6f$exports.Group = $5055ca4f98315c6f$var$Group;
$5055ca4f98315c6f$var$Group.prototype.nodeType = 'Group';
(0, $2aee50cb6c94cb28$exports._registerNode)($5055ca4f98315c6f$var$Group);




var $7bf318e9b40f0603$exports = {};
"use strict";
Object.defineProperty($7bf318e9b40f0603$exports, "__esModule", {
    value: true
});
$7bf318e9b40f0603$exports.Animation = void 0;


var $7bf318e9b40f0603$var$now = function() {
    if ($2aee50cb6c94cb28$exports.glob.performance && $2aee50cb6c94cb28$exports.glob.performance.now) return function() {
        return $2aee50cb6c94cb28$exports.glob.performance.now();
    };
    return function() {
        return new Date().getTime();
    };
}();
class $7bf318e9b40f0603$var$Animation {
    constructor(func, layers){
        this.id = $7bf318e9b40f0603$var$Animation.animIdCounter++;
        this.frame = {
            time: 0,
            timeDiff: 0,
            lastTime: $7bf318e9b40f0603$var$now(),
            frameRate: 0
        };
        this.func = func;
        this.setLayers(layers);
    }
    setLayers(layers) {
        var lays = [];
        if (!layers) lays = [];
        else if (layers.length > 0) lays = layers;
        else lays = [
            layers
        ];
        this.layers = lays;
        return this;
    }
    getLayers() {
        return this.layers;
    }
    addLayer(layer) {
        var layers = this.layers, len = layers.length, n;
        for(n = 0; n < len; n++){
            if (layers[n]._id === layer._id) return false;
        }
        this.layers.push(layer);
        return true;
    }
    isRunning() {
        var a = $7bf318e9b40f0603$var$Animation, animations = a.animations, len = animations.length, n;
        for(n = 0; n < len; n++){
            if (animations[n].id === this.id) return true;
        }
        return false;
    }
    start() {
        this.stop();
        this.frame.timeDiff = 0;
        this.frame.lastTime = $7bf318e9b40f0603$var$now();
        $7bf318e9b40f0603$var$Animation._addAnimation(this);
        return this;
    }
    stop() {
        $7bf318e9b40f0603$var$Animation._removeAnimation(this);
        return this;
    }
    _updateFrameObject(time) {
        this.frame.timeDiff = time - this.frame.lastTime;
        this.frame.lastTime = time;
        this.frame.time += this.frame.timeDiff;
        this.frame.frameRate = 1000 / this.frame.timeDiff;
    }
    static _addAnimation(anim) {
        this.animations.push(anim);
        this._handleAnimation();
    }
    static _removeAnimation(anim) {
        var id = anim.id, animations = this.animations, len = animations.length, n;
        for(n = 0; n < len; n++)if (animations[n].id === id) {
            this.animations.splice(n, 1);
            break;
        }
    }
    static _runFrames() {
        var layerHash = {}, animations = this.animations, anim, layers, func, n, i, layersLen, layer, key, needRedraw;
        for(n = 0; n < animations.length; n++){
            anim = animations[n];
            layers = anim.layers;
            func = anim.func;
            anim._updateFrameObject($7bf318e9b40f0603$var$now());
            layersLen = layers.length;
            if (func) needRedraw = func.call(anim, anim.frame) !== false;
            else needRedraw = true;
            if (!needRedraw) continue;
            for(i = 0; i < layersLen; i++){
                layer = layers[i];
                if (layer._id !== undefined) layerHash[layer._id] = layer;
            }
        }
        for(key in layerHash){
            if (!layerHash.hasOwnProperty(key)) continue;
            layerHash[key].batchDraw();
        }
    }
    static _animationLoop() {
        var Anim = $7bf318e9b40f0603$var$Animation;
        if (Anim.animations.length) {
            Anim._runFrames();
            $f4b7065bbd5eff66$exports.Util.requestAnimFrame(Anim._animationLoop);
        } else Anim.animRunning = false;
    }
    static _handleAnimation() {
        if (!this.animRunning) {
            this.animRunning = true;
            $f4b7065bbd5eff66$exports.Util.requestAnimFrame(this._animationLoop);
        }
    }
}
$7bf318e9b40f0603$var$Animation.animations = [];
$7bf318e9b40f0603$var$Animation.animIdCounter = 0;
$7bf318e9b40f0603$var$Animation.animRunning = false;
$7bf318e9b40f0603$exports.Animation = $7bf318e9b40f0603$var$Animation;


var $e4c921d792eec428$exports = {};
"use strict";
Object.defineProperty($e4c921d792eec428$exports, "__esModule", {
    value: true
});
$e4c921d792eec428$exports.Easings = $e4c921d792eec428$exports.Tween = void 0;




var $e4c921d792eec428$var$blacklist = {
    node: 1,
    duration: 1,
    easing: 1,
    onFinish: 1,
    yoyo: 1
}, $e4c921d792eec428$var$PAUSED = 1, $e4c921d792eec428$var$PLAYING = 2, $e4c921d792eec428$var$REVERSING = 3, $e4c921d792eec428$var$idCounter = 0, $e4c921d792eec428$var$colorAttrs = [
    'fill',
    'stroke',
    'shadowColor'
];
class $e4c921d792eec428$var$TweenEngine {
    constructor(prop, propFunc, func, begin, finish, duration, yoyo){
        this.prop = prop;
        this.propFunc = propFunc;
        this.begin = begin;
        this._pos = begin;
        this.duration = duration;
        this._change = 0;
        this.prevPos = 0;
        this.yoyo = yoyo;
        this._time = 0;
        this._position = 0;
        this._startTime = 0;
        this._finish = 0;
        this.func = func;
        this._change = finish - this.begin;
        this.pause();
    }
    fire(str) {
        var handler = this[str];
        if (handler) handler();
    }
    setTime(t) {
        if (t > this.duration) {
            if (this.yoyo) {
                this._time = this.duration;
                this.reverse();
            } else this.finish();
        } else if (t < 0) {
            if (this.yoyo) {
                this._time = 0;
                this.play();
            } else this.reset();
        } else {
            this._time = t;
            this.update();
        }
    }
    getTime() {
        return this._time;
    }
    setPosition(p) {
        this.prevPos = this._pos;
        this.propFunc(p);
        this._pos = p;
    }
    getPosition(t) {
        if (t === undefined) t = this._time;
        return this.func(t, this.begin, this._change, this.duration);
    }
    play() {
        this.state = $e4c921d792eec428$var$PLAYING;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onPlay');
    }
    reverse() {
        this.state = $e4c921d792eec428$var$REVERSING;
        this._time = this.duration - this._time;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onReverse');
    }
    seek(t) {
        this.pause();
        this._time = t;
        this.update();
        this.fire('onSeek');
    }
    reset() {
        this.pause();
        this._time = 0;
        this.update();
        this.fire('onReset');
    }
    finish() {
        this.pause();
        this._time = this.duration;
        this.update();
        this.fire('onFinish');
    }
    update() {
        this.setPosition(this.getPosition(this._time));
        this.fire('onUpdate');
    }
    onEnterFrame() {
        var t = this.getTimer() - this._startTime;
        if (this.state === $e4c921d792eec428$var$PLAYING) this.setTime(t);
        else if (this.state === $e4c921d792eec428$var$REVERSING) this.setTime(this.duration - t);
    }
    pause() {
        this.state = $e4c921d792eec428$var$PAUSED;
        this.fire('onPause');
    }
    getTimer() {
        return new Date().getTime();
    }
}
class $e4c921d792eec428$var$Tween {
    constructor(config){
        var that = this, node = config.node, nodeId = node._id, duration, easing = config.easing || $e4c921d792eec428$exports.Easings.Linear, yoyo = !!config.yoyo, key;
        if (typeof config.duration === 'undefined') duration = 0.3;
        else if (config.duration === 0) duration = 0.001;
        else duration = config.duration;
        this.node = node;
        this._id = $e4c921d792eec428$var$idCounter++;
        var layers = node.getLayer() || (node instanceof $2aee50cb6c94cb28$exports.Konva['Stage'] ? node.getLayers() : null);
        if (!layers) $f4b7065bbd5eff66$exports.Util.error('Tween constructor have `node` that is not in a layer. Please add node into layer first.');
        this.anim = new $7bf318e9b40f0603$exports.Animation(function() {
            that.tween.onEnterFrame();
        }, layers);
        this.tween = new $e4c921d792eec428$var$TweenEngine(key, function(i) {
            that._tweenFunc(i);
        }, easing, 0, 1, duration * 1000, yoyo);
        this._addListeners();
        if (!$e4c921d792eec428$var$Tween.attrs[nodeId]) $e4c921d792eec428$var$Tween.attrs[nodeId] = {};
        if (!$e4c921d792eec428$var$Tween.attrs[nodeId][this._id]) $e4c921d792eec428$var$Tween.attrs[nodeId][this._id] = {};
        if (!$e4c921d792eec428$var$Tween.tweens[nodeId]) $e4c921d792eec428$var$Tween.tweens[nodeId] = {};
        for(key in config)if ($e4c921d792eec428$var$blacklist[key] === undefined) this._addAttr(key, config[key]);
        this.reset();
        this.onFinish = config.onFinish;
        this.onReset = config.onReset;
        this.onUpdate = config.onUpdate;
    }
    _addAttr(key, end) {
        var node = this.node, nodeId = node._id, start, diff, tweenId, n, len, trueEnd, trueStart, endRGBA;
        tweenId = $e4c921d792eec428$var$Tween.tweens[nodeId][key];
        if (tweenId) delete $e4c921d792eec428$var$Tween.attrs[nodeId][tweenId][key];
        start = node.getAttr(key);
        if ($f4b7065bbd5eff66$exports.Util._isArray(end)) {
            diff = [];
            len = Math.max(end.length, start.length);
            if (key === 'points' && end.length !== start.length) {
                if (end.length > start.length) {
                    trueStart = start;
                    start = $f4b7065bbd5eff66$exports.Util._prepareArrayForTween(start, end, node.closed());
                } else {
                    trueEnd = end;
                    end = $f4b7065bbd5eff66$exports.Util._prepareArrayForTween(end, start, node.closed());
                }
            }
            if (key.indexOf('fill') === 0) {
                for(n = 0; n < len; n++)if (n % 2 === 0) diff.push(end[n] - start[n]);
                else {
                    var startRGBA = $f4b7065bbd5eff66$exports.Util.colorToRGBA(start[n]);
                    endRGBA = $f4b7065bbd5eff66$exports.Util.colorToRGBA(end[n]);
                    start[n] = startRGBA;
                    diff.push({
                        r: endRGBA.r - startRGBA.r,
                        g: endRGBA.g - startRGBA.g,
                        b: endRGBA.b - startRGBA.b,
                        a: endRGBA.a - startRGBA.a
                    });
                }
            } else for(n = 0; n < len; n++)diff.push(end[n] - start[n]);
        } else if ($e4c921d792eec428$var$colorAttrs.indexOf(key) !== -1) {
            start = $f4b7065bbd5eff66$exports.Util.colorToRGBA(start);
            endRGBA = $f4b7065bbd5eff66$exports.Util.colorToRGBA(end);
            diff = {
                r: endRGBA.r - start.r,
                g: endRGBA.g - start.g,
                b: endRGBA.b - start.b,
                a: endRGBA.a - start.a
            };
        } else diff = end - start;
        $e4c921d792eec428$var$Tween.attrs[nodeId][this._id][key] = {
            start: start,
            diff: diff,
            end: end,
            trueEnd: trueEnd,
            trueStart: trueStart
        };
        $e4c921d792eec428$var$Tween.tweens[nodeId][key] = this._id;
    }
    _tweenFunc(i) {
        var node = this.node, attrs = $e4c921d792eec428$var$Tween.attrs[node._id][this._id], key, attr, start, diff, newVal, n, len, end;
        for(key in attrs){
            attr = attrs[key];
            start = attr.start;
            diff = attr.diff;
            end = attr.end;
            if ($f4b7065bbd5eff66$exports.Util._isArray(start)) {
                newVal = [];
                len = Math.max(start.length, end.length);
                if (key.indexOf('fill') === 0) {
                    for(n = 0; n < len; n++)if (n % 2 === 0) newVal.push((start[n] || 0) + diff[n] * i);
                    else newVal.push('rgba(' + Math.round(start[n].r + diff[n].r * i) + ',' + Math.round(start[n].g + diff[n].g * i) + ',' + Math.round(start[n].b + diff[n].b * i) + ',' + (start[n].a + diff[n].a * i) + ')');
                } else for(n = 0; n < len; n++)newVal.push((start[n] || 0) + diff[n] * i);
            } else if ($e4c921d792eec428$var$colorAttrs.indexOf(key) !== -1) newVal = 'rgba(' + Math.round(start.r + diff.r * i) + ',' + Math.round(start.g + diff.g * i) + ',' + Math.round(start.b + diff.b * i) + ',' + (start.a + diff.a * i) + ')';
            else newVal = start + diff * i;
            node.setAttr(key, newVal);
        }
    }
    _addListeners() {
        this.tween.onPlay = ()=>{
            this.anim.start();
        };
        this.tween.onReverse = ()=>{
            this.anim.start();
        };
        this.tween.onPause = ()=>{
            this.anim.stop();
        };
        this.tween.onFinish = ()=>{
            var node = this.node;
            var attrs = $e4c921d792eec428$var$Tween.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueEnd) node.setAttr('points', attrs.points.trueEnd);
            if (this.onFinish) this.onFinish.call(this);
        };
        this.tween.onReset = ()=>{
            var node = this.node;
            var attrs = $e4c921d792eec428$var$Tween.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueStart) node.points(attrs.points.trueStart);
            if (this.onReset) this.onReset();
        };
        this.tween.onUpdate = ()=>{
            if (this.onUpdate) this.onUpdate.call(this);
        };
    }
    play() {
        this.tween.play();
        return this;
    }
    reverse() {
        this.tween.reverse();
        return this;
    }
    reset() {
        this.tween.reset();
        return this;
    }
    seek(t) {
        this.tween.seek(t * 1000);
        return this;
    }
    pause() {
        this.tween.pause();
        return this;
    }
    finish() {
        this.tween.finish();
        return this;
    }
    destroy() {
        var nodeId = this.node._id, thisId = this._id, attrs = $e4c921d792eec428$var$Tween.tweens[nodeId], key;
        this.pause();
        for(key in attrs)delete $e4c921d792eec428$var$Tween.tweens[nodeId][key];
        delete $e4c921d792eec428$var$Tween.attrs[nodeId][thisId];
    }
}
$e4c921d792eec428$var$Tween.attrs = {};
$e4c921d792eec428$var$Tween.tweens = {};
$e4c921d792eec428$exports.Tween = $e4c921d792eec428$var$Tween;
$f5298bb5f7719915$exports.Node.prototype.to = function(params) {
    var onFinish = params.onFinish;
    params.node = this;
    params.onFinish = function() {
        this.destroy();
        if (onFinish) onFinish();
    };
    var tween = new $e4c921d792eec428$var$Tween(params);
    tween.play();
};
$e4c921d792eec428$exports.Easings = {
    BackEaseIn (t, b, c, d) {
        var s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    BackEaseOut (t, b, c, d) {
        var s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    BackEaseInOut (t, b, c, d) {
        var s = 1.70158;
        if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    },
    ElasticEaseIn (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    ElasticEaseOut (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    },
    ElasticEaseInOut (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d / 2) === 2) return b + c;
        if (!p) p = d * (0.3 * 1.5);
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
    },
    BounceEaseOut (t, b, c, d) {
        if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
        else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
        else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
        else return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    },
    BounceEaseIn (t, b, c, d) {
        return c - $e4c921d792eec428$exports.Easings.BounceEaseOut(d - t, 0, c, d) + b;
    },
    BounceEaseInOut (t, b, c, d) {
        if (t < d / 2) return $e4c921d792eec428$exports.Easings.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
        else return $e4c921d792eec428$exports.Easings.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
    },
    EaseIn (t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    EaseOut (t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    EaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b;
        return -c / 2 * (--t * (t - 2) - 1) + b;
    },
    StrongEaseIn (t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    },
    StrongEaseOut (t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    StrongEaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    },
    Linear (t, b, c, d) {
        return c * t / d + b;
    }
};




$748e96e4fda143cd$exports.Konva = $f4b7065bbd5eff66$exports.Util._assign($2aee50cb6c94cb28$exports.Konva, {
    Util: $f4b7065bbd5eff66$exports.Util,
    Transform: $f4b7065bbd5eff66$exports.Transform,
    Node: $f5298bb5f7719915$exports.Node,
    Container: $a98a57b280deff40$exports.Container,
    Stage: $607fbe05cce0d783$exports.Stage,
    stages: $607fbe05cce0d783$exports.stages,
    Layer: $48dd4613a2b4f2df$exports.Layer,
    FastLayer: $23cb2c6573741a54$exports.FastLayer,
    Group: $5055ca4f98315c6f$exports.Group,
    DD: $49b27c4d80a13abe$exports.DD,
    Shape: $1d27e4c6cbd221af$exports.Shape,
    shapes: $1d27e4c6cbd221af$exports.shapes,
    Animation: $7bf318e9b40f0603$exports.Animation,
    Tween: $e4c921d792eec428$exports.Tween,
    Easings: $e4c921d792eec428$exports.Easings,
    Context: $ba5dd10b43d209dd$exports.Context,
    Canvas: $e708bc73165de52e$exports.Canvas
});
$748e96e4fda143cd$exports.default = $748e96e4fda143cd$exports.Konva;


Object.defineProperty($e7665822d65865e0$exports, "Konva", {
    enumerable: true,
    get: function() {
        return $748e96e4fda143cd$exports.Konva;
    }
});

$e7665822d65865e0$exports = $748e96e4fda143cd$exports.Konva;


var $05c6c9399312eddb$exports = {};
/* global module, require */ 
$05c6c9399312eddb$exports = (parcelRequire("9nh0j"));
parcelRequire("e9FyL");
parcelRequire("4p70X");
var $4c4cb74885a67011$exports = {};
/*
 * JavaScript Load Image Fetch
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2017, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */ 
(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) // Register as an anonymous AMD module:
    define([
        './load-image'
    ], factory);
    else if (0, $4c4cb74885a67011$exports) factory((parcelRequire("9nh0j")));
    else // Browser globals:
    factory(window.loadImage);
})(function(loadImage) {
    'use strict';
    var global = loadImage.global;
    if (global.fetch && global.Request && global.Response && global.Response.prototype.blob) loadImage.fetchBlob = function(url, callback, options) {
        /**
       * Fetch response handler.
       *
       * @param {Response} response Fetch response
       * @returns {Blob} Fetched Blob.
       */ function responseHandler(response) {
            return response.blob();
        }
        if (global.Promise && typeof callback !== 'function') return fetch(new Request(url, callback)).then(responseHandler);
        fetch(new Request(url, options)).then(responseHandler).then(callback)[// Avoid parsing error in IE<9, where catch is a reserved word.
        // eslint-disable-next-line dot-notation
        'catch'](function(err) {
            callback(null, err);
        });
    };
    else if (global.XMLHttpRequest && // https://xhr.spec.whatwg.org/#the-responsetype-attribute
    new XMLHttpRequest().responseType === '') loadImage.fetchBlob = function(url, callback, options) {
        /**
       * Promise executor
       *
       * @param {Function} resolve Resolution function
       * @param {Function} reject Rejection function
       */ function executor(resolve, reject) {
            options = options || {} // eslint-disable-line no-param-reassign
            ;
            var req = new XMLHttpRequest();
            req.open(options.method || 'GET', url);
            if (options.headers) Object.keys(options.headers).forEach(function(key) {
                req.setRequestHeader(key, options.headers[key]);
            });
            req.withCredentials = options.credentials === 'include';
            req.responseType = 'blob';
            req.onload = function() {
                resolve(req.response);
            };
            req.onerror = req.onabort = req.ontimeout = function(err) {
                if (resolve === reject) // Not using Promises
                reject(null, err);
                else reject(err);
            };
            req.send(options.body);
        }
        if (global.Promise && typeof callback !== 'function') {
            options = callback // eslint-disable-line no-param-reassign
            ;
            return new Promise(executor);
        }
        return executor(callback, callback);
    };
});


parcelRequire("khOMr");
var $492d7d7987f64138$exports = {};
/*
 * JavaScript Load Image Exif Map
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Exif tags mapping based on
 * https://github.com/jseidelin/exif-js
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */ 

(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) // Register as an anonymous AMD module:
    define([
        './load-image',
        './load-image-exif'
    ], factory);
    else if (0, $492d7d7987f64138$exports) factory((parcelRequire("9nh0j")), (parcelRequire("khOMr")));
    else // Browser globals:
    factory(window.loadImage);
})(function(loadImage) {
    'use strict';
    var ExifMapProto = loadImage.ExifMap.prototype;
    ExifMapProto.tags = {
        // =================
        // TIFF tags (IFD0):
        // =================
        0x0100: 'ImageWidth',
        0x0101: 'ImageHeight',
        0x0102: 'BitsPerSample',
        0x0103: 'Compression',
        0x0106: 'PhotometricInterpretation',
        0x0112: 'Orientation',
        0x0115: 'SamplesPerPixel',
        0x011c: 'PlanarConfiguration',
        0x0212: 'YCbCrSubSampling',
        0x0213: 'YCbCrPositioning',
        0x011a: 'XResolution',
        0x011b: 'YResolution',
        0x0128: 'ResolutionUnit',
        0x0111: 'StripOffsets',
        0x0116: 'RowsPerStrip',
        0x0117: 'StripByteCounts',
        0x0201: 'JPEGInterchangeFormat',
        0x0202: 'JPEGInterchangeFormatLength',
        0x012d: 'TransferFunction',
        0x013e: 'WhitePoint',
        0x013f: 'PrimaryChromaticities',
        0x0211: 'YCbCrCoefficients',
        0x0214: 'ReferenceBlackWhite',
        0x0132: 'DateTime',
        0x010e: 'ImageDescription',
        0x010f: 'Make',
        0x0110: 'Model',
        0x0131: 'Software',
        0x013b: 'Artist',
        0x8298: 'Copyright',
        0x8769: {
            // ExifIFDPointer
            0x9000: 'ExifVersion',
            0xa000: 'FlashpixVersion',
            0xa001: 'ColorSpace',
            0xa002: 'PixelXDimension',
            0xa003: 'PixelYDimension',
            0xa500: 'Gamma',
            0x9101: 'ComponentsConfiguration',
            0x9102: 'CompressedBitsPerPixel',
            0x927c: 'MakerNote',
            0x9286: 'UserComment',
            0xa004: 'RelatedSoundFile',
            0x9003: 'DateTimeOriginal',
            0x9004: 'DateTimeDigitized',
            0x9010: 'OffsetTime',
            0x9011: 'OffsetTimeOriginal',
            0x9012: 'OffsetTimeDigitized',
            0x9290: 'SubSecTime',
            0x9291: 'SubSecTimeOriginal',
            0x9292: 'SubSecTimeDigitized',
            0x829a: 'ExposureTime',
            0x829d: 'FNumber',
            0x8822: 'ExposureProgram',
            0x8824: 'SpectralSensitivity',
            0x8827: 'PhotographicSensitivity',
            0x8828: 'OECF',
            0x8830: 'SensitivityType',
            0x8831: 'StandardOutputSensitivity',
            0x8832: 'RecommendedExposureIndex',
            0x8833: 'ISOSpeed',
            0x8834: 'ISOSpeedLatitudeyyy',
            0x8835: 'ISOSpeedLatitudezzz',
            0x9201: 'ShutterSpeedValue',
            0x9202: 'ApertureValue',
            0x9203: 'BrightnessValue',
            0x9204: 'ExposureBias',
            0x9205: 'MaxApertureValue',
            0x9206: 'SubjectDistance',
            0x9207: 'MeteringMode',
            0x9208: 'LightSource',
            0x9209: 'Flash',
            0x9214: 'SubjectArea',
            0x920a: 'FocalLength',
            0xa20b: 'FlashEnergy',
            0xa20c: 'SpatialFrequencyResponse',
            0xa20e: 'FocalPlaneXResolution',
            0xa20f: 'FocalPlaneYResolution',
            0xa210: 'FocalPlaneResolutionUnit',
            0xa214: 'SubjectLocation',
            0xa215: 'ExposureIndex',
            0xa217: 'SensingMethod',
            0xa300: 'FileSource',
            0xa301: 'SceneType',
            0xa302: 'CFAPattern',
            0xa401: 'CustomRendered',
            0xa402: 'ExposureMode',
            0xa403: 'WhiteBalance',
            0xa404: 'DigitalZoomRatio',
            0xa405: 'FocalLengthIn35mmFilm',
            0xa406: 'SceneCaptureType',
            0xa407: 'GainControl',
            0xa408: 'Contrast',
            0xa409: 'Saturation',
            0xa40a: 'Sharpness',
            0xa40b: 'DeviceSettingDescription',
            0xa40c: 'SubjectDistanceRange',
            0xa420: 'ImageUniqueID',
            0xa430: 'CameraOwnerName',
            0xa431: 'BodySerialNumber',
            0xa432: 'LensSpecification',
            0xa433: 'LensMake',
            0xa434: 'LensModel',
            0xa435: 'LensSerialNumber'
        },
        0x8825: {
            // GPSInfoIFDPointer
            0x0000: 'GPSVersionID',
            0x0001: 'GPSLatitudeRef',
            0x0002: 'GPSLatitude',
            0x0003: 'GPSLongitudeRef',
            0x0004: 'GPSLongitude',
            0x0005: 'GPSAltitudeRef',
            0x0006: 'GPSAltitude',
            0x0007: 'GPSTimeStamp',
            0x0008: 'GPSSatellites',
            0x0009: 'GPSStatus',
            0x000a: 'GPSMeasureMode',
            0x000b: 'GPSDOP',
            0x000c: 'GPSSpeedRef',
            0x000d: 'GPSSpeed',
            0x000e: 'GPSTrackRef',
            0x000f: 'GPSTrack',
            0x0010: 'GPSImgDirectionRef',
            0x0011: 'GPSImgDirection',
            0x0012: 'GPSMapDatum',
            0x0013: 'GPSDestLatitudeRef',
            0x0014: 'GPSDestLatitude',
            0x0015: 'GPSDestLongitudeRef',
            0x0016: 'GPSDestLongitude',
            0x0017: 'GPSDestBearingRef',
            0x0018: 'GPSDestBearing',
            0x0019: 'GPSDestDistanceRef',
            0x001a: 'GPSDestDistance',
            0x001b: 'GPSProcessingMethod',
            0x001c: 'GPSAreaInformation',
            0x001d: 'GPSDateStamp',
            0x001e: 'GPSDifferential',
            0x001f: 'GPSHPositioningError'
        },
        0xa005: {
            // InteroperabilityIFDPointer
            0x0001: 'InteroperabilityIndex'
        }
    };
    // IFD1 directory can contain any IFD0 tags:
    ExifMapProto.tags.ifd1 = ExifMapProto.tags;
    ExifMapProto.stringValues = {
        ExposureProgram: {
            0: 'Undefined',
            1: 'Manual',
            2: 'Normal program',
            3: 'Aperture priority',
            4: 'Shutter priority',
            5: 'Creative program',
            6: 'Action program',
            7: 'Portrait mode',
            8: 'Landscape mode'
        },
        MeteringMode: {
            0: 'Unknown',
            1: 'Average',
            2: 'CenterWeightedAverage',
            3: 'Spot',
            4: 'MultiSpot',
            5: 'Pattern',
            6: 'Partial',
            255: 'Other'
        },
        LightSource: {
            0: 'Unknown',
            1: 'Daylight',
            2: 'Fluorescent',
            3: 'Tungsten (incandescent light)',
            4: 'Flash',
            9: 'Fine weather',
            10: 'Cloudy weather',
            11: 'Shade',
            12: 'Daylight fluorescent (D 5700 - 7100K)',
            13: 'Day white fluorescent (N 4600 - 5400K)',
            14: 'Cool white fluorescent (W 3900 - 4500K)',
            15: 'White fluorescent (WW 3200 - 3700K)',
            17: 'Standard light A',
            18: 'Standard light B',
            19: 'Standard light C',
            20: 'D55',
            21: 'D65',
            22: 'D75',
            23: 'D50',
            24: 'ISO studio tungsten',
            255: 'Other'
        },
        Flash: {
            0x0000: 'Flash did not fire',
            0x0001: 'Flash fired',
            0x0005: 'Strobe return light not detected',
            0x0007: 'Strobe return light detected',
            0x0009: 'Flash fired, compulsory flash mode',
            0x000d: 'Flash fired, compulsory flash mode, return light not detected',
            0x000f: 'Flash fired, compulsory flash mode, return light detected',
            0x0010: 'Flash did not fire, compulsory flash mode',
            0x0018: 'Flash did not fire, auto mode',
            0x0019: 'Flash fired, auto mode',
            0x001d: 'Flash fired, auto mode, return light not detected',
            0x001f: 'Flash fired, auto mode, return light detected',
            0x0020: 'No flash function',
            0x0041: 'Flash fired, red-eye reduction mode',
            0x0045: 'Flash fired, red-eye reduction mode, return light not detected',
            0x0047: 'Flash fired, red-eye reduction mode, return light detected',
            0x0049: 'Flash fired, compulsory flash mode, red-eye reduction mode',
            0x004d: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected',
            0x004f: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light detected',
            0x0059: 'Flash fired, auto mode, red-eye reduction mode',
            0x005d: 'Flash fired, auto mode, return light not detected, red-eye reduction mode',
            0x005f: 'Flash fired, auto mode, return light detected, red-eye reduction mode'
        },
        SensingMethod: {
            1: 'Undefined',
            2: 'One-chip color area sensor',
            3: 'Two-chip color area sensor',
            4: 'Three-chip color area sensor',
            5: 'Color sequential area sensor',
            7: 'Trilinear sensor',
            8: 'Color sequential linear sensor'
        },
        SceneCaptureType: {
            0: 'Standard',
            1: 'Landscape',
            2: 'Portrait',
            3: 'Night scene'
        },
        SceneType: {
            1: 'Directly photographed'
        },
        CustomRendered: {
            0: 'Normal process',
            1: 'Custom process'
        },
        WhiteBalance: {
            0: 'Auto white balance',
            1: 'Manual white balance'
        },
        GainControl: {
            0: 'None',
            1: 'Low gain up',
            2: 'High gain up',
            3: 'Low gain down',
            4: 'High gain down'
        },
        Contrast: {
            0: 'Normal',
            1: 'Soft',
            2: 'Hard'
        },
        Saturation: {
            0: 'Normal',
            1: 'Low saturation',
            2: 'High saturation'
        },
        Sharpness: {
            0: 'Normal',
            1: 'Soft',
            2: 'Hard'
        },
        SubjectDistanceRange: {
            0: 'Unknown',
            1: 'Macro',
            2: 'Close view',
            3: 'Distant view'
        },
        FileSource: {
            3: 'DSC'
        },
        ComponentsConfiguration: {
            0: '',
            1: 'Y',
            2: 'Cb',
            3: 'Cr',
            4: 'R',
            5: 'G',
            6: 'B'
        },
        Orientation: {
            1: 'Original',
            2: 'Horizontal flip',
            3: "Rotate 180\xb0 CCW",
            4: 'Vertical flip',
            5: "Vertical flip + Rotate 90\xb0 CW",
            6: "Rotate 90\xb0 CW",
            7: "Horizontal flip + Rotate 90\xb0 CW",
            8: "Rotate 90\xb0 CCW"
        }
    };
    ExifMapProto.getText = function(name) {
        var value = this.get(name);
        switch(name){
            case 'LightSource':
            case 'Flash':
            case 'MeteringMode':
            case 'ExposureProgram':
            case 'SensingMethod':
            case 'SceneCaptureType':
            case 'SceneType':
            case 'CustomRendered':
            case 'WhiteBalance':
            case 'GainControl':
            case 'Contrast':
            case 'Saturation':
            case 'Sharpness':
            case 'SubjectDistanceRange':
            case 'FileSource':
            case 'Orientation':
                return this.stringValues[name][value];
            case 'ExifVersion':
            case 'FlashpixVersion':
                if (!value) return;
                return String.fromCharCode(value[0], value[1], value[2], value[3]);
            case 'ComponentsConfiguration':
                if (!value) return;
                return this.stringValues[name][value[0]] + this.stringValues[name][value[1]] + this.stringValues[name][value[2]] + this.stringValues[name][value[3]];
            case 'GPSVersionID':
                if (!value) return;
                return value[0] + '.' + value[1] + '.' + value[2] + '.' + value[3];
        }
        return String(value);
    };
    ExifMapProto.getAll = function() {
        var map = {};
        var prop;
        var obj;
        var name;
        for(prop in this)if (Object.prototype.hasOwnProperty.call(this, prop)) {
            obj = this[prop];
            if (obj && obj.getAll) map[this.ifds[prop].name] = obj.getAll();
            else {
                name = this.tags[prop];
                if (name) map[name] = this.getText(name);
            }
        }
        return map;
    };
    ExifMapProto.getName = function(tagCode) {
        var name = this.tags[tagCode];
        if (typeof name === 'object') return this.ifds[tagCode].name;
        return name;
    };
    (function() {
        var tags = ExifMapProto.tags;
        var prop;
        var ifd;
        var subTags;
        // Map the tag names to tags:
        for(prop in tags)if (Object.prototype.hasOwnProperty.call(tags, prop)) {
            ifd = ExifMapProto.ifds[prop];
            if (ifd) {
                subTags = tags[prop];
                for(prop in subTags)if (Object.prototype.hasOwnProperty.call(subTags, prop)) ifd.map[subTags[prop]] = Number(prop);
            } else ExifMapProto.map[tags[prop]] = Number(prop);
        }
    })();
});


parcelRequire("19Rix");
var $b6ac130fe6c82c07$exports = {};
/*
 * JavaScript Load Image IPTC Map
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * Copyright 2018, Dave Bevan
 *
 * IPTC tags mapping based on
 * https://iptc.org/standards/photo-metadata
 * https://exiftool.org/TagNames/IPTC.html
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */ 

(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) // Register as an anonymous AMD module:
    define([
        './load-image',
        './load-image-iptc'
    ], factory);
    else if (0, $b6ac130fe6c82c07$exports) factory((parcelRequire("9nh0j")), (parcelRequire("19Rix")));
    else // Browser globals:
    factory(window.loadImage);
})(function(loadImage) {
    'use strict';
    var IptcMapProto = loadImage.IptcMap.prototype;
    IptcMapProto.tags = {
        0: 'ApplicationRecordVersion',
        3: 'ObjectTypeReference',
        4: 'ObjectAttributeReference',
        5: 'ObjectName',
        7: 'EditStatus',
        8: 'EditorialUpdate',
        10: 'Urgency',
        12: 'SubjectReference',
        15: 'Category',
        20: 'SupplementalCategories',
        22: 'FixtureIdentifier',
        25: 'Keywords',
        26: 'ContentLocationCode',
        27: 'ContentLocationName',
        30: 'ReleaseDate',
        35: 'ReleaseTime',
        37: 'ExpirationDate',
        38: 'ExpirationTime',
        40: 'SpecialInstructions',
        42: 'ActionAdvised',
        45: 'ReferenceService',
        47: 'ReferenceDate',
        50: 'ReferenceNumber',
        55: 'DateCreated',
        60: 'TimeCreated',
        62: 'DigitalCreationDate',
        63: 'DigitalCreationTime',
        65: 'OriginatingProgram',
        70: 'ProgramVersion',
        75: 'ObjectCycle',
        80: 'Byline',
        85: 'BylineTitle',
        90: 'City',
        92: 'Sublocation',
        95: 'State',
        100: 'CountryCode',
        101: 'Country',
        103: 'OriginalTransmissionReference',
        105: 'Headline',
        110: 'Credit',
        115: 'Source',
        116: 'CopyrightNotice',
        118: 'Contact',
        120: 'Caption',
        121: 'LocalCaption',
        122: 'Writer',
        125: 'RasterizedCaption',
        130: 'ImageType',
        131: 'ImageOrientation',
        135: 'LanguageIdentifier',
        150: 'AudioType',
        151: 'AudioSamplingRate',
        152: 'AudioSamplingResolution',
        153: 'AudioDuration',
        154: 'AudioOutcue',
        184: 'JobID',
        185: 'MasterDocumentID',
        186: 'ShortDocumentID',
        187: 'UniqueDocumentID',
        188: 'OwnerID',
        200: 'ObjectPreviewFileFormat',
        201: 'ObjectPreviewFileVersion',
        202: 'ObjectPreviewData',
        221: 'Prefs',
        225: 'ClassifyState',
        228: 'SimilarityIndex',
        230: 'DocumentNotes',
        231: 'DocumentHistory',
        232: 'ExifCameraInfo',
        255: 'CatalogSets'
    };
    IptcMapProto.stringValues = {
        10: {
            0: '0 (reserved)',
            1: '1 (most urgent)',
            2: '2',
            3: '3',
            4: '4',
            5: '5 (normal urgency)',
            6: '6',
            7: '7',
            8: '8 (least urgent)',
            9: '9 (user-defined priority)'
        },
        75: {
            a: 'Morning',
            b: 'Both Morning and Evening',
            p: 'Evening'
        },
        131: {
            L: 'Landscape',
            P: 'Portrait',
            S: 'Square'
        }
    };
    IptcMapProto.getText = function(id) {
        var value = this.get(id);
        var tagCode = this.map[id];
        var stringValue = this.stringValues[tagCode];
        if (stringValue) return stringValue[value];
        return String(value);
    };
    IptcMapProto.getAll = function() {
        var map = {};
        var prop;
        var name;
        for(prop in this)if (Object.prototype.hasOwnProperty.call(this, prop)) {
            name = this.tags[prop];
            if (name) map[name] = this.getText(name);
        }
        return map;
    };
    IptcMapProto.getName = function(tagCode) {
        return this.tags[tagCode];
    };
    (function() {
        var tags = IptcMapProto.tags;
        var map = IptcMapProto.map || {};
        var prop;
        // Map the tag names to tags:
        for(prop in tags)if (Object.prototype.hasOwnProperty.call(tags, prop)) map[tags[prop]] = Number(prop);
    })();
});


var $bd20fd7b7b33f0bd$exports = {};
/*
 * JavaScript Load Image Orientation
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */ /*
Exif orientation values to correctly display the letter F:

    1             2
  ██████        ██████
  ██                ██
  ████            ████
  ██                ██
  ██                ██

    3             4
      ██        ██
      ██        ██
    ████        ████
      ██        ██
  ██████        ██████

    5             6
██████████    ██
██  ██        ██  ██
██            ██████████

    7             8
        ██    ██████████
    ██  ██        ██  ██
██████████            ██

*/ 


(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) // Register as an anonymous AMD module:
    define([
        './load-image',
        './load-image-scale',
        './load-image-meta'
    ], factory);
    else if (0, $bd20fd7b7b33f0bd$exports) factory((parcelRequire("9nh0j")), (parcelRequire("e9FyL")), (parcelRequire("4p70X")));
    else // Browser globals:
    factory(window.loadImage);
})(function(loadImage) {
    'use strict';
    var originalTransform = loadImage.transform;
    var originalRequiresCanvas = loadImage.requiresCanvas;
    var originalRequiresMetaData = loadImage.requiresMetaData;
    var originalTransformCoordinates = loadImage.transformCoordinates;
    var originalGetTransformedOptions = loadImage.getTransformedOptions;
    (function($) {
        // Guard for non-browser environments (e.g. server-side rendering):
        if (!$.global.document) return;
        // black+white 3x2 JPEG, with the following meta information set:
        // - EXIF Orientation: 6 (Rotated 90° CCW)
        // Image data layout (B=black, F=white):
        // BFF
        // BBB
        var testImageURL = "data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAIAAwMBEQACEQEDEQH/xABRAAEAAAAAAAAAAAAAAAAAAAAKEAEBAQADAQEAAAAAAAAAAAAGBQQDCAkCBwEBAAAAAAAAAAAAAAAAAAAAABEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AG8T9NfSMEVMhQvoP3fFiRZ+MTHDifa/95OFSZU5OzRzxkyejv8ciEfhSceSXGjS8eSdLnZc2HDm4M3BxcXwH/9k=";
        var img = document.createElement('img');
        img.onload = function() {
            // Check if the browser supports automatic image orientation:
            $.orientation = img.width === 2 && img.height === 3;
            if ($.orientation) {
                var canvas = $.createCanvas(1, 1, true);
                var ctx = canvas.getContext('2d');
                ctx.drawImage(img, 1, 1, 1, 1, 0, 0, 1, 1);
                // Check if the source image coordinates (sX, sY, sWidth, sHeight) are
                // correctly applied to the auto-orientated image, which should result
                // in a white opaque pixel (e.g. in Safari).
                // Browsers that show a transparent pixel (e.g. Chromium) fail to crop
                // auto-oriented images correctly and require a workaround, e.g.
                // drawing the complete source image to an intermediate canvas first.
                // See https://bugs.chromium.org/p/chromium/issues/detail?id=1074354
                $.orientationCropBug = ctx.getImageData(0, 0, 1, 1).data.toString() !== '255,255,255,255';
            }
        };
        img.src = testImageURL;
    })(loadImage);
    /**
   * Determines if the orientation requires a canvas element.
   *
   * @param {object} [options] Options object
   * @param {boolean} [withMetaData] Is metadata required for orientation
   * @returns {boolean} Returns true if orientation requires canvas/meta
   */ function requiresCanvasOrientation(options, withMetaData) {
        var orientation = options && options.orientation;
        return(// Exif orientation for browsers without automatic image orientation:
        orientation === true && !loadImage.orientation || // Orientation reset for browsers with automatic image orientation:
        orientation === 1 && loadImage.orientation || // Orientation to defined value, requires meta for orientation reset only:
        (!withMetaData || loadImage.orientation) && orientation > 1 && orientation < 9);
    }
    /**
   * Determines if the image requires an orientation change.
   *
   * @param {number} [orientation] Defined orientation value
   * @param {number} [autoOrientation] Auto-orientation based on Exif data
   * @returns {boolean} Returns true if an orientation change is required
   */ function requiresOrientationChange(orientation, autoOrientation) {
        return orientation !== autoOrientation && (orientation === 1 && autoOrientation > 1 && autoOrientation < 9 || orientation > 1 && orientation < 9);
    }
    /**
   * Determines orientation combinations that require a rotation by 180°.
   *
   * The following is a list of combinations that return true:
   *
   * 2 (flip) => 5 (rot90,flip), 7 (rot90,flip), 6 (rot90), 8 (rot90)
   * 4 (flip) => 5 (rot90,flip), 7 (rot90,flip), 6 (rot90), 8 (rot90)
   *
   * 5 (rot90,flip) => 2 (flip), 4 (flip), 6 (rot90), 8 (rot90)
   * 7 (rot90,flip) => 2 (flip), 4 (flip), 6 (rot90), 8 (rot90)
   *
   * 6 (rot90) => 2 (flip), 4 (flip), 5 (rot90,flip), 7 (rot90,flip)
   * 8 (rot90) => 2 (flip), 4 (flip), 5 (rot90,flip), 7 (rot90,flip)
   *
   * @param {number} [orientation] Defined orientation value
   * @param {number} [autoOrientation] Auto-orientation based on Exif data
   * @returns {boolean} Returns true if rotation by 180° is required
   */ function requiresRot180(orientation, autoOrientation) {
        if (autoOrientation > 1 && autoOrientation < 9) switch(orientation){
            case 2:
            case 4:
                return autoOrientation > 4;
            case 5:
            case 7:
                return autoOrientation % 2 === 0;
            case 6:
            case 8:
                return autoOrientation === 2 || autoOrientation === 4 || autoOrientation === 5 || autoOrientation === 7;
        }
        return false;
    }
    // Determines if the target image should be a canvas element:
    loadImage.requiresCanvas = function(options) {
        return requiresCanvasOrientation(options) || originalRequiresCanvas.call(loadImage, options);
    };
    // Determines if metadata should be loaded automatically:
    loadImage.requiresMetaData = function(options) {
        return requiresCanvasOrientation(options, true) || originalRequiresMetaData.call(loadImage, options);
    };
    loadImage.transform = function(img, options, callback, file, data) {
        originalTransform.call(loadImage, img, options, function(img, data) {
            if (data) {
                var autoOrientation = loadImage.orientation && data.exif && data.exif.get('Orientation');
                if (autoOrientation > 4 && autoOrientation < 9) {
                    // Automatic image orientation switched image dimensions
                    var originalWidth = data.originalWidth;
                    var originalHeight = data.originalHeight;
                    data.originalWidth = originalHeight;
                    data.originalHeight = originalWidth;
                }
            }
            callback(img, data);
        }, file, data);
    };
    // Transforms coordinate and dimension options
    // based on the given orientation option:
    loadImage.getTransformedOptions = function(img, opts, data) {
        var options = originalGetTransformedOptions.call(loadImage, img, opts);
        var exifOrientation = data.exif && data.exif.get('Orientation');
        var orientation = options.orientation;
        var autoOrientation = loadImage.orientation && exifOrientation;
        if (orientation === true) orientation = exifOrientation;
        if (!requiresOrientationChange(orientation, autoOrientation)) return options;
        var top = options.top;
        var right = options.right;
        var bottom = options.bottom;
        var left = options.left;
        var newOptions = {};
        for(var i in options)if (Object.prototype.hasOwnProperty.call(options, i)) newOptions[i] = options[i];
        newOptions.orientation = orientation;
        if (orientation > 4 && !(autoOrientation > 4) || orientation < 5 && autoOrientation > 4) {
            // Image dimensions and target dimensions are switched
            newOptions.maxWidth = options.maxHeight;
            newOptions.maxHeight = options.maxWidth;
            newOptions.minWidth = options.minHeight;
            newOptions.minHeight = options.minWidth;
            newOptions.sourceWidth = options.sourceHeight;
            newOptions.sourceHeight = options.sourceWidth;
        }
        if (autoOrientation > 1) {
            // Browsers which correctly apply source image coordinates to
            // auto-oriented images
            switch(autoOrientation){
                case 2:
                    // Horizontal flip
                    right = options.left;
                    left = options.right;
                    break;
                case 3:
                    // 180° Rotate CCW
                    top = options.bottom;
                    right = options.left;
                    bottom = options.top;
                    left = options.right;
                    break;
                case 4:
                    // Vertical flip
                    top = options.bottom;
                    bottom = options.top;
                    break;
                case 5:
                    // Horizontal flip + 90° Rotate CCW
                    top = options.left;
                    right = options.bottom;
                    bottom = options.right;
                    left = options.top;
                    break;
                case 6:
                    // 90° Rotate CCW
                    top = options.left;
                    right = options.top;
                    bottom = options.right;
                    left = options.bottom;
                    break;
                case 7:
                    // Vertical flip + 90° Rotate CCW
                    top = options.right;
                    right = options.top;
                    bottom = options.left;
                    left = options.bottom;
                    break;
                case 8:
                    // 90° Rotate CW
                    top = options.right;
                    right = options.bottom;
                    bottom = options.left;
                    left = options.top;
                    break;
            }
            // Some orientation combinations require additional rotation by 180°:
            if (requiresRot180(orientation, autoOrientation)) {
                var tmpTop = top;
                var tmpRight = right;
                top = bottom;
                right = left;
                bottom = tmpTop;
                left = tmpRight;
            }
        }
        newOptions.top = top;
        newOptions.right = right;
        newOptions.bottom = bottom;
        newOptions.left = left;
        // Account for defined browser orientation:
        switch(orientation){
            case 2:
                // Horizontal flip
                newOptions.right = left;
                newOptions.left = right;
                break;
            case 3:
                // 180° Rotate CCW
                newOptions.top = bottom;
                newOptions.right = left;
                newOptions.bottom = top;
                newOptions.left = right;
                break;
            case 4:
                // Vertical flip
                newOptions.top = bottom;
                newOptions.bottom = top;
                break;
            case 5:
                // Vertical flip + 90° Rotate CW
                newOptions.top = left;
                newOptions.right = bottom;
                newOptions.bottom = right;
                newOptions.left = top;
                break;
            case 6:
                // 90° Rotate CW
                newOptions.top = right;
                newOptions.right = bottom;
                newOptions.bottom = left;
                newOptions.left = top;
                break;
            case 7:
                // Horizontal flip + 90° Rotate CW
                newOptions.top = right;
                newOptions.right = top;
                newOptions.bottom = left;
                newOptions.left = bottom;
                break;
            case 8:
                // 90° Rotate CCW
                newOptions.top = left;
                newOptions.right = top;
                newOptions.bottom = right;
                newOptions.left = bottom;
                break;
        }
        return newOptions;
    };
    // Transform image orientation based on the given EXIF orientation option:
    loadImage.transformCoordinates = function(canvas, options, data) {
        originalTransformCoordinates.call(loadImage, canvas, options, data);
        var orientation = options.orientation;
        var autoOrientation = loadImage.orientation && data.exif && data.exif.get('Orientation');
        if (!requiresOrientationChange(orientation, autoOrientation)) return;
        var ctx = canvas.getContext('2d');
        var width = canvas.width;
        var height = canvas.height;
        var sourceWidth = width;
        var sourceHeight = height;
        if (orientation > 4 && !(autoOrientation > 4) || orientation < 5 && autoOrientation > 4) {
            // Image dimensions and target dimensions are switched
            canvas.width = height;
            canvas.height = width;
        }
        if (orientation > 4) {
            // Destination and source dimensions are switched
            sourceWidth = height;
            sourceHeight = width;
        }
        // Reset automatic browser orientation:
        switch(autoOrientation){
            case 2:
                // Horizontal flip
                ctx.translate(sourceWidth, 0);
                ctx.scale(-1, 1);
                break;
            case 3:
                // 180° Rotate CCW
                ctx.translate(sourceWidth, sourceHeight);
                ctx.rotate(Math.PI);
                break;
            case 4:
                // Vertical flip
                ctx.translate(0, sourceHeight);
                ctx.scale(1, -1);
                break;
            case 5:
                // Horizontal flip + 90° Rotate CCW
                ctx.rotate(-0.5 * Math.PI);
                ctx.scale(-1, 1);
                break;
            case 6:
                // 90° Rotate CCW
                ctx.rotate(-0.5 * Math.PI);
                ctx.translate(-sourceWidth, 0);
                break;
            case 7:
                // Vertical flip + 90° Rotate CCW
                ctx.rotate(-0.5 * Math.PI);
                ctx.translate(-sourceWidth, sourceHeight);
                ctx.scale(1, -1);
                break;
            case 8:
                // 90° Rotate CW
                ctx.rotate(0.5 * Math.PI);
                ctx.translate(0, -sourceHeight);
                break;
        }
        // Some orientation combinations require additional rotation by 180°:
        if (requiresRot180(orientation, autoOrientation)) {
            ctx.translate(sourceWidth, sourceHeight);
            ctx.rotate(Math.PI);
        }
        switch(orientation){
            case 2:
                // Horizontal flip
                ctx.translate(width, 0);
                ctx.scale(-1, 1);
                break;
            case 3:
                // 180° Rotate CCW
                ctx.translate(width, height);
                ctx.rotate(Math.PI);
                break;
            case 4:
                // Vertical flip
                ctx.translate(0, height);
                ctx.scale(1, -1);
                break;
            case 5:
                // Vertical flip + 90° Rotate CW
                ctx.rotate(0.5 * Math.PI);
                ctx.scale(1, -1);
                break;
            case 6:
                // 90° Rotate CW
                ctx.rotate(0.5 * Math.PI);
                ctx.translate(0, -height);
                break;
            case 7:
                // Horizontal flip + 90° Rotate CW
                ctx.rotate(0.5 * Math.PI);
                ctx.translate(width, -height);
                ctx.scale(-1, 1);
                break;
            case 8:
                // 90° Rotate CCW
                ctx.rotate(-0.5 * Math.PI);
                ctx.translate(-width, 0);
                break;
        }
    };
});




var $d839baee7d0bb319$exports = {};
"use strict";
Object.defineProperty($d839baee7d0bb319$exports, "__esModule", {
    value: true
});
$d839baee7d0bb319$exports.Image = void 0;





class $d839baee7d0bb319$var$Image extends $1d27e4c6cbd221af$exports.Shape {
    constructor(attrs){
        super(attrs);
        this.on('imageChange.konva', ()=>{
            this._setImageLoad();
        });
        this._setImageLoad();
    }
    _setImageLoad() {
        const image = this.image();
        if (image && image.complete) return;
        if (image && image.readyState === 4) return;
        if (image && image['addEventListener']) image['addEventListener']('load', ()=>{
            this._requestDraw();
        });
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(true);
    }
    _sceneFunc(context) {
        const width = this.getWidth();
        const height = this.getHeight();
        const cornerRadius = this.cornerRadius();
        const image = this.attrs.image;
        let params;
        if (image) {
            const cropWidth = this.attrs.cropWidth;
            const cropHeight = this.attrs.cropHeight;
            if (cropWidth && cropHeight) params = [
                image,
                this.cropX(),
                this.cropY(),
                cropWidth,
                cropHeight,
                0,
                0,
                width,
                height
            ];
            else params = [
                image,
                0,
                0,
                width,
                height
            ];
        }
        if (this.hasFill() || this.hasStroke() || cornerRadius) {
            context.beginPath();
            cornerRadius ? $f4b7065bbd5eff66$exports.Util.drawRoundedRectPath(context, width, height, cornerRadius) : context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (cornerRadius) context.clip();
            context.drawImage.apply(context, params);
        }
    }
    _hitFunc(context) {
        var width = this.width(), height = this.height(), cornerRadius = this.cornerRadius();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else $f4b7065bbd5eff66$exports.Util.drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        var _a, _b;
        return (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width;
    }
    getHeight() {
        var _a, _b;
        return (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height;
    }
    static fromURL(url, callback, onError = null) {
        var img = $f4b7065bbd5eff66$exports.Util.createImageElement();
        img.onload = function() {
            var image = new $d839baee7d0bb319$var$Image({
                image: img
            });
            callback(image);
        };
        img.onerror = onError;
        img.crossOrigin = 'Anonymous';
        img.src = url;
    }
}
$d839baee7d0bb319$exports.Image = $d839baee7d0bb319$var$Image;
$d839baee7d0bb319$var$Image.prototype.className = 'Image';
(0, $2aee50cb6c94cb28$exports._registerNode)($d839baee7d0bb319$var$Image);
$4831cc45767eb450$exports.Factory.addGetterSetter($d839baee7d0bb319$var$Image, 'cornerRadius', 0, (0, $b21213ef7b53b4df$exports.getNumberOrArrayOfNumbersValidator)(4));
$4831cc45767eb450$exports.Factory.addGetterSetter($d839baee7d0bb319$var$Image, 'image');
$4831cc45767eb450$exports.Factory.addComponentsGetterSetter($d839baee7d0bb319$var$Image, 'crop', [
    'x',
    'y',
    'width',
    'height'
]);
$4831cc45767eb450$exports.Factory.addGetterSetter($d839baee7d0bb319$var$Image, 'cropX', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($d839baee7d0bb319$var$Image, 'cropY', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($d839baee7d0bb319$var$Image, 'cropWidth', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());
$4831cc45767eb450$exports.Factory.addGetterSetter($d839baee7d0bb319$var$Image, 'cropHeight', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());


var $3fef5efc116c51d2$exports = {};
"use strict";
Object.defineProperty($3fef5efc116c51d2$exports, "__esModule", {
    value: true
});
$3fef5efc116c51d2$exports.Circle = void 0;




class $3fef5efc116c51d2$var$Circle extends $1d27e4c6cbd221af$exports.Shape {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        if (this.radius() !== width / 2) this.radius(width / 2);
    }
    setHeight(height) {
        if (this.radius() !== height / 2) this.radius(height / 2);
    }
}
$3fef5efc116c51d2$exports.Circle = $3fef5efc116c51d2$var$Circle;
$3fef5efc116c51d2$var$Circle.prototype._centroid = true;
$3fef5efc116c51d2$var$Circle.prototype.className = 'Circle';
$3fef5efc116c51d2$var$Circle.prototype._attrsAffectingSize = [
    'radius'
];
(0, $2aee50cb6c94cb28$exports._registerNode)($3fef5efc116c51d2$var$Circle);
$4831cc45767eb450$exports.Factory.addGetterSetter($3fef5efc116c51d2$var$Circle, 'radius', 0, (0, $b21213ef7b53b4df$exports.getNumberValidator)());


var $c40c1bbcc3ab05f4$exports = {};
"use strict";
Object.defineProperty($c40c1bbcc3ab05f4$exports, "__esModule", {
    value: true
});
$c40c1bbcc3ab05f4$exports.Rect = void 0;





class $c40c1bbcc3ab05f4$var$Rect extends $1d27e4c6cbd221af$exports.Shape {
    _sceneFunc(context) {
        var cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else $f4b7065bbd5eff66$exports.Util.drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
}
$c40c1bbcc3ab05f4$exports.Rect = $c40c1bbcc3ab05f4$var$Rect;
$c40c1bbcc3ab05f4$var$Rect.prototype.className = 'Rect';
(0, $2aee50cb6c94cb28$exports._registerNode)($c40c1bbcc3ab05f4$var$Rect);
$4831cc45767eb450$exports.Factory.addGetterSetter($c40c1bbcc3ab05f4$var$Rect, 'cornerRadius', 0, (0, $b21213ef7b53b4df$exports.getNumberOrArrayOfNumbersValidator)(4));


var $2b08b1080ef1c407$exports = {};
"use strict";
Object.defineProperty($2b08b1080ef1c407$exports, "__esModule", {
    value: true
});
$2b08b1080ef1c407$exports.Path = void 0;



var $5c557549876211df$exports = {};
"use strict";
Object.defineProperty($5c557549876211df$exports, "__esModule", {
    value: true
});
$5c557549876211df$exports.t2length = $5c557549876211df$exports.getQuadraticArcLength = $5c557549876211df$exports.getCubicArcLength = $5c557549876211df$exports.binomialCoefficients = $5c557549876211df$exports.cValues = $5c557549876211df$exports.tValues = void 0;
$5c557549876211df$exports.tValues = [
    [],
    [],
    [
        -0.5773502691896257,
        0.5773502691896257645091487805019574556476
    ],
    [
        0,
        -0.7745966692414834,
        0.7745966692414833770358530799564799221665
    ],
    [
        -0.33998104358485626,
        0.3399810435848562648026657591032446872005,
        -0.8611363115940526,
        0.8611363115940525752239464888928095050957
    ],
    [
        0,
        -0.5384693101056831,
        0.5384693101056830910363144207002088049672,
        -0.906179845938664,
        0.9061798459386639927976268782993929651256
    ],
    [
        0.6612093864662645136613995950199053470064,
        -0.6612093864662645,
        -0.2386191860831969,
        0.2386191860831969086305017216807119354186,
        -0.932469514203152,
        0.9324695142031520278123015544939946091347
    ],
    [
        0,
        0.4058451513773971669066064120769614633473,
        -0.4058451513773972,
        -0.7415311855993945,
        0.7415311855993944398638647732807884070741,
        -0.9491079123427585,
        0.9491079123427585245261896840478512624007
    ],
    [
        -0.1834346424956498,
        0.1834346424956498049394761423601839806667,
        -0.525532409916329,
        0.5255324099163289858177390491892463490419,
        -0.7966664774136267,
        0.7966664774136267395915539364758304368371,
        -0.9602898564975363,
        0.9602898564975362316835608685694729904282
    ],
    [
        0,
        -0.8360311073266358,
        0.8360311073266357942994297880697348765441,
        -0.9681602395076261,
        0.9681602395076260898355762029036728700494,
        -0.3242534234038089,
        0.3242534234038089290385380146433366085719,
        -0.6133714327005904,
        0.6133714327005903973087020393414741847857
    ],
    [
        -0.14887433898163122,
        0.1488743389816312108848260011297199846175,
        -0.4333953941292472,
        0.4333953941292471907992659431657841622,
        -0.6794095682990244,
        0.6794095682990244062343273651148735757692,
        -0.8650633666889845,
        0.8650633666889845107320966884234930485275,
        -0.9739065285171717,
        0.9739065285171717200779640120844520534282
    ],
    [
        0,
        -0.26954315595234496,
        0.2695431559523449723315319854008615246796,
        -0.5190961292068118,
        0.5190961292068118159257256694586095544802,
        -0.7301520055740494,
        0.7301520055740493240934162520311534580496,
        -0.8870625997680953,
        0.8870625997680952990751577693039272666316,
        -0.978228658146057,
        0.9782286581460569928039380011228573907714
    ],
    [
        -0.1252334085114689,
        0.1252334085114689154724413694638531299833,
        -0.3678314989981802,
        0.3678314989981801937526915366437175612563,
        -0.5873179542866175,
        0.587317954286617447296702418940534280369,
        -0.7699026741943047,
        0.7699026741943046870368938332128180759849,
        -0.9041172563704749,
        0.9041172563704748566784658661190961925375,
        -0.9815606342467192,
        0.9815606342467192506905490901492808229601
    ],
    [
        0,
        -0.2304583159551348,
        0.2304583159551347940655281210979888352115,
        -0.44849275103644687,
        0.4484927510364468528779128521276398678019,
        -0.6423493394403402,
        0.6423493394403402206439846069955156500716,
        -0.8015780907333099,
        0.8015780907333099127942064895828598903056,
        -0.9175983992229779,
        0.9175983992229779652065478365007195123904,
        -0.9841830547185881,
        0.9841830547185881494728294488071096110649
    ],
    [
        -0.10805494870734367,
        0.1080549487073436620662446502198347476119,
        -0.31911236892788974,
        0.3191123689278897604356718241684754668342,
        -0.5152486363581541,
        0.5152486363581540919652907185511886623088,
        -0.6872929048116855,
        0.6872929048116854701480198030193341375384,
        -0.827201315069765,
        0.8272013150697649931897947426503949610397,
        -0.9284348836635735,
        0.928434883663573517336391139377874264477,
        -0.9862838086968123,
        0.986283808696812338841597266704052801676
    ],
    [
        0,
        -0.20119409399743451,
        0.2011940939974345223006283033945962078128,
        -0.3941513470775634,
        0.3941513470775633698972073709810454683627,
        -0.5709721726085388,
        0.5709721726085388475372267372539106412383,
        -0.7244177313601701,
        0.7244177313601700474161860546139380096308,
        -0.8482065834104272,
        0.8482065834104272162006483207742168513662,
        -0.937273392400706,
        0.9372733924007059043077589477102094712439,
        -0.9879925180204854,
        0.9879925180204854284895657185866125811469
    ],
    [
        -0.09501250983763744,
        0.0950125098376374401853193354249580631303,
        -0.2816035507792589,
        0.281603550779258913230460501460496106486,
        -0.45801677765722737,
        0.45801677765722738634241944298357757354,
        -0.6178762444026438,
        0.6178762444026437484466717640487910189918,
        -0.755404408355003,
        0.7554044083550030338951011948474422683538,
        -0.8656312023878318,
        0.8656312023878317438804678977123931323873,
        -0.9445750230732326,
        0.9445750230732325760779884155346083450911,
        -0.9894009349916499,
        0.9894009349916499325961541734503326274262
    ],
    [
        0,
        -0.17848418149584785,
        0.1784841814958478558506774936540655574754,
        -0.3512317634538763,
        0.3512317634538763152971855170953460050405,
        -0.5126905370864769,
        0.5126905370864769678862465686295518745829,
        -0.6576711592166907,
        0.6576711592166907658503022166430023351478,
        -0.7815140038968014,
        0.7815140038968014069252300555204760502239,
        -0.8802391537269859,
        0.8802391537269859021229556944881556926234,
        -0.9506755217687678,
        0.9506755217687677612227169578958030214433,
        -0.9905754753144174,
        0.9905754753144173356754340199406652765077
    ],
    [
        -0.0847750130417353,
        0.0847750130417353012422618529357838117333,
        -0.2518862256915055,
        0.2518862256915055095889728548779112301628,
        -0.41175116146284263,
        0.4117511614628426460359317938330516370789,
        -0.5597708310739475,
        0.5597708310739475346078715485253291369276,
        -0.6916870430603532,
        0.6916870430603532078748910812888483894522,
        -0.8037049589725231,
        0.8037049589725231156824174550145907971032,
        -0.8926024664975557,
        0.8926024664975557392060605911271455154078,
        -0.9558239495713977,
        0.9558239495713977551811958929297763099728,
        -0.9915651684209309,
        0.9915651684209309467300160047061507702525
    ],
    [
        0,
        -0.16035864564022537,
        0.1603586456402253758680961157407435495048,
        -0.31656409996362983,
        0.3165640999636298319901173288498449178922,
        -0.46457074137596094,
        0.4645707413759609457172671481041023679762,
        -0.600545304661681,
        0.6005453046616810234696381649462392798683,
        -0.7209661773352294,
        0.7209661773352293786170958608237816296571,
        -0.8227146565371428,
        0.8227146565371428249789224867127139017745,
        -0.9031559036148179,
        0.9031559036148179016426609285323124878093,
        -0.96020815213483,
        0.960208152134830030852778840687651526615,
        -0.9924068438435844,
        0.9924068438435844031890176702532604935893
    ],
    [
        -0.07652652113349734,
        0.0765265211334973337546404093988382110047,
        -0.22778585114164507,
        0.227785851141645078080496195368574624743,
        -0.37370608871541955,
        0.3737060887154195606725481770249272373957,
        -0.5108670019508271,
        0.5108670019508270980043640509552509984254,
        -0.636053680726515,
        0.6360536807265150254528366962262859367433,
        -0.7463319064601508,
        0.7463319064601507926143050703556415903107,
        -0.8391169718222188,
        0.8391169718222188233945290617015206853296,
        -0.912234428251326,
        0.9122344282513259058677524412032981130491,
        -0.9639719272779138,
        0.963971927277913791267666131197277221912,
        -0.9931285991850949,
        0.9931285991850949247861223884713202782226
    ],
    [
        0,
        -0.1455618541608951,
        0.1455618541608950909370309823386863301163,
        -0.2880213168024011,
        0.288021316802401096600792516064600319909,
        -0.4243421202074388,
        0.4243421202074387835736688885437880520964,
        -0.5516188358872198,
        0.551618835887219807059018796724313286622,
        -0.6671388041974123,
        0.667138804197412319305966669990339162597,
        -0.7684399634756779,
        0.7684399634756779086158778513062280348209,
        -0.8533633645833173,
        0.8533633645833172836472506385875676702761,
        -0.9200993341504008,
        0.9200993341504008287901871337149688941591,
        -0.9672268385663063,
        0.9672268385663062943166222149076951614246,
        -0.9937521706203895,
        0.9937521706203895002602420359379409291933
    ],
    [
        -0.06973927331972223,
        0.0697392733197222212138417961186280818222,
        -0.20786042668822127,
        0.2078604266882212854788465339195457342156,
        -0.34193582089208424,
        0.3419358208920842251581474204273796195591,
        -0.469355837986757,
        0.4693558379867570264063307109664063460953,
        -0.5876404035069116,
        0.5876404035069115929588769276386473488776,
        -0.6944872631866827,
        0.6944872631866827800506898357622567712673,
        -0.7878168059792081,
        0.7878168059792081620042779554083515213881,
        -0.8658125777203002,
        0.8658125777203001365364256370193787290847,
        -0.926956772187174,
        0.9269567721871740005206929392590531966353,
        -0.9700604978354287,
        0.9700604978354287271239509867652687108059,
        -0.9942945854823992,
        0.994294585482399292073031421161298980393
    ],
    [
        0,
        -0.1332568242984661,
        0.1332568242984661109317426822417661370104,
        -0.26413568097034495,
        0.264135680970344930533869538283309602979,
        -0.3903010380302908,
        0.390301038030290831421488872880605458578,
        -0.5095014778460075,
        0.5095014778460075496897930478668464305448,
        -0.6196098757636461,
        0.6196098757636461563850973116495956533871,
        -0.7186613631319502,
        0.7186613631319501944616244837486188483299,
        -0.8048884016188399,
        0.8048884016188398921511184069967785579414,
        -0.8767523582704416,
        0.8767523582704416673781568859341456716389,
        -0.9329710868260161,
        0.9329710868260161023491969890384229782357,
        -0.9725424712181152,
        0.9725424712181152319560240768207773751816,
        -0.9947693349975522,
        0.9947693349975521235239257154455743605736
    ],
    [
        -0.06405689286260563,
        0.0640568928626056260850430826247450385909,
        -0.1911188674736163,
        0.1911188674736163091586398207570696318404,
        -0.3150426796961634,
        0.3150426796961633743867932913198102407864,
        -0.4337935076260451,
        0.4337935076260451384870842319133497124524,
        -0.5454214713888396,
        0.5454214713888395356583756172183723700107,
        -0.6480936519369755,
        0.6480936519369755692524957869107476266696,
        -0.7401241915785544,
        0.7401241915785543642438281030999784255232,
        -0.820001985973903,
        0.8200019859739029219539498726697452080761,
        -0.8864155270044011,
        0.8864155270044010342131543419821967550873,
        -0.9382745520027328,
        0.9382745520027327585236490017087214496548,
        -0.9747285559713095,
        0.9747285559713094981983919930081690617411,
        -0.9951872199970213,
        0.9951872199970213601799974097007368118745
    ]
];
$5c557549876211df$exports.cValues = [
    [],
    [],
    [
        1.0,
        1.0
    ],
    [
        0.8888888888888888888888888888888888888888,
        0.5555555555555555555555555555555555555555,
        0.5555555555555555555555555555555555555555
    ],
    [
        0.6521451548625461426269360507780005927646,
        0.6521451548625461426269360507780005927646,
        0.3478548451374538573730639492219994072353,
        0.3478548451374538573730639492219994072353
    ],
    [
        0.5688888888888888888888888888888888888888,
        0.4786286704993664680412915148356381929122,
        0.4786286704993664680412915148356381929122,
        0.2369268850561890875142640407199173626432,
        0.2369268850561890875142640407199173626432
    ],
    [
        0.3607615730481386075698335138377161116615,
        0.3607615730481386075698335138377161116615,
        0.4679139345726910473898703439895509948116,
        0.4679139345726910473898703439895509948116,
        0.1713244923791703450402961421727328935268,
        0.1713244923791703450402961421727328935268
    ],
    [
        0.4179591836734693877551020408163265306122,
        0.3818300505051189449503697754889751338783,
        0.3818300505051189449503697754889751338783,
        0.2797053914892766679014677714237795824869,
        0.2797053914892766679014677714237795824869,
        0.1294849661688696932706114326790820183285,
        0.1294849661688696932706114326790820183285
    ],
    [
        0.3626837833783619829651504492771956121941,
        0.3626837833783619829651504492771956121941,
        0.3137066458778872873379622019866013132603,
        0.3137066458778872873379622019866013132603,
        0.2223810344533744705443559944262408844301,
        0.2223810344533744705443559944262408844301,
        0.1012285362903762591525313543099621901153,
        0.1012285362903762591525313543099621901153
    ],
    [
        0.3302393550012597631645250692869740488788,
        0.1806481606948574040584720312429128095143,
        0.1806481606948574040584720312429128095143,
        0.0812743883615744119718921581105236506756,
        0.0812743883615744119718921581105236506756,
        0.3123470770400028400686304065844436655987,
        0.3123470770400028400686304065844436655987,
        0.2606106964029354623187428694186328497718,
        0.2606106964029354623187428694186328497718
    ],
    [
        0.295524224714752870173892994651338329421,
        0.295524224714752870173892994651338329421,
        0.2692667193099963550912269215694693528597,
        0.2692667193099963550912269215694693528597,
        0.2190863625159820439955349342281631924587,
        0.2190863625159820439955349342281631924587,
        0.1494513491505805931457763396576973324025,
        0.1494513491505805931457763396576973324025,
        0.0666713443086881375935688098933317928578,
        0.0666713443086881375935688098933317928578
    ],
    [
        0.272925086777900630714483528336342189156,
        0.2628045445102466621806888698905091953727,
        0.2628045445102466621806888698905091953727,
        0.2331937645919904799185237048431751394317,
        0.2331937645919904799185237048431751394317,
        0.1862902109277342514260976414316558916912,
        0.1862902109277342514260976414316558916912,
        0.1255803694649046246346942992239401001976,
        0.1255803694649046246346942992239401001976,
        0.0556685671161736664827537204425485787285,
        0.0556685671161736664827537204425485787285
    ],
    [
        0.2491470458134027850005624360429512108304,
        0.2491470458134027850005624360429512108304,
        0.2334925365383548087608498989248780562594,
        0.2334925365383548087608498989248780562594,
        0.2031674267230659217490644558097983765065,
        0.2031674267230659217490644558097983765065,
        0.160078328543346226334652529543359071872,
        0.160078328543346226334652529543359071872,
        0.1069393259953184309602547181939962242145,
        0.1069393259953184309602547181939962242145,
        0.047175336386511827194615961485017060317,
        0.047175336386511827194615961485017060317
    ],
    [
        0.2325515532308739101945895152688359481566,
        0.2262831802628972384120901860397766184347,
        0.2262831802628972384120901860397766184347,
        0.2078160475368885023125232193060527633865,
        0.2078160475368885023125232193060527633865,
        0.1781459807619457382800466919960979955128,
        0.1781459807619457382800466919960979955128,
        0.1388735102197872384636017768688714676218,
        0.1388735102197872384636017768688714676218,
        0.0921214998377284479144217759537971209236,
        0.0921214998377284479144217759537971209236,
        0.0404840047653158795200215922009860600419,
        0.0404840047653158795200215922009860600419
    ],
    [
        0.2152638534631577901958764433162600352749,
        0.2152638534631577901958764433162600352749,
        0.2051984637212956039659240656612180557103,
        0.2051984637212956039659240656612180557103,
        0.1855383974779378137417165901251570362489,
        0.1855383974779378137417165901251570362489,
        0.1572031671581935345696019386238421566056,
        0.1572031671581935345696019386238421566056,
        0.1215185706879031846894148090724766259566,
        0.1215185706879031846894148090724766259566,
        0.0801580871597602098056332770628543095836,
        0.0801580871597602098056332770628543095836,
        0.0351194603317518630318328761381917806197,
        0.0351194603317518630318328761381917806197
    ],
    [
        0.2025782419255612728806201999675193148386,
        0.1984314853271115764561183264438393248186,
        0.1984314853271115764561183264438393248186,
        0.1861610000155622110268005618664228245062,
        0.1861610000155622110268005618664228245062,
        0.1662692058169939335532008604812088111309,
        0.1662692058169939335532008604812088111309,
        0.1395706779261543144478047945110283225208,
        0.1395706779261543144478047945110283225208,
        0.1071592204671719350118695466858693034155,
        0.1071592204671719350118695466858693034155,
        0.0703660474881081247092674164506673384667,
        0.0703660474881081247092674164506673384667,
        0.0307532419961172683546283935772044177217,
        0.0307532419961172683546283935772044177217
    ],
    [
        0.1894506104550684962853967232082831051469,
        0.1894506104550684962853967232082831051469,
        0.1826034150449235888667636679692199393835,
        0.1826034150449235888667636679692199393835,
        0.1691565193950025381893120790303599622116,
        0.1691565193950025381893120790303599622116,
        0.1495959888165767320815017305474785489704,
        0.1495959888165767320815017305474785489704,
        0.1246289712555338720524762821920164201448,
        0.1246289712555338720524762821920164201448,
        0.0951585116824927848099251076022462263552,
        0.0951585116824927848099251076022462263552,
        0.0622535239386478928628438369943776942749,
        0.0622535239386478928628438369943776942749,
        0.0271524594117540948517805724560181035122,
        0.0271524594117540948517805724560181035122
    ],
    [
        0.1794464703562065254582656442618856214487,
        0.1765627053669926463252709901131972391509,
        0.1765627053669926463252709901131972391509,
        0.1680041021564500445099706637883231550211,
        0.1680041021564500445099706637883231550211,
        0.1540457610768102880814315948019586119404,
        0.1540457610768102880814315948019586119404,
        0.1351363684685254732863199817023501973721,
        0.1351363684685254732863199817023501973721,
        0.1118838471934039710947883856263559267358,
        0.1118838471934039710947883856263559267358,
        0.0850361483171791808835353701910620738504,
        0.0850361483171791808835353701910620738504,
        0.0554595293739872011294401653582446605128,
        0.0554595293739872011294401653582446605128,
        0.0241483028685479319601100262875653246916,
        0.0241483028685479319601100262875653246916
    ],
    [
        0.1691423829631435918406564701349866103341,
        0.1691423829631435918406564701349866103341,
        0.1642764837458327229860537764659275904123,
        0.1642764837458327229860537764659275904123,
        0.1546846751262652449254180038363747721932,
        0.1546846751262652449254180038363747721932,
        0.1406429146706506512047313037519472280955,
        0.1406429146706506512047313037519472280955,
        0.1225552067114784601845191268002015552281,
        0.1225552067114784601845191268002015552281,
        0.1009420441062871655628139849248346070628,
        0.1009420441062871655628139849248346070628,
        0.0764257302548890565291296776166365256053,
        0.0764257302548890565291296776166365256053,
        0.0497145488949697964533349462026386416808,
        0.0497145488949697964533349462026386416808,
        0.0216160135264833103133427102664524693876,
        0.0216160135264833103133427102664524693876
    ],
    [
        0.1610544498487836959791636253209167350399,
        0.1589688433939543476499564394650472016787,
        0.1589688433939543476499564394650472016787,
        0.152766042065859666778855400897662998461,
        0.152766042065859666778855400897662998461,
        0.1426067021736066117757461094419029724756,
        0.1426067021736066117757461094419029724756,
        0.1287539625393362276755157848568771170558,
        0.1287539625393362276755157848568771170558,
        0.1115666455473339947160239016817659974813,
        0.1115666455473339947160239016817659974813,
        0.0914900216224499994644620941238396526609,
        0.0914900216224499994644620941238396526609,
        0.0690445427376412265807082580060130449618,
        0.0690445427376412265807082580060130449618,
        0.0448142267656996003328381574019942119517,
        0.0448142267656996003328381574019942119517,
        0.0194617882297264770363120414644384357529,
        0.0194617882297264770363120414644384357529
    ],
    [
        0.1527533871307258506980843319550975934919,
        0.1527533871307258506980843319550975934919,
        0.1491729864726037467878287370019694366926,
        0.1491729864726037467878287370019694366926,
        0.1420961093183820513292983250671649330345,
        0.1420961093183820513292983250671649330345,
        0.1316886384491766268984944997481631349161,
        0.1316886384491766268984944997481631349161,
        0.118194531961518417312377377711382287005,
        0.118194531961518417312377377711382287005,
        0.1019301198172404350367501354803498761666,
        0.1019301198172404350367501354803498761666,
        0.0832767415767047487247581432220462061001,
        0.0832767415767047487247581432220462061001,
        0.0626720483341090635695065351870416063516,
        0.0626720483341090635695065351870416063516,
        0.040601429800386941331039952274932109879,
        0.040601429800386941331039952274932109879,
        0.0176140071391521183118619623518528163621,
        0.0176140071391521183118619623518528163621
    ],
    [
        0.1460811336496904271919851476833711882448,
        0.1445244039899700590638271665537525436099,
        0.1445244039899700590638271665537525436099,
        0.1398873947910731547221334238675831108927,
        0.1398873947910731547221334238675831108927,
        0.132268938633337461781052574496775604329,
        0.132268938633337461781052574496775604329,
        0.1218314160537285341953671771257335983563,
        0.1218314160537285341953671771257335983563,
        0.1087972991671483776634745780701056420336,
        0.1087972991671483776634745780701056420336,
        0.0934444234560338615532897411139320884835,
        0.0934444234560338615532897411139320884835,
        0.0761001136283793020170516533001831792261,
        0.0761001136283793020170516533001831792261,
        0.0571344254268572082836358264724479574912,
        0.0571344254268572082836358264724479574912,
        0.0369537897708524937999506682993296661889,
        0.0369537897708524937999506682993296661889,
        0.0160172282577743333242246168584710152658,
        0.0160172282577743333242246168584710152658
    ],
    [
        0.1392518728556319933754102483418099578739,
        0.1392518728556319933754102483418099578739,
        0.1365414983460151713525738312315173965863,
        0.1365414983460151713525738312315173965863,
        0.1311735047870623707329649925303074458757,
        0.1311735047870623707329649925303074458757,
        0.1232523768105124242855609861548144719594,
        0.1232523768105124242855609861548144719594,
        0.1129322960805392183934006074217843191142,
        0.1129322960805392183934006074217843191142,
        0.1004141444428809649320788378305362823508,
        0.1004141444428809649320788378305362823508,
        0.0859416062170677274144436813727028661891,
        0.0859416062170677274144436813727028661891,
        0.0697964684245204880949614189302176573987,
        0.0697964684245204880949614189302176573987,
        0.0522933351526832859403120512732112561121,
        0.0522933351526832859403120512732112561121,
        0.0337749015848141547933022468659129013491,
        0.0337749015848141547933022468659129013491,
        0.0146279952982722006849910980471854451902,
        0.0146279952982722006849910980471854451902
    ],
    [
        0.1336545721861061753514571105458443385831,
        0.132462039404696617371642464703316925805,
        0.132462039404696617371642464703316925805,
        0.1289057221880821499785953393997936532597,
        0.1289057221880821499785953393997936532597,
        0.1230490843067295304675784006720096548158,
        0.1230490843067295304675784006720096548158,
        0.1149966402224113649416435129339613014914,
        0.1149966402224113649416435129339613014914,
        0.1048920914645414100740861850147438548584,
        0.1048920914645414100740861850147438548584,
        0.0929157660600351474770186173697646486034,
        0.0929157660600351474770186173697646486034,
        0.0792814117767189549228925247420432269137,
        0.0792814117767189549228925247420432269137,
        0.0642324214085258521271696151589109980391,
        0.0642324214085258521271696151589109980391,
        0.0480376717310846685716410716320339965612,
        0.0480376717310846685716410716320339965612,
        0.0309880058569794443106942196418845053837,
        0.0309880058569794443106942196418845053837,
        0.0134118594871417720813094934586150649766,
        0.0134118594871417720813094934586150649766
    ],
    [
        0.1279381953467521569740561652246953718517,
        0.1279381953467521569740561652246953718517,
        0.1258374563468282961213753825111836887264,
        0.1258374563468282961213753825111836887264,
        0.121670472927803391204463153476262425607,
        0.121670472927803391204463153476262425607,
        0.1155056680537256013533444839067835598622,
        0.1155056680537256013533444839067835598622,
        0.1074442701159656347825773424466062227946,
        0.1074442701159656347825773424466062227946,
        0.0976186521041138882698806644642471544279,
        0.0976186521041138882698806644642471544279,
        0.086190161531953275917185202983742667185,
        0.086190161531953275917185202983742667185,
        0.0733464814110803057340336152531165181193,
        0.0733464814110803057340336152531165181193,
        0.0592985849154367807463677585001085845412,
        0.0592985849154367807463677585001085845412,
        0.0442774388174198061686027482113382288593,
        0.0442774388174198061686027482113382288593,
        0.0285313886289336631813078159518782864491,
        0.0285313886289336631813078159518782864491,
        0.0123412297999871995468056670700372915759,
        0.0123412297999871995468056670700372915759
    ]
];
$5c557549876211df$exports.binomialCoefficients = [
    [
        1
    ],
    [
        1,
        1
    ],
    [
        1,
        2,
        1
    ],
    [
        1,
        3,
        3,
        1
    ]
];
const $5c557549876211df$var$getCubicArcLength = (xs, ys, t)=>{
    let z;
    let sum;
    let correctedT;
    const n = 20;
    z = t / 2;
    sum = 0;
    for(let i = 0; i < n; i++){
        correctedT = z * $5c557549876211df$exports.tValues[n][i] + z;
        sum += $5c557549876211df$exports.cValues[n][i] * $5c557549876211df$var$BFunc(xs, ys, correctedT);
    }
    return z * sum;
};
$5c557549876211df$exports.getCubicArcLength = $5c557549876211df$var$getCubicArcLength;
const $5c557549876211df$var$getQuadraticArcLength = (xs, ys, t)=>{
    if (t === undefined) t = 1;
    const ax = xs[0] - 2 * xs[1] + xs[2];
    const ay = ys[0] - 2 * ys[1] + ys[2];
    const bx = 2 * xs[1] - 2 * xs[0];
    const by = 2 * ys[1] - 2 * ys[0];
    const A = 4 * (ax * ax + ay * ay);
    const B = 4 * (ax * bx + ay * by);
    const C = bx * bx + by * by;
    if (A === 0) return t * Math.sqrt(Math.pow(xs[2] - xs[0], 2) + Math.pow(ys[2] - ys[0], 2));
    const b = B / (2 * A);
    const c = C / A;
    const u = t + b;
    const k = c - b * b;
    const uuk = u * u + k > 0 ? Math.sqrt(u * u + k) : 0;
    const bbk = b * b + k > 0 ? Math.sqrt(b * b + k) : 0;
    const term = b + Math.sqrt(b * b + k) !== 0 ? k * Math.log(Math.abs((u + uuk) / (b + bbk))) : 0;
    return Math.sqrt(A) / 2 * (u * uuk - b * bbk + term);
};
$5c557549876211df$exports.getQuadraticArcLength = $5c557549876211df$var$getQuadraticArcLength;
function $5c557549876211df$var$BFunc(xs, ys, t) {
    const xbase = $5c557549876211df$var$getDerivative(1, t, xs);
    const ybase = $5c557549876211df$var$getDerivative(1, t, ys);
    const combined = xbase * xbase + ybase * ybase;
    return Math.sqrt(combined);
}
const $5c557549876211df$var$getDerivative = (derivative, t, vs)=>{
    const n = vs.length - 1;
    let _vs;
    let value;
    if (n === 0) return 0;
    if (derivative === 0) {
        value = 0;
        for(let k = 0; k <= n; k++)value += $5c557549876211df$exports.binomialCoefficients[n][k] * Math.pow(1 - t, n - k) * Math.pow(t, k) * vs[k];
        return value;
    } else {
        _vs = new Array(n);
        for(let k = 0; k < n; k++)_vs[k] = n * (vs[k + 1] - vs[k]);
        return $5c557549876211df$var$getDerivative(derivative - 1, t, _vs);
    }
};
const $5c557549876211df$var$t2length = (length, totalLength, func)=>{
    let error = 1;
    let t = length / totalLength;
    let step = (length - func(t)) / totalLength;
    let numIterations = 0;
    while(error > 0.001){
        const increasedTLength = func(t + step);
        const increasedTError = Math.abs(length - increasedTLength) / totalLength;
        if (increasedTError < error) {
            error = increasedTError;
            t += step;
        } else {
            const decreasedTLength = func(t - step);
            const decreasedTError = Math.abs(length - decreasedTLength) / totalLength;
            if (decreasedTError < error) {
                error = decreasedTError;
                t -= step;
            } else step /= 2;
        }
        numIterations++;
        if (numIterations > 500) break;
    }
    return t;
};
$5c557549876211df$exports.t2length = $5c557549876211df$var$t2length;


class $2b08b1080ef1c407$var$Path extends $1d27e4c6cbd221af$exports.Shape {
    constructor(config){
        super(config);
        this.dataArray = [];
        this.pathLength = 0;
        this._readDataAttribute();
        this.on('dataChange.konva', function() {
            this._readDataAttribute();
        });
    }
    _readDataAttribute() {
        this.dataArray = $2b08b1080ef1c407$var$Path.parsePathData(this.data());
        this.pathLength = $2b08b1080ef1c407$var$Path.getPathLength(this.dataArray);
    }
    _sceneFunc(context) {
        var ca = this.dataArray;
        context.beginPath();
        var isClosed = false;
        for(var n = 0; n < ca.length; n++){
            var c = ca[n].command;
            var p = ca[n].points;
            switch(c){
                case 'L':
                    context.lineTo(p[0], p[1]);
                    break;
                case 'M':
                    context.moveTo(p[0], p[1]);
                    break;
                case 'C':
                    context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
                    break;
                case 'Q':
                    context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
                    break;
                case 'A':
                    var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6], fs = p[7];
                    var r = rx > ry ? rx : ry;
                    var scaleX = rx > ry ? 1 : rx / ry;
                    var scaleY = rx > ry ? ry / rx : 1;
                    context.translate(cx, cy);
                    context.rotate(psi);
                    context.scale(scaleX, scaleY);
                    context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
                    context.scale(1 / scaleX, 1 / scaleY);
                    context.rotate(-psi);
                    context.translate(-cx, -cy);
                    break;
                case 'z':
                    isClosed = true;
                    context.closePath();
                    break;
            }
        }
        if (!isClosed && !this.hasFill()) context.strokeShape(this);
        else context.fillStrokeShape(this);
    }
    getSelfRect() {
        var points = [];
        this.dataArray.forEach(function(data) {
            if (data.command === 'A') {
                var start = data.points[4];
                var dTheta = data.points[5];
                var end = data.points[4] + dTheta;
                var inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                if (dTheta < 0) for(let t = start - inc; t > end; t -= inc){
                    const point = $2b08b1080ef1c407$var$Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
                else for(let t = start + inc; t < end; t += inc){
                    const point = $2b08b1080ef1c407$var$Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
            } else if (data.command === 'C') for(let t = 0.0; t <= 1; t += 0.01){
                const point = $2b08b1080ef1c407$var$Path.getPointOnCubicBezier(t, data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]);
                points.push(point.x, point.y);
            }
            else points = points.concat(data.points);
        });
        var minX = points[0];
        var maxX = points[0];
        var minY = points[1];
        var maxY = points[1];
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            if (!isNaN(x)) {
                minX = Math.min(minX, x);
                maxX = Math.max(maxX, x);
            }
            if (!isNaN(y)) {
                minY = Math.min(minY, y);
                maxY = Math.max(maxY, y);
            }
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getLength() {
        return this.pathLength;
    }
    getPointAtLength(length) {
        return $2b08b1080ef1c407$var$Path.getPointAtLengthOfDataArray(length, this.dataArray);
    }
    static getLineLength(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    static getPathLength(dataArray) {
        let pathLength = 0;
        for(var i = 0; i < dataArray.length; ++i)pathLength += dataArray[i].pathLength;
        return pathLength;
    }
    static getPointAtLengthOfDataArray(length, dataArray) {
        var point, i = 0, ii = dataArray.length;
        if (!ii) return null;
        while(i < ii && length > dataArray[i].pathLength){
            length -= dataArray[i].pathLength;
            ++i;
        }
        if (i === ii) {
            point = dataArray[i - 1].points.slice(-2);
            return {
                x: point[0],
                y: point[1]
            };
        }
        if (length < 0.01) {
            point = dataArray[i].points.slice(0, 2);
            return {
                x: point[0],
                y: point[1]
            };
        }
        var cp = dataArray[i];
        var p = cp.points;
        switch(cp.command){
            case 'L':
                return $2b08b1080ef1c407$var$Path.getPointOnLine(length, cp.start.x, cp.start.y, p[0], p[1]);
            case 'C':
                return $2b08b1080ef1c407$var$Path.getPointOnCubicBezier((0, $5c557549876211df$exports.t2length)(length, $2b08b1080ef1c407$var$Path.getPathLength(dataArray), (i)=>{
                    return (0, $5c557549876211df$exports.getCubicArcLength)([
                        cp.start.x,
                        p[0],
                        p[2],
                        p[4]
                    ], [
                        cp.start.y,
                        p[1],
                        p[3],
                        p[5]
                    ], i);
                }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3], p[4], p[5]);
            case 'Q':
                return $2b08b1080ef1c407$var$Path.getPointOnQuadraticBezier((0, $5c557549876211df$exports.t2length)(length, $2b08b1080ef1c407$var$Path.getPathLength(dataArray), (i)=>{
                    return (0, $5c557549876211df$exports.getQuadraticArcLength)([
                        cp.start.x,
                        p[0],
                        p[2]
                    ], [
                        cp.start.y,
                        p[1],
                        p[3]
                    ], i);
                }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3]);
            case 'A':
                var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6];
                theta += dTheta * length / cp.pathLength;
                return $2b08b1080ef1c407$var$Path.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
        }
        return null;
    }
    static getPointOnLine(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
        if (fromX === undefined) fromX = P1x;
        if (fromY === undefined) fromY = P1y;
        var m = (P2y - P1y) / (P2x - P1x + 0.00000001);
        var run = Math.sqrt(dist * dist / (1 + m * m));
        if (P2x < P1x) run *= -1;
        var rise = m * run;
        var pt;
        if (P2x === P1x) pt = {
            x: fromX,
            y: fromY + rise
        };
        else if ((fromY - P1y) / (fromX - P1x + 0.00000001) === m) pt = {
            x: fromX + run,
            y: fromY + rise
        };
        else {
            var ix, iy;
            var len = this.getLineLength(P1x, P1y, P2x, P2y);
            var u = (fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y);
            u = u / (len * len);
            ix = P1x + u * (P2x - P1x);
            iy = P1y + u * (P2y - P1y);
            var pRise = this.getLineLength(fromX, fromY, ix, iy);
            var pRun = Math.sqrt(dist * dist - pRise * pRise);
            run = Math.sqrt(pRun * pRun / (1 + m * m));
            if (P2x < P1x) run *= -1;
            rise = m * run;
            pt = {
                x: ix + run,
                y: iy + rise
            };
        }
        return pt;
    }
    static getPointOnCubicBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
        function CB1(t) {
            return t * t * t;
        }
        function CB2(t) {
            return 3 * t * t * (1 - t);
        }
        function CB3(t) {
            return 3 * t * (1 - t) * (1 - t);
        }
        function CB4(t) {
            return (1 - t) * (1 - t) * (1 - t);
        }
        var x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
        var y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnQuadraticBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y) {
        function QB1(t) {
            return t * t;
        }
        function QB2(t) {
            return 2 * t * (1 - t);
        }
        function QB3(t) {
            return (1 - t) * (1 - t);
        }
        var x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
        var y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
        var cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
        var pt = {
            x: rx * Math.cos(theta),
            y: ry * Math.sin(theta)
        };
        return {
            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
            y: cy + (pt.x * sinPsi + pt.y * cosPsi)
        };
    }
    static parsePathData(data) {
        if (!data) return [];
        var cs = data;
        var cc = [
            'm',
            'M',
            'l',
            'L',
            'v',
            'V',
            'h',
            'H',
            'z',
            'Z',
            'c',
            'C',
            'q',
            'Q',
            't',
            'T',
            's',
            'S',
            'a',
            'A'
        ];
        cs = cs.replace(new RegExp(' ', 'g'), ',');
        for(var n = 0; n < cc.length; n++)cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
        var arr = cs.split('|');
        var ca = [];
        var coords = [];
        var cpx = 0;
        var cpy = 0;
        var re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
        var match;
        for(n = 1; n < arr.length; n++){
            var str = arr[n];
            var c = str.charAt(0);
            str = str.slice(1);
            coords.length = 0;
            while(match = re.exec(str))coords.push(match[0]);
            var p = [];
            for(var j = 0, jlen = coords.length; j < jlen; j++){
                if (coords[j] === '00') {
                    p.push(0, 0);
                    continue;
                }
                var parsed = parseFloat(coords[j]);
                if (!isNaN(parsed)) p.push(parsed);
                else p.push(0);
            }
            while(p.length > 0){
                if (isNaN(p[0])) break;
                var cmd = null;
                var points = [];
                var startX = cpx, startY = cpy;
                var prevCmd, ctlPtx, ctlPty;
                var rx, ry, psi, fa, fs, x1, y1;
                switch(c){
                    case 'l':
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'L':
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'm':
                        var dx = p.shift();
                        var dy = p.shift();
                        cpx += dx;
                        cpy += dy;
                        cmd = 'M';
                        if (ca.length > 2 && ca[ca.length - 1].command === 'z') {
                            for(var idx = ca.length - 2; idx >= 0; idx--)if (ca[idx].command === 'M') {
                                cpx = ca[idx].points[0] + dx;
                                cpy = ca[idx].points[1] + dy;
                                break;
                            }
                        }
                        points.push(cpx, cpy);
                        c = 'l';
                        break;
                    case 'M':
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'M';
                        points.push(cpx, cpy);
                        c = 'L';
                        break;
                    case 'h':
                        cpx += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'H':
                        cpx = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'v':
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'V':
                        cpy = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'C':
                        points.push(p.shift(), p.shift(), p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'c':
                        points.push(cpx + p.shift(), cpy + p.shift(), cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'S':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 's':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'Q':
                        points.push(p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'q':
                        points.push(cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(cpx, cpy);
                        break;
                    case 'T':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 't':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 'A':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                    case 'a':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                }
                ca.push({
                    command: cmd || c,
                    points: points,
                    start: {
                        x: startX,
                        y: startY
                    },
                    pathLength: this.calcLength(startX, startY, cmd || c, points)
                });
            }
            if (c === 'z' || c === 'Z') ca.push({
                command: 'z',
                points: [],
                start: undefined,
                pathLength: 0
            });
        }
        return ca;
    }
    static calcLength(x, y, cmd, points) {
        var len, p1, p2, t;
        var path = $2b08b1080ef1c407$var$Path;
        switch(cmd){
            case 'L':
                return path.getLineLength(x, y, points[0], points[1]);
            case 'C':
                return (0, $5c557549876211df$exports.getCubicArcLength)([
                    x,
                    points[0],
                    points[2],
                    points[4]
                ], [
                    y,
                    points[1],
                    points[3],
                    points[5]
                ], 1);
            case 'Q':
                return (0, $5c557549876211df$exports.getQuadraticArcLength)([
                    x,
                    points[0],
                    points[2]
                ], [
                    y,
                    points[1],
                    points[3]
                ], 1);
            case 'A':
                len = 0.0;
                var start = points[4];
                var dTheta = points[5];
                var end = points[4] + dTheta;
                var inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                p1 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
                if (dTheta < 0) for(t = start - inc; t > end; t -= inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                else for(t = start + inc; t < end; t += inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
                len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                return len;
        }
        return 0;
    }
    static convertEndpointToCenterParameterization(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
        var psi = psiDeg * (Math.PI / 180.0);
        var xp = Math.cos(psi) * (x1 - x2) / 2.0 + Math.sin(psi) * (y1 - y2) / 2.0;
        var yp = -1 * Math.sin(psi) * (x1 - x2) / 2.0 + Math.cos(psi) * (y1 - y2) / 2.0;
        var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
        if (lambda > 1) {
            rx *= Math.sqrt(lambda);
            ry *= Math.sqrt(lambda);
        }
        var f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
        if (fa === fs) f *= -1;
        if (isNaN(f)) f = 0;
        var cxp = f * rx * yp / ry;
        var cyp = f * -ry * xp / rx;
        var cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
        var cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
        var vMag = function(v) {
            return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
        };
        var vRatio = function(u, v) {
            return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
        };
        var vAngle = function(u, v) {
            return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
        };
        var theta = vAngle([
            1,
            0
        ], [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ]);
        var u = [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ];
        var v = [
            (-1 * xp - cxp) / rx,
            (-1 * yp - cyp) / ry
        ];
        var dTheta = vAngle(u, v);
        if (vRatio(u, v) <= -1) dTheta = Math.PI;
        if (vRatio(u, v) >= 1) dTheta = 0;
        if (fs === 0 && dTheta > 0) dTheta = dTheta - 2 * Math.PI;
        if (fs === 1 && dTheta < 0) dTheta = dTheta + 2 * Math.PI;
        return [
            cx,
            cy,
            rx,
            ry,
            theta,
            dTheta,
            psi,
            fs
        ];
    }
}
$2b08b1080ef1c407$exports.Path = $2b08b1080ef1c407$var$Path;
$2b08b1080ef1c407$var$Path.prototype.className = 'Path';
$2b08b1080ef1c407$var$Path.prototype._attrsAffectingSize = [
    'data'
];
(0, $2aee50cb6c94cb28$exports._registerNode)($2b08b1080ef1c407$var$Path);
$4831cc45767eb450$exports.Factory.addGetterSetter($2b08b1080ef1c407$var$Path, 'data');




class $b11aa0bdc027d4ae$var$Avatar extends (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).Component {
    static defaultProps = {
        shadingColor: 'grey',
        shadingOpacity: 0.6,
        cropColor: 'white',
        closeIconColor: 'white',
        lineWidth: 4,
        minCropRadius: 30,
        backgroundColor: 'grey',
        mimeTypes: 'image/jpeg,image/png',
        exportAsSquare: false,
        exportSize: undefined,
        exportMimeType: 'image/png',
        exportQuality: 1.0,
        mobileScaleSpeed: 0.5,
        onClose: ()=>{},
        onCrop: ()=>{},
        onFileLoad: ()=>{},
        onImageLoad: ()=>{},
        onBeforeFileLoad: ()=>{},
        label: 'Choose a file',
        labelStyle: {
            fontSize: '1.25em',
            fontWeight: '700',
            color: 'black',
            display: 'inline-block',
            fontFamily: 'sans-serif',
            cursor: 'pointer'
        },
        borderStyle: {
            border: '2px solid #979797',
            borderStyle: 'dashed',
            borderRadius: '8px',
            textAlign: 'center'
        }
    };
    constructor(props){
        super(props);
        const containerId = this.generateHash('avatar_container');
        const loaderId = this.generateHash('avatar_loader');
        this.onFileLoad = this.onFileLoad.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.state = {
            imgWidth: 0,
            imgHeight: 0,
            scale: 1,
            containerId: containerId,
            loaderId: loaderId,
            lastMouseY: 0,
            showLoader: !(this.props.src || this.props.img)
        };
    }
    get lineWidth() {
        return this.props.lineWidth;
    }
    get containerId() {
        return this.state.containerId;
    }
    get closeIconColor() {
        return this.props.closeIconColor;
    }
    get cropColor() {
        return this.props.cropColor;
    }
    get loaderId() {
        return this.state.loaderId;
    }
    get mimeTypes() {
        return this.props.mimeTypes;
    }
    get backgroundColor() {
        return this.props.backgroundColor;
    }
    get shadingColor() {
        return this.props.shadingColor;
    }
    get shadingOpacity() {
        return this.props.shadingOpacity;
    }
    get mobileScaleSpeed() {
        return this.props.mobileScaleSpeed;
    }
    get cropRadius() {
        return this.state.cropRadius;
    }
    get minCropRadius() {
        return this.props.minCropRadius;
    }
    get scale() {
        return this.state.scale;
    }
    get width() {
        return this.state.imgWidth;
    }
    get halfWidth() {
        return this.state.imgWidth / 2;
    }
    get height() {
        return this.state.imgHeight;
    }
    get halfHeight() {
        return this.state.imgHeight / 2;
    }
    get image() {
        return this.state.image;
    }
    generateHash(prefix) {
        const s4 = ()=>Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        return prefix + '-' + s4() + '-' + s4() + '-' + s4();
    }
    onCloseCallback() {
        this.props.onClose();
    }
    onCropCallback(img) {
        this.props.onCrop(img);
    }
    onFileLoadCallback(file) {
        this.props.onFileLoad(file);
    }
    onBeforeFileLoadCallback(elem) {
        this.props.onBeforeFileLoad(elem);
    }
    onImageLoadCallback(image) {
        this.props.onImageLoad(image);
    }
    componentDidMount() {
        if (this.state.showLoader) return;
        const image = this.props.img || new Image();
        image.crossOrigin = 'Anonymous';
        if (!this.props.img && this.props.src) image.src = this.props.src;
        this.setState({
            image: image
        }, ()=>{
            if (this.image.complete) return this.init();
            this.image.onload = ()=>{
                this.onImageLoadCallback(this.image);
                this.init();
            };
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.src !== this.props.src) this.image.src = this.props.src;
    }
    onFileLoad(e) {
        console.log('Avatar.onFileLoad - e:', e);
        e.preventDefault();
        this.onBeforeFileLoadCallback(e);
        if (!e.target.value) return;
        let file = e.target.files[0];
        this.onFileLoadCallback(file);
        const ref = this;
        console.log('Avatar.onFileLoad - LoadImage');
        (0, (/*@__PURE__*/$parcel$interopDefault($05c6c9399312eddb$exports)))(file, function(image, data) {
            console.log('Avatar.onFileLoad - after LoadImage - image:', image, ', data:', data);
            ref.setState({
                image: image,
                file: file,
                showLoader: false
            }, ()=>{
                ref.init();
            });
        }, {
            meta: true
        });
    }
    onCloseClick() {
        this.setState({
            showLoader: true
        }, ()=>this.onCloseCallback());
    }
    init() {
        console.log('Avatar.init - this.image:', this.image, ', this.props:', this.props);
        const { height: height, minCropRadius: minCropRadius, cropRadius: cropRadius } = this.props;
        const originalWidth = this.image.width;
        const originalHeight = this.image.height;
        const ration = originalHeight / originalWidth;
        const { imageWidth: imageWidth, imageHeight: imageHeight } = this.props;
        let imgHeight;
        let imgWidth;
        if (imageHeight && imageWidth) console.warn('The imageWidth and imageHeight properties can not be set together, using only imageWidth.');
        if (imageHeight && !imageWidth) {
            imgHeight = imageHeight || originalHeight;
            imgWidth = imgHeight / ration;
        } else if (imageWidth) {
            imgWidth = imageWidth;
            imgHeight = imgWidth * ration || originalHeight;
        } else {
            imgHeight = height || originalHeight;
            imgWidth = imgHeight / ration;
        }
        console.log('imgWidth:', imgWidth);
        console.log('imgHeight:', imgHeight);
        const scale = imgHeight / originalHeight;
        console.log('scale:', scale);
        const calculatedRadius = Math.max(minCropRadius, cropRadius || Math.min(imgWidth, imgHeight) / 3);
        console.log('calculatedRadius:', calculatedRadius);
        this.setState({
            imgWidth: imgWidth,
            imgHeight: imgHeight,
            scale: scale,
            cropRadius: calculatedRadius
        }, this.initCanvas);
    }
    initCanvas() {
        const stage = this.initStage();
        const background = this.initBackground();
        const shading = this.initShading();
        const crop = this.initCrop();
        const cropStroke = this.initCropStroke();
        const resize = this.initResize();
        const resizeIcon = this.initResizeIcon();
        const layer = new (0, (/*@__PURE__*/$parcel$interopDefault($e7665822d65865e0$exports))).Layer();
        layer.add(background);
        layer.add(shading);
        layer.add(cropStroke);
        layer.add(crop);
        layer.add(resize);
        layer.add(resizeIcon);
        stage.add(layer);
        const scaledRadius = (scale = 0)=>crop.radius() - scale;
        const isLeftCorner = (scale)=>crop.x() - scaledRadius(scale) < 0;
        const calcLeft = ()=>crop.radius() + 1;
        const isTopCorner = (scale)=>crop.y() - scaledRadius(scale) < 0;
        const calcTop = ()=>crop.radius() + 1;
        const isRightCorner = (scale)=>crop.x() + scaledRadius(scale) > stage.width();
        const calcRight = ()=>stage.width() - crop.radius() - 1;
        const isBottomCorner = (scale)=>crop.y() + scaledRadius(scale) > stage.height();
        const calcBottom = ()=>stage.height() - crop.radius() - 1;
        const isNotOutOfScale = (scale)=>!isLeftCorner(scale) && !isRightCorner(scale) && !isBottomCorner(scale) && !isTopCorner(scale);
        const calcScaleRadius = (scale)=>scaledRadius(scale) >= this.minCropRadius ? scale : crop.radius() - this.minCropRadius;
        const calcResizerX = (x)=>x + crop.radius() * 0.86;
        const calcResizerY = (y)=>y - crop.radius() * 0.5;
        const moveResizer = (x, y)=>{
            resize.x(calcResizerX(x) - 8);
            resize.y(calcResizerY(y) - 8);
            resizeIcon.x(calcResizerX(x) - 8);
            resizeIcon.y(calcResizerY(y) - 10);
        };
        const getPreview = ()=>{
            if (this.props.exportAsSquare) {
                const fullSizeImage = new (0, (/*@__PURE__*/$parcel$interopDefault($e7665822d65865e0$exports))).Image({
                    image: this.image
                });
                const xScale = fullSizeImage.width() / background.width();
                const yScale = fullSizeImage.height() / background.height();
                const width = crop.radius() * 2 * xScale;
                const height = crop.radius() * 2 * yScale;
                const pixelRatio = this.props.exportSize ? this.props.exportSize / width : undefined;
                return fullSizeImage.toDataURL({
                    x: (crop.x() - crop.radius()) * xScale,
                    y: (crop.y() - crop.radius()) * yScale,
                    width: width,
                    height: height,
                    pixelRatio: pixelRatio,
                    mimeType: this.props.exportMimeType,
                    quality: this.props.exportQuality
                });
            } else {
                const width = crop.radius() * 2;
                const height = crop.radius() * 2;
                const pixelRatio = this.props.exportSize ? this.props.exportSize / width : undefined;
                return crop.toDataURL({
                    x: crop.x() - crop.radius(),
                    y: crop.y() - crop.radius(),
                    width: width,
                    height: height,
                    pixelRatio: pixelRatio,
                    mimeType: this.props.exportMimeType,
                    quality: this.props.exportQuality
                });
            }
        };
        const onScaleCallback = (scaleY)=>{
            const scale = scaleY > 0 || isNotOutOfScale(scaleY) ? scaleY : 0;
            cropStroke.radius(cropStroke.radius() - calcScaleRadius(scale));
            crop.radius(crop.radius() - calcScaleRadius(scale));
            resize.fire('resize');
        };
        this.onCropCallback(getPreview());
        crop.on('dragmove', ()=>crop.fire('resize'));
        crop.on('dragend', ()=>this.onCropCallback(getPreview()));
        crop.on('resize', ()=>{
            const x = isLeftCorner() ? calcLeft() : isRightCorner() ? calcRight() : crop.x();
            const y = isTopCorner() ? calcTop() : isBottomCorner() ? calcBottom() : crop.y();
            moveResizer(x, y);
            crop.setFillPatternOffset({
                x: x / this.scale,
                y: y / this.scale
            });
            crop.x(x);
            cropStroke.x(x);
            crop.y(y);
            cropStroke.y(y);
        });
        crop.on('mouseenter', ()=>stage.container().style.cursor = 'move');
        crop.on('mouseleave', ()=>stage.container().style.cursor = 'default');
        crop.on('dragstart', ()=>stage.container().style.cursor = 'move');
        crop.on('dragend', ()=>stage.container().style.cursor = 'default');
        resize.on('touchstart', (evt)=>{
            resize.on('dragmove', (dragEvt)=>{
                if (dragEvt.evt.type !== 'touchmove') return;
                const scaleY = dragEvt.evt.changedTouches['0'].pageY - evt.evt.changedTouches['0'].pageY || 0;
                onScaleCallback(scaleY * this.mobileScaleSpeed);
            });
        });
        resize.on('dragmove', (evt)=>{
            if (evt.evt.type === 'touchmove') return;
            const newMouseY = evt.evt.y;
            const ieScaleFactor = newMouseY ? newMouseY - this.state.lastMouseY : undefined;
            const scaleY = evt.evt.movementY || ieScaleFactor || 0;
            this.setState({
                lastMouseY: newMouseY
            });
            onScaleCallback(scaleY);
        });
        resize.on('dragend', ()=>this.onCropCallback(getPreview()));
        resize.on('resize', ()=>moveResizer(crop.x(), crop.y()));
        resize.on('mouseenter', ()=>stage.container().style.cursor = 'nesw-resize');
        resize.on('mouseleave', ()=>stage.container().style.cursor = 'default');
        resize.on('dragstart', (evt)=>{
            this.setState({
                lastMouseY: evt.evt.y
            });
            stage.container().style.cursor = 'nesw-resize';
        });
        resize.on('dragend', ()=>stage.container().style.cursor = 'default');
    }
    initStage() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($e7665822d65865e0$exports))).Stage({
            container: this.containerId,
            width: this.width,
            height: this.height
        });
    }
    initBackground() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($e7665822d65865e0$exports))).Image({
            x: 0,
            y: 0,
            width: this.width,
            height: this.height,
            image: this.image
        });
    }
    initShading() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($e7665822d65865e0$exports))).Rect({
            x: 0,
            y: 0,
            width: this.width,
            height: this.height,
            fill: this.shadingColor,
            strokeWidth: 4,
            opacity: this.shadingOpacity
        });
    }
    initCrop() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($e7665822d65865e0$exports))).Circle({
            x: this.halfWidth,
            y: this.halfHeight,
            radius: this.cropRadius,
            fillPatternImage: this.image,
            fillPatternOffset: {
                x: this.halfWidth / this.scale,
                y: this.halfHeight / this.scale
            },
            fillPatternScale: {
                x: this.scale,
                y: this.scale
            },
            opacity: 1,
            draggable: true,
            dashEnabled: true,
            dash: [
                10,
                5
            ]
        });
    }
    initCropStroke() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($e7665822d65865e0$exports))).Circle({
            x: this.halfWidth,
            y: this.halfHeight,
            radius: this.cropRadius,
            stroke: this.cropColor,
            strokeWidth: this.lineWidth,
            strokeScaleEnabled: true,
            dashEnabled: true,
            dash: [
                10,
                5
            ]
        });
    }
    initResize() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($e7665822d65865e0$exports))).Rect({
            x: this.halfWidth + this.cropRadius * 0.86 - 8,
            y: this.halfHeight + this.cropRadius * -0.5 - 8,
            width: 16,
            height: 16,
            draggable: true,
            dragBoundFunc: function(pos) {
                return {
                    x: this.getAbsolutePosition().x,
                    y: pos.y
                };
            }
        });
    }
    initResizeIcon() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($e7665822d65865e0$exports))).Path({
            x: this.halfWidth + this.cropRadius * 0.86 - 8,
            y: this.halfHeight + this.cropRadius * -0.5 - 10,
            data: 'M47.624,0.124l12.021,9.73L44.5,24.5l10,10l14.661-15.161l9.963,12.285v-31.5H47.624z M24.5,44.5   L9.847,59.653L0,47.5V79h31.5l-12.153-9.847L34.5,54.5L24.5,44.5z',
            fill: this.cropColor,
            scale: {
                x: 0.2,
                y: 0.2
            }
        });
    }
    render() {
        const { width: width, height: height } = this.props;
        const style = {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: this.backgroundColor,
            width: width || this.width,
            position: 'relative'
        };
        const inputStyle = {
            width: 0.1,
            height: 0.1,
            opacity: 0,
            overflow: 'hidden',
            position: 'absolute',
            zIndex: -1
        };
        const label = this.props.label;
        const labelStyle = {
            ...this.props.labelStyle,
            lineHeight: (height || 200) + 'px'
        };
        const borderStyle = {
            ...this.props.borderStyle,
            width: width || 200,
            height: height || 200
        };
        const closeBtnStyle = {
            position: 'absolute',
            zIndex: 999,
            cursor: 'pointer',
            left: '10px',
            top: '10px'
        };
        return /*#__PURE__*/ (0, $bb3TF.jsx)("div", {
            children: this.state.showLoader ? /*#__PURE__*/ (0, $bb3TF.jsxs)("div", {
                style: borderStyle,
                children: [
                    /*#__PURE__*/ (0, $bb3TF.jsx)("input", {
                        onChange: (e)=>this.onFileLoad(e),
                        name: this.loaderId,
                        type: "file",
                        id: this.loaderId,
                        style: inputStyle,
                        accept: this.mimeTypes
                    }),
                    /*#__PURE__*/ (0, $bb3TF.jsx)("label", {
                        htmlFor: this.loaderId,
                        style: labelStyle,
                        children: label
                    })
                ]
            }) : /*#__PURE__*/ (0, $bb3TF.jsxs)("div", {
                style: style,
                children: [
                    /*#__PURE__*/ (0, $bb3TF.jsx)("svg", {
                        onClick: this.onCloseClick,
                        style: closeBtnStyle,
                        viewBox: "0 0 475.2 475.2",
                        width: "20px",
                        height: "20px",
                        children: /*#__PURE__*/ (0, $bb3TF.jsxs)("g", {
                            children: [
                                /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                                    d: "M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6    s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7    s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7    C468.6,170.8,468.6,304.4,386.5,386.5z",
                                    fill: this.closeIconColor
                                }),
                                /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                                    d: "M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1    l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4    c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z",
                                    fill: this.closeIconColor
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bb3TF.jsx)("div", {
                        id: this.containerId
                    })
                ]
            })
        });
    }
}
var $b11aa0bdc027d4ae$export$2e2bcd8739ae039 = $b11aa0bdc027d4ae$var$Avatar;



var $28707b8ac12a66f0$require$Buffer = $c62b475e31b1e858$export$a143d493d941bafc;
const { UserOutlined: $28707b8ac12a66f0$var$UserOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Title: $28707b8ac12a66f0$var$Title, Paragraph: $28707b8ac12a66f0$var$Paragraph, Text: $28707b8ac12a66f0$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $28707b8ac12a66f0$var$MAX_IMAGE_SIZE = 8388608; // 8MB
const $28707b8ac12a66f0$var$ProfilePhoto = ()=>{
    // Manage photo to be uploaded
    const [preview, setPreview] = (0, $6fFrj.useState)(null);
    const [updatingPhoto, setUpdatingPhoto] = (0, $6fFrj.useState)(false);
    // Handle errors
    const [error, setError] = (0, $6fFrj.useState)(null);
    // Access to user information in the Redux store
    const { id: id, profilePhoto: profilePhoto } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    // Access dispatcher to update profile photo
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    // Mutation hook to update profile photo
    const [updateUserProfilePhoto, { data: data, loading: loading }] = (0, $33beb5b1bfae180c$export$d289fa9f4c70490b)();
    const [getUserProfilePhotoPresignedURL, { loading: presignedUrlLoading }] = (0, $33beb5b1bfae180c$export$3ecc2dddf1160880)();
    const [uploadingToS3, setUploadingToS3] = (0, $6fFrj.useState)(false);
    const onClose = ()=>{
        console.log('ProfilePhoto.onClose');
        setPreview(null);
    };
    const onCrop = (prev)=>{
        console.log('ProfilePhoto.onCrop');
        setPreview(prev);
    };
    const onBeforeFileLoad = (elem)=>{
        const { size: size } = elem.target.files[0];
        console.log('ProfilePhoto.onBeforeFileLoad - size:', size);
        if (size > $28707b8ac12a66f0$var$MAX_IMAGE_SIZE) setError('File to be uploaded is too big. Max image size 8MB.');
    };
    const handleUpdatePhoto = ()=>{
        setError(null);
        setUpdatingPhoto(true);
    };
    const handleCancelFile = ()=>{
        setPreview(null);
        setUpdatingPhoto(false);
    };
    const handleSaveChanges = async ()=>{
        try {
            const presignedUrlData = await getUserProfilePhotoPresignedURL({
                variables: {
                    updateUserInformationInput: {
                        id: id
                    }
                }
            });
            const fileUrl = new URL(presignedUrlData.data.GetUserProfilePhotoPresignedURL);
            setUploadingToS3(true);
            await (0, (/*@__PURE__*/$parcel$interopDefault($18ae57eea10fd4c8$exports))).put(fileUrl.toString(), $28707b8ac12a66f0$require$Buffer.from(preview.split(',')[1], 'base64'), {
                headers: {
                    'Content-Type': 'image/png'
                }
            });
            setUploadingToS3(false);
            await updateUserProfilePhoto({
                variables: {
                    updateUserInformationInput: {
                        id: id,
                        profilePhoto: `${fileUrl.origin}${fileUrl.pathname}`
                    }
                }
            });
            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
                Title: 'Update profile photo',
                Source: 'Button click',
                url: window.location.href
            });
        } catch (e) {
            setUploadingToS3(false);
            console.warn(e);
            setError('Error while trying to upload the photo');
        }
    };
    (0, $6fFrj.useEffect)(()=>{
        if (data) {
            dispatch((0, $e3b9937a336ce5aa$export$a47ec9a39832a0a7)(`${data.updateUserProfilePhoto.profilePhoto}?cacheControl=${Math.trunc(Math.random() * 1e15)}`));
            setUpdatingPhoto(false);
            setPreview(null);
        }
    }, [
        data
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (error) {
            setUpdatingPhoto(false);
            setPreview(null);
        }
    }, [
        error
    ]);
    const isLoading = loading || presignedUrlLoading || uploadingToS3;
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $58c1491b566e843c$export$2e2bcd8739ae039), {
                title: "Profile Photo",
                tooltipTitle: "Why do we need your picture?",
                tooltipContent: (0, $bb3TF.jsx)($28707b8ac12a66f0$var$Paragraph, {
                    children: `Your profile photo adds to your trusted
            brand and will be presented on your client's home page.`
                })
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                className: $f2c2338526651060$export$20d4618f963aa6ef,
                children: (0, $bb3TF.jsx)($28707b8ac12a66f0$var$Text, {
                    small: true,
                    children: "Image type should be jpeg or png. Max image size 8 MB."
                })
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    30,
                    0
                ],
                style: {
                    marginTop: '15px'
                },
                children: [
                    isLoading && (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                        size: "large"
                    }),
                    !isLoading && updatingPhoto ? (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                sm: 24,
                                md: 18,
                                lg: 16,
                                xl: 14,
                                className: $f2c2338526651060$export$a46a71c66786da6d,
                                children: (0, $bb3TF.jsx)("div", {
                                    style: {
                                        cursor: 'pointer'
                                    },
                                    children: (0, $bb3TF.jsx)((0, $b11aa0bdc027d4ae$export$2e2bcd8739ae039), {
                                        width: 380,
                                        imageWidth: 380,
                                        height: 285,
                                        onCrop: onCrop,
                                        onClose: onClose,
                                        onBeforeFileLoad: onBeforeFileLoad,
                                        label: "Click to upload your profile photo",
                                        labelStyle: {
                                            fontSize: '1.25em',
                                            fontWeight: 700,
                                            color: 'black',
                                            display: 'inline-block',
                                            fontFamily: 'sans-serif',
                                            lineHeight: 285,
                                            width: '100%',
                                            cursor: 'pointer'
                                        }
                                    })
                                })
                            }),
                            (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                sm: 24,
                                md: 14,
                                lg: 7,
                                xl: 5,
                                children: [
                                    (0, $bb3TF.jsx)($28707b8ac12a66f0$var$Title, {
                                        level: 4,
                                        style: {
                                            textAlign: 'center'
                                        },
                                        children: "Preview"
                                    }),
                                    (0, $bb3TF.jsx)("div", {
                                        style: {
                                            display: 'flex',
                                            justifyContent: 'center'
                                        },
                                        children: (0, $bb3TF.jsx)((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                                            size: 145,
                                            src: preview,
                                            alt: "Preview",
                                            icon: (0, $bb3TF.jsx)($28707b8ac12a66f0$var$UserOutlined, {})
                                        })
                                    })
                                ]
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: 24,
                                children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                    gutter: [
                                        10,
                                        0
                                    ],
                                    style: {
                                        marginTop: '20px',
                                        marginLeft: '10px'
                                    },
                                    children: [
                                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                            children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                type: "default",
                                                size: "large",
                                                onClick: handleCancelFile,
                                                children: "Cancel"
                                            })
                                        }),
                                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                            children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                type: "primary",
                                                size: "large",
                                                onClick: handleSaveChanges,
                                                disabled: !preview,
                                                children: "Save Changes"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                        children: [
                            (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                sm: 14,
                                md: 11,
                                lg: 8,
                                children: [
                                    (0, $bb3TF.jsx)((0, $1089f078d9068e78$export$2e2bcd8739ae039), {
                                        size: 175,
                                        src: profilePhoto,
                                        alt: "Profile Photo",
                                        icon: (0, $bb3TF.jsx)($28707b8ac12a66f0$var$UserOutlined, {})
                                    }),
                                    (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                        type: "default",
                                        size: "large",
                                        onClick: handleUpdatePhoto,
                                        loading: loading,
                                        className: $f2c2338526651060$export$60576639ab27a08c,
                                        children: "Update Profile Photo"
                                    })
                                ]
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                sm: 14,
                                md: 11,
                                lg: 8,
                                children: error && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                                    style: {
                                        marginTop: 15,
                                        marginBottom: 15
                                    },
                                    type: "warning",
                                    message: error,
                                    description: "Please, try again"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $28707b8ac12a66f0$export$2e2bcd8739ae039 = $28707b8ac12a66f0$var$ProfilePhoto;


var $8ad24cd47a89e017$export$2e2bcd8739ae039 = (0, $28707b8ac12a66f0$export$2e2bcd8739ae039);



var $6fFrj = parcelRequire("6fFrj");

var $bb3TF = parcelRequire("bb3TF");

var $ipnkk = parcelRequire("ipnkk");








const $3b22454bc068a712$var$isCompany = (x)=>x === 'COMPANY';
const $3b22454bc068a712$var$requiredStringForCompany = (requiredMessage)=>$2746dd37f1d91ea1$export$185802fd694ee1f5().when([
        'businessType'
    ], {
        is: $3b22454bc068a712$var$isCompany,
        then: $2746dd37f1d91ea1$export$185802fd694ee1f5().required(requiredMessage)
    });
const $3b22454bc068a712$var$requiredNumberForCompany = (requiredMessage)=>$4b40952b17040dfe$export$185802fd694ee1f5().when([
        'businessType'
    ], {
        is: $3b22454bc068a712$var$isCompany,
        then: $4b40952b17040dfe$export$185802fd694ee1f5().nullable().required(requiredMessage)
    });
const $3b22454bc068a712$export$2959d5e81c412e6d = $ee6ba11cc5736d52$export$185802fd694ee1f5().shape({
    firstName: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('The first name is required'),
    lastName: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('The last name is required'),
    dateOfBirth: $b2e6c69aab0808b6$export$185802fd694ee1f5().required('The date of birth is required'),
    phoneNumber: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('The phone number is required'),
    addressLine1: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('The address is required'),
    addressLine2: $2746dd37f1d91ea1$export$185802fd694ee1f5(),
    city: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('The city is required'),
    state: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('The state is required'),
    zip: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('The ZIP is required'),
    businessType: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('The business type is required'),
    businessName: $2746dd37f1d91ea1$export$185802fd694ee1f5(),
    businessPhone: $3b22454bc068a712$var$requiredStringForCompany('The business phone number is required'),
    businessAddressLine1: $3b22454bc068a712$var$requiredStringForCompany('The business address is required'),
    businessAddressLine2: $2746dd37f1d91ea1$export$185802fd694ee1f5(),
    businessCity: $3b22454bc068a712$var$requiredStringForCompany('The business city is required'),
    businessState: $3b22454bc068a712$var$requiredStringForCompany('The business state is required'),
    businessZip: $3b22454bc068a712$var$requiredStringForCompany('The business ZIP is required'),
    taxReturns: $4b40952b17040dfe$export$185802fd694ee1f5(),
    taxPracticeYears: $4b40952b17040dfe$export$185802fd694ee1f5(),
    tax: $3b22454bc068a712$var$requiredNumberForCompany('The tax is required'),
    accounting: $3b22454bc068a712$var$requiredNumberForCompany('The accounting is required'),
    bookKeeping: $3b22454bc068a712$var$requiredNumberForCompany('The bookkeeping is required'),
    payroll: $3b22454bc068a712$var$requiredNumberForCompany('The payroll is required'),
    taxResolution: $3b22454bc068a712$var$requiredNumberForCompany('The tax resolution is required'),
    other: $3b22454bc068a712$var$requiredNumberForCompany('The other is required')
});
const $3b22454bc068a712$export$d87d20483f96674b = $ee6ba11cc5736d52$export$185802fd694ee1f5().shape({
    dateOfBirth: $b2e6c69aab0808b6$export$185802fd694ee1f5(),
    addressLine2: $2746dd37f1d91ea1$export$185802fd694ee1f5(),
    zip: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('The ZIP is required'),
    city: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('The city is required'),
    state: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('The state is required'),
    lastName: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('Last name is required'),
    firstName: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('First name is required'),
    addressLine1: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('The address is required'),
    businessType: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('Business type is required'),
    phoneNumber: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('The phone number is required')
});
const $3b22454bc068a712$export$7c4fcebc6bcf21e6 = $ee6ba11cc5736d52$export$185802fd694ee1f5().shape({
    dateOfBirth: $b2e6c69aab0808b6$export$185802fd694ee1f5(),
    lastName: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('Last name is required'),
    firstName: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('First name is required'),
    phoneNumber: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('The phone number is required')
});



const $d105fbcf37667062$var$stateOptions = (0, $d795f89fa43cfb57$export$2e2bcd8739ae039).map((state)=>({
        label: state.name,
        value: state.abbreviation
    }));
const $d105fbcf37667062$export$7043120777971352 = ({ tax: tax, zip: zip, city: city, other: other, state: state, payroll: payroll, lastName: lastName, firstName: firstName, accounting: accounting, taxReturns: taxReturns, dateOfBirth: dateOfBirth, phoneNumber: phoneNumber, bookKeeping: bookKeeping, businessZip: businessZip, addressLine1: addressLine1, addressLine2: addressLine2, businessType: businessType, businessName: businessName, businessCity: businessCity, taxResolution: taxResolution, businessPhone: businessPhone, businessState: businessState, taxPracticeYears: taxPracticeYears, businessAddressLine1: businessAddressLine1, businessAddressLine2: businessAddressLine2 })=>[
        {
            span: {
                xs: 12
            },
            required: true,
            key: 'firstName',
            value: firstName,
            inputType: 'text',
            label: 'First name',
            placeHolder: 'First name'
        },
        {
            span: {
                xs: 12
            },
            required: true,
            key: 'lastName',
            value: lastName,
            inputType: 'text',
            label: 'Last Name',
            placeHolder: 'Last Name'
        },
        {
            span: {
                xs: 12
            },
            required: true,
            inputType: 'date',
            value: dateOfBirth,
            key: 'dateOfBirth',
            label: 'Date Of Birth',
            placeHolder: 'Date Of Birth'
        },
        {
            span: {
                xs: 12
            },
            required: true,
            inputType: 'phoneNumber',
            value: phoneNumber,
            key: 'phoneNumber',
            label: 'Phone Number',
            placeHolder: '(XXX) XXX-XXXX'
        },
        {
            span: {
                xs: 12
            },
            required: true,
            key: 'addressLine1',
            value: addressLine1,
            inputType: 'textArea',
            label: 'Address Line 1',
            placeHolder: 'Address Line 1'
        },
        {
            span: {
                xs: 12
            },
            required: false,
            key: 'addressLine2',
            value: addressLine2,
            inputType: 'textArea',
            label: 'Address Line 2',
            placeHolder: 'Address Line 2'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            key: 'city',
            value: city,
            label: 'City',
            required: true,
            inputType: 'text',
            placeHolder: 'City'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            key: 'state',
            value: state,
            label: 'State',
            required: true,
            inputType: 'select',
            options: $d105fbcf37667062$var$stateOptions,
            placeHolder: 'State'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            key: 'zip',
            value: zip,
            required: true,
            inputType: 'text',
            label: 'ZIP/Postal Code',
            placeHolder: 'ZIP/Postal Code'
        },
        {
            span: {
                xs: 24
            },
            required: true,
            key: 'businessType',
            value: businessType,
            inputType: 'radioButton',
            label: 'I am operating as',
            placeHolder: 'I am operating as',
            options: [
                {
                    label: 'An individual tax preparer',
                    value: 'INDIVIDUAL'
                },
                {
                    label: 'A business',
                    value: 'COMPANY'
                }
            ]
        },
        {
            span: {
                xs: 12
            },
            required: false,
            inputType: 'text',
            key: 'businessName',
            value: businessName,
            label: 'Your Business Name',
            placeHolder: 'Your Business Name'
        },
        {
            span: {
                xs: 12
            },
            required: true,
            inputType: 'phoneNumber',
            key: 'businessPhone',
            value: businessPhone,
            label: 'Your Business Phone Number',
            placeHolder: 'Your Business Phone Number'
        },
        {
            span: {
                xs: 12
            },
            required: true,
            inputType: 'textArea',
            label: 'Address Line 1',
            key: 'businessAddressLine1',
            value: businessAddressLine1,
            placeHolder: 'Address Line 1'
        },
        {
            span: {
                xs: 12
            },
            required: false,
            inputType: 'textArea',
            label: 'Address Line 2',
            key: 'businessAddressLine2',
            value: businessAddressLine2,
            placeHolder: 'Address Line 2'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            label: 'City',
            required: true,
            inputType: 'text',
            placeHolder: 'City',
            value: businessCity,
            key: 'businessCity'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            label: 'State',
            required: true,
            inputType: 'select',
            options: $d105fbcf37667062$var$stateOptions,
            value: businessState,
            key: 'businessState',
            placeHolder: 'State'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            required: true,
            inputType: 'text',
            key: 'businessZip',
            value: businessZip,
            label: 'ZIP/Postal Code',
            placeHolder: 'ZIP/Postal Code'
        },
        {
            span: {
                xs: 24
            },
            required: false,
            key: 'taxReturns',
            value: taxReturns,
            inputType: 'number',
            label: 'Number of Tax Returns in the Past Season',
            placeHolder: 'Number of Tax Returns in the Past Season'
        },
        {
            span: {
                xs: 24
            },
            required: false,
            inputType: 'number',
            key: 'taxPracticeYears',
            value: taxPracticeYears,
            label: 'Number of Years in Business',
            placeHolder: 'Number of Years in Business'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            key: 'tax',
            label: 'Tax',
            required: true,
            value: tax ?? 0,
            placeHolder: 'Tax',
            inputType: 'number'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            required: true,
            key: 'accounting',
            inputType: 'number',
            label: 'Accounting',
            value: accounting ?? 0,
            placeHolder: 'Accounting'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            required: true,
            key: 'bookKeeping',
            inputType: 'number',
            label: 'Bookkeeping',
            value: bookKeeping ?? 0,
            placeHolder: 'Bookkeeping'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            key: 'payroll',
            required: true,
            label: 'Payroll',
            inputType: 'number',
            value: payroll ?? 0,
            placeHolder: 'Payroll'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            required: true,
            inputType: 'number',
            key: 'taxResolution',
            label: 'Tax Resolution',
            value: taxResolution ?? 0,
            placeHolder: 'Tax Resolution'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            key: 'other',
            label: 'Other',
            required: true,
            value: other ?? 0,
            inputType: 'number',
            placeHolder: 'Other'
        }
    ];
const $d105fbcf37667062$export$a16362b8aa6cbb7f = ({ zip: zip, city: city, state: state, lastName: lastName, firstName: firstName, dateOfBirth: dateOfBirth, phoneNumber: phoneNumber, addressLine1: addressLine1, addressLine2: addressLine2, businessType: businessType })=>[
        {
            span: {
                xs: 12
            },
            required: true,
            key: 'firstName',
            value: firstName,
            inputType: 'text',
            label: 'First name',
            placeHolder: 'First name'
        },
        {
            span: {
                xs: 12
            },
            required: true,
            key: 'lastName',
            value: lastName,
            inputType: 'text',
            label: 'Last Name',
            placeHolder: 'Last Name'
        },
        {
            span: {
                xs: 12
            },
            required: false,
            inputType: 'date',
            value: dateOfBirth,
            key: 'dateOfBirth',
            label: 'Date Of Birth',
            placeHolder: 'Date Of Birth'
        },
        {
            span: {
                xs: 12
            },
            required: true,
            inputType: 'phoneNumber',
            value: phoneNumber,
            key: 'phoneNumber',
            label: 'Phone Number',
            placeHolder: '(XXX) XXX-XXXX'
        },
        {
            span: {
                xs: 12
            },
            required: true,
            key: 'addressLine1',
            value: addressLine1,
            inputType: 'textArea',
            label: 'Address Line 1',
            placeHolder: 'Address Line 1'
        },
        {
            span: {
                xs: 12
            },
            required: false,
            key: 'addressLine2',
            value: addressLine2,
            inputType: 'textArea',
            label: 'Address Line 2',
            placeHolder: 'Address Line 2'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            key: 'city',
            value: city,
            label: 'City',
            required: true,
            inputType: 'text',
            placeHolder: 'City'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            key: 'state',
            value: state,
            label: 'State',
            required: true,
            inputType: 'text',
            placeHolder: 'State'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            key: 'zip',
            value: zip,
            required: true,
            inputType: 'text',
            label: 'ZIP/Postal Code',
            placeHolder: 'ZIP/Postal Code'
        },
        {
            span: {
                xs: 24
            },
            required: true,
            key: 'businessType',
            value: businessType,
            inputType: 'radioButton',
            label: 'I am operating as',
            placeHolder: 'I am operating as',
            options: [
                {
                    label: 'An individual tax preparer',
                    value: 'INDIVIDUAL'
                },
                {
                    label: 'A business',
                    value: 'COMPANY'
                }
            ]
        }
    ];
const $d105fbcf37667062$export$1ccb5b25c036c745 = ({ firstName: firstName, lastName: lastName, phoneNumber: phoneNumber, dateOfBirth: dateOfBirth, addressLine1: addressLine1, addressLine2: addressLine2, city: city, state: state, zip: zip })=>[
        {
            span: {
                xs: 12
            },
            required: true,
            key: 'firstName',
            value: firstName,
            inputType: 'text',
            label: 'First name',
            placeHolder: 'First name'
        },
        {
            span: {
                xs: 12
            },
            required: true,
            key: 'lastName',
            value: lastName,
            inputType: 'text',
            label: 'Last Name',
            placeHolder: 'Last Name'
        },
        {
            span: {
                xs: 12
            },
            required: false,
            inputType: 'date',
            value: dateOfBirth,
            key: 'dateOfBirth',
            label: 'Date Of Birth',
            placeHolder: 'Date Of Birth'
        },
        {
            span: {
                xs: 12
            },
            required: true,
            inputType: 'phoneNumber',
            value: phoneNumber,
            key: 'phoneNumber',
            label: 'Phone Number',
            placeHolder: '(XXX) XXX-XXXX'
        },
        {
            span: {
                xs: 12
            },
            required: true,
            key: 'addressLine1',
            value: addressLine1,
            inputType: 'textArea',
            label: 'Address Line 1',
            placeHolder: 'Address Line 1'
        },
        {
            span: {
                xs: 12
            },
            required: false,
            key: 'addressLine2',
            value: addressLine2,
            inputType: 'textArea',
            label: 'Address Line 2',
            placeHolder: 'Address Line 2'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            key: 'city',
            value: city,
            label: 'City',
            required: true,
            inputType: 'text',
            placeHolder: 'City'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            key: 'state',
            value: state,
            label: 'State',
            required: true,
            inputType: 'text',
            placeHolder: 'State'
        },
        {
            span: {
                xl: 8,
                md: 12,
                xs: 24
            },
            key: 'zip',
            value: zip,
            required: true,
            inputType: 'text',
            label: 'ZIP/Postal Code',
            placeHolder: 'ZIP/Postal Code'
        }
    ];


const { Paragraph: $1406c3889597a60d$var$Paragraph, Text: $1406c3889597a60d$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
// Initialize all values with zero or an empty string
const $1406c3889597a60d$var$PREPARER_INITIAL_VALUES = {
    tax: 0,
    zip: '',
    city: '',
    other: 0,
    state: '',
    payroll: 0,
    lastName: '',
    firstName: '',
    taxReturns: 0,
    accounting: 0,
    bookKeeping: 0,
    dateOfBirth: '',
    phoneNumber: '',
    businessZip: '',
    addressLine1: '',
    businessType: '',
    addressLine2: '',
    taxResolution: 0,
    businessCity: '',
    businessName: '',
    businessState: '',
    businessPhone: '',
    taxPracticeYears: 0,
    businessAddressLine1: '',
    businessAddressLine2: ''
};
const $1406c3889597a60d$var$STAFF_INITIAL_VALUES = {
    zip: '',
    city: '',
    state: '',
    lastName: '',
    firstName: '',
    dateOfBirth: '',
    phoneNumber: '',
    addressLine1: '',
    addressLine2: ''
};
const $1406c3889597a60d$var$formikRef = /*#__PURE__*/ (0, $6fFrj.createRef)();
const $1406c3889597a60d$var$FirmInfo = ()=>{
    // Get user information from Redux store
    const { userRole: userRole, userInformationId: userInformationId, firmAccountId: firmAccountId } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    // Form Values State
    const [isStaff] = (0, $6fFrj.useState)(userRole === 'STAFF');
    const [isLoading, setIsLoading] = (0, $6fFrj.useState)(false);
    const [hasWarning, setHasWarning] = (0, $6fFrj.useState)(false);
    const [personalPhoneId, setPersonalPhoneId] = (0, $6fFrj.useState)('');
    const [businessPhoneId, setBusinessPhoneId] = (0, $6fFrj.useState)('');
    const [isPreparer] = (0, $6fFrj.useState)(userRole === 'TAX_PREPARER');
    const [personalAddressId, setPersonalAddressId] = (0, $6fFrj.useState)('');
    const [businessAddressId, setBusinessAddressId] = (0, $6fFrj.useState)('');
    const [staffValues, setStaffValues] = (0, $6fFrj.useState)($1406c3889597a60d$var$STAFF_INITIAL_VALUES);
    const [preparerValues, setPreparerValues] = (0, $6fFrj.useState)($1406c3889597a60d$var$PREPARER_INITIAL_VALUES);
    // State to show custom errors
    const [customError, setCustomError] = (0, $6fFrj.useState)(null);
    // Get business info
    const { data: businessInfoData, loading: loadingBusinessInfo } = (0, $732264f53056e08f$export$c65bb1005cf74961)();
    // Create business info
    const [createBusinessInformationMutation] = (0, $33beb5b1bfae180c$export$da7467fe254a46d8)();
    // Update business info
    const [updateBusinessInformationMutation] = (0, $33beb5b1bfae180c$export$28256303d1a07fbc)();
    // Query for getting custom domain
    const { data: data, loading: loadingQuery } = (0, $732264f53056e08f$export$e58c984431e9a06d)({
        variables: {
            id: userInformationId
        }
    });
    // Mutation to update user information
    const [updateUserInformation] = (0, $33beb5b1bfae180c$export$e3e115fc54c52e18)({
        onCompleted: ()=>{
            window.scrollTo(0, 0);
        },
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$73c49c0d19880aef),
                variables: {
                    id: userInformationId
                }
            },
            ...isPreparer && businessInfoData ? [
                {
                    query: (0, $732264f53056e08f$export$fde7a102bea6da56)
                }
            ] : []
        ],
        awaitRefetchQueries: true
    });
    // eslint-disable-next-line
    const [removeBusinessInfo] = (0, $33beb5b1bfae180c$export$9ffbbb21aab6135e)();
    const [updateFirmAccount] = (0, $33beb5b1bfae180c$export$3651467deb80cf0)();
    const { data: firmAccountData } = (0, $732264f53056e08f$export$54402da0a9e269fe)({
        variables: {
            id: firmAccountId
        }
    });
    (0, $6fFrj.useEffect)(()=>{
        if (isPreparer && data && businessInfoData && firmAccountData) {
            const { firstName: firstName, lastName: lastName, birthday: dateOfBirth, Phones: Phones, Address: Addresses } = data.UserInformation;
            const { other: other, taxReturns: taxReturns, taxPercent: tax, Phones: BusinessPhones, payrollPercent: payroll, Address: BusinessAddresses, accountingPercent: accounting, bookKeepingPercent: bookKeeping, yearsInBusiness: taxPracticeYears, taxResolutionPercent: taxResolution } = businessInfoData.BusinessInformation;
            const phone = Phones?.filter(({ type: type })=>type !== 'OFFICE')[0] ?? null;
            const { name: businessName, businessType: businessType } = firmAccountData.FirmAccountById;
            const address = Addresses?.filter(({ type: type })=>type !== 'BUSINESS')[0] ?? null;
            const businessPhone = BusinessPhones?.filter(({ type: type })=>type === 'OFFICE')[0] ?? null;
            const businessAddress = BusinessAddresses?.filter(({ type: type })=>type === 'BUSINESS')[0] ?? null;
            setPreparerValues({
                ...preparerValues,
                tax: tax,
                other: other,
                payroll: payroll,
                lastName: lastName,
                firstName: firstName,
                taxReturns: taxReturns,
                accounting: accounting,
                bookKeeping: bookKeeping,
                businessType: businessType,
                businessName: businessName ?? '',
                taxResolution: taxResolution ?? 0,
                taxPracticeYears: taxPracticeYears,
                ...phone ? {
                    phoneNumber: phone.value
                } : {},
                dateOfBirth: (0, (/*@__PURE__*/$parcel$interopDefault($7b899c8e5076dc5b$exports)))(dateOfBirth),
                ...businessPhone ? {
                    businessPhone: businessPhone.value
                } : {},
                ...address ? {
                    zip: address.zip,
                    city: address.city,
                    state: address.state,
                    addressLine1: address.lineOne,
                    addressLine2: address.lineTwo ?? ''
                } : {},
                ...businessAddress ? {
                    businessZip: businessAddress.zip,
                    businessCity: businessAddress.city,
                    businessState: businessAddress.state,
                    businessAddressLine1: businessAddress.lineOne,
                    businessAddressLine2: businessAddress.lineTwo
                } : {}
            });
            if (phone) setPersonalPhoneId(phone.id);
            if (address) setPersonalAddressId(address.id);
            if (businessPhone) setBusinessPhoneId(businessPhone.id);
            if (businessAddress) setBusinessAddressId(businessAddress.id);
        } else if (isPreparer && data && firmAccountData) {
            const { firstName: firstName, lastName: lastName, birthday: dateOfBirth, Phones: Phones, Address: Addresses } = data.UserInformation;
            const { businessType: businessType } = firmAccountData.FirmAccountById;
            const phone = Phones.filter(({ type: type })=>type !== 'OFFICE')[0] ?? null;
            const address = Addresses.filter(({ type: type })=>type !== 'BUSINESS')[0] ?? null;
            setPreparerValues({
                ...preparerValues,
                lastName: lastName,
                firstName: firstName,
                businessType: businessType,
                ...phone ? {
                    phoneNumber: phone.value
                } : {},
                ...address ? {
                    zip: address.zip,
                    city: address.city,
                    state: address.state,
                    addressLine1: address.lineOne,
                    dateOfBirth: (0, (/*@__PURE__*/$parcel$interopDefault($7b899c8e5076dc5b$exports)))(dateOfBirth),
                    addressLine2: address.lineTwo ?? ''
                } : {}
            });
            if (phone) setPersonalPhoneId(phone.id);
            if (address) setPersonalAddressId(address.id);
        }
        if (isStaff && data) {
            const { firstName: firstName, lastName: lastName, birthday: dateOfBirth, Phones: Phones, Address: Addresses } = data.UserInformation;
            const phone = Phones.filter(({ type: type })=>type !== 'OFFICE')[0] ?? null;
            const address = Addresses.filter(({ type: type })=>type !== 'BUSINESS')[0] ?? null;
            setStaffValues({
                ...staffValues,
                firstName: firstName,
                lastName: lastName,
                dateOfBirth: dateOfBirth,
                ...phone ? {
                    phoneNumber: phone.value
                } : {},
                ...address ? {
                    zip: address.zip,
                    city: address.city,
                    state: address.state,
                    addressLine1: address.lineOne,
                    addressLine2: address.lineTwo
                } : {}
            });
            if (phone) setPersonalPhoneId(phone.id);
            if (address) setPersonalAddressId(address.id);
        }
    }, [
        data,
        businessInfoData,
        firmAccountData
    ]);
    const setPercentage = (tax, accounting, book, payroll, taxR, other)=>{
        const total = (tax || 0) + (accounting || 0) + (book || 0) + (payroll || 0) + (taxR || 0) + (other || 0);
        return total;
    };
    // eslint-disable-next-line
    const submitForm = (values, resetForm)=>{
        if (isPreparer && 'tax' in values) {
            const { tax: tax, zip: zip, city: city, other: other, state: state, payroll: payroll, lastName: lastName, firstName: firstName, accounting: accounting, taxReturns: taxReturns, businessZip: businessZip, bookKeeping: bookKeeping, phoneNumber: phoneNumber, dateOfBirth: dateOfBirth, businessType: businessType, businessName: businessName, businessCity: businessCity, addressLine1: addressLine1, addressLine2: addressLine2, businessState: businessState, taxResolution: taxResolution, businessPhone: businessPhone, taxPracticeYears: taxPracticeYears, businessAddressLine1: businessAddressLine1, businessAddressLine2: businessAddressLine2 } = values;
            const totalPercent = tax + accounting + bookKeeping + payroll + taxResolution + other;
            if (businessType === 'COMPANY' && totalPercent !== 100) setCustomError({
                keys: [
                    'tax',
                    'other',
                    'payroll',
                    'accounting',
                    'bookKeeping',
                    'taxResolution'
                ],
                error: 'Values must add to 100%'
            });
            else {
                // Format business address to use in mutation
                const businessAddress = {
                    zip: businessZip,
                    city: businessCity,
                    state: businessState,
                    id: businessAddressId,
                    lineOne: businessAddressLine1,
                    lineTwo: businessAddressLine2
                };
                // Format business phone to use in mutation
                const businessPhoneNumber = {
                    id: businessPhoneId,
                    value: businessPhone
                };
                // Format personal address to use in mutation
                const personalAddress = {
                    zip: zip,
                    city: city,
                    state: state,
                    lineOne: addressLine1,
                    lineTwo: addressLine2,
                    id: personalAddressId,
                    type: 'PERSONAL'
                };
                // Format personal phone number to use in mutation
                const personalPhoneNumber = {
                    id: personalPhoneId,
                    value: phoneNumber,
                    type: 'PERSONAL'
                };
                setCustomError(null);
                setIsLoading(true);
                Promise.all([
                    updateUserInformation({
                        variables: {
                            updateUserInformationInput: {
                                lastName: lastName,
                                firstName: firstName,
                                id: userInformationId,
                                birthday: dateOfBirth,
                                Phones: [
                                    personalPhoneNumber
                                ],
                                Address: [
                                    {
                                        ...personalAddress
                                    }
                                ]
                            }
                        }
                    }),
                    businessInfoData && businessInfoData.BusinessInformation.id ? [
                        ...businessType !== '' ? [
                            businessType === 'COMPANY' ? [
                                updateBusinessInformationMutation({
                                    variables: {
                                        updateBusinessInformationInput: {
                                            other: other,
                                            taxReturns: taxReturns,
                                            businessName: businessName,
                                            businessType: businessType,
                                            taxPercent: tax,
                                            ...businessAddressId.length && businessPhoneId.length || !businessAddressId.length && businessPhoneId.length || businessAddressId.length && !businessPhoneId.length ? {
                                                Address: [
                                                    businessAddress
                                                ],
                                                Phones: [
                                                    businessPhoneNumber
                                                ]
                                            } : {},
                                            payrollPercent: payroll,
                                            accountingPercent: accounting,
                                            bookKeepingPercent: bookKeeping,
                                            yearsInBusiness: taxPracticeYears,
                                            taxResolutionPercent: taxResolution,
                                            id: businessInfoData.BusinessInformation.id
                                        }
                                    }
                                })
                            ] : [
                                updateFirmAccount({
                                    variables: {
                                        updateFirmAccountInput: {
                                            name: null,
                                            businessType: businessType,
                                            id: firmAccountId
                                        }
                                    }
                                }),
                                removeBusinessInfo({
                                    variables: {
                                        id: businessInfoData.BusinessInformation.id
                                    }
                                })
                            ]
                        ] : []
                    ] : [
                        ...businessType ? [
                            updateFirmAccount({
                                variables: {
                                    updateFirmAccountInput: {
                                        businessType: businessType,
                                        id: firmAccountId,
                                        name: businessName
                                    }
                                }
                            })
                        ] : [],
                        ...businessType === 'COMPANY' ? [
                            createBusinessInformationMutation({
                                variables: {
                                    createBusinessInformationInput: {
                                        other: other,
                                        taxReturns: taxReturns,
                                        taxPercent: tax,
                                        payrollPercent: payroll,
                                        accountingPercent: accounting,
                                        bookKeepingPercent: bookKeeping,
                                        yearsInBusiness: taxPracticeYears,
                                        taxResolutionPercent: taxResolution,
                                        Phones: [
                                            {
                                                value: businessPhone,
                                                type: 'OFFICE'
                                            }
                                        ],
                                        Address: [
                                            {
                                                zip: businessZip,
                                                city: businessCity,
                                                state: businessState,
                                                lineOne: businessAddressLine1,
                                                lineTwo: businessAddressLine2,
                                                type: 'BUSINESS'
                                            }
                                        ]
                                    }
                                }
                            })
                        ] : []
                    ]
                ]).then(()=>{
                    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Information saved successfully');
                    if (typeof resetForm === 'function' && values.businessType === 'INDIVIDUAL') {
                        resetForm({
                            ...values,
                            tax: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.tax,
                            other: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.other,
                            payroll: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.payroll,
                            taxReturns: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.taxReturns,
                            accounting: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.accounting,
                            businessZip: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.businessZip,
                            bookKeeping: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.bookKeeping,
                            businessName: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.businessName,
                            businessCity: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.businessCity,
                            businessPhone: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.businessPhone,
                            taxResolution: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.taxResolution,
                            businessState: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.businessState,
                            taxPracticeYears: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.taxPracticeYears,
                            businessAddressLine1: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.businessAddressLine1,
                            businessAddressLine2: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.businessAddressLine2
                        });
                        setPreparerValues({
                            ...values,
                            tax: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.tax,
                            other: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.other,
                            payroll: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.payroll,
                            taxReturns: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.taxReturns,
                            accounting: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.accounting,
                            businessZip: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.businessZip,
                            bookKeeping: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.bookKeeping,
                            businessName: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.businessName,
                            businessCity: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.businessCity,
                            businessPhone: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.businessPhone,
                            taxResolution: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.taxResolution,
                            businessState: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.businessState,
                            taxPracticeYears: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.taxPracticeYears,
                            businessAddressLine1: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.businessAddressLine1,
                            businessAddressLine2: $1406c3889597a60d$var$PREPARER_INITIAL_VALUES.businessAddressLine2
                        });
                    } else if (typeof resetForm === 'function') resetForm(values);
                }).catch((error)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message)).finally(()=>{
                    setIsLoading(false);
                });
            }
        } else {
            const { zip: zip, city: city, state: state, lastName: lastName, firstName: firstName, phoneNumber: phoneNumber, addressLine1: addressLine1, addressLine2: addressLine2, dateOfBirth: birthday } = values;
            // format personal addres to be used in mutation
            const personalAddress = {
                zip: zip,
                city: city,
                state: state,
                lineOne: addressLine1,
                lineTwo: addressLine2,
                id: personalAddressId,
                type: 'PERSONAL'
            };
            // Format personal phone number to use in mutation
            const personalPhoneNumber = {
                id: personalPhoneId,
                value: phoneNumber,
                type: 'PERSONAL'
            };
            setIsLoading(true);
            updateUserInformation({
                variables: {
                    updateUserInformationInput: {
                        birthday: birthday,
                        lastName: lastName,
                        firstName: firstName,
                        id: userInformationId,
                        ...personalAddressId ? {
                            Address: [
                                personalAddress
                            ]
                        } : {},
                        Phones: [
                            personalPhoneNumber
                        ]
                    }
                }
            }).then(()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Information saved successfully');
            }).catch((error)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message)).finally(()=>{
                setIsLoading(false);
            });
        }
    };
    // eslint-disable-next-line
    const handleSubmitForm = (values, resetForm)=>{
        if ('businessType' in values && isPreparer) {
            // Related business information
            const { tax: tax, other: other, payroll: payroll, taxReturns: taxReturns, accounting: accounting, businessZip: businessZip, bookKeeping: bookKeeping, businessName: businessName, businessCity: businessCity, businessPhone: businessPhone, taxResolution: taxResolution, businessState: businessState, taxPracticeYears: taxPracticeYears, businessAddressLine1: businessAddressLine1, businessAddressLine2: businessAddressLine2 } = values;
            const relatedBusinessValues = {
                tax: tax,
                other: other,
                payroll: payroll,
                taxReturns: taxReturns,
                accounting: accounting,
                businessZip: businessZip,
                bookKeeping: bookKeeping,
                businessName: businessName,
                businessCity: businessCity,
                businessPhone: businessPhone,
                taxResolution: taxResolution,
                businessState: businessState,
                taxPracticeYears: taxPracticeYears,
                businessAddressLine1: businessAddressLine1,
                businessAddressLine2: businessAddressLine2
            };
            if (!hasWarning && values.businessType === 'INDIVIDUAL' && Object.values(relatedBusinessValues).some((value)=>value)) setHasWarning(true);
            else if (resetForm) submitForm(values, resetForm);
            else submitForm(values);
        } else submitForm(values);
    };
    if (loadingQuery || loadingBusinessInfo) return (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
        size: "large"
    });
    return (0, $bb3TF.jsxs)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
        style: {
            backgroundColor: 'white',
            paddingRight: '10px'
        },
        children: [
            (0, $bb3TF.jsx)((0, $58c1491b566e843c$export$2e2bcd8739ae039), {
                title: isStaff ? 'Personal Info' : 'Firm Info',
                tooltipTitle: "What do we do with this information?",
                tooltipContent: (0, $bb3TF.jsx)($1406c3889597a60d$var$Paragraph, {
                    children: `We brand your client's home page with your business name, email,
          and phone number. This allows them to easily stay in touch.`
                })
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)((0, $ipnkk.Formik), {
                    enableReinitialize: true,
                    innerRef: $1406c3889597a60d$var$formikRef,
                    initialValues: !isPreparer && isStaff ? staffValues : preparerValues,
                    onSubmit: (values)=>handleSubmitForm(values, $1406c3889597a60d$var$formikRef?.current?.resetForm),
                    validationSchema: !isPreparer && isStaff ? (0, $3b22454bc068a712$export$7c4fcebc6bcf21e6) : (0, $3b22454bc068a712$export$2959d5e81c412e6d),
                    children: ({ values: values, errors: errors, touched: touched, resetForm: resetForm, handleBlur: handleBlur, handleChange: handleChange, handleSubmit: handleSubmit, setFieldValue: setFieldValue })=>(0, $bb3TF.jsxs)("form", {
                            onSubmit: handleSubmit,
                            style: {
                                width: '100%'
                            },
                            children: [
                                (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                                    size: "large",
                                    direction: "vertical",
                                    style: {
                                        width: '100%'
                                    },
                                    children: [
                                        (0, $bb3TF.jsx)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                                            size: "small",
                                            title: (0, $bb3TF.jsx)("b", {
                                                children: "Your Personal Information:"
                                            }),
                                            bordered: false,
                                            children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                                gutter: [
                                                    16,
                                                    16
                                                ],
                                                children: [
                                                    isPreparer ? (0, $d105fbcf37667062$export$7043120777971352)(preparerValues).map((item)=>{
                                                        if (item.key === 'tax' && 'businessType' in values && values.businessType === 'COMPANY') return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                                                            children: [
                                                                (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                                                    span: 24,
                                                                    children: (0, $bb3TF.jsx)($1406c3889597a60d$var$Text, {
                                                                        children: "Tell us about your practice so we can better serve you:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $6fFrj.createElement)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                                                    ...item.span,
                                                                    key: item.key
                                                                }, (0, $bb3TF.jsx)((0, $ee43b16a73c53ab8$export$2e2bcd8739ae039), {
                                                                    item: item,
                                                                    addonAfter: "%",
                                                                    errors: errors,
                                                                    touched: touched,
                                                                    handleBlur: handleBlur,
                                                                    value: values[item.key],
                                                                    customError: customError,
                                                                    handleChange: handleChange,
                                                                    setFieldValue: setFieldValue
                                                                }))
                                                            ]
                                                        });
                                                        if (item.key === 'businessName' && 'businessType' in values && values.businessType === 'COMPANY') return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                                                            children: [
                                                                (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                                                    span: 24,
                                                                    children: (0, $bb3TF.jsx)("b", {
                                                                        children: "Your Business Information:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $6fFrj.createElement)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                                                    ...item.span,
                                                                    key: item.key
                                                                }, (0, $bb3TF.jsx)((0, $ee43b16a73c53ab8$export$2e2bcd8739ae039), {
                                                                    item: item,
                                                                    errors: errors,
                                                                    touched: touched,
                                                                    handleBlur: handleBlur,
                                                                    value: values[item.key],
                                                                    customError: customError,
                                                                    handleChange: handleChange,
                                                                    setFieldValue: setFieldValue
                                                                }))
                                                            ]
                                                        });
                                                        if ('businessType' in values && (!values.businessType || values.businessType === 'INDIVIDUAL')) switch(item.key){
                                                            case 'businessName':
                                                            case 'businessPhone':
                                                            case 'businessAddressLine1':
                                                            case 'businessAddressLine2':
                                                            case 'businessCity':
                                                            case 'businessState':
                                                            case 'businessZip':
                                                            case 'taxReturns':
                                                            case 'taxPracticeYears':
                                                            case 'tax':
                                                            case 'accounting':
                                                            case 'bookKeeping':
                                                            case 'payroll':
                                                            case 'taxResolution':
                                                            case 'other':
                                                                return false;
                                                            default:
                                                        }
                                                        return /*#__PURE__*/ (0, $6fFrj.createElement)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                                            ...item.span,
                                                            key: item.key
                                                        }, (0, $bb3TF.jsx)((0, $ee43b16a73c53ab8$export$2e2bcd8739ae039), {
                                                            item: item,
                                                            errors: errors,
                                                            touched: touched,
                                                            handleBlur: handleBlur,
                                                            value: values[item.key],
                                                            customError: customError,
                                                            handleChange: handleChange,
                                                            setFieldValue: setFieldValue,
                                                            addonAfter: item.key === 'accounting' || item.key === 'bookKeeping' || item.key === 'payroll' || item.key === 'taxResolution' || item.key === 'other' ? '%' : null
                                                        }));
                                                    }) : (0, $d105fbcf37667062$export$1ccb5b25c036c745)(staffValues).map((item)=>/*#__PURE__*/ (0, $6fFrj.createElement)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                                            ...item.span,
                                                            key: item.key
                                                        }, (0, $bb3TF.jsx)((0, $ee43b16a73c53ab8$export$2e2bcd8739ae039), {
                                                            item: item,
                                                            errors: errors,
                                                            touched: touched,
                                                            handleBlur: handleBlur,
                                                            value: values[item.key],
                                                            customError: customError,
                                                            handleChange: handleChange,
                                                            setFieldValue: setFieldValue,
                                                            addonAfter: item.key === 'accounting' || item.key === 'bookKeeping' || item.key === 'payroll' || item.key === 'taxResolution' || item.key === 'other' ? '%' : null
                                                        }))),
                                                    'tax' in values && values.businessType && values.businessType === 'COMPANY' && (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                                        span: 24,
                                                        style: {
                                                            display: 'flex',
                                                            justifyContent: 'flex-end'
                                                        },
                                                        children: (0, $bb3TF.jsxs)($1406c3889597a60d$var$Text, {
                                                            strong: true,
                                                            children: [
                                                                "Total Percentage:",
                                                                ' ',
                                                                setPercentage(values.tax, values.accounting, values.bookKeeping, values.payroll, values.taxResolution, values.other),
                                                                "%"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        isLoading ? (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                                            size: "small"
                                        }) : (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                            disabled: hasWarning,
                                            type: "primary",
                                            htmlType: "submit",
                                            children: "Save Information"
                                        })
                                    ]
                                }),
                                hasWarning && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                                    style: {
                                        marginTop: 20
                                    },
                                    type: "warning",
                                    message: "You are changing the way you operate, it is possible that information about your business may be lost. Are you sure?",
                                    action: (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                                        direction: "vertical",
                                        children: [
                                            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                size: "small",
                                                type: "primary",
                                                onClick: ()=>{
                                                    setHasWarning(false);
                                                    handleSubmitForm(values, resetForm);
                                                },
                                                children: "Accept"
                                            }),
                                            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                size: "small",
                                                danger: true,
                                                onClick: ()=>{
                                                    setHasWarning(false);
                                                },
                                                children: "Decline"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                })
            })
        ]
    });
};
var $1406c3889597a60d$export$2e2bcd8739ae039 = $1406c3889597a60d$var$FirmInfo;


var $2e33db7b040b4658$export$2e2bcd8739ae039 = (0, $1406c3889597a60d$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");









var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $bb3TF = parcelRequire("bb3TF");


const { Text: $2a4f5d2919a8f5fa$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $2a4f5d2919a8f5fa$var$CustomDomainDNSModal = ({ isDNSModalVisible: isDNSModalVisible, setIsDNSModalVisible: setIsDNSModalVisible })=>{
    // Query for getting cloudfront distribution
    const { data: cloudfrontDistributionData } = (0, $732264f53056e08f$export$f20a576d40a9b29)({
    });
    const { GetCloudFrontDistributionByCertificateArn: GetCloudFrontDistributionByCertificateArn } = cloudfrontDistributionData || {};
    const [subdomain, ...domainSection] = GetCloudFrontDistributionByCertificateArn?.Aliases?.Items?.[0]?.split('.') || [];
    return (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        title: "Final step: DNS Configuration",
        width: "75%",
        visible: isDNSModalVisible,
        onCancel: ()=>setIsDNSModalVisible(false),
        footer: [
            (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                onClick: ()=>setIsDNSModalVisible(false),
                type: "primary",
                children: "close"
            })
        ],
        children: (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            gutter: 16,
            children: (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                span: 24,
                children: [
                    "You must setup a CNAME record for your domain to complete the custom domain setup.",
                    (0, $bb3TF.jsx)("br", {}),
                    (0, $bb3TF.jsx)("br", {}),
                    (0, $bb3TF.jsx)("b", {
                        children: "To set up:"
                    }),
                    (0, $bb3TF.jsx)("br", {}),
                    "1. Log in to your domain registrar.",
                    (0, $bb3TF.jsx)("br", {}),
                    "2. Navigate to the DNS settings for your domain.",
                    (0, $bb3TF.jsx)("br", {}),
                    "3. Create a CNAME record with the host",
                    ' ',
                    (0, $bb3TF.jsx)($2a4f5d2919a8f5fa$var$Text, {
                        copyable: true,
                        code: true,
                        children: subdomain
                    }),
                    ' ',
                    "with the value",
                    ' ',
                    (0, $bb3TF.jsx)($2a4f5d2919a8f5fa$var$Text, {
                        copyable: true,
                        code: true,
                        children: GetCloudFrontDistributionByCertificateArn?.DomainName
                    }),
                    ".",
                    (0, $bb3TF.jsx)("br", {}),
                    (0, $bb3TF.jsx)("br", {}),
                    "For further assistance, please check out our",
                    ' ',
                    (0, $bb3TF.jsx)("a", {
                        href: "https://help.taxaroo.com/article/87-how-to-create-custom-domain",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "help document"
                    }),
                    ", contact support, or contact your domain registrar.",
                    (0, $bb3TF.jsx)("br", {}),
                    (0, $bb3TF.jsx)("br", {}),
                    "*Note: DNS changes can take up to an hour and sometimes longer to take effect."
                ]
            })
        })
    });
};
var $2a4f5d2919a8f5fa$export$2e2bcd8739ae039 = $2a4f5d2919a8f5fa$var$CustomDomainDNSModal;



var $bb3TF = parcelRequire("bb3TF");


const { Text: $b23f17af94c41ac9$var$Text, Paragraph: $b23f17af94c41ac9$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $b23f17af94c41ac9$var$CustomDomainStatusAlert = ({ status: status, failureReason: failureReason, cnameError: cnameError, setIsCnameModalVisible: setIsCnameModalVisible, certificateStatus: certificateStatus, loadingCertificateStatus: loadingCertificateStatus })=>{
    if (!certificateStatus && loadingCertificateStatus) return null;
    if (status === (0, $8f7fe33a44836803$export$e5f8203198481f3c).Issued && !cnameError) return null;
    if (status && status !== (0, $8f7fe33a44836803$export$e5f8203198481f3c).Issued) {
        const domainValidationSplit = certificateStatus?.CustomDomainCertificateStatus?.DomainValidationOptions.name?.split('.');
        return (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
            message: (0, $bb3TF.jsxs)($b23f17af94c41ac9$var$Text, {
                style: {
                    color: 'white',
                    fontSize: 18
                },
                children: [
                    status === (0, $8f7fe33a44836803$export$e5f8203198481f3c).PendingValidation && 'First Step: Your custom domain is currently pending verification.',
                    status !== (0, $8f7fe33a44836803$export$e5f8203198481f3c).PendingValidation && `The status of your custom domain is currently ${status}.`
                ]
            }),
            type: "warning",
            showIcon: true,
            description: (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                children: [
                    (0, $bb3TF.jsxs)($b23f17af94c41ac9$var$Text, {
                        style: {
                            color: 'white',
                            fontSize: 17
                        },
                        children: [
                            status === (0, $8f7fe33a44836803$export$e5f8203198481f3c).PendingValidation && // 'Please check your email for a message from no-reply@certificates.amazon.com and follow the instructions to verify your domain.'
                            'Please add CNAME records to your domain DNS settings database in order to finish the verification process:',
                            status !== (0, $8f7fe33a44836803$export$e5f8203198481f3c).PendingValidation && `Error code: ${failureReason}. If you need help with this matter, please contact customer support.`
                        ]
                    }),
                    status === (0, $8f7fe33a44836803$export$e5f8203198481f3c).PendingValidation && (0, $bb3TF.jsxs)($b23f17af94c41ac9$var$Paragraph, {
                        style: {
                            paddingTop: '15px'
                        },
                        children: [
                            !certificateStatus?.CustomDomainCertificateStatus?.DomainValidationOptions?.name ? (0, $bb3TF.jsx)($b23f17af94c41ac9$var$Paragraph, {
                                children: (0, $bb3TF.jsx)($b23f17af94c41ac9$var$Text, {
                                    children: "(Please wait a few seconds and refresh the page to see values)"
                                })
                            }) : (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                                children: [
                                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                        children: (0, $bb3TF.jsxs)($b23f17af94c41ac9$var$Text, {
                                            children: [
                                                (0, $bb3TF.jsx)($b23f17af94c41ac9$var$Text, {
                                                    strong: true,
                                                    underline: true,
                                                    children: "Name:"
                                                }),
                                                (0, $bb3TF.jsx)($b23f17af94c41ac9$var$Text, {
                                                    copyable: true,
                                                    code: true,
                                                    children: `${domainValidationSplit?.[0]}.${domainValidationSplit?.[1]}`
                                                })
                                            ]
                                        })
                                    }),
                                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                        style: {
                                            marginTop: 10
                                        },
                                        children: (0, $bb3TF.jsxs)($b23f17af94c41ac9$var$Text, {
                                            children: [
                                                (0, $bb3TF.jsx)($b23f17af94c41ac9$var$Text, {
                                                    strong: true,
                                                    underline: true,
                                                    children: "Value:"
                                                }),
                                                (0, $bb3TF.jsx)($b23f17af94c41ac9$var$Text, {
                                                    copyable: true,
                                                    code: true,
                                                    children: certificateStatus?.CustomDomainCertificateStatus?.DomainValidationOptions.value
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            (0, $bb3TF.jsx)($b23f17af94c41ac9$var$Paragraph, {
                                style: {
                                    paddingTop: '15px'
                                },
                                children: (0, $bb3TF.jsx)($b23f17af94c41ac9$var$Text, {
                                    style: {
                                        color: '#fff'
                                    },
                                    children: "Please note that it can take up to an hour to propagate this values. And after verification is finished you'll be able to move on to the last step."
                                })
                            })
                        ]
                    })
                ]
            }),
            style: {
                marginBottom: 20,
                marginTop: 20,
                padding: 15
            }
        });
    }
    if (cnameError) return (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
        message: (0, $bb3TF.jsxs)($b23f17af94c41ac9$var$Text, {
            style: {
                color: 'white',
                fontSize: 18
            },
            children: [
                !cnameError.includes('already has a CNAME record') && 'Final step: ',
                cnameError
            ]
        }),
        type: "warning",
        showIcon: true,
        description: cnameError.includes('already has a CNAME record') ? (0, $bb3TF.jsx)($b23f17af94c41ac9$var$Text, {
            style: {
                color: 'white',
                fontSize: 17
            },
            children: "Please contact our customer support if you would like help updating your DNS records."
        }) : (0, $bb3TF.jsxs)($b23f17af94c41ac9$var$Text, {
            style: {
                color: 'white',
                fontSize: 17
            },
            children: [
                "Please update your DNS by creating a CNAME record for your domain.",
                (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    type: "link",
                    onClick: ()=>setIsCnameModalVisible(true),
                    style: {
                        padding: 2,
                        textTransform: 'none'
                    },
                    children: "See Details"
                })
            ]
        }),
        style: {
            marginBottom: 20,
            marginTop: 20,
            padding: 15
        }
    });
    return null;
};
var $b23f17af94c41ac9$export$2e2bcd8739ae039 = $b23f17af94c41ac9$var$CustomDomainStatusAlert;




const { SaveOutlined: $ebeb6abd3f0132f9$var$SaveOutlined, DeleteOutlined: $ebeb6abd3f0132f9$var$DeleteOutlined, LinkOutlined: $ebeb6abd3f0132f9$var$LinkOutlined, MailOutlined: $ebeb6abd3f0132f9$var$MailOutlined, ReloadOutlined: $ebeb6abd3f0132f9$var$ReloadOutlined, InfoCircleOutlined: $ebeb6abd3f0132f9$var$InfoCircleOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Title: $ebeb6abd3f0132f9$var$Title, Paragraph: $ebeb6abd3f0132f9$var$Paragraph, Text: $ebeb6abd3f0132f9$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $ebeb6abd3f0132f9$var$CustomDomain = (props)=>{
    const { customDomain: customDomain, status: status, failureReason: failureReason, cnameError: cnameError, domain: domain, enableEditCustomDomain: enableEditCustomDomain, handleCreateDomain: handleCreateDomain, handleRemoveDomain: handleRemoveDomain, loadingCreateMutation: loadingCreateMutation, loadingDeleteMutation: loadingDeleteMutation, setDomain: setDomain, setEnableEditCustomDomain: setEnableEditCustomDomain, setSubdomain: setSubdomain, setVisibleTooltip: setVisibleTooltip, subdomain: subdomain, visibleTooltip: visibleTooltip, handleGetCertificateStatus: handleGetCertificateStatus, handleResendEmails: handleResendEmails, certificateStatusLoading: certificateStatusLoading, resendEmailsLoading: resendEmailsLoading, certificateStatus: certificateStatus } = props;
    const [isCnameModalVisible, setIsCnameModalVisible] = (0, $6fFrj.useState)(false);
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 2,
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 24,
                        children: (0, $bb3TF.jsx)((0, $b23f17af94c41ac9$export$2e2bcd8739ae039), {
                            status: status,
                            failureReason: failureReason,
                            cnameError: cnameError,
                            setIsCnameModalVisible: setIsCnameModalVisible,
                            certificateStatus: certificateStatus,
                            loadingCertificateStatus: certificateStatusLoading
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 24,
                        children: (0, $bb3TF.jsxs)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                            children: [
                                (0, $bb3TF.jsx)($ebeb6abd3f0132f9$var$Title, {
                                    level: 5,
                                    children: (0, $bb3TF.jsx)($ebeb6abd3f0132f9$var$Text, {
                                        children: "Step 1"
                                    })
                                }),
                                (0, $bb3TF.jsxs)($ebeb6abd3f0132f9$var$Paragraph, {
                                    children: [
                                        (0, $bb3TF.jsx)($ebeb6abd3f0132f9$var$Text, {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: "Custom Domain "
                                        }),
                                        (0, $bb3TF.jsx)("a", {
                                            href: "https://help.taxaroo.com/article/87-how-to-create-custom-domain",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: (0, $bb3TF.jsx)($ebeb6abd3f0132f9$var$InfoCircleOutlined, {
                                                style: {
                                                    fontSize: '14px',
                                                    position: 'relative',
                                                    top: '-0.3em',
                                                    left: '0.3em'
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            !customDomain.id && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 2,
                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    span: 24,
                    children: (0, $bb3TF.jsxs)("div", {
                        style: {
                            display: 'flex',
                            marginLeft: 5
                        },
                        children: [
                            (0, $bb3TF.jsx)((0, $4fd303306a27e42e$export$2e2bcd8739ae039), {
                                checked: enableEditCustomDomain,
                                size: "small",
                                onChange: (check)=>{
                                    setEnableEditCustomDomain(check);
                                    (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
                                        Title: 'Enable domain editing',
                                        Source: 'Toggle click',
                                        value: check,
                                        url: window.location.href
                                    });
                                },
                                style: {
                                    marginTop: 2
                                }
                            }),
                            (0, $bb3TF.jsx)($ebeb6abd3f0132f9$var$Paragraph, {
                                small: true,
                                style: {
                                    marginLeft: 5
                                },
                                children: enableEditCustomDomain ? 'Disable domain editing' : 'Enable domain editing'
                            })
                        ]
                    })
                })
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                align: "middle",
                justify: "center",
                gutter: 10,
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        sm: 6,
                        md: 4,
                        lg: 2,
                        children: (0, $bb3TF.jsx)($ebeb6abd3f0132f9$var$Text, {
                            style: {
                                display: 'flex',
                                justifyContent: 'center',
                                fontSize: 18,
                                whiteSpace: 'nowrap'
                            },
                            children: "https://"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        sm: 18,
                        md: 7,
                        lg: 9,
                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                            size: "large",
                            disabled: !enableEditCustomDomain,
                            value: subdomain,
                            onChange: (e)=>setSubdomain(e.target.value),
                            placeholder: "clients"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        sm: 4,
                        md: 1,
                        children: (0, $bb3TF.jsx)($ebeb6abd3f0132f9$var$Text, {
                            style: {
                                display: 'flex',
                                justifyContent: 'center',
                                fontWeight: 'bold',
                                fontSize: 18
                            },
                            children: "."
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        sm: 20,
                        md: 8,
                        lg: 9,
                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                            disabled: !enableEditCustomDomain,
                            size: "large",
                            value: domain,
                            onChange: (e)=>setDomain(e.target.value),
                            placeholder: "taxaroo.com"
                        })
                    }),
                    (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        md: 4,
                        lg: 3,
                        children: [
                            !customDomain.id && (0, $bb3TF.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'center'
                                },
                                children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                    title: "Save Changes",
                                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                        type: "primary",
                                        shape: "circle",
                                        size: "large",
                                        disabled: !enableEditCustomDomain,
                                        style: {
                                            cursor: 'pointer'
                                        },
                                        onClick: handleCreateDomain,
                                        icon: loadingCreateMutation ? null : (0, $bb3TF.jsx)($ebeb6abd3f0132f9$var$SaveOutlined, {}),
                                        loading: loadingCreateMutation
                                    })
                                })
                            }),
                            customDomain.id && (0, $bb3TF.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'center'
                                },
                                children: [
                                    (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                        title: "Go to website",
                                        arrowPointAtCenter: true,
                                        children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                            type: "primary",
                                            shape: "circle",
                                            size: "large",
                                            style: {
                                                cursor: 'pointer'
                                            },
                                            onClick: ()=>window.open(`https://${customDomain.name}`, '_blank'),
                                            icon: (0, $bb3TF.jsx)($ebeb6abd3f0132f9$var$LinkOutlined, {})
                                        })
                                    }),
                                    (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                        title: "Delete custom domain",
                                        open: visibleTooltip,
                                        arrowPointAtCenter: true,
                                        children: (0, $bb3TF.jsx)((0, $a361442371f1d4e9$export$2e2bcd8739ae039), {
                                            title: "Are you sure you want to delete this domain?",
                                            onConfirm: handleRemoveDomain,
                                            onCancel: ()=>setVisibleTooltip(undefined),
                                            okText: "Yes",
                                            cancelText: "No",
                                            placement: "topRight",
                                            children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                type: "default",
                                                danger: true,
                                                shape: "circle",
                                                size: "large",
                                                style: {
                                                    cursor: 'pointer',
                                                    marginLeft: 8
                                                },
                                                onClick: ()=>setVisibleTooltip(false),
                                                icon: loadingDeleteMutation ? null : (0, $bb3TF.jsx)($ebeb6abd3f0132f9$var$DeleteOutlined, {}),
                                                loading: loadingDeleteMutation
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            customDomain.id && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                align: "middle",
                justify: "center",
                gutter: 25,
                style: {
                    paddingTop: '15px'
                },
                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                        title: "Check certificate status",
                        arrowPointAtCenter: true,
                        open: visibleTooltip,
                        children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                            type: "default",
                            shape: "circle",
                            size: "large",
                            style: {
                                cursor: 'pointer'
                            },
                            onClick: ()=>{
                                setVisibleTooltip(undefined);
                                handleGetCertificateStatus();
                            },
                            icon: (0, $bb3TF.jsx)($ebeb6abd3f0132f9$var$ReloadOutlined, {}),
                            disabled: Boolean(certificateStatusLoading || resendEmailsLoading)
                        })
                    })
                })
            }),
            customDomain?.id && status === (0, $8f7fe33a44836803$export$e5f8203198481f3c).Issued && (0, $bb3TF.jsx)((0, $2a4f5d2919a8f5fa$export$2e2bcd8739ae039), {
                isDNSModalVisible: isCnameModalVisible,
                setIsDNSModalVisible: setIsCnameModalVisible
            })
        ]
    });
};
var $ebeb6abd3f0132f9$export$2e2bcd8739ae039 = $ebeb6abd3f0132f9$var$CustomDomain;


var $3b9f153858b4bc0b$export$2e2bcd8739ae039 = (0, $ebeb6abd3f0132f9$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");

var $629399d0ef15261b$export$bed4958795da8ac0;
var $629399d0ef15261b$export$d846a084e680d8e;
$629399d0ef15261b$export$bed4958795da8ac0 = `_0JTGSW_row-divider`;
$629399d0ef15261b$export$d846a084e680d8e = `_0JTGSW_typography`;


const { DeleteOutlined: $914e5321cdddbdda$var$DeleteOutlined, InboxOutlined: $914e5321cdddbdda$var$InboxOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Title: $914e5321cdddbdda$var$Title, Paragraph: $914e5321cdddbdda$var$Paragraph, Text: $914e5321cdddbdda$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { Dragger: $914e5321cdddbdda$var$Dragger } = (0, $09e7a312b8c0b52f$export$2e2bcd8739ae039);
const $914e5321cdddbdda$var$CustomLogo = (props)=>{
    const { logo: logo, draggerProps: draggerProps, setLogo: setLogo, isLoading: isLoading } = props;
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    span: 24,
                    children: (0, $bb3TF.jsxs)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                        className: $629399d0ef15261b$export$d846a084e680d8e,
                        children: [
                            (0, $bb3TF.jsx)($914e5321cdddbdda$var$Title, {
                                level: 5,
                                children: "Step 2"
                            }),
                            (0, $bb3TF.jsx)($914e5321cdddbdda$var$Paragraph, {
                                style: {
                                    marginBottom: 0
                                },
                                children: (0, $bb3TF.jsx)($914e5321cdddbdda$var$Text, {
                                    children: (0, $bb3TF.jsx)("b", {
                                        children: "Your Logo"
                                    })
                                })
                            }),
                            (0, $bb3TF.jsx)($914e5321cdddbdda$var$Paragraph, {
                                small: true,
                                children: "Optimal size: 200 pixels (width) x 100 pixels (height). Max file size: 5 MB."
                            })
                        ]
                    })
                })
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 2,
                style: {
                    marginTop: 18,
                    minHeight: 200
                },
                children: (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    span: 24,
                    children: [
                        !logo && (isLoading ? (0, $bb3TF.jsx)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                            style: {
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            },
                            children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                                size: "large"
                            })
                        }) : (0, $bb3TF.jsxs)($914e5321cdddbdda$var$Dragger, {
                            ...draggerProps,
                            children: [
                                (0, $bb3TF.jsx)("p", {
                                    className: "ant-upload-drag-icon",
                                    children: (0, $bb3TF.jsx)($914e5321cdddbdda$var$InboxOutlined, {})
                                }),
                                (0, $bb3TF.jsxs)("p", {
                                    className: "ant-upload-text",
                                    children: [
                                        "Click or drag file to this area",
                                        (0, $bb3TF.jsx)("br", {}),
                                        "to upload your logo"
                                    ]
                                }),
                                (0, $bb3TF.jsx)("p", {
                                    className: "ant-upload-hint",
                                    children: "The file must be a .jpeg, .jpg, or .png image"
                                })
                            ]
                        })),
                        logo && (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                            style: {
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center'
                            },
                            children: [
                                (0, $bb3TF.jsx)((0, $290d39e90e1ee9b2$export$2e2bcd8739ae039), {
                                    width: 275,
                                    src: `${logo}?cacheControl=${Math.trunc(Math.random() * 1e15)}`
                                }),
                                (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                    title: "Delete logo",
                                    arrowPointAtCenter: true,
                                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                        type: "primary",
                                        danger: true,
                                        shape: "circle",
                                        style: {
                                            cursor: 'pointer',
                                            marginLeft: 15,
                                            marginBottom: 5
                                        },
                                        onClick: ()=>{
                                            setLogo('');
                                            (0, $55c6005cab9be059$export$2e2bcd8739ae039).info("Don't forget to save changes!");
                                        },
                                        icon: (0, $bb3TF.jsx)($914e5321cdddbdda$var$DeleteOutlined, {})
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $914e5321cdddbdda$export$2e2bcd8739ae039 = $914e5321cdddbdda$var$CustomLogo;


var $2feb255bcb517355$export$2e2bcd8739ae039 = (0, $914e5321cdddbdda$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");


const $82f5f3015083ef55$export$8f45430ccf837300 = [
    '#f44336',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#2196f3'
];
const $82f5f3015083ef55$export$6b5388d74f5e0c9d = [
    '#f44336',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#2196f3',
    '#03a9f4',
    '#00bcd4',
    '#009688',
    '#4caf50',
    '#8bc34a',
    '#cddc39',
    '#ffeb3b',
    '#ffc107',
    '#ff9800',
    '#ff5722',
    '#795548',
    '#607d8b'
];
const $82f5f3015083ef55$export$fc6e89e9bf9f348b = {
    headerBackgroundColor: 'Header background color',
    headerFontColor: 'Header font color'
};
const $82f5f3015083ef55$export$37cc283d8fbd3462 = (file)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = ()=>resolve(reader.result.toString());
        reader.onerror = (error)=>reject(error);
    });


const { InfoCircleTwoTone: $0f6791c0e0e329fc$var$InfoCircleTwoTone, BgColorsOutlined: $0f6791c0e0e329fc$var$BgColorsOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Title: $0f6791c0e0e329fc$var$Title, Paragraph: $0f6791c0e0e329fc$var$Paragraph, Text: $0f6791c0e0e329fc$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $0f6791c0e0e329fc$var$CustomColor = (props)=>{
    const { category: category, chooseMoreColors: chooseMoreColors, customColor: customColor, colors: colors, dispatch: dispatch, title: title } = props;
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    span: 24,
                    children: (0, $bb3TF.jsxs)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                        children: [
                            (0, $bb3TF.jsxs)($0f6791c0e0e329fc$var$Title, {
                                level: 5,
                                children: [
                                    title,
                                    "\u00A0",
                                    (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
                                        overlayStyle: {
                                            width: '50%'
                                        },
                                        placement: "right",
                                        content: "Select a color or manually add a color hex right after #",
                                        title: "How does this work?",
                                        trigger: "hover",
                                        children: (0, $bb3TF.jsx)($0f6791c0e0e329fc$var$InfoCircleTwoTone, {
                                            style: {
                                                fontSize: 14
                                            }
                                        })
                                    })
                                ]
                            }),
                            (0, $bb3TF.jsx)($0f6791c0e0e329fc$var$Paragraph, {
                                style: {
                                    marginBottom: 0
                                },
                                children: (0, $bb3TF.jsx)($0f6791c0e0e329fc$var$Text, {
                                    children: (0, $bb3TF.jsx)("b", {
                                        children: (0, $82f5f3015083ef55$export$fc6e89e9bf9f348b)[category]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: 2,
                align: "middle",
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        sm: 24,
                        md: 8,
                        lg: 4,
                        children: (0, $bb3TF.jsx)("div", {
                            style: {
                                borderRadius: 5,
                                borderStyle: 'solid',
                                borderColor: customColor === '#ffffff' ? 'black' : customColor,
                                borderWidth: 2,
                                height: 90,
                                width: 90,
                                marginLeft: 5,
                                backgroundColor: customColor
                            }
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        sm: 24,
                        md: 15,
                        lg: 20,
                        children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            children: [
                                (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                    sm: 19,
                                    md: 21,
                                    lg: 23,
                                    children: (0, $bb3TF.jsx)((0, $0a4545e4b6d3c674$export$2e2bcd8739ae039), {
                                        colors: colors,
                                        color: customColor,
                                        width: "100%",
                                        onChange: (color)=>dispatch({
                                                type: category,
                                                payload: {
                                                    [category]: color.hex
                                                }
                                            }),
                                        triangle: "hide"
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                    sm: 5,
                                    md: 3,
                                    lg: 1,
                                    children: (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                        title: "Choose more colors",
                                        children: (0, $bb3TF.jsx)($0f6791c0e0e329fc$var$BgColorsOutlined, {
                                            onClick: ()=>chooseMoreColors(category, customColor),
                                            style: {
                                                cursor: 'pointer',
                                                fontSize: 32,
                                                marginLeft: 8,
                                                marginTop: 12
                                            }
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $0f6791c0e0e329fc$export$2e2bcd8739ae039 = $0f6791c0e0e329fc$var$CustomColor;


var $01372aee6ada4504$export$2e2bcd8739ae039 = (0, $0f6791c0e0e329fc$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");

var $6cd695ec72dbc93a$export$bed4958795da8ac0;
var $6cd695ec72dbc93a$export$d846a084e680d8e;
$6cd695ec72dbc93a$export$bed4958795da8ac0 = `tEgNLa_row-divider`;
$6cd695ec72dbc93a$export$d846a084e680d8e = `tEgNLa_typography`;


const { Title: $75caf6d49ae80623$var$Title, Paragraph: $75caf6d49ae80623$var$Paragraph, Text: $75caf6d49ae80623$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $75caf6d49ae80623$var$LayoutPreview = ({ customColors: customColors, logo: logo })=>(0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 24,
                        children: (0, $bb3TF.jsxs)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                            className: $6cd695ec72dbc93a$export$d846a084e680d8e,
                            children: [
                                (0, $bb3TF.jsx)($75caf6d49ae80623$var$Title, {
                                    level: 5,
                                    children: "Step 5"
                                }),
                                (0, $bb3TF.jsx)($75caf6d49ae80623$var$Paragraph, {
                                    children: (0, $bb3TF.jsx)($75caf6d49ae80623$var$Text, {
                                        children: (0, $bb3TF.jsx)("b", {
                                            children: "Preview your branding"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 16
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)("div", {
                    className: "site-card-border-less-wrapper",
                    style: {
                        width: '100%'
                    },
                    children: (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                        bordered: false,
                        style: {
                            width: '100%'
                        },
                        children: [
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                align: "middle",
                                style: {
                                    backgroundColor: customColors.headerBackgroundColor
                                },
                                children: [
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        span: 1,
                                        style: {
                                            paddingTop: 10
                                        }
                                    }),
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        span: 16,
                                        style: {
                                            paddingTop: 10
                                        },
                                        children: (0, $bb3TF.jsx)((0, $290d39e90e1ee9b2$export$2e2bcd8739ae039), {
                                            width: 90,
                                            src: logo,
                                            fallback: "data:image/png;base64,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"
                                        })
                                    }),
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        style: {
                                            paddingTop: 10
                                        },
                                        children: (0, $bb3TF.jsx)($75caf6d49ae80623$var$Text, {
                                            style: {
                                                color: customColors.headerFontColor
                                            },
                                            children: "client@example.com"
                                        })
                                    })
                                ]
                            }),
                            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                justify: "center",
                                style: {
                                    backgroundColor: '#ffffff',
                                    height: '150px'
                                },
                                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                    span: 8,
                                    style: {
                                        display: 'flex',
                                        justifyContent: 'center'
                                    },
                                    children: (0, $bb3TF.jsx)($75caf6d49ae80623$var$Text, {
                                        style: {
                                            marginTop: 30,
                                            color: '#000000'
                                        },
                                        children: "Sample Text"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
var $75caf6d49ae80623$export$2e2bcd8739ae039 = $75caf6d49ae80623$var$LayoutPreview;


var $c9b128c36f529098$export$2e2bcd8739ae039 = (0, $75caf6d49ae80623$export$2e2bcd8739ae039);



const $dac1b49dd4f1f064$export$d4c72bab9d6cc13a = {
    headerBackgroundColor: '#ffffff',
    headerFontColor: '#000000'
};
var $dac1b49dd4f1f064$export$18180bcdd5fcbb1;
(function(CustomLayoutCategory) {
    CustomLayoutCategory["HEADER_BACKGROUND_COLOR"] = "headerBackgroundColor";
    CustomLayoutCategory["HEADER_FONT_COLOR"] = "headerFontColor";
    CustomLayoutCategory["INITIAL_VALUES"] = "initialValues";
})($dac1b49dd4f1f064$export$18180bcdd5fcbb1 || ($dac1b49dd4f1f064$export$18180bcdd5fcbb1 = {}));
const $dac1b49dd4f1f064$export$34ebea76d94ccd0d = (state, action)=>{
    switch(action.type){
        case $dac1b49dd4f1f064$export$18180bcdd5fcbb1.HEADER_BACKGROUND_COLOR:
            return {
                ...state,
                headerBackgroundColor: action.payload.headerBackgroundColor
            };
        case $dac1b49dd4f1f064$export$18180bcdd5fcbb1.HEADER_FONT_COLOR:
            return {
                ...state,
                headerFontColor: action.payload.headerFontColor
            };
        case $dac1b49dd4f1f064$export$18180bcdd5fcbb1.INITIAL_VALUES:
            return {
                ...action.payload
            };
        default:
            return state;
    }
};


var $64b53e1ac5906baf$export$88c3753063c50488;
var $64b53e1ac5906baf$export$d846a084e680d8e;
$64b53e1ac5906baf$export$88c3753063c50488 = `_dy6yq_rowDivider`;
$64b53e1ac5906baf$export$d846a084e680d8e = `_dy6yq_typography`;


const { SaveOutlined: $5e245eaf8da83742$var$SaveOutlined, CloseOutlined: $5e245eaf8da83742$var$CloseOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Paragraph: $5e245eaf8da83742$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
function $5e245eaf8da83742$var$getNonCachedLogo(logo) {
    return `${logo}?t=${new Date().getTime()}`;
}
const $5e245eaf8da83742$var$SiteBranding = ()=>{
    // Access to user information in the Redux store
    const { firmAccountId: firmAccountId } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    // Manage state for custom layout
    const [customLayoutId, setCustomLayoutId] = (0, $6fFrj.useState)(null);
    const [customColors, dispatch] = (0, $6fFrj.useReducer)((0, $dac1b49dd4f1f064$export$34ebea76d94ccd0d), (0, $dac1b49dd4f1f064$export$d4c72bab9d6cc13a));
    const [isModalVisible, setIsModalVisible] = (0, $6fFrj.useState)(false);
    const [moreColorHex, setMoreColorHex] = (0, $6fFrj.useState)();
    const [isDomainsModalVisible, setIsDomainsModalVisible] = (0, $6fFrj.useState)(false);
    const [cnameError, setCnameError] = (0, $6fFrj.useState)('');
    // Manage state to store color category (header background color, header text color, etc)
    const [colorCategory, setColorCategory] = (0, $6fFrj.useState)();
    // Manage state for custom logo
    const [logo, setLogo] = (0, $6fFrj.useState)('');
    const [nonCachedLogo, setNonCachedLogo] = (0, $6fFrj.useState)('');
    // Manage state for custom domain
    const [customDomain, setCustomDomain] = (0, $6fFrj.useState)({
        id: null,
        name: ''
    });
    const [subdomain, setSubdomain] = (0, $6fFrj.useState)('');
    const [domain, setDomain] = (0, $6fFrj.useState)('');
    // Manage state for user interface
    const [enableEditCustomDomain, setEnableEditCustomDomain] = (0, $6fFrj.useState)(false);
    const [visibleTooltip, setVisibleTooltip] = (0, $6fFrj.useState)(undefined);
    // Post-mutation handlers
    const handleOnCreateDomainCompleted = ()=>{
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Custom domain saved successfully!');
        setEnableEditCustomDomain(false);
        setVisibleTooltip(undefined);
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        getCustomDomainCertificateStatus();
    };
    const handleOnRemoveCompleted = async ()=>{
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Custom domain deleted successfully!');
        setEnableEditCustomDomain(false);
        setCustomDomain({
            id: null,
            name: ''
        });
        setSubdomain('');
        setDomain('');
        setVisibleTooltip(undefined);
        setCnameError('');
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        getCustomDomainCnameStatus();
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        getCustomDomainCertificateStatus();
    };
    const handleOnError = ()=>{
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error has occurred, please try again.');
    };
    // Query for getting custom domain
    const { data: customDomainQueryData, loading: loadingCustomDomainQuery } = (0, $732264f53056e08f$export$65d51915dfd746a3)();
    // using a useState here so I can set it to null when there is an error
    const [certificateStatus, setCertificateStatus] = (0, $6fFrj.useState)(null);
    // Query for getting custom domain certificate status
    const [getCustomDomainCertificateStatus, { loading: certificateStatusLoading }] = (0, $732264f53056e08f$export$b1a758a27418fc73)({
        fetchPolicy: 'network-only',
        onCompleted (data) {
            setCertificateStatus(data);
        },
        onError: (error)=>{
            setCertificateStatus(null); // set to null if error
            if (error.message === 'One or more aliases specified for the distribution includes an incorrectly configured DNS record that points to another CloudFront distribution. You must update the DNS record to correct the problem. For more information, see https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/CNAMEs.html#alternate-domain-names-restrictions') setCnameError('You custom domain already has a CNAME record pointing to a different domian. Please remove your existing CNAME record and reload the page.');
        }
    });
    const { CustomDomainCertificateStatus: CustomDomainCertificateStatus } = certificateStatus || {};
    // Query for getting custom domain cname status
    const [getCustomDomainCnameStatus, { data: cnameStatus, loading: cnameStatusLoading }] = (0, $732264f53056e08f$export$4a1ba03041072c39)({
        onError: (error)=>{
            if (error?.message?.includes('queryCname ENODATA') || error?.message?.includes('queryCname ENOTFOUND')) setCnameError('CNAME record not found.');
        },
        onCompleted: (cnameStatusData)=>{
            if (cnameStatusData?.CustomDomainCnameStatus?.cnameStatus !== 'VERIFIED') setCnameError(cnameStatusData?.CustomDomainCnameStatus?.cnameStatus);
        }
    });
    // Query for getting custom layout
    const { data: customLayoutData, loading: loadingCustomLayoutQuery } = (0, $732264f53056e08f$export$a9d926e7a1510ac6)();
    // Query for checking if custom domain is live
    // check if custom domain is live
    const [checkIfCustomDomainIsLive, { data: domainLiveData }] = (0, $732264f53056e08f$export$1a0c8fbd0bcd031a)({
        variables: {
            url: customDomain?.name
        }
    });
    const { IsDomainLive: isDomainLive } = domainLiveData || {};
    // Mutation for creating a custom domain
    const [createCustomDomain, { loading: loadingCreateMutation }] = (0, $33beb5b1bfae180c$export$b0186010bb4cc701)({
        onCompleted: handleOnCreateDomainCompleted,
        onError: handleOnError,
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$4b2f97b8ce17ee4)
            }
        ],
        awaitRefetchQueries: true
    });
    // Mutation for creating a custom layout
    const [createCustomLayout, { loading: loadingCreateLayout }] = (0, $33beb5b1bfae180c$export$7b9fe9a07323d7a9)({
        onCompleted: ()=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Custom layout saved successfully!'),
        onError: handleOnError,
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$dd6355313f82125f)
            }
        ],
        awaitRefetchQueries: true
    });
    // Mutation for updating custom layout
    const [updateCustomLayout, { loading: loadingUpdateLayout }] = (0, $33beb5b1bfae180c$export$4b25a5e514b06217)({
        onCompleted: ()=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Custom layout saved successfully!'),
        onError: handleOnError,
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$dd6355313f82125f)
            }
        ],
        awaitRefetchQueries: true
    });
    // Mutation for removing custom domain
    const [removeCustomDomain, { loading: loadingDeleteMutation }] = (0, $33beb5b1bfae180c$export$9692eef04d6c9776)({
        onCompleted: handleOnRemoveCompleted,
        onError: handleOnError,
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$6ba3fa77a474aebb)
            }
        ],
        awaitRefetchQueries: true
    });
    // Mutation to get presigned URL for logo
    const [getSiteBrandingLogoPresignedURL, { loading: presignedUrlLoading }] = (0, $33beb5b1bfae180c$export$9036669b8d399532)();
    const [uploadingToS3, setUploadingToS3] = (0, $6fFrj.useState)(false);
    const [customDomainResendEmails, { loading: resendEmailsLoading }] = (0, $33beb5b1bfae180c$export$f4a6b05e46e5a550)({
        onError: handleOnError
    });
    const handleGetCertificateStatus = async ()=>{
        const status = await getCustomDomainCertificateStatus({
            onError: (error)=>{
                setCertificateStatus(null);
                if (error.message === 'One or more aliases specified for the distribution includes an incorrectly configured DNS record that points to another CloudFront distribution. You must update the DNS record to correct the problem. For more information, see https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/CNAMEs.html#alternate-domain-names-restrictions') (0, $55c6005cab9be059$export$2e2bcd8739ae039).info('Certificate is successfully issued.');
                else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`Error getting certificate status: ${error.message}`);
            }
        });
        const { Status: Status } = status.data.CustomDomainCertificateStatus;
        if (Status === (0, $8f7fe33a44836803$export$e5f8203198481f3c).Issued) (0, $55c6005cab9be059$export$2e2bcd8739ae039).info('Certificate is successfully issued.');
        else (0, $55c6005cab9be059$export$2e2bcd8739ae039).info(`Status: ${Status.toLowerCase().split('_').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}`, 5);
    };
    const handleResendEmails = async ()=>{
        const status = await customDomainResendEmails();
        if (status.data.CustomDomainResendEmails) (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Emails are successfully sent.');
        else handleOnError();
    };
    // Mutation handlers
    const handleCreateDomain = async ()=>{
        const result = await createCustomDomain({
            variables: {
                createCustomDomainsInput: {
                    name: `${subdomain}.${domain}`,
                    firmAccountId: firmAccountId,
                    status: (0, $8f7fe33a44836803$export$e5f8203198481f3c).Issued
                }
            }
        });
        if (result.data.createCustomDomains.id) // setIsDomainsModalVisible(true); // do not show this modal for DNS verification
        setTimeout(getCustomDomainCertificateStatus, 3000); // to get DNS verification values
        else handleOnError();
    };
    const handleUpsertCustomLayout = ()=>{
        if (customLayoutId) updateCustomLayout({
            variables: {
                updateCustomLayoutInput: {
                    ...customColors,
                    logo: logo
                }
            }
        });
        else createCustomLayout({
            variables: {
                createCustomLayoutInput: {
                    ...customColors,
                    firmAccountId: firmAccountId,
                    logo: logo
                }
            }
        });
    };
    const handleRemoveDomain = async ()=>{
        await removeCustomDomain({
            variables: {
                id: customDomain.id
            }
        });
    };
    const setCustomLayoutInitialValues = (customLayoutInitialValues)=>{
        const { id: id, logo: initialLogo, headerBackgroundColor: headerBackgroundColor, headerFontColor: headerFontColor } = customLayoutInitialValues;
        setCustomLayoutId(id);
        setLogo(initialLogo || '');
        setNonCachedLogo(initialLogo ? $5e245eaf8da83742$var$getNonCachedLogo(initialLogo) : '');
        dispatch({
            type: (0, $dac1b49dd4f1f064$export$18180bcdd5fcbb1).INITIAL_VALUES,
            payload: {
                headerBackgroundColor: headerBackgroundColor || '#ffffff',
                headerFontColor: headerFontColor || '#ffffff'
            }
        });
    };
    const handleCancelChanges = ()=>{
        // Set logo and custom layout initial values
        if (customLayoutData) setCustomLayoutInitialValues(customLayoutData.CustomLayout);
        else setCustomLayoutInitialValues({
            ...(0, $dac1b49dd4f1f064$export$d4c72bab9d6cc13a),
            id: customLayoutId,
            logo: null
        });
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('The changes were cancelled');
    };
    const handleResetDefault = ()=>{
        updateCustomLayout({
            variables: {
                updateCustomLayoutInput: {
                    ...(0, $dac1b49dd4f1f064$export$d4c72bab9d6cc13a),
                    // id: customLayoutId,
                    logo: null
                }
            }
        });
    };
    // Props for Ant Design dragger
    const draggerProps = {
        name: 'file',
        multiple: false,
        accept: 'image/png,image/jpg,image/jpeg',
        beforeUpload: async (file)=>{
            // Check if file type is allowed
            const acceptedTypes = [
                'image/png',
                'image/jpg',
                'image/jpeg'
            ];
            if (!acceptedTypes.includes(file.type)) {
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('File type not allowed, please try again');
                return (0, $09e7a312b8c0b52f$export$2e2bcd8739ae039).LIST_IGNORE;
            }
            // Check file size
            if (file.size > 5242880) {
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('File is too big, please try again');
                return (0, $09e7a312b8c0b52f$export$2e2bcd8739ae039).LIST_IGNORE;
            }
            try {
                const presignedUrlData = await getSiteBrandingLogoPresignedURL({
                    variables: {
                        mimeType: file.type
                    }
                });
                const fileUrl = new URL(presignedUrlData.data.GetSiteBrandingLogoPresignedURL);
                setUploadingToS3(true);
                await (0, (/*@__PURE__*/$parcel$interopDefault($18ae57eea10fd4c8$exports))).put(fileUrl.toString(), file, {
                    headers: {
                        'Content-Type': file.type
                    }
                });
                setUploadingToS3(false);
                const logoUrl = `${fileUrl.origin}${fileUrl.pathname}`;
                setLogo(logoUrl);
                setNonCachedLogo($5e245eaf8da83742$var$getNonCachedLogo(logoUrl));
            } catch (e) {
                setUploadingToS3(false);
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error has occurred, please try again.');
            }
            // Return false so that image is not automatically uploaded
            return false;
        }
    };
    // Color helper functions
    const chooseMoreColors = (category, currentColorSelected)=>{
        setIsModalVisible(true);
        setMoreColorHex(currentColorSelected);
        setColorCategory(category);
    };
    const moreColorChooseModalHandleOk = ()=>{
        setIsModalVisible(false);
        dispatch({
            type: colorCategory,
            payload: {
                [colorCategory]: moreColorHex
            }
        });
    };
    const moreColorChooseModalHandleCancel = ()=>{
        setIsModalVisible(false);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (!isDomainLive) {
            // if custom domain is not working
            // and we need to run some checks to display why
            // fetch the current status of the certificate (this will also trigger an update to the CustomDomain status in the db)
            getCustomDomainCertificateStatus();
            // fetch the current status of the cname
            getCustomDomainCnameStatus();
        }
    }, [
        isDomainLive
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (customDomain?.name) checkIfCustomDomainIsLive();
    }, [
        customDomain?.name,
        CustomDomainCertificateStatus?.Status,
        cnameError
    ]);
    (0, $6fFrj.useEffect)(()=>{
        // Set custom domain initial values
        if (customDomainQueryData) // If it exists, get custom domain name and id
        {
            if (customDomainQueryData.CustomDomainUser?.name) {
                const { id: id, name: name } = customDomainQueryData.CustomDomainUser;
                setCustomDomain({
                    id: id,
                    name: name
                });
                const [subdomainSection, ...domainSection] = name.split('.');
                // Separate subdomain and domain and save data in state
                setSubdomain(subdomainSection);
                setDomain(domainSection.join('.'));
            }
        }
    }, [
        customDomainQueryData
    ]);
    (0, $6fFrj.useEffect)(()=>{
        // Set logo and custom layout initial values
        if (customLayoutData?.CustomLayout) setCustomLayoutInitialValues(customLayoutData.CustomLayout);
    }, [
        customLayoutData
    ]);
    if (loadingCustomDomainQuery || loadingCustomLayoutQuery) return (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
        size: "large"
    });
    return (0, $bb3TF.jsxs)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
        style: {
            backgroundColor: 'white'
        },
        children: [
            (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                direction: "vertical",
                style: {
                    width: '98%'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $58c1491b566e843c$export$2e2bcd8739ae039), {
                        title: "Custom Branding",
                        tooltipTitle: "How does this work?",
                        tooltipContent: (0, $bb3TF.jsx)($5e245eaf8da83742$var$Paragraph, {
                            children: "You can use options below to customize Taxaroo so that it better matches your brand. The theming will only be visible to clients, so use the preview provided to evaluate your selections. Using custom domain on Taxaroo allows your firm to have your client portal hosted on a subdomain of your main website domain name."
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $3b9f153858b4bc0b$export$2e2bcd8739ae039), {
                        customDomain: customDomain,
                        status: CustomDomainCertificateStatus?.Status || customDomainQueryData.CustomDomainUser?.status,
                        failureReason: CustomDomainCertificateStatus?.FailureReason,
                        cnameError: cnameError,
                        domain: domain,
                        enableEditCustomDomain: enableEditCustomDomain,
                        handleCreateDomain: handleCreateDomain,
                        handleRemoveDomain: handleRemoveDomain,
                        loadingCreateMutation: loadingCreateMutation,
                        loadingDeleteMutation: loadingDeleteMutation,
                        setDomain: setDomain,
                        setEnableEditCustomDomain: setEnableEditCustomDomain,
                        setSubdomain: setSubdomain,
                        setVisibleTooltip: setVisibleTooltip,
                        subdomain: subdomain,
                        visibleTooltip: visibleTooltip,
                        handleGetCertificateStatus: handleGetCertificateStatus,
                        handleResendEmails: handleResendEmails,
                        certificateStatusLoading: certificateStatusLoading,
                        resendEmailsLoading: resendEmailsLoading,
                        certificateStatus: certificateStatus
                    }),
                    (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {
                        className: $64b53e1ac5906baf$export$88c3753063c50488
                    }),
                    (0, $bb3TF.jsx)((0, $2feb255bcb517355$export$2e2bcd8739ae039), {
                        logo: logo,
                        draggerProps: draggerProps,
                        setLogo: (s)=>{
                            setLogo(s);
                            setNonCachedLogo($5e245eaf8da83742$var$getNonCachedLogo(s));
                        },
                        isLoading: Boolean(presignedUrlLoading || uploadingToS3)
                    }),
                    (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {
                        className: $64b53e1ac5906baf$export$88c3753063c50488
                    }),
                    (0, $bb3TF.jsx)((0, $01372aee6ada4504$export$2e2bcd8739ae039), {
                        category: (0, $dac1b49dd4f1f064$export$18180bcdd5fcbb1).HEADER_BACKGROUND_COLOR,
                        chooseMoreColors: chooseMoreColors,
                        colors: (0, $82f5f3015083ef55$export$8f45430ccf837300),
                        customColor: customColors.headerBackgroundColor,
                        dispatch: dispatch,
                        title: "Step 3"
                    }),
                    (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {
                        className: $64b53e1ac5906baf$export$88c3753063c50488
                    }),
                    (0, $bb3TF.jsx)((0, $01372aee6ada4504$export$2e2bcd8739ae039), {
                        category: (0, $dac1b49dd4f1f064$export$18180bcdd5fcbb1).HEADER_FONT_COLOR,
                        chooseMoreColors: chooseMoreColors,
                        colors: (0, $82f5f3015083ef55$export$8f45430ccf837300),
                        customColor: customColors.headerFontColor,
                        dispatch: dispatch,
                        title: "Step 4"
                    }),
                    (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {
                        className: $64b53e1ac5906baf$export$88c3753063c50488
                    }),
                    (0, $bb3TF.jsx)((0, $c9b128c36f529098$export$2e2bcd8739ae039), {
                        customColors: customColors,
                        logo: nonCachedLogo
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        style: {
                            marginTop: 20
                        },
                        justify: "space-between",
                        gutter: 16,
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                className: "gutter-row",
                                sm: 24,
                                lg: 12,
                                children: (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    onClick: handleUpsertCustomLayout,
                                    icon: (0, $bb3TF.jsx)($5e245eaf8da83742$var$SaveOutlined, {}),
                                    loading: loadingCreateLayout || loadingUpdateLayout,
                                    children: "Save changes"
                                })
                            }),
                            (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                md: 24,
                                lg: 12,
                                style: {
                                    display: 'flex',
                                    justifyContent: 'flex-end'
                                },
                                children: [
                                    (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                                        onClick: handleCancelChanges,
                                        icon: (0, $bb3TF.jsx)($5e245eaf8da83742$var$CloseOutlined, {}),
                                        style: {
                                            marginRight: 10
                                        },
                                        children: "Cancel changes"
                                    }),
                                    (0, $bb3TF.jsx)((0, $a361442371f1d4e9$export$2e2bcd8739ae039), {
                                        title: "Are you sure you want to reset to default values?",
                                        onConfirm: handleResetDefault,
                                        okText: "Yes",
                                        cancelText: "No",
                                        placement: "topRight",
                                        children: (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                                            danger: true,
                                            children: "Reset Default"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
                smallTitle: true,
                title: (0, $82f5f3015083ef55$export$fc6e89e9bf9f348b)[colorCategory],
                width: 300,
                visible: isModalVisible,
                onOk: moreColorChooseModalHandleOk,
                onCancel: moreColorChooseModalHandleCancel,
                children: (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    gutter: 16,
                    children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 24,
                        children: (0, $bb3TF.jsx)((0, $dcbae8534cd3514b$export$2e2bcd8739ae039), {
                            triangle: "hide",
                            styles: {
                                default: {
                                    card: {
                                        minWidth: 'fit-content'
                                    }
                                }
                            },
                            colors: (0, $82f5f3015083ef55$export$6b5388d74f5e0c9d),
                            color: moreColorHex,
                            onChange: (color)=>setMoreColorHex(color?.hex)
                        })
                    })
                })
            }),
            (0, $bb3TF.jsxs)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
                title: "First Step: Activate Certificate",
                width: "75%",
                open: isDomainsModalVisible,
                onCancel: ()=>setIsDomainsModalVisible(false),
                footer: [
                    (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                        onClick: ()=>setIsDomainsModalVisible(false),
                        type: "primary",
                        children: "Accept"
                    })
                ],
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        gutter: 16,
                        children: (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            span: 24,
                            children: [
                                "We have triggered an email sent to the technical contact on your domain registration (ex on Godaddy or Network Solutions, etc) that you must approve for the SSL certificate of your white-labled client interview portal to work properly on the subdomain of your domain name. Please click the link in that email to approve this to complete your custom domain setup.",
                                (0, $bb3TF.jsxs)("ul", {
                                    children: [
                                        (0, $bb3TF.jsx)("li", {
                                            children: `admin@${domain}`
                                        }),
                                        (0, $bb3TF.jsx)("li", {
                                            children: `administrator@${domain}`
                                        }),
                                        (0, $bb3TF.jsx)("li", {
                                            children: `hostmaster@${domain}`
                                        }),
                                        (0, $bb3TF.jsx)("li", {
                                            children: `postmaster@${domain}`
                                        }),
                                        (0, $bb3TF.jsx)("li", {
                                            children: `webmaster@${domain}`
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            span: 24,
                            children: (0, $bb3TF.jsxs)($5e245eaf8da83742$var$Paragraph, {
                                children: [
                                    (0, $bb3TF.jsx)("br", {}),
                                    "*Activating your certificate is the first step of two. In the next step, you will add a DNS record."
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $5e245eaf8da83742$export$2e2bcd8739ae039 = $5e245eaf8da83742$var$SiteBranding;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");








const { DeleteOutlined: $644ba4d681f5ca51$var$DeleteOutlined, ToolFilled: $644ba4d681f5ca51$var$ToolFilled, WarningFilled: $644ba4d681f5ca51$var$WarningFilled, CheckCircleFilled: $644ba4d681f5ca51$var$CheckCircleFilled } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Paragraph: $644ba4d681f5ca51$var$Paragraph, Text: $644ba4d681f5ca51$var$Text, Title: $644ba4d681f5ca51$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $644ba4d681f5ca51$var$validationSchema = $ee6ba11cc5736d52$export$185802fd694ee1f5().shape({
    email: $2746dd37f1d91ea1$export$185802fd694ee1f5().email('Please enter a valid email').required('Email is required')
});
const $644ba4d681f5ca51$var$Calendars = ()=>{
    const navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    // const [getAuthUrl, { loading: loadingAuthUrl, error: errorAuthUrl }] =
    //   useGetNylasAuthUrlMutation();
    const [getCalendarOauthUrl, { loading: loadingCalendarOauthUrl, error: errorCalendarOauthUrl }] = (0, $cfef3f1bede5cb90$export$e17d833f6fc5a980)();
    // const handleEmailSync = async (email: string) => {
    //   const result = await getAuthUrl({
    //     variables: {
    //       input: {
    //         email,
    //         callbackUrl: `${window.location.origin}/settings/calendars`,
    //       },
    //     },
    //   });
    //   window.location.href = result.data.getNylasAuthUrl.url;
    // };
    // const formik = useFormik({
    //   initialValues: { email: '' },
    //   validationSchema,
    //   onSubmit: (values) => {
    //     handleEmailSync(values.email);
    //   },
    // });
    // const { touched, values, errors, handleSubmit, handleChange } = formik;
    const [searchParams, setSearchParams] = (0, $a6e470ffbc8d2470$export$f1a78c17382fe22a)();
    const handleOnError = (error)=>{
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`An error has occurred: ${error.message}.`);
    };
    // const {
    //   data: accounts,
    //   loading: loadingAccounts,
    //   error: errorAccounts,
    // } = useGetNylasAccountsQuery();
    const { data: externalCalendars, loading: loadingExternalCalendars, error: errorExternalCalendars } = (0, $732264f53056e08f$export$d9ea033fb1dff7c9)();
    // const [deleteNylasAccountMutation, { loading: loadingDeleteNylasAccount }] =
    //   useDeleteNylasAccountMutation({
    //     onError: handleOnError,
    //     refetchQueries: [GetNylasAccountsDocument],
    //     awaitRefetchQueries: true,
    //   });
    const [disconnectExternalCalendar, { loading: loadingDisconnectExternalCalendar }] = (0, $33beb5b1bfae180c$export$db8c30ad7ae8d2af)({
        onError: handleOnError,
        refetchQueries: [
            (0, $732264f53056e08f$export$1c391ecc5d16fdd6)
        ],
        awaitRefetchQueries: true
    });
    const handleDisconnectCalendar = async (externalCalendarId)=>{
        await disconnectExternalCalendar({
            variables: {
                externalCalendarId: externalCalendarId
            }
        });
    };
    const [authUrlCallback, { loading: loadingAuthUrlCallback }] = (0, $33beb5b1bfae180c$export$8c193a78072ec72a)({
        onError: handleOnError,
        refetchQueries: [
            (0, $732264f53056e08f$export$958be556361890bd)
        ],
        awaitRefetchQueries: true
    });
    const { data: firmSettingsData, loading: firmSettingsLoading, error: firmSettingsError } = (0, $732264f53056e08f$export$1757fc42814f776a)({
        variables: {
            name: 'disable-taxaroo-calendar'
        }
    });
    const [disableTaxarooCalendarValue, setDisableTaxarooCalendarValue] = (0, $6fFrj.useState)(false);
    const [createFirmSetting, { loading: createFirmSettingLoading }] = (0, $33beb5b1bfae180c$export$1ff58c91a8b6e9e1)({
        onError: handleOnError,
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$d44bacce7a2eea3),
                variables: {
                    name: 'disable-taxaroo-calendar'
                }
            }
        ],
        awaitRefetchQueries: true
    });
    const [updateFirmSetting, { loading: updateFirmSettingLoading }] = (0, $33beb5b1bfae180c$export$1a4761718d2c597b)({
        onError: handleOnError,
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$d44bacce7a2eea3),
                variables: {
                    name: 'disable-taxaroo-calendar'
                }
            }
        ],
        awaitRefetchQueries: true
    });
    (0, $6fFrj.useEffect)(()=>{
        if (firmSettingsData?.getFirmSetting?.name) // eslint-disable-next-line no-underscore-dangle
        {
            if (firmSettingsData.getFirmSetting.value.__typename === 'BooleanValue') setDisableTaxarooCalendarValue(firmSettingsData.getFirmSetting.value.boolValue);
        }
    }, [
        firmSettingsData?.getFirmSetting
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (searchParams.get('state') && searchParams.get('code')) {
            const code = searchParams.get('code');
            const handleAuthUrlCallback = async (theCode)=>{
                await authUrlCallback({
                    variables: {
                        input: {
                            code: theCode
                        }
                    }
                });
            };
            handleAuthUrlCallback(code);
        }
    }, []);
    (0, $6fFrj.useEffect)(()=>{
        if (errorExternalCalendars) return handleOnError(errorExternalCalendars);
        if (errorCalendarOauthUrl) return handleOnError(errorCalendarOauthUrl);
        if (firmSettingsError) return handleOnError(firmSettingsError);
        return null;
    }, [
        errorExternalCalendars,
        errorCalendarOauthUrl,
        firmSettingsError
    ]);
    const changeDisableTaxarooCalendarSetting = async (val)=>{
        if (firmSettingsData?.getFirmSetting?.id) await updateFirmSetting({
            variables: {
                id: firmSettingsData.getFirmSetting.id,
                value: String(val)
            }
        });
        else await createFirmSetting({
            variables: {
                name: firmSettingsData.getFirmSetting.name,
                value: String(val)
            }
        });
    };
    const handleConnectExternalCalendar = (provider)=>{
        getCalendarOauthUrl({
            variables: {
                provider: provider
            },
            onCompleted: (data)=>{
                window.location.href = data.getCalendarOauthUrl;
            }
        });
    };
    return (0, $bb3TF.jsxs)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
        style: {
            backgroundColor: 'white'
        },
        children: [
            (0, $bb3TF.jsx)((0, $58c1491b566e843c$export$2e2bcd8739ae039), {
                title: "Calendars",
                tooltipTitle: "What do we do with this information?",
                tooltipContent: (0, $bb3TF.jsx)($644ba4d681f5ca51$var$Paragraph, {
                    children: (0, $bb3TF.jsx)($644ba4d681f5ca51$var$Text, {
                        children: "Calendars"
                    })
                })
            }),
            (0, $bb3TF.jsxs)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                style: {
                    paddingTop: '10px'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($644ba4d681f5ca51$var$Paragraph, {
                            children: (0, $bb3TF.jsx)($644ba4d681f5ca51$var$Text, {
                                children: "Synchronize your Google or Outlook calendar"
                            })
                        })
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        gutter: 15,
                        style: {
                            marginBottom: '15px'
                        },
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                    onClick: ()=>handleConnectExternalCalendar('GOOGLE'),
                                    children: "Google Calendar"
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                    onClick: ()=>handleConnectExternalCalendar('MICROSOFT'),
                                    children: "Microsoft Outlook"
                                })
                            })
                        ]
                    }),
                    loadingExternalCalendars || loadingDisconnectExternalCalendar || loadingAuthUrlCallback ? (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        align: "middle",
                        justify: "center",
                        children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                            size: "large"
                        })
                    }) : externalCalendars?.getExternalCalendars.map((account)=>(0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            style: {
                                paddingBottom: '10px'
                            },
                            children: [
                                (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                    style: {
                                        width: '50%'
                                    },
                                    children: (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                                        size: "middle",
                                        children: [
                                            (0, $bb3TF.jsx)($644ba4d681f5ca51$var$Text, {
                                                children: account.provider
                                            }),
                                            (0, $bb3TF.jsx)($644ba4d681f5ca51$var$Text, {
                                                children: account.connectedEmail
                                            })
                                        ]
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                    children: (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                        gutter: 15,
                                        children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                            children: (0, $bb3TF.jsx)((0, $92b07c154bbb4d14$export$2e2bcd8739ae039), {
                                                tooltip: "Disconnect Calendar",
                                                confirmAction: true,
                                                confirmLabel: "Are you sure?",
                                                onClick: ()=>handleDisconnectCalendar(account.id),
                                                buttonProps: {
                                                    type: 'primary'
                                                },
                                                children: (0, $bb3TF.jsx)($644ba4d681f5ca51$var$DeleteOutlined, {})
                                            })
                                        })
                                    })
                                })
                            ]
                        }, account.id))
                ]
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                style: {
                    paddingTop: '20px'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        style: {
                            width: '100%'
                        },
                        children: (0, $bb3TF.jsx)($644ba4d681f5ca51$var$Title, {
                            level: 5,
                            children: "Settings"
                        })
                    }),
                    firmSettingsLoading && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        align: "middle",
                        justify: "center",
                        children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                            size: "large"
                        })
                    }),
                    firmSettingsData?.getFirmSetting?.description && (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        gutter: 15,
                        align: "middle",
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                style: {
                                    width: '60%'
                                },
                                children: (0, $bb3TF.jsx)($644ba4d681f5ca51$var$Text, {
                                    children: firmSettingsData.getFirmSetting.description
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                children: (0, $bb3TF.jsx)((0, $4fd303306a27e42e$export$2e2bcd8739ae039), {
                                    onChange: (val)=>changeDisableTaxarooCalendarSetting(val),
                                    checked: disableTaxarooCalendarValue,
                                    loading: createFirmSettingLoading || updateFirmSettingLoading
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $644ba4d681f5ca51$export$2e2bcd8739ae039 = $644ba4d681f5ca51$var$Calendars;


var $2aa219cb80eed11e$export$2e2bcd8739ae039 = (0, $644ba4d681f5ca51$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");






var $04e55200d1b63c0c$export$e8c9778bf415dd08;
var $04e55200d1b63c0c$export$1a952fe22cdce89e;
$04e55200d1b63c0c$export$e8c9778bf415dd08 = `GR6x8W_divider`;
$04e55200d1b63c0c$export$1a952fe22cdce89e = `GR6x8W_sectionTitle`;



const { Title: $4325d8ed5326d036$var$Title, Text: $4325d8ed5326d036$var$Text, Paragraph: $4325d8ed5326d036$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { Option: $4325d8ed5326d036$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
// interface NotificationsProps {}
const $4325d8ed5326d036$var$Notifications = ()=>{
    const [emailToYouOrTeamToUpdate, setEmailToYouOrTeamToUpdate] = (0, $6fFrj.useState)([]);
    const [emailToClientsToUpdate, setEmailToClientsToUpdate] = (0, $6fFrj.useState)([]);
    const [currentlyCheckedEmailToClients, setCurrentlyCheckedEmailToClients] = (0, $6fFrj.useState)(null);
    const [clientRemindersToUpdate, setClientRemindersToUpdate] = (0, $6fFrj.useState)([]);
    const [currentlyCheckedReminders, setCurrentlyCheckedReminders] = (0, $6fFrj.useState)(null);
    const [clientReminderFrequencyToUpdate, setClientReminderFrequencyToUpdate] = (0, $6fFrj.useState)([]);
    const [clientMaxRemindersToUpdate, setClientMaxRemindersToUpdate] = (0, $6fFrj.useState)([]);
    const [maxReminders, setMaxReminders] = (0, $6fFrj.useState)();
    const [frequency, setFrequency] = (0, $6fFrj.useState)();
    const [isReminderEditorActive, setIsReminderEditorActive] = (0, $6fFrj.useState)(false);
    const { showModal: showModal, accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    // Get firm notifications
    const { data: notificationsData, loading: loadingGetNotifications } = (0, $732264f53056e08f$export$1c0bc3e3ba440b3)();
    // Update firm notifications
    const [updateFirmNotificationsMutation, { loading: loadingUpdateNotifications }] = (0, $33beb5b1bfae180c$export$7fd593d2e3e2fa1c)({
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Notifications updated successfully');
            setEmailToClientsToUpdate([]);
            setEmailToYouOrTeamToUpdate([]);
        },
        onError: (error)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message)
    });
    const [createFirmNotificationReminderMutation, { loading: loadingCreateFirmNotificationsReminder }] = (0, $33beb5b1bfae180c$export$b2eab14b2da19b5f)({
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Client reminder created successfully');
            setClientRemindersToUpdate([]);
            setClientReminderFrequencyToUpdate([]);
            setClientMaxRemindersToUpdate([]);
        },
        onError: (error)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message, 10),
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$2f920ec7f11a1ff5)
            }
        ],
        awaitRefetchQueries: true
    });
    const [updateFirmNotificationReminderMutation, { loading: loadingUpdateFirmNotificationsReminder }] = (0, $33beb5b1bfae180c$export$4c20fcf201489f71)({
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Client reminder updated successfully');
            setClientRemindersToUpdate([]);
            setClientReminderFrequencyToUpdate([]);
            setClientMaxRemindersToUpdate([]);
        },
        onError: (error)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message, 10)
    });
    const [deleteFirmNotificationReminderMutation, { loading: loadingDeleteFirmNotificationsReminder }] = (0, $33beb5b1bfae180c$export$aacbfa8f3fc4b975)({
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Client reminder deleted successfully');
            setClientRemindersToUpdate([]);
            setClientReminderFrequencyToUpdate([]);
            setClientMaxRemindersToUpdate([]);
        },
        onError: (error)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message, 10),
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$2f920ec7f11a1ff5)
            }
        ],
        awaitRefetchQueries: true
    });
    // Set new client data
    (0, $6fFrj.useEffect)(()=>{
        if (notificationsData) {
            const activeReminder = notificationsData.getFirmNotifications.REMINDERS.find((r)=>r.active);
            if (activeReminder) {
                setMaxReminders(activeReminder.FirmNotificationReminder.maxReminders);
                setFrequency(activeReminder.FirmNotificationReminder.frequency);
            } else {
                setMaxReminders(undefined);
                setFrequency(undefined);
            }
        }
        setIsReminderEditorActive(notificationsData?.getFirmNotifications?.REMINDERS.filter((x)=>x?.active)?.length > 0);
    }, [
        notificationsData
    ]);
    // Groups default values
    const activetTeamIds = notificationsData?.getFirmNotifications?.TEAM.filter((item)=>item?.active === true).map((item)=>item.id);
    const activeClientIds = notificationsData?.getFirmNotifications?.CLIENT.filter((item)=>item?.active === true && (item?.Notifications?.name !== 'client-birthday' || accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).birthdayEmails])).map((item)=>item.id);
    // useEffect to set CurrentlyCheckedEmailToClients to activeClientIds on page load
    (0, $6fFrj.useEffect)(()=>{
        if (activeClientIds && currentlyCheckedEmailToClients === null) setCurrentlyCheckedEmailToClients(activeClientIds);
    }, [
        activeClientIds,
        setCurrentlyCheckedEmailToClients
    ]);
    const activeReminderIds = notificationsData?.getFirmNotifications?.REMINDERS.filter((item)=>item?.active === true && (item?.Notifications?.name !== 'firm-requests-document-client-hasnt-sent-it' || accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).followUps])).map((item)=>item.id);
    // useEffect to set CurrentlyCheckedReminders to activeReminderIds on page load
    (0, $6fFrj.useEffect)(()=>{
        if (activeReminderIds && currentlyCheckedReminders === null) setCurrentlyCheckedReminders(activeReminderIds);
    }, [
        activeReminderIds,
        setCurrentlyCheckedReminders
    ]);
    // Groups options
    const emailToYouAndTeamOptions = notificationsData?.getFirmNotifications?.TEAM.map((item)=>({
            value: item.id,
            label: item.Notifications.description
        }));
    const emailToClientOptions = notificationsData?.getFirmNotifications?.CLIENT.map((item)=>({
            value: item.id,
            label: item.Notifications.description,
            disabled: item.Notifications.name === 'client-birthday' && !accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).birthdayEmails]
        }));
    const eventRemindersToClientOptions = notificationsData?.getFirmNotifications?.REMINDERS.map((item)=>({
            value: item.id,
            label: item.Notifications.description,
            disabled: item.Notifications.name === 'firm-requests-document-client-hasnt-sent-it' && !accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).followUps]
        }));
    const days = [
        1,
        2,
        3,
        4,
        5,
        6,
        7
    ];
    // Groups handle change
    const handleChangeTeamValues = (value)=>{
        const updatedValues = notificationsData?.getFirmNotifications?.TEAM.map(({ id: id, notificationId: notificationId })=>({
                id: id,
                notificationId: notificationId,
                active: value.includes(id)
            }));
        const results = updatedValues.filter(({ id: id1, active: active1 })=>!notificationsData?.getFirmNotifications?.TEAM.some(({ id: id2, active: active2 })=>id2 === id1 && active1 === active2));
        if (results) setEmailToYouOrTeamToUpdate([
            ...results
        ]);
        else setEmailToYouOrTeamToUpdate([]);
    };
    const handleChangeClientValues = (values)=>{
        const updatedValues = notificationsData?.getFirmNotifications?.CLIENT.map(({ id: id, notificationId: notificationId })=>({
                id: id,
                notificationId: notificationId,
                active: values.includes(id)
            }));
        const results = updatedValues.filter(({ id: id1, active: active1 })=>!notificationsData?.getFirmNotifications?.CLIENT.some(({ id: id2, active: active2 })=>id2 === id1 && active1 === active2));
        if (results) setEmailToClientsToUpdate([
            ...results
        ]);
        else setEmailToClientsToUpdate([]);
    };
    const handleChangeRemindersValues = (values)=>{
        setIsReminderEditorActive(values?.length > 0);
        if (values?.length > 0) {
            if (!frequency && !maxReminders) {
                const activeReminder = notificationsData.getFirmNotifications?.REMINDERS?.find((r)=>r.active);
                if (activeReminder) {
                    setMaxReminders(activeReminder.FirmNotificationReminder.maxReminders);
                    setFrequency(activeReminder.FirmNotificationReminder.frequency);
                } else {
                    setFrequency(4);
                    setMaxReminders(8);
                }
            }
        } else {
            setFrequency(null);
            setMaxReminders(null);
        }
        const updatedValues = notificationsData?.getFirmNotifications?.REMINDERS.map(({ id: id, notificationId: notificationId })=>({
                id: id,
                notificationId: notificationId,
                active: values.includes(id)
            }));
        const results = updatedValues.filter(({ id: id1, active: active1 })=>!notificationsData?.getFirmNotifications?.REMINDERS.some(({ id: id2, active: active2 })=>id2 === id1 && active1 === active2));
        if (results) setClientRemindersToUpdate([
            ...results
        ]);
        else setClientRemindersToUpdate([]);
    };
    const handleFrequencySelectChange = (values, value)=>{
        setFrequency(parseInt(value.key, 10));
        const updatedValues = notificationsData?.getFirmNotifications?.REMINDERS.map((firmNotification)=>({
                id: firmNotification.id,
                FirmNotificationReminder: {
                    frequency: parseInt(value.key, 10)
                }
            }));
        setClientReminderFrequencyToUpdate([
            updatedValues
        ]);
        if (parseInt(value.key, 10) === frequency) setClientReminderFrequencyToUpdate([]);
    };
    const handleMaxRemindersChange = (value)=>{
        setMaxReminders(value);
        const updatedValues = notificationsData?.getFirmNotifications?.REMINDERS.map((firmNotification)=>({
                id: firmNotification.id,
                FirmNotificationReminder: {
                    maxReminders: value
                }
            }));
        setClientMaxRemindersToUpdate([
            updatedValues
        ]);
        if (value === maxReminders) setClientMaxRemindersToUpdate([]);
    };
    const handleSaveChanges = ()=>{
        // if no access to birthday emails, strip them out of the array
        let emailToClientsToUpdateFiltered = null;
        if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).birthdayEmails]) {
            const birthdayNotificationId = notificationsData?.getFirmNotifications?.CLIENT.find((x)=>x?.Notifications.name === 'client-birthday')?.id;
            emailToClientsToUpdateFiltered = emailToClientsToUpdate?.filter((x)=>x?.id !== birthdayNotificationId);
        }
        // Update notifications
        if (emailToYouOrTeamToUpdate?.length || emailToClientsToUpdate?.length || clientRemindersToUpdate?.length) updateFirmNotificationsMutation({
            variables: {
                updateFirmNotificationsStatusInput: {
                    firmNotifications: emailToYouOrTeamToUpdate.concat(emailToClientsToUpdateFiltered || emailToClientsToUpdate).concat(clientRemindersToUpdate)
                }
            }
        });
        // Create new reminders
        const newReminderIds = clientRemindersToUpdate.filter((x)=>x?.active).map((x)=>x.id);
        const newReminders = newReminderIds.map((id)=>({
                id: id,
                frequency: frequency || 4,
                maxReminders: maxReminders || 8
            }));
        // console.log(`newReminders: ${JSON.stringify(newReminders)}`)
        // eslint-disable-next-line no-restricted-syntax
        for (const r of newReminders)createFirmNotificationReminderMutation({
            variables: {
                createFirmNotificationReminderInput: {
                    firmNotificationId: r.id,
                    frequency: r.frequency,
                    maxReminders: r.maxReminders
                }
            }
        });
        // Delete old reminders
        const oldReminderIds = clientRemindersToUpdate.filter((x)=>!x?.active).map((x)=>x.id);
        // console.log(`oldReminderIds: ${JSON.stringify(oldReminderIds)}`)
        // eslint-disable-next-line no-restricted-syntax
        for (const id of oldReminderIds)deleteFirmNotificationReminderMutation({
            variables: {
                id: id
            }
        });
        // Update existing reminders
        const frequencyUpdatedIds = (clientReminderFrequencyToUpdate[0] ?? []).map((x)=>x.id);
        const maxRemindersUpdatedIds = (clientMaxRemindersToUpdate[0] ?? []).map((x)=>x.id);
        const updatedReminderIds = frequencyUpdatedIds.concat(maxRemindersUpdatedIds.filter((x)=>!frequencyUpdatedIds.includes(x))).filter((x)=>!newReminderIds.includes(x) && !oldReminderIds.includes(x)).filter((id)=>notificationsData.getFirmNotifications.REMINDERS.find((r)=>r.id === id)?.FirmNotificationReminder?.id);
        const updatedReminders = updatedReminderIds.map((id)=>({
                id: id,
                frequency: frequency || 4,
                maxReminders: maxReminders || 8
            }));
        // console.log(`updatedReminders: ${JSON.stringify(updatedReminders)}`)
        // eslint-disable-next-line no-restricted-syntax
        for (const r of updatedReminders)updateFirmNotificationReminderMutation({
            variables: {
                updateFirmNotificationReminderInput: r
            }
        });
        const preferences = [];
        notificationsData?.getFirmNotifications?.TEAM.forEach((n)=>{
            const updated = emailToYouOrTeamToUpdate.find((toUpdate)=>toUpdate.id === n.id);
            preferences.push({
                [n.Notifications.description]: updated ? updated.active : n.active
            });
        });
        notificationsData?.getFirmNotifications?.CLIENT.forEach((n)=>{
            const updated = emailToClientsToUpdate.find((toUpdate)=>toUpdate.id === n.id);
            preferences.push({
                [n.Notifications.description]: updated ? updated.active : n.active
            });
        });
        notificationsData?.getFirmNotifications?.REMINDERS.forEach((n)=>{
            const updated = clientRemindersToUpdate.find((toUpdate)=>toUpdate.id === n.id);
            preferences.push({
                [n.Notifications.description]: updated ? updated.active : n.active
            });
        });
        (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
            Title: 'Save notification settings',
            Source: 'Button click',
            value: preferences.reduce((obj, item)=>({
                    ...obj,
                    ...item
                }), {}),
            url: window.location.href
        });
    };
    if (loadingGetNotifications) return (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
        size: "large"
    });
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)((0, $58c1491b566e843c$export$2e2bcd8739ae039), {
                title: "Notifications",
                tooltipTitle: "Notification Settings",
                tooltipContent: (0, $bb3TF.jsxs)($4325d8ed5326d036$var$Paragraph, {
                    children: [
                        `You can configure whether or not to receive email notifications for
            certain actions taken by clients, and whether or not send clients automated emails based on your team's actions.`,
                        (0, $bb3TF.jsx)("br", {}),
                        (0, $bb3TF.jsx)("br", {}),
                        "Not all emails are configurable yet, but additional options continue to be added over time."
                    ]
                })
            }),
            (0, $bb3TF.jsx)($4325d8ed5326d036$var$Title, {
                level: 5,
                className: $04e55200d1b63c0c$export$1a952fe22cdce89e,
                children: "Actions that generate an email to you or your team"
            }),
            (0, $bb3TF.jsx)((0, $66ef76fa6be8ca1a$export$2e2bcd8739ae039).Group, {
                defaultValue: activetTeamIds,
                className: "checkbox-group",
                options: emailToYouAndTeamOptions,
                onChange: handleChangeTeamValues,
                disabled: loadingUpdateNotifications || loadingCreateFirmNotificationsReminder || loadingDeleteFirmNotificationsReminder || loadingUpdateFirmNotificationsReminder
            }),
            (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {
                className: $04e55200d1b63c0c$export$e8c9778bf415dd08
            }),
            (0, $bb3TF.jsx)($4325d8ed5326d036$var$Title, {
                level: 5,
                className: $04e55200d1b63c0c$export$1a952fe22cdce89e,
                children: "Actions that generate notifications to your clients"
            }),
            (0, $bb3TF.jsx)("div", {
                className: "checkbox-group",
                children: emailToClientOptions.map((item)=>(0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                        title: item.label.includes('birthday') && item.disabled ? 'Automated birthday emails are only available on the Pro Plan' : null,
                        placement: "topLeft",
                        children: (0, $bb3TF.jsx)("div", {
                            style: {
                                display: 'inline-block'
                            },
                            children: (0, $bb3TF.jsx)((0, $66ef76fa6be8ca1a$export$2e2bcd8739ae039), {
                                disabled: item.disabled,
                                style: {
                                    marginLeft: 0
                                },
                                checked: currentlyCheckedEmailToClients?.includes(item.value),
                                onChange: (e)=>{
                                    const checkedValues = [
                                        ...currentlyCheckedEmailToClients
                                    ];
                                    if (e.target.checked) checkedValues.push(item.value);
                                    else checkedValues.splice(checkedValues.indexOf(item.value), 1);
                                    setCurrentlyCheckedEmailToClients(checkedValues);
                                    handleChangeClientValues(checkedValues);
                                },
                                children: item.label
                            })
                        })
                    }, item.value))
            }),
            (0, $bb3TF.jsx)("div", {
                style: {
                    height: '35px'
                }
            }),
            (0, $bb3TF.jsx)((0, $58c1491b566e843c$export$2e2bcd8739ae039), {
                title: "Automated Follow-ups",
                tooltipTitle: "Automated Follow-up Settings",
                tooltipContent: (0, $bb3TF.jsx)($4325d8ed5326d036$var$Paragraph, {
                    children: "You can configure frequency and maximum number of reminders sent periodically to your clients."
                })
            }),
            (0, $bb3TF.jsx)("div", {
                className: "checkbox-group",
                children: eventRemindersToClientOptions.map((item)=>(0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                        title: item.label.includes('requested') && item.disabled ? 'Automated follow-up emails are only available on the Pro Plan' : null,
                        placement: "topLeft",
                        children: (0, $bb3TF.jsx)("div", {
                            style: {
                                display: 'inline-block'
                            },
                            children: (0, $bb3TF.jsx)((0, $66ef76fa6be8ca1a$export$2e2bcd8739ae039), {
                                disabled: item.disabled,
                                style: {
                                    marginLeft: 0
                                },
                                checked: currentlyCheckedReminders?.includes(item.value),
                                onChange: (e)=>{
                                    const checkedValues = [
                                        ...currentlyCheckedReminders
                                    ];
                                    if (e.target.checked) checkedValues.push(item.value);
                                    else checkedValues.splice(checkedValues.indexOf(item.value), 1);
                                    setCurrentlyCheckedReminders(checkedValues);
                                    handleChangeRemindersValues(checkedValues);
                                },
                                children: item.label
                            })
                        })
                    }, item.value))
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    10,
                    0
                ],
                style: {
                    marginTop: 15,
                    marginLeft: 45
                },
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 7,
                        style: {
                            maxWidth: '11em'
                        },
                        children: (0, $bb3TF.jsx)($4325d8ed5326d036$var$Text, {
                            style: {
                                fontFamily: 'sans-serif',
                                zoom: 1.2
                            },
                            children: "Frequency:"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                            value: `${frequency ? `Every ${frequency} day(s)` : ''}`,
                            style: {
                                width: 175
                            },
                            onChange: (label, value)=>handleFrequencySelectChange(label, value),
                            disabled: loadingUpdateNotifications || loadingCreateFirmNotificationsReminder || loadingDeleteFirmNotificationsReminder || loadingUpdateFirmNotificationsReminder || !isReminderEditorActive || !accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).followUps],
                            children: days.map((item)=>(0, $bb3TF.jsx)($4325d8ed5326d036$var$Option, {
                                    value: `Every ${item} day(s)`,
                                    label: `${notificationsData?.getFirmNotifications?.REMINDERS[0]?.id}`,
                                    children: `Every ${item} day(s)`
                                }, item))
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                gutter: [
                    10,
                    0
                ],
                style: {
                    marginTop: 10,
                    marginLeft: 45
                },
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        span: 7,
                        style: {
                            maxWidth: '11em'
                        },
                        children: (0, $bb3TF.jsx)($4325d8ed5326d036$var$Text, {
                            style: {
                                fontFamily: 'sans-serif',
                                zoom: 1.2
                            },
                            children: "Maximum number of reminders:"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $4d58e046767e1c41$export$2e2bcd8739ae039), {
                            min: 1,
                            max: 365,
                            value: maxReminders,
                            style: {
                                width: 175
                            },
                            onChange: handleMaxRemindersChange,
                            disabled: loadingUpdateNotifications || loadingCreateFirmNotificationsReminder || loadingDeleteFirmNotificationsReminder || loadingUpdateFirmNotificationsReminder || !isReminderEditorActive || !accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).followUps]
                        })
                    })
                ]
            }),
            (0, $bb3TF.jsx)("div", {
                style: {
                    height: '30px'
                }
            }),
            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                type: "primary",
                size: "large",
                onClick: handleSaveChanges,
                disabled: emailToYouOrTeamToUpdate?.length === 0 && emailToClientsToUpdate?.length === 0 && clientRemindersToUpdate?.length === 0 && clientReminderFrequencyToUpdate?.length === 0 && clientMaxRemindersToUpdate?.length === 0,
                loading: loadingUpdateNotifications || loadingCreateFirmNotificationsReminder || loadingDeleteFirmNotificationsReminder || loadingUpdateFirmNotificationsReminder,
                children: "Save Updates"
            })
        ]
    });
};
var $4325d8ed5326d036$export$2e2bcd8739ae039 = $4325d8ed5326d036$var$Notifications;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

var $ipnkk = parcelRequire("ipnkk");





const { InfoCircleTwoTone: $472cf947bf00085b$var$InfoCircleTwoTone } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Title: $472cf947bf00085b$var$Title, Paragraph: $472cf947bf00085b$var$Paragraph, Text: $472cf947bf00085b$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { TextArea: $472cf947bf00085b$var$TextArea } = (0, $1fb834916a156dcf$export$2e2bcd8739ae039);
// interface PixelProps {}
const $472cf947bf00085b$var$Pixels = ()=>{
    const { data: data, loading: loadingGetCustomLayout } = (0, $732264f53056e08f$export$a9d926e7a1510ac6)();
    const [updatePixelsMutation, { loading: loading }] = (0, $33beb5b1bfae180c$export$bae89db0f7715647)({
        onCompleted: ()=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Pixels updated successfully'),
        onError: (error)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message)
    });
    const { showModal: showModal, hideModal: hideModal, accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    const validationSchema = $ee6ba11cc5736d52$export$185802fd694ee1f5().shape({
        pixelCode: $2746dd37f1d91ea1$export$185802fd694ee1f5().nullable()
    });
    const [savedPixelCode, setSavedPixelCode] = (0, $6fFrj.useState)('');
    const [pixelCode, setPixelCode] = (0, $6fFrj.useState)('');
    const formik = (0, $ipnkk.useFormik)({
        initialValues: {
            pixelCode: ''
        },
        validationSchema: validationSchema,
        onSubmit: (values)=>{
            updatePixelsMutation({
                variables: {
                    updateCustomLayoutInput: {
                        pixelCode: values.pixelCode
                    }
                },
                onCompleted: ()=>{
                    setSavedPixelCode(pixelCode);
                }
            });
        }
    });
    const getMoreInfoContent = ()=>(0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            children: (0, $bb3TF.jsx)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsxs)($472cf947bf00085b$var$Paragraph, {
                    children: [
                        "Place your pixel code to be added to your client portal here.",
                        ' ',
                        (0, $bb3TF.jsx)("a", {
                            href: "https://help.taxaroo.com/article/31-how-pixels-work",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "See our help document here"
                        }),
                        "."
                    ]
                })
            })
        });
    (0, $6fFrj.useEffect)(()=>{
        const value = data?.CustomLayout?.pixelCode;
        setSavedPixelCode(value);
        setPixelCode(value);
    }, [
        data
    ]);
    (0, $6fFrj.useEffect)(()=>{
        formik.setFieldValue('pixelCode', pixelCode);
    }, [
        pixelCode
    ]);
    if (loadingGetCustomLayout) return (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
        size: "large"
    });
    // check if user has access to this feature
    if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).pixels]) showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).pixels, false);
    else hideModal();
    return (0, $bb3TF.jsx)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
        style: {
            backgroundColor: 'white'
        },
        children: (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
            direction: "vertical",
            style: {
                width: '98%'
            },
            children: [
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    gutter: 16,
                    style: {
                        borderBottom: '1px dashed #D6D6D6',
                        marginRight: 15
                    },
                    children: [
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsx)($472cf947bf00085b$var$Title, {
                                level: 3,
                                children: "Pixels Integration"
                            })
                        }),
                        (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
                                overlayStyle: {
                                    width: '50%'
                                },
                                placement: "right",
                                content: getMoreInfoContent,
                                title: "How does this work?",
                                trigger: "click",
                                children: (0, $bb3TF.jsx)($472cf947bf00085b$var$InfoCircleTwoTone, {})
                            })
                        })
                    ]
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsx)($472cf947bf00085b$var$Paragraph, {
                                children: (0, $bb3TF.jsx)($472cf947bf00085b$var$Text, {
                                    children: "Place your pixel code here."
                                })
                            })
                        })
                    })
                }),
                (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                    name: "primary",
                    onFinish: formik.handleSubmit,
                    children: [
                        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                style: {
                                    width: '80%'
                                },
                                children: (0, $bb3TF.jsx)($472cf947bf00085b$var$TextArea, {
                                    rows: 6,
                                    name: "pixelCode",
                                    value: pixelCode,
                                    onChange: (e)=>setPixelCode(e.target.value),
                                    disabled: loading
                                })
                            })
                        }),
                        formik.touched.pixelCode && formik.errors.pixelCode && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            message: formik.errors.pixelCode,
                            type: "error",
                            style: {
                                width: '80%'
                            }
                        }),
                        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                            gutter: 16,
                            style: {
                                marginTop: 20
                            },
                            children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                className: "gutter-row",
                                span: 6,
                                children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                    disabled: pixelCode === savedPixelCode,
                                    type: "primary",
                                    htmlType: "submit",
                                    loading: loading,
                                    children: "Save changes"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $472cf947bf00085b$export$2e2bcd8739ae039 = $472cf947bf00085b$var$Pixels;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


const { BankOutlined: $505bbb173d554bd0$var$BankOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $505bbb173d554bd0$var$StripeInfo = ({ handleSetError: handleSetError, isOnBoardingFinished: isOnBoardingFinished, areStripeInfoLoading: areStripeInfoLoading, connectAccountId: accountId })=>{
    const connectAccountId = (0, $6fFrj.useMemo)(()=>accountId, [
        accountId
    ]);
    const loadingStripeInfo = (0, $6fFrj.useMemo)(()=>areStripeInfoLoading, [
        areStripeInfoLoading
    ]);
    const finishedOnboarding = (0, $6fFrj.useMemo)(()=>isOnBoardingFinished, [
        isOnBoardingFinished
    ]);
    const [getOnBoardingLink, { loading: loadingOnboardingLink }] = (0, $33beb5b1bfae180c$export$87788bf64b1c5271)();
    const handleGetOnboardingLink = async ()=>{
        try {
            const link = await getOnBoardingLink({
                variables: {
                    returnUrl: window.location.href
                }
            });
            window.open(link.data.GetOnBoardingLink, '_blank');
        } catch (err) {
            handleSetError(err.message);
        }
    };
    return finishedOnboarding ? (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        align: "middle",
        justify: "center",
        children: (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
            showIcon: true,
            message: "",
            description: (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                children: [
                    "Your bank account is successfully linked to Stripe, and client payments will now be processed directly to you. To update any of your bank information in the future, you can do so directly with",
                    (0, $bb3TF.jsx)("a", {
                        href: "https://stripe.com",
                        target: "_blank",
                        rel: "noreferrer",
                        children: " Stripe"
                    }),
                    "."
                ]
            }),
            type: "success"
        })
    }) : (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        align: "middle",
        justify: "start",
        children: [
            connectAccountId && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                style: {
                    width: '100%',
                    padding: '15px',
                    marginBottom: '20px'
                },
                message: "Please connect to Stripe below to invoice clients within Taxaroo",
                type: "warning",
                closable: true,
                showIcon: true
            }),
            (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                type: "primary",
                size: "large",
                style: {
                    cursor: 'pointer'
                },
                onClick: handleGetOnboardingLink,
                icon: (0, $bb3TF.jsx)($505bbb173d554bd0$var$BankOutlined, {}),
                disabled: Boolean(loadingStripeInfo || loadingOnboardingLink),
                children: "Connect to Stripe"
            })
        ]
    });
};
$505bbb173d554bd0$var$StripeInfo.defaultProps = {
    connectAccountId: null
};
var $505bbb173d554bd0$export$2e2bcd8739ae039 = $505bbb173d554bd0$var$StripeInfo;


const { Paragraph: $b4da56a5c53b9e80$var$Paragraph, Text: $b4da56a5c53b9e80$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $b4da56a5c53b9e80$var$ClientInvoicing = ()=>{
    const { data: stripeInfo, loading: loadingStripeInfo, error: stripeInfoError } = (0, $732264f53056e08f$export$9f382c5aef9c5d4d)();
    const [error, setError] = (0, $6fFrj.useState)(undefined);
    const [info, setInfo] = (0, $6fFrj.useState)(undefined);
    const setErrorHandler = (errorMessage)=>{
        setError(errorMessage);
    };
    (0, $6fFrj.useEffect)(()=>{
        if (stripeInfoError) {
            if (stripeInfoError.graphQLErrors[0].name === 'PermissionException') setInfo('The admin of your account can connect Stripe to Taxaroo');
            else setError(stripeInfoError.message);
        }
    }, [
        stripeInfoError
    ]);
    return (0, $bb3TF.jsx)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
        style: {
            backgroundColor: 'white'
        },
        children: (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
            direction: "vertical",
            style: {
                width: '98%'
            },
            children: [
                (0, $bb3TF.jsx)((0, $58c1491b566e843c$export$2e2bcd8739ae039), {
                    title: "Setup Invoicing",
                    tooltipTitle: "Why do we need this information?",
                    tooltipContent: (0, $bb3TF.jsxs)($b4da56a5c53b9e80$var$Paragraph, {
                        children: [
                            "This allows clients to pay easily and securely with credit card. For your protection,",
                            ' ',
                            (0, $bb3TF.jsx)($b4da56a5c53b9e80$var$Text, {
                                strong: true,
                                children: " we do not view or store this information "
                            }),
                            "on our own servers. We pass this information securely to our payment services provider,",
                            (0, $bb3TF.jsx)("a", {
                                href: "https://stripe.com",
                                target: "_blank",
                                rel: "noreferrer",
                                children: " Stripe "
                            }),
                            "."
                        ]
                    })
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    children: (0, $bb3TF.jsx)($b4da56a5c53b9e80$var$Text, {
                        strong: true,
                        children: "Setup your bank account to accept direct payments"
                    })
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    children: (0, $bb3TF.jsxs)($b4da56a5c53b9e80$var$Paragraph, {
                        children: [
                            "We have partnered with",
                            ' ',
                            (0, $bb3TF.jsx)("a", {
                                href: "https://stripe.com",
                                target: "_blank",
                                rel: "noreferrer",
                                children: " Stripe "
                            }),
                            "to securely manage your bank account. When a client pays an invoice, Stripe will process directly into your bank account."
                        ]
                    })
                }),
                loadingStripeInfo ? (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    align: "middle",
                    justify: "center",
                    style: {
                        paddingTop: '15px'
                    },
                    children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                        size: "large"
                    })
                }) : !stripeInfoError && (0, $bb3TF.jsx)((0, $505bbb173d554bd0$export$2e2bcd8739ae039), {
                    handleSetError: setErrorHandler,
                    areStripeInfoLoading: loadingStripeInfo,
                    connectAccountId: stripeInfo?.CurrentStripeInformation.connectAccountId,
                    isOnBoardingFinished: stripeInfo?.CurrentStripeInformation.finishedOnboarding
                }),
                error && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    align: "middle",
                    justify: "center",
                    style: {
                        paddingTop: '15px'
                    },
                    children: (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                        style: {
                            width: '100%',
                            padding: '20px'
                        },
                        message: error,
                        type: "error",
                        closable: true,
                        onClose: ()=>{
                            setError(undefined);
                        }
                    })
                }),
                info && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    align: "middle",
                    justify: "center",
                    style: {
                        paddingTop: '15px'
                    },
                    children: (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                        style: {
                            width: '100%',
                            padding: '20px'
                        },
                        message: info,
                        type: "info",
                        closable: true,
                        onClose: ()=>{
                            setInfo(undefined);
                        }
                    })
                })
            ]
        })
    });
};
var $b4da56a5c53b9e80$export$2e2bcd8739ae039 = $b4da56a5c53b9e80$var$ClientInvoicing;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



const { InfoCircleTwoTone: $5c06aaa5544b4a13$var$InfoCircleTwoTone, SaveOutlined: $5c06aaa5544b4a13$var$SaveOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Title: $5c06aaa5544b4a13$var$Title, Paragraph: $5c06aaa5544b4a13$var$Paragraph, Text: $5c06aaa5544b4a13$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
// interface SecurityProps {}
const $5c06aaa5544b4a13$var$Security = ()=>{
    const [code, setCode] = (0, $6fFrj.useState)('');
    const [switch2FAValue, setSwitch2FAValue] = (0, $6fFrj.useState)();
    const [twoStepAuthChanged, setTwoStepAuthChanged] = (0, $6fFrj.useState)(false);
    const [twoStepValueToChange, setTwoStepValueToChange] = (0, $6fFrj.useState)();
    const { data: data, loading: loading } = (0, $732264f53056e08f$export$4926b8950ca37617)();
    // Get OTP existance
    const { data: OTPBooleanData, loading: loadingGetOTPBooleanData } = (0, $732264f53056e08f$export$b38c1895a2435d0b)();
    const copyToClipboard = ()=>navigator.clipboard.writeText(data.generateOTP.key);
    const [validateOtpMutation, { loading: loadingValidateOTP }] = (0, $33beb5b1bfae180c$export$9e48322a06db8fe9)({
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Enabled two step auth');
            setTwoStepAuthChanged(false);
            setTwoStepValueToChange(undefined);
        },
        onError: ()=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Please provide a valid code'),
        variables: {
            validateOtp: {
                code: code,
                secretOTP: data?.generateOTP?.key
            }
        },
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$4e88a0f959694e05)
            }
        ],
        awaitRefetchQueries: true
    });
    const [deleteTwoStepFromUser, { loading: loadingDeleteTwoStepFromUser }] = (0, $33beb5b1bfae180c$export$b9f15128ac3e36a0)({
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Disabled two step auth');
            setTwoStepAuthChanged(false);
            setTwoStepValueToChange(undefined);
        },
        onError: ()=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Please provide a valid code'),
        variables: {
            validateOtp: {
                code: code
            }
        },
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$4e88a0f959694e05)
            }
        ],
        awaitRefetchQueries: true
    });
    // Set initial switch value and listen for mutations to update the original value
    (0, $6fFrj.useEffect)(()=>{
        if (OTPBooleanData) setSwitch2FAValue(OTPBooleanData?.GetOTPBoolean.success);
    }, [
        OTPBooleanData
    ]);
    const getMoreInfoContent = ()=>(0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            children: (0, $bb3TF.jsx)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Paragraph, {
                    children: "Two-Factor Authentication (2FA) works by adding an additional layer of security to your Taxaroo account."
                })
            })
        });
    const twoStepAuthChangedSwitchOnChange = (enabled)=>{
        setSwitch2FAValue(enabled);
        setCode('');
        if (OTPBooleanData?.GetOTPBoolean.success !== enabled) {
            setTwoStepAuthChanged(true);
            setTwoStepValueToChange(!OTPBooleanData?.GetOTPBoolean.success);
        }
        if (OTPBooleanData?.GetOTPBoolean.success === enabled) {
            setTwoStepAuthChanged(false);
            setTwoStepValueToChange(undefined);
        }
    };
    const handleOTPOnSaveChanges = ()=>{
        if (twoStepValueToChange === true || twoStepValueToChange === false) {
            if (twoStepValueToChange === true) validateOtpMutation();
            if (twoStepValueToChange === false) deleteTwoStepFromUser();
        } else (0, $55c6005cab9be059$export$2e2bcd8739ae039).info('No changes to save');
    };
    return (0, $bb3TF.jsxs)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
        style: {
            backgroundColor: 'white'
        },
        children: [
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                style: {
                    flexFlow: 'row',
                    width: '100%'
                },
                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    span: 24,
                    style: {
                        borderRight: '1px solid #EFEFEF'
                    },
                    children: (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                        direction: "vertical",
                        style: {
                            width: '98%'
                        },
                        children: [
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                gutter: 16,
                                style: {
                                    borderBottom: '1px dashed #D6D6D6',
                                    marginRight: 15
                                },
                                children: [
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        children: (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Title, {
                                            level: 3,
                                            children: "Two-Factor authentication"
                                        })
                                    }),
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        children: (0, $bb3TF.jsx)((0, $66cce4f0794ba24e$export$2e2bcd8739ae039), {
                                            overlayStyle: {
                                                width: '50%'
                                            },
                                            placement: "right",
                                            content: getMoreInfoContent,
                                            title: "How does this work?",
                                            trigger: "click",
                                            children: (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$InfoCircleTwoTone, {})
                                        })
                                    })
                                ]
                            }),
                            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                gutter: 2,
                                style: {
                                    marginTop: 18
                                },
                                children: [
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        span: 8,
                                        children: (0, $bb3TF.jsxs)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                                            children: [
                                                (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Title, {
                                                    level: 5,
                                                    children: (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Text, {
                                                        children: "Step 1"
                                                    })
                                                }),
                                                (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Paragraph, {
                                                    children: (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Text, {
                                                        children: (0, $bb3TF.jsx)("b", {
                                                            children: "Enable two-step authentication to add an additional layer of security."
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        children: (0, $bb3TF.jsx)((0, $4fd303306a27e42e$export$2e2bcd8739ae039), {
                                            onChange: twoStepAuthChangedSwitchOnChange,
                                            checkedChildren: "ON",
                                            unCheckedChildren: "OFF",
                                            checked: switch2FAValue,
                                            disabled: loadingGetOTPBooleanData
                                        })
                                    })
                                ]
                            }),
                            twoStepAuthChanged && twoStepValueToChange === true && (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                                children: [
                                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                        gutter: 2,
                                        style: {
                                            marginTop: 18
                                        },
                                        children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                            span: 8,
                                            children: (0, $bb3TF.jsxs)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                                                children: [
                                                    (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Title, {
                                                        level: 5,
                                                        children: (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Text, {
                                                            children: "Step 2"
                                                        })
                                                    }),
                                                    (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Paragraph, {
                                                        children: (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Text, {
                                                            children: (0, $bb3TF.jsx)("b", {
                                                                children: "Scan this barcode with your app."
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                        children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                            span: 6,
                                            children: loading ? (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                                                size: "small"
                                            }) : (0, $bb3TF.jsx)("img", {
                                                src: `data:image/svg+xml;utf8,${data.generateOTP.codeQR}`,
                                                alt: "qrCode"
                                            })
                                        })
                                    }),
                                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                        children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                            span: 10,
                                            children: (0, $bb3TF.jsx)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                                                children: (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Paragraph, {
                                                    children: (0, $bb3TF.jsxs)($5c06aaa5544b4a13$var$Text, {
                                                        children: [
                                                            "If you can't use barcode ",
                                                            (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                                                                type: "ghost",
                                                                onClick: ()=>{
                                                                    copyToClipboard();
                                                                    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Copied to clipboard');
                                                                },
                                                                children: "Get a key"
                                                            }),
                                                            "\u00A0 for manual entry."
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                        gutter: 2,
                                        style: {
                                            marginTop: 18
                                        },
                                        children: [
                                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                                span: 8,
                                                children: (0, $bb3TF.jsxs)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                                                    children: [
                                                        (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Title, {
                                                            level: 5,
                                                            children: (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Text, {
                                                                children: "Step 3"
                                                            })
                                                        }),
                                                        (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Paragraph, {
                                                            children: (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Text, {
                                                                children: (0, $bb3TF.jsx)("b", {
                                                                    children: "Enter the six-digit code from your app."
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                                children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                                    size: "large",
                                                    placeholder: "Six Digit Code",
                                                    value: code,
                                                    onPressEnter: handleOTPOnSaveChanges,
                                                    maxLength: 6,
                                                    onChange: (e)=>{
                                                        setCode(e.target.value);
                                                    },
                                                    allowClear: true
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            twoStepAuthChanged && twoStepValueToChange === false && (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                gutter: 2,
                                style: {
                                    marginTop: 18
                                },
                                children: [
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        span: 8,
                                        children: (0, $bb3TF.jsxs)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                                            children: [
                                                (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Title, {
                                                    level: 5,
                                                    children: (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Text, {
                                                        children: "Step 2"
                                                    })
                                                }),
                                                (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Paragraph, {
                                                    children: (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Text, {
                                                        children: (0, $bb3TF.jsx)("b", {
                                                            children: "To disable the two-step authentication. Please enter the six-digit code from your app"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                            size: "large",
                                            placeholder: "Six Digit Code",
                                            value: code,
                                            maxLength: 6,
                                            onPressEnter: handleOTPOnSaveChanges,
                                            onChange: (e)=>{
                                                setCode(e.target.value);
                                            },
                                            allowClear: true
                                        })
                                    })
                                ]
                            }),
                            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                gutter: 16,
                                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                    className: "gutter-row",
                                    span: 6,
                                    children: loadingValidateOTP || loadingDeleteTwoStepFromUser ? (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                                        size: "small"
                                    }) : (0, $bb3TF.jsx)((0, $ea0942a2e543872a$export$2e2bcd8739ae039), {
                                        type: "primary",
                                        icon: (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$SaveOutlined, {}),
                                        disabled: !twoStepAuthChanged,
                                        onClick: ()=>{
                                            handleOTPOnSaveChanges();
                                        },
                                        children: "Save changes"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            OTPBooleanData?.GetOTPBoolean.success && Boolean(OTPBooleanData?.GetOTPBoolean.apiToken) && (0, $bb3TF.jsxs)("div", {
                style: {
                    paddingTop: '30px'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Title, {
                            level: 5,
                            children: "API token for Zapier intergrations"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($5c06aaa5544b4a13$var$Paragraph, {
                            style: {
                                width: '50%'
                            },
                            ellipsis: true,
                            copyable: true,
                            code: true,
                            children: OTPBooleanData?.GetOTPBoolean.apiToken
                        })
                    })
                ]
            })
        ]
    });
};
var $5c06aaa5544b4a13$export$2e2bcd8739ae039 = $5c06aaa5544b4a13$var$Security;



var $bb3TF = parcelRequire("bb3TF");




const { Paragraph: $dd48553a54d7a3ce$var$Paragraph, Text: $dd48553a54d7a3ce$var$Text, Title: $dd48553a54d7a3ce$var$Title, Link: $dd48553a54d7a3ce$var$Link } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $dd48553a54d7a3ce$var$TaxarooDrive = ()=>{
    const { showModal: showModal, hideModal: hideModal, accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    const needsToUpgrade = !accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).mappedDrive];
    if (needsToUpgrade) showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).mappedDrive, false);
    else hideModal();
    return (0, $bb3TF.jsxs)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
        style: {
            backgroundColor: 'white'
        },
        children: [
            (0, $bb3TF.jsx)((0, $58c1491b566e843c$export$2e2bcd8739ae039), {
                title: "Taxaroo Drive"
            }),
            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                style: {
                    paddingTop: '10px'
                },
                children: (0, $bb3TF.jsxs)((0, $e8201deab6acaf74$export$2e2bcd8739ae039), {
                    children: [
                        (0, $bb3TF.jsx)($dd48553a54d7a3ce$var$Paragraph, {
                            children: (0, $bb3TF.jsx)($dd48553a54d7a3ce$var$Text, {
                                children: "Welcome to the Taxaroo Mapped Drive Settings page. Here, you can download the necessary installation files to connect your local computer to your Taxaroo firm portal. This feature allows you to seamlessly drag and drop files between your computer and your cloud-based dashboard, making document management easier and more efficient."
                            })
                        }),
                        (0, $bb3TF.jsx)($dd48553a54d7a3ce$var$Paragraph, {
                            children: (0, $bb3TF.jsx)($dd48553a54d7a3ce$var$Text, {
                                children: "To get started, simply download the installation file for your type of computer below. Once installed, you\u2019ll be able to access your Taxaroo client files directly from your computer, just like any other local drive."
                            })
                        }),
                        (0, $bb3TF.jsx)($dd48553a54d7a3ce$var$Paragraph, {
                            children: (0, $bb3TF.jsx)($dd48553a54d7a3ce$var$Text, {
                                children: "Taxaroo Drive is supported on Windows 10 and 11 at this time."
                            })
                        }),
                        (0, $bb3TF.jsx)($dd48553a54d7a3ce$var$Paragraph, {
                            children: (0, $bb3TF.jsx)($dd48553a54d7a3ce$var$Text, {
                                children: "If you encounter any issues or have any questions, don\u2019t hesitate to reach out to our support team. We\u2019re here to help!"
                            })
                        }),
                        (0, $bb3TF.jsx)($dd48553a54d7a3ce$var$Title, {
                            level: 5,
                            children: "Taxaroo Drive Installer File"
                        }),
                        (0, $bb3TF.jsx)((0, $550318ddff00815a$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsx)((0, $550318ddff00815a$export$2e2bcd8739ae039).Item, {
                                children: (0, $bb3TF.jsx)($dd48553a54d7a3ce$var$Link, {
                                    href: "https://taxaroo1.s3.amazonaws.com/taxaroo-drive/distrib/windows_amd64/TaxarooDriveInstall.exe",
                                    onClick: ()=>{
                                        (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).CLICK, {
                                            Title: 'Taxaroo drive installer',
                                            Source: 'Link click',
                                            url: window.location.href
                                        });
                                    },
                                    children: "Windows, Intel (windows_amd64)"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $dd48553a54d7a3ce$export$2e2bcd8739ae039 = $dd48553a54d7a3ce$var$TaxarooDrive;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

var $f76f47029f922cd6$export$f683f479e7d25898;
var $f76f47029f922cd6$export$ce2114882f5aca2b;
var $f76f47029f922cd6$export$df03f54e09e486fa;
var $f76f47029f922cd6$export$8879818f4928305f;
$f76f47029f922cd6$export$f683f479e7d25898 = `bImQHq_addon`;
$f76f47029f922cd6$export$ce2114882f5aca2b = `bImQHq_centeredText`;
$f76f47029f922cd6$export$df03f54e09e486fa = `bImQHq_icons`;
$f76f47029f922cd6$export$8879818f4928305f = `bImQHq_saveOutlined`;


const { SaveOutlined: $7a3b72f02199a60e$var$SaveOutlined, SyncOutlined: $7a3b72f02199a60e$var$SyncOutlined, ApiOutlined: $7a3b72f02199a60e$var$ApiOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Title: $7a3b72f02199a60e$var$Title, Text: $7a3b72f02199a60e$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { useBreakpoint: $7a3b72f02199a60e$var$useBreakpoint } = (0, $89d88a41b53d163f$export$2e2bcd8739ae039);
const $7a3b72f02199a60e$var$InviteLinkRow = ({ title: title, subtitle: subtitle, baseLink: baseLink, defaultValue: defaultValue, currentValue: currentValue, onChange: onChange, onSave: onSave, onReset: onReset, onOpen: onOpen, updateLoad: updateLoad })=>{
    const screens = $7a3b72f02199a60e$var$useBreakpoint();
    const [load, setLoad] = (0, $6fFrj.useState)(updateLoad);
    (0, $6fFrj.useEffect)(()=>{
        setLoad(load);
    }, [
        updateLoad
    ]);
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                className: $f76f47029f922cd6$export$ce2114882f5aca2b,
                direction: "vertical",
                children: [
                    (0, $bb3TF.jsx)($7a3b72f02199a60e$var$Title, {
                        level: 4,
                        style: {
                            marginBottom: 0
                        },
                        children: title
                    }),
                    (0, $bb3TF.jsx)($7a3b72f02199a60e$var$Text, {
                        small: true,
                        children: subtitle
                    })
                ]
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                style: {
                    alignItems: 'center'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        className: $f76f47029f922cd6$export$f683f479e7d25898,
                        children: (0, $bb3TF.jsxs)($7a3b72f02199a60e$var$Text, {
                            children: [
                                baseLink,
                                "/"
                            ]
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                            size: "large",
                            defaultValue: defaultValue,
                            value: currentValue,
                            onChange: (e)=>{
                                onChange(e.target.value);
                            },
                            style: {
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0
                            }
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        style: {
                            marginTop: screens.lg ? 0 : 10
                        },
                        children: !load ? (0, $bb3TF.jsxs)("div", {
                            className: $f76f47029f922cd6$export$df03f54e09e486fa,
                            children: [
                                (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                    title: "Save Changes",
                                    children: (0, $bb3TF.jsxs)("div", {
                                        children: [
                                            ' ',
                                            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                icon: (0, $bb3TF.jsx)($7a3b72f02199a60e$var$SaveOutlined, {}),
                                                type: "link",
                                                style: {
                                                    pointerEvents: defaultValue === currentValue || currentValue === '' ? 'none' : 'auto'
                                                },
                                                disabled: defaultValue === currentValue || currentValue === '',
                                                onClick: ()=>{
                                                    onSave();
                                                }
                                            })
                                        ]
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                    title: "Reset Invite Link",
                                    children: (0, $bb3TF.jsxs)("div", {
                                        children: [
                                            ' ',
                                            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                                icon: (0, $bb3TF.jsx)($7a3b72f02199a60e$var$SyncOutlined, {}),
                                                type: "link",
                                                // required for tooltip https://github.com/react-component/tooltip/issues/18#issuecomment-411476678
                                                // style={{ pointerEvents: defaultValue === currentValue ? 'none' : 'auto' }}
                                                // disabled={defaultValue === currentValue}
                                                onClick: ()=>{
                                                    onReset();
                                                }
                                            })
                                        ]
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
                                    title: "Open Invite Link",
                                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                        icon: (0, $bb3TF.jsx)($7a3b72f02199a60e$var$ApiOutlined, {}),
                                        type: "link",
                                        // disabled={defaultValue !== currentValue}
                                        onClick: ()=>{
                                            onOpen();
                                        }
                                    })
                                })
                            ]
                        }) : (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                            size: "large"
                        })
                    })
                ]
            })
        ]
    });
};
var $7a3b72f02199a60e$export$2e2bcd8739ae039 = $7a3b72f02199a60e$var$InviteLinkRow;









var $48f4d99c1799766e$export$ce2114882f5aca2b;
var $48f4d99c1799766e$export$34e0f9847d4c02dd;
var $48f4d99c1799766e$export$6d978f777c763790;
var $48f4d99c1799766e$export$fadbfc2c9024227b;
var $48f4d99c1799766e$export$8879818f4928305f;
$48f4d99c1799766e$export$ce2114882f5aca2b = `Wp1TVG_centeredText`;
$48f4d99c1799766e$export$34e0f9847d4c02dd = `Wp1TVG_container`;
$48f4d99c1799766e$export$6d978f777c763790 = `Wp1TVG_dashedHeader`;
$48f4d99c1799766e$export$fadbfc2c9024227b = `Wp1TVG_inviteLinkBackground`;
$48f4d99c1799766e$export$8879818f4928305f = `Wp1TVG_saveOutlined`;



const $27f5c1aafb8cd10d$export$85b43ea59a8cb058 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('An error has occurred, please try again.');
};
const $27f5c1aafb8cd10d$export$53163c51321d0ebd = (error)=>{
    let text;
    if (error?.graphQLErrors?.at(0)?.name === 'RecordAlreadyInDb') text = 'That link is already taken. Please choose another.';
    else text = 'An error has occurred, please try again.';
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(text);
};
const $27f5c1aafb8cd10d$export$e698b75a58d24c6e = (error)=>{
    let text;
    if (error?.graphQLErrors?.at(0)?.name === 'RecordAlreadyInDb') text = 'That link is already taken. Please choose another.';
    else text = 'An error has occurred, please try again.';
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(text);
};
const $27f5c1aafb8cd10d$export$f52cdfa017f3e64 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Firm Invite Link saved successfully!');
};
const $27f5c1aafb8cd10d$export$c56dfa6f9d473d17 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Personal Invite Link saved successfully!');
};
const $27f5c1aafb8cd10d$export$75d00aea5b82c77b = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Link saved successfully!');
};


const { Paragraph: $ce2057fc87a3f13e$var$Paragraph, Text: $ce2057fc87a3f13e$var$Text } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $ce2057fc87a3f13e$var$getMoreInfoContent = ()=>(0, $bb3TF.jsx)($ce2057fc87a3f13e$var$Paragraph, {
        children: "This link is unique to your firm and profile. Team members who send out the link have clients automatically assigned to them in the queue."
    });
const $ce2057fc87a3f13e$var$initialState = {
    baseLink: `${"https://client.taxaroo.com" ?? 'https://client.taxaroo.com'}/invite`,
    baseFirmInput: '',
    basePersonalInput: ''
};
const $ce2057fc87a3f13e$var$InviteLink = ()=>{
    const { firmAccountId: firmAccountId, userId: userId } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const [baseLink, setBaseLink] = (0, $6fFrj.useState)($ce2057fc87a3f13e$var$initialState.baseLink);
    const [firmInput, setFirmInput] = (0, $6fFrj.useState)($ce2057fc87a3f13e$var$initialState.baseFirmInput);
    const [personalInput, setPersonalInput] = (0, $6fFrj.useState)($ce2057fc87a3f13e$var$initialState.basePersonalInput);
    const [cnameError, setCnameError] = (0, $6fFrj.useState)('');
    const [isCnameModalVisible, setIsCnameModalVisible] = (0, $6fFrj.useState)(false);
    // get custom domain
    const { data: customDomainUserData, loading: loadingCustomDomainUser } = (0, $732264f53056e08f$export$bd03447e34c3ce51)();
    const { CustomDomainUser: CustomDomainUser } = customDomainUserData || {};
    // get custom domain certificate status
    const [getCustomDomainCertificateStatus, { data: certificateStatus, loading: certificateStatusLoading }] = (0, $732264f53056e08f$export$b1a758a27418fc73)();
    const { CustomDomainCertificateStatus: CustomDomainCertificateStatus } = certificateStatus || {};
    // Query for getting custom domain cname status
    const [getCustomDomainCnameStatus, { data: cnameStatus, loading: cnameStatusLoading }] = (0, $732264f53056e08f$export$4a1ba03041072c39)({
        onError: (error)=>{
            if (error?.message.includes('queryCname ENODATA')) setCnameError('CNAME record not found.');
        },
        onCompleted: ()=>setCnameError('')
    });
    // query for firm and user unique links
    const { data: customUserUniqueLinkData, loading: loadingUserUniqueLink } = (0, $732264f53056e08f$export$67e1b8b3789d08d)({
        variables: {
            id: userId
        }
    });
    const { data: customFirmUniqueLinkData, loading: loadingFirmUniqueLinkQuery } = (0, $732264f53056e08f$export$9f81c3500d5c21a0)({
        variables: {
            id: firmAccountId
        }
    });
    const [updateFirmLink, { data: firmData, error: firmError, loading: loadingUpdateFirmLinkMutation }] = (0, $33beb5b1bfae180c$export$bafa3df68c8afd6d)({
        onCompleted: ()=>{
            setFirmInput(firmData.updateFirmUniqueLink.uniqueLink);
            (0, $27f5c1aafb8cd10d$export$f52cdfa017f3e64)();
        },
        onError: ()=>{
            (0, $27f5c1aafb8cd10d$export$53163c51321d0ebd)(firmError);
        },
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$36883e83eb872d84),
                variables: {
                    id: firmAccountId,
                    ownerId: userId
                }
            }
        ],
        awaitRefetchQueries: true
    });
    const [updateUserLink, { data: userData, error: userError, loading: loadingUpdateUserLink }] = (0, $33beb5b1bfae180c$export$72dac375941973c9)({
        onCompleted: ()=>{
            setPersonalInput(userData.updateUserUniqueLink.uniqueLink);
            (0, $27f5c1aafb8cd10d$export$c56dfa6f9d473d17)();
        },
        onError: ()=>{
            (0, $27f5c1aafb8cd10d$export$e698b75a58d24c6e)(userError);
        },
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$cd6fb1839b461eb3),
                variables: {
                    id: userId
                }
            }
        ],
        awaitRefetchQueries: true
    });
    // check if custom domain is live
    const [checkIfCustomDomainIsLive, { data: domainLiveData, loading: loadingIsDomainLive }] = (0, $732264f53056e08f$export$1a0c8fbd0bcd031a)({
        variables: {
            url: CustomDomainUser?.name
        }
    });
    const { IsDomainLive: isDomainLive } = domainLiveData || {};
    (0, $6fFrj.useEffect)(()=>{
        if (!isDomainLive) {
            // if custom domain is not working
            // we need to show default invite link
            setBaseLink(`${"https://client.taxaroo.com" ?? 'https://client.taxaroo.com'}/invite`);
            // and we need to run some checks to display why
            // fetch the current status of the certificate (this will also trigger an update to the CustomDomain status in the db)
            getCustomDomainCertificateStatus();
            // fetch the current status of the cname
            getCustomDomainCnameStatus();
        } else setBaseLink(`https://${CustomDomainUser?.name}/invite`);
    }, [
        isDomainLive,
        CustomDomainUser?.name
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (CustomDomainUser?.name) checkIfCustomDomainIsLive();
    }, [
        CustomDomainUser?.name,
        CustomDomainCertificateStatus?.Status,
        cnameError
    ]);
    (0, $6fFrj.useEffect)(()=>{
        setFirmInput(customFirmUniqueLinkData?.FirmAccountById?.uniqueLink || firmAccountId);
    }, [
        customFirmUniqueLinkData
    ]);
    (0, $6fFrj.useEffect)(()=>{
        setPersonalInput(customUserUniqueLinkData?.UserById?.uniqueLink || userId);
    }, [
        customUserUniqueLinkData
    ]);
    const openLink = (url)=>{
        const win = window.open(url, '_blank');
        if (win != null) win.focus();
    };
    const saveFirmLink = (link)=>{
        if (firmAccountId) updateFirmLink({
            variables: {
                updateFirmAccountInput: {
                    id: firmAccountId,
                    uniqueLink: link
                }
            }
        });
    };
    const savePersonalLink = (link)=>{
        if (userId) updateUserLink({
            variables: {
                updateUserInput: {
                    id: userId,
                    uniqueLink: link
                }
            }
        });
    };
    if (loadingCustomDomainUser || loadingUserUniqueLink || loadingFirmUniqueLinkQuery || loadingIsDomainLive) return (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
        size: "large"
    });
    return (0, $bb3TF.jsxs)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
        style: {
            backgroundColor: 'white'
        },
        children: [
            (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                direction: "vertical",
                style: {
                    width: '98%'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $58c1491b566e843c$export$2e2bcd8739ae039), {
                        title: "Invite Link",
                        tooltipTitle: "How does this work?",
                        tooltipContent: $ce2057fc87a3f13e$var$getMoreInfoContent
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($ce2057fc87a3f13e$var$Text, {
                            strong: true,
                            children: "Share with your link with your clients so they can submit through your portal"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)($ce2057fc87a3f13e$var$Text, {
                            small: true,
                            children: `Add this link to your own website, send it to clients via email, or
            share on social media. Clients will be onboarding to your account,
            and you'll be notified when they sign up.`
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $b23f17af94c41ac9$export$2e2bcd8739ae039), {
                        status: CustomDomainCertificateStatus?.Status,
                        failureReason: CustomDomainCertificateStatus?.FailureReason,
                        cnameError: cnameError,
                        setIsCnameModalVisible: setIsCnameModalVisible,
                        certificateStatus: certificateStatus,
                        loadingCertificateStatus: certificateStatusLoading
                    }),
                    (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                        direction: "vertical",
                        className: $48f4d99c1799766e$export$fadbfc2c9024227b,
                        children: [
                            (0, $bb3TF.jsx)((0, $7a3b72f02199a60e$export$2e2bcd8739ae039), {
                                updateLoad: loadingUpdateFirmLinkMutation,
                                title: "Firm Invite Link",
                                subtitle: "(Clients can access your secure portal)",
                                baseLink: baseLink,
                                defaultValue: "",
                                currentValue: firmInput,
                                onChange: (value)=>setFirmInput(value),
                                onSave: ()=>{
                                    saveFirmLink(firmInput);
                                },
                                onReset: ()=>{
                                    saveFirmLink('');
                                },
                                onOpen: ()=>openLink(`${baseLink}/${firmInput}`)
                            }),
                            (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {}),
                            (0, $bb3TF.jsx)((0, $7a3b72f02199a60e$export$2e2bcd8739ae039), {
                                updateLoad: loadingUpdateUserLink,
                                title: "Personal Invite Link",
                                subtitle: "(Clients are automatically assigned to you in the Jobs\n              Queue)",
                                baseLink: `${baseLink}/${firmInput}`,
                                defaultValue: "",
                                currentValue: personalInput,
                                onChange: (value)=>setPersonalInput(value),
                                onSave: ()=>{
                                    savePersonalLink(personalInput);
                                },
                                onReset: ()=>{
                                    savePersonalLink('');
                                },
                                onOpen: ()=>openLink(`${baseLink}/${firmInput}/${personalInput}`)
                            })
                        ]
                    })
                ]
            }),
            cnameError && customDomainUserData?.CustomDomainUser?.status === (0, $8f7fe33a44836803$export$e5f8203198481f3c).Issued && (0, $bb3TF.jsx)((0, $2a4f5d2919a8f5fa$export$2e2bcd8739ae039), {
                isDNSModalVisible: isCnameModalVisible,
                setIsDNSModalVisible: setIsCnameModalVisible
            })
        ]
    });
};
var $ce2057fc87a3f13e$export$2e2bcd8739ae039 = $ce2057fc87a3f13e$var$InviteLink;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




var $5fApW = parcelRequire("5fApW");
function $a8bea4e18d138eb8$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? Object(arguments[i]) : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5fApW.default)(target, key, source[key]);
        });
    }
    return target;
}



var $9VR4w = parcelRequire("9VR4w");

var $8HiBB = parcelRequire("8HiBB");

var $hEAnx = parcelRequire("hEAnx");

var $d60oy = parcelRequire("d60oy");

var $2tFMC = parcelRequire("2tFMC");

var $4TaHZ = parcelRequire("4TaHZ");

var $5fApW = parcelRequire("5fApW");

var $6fFrj = parcelRequire("6fFrj");

var $8CZEB = parcelRequire("8CZEB");



var $cgjHV = parcelRequire("cgjHV");
var $0f0f7fce05c407ef$var$Manager = function() {
    function Manager() {
        (0, $9VR4w.default)(this, Manager);
        (0, $5fApW.default)(this, "refs", {});
    }
    (0, $8HiBB.default)(Manager, [
        {
            key: "add",
            value: function add(collection, ref) {
                if (!this.refs[collection]) this.refs[collection] = [];
                this.refs[collection].push(ref);
            }
        },
        {
            key: "remove",
            value: function remove(collection, ref) {
                var index = this.getIndex(collection, ref);
                if (index !== -1) this.refs[collection].splice(index, 1);
            }
        },
        {
            key: "isActive",
            value: function isActive() {
                return this.active;
            }
        },
        {
            key: "getActive",
            value: function getActive() {
                var _this = this;
                return this.refs[this.active.collection].find(function(_ref) {
                    var node = _ref.node;
                    return node.sortableInfo.index == _this.active.index;
                });
            }
        },
        {
            key: "getIndex",
            value: function getIndex(collection, ref) {
                return this.refs[collection].indexOf(ref);
            }
        },
        {
            key: "getOrderedRefs",
            value: function getOrderedRefs() {
                var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
                return this.refs[collection].sort($0f0f7fce05c407ef$var$sortByIndex);
            }
        }
    ]);
    return Manager;
}();
function $0f0f7fce05c407ef$var$sortByIndex(_ref2, _ref3) {
    var index1 = _ref2.node.sortableInfo.index;
    var index2 = _ref3.node.sortableInfo.index;
    return index1 - index2;
}
function $0f0f7fce05c407ef$export$5d49d615ad5ea2b0(array, from, to) {
    array = array.slice();
    array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
    return array;
}
function $0f0f7fce05c407ef$var$omit(obj, keysToOmit) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
        return acc;
    }, {});
}
var $0f0f7fce05c407ef$var$events = {
    end: [
        'touchend',
        'touchcancel',
        'mouseup'
    ],
    move: [
        'touchmove',
        'mousemove'
    ],
    start: [
        'touchstart',
        'mousedown'
    ]
};
var $0f0f7fce05c407ef$var$vendorPrefix = function() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return '';
    var styles = window.getComputedStyle(document.documentElement, '') || [
        '-moz-hidden-iframe'
    ];
    var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && [
        '',
        'o'
    ])[1];
    switch(pre){
        case 'ms':
            return 'ms';
        default:
            return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
    }
}();
function $0f0f7fce05c407ef$var$setInlineStyles(node, styles) {
    Object.keys(styles).forEach(function(key) {
        node.style[key] = styles[key];
    });
}
function $0f0f7fce05c407ef$var$setTranslate3d(node, translate) {
    node.style["".concat($0f0f7fce05c407ef$var$vendorPrefix, "Transform")] = translate == null ? '' : "translate3d(".concat(translate.x, "px,").concat(translate.y, "px,0)");
}
function $0f0f7fce05c407ef$var$setTransitionDuration(node, duration) {
    node.style["".concat($0f0f7fce05c407ef$var$vendorPrefix, "TransitionDuration")] = duration == null ? '' : "".concat(duration, "ms");
}
function $0f0f7fce05c407ef$var$closest(el, fn) {
    while(el){
        if (fn(el)) return el;
        el = el.parentNode;
    }
    return null;
}
function $0f0f7fce05c407ef$var$limit(min, max, value1) {
    return Math.max(min, Math.min(value1, max));
}
function $0f0f7fce05c407ef$var$getPixelValue(stringValue) {
    if (stringValue.substr(-2) === 'px') return parseFloat(stringValue);
    return 0;
}
function $0f0f7fce05c407ef$var$getElementMargin(element) {
    var style = window.getComputedStyle(element);
    return {
        bottom: $0f0f7fce05c407ef$var$getPixelValue(style.marginBottom),
        left: $0f0f7fce05c407ef$var$getPixelValue(style.marginLeft),
        right: $0f0f7fce05c407ef$var$getPixelValue(style.marginRight),
        top: $0f0f7fce05c407ef$var$getPixelValue(style.marginTop)
    };
}
function $0f0f7fce05c407ef$var$provideDisplayName(prefix, Component$$1) {
    var componentName = Component$$1.displayName || Component$$1.name;
    return componentName ? "".concat(prefix, "(").concat(componentName, ")") : prefix;
}
function $0f0f7fce05c407ef$var$getScrollAdjustedBoundingClientRect(node, scrollDelta) {
    var boundingClientRect = node.getBoundingClientRect();
    return {
        top: boundingClientRect.top + scrollDelta.top,
        left: boundingClientRect.left + scrollDelta.left
    };
}
function $0f0f7fce05c407ef$var$getPosition(event) {
    if (event.touches && event.touches.length) return {
        x: event.touches[0].pageX,
        y: event.touches[0].pageY
    };
    else if (event.changedTouches && event.changedTouches.length) return {
        x: event.changedTouches[0].pageX,
        y: event.changedTouches[0].pageY
    };
    else return {
        x: event.pageX,
        y: event.pageY
    };
}
function $0f0f7fce05c407ef$var$isTouchEvent(event) {
    return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}
function $0f0f7fce05c407ef$var$getEdgeOffset(node, parent) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        left: 0,
        top: 0
    };
    if (!node) return undefined;
    var nodeOffset = {
        left: offset.left + node.offsetLeft,
        top: offset.top + node.offsetTop
    };
    if (node.parentNode === parent) return nodeOffset;
    return $0f0f7fce05c407ef$var$getEdgeOffset(node.parentNode, parent, nodeOffset);
}
function $0f0f7fce05c407ef$var$getTargetIndex(newIndex, prevIndex, oldIndex) {
    if (newIndex < oldIndex && newIndex > prevIndex) return newIndex - 1;
    else if (newIndex > oldIndex && newIndex < prevIndex) return newIndex + 1;
    else return newIndex;
}
function $0f0f7fce05c407ef$var$getLockPixelOffset(_ref) {
    var lockOffset = _ref.lockOffset, width = _ref.width, height = _ref.height;
    var offsetX = lockOffset;
    var offsetY = lockOffset;
    var unit = 'px';
    if (typeof lockOffset === 'string') {
        var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
        (0, (/*@__PURE__*/$parcel$interopDefault($d787f36c95e388b1$exports)))(match !== null, 'lockOffset value should be a number or a string of a number followed by "px" or "%". Given %s', lockOffset);
        offsetX = parseFloat(lockOffset);
        offsetY = parseFloat(lockOffset);
        unit = match[1];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($d787f36c95e388b1$exports)))(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);
    if (unit === '%') {
        offsetX = offsetX * width / 100;
        offsetY = offsetY * height / 100;
    }
    return {
        x: offsetX,
        y: offsetY
    };
}
function $0f0f7fce05c407ef$var$getLockPixelOffsets(_ref2) {
    var height = _ref2.height, width = _ref2.width, lockOffset = _ref2.lockOffset;
    var offsets = Array.isArray(lockOffset) ? lockOffset : [
        lockOffset,
        lockOffset
    ];
    (0, (/*@__PURE__*/$parcel$interopDefault($d787f36c95e388b1$exports)))(offsets.length === 2, "lockOffset prop of SortableContainer should be a single value or an array of exactly two values. Given %s", lockOffset);
    var _offsets = (0, $951471461146a3e9$export$2e2bcd8739ae039)(offsets, 2), minLockOffset = _offsets[0], maxLockOffset = _offsets[1];
    return [
        $0f0f7fce05c407ef$var$getLockPixelOffset({
            height: height,
            lockOffset: minLockOffset,
            width: width
        }),
        $0f0f7fce05c407ef$var$getLockPixelOffset({
            height: height,
            lockOffset: maxLockOffset,
            width: width
        })
    ];
}
function $0f0f7fce05c407ef$var$isScrollable(el) {
    var computedStyle = window.getComputedStyle(el);
    var overflowRegex = /(auto|scroll)/;
    var properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.find(function(property) {
        return overflowRegex.test(computedStyle[property]);
    });
}
function $0f0f7fce05c407ef$var$getScrollingParent(el) {
    if (!(el instanceof HTMLElement)) return null;
    else if ($0f0f7fce05c407ef$var$isScrollable(el)) return el;
    else return $0f0f7fce05c407ef$var$getScrollingParent(el.parentNode);
}
function $0f0f7fce05c407ef$var$getContainerGridGap(element) {
    var style = window.getComputedStyle(element);
    if (style.display === 'grid') return {
        x: $0f0f7fce05c407ef$var$getPixelValue(style.gridColumnGap),
        y: $0f0f7fce05c407ef$var$getPixelValue(style.gridRowGap)
    };
    return {
        x: 0,
        y: 0
    };
}
var $0f0f7fce05c407ef$var$KEYCODE = {
    TAB: 9,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
};
var $0f0f7fce05c407ef$var$NodeType = {
    Anchor: 'A',
    Button: 'BUTTON',
    Canvas: 'CANVAS',
    Input: 'INPUT',
    Option: 'OPTION',
    Textarea: 'TEXTAREA',
    Select: 'SELECT'
};
function $0f0f7fce05c407ef$var$cloneNode(node) {
    var selector = 'input, textarea, select, canvas, [contenteditable]';
    var fields = node.querySelectorAll(selector);
    var clonedNode = node.cloneNode(true);
    var clonedFields = (0, $ade8cf5a4b72a7ba$export$2e2bcd8739ae039)(clonedNode.querySelectorAll(selector));
    clonedFields.forEach(function(field, i) {
        if (field.type !== 'file') field.value = fields[i].value;
        if (field.type === 'radio' && field.name) field.name = "__sortableClone__".concat(field.name);
        if (field.tagName === $0f0f7fce05c407ef$var$NodeType.Canvas && fields[i].width > 0 && fields[i].height > 0) {
            var destCtx = field.getContext('2d');
            destCtx.drawImage(fields[i], 0, 0);
        }
    });
    return clonedNode;
}
function $0f0f7fce05c407ef$export$680929e2aec3ce89(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_React$Component) {
        (0, $2tFMC.default)(WithSortableHandle, _React$Component);
        function WithSortableHandle() {
            var _getPrototypeOf2;
            var _this;
            (0, $9VR4w.default)(this, WithSortableHandle);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = (0, $hEAnx.default)(this, (_getPrototypeOf2 = (0, $d60oy.default)(WithSortableHandle)).call.apply(_getPrototypeOf2, [
                this
            ].concat(args)));
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "wrappedInstance", (0, $6fFrj.createRef)());
            return _this;
        }
        (0, $8HiBB.default)(WithSortableHandle, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var node = (0, $8CZEB.findDOMNode)(this);
                    node.sortableHandle = true;
                }
            },
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($d787f36c95e388b1$exports)))(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
                    return this.wrappedInstance.current;
                }
            },
            {
                key: "render",
                value: function render() {
                    var ref = config.withRef ? this.wrappedInstance : null;
                    return (0, $6fFrj.createElement)(WrappedComponent, (0, $876165ca1d22d290$export$2e2bcd8739ae039)({
                        ref: ref
                    }, this.props));
                }
            }
        ]);
        return WithSortableHandle;
    }((0, $6fFrj.Component)), (0, $5fApW.default)(_class, "displayName", $0f0f7fce05c407ef$var$provideDisplayName('sortableHandle', WrappedComponent)), _temp;
}
function $0f0f7fce05c407ef$var$isSortableHandle(node) {
    return node.sortableHandle != null;
}
var $0f0f7fce05c407ef$var$AutoScroller = function() {
    function AutoScroller(container, onScrollCallback) {
        (0, $9VR4w.default)(this, AutoScroller);
        this.container = container;
        this.onScrollCallback = onScrollCallback;
    }
    (0, $8HiBB.default)(AutoScroller, [
        {
            key: "clear",
            value: function clear() {
                if (this.interval == null) return;
                clearInterval(this.interval);
                this.interval = null;
            }
        },
        {
            key: "update",
            value: function update(_ref) {
                var _this = this;
                var translate = _ref.translate, minTranslate = _ref.minTranslate, maxTranslate = _ref.maxTranslate, width = _ref.width, height = _ref.height;
                var direction = {
                    x: 0,
                    y: 0
                };
                var speed = {
                    x: 1,
                    y: 1
                };
                var acceleration = {
                    x: 10,
                    y: 10
                };
                var _this$container = this.container, scrollTop = _this$container.scrollTop, scrollLeft = _this$container.scrollLeft, scrollHeight = _this$container.scrollHeight, scrollWidth = _this$container.scrollWidth, clientHeight = _this$container.clientHeight, clientWidth = _this$container.clientWidth;
                var isTop = scrollTop === 0;
                var isBottom = scrollHeight - scrollTop - clientHeight === 0;
                var isLeft = scrollLeft === 0;
                var isRight = scrollWidth - scrollLeft - clientWidth === 0;
                if (translate.y >= maxTranslate.y - height / 2 && !isBottom) {
                    direction.y = 1;
                    speed.y = acceleration.y * Math.abs((maxTranslate.y - height / 2 - translate.y) / height);
                } else if (translate.x >= maxTranslate.x - width / 2 && !isRight) {
                    direction.x = 1;
                    speed.x = acceleration.x * Math.abs((maxTranslate.x - width / 2 - translate.x) / width);
                } else if (translate.y <= minTranslate.y + height / 2 && !isTop) {
                    direction.y = -1;
                    speed.y = acceleration.y * Math.abs((translate.y - height / 2 - minTranslate.y) / height);
                } else if (translate.x <= minTranslate.x + width / 2 && !isLeft) {
                    direction.x = -1;
                    speed.x = acceleration.x * Math.abs((translate.x - width / 2 - minTranslate.x) / width);
                }
                if (this.interval) {
                    this.clear();
                    this.isAutoScrolling = false;
                }
                if (direction.x !== 0 || direction.y !== 0) this.interval = setInterval(function() {
                    _this.isAutoScrolling = true;
                    var offset = {
                        left: speed.x * direction.x,
                        top: speed.y * direction.y
                    };
                    _this.container.scrollTop += offset.top;
                    _this.container.scrollLeft += offset.left;
                    _this.onScrollCallback(offset);
                }, 5);
            }
        }
    ]);
    return AutoScroller;
}();
function $0f0f7fce05c407ef$var$defaultGetHelperDimensions(_ref) {
    var node = _ref.node;
    return {
        height: node.offsetHeight,
        width: node.offsetWidth
    };
}
function $0f0f7fce05c407ef$var$defaultShouldCancelStart(event) {
    var interactiveElements = [
        $0f0f7fce05c407ef$var$NodeType.Input,
        $0f0f7fce05c407ef$var$NodeType.Textarea,
        $0f0f7fce05c407ef$var$NodeType.Select,
        $0f0f7fce05c407ef$var$NodeType.Option,
        $0f0f7fce05c407ef$var$NodeType.Button
    ];
    if (interactiveElements.indexOf(event.target.tagName) !== -1) return true;
    if ($0f0f7fce05c407ef$var$closest(event.target, function(el) {
        return el.contentEditable === 'true';
    })) return true;
    return false;
}
var $0f0f7fce05c407ef$var$propTypes = {
    axis: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOf([
        'x',
        'y',
        'xy'
    ]),
    contentWindow: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).any,
    disableAutoscroll: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    distance: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    getContainer: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    getHelperDimensions: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    helperClass: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    helperContainer: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
        typeof HTMLElement === 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).any : (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).instanceOf(HTMLElement)
    ]),
    hideSortableGhost: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    keyboardSortingTransitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    lockAxis: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
    lockOffset: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string
        ]))
    ]),
    lockToContainerEdges: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    onSortEnd: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onSortMove: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onSortOver: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    onSortStart: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    pressDelay: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    pressThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    keyCodes: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).shape({
        lift: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number),
        drop: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number),
        cancel: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number),
        up: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number),
        down: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number)
    }),
    shouldCancelStart: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
    updateBeforeSortStart: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).func,
    useDragHandle: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool,
    useWindowAsScrollContainer: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool
};
var $0f0f7fce05c407ef$var$defaultKeyCodes = {
    lift: [
        $0f0f7fce05c407ef$var$KEYCODE.SPACE
    ],
    drop: [
        $0f0f7fce05c407ef$var$KEYCODE.SPACE
    ],
    cancel: [
        $0f0f7fce05c407ef$var$KEYCODE.ESC
    ],
    up: [
        $0f0f7fce05c407ef$var$KEYCODE.UP,
        $0f0f7fce05c407ef$var$KEYCODE.LEFT
    ],
    down: [
        $0f0f7fce05c407ef$var$KEYCODE.DOWN,
        $0f0f7fce05c407ef$var$KEYCODE.RIGHT
    ]
};
var $0f0f7fce05c407ef$var$defaultProps = {
    axis: 'y',
    disableAutoscroll: false,
    distance: 0,
    getHelperDimensions: $0f0f7fce05c407ef$var$defaultGetHelperDimensions,
    hideSortableGhost: true,
    lockOffset: '50%',
    lockToContainerEdges: false,
    pressDelay: 0,
    pressThreshold: 5,
    keyCodes: $0f0f7fce05c407ef$var$defaultKeyCodes,
    shouldCancelStart: $0f0f7fce05c407ef$var$defaultShouldCancelStart,
    transitionDuration: 300,
    useWindowAsScrollContainer: false
};
var $0f0f7fce05c407ef$var$omittedProps = Object.keys($0f0f7fce05c407ef$var$propTypes);
function $0f0f7fce05c407ef$var$validateProps(props) {
    (0, (/*@__PURE__*/$parcel$interopDefault($d787f36c95e388b1$exports)))(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
}
function $0f0f7fce05c407ef$var$_finallyRethrows(body, finalizer) {
    try {
        var result = body();
    } catch (e) {
        return finalizer(true, e);
    }
    if (result && result.then) return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
    return finalizer(false, value);
}
var $0f0f7fce05c407ef$var$SortableContext = (0, $6fFrj.createContext)({
    manager: {}
});
function $0f0f7fce05c407ef$export$a4b10e5599330dd0(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_React$Component) {
        (0, $2tFMC.default)(WithSortableContainer, _React$Component);
        function WithSortableContainer(props) {
            var _this;
            (0, $9VR4w.default)(this, WithSortableContainer);
            _this = (0, $hEAnx.default)(this, (0, $d60oy.default)(WithSortableContainer).call(this, props));
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "state", {});
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "handleStart", function(event) {
                var _this$props = _this.props, distance = _this$props.distance, shouldCancelStart = _this$props.shouldCancelStart;
                if (event.button === 2 || shouldCancelStart(event)) return;
                _this.touched = true;
                _this.position = $0f0f7fce05c407ef$var$getPosition(event);
                var node = $0f0f7fce05c407ef$var$closest(event.target, function(el) {
                    return el.sortableInfo != null;
                });
                if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
                    var useDragHandle = _this.props.useDragHandle;
                    var _node$sortableInfo = node.sortableInfo, index = _node$sortableInfo.index, collection = _node$sortableInfo.collection, disabled = _node$sortableInfo.disabled;
                    if (disabled) return;
                    if (useDragHandle && !$0f0f7fce05c407ef$var$closest(event.target, $0f0f7fce05c407ef$var$isSortableHandle)) return;
                    _this.manager.active = {
                        collection: collection,
                        index: index
                    };
                    if (!$0f0f7fce05c407ef$var$isTouchEvent(event) && event.target.tagName === $0f0f7fce05c407ef$var$NodeType.Anchor) event.preventDefault();
                    if (!distance) {
                        if (_this.props.pressDelay === 0) _this.handlePress(event);
                        else _this.pressTimer = setTimeout(function() {
                            return _this.handlePress(event);
                        }, _this.props.pressDelay);
                    }
                }
            });
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "nodeIsChild", function(node) {
                return node.sortableInfo.manager === _this.manager;
            });
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "handleMove", function(event) {
                var _this$props2 = _this.props, distance = _this$props2.distance, pressThreshold = _this$props2.pressThreshold;
                if (!_this.state.sorting && _this.touched && !_this._awaitingUpdateBeforeSortStart) {
                    var position = $0f0f7fce05c407ef$var$getPosition(event);
                    var delta = {
                        x: _this.position.x - position.x,
                        y: _this.position.y - position.y
                    };
                    var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);
                    _this.delta = delta;
                    if (!distance && (!pressThreshold || combinedDelta >= pressThreshold)) {
                        clearTimeout(_this.cancelTimer);
                        _this.cancelTimer = setTimeout(_this.cancel, 0);
                    } else if (distance && combinedDelta >= distance && _this.manager.isActive()) _this.handlePress(event);
                }
            });
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "handleEnd", function() {
                _this.touched = false;
                _this.cancel();
            });
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "cancel", function() {
                var distance = _this.props.distance;
                var sorting = _this.state.sorting;
                if (!sorting) {
                    if (!distance) clearTimeout(_this.pressTimer);
                    _this.manager.active = null;
                }
            });
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "handlePress", function(event) {
                try {
                    var active = _this.manager.getActive();
                    var _temp6 = function() {
                        if (active) {
                            var _temp7 = function _temp7() {
                                var index = _node.sortableInfo.index;
                                var margin = $0f0f7fce05c407ef$var$getElementMargin(_node);
                                var gridGap = $0f0f7fce05c407ef$var$getContainerGridGap(_this.container);
                                var containerBoundingRect = _this.scrollContainer.getBoundingClientRect();
                                var dimensions = _getHelperDimensions({
                                    index: index,
                                    node: _node,
                                    collection: _collection
                                });
                                _this.node = _node;
                                _this.margin = margin;
                                _this.gridGap = gridGap;
                                _this.width = dimensions.width;
                                _this.height = dimensions.height;
                                _this.marginOffset = {
                                    x: _this.margin.left + _this.margin.right + _this.gridGap.x,
                                    y: Math.max(_this.margin.top, _this.margin.bottom, _this.gridGap.y)
                                };
                                _this.boundingClientRect = _node.getBoundingClientRect();
                                _this.containerBoundingRect = containerBoundingRect;
                                _this.index = index;
                                _this.newIndex = index;
                                _this.axis = {
                                    x: _axis.indexOf('x') >= 0,
                                    y: _axis.indexOf('y') >= 0
                                };
                                _this.offsetEdge = $0f0f7fce05c407ef$var$getEdgeOffset(_node, _this.container);
                                if (_isKeySorting) _this.initialOffset = $0f0f7fce05c407ef$var$getPosition((0, $a8bea4e18d138eb8$export$2e2bcd8739ae039)({}, event, {
                                    pageX: _this.boundingClientRect.left,
                                    pageY: _this.boundingClientRect.top
                                }));
                                else _this.initialOffset = $0f0f7fce05c407ef$var$getPosition(event);
                                _this.initialScroll = {
                                    left: _this.scrollContainer.scrollLeft,
                                    top: _this.scrollContainer.scrollTop
                                };
                                _this.initialWindowScroll = {
                                    left: window.pageXOffset,
                                    top: window.pageYOffset
                                };
                                _this.helper = _this.helperContainer.appendChild($0f0f7fce05c407ef$var$cloneNode(_node));
                                $0f0f7fce05c407ef$var$setInlineStyles(_this.helper, {
                                    boxSizing: 'border-box',
                                    height: "".concat(_this.height, "px"),
                                    left: "".concat(_this.boundingClientRect.left - margin.left, "px"),
                                    pointerEvents: 'none',
                                    position: 'fixed',
                                    top: "".concat(_this.boundingClientRect.top - margin.top, "px"),
                                    width: "".concat(_this.width, "px")
                                });
                                if (_isKeySorting) _this.helper.focus();
                                if (_hideSortableGhost) {
                                    _this.sortableGhost = _node;
                                    $0f0f7fce05c407ef$var$setInlineStyles(_node, {
                                        opacity: 0,
                                        visibility: 'hidden'
                                    });
                                }
                                _this.minTranslate = {};
                                _this.maxTranslate = {};
                                if (_isKeySorting) {
                                    var _ref = _useWindowAsScrollContainer ? {
                                        top: 0,
                                        left: 0,
                                        width: _this.contentWindow.innerWidth,
                                        height: _this.contentWindow.innerHeight
                                    } : _this.containerBoundingRect, containerTop = _ref.top, containerLeft = _ref.left, containerWidth = _ref.width, containerHeight = _ref.height;
                                    var containerBottom = containerTop + containerHeight;
                                    var containerRight = containerLeft + containerWidth;
                                    if (_this.axis.x) {
                                        _this.minTranslate.x = containerLeft - _this.boundingClientRect.left;
                                        _this.maxTranslate.x = containerRight - (_this.boundingClientRect.left + _this.width);
                                    }
                                    if (_this.axis.y) {
                                        _this.minTranslate.y = containerTop - _this.boundingClientRect.top;
                                        _this.maxTranslate.y = containerBottom - (_this.boundingClientRect.top + _this.height);
                                    }
                                } else {
                                    if (_this.axis.x) {
                                        _this.minTranslate.x = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
                                        _this.maxTranslate.x = (_useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
                                    }
                                    if (_this.axis.y) {
                                        _this.minTranslate.y = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
                                        _this.maxTranslate.y = (_useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
                                    }
                                }
                                if (_helperClass) _helperClass.split(' ').forEach(function(className) {
                                    return _this.helper.classList.add(className);
                                });
                                _this.listenerNode = event.touches ? event.target : _this.contentWindow;
                                if (_isKeySorting) {
                                    _this.listenerNode.addEventListener('wheel', _this.handleKeyEnd, true);
                                    _this.listenerNode.addEventListener('mousedown', _this.handleKeyEnd, true);
                                    _this.listenerNode.addEventListener('keydown', _this.handleKeyDown);
                                } else {
                                    $0f0f7fce05c407ef$var$events.move.forEach(function(eventName) {
                                        return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
                                    });
                                    $0f0f7fce05c407ef$var$events.end.forEach(function(eventName) {
                                        return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
                                    });
                                }
                                _this.setState({
                                    sorting: true,
                                    sortingIndex: index
                                });
                                if (_onSortStart) _onSortStart({
                                    node: _node,
                                    index: index,
                                    collection: _collection,
                                    isKeySorting: _isKeySorting,
                                    nodes: _this.manager.getOrderedRefs(),
                                    helper: _this.helper
                                }, event);
                                if (_isKeySorting) _this.keyMove(0);
                            };
                            var _this$props3 = _this.props, _axis = _this$props3.axis, _getHelperDimensions = _this$props3.getHelperDimensions, _helperClass = _this$props3.helperClass, _hideSortableGhost = _this$props3.hideSortableGhost, updateBeforeSortStart = _this$props3.updateBeforeSortStart, _onSortStart = _this$props3.onSortStart, _useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
                            var _node = active.node, _collection = active.collection;
                            var _isKeySorting = _this.manager.isKeySorting;
                            var _temp8 = function() {
                                if (typeof updateBeforeSortStart === 'function') {
                                    _this._awaitingUpdateBeforeSortStart = true;
                                    var _temp9 = $0f0f7fce05c407ef$var$_finallyRethrows(function() {
                                        var index = _node.sortableInfo.index;
                                        return Promise.resolve(updateBeforeSortStart({
                                            collection: _collection,
                                            index: index,
                                            node: _node,
                                            isKeySorting: _isKeySorting
                                        }, event)).then(function() {});
                                    }, function(_wasThrown, _result) {
                                        _this._awaitingUpdateBeforeSortStart = false;
                                        if (_wasThrown) throw _result;
                                        return _result;
                                    });
                                    if (_temp9 && _temp9.then) return _temp9.then(function() {});
                                }
                            }();
                            return _temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8);
                        }
                    }();
                    return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function() {}) : void 0);
                } catch (e) {
                    return Promise.reject(e);
                }
            });
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "handleSortMove", function(event) {
                var onSortMove = _this.props.onSortMove;
                if (typeof event.preventDefault === 'function' && event.cancelable) event.preventDefault();
                _this.updateHelperPosition(event);
                _this.animateNodes();
                _this.autoscroll();
                if (onSortMove) onSortMove(event);
            });
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "handleSortEnd", function(event) {
                var _this$props4 = _this.props, hideSortableGhost = _this$props4.hideSortableGhost, onSortEnd = _this$props4.onSortEnd;
                var _this$manager = _this.manager, collection = _this$manager.active.collection, isKeySorting = _this$manager.isKeySorting;
                var nodes = _this.manager.getOrderedRefs();
                if (_this.listenerNode) {
                    if (isKeySorting) {
                        _this.listenerNode.removeEventListener('wheel', _this.handleKeyEnd, true);
                        _this.listenerNode.removeEventListener('mousedown', _this.handleKeyEnd, true);
                        _this.listenerNode.removeEventListener('keydown', _this.handleKeyDown);
                    } else {
                        $0f0f7fce05c407ef$var$events.move.forEach(function(eventName) {
                            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
                        });
                        $0f0f7fce05c407ef$var$events.end.forEach(function(eventName) {
                            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
                        });
                    }
                }
                _this.helper.parentNode.removeChild(_this.helper);
                if (hideSortableGhost && _this.sortableGhost) $0f0f7fce05c407ef$var$setInlineStyles(_this.sortableGhost, {
                    opacity: '',
                    visibility: ''
                });
                for(var i = 0, len = nodes.length; i < len; i++){
                    var _node2 = nodes[i];
                    var el = _node2.node;
                    _node2.edgeOffset = null;
                    _node2.boundingClientRect = null;
                    $0f0f7fce05c407ef$var$setTranslate3d(el, null);
                    $0f0f7fce05c407ef$var$setTransitionDuration(el, null);
                    _node2.translate = null;
                }
                _this.autoScroller.clear();
                _this.manager.active = null;
                _this.manager.isKeySorting = false;
                _this.setState({
                    sorting: false,
                    sortingIndex: null
                });
                if (typeof onSortEnd === 'function') onSortEnd({
                    collection: collection,
                    newIndex: _this.newIndex,
                    oldIndex: _this.index,
                    isKeySorting: isKeySorting,
                    nodes: nodes
                }, event);
                _this.touched = false;
            });
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "autoscroll", function() {
                var disableAutoscroll = _this.props.disableAutoscroll;
                var isKeySorting = _this.manager.isKeySorting;
                if (disableAutoscroll) {
                    _this.autoScroller.clear();
                    return;
                }
                if (isKeySorting) {
                    var translate = (0, $a8bea4e18d138eb8$export$2e2bcd8739ae039)({}, _this.translate);
                    var scrollX = 0;
                    var scrollY = 0;
                    if (_this.axis.x) {
                        translate.x = Math.min(_this.maxTranslate.x, Math.max(_this.minTranslate.x, _this.translate.x));
                        scrollX = _this.translate.x - translate.x;
                    }
                    if (_this.axis.y) {
                        translate.y = Math.min(_this.maxTranslate.y, Math.max(_this.minTranslate.y, _this.translate.y));
                        scrollY = _this.translate.y - translate.y;
                    }
                    _this.translate = translate;
                    $0f0f7fce05c407ef$var$setTranslate3d(_this.helper, _this.translate);
                    _this.scrollContainer.scrollLeft += scrollX;
                    _this.scrollContainer.scrollTop += scrollY;
                    return;
                }
                _this.autoScroller.update({
                    height: _this.height,
                    maxTranslate: _this.maxTranslate,
                    minTranslate: _this.minTranslate,
                    translate: _this.translate,
                    width: _this.width
                });
            });
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "onAutoScroll", function(offset) {
                _this.translate.x += offset.left;
                _this.translate.y += offset.top;
                _this.animateNodes();
            });
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "handleKeyDown", function(event) {
                var keyCode = event.keyCode;
                var _this$props5 = _this.props, shouldCancelStart = _this$props5.shouldCancelStart, _this$props5$keyCodes = _this$props5.keyCodes, customKeyCodes = _this$props5$keyCodes === void 0 ? {} : _this$props5$keyCodes;
                var keyCodes = (0, $a8bea4e18d138eb8$export$2e2bcd8739ae039)({}, $0f0f7fce05c407ef$var$defaultKeyCodes, customKeyCodes);
                if (_this.manager.active && !_this.manager.isKeySorting || !_this.manager.active && (!keyCodes.lift.includes(keyCode) || shouldCancelStart(event) || !_this.isValidSortingTarget(event))) return;
                event.stopPropagation();
                event.preventDefault();
                if (keyCodes.lift.includes(keyCode) && !_this.manager.active) _this.keyLift(event);
                else if (keyCodes.drop.includes(keyCode) && _this.manager.active) _this.keyDrop(event);
                else if (keyCodes.cancel.includes(keyCode)) {
                    _this.newIndex = _this.manager.active.index;
                    _this.keyDrop(event);
                } else if (keyCodes.up.includes(keyCode)) _this.keyMove(-1);
                else if (keyCodes.down.includes(keyCode)) _this.keyMove(1);
            });
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "keyLift", function(event) {
                var target = event.target;
                var node = $0f0f7fce05c407ef$var$closest(target, function(el) {
                    return el.sortableInfo != null;
                });
                var _node$sortableInfo2 = node.sortableInfo, index = _node$sortableInfo2.index, collection = _node$sortableInfo2.collection;
                _this.initialFocusedNode = target;
                _this.manager.isKeySorting = true;
                _this.manager.active = {
                    index: index,
                    collection: collection
                };
                _this.handlePress(event);
            });
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "keyMove", function(shift) {
                var nodes = _this.manager.getOrderedRefs();
                var lastIndex = nodes[nodes.length - 1].node.sortableInfo.index;
                var newIndex = _this.newIndex + shift;
                var prevIndex = _this.newIndex;
                if (newIndex < 0 || newIndex > lastIndex) return;
                _this.prevIndex = prevIndex;
                _this.newIndex = newIndex;
                var targetIndex = $0f0f7fce05c407ef$var$getTargetIndex(_this.newIndex, _this.prevIndex, _this.index);
                var target = nodes.find(function(_ref2) {
                    var node = _ref2.node;
                    return node.sortableInfo.index === targetIndex;
                });
                var targetNode = target.node;
                var scrollDelta = _this.containerScrollDelta;
                var targetBoundingClientRect = target.boundingClientRect || $0f0f7fce05c407ef$var$getScrollAdjustedBoundingClientRect(targetNode, scrollDelta);
                var targetTranslate = target.translate || {
                    x: 0,
                    y: 0
                };
                var targetPosition = {
                    top: targetBoundingClientRect.top + targetTranslate.y - scrollDelta.top,
                    left: targetBoundingClientRect.left + targetTranslate.x - scrollDelta.left
                };
                var shouldAdjustForSize = prevIndex < newIndex;
                var sizeAdjustment = {
                    x: shouldAdjustForSize && _this.axis.x ? targetNode.offsetWidth - _this.width : 0,
                    y: shouldAdjustForSize && _this.axis.y ? targetNode.offsetHeight - _this.height : 0
                };
                _this.handleSortMove({
                    pageX: targetPosition.left + sizeAdjustment.x,
                    pageY: targetPosition.top + sizeAdjustment.y,
                    ignoreTransition: shift === 0
                });
            });
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "keyDrop", function(event) {
                _this.handleSortEnd(event);
                if (_this.initialFocusedNode) _this.initialFocusedNode.focus();
            });
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "handleKeyEnd", function(event) {
                if (_this.manager.active) _this.keyDrop(event);
            });
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "isValidSortingTarget", function(event) {
                var useDragHandle = _this.props.useDragHandle;
                var target = event.target;
                var node = $0f0f7fce05c407ef$var$closest(target, function(el) {
                    return el.sortableInfo != null;
                });
                return node && node.sortableInfo && !node.sortableInfo.disabled && (useDragHandle ? $0f0f7fce05c407ef$var$isSortableHandle(target) : target.sortableInfo);
            });
            var manager = new $0f0f7fce05c407ef$var$Manager();
            $0f0f7fce05c407ef$var$validateProps(props);
            _this.manager = manager;
            _this.wrappedInstance = (0, $6fFrj.createRef)();
            _this.sortableContextValue = {
                manager: manager
            };
            _this.events = {
                end: _this.handleEnd,
                move: _this.handleMove,
                start: _this.handleStart
            };
            return _this;
        }
        (0, $8HiBB.default)(WithSortableContainer, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this2 = this;
                    var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
                    var container = this.getContainer();
                    Promise.resolve(container).then(function(containerNode) {
                        _this2.container = containerNode;
                        _this2.document = _this2.container.ownerDocument || document;
                        var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;
                        _this2.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
                        _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : $0f0f7fce05c407ef$var$getScrollingParent(_this2.container) || _this2.container;
                        _this2.autoScroller = new $0f0f7fce05c407ef$var$AutoScroller(_this2.scrollContainer, _this2.onAutoScroll);
                        Object.keys(_this2.events).forEach(function(key) {
                            return $0f0f7fce05c407ef$var$events[key].forEach(function(eventName) {
                                return _this2.container.addEventListener(eventName, _this2.events[key], false);
                            });
                        });
                        _this2.container.addEventListener('keydown', _this2.handleKeyDown);
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    var _this3 = this;
                    if (this.helper && this.helper.parentNode) this.helper.parentNode.removeChild(this.helper);
                    if (!this.container) return;
                    Object.keys(this.events).forEach(function(key) {
                        return $0f0f7fce05c407ef$var$events[key].forEach(function(eventName) {
                            return _this3.container.removeEventListener(eventName, _this3.events[key]);
                        });
                    });
                    this.container.removeEventListener('keydown', this.handleKeyDown);
                }
            },
            {
                key: "updateHelperPosition",
                value: function updateHelperPosition(event) {
                    var _this$props6 = this.props, lockAxis = _this$props6.lockAxis, lockOffset = _this$props6.lockOffset, lockToContainerEdges = _this$props6.lockToContainerEdges, transitionDuration = _this$props6.transitionDuration, _this$props6$keyboard = _this$props6.keyboardSortingTransitionDuration, keyboardSortingTransitionDuration = _this$props6$keyboard === void 0 ? transitionDuration : _this$props6$keyboard;
                    var isKeySorting = this.manager.isKeySorting;
                    var ignoreTransition = event.ignoreTransition;
                    var offset = $0f0f7fce05c407ef$var$getPosition(event);
                    var translate = {
                        x: offset.x - this.initialOffset.x,
                        y: offset.y - this.initialOffset.y
                    };
                    translate.y -= window.pageYOffset - this.initialWindowScroll.top;
                    translate.x -= window.pageXOffset - this.initialWindowScroll.left;
                    this.translate = translate;
                    if (lockToContainerEdges) {
                        var _getLockPixelOffsets = $0f0f7fce05c407ef$var$getLockPixelOffsets({
                            height: this.height,
                            lockOffset: lockOffset,
                            width: this.width
                        }), _getLockPixelOffsets2 = (0, $951471461146a3e9$export$2e2bcd8739ae039)(_getLockPixelOffsets, 2), minLockOffset = _getLockPixelOffsets2[0], maxLockOffset = _getLockPixelOffsets2[1];
                        var minOffset = {
                            x: this.width / 2 - minLockOffset.x,
                            y: this.height / 2 - minLockOffset.y
                        };
                        var maxOffset = {
                            x: this.width / 2 - maxLockOffset.x,
                            y: this.height / 2 - maxLockOffset.y
                        };
                        translate.x = $0f0f7fce05c407ef$var$limit(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
                        translate.y = $0f0f7fce05c407ef$var$limit(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
                    }
                    if (lockAxis === 'x') translate.y = 0;
                    else if (lockAxis === 'y') translate.x = 0;
                    if (isKeySorting && keyboardSortingTransitionDuration && !ignoreTransition) $0f0f7fce05c407ef$var$setTransitionDuration(this.helper, keyboardSortingTransitionDuration);
                    $0f0f7fce05c407ef$var$setTranslate3d(this.helper, translate);
                }
            },
            {
                key: "animateNodes",
                value: function animateNodes() {
                    var _this$props7 = this.props, transitionDuration = _this$props7.transitionDuration, hideSortableGhost = _this$props7.hideSortableGhost, onSortOver = _this$props7.onSortOver;
                    var containerScrollDelta = this.containerScrollDelta, windowScrollDelta = this.windowScrollDelta;
                    var nodes = this.manager.getOrderedRefs();
                    var sortingOffset = {
                        left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
                        top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
                    };
                    var isKeySorting = this.manager.isKeySorting;
                    var prevIndex = this.newIndex;
                    this.newIndex = null;
                    for(var i = 0, len = nodes.length; i < len; i++){
                        var _node3 = nodes[i].node;
                        var index = _node3.sortableInfo.index;
                        var width = _node3.offsetWidth;
                        var height = _node3.offsetHeight;
                        var offset = {
                            height: this.height > height ? height / 2 : this.height / 2,
                            width: this.width > width ? width / 2 : this.width / 2
                        };
                        var mustShiftBackward = isKeySorting && index > this.index && index <= prevIndex;
                        var mustShiftForward = isKeySorting && index < this.index && index >= prevIndex;
                        var translate = {
                            x: 0,
                            y: 0
                        };
                        var edgeOffset = nodes[i].edgeOffset;
                        if (!edgeOffset) {
                            edgeOffset = $0f0f7fce05c407ef$var$getEdgeOffset(_node3, this.container);
                            nodes[i].edgeOffset = edgeOffset;
                            if (isKeySorting) nodes[i].boundingClientRect = $0f0f7fce05c407ef$var$getScrollAdjustedBoundingClientRect(_node3, containerScrollDelta);
                        }
                        var nextNode = i < nodes.length - 1 && nodes[i + 1];
                        var prevNode = i > 0 && nodes[i - 1];
                        if (nextNode && !nextNode.edgeOffset) {
                            nextNode.edgeOffset = $0f0f7fce05c407ef$var$getEdgeOffset(nextNode.node, this.container);
                            if (isKeySorting) nextNode.boundingClientRect = $0f0f7fce05c407ef$var$getScrollAdjustedBoundingClientRect(nextNode.node, containerScrollDelta);
                        }
                        if (index === this.index) {
                            if (hideSortableGhost) {
                                this.sortableGhost = _node3;
                                $0f0f7fce05c407ef$var$setInlineStyles(_node3, {
                                    opacity: 0,
                                    visibility: 'hidden'
                                });
                            }
                            continue;
                        }
                        if (transitionDuration) $0f0f7fce05c407ef$var$setTransitionDuration(_node3, transitionDuration);
                        if (this.axis.x) {
                            if (this.axis.y) {
                                if (mustShiftForward || index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                                    translate.x = this.width + this.marginOffset.x;
                                    if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                                        if (nextNode) {
                                            translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                                            translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                                        }
                                    }
                                    if (this.newIndex === null) this.newIndex = index;
                                } else if (mustShiftBackward || index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                                    translate.x = -(this.width + this.marginOffset.x);
                                    if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                                        if (prevNode) {
                                            translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                                            translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                                        }
                                    }
                                    this.newIndex = index;
                                }
                            } else {
                                if (mustShiftBackward || index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                                    translate.x = -(this.width + this.marginOffset.x);
                                    this.newIndex = index;
                                } else if (mustShiftForward || index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                                    translate.x = this.width + this.marginOffset.x;
                                    if (this.newIndex == null) this.newIndex = index;
                                }
                            }
                        } else if (this.axis.y) {
                            if (mustShiftBackward || index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
                                translate.y = -(this.height + this.marginOffset.y);
                                this.newIndex = index;
                            } else if (mustShiftForward || index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
                                translate.y = this.height + this.marginOffset.y;
                                if (this.newIndex == null) this.newIndex = index;
                            }
                        }
                        $0f0f7fce05c407ef$var$setTranslate3d(_node3, translate);
                        nodes[i].translate = translate;
                    }
                    if (this.newIndex == null) this.newIndex = this.index;
                    if (isKeySorting) this.newIndex = prevIndex;
                    var oldIndex = isKeySorting ? this.prevIndex : prevIndex;
                    if (onSortOver && this.newIndex !== oldIndex) onSortOver({
                        collection: this.manager.active.collection,
                        index: this.index,
                        newIndex: this.newIndex,
                        oldIndex: oldIndex,
                        isKeySorting: isKeySorting,
                        nodes: nodes,
                        helper: this.helper
                    });
                }
            },
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($d787f36c95e388b1$exports)))(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
                    return this.wrappedInstance.current;
                }
            },
            {
                key: "getContainer",
                value: function getContainer() {
                    var getContainer = this.props.getContainer;
                    if (typeof getContainer !== 'function') return (0, $8CZEB.findDOMNode)(this);
                    return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
                }
            },
            {
                key: "render",
                value: function render() {
                    var ref = config.withRef ? this.wrappedInstance : null;
                    return (0, $6fFrj.createElement)($0f0f7fce05c407ef$var$SortableContext.Provider, {
                        value: this.sortableContextValue
                    }, (0, $6fFrj.createElement)(WrappedComponent, (0, $876165ca1d22d290$export$2e2bcd8739ae039)({
                        ref: ref
                    }, $0f0f7fce05c407ef$var$omit(this.props, $0f0f7fce05c407ef$var$omittedProps))));
                }
            },
            {
                key: "helperContainer",
                get: function get() {
                    var helperContainer = this.props.helperContainer;
                    if (typeof helperContainer === 'function') return helperContainer();
                    return this.props.helperContainer || this.document.body;
                }
            },
            {
                key: "containerScrollDelta",
                get: function get() {
                    var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
                    if (useWindowAsScrollContainer) return {
                        left: 0,
                        top: 0
                    };
                    return {
                        left: this.scrollContainer.scrollLeft - this.initialScroll.left,
                        top: this.scrollContainer.scrollTop - this.initialScroll.top
                    };
                }
            },
            {
                key: "windowScrollDelta",
                get: function get() {
                    return {
                        left: this.contentWindow.pageXOffset - this.initialWindowScroll.left,
                        top: this.contentWindow.pageYOffset - this.initialWindowScroll.top
                    };
                }
            }
        ]);
        return WithSortableContainer;
    }((0, $6fFrj.Component)), (0, $5fApW.default)(_class, "displayName", $0f0f7fce05c407ef$var$provideDisplayName('sortableList', WrappedComponent)), (0, $5fApW.default)(_class, "defaultProps", $0f0f7fce05c407ef$var$defaultProps), (0, $5fApW.default)(_class, "propTypes", $0f0f7fce05c407ef$var$propTypes), _temp;
}
var $0f0f7fce05c407ef$var$propTypes$1 = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number.isRequired,
    collection: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).string
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($cgjHV))).bool
};
var $0f0f7fce05c407ef$var$omittedProps$1 = Object.keys($0f0f7fce05c407ef$var$propTypes$1);
function $0f0f7fce05c407ef$export$58d1e4fb0d207bf7(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_React$Component) {
        (0, $2tFMC.default)(WithSortableElement, _React$Component);
        function WithSortableElement() {
            var _getPrototypeOf2;
            var _this;
            (0, $9VR4w.default)(this, WithSortableElement);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = (0, $hEAnx.default)(this, (_getPrototypeOf2 = (0, $d60oy.default)(WithSortableElement)).call.apply(_getPrototypeOf2, [
                this
            ].concat(args)));
            (0, $5fApW.default)((0, $4TaHZ.default)((0, $4TaHZ.default)(_this)), "wrappedInstance", (0, $6fFrj.createRef)());
            return _this;
        }
        (0, $8HiBB.default)(WithSortableElement, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.register();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.node) {
                        if (prevProps.index !== this.props.index) this.node.sortableInfo.index = this.props.index;
                        if (prevProps.disabled !== this.props.disabled) this.node.sortableInfo.disabled = this.props.disabled;
                    }
                    if (prevProps.collection !== this.props.collection) {
                        this.unregister(prevProps.collection);
                        this.register();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.unregister();
                }
            },
            {
                key: "register",
                value: function register() {
                    var _this$props = this.props, collection = _this$props.collection, disabled = _this$props.disabled, index = _this$props.index;
                    var node = (0, $8CZEB.findDOMNode)(this);
                    node.sortableInfo = {
                        collection: collection,
                        disabled: disabled,
                        index: index,
                        manager: this.context.manager
                    };
                    this.node = node;
                    this.ref = {
                        node: node
                    };
                    this.context.manager.add(collection, this.ref);
                }
            },
            {
                key: "unregister",
                value: function unregister() {
                    var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.collection;
                    this.context.manager.remove(collection, this.ref);
                }
            },
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($d787f36c95e388b1$exports)))(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
                    return this.wrappedInstance.current;
                }
            },
            {
                key: "render",
                value: function render() {
                    var ref = config.withRef ? this.wrappedInstance : null;
                    return (0, $6fFrj.createElement)(WrappedComponent, (0, $876165ca1d22d290$export$2e2bcd8739ae039)({
                        ref: ref
                    }, $0f0f7fce05c407ef$var$omit(this.props, $0f0f7fce05c407ef$var$omittedProps$1)));
                }
            }
        ]);
        return WithSortableElement;
    }((0, $6fFrj.Component)), (0, $5fApW.default)(_class, "displayName", $0f0f7fce05c407ef$var$provideDisplayName('sortableElement', WrappedComponent)), (0, $5fApW.default)(_class, "contextType", $0f0f7fce05c407ef$var$SortableContext), (0, $5fApW.default)(_class, "propTypes", $0f0f7fce05c407ef$var$propTypes$1), (0, $5fApW.default)(_class, "defaultProps", {
        collection: 0
    }), _temp;
}









const $d1d0d5a6a640c7b1$export$3be6ab8ec741e1a2 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Progress Status created successfully!');
};
const $d1d0d5a6a640c7b1$export$b8d26c8402019479 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Progress Status updated successfully!');
};
const $d1d0d5a6a640c7b1$export$bac9a38915c465a = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Progress Status deleted  successfully!');
};
const $d1d0d5a6a640c7b1$export$d559e6d83a28af84 = ()=>{
    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Progress Status sorted successfully!');
};



var $bb3TF = parcelRequire("bb3TF");


const { MenuOutlined: $d3c503b2accd0037$var$MenuOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $d3c503b2accd0037$var$DragHandle = (0, $0f0f7fce05c407ef$export$680929e2aec3ce89)(({ disabled: disabled })=>{
    if (disabled) return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        title: "Default statuses are not sortable",
        children: (0, $bb3TF.jsx)($d3c503b2accd0037$var$MenuOutlined, {
            style: {
                cursor: 'not-allowed',
                color: '#999',
                display: 'block'
            }
        })
    });
    return (0, $bb3TF.jsx)($d3c503b2accd0037$var$MenuOutlined, {
        style: {
            cursor: 'ns-resize',
            color: '#999',
            display: 'block'
        }
    });
});
var $d3c503b2accd0037$export$2e2bcd8739ae039 = $d3c503b2accd0037$var$DragHandle;




var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");

const $84d5a6213c4669b2$var$MySortableContainer = (0, $0f0f7fce05c407ef$export$a4b10e5599330dd0)((props)=>(0, $bb3TF.jsx)("tbody", {
        ...props
    }));
const $84d5a6213c4669b2$var$DraggableContainer = ({ onSortEnd: onSortEnd, ...props })=>(0, $bb3TF.jsx)($84d5a6213c4669b2$var$MySortableContainer, {
        onSortEnd: onSortEnd,
        ...props
    });
var $84d5a6213c4669b2$export$2e2bcd8739ae039 = $84d5a6213c4669b2$var$DraggableContainer;


var $3d1ddce0415a8ac4$export$cb6c30b631422a13;
var $3d1ddce0415a8ac4$export$fdd7b475efdef95e;
var $3d1ddce0415a8ac4$export$ca4e8b3f196cd6b9;
var $3d1ddce0415a8ac4$export$547590a5921c000b;
$3d1ddce0415a8ac4$export$cb6c30b631422a13 = `agv7ZW_btnContainer`;
$3d1ddce0415a8ac4$export$fdd7b475efdef95e = `agv7ZW_drag-invisible`;
$3d1ddce0415a8ac4$export$ca4e8b3f196cd6b9 = `agv7ZW_drag-visible`;
$3d1ddce0415a8ac4$export$547590a5921c000b = `agv7ZW_row-dragging`;



const { EditOutlined: $8cab7f86901e71c6$var$EditOutlined, DeleteOutlined: $8cab7f86901e71c6$var$DeleteOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const { Paragraph: $8cab7f86901e71c6$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { useBreakpoint: $8cab7f86901e71c6$var$useBreakpoint } = (0, $89d88a41b53d163f$export$2e2bcd8739ae039);
const $8cab7f86901e71c6$var$SortableItem = (0, $0f0f7fce05c407ef$export$58d1e4fb0d207bf7)((props)=>(0, $bb3TF.jsx)("tr", {
        ...props
    }));
// only new statuses are sortable/deletable, default statuses are not
const $8cab7f86901e71c6$var$disableByObj = (obj)=>obj && [
        (0, $8f7fe33a44836803$export$f493388d2527ca1f).Completed,
        (0, $8f7fe33a44836803$export$f493388d2527ca1f).Unassigned,
        (0, $8f7fe33a44836803$export$f493388d2527ca1f).InProgress
    ].includes(obj.underlyingStatus);
const $8cab7f86901e71c6$var$ProgressStatuses = ()=>{
    const screens = $8cab7f86901e71c6$var$useBreakpoint();
    const [statuses, setStatuses] = (0, $6fFrj.useState)([]);
    const [isModalVisible, setIsModalVisible] = (0, $6fFrj.useState)(false);
    const [status, setStatus] = (0, $6fFrj.useState)('');
    const [updateStatusId, setUpdateStatusId] = (0, $6fFrj.useState)('');
    const [loading, setLoading] = (0, $6fFrj.useState)(false);
    // Get progress status
    const { data: progressStatusData, loading: loadingStatusData } = (0, $732264f53056e08f$export$9ca2f42b9d2b732f)();
    (0, $6fFrj.useEffect)(()=>{
        if (progressStatusData && progressStatusData.ProgressStatuses) {
            const sorted = Object.assign([], progressStatusData.ProgressStatuses);
            setStatuses(sorted.sort((a, b)=>a.index - b.index));
        }
    }, [
        progressStatusData
    ]);
    // Delete progress status
    const [deleteProgressStatus, { loading: loadingDelete }] = (0, $33beb5b1bfae180c$export$1ddc74f362951435)({
        onCompleted: (0, $d1d0d5a6a640c7b1$export$bac9a38915c465a),
        onError: (error)=>{
            const errorMessage = error.graphQLErrors?.at(0)?.message;
            if (errorMessage && errorMessage.indexOf('is used') > -1) (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('You cannot delete a status while there are jobs assigned to it. Please remove all jobs from this status and you can delete it.');
            else (0, $27f5c1aafb8cd10d$export$85b43ea59a8cb058)();
        },
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$b7a996941feacd9b)
            }
        ],
        awaitRefetchQueries: true
    });
    const handleRemoveProgress = async (id)=>{
        await deleteProgressStatus({
            variables: {
                id: id
            }
        });
    };
    // Update progress status
    const [updateProgressStatus, { loading: loadingUpdate }] = (0, $33beb5b1bfae180c$export$d71ddcc0c0996419)({
        onError: (0, $27f5c1aafb8cd10d$export$85b43ea59a8cb058),
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$b7a996941feacd9b)
            }
        ],
        awaitRefetchQueries: true
    });
    const [switchOrderOfProgressStatus, { loading: loadingSwitchOrder }] = (0, $33beb5b1bfae180c$export$bc017c666357fa36)({
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        },
        onCompleted: (0, $d1d0d5a6a640c7b1$export$d559e6d83a28af84),
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$b7a996941feacd9b)
            }
        ],
        awaitRefetchQueries: true
    });
    const handleEditProgress = async ()=>{
        await updateProgressStatus({
            variables: {
                updateProgressStatusInput: {
                    id: updateStatusId,
                    status: status
                }
            }
        });
    };
    // Create progress status
    const [createProgressStatus, { loading: loadingCreate }] = (0, $33beb5b1bfae180c$export$677cd2e5fbceed8f)({
        onCompleted: (0, $d1d0d5a6a640c7b1$export$3be6ab8ec741e1a2),
        onError: (0, $27f5c1aafb8cd10d$export$85b43ea59a8cb058),
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$b7a996941feacd9b)
            }
        ],
        awaitRefetchQueries: true
    });
    const handleCreateProgress = ()=>{
        if (status !== '') {
            const cap = status.replace(/\b\w/g, (l)=>l.toUpperCase());
            if (statuses.find((item)=>item.status === cap) === undefined) {
                const localstatus = Object.assign([], statuses);
                if (cap === 'Completed') {
                    const newstatus = {
                        status: cap
                    };
                    localstatus.push(newstatus);
                } else if (cap === 'Unassigned') localstatus.unshift({
                    status: cap
                });
                else localstatus.splice(statuses.length - 1, 0, {
                    status: cap
                });
                localstatus.forEach(async (item, i)=>{
                    const index = statuses[statuses.length - 2].index + 1;
                    if (!item.id) await createProgressStatus({
                        variables: {
                            createProgressStatusesInput: {
                                index: index,
                                status: cap
                            }
                        }
                    });
                });
            } else (0, $e19596a12ff9a33f$export$f69c19e57285b83a)('Status Progress already created.', 'error');
        }
    };
    // modal actions
    // set edit modal
    const setUpdate = (obj)=>{
        setUpdateStatusId(obj.id);
        setStatus(obj.status);
        setIsModalVisible(true);
    };
    const handleCancel = ()=>{
        setIsModalVisible(false);
        setStatus('');
        setUpdateStatusId('');
    };
    const handleOk = ()=>{
        if (updateStatusId !== '') handleEditProgress();
        else handleCreateProgress();
        handleCancel();
    };
    // Draggable actions
    const onSortEnd = ({ oldIndex: oldIndex, newIndex: newIndex })=>{
        if (oldIndex !== newIndex) {
            if (newIndex !== 0 && newIndex !== statuses.length - 1) {
                setLoading(true);
                // const newitems = arrayMove(statuses, oldIndex, newIndex);
                const newData = (0, $0f0f7fce05c407ef$export$5d49d615ad5ea2b0)([].concat(statuses), oldIndex, newIndex).filter((el)=>!!el);
                setStatuses(newData);
                switchOrderOfProgressStatus({
                    variables: {
                        switchOrderOfProgressStatusesInput: {
                            idOne: statuses[newIndex].id,
                            idTwo: statuses[oldIndex].id,
                            indexOne: statuses[oldIndex].index,
                            indexTwo: statuses[newIndex].index
                        }
                    }
                });
            } else {
                (0, $e19596a12ff9a33f$export$f69c19e57285b83a)('You cannot place custom status before "Unassigned" or after "Completed" status.', 'error');
                setLoading(false);
            }
        }
    };
    const DraggableBodyRow = ({ ...restProps })=>{
        const index = statuses.findIndex((x)=>x.id === restProps['data-row-key']);
        return (0, $bb3TF.jsx)($8cab7f86901e71c6$var$SortableItem, {
            index: index,
            ...restProps,
            disabled: $8cab7f86901e71c6$var$disableByObj(statuses[index])
        });
    };
    if (loadingStatusData) return (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
        size: "large"
    });
    return (0, $bb3TF.jsx)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
        style: {
            backgroundColor: 'white'
        },
        children: (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
            direction: "vertical",
            style: {
                width: '98%'
            },
            children: [
                (0, $bb3TF.jsx)((0, $58c1491b566e843c$export$2e2bcd8739ae039), {
                    title: "Workflow",
                    tooltipTitle: "How does this work?",
                    tooltipContent: (0, $bb3TF.jsx)($8cab7f86901e71c6$var$Paragraph, {
                        children: "Add or remove progress status sections for your jobs in the dashboard."
                    })
                }),
                (0, $bb3TF.jsx)((0, $2eb2b7b37988b8f9$export$2e2bcd8739ae039), {
                    loading: loadingCreate || loadingUpdate || loadingDelete || loadingSwitchOrder,
                    rowKey: (record)=>record.id,
                    columns: [
                        {
                            title: 'Sort',
                            dataIndex: '',
                            key: 'sort',
                            width: 100,
                            render (obj) {
                                return (0, $bb3TF.jsx)((0, $d3c503b2accd0037$export$2e2bcd8739ae039), {
                                    disabled: $8cab7f86901e71c6$var$disableByObj(obj)
                                });
                            }
                        },
                        {
                            title: 'Status',
                            dataIndex: 'status',
                            key: 'status'
                        },
                        {
                            title: 'Actions',
                            dataIndex: '',
                            key: 'id',
                            align: 'center',
                            width: 200,
                            render: (obj)=>{
                                const disabled = $8cab7f86901e71c6$var$disableByObj(obj);
                                return (0, $bb3TF.jsxs)("div", {
                                    className: $3d1ddce0415a8ac4$export$cb6c30b631422a13,
                                    children: [
                                        (0, $bb3TF.jsx)((0, $92b07c154bbb4d14$export$2e2bcd8739ae039), {
                                            tooltip: "Update Progress Status ",
                                            onClick: ()=>setUpdate(obj),
                                            children: (0, $bb3TF.jsx)($8cab7f86901e71c6$var$EditOutlined, {})
                                        }),
                                        (0, $bb3TF.jsx)((0, $92b07c154bbb4d14$export$2e2bcd8739ae039), {
                                            tooltip: disabled ? 'Default statuses cannot be deleted' : 'Delete Progress Status',
                                            confirmAction: true,
                                            confirmLabel: "Are you sure?",
                                            onClick: ()=>handleRemoveProgress(obj.id),
                                            buttonProps: {
                                                danger: true,
                                                disabled: disabled
                                            },
                                            children: (0, $bb3TF.jsx)($8cab7f86901e71c6$var$DeleteOutlined, {})
                                        })
                                    ]
                                });
                            }
                        }
                    ],
                    dataSource: statuses,
                    scroll: {
                        x: 'max-content'
                    },
                    sticky: true,
                    bordered: true,
                    components: {
                        body: {
                            wrapper: (props)=>(0, $bb3TF.jsx)((0, $84d5a6213c4669b2$export$2e2bcd8739ae039), {
                                    onSortEnd: onSortEnd,
                                    ...props
                                }),
                            row: DraggableBodyRow
                        }
                    }
                }),
                (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    size: "large",
                    type: "primary",
                    onClick: ()=>setIsModalVisible(true),
                    disabled: loadingCreate || loadingUpdate || loadingDelete,
                    children: "Add Progress Status"
                }),
                (0, $bb3TF.jsxs)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
                    title: updateStatusId ? 'Update Status' : 'Add Status',
                    visible: isModalVisible,
                    onOk: handleOk,
                    onCancel: handleCancel,
                    children: [
                        (0, $bb3TF.jsx)("p", {
                            children: "Label:"
                        }),
                        (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                            value: status,
                            onChange: (e)=>setStatus(e.target.value)
                        })
                    ]
                })
            ]
        })
    });
};
var $8cab7f86901e71c6$export$2e2bcd8739ae039 = $8cab7f86901e71c6$var$ProgressStatuses;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");












const { Paragraph: $3930d3e236d3c92e$var$Paragraph, Text: $3930d3e236d3c92e$var$Text, Title: $3930d3e236d3c92e$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $3930d3e236d3c92e$export$a919ba8a22173709 = (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
    children: [
        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            className: $d2f51651a502d078$export$af5e71fe29d96ba7,
            children: "Chat only plan"
        }),
        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            style: {
                fontSize: '14px'
            },
            children: "Basic plan but only chat available"
        }),
        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            className: $d2f51651a502d078$export$fadbecb2c2f910ef,
            children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                className: $d2f51651a502d078$export$8cc0924721e82658,
                align: "middle",
                children: [
                    (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                        className: $d2f51651a502d078$export$96427d1536b00cf2
                    }),
                    "Available from your firm dashboard"
                ]
            })
        })
    ]
});
const $3930d3e236d3c92e$export$e66a5e5cc4df4ffa = (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
    children: [
        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            className: $d2f51651a502d078$export$af5e71fe29d96ba7,
            children: "Basic plan"
        }),
        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            style: {
                fontSize: '14px'
            },
            children: "The Starter Boost"
        }),
        (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            className: $d2f51651a502d078$export$fadbecb2c2f910ef,
            children: [
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$8cc0924721e82658,
                    align: "middle",
                    children: [
                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                            className: $d2f51651a502d078$export$96427d1536b00cf2
                        }),
                        "Limited to 1 hour session per day"
                    ]
                }),
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$8cc0924721e82658,
                    align: "middle",
                    children: [
                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                            className: $d2f51651a502d078$export$96427d1536b00cf2
                        }),
                        "Available from your firm dashboard"
                    ]
                })
            ]
        })
    ]
});
const $3930d3e236d3c92e$export$7a3344395b0da385 = (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
    children: [
        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            className: [
                $d2f51651a502d078$export$af5e71fe29d96ba7,
                $d2f51651a502d078$export$256e8e2c5d45fb6b
            ],
            children: "Premium plan"
        }),
        (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            style: {
                fontSize: '14px'
            },
            children: "All-Inclusive Excellence"
        }),
        (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            className: $d2f51651a502d078$export$fadbecb2c2f910ef,
            children: [
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$8cc0924721e82658,
                    align: "middle",
                    children: [
                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                            className: $d2f51651a502d078$export$e49b69e2917041e0
                        }),
                        "Limited to 2 hour session per day"
                    ]
                }),
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$8cc0924721e82658,
                    align: "middle",
                    children: [
                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                            className: $d2f51651a502d078$export$e49b69e2917041e0
                        }),
                        "Available from your firm dashboard"
                    ]
                }),
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    className: $d2f51651a502d078$export$8cc0924721e82658,
                    align: "middle",
                    children: [
                        (0, $bb3TF.jsx)((0, $6b2f9db68b803801$export$2e2bcd8739ae039), {
                            className: $d2f51651a502d078$export$e49b69e2917041e0
                        }),
                        "Available from your client portal"
                    ]
                })
            ]
        })
    ]
});
const $3930d3e236d3c92e$var$Ai = ()=>{
    const { firmAccountId: firmAccountId } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const [enableClientBot, setEnableClientBot] = (0, $6fFrj.useState)(false);
    const [plan, setPlan] = (0, $6fFrj.useState)();
    const [enableClientAiBotSetting, setEnableClientAiBotSetting] = (0, $6fFrj.useState)(null);
    const [createAiAgentMessage] = (0, $4cdb1470f9874f96$export$cb4c7b6a946a397c)({
        refetchQueries: [
            (0, $f442d9dc730cd5f3$export$ad65fcc6f7468098)
        ],
        awaitRefetchQueries: true,
        onError: (err)=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message)
    });
    const handleOnError = (error)=>{
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`An error has occurred: ${error.message}.`);
    };
    const { data: aiSettingsData, loading: aiSettingsLoading, error: aiSettingsError } = (0, $732264f53056e08f$export$9fced88514778fe9)({
        variables: {
            category: 'FIRM_AI_SETTINGS'
        },
        skip: !firmAccountId
    });
    const { data: firmAccountPremiumAddOn } = (0, $141d022d397c6782$export$a63090a6696b4950)({
        variables: {
            name: 'taxaroo-ai-premium-plan'
        }
    });
    const [createFirmSetting, { loading: createFirmSettingLoading }] = (0, $33beb5b1bfae180c$export$1ff58c91a8b6e9e1)({
        onError: handleOnError,
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$d16c1a94a02eda7f),
                variables: {
                    category: 'FIRM_AI_SETTINGS'
                }
            }
        ],
        awaitRefetchQueries: true
    });
    const [updateFirmSetting, { loading: updateFirmSettingLoading }] = (0, $33beb5b1bfae180c$export$1a4761718d2c597b)({
        onError: handleOnError,
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$d16c1a94a02eda7f),
                variables: {
                    category: 'FIRM_AI_SETTINGS'
                }
            }
        ],
        awaitRefetchQueries: true
    });
    (0, $6fFrj.useEffect)(()=>{
        if (aiSettingsData?.getFirmSettings) {
            const myEnableClientAiBotSetting = aiSettingsData.getFirmSettings.find((setting)=>setting.name === 'enable-client-ai-bot');
            setEnableClientAiBotSetting(myEnableClientAiBotSetting);
            // todo
            setEnableClientBot(// eslint-disable-next-line no-underscore-dangle
            myEnableClientAiBotSetting?.value.__typename === 'BooleanValue' ? myEnableClientAiBotSetting.value.boolValue : false);
        }
    }, [
        aiSettingsData?.getFirmSettings
    ]);
    (0, $6fFrj.useEffect)(()=>{
        if (aiSettingsError) return handleOnError(aiSettingsError);
        return null;
    }, [
        aiSettingsError
    ]);
    const changeEnableAiInClientPortal = async (val)=>{
        setEnableClientBot(val);
        try {
            if (enableClientAiBotSetting?.id) await updateFirmSetting({
                variables: {
                    id: enableClientAiBotSetting.id,
                    value: String(val)
                }
            });
            else await createFirmSetting({
                variables: {
                    name: 'enable-client-ai-bot',
                    value: String(val)
                }
            });
        } catch (error) {
            setEnableClientBot(!val);
        }
    };
    const subscriptionCreated = async (newPlan)=>{
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).success(`Subscription created for ${newPlan} plan`);
        await createAiAgentMessage({
            variables: {
                createAiAgentMessageInput: {
                    type: (0, $8f7fe33a44836803$export$614f97abc1364581).System,
                    text: `Welcome back! '${newPlan}' plan unlocked`
                }
            }
        });
        // reload the page, todo: fix this
        setTimeout(()=>{
            window.location.reload();
        }, 1500);
    };
    return (0, $bb3TF.jsxs)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
        style: {
            backgroundColor: 'white'
        },
        children: [
            (0, $bb3TF.jsx)((0, $58c1491b566e843c$export$2e2bcd8739ae039), {
                title: "AI Settings",
                tooltipTitle: "AI Settings",
                tooltipContent: (0, $bb3TF.jsx)($3930d3e236d3c92e$var$Paragraph, {
                    children: (0, $bb3TF.jsx)($3930d3e236d3c92e$var$Text, {
                        children: "Customize your AI settings"
                    })
                })
            }),
            (0, $bb3TF.jsxs)("div", {
                style: {
                    paddingTop: '20px',
                    marginBottom: '125px'
                },
                children: [
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        style: {
                            width: '100%'
                        },
                        children: [
                            (0, $bb3TF.jsx)($3930d3e236d3c92e$var$Title, {
                                level: 5,
                                children: "Enable AI Assistant in your client portal?"
                            }),
                            (0, $bb3TF.jsx)($3930d3e236d3c92e$var$Text, {
                                style: {
                                    backgroundImage: 'linear-gradient(to right, #0057A5, #0A8CED)',
                                    color: 'transparent',
                                    backgroundClip: 'text',
                                    marginLeft: '8px',
                                    lineHeight: '14px',
                                    textAlign: 'center',
                                    fontWeight: 'bold'
                                },
                                children: "(Coming Soon)"
                            })
                        ]
                    }),
                    aiSettingsLoading && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        align: "middle",
                        justify: "center",
                        children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                            size: "large"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        gutter: 15,
                        align: "middle",
                        children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsx)((0, $4fd303306a27e42e$export$2e2bcd8739ae039), {
                                onChange: (val)=>changeEnableAiInClientPortal(val),
                                checked: enableClientBot,
                                loading: updateFirmSettingLoading || createFirmSettingLoading,
                                disabled: !firmAccountPremiumAddOn?.firmAccountAddOnByName?.id || firmAccountPremiumAddOn?.firmAccountAddOnByName?.subscriptionStatus !== (0, $8f7fe33a44836803$export$a19dca1ceabeb485).Active
                            })
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        style: {
                            marginTop: '25px'
                        },
                        children: (0, $bb3TF.jsx)((0, $a200d37e26ccfc3d$export$2e2bcd8739ae039), {
                            subscriptionCreated: ()=>subscriptionCreated(plan),
                            subscriptionCancelled: ()=>{
                                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Subscription cancelled');
                            },
                            plan: plan,
                            setPlan: setPlan
                        })
                    })
                ]
            })
        ]
    });
};
var $3930d3e236d3c92e$export$2e2bcd8739ae039 = $3930d3e236d3c92e$var$Ai;


var $f16624e82228af20$export$2e2bcd8739ae039 = (0, $3930d3e236d3c92e$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");







var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");

const { PlusOutlined: $e35118da10516dbb$var$PlusOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $e35118da10516dbb$var$NoTeamMembers = ({ onClick: onClick })=>(0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
        justify: "center",
        style: {
            marginTop: 25
        },
        children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
            type: "primary",
            shape: "round",
            icon: (0, $bb3TF.jsx)($e35118da10516dbb$var$PlusOutlined, {}),
            iconDirection: "left",
            onClick: onClick,
            children: "Add your first team member"
        })
    });
var $e35118da10516dbb$export$2e2bcd8739ae039 = $e35118da10516dbb$var$NoTeamMembers;





var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");





var $bb3TF = parcelRequire("bb3TF");

var $ed79b10f4e35ac88$export$1b7c4387d8e09bda;
var $ed79b10f4e35ac88$export$7246d22ab0922ede;
$ed79b10f4e35ac88$export$1b7c4387d8e09bda = `iY_ioW_featuresList`;
$ed79b10f4e35ac88$export$7246d22ab0922ede = `iY_ioW_radioGroup`;


const { TextArea: $83416fd2de442fe8$var$TextArea } = (0, $1fb834916a156dcf$export$2e2bcd8739ae039);
const { Item: $83416fd2de442fe8$var$Item } = (0, $6ee812964d9db826$export$2e2bcd8739ae039);
const $83416fd2de442fe8$export$1717af9f6ef1c6b8 = ({ form: form })=>(0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
        form: form,
        style: {
            width: '100%'
        },
        layout: "vertical",
        name: "cancelSubscriptionForm",
        children: [
            (0, $bb3TF.jsx)($83416fd2de442fe8$var$Item, {
                name: "reasonSelection",
                label: "Please select a reason",
                rules: [
                    {
                        required: true,
                        message: 'Please select a reason'
                    }
                ],
                children: (0, $bb3TF.jsxs)((0, $d2c10fe172769914$export$2e2bcd8739ae039).Group, {
                    className: $ed79b10f4e35ac88$export$7246d22ab0922ede,
                    children: [
                        (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039), {
                            value: "too_complex",
                            children: "Ease of use was less than expected"
                        }),
                        (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039), {
                            value: "switched_service",
                            children: "I found an alternative (please describe which and why)"
                        }),
                        (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039), {
                            value: "too_expensive",
                            children: "It is too expensive (please describe your budget)"
                        }),
                        (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039), {
                            value: "unused",
                            children: "It is no longer tax season"
                        }),
                        (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039), {
                            value: "missing_features",
                            children: "I need more features (please describe which and why)"
                        }),
                        (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039), {
                            value: "customer_service",
                            children: "Customer service was less than expected (please describe)"
                        }),
                        (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039), {
                            value: "low_quality",
                            children: "Quality was less than expected (please describe what went wrong)"
                        }),
                        (0, $bb3TF.jsx)((0, $d2c10fe172769914$export$2e2bcd8739ae039), {
                            value: "other",
                            children: "Other reason (please describe)"
                        })
                    ]
                })
            }),
            (0, $bb3TF.jsx)($83416fd2de442fe8$var$Item, {
                name: "reason",
                label: "Please describe",
                rules: [
                    {
                        required: true,
                        message: 'Please describe'
                    }
                ],
                children: (0, $bb3TF.jsx)($83416fd2de442fe8$var$TextArea, {
                    placeholder: "Taxaroo is always looking to improve. Please let us know why you are canceling your subscription."
                })
            })
        ]
    });



var $bb3TF = parcelRequire("bb3TF");


const { Title: $ea9b9c047d9f6e1b$var$Title, Paragraph: $ea9b9c047d9f6e1b$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { TagOutlined: $ea9b9c047d9f6e1b$var$TagOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $ea9b9c047d9f6e1b$var$OfferCard = ({ offerName: offerName, saveAmount: saveAmount, body: body, handleRedeemOffer: handleRedeemOffer, loading: loading, buttonText: buttonText, featuresTitle: featuresTitle, featuresColumn1: featuresColumn1, featuresColumn2: featuresColumn2, bottomBullets: bottomBullets })=>(0, $bb3TF.jsx)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
        title: (0, $bb3TF.jsx)($ea9b9c047d9f6e1b$var$Title, {
            level: 3,
            style: {
                margin: 0,
                color: 'white',
                textWrap: 'wrap'
            },
            children: offerName
        }),
        style: {
            marginBottom: '20px',
            background: 'var(--primary-color)'
        },
        children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            style: {
                marginTop: -30
            },
            children: [
                saveAmount > 0 && (0, $bb3TF.jsx)((0, $3c2758025c182ca4$export$2e2bcd8739ae039), {
                    icon: (0, $bb3TF.jsx)($ea9b9c047d9f6e1b$var$TagOutlined, {}),
                    color: "var(--primary-dark)",
                    children: `Save $${saveAmount.toFixed(2)} per year`
                }),
                (0, $bb3TF.jsx)($ea9b9c047d9f6e1b$var$Paragraph, {
                    style: {
                        color: 'white',
                        marginTop: 15,
                        marginBottom: -10
                    },
                    children: body
                }),
                featuresTitle && (0, $bb3TF.jsx)($ea9b9c047d9f6e1b$var$Title, {
                    level: 4,
                    style: {
                        color: 'white'
                    },
                    children: featuresTitle
                }),
                (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    gutter: 24,
                    style: {
                        width: '100%',
                        fontSize: 18
                    },
                    children: [
                        featuresColumn1 && (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            sm: 24,
                            md: 24,
                            lg: 12,
                            xl: 12,
                            children: (0, $bb3TF.jsx)("ul", {
                                className: $ed79b10f4e35ac88$export$1b7c4387d8e09bda,
                                style: {
                                    marginBottom: 0,
                                    listStyle: 'outside'
                                },
                                children: featuresColumn1.map((feature)=>(0, $bb3TF.jsx)("li", {
                                        children: feature
                                    }, feature))
                            })
                        }),
                        featuresColumn2 && (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                            sm: 24,
                            md: 24,
                            lg: 12,
                            xl: 12,
                            children: (0, $bb3TF.jsx)("ul", {
                                className: $ed79b10f4e35ac88$export$1b7c4387d8e09bda,
                                style: {
                                    listStyle: 'outside'
                                },
                                children: featuresColumn2.map((feature)=>(0, $bb3TF.jsx)("li", {
                                        children: feature
                                    }, feature))
                            })
                        })
                    ]
                }),
                bottomBullets && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    style: {
                        width: '100%',
                        fontSize: 18,
                        marginTop: -18
                    },
                    children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        children: (0, $bb3TF.jsx)("ul", {
                            className: $ed79b10f4e35ac88$export$1b7c4387d8e09bda,
                            style: {
                                listStyle: 'outside'
                            },
                            children: bottomBullets.map((feature)=>(0, $bb3TF.jsx)("li", {
                                    children: feature
                                }, feature))
                        })
                    })
                }),
                (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    type: "default",
                    style: {
                        marginTop: '10px',
                        width: '100%'
                    },
                    size: "large",
                    onClick: handleRedeemOffer,
                    loading: loading,
                    children: buttonText
                })
            ]
        })
    });
$ea9b9c047d9f6e1b$var$OfferCard.defaultProps = {
    saveAmount: 0,
    featuresTitle: '',
    featuresColumn1: [],
    featuresColumn2: [],
    bottomBullets: []
};
var $ea9b9c047d9f6e1b$export$2e2bcd8739ae039 = $ea9b9c047d9f6e1b$var$OfferCard;


const { Title: $40a78cc88cda8de1$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $40a78cc88cda8de1$var$CancelSubscriptionModal = ({ isModalVisible: isModalVisible, setIsModalVisible: setIsModalVisible, subscription: subscription })=>{
    const [saveAmount, setSaveAmount] = (0, $6fFrj.useState)(0);
    const [newAmount, setNewAmount] = (0, $6fFrj.useState)(0);
    const [step, setStep] = (0, $6fFrj.useState)(1); // 1 = collect reason, 2 = downsell offer, 3 = lite plan, // 4 = free plan, otherwise cancel subscritpion
    const paused = !!subscription?.pause_collection?.behavior || subscription?.status === 'paused';
    const subscriptionInterval = subscription?.items?.data[0]?.plan?.interval;
    const [reasonForm] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    // graphql
    // get cancellation price data
    const { data: cancellationPriceData } = (0, $fa3f5c8f35890bd3$export$51bb9b73b250814d)();
    const cancellationPrice = cancellationPriceData?.GetCancellationPrice;
    // update subscription
    const [updateSubscritpion, { loading: loadingUpdateSubscription }] = (0, $33beb5b1bfae180c$export$2533d517ac4b0c7f)();
    // cancel subscription
    const [deleteSubscription, { loading: loadingDeleteSubscription }] = (0, $33beb5b1bfae180c$export$9c57662aa631e6ad)();
    const isOnLitePlan = subscription?.items?.data[0]?.plan?.id === (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeLitePlanPriceId;
    const isOnFreePlan = subscription?.items?.data[0]?.plan?.id === (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeFreePlanPriceId;
    const isOnDownSellOffer = cancellationPrice?.id === subscription?.items?.data[0]?.plan.id;
    const isOnLastStep = step === 3 || step === 2 && isOnLitePlan;
    // saveAmount for the new subscription
    (0, $6fFrj.useEffect)(()=>{
        if (cancellationPrice?.tiers?.length) {
            // find the tier with flat_amount
            const cancellationFlatAmountTier = cancellationPrice.tiers.find((tier)=>tier.flat_amount);
            const currentSubscriptionFlatAmountTier = subscription?.items?.data[0]?.plan?.tiers?.find((tier)=>tier.flat_amount);
            if (cancellationFlatAmountTier?.flat_amount && currentSubscriptionFlatAmountTier?.flat_amount) {
                const newSaveAmount = subscriptionInterval === 'month' ? currentSubscriptionFlatAmountTier.flat_amount * 12 - cancellationFlatAmountTier.flat_amount : currentSubscriptionFlatAmountTier.flat_amount - cancellationFlatAmountTier.flat_amount;
                setSaveAmount(newSaveAmount / 100);
                setNewAmount(cancellationFlatAmountTier.flat_amount / 100);
            }
        }
    }, [
        cancellationPrice,
        subscription
    ]);
    // additional logic for step changes
    (0, $6fFrj.useEffect)(()=>{
        // if already on downsell offer, skip to step 3
        if (step === 2 && isOnDownSellOffer) setStep(3);
    // if already on lite plan, skip to step 4
    // if (step === 3 && isOnLitePlan) {
    //   setStep(4);
    // }
    }, [
        step,
        paused,
        cancellationPrice,
        subscription
    ]);
    const closeModal = ()=>{
        setIsModalVisible(false);
        setStep(1);
        reasonForm.resetFields();
    };
    const handleCancelSubscription = async ()=>{
        // cancel subscription at end of billing period (function also sends emails and triggers zap)
        deleteSubscription({
            variables: {
                subscriptionId: subscription?.id,
                deleteStripeSubscriptionInput: {
                    cancellation_details: {
                        comment: reasonForm.getFieldValue('reason'),
                        feedback: reasonForm.getFieldValue('reasonSelection')
                    }
                }
            },
            refetchQueries: [
                'GetSubscription',
                'GetPlanAccessLevel'
            ],
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Subscription canceled.');
                closeModal();
            },
            onError: (error)=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
            }
        });
    };
    const handleSwitchToPlan = (priceId, quantity)=>{
        updateSubscritpion({
            variables: {
                resume: paused ? true : undefined,
                updateStripeSubscriptionInput: {
                    items: [
                        {
                            id: subscription?.items?.data[0]?.id,
                            price: priceId,
                            quantity: quantity
                        }
                    ]
                }
            },
            refetchQueries: [
                'GetSubscription',
                'GetPlanAccessLevel'
            ],
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Subscription updated!');
                closeModal();
            },
            onError: (error)=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
            }
        });
    };
    // const handlePauseSubscription = async () => {
    //   await updateSubscritpion({
    //     variables: {
    //       updateStripeSubscriptionInput: {
    //         pause_collection: {
    //           behavior: 'void',
    //           resumes_at: resumesAt.getTime() / 1000,
    //         },
    //       },
    //     },
    //     refetchQueries: ['GetSubscription'],
    //     onCompleted: () => {
    //       message.success('Subscription paused.');
    //       closeModal();
    //     },
    //   });
    // };
    const continueToNextStep = ()=>{
        if (step === 1) // validate form
        reasonForm.validateFields().then(()=>{
            setStep((prev)=>prev + 1);
        });
        else setStep((prev)=>prev + 1);
    };
    const handleBack = ()=>{
        setStep((prev)=>prev - 1);
    };
    return (0, $bb3TF.jsxs)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        title: "Cancel Your Plan",
        visible: isModalVisible,
        centered: true,
        style: {
            top: 15,
            marginBottom: 100
        },
        destroyOnClose: true,
        onCancel: closeModal,
        width: 800,
        footer: [
            (0, $bb3TF.jsxs)("div", {
                style: {
                    display: 'flex',
                    justifyContent: step === 1 ? 'flex-end' : 'space-between',
                    width: '100%'
                },
                children: [
                    step > 1 && (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        onClick: handleBack,
                        children: "Back"
                    }, "back"),
                    (0, $bb3TF.jsxs)("div", {
                        children: [
                            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                onClick: closeModal,
                                style: {
                                    marginRight: '8px'
                                },
                                children: "Cancel"
                            }, "Cancel"),
                            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                type: "primary",
                                onClick: isOnLastStep ? ()=>handleCancelSubscription() : ()=>continueToNextStep(),
                                danger: isOnLastStep,
                                loading: loadingDeleteSubscription,
                                children: isOnLastStep ? 'No, Delete my data' : 'Next'
                            }, "next")
                        ]
                    })
                ]
            })
        ],
        children: [
            (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                message: "Are you sure you want to cancel your subscription?",
                description: "You will lose access to your account after your current billing cycle ends.",
                type: "warning",
                showIcon: true,
                style: {
                    marginBottom: '20px'
                }
            }),
            (0, $bb3TF.jsx)($40a78cc88cda8de1$var$Title, {
                level: 4,
                children: "Before you go..."
            }),
            step === 1 && (0, $bb3TF.jsx)((0, $83416fd2de442fe8$export$1717af9f6ef1c6b8), {
                form: reasonForm
            }),
            step === 2 && (0, $bb3TF.jsx)((0, $ea9b9c047d9f6e1b$export$2e2bcd8739ae039), {
                offerName: cancellationPrice?.nickname,
                saveAmount: saveAmount,
                body: `By clicking redeem discount you agree to pay $${newAmount.toFixed(2)} per year. You can still cancel at any time.`,
                handleRedeemOffer: ()=>handleSwitchToPlan(cancellationPrice?.id, 2),
                loading: loadingUpdateSubscription,
                buttonText: "Redeem Discount"
            }),
            step === 3 && (0, $bb3TF.jsx)((0, $ea9b9c047d9f6e1b$export$2e2bcd8739ae039), {
                offerName: "Or, would you like to try our Lite Plan",
                body: "One team member with limited features for only $395 per year. You can still cancel at any time.",
                handleRedeemOffer: ()=>handleSwitchToPlan((0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeLitePlanPriceId, 1),
                loading: loadingUpdateSubscription,
                buttonText: "Choose Lite Plan",
                featuresTitle: "Includes:",
                featuresColumn1: [
                    'Interviews',
                    'Document uploads',
                    'Messaging',
                    'White Labeling',
                    'Appointments',
                    'Video Calls'
                ],
                featuresColumn2: [
                    'Analytics',
                    'Spanish Workflows',
                    'Referral Program',
                    'Invoicing',
                    'Pixels',
                    'Birthday Emails'
                ]
            }),
            step === 4 && (0, $bb3TF.jsx)((0, $ea9b9c047d9f6e1b$export$2e2bcd8739ae039), {
                offerName: "How about using our Free Plan?",
                body: "By clicking Downgrade to Free Plan you will be moved to our free plan which includes these basic features.",
                handleRedeemOffer: ()=>handleSwitchToPlan((0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeFreePlanPriceId, 1),
                loading: loadingUpdateSubscription,
                buttonText: "Downgrade to Free Plan",
                featuresTitle: "Includes:",
                featuresColumn1: [
                    'Interviews',
                    'Document uploads',
                    'Messaging',
                    'White Labeling'
                ],
                featuresColumn2: [
                    'Analytics',
                    'Spanish Workflows',
                    'Referral Program',
                    'Invoicing ($10 processing fee)'
                ],
                bottomBullets: [
                    'Get a revenue share for all products sold to your customers'
                ]
            })
        ]
    });
};
var $40a78cc88cda8de1$export$2e2bcd8739ae039 = $40a78cc88cda8de1$var$CancelSubscriptionModal;




var $bab24f83ab824dd9$export$b6fb1741c7f64881;
$bab24f83ab824dd9$export$b6fb1741c7f64881 = `onaijq_actionButtons`;




var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");



var $ipnkk = parcelRequire("ipnkk");


var $6Sgv0 = parcelRequire("6Sgv0");
const { Item: $b3418ead49d42b22$var$Item } = (0, $6ee812964d9db826$export$2e2bcd8739ae039);
const { Option: $b3418ead49d42b22$var$Option } = (0, $f7b06a01f57032f1$export$2e2bcd8739ae039);
const $b3418ead49d42b22$var$isBirthdayValid = (date)=>{
    console.log(`isBirthdayValid - date: ${JSON.stringify(date)}`);
    if (!date) return false;
    const max = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))();
    const min = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))('1900-01-01', 'YYYY-MM-DD');
    const current = (0, (/*@__PURE__*/$parcel$interopDefault($6Sgv0)))(date);
    const isValid = current.isAfter(min) && current.isBefore(max);
    console.log(`isValid: ${isValid}`);
    return isValid;
};
const $b3418ead49d42b22$var$ManageTeamModal = ({ showModal: showModal, onAddMemberTeam: onAddMemberTeam, roles: roles, setModal: setModal, firmAccountId: firmAccountId, languageId: languageId })=>{
    const [addMemberToFirmMutation, { loading: loading }] = (0, $33beb5b1bfae180c$export$4cbc8f1dda0b22be)();
    const [isNotCompanyEmail, setIsNotCompanyEmail] = (0, $6fFrj.useState)(false);
    const formik = (0, $ipnkk.useFormik)({
        validationSchema: $ee6ba11cc5736d52$export$185802fd694ee1f5().shape({
            email: $2746dd37f1d91ea1$export$185802fd694ee1f5().email().required('Email is required'),
            firstName: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('First name is required'),
            lastName: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('Last name is required'),
            birthday: $b2e6c69aab0808b6$export$185802fd694ee1f5().required('Date of birth is required').test('is-birthday-valid', 'Birthday is not valid', $b3418ead49d42b22$var$isBirthdayValid),
            roleId: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('Role is required')
        }),
        initialValues: {
            email: '',
            firstName: '',
            lastName: '',
            birthday: undefined,
            roleId: ''
        },
        onSubmit: async ({ firstName: firstName, lastName: lastName, email: email, roleId: roleId, birthday: birthday })=>{
            try {
                const res = await addMemberToFirmMutation({
                    variables: {
                        firmAccountId: firmAccountId,
                        memberAddInput: {
                            email: email,
                            roleId: roleId,
                            birthday: birthday,
                            lastName: lastName,
                            firstName: firstName,
                            languageId: languageId
                        }
                    }
                });
                const membersArr = res?.data?.addMemberToFirm;
                const newMember = membersArr[membersArr.length - 1];
                onAddMemberTeam(newMember);
                setModal(false);
                formik.resetForm();
            } catch (err) {
                if (err.message === 'Error code 2004') {
                    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Your account reached the maximum number of members');
                    setModal(false);
                } else if (err.message === 'Error code 1014') {
                    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('This email is already used for another account. Please use a different email to add as a team member.');
                    setModal(false);
                } else if (err.message === 'Error code 1011') {
                    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('You do not have permission to delete this user');
                    setModal(false);
                } else {
                    (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message || 'Could Not Add Member Team');
                    setModal(false);
                }
            }
        }
    });
    const { touched: touched, values: values, errors: errors, handleSubmit: handleSubmit, handleChange: handleChange, resetForm: resetForm } = formik;
    const checkIsCompanyEmail = (e)=>{
        const pattern = /@(gmail\.com|live\.com|comcast\.com|outlook\.com|icloud\.com|aol\.com|hotmail\.com|yahoo\..*)$/;
        setIsNotCompanyEmail(pattern.test(e));
    };
    const getEmailInputValidateStatus = ()=>{
        if (isNotCompanyEmail) return 'warning';
        if (touched.email && errors.email) return 'error';
        return 'success';
    };
    const getEmailInputHelpText = ()=>{
        if (isNotCompanyEmail) return 'Using emails from Google, Yahoo, Aol, etc. will cause emails to go out from @taxaroo.com (instead of your custom domain). Consider using company emails instead.';
        if (touched.email && errors.email) return (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
            message: errors.email,
            type: "error"
        });
        return null;
    };
    return (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
        title: "Add New Team Member",
        centered: true,
        visible: showModal,
        onCancel: ()=>{
            setModal(false);
            resetForm();
        },
        onOk: ()=>formik.submitForm(),
        okText: "Add Member",
        confirmLoading: loading,
        children: (0, $bb3TF.jsx)((0, $ipnkk.FormikProvider), {
            value: formik,
            children: (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                layout: "vertical",
                name: "basic",
                onFinish: handleSubmit,
                children: [
                    (0, $bb3TF.jsx)($b3418ead49d42b22$var$Item, {
                        label: "Email",
                        validateStatus: getEmailInputValidateStatus(),
                        help: getEmailInputHelpText(),
                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                            name: "email",
                            onChange: handleChange,
                            value: values.email,
                            disabled: loading,
                            placeholder: "Email",
                            onBlur: ()=>{
                                checkIsCompanyEmail(values.email);
                            }
                        })
                    }),
                    (0, $bb3TF.jsx)($b3418ead49d42b22$var$Item, {
                        label: "First Name",
                        validateStatus: touched.firstName && errors.firstName ? 'error' : 'success',
                        help: touched.firstName && errors.firstName && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            message: errors.firstName,
                            type: "error"
                        }),
                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                            name: "firstName",
                            onChange: handleChange,
                            value: values.firstName,
                            disabled: loading,
                            placeholder: "First Name"
                        })
                    }),
                    (0, $bb3TF.jsx)($b3418ead49d42b22$var$Item, {
                        label: "Last Name",
                        validateStatus: touched.lastName && errors.lastName ? 'error' : 'success',
                        help: touched.lastName && errors.lastName && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            message: errors.lastName,
                            type: "error"
                        }),
                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                            name: "lastName",
                            onChange: handleChange,
                            value: values.lastName,
                            disabled: loading,
                            placeholder: "Last Name"
                        })
                    }),
                    (0, $bb3TF.jsx)($b3418ead49d42b22$var$Item, {
                        label: "Date of Birth",
                        help: touched.birthday && errors.birthday && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            message: errors.birthday,
                            type: "error"
                        }),
                        children: (0, $bb3TF.jsx)((0, $dd1293f125eb7a8a$export$2e2bcd8739ae039), {
                            disabled: loading,
                            value: values.birthday,
                            onChange: (value)=>{
                                formik.setFieldValue('birthday', value);
                            },
                            placeholder: "MM/DD/YYYY",
                            format: "MM/DD/YYYY",
                            style: {
                                width: '100%'
                            }
                        })
                    }),
                    (0, $bb3TF.jsx)($b3418ead49d42b22$var$Item, {
                        label: "Account Role",
                        validateStatus: touched.roleId && errors.roleId ? 'error' : 'success',
                        help: touched.roleId && errors.roleId && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                            message: errors.roleId,
                            type: "error"
                        }),
                        children: roles.length > 0 && (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
                            style: {
                                width: '100%',
                                display: 'flex'
                            },
                            onChange: handleChange('roleId'),
                            value: values.roleId,
                            dropdownStyle: {
                                zIndex: 9999
                            },
                            disabled: loading,
                            children: roles.map((role)=>(0, $bb3TF.jsx)($b3418ead49d42b22$var$Option, {
                                    value: role.id,
                                    children: role.description === 'TAX_PREPARER' ? 'Admin' : 'Staff'
                                }, role.id))
                        })
                    })
                ]
            })
        })
    });
};
var $b3418ead49d42b22$export$2e2bcd8739ae039 = $b3418ead49d42b22$var$ManageTeamModal;



var $bb3TF = parcelRequire("bb3TF");

var $43575de0979f245e$export$75c7eceb341d4699;
$43575de0979f245e$export$75c7eceb341d4699 = `_9mxrKG_manageTeamRoleSelect`;


const $ff3ede909c5885de$var$ManageTeamRoleSelect = ({ accountRole: accountRole, firm: firm, updateMember: updateMember, preparerDetailId: preparerDetailId })=>(0, $bb3TF.jsx)("div", {
        children: (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039), {
            defaultValue: accountRole === 'TAX_PREPARER' ? 'Admin' : 'Staff',
            className: $43575de0979f245e$export$75c7eceb341d4699,
            onChange: (value)=>updateMember(preparerDetailId, value),
            children: firm.map((role)=>{
                if (!role.description.includes('owner')) return (0, $bb3TF.jsx)((0, $f7b06a01f57032f1$export$2e2bcd8739ae039).Option, {
                    value: role.id,
                    children: role.description === 'TAX_PREPARER' ? 'Admin' : 'Staff'
                }, role.id);
                return null;
            })
        })
    });
var $ff3ede909c5885de$export$2e2bcd8739ae039 = $ff3ede909c5885de$var$ManageTeamRoleSelect;



const { Text: $e5a06dc61e83803b$var$Text, Paragraph: $e5a06dc61e83803b$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { PlusOutlined: $e5a06dc61e83803b$var$PlusOutlined, SyncOutlined: $e5a06dc61e83803b$var$SyncOutlined, SaveOutlined: $e5a06dc61e83803b$var$SaveOutlined, DeleteOutlined: $e5a06dc61e83803b$var$DeleteOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $e5a06dc61e83803b$var$ManageTeam = ()=>{
    const schema = $ee6ba11cc5736d52$export$185802fd694ee1f5().shape({
        email: $2746dd37f1d91ea1$export$185802fd694ee1f5().email('Please enter a valid email address').required('Please enter your email')
    });
    const { firmAccountId: firmAccountId, languageId: languageId } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const [members, setMembers] = (0, $6fFrj.useState)([]);
    const [roles, setRoles] = (0, $6fFrj.useState)([]);
    const [modal, setModal] = (0, $6fFrj.useState)(false);
    const [updatePlanModalVisible, setUpdatePlanModalVisible] = (0, $6fFrj.useState)(false);
    const [overPaying, setOverPaying] = (0, $6fFrj.useState)(false);
    const [cancelPlanModalVisible, setCancelPlanModalVisible] = (0, $6fFrj.useState)(false);
    const [emailErrorIds, setEmailErrorIds] = (0, $6fFrj.useState)({});
    const { showModal: showModal, accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    // graphql
    // Get customerId
    const { data: currentStripeInformation, loading: loadingCustomer } = (0, $732264f53056e08f$export$9f382c5aef9c5d4d)();
    const { customerId: customerId } = currentStripeInformation?.CurrentStripeInformation ?? {};
    // Get subscription info query
    const { data: subscriptionData, loading: loadingSubscription } = (0, $732264f53056e08f$export$a95e19dd5dcb47c4)();
    // Create billing portal session mutation
    const [createBillingPortalSession] = (0, $99ead93e2ec80d4e$export$1940481f2be3ddf2)({
        onError: (err)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message);
        }
    });
    // get team members
    const { data: customUserFirmAccount, loading: loadingUserFirmAccount } = (0, $732264f53056e08f$export$deb804dbb627e21)({
        variables: {
            firmAccountId: firmAccountId,
            filterDelete: false
        }
    });
    // get role types
    const { data: customAllRoles, loading: loadingCustomAllRoles } = (0, $732264f53056e08f$export$df99cc263e9b1304)();
    // update subscription
    const [updateSubscritpion, { loading: loadingUpdateSubscription }] = (0, $33beb5b1bfae180c$export$2533d517ac4b0c7f)();
    // create subscription
    const [createSubscritpion, { loading: loadingCreateSubscription }] = (0, $33beb5b1bfae180c$export$cad47f76ff30cf27)();
    // set members
    (0, $6fFrj.useEffect)(()=>{
        if (customUserFirmAccount && customUserFirmAccount.UserFirmAccountByFirmAccountAndFilter.length > 0) setMembers(customUserFirmAccount.UserFirmAccountByFirmAccountAndFilter);
    }, [
        customUserFirmAccount
    ]);
    // set roles
    (0, $6fFrj.useEffect)(()=>{
        if (customAllRoles && customAllRoles.Roles) {
            const filteredRoles = customAllRoles.Roles.filter((item)=>item.description === 'TAX_PREPARER' || item.description === 'STAFF');
            setRoles(filteredRoles);
        }
    }, [
        customAllRoles
    ]);
    // if paying for more seats than you have, notify user
    (0, $6fFrj.useEffect)(()=>{
        if (members && subscriptionData?.GetSubscriptionByContext?.quantity) {
            const activeMembers = members.filter((member)=>!member.Users.deleteAt);
            if (subscriptionData?.GetSubscriptionByContext?.quantity > activeMembers.length && subscriptionData?.GetSubscriptionByContext?.quantity > 2) setOverPaying(true);
            else setOverPaying(false);
        }
    }, [
        members,
        subscriptionData?.GetSubscriptionByContext?.quantity
    ]);
    // Query to check if it's possible to add a new member
    const [checkCanAddTeamMember] = (0, $33beb5b1bfae180c$export$80cc0b112578fdd6)({
        variables: {
            firmAccountId: firmAccountId
        },
        fetchPolicy: 'no-cache',
        onCompleted: ()=>{
            setModal(true);
            (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).MODAL_SHOW, {
                'Modal Title': 'Add new team member',
                Source: 'Click on button',
                url: window.location.href
            });
        },
        onError: (error)=>{
            const graphqlError = error.graphQLErrors[0];
            const text = graphqlError?.message;
            if (text === 'Error code 2004') setUpdatePlanModalVisible(true);
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Could not add member team');
        }
    });
    // Mutation to delete a team member
    const [deleteTeamMember, { loading: loadingDeleteTeamMember }] = (0, $33beb5b1bfae180c$export$83db09edaf672ed7)({
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Changes saved successfully!');
        },
        onError: ()=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).warn('Couldn\'t delete user.'),
        refetchQueries: [
            'GetSubscriptionByContext',
            'GetUserFirmAccountByFirmAccountAndFilter'
        ],
        awaitRefetchQueries: true
    });
    // Mutation to update a team member
    const [updateRoleTeamMember, { loading: loadingUpdateTeamMember }] = (0, $33beb5b1bfae180c$export$91f6062913294367)({
        onCompleted: ()=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Changes saved successfully!'),
        onError: (error)=>{
            const graphqlErrorName = error.graphQLErrors?.at(0)?.name;
            if (graphqlErrorName === 'RecordAlreadyInDb') (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Saving is impossible: this email is already used by another user.');
            else if (graphqlErrorName === 'PermissionException') (0, $55c6005cab9be059$export$2e2bcd8739ae039).info('Please contact support to update the account owner email address.');
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).warn('Update not possible.');
        },
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$7e72633a492e9933),
                variables: {
                    firmAccountId: firmAccountId
                }
            }
        ],
        awaitRefetchQueries: true
    });
    // Mutation to reactivate a team member
    const [reactivateTeamMember, { loading: loadingReactivateTeamMember }] = (0, $33beb5b1bfae180c$export$135f21ea45aea87f)({
        onCompleted: ()=>(0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Changes saved successfully!'),
        onError: (err)=>{
            if (err.message === 'Error code 2004') setUpdatePlanModalVisible(true);
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).warn('Update unsuccessful.');
        },
        refetchQueries: [
            'GetSubscriptionByContext',
            'GetUserFirmAccountByFirmAccountAndFilter'
        ],
        awaitRefetchQueries: true
    });
    const updateMember = (preparerDetailId, param, value)=>{
        const newRole = roles.find((obj)=>obj.id === value);
        const editedMembers = members.map((obj)=>({
                ...obj,
                Roles: param === 'role' && obj.Users.id === preparerDetailId ? newRole : obj.Roles,
                Users: param === 'email' && obj.Users.id === preparerDetailId ? {
                    ...obj.Users,
                    email: value
                } : obj.Users
            }));
        setMembers(editedMembers);
    };
    const saveMember = (preparerDetailId)=>{
        const selectedMember = members.find((obj)=>obj.Users.id === preparerDetailId);
        updateRoleTeamMember({
            variables: {
                firmAccountId: firmAccountId,
                userId: preparerDetailId,
                newRoleId: selectedMember.Roles.id,
                newEmail: selectedMember.Users.email
            }
        });
    };
    const deleteMember = (preparerDetailId)=>{
        const ids = {
            ...emailErrorIds
        };
        delete ids[preparerDetailId];
        setEmailErrorIds(ids);
        deleteTeamMember({
            variables: {
                firmAccountId: firmAccountId,
                userId: preparerDetailId
            }
        });
    };
    const reactivateMember = (preparerDetailId)=>{
        reactivateTeamMember({
            variables: {
                firmAccountId: firmAccountId,
                userId: preparerDetailId
            }
        });
    };
    const handleUpdatePlan = async ()=>{
        if (loadingSubscription || loadingCustomer) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).info('Loading subscription information. Please wait a couple seconds and try again.');
            return;
        }
        const { data: data } = await createBillingPortalSession({
            variables: {
                createBillingPortalInput: {
                    customer: customerId,
                    return_url: window.location.href,
                    flow_data: !subscriptionData?.GetSubscriptionByContext?.pause_collection?.behavior || subscriptionData?.GetSubscriptionByContext?.status === 'paused' ? {
                        type: 'subscription_update',
                        subscription_update: {
                            subscription: subscriptionData?.GetSubscriptionByContext?.id
                        }
                    } : undefined
                }
            }
        });
        window.location.href = data.createBillingPortalSession;
    };
    const handleCancelPlan = async ()=>{
        console.log('handleCancelPlan');
        if (loadingSubscription || loadingCustomer) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).info('Loading subscription information. Please wait a couple seconds and try again.');
            return;
        }
        setCancelPlanModalVisible(true);
    };
    const handleRenewPlan = async ()=>{
        if (loadingSubscription || loadingCustomer) {
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).info('Loading subscription information. Please wait a couple seconds and try again.');
            return;
        }
        if (subscriptionData.GetSubscriptionByContext?.status === 'active' && subscriptionData.GetSubscriptionByContext?.cancel_at_period_end) // update subscription to cancel at period end to false
        await updateSubscritpion({
            variables: {
                updateStripeSubscriptionInput: {
                    cancel_at_period_end: false
                }
            },
            refetchQueries: [
                'GetSubscriptionByContext'
            ],
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Subscription renewed successfully');
            },
            onError: (error)=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`Subscription could not be renewed. ${error.message}`);
            }
        });
        else if (subscriptionData.GetSubscriptionByContext?.status === 'canceled') // we need to start a whole new subscription
        await createSubscritpion({
            variables: {
                createStripeSubscriptionInput: {
                    customerId: subscriptionData.GetSubscriptionByContext?.customer,
                    planId: subscriptionData.GetSubscriptionByContext?.items.data[0].plan.id,
                    quantity: subscriptionData.GetSubscriptionByContext?.quantity,
                    firmAccountId: firmAccountId
                }
            },
            refetchQueries: [
                'GetSubscriptionByContext'
            ],
            onCompleted: ()=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Subscription renewed successfully');
            },
            onError: (error)=>{
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`Subscription could not be renewed. ${error.message}`);
            }
        });
    };
    const handleAddTeamMember = ()=>{
        // first check if on a plan that allows
        if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).teamMembers]) {
            showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).teamMembers);
            return;
        }
        // then check if their plan has room for another member
        checkCanAddTeamMember();
    };
    if (loadingUserFirmAccount || loadingCustomAllRoles) return (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
        size: "large"
    });
    const getClassByUsers = (users)=>users.deleteAt ? 'manage-team-deleted-user' : '';
    return (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
        size: "small",
        direction: "vertical",
        style: {
            width: '100%'
        },
        children: [
            (0, $bb3TF.jsx)((0, $58c1491b566e843c$export$2e2bcd8739ae039), {
                title: "Manage Team",
                tooltipTitle: "How does this work?",
                tooltipContent: (0, $bb3TF.jsx)($e5a06dc61e83803b$var$Paragraph, {
                    children: "Add or remove members of your team."
                })
            }),
            overPaying && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                type: "success",
                message: "Your plan supports more team members than you have active.",
                description: "You may add more team members or update your billing plan to reduce the number of seats you are paying for.",
                showIcon: true,
                style: {
                    marginTop: 20,
                    marginBottom: 20
                },
                closable: true
            }),
            (0, $bb3TF.jsx)((0, $2eb2b7b37988b8f9$export$2e2bcd8739ae039), {
                rowKey: (record)=>record.id,
                columns: [
                    {
                        title: 'Name',
                        dataIndex: 'Users',
                        key: 'name',
                        fixed: 'left',
                        width: 150,
                        render: (users)=>(0, $bb3TF.jsx)($e5a06dc61e83803b$var$Text, {
                                className: getClassByUsers(users),
                                children: `${users.UserInformation?.firstName} ${users.UserInformation?.lastName}`
                            })
                    },
                    {
                        title: 'Email',
                        dataIndex: 'Users',
                        key: 'email',
                        width: 150,
                        render: (users)=>users.deleteAt ? (0, $bb3TF.jsx)($e5a06dc61e83803b$var$Text, {
                                className: getClassByUsers(users),
                                children: users.email
                            }) : (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                validateStatus: emailErrorIds[users.id] ? 'error' : 'success',
                                help: emailErrorIds[users.id] ? 'Email address is invalid' : '',
                                className: "manage-team-form-item",
                                style: {
                                    marginBottom: 0
                                },
                                children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                    value: users.email,
                                    validateStatus: true,
                                    onChange: (e)=>{
                                        const email = e.target.value;
                                        updateMember(users.id, 'email', e.target.value);
                                        schema.validate({
                                            email: email
                                        }).then(()=>{
                                            const ids = {
                                                ...emailErrorIds
                                            };
                                            delete ids[users.id];
                                            setEmailErrorIds(ids);
                                        }).catch(()=>{
                                            setEmailErrorIds({
                                                ...emailErrorIds,
                                                [users.id]: true
                                            });
                                        });
                                    }
                                })
                            })
                    },
                    {
                        title: 'Role',
                        key: 'role',
                        width: 150,
                        render: (data)=>!data.Users.deleteAt ? (0, $bb3TF.jsx)((0, $ff3ede909c5885de$export$2e2bcd8739ae039), {
                                accountRole: data.Roles.description,
                                firm: roles,
                                updateMember: (preparerDetailId, role)=>updateMember(preparerDetailId, 'role', role),
                                preparerDetailId: data.Users.id
                            }) : (0, $bb3TF.jsx)($e5a06dc61e83803b$var$Text, {
                                className: getClassByUsers(data.Users),
                                style: {
                                    textTransform: 'capitalize'
                                },
                                children: data.Roles.description === 'TAX_PREPARER' ? 'Admin' : 'Staff'
                            })
                    },
                    // {
                    //   title: 'Referral Code',
                    //   key: 'Referal',
                    //   width: 120,
                    //   render: (data) => {
                    //     if (data.Users.deleteAt) {
                    //       return (
                    //         <span style={{ padding: 15 }}>
                    //           <StopOutlined title="Deleted team member" />
                    //         </span>
                    //       );
                    //     }
                    //     return <ManageTeamReferral userId={data.Users.id} />;
                    //   },
                    // },
                    {
                        title: '',
                        dataIndex: '',
                        key: 'action',
                        width: 120,
                        render: (data)=>{
                            if (data.Users.deleteAt) return (0, $bb3TF.jsx)("div", {
                                className: $bab24f83ab824dd9$export$b6fb1741c7f64881,
                                children: loadingReactivateTeamMember ? (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                                    size: "small"
                                }) : (0, $bb3TF.jsx)((0, $92b07c154bbb4d14$export$2e2bcd8739ae039), {
                                    tooltip: "Reactivate Member",
                                    confirmAction: true,
                                    confirmLabel: "Are you sure?",
                                    onClick: ()=>reactivateMember(data.Users.id),
                                    children: (0, $bb3TF.jsx)($e5a06dc61e83803b$var$SyncOutlined, {})
                                })
                            });
                            return (0, $bb3TF.jsxs)("div", {
                                className: $bab24f83ab824dd9$export$b6fb1741c7f64881,
                                children: [
                                    !emailErrorIds[data.Users.id] && (0, $bb3TF.jsx)((0, $92b07c154bbb4d14$export$2e2bcd8739ae039), {
                                        tooltip: "Save Change",
                                        confirmAction: true,
                                        confirmLabel: "Are you sure?",
                                        onClick: ()=>saveMember(data.Users.id),
                                        children: (0, $bb3TF.jsx)($e5a06dc61e83803b$var$SaveOutlined, {})
                                    }),
                                    (0, $bb3TF.jsx)((0, $92b07c154bbb4d14$export$2e2bcd8739ae039), {
                                        tooltip: "Delete Team Member",
                                        confirmAction: true,
                                        confirmLabel: "Are you sure?",
                                        onClick: ()=>deleteMember(data.Users.id),
                                        buttonProps: {
                                            type: 'primary'
                                        },
                                        children: (0, $bb3TF.jsx)($e5a06dc61e83803b$var$DeleteOutlined, {})
                                    })
                                ]
                            });
                        }
                    }
                ],
                loading: loadingDeleteTeamMember || loadingUpdateTeamMember,
                dataSource: members,
                scroll: {
                    x: true
                },
                bordered: true,
                noDataProps: {
                    title: 'No team members yet',
                    extra: (0, $bb3TF.jsx)((0, $e35118da10516dbb$export$2e2bcd8739ae039), {
                        onClick: ()=>setModal(true)
                    })
                },
                rowClassName: ()=>'manage-team-row',
                pagination: {
                    hideOnSinglePage: true
                }
            }),
            (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                type: "primary",
                onClick: handleAddTeamMember,
                icon: (0, $bb3TF.jsx)($e5a06dc61e83803b$var$PlusOutlined, {}),
                iconDirection: "left",
                style: {
                    marginBottom: 20,
                    marginTop: 25
                },
                disabled: loadingDeleteTeamMember || loadingUpdateTeamMember,
                children: "Add Team Member"
            }),
            (0, $bb3TF.jsxs)($e5a06dc61e83803b$var$Text, {
                style: {
                    color: 'grey'
                },
                children: [
                    (0, $bb3TF.jsxs)($e5a06dc61e83803b$var$Text, {
                        strong: true,
                        style: {
                            color: 'grey'
                        },
                        children: [
                            "Admins",
                            ' '
                        ]
                    }),
                    "have access to all clients and firm settings"
                ]
            }),
            (0, $bb3TF.jsxs)($e5a06dc61e83803b$var$Text, {
                style: {
                    color: 'grey'
                },
                children: [
                    (0, $bb3TF.jsxs)($e5a06dc61e83803b$var$Text, {
                        strong: true,
                        style: {
                            color: 'grey'
                        },
                        children: [
                            "Staff",
                            ' '
                        ]
                    }),
                    "only have access to assigned clients and personal settings"
                ]
            }),
            (0, $bb3TF.jsx)((0, $d81b70d88f5c0cb1$export$2e2bcd8739ae039), {
                style: {
                    margin: '8px 0'
                }
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                style: {
                    marginLeft: -15,
                    marginBottom: 30
                },
                children: [
                    (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        type: "link",
                        onClick: handleUpdatePlan,
                        style: {
                            color: 'gray',
                            fontSize: '14px',
                            fontWeight: 'normal',
                            textTransform: 'none'
                        },
                        children: "Add team members"
                    }),
                    (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        type: "link",
                        onClick: handleUpdatePlan,
                        style: {
                            color: 'gray',
                            fontSize: '14px',
                            fontWeight: 'normal',
                            textTransform: 'none'
                        },
                        children: "Update plan"
                    }),
                    subscriptionData?.GetSubscriptionByContext?.status !== 'canceled' && !subscriptionData?.GetSubscriptionByContext?.cancel_at && (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        type: "link",
                        onClick: handleCancelPlan,
                        style: {
                            color: 'gray',
                            fontSize: '14px',
                            fontWeight: 'normal',
                            textTransform: 'none'
                        },
                        children: "Cancel account"
                    }),
                    (subscriptionData?.GetSubscriptionByContext?.status === 'canceled' || subscriptionData?.GetSubscriptionByContext?.cancel_at) && (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        type: "link",
                        onClick: handleRenewPlan,
                        loading: loadingUpdateSubscription || loadingCreateSubscription,
                        style: {
                            color: 'gray',
                            fontSize: '14px',
                            fontWeight: 'normal',
                            textTransform: 'none'
                        },
                        children: "Reactivate account"
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $b3418ead49d42b22$export$2e2bcd8739ae039), {
                roles: roles,
                showModal: modal,
                setModal: setModal,
                onAddMemberTeam: (newMember)=>{
                    setMembers([
                        ...members,
                        newMember
                    ]);
                    // updateStep(accessToken, 5);
                    (0, $e19596a12ff9a33f$export$f69c19e57285b83a)('The Team Member Was Added Successfully', 'success');
                },
                firmAccountId: firmAccountId,
                languageId: languageId
            }),
            (0, $bb3TF.jsxs)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
                title: "No more seats available",
                visible: updatePlanModalVisible,
                onCancel: ()=>setUpdatePlanModalVisible(false),
                footer: [
                    (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        type: "primary",
                        onClick: handleUpdatePlan,
                        children: "Update Plan"
                    }, "updatePlan"),
                    (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                        type: "default",
                        onClick: ()=>setUpdatePlanModalVisible(false),
                        children: "Close"
                    }, "close")
                ],
                children: [
                    (0, $bb3TF.jsx)("p", {
                        children: "Your account is already using all the team member seats available."
                    }),
                    (0, $bb3TF.jsx)("p", {
                        children: "You may add more seats to your plan from the Billing Portal by increasing the quantity of your plan."
                    })
                ]
            }),
            (0, $bb3TF.jsx)((0, $40a78cc88cda8de1$export$2e2bcd8739ae039), {
                setIsModalVisible: setCancelPlanModalVisible,
                isModalVisible: cancelPlanModalVisible,
                subscription: subscriptionData?.GetSubscriptionByContext
            })
        ]
    });
};
var $e5a06dc61e83803b$export$2e2bcd8739ae039 = $e5a06dc61e83803b$var$ManageTeam;









var $bb3TF = parcelRequire("bb3TF");






const { Text: $3e504d44292ecb7c$var$Text, Paragraph: $3e504d44292ecb7c$var$Paragraph, Title: $3e504d44292ecb7c$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $3e504d44292ecb7c$var$Monetization = ()=>{
    const { firmAccountId: firmAccountId, accessToken: accessToken } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    //   const [enableClientBot, setEnableClientBot] = useState<boolean>(false);
    const { data: monetizationSettings, loading: monetizationSettingsLoading } = (0, $732264f53056e08f$export$9fced88514778fe9)({
        variables: {
            category: 'FIRM_MONETIZATION_SETTINGS'
        },
        skip: !firmAccountId,
        onError: (error)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
        }
    });
    const handleOnError = (error)=>{
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(`An error has occurred: ${error.message}.`);
    };
    const { data: planAccessData, loading: loadingPlanType } = (0, $fa3f5c8f35890bd3$export$793fe9e22153f877)({
        skip: !accessToken
    });
    const currentPlanAccess = planAccessData?.getPlanAccessLevel?.planType;
    const [createFirmSetting, { loading: createFirmSettingLoading }] = (0, $33beb5b1bfae180c$export$1ff58c91a8b6e9e1)({
        onError: handleOnError,
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$d16c1a94a02eda7f),
                variables: {
                    category: 'FIRM_MONETIZATION_SETTINGS'
                }
            }
        ],
        awaitRefetchQueries: true
    });
    const [updateFirmSetting, { loading: updateFirmSettingLoading }] = (0, $33beb5b1bfae180c$export$1a4761718d2c597b)({
        onError: handleOnError,
        refetchQueries: [
            {
                query: (0, $732264f53056e08f$export$d16c1a94a02eda7f),
                variables: {
                    category: 'FIRM_MONETIZATION_SETTINGS'
                }
            }
        ],
        awaitRefetchQueries: true
    });
    const getIsDisabled = (settingName)=>{
        console.log(currentPlanAccess);
        switch(settingName){
            case 'enable-client-audit-assistance':
                return currentPlanAccess === 'FREE';
            default:
                return true;
        }
    };
    const changeSetting = async (setting, val)=>{
        try {
            if (setting.id) await updateFirmSetting({
                variables: {
                    id: setting.id,
                    value: String(val)
                }
            });
            else await createFirmSetting({
                variables: {
                    name: setting.name,
                    value: String(val)
                }
            });
        } catch (error) {
            console.log(error);
        }
    };
    return (0, $bb3TF.jsxs)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
        style: {
            backgroundColor: 'white'
        },
        children: [
            (0, $bb3TF.jsx)((0, $58c1491b566e843c$export$2e2bcd8739ae039), {
                title: "Monetization Settings",
                tooltipTitle: "Monetization Settings",
                tooltipContent: (0, $bb3TF.jsx)($3e504d44292ecb7c$var$Paragraph, {
                    children: (0, $bb3TF.jsx)($3e504d44292ecb7c$var$Text, {
                        children: "Customize your monetization features"
                    })
                })
            }),
            (0, $bb3TF.jsxs)("div", {
                style: {
                    paddingTop: '20px',
                    marginBottom: '125px'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                        style: {
                            width: '100%'
                        },
                        align: "middle",
                        children: monetizationSettings?.getFirmSettings?.map((setting)=>(0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                                children: (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                                    direction: "vertical",
                                    align: "start",
                                    children: [
                                        (0, $bb3TF.jsx)($3e504d44292ecb7c$var$Title, {
                                            style: {
                                                margin: 0
                                            },
                                            level: 5,
                                            children: setting.description
                                        }),
                                        (0, $bb3TF.jsx)((0, $4fd303306a27e42e$export$2e2bcd8739ae039), {
                                            onChange: (val)=>changeSetting(setting, val),
                                            // eslint-disable-next-line
                                            checked: setting.value.__typename === "BooleanValue" ? setting.value?.boolValue : false,
                                            loading: updateFirmSettingLoading || createFirmSettingLoading,
                                            disabled: getIsDisabled(setting.name)
                                        })
                                    ]
                                })
                            }))
                    }),
                    monetizationSettingsLoading && (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        align: "middle",
                        justify: "center",
                        children: (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                            size: "large"
                        })
                    })
                ]
            })
        ]
    });
};
var $3e504d44292ecb7c$export$2e2bcd8739ae039 = $3e504d44292ecb7c$var$Monetization;


const { TabPane: $21b9311cdd522374$var$TabPane } = (0, $5024ed5b7bb39672$export$2e2bcd8739ae039);
const { Title: $21b9311cdd522374$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { useBreakpoint: $21b9311cdd522374$var$useBreakpoint } = (0, $89d88a41b53d163f$export$2e2bcd8739ae039);
const { BankOutlined: $21b9311cdd522374$var$BankOutlined, InfoCircleOutlined: $21b9311cdd522374$var$InfoCircleOutlined, PictureOutlined: $21b9311cdd522374$var$PictureOutlined, FormatPainterOutlined: $21b9311cdd522374$var$FormatPainterOutlined, LinkOutlined: $21b9311cdd522374$var$LinkOutlined, CreditCardOutlined: $21b9311cdd522374$var$CreditCardOutlined, DollarOutlined: $21b9311cdd522374$var$DollarOutlined, TeamOutlined: $21b9311cdd522374$var$TeamOutlined, MailOutlined: $21b9311cdd522374$var$MailOutlined, CodeOutlined: $21b9311cdd522374$var$CodeOutlined, ApartmentOutlined: $21b9311cdd522374$var$ApartmentOutlined, LockOutlined: $21b9311cdd522374$var$LockOutlined, CalendarOutlined: $21b9311cdd522374$var$CalendarOutlined, CloudOutlined: $21b9311cdd522374$var$CloudOutlined } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $21b9311cdd522374$var$AccountSettings = ()=>{
    const { userRole: userRole } = (0, $58073eff19365823$export$a7347740d65f620b)((state)=>state.session);
    const [isStaff] = (0, $6fFrj.useState)(userRole === 'STAFF');
    const screens = $21b9311cdd522374$var$useBreakpoint();
    const { sm: sm } = screens;
    const { tab: tab } = (0, $990f835fb2356f36$export$99eaa27ddbbb95ef)();
    const navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    const [activeTab, setActiveTab] = (0, $6fFrj.useState)('firm-info');
    const { showModal: showModal, accessObject: accessObject } = (0, $a8c21a2ece310828$export$c8ea4d078f89ced5)();
    // Get customerId
    const { data: currentStripeInformation } = (0, $732264f53056e08f$export$9f382c5aef9c5d4d)();
    const { customerId: customerId } = currentStripeInformation?.CurrentStripeInformation ?? {};
    // Create billing portal session mutation
    const [createBillingPortalSession] = (0, $99ead93e2ec80d4e$export$1940481f2be3ddf2)();
    const handleChange = (newTab)=>{
        if (newTab === 'billing-portal') {
            createBillingPortalSession({
                variables: {
                    createBillingPortalInput: {
                        customer: customerId,
                        return_url: window.location.href
                    }
                }
            }).then(({ data: data })=>{
                window.location.href = data?.createBillingPortalSession;
            });
            return;
        }
        if (newTab === 'taxaroo-drive') {
            if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).mappedDrive]) {
                showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).mappedDrive);
                return;
            }
        }
        if (newTab === 'pixels') {
            if (!accessObject?.[(0, $a8c21a2ece310828$export$617d79dae526d2cf).pixels]) {
                showModal((0, $a8c21a2ece310828$export$617d79dae526d2cf).pixels);
                return;
            }
        }
        navigate(`/settings/${newTab}`);
        (0, $dfc6a33c14790f87$export$10a8148065e6dad6)((0, $dfc6a33c14790f87$export$8f144a86ebfa3544).TAB_SELECT, {
            'Tab Description': 'Settings Tabs',
            'Tab Selected': newTab,
            url: window.location.href
        });
    };
    (0, $6fFrj.useEffect)(()=>{
        if (tab) setActiveTab(tab);
    }, [
        tab
    ]);
    return (0, $bb3TF.jsxs)("div", {
        children: [
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    children: (0, $bb3TF.jsx)($21b9311cdd522374$var$Title, {
                        level: 3,
                        children: "Account Settings"
                    })
                })
            }),
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                children: (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                    span: 24,
                    children: (0, $bb3TF.jsx)("div", {
                        className: "card-container",
                        children: (0, $bb3TF.jsxs)((0, $5024ed5b7bb39672$export$2e2bcd8739ae039), {
                            activeKey: activeTab,
                            type: "card",
                            tabPosition: sm ? 'left' : 'top',
                            size: "small",
                            onChange: handleChange,
                            tabBarStyle: {
                                color: 'var(--primary-dark)'
                            },
                            children: [
                                (0, $bb3TF.jsx)($21b9311cdd522374$var$TabPane, {
                                    tab: (0, $bb3TF.jsxs)("span", {
                                        children: [
                                            (0, $bb3TF.jsx)($21b9311cdd522374$var$InfoCircleOutlined, {}),
                                            isStaff ? 'Personal Info' : 'Firm Info'
                                        ]
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $2e33db7b040b4658$export$2e2bcd8739ae039), {})
                                }, "firm-info"),
                                (0, $bb3TF.jsx)($21b9311cdd522374$var$TabPane, {
                                    tab: (0, $bb3TF.jsxs)("span", {
                                        children: [
                                            (0, $bb3TF.jsx)($21b9311cdd522374$var$PictureOutlined, {}),
                                            "Profile Photo"
                                        ]
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $8ad24cd47a89e017$export$2e2bcd8739ae039), {})
                                }, "profile-photo"),
                                !isStaff && (0, $bb3TF.jsx)($21b9311cdd522374$var$TabPane, {
                                    tab: (0, $bb3TF.jsxs)("span", {
                                        children: [
                                            (0, $bb3TF.jsx)($21b9311cdd522374$var$FormatPainterOutlined, {}),
                                            "Site Branding"
                                        ]
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $5e245eaf8da83742$export$2e2bcd8739ae039), {})
                                }, "site-branding"),
                                (0, $bb3TF.jsx)($21b9311cdd522374$var$TabPane, {
                                    tab: (0, $bb3TF.jsxs)("span", {
                                        children: [
                                            (0, $bb3TF.jsx)($21b9311cdd522374$var$LinkOutlined, {}),
                                            "Invite Link"
                                        ]
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $ce2057fc87a3f13e$export$2e2bcd8739ae039), {})
                                }, "invite-link"),
                                !isStaff && (0, $bb3TF.jsx)($21b9311cdd522374$var$TabPane, {
                                    tab: (0, $bb3TF.jsxs)("span", {
                                        children: [
                                            (0, $bb3TF.jsx)($21b9311cdd522374$var$BankOutlined, {}),
                                            "Setup Invoicing"
                                        ]
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $b4da56a5c53b9e80$export$2e2bcd8739ae039), {})
                                }, "setup-invoicing"),
                                !isStaff && (0, $bb3TF.jsx)($21b9311cdd522374$var$TabPane, {
                                    tab: (0, $bb3TF.jsxs)("span", {
                                        children: [
                                            (0, $bb3TF.jsx)($21b9311cdd522374$var$DollarOutlined, {}),
                                            "Monetization"
                                        ]
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $3e504d44292ecb7c$export$2e2bcd8739ae039), {})
                                }, "monetization"),
                                !isStaff && (0, $bb3TF.jsx)($21b9311cdd522374$var$TabPane, {
                                    tab: (0, $bb3TF.jsxs)("span", {
                                        children: [
                                            (0, $bb3TF.jsx)($21b9311cdd522374$var$CreditCardOutlined, {}),
                                            "Billing Portal"
                                        ]
                                    })
                                }, "billing-portal"),
                                !isStaff && (0, $bb3TF.jsx)($21b9311cdd522374$var$TabPane, {
                                    tab: (0, $bb3TF.jsxs)("span", {
                                        children: [
                                            (0, $bb3TF.jsx)($21b9311cdd522374$var$TeamOutlined, {}),
                                            "Manage Team"
                                        ]
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $e5a06dc61e83803b$export$2e2bcd8739ae039), {
                                        userId: 321,
                                        userRole: "admin",
                                        numTeamMembers: 2,
                                        // currentStep={currentStep}
                                        token: "token"
                                    })
                                }, "manage-team"),
                                (0, $bb3TF.jsx)($21b9311cdd522374$var$TabPane, {
                                    tab: (0, $bb3TF.jsxs)("span", {
                                        children: [
                                            (0, $bb3TF.jsx)($21b9311cdd522374$var$LockOutlined, {}),
                                            "Security"
                                        ]
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $5c06aaa5544b4a13$export$2e2bcd8739ae039), {})
                                }, "security"),
                                (0, $bb3TF.jsx)($21b9311cdd522374$var$TabPane, {
                                    tab: (0, $bb3TF.jsxs)("span", {
                                        children: [
                                            (0, $bb3TF.jsx)($21b9311cdd522374$var$CloudOutlined, {}),
                                            "Taxaroo Drive"
                                        ]
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $dd48553a54d7a3ce$export$2e2bcd8739ae039), {})
                                }, "taxaroo-drive"),
                                !isStaff && (0, $bb3TF.jsx)($21b9311cdd522374$var$TabPane, {
                                    tab: (0, $bb3TF.jsxs)("span", {
                                        children: [
                                            (0, $bb3TF.jsx)($21b9311cdd522374$var$MailOutlined, {}),
                                            "Notifications"
                                        ]
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $4325d8ed5326d036$export$2e2bcd8739ae039), {})
                                }, "notifications"),
                                !isStaff && (0, $bb3TF.jsx)($21b9311cdd522374$var$TabPane, {
                                    tab: (0, $bb3TF.jsxs)("span", {
                                        children: [
                                            (0, $bb3TF.jsx)($21b9311cdd522374$var$CodeOutlined, {}),
                                            "Pixels"
                                        ]
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $472cf947bf00085b$export$2e2bcd8739ae039), {})
                                }, "pixels"),
                                (0, $bb3TF.jsx)($21b9311cdd522374$var$TabPane, {
                                    tab: (0, $bb3TF.jsxs)("span", {
                                        children: [
                                            (0, $bb3TF.jsx)($21b9311cdd522374$var$CalendarOutlined, {}),
                                            "Calendars"
                                        ]
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $2aa219cb80eed11e$export$2e2bcd8739ae039), {})
                                }, "calendars"),
                                !isStaff && (0, $bb3TF.jsx)($21b9311cdd522374$var$TabPane, {
                                    tab: (0, $bb3TF.jsxs)("span", {
                                        children: [
                                            (0, $bb3TF.jsx)($21b9311cdd522374$var$ApartmentOutlined, {}),
                                            "Workflow"
                                        ]
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $8cab7f86901e71c6$export$2e2bcd8739ae039), {})
                                }, "workflow"),
                                (0, $bb3TF.jsx)($21b9311cdd522374$var$TabPane, {
                                    tab: (0, $bb3TF.jsxs)("span", {
                                        children: [
                                            (0, $bb3TF.jsx)((0, $c8efa4c2e6243fee$export$f04a61298a47a40f).AiMagic, {
                                                style: {
                                                    marginRight: '10px'
                                                }
                                            }),
                                            "AI"
                                        ]
                                    }),
                                    children: (0, $bb3TF.jsx)((0, $f16624e82228af20$export$2e2bcd8739ae039), {})
                                }, "ai")
                            ]
                        })
                    })
                })
            })
        ]
    });
};
var $21b9311cdd522374$export$2e2bcd8739ae039 = $21b9311cdd522374$var$AccountSettings;


var $ab59d8d46aeef48f$export$2e2bcd8739ae039 = (0, $21b9311cdd522374$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");
const $825e11649f22b564$var$ClientPage = ()=>(0, $bb3TF.jsx)("p", {
        children: "Tax Payer Space"
    });
var $825e11649f22b564$export$2e2bcd8739ae039 = $825e11649f22b564$var$ClientPage;



var $bb3TF = parcelRequire("bb3TF");


var $6fFrj = parcelRequire("6fFrj");


const $97823e15e804c9f9$var$ExternalCalendarRedirect = ()=>{
    const navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    const location = (0, $990f835fb2356f36$export$45d76561a5302f2b)();
    const params = (0, $990f835fb2356f36$export$99eaa27ddbbb95ef)();
    const [connectExternalCalendar, { data: data, loading: loading }] = (0, $a86ee2eea1b8cff6$export$633280c0c1c517b)();
    (0, $6fFrj.useEffect)(()=>{
        const code = new URLSearchParams(location.search).get('code');
        const state = new URLSearchParams(location.search).get('state');
        const provider = params.provider.toUpperCase();
        if (code && provider && state) connectExternalCalendar({
            variables: {
                code: code,
                provider: provider,
                state: state
            },
            onCompleted: ()=>{
                navigate('/settings/calendars');
            },
            onError: (error)=>{
                navigate('/settings/calendars');
                (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message);
            }
        });
    }, [
        location.search
    ]);
    return (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
        fullscreen: true
    });
};
var $97823e15e804c9f9$export$2e2bcd8739ae039 = $97823e15e804c9f9$var$ExternalCalendarRedirect;


const $aa8f22afe69674e9$export$fd43ec2654dfed19 = [
    {
        path: '/',
        element: (0, $bb3TF.jsx)((0, $cfcef03c4146f02b$export$2e2bcd8739ae039), {})
    },
    {
        path: '/settings',
        element: (0, $bb3TF.jsx)((0, $ab59d8d46aeef48f$export$2e2bcd8739ae039), {}),
        children: (0, $bb3TF.jsx)((0, $990f835fb2356f36$export$e7b0ac011bb776c6), {
            path: ":tab",
            element: (0, $bb3TF.jsx)((0, $ab59d8d46aeef48f$export$2e2bcd8739ae039), {})
        })
    },
    {
        path: '/onboarding',
        element: (0, $bb3TF.jsx)((0, $692778c9933b99d3$export$2e2bcd8739ae039), {})
    },
    {
        path: '/appointments',
        element: (0, $bb3TF.jsx)((0, $70e52ac512f25943$export$2e2bcd8739ae039), {})
    },
    {
        path: '/chat',
        element: (0, $bb3TF.jsx)((0, $9f8459ba594d5b47$export$8624ff1b6d3ea6ae), {
            children: (0, $bb3TF.jsx)((0, $5acb63e4e117216a$export$2e2bcd8739ae039), {})
        })
    },
    {
        path: '/interviews',
        element: (0, $bb3TF.jsx)((0, $e26a1ed35617e99f$export$2e2bcd8739ae039), {})
    },
    {
        path: '/analytics',
        element: (0, $bb3TF.jsx)((0, $0ed549787c3d719b$export$2e2bcd8739ae039), {})
    },
    {
        path: '/clients',
        element: (0, $bb3TF.jsx)((0, $825e11649f22b564$export$2e2bcd8739ae039), {})
    },
    {
        path: '/clients/details',
        element: (0, $bb3TF.jsx)((0, $2d5c0cd7350fded7$export$2e2bcd8739ae039), {})
    },
    {
        path: '/external-calendar/:provider',
        element: (0, $bb3TF.jsx)((0, $97823e15e804c9f9$export$2e2bcd8739ae039), {})
    }
];



var $bb3TF = parcelRequire("bb3TF");

var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




const $fa09d5b22c557d9e$var$defaultOptions = {};
const $fa09d5b22c557d9e$export$e54909d21f9e0bf9 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    query GetPasswordResetIncludeFirm($id: String!) {
  passwordResetIncludeFirm(id: $id) {
    id
    Users {
      id
      email
      UserFirmAccount {
        id
        FirmAccount {
          id
          name
        }
      }
    }
  }
}
    `;
function $fa09d5b22c557d9e$export$80f4c7ddb3ba32ae(baseOptions) {
    const options = {
        ...$fa09d5b22c557d9e$var$defaultOptions,
        ...baseOptions
    };
    return $cec66d7339eadd2d$export$dd0a697e1782aedd($fa09d5b22c557d9e$export$e54909d21f9e0bf9, options);
}
function $fa09d5b22c557d9e$export$8416bb8057b3ce4(baseOptions) {
    const options = {
        ...$fa09d5b22c557d9e$var$defaultOptions,
        ...baseOptions
    };
    return $b479e4ced1af6421$export$fd83eea6ecd2d8fa($fa09d5b22c557d9e$export$e54909d21f9e0bf9, options);
}
const $fa09d5b22c557d9e$export$39ac829ab91f0716 = {
    Query: {
        GetPasswordResetIncludeFirm: 'GetPasswordResetIncludeFirm'
    }
};



const $ebe2df5ae4e7ccaa$var$defaultOptions = {};
const $ebe2df5ae4e7ccaa$export$220cc41523e45ddf = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation ResetPassword($resetPasswordInput: ResetPasswordInput!) {
  ResetPassword(resetPasswordInput: $resetPasswordInput)
}
    `;
function $ebe2df5ae4e7ccaa$export$3177acf383c684f6(baseOptions) {
    const options = {
        ...$ebe2df5ae4e7ccaa$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($ebe2df5ae4e7ccaa$export$220cc41523e45ddf, options);
}
const $ebe2df5ae4e7ccaa$export$a038d8eee1353d1f = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation ActivateClientAccount($activateClientInput: ActivateClientInput!) {
  ActivateClientAccount(activateClientInput: $activateClientInput)
}
    `;
function $ebe2df5ae4e7ccaa$export$eb9aaa555dd41628(baseOptions) {
    const options = {
        ...$ebe2df5ae4e7ccaa$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($ebe2df5ae4e7ccaa$export$a038d8eee1353d1f, options);
}
const $ebe2df5ae4e7ccaa$export$520f30124dfc680b = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation createPasswordResetByEmail($email: String!) {
  createPasswordResetByEmail(email: $email) {
    expiresAt
  }
}
    `;
function $ebe2df5ae4e7ccaa$export$afbf6e0daaff4bf5(baseOptions) {
    const options = {
        ...$ebe2df5ae4e7ccaa$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($ebe2df5ae4e7ccaa$export$520f30124dfc680b, options);
}
const $ebe2df5ae4e7ccaa$export$39ac829ab91f0716 = {
    Mutation: {
        ResetPassword: 'ResetPassword',
        ActivateClientAccount: 'ActivateClientAccount',
        createPasswordResetByEmail: 'createPasswordResetByEmail'
    }
};



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");


var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");
const $2117bee6f7d3173c$var$SvgWarningCircleFilled = (props)=>/*#__PURE__*/ (0, $bb3TF.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 9,
        height: 9,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bb3TF.jsx)("g", {
                clipPath: "url(#warningCircleFilled_svg__a)",
                children: /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                    d: "M4.5 9a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-6.75a.42.42 0 0 1 .422.422V4.64a.42.42 0 1 1-.844 0V2.67A.42.42 0 0 1 4.5 2.25Zm-.563 3.938a.563.563 0 1 1 1.126 0 .563.563 0 0 1-1.125 0Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $bb3TF.jsx)("defs", {
                children: /*#__PURE__*/ (0, $bb3TF.jsx)("clipPath", {
                    id: "warningCircleFilled_svg__a",
                    children: /*#__PURE__*/ (0, $bb3TF.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h9v9H0z"
                    })
                })
            })
        ]
    });
var $2117bee6f7d3173c$export$2e2bcd8739ae039 = $2117bee6f7d3173c$var$SvgWarningCircleFilled;


var $726db529b1143da1$export$7e3de92c596d6d92;
var $726db529b1143da1$export$26ce102b7fe49e9f;
var $726db529b1143da1$export$4cda166b212150b9;
$726db529b1143da1$export$7e3de92c596d6d92 = `J6JfPG_checkCircleFilled`;
$726db529b1143da1$export$26ce102b7fe49e9f = `J6JfPG_passwordTooltip`;
$726db529b1143da1$export$4cda166b212150b9 = `J6JfPG_warningCircleFilled`;


const { CheckCircleFilled: $1e9efe4b9b95edaa$var$CheckCircleFilled } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $1e9efe4b9b95edaa$var$PasswordRequirements = [
    {
        message: 'Must be between 8 and 30 characters long',
        validate: (password)=>password?.length >= 8 && password?.length <= 30
    },
    {
        message: 'Must contain at least one lowercase letter',
        validate: (password)=>/[a-z]/.test(password)
    },
    {
        message: 'Must contain at least one uppercase letter',
        validate: (password)=>/[A-Z]/.test(password)
    },
    {
        message: 'Must contain at least one number',
        validate: (password)=>/[0-9]/.test(password)
    },
    {
        message: 'Must contain at least one special character',
        validate: (password)=>/[^A-Za-z0-9]/.test(password)
    }
];
const $1e9efe4b9b95edaa$var$PasswordTooltipValue = ({ password: password })=>(0, $bb3TF.jsx)("div", {
        style: {
            paddingTop: 10
        },
        children: $1e9efe4b9b95edaa$var$PasswordRequirements.map((requirement)=>(0, $bb3TF.jsxs)("p", {
                style: {
                    color: requirement.validate(password) ? '#404040' : 'white'
                },
                children: [
                    requirement.validate(password) ? (0, $bb3TF.jsx)($1e9efe4b9b95edaa$var$CheckCircleFilled, {
                        className: $726db529b1143da1$export$7e3de92c596d6d92
                    }) : (0, $bb3TF.jsx)((0, $2117bee6f7d3173c$export$2e2bcd8739ae039), {
                        className: $726db529b1143da1$export$4cda166b212150b9
                    }),
                    ' ',
                    requirement.message
                ]
            }, requirement.message))
    });
const $1e9efe4b9b95edaa$var$PasswordInputWithTooltip = ({ tooltipProps: tooltipProps })=>{
    const [password, setPassword] = (0, $6fFrj.useState)('');
    return (0, $bb3TF.jsx)((0, $fd177f0fd45f56a6$export$2e2bcd8739ae039), {
        trigger: [
            'focus'
        ],
        title: (0, $bb3TF.jsx)($1e9efe4b9b95edaa$var$PasswordTooltipValue, {
            password: password
        }),
        placement: "bottomLeft",
        color: "#282828",
        overlayClassName: $726db529b1143da1$export$26ce102b7fe49e9f,
        ...tooltipProps,
        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039).Password, {
            autoComplete: "new-password",
            type: "white",
            placeholder: "Enter Password ...",
            size: "large",
            onChange: (e)=>setPassword(e.target.value)
        })
    });
};
$1e9efe4b9b95edaa$var$PasswordInputWithTooltip.defaultProps = {
    tooltipProps: {}
};
var $1e9efe4b9b95edaa$export$2e2bcd8739ae039 = $1e9efe4b9b95edaa$var$PasswordInputWithTooltip;


var $1f98c8faf1ba484f$export$9142f086d48553b0;
var $1f98c8faf1ba484f$export$6d9e59725930d31e;
$1f98c8faf1ba484f$export$9142f086d48553b0 = `Exleaa_activate-account-page`;
$1f98c8faf1ba484f$export$6d9e59725930d31e = `Exleaa_activate-account-wrapper`;


const { Text: $182bfd81c46fadd7$var$Text, Title: $182bfd81c46fadd7$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { useBreakpoint: $182bfd81c46fadd7$var$useBreakpoint } = (0, $89d88a41b53d163f$export$2e2bcd8739ae039);
function $182bfd81c46fadd7$var$ActivatePreparerAccount() {
    const [error, setError] = (0, $6fFrj.useState)(null);
    const screens = $182bfd81c46fadd7$var$useBreakpoint();
    const navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    const { id: id } = (0, $990f835fb2356f36$export$99eaa27ddbbb95ef)();
    const baseUrl = window.location.origin;
    // graphql
    // fetch user and firm name by PasswordResetId
    const { data: data, loading: loadingPasswordReset } = (0, $fa09d5b22c557d9e$export$80f4c7ddb3ba32ae)({
        variables: {
            id: id
        },
        onError: (err)=>{
            if (err.message.includes('1001')) setError('CannotFindRecordException');
            else if (err.message.includes('4002')) setError('PasswordResetExpiredException');
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message);
        },
        onCompleted: ()=>{
            setError(null);
        }
    });
    const { Users: Users } = data?.passwordResetIncludeFirm || {};
    const { email: email, UserFirmAccount: UserFirmAccount } = Users || {};
    const firmName = UserFirmAccount?.length === 1 ? UserFirmAccount[0].FirmAccount.name : null;
    // mutation to reset password
    const [resetPassword, { loading: loadingActivatingAccount }] = (0, $ebe2df5ae4e7ccaa$export$eb9aaa555dd41628)({
        onError: (err)=>{
            if (err.message.includes('1005')) (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Password doesn\'t meet the requirements.');
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message);
        },
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Account activated. Please login.', 10);
            setTimeout(()=>{
                navigate('/login');
            }, 300);
        }
    });
    const onFinish = (values)=>{
        resetPassword({
            variables: {
                activateClientInput: {
                    uuid: id,
                    password: values.the_pass,
                    passwordConfirmation: values.the_confirm_pass
                }
            }
        });
    };
    const onFinishFailed = (errorInfo)=>{
        console.error('Failed:', errorInfo);
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Account activation failed.');
    };
    if (error) return (0, $bb3TF.jsx)("div", {
        className: $1f98c8faf1ba484f$export$9142f086d48553b0,
        children: (0, $bb3TF.jsx)("div", {
            className: $1f98c8faf1ba484f$export$6d9e59725930d31e,
            children: (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                style: {
                    padding: screens.md ? '10px 80px' : '5px',
                    maxWidth: '900px'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        style: {
                            margin: '0 0 60px 0'
                        },
                        children: (0, $bb3TF.jsx)((0, $1cbcb18aa67bf12c$export$2e2bcd8739ae039), {
                            width: "170",
                            height: "40"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        children: (0, $bb3TF.jsxs)("div", {
                            style: {
                                textAlign: 'center',
                                marginBottom: '20px'
                            },
                            children: [
                                (0, $bb3TF.jsx)($182bfd81c46fadd7$var$Title, {
                                    level: 3,
                                    children: "Activate Your Account"
                                }),
                                error === 'CannotFindRecordException' && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                                    type: "error",
                                    showIcon: true,
                                    message: "Record could not be found.",
                                    description: "This could be becuase you have already activated your account. To update your password please select forgot password from the login screen.\n                    Otherwise please request a new link from your firm admin.",
                                    style: {
                                        marginTop: '40px',
                                        maxWidth: '500px'
                                    }
                                }),
                                error === 'PasswordResetExpiredException' && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                                    type: "error",
                                    showIcon: true,
                                    message: "This link has expired.",
                                    description: "Please request a new link from your firm admin.",
                                    style: {
                                        marginTop: '40px'
                                    }
                                })
                            ]
                        })
                    }),
                    (0, $bb3TF.jsx)("div", {
                        style: {
                            textAlign: 'center'
                        },
                        children: (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                            to: "/login",
                            children: "Go to login"
                        })
                    })
                ]
            })
        })
    });
    return (0, $bb3TF.jsx)("div", {
        className: $1f98c8faf1ba484f$export$9142f086d48553b0,
        children: (0, $bb3TF.jsx)("div", {
            className: $1f98c8faf1ba484f$export$6d9e59725930d31e,
            children: (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                style: {
                    padding: screens.md ? '10px 80px' : '5px',
                    maxWidth: '900px'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        style: {
                            margin: '0 0 60px 0'
                        },
                        children: (0, $bb3TF.jsx)((0, $1cbcb18aa67bf12c$export$2e2bcd8739ae039), {
                            width: "170",
                            height: "40"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        children: (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                            name: "Activate Account",
                            layout: "vertical",
                            onFinish: onFinish,
                            onFinishFailed: onFinishFailed,
                            children: [
                                (0, $bb3TF.jsxs)("div", {
                                    style: {
                                        textAlign: 'center',
                                        marginBottom: '20px'
                                    },
                                    children: [
                                        (0, $bb3TF.jsx)($182bfd81c46fadd7$var$Title, {
                                            level: 3,
                                            children: "Activate Your Account"
                                        }),
                                        loadingPasswordReset ? (0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039), {
                                            paragraph: {
                                                rows: 2,
                                                width: 500
                                            },
                                            style: {
                                                marginTop: 40
                                            }
                                        }) : (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                                            direction: "vertical",
                                            children: [
                                                firmName && (0, $bb3TF.jsxs)($182bfd81c46fadd7$var$Text, {
                                                    children: [
                                                        (0, $bb3TF.jsx)("b", {
                                                            children: firmName
                                                        }),
                                                        ' ',
                                                        "added you as a team member."
                                                    ]
                                                }),
                                                (0, $bb3TF.jsxs)($182bfd81c46fadd7$var$Text, {
                                                    children: [
                                                        "To get started, please create a password below.",
                                                        (0, $bb3TF.jsx)("br", {}),
                                                        "In the future you can sign in directly at",
                                                        (0, $bb3TF.jsxs)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                                                            to: `${baseUrl}/login`,
                                                            children: [
                                                                ' ',
                                                                baseUrl,
                                                                "/login"
                                                            ]
                                                        }),
                                                        ' ',
                                                        "with the email address",
                                                        ' ',
                                                        (0, $bb3TF.jsx)("b", {
                                                            children: email
                                                        }),
                                                        "."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "the_pass",
                                    label: "Password",
                                    rules: [
                                        {
                                            required: true,
                                            message: 'The password is required'
                                        }
                                    ],
                                    children: (0, $bb3TF.jsx)("div", {
                                        children: (0, $bb3TF.jsx)((0, $1e9efe4b9b95edaa$export$2e2bcd8739ae039), {
                                            tooltipProps: {
                                                placement: 'topLeft'
                                            }
                                        })
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "the_confirm_pass",
                                    label: "Confirm Password",
                                    dependencies: [
                                        'the_pass'
                                    ],
                                    rules: [
                                        {
                                            required: true
                                        },
                                        ({ getFieldValue: getFieldValue })=>({
                                                validator (_, value) {
                                                    if (!value || getFieldValue('the_pass') === value) return Promise.resolve();
                                                    return Promise.reject(new Error('The two passwords that you entered do not match!'));
                                                }
                                            })
                                    ],
                                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039).Password, {
                                        autoComplete: "disabled",
                                        placeholder: "Confirm Password"
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                        type: "primary",
                                        htmlType: "submit",
                                        loading: loadingActivatingAccount,
                                        style: {
                                            width: '100%',
                                            justifyContent: 'center'
                                        },
                                        size: "large",
                                        children: "Activate Your Account"
                                    })
                                }),
                                (0, $bb3TF.jsx)("div", {
                                    style: {
                                        textAlign: 'center'
                                    },
                                    children: (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                                        to: "/login",
                                        children: "Go to login"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
var $182bfd81c46fadd7$export$2e2bcd8739ae039 = $182bfd81c46fadd7$var$ActivatePreparerAccount;



var $bb3TF = parcelRequire("bb3TF");





var $f47f5b5c04544533$export$2288cfe90701285e;
var $f47f5b5c04544533$export$9f31b671308a2114;
$f47f5b5c04544533$export$2288cfe90701285e = `jOTHVG_forgot-password-page`;
$f47f5b5c04544533$export$9f31b671308a2114 = `jOTHVG_forgot-password-wrapper`;


const { Text: $49b54f44f4976d66$var$Text, Title: $49b54f44f4976d66$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { useBreakpoint: $49b54f44f4976d66$var$useBreakpoint } = (0, $89d88a41b53d163f$export$2e2bcd8739ae039);
function $49b54f44f4976d66$var$ForgotPassword() {
    const screens = $49b54f44f4976d66$var$useBreakpoint();
    // graphql
    // mutation to create password reset
    const [createPasswordReset, { loading: loadingCreatePasswordReset }] = (0, $ebe2df5ae4e7ccaa$export$afbf6e0daaff4bf5)({
        onError: (err)=>{
            if (err.message === 'Error code 1001') (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('This email is not registered in the system. Please try another email.');
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message);
        },
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Password reset link sent.');
        }
    });
    const onFinish = async (values)=>{
        console.log('values: ', values);
        await createPasswordReset({
            variables: {
                email: values.email
            }
        });
    };
    const onFinishFailed = (errorInfo)=>{
        console.error('Failed:', errorInfo);
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Something went wrong.');
    };
    const cardWidth = (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? (0, $0316ae7d1654226a$export$b042f465f6c08a24)() * 0.95 : undefined;
    return (0, $bb3TF.jsx)("div", {
        className: $f47f5b5c04544533$export$2288cfe90701285e,
        children: (0, $bb3TF.jsx)("div", {
            className: $f47f5b5c04544533$export$9f31b671308a2114,
            children: (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                style: {
                    padding: screens.md ? '10px 80px' : '5px',
                    maxWidth: 900,
                    width: (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? '100%' : cardWidth
                },
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        style: {
                            margin: '0 0 60px 0'
                        },
                        children: (0, $bb3TF.jsx)((0, $1cbcb18aa67bf12c$export$2e2bcd8739ae039), {
                            width: "170",
                            height: "40"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        children: (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                            name: "Forgot Password",
                            layout: "vertical",
                            onFinish: onFinish,
                            onFinishFailed: onFinishFailed,
                            style: {
                                width: (0, $0316ae7d1654226a$export$7d9f9b4046392aed)() ? '100%' : undefined
                            },
                            children: [
                                (0, $bb3TF.jsxs)("div", {
                                    style: {
                                        textAlign: 'center',
                                        marginBottom: '20px'
                                    },
                                    children: [
                                        (0, $bb3TF.jsx)($49b54f44f4976d66$var$Title, {
                                            level: 3,
                                            children: "Forgot Your Password?"
                                        }),
                                        (0, $bb3TF.jsx)($49b54f44f4976d66$var$Text, {
                                            children: "Enter your email address below and we'll send you a secure reset link."
                                        })
                                    ]
                                }),
                                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    label: "Email",
                                    name: "email",
                                    rules: [
                                        {
                                            required: true,
                                            type: 'email',
                                            message: 'Please input a valid email!'
                                        }
                                    ],
                                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                        size: "large"
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                        type: "primary",
                                        htmlType: "submit",
                                        loading: loadingCreatePasswordReset,
                                        style: {
                                            width: '100%',
                                            justifyContent: 'center'
                                        },
                                        size: "large",
                                        children: "Request Password Reset"
                                    })
                                }),
                                (0, $bb3TF.jsxs)("div", {
                                    style: {
                                        textAlign: 'center'
                                    },
                                    children: [
                                        (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                                            to: "/login",
                                            children: "Back to login"
                                        }),
                                        (0, $bb3TF.jsxs)("p", {
                                            children: [
                                                "New to Taxaroo?",
                                                ' ',
                                                (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                                                    to: "/register",
                                                    children: "Create Account"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
var $49b54f44f4976d66$export$2e2bcd8739ae039 = $49b54f44f4976d66$var$ForgotPassword;


var $21c96e3ab60625be$export$2e2bcd8739ae039 = (0, $49b54f44f4976d66$export$2e2bcd8739ae039);



var $99b2ed209f63b653$export$2e2bcd8739ae039 = (0, $bc55ebad68166096$export$2e2bcd8739ae039);



var $bb3TF = parcelRequire("bb3TF");
parcelRequire("6fFrj");

var $bb3TF = parcelRequire("bb3TF");




var $6fFrj = parcelRequire("6fFrj");

var $bb3TF = parcelRequire("bb3TF");


var $9c3f9b2b182b5876$export$25e2314fd4de07ac;
var $9c3f9b2b182b5876$export$38e42c68cf43b5d4;
var $9c3f9b2b182b5876$export$db3c28d99448dcff;
var $9c3f9b2b182b5876$export$c713e2f9d13dd9ff;
var $9c3f9b2b182b5876$export$10304e08b2296fa9;
var $9c3f9b2b182b5876$export$4eb715cd1c502a11;
var $9c3f9b2b182b5876$export$11a325d2e1afdb5;
var $9c3f9b2b182b5876$export$744e831651d14191;
var $9c3f9b2b182b5876$export$3627041d21bec84d;
var $9c3f9b2b182b5876$export$2cedfd664bb3bd01;
$9c3f9b2b182b5876$export$25e2314fd4de07ac = `PhQ1Iq_checkboxIcon`;
$9c3f9b2b182b5876$export$38e42c68cf43b5d4 = `PhQ1Iq_header`;
$9c3f9b2b182b5876$export$db3c28d99448dcff = `PhQ1Iq_logo`;
$9c3f9b2b182b5876$export$c713e2f9d13dd9ff = `PhQ1Iq_registerFlowContainer`;
$9c3f9b2b182b5876$export$10304e08b2296fa9 = `PhQ1Iq_registerSectionCol`;
$9c3f9b2b182b5876$export$4eb715cd1c502a11 = `PhQ1Iq_registerTitle`;
$9c3f9b2b182b5876$export$11a325d2e1afdb5 = `PhQ1Iq_reverseOnSmall`;
$9c3f9b2b182b5876$export$744e831651d14191 = `PhQ1Iq_signInLink`;
$9c3f9b2b182b5876$export$3627041d21bec84d = `PhQ1Iq_signupContainer`;
$9c3f9b2b182b5876$export$2cedfd664bb3bd01 = `PhQ1Iq_textContainer`;


const { Title: $0bab2e8e179d4253$var$Title, Paragraph: $0bab2e8e179d4253$var$Paragraph } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { CheckCircleFilled: $0bab2e8e179d4253$var$CheckCircleFilled } = (0, $f62360d97c6e7e3d$export$2e2bcd8739ae039);
const $0bab2e8e179d4253$var$features = [
    'Effortless client onboarding',
    'Hassle-free invoicing & payments',
    'Secure IRS-compliant e-signatures',
    'Secure messaging (Chat, SMS & Video)',
    'Secure document portal with 256-bit encryption',
    'Seamless appointment scheduling',
    'Track performance and growth with analytics'
];
const $0bab2e8e179d4253$var$freeFeatures = [
    'Client Portal / Interviews',
    'Document Management',
    'Secure Communications',
    'Easy Payments ($10 per payment)',
    'Built-in Client Referral Program',
    'Save 47 minutes per return!'
];
const $0bab2e8e179d4253$var$FeaturesSection = ({ free: free = false })=>{
    const featuresList = free ? $0bab2e8e179d4253$var$freeFeatures : $0bab2e8e179d4253$var$features;
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsx)($0bab2e8e179d4253$var$Title, {
                level: 2,
                className: $9c3f9b2b182b5876$export$4eb715cd1c502a11,
                children: free ? "Boost Efficiency & Client Satisfaction \u2013 Free!" : 'REGISTRATION'
            }),
            free ? (0, $bb3TF.jsx)("p", {
                style: {
                    fontSize: 31
                },
                children: "Unleash your tax firm's potential and grow your business without spending a dime!"
            }) : (0, $bb3TF.jsxs)("p", {
                children: [
                    "Save",
                    ' ',
                    (0, $bb3TF.jsx)("span", {
                        style: {
                            color: '#0057A5'
                        },
                        children: "47 minutes"
                    }),
                    ' ',
                    "per return, increase productivity & delight your clients!"
                ]
            }),
            (0, $bb3TF.jsx)("ul", {
                children: featuresList.map((feature)=>(0, $bb3TF.jsxs)("li", {
                        children: [
                            (0, $bb3TF.jsx)($0bab2e8e179d4253$var$CheckCircleFilled, {
                                className: $9c3f9b2b182b5876$export$25e2314fd4de07ac
                            }),
                            ' ',
                            feature
                        ]
                    }, feature))
            }),
            (0, $bb3TF.jsxs)($0bab2e8e179d4253$var$Paragraph, {
                style: {
                    marginTop: 33
                },
                children: [
                    "Already Registered?",
                    ' ',
                    (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                        to: "/login",
                        style: {
                            color: '#0057A5',
                            textDecoration: 'underline'
                        },
                        children: "Login"
                    })
                ]
            })
        ]
    });
};
$0bab2e8e179d4253$var$FeaturesSection.defaultProps = {
    free: false
};
var $0bab2e8e179d4253$export$2e2bcd8739ae039 = $0bab2e8e179d4253$var$FeaturesSection;




var $bb3TF = parcelRequire("bb3TF");


var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");













const $71ad573b1913d00b$var$defaultOptions = {};
const $71ad573b1913d00b$export$fecb8f8f1eeedbbb = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation validateEmailAddress($email: String!) {
  validateEmailAddress(email: $email) {
    isFormatValid
    isMxFound
    isDisposable
    domainSuggestion
  }
}
    `;
function $71ad573b1913d00b$export$5efcce6b47dbd7de(baseOptions) {
    const options = {
        ...$71ad573b1913d00b$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($71ad573b1913d00b$export$fecb8f8f1eeedbbb, options);
}
const $71ad573b1913d00b$export$39ac829ab91f0716 = {
    Mutation: {
        validateEmailAddress: 'validateEmailAddress'
    }
};



const $0b8acd77f1b84d25$var$defaultOptions = {};
const $0b8acd77f1b84d25$export$aac1e4339d807cb3 = (0, $a6e2f431afb98ad4$export$72e4926bf8358653)`
    mutation upsertContact($syncContactInput: SyncContactInput!) {
  upsertContact(syncContactInput: $syncContactInput) {
    id
    firstName
    lastName
    email
  }
}
    `;
function $0b8acd77f1b84d25$export$d4cc22181bc0d39b(baseOptions) {
    const options = {
        ...$0b8acd77f1b84d25$var$defaultOptions,
        ...baseOptions
    };
    return $e23899b62b96dde3$export$609860bf8b0084c($0b8acd77f1b84d25$export$aac1e4339d807cb3, options);
}
const $0b8acd77f1b84d25$export$39ac829ab91f0716 = {
    Mutation: {
        upsertContact: 'upsertContact'
    }
};


var $66a72470aca965e3$export$c95979b960f4acea;
var $66a72470aca965e3$export$f562fd61c53bdcd9;
var $66a72470aca965e3$export$82e6205b15e6c637;
var $66a72470aca965e3$export$c091916f1530334c;
var $66a72470aca965e3$export$7fe2fed425e2b710;
var $66a72470aca965e3$export$b04ccebac0389b88;
var $66a72470aca965e3$export$a6270ac486415633;
var $66a72470aca965e3$export$74af9a7e94972b43;
var $66a72470aca965e3$export$3ef34f724465020e;
$66a72470aca965e3$export$c95979b960f4acea = `APtiGG_fade-in`;
$66a72470aca965e3$export$c95979b960f4acea;
$66a72470aca965e3$export$f562fd61c53bdcd9 = `APtiGG_fade-out`;
$66a72470aca965e3$export$f562fd61c53bdcd9;
$66a72470aca965e3$export$82e6205b15e6c637 = `APtiGG_fadeIn`;
$66a72470aca965e3$export$c091916f1530334c = `APtiGG_fadeOut`;
$66a72470aca965e3$export$7fe2fed425e2b710 = `APtiGG_registerButton`;
$66a72470aca965e3$export$b04ccebac0389b88 = `APtiGG_registerFormInput`;
$66a72470aca965e3$export$a6270ac486415633 = `APtiGG_registerFormItem`;
$66a72470aca965e3$export$74af9a7e94972b43 = `APtiGG_smsTerms`;
$66a72470aca965e3$export$3ef34f724465020e = `APtiGG_termsItem`;



const { useBreakpoint: $31a5b8fce93bc663$var$useBreakpoint } = (0, $89d88a41b53d163f$export$2e2bcd8739ae039);
function $31a5b8fce93bc663$var$RegisterForm({ free: free = false }) {
    const screens = $31a5b8fce93bc663$var$useBreakpoint();
    const navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const [form] = (0, $6ee812964d9db826$export$2e2bcd8739ae039).useForm();
    const [disabledNext, setDisabledNext] = (0, $6fFrj.useState)(true);
    const [loadingText, setLoadingText] = (0, $6fFrj.useState)('Hang tight while we create your account...');
    const [fadeOut, setFadeOut] = (0, $6fFrj.useState)(false);
    const [emailAddressesCache, setEmailAddressesCache] = (0, $6fFrj.useState)(new Map());
    const [searchParams] = (0, $a6e470ffbc8d2470$export$f1a78c17382fe22a)();
    const initialEmail = searchParams.get('email');
    const [registUser, { loading: registerLoading }] = (0, $43b72605a58be821$export$29f624c4457620bb)();
    const [upsertContactActiveCampaign] = (0, $0b8acd77f1b84d25$export$d4cc22181bc0d39b)();
    const { data: languageData } = (0, $e9d4d19cd26b2dae$export$f79bf1158a0f4b6a)();
    const { languages: languages } = languageData ?? {};
    const [validateEmail] = (0, $71ad573b1913d00b$export$5efcce6b47dbd7de)();
    const verifyEmailAddress = async (email)=>{
        const cachedValue = emailAddressesCache.get(email);
        if (cachedValue) return cachedValue;
        const result = await validateEmail({
            variables: {
                email: email
            }
        });
        if (result?.data?.validateEmailAddress) {
            setEmailAddressesCache((curr)=>curr.set(email, result.data.validateEmailAddress));
            return result.data.validateEmailAddress;
        }
        return null;
    };
    const validateEmailAddress = async (emailValue)=>{
        try {
            const result = await verifyEmailAddress(emailValue);
            if (result) {
                const errors = [];
                if (result.domainSuggestion) {
                    const emailName = emailValue.split('@')[0];
                    errors.push(`Did you mean ${emailName}@${result.domainSuggestion}?`);
                } else if (result.isDisposable) errors.push('Temporary email cannot be used');
                else if (!result.isFormatValid) errors.push('Format is not valid');
                else if (!result.isMxFound) errors.push('Domain is not exists');
                form.setFields([
                    {
                        name: 'email',
                        errors: errors
                    }
                ]);
            }
        } catch (err) {
            console.warn(err.message);
        }
    };
    (0, $6fFrj.useEffect)(()=>{
        if (registerLoading) {
            const timeouts = [];
            timeouts.push(setTimeout(()=>{
                setFadeOut(true); // Start fade out
                timeouts.push(setTimeout(()=>{
                    setLoadingText("Kangaroo's are fast, but optimizing your practice takes a moment...");
                    setFadeOut(false); // Fade in the new text
                }, 1000)); // this should be the length of your fade out
            }, 5000));
            timeouts.push(setTimeout(()=>{
                setFadeOut(true); // Start fade out
                timeouts.push(setTimeout(()=>{
                    setLoadingText('Just a hop away from completion...');
                    setFadeOut(false); // Fade in the new text
                }, 1000)); // this should be the length of your fade out
            }, 11000));
            return ()=>{
                timeouts.forEach(clearTimeout); // Clear all timeouts when the component unmounts
            };
        }
        return ()=>null;
    }, [
        registerLoading
    ]);
    const onSubmit = async (values)=>{
        const { firstName: firstName, lastName: lastName, phoneNumber: phoneNumber, email: email, password: password } = values;
        // validate email address before submit
        await validateEmailAddress(email);
        const emailErrors = form.getFieldError('email');
        if (emailErrors.length) return;
        // register
        try {
            const sessionEntity = (await registUser({
                variables: {
                    createUserInput: {
                        planId: free ? (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeFreePlanPriceId : (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039)?.stripeMonthlyPlanPriceId ?? undefined,
                        email: email,
                        password: password,
                        UserInformation: {
                            firstName: firstName,
                            lastName: lastName,
                            Phones: [
                                {
                                    value: phoneNumber,
                                    type: (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Mobile
                                }
                            ]
                        }
                    }
                },
                onCompleted: ()=>{
                    (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Your account was successfully created!');
                }
            })).data?.Register ?? {};
            if (sessionEntity.accessToken?.length) {
                const { accessToken: accessToken, UserFirmAccount: UserFirmAccount } = sessionEntity;
                const { FirmAccount: FirmAccount, Users: Users, Roles: Roles } = UserFirmAccount;
                const { businessType: businessType, Users: FirmUser, BusinessInformation: BusinessInformation } = FirmAccount;
                const { UserInformation: UserInformation } = Users;
                dispatch((0, $e3b9937a336ce5aa$export$b94982631f8f9752)({
                    accessToken: accessToken,
                    id: UserInformation?.id ?? '',
                    email: Users?.email ?? '',
                    userId: UserInformation?.userId ?? '',
                    userInformationId: UserInformation?.id ?? '',
                    firstName: UserInformation?.firstName ?? '',
                    lastName: UserInformation?.lastName ?? '',
                    birthday: UserInformation?.birthday ?? '',
                    ssn: UserInformation?.ssn ?? '',
                    profilePhoto: UserInformation?.profilePhoto ?? '',
                    firmAccountId: FirmAccount?.id ?? '',
                    languageId: Users?.languageId ?? '',
                    userRole: Roles?.description ?? '',
                    progressStatuses: [
                        ...FirmAccount.ProgressStatuses ?? []
                    ].map(({ id: statusId, status: status, underlyingStatus: underlyingStatus, index: index })=>({
                            status: status,
                            underlyingStatus: underlyingStatus,
                            index: index,
                            id: statusId
                        })),
                    firmName: FirmAccount.name ?? '',
                    firmAddress: '',
                    firmPhoneNumber: phoneNumber,
                    firmCreatedAt: FirmAccount.createAt ?? ''
                }));
                dispatch((0, $e3b9937a336ce5aa$export$d25bc3c2e588da99)({
                    languages: languages
                }));
                (0, $dfc6a33c14790f87$export$b3f6a57c0551730)(UserInformation?.userId, Users?.email, UserInformation?.firstName, UserInformation?.lastName, Roles?.description, FirmAccount?.id);
                navigate('/onboarding');
            }
        } catch (error) {
            if (error.message && error.message === 'Error code 1002') (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('The user with this email is already registered. Please try another email.');
            else if (error.message && error.message === 'Error code 1005') (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Password does not meet the requirements. Please use a stronger password.', 7);
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(error.message ?? 'Something went wrong while trying to regist the user');
        }
    };
    // use this to disable the submit button until all fields are filled
    // const handleFormChange = (target) => {
    //   const [{ name: [name], value }] = target;
    //   const hasErrors = form.getFieldsError().some(({ errors }) => errors?.length);
    //   const currentFirstName = form.getFieldValue('firstName');
    //   const currentLastName = form.getFieldValue('lastName');
    //   const currentPhoneNumber = form.getFieldValue('phoneNumber');
    //   const currentEmail = form.getFieldValue('email');
    //   const currentPassword = form.getFieldValue('password');
    //   const currentConfirmPassword = form.getFieldValue('confirmPassword');
    //   const noValues = [
    //     currentFirstName,
    //     currentLastName,
    //     currentPhoneNumber,
    //     currentEmail,
    //     currentPassword,
    //     currentConfirmPassword,
    //   ].filter(
    //     (fieldValue) => (typeof fieldValue === 'string' && !fieldValue?.length) || (typeof fieldValue === 'object' && !fieldValue),
    //   );
    //   setDisabledNext(hasErrors || noValues?.length > 0);
    // };
    const sendUserToActiveCampaign = async ()=>{
        try {
            const firstName = form.getFieldValue('firstName');
            const lastName = form.getFieldValue('lastName');
            const email = form.getFieldValue('email');
            const phone = form.getFieldValue('phoneNumber');
            if (firstName && lastName && email) await upsertContactActiveCampaign({
                variables: {
                    syncContactInput: {
                        firstName: firstName,
                        lastName: lastName,
                        email: email,
                        phone: phone,
                        tag: '146'
                    }
                }
            });
        } catch (err) {
            console.warn(err);
        }
    };
    const handleEmailBlur = async ()=>{
        const emailErrors = form.getFieldError('email');
        if (emailErrors.length) return;
        const emailValue = form.getFieldValue('email');
        if (emailValue) {
            await validateEmailAddress(emailValue);
            const newEmailErrors = form.getFieldError('email');
            if (!newEmailErrors.length) await sendUserToActiveCampaign();
        }
    };
    const handlePhoneBlur = async ()=>{
        const phoneErrors = form.getFieldError('phoneNumber');
        if (phoneErrors.length) return;
        const phoneValue = form.getFieldValue('phoneNumber');
        if (phoneValue) await sendUserToActiveCampaign();
    };
    return (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
        children: [
            (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                style: {
                    width: '100%'
                },
                layout: "vertical",
                form: form,
                initialValues: {
                    email: initialEmail || ''
                },
                onFinish: onSubmit,
                // onFieldsChange={handleFormChange}
                // eslint-disable-next-line no-template-curly-in-string
                validateMessages: {
                    required: '${label} is required'
                },
                className: "registerForm",
                children: [
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        gutter: 20,
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: 24,
                                md: 12,
                                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "firstName",
                                    label: "First Name",
                                    rules: [
                                        {
                                            required: true
                                        }
                                    ],
                                    className: $66a72470aca965e3$export$a6270ac486415633,
                                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                        autoComplete: "given-name",
                                        type: "white",
                                        placeholder: "Enter First name ...",
                                        size: "large"
                                    }, "first-name-input")
                                }, "first-name")
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: 24,
                                md: 12,
                                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "lastName",
                                    label: "Last Name",
                                    rules: [
                                        {
                                            required: true
                                        }
                                    ],
                                    className: $66a72470aca965e3$export$a6270ac486415633,
                                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                                        autoComplete: "family-name",
                                        type: "white",
                                        placeholder: "Enter Last name ...",
                                        size: "large"
                                    })
                                }, "last-name")
                            })
                        ]
                    }),
                    (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                        name: "email",
                        label: "Email",
                        rules: [
                            {
                                required: true,
                                message: 'Email is required'
                            },
                            {
                                type: 'email',
                                message: 'Invalid email'
                            }
                        ],
                        className: $66a72470aca965e3$export$a6270ac486415633,
                        style: {
                            display: initialEmail ? 'none' : 'block'
                        },
                        children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039), {
                            autoComplete: "email",
                            placeholder: "Enter Email ...",
                            size: "large",
                            type: "white",
                            onBlur: handleEmailBlur
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                        className: $66a72470aca965e3$export$a6270ac486415633,
                        style: {
                            flex: 1
                        },
                        name: "phoneNumber",
                        label: "Mobile Number",
                        rules: [
                            {
                                required: true
                            }
                        ],
                        children: (0, $bb3TF.jsx)((0, $5ba7d8eeafddcf67$export$2e2bcd8739ae039), {
                            // style={{ background: '#FFFFFF !important' }}
                            color: "white",
                            size: "large",
                            placeholder: "Enter Mobile Number ...",
                            onBlur: handlePhoneBlur
                        })
                    }, "phone-number"),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        gutter: 20,
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: 24,
                                md: 12,
                                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "password",
                                    label: "Create Password",
                                    rules: [
                                        {
                                            required: true,
                                            message: 'The password is required'
                                        }
                                    ],
                                    className: $66a72470aca965e3$export$a6270ac486415633,
                                    children: (0, $bb3TF.jsx)("div", {
                                        children: (0, $bb3TF.jsx)((0, $1e9efe4b9b95edaa$export$2e2bcd8739ae039), {})
                                    })
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: 24,
                                md: 12,
                                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "confirmPassword",
                                    label: "Confirm Password",
                                    dependencies: [
                                        'password'
                                    ],
                                    rules: [
                                        {
                                            required: true
                                        },
                                        ({ getFieldValue: getFieldValue })=>({
                                                validator (_, value) {
                                                    if (!value || getFieldValue('password') === value) return Promise.resolve();
                                                    return Promise.reject(new Error('The two passwords that you entered do not match!'));
                                                }
                                            })
                                    ],
                                    className: $66a72470aca965e3$export$a6270ac486415633,
                                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039).Password, {
                                        autoComplete: "new-password",
                                        type: "white",
                                        style: {
                                            fontSize: '14px !important'
                                        },
                                        placeholder: "Enter Confirm Password ...",
                                        size: "large"
                                    })
                                })
                            })
                        ]
                    }),
                    (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                        name: "terms",
                        valuePropName: "checked",
                        rules: [
                            {
                                required: true,
                                message: 'Please agree to the terms and conditions'
                            }
                        ],
                        className: $66a72470aca965e3$export$a6270ac486415633,
                        children: (0, $bb3TF.jsx)((0, $66ef76fa6be8ca1a$export$2e2bcd8739ae039), {
                            children: (0, $bb3TF.jsxs)("span", {
                                className: $66a72470aca965e3$export$3ef34f724465020e,
                                children: [
                                    "I agree to the",
                                    ' ',
                                    (0, $bb3TF.jsx)("a", {
                                        href: "https://taxaroo.com/terms-of-use",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "Terms & Conditions"
                                    }),
                                    ' ',
                                    "and",
                                    ' ',
                                    (0, $bb3TF.jsx)("a", {
                                        href: "https://taxaroo.com/privacy",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "Privacy Policy"
                                    }),
                                    "."
                                ]
                            })
                        })
                    }),
                    (0, $bb3TF.jsx)("p", {
                        className: $66a72470aca965e3$export$74af9a7e94972b43,
                        children: "By submitting this form, you consent to receive SMS messages and/or emails from Taxaroo. Message frequency varies. To unsubscribe, follow the instructions provided in our communications. Msg & data rates may apply for SMS. Your information is secure and will not be sold to third parties. Text HELP for help. Text STOP to cancel."
                    }),
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        gutter: [
                            10,
                            10
                        ],
                        justify: "space-between",
                        style: {
                            marginTop: screens.md ? 15 : 0
                        },
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: 14,
                                    margin: '0 auto',
                                    display: 'flex'
                                },
                                children: (0, $bb3TF.jsxs)("p", {
                                    style: {
                                        alignSelf: 'center',
                                        margin: '0 auto'
                                    },
                                    children: [
                                        free ? 'Subscribe for free.' : 'Get started risk free.',
                                        ' ',
                                        (0, $bb3TF.jsx)("span", {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: "No credit card required!"
                                        })
                                    ]
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                style: {
                                    margin: '0 auto'
                                },
                                children: (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    style: {
                                        marginBottom: 0
                                    },
                                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                        type: "primary",
                                        size: "large",
                                        loading: registerLoading,
                                        htmlType: "submit",
                                        // icon={<RightOutlined />}
                                        className: $66a72470aca965e3$export$7fe2fed425e2b710,
                                        children: free ? 'Get Started' : 'Try now'
                                    })
                                })
                            })
                        ]
                    })
                ]
            }, "register-flow"),
            (0, $bb3TF.jsxs)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
                visible: registerLoading,
                closable: false,
                footer: null,
                width: 500,
                bodyStyle: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '50px 0'
                },
                okButtonProps: {
                    style: {
                        display: 'none'
                    }
                },
                children: [
                    (0, $bb3TF.jsx)((0, $53a209758b3184a9$export$2e2bcd8739ae039), {
                        size: "calc(30vh)",
                        type: "icon",
                        id: "billing_portal_redirect",
                        speed: 1.3
                    }),
                    (0, $bb3TF.jsx)("h3", {
                        style: {
                            marginTop: 20,
                            textAlign: 'center'
                        },
                        className: fadeOut ? $66a72470aca965e3$export$c091916f1530334c : $66a72470aca965e3$export$82e6205b15e6c637,
                        children: loadingText
                    })
                ]
            })
        ]
    });
}
$31a5b8fce93bc663$var$RegisterForm.defaultProps = {
    free: false
};
var $31a5b8fce93bc663$export$2e2bcd8739ae039 = $31a5b8fce93bc663$var$RegisterForm;



const { Title: $28cd675f288ee5e2$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const $28cd675f288ee5e2$var$RegisterSection = ({ free: free = false })=>{
    const title = free ? 'Unlock Your Free Taxaroo Experience' : 'Start Your Taxaroo 7-day Free Trial';
    return (0, $bb3TF.jsx)("div", {
        className: `showScrollbar ${$9c3f9b2b182b5876$export$c713e2f9d13dd9ff}`,
        children: (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
            justify: "center",
            style: {
                flex: 1,
                marginTop: -5
            },
            children: [
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "center",
                    style: {
                        marginBottom: 20
                    },
                    children: (0, $bb3TF.jsx)($28cd675f288ee5e2$var$Title, {
                        level: 3,
                        children: title
                    })
                }),
                (0, $bb3TF.jsx)((0, $31a5b8fce93bc663$export$2e2bcd8739ae039), {
                    free: free
                })
            ]
        })
    });
};
$28cd675f288ee5e2$var$RegisterSection.defaultProps = {
    free: false
};
var $28cd675f288ee5e2$export$2e2bcd8739ae039 = $28cd675f288ee5e2$var$RegisterSection;


const { Header: $127fc73a00dddfa7$var$Header } = (0, $0102c485edc5bdcf$export$2e2bcd8739ae039);
const $127fc73a00dddfa7$var$RegisterTemplate = ({ free: free = false })=>{
    (0, $6fFrj.useEffect)(()=>{
        // destroy current help scout beacon and init the one starting on ask question
        window.Beacon('destroy');
        window.Beacon('init', '1749d000-7e8f-4fba-99fe-bf37ed9faed7');
        return ()=>{
            // destroy current help scout beacon and init the one starting on answers
            window.Beacon('destroy');
            window.Beacon('init', 'd3ee6f02-27a3-424d-832f-c3755284928e');
        };
    }, []);
    return (0, $bb3TF.jsxs)((0, $0102c485edc5bdcf$export$2e2bcd8739ae039), {
        children: [
            (0, $bb3TF.jsxs)($127fc73a00dddfa7$var$Header, {
                className: [
                    $9c3f9b2b182b5876$export$38e42c68cf43b5d4,
                    'elevated'
                ],
                children: [
                    (0, $bb3TF.jsx)((0, $1cbcb18aa67bf12c$export$2e2bcd8739ae039), {
                        className: $9c3f9b2b182b5876$export$db3c28d99448dcff
                    }),
                    (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                        to: "/login",
                        className: $9c3f9b2b182b5876$export$744e831651d14191,
                        children: "Sign In"
                    })
                ]
            }),
            (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                justify: "center",
                className: $9c3f9b2b182b5876$export$3627041d21bec84d,
                children: [
                    (0, $bb3TF.jsxs)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        gutter: {
                            xs: 0,
                            lg: 100
                        },
                        className: $9c3f9b2b182b5876$export$11a325d2e1afdb5,
                        children: [
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: 24,
                                xl: 12,
                                className: $9c3f9b2b182b5876$export$2cedfd664bb3bd01,
                                children: (0, $bb3TF.jsx)((0, $0bab2e8e179d4253$export$2e2bcd8739ae039), {
                                    free: free
                                })
                            }),
                            (0, $bb3TF.jsx)((0, $b72d204d9844548f$export$2e2bcd8739ae039), {
                                span: 24,
                                xl: 12,
                                className: $9c3f9b2b182b5876$export$10304e08b2296fa9,
                                children: (0, $bb3TF.jsx)((0, $28cd675f288ee5e2$export$2e2bcd8739ae039), {
                                    free: free
                                })
                            })
                        ]
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        style: {
                            marginTop: 60
                        },
                        children: (0, $bb3TF.jsxs)("p", {
                            style: {
                                textAlign: 'center'
                            },
                            children: [
                                (0, $bb3TF.jsx)("a", {
                                    style: {
                                        color: 'inherit'
                                    },
                                    href: "https://taxaroo.com/privacy",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Privacy Policy"
                                }),
                                ' ',
                                "|",
                                ' ',
                                (0, $bb3TF.jsx)("a", {
                                    style: {
                                        color: 'inherit'
                                    },
                                    href: "https://taxaroo.com//terms-of-use",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Terms of Service"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
$127fc73a00dddfa7$var$RegisterTemplate.defaultProps = {
    free: false
};
var $127fc73a00dddfa7$export$2e2bcd8739ae039 = $127fc73a00dddfa7$var$RegisterTemplate;


const $b9dd44a2cb3e46a1$var$RegisterPage = ({ free: free = false })=>(0, $bb3TF.jsx)((0, $127fc73a00dddfa7$export$2e2bcd8739ae039), {
        free: free
    });
$b9dd44a2cb3e46a1$var$RegisterPage.defaultProps = {
    free: false
};
var $b9dd44a2cb3e46a1$export$2e2bcd8739ae039 = $b9dd44a2cb3e46a1$var$RegisterPage;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");






var $b4d2398b06a77a06$export$59d8e192567db219;
var $b4d2398b06a77a06$export$98af52169a004230;
$b4d2398b06a77a06$export$59d8e192567db219 = `JfMHtG_reset-password-page`;
$b4d2398b06a77a06$export$98af52169a004230 = `JfMHtG_reset-password-wrapper`;


const { Text: $2898b6db5f1054c5$var$Text, Title: $2898b6db5f1054c5$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { useBreakpoint: $2898b6db5f1054c5$var$useBreakpoint } = (0, $89d88a41b53d163f$export$2e2bcd8739ae039);
function $2898b6db5f1054c5$var$ResetPassword() {
    const [error, setError] = (0, $6fFrj.useState)(null);
    const screens = $2898b6db5f1054c5$var$useBreakpoint();
    const navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    const { id: id } = (0, $990f835fb2356f36$export$99eaa27ddbbb95ef)();
    const baseUrl = window.location.origin;
    // graphql
    // fetch user and firm name by PasswordResetId
    const { data: data, loading: loadingPasswordReset } = (0, $fa09d5b22c557d9e$export$80f4c7ddb3ba32ae)({
        variables: {
            id: id
        },
        onError: (err)=>{
            if (err.message.includes('1001')) setError('CannotFindRecordException');
            else if (err.message.includes('4002')) setError('PasswordResetExpiredException');
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message);
        },
        onCompleted: ()=>{
            setError(null);
        }
    });
    const { Users: Users } = data?.passwordResetIncludeFirm || {};
    const { email: email } = Users || {};
    // mutation to reset password
    const [resetPassword, { loading: loadingResetPassword }] = (0, $ebe2df5ae4e7ccaa$export$3177acf383c684f6)({
        onError: (err)=>{
            if (err.message.includes('1005')) (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Password doesn\'t meet the requirements.');
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message);
        },
        onCompleted: ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Password reset. Please login.', 10);
            setTimeout(()=>{
                navigate('/login');
            }, 300);
        }
    });
    const onFinish = (values)=>{
        resetPassword({
            variables: {
                resetPasswordInput: {
                    uuid: id,
                    password: values.the_pass,
                    passwordConfirmation: values.the_confirm_pass
                }
            }
        });
    };
    const onFinishFailed = (errorInfo)=>{
        console.error('Failed:', errorInfo);
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Account activation failed.');
    };
    if (error) return (0, $bb3TF.jsx)("div", {
        className: $b4d2398b06a77a06$export$59d8e192567db219,
        children: (0, $bb3TF.jsx)("div", {
            className: $b4d2398b06a77a06$export$98af52169a004230,
            children: (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                style: {
                    padding: screens.md ? '10px 80px' : '5px',
                    maxWidth: '900px'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        style: {
                            margin: '0 0 60px 0'
                        },
                        children: (0, $bb3TF.jsx)((0, $1cbcb18aa67bf12c$export$2e2bcd8739ae039), {
                            width: "170",
                            height: "40"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        children: (0, $bb3TF.jsxs)("div", {
                            style: {
                                textAlign: 'center',
                                marginBottom: '20px'
                            },
                            children: [
                                (0, $bb3TF.jsx)($2898b6db5f1054c5$var$Title, {
                                    level: 3,
                                    children: "Reset Your Password"
                                }),
                                error === 'CannotFindRecordException' && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                                    type: "error",
                                    showIcon: true,
                                    message: "Record could not be found.",
                                    description: "This could be becuase you have already reset your password. Try logging in, or requesting a password reset again.",
                                    style: {
                                        marginTop: '40px',
                                        maxWidth: '500px'
                                    }
                                }),
                                error === 'PasswordResetExpiredException' && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                                    type: "error",
                                    showIcon: true,
                                    message: "This link has expired.",
                                    description: "Please request a new link to reset your password.",
                                    style: {
                                        marginTop: '40px'
                                    }
                                })
                            ]
                        })
                    }),
                    (0, $bb3TF.jsx)("div", {
                        style: {
                            textAlign: 'center'
                        },
                        children: (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                            to: "/login",
                            children: "Go to login"
                        })
                    })
                ]
            })
        })
    });
    return (0, $bb3TF.jsx)("div", {
        className: $b4d2398b06a77a06$export$59d8e192567db219,
        children: (0, $bb3TF.jsx)("div", {
            className: $b4d2398b06a77a06$export$98af52169a004230,
            children: (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                style: {
                    padding: screens.md ? '10px 80px' : '5px',
                    maxWidth: '900px'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        style: {
                            margin: '0 0 60px 0'
                        },
                        children: (0, $bb3TF.jsx)((0, $1cbcb18aa67bf12c$export$2e2bcd8739ae039), {
                            width: "170",
                            height: "40"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        children: (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                            name: "Reset Password",
                            layout: "vertical",
                            onFinish: onFinish,
                            onFinishFailed: onFinishFailed,
                            children: [
                                (0, $bb3TF.jsxs)("div", {
                                    style: {
                                        textAlign: 'center',
                                        marginBottom: '20px'
                                    },
                                    children: [
                                        (0, $bb3TF.jsx)($2898b6db5f1054c5$var$Title, {
                                            level: 3,
                                            children: "Reset Your Password"
                                        }),
                                        loadingPasswordReset ? (0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039), {
                                            paragraph: {
                                                rows: 2,
                                                width: 500
                                            },
                                            style: {
                                                marginTop: 40
                                            }
                                        }) : (0, $bb3TF.jsx)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                                            direction: "vertical",
                                            children: (0, $bb3TF.jsxs)($2898b6db5f1054c5$var$Text, {
                                                children: [
                                                    "In the future you can sign in directly at",
                                                    (0, $bb3TF.jsxs)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                                                        to: `${baseUrl}/login`,
                                                        children: [
                                                            ' ',
                                                            baseUrl,
                                                            "/login"
                                                        ]
                                                    }),
                                                    ' ',
                                                    "with the email address",
                                                    ' ',
                                                    (0, $bb3TF.jsx)("b", {
                                                        children: email
                                                    }),
                                                    "."
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "the_pass",
                                    label: "Password",
                                    rules: [
                                        {
                                            required: true,
                                            message: 'The password is required'
                                        }
                                    ],
                                    children: (0, $bb3TF.jsx)("div", {
                                        children: (0, $bb3TF.jsx)((0, $1e9efe4b9b95edaa$export$2e2bcd8739ae039), {
                                            tooltipProps: {
                                                placement: 'topLeft'
                                            }
                                        })
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "the_confirm_pass",
                                    label: "Confirm Password",
                                    dependencies: [
                                        'the_pass'
                                    ],
                                    rules: [
                                        {
                                            required: true,
                                            message: 'The password confirmation is required'
                                        },
                                        ({ getFieldValue: getFieldValue })=>({
                                                validator (_, value) {
                                                    if (!value || getFieldValue('the_pass') === value) return Promise.resolve();
                                                    return Promise.reject(new Error('The two passwords that you entered do not match!'));
                                                }
                                            })
                                    ],
                                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039).Password, {
                                        autoComplete: "disabled",
                                        placeholder: "Confirm Password"
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                        type: "primary",
                                        htmlType: "submit",
                                        loading: loadingResetPassword,
                                        style: {
                                            width: '100%',
                                            justifyContent: 'center'
                                        },
                                        size: "large",
                                        children: "Reset Your Password"
                                    })
                                }),
                                (0, $bb3TF.jsx)("div", {
                                    style: {
                                        textAlign: 'center'
                                    },
                                    children: (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                                        to: "/login",
                                        children: "Go to login"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
var $2898b6db5f1054c5$export$2e2bcd8739ae039 = $2898b6db5f1054c5$var$ResetPassword;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");










var $5da34c70123dbb3a$export$9142f086d48553b0;
var $5da34c70123dbb3a$export$6d9e59725930d31e;
$5da34c70123dbb3a$export$9142f086d48553b0 = `aK-Tkq_activate-account-page`;
$5da34c70123dbb3a$export$6d9e59725930d31e = `aK-Tkq_activate-account-wrapper`;


const { Text: $9d0d672d9619ae43$var$Text, Title: $9d0d672d9619ae43$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
const { useBreakpoint: $9d0d672d9619ae43$var$useBreakpoint } = (0, $89d88a41b53d163f$export$2e2bcd8739ae039);
const $9d0d672d9619ae43$var$getFirmAddress = (businessType, { User: User, BusinessInformation: BusinessInformation })=>{
    if (businessType === 'INDIVIDUAL') {
        const [Address] = User.UserInformation.Address.filter(({ type: type })=>type === 'PERSONAL');
        if (Address) {
            const { lineOne: lineOne, lineTwo: lineTwo, city: city, state: state, zip: zip } = Address;
            return `${lineOne ?? ''}, ${lineTwo ?? ''} ${city}, ${state} ${zip}`;
        }
    }
    const [Address] = BusinessInformation?.Address.filter(({ type: type })=>type === 'BUSINESS') ?? [];
    if (Address) {
        const { lineOne: lineOne, lineTwo: lineTwo, city: city, state: state, zip: zip } = Address;
        return `${lineOne ?? ''}, ${lineTwo ?? ''} ${city}, ${state} ${zip}`;
    }
    return '';
};
const $9d0d672d9619ae43$var$getFirmPhoneNumber = (businessType, { User: User, BusinessInformation: BusinessInformation })=>{
    if (businessType === 'INDIVIDUAL') {
        const [Phone] = User.UserInformation.Phones.filter(({ type: type })=>type === 'PERSONAL');
        if (Phone) {
            const { value: value } = Phone;
            return value ?? '';
        }
        return '';
    }
    const [Phone] = BusinessInformation.Phones.filter(({ type: type })=>type === 'OFFICE');
    if (Phone) {
        const { value: value } = Phone;
        return value ?? '';
    }
    return '';
};
function $9d0d672d9619ae43$var$ActivateAccount() {
    const [error, setError] = (0, $6fFrj.useState)(null);
    const [finalPassword, setFinalPassword] = (0, $6fFrj.useState)('');
    const screens = $9d0d672d9619ae43$var$useBreakpoint();
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    const { id: id } = (0, $990f835fb2356f36$export$99eaa27ddbbb95ef)();
    const baseUrl = window.location.origin;
    // graphql
    const [getLanguages] = (0, $e9d4d19cd26b2dae$export$5d4e05e09dcdd3b7)();
    const [login, { loading: loadingLogin }] = (0, $7e016fc573eed7c4$export$cddfb6c1bfa4d45f)();
    // fetch user and firm name by PasswordResetId
    const { data: data, loading: loadingPasswordReset } = (0, $fa09d5b22c557d9e$export$80f4c7ddb3ba32ae)({
        variables: {
            id: id
        },
        onError: (err)=>{
            if (err.message.includes('1001')) setError('CannotFindRecordException');
            else if (err.message.includes('4002')) setError('PasswordResetExpiredException');
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message);
        },
        onCompleted: ()=>{
            setError(null);
        }
    });
    const { Users: Users } = data?.passwordResetIncludeFirm || {};
    const { email: email, UserFirmAccount: UserFirmAccount } = Users || {};
    const firmName = UserFirmAccount?.length === 1 ? UserFirmAccount[0].FirmAccount.name : null;
    // mutation to reset password
    const [resetPassword, { loading: loadingActivatingAccount }] = (0, $ebe2df5ae4e7ccaa$export$eb9aaa555dd41628)({
        onError: (err)=>{
            if (err.message.includes('1005')) (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Password doesn\'t meet the requirements.');
            else (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message);
        },
        onCompleted: async ()=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).success('Account activated.', 10);
            const languagesResult = await getLanguages();
            const { languages: languages } = languagesResult.data;
            const loginResult = (await login({
                variables: {
                    loginInput: {
                        email: email,
                        password: finalPassword
                    }
                }
            })).data?.Login ?? {};
            if (loginResult.accessToken?.length) {
                const { accessToken: accessToken, UserFirmAccount: loginResultUserFirmAccount } = loginResult;
                const { FirmAccount: FirmAccount, Users: loginResultUsers, Roles: Roles } = loginResultUserFirmAccount;
                const { businessType: businessType, Users: FirmUser, BusinessInformation: BusinessInformation } = FirmAccount;
                const { UserInformation: UserInformation } = loginResultUsers;
                dispatch((0, $e3b9937a336ce5aa$export$b94982631f8f9752)({
                    accessToken: accessToken,
                    id: UserInformation?.id ?? '',
                    email: loginResultUsers?.email ?? '',
                    userId: UserInformation?.userId ?? '',
                    userInformationId: UserInformation?.id ?? '',
                    firstName: UserInformation?.firstName ?? '',
                    lastName: UserInformation?.lastName ?? '',
                    birthday: UserInformation?.birthday ?? '',
                    ssn: UserInformation?.ssn ?? '',
                    profilePhoto: UserInformation?.profilePhoto ?? '',
                    firmAccountId: FirmAccount?.id ?? '',
                    languageId: loginResultUsers?.languageId ?? '',
                    userRole: Roles?.description ?? '',
                    progressStatuses: [
                        ...FirmAccount.ProgressStatuses ?? []
                    ].map(({ id: statusId, status: status, underlyingStatus: underlyingStatus, index: index })=>({
                            status: status,
                            underlyingStatus: underlyingStatus,
                            index: index,
                            id: statusId
                        })),
                    firmName: FirmAccount.name ?? '',
                    firmAddress: $9d0d672d9619ae43$var$getFirmAddress(businessType, {
                        User: FirmUser,
                        BusinessInformation: BusinessInformation
                    }),
                    firmPhoneNumber: $9d0d672d9619ae43$var$getFirmPhoneNumber(businessType, {
                        User: FirmUser,
                        BusinessInformation: BusinessInformation
                    }),
                    firmCreatedAt: FirmAccount.createAt ?? ''
                }));
                dispatch((0, $e3b9937a336ce5aa$export$d25bc3c2e588da99)({
                    languages: languages
                }));
                navigate('/onboarding');
            }
        }
    });
    const onFinish = (values)=>{
        resetPassword({
            variables: {
                activateClientInput: {
                    uuid: id,
                    password: values.the_pass,
                    passwordConfirmation: values.the_confirm_pass
                }
            }
        });
        setFinalPassword(values.the_pass);
    };
    const onFinishFailed = (errorInfo)=>{
        console.error('Failed:', errorInfo);
        (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Account activation failed.');
    };
    if (error) return (0, $bb3TF.jsx)("div", {
        className: $5da34c70123dbb3a$export$9142f086d48553b0,
        children: (0, $bb3TF.jsx)("div", {
            className: $5da34c70123dbb3a$export$6d9e59725930d31e,
            children: (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                style: {
                    padding: screens.md ? '10px 80px' : '5px',
                    maxWidth: '900px'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        style: {
                            margin: '0 0 60px 0'
                        },
                        children: (0, $bb3TF.jsx)((0, $1cbcb18aa67bf12c$export$2e2bcd8739ae039), {
                            width: "170",
                            height: "40"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        children: (0, $bb3TF.jsxs)("div", {
                            style: {
                                textAlign: 'center',
                                marginBottom: '20px'
                            },
                            children: [
                                (0, $bb3TF.jsx)($9d0d672d9619ae43$var$Title, {
                                    level: 3,
                                    children: "Activate Your Account"
                                }),
                                error === 'CannotFindRecordException' && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                                    type: "error",
                                    showIcon: true,
                                    message: "Record could not be found.",
                                    description: "This could be becuase you have already activated your account. To update your password please select forgot password from the login screen.",
                                    style: {
                                        marginTop: '40px',
                                        maxWidth: '500px'
                                    }
                                }),
                                error === 'PasswordResetExpiredException' && (0, $bb3TF.jsx)((0, $a2607640c59659c0$export$2e2bcd8739ae039), {
                                    type: "error",
                                    showIcon: true,
                                    message: "This link has expired.",
                                    description: "Please request a new link from your firm admin.",
                                    style: {
                                        marginTop: '40px'
                                    }
                                })
                            ]
                        })
                    }),
                    (0, $bb3TF.jsx)("div", {
                        style: {
                            textAlign: 'center'
                        },
                        children: (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                            to: "/login",
                            children: "Go to login"
                        })
                    })
                ]
            })
        })
    });
    return (0, $bb3TF.jsx)("div", {
        className: $5da34c70123dbb3a$export$9142f086d48553b0,
        children: (0, $bb3TF.jsx)("div", {
            className: $5da34c70123dbb3a$export$6d9e59725930d31e,
            children: (0, $bb3TF.jsxs)((0, $5e9046d6437d332e$export$2e2bcd8739ae039), {
                style: {
                    padding: screens.md ? '10px 80px' : '5px',
                    maxWidth: '900px'
                },
                children: [
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        style: {
                            margin: '0 0 60px 0'
                        },
                        children: (0, $bb3TF.jsx)((0, $1cbcb18aa67bf12c$export$2e2bcd8739ae039), {
                            width: "170",
                            height: "40"
                        })
                    }),
                    (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                        justify: "center",
                        children: (0, $bb3TF.jsxs)((0, $6ee812964d9db826$export$2e2bcd8739ae039), {
                            name: "Activate Account",
                            layout: "vertical",
                            onFinish: onFinish,
                            onFinishFailed: onFinishFailed,
                            children: [
                                (0, $bb3TF.jsxs)("div", {
                                    style: {
                                        textAlign: 'center',
                                        marginBottom: '20px'
                                    },
                                    children: [
                                        (0, $bb3TF.jsx)($9d0d672d9619ae43$var$Title, {
                                            level: 3,
                                            children: "Activate Your Account"
                                        }),
                                        loadingPasswordReset ? (0, $bb3TF.jsx)((0, $6277e5722f665338$export$2e2bcd8739ae039), {
                                            paragraph: {
                                                rows: 2,
                                                width: 500
                                            },
                                            style: {
                                                marginTop: 40
                                            }
                                        }) : (0, $bb3TF.jsxs)((0, $4563a45a032814da$export$2e2bcd8739ae039), {
                                            direction: "vertical",
                                            children: [
                                                firmName && (0, $bb3TF.jsx)($9d0d672d9619ae43$var$Text, {
                                                    children: (0, $bb3TF.jsx)("b", {
                                                        children: firmName
                                                    })
                                                }),
                                                (0, $bb3TF.jsxs)($9d0d672d9619ae43$var$Text, {
                                                    children: [
                                                        "To get started, please create a password below.",
                                                        (0, $bb3TF.jsx)("br", {}),
                                                        "In the future you can sign in directly at",
                                                        (0, $bb3TF.jsxs)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                                                            to: `${baseUrl}/login`,
                                                            children: [
                                                                ' ',
                                                                baseUrl,
                                                                "/login"
                                                            ]
                                                        }),
                                                        ' ',
                                                        "with the email address",
                                                        ' ',
                                                        (0, $bb3TF.jsx)("b", {
                                                            children: email
                                                        }),
                                                        "."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "the_pass",
                                    label: "Password",
                                    rules: [
                                        {
                                            required: true,
                                            message: 'The password is required'
                                        }
                                    ],
                                    children: (0, $bb3TF.jsx)("div", {
                                        children: (0, $bb3TF.jsx)((0, $1e9efe4b9b95edaa$export$2e2bcd8739ae039), {
                                            tooltipProps: {
                                                placement: 'topLeft'
                                            }
                                        })
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    name: "the_confirm_pass",
                                    label: "Confirm Password",
                                    dependencies: [
                                        'the_pass'
                                    ],
                                    rules: [
                                        {
                                            required: true
                                        },
                                        ({ getFieldValue: getFieldValue })=>({
                                                validator (_, value) {
                                                    if (!value || getFieldValue('the_pass') === value) return Promise.resolve();
                                                    return Promise.reject(new Error('The two passwords that you entered do not match!'));
                                                }
                                            })
                                    ],
                                    children: (0, $bb3TF.jsx)((0, $1fb834916a156dcf$export$2e2bcd8739ae039).Password, {
                                        autoComplete: "disabled",
                                        placeholder: "Confirm Password"
                                    })
                                }),
                                (0, $bb3TF.jsx)((0, $6ee812964d9db826$export$2e2bcd8739ae039).Item, {
                                    children: (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                                        type: "primary",
                                        htmlType: "submit",
                                        loading: loadingActivatingAccount,
                                        style: {
                                            width: '100%',
                                            justifyContent: 'center'
                                        },
                                        size: "large",
                                        children: "Activate Your Account"
                                    })
                                }),
                                (0, $bb3TF.jsx)("div", {
                                    style: {
                                        textAlign: 'center'
                                    },
                                    children: (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$a6c7ac8248d6e38a), {
                                        to: "/login",
                                        children: "Go to login"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
var $9d0d672d9619ae43$export$2e2bcd8739ae039 = $9d0d672d9619ae43$var$ActivateAccount;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




var $a2f0213bc8771ab0$export$f7c1fe483e0c5bce;
var $a2f0213bc8771ab0$export$a1ae44160bd61c4d;
$a2f0213bc8771ab0$export$f7c1fe483e0c5bce = `JWb_jq_billing-redirect-page`;
$a2f0213bc8771ab0$export$a1ae44160bd61c4d = `JWb_jq_billing-redirect-wrapper`;


const { Title: $ca7f5990a1639985$var$Title } = (0, $e8201deab6acaf74$export$2e2bcd8739ae039);
function $ca7f5990a1639985$var$BillingPortalRedirect() {
    // get customer id from url
    const [searchParams] = (0, $a6e470ffbc8d2470$export$f1a78c17382fe22a)();
    const customer = searchParams.get('customer');
    const type = searchParams.get('type');
    const subscription = searchParams.get('subscription');
    let flowData;
    switch(type){
        case 'addFirstPaymentMethod':
            flowData = {
                type: 'payment_method_update',
                after_completion: {
                    type: 'hosted_confirmation',
                    // todo
                    hosted_confirmation: {
                        custom_message: 'Your payment method has been successfully added! Update to our yearly plan and save 16.7% per year.'
                    }
                }
            };
            break;
        case 'updatePaymentMethod':
            flowData = {
                type: 'payment_method_update'
            };
            break;
        case 'updatePlan':
            if (subscription) flowData = {
                type: 'subscription_update',
                subscription_update: {
                    subscription: subscription
                }
            };
            break;
        case 'cancelPlan':
            if (!subscription) (0, $55c6005cab9be059$export$2e2bcd8739ae039).error('Subscription id is required to cancel plan');
            else flowData = {
                type: 'subscription_cancel',
                subscription_cancel: {
                    subscription: subscription
                }
            };
            break;
        default:
            break;
    }
    // graphql
    // Create billing portal session mutation
    const [createBillingPortalSession, { data: portalSessionData }] = (0, $99ead93e2ec80d4e$export$1940481f2be3ddf2)({
        variables: {
            createBillingPortalInput: {
                customer: customer,
                flow_data: flowData
            }
        },
        onError: (err)=>{
            (0, $55c6005cab9be059$export$2e2bcd8739ae039).error(err.message);
        }
    });
    (0, $6fFrj.useEffect)(()=>{
        createBillingPortalSession();
    }, [
        customer
    ]);
    if (portalSessionData?.createBillingPortalSession) window.location.href = portalSessionData.createBillingPortalSession;
    return (0, $bb3TF.jsx)("div", {
        className: $a2f0213bc8771ab0$export$f7c1fe483e0c5bce,
        children: (0, $bb3TF.jsxs)("div", {
            className: $a2f0213bc8771ab0$export$a1ae44160bd61c4d,
            children: [
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "center",
                    children: (0, $bb3TF.jsx)((0, $53a209758b3184a9$export$2e2bcd8739ae039), {
                        size: "calc(100vh)",
                        type: "full",
                        id: "billing_portal_redirect",
                        style: {
                            marginTop: 'calc(50vh * -1)'
                        }
                    })
                }),
                (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    justify: "center",
                    style: {
                        marginTop: 'calc(50vh * -1)',
                        zIndex: 999
                    },
                    children: (0, $bb3TF.jsx)($ca7f5990a1639985$var$Title, {
                        level: 3,
                        children: "You are being redirected to our secure billing portal..."
                    })
                })
            ]
        })
    });
}
var $ca7f5990a1639985$export$2e2bcd8739ae039 = $ca7f5990a1639985$var$BillingPortalRedirect;



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");




var $8e4c4b00bb1a3f92$export$523fb3936f49e028;
var $8e4c4b00bb1a3f92$export$4b3ec46669330fb1;
$8e4c4b00bb1a3f92$export$523fb3936f49e028 = `UIcbfq_page`;
$8e4c4b00bb1a3f92$export$4b3ec46669330fb1 = `UIcbfq_pageWrapper`;


const $3e638b40c101977b$var$StripePricingPage = ()=>{
    const { id: id } = (0, $990f835fb2356f36$export$99eaa27ddbbb95ef)();
    const [searchParams] = (0, $a6e470ffbc8d2470$export$f1a78c17382fe22a)();
    const email = searchParams.get('email');
    (0, $6fFrj.useEffect)(()=>{
        const script = document.createElement('script');
        script.src = 'https://js.stripe.com/v3/pricing-table.js';
        script.async = true;
        document.body.appendChild(script);
        return ()=>{
            document.body.removeChild(script);
        };
    }, []);
    // useEffect to hide the beacon
    (0, $6fFrj.useEffect)(()=>{
        let intervalId;
        const hideBeacon = ()=>{
            const beacon = document.querySelector('.BeaconFabButtonFrame');
            if (beacon) {
                beacon.setAttribute('style', 'display: none !important');
                clearInterval(intervalId); // clear the interval once the beacon is found and hidden
            }
        };
        intervalId = setInterval(hideBeacon, 100); // poll every 100ms
        return ()=>clearInterval(intervalId); // cleanup on component unmount
    }, []);
    const renderStripePricingTable = ()=>/*#__PURE__*/ (0, $6fFrj.createElement)('stripe-pricing-table', {
            'pricing-table-id': id,
            'publishable-key': (0, $6fe88dfd8b11724f$export$2e2bcd8739ae039).stripeAPIKey,
            'customer-email': email
        });
    return (0, $bb3TF.jsxs)("div", {
        className: $8e4c4b00bb1a3f92$export$523fb3936f49e028,
        children: [
            (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                justify: "center",
                style: {
                    marginBottom: 70,
                    marginLeft: -12
                },
                children: (0, $bb3TF.jsx)((0, $1cbcb18aa67bf12c$export$2e2bcd8739ae039), {
                    width: "250"
                })
            }),
            (0, $bb3TF.jsx)("div", {
                className: $8e4c4b00bb1a3f92$export$4b3ec46669330fb1,
                children: (0, $bb3TF.jsx)((0, $66a23e9427b53328$export$2e2bcd8739ae039), {
                    style: {
                        scale: '1.1'
                    },
                    children: renderStripePricingTable()
                })
            })
        ]
    });
};
var $3e638b40c101977b$export$2e2bcd8739ae039 = $3e638b40c101977b$var$StripePricingPage;




var $bb3TF = parcelRequire("bb3TF");

var $bb3TF = parcelRequire("bb3TF");


var $6fFrj = parcelRequire("6fFrj");


var $6fFrj = parcelRequire("6fFrj");

var $bb3TF = parcelRequire("bb3TF");


var $ipnkk = parcelRequire("ipnkk");







var $69dbf69de0ad8066$export$3c62f02e7eb89ce3;
var $69dbf69de0ad8066$export$a274fc9f7c970a6;
var $69dbf69de0ad8066$export$7f895a4e8c2c866e;
var $69dbf69de0ad8066$export$a87112714163b3c0;
var $69dbf69de0ad8066$export$b1ab8345e9ae3668;
var $69dbf69de0ad8066$export$1b51ec50420f32c6;
var $69dbf69de0ad8066$export$ef72a2606444d876;
var $69dbf69de0ad8066$export$cd89a7c3272c9e3;
var $69dbf69de0ad8066$export$c3b6bded7e774162;
var $69dbf69de0ad8066$export$2bb4618f153787e9;
var $69dbf69de0ad8066$export$2abcca4d2639ebfc;
var $69dbf69de0ad8066$export$54032ca4a2601cc4;
var $69dbf69de0ad8066$export$75d4ab52b06acbab;
$69dbf69de0ad8066$export$3c62f02e7eb89ce3 = `_0vbNYa_inviteActivateCheckbox`;
$69dbf69de0ad8066$export$a274fc9f7c970a6 = `_0vbNYa_inviteActivateContainer`;
$69dbf69de0ad8066$export$7f895a4e8c2c866e = `_0vbNYa_inviteActivateContent`;
$69dbf69de0ad8066$export$a87112714163b3c0 = `_0vbNYa_inviteActivateFormCard`;
$69dbf69de0ad8066$export$b1ab8345e9ae3668 = `_0vbNYa_inviteActivateFormHeader`;
$69dbf69de0ad8066$export$1b51ec50420f32c6 = `_0vbNYa_inviteActivateSpinner`;
$69dbf69de0ad8066$export$ef72a2606444d876 = `_0vbNYa_inviteActivateTerms`;
$69dbf69de0ad8066$export$cd89a7c3272c9e3 = `_0vbNYa_inviteAlreadyClient`;
$69dbf69de0ad8066$export$c3b6bded7e774162 = `_0vbNYa_inviteAlreadyClientContainer`;
$69dbf69de0ad8066$export$2bb4618f153787e9 = `_0vbNYa_inviteInnerContentContainer`;
$69dbf69de0ad8066$export$2abcca4d2639ebfc = `_0vbNYa_inviteLeftSideContainer`;
$69dbf69de0ad8066$export$54032ca4a2601cc4 = `_0vbNYa_inviteRightSideContainer`;
$69dbf69de0ad8066$export$75d4ab52b06acbab = `_0vbNYa_inviteWelcomeMessage`;




const $8f944d245916caef$var$TAX_YEAR_OPTIONS = (0, $02555ecb9d643fe4$export$2e2bcd8739ae039)(10);
const $8f944d245916caef$export$4977f55466ea2c64 = ({ job: job, email: email, taxYear: taxYear, landline: landline, lastName: lastName, language: language, birthday: birthday, firstName: firstName, workNumber: workNumber, mobileNumber: mobileNumber, createPassword: createPassword, confirmPassword: confirmPassword }, jobOptions, languageOptions)=>{
    const { t: t } = (0, $e3ea6dd032e45947$export$9fc83ad70ead8663)();
    const span = {
        xs: 24
    };
    const emailField = {
        span: span,
        key: 'email',
        value: email,
        required: true,
        inputType: 'text',
        placeHolder: '',
        label: t('client.onboarding.fields.email'),
        autoComplete: 'email'
    };
    const firstNameField = {
        span: span,
        required: true,
        placeHolder: '',
        key: 'firstName',
        value: firstName,
        inputType: 'text',
        label: t('client.onboarding.fields.firstName'),
        autoComplete: 'given-name'
    };
    const lastNameField = {
        span: span,
        required: true,
        key: 'lastName',
        placeHolder: '',
        value: lastName,
        inputType: 'text',
        label: t('client.onboarding.fields.lastName'),
        autoComplete: 'family-name'
    };
    const birthdayField = {
        span: span,
        required: true,
        key: 'birthday',
        value: birthday,
        placeHolder: '',
        inputType: 'date',
        label: t('client.onboarding.fields.birthday'),
        autoComplete: 'bday'
    };
    const landlineField = {
        span: span,
        required: false,
        key: 'landline',
        value: landline,
        placeHolder: '',
        inputType: 'text',
        label: t('client.onboarding.fields.landline'),
        autoComplete: 'tel'
    };
    const mobileNumberField = {
        span: span,
        required: true,
        placeHolder: '',
        inputType: 'text',
        key: 'mobileNumber',
        value: mobileNumber,
        label: t('client.onboarding.fields.mobileNumber'),
        autoComplete: 'tel'
    };
    const workNumberField = {
        span: span,
        required: false,
        placeHolder: '',
        key: 'workNumber',
        value: workNumber,
        inputType: 'text',
        label: t('client.onboarding.fields.workNumber'),
        autoComplete: 'tel'
    };
    const createPasswordField = {
        span: span,
        required: true,
        placeHolder: '',
        inputType: 'password',
        key: 'createPassword',
        value: createPassword,
        label: t('client.onboarding.fields.createPassword'),
        autoComplete: 'new-password'
    };
    const confirmPasswordField = {
        span: span,
        required: true,
        placeHolder: '',
        inputType: 'password',
        value: confirmPassword,
        key: 'confirmPassword',
        label: t('client.onboarding.fields.confirmPassword'),
        autoComplete: 'new-password'
    };
    const taxYearField = {
        span: span,
        key: 'taxyYear',
        value: taxYear,
        placeHolder: '',
        inputType: 'select',
        options: $8f944d245916caef$var$TAX_YEAR_OPTIONS,
        required: typeof taxYear !== 'undefined',
        label: t('client.onboarding.fields.taxYear')
    };
    const jobField = {
        span: span,
        key: 'job',
        value: job,
        placeHolder: '',
        inputType: 'select',
        options: jobOptions ?? [],
        required: typeof job !== 'undefined',
        label: t('client.onboarding.fields.job')
    };
    const languageField = {
        span: span,
        required: false,
        value: language,
        key: 'language',
        placeHolder: '',
        inputType: 'select',
        options: languageOptions ?? [],
        label: t('client.onboarding.fields.language')
    };
    return [
        emailField,
        firstNameField,
        lastNameField,
        birthdayField,
        landlineField,
        mobileNumberField,
        workNumberField,
        createPasswordField,
        confirmPasswordField,
        ...taxYear ? [
            taxYearField
        ] : [],
        ...job ? [
            jobField
        ] : [],
        languageField
    ];
};



var $bb3TF = parcelRequire("bb3TF");

var $6fFrj = parcelRequire("6fFrj");

var $e570fe2d34b07987$exports = {};

$parcel$export($e570fe2d34b07987$exports, "invite-header", function () { return $e570fe2d34b07987$export$976d6770cddd8088; }, function (v) { return $e570fe2d34b07987$export$976d6770cddd8088 = v; });
$parcel$export($e570fe2d34b07987$exports, "invite-header-logo", function () { return $e570fe2d34b07987$export$9871f51a8b7660e4; }, function (v) { return $e570fe2d34b07987$export$9871f51a8b7660e4 = v; });
$parcel$export($e570fe2d34b07987$exports, "invite-header-wrapper", function () { return $e570fe2d34b07987$export$c1753da862b0aab5; }, function (v) { return $e570fe2d34b07987$export$c1753da862b0aab5 = v; });
var $e570fe2d34b07987$export$976d6770cddd8088;
var $e570fe2d34b07987$export$9871f51a8b7660e4;
var $e570fe2d34b07987$export$c1753da862b0aab5;
$e570fe2d34b07987$export$976d6770cddd8088 = `P8L-La_invite-header`;
$e570fe2d34b07987$export$9871f51a8b7660e4 = `P8L-La_invite-header-logo`;
$e570fe2d34b07987$export$c1753da862b0aab5 = `P8L-La_invite-header-wrapper`;


const $b0a23e4518acb001$var$InviteHeader = ({ buttonType: buttonType, buttonHref: buttonHref, buttonLabel: buttonLabel, imageAddress: imageAddress, marginBottom: marginBottom, onButtonClick: onButtonClick })=>(0, $bb3TF.jsx)("header", {
        style: {
            marginBottom: marginBottom
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e570fe2d34b07987$exports))).inviteHeader,
        children: (0, $bb3TF.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($e570fe2d34b07987$exports))).inviteHeaderWrapper,
            style: {
                ...imageAddress ? {
                    justifyContent: 'space-between'
                } : {
                    justifyContent: 'flex-end'
                }
            },
            children: [
                imageAddress && (0, $bb3TF.jsx)("img", {
                    src: imageAddress,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e570fe2d34b07987$exports))).inviteHeaderLogo,
                    alt: "Business logo"
                }),
                (0, $bb3TF.jsx)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039), {
                    type: buttonType,
                    ...buttonHref ? {
                        href: buttonHref
                    } : {},
                    ...onButtonClick ? {
                        onClick: onButtonClick
                    } : {},
                    children: buttonLabel
                })
            ]
        })
    });
var $b0a23e4518acb001$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).memo($b0a23e4518acb001$var$InviteHeader);



const $1ef6107daf2a0c94$export$e70c050aa3635dde = (t)=>$ee6ba11cc5736d52$export$185802fd694ee1f5().shape({
        landline: $2746dd37f1d91ea1$export$185802fd694ee1f5(),
        language: $2746dd37f1d91ea1$export$185802fd694ee1f5(),
        workNumber: $2746dd37f1d91ea1$export$185802fd694ee1f5(),
        job: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('client.onboarding.fields.validate.job'),
        birthday: $b2e6c69aab0808b6$export$185802fd694ee1f5().required(t('client.onboarding.fields.validate.birthday')),
        taxYear: $2746dd37f1d91ea1$export$185802fd694ee1f5().required(t('client.onboarding.fields.validate.taxYear')),
        lastName: $2746dd37f1d91ea1$export$185802fd694ee1f5().required(t('client.onboarding.fields.validate.lastName')),
        firstName: $2746dd37f1d91ea1$export$185802fd694ee1f5().required(t('client.onboarding.fields.validate.firstName')),
        mobileNumber: $2746dd37f1d91ea1$export$185802fd694ee1f5().required(t('client.onboarding.fields.validate.mobileNumber')),
        createPassword: $2746dd37f1d91ea1$export$185802fd694ee1f5().min(8, t('client.onboarding.fields.validate.createPassword2')).matches(/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.*[!@#$%^&*])(?=.{8,})/, t('client.onboarding.fields.validate.createPassword3')).required('client.onboarding.fields.validate.createPassword'),
        email: $2746dd37f1d91ea1$export$185802fd694ee1f5().email(t('client.onboarding.validate.invalidEmail')).required(t('client.onboarding.fields.validate.email')),
        confirmPassword: $2746dd37f1d91ea1$export$185802fd694ee1f5().required(t('client.onboarding.fields.validate.confirmPassword')).oneOf([
            $a30d53bf69a44d9d$export$185802fd694ee1f5('createPassword'),
            null
        ], t('client.onboarding.fields.validate.confirmPassword2'))
    });
const $1ef6107daf2a0c94$export$74bafde89cb8fe4b = $ee6ba11cc5736d52$export$185802fd694ee1f5().shape({
    landline: $2746dd37f1d91ea1$export$185802fd694ee1f5(),
    language: $2746dd37f1d91ea1$export$185802fd694ee1f5(),
    workNumber: $2746dd37f1d91ea1$export$185802fd694ee1f5(),
    birthday: $b2e6c69aab0808b6$export$185802fd694ee1f5().required('client.onboarding.fields.validate.birthday'),
    lastName: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('client.onboarding.fields.validate.lastName'),
    firstName: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('client.onboarding.fields.validate.firstName'),
    mobileNumber: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('client.onboarding.fields.validate.mobileNumber'),
    createPassword: $2746dd37f1d91ea1$export$185802fd694ee1f5().min(8, 'client.onboarding.fields.validate.createPassword2').matches(/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.*[!@#$%^&*])(?=.{8,})/, 'client.onboarding.fields.validate.createPassword3').required('client.onboarding.fields.validate.createPassword'),
    email: $2746dd37f1d91ea1$export$185802fd694ee1f5().email('client.onboarding.fields.validate.invalidEmail').required('client.onboarding.fields.validate.email'),
    confirmPassword: $2746dd37f1d91ea1$export$185802fd694ee1f5().required('client.onboarding.fields.validate.confirmPassword').oneOf([
        $a30d53bf69a44d9d$export$185802fd694ee1f5('createPassword'),
        null
    ], 'client.onboarding.fields.validate.confirmPassword2')
});


const $9c756d3c14710b5a$var$Col = /*#__PURE__*/ (0, $6fFrj.memo)((0, $b72d204d9844548f$export$2e2bcd8739ae039));
const $9c756d3c14710b5a$var$Row = /*#__PURE__*/ (0, $6fFrj.memo)((0, $66a23e9427b53328$export$2e2bcd8739ae039));
const $9c756d3c14710b5a$var$Button = /*#__PURE__*/ (0, $6fFrj.memo)((0, $8c24ac1f2368b964$export$2e2bcd8739ae039));
const $9c756d3c14710b5a$var$Checkbox = /*#__PURE__*/ (0, $6fFrj.memo)((0, $66ef76fa6be8ca1a$export$2e2bcd8739ae039));
const $9c756d3c14710b5a$var$Typography = /*#__PURE__*/ (0, $6fFrj.memo)((0, $e8201deab6acaf74$export$2e2bcd8739ae039));
const $9c756d3c14710b5a$var$INITIAL_VALUES = {
    job: '',
    email: '',
    taxYear: '',
    landline: '',
    birthday: '',
    lastName: '',
    language: '',
    firstName: '',
    workNumber: '',
    mobileNumber: '',
    createPassword: '',
    confirmPassword: ''
};
const $9c756d3c14710b5a$var$InviteClient = ()=>{
    const navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    /*
      * Use type any because the type of this value had to be of a type that exists in the taxaro-ui
      * repo and is not within the scope of the project (Type: Gutter).
    */ const [rowGutter] = (0, $6fFrj.useState)([
        16,
        16
    ]);
    const locationState = (0, $990f835fb2356f36$export$45d76561a5302f2b)().state;
    const { t: t, i18n: i18n } = (0, $e3ea6dd032e45947$export$9fc83ad70ead8663)();
    const { data: data, languages: languages, accessToken: accessToken } = locationState;
    const updateClientInitialValues = {
        ...$9c756d3c14710b5a$var$INITIAL_VALUES
    };
    delete updateClientInitialValues.job;
    delete updateClientInitialValues.taxYear;
    const [clientValues, setClientValues] = (0, $6fFrj.useState)($9c756d3c14710b5a$var$INITIAL_VALUES);
    const [isModalVisible, setIsModalVisible] = (0, $6fFrj.useState)(false);
    const [areTermsAccepted, setAreTermsAccepted] = (0, $6fFrj.useState)(false);
    const [getJobs, { data: interviewsData, loading: loading }] = (0, $774cc9a1c383b6aa$export$2d8ec82bd3e5a3ff)();
    const [updateClient, { loading: updateClientLoading }] = (0, $edf372aa0dea9531$export$4d2f387ef3a8c19f)({
        context: {
            headers: {
                authorization: accessToken
            }
        }
    });
    const handleSubmitForm = ({ email: email, landline: landline, lastName: lastName, birthday: birthday, firstName: firstName, workNumber: workNumber, mobileNumber: mobileNumber, language: languageId, createPassword: password })=>{
        const Phones = [
            {
                id: undefined,
                value: mobileNumber,
                type: (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Personal
            },
            ...landline.length ? [
                {
                    id: undefined,
                    value: landline,
                    type: (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Home
                }
            ] : [],
            ...workNumber.length ? [
                {
                    id: undefined,
                    value: workNumber,
                    type: (0, $8f7fe33a44836803$export$a9572cd0d740fbfc).Office
                }
            ] : []
        ];
        if (data && data.email) updateClient({
            variables: {
                updateClientInput: {
                    email: email,
                    password: password,
                    languageId: languageId,
                    userInformation: {
                        Phones: Phones,
                        lastName: lastName,
                        birthday: birthday,
                        firstName: firstName,
                        id: data.UserInformation.id
                    }
                }
            }
        }).then((response)=>{
            if (response.data.UpdateClient.success) setIsModalVisible(true);
            else (0, $e19596a12ff9a33f$export$f69c19e57285b83a)(t('client.onboarding.failure'), 'warning');
        }).catch(()=>{
            (0, $e19596a12ff9a33f$export$f69c19e57285b83a)(t('client.onboarding.failure'), 'error');
        });
    };
    // * FORMIK CONFIG
    const { errors: errors, values: values, touched: touched, handleChange: handleChange, handleBlur: handleBlur, setFieldValue: setFieldValue, handleSubmit: handleSubmit } = (0, $ipnkk.useFormik)({
        enableReinitialize: true,
        initialValues: clientValues,
        validationSchema: data && data.email ? (0, $1ef6107daf2a0c94$export$74bafde89cb8fe4b) : (0, $1ef6107daf2a0c94$export$e70c050aa3635dde)(t),
        onSubmit: handleSubmitForm
    });
    const handleFormikBlur = (0, $6fFrj.useCallback)((event)=>{
        handleBlur(event);
    }, []);
    const handleFormikChange = (0, $6fFrj.useCallback)((event)=>{
        handleChange(event);
    }, []);
    const handleSetFieldValue = (0, $6fFrj.useCallback)((field, value, shouldValidate)=>{
        if (field === 'language') {
            const language = languages.filter(({ id: id })=>id === value)[0].lang.toLowerCase();
            i18n.changeLanguage(language);
            localStorage.setItem('lang', language);
        }
        setFieldValue(field, value, shouldValidate);
    }, []);
    const formatErrorMessages = (0, $6fFrj.useCallback)((formikErrors)=>{
        const currentErrors = {
            ...formikErrors
        };
        Object.keys(formikErrors).forEach((key)=>{
            currentErrors[key] = t(currentErrors[key]);
        });
        return currentErrors;
    }, []);
    const handleSignInNavigate = (0, $6fFrj.useCallback)(()=>{
        navigate('/login');
    }, []);
    /*
      * Use type any because the type of this value had to be of a type that exists in the taxaro-ui
      * repo and is not within the scope of the project (Type: CheckboxChange).
    */ const handleCheckboxChange = (0, $6fFrj.useCallback)((event)=>setAreTermsAccepted(event.target.checked), []);
    const handleCloseModal = ()=>{
        setIsModalVisible(false);
        handleSignInNavigate();
    };
    const getFormFields = (0, $6fFrj.useCallback)((fields, jobs, languagesOptions)=>(0, $8f944d245916caef$export$4977f55466ea2c64)(fields, jobs, languagesOptions), []);
    (0, $6fFrj.useEffect)(()=>{
        if (data) {
            const { email: email, languageId: language, UserInformation: UserInformation } = data;
            const { birthday: birthday, firstName: firstName, lastName: lastName } = UserInformation;
            const lang = localStorage.getItem('lang');
            if (lang) {
                const userLanguage = languages.filter(({ id: id })=>id === language)[0].lang.toLowerCase();
                if (userLanguage !== lang) {
                    i18n.changeLanguage(userLanguage);
                    localStorage.setItem('lang', userLanguage);
                }
            }
            setClientValues({
                ...clientValues,
                email: email,
                language: language,
                birthday: birthday,
                lastName: lastName,
                firstName: firstName,
                job: undefined,
                taxYear: undefined
            });
        }
    }, []);
    (0, $6fFrj.useEffect)(()=>{
        if (!data) getJobs();
    }, []);
    return (0, $bb3TF.jsxs)("div", {
        className: $69dbf69de0ad8066$export$a274fc9f7c970a6,
        style: {
            ...loading || updateClientLoading ? {
                height: '100vh'
            } : {}
        },
        children: [
            (0, $bb3TF.jsx)((0, $b0a23e4518acb001$export$2e2bcd8739ae039), {
                buttonHref: "/login",
                buttonType: "link",
                buttonLabel: t('client.onboarding.signin')
            }),
            (0, $bb3TF.jsxs)("div", {
                className: $69dbf69de0ad8066$export$7f895a4e8c2c866e,
                children: [
                    (0, $bb3TF.jsx)("form", {
                        onSubmit: handleSubmit,
                        children: (0, $bb3TF.jsx)("div", {
                            className: $69dbf69de0ad8066$export$a87112714163b3c0,
                            children: loading && !interviewsData ? (0, $bb3TF.jsxs)("div", {
                                className: $69dbf69de0ad8066$export$1b51ec50420f32c6,
                                children: [
                                    (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {}),
                                    (0, $bb3TF.jsx)("strong", {
                                        children: "Loading ..."
                                    })
                                ]
                            }) : (0, $bb3TF.jsxs)((0, $bb3TF.Fragment), {
                                children: [
                                    (0, $bb3TF.jsx)("div", {
                                        className: $69dbf69de0ad8066$export$b1ab8345e9ae3668,
                                        children: (0, $bb3TF.jsx)("strong", {
                                            children: t('client.onboarding.title', {
                                                name: data?.ownerName ?? ''
                                            }).toUpperCase()
                                        })
                                    }),
                                    (0, $bb3TF.jsxs)("div", {
                                        className: $69dbf69de0ad8066$export$2bb4618f153787e9,
                                        children: [
                                            (0, $bb3TF.jsxs)("div", {
                                                className: $69dbf69de0ad8066$export$2abcca4d2639ebfc,
                                                children: [
                                                    (0, $bb3TF.jsx)($9c756d3c14710b5a$var$Typography, {
                                                        children: t('client.onboarding.subtitle')
                                                    }),
                                                    (0, $bb3TF.jsx)($9c756d3c14710b5a$var$Row, {
                                                        gutter: rowGutter,
                                                        children: getFormFields(clientValues, interviewsData?.interviewNames.map(({ id: id, name: name })=>({
                                                                label: name,
                                                                value: id
                                                            })), languages?.map(({ description: description, id: id })=>({
                                                                value: id,
                                                                label: description
                                                            }))).map((item)=>/*#__PURE__*/ (0, $6fFrj.createElement)($9c756d3c14710b5a$var$Col, {
                                                                ...item.span,
                                                                key: item.key
                                                            }, (0, $bb3TF.jsx)((0, $ee43b16a73c53ab8$export$2e2bcd8739ae039), {
                                                                item: item,
                                                                touched: touched,
                                                                value: values[item.key],
                                                                handleBlur: handleFormikBlur,
                                                                handleChange: handleFormikChange,
                                                                setFieldValue: handleSetFieldValue,
                                                                errors: formatErrorMessages(errors),
                                                                ...item.key === 'email' && data && data.email ? {
                                                                    disabled: true
                                                                } : {}
                                                            })))
                                                    }),
                                                    (0, $bb3TF.jsxs)("div", {
                                                        children: [
                                                            (0, $bb3TF.jsxs)("div", {
                                                                className: $69dbf69de0ad8066$export$ef72a2606444d876,
                                                                children: [
                                                                    (0, $bb3TF.jsx)($9c756d3c14710b5a$var$Checkbox, {
                                                                        onChange: handleCheckboxChange,
                                                                        className: $69dbf69de0ad8066$export$3c62f02e7eb89ce3
                                                                    }),
                                                                    (0, $bb3TF.jsx)($9c756d3c14710b5a$var$Typography, {
                                                                        children: t('client.onboarding.agreeTerms')
                                                                    }),
                                                                    (0, $bb3TF.jsxs)("a", {
                                                                        target: "_blank",
                                                                        href: "https://taxaroo.com/terms-of-use/",
                                                                        rel: "noreferrer",
                                                                        children: [
                                                                            t('client.onboarding.termsOfUse'),
                                                                            "."
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            (0, $bb3TF.jsx)($9c756d3c14710b5a$var$Button, {
                                                                disabled: !!Object.keys(errors).length || !areTermsAccepted,
                                                                type: "primary",
                                                                htmlType: "submit",
                                                                children: t('client.onboarding.getStarted')
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            (0, $bb3TF.jsxs)("div", {
                                                className: $69dbf69de0ad8066$export$54032ca4a2601cc4,
                                                children: [
                                                    (0, $bb3TF.jsx)($9c756d3c14710b5a$var$Typography, {
                                                        className: $69dbf69de0ad8066$export$75d4ab52b06acbab,
                                                        children: t('client.onboarding.welcome')
                                                    }),
                                                    (0, $bb3TF.jsxs)("div", {
                                                        className: $69dbf69de0ad8066$export$c3b6bded7e774162,
                                                        children: [
                                                            (0, $bb3TF.jsx)($9c756d3c14710b5a$var$Typography, {
                                                                className: $69dbf69de0ad8066$export$cd89a7c3272c9e3,
                                                                children: t('client.onboarding.alreadyClient')
                                                            }),
                                                            (0, $bb3TF.jsx)($9c756d3c14710b5a$var$Button, {
                                                                type: "primary",
                                                                onClick: handleSignInNavigate,
                                                                children: t('client.onboarding.signin')
                                                            })
                                                        ]
                                                    }),
                                                    (0, $bb3TF.jsx)("p", {
                                                        children: t('client.onboarding.ours')
                                                    }),
                                                    (0, $bb3TF.jsx)("p", {
                                                        children: t('client.onboarding.instructions')
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    (0, $bb3TF.jsx)("div", {})
                ]
            }),
            (0, $bb3TF.jsx)((0, $6db0040c215ed6e9$export$2e2bcd8739ae039), {
                visible: isModalVisible,
                onCancel: handleCloseModal,
                type: "success",
                title: "Client on-boarding",
                footer: [
                    (0, $bb3TF.jsx)($9c756d3c14710b5a$var$Button, {
                        type: "primary",
                        onClick: handleCloseModal,
                        children: "Okay"
                    })
                ],
                children: (0, $bb3TF.jsx)("p", {
                    children: t('client.onboarding.success')
                })
            })
        ]
    });
};
var $9c756d3c14710b5a$export$2e2bcd8739ae039 = $9c756d3c14710b5a$var$InviteClient;





var $04377615e3db5007$exports = {};

$parcel$export($04377615e3db5007$exports, "invite-container", function () { return $04377615e3db5007$export$fa156afd556b3593; }, function (v) { return $04377615e3db5007$export$fa156afd556b3593 = v; });
$parcel$export($04377615e3db5007$exports, "spiner-container", function () { return $04377615e3db5007$export$3cf240de01d146fe; }, function (v) { return $04377615e3db5007$export$3cf240de01d146fe = v; });
var $04377615e3db5007$export$fa156afd556b3593;
var $04377615e3db5007$export$3cf240de01d146fe;
$04377615e3db5007$export$fa156afd556b3593 = `dKb5FW_invite-container`;
$04377615e3db5007$export$3cf240de01d146fe = `dKb5FW_spiner-container`;



var $6fFrj = parcelRequire("6fFrj");

function $fd6d289c3118fc90$export$b37ee0d76c6d2fbc() {
    const { search: search } = (0, $990f835fb2356f36$export$45d76561a5302f2b)();
    return (0, $6fFrj.useMemo)(()=>new URLSearchParams(search), [
        search
    ]);
}



const $56bbd7f01fbd1451$export$922dbcccef24242f = ()=>{
    const query = (0, $fd6d289c3118fc90$export$b37ee0d76c6d2fbc)();
    const navigate = (0, $990f835fb2356f36$export$9770f232ac06a008)();
    const dispatch = (0, $58073eff19365823$export$f51d452c10d5b956)();
    const access = query.get('access');
    const [getClientData, { loading: loading, data: clientData }] = (0, $e9d4d19cd26b2dae$export$516eb4694483a826)();
    const [getLanguages, { data: languagesData }] = (0, $e9d4d19cd26b2dae$export$5d4e05e09dcdd3b7)();
    (0, $6fFrj.useEffect)(()=>{
        dispatch((0, $e3b9937a336ce5aa$export$b5d16ddcd70241c7)());
        dispatch((0, $59a61dbb6cd2676b$export$28052446e33b6b86)());
        getClientData({
            context: {
                headers: {
                    authorization: access
                }
            }
        });
        getLanguages({
            context: {
                headers: {
                    authorization: access
                }
            }
        });
    }, []);
    (0, $6fFrj.useEffect)(()=>{
        if (clientData && languagesData && clientData.ClientOnboardingData.allowed && !loading) navigate('/invite/activate', {
            state: {
                accessToken: access,
                data: clientData.ClientOnboardingData,
                ...languagesData ? {
                    languages: languagesData.languages
                } : {}
            }
        });
        else if (clientData && !clientData.ClientOnboardingData.allowed) navigate('/login');
    }, [
        clientData,
        languagesData
    ]);
    return (0, $bb3TF.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($04377615e3db5007$exports))).spinerContainer,
        children: [
            (0, $bb3TF.jsx)((0, $80a5ad5fdc1497cd$export$2e2bcd8739ae039), {
                size: "large"
            }),
            (0, $bb3TF.jsx)("strong", {
                children: "Processing data ..."
            })
        ]
    });
};
const $56bbd7f01fbd1451$export$7321ff25eaf2fc66 = ()=>(0, $bb3TF.jsx)((0, $9c756d3c14710b5a$export$2e2bcd8739ae039), {});


const $711711ba5e66ada4$export$24d623a32ea87295 = ()=>(0, $bb3TF.jsx)((0, $56bbd7f01fbd1451$export$7321ff25eaf2fc66), {});
const $711711ba5e66ada4$export$b2ed64afc0a53b97 = ()=>(0, $bb3TF.jsx)((0, $56bbd7f01fbd1451$export$922dbcccef24242f), {});


const $c395154faffdb17e$export$46507f50e22c0461 = [
    {
        path: '/login',
        element: (0, $bb3TF.jsx)((0, $b72a40106d659ce4$export$693ba5b7fe7beabd), {
            children: (0, $bb3TF.jsx)((0, $99b2ed209f63b653$export$2e2bcd8739ae039), {})
        })
    },
    {
        path: '/forgot-password',
        element: (0, $bb3TF.jsx)((0, $b72a40106d659ce4$export$693ba5b7fe7beabd), {
            children: (0, $bb3TF.jsx)((0, $21c96e3ab60625be$export$2e2bcd8739ae039), {})
        })
    },
    {
        path: '/reset-password/:id',
        element: (0, $bb3TF.jsx)((0, $b72a40106d659ce4$export$693ba5b7fe7beabd), {
            children: (0, $bb3TF.jsx)((0, $2898b6db5f1054c5$export$2e2bcd8739ae039), {})
        })
    },
    {
        path: '/activate-preparer-account/:id',
        element: (0, $bb3TF.jsx)((0, $b72a40106d659ce4$export$693ba5b7fe7beabd), {
            children: (0, $bb3TF.jsx)((0, $182bfd81c46fadd7$export$2e2bcd8739ae039), {})
        })
    },
    {
        path: '/activate-account/:id',
        element: (0, $bb3TF.jsx)((0, $b72a40106d659ce4$export$693ba5b7fe7beabd), {
            children: (0, $bb3TF.jsx)((0, $9d0d672d9619ae43$export$2e2bcd8739ae039), {})
        })
    },
    {
        path: '/invite/activate/pre',
        element: (0, $bb3TF.jsx)((0, $b72a40106d659ce4$export$693ba5b7fe7beabd), {
            children: (0, $bb3TF.jsx)((0, $711711ba5e66ada4$export$b2ed64afc0a53b97), {})
        })
    },
    {
        path: '/invite/activate',
        element: (0, $bb3TF.jsx)((0, $b72a40106d659ce4$export$693ba5b7fe7beabd), {
            children: (0, $bb3TF.jsx)((0, $711711ba5e66ada4$export$24d623a32ea87295), {})
        })
    },
    {
        path: '/register',
        element: (0, $bb3TF.jsx)((0, $b72a40106d659ce4$export$693ba5b7fe7beabd), {
            children: (0, $bb3TF.jsx)((0, $b9dd44a2cb3e46a1$export$2e2bcd8739ae039), {})
        })
    },
    {
        path: '/free-plan',
        element: (0, $bb3TF.jsx)((0, $b72a40106d659ce4$export$693ba5b7fe7beabd), {
            children: (0, $bb3TF.jsx)((0, $b9dd44a2cb3e46a1$export$2e2bcd8739ae039), {
                free: true
            })
        })
    },
    {
        path: '/billing-portal',
        element: (0, $bb3TF.jsx)((0, $b72a40106d659ce4$export$693ba5b7fe7beabd), {
            children: (0, $bb3TF.jsx)((0, $ca7f5990a1639985$export$2e2bcd8739ae039), {})
        })
    },
    {
        path: '/special-offer/:id',
        element: (0, $bb3TF.jsx)((0, $b72a40106d659ce4$export$693ba5b7fe7beabd), {
            children: (0, $bb3TF.jsx)((0, $3e638b40c101977b$export$2e2bcd8739ae039), {})
        })
    }
];


const $fa32d143a15e62b2$var$TaxarooRoutes = ()=>{
    (0, $1b6cd4304c8b74ff$export$ce099541bf79f159)();
    return (0, $bb3TF.jsxs)((0, $990f835fb2356f36$export$3565eb3d00ca5a74), {
        children: [
            (0, $c395154faffdb17e$export$46507f50e22c0461).map((route)=>(0, $bb3TF.jsx)((0, $990f835fb2356f36$export$e7b0ac011bb776c6), {
                    ...route
                }, route.path)),
            (0, $aa8f22afe69674e9$export$fd43ec2654dfed19).map(({ element: element, ...route })=>(0, $bb3TF.jsx)((0, $990f835fb2356f36$export$e7b0ac011bb776c6), {
                    element: (0, $bb3TF.jsx)((0, $8179f22897d97d36$export$2e2bcd8739ae039), {
                        children: element
                    }),
                    ...route
                }, route.path)),
            (0, $bb3TF.jsx)((0, $990f835fb2356f36$export$e7b0ac011bb776c6), {
                path: "*",
                element: (0, $bb3TF.jsx)((0, $b72a40106d659ce4$export$693ba5b7fe7beabd), {
                    children: (0, $bb3TF.jsx)((0, $83c6dec095052af7$export$2e2bcd8739ae039), {})
                })
            })
        ]
    });
};
var $fa32d143a15e62b2$export$2e2bcd8739ae039 = $fa32d143a15e62b2$var$TaxarooRoutes;



// https://app.usermaven.com/env/UM2bqclomL/setup-guides/integration?type=react
const $8d7cb33970ee9a17$var$usermavenClient = (0, $1b6cd4304c8b74ff$export$5d730b7aed1a3eb0)({
    key: 'UM2bqclomL'
});
const $8d7cb33970ee9a17$var$App = ()=>(0, $bb3TF.jsx)((0, $1b6cd4304c8b74ff$export$e16a8f6f26d15fff), {
        client: $8d7cb33970ee9a17$var$usermavenClient,
        children: (0, $bb3TF.jsx)((0, $a6e470ffbc8d2470$export$9ba4e89fdfa1fc54), {
            children: (0, $bb3TF.jsx)((0, $fa32d143a15e62b2$export$2e2bcd8739ae039), {})
        })
    });
var $8d7cb33970ee9a17$export$2e2bcd8739ae039 = $8d7cb33970ee9a17$var$App;




var $cLIgV = parcelRequire("cLIgV");

/* eslint-disable quote-props */ /* eslint-disable max-len */ const $d34a81f4e1779fba$var$enInternationalization = {
    translation: {
        'scheduleCall.error': 'There is no more dates available for this day.',
        'scheduleCall.callScheduled': 'Call Scheduled',
        'scheduleCall.schedule': 'Schedule',
        'scheduleCall.selectOption': 'Time',
        'scheduleCall.duration': 'Duration',
        'scheduleCall.date': 'Date',
        'scheduleCall.next': 'Next',
        'scheduleCall.skipNotes': 'Skip notes',
        'scheduleCall.notes': 'Notes',
        'scheduleCall.scheduleCall': 'Schedule Appointment',
        'chat.downloadFile.error': 'This file is corrupted or has been deleted',
        'chat.incomingCall.accept': 'Accept',
        'chat.incomingCall.decline': 'Decline',
        'chat.incomingCall.title': "Incoming Call\u2026",
        'chat.chatInput.uploadLabel': 'Attach File',
        'chat.chatInput.emoji': 'Emoji',
        'chat.chatInput.fileUploaded': 'file uploaded successfully.',
        'chat.chatInput.fileNotUploaded': 'file upload failed.',
        'chat.chatInput.selectProject': 'Select a project to upload a file.',
        'chat.chatInput.sendMessage': 'Send Message',
        'chat.userActive': 'Active Now',
        'chat.messagesList.missedCall': 'Declined Call',
        'videocall.call.meetingWith': 'Meeting with',
        'videocall.call.callScheduledFor': 'This call is scheduled for {{date}} at {{timeH}}:{{timeM}} you may access it on that time.',
        'call.callErrors.description.cleanMeeting': 'Please, choose your audio and video settings.',
        'call.callErrors.title.userNotInvited': 'User not invited to call',
        'call.callErrors.description.userNotInvited': 'You are not invited to this call.',
        'call.callErrors.title.mustLogin': 'User not logged in',
        'call.callErrors.description.mustLogin': 'Log in to enter this call.',
        'call.callErrors.button.mustLogin': 'Log in.',
        'call.callErrors.title.earlierAccess': 'This room is not available yet',
        'call.callErrors.title.laterAccess': 'This call has ended',
        'call.callErrors.description.laterAccess': 'You may still access chat messages.',
        'call.callErrors.title.callCancelled': 'This video call was cancelled',
        'call.callErrors.description.callCancelled': 'This video call was cancelled by one or more of the participants.',
        'call.callErrors.title.noCam': 'Camera permission denied',
        'call.callErrors.description.noCam': 'You have not granted or blocked camera access. Please update your browser settings to allow access.',
        'call.callErrors.title.noMic': 'Microphone permission denied',
        'call.callErrors.description.noMic': 'You have not granted or blocked microphone access. Please update your browser settings to allow access.',
        'call.callErrors.title.callExpired': 'This call has already expired',
        'call.callErrors.description.callExpired': 'If you think this an error, please contact your Tax Preparer.',
        'call.join': 'Join Now',
        'videocall.me': 'Me',
        'videocall.callMenu.recordSession': 'Record Session',
        'videocall.callMenu.stopRecording': 'Stop Recording',
        'client.onboarding.signin': 'Sign in',
        'client.onboarding.title': 'Register for {{name}} to prepare your taxes',
        'client.onboarding.subtitle': 'Provide some basic information to get started',
        'client.onboarding.welcome': 'Welcome to our secure portal',
        'client.onboarding.alreadyClient': 'Already a client?',
        'client.onboarding.ours': 'Ours is an online platform used to easily and securely share information with your tax preparer.',
        'client.onboarding.instructions': 'You\'re one step away from working with your tax preparer entirely online, but first you need to set a password for your account. This will allow you to get back to your account later by logging in to our portal with your email address.',
        'client.onboarding.agreeTerms': 'I agree to the platform\'s ',
        'client.onboarding.termsOfUse': 'Terms of Use',
        'client.onboarding.getStarted': 'Get Started',
        'client.onboarding.success': 'Your account has been successfully activated. You can now use our platform by logging in.',
        'client.onboarding.failure': 'Something went wrong during the account activation process. Please make sure that the data you entered is correct. If the problem persists please contact the preparer who sent you the invitation.',
        'client.onboarding.fields.email': 'Email',
        'client.onboarding.fields.firstName': 'First Name',
        'client.onboarding.fields.lastName': 'Last Name',
        'client.onboarding.fields.birthday': 'Date of Birth',
        'client.onboarding.fields.landline': 'Landline',
        'client.onboarding.fields.mobileNumber': 'Mobile Number',
        'client.onboarding.fields.workNumber': 'Work Number',
        'client.onboarding.fields.createPassword': 'Create Password',
        'client.onboarding.fields.confirmPassword': 'Confirm Password',
        'client.onboarding.fields.taxYear': 'Which tax year is this for?',
        'client.onboarding.fields.job': 'What tax filling is this for?',
        'client.onboarding.fields.language': 'Language',
        'client.onboarding.fields.validate.email': 'The email is required',
        'client.onboarding.fields.validate.invalidEmail': 'Invalid email',
        'client.onboarding.fields.validate.firstName': 'First Name is required',
        'client.onboarding.fields.validate.lastName': 'Last Name is required',
        'client.onboarding.fields.validate.birthday': 'Birthday is required',
        'client.onboarding.fields.validate.mobileNumber': 'Mobile Number is required',
        'client.onboarding.fields.validate.createPassword': 'Password is required',
        'client.onboarding.fields.validate.createPassword2': 'The password must be at least 8 characters long',
        'client.onboarding.fields.validate.createPassword3': 'The password must contain at least one lowecase letter, one uppercase letter, a number from 0-9 and one of these characters: !@#$%^&*',
        'client.onboarding.fields.validate.confirmPassword': 'Confirm Password is required',
        'client.onboarding.fields.validate.confirmPassword2': 'Password must match',
        'client.onboarding.fields.validate.taxYear': 'Tax Year is required',
        'client.onboarding.fields.validate.job': 'Tax filling is required'
    },
    emojiMart: {
        search: 'Search',
        clear: 'Clear',
        notfound: 'No Emoji Found',
        skintext: 'Choose your default skin tone',
        categories: {
            search: 'Search Results',
            recent: 'Frequently Used',
            smileys: 'Smileys & Emotion',
            people: 'People & Body',
            nature: 'Animals & Nature',
            foods: 'Food & Drink',
            activity: 'Activity',
            places: 'Travel & Places',
            objects: 'Objects',
            symbols: 'Symbols',
            flags: 'Flags',
            custom: 'Custom'
        },
        categorieslabel: 'Emoji categories',
        skintones: {
            1: 'Default Skin Tone',
            2: 'Light Skin Tone',
            3: 'Medium-Light Skin Tone',
            4: 'Medium Skin Tone',
            5: 'Medium-Dark Skin Tone',
            6: 'Dark Skin Tone'
        }
    }
};
var $d34a81f4e1779fba$export$2e2bcd8739ae039 = $d34a81f4e1779fba$var$enInternationalization;


/* eslint-disable quote-props */ /* eslint-disable max-len */ const $fec4257d9ac0c53e$var$esInternationalization = {
    translation: {
        'scheduleCall.error': "No hay m\xe1s fechas disponibles para este d\xeda.",
        'scheduleCall.callScheduled': 'Llamada programada',
        'scheduleCall.schedule': 'Programar',
        'scheduleCall.selectOption': "Seleccione una opci\xf3n",
        'scheduleCall.duration': "Duraci\xf3n",
        'scheduleCall.date': 'Fecha',
        'scheduleCall.next': 'Siguiente',
        'scheduleCall.skipNotes': 'Saltar notas',
        'scheduleCall.notes': 'Notas',
        'scheduleCall.scheduleCall': 'Programar llamada',
        'chat.downloadFile.error': "Este archivo est\xe1 da\xf1ado o se ha eliminado",
        'chat.incomingCall.accept': 'Aceptar',
        'chat.incomingCall.decline': 'Rechazar',
        'chat.incomingCall.title': 'Llamada Entrante',
        'chat.chatInput.uploadLabel': 'Adjuntar Archivo',
        'chat.chatInput.emoji': 'Emoji',
        'chat.chatInput.fileUploaded': 'cargado exitosamente.',
        'chat.chatInput.fileNotUploaded': "fall\xf3 al cargar.",
        'chat.chatInput.selectProject': 'Seleccione un proyecto para cargar un archivo.',
        'chat.chatInput.sendMessage': 'Enviar Mensaje',
        'chat.userActive': 'Activo Ahora',
        'chat.messagesList.missedCall': 'Llamada rechazada',
        'videocall.call.meetingWith': "Reuni\xf3n con",
        'videocall.call.callScheduledFor': "Esta llamada est\xe1 programada para {{date}} a las {{timeH}}:{{timeM}} puedes acceder hasta ese momento.",
        'call.callErrors.description.cleanMeeting': "Por favor, elija su configuraci\xf3n de audio y video.",
        'call.callErrors.title.userNotInvited': 'Usuario no invitado a hablar',
        'call.callErrors.description.userNotInvited': "No est\xe1s invitado a esta llamada.",
        'call.callErrors.title.mustLogin': "El usuario no ha iniciado sesi\xf3n",
        'call.callErrors.description.mustLogin': "Inicie sesi\xf3n para ingresar a esta llamada.",
        'call.callErrors.button.mustLogin': "Iniciar sesi\xf3n.",
        'call.callErrors.title.earlierAccess': "Esta llamada a\xfan no est\xe1 disponible",
        'call.callErrors.title.laterAccess': 'Esta llamada ha terminado',
        'call.callErrors.description.laterAccess': "A\xfan puedes acceder a los mensajes de chat.",
        'call.callErrors.title.callCancelled': 'Esta videollamada fue cancelada',
        'call.callErrors.description.callCancelled': "Esta videollamada fue cancelada por uno o m\xe1s de los participantes.",
        'call.callErrors.title.noCam': "Permiso de c\xe1mara denegado",
        'call.callErrors.description.noCam': "No ha concedido ni bloqueado el acceso a la c\xe1mara. Actualice la configuraci\xf3n de su navegador para permitir el acceso.",
        'call.callErrors.title.noMic': "Permiso de micr\xf3fono denegado",
        'call.callErrors.description.noMic': "No ha concedido ni bloqueado el acceso al micr\xf3fono. Actualice la configuraci\xf3n de su navegador para permitir el acceso.",
        'call.callErrors.title.callExpired': "Esta llamada ya venci\xf3",
        'call.callErrors.description.callExpired': "Si cree que se trata de un error, comun\xedquese con su preparador de impuestos.",
        'call.join': "\xdanete ahora",
        'videocall.me': 'Yo',
        'videocall.callMenu.recordSession': "Grabar Sesi\xf3n",
        'videocall.callMenu.stopRecording': 'Dejar de Grabar',
        'client.onboarding.signin': 'Iniciar Sesion',
        'client.onboarding.title': 'Registrese para que {{name}} prepare sus impuestos',
        'client.onboarding.subtitle': "Proporciona informaci\xf3n b\xe1sica para empezar",
        'client.onboarding.welcome': 'Bienvenido a nuestro portal seguro',
        'client.onboarding.alreadyClient': "\xbfYa es cliente?",
        'client.onboarding.ours': "La nuestra es una plataforma en l\xednea que se utiliza para compartir f\xe1cilmente y de forma segura la informaci\xf3n con su preparador de impuestos.",
        'client.onboarding.instructions': "Est\xe1 a un paso de trabajar con su preparador de impuestos completamente en l\xednea, pero primero necesita establecer una contrase\xf1a para su cuenta. Esto le permitir\xe1 volver a su cuenta m\xe1s tarde accediendo a nuestro portal con su direcci\xf3n de correo electr\xf3nico.",
        'client.onboarding.agreeTerms': 'Estoy de acuerdo con las ',
        'client.onboarding.termsOfUse': 'Condiciones de uso',
        'client.onboarding.getStarted': 'Empezar a trabajar',
        'client.onboarding.success': "Su cuenta ha sido activada con \xe9xito. Ahora puede utilizar nuestra plataforma iniciando sesi\xf3n",
        'client.onboarding.failure': "Algo ha ido mal durante el proceso de activaci\xf3n de la cuenta. Por favor, aseg\xfarese de que los datos que ha introducido son correctos. Si el problema persiste, p\xf3ngase en contacto con el preparador fiscal que le envi\xf3 la invitaci\xf3n.",
        'client.onboarding.fields.email': "Correo electr\xf3nico",
        'client.onboarding.fields.firstName': 'Nombre',
        'client.onboarding.fields.lastName': 'Apellido',
        'client.onboarding.fields.birthday': 'Fecha de Nacimiento',
        'client.onboarding.fields.landline': 'Telefono Fijo',
        'client.onboarding.fields.mobileNumber': "Telefono M\xf3vil",
        'client.onboarding.fields.workNumber': 'Telefono De Trabajo',
        'client.onboarding.fields.createPassword': "Crea Una Contrase\xf1a",
        'client.onboarding.fields.confirmPassword': "Confirma Tu Contrase\xf1a",
        'client.onboarding.fields.taxYear': "\xbfPara qu\xe9 a\xf1o fiscal es esto?",
        'client.onboarding.fields.job': "\xbfPara qu\xe9 sera la declaraci\xf3n de impuestos?",
        'client.onboarding.fields.language': 'Idioma',
        'client.onboarding.fields.validate.email': "El correo electr\xf3nico es requerido",
        'client.onboarding.fields.validate.invalidEmail': "Correo electr\xf3nico invalido",
        'client.onboarding.fields.validate.firstName': 'El Nombre es requerido',
        'client.onboarding.fields.validate.lastName': 'El Apellido es requerido',
        'client.onboarding.fields.validate.birthday': 'La Fecha de Nacimiento es requerida',
        'client.onboarding.fields.validate.mobileNumber': "El Telefono M\xf3vil es requerido",
        'client.onboarding.fields.validate.createPassword': "La Contrase\xf1a es requerida",
        'client.onboarding.fields.validate.createPassword2': "La contrase\xf1a debe tener al menos 8 caracteres",
        'client.onboarding.fields.validate.createPassword3': "La Contrase\xf1a debe contener al menos una letra min\xfascula, una may\xfascula, un n\xfamero del 0 al 9 y uno de estos caracteres: !@#$%^&*",
        'client.onboarding.fields.validate.confirmPassword': "Confirmar la Contrase\xf1a es requerido",
        'client.onboarding.fields.validate.confirmPassword2': "La Contrase\xf1a debe coincidir",
        'client.onboarding.fields.validate.taxYear': "El a\xf1o fiscal es requerido",
        'client.onboarding.fields.validate.job': 'Tipo de declaracion de impuestos es requerido'
    },
    emojiMart: {
        search: 'Buscar',
        clear: 'Limpiar',
        notfound: "No se encontr\xf3 ning\xfan emoji",
        skintext: 'Elija su tono de piel predeterminado',
        categories: {
            search: "Resultados de la b\xfasqueda",
            recent: 'Usados frecuentemente',
            smileys: "Emoticonos y emoci\xf3n",
            people: 'Personas y cuerpo',
            nature: 'Animales y naturaleza',
            foods: 'Comida y bebida',
            activity: 'Actividad',
            places: 'Viajes y lugares',
            objects: 'Objectos',
            symbols: 'Simbolos',
            flags: 'Banderas',
            custom: 'Personalizado'
        },
        categorieslabel: "Categor\xedas de emoji",
        skintones: {
            1: 'Default Skin Tone',
            2: 'Light Skin Tone',
            3: 'Medium-Light Skin Tone',
            4: 'Medium Skin Tone',
            5: 'Medium-Dark Skin Tone',
            6: 'Dark Skin Tone'
        }
    }
};
var $fec4257d9ac0c53e$export$2e2bcd8739ae039 = $fec4257d9ac0c53e$var$esInternationalization;


const $d0fa38535bdbbe6a$var$lang = localStorage.getItem('lang') || 'en';
(0, $cLIgV.default).use((0, $3b1a0d944fd02b49$export$ae7e14d40d89f296)).init({
    resources: {
        en: $d34a81f4e1779fba$export$2e2bcd8739ae039,
        es: $fec4257d9ac0c53e$export$2e2bcd8739ae039
    },
    fallbackLng: [
        'en',
        'es'
    ],
    lng: $d0fa38535bdbbe6a$var$lang,
    keySeparator: false,
    interpolation: {
        escapeValue: true
    }
});
var $d0fa38535bdbbe6a$export$2e2bcd8739ae039 = (0, $cLIgV.default);


const $5044f3757f0e9464$var$persistor = (0, $64c53298d3249927$export$2e2bcd8739ae039)((0, $e4ec60025026f14e$export$2e2bcd8739ae039));
$efb8670e6decf1f1$export$2cd8252107eb640b({
    dsn: "https://04d32ccb5dd14babaca34ae4b0b468f7@o483886.ingest.sentry.io/4505235915341824",
    integrations: [
        new $d45b5653f1edc3ff$export$46d3bbd0375f5fa4(),
        new $af5eb29b940bd654$export$a35c789ed37ee0f7({
            maskAllText: false
        })
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1,
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: "production"
});
(0, (/*@__PURE__*/$parcel$interopDefault($8CZEB))).render((0, $bb3TF.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6fFrj))).StrictMode, {
    children: (0, $bb3TF.jsx)((0, $aada76e34d6cfbf9$export$c16b04c8a9956446), {
        client: (0, $d9c9d80f653581ac$export$2e2bcd8739ae039),
        children: (0, $bb3TF.jsx)((0, $211270d3ecf64ed8$export$2e2bcd8739ae039), {
            store: (0, $e4ec60025026f14e$export$2e2bcd8739ae039),
            children: (0, $bb3TF.jsx)((0, $caa8046e980e645b$export$311ca220e7478cda), {
                loading: null,
                persistor: $5044f3757f0e9464$var$persistor,
                children: (0, $bb3TF.jsx)((0, $a8c21a2ece310828$export$178405afcd8c5eb), {
                    children: (0, $bb3TF.jsx)((0, $8d7cb33970ee9a17$export$2e2bcd8739ae039), {})
                })
            })
        })
    })
}), document.getElementById('app'));

})();
//# sourceMappingURL=index.3aaedeb0.js.map
